(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["molstar"] = factory();
	else
		root["molstar"] = factory();
})(window, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__webpack_require__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __webpack_require__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__webpack_require__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = "./lib/apps/viewer/index.js");
/******/ })
/************************************************************************/
/******/ ({

/***/ "./lib/apps/viewer/embedded.html":
/*!***************************************!*\
  !*** ./lib/apps/viewer/embedded.html ***!
  \***************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (__webpack_require__.p + "embedded.html");

/***/ }),

/***/ "./lib/apps/viewer/favicon.ico":
/*!*************************************!*\
  !*** ./lib/apps/viewer/favicon.ico ***!
  \*************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (__webpack_require__.p + "favicon.ico");

/***/ }),

/***/ "./lib/apps/viewer/index.html":
/*!************************************!*\
  !*** ./lib/apps/viewer/index.html ***!
  \************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (__webpack_require__.p + "index.html");

/***/ }),

/***/ "./lib/apps/viewer/index.js":
/*!**********************************!*\
  !*** ./lib/apps/viewer/index.js ***!
  \**********************************/
/*! exports provided: version, setProductionMode, setDebugMode, Viewer */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Viewer", function() { return Viewer; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _mol_util_polyfill__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../mol-util/polyfill */ "./lib/mol-util/polyfill.js");
/* harmony import */ var _mol_util_polyfill__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_mol_util_polyfill__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _mol_plugin__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../mol-plugin */ "./lib/mol-plugin/index.js");
/* harmony import */ var _index_html__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./index.html */ "./lib/apps/viewer/index.html");
/* harmony import */ var _embedded_html__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./embedded.html */ "./lib/apps/viewer/embedded.html");
/* harmony import */ var _favicon_ico__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./favicon.ico */ "./lib/apps/viewer/favicon.ico");
/* harmony import */ var _mol_plugin_commands__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../../mol-plugin/commands */ "./lib/mol-plugin/commands.js");
/* harmony import */ var _mol_plugin_spec__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../../mol-plugin/spec */ "./lib/mol-plugin/spec.js");
/* harmony import */ var _mol_plugin_state_actions_structure__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ../../mol-plugin-state/actions/structure */ "./lib/mol-plugin-state/actions/structure.js");
/* harmony import */ var _mol_plugin_config__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ../../mol-plugin/config */ "./lib/mol-plugin/config.js");
/* harmony import */ var _extensions_cellpack__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ../../extensions/cellpack */ "./lib/extensions/cellpack/index.js");
/* harmony import */ var _extensions_rcsb__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ../../extensions/rcsb */ "./lib/extensions/rcsb/index.js");
/* harmony import */ var _extensions_pdbe__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! ../../extensions/pdbe */ "./lib/extensions/pdbe/index.js");
/* harmony import */ var _mol_util_assets__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! ../../mol-util/assets */ "./lib/mol-util/assets.js");
/* harmony import */ var _mol_util_type_helpers__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! ../../mol-util/type-helpers */ "./lib/mol-util/type-helpers.js");
/* harmony import */ var _mol_plugin_state_actions_volume__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! ../../mol-plugin-state/actions/volume */ "./lib/mol-plugin-state/actions/volume.js");
/* harmony import */ var _extensions_anvil_behavior__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(/*! ../../extensions/anvil/behavior */ "./lib/extensions/anvil/behavior.js");
/* harmony import */ var _extensions_dnatco__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(/*! ../../extensions/dnatco */ "./lib/extensions/dnatco/index.js");
/* harmony import */ var _extensions_g3d_format__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(/*! ../../extensions/g3d/format */ "./lib/extensions/g3d/format.js");
/* harmony import */ var _mol_plugin_state_transforms__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(/*! ../../mol-plugin-state/transforms */ "./lib/mol-plugin-state/transforms.js");
/* harmony import */ var _mol_plugin_state_helpers_volume_representation_params__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(/*! ../../mol-plugin-state/helpers/volume-representation-params */ "./lib/mol-plugin-state/helpers/volume-representation-params.js");
/* harmony import */ var _extensions_mp4_export__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(/*! ../../extensions/mp4-export */ "./lib/extensions/mp4-export/index.js");
/* harmony import */ var _mol_plugin_version__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(/*! ../../mol-plugin/version */ "./lib/mol-plugin/version.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "version", function() { return _mol_plugin_version__WEBPACK_IMPORTED_MODULE_22__["PLUGIN_VERSION"]; });

/* harmony import */ var _mol_util_debug__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(/*! ../../mol-util/debug */ "./lib/mol-util/debug.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "setProductionMode", function() { return _mol_util_debug__WEBPACK_IMPORTED_MODULE_23__["setProductionMode"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "setDebugMode", function() { return _mol_util_debug__WEBPACK_IMPORTED_MODULE_23__["setDebugMode"]; });

/**
 * Copyright (c) 2018-2020 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author David Sehnal <david.sehnal@gmail.com>
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */






















__webpack_require__(/*! mol-plugin-ui/skin/light.scss */ "./lib/mol-plugin-ui/skin/light.scss");


var CustomFormats = [
    ['g3d', _extensions_g3d_format__WEBPACK_IMPORTED_MODULE_18__["G3dProvider"]]
];
var Extensions = {
    'cellpack': _mol_plugin_spec__WEBPACK_IMPORTED_MODULE_7__["PluginSpec"].Behavior(_extensions_cellpack__WEBPACK_IMPORTED_MODULE_10__["CellPack"]),
    'dnatco-confal-pyramids': _mol_plugin_spec__WEBPACK_IMPORTED_MODULE_7__["PluginSpec"].Behavior(_extensions_dnatco__WEBPACK_IMPORTED_MODULE_17__["DnatcoConfalPyramids"]),
    'pdbe-structure-quality-report': _mol_plugin_spec__WEBPACK_IMPORTED_MODULE_7__["PluginSpec"].Behavior(_extensions_pdbe__WEBPACK_IMPORTED_MODULE_12__["PDBeStructureQualityReport"]),
    'rcsb-assembly-symmetry': _mol_plugin_spec__WEBPACK_IMPORTED_MODULE_7__["PluginSpec"].Behavior(_extensions_rcsb__WEBPACK_IMPORTED_MODULE_11__["RCSBAssemblySymmetry"]),
    'rcsb-validation-report': _mol_plugin_spec__WEBPACK_IMPORTED_MODULE_7__["PluginSpec"].Behavior(_extensions_rcsb__WEBPACK_IMPORTED_MODULE_11__["RCSBValidationReport"]),
    'anvil-membrane-orientation': _mol_plugin_spec__WEBPACK_IMPORTED_MODULE_7__["PluginSpec"].Behavior(_extensions_anvil_behavior__WEBPACK_IMPORTED_MODULE_16__["ANVILMembraneOrientation"]),
    'g3d': _mol_plugin_spec__WEBPACK_IMPORTED_MODULE_7__["PluginSpec"].Behavior(_extensions_g3d_format__WEBPACK_IMPORTED_MODULE_18__["G3DFormat"]),
    'mp4-export': _mol_plugin_spec__WEBPACK_IMPORTED_MODULE_7__["PluginSpec"].Behavior(_extensions_mp4_export__WEBPACK_IMPORTED_MODULE_21__["Mp4Export"])
};
var DefaultViewerOptions = {
    customFormats: CustomFormats,
    extensions: Object(_mol_util_type_helpers__WEBPACK_IMPORTED_MODULE_14__["ObjectKeys"])(Extensions),
    layoutIsExpanded: true,
    layoutShowControls: true,
    layoutShowRemoteState: true,
    layoutControlsDisplay: 'reactive',
    layoutShowSequence: true,
    layoutShowLog: true,
    layoutShowLeftPanel: true,
    disableAntialiasing: false,
    pixelScale: 1,
    enableWboit: true,
    viewportShowExpand: _mol_plugin_config__WEBPACK_IMPORTED_MODULE_9__["PluginConfig"].Viewport.ShowExpand.defaultValue,
    viewportShowControls: _mol_plugin_config__WEBPACK_IMPORTED_MODULE_9__["PluginConfig"].Viewport.ShowControls.defaultValue,
    viewportShowSettings: _mol_plugin_config__WEBPACK_IMPORTED_MODULE_9__["PluginConfig"].Viewport.ShowSettings.defaultValue,
    viewportShowSelectionMode: _mol_plugin_config__WEBPACK_IMPORTED_MODULE_9__["PluginConfig"].Viewport.ShowSelectionMode.defaultValue,
    viewportShowAnimation: _mol_plugin_config__WEBPACK_IMPORTED_MODULE_9__["PluginConfig"].Viewport.ShowAnimation.defaultValue,
    pluginStateServer: _mol_plugin_config__WEBPACK_IMPORTED_MODULE_9__["PluginConfig"].State.DefaultServer.defaultValue,
    volumeStreamingServer: _mol_plugin_config__WEBPACK_IMPORTED_MODULE_9__["PluginConfig"].VolumeStreaming.DefaultServer.defaultValue,
    volumeStreamingDisabled: !_mol_plugin_config__WEBPACK_IMPORTED_MODULE_9__["PluginConfig"].VolumeStreaming.Enabled.defaultValue,
    pdbProvider: _mol_plugin_config__WEBPACK_IMPORTED_MODULE_9__["PluginConfig"].Download.DefaultPdbProvider.defaultValue,
    emdbProvider: _mol_plugin_config__WEBPACK_IMPORTED_MODULE_9__["PluginConfig"].Download.DefaultEmdbProvider.defaultValue,
};
var Viewer = /** @class */ (function () {
    function Viewer(elementOrId, options) {
        if (options === void 0) { options = {}; }
        var o = Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, DefaultViewerOptions), options);
        var spec = {
            actions: Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__spreadArrays"])(_mol_plugin__WEBPACK_IMPORTED_MODULE_2__["DefaultPluginSpec"].actions),
            behaviors: Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__spreadArrays"])(_mol_plugin__WEBPACK_IMPORTED_MODULE_2__["DefaultPluginSpec"].behaviors, o.extensions.map(function (e) { return Extensions[e]; })),
            animations: Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__spreadArrays"])(_mol_plugin__WEBPACK_IMPORTED_MODULE_2__["DefaultPluginSpec"].animations || []),
            customParamEditors: _mol_plugin__WEBPACK_IMPORTED_MODULE_2__["DefaultPluginSpec"].customParamEditors,
            customFormats: o === null || o === void 0 ? void 0 : o.customFormats,
            layout: {
                initial: {
                    isExpanded: o.layoutIsExpanded,
                    showControls: o.layoutShowControls,
                    controlsDisplay: o.layoutControlsDisplay,
                },
                controls: Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, _mol_plugin__WEBPACK_IMPORTED_MODULE_2__["DefaultPluginSpec"].layout && _mol_plugin__WEBPACK_IMPORTED_MODULE_2__["DefaultPluginSpec"].layout.controls), { top: o.layoutShowSequence ? undefined : 'none', bottom: o.layoutShowLog ? undefined : 'none', left: o.layoutShowLeftPanel ? undefined : 'none' })
            },
            components: Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, _mol_plugin__WEBPACK_IMPORTED_MODULE_2__["DefaultPluginSpec"].components), { remoteState: o.layoutShowRemoteState ? 'default' : 'none' }),
            config: [
                [_mol_plugin_config__WEBPACK_IMPORTED_MODULE_9__["PluginConfig"].General.DisableAntialiasing, o.disableAntialiasing],
                [_mol_plugin_config__WEBPACK_IMPORTED_MODULE_9__["PluginConfig"].General.PixelScale, o.pixelScale],
                [_mol_plugin_config__WEBPACK_IMPORTED_MODULE_9__["PluginConfig"].General.EnableWboit, o.enableWboit],
                [_mol_plugin_config__WEBPACK_IMPORTED_MODULE_9__["PluginConfig"].Viewport.ShowExpand, o.viewportShowExpand],
                [_mol_plugin_config__WEBPACK_IMPORTED_MODULE_9__["PluginConfig"].Viewport.ShowControls, o.viewportShowControls],
                [_mol_plugin_config__WEBPACK_IMPORTED_MODULE_9__["PluginConfig"].Viewport.ShowSettings, o.viewportShowSettings],
                [_mol_plugin_config__WEBPACK_IMPORTED_MODULE_9__["PluginConfig"].Viewport.ShowSelectionMode, o.viewportShowSelectionMode],
                [_mol_plugin_config__WEBPACK_IMPORTED_MODULE_9__["PluginConfig"].Viewport.ShowAnimation, o.viewportShowAnimation],
                [_mol_plugin_config__WEBPACK_IMPORTED_MODULE_9__["PluginConfig"].State.DefaultServer, o.pluginStateServer],
                [_mol_plugin_config__WEBPACK_IMPORTED_MODULE_9__["PluginConfig"].State.CurrentServer, o.pluginStateServer],
                [_mol_plugin_config__WEBPACK_IMPORTED_MODULE_9__["PluginConfig"].VolumeStreaming.DefaultServer, o.volumeStreamingServer],
                [_mol_plugin_config__WEBPACK_IMPORTED_MODULE_9__["PluginConfig"].VolumeStreaming.Enabled, !o.volumeStreamingDisabled],
                [_mol_plugin_config__WEBPACK_IMPORTED_MODULE_9__["PluginConfig"].Download.DefaultPdbProvider, o.pdbProvider],
                [_mol_plugin_config__WEBPACK_IMPORTED_MODULE_9__["PluginConfig"].Download.DefaultEmdbProvider, o.emdbProvider]
            ]
        };
        var element = typeof elementOrId === 'string'
            ? document.getElementById(elementOrId)
            : elementOrId;
        if (!element)
            throw new Error("Could not get element with id '" + elementOrId + "'");
        this.plugin = Object(_mol_plugin__WEBPACK_IMPORTED_MODULE_2__["createPlugin"])(element, spec);
    }
    Viewer.prototype.setRemoteSnapshot = function (id) {
        var url = this.plugin.config.get(_mol_plugin_config__WEBPACK_IMPORTED_MODULE_9__["PluginConfig"].State.CurrentServer) + "/get/" + id;
        return _mol_plugin_commands__WEBPACK_IMPORTED_MODULE_6__["PluginCommands"].State.Snapshots.Fetch(this.plugin, { url: url });
    };
    Viewer.prototype.loadSnapshotFromUrl = function (url, type) {
        return _mol_plugin_commands__WEBPACK_IMPORTED_MODULE_6__["PluginCommands"].State.Snapshots.OpenUrl(this.plugin, { url: url, type: type });
    };
    Viewer.prototype.loadStructureFromUrl = function (url, format, isBinary, options) {
        if (format === void 0) { format = 'mmcif'; }
        if (isBinary === void 0) { isBinary = false; }
        var params = _mol_plugin_state_actions_structure__WEBPACK_IMPORTED_MODULE_8__["DownloadStructure"].createDefaultParams(this.plugin.state.data.root.obj, this.plugin);
        return this.plugin.runTask(this.plugin.state.data.applyAction(_mol_plugin_state_actions_structure__WEBPACK_IMPORTED_MODULE_8__["DownloadStructure"], {
            source: {
                name: 'url',
                params: {
                    url: _mol_util_assets__WEBPACK_IMPORTED_MODULE_13__["Asset"].Url(url),
                    format: format,
                    isBinary: isBinary,
                    options: Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, params.source.params.options), { representationParams: options === null || options === void 0 ? void 0 : options.representationParams }),
                }
            }
        }));
    };
    Viewer.prototype.loadAllModelsOrAssemblyFromUrl = function (url, format, isBinary, options) {
        if (format === void 0) { format = 'mmcif'; }
        if (isBinary === void 0) { isBinary = false; }
        return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"])(this, void 0, void 0, function () {
            var plugin, data, trajectory;
            return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__generator"])(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        plugin = this.plugin;
                        return [4 /*yield*/, plugin.builders.data.download({ url: url, isBinary: isBinary }, { state: { isGhost: true } })];
                    case 1:
                        data = _a.sent();
                        return [4 /*yield*/, plugin.builders.structure.parseTrajectory(data, format)];
                    case 2:
                        trajectory = _a.sent();
                        return [4 /*yield*/, this.plugin.builders.structure.hierarchy.applyPreset(trajectory, 'all-models', { useDefaultIfSingleModel: true, representationPresetParams: options === null || options === void 0 ? void 0 : options.representationParams })];
                    case 3:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    Viewer.prototype.loadStructureFromData = function (data, format, options) {
        return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"])(this, void 0, void 0, function () {
            var _data, trajectory;
            return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__generator"])(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.plugin.builders.data.rawData({ data: data, label: options === null || options === void 0 ? void 0 : options.dataLabel })];
                    case 1:
                        _data = _a.sent();
                        return [4 /*yield*/, this.plugin.builders.structure.parseTrajectory(_data, format)];
                    case 2:
                        trajectory = _a.sent();
                        return [4 /*yield*/, this.plugin.builders.structure.hierarchy.applyPreset(trajectory, 'default')];
                    case 3:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    Viewer.prototype.loadPdb = function (pdb, options) {
        var params = _mol_plugin_state_actions_structure__WEBPACK_IMPORTED_MODULE_8__["DownloadStructure"].createDefaultParams(this.plugin.state.data.root.obj, this.plugin);
        var provider = this.plugin.config.get(_mol_plugin_config__WEBPACK_IMPORTED_MODULE_9__["PluginConfig"].Download.DefaultPdbProvider);
        return this.plugin.runTask(this.plugin.state.data.applyAction(_mol_plugin_state_actions_structure__WEBPACK_IMPORTED_MODULE_8__["DownloadStructure"], {
            source: {
                name: 'pdb',
                params: {
                    provider: {
                        id: pdb,
                        server: {
                            name: provider,
                            params: _mol_plugin_state_actions_structure__WEBPACK_IMPORTED_MODULE_8__["PdbDownloadProvider"][provider].defaultValue
                        }
                    },
                    options: Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, params.source.params.options), { representationParams: options === null || options === void 0 ? void 0 : options.representationParams }),
                }
            }
        }));
    };
    Viewer.prototype.loadPdbDev = function (pdbDev) {
        var params = _mol_plugin_state_actions_structure__WEBPACK_IMPORTED_MODULE_8__["DownloadStructure"].createDefaultParams(this.plugin.state.data.root.obj, this.plugin);
        return this.plugin.runTask(this.plugin.state.data.applyAction(_mol_plugin_state_actions_structure__WEBPACK_IMPORTED_MODULE_8__["DownloadStructure"], {
            source: {
                name: 'pdb-dev',
                params: {
                    provider: {
                        id: pdbDev,
                        encoding: 'bcif',
                    },
                    options: params.source.params.options,
                }
            }
        }));
    };
    Viewer.prototype.loadEmdb = function (emdb, options) {
        var _a;
        var provider = this.plugin.config.get(_mol_plugin_config__WEBPACK_IMPORTED_MODULE_9__["PluginConfig"].Download.DefaultEmdbProvider);
        return this.plugin.runTask(this.plugin.state.data.applyAction(_mol_plugin_state_actions_volume__WEBPACK_IMPORTED_MODULE_15__["DownloadDensity"], {
            source: {
                name: 'pdb-emd-ds',
                params: {
                    provider: {
                        id: emdb,
                        server: provider,
                    },
                    detail: (_a = options === null || options === void 0 ? void 0 : options.detail) !== null && _a !== void 0 ? _a : 3,
                }
            }
        }));
    };
    Viewer.prototype.loadVolumeFromUrl = function (url, format, isBinary, isovalues, entryId) {
        return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"])(this, void 0, void 0, function () {
            var plugin;
            var _this = this;
            return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__generator"])(this, function (_a) {
                plugin = this.plugin;
                if (!plugin.dataFormats.get(format)) {
                    throw new Error("Unknown density format: " + format);
                }
                return [2 /*return*/, plugin.dataTransaction(function () { return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"])(_this, void 0, void 0, function () {
                        var data, parsed, volume, repr, _i, isovalues_1, iso;
                        var _a;
                        return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__generator"])(this, function (_b) {
                            switch (_b.label) {
                                case 0: return [4 /*yield*/, plugin.builders.data.download({ url: url, isBinary: isBinary, label: entryId }, { state: { isGhost: true } })];
                                case 1:
                                    data = _b.sent();
                                    return [4 /*yield*/, plugin.dataFormats.get(format).parse(plugin, data, { entryId: entryId })];
                                case 2:
                                    parsed = _b.sent();
                                    volume = (parsed.volume || parsed.volumes[0]);
                                    if (!(volume === null || volume === void 0 ? void 0 : volume.isOk))
                                        throw new Error('Failed to parse any volume.');
                                    repr = plugin.build().to(volume);
                                    for (_i = 0, isovalues_1 = isovalues; _i < isovalues_1.length; _i++) {
                                        iso = isovalues_1[_i];
                                        repr.apply(_mol_plugin_state_transforms__WEBPACK_IMPORTED_MODULE_19__["StateTransforms"].Representation.VolumeRepresentation3D, Object(_mol_plugin_state_helpers_volume_representation_params__WEBPACK_IMPORTED_MODULE_20__["createVolumeRepresentationParams"])(this.plugin, volume.data, {
                                            type: 'isosurface',
                                            typeParams: { alpha: (_a = iso.alpha) !== null && _a !== void 0 ? _a : 1, isoValue: iso.type === 'absolute' ? { kind: 'absolute', absoluteValue: iso.value } : { kind: 'relative', relativeValue: iso.value } },
                                            color: 'uniform',
                                            colorParams: { value: iso.color }
                                        }));
                                    }
                                    return [4 /*yield*/, repr.commit()];
                                case 3:
                                    _b.sent();
                                    return [2 /*return*/];
                            }
                        });
                    }); })];
            });
        });
    };
    Viewer.prototype.handleResize = function () {
        this.plugin.layout.events.updated.next();
    };
    return Viewer;
}());

//# sourceMappingURL=index.js.map

/***/ }),

/***/ "./lib/extensions/anvil/algorithm.js":
/*!*******************************************!*\
  !*** ./lib/extensions/anvil/algorithm.js ***!
  \*******************************************/
/*! exports provided: ANVILParams, computeANVIL, calculate, isInMembranePlane, isHydrophobic */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ANVILParams", function() { return ANVILParams; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "computeANVIL", function() { return computeANVIL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "calculate", function() { return calculate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isInMembranePlane", function() { return isInMembranePlane; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isHydrophobic", function() { return isHydrophobic; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _mol_model_structure__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../mol-model/structure */ "./lib/mol-model/structure.js");
/* harmony import */ var _mol_task__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../mol-task */ "./lib/mol-task/index.js");
/* harmony import */ var _mol_math_geometry_centroid_helper__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../mol-math/geometry/centroid-helper */ "./lib/mol-math/geometry/centroid-helper.js");
/* harmony import */ var _mol_model_props_computed_accessible_surface_area__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../mol-model-props/computed/accessible-surface-area */ "./lib/mol-model-props/computed/accessible-surface-area.js");
/* harmony import */ var _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../mol-math/linear-algebra */ "./lib/mol-math/linear-algebra.js");
/* harmony import */ var _mol_model_structure_util__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../../mol-model/structure/util */ "./lib/mol-model/structure/util.js");
/* harmony import */ var _mol_model_props_computed_accessible_surface_area_shrake_rupley__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../../mol-model-props/computed/accessible-surface-area/shrake-rupley */ "./lib/mol-model-props/computed/accessible-surface-area/shrake-rupley.js");
/* harmony import */ var _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ../../mol-util/param-definition */ "./lib/mol-util/param-definition.js");
/**
 * Copyright (c) 2020 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author Sebastian Bittrich <sebastian.bittrich@rcsb.org>
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */









;
var ANVILParams = {
    numberOfSpherePoints: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_8__["ParamDefinition"].Numeric(120, { min: 35, max: 700, step: 1 }, { description: 'Number of spheres/directions to test for membrane placement. Original value is 350.' }),
    stepSize: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_8__["ParamDefinition"].Numeric(1, { min: 0.25, max: 4, step: 0.25 }, { description: 'Thickness of membrane slices that will be tested' }),
    minThickness: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_8__["ParamDefinition"].Numeric(20, { min: 10, max: 30, step: 1 }, { description: 'Minimum membrane thickness used during refinement' }),
    maxThickness: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_8__["ParamDefinition"].Numeric(40, { min: 30, max: 50, step: 1 }, { description: 'Maximum membrane thickness used during refinement' }),
    asaCutoff: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_8__["ParamDefinition"].Numeric(40, { min: 10, max: 100, step: 1 }, { description: 'Absolute ASA cutoff above which residues will be considered' })
};
/**
 * Implements:
 * Membrane positioning for high- and low-resolution protein structures through a binary classification approach
 * Guillaume Postic, Yassine Ghouzam, Vincent Guiraud, and Jean-Christophe Gelly
 * Protein Engineering, Design & Selection, 2015, 1–5
 * doi: 10.1093/protein/gzv063
 */
function computeANVIL(structure, props) {
    var _this = this;
    return _mol_task__WEBPACK_IMPORTED_MODULE_2__["Task"].create('Compute Membrane Orientation', function (runtime) { return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"])(_this, void 0, void 0, function () {
        return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__generator"])(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, calculate(runtime, structure, props)];
                case 1: return [2 /*return*/, _a.sent()];
            }
        });
    }); });
}
var l = _mol_model_structure__WEBPACK_IMPORTED_MODULE_1__["StructureElement"].Location.create(void 0);
var centroidHelper = new _mol_math_geometry_centroid_helper__WEBPACK_IMPORTED_MODULE_3__["CentroidHelper"]();
function initialize(structure, props) {
    var _a = _mol_model_structure__WEBPACK_IMPORTED_MODULE_1__["StructureProperties"].atom, label_atom_id = _a.label_atom_id, x = _a.x, y = _a.y, z = _a.z;
    var elementCount = structure.polymerResidueCount;
    centroidHelper.reset();
    l.structure = structure;
    var offsets = new Int32Array(elementCount);
    var exposed = new Array(elementCount);
    var accessibleSurfaceArea = structure && _mol_model_props_computed_accessible_surface_area__WEBPACK_IMPORTED_MODULE_4__["AccessibleSurfaceAreaProvider"].get(structure);
    var asa = accessibleSurfaceArea.value;
    var vec = Object(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_5__["Vec3"])();
    var m = 0;
    for (var i = 0, il = structure.units.length; i < il; ++i) {
        var unit = structure.units[i];
        var elements = unit.elements;
        l.unit = unit;
        for (var j = 0, jl = elements.length; j < jl; ++j) {
            var eI = elements[j];
            l.element = eI;
            // consider only amino acids
            if (Object(_mol_model_structure_util__WEBPACK_IMPORTED_MODULE_6__["getElementMoleculeType"])(unit, eI) !== 5 /* Protein */) {
                continue;
            }
            // only CA is considered for downstream operations
            if (label_atom_id(l) !== 'CA') {
                continue;
            }
            // while iterating use first pass to compute centroid
            _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_5__["Vec3"].set(vec, x(l), y(l), z(l));
            centroidHelper.includeStep(vec);
            // keep track of offsets and exposed state to reuse
            offsets[m] = structure.serialMapping.getSerialIndex(l.unit, l.element);
            exposed[m] = _mol_model_props_computed_accessible_surface_area_shrake_rupley__WEBPACK_IMPORTED_MODULE_7__["AccessibleSurfaceArea"].getValue(l, asa) > props.asaCutoff;
            m++;
        }
    }
    // omit potentially empty tail1
    offsets = offsets.slice(0, m);
    exposed = exposed.slice(0, m);
    // calculate centroid and extent
    centroidHelper.finishedIncludeStep();
    var centroid = centroidHelper.center;
    for (var k = 0, kl = offsets.length; k < kl; k++) {
        setLocation(l, structure, offsets[k]);
        _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_5__["Vec3"].set(vec, x(l), y(l), z(l));
        centroidHelper.radiusStep(vec);
    }
    var extent = 1.2 * Math.sqrt(centroidHelper.radiusSq);
    return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, props), { structure: structure, offsets: offsets, exposed: exposed, centroid: centroid, extent: extent });
}
function calculate(runtime, structure, params) {
    return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"])(this, void 0, void 0, function () {
        var label_comp_id, ctx, initialHphobHphil, initialMembrane, alternativeMembrane, membrane;
        return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__generator"])(this, function (_a) {
            label_comp_id = _mol_model_structure__WEBPACK_IMPORTED_MODULE_1__["StructureProperties"].atom.label_comp_id;
            ctx = initialize(structure, params);
            initialHphobHphil = HphobHphil.filtered(ctx, label_comp_id);
            initialMembrane = findMembrane(ctx, generateSpherePoints(ctx, ctx.numberOfSpherePoints), initialHphobHphil, label_comp_id);
            alternativeMembrane = findMembrane(ctx, findProximateAxes(ctx, initialMembrane), initialHphobHphil, label_comp_id);
            membrane = initialMembrane.qmax > alternativeMembrane.qmax ? initialMembrane : alternativeMembrane;
            return [2 /*return*/, {
                    planePoint1: membrane.planePoint1,
                    planePoint2: membrane.planePoint2,
                    normalVector: membrane.normalVector,
                    radius: ctx.extent,
                    centroid: ctx.centroid
                }];
        });
    });
}
var MembraneCandidate;
(function (MembraneCandidate) {
    function initial(c1, c2, stats) {
        return {
            planePoint1: c1,
            planePoint2: c2,
            stats: stats
        };
    }
    MembraneCandidate.initial = initial;
    function scored(spherePoint, c1, c2, stats, qmax, centroid) {
        var diam_vect = Object(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_5__["Vec3"])();
        _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_5__["Vec3"].sub(diam_vect, centroid, spherePoint);
        return {
            planePoint1: c1,
            planePoint2: c2,
            stats: stats,
            normalVector: diam_vect,
            spherePoint: spherePoint,
            qmax: qmax
        };
    }
    MembraneCandidate.scored = scored;
})(MembraneCandidate || (MembraneCandidate = {}));
function findMembrane(ctx, spherePoints, initialStats, label_comp_id) {
    var centroid = ctx.centroid, stepSize = ctx.stepSize, minThickness = ctx.minThickness, maxThickness = ctx.maxThickness;
    // best performing membrane
    var membrane;
    // score of the best performing membrane
    var qmax = 0;
    // construct slices of thickness 1.0 along the axis connecting the centroid and the spherePoint
    var diam = Object(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_5__["Vec3"])();
    for (var i = 0, il = spherePoints.length; i < il; i++) {
        var spherePoint = spherePoints[i];
        _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_5__["Vec3"].sub(diam, centroid, spherePoint);
        _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_5__["Vec3"].scale(diam, diam, 2);
        var diamNorm = _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_5__["Vec3"].magnitude(diam);
        var qvartemp = [];
        var _loop_1 = function (i_1, il_1) {
            var c1 = Object(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_5__["Vec3"])();
            var c2 = Object(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_5__["Vec3"])();
            _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_5__["Vec3"].scaleAndAdd(c1, spherePoint, diam, i_1 / diamNorm);
            _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_5__["Vec3"].scaleAndAdd(c2, spherePoint, diam, (i_1 + stepSize) / diamNorm);
            // evaluate how well this membrane slice embeddeds the peculiar residues
            var stats = HphobHphil.filtered(ctx, label_comp_id, function (testPoint) { return isInMembranePlane(testPoint, diam, c1, c2); });
            qvartemp.push(MembraneCandidate.initial(c1, c2, stats));
        };
        for (var i_1 = 0, il_1 = diamNorm - stepSize; i_1 < il_1; i_1 += stepSize) {
            _loop_1(i_1, il_1);
        }
        var jmax = (minThickness / stepSize) - 1;
        for (var width = 0, widthl = maxThickness; width < widthl;) {
            var imax = qvartemp.length - 1 - jmax;
            for (var i_2 = 0, il_2 = imax; i_2 < il_2; i_2++) {
                var c1 = qvartemp[i_2].planePoint1;
                var c2 = qvartemp[i_2 + jmax].planePoint2;
                var hphob = 0;
                var hphil = 0;
                var total = 0;
                for (var j = 0; j < jmax; j++) {
                    var ij = qvartemp[i_2 + j];
                    if (j === 0 || j === jmax - 1) {
                        hphob += 0.5 * ij.stats.hphob;
                        hphil += 0.5 * ij.stats.hphil;
                    }
                    else {
                        hphob += ij.stats.hphob;
                        hphil += ij.stats.hphil;
                    }
                    total += ij.stats.total;
                }
                var stats = HphobHphil.of(hphob, hphil, total);
                if (hphob !== 0) {
                    var qvaltest = qValue(stats, initialStats);
                    if (qvaltest > qmax) {
                        qmax = qvaltest;
                        membrane = MembraneCandidate.scored(spherePoint, c1, c2, HphobHphil.of(hphob, hphil, total), qmax, centroid);
                    }
                }
            }
            jmax++;
            width = (jmax + 1) * stepSize;
        }
    }
    return membrane;
}
function qValue(currentStats, initialStats) {
    if (initialStats.hphob < 1) {
        initialStats.hphob = 0.1;
    }
    if (initialStats.hphil < 1) {
        initialStats.hphil += 1;
    }
    var part_tot = currentStats.hphob + currentStats.hphil;
    return (currentStats.hphob * (initialStats.hphil - currentStats.hphil) - currentStats.hphil * (initialStats.hphob - currentStats.hphob)) /
        Math.sqrt(part_tot * initialStats.hphob * initialStats.hphil * (initialStats.hphob + initialStats.hphil - part_tot));
}
function isInMembranePlane(testPoint, normalVector, planePoint1, planePoint2) {
    var d1 = -_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_5__["Vec3"].dot(normalVector, planePoint1);
    var d2 = -_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_5__["Vec3"].dot(normalVector, planePoint2);
    var d = -_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_5__["Vec3"].dot(normalVector, testPoint);
    return d > Math.min(d1, d2) && d < Math.max(d1, d2);
}
// generates a defined number of points on a sphere with radius = extent around the specified centroid
function generateSpherePoints(ctx, numberOfSpherePoints) {
    var centroid = ctx.centroid, extent = ctx.extent;
    var points = [];
    var oldPhi = 0, h, theta, phi;
    for (var k = 1, kl = numberOfSpherePoints + 1; k < kl; k++) {
        h = -1 + 2 * (k - 1) / (numberOfSpherePoints - 1);
        theta = Math.acos(h);
        phi = (k === 1 || k === numberOfSpherePoints) ? 0 : (oldPhi + 3.6 / Math.sqrt(numberOfSpherePoints * (1 - h * h))) % (2 * Math.PI);
        var point = _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_5__["Vec3"].create(extent * Math.sin(phi) * Math.sin(theta) + centroid[0], extent * Math.cos(theta) + centroid[1], extent * Math.cos(phi) * Math.sin(theta) + centroid[2]);
        points[k - 1] = point;
        oldPhi = phi;
    }
    return points;
}
// generates sphere points close to that of the initial membrane
function findProximateAxes(ctx, membrane) {
    var numberOfSpherePoints = ctx.numberOfSpherePoints, extent = ctx.extent;
    var points = generateSpherePoints(ctx, 30000);
    var j = 4;
    var sphere_pts2 = [];
    while (sphere_pts2.length < numberOfSpherePoints) {
        var d = 2 * extent / numberOfSpherePoints + j;
        var dsq = d * d;
        sphere_pts2 = [];
        for (var i = 0, il = points.length; i < il; i++) {
            if (_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_5__["Vec3"].squaredDistance(points[i], membrane.spherePoint) < dsq) {
                sphere_pts2.push(points[i]);
            }
        }
        j += 0.2;
    }
    return sphere_pts2;
}
var HphobHphil;
(function (HphobHphil) {
    function of(hphob, hphil, total) {
        return {
            hphob: hphob,
            hphil: hphil,
            total: !!total ? total : hphob + hphil
        };
    }
    HphobHphil.of = of;
    var testPoint = Object(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_5__["Vec3"])();
    function filtered(ctx, label_comp_id, filter) {
        var offsets = ctx.offsets, exposed = ctx.exposed, structure = ctx.structure;
        var _a = _mol_model_structure__WEBPACK_IMPORTED_MODULE_1__["StructureProperties"].atom, x = _a.x, y = _a.y, z = _a.z;
        var hphob = 0;
        var hphil = 0;
        for (var k = 0, kl = offsets.length; k < kl; k++) {
            // ignore buried residues
            if (!exposed[k]) {
                continue;
            }
            setLocation(l, structure, offsets[k]);
            _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_5__["Vec3"].set(testPoint, x(l), y(l), z(l));
            // testPoints have to be in putative membrane layer
            if (filter && !filter(testPoint)) {
                continue;
            }
            if (isHydrophobic(label_comp_id(l))) {
                hphob++;
            }
            else {
                hphil++;
            }
        }
        return of(hphob, hphil);
    }
    HphobHphil.filtered = filtered;
})(HphobHphil || (HphobHphil = {}));
// ANVIL-specific (not general) definition of membrane-favoring amino acids
var HYDROPHOBIC_AMINO_ACIDS = new Set(['ALA', 'CYS', 'GLY', 'HIS', 'ILE', 'LEU', 'MET', 'PHE', 'SER', 'THR', 'VAL']);
function isHydrophobic(label_comp_id) {
    return HYDROPHOBIC_AMINO_ACIDS.has(label_comp_id);
}
function setLocation(l, structure, serialIndex) {
    l.structure = structure;
    l.unit = structure.units[structure.serialMapping.unitIndices[serialIndex]];
    l.element = structure.serialMapping.elementIndices[serialIndex];
    return l;
}
//# sourceMappingURL=algorithm.js.map

/***/ }),

/***/ "./lib/extensions/anvil/behavior.js":
/*!******************************************!*\
  !*** ./lib/extensions/anvil/behavior.js ***!
  \******************************************/
/*! exports provided: ANVILMembraneOrientation, isTransmembrane, MembraneOrientation3D, MembraneOrientationPreset, tryCreateMembraneOrientation */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ANVILMembraneOrientation", function() { return ANVILMembraneOrientation; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isTransmembrane", function() { return isTransmembrane; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MembraneOrientation3D", function() { return MembraneOrientation3D; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MembraneOrientationPreset", function() { return MembraneOrientationPreset; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "tryCreateMembraneOrientation", function() { return tryCreateMembraneOrientation; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../mol-util/param-definition */ "./lib/mol-util/param-definition.js");
/* harmony import */ var _mol_plugin_state_builder_structure_representation_preset__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../mol-plugin-state/builder/structure/representation-preset */ "./lib/mol-plugin-state/builder/structure/representation-preset.js");
/* harmony import */ var _prop__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./prop */ "./lib/extensions/anvil/prop.js");
/* harmony import */ var _mol_state__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../mol-state */ "./lib/mol-state/index.js");
/* harmony import */ var _mol_task__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../mol-task */ "./lib/mol-task/index.js");
/* harmony import */ var _mol_plugin_behavior__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../../mol-plugin/behavior */ "./lib/mol-plugin/behavior.js");
/* harmony import */ var _representation__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ./representation */ "./lib/extensions/anvil/representation.js");
/* harmony import */ var _mol_theme_color_hydrophobicity__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ../../mol-theme/color/hydrophobicity */ "./lib/mol-theme/color/hydrophobicity.js");
/* harmony import */ var _mol_plugin_state_objects__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ../../mol-plugin-state/objects */ "./lib/mol-plugin-state/objects.js");
/* harmony import */ var _mol_script_runtime_query_compiler__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ../../mol-script/runtime/query/compiler */ "./lib/mol-script/runtime/query/compiler.js");
/* harmony import */ var _mol_plugin_state_helpers_structure_selection_query__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ../../mol-plugin-state/helpers/structure-selection-query */ "./lib/mol-plugin-state/helpers/structure-selection-query.js");
/* harmony import */ var _mol_script_language_builder__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! ../../mol-script/language/builder */ "./lib/mol-script/language/builder.js");
/**
 * Copyright (c) 2020 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 * @author Sebastian Bittrich <sebastian.bittrich@rcsb.org>
 */













var Tag = _prop__WEBPACK_IMPORTED_MODULE_3__["MembraneOrientation"].Tag;
var ANVILMembraneOrientation = _mol_plugin_behavior__WEBPACK_IMPORTED_MODULE_6__["PluginBehavior"].create({
    name: 'anvil-membrane-orientation-prop',
    category: 'custom-props',
    display: {
        name: 'Membrane Orientation',
        description: 'Data calculated with ANVIL algorithm.'
    },
    ctor: /** @class */ (function (_super) {
        Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__extends"])(class_1, _super);
        function class_1() {
            var _this = _super !== null && _super.apply(this, arguments) || this;
            _this.provider = _prop__WEBPACK_IMPORTED_MODULE_3__["MembraneOrientationProvider"];
            return _this;
        }
        class_1.prototype.register = function () {
            _mol_script_runtime_query_compiler__WEBPACK_IMPORTED_MODULE_10__["DefaultQueryRuntimeTable"].addCustomProp(this.provider.descriptor);
            this.ctx.customStructureProperties.register(this.provider, this.params.autoAttach);
            this.ctx.representation.structure.registry.add(_representation__WEBPACK_IMPORTED_MODULE_7__["MembraneOrientationRepresentationProvider"]);
            this.ctx.query.structure.registry.add(isTransmembrane);
            this.ctx.genericRepresentationControls.set(Tag.Representation, function (selection) {
                var refs = [];
                selection.structures.forEach(function (structure) {
                    var _a;
                    var memRepr = (_a = structure.genericRepresentations) === null || _a === void 0 ? void 0 : _a.filter(function (r) { return r.cell.transform.transformer.id === MembraneOrientation3D.id; })[0];
                    if (memRepr)
                        refs.push(memRepr);
                });
                return [refs, 'Membrane Orientation'];
            });
            this.ctx.builders.structure.representation.registerPreset(MembraneOrientationPreset);
        };
        class_1.prototype.update = function (p) {
            var updated = this.params.autoAttach !== p.autoAttach;
            this.params.autoAttach = p.autoAttach;
            this.ctx.customStructureProperties.setDefaultAutoAttach(this.provider.descriptor.name, this.params.autoAttach);
            return updated;
        };
        class_1.prototype.unregister = function () {
            _mol_script_runtime_query_compiler__WEBPACK_IMPORTED_MODULE_10__["DefaultQueryRuntimeTable"].removeCustomProp(this.provider.descriptor);
            this.ctx.customStructureProperties.unregister(this.provider.descriptor.name);
            this.ctx.representation.structure.registry.remove(_representation__WEBPACK_IMPORTED_MODULE_7__["MembraneOrientationRepresentationProvider"]);
            this.ctx.query.structure.registry.remove(isTransmembrane);
            this.ctx.genericRepresentationControls.delete(Tag.Representation);
            this.ctx.builders.structure.representation.unregisterPreset(MembraneOrientationPreset);
        };
        return class_1;
    }(_mol_plugin_behavior__WEBPACK_IMPORTED_MODULE_6__["PluginBehavior"].Handler)),
    params: function () { return ({
        autoAttach: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_1__["ParamDefinition"].Boolean(false)
    }); }
});
//
var isTransmembrane = Object(_mol_plugin_state_helpers_structure_selection_query__WEBPACK_IMPORTED_MODULE_11__["StructureSelectionQuery"])('Residues Embedded in Membrane', _mol_script_language_builder__WEBPACK_IMPORTED_MODULE_12__["MolScriptBuilder"].struct.modifier.union([
    _mol_script_language_builder__WEBPACK_IMPORTED_MODULE_12__["MolScriptBuilder"].struct.modifier.wholeResidues([
        _mol_script_language_builder__WEBPACK_IMPORTED_MODULE_12__["MolScriptBuilder"].struct.modifier.union([
            _mol_script_language_builder__WEBPACK_IMPORTED_MODULE_12__["MolScriptBuilder"].struct.generator.atomGroups({
                'chain-test': _mol_script_language_builder__WEBPACK_IMPORTED_MODULE_12__["MolScriptBuilder"].core.rel.eq([_mol_script_language_builder__WEBPACK_IMPORTED_MODULE_12__["MolScriptBuilder"].ammp('objectPrimitive'), 'atomistic']),
                'atom-test': _prop__WEBPACK_IMPORTED_MODULE_3__["MembraneOrientation"].symbols.isTransmembrane.symbol(),
            })
        ])
    ])
]), {
    description: 'Select residues that are embedded between the membrane layers.',
    category: _mol_plugin_state_helpers_structure_selection_query__WEBPACK_IMPORTED_MODULE_11__["StructureSelectionCategory"].Residue,
    ensureCustomProperties: function (ctx, structure) {
        return _prop__WEBPACK_IMPORTED_MODULE_3__["MembraneOrientationProvider"].attach(ctx, structure);
    }
});
//

var MembraneOrientation3D = _mol_plugin_state_objects__WEBPACK_IMPORTED_MODULE_9__["PluginStateTransform"].BuiltIn({
    name: 'membrane-orientation-3d',
    display: {
        name: 'Membrane Orientation',
        description: 'Membrane Orientation planes and rims. Data calculated with ANVIL algorithm.'
    },
    from: _mol_plugin_state_objects__WEBPACK_IMPORTED_MODULE_9__["PluginStateObject"].Molecule.Structure,
    to: _mol_plugin_state_objects__WEBPACK_IMPORTED_MODULE_9__["PluginStateObject"].Shape.Representation3D,
    params: function (a) {
        return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, _representation__WEBPACK_IMPORTED_MODULE_7__["MembraneOrientationParams"]);
    }
})({
    canAutoUpdate: function (_a) {
        var oldParams = _a.oldParams, newParams = _a.newParams;
        return true;
    },
    apply: function (_a, plugin) {
        var _this = this;
        var a = _a.a, params = _a.params;
        return _mol_task__WEBPACK_IMPORTED_MODULE_5__["Task"].create('Membrane Orientation', function (ctx) { return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"])(_this, void 0, void 0, function () {
            var repr;
            var _a;
            return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__generator"])(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, _prop__WEBPACK_IMPORTED_MODULE_3__["MembraneOrientationProvider"].attach({ runtime: ctx, assetManager: plugin.managers.asset }, a.data)];
                    case 1:
                        _b.sent();
                        repr = Object(_representation__WEBPACK_IMPORTED_MODULE_7__["MembraneOrientationRepresentation"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({ webgl: (_a = plugin.canvas3d) === null || _a === void 0 ? void 0 : _a.webgl }, plugin.representation.structure.themes), function () { return _representation__WEBPACK_IMPORTED_MODULE_7__["MembraneOrientationParams"]; });
                        return [4 /*yield*/, repr.createOrUpdate(params, a.data).runInContext(ctx)];
                    case 2:
                        _b.sent();
                        return [2 /*return*/, new _mol_plugin_state_objects__WEBPACK_IMPORTED_MODULE_9__["PluginStateObject"].Shape.Representation3D({ repr: repr, source: a }, { label: 'Membrane Orientation' })];
                }
            });
        }); });
    },
    update: function (_a, plugin) {
        var _this = this;
        var a = _a.a, b = _a.b, newParams = _a.newParams;
        return _mol_task__WEBPACK_IMPORTED_MODULE_5__["Task"].create('Membrane Orientation', function (ctx) { return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"])(_this, void 0, void 0, function () {
            var props;
            return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__generator"])(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, _prop__WEBPACK_IMPORTED_MODULE_3__["MembraneOrientationProvider"].attach({ runtime: ctx, assetManager: plugin.managers.asset }, a.data)];
                    case 1:
                        _a.sent();
                        props = Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, b.data.repr.props), newParams);
                        return [4 /*yield*/, b.data.repr.createOrUpdate(props, a.data).runInContext(ctx)];
                    case 2:
                        _a.sent();
                        return [2 /*return*/, _mol_state__WEBPACK_IMPORTED_MODULE_4__["StateTransformer"].UpdateResult.Updated];
                }
            });
        }); });
    },
    isApplicable: function (a) {
        return _prop__WEBPACK_IMPORTED_MODULE_3__["MembraneOrientationProvider"].isApplicable(a.data);
    }
});
var MembraneOrientationPreset = Object(_mol_plugin_state_builder_structure_representation_preset__WEBPACK_IMPORTED_MODULE_2__["StructureRepresentationPresetProvider"])({
    id: 'preset-membrane-orientation',
    display: {
        name: 'Membrane Orientation', group: 'Annotation',
        description: 'Shows orientation of membrane layers. Data calculated with ANVIL algorithm.' // TODO add ' or obtained via RCSB PDB'
    },
    isApplicable: function (a) {
        return _prop__WEBPACK_IMPORTED_MODULE_3__["MembraneOrientationProvider"].isApplicable(a.data);
    },
    params: function () { return _mol_plugin_state_builder_structure_representation_preset__WEBPACK_IMPORTED_MODULE_2__["StructureRepresentationPresetProvider"].CommonParams; },
    apply: function (ref, params, plugin) {
        var _a;
        return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"])(this, void 0, void 0, function () {
            var structureCell, structure, membraneOrientation, colorTheme, preset;
            var _this = this;
            return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__generator"])(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        structureCell = _mol_state__WEBPACK_IMPORTED_MODULE_4__["StateObjectRef"].resolveAndCheck(plugin.state.data, ref);
                        structure = (_a = structureCell === null || structureCell === void 0 ? void 0 : structureCell.obj) === null || _a === void 0 ? void 0 : _a.data;
                        if (!structureCell || !structure)
                            return [2 /*return*/, {}];
                        if (!!_prop__WEBPACK_IMPORTED_MODULE_3__["MembraneOrientationProvider"].get(structure).value) return [3 /*break*/, 2];
                        return [4 /*yield*/, plugin.runTask(_mol_task__WEBPACK_IMPORTED_MODULE_5__["Task"].create('Membrane Orientation', function (runtime) { return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"])(_this, void 0, void 0, function () {
                                return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__generator"])(this, function (_a) {
                                    switch (_a.label) {
                                        case 0: return [4 /*yield*/, _prop__WEBPACK_IMPORTED_MODULE_3__["MembraneOrientationProvider"].attach({ runtime: runtime, assetManager: plugin.managers.asset }, structure)];
                                        case 1:
                                            _a.sent();
                                            return [2 /*return*/];
                                    }
                                });
                            }); }))];
                    case 1:
                        _b.sent();
                        _b.label = 2;
                    case 2: return [4 /*yield*/, tryCreateMembraneOrientation(plugin, structureCell)];
                    case 3:
                        membraneOrientation = _b.sent();
                        colorTheme = _mol_theme_color_hydrophobicity__WEBPACK_IMPORTED_MODULE_8__["HydrophobicityColorThemeProvider"].name;
                        return [4 /*yield*/, _mol_plugin_state_builder_structure_representation_preset__WEBPACK_IMPORTED_MODULE_2__["PresetStructureRepresentations"].auto.apply(ref, Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, params), { theme: { globalName: colorTheme, focus: { name: colorTheme } } }), plugin)];
                    case 4:
                        preset = _b.sent();
                        return [2 /*return*/, { components: preset.components, representations: Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, preset.representations), { membraneOrientation: membraneOrientation }) }];
                }
            });
        });
    }
});
function tryCreateMembraneOrientation(plugin, structure, params, initialState) {
    var state = plugin.state.data;
    var membraneOrientation = state.build().to(structure)
        .applyOrUpdateTagged('membrane-orientation-3d', MembraneOrientation3D, params, { state: initialState });
    return membraneOrientation.commit({ revertOnError: true });
}
//# sourceMappingURL=behavior.js.map

/***/ }),

/***/ "./lib/extensions/anvil/prop.js":
/*!**************************************!*\
  !*** ./lib/extensions/anvil/prop.js ***!
  \**************************************/
/*! exports provided: MembraneOrientationParams, MembraneOrientation, MembraneOrientationProvider */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MembraneOrientationParams", function() { return MembraneOrientationParams; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MembraneOrientation", function() { return MembraneOrientation; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MembraneOrientationProvider", function() { return MembraneOrientationProvider; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../mol-util/param-definition */ "./lib/mol-util/param-definition.js");
/* harmony import */ var _mol_model_structure__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../mol-model/structure */ "./lib/mol-model/structure.js");
/* harmony import */ var _mol_model_custom_property__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../mol-model/custom-property */ "./lib/mol-model/custom-property.js");
/* harmony import */ var _algorithm__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./algorithm */ "./lib/extensions/anvil/algorithm.js");
/* harmony import */ var _mol_model_props_common_custom_structure_property__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../mol-model-props/common/custom-structure-property */ "./lib/mol-model-props/common/custom-structure-property.js");
/* harmony import */ var _mol_model_props_computed_accessible_surface_area__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../../mol-model-props/computed/accessible-surface-area */ "./lib/mol-model-props/computed/accessible-surface-area.js");
/* harmony import */ var _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../../mol-math/linear-algebra */ "./lib/mol-math/linear-algebra.js");
/* harmony import */ var _mol_script_runtime_query_base__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ../../mol-script/runtime/query/base */ "./lib/mol-script/runtime/query/base.js");
/* harmony import */ var _mol_script_language_symbol__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ../../mol-script/language/symbol */ "./lib/mol-script/language/symbol.js");
/* harmony import */ var _mol_script_language_type__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ../../mol-script/language/type */ "./lib/mol-script/language/type.js");
/**
 * Copyright (c) 2020 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author Sebastian Bittrich <sebastian.bittrich@rcsb.org>
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */











var MembraneOrientationParams = Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, _algorithm__WEBPACK_IMPORTED_MODULE_4__["ANVILParams"]);

var MembraneOrientation;
(function (MembraneOrientation) {
    var Tag;
    (function (Tag) {
        Tag["Representation"] = "membrane-orientation-3d";
    })(Tag = MembraneOrientation.Tag || (MembraneOrientation.Tag = {}));
    var pos = Object(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_7__["Vec3"])();
    MembraneOrientation.symbols = {
        isTransmembrane: _mol_script_runtime_query_base__WEBPACK_IMPORTED_MODULE_8__["QuerySymbolRuntime"].Dynamic(Object(_mol_script_language_symbol__WEBPACK_IMPORTED_MODULE_9__["CustomPropSymbol"])('computed', 'membrane-orientation.is-transmembrane', _mol_script_language_type__WEBPACK_IMPORTED_MODULE_10__["default"].Bool), function (ctx) {
            var _a = ctx.element, unit = _a.unit, structure = _a.structure;
            var _b = _mol_model_structure__WEBPACK_IMPORTED_MODULE_2__["StructureProperties"].atom, x = _b.x, y = _b.y, z = _b.z;
            if (!_mol_model_structure__WEBPACK_IMPORTED_MODULE_2__["Unit"].isAtomic(unit))
                return 0;
            var membraneOrientation = MembraneOrientationProvider.get(structure).value;
            if (!membraneOrientation)
                return 0;
            _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_7__["Vec3"].set(pos, x(ctx.element), y(ctx.element), z(ctx.element));
            var _c = membraneOrientation, normalVector = _c.normalVector, planePoint1 = _c.planePoint1, planePoint2 = _c.planePoint2;
            return Object(_algorithm__WEBPACK_IMPORTED_MODULE_4__["isInMembranePlane"])(pos, normalVector, planePoint1, planePoint2);
        })
    };
})(MembraneOrientation || (MembraneOrientation = {}));
var MembraneOrientationProvider = _mol_model_props_common_custom_structure_property__WEBPACK_IMPORTED_MODULE_5__["CustomStructureProperty"].createProvider({
    label: 'Membrane Orientation',
    descriptor: Object(_mol_model_custom_property__WEBPACK_IMPORTED_MODULE_3__["CustomPropertyDescriptor"])({
        name: 'anvil_computed_membrane_orientation',
        symbols: MembraneOrientation.symbols,
    }),
    type: 'root',
    defaultParams: MembraneOrientationParams,
    getParams: function (data) { return MembraneOrientationParams; },
    isApplicable: function (data) { return true; },
    obtain: function (ctx, data, props) { return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"])(void 0, void 0, void 0, function () {
        var p;
        var _a;
        return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__generator"])(this, function (_b) {
            switch (_b.label) {
                case 0:
                    p = Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_1__["ParamDefinition"].getDefaultValues(MembraneOrientationParams)), props);
                    _a = {};
                    return [4 /*yield*/, computeAnvil(ctx, data, p)];
                case 1: return [2 /*return*/, (_a.value = _b.sent(), _a)];
            }
        });
    }); }
});
function computeAnvil(ctx, data, props) {
    return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"])(this, void 0, void 0, function () {
        var p;
        return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__generator"])(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, _mol_model_props_computed_accessible_surface_area__WEBPACK_IMPORTED_MODULE_6__["AccessibleSurfaceAreaProvider"].attach(ctx, data)];
                case 1:
                    _a.sent();
                    p = Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_1__["ParamDefinition"].getDefaultValues(_algorithm__WEBPACK_IMPORTED_MODULE_4__["ANVILParams"])), props);
                    return [4 /*yield*/, Object(_algorithm__WEBPACK_IMPORTED_MODULE_4__["computeANVIL"])(data, p).runInContext(ctx.runtime)];
                case 2: return [2 /*return*/, _a.sent()];
            }
        });
    });
}
//# sourceMappingURL=prop.js.map

/***/ }),

/***/ "./lib/extensions/anvil/representation.js":
/*!************************************************!*\
  !*** ./lib/extensions/anvil/representation.js ***!
  \************************************************/
/*! exports provided: MembraneOrientationParams, getMembraneOrientationParams, MembraneOrientationRepresentation, MembraneOrientationRepresentationProvider */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MembraneOrientationParams", function() { return MembraneOrientationParams; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getMembraneOrientationParams", function() { return getMembraneOrientationParams; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MembraneOrientationRepresentation", function() { return MembraneOrientationRepresentation; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MembraneOrientationRepresentationProvider", function() { return MembraneOrientationRepresentationProvider; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../mol-util/param-definition */ "./lib/mol-util/param-definition.js");
/* harmony import */ var _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../mol-math/linear-algebra */ "./lib/mol-math/linear-algebra.js");
/* harmony import */ var _mol_repr_representation__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../mol-repr/representation */ "./lib/mol-repr/representation.js");
/* harmony import */ var _mol_model_structure__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../mol-model/structure */ "./lib/mol-model/structure.js");
/* harmony import */ var _mol_geo_geometry_spheres_spheres__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../mol-geo/geometry/spheres/spheres */ "./lib/mol-geo/geometry/spheres/spheres.js");
/* harmony import */ var _mol_repr_structure_representation__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../../mol-repr/structure/representation */ "./lib/mol-repr/structure/representation.js");
/* harmony import */ var _mol_repr_shape_representation__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../../mol-repr/shape/representation */ "./lib/mol-repr/shape/representation.js");
/* harmony import */ var _mol_model_shape__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ../../mol-model/shape */ "./lib/mol-model/shape.js");
/* harmony import */ var _mol_geo_geometry_lines_lines__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ../../mol-geo/geometry/lines/lines */ "./lib/mol-geo/geometry/lines/lines.js");
/* harmony import */ var _mol_geo_geometry_mesh_mesh__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ../../mol-geo/geometry/mesh/mesh */ "./lib/mol-geo/geometry/mesh/mesh.js");
/* harmony import */ var _mol_geo_geometry_lines_lines_builder__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ../../mol-geo/geometry/lines/lines-builder */ "./lib/mol-geo/geometry/lines/lines-builder.js");
/* harmony import */ var _mol_geo_primitive_circle__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! ../../mol-geo/primitive/circle */ "./lib/mol-geo/primitive/circle.js");
/* harmony import */ var _mol_geo_primitive_primitive__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! ../../mol-geo/primitive/primitive */ "./lib/mol-geo/primitive/primitive.js");
/* harmony import */ var _mol_geo_geometry_mesh_mesh_builder__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! ../../mol-geo/geometry/mesh/mesh-builder */ "./lib/mol-geo/geometry/mesh/mesh-builder.js");
/* harmony import */ var _prop__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! ./prop */ "./lib/extensions/anvil/prop.js");
/* harmony import */ var _mol_util_marker_action__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(/*! ../../mol-util/marker-action */ "./lib/mol-util/marker-action.js");
/* harmony import */ var _mol_theme_label__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(/*! ../../mol-theme/label */ "./lib/mol-theme/label.js");
/* harmony import */ var _mol_util_color_names__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(/*! ../../mol-util/color/names */ "./lib/mol-util/color/names.js");
/**
 * Copyright (c) 2020 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 * @author Sebastian Bittrich <sebastian.bittrich@rcsb.org>
 */



















var SharedParams = {
    color: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_1__["ParamDefinition"].Color(_mol_util_color_names__WEBPACK_IMPORTED_MODULE_18__["ColorNames"].lightgrey),
    radiusFactor: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_1__["ParamDefinition"].Numeric(0.8333, { min: 0.1, max: 3.0, step: 0.01 }, { description: 'Scale the radius of the membrane layer' })
};
var BilayerSpheresParams = Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, _mol_geo_geometry_spheres_spheres__WEBPACK_IMPORTED_MODULE_5__["Spheres"].Params), SharedParams), { sphereSize: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_1__["ParamDefinition"].Numeric(1, { min: 0.1, max: 10, step: 0.1 }, { description: 'Size of spheres that represent membrane planes' }), density: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_1__["ParamDefinition"].Numeric(1, { min: 0.25, max: 10, step: 0.25 }, { description: 'Distance between spheres' }) });
var BilayerPlanesParams = Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, _mol_geo_geometry_mesh_mesh__WEBPACK_IMPORTED_MODULE_10__["Mesh"].Params), SharedParams), { sectorOpacity: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_1__["ParamDefinition"].Numeric(0.5, { min: 0, max: 1, step: 0.01 }) });
var BilayerRimsParams = Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, _mol_geo_geometry_lines_lines__WEBPACK_IMPORTED_MODULE_9__["Lines"].Params), SharedParams), { lineSizeAttenuation: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_1__["ParamDefinition"].Boolean(true), linesSize: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_1__["ParamDefinition"].Numeric(0.3, { min: 0.01, max: 50, step: 0.01 }), dashedLines: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_1__["ParamDefinition"].Boolean(true) });
var MembraneOrientationVisuals = {
    'bilayer-planes': function (ctx, getParams) { return Object(_mol_repr_shape_representation__WEBPACK_IMPORTED_MODULE_7__["ShapeRepresentation"])(getBilayerPlanes, _mol_geo_geometry_mesh_mesh__WEBPACK_IMPORTED_MODULE_10__["Mesh"].Utils, { modifyState: function (s) { return (Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, s), { markerActions: _mol_util_marker_action__WEBPACK_IMPORTED_MODULE_16__["MarkerActions"].Highlighting })); }, modifyProps: function (p) { return (Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, p), { alpha: p.sectorOpacity, ignoreLight: true, doubleSided: false })); } }); },
    'bilayer-rims': function (ctx, getParams) { return Object(_mol_repr_shape_representation__WEBPACK_IMPORTED_MODULE_7__["ShapeRepresentation"])(getBilayerRims, _mol_geo_geometry_lines_lines__WEBPACK_IMPORTED_MODULE_9__["Lines"].Utils, { modifyState: function (s) { return (Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, s), { markerActions: _mol_util_marker_action__WEBPACK_IMPORTED_MODULE_16__["MarkerActions"].Highlighting })); } }); }
};
var MembraneOrientationParams = Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, BilayerSpheresParams), BilayerPlanesParams), BilayerRimsParams), { visuals: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_1__["ParamDefinition"].MultiSelect(['bilayer-planes', 'bilayer-rims'], _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_1__["ParamDefinition"].objectToOptions(MembraneOrientationVisuals)) });
function getMembraneOrientationParams(ctx, structure) {
    return _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_1__["ParamDefinition"].clone(MembraneOrientationParams);
}
function MembraneOrientationRepresentation(ctx, getParams) {
    return _mol_repr_representation__WEBPACK_IMPORTED_MODULE_3__["Representation"].createMulti('Membrane Orientation', ctx, getParams, _mol_repr_structure_representation__WEBPACK_IMPORTED_MODULE_6__["StructureRepresentationStateBuilder"], MembraneOrientationVisuals);
}
var MembraneOrientationRepresentationProvider = Object(_mol_repr_structure_representation__WEBPACK_IMPORTED_MODULE_6__["StructureRepresentationProvider"])({
    name: 'membrane-orientation',
    label: 'Membrane Orientation',
    description: 'Displays a grid of points representing membrane layers.',
    factory: MembraneOrientationRepresentation,
    getParams: getMembraneOrientationParams,
    defaultValues: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_1__["ParamDefinition"].getDefaultValues(MembraneOrientationParams),
    defaultColorTheme: { name: 'shape-group' },
    defaultSizeTheme: { name: 'shape-group' },
    isApplicable: function (structure) { return structure.elementCount > 0; },
    ensureCustomProperties: {
        attach: function (ctx, structure) { return _prop__WEBPACK_IMPORTED_MODULE_15__["MembraneOrientationProvider"].attach(ctx, structure, void 0, true); },
        detach: function (data) { return _prop__WEBPACK_IMPORTED_MODULE_15__["MembraneOrientationProvider"].ref(data, false); }
    }
});
function membraneLabel(data) {
    return Object(_mol_theme_label__WEBPACK_IMPORTED_MODULE_17__["lociLabel"])(_mol_model_structure__WEBPACK_IMPORTED_MODULE_4__["Structure"].Loci(data)) + " | Membrane Orientation";
}
function getBilayerRims(ctx, data, props, shape) {
    var _a = _prop__WEBPACK_IMPORTED_MODULE_15__["MembraneOrientationProvider"].get(data).value, p1 = _a.planePoint1, p2 = _a.planePoint2, centroid = _a.centroid, normal = _a.normalVector, radius = _a.radius;
    var scaledRadius = props.radiusFactor * radius;
    var builder = _mol_geo_geometry_lines_lines_builder__WEBPACK_IMPORTED_MODULE_11__["LinesBuilder"].create(128, 64, shape === null || shape === void 0 ? void 0 : shape.geometry);
    getLayerCircle(builder, p1, centroid, normal, scaledRadius, props);
    getLayerCircle(builder, p2, centroid, normal, scaledRadius, props);
    return _mol_model_shape__WEBPACK_IMPORTED_MODULE_8__["Shape"].create('Bilayer rims', data, builder.getLines(), function () { return props.color; }, function () { return props.linesSize; }, function () { return membraneLabel(data); });
}
function getLayerCircle(builder, p, centroid, normal, radius, props, shape) {
    var circle = getCircle(p, centroid, normal, radius);
    var indices = circle.indices, vertices = circle.vertices;
    for (var j = 0, jl = indices.length; j < jl; j += 3) {
        if (props.dashedLines && j % 2 === 1)
            continue; // draw every other segment to get dashes
        var start = indices[j] * 3;
        var end = indices[j + 1] * 3;
        var startX = vertices[start];
        var startY = vertices[start + 1];
        var startZ = vertices[start + 2];
        var endX = vertices[end];
        var endY = vertices[end + 1];
        var endZ = vertices[end + 2];
        builder.add(startX, startY, startZ, endX, endY, endZ, 0);
    }
}
var tmpMat = Object(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_2__["Mat4"])();
function getCircle(p, centroid, normal, radius) {
    _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_2__["Mat4"].targetTo(tmpMat, p, centroid, normal);
    _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_2__["Mat4"].setTranslation(tmpMat, p);
    _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_2__["Mat4"].mul(tmpMat, tmpMat, _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_2__["Mat4"].rotX90);
    var circle = Object(_mol_geo_primitive_circle__WEBPACK_IMPORTED_MODULE_12__["Circle"])({ radius: radius, segments: 64 });
    return Object(_mol_geo_primitive_primitive__WEBPACK_IMPORTED_MODULE_13__["transformPrimitive"])(circle, tmpMat);
}
function getBilayerPlanes(ctx, data, props, shape) {
    var _a = _prop__WEBPACK_IMPORTED_MODULE_15__["MembraneOrientationProvider"].get(data).value, p1 = _a.planePoint1, p2 = _a.planePoint2, centroid = _a.centroid, normal = _a.normalVector, radius = _a.radius;
    var state = _mol_geo_geometry_mesh_mesh_builder__WEBPACK_IMPORTED_MODULE_14__["MeshBuilder"].createState(128, 64, shape && shape.geometry);
    var scaledRadius = props.radiusFactor * radius;
    getLayerPlane(state, p1, centroid, normal, scaledRadius);
    getLayerPlane(state, p2, centroid, normal, scaledRadius);
    return _mol_model_shape__WEBPACK_IMPORTED_MODULE_8__["Shape"].create('Bilayer planes', data, _mol_geo_geometry_mesh_mesh_builder__WEBPACK_IMPORTED_MODULE_14__["MeshBuilder"].getMesh(state), function () { return props.color; }, function () { return 1; }, function () { return membraneLabel(data); });
}
function getLayerPlane(state, p, centroid, normal, radius) {
    var circle = getCircle(p, centroid, normal, radius);
    state.currentGroup = 0;
    _mol_geo_geometry_mesh_mesh_builder__WEBPACK_IMPORTED_MODULE_14__["MeshBuilder"].addPrimitive(state, _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_2__["Mat4"].id, circle);
    _mol_geo_geometry_mesh_mesh_builder__WEBPACK_IMPORTED_MODULE_14__["MeshBuilder"].addPrimitiveFlipped(state, _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_2__["Mat4"].id, circle);
}
//# sourceMappingURL=representation.js.map

/***/ }),

/***/ "./lib/extensions/cellpack/color/generate.js":
/*!***************************************************!*\
  !*** ./lib/extensions/cellpack/color/generate.js ***!
  \***************************************************/
/*! exports provided: CellPackGenerateColorThemeParams, getCellPackGenerateColorThemeParams, CellPackGenerateColorTheme, CellPackGenerateColorThemeProvider */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CellPackGenerateColorThemeParams", function() { return CellPackGenerateColorThemeParams; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getCellPackGenerateColorThemeParams", function() { return getCellPackGenerateColorThemeParams; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CellPackGenerateColorTheme", function() { return CellPackGenerateColorTheme; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CellPackGenerateColorThemeProvider", function() { return CellPackGenerateColorThemeProvider; });
/* harmony import */ var _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../../mol-util/param-definition */ "./lib/mol-util/param-definition.js");
/* harmony import */ var _mol_util_color__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../../mol-util/color */ "./lib/mol-util/color/index.js");
/* harmony import */ var _mol_util_color_palette__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../../mol-util/color/palette */ "./lib/mol-util/color/palette.js");
/* harmony import */ var _mol_model_structure__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../../mol-model/structure */ "./lib/mol-model/structure.js");
/* harmony import */ var _property__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../property */ "./lib/extensions/cellpack/property.js");
/* harmony import */ var _mol_util_color_distinct__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../../mol-util/color/distinct */ "./lib/mol-util/color/distinct.js");
/* harmony import */ var _mol_util_color_spaces_hcl__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../../../mol-util/color/spaces/hcl */ "./lib/mol-util/color/spaces/hcl.js");
/**
 * Copyright (c) 2020-2021 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */







var DefaultColor = Object(_mol_util_color__WEBPACK_IMPORTED_MODULE_1__["Color"])(0xCCCCCC);
var Description = 'Gives every model in a CellPack packing a unique generated color similar to other models in the packing.';
var CellPackGenerateColorThemeParams = {};
function getCellPackGenerateColorThemeParams(ctx) {
    return CellPackGenerateColorThemeParams; // TODO return copy
}
function CellPackGenerateColorTheme(ctx, props) {
    var color;
    var legend;
    var info = ctx.structure && _property__WEBPACK_IMPORTED_MODULE_4__["CellPackInfoProvider"].get(ctx.structure).value;
    if (ctx.structure && info) {
        var colors = Object(_mol_util_color_distinct__WEBPACK_IMPORTED_MODULE_5__["distinctColors"])(info.packingsCount);
        var hcl = _mol_util_color_spaces_hcl__WEBPACK_IMPORTED_MODULE_6__["Hcl"].fromColor(Object(_mol_util_color_spaces_hcl__WEBPACK_IMPORTED_MODULE_6__["Hcl"])(), colors[info.packingIndex]);
        var hue = [Math.max(0, hcl[0] - 35), Math.min(360, hcl[0] + 35)];
        var models = ctx.structure.root.models;
        var size = 0;
        for (var _i = 0, models_1 = models; _i < models_1.length; _i++) {
            var m = models_1[_i];
            size = Math.max(size, _mol_model_structure__WEBPACK_IMPORTED_MODULE_3__["Model"].TrajectoryInfo.get(m).size);
        }
        var palette = Object(_mol_util_color_palette__WEBPACK_IMPORTED_MODULE_2__["getPalette"])(size, { palette: {
                name: 'generate',
                params: {
                    hue: hue,
                    chroma: [30, 80], luminance: [15, 85],
                    clusteringStepCount: 50, minSampleCount: 800, maxCount: 75
                }
            } }, { minLabel: 'Min', maxLabel: 'Max' });
        legend = palette.legend;
        var modelColor_1 = new Map();
        for (var i = 0, il = models.length; i < il; ++i) {
            var idx = _mol_model_structure__WEBPACK_IMPORTED_MODULE_3__["Model"].TrajectoryInfo.get(models[i]).index;
            modelColor_1.set(_mol_model_structure__WEBPACK_IMPORTED_MODULE_3__["Model"].TrajectoryInfo.get(models[i]).index, palette.color(idx));
        }
        color = function (location) {
            if (_mol_model_structure__WEBPACK_IMPORTED_MODULE_3__["StructureElement"].Location.is(location)) {
                return modelColor_1.get(_mol_model_structure__WEBPACK_IMPORTED_MODULE_3__["Model"].TrajectoryInfo.get(location.unit.model).index);
            }
            else if (_mol_model_structure__WEBPACK_IMPORTED_MODULE_3__["Bond"].isLocation(location)) {
                return modelColor_1.get(_mol_model_structure__WEBPACK_IMPORTED_MODULE_3__["Model"].TrajectoryInfo.get(location.aUnit.model).index);
            }
            return DefaultColor;
        };
    }
    else {
        color = function () { return DefaultColor; };
    }
    return {
        factory: CellPackGenerateColorTheme,
        granularity: 'instance',
        color: color,
        props: props,
        description: Description,
        legend: legend
    };
}
var CellPackGenerateColorThemeProvider = {
    name: 'cellpack-generate',
    label: 'CellPack Generate',
    category: "Chain Property" /* Chain */,
    factory: CellPackGenerateColorTheme,
    getParams: getCellPackGenerateColorThemeParams,
    defaultValues: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_0__["ParamDefinition"].getDefaultValues(CellPackGenerateColorThemeParams),
    isApplicable: function (ctx) {
        return (!!ctx.structure && ctx.structure.elementCount > 0 &&
            !!_property__WEBPACK_IMPORTED_MODULE_4__["CellPackInfoProvider"].get(ctx.structure).value);
    }
};
//# sourceMappingURL=generate.js.map

/***/ }),

/***/ "./lib/extensions/cellpack/color/provided.js":
/*!***************************************************!*\
  !*** ./lib/extensions/cellpack/color/provided.js ***!
  \***************************************************/
/*! exports provided: CellPackProvidedColorThemeParams, getCellPackProvidedColorThemeParams, CellPackProvidedColorTheme, CellPackProvidedColorThemeProvider */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CellPackProvidedColorThemeParams", function() { return CellPackProvidedColorThemeParams; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getCellPackProvidedColorThemeParams", function() { return getCellPackProvidedColorThemeParams; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CellPackProvidedColorTheme", function() { return CellPackProvidedColorTheme; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CellPackProvidedColorThemeProvider", function() { return CellPackProvidedColorThemeProvider; });
/* harmony import */ var _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../../mol-util/param-definition */ "./lib/mol-util/param-definition.js");
/* harmony import */ var _mol_util_color__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../../mol-util/color */ "./lib/mol-util/color/index.js");
/* harmony import */ var _mol_model_structure__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../../mol-model/structure */ "./lib/mol-model/structure.js");
/* harmony import */ var _property__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../property */ "./lib/extensions/cellpack/property.js");
/**
 * Copyright (c) 2020 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */




var DefaultColor = Object(_mol_util_color__WEBPACK_IMPORTED_MODULE_1__["Color"])(0xCCCCCC);
var Description = 'Gives every model in a CellPack the color provied in the packing data.';
var CellPackProvidedColorThemeParams = {};
function getCellPackProvidedColorThemeParams(ctx) {
    return CellPackProvidedColorThemeParams; // TODO return copy
}
function CellPackProvidedColorTheme(ctx, props) {
    var color;
    var legend;
    var info = ctx.structure && _property__WEBPACK_IMPORTED_MODULE_3__["CellPackInfoProvider"].get(ctx.structure).value;
    if (ctx.structure && (info === null || info === void 0 ? void 0 : info.colors)) {
        var models = ctx.structure.root.models;
        var modelColor_1 = new Map();
        for (var i = 0, il = models.length; i < il; ++i) {
            var idx = _mol_model_structure__WEBPACK_IMPORTED_MODULE_2__["Model"].TrajectoryInfo.get(models[i]).index;
            modelColor_1.set(_mol_model_structure__WEBPACK_IMPORTED_MODULE_2__["Model"].TrajectoryInfo.get(models[i]).index, info.colors[idx]);
        }
        color = function (location) {
            if (_mol_model_structure__WEBPACK_IMPORTED_MODULE_2__["StructureElement"].Location.is(location)) {
                return modelColor_1.get(_mol_model_structure__WEBPACK_IMPORTED_MODULE_2__["Model"].TrajectoryInfo.get(location.unit.model).index);
            }
            else if (_mol_model_structure__WEBPACK_IMPORTED_MODULE_2__["Bond"].isLocation(location)) {
                return modelColor_1.get(_mol_model_structure__WEBPACK_IMPORTED_MODULE_2__["Model"].TrajectoryInfo.get(location.aUnit.model).index);
            }
            return DefaultColor;
        };
    }
    else {
        color = function () { return DefaultColor; };
    }
    return {
        factory: CellPackProvidedColorTheme,
        granularity: 'instance',
        color: color,
        props: props,
        description: Description,
        legend: legend
    };
}
var CellPackProvidedColorThemeProvider = {
    name: 'cellpack-provided',
    label: 'CellPack Provided',
    category: "Chain Property" /* Chain */,
    factory: CellPackProvidedColorTheme,
    getParams: getCellPackProvidedColorThemeParams,
    defaultValues: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_0__["ParamDefinition"].getDefaultValues(CellPackProvidedColorThemeParams),
    isApplicable: function (ctx) {
        var _a;
        return (!!ctx.structure && ctx.structure.elementCount > 0 &&
            _mol_model_structure__WEBPACK_IMPORTED_MODULE_2__["Model"].TrajectoryInfo.get(ctx.structure.models[0]).size > 1 &&
            !!((_a = _property__WEBPACK_IMPORTED_MODULE_3__["CellPackInfoProvider"].get(ctx.structure).value) === null || _a === void 0 ? void 0 : _a.colors));
    }
};
//# sourceMappingURL=provided.js.map

/***/ }),

/***/ "./lib/extensions/cellpack/curve.js":
/*!******************************************!*\
  !*** ./lib/extensions/cellpack/curve.js ***!
  \******************************************/
/*! exports provided: getMatFromResamplePoints */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getMatFromResamplePoints", function() { return getMatFromResamplePoints; });
/* harmony import */ var _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../mol-math/linear-algebra */ "./lib/mol-math/linear-algebra.js");
/**
 * Copyright (c) 2019 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author Ludovic Autin <autin@scripps.edu>
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */

var a0Tmp = Object(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"])();
var a1Tmp = Object(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"])();
var a2Tmp = Object(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"])();
var a3Tmp = Object(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"])();
function CubicInterpolate(out, y0, y1, y2, y3, mu) {
    var mu2 = mu * mu;
    _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"].sub(a0Tmp, y3, y2);
    _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"].sub(a0Tmp, a0Tmp, y0);
    _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"].add(a0Tmp, a0Tmp, y1);
    _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"].sub(a1Tmp, y0, y1);
    _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"].sub(a1Tmp, a1Tmp, a0Tmp);
    _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"].sub(a2Tmp, y2, y0);
    _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"].copy(a3Tmp, y1);
    out[0] = a0Tmp[0] * mu * mu2 + a1Tmp[0] * mu2 + a2Tmp[0] * mu + a3Tmp[0];
    out[1] = a0Tmp[1] * mu * mu2 + a1Tmp[1] * mu2 + a2Tmp[1] * mu + a3Tmp[1];
    out[2] = a0Tmp[2] * mu * mu2 + a1Tmp[2] * mu2 + a2Tmp[2] * mu + a3Tmp[2];
    return out;
}
var cp0 = Object(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"])();
var cp1 = Object(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"])();
var cp2 = Object(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"])();
var cp3 = Object(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"])();
var currentPosition = Object(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"])();
function ResampleControlPoints(points, segmentLength) {
    var nP = points.length / 3;
    // insert a point at the end and at the begining
    // controlPoints.Insert(0, controlPoints[0] + (controlPoints[0] - controlPoints[1]) / 2.0f);
    // controlPoints.Add(controlPoints[nP - 1] + (controlPoints[nP - 1] - controlPoints[nP - 2]) / 2.0f);
    var resampledControlPoints = [];
    // resampledControlPoints.Add(controlPoints[0]);
    // resampledControlPoints.Add(controlPoints[1]);
    var idx = 1;
    // const currentPosition = Vec3.create(points[idx * 3], points[idx * 3 + 1], points[idx * 3 + 2])
    _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"].fromArray(currentPosition, points, idx * 3);
    var lerpValue = 0.0;
    // Normalize the distance between control points
    while (true) {
        if (idx + 2 >= nP)
            break;
        _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"].fromArray(cp0, points, (idx - 1) * 3);
        _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"].fromArray(cp1, points, idx * 3);
        _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"].fromArray(cp2, points, (idx + 1) * 3);
        _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"].fromArray(cp3, points, (idx + 2) * 3);
        // const cp0 = Vec3.create(points[(idx-1)*3], points[(idx-1)*3+1], points[(idx-1)*3+2]) // controlPoints[currentPointId - 1];
        // const cp1 = Vec3.create(points[idx*3], points[idx*3+1], points[idx*3+2]) // controlPoints[currentPointId];
        // const cp2 = Vec3.create(points[(idx+1)*3], points[(idx+1)*3+1], points[(idx+1)*3+2]) // controlPoints[currentPointId + 1];
        // const cp3 = Vec3.create(points[(idx+2)*3], points[(idx+2)*3+1], points[(idx+2)*3+2]); // controlPoints[currentPointId + 2];
        var found = false;
        for (; lerpValue <= 1; lerpValue += 0.01) {
            // lerp?slerp
            // let candidate:Vec3 = Vec3.lerp(Vec3.zero(), cp0, cp1, lerpValue);
            // const candidate:Vec3 = Vec3.bezier(Vec3.zero(), cp0, cp1, cp2, cp3, lerpValue);
            var candidate = CubicInterpolate(Object(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"])(), cp0, cp1, cp2, cp3, lerpValue);
            var d = _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"].distance(currentPosition, candidate);
            if (d > segmentLength) {
                resampledControlPoints.push(candidate);
                _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"].copy(currentPosition, candidate);
                found = true;
                break;
            }
        }
        if (!found) {
            lerpValue = 0;
            idx += 1;
        }
    }
    return resampledControlPoints;
}
var prevV = Object(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"])();
var tmpV1 = Object(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"])();
var tmpV2 = Object(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"])();
var tmpV3 = Object(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"])();
// easier to align to theses normals
function GetSmoothNormals(points) {
    var nP = points.length;
    var smoothNormals = [];
    if (points.length < 3) {
        for (var i = 0; i < points.length; ++i)
            smoothNormals.push(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"].normalize(Object(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"])(), points[i]));
        return smoothNormals;
    }
    var p0 = points[0];
    var p1 = points[1];
    var p2 = points[2];
    var p21 = _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"].sub(tmpV1, p2, p1);
    var p01 = _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"].sub(tmpV2, p0, p1);
    var p0121 = _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"].cross(tmpV3, p01, p21);
    _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"].normalize(prevV, p0121);
    smoothNormals.push(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"].clone(prevV));
    for (var i = 1; i < points.length - 1; ++i) {
        p0 = points[i - 1];
        p1 = points[i];
        p2 = points[i + 1];
        var t = _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"].normalize(tmpV1, _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"].sub(tmpV1, p2, p0));
        var b = _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"].normalize(tmpV2, _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"].cross(tmpV2, t, prevV));
        var n = _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"].normalize(Object(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"])(), _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"].cross(tmpV3, t, b));
        _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"].negate(n, n);
        _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"].copy(prevV, n);
        smoothNormals.push(n);
    }
    var last = Object(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"])();
    _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"].normalize(last, _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"].cross(last, _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"].sub(tmpV1, points[nP - 3], points[nP - 2]), _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"].sub(tmpV2, points[nP - 2], points[nP - 1])));
    smoothNormals.push(last);
    return smoothNormals;
}
var frameTmpV1 = Object(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"])();
var frameTmpV2 = Object(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"])();
var frameTmpV3 = Object(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"])();
function getFrame(reference, tangent) {
    var t = _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"].normalize(Object(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"])(), tangent);
    // make reference vector orthogonal to tangent
    var proj_r_to_t = _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"].scale(frameTmpV1, tangent, _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"].dot(reference, tangent) / _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"].dot(tangent, tangent));
    var r = _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"].normalize(Object(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"])(), _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"].sub(frameTmpV2, reference, proj_r_to_t));
    // make bitangent vector orthogonal to the others
    var s = _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"].normalize(Object(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"])(), _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"].cross(frameTmpV3, t, r));
    return { t: t, r: r, s: s };
}
var mfTmpV1 = Object(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"])();
var mfTmpV2 = Object(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"])();
var mfTmpV3 = Object(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"])();
var mfTmpV4 = Object(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"])();
var mfTmpV5 = Object(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"])();
var mfTmpV6 = Object(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"])();
var mfTmpV7 = Object(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"])();
var mfTmpV8 = Object(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"])();
var mfTmpV9 = Object(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"])();
// easier to align to theses normals
// https://github.com/bzamecnik/gpg/blob/master/rotation-minimizing-frame/rmf.py
function GetMiniFrame(points, normals) {
    var frames = [];
    var t0 = _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"].normalize(mfTmpV1, _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"].sub(mfTmpV1, points[1], points[0]));
    frames.push(getFrame(normals[0], t0));
    for (var i = 0; i < points.length - 2; ++i) {
        var t2 = _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"].normalize(mfTmpV1, _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"].sub(mfTmpV1, points[i + 2], points[i + 1]));
        var v1 = _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"].sub(mfTmpV2, points[i + 1], points[i]); // this is tangeant
        var c1 = _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"].dot(v1, v1);
        // compute r_i^L = R_1 * r_i
        var v1r = _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"].scale(mfTmpV3, v1, (2.0 / c1) * _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"].dot(v1, frames[i].r));
        var ref_L_i = _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"].sub(mfTmpV4, frames[i].r, v1r);
        // compute t_i^L = R_1 * t_i
        var v1t = _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"].scale(mfTmpV5, v1, (2.0 / c1) * _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"].dot(v1, frames[i].t));
        var tan_L_i = _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"].sub(mfTmpV6, frames[i].t, v1t);
        // # compute reflection vector of R_2
        var v2 = _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"].sub(mfTmpV7, t2, tan_L_i);
        var c2 = _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"].dot(v2, v2);
        // compute r_(i+1) = R_2 * r_i^L
        var v2l = _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"].scale(mfTmpV8, v1, (2.0 / c2) * _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"].dot(v2, ref_L_i));
        var ref_next = _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"].sub(mfTmpV9, ref_L_i, v2l); // ref_L_i - (2 / c2) * v2.dot(ref_L_i) * v2
        frames.push(getFrame(ref_next, t2)); // frames.append(Frame(ref_next, tangents[i+1]))
    }
    return frames;
}
var rpTmpVec1 = Object(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"])();
function getMatFromResamplePoints(points, segmentLength, resample) {
    var new_points = [];
    if (resample)
        new_points = ResampleControlPoints(points, segmentLength);
    else {
        for (var idx = 0; idx < points.length / 3; ++idx) {
            new_points.push(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"].fromArray(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"].zero(), points, idx * 3));
        }
    }
    var npoints = new_points.length;
    var new_normal = GetSmoothNormals(new_points);
    var frames = GetMiniFrame(new_points, new_normal);
    var limit = npoints;
    var transforms = [];
    var pti = _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"].copy(rpTmpVec1, new_points[0]);
    for (var i = 0; i < npoints - 2; ++i) {
        var pti1 = new_points[i + 1]; // Vec3.create(points[(i+1)*3],points[(i+1)*3+1],points[(i+1)*3+2]);
        var d = _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"].distance(pti, pti1);
        if (d >= segmentLength) {
            // use twist or random?
            var quat = _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Quat"].rotationTo(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Quat"].zero(), _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"].create(0, 0, 1), frames[i].t); // Quat.rotationTo(Quat.zero(), Vec3.create(0,0,1),new_normal[i]);//Quat.rotationTo(Quat.zero(), Vec3.create(0,0,1),direction);new_normal
            var rq = _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Quat"].setAxisAngle(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Quat"].zero(), frames[i].t, Math.random() * 3.60); // Quat.setAxisAngle(Quat.zero(),direction, Math.random()*3.60 );//Quat.identity();//
            var m = _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Mat4"].fromQuat(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Mat4"].zero(), _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Quat"].multiply(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Quat"].zero(), rq, quat)); // Mat4.fromQuat(Mat4.zero(),Quat.multiply(Quat.zero(),quat1,quat2));//Mat4.fromQuat(Mat4.zero(),quat);//Mat4.identity();//Mat4.fromQuat(Mat4.zero(),Quat.multiply(Quat.zero(),rq,quat));
            // let pos:Vec3 = Vec3.add(Vec3.zero(),pti1,pti)
            // pos = Vec3.scale(pos,pos,1.0/2.0);
            // Vec3.makeRotation(Mat4.zero(),Vec3.create(0,0,1),frames[i].t);//
            _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Mat4"].setTranslation(m, pti1);
            // let m2:Mat4 = GetTubePropertiesMatrix(pti,pti1);
            // let q:Quat = Quat.rotationTo(Quat.zero(), Vec3.create(0,1,0),Vec3.create(0,0,1))
            // m2=Mat4.mul(Mat4.identity(),Mat4.fromQuat(Mat4.zero(),q),m2);
            transforms.push(m);
            _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"].copy(pti, pti1);
        }
        if (transforms.length >= limit)
            break;
    }
    return transforms;
}
//# sourceMappingURL=curve.js.map

/***/ }),

/***/ "./lib/extensions/cellpack/index.js":
/*!******************************************!*\
  !*** ./lib/extensions/cellpack/index.js ***!
  \******************************************/
/*! exports provided: CellPack */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CellPack", function() { return CellPack; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _mol_plugin_behavior__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../mol-plugin/behavior */ "./lib/mol-plugin/behavior.js");
/* harmony import */ var _model__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./model */ "./lib/extensions/cellpack/model.js");
/* harmony import */ var _color_generate__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./color/generate */ "./lib/extensions/cellpack/color/generate.js");
/* harmony import */ var _color_provided__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./color/provided */ "./lib/extensions/cellpack/color/provided.js");
/**
 * Copyright (c) 2020 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */





var CellPack = _mol_plugin_behavior__WEBPACK_IMPORTED_MODULE_1__["PluginBehavior"].create({
    name: 'cellpack',
    category: 'custom-props',
    display: {
        name: 'CellPack',
        description: 'CellPack Model Loading and Viewing.'
    },
    ctor: /** @class */ (function (_super) {
        Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__extends"])(class_1, _super);
        function class_1() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        class_1.prototype.register = function () {
            this.ctx.state.data.actions.add(_model__WEBPACK_IMPORTED_MODULE_2__["LoadCellPackModel"]);
            this.ctx.representation.structure.themes.colorThemeRegistry.add(_color_generate__WEBPACK_IMPORTED_MODULE_3__["CellPackGenerateColorThemeProvider"]);
            this.ctx.representation.structure.themes.colorThemeRegistry.add(_color_provided__WEBPACK_IMPORTED_MODULE_4__["CellPackProvidedColorThemeProvider"]);
        };
        class_1.prototype.unregister = function () {
            this.ctx.state.data.actions.remove(_model__WEBPACK_IMPORTED_MODULE_2__["LoadCellPackModel"]);
            this.ctx.representation.structure.themes.colorThemeRegistry.remove(_color_generate__WEBPACK_IMPORTED_MODULE_3__["CellPackGenerateColorThemeProvider"]);
            this.ctx.representation.structure.themes.colorThemeRegistry.remove(_color_provided__WEBPACK_IMPORTED_MODULE_4__["CellPackProvidedColorThemeProvider"]);
        };
        return class_1;
    }(_mol_plugin_behavior__WEBPACK_IMPORTED_MODULE_1__["PluginBehavior"].Handler))
});
//# sourceMappingURL=index.js.map

/***/ }),

/***/ "./lib/extensions/cellpack/model.js":
/*!******************************************!*\
  !*** ./lib/extensions/cellpack/model.js ***!
  \******************************************/
/*! exports provided: createStructureFromCellPack, LoadCellPackModel */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createStructureFromCellPack", function() { return createStructureFromCellPack; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "LoadCellPackModel", function() { return LoadCellPackModel; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _mol_state__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../mol-state */ "./lib/mol-state/index.js");
/* harmony import */ var _mol_plugin_state_objects__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../mol-plugin-state/objects */ "./lib/mol-plugin-state/objects.js");
/* harmony import */ var _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../mol-util/param-definition */ "./lib/mol-util/param-definition.js");
/* harmony import */ var _util__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./util */ "./lib/extensions/cellpack/util.js");
/* harmony import */ var _mol_model_structure__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../mol-model/structure */ "./lib/mol-model/structure.js");
/* harmony import */ var _mol_model_formats_structure_mmcif__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../../mol-model-formats/structure/mmcif */ "./lib/mol-model-formats/structure/mmcif.js");
/* harmony import */ var _mol_model_formats_structure_pdb__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../../mol-model-formats/structure/pdb */ "./lib/mol-model-formats/structure/pdb.js");
/* harmony import */ var _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ../../mol-math/linear-algebra */ "./lib/mol-math/linear-algebra.js");
/* harmony import */ var _mol_math_geometry__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ../../mol-math/geometry */ "./lib/mol-math/geometry.js");
/* harmony import */ var _mol_task__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ../../mol-task */ "./lib/mol-task/index.js");
/* harmony import */ var _mol_plugin_state_transforms__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ../../mol-plugin-state/transforms */ "./lib/mol-plugin-state/transforms.js");
/* harmony import */ var _state__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! ./state */ "./lib/extensions/cellpack/state.js");
/* harmony import */ var _mol_script_language_builder__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! ../../mol-script/language/builder */ "./lib/mol-script/language/builder.js");
/* harmony import */ var _curve__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! ./curve */ "./lib/extensions/cellpack/curve.js");
/* harmony import */ var _mol_script_runtime_query_compiler__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! ../../mol-script/runtime/query/compiler */ "./lib/mol-script/runtime/query/compiler.js");
/* harmony import */ var _mol_io_reader_cif__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(/*! ../../mol-io/reader/cif */ "./lib/mol-io/reader/cif.js");
/* harmony import */ var _mol_data_db__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(/*! ../../mol-data/db */ "./lib/mol-data/db.js");
/* harmony import */ var _mol_model_formats_structure_basic_parser__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(/*! ../../mol-model-formats/structure/basic/parser */ "./lib/mol-model-formats/structure/basic/parser.js");
/* harmony import */ var _preset__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(/*! ./preset */ "./lib/extensions/cellpack/preset.js");
/* harmony import */ var _mol_util_assets__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(/*! ../../mol-util/assets */ "./lib/mol-util/assets.js");
/* harmony import */ var _mol_util_color__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(/*! ../../mol-util/color */ "./lib/mol-util/color/index.js");
/* harmony import */ var _mol_util_data_source__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(/*! ../../mol-util/data-source */ "./lib/mol-util/data-source.js");
/* harmony import */ var _mol_util_object__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(/*! ../../mol-util/object */ "./lib/mol-util/object.js");
/**
 * Copyright (c) 2019-2021 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */
























function getCellPackModelUrl(fileName, baseUrl) {
    return baseUrl + "/results/" + fileName;
}
var TrajectoryCache = /** @class */ (function () {
    function TrajectoryCache() {
        this.map = new Map();
    }
    TrajectoryCache.prototype.set = function (id, trajectory) { this.map.set(id, trajectory); };
    TrajectoryCache.prototype.get = function (id) { return this.map.get(id); };
    return TrajectoryCache;
}());
function getModel(plugin, id, ingredient, baseUrl, trajCache, file) {
    return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"])(this, void 0, void 0, function () {
        var assetManager, modelIndex, surface, trajectory, assets, text, cif, binary, cif, text, pdb, data, e_1, _a, mmcif, asset, _b, mmcif, asset, data, model;
        return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__generator"])(this, function (_c) {
            switch (_c.label) {
                case 0:
                    assetManager = plugin.managers.asset;
                    modelIndex = (ingredient.source.model) ? parseInt(ingredient.source.model) : 0;
                    surface = (ingredient.ingtype) ? (ingredient.ingtype === 'transmembrane') : false;
                    trajectory = trajCache.get(id);
                    assets = [];
                    if (!!trajectory) return [3 /*break*/, 32];
                    if (!file) return [3 /*break*/, 14];
                    if (!file.name.endsWith('.cif')) return [3 /*break*/, 4];
                    return [4 /*yield*/, plugin.runTask(assetManager.resolve(file, 'string'))];
                case 1:
                    text = _c.sent();
                    assets.push(text);
                    return [4 /*yield*/, Object(_util__WEBPACK_IMPORTED_MODULE_4__["parseCif"])(plugin, text.data)];
                case 2:
                    cif = (_c.sent()).blocks[0];
                    return [4 /*yield*/, plugin.runTask(Object(_mol_model_formats_structure_mmcif__WEBPACK_IMPORTED_MODULE_6__["trajectoryFromMmCIF"])(cif))];
                case 3:
                    trajectory = _c.sent();
                    return [3 /*break*/, 13];
                case 4:
                    if (!file.name.endsWith('.bcif')) return [3 /*break*/, 8];
                    return [4 /*yield*/, plugin.runTask(assetManager.resolve(file, 'binary'))];
                case 5:
                    binary = _c.sent();
                    assets.push(binary);
                    return [4 /*yield*/, Object(_util__WEBPACK_IMPORTED_MODULE_4__["parseCif"])(plugin, binary.data)];
                case 6:
                    cif = (_c.sent()).blocks[0];
                    return [4 /*yield*/, plugin.runTask(Object(_mol_model_formats_structure_mmcif__WEBPACK_IMPORTED_MODULE_6__["trajectoryFromMmCIF"])(cif))];
                case 7:
                    trajectory = _c.sent();
                    return [3 /*break*/, 13];
                case 8:
                    if (!file.name.endsWith('.pdb')) return [3 /*break*/, 12];
                    return [4 /*yield*/, plugin.runTask(assetManager.resolve(file, 'string'))];
                case 9:
                    text = _c.sent();
                    assets.push(text);
                    return [4 /*yield*/, Object(_util__WEBPACK_IMPORTED_MODULE_4__["parsePDBfile"])(plugin, text.data, id)];
                case 10:
                    pdb = _c.sent();
                    return [4 /*yield*/, plugin.runTask(Object(_mol_model_formats_structure_pdb__WEBPACK_IMPORTED_MODULE_7__["trajectoryFromPDB"])(pdb))];
                case 11:
                    trajectory = _c.sent();
                    return [3 /*break*/, 13];
                case 12: throw new Error("unsupported file type '" + file.name + "'");
                case 13: return [3 /*break*/, 31];
                case 14:
                    if (!id.match(/^[1-9][a-zA-Z0-9]{3,3}$/i)) return [3 /*break*/, 26];
                    if (!surface) return [3 /*break*/, 22];
                    _c.label = 15;
                case 15:
                    _c.trys.push([15, 18, , 21]);
                    return [4 /*yield*/, Object(_util__WEBPACK_IMPORTED_MODULE_4__["getFromOPM"])(plugin, id, assetManager)];
                case 16:
                    data = _c.sent();
                    assets.push(data.asset);
                    return [4 /*yield*/, plugin.runTask(Object(_mol_model_formats_structure_pdb__WEBPACK_IMPORTED_MODULE_7__["trajectoryFromPDB"])(data.pdb))];
                case 17:
                    trajectory = _c.sent();
                    return [3 /*break*/, 21];
                case 18:
                    e_1 = _c.sent();
                    return [4 /*yield*/, Object(_util__WEBPACK_IMPORTED_MODULE_4__["getFromPdb"])(plugin, id, assetManager)];
                case 19:
                    _a = _c.sent(), mmcif = _a.mmcif, asset = _a.asset;
                    assets.push(asset);
                    return [4 /*yield*/, plugin.runTask(Object(_mol_model_formats_structure_mmcif__WEBPACK_IMPORTED_MODULE_6__["trajectoryFromMmCIF"])(mmcif))];
                case 20:
                    trajectory = _c.sent();
                    return [3 /*break*/, 21];
                case 21: return [3 /*break*/, 25];
                case 22: return [4 /*yield*/, Object(_util__WEBPACK_IMPORTED_MODULE_4__["getFromPdb"])(plugin, id, assetManager)];
                case 23:
                    _b = _c.sent(), mmcif = _b.mmcif, asset = _b.asset;
                    assets.push(asset);
                    return [4 /*yield*/, plugin.runTask(Object(_mol_model_formats_structure_mmcif__WEBPACK_IMPORTED_MODULE_6__["trajectoryFromMmCIF"])(mmcif))];
                case 24:
                    trajectory = _c.sent();
                    _c.label = 25;
                case 25: return [3 /*break*/, 31];
                case 26: return [4 /*yield*/, Object(_util__WEBPACK_IMPORTED_MODULE_4__["getFromCellPackDB"])(plugin, id, baseUrl, assetManager)];
                case 27:
                    data = _c.sent();
                    assets.push(data.asset);
                    if (!('pdb' in data)) return [3 /*break*/, 29];
                    return [4 /*yield*/, plugin.runTask(Object(_mol_model_formats_structure_pdb__WEBPACK_IMPORTED_MODULE_7__["trajectoryFromPDB"])(data.pdb))];
                case 28:
                    trajectory = _c.sent();
                    return [3 /*break*/, 31];
                case 29: return [4 /*yield*/, plugin.runTask(Object(_mol_model_formats_structure_mmcif__WEBPACK_IMPORTED_MODULE_6__["trajectoryFromMmCIF"])(data.mmcif))];
                case 30:
                    trajectory = _c.sent();
                    _c.label = 31;
                case 31:
                    trajCache.set(id, trajectory);
                    _c.label = 32;
                case 32: return [4 /*yield*/, plugin.resolveTask(trajectory === null || trajectory === void 0 ? void 0 : trajectory.getFrameAtIndex(modelIndex))];
                case 33:
                    model = _c.sent();
                    return [2 /*return*/, { model: model, assets: assets }];
            }
        });
    });
}
function getStructure(plugin, model, source, props) {
    if (props === void 0) { props = {}; }
    return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"])(this, void 0, void 0, function () {
        var structure, assembly, query, asymIds, compiled, result;
        return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__generator"])(this, function (_a) {
            switch (_a.label) {
                case 0:
                    structure = _mol_model_structure__WEBPACK_IMPORTED_MODULE_5__["Structure"].ofModel(model);
                    assembly = props.assembly;
                    if (!assembly) return [3 /*break*/, 2];
                    return [4 /*yield*/, plugin.runTask(_mol_model_structure__WEBPACK_IMPORTED_MODULE_5__["StructureSymmetry"].buildAssembly(structure, assembly))];
                case 1:
                    structure = _a.sent();
                    _a.label = 2;
                case 2:
                    if (source.selection) {
                        asymIds = source.selection.replace(' ', '').replace(':', '').split('or');
                        query = _mol_script_language_builder__WEBPACK_IMPORTED_MODULE_13__["MolScriptBuilder"].struct.modifier.union([
                            _mol_script_language_builder__WEBPACK_IMPORTED_MODULE_13__["MolScriptBuilder"].struct.generator.atomGroups({
                                'entity-test': _mol_script_language_builder__WEBPACK_IMPORTED_MODULE_13__["MolScriptBuilder"].core.rel.eq([_mol_script_language_builder__WEBPACK_IMPORTED_MODULE_13__["MolScriptBuilder"].ammp('entityType'), 'polymer']),
                                'chain-test': _mol_script_language_builder__WEBPACK_IMPORTED_MODULE_13__["MolScriptBuilder"].core.set.has([_mol_script_language_builder__WEBPACK_IMPORTED_MODULE_13__["MolScriptBuilder"].set.apply(_mol_script_language_builder__WEBPACK_IMPORTED_MODULE_13__["MolScriptBuilder"], asymIds), _mol_script_language_builder__WEBPACK_IMPORTED_MODULE_13__["MolScriptBuilder"].ammp('auth_asym_id')])
                            })
                        ]);
                    }
                    else {
                        query = _mol_script_language_builder__WEBPACK_IMPORTED_MODULE_13__["MolScriptBuilder"].struct.modifier.union([
                            _mol_script_language_builder__WEBPACK_IMPORTED_MODULE_13__["MolScriptBuilder"].struct.generator.atomGroups({
                                'entity-test': _mol_script_language_builder__WEBPACK_IMPORTED_MODULE_13__["MolScriptBuilder"].core.rel.eq([_mol_script_language_builder__WEBPACK_IMPORTED_MODULE_13__["MolScriptBuilder"].ammp('entityType'), 'polymer'])
                            })
                        ]);
                    }
                    compiled = Object(_mol_script_runtime_query_compiler__WEBPACK_IMPORTED_MODULE_15__["compile"])(query);
                    result = compiled(new _mol_model_structure__WEBPACK_IMPORTED_MODULE_5__["QueryContext"](structure));
                    structure = _mol_model_structure__WEBPACK_IMPORTED_MODULE_5__["StructureSelection"].unionStructure(result);
                    return [2 /*return*/, structure];
            }
        });
    });
}
function getTransformLegacy(trans, rot) {
    var q = _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_8__["Quat"].create(-rot[3], rot[0], rot[1], rot[2]);
    var m = _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_8__["Mat4"].fromQuat(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_8__["Mat4"].zero(), q);
    _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_8__["Mat4"].transpose(m, m);
    _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_8__["Mat4"].scale(m, m, _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_8__["Vec3"].create(-1.0, 1.0, -1.0));
    _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_8__["Mat4"].setTranslation(m, trans);
    return m;
}
function getTransform(trans, rot) {
    var q = _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_8__["Quat"].create(rot[0], rot[1], rot[2], rot[3]);
    var m = _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_8__["Mat4"].fromQuat(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_8__["Mat4"].zero(), q);
    var p = _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_8__["Vec3"].create(trans[0], trans[1], trans[2]);
    _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_8__["Mat4"].setTranslation(m, p);
    return m;
}
function getResultTransforms(results, legacy) {
    if (legacy)
        return results.map(function (r) { return getTransformLegacy(r[0], r[1]); });
    else
        return results.map(function (r) { return getTransform(r[0], r[1]); });
}
function getCurveTransforms(ingredient) {
    var n = ingredient.nbCurve || 0;
    var instances = [];
    var segmentLength = 3.4;
    if (ingredient.uLength) {
        segmentLength = ingredient.uLength;
    }
    else if (ingredient.radii) {
        segmentLength = ingredient.radii[0].radii
            ? ingredient.radii[0].radii[0] * 2.0
            : 3.4;
    }
    var resampling = false;
    for (var i = 0; i < n; ++i) {
        var cname = "curve" + i;
        if (!(cname in ingredient)) {
            // console.warn(`Expected '${cname}' in ingredient`)
            continue;
        }
        var _points = ingredient[cname];
        if (_points.length <= 2) {
            // TODO handle curve with 2 or less points
            continue;
        }
        // test for resampling
        var distance = _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_8__["Vec3"].distance(_points[0], _points[1]);
        if (distance >= segmentLength + 2.0) {
            console.info(distance);
            resampling = true;
        }
        var points = new Float32Array(_points.length * 3);
        for (var i_1 = 0, il = _points.length; i_1 < il; ++i_1)
            _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_8__["Vec3"].toArray(_points[i_1], points, i_1 * 3);
        var newInstances = Object(_curve__WEBPACK_IMPORTED_MODULE_14__["getMatFromResamplePoints"])(points, segmentLength, resampling);
        instances.push.apply(instances, newInstances);
    }
    return instances;
}
function getAssembly(transforms, structure) {
    var builder = _mol_model_structure__WEBPACK_IMPORTED_MODULE_5__["Structure"].Builder();
    var units = structure.units;
    for (var i = 0, il = transforms.length; i < il; ++i) {
        var id = "" + (i + 1);
        var op = _mol_math_geometry__WEBPACK_IMPORTED_MODULE_9__["SymmetryOperator"].create(id, transforms[i], { assembly: { id: id, operId: i, operList: [id] } });
        for (var _i = 0, units_1 = units; _i < units_1.length; _i++) {
            var unit = units_1[_i];
            builder.addWithOperator(unit, op);
        }
    }
    return builder.getStructure();
}
function getCifCurve(name, transforms, model) {
    if (!_mol_model_formats_structure_mmcif__WEBPACK_IMPORTED_MODULE_6__["MmcifFormat"].is(model.sourceData))
        throw new Error('mmcif source data needed');
    var db = model.sourceData.data.db;
    var d = db.atom_site;
    var n = d._rowCount;
    var rowCount = n * transforms.length;
    var _a = model.atomicHierarchy.chainAtomSegments, offsets = _a.offsets, count = _a.count;
    var x = d.Cartn_x.toArray();
    var y = d.Cartn_y.toArray();
    var z = d.Cartn_z.toArray();
    var Cartn_x = new Float32Array(rowCount);
    var Cartn_y = new Float32Array(rowCount);
    var Cartn_z = new Float32Array(rowCount);
    var map = new Uint32Array(rowCount);
    var seq = new Int32Array(rowCount);
    var offset = 0;
    for (var c = 0; c < count; ++c) {
        var cStart = offsets[c];
        var cEnd = offsets[c + 1];
        var cLength = cEnd - cStart;
        for (var t = 0, tl = transforms.length; t < tl; ++t) {
            var m = transforms[t];
            for (var j = cStart; j < cEnd; ++j) {
                var i = offset + j - cStart;
                var xj = x[j], yj = y[j], zj = z[j];
                Cartn_x[i] = m[0] * xj + m[4] * yj + m[8] * zj + m[12];
                Cartn_y[i] = m[1] * xj + m[5] * yj + m[9] * zj + m[13];
                Cartn_z[i] = m[2] * xj + m[6] * yj + m[10] * zj + m[14];
                map[i] = j;
                seq[i] = t + 1;
            }
            offset += cLength;
        }
    }
    function multColumn(column) {
        var array = column.toArray();
        return _mol_data_db__WEBPACK_IMPORTED_MODULE_17__["Column"].ofLambda({
            value: function (row) { return array[map[row]]; },
            areValuesEqual: function (rowA, rowB) { return map[rowA] === map[rowB] || array[map[rowA]] === array[map[rowB]]; },
            rowCount: rowCount,
            schema: column.schema
        });
    }
    var _atom_site = {
        auth_asym_id: _mol_io_reader_cif__WEBPACK_IMPORTED_MODULE_16__["CifField"].ofColumn(multColumn(d.auth_asym_id)),
        auth_atom_id: _mol_io_reader_cif__WEBPACK_IMPORTED_MODULE_16__["CifField"].ofColumn(multColumn(d.auth_atom_id)),
        auth_comp_id: _mol_io_reader_cif__WEBPACK_IMPORTED_MODULE_16__["CifField"].ofColumn(multColumn(d.auth_comp_id)),
        auth_seq_id: _mol_io_reader_cif__WEBPACK_IMPORTED_MODULE_16__["CifField"].ofNumbers(seq),
        B_iso_or_equiv: _mol_io_reader_cif__WEBPACK_IMPORTED_MODULE_16__["CifField"].ofColumn(_mol_data_db__WEBPACK_IMPORTED_MODULE_17__["Column"].ofConst(0, rowCount, _mol_data_db__WEBPACK_IMPORTED_MODULE_17__["Column"].Schema.float)),
        Cartn_x: _mol_io_reader_cif__WEBPACK_IMPORTED_MODULE_16__["CifField"].ofNumbers(Cartn_x),
        Cartn_y: _mol_io_reader_cif__WEBPACK_IMPORTED_MODULE_16__["CifField"].ofNumbers(Cartn_y),
        Cartn_z: _mol_io_reader_cif__WEBPACK_IMPORTED_MODULE_16__["CifField"].ofNumbers(Cartn_z),
        group_PDB: _mol_io_reader_cif__WEBPACK_IMPORTED_MODULE_16__["CifField"].ofColumn(_mol_data_db__WEBPACK_IMPORTED_MODULE_17__["Column"].ofConst('ATOM', rowCount, _mol_data_db__WEBPACK_IMPORTED_MODULE_17__["Column"].Schema.str)),
        id: _mol_io_reader_cif__WEBPACK_IMPORTED_MODULE_16__["CifField"].ofColumn(_mol_data_db__WEBPACK_IMPORTED_MODULE_17__["Column"].ofLambda({
            value: function (row) { return row; },
            areValuesEqual: function (rowA, rowB) { return rowA === rowB; },
            rowCount: rowCount,
            schema: d.id.schema,
        })),
        label_alt_id: _mol_io_reader_cif__WEBPACK_IMPORTED_MODULE_16__["CifField"].ofColumn(multColumn(d.label_alt_id)),
        label_asym_id: _mol_io_reader_cif__WEBPACK_IMPORTED_MODULE_16__["CifField"].ofColumn(multColumn(d.label_asym_id)),
        label_atom_id: _mol_io_reader_cif__WEBPACK_IMPORTED_MODULE_16__["CifField"].ofColumn(multColumn(d.label_atom_id)),
        label_comp_id: _mol_io_reader_cif__WEBPACK_IMPORTED_MODULE_16__["CifField"].ofColumn(multColumn(d.label_comp_id)),
        label_seq_id: _mol_io_reader_cif__WEBPACK_IMPORTED_MODULE_16__["CifField"].ofNumbers(seq),
        label_entity_id: _mol_io_reader_cif__WEBPACK_IMPORTED_MODULE_16__["CifField"].ofColumn(_mol_data_db__WEBPACK_IMPORTED_MODULE_17__["Column"].ofConst('1', rowCount, _mol_data_db__WEBPACK_IMPORTED_MODULE_17__["Column"].Schema.str)),
        occupancy: _mol_io_reader_cif__WEBPACK_IMPORTED_MODULE_16__["CifField"].ofColumn(_mol_data_db__WEBPACK_IMPORTED_MODULE_17__["Column"].ofConst(1, rowCount, _mol_data_db__WEBPACK_IMPORTED_MODULE_17__["Column"].Schema.float)),
        type_symbol: _mol_io_reader_cif__WEBPACK_IMPORTED_MODULE_16__["CifField"].ofColumn(multColumn(d.type_symbol)),
        pdbx_PDB_ins_code: _mol_io_reader_cif__WEBPACK_IMPORTED_MODULE_16__["CifField"].ofColumn(_mol_data_db__WEBPACK_IMPORTED_MODULE_17__["Column"].ofConst('', rowCount, _mol_data_db__WEBPACK_IMPORTED_MODULE_17__["Column"].Schema.str)),
        pdbx_PDB_model_num: _mol_io_reader_cif__WEBPACK_IMPORTED_MODULE_16__["CifField"].ofColumn(_mol_data_db__WEBPACK_IMPORTED_MODULE_17__["Column"].ofConst(1, rowCount, _mol_data_db__WEBPACK_IMPORTED_MODULE_17__["Column"].Schema.int)),
    };
    var categories = {
        entity: _mol_io_reader_cif__WEBPACK_IMPORTED_MODULE_16__["CifCategory"].ofTable('entity', db.entity),
        chem_comp: _mol_io_reader_cif__WEBPACK_IMPORTED_MODULE_16__["CifCategory"].ofTable('chem_comp', db.chem_comp),
        atom_site: _mol_io_reader_cif__WEBPACK_IMPORTED_MODULE_16__["CifCategory"].ofFields('atom_site', _atom_site)
    };
    return {
        header: name,
        categoryNames: Object.keys(categories),
        categories: categories
    };
}
function getCurve(plugin, name, ingredient, transforms, model) {
    return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"])(this, void 0, void 0, function () {
        var cif, curveModelTask, curveModel;
        var _this = this;
        return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__generator"])(this, function (_a) {
            switch (_a.label) {
                case 0:
                    cif = getCifCurve(name, transforms, model);
                    curveModelTask = _mol_task__WEBPACK_IMPORTED_MODULE_10__["Task"].create('Curve Model', function (ctx) { return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"])(_this, void 0, void 0, function () {
                        var format, models;
                        return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__generator"])(this, function (_a) {
                            switch (_a.label) {
                                case 0:
                                    format = _mol_model_formats_structure_mmcif__WEBPACK_IMPORTED_MODULE_6__["MmcifFormat"].fromFrame(cif);
                                    return [4 /*yield*/, Object(_mol_model_formats_structure_basic_parser__WEBPACK_IMPORTED_MODULE_18__["createModels"])(format.data.db, format, ctx)];
                                case 1:
                                    models = _a.sent();
                                    return [2 /*return*/, models.representative];
                            }
                        });
                    }); });
                    return [4 /*yield*/, plugin.runTask(curveModelTask)];
                case 1:
                    curveModel = _a.sent();
                    return [2 /*return*/, getStructure(plugin, curveModel, ingredient.source)];
            }
        });
    });
}
function getIngredientStructure(plugin, ingredient, baseUrl, ingredientFiles, trajCache) {
    return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"])(this, void 0, void 0, function () {
        var name, source, results, nbCurve, file, _a, model, assets, structure, bu, legacy, structureMean, m1, m, q, m;
        return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__generator"])(this, function (_b) {
            switch (_b.label) {
                case 0:
                    name = ingredient.name, source = ingredient.source, results = ingredient.results, nbCurve = ingredient.nbCurve;
                    if (source.pdb === 'None')
                        return [2 /*return*/];
                    file = ingredientFiles[source.pdb];
                    if (!file) {
                        // TODO can these be added to the library?
                        if (name === 'HIV1_CAhex_0_1_0')
                            return [2 /*return*/]; // 1VU4CtoH_hex.pdb
                        if (name === 'HIV1_CAhexCyclophilA_0_1_0')
                            return [2 /*return*/]; // 1AK4fitTo1VU4hex.pdb
                        if (name === 'iLDL')
                            return [2 /*return*/]; // EMD-5239
                        if (name === 'peptides')
                            return [2 /*return*/]; // peptide.pdb
                        if (name === 'lypoglycane')
                            return [2 /*return*/];
                    }
                    return [4 /*yield*/, getModel(plugin, source.pdb || name, ingredient, baseUrl, trajCache, file)];
                case 1:
                    _a = _b.sent(), model = _a.model, assets = _a.assets;
                    if (!model)
                        return [2 /*return*/];
                    if (!nbCurve) return [3 /*break*/, 3];
                    return [4 /*yield*/, getCurve(plugin, name, ingredient, getCurveTransforms(ingredient), model)];
                case 2:
                    structure = _b.sent();
                    return [3 /*break*/, 5];
                case 3:
                    bu = source.bu ? source.bu : undefined;
                    if (bu) {
                        if (bu === 'AU') {
                            bu = undefined;
                        }
                        else {
                            bu = bu.slice(2);
                        }
                    }
                    return [4 /*yield*/, getStructure(plugin, model, source, { assembly: bu })];
                case 4:
                    structure = _b.sent();
                    legacy = true;
                    if (ingredient.offset || ingredient.principalAxis) {
                        legacy = false;
                        structureMean = Object(_util__WEBPACK_IMPORTED_MODULE_4__["getStructureMean"])(structure);
                        _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_8__["Vec3"].negate(structureMean, structureMean);
                        m1 = _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_8__["Mat4"].identity();
                        _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_8__["Mat4"].setTranslation(m1, structureMean);
                        structure = _mol_model_structure__WEBPACK_IMPORTED_MODULE_5__["Structure"].transform(structure, m1);
                        if (ingredient.offset) {
                            if (!_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_8__["Vec3"].exactEquals(ingredient.offset, _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_8__["Vec3"].zero())) {
                                m = _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_8__["Mat4"].identity();
                                _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_8__["Mat4"].setTranslation(m, ingredient.offset);
                                structure = _mol_model_structure__WEBPACK_IMPORTED_MODULE_5__["Structure"].transform(structure, m);
                            }
                        }
                        if (ingredient.principalAxis) {
                            if (!_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_8__["Vec3"].exactEquals(ingredient.principalAxis, _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_8__["Vec3"].unitZ)) {
                                q = _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_8__["Quat"].identity();
                                _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_8__["Quat"].rotationTo(q, ingredient.principalAxis, _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_8__["Vec3"].unitZ);
                                m = _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_8__["Mat4"].fromQuat(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_8__["Mat4"].zero(), q);
                                structure = _mol_model_structure__WEBPACK_IMPORTED_MODULE_5__["Structure"].transform(structure, m);
                            }
                        }
                    }
                    structure = getAssembly(getResultTransforms(results, legacy), structure);
                    _b.label = 5;
                case 5: return [2 /*return*/, { structure: structure, assets: assets }];
            }
        });
    });
}
function createStructureFromCellPack(plugin, packing, baseUrl, ingredientFiles) {
    var _this = this;
    return _mol_task__WEBPACK_IMPORTED_MODULE_10__["Task"].create('Create Packing Structure', function (ctx) { return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"])(_this, void 0, void 0, function () {
        var ingredients, name, assets, trajCache, structures, colors, skipColors, _a, _b, _i, iName, ingredientStructure, c, units, offsetInvariantId, offsetChainGroupId, _c, structures_1, s, maxInvariantId, maxChainGroupId, _d, _e, u, invariantId, chainGroupId, structure, i, il;
        return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__generator"])(this, function (_f) {
            switch (_f.label) {
                case 0:
                    ingredients = packing.ingredients, name = packing.name;
                    assets = [];
                    trajCache = new TrajectoryCache();
                    structures = [];
                    colors = [];
                    skipColors = false;
                    _a = [];
                    for (_b in ingredients)
                        _a.push(_b);
                    _i = 0;
                    _f.label = 1;
                case 1:
                    if (!(_i < _a.length)) return [3 /*break*/, 6];
                    iName = _a[_i];
                    if (!ctx.shouldUpdate) return [3 /*break*/, 3];
                    return [4 /*yield*/, ctx.update(iName)];
                case 2:
                    _f.sent();
                    _f.label = 3;
                case 3: return [4 /*yield*/, getIngredientStructure(plugin, ingredients[iName], baseUrl, ingredientFiles, trajCache)];
                case 4:
                    ingredientStructure = _f.sent();
                    if (ingredientStructure) {
                        structures.push(ingredientStructure.structure);
                        assets.push.apply(assets, ingredientStructure.assets);
                        c = ingredients[iName].color;
                        if (c) {
                            colors.push(_mol_util_color__WEBPACK_IMPORTED_MODULE_21__["Color"].fromNormalizedRgb(c[0], c[1], c[2]));
                        }
                        else {
                            skipColors = true;
                        }
                    }
                    _f.label = 5;
                case 5:
                    _i++;
                    return [3 /*break*/, 1];
                case 6:
                    if (!ctx.shouldUpdate) return [3 /*break*/, 8];
                    return [4 /*yield*/, ctx.update(name + " - units")];
                case 7:
                    _f.sent();
                    _f.label = 8;
                case 8:
                    units = [];
                    offsetInvariantId = 0;
                    offsetChainGroupId = 0;
                    _c = 0, structures_1 = structures;
                    _f.label = 9;
                case 9:
                    if (!(_c < structures_1.length)) return [3 /*break*/, 13];
                    s = structures_1[_c];
                    if (!ctx.shouldUpdate) return [3 /*break*/, 11];
                    return [4 /*yield*/, ctx.update("" + s.label)];
                case 10:
                    _f.sent();
                    _f.label = 11;
                case 11:
                    maxInvariantId = 0;
                    maxChainGroupId = 0;
                    for (_d = 0, _e = s.units; _d < _e.length; _d++) {
                        u = _e[_d];
                        invariantId = u.invariantId + offsetInvariantId;
                        chainGroupId = u.chainGroupId + offsetChainGroupId;
                        if (u.invariantId > maxInvariantId)
                            maxInvariantId = u.invariantId;
                        units.push(_mol_model_structure__WEBPACK_IMPORTED_MODULE_5__["Unit"].create(units.length, invariantId, chainGroupId, u.traits, u.kind, u.model, u.conformation.operator, u.elements, u.props));
                    }
                    offsetInvariantId += maxInvariantId + 1;
                    offsetChainGroupId += maxChainGroupId + 1;
                    _f.label = 12;
                case 12:
                    _c++;
                    return [3 /*break*/, 9];
                case 13:
                    if (!ctx.shouldUpdate) return [3 /*break*/, 15];
                    return [4 /*yield*/, ctx.update(name + " - structure")];
                case 14:
                    _f.sent();
                    _f.label = 15;
                case 15:
                    structure = new _mol_model_structure__WEBPACK_IMPORTED_MODULE_5__["Structure"](units);
                    for (i = 0, il = structure.models.length; i < il; ++i) {
                        _mol_model_structure__WEBPACK_IMPORTED_MODULE_5__["Model"].TrajectoryInfo.set(structure.models[i], { size: il, index: i });
                    }
                    return [2 /*return*/, { structure: structure, assets: assets, colors: skipColors ? undefined : colors }];
            }
        });
    }); });
}
function handleHivRna(plugin, packings, baseUrl) {
    return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"])(this, void 0, void 0, function () {
        var i, il, url, json, points, curve0, j, jl;
        return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__generator"])(this, function (_a) {
            switch (_a.label) {
                case 0:
                    i = 0, il = packings.length;
                    _a.label = 1;
                case 1:
                    if (!(i < il)) return [3 /*break*/, 4];
                    if (!(packings[i].name === 'HIV1_capsid_3j3q_PackInner_0_1_0')) return [3 /*break*/, 3];
                    url = _mol_util_assets__WEBPACK_IMPORTED_MODULE_20__["Asset"].getUrlAsset(plugin.managers.asset, baseUrl + "/extras/rna_allpoints.json");
                    return [4 /*yield*/, plugin.runTask(plugin.managers.asset.resolve(url, 'json', false))];
                case 2:
                    json = _a.sent();
                    points = json.data.points;
                    curve0 = [];
                    for (j = 0, jl = points.length; j < jl; j += 3) {
                        curve0.push(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_8__["Vec3"].fromArray(Object(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_8__["Vec3"])(), points, j));
                    }
                    packings[i].ingredients['RNA'] = {
                        source: { pdb: 'RNA_U_Base.pdb', transform: { center: false } },
                        results: [],
                        name: 'RNA',
                        nbCurve: 1,
                        curve0: curve0
                    };
                    _a.label = 3;
                case 3:
                    ++i;
                    return [3 /*break*/, 1];
                case 4: return [2 /*return*/];
            }
        });
    });
}
function loadMembrane(plugin, name, state, params) {
    return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"])(this, void 0, void 0, function () {
        var file, fileName, _i, _a, f, cifileName, _b, _c, f, b, url, membrane, membraneParams;
        return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__generator"])(this, function (_d) {
            switch (_d.label) {
                case 0:
                    file = undefined;
                    if (params.ingredients !== null) {
                        fileName = name + ".bcif";
                        for (_i = 0, _a = params.ingredients; _i < _a.length; _i++) {
                            f = _a[_i];
                            if (fileName === f.name) {
                                file = f;
                                break;
                            }
                        }
                        if (!file) {
                            cifileName = name + ".cif";
                            for (_b = 0, _c = params.ingredients; _b < _c.length; _b++) {
                                f = _c[_b];
                                if (cifileName === f.name) {
                                    file = f;
                                    break;
                                }
                            }
                        }
                    }
                    b = state.build().toRoot();
                    if (file) {
                        if (file.name.endsWith('.cif')) {
                            b = b.apply(_mol_plugin_state_transforms__WEBPACK_IMPORTED_MODULE_11__["StateTransforms"].Data.ReadFile, { file: file, isBinary: false, label: file.name }, { state: { isGhost: true } });
                        }
                        else if (file.name.endsWith('.bcif')) {
                            b = b.apply(_mol_plugin_state_transforms__WEBPACK_IMPORTED_MODULE_11__["StateTransforms"].Data.ReadFile, { file: file, isBinary: true, label: file.name }, { state: { isGhost: true } });
                        }
                    }
                    else {
                        url = _mol_util_assets__WEBPACK_IMPORTED_MODULE_20__["Asset"].getUrlAsset(plugin.managers.asset, params.baseUrl + "/membranes/" + name + ".bcif");
                        b = b.apply(_mol_plugin_state_transforms__WEBPACK_IMPORTED_MODULE_11__["StateTransforms"].Data.Download, { url: url, isBinary: true, label: name }, { state: { isGhost: true } });
                    }
                    return [4 /*yield*/, b.apply(_mol_plugin_state_transforms__WEBPACK_IMPORTED_MODULE_11__["StateTransforms"].Data.ParseCif, undefined, { state: { isGhost: true } })
                            .apply(_mol_plugin_state_transforms__WEBPACK_IMPORTED_MODULE_11__["StateTransforms"].Model.TrajectoryFromMmCif, undefined, { state: { isGhost: true } })
                            .apply(_mol_plugin_state_transforms__WEBPACK_IMPORTED_MODULE_11__["StateTransforms"].Model.ModelFromTrajectory, undefined, { state: { isGhost: true } })
                            .apply(_state__WEBPACK_IMPORTED_MODULE_12__["StructureFromAssemblies"], undefined, { state: { isGhost: true } })
                            .commit({ revertOnError: true })];
                case 1:
                    membrane = _d.sent();
                    membraneParams = {
                        representation: params.preset.representation,
                    };
                    return [4 /*yield*/, _preset__WEBPACK_IMPORTED_MODULE_19__["CellpackMembranePreset"].apply(membrane, membraneParams, plugin)];
                case 2:
                    _d.sent();
                    return [2 /*return*/];
            }
        });
    });
}
function loadPackings(plugin, runtime, state, params) {
    return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"])(this, void 0, void 0, function () {
        var ingredientFiles, cellPackJson, url, file, jsonFile, data, cellPackBuilder, cellPackObject, packings, i, il, p, packing, packingParams;
        return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__generator"])(this, function (_a) {
            switch (_a.label) {
                case 0:
                    ingredientFiles = params.ingredients || [];
                    if (!(params.source.name === 'id')) return [3 /*break*/, 1];
                    url = _mol_util_assets__WEBPACK_IMPORTED_MODULE_20__["Asset"].getUrlAsset(plugin.managers.asset, getCellPackModelUrl(params.source.params, params.baseUrl));
                    cellPackJson = state.build().toRoot()
                        .apply(_mol_plugin_state_transforms__WEBPACK_IMPORTED_MODULE_11__["StateTransforms"].Data.Download, { url: url, isBinary: false, label: params.source.params }, { state: { isGhost: true } });
                    return [3 /*break*/, 5];
                case 1:
                    file = params.source.params;
                    if (!(file === null || file === void 0 ? void 0 : file.file)) {
                        plugin.log.error('No file selected');
                        return [2 /*return*/];
                    }
                    jsonFile = void 0;
                    if (!file.name.toLowerCase().endsWith('.zip')) return [3 /*break*/, 3];
                    return [4 /*yield*/, Object(_mol_util_data_source__WEBPACK_IMPORTED_MODULE_22__["readFromFile"])(file.file, 'zip').runInContext(runtime)];
                case 2:
                    data = _a.sent();
                    jsonFile = _mol_util_assets__WEBPACK_IMPORTED_MODULE_20__["Asset"].File(new File([data['model.json']], 'model.json'));
                    Object(_mol_util_object__WEBPACK_IMPORTED_MODULE_23__["objectForEach"])(data, function (v, k) {
                        if (k === 'model.json')
                            return;
                        ingredientFiles.push(_mol_util_assets__WEBPACK_IMPORTED_MODULE_20__["Asset"].File(new File([v], k)));
                    });
                    return [3 /*break*/, 4];
                case 3:
                    jsonFile = file;
                    _a.label = 4;
                case 4:
                    cellPackJson = state.build().toRoot()
                        .apply(_mol_plugin_state_transforms__WEBPACK_IMPORTED_MODULE_11__["StateTransforms"].Data.ReadFile, { file: jsonFile, isBinary: false, label: jsonFile.name }, { state: { isGhost: true } });
                    _a.label = 5;
                case 5:
                    cellPackBuilder = cellPackJson
                        .apply(_mol_plugin_state_transforms__WEBPACK_IMPORTED_MODULE_11__["StateTransforms"].Data.ParseJson, undefined, { state: { isGhost: true } })
                        .apply(_state__WEBPACK_IMPORTED_MODULE_12__["ParseCellPack"]);
                    return [4 /*yield*/, state.updateTree(cellPackBuilder).runInContext(runtime)];
                case 6:
                    cellPackObject = _a.sent();
                    packings = cellPackObject.obj.data.packings;
                    return [4 /*yield*/, handleHivRna(plugin, packings, params.baseUrl)];
                case 7:
                    _a.sent();
                    i = 0, il = packings.length;
                    _a.label = 8;
                case 8:
                    if (!(i < il)) return [3 /*break*/, 13];
                    p = { packing: i, baseUrl: params.baseUrl, ingredientFiles: ingredientFiles };
                    return [4 /*yield*/, state.build()
                            .to(cellPackBuilder.ref)
                            .apply(_state__WEBPACK_IMPORTED_MODULE_12__["StructureFromCellpack"], p)
                            .commit({ revertOnError: true })];
                case 9:
                    packing = _a.sent();
                    packingParams = {
                        traceOnly: params.preset.traceOnly,
                        representation: params.preset.representation,
                    };
                    return [4 /*yield*/, _preset__WEBPACK_IMPORTED_MODULE_19__["CellpackPackingPreset"].apply(packing, packingParams, plugin)];
                case 10:
                    _a.sent();
                    if (!(packings[i].location === 'surface' && params.membrane)) return [3 /*break*/, 12];
                    return [4 /*yield*/, loadMembrane(plugin, packings[i].name, state, params)];
                case 11:
                    _a.sent();
                    _a.label = 12;
                case 12:
                    ++i;
                    return [3 /*break*/, 8];
                case 13: return [2 /*return*/];
            }
        });
    });
}
var LoadCellPackModelParams = {
    source: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_3__["ParamDefinition"].MappedStatic('id', {
        'id': _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_3__["ParamDefinition"].Select('InfluenzaModel2.json', [
            ['blood_hiv_immature_inside.json', 'Blood HIV immature'],
            ['HIV_immature_model.json', 'HIV immature'],
            ['BloodHIV1.0_mixed_fixed_nc1.cpr', 'Blood HIV'],
            ['HIV-1_0.1.6-8_mixed_radii_pdb.cpr', 'HIV'],
            ['influenza_model1.json', 'Influenza envelope'],
            ['InfluenzaModel2.json', 'Influenza Complete'],
            ['ExosomeModel.json', 'Exosome Model'],
            ['Mycoplasma1.5_mixed_pdb_fixed.cpr', 'Mycoplasma simple'],
            ['MycoplasmaModel.json', 'Mycoplasma WholeCell model'],
        ], { description: 'Download the model definition with `id` from the server at `baseUrl.`' }),
        'file': _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_3__["ParamDefinition"].File({ accept: '.json,.cpr,.zip', description: 'Open model definition from .json/.cpr file or open .zip file containing model definition plus ingredients.' }),
    }, { options: [['id', 'Id'], ['file', 'File']] }),
    baseUrl: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_3__["ParamDefinition"].Text(_state__WEBPACK_IMPORTED_MODULE_12__["DefaultCellPackBaseUrl"]),
    membrane: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_3__["ParamDefinition"].Boolean(true),
    ingredients: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_3__["ParamDefinition"].FileList({ accept: '.cif,.bcif,.pdb', label: 'Ingredients' }),
    preset: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_3__["ParamDefinition"].Group({
        traceOnly: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_3__["ParamDefinition"].Boolean(false),
        representation: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_3__["ParamDefinition"].Select('gaussian-surface', _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_3__["ParamDefinition"].arrayToOptions(['spacefill', 'gaussian-surface', 'point', 'orientation']))
    }, { isExpanded: true })
};
var LoadCellPackModel = _mol_state__WEBPACK_IMPORTED_MODULE_1__["StateAction"].build({
    display: { name: 'Load CellPack', description: 'Open or download a model' },
    params: LoadCellPackModelParams,
    from: _mol_plugin_state_objects__WEBPACK_IMPORTED_MODULE_2__["PluginStateObject"].Root
})(function (_a, ctx) {
    var state = _a.state, params = _a.params;
    return _mol_task__WEBPACK_IMPORTED_MODULE_10__["Task"].create('CellPack Loader', function (taskCtx) { return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"])(void 0, void 0, void 0, function () {
        return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__generator"])(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, loadPackings(ctx, taskCtx, state, params)];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    }); });
});
//# sourceMappingURL=model.js.map

/***/ }),

/***/ "./lib/extensions/cellpack/preset.js":
/*!*******************************************!*\
  !*** ./lib/extensions/cellpack/preset.js ***!
  \*******************************************/
/*! exports provided: CellpackPackingPresetParams, CellpackPackingPreset, CellpackMembranePresetParams, CellpackMembranePreset */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CellpackPackingPresetParams", function() { return CellpackPackingPresetParams; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CellpackPackingPreset", function() { return CellpackPackingPreset; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CellpackMembranePresetParams", function() { return CellpackMembranePresetParams; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CellpackMembranePreset", function() { return CellpackMembranePreset; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _mol_state__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../mol-state */ "./lib/mol-state/index.js");
/* harmony import */ var _mol_plugin_state_builder_structure_representation_preset__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../mol-plugin-state/builder/structure/representation-preset */ "./lib/mol-plugin-state/builder/structure/representation-preset.js");
/* harmony import */ var _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../mol-util/param-definition */ "./lib/mol-util/param-definition.js");
/* harmony import */ var _mol_util_color_names__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../mol-util/color/names */ "./lib/mol-util/color/names.js");
/* harmony import */ var _color_generate__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./color/generate */ "./lib/extensions/cellpack/color/generate.js");
/* harmony import */ var _property__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ./property */ "./lib/extensions/cellpack/property.js");
/* harmony import */ var _color_provided__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ./color/provided */ "./lib/extensions/cellpack/color/provided.js");
/**
 * Copyright (c) 2020 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */








var CellpackPackingPresetParams = {
    traceOnly: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_3__["ParamDefinition"].Boolean(true),
    representation: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_3__["ParamDefinition"].Select('gaussian-surface', _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_3__["ParamDefinition"].arrayToOptions(['gaussian-surface', 'spacefill', 'point', 'orientation'])),
};
var CellpackPackingPreset = Object(_mol_plugin_state_builder_structure_representation_preset__WEBPACK_IMPORTED_MODULE_2__["StructureRepresentationPresetProvider"])({
    id: 'preset-structure-representation-cellpack-packing',
    display: { name: 'CellPack Packing' },
    params: function () { return CellpackPackingPresetParams; },
    apply: function (ref, params, plugin) {
        var _a, _b;
        return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"])(this, void 0, void 0, function () {
            var structureCell, reprProps, components, info, color, _c, update, builder, typeParams, representations;
            var _d;
            return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__generator"])(this, function (_e) {
                switch (_e.label) {
                    case 0:
                        structureCell = _mol_state__WEBPACK_IMPORTED_MODULE_1__["StateObjectRef"].resolveAndCheck(plugin.state.data, ref);
                        if (!structureCell)
                            return [2 /*return*/, {}];
                        reprProps = {
                            ignoreHydrogens: true,
                            traceOnly: params.traceOnly
                        };
                        _d = {};
                        return [4 /*yield*/, Object(_mol_plugin_state_builder_structure_representation_preset__WEBPACK_IMPORTED_MODULE_2__["presetStaticComponent"])(plugin, structureCell, 'polymer')];
                    case 1:
                        components = (_d.polymer = _e.sent(),
                            _d);
                        if (params.representation === 'gaussian-surface') {
                            Object.assign(reprProps, {
                                quality: 'custom', resolution: 10, radiusOffset: 2, doubleSided: false
                            });
                        }
                        else if (params.representation === 'spacefill' && params.traceOnly) {
                            Object.assign(reprProps, { sizeFactor: 2 });
                        }
                        info = ((_a = structureCell.obj) === null || _a === void 0 ? void 0 : _a.data) && _property__WEBPACK_IMPORTED_MODULE_6__["CellPackInfoProvider"].get((_b = structureCell.obj) === null || _b === void 0 ? void 0 : _b.data).value;
                        color = (info === null || info === void 0 ? void 0 : info.colors) ? _color_provided__WEBPACK_IMPORTED_MODULE_7__["CellPackProvidedColorThemeProvider"].name : _color_generate__WEBPACK_IMPORTED_MODULE_5__["CellPackGenerateColorThemeProvider"].name;
                        _c = _mol_plugin_state_builder_structure_representation_preset__WEBPACK_IMPORTED_MODULE_2__["StructureRepresentationPresetProvider"].reprBuilder(plugin, {}), update = _c.update, builder = _c.builder, typeParams = _c.typeParams;
                        representations = {
                            polymer: builder.buildRepresentation(update, components.polymer, { type: params.representation, typeParams: Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, typeParams), reprProps), color: color }, { tag: 'polymer' })
                        };
                        return [4 /*yield*/, update.commit({ revertOnError: true })];
                    case 2:
                        _e.sent();
                        return [2 /*return*/, { components: components, representations: representations }];
                }
            });
        });
    }
});
//
var CellpackMembranePresetParams = {
    representation: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_3__["ParamDefinition"].Select('gaussian-surface', _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_3__["ParamDefinition"].arrayToOptions(['gaussian-surface', 'spacefill', 'point', 'orientation'])),
};
var CellpackMembranePreset = Object(_mol_plugin_state_builder_structure_representation_preset__WEBPACK_IMPORTED_MODULE_2__["StructureRepresentationPresetProvider"])({
    id: 'preset-structure-representation-cellpack-membrane',
    display: { name: 'CellPack Membrane' },
    params: function () { return CellpackMembranePresetParams; },
    apply: function (ref, params, plugin) {
        return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"])(this, void 0, void 0, function () {
            var structureCell, reprProps, components, _a, update, builder, typeParams, representations;
            var _b;
            return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__generator"])(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        structureCell = _mol_state__WEBPACK_IMPORTED_MODULE_1__["StateObjectRef"].resolveAndCheck(plugin.state.data, ref);
                        if (!structureCell)
                            return [2 /*return*/, {}];
                        reprProps = {
                            ignoreHydrogens: true,
                        };
                        _b = {};
                        return [4 /*yield*/, Object(_mol_plugin_state_builder_structure_representation_preset__WEBPACK_IMPORTED_MODULE_2__["presetStaticComponent"])(plugin, structureCell, 'all', { label: 'Membrane' })];
                    case 1:
                        components = (_b.membrane = _c.sent(),
                            _b);
                        if (params.representation === 'gaussian-surface') {
                            Object.assign(reprProps, {
                                quality: 'custom', resolution: 10, radiusOffset: 2, doubleSided: false
                            });
                        }
                        _a = _mol_plugin_state_builder_structure_representation_preset__WEBPACK_IMPORTED_MODULE_2__["StructureRepresentationPresetProvider"].reprBuilder(plugin, {}), update = _a.update, builder = _a.builder, typeParams = _a.typeParams;
                        representations = {
                            membrane: builder.buildRepresentation(update, components.membrane, { type: 'gaussian-surface', typeParams: Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, typeParams), reprProps), color: 'uniform', colorParams: { value: _mol_util_color_names__WEBPACK_IMPORTED_MODULE_4__["ColorNames"].lightgrey } }, { tag: 'all' })
                        };
                        return [4 /*yield*/, update.commit({ revertOnError: true })];
                    case 2:
                        _c.sent();
                        return [2 /*return*/, { components: components, representations: representations }];
                }
            });
        });
    }
});
//# sourceMappingURL=preset.js.map

/***/ }),

/***/ "./lib/extensions/cellpack/property.js":
/*!*********************************************!*\
  !*** ./lib/extensions/cellpack/property.js ***!
  \*********************************************/
/*! exports provided: CellPackInfoProvider */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CellPackInfoProvider", function() { return CellPackInfoProvider; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _mol_model_props_common_custom_structure_property__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../mol-model-props/common/custom-structure-property */ "./lib/mol-model-props/common/custom-structure-property.js");
/* harmony import */ var _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../mol-util/param-definition */ "./lib/mol-util/param-definition.js");
/* harmony import */ var _mol_model_custom_property__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../mol-model/custom-property */ "./lib/mol-model/custom-property.js");
/**
 * Copyright (c) 2020 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */




var CellPackInfoParams = {
    info: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_2__["ParamDefinition"].Value({ packingsCount: 1, packingIndex: 0, colors: undefined }, { isHidden: true })
};
var CellPackInfoProvider = _mol_model_props_common_custom_structure_property__WEBPACK_IMPORTED_MODULE_1__["CustomStructureProperty"].createProvider({
    label: 'CellPack Info',
    descriptor: Object(_mol_model_custom_property__WEBPACK_IMPORTED_MODULE_3__["CustomPropertyDescriptor"])({ name: 'cellpack-info' }),
    type: 'root',
    defaultParams: CellPackInfoParams,
    getParams: function (data) { return CellPackInfoParams; },
    isApplicable: function (data) { return true; },
    obtain: function (ctx, data, props) { return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"])(void 0, void 0, void 0, function () {
        return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__generator"])(this, function (_a) {
            return [2 /*return*/, {
                    value: Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, CellPackInfoParams.info.defaultValue), props.info)
                }];
        });
    }); }
});
//# sourceMappingURL=property.js.map

/***/ }),

/***/ "./lib/extensions/cellpack/state.js":
/*!******************************************!*\
  !*** ./lib/extensions/cellpack/state.js ***!
  \******************************************/
/*! exports provided: DefaultCellPackBaseUrl, CellPack, ParseCellPack, StructureFromCellpack, StructureFromAssemblies */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DefaultCellPackBaseUrl", function() { return DefaultCellPackBaseUrl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CellPack", function() { return CellPack; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ParseCellPack", function() { return ParseCellPack; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "StructureFromCellpack", function() { return StructureFromCellpack; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "StructureFromAssemblies", function() { return StructureFromAssemblies; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _mol_plugin_state_objects__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../mol-plugin-state/objects */ "./lib/mol-plugin-state/objects.js");
/* harmony import */ var _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../mol-util/param-definition */ "./lib/mol-util/param-definition.js");
/* harmony import */ var _mol_task__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../mol-task */ "./lib/mol-task/index.js");
/* harmony import */ var _model__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./model */ "./lib/extensions/cellpack/model.js");
/* harmony import */ var _property__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./property */ "./lib/extensions/cellpack/property.js");
/* harmony import */ var _mol_model_structure__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../../mol-model/structure */ "./lib/mol-model/structure.js");
/* harmony import */ var _mol_model_formats_structure_property_symmetry__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../../mol-model-formats/structure/property/symmetry */ "./lib/mol-model-formats/structure/property/symmetry.js");
/**
 * Copyright (c) 2019-2020 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */








var DefaultCellPackBaseUrl = 'https://mesoscope.scripps.edu/data/cellPACK_data/cellPACK_database_1.1.0/';
var CellPack = /** @class */ (function (_super) {
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__extends"])(CellPack, _super);
    function CellPack() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return CellPack;
}(_mol_plugin_state_objects__WEBPACK_IMPORTED_MODULE_1__["PluginStateObject"].Create({ name: 'CellPack', typeClass: 'Object' })));


var ParseCellPack = _mol_plugin_state_objects__WEBPACK_IMPORTED_MODULE_1__["PluginStateTransform"].BuiltIn({
    name: 'parse-cellpack',
    display: { name: 'Parse CellPack', description: 'Parse CellPack from JSON data' },
    from: _mol_plugin_state_objects__WEBPACK_IMPORTED_MODULE_1__["PluginStateObject"].Format.Json,
    to: CellPack
})({
    apply: function (_a) {
        var _this = this;
        var a = _a.a;
        return _mol_task__WEBPACK_IMPORTED_MODULE_3__["Task"].create('Parse CellPack', function (ctx) { return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"])(_this, void 0, void 0, function () {
            var cell, packings, compartments, cytoplasme, name_1, _a, surface, interior;
            return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__generator"])(this, function (_b) {
                cell = a.data;
                packings = [];
                compartments = cell.compartments, cytoplasme = cell.cytoplasme;
                if (compartments) {
                    for (name_1 in compartments) {
                        _a = compartments[name_1], surface = _a.surface, interior = _a.interior;
                        if (surface)
                            packings.push({ name: name_1, location: 'surface', ingredients: surface.ingredients });
                        if (interior)
                            packings.push({ name: name_1, location: 'interior', ingredients: interior.ingredients });
                    }
                }
                if (cytoplasme)
                    packings.push({ name: 'Cytoplasme', location: 'cytoplasme', ingredients: cytoplasme.ingredients });
                return [2 /*return*/, new CellPack({ cell: cell, packings: packings })];
            });
        }); });
    }
});

var StructureFromCellpack = _mol_plugin_state_objects__WEBPACK_IMPORTED_MODULE_1__["PluginStateTransform"].BuiltIn({
    name: 'structure-from-cellpack',
    display: { name: 'Structure from CellPack', description: 'Create Structure from CellPack Packing' },
    from: CellPack,
    to: _mol_plugin_state_objects__WEBPACK_IMPORTED_MODULE_1__["PluginStateObject"].Molecule.Structure,
    params: function (a) {
        var options = a ? a.data.packings.map(function (d, i) { return [i, d.name]; }) : [];
        return {
            packing: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_2__["ParamDefinition"].Select(0, options),
            baseUrl: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_2__["ParamDefinition"].Text(DefaultCellPackBaseUrl),
            ingredientFiles: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_2__["ParamDefinition"].FileList({ accept: '.cif,.bcif,.pdb' })
        };
    }
})({
    apply: function (_a, plugin) {
        var _this = this;
        var a = _a.a, params = _a.params, cache = _a.cache;
        return _mol_task__WEBPACK_IMPORTED_MODULE_3__["Task"].create('Structure from CellPack', function (ctx) { return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"])(_this, void 0, void 0, function () {
            var packing, ingredientFiles, _i, _a, file, _b, structure, assets, colors;
            return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__generator"])(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        packing = a.data.packings[params.packing];
                        ingredientFiles = {};
                        if (params.ingredientFiles !== null) {
                            for (_i = 0, _a = params.ingredientFiles; _i < _a.length; _i++) {
                                file = _a[_i];
                                ingredientFiles[file.name] = file;
                            }
                        }
                        return [4 /*yield*/, Object(_model__WEBPACK_IMPORTED_MODULE_4__["createStructureFromCellPack"])(plugin, packing, params.baseUrl, ingredientFiles).runInContext(ctx)];
                    case 1:
                        _b = _c.sent(), structure = _b.structure, assets = _b.assets, colors = _b.colors;
                        return [4 /*yield*/, _property__WEBPACK_IMPORTED_MODULE_5__["CellPackInfoProvider"].attach({ runtime: ctx, assetManager: plugin.managers.asset }, structure, {
                                info: { packingsCount: a.data.packings.length, packingIndex: params.packing, colors: colors }
                            })];
                    case 2:
                        _c.sent();
                        cache.assets = assets;
                        return [2 /*return*/, new _mol_plugin_state_objects__WEBPACK_IMPORTED_MODULE_1__["PluginStateObject"].Molecule.Structure(structure, { label: packing.name })];
                }
            });
        }); });
    },
    dispose: function (_a) {
        var b = _a.b, cache = _a.cache;
        var assets = cache.assets;
        if (assets) {
            for (var _i = 0, assets_1 = assets; _i < assets_1.length; _i++) {
                var a = assets_1[_i];
                a.dispose();
            }
        }
        if (b) {
            b.data.customPropertyDescriptors.dispose();
            for (var _b = 0, _c = b.data.models; _b < _c.length; _b++) {
                var m = _c[_b];
                m.customProperties.dispose();
            }
        }
    }
});

var StructureFromAssemblies = _mol_plugin_state_objects__WEBPACK_IMPORTED_MODULE_1__["PluginStateTransform"].BuiltIn({
    name: 'Structure from all assemblies',
    display: { name: 'Structure from all assemblies' },
    from: _mol_plugin_state_objects__WEBPACK_IMPORTED_MODULE_1__["PluginStateObject"].Molecule.Model,
    to: _mol_plugin_state_objects__WEBPACK_IMPORTED_MODULE_1__["PluginStateObject"].Molecule.Structure,
    params: {}
})({
    canAutoUpdate: function (_a) {
        var newParams = _a.newParams;
        return true;
    },
    apply: function (_a) {
        var _this = this;
        var a = _a.a, params = _a.params;
        return _mol_task__WEBPACK_IMPORTED_MODULE_3__["Task"].create('Build Structure', function (ctx) { return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"])(_this, void 0, void 0, function () {
            var model, initial_structure, structures, structure, symmetry, _i, _a, a_1, s, builder, offsetInvariantId, _b, structures_1, s, maxInvariantId, _c, _d, u, invariantId, i, il;
            return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__generator"])(this, function (_e) {
                switch (_e.label) {
                    case 0:
                        model = a.data;
                        initial_structure = _mol_model_structure__WEBPACK_IMPORTED_MODULE_6__["Structure"].ofModel(model);
                        structures = [];
                        structure = initial_structure;
                        symmetry = _mol_model_formats_structure_property_symmetry__WEBPACK_IMPORTED_MODULE_7__["ModelSymmetry"].Provider.get(model);
                        if (!(symmetry && symmetry.assemblies.length !== 0)) return [3 /*break*/, 5];
                        _i = 0, _a = symmetry.assemblies;
                        _e.label = 1;
                    case 1:
                        if (!(_i < _a.length)) return [3 /*break*/, 4];
                        a_1 = _a[_i];
                        return [4 /*yield*/, _mol_model_structure__WEBPACK_IMPORTED_MODULE_6__["StructureSymmetry"].buildAssembly(initial_structure, a_1.id).runInContext(ctx)];
                    case 2:
                        s = _e.sent();
                        structures.push(s);
                        _e.label = 3;
                    case 3:
                        _i++;
                        return [3 /*break*/, 1];
                    case 4:
                        builder = _mol_model_structure__WEBPACK_IMPORTED_MODULE_6__["Structure"].Builder();
                        offsetInvariantId = 0;
                        for (_b = 0, structures_1 = structures; _b < structures_1.length; _b++) {
                            s = structures_1[_b];
                            maxInvariantId = 0;
                            for (_c = 0, _d = s.units; _c < _d.length; _c++) {
                                u = _d[_c];
                                invariantId = u.invariantId + offsetInvariantId;
                                if (u.invariantId > maxInvariantId)
                                    maxInvariantId = u.invariantId;
                                builder.addUnit(u.kind, u.model, u.conformation.operator, u.elements, 0 /* None */, invariantId);
                            }
                            offsetInvariantId += maxInvariantId + 1;
                        }
                        structure = builder.getStructure();
                        for (i = 0, il = structure.models.length; i < il; ++i) {
                            _mol_model_structure__WEBPACK_IMPORTED_MODULE_6__["Model"].TrajectoryInfo.set(structure.models[i], { size: il, index: i });
                        }
                        _e.label = 5;
                    case 5: return [2 /*return*/, new _mol_plugin_state_objects__WEBPACK_IMPORTED_MODULE_1__["PluginStateObject"].Molecule.Structure(structure, { label: a.label, description: "" + a.description })];
                }
            });
        }); });
    },
    dispose: function (_a) {
        var b = _a.b;
        b === null || b === void 0 ? void 0 : b.data.customPropertyDescriptors.dispose();
    }
});
//# sourceMappingURL=state.js.map

/***/ }),

/***/ "./lib/extensions/cellpack/util.js":
/*!*****************************************!*\
  !*** ./lib/extensions/cellpack/util.js ***!
  \*****************************************/
/*! exports provided: parseCif, parsePDBfile, getFromPdb, getFromOPM, getFromCellPackDB, getStructureMean */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "parseCif", function() { return parseCif; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "parsePDBfile", function() { return parsePDBfile; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getFromPdb", function() { return getFromPdb; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getFromOPM", function() { return getFromOPM; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getFromCellPackDB", function() { return getFromCellPackDB; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getStructureMean", function() { return getStructureMean; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _mol_io_reader_cif__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../mol-io/reader/cif */ "./lib/mol-io/reader/cif.js");
/* harmony import */ var _mol_io_reader_pdb_parser__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../mol-io/reader/pdb/parser */ "./lib/mol-io/reader/pdb/parser.js");
/* harmony import */ var _mol_util_assets__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../mol-util/assets */ "./lib/mol-util/assets.js");
/* harmony import */ var _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../mol-math/linear-algebra */ "./lib/mol-math/linear-algebra.js");
/**
 * Copyright (c) 2019-2020 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */





function parseCif(plugin, data) {
    return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"])(this, void 0, void 0, function () {
        var comp, parsed;
        return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__generator"])(this, function (_a) {
            switch (_a.label) {
                case 0:
                    comp = _mol_io_reader_cif__WEBPACK_IMPORTED_MODULE_1__["CIF"].parse(data);
                    return [4 /*yield*/, plugin.runTask(comp)];
                case 1:
                    parsed = _a.sent();
                    if (parsed.isError)
                        throw parsed;
                    return [2 /*return*/, parsed.result];
            }
        });
    });
}
function parsePDBfile(plugin, data, id) {
    return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"])(this, void 0, void 0, function () {
        var comp, parsed;
        return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__generator"])(this, function (_a) {
            switch (_a.label) {
                case 0:
                    comp = Object(_mol_io_reader_pdb_parser__WEBPACK_IMPORTED_MODULE_2__["parsePDB"])(data, id);
                    return [4 /*yield*/, plugin.runTask(comp)];
                case 1:
                    parsed = _a.sent();
                    if (parsed.isError)
                        throw parsed;
                    return [2 /*return*/, parsed.result];
            }
        });
    });
}
function downloadCif(plugin, url, isBinary, assetManager) {
    return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"])(this, void 0, void 0, function () {
        var type, asset;
        var _a;
        return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__generator"])(this, function (_b) {
            switch (_b.label) {
                case 0:
                    type = isBinary ? 'binary' : 'string';
                    return [4 /*yield*/, plugin.runTask(assetManager.resolve(_mol_util_assets__WEBPACK_IMPORTED_MODULE_3__["Asset"].getUrlAsset(assetManager, url), type))];
                case 1:
                    asset = _b.sent();
                    _a = {};
                    return [4 /*yield*/, parseCif(plugin, asset.data)];
                case 2: return [2 /*return*/, (_a.cif = _b.sent(), _a.asset = asset, _a)];
            }
        });
    });
}
function downloadPDB(plugin, url, id, assetManager) {
    return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"])(this, void 0, void 0, function () {
        var asset;
        var _a;
        return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__generator"])(this, function (_b) {
            switch (_b.label) {
                case 0: return [4 /*yield*/, assetManager.resolve(_mol_util_assets__WEBPACK_IMPORTED_MODULE_3__["Asset"].getUrlAsset(assetManager, url), 'string').run()];
                case 1:
                    asset = _b.sent();
                    _a = {};
                    return [4 /*yield*/, parsePDBfile(plugin, asset.data, id)];
                case 2: return [2 /*return*/, (_a.pdb = _b.sent(), _a.asset = asset, _a)];
            }
        });
    });
}
function getFromPdb(plugin, pdbId, assetManager) {
    return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"])(this, void 0, void 0, function () {
        var _a, cif, asset;
        return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__generator"])(this, function (_b) {
            switch (_b.label) {
                case 0: return [4 /*yield*/, downloadCif(plugin, "https://models.rcsb.org/" + pdbId.toUpperCase() + ".bcif", true, assetManager)];
                case 1:
                    _a = _b.sent(), cif = _a.cif, asset = _a.asset;
                    return [2 /*return*/, { mmcif: cif.blocks[0], asset: asset }];
            }
        });
    });
}
function getFromOPM(plugin, pdbId, assetManager) {
    return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"])(this, void 0, void 0, function () {
        var asset;
        var _a;
        return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__generator"])(this, function (_b) {
            switch (_b.label) {
                case 0: return [4 /*yield*/, plugin.runTask(assetManager.resolve(_mol_util_assets__WEBPACK_IMPORTED_MODULE_3__["Asset"].getUrlAsset(assetManager, "https://opm-assets.storage.googleapis.com/pdb/" + pdbId.toLowerCase() + ".pdb"), 'string'))];
                case 1:
                    asset = _b.sent();
                    _a = {};
                    return [4 /*yield*/, parsePDBfile(plugin, asset.data, pdbId)];
                case 2: return [2 /*return*/, (_a.pdb = _b.sent(), _a.asset = asset, _a)];
            }
        });
    });
}
function getFromCellPackDB(plugin, id, baseUrl, assetManager) {
    return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"])(this, void 0, void 0, function () {
        var isBinary, _a, cif, asset, name_1;
        return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__generator"])(this, function (_b) {
            switch (_b.label) {
                case 0:
                    if (!(id.toLowerCase().endsWith('.cif') || id.toLowerCase().endsWith('.bcif'))) return [3 /*break*/, 2];
                    isBinary = id.toLowerCase().endsWith('.bcif');
                    return [4 /*yield*/, downloadCif(plugin, baseUrl + "/other/" + id, isBinary, assetManager)];
                case 1:
                    _a = _b.sent(), cif = _a.cif, asset = _a.asset;
                    return [2 /*return*/, { mmcif: cif.blocks[0], asset: asset }];
                case 2:
                    name_1 = id.endsWith('.pdb') ? id.substring(0, id.length - 4) : id;
                    return [4 /*yield*/, downloadPDB(plugin, baseUrl + "/other/" + name_1 + ".pdb", name_1, assetManager)];
                case 3: return [2 /*return*/, _b.sent()];
            }
        });
    });
}
function getStructureMean(structure) {
    var xSum = 0, ySum = 0, zSum = 0;
    for (var i = 0, il = structure.units.length; i < il; ++i) {
        var unit = structure.units[i];
        var elements = unit.elements;
        var _a = unit.conformation, x = _a.x, y = _a.y, z = _a.z;
        for (var j = 0, jl = elements.length; j < jl; ++j) {
            var eI = elements[j];
            xSum += x(eI);
            ySum += y(eI);
            zSum += z(eI);
        }
    }
    var elementCount = structure.elementCount;
    return _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_4__["Vec3"].create(xSum / elementCount, ySum / elementCount, zSum / elementCount);
}
//# sourceMappingURL=util.js.map

/***/ }),

/***/ "./lib/extensions/dnatco/confal-pyramids/behavior.js":
/*!***********************************************************!*\
  !*** ./lib/extensions/dnatco/confal-pyramids/behavior.js ***!
  \***********************************************************/
/*! exports provided: DnatcoConfalPyramidsPreset, DnatcoConfalPyramids */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DnatcoConfalPyramidsPreset", function() { return DnatcoConfalPyramidsPreset; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DnatcoConfalPyramids", function() { return DnatcoConfalPyramids; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _color__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./color */ "./lib/extensions/dnatco/confal-pyramids/color.js");
/* harmony import */ var _property__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./property */ "./lib/extensions/dnatco/confal-pyramids/property.js");
/* harmony import */ var _representation__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./representation */ "./lib/extensions/dnatco/confal-pyramids/representation.js");
/* harmony import */ var _mol_plugin_behavior_behavior__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../../mol-plugin/behavior/behavior */ "./lib/mol-plugin/behavior/behavior.js");
/* harmony import */ var _mol_plugin_state_builder_structure_representation_preset__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../../mol-plugin-state/builder/structure/representation-preset */ "./lib/mol-plugin-state/builder/structure/representation-preset.js");
/* harmony import */ var _mol_state__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../../../mol-state */ "./lib/mol-state/index.js");
/* harmony import */ var _mol_task__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../../../mol-task */ "./lib/mol-task/index.js");
/* harmony import */ var _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ../../../mol-util/param-definition */ "./lib/mol-util/param-definition.js");
/**
 * Copyright (c) 2018-2020 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author Michal Malý <michal.maly@ibt.cas.cz>
 * @author Jiří Černý <jiri.cerny@ibt.cas.cz>
 */









var DnatcoConfalPyramidsPreset = Object(_mol_plugin_state_builder_structure_representation_preset__WEBPACK_IMPORTED_MODULE_5__["StructureRepresentationPresetProvider"])({
    id: 'preset-structure-representation-confal-pyramids',
    display: {
        name: 'Confal Pyramids', group: 'Annotation',
        description: 'Schematic depiction of conformer class and confal value.',
    },
    isApplicable: function (a) {
        return a.data.models.length >= 1 && a.data.models.some(function (m) { return _property__WEBPACK_IMPORTED_MODULE_2__["ConfalPyramids"].isApplicable(m); });
    },
    params: function () { return _mol_plugin_state_builder_structure_representation_preset__WEBPACK_IMPORTED_MODULE_5__["StructureRepresentationPresetProvider"].CommonParams; },
    apply: function (ref, params, plugin) {
        var _a;
        return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"])(this, void 0, void 0, function () {
            var structureCell, model, _b, components, representations, pyramids, _c, update, builder, typeParams, pyramidsRepr;
            var _this = this;
            return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__generator"])(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        structureCell = _mol_state__WEBPACK_IMPORTED_MODULE_6__["StateObjectRef"].resolveAndCheck(plugin.state.data, ref);
                        model = (_a = structureCell === null || structureCell === void 0 ? void 0 : structureCell.obj) === null || _a === void 0 ? void 0 : _a.data.model;
                        if (!structureCell || !model)
                            return [2 /*return*/, {}];
                        return [4 /*yield*/, plugin.runTask(_mol_task__WEBPACK_IMPORTED_MODULE_7__["Task"].create('Confal Pyramids', function (runtime) { return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"])(_this, void 0, void 0, function () {
                                return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__generator"])(this, function (_a) {
                                    switch (_a.label) {
                                        case 0: return [4 /*yield*/, _property__WEBPACK_IMPORTED_MODULE_2__["ConfalPyramidsProvider"].attach({ runtime: runtime, assetManager: plugin.managers.asset }, model)];
                                        case 1:
                                            _a.sent();
                                            return [2 /*return*/];
                                    }
                                });
                            }); }))];
                    case 1:
                        _d.sent();
                        return [4 /*yield*/, _mol_plugin_state_builder_structure_representation_preset__WEBPACK_IMPORTED_MODULE_5__["PresetStructureRepresentations"].auto.apply(ref, Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, params), plugin)];
                    case 2:
                        _b = _d.sent(), components = _b.components, representations = _b.representations;
                        return [4 /*yield*/, plugin.builders.structure.tryCreateComponentStatic(structureCell, 'nucleic', { label: 'Confal Pyramids' })];
                    case 3:
                        pyramids = _d.sent();
                        _c = _mol_plugin_state_builder_structure_representation_preset__WEBPACK_IMPORTED_MODULE_5__["StructureRepresentationPresetProvider"].reprBuilder(plugin, params), update = _c.update, builder = _c.builder, typeParams = _c.typeParams;
                        if (representations)
                            pyramidsRepr = builder.buildRepresentation(update, pyramids, { type: _representation__WEBPACK_IMPORTED_MODULE_3__["ConfalPyramidsRepresentationProvider"], typeParams: typeParams, color: _color__WEBPACK_IMPORTED_MODULE_1__["ConfalPyramidsColorThemeProvider"] }, { tag: 'confal-pyramdis' });
                        return [4 /*yield*/, update.commit({ revertOnError: true })];
                    case 4:
                        _d.sent();
                        return [2 /*return*/, { components: Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, components), { pyramids: pyramids }), representations: Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, representations), { pyramidsRepr: pyramidsRepr }) }];
                }
            });
        });
    }
});
var DnatcoConfalPyramids = _mol_plugin_behavior_behavior__WEBPACK_IMPORTED_MODULE_4__["PluginBehavior"].create({
    name: 'dnatco-confal-pyramids-prop',
    category: 'custom-props',
    display: {
        name: 'Confal Pyramids',
        description: 'Schematic depiction of conformer class and confal value.',
    },
    ctor: /** @class */ (function (_super) {
        Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__extends"])(class_1, _super);
        function class_1() {
            var _this = _super !== null && _super.apply(this, arguments) || this;
            _this.provider = _property__WEBPACK_IMPORTED_MODULE_2__["ConfalPyramidsProvider"];
            _this.labelConfalPyramids = {
                label: function (loci) {
                    if (!_this.params.showToolTip)
                        return void 0;
                    /* TODO: Implement this */
                    return void 0;
                }
            };
            return _this;
        }
        class_1.prototype.register = function () {
            this.ctx.customModelProperties.register(this.provider, this.params.autoAttach);
            this.ctx.managers.lociLabels.addProvider(this.labelConfalPyramids);
            this.ctx.representation.structure.themes.colorThemeRegistry.add(_color__WEBPACK_IMPORTED_MODULE_1__["ConfalPyramidsColorThemeProvider"]);
            this.ctx.representation.structure.registry.add(_representation__WEBPACK_IMPORTED_MODULE_3__["ConfalPyramidsRepresentationProvider"]);
            this.ctx.builders.structure.representation.registerPreset(DnatcoConfalPyramidsPreset);
        };
        class_1.prototype.update = function (p) {
            var updated = this.params.autoAttach !== p.autoAttach;
            this.params.autoAttach = p.autoAttach;
            this.params.showToolTip = p.showToolTip;
            this.ctx.customModelProperties.setDefaultAutoAttach(this.provider.descriptor.name, this.params.autoAttach);
            return updated;
        };
        class_1.prototype.unregister = function () {
            this.ctx.customModelProperties.unregister(_property__WEBPACK_IMPORTED_MODULE_2__["ConfalPyramidsProvider"].descriptor.name);
            this.ctx.managers.lociLabels.removeProvider(this.labelConfalPyramids);
            this.ctx.representation.structure.registry.remove(_representation__WEBPACK_IMPORTED_MODULE_3__["ConfalPyramidsRepresentationProvider"]);
            this.ctx.representation.structure.themes.colorThemeRegistry.remove(_color__WEBPACK_IMPORTED_MODULE_1__["ConfalPyramidsColorThemeProvider"]);
            this.ctx.builders.structure.representation.unregisterPreset(DnatcoConfalPyramidsPreset);
        };
        return class_1;
    }(_mol_plugin_behavior_behavior__WEBPACK_IMPORTED_MODULE_4__["PluginBehavior"].Handler)),
    params: function () { return ({
        autoAttach: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_8__["ParamDefinition"].Boolean(true),
        showToolTip: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_8__["ParamDefinition"].Boolean(true)
    }); }
});
//# sourceMappingURL=behavior.js.map

/***/ }),

/***/ "./lib/extensions/dnatco/confal-pyramids/color.js":
/*!********************************************************!*\
  !*** ./lib/extensions/dnatco/confal-pyramids/color.js ***!
  \********************************************************/
/*! exports provided: ConfalPyramidsColorThemeParams, getConfalPyramidsColorThemeParams, ConfalPyramidsColorTheme, ConfalPyramidsColorThemeProvider */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ConfalPyramidsColorThemeParams", function() { return ConfalPyramidsColorThemeParams; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getConfalPyramidsColorThemeParams", function() { return getConfalPyramidsColorThemeParams; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ConfalPyramidsColorTheme", function() { return ConfalPyramidsColorTheme; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ConfalPyramidsColorThemeProvider", function() { return ConfalPyramidsColorThemeProvider; });
/* harmony import */ var _property__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./property */ "./lib/extensions/dnatco/confal-pyramids/property.js");
/* harmony import */ var _types__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./types */ "./lib/extensions/dnatco/confal-pyramids/types.js");
/* harmony import */ var _mol_util_color__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../../mol-util/color */ "./lib/mol-util/color/index.js");
/* harmony import */ var _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../../mol-util/param-definition */ "./lib/mol-util/param-definition.js");
/* harmony import */ var _mol_util_legend__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../../mol-util/legend */ "./lib/mol-util/legend.js");
/* harmony import */ var _mol_data_util__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../../mol-data/util */ "./lib/mol-data/util.js");
/**
 * Copyright (c) 2018-2020 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author Michal Malý <michal.maly@ibt.cas.cz>
 * @author Jiří Černý <jiri.cerny@ibt.cas.cz>
 */






var DefaultColor = Object(_mol_util_color__WEBPACK_IMPORTED_MODULE_2__["Color"])(0xCCCCCC);
var Description = 'Assigns colors to confal pyramids';
var ErrorColor = Object(_mol_util_color__WEBPACK_IMPORTED_MODULE_2__["Color"])(0xFFA10A);
var ColorMapping = new Map([
    ['A', Object(_mol_util_color__WEBPACK_IMPORTED_MODULE_2__["Color"])(0xFFC1C1)],
    ['B', Object(_mol_util_color__WEBPACK_IMPORTED_MODULE_2__["Color"])(0xC8CFFF)],
    ['BII', Object(_mol_util_color__WEBPACK_IMPORTED_MODULE_2__["Color"])(0x0059DA)],
    ['miB', Object(_mol_util_color__WEBPACK_IMPORTED_MODULE_2__["Color"])(0x3BE8FB)],
    ['Z', Object(_mol_util_color__WEBPACK_IMPORTED_MODULE_2__["Color"])(0x01F60E)],
    ['IC', Object(_mol_util_color__WEBPACK_IMPORTED_MODULE_2__["Color"])(0xFA5CFB)],
    ['OPN', Object(_mol_util_color__WEBPACK_IMPORTED_MODULE_2__["Color"])(0xE90000)],
    ['SYN', Object(_mol_util_color__WEBPACK_IMPORTED_MODULE_2__["Color"])(0xFFFF01)],
    ['N', Object(_mol_util_color__WEBPACK_IMPORTED_MODULE_2__["Color"])(0xF2F2F2)],
]);
var NtCToClasses = new Map([
    ['NANT', ['N', 'N']],
    ['AA00', ['A', 'A']],
    ['AA02', ['A', 'A']],
    ['AA03', ['A', 'A']],
    ['AA04', ['A', 'A']],
    ['AA08', ['A', 'A']],
    ['AA09', ['A', 'A']],
    ['AA01', ['A', 'A']],
    ['AA05', ['A', 'A']],
    ['AA06', ['A', 'A']],
    ['AA10', ['A', 'A']],
    ['AA11', ['A', 'A']],
    ['AA07', ['A', 'A']],
    ['AA12', ['A', 'A']],
    ['AA13', ['A', 'A']],
    ['AB01', ['A', 'B']],
    ['AB02', ['A', 'B']],
    ['AB03', ['A', 'B']],
    ['AB04', ['A', 'B']],
    ['AB05', ['A', 'B']],
    ['BA01', ['B', 'A']],
    ['BA05', ['B', 'A']],
    ['BA09', ['B', 'A']],
    ['BA08', ['BII', 'A']],
    ['BA10', ['B', 'A']],
    ['BA13', ['BII', 'A']],
    ['BA16', ['BII', 'A']],
    ['BA17', ['BII', 'A']],
    ['BB00', ['B', 'B']],
    ['BB01', ['B', 'B']],
    ['BB17', ['B', 'B']],
    ['BB02', ['B', 'B']],
    ['BB03', ['B', 'B']],
    ['BB11', ['B', 'B']],
    ['BB16', ['B', 'B']],
    ['BB04', ['B', 'BII']],
    ['BB05', ['B', 'BII']],
    ['BB07', ['BII', 'BII']],
    ['BB08', ['BII', 'BII']],
    ['BB10', ['miB', 'miB']],
    ['BB12', ['miB', 'miB']],
    ['BB13', ['miB', 'miB']],
    ['BB14', ['miB', 'miB']],
    ['BB15', ['miB', 'miB']],
    ['BB20', ['miB', 'miB']],
    ['IC01', ['IC', 'IC']],
    ['IC02', ['IC', 'IC']],
    ['IC03', ['IC', 'IC']],
    ['IC04', ['IC', 'IC']],
    ['IC05', ['IC', 'IC']],
    ['IC06', ['IC', 'IC']],
    ['IC07', ['IC', 'IC']],
    ['OP01', ['OPN', 'OPN']],
    ['OP02', ['OPN', 'OPN']],
    ['OP03', ['OPN', 'OPN']],
    ['OP04', ['OPN', 'OPN']],
    ['OP05', ['OPN', 'OPN']],
    ['OP06', ['OPN', 'OPN']],
    ['OP07', ['OPN', 'OPN']],
    ['OP08', ['OPN', 'OPN']],
    ['OP09', ['OPN', 'OPN']],
    ['OP10', ['OPN', 'OPN']],
    ['OP11', ['OPN', 'OPN']],
    ['OP12', ['OPN', 'OPN']],
    ['OP13', ['OPN', 'OPN']],
    ['OP14', ['OPN', 'OPN']],
    ['OP15', ['OPN', 'OPN']],
    ['OP16', ['OPN', 'OPN']],
    ['OP17', ['OPN', 'OPN']],
    ['OP18', ['OPN', 'OPN']],
    ['OP19', ['OPN', 'OPN']],
    ['OP20', ['OPN', 'OPN']],
    ['OP21', ['OPN', 'OPN']],
    ['OP22', ['OPN', 'OPN']],
    ['OP23', ['OPN', 'OPN']],
    ['OP24', ['OPN', 'OPN']],
    ['OP25', ['OPN', 'OPN']],
    ['OP26', ['OPN', 'OPN']],
    ['OP27', ['OPN', 'OPN']],
    ['OP28', ['OPN', 'OPN']],
    ['OP29', ['OPN', 'OPN']],
    ['OP30', ['OPN', 'OPN']],
    ['OP31', ['OPN', 'OPN']],
    ['OPS1', ['OPN', 'OPN']],
    ['OP1S', ['OPN', 'SYN']],
    ['AAS1', ['SYN', 'A']],
    ['AB1S', ['A', 'SYN']],
    ['AB2S', ['A', 'SYN']],
    ['BB1S', ['B', 'SYN']],
    ['BB2S', ['B', 'SYN']],
    ['BBS1', ['SYN', 'B']],
    ['ZZ01', ['Z', 'Z']],
    ['ZZ02', ['Z', 'Z']],
    ['ZZ1S', ['Z', 'SYN']],
    ['ZZ2S', ['Z', 'SYN']],
    ['ZZS1', ['SYN', 'Z']],
    ['ZZS2', ['SYN', 'Z']],
]);
function getConformerColor(ntc, useLower) {
    var _a;
    var item = NtCToClasses.get(ntc);
    if (!item)
        return ErrorColor;
    return (_a = ColorMapping.get(useLower ? item[1] : item[0])) !== null && _a !== void 0 ? _a : ErrorColor;
}
var ConfalPyramidsColorThemeParams = {};
function getConfalPyramidsColorThemeParams(ctx) {
    return ConfalPyramidsColorThemeParams; // TODO return copy
}
function ConfalPyramidsColorTheme(ctx, props) {
    function color(location, isSecondary) {
        if (_types__WEBPACK_IMPORTED_MODULE_1__["ConfalPyramidsTypes"].isLocation(location)) {
            var _a = location.data, pyramid = _a.pyramid, isLower = _a.isLower;
            return getConformerColor(pyramid.NtC, isLower);
        }
        return DefaultColor;
    }
    return {
        factory: ConfalPyramidsColorTheme,
        granularity: 'group',
        color: color,
        props: props,
        description: Description,
        legend: Object(_mol_util_legend__WEBPACK_IMPORTED_MODULE_4__["TableLegend"])(Object(_mol_data_util__WEBPACK_IMPORTED_MODULE_5__["iterableToArray"])(ColorMapping.entries()).map(function (_a) {
            var conformer = _a[0], color = _a[1];
            return [conformer, color];
        }).concat([
            ['Error', ErrorColor],
            ['Unknown', DefaultColor]
        ]))
    };
}
var ConfalPyramidsColorThemeProvider = {
    name: 'confal-pyramids',
    label: 'Confal Pyramids',
    category: "Residue Property" /* Residue */,
    factory: ConfalPyramidsColorTheme,
    getParams: getConfalPyramidsColorThemeParams,
    defaultValues: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_3__["ParamDefinition"].getDefaultValues(ConfalPyramidsColorThemeParams),
    isApplicable: function (ctx) { return !!ctx.structure && ctx.structure.models.some(function (m) { return _property__WEBPACK_IMPORTED_MODULE_0__["ConfalPyramids"].isApplicable(m); }); },
    ensureCustomProperties: {
        attach: function (ctx, data) { return data.structure ? _property__WEBPACK_IMPORTED_MODULE_0__["ConfalPyramidsProvider"].attach(ctx, data.structure.models[0], void 0, true) : Promise.resolve(); },
        detach: function (data) { return data.structure && data.structure.models[0].customProperties.reference(_property__WEBPACK_IMPORTED_MODULE_0__["ConfalPyramidsProvider"].descriptor, false); }
    }
};
//# sourceMappingURL=color.js.map

/***/ }),

/***/ "./lib/extensions/dnatco/confal-pyramids/property.js":
/*!***********************************************************!*\
  !*** ./lib/extensions/dnatco/confal-pyramids/property.js ***!
  \***********************************************************/
/*! exports provided: ConfalPyramids, ConfalPyramidsParams, ConfalPyramidsProvider */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ConfalPyramids", function() { return ConfalPyramids; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ConfalPyramidsParams", function() { return ConfalPyramidsParams; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ConfalPyramidsProvider", function() { return ConfalPyramidsProvider; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _types__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./types */ "./lib/extensions/dnatco/confal-pyramids/types.js");
/* harmony import */ var _mol_data_db__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../../mol-data/db */ "./lib/mol-data/db.js");
/* harmony import */ var _mol_io_reader_cif_schema__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../../mol-io/reader/cif/schema */ "./lib/mol-io/reader/cif/schema.js");
/* harmony import */ var _mol_model_custom_property__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../../mol-model/custom-property */ "./lib/mol-model/custom-property.js");
/* harmony import */ var _mol_model_props_common_custom_model_property__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../../mol-model-props/common/custom-model-property */ "./lib/mol-model-props/common/custom-model-property.js");
/* harmony import */ var _mol_model_props_common_wrapper__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../../../mol-model-props/common/wrapper */ "./lib/mol-model-props/common/wrapper.js");
/* harmony import */ var _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../../../mol-util/param-definition */ "./lib/mol-util/param-definition.js");
/* harmony import */ var _mol_model_formats_structure_mmcif__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ../../../mol-model-formats/structure/mmcif */ "./lib/mol-model-formats/structure/mmcif.js");
/**
 * Copyright (c) 2018-2020 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author Michal Malý <michal.maly@ibt.cas.cz>
 * @author Jiří Černý <jiri.cerny@ibt.cas.cz>
 */









var ConfalPyramids;
(function (ConfalPyramids) {
    ConfalPyramids.Schema = {
        ndb_struct_ntc_step: {
            id: _mol_data_db__WEBPACK_IMPORTED_MODULE_2__["Column"].Schema.int,
            name: _mol_data_db__WEBPACK_IMPORTED_MODULE_2__["Column"].Schema.str,
            PDB_model_number: _mol_data_db__WEBPACK_IMPORTED_MODULE_2__["Column"].Schema.int,
            label_entity_id_1: _mol_data_db__WEBPACK_IMPORTED_MODULE_2__["Column"].Schema.int,
            label_asym_id_1: _mol_data_db__WEBPACK_IMPORTED_MODULE_2__["Column"].Schema.str,
            label_seq_id_1: _mol_data_db__WEBPACK_IMPORTED_MODULE_2__["Column"].Schema.int,
            label_comp_id_1: _mol_data_db__WEBPACK_IMPORTED_MODULE_2__["Column"].Schema.str,
            label_alt_id_1: _mol_data_db__WEBPACK_IMPORTED_MODULE_2__["Column"].Schema.str,
            label_entity_id_2: _mol_data_db__WEBPACK_IMPORTED_MODULE_2__["Column"].Schema.int,
            label_asym_id_2: _mol_data_db__WEBPACK_IMPORTED_MODULE_2__["Column"].Schema.str,
            label_seq_id_2: _mol_data_db__WEBPACK_IMPORTED_MODULE_2__["Column"].Schema.int,
            label_comp_id_2: _mol_data_db__WEBPACK_IMPORTED_MODULE_2__["Column"].Schema.str,
            label_alt_id_2: _mol_data_db__WEBPACK_IMPORTED_MODULE_2__["Column"].Schema.str,
            auth_asym_id_1: _mol_data_db__WEBPACK_IMPORTED_MODULE_2__["Column"].Schema.str,
            auth_seq_id_1: _mol_data_db__WEBPACK_IMPORTED_MODULE_2__["Column"].Schema.int,
            auth_asym_id_2: _mol_data_db__WEBPACK_IMPORTED_MODULE_2__["Column"].Schema.str,
            auth_seq_id_2: _mol_data_db__WEBPACK_IMPORTED_MODULE_2__["Column"].Schema.int,
            PDB_ins_code_1: _mol_data_db__WEBPACK_IMPORTED_MODULE_2__["Column"].Schema.str,
            PDB_ins_code_2: _mol_data_db__WEBPACK_IMPORTED_MODULE_2__["Column"].Schema.str,
        },
        ndb_struct_ntc_step_summary: {
            step_id: _mol_data_db__WEBPACK_IMPORTED_MODULE_2__["Column"].Schema.int,
            assigned_CANA: _mol_data_db__WEBPACK_IMPORTED_MODULE_2__["Column"].Schema.str,
            assigned_NtC: _mol_data_db__WEBPACK_IMPORTED_MODULE_2__["Column"].Schema.str,
            confal_score: _mol_data_db__WEBPACK_IMPORTED_MODULE_2__["Column"].Schema.int,
            euclidean_distance_NtC_ideal: _mol_data_db__WEBPACK_IMPORTED_MODULE_2__["Column"].Schema.float,
            cartesian_rmsd_closest_NtC_representative: _mol_data_db__WEBPACK_IMPORTED_MODULE_2__["Column"].Schema.float,
            closest_CANA: _mol_data_db__WEBPACK_IMPORTED_MODULE_2__["Column"].Schema.str,
            closest_NtC: _mol_data_db__WEBPACK_IMPORTED_MODULE_2__["Column"].Schema.str,
            closest_step_golden: _mol_data_db__WEBPACK_IMPORTED_MODULE_2__["Column"].Schema.str
        }
    };
    function fromCif(ctx, model, props) {
        return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"])(this, void 0, void 0, function () {
            var info, data, fromCif;
            return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__generator"])(this, function (_a) {
                info = _mol_model_props_common_wrapper__WEBPACK_IMPORTED_MODULE_6__["PropertyWrapper"].createInfo();
                data = getCifData(model);
                if (data === undefined)
                    return [2 /*return*/, { value: { info: info, data: undefined } }];
                fromCif = createPyramidsFromCif(model, data.steps, data.stepsSummary);
                return [2 /*return*/, { value: { info: info, data: fromCif } }];
            });
        });
    }
    ConfalPyramids.fromCif = fromCif;
    function getCifData(model) {
        if (!_mol_model_formats_structure_mmcif__WEBPACK_IMPORTED_MODULE_8__["MmcifFormat"].is(model.sourceData))
            throw new Error('Data format must be mmCIF');
        if (!hasNdbStructNtcCategories(model))
            return undefined;
        return {
            steps: Object(_mol_io_reader_cif_schema__WEBPACK_IMPORTED_MODULE_3__["toTable"])(ConfalPyramids.Schema.ndb_struct_ntc_step, model.sourceData.data.frame.categories.ndb_struct_ntc_step),
            stepsSummary: Object(_mol_io_reader_cif_schema__WEBPACK_IMPORTED_MODULE_3__["toTable"])(ConfalPyramids.Schema.ndb_struct_ntc_step_summary, model.sourceData.data.frame.categories.ndb_struct_ntc_step_summary)
        };
    }
    function hasNdbStructNtcCategories(model) {
        if (!_mol_model_formats_structure_mmcif__WEBPACK_IMPORTED_MODULE_8__["MmcifFormat"].is(model.sourceData))
            return false;
        var names = (model.sourceData).data.frame.categoryNames;
        return names.includes('ndb_struct_ntc_step') && names.includes('ndb_struct_ntc_step_summary');
    }
    function isApplicable(model) {
        return !!model && hasNdbStructNtcCategories(model);
    }
    ConfalPyramids.isApplicable = isApplicable;
})(ConfalPyramids || (ConfalPyramids = {}));
var ConfalPyramidsParams = {};
var ConfalPyramidsProvider = _mol_model_props_common_custom_model_property__WEBPACK_IMPORTED_MODULE_5__["CustomModelProperty"].createProvider({
    label: 'Confal Pyramids',
    descriptor: Object(_mol_model_custom_property__WEBPACK_IMPORTED_MODULE_4__["CustomPropertyDescriptor"])({
        name: 'confal_pyramids',
    }),
    type: 'static',
    defaultParams: ConfalPyramidsParams,
    getParams: function (data) { return ConfalPyramidsParams; },
    isApplicable: function (data) { return ConfalPyramids.isApplicable(data); },
    obtain: function (ctx, data, props) { return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"])(void 0, void 0, void 0, function () {
        var p;
        return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__generator"])(this, function (_a) {
            p = Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_7__["ParamDefinition"].getDefaultValues(ConfalPyramidsParams)), props);
            return [2 /*return*/, ConfalPyramids.fromCif(ctx, data, p)];
        });
    }); }
});
function createPyramidsFromCif(model, steps, stepsSummary) {
    var pyramids = new Array();
    var names = new Map();
    var locations = new Array();
    var hasMultipleModels = false;
    var id = steps.id, PDB_model_number = steps.PDB_model_number, name = steps.name, auth_asym_id_1 = steps.auth_asym_id_1, auth_seq_id_1 = steps.auth_seq_id_1, label_comp_id_1 = steps.label_comp_id_1, label_alt_id_1 = steps.label_alt_id_1, PDB_ins_code_1 = steps.PDB_ins_code_1, auth_asym_id_2 = steps.auth_asym_id_2, auth_seq_id_2 = steps.auth_seq_id_2, label_comp_id_2 = steps.label_comp_id_2, label_alt_id_2 = steps.label_alt_id_2, PDB_ins_code_2 = steps.PDB_ins_code_2, _rowCount = steps._rowCount;
    if (_rowCount !== stepsSummary._rowCount)
        throw new Error('Inconsistent mmCIF data');
    for (var i = 0; i < _rowCount; i++) {
        var model_num = PDB_model_number.value(i);
        if (model_num !== model.modelNum) {
            hasMultipleModels = true;
            continue; // We are only interested in data for the current model
        }
        var _a = getNtCAndConfalScore(id.value(i), i, stepsSummary), _NtC = _a._NtC, _confal_score = _a._confal_score;
        var pyramid = {
            PDB_model_number: model_num,
            name: name.value(i),
            auth_asym_id_1: auth_asym_id_1.value(i),
            auth_seq_id_1: auth_seq_id_1.value(i),
            label_comp_id_1: label_comp_id_1.value(i),
            label_alt_id_1: label_alt_id_1.value(i),
            PDB_ins_code_1: PDB_ins_code_1.value(i),
            auth_asym_id_2: auth_asym_id_2.value(i),
            auth_seq_id_2: auth_seq_id_2.value(i),
            label_comp_id_2: label_comp_id_2.value(i),
            label_alt_id_2: label_alt_id_2.value(i),
            PDB_ins_code_2: PDB_ins_code_2.value(i),
            confal_score: _confal_score,
            NtC: _NtC
        };
        pyramids.push(pyramid);
        names.set(pyramid.name, pyramids.length - 1);
        locations.push(_types__WEBPACK_IMPORTED_MODULE_1__["ConfalPyramidsTypes"].Location(pyramid, false));
        locations.push(_types__WEBPACK_IMPORTED_MODULE_1__["ConfalPyramidsTypes"].Location(pyramid, true));
    }
    return { pyramids: pyramids, names: names, locations: locations, hasMultipleModels: hasMultipleModels };
}
function getNtCAndConfalScore(id, i, stepsSummary) {
    var step_id = stepsSummary.step_id, confal_score = stepsSummary.confal_score, assigned_NtC = stepsSummary.assigned_NtC;
    // Assume that step_ids in ntc_step_summary are in the same order as steps in ntc_step
    for (var j = i; j < stepsSummary._rowCount; j++) {
        if (id === step_id.value(j))
            return { _NtC: assigned_NtC.value(j), _confal_score: confal_score.value(j) };
    }
    // Safety net for cases where the previous assumption is not met
    for (var j = 0; j < i; j++) {
        if (id === step_id.value(j))
            return { _NtC: assigned_NtC.value(j), _confal_score: confal_score.value(j) };
    }
    throw new Error('Inconsistent mmCIF data');
}
//# sourceMappingURL=property.js.map

/***/ }),

/***/ "./lib/extensions/dnatco/confal-pyramids/representation.js":
/*!*****************************************************************!*\
  !*** ./lib/extensions/dnatco/confal-pyramids/representation.js ***!
  \*****************************************************************/
/*! exports provided: ConfalPyramidsParams, getConfalPyramidsParams, ConfalPyramidsRepresentation, ConfalPyramidsRepresentationProvider */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ConfalPyramidsParams", function() { return ConfalPyramidsParams; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getConfalPyramidsParams", function() { return getConfalPyramidsParams; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ConfalPyramidsRepresentation", function() { return ConfalPyramidsRepresentation; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ConfalPyramidsRepresentationProvider", function() { return ConfalPyramidsRepresentationProvider; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _property__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./property */ "./lib/extensions/dnatco/confal-pyramids/property.js");
/* harmony import */ var _util__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./util */ "./lib/extensions/dnatco/confal-pyramids/util.js");
/* harmony import */ var _types__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./types */ "./lib/extensions/dnatco/confal-pyramids/types.js");
/* harmony import */ var _mol_geo_geometry_mesh_mesh__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../../mol-geo/geometry/mesh/mesh */ "./lib/mol-geo/geometry/mesh/mesh.js");
/* harmony import */ var _mol_geo_geometry_mesh_mesh_builder__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../../mol-geo/geometry/mesh/mesh-builder */ "./lib/mol-geo/geometry/mesh/mesh-builder.js");
/* harmony import */ var _mol_geo_primitive_primitive__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../../../mol-geo/primitive/primitive */ "./lib/mol-geo/primitive/primitive.js");
/* harmony import */ var _mol_geo_util_location_iterator__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../../../mol-geo/util/location-iterator */ "./lib/mol-geo/util/location-iterator.js");
/* harmony import */ var _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ../../../mol-math/linear-algebra */ "./lib/mol-math/linear-algebra.js");
/* harmony import */ var _mol_model_loci__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ../../../mol-model/loci */ "./lib/mol-model/loci.js");
/* harmony import */ var _mol_model_structure__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ../../../mol-model/structure */ "./lib/mol-model/structure.js");
/* harmony import */ var _mol_repr_representation__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ../../../mol-repr/representation */ "./lib/mol-repr/representation.js");
/* harmony import */ var _mol_repr_structure_representation__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! ../../../mol-repr/structure/representation */ "./lib/mol-repr/structure/representation.js");
/* harmony import */ var _mol_repr_structure_units_visual__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! ../../../mol-repr/structure/units-visual */ "./lib/mol-repr/structure/units-visual.js");
/* harmony import */ var _mol_repr_structure_visual_util_common__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! ../../../mol-repr/structure/visual/util/common */ "./lib/mol-repr/structure/visual/util/common.js");
/* harmony import */ var _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! ../../../mol-util/param-definition */ "./lib/mol-util/param-definition.js");
/* harmony import */ var _mol_model_location__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(/*! ../../../mol-model/location */ "./lib/mol-model/location.js");
/**
 * Copyright (c) 2018-2020 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author Michal Malý <michal.maly@ibt.cas.cz>
 * @author Jiří Černý <jiri.cerny@ibt.cas.cz>
 */

















var t = _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_8__["Mat4"].identity();
var w = _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_8__["Vec3"].zero();
var mp = _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_8__["Vec3"].zero();
function calcMidpoint(mp, v, w) {
    _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_8__["Vec3"].sub(mp, v, w);
    _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_8__["Vec3"].scale(mp, mp, 0.5);
    _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_8__["Vec3"].add(mp, mp, w);
}
function shiftVertex(vec, ref, scale) {
    _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_8__["Vec3"].sub(w, vec, ref);
    _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_8__["Vec3"].scale(w, w, scale);
    _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_8__["Vec3"].add(vec, vec, w);
}
var ConfalPyramidsMeshParams = Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, _mol_repr_structure_units_visual__WEBPACK_IMPORTED_MODULE_13__["UnitsMeshParams"]);
function createConfalPyramidsIterator(structureGroup) {
    var structure = structureGroup.structure, group = structureGroup.group;
    var instanceCount = group.units.length;
    var prop = _property__WEBPACK_IMPORTED_MODULE_1__["ConfalPyramidsProvider"].get(structure.model).value;
    if (prop === undefined || prop.data === undefined) {
        return Object(_mol_geo_util_location_iterator__WEBPACK_IMPORTED_MODULE_7__["LocationIterator"])(0, 1, 1, function () { return _mol_model_location__WEBPACK_IMPORTED_MODULE_16__["NullLocation"]; });
    }
    var locations = prop.data.locations;
    var getLocation = function (groupIndex, instanceIndex) {
        if (locations.length <= groupIndex)
            return _mol_model_location__WEBPACK_IMPORTED_MODULE_16__["NullLocation"];
        return locations[groupIndex];
    };
    return Object(_mol_geo_util_location_iterator__WEBPACK_IMPORTED_MODULE_7__["LocationIterator"])(locations.length, instanceCount, 1, getLocation);
}
function createConfalPyramidsMesh(ctx, unit, structure, theme, props, mesh) {
    if (!_mol_model_structure__WEBPACK_IMPORTED_MODULE_10__["Unit"].isAtomic(unit))
        return _mol_geo_geometry_mesh_mesh__WEBPACK_IMPORTED_MODULE_4__["Mesh"].createEmpty(mesh);
    var prop = _property__WEBPACK_IMPORTED_MODULE_1__["ConfalPyramidsProvider"].get(structure.model).value;
    if (prop === undefined || prop.data === undefined)
        return _mol_geo_geometry_mesh_mesh__WEBPACK_IMPORTED_MODULE_4__["Mesh"].createEmpty(mesh);
    var pyramids = prop.data.pyramids;
    if (pyramids.length === 0)
        return _mol_geo_geometry_mesh_mesh__WEBPACK_IMPORTED_MODULE_4__["Mesh"].createEmpty(mesh);
    var mb = _mol_geo_geometry_mesh_mesh_builder__WEBPACK_IMPORTED_MODULE_5__["MeshBuilder"].createState(512, 512, mesh);
    var handler = function (pyramid, first, second, firsLocIndex, secondLocIndex) {
        if (firsLocIndex === -1 || secondLocIndex === -1)
            throw new Error('Invalid location index');
        var scale = (pyramid.confal_score - 20.0) / 100.0;
        var O3 = first.O3.pos;
        var OP1 = second.OP1.pos;
        var OP2 = second.OP2.pos;
        var O5 = second.O5.pos;
        var P = second.P.pos;
        shiftVertex(O3, P, scale);
        shiftVertex(OP1, P, scale);
        shiftVertex(OP2, P, scale);
        shiftVertex(O5, P, scale);
        calcMidpoint(mp, O3, O5);
        mb.currentGroup = firsLocIndex;
        var pb = Object(_mol_geo_primitive_primitive__WEBPACK_IMPORTED_MODULE_6__["PrimitiveBuilder"])(3);
        /* Upper part (for first residue in step) */
        pb.add(O3, OP1, OP2);
        pb.add(O3, mp, OP1);
        pb.add(O3, OP2, mp);
        _mol_geo_geometry_mesh_mesh_builder__WEBPACK_IMPORTED_MODULE_5__["MeshBuilder"].addPrimitive(mb, t, pb.getPrimitive());
        /* Lower part (for second residue in step */
        mb.currentGroup = secondLocIndex;
        pb = Object(_mol_geo_primitive_primitive__WEBPACK_IMPORTED_MODULE_6__["PrimitiveBuilder"])(3);
        pb.add(mp, O5, OP1);
        pb.add(mp, OP2, O5);
        pb.add(O5, OP2, OP1);
        _mol_geo_geometry_mesh_mesh_builder__WEBPACK_IMPORTED_MODULE_5__["MeshBuilder"].addPrimitive(mb, t, pb.getPrimitive());
    };
    var walker = new _util__WEBPACK_IMPORTED_MODULE_2__["ConfalPyramidsUtil"].UnitWalker(structure, unit, handler);
    walker.walk();
    return _mol_geo_geometry_mesh_mesh_builder__WEBPACK_IMPORTED_MODULE_5__["MeshBuilder"].getMesh(mb);
}
function getConfalPyramidLoci(pickingId, structureGroup, id) {
    var groupId = pickingId.groupId, objectId = pickingId.objectId, instanceId = pickingId.instanceId;
    if (objectId !== id)
        return _mol_model_loci__WEBPACK_IMPORTED_MODULE_9__["EmptyLoci"];
    var structure = structureGroup.structure;
    var unit = structureGroup.group.units[instanceId];
    if (!_mol_model_structure__WEBPACK_IMPORTED_MODULE_10__["Unit"].isAtomic(unit))
        return _mol_model_loci__WEBPACK_IMPORTED_MODULE_9__["EmptyLoci"];
    var prop = _property__WEBPACK_IMPORTED_MODULE_1__["ConfalPyramidsProvider"].get(structure.model).value;
    if (prop === undefined || prop.data === undefined)
        return _mol_model_loci__WEBPACK_IMPORTED_MODULE_9__["EmptyLoci"];
    var locations = prop.data.locations;
    if (locations.length <= groupId)
        return _mol_model_loci__WEBPACK_IMPORTED_MODULE_9__["EmptyLoci"];
    var altId = _mol_model_structure__WEBPACK_IMPORTED_MODULE_10__["StructureProperties"].atom.label_alt_id(_types__WEBPACK_IMPORTED_MODULE_3__["ConfalPyramidsTypes"].toElementLocation(locations[groupId]));
    var rI = unit.residueIndex[locations[groupId].element.element];
    return Object(_mol_repr_structure_visual_util_common__WEBPACK_IMPORTED_MODULE_14__["getAltResidueLociFromId"])(structure, unit, rI, altId);
}
function eachConfalPyramid(loci, structureGroup, apply) {
    return false; // TODO: Implement me
}
function ConfalPyramidsVisual(materialId) {
    return Object(_mol_repr_structure_units_visual__WEBPACK_IMPORTED_MODULE_13__["UnitsMeshVisual"])({
        defaultProps: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_15__["ParamDefinition"].getDefaultValues(ConfalPyramidsMeshParams),
        createGeometry: createConfalPyramidsMesh,
        createLocationIterator: createConfalPyramidsIterator,
        getLoci: getConfalPyramidLoci,
        eachLocation: eachConfalPyramid,
        setUpdateState: function (state, newProps, currentProps) {
        }
    }, materialId);
}
var ConfalPyramidsVisuals = {
    'confal-pyramids-symbol': function (ctx, getParams) { return Object(_mol_repr_structure_representation__WEBPACK_IMPORTED_MODULE_12__["UnitsRepresentation"])('Confal Pyramids Symbol Mesh', ctx, getParams, ConfalPyramidsVisual); },
};
var ConfalPyramidsParams = Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, _mol_repr_structure_units_visual__WEBPACK_IMPORTED_MODULE_13__["UnitsMeshParams"]);
function getConfalPyramidsParams(ctx, structure) {
    return _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_15__["ParamDefinition"].clone(ConfalPyramidsParams);
}
function ConfalPyramidsRepresentation(ctx, getParams) {
    var repr = _mol_repr_representation__WEBPACK_IMPORTED_MODULE_11__["Representation"].createMulti('Confal Pyramids', ctx, getParams, _mol_repr_structure_representation__WEBPACK_IMPORTED_MODULE_12__["StructureRepresentationStateBuilder"], ConfalPyramidsVisuals);
    return repr;
}
var ConfalPyramidsRepresentationProvider = Object(_mol_repr_structure_representation__WEBPACK_IMPORTED_MODULE_12__["StructureRepresentationProvider"])({
    name: 'confal-pyramids',
    label: 'Confal Pyramids',
    description: 'Displays schematic depiction of conformer classes and confal values',
    factory: ConfalPyramidsRepresentation,
    getParams: getConfalPyramidsParams,
    defaultValues: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_15__["ParamDefinition"].getDefaultValues(ConfalPyramidsParams),
    defaultColorTheme: { name: 'confal-pyramids' },
    defaultSizeTheme: { name: 'uniform' },
    isApplicable: function (structure) { return structure.models.some(function (m) { return _property__WEBPACK_IMPORTED_MODULE_1__["ConfalPyramids"].isApplicable(m); }); },
    ensureCustomProperties: {
        attach: function (ctx, structure) { return _property__WEBPACK_IMPORTED_MODULE_1__["ConfalPyramidsProvider"].attach(ctx, structure.model, void 0, true); },
        detach: function (data) { return _property__WEBPACK_IMPORTED_MODULE_1__["ConfalPyramidsProvider"].ref(data.model, false); },
    }
});
//# sourceMappingURL=representation.js.map

/***/ }),

/***/ "./lib/extensions/dnatco/confal-pyramids/types.js":
/*!********************************************************!*\
  !*** ./lib/extensions/dnatco/confal-pyramids/types.js ***!
  \********************************************************/
/*! exports provided: ConfalPyramidsTypes */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ConfalPyramidsTypes", function() { return ConfalPyramidsTypes; });
/* harmony import */ var _mol_model_location__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../../mol-model/location */ "./lib/mol-model/location.js");
/* harmony import */ var _mol_model_structure__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../../mol-model/structure */ "./lib/mol-model/structure.js");
/**
 * Copyright (c) 2018-2020 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author Michal Malý <michal.maly@ibt.cas.cz>
 * @author Jiří Černý <jiri.cerny@ibt.cas.cz>
 */


var ConfalPyramidsTypes;
(function (ConfalPyramidsTypes) {
    function Location(pyramid, isLower, structure, unit, element) {
        return Object(_mol_model_location__WEBPACK_IMPORTED_MODULE_0__["DataLocation"])('pyramid', { pyramid: pyramid, isLower: isLower }, { structure: structure, unit: unit, element: element });
    }
    ConfalPyramidsTypes.Location = Location;
    function isLocation(x) {
        return !!x && x.kind === 'data-location' && x.tag === 'pyramid';
    }
    ConfalPyramidsTypes.isLocation = isLocation;
    function toElementLocation(location) {
        return _mol_model_structure__WEBPACK_IMPORTED_MODULE_1__["StructureElement"].Location.create(location.element.structure, location.element.unit, location.element.element);
    }
    ConfalPyramidsTypes.toElementLocation = toElementLocation;
})(ConfalPyramidsTypes || (ConfalPyramidsTypes = {}));
//# sourceMappingURL=types.js.map

/***/ }),

/***/ "./lib/extensions/dnatco/confal-pyramids/util.js":
/*!*******************************************************!*\
  !*** ./lib/extensions/dnatco/confal-pyramids/util.js ***!
  \*******************************************************/
/*! exports provided: ConfalPyramidsUtil */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ConfalPyramidsUtil", function() { return ConfalPyramidsUtil; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _property__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./property */ "./lib/extensions/dnatco/confal-pyramids/property.js");
/* harmony import */ var _mol_data_int__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../../mol-data/int */ "./lib/mol-data/int.js");
/* harmony import */ var _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../../mol-math/linear-algebra */ "./lib/mol-math/linear-algebra.js");
/* harmony import */ var _mol_model_structure__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../../mol-model/structure */ "./lib/mol-model/structure.js");
/**
 * Copyright (c) 2018-2020 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author Michal Malý <michal.maly@ibt.cas.cz>
 * @author Jiří Černý <jiri.cerny@ibt.cas.cz>
 */





var ConfalPyramidsUtil;
(function (ConfalPyramidsUtil) {
    function residueInfoFromLocation(loc) {
        return {
            PDB_model_num: _mol_model_structure__WEBPACK_IMPORTED_MODULE_4__["StructureProperties"].unit.model_num(loc),
            asym_id: _mol_model_structure__WEBPACK_IMPORTED_MODULE_4__["StructureProperties"].chain.label_asym_id(loc),
            auth_asym_id: _mol_model_structure__WEBPACK_IMPORTED_MODULE_4__["StructureProperties"].chain.auth_asym_id(loc),
            seq_id: _mol_model_structure__WEBPACK_IMPORTED_MODULE_4__["StructureProperties"].residue.label_seq_id(loc),
            auth_seq_id: _mol_model_structure__WEBPACK_IMPORTED_MODULE_4__["StructureProperties"].residue.auth_seq_id(loc),
            comp_id: _mol_model_structure__WEBPACK_IMPORTED_MODULE_4__["StructureProperties"].atom.label_comp_id(loc),
            alt_id: _mol_model_structure__WEBPACK_IMPORTED_MODULE_4__["StructureProperties"].atom.label_alt_id(loc),
            ins_code: _mol_model_structure__WEBPACK_IMPORTED_MODULE_4__["StructureProperties"].residue.pdbx_PDB_ins_code(loc)
        };
    }
    function hasMultipleModels(unit) {
        var prop = _property__WEBPACK_IMPORTED_MODULE_1__["ConfalPyramidsProvider"].get(unit.model).value;
        if (prop === undefined || prop.data === undefined)
            throw new Error('No custom properties data');
        return prop.data.hasMultipleModels;
    }
    ConfalPyramidsUtil.hasMultipleModels = hasMultipleModels;
    function getPossibleAltIdsIndices(eIFirst, eILast, structure, unit) {
        var loc = _mol_model_structure__WEBPACK_IMPORTED_MODULE_4__["StructureElement"].Location.create(structure, unit, -1);
        var uIFirst = _mol_data_int__WEBPACK_IMPORTED_MODULE_2__["OrderedSet"].indexOf(unit.elements, eIFirst);
        var uILast = _mol_data_int__WEBPACK_IMPORTED_MODULE_2__["OrderedSet"].indexOf(unit.elements, eILast);
        var possibleAltIds = [];
        for (var uI = uIFirst; uI <= uILast; uI++) {
            loc.element = unit.elements[uI];
            var altId = _mol_model_structure__WEBPACK_IMPORTED_MODULE_4__["StructureProperties"].atom.label_alt_id(loc);
            if (altId !== '' && !possibleAltIds.includes(altId))
                possibleAltIds.push(altId);
        }
        return possibleAltIds;
    }
    function getPossibleAltIdsResidue(residue, structure, unit) {
        return getPossibleAltIdsIndices(unit.elements[residue.start], unit.elements[residue.end - 1], structure, unit);
    }
    var Utility = /** @class */ (function () {
        function Utility(unit) {
            var prop = _property__WEBPACK_IMPORTED_MODULE_1__["ConfalPyramidsProvider"].get(unit.model).value;
            if (prop === undefined || prop.data === undefined)
                throw new Error('No custom properties data');
            this.data = prop.data;
            this.hasMultipleModels = hasMultipleModels(unit);
            this.entryId = unit.model.entryId.toLowerCase();
            this.modelNum = unit.model.modelNum;
        }
        Utility.prototype.getPyramidByName = function (name) {
            var index = this.data.names.get(name);
            if (index === undefined)
                return { pyramid: undefined, index: -1 };
            return { pyramid: this.data.pyramids[index], index: index };
        };
        Utility.prototype.stepToName = function (entry_id, modelNum, locFirst, locSecond, fakeAltId_1, fakeAltId_2) {
            var first = residueInfoFromLocation(locFirst);
            var second = residueInfoFromLocation(locSecond);
            var model_id = this.hasMultipleModels ? "-m" + modelNum : '';
            var alt_id_1 = fakeAltId_1 !== '' ? "." + fakeAltId_1 : (first.alt_id.length ? "." + first.alt_id : '');
            var alt_id_2 = fakeAltId_2 !== '' ? "." + fakeAltId_2 : (second.alt_id.length ? "." + second.alt_id : '');
            var ins_code_1 = first.ins_code.length ? "." + first.ins_code : '';
            var ins_code_2 = second.ins_code.length ? "." + second.ins_code : '';
            return "" + entry_id + model_id + "_" + first.auth_asym_id + "_" + first.comp_id + alt_id_1 + "_" + first.auth_seq_id + ins_code_1 + "_" + second.comp_id + alt_id_2 + "_" + second.auth_seq_id + ins_code_2;
        };
        return Utility;
    }());
    var UnitWalker = /** @class */ (function (_super) {
        Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__extends"])(UnitWalker, _super);
        function UnitWalker(structure, unit, handler) {
            var _this = _super.call(this, unit) || this;
            _this.structure = structure;
            _this.unit = unit;
            _this.handler = handler;
            _this.chainIt = _mol_data_int__WEBPACK_IMPORTED_MODULE_2__["Segmentation"].transientSegments(unit.model.atomicHierarchy.chainAtomSegments, unit.elements);
            _this.residueIt = _mol_data_int__WEBPACK_IMPORTED_MODULE_2__["Segmentation"].transientSegments(unit.model.atomicHierarchy.residueAtomSegments, unit.elements);
            return _this;
        }
        UnitWalker.prototype.getAtomIndices = function (names, residue) {
            var rI = residue.start;
            var rILast = residue.end - 1;
            var indices = [];
            for (; rI !== rILast; rI++) {
                var eI = this.unit.elements[rI];
                var loc = _mol_model_structure__WEBPACK_IMPORTED_MODULE_4__["StructureElement"].Location.create(this.structure, this.unit, eI);
                var thisName = _mol_model_structure__WEBPACK_IMPORTED_MODULE_4__["StructureProperties"].atom.label_atom_id(loc);
                if (names.includes(thisName))
                    indices.push(eI);
            }
            if (indices.length === 0)
                throw new Error("Element " + name + " not found on residue " + residue.index);
            return indices;
        };
        UnitWalker.prototype.getAtomPositions = function (indices) {
            var pos = this.unit.conformation.invariantPosition;
            var positions = [];
            for (var _i = 0, indices_1 = indices; _i < indices_1.length; _i++) {
                var eI = indices_1[_i];
                var v = _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_3__["Vec3"].zero();
                pos(eI, v);
                positions.push(v);
            }
            return positions;
        };
        UnitWalker.prototype.handleStep = function (firstAtoms, secondAtoms) {
            var _this = this;
            var modelNum = this.hasMultipleModels ? this.modelNum : -1;
            var ok = false;
            var firstLoc = _mol_model_structure__WEBPACK_IMPORTED_MODULE_4__["StructureElement"].Location.create(this.structure, this.unit, -1);
            var secondLoc = _mol_model_structure__WEBPACK_IMPORTED_MODULE_4__["StructureElement"].Location.create(this.structure, this.unit, -1);
            for (var i = 0; i < firstAtoms.length; i++) {
                var first = firstAtoms[i];
                for (var j = 0; j < secondAtoms.length; j++) {
                    var second = secondAtoms[j];
                    firstLoc.element = first.O3.index;
                    secondLoc.element = second.OP1.index;
                    var name_1 = this.stepToName(this.entryId, modelNum, firstLoc, secondLoc, first.O3.fakeAltId, second.OP1.fakeAltId);
                    var _a = this.getPyramidByName(name_1), pyramid = _a.pyramid, index = _a.index;
                    if (pyramid !== undefined) {
                        var setLoc = function (loc, eI) {
                            loc.element.structure = _this.structure;
                            loc.element.unit = _this.unit;
                            loc.element.element = eI;
                        };
                        var locIndex = index * 2;
                        setLoc(this.data.locations[locIndex], firstLoc.element);
                        setLoc(this.data.locations[locIndex + 1], secondLoc.element);
                        this.handler(pyramid, first, second, locIndex, locIndex + 1);
                        ok = true;
                    }
                }
            }
            if (!ok)
                throw new Error('Bogus step');
        };
        UnitWalker.prototype.processFirstResidue = function (residue, possibleAltIds) {
            var indO3 = this.getAtomIndices(['O3\'', 'O3*'], residue);
            var posO3 = this.getAtomPositions(indO3);
            var altPos = [
                { O3: { pos: posO3[0], index: indO3[0], fakeAltId: '' } }
            ];
            for (var i = 1; i < indO3.length; i++) {
                altPos.push({ O3: { pos: posO3[i], index: indO3[i], fakeAltId: '' } });
            }
            if (altPos.length === 1 && possibleAltIds.length > 1) {
                /* We have some alternate positions on the residue but O3 does not have any - fake them */
                altPos[0].O3.fakeAltId = possibleAltIds[0];
                for (var i = 1; i < possibleAltIds.length; i++)
                    altPos.push({ O3: { pos: posO3[0], index: indO3[0], fakeAltId: possibleAltIds[i] } });
            }
            return altPos;
        };
        UnitWalker.prototype.processSecondResidue = function (residue, possibleAltIds) {
            var indOP1 = this.getAtomIndices(['OP1'], residue);
            var indOP2 = this.getAtomIndices(['OP2'], residue);
            var indO5 = this.getAtomIndices(['O5\'', 'O5*'], residue);
            var indP = this.getAtomIndices(['P'], residue);
            var posOP1 = this.getAtomPositions(indOP1);
            var posOP2 = this.getAtomPositions(indOP2);
            var posO5 = this.getAtomPositions(indO5);
            var posP = this.getAtomPositions(indP);
            var infoOP1 = [];
            /* We use OP1 as "pivotal" atom. There is no specific reason
             * to pick OP1, it is as good a choice as any other atom
             */
            if (indOP1.length === 1 && possibleAltIds.length > 1) {
                /* No altIds on OP1, fake them */
                for (var _i = 0, possibleAltIds_1 = possibleAltIds; _i < possibleAltIds_1.length; _i++) {
                    var altId = possibleAltIds_1[_i];
                    infoOP1.push({ pos: posOP1[0], index: indOP1[0], fakeAltId: altId });
                }
            }
            else {
                for (var i = 0; i < indOP1.length; i++)
                    infoOP1.push({ pos: posOP1[i], index: indOP1[i], fakeAltId: '' });
            }
            var mkInfo = function (i, indices, positions, altId) {
                if (i >= indices.length) {
                    var last = indices.length - 1;
                    return { pos: positions[last], index: indices[last], fakeAltId: altId };
                }
                return { pos: positions[i], index: indices[i], fakeAltId: altId };
            };
            var altPos = [];
            for (var i = 0; i < infoOP1.length; i++) {
                var altId = infoOP1[i].fakeAltId;
                var OP2 = mkInfo(i, indOP2, posOP2, altId);
                var O5 = mkInfo(i, indO5, posO5, altId);
                var P = mkInfo(i, indP, posP, altId);
                altPos.push({ OP1: infoOP1[i], OP2: OP2, O5: O5, P: P });
            }
            return altPos;
        };
        UnitWalker.prototype.step = function (residue) {
            var firstPossibleAltIds = getPossibleAltIdsResidue(residue, this.structure, this.unit);
            var firstAtoms = this.processFirstResidue(residue, firstPossibleAltIds);
            residue = this.residueIt.move();
            var secondPossibleAltIds = getPossibleAltIdsResidue(residue, this.structure, this.unit);
            var secondAtoms = this.processSecondResidue(residue, secondPossibleAltIds);
            return { firstAtoms: firstAtoms, secondAtoms: secondAtoms };
        };
        UnitWalker.prototype.walk = function () {
            while (this.chainIt.hasNext) {
                this.residueIt.setSegment(this.chainIt.move());
                var residue = this.residueIt.move();
                while (this.residueIt.hasNext) {
                    try {
                        var _a = this.step(residue), firstAtoms = _a.firstAtoms, secondAtoms = _a.secondAtoms;
                        this.handleStep(firstAtoms, secondAtoms);
                    }
                    catch (error) {
                        /* Skip and move along */
                        residue = this.residueIt.move();
                    }
                }
            }
        };
        return UnitWalker;
    }(Utility));
    ConfalPyramidsUtil.UnitWalker = UnitWalker;
})(ConfalPyramidsUtil || (ConfalPyramidsUtil = {}));
//# sourceMappingURL=util.js.map

/***/ }),

/***/ "./lib/extensions/dnatco/index.js":
/*!****************************************!*\
  !*** ./lib/extensions/dnatco/index.js ***!
  \****************************************/
/*! exports provided: DnatcoConfalPyramids */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _confal_pyramids_behavior__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./confal-pyramids/behavior */ "./lib/extensions/dnatco/confal-pyramids/behavior.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "DnatcoConfalPyramids", function() { return _confal_pyramids_behavior__WEBPACK_IMPORTED_MODULE_0__["DnatcoConfalPyramids"]; });

/**
 * Copyright (c) 2018-2020 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author Michal Malý <michal.maly@ibt.cas.cz>
 * @author Jiří Černý <jiri.cerny@ibt.cas.cz>
 */

//# sourceMappingURL=index.js.map

/***/ }),

/***/ "./lib/extensions/g3d/data.js":
/*!************************************!*\
  !*** ./lib/extensions/g3d/data.js ***!
  \************************************/
/*! exports provided: getG3dHeader, getG3dDataBlock */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getG3dHeader", function() { return getG3dHeader; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getG3dDataBlock", function() { return getG3dDataBlock; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _mol_io_common_msgpack_decode__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../mol-io/common/msgpack/decode */ "./lib/mol-io/common/msgpack/decode.js");
/* harmony import */ var _mol_task__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../mol-task */ "./lib/mol-task/index.js");
/* harmony import */ var _mol_util_zip_zip__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../mol-util/zip/zip */ "./lib/mol-util/zip/zip.js");
/**
 * Copyright (c) 2020 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author David Sehnal <david.sehnal@gmail.com>
 */




var HEADER_SIZE = 64000;
function getG3dHeader(ctx, urlOrData) {
    return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"])(this, void 0, void 0, function () {
        var data, last, header;
        return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__generator"])(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, getRawData(ctx, urlOrData, { offset: 0, size: HEADER_SIZE })];
                case 1:
                    data = _a.sent();
                    last = data.length - 1;
                    for (; last >= 0; last--) {
                        if (data[last] !== 0)
                            break;
                    }
                    header = Object(_mol_io_common_msgpack_decode__WEBPACK_IMPORTED_MODULE_1__["default"])(data.slice(0, last + 1));
                    return [2 /*return*/, header];
            }
        });
    });
}
function getG3dDataBlock(ctx, header, urlOrData, resolution) {
    return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"])(this, void 0, void 0, function () {
        var data, unzipped;
        return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__generator"])(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!header.offsets[resolution])
                        throw new Error("Resolution " + resolution + " not available.");
                    return [4 /*yield*/, getRawData(ctx, urlOrData, header.offsets[resolution])];
                case 1:
                    data = _a.sent();
                    return [4 /*yield*/, ctx.runTask(_mol_task__WEBPACK_IMPORTED_MODULE_2__["Task"].create('Unzip', function (ctx) { return Object(_mol_util_zip_zip__WEBPACK_IMPORTED_MODULE_3__["inflate"])(ctx, data); }))];
                case 2:
                    unzipped = _a.sent();
                    return [2 /*return*/, {
                            header: header,
                            resolution: resolution,
                            data: Object(_mol_io_common_msgpack_decode__WEBPACK_IMPORTED_MODULE_1__["default"])(unzipped)
                        }];
            }
        });
    });
}
function getRawData(ctx, urlOrData, range) {
    return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"])(this, void 0, void 0, function () {
        return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__generator"])(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!(typeof urlOrData === 'string')) return [3 /*break*/, 2];
                    return [4 /*yield*/, ctx.runTask(ctx.fetch({ url: urlOrData, headers: [['Range', "bytes=" + range.offset + "-" + (range.offset + range.size - 1)]], type: 'binary' }))];
                case 1: return [2 /*return*/, _a.sent()];
                case 2: return [2 /*return*/, urlOrData.slice(range.offset, range.offset + range.size)];
            }
        });
    });
}
//# sourceMappingURL=data.js.map

/***/ }),

/***/ "./lib/extensions/g3d/format.js":
/*!**************************************!*\
  !*** ./lib/extensions/g3d/format.js ***!
  \**************************************/
/*! exports provided: G3dProvider, G3dHeaderObject, G3DHeaderFromFile, G3DHeaderFromUrl, G3DTrajectory, LoadG3D, G3DFormat */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "G3dProvider", function() { return G3dProvider; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "G3dHeaderObject", function() { return G3dHeaderObject; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "G3DHeaderFromFile", function() { return G3DHeaderFromFile; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "G3DHeaderFromUrl", function() { return G3DHeaderFromUrl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "G3DTrajectory", function() { return G3DTrajectory; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "LoadG3D", function() { return LoadG3D; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "G3DFormat", function() { return G3DFormat; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _mol_plugin_state_formats_trajectory__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../mol-plugin-state/formats/trajectory */ "./lib/mol-plugin-state/formats/trajectory.js");
/* harmony import */ var _mol_plugin_state_objects__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../mol-plugin-state/objects */ "./lib/mol-plugin-state/objects.js");
/* harmony import */ var _mol_plugin_behavior__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../mol-plugin/behavior */ "./lib/mol-plugin/behavior.js");
/* harmony import */ var _mol_script_runtime_query_base__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../mol-script/runtime/query/base */ "./lib/mol-script/runtime/query/base.js");
/* harmony import */ var _mol_state__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../mol-state */ "./lib/mol-state/index.js");
/* harmony import */ var _mol_task__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../../mol-task */ "./lib/mol-task/index.js");
/* harmony import */ var _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../../mol-util/param-definition */ "./lib/mol-util/param-definition.js");
/* harmony import */ var _data__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ./data */ "./lib/extensions/g3d/data.js");
/* harmony import */ var _model__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ./model */ "./lib/extensions/g3d/model.js");
/* harmony import */ var _mol_plugin_state_transforms__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ../../mol-plugin-state/transforms */ "./lib/mol-plugin-state/transforms.js");
/* harmony import */ var _mol_plugin_state_helpers_structure_representation_params__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ../../mol-plugin-state/helpers/structure-representation-params */ "./lib/mol-plugin-state/helpers/structure-representation-params.js");
/* harmony import */ var _mol_util_string__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! ../../mol-util/string */ "./lib/mol-util/string.js");
/* harmony import */ var _mol_util_object__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! ../../mol-util/object */ "./lib/mol-util/object.js");
/**
 * Copyright (c) 2020 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author David Sehnal <david.sehnal@gmail.com>
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */














var G3dProvider = {
    label: 'G3D',
    description: 'G3D',
    category: _mol_plugin_state_formats_trajectory__WEBPACK_IMPORTED_MODULE_1__["TrajectoryFormatCategory"],
    binaryExtensions: ['g3d'],
    parse: function (plugin, data) { return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"])(void 0, void 0, void 0, function () {
        var trajectory;
        return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__generator"])(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, plugin.state.data.build()
                        .to(data)
                        .apply(G3DHeaderFromFile, {}, { state: { isGhost: true } })
                        .apply(G3DTrajectory)
                        .commit()];
                case 1:
                    trajectory = _a.sent();
                    return [2 /*return*/, { trajectory: trajectory }];
            }
        });
    }); },
    visuals: defaultStructure
};
function defaultStructure(plugin, data) {
    return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"])(this, void 0, void 0, function () {
        var builder, model, structure, info, components, repr, _i, _a, h;
        return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__generator"])(this, function (_b) {
            switch (_b.label) {
                case 0:
                    builder = plugin.builders.structure;
                    return [4 /*yield*/, builder.createModel(data.trajectory)];
                case 1:
                    model = _b.sent();
                    if (!model)
                        return [2 /*return*/];
                    return [4 /*yield*/, builder.createStructure(model)];
                case 2:
                    structure = _b.sent();
                    info = _model__WEBPACK_IMPORTED_MODULE_9__["G3dInfoDataProperty"].get(model.data);
                    if (!info)
                        return [2 /*return*/];
                    components = plugin.build().to(structure);
                    repr = Object(_mol_plugin_state_helpers_structure_representation_params__WEBPACK_IMPORTED_MODULE_11__["createStructureRepresentationParams"])(plugin, void 0, {
                        type: 'cartoon',
                        color: 'polymer-index',
                        size: 'uniform',
                        sizeParams: { value: 0.25 }
                    });
                    for (_i = 0, _a = info.haplotypes; _i < _a.length; _i++) {
                        h = _a[_i];
                        components
                            .apply(_mol_plugin_state_transforms__WEBPACK_IMPORTED_MODULE_10__["StateTransforms"].Model.StructureSelectionFromExpression, { expression: Object(_model__WEBPACK_IMPORTED_MODULE_9__["g3dHaplotypeQuery"])(h), label: Object(_mol_util_string__WEBPACK_IMPORTED_MODULE_12__["stringToWords"])(h) })
                            .apply(_mol_plugin_state_transforms__WEBPACK_IMPORTED_MODULE_10__["StateTransforms"].Representation.StructureRepresentation3D, repr);
                    }
                    return [4 /*yield*/, components.commit()];
                case 3:
                    _b.sent();
                    return [2 /*return*/];
            }
        });
    });
}
var G3dHeaderObject = /** @class */ (function (_super) {
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__extends"])(G3dHeaderObject, _super);
    function G3dHeaderObject() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return G3dHeaderObject;
}(_mol_plugin_state_objects__WEBPACK_IMPORTED_MODULE_2__["PluginStateObject"].Create({ name: 'G3D Header', typeClass: 'Data' })));

var G3DHeaderFromFile = _mol_plugin_state_objects__WEBPACK_IMPORTED_MODULE_2__["PluginStateTransform"].BuiltIn({
    name: 'g3d-header-from-file',
    display: { name: 'G3D Header', description: 'Parse G3D Header' },
    from: _mol_plugin_state_objects__WEBPACK_IMPORTED_MODULE_2__["PluginStateObject"].Data.Binary,
    to: G3dHeaderObject
})({
    apply: function (_a, plugin) {
        var _this = this;
        var a = _a.a;
        return _mol_task__WEBPACK_IMPORTED_MODULE_6__["Task"].create('Parse G3D', function () { return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"])(_this, void 0, void 0, function () {
            var header;
            return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__generator"])(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, Object(_data__WEBPACK_IMPORTED_MODULE_8__["getG3dHeader"])(plugin, a.data)];
                    case 1:
                        header = _a.sent();
                        return [2 /*return*/, new G3dHeaderObject({ header: header, urlOrData: a.data, cache: {} }, { label: header.name, description: header.genome })];
                }
            });
        }); });
    }
});
var G3DHeaderFromUrl = _mol_plugin_state_objects__WEBPACK_IMPORTED_MODULE_2__["PluginStateTransform"].BuiltIn({
    name: 'g3d-header-from-url',
    display: { name: 'G3D Header', description: 'Parse G3D Header' },
    params: { url: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_7__["ParamDefinition"].Text('') },
    from: _mol_plugin_state_objects__WEBPACK_IMPORTED_MODULE_2__["PluginStateObject"].Root,
    to: G3dHeaderObject
})({
    apply: function (_a, plugin) {
        var _this = this;
        var params = _a.params;
        return _mol_task__WEBPACK_IMPORTED_MODULE_6__["Task"].create('Parse G3D', function () { return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"])(_this, void 0, void 0, function () {
            var header;
            return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__generator"])(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, Object(_data__WEBPACK_IMPORTED_MODULE_8__["getG3dHeader"])(plugin, params.url)];
                    case 1:
                        header = _a.sent();
                        return [2 /*return*/, new G3dHeaderObject({ header: header, urlOrData: params.url, cache: {} }, { label: header.name, description: header.genome })];
                }
            });
        }); });
    }
});
var G3DTrajectory = _mol_plugin_state_objects__WEBPACK_IMPORTED_MODULE_2__["PluginStateTransform"].BuiltIn({
    name: 'g3d-trajecotry',
    display: { name: 'G3D Trajectory', description: 'Create G3D Trajectory' },
    params: function (a) {
        if (!a)
            return { resolution: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_7__["ParamDefinition"].Numeric(200000) };
        var rs = a.data.header.resolutions;
        return {
            resolution: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_7__["ParamDefinition"].Select(rs[rs.length - 1], rs.map(function (r) { return [r, '' + r]; }))
        };
    },
    from: G3dHeaderObject,
    to: _mol_plugin_state_objects__WEBPACK_IMPORTED_MODULE_2__["PluginStateObject"].Molecule.Trajectory
})({
    apply: function (_a, plugin) {
        var _this = this;
        var a = _a.a, params = _a.params;
        return _mol_task__WEBPACK_IMPORTED_MODULE_6__["Task"].create('G3D Trajectory', function (ctx) { return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"])(_this, void 0, void 0, function () {
            var data, traj;
            return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__generator"])(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (a.data.cache[params.resolution]) {
                            return [2 /*return*/, new _mol_plugin_state_objects__WEBPACK_IMPORTED_MODULE_2__["PluginStateObject"].Molecule.Trajectory(a.data.cache[params.resolution], { label: a.label, description: a.description })];
                        }
                        return [4 /*yield*/, Object(_data__WEBPACK_IMPORTED_MODULE_8__["getG3dDataBlock"])(plugin, a.data.header, a.data.urlOrData, params.resolution)];
                    case 1:
                        data = _a.sent();
                        return [4 /*yield*/, Object(_model__WEBPACK_IMPORTED_MODULE_9__["trajectoryFromG3D"])(data).runInContext(ctx)];
                    case 2:
                        traj = _a.sent();
                        a.data.cache[params.resolution] = traj;
                        return [2 /*return*/, new _mol_plugin_state_objects__WEBPACK_IMPORTED_MODULE_2__["PluginStateObject"].Molecule.Trajectory(traj, { label: a.label, description: a.description })];
                }
            });
        }); });
    }
});
var LoadG3D = _mol_state__WEBPACK_IMPORTED_MODULE_5__["StateAction"].build({
    display: { name: 'Load Genome 3D (G3D)', description: 'Load G3D file from the specified URL.' },
    from: _mol_plugin_state_objects__WEBPACK_IMPORTED_MODULE_2__["PluginStateObject"].Root,
    params: { url: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_7__["ParamDefinition"].Text('') }
})(function (_a, ctx) {
    var params = _a.params, state = _a.state;
    return _mol_task__WEBPACK_IMPORTED_MODULE_6__["Task"].create('Genome3D', function (taskCtx) {
        return state.transaction(function () { return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"])(void 0, void 0, void 0, function () {
            var trajectory;
            return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__generator"])(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (params.url.trim().length === 0) {
                            throw new Error('Specify URL');
                        }
                        ctx.behaviors.layout.leftPanelTabName.next('data');
                        return [4 /*yield*/, state.build().toRoot()
                                .apply(G3DHeaderFromUrl, { url: params.url })
                                .apply(G3DTrajectory)
                                .commit()];
                    case 1:
                        trajectory = _a.sent();
                        return [4 /*yield*/, defaultStructure(ctx, { trajectory: trajectory })];
                    case 2:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        }); }).runInContext(taskCtx);
    });
});
var G3DFormat = _mol_plugin_behavior__WEBPACK_IMPORTED_MODULE_3__["PluginBehavior"].create({
    name: 'g3d',
    category: 'misc',
    display: {
        name: 'G3D',
        description: 'G3D Format Support'
    },
    ctor: /** @class */ (function (_super) {
        Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__extends"])(class_1, _super);
        function class_1() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        class_1.prototype.register = function () {
            this.ctx.state.data.actions.add(LoadG3D);
            Object(_mol_util_object__WEBPACK_IMPORTED_MODULE_13__["objectForEach"])(_model__WEBPACK_IMPORTED_MODULE_9__["G3dSymbols"], function (s) { return _mol_script_runtime_query_base__WEBPACK_IMPORTED_MODULE_4__["DefaultQueryRuntimeTable"].addSymbol(s); });
            this.ctx.managers.lociLabels.addProvider(_model__WEBPACK_IMPORTED_MODULE_9__["G3dLabelProvider"]);
        };
        class_1.prototype.unregister = function () {
            this.ctx.state.data.actions.remove(LoadG3D);
            Object(_mol_util_object__WEBPACK_IMPORTED_MODULE_13__["objectForEach"])(_model__WEBPACK_IMPORTED_MODULE_9__["G3dSymbols"], function (s) { return _mol_script_runtime_query_base__WEBPACK_IMPORTED_MODULE_4__["DefaultQueryRuntimeTable"].removeSymbol(s); });
            this.ctx.managers.lociLabels.removeProvider(_model__WEBPACK_IMPORTED_MODULE_9__["G3dLabelProvider"]);
        };
        return class_1;
    }(_mol_plugin_behavior__WEBPACK_IMPORTED_MODULE_3__["PluginBehavior"].Handler))
});
//# sourceMappingURL=format.js.map

/***/ }),

/***/ "./lib/extensions/g3d/model.js":
/*!*************************************!*\
  !*** ./lib/extensions/g3d/model.js ***!
  \*************************************/
/*! exports provided: trajectoryFromG3D, G3dSymbols, G3dInfoDataProperty, g3dHaplotypeQuery, g3dChromosomeQuery, g3dRegionQuery, G3dLabelProvider */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "trajectoryFromG3D", function() { return trajectoryFromG3D; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "G3dSymbols", function() { return G3dSymbols; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "G3dInfoDataProperty", function() { return G3dInfoDataProperty; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g3dHaplotypeQuery", function() { return g3dHaplotypeQuery; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g3dChromosomeQuery", function() { return g3dChromosomeQuery; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g3dRegionQuery", function() { return g3dRegionQuery; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "G3dLabelProvider", function() { return G3dLabelProvider; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _mol_data_db__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../mol-data/db */ "./lib/mol-data/db.js");
/* harmony import */ var _mol_data_int__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../mol-data/int */ "./lib/mol-data/int.js");
/* harmony import */ var _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../mol-math/linear-algebra */ "./lib/mol-math/linear-algebra.js");
/* harmony import */ var _mol_model_formats_structure_basic_parser__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../mol-model-formats/structure/basic/parser */ "./lib/mol-model-formats/structure/basic/parser.js");
/* harmony import */ var _mol_model_formats_structure_basic_schema__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../mol-model-formats/structure/basic/schema */ "./lib/mol-model-formats/structure/basic/schema.js");
/* harmony import */ var _mol_model_formats_structure_common_entity__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../../mol-model-formats/structure/common/entity */ "./lib/mol-model-formats/structure/common/entity.js");
/* harmony import */ var _mol_model_loci__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../../mol-model/loci */ "./lib/mol-model/loci.js");
/* harmony import */ var _mol_model_structure__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ../../mol-model/structure */ "./lib/mol-model/structure.js");
/* harmony import */ var _mol_script_language_builder__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ../../mol-script/language/builder */ "./lib/mol-script/language/builder.js");
/* harmony import */ var _mol_script_language_symbol__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ../../mol-script/language/symbol */ "./lib/mol-script/language/symbol.js");
/* harmony import */ var _mol_script_language_type__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ../../mol-script/language/type */ "./lib/mol-script/language/type.js");
/* harmony import */ var _mol_script_runtime_query_base__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! ../../mol-script/runtime/query/base */ "./lib/mol-script/runtime/query/base.js");
/* harmony import */ var _mol_task__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! ../../mol-task */ "./lib/mol-task/index.js");
/* harmony import */ var _mol_util_object__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! ../../mol-util/object */ "./lib/mol-util/object.js");
/* harmony import */ var _mol_model_formats_structure_common_property__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! ../../mol-model-formats/structure/common/property */ "./lib/mol-model-formats/structure/common/property.js");
/**
 * Copyright (c) 2020 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author David Sehnal <david.sehnal@gmail.com>
 */
















function getColumns(block) {
    var data = block.data;
    var size = 0;
    Object(_mol_util_object__WEBPACK_IMPORTED_MODULE_14__["objectForEach"])(data, function (h) { return Object(_mol_util_object__WEBPACK_IMPORTED_MODULE_14__["objectForEach"])(h, function (g) { return size += g.start.length; }); });
    var normalized = {
        entity_id: new Array(size),
        chromosome: new Array(size),
        seq_id_begin: new Int32Array(size),
        seq_id_end: new Int32Array(size),
        start: new Int32Array(size),
        x: new Float32Array(size),
        y: new Float32Array(size),
        z: new Float32Array(size),
        r: new Float32Array(size),
        haplotype: new Array(size)
    };
    var p = [Object(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_3__["Vec3"])(), Object(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_3__["Vec3"])(), Object(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_3__["Vec3"])()];
    var o = 0;
    Object(_mol_util_object__WEBPACK_IMPORTED_MODULE_14__["objectForEach"])(data, function (hs, h) {
        Object(_mol_util_object__WEBPACK_IMPORTED_MODULE_14__["objectForEach"])(hs, function (chs, ch) {
            var entity_id = ch + "-" + h;
            var l = chs.start.length;
            if (l === 0)
                return;
            var x = chs.x[0];
            var y = chs.y[0];
            var z = chs.z[0];
            _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_3__["Vec3"].set(p[0], x, y, z);
            _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_3__["Vec3"].set(p[2], x, y, z);
            for (var i = 0; i < l; i++) {
                normalized.entity_id[o] = entity_id;
                normalized.chromosome[o] = ch;
                normalized.start[o] = chs.start[i];
                normalized.seq_id_begin[o] = o;
                normalized.seq_id_end[o] = o;
                x = chs.x[i];
                y = chs.y[i];
                z = chs.z[i];
                _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_3__["Vec3"].set(p[1], x, y, z);
                if (i + 1 < l)
                    _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_3__["Vec3"].set(p[2], chs.x[i + 1], chs.y[i + 1], chs.z[i + 1]);
                else
                    _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_3__["Vec3"].set(p[2], x, y, z);
                normalized.x[o] = x;
                normalized.y[o] = y;
                normalized.z[o] = z;
                normalized.r[o] = 2 / 3 * Math.min(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_3__["Vec3"].distance(p[0], p[1]), _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_3__["Vec3"].distance(p[1], p[2]));
                normalized.haplotype[o] = h;
                var _p = p[0];
                p[0] = p[1];
                p[1] = _p;
                o++;
            }
            if (l === 1) {
                normalized.r[o - 1] = 1;
            }
        });
    });
    return normalized;
}
function getTraj(ctx, data) {
    return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"])(this, void 0, void 0, function () {
        var normalized, rowCount, entityIds, entityBuilder, eName, i, e, entityId, ihm_sphere_obj_site, basic, models;
        return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__generator"])(this, function (_a) {
            switch (_a.label) {
                case 0:
                    normalized = getColumns(data);
                    rowCount = normalized.seq_id_begin.length;
                    entityIds = new Array(rowCount);
                    entityBuilder = new _mol_model_formats_structure_common_entity__WEBPACK_IMPORTED_MODULE_6__["EntityBuilder"]();
                    eName = { customName: '' };
                    for (i = 0; i < rowCount; ++i) {
                        e = normalized.entity_id[i];
                        eName.customName = e;
                        entityId = entityBuilder.getEntityId(e, 7 /* DNA */, e, eName);
                        entityIds[i] = entityId;
                    }
                    ihm_sphere_obj_site = _mol_data_db__WEBPACK_IMPORTED_MODULE_1__["Table"].ofPartialColumns(_mol_model_formats_structure_basic_schema__WEBPACK_IMPORTED_MODULE_5__["BasicSchema"].ihm_sphere_obj_site, {
                        id: _mol_data_db__WEBPACK_IMPORTED_MODULE_1__["Column"].range(0, rowCount),
                        entity_id: _mol_data_db__WEBPACK_IMPORTED_MODULE_1__["Column"].ofStringArray(entityIds),
                        seq_id_begin: _mol_data_db__WEBPACK_IMPORTED_MODULE_1__["Column"].ofIntArray(normalized.seq_id_begin),
                        seq_id_end: _mol_data_db__WEBPACK_IMPORTED_MODULE_1__["Column"].ofIntArray(normalized.seq_id_end),
                        asym_id: _mol_data_db__WEBPACK_IMPORTED_MODULE_1__["Column"].ofStringArray(normalized.chromosome),
                        Cartn_x: _mol_data_db__WEBPACK_IMPORTED_MODULE_1__["Column"].ofFloatArray(normalized.x),
                        Cartn_y: _mol_data_db__WEBPACK_IMPORTED_MODULE_1__["Column"].ofFloatArray(normalized.y),
                        Cartn_z: _mol_data_db__WEBPACK_IMPORTED_MODULE_1__["Column"].ofFloatArray(normalized.z),
                        object_radius: _mol_data_db__WEBPACK_IMPORTED_MODULE_1__["Column"].ofFloatArray(normalized.r),
                        rmsf: _mol_data_db__WEBPACK_IMPORTED_MODULE_1__["Column"].ofConst(0, rowCount, _mol_data_db__WEBPACK_IMPORTED_MODULE_1__["Column"].Schema.float),
                        model_id: _mol_data_db__WEBPACK_IMPORTED_MODULE_1__["Column"].ofConst(1, rowCount, _mol_data_db__WEBPACK_IMPORTED_MODULE_1__["Column"].Schema.int),
                    }, rowCount);
                    basic = Object(_mol_model_formats_structure_basic_schema__WEBPACK_IMPORTED_MODULE_5__["createBasic"])({
                        entity: entityBuilder.getEntityTable(),
                        ihm_model_list: _mol_data_db__WEBPACK_IMPORTED_MODULE_1__["Table"].ofPartialColumns(_mol_model_formats_structure_basic_schema__WEBPACK_IMPORTED_MODULE_5__["BasicSchema"].ihm_model_list, {
                            model_id: _mol_data_db__WEBPACK_IMPORTED_MODULE_1__["Column"].ofIntArray([1]),
                            model_name: _mol_data_db__WEBPACK_IMPORTED_MODULE_1__["Column"].ofStringArray(['G3D Model']),
                        }, 1),
                        ihm_sphere_obj_site: ihm_sphere_obj_site
                    });
                    return [4 /*yield*/, Object(_mol_model_formats_structure_basic_parser__WEBPACK_IMPORTED_MODULE_4__["createModels"])(basic, { kind: 'g3d', name: 'G3D', data: data }, ctx)];
                case 1:
                    models = _a.sent();
                    G3dInfoDataProperty.set(models.representative, {
                        haplotypes: Object.keys(data.data),
                        haplotype: normalized.haplotype,
                        resolution: data.resolution,
                        start: normalized.start,
                        chroms: normalized.chromosome,
                    });
                    return [2 /*return*/, models];
            }
        });
    });
}
function trajectoryFromG3D(data) {
    var _this = this;
    return _mol_task__WEBPACK_IMPORTED_MODULE_13__["Task"].create('Parse G3D', function (ctx) { return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"])(_this, void 0, void 0, function () {
        return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__generator"])(this, function (_a) {
            return [2 /*return*/, getTraj(ctx, data)];
        });
    }); });
}
var G3dSymbols = {
    haplotype: _mol_script_runtime_query_base__WEBPACK_IMPORTED_MODULE_12__["QuerySymbolRuntime"].Dynamic(Object(_mol_script_language_symbol__WEBPACK_IMPORTED_MODULE_10__["CustomPropSymbol"])('g3d', 'haplotype', _mol_script_language_type__WEBPACK_IMPORTED_MODULE_11__["default"].Str), function (ctx) {
        if (_mol_model_structure__WEBPACK_IMPORTED_MODULE_8__["Unit"].isAtomic(ctx.element.unit))
            return '';
        var info = G3dInfoDataProperty.get(ctx.element.unit.model);
        if (!info)
            return '';
        var seqId = ctx.element.unit.model.coarseHierarchy.spheres.seq_id_begin.value(ctx.element.element);
        return info.haplotype[seqId] || '';
    }),
    chromosome: _mol_script_runtime_query_base__WEBPACK_IMPORTED_MODULE_12__["QuerySymbolRuntime"].Dynamic(Object(_mol_script_language_symbol__WEBPACK_IMPORTED_MODULE_10__["CustomPropSymbol"])('g3d', 'chromosome', _mol_script_language_type__WEBPACK_IMPORTED_MODULE_11__["default"].Str), function (ctx) {
        if (_mol_model_structure__WEBPACK_IMPORTED_MODULE_8__["Unit"].isAtomic(ctx.element.unit))
            return '';
        var asym_id = ctx.element.unit.model.coarseHierarchy.spheres.asym_id;
        return asym_id.value(ctx.element.element) || '';
    }),
    region: _mol_script_runtime_query_base__WEBPACK_IMPORTED_MODULE_12__["QuerySymbolRuntime"].Dynamic(Object(_mol_script_language_symbol__WEBPACK_IMPORTED_MODULE_10__["CustomPropSymbol"])('g3d', 'region', _mol_script_language_type__WEBPACK_IMPORTED_MODULE_11__["default"].Num), function (ctx) {
        if (_mol_model_structure__WEBPACK_IMPORTED_MODULE_8__["Unit"].isAtomic(ctx.element.unit))
            return '';
        var info = G3dInfoDataProperty.get(ctx.element.unit.model);
        if (!info)
            return 0;
        var seqId = ctx.element.unit.model.coarseHierarchy.spheres.seq_id_begin.value(ctx.element.element);
        return info.start[seqId] || 0;
    })
};
var G3dInfoDataProperty = _mol_model_formats_structure_common_property__WEBPACK_IMPORTED_MODULE_15__["FormatPropertyProvider"].create({ name: 'g3d_info' });
function g3dHaplotypeQuery(haplotype) {
    return _mol_script_language_builder__WEBPACK_IMPORTED_MODULE_9__["MolScriptBuilder"].struct.generator.atomGroups({
        'chain-test': _mol_script_language_builder__WEBPACK_IMPORTED_MODULE_9__["MolScriptBuilder"].core.rel.eq([G3dSymbols.haplotype.symbol(), haplotype]),
    });
}
function g3dChromosomeQuery(chr) {
    return _mol_script_language_builder__WEBPACK_IMPORTED_MODULE_9__["MolScriptBuilder"].struct.generator.atomGroups({
        'chain-test': _mol_script_language_builder__WEBPACK_IMPORTED_MODULE_9__["MolScriptBuilder"].core.logic.and([
            _mol_script_language_builder__WEBPACK_IMPORTED_MODULE_9__["MolScriptBuilder"].core.rel.eq([_mol_script_language_builder__WEBPACK_IMPORTED_MODULE_9__["MolScriptBuilder"].ammp('objectPrimitive'), 'sphere']),
            _mol_script_language_builder__WEBPACK_IMPORTED_MODULE_9__["MolScriptBuilder"].core.rel.eq([G3dSymbols.chromosome.symbol(), chr])
        ])
    });
}
function g3dRegionQuery(chr, start, end) {
    return _mol_script_language_builder__WEBPACK_IMPORTED_MODULE_9__["MolScriptBuilder"].struct.generator.atomGroups({
        'chain-test': _mol_script_language_builder__WEBPACK_IMPORTED_MODULE_9__["MolScriptBuilder"].core.logic.and([
            _mol_script_language_builder__WEBPACK_IMPORTED_MODULE_9__["MolScriptBuilder"].core.rel.eq([_mol_script_language_builder__WEBPACK_IMPORTED_MODULE_9__["MolScriptBuilder"].ammp('objectPrimitive'), 'sphere']),
            _mol_script_language_builder__WEBPACK_IMPORTED_MODULE_9__["MolScriptBuilder"].core.rel.eq([G3dSymbols.chromosome.symbol(), chr])
        ]),
        'residue-test': _mol_script_language_builder__WEBPACK_IMPORTED_MODULE_9__["MolScriptBuilder"].core.rel.inRange([G3dSymbols.region.symbol(), start, end])
    });
}
;
var G3dLabelProvider = {
    label: function (e) {
        if (e.kind !== 'element-loci' || _mol_model_loci__WEBPACK_IMPORTED_MODULE_7__["Loci"].isEmpty(e))
            return;
        var first = e.elements[0];
        if (e.elements.length !== 1 || _mol_model_structure__WEBPACK_IMPORTED_MODULE_8__["Unit"].isAtomic(first.unit))
            return;
        var info = G3dInfoDataProperty.get(first.unit.model);
        if (!info)
            return;
        var eI = first.unit.elements[_mol_data_int__WEBPACK_IMPORTED_MODULE_2__["OrderedSet"].getAt(first.indices, 0)];
        var seqId = first.unit.model.coarseHierarchy.spheres.seq_id_begin.value(eI);
        return "<b>Start:</b> " + info.start[seqId] + " <small>| resolution " + info.resolution + "<small>";
    }
};
//# sourceMappingURL=model.js.map

/***/ }),

/***/ "./lib/extensions/mp4-export/controls.js":
/*!***********************************************!*\
  !*** ./lib/extensions/mp4-export/controls.js ***!
  \***********************************************/
/*! exports provided: Mp4AnimationParams, Mp4Controls */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Mp4AnimationParams", function() { return Mp4AnimationParams; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Mp4Controls", function() { return Mp4Controls; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var rxjs_operators__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! rxjs/operators */ "./node_modules/rxjs/_esm5/operators/index.js");
/* harmony import */ var _mol_plugin_state_component__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../mol-plugin-state/component */ "./lib/mol-plugin-state/component.js");
/* harmony import */ var _mol_task__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../mol-task */ "./lib/mol-task/index.js");
/* harmony import */ var _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../mol-util/param-definition */ "./lib/mol-util/param-definition.js");
/* harmony import */ var _encoder__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./encoder */ "./lib/extensions/mp4-export/encoder.js");
/**
 * Copyright (c) 2020 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author David Sehnal <david.sehnal@gmail.com>
 */






var Mp4AnimationParams = {
    quantization: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_4__["ParamDefinition"].Numeric(18, { min: 10, max: 51 }, { description: 'Lower is better, but slower.' })
};
var Mp4Controls = /** @class */ (function (_super) {
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__extends"])(Mp4Controls, _super);
    function Mp4Controls(plugin) {
        var _this = _super.call(this) || this;
        _this.plugin = plugin;
        _this.currentNames = new Set();
        _this.animations = [];
        _this.behaviors = {
            animations: _this.ev.behavior({}),
            current: _this.ev.behavior(void 0),
            canApply: _this.ev.behavior({ canApply: false }),
            info: _this.ev.behavior({ width: 0, height: 0 }),
            params: _this.ev.behavior(_mol_util_param_definition__WEBPACK_IMPORTED_MODULE_4__["ParamDefinition"].getDefaultValues(Mp4AnimationParams))
        };
        _this.init();
        return _this;
    }
    Mp4Controls.prototype.setCurrent = function (name) {
        var _a, _b;
        var anim = this.animations.find(function (a) { return a.name === name; });
        if (!anim) {
            this.behaviors.current.next(anim);
            return;
        }
        var params = anim.params(this.plugin);
        var values = _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_4__["ParamDefinition"].getDefaultValues(params);
        this.behaviors.current.next({ anim: anim, params: params, values: values });
        this.behaviors.canApply.next((_b = (_a = anim.canApply) === null || _a === void 0 ? void 0 : _a.call(anim, this.plugin)) !== null && _b !== void 0 ? _b : { canApply: true });
    };
    Mp4Controls.prototype.setCurrentParams = function (values) {
        this.behaviors.current.next(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, this.behaviors.current.value), { values: values }));
    };
    Object.defineProperty(Mp4Controls.prototype, "current", {
        get: function () {
            return this.behaviors.current.value;
        },
        enumerable: false,
        configurable: true
    });
    Mp4Controls.prototype.render = function () {
        var _this = this;
        var task = _mol_task__WEBPACK_IMPORTED_MODULE_3__["Task"].create('Export Animation', function (ctx) { return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"])(_this, void 0, void 0, function () {
            var resolution, anim, movie, filename, e_1;
            var _a, _b, _c;
            return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__generator"])(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        _d.trys.push([0, 2, , 3]);
                        resolution = (_a = this.plugin.helpers.viewportScreenshot) === null || _a === void 0 ? void 0 : _a.getSizeAndViewport();
                        anim = this.current;
                        return [4 /*yield*/, Object(_encoder__WEBPACK_IMPORTED_MODULE_5__["encodeMp4Animation"])(this.plugin, ctx, Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({ animation: {
                                    definition: anim.anim,
                                    params: anim.values,
                                } }, resolution), { quantizationParameter: this.behaviors.params.value.quantization, pass: (_b = this.plugin.helpers.viewportScreenshot) === null || _b === void 0 ? void 0 : _b.imagePass }))];
                    case 1:
                        movie = _d.sent();
                        filename = anim.anim.display.name.toLowerCase().replace(/\s/g, '-').replace(/[^a-z0-9_\-]/g, '');
                        return [2 /*return*/, { movie: movie, filename: ((_c = this.plugin.helpers.viewportScreenshot) === null || _c === void 0 ? void 0 : _c.getFilename('')) + "_" + filename + ".mp4" }];
                    case 2:
                        e_1 = _d.sent();
                        this.plugin.log.error('' + e_1);
                        throw e_1;
                    case 3: return [2 /*return*/];
                }
            });
        }); });
        return this.plugin.runTask(task, { useOverlay: true });
    };
    Object.defineProperty(Mp4Controls.prototype, "manager", {
        get: function () {
            return this.plugin.managers.animation;
        },
        enumerable: false,
        configurable: true
    });
    Mp4Controls.prototype.syncInfo = function () {
        var helper = this.plugin.helpers.viewportScreenshot;
        var size = helper === null || helper === void 0 ? void 0 : helper.getSizeAndViewport();
        if (!size)
            return;
        this.behaviors.info.next({ width: size.viewport.width, height: size.viewport.height });
    };
    Mp4Controls.prototype.sync = function () {
        var _this = this;
        var _a, _b;
        var animations = this.manager.animations.filter(function (a) { return a.isExportable; });
        var hasAll = animations.every(function (a) { return _this.currentNames.has(a.name); });
        if (hasAll && this.currentNames.size === animations.length) {
            return;
        }
        var params = {
            current: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_4__["ParamDefinition"].Select((_a = animations[0]) === null || _a === void 0 ? void 0 : _a.name, animations.map(function (a) { return [a.name, a.display.name]; }), { label: 'Animation' })
        };
        var current = this.behaviors.current.value;
        var hasCurrent = !!animations.find(function (a) { return a.name === (current === null || current === void 0 ? void 0 : current.anim.name); });
        this.animations = animations;
        if (!hasCurrent) {
            this.setCurrent((_b = animations[0]) === null || _b === void 0 ? void 0 : _b.name);
        }
        this.behaviors.animations.next(params);
    };
    Mp4Controls.prototype.init = function () {
        var _this = this;
        var _a, _b;
        this.subscribe(this.plugin.managers.animation.events.updated.pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_1__["debounceTime"])(16)), function () {
            _this.sync();
        });
        this.subscribe((_a = this.plugin.canvas3d) === null || _a === void 0 ? void 0 : _a.resized, function () { return _this.syncInfo(); });
        this.subscribe((_b = this.plugin.helpers.viewportScreenshot) === null || _b === void 0 ? void 0 : _b.events.previewed, function () { return _this.syncInfo(); });
        this.subscribe(this.plugin.behaviors.state.isBusy, function (b) {
            var _a, _b, _c;
            var anim = _this.current;
            if (!b && anim) {
                _this.behaviors.canApply.next((_c = (_b = (_a = anim.anim).canApply) === null || _b === void 0 ? void 0 : _b.call(_a, _this.plugin)) !== null && _c !== void 0 ? _c : { canApply: true });
            }
        });
        this.sync();
        this.syncInfo();
    };
    return Mp4Controls;
}(_mol_plugin_state_component__WEBPACK_IMPORTED_MODULE_2__["PluginComponent"]));

//# sourceMappingURL=controls.js.map

/***/ }),

/***/ "./lib/extensions/mp4-export/encoder.js":
/*!**********************************************!*\
  !*** ./lib/extensions/mp4-export/encoder.js ***!
  \**********************************************/
/*! exports provided: encodeMp4Animation */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "encodeMp4Animation", function() { return encodeMp4Animation; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var h264_mp4_encoder__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! h264-mp4-encoder */ "./node_modules/h264-mp4-encoder/embuild/dist/h264-mp4-encoder.node.js");
/* harmony import */ var h264_mp4_encoder__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(h264_mp4_encoder__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _mol_plugin_state_animation_model__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../mol-plugin-state/animation/model */ "./lib/mol-plugin-state/animation/model.js");
/**
 * Copyright (c) 2020 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author David Sehnal <david.sehnal@gmail.com>
 */



function encodeMp4Animation(plugin, ctx, params) {
    var _a, _b, _c;
    return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"])(this, void 0, void 0, function () {
        var durationMs, encoder, width, height, vw, vh, normalizedViewport, loop, canvasProps, wasAnimating, stoppedAnimation, finalized, fps, N, dt, i, image;
        return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__generator"])(this, function (_d) {
            switch (_d.label) {
                case 0: return [4 /*yield*/, ctx.update({ message: 'Initializing...', isIndeterminate: true })];
                case 1:
                    _d.sent();
                    validateViewport(params);
                    durationMs = _mol_plugin_state_animation_model__WEBPACK_IMPORTED_MODULE_2__["PluginStateAnimation"].getDuration(plugin, params.animation);
                    if (durationMs === void 0) {
                        throw new Error('The animation does not have the duration specified.');
                    }
                    return [4 /*yield*/, h264_mp4_encoder__WEBPACK_IMPORTED_MODULE_1__["createH264MP4Encoder"]()];
                case 2:
                    encoder = _d.sent();
                    width = params.width, height = params.height;
                    vw = params.viewport.width, vh = params.viewport.height;
                    // dimensions must be a multiple of 2
                    if (vw % 2 !== 0)
                        vw -= 1;
                    if (vh % 2 !== 0)
                        vh -= 1;
                    normalizedViewport = Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, params.viewport), { width: vw, height: vh });
                    encoder.width = vw;
                    encoder.height = vh;
                    if (params.quantizationParameter)
                        encoder.quantizationParameter = params.quantizationParameter;
                    if (params.fps)
                        encoder.frameRate = params.fps;
                    encoder.initialize();
                    loop = plugin.animationLoop;
                    canvasProps = (_a = plugin.canvas3d) === null || _a === void 0 ? void 0 : _a.props;
                    wasAnimating = loop.isAnimating;
                    stoppedAnimation = true, finalized = false;
                    _d.label = 3;
                case 3:
                    _d.trys.push([3, , 13, 16]);
                    loop.stop();
                    loop.resetTime(0);
                    if (params.customBackground !== void 0) {
                        (_b = plugin.canvas3d) === null || _b === void 0 ? void 0 : _b.setProps({ renderer: { backgroundColor: params.customBackground }, transparentBackground: false }, true);
                    }
                    fps = encoder.frameRate;
                    N = Math.ceil(durationMs / 1000 * fps);
                    dt = durationMs / N;
                    return [4 /*yield*/, ctx.update({ message: 'Rendering...', isIndeterminate: false, current: 0, max: N + 1 })];
                case 4:
                    _d.sent();
                    return [4 /*yield*/, plugin.managers.animation.play(params.animation.definition, params.animation.params)];
                case 5:
                    _d.sent();
                    stoppedAnimation = false;
                    i = 0;
                    _d.label = 6;
                case 6:
                    if (!(i <= N)) return [3 /*break*/, 10];
                    return [4 /*yield*/, loop.tick(i * dt, { isSynchronous: true, manualDraw: true })];
                case 7:
                    _d.sent();
                    image = params.pass.getImageData(width, height, normalizedViewport);
                    encoder.addFrameRgba(image.data);
                    if (!ctx.shouldUpdate) return [3 /*break*/, 9];
                    return [4 /*yield*/, ctx.update({ current: i + 1 })];
                case 8:
                    _d.sent();
                    _d.label = 9;
                case 9:
                    i++;
                    return [3 /*break*/, 6];
                case 10: return [4 /*yield*/, ctx.update({ message: 'Applying finishing touches...', isIndeterminate: true })];
                case 11:
                    _d.sent();
                    return [4 /*yield*/, plugin.managers.animation.stop()];
                case 12:
                    _d.sent();
                    stoppedAnimation = true;
                    encoder.finalize();
                    finalized = true;
                    return [2 /*return*/, encoder.FS.readFile(encoder.outputFilename)];
                case 13:
                    if (finalized)
                        encoder.delete();
                    if (params.customBackground !== void 0) {
                        (_c = plugin.canvas3d) === null || _c === void 0 ? void 0 : _c.setProps({ renderer: { backgroundColor: canvasProps === null || canvasProps === void 0 ? void 0 : canvasProps.renderer.backgroundColor }, transparentBackground: canvasProps === null || canvasProps === void 0 ? void 0 : canvasProps.transparentBackground });
                    }
                    if (!!stoppedAnimation) return [3 /*break*/, 15];
                    return [4 /*yield*/, plugin.managers.animation.stop()];
                case 14:
                    _d.sent();
                    _d.label = 15;
                case 15:
                    if (wasAnimating)
                        loop.start();
                    return [7 /*endfinally*/];
                case 16: return [2 /*return*/];
            }
        });
    });
}
function validateViewport(params) {
    if (params.viewport.x + params.viewport.width > params.width || params.viewport.y + params.viewport.height > params.height) {
        throw new Error('Viewport exceeds the canvas dimensions.');
    }
}
//# sourceMappingURL=encoder.js.map

/***/ }),

/***/ "./lib/extensions/mp4-export/index.js":
/*!********************************************!*\
  !*** ./lib/extensions/mp4-export/index.js ***!
  \********************************************/
/*! exports provided: Mp4Export */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Mp4Export", function() { return Mp4Export; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _mol_plugin_behavior_behavior__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../mol-plugin/behavior/behavior */ "./lib/mol-plugin/behavior/behavior.js");
/* harmony import */ var _ui__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./ui */ "./lib/extensions/mp4-export/ui.js");
/**
 * Copyright (c) 2020 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author David Sehnal <david.sehnal@gmail.com>
 */



var Mp4Export = _mol_plugin_behavior_behavior__WEBPACK_IMPORTED_MODULE_1__["PluginBehavior"].create({
    name: 'extension-mp4-export',
    category: 'misc',
    display: {
        name: 'MP4 Animation Export'
    },
    ctor: /** @class */ (function (_super) {
        Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__extends"])(class_1, _super);
        function class_1() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        class_1.prototype.register = function () {
            this.ctx.customStructureControls.set('mp4-export', _ui__WEBPACK_IMPORTED_MODULE_2__["Mp4EncoderUI"]);
        };
        class_1.prototype.update = function () {
            return false;
        };
        class_1.prototype.unregister = function () {
            this.ctx.customStructureControls.delete('mp4-export');
        };
        return class_1;
    }(_mol_plugin_behavior_behavior__WEBPACK_IMPORTED_MODULE_1__["PluginBehavior"].Handler)),
    params: function () { return ({}); }
});
//# sourceMappingURL=index.js.map

/***/ }),

/***/ "./lib/extensions/mp4-export/ui.js":
/*!*****************************************!*\
  !*** ./lib/extensions/mp4-export/ui.js ***!
  \*****************************************/
/*! exports provided: Mp4EncoderUI */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Mp4EncoderUI", function() { return Mp4EncoderUI; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! react */ "./node_modules/react/index.js");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var rxjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! rxjs */ "./node_modules/rxjs/_esm5/index.js");
/* harmony import */ var rxjs_operators__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! rxjs/operators */ "./node_modules/rxjs/_esm5/operators/index.js");
/* harmony import */ var _mol_plugin_ui_base__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../mol-plugin-ui/base */ "./lib/mol-plugin-ui/base.js");
/* harmony import */ var _mol_plugin_ui_controls_common__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../mol-plugin-ui/controls/common */ "./lib/mol-plugin-ui/controls/common.js");
/* harmony import */ var _mol_plugin_ui_controls_icons__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../../mol-plugin-ui/controls/icons */ "./lib/mol-plugin-ui/controls/icons.js");
/* harmony import */ var _mol_plugin_ui_controls_parameters__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../../mol-plugin-ui/controls/parameters */ "./lib/mol-plugin-ui/controls/parameters.js");
/* harmony import */ var _mol_util_download__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ../../mol-util/download */ "./lib/mol-util/download.js");
/* harmony import */ var _controls__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ./controls */ "./lib/extensions/mp4-export/controls.js");
/**
 * Copyright (c) 2020 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author David Sehnal <david.sehnal@gmail.com>
 */










var Mp4EncoderUI = /** @class */ (function (_super) {
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__extends"])(Mp4EncoderUI, _super);
    function Mp4EncoderUI() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.save = function () {
            Object(_mol_util_download__WEBPACK_IMPORTED_MODULE_8__["download"])(new Blob([_this.state.data.movie]), _this.state.data.filename);
        };
        _this.generate = function () { return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"])(_this, void 0, void 0, function () {
            var data, _a;
            return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__generator"])(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _b.trys.push([0, 2, , 3]);
                        this.setState({ busy: true });
                        return [4 /*yield*/, this.controls.render()];
                    case 1:
                        data = _b.sent();
                        this.setState({ busy: false, data: data });
                        return [3 /*break*/, 3];
                    case 2:
                        _a = _b.sent();
                        this.setState({ busy: false });
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        }); };
        return _this;
    }
    Object.defineProperty(Mp4EncoderUI.prototype, "controls", {
        get: function () {
            return this._controls || (this._controls = new _controls__WEBPACK_IMPORTED_MODULE_9__["Mp4Controls"](this.plugin));
        },
        enumerable: false,
        configurable: true
    });
    Mp4EncoderUI.prototype.defaultState = function () {
        return {
            header: 'Export Animation',
            isCollapsed: true,
            brand: { accent: 'cyan', svg: _mol_plugin_ui_controls_icons__WEBPACK_IMPORTED_MODULE_6__["SubscriptionsOutlinedSvg"] }
        };
    };
    Mp4EncoderUI.prototype.downloadControls = function () {
        var _this = this;
        return react__WEBPACK_IMPORTED_MODULE_1___default.a.createElement(react__WEBPACK_IMPORTED_MODULE_1___default.a.Fragment, null,
            react__WEBPACK_IMPORTED_MODULE_1___default.a.createElement("div", { className: 'msp-control-offset msp-help-text' },
                react__WEBPACK_IMPORTED_MODULE_1___default.a.createElement("div", { className: 'msp-help-description', style: { textAlign: 'center' } }, "Rendering successful!")),
            react__WEBPACK_IMPORTED_MODULE_1___default.a.createElement(_mol_plugin_ui_controls_common__WEBPACK_IMPORTED_MODULE_5__["Button"], { icon: _mol_plugin_ui_controls_icons__WEBPACK_IMPORTED_MODULE_6__["GetAppSvg"], onClick: this.save, style: { marginTop: 1 } }, "Save Animation"),
            react__WEBPACK_IMPORTED_MODULE_1___default.a.createElement(_mol_plugin_ui_controls_common__WEBPACK_IMPORTED_MODULE_5__["Button"], { onClick: function () { return _this.setState({ data: void 0 }); }, style: { marginTop: 6 } }, "Clear"));
    };
    Mp4EncoderUI.prototype.renderControls = function () {
        var _a;
        if (this.state.data) {
            return this.downloadControls();
        }
        var ctrl = this.controls;
        var current = ctrl.behaviors.current.value;
        var info = ctrl.behaviors.info.value;
        var canApply = ctrl.behaviors.canApply.value;
        return react__WEBPACK_IMPORTED_MODULE_1___default.a.createElement(react__WEBPACK_IMPORTED_MODULE_1___default.a.Fragment, null,
            react__WEBPACK_IMPORTED_MODULE_1___default.a.createElement(_mol_plugin_ui_controls_parameters__WEBPACK_IMPORTED_MODULE_7__["ParameterControls"], { params: ctrl.behaviors.animations.value, values: { current: current === null || current === void 0 ? void 0 : current.anim.name }, onChangeValues: function (xs) { return ctrl.setCurrent(xs.current); }, isDisabled: this.state.busy }),
            current && react__WEBPACK_IMPORTED_MODULE_1___default.a.createElement(_mol_plugin_ui_controls_parameters__WEBPACK_IMPORTED_MODULE_7__["ParameterControls"], { params: current.params, values: current.values, onChangeValues: function (xs) { return ctrl.setCurrentParams(xs); }, isDisabled: this.state.busy }),
            react__WEBPACK_IMPORTED_MODULE_1___default.a.createElement("div", { className: 'msp-control-offset msp-help-text' },
                react__WEBPACK_IMPORTED_MODULE_1___default.a.createElement("div", { className: 'msp-help-description', style: { textAlign: 'center' } },
                    "Resolution: ",
                    info.width,
                    "x",
                    info.height,
                    react__WEBPACK_IMPORTED_MODULE_1___default.a.createElement("br", null),
                    "Adjust in viewport using ",
                    react__WEBPACK_IMPORTED_MODULE_1___default.a.createElement(_mol_plugin_ui_controls_icons__WEBPACK_IMPORTED_MODULE_6__["Icon"], { svg: _mol_plugin_ui_controls_icons__WEBPACK_IMPORTED_MODULE_6__["CameraOutlinedSvg"], inline: true }))),
            react__WEBPACK_IMPORTED_MODULE_1___default.a.createElement(_mol_plugin_ui_controls_parameters__WEBPACK_IMPORTED_MODULE_7__["ParameterControls"], { params: _controls__WEBPACK_IMPORTED_MODULE_9__["Mp4AnimationParams"], values: ctrl.behaviors.params.value, onChangeValues: function (xs) { return ctrl.behaviors.params.next(xs); }, isDisabled: this.state.busy }),
            react__WEBPACK_IMPORTED_MODULE_1___default.a.createElement(_mol_plugin_ui_controls_common__WEBPACK_IMPORTED_MODULE_5__["Button"], { onClick: this.generate, style: { marginTop: 1 }, disabled: this.state.busy || !canApply.canApply, commit: canApply.canApply ? 'on' : 'off' }, canApply.canApply ? 'Render' : (_a = canApply.reason) !== null && _a !== void 0 ? _a : 'Invalid params/state'));
    };
    Mp4EncoderUI.prototype.componentDidMount = function () {
        var _this = this;
        var merged = Object(rxjs__WEBPACK_IMPORTED_MODULE_2__["merge"])(this.controls.behaviors.animations, this.controls.behaviors.current, this.controls.behaviors.canApply, this.controls.behaviors.info, this.controls.behaviors.params);
        this.subscribe(merged.pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_3__["debounceTime"])(10)), function () {
            if (!_this.state.isCollapsed)
                _this.forceUpdate();
        });
    };
    Mp4EncoderUI.prototype.componentWillUnmount = function () {
        var _a;
        (_a = this._controls) === null || _a === void 0 ? void 0 : _a.dispose();
        this._controls = void 0;
    };
    return Mp4EncoderUI;
}(_mol_plugin_ui_base__WEBPACK_IMPORTED_MODULE_4__["CollapsableControls"]));

//# sourceMappingURL=ui.js.map

/***/ }),

/***/ "./lib/extensions/pdbe/index.js":
/*!**************************************!*\
  !*** ./lib/extensions/pdbe/index.js ***!
  \**************************************/
/*! exports provided: PDBeStructureQualityReport, PDBePreferredAssembly, PDBeStructRefDomain */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _structure_quality_report_behavior__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./structure-quality-report/behavior */ "./lib/extensions/pdbe/structure-quality-report/behavior.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "PDBeStructureQualityReport", function() { return _structure_quality_report_behavior__WEBPACK_IMPORTED_MODULE_0__["PDBeStructureQualityReport"]; });

/* harmony import */ var _preferred_assembly__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./preferred-assembly */ "./lib/extensions/pdbe/preferred-assembly.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "PDBePreferredAssembly", function() { return _preferred_assembly__WEBPACK_IMPORTED_MODULE_1__["PDBePreferredAssembly"]; });

/* harmony import */ var _struct_ref_domain__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./struct-ref-domain */ "./lib/extensions/pdbe/struct-ref-domain.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "PDBeStructRefDomain", function() { return _struct_ref_domain__WEBPACK_IMPORTED_MODULE_2__["PDBeStructRefDomain"]; });

/**
 * Copyright (c) 2020 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */



//# sourceMappingURL=index.js.map

/***/ }),

/***/ "./lib/extensions/pdbe/preferred-assembly.js":
/*!***************************************************!*\
  !*** ./lib/extensions/pdbe/preferred-assembly.js ***!
  \***************************************************/
/*! exports provided: PDBePreferredAssembly */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "PDBePreferredAssembly", function() { return PDBePreferredAssembly; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _mol_data_db__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../mol-data/db */ "./lib/mol-data/db.js");
/* harmony import */ var _mol_io_reader_cif_schema__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../mol-io/reader/cif/schema */ "./lib/mol-io/reader/cif/schema.js");
/* harmony import */ var _mol_io_writer_cif__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../mol-io/writer/cif */ "./lib/mol-io/writer/cif.js");
/* harmony import */ var _mol_model_formats_structure_property_symmetry__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../mol-model-formats/structure/property/symmetry */ "./lib/mol-model-formats/structure/property/symmetry.js");
/* harmony import */ var _mol_model_formats_structure_mmcif__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../mol-model-formats/structure/mmcif */ "./lib/mol-model-formats/structure/mmcif.js");
/* harmony import */ var _mol_model_custom_property__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../../mol-model/custom-property */ "./lib/mol-model/custom-property.js");
/**
 * Copyright (c) 2018 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author David Sehnal <david.sehnal@gmail.com>
 */







var PDBePreferredAssembly;
(function (PDBePreferredAssembly) {
    function getFirstFromModel(model) {
        var symmetry = _mol_model_formats_structure_property_symmetry__WEBPACK_IMPORTED_MODULE_4__["ModelSymmetry"].Provider.get(model);
        return (symmetry === null || symmetry === void 0 ? void 0 : symmetry.assemblies.length) ? symmetry.assemblies[0].id : '';
    }
    PDBePreferredAssembly.getFirstFromModel = getFirstFromModel;
    function get(model) {
        return model._staticPropertyData.__PDBePreferredAssebly__ || getFirstFromModel(model);
    }
    PDBePreferredAssembly.get = get;
    function set(model, prop) {
        model._staticPropertyData.__PDBePreferredAssebly__ = prop;
    }
    PDBePreferredAssembly.Schema = {
        pdbe_preferred_assembly: {
            assembly_id: _mol_data_db__WEBPACK_IMPORTED_MODULE_1__["Column"].Schema.str
        }
    };
    PDBePreferredAssembly.Descriptor = Object(_mol_model_custom_property__WEBPACK_IMPORTED_MODULE_6__["CustomPropertyDescriptor"])({
        name: 'pdbe_preferred_assembly',
        cifExport: {
            prefix: 'pdbe',
            context: function (ctx) { return get(ctx.firstModel); },
            categories: [{
                    name: 'pdbe_preferred_assembly',
                    instance: function (ctx) {
                        return _mol_io_writer_cif__WEBPACK_IMPORTED_MODULE_3__["CifWriter"].Category.ofTable(_mol_data_db__WEBPACK_IMPORTED_MODULE_1__["Table"].ofArrays(PDBePreferredAssembly.Schema.pdbe_preferred_assembly, { assembly_id: [ctx] }));
                    }
                }]
        }
    });
    function fromCifData(model) {
        if (!_mol_model_formats_structure_mmcif__WEBPACK_IMPORTED_MODULE_5__["MmcifFormat"].is(model.sourceData))
            return void 0;
        var cat = model.sourceData.data.frame.categories.pdbe_preferred_assembly;
        if (!cat)
            return void 0;
        return Object(_mol_io_reader_cif_schema__WEBPACK_IMPORTED_MODULE_2__["toTable"])(PDBePreferredAssembly.Schema.pdbe_preferred_assembly, cat).assembly_id.value(0) || getFirstFromModel(model);
    }
    function attachFromCifOrApi(model, params) {
        return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"])(this, void 0, void 0, function () {
            var asmName, data;
            return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__generator"])(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (model.customProperties.has(PDBePreferredAssembly.Descriptor))
                            return [2 /*return*/, true];
                        asmName = fromCifData(model);
                        if (!(asmName === void 0 && params.PDBe_apiSourceJson)) return [3 /*break*/, 2];
                        return [4 /*yield*/, params.PDBe_apiSourceJson(model)];
                    case 1:
                        data = _a.sent();
                        if (!data)
                            return [2 /*return*/, false];
                        asmName = asmNameFromJson(model, data);
                        return [3 /*break*/, 3];
                    case 2: return [2 /*return*/, false];
                    case 3:
                        if (!asmName)
                            return [2 /*return*/, false];
                        model.customProperties.add(PDBePreferredAssembly.Descriptor);
                        set(model, asmName);
                        return [2 /*return*/, true];
                }
            });
        });
    }
    PDBePreferredAssembly.attachFromCifOrApi = attachFromCifOrApi;
})(PDBePreferredAssembly || (PDBePreferredAssembly = {}));
function asmNameFromJson(modelData, data) {
    var assemblies = data[0] && data[0].assemblies;
    if (!assemblies || !assemblies.length)
        return PDBePreferredAssembly.getFirstFromModel(modelData);
    for (var _i = 0, assemblies_1 = assemblies; _i < assemblies_1.length; _i++) {
        var asm = assemblies_1[_i];
        if (asm.preferred) {
            return asm.assembly_id;
        }
    }
    return assemblies[0].assembly_id;
}
//# sourceMappingURL=preferred-assembly.js.map

/***/ }),

/***/ "./lib/extensions/pdbe/struct-ref-domain.js":
/*!**************************************************!*\
  !*** ./lib/extensions/pdbe/struct-ref-domain.js ***!
  \**************************************************/
/*! exports provided: PDBeStructRefDomain */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "PDBeStructRefDomain", function() { return PDBeStructRefDomain; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _mol_data_db__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../mol-data/db */ "./lib/mol-data/db.js");
/* harmony import */ var _mol_io_reader_cif_schema__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../mol-io/reader/cif/schema */ "./lib/mol-io/reader/cif/schema.js");
/* harmony import */ var _mol_io_writer_cif__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../mol-io/writer/cif */ "./lib/mol-io/writer/cif.js");
/* harmony import */ var _mol_model_props_common_wrapper__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../mol-model-props/common/wrapper */ "./lib/mol-model-props/common/wrapper.js");
/* harmony import */ var _mol_model_formats_structure_mmcif__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../mol-model-formats/structure/mmcif */ "./lib/mol-model-formats/structure/mmcif.js");
/* harmony import */ var _mol_model_custom_property__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../../mol-model/custom-property */ "./lib/mol-model/custom-property.js");
/**
 * Copyright (c) 2018 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author David Sehnal <david.sehnal@gmail.com>
 */







var PDBeStructRefDomain;
(function (PDBeStructRefDomain) {
    function get(model) {
        return model._staticPropertyData.__PDBeStructRefSeq__;
    }
    PDBeStructRefDomain.get = get;
    function set(model, prop) {
        model._staticPropertyData.__PDBeStructRefSeq__ = prop;
    }
    PDBeStructRefDomain.Schema = {
        pdbe_struct_ref_domain: {
            id: _mol_data_db__WEBPACK_IMPORTED_MODULE_1__["Column"].Schema.int,
            db_name: _mol_data_db__WEBPACK_IMPORTED_MODULE_1__["Column"].Schema.str,
            db_code: _mol_data_db__WEBPACK_IMPORTED_MODULE_1__["Column"].Schema.str,
            identifier: _mol_data_db__WEBPACK_IMPORTED_MODULE_1__["Column"].Schema.str,
            name: _mol_data_db__WEBPACK_IMPORTED_MODULE_1__["Column"].Schema.str,
            label_entity_id: _mol_data_db__WEBPACK_IMPORTED_MODULE_1__["Column"].Schema.str,
            label_asym_id: _mol_data_db__WEBPACK_IMPORTED_MODULE_1__["Column"].Schema.str,
            beg_label_seq_id: _mol_data_db__WEBPACK_IMPORTED_MODULE_1__["Column"].Schema.int,
            beg_pdbx_PDB_ins_code: _mol_data_db__WEBPACK_IMPORTED_MODULE_1__["Column"].Schema.str,
            end_label_seq_id: _mol_data_db__WEBPACK_IMPORTED_MODULE_1__["Column"].Schema.int,
            end_pdbx_PDB_ins_code: _mol_data_db__WEBPACK_IMPORTED_MODULE_1__["Column"].Schema.str
        }
    };
    PDBeStructRefDomain.Descriptor = Object(_mol_model_custom_property__WEBPACK_IMPORTED_MODULE_6__["CustomPropertyDescriptor"])({
        name: 'pdbe_struct_ref_domain',
        cifExport: {
            prefix: 'pdbe',
            context: function (ctx) { return get(ctx.firstModel); },
            categories: [
                _mol_model_props_common_wrapper__WEBPACK_IMPORTED_MODULE_4__["PropertyWrapper"].defaultInfoCategory('pdbe_struct_ref_domain_info', function (ctx) { return ctx.info; }),
                {
                    name: 'pdbe_struct_ref_domain',
                    instance: function (ctx) {
                        if (!ctx || !ctx.data)
                            return _mol_io_writer_cif__WEBPACK_IMPORTED_MODULE_3__["CifWriter"].Category.Empty;
                        return _mol_io_writer_cif__WEBPACK_IMPORTED_MODULE_3__["CifWriter"].Category.ofTable(ctx.data);
                    }
                }
            ]
        }
    });
    function fromCifData(model) {
        if (!_mol_model_formats_structure_mmcif__WEBPACK_IMPORTED_MODULE_5__["MmcifFormat"].is(model.sourceData))
            return void 0;
        var cat = model.sourceData.data.frame.categories.pdbe_struct_ref_domain;
        if (!cat)
            return void 0;
        return Object(_mol_io_reader_cif_schema__WEBPACK_IMPORTED_MODULE_2__["toTable"])(PDBeStructRefDomain.Schema.pdbe_struct_ref_domain, cat);
    }
    function attachFromCifOrApi(model, params) {
        return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"])(this, void 0, void 0, function () {
            var table, info, data;
            return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__generator"])(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (model.customProperties.has(PDBeStructRefDomain.Descriptor))
                            return [2 /*return*/, true];
                        info = _mol_model_props_common_wrapper__WEBPACK_IMPORTED_MODULE_4__["PropertyWrapper"].tryGetInfoFromCif('pdbe_struct_ref_domain_info', model);
                        if (!info) return [3 /*break*/, 1];
                        table = fromCifData(model);
                        return [3 /*break*/, 4];
                    case 1:
                        if (!params.PDBe_apiSourceJson) return [3 /*break*/, 3];
                        return [4 /*yield*/, params.PDBe_apiSourceJson(model)];
                    case 2:
                        data = _a.sent();
                        if (!data)
                            return [2 /*return*/, false];
                        info = _mol_model_props_common_wrapper__WEBPACK_IMPORTED_MODULE_4__["PropertyWrapper"].createInfo();
                        table = fromPDBeJson(model, data);
                        return [3 /*break*/, 4];
                    case 3: return [2 /*return*/, false];
                    case 4:
                        model.customProperties.add(PDBeStructRefDomain.Descriptor);
                        set(model, { info: info, data: table });
                        return [2 /*return*/, true];
                }
            });
        });
    }
    PDBeStructRefDomain.attachFromCifOrApi = attachFromCifOrApi;
})(PDBeStructRefDomain || (PDBeStructRefDomain = {}));
function fromPDBeJson(modelData, data) {
    var rows = [];
    var id = 1;
    for (var _i = 0, _a = Object.keys(data); _i < _a.length; _i++) {
        var db_name = _a[_i];
        var db = data[db_name];
        for (var _b = 0, _c = Object.keys(db); _b < _c.length; _b++) {
            var db_code = _c[_b];
            var domain = db[db_code];
            for (var _d = 0, _e = domain.mappings; _d < _e.length; _d++) {
                var map = _e[_d];
                rows.push({
                    id: id++,
                    db_name: db_name,
                    db_code: db_code,
                    identifier: domain.identifier,
                    name: domain.name,
                    label_entity_id: '' + map.entity_id,
                    label_asym_id: map.struct_asym_id,
                    beg_label_seq_id: map.start.residue_number,
                    beg_pdbx_PDB_ins_code: map.start.author_insertion_code,
                    end_label_seq_id: map.end.residue_number,
                    end_pdbx_PDB_ins_code: map.end.author_insertion_code,
                });
            }
        }
    }
    return _mol_data_db__WEBPACK_IMPORTED_MODULE_1__["Table"].ofRows(PDBeStructRefDomain.Schema.pdbe_struct_ref_domain, rows);
}
//# sourceMappingURL=struct-ref-domain.js.map

/***/ }),

/***/ "./lib/extensions/pdbe/structure-quality-report/behavior.js":
/*!******************************************************************!*\
  !*** ./lib/extensions/pdbe/structure-quality-report/behavior.js ***!
  \******************************************************************/
/*! exports provided: PDBeStructureQualityReport */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "PDBeStructureQualityReport", function() { return PDBeStructureQualityReport; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _mol_data_int__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../../mol-data/int */ "./lib/mol-data/int.js");
/* harmony import */ var _prop__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./prop */ "./lib/extensions/pdbe/structure-quality-report/prop.js");
/* harmony import */ var _color__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./color */ "./lib/extensions/pdbe/structure-quality-report/color.js");
/* harmony import */ var _mol_model_structure__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../../mol-model/structure */ "./lib/mol-model/structure.js");
/* harmony import */ var _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../../mol-util/param-definition */ "./lib/mol-util/param-definition.js");
/* harmony import */ var _mol_plugin_behavior_behavior__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../../../mol-plugin/behavior/behavior */ "./lib/mol-plugin/behavior/behavior.js");
/**
 * Copyright (c) 2018-2020 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author David Sehnal <david.sehnal@gmail.com>
 */







var PDBeStructureQualityReport = _mol_plugin_behavior_behavior__WEBPACK_IMPORTED_MODULE_6__["PluginBehavior"].create({
    name: 'pdbe-structure-quality-report-prop',
    category: 'custom-props',
    display: {
        name: 'Structure Quality Report',
        description: 'Data from wwPDB Validation Report, obtained via PDBe.'
    },
    ctor: /** @class */ (function (_super) {
        Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__extends"])(class_1, _super);
        function class_1() {
            var _this = _super !== null && _super.apply(this, arguments) || this;
            _this.provider = _prop__WEBPACK_IMPORTED_MODULE_2__["StructureQualityReportProvider"];
            _this.labelPDBeValidation = {
                label: function (loci) {
                    if (!_this.params.showTooltip)
                        return void 0;
                    switch (loci.kind) {
                        case 'element-loci':
                            if (loci.elements.length === 0)
                                return void 0;
                            var e = loci.elements[0];
                            var u = e.unit;
                            if (!u.model.customProperties.hasReference(_prop__WEBPACK_IMPORTED_MODULE_2__["StructureQualityReportProvider"].descriptor))
                                return void 0;
                            var se = _mol_model_structure__WEBPACK_IMPORTED_MODULE_4__["StructureElement"].Location.create(loci.structure, u, u.elements[_mol_data_int__WEBPACK_IMPORTED_MODULE_1__["OrderedSet"].getAt(e.indices, 0)]);
                            var issues = _prop__WEBPACK_IMPORTED_MODULE_2__["StructureQualityReport"].getIssues(se);
                            if (issues.length === 0)
                                return 'Validation: No Issues';
                            return "Validation: " + issues.join(', ');
                        default: return void 0;
                    }
                }
            };
            return _this;
        }
        class_1.prototype.register = function () {
            this.ctx.customModelProperties.register(this.provider, this.params.autoAttach);
            this.ctx.managers.lociLabels.addProvider(this.labelPDBeValidation);
            this.ctx.representation.structure.themes.colorThemeRegistry.add(_color__WEBPACK_IMPORTED_MODULE_3__["StructureQualityReportColorThemeProvider"]);
        };
        class_1.prototype.update = function (p) {
            var updated = this.params.autoAttach !== p.autoAttach;
            this.params.autoAttach = p.autoAttach;
            this.params.showTooltip = p.showTooltip;
            this.ctx.customModelProperties.setDefaultAutoAttach(this.provider.descriptor.name, this.params.autoAttach);
            return updated;
        };
        class_1.prototype.unregister = function () {
            this.ctx.customModelProperties.unregister(_prop__WEBPACK_IMPORTED_MODULE_2__["StructureQualityReportProvider"].descriptor.name);
            this.ctx.managers.lociLabels.removeProvider(this.labelPDBeValidation);
            this.ctx.representation.structure.themes.colorThemeRegistry.remove(_color__WEBPACK_IMPORTED_MODULE_3__["StructureQualityReportColorThemeProvider"]);
        };
        return class_1;
    }(_mol_plugin_behavior_behavior__WEBPACK_IMPORTED_MODULE_6__["PluginBehavior"].Handler)),
    params: function () { return ({
        autoAttach: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_5__["ParamDefinition"].Boolean(false),
        showTooltip: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_5__["ParamDefinition"].Boolean(true)
    }); }
});
//# sourceMappingURL=behavior.js.map

/***/ }),

/***/ "./lib/extensions/pdbe/structure-quality-report/color.js":
/*!***************************************************************!*\
  !*** ./lib/extensions/pdbe/structure-quality-report/color.js ***!
  \***************************************************************/
/*! exports provided: StructureQualityReportColorThemeParams, StructureQualityReportColorTheme, StructureQualityReportColorThemeProvider */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "StructureQualityReportColorThemeParams", function() { return StructureQualityReportColorThemeParams; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "StructureQualityReportColorTheme", function() { return StructureQualityReportColorTheme; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "StructureQualityReportColorThemeProvider", function() { return StructureQualityReportColorThemeProvider; });
/* harmony import */ var _prop__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./prop */ "./lib/extensions/pdbe/structure-quality-report/prop.js");
/* harmony import */ var _mol_model_structure__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../../mol-model/structure */ "./lib/mol-model/structure.js");
/* harmony import */ var _mol_util_color__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../../mol-util/color */ "./lib/mol-util/color/index.js");
/* harmony import */ var _mol_util_legend__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../../mol-util/legend */ "./lib/mol-util/legend.js");
/* harmony import */ var _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../../mol-util/param-definition */ "./lib/mol-util/param-definition.js");
/**
 * Copyright (c) 2018 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author David Sehnal <david.sehnal@gmail.com>
 */





var ValidationColors = [
    _mol_util_color__WEBPACK_IMPORTED_MODULE_2__["Color"].fromRgb(170, 170, 170),
    _mol_util_color__WEBPACK_IMPORTED_MODULE_2__["Color"].fromRgb(0, 255, 0),
    _mol_util_color__WEBPACK_IMPORTED_MODULE_2__["Color"].fromRgb(255, 255, 0),
    _mol_util_color__WEBPACK_IMPORTED_MODULE_2__["Color"].fromRgb(255, 128, 0),
    _mol_util_color__WEBPACK_IMPORTED_MODULE_2__["Color"].fromRgb(255, 0, 0),
];
var ValidationColorTable = [
    ['No Issues', ValidationColors[1]],
    ['One Issue', ValidationColors[2]],
    ['Two Issues', ValidationColors[3]],
    ['Three Or More Issues', ValidationColors[4]],
    ['Not Applicable', ValidationColors[9]]
];
var StructureQualityReportColorThemeParams = {
    type: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_4__["ParamDefinition"].MappedStatic('issue-count', {
        'issue-count': _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_4__["ParamDefinition"].Group({}),
        'specific-issue': _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_4__["ParamDefinition"].Group({
            kind: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_4__["ParamDefinition"].Text()
        })
    })
};
function StructureQualityReportColorTheme(ctx, props) {
    var color;
    if (ctx.structure && !ctx.structure.isEmpty && ctx.structure.models[0].customProperties.has(_prop__WEBPACK_IMPORTED_MODULE_0__["StructureQualityReportProvider"].descriptor)) {
        var getIssues_1 = _prop__WEBPACK_IMPORTED_MODULE_0__["StructureQualityReport"].getIssues;
        var l_1 = _mol_model_structure__WEBPACK_IMPORTED_MODULE_1__["StructureElement"].Location.create(ctx.structure);
        if (props.type.name === 'issue-count') {
            color = function (location) {
                if (_mol_model_structure__WEBPACK_IMPORTED_MODULE_1__["StructureElement"].Location.is(location)) {
                    return ValidationColors[Math.min(3, getIssues_1(location).length) + 1];
                }
                else if (_mol_model_structure__WEBPACK_IMPORTED_MODULE_1__["Bond"].isLocation(location)) {
                    l_1.unit = location.aUnit;
                    l_1.element = location.aUnit.elements[location.aIndex];
                    return ValidationColors[Math.min(3, getIssues_1(l_1).length) + 1];
                }
                return ValidationColors[0];
            };
        }
        else {
            var issue_1 = props.type.params.kind;
            color = function (location) {
                if (_mol_model_structure__WEBPACK_IMPORTED_MODULE_1__["StructureElement"].Location.is(location) && getIssues_1(location).indexOf(issue_1) >= 0) {
                    return ValidationColors[4];
                }
                else if (_mol_model_structure__WEBPACK_IMPORTED_MODULE_1__["Bond"].isLocation(location)) {
                    l_1.unit = location.aUnit;
                    l_1.element = location.aUnit.elements[location.aIndex];
                    return ValidationColors[Math.min(3, getIssues_1(l_1).length) + 1];
                }
                return ValidationColors[0];
            };
        }
    }
    else {
        color = function () { return ValidationColors[0]; };
    }
    return {
        factory: StructureQualityReportColorTheme,
        granularity: 'group',
        color: color,
        props: props,
        description: 'Assigns residue colors according to the number of quality issues or a specific quality issue. Data from wwPDB Validation Report, obtained via PDBe.',
        legend: Object(_mol_util_legend__WEBPACK_IMPORTED_MODULE_3__["TableLegend"])(ValidationColorTable)
    };
}
var StructureQualityReportColorThemeProvider = {
    name: 'pdbe-structure-quality-report',
    label: 'Structure Quality Report',
    category: "Validation" /* Validation */,
    factory: StructureQualityReportColorTheme,
    getParams: function (ctx) {
        var issueTypes = _prop__WEBPACK_IMPORTED_MODULE_0__["StructureQualityReport"].getIssueTypes(ctx.structure);
        if (issueTypes.length === 0) {
            return {
                type: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_4__["ParamDefinition"].MappedStatic('issue-count', {
                    'issue-count': _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_4__["ParamDefinition"].Group({})
                })
            };
        }
        return {
            type: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_4__["ParamDefinition"].MappedStatic('issue-count', {
                'issue-count': _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_4__["ParamDefinition"].Group({}),
                'specific-issue': _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_4__["ParamDefinition"].Group({
                    kind: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_4__["ParamDefinition"].Select(issueTypes[0], _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_4__["ParamDefinition"].arrayToOptions(issueTypes))
                }, { isFlat: true })
            })
        };
    },
    defaultValues: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_4__["ParamDefinition"].getDefaultValues(StructureQualityReportColorThemeParams),
    isApplicable: function (ctx) { var _a; return _prop__WEBPACK_IMPORTED_MODULE_0__["StructureQualityReport"].isApplicable((_a = ctx.structure) === null || _a === void 0 ? void 0 : _a.models[0]); },
    ensureCustomProperties: {
        attach: function (ctx, data) { return data.structure ? _prop__WEBPACK_IMPORTED_MODULE_0__["StructureQualityReportProvider"].attach(ctx, data.structure.models[0], void 0, true) : Promise.resolve(); },
        detach: function (data) { return data.structure && data.structure.models[0].customProperties.reference(_prop__WEBPACK_IMPORTED_MODULE_0__["StructureQualityReportProvider"].descriptor, false); }
    }
};
//# sourceMappingURL=color.js.map

/***/ }),

/***/ "./lib/extensions/pdbe/structure-quality-report/prop.js":
/*!**************************************************************!*\
  !*** ./lib/extensions/pdbe/structure-quality-report/prop.js ***!
  \**************************************************************/
/*! exports provided: StructureQualityReport, StructureQualityReportParams, StructureQualityReportProvider */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "StructureQualityReport", function() { return StructureQualityReport; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "StructureQualityReportParams", function() { return StructureQualityReportParams; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "StructureQualityReportProvider", function() { return StructureQualityReportProvider; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _mol_data_db__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../../mol-data/db */ "./lib/mol-data/db.js");
/* harmony import */ var _mol_io_reader_cif_schema__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../../mol-io/reader/cif/schema */ "./lib/mol-io/reader/cif/schema.js");
/* harmony import */ var _mol_io_reader_cif_schema_mmcif_extras__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../../mol-io/reader/cif/schema/mmcif-extras */ "./lib/mol-io/reader/cif/schema/mmcif-extras.js");
/* harmony import */ var _mol_io_writer_cif__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../../mol-io/writer/cif */ "./lib/mol-io/writer/cif.js");
/* harmony import */ var _mol_model_structure__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../../mol-model/structure */ "./lib/mol-model/structure.js");
/* harmony import */ var _mol_model_structure_export_categories_atom_site__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../../../mol-model/structure/export/categories/atom_site */ "./lib/mol-model/structure/export/categories/atom_site.js");
/* harmony import */ var _mol_script_language_symbol__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../../../mol-script/language/symbol */ "./lib/mol-script/language/symbol.js");
/* harmony import */ var _mol_script_language_type__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ../../../mol-script/language/type */ "./lib/mol-script/language/type.js");
/* harmony import */ var _mol_script_runtime_query_compiler__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ../../../mol-script/runtime/query/compiler */ "./lib/mol-script/runtime/query/compiler.js");
/* harmony import */ var _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ../../../mol-util/param-definition */ "./lib/mol-util/param-definition.js");
/* harmony import */ var _mol_util_array__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ../../../mol-util/array */ "./lib/mol-util/array.js");
/* harmony import */ var _mol_model_formats_structure_mmcif__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! ../../../mol-model-formats/structure/mmcif */ "./lib/mol-model-formats/structure/mmcif.js");
/* harmony import */ var _mol_model_props_common_wrapper__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! ../../../mol-model-props/common/wrapper */ "./lib/mol-model-props/common/wrapper.js");
/* harmony import */ var _mol_model_props_common_custom_model_property__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! ../../../mol-model-props/common/custom-model-property */ "./lib/mol-model-props/common/custom-model-property.js");
/* harmony import */ var _mol_util_assets__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! ../../../mol-util/assets */ "./lib/mol-util/assets.js");
/* harmony import */ var _mol_model_custom_property__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(/*! ../../../mol-model/custom-property */ "./lib/mol-model/custom-property.js");
/**
 * Copyright (c) 2018-2020 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author David Sehnal <david.sehnal@gmail.com>
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */


















var StructureQualityReport;
(function (StructureQualityReport) {
    StructureQualityReport.DefaultServerUrl = 'https://www.ebi.ac.uk/pdbe/api/validation/residuewise_outlier_summary/entry/';
    function getEntryUrl(pdbId, serverUrl) {
        return serverUrl + "/" + pdbId.toLowerCase();
    }
    StructureQualityReport.getEntryUrl = getEntryUrl;
    function isApplicable(model) {
        return !!model && _mol_model_structure__WEBPACK_IMPORTED_MODULE_5__["Model"].isFromPdbArchive(model);
    }
    StructureQualityReport.isApplicable = isApplicable;
    StructureQualityReport.Schema = {
        pdbe_structure_quality_report: {
            updated_datetime_utc: _mol_data_db__WEBPACK_IMPORTED_MODULE_1__["Column"].Schema.str
        },
        pdbe_structure_quality_report_issues: Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({ id: _mol_data_db__WEBPACK_IMPORTED_MODULE_1__["Column"].Schema.int }, _mol_io_reader_cif_schema_mmcif_extras__WEBPACK_IMPORTED_MODULE_3__["mmCIF_residueId_schema"]), { pdbx_PDB_model_num: _mol_data_db__WEBPACK_IMPORTED_MODULE_1__["Column"].Schema.int, issue_type_group_id: _mol_data_db__WEBPACK_IMPORTED_MODULE_1__["Column"].Schema.int }),
        pdbe_structure_quality_report_issue_types: {
            group_id: _mol_data_db__WEBPACK_IMPORTED_MODULE_1__["Column"].Schema.int,
            issue_type: _mol_data_db__WEBPACK_IMPORTED_MODULE_1__["Column"].Schema.str
        }
    };
    function fromJson(model, data) {
        var info = _mol_model_props_common_wrapper__WEBPACK_IMPORTED_MODULE_13__["PropertyWrapper"].createInfo();
        var issueMap = createIssueMapFromJson(model, data);
        return { info: info, data: issueMap };
    }
    StructureQualityReport.fromJson = fromJson;
    function fromServer(ctx, model, props) {
        return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"])(this, void 0, void 0, function () {
            var url, json, data;
            return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__generator"])(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = _mol_util_assets__WEBPACK_IMPORTED_MODULE_15__["Asset"].getUrlAsset(ctx.assetManager, getEntryUrl(model.entryId, props.serverUrl));
                        return [4 /*yield*/, ctx.assetManager.resolve(url, 'json').runInContext(ctx.runtime)];
                    case 1:
                        json = _a.sent();
                        data = json.data[model.entryId.toLowerCase()];
                        if (!data)
                            throw new Error('missing data');
                        return [2 /*return*/, { value: fromJson(model, data), assets: [json] }];
                }
            });
        });
    }
    StructureQualityReport.fromServer = fromServer;
    function fromCif(ctx, model, props) {
        var info = _mol_model_props_common_wrapper__WEBPACK_IMPORTED_MODULE_13__["PropertyWrapper"].tryGetInfoFromCif('pdbe_structure_quality_report', model);
        if (!info)
            return;
        var data = getCifData(model);
        var issueMap = createIssueMapFromCif(model, data.residues, data.groups);
        return { info: info, data: issueMap };
    }
    StructureQualityReport.fromCif = fromCif;
    function fromCifOrServer(ctx, model, props) {
        return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"])(this, void 0, void 0, function () {
            var cif;
            return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__generator"])(this, function (_a) {
                cif = fromCif(ctx, model, props);
                return [2 /*return*/, cif ? { value: cif } : fromServer(ctx, model, props)];
            });
        });
    }
    StructureQualityReport.fromCifOrServer = fromCifOrServer;
    var _emptyArray = [];
    function getIssues(e) {
        if (!_mol_model_structure__WEBPACK_IMPORTED_MODULE_5__["Unit"].isAtomic(e.unit))
            return _emptyArray;
        var prop = StructureQualityReportProvider.get(e.unit.model).value;
        if (!prop || !prop.data)
            return _emptyArray;
        var rI = e.unit.residueIndex[e.element];
        return prop.data.issues.has(rI) ? prop.data.issues.get(rI) : _emptyArray;
    }
    StructureQualityReport.getIssues = getIssues;
    function getIssueTypes(structure) {
        if (!structure)
            return _emptyArray;
        var prop = StructureQualityReportProvider.get(structure.models[0]).value;
        if (!prop || !prop.data)
            return _emptyArray;
        return prop.data.issueTypes;
    }
    StructureQualityReport.getIssueTypes = getIssueTypes;
    function getCifData(model) {
        if (!_mol_model_formats_structure_mmcif__WEBPACK_IMPORTED_MODULE_12__["MmcifFormat"].is(model.sourceData))
            throw new Error('Data format must be mmCIF.');
        return {
            residues: Object(_mol_io_reader_cif_schema__WEBPACK_IMPORTED_MODULE_2__["toTable"])(StructureQualityReport.Schema.pdbe_structure_quality_report_issues, model.sourceData.data.frame.categories.pdbe_structure_quality_report_issues),
            groups: Object(_mol_io_reader_cif_schema__WEBPACK_IMPORTED_MODULE_2__["toTable"])(StructureQualityReport.Schema.pdbe_structure_quality_report_issue_types, model.sourceData.data.frame.categories.pdbe_structure_quality_report_issue_types),
        };
    }
})(StructureQualityReport || (StructureQualityReport = {}));
var StructureQualityReportParams = {
    serverUrl: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_10__["ParamDefinition"].Text(StructureQualityReport.DefaultServerUrl, { description: 'JSON API Server URL' })
};
var StructureQualityReportProvider = _mol_model_props_common_custom_model_property__WEBPACK_IMPORTED_MODULE_14__["CustomModelProperty"].createProvider({
    label: 'Structure Quality Report',
    descriptor: Object(_mol_model_custom_property__WEBPACK_IMPORTED_MODULE_16__["CustomPropertyDescriptor"])({
        name: 'pdbe_structure_quality_report',
        cifExport: {
            prefix: 'pdbe',
            context: function (ctx) {
                return createExportContext(ctx);
            },
            categories: [
                _mol_model_props_common_wrapper__WEBPACK_IMPORTED_MODULE_13__["PropertyWrapper"].defaultInfoCategory('pdbe_structure_quality_report', function (ctx) { return ctx.info; }),
                {
                    name: 'pdbe_structure_quality_report_issues',
                    instance: function (ctx) {
                        return {
                            fields: _structure_quality_report_issues_fields,
                            source: ctx.models.map(function (data) { return ({ data: data, rowCount: data.elements.length }); })
                        };
                    }
                }, {
                    name: 'pdbe_structure_quality_report_issue_types',
                    instance: function (ctx) {
                        return _mol_io_writer_cif__WEBPACK_IMPORTED_MODULE_4__["CifWriter"].Category.ofTable(ctx.issueTypes);
                    }
                }
            ]
        },
        symbols: {
            issueCount: _mol_script_runtime_query_compiler__WEBPACK_IMPORTED_MODULE_9__["QuerySymbolRuntime"].Dynamic(Object(_mol_script_language_symbol__WEBPACK_IMPORTED_MODULE_7__["CustomPropSymbol"])('pdbe', 'structure-quality.issue-count', _mol_script_language_type__WEBPACK_IMPORTED_MODULE_8__["default"].Num), function (ctx) { return StructureQualityReport.getIssues(ctx.element).length; }),
        }
    }),
    type: 'static',
    defaultParams: StructureQualityReportParams,
    getParams: function (data) { return StructureQualityReportParams; },
    isApplicable: function (data) { return StructureQualityReport.isApplicable(data); },
    obtain: function (ctx, data, props) { return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"])(void 0, void 0, void 0, function () {
        var p;
        return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__generator"])(this, function (_a) {
            switch (_a.label) {
                case 0:
                    p = Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_10__["ParamDefinition"].getDefaultValues(StructureQualityReportParams)), props);
                    return [4 /*yield*/, StructureQualityReport.fromCifOrServer(ctx, data, p)];
                case 1: return [2 /*return*/, _a.sent()];
            }
        });
    }); }
});
var _structure_quality_report_issues_fields = _mol_io_writer_cif__WEBPACK_IMPORTED_MODULE_4__["CifWriter"].fields()
    .index('id')
    .many(Object(_mol_model_structure_export_categories_atom_site__WEBPACK_IMPORTED_MODULE_6__["residueIdFields"])(function (i, d) { return d.elements[i]; }, { includeModelNum: true }))
    .int('issue_type_group_id', function (i, d) { return d.groupId[i]; })
    .getFields();
function createExportContext(ctx) {
    var groupMap = new Map();
    var models = [];
    var group_id = [], issue_type = [];
    var info = _mol_model_props_common_wrapper__WEBPACK_IMPORTED_MODULE_13__["PropertyWrapper"].createInfo();
    for (var _i = 0, _a = ctx.structures; _i < _a.length; _i++) {
        var s = _a[_i];
        var prop = StructureQualityReportProvider.get(s.model).value;
        if (prop)
            info = prop.info;
        if (!prop || !prop.data)
            continue;
        var _b = prop.data.issues.getElements(s), elements = _b.elements, property = _b.property;
        if (elements.length === 0)
            continue;
        var elementGroupId = [];
        for (var i = 0; i < elements.length; i++) {
            var issues = property(i);
            var key = issues.join(',');
            if (!groupMap.has(key)) {
                var idx = groupMap.size + 1;
                groupMap.set(key, idx);
                for (var _c = 0, issues_1 = issues; _c < issues_1.length; _c++) {
                    var issue = issues_1[_c];
                    group_id.push(idx);
                    issue_type.push(issue);
                }
            }
            elementGroupId[i] = groupMap.get(key);
        }
        models.push({ elements: elements, groupId: elementGroupId });
    }
    return {
        info: info,
        models: models,
        issueTypes: _mol_data_db__WEBPACK_IMPORTED_MODULE_1__["Table"].ofArrays(StructureQualityReport.Schema.pdbe_structure_quality_report_issue_types, { group_id: group_id, issue_type: issue_type })
    };
}
function createIssueMapFromJson(modelData, data) {
    var ret = new Map();
    if (!data.molecules)
        return;
    var issueTypes = [];
    for (var _i = 0, _a = data.molecules; _i < _a.length; _i++) {
        var entity = _a[_i];
        var entity_id = entity.entity_id.toString();
        for (var _b = 0, _c = entity.chains; _b < _c.length; _b++) {
            var chain = _c[_b];
            var asym_id = chain.struct_asym_id.toString();
            for (var _d = 0, _e = chain.models; _d < _e.length; _d++) {
                var model = _e[_d];
                var model_id = model.model_id.toString();
                if (+model_id !== modelData.modelNum)
                    continue;
                for (var _f = 0, _g = model.residues; _f < _g.length; _f++) {
                    var residue = _g[_f];
                    var auth_seq_id = residue.author_residue_number, ins_code = residue.author_insertion_code || '';
                    var idx = modelData.atomicHierarchy.index.findResidue(entity_id, asym_id, auth_seq_id, ins_code);
                    ret.set(idx, residue.outlier_types);
                    for (var _h = 0, _j = residue.outlier_types; _h < _j.length; _h++) {
                        var t = _j[_h];
                        Object(_mol_util_array__WEBPACK_IMPORTED_MODULE_11__["arraySetAdd"])(issueTypes, t);
                    }
                }
            }
        }
    }
    return {
        issues: _mol_model_structure__WEBPACK_IMPORTED_MODULE_5__["IndexedCustomProperty"].fromResidueMap(ret),
        issueTypes: issueTypes
    };
}
function createIssueMapFromCif(modelData, residueData, groupData) {
    var ret = new Map();
    var label_entity_id = residueData.label_entity_id, label_asym_id = residueData.label_asym_id, auth_seq_id = residueData.auth_seq_id, pdbx_PDB_ins_code = residueData.pdbx_PDB_ins_code, issue_type_group_id = residueData.issue_type_group_id, pdbx_PDB_model_num = residueData.pdbx_PDB_model_num, _rowCount = residueData._rowCount;
    var groups = parseIssueTypes(groupData);
    for (var i = 0; i < _rowCount; i++) {
        if (pdbx_PDB_model_num.value(i) !== modelData.modelNum)
            continue;
        var idx = modelData.atomicHierarchy.index.findResidue(label_entity_id.value(i), label_asym_id.value(i), auth_seq_id.value(i), pdbx_PDB_ins_code.value(i));
        ret.set(idx, groups.get(issue_type_group_id.value(i)));
    }
    var issueTypes = [];
    groups.forEach(function (issues) {
        for (var _i = 0, issues_2 = issues; _i < issues_2.length; _i++) {
            var t = issues_2[_i];
            Object(_mol_util_array__WEBPACK_IMPORTED_MODULE_11__["arraySetAdd"])(issueTypes, t);
        }
    });
    return {
        issues: _mol_model_structure__WEBPACK_IMPORTED_MODULE_5__["IndexedCustomProperty"].fromResidueMap(ret),
        issueTypes: issueTypes
    };
}
function parseIssueTypes(groupData) {
    var ret = new Map();
    var group_id = groupData.group_id, issue_type = groupData.issue_type;
    for (var i = 0; i < groupData._rowCount; i++) {
        var group = void 0;
        var id = group_id.value(i);
        if (ret.has(id))
            group = ret.get(id);
        else {
            group = [];
            ret.set(id, group);
        }
        group.push(issue_type.value(i));
    }
    return ret;
}
//# sourceMappingURL=prop.js.map

/***/ }),

/***/ "./lib/extensions/rcsb/assembly-symmetry/behavior.js":
/*!***********************************************************!*\
  !*** ./lib/extensions/rcsb/assembly-symmetry/behavior.js ***!
  \***********************************************************/
/*! exports provided: RCSBAssemblySymmetry, InitAssemblySymmetry3D, AssemblySymmetry3D, AssemblySymmetryPresetParams, AssemblySymmetryPreset, tryCreateAssemblySymmetry */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "RCSBAssemblySymmetry", function() { return RCSBAssemblySymmetry; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "InitAssemblySymmetry3D", function() { return InitAssemblySymmetry3D; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "AssemblySymmetry3D", function() { return AssemblySymmetry3D; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "AssemblySymmetryPresetParams", function() { return AssemblySymmetryPresetParams; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "AssemblySymmetryPreset", function() { return AssemblySymmetryPreset; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "tryCreateAssemblySymmetry", function() { return tryCreateAssemblySymmetry; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../../mol-util/param-definition */ "./lib/mol-util/param-definition.js");
/* harmony import */ var _prop__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./prop */ "./lib/extensions/rcsb/assembly-symmetry/prop.js");
/* harmony import */ var _mol_plugin_behavior_behavior__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../../mol-plugin/behavior/behavior */ "./lib/mol-plugin/behavior/behavior.js");
/* harmony import */ var _representation__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./representation */ "./lib/extensions/rcsb/assembly-symmetry/representation.js");
/* harmony import */ var _color__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./color */ "./lib/extensions/rcsb/assembly-symmetry/color.js");
/* harmony import */ var _mol_plugin_state_objects__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../../../mol-plugin-state/objects */ "./lib/mol-plugin-state/objects.js");
/* harmony import */ var _mol_task__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../../../mol-task */ "./lib/mol-task/index.js");
/* harmony import */ var _mol_state__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ../../../mol-state */ "./lib/mol-state/index.js");
/* harmony import */ var _ui__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ./ui */ "./lib/extensions/rcsb/assembly-symmetry/ui.js");
/* harmony import */ var _mol_plugin_state_builder_structure_representation_preset__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ../../../mol-plugin-state/builder/structure/representation-preset */ "./lib/mol-plugin-state/builder/structure/representation-preset.js");
/**
 * Copyright (c) 2018-2020 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */











var Tag = _prop__WEBPACK_IMPORTED_MODULE_2__["AssemblySymmetry"].Tag;
var RCSBAssemblySymmetry = _mol_plugin_behavior_behavior__WEBPACK_IMPORTED_MODULE_3__["PluginBehavior"].create({
    name: 'rcsb-assembly-symmetry-prop',
    category: 'custom-props',
    display: {
        name: 'Assembly Symmetry',
        description: 'Assembly Symmetry data calculated with BioJava, obtained via RCSB PDB.'
    },
    ctor: /** @class */ (function (_super) {
        Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__extends"])(class_1, _super);
        function class_1() {
            var _this = _super !== null && _super.apply(this, arguments) || this;
            _this.provider = _prop__WEBPACK_IMPORTED_MODULE_2__["AssemblySymmetryProvider"];
            return _this;
        }
        class_1.prototype.register = function () {
            this.ctx.state.data.actions.add(InitAssemblySymmetry3D);
            this.ctx.customStructureProperties.register(this.provider, this.params.autoAttach);
            this.ctx.representation.structure.themes.colorThemeRegistry.add(_color__WEBPACK_IMPORTED_MODULE_5__["AssemblySymmetryClusterColorThemeProvider"]);
            this.ctx.genericRepresentationControls.set(Tag.Representation, function (selection) {
                var refs = [];
                selection.structures.forEach(function (structure) {
                    var _a;
                    var symmRepr = (_a = structure.genericRepresentations) === null || _a === void 0 ? void 0 : _a.filter(function (r) { return r.cell.transform.transformer.id === AssemblySymmetry3D.id; })[0];
                    if (symmRepr)
                        refs.push(symmRepr);
                });
                return [refs, 'Symmetries'];
            });
            this.ctx.customStructureControls.set(Tag.Representation, _ui__WEBPACK_IMPORTED_MODULE_9__["AssemblySymmetryControls"]);
            this.ctx.builders.structure.representation.registerPreset(AssemblySymmetryPreset);
        };
        class_1.prototype.update = function (p) {
            var updated = this.params.autoAttach !== p.autoAttach;
            this.params.autoAttach = p.autoAttach;
            this.ctx.customStructureProperties.setDefaultAutoAttach(this.provider.descriptor.name, this.params.autoAttach);
            return updated;
        };
        class_1.prototype.unregister = function () {
            this.ctx.state.data.actions.remove(InitAssemblySymmetry3D);
            this.ctx.customStructureProperties.unregister(this.provider.descriptor.name);
            this.ctx.representation.structure.themes.colorThemeRegistry.remove(_color__WEBPACK_IMPORTED_MODULE_5__["AssemblySymmetryClusterColorThemeProvider"]);
            this.ctx.genericRepresentationControls.delete(Tag.Representation);
            this.ctx.customStructureControls.delete(Tag.Representation);
            this.ctx.builders.structure.representation.unregisterPreset(AssemblySymmetryPreset);
        };
        return class_1;
    }(_mol_plugin_behavior_behavior__WEBPACK_IMPORTED_MODULE_3__["PluginBehavior"].Handler)),
    params: function () { return ({
        autoAttach: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_1__["ParamDefinition"].Boolean(false),
        serverUrl: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_1__["ParamDefinition"].Text(_prop__WEBPACK_IMPORTED_MODULE_2__["AssemblySymmetry"].DefaultServerUrl)
    }); }
});
//
var InitAssemblySymmetry3D = _mol_state__WEBPACK_IMPORTED_MODULE_8__["StateAction"].build({
    display: {
        name: 'Assembly Symmetry',
        description: 'Initialize Assembly Symmetry axes and cage. Data calculated with BioJava, obtained via RCSB PDB.'
    },
    from: _mol_plugin_state_objects__WEBPACK_IMPORTED_MODULE_6__["PluginStateObject"].Molecule.Structure,
    isApplicable: function (a) { return _prop__WEBPACK_IMPORTED_MODULE_2__["AssemblySymmetry"].isApplicable(a.data); }
})(function (_a, plugin) {
    var a = _a.a, ref = _a.ref, state = _a.state;
    return _mol_task__WEBPACK_IMPORTED_MODULE_7__["Task"].create('Init Assembly Symmetry', function (ctx) { return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"])(void 0, void 0, void 0, function () {
        var propCtx, assemblySymmetryData, symmetryIndex, e_1, tree;
        return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__generator"])(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 3, , 4]);
                    propCtx = { runtime: ctx, assetManager: plugin.managers.asset };
                    return [4 /*yield*/, _prop__WEBPACK_IMPORTED_MODULE_2__["AssemblySymmetryDataProvider"].attach(propCtx, a.data)];
                case 1:
                    _a.sent();
                    assemblySymmetryData = _prop__WEBPACK_IMPORTED_MODULE_2__["AssemblySymmetryDataProvider"].get(a.data).value;
                    symmetryIndex = assemblySymmetryData ? _prop__WEBPACK_IMPORTED_MODULE_2__["AssemblySymmetry"].firstNonC1(assemblySymmetryData) : -1;
                    return [4 /*yield*/, _prop__WEBPACK_IMPORTED_MODULE_2__["AssemblySymmetryProvider"].attach(propCtx, a.data, { symmetryIndex: symmetryIndex })];
                case 2:
                    _a.sent();
                    return [3 /*break*/, 4];
                case 3:
                    e_1 = _a.sent();
                    plugin.log.error("Assembly Symmetry: " + e_1);
                    return [2 /*return*/];
                case 4:
                    tree = state.build().to(ref)
                        .applyOrUpdateTagged(_prop__WEBPACK_IMPORTED_MODULE_2__["AssemblySymmetry"].Tag.Representation, AssemblySymmetry3D);
                    return [4 /*yield*/, state.updateTree(tree).runInContext(ctx)];
                case 5:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    }); });
});

var AssemblySymmetry3D = _mol_plugin_state_objects__WEBPACK_IMPORTED_MODULE_6__["PluginStateTransform"].BuiltIn({
    name: Tag.Representation,
    display: {
        name: 'Assembly Symmetry',
        description: 'Assembly Symmetry axes and cage. Data calculated with BioJava, obtained via RCSB PDB.'
    },
    from: _mol_plugin_state_objects__WEBPACK_IMPORTED_MODULE_6__["PluginStateObject"].Molecule.Structure,
    to: _mol_plugin_state_objects__WEBPACK_IMPORTED_MODULE_6__["PluginStateObject"].Shape.Representation3D,
    params: function (a) {
        return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, _representation__WEBPACK_IMPORTED_MODULE_4__["AssemblySymmetryParams"]);
    }
})({
    canAutoUpdate: function (_a) {
        var oldParams = _a.oldParams, newParams = _a.newParams;
        return true;
    },
    apply: function (_a, plugin) {
        var _this = this;
        var a = _a.a, params = _a.params;
        return _mol_task__WEBPACK_IMPORTED_MODULE_7__["Task"].create('Assembly Symmetry', function (ctx) { return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"])(_this, void 0, void 0, function () {
            var assemblySymmetry, repr, type, kind, symbol;
            var _a;
            return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__generator"])(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, _prop__WEBPACK_IMPORTED_MODULE_2__["AssemblySymmetryProvider"].attach({ runtime: ctx, assetManager: plugin.managers.asset }, a.data)];
                    case 1:
                        _b.sent();
                        assemblySymmetry = _prop__WEBPACK_IMPORTED_MODULE_2__["AssemblySymmetryProvider"].get(a.data).value;
                        if (!assemblySymmetry || assemblySymmetry.symbol === 'C1') {
                            return [2 /*return*/, _mol_state__WEBPACK_IMPORTED_MODULE_8__["StateObject"].Null];
                        }
                        repr = Object(_representation__WEBPACK_IMPORTED_MODULE_4__["AssemblySymmetryRepresentation"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({ webgl: (_a = plugin.canvas3d) === null || _a === void 0 ? void 0 : _a.webgl }, plugin.representation.structure.themes), function () { return _representation__WEBPACK_IMPORTED_MODULE_4__["AssemblySymmetryParams"]; });
                        return [4 /*yield*/, repr.createOrUpdate(params, a.data).runInContext(ctx)];
                    case 2:
                        _b.sent();
                        type = assemblySymmetry.type, kind = assemblySymmetry.kind, symbol = assemblySymmetry.symbol;
                        return [2 /*return*/, new _mol_plugin_state_objects__WEBPACK_IMPORTED_MODULE_6__["PluginStateObject"].Shape.Representation3D({ repr: repr, source: a }, { label: kind, description: type + " (" + symbol + ")" })];
                }
            });
        }); });
    },
    update: function (_a, plugin) {
        var _this = this;
        var a = _a.a, b = _a.b, newParams = _a.newParams;
        return _mol_task__WEBPACK_IMPORTED_MODULE_7__["Task"].create('Assembly Symmetry', function (ctx) { return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"])(_this, void 0, void 0, function () {
            var assemblySymmetry, props, type, kind, symbol;
            return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__generator"])(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, _prop__WEBPACK_IMPORTED_MODULE_2__["AssemblySymmetryProvider"].attach({ runtime: ctx, assetManager: plugin.managers.asset }, a.data)];
                    case 1:
                        _a.sent();
                        assemblySymmetry = _prop__WEBPACK_IMPORTED_MODULE_2__["AssemblySymmetryProvider"].get(a.data).value;
                        if (!assemblySymmetry || assemblySymmetry.symbol === 'C1') {
                            // this should NOT be StateTransformer.UpdateResult.Null
                            // because that keeps the old object
                            return [2 /*return*/, _mol_state__WEBPACK_IMPORTED_MODULE_8__["StateTransformer"].UpdateResult.Recreate];
                        }
                        props = Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, b.data.repr.props), newParams);
                        return [4 /*yield*/, b.data.repr.createOrUpdate(props, a.data).runInContext(ctx)];
                    case 2:
                        _a.sent();
                        type = assemblySymmetry.type, kind = assemblySymmetry.kind, symbol = assemblySymmetry.symbol;
                        b.label = kind;
                        b.description = type + " (" + symbol + ")";
                        return [2 /*return*/, _mol_state__WEBPACK_IMPORTED_MODULE_8__["StateTransformer"].UpdateResult.Updated];
                }
            });
        }); });
    },
    isApplicable: function (a) {
        return _prop__WEBPACK_IMPORTED_MODULE_2__["AssemblySymmetry"].isApplicable(a.data);
    }
});
//
var AssemblySymmetryPresetParams = Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, _mol_plugin_state_builder_structure_representation_preset__WEBPACK_IMPORTED_MODULE_10__["StructureRepresentationPresetProvider"].CommonParams);
var AssemblySymmetryPreset = Object(_mol_plugin_state_builder_structure_representation_preset__WEBPACK_IMPORTED_MODULE_10__["StructureRepresentationPresetProvider"])({
    id: 'preset-structure-representation-rcsb-assembly-symmetry',
    display: {
        name: 'Assembly Symmetry', group: 'Annotation',
        description: 'Shows Assembly Symmetry axes and cage; colors structure according to assembly symmetry cluster membership. Data calculated with BioJava, obtained via RCSB PDB.'
    },
    isApplicable: function (a) {
        return _prop__WEBPACK_IMPORTED_MODULE_2__["AssemblySymmetry"].isApplicable(a.data);
    },
    params: function () { return AssemblySymmetryPresetParams; },
    apply: function (ref, params, plugin) {
        var _a;
        return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"])(this, void 0, void 0, function () {
            var structureCell, structure, assemblySymmetry, colorTheme, preset;
            var _this = this;
            return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__generator"])(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        structureCell = _mol_state__WEBPACK_IMPORTED_MODULE_8__["StateObjectRef"].resolveAndCheck(plugin.state.data, ref);
                        structure = (_a = structureCell === null || structureCell === void 0 ? void 0 : structureCell.obj) === null || _a === void 0 ? void 0 : _a.data;
                        if (!structureCell || !structure)
                            return [2 /*return*/, {}];
                        if (!!_prop__WEBPACK_IMPORTED_MODULE_2__["AssemblySymmetryDataProvider"].get(structure).value) return [3 /*break*/, 2];
                        return [4 /*yield*/, plugin.runTask(_mol_task__WEBPACK_IMPORTED_MODULE_7__["Task"].create('Assembly Symmetry', function (runtime) { return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"])(_this, void 0, void 0, function () {
                                var propCtx, assemblySymmetryData, symmetryIndex;
                                return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__generator"])(this, function (_a) {
                                    switch (_a.label) {
                                        case 0:
                                            propCtx = { runtime: runtime, assetManager: plugin.managers.asset };
                                            return [4 /*yield*/, _prop__WEBPACK_IMPORTED_MODULE_2__["AssemblySymmetryDataProvider"].attach(propCtx, structure)];
                                        case 1:
                                            _a.sent();
                                            assemblySymmetryData = _prop__WEBPACK_IMPORTED_MODULE_2__["AssemblySymmetryDataProvider"].get(structure).value;
                                            symmetryIndex = assemblySymmetryData ? _prop__WEBPACK_IMPORTED_MODULE_2__["AssemblySymmetry"].firstNonC1(assemblySymmetryData) : -1;
                                            return [4 /*yield*/, _prop__WEBPACK_IMPORTED_MODULE_2__["AssemblySymmetryProvider"].attach(propCtx, structure, { symmetryIndex: symmetryIndex })];
                                        case 2:
                                            _a.sent();
                                            return [2 /*return*/];
                                    }
                                });
                            }); }))];
                    case 1:
                        _b.sent();
                        _b.label = 2;
                    case 2: return [4 /*yield*/, tryCreateAssemblySymmetry(plugin, structureCell)];
                    case 3:
                        assemblySymmetry = _b.sent();
                        colorTheme = assemblySymmetry.isOk ? Tag.Cluster : undefined;
                        return [4 /*yield*/, _mol_plugin_state_builder_structure_representation_preset__WEBPACK_IMPORTED_MODULE_10__["PresetStructureRepresentations"].auto.apply(ref, Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, params), { theme: { globalName: colorTheme, focus: { name: colorTheme } } }), plugin)];
                    case 4:
                        preset = _b.sent();
                        return [2 /*return*/, { components: preset.components, representations: Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, preset.representations), { assemblySymmetry: assemblySymmetry }) }];
                }
            });
        });
    }
});
function tryCreateAssemblySymmetry(plugin, structure, params, initialState) {
    var state = plugin.state.data;
    var assemblySymmetry = state.build().to(structure)
        .applyOrUpdateTagged(_prop__WEBPACK_IMPORTED_MODULE_2__["AssemblySymmetry"].Tag.Representation, AssemblySymmetry3D, params, { state: initialState });
    return assemblySymmetry.commit({ revertOnError: true });
}
//# sourceMappingURL=behavior.js.map

/***/ }),

/***/ "./lib/extensions/rcsb/assembly-symmetry/color.js":
/*!********************************************************!*\
  !*** ./lib/extensions/rcsb/assembly-symmetry/color.js ***!
  \********************************************************/
/*! exports provided: AssemblySymmetryClusterColorThemeParams, getAssemblySymmetryClusterColorThemeParams, AssemblySymmetryClusterColorTheme, AssemblySymmetryClusterColorThemeProvider */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "AssemblySymmetryClusterColorThemeParams", function() { return AssemblySymmetryClusterColorThemeParams; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getAssemblySymmetryClusterColorThemeParams", function() { return getAssemblySymmetryClusterColorThemeParams; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "AssemblySymmetryClusterColorTheme", function() { return AssemblySymmetryClusterColorTheme; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "AssemblySymmetryClusterColorThemeProvider", function() { return AssemblySymmetryClusterColorThemeProvider; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../../mol-util/param-definition */ "./lib/mol-util/param-definition.js");
/* harmony import */ var _prop__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./prop */ "./lib/extensions/rcsb/assembly-symmetry/prop.js");
/* harmony import */ var _mol_util_color__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../../mol-util/color */ "./lib/mol-util/color/index.js");
/* harmony import */ var _mol_model_structure__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../../mol-model/structure */ "./lib/mol-model/structure.js");
/* harmony import */ var _mol_util_color_palette__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../../mol-util/color/palette */ "./lib/mol-util/color/palette.js");
/**
 * Copyright (c) 2018-2020 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */






var DefaultColor = Object(_mol_util_color__WEBPACK_IMPORTED_MODULE_3__["Color"])(0xCCCCCC);
function getAsymId(unit) {
    switch (unit.kind) {
        case 0 /* Atomic */:
            return _mol_model_structure__WEBPACK_IMPORTED_MODULE_4__["StructureProperties"].chain.label_asym_id;
        case 1 /* Spheres */:
        case 2 /* Gaussians */:
            return _mol_model_structure__WEBPACK_IMPORTED_MODULE_4__["StructureProperties"].coarse.asym_id;
    }
}
function clusterMemberKey(asymId, operList) {
    return asymId + "-" + operList.join('|');
}
var AssemblySymmetryClusterColorThemeParams = Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, Object(_mol_util_color_palette__WEBPACK_IMPORTED_MODULE_5__["getPaletteParams"])({ colorList: 'red-yellow-blue' }));
function getAssemblySymmetryClusterColorThemeParams(ctx) {
    var params = _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_1__["ParamDefinition"].clone(AssemblySymmetryClusterColorThemeParams);
    return params;
}
function AssemblySymmetryClusterColorTheme(ctx, props) {
    var _a;
    var color = function () { return DefaultColor; };
    var legend;
    var assemblySymmetry = ctx.structure && _prop__WEBPACK_IMPORTED_MODULE_2__["AssemblySymmetryProvider"].get(ctx.structure);
    var contextHash = assemblySymmetry === null || assemblySymmetry === void 0 ? void 0 : assemblySymmetry.version;
    var clusters = (_a = assemblySymmetry === null || assemblySymmetry === void 0 ? void 0 : assemblySymmetry.value) === null || _a === void 0 ? void 0 : _a.clusters;
    if ((clusters === null || clusters === void 0 ? void 0 : clusters.length) && ctx.structure) {
        var l_1 = _mol_model_structure__WEBPACK_IMPORTED_MODULE_4__["StructureElement"].Location.create(ctx.structure);
        var clusterByMember_1 = new Map();
        for (var i = 0, il = clusters.length; i < il; ++i) {
            var members = clusters[i].members;
            for (var j = 0, jl = members.length; j < jl; ++j) {
                var asymId = members[j].asym_id;
                var operList = Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__spreadArrays"])(members[j].pdbx_struct_oper_list_ids || []);
                clusterByMember_1.set(clusterMemberKey(asymId, operList), i);
                if (operList.length === 0) {
                    operList.push('1'); // TODO hack assuming '1' is the id of the identity operator
                    clusterByMember_1.set(clusterMemberKey(asymId, operList), i);
                }
            }
        }
        var palette_1 = Object(_mol_util_color_palette__WEBPACK_IMPORTED_MODULE_5__["getPalette"])(clusters.length, props);
        legend = palette_1.legend;
        var _emptyList_1 = [];
        var getColor_1 = function (location) {
            var assembly = location.unit.conformation.operator.assembly;
            var asymId = getAsymId(location.unit)(location);
            var cluster = clusterByMember_1.get(clusterMemberKey(asymId, (assembly === null || assembly === void 0 ? void 0 : assembly.operList) || _emptyList_1));
            return cluster !== undefined ? palette_1.color(cluster) : DefaultColor;
        };
        color = function (location) {
            if (_mol_model_structure__WEBPACK_IMPORTED_MODULE_4__["StructureElement"].Location.is(location)) {
                return getColor_1(location);
            }
            else if (_mol_model_structure__WEBPACK_IMPORTED_MODULE_4__["Bond"].isLocation(location)) {
                l_1.unit = location.aUnit;
                l_1.element = location.aUnit.elements[location.aIndex];
                return getColor_1(l_1);
            }
            return DefaultColor;
        };
    }
    return {
        factory: AssemblySymmetryClusterColorTheme,
        granularity: 'instance',
        color: color,
        props: props,
        contextHash: contextHash,
        description: 'Assigns chain colors according to assembly symmetry cluster membership calculated with BioJava and obtained via RCSB PDB.',
        legend: legend
    };
}
var AssemblySymmetryClusterColorThemeProvider = {
    name: _prop__WEBPACK_IMPORTED_MODULE_2__["AssemblySymmetry"].Tag.Cluster,
    label: 'Assembly Symmetry Cluster',
    category: "Symmetry" /* Symmetry */,
    factory: AssemblySymmetryClusterColorTheme,
    getParams: getAssemblySymmetryClusterColorThemeParams,
    defaultValues: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_1__["ParamDefinition"].getDefaultValues(AssemblySymmetryClusterColorThemeParams),
    isApplicable: function (ctx) { return _prop__WEBPACK_IMPORTED_MODULE_2__["AssemblySymmetry"].isApplicable(ctx.structure); },
    ensureCustomProperties: {
        attach: function (ctx, data) { return data.structure ? _prop__WEBPACK_IMPORTED_MODULE_2__["AssemblySymmetryProvider"].attach(ctx, data.structure, void 0, true) : Promise.resolve(); },
        detach: function (data) { return data.structure && data.structure.customPropertyDescriptors.reference(_prop__WEBPACK_IMPORTED_MODULE_2__["AssemblySymmetryProvider"].descriptor, false); }
    }
};
//# sourceMappingURL=color.js.map

/***/ }),

/***/ "./lib/extensions/rcsb/assembly-symmetry/prop.js":
/*!*******************************************************!*\
  !*** ./lib/extensions/rcsb/assembly-symmetry/prop.js ***!
  \*******************************************************/
/*! exports provided: isBiologicalAssembly, AssemblySymmetry, getSymmetrySelectParam, AssemblySymmetryDataParams, AssemblySymmetryDataProvider, AssemblySymmetryParams, AssemblySymmetryProvider */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isBiologicalAssembly", function() { return isBiologicalAssembly; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "AssemblySymmetry", function() { return AssemblySymmetry; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getSymmetrySelectParam", function() { return getSymmetrySelectParam; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "AssemblySymmetryDataParams", function() { return AssemblySymmetryDataParams; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "AssemblySymmetryDataProvider", function() { return AssemblySymmetryDataProvider; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "AssemblySymmetryParams", function() { return AssemblySymmetryParams; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "AssemblySymmetryProvider", function() { return AssemblySymmetryProvider; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _graphql_symmetry_gql__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../graphql/symmetry.gql */ "./lib/extensions/rcsb/graphql/symmetry.gql.js");
/* harmony import */ var _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../../mol-util/param-definition */ "./lib/mol-util/param-definition.js");
/* harmony import */ var _mol_model_structure__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../../mol-model/structure */ "./lib/mol-model/structure.js");
/* harmony import */ var _mol_data_db__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../../mol-data/db */ "./lib/mol-data/db.js");
/* harmony import */ var _mol_util_graphql_client__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../../mol-util/graphql-client */ "./lib/mol-util/graphql-client.js");
/* harmony import */ var _mol_model_props_common_custom_structure_property__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../../../mol-model-props/common/custom-structure-property */ "./lib/mol-model-props/common/custom-structure-property.js");
/* harmony import */ var _mol_model_formats_structure_mmcif__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../../../mol-model-formats/structure/mmcif */ "./lib/mol-model-formats/structure/mmcif.js");
/* harmony import */ var _mol_util_set__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ../../../mol-util/set */ "./lib/mol-util/set.js");
/* harmony import */ var _mol_script_language_builder__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ../../../mol-script/language/builder */ "./lib/mol-script/language/builder.js");
/* harmony import */ var _mol_script_runtime_query_compiler__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ../../../mol-script/runtime/query/compiler */ "./lib/mol-script/runtime/query/compiler.js");
/* harmony import */ var _mol_model_custom_property__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ../../../mol-model/custom-property */ "./lib/mol-model/custom-property.js");
/**
 * Copyright (c) 2018-2020 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */












var BiologicalAssemblyNames = new Set([
    'author_and_software_defined_assembly',
    'author_defined_assembly',
    'complete icosahedral assembly',
    'complete point assembly',
    'representative helical assembly',
    'software_defined_assembly'
]);
function isBiologicalAssembly(structure) {
    var _a;
    if (!_mol_model_formats_structure_mmcif__WEBPACK_IMPORTED_MODULE_7__["MmcifFormat"].is(structure.models[0].sourceData))
        return false;
    var mmcif = structure.models[0].sourceData.data.db;
    if (!mmcif.pdbx_struct_assembly.details.isDefined)
        return false;
    var id = ((_a = structure.units[0].conformation.operator.assembly) === null || _a === void 0 ? void 0 : _a.id) || '';
    if (id === '')
        return true;
    var indices = _mol_data_db__WEBPACK_IMPORTED_MODULE_4__["Column"].indicesOf(mmcif.pdbx_struct_assembly.id, function (e) { return e === id; });
    if (indices.length !== 1)
        return false;
    var details = mmcif.pdbx_struct_assembly.details.value(indices[0]);
    return BiologicalAssemblyNames.has(details);
}
var AssemblySymmetry;
(function (AssemblySymmetry) {
    var Tag;
    (function (Tag) {
        Tag["Cluster"] = "rcsb-assembly-symmetry-cluster";
        Tag["Representation"] = "rcsb-assembly-symmetry-3d";
    })(Tag = AssemblySymmetry.Tag || (AssemblySymmetry.Tag = {}));
    AssemblySymmetry.DefaultServerUrl = 'https://data.rcsb.org/graphql';
    function isApplicable(structure) {
        return (!!structure && structure.models.length === 1 &&
            _mol_model_structure__WEBPACK_IMPORTED_MODULE_3__["Model"].isFromPdbArchive(structure.models[0]) &&
            isBiologicalAssembly(structure));
    }
    AssemblySymmetry.isApplicable = isApplicable;
    function fetch(ctx, structure, props) {
        var _a, _b;
        return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"])(this, void 0, void 0, function () {
            var client, variables, result, value;
            return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__generator"])(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        if (!isApplicable(structure))
                            return [2 /*return*/, { value: [] }];
                        client = new _mol_util_graphql_client__WEBPACK_IMPORTED_MODULE_5__["GraphQLClient"](props.serverUrl, ctx.assetManager);
                        variables = {
                            assembly_id: ((_a = structure.units[0].conformation.operator.assembly) === null || _a === void 0 ? void 0 : _a.id) || '',
                            entry_id: structure.units[0].model.entryId
                        };
                        return [4 /*yield*/, client.request(ctx.runtime, _graphql_symmetry_gql__WEBPACK_IMPORTED_MODULE_1__["default"], variables)];
                    case 1:
                        result = _c.sent();
                        value = [];
                        if (!((_b = result.data.assembly) === null || _b === void 0 ? void 0 : _b.rcsb_struct_symmetry)) {
                            console.error('expected `rcsb_struct_symmetry` field');
                        }
                        else {
                            value = result.data.assembly.rcsb_struct_symmetry;
                        }
                        return [2 /*return*/, { value: value, assets: [result] }];
                }
            });
        });
    }
    AssemblySymmetry.fetch = fetch;
    /** Returns the index of the first non C1 symmetry or -1 */
    function firstNonC1(assemblySymmetryData) {
        for (var i = 0, il = assemblySymmetryData.length; i < il; ++i) {
            if (assemblySymmetryData[i].symbol !== 'C1')
                return i;
        }
        return -1;
    }
    AssemblySymmetry.firstNonC1 = firstNonC1;
    function isRotationAxes(x) {
        return !!x && x.length > 0;
    }
    AssemblySymmetry.isRotationAxes = isRotationAxes;
    function getAsymIds(assemblySymmetry) {
        var asymIds = new Set();
        for (var _i = 0, _a = assemblySymmetry.clusters; _i < _a.length; _i++) {
            var c = _a[_i];
            if (!(c === null || c === void 0 ? void 0 : c.members))
                continue;
            for (var _b = 0, _c = c.members; _b < _c.length; _b++) {
                var m = _c[_b];
                if (m === null || m === void 0 ? void 0 : m.asym_id)
                    asymIds.add(m.asym_id);
            }
        }
        return _mol_util_set__WEBPACK_IMPORTED_MODULE_8__["SetUtils"].toArray(asymIds);
    }
    AssemblySymmetry.getAsymIds = getAsymIds;
    function getAsymIdsStructure(structure, asymIds) {
        var query = _mol_script_language_builder__WEBPACK_IMPORTED_MODULE_9__["MolScriptBuilder"].struct.modifier.union([
            _mol_script_language_builder__WEBPACK_IMPORTED_MODULE_9__["MolScriptBuilder"].struct.generator.atomGroups({
                'chain-test': _mol_script_language_builder__WEBPACK_IMPORTED_MODULE_9__["MolScriptBuilder"].core.set.has([_mol_script_language_builder__WEBPACK_IMPORTED_MODULE_9__["MolScriptBuilder"].set.apply(_mol_script_language_builder__WEBPACK_IMPORTED_MODULE_9__["MolScriptBuilder"], asymIds), _mol_script_language_builder__WEBPACK_IMPORTED_MODULE_9__["MolScriptBuilder"].ammp('label_asym_id')])
            })
        ]);
        var compiled = Object(_mol_script_runtime_query_compiler__WEBPACK_IMPORTED_MODULE_10__["compile"])(query);
        var result = compiled(new _mol_model_structure__WEBPACK_IMPORTED_MODULE_3__["QueryContext"](structure));
        return _mol_model_structure__WEBPACK_IMPORTED_MODULE_3__["StructureSelection"].unionStructure(result);
    }
    /** Returns structure limited to all cluster member chains */
    function getStructure(structure, assemblySymmetry) {
        var asymIds = AssemblySymmetry.getAsymIds(assemblySymmetry);
        return asymIds.length > 0 ? getAsymIdsStructure(structure, asymIds) : structure;
    }
    AssemblySymmetry.getStructure = getStructure;
})(AssemblySymmetry || (AssemblySymmetry = {}));
function getSymmetrySelectParam(structure) {
    var param = _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_2__["ParamDefinition"].Select(0, [[0, 'First Symmetry']]);
    if (structure) {
        var assemblySymmetryData = AssemblySymmetryDataProvider.get(structure).value;
        if (assemblySymmetryData) {
            var options = [];
            for (var i = 0, il = assemblySymmetryData.length; i < il; ++i) {
                var _a = assemblySymmetryData[i], symbol = _a.symbol, kind = _a.kind;
                if (symbol !== 'C1') {
                    options.push([i, i + 1 + ": " + symbol + " " + kind]);
                }
            }
            if (options.length) {
                param.options = options;
                param.defaultValue = options[0][0];
            }
        }
    }
    return param;
}
//
var AssemblySymmetryDataParams = {
    serverUrl: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_2__["ParamDefinition"].Text(AssemblySymmetry.DefaultServerUrl, { description: 'GraphQL endpoint URL' })
};
var AssemblySymmetryDataProvider = _mol_model_props_common_custom_structure_property__WEBPACK_IMPORTED_MODULE_6__["CustomStructureProperty"].createProvider({
    label: 'Assembly Symmetry Data',
    descriptor: Object(_mol_model_custom_property__WEBPACK_IMPORTED_MODULE_11__["CustomPropertyDescriptor"])({
        name: 'rcsb_struct_symmetry_data',
    }),
    type: 'root',
    defaultParams: AssemblySymmetryDataParams,
    getParams: function (data) { return AssemblySymmetryDataParams; },
    isApplicable: function (data) { return AssemblySymmetry.isApplicable(data); },
    obtain: function (ctx, data, props) { return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"])(void 0, void 0, void 0, function () {
        var p;
        return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__generator"])(this, function (_a) {
            switch (_a.label) {
                case 0:
                    p = Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_2__["ParamDefinition"].getDefaultValues(AssemblySymmetryDataParams)), props);
                    return [4 /*yield*/, AssemblySymmetry.fetch(ctx, data, p)];
                case 1: return [2 /*return*/, _a.sent()];
            }
        });
    }); }
});
//
function getAssemblySymmetryParams(data) {
    return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, AssemblySymmetryDataParams), { symmetryIndex: getSymmetrySelectParam(data) });
}
var AssemblySymmetryParams = getAssemblySymmetryParams();
var AssemblySymmetryProvider = _mol_model_props_common_custom_structure_property__WEBPACK_IMPORTED_MODULE_6__["CustomStructureProperty"].createProvider({
    label: 'Assembly Symmetry',
    descriptor: Object(_mol_model_custom_property__WEBPACK_IMPORTED_MODULE_11__["CustomPropertyDescriptor"])({
        name: 'rcsb_struct_symmetry',
    }),
    type: 'root',
    defaultParams: AssemblySymmetryParams,
    getParams: getAssemblySymmetryParams,
    isApplicable: function (data) { return AssemblySymmetry.isApplicable(data); },
    obtain: function (ctx, data, props) { return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"])(void 0, void 0, void 0, function () {
        var p, assemblySymmetryData, assemblySymmetry;
        return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__generator"])(this, function (_a) {
            switch (_a.label) {
                case 0:
                    p = Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_2__["ParamDefinition"].getDefaultValues(getAssemblySymmetryParams(data))), props);
                    return [4 /*yield*/, AssemblySymmetryDataProvider.attach(ctx, data, p)];
                case 1:
                    _a.sent();
                    assemblySymmetryData = AssemblySymmetryDataProvider.get(data).value;
                    assemblySymmetry = assemblySymmetryData === null || assemblySymmetryData === void 0 ? void 0 : assemblySymmetryData[p.symmetryIndex];
                    if (!assemblySymmetry)
                        new Error("No assembly symmetry found for index " + p.symmetryIndex);
                    return [2 /*return*/, { value: assemblySymmetry }];
            }
        });
    }); }
});
//# sourceMappingURL=prop.js.map

/***/ }),

/***/ "./lib/extensions/rcsb/assembly-symmetry/representation.js":
/*!*****************************************************************!*\
  !*** ./lib/extensions/rcsb/assembly-symmetry/representation.js ***!
  \*****************************************************************/
/*! exports provided: AssemblySymmetryParams, AssemblySymmetryRepresentation */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "AssemblySymmetryParams", function() { return AssemblySymmetryParams; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "AssemblySymmetryRepresentation", function() { return AssemblySymmetryRepresentation; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../../mol-util/param-definition */ "./lib/mol-util/param-definition.js");
/* harmony import */ var _prop__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./prop */ "./lib/extensions/rcsb/assembly-symmetry/prop.js");
/* harmony import */ var _mol_geo_geometry_mesh_mesh_builder__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../../mol-geo/geometry/mesh/mesh-builder */ "./lib/mol-geo/geometry/mesh/mesh-builder.js");
/* harmony import */ var _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../../mol-math/linear-algebra */ "./lib/mol-math/linear-algebra.js");
/* harmony import */ var _mol_geo_geometry_mesh_builder_cylinder__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../../mol-geo/geometry/mesh/builder/cylinder */ "./lib/mol-geo/geometry/mesh/builder/cylinder.js");
/* harmony import */ var _mol_geo_geometry_mesh_mesh__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../../../mol-geo/geometry/mesh/mesh */ "./lib/mol-geo/geometry/mesh/mesh.js");
/* harmony import */ var _mol_model_shape__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../../../mol-model/shape */ "./lib/mol-model/shape.js");
/* harmony import */ var _mol_util_color_names__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ../../../mol-util/color/names */ "./lib/mol-util/color/names.js");
/* harmony import */ var _mol_repr_shape_representation__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ../../../mol-repr/shape/representation */ "./lib/mol-repr/shape/representation.js");
/* harmony import */ var _mol_util_marker_action__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ../../../mol-util/marker-action */ "./lib/mol-util/marker-action.js");
/* harmony import */ var _mol_geo_primitive_prism__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ../../../mol-geo/primitive/prism */ "./lib/mol-geo/primitive/prism.js");
/* harmony import */ var _mol_geo_primitive_wedge__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! ../../../mol-geo/primitive/wedge */ "./lib/mol-geo/primitive/wedge.js");
/* harmony import */ var _mol_geo_primitive_primitive__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! ../../../mol-geo/primitive/primitive */ "./lib/mol-geo/primitive/primitive.js");
/* harmony import */ var _mol_util_memoize__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! ../../../mol-util/memoize */ "./lib/mol-util/memoize.js");
/* harmony import */ var _mol_geo_primitive_polygon__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! ../../../mol-geo/primitive/polygon */ "./lib/mol-geo/primitive/polygon.js");
/* harmony import */ var _mol_util_color__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(/*! ../../../mol-util/color */ "./lib/mol-util/color/index.js");
/* harmony import */ var _mol_util_legend__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(/*! ../../../mol-util/legend */ "./lib/mol-util/legend.js");
/* harmony import */ var _mol_repr_representation__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(/*! ../../../mol-repr/representation */ "./lib/mol-repr/representation.js");
/* harmony import */ var _mol_geo_primitive_cage__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(/*! ../../../mol-geo/primitive/cage */ "./lib/mol-geo/primitive/cage.js");
/* harmony import */ var _mol_geo_primitive_octahedron__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(/*! ../../../mol-geo/primitive/octahedron */ "./lib/mol-geo/primitive/octahedron.js");
/* harmony import */ var _mol_geo_primitive_tetrahedron__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(/*! ../../../mol-geo/primitive/tetrahedron */ "./lib/mol-geo/primitive/tetrahedron.js");
/* harmony import */ var _mol_geo_primitive_icosahedron__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(/*! ../../../mol-geo/primitive/icosahedron */ "./lib/mol-geo/primitive/icosahedron.js");
/* harmony import */ var _mol_math_misc__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(/*! ../../../mol-math/misc */ "./lib/mol-math/misc.js");
/* harmony import */ var _mol_math_linear_algebra_3d_common__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(/*! ../../../mol-math/linear-algebra/3d/common */ "./lib/mol-math/linear-algebra/3d/common.js");
/* harmony import */ var _mol_util_number__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__(/*! ../../../mol-util/number */ "./lib/mol-util/number.js");
/* harmony import */ var _mol_math_geometry__WEBPACK_IMPORTED_MODULE_26__ = __webpack_require__(/*! ../../../mol-math/geometry */ "./lib/mol-math/geometry.js");
/**
 * Copyright (c) 2018-2020 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */



























var OrderColors = Object(_mol_util_color__WEBPACK_IMPORTED_MODULE_16__["ColorMap"])({
    '2': _mol_util_color_names__WEBPACK_IMPORTED_MODULE_8__["ColorNames"].deepskyblue,
    '3': _mol_util_color_names__WEBPACK_IMPORTED_MODULE_8__["ColorNames"].lime,
    'N': _mol_util_color_names__WEBPACK_IMPORTED_MODULE_8__["ColorNames"].red,
});
var OrderColorsLegend = Object(_mol_util_legend__WEBPACK_IMPORTED_MODULE_17__["TableLegend"])(Object.keys(OrderColors).map(function (name) {
    return [name, OrderColors[name]];
}));
function axesColorHelp(value) {
    return value.name === 'byOrder'
        ? { description: 'Color axes by their order', legend: OrderColorsLegend }
        : {};
}
var SharedParams = Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, _mol_geo_geometry_mesh_mesh__WEBPACK_IMPORTED_MODULE_6__["Mesh"].Params), { scale: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_1__["ParamDefinition"].Numeric(2, { min: 0.1, max: 5, step: 0.1 }) });
var AxesParams = Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, SharedParams), { axesColor: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_1__["ParamDefinition"].MappedStatic('byOrder', {
        byOrder: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_1__["ParamDefinition"].EmptyGroup(),
        uniform: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_1__["ParamDefinition"].Group({
            colorValue: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_1__["ParamDefinition"].Color(_mol_util_color_names__WEBPACK_IMPORTED_MODULE_8__["ColorNames"].orange),
        }, { isFlat: true })
    }, { help: axesColorHelp }) });
var CageParams = Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, SharedParams), { cageColor: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_1__["ParamDefinition"].Color(_mol_util_color_names__WEBPACK_IMPORTED_MODULE_8__["ColorNames"].orange) });
var AssemblySymmetryVisuals = {
    // cage should come before 'axes' so that the representative loci uses the cage shape
    'cage': function (ctx, getParams) { return Object(_mol_repr_shape_representation__WEBPACK_IMPORTED_MODULE_9__["ShapeRepresentation"])(getCageShape, _mol_geo_geometry_mesh_mesh__WEBPACK_IMPORTED_MODULE_6__["Mesh"].Utils, { modifyState: function (s) { return (Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, s), { markerActions: _mol_util_marker_action__WEBPACK_IMPORTED_MODULE_10__["MarkerActions"].Highlighting })); } }); },
    'axes': function (ctx, getParams) { return Object(_mol_repr_shape_representation__WEBPACK_IMPORTED_MODULE_9__["ShapeRepresentation"])(getAxesShape, _mol_geo_geometry_mesh_mesh__WEBPACK_IMPORTED_MODULE_6__["Mesh"].Utils, { modifyState: function (s) { return (Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, s), { markerActions: _mol_util_marker_action__WEBPACK_IMPORTED_MODULE_10__["MarkerActions"].Highlighting })); } }); },
};
var AssemblySymmetryParams = Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, AxesParams), CageParams), { visuals: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_1__["ParamDefinition"].MultiSelect(['axes', 'cage'], _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_1__["ParamDefinition"].objectToOptions(AssemblySymmetryVisuals)) });
//
function getAssemblyName(s) {
    var _a;
    var id = ((_a = s.units[0].conformation.operator.assembly) === null || _a === void 0 ? void 0 : _a.id) || '';
    return Object(_mol_util_number__WEBPACK_IMPORTED_MODULE_25__["isInteger"])(id) ? "Assembly " + id : id;
}
var t = _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_4__["Mat4"].identity();
var tmpV = Object(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_4__["Vec3"])();
var tmpCenter = Object(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_4__["Vec3"])();
var tmpScale = Object(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_4__["Vec3"])();
var getOrderPrimitive = Object(_mol_util_memoize__WEBPACK_IMPORTED_MODULE_14__["memoize1"])(function (order) {
    if (order < 2) {
        return Object(_mol_geo_primitive_prism__WEBPACK_IMPORTED_MODULE_11__["Prism"])(Object(_mol_geo_primitive_polygon__WEBPACK_IMPORTED_MODULE_15__["polygon"])(48, false));
    }
    else if (order === 2) {
        var lens = Object(_mol_geo_primitive_prism__WEBPACK_IMPORTED_MODULE_11__["Prism"])(Object(_mol_geo_primitive_polygon__WEBPACK_IMPORTED_MODULE_15__["polygon"])(48, false));
        var m = _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_4__["Mat4"].identity();
        _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_4__["Mat4"].scale(m, m, _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_4__["Vec3"].create(1, 0.35, 1));
        Object(_mol_geo_primitive_primitive__WEBPACK_IMPORTED_MODULE_13__["transformPrimitive"])(lens, m);
        return lens;
    }
    else if (order === 3) {
        return Object(_mol_geo_primitive_wedge__WEBPACK_IMPORTED_MODULE_12__["Wedge"])();
    }
    else {
        return Object(_mol_geo_primitive_prism__WEBPACK_IMPORTED_MODULE_11__["Prism"])(Object(_mol_geo_primitive_polygon__WEBPACK_IMPORTED_MODULE_15__["polygon"])(order, false));
    }
});
function getAxesMesh(data, props, mesh) {
    var scale = props.scale;
    var rotation_axes = data.rotation_axes;
    if (!_prop__WEBPACK_IMPORTED_MODULE_2__["AssemblySymmetry"].isRotationAxes(rotation_axes))
        return _mol_geo_geometry_mesh_mesh__WEBPACK_IMPORTED_MODULE_6__["Mesh"].createEmpty(mesh);
    var _a = rotation_axes[0], start = _a.start, end = _a.end;
    var radius = (_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_4__["Vec3"].distance(start, end) / 500) * scale;
    _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_4__["Vec3"].set(tmpScale, radius * 7, radius * 7, radius * 0.4);
    var cylinderProps = { radiusTop: radius, radiusBottom: radius };
    var builderState = _mol_geo_geometry_mesh_mesh_builder__WEBPACK_IMPORTED_MODULE_3__["MeshBuilder"].createState(256, 128, mesh);
    builderState.currentGroup = 0;
    _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_4__["Vec3"].scale(tmpCenter, _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_4__["Vec3"].add(tmpCenter, start, end), 0.5);
    for (var i = 0, il = rotation_axes.length; i < il; ++i) {
        var _b = rotation_axes[i], order = _b.order, start_1 = _b.start, end_1 = _b.end;
        builderState.currentGroup = i;
        Object(_mol_geo_geometry_mesh_builder_cylinder__WEBPACK_IMPORTED_MODULE_5__["addCylinder"])(builderState, start_1, end_1, 1, cylinderProps);
        var primitive = getOrderPrimitive(order);
        if (primitive) {
            _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_4__["Vec3"].scale(tmpCenter, _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_4__["Vec3"].add(tmpCenter, start_1, end_1), 0.5);
            if (_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_4__["Vec3"].dot(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_4__["Vec3"].unitY, _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_4__["Vec3"].sub(tmpV, start_1, tmpCenter)) === 0) {
                _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_4__["Mat4"].targetTo(t, start_1, tmpCenter, _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_4__["Vec3"].unitY);
            }
            else {
                _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_4__["Mat4"].targetTo(t, start_1, tmpCenter, _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_4__["Vec3"].unitX);
            }
            _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_4__["Mat4"].scale(t, t, tmpScale);
            _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_4__["Mat4"].setTranslation(t, start_1);
            _mol_geo_geometry_mesh_mesh_builder__WEBPACK_IMPORTED_MODULE_3__["MeshBuilder"].addPrimitive(builderState, t, primitive);
            _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_4__["Mat4"].setTranslation(t, end_1);
            _mol_geo_geometry_mesh_mesh_builder__WEBPACK_IMPORTED_MODULE_3__["MeshBuilder"].addPrimitive(builderState, t, primitive);
        }
    }
    return _mol_geo_geometry_mesh_mesh_builder__WEBPACK_IMPORTED_MODULE_3__["MeshBuilder"].getMesh(builderState);
}
function getAxesShape(ctx, data, props, shape) {
    var assemblySymmetry = _prop__WEBPACK_IMPORTED_MODULE_2__["AssemblySymmetryProvider"].get(data).value;
    var geo = getAxesMesh(assemblySymmetry, props, shape && shape.geometry);
    var getColor = function (groupId) {
        var _a;
        if (props.axesColor.name === 'byOrder') {
            var rotation_axes = assemblySymmetry.rotation_axes;
            var order = (_a = rotation_axes[groupId]) === null || _a === void 0 ? void 0 : _a.order;
            if (order === 2)
                return OrderColors[2];
            else if (order === 3)
                return OrderColors[3];
            else
                return OrderColors.N;
        }
        else {
            return props.axesColor.params.colorValue;
        }
    };
    var getLabel = function (groupId) {
        var _a;
        var type = assemblySymmetry.type, symbol = assemblySymmetry.symbol, kind = assemblySymmetry.kind, rotation_axes = assemblySymmetry.rotation_axes;
        var order = (_a = rotation_axes[groupId]) === null || _a === void 0 ? void 0 : _a.order;
        return [
            "<small>" + data.model.entryId + "</small>",
            "<small>" + getAssemblyName(data) + "</small>",
            "Axis " + (groupId + 1) + " with Order " + order + " of " + type + " " + kind + " (" + symbol + ")"
        ].join(' | ');
    };
    return _mol_model_shape__WEBPACK_IMPORTED_MODULE_7__["Shape"].create('Axes', data, geo, getColor, function () { return 1; }, getLabel);
}
//
var getSymbolCage = Object(_mol_util_memoize__WEBPACK_IMPORTED_MODULE_14__["memoize1"])(function (symbol) {
    if (symbol.startsWith('D') || symbol.startsWith('C')) {
        // z axis is prism axis, x/y axes cut through edge midpoints
        var fold = parseInt(symbol.substr(1));
        var cage = void 0;
        if (fold === 2) {
            cage = Object(_mol_geo_primitive_prism__WEBPACK_IMPORTED_MODULE_11__["PrismCage"])(Object(_mol_geo_primitive_polygon__WEBPACK_IMPORTED_MODULE_15__["polygon"])(4, false));
        }
        else if (fold === 3) {
            cage = Object(_mol_geo_primitive_wedge__WEBPACK_IMPORTED_MODULE_12__["WedgeCage"])();
        }
        else if (fold > 3) {
            cage = Object(_mol_geo_primitive_prism__WEBPACK_IMPORTED_MODULE_11__["PrismCage"])(Object(_mol_geo_primitive_polygon__WEBPACK_IMPORTED_MODULE_15__["polygon"])(fold, false));
        }
        else {
            return;
        }
        if (fold % 2 === 0) {
            return cage;
        }
        else {
            var m = _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_4__["Mat4"].identity();
            _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_4__["Mat4"].rotate(m, m, 1 / fold * Math.PI / 2, _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_4__["Vec3"].unitZ);
            return Object(_mol_geo_primitive_cage__WEBPACK_IMPORTED_MODULE_19__["transformCage"])(Object(_mol_geo_primitive_cage__WEBPACK_IMPORTED_MODULE_19__["cloneCage"])(cage), m);
        }
    }
    else if (symbol === 'O') {
        // x/y/z axes cut through order 4 vertices
        return Object(_mol_geo_primitive_octahedron__WEBPACK_IMPORTED_MODULE_20__["OctahedronCage"])();
    }
    else if (symbol === 'I') {
        // z axis cut through order 5 vertex
        // x axis cut through edge midpoint
        var cage = Object(_mol_geo_primitive_icosahedron__WEBPACK_IMPORTED_MODULE_22__["IcosahedronCage"])();
        var m = _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_4__["Mat4"].identity();
        _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_4__["Mat4"].rotate(m, m, Object(_mol_math_misc__WEBPACK_IMPORTED_MODULE_23__["degToRad"])(31.7), _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_4__["Vec3"].unitX);
        return Object(_mol_geo_primitive_cage__WEBPACK_IMPORTED_MODULE_19__["transformCage"])(Object(_mol_geo_primitive_cage__WEBPACK_IMPORTED_MODULE_19__["cloneCage"])(cage), m);
    }
    else if (symbol === 'T') {
        // x/y/z axes cut through edge midpoints
        return Object(_mol_geo_primitive_tetrahedron__WEBPACK_IMPORTED_MODULE_21__["TetrahedronCage"])();
    }
});
function getSymbolScale(symbol) {
    if (symbol.startsWith('D') || symbol.startsWith('C')) {
        return 0.75;
    }
    else if (symbol === 'O') {
        return 1.2;
    }
    else if (symbol === 'I') {
        return 0.25;
    }
    else if (symbol === 'T') {
        return 0.8;
    }
    return 1;
}
function setSymbolTransform(t, symbol, axes, size, structure) {
    var eye = Object(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_4__["Vec3"])();
    var target = Object(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_4__["Vec3"])();
    var dir = Object(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_4__["Vec3"])();
    var up = Object(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_4__["Vec3"])();
    var pair = undefined;
    if (symbol.startsWith('C')) {
        pair = [axes[0]];
    }
    else if (symbol.startsWith('D')) {
        var fold_1 = parseInt(symbol.substr(1));
        if (fold_1 === 2) {
            pair = axes.filter(function (a) { return a.order === 2; });
        }
        else if (fold_1 >= 3) {
            var aN = axes.filter(function (a) { return a.order === fold_1; })[0];
            var a2 = axes.filter(function (a) { return a.order === 2; })[1];
            pair = [aN, a2];
        }
    }
    else if (symbol === 'O') {
        pair = axes.filter(function (a) { return a.order === 4; });
    }
    else if (symbol === 'I') {
        var a5 = axes.filter(function (a) { return a.order === 5; })[0];
        var a5dir = _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_4__["Vec3"].sub(Object(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_4__["Vec3"])(), a5.end, a5.start);
        pair = [a5];
        for (var _i = 0, _a = axes.filter(function (a) { return a.order === 3; }); _i < _a.length; _i++) {
            var a = _a[_i];
            var d = Object(_mol_math_misc__WEBPACK_IMPORTED_MODULE_23__["radToDeg"])(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_4__["Vec3"].angle(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_4__["Vec3"].sub(up, a.end, a.start), a5dir));
            if (!pair[1] && (Object(_mol_math_linear_algebra_3d_common__WEBPACK_IMPORTED_MODULE_24__["equalEps"])(d, 100.81, 0.1) || Object(_mol_math_linear_algebra_3d_common__WEBPACK_IMPORTED_MODULE_24__["equalEps"])(d, 79.19, 0.1))) {
                pair[1] = a;
                break;
            }
        }
    }
    else if (symbol === 'T') {
        pair = axes.filter(function (a) { return a.order === 2; });
    }
    _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_4__["Mat4"].setIdentity(t);
    if (pair) {
        var aA = pair[0], aB = pair[1];
        _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_4__["Vec3"].scale(eye, _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_4__["Vec3"].add(eye, aA.end, aA.start), 0.5);
        _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_4__["Vec3"].copy(target, aA.end);
        if (aB) {
            _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_4__["Vec3"].sub(up, aB.end, aB.start);
            _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_4__["Vec3"].sub(dir, eye, target);
            if (_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_4__["Vec3"].dot(dir, up) < 0)
                _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_4__["Vec3"].negate(up, up);
            _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_4__["Mat4"].targetTo(t, eye, target, up);
            if (symbol.startsWith('D')) {
                var sphere = structure.lookup3d.boundary.sphere;
                var sizeXY = (sphere.radius * 2) * 0.8; // fallback for missing extrema
                if (_mol_math_geometry__WEBPACK_IMPORTED_MODULE_26__["Sphere3D"].hasExtrema(sphere)) {
                    var n_1 = _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_4__["Mat3"].directionTransform(Object(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_4__["Mat3"])(), t);
                    var dirs = unitCircleDirections.map(function (d) { return _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_4__["Vec3"].transformMat3(Object(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_4__["Vec3"])(), d, n_1); });
                    sizeXY = getMaxProjectedDistance(sphere.extrema, dirs, sphere.center) * 1.6;
                }
                _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_4__["Mat4"].scale(t, t, _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_4__["Vec3"].create(sizeXY, sizeXY, _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_4__["Vec3"].distance(aA.start, aA.end) * 0.9));
            }
            else {
                _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_4__["Mat4"].scaleUniformly(t, t, size * getSymbolScale(symbol));
            }
        }
        else {
            if (_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_4__["Vec3"].dot(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_4__["Vec3"].unitY, _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_4__["Vec3"].sub(tmpV, aA.end, aA.start)) === 0) {
                _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_4__["Vec3"].copy(up, _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_4__["Vec3"].unitY);
            }
            else {
                _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_4__["Vec3"].copy(up, _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_4__["Vec3"].unitX);
            }
            _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_4__["Mat4"].targetTo(t, eye, target, up);
            var sphere = structure.lookup3d.boundary.sphere;
            var sizeXY = (sphere.radius * 2) * 0.8; // fallback for missing extrema
            if (_mol_math_geometry__WEBPACK_IMPORTED_MODULE_26__["Sphere3D"].hasExtrema(sphere)) {
                var n_2 = _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_4__["Mat3"].directionTransform(Object(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_4__["Mat3"])(), t);
                var dirs = unitCircleDirections.map(function (d) { return _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_4__["Vec3"].transformMat3(Object(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_4__["Vec3"])(), d, n_2); });
                sizeXY = getMaxProjectedDistance(sphere.extrema, dirs, sphere.center);
            }
            _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_4__["Mat4"].scale(t, t, _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_4__["Vec3"].create(sizeXY, sizeXY, size * 0.9));
        }
    }
}
var unitCircleDirections = (function () {
    var dirs = [];
    var circle = Object(_mol_geo_primitive_polygon__WEBPACK_IMPORTED_MODULE_15__["polygon"])(12, false, 1);
    for (var i = 0, il = circle.length; i < il; i += 3) {
        dirs.push(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_4__["Vec3"].fromArray(Object(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_4__["Vec3"])(), circle, i));
    }
    return dirs;
})();
var tmpProj = Object(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_4__["Vec3"])();
function getMaxProjectedDistance(points, directions, center) {
    var maxDist = 0;
    for (var _i = 0, points_1 = points; _i < points_1.length; _i++) {
        var p = points_1[_i];
        for (var _a = 0, directions_1 = directions; _a < directions_1.length; _a++) {
            var d = directions_1[_a];
            _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_4__["Vec3"].projectPointOnVector(tmpProj, p, d, center);
            var dist = _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_4__["Vec3"].distance(tmpProj, center);
            if (dist > maxDist)
                maxDist = dist;
        }
    }
    return maxDist;
}
function getCageMesh(data, props, mesh) {
    var assemblySymmetry = _prop__WEBPACK_IMPORTED_MODULE_2__["AssemblySymmetryProvider"].get(data).value;
    var scale = props.scale;
    var rotation_axes = assemblySymmetry.rotation_axes, symbol = assemblySymmetry.symbol;
    if (!_prop__WEBPACK_IMPORTED_MODULE_2__["AssemblySymmetry"].isRotationAxes(rotation_axes))
        return _mol_geo_geometry_mesh_mesh__WEBPACK_IMPORTED_MODULE_6__["Mesh"].createEmpty(mesh);
    var structure = _prop__WEBPACK_IMPORTED_MODULE_2__["AssemblySymmetry"].getStructure(data, assemblySymmetry);
    var cage = getSymbolCage(symbol);
    if (!cage)
        return _mol_geo_geometry_mesh_mesh__WEBPACK_IMPORTED_MODULE_6__["Mesh"].createEmpty(mesh);
    var _a = rotation_axes[0], start = _a.start, end = _a.end;
    var size = _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_4__["Vec3"].distance(start, end);
    var radius = (size / 500) * scale;
    var builderState = _mol_geo_geometry_mesh_mesh_builder__WEBPACK_IMPORTED_MODULE_3__["MeshBuilder"].createState(256, 128, mesh);
    builderState.currentGroup = 0;
    setSymbolTransform(t, symbol, rotation_axes, size, structure);
    _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_4__["Vec3"].scale(tmpCenter, _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_4__["Vec3"].add(tmpCenter, start, end), 0.5);
    _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_4__["Mat4"].setTranslation(t, tmpCenter);
    _mol_geo_geometry_mesh_mesh_builder__WEBPACK_IMPORTED_MODULE_3__["MeshBuilder"].addCage(builderState, t, cage, radius, 1, 8);
    return _mol_geo_geometry_mesh_mesh_builder__WEBPACK_IMPORTED_MODULE_3__["MeshBuilder"].getMesh(builderState);
}
function getCageShape(ctx, data, props, shape) {
    var assemblySymmetry = _prop__WEBPACK_IMPORTED_MODULE_2__["AssemblySymmetryProvider"].get(data).value;
    var geo = getCageMesh(data, props, shape && shape.geometry);
    var getColor = function (groupId) {
        return props.cageColor;
    };
    var getLabel = function (groupId) {
        var type = assemblySymmetry.type, symbol = assemblySymmetry.symbol, kind = assemblySymmetry.kind;
        data.model.entryId;
        return [
            "<small>" + data.model.entryId + "</small>",
            "<small>" + getAssemblyName(data) + "</small>",
            "Cage of " + type + " " + kind + " (" + symbol + ")"
        ].join(' | ');
    };
    return _mol_model_shape__WEBPACK_IMPORTED_MODULE_7__["Shape"].create('Cage', data, geo, getColor, function () { return 1; }, getLabel);
}
function AssemblySymmetryRepresentation(ctx, getParams) {
    return _mol_repr_representation__WEBPACK_IMPORTED_MODULE_18__["Representation"].createMulti('Assembly Symmetry', ctx, getParams, _mol_repr_representation__WEBPACK_IMPORTED_MODULE_18__["Representation"].StateBuilder, AssemblySymmetryVisuals);
}
//# sourceMappingURL=representation.js.map

/***/ }),

/***/ "./lib/extensions/rcsb/assembly-symmetry/ui.js":
/*!*****************************************************!*\
  !*** ./lib/extensions/rcsb/assembly-symmetry/ui.js ***!
  \*****************************************************/
/*! exports provided: AssemblySymmetryControls */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "AssemblySymmetryControls", function() { return AssemblySymmetryControls; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! react */ "./node_modules/react/index.js");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _mol_plugin_ui_base__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../../mol-plugin-ui/base */ "./lib/mol-plugin-ui/base.js");
/* harmony import */ var _mol_plugin_ui_state_apply_action__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../../mol-plugin-ui/state/apply-action */ "./lib/mol-plugin-ui/state/apply-action.js");
/* harmony import */ var _behavior__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./behavior */ "./lib/extensions/rcsb/assembly-symmetry/behavior.js");
/* harmony import */ var _prop__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./prop */ "./lib/extensions/rcsb/assembly-symmetry/prop.js");
/* harmony import */ var _mol_plugin_ui_controls_parameters__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../../../mol-plugin-ui/controls/parameters */ "./lib/mol-plugin-ui/controls/parameters.js");
/* harmony import */ var _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../../../mol-util/param-definition */ "./lib/mol-util/param-definition.js");
/* harmony import */ var _mol_plugin_state_manager_structure_hierarchy__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ../../../mol-plugin-state/manager/structure/hierarchy */ "./lib/mol-plugin-state/manager/structure/hierarchy.js");
/* harmony import */ var _mol_state__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ../../../mol-state */ "./lib/mol-state/index.js");
/* harmony import */ var _mol_plugin_state_objects__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ../../../mol-plugin-state/objects */ "./lib/mol-plugin-state/objects.js");
/* harmony import */ var _mol_task__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ../../../mol-task */ "./lib/mol-task/index.js");
/* harmony import */ var _mol_plugin_ui_controls_icons__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! ../../../mol-plugin-ui/controls/icons */ "./lib/mol-plugin-ui/controls/icons.js");
/**
 * Copyright (c) 2020 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */













var AssemblySymmetryControls = /** @class */ (function (_super) {
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__extends"])(AssemblySymmetryControls, _super);
    function AssemblySymmetryControls() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.paramsOnChange = function (options) {
            _this.updateAssemblySymmetry(options);
        };
        return _this;
    }
    AssemblySymmetryControls.prototype.defaultState = function () {
        return {
            header: 'Assembly Symmetry',
            isCollapsed: false,
            isBusy: false,
            isHidden: true,
            brand: { accent: 'cyan', svg: _mol_plugin_ui_controls_icons__WEBPACK_IMPORTED_MODULE_12__["ExtensionSvg"] }
        };
    };
    AssemblySymmetryControls.prototype.componentDidMount = function () {
        var _this = this;
        this.subscribe(this.plugin.managers.structure.hierarchy.behaviors.selection, function () {
            _this.setState({
                isHidden: !_this.canEnable(),
                description: _mol_plugin_state_manager_structure_hierarchy__WEBPACK_IMPORTED_MODULE_8__["StructureHierarchyManager"].getSelectedStructuresDescription(_this.plugin)
            });
        });
        this.subscribe(this.plugin.state.events.cell.stateUpdated, function (e) {
            if (e.cell.transform.transformer === _behavior__WEBPACK_IMPORTED_MODULE_4__["AssemblySymmetry3D"])
                _this.forceUpdate();
        });
        this.subscribe(this.plugin.behaviors.state.isBusy, function (v) { return _this.setState({ isBusy: v }); });
    };
    Object.defineProperty(AssemblySymmetryControls.prototype, "pivot", {
        get: function () {
            return this.plugin.managers.structure.hierarchy.selection.structures[0];
        },
        enumerable: false,
        configurable: true
    });
    AssemblySymmetryControls.prototype.canEnable = function () {
        var _a, _b;
        var selection = this.plugin.managers.structure.hierarchy.selection;
        if (selection.structures.length !== 1)
            return false;
        var pivot = this.pivot.cell;
        if (!pivot.obj)
            return false;
        return !!((_b = (_a = _behavior__WEBPACK_IMPORTED_MODULE_4__["InitAssemblySymmetry3D"].definition).isApplicable) === null || _b === void 0 ? void 0 : _b.call(_a, pivot.obj, pivot.transform, this.plugin));
    };
    AssemblySymmetryControls.prototype.renderEnable = function () {
        var pivot = this.pivot;
        if (!pivot.cell.parent)
            return null;
        return react__WEBPACK_IMPORTED_MODULE_1__["createElement"](_mol_plugin_ui_state_apply_action__WEBPACK_IMPORTED_MODULE_3__["ApplyActionControl"], { state: pivot.cell.parent, action: EnableAssemblySymmetry3D, initiallyCollapsed: true, nodeRef: pivot.cell.transform.ref, simpleApply: { header: 'Enable', icon: _mol_plugin_ui_controls_icons__WEBPACK_IMPORTED_MODULE_12__["CheckSvg"] } });
    };
    AssemblySymmetryControls.prototype.renderNoSymmetries = function () {
        return react__WEBPACK_IMPORTED_MODULE_1__["createElement"]("div", { className: 'msp-row-text' },
            react__WEBPACK_IMPORTED_MODULE_1__["createElement"]("div", null, "No Symmetries for Assembly"));
    };
    Object.defineProperty(AssemblySymmetryControls.prototype, "params", {
        get: function () {
            var _a;
            var structure = (_a = this.pivot.cell.obj) === null || _a === void 0 ? void 0 : _a.data;
            var params = _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_7__["ParamDefinition"].clone(structure ? _prop__WEBPACK_IMPORTED_MODULE_5__["AssemblySymmetryProvider"].getParams(structure) : _prop__WEBPACK_IMPORTED_MODULE_5__["AssemblySymmetryProvider"].defaultParams);
            params.serverUrl.isHidden = true;
            params.symmetryIndex.options = Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__spreadArrays"])([[-1, 'Off']], params.symmetryIndex.options);
            return params;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AssemblySymmetryControls.prototype, "values", {
        get: function () {
            var _a;
            var structure = (_a = this.pivot.cell.obj) === null || _a === void 0 ? void 0 : _a.data;
            if (structure) {
                return _prop__WEBPACK_IMPORTED_MODULE_5__["AssemblySymmetryProvider"].props(structure);
            }
            else {
                return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_7__["ParamDefinition"].getDefaultValues(_prop__WEBPACK_IMPORTED_MODULE_5__["AssemblySymmetryProvider"].defaultParams)), { symmetryIndex: -1 });
            }
        },
        enumerable: false,
        configurable: true
    });
    AssemblySymmetryControls.prototype.updateAssemblySymmetry = function (values) {
        var _a, _b, _c, _d;
        return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"])(this, void 0, void 0, function () {
            var s, currValues, b, pd, params, _i, _e, components, name_1;
            return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__generator"])(this, function (_f) {
                switch (_f.label) {
                    case 0:
                        s = this.pivot;
                        currValues = _prop__WEBPACK_IMPORTED_MODULE_5__["AssemblySymmetryProvider"].props(s.cell.obj.data);
                        if (_mol_util_param_definition__WEBPACK_IMPORTED_MODULE_7__["ParamDefinition"].areEqual(_prop__WEBPACK_IMPORTED_MODULE_5__["AssemblySymmetryProvider"].defaultParams, currValues, values))
                            return [2 /*return*/];
                        if (!s.properties) return [3 /*break*/, 2];
                        b = this.plugin.state.data.build();
                        b.to(s.properties.cell).update(function (old) {
                            old.properties[_prop__WEBPACK_IMPORTED_MODULE_5__["AssemblySymmetryProvider"].descriptor.name] = values;
                        });
                        return [4 /*yield*/, b.commit()];
                    case 1:
                        _f.sent();
                        return [3 /*break*/, 4];
                    case 2:
                        pd = this.plugin.customStructureProperties.getParams((_a = s.cell.obj) === null || _a === void 0 ? void 0 : _a.data);
                        params = _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_7__["ParamDefinition"].getDefaultValues(pd);
                        params.properties[_prop__WEBPACK_IMPORTED_MODULE_5__["AssemblySymmetryProvider"].descriptor.name] = values;
                        return [4 /*yield*/, this.plugin.builders.structure.insertStructureProperties(s.cell, params)];
                    case 3:
                        _f.sent();
                        _f.label = 4;
                    case 4:
                        _i = 0, _e = this.plugin.managers.structure.hierarchy.currentComponentGroups;
                        _f.label = 5;
                    case 5:
                        if (!(_i < _e.length)) return [3 /*break*/, 11];
                        components = _e[_i];
                        if (!(values.symmetryIndex === -1)) return [3 /*break*/, 8];
                        name_1 = (_d = (_c = (_b = components[0]) === null || _b === void 0 ? void 0 : _b.representations[0]) === null || _c === void 0 ? void 0 : _c.cell.transform.params) === null || _d === void 0 ? void 0 : _d.colorTheme.name;
                        if (!(name_1 === _prop__WEBPACK_IMPORTED_MODULE_5__["AssemblySymmetry"].Tag.Cluster)) return [3 /*break*/, 7];
                        return [4 /*yield*/, this.plugin.managers.structure.component.updateRepresentationsTheme(components, { color: 'default' })];
                    case 6:
                        _f.sent();
                        _f.label = 7;
                    case 7: return [3 /*break*/, 10];
                    case 8:
                        Object(_behavior__WEBPACK_IMPORTED_MODULE_4__["tryCreateAssemblySymmetry"])(this.plugin, s.cell);
                        return [4 /*yield*/, this.plugin.managers.structure.component.updateRepresentationsTheme(components, { color: _prop__WEBPACK_IMPORTED_MODULE_5__["AssemblySymmetry"].Tag.Cluster })];
                    case 9:
                        _f.sent();
                        _f.label = 10;
                    case 10:
                        _i++;
                        return [3 /*break*/, 5];
                    case 11: return [2 /*return*/];
                }
            });
        });
    };
    Object.defineProperty(AssemblySymmetryControls.prototype, "hasAssemblySymmetry3D", {
        get: function () {
            return !this.pivot.cell.parent || !!_mol_state__WEBPACK_IMPORTED_MODULE_9__["StateSelection"].findTagInSubtree(this.pivot.cell.parent.tree, this.pivot.cell.transform.ref, _prop__WEBPACK_IMPORTED_MODULE_5__["AssemblySymmetry"].Tag.Representation);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AssemblySymmetryControls.prototype, "enable", {
        get: function () {
            return !this.hasAssemblySymmetry3D && this.values.symmetryIndex !== -1;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AssemblySymmetryControls.prototype, "noSymmetries", {
        get: function () {
            var _a;
            var structure = (_a = this.pivot.cell.obj) === null || _a === void 0 ? void 0 : _a.data;
            var data = structure && _prop__WEBPACK_IMPORTED_MODULE_5__["AssemblySymmetryDataProvider"].get(structure).value;
            return data && data.filter(function (sym) { return sym.symbol !== 'C1'; }).length === 0;
        },
        enumerable: false,
        configurable: true
    });
    AssemblySymmetryControls.prototype.renderParams = function () {
        return react__WEBPACK_IMPORTED_MODULE_1__["createElement"](react__WEBPACK_IMPORTED_MODULE_1__["Fragment"], null,
            react__WEBPACK_IMPORTED_MODULE_1__["createElement"](_mol_plugin_ui_controls_parameters__WEBPACK_IMPORTED_MODULE_6__["ParameterControls"], { params: this.params, values: this.values, onChangeValues: this.paramsOnChange }));
    };
    AssemblySymmetryControls.prototype.renderControls = function () {
        if (!this.pivot)
            return null;
        if (this.noSymmetries)
            return this.renderNoSymmetries();
        if (this.enable)
            return this.renderEnable();
        return this.renderParams();
    };
    return AssemblySymmetryControls;
}(_mol_plugin_ui_base__WEBPACK_IMPORTED_MODULE_2__["CollapsableControls"]));

var EnableAssemblySymmetry3D = _mol_state__WEBPACK_IMPORTED_MODULE_9__["StateAction"].build({
    from: _mol_plugin_state_objects__WEBPACK_IMPORTED_MODULE_10__["PluginStateObject"].Molecule.Structure,
})(function (_a, plugin) {
    var a = _a.a, ref = _a.ref, state = _a.state;
    return _mol_task__WEBPACK_IMPORTED_MODULE_11__["Task"].create('Enable Assembly Symmetry', function (ctx) { return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"])(void 0, void 0, void 0, function () {
        return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__generator"])(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, _behavior__WEBPACK_IMPORTED_MODULE_4__["AssemblySymmetryPreset"].apply(ref, Object.create(null), plugin)];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    }); });
});
//# sourceMappingURL=ui.js.map

/***/ }),

/***/ "./lib/extensions/rcsb/graphql/symmetry.gql.js":
/*!*****************************************************!*\
  !*** ./lib/extensions/rcsb/graphql/symmetry.gql.js ***!
  \*****************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (/* GraphQL */"\nquery AssemblySymmetry($assembly_id: String!, $entry_id: String!) {\n    assembly(assembly_id: $assembly_id, entry_id: $entry_id) {\n        rcsb_struct_symmetry {\n            clusters {\n                avg_rmsd\n                members {\n                    asym_id\n                    pdbx_struct_oper_list_ids\n                }\n            }\n            kind\n            oligomeric_state\n            rotation_axes {\n                order\n                start\n                end\n            }\n            stoichiometry\n            symbol\n            type\n        }\n    }\n}\n");
//# sourceMappingURL=symmetry.gql.js.map

/***/ }),

/***/ "./lib/extensions/rcsb/index.js":
/*!**************************************!*\
  !*** ./lib/extensions/rcsb/index.js ***!
  \**************************************/
/*! exports provided: RCSBAssemblySymmetry, RCSBValidationReport */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _assembly_symmetry_behavior__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./assembly-symmetry/behavior */ "./lib/extensions/rcsb/assembly-symmetry/behavior.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "RCSBAssemblySymmetry", function() { return _assembly_symmetry_behavior__WEBPACK_IMPORTED_MODULE_0__["RCSBAssemblySymmetry"]; });

/* harmony import */ var _validation_report_behavior__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./validation-report/behavior */ "./lib/extensions/rcsb/validation-report/behavior.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "RCSBValidationReport", function() { return _validation_report_behavior__WEBPACK_IMPORTED_MODULE_1__["RCSBValidationReport"]; });

/**
 * Copyright (c) 2020 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */


//# sourceMappingURL=index.js.map

/***/ }),

/***/ "./lib/extensions/rcsb/validation-report/behavior.js":
/*!***********************************************************!*\
  !*** ./lib/extensions/rcsb/validation-report/behavior.js ***!
  \***********************************************************/
/*! exports provided: RCSBValidationReport, ValidationReportGeometryQualityPreset, ValidationReportDensityFitPreset, ValidationReportRandomCoilIndexPreset */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "RCSBValidationReport", function() { return RCSBValidationReport; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ValidationReportGeometryQualityPreset", function() { return ValidationReportGeometryQualityPreset; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ValidationReportDensityFitPreset", function() { return ValidationReportDensityFitPreset; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ValidationReportRandomCoilIndexPreset", function() { return ValidationReportRandomCoilIndexPreset; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../../mol-util/param-definition */ "./lib/mol-util/param-definition.js");
/* harmony import */ var _mol_plugin_behavior_behavior__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../../mol-plugin/behavior/behavior */ "./lib/mol-plugin/behavior/behavior.js");
/* harmony import */ var _prop__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./prop */ "./lib/extensions/rcsb/validation-report/prop.js");
/* harmony import */ var _color_random_coil_index__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./color/random-coil-index */ "./lib/extensions/rcsb/validation-report/color/random-coil-index.js");
/* harmony import */ var _color_geometry_quality__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./color/geometry-quality */ "./lib/extensions/rcsb/validation-report/color/geometry-quality.js");
/* harmony import */ var _mol_data_int__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../../../mol-data/int */ "./lib/mol-data/int.js");
/* harmony import */ var _representation__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ./representation */ "./lib/extensions/rcsb/validation-report/representation.js");
/* harmony import */ var _color_density_fit__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ./color/density-fit */ "./lib/extensions/rcsb/validation-report/color/density-fit.js");
/* harmony import */ var _mol_data_util__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ../../../mol-data/util */ "./lib/mol-data/util.js");
/* harmony import */ var _mol_script_runtime_query_compiler__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ../../../mol-script/runtime/query/compiler */ "./lib/mol-script/runtime/query/compiler.js");
/* harmony import */ var _mol_plugin_state_helpers_structure_selection_query__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ../../../mol-plugin-state/helpers/structure-selection-query */ "./lib/mol-plugin-state/helpers/structure-selection-query.js");
/* harmony import */ var _mol_script_language_builder__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! ../../../mol-script/language/builder */ "./lib/mol-script/language/builder.js");
/* harmony import */ var _mol_task__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! ../../../mol-task */ "./lib/mol-task/index.js");
/* harmony import */ var _mol_plugin_state_builder_structure_representation_preset__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! ../../../mol-plugin-state/builder/structure/representation-preset */ "./lib/mol-plugin-state/builder/structure/representation-preset.js");
/* harmony import */ var _mol_state__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! ../../../mol-state */ "./lib/mol-state/index.js");
/* harmony import */ var _mol_model_structure__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(/*! ../../../mol-model/structure */ "./lib/mol-model/structure.js");
/**
 * Copyright (c) 2020 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */

















var RCSBValidationReport = _mol_plugin_behavior_behavior__WEBPACK_IMPORTED_MODULE_2__["PluginBehavior"].create({
    name: 'rcsb-validation-report-prop',
    category: 'custom-props',
    display: {
        name: 'Validation Report',
        description: 'Data from wwPDB Validation Report, obtained via RCSB PDB.'
    },
    ctor: /** @class */ (function (_super) {
        Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__extends"])(class_1, _super);
        function class_1() {
            var _this = _super !== null && _super.apply(this, arguments) || this;
            _this.provider = _prop__WEBPACK_IMPORTED_MODULE_3__["ValidationReportProvider"];
            _this.labelProvider = {
                label: function (loci) {
                    if (!_this.params.showTooltip)
                        return;
                    return [
                        geometryQualityLabel(loci),
                        densityFitLabel(loci),
                        randomCoilIndexLabel(loci)
                    ].filter(function (l) { return !!l; }).join('</br>');
                }
            };
            return _this;
        }
        class_1.prototype.register = function () {
            _mol_script_runtime_query_compiler__WEBPACK_IMPORTED_MODULE_10__["DefaultQueryRuntimeTable"].addCustomProp(this.provider.descriptor);
            this.ctx.customModelProperties.register(this.provider, this.params.autoAttach);
            this.ctx.managers.lociLabels.addProvider(this.labelProvider);
            this.ctx.representation.structure.themes.colorThemeRegistry.add(_color_density_fit__WEBPACK_IMPORTED_MODULE_8__["DensityFitColorThemeProvider"]);
            this.ctx.representation.structure.themes.colorThemeRegistry.add(_color_geometry_quality__WEBPACK_IMPORTED_MODULE_5__["GeometryQualityColorThemeProvider"]);
            this.ctx.representation.structure.themes.colorThemeRegistry.add(_color_random_coil_index__WEBPACK_IMPORTED_MODULE_4__["RandomCoilIndexColorThemeProvider"]);
            this.ctx.representation.structure.registry.add(_representation__WEBPACK_IMPORTED_MODULE_7__["ClashesRepresentationProvider"]);
            this.ctx.query.structure.registry.add(hasClash);
            this.ctx.builders.structure.representation.registerPreset(ValidationReportGeometryQualityPreset);
            this.ctx.builders.structure.representation.registerPreset(ValidationReportDensityFitPreset);
            this.ctx.builders.structure.representation.registerPreset(ValidationReportRandomCoilIndexPreset);
        };
        class_1.prototype.update = function (p) {
            var updated = this.params.autoAttach !== p.autoAttach;
            this.params.autoAttach = p.autoAttach;
            this.params.showTooltip = p.showTooltip;
            this.ctx.customStructureProperties.setDefaultAutoAttach(this.provider.descriptor.name, this.params.autoAttach);
            return updated;
        };
        class_1.prototype.unregister = function () {
            _mol_script_runtime_query_compiler__WEBPACK_IMPORTED_MODULE_10__["DefaultQueryRuntimeTable"].removeCustomProp(this.provider.descriptor);
            this.ctx.customStructureProperties.unregister(this.provider.descriptor.name);
            this.ctx.managers.lociLabels.removeProvider(this.labelProvider);
            this.ctx.representation.structure.themes.colorThemeRegistry.remove(_color_density_fit__WEBPACK_IMPORTED_MODULE_8__["DensityFitColorThemeProvider"]);
            this.ctx.representation.structure.themes.colorThemeRegistry.remove(_color_geometry_quality__WEBPACK_IMPORTED_MODULE_5__["GeometryQualityColorThemeProvider"]);
            this.ctx.representation.structure.themes.colorThemeRegistry.remove(_color_random_coil_index__WEBPACK_IMPORTED_MODULE_4__["RandomCoilIndexColorThemeProvider"]);
            this.ctx.representation.structure.registry.remove(_representation__WEBPACK_IMPORTED_MODULE_7__["ClashesRepresentationProvider"]);
            this.ctx.query.structure.registry.remove(hasClash);
            this.ctx.builders.structure.representation.unregisterPreset(ValidationReportGeometryQualityPreset);
            this.ctx.builders.structure.representation.unregisterPreset(ValidationReportDensityFitPreset);
            this.ctx.builders.structure.representation.unregisterPreset(ValidationReportRandomCoilIndexPreset);
        };
        return class_1;
    }(_mol_plugin_behavior_behavior__WEBPACK_IMPORTED_MODULE_2__["PluginBehavior"].Handler)),
    params: function () { return ({
        autoAttach: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_1__["ParamDefinition"].Boolean(false),
        showTooltip: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_1__["ParamDefinition"].Boolean(true),
        baseUrl: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_1__["ParamDefinition"].Text(_prop__WEBPACK_IMPORTED_MODULE_3__["ValidationReport"].DefaultBaseUrl)
    }); }
});
//
function geometryQualityLabel(loci) {
    if (loci.kind === 'element-loci') {
        if (loci.elements.length === 0)
            return;
        if (loci.elements.length === 1 && _mol_data_int__WEBPACK_IMPORTED_MODULE_6__["OrderedSet"].size(loci.elements[0].indices) === 1) {
            var _a = loci.elements[0], unit = _a.unit, indices = _a.indices;
            var validationReport = _prop__WEBPACK_IMPORTED_MODULE_3__["ValidationReportProvider"].get(unit.model).value;
            if (!validationReport)
                return;
            if (!unit.model.customProperties.hasReference(_prop__WEBPACK_IMPORTED_MODULE_3__["ValidationReportProvider"].descriptor))
                return;
            var bondOutliers_1 = validationReport.bondOutliers, angleOutliers_1 = validationReport.angleOutliers;
            var eI = unit.elements[_mol_data_int__WEBPACK_IMPORTED_MODULE_6__["OrderedSet"].start(indices)];
            var issues_1 = new Set();
            var bonds = bondOutliers_1.index.get(eI);
            if (bonds)
                bonds.forEach(function (b) { return issues_1.add(bondOutliers_1.data[b].tag); });
            var angles = angleOutliers_1.index.get(eI);
            if (angles)
                angles.forEach(function (a) { return issues_1.add(angleOutliers_1.data[a].tag); });
            if (issues_1.size === 0) {
                return "Geometry Quality <small>(1 Atom)</small>: no issues";
            }
            var summary_1 = [];
            issues_1.forEach(function (name) { return summary_1.push(name); });
            return "Geometry Quality <small>(1 Atom)</small>: " + summary_1.join(', ');
        }
        var hasValidationReport = false;
        var seen_1 = new Set();
        var cummulativeIssues_1 = new Map();
        var _loop_1 = function (indices, unit) {
            var validationReport = _prop__WEBPACK_IMPORTED_MODULE_3__["ValidationReportProvider"].get(unit.model).value;
            if (!validationReport)
                return "continue";
            if (!unit.model.customProperties.hasReference(_prop__WEBPACK_IMPORTED_MODULE_3__["ValidationReportProvider"].descriptor))
                return "continue";
            hasValidationReport = true;
            var geometryIssues = validationReport.geometryIssues;
            var residueIndex = unit.model.atomicHierarchy.residueAtomSegments.index;
            var elements = unit.elements;
            _mol_data_int__WEBPACK_IMPORTED_MODULE_6__["OrderedSet"].forEach(indices, function (idx) {
                var eI = elements[idx];
                var rI = residueIndex[eI];
                var residueKey = Object(_mol_data_util__WEBPACK_IMPORTED_MODULE_9__["cantorPairing"])(rI, unit.id);
                if (!seen_1.has(residueKey)) {
                    var issues = geometryIssues.get(rI);
                    if (issues) {
                        issues.forEach(function (name) {
                            var count = cummulativeIssues_1.get(name) || 0;
                            cummulativeIssues_1.set(name, count + 1);
                        });
                    }
                    seen_1.add(residueKey);
                }
            });
        };
        for (var _i = 0, _b = loci.elements; _i < _b.length; _i++) {
            var _c = _b[_i], indices = _c.indices, unit = _c.unit;
            _loop_1(indices, unit);
        }
        if (!hasValidationReport)
            return;
        var residueCount = "<small>(" + seen_1.size + " " + (seen_1.size > 1 ? 'Residues' : 'Residue') + ")</small>";
        if (cummulativeIssues_1.size === 0) {
            return "Geometry Quality " + residueCount + ": no issues";
        }
        var summary_2 = [];
        cummulativeIssues_1.forEach(function (count, name) {
            summary_2.push("" + name + (count > 1 ? " \u00D7 " + count : ''));
        });
        return "Geometry Quality " + residueCount + ": " + summary_2.join(', ');
    }
}
function densityFitLabel(loci) {
    if (loci.kind === 'element-loci') {
        if (loci.elements.length === 0)
            return;
        var seen_2 = new Set();
        var rsrzSeen_1 = new Set();
        var rsccSeen_1 = new Set();
        var rsrzSum_1 = 0;
        var rsccSum_1 = 0;
        var _loop_2 = function (indices, unit) {
            var validationReport = _prop__WEBPACK_IMPORTED_MODULE_3__["ValidationReportProvider"].get(unit.model).value;
            if (!validationReport)
                return "continue";
            if (!unit.model.customProperties.hasReference(_prop__WEBPACK_IMPORTED_MODULE_3__["ValidationReportProvider"].descriptor))
                return "continue";
            var rsrz = validationReport.rsrz, rscc = validationReport.rscc;
            var residueIndex = unit.model.atomicHierarchy.residueAtomSegments.index;
            var elements = unit.elements;
            _mol_data_int__WEBPACK_IMPORTED_MODULE_6__["OrderedSet"].forEach(indices, function (idx) {
                var eI = elements[idx];
                var rI = residueIndex[eI];
                var residueKey = Object(_mol_data_util__WEBPACK_IMPORTED_MODULE_9__["cantorPairing"])(rI, unit.id);
                if (!seen_2.has(residueKey)) {
                    var rsrzValue = rsrz.get(rI);
                    var rsccValue = rscc.get(rI);
                    if (rsrzValue !== undefined) {
                        rsrzSum_1 += rsrzValue;
                        rsrzSeen_1.add(residueKey);
                    }
                    else if (rsccValue !== undefined) {
                        rsccSum_1 += rsccValue;
                        rsccSeen_1.add(residueKey);
                    }
                    seen_2.add(residueKey);
                }
            });
        };
        for (var _i = 0, _a = loci.elements; _i < _a.length; _i++) {
            var _b = _a[_i], indices = _b.indices, unit = _b.unit;
            _loop_2(indices, unit);
        }
        if (seen_2.size === 0)
            return;
        var summary = [];
        if (rsrzSeen_1.size) {
            var rsrzCount = "<small>(" + rsrzSeen_1.size + " " + (rsrzSeen_1.size > 1 ? 'Residues avg.' : 'Residue') + ")</small>";
            var rsrzAvg = rsrzSum_1 / rsrzSeen_1.size;
            summary.push("Real-Space R Z-score " + rsrzCount + ": " + rsrzAvg.toFixed(2));
        }
        if (rsccSeen_1.size) {
            var rsccCount = "<small>(" + rsccSeen_1.size + " " + (rsccSeen_1.size > 1 ? 'Residues avg.' : 'Residue') + ")</small>";
            var rsccAvg = rsccSum_1 / rsccSeen_1.size;
            summary.push("Real-Space Correlation Coefficient " + rsccCount + ": " + rsccAvg.toFixed(2));
        }
        if (summary.length) {
            return summary.join('</br>');
        }
    }
}
function randomCoilIndexLabel(loci) {
    if (loci.kind === 'element-loci') {
        if (loci.elements.length === 0)
            return;
        var seen_3 = new Set();
        var sum_1 = 0;
        var _loop_3 = function (indices, unit) {
            var validationReport = _prop__WEBPACK_IMPORTED_MODULE_3__["ValidationReportProvider"].get(unit.model).value;
            if (!validationReport)
                return "continue";
            if (!unit.model.customProperties.hasReference(_prop__WEBPACK_IMPORTED_MODULE_3__["ValidationReportProvider"].descriptor))
                return "continue";
            var rci = validationReport.rci;
            var residueIndex = unit.model.atomicHierarchy.residueAtomSegments.index;
            var elements = unit.elements;
            _mol_data_int__WEBPACK_IMPORTED_MODULE_6__["OrderedSet"].forEach(indices, function (idx) {
                var eI = elements[idx];
                var rI = residueIndex[eI];
                var residueKey = Object(_mol_data_util__WEBPACK_IMPORTED_MODULE_9__["cantorPairing"])(rI, unit.id);
                if (!seen_3.has(residueKey)) {
                    var rciValue = rci.get(rI);
                    if (rciValue !== undefined) {
                        sum_1 += rciValue;
                        seen_3.add(residueKey);
                    }
                }
            });
        };
        for (var _i = 0, _a = loci.elements; _i < _a.length; _i++) {
            var _b = _a[_i], indices = _b.indices, unit = _b.unit;
            _loop_3(indices, unit);
        }
        if (seen_3.size === 0)
            return;
        var residueCount = "<small>(" + seen_3.size + " " + (seen_3.size > 1 ? 'Residues avg.' : 'Residue') + ")</small>";
        var rciAvg = sum_1 / seen_3.size;
        return "Random Coil Index " + residueCount + ": " + rciAvg.toFixed(2);
    }
}
//
var hasClash = Object(_mol_plugin_state_helpers_structure_selection_query__WEBPACK_IMPORTED_MODULE_11__["StructureSelectionQuery"])('Residues with Clashes', _mol_script_language_builder__WEBPACK_IMPORTED_MODULE_12__["MolScriptBuilder"].struct.modifier.union([
    _mol_script_language_builder__WEBPACK_IMPORTED_MODULE_12__["MolScriptBuilder"].struct.modifier.wholeResidues([
        _mol_script_language_builder__WEBPACK_IMPORTED_MODULE_12__["MolScriptBuilder"].struct.modifier.union([
            _mol_script_language_builder__WEBPACK_IMPORTED_MODULE_12__["MolScriptBuilder"].struct.generator.atomGroups({
                'chain-test': _mol_script_language_builder__WEBPACK_IMPORTED_MODULE_12__["MolScriptBuilder"].core.rel.eq([_mol_script_language_builder__WEBPACK_IMPORTED_MODULE_12__["MolScriptBuilder"].ammp('objectPrimitive'), 'atomistic']),
                'atom-test': _prop__WEBPACK_IMPORTED_MODULE_3__["ValidationReport"].symbols.hasClash.symbol(),
            })
        ])
    ])
]), {
    description: 'Select residues with clashes in the wwPDB validation report.',
    category: _mol_plugin_state_helpers_structure_selection_query__WEBPACK_IMPORTED_MODULE_11__["StructureSelectionCategory"].Residue,
    ensureCustomProperties: function (ctx, structure) {
        return _prop__WEBPACK_IMPORTED_MODULE_3__["ValidationReportProvider"].attach(ctx, structure.models[0]);
    }
});
//
var ValidationReportGeometryQualityPreset = Object(_mol_plugin_state_builder_structure_representation_preset__WEBPACK_IMPORTED_MODULE_14__["StructureRepresentationPresetProvider"])({
    id: 'preset-structure-representation-rcsb-validation-report-geometry-uality',
    display: {
        name: 'Validation Report (Geometry Quality)', group: 'Annotation',
        description: 'Color structure based on geometry quality; show geometry clashes. Data from wwPDB Validation Report, obtained via RCSB PDB.'
    },
    isApplicable: function (a) {
        return a.data.models.length === 1 && _prop__WEBPACK_IMPORTED_MODULE_3__["ValidationReport"].isApplicable(a.data.models[0]);
    },
    params: function () { return _mol_plugin_state_builder_structure_representation_preset__WEBPACK_IMPORTED_MODULE_14__["StructureRepresentationPresetProvider"].CommonParams; },
    apply: function (ref, params, plugin) {
        var _a;
        return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"])(this, void 0, void 0, function () {
            var structureCell, structure, colorTheme, _b, components, representations, clashes, _c, update, builder, typeParams, color, clashesBallAndStick, clashesRepr;
            var _this = this;
            return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__generator"])(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        structureCell = _mol_state__WEBPACK_IMPORTED_MODULE_15__["StateObjectRef"].resolveAndCheck(plugin.state.data, ref);
                        structure = (_a = structureCell === null || structureCell === void 0 ? void 0 : structureCell.obj) === null || _a === void 0 ? void 0 : _a.data;
                        if (!structureCell || !structure)
                            return [2 /*return*/, {}];
                        return [4 /*yield*/, plugin.runTask(_mol_task__WEBPACK_IMPORTED_MODULE_13__["Task"].create('Validation Report', function (runtime) { return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"])(_this, void 0, void 0, function () {
                                return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__generator"])(this, function (_a) {
                                    switch (_a.label) {
                                        case 0: return [4 /*yield*/, _prop__WEBPACK_IMPORTED_MODULE_3__["ValidationReportProvider"].attach({ runtime: runtime, assetManager: plugin.managers.asset }, structure.models[0])];
                                        case 1:
                                            _a.sent();
                                            return [2 /*return*/];
                                    }
                                });
                            }); }))];
                    case 1:
                        _d.sent();
                        colorTheme = _color_geometry_quality__WEBPACK_IMPORTED_MODULE_5__["GeometryQualityColorThemeProvider"].name;
                        return [4 /*yield*/, _mol_plugin_state_builder_structure_representation_preset__WEBPACK_IMPORTED_MODULE_14__["PresetStructureRepresentations"].auto.apply(ref, Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, params), { theme: { globalName: colorTheme, focus: { name: colorTheme } } }), plugin)];
                    case 2:
                        _b = _d.sent(), components = _b.components, representations = _b.representations;
                        return [4 /*yield*/, plugin.builders.structure.tryCreateComponentFromExpression(structureCell, hasClash.expression, 'clashes', { label: 'Clashes' })];
                    case 3:
                        clashes = _d.sent();
                        _c = _mol_plugin_state_builder_structure_representation_preset__WEBPACK_IMPORTED_MODULE_14__["StructureRepresentationPresetProvider"].reprBuilder(plugin, params), update = _c.update, builder = _c.builder, typeParams = _c.typeParams, color = _c.color;
                        if (representations) {
                            clashesBallAndStick = builder.buildRepresentation(update, clashes, { type: 'ball-and-stick', typeParams: typeParams, color: colorTheme }, { tag: 'clashes-ball-and-stick' });
                            clashesRepr = builder.buildRepresentation(update, clashes, { type: _representation__WEBPACK_IMPORTED_MODULE_7__["ClashesRepresentationProvider"].name, typeParams: typeParams, color: color }, { tag: 'clashes-repr' });
                        }
                        return [4 /*yield*/, update.commit({ revertOnError: true })];
                    case 4:
                        _d.sent();
                        return [2 /*return*/, { components: Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, components), { clashes: clashes }), representations: Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, representations), { clashesBallAndStick: clashesBallAndStick, clashesRepr: clashesRepr }) }];
                }
            });
        });
    }
});
var ValidationReportDensityFitPreset = Object(_mol_plugin_state_builder_structure_representation_preset__WEBPACK_IMPORTED_MODULE_14__["StructureRepresentationPresetProvider"])({
    id: 'preset-structure-representation-rcsb-validation-report-density-fit',
    display: {
        name: 'Validation Report (Density Fit)', group: 'Annotation',
        description: 'Color structure based on density fit. Data from wwPDB Validation Report, obtained via RCSB PDB.'
    },
    isApplicable: function (a) {
        return a.data.models.length === 1 && _prop__WEBPACK_IMPORTED_MODULE_3__["ValidationReport"].isApplicable(a.data.models[0]) && _mol_model_structure__WEBPACK_IMPORTED_MODULE_16__["Model"].isFromXray(a.data.models[0]) && _mol_model_structure__WEBPACK_IMPORTED_MODULE_16__["Model"].probablyHasDensityMap(a.data.models[0]);
    },
    params: function () { return _mol_plugin_state_builder_structure_representation_preset__WEBPACK_IMPORTED_MODULE_14__["StructureRepresentationPresetProvider"].CommonParams; },
    apply: function (ref, params, plugin) {
        var _a;
        return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"])(this, void 0, void 0, function () {
            var structureCell, structure, colorTheme;
            var _this = this;
            return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__generator"])(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        structureCell = _mol_state__WEBPACK_IMPORTED_MODULE_15__["StateObjectRef"].resolveAndCheck(plugin.state.data, ref);
                        structure = (_a = structureCell === null || structureCell === void 0 ? void 0 : structureCell.obj) === null || _a === void 0 ? void 0 : _a.data;
                        if (!structureCell || !structure)
                            return [2 /*return*/, {}];
                        return [4 /*yield*/, plugin.runTask(_mol_task__WEBPACK_IMPORTED_MODULE_13__["Task"].create('Validation Report', function (runtime) { return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"])(_this, void 0, void 0, function () {
                                return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__generator"])(this, function (_a) {
                                    switch (_a.label) {
                                        case 0: return [4 /*yield*/, _prop__WEBPACK_IMPORTED_MODULE_3__["ValidationReportProvider"].attach({ runtime: runtime, assetManager: plugin.managers.asset }, structure.models[0])];
                                        case 1:
                                            _a.sent();
                                            return [2 /*return*/];
                                    }
                                });
                            }); }))];
                    case 1:
                        _b.sent();
                        colorTheme = _color_density_fit__WEBPACK_IMPORTED_MODULE_8__["DensityFitColorThemeProvider"].name;
                        return [4 /*yield*/, _mol_plugin_state_builder_structure_representation_preset__WEBPACK_IMPORTED_MODULE_14__["PresetStructureRepresentations"].auto.apply(ref, Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, params), { theme: { globalName: colorTheme, focus: { name: colorTheme } } }), plugin)];
                    case 2: return [2 /*return*/, _b.sent()];
                }
            });
        });
    }
});
var ValidationReportRandomCoilIndexPreset = Object(_mol_plugin_state_builder_structure_representation_preset__WEBPACK_IMPORTED_MODULE_14__["StructureRepresentationPresetProvider"])({
    id: 'preset-structure-representation-rcsb-validation-report-random-coil-index',
    display: {
        name: 'Validation Report (Random Coil Index)', group: 'Annotation',
        description: 'Color structure based on Random Coil Index. Data from wwPDB Validation Report, obtained via RCSB PDB.'
    },
    isApplicable: function (a) {
        return a.data.models.length === 1 && _prop__WEBPACK_IMPORTED_MODULE_3__["ValidationReport"].isApplicable(a.data.models[0]) && _mol_model_structure__WEBPACK_IMPORTED_MODULE_16__["Model"].isFromNmr(a.data.models[0]);
    },
    params: function () { return _mol_plugin_state_builder_structure_representation_preset__WEBPACK_IMPORTED_MODULE_14__["StructureRepresentationPresetProvider"].CommonParams; },
    apply: function (ref, params, plugin) {
        var _a;
        return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"])(this, void 0, void 0, function () {
            var structureCell, structure, colorTheme;
            var _this = this;
            return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__generator"])(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        structureCell = _mol_state__WEBPACK_IMPORTED_MODULE_15__["StateObjectRef"].resolveAndCheck(plugin.state.data, ref);
                        structure = (_a = structureCell === null || structureCell === void 0 ? void 0 : structureCell.obj) === null || _a === void 0 ? void 0 : _a.data;
                        if (!structureCell || !structure)
                            return [2 /*return*/, {}];
                        return [4 /*yield*/, plugin.runTask(_mol_task__WEBPACK_IMPORTED_MODULE_13__["Task"].create('Validation Report', function (runtime) { return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"])(_this, void 0, void 0, function () {
                                return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__generator"])(this, function (_a) {
                                    switch (_a.label) {
                                        case 0: return [4 /*yield*/, _prop__WEBPACK_IMPORTED_MODULE_3__["ValidationReportProvider"].attach({ runtime: runtime, assetManager: plugin.managers.asset }, structure.models[0])];
                                        case 1:
                                            _a.sent();
                                            return [2 /*return*/];
                                    }
                                });
                            }); }))];
                    case 1:
                        _b.sent();
                        colorTheme = _color_random_coil_index__WEBPACK_IMPORTED_MODULE_4__["RandomCoilIndexColorThemeProvider"].name;
                        return [4 /*yield*/, _mol_plugin_state_builder_structure_representation_preset__WEBPACK_IMPORTED_MODULE_14__["PresetStructureRepresentations"].auto.apply(ref, Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, params), { theme: { globalName: colorTheme, focus: { name: colorTheme } } }), plugin)];
                    case 2: return [2 /*return*/, _b.sent()];
                }
            });
        });
    }
});
//# sourceMappingURL=behavior.js.map

/***/ }),

/***/ "./lib/extensions/rcsb/validation-report/color/density-fit.js":
/*!********************************************************************!*\
  !*** ./lib/extensions/rcsb/validation-report/color/density-fit.js ***!
  \********************************************************************/
/*! exports provided: DensityFitColorTheme, DensityFitColorThemeProvider */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DensityFitColorTheme", function() { return DensityFitColorTheme; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DensityFitColorThemeProvider", function() { return DensityFitColorThemeProvider; });
/* harmony import */ var _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../../../mol-util/param-definition */ "./lib/mol-util/param-definition.js");
/* harmony import */ var _mol_util_color__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../../../mol-util/color */ "./lib/mol-util/color/index.js");
/* harmony import */ var _mol_model_structure__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../../../mol-model/structure */ "./lib/mol-model/structure.js");
/* harmony import */ var _prop__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../prop */ "./lib/extensions/rcsb/validation-report/prop.js");
/**
 * Copyright (c) 2020 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */




var DefaultColor = Object(_mol_util_color__WEBPACK_IMPORTED_MODULE_1__["Color"])(0xCCCCCC);
function DensityFitColorTheme(ctx, props) {
    var _a;
    var color = function () { return DefaultColor; };
    var scaleRsrz = _mol_util_color__WEBPACK_IMPORTED_MODULE_1__["ColorScale"].create({
        minLabel: 'Poor',
        maxLabel: 'Better',
        domain: [2, 0],
        listOrName: 'red-yellow-blue',
    });
    var scaleRscc = _mol_util_color__WEBPACK_IMPORTED_MODULE_1__["ColorScale"].create({
        minLabel: 'Poor',
        maxLabel: 'Better',
        domain: [0.678, 1.0],
        listOrName: 'red-yellow-blue',
    });
    var validationReport = ctx.structure && _prop__WEBPACK_IMPORTED_MODULE_3__["ValidationReportProvider"].get(ctx.structure.models[0]);
    var contextHash = validationReport === null || validationReport === void 0 ? void 0 : validationReport.version;
    var model = (_a = ctx.structure) === null || _a === void 0 ? void 0 : _a.models[0];
    if ((validationReport === null || validationReport === void 0 ? void 0 : validationReport.value) && model) {
        var _b = validationReport.value, rsrz_1 = _b.rsrz, rscc_1 = _b.rscc;
        var residueIndex_1 = model.atomicHierarchy.residueAtomSegments.index;
        var getColor_1 = function (element) {
            var rsrzValue = rsrz_1.get(residueIndex_1[element]);
            if (rsrzValue !== undefined)
                return scaleRsrz.color(rsrzValue);
            var rsccValue = rscc_1.get(residueIndex_1[element]);
            if (rsccValue !== undefined)
                return scaleRscc.color(rsccValue);
            return DefaultColor;
        };
        color = function (location) {
            if (_mol_model_structure__WEBPACK_IMPORTED_MODULE_2__["StructureElement"].Location.is(location) && location.unit.model === model) {
                return getColor_1(location.element);
            }
            else if (_mol_model_structure__WEBPACK_IMPORTED_MODULE_2__["Bond"].isLocation(location) && location.aUnit.model === model) {
                return getColor_1(location.aUnit.elements[location.aIndex]);
            }
            return DefaultColor;
        };
    }
    return {
        factory: DensityFitColorTheme,
        granularity: 'group',
        color: color,
        props: props,
        contextHash: contextHash,
        description: 'Assigns residue colors according to the density fit using normalized Real Space R (RSRZ) for polymer residues and real space correlation coefficient (RSCC) for ligands. Colors range from poor (RSRZ = 2 or RSCC = 0.678) - to better (RSRZ = 0 or RSCC = 1.0). Data from wwPDB Validation Report, obtained via RCSB PDB.',
        legend: scaleRsrz.legend
    };
}
var DensityFitColorThemeProvider = {
    name: _prop__WEBPACK_IMPORTED_MODULE_3__["ValidationReport"].Tag.DensityFit,
    label: 'Density Fit',
    category: "Validation" /* Validation */,
    factory: DensityFitColorTheme,
    getParams: function () { return ({}); },
    defaultValues: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_0__["ParamDefinition"].getDefaultValues({}),
    isApplicable: function (ctx) { return !!ctx.structure && _prop__WEBPACK_IMPORTED_MODULE_3__["ValidationReport"].isApplicable(ctx.structure.models[0]) && _mol_model_structure__WEBPACK_IMPORTED_MODULE_2__["Model"].isFromXray(ctx.structure.models[0]) && _mol_model_structure__WEBPACK_IMPORTED_MODULE_2__["Model"].probablyHasDensityMap(ctx.structure.models[0]); },
    ensureCustomProperties: {
        attach: function (ctx, data) { return data.structure ? _prop__WEBPACK_IMPORTED_MODULE_3__["ValidationReportProvider"].attach(ctx, data.structure.models[0], void 0, true) : Promise.resolve(); },
        detach: function (data) { return data.structure && data.structure.models[0].customProperties.reference(_prop__WEBPACK_IMPORTED_MODULE_3__["ValidationReportProvider"].descriptor, false); }
    }
};
//# sourceMappingURL=density-fit.js.map

/***/ }),

/***/ "./lib/extensions/rcsb/validation-report/color/geometry-quality.js":
/*!*************************************************************************!*\
  !*** ./lib/extensions/rcsb/validation-report/color/geometry-quality.js ***!
  \*************************************************************************/
/*! exports provided: getGeometricQualityColorThemeParams, GeometryQualityColorTheme, GeometryQualityColorThemeProvider */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getGeometricQualityColorThemeParams", function() { return getGeometricQualityColorThemeParams; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "GeometryQualityColorTheme", function() { return GeometryQualityColorTheme; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "GeometryQualityColorThemeProvider", function() { return GeometryQualityColorThemeProvider; });
/* harmony import */ var _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../../../mol-util/param-definition */ "./lib/mol-util/param-definition.js");
/* harmony import */ var _mol_util_color__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../../../mol-util/color */ "./lib/mol-util/color/index.js");
/* harmony import */ var _mol_model_structure__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../../../mol-model/structure */ "./lib/mol-model/structure.js");
/* harmony import */ var _prop__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../prop */ "./lib/extensions/rcsb/validation-report/prop.js");
/* harmony import */ var _mol_util_legend__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../../../mol-util/legend */ "./lib/mol-util/legend.js");
/* harmony import */ var _mol_util_set__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../../../mol-util/set */ "./lib/mol-util/set.js");
/**
 * Copyright (c) 2020 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */






var DefaultColor = Object(_mol_util_color__WEBPACK_IMPORTED_MODULE_1__["Color"])(0x909090);
var NoIssuesColor = Object(_mol_util_color__WEBPACK_IMPORTED_MODULE_1__["Color"])(0x2166ac);
var OneIssueColor = Object(_mol_util_color__WEBPACK_IMPORTED_MODULE_1__["Color"])(0xfee08b);
var TwoIssuesColor = Object(_mol_util_color__WEBPACK_IMPORTED_MODULE_1__["Color"])(0xf46d43);
var ThreeOrMoreIssuesColor = Object(_mol_util_color__WEBPACK_IMPORTED_MODULE_1__["Color"])(0xa50026);
var ColorLegend = Object(_mol_util_legend__WEBPACK_IMPORTED_MODULE_4__["TableLegend"])([
    ['Data unavailable', DefaultColor],
    ['No issues', NoIssuesColor],
    ['One issue', OneIssueColor],
    ['Two issues', TwoIssuesColor],
    ['Three or more issues', ThreeOrMoreIssuesColor],
]);
function getGeometricQualityColorThemeParams(ctx) {
    var validationReport = !!ctx.structure && ctx.structure.models.length > 0 && _prop__WEBPACK_IMPORTED_MODULE_3__["ValidationReportProvider"].get(ctx.structure.models[0]).value;
    var options = [];
    if (validationReport) {
        var kinds_1 = new Set();
        validationReport.geometryIssues.forEach(function (v) { return v.forEach(function (k) { return kinds_1.add(k); }); });
        kinds_1.forEach(function (k) { return options.push([k, k]); });
    }
    return {
        ignore: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_0__["ParamDefinition"].MultiSelect([], options)
    };
}
function GeometryQualityColorTheme(ctx, props) {
    var _a;
    var color = function () { return DefaultColor; };
    var validationReport = !!ctx.structure && ctx.structure.models.length > 0 ? _prop__WEBPACK_IMPORTED_MODULE_3__["ValidationReportProvider"].get(ctx.structure.models[0]) : void 0;
    var contextHash = validationReport === null || validationReport === void 0 ? void 0 : validationReport.version;
    var value = validationReport === null || validationReport === void 0 ? void 0 : validationReport.value;
    var model = (_a = ctx.structure) === null || _a === void 0 ? void 0 : _a.models[0];
    if (value && model) {
        var geometryIssues_1 = value.geometryIssues, clashes_1 = value.clashes, bondOutliers_1 = value.bondOutliers, angleOutliers_1 = value.angleOutliers;
        var residueIndex_1 = model.atomicHierarchy.residueAtomSegments.index;
        var polymerType_1 = model.atomicHierarchy.derived.residue.polymerType;
        var ignore_1 = new Set(props.ignore);
        var getColor_1 = function (element) {
            var rI = residueIndex_1[element];
            var value = geometryIssues_1.get(rI);
            if (value === undefined)
                return DefaultColor;
            var count = _mol_util_set__WEBPACK_IMPORTED_MODULE_5__["SetUtils"].differenceSize(value, ignore_1);
            if (count > 0 && polymerType_1[rI] === 0 /* NA */) {
                count = 0;
                if (!ignore_1.has('clash') && clashes_1.getVertexEdgeCount(element) > 0)
                    count += 1;
                if (!ignore_1.has('mog-bond-outlier') && bondOutliers_1.index.has(element))
                    count += 1;
                if (!ignore_1.has('mog-angle-outlier') && angleOutliers_1.index.has(element))
                    count += 1;
            }
            switch (count) {
                case undefined: return DefaultColor;
                case 0: return NoIssuesColor;
                case 1: return OneIssueColor;
                case 2: return TwoIssuesColor;
                default: return ThreeOrMoreIssuesColor;
            }
        };
        color = function (location) {
            if (_mol_model_structure__WEBPACK_IMPORTED_MODULE_2__["StructureElement"].Location.is(location) && location.unit.model === model) {
                return getColor_1(location.element);
            }
            else if (_mol_model_structure__WEBPACK_IMPORTED_MODULE_2__["Bond"].isLocation(location) && location.aUnit.model === model) {
                return getColor_1(location.aUnit.elements[location.aIndex]);
            }
            return DefaultColor;
        };
    }
    return {
        factory: GeometryQualityColorTheme,
        granularity: 'group',
        color: color,
        props: props,
        contextHash: contextHash,
        description: 'Assigns residue colors according to the number of (filtered) geometry issues. Data from wwPDB Validation Report, obtained via RCSB PDB.',
        legend: ColorLegend
    };
}
var GeometryQualityColorThemeProvider = {
    name: _prop__WEBPACK_IMPORTED_MODULE_3__["ValidationReport"].Tag.GeometryQuality,
    label: 'Geometry Quality',
    category: "Validation" /* Validation */,
    factory: GeometryQualityColorTheme,
    getParams: getGeometricQualityColorThemeParams,
    defaultValues: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_0__["ParamDefinition"].getDefaultValues(getGeometricQualityColorThemeParams({})),
    isApplicable: function (ctx) { var _a; return _prop__WEBPACK_IMPORTED_MODULE_3__["ValidationReport"].isApplicable((_a = ctx.structure) === null || _a === void 0 ? void 0 : _a.models[0]); },
    ensureCustomProperties: {
        attach: function (ctx, data) { return data.structure ? _prop__WEBPACK_IMPORTED_MODULE_3__["ValidationReportProvider"].attach(ctx, data.structure.models[0], void 0, true) : Promise.resolve(); },
        detach: function (data) { return data.structure && data.structure.models[0].customProperties.reference(_prop__WEBPACK_IMPORTED_MODULE_3__["ValidationReportProvider"].descriptor, false); }
    }
};
//# sourceMappingURL=geometry-quality.js.map

/***/ }),

/***/ "./lib/extensions/rcsb/validation-report/color/random-coil-index.js":
/*!**************************************************************************!*\
  !*** ./lib/extensions/rcsb/validation-report/color/random-coil-index.js ***!
  \**************************************************************************/
/*! exports provided: RandomCoilIndexColorTheme, RandomCoilIndexColorThemeProvider */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "RandomCoilIndexColorTheme", function() { return RandomCoilIndexColorTheme; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "RandomCoilIndexColorThemeProvider", function() { return RandomCoilIndexColorThemeProvider; });
/* harmony import */ var _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../../../mol-util/param-definition */ "./lib/mol-util/param-definition.js");
/* harmony import */ var _mol_util_color__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../../../mol-util/color */ "./lib/mol-util/color/index.js");
/* harmony import */ var _mol_model_structure__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../../../mol-model/structure */ "./lib/mol-model/structure.js");
/* harmony import */ var _prop__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../prop */ "./lib/extensions/rcsb/validation-report/prop.js");
/**
 * Copyright (c) 2020 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */




var DefaultColor = Object(_mol_util_color__WEBPACK_IMPORTED_MODULE_1__["Color"])(0xCCCCCC);
function RandomCoilIndexColorTheme(ctx, props) {
    var _a, _b;
    var color = function () { return DefaultColor; };
    var scale = _mol_util_color__WEBPACK_IMPORTED_MODULE_1__["ColorScale"].create({
        reverse: true,
        domain: [0, 0.6],
        listOrName: 'red-yellow-blue',
    });
    var validationReport = ctx.structure && _prop__WEBPACK_IMPORTED_MODULE_3__["ValidationReportProvider"].get(ctx.structure.models[0]);
    var contextHash = validationReport === null || validationReport === void 0 ? void 0 : validationReport.version;
    var rci = (_a = validationReport === null || validationReport === void 0 ? void 0 : validationReport.value) === null || _a === void 0 ? void 0 : _a.rci;
    var model = (_b = ctx.structure) === null || _b === void 0 ? void 0 : _b.models[0];
    if (rci && model) {
        var residueIndex_1 = model.atomicHierarchy.residueAtomSegments.index;
        var getColor_1 = function (element) {
            var value = rci.get(residueIndex_1[element]);
            return value === undefined ? DefaultColor : scale.color(value);
        };
        color = function (location) {
            if (_mol_model_structure__WEBPACK_IMPORTED_MODULE_2__["StructureElement"].Location.is(location) && location.unit.model === model) {
                return getColor_1(location.element);
            }
            else if (_mol_model_structure__WEBPACK_IMPORTED_MODULE_2__["Bond"].isLocation(location) && location.aUnit.model === model) {
                return getColor_1(location.aUnit.elements[location.aIndex]);
            }
            return DefaultColor;
        };
    }
    return {
        factory: RandomCoilIndexColorTheme,
        granularity: 'group',
        color: color,
        props: props,
        contextHash: contextHash,
        description: 'Assigns residue colors according to the Random Coil Index value. Data from wwPDB Validation Report, obtained via RCSB PDB.',
        legend: scale.legend
    };
}
var RandomCoilIndexColorThemeProvider = {
    name: _prop__WEBPACK_IMPORTED_MODULE_3__["ValidationReport"].Tag.RandomCoilIndex,
    label: 'Random Coil Index',
    category: "Validation" /* Validation */,
    factory: RandomCoilIndexColorTheme,
    getParams: function () { return ({}); },
    defaultValues: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_0__["ParamDefinition"].getDefaultValues({}),
    isApplicable: function (ctx) { return !!ctx.structure && _prop__WEBPACK_IMPORTED_MODULE_3__["ValidationReport"].isApplicable(ctx.structure.models[0]) && _mol_model_structure__WEBPACK_IMPORTED_MODULE_2__["Model"].isFromNmr(ctx.structure.models[0]); },
    ensureCustomProperties: {
        attach: function (ctx, data) { return data.structure ? _prop__WEBPACK_IMPORTED_MODULE_3__["ValidationReportProvider"].attach(ctx, data.structure.models[0], void 0, true) : Promise.resolve(); },
        detach: function (data) { return data.structure && data.structure.models[0].customProperties.reference(_prop__WEBPACK_IMPORTED_MODULE_3__["ValidationReportProvider"].descriptor, false); }
    }
};
//# sourceMappingURL=random-coil-index.js.map

/***/ }),

/***/ "./lib/extensions/rcsb/validation-report/prop.js":
/*!*******************************************************!*\
  !*** ./lib/extensions/rcsb/validation-report/prop.js ***!
  \*******************************************************/
/*! exports provided: ValidationReport, ValidationReportParams, ValidationReportProvider, ClashesProvider */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ValidationReport", function() { return ValidationReport; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ValidationReportParams", function() { return ValidationReportParams; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ValidationReportProvider", function() { return ValidationReportProvider; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ClashesProvider", function() { return ClashesProvider; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../../mol-util/param-definition */ "./lib/mol-util/param-definition.js");
/* harmony import */ var _mol_model_structure__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../../mol-model/structure */ "./lib/mol-model/structure.js");
/* harmony import */ var _mol_model_props_common_custom_model_property__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../../mol-model-props/common/custom-model-property */ "./lib/mol-model-props/common/custom-model-property.js");
/* harmony import */ var _mol_model_structure_model__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../../mol-model/structure/model */ "./lib/mol-model/structure/model.js");
/* harmony import */ var _mol_math_graph__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../../mol-math/graph */ "./lib/mol-math/graph.js");
/* harmony import */ var _mol_model_props_common_custom_structure_property__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../../../mol-model-props/common/custom-structure-property */ "./lib/mol-model-props/common/custom-structure-property.js");
/* harmony import */ var _mol_math_graph_inter_unit_graph__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../../../mol-math/graph/inter-unit-graph */ "./lib/mol-math/graph/inter-unit-graph.js");
/* harmony import */ var _mol_data_int__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ../../../mol-data/int */ "./lib/mol-data/int.js");
/* harmony import */ var _mol_util_array__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ../../../mol-util/array */ "./lib/mol-util/array.js");
/* harmony import */ var _mol_math_linear_algebra_3d_common__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ../../../mol-math/linear-algebra/3d/common */ "./lib/mol-math/linear-algebra/3d/common.js");
/* harmony import */ var _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ../../../mol-math/linear-algebra */ "./lib/mol-math/linear-algebra.js");
/* harmony import */ var _mol_script_runtime_query_compiler__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! ../../../mol-script/runtime/query/compiler */ "./lib/mol-script/runtime/query/compiler.js");
/* harmony import */ var _mol_script_language_symbol__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! ../../../mol-script/language/symbol */ "./lib/mol-script/language/symbol.js");
/* harmony import */ var _mol_script_language_type__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! ../../../mol-script/language/type */ "./lib/mol-script/language/type.js");
/* harmony import */ var _mol_util_assets__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! ../../../mol-util/assets */ "./lib/mol-util/assets.js");
/* harmony import */ var _mol_model_custom_property__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(/*! ../../../mol-model/custom-property */ "./lib/mol-model/custom-property.js");
/**
 * Copyright (c) 2020 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */


















var ValidationReport;
(function (ValidationReport) {
    var Tag;
    (function (Tag) {
        Tag["DensityFit"] = "rcsb-density-fit";
        Tag["GeometryQuality"] = "rcsb-geometry-quality";
        Tag["RandomCoilIndex"] = "rcsb-random-coil-index";
        Tag["Clashes"] = "rcsb-clashes";
    })(Tag = ValidationReport.Tag || (ValidationReport.Tag = {}));
    ValidationReport.DefaultBaseUrl = '//ftp.rcsb.org/pub/pdb/validation_reports';
    function getEntryUrl(pdbId, baseUrl) {
        var id = pdbId.toLowerCase();
        return baseUrl + "/" + id.substr(1, 2) + "/" + id + "/" + id + "_validation.xml.gz";
    }
    ValidationReport.getEntryUrl = getEntryUrl;
    function isApplicable(model) {
        return !!model && _mol_model_structure_model__WEBPACK_IMPORTED_MODULE_4__["Model"].isFromPdbArchive(model);
    }
    ValidationReport.isApplicable = isApplicable;
    function fromXml(xml, model) {
        return parseValidationReportXml(xml, model);
    }
    ValidationReport.fromXml = fromXml;
    function fetch(ctx, model, props) {
        return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"])(this, void 0, void 0, function () {
            var url, xml;
            return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__generator"])(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = _mol_util_assets__WEBPACK_IMPORTED_MODULE_15__["Asset"].getUrlAsset(ctx.assetManager, getEntryUrl(model.entryId, props.baseUrl));
                        return [4 /*yield*/, ctx.assetManager.resolve(url, 'xml').runInContext(ctx.runtime)];
                    case 1:
                        xml = _a.sent();
                        return [2 /*return*/, { value: fromXml(xml.data, model), assets: [xml] }];
                }
            });
        });
    }
    ValidationReport.fetch = fetch;
    function open(ctx, model, props) {
        return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"])(this, void 0, void 0, function () {
            var xml;
            return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__generator"])(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (props.input === null)
                            throw new Error('No file given');
                        return [4 /*yield*/, ctx.assetManager.resolve(props.input, 'xml').runInContext(ctx.runtime)];
                    case 1:
                        xml = _a.sent();
                        return [2 /*return*/, { value: fromXml(xml.data, model), assets: [xml] }];
                }
            });
        });
    }
    ValidationReport.open = open;
    function obtain(ctx, model, props) {
        return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"])(this, void 0, void 0, function () {
            return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__generator"])(this, function (_a) {
                switch (props.source.name) {
                    case 'file': return [2 /*return*/, open(ctx, model, props.source.params)];
                    case 'server': return [2 /*return*/, fetch(ctx, model, props.source.params)];
                }
                return [2 /*return*/];
            });
        });
    }
    ValidationReport.obtain = obtain;
    ValidationReport.symbols = {
        hasClash: _mol_script_runtime_query_compiler__WEBPACK_IMPORTED_MODULE_12__["QuerySymbolRuntime"].Dynamic(Object(_mol_script_language_symbol__WEBPACK_IMPORTED_MODULE_13__["CustomPropSymbol"])('rcsb', 'validation-report.has-clash', _mol_script_language_type__WEBPACK_IMPORTED_MODULE_14__["default"].Bool), function (ctx) {
            var _a = ctx.element, unit = _a.unit, element = _a.element;
            if (!_mol_model_structure__WEBPACK_IMPORTED_MODULE_2__["Unit"].isAtomic(unit))
                return 0;
            var validationReport = ValidationReportProvider.get(unit.model).value;
            return validationReport && validationReport.clashes.getVertexEdgeCount(element) > 0;
        }),
        issueCount: _mol_script_runtime_query_compiler__WEBPACK_IMPORTED_MODULE_12__["QuerySymbolRuntime"].Dynamic(Object(_mol_script_language_symbol__WEBPACK_IMPORTED_MODULE_13__["CustomPropSymbol"])('rcsb', 'validation-report.issue-count', _mol_script_language_type__WEBPACK_IMPORTED_MODULE_14__["default"].Num), function (ctx) {
            var _a;
            var _b = ctx.element, unit = _b.unit, element = _b.element;
            if (!_mol_model_structure__WEBPACK_IMPORTED_MODULE_2__["Unit"].isAtomic(unit))
                return 0;
            var validationReport = ValidationReportProvider.get(unit.model).value;
            return ((_a = validationReport === null || validationReport === void 0 ? void 0 : validationReport.geometryIssues.get(unit.residueIndex[element])) === null || _a === void 0 ? void 0 : _a.size) || 0;
        }),
    };
})(ValidationReport || (ValidationReport = {}));
var FileSourceParams = {
    input: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_1__["ParamDefinition"].File({ accept: '.xml,.gz,.zip' })
};
var ServerSourceParams = {
    baseUrl: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_1__["ParamDefinition"].Text(ValidationReport.DefaultBaseUrl, { description: 'Base URL to directory tree' })
};
var ValidationReportParams = {
    source: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_1__["ParamDefinition"].MappedStatic('server', {
        'file': _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_1__["ParamDefinition"].Group(FileSourceParams, { label: 'File', isFlat: true }),
        'server': _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_1__["ParamDefinition"].Group(ServerSourceParams, { label: 'Server', isFlat: true }),
    }, { options: [['file', 'File'], ['server', 'Server']] })
};
var ValidationReportProvider = _mol_model_props_common_custom_model_property__WEBPACK_IMPORTED_MODULE_3__["CustomModelProperty"].createProvider({
    label: 'Validation Report',
    descriptor: Object(_mol_model_custom_property__WEBPACK_IMPORTED_MODULE_16__["CustomPropertyDescriptor"])({
        name: 'rcsb_validation_report',
        symbols: ValidationReport.symbols
    }),
    type: 'dynamic',
    defaultParams: ValidationReportParams,
    getParams: function (data) { return ValidationReportParams; },
    isApplicable: function (data) { return ValidationReport.isApplicable(data); },
    obtain: function (ctx, data, props) { return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"])(void 0, void 0, void 0, function () {
        var p;
        return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__generator"])(this, function (_a) {
            switch (_a.label) {
                case 0:
                    p = Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_1__["ParamDefinition"].getDefaultValues(ValidationReportParams)), props);
                    return [4 /*yield*/, ValidationReport.obtain(ctx, data, p)];
                case 1: return [2 /*return*/, _a.sent()];
            }
        });
    }); }
});
function createInterUnitClashes(structure, clashes) {
    var builder = new _mol_math_graph_inter_unit_graph__WEBPACK_IMPORTED_MODULE_7__["InterUnitGraph"].Builder();
    var a = clashes.a, b = clashes.b, _a = clashes.edgeProps, id = _a.id, magnitude = _a.magnitude, distance = _a.distance;
    var pA = Object(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_11__["Vec3"])(), pB = Object(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_11__["Vec3"])();
    _mol_model_structure__WEBPACK_IMPORTED_MODULE_2__["Structure"].eachUnitPair(structure, function (unitA, unitB) {
        var elementsA = unitA.elements;
        var elementsB = unitB.elements;
        builder.startUnitPair(unitA.id, unitB.id);
        for (var i = 0, il = clashes.edgeCount * 2; i < il; ++i) {
            // TODO create lookup
            var indexA = _mol_data_int__WEBPACK_IMPORTED_MODULE_8__["SortedArray"].indexOf(elementsA, a[i]);
            var indexB = _mol_data_int__WEBPACK_IMPORTED_MODULE_8__["SortedArray"].indexOf(elementsB, b[i]);
            if (indexA !== -1 && indexB !== -1) {
                unitA.conformation.position(a[i], pA);
                unitB.conformation.position(b[i], pB);
                // check actual distance to avoid clashes between unrelated chain instances
                if (Object(_mol_math_linear_algebra_3d_common__WEBPACK_IMPORTED_MODULE_10__["equalEps"])(distance[i], _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_11__["Vec3"].distance(pA, pB), 0.1)) {
                    builder.add(indexA, indexB, {
                        id: id[i],
                        magnitude: magnitude[i],
                        distance: distance[i],
                    });
                }
            }
        }
        builder.finishUnitPair();
    }, {
        maxRadius: Object(_mol_util_array__WEBPACK_IMPORTED_MODULE_9__["arrayMax"])(clashes.edgeProps.distance),
        validUnit: function (unit) { return _mol_model_structure__WEBPACK_IMPORTED_MODULE_2__["Unit"].isAtomic(unit); },
        validUnitPair: function (unitA, unitB) { return unitA.model === unitB.model; }
    });
    return new _mol_math_graph_inter_unit_graph__WEBPACK_IMPORTED_MODULE_7__["InterUnitGraph"](builder.getMap());
}
function createIntraUnitClashes(unit, clashes) {
    var aIndices = [];
    var bIndices = [];
    var ids = [];
    var magnitudes = [];
    var distances = [];
    var pA = Object(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_11__["Vec3"])(), pB = Object(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_11__["Vec3"])();
    var elements = unit.elements;
    var a = clashes.a, b = clashes.b, edgeCount = clashes.edgeCount, edgeProps = clashes.edgeProps;
    for (var i = 0, il = edgeCount * 2; i < il; ++i) {
        // TODO create lookup
        var indexA = _mol_data_int__WEBPACK_IMPORTED_MODULE_8__["SortedArray"].indexOf(elements, a[i]);
        var indexB = _mol_data_int__WEBPACK_IMPORTED_MODULE_8__["SortedArray"].indexOf(elements, b[i]);
        if (indexA !== -1 && indexB !== -1) {
            unit.conformation.position(a[i], pA);
            unit.conformation.position(b[i], pB);
            // check actual distance to avoid clashes between unrelated chain instances
            if (Object(_mol_math_linear_algebra_3d_common__WEBPACK_IMPORTED_MODULE_10__["equalEps"])(edgeProps.distance[i], _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_11__["Vec3"].distance(pA, pB), 0.1)) {
                aIndices.push(indexA);
                bIndices.push(indexB);
                ids.push(edgeProps.id[i]);
                magnitudes.push(edgeProps.magnitude[i]);
                distances.push(edgeProps.distance[i]);
            }
        }
    }
    var builder = new _mol_math_graph__WEBPACK_IMPORTED_MODULE_5__["IntAdjacencyGraph"].EdgeBuilder(elements.length, aIndices, bIndices);
    var id = new Int32Array(builder.slotCount);
    var magnitude = new Float32Array(builder.slotCount);
    var distance = new Float32Array(builder.slotCount);
    for (var i = 0, _i = builder.edgeCount; i < _i; i++) {
        builder.addNextEdge();
        builder.assignProperty(id, ids[i]);
        builder.assignProperty(magnitude, magnitudes[i]);
        builder.assignProperty(distance, distances[i]);
    }
    return builder.createGraph({ id: id, magnitude: magnitude, distance: distance });
}
function createClashes(structure, clashes) {
    var intraUnit = _mol_data_int__WEBPACK_IMPORTED_MODULE_8__["IntMap"].Mutable();
    for (var i = 0, il = structure.unitSymmetryGroups.length; i < il; ++i) {
        var group = structure.unitSymmetryGroups[i];
        if (!_mol_model_structure__WEBPACK_IMPORTED_MODULE_2__["Unit"].isAtomic(group.units[0]))
            continue;
        var intraClashes = createIntraUnitClashes(group.units[0], clashes);
        for (var j = 0, jl = group.units.length; j < jl; ++j) {
            intraUnit.set(group.units[j].id, intraClashes);
        }
    }
    return {
        interUnit: createInterUnitClashes(structure, clashes),
        intraUnit: intraUnit
    };
}
var ClashesProvider = _mol_model_props_common_custom_structure_property__WEBPACK_IMPORTED_MODULE_6__["CustomStructureProperty"].createProvider({
    label: 'Clashes',
    descriptor: Object(_mol_model_custom_property__WEBPACK_IMPORTED_MODULE_16__["CustomPropertyDescriptor"])({
        name: 'rcsb_clashes',
    }),
    type: 'local',
    defaultParams: {},
    getParams: function (data) { return ({}); },
    isApplicable: function (data) { return true; },
    obtain: function (ctx, data) { return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"])(void 0, void 0, void 0, function () {
        var validationReport;
        return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__generator"])(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, ValidationReportProvider.attach(ctx, data.models[0])];
                case 1:
                    _a.sent();
                    validationReport = ValidationReportProvider.get(data.models[0]).value;
                    return [2 /*return*/, {
                            value: createClashes(data, validationReport.clashes)
                        }];
            }
        });
    }); }
});
//
function getItem(a, name) {
    var item = a.getNamedItem(name);
    return item !== null ? item.value : '';
}
function hasAttr(a, name, value) {
    var item = a.getNamedItem(name);
    return item !== null && item.value === value;
}
function getMogInfo(a) {
    return {
        mean: parseFloat(getItem(a, 'mean')),
        obs: parseFloat(getItem(a, 'obsval')),
        stdev: parseFloat(getItem(a, 'stdev')),
        z: parseFloat(getItem(a, 'Zscore')),
    };
}
function getMolInfo(a) {
    return {
        mean: parseFloat(getItem(a, 'mean')),
        obs: parseFloat(getItem(a, 'obs')),
        stdev: parseFloat(getItem(a, 'stdev')),
        z: parseInt(getItem(a, 'z')),
    };
}
function addIndex(index, element, map) {
    if (map.has(element))
        map.get(element).push(index);
    else
        map.set(element, [index]);
}
function ClashesBuilder(elementsCount) {
    var aIndices = [];
    var bIndices = [];
    var ids = [];
    var magnitudes = [];
    var distances = [];
    var seen = new Map();
    return {
        add: function (element, id, magnitude, distance, isSymop) {
            var hash = id + "|" + (isSymop ? 's' : '');
            var other = seen.get(hash);
            if (other !== undefined) {
                aIndices[aIndices.length] = element;
                bIndices[bIndices.length] = other;
                ids[ids.length] = id;
                magnitudes[magnitudes.length] = magnitude;
                distances[distances.length] = distance;
            }
            else {
                seen.set(hash, element);
            }
        },
        get: function () {
            var builder = new _mol_math_graph__WEBPACK_IMPORTED_MODULE_5__["IntAdjacencyGraph"].EdgeBuilder(elementsCount, aIndices, bIndices);
            var id = new Int32Array(builder.slotCount);
            var magnitude = new Float32Array(builder.slotCount);
            var distance = new Float32Array(builder.slotCount);
            for (var i = 0, _i = builder.edgeCount; i < _i; i++) {
                builder.addNextEdge();
                builder.assignProperty(id, ids[i]);
                builder.assignProperty(magnitude, magnitudes[i]);
                builder.assignProperty(distance, distances[i]);
            }
            return builder.createGraph({ id: id, magnitude: magnitude, distance: distance });
        }
    };
}
function parseValidationReportXml(xml, model) {
    var rsrz = new Map();
    var rscc = new Map();
    var rci = new Map();
    var geometryIssues = new Map();
    var bondOutliers = {
        index: new Map(),
        data: []
    };
    var angleOutliers = {
        index: new Map(),
        data: []
    };
    var clashesBuilder = ClashesBuilder(model.atomicHierarchy.atoms._rowCount);
    var index = model.atomicHierarchy.index;
    var entries = xml.getElementsByTagName('Entry');
    if (entries.length === 1) {
        var chemicalShiftLists = entries[0].getElementsByTagName('chemical_shift_list');
        if (chemicalShiftLists.length === 1) {
            var randomCoilIndices = chemicalShiftLists[0].getElementsByTagName('random_coil_index');
            for (var j = 0, jl = randomCoilIndices.length; j < jl; ++j) {
                var attributes = randomCoilIndices[j].attributes;
                var value = parseFloat(getItem(attributes, 'value'));
                var auth_asym_id = getItem(attributes, 'chain');
                var auth_comp_id = getItem(attributes, 'rescode');
                var auth_seq_id = parseInt(getItem(attributes, 'resnum'));
                var rI = index.findResidueAuth({ auth_asym_id: auth_asym_id, auth_comp_id: auth_comp_id, auth_seq_id: auth_seq_id });
                if (rI !== -1)
                    rci.set(rI, value);
            }
        }
    }
    var groups = xml.getElementsByTagName('ModelledSubgroup');
    for (var i = 0, il = groups.length; i < il; ++i) {
        var g = groups[i];
        var ga = g.attributes;
        var pdbx_PDB_model_num = parseInt(getItem(ga, 'model'));
        if (model.modelNum !== pdbx_PDB_model_num)
            continue;
        var auth_asym_id = getItem(ga, 'chain');
        var auth_comp_id = getItem(ga, 'resname');
        var auth_seq_id = parseInt(getItem(ga, 'resnum'));
        var pdbx_PDB_ins_code = getItem(ga, 'icode').trim() || undefined;
        var label_alt_id = getItem(ga, 'altcode').trim() || undefined;
        var rI = index.findResidueAuth({ auth_asym_id: auth_asym_id, auth_comp_id: auth_comp_id, auth_seq_id: auth_seq_id, pdbx_PDB_ins_code: pdbx_PDB_ins_code });
        // continue if no residue index is found
        if (rI === -1)
            continue;
        if (ga.getNamedItem('rsrz') !== null)
            rsrz.set(rI, parseFloat(getItem(ga, 'rsrz')));
        if (ga.getNamedItem('rscc') !== null)
            rscc.set(rI, parseFloat(getItem(ga, 'rscc')));
        var isPolymer = getItem(ga, 'seq') !== '.';
        var issues = new Set();
        if (isPolymer) {
            var molBondOutliers = g.getElementsByTagName('bond-outlier');
            if (molBondOutliers.length)
                issues.add('bond-outlier');
            for (var j = 0, jl = molBondOutliers.length; j < jl; ++j) {
                var bo = molBondOutliers[j].attributes;
                var idx = bondOutliers.data.length;
                var atomA = index.findAtomOnResidue(rI, getItem(bo, 'atom0'));
                var atomB = index.findAtomOnResidue(rI, getItem(bo, 'atom1'));
                addIndex(idx, atomA, bondOutliers.index);
                addIndex(idx, atomB, bondOutliers.index);
                bondOutliers.data.push(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({ tag: 'bond-outlier', atomA: atomA, atomB: atomB }, getMolInfo(bo)));
            }
            var molAngleOutliers = g.getElementsByTagName('angle-outlier');
            if (molAngleOutliers.length)
                issues.add('angle-outlier');
            for (var j = 0, jl = molAngleOutliers.length; j < jl; ++j) {
                var ao = molAngleOutliers[j].attributes;
                var idx = bondOutliers.data.length;
                var atomA = index.findAtomOnResidue(rI, getItem(ao, 'atom0'));
                var atomB = index.findAtomOnResidue(rI, getItem(ao, 'atom1'));
                var atomC = index.findAtomOnResidue(rI, getItem(ao, 'atom2'));
                addIndex(idx, atomA, angleOutliers.index);
                addIndex(idx, atomB, angleOutliers.index);
                addIndex(idx, atomC, angleOutliers.index);
                angleOutliers.data.push(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({ tag: 'angle-outlier', atomA: atomA, atomB: atomB, atomC: atomC }, getMolInfo(ao)));
            }
            var planeOutliers = g.getElementsByTagName('plane-outlier');
            if (planeOutliers.length)
                issues.add('plane-outlier');
            if (hasAttr(ga, 'rota', 'OUTLIER'))
                issues.add('rotamer-outlier');
            if (hasAttr(ga, 'rama', 'OUTLIER'))
                issues.add('ramachandran-outlier');
            if (hasAttr(ga, 'RNApucker', 'outlier'))
                issues.add('RNApucker-outlier');
        }
        else {
            var mogBondOutliers = g.getElementsByTagName('mog-bond-outlier');
            if (mogBondOutliers.length)
                issues.add('mog-bond-outlier');
            for (var j = 0, jl = mogBondOutliers.length; j < jl; ++j) {
                var mbo = mogBondOutliers[j].attributes;
                var atoms = getItem(mbo, 'atoms').split(',');
                var idx = bondOutliers.data.length;
                var atomA = index.findAtomOnResidue(rI, atoms[0]);
                var atomB = index.findAtomOnResidue(rI, atoms[1]);
                addIndex(idx, atomA, bondOutliers.index);
                addIndex(idx, atomB, bondOutliers.index);
                bondOutliers.data.push(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({ tag: 'mog-bond-outlier', atomA: atomA, atomB: atomB }, getMogInfo(mbo)));
            }
            var mogAngleOutliers = g.getElementsByTagName('mog-angle-outlier');
            if (mogAngleOutliers.length)
                issues.add('mog-angle-outlier');
            for (var j = 0, jl = mogAngleOutliers.length; j < jl; ++j) {
                var mao = mogAngleOutliers[j].attributes;
                var atoms = getItem(mao, 'atoms').split(',');
                var idx = angleOutliers.data.length;
                var atomA = index.findAtomOnResidue(rI, atoms[0]);
                var atomB = index.findAtomOnResidue(rI, atoms[1]);
                var atomC = index.findAtomOnResidue(rI, atoms[2]);
                addIndex(idx, atomA, angleOutliers.index);
                addIndex(idx, atomB, angleOutliers.index);
                addIndex(idx, atomC, angleOutliers.index);
                angleOutliers.data.push(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({ tag: 'mog-angle-outlier', atomA: atomA, atomB: atomB, atomC: atomC }, getMogInfo(mao)));
            }
        }
        var clashes_1 = g.getElementsByTagName('clash');
        if (clashes_1.length)
            issues.add('clash');
        for (var j = 0, jl = clashes_1.length; j < jl; ++j) {
            var ca = clashes_1[j].attributes;
            var id = parseInt(getItem(ca, 'cid'));
            var magnitude = parseFloat(getItem(ca, 'clashmag'));
            var distance = parseFloat(getItem(ca, 'dist'));
            var label_atom_id = getItem(ca, 'atom');
            var element = index.findAtomOnResidue(rI, label_atom_id, label_alt_id);
            if (element !== -1) {
                clashesBuilder.add(element, id, magnitude, distance, false);
            }
        }
        var symmClashes = g.getElementsByTagName('symm-clash');
        if (symmClashes.length)
            issues.add('symm-clash');
        for (var j = 0, jl = symmClashes.length; j < jl; ++j) {
            var sca = symmClashes[j].attributes;
            var id = parseInt(getItem(sca, 'scid'));
            var magnitude = parseFloat(getItem(sca, 'clashmag'));
            var distance = parseFloat(getItem(sca, 'dist'));
            var label_atom_id = getItem(sca, 'atom');
            var element = index.findAtomOnResidue(rI, label_atom_id, label_alt_id);
            if (element !== -1) {
                clashesBuilder.add(element, id, magnitude, distance, true);
            }
        }
        geometryIssues.set(rI, issues);
    }
    var clashes = clashesBuilder.get();
    var validationReport = {
        rsrz: rsrz, rscc: rscc, rci: rci, geometryIssues: geometryIssues,
        bondOutliers: bondOutliers, angleOutliers: angleOutliers,
        clashes: clashes
    };
    return validationReport;
}
//# sourceMappingURL=prop.js.map

/***/ }),

/***/ "./lib/extensions/rcsb/validation-report/representation.js":
/*!*****************************************************************!*\
  !*** ./lib/extensions/rcsb/validation-report/representation.js ***!
  \*****************************************************************/
/*! exports provided: IntraUnitClashParams, IntraUnitClashVisual, InterUnitClashParams, InterUnitClashVisual, ClashesParams, getClashesParams, ClashesRepresentation, ClashesRepresentationProvider */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "IntraUnitClashParams", function() { return IntraUnitClashParams; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "IntraUnitClashVisual", function() { return IntraUnitClashVisual; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "InterUnitClashParams", function() { return InterUnitClashParams; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "InterUnitClashVisual", function() { return InterUnitClashVisual; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ClashesParams", function() { return ClashesParams; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getClashesParams", function() { return getClashesParams; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ClashesRepresentation", function() { return ClashesRepresentation; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ClashesRepresentationProvider", function() { return ClashesRepresentationProvider; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../../mol-util/param-definition */ "./lib/mol-util/param-definition.js");
/* harmony import */ var _mol_model_structure__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../../mol-model/structure */ "./lib/mol-model/structure.js");
/* harmony import */ var _mol_geo_geometry_mesh_mesh__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../../mol-geo/geometry/mesh/mesh */ "./lib/mol-geo/geometry/mesh/mesh.js");
/* harmony import */ var _mol_model_loci__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../../mol-model/loci */ "./lib/mol-model/loci.js");
/* harmony import */ var _mol_repr_representation__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../../mol-repr/representation */ "./lib/mol-repr/representation.js");
/* harmony import */ var _mol_repr_structure_representation__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../../../mol-repr/structure/representation */ "./lib/mol-repr/structure/representation.js");
/* harmony import */ var _mol_repr_structure_visual_util_link__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../../../mol-repr/structure/visual/util/link */ "./lib/mol-repr/structure/visual/util/link.js");
/* harmony import */ var _mol_repr_structure_units_visual__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ../../../mol-repr/structure/units-visual */ "./lib/mol-repr/structure/units-visual.js");
/* harmony import */ var _mol_geo_util_location_iterator__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ../../../mol-geo/util/location-iterator */ "./lib/mol-geo/util/location-iterator.js");
/* harmony import */ var _prop__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ./prop */ "./lib/extensions/rcsb/validation-report/prop.js");
/* harmony import */ var _mol_repr_structure_complex_visual__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ../../../mol-repr/structure/complex-visual */ "./lib/mol-repr/structure/complex-visual.js");
/* harmony import */ var _mol_util_color__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! ../../../mol-util/color */ "./lib/mol-util/color/index.js");
/* harmony import */ var _mol_util_marker_action__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! ../../../mol-util/marker-action */ "./lib/mol-util/marker-action.js");
/* harmony import */ var _mol_math_geometry_centroid_helper__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! ../../../mol-math/geometry/centroid-helper */ "./lib/mol-math/geometry/centroid-helper.js");
/* harmony import */ var _mol_theme_label__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! ../../../mol-theme/label */ "./lib/mol-theme/label.js");
/* harmony import */ var _mol_repr_structure_params__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(/*! ../../../mol-repr/structure/params */ "./lib/mol-repr/structure/params.js");
/**
 * Copyright (c) 2020 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */

















//
function createIntraUnitClashCylinderMesh(ctx, unit, structure, theme, props, mesh) {
    if (!_mol_model_structure__WEBPACK_IMPORTED_MODULE_2__["Unit"].isAtomic(unit))
        return _mol_geo_geometry_mesh_mesh__WEBPACK_IMPORTED_MODULE_3__["Mesh"].createEmpty(mesh);
    var clashes = _prop__WEBPACK_IMPORTED_MODULE_10__["ClashesProvider"].get(structure).value.intraUnit.get(unit.id);
    var edgeCount = clashes.edgeCount, a = clashes.a, b = clashes.b, edgeProps = clashes.edgeProps;
    var magnitude = edgeProps.magnitude;
    var sizeFactor = props.sizeFactor;
    if (!edgeCount)
        return _mol_geo_geometry_mesh_mesh__WEBPACK_IMPORTED_MODULE_3__["Mesh"].createEmpty(mesh);
    var elements = unit.elements;
    var pos = unit.conformation.invariantPosition;
    var builderProps = {
        linkCount: edgeCount * 2,
        position: function (posA, posB, edgeIndex) {
            pos(elements[a[edgeIndex]], posA);
            pos(elements[b[edgeIndex]], posB);
        },
        style: function (edgeIndex) { return 4 /* Disk */; },
        radius: function (edgeIndex) { return magnitude[edgeIndex] * sizeFactor; },
    };
    return Object(_mol_repr_structure_visual_util_link__WEBPACK_IMPORTED_MODULE_7__["createLinkCylinderMesh"])(ctx, builderProps, props, mesh);
}
var IntraUnitClashParams = Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, _mol_repr_structure_units_visual__WEBPACK_IMPORTED_MODULE_8__["UnitsMeshParams"]), _mol_repr_structure_visual_util_link__WEBPACK_IMPORTED_MODULE_7__["LinkCylinderParams"]), { linkCap: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_1__["ParamDefinition"].Boolean(true), sizeFactor: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_1__["ParamDefinition"].Numeric(1, { min: 0, max: 10, step: 0.01 }) });
function IntraUnitClashVisual(materialId) {
    return Object(_mol_repr_structure_units_visual__WEBPACK_IMPORTED_MODULE_8__["UnitsMeshVisual"])({
        defaultProps: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_1__["ParamDefinition"].getDefaultValues(IntraUnitClashParams),
        createGeometry: createIntraUnitClashCylinderMesh,
        createLocationIterator: createIntraClashIterator,
        getLoci: getIntraClashLoci,
        eachLocation: eachIntraClash,
        setUpdateState: function (state, newProps, currentProps) {
            state.createGeometry = (newProps.sizeFactor !== currentProps.sizeFactor ||
                newProps.radialSegments !== currentProps.radialSegments ||
                newProps.linkScale !== currentProps.linkScale ||
                newProps.linkSpacing !== currentProps.linkSpacing ||
                newProps.linkCap !== currentProps.linkCap);
        }
    }, materialId);
}
function getIntraClashBoundingSphere(unit, clashes, elements, boundingSphere) {
    return _mol_math_geometry_centroid_helper__WEBPACK_IMPORTED_MODULE_14__["CentroidHelper"].fromPairProvider(elements.length, function (i, pA, pB) {
        unit.conformation.position(unit.elements[clashes.a[elements[i]]], pA);
        unit.conformation.position(unit.elements[clashes.b[elements[i]]], pB);
    }, boundingSphere);
}
function getIntraClashLabel(structure, unit, clashes, elements) {
    var idx = elements[0];
    if (idx === undefined)
        return '';
    var _a = clashes.edgeProps, id = _a.id, magnitude = _a.magnitude, distance = _a.distance;
    var mag = magnitude[idx].toFixed(2);
    var dist = distance[idx].toFixed(2);
    return [
        "Clash id: " + id[idx] + " | Magnitude: " + mag + " \u212B | Distance: " + dist + " \u212B",
        Object(_mol_theme_label__WEBPACK_IMPORTED_MODULE_15__["bondLabel"])(_mol_model_structure__WEBPACK_IMPORTED_MODULE_2__["Bond"].Location(structure, unit, clashes.a[idx], structure, unit, clashes.b[idx]))
    ].join('</br>');
}
function IntraClashLoci(structure, unit, clashes, elements) {
    return Object(_mol_model_loci__WEBPACK_IMPORTED_MODULE_4__["DataLoci"])('intra-clashes', { unit: unit, clashes: clashes }, elements, function (boundingSphere) { return getIntraClashBoundingSphere(unit, clashes, elements, boundingSphere); }, function () { return getIntraClashLabel(structure, unit, clashes, elements); });
}
function getIntraClashLoci(pickingId, structureGroup, id) {
    var objectId = pickingId.objectId, instanceId = pickingId.instanceId, groupId = pickingId.groupId;
    if (id === objectId) {
        var structure = structureGroup.structure, group = structureGroup.group;
        var unit = group.units[instanceId];
        if (_mol_model_structure__WEBPACK_IMPORTED_MODULE_2__["Unit"].isAtomic(unit)) {
            var clashes = _prop__WEBPACK_IMPORTED_MODULE_10__["ClashesProvider"].get(structure).value.intraUnit.get(unit.id);
            return IntraClashLoci(structure, unit, clashes, [groupId]);
        }
    }
    return _mol_model_loci__WEBPACK_IMPORTED_MODULE_4__["EmptyLoci"];
}
function eachIntraClash(loci, structureGroup, apply) {
    var changed = false;
    // TODO
    return changed;
}
function createIntraClashIterator(structureGroup) {
    var structure = structureGroup.structure, group = structureGroup.group;
    var unit = group.units[0];
    var clashes = _prop__WEBPACK_IMPORTED_MODULE_10__["ClashesProvider"].get(structure).value.intraUnit.get(unit.id);
    var a = clashes.a;
    var groupCount = clashes.edgeCount * 2;
    var instanceCount = group.units.length;
    var location = _mol_model_structure__WEBPACK_IMPORTED_MODULE_2__["StructureElement"].Location.create(structure);
    var getLocation = function (groupIndex, instanceIndex) {
        var unit = group.units[instanceIndex];
        location.unit = unit;
        location.element = unit.elements[a[groupIndex]];
        return location;
    };
    return Object(_mol_geo_util_location_iterator__WEBPACK_IMPORTED_MODULE_9__["LocationIterator"])(groupCount, instanceCount, 1, getLocation);
}
//
function createInterUnitClashCylinderMesh(ctx, structure, theme, props, mesh) {
    var clashes = _prop__WEBPACK_IMPORTED_MODULE_10__["ClashesProvider"].get(structure).value.interUnit;
    var edges = clashes.edges, edgeCount = clashes.edgeCount;
    var sizeFactor = props.sizeFactor;
    if (!edgeCount)
        return _mol_geo_geometry_mesh_mesh__WEBPACK_IMPORTED_MODULE_3__["Mesh"].createEmpty(mesh);
    var builderProps = {
        linkCount: edgeCount,
        position: function (posA, posB, edgeIndex) {
            var b = edges[edgeIndex];
            var uA = structure.unitMap.get(b.unitA);
            var uB = structure.unitMap.get(b.unitB);
            uA.conformation.position(uA.elements[b.indexA], posA);
            uB.conformation.position(uB.elements[b.indexB], posB);
        },
        style: function (edgeIndex) { return 4 /* Disk */; },
        radius: function (edgeIndex) { return edges[edgeIndex].props.magnitude * sizeFactor; }
    };
    return Object(_mol_repr_structure_visual_util_link__WEBPACK_IMPORTED_MODULE_7__["createLinkCylinderMesh"])(ctx, builderProps, props, mesh);
}
var InterUnitClashParams = Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, _mol_repr_structure_complex_visual__WEBPACK_IMPORTED_MODULE_11__["ComplexMeshParams"]), _mol_repr_structure_visual_util_link__WEBPACK_IMPORTED_MODULE_7__["LinkCylinderParams"]), { linkCap: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_1__["ParamDefinition"].Boolean(true), sizeFactor: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_1__["ParamDefinition"].Numeric(1, { min: 0, max: 10, step: 0.01 }) });
function InterUnitClashVisual(materialId) {
    return Object(_mol_repr_structure_complex_visual__WEBPACK_IMPORTED_MODULE_11__["ComplexMeshVisual"])({
        defaultProps: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_1__["ParamDefinition"].getDefaultValues(InterUnitClashParams),
        createGeometry: createInterUnitClashCylinderMesh,
        createLocationIterator: createInterClashIterator,
        getLoci: getInterClashLoci,
        eachLocation: eachInterClash,
        setUpdateState: function (state, newProps, currentProps) {
            state.createGeometry = (newProps.sizeFactor !== currentProps.sizeFactor ||
                newProps.radialSegments !== currentProps.radialSegments ||
                newProps.linkScale !== currentProps.linkScale ||
                newProps.linkSpacing !== currentProps.linkSpacing ||
                newProps.linkCap !== currentProps.linkCap);
        }
    }, materialId);
}
function getInterClashBoundingSphere(structure, clashes, elements, boundingSphere) {
    return _mol_math_geometry_centroid_helper__WEBPACK_IMPORTED_MODULE_14__["CentroidHelper"].fromPairProvider(elements.length, function (i, pA, pB) {
        var c = clashes.edges[elements[i]];
        var uA = structure.unitMap.get(c.unitA);
        var uB = structure.unitMap.get(c.unitB);
        uA.conformation.position(uA.elements[c.indexA], pA);
        uB.conformation.position(uB.elements[c.indexB], pB);
    }, boundingSphere);
}
function getInterClashLabel(structure, clashes, elements) {
    var idx = elements[0];
    if (idx === undefined)
        return '';
    var c = clashes.edges[idx];
    var uA = structure.unitMap.get(c.unitA);
    var uB = structure.unitMap.get(c.unitB);
    var mag = c.props.magnitude.toFixed(2);
    var dist = c.props.distance.toFixed(2);
    return [
        "Clash id: " + c.props.id + " | Magnitude: " + mag + " \u212B | Distance: " + dist + " \u212B",
        Object(_mol_theme_label__WEBPACK_IMPORTED_MODULE_15__["bondLabel"])(_mol_model_structure__WEBPACK_IMPORTED_MODULE_2__["Bond"].Location(structure, uA, c.indexA, structure, uB, c.indexB))
    ].join('</br>');
}
function InterClashLoci(structure, clashes, elements) {
    return Object(_mol_model_loci__WEBPACK_IMPORTED_MODULE_4__["DataLoci"])('inter-clashes', clashes, elements, function (boundingSphere) { return getInterClashBoundingSphere(structure, clashes, elements, boundingSphere); }, function () { return getInterClashLabel(structure, clashes, elements); });
}
function getInterClashLoci(pickingId, structure, id) {
    var objectId = pickingId.objectId, groupId = pickingId.groupId;
    if (id === objectId) {
        var clashes = _prop__WEBPACK_IMPORTED_MODULE_10__["ClashesProvider"].get(structure).value.interUnit;
        return InterClashLoci(structure, clashes, [groupId]);
    }
    return _mol_model_loci__WEBPACK_IMPORTED_MODULE_4__["EmptyLoci"];
}
function eachInterClash(loci, structure, apply) {
    var changed = false;
    // TODO
    return changed;
}
function createInterClashIterator(structure) {
    var clashes = _prop__WEBPACK_IMPORTED_MODULE_10__["ClashesProvider"].get(structure).value.interUnit;
    var groupCount = clashes.edgeCount;
    var instanceCount = 1;
    var location = _mol_model_structure__WEBPACK_IMPORTED_MODULE_2__["StructureElement"].Location.create(structure);
    var getLocation = function (groupIndex) {
        var clash = clashes.edges[groupIndex];
        location.unit = structure.unitMap.get(clash.unitA);
        location.element = location.unit.elements[clash.indexA];
        return location;
    };
    return Object(_mol_geo_util_location_iterator__WEBPACK_IMPORTED_MODULE_9__["LocationIterator"])(groupCount, instanceCount, 1, getLocation, true);
}
//
var ClashesVisuals = {
    'intra-clash': function (ctx, getParams) { return Object(_mol_repr_structure_representation__WEBPACK_IMPORTED_MODULE_6__["UnitsRepresentation"])('Intra-unit clash cylinder', ctx, getParams, IntraUnitClashVisual); },
    'inter-clash': function (ctx, getParams) { return Object(_mol_repr_structure_representation__WEBPACK_IMPORTED_MODULE_6__["ComplexRepresentation"])('Inter-unit clash cylinder', ctx, getParams, InterUnitClashVisual); },
};
var ClashesParams = Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, IntraUnitClashParams), InterUnitClashParams), { unitKinds: Object(_mol_repr_structure_params__WEBPACK_IMPORTED_MODULE_16__["getUnitKindsParam"])(['atomic']), visuals: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_1__["ParamDefinition"].MultiSelect(['intra-clash', 'inter-clash'], _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_1__["ParamDefinition"].objectToOptions(ClashesVisuals)) });
function getClashesParams(ctx, structure) {
    return _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_1__["ParamDefinition"].clone(ClashesParams);
}
function ClashesRepresentation(ctx, getParams) {
    var repr = _mol_repr_representation__WEBPACK_IMPORTED_MODULE_5__["Representation"].createMulti('Clashes', ctx, getParams, _mol_repr_structure_representation__WEBPACK_IMPORTED_MODULE_6__["StructureRepresentationStateBuilder"], ClashesVisuals);
    repr.setState({ markerActions: _mol_util_marker_action__WEBPACK_IMPORTED_MODULE_13__["MarkerActions"].Highlighting });
    return repr;
}
var ClashesRepresentationProvider = Object(_mol_repr_structure_representation__WEBPACK_IMPORTED_MODULE_6__["StructureRepresentationProvider"])({
    name: _prop__WEBPACK_IMPORTED_MODULE_10__["ValidationReport"].Tag.Clashes,
    label: 'Validation Clashes',
    description: 'Displays clashes between atoms as disks. Data from wwPDB Validation Report, obtained via RCSB PDB.',
    factory: ClashesRepresentation,
    getParams: getClashesParams,
    defaultValues: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_1__["ParamDefinition"].getDefaultValues(ClashesParams),
    defaultColorTheme: { name: 'uniform', props: { value: Object(_mol_util_color__WEBPACK_IMPORTED_MODULE_12__["Color"])(0xFA28FF) } },
    defaultSizeTheme: { name: 'physical' },
    isApplicable: function (structure) { return structure.elementCount > 0; },
    ensureCustomProperties: {
        attach: function (ctx, structure) { return _prop__WEBPACK_IMPORTED_MODULE_10__["ClashesProvider"].attach(ctx, structure, void 0, true); },
        detach: function (data) { return _prop__WEBPACK_IMPORTED_MODULE_10__["ClashesProvider"].ref(data, false); }
    }
});
//# sourceMappingURL=representation.js.map

/***/ }),

/***/ "./lib/mol-canvas3d/camera.js":
/*!************************************!*\
  !*** ./lib/mol-canvas3d/camera.js ***!
  \************************************/
/*! exports provided: Camera */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Camera", function() { return Camera; });
/* harmony import */ var _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../mol-math/linear-algebra */ "./lib/mol-math/linear-algebra.js");
/* harmony import */ var _camera_util__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./camera/util */ "./lib/mol-canvas3d/camera/util.js");
/* harmony import */ var _camera_transition__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./camera/transition */ "./lib/mol-canvas3d/camera/transition.js");
/* harmony import */ var rxjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! rxjs */ "./node_modules/rxjs/_esm5/index.js");
/**
 * Copyright (c) 2018-2020 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author David Sehnal <david.sehnal@gmail.com>
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */





var Camera = /** @class */ (function () {
    function Camera(state, viewport, props) {
        if (viewport === void 0) { viewport = _camera_util__WEBPACK_IMPORTED_MODULE_1__["Viewport"].create(0, 0, 128, 128); }
        if (props === void 0) { props = {}; }
        this.view = _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Mat4"].identity();
        this.projection = _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Mat4"].identity();
        this.projectionView = _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Mat4"].identity();
        this.inverseProjectionView = _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Mat4"].identity();
        this.state = Camera.createDefaultSnapshot();
        this.viewOffset = Camera.ViewOffset();
        this.near = 1;
        this.far = 10000;
        this.fogNear = 5000;
        this.fogFar = 10000;
        this.zoom = 1;
        this.transition = new _camera_transition__WEBPACK_IMPORTED_MODULE_2__["CameraTransitionManager"](this);
        this.stateChanged = new rxjs__WEBPACK_IMPORTED_MODULE_3__["BehaviorSubject"](this.state);
        this.prevProjection = _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Mat4"].identity();
        this.prevView = _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Mat4"].identity();
        this.deltaDirection = Object(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"])();
        this.newPosition = Object(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"])();
        this.viewport = viewport;
        this.pixelScale = props.pixelScale || 1;
        Camera.copySnapshot(this.state, state);
    }
    Object.defineProperty(Camera.prototype, "pixelRatio", {
        get: function () {
            var dpr = (typeof window !== 'undefined') ? window.devicePixelRatio : 1;
            return dpr * this.pixelScale;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Camera.prototype, "position", {
        get: function () { return this.state.position; },
        set: function (v) { _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"].copy(this.state.position, v); },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Camera.prototype, "up", {
        get: function () { return this.state.up; },
        set: function (v) { _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"].copy(this.state.up, v); },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Camera.prototype, "target", {
        get: function () { return this.state.target; },
        set: function (v) { _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"].copy(this.state.target, v); },
        enumerable: false,
        configurable: true
    });
    Camera.prototype.update = function () {
        var snapshot = this.state;
        if (snapshot.radiusMax === 0) {
            return false;
        }
        var height = 2 * Math.tan(snapshot.fov / 2) * _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"].distance(snapshot.position, snapshot.target);
        this.zoom = this.viewport.height / height;
        updateClip(this);
        switch (this.state.mode) {
            case 'orthographic':
                updateOrtho(this);
                break;
            case 'perspective':
                updatePers(this);
                break;
            default: throw new Error('unknown camera mode');
        }
        var changed = !_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Mat4"].areEqual(this.projection, this.prevProjection, _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["EPSILON"]) || !_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Mat4"].areEqual(this.view, this.prevView, _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["EPSILON"]);
        if (changed) {
            _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Mat4"].mul(this.projectionView, this.projection, this.view);
            _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Mat4"].invert(this.inverseProjectionView, this.projectionView);
            _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Mat4"].copy(this.prevView, this.view);
            _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Mat4"].copy(this.prevProjection, this.projection);
        }
        return changed;
    };
    Camera.prototype.setState = function (snapshot, durationMs) {
        this.transition.apply(snapshot, durationMs);
        this.stateChanged.next(snapshot);
    };
    Camera.prototype.getSnapshot = function () {
        return Camera.copySnapshot(Camera.createDefaultSnapshot(), this.state);
    };
    Camera.prototype.getTargetDistance = function (radius) {
        return Camera.targetDistance(radius, this.state.fov, this.viewport.width, this.viewport.height);
    };
    Camera.prototype.getFocus = function (target, radius, up, dir) {
        var r = Math.max(radius, 0.01);
        var targetDistance = this.getTargetDistance(r);
        _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"].sub(this.deltaDirection, this.target, this.position);
        if (dir)
            _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"].matchDirection(this.deltaDirection, dir, this.deltaDirection);
        _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"].setMagnitude(this.deltaDirection, this.deltaDirection, targetDistance);
        _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"].sub(this.newPosition, target, this.deltaDirection);
        var state = Camera.copySnapshot(Camera.createDefaultSnapshot(), this.state);
        state.target = _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"].clone(target);
        state.radius = r;
        state.position = _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"].clone(this.newPosition);
        if (up)
            _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"].matchDirection(state.up, up, state.up);
        return state;
    };
    Camera.prototype.focus = function (target, radius, durationMs, up, dir) {
        if (radius > 0) {
            this.setState(this.getFocus(target, radius, up, dir), durationMs);
        }
    };
    Camera.prototype.project = function (out, point) {
        return Object(_camera_util__WEBPACK_IMPORTED_MODULE_1__["cameraProject"])(out, point, this.viewport, this.projectionView);
    };
    Camera.prototype.unproject = function (out, point) {
        return Object(_camera_util__WEBPACK_IMPORTED_MODULE_1__["cameraUnproject"])(out, point, this.viewport, this.inverseProjectionView);
    };
    return Camera;
}());
(function (Camera) {
    function ViewOffset() {
        return {
            enabled: false,
            fullWidth: 1, fullHeight: 1,
            offsetX: 0, offsetY: 0,
            width: 1, height: 1
        };
    }
    Camera.ViewOffset = ViewOffset;
    function setViewOffset(out, fullWidth, fullHeight, offsetX, offsetY, width, height) {
        out.fullWidth = fullWidth;
        out.fullHeight = fullHeight;
        out.offsetX = offsetX;
        out.offsetY = offsetY;
        out.width = width;
        out.height = height;
    }
    Camera.setViewOffset = setViewOffset;
    function copyViewOffset(out, view) {
        out.enabled = view.enabled;
        out.fullWidth = view.fullWidth;
        out.fullHeight = view.fullHeight;
        out.offsetX = view.offsetX;
        out.offsetY = view.offsetY;
        out.width = view.width;
        out.height = view.height;
    }
    Camera.copyViewOffset = copyViewOffset;
    function targetDistance(radius, fov, width, height) {
        var r = Math.max(radius, 0.01);
        var aspect = width / height;
        var aspectFactor = (height < width ? 1 : aspect);
        return Math.abs((r / aspectFactor) / Math.sin(fov / 2));
    }
    Camera.targetDistance = targetDistance;
    function createDefaultSnapshot() {
        return {
            mode: 'perspective',
            fov: Math.PI / 4,
            position: _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"].create(0, 0, 100),
            up: _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"].create(0, 1, 0),
            target: _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"].create(0, 0, 0),
            radius: 0,
            radiusMax: 0,
            fog: 50,
            clipFar: true
        };
    }
    Camera.createDefaultSnapshot = createDefaultSnapshot;
    function copySnapshot(out, source) {
        if (!source)
            return out;
        if (typeof source.mode !== 'undefined')
            out.mode = source.mode;
        if (typeof source.fov !== 'undefined')
            out.fov = source.fov;
        if (typeof source.position !== 'undefined')
            _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"].copy(out.position, source.position);
        if (typeof source.up !== 'undefined')
            _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"].copy(out.up, source.up);
        if (typeof source.target !== 'undefined')
            _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"].copy(out.target, source.target);
        if (typeof source.radius !== 'undefined')
            out.radius = source.radius;
        if (typeof source.radiusMax !== 'undefined')
            out.radiusMax = source.radiusMax;
        if (typeof source.fog !== 'undefined')
            out.fog = source.fog;
        if (typeof source.clipFar !== 'undefined')
            out.clipFar = source.clipFar;
        return out;
    }
    Camera.copySnapshot = copySnapshot;
})(Camera || (Camera = {}));
function updateOrtho(camera) {
    var viewport = camera.viewport, zoom = camera.zoom, near = camera.near, far = camera.far, viewOffset = camera.viewOffset;
    var fullLeft = -viewport.width / 2;
    var fullRight = viewport.width / 2;
    var fullTop = viewport.height / 2;
    var fullBottom = -viewport.height / 2;
    var dx = (fullRight - fullLeft) / (2 * zoom);
    var dy = (fullTop - fullBottom) / (2 * zoom);
    var cx = (fullRight + fullLeft) / 2;
    var cy = (fullTop + fullBottom) / 2;
    var left = cx - dx;
    var right = cx + dx;
    var top = cy + dy;
    var bottom = cy - dy;
    if (viewOffset.enabled) {
        var zoomW = zoom / (viewOffset.width / viewOffset.fullWidth);
        var zoomH = zoom / (viewOffset.height / viewOffset.fullHeight);
        var scaleW = (fullRight - fullLeft) / viewOffset.width;
        var scaleH = (fullTop - fullBottom) / viewOffset.height;
        left += scaleW * (viewOffset.offsetX / zoomW);
        right = left + scaleW * (viewOffset.width / zoomW);
        top -= scaleH * (viewOffset.offsetY / zoomH);
        bottom = top - scaleH * (viewOffset.height / zoomH);
    }
    // build projection matrix
    _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Mat4"].ortho(camera.projection, left, right, top, bottom, near, far);
    // build view matrix
    _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Mat4"].lookAt(camera.view, camera.position, camera.target, camera.up);
}
function updatePers(camera) {
    var aspect = camera.viewport.width / camera.viewport.height;
    var near = camera.near, far = camera.far, viewOffset = camera.viewOffset;
    var top = near * Math.tan(0.5 * camera.state.fov);
    var height = 2 * top;
    var width = aspect * height;
    var left = -0.5 * width;
    if (viewOffset.enabled) {
        left += viewOffset.offsetX * width / viewOffset.fullWidth;
        top -= viewOffset.offsetY * height / viewOffset.fullHeight;
        width *= viewOffset.width / viewOffset.fullWidth;
        height *= viewOffset.height / viewOffset.fullHeight;
    }
    // build projection matrix
    _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Mat4"].perspective(camera.projection, left, left + width, top, top - height, near, far);
    // build view matrix
    _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Mat4"].lookAt(camera.view, camera.position, camera.target, camera.up);
}
function updateClip(camera) {
    var _a = camera.state, radius = _a.radius, radiusMax = _a.radiusMax, mode = _a.mode, fog = _a.fog, clipFar = _a.clipFar;
    if (radius < 0.01)
        radius = 0.01;
    var normalizedFar = clipFar ? radius : radiusMax;
    var cameraDistance = _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"].distance(camera.position, camera.target);
    var near = cameraDistance - radius;
    var far = cameraDistance + normalizedFar;
    var fogNearFactor = -(50 - fog) / 50;
    var fogNear = cameraDistance - (normalizedFar * fogNearFactor);
    var fogFar = far;
    if (mode === 'perspective') {
        // set at least to 5 to avoid slow sphere impostor rendering
        near = Math.max(Math.min(radiusMax, 5), near);
        far = Math.max(5, far);
    }
    else {
        near = Math.max(0, near);
        far = Math.max(0, far);
    }
    if (near === far) {
        // make sure near and far are not identical to avoid Infinity in the projection matrix
        far = near + 0.01;
    }
    camera.near = near;
    camera.far = 2 * far; // avoid precision issues distingushing far objects from background
    camera.fogNear = fogNear;
    camera.fogFar = fogFar;
}
//# sourceMappingURL=camera.js.map

/***/ }),

/***/ "./lib/mol-canvas3d/camera/stereo.js":
/*!*******************************************!*\
  !*** ./lib/mol-canvas3d/camera/stereo.js ***!
  \*******************************************/
/*! exports provided: StereoCameraParams, DefaultStereoCameraProps, StereoCamera */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "StereoCameraParams", function() { return StereoCameraParams; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DefaultStereoCameraProps", function() { return DefaultStereoCameraProps; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "StereoCamera", function() { return StereoCamera; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../mol-math/linear-algebra */ "./lib/mol-math/linear-algebra.js");
/* harmony import */ var _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../mol-util/param-definition */ "./lib/mol-util/param-definition.js");
/* harmony import */ var _camera__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../camera */ "./lib/mol-canvas3d/camera.js");
/* harmony import */ var _util__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./util */ "./lib/mol-canvas3d/camera/util.js");
/**
 * Copyright (c) 2020 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author David Sehnal <david.sehnal@gmail.com>
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 *
 * Adapted from three.js, The MIT License, Copyright © 2010-2020 three.js authors
 */





var StereoCameraParams = {
    eyeSeparation: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_2__["ParamDefinition"].Numeric(0.064, { min: 0.01, max: 0.5, step: 0.001 }),
    focus: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_2__["ParamDefinition"].Numeric(10, { min: 1, max: 100, step: 0.01 }),
};
var DefaultStereoCameraProps = _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_2__["ParamDefinition"].getDefaultValues(StereoCameraParams);

var StereoCamera = /** @class */ (function () {
    function StereoCamera(parent, props) {
        if (props === void 0) { props = {}; }
        this.parent = parent;
        this.left = new EyeCamera();
        this.right = new EyeCamera();
        this.props = Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, DefaultStereoCameraProps), props);
    }
    Object.defineProperty(StereoCamera.prototype, "viewport", {
        get: function () {
            return this.parent.viewport;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(StereoCamera.prototype, "viewOffset", {
        get: function () {
            return this.parent.viewOffset;
        },
        enumerable: false,
        configurable: true
    });
    StereoCamera.prototype.setProps = function (props) {
        Object.assign(this.props, props);
    };
    StereoCamera.prototype.update = function () {
        this.parent.update();
        update(this.parent, this.props, this.left, this.right);
    };
    return StereoCamera;
}());
(function (StereoCamera) {
    function is(camera) {
        return 'left' in camera && 'right' in camera;
    }
    StereoCamera.is = is;
})(StereoCamera || (StereoCamera = {}));
var EyeCamera = /** @class */ (function () {
    function EyeCamera() {
        this.viewport = _util__WEBPACK_IMPORTED_MODULE_4__["Viewport"].create(0, 0, 0, 0);
        this.view = Object(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_1__["Mat4"])();
        this.projection = Object(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_1__["Mat4"])();
        this.projectionView = Object(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_1__["Mat4"])();
        this.inverseProjectionView = Object(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_1__["Mat4"])();
        this.state = _camera__WEBPACK_IMPORTED_MODULE_3__["Camera"].createDefaultSnapshot();
        this.viewOffset = _camera__WEBPACK_IMPORTED_MODULE_3__["Camera"].ViewOffset();
        this.far = 0;
        this.near = 0;
        this.fogFar = 0;
        this.fogNear = 0;
    }
    return EyeCamera;
}());
var eyeLeft = _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_1__["Mat4"].identity(), eyeRight = _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_1__["Mat4"].identity();
function update(camera, props, left, right) {
    // Copy the states
    _util__WEBPACK_IMPORTED_MODULE_4__["Viewport"].copy(left.viewport, camera.viewport);
    _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_1__["Mat4"].copy(left.view, camera.view);
    _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_1__["Mat4"].copy(left.projection, camera.projection);
    _camera__WEBPACK_IMPORTED_MODULE_3__["Camera"].copySnapshot(left.state, camera.state);
    _camera__WEBPACK_IMPORTED_MODULE_3__["Camera"].copyViewOffset(left.viewOffset, camera.viewOffset);
    left.far = camera.far;
    left.near = camera.near;
    left.fogFar = camera.fogFar;
    left.fogNear = camera.fogNear;
    _util__WEBPACK_IMPORTED_MODULE_4__["Viewport"].copy(right.viewport, camera.viewport);
    _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_1__["Mat4"].copy(right.view, camera.view);
    _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_1__["Mat4"].copy(right.projection, camera.projection);
    _camera__WEBPACK_IMPORTED_MODULE_3__["Camera"].copySnapshot(right.state, camera.state);
    _camera__WEBPACK_IMPORTED_MODULE_3__["Camera"].copyViewOffset(right.viewOffset, camera.viewOffset);
    right.far = camera.far;
    right.near = camera.near;
    right.fogFar = camera.fogFar;
    right.fogNear = camera.fogNear;
    // update the view offsets
    var w = Math.floor(camera.viewport.width / 2);
    var aspect = w / camera.viewport.height;
    left.viewport.width = w;
    right.viewport.x += w;
    right.viewport.width -= w;
    // update the projection and view matrices
    var eyeSepHalf = props.eyeSeparation / 2;
    var eyeSepOnProjection = eyeSepHalf * camera.near / props.focus;
    var ymax = camera.near * Math.tan(camera.state.fov * 0.5);
    var xmin, xmax;
    // translate xOffset
    eyeLeft[12] = -eyeSepHalf;
    eyeRight[12] = eyeSepHalf;
    // for left eye
    xmin = -ymax * aspect + eyeSepOnProjection;
    xmax = ymax * aspect + eyeSepOnProjection;
    left.projection[0] = 2 * camera.near / (xmax - xmin);
    left.projection[8] = (xmax + xmin) / (xmax - xmin);
    _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_1__["Mat4"].mul(left.view, left.view, eyeLeft);
    _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_1__["Mat4"].mul(left.projectionView, left.projection, left.view);
    _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_1__["Mat4"].invert(left.inverseProjectionView, left.projectionView);
    // for right eye
    xmin = -ymax * aspect - eyeSepOnProjection;
    xmax = ymax * aspect - eyeSepOnProjection;
    right.projection[0] = 2 * camera.near / (xmax - xmin);
    right.projection[8] = (xmax + xmin) / (xmax - xmin);
    _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_1__["Mat4"].mul(right.view, right.view, eyeRight);
    _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_1__["Mat4"].mul(right.projectionView, right.projection, right.view);
    _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_1__["Mat4"].invert(right.inverseProjectionView, right.projectionView);
}
//# sourceMappingURL=stereo.js.map

/***/ }),

/***/ "./lib/mol-canvas3d/camera/transition.js":
/*!***********************************************!*\
  !*** ./lib/mol-canvas3d/camera/transition.js ***!
  \***********************************************/
/*! exports provided: CameraTransitionManager */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CameraTransitionManager", function() { return CameraTransitionManager; });
/* harmony import */ var _camera__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../camera */ "./lib/mol-canvas3d/camera.js");
/* harmony import */ var _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../mol-math/linear-algebra */ "./lib/mol-math/linear-algebra.js");
/* harmony import */ var _mol_math_interpolate__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../mol-math/interpolate */ "./lib/mol-math/interpolate.js");
/**
 * Copyright (c) 2018-2019 Mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author David Sehnal <david.sehnal@gmail.com>
 */




var CameraTransitionManager = /** @class */ (function () {
    function CameraTransitionManager(camera) {
        this.camera = camera;
        this.t = 0;
        this.func = CameraTransitionManager.defaultTransition;
        this.start = 0;
        this.inTransition = false;
        this.durationMs = 0;
        this._source = _camera__WEBPACK_IMPORTED_MODULE_0__["Camera"].createDefaultSnapshot();
        this._target = _camera__WEBPACK_IMPORTED_MODULE_0__["Camera"].createDefaultSnapshot();
        this._current = _camera__WEBPACK_IMPORTED_MODULE_0__["Camera"].createDefaultSnapshot();
    }
    Object.defineProperty(CameraTransitionManager.prototype, "source", {
        get: function () { return this._source; },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CameraTransitionManager.prototype, "target", {
        get: function () { return this._target; },
        enumerable: false,
        configurable: true
    });
    CameraTransitionManager.prototype.apply = function (to, durationMs, transition) {
        if (durationMs === void 0) { durationMs = 0; }
        if (!this.inTransition || durationMs > 0) {
            _camera__WEBPACK_IMPORTED_MODULE_0__["Camera"].copySnapshot(this._source, this.camera.state);
        }
        if (!this.inTransition) {
            _camera__WEBPACK_IMPORTED_MODULE_0__["Camera"].copySnapshot(this._target, this.camera.state);
        }
        _camera__WEBPACK_IMPORTED_MODULE_0__["Camera"].copySnapshot(this._target, to);
        if (this._target.radius > this._target.radiusMax) {
            this._target.radius = this._target.radiusMax;
        }
        if (!this.inTransition && durationMs <= 0 || (typeof to.mode !== 'undefined' && to.mode !== this.camera.state.mode)) {
            this.finish(this._target);
            return;
        }
        this.inTransition = true;
        this.func = transition || CameraTransitionManager.defaultTransition;
        if (!this.inTransition || durationMs > 0) {
            this.start = this.t;
            this.durationMs = durationMs;
        }
    };
    CameraTransitionManager.prototype.tick = function (t) {
        this.t = t;
        this.update();
    };
    CameraTransitionManager.prototype.finish = function (to) {
        _camera__WEBPACK_IMPORTED_MODULE_0__["Camera"].copySnapshot(this.camera.state, to);
        this.inTransition = false;
    };
    CameraTransitionManager.prototype.update = function () {
        if (!this.inTransition)
            return;
        var normalized = Math.min((this.t - this.start) / this.durationMs, 1);
        if (normalized === 1) {
            this.finish(this._target);
            return;
        }
        this.func(this._current, normalized, this._source, this._target);
        _camera__WEBPACK_IMPORTED_MODULE_0__["Camera"].copySnapshot(this.camera.state, this._current);
    };
    return CameraTransitionManager;
}());
(function (CameraTransitionManager) {
    var _rot = _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_1__["Quat"].identity();
    function defaultTransition(out, t, source, target) {
        _camera__WEBPACK_IMPORTED_MODULE_0__["Camera"].copySnapshot(out, target);
        // Rotate up
        _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_1__["Quat"].slerp(_rot, _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_1__["Quat"].Identity, _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_1__["Quat"].rotationTo(_rot, source.up, target.up), t);
        _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_1__["Vec3"].transformQuat(out.up, source.up, _rot);
        // Lerp target, position & radius
        _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_1__["Vec3"].lerp(out.target, source.target, target.target, t);
        _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_1__["Vec3"].lerp(out.position, source.position, target.position, t);
        out.radius = Object(_mol_math_interpolate__WEBPACK_IMPORTED_MODULE_2__["lerp"])(source.radius, target.radius, t);
        // TODO take change of `clipFar` into account
        out.radiusMax = Object(_mol_math_interpolate__WEBPACK_IMPORTED_MODULE_2__["lerp"])(source.radiusMax, target.radiusMax, t);
        // Lerp fov & fog
        out.fov = Object(_mol_math_interpolate__WEBPACK_IMPORTED_MODULE_2__["lerp"])(source.fov, target.fov, t);
        out.fog = Object(_mol_math_interpolate__WEBPACK_IMPORTED_MODULE_2__["lerp"])(source.fog, target.fog, t);
    }
    CameraTransitionManager.defaultTransition = defaultTransition;
})(CameraTransitionManager || (CameraTransitionManager = {}));
//# sourceMappingURL=transition.js.map

/***/ }),

/***/ "./lib/mol-canvas3d/camera/util.js":
/*!*****************************************!*\
  !*** ./lib/mol-canvas3d/camera/util.js ***!
  \*****************************************/
/*! exports provided: Viewport, cameraProject, cameraUnproject */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Viewport", function() { return Viewport; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "cameraProject", function() { return cameraProject; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "cameraUnproject", function() { return cameraUnproject; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../mol-math/linear-algebra */ "./lib/mol-math/linear-algebra.js");
/**
 * Copyright (c) 2018-2019 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */



function Viewport() {
    return Viewport.zero();
}
(function (Viewport) {
    function zero() {
        return { x: 0, y: 0, width: 0, height: 0 };
    }
    Viewport.zero = zero;
    function create(x, y, width, height) {
        return { x: x, y: y, width: width, height: height };
    }
    Viewport.create = create;
    function clone(viewport) {
        return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, viewport);
    }
    Viewport.clone = clone;
    function copy(target, source) {
        return Object.assign(target, source);
    }
    Viewport.copy = copy;
    function set(viewport, x, y, width, height) {
        viewport.x = x;
        viewport.y = y;
        viewport.width = width;
        viewport.height = height;
        return viewport;
    }
    Viewport.set = set;
    function toVec4(v4, viewport) {
        v4[0] = viewport.x;
        v4[1] = viewport.y;
        v4[2] = viewport.width;
        v4[3] = viewport.height;
        return v4;
    }
    Viewport.toVec4 = toVec4;
    function equals(a, b) {
        return a.x === b.x && a.y === b.y && a.width === b.width && a.height === b.height;
    }
    Viewport.equals = equals;
})(Viewport || (Viewport = {}));
//
var NEAR_RANGE = 0;
var FAR_RANGE = 1;
var tmpVec4 = Object(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_1__["Vec4"])();
/** Transform point into 2D window coordinates. */
function cameraProject(out, point, viewport, projectionView) {
    var vX = viewport.x, vY = viewport.y, vWidth = viewport.width, vHeight = viewport.height;
    // clip space -> NDC -> window coordinates, implicit 1.0 for w component
    _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_1__["Vec4"].set(tmpVec4, point[0], point[1], point[2], 1.0);
    // transform into clip space
    _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_1__["Vec4"].transformMat4(tmpVec4, tmpVec4, projectionView);
    // transform into NDC
    var w = tmpVec4[3];
    if (w !== 0) {
        tmpVec4[0] /= w;
        tmpVec4[1] /= w;
        tmpVec4[2] /= w;
    }
    // transform into window coordinates, set fourth component is (1/clip.w) as in gl_FragCoord.w
    out[0] = vX + vWidth / 2 * tmpVec4[0] + (0 + vWidth / 2);
    out[1] = vY + vHeight / 2 * tmpVec4[1] + (0 + vHeight / 2);
    out[2] = (FAR_RANGE - NEAR_RANGE) / 2 * tmpVec4[2] + (FAR_RANGE + NEAR_RANGE) / 2;
    out[3] = w === 0 ? 0 : 1 / w;
    return out;
}
/**
 * Transform point from screen space to 3D coordinates.
 * The point must have x and y set to 2D window coordinates and z between 0 (near) and 1 (far).
 */
function cameraUnproject(out, point, viewport, inverseProjectionView) {
    var vX = viewport.x, vY = viewport.y, vWidth = viewport.width, vHeight = viewport.height;
    var x = point[0] - vX;
    var y = (vHeight - point[1] - 1) - vY;
    var z = point[2];
    out[0] = (2 * x) / vWidth - 1;
    out[1] = (2 * y) / vHeight - 1;
    out[2] = 2 * z - 1;
    return _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_1__["Vec3"].transformMat4(out, out, inverseProjectionView);
}
//# sourceMappingURL=util.js.map

/***/ }),

/***/ "./lib/mol-canvas3d/canvas3d.js":
/*!**************************************!*\
  !*** ./lib/mol-canvas3d/canvas3d.js ***!
  \**************************************/
/*! exports provided: Canvas3DParams, DefaultCanvas3DParams, Canvas3DContext, Canvas3D */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* WEBPACK VAR INJECTION */(function(setImmediate, clearImmediate) {/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Canvas3DParams", function() { return Canvas3DParams; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DefaultCanvas3DParams", function() { return DefaultCanvas3DParams; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Canvas3DContext", function() { return Canvas3DContext; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Canvas3D", function() { return Canvas3D; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var rxjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! rxjs */ "./node_modules/rxjs/_esm5/index.js");
/* harmony import */ var _mol_util_now__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../mol-util/now */ "./lib/mol-util/now.js");
/* harmony import */ var _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../mol-math/linear-algebra */ "./lib/mol-math/linear-algebra.js");
/* harmony import */ var _mol_util_input_input_observer__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../mol-util/input/input-observer */ "./lib/mol-util/input/input-observer.js");
/* harmony import */ var _mol_gl_renderer__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../mol-gl/renderer */ "./lib/mol-gl/renderer.js");
/* harmony import */ var _controls_trackball__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ./controls/trackball */ "./lib/mol-canvas3d/controls/trackball.js");
/* harmony import */ var _camera_util__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ./camera/util */ "./lib/mol-canvas3d/camera/util.js");
/* harmony import */ var _mol_gl_webgl_context__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ../mol-gl/webgl/context */ "./lib/mol-gl/webgl/context.js");
/* harmony import */ var _mol_repr_representation__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ../mol-repr/representation */ "./lib/mol-repr/representation.js");
/* harmony import */ var _mol_gl_scene__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ../mol-gl/scene */ "./lib/mol-gl/scene.js");
/* harmony import */ var _mol_model_loci__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ../mol-model/loci */ "./lib/mol-model/loci.js");
/* harmony import */ var _camera__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! ./camera */ "./lib/mol-canvas3d/camera.js");
/* harmony import */ var _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! ../mol-util/param-definition */ "./lib/mol-util/param-definition.js");
/* harmony import */ var _helper_bounding_sphere_helper__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! ./helper/bounding-sphere-helper */ "./lib/mol-canvas3d/helper/bounding-sphere-helper.js");
/* harmony import */ var _mol_util_set__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! ../mol-util/set */ "./lib/mol-util/set.js");
/* harmony import */ var _helper_interaction_events__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(/*! ./helper/interaction-events */ "./lib/mol-canvas3d/helper/interaction-events.js");
/* harmony import */ var _passes_postprocessing__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(/*! ./passes/postprocessing */ "./lib/mol-canvas3d/passes/postprocessing.js");
/* harmony import */ var _passes_multi_sample__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(/*! ./passes/multi-sample */ "./lib/mol-canvas3d/passes/multi-sample.js");
/* harmony import */ var _passes_pick__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(/*! ./passes/pick */ "./lib/mol-canvas3d/passes/pick.js");
/* harmony import */ var _passes_image__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(/*! ./passes/image */ "./lib/mol-canvas3d/passes/image.js");
/* harmony import */ var _mol_math_geometry__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(/*! ../mol-math/geometry */ "./lib/mol-math/geometry.js");
/* harmony import */ var _mol_util_debug__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(/*! ../mol-util/debug */ "./lib/mol-util/debug.js");
/* harmony import */ var _helper_camera_helper__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(/*! ./helper/camera-helper */ "./lib/mol-canvas3d/helper/camera-helper.js");
/* harmony import */ var immer__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(/*! immer */ "./node_modules/immer/dist/immer.esm.js");
/* harmony import */ var _helper_handle_helper__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__(/*! ./helper/handle-helper */ "./lib/mol-canvas3d/helper/handle-helper.js");
/* harmony import */ var _camera_stereo__WEBPACK_IMPORTED_MODULE_26__ = __webpack_require__(/*! ./camera/stereo */ "./lib/mol-canvas3d/camera/stereo.js");
/* harmony import */ var _helper_helper__WEBPACK_IMPORTED_MODULE_27__ = __webpack_require__(/*! ./helper/helper */ "./lib/mol-canvas3d/helper/helper.js");
/* harmony import */ var _passes_passes__WEBPACK_IMPORTED_MODULE_28__ = __webpack_require__(/*! ./passes/passes */ "./lib/mol-canvas3d/passes/passes.js");
/* harmony import */ var _mol_util__WEBPACK_IMPORTED_MODULE_29__ = __webpack_require__(/*! ../mol-util */ "./lib/mol-util/index.js");
/**
 * Copyright (c) 2018-2021 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 * @author David Sehnal <david.sehnal@gmail.com>
 */






























var Canvas3DParams = {
    camera: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_13__["ParamDefinition"].Group({
        mode: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_13__["ParamDefinition"].Select('perspective', _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_13__["ParamDefinition"].arrayToOptions(['perspective', 'orthographic']), { label: 'Camera' }),
        helper: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_13__["ParamDefinition"].Group(_helper_camera_helper__WEBPACK_IMPORTED_MODULE_23__["CameraHelperParams"], { isFlat: true }),
        stereo: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_13__["ParamDefinition"].MappedStatic('off', {
            on: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_13__["ParamDefinition"].Group(_camera_stereo__WEBPACK_IMPORTED_MODULE_26__["StereoCameraParams"]),
            off: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_13__["ParamDefinition"].Group({})
        }, { cycle: true, hideIf: function (p) { return (p === null || p === void 0 ? void 0 : p.mode) !== 'perspective'; } }),
        manualReset: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_13__["ParamDefinition"].Boolean(false, { isHidden: true }),
    }, { pivot: 'mode' }),
    cameraFog: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_13__["ParamDefinition"].MappedStatic('on', {
        on: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_13__["ParamDefinition"].Group({
            intensity: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_13__["ParamDefinition"].Numeric(15, { min: 1, max: 100, step: 1 }),
        }),
        off: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_13__["ParamDefinition"].Group({})
    }, { cycle: true, description: 'Show fog in the distance' }),
    cameraClipping: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_13__["ParamDefinition"].Group({
        radius: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_13__["ParamDefinition"].Numeric(100, { min: 0, max: 99, step: 1 }, { label: 'Clipping', description: 'How much of the scene to show.' }),
        far: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_13__["ParamDefinition"].Boolean(true, { description: 'Hide scene in the distance' }),
    }, { pivot: 'radius' }),
    viewport: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_13__["ParamDefinition"].MappedStatic('canvas', {
        canvas: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_13__["ParamDefinition"].Group({}),
        custom: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_13__["ParamDefinition"].Group({
            x: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_13__["ParamDefinition"].Numeric(0),
            y: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_13__["ParamDefinition"].Numeric(0),
            width: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_13__["ParamDefinition"].Numeric(128),
            height: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_13__["ParamDefinition"].Numeric(128)
        })
    }),
    cameraResetDurationMs: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_13__["ParamDefinition"].Numeric(250, { min: 0, max: 1000, step: 1 }, { description: 'The time it takes to reset the camera.' }),
    transparentBackground: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_13__["ParamDefinition"].Boolean(false),
    multiSample: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_13__["ParamDefinition"].Group(_passes_multi_sample__WEBPACK_IMPORTED_MODULE_18__["MultiSampleParams"]),
    postprocessing: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_13__["ParamDefinition"].Group(_passes_postprocessing__WEBPACK_IMPORTED_MODULE_17__["PostprocessingParams"]),
    renderer: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_13__["ParamDefinition"].Group(_mol_gl_renderer__WEBPACK_IMPORTED_MODULE_5__["RendererParams"]),
    trackball: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_13__["ParamDefinition"].Group(_controls_trackball__WEBPACK_IMPORTED_MODULE_6__["TrackballControlsParams"]),
    debug: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_13__["ParamDefinition"].Group(_helper_bounding_sphere_helper__WEBPACK_IMPORTED_MODULE_14__["DebugHelperParams"]),
    handle: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_13__["ParamDefinition"].Group(_helper_handle_helper__WEBPACK_IMPORTED_MODULE_25__["HandleHelperParams"]),
};
var DefaultCanvas3DParams = _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_13__["ParamDefinition"].getDefaultValues(Canvas3DParams);

var Canvas3DContext;
(function (Canvas3DContext) {
    var DefaultAttribs = {
        /** true by default to avoid issues with Safari (Jan 2021) */
        antialias: true,
        /** true to support multiple Canvas3D objects with a single context */
        preserveDrawingBuffer: true,
        pixelScale: 1,
        pickScale: 0.25,
        enableWboit: true
    };
    function fromCanvas(canvas, attribs) {
        if (attribs === void 0) { attribs = {}; }
        var a = Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, DefaultAttribs), attribs);
        var antialias = a.antialias, preserveDrawingBuffer = a.preserveDrawingBuffer, pixelScale = a.pixelScale;
        var gl = Object(_mol_gl_webgl_context__WEBPACK_IMPORTED_MODULE_8__["getGLContext"])(canvas, {
            antialias: antialias,
            preserveDrawingBuffer: preserveDrawingBuffer,
            alpha: true,
            depth: true,
            premultipliedAlpha: true,
        });
        if (gl === null)
            throw new Error('Could not create a WebGL rendering context');
        var input = _mol_util_input_input_observer__WEBPACK_IMPORTED_MODULE_4__["default"].fromElement(canvas, { pixelScale: pixelScale });
        var webgl = Object(_mol_gl_webgl_context__WEBPACK_IMPORTED_MODULE_8__["createContext"])(gl, { pixelScale: pixelScale });
        var passes = new _passes_passes__WEBPACK_IMPORTED_MODULE_28__["Passes"](webgl, attribs);
        if (_mol_util_debug__WEBPACK_IMPORTED_MODULE_22__["isDebugMode"]) {
            var loseContextExt_1 = gl.getExtension('WEBGL_lose_context');
            if (loseContextExt_1) {
                // Hold down shift+ctrl+alt and press any mouse button to call `loseContext`.
                // After 1 second `restoreContext` will be called.
                canvas.addEventListener('mousedown', function (e) {
                    if (webgl.isContextLost)
                        return;
                    if (!e.shiftKey || !e.ctrlKey || !e.altKey)
                        return;
                    if (_mol_util_debug__WEBPACK_IMPORTED_MODULE_22__["isDebugMode"])
                        console.log('lose context');
                    loseContextExt_1.loseContext();
                    setTimeout(function () {
                        if (!webgl.isContextLost)
                            return;
                        if (_mol_util_debug__WEBPACK_IMPORTED_MODULE_22__["isDebugMode"])
                            console.log('restore context');
                        loseContextExt_1.restoreContext();
                    }, 1000);
                }, false);
            }
        }
        // https://www.khronos.org/webgl/wiki/HandlingContextLost
        var contextLost = new rxjs__WEBPACK_IMPORTED_MODULE_1__["BehaviorSubject"](0);
        var handleWebglContextLost = function (e) {
            webgl.setContextLost();
            e.preventDefault();
            if (_mol_util_debug__WEBPACK_IMPORTED_MODULE_22__["isDebugMode"])
                console.log('context lost');
            contextLost.next(Object(_mol_util_now__WEBPACK_IMPORTED_MODULE_2__["now"])());
        };
        var handlewWebglContextRestored = function () {
            if (!webgl.isContextLost)
                return;
            webgl.handleContextRestored(function () {
                passes.draw.reset();
            });
            if (_mol_util_debug__WEBPACK_IMPORTED_MODULE_22__["isDebugMode"])
                console.log('context restored');
        };
        canvas.addEventListener('webglcontextlost', handleWebglContextLost, false);
        canvas.addEventListener('webglcontextrestored', handlewWebglContextRestored, false);
        return {
            canvas: canvas,
            webgl: webgl,
            input: input,
            passes: passes,
            attribs: a,
            contextLost: contextLost,
            contextRestored: webgl.contextRestored,
            dispose: function (options) {
                input.dispose();
                canvas.removeEventListener('webglcontextlost', handleWebglContextLost, false);
                canvas.removeEventListener('webglcontextrestored', handlewWebglContextRestored, false);
                webgl.destroy(options);
            }
        };
    }
    Canvas3DContext.fromCanvas = fromCanvas;
})(Canvas3DContext || (Canvas3DContext = {}));

var requestAnimationFrame = typeof window !== 'undefined'
    ? window.requestAnimationFrame
    : function (f) { return setImmediate(function () { return f(Date.now()); }); };
var cancelAnimationFrame = typeof window !== 'undefined'
    ? window.cancelAnimationFrame
    : function (handle) { return clearImmediate(handle); };
var Canvas3D;
(function (Canvas3D) {
    function create(_a, props) {
        var webgl = _a.webgl, input = _a.input, passes = _a.passes, attribs = _a.attribs;
        if (props === void 0) { props = {}; }
        var p = Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, DefaultCanvas3DParams), props);
        var reprRenderObjects = new Map();
        var reprUpdatedSubscriptions = new Map();
        var reprCount = new rxjs__WEBPACK_IMPORTED_MODULE_1__["BehaviorSubject"](0);
        var startTime = Object(_mol_util_now__WEBPACK_IMPORTED_MODULE_2__["now"])();
        var didDraw = new rxjs__WEBPACK_IMPORTED_MODULE_1__["BehaviorSubject"](0);
        var commited = new rxjs__WEBPACK_IMPORTED_MODULE_1__["BehaviorSubject"](0);
        var gl = webgl.gl, contextRestored = webgl.contextRestored;
        var x = 0;
        var y = 0;
        var width = 128;
        var height = 128;
        updateViewport();
        var scene = _mol_gl_scene__WEBPACK_IMPORTED_MODULE_10__["default"].create(webgl);
        var camera = new _camera__WEBPACK_IMPORTED_MODULE_12__["Camera"]({
            position: _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_3__["Vec3"].create(0, 0, 100),
            mode: p.camera.mode,
            fog: p.cameraFog.name === 'on' ? p.cameraFog.params.intensity : 0,
            clipFar: p.cameraClipping.far
        }, { x: x, y: y, width: width, height: height }, { pixelScale: attribs.pixelScale });
        var stereoCamera = new _camera_stereo__WEBPACK_IMPORTED_MODULE_26__["StereoCamera"](camera, p.camera.stereo.params);
        var controls = _controls_trackball__WEBPACK_IMPORTED_MODULE_6__["TrackballControls"].create(input, camera, p.trackball);
        var renderer = _mol_gl_renderer__WEBPACK_IMPORTED_MODULE_5__["default"].create(webgl, p.renderer);
        var helper = new _helper_helper__WEBPACK_IMPORTED_MODULE_27__["Helper"](webgl, scene, p);
        var pickHelper = new _passes_pick__WEBPACK_IMPORTED_MODULE_19__["PickHelper"](webgl, renderer, scene, helper, passes.pick, { x: x, y: y, width: width, height: height });
        var interactionHelper = new _helper_interaction_events__WEBPACK_IMPORTED_MODULE_16__["Canvas3dInteractionHelper"](identify, getLoci, input, camera);
        var multiSampleHelper = new _passes_multi_sample__WEBPACK_IMPORTED_MODULE_18__["MultiSampleHelper"](passes.multiSample);
        var drawPending = false;
        var cameraResetRequested = false;
        var nextCameraResetDuration = void 0;
        var nextCameraResetSnapshot = void 0;
        var resizeRequested = false;
        var notifyDidDraw = true;
        function getLoci(pickingId) {
            var loci = _mol_model_loci__WEBPACK_IMPORTED_MODULE_11__["EmptyLoci"];
            var repr = _mol_repr_representation__WEBPACK_IMPORTED_MODULE_9__["Representation"].Empty;
            if (pickingId) {
                loci = helper.handle.getLoci(pickingId);
                reprRenderObjects.forEach(function (_, _repr) {
                    var _loci = _repr.getLoci(pickingId);
                    if (!Object(_mol_model_loci__WEBPACK_IMPORTED_MODULE_11__["isEmptyLoci"])(_loci)) {
                        if (!Object(_mol_model_loci__WEBPACK_IMPORTED_MODULE_11__["isEmptyLoci"])(loci)) {
                            console.warn('found another loci, this should not happen');
                        }
                        loci = _loci;
                        repr = _repr;
                    }
                });
            }
            return { loci: loci, repr: repr };
        }
        function mark(reprLoci, action) {
            var repr = reprLoci.repr, loci = reprLoci.loci;
            var changed = false;
            if (repr) {
                changed = repr.mark(loci, action);
            }
            else {
                changed = helper.handle.mark(loci, action);
                reprRenderObjects.forEach(function (_, _repr) { changed = _repr.mark(loci, action) || changed; });
            }
            if (changed) {
                scene.update(void 0, true);
                helper.handle.scene.update(void 0, true);
                var prevPickDirty = pickHelper.dirty;
                draw(true);
                pickHelper.dirty = prevPickDirty; // marking does not change picking buffers
            }
        }
        function render(force) {
            if (webgl.isContextLost)
                return false;
            var resized = false;
            if (resizeRequested) {
                handleResize(false);
                resizeRequested = false;
                resized = true;
            }
            if (x > gl.drawingBufferWidth || x + width < 0 ||
                y > gl.drawingBufferHeight || y + height < 0)
                return false;
            var didRender = false;
            controls.update(currentTime);
            var cameraChanged = camera.update();
            var multiSampleChanged = multiSampleHelper.update(force || cameraChanged, p.multiSample);
            if (resized || force || cameraChanged || multiSampleChanged) {
                var cam = camera;
                if (p.camera.stereo.name === 'on') {
                    stereoCamera.update();
                    cam = stereoCamera;
                }
                if (_passes_multi_sample__WEBPACK_IMPORTED_MODULE_18__["MultiSamplePass"].isEnabled(p.multiSample)) {
                    multiSampleHelper.render(renderer, cam, scene, helper, true, p.transparentBackground, p);
                }
                else {
                    passes.draw.render(renderer, cam, scene, helper, true, p.transparentBackground, p.postprocessing);
                }
                pickHelper.dirty = true;
                didRender = true;
            }
            return didRender;
        }
        var forceNextDraw = false;
        var forceDrawAfterAllCommited = false;
        var currentTime = 0;
        function draw(force) {
            if (render(!!force || forceNextDraw) && notifyDidDraw) {
                didDraw.next(Object(_mol_util_now__WEBPACK_IMPORTED_MODULE_2__["now"])() - startTime);
            }
            forceNextDraw = false;
            drawPending = false;
        }
        function requestDraw(force) {
            if (drawPending)
                return;
            drawPending = true;
            forceNextDraw = !!force;
        }
        var animationFrameHandle = 0;
        function tick(t, options) {
            currentTime = t;
            commit(options === null || options === void 0 ? void 0 : options.isSynchronous);
            camera.transition.tick(currentTime);
            if (options === null || options === void 0 ? void 0 : options.manualDraw) {
                return;
            }
            draw(false);
            if (!camera.transition.inTransition && !webgl.isContextLost) {
                interactionHelper.tick(currentTime);
            }
        }
        function _animate() {
            tick(Object(_mol_util_now__WEBPACK_IMPORTED_MODULE_2__["now"])());
            animationFrameHandle = requestAnimationFrame(_animate);
        }
        function resetTime(t) {
            startTime = t;
            controls.start(t);
        }
        function animate() {
            controls.start(Object(_mol_util_now__WEBPACK_IMPORTED_MODULE_2__["now"])());
            if (animationFrameHandle === 0)
                _animate();
        }
        function pause() {
            cancelAnimationFrame(animationFrameHandle);
            animationFrameHandle = 0;
        }
        function identify(x, y) {
            var cam = p.camera.stereo.name === 'on' ? stereoCamera : camera;
            return webgl.isContextLost ? undefined : pickHelper.identify(x, y, cam);
        }
        function commit(isSynchronous) {
            if (isSynchronous === void 0) { isSynchronous = false; }
            var allCommited = commitScene(isSynchronous);
            // Only reset the camera after the full scene has been commited.
            if (allCommited) {
                resolveCameraReset();
                if (forceDrawAfterAllCommited) {
                    if (helper.debug.isEnabled)
                        helper.debug.update();
                    draw(true);
                    forceDrawAfterAllCommited = false;
                }
                commited.next(Object(_mol_util_now__WEBPACK_IMPORTED_MODULE_2__["now"])());
            }
        }
        function resolveCameraReset() {
            if (!cameraResetRequested)
                return;
            var _a = scene.boundingSphereVisible, center = _a.center, radius = _a.radius;
            if (radius > 0) {
                var duration = nextCameraResetDuration === undefined ? p.cameraResetDurationMs : nextCameraResetDuration;
                var focus_1 = camera.getFocus(center, radius);
                var snapshot = nextCameraResetSnapshot ? Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, focus_1), nextCameraResetSnapshot) : focus_1;
                camera.setState(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, snapshot), { radiusMax: scene.boundingSphere.radius }), duration);
            }
            nextCameraResetDuration = void 0;
            nextCameraResetSnapshot = void 0;
            cameraResetRequested = false;
        }
        var oldBoundingSphereVisible = Object(_mol_math_geometry__WEBPACK_IMPORTED_MODULE_21__["Sphere3D"])();
        var cameraSphere = Object(_mol_math_geometry__WEBPACK_IMPORTED_MODULE_21__["Sphere3D"])();
        function shouldResetCamera() {
            if (camera.state.radiusMax === 0)
                return true;
            if (camera.transition.inTransition || nextCameraResetSnapshot)
                return false;
            var cameraSphereOverlapsNone = true;
            _mol_math_geometry__WEBPACK_IMPORTED_MODULE_21__["Sphere3D"].set(cameraSphere, camera.state.target, camera.state.radius);
            // check if any renderable has moved outside of the old bounding sphere
            // and if no renderable is overlapping with the camera sphere
            for (var _i = 0, _a = scene.renderables; _i < _a.length; _i++) {
                var r = _a[_i];
                if (!r.state.visible)
                    continue;
                var b = r.values.boundingSphere.ref.value;
                if (!b.radius)
                    continue;
                var cameraDist = _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_3__["Vec3"].distance(cameraSphere.center, b.center);
                if ((cameraDist > cameraSphere.radius || cameraDist > b.radius || b.radius > camera.state.radiusMax) && !_mol_math_geometry__WEBPACK_IMPORTED_MODULE_21__["Sphere3D"].includes(oldBoundingSphereVisible, b))
                    return true;
                if (_mol_math_geometry__WEBPACK_IMPORTED_MODULE_21__["Sphere3D"].overlaps(cameraSphere, b))
                    cameraSphereOverlapsNone = false;
            }
            return cameraSphereOverlapsNone;
        }
        var sceneCommitTimeoutMs = 250;
        function commitScene(isSynchronous) {
            if (!scene.needsCommit)
                return true;
            // snapshot the current bounding sphere of visible objects
            _mol_math_geometry__WEBPACK_IMPORTED_MODULE_21__["Sphere3D"].copy(oldBoundingSphereVisible, scene.boundingSphereVisible);
            if (!scene.commit(isSynchronous ? void 0 : sceneCommitTimeoutMs))
                return false;
            if (helper.debug.isEnabled)
                helper.debug.update();
            if (!p.camera.manualReset && (reprCount.value === 0 || shouldResetCamera())) {
                cameraResetRequested = true;
            }
            if (oldBoundingSphereVisible.radius === 0)
                nextCameraResetDuration = 0;
            camera.setState({ radiusMax: scene.boundingSphere.radius }, 0);
            reprCount.next(reprRenderObjects.size);
            if (_mol_util_debug__WEBPACK_IMPORTED_MODULE_22__["isDebugMode"])
                consoleStats();
            return true;
        }
        function consoleStats() {
            console.table(scene.renderables.map(function (r) { return ({
                drawCount: r.values.drawCount.ref.value,
                instanceCount: r.values.instanceCount.ref.value,
                materialId: r.materialId,
                renderItemId: r.id,
            }); }));
            console.log(webgl.stats);
            var _a = webgl.resources.getByteCounts(), texture = _a.texture, attribute = _a.attribute, elements = _a.elements;
            console.log({
                texture: (texture / 1024 / 1024).toFixed(3) + " MiB",
                attribute: (attribute / 1024 / 1024).toFixed(3) + " MiB",
                elements: (elements / 1024 / 1024).toFixed(3) + " MiB",
            });
        }
        function add(repr) {
            registerAutoUpdate(repr);
            var oldRO = reprRenderObjects.get(repr);
            var newRO = new Set();
            repr.renderObjects.forEach(function (o) { return newRO.add(o); });
            if (oldRO) {
                if (!_mol_util_set__WEBPACK_IMPORTED_MODULE_15__["SetUtils"].areEqual(newRO, oldRO)) {
                    newRO.forEach(function (o) { if (!oldRO.has(o))
                        scene.add(o); });
                    oldRO.forEach(function (o) { if (!newRO.has(o))
                        scene.remove(o); });
                }
            }
            else {
                repr.renderObjects.forEach(function (o) { return scene.add(o); });
            }
            reprRenderObjects.set(repr, newRO);
            scene.update(repr.renderObjects, false);
            forceDrawAfterAllCommited = true;
            if (_mol_util_debug__WEBPACK_IMPORTED_MODULE_22__["isDebugMode"])
                consoleStats();
        }
        function remove(repr) {
            unregisterAutoUpdate(repr);
            var renderObjects = reprRenderObjects.get(repr);
            if (renderObjects) {
                renderObjects.forEach(function (o) { return scene.remove(o); });
                reprRenderObjects.delete(repr);
                forceDrawAfterAllCommited = true;
                if (_mol_util_debug__WEBPACK_IMPORTED_MODULE_22__["isDebugMode"])
                    consoleStats();
            }
        }
        function registerAutoUpdate(repr) {
            if (reprUpdatedSubscriptions.has(repr))
                return;
            reprUpdatedSubscriptions.set(repr, repr.updated.subscribe(function (_) {
                if (!repr.state.syncManually)
                    add(repr);
            }));
        }
        function unregisterAutoUpdate(repr) {
            var updatedSubscription = reprUpdatedSubscriptions.get(repr);
            if (updatedSubscription) {
                updatedSubscription.unsubscribe();
                reprUpdatedSubscriptions.delete(repr);
            }
        }
        function getProps() {
            var radius = scene.boundingSphere.radius > 0
                ? 100 - Math.round((camera.transition.target.radius / scene.boundingSphere.radius) * 100)
                : 0;
            return {
                camera: {
                    mode: camera.state.mode,
                    helper: Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, helper.camera.props),
                    stereo: Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, p.camera.stereo),
                    manualReset: !!p.camera.manualReset
                },
                cameraFog: camera.state.fog > 0
                    ? { name: 'on', params: { intensity: camera.state.fog } }
                    : { name: 'off', params: {} },
                cameraClipping: { far: camera.state.clipFar, radius: radius },
                cameraResetDurationMs: p.cameraResetDurationMs,
                transparentBackground: p.transparentBackground,
                viewport: p.viewport,
                postprocessing: Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, p.postprocessing),
                multiSample: Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, p.multiSample),
                renderer: Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, renderer.props),
                trackball: Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, controls.props),
                debug: Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, helper.debug.props),
                handle: Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, helper.handle.props),
            };
        }
        var contextRestoredSub = contextRestored.subscribe(function () {
            pickHelper.dirty = true;
            draw(true);
            // Unclear why, but in Chrome with wboit enabled the first `draw` only clears
            // the drawingBuffer. Note that in Firefox the drawingBuffer is preserved after
            // context loss so it is unclear if it behaves the same.
            draw(true);
        });
        var resized = new rxjs__WEBPACK_IMPORTED_MODULE_1__["BehaviorSubject"](0);
        function handleResize(draw) {
            if (draw === void 0) { draw = true; }
            passes.updateSize();
            updateViewport();
            syncViewport();
            if (draw)
                requestDraw(true);
            resized.next(+new Date());
        }
        return {
            webgl: webgl,
            add: add,
            remove: remove,
            commit: commit,
            update: function (repr, keepSphere) {
                if (repr) {
                    if (!reprRenderObjects.has(repr))
                        return;
                    scene.update(repr.renderObjects, !!keepSphere);
                }
                else {
                    scene.update(void 0, !!keepSphere);
                }
                forceDrawAfterAllCommited = true;
            },
            clear: function () {
                reprUpdatedSubscriptions.forEach(function (v) { return v.unsubscribe(); });
                reprUpdatedSubscriptions.clear();
                reprRenderObjects.clear();
                scene.clear();
                helper.debug.clear();
                requestDraw(true);
                reprCount.next(reprRenderObjects.size);
            },
            syncVisibility: function () {
                if (camera.state.radiusMax === 0) {
                    cameraResetRequested = true;
                    nextCameraResetDuration = 0;
                }
                if (scene.syncVisibility()) {
                    if (helper.debug.isEnabled)
                        helper.debug.update();
                }
                requestDraw(true);
            },
            requestDraw: requestDraw,
            tick: tick,
            animate: animate,
            resetTime: resetTime,
            pause: pause,
            identify: identify,
            mark: mark,
            getLoci: getLoci,
            handleResize: handleResize,
            requestResize: function () {
                resizeRequested = true;
            },
            requestCameraReset: function (options) {
                nextCameraResetDuration = options === null || options === void 0 ? void 0 : options.durationMs;
                nextCameraResetSnapshot = options === null || options === void 0 ? void 0 : options.snapshot;
                cameraResetRequested = true;
            },
            camera: camera,
            boundingSphere: scene.boundingSphere,
            get notifyDidDraw() { return notifyDidDraw; },
            set notifyDidDraw(v) { notifyDidDraw = v; },
            didDraw: didDraw,
            commited: commited,
            reprCount: reprCount,
            resized: resized,
            setProps: function (properties, doNotRequestDraw) {
                var _a, _b, _c;
                if (doNotRequestDraw === void 0) { doNotRequestDraw = false; }
                var props = typeof properties === 'function'
                    ? Object(immer__WEBPACK_IMPORTED_MODULE_24__["produce"])(getProps(), properties)
                    : properties;
                var cameraState = Object.create(null);
                if (props.camera && props.camera.mode !== undefined && props.camera.mode !== camera.state.mode) {
                    cameraState.mode = props.camera.mode;
                }
                if (props.cameraFog !== undefined && props.cameraFog.params) {
                    var newFog = props.cameraFog.name === 'on' ? props.cameraFog.params.intensity : 0;
                    if (newFog !== camera.state.fog)
                        cameraState.fog = newFog;
                }
                if (props.cameraClipping !== undefined) {
                    if (props.cameraClipping.far !== undefined && props.cameraClipping.far !== camera.state.clipFar) {
                        cameraState.clipFar = props.cameraClipping.far;
                    }
                    if (props.cameraClipping.radius !== undefined) {
                        var radius = (scene.boundingSphere.radius / 100) * (100 - props.cameraClipping.radius);
                        if (radius > 0 && radius !== cameraState.radius) {
                            // if radius = 0, NaNs happen
                            cameraState.radius = Math.max(radius, 0.01);
                        }
                    }
                }
                if (Object.keys(cameraState).length > 0)
                    camera.setState(cameraState);
                if ((_a = props.camera) === null || _a === void 0 ? void 0 : _a.helper)
                    helper.camera.setProps(props.camera.helper);
                if (((_b = props.camera) === null || _b === void 0 ? void 0 : _b.manualReset) !== undefined)
                    p.camera.manualReset = props.camera.manualReset;
                if (((_c = props.camera) === null || _c === void 0 ? void 0 : _c.stereo) !== undefined)
                    Object.assign(p.camera.stereo, props.camera.stereo);
                if (props.cameraResetDurationMs !== undefined)
                    p.cameraResetDurationMs = props.cameraResetDurationMs;
                if (props.transparentBackground !== undefined)
                    p.transparentBackground = props.transparentBackground;
                if (props.viewport !== undefined) {
                    var doNotUpdate = p.viewport === props.viewport ||
                        (p.viewport.name === props.viewport.name && Object(_mol_util__WEBPACK_IMPORTED_MODULE_29__["shallowEqual"])(p.viewport.params, props.viewport.params));
                    if (!doNotUpdate) {
                        p.viewport = props.viewport;
                        updateViewport();
                        syncViewport();
                    }
                }
                if (props.postprocessing)
                    Object.assign(p.postprocessing, props.postprocessing);
                if (props.multiSample)
                    Object.assign(p.multiSample, props.multiSample);
                if (props.renderer)
                    renderer.setProps(props.renderer);
                if (props.trackball)
                    controls.setProps(props.trackball);
                if (props.debug)
                    helper.debug.setProps(props.debug);
                if (props.handle)
                    helper.handle.setProps(props.handle);
                if (cameraState.mode === 'orthographic') {
                    p.camera.stereo.name = 'off';
                }
                if (!doNotRequestDraw) {
                    requestDraw(true);
                }
            },
            getImagePass: function (props) {
                if (props === void 0) { props = {}; }
                return new _passes_image__WEBPACK_IMPORTED_MODULE_20__["ImagePass"](webgl, renderer, scene, camera, helper, passes.draw.wboitEnabled, props);
            },
            get props() {
                return getProps();
            },
            get input() {
                return input;
            },
            get stats() {
                return renderer.stats;
            },
            get interaction() {
                return interactionHelper.events;
            },
            dispose: function () {
                contextRestoredSub.unsubscribe();
                scene.clear();
                helper.debug.clear();
                controls.dispose();
                renderer.dispose();
                interactionHelper.dispose();
            }
        };
        function updateViewport() {
            if (p.viewport.name === 'canvas') {
                x = 0;
                y = 0;
                width = gl.drawingBufferWidth;
                height = gl.drawingBufferHeight;
            }
            else {
                x = p.viewport.params.x * webgl.pixelRatio;
                y = p.viewport.params.y * webgl.pixelRatio;
                width = p.viewport.params.width * webgl.pixelRatio;
                height = p.viewport.params.height * webgl.pixelRatio;
            }
        }
        function syncViewport() {
            pickHelper.setViewport(x, y, width, height);
            renderer.setViewport(x, y, width, height);
            _camera_util__WEBPACK_IMPORTED_MODULE_7__["Viewport"].set(camera.viewport, x, y, width, height);
            _camera_util__WEBPACK_IMPORTED_MODULE_7__["Viewport"].set(controls.viewport, x, y, width, height);
        }
    }
    Canvas3D.create = create;
})(Canvas3D || (Canvas3D = {}));
//# sourceMappingURL=canvas3d.js.map
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(/*! ./../../node_modules/timers-browserify/main.js */ "./node_modules/timers-browserify/main.js").setImmediate, __webpack_require__(/*! ./../../node_modules/timers-browserify/main.js */ "./node_modules/timers-browserify/main.js").clearImmediate))

/***/ }),

/***/ "./lib/mol-canvas3d/controls/trackball.js":
/*!************************************************!*\
  !*** ./lib/mol-canvas3d/controls/trackball.js ***!
  \************************************************/
/*! exports provided: DefaultTrackballBindings, TrackballControlsParams, TrackballControls */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DefaultTrackballBindings", function() { return DefaultTrackballBindings; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "TrackballControlsParams", function() { return TrackballControlsParams; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "TrackballControls", function() { return TrackballControls; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../mol-math/linear-algebra */ "./lib/mol-math/linear-algebra.js");
/* harmony import */ var _camera_util__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../camera/util */ "./lib/mol-canvas3d/camera/util.js");
/* harmony import */ var _mol_util_input_input_observer__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../mol-util/input/input-observer */ "./lib/mol-util/input/input-observer.js");
/* harmony import */ var _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../mol-util/param-definition */ "./lib/mol-util/param-definition.js");
/* harmony import */ var _mol_math_misc__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../mol-math/misc */ "./lib/mol-math/misc.js");
/* harmony import */ var _mol_util_binding__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../../mol-util/binding */ "./lib/mol-util/binding.js");
/**
 * Copyright (c) 2018-2019 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 * @author David Sehnal <david.sehnal@gmail.com>
 *
 * This code has been modified from https://github.com/mrdoob/three.js/,
 * copyright (c) 2010-2018 three.js authors. MIT License
 */







var B = _mol_util_input_input_observer__WEBPACK_IMPORTED_MODULE_3__["ButtonsType"];
var M = _mol_util_input_input_observer__WEBPACK_IMPORTED_MODULE_3__["ModifiersKeys"];
var Trigger = _mol_util_binding__WEBPACK_IMPORTED_MODULE_6__["Binding"].Trigger;
var DefaultTrackballBindings = {
    dragRotate: Object(_mol_util_binding__WEBPACK_IMPORTED_MODULE_6__["Binding"])([Trigger(1 /* Primary */, M.create())], 'Rotate', 'Drag using ${triggers}'),
    dragRotateZ: Object(_mol_util_binding__WEBPACK_IMPORTED_MODULE_6__["Binding"])([Trigger(1 /* Primary */, M.create({ shift: true }))], 'Rotate around z-axis', 'Drag using ${triggers}'),
    dragPan: Object(_mol_util_binding__WEBPACK_IMPORTED_MODULE_6__["Binding"])([Trigger(2 /* Secondary */, M.create()), Trigger(1 /* Primary */, M.create({ control: true }))], 'Pan', 'Drag using ${triggers}'),
    dragZoom: _mol_util_binding__WEBPACK_IMPORTED_MODULE_6__["Binding"].Empty,
    dragFocus: Object(_mol_util_binding__WEBPACK_IMPORTED_MODULE_6__["Binding"])([Trigger(8 /* Forth */, M.create())], 'Focus', 'Drag using ${triggers}'),
    dragFocusZoom: Object(_mol_util_binding__WEBPACK_IMPORTED_MODULE_6__["Binding"])([Trigger(4 /* Auxilary */, M.create())], 'Focus and zoom', 'Drag using ${triggers}'),
    scrollZoom: Object(_mol_util_binding__WEBPACK_IMPORTED_MODULE_6__["Binding"])([Trigger(4 /* Auxilary */, M.create())], 'Zoom', 'Scroll using ${triggers}'),
    scrollFocus: Object(_mol_util_binding__WEBPACK_IMPORTED_MODULE_6__["Binding"])([Trigger(4 /* Auxilary */, M.create({ shift: true }))], 'Clip', 'Scroll using ${triggers}'),
    scrollFocusZoom: _mol_util_binding__WEBPACK_IMPORTED_MODULE_6__["Binding"].Empty,
};
var TrackballControlsParams = {
    noScroll: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_4__["ParamDefinition"].Boolean(true, { isHidden: true }),
    rotateSpeed: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_4__["ParamDefinition"].Numeric(5.0, { min: 1, max: 10, step: 1 }),
    zoomSpeed: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_4__["ParamDefinition"].Numeric(7.0, { min: 1, max: 15, step: 1 }),
    panSpeed: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_4__["ParamDefinition"].Numeric(1.0, { min: 0.1, max: 5, step: 0.1 }),
    spin: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_4__["ParamDefinition"].Boolean(false, { description: 'Spin the 3D scene around the x-axis in view space' }),
    spinSpeed: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_4__["ParamDefinition"].Numeric(1, { min: -20, max: 20, step: 1 }),
    staticMoving: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_4__["ParamDefinition"].Boolean(true, { isHidden: true }),
    dynamicDampingFactor: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_4__["ParamDefinition"].Numeric(0.2, {}, { isHidden: true }),
    minDistance: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_4__["ParamDefinition"].Numeric(0.01, {}, { isHidden: true }),
    maxDistance: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_4__["ParamDefinition"].Numeric(1e150, {}, { isHidden: true }),
    bindings: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_4__["ParamDefinition"].Value(DefaultTrackballBindings, { isHidden: true })
};

var TrackballControls;
(function (TrackballControls) {
    function create(input, camera, props) {
        if (props === void 0) { props = {}; }
        var p = Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_4__["ParamDefinition"].getDefaultValues(TrackballControlsParams)), props);
        var viewport = _camera_util__WEBPACK_IMPORTED_MODULE_2__["Viewport"].clone(camera.viewport);
        var disposed = false;
        var dragSub = input.drag.subscribe(onDrag);
        var interactionEndSub = input.interactionEnd.subscribe(onInteractionEnd);
        var wheelSub = input.wheel.subscribe(onWheel);
        var pinchSub = input.pinch.subscribe(onPinch);
        var _isInteracting = false;
        // For internal use
        var lastPosition = Object(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_1__["Vec3"])();
        var _eye = Object(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_1__["Vec3"])();
        var _rotPrev = Object(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_1__["Vec2"])();
        var _rotCurr = Object(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_1__["Vec2"])();
        var _rotLastAxis = Object(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_1__["Vec3"])();
        var _rotLastAngle = 0;
        var _zRotPrev = Object(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_1__["Vec2"])();
        var _zRotCurr = Object(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_1__["Vec2"])();
        var _zRotLastAngle = 0;
        var _zoomStart = Object(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_1__["Vec2"])();
        var _zoomEnd = Object(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_1__["Vec2"])();
        var _focusStart = Object(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_1__["Vec2"])();
        var _focusEnd = Object(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_1__["Vec2"])();
        var _panStart = Object(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_1__["Vec2"])();
        var _panEnd = Object(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_1__["Vec2"])();
        // Initial values for reseting
        var target0 = _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_1__["Vec3"].clone(camera.target);
        var position0 = _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_1__["Vec3"].clone(camera.position);
        var up0 = _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_1__["Vec3"].clone(camera.up);
        var mouseOnScreenVec2 = Object(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_1__["Vec2"])();
        function getMouseOnScreen(pageX, pageY) {
            return _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_1__["Vec2"].set(mouseOnScreenVec2, (pageX - viewport.x) / viewport.width, (pageY - viewport.y) / viewport.height);
        }
        var mouseOnCircleVec2 = Object(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_1__["Vec2"])();
        function getMouseOnCircle(pageX, pageY) {
            return _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_1__["Vec2"].set(mouseOnCircleVec2, (pageX - viewport.width * 0.5 - viewport.x) / (viewport.width * 0.5), (viewport.height + 2 * (viewport.y - pageY)) / viewport.width // screen.width intentional
            );
        }
        var rotAxis = Object(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_1__["Vec3"])();
        var rotQuat = Object(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_1__["Quat"])();
        var rotEyeDir = Object(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_1__["Vec3"])();
        var rotObjUpDir = Object(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_1__["Vec3"])();
        var rotObjSideDir = Object(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_1__["Vec3"])();
        var rotMoveDir = Object(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_1__["Vec3"])();
        function rotateCamera() {
            var dx = _rotCurr[0] - _rotPrev[0];
            var dy = _rotCurr[1] - _rotPrev[1];
            _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_1__["Vec3"].set(rotMoveDir, dx, dy, 0);
            var aspectRatio = input.width / input.height;
            var angle = _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_1__["Vec3"].magnitude(rotMoveDir) * p.rotateSpeed * input.pixelRatio * aspectRatio;
            if (angle) {
                _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_1__["Vec3"].sub(_eye, camera.position, camera.target);
                _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_1__["Vec3"].normalize(rotEyeDir, _eye);
                _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_1__["Vec3"].normalize(rotObjUpDir, camera.up);
                _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_1__["Vec3"].normalize(rotObjSideDir, _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_1__["Vec3"].cross(rotObjSideDir, rotObjUpDir, rotEyeDir));
                _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_1__["Vec3"].setMagnitude(rotObjUpDir, rotObjUpDir, dy);
                _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_1__["Vec3"].setMagnitude(rotObjSideDir, rotObjSideDir, dx);
                _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_1__["Vec3"].add(rotMoveDir, rotObjUpDir, rotObjSideDir);
                _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_1__["Vec3"].normalize(rotAxis, _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_1__["Vec3"].cross(rotAxis, rotMoveDir, _eye));
                _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_1__["Quat"].setAxisAngle(rotQuat, rotAxis, angle);
                _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_1__["Vec3"].transformQuat(_eye, _eye, rotQuat);
                _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_1__["Vec3"].transformQuat(camera.up, camera.up, rotQuat);
                _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_1__["Vec3"].copy(_rotLastAxis, rotAxis);
                _rotLastAngle = angle;
            }
            else if (!p.staticMoving && _rotLastAngle) {
                _rotLastAngle *= Math.sqrt(1.0 - p.dynamicDampingFactor);
                _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_1__["Vec3"].sub(_eye, camera.position, camera.target);
                _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_1__["Quat"].setAxisAngle(rotQuat, _rotLastAxis, _rotLastAngle);
                _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_1__["Vec3"].transformQuat(_eye, _eye, rotQuat);
                _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_1__["Vec3"].transformQuat(camera.up, camera.up, rotQuat);
            }
            _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_1__["Vec2"].copy(_rotPrev, _rotCurr);
        }
        var zRotQuat = Object(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_1__["Quat"])();
        function zRotateCamera() {
            var dx = _zRotCurr[0] - _zRotPrev[0];
            var dy = _zRotCurr[1] - _zRotPrev[1];
            var angle = p.rotateSpeed * (-dx + dy) * -0.05;
            if (angle) {
                _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_1__["Vec3"].sub(_eye, camera.position, camera.target);
                _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_1__["Quat"].setAxisAngle(zRotQuat, _eye, angle);
                _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_1__["Vec3"].transformQuat(camera.up, camera.up, zRotQuat);
                _zRotLastAngle = angle;
            }
            else if (!p.staticMoving && _zRotLastAngle) {
                _zRotLastAngle *= Math.sqrt(1.0 - p.dynamicDampingFactor);
                _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_1__["Vec3"].sub(_eye, camera.position, camera.target);
                _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_1__["Quat"].setAxisAngle(zRotQuat, _eye, _zRotLastAngle);
                _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_1__["Vec3"].transformQuat(camera.up, camera.up, zRotQuat);
            }
            _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_1__["Vec2"].copy(_zRotPrev, _zRotCurr);
        }
        function zoomCamera() {
            var factor = 1.0 + (_zoomEnd[1] - _zoomStart[1]) * p.zoomSpeed;
            if (factor !== 1.0 && factor > 0.0) {
                _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_1__["Vec3"].scale(_eye, _eye, factor);
            }
            if (p.staticMoving) {
                _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_1__["Vec2"].copy(_zoomStart, _zoomEnd);
            }
            else {
                _zoomStart[1] += (_zoomEnd[1] - _zoomStart[1]) * p.dynamicDampingFactor;
            }
        }
        function focusCamera() {
            var factor = (_focusEnd[1] - _focusStart[1]) * p.zoomSpeed;
            if (factor !== 0.0) {
                var radius = Math.max(1, camera.state.radius + camera.state.radius * factor);
                camera.setState({ radius: radius });
            }
            if (p.staticMoving) {
                _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_1__["Vec2"].copy(_focusStart, _focusEnd);
            }
            else {
                _focusStart[1] += (_focusEnd[1] - _focusStart[1]) * p.dynamicDampingFactor;
            }
        }
        var panMouseChange = Object(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_1__["Vec2"])();
        var panObjUp = Object(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_1__["Vec3"])();
        var panOffset = Object(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_1__["Vec3"])();
        function panCamera() {
            _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_1__["Vec2"].sub(panMouseChange, _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_1__["Vec2"].copy(panMouseChange, _panEnd), _panStart);
            if (_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_1__["Vec2"].squaredMagnitude(panMouseChange)) {
                var factor = input.pixelRatio * p.panSpeed;
                panMouseChange[0] *= (1 / camera.zoom) * camera.viewport.width * factor;
                panMouseChange[1] *= (1 / camera.zoom) * camera.viewport.height * factor;
                _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_1__["Vec3"].cross(panOffset, _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_1__["Vec3"].copy(panOffset, _eye), camera.up);
                _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_1__["Vec3"].setMagnitude(panOffset, panOffset, panMouseChange[0]);
                _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_1__["Vec3"].setMagnitude(panObjUp, camera.up, panMouseChange[1]);
                _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_1__["Vec3"].add(panOffset, panOffset, panObjUp);
                _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_1__["Vec3"].add(camera.position, camera.position, panOffset);
                _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_1__["Vec3"].add(camera.target, camera.target, panOffset);
                if (p.staticMoving) {
                    _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_1__["Vec2"].copy(_panStart, _panEnd);
                }
                else {
                    _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_1__["Vec2"].sub(panMouseChange, _panEnd, _panStart);
                    _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_1__["Vec2"].scale(panMouseChange, panMouseChange, p.dynamicDampingFactor);
                    _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_1__["Vec2"].add(_panStart, _panStart, panMouseChange);
                }
            }
        }
        /**
         * Ensure the distance between object and target is within the min/max distance
         * and not too large compared to `camera.state.radiusMax`
         */
        function checkDistances() {
            var maxDistance = Math.min(Math.max(camera.state.radiusMax * 1000, 0.01), p.maxDistance);
            if (_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_1__["Vec3"].squaredMagnitude(_eye) > maxDistance * maxDistance) {
                _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_1__["Vec3"].setMagnitude(_eye, _eye, maxDistance);
                _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_1__["Vec3"].add(camera.position, camera.target, _eye);
                _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_1__["Vec2"].copy(_zoomStart, _zoomEnd);
                _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_1__["Vec2"].copy(_focusStart, _focusEnd);
            }
            if (_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_1__["Vec3"].squaredMagnitude(_eye) < p.minDistance * p.minDistance) {
                _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_1__["Vec3"].setMagnitude(_eye, _eye, p.minDistance);
                _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_1__["Vec3"].add(camera.position, camera.target, _eye);
                _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_1__["Vec2"].copy(_zoomStart, _zoomEnd);
                _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_1__["Vec2"].copy(_focusStart, _focusEnd);
            }
        }
        function outsideViewport(x, y) {
            x *= input.pixelRatio;
            y *= input.pixelRatio;
            return (x > viewport.x + viewport.width ||
                input.height - y > viewport.y + viewport.height ||
                x < viewport.x ||
                input.height - y < viewport.y);
        }
        var lastUpdated = -1;
        /** Update the object's position, direction and up vectors */
        function update(t) {
            if (lastUpdated === t)
                return;
            if (p.spin && lastUpdated > 0)
                spin(t - lastUpdated);
            _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_1__["Vec3"].sub(_eye, camera.position, camera.target);
            rotateCamera();
            zRotateCamera();
            zoomCamera();
            focusCamera();
            panCamera();
            _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_1__["Vec3"].add(camera.position, camera.target, _eye);
            checkDistances();
            if (_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_1__["Vec3"].squaredDistance(lastPosition, camera.position) > _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_1__["EPSILON"]) {
                _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_1__["Vec3"].copy(lastPosition, camera.position);
            }
            lastUpdated = t;
        }
        /** Reset object's vectors and the target vector to their initial values */
        function reset() {
            _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_1__["Vec3"].copy(camera.target, target0);
            _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_1__["Vec3"].copy(camera.position, position0);
            _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_1__["Vec3"].copy(camera.up, up0);
            _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_1__["Vec3"].sub(_eye, camera.position, camera.target);
            _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_1__["Vec3"].copy(lastPosition, camera.position);
        }
        // listeners
        function onDrag(_a) {
            var x = _a.x, y = _a.y, pageX = _a.pageX, pageY = _a.pageY, buttons = _a.buttons, modifiers = _a.modifiers, isStart = _a.isStart;
            var isOutside = outsideViewport(x, y);
            if (isStart && isOutside)
                return;
            if (!isStart && !_isInteracting)
                return;
            _isInteracting = true;
            var dragRotate = _mol_util_binding__WEBPACK_IMPORTED_MODULE_6__["Binding"].match(p.bindings.dragRotate, buttons, modifiers);
            var dragRotateZ = _mol_util_binding__WEBPACK_IMPORTED_MODULE_6__["Binding"].match(p.bindings.dragRotateZ, buttons, modifiers);
            var dragPan = _mol_util_binding__WEBPACK_IMPORTED_MODULE_6__["Binding"].match(p.bindings.dragPan, buttons, modifiers);
            var dragZoom = _mol_util_binding__WEBPACK_IMPORTED_MODULE_6__["Binding"].match(p.bindings.dragZoom, buttons, modifiers);
            var dragFocus = _mol_util_binding__WEBPACK_IMPORTED_MODULE_6__["Binding"].match(p.bindings.dragFocus, buttons, modifiers);
            var dragFocusZoom = _mol_util_binding__WEBPACK_IMPORTED_MODULE_6__["Binding"].match(p.bindings.dragFocusZoom, buttons, modifiers);
            getMouseOnCircle(pageX, pageY);
            getMouseOnScreen(pageX, pageY);
            if (isStart) {
                if (dragRotate) {
                    _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_1__["Vec2"].copy(_rotCurr, mouseOnCircleVec2);
                    _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_1__["Vec2"].copy(_rotPrev, _rotCurr);
                }
                if (dragRotateZ) {
                    _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_1__["Vec2"].copy(_zRotCurr, mouseOnCircleVec2);
                    _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_1__["Vec2"].copy(_zRotPrev, _zRotCurr);
                }
                if (dragZoom || dragFocusZoom) {
                    _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_1__["Vec2"].copy(_zoomStart, mouseOnScreenVec2);
                    _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_1__["Vec2"].copy(_zoomEnd, _zoomStart);
                }
                if (dragFocus) {
                    _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_1__["Vec2"].copy(_focusStart, mouseOnScreenVec2);
                    _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_1__["Vec2"].copy(_focusEnd, _focusStart);
                }
                if (dragPan) {
                    _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_1__["Vec2"].copy(_panStart, mouseOnScreenVec2);
                    _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_1__["Vec2"].copy(_panEnd, _panStart);
                }
            }
            if (dragRotate)
                _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_1__["Vec2"].copy(_rotCurr, mouseOnCircleVec2);
            if (dragRotateZ)
                _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_1__["Vec2"].copy(_zRotCurr, mouseOnCircleVec2);
            if (dragZoom || dragFocusZoom)
                _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_1__["Vec2"].copy(_zoomEnd, mouseOnScreenVec2);
            if (dragFocus)
                _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_1__["Vec2"].copy(_focusEnd, mouseOnScreenVec2);
            if (dragFocusZoom) {
                var dist = _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_1__["Vec3"].distance(camera.state.position, camera.state.target);
                camera.setState({ radius: dist / 5 });
            }
            if (dragPan)
                _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_1__["Vec2"].copy(_panEnd, mouseOnScreenVec2);
        }
        function onInteractionEnd() {
            _isInteracting = false;
        }
        function onWheel(_a) {
            var x = _a.x, y = _a.y, dx = _a.dx, dy = _a.dy, dz = _a.dz, buttons = _a.buttons, modifiers = _a.modifiers;
            if (outsideViewport(x, y))
                return;
            var delta = Object(_mol_math_misc__WEBPACK_IMPORTED_MODULE_5__["absMax"])(dx, dy, dz);
            if (_mol_util_binding__WEBPACK_IMPORTED_MODULE_6__["Binding"].match(p.bindings.scrollZoom, buttons, modifiers)) {
                _zoomEnd[1] += delta * 0.0001;
            }
            if (_mol_util_binding__WEBPACK_IMPORTED_MODULE_6__["Binding"].match(p.bindings.scrollFocus, buttons, modifiers)) {
                _focusEnd[1] += delta * 0.0001;
            }
        }
        function onPinch(_a) {
            var fraction = _a.fraction, buttons = _a.buttons, modifiers = _a.modifiers;
            if (_mol_util_binding__WEBPACK_IMPORTED_MODULE_6__["Binding"].match(p.bindings.scrollZoom, buttons, modifiers)) {
                _isInteracting = true;
                _zoomEnd[1] += (fraction - 1) * 0.1;
            }
        }
        function dispose() {
            if (disposed)
                return;
            disposed = true;
            dragSub.unsubscribe();
            wheelSub.unsubscribe();
            pinchSub.unsubscribe();
            interactionEndSub.unsubscribe();
        }
        var _spinSpeed = _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_1__["Vec2"].create(0.005, 0);
        function spin(deltaT) {
            if (p.spinSpeed === 0)
                return;
            var frameSpeed = (p.spinSpeed || 0) / 1000;
            _spinSpeed[0] = 60 * Math.min(Math.abs(deltaT), 1000 / 8) / 1000 * frameSpeed;
            if (!_isInteracting)
                _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_1__["Vec2"].add(_rotCurr, _rotPrev, _spinSpeed);
        }
        function start(t) {
            lastUpdated = -1;
            update(t);
        }
        return {
            viewport: viewport,
            get props() { return p; },
            setProps: function (props) {
                Object.assign(p, props);
            },
            start: start,
            update: update,
            reset: reset,
            dispose: dispose
        };
    }
    TrackballControls.create = create;
})(TrackballControls || (TrackballControls = {}));
//# sourceMappingURL=trackball.js.map

/***/ }),

/***/ "./lib/mol-canvas3d/helper/bounding-sphere-helper.js":
/*!***********************************************************!*\
  !*** ./lib/mol-canvas3d/helper/bounding-sphere-helper.js ***!
  \***********************************************************/
/*! exports provided: DebugHelperParams, BoundingSphereHelper */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DebugHelperParams", function() { return DebugHelperParams; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "BoundingSphereHelper", function() { return BoundingSphereHelper; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _mol_gl_render_object__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../mol-gl/render-object */ "./lib/mol-gl/render-object.js");
/* harmony import */ var _mol_geo_geometry_mesh_mesh_builder__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../mol-geo/geometry/mesh/mesh-builder */ "./lib/mol-geo/geometry/mesh/mesh-builder.js");
/* harmony import */ var _mol_geo_geometry_mesh_builder_sphere__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../mol-geo/geometry/mesh/builder/sphere */ "./lib/mol-geo/geometry/mesh/builder/sphere.js");
/* harmony import */ var _mol_geo_geometry_mesh_mesh__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../mol-geo/geometry/mesh/mesh */ "./lib/mol-geo/geometry/mesh/mesh.js");
/* harmony import */ var _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../mol-util/param-definition */ "./lib/mol-util/param-definition.js");
/* harmony import */ var _mol_gl_scene__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../../mol-gl/scene */ "./lib/mol-gl/scene.js");
/* harmony import */ var _mol_math_geometry__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../../mol-math/geometry */ "./lib/mol-math/geometry.js");
/* harmony import */ var _mol_util_color_names__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ../../mol-util/color/names */ "./lib/mol-util/color/names.js");
/* harmony import */ var _mol_geo_primitive_sphere__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ../../mol-geo/primitive/sphere */ "./lib/mol-geo/primitive/sphere.js");
/* harmony import */ var _mol_util__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ../../mol-util */ "./lib/mol-util/index.js");
/* harmony import */ var _mol_geo_geometry_geometry__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ../../mol-geo/geometry/geometry */ "./lib/mol-geo/geometry/geometry.js");
/**
 * Copyright (c) 2018-2020 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */












var DebugHelperParams = {
    sceneBoundingSpheres: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_5__["ParamDefinition"].Boolean(false, { description: 'Show full scene bounding spheres.' }),
    visibleSceneBoundingSpheres: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_5__["ParamDefinition"].Boolean(false, { description: 'Show visible scene bounding spheres.' }),
    objectBoundingSpheres: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_5__["ParamDefinition"].Boolean(false, { description: 'Show bounding spheres of visible render objects.' }),
    instanceBoundingSpheres: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_5__["ParamDefinition"].Boolean(false, { description: 'Show bounding spheres of visible instances.' }),
};
var BoundingSphereHelper = /** @class */ (function () {
    function BoundingSphereHelper(ctx, parent, props) {
        this.objectsData = new Map();
        this.instancesData = new Map();
        this.scene = _mol_gl_scene__WEBPACK_IMPORTED_MODULE_6__["default"].create(ctx);
        this.parent = parent;
        this._props = Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_5__["ParamDefinition"].getDefaultValues(DebugHelperParams)), props);
    }
    BoundingSphereHelper.prototype.update = function () {
        var _this = this;
        var newSceneData = updateBoundingSphereData(this.scene, this.parent.boundingSphere, this.sceneData, _mol_util_color_names__WEBPACK_IMPORTED_MODULE_8__["ColorNames"].lightgrey, sceneMaterialId);
        if (newSceneData)
            this.sceneData = newSceneData;
        var newVisibleSceneData = updateBoundingSphereData(this.scene, this.parent.boundingSphereVisible, this.visibleSceneData, _mol_util_color_names__WEBPACK_IMPORTED_MODULE_8__["ColorNames"].black, visibleSceneMaterialId);
        if (newVisibleSceneData)
            this.visibleSceneData = newVisibleSceneData;
        this.parent.forEach(function (r, ro) {
            var objectData = _this.objectsData.get(ro);
            var newObjectData = updateBoundingSphereData(_this.scene, r.values.boundingSphere.ref.value, objectData, _mol_util_color_names__WEBPACK_IMPORTED_MODULE_8__["ColorNames"].tomato, objectMaterialId);
            if (newObjectData)
                _this.objectsData.set(ro, newObjectData);
            var instanceData = _this.instancesData.get(ro);
            var newInstanceData = updateBoundingSphereData(_this.scene, r.values.invariantBoundingSphere.ref.value, instanceData, _mol_util_color_names__WEBPACK_IMPORTED_MODULE_8__["ColorNames"].skyblue, instanceMaterialId, {
                aTransform: ro.values.aTransform,
                matrix: ro.values.matrix,
                transform: ro.values.transform,
                extraTransform: ro.values.extraTransform,
                uInstanceCount: ro.values.uInstanceCount,
                instanceCount: ro.values.instanceCount,
                aInstance: ro.values.aInstance,
                hasReflection: ro.values.hasReflection,
            });
            if (newInstanceData)
                _this.instancesData.set(ro, newInstanceData);
        });
        this.objectsData.forEach(function (objectData, ro) {
            if (!_this.parent.has(ro)) {
                _this.scene.remove(objectData.renderObject);
                _this.objectsData.delete(ro);
            }
        });
        this.instancesData.forEach(function (instanceData, ro) {
            if (!_this.parent.has(ro)) {
                _this.scene.remove(instanceData.renderObject);
                _this.instancesData.delete(ro);
            }
        });
        this.scene.update(void 0, false);
        this.scene.commit();
    };
    BoundingSphereHelper.prototype.syncVisibility = function () {
        var _this = this;
        if (this.sceneData) {
            this.sceneData.renderObject.state.visible = this._props.sceneBoundingSpheres;
        }
        if (this.visibleSceneData) {
            this.visibleSceneData.renderObject.state.visible = this._props.visibleSceneBoundingSpheres;
        }
        this.parent.forEach(function (_, ro) {
            var objectData = _this.objectsData.get(ro);
            if (objectData)
                objectData.renderObject.state.visible = ro.state.visible && _this._props.objectBoundingSpheres;
            var instanceData = _this.instancesData.get(ro);
            if (instanceData)
                instanceData.renderObject.state.visible = ro.state.visible && _this._props.instanceBoundingSpheres;
        });
    };
    BoundingSphereHelper.prototype.clear = function () {
        this.sceneData = undefined;
        this.objectsData.clear();
        this.scene.clear();
    };
    Object.defineProperty(BoundingSphereHelper.prototype, "isEnabled", {
        get: function () {
            return (this._props.sceneBoundingSpheres || this._props.visibleSceneBoundingSpheres ||
                this._props.objectBoundingSpheres || this._props.instanceBoundingSpheres);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BoundingSphereHelper.prototype, "props", {
        get: function () { return this._props; },
        enumerable: false,
        configurable: true
    });
    BoundingSphereHelper.prototype.setProps = function (props) {
        Object.assign(this._props, props);
        if (this.isEnabled)
            this.update();
    };
    return BoundingSphereHelper;
}());

function updateBoundingSphereData(scene, boundingSphere, data, color, materialId, transform) {
    if (!data || !_mol_math_geometry__WEBPACK_IMPORTED_MODULE_7__["Sphere3D"].equals(data.boundingSphere, boundingSphere)) {
        var mesh = createBoundingSphereMesh(boundingSphere, data && data.mesh);
        var renderObject = data ? data.renderObject : createBoundingSphereRenderObject(mesh, color, materialId, transform);
        if (data) {
            _mol_util__WEBPACK_IMPORTED_MODULE_10__["ValueCell"].updateIfChanged(renderObject.values.drawCount, _mol_geo_geometry_geometry__WEBPACK_IMPORTED_MODULE_11__["Geometry"].getDrawCount(mesh));
        }
        else {
            scene.add(renderObject);
        }
        return { boundingSphere: _mol_math_geometry__WEBPACK_IMPORTED_MODULE_7__["Sphere3D"].clone(boundingSphere), renderObject: renderObject, mesh: mesh };
    }
}
function createBoundingSphereMesh(boundingSphere, mesh) {
    var detail = 2;
    var vertexCount = Object(_mol_geo_primitive_sphere__WEBPACK_IMPORTED_MODULE_9__["sphereVertexCount"])(detail);
    var builderState = _mol_geo_geometry_mesh_mesh_builder__WEBPACK_IMPORTED_MODULE_2__["MeshBuilder"].createState(vertexCount, vertexCount / 2, mesh);
    if (boundingSphere.radius) {
        Object(_mol_geo_geometry_mesh_builder_sphere__WEBPACK_IMPORTED_MODULE_3__["addSphere"])(builderState, boundingSphere.center, boundingSphere.radius, detail);
        if (_mol_math_geometry__WEBPACK_IMPORTED_MODULE_7__["Sphere3D"].hasExtrema(boundingSphere)) {
            for (var _i = 0, _a = boundingSphere.extrema; _i < _a.length; _i++) {
                var e = _a[_i];
                Object(_mol_geo_geometry_mesh_builder_sphere__WEBPACK_IMPORTED_MODULE_3__["addSphere"])(builderState, e, 1.0, 0);
            }
        }
    }
    return _mol_geo_geometry_mesh_mesh_builder__WEBPACK_IMPORTED_MODULE_2__["MeshBuilder"].getMesh(builderState);
}
var sceneMaterialId = Object(_mol_gl_render_object__WEBPACK_IMPORTED_MODULE_1__["getNextMaterialId"])();
var visibleSceneMaterialId = Object(_mol_gl_render_object__WEBPACK_IMPORTED_MODULE_1__["getNextMaterialId"])();
var objectMaterialId = Object(_mol_gl_render_object__WEBPACK_IMPORTED_MODULE_1__["getNextMaterialId"])();
var instanceMaterialId = Object(_mol_gl_render_object__WEBPACK_IMPORTED_MODULE_1__["getNextMaterialId"])();
function createBoundingSphereRenderObject(mesh, color, materialId, transform) {
    var values = _mol_geo_geometry_mesh_mesh__WEBPACK_IMPORTED_MODULE_4__["Mesh"].Utils.createValuesSimple(mesh, { alpha: 0.1, doubleSided: false }, color, 1, transform);
    return Object(_mol_gl_render_object__WEBPACK_IMPORTED_MODULE_1__["createRenderObject"])('mesh', values, { disposed: false, visible: true, alphaFactor: 1, pickable: false, colorOnly: false, opaque: false, writeDepth: false, noClip: false }, materialId);
}
//# sourceMappingURL=bounding-sphere-helper.js.map

/***/ }),

/***/ "./lib/mol-canvas3d/helper/camera-helper.js":
/*!**************************************************!*\
  !*** ./lib/mol-canvas3d/helper/camera-helper.js ***!
  \**************************************************/
/*! exports provided: CameraHelperParams, CameraHelper */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CameraHelperParams", function() { return CameraHelperParams; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CameraHelper", function() { return CameraHelper; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _mol_gl_scene__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../mol-gl/scene */ "./lib/mol-gl/scene.js");
/* harmony import */ var _camera__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../camera */ "./lib/mol-canvas3d/camera.js");
/* harmony import */ var _mol_geo_geometry_mesh_mesh_builder__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../mol-geo/geometry/mesh/mesh-builder */ "./lib/mol-geo/geometry/mesh/mesh-builder.js");
/* harmony import */ var _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../mol-math/linear-algebra */ "./lib/mol-math/linear-algebra.js");
/* harmony import */ var _mol_geo_geometry_mesh_builder_sphere__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../mol-geo/geometry/mesh/builder/sphere */ "./lib/mol-geo/geometry/mesh/builder/sphere.js");
/* harmony import */ var _mol_geo_geometry_mesh_mesh__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../../mol-geo/geometry/mesh/mesh */ "./lib/mol-geo/geometry/mesh/mesh.js");
/* harmony import */ var _mol_util_color_names__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../../mol-util/color/names */ "./lib/mol-util/color/names.js");
/* harmony import */ var _mol_geo_geometry_mesh_builder_cylinder__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ../../mol-geo/geometry/mesh/builder/cylinder */ "./lib/mol-geo/geometry/mesh/builder/cylinder.js");
/* harmony import */ var _mol_math_geometry__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ../../mol-math/geometry */ "./lib/mol-math/geometry.js");
/* harmony import */ var _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ../../mol-util/param-definition */ "./lib/mol-util/param-definition.js");
/* harmony import */ var immer__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! immer */ "./node_modules/immer/dist/immer.esm.js");
/* harmony import */ var _mol_model_shape__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! ../../mol-model/shape */ "./lib/mol-model/shape.js");
/**
 * Copyright (c) 2020 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */













// TODO add scale line/grid
var AxesParams = Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, _mol_geo_geometry_mesh_mesh__WEBPACK_IMPORTED_MODULE_6__["Mesh"].Params), { alpha: Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, _mol_geo_geometry_mesh_mesh__WEBPACK_IMPORTED_MODULE_6__["Mesh"].Params.alpha), { defaultValue: 0.33 }), ignoreLight: Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, _mol_geo_geometry_mesh_mesh__WEBPACK_IMPORTED_MODULE_6__["Mesh"].Params.ignoreLight), { defaultValue: true }), colorX: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_10__["ParamDefinition"].Color(_mol_util_color_names__WEBPACK_IMPORTED_MODULE_7__["ColorNames"].red, { isEssential: true }), colorY: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_10__["ParamDefinition"].Color(_mol_util_color_names__WEBPACK_IMPORTED_MODULE_7__["ColorNames"].green, { isEssential: true }), colorZ: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_10__["ParamDefinition"].Color(_mol_util_color_names__WEBPACK_IMPORTED_MODULE_7__["ColorNames"].blue, { isEssential: true }), scale: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_10__["ParamDefinition"].Numeric(0.33, { min: 0.1, max: 2, step: 0.1 }, { isEssential: true }) });
var CameraHelperParams = {
    axes: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_10__["ParamDefinition"].MappedStatic('on', {
        on: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_10__["ParamDefinition"].Group(AxesParams),
        off: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_10__["ParamDefinition"].Group({})
    }, { cycle: true, description: 'Show camera orientation axes' }),
};
var CameraHelper = /** @class */ (function () {
    function CameraHelper(webgl, props) {
        if (props === void 0) { props = {}; }
        this.webgl = webgl;
        this.props = {
            axes: { name: 'off', params: {} }
        };
        this.scene = _mol_gl_scene__WEBPACK_IMPORTED_MODULE_1__["default"].create(webgl);
        this.camera = new _camera__WEBPACK_IMPORTED_MODULE_2__["Camera"]();
        _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_4__["Vec3"].set(this.camera.up, 0, 1, 0);
        _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_4__["Vec3"].set(this.camera.target, 0, 0, 0);
        this.setProps(props);
    }
    CameraHelper.prototype.setProps = function (props) {
        var _this = this;
        this.props = Object(immer__WEBPACK_IMPORTED_MODULE_11__["default"])(this.props, function (p) {
            if (props.axes !== undefined) {
                p.axes.name = props.axes.name;
                if (props.axes.name === 'on') {
                    _this.scene.clear();
                    var params = Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, props.axes.params), { scale: props.axes.params.scale * _this.webgl.pixelRatio });
                    _this.renderObject = createAxesRenderObject(params);
                    _this.renderObject.state.noClip = true;
                    _this.scene.add(_this.renderObject);
                    _this.scene.commit();
                    _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_4__["Vec3"].set(_this.camera.position, 0, 0, params.scale * 200);
                    _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_4__["Mat4"].lookAt(_this.camera.view, _this.camera.position, _this.camera.target, _this.camera.up);
                    p.axes.params = Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, props.axes.params);
                }
            }
        });
    };
    Object.defineProperty(CameraHelper.prototype, "isEnabled", {
        get: function () {
            return this.props.axes.name === 'on';
        },
        enumerable: false,
        configurable: true
    });
    CameraHelper.prototype.update = function (camera) {
        if (!this.renderObject)
            return;
        updateCamera(this.camera, camera.viewport, camera.viewOffset);
        _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_4__["Mat4"].extractRotation(this.scene.view, camera.view);
        var r = this.renderObject.values.boundingSphere.ref.value.radius;
        _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_4__["Mat4"].setTranslation(this.scene.view, _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_4__["Vec3"].create(-camera.viewport.width / 2 + r, -camera.viewport.height / 2 + r, 0));
    };
    return CameraHelper;
}());

function updateCamera(camera, viewport, viewOffset) {
    var near = camera.near, far = camera.far;
    var fullLeft = -viewport.width / 2;
    var fullRight = viewport.width / 2;
    var fullTop = viewport.height / 2;
    var fullBottom = -viewport.height / 2;
    var dx = (fullRight - fullLeft) / 2;
    var dy = (fullTop - fullBottom) / 2;
    var cx = (fullRight + fullLeft) / 2;
    var cy = (fullTop + fullBottom) / 2;
    var left = cx - dx;
    var right = cx + dx;
    var top = cy + dy;
    var bottom = cy - dy;
    if (viewOffset.enabled) {
        var scaleW = (fullRight - fullLeft) / viewOffset.width;
        var scaleH = (fullTop - fullBottom) / viewOffset.height;
        left += scaleW * viewOffset.offsetX;
        right = left + scaleW * viewOffset.width;
        top -= scaleH * viewOffset.offsetY;
        bottom = top - scaleH * viewOffset.height;
    }
    _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_4__["Mat4"].ortho(camera.projection, left, right, top, bottom, near, far);
}
function createAxesMesh(scale, mesh) {
    var state = _mol_geo_geometry_mesh_mesh_builder__WEBPACK_IMPORTED_MODULE_3__["MeshBuilder"].createState(512, 256, mesh);
    var radius = 0.05 * scale;
    var x = _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_4__["Vec3"].scale(Object(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_4__["Vec3"])(), _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_4__["Vec3"].unitX, scale);
    var y = _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_4__["Vec3"].scale(Object(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_4__["Vec3"])(), _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_4__["Vec3"].unitY, scale);
    var z = _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_4__["Vec3"].scale(Object(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_4__["Vec3"])(), _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_4__["Vec3"].unitZ, scale);
    var cylinderProps = { radiusTop: radius, radiusBottom: radius, radialSegments: 32 };
    state.currentGroup = 0;
    Object(_mol_geo_geometry_mesh_builder_sphere__WEBPACK_IMPORTED_MODULE_5__["addSphere"])(state, _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_4__["Vec3"].origin, radius, 2);
    state.currentGroup = 1;
    Object(_mol_geo_geometry_mesh_builder_sphere__WEBPACK_IMPORTED_MODULE_5__["addSphere"])(state, x, radius, 2);
    Object(_mol_geo_geometry_mesh_builder_cylinder__WEBPACK_IMPORTED_MODULE_8__["addCylinder"])(state, _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_4__["Vec3"].origin, x, 1, cylinderProps);
    state.currentGroup = 2;
    Object(_mol_geo_geometry_mesh_builder_sphere__WEBPACK_IMPORTED_MODULE_5__["addSphere"])(state, y, radius, 2);
    Object(_mol_geo_geometry_mesh_builder_cylinder__WEBPACK_IMPORTED_MODULE_8__["addCylinder"])(state, _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_4__["Vec3"].origin, y, 1, cylinderProps);
    state.currentGroup = 3;
    Object(_mol_geo_geometry_mesh_builder_sphere__WEBPACK_IMPORTED_MODULE_5__["addSphere"])(state, z, radius, 2);
    Object(_mol_geo_geometry_mesh_builder_cylinder__WEBPACK_IMPORTED_MODULE_8__["addCylinder"])(state, _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_4__["Vec3"].origin, z, 1, cylinderProps);
    return _mol_geo_geometry_mesh_mesh_builder__WEBPACK_IMPORTED_MODULE_3__["MeshBuilder"].getMesh(state);
}
function getAxesShape(props, shape) {
    var scale = 100 * props.scale;
    var mesh = createAxesMesh(scale, shape === null || shape === void 0 ? void 0 : shape.geometry);
    mesh.setBoundingSphere(_mol_math_geometry__WEBPACK_IMPORTED_MODULE_9__["Sphere3D"].create(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_4__["Vec3"].create(scale / 2, scale / 2, scale / 2), scale + scale / 4));
    var getColor = function (groupId) {
        switch (groupId) {
            case 1: return props.colorX;
            case 2: return props.colorY;
            case 3: return props.colorZ;
            default: return _mol_util_color_names__WEBPACK_IMPORTED_MODULE_7__["ColorNames"].grey;
        }
    };
    return _mol_model_shape__WEBPACK_IMPORTED_MODULE_12__["Shape"].create('axes', {}, mesh, getColor, function () { return 1; }, function () { return ''; });
}
function createAxesRenderObject(props) {
    var shape = getAxesShape(props);
    return _mol_model_shape__WEBPACK_IMPORTED_MODULE_12__["Shape"].createRenderObject(shape, props);
}
//# sourceMappingURL=camera-helper.js.map

/***/ }),

/***/ "./lib/mol-canvas3d/helper/handle-helper.js":
/*!**************************************************!*\
  !*** ./lib/mol-canvas3d/helper/handle-helper.js ***!
  \**************************************************/
/*! exports provided: HandleHelperParams, HandleHelper, HandleGroup, isHandleLoci */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "HandleHelperParams", function() { return HandleHelperParams; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "HandleHelper", function() { return HandleHelper; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "HandleGroup", function() { return HandleGroup; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isHandleLoci", function() { return isHandleLoci; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _mol_gl_scene__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../mol-gl/scene */ "./lib/mol-gl/scene.js");
/* harmony import */ var _mol_geo_geometry_mesh_mesh_builder__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../mol-geo/geometry/mesh/mesh-builder */ "./lib/mol-geo/geometry/mesh/mesh-builder.js");
/* harmony import */ var _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../mol-math/linear-algebra */ "./lib/mol-math/linear-algebra.js");
/* harmony import */ var _mol_geo_geometry_mesh_builder_sphere__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../mol-geo/geometry/mesh/builder/sphere */ "./lib/mol-geo/geometry/mesh/builder/sphere.js");
/* harmony import */ var _mol_geo_geometry_mesh_mesh__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../mol-geo/geometry/mesh/mesh */ "./lib/mol-geo/geometry/mesh/mesh.js");
/* harmony import */ var _mol_util_color_names__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../../mol-util/color/names */ "./lib/mol-util/color/names.js");
/* harmony import */ var _mol_geo_geometry_mesh_builder_cylinder__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../../mol-geo/geometry/mesh/builder/cylinder */ "./lib/mol-geo/geometry/mesh/builder/cylinder.js");
/* harmony import */ var _mol_util__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ../../mol-util */ "./lib/mol-util/index.js");
/* harmony import */ var _mol_math_geometry__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ../../mol-math/geometry */ "./lib/mol-math/geometry.js");
/* harmony import */ var _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ../../mol-util/param-definition */ "./lib/mol-util/param-definition.js");
/* harmony import */ var immer__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! immer */ "./node_modules/immer/dist/immer.esm.js");
/* harmony import */ var _mol_model_shape__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! ../../mol-model/shape */ "./lib/mol-model/shape.js");
/* harmony import */ var _mol_model_loci__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! ../../mol-model/loci */ "./lib/mol-model/loci.js");
/* harmony import */ var _mol_util_marker_action__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! ../../mol-util/marker-action */ "./lib/mol-util/marker-action.js");
/* harmony import */ var _mol_repr_visual__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! ../../mol-repr/visual */ "./lib/mol-repr/visual.js");
/* harmony import */ var _mol_data_int__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(/*! ../../mol-data/int */ "./lib/mol-data/int.js");
/**
 * Copyright (c) 2020 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */

















var HandleParams = Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, _mol_geo_geometry_mesh_mesh__WEBPACK_IMPORTED_MODULE_5__["Mesh"].Params), { alpha: Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, _mol_geo_geometry_mesh_mesh__WEBPACK_IMPORTED_MODULE_5__["Mesh"].Params.alpha), { defaultValue: 1 }), ignoreLight: Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, _mol_geo_geometry_mesh_mesh__WEBPACK_IMPORTED_MODULE_5__["Mesh"].Params.ignoreLight), { defaultValue: true }), colorX: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_10__["ParamDefinition"].Color(_mol_util_color_names__WEBPACK_IMPORTED_MODULE_6__["ColorNames"].red, { isEssential: true }), colorY: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_10__["ParamDefinition"].Color(_mol_util_color_names__WEBPACK_IMPORTED_MODULE_6__["ColorNames"].green, { isEssential: true }), colorZ: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_10__["ParamDefinition"].Color(_mol_util_color_names__WEBPACK_IMPORTED_MODULE_6__["ColorNames"].blue, { isEssential: true }), scale: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_10__["ParamDefinition"].Numeric(0.33, { min: 0.1, max: 2, step: 0.1 }, { isEssential: true }) });
var HandleHelperParams = {
    handle: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_10__["ParamDefinition"].MappedStatic('off', {
        on: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_10__["ParamDefinition"].Group(HandleParams),
        off: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_10__["ParamDefinition"].Group({})
    }, { cycle: true, description: 'Show handle tool' }),
};
var HandleHelper = /** @class */ (function () {
    function HandleHelper(webgl, props) {
        var _this = this;
        if (props === void 0) { props = {}; }
        this.webgl = webgl;
        this.props = {
            handle: { name: 'off', params: {} }
        };
        this._transform = Object(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_3__["Mat4"])();
        this.eachGroup = function (loci, apply) {
            if (!_this.renderObject)
                return false;
            if (!isHandleLoci(loci))
                return false;
            var changed = false;
            var groupCount = _this.renderObject.values.uGroupCount.ref.value;
            var elements = loci.elements;
            for (var _i = 0, elements_1 = elements; _i < elements_1.length; _i++) {
                var _a = elements_1[_i], groupId = _a.groupId, instanceId = _a.instanceId;
                var idx = instanceId * groupCount + groupId;
                if (apply(_mol_data_int__WEBPACK_IMPORTED_MODULE_16__["Interval"].ofSingleton(idx)))
                    changed = true;
            }
            return changed;
        };
        this.scene = _mol_gl_scene__WEBPACK_IMPORTED_MODULE_1__["default"].create(webgl);
        this.setProps(props);
    }
    HandleHelper.prototype.getBoundingSphere = function (out, instanceId) {
        if (this.renderObject) {
            _mol_math_geometry__WEBPACK_IMPORTED_MODULE_9__["Sphere3D"].copy(out, this.renderObject.values.invariantBoundingSphere.ref.value);
            _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_3__["Mat4"].fromArray(this._transform, this.renderObject.values.aTransform.ref.value, instanceId * 16);
            _mol_math_geometry__WEBPACK_IMPORTED_MODULE_9__["Sphere3D"].transform(out, out, this._transform);
        }
        return out;
    };
    HandleHelper.prototype.setProps = function (props) {
        var _this = this;
        this.props = Object(immer__WEBPACK_IMPORTED_MODULE_11__["default"])(this.props, function (p) {
            if (props.handle !== undefined) {
                p.handle.name = props.handle.name;
                if (props.handle.name === 'on') {
                    _this.scene.clear();
                    var params = Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, props.handle.params), { scale: props.handle.params.scale * _this.webgl.pixelRatio });
                    _this.renderObject = createHandleRenderObject(params);
                    _this.renderObject.state.noClip = true;
                    _this.scene.add(_this.renderObject);
                    _this.scene.commit();
                    p.handle.params = Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, props.handle.params);
                }
            }
        });
    };
    Object.defineProperty(HandleHelper.prototype, "isEnabled", {
        get: function () {
            return this.props.handle.name === 'on';
        },
        enumerable: false,
        configurable: true
    });
    // TODO could be a lists of position/rotation if we want to show more than one handle tool,
    //      they would be distingishable by their instanceId
    HandleHelper.prototype.update = function (camera, position, rotation) {
        if (!this.renderObject)
            return;
        _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_3__["Mat4"].setTranslation(this.renderObject.values.aTransform.ref.value, position);
        _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_3__["Mat4"].fromMat3(this.renderObject.values.aTransform.ref.value, rotation);
        // TODO make invariant to camera scaling by adjusting renderObject transform
        _mol_util__WEBPACK_IMPORTED_MODULE_8__["ValueCell"].update(this.renderObject.values.aTransform, this.renderObject.values.aTransform.ref.value);
        this.scene.update([this.renderObject], true);
    };
    HandleHelper.prototype.getLoci = function (pickingId) {
        var objectId = pickingId.objectId, groupId = pickingId.groupId, instanceId = pickingId.instanceId;
        if (!this.renderObject || objectId !== this.renderObject.id)
            return _mol_model_loci__WEBPACK_IMPORTED_MODULE_13__["EmptyLoci"];
        return HandleLoci(this, groupId, instanceId);
    };
    HandleHelper.prototype.mark = function (loci, action) {
        if (!_mol_util_marker_action__WEBPACK_IMPORTED_MODULE_14__["MarkerActions"].is(_mol_util_marker_action__WEBPACK_IMPORTED_MODULE_14__["MarkerActions"].Highlighting, action))
            return false;
        if (!isHandleLoci(loci))
            return false;
        if (loci.data !== this)
            return false;
        return _mol_repr_visual__WEBPACK_IMPORTED_MODULE_15__["Visual"].mark(this.renderObject, loci, action, this.eachGroup);
    };
    return HandleHelper;
}());

function createHandleMesh(scale, mesh) {
    var state = _mol_geo_geometry_mesh_mesh_builder__WEBPACK_IMPORTED_MODULE_2__["MeshBuilder"].createState(512, 256, mesh);
    var radius = 0.05 * scale;
    var x = _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_3__["Vec3"].scale(Object(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_3__["Vec3"])(), _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_3__["Vec3"].unitX, scale);
    var y = _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_3__["Vec3"].scale(Object(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_3__["Vec3"])(), _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_3__["Vec3"].unitY, scale);
    var z = _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_3__["Vec3"].scale(Object(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_3__["Vec3"])(), _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_3__["Vec3"].unitZ, scale);
    var cylinderProps = { radiusTop: radius, radiusBottom: radius, radialSegments: 32 };
    state.currentGroup = HandleGroup.TranslateScreenXY;
    Object(_mol_geo_geometry_mesh_builder_sphere__WEBPACK_IMPORTED_MODULE_4__["addSphere"])(state, _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_3__["Vec3"].origin, radius * 3, 2);
    state.currentGroup = HandleGroup.TranslateObjectX;
    Object(_mol_geo_geometry_mesh_builder_sphere__WEBPACK_IMPORTED_MODULE_4__["addSphere"])(state, x, radius, 2);
    Object(_mol_geo_geometry_mesh_builder_cylinder__WEBPACK_IMPORTED_MODULE_7__["addCylinder"])(state, _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_3__["Vec3"].origin, x, 1, cylinderProps);
    state.currentGroup = HandleGroup.TranslateObjectY;
    Object(_mol_geo_geometry_mesh_builder_sphere__WEBPACK_IMPORTED_MODULE_4__["addSphere"])(state, y, radius, 2);
    Object(_mol_geo_geometry_mesh_builder_cylinder__WEBPACK_IMPORTED_MODULE_7__["addCylinder"])(state, _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_3__["Vec3"].origin, y, 1, cylinderProps);
    state.currentGroup = HandleGroup.TranslateObjectZ;
    Object(_mol_geo_geometry_mesh_builder_sphere__WEBPACK_IMPORTED_MODULE_4__["addSphere"])(state, z, radius, 2);
    Object(_mol_geo_geometry_mesh_builder_cylinder__WEBPACK_IMPORTED_MODULE_7__["addCylinder"])(state, _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_3__["Vec3"].origin, z, 1, cylinderProps);
    // TODO add more helper geometries for the other HandleGroup options
    // TODO add props to create subset of geometries
    return _mol_geo_geometry_mesh_mesh_builder__WEBPACK_IMPORTED_MODULE_2__["MeshBuilder"].getMesh(state);
}
var HandleGroup = {
    None: 0,
    TranslateScreenXY: 1,
    // TranslateScreenZ: 2,
    TranslateObjectX: 3,
    TranslateObjectY: 4,
    TranslateObjectZ: 5,
};
function HandleLoci(handleHelper, groupId, instanceId) {
    return Object(_mol_model_loci__WEBPACK_IMPORTED_MODULE_13__["DataLoci"])('handle', handleHelper, [{ groupId: groupId, instanceId: instanceId }], function (boundingSphere) { return handleHelper.getBoundingSphere(boundingSphere, instanceId); }, function () { return "Handle Helper | Group Id " + groupId + " | Instance Id " + instanceId; });
}
function isHandleLoci(x) {
    return x.kind === 'data-loci' && x.tag === 'handle';
}
function getHandleShape(props, shape) {
    var scale = 10 * props.scale;
    var mesh = createHandleMesh(scale, shape === null || shape === void 0 ? void 0 : shape.geometry);
    mesh.setBoundingSphere(_mol_math_geometry__WEBPACK_IMPORTED_MODULE_9__["Sphere3D"].create(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_3__["Vec3"].create(scale / 2, scale / 2, scale / 2), scale + scale / 4));
    var getColor = function (groupId) {
        switch (groupId) {
            case HandleGroup.TranslateObjectX: return props.colorX;
            case HandleGroup.TranslateObjectY: return props.colorY;
            case HandleGroup.TranslateObjectZ: return props.colorZ;
            default: return _mol_util_color_names__WEBPACK_IMPORTED_MODULE_6__["ColorNames"].grey;
        }
    };
    return _mol_model_shape__WEBPACK_IMPORTED_MODULE_12__["Shape"].create('handle', {}, mesh, getColor, function () { return 1; }, function () { return ''; });
}
function createHandleRenderObject(props) {
    var shape = getHandleShape(props);
    return _mol_model_shape__WEBPACK_IMPORTED_MODULE_12__["Shape"].createRenderObject(shape, props);
}
//# sourceMappingURL=handle-helper.js.map

/***/ }),

/***/ "./lib/mol-canvas3d/helper/helper.js":
/*!*******************************************!*\
  !*** ./lib/mol-canvas3d/helper/helper.js ***!
  \*******************************************/
/*! exports provided: HelperParams, DefaultHelperProps, Helper */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "HelperParams", function() { return HelperParams; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DefaultHelperProps", function() { return DefaultHelperProps; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Helper", function() { return Helper; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../mol-util/param-definition */ "./lib/mol-util/param-definition.js");
/* harmony import */ var _bounding_sphere_helper__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./bounding-sphere-helper */ "./lib/mol-canvas3d/helper/bounding-sphere-helper.js");
/* harmony import */ var _camera_helper__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./camera-helper */ "./lib/mol-canvas3d/helper/camera-helper.js");
/* harmony import */ var _handle_helper__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./handle-helper */ "./lib/mol-canvas3d/helper/handle-helper.js");
/**
 * Copyright (c) 2020 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */





var HelperParams = {
    debug: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_1__["ParamDefinition"].Group(_bounding_sphere_helper__WEBPACK_IMPORTED_MODULE_2__["DebugHelperParams"]),
    camera: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_1__["ParamDefinition"].Group({
        helper: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_1__["ParamDefinition"].Group(_camera_helper__WEBPACK_IMPORTED_MODULE_3__["CameraHelperParams"])
    }),
    handle: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_1__["ParamDefinition"].Group(_handle_helper__WEBPACK_IMPORTED_MODULE_4__["HandleHelperParams"]),
};
var DefaultHelperProps = _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_1__["ParamDefinition"].getDefaultValues(HelperParams);
var Helper = /** @class */ (function () {
    function Helper(webgl, scene, props) {
        if (props === void 0) { props = {}; }
        var p = Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, DefaultHelperProps), props);
        this.debug = new _bounding_sphere_helper__WEBPACK_IMPORTED_MODULE_2__["BoundingSphereHelper"](webgl, scene, p.debug);
        this.camera = new _camera_helper__WEBPACK_IMPORTED_MODULE_3__["CameraHelper"](webgl, p.camera.helper);
        this.handle = new _handle_helper__WEBPACK_IMPORTED_MODULE_4__["HandleHelper"](webgl, p.handle);
    }
    return Helper;
}());

//# sourceMappingURL=helper.js.map

/***/ }),

/***/ "./lib/mol-canvas3d/helper/interaction-events.js":
/*!*******************************************************!*\
  !*** ./lib/mol-canvas3d/helper/interaction-events.js ***!
  \*******************************************************/
/*! exports provided: Canvas3dInteractionHelper */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Canvas3dInteractionHelper", function() { return Canvas3dInteractionHelper; });
/* harmony import */ var _mol_repr_representation__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../mol-repr/representation */ "./lib/mol-repr/representation.js");
/* harmony import */ var _mol_util_input_input_observer__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../mol-util/input/input-observer */ "./lib/mol-util/input/input-observer.js");
/* harmony import */ var _mol_util_rx_event_helper__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../mol-util/rx-event-helper */ "./lib/mol-util/rx-event-helper.js");
/* harmony import */ var _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../mol-math/linear-algebra */ "./lib/mol-math/linear-algebra.js");
/**
 * Copyright (c) 2018-2020 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author David Sehnal <david.sehnal@gmail.com>
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */




var Canvas3dInteractionHelper = /** @class */ (function () {
    function Canvas3dInteractionHelper(canvasIdentify, getLoci, input, camera, maxFps) {
        var _this = this;
        if (maxFps === void 0) { maxFps = 30; }
        this.canvasIdentify = canvasIdentify;
        this.getLoci = getLoci;
        this.input = input;
        this.camera = camera;
        this.maxFps = maxFps;
        this.ev = _mol_util_rx_event_helper__WEBPACK_IMPORTED_MODULE_2__["RxEventHelper"].create();
        this.events = {
            hover: this.ev(),
            drag: this.ev(),
            click: this.ev(),
        };
        this.startX = -1;
        this.startY = -1;
        this.endX = -1;
        this.endY = -1;
        this.id = void 0;
        this.position = void 0;
        this.currentIdentifyT = 0;
        this.isInteracting = false;
        this.prevLoci = _mol_repr_representation__WEBPACK_IMPORTED_MODULE_0__["Representation"].Loci.Empty;
        this.prevT = 0;
        this.inside = false;
        this.buttons = _mol_util_input_input_observer__WEBPACK_IMPORTED_MODULE_1__["ButtonsType"].create(0);
        this.button = _mol_util_input_input_observer__WEBPACK_IMPORTED_MODULE_1__["ButtonsType"].create(0);
        this.modifiers = _mol_util_input_input_observer__WEBPACK_IMPORTED_MODULE_1__["ModifiersKeys"].None;
        input.drag.subscribe(function (_a) {
            var x = _a.x, y = _a.y, buttons = _a.buttons, button = _a.button, modifiers = _a.modifiers;
            _this.isInteracting = true;
            // console.log('drag');
            _this.drag(x, y, buttons, button, modifiers);
        });
        input.move.subscribe(function (_a) {
            var x = _a.x, y = _a.y, inside = _a.inside, buttons = _a.buttons, button = _a.button, modifiers = _a.modifiers;
            if (!inside || _this.isInteracting)
                return;
            // console.log('move');
            _this.move(x, y, buttons, button, modifiers);
        });
        input.leave.subscribe(function () {
            // console.log('leave');
            _this.leave();
        });
        input.click.subscribe(function (_a) {
            var x = _a.x, y = _a.y, buttons = _a.buttons, button = _a.button, modifiers = _a.modifiers;
            if (_this.outsideViewport(x, y))
                return;
            // console.log('click');
            _this.click(x, y, buttons, button, modifiers);
        });
        input.interactionEnd.subscribe(function () {
            // console.log('interactionEnd');
            _this.isInteracting = false;
        });
        input.modifiers.subscribe(function (modifiers) {
            // console.log('modifiers');
            _this.modify(modifiers);
        });
    }
    Canvas3dInteractionHelper.prototype.identify = function (e, t) {
        var xyChanged = this.startX !== this.endX || this.startY !== this.endY;
        if (e === 2 /* Drag */) {
            if (xyChanged && !_mol_repr_representation__WEBPACK_IMPORTED_MODULE_0__["Representation"].Loci.isEmpty(this.prevLoci)) {
                this.events.drag.next({ current: this.prevLoci, buttons: this.buttons, button: this.button, modifiers: this.modifiers, pageStart: _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_3__["Vec2"].create(this.startX, this.startY), pageEnd: _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_3__["Vec2"].create(this.endX, this.endY) });
                this.startX = this.endX;
                this.startY = this.endY;
            }
            return;
        }
        if (xyChanged) {
            var pickData = this.canvasIdentify(this.endX, this.endY);
            this.id = pickData === null || pickData === void 0 ? void 0 : pickData.id;
            this.position = pickData === null || pickData === void 0 ? void 0 : pickData.position;
            this.startX = this.endX;
            this.startY = this.endY;
        }
        if (e === 1 /* Click */) {
            var loci_1 = this.getLoci(this.id);
            this.events.click.next({ current: loci_1, buttons: this.buttons, button: this.button, modifiers: this.modifiers, page: _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_3__["Vec2"].create(this.endX, this.endY), position: this.position });
            this.prevLoci = loci_1;
            return;
        }
        if (!this.inside || this.currentIdentifyT !== t || !xyChanged || this.outsideViewport(this.endX, this.endY))
            return;
        var loci = this.getLoci(this.id);
        this.events.hover.next({ current: loci, buttons: this.buttons, button: this.button, modifiers: this.modifiers, page: _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_3__["Vec2"].create(this.endX, this.endY), position: this.position });
        this.prevLoci = loci;
    };
    Canvas3dInteractionHelper.prototype.tick = function (t) {
        if (this.inside && t - this.prevT > 1000 / this.maxFps) {
            this.prevT = t;
            this.currentIdentifyT = t;
            this.identify(this.isInteracting ? 2 /* Drag */ : 0 /* Move */, t);
        }
    };
    Canvas3dInteractionHelper.prototype.leave = function () {
        this.inside = false;
        if (!_mol_repr_representation__WEBPACK_IMPORTED_MODULE_0__["Representation"].Loci.isEmpty(this.prevLoci)) {
            this.prevLoci = _mol_repr_representation__WEBPACK_IMPORTED_MODULE_0__["Representation"].Loci.Empty;
            this.events.hover.next({ current: this.prevLoci, buttons: this.buttons, button: this.button, modifiers: this.modifiers });
        }
    };
    Canvas3dInteractionHelper.prototype.move = function (x, y, buttons, button, modifiers) {
        this.inside = true;
        this.buttons = buttons;
        this.button = button;
        this.modifiers = modifiers;
        this.endX = x;
        this.endY = y;
    };
    Canvas3dInteractionHelper.prototype.click = function (x, y, buttons, button, modifiers) {
        this.endX = x;
        this.endY = y;
        this.buttons = buttons;
        this.button = button;
        this.modifiers = modifiers;
        this.identify(1 /* Click */, 0);
    };
    Canvas3dInteractionHelper.prototype.drag = function (x, y, buttons, button, modifiers) {
        this.endX = x;
        this.endY = y;
        this.buttons = buttons;
        this.button = button;
        this.modifiers = modifiers;
        this.identify(2 /* Drag */, 0);
    };
    Canvas3dInteractionHelper.prototype.modify = function (modifiers) {
        if (_mol_util_input_input_observer__WEBPACK_IMPORTED_MODULE_1__["ModifiersKeys"].areEqual(modifiers, this.modifiers))
            return;
        this.modifiers = modifiers;
        this.events.hover.next({ current: this.prevLoci, buttons: this.buttons, button: this.button, modifiers: this.modifiers, page: _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_3__["Vec2"].create(this.endX, this.endY), position: this.position });
    };
    Canvas3dInteractionHelper.prototype.outsideViewport = function (x, y) {
        var _a = this, input = _a.input, viewport = _a.camera.viewport;
        x *= input.pixelRatio;
        y *= input.pixelRatio;
        return (x > viewport.x + viewport.width ||
            input.height - y > viewport.y + viewport.height ||
            x < viewport.x ||
            input.height - y < viewport.y);
    };
    Canvas3dInteractionHelper.prototype.dispose = function () {
        this.ev.dispose();
    };
    return Canvas3dInteractionHelper;
}());

//# sourceMappingURL=interaction-events.js.map

/***/ }),

/***/ "./lib/mol-canvas3d/passes/draw.js":
/*!*****************************************!*\
  !*** ./lib/mol-canvas3d/passes/draw.js ***!
  \*****************************************/
/*! exports provided: DrawPass */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DrawPass", function() { return DrawPass; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _mol_gl_webgl_render_target__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../mol-gl/webgl/render-target */ "./lib/mol-gl/webgl/render-target.js");
/* harmony import */ var _mol_gl_compute_util__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../mol-gl/compute/util */ "./lib/mol-gl/compute/util.js");
/* harmony import */ var _mol_gl_renderable_schema__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../mol-gl/renderable/schema */ "./lib/mol-gl/renderable/schema.js");
/* harmony import */ var _mol_gl_renderable__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../mol-gl/renderable */ "./lib/mol-gl/renderable.js");
/* harmony import */ var _mol_gl_shader_code__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../mol-gl/shader-code */ "./lib/mol-gl/shader-code.js");
/* harmony import */ var _mol_gl_webgl_render_item__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../../mol-gl/webgl/render-item */ "./lib/mol-gl/webgl/render-item.js");
/* harmony import */ var _mol_util__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../../mol-util */ "./lib/mol-util/index.js");
/* harmony import */ var _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ../../mol-math/linear-algebra */ "./lib/mol-math/linear-algebra.js");
/* harmony import */ var _mol_gl_shader_quad_vert__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ../../mol-gl/shader/quad.vert */ "./lib/mol-gl/shader/quad.vert.js");
/* harmony import */ var _mol_gl_shader_depth_merge_frag__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ../../mol-gl/shader/depth-merge.frag */ "./lib/mol-gl/shader/depth-merge.frag.js");
/* harmony import */ var _mol_gl_shader_copy_frag__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ../../mol-gl/shader/copy.frag */ "./lib/mol-gl/shader/copy.frag.js");
/* harmony import */ var _camera_stereo__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! ../camera/stereo */ "./lib/mol-canvas3d/camera/stereo.js");
/* harmony import */ var _wboit__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! ./wboit */ "./lib/mol-canvas3d/passes/wboit.js");
/* harmony import */ var _postprocessing__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! ./postprocessing */ "./lib/mol-canvas3d/passes/postprocessing.js");
/**
 * Copyright (c) 2019-2020 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 * @author Áron Samuel Kovács <aron.kovacs@mail.muni.cz>
 */















var DepthMergeSchema = Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, _mol_gl_compute_util__WEBPACK_IMPORTED_MODULE_2__["QuadSchema"]), { tDepthPrimitives: Object(_mol_gl_renderable_schema__WEBPACK_IMPORTED_MODULE_3__["TextureSpec"])('texture', 'depth', 'ushort', 'nearest'), tDepthVolumes: Object(_mol_gl_renderable_schema__WEBPACK_IMPORTED_MODULE_3__["TextureSpec"])('texture', 'depth', 'ushort', 'nearest'), uTexSize: Object(_mol_gl_renderable_schema__WEBPACK_IMPORTED_MODULE_3__["UniformSpec"])('v2'), dPackedDepth: Object(_mol_gl_renderable_schema__WEBPACK_IMPORTED_MODULE_3__["DefineSpec"])('boolean') });
var DepthMergeShaderCode = Object(_mol_gl_shader_code__WEBPACK_IMPORTED_MODULE_5__["ShaderCode"])('depth-merge', _mol_gl_shader_quad_vert__WEBPACK_IMPORTED_MODULE_9__["default"], _mol_gl_shader_depth_merge_frag__WEBPACK_IMPORTED_MODULE_10__["default"]);
function getDepthMergeRenderable(ctx, depthTexturePrimitives, depthTextureVolumes, packedDepth) {
    var values = Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, _mol_gl_compute_util__WEBPACK_IMPORTED_MODULE_2__["QuadValues"]), { tDepthPrimitives: _mol_util__WEBPACK_IMPORTED_MODULE_7__["ValueCell"].create(depthTexturePrimitives), tDepthVolumes: _mol_util__WEBPACK_IMPORTED_MODULE_7__["ValueCell"].create(depthTextureVolumes), uTexSize: _mol_util__WEBPACK_IMPORTED_MODULE_7__["ValueCell"].create(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_8__["Vec2"].create(depthTexturePrimitives.getWidth(), depthTexturePrimitives.getHeight())), dPackedDepth: _mol_util__WEBPACK_IMPORTED_MODULE_7__["ValueCell"].create(packedDepth) });
    var schema = Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, DepthMergeSchema);
    var renderItem = Object(_mol_gl_webgl_render_item__WEBPACK_IMPORTED_MODULE_6__["createComputeRenderItem"])(ctx, 'triangles', DepthMergeShaderCode, schema, values);
    return Object(_mol_gl_renderable__WEBPACK_IMPORTED_MODULE_4__["createComputeRenderable"])(renderItem, values);
}
var CopySchema = Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, _mol_gl_compute_util__WEBPACK_IMPORTED_MODULE_2__["QuadSchema"]), { tColor: Object(_mol_gl_renderable_schema__WEBPACK_IMPORTED_MODULE_3__["TextureSpec"])('texture', 'rgba', 'ubyte', 'nearest'), uTexSize: Object(_mol_gl_renderable_schema__WEBPACK_IMPORTED_MODULE_3__["UniformSpec"])('v2') });
var CopyShaderCode = Object(_mol_gl_shader_code__WEBPACK_IMPORTED_MODULE_5__["ShaderCode"])('copy', _mol_gl_shader_quad_vert__WEBPACK_IMPORTED_MODULE_9__["default"], _mol_gl_shader_copy_frag__WEBPACK_IMPORTED_MODULE_11__["copy_frag"]);
function getCopyRenderable(ctx, colorTexture) {
    var values = Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, _mol_gl_compute_util__WEBPACK_IMPORTED_MODULE_2__["QuadValues"]), { tColor: _mol_util__WEBPACK_IMPORTED_MODULE_7__["ValueCell"].create(colorTexture), uTexSize: _mol_util__WEBPACK_IMPORTED_MODULE_7__["ValueCell"].create(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_8__["Vec2"].create(colorTexture.getWidth(), colorTexture.getHeight())) });
    var schema = Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, CopySchema);
    var renderItem = Object(_mol_gl_webgl_render_item__WEBPACK_IMPORTED_MODULE_6__["createComputeRenderItem"])(ctx, 'triangles', CopyShaderCode, schema, values);
    return Object(_mol_gl_renderable__WEBPACK_IMPORTED_MODULE_4__["createComputeRenderable"])(renderItem, values);
}
var DrawPass = /** @class */ (function () {
    function DrawPass(webgl, width, height, enableWboit) {
        this.webgl = webgl;
        var extensions = webgl.extensions, resources = webgl.resources;
        this.drawTarget = Object(_mol_gl_webgl_render_target__WEBPACK_IMPORTED_MODULE_1__["createNullRenderTarget"])(webgl.gl);
        this.colorTarget = webgl.createRenderTarget(width, height, true, 'uint8', 'linear');
        this.packedDepth = !extensions.depthTexture;
        this.depthTarget = webgl.createRenderTarget(width, height);
        this.depthTexture = this.depthTarget.texture;
        this.depthTargetPrimitives = this.packedDepth ? webgl.createRenderTarget(width, height) : null;
        this.depthTargetVolumes = this.packedDepth ? webgl.createRenderTarget(width, height) : null;
        this.depthTexturePrimitives = this.depthTargetPrimitives ? this.depthTargetPrimitives.texture : resources.texture('image-depth', 'depth', 'ushort', 'nearest');
        this.depthTextureVolumes = this.depthTargetVolumes ? this.depthTargetVolumes.texture : resources.texture('image-depth', 'depth', 'ushort', 'nearest');
        if (!this.packedDepth) {
            this.depthTexturePrimitives.define(width, height);
            this.depthTextureVolumes.define(width, height);
        }
        this.depthMerge = getDepthMergeRenderable(webgl, this.depthTexturePrimitives, this.depthTextureVolumes, this.packedDepth);
        this.wboit = enableWboit ? new _wboit__WEBPACK_IMPORTED_MODULE_13__["WboitPass"](webgl, width, height) : undefined;
        this.postprocessing = new _postprocessing__WEBPACK_IMPORTED_MODULE_14__["PostprocessingPass"](webgl, this);
        this.antialiasing = new _postprocessing__WEBPACK_IMPORTED_MODULE_14__["AntialiasingPass"](webgl, this);
        this.copyFboTarget = getCopyRenderable(webgl, this.colorTarget.texture);
        this.copyFboPostprocessing = getCopyRenderable(webgl, this.postprocessing.target.texture);
    }
    Object.defineProperty(DrawPass.prototype, "wboitEnabled", {
        get: function () {
            var _a;
            return !!((_a = this.wboit) === null || _a === void 0 ? void 0 : _a.supported);
        },
        enumerable: false,
        configurable: true
    });
    DrawPass.prototype.reset = function () {
        var _a;
        (_a = this.wboit) === null || _a === void 0 ? void 0 : _a.reset();
    };
    DrawPass.prototype.setSize = function (width, height) {
        var _a;
        var w = this.colorTarget.getWidth();
        var h = this.colorTarget.getHeight();
        if (width !== w || height !== h) {
            this.colorTarget.setSize(width, height);
            this.depthTarget.setSize(width, height);
            if (this.depthTargetPrimitives) {
                this.depthTargetPrimitives.setSize(width, height);
            }
            else {
                this.depthTexturePrimitives.define(width, height);
            }
            if (this.depthTargetVolumes) {
                this.depthTargetVolumes.setSize(width, height);
            }
            else {
                this.depthTextureVolumes.define(width, height);
            }
            _mol_util__WEBPACK_IMPORTED_MODULE_7__["ValueCell"].update(this.depthMerge.values.uTexSize, _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_8__["Vec2"].set(this.depthMerge.values.uTexSize.ref.value, width, height));
            _mol_util__WEBPACK_IMPORTED_MODULE_7__["ValueCell"].update(this.copyFboTarget.values.uTexSize, _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_8__["Vec2"].set(this.copyFboTarget.values.uTexSize.ref.value, width, height));
            _mol_util__WEBPACK_IMPORTED_MODULE_7__["ValueCell"].update(this.copyFboPostprocessing.values.uTexSize, _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_8__["Vec2"].set(this.copyFboPostprocessing.values.uTexSize.ref.value, width, height));
            if ((_a = this.wboit) === null || _a === void 0 ? void 0 : _a.supported) {
                this.wboit.setSize(width, height);
            }
            this.postprocessing.setSize(width, height);
            this.antialiasing.setSize(width, height);
        }
    };
    DrawPass.prototype._depthMerge = function () {
        var _a = this.webgl, state = _a.state, gl = _a.gl;
        this.depthMerge.update();
        this.depthTarget.bind();
        state.disable(gl.BLEND);
        state.disable(gl.DEPTH_TEST);
        state.disable(gl.CULL_FACE);
        state.depthMask(false);
        state.clearColor(1, 1, 1, 1);
        gl.clear(gl.COLOR_BUFFER_BIT);
        this.depthMerge.render();
    };
    DrawPass.prototype._renderWboit = function (renderer, camera, scene, transparentBackground, postprocessingProps) {
        var _a;
        if (!((_a = this.wboit) === null || _a === void 0 ? void 0 : _a.supported))
            throw new Error('expected wboit to be supported');
        this.colorTarget.bind();
        renderer.clear(true);
        // render opaque primitives
        this.depthTexturePrimitives.attachFramebuffer(this.colorTarget.framebuffer, 'depth');
        this.colorTarget.bind();
        renderer.clearDepth();
        renderer.renderWboitOpaque(scene.primitives, camera, null);
        // render opaque volumes
        this.depthTextureVolumes.attachFramebuffer(this.colorTarget.framebuffer, 'depth');
        this.colorTarget.bind();
        renderer.clearDepth();
        renderer.renderWboitOpaque(scene.volumes, camera, this.depthTexturePrimitives);
        // merge depth of opaque primitives and volumes
        this._depthMerge();
        if (_postprocessing__WEBPACK_IMPORTED_MODULE_14__["PostprocessingPass"].isEnabled(postprocessingProps)) {
            this.postprocessing.render(camera, false, transparentBackground, renderer.props.backgroundColor, postprocessingProps);
        }
        // render transparent primitives and volumes
        this.wboit.bind();
        renderer.renderWboitTransparent(scene.primitives, camera, this.depthTexture);
        renderer.renderWboitTransparent(scene.volumes, camera, this.depthTexture);
        // evaluate wboit
        if (_postprocessing__WEBPACK_IMPORTED_MODULE_14__["PostprocessingPass"].isEnabled(postprocessingProps)) {
            this.depthTexturePrimitives.attachFramebuffer(this.postprocessing.target.framebuffer, 'depth');
            this.postprocessing.target.bind();
        }
        else {
            this.depthTexturePrimitives.attachFramebuffer(this.colorTarget.framebuffer, 'depth');
            this.colorTarget.bind();
        }
        this.wboit.render();
    };
    DrawPass.prototype._renderBlended = function (renderer, camera, scene, toDrawingBuffer, transparentBackground, postprocessingProps) {
        if (toDrawingBuffer) {
            this.drawTarget.bind();
        }
        else {
            this.colorTarget.bind();
            if (!this.packedDepth) {
                this.depthTexturePrimitives.attachFramebuffer(this.colorTarget.framebuffer, 'depth');
            }
        }
        renderer.clear(true);
        renderer.renderBlendedOpaque(scene.primitives, camera, null);
        if (!toDrawingBuffer) {
            // do a depth pass if not rendering to drawing buffer and
            // extensions.depthTexture is unsupported (i.e. depthTarget is set)
            if (this.depthTargetPrimitives) {
                this.depthTargetPrimitives.bind();
                renderer.clear(false);
                // TODO: this should only render opaque
                renderer.renderDepth(scene.primitives, camera, null);
                this.colorTarget.bind();
            }
            // do direct-volume rendering
            if (!this.packedDepth) {
                this.depthTextureVolumes.attachFramebuffer(this.colorTarget.framebuffer, 'depth');
                renderer.clearDepth(); // from previous frame
            }
            renderer.renderBlendedVolumeOpaque(scene.volumes, camera, this.depthTexturePrimitives);
            // do volume depth pass if extensions.depthTexture is unsupported (i.e. depthTarget is set)
            if (this.depthTargetVolumes) {
                this.depthTargetVolumes.bind();
                renderer.clear(false);
                renderer.renderDepth(scene.volumes, camera, this.depthTexturePrimitives);
                this.colorTarget.bind();
            }
            // merge depths from primitive and volume rendering
            this._depthMerge();
            this.colorTarget.bind();
            if (_postprocessing__WEBPACK_IMPORTED_MODULE_14__["PostprocessingPass"].isEnabled(postprocessingProps)) {
                this.postprocessing.render(camera, false, transparentBackground, renderer.props.backgroundColor, postprocessingProps);
            }
            renderer.renderBlendedVolumeTransparent(scene.volumes, camera, this.depthTexturePrimitives);
            var target = _postprocessing__WEBPACK_IMPORTED_MODULE_14__["PostprocessingPass"].isEnabled(postprocessingProps)
                ? this.postprocessing.target : this.colorTarget;
            if (!this.packedDepth) {
                this.depthTexturePrimitives.attachFramebuffer(target.framebuffer, 'depth');
            }
            target.bind();
        }
        renderer.renderBlendedTransparent(scene.primitives, camera, null);
    };
    DrawPass.prototype._render = function (renderer, camera, scene, helper, toDrawingBuffer, transparentBackground, postprocessingProps) {
        var volumeRendering = scene.volumes.renderables.length > 0;
        var postprocessingEnabled = _postprocessing__WEBPACK_IMPORTED_MODULE_14__["PostprocessingPass"].isEnabled(postprocessingProps);
        var antialiasingEnabled = _postprocessing__WEBPACK_IMPORTED_MODULE_14__["AntialiasingPass"].isEnabled(postprocessingProps);
        var _a = camera.viewport, x = _a.x, y = _a.y, width = _a.width, height = _a.height;
        renderer.setViewport(x, y, width, height);
        renderer.update(camera);
        if (this.wboitEnabled) {
            this._renderWboit(renderer, camera, scene, transparentBackground, postprocessingProps);
        }
        else {
            this._renderBlended(renderer, camera, scene, !volumeRendering && !postprocessingEnabled && !antialiasingEnabled && toDrawingBuffer, transparentBackground, postprocessingProps);
        }
        if (_postprocessing__WEBPACK_IMPORTED_MODULE_14__["PostprocessingPass"].isEnabled(postprocessingProps)) {
            this.postprocessing.target.bind();
        }
        else if (!toDrawingBuffer || volumeRendering || this.wboitEnabled) {
            this.colorTarget.bind();
        }
        else {
            this.drawTarget.bind();
        }
        if (helper.debug.isEnabled) {
            helper.debug.syncVisibility();
            renderer.renderBlended(helper.debug.scene, camera, null);
        }
        if (helper.handle.isEnabled) {
            renderer.renderBlended(helper.handle.scene, camera, null);
        }
        if (helper.camera.isEnabled) {
            helper.camera.update(camera);
            renderer.update(helper.camera.camera);
            renderer.renderBlended(helper.camera.scene, helper.camera.camera, null);
        }
        if (antialiasingEnabled) {
            this.antialiasing.render(camera, toDrawingBuffer, postprocessingProps);
        }
        else if (toDrawingBuffer) {
            this.drawTarget.bind();
            this.webgl.state.disable(this.webgl.gl.DEPTH_TEST);
            if (_postprocessing__WEBPACK_IMPORTED_MODULE_14__["PostprocessingPass"].isEnabled(postprocessingProps)) {
                this.copyFboPostprocessing.render();
            }
            else if (volumeRendering || this.wboitEnabled) {
                this.copyFboTarget.render();
            }
        }
        this.webgl.gl.flush();
    };
    DrawPass.prototype.render = function (renderer, camera, scene, helper, toDrawingBuffer, transparentBackground, postprocessingProps) {
        renderer.setTransparentBackground(transparentBackground);
        renderer.setDrawingBufferSize(this.colorTarget.getWidth(), this.colorTarget.getHeight());
        if (_camera_stereo__WEBPACK_IMPORTED_MODULE_12__["StereoCamera"].is(camera)) {
            this._render(renderer, camera.left, scene, helper, toDrawingBuffer, transparentBackground, postprocessingProps);
            this._render(renderer, camera.right, scene, helper, toDrawingBuffer, transparentBackground, postprocessingProps);
        }
        else {
            this._render(renderer, camera, scene, helper, toDrawingBuffer, transparentBackground, postprocessingProps);
        }
    };
    DrawPass.prototype.getColorTarget = function (postprocessingProps) {
        if (_postprocessing__WEBPACK_IMPORTED_MODULE_14__["AntialiasingPass"].isEnabled(postprocessingProps)) {
            return this.antialiasing.target;
        }
        else if (_postprocessing__WEBPACK_IMPORTED_MODULE_14__["PostprocessingPass"].isEnabled(postprocessingProps)) {
            return this.postprocessing.target;
        }
        return this.colorTarget;
    };
    return DrawPass;
}());

//# sourceMappingURL=draw.js.map

/***/ }),

/***/ "./lib/mol-canvas3d/passes/fxaa.js":
/*!*****************************************!*\
  !*** ./lib/mol-canvas3d/passes/fxaa.js ***!
  \*****************************************/
/*! exports provided: FxaaParams, FxaaPass */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FxaaParams", function() { return FxaaParams; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FxaaPass", function() { return FxaaPass; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _mol_gl_compute_util__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../mol-gl/compute/util */ "./lib/mol-gl/compute/util.js");
/* harmony import */ var _mol_gl_renderable__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../mol-gl/renderable */ "./lib/mol-gl/renderable.js");
/* harmony import */ var _mol_gl_renderable_schema__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../mol-gl/renderable/schema */ "./lib/mol-gl/renderable/schema.js");
/* harmony import */ var _mol_gl_shader_code__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../mol-gl/shader-code */ "./lib/mol-gl/shader-code.js");
/* harmony import */ var _mol_gl_webgl_render_item__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../mol-gl/webgl/render-item */ "./lib/mol-gl/webgl/render-item.js");
/* harmony import */ var _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../../mol-math/linear-algebra */ "./lib/mol-math/linear-algebra.js");
/* harmony import */ var _mol_util__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../../mol-util */ "./lib/mol-util/index.js");
/* harmony import */ var _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ../../mol-util/param-definition */ "./lib/mol-util/param-definition.js");
/* harmony import */ var _mol_gl_shader_quad_vert__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ../../mol-gl/shader/quad.vert */ "./lib/mol-gl/shader/quad.vert.js");
/* harmony import */ var _mol_gl_shader_fxaa_frag__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ../../mol-gl/shader/fxaa.frag */ "./lib/mol-gl/shader/fxaa.frag.js");
/**
 * Copyright (c) 2020 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */











var FxaaParams = {
    edgeThresholdMin: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_8__["ParamDefinition"].Numeric(0.0312, { min: 0.0312, max: 0.0833, step: 0.0001 }, { description: 'Trims the algorithm from processing darks.' }),
    edgeThresholdMax: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_8__["ParamDefinition"].Numeric(0.063, { min: 0.063, max: 0.333, step: 0.001 }, { description: 'The minimum amount of local contrast required to apply algorithm.' }),
    iterations: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_8__["ParamDefinition"].Numeric(12, { min: 0, max: 16, step: 1 }, { description: 'Number of edge exploration steps.' }),
    subpixelQuality: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_8__["ParamDefinition"].Numeric(0.30, { min: 0.00, max: 1.00, step: 0.01 }, { description: 'Choose the amount of sub-pixel aliasing removal.' }),
};
var FxaaPass = /** @class */ (function () {
    function FxaaPass(webgl, input) {
        this.webgl = webgl;
        this.renderable = getFxaaRenderable(webgl, input);
    }
    FxaaPass.prototype.updateState = function (viewport) {
        var _a = this.webgl, gl = _a.gl, state = _a.state;
        state.enable(gl.SCISSOR_TEST);
        state.disable(gl.BLEND);
        state.disable(gl.DEPTH_TEST);
        state.depthMask(false);
        var x = viewport.x, y = viewport.y, width = viewport.width, height = viewport.height;
        gl.viewport(x, y, width, height);
        gl.scissor(x, y, width, height);
        state.clearColor(0, 0, 0, 1);
        gl.clear(gl.COLOR_BUFFER_BIT);
    };
    FxaaPass.prototype.setSize = function (width, height) {
        _mol_util__WEBPACK_IMPORTED_MODULE_7__["ValueCell"].update(this.renderable.values.uTexSizeInv, _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_6__["Vec2"].set(this.renderable.values.uTexSizeInv.ref.value, 1 / width, 1 / height));
    };
    FxaaPass.prototype.update = function (input, props) {
        var values = this.renderable.values;
        var edgeThresholdMin = props.edgeThresholdMin, edgeThresholdMax = props.edgeThresholdMax, iterations = props.iterations, subpixelQuality = props.subpixelQuality;
        var needsUpdate = false;
        if (values.tColor.ref.value !== input) {
            _mol_util__WEBPACK_IMPORTED_MODULE_7__["ValueCell"].update(this.renderable.values.tColor, input);
            needsUpdate = true;
        }
        if (values.dEdgeThresholdMin.ref.value !== edgeThresholdMin)
            needsUpdate = true;
        _mol_util__WEBPACK_IMPORTED_MODULE_7__["ValueCell"].updateIfChanged(values.dEdgeThresholdMin, edgeThresholdMin);
        if (values.dEdgeThresholdMax.ref.value !== edgeThresholdMax)
            needsUpdate = true;
        _mol_util__WEBPACK_IMPORTED_MODULE_7__["ValueCell"].updateIfChanged(values.dEdgeThresholdMax, edgeThresholdMax);
        if (values.dIterations.ref.value !== iterations)
            needsUpdate = true;
        _mol_util__WEBPACK_IMPORTED_MODULE_7__["ValueCell"].updateIfChanged(values.dIterations, iterations);
        if (values.dSubpixelQuality.ref.value !== subpixelQuality)
            needsUpdate = true;
        _mol_util__WEBPACK_IMPORTED_MODULE_7__["ValueCell"].updateIfChanged(values.dSubpixelQuality, subpixelQuality);
        if (needsUpdate) {
            this.renderable.update();
        }
    };
    FxaaPass.prototype.render = function (viewport, target) {
        if (target) {
            target.bind();
        }
        else {
            this.webgl.unbindFramebuffer();
        }
        this.updateState(viewport);
        this.renderable.render();
    };
    return FxaaPass;
}());

//
var FxaaSchema = Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, _mol_gl_compute_util__WEBPACK_IMPORTED_MODULE_1__["QuadSchema"]), { tColor: Object(_mol_gl_renderable_schema__WEBPACK_IMPORTED_MODULE_3__["TextureSpec"])('texture', 'rgba', 'ubyte', 'linear'), uTexSizeInv: Object(_mol_gl_renderable_schema__WEBPACK_IMPORTED_MODULE_3__["UniformSpec"])('v2'), dEdgeThresholdMin: Object(_mol_gl_renderable_schema__WEBPACK_IMPORTED_MODULE_3__["DefineSpec"])('number'), dEdgeThresholdMax: Object(_mol_gl_renderable_schema__WEBPACK_IMPORTED_MODULE_3__["DefineSpec"])('number'), dIterations: Object(_mol_gl_renderable_schema__WEBPACK_IMPORTED_MODULE_3__["DefineSpec"])('number'), dSubpixelQuality: Object(_mol_gl_renderable_schema__WEBPACK_IMPORTED_MODULE_3__["DefineSpec"])('number') });
var FxaaShaderCode = Object(_mol_gl_shader_code__WEBPACK_IMPORTED_MODULE_4__["ShaderCode"])('fxaa', _mol_gl_shader_quad_vert__WEBPACK_IMPORTED_MODULE_9__["default"], _mol_gl_shader_fxaa_frag__WEBPACK_IMPORTED_MODULE_10__["default"]);
function getFxaaRenderable(ctx, colorTexture) {
    var width = colorTexture.getWidth();
    var height = colorTexture.getHeight();
    var values = Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, _mol_gl_compute_util__WEBPACK_IMPORTED_MODULE_1__["QuadValues"]), { tColor: _mol_util__WEBPACK_IMPORTED_MODULE_7__["ValueCell"].create(colorTexture), uTexSizeInv: _mol_util__WEBPACK_IMPORTED_MODULE_7__["ValueCell"].create(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_6__["Vec2"].create(1 / width, 1 / height)), dEdgeThresholdMin: _mol_util__WEBPACK_IMPORTED_MODULE_7__["ValueCell"].create(0.0312), dEdgeThresholdMax: _mol_util__WEBPACK_IMPORTED_MODULE_7__["ValueCell"].create(0.125), dIterations: _mol_util__WEBPACK_IMPORTED_MODULE_7__["ValueCell"].create(12), dSubpixelQuality: _mol_util__WEBPACK_IMPORTED_MODULE_7__["ValueCell"].create(0.3) });
    var schema = Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, FxaaSchema);
    var renderItem = Object(_mol_gl_webgl_render_item__WEBPACK_IMPORTED_MODULE_5__["createComputeRenderItem"])(ctx, 'triangles', FxaaShaderCode, schema, values);
    return Object(_mol_gl_renderable__WEBPACK_IMPORTED_MODULE_2__["createComputeRenderable"])(renderItem, values);
}
//# sourceMappingURL=fxaa.js.map

/***/ }),

/***/ "./lib/mol-canvas3d/passes/image.js":
/*!******************************************!*\
  !*** ./lib/mol-canvas3d/passes/image.js ***!
  \******************************************/
/*! exports provided: ImageParams, ImagePass */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ImageParams", function() { return ImageParams; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ImagePass", function() { return ImagePass; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../mol-util/param-definition */ "./lib/mol-util/param-definition.js");
/* harmony import */ var _draw__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./draw */ "./lib/mol-canvas3d/passes/draw.js");
/* harmony import */ var _postprocessing__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./postprocessing */ "./lib/mol-canvas3d/passes/postprocessing.js");
/* harmony import */ var _multi_sample__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./multi-sample */ "./lib/mol-canvas3d/passes/multi-sample.js");
/* harmony import */ var _camera__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../camera */ "./lib/mol-canvas3d/camera.js");
/* harmony import */ var _camera_util__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../camera/util */ "./lib/mol-canvas3d/camera/util.js");
/* harmony import */ var _mol_util_image__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../../mol-util/image */ "./lib/mol-util/image.js");
/* harmony import */ var _helper_camera_helper__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ../helper/camera-helper */ "./lib/mol-canvas3d/helper/camera-helper.js");
/**
 * Copyright (c) 2019-2020 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */









var ImageParams = {
    transparentBackground: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_1__["ParamDefinition"].Boolean(false),
    multiSample: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_1__["ParamDefinition"].Group(_multi_sample__WEBPACK_IMPORTED_MODULE_4__["MultiSampleParams"]),
    postprocessing: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_1__["ParamDefinition"].Group(_postprocessing__WEBPACK_IMPORTED_MODULE_3__["PostprocessingParams"]),
    cameraHelper: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_1__["ParamDefinition"].Group(_helper_camera_helper__WEBPACK_IMPORTED_MODULE_8__["CameraHelperParams"]),
};
var ImagePass = /** @class */ (function () {
    function ImagePass(webgl, renderer, scene, camera, helper, enableWboit, props) {
        this.webgl = webgl;
        this.renderer = renderer;
        this.scene = scene;
        this.camera = camera;
        this._width = 0;
        this._height = 0;
        this._camera = new _camera__WEBPACK_IMPORTED_MODULE_5__["Camera"]();
        this.props = Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_1__["ParamDefinition"].getDefaultValues(ImageParams)), props);
        this.drawPass = new _draw__WEBPACK_IMPORTED_MODULE_2__["DrawPass"](webgl, 128, 128, enableWboit);
        this.multiSamplePass = new _multi_sample__WEBPACK_IMPORTED_MODULE_4__["MultiSamplePass"](webgl, this.drawPass);
        this.multiSampleHelper = new _multi_sample__WEBPACK_IMPORTED_MODULE_4__["MultiSampleHelper"](this.multiSamplePass);
        this.helper = {
            camera: new _helper_camera_helper__WEBPACK_IMPORTED_MODULE_8__["CameraHelper"](webgl, this.props.cameraHelper),
            debug: helper.debug,
            handle: helper.handle,
        };
        this.setSize(1024, 768);
    }
    Object.defineProperty(ImagePass.prototype, "colorTarget", {
        get: function () { return this._colorTarget; },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ImagePass.prototype, "width", {
        get: function () { return this._width; },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ImagePass.prototype, "height", {
        get: function () { return this._height; },
        enumerable: false,
        configurable: true
    });
    ImagePass.prototype.setSize = function (width, height) {
        if (width === this._width && height === this._height)
            return;
        this._width = width;
        this._height = height;
        this.drawPass.setSize(width, height);
        this.multiSamplePass.syncSize();
    };
    ImagePass.prototype.setProps = function (props) {
        if (props === void 0) { props = {}; }
        Object.assign(this.props, props);
        if (props.cameraHelper)
            this.helper.camera.setProps(props.cameraHelper);
    };
    ImagePass.prototype.render = function () {
        _camera__WEBPACK_IMPORTED_MODULE_5__["Camera"].copySnapshot(this._camera.state, this.camera.state);
        _camera_util__WEBPACK_IMPORTED_MODULE_6__["Viewport"].set(this._camera.viewport, 0, 0, this._width, this._height);
        this._camera.update();
        if (_multi_sample__WEBPACK_IMPORTED_MODULE_4__["MultiSamplePass"].isEnabled(this.props.multiSample)) {
            this.multiSampleHelper.render(this.renderer, this._camera, this.scene, this.helper, false, this.props.transparentBackground, this.props);
            this._colorTarget = this.multiSamplePass.colorTarget;
        }
        else {
            this.drawPass.render(this.renderer, this._camera, this.scene, this.helper, false, this.props.transparentBackground, this.props.postprocessing);
            this._colorTarget = this.drawPass.getColorTarget(this.props.postprocessing);
        }
    };
    ImagePass.prototype.getImageData = function (width, height, viewport) {
        var _a, _b;
        this.setSize(width, height);
        this.render();
        this.colorTarget.bind();
        var w = (_a = viewport === null || viewport === void 0 ? void 0 : viewport.width) !== null && _a !== void 0 ? _a : width, h = (_b = viewport === null || viewport === void 0 ? void 0 : viewport.height) !== null && _b !== void 0 ? _b : height;
        var array = new Uint8Array(w * h * 4);
        if (!viewport) {
            this.webgl.readPixels(0, 0, w, h, array);
        }
        else {
            this.webgl.readPixels(viewport.x, height - viewport.y - viewport.height, w, h, array);
        }
        _mol_util_image__WEBPACK_IMPORTED_MODULE_7__["PixelData"].flipY({ array: array, width: w, height: h });
        return new ImageData(new Uint8ClampedArray(array), w, h);
    };
    return ImagePass;
}());

//# sourceMappingURL=image.js.map

/***/ }),

/***/ "./lib/mol-canvas3d/passes/multi-sample.js":
/*!*************************************************!*\
  !*** ./lib/mol-canvas3d/passes/multi-sample.js ***!
  \*************************************************/
/*! exports provided: MultiSampleParams, MultiSamplePass, MultiSampleHelper */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MultiSampleParams", function() { return MultiSampleParams; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MultiSamplePass", function() { return MultiSamplePass; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MultiSampleHelper", function() { return MultiSampleHelper; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _mol_gl_compute_util__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../mol-gl/compute/util */ "./lib/mol-gl/compute/util.js");
/* harmony import */ var _mol_gl_renderable_schema__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../mol-gl/renderable/schema */ "./lib/mol-gl/renderable/schema.js");
/* harmony import */ var _mol_util__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../mol-util */ "./lib/mol-util/index.js");
/* harmony import */ var _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../mol-math/linear-algebra */ "./lib/mol-math/linear-algebra.js");
/* harmony import */ var _mol_gl_shader_code__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../mol-gl/shader-code */ "./lib/mol-gl/shader-code.js");
/* harmony import */ var _mol_gl_webgl_render_item__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../../mol-gl/webgl/render-item */ "./lib/mol-gl/webgl/render-item.js");
/* harmony import */ var _mol_gl_renderable__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../../mol-gl/renderable */ "./lib/mol-gl/renderable.js");
/* harmony import */ var _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ../../mol-util/param-definition */ "./lib/mol-util/param-definition.js");
/* harmony import */ var _mol_canvas3d_camera__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ../../mol-canvas3d/camera */ "./lib/mol-canvas3d/camera.js");
/* harmony import */ var _mol_gl_shader_quad_vert__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ../../mol-gl/shader/quad.vert */ "./lib/mol-gl/shader/quad.vert.js");
/* harmony import */ var _mol_gl_shader_compose_frag__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ../../mol-gl/shader/compose.frag */ "./lib/mol-gl/shader/compose.frag.js");
/**
 * Copyright (c) 2019-2021 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */












var ComposeSchema = Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, _mol_gl_compute_util__WEBPACK_IMPORTED_MODULE_1__["QuadSchema"]), { tColor: Object(_mol_gl_renderable_schema__WEBPACK_IMPORTED_MODULE_2__["TextureSpec"])('texture', 'rgba', 'ubyte', 'nearest'), uTexSize: Object(_mol_gl_renderable_schema__WEBPACK_IMPORTED_MODULE_2__["UniformSpec"])('v2'), uWeight: Object(_mol_gl_renderable_schema__WEBPACK_IMPORTED_MODULE_2__["UniformSpec"])('f') });
var ComposeShaderCode = Object(_mol_gl_shader_code__WEBPACK_IMPORTED_MODULE_5__["ShaderCode"])('compose', _mol_gl_shader_quad_vert__WEBPACK_IMPORTED_MODULE_10__["default"], _mol_gl_shader_compose_frag__WEBPACK_IMPORTED_MODULE_11__["default"]);
function getComposeRenderable(ctx, colorTexture) {
    var values = Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, _mol_gl_compute_util__WEBPACK_IMPORTED_MODULE_1__["QuadValues"]), { tColor: _mol_util__WEBPACK_IMPORTED_MODULE_3__["ValueCell"].create(colorTexture), uTexSize: _mol_util__WEBPACK_IMPORTED_MODULE_3__["ValueCell"].create(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_4__["Vec2"].create(colorTexture.getWidth(), colorTexture.getHeight())), uWeight: _mol_util__WEBPACK_IMPORTED_MODULE_3__["ValueCell"].create(1.0) });
    var schema = Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, ComposeSchema);
    var renderItem = Object(_mol_gl_webgl_render_item__WEBPACK_IMPORTED_MODULE_6__["createComputeRenderItem"])(ctx, 'triangles', ComposeShaderCode, schema, values);
    return Object(_mol_gl_renderable__WEBPACK_IMPORTED_MODULE_7__["createComputeRenderable"])(renderItem, values);
}
var MultiSampleParams = {
    mode: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_8__["ParamDefinition"].Select('off', [['off', 'Off'], ['on', 'On'], ['temporal', 'Temporal']]),
    sampleLevel: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_8__["ParamDefinition"].Numeric(2, { min: 0, max: 5, step: 1 }),
};
var MultiSamplePass = /** @class */ (function () {
    function MultiSamplePass(webgl, drawPass) {
        this.webgl = webgl;
        this.drawPass = drawPass;
        var _a = webgl.extensions, colorBufferFloat = _a.colorBufferFloat, textureFloat = _a.textureFloat, colorBufferHalfFloat = _a.colorBufferHalfFloat, textureHalfFloat = _a.textureHalfFloat;
        var width = drawPass.colorTarget.getWidth();
        var height = drawPass.colorTarget.getHeight();
        this.colorTarget = webgl.createRenderTarget(width, height, false);
        var type = colorBufferHalfFloat && textureHalfFloat ? 'fp16' :
            colorBufferFloat && textureFloat ? 'float32' : 'uint8';
        this.composeTarget = webgl.createRenderTarget(width, height, false, type);
        this.holdTarget = webgl.createRenderTarget(width, height, false);
        this.compose = getComposeRenderable(webgl, drawPass.colorTarget.texture);
    }
    MultiSamplePass.isEnabled = function (props) {
        return props.mode !== 'off';
    };
    MultiSamplePass.prototype.syncSize = function () {
        var width = this.drawPass.colorTarget.getWidth();
        var height = this.drawPass.colorTarget.getHeight();
        var _a = this.compose.values.uTexSize.ref.value, w = _a[0], h = _a[1];
        if (width !== w || height !== h) {
            this.colorTarget.setSize(width, height);
            this.composeTarget.setSize(width, height);
            this.holdTarget.setSize(width, height);
            _mol_util__WEBPACK_IMPORTED_MODULE_3__["ValueCell"].update(this.compose.values.uTexSize, _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_4__["Vec2"].set(this.compose.values.uTexSize.ref.value, width, height));
        }
    };
    MultiSamplePass.prototype.render = function (sampleIndex, renderer, camera, scene, helper, toDrawingBuffer, transparentBackground, props) {
        if (props.multiSample.mode === 'temporal') {
            return this.renderTemporalMultiSample(sampleIndex, renderer, camera, scene, helper, toDrawingBuffer, transparentBackground, props);
        }
        else {
            this.renderMultiSample(renderer, camera, scene, helper, toDrawingBuffer, transparentBackground, props);
            return sampleIndex;
        }
    };
    MultiSamplePass.prototype.bindOutputTarget = function (toDrawingBuffer) {
        if (toDrawingBuffer) {
            this.webgl.unbindFramebuffer();
        }
        else {
            this.colorTarget.bind();
        }
    };
    MultiSamplePass.prototype.renderMultiSample = function (renderer, camera, scene, helper, toDrawingBuffer, transparentBackground, props) {
        var _a = this, compose = _a.compose, composeTarget = _a.composeTarget, drawPass = _a.drawPass, webgl = _a.webgl;
        var gl = webgl.gl, state = webgl.state;
        // based on the Multisample Anti-Aliasing Render Pass
        // contributed to three.js by bhouston / http://clara.io/
        //
        // This manual approach to MSAA re-renders the scene once for
        // each sample with camera jitter and accumulates the results.
        var offsetList = JitterVectors[Math.max(0, Math.min(props.multiSample.sampleLevel, 5))];
        var _b = camera.viewport, x = _b.x, y = _b.y, width = _b.width, height = _b.height;
        var baseSampleWeight = 1.0 / offsetList.length;
        var roundingRange = 1 / 32;
        camera.viewOffset.enabled = true;
        _mol_util__WEBPACK_IMPORTED_MODULE_3__["ValueCell"].update(compose.values.tColor, drawPass.getColorTarget(props.postprocessing).texture);
        compose.update();
        // render the scene multiple times, each slightly jitter offset
        // from the last and accumulate the results.
        for (var i = 0; i < offsetList.length; ++i) {
            var offset = offsetList[i];
            _mol_canvas3d_camera__WEBPACK_IMPORTED_MODULE_9__["Camera"].setViewOffset(camera.viewOffset, width, height, offset[0], offset[1], width, height);
            camera.update();
            // the theory is that equal weights for each sample lead to an accumulation of rounding
            // errors. The following equation varies the sampleWeight per sample so that it is uniformly
            // distributed across a range of values whose rounding errors cancel each other out.
            var uniformCenteredDistribution = -0.5 + (i + 0.5) / offsetList.length;
            var sampleWeight = baseSampleWeight + roundingRange * uniformCenteredDistribution;
            _mol_util__WEBPACK_IMPORTED_MODULE_3__["ValueCell"].update(compose.values.uWeight, sampleWeight);
            // render scene
            drawPass.render(renderer, camera, scene, helper, false, transparentBackground, props.postprocessing);
            // compose rendered scene with compose target
            composeTarget.bind();
            state.enable(gl.BLEND);
            state.blendEquationSeparate(gl.FUNC_ADD, gl.FUNC_ADD);
            state.blendFuncSeparate(gl.ONE, gl.ONE, gl.ONE, gl.ONE);
            state.disable(gl.DEPTH_TEST);
            state.depthMask(false);
            gl.viewport(x, y, width, height);
            gl.scissor(x, y, width, height);
            if (i === 0) {
                state.clearColor(0, 0, 0, 0);
                gl.clear(gl.COLOR_BUFFER_BIT);
            }
            compose.render();
        }
        _mol_util__WEBPACK_IMPORTED_MODULE_3__["ValueCell"].update(compose.values.uWeight, 1.0);
        _mol_util__WEBPACK_IMPORTED_MODULE_3__["ValueCell"].update(compose.values.tColor, composeTarget.texture);
        compose.update();
        this.bindOutputTarget(toDrawingBuffer);
        gl.viewport(x, y, width, height);
        gl.scissor(x, y, width, height);
        state.disable(gl.BLEND);
        compose.render();
        camera.viewOffset.enabled = false;
        camera.update();
    };
    MultiSamplePass.prototype.renderTemporalMultiSample = function (sampleIndex, renderer, camera, scene, helper, toDrawingBuffer, transparentBackground, props) {
        var _a = this, compose = _a.compose, composeTarget = _a.composeTarget, holdTarget = _a.holdTarget, drawPass = _a.drawPass, webgl = _a.webgl;
        var gl = webgl.gl, state = webgl.state;
        // based on the Multisample Anti-Aliasing Render Pass
        // contributed to three.js by bhouston / http://clara.io/
        //
        // This manual approach to MSAA re-renders the scene once for
        // each sample with camera jitter and accumulates the results.
        var offsetList = JitterVectors[Math.max(0, Math.min(props.multiSample.sampleLevel, 5))];
        if (sampleIndex === -2 || sampleIndex >= offsetList.length)
            return -2;
        var _b = camera.viewport, x = _b.x, y = _b.y, width = _b.width, height = _b.height;
        var sampleWeight = 1.0 / offsetList.length;
        if (sampleIndex === -1) {
            drawPass.render(renderer, camera, scene, helper, false, transparentBackground, props.postprocessing);
            _mol_util__WEBPACK_IMPORTED_MODULE_3__["ValueCell"].update(compose.values.uWeight, 1.0);
            _mol_util__WEBPACK_IMPORTED_MODULE_3__["ValueCell"].update(compose.values.tColor, drawPass.getColorTarget(props.postprocessing).texture);
            compose.update();
            holdTarget.bind();
            state.disable(gl.BLEND);
            state.disable(gl.DEPTH_TEST);
            state.depthMask(false);
            gl.viewport(x, y, width, height);
            gl.scissor(x, y, width, height);
            compose.render();
            sampleIndex += 1;
        }
        else {
            camera.viewOffset.enabled = true;
            _mol_util__WEBPACK_IMPORTED_MODULE_3__["ValueCell"].update(compose.values.tColor, drawPass.getColorTarget(props.postprocessing).texture);
            _mol_util__WEBPACK_IMPORTED_MODULE_3__["ValueCell"].update(compose.values.uWeight, sampleWeight);
            compose.update();
            // render the scene multiple times, each slightly jitter offset
            // from the last and accumulate the results.
            var numSamplesPerFrame = Math.pow(2, Math.max(0, props.multiSample.sampleLevel - 2));
            for (var i = 0; i < numSamplesPerFrame; ++i) {
                var offset = offsetList[sampleIndex];
                _mol_canvas3d_camera__WEBPACK_IMPORTED_MODULE_9__["Camera"].setViewOffset(camera.viewOffset, width, height, offset[0], offset[1], width, height);
                camera.update();
                // render scene
                drawPass.render(renderer, camera, scene, helper, false, transparentBackground, props.postprocessing);
                // compose rendered scene with compose target
                composeTarget.bind();
                state.enable(gl.BLEND);
                state.blendEquationSeparate(gl.FUNC_ADD, gl.FUNC_ADD);
                state.blendFuncSeparate(gl.ONE, gl.ONE, gl.ONE, gl.ONE);
                state.disable(gl.DEPTH_TEST);
                state.depthMask(false);
                gl.viewport(x, y, width, height);
                gl.scissor(x, y, width, height);
                if (sampleIndex === 0) {
                    state.clearColor(0, 0, 0, 0);
                    gl.clear(gl.COLOR_BUFFER_BIT);
                }
                compose.render();
                sampleIndex += 1;
                if (sampleIndex >= offsetList.length)
                    break;
            }
        }
        this.bindOutputTarget(toDrawingBuffer);
        gl.viewport(x, y, width, height);
        gl.scissor(x, y, width, height);
        var accumulationWeight = sampleIndex * sampleWeight;
        if (accumulationWeight > 0) {
            _mol_util__WEBPACK_IMPORTED_MODULE_3__["ValueCell"].update(compose.values.uWeight, 1.0);
            _mol_util__WEBPACK_IMPORTED_MODULE_3__["ValueCell"].update(compose.values.tColor, composeTarget.texture);
            compose.update();
            state.disable(gl.BLEND);
            compose.render();
        }
        if (accumulationWeight < 1.0) {
            _mol_util__WEBPACK_IMPORTED_MODULE_3__["ValueCell"].update(compose.values.uWeight, 1.0 - accumulationWeight);
            _mol_util__WEBPACK_IMPORTED_MODULE_3__["ValueCell"].update(compose.values.tColor, holdTarget.texture);
            compose.update();
            if (accumulationWeight === 0)
                state.disable(gl.BLEND);
            else
                state.enable(gl.BLEND);
            compose.render();
        }
        camera.viewOffset.enabled = false;
        camera.update();
        return sampleIndex >= offsetList.length ? -2 : sampleIndex;
    };
    return MultiSamplePass;
}());

var JitterVectors = [
    [
        [0, 0]
    ],
    [
        [4, 4], [-4, -4]
    ],
    [
        [-2, -6], [6, -2], [-6, 2], [2, 6]
    ],
    [
        [1, -3], [-1, 3], [5, 1], [-3, -5],
        [-5, 5], [-7, -1], [3, 7], [7, -7]
    ],
    [
        [1, 1], [-1, -3], [-3, 2], [4, -1],
        [-5, -2], [2, 5], [5, 3], [3, -5],
        [-2, 6], [0, -7], [-4, -6], [-6, 4],
        [-8, 0], [7, -4], [6, 7], [-7, -8]
    ],
    [
        [-4, -7], [-7, -5], [-3, -5], [-5, -4],
        [-1, -4], [-2, -2], [-6, -1], [-4, 0],
        [-7, 1], [-1, 2], [-6, 3], [-3, 3],
        [-7, 6], [-3, 6], [-5, 7], [-1, 7],
        [5, -7], [1, -6], [6, -5], [4, -4],
        [2, -3], [7, -2], [1, -1], [4, -1],
        [2, 1], [6, 2], [0, 4], [4, 4],
        [2, 5], [7, 5], [5, 6], [3, 7]
    ]
];
JitterVectors.forEach(function (offsetList) {
    offsetList.forEach(function (offset) {
        // 0.0625 = 1 / 16
        offset[0] *= 0.0625;
        offset[1] *= 0.0625;
    });
});
var MultiSampleHelper = /** @class */ (function () {
    function MultiSampleHelper(multiSamplePass) {
        this.multiSamplePass = multiSamplePass;
        this.sampleIndex = -2;
    }
    MultiSampleHelper.prototype.update = function (changed, props) {
        if (changed)
            this.sampleIndex = -1;
        return props.mode === 'temporal' ? this.sampleIndex !== -2 : false;
    };
    MultiSampleHelper.prototype.render = function (renderer, camera, scene, helper, toDrawingBuffer, transparentBackground, props) {
        this.sampleIndex = this.multiSamplePass.render(this.sampleIndex, renderer, camera, scene, helper, toDrawingBuffer, transparentBackground, props);
    };
    return MultiSampleHelper;
}());

//# sourceMappingURL=multi-sample.js.map

/***/ }),

/***/ "./lib/mol-canvas3d/passes/passes.js":
/*!*******************************************!*\
  !*** ./lib/mol-canvas3d/passes/passes.js ***!
  \*******************************************/
/*! exports provided: Passes */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Passes", function() { return Passes; });
/* harmony import */ var _draw__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./draw */ "./lib/mol-canvas3d/passes/draw.js");
/* harmony import */ var _pick__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./pick */ "./lib/mol-canvas3d/passes/pick.js");
/* harmony import */ var _multi_sample__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./multi-sample */ "./lib/mol-canvas3d/passes/multi-sample.js");
/**
 * Copyright (c) 2020 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */



var Passes = /** @class */ (function () {
    function Passes(webgl, attribs) {
        if (attribs === void 0) { attribs = {}; }
        this.webgl = webgl;
        var gl = webgl.gl;
        this.draw = new _draw__WEBPACK_IMPORTED_MODULE_0__["DrawPass"](webgl, gl.drawingBufferWidth, gl.drawingBufferHeight, attribs.enableWboit || false);
        this.pick = new _pick__WEBPACK_IMPORTED_MODULE_1__["PickPass"](webgl, this.draw, attribs.pickScale || 0.25);
        this.multiSample = new _multi_sample__WEBPACK_IMPORTED_MODULE_2__["MultiSamplePass"](webgl, this.draw);
    }
    Passes.prototype.updateSize = function () {
        var gl = this.webgl.gl;
        this.draw.setSize(gl.drawingBufferWidth, gl.drawingBufferHeight);
        this.pick.syncSize();
        this.multiSample.syncSize();
    };
    return Passes;
}());

//# sourceMappingURL=passes.js.map

/***/ }),

/***/ "./lib/mol-canvas3d/passes/pick.js":
/*!*****************************************!*\
  !*** ./lib/mol-canvas3d/passes/pick.js ***!
  \*****************************************/
/*! exports provided: PickPass, PickHelper */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "PickPass", function() { return PickPass; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "PickHelper", function() { return PickHelper; });
/* harmony import */ var _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../mol-math/linear-algebra */ "./lib/mol-math/linear-algebra.js");
/* harmony import */ var _mol_util_float_packing__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../mol-util/float-packing */ "./lib/mol-util/float-packing.js");
/* harmony import */ var _camera_stereo__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../camera/stereo */ "./lib/mol-canvas3d/camera/stereo.js");
/* harmony import */ var _camera_util__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../camera/util */ "./lib/mol-canvas3d/camera/util.js");
/**
 * Copyright (c) 2019-2020 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */





var NullId = Math.pow(2, 24) - 2;
var PickPass = /** @class */ (function () {
    function PickPass(webgl, drawPass, pickBaseScale) {
        this.webgl = webgl;
        this.drawPass = drawPass;
        this.pickBaseScale = pickBaseScale;
        var pickScale = pickBaseScale / webgl.pixelRatio;
        this.pickWidth = Math.ceil(drawPass.colorTarget.getWidth() * pickScale);
        this.pickHeight = Math.ceil(drawPass.colorTarget.getHeight() * pickScale);
        this.objectPickTarget = webgl.createRenderTarget(this.pickWidth, this.pickHeight);
        this.instancePickTarget = webgl.createRenderTarget(this.pickWidth, this.pickHeight);
        this.groupPickTarget = webgl.createRenderTarget(this.pickWidth, this.pickHeight);
        this.depthPickTarget = webgl.createRenderTarget(this.pickWidth, this.pickHeight);
    }
    Object.defineProperty(PickPass.prototype, "drawingBufferHeight", {
        get: function () {
            return this.drawPass.colorTarget.getHeight();
        },
        enumerable: false,
        configurable: true
    });
    PickPass.prototype.syncSize = function () {
        var pickScale = this.pickBaseScale / this.webgl.pixelRatio;
        var pickWidth = Math.ceil(this.drawPass.colorTarget.getWidth() * pickScale);
        var pickHeight = Math.ceil(this.drawPass.colorTarget.getHeight() * pickScale);
        if (pickWidth !== this.pickWidth || pickHeight !== this.pickHeight) {
            this.pickWidth = pickWidth;
            this.pickHeight = pickHeight;
            this.objectPickTarget.setSize(this.pickWidth, this.pickHeight);
            this.instancePickTarget.setSize(this.pickWidth, this.pickHeight);
            this.groupPickTarget.setSize(this.pickWidth, this.pickHeight);
            this.depthPickTarget.setSize(this.pickWidth, this.pickHeight);
        }
    };
    PickPass.prototype.renderVariant = function (renderer, camera, scene, helper, variant) {
        var depth = this.drawPass.depthTexturePrimitives;
        renderer.clear(false);
        renderer.renderPick(scene.primitives, camera, variant, null);
        renderer.renderPick(scene.volumes, camera, variant, depth);
        renderer.renderPick(helper.handle.scene, camera, variant, null);
    };
    PickPass.prototype.render = function (renderer, camera, scene, helper) {
        renderer.update(camera);
        this.objectPickTarget.bind();
        this.renderVariant(renderer, camera, scene, helper, 'pickObject');
        this.instancePickTarget.bind();
        this.renderVariant(renderer, camera, scene, helper, 'pickInstance');
        this.groupPickTarget.bind();
        this.renderVariant(renderer, camera, scene, helper, 'pickGroup');
        this.depthPickTarget.bind();
        this.renderVariant(renderer, camera, scene, helper, 'depth');
    };
    return PickPass;
}());

var PickHelper = /** @class */ (function () {
    function PickHelper(webgl, renderer, scene, helper, pickPass, viewport) {
        this.webgl = webgl;
        this.renderer = renderer;
        this.scene = scene;
        this.helper = helper;
        this.pickPass = pickPass;
        this.dirty = true;
        this.viewport = Object(_camera_util__WEBPACK_IMPORTED_MODULE_3__["Viewport"])();
        this.setViewport(viewport.x, viewport.y, viewport.width, viewport.height);
    }
    PickHelper.prototype.setupBuffers = function () {
        var bufferSize = this.pickWidth * this.pickHeight * 4;
        if (!this.objectBuffer || this.objectBuffer.length !== bufferSize) {
            this.objectBuffer = new Uint8Array(bufferSize);
            this.instanceBuffer = new Uint8Array(bufferSize);
            this.groupBuffer = new Uint8Array(bufferSize);
            this.depthBuffer = new Uint8Array(bufferSize);
        }
    };
    PickHelper.prototype.setViewport = function (x, y, width, height) {
        _camera_util__WEBPACK_IMPORTED_MODULE_3__["Viewport"].set(this.viewport, x, y, width, height);
        this.pickScale = this.pickPass.pickBaseScale / this.webgl.pixelRatio;
        this.pickX = Math.ceil(x * this.pickScale);
        this.pickY = Math.ceil(y * this.pickScale);
        var pickWidth = Math.ceil(width * this.pickScale);
        var pickHeight = Math.ceil(height * this.pickScale);
        if (pickWidth !== this.pickWidth || pickHeight !== this.pickHeight) {
            this.pickWidth = pickWidth;
            this.pickHeight = pickHeight;
            this.halfPickWidth = Math.floor(this.pickWidth / 2);
            this.setupBuffers();
        }
    };
    PickHelper.prototype.syncBuffers = function () {
        var _a = this, pickX = _a.pickX, pickY = _a.pickY, pickWidth = _a.pickWidth, pickHeight = _a.pickHeight;
        this.pickPass.objectPickTarget.bind();
        this.webgl.readPixels(pickX, pickY, pickWidth, pickHeight, this.objectBuffer);
        this.pickPass.instancePickTarget.bind();
        this.webgl.readPixels(pickX, pickY, pickWidth, pickHeight, this.instanceBuffer);
        this.pickPass.groupPickTarget.bind();
        this.webgl.readPixels(pickX, pickY, pickWidth, pickHeight, this.groupBuffer);
        this.pickPass.depthPickTarget.bind();
        this.webgl.readPixels(pickX, pickY, pickWidth, pickHeight, this.depthBuffer);
    };
    PickHelper.prototype.getBufferIdx = function (x, y) {
        return (y * this.pickWidth + x) * 4;
    };
    PickHelper.prototype.getDepth = function (x, y) {
        var idx = this.getBufferIdx(x, y);
        var b = this.depthBuffer;
        return Object(_mol_util_float_packing__WEBPACK_IMPORTED_MODULE_1__["unpackRGBAToDepth"])(b[idx], b[idx + 1], b[idx + 2], b[idx + 3]);
    };
    PickHelper.prototype.getId = function (x, y, buffer) {
        var idx = this.getBufferIdx(x, y);
        return Object(_mol_util_float_packing__WEBPACK_IMPORTED_MODULE_1__["decodeFloatRGB"])(buffer[idx], buffer[idx + 1], buffer[idx + 2]);
    };
    PickHelper.prototype.render = function (camera) {
        var _a = this, pickX = _a.pickX, pickY = _a.pickY, pickWidth = _a.pickWidth, pickHeight = _a.pickHeight, halfPickWidth = _a.halfPickWidth;
        var _b = this, renderer = _b.renderer, scene = _b.scene, helper = _b.helper;
        renderer.setTransparentBackground(false);
        renderer.setDrawingBufferSize(this.pickPass.objectPickTarget.getWidth(), this.pickPass.objectPickTarget.getHeight());
        if (_camera_stereo__WEBPACK_IMPORTED_MODULE_2__["StereoCamera"].is(camera)) {
            renderer.setViewport(pickX, pickY, halfPickWidth, pickHeight);
            this.pickPass.render(renderer, camera.left, scene, helper);
            renderer.setViewport(pickX + halfPickWidth, pickY, pickWidth - halfPickWidth, pickHeight);
            this.pickPass.render(renderer, camera.right, scene, helper);
        }
        else {
            renderer.setViewport(pickX, pickY, pickWidth, pickHeight);
            this.pickPass.render(renderer, camera, scene, helper);
        }
        this.dirty = false;
    };
    PickHelper.prototype.identify = function (x, y, camera) {
        var _a = this, webgl = _a.webgl, pickScale = _a.pickScale;
        if (webgl.isContextLost)
            return;
        x *= webgl.pixelRatio;
        y *= webgl.pixelRatio;
        y = this.pickPass.drawingBufferHeight - y; // flip y
        var viewport = this.viewport;
        // check if within viewport
        if (x < viewport.x ||
            y < viewport.y ||
            x > viewport.x + viewport.width ||
            y > viewport.y + viewport.height)
            return;
        if (this.dirty) {
            this.render(camera);
            this.syncBuffers();
        }
        var xv = x - viewport.x;
        var yv = y - viewport.y;
        var xp = Math.floor(xv * pickScale);
        var yp = Math.floor(yv * pickScale);
        var objectId = this.getId(xp, yp, this.objectBuffer);
        // console.log('objectId', objectId);
        if (objectId === -1 || objectId === NullId)
            return;
        var instanceId = this.getId(xp, yp, this.instanceBuffer);
        // console.log('instanceId', instanceId);
        if (instanceId === -1 || instanceId === NullId)
            return;
        var groupId = this.getId(xp, yp, this.groupBuffer);
        // console.log('groupId', groupId);
        if (groupId === -1 || groupId === NullId)
            return;
        var z = this.getDepth(xp, yp);
        var position = _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"].create(x, viewport.height - y, z);
        if (_camera_stereo__WEBPACK_IMPORTED_MODULE_2__["StereoCamera"].is(camera)) {
            var halfWidth = Math.floor(viewport.width / 2);
            if (x > viewport.x + halfWidth) {
                position[0] = viewport.x + (xv - halfWidth) * 2;
                Object(_camera_util__WEBPACK_IMPORTED_MODULE_3__["cameraUnproject"])(position, position, viewport, camera.right.inverseProjectionView);
            }
            else {
                position[0] = viewport.x + xv * 2;
                Object(_camera_util__WEBPACK_IMPORTED_MODULE_3__["cameraUnproject"])(position, position, viewport, camera.left.inverseProjectionView);
            }
        }
        else {
            Object(_camera_util__WEBPACK_IMPORTED_MODULE_3__["cameraUnproject"])(position, position, viewport, camera.inverseProjectionView);
        }
        // console.log({ { objectId, instanceId, groupId }, position} );
        return { id: { objectId: objectId, instanceId: instanceId, groupId: groupId }, position: position };
    };
    return PickHelper;
}());

//# sourceMappingURL=pick.js.map

/***/ }),

/***/ "./lib/mol-canvas3d/passes/postprocessing.js":
/*!***************************************************!*\
  !*** ./lib/mol-canvas3d/passes/postprocessing.js ***!
  \***************************************************/
/*! exports provided: PostprocessingParams, PostprocessingPass, AntialiasingPass */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "PostprocessingParams", function() { return PostprocessingParams; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "PostprocessingPass", function() { return PostprocessingPass; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "AntialiasingPass", function() { return AntialiasingPass; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _mol_gl_compute_util__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../mol-gl/compute/util */ "./lib/mol-gl/compute/util.js");
/* harmony import */ var _mol_gl_renderable_schema__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../mol-gl/renderable/schema */ "./lib/mol-gl/renderable/schema.js");
/* harmony import */ var _mol_gl_shader_code__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../mol-gl/shader-code */ "./lib/mol-gl/shader-code.js");
/* harmony import */ var _mol_util__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../mol-util */ "./lib/mol-util/index.js");
/* harmony import */ var _mol_gl_webgl_render_item__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../mol-gl/webgl/render-item */ "./lib/mol-gl/webgl/render-item.js");
/* harmony import */ var _mol_gl_renderable__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../../mol-gl/renderable */ "./lib/mol-gl/renderable.js");
/* harmony import */ var _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../../mol-math/linear-algebra */ "./lib/mol-math/linear-algebra.js");
/* harmony import */ var _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ../../mol-util/param-definition */ "./lib/mol-util/param-definition.js");
/* harmony import */ var _mol_gl_shader_quad_vert__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ../../mol-gl/shader/quad.vert */ "./lib/mol-gl/shader/quad.vert.js");
/* harmony import */ var _mol_gl_shader_outlines_frag__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ../../mol-gl/shader/outlines.frag */ "./lib/mol-gl/shader/outlines.frag.js");
/* harmony import */ var _mol_gl_shader_ssao_frag__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ../../mol-gl/shader/ssao.frag */ "./lib/mol-gl/shader/ssao.frag.js");
/* harmony import */ var _mol_gl_shader_ssao_blur_frag__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! ../../mol-gl/shader/ssao-blur.frag */ "./lib/mol-gl/shader/ssao-blur.frag.js");
/* harmony import */ var _mol_gl_shader_postprocessing_frag__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! ../../mol-gl/shader/postprocessing.frag */ "./lib/mol-gl/shader/postprocessing.frag.js");
/* harmony import */ var _mol_util_color__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! ../../mol-util/color */ "./lib/mol-util/color/index.js");
/* harmony import */ var _fxaa__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! ./fxaa */ "./lib/mol-canvas3d/passes/fxaa.js");
/* harmony import */ var _smaa__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(/*! ./smaa */ "./lib/mol-canvas3d/passes/smaa.js");
/**
 * Copyright (c) 2019-2020 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 * @author Áron Samuel Kovács <aron.kovacs@mail.muni.cz>
 */

















var OutlinesSchema = Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, _mol_gl_compute_util__WEBPACK_IMPORTED_MODULE_1__["QuadSchema"]), { tDepth: Object(_mol_gl_renderable_schema__WEBPACK_IMPORTED_MODULE_2__["TextureSpec"])('texture', 'rgba', 'ubyte', 'nearest'), uTexSize: Object(_mol_gl_renderable_schema__WEBPACK_IMPORTED_MODULE_2__["UniformSpec"])('v2'), dOrthographic: Object(_mol_gl_renderable_schema__WEBPACK_IMPORTED_MODULE_2__["DefineSpec"])('number'), uNear: Object(_mol_gl_renderable_schema__WEBPACK_IMPORTED_MODULE_2__["UniformSpec"])('f'), uFar: Object(_mol_gl_renderable_schema__WEBPACK_IMPORTED_MODULE_2__["UniformSpec"])('f'), uMaxPossibleViewZDiff: Object(_mol_gl_renderable_schema__WEBPACK_IMPORTED_MODULE_2__["UniformSpec"])('f') });
function getOutlinesRenderable(ctx, depthTexture) {
    var values = Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, _mol_gl_compute_util__WEBPACK_IMPORTED_MODULE_1__["QuadValues"]), { tDepth: _mol_util__WEBPACK_IMPORTED_MODULE_4__["ValueCell"].create(depthTexture), uTexSize: _mol_util__WEBPACK_IMPORTED_MODULE_4__["ValueCell"].create(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_7__["Vec2"].create(depthTexture.getWidth(), depthTexture.getHeight())), dOrthographic: _mol_util__WEBPACK_IMPORTED_MODULE_4__["ValueCell"].create(0), uNear: _mol_util__WEBPACK_IMPORTED_MODULE_4__["ValueCell"].create(1), uFar: _mol_util__WEBPACK_IMPORTED_MODULE_4__["ValueCell"].create(10000), uMaxPossibleViewZDiff: _mol_util__WEBPACK_IMPORTED_MODULE_4__["ValueCell"].create(0.5) });
    var schema = Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, OutlinesSchema);
    var shaderCode = Object(_mol_gl_shader_code__WEBPACK_IMPORTED_MODULE_3__["ShaderCode"])('outlines', _mol_gl_shader_quad_vert__WEBPACK_IMPORTED_MODULE_9__["default"], _mol_gl_shader_outlines_frag__WEBPACK_IMPORTED_MODULE_10__["default"]);
    var renderItem = Object(_mol_gl_webgl_render_item__WEBPACK_IMPORTED_MODULE_5__["createComputeRenderItem"])(ctx, 'triangles', shaderCode, schema, values);
    return Object(_mol_gl_renderable__WEBPACK_IMPORTED_MODULE_6__["createComputeRenderable"])(renderItem, values);
}
var SsaoSchema = Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, _mol_gl_compute_util__WEBPACK_IMPORTED_MODULE_1__["QuadSchema"]), { tDepth: Object(_mol_gl_renderable_schema__WEBPACK_IMPORTED_MODULE_2__["TextureSpec"])('texture', 'rgba', 'ubyte', 'nearest'), uSamples: Object(_mol_gl_renderable_schema__WEBPACK_IMPORTED_MODULE_2__["UniformSpec"])('v3[]'), dNSamples: Object(_mol_gl_renderable_schema__WEBPACK_IMPORTED_MODULE_2__["DefineSpec"])('number'), uProjection: Object(_mol_gl_renderable_schema__WEBPACK_IMPORTED_MODULE_2__["UniformSpec"])('m4'), uInvProjection: Object(_mol_gl_renderable_schema__WEBPACK_IMPORTED_MODULE_2__["UniformSpec"])('m4'), uTexSize: Object(_mol_gl_renderable_schema__WEBPACK_IMPORTED_MODULE_2__["UniformSpec"])('v2'), uRadius: Object(_mol_gl_renderable_schema__WEBPACK_IMPORTED_MODULE_2__["UniformSpec"])('f'), uBias: Object(_mol_gl_renderable_schema__WEBPACK_IMPORTED_MODULE_2__["UniformSpec"])('f') });
function getSsaoRenderable(ctx, depthTexture) {
    var values = Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, _mol_gl_compute_util__WEBPACK_IMPORTED_MODULE_1__["QuadValues"]), { tDepth: _mol_util__WEBPACK_IMPORTED_MODULE_4__["ValueCell"].create(depthTexture), uSamples: _mol_util__WEBPACK_IMPORTED_MODULE_4__["ValueCell"].create([0.0, 0.0, 1.0]), dNSamples: _mol_util__WEBPACK_IMPORTED_MODULE_4__["ValueCell"].create(1), uProjection: _mol_util__WEBPACK_IMPORTED_MODULE_4__["ValueCell"].create(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_7__["Mat4"].identity()), uInvProjection: _mol_util__WEBPACK_IMPORTED_MODULE_4__["ValueCell"].create(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_7__["Mat4"].identity()), uTexSize: _mol_util__WEBPACK_IMPORTED_MODULE_4__["ValueCell"].create(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_7__["Vec2"].create(ctx.gl.drawingBufferWidth, ctx.gl.drawingBufferHeight)), uRadius: _mol_util__WEBPACK_IMPORTED_MODULE_4__["ValueCell"].create(8.0), uBias: _mol_util__WEBPACK_IMPORTED_MODULE_4__["ValueCell"].create(0.025) });
    var schema = Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, SsaoSchema);
    var shaderCode = Object(_mol_gl_shader_code__WEBPACK_IMPORTED_MODULE_3__["ShaderCode"])('ssao', _mol_gl_shader_quad_vert__WEBPACK_IMPORTED_MODULE_9__["default"], _mol_gl_shader_ssao_frag__WEBPACK_IMPORTED_MODULE_11__["default"]);
    var renderItem = Object(_mol_gl_webgl_render_item__WEBPACK_IMPORTED_MODULE_5__["createComputeRenderItem"])(ctx, 'triangles', shaderCode, schema, values);
    return Object(_mol_gl_renderable__WEBPACK_IMPORTED_MODULE_6__["createComputeRenderable"])(renderItem, values);
}
var SsaoBlurSchema = Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, _mol_gl_compute_util__WEBPACK_IMPORTED_MODULE_1__["QuadSchema"]), { tSsaoDepth: Object(_mol_gl_renderable_schema__WEBPACK_IMPORTED_MODULE_2__["TextureSpec"])('texture', 'rgba', 'ubyte', 'nearest'), uTexSize: Object(_mol_gl_renderable_schema__WEBPACK_IMPORTED_MODULE_2__["UniformSpec"])('v2'), uKernel: Object(_mol_gl_renderable_schema__WEBPACK_IMPORTED_MODULE_2__["UniformSpec"])('f[]'), dOcclusionKernelSize: Object(_mol_gl_renderable_schema__WEBPACK_IMPORTED_MODULE_2__["DefineSpec"])('number'), uBlurDirectionX: Object(_mol_gl_renderable_schema__WEBPACK_IMPORTED_MODULE_2__["UniformSpec"])('f'), uBlurDirectionY: Object(_mol_gl_renderable_schema__WEBPACK_IMPORTED_MODULE_2__["UniformSpec"])('f'), uMaxPossibleViewZDiff: Object(_mol_gl_renderable_schema__WEBPACK_IMPORTED_MODULE_2__["UniformSpec"])('f'), uNear: Object(_mol_gl_renderable_schema__WEBPACK_IMPORTED_MODULE_2__["UniformSpec"])('f'), uFar: Object(_mol_gl_renderable_schema__WEBPACK_IMPORTED_MODULE_2__["UniformSpec"])('f'), dOrthographic: Object(_mol_gl_renderable_schema__WEBPACK_IMPORTED_MODULE_2__["DefineSpec"])('number') });
function getSsaoBlurRenderable(ctx, ssaoDepthTexture, direction) {
    var values = Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, _mol_gl_compute_util__WEBPACK_IMPORTED_MODULE_1__["QuadValues"]), { tSsaoDepth: _mol_util__WEBPACK_IMPORTED_MODULE_4__["ValueCell"].create(ssaoDepthTexture), uTexSize: _mol_util__WEBPACK_IMPORTED_MODULE_4__["ValueCell"].create(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_7__["Vec2"].create(ssaoDepthTexture.getWidth(), ssaoDepthTexture.getHeight())), uKernel: _mol_util__WEBPACK_IMPORTED_MODULE_4__["ValueCell"].create([0.0]), dOcclusionKernelSize: _mol_util__WEBPACK_IMPORTED_MODULE_4__["ValueCell"].create(1), uBlurDirectionX: _mol_util__WEBPACK_IMPORTED_MODULE_4__["ValueCell"].create(direction === 'horizontal' ? 1 : 0), uBlurDirectionY: _mol_util__WEBPACK_IMPORTED_MODULE_4__["ValueCell"].create(direction === 'vertical' ? 1 : 0), uMaxPossibleViewZDiff: _mol_util__WEBPACK_IMPORTED_MODULE_4__["ValueCell"].create(0.5), uNear: _mol_util__WEBPACK_IMPORTED_MODULE_4__["ValueCell"].create(0.0), uFar: _mol_util__WEBPACK_IMPORTED_MODULE_4__["ValueCell"].create(10000.0), dOrthographic: _mol_util__WEBPACK_IMPORTED_MODULE_4__["ValueCell"].create(0) });
    var schema = Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, SsaoBlurSchema);
    var shaderCode = Object(_mol_gl_shader_code__WEBPACK_IMPORTED_MODULE_3__["ShaderCode"])('ssao_blur', _mol_gl_shader_quad_vert__WEBPACK_IMPORTED_MODULE_9__["default"], _mol_gl_shader_ssao_blur_frag__WEBPACK_IMPORTED_MODULE_12__["default"]);
    var renderItem = Object(_mol_gl_webgl_render_item__WEBPACK_IMPORTED_MODULE_5__["createComputeRenderItem"])(ctx, 'triangles', shaderCode, schema, values);
    return Object(_mol_gl_renderable__WEBPACK_IMPORTED_MODULE_6__["createComputeRenderable"])(renderItem, values);
}
function getBlurKernel(kernelSize) {
    var sigma = kernelSize / 3.0;
    var halfKernelSize = Math.floor((kernelSize + 1) / 2);
    var kernel = [];
    for (var x = 0; x < halfKernelSize; x++) {
        kernel.push((1.0 / ((Math.sqrt(2 * Math.PI)) * sigma)) * Math.exp(-x * x / (2 * sigma * sigma)));
    }
    return kernel;
}
function getSamples(vectorSamples, nSamples) {
    var samples = [];
    for (var i = 0; i < nSamples; i++) {
        var scale = (i * i + 2.0 * i + 1) / (nSamples * nSamples);
        scale = 0.1 + scale * (1.0 - 0.1);
        samples.push(vectorSamples[i][0] * scale);
        samples.push(vectorSamples[i][1] * scale);
        samples.push(vectorSamples[i][2] * scale);
    }
    return samples;
}
var PostprocessingSchema = Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, _mol_gl_compute_util__WEBPACK_IMPORTED_MODULE_1__["QuadSchema"]), { tSsaoDepth: Object(_mol_gl_renderable_schema__WEBPACK_IMPORTED_MODULE_2__["TextureSpec"])('texture', 'rgba', 'ubyte', 'nearest'), tColor: Object(_mol_gl_renderable_schema__WEBPACK_IMPORTED_MODULE_2__["TextureSpec"])('texture', 'rgba', 'ubyte', 'nearest'), tDepth: Object(_mol_gl_renderable_schema__WEBPACK_IMPORTED_MODULE_2__["TextureSpec"])('texture', 'rgba', 'ubyte', 'nearest'), tOutlines: Object(_mol_gl_renderable_schema__WEBPACK_IMPORTED_MODULE_2__["TextureSpec"])('texture', 'rgba', 'ubyte', 'nearest'), uTexSize: Object(_mol_gl_renderable_schema__WEBPACK_IMPORTED_MODULE_2__["UniformSpec"])('v2'), dOrthographic: Object(_mol_gl_renderable_schema__WEBPACK_IMPORTED_MODULE_2__["DefineSpec"])('number'), uNear: Object(_mol_gl_renderable_schema__WEBPACK_IMPORTED_MODULE_2__["UniformSpec"])('f'), uFar: Object(_mol_gl_renderable_schema__WEBPACK_IMPORTED_MODULE_2__["UniformSpec"])('f'), uFogNear: Object(_mol_gl_renderable_schema__WEBPACK_IMPORTED_MODULE_2__["UniformSpec"])('f'), uFogFar: Object(_mol_gl_renderable_schema__WEBPACK_IMPORTED_MODULE_2__["UniformSpec"])('f'), uFogColor: Object(_mol_gl_renderable_schema__WEBPACK_IMPORTED_MODULE_2__["UniformSpec"])('v3'), uTransparentBackground: Object(_mol_gl_renderable_schema__WEBPACK_IMPORTED_MODULE_2__["UniformSpec"])('b'), uMaxPossibleViewZDiff: Object(_mol_gl_renderable_schema__WEBPACK_IMPORTED_MODULE_2__["UniformSpec"])('f'), dOcclusionEnable: Object(_mol_gl_renderable_schema__WEBPACK_IMPORTED_MODULE_2__["DefineSpec"])('boolean'), dOutlineEnable: Object(_mol_gl_renderable_schema__WEBPACK_IMPORTED_MODULE_2__["DefineSpec"])('boolean'), dOutlineScale: Object(_mol_gl_renderable_schema__WEBPACK_IMPORTED_MODULE_2__["DefineSpec"])('number'), uOutlineThreshold: Object(_mol_gl_renderable_schema__WEBPACK_IMPORTED_MODULE_2__["UniformSpec"])('f') });
function getPostprocessingRenderable(ctx, colorTexture, depthTexture, outlinesTexture, ssaoDepthTexture) {
    var values = Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, _mol_gl_compute_util__WEBPACK_IMPORTED_MODULE_1__["QuadValues"]), { tSsaoDepth: _mol_util__WEBPACK_IMPORTED_MODULE_4__["ValueCell"].create(ssaoDepthTexture), tColor: _mol_util__WEBPACK_IMPORTED_MODULE_4__["ValueCell"].create(colorTexture), tDepth: _mol_util__WEBPACK_IMPORTED_MODULE_4__["ValueCell"].create(depthTexture), tOutlines: _mol_util__WEBPACK_IMPORTED_MODULE_4__["ValueCell"].create(outlinesTexture), uTexSize: _mol_util__WEBPACK_IMPORTED_MODULE_4__["ValueCell"].create(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_7__["Vec2"].create(colorTexture.getWidth(), colorTexture.getHeight())), dOrthographic: _mol_util__WEBPACK_IMPORTED_MODULE_4__["ValueCell"].create(0), uNear: _mol_util__WEBPACK_IMPORTED_MODULE_4__["ValueCell"].create(1), uFar: _mol_util__WEBPACK_IMPORTED_MODULE_4__["ValueCell"].create(10000), uFogNear: _mol_util__WEBPACK_IMPORTED_MODULE_4__["ValueCell"].create(10000), uFogFar: _mol_util__WEBPACK_IMPORTED_MODULE_4__["ValueCell"].create(10000), uFogColor: _mol_util__WEBPACK_IMPORTED_MODULE_4__["ValueCell"].create(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_7__["Vec3"].create(1, 1, 1)), uTransparentBackground: _mol_util__WEBPACK_IMPORTED_MODULE_4__["ValueCell"].create(false), uMaxPossibleViewZDiff: _mol_util__WEBPACK_IMPORTED_MODULE_4__["ValueCell"].create(0.5), dOcclusionEnable: _mol_util__WEBPACK_IMPORTED_MODULE_4__["ValueCell"].create(false), dOutlineEnable: _mol_util__WEBPACK_IMPORTED_MODULE_4__["ValueCell"].create(false), dOutlineScale: _mol_util__WEBPACK_IMPORTED_MODULE_4__["ValueCell"].create(1), uOutlineThreshold: _mol_util__WEBPACK_IMPORTED_MODULE_4__["ValueCell"].create(0.33) });
    var schema = Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, PostprocessingSchema);
    var shaderCode = Object(_mol_gl_shader_code__WEBPACK_IMPORTED_MODULE_3__["ShaderCode"])('postprocessing', _mol_gl_shader_quad_vert__WEBPACK_IMPORTED_MODULE_9__["default"], _mol_gl_shader_postprocessing_frag__WEBPACK_IMPORTED_MODULE_13__["default"]);
    var renderItem = Object(_mol_gl_webgl_render_item__WEBPACK_IMPORTED_MODULE_5__["createComputeRenderItem"])(ctx, 'triangles', shaderCode, schema, values);
    return Object(_mol_gl_renderable__WEBPACK_IMPORTED_MODULE_6__["createComputeRenderable"])(renderItem, values);
}
var PostprocessingParams = {
    occlusion: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_8__["ParamDefinition"].MappedStatic('on', {
        on: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_8__["ParamDefinition"].Group({
            samples: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_8__["ParamDefinition"].Numeric(64, { min: 1, max: 256, step: 1 }),
            radius: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_8__["ParamDefinition"].Numeric(5, { min: 0, max: 10, step: 0.1 }, { description: 'Final radius is 2^x.' }),
            bias: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_8__["ParamDefinition"].Numeric(0.8, { min: 0, max: 3, step: 0.1 }),
            blurKernelSize: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_8__["ParamDefinition"].Numeric(20, { min: 1, max: 25, step: 2 }),
        }),
        off: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_8__["ParamDefinition"].Group({})
    }, { cycle: true, description: 'Darken occluded crevices with the ambient occlusion effect' }),
    outline: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_8__["ParamDefinition"].MappedStatic('off', {
        on: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_8__["ParamDefinition"].Group({
            scale: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_8__["ParamDefinition"].Numeric(1, { min: 1, max: 5, step: 1 }),
            threshold: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_8__["ParamDefinition"].Numeric(0.33, { min: 0.01, max: 1, step: 0.01 }),
        }),
        off: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_8__["ParamDefinition"].Group({})
    }, { cycle: true, description: 'Draw outline around 3D objects' }),
    antialiasing: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_8__["ParamDefinition"].MappedStatic('smaa', {
        fxaa: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_8__["ParamDefinition"].Group(_fxaa__WEBPACK_IMPORTED_MODULE_15__["FxaaParams"]),
        smaa: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_8__["ParamDefinition"].Group(_smaa__WEBPACK_IMPORTED_MODULE_16__["SmaaParams"]),
        off: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_8__["ParamDefinition"].Group({})
    }, { options: [['fxaa', 'FXAA'], ['smaa', 'SMAA'], ['off', 'Off']], description: 'Smooth pixel edges' }),
};
var PostprocessingPass = /** @class */ (function () {
    function PostprocessingPass(webgl, drawPass) {
        this.webgl = webgl;
        this.scale = 1 / this.webgl.pixelRatio;
        var colorTarget = drawPass.colorTarget, depthTexture = drawPass.depthTexture;
        var width = colorTarget.getWidth();
        var height = colorTarget.getHeight();
        this.nSamples = 1;
        this.blurKernelSize = 1;
        this.target = webgl.createRenderTarget(width, height, false, 'uint8', 'linear');
        this.outlinesTarget = webgl.createRenderTarget(width, height, false);
        this.outlinesRenderable = getOutlinesRenderable(webgl, depthTexture);
        this.randomHemisphereVector = [];
        for (var i = 0; i < 256; i++) {
            var v = Object(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_7__["Vec3"])();
            v[0] = Math.random() * 2.0 - 1.0;
            v[1] = Math.random() * 2.0 - 1.0;
            v[2] = Math.random();
            _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_7__["Vec3"].normalize(v, v);
            _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_7__["Vec3"].scale(v, v, Math.random());
            this.randomHemisphereVector.push(v);
        }
        this.ssaoFramebuffer = webgl.resources.framebuffer();
        this.ssaoBlurFirstPassFramebuffer = webgl.resources.framebuffer();
        this.ssaoBlurSecondPassFramebuffer = webgl.resources.framebuffer();
        var sw = Math.floor(width * this.scale);
        var sh = Math.floor(height * this.scale);
        this.ssaoDepthTexture = webgl.resources.texture('image-uint8', 'rgba', 'ubyte', 'linear');
        this.ssaoDepthTexture.define(sw, sh);
        this.ssaoDepthTexture.attachFramebuffer(this.ssaoFramebuffer, 'color0');
        this.ssaoDepthBlurProxyTexture = webgl.resources.texture('image-uint8', 'rgba', 'ubyte', 'linear');
        this.ssaoDepthBlurProxyTexture.define(sw, sh);
        this.ssaoDepthBlurProxyTexture.attachFramebuffer(this.ssaoBlurFirstPassFramebuffer, 'color0');
        this.ssaoDepthTexture.attachFramebuffer(this.ssaoBlurSecondPassFramebuffer, 'color0');
        this.ssaoRenderable = getSsaoRenderable(webgl, depthTexture);
        this.ssaoBlurFirstPassRenderable = getSsaoBlurRenderable(webgl, this.ssaoDepthTexture, 'horizontal');
        this.ssaoBlurSecondPassRenderable = getSsaoBlurRenderable(webgl, this.ssaoDepthBlurProxyTexture, 'vertical');
        this.renderable = getPostprocessingRenderable(webgl, colorTarget.texture, depthTexture, this.outlinesTarget.texture, this.ssaoDepthTexture);
    }
    PostprocessingPass.isEnabled = function (props) {
        return props.occlusion.name === 'on' || props.outline.name === 'on';
    };
    PostprocessingPass.prototype.setSize = function (width, height) {
        var _a = this.renderable.values.uTexSize.ref.value, w = _a[0], h = _a[1];
        if (width !== w || height !== h) {
            var sw = Math.floor(width * this.scale);
            var sh = Math.floor(height * this.scale);
            this.target.setSize(width, height);
            this.outlinesTarget.setSize(width, height);
            this.ssaoDepthTexture.define(sw, sh);
            this.ssaoDepthBlurProxyTexture.define(sw, sh);
            _mol_util__WEBPACK_IMPORTED_MODULE_4__["ValueCell"].update(this.renderable.values.uTexSize, _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_7__["Vec2"].set(this.renderable.values.uTexSize.ref.value, width, height));
            _mol_util__WEBPACK_IMPORTED_MODULE_4__["ValueCell"].update(this.outlinesRenderable.values.uTexSize, _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_7__["Vec2"].set(this.outlinesRenderable.values.uTexSize.ref.value, width, height));
            _mol_util__WEBPACK_IMPORTED_MODULE_4__["ValueCell"].update(this.ssaoRenderable.values.uTexSize, _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_7__["Vec2"].set(this.ssaoRenderable.values.uTexSize.ref.value, sw, sh));
            _mol_util__WEBPACK_IMPORTED_MODULE_4__["ValueCell"].update(this.ssaoBlurFirstPassRenderable.values.uTexSize, _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_7__["Vec2"].set(this.ssaoRenderable.values.uTexSize.ref.value, sw, sh));
            _mol_util__WEBPACK_IMPORTED_MODULE_4__["ValueCell"].update(this.ssaoBlurSecondPassRenderable.values.uTexSize, _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_7__["Vec2"].set(this.ssaoRenderable.values.uTexSize.ref.value, sw, sh));
        }
    };
    PostprocessingPass.prototype.updateState = function (camera, transparentBackground, backgroundColor, props) {
        var needsUpdateMain = false;
        var needsUpdateSsao = false;
        var needsUpdateSsaoBlur = false;
        var orthographic = camera.state.mode === 'orthographic' ? 1 : 0;
        var outlinesEnabled = props.outline.name === 'on';
        var occlusionEnabled = props.occlusion.name === 'on';
        var invProjection = _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_7__["Mat4"].identity();
        _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_7__["Mat4"].invert(invProjection, camera.projection);
        if (props.occlusion.name === 'on') {
            _mol_util__WEBPACK_IMPORTED_MODULE_4__["ValueCell"].updateIfChanged(this.ssaoRenderable.values.uProjection, camera.projection);
            _mol_util__WEBPACK_IMPORTED_MODULE_4__["ValueCell"].updateIfChanged(this.ssaoRenderable.values.uInvProjection, invProjection);
            _mol_util__WEBPACK_IMPORTED_MODULE_4__["ValueCell"].updateIfChanged(this.ssaoBlurFirstPassRenderable.values.uNear, camera.near);
            _mol_util__WEBPACK_IMPORTED_MODULE_4__["ValueCell"].updateIfChanged(this.ssaoBlurSecondPassRenderable.values.uNear, camera.near);
            _mol_util__WEBPACK_IMPORTED_MODULE_4__["ValueCell"].updateIfChanged(this.ssaoBlurFirstPassRenderable.values.uFar, camera.far);
            _mol_util__WEBPACK_IMPORTED_MODULE_4__["ValueCell"].updateIfChanged(this.ssaoBlurSecondPassRenderable.values.uFar, camera.far);
            if (this.ssaoBlurFirstPassRenderable.values.dOrthographic.ref.value !== orthographic) {
                needsUpdateSsaoBlur = true;
            }
            _mol_util__WEBPACK_IMPORTED_MODULE_4__["ValueCell"].updateIfChanged(this.ssaoBlurFirstPassRenderable.values.dOrthographic, orthographic);
            _mol_util__WEBPACK_IMPORTED_MODULE_4__["ValueCell"].updateIfChanged(this.ssaoBlurSecondPassRenderable.values.dOrthographic, orthographic);
            if (this.nSamples !== props.occlusion.params.samples) {
                needsUpdateSsao = true;
                this.nSamples = props.occlusion.params.samples;
                _mol_util__WEBPACK_IMPORTED_MODULE_4__["ValueCell"].updateIfChanged(this.ssaoRenderable.values.uSamples, getSamples(this.randomHemisphereVector, this.nSamples));
                _mol_util__WEBPACK_IMPORTED_MODULE_4__["ValueCell"].updateIfChanged(this.ssaoRenderable.values.dNSamples, this.nSamples);
            }
            _mol_util__WEBPACK_IMPORTED_MODULE_4__["ValueCell"].updateIfChanged(this.ssaoRenderable.values.uRadius, Math.pow(2, props.occlusion.params.radius));
            _mol_util__WEBPACK_IMPORTED_MODULE_4__["ValueCell"].updateIfChanged(this.ssaoRenderable.values.uBias, props.occlusion.params.bias);
            if (this.blurKernelSize !== props.occlusion.params.blurKernelSize) {
                needsUpdateSsaoBlur = true;
                this.blurKernelSize = props.occlusion.params.blurKernelSize;
                var kernel = getBlurKernel(this.blurKernelSize);
                _mol_util__WEBPACK_IMPORTED_MODULE_4__["ValueCell"].updateIfChanged(this.ssaoBlurFirstPassRenderable.values.uKernel, kernel);
                _mol_util__WEBPACK_IMPORTED_MODULE_4__["ValueCell"].updateIfChanged(this.ssaoBlurSecondPassRenderable.values.uKernel, kernel);
                _mol_util__WEBPACK_IMPORTED_MODULE_4__["ValueCell"].updateIfChanged(this.ssaoBlurFirstPassRenderable.values.dOcclusionKernelSize, this.blurKernelSize);
                _mol_util__WEBPACK_IMPORTED_MODULE_4__["ValueCell"].updateIfChanged(this.ssaoBlurSecondPassRenderable.values.dOcclusionKernelSize, this.blurKernelSize);
            }
        }
        if (props.outline.name === 'on') {
            var factor = Math.pow(1000, props.outline.params.threshold) / 1000;
            var maxPossibleViewZDiff = factor * (camera.far - camera.near);
            var outlineScale = props.outline.params.scale - 1;
            _mol_util__WEBPACK_IMPORTED_MODULE_4__["ValueCell"].updateIfChanged(this.outlinesRenderable.values.uNear, camera.near);
            _mol_util__WEBPACK_IMPORTED_MODULE_4__["ValueCell"].updateIfChanged(this.outlinesRenderable.values.uFar, camera.far);
            _mol_util__WEBPACK_IMPORTED_MODULE_4__["ValueCell"].updateIfChanged(this.outlinesRenderable.values.uMaxPossibleViewZDiff, maxPossibleViewZDiff);
            _mol_util__WEBPACK_IMPORTED_MODULE_4__["ValueCell"].updateIfChanged(this.renderable.values.uMaxPossibleViewZDiff, maxPossibleViewZDiff);
            _mol_util__WEBPACK_IMPORTED_MODULE_4__["ValueCell"].updateIfChanged(this.renderable.values.uOutlineThreshold, props.outline.params.threshold);
            if (this.renderable.values.dOutlineScale.ref.value !== outlineScale) {
                needsUpdateMain = true;
            }
            _mol_util__WEBPACK_IMPORTED_MODULE_4__["ValueCell"].updateIfChanged(this.renderable.values.dOutlineScale, outlineScale);
        }
        _mol_util__WEBPACK_IMPORTED_MODULE_4__["ValueCell"].updateIfChanged(this.renderable.values.uFar, camera.far);
        _mol_util__WEBPACK_IMPORTED_MODULE_4__["ValueCell"].updateIfChanged(this.renderable.values.uNear, camera.near);
        _mol_util__WEBPACK_IMPORTED_MODULE_4__["ValueCell"].updateIfChanged(this.renderable.values.uFogFar, camera.fogFar);
        _mol_util__WEBPACK_IMPORTED_MODULE_4__["ValueCell"].updateIfChanged(this.renderable.values.uFogNear, camera.fogNear);
        _mol_util__WEBPACK_IMPORTED_MODULE_4__["ValueCell"].update(this.renderable.values.uFogColor, _mol_util_color__WEBPACK_IMPORTED_MODULE_14__["Color"].toVec3Normalized(this.renderable.values.uFogColor.ref.value, backgroundColor));
        _mol_util__WEBPACK_IMPORTED_MODULE_4__["ValueCell"].updateIfChanged(this.renderable.values.uTransparentBackground, transparentBackground);
        if (this.renderable.values.dOrthographic.ref.value !== orthographic) {
            needsUpdateMain = true;
        }
        _mol_util__WEBPACK_IMPORTED_MODULE_4__["ValueCell"].updateIfChanged(this.renderable.values.dOrthographic, orthographic);
        if (this.renderable.values.dOutlineEnable.ref.value !== outlinesEnabled) {
            needsUpdateMain = true;
        }
        _mol_util__WEBPACK_IMPORTED_MODULE_4__["ValueCell"].updateIfChanged(this.renderable.values.dOutlineEnable, outlinesEnabled);
        if (this.renderable.values.dOcclusionEnable.ref.value !== occlusionEnabled) {
            needsUpdateMain = true;
        }
        _mol_util__WEBPACK_IMPORTED_MODULE_4__["ValueCell"].updateIfChanged(this.renderable.values.dOcclusionEnable, occlusionEnabled);
        if (needsUpdateSsao) {
            this.ssaoRenderable.update();
        }
        if (needsUpdateSsaoBlur) {
            this.ssaoBlurFirstPassRenderable.update();
            this.ssaoBlurSecondPassRenderable.update();
        }
        if (needsUpdateMain) {
            this.renderable.update();
        }
        var _a = this.webgl, gl = _a.gl, state = _a.state;
        state.enable(gl.SCISSOR_TEST);
        state.disable(gl.BLEND);
        state.disable(gl.DEPTH_TEST);
        state.depthMask(false);
        var _b = camera.viewport, x = _b.x, y = _b.y, width = _b.width, height = _b.height;
        gl.viewport(x, y, width, height);
        gl.scissor(x, y, width, height);
    };
    PostprocessingPass.prototype.render = function (camera, toDrawingBuffer, transparentBackground, backgroundColor, props) {
        this.updateState(camera, transparentBackground, backgroundColor, props);
        if (props.outline.name === 'on') {
            this.outlinesTarget.bind();
            this.outlinesRenderable.render();
        }
        if (props.occlusion.name === 'on') {
            var _a = camera.viewport, x = _a.x, y = _a.y, width = _a.width, height = _a.height;
            var sx = Math.floor(x * this.scale);
            var sy = Math.floor(y * this.scale);
            var sw = Math.floor(width * this.scale);
            var sh = Math.floor(height * this.scale);
            this.webgl.gl.viewport(sx, sy, sw, sh);
            this.webgl.gl.scissor(sx, sy, sw, sh);
            this.ssaoFramebuffer.bind();
            this.ssaoRenderable.render();
            this.ssaoBlurFirstPassFramebuffer.bind();
            this.ssaoBlurFirstPassRenderable.render();
            this.ssaoBlurSecondPassFramebuffer.bind();
            this.ssaoBlurSecondPassRenderable.render();
            this.webgl.gl.viewport(x, y, width, height);
            this.webgl.gl.scissor(x, y, width, height);
        }
        if (toDrawingBuffer) {
            this.webgl.unbindFramebuffer();
        }
        else {
            this.target.bind();
        }
        var _b = this.webgl, gl = _b.gl, state = _b.state;
        state.clearColor(0, 0, 0, 1);
        gl.clear(gl.COLOR_BUFFER_BIT);
        this.renderable.render();
    };
    return PostprocessingPass;
}());

var AntialiasingPass = /** @class */ (function () {
    function AntialiasingPass(webgl, drawPass) {
        this.drawPass = drawPass;
        var colorTarget = drawPass.colorTarget;
        var width = colorTarget.getWidth();
        var height = colorTarget.getHeight();
        this.target = webgl.createRenderTarget(width, height, false);
        this.fxaa = new _fxaa__WEBPACK_IMPORTED_MODULE_15__["FxaaPass"](webgl, this.target.texture);
        this.smaa = new _smaa__WEBPACK_IMPORTED_MODULE_16__["SmaaPass"](webgl, this.target.texture);
    }
    AntialiasingPass.isEnabled = function (props) {
        return props.antialiasing.name !== 'off';
    };
    AntialiasingPass.prototype.setSize = function (width, height) {
        var w = this.target.texture.getWidth();
        var h = this.target.texture.getHeight();
        if (width !== w || height !== h) {
            this.target.setSize(width, height);
            this.fxaa.setSize(width, height);
            if (this.smaa.supported)
                this.smaa.setSize(width, height);
        }
    };
    AntialiasingPass.prototype._renderFxaa = function (camera, toDrawingBuffer, props) {
        if (props.antialiasing.name !== 'fxaa')
            return;
        var input = PostprocessingPass.isEnabled(props)
            ? this.drawPass.postprocessing.target.texture
            : this.drawPass.colorTarget.texture;
        this.fxaa.update(input, props.antialiasing.params);
        this.fxaa.render(camera.viewport, toDrawingBuffer ? undefined : this.target);
    };
    AntialiasingPass.prototype._renderSmaa = function (camera, toDrawingBuffer, props) {
        if (props.antialiasing.name !== 'smaa')
            return;
        var input = PostprocessingPass.isEnabled(props)
            ? this.drawPass.postprocessing.target.texture
            : this.drawPass.colorTarget.texture;
        this.smaa.update(input, props.antialiasing.params);
        this.smaa.render(camera.viewport, toDrawingBuffer ? undefined : this.target);
    };
    AntialiasingPass.prototype.render = function (camera, toDrawingBuffer, props) {
        if (props.antialiasing.name === 'off')
            return;
        if (props.antialiasing.name === 'fxaa') {
            this._renderFxaa(camera, toDrawingBuffer, props);
        }
        else if (props.antialiasing.name === 'smaa') {
            if (!this.smaa.supported) {
                throw new Error('SMAA not supported, missing "HTMLImageElement"');
            }
            this._renderSmaa(camera, toDrawingBuffer, props);
        }
    };
    return AntialiasingPass;
}());

//# sourceMappingURL=postprocessing.js.map

/***/ }),

/***/ "./lib/mol-canvas3d/passes/smaa.js":
/*!*****************************************!*\
  !*** ./lib/mol-canvas3d/passes/smaa.js ***!
  \*****************************************/
/*! exports provided: SmaaParams, SmaaPass */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SmaaParams", function() { return SmaaParams; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SmaaPass", function() { return SmaaPass; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _mol_gl_compute_util__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../mol-gl/compute/util */ "./lib/mol-gl/compute/util.js");
/* harmony import */ var _mol_gl_renderable__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../mol-gl/renderable */ "./lib/mol-gl/renderable.js");
/* harmony import */ var _mol_gl_renderable_schema__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../mol-gl/renderable/schema */ "./lib/mol-gl/renderable/schema.js");
/* harmony import */ var _mol_gl_shader_code__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../mol-gl/shader-code */ "./lib/mol-gl/shader-code.js");
/* harmony import */ var _mol_gl_webgl_render_item__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../mol-gl/webgl/render-item */ "./lib/mol-gl/webgl/render-item.js");
/* harmony import */ var _mol_gl_webgl_texture__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../../mol-gl/webgl/texture */ "./lib/mol-gl/webgl/texture.js");
/* harmony import */ var _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../../mol-math/linear-algebra */ "./lib/mol-math/linear-algebra.js");
/* harmony import */ var _mol_util__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ../../mol-util */ "./lib/mol-util/index.js");
/* harmony import */ var _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ../../mol-util/param-definition */ "./lib/mol-util/param-definition.js");
/* harmony import */ var _mol_gl_shader_smaa_blend_vert__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ../../mol-gl/shader/smaa/blend.vert */ "./lib/mol-gl/shader/smaa/blend.vert.js");
/* harmony import */ var _mol_gl_shader_smaa_blend_frag__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ../../mol-gl/shader/smaa/blend.frag */ "./lib/mol-gl/shader/smaa/blend.frag.js");
/* harmony import */ var _mol_gl_shader_smaa_weights_vert__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! ../../mol-gl/shader/smaa/weights.vert */ "./lib/mol-gl/shader/smaa/weights.vert.js");
/* harmony import */ var _mol_gl_shader_smaa_weights_frag__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! ../../mol-gl/shader/smaa/weights.frag */ "./lib/mol-gl/shader/smaa/weights.frag.js");
/* harmony import */ var _mol_gl_shader_smaa_edges_vert__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! ../../mol-gl/shader/smaa/edges.vert */ "./lib/mol-gl/shader/smaa/edges.vert.js");
/* harmony import */ var _mol_gl_shader_smaa_edges_frag__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! ../../mol-gl/shader/smaa/edges.frag */ "./lib/mol-gl/shader/smaa/edges.frag.js");
/* harmony import */ var _camera_util__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(/*! ../camera/util */ "./lib/mol-canvas3d/camera/util.js");
/* harmony import */ var _mol_util_debug__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(/*! ../../mol-util/debug */ "./lib/mol-util/debug.js");
/**
 * Copyright (c) 2020 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */


















var SmaaParams = {
    edgeThreshold: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_9__["ParamDefinition"].Numeric(0.1, { min: 0.05, max: 0.15, step: 0.01 }),
    maxSearchSteps: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_9__["ParamDefinition"].Numeric(16, { min: 0, max: 32, step: 1 }),
};
var SmaaPass = /** @class */ (function () {
    function SmaaPass(webgl, input) {
        this.webgl = webgl;
        this._supported = false;
        if (typeof HTMLImageElement === undefined) {
            if (_mol_util_debug__WEBPACK_IMPORTED_MODULE_17__["isDebugMode"])
                console.log("Missing \"HTMLImageElement\" required for \"SMAA\"");
            return;
        }
        var width = input.getWidth();
        var height = input.getHeight();
        this.edgesTarget = webgl.createRenderTarget(width, height, false, 'uint8', 'linear');
        this.weightsTarget = webgl.createRenderTarget(width, height, false, 'uint8', 'linear');
        this.edgesRenderable = getEdgesRenderable(webgl, input);
        this.weightsRenderable = getWeightsRenderable(webgl, this.edgesTarget.texture);
        this.blendRenderable = getBlendRenderable(webgl, input, this.weightsTarget.texture);
        this._supported = true;
    }
    Object.defineProperty(SmaaPass.prototype, "supported", {
        get: function () {
            return this._supported;
        },
        enumerable: false,
        configurable: true
    });
    SmaaPass.prototype.updateState = function (viewport) {
        var _a = this.webgl, gl = _a.gl, state = _a.state;
        state.enable(gl.SCISSOR_TEST);
        state.disable(gl.BLEND);
        state.disable(gl.DEPTH_TEST);
        state.depthMask(false);
        var x = viewport.x, y = viewport.y, width = viewport.width, height = viewport.height;
        gl.viewport(x, y, width, height);
        gl.scissor(x, y, width, height);
        state.clearColor(0, 0, 0, 1);
        gl.clear(gl.COLOR_BUFFER_BIT);
        _mol_util__WEBPACK_IMPORTED_MODULE_8__["ValueCell"].update(this.edgesRenderable.values.uViewport, _camera_util__WEBPACK_IMPORTED_MODULE_16__["Viewport"].toVec4(this.edgesRenderable.values.uViewport.ref.value, viewport));
        _mol_util__WEBPACK_IMPORTED_MODULE_8__["ValueCell"].update(this.weightsRenderable.values.uViewport, _camera_util__WEBPACK_IMPORTED_MODULE_16__["Viewport"].toVec4(this.weightsRenderable.values.uViewport.ref.value, viewport));
        _mol_util__WEBPACK_IMPORTED_MODULE_8__["ValueCell"].update(this.blendRenderable.values.uViewport, _camera_util__WEBPACK_IMPORTED_MODULE_16__["Viewport"].toVec4(this.blendRenderable.values.uViewport.ref.value, viewport));
    };
    SmaaPass.prototype.setSize = function (width, height) {
        var w = this.edgesTarget.getWidth();
        var h = this.edgesTarget.getHeight();
        if (width !== w || height !== h) {
            this.edgesTarget.setSize(width, height);
            this.weightsTarget.setSize(width, height);
            _mol_util__WEBPACK_IMPORTED_MODULE_8__["ValueCell"].update(this.edgesRenderable.values.uTexSizeInv, _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_7__["Vec2"].set(this.edgesRenderable.values.uTexSizeInv.ref.value, 1 / width, 1 / height));
            _mol_util__WEBPACK_IMPORTED_MODULE_8__["ValueCell"].update(this.weightsRenderable.values.uTexSizeInv, _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_7__["Vec2"].set(this.weightsRenderable.values.uTexSizeInv.ref.value, 1 / width, 1 / height));
            _mol_util__WEBPACK_IMPORTED_MODULE_8__["ValueCell"].update(this.blendRenderable.values.uTexSizeInv, _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_7__["Vec2"].set(this.blendRenderable.values.uTexSizeInv.ref.value, 1 / width, 1 / height));
        }
    };
    SmaaPass.prototype.update = function (input, props) {
        var edgesNeedsUpdate = false;
        if (this.edgesRenderable.values.tColor.ref.value !== input) {
            _mol_util__WEBPACK_IMPORTED_MODULE_8__["ValueCell"].update(this.edgesRenderable.values.tColor, input);
            edgesNeedsUpdate = true;
        }
        if (this.edgesRenderable.values.dEdgeThreshold.ref.value !== props.edgeThreshold) {
            _mol_util__WEBPACK_IMPORTED_MODULE_8__["ValueCell"].update(this.edgesRenderable.values.dEdgeThreshold, props.edgeThreshold);
            edgesNeedsUpdate = true;
        }
        if (edgesNeedsUpdate)
            this.edgesRenderable.update();
        if (this.weightsRenderable.values.dMaxSearchSteps.ref.value !== props.maxSearchSteps) {
            _mol_util__WEBPACK_IMPORTED_MODULE_8__["ValueCell"].update(this.weightsRenderable.values.dMaxSearchSteps, props.maxSearchSteps);
            this.weightsRenderable.update();
        }
        if (this.blendRenderable.values.tColor.ref.value !== input) {
            _mol_util__WEBPACK_IMPORTED_MODULE_8__["ValueCell"].update(this.blendRenderable.values.tColor, input);
            this.blendRenderable.update();
        }
    };
    SmaaPass.prototype.render = function (viewport, target) {
        this.edgesTarget.bind();
        this.updateState(viewport);
        this.edgesRenderable.render();
        this.weightsTarget.bind();
        this.updateState(viewport);
        this.weightsRenderable.render();
        if (target) {
            target.bind();
        }
        else {
            this.webgl.unbindFramebuffer();
        }
        this.updateState(viewport);
        this.blendRenderable.render();
    };
    return SmaaPass;
}());

//
var EdgesSchema = Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, _mol_gl_compute_util__WEBPACK_IMPORTED_MODULE_1__["QuadSchema"]), { tColor: Object(_mol_gl_renderable_schema__WEBPACK_IMPORTED_MODULE_3__["TextureSpec"])('texture', 'rgba', 'ubyte', 'linear'), uTexSizeInv: Object(_mol_gl_renderable_schema__WEBPACK_IMPORTED_MODULE_3__["UniformSpec"])('v2'), uViewport: Object(_mol_gl_renderable_schema__WEBPACK_IMPORTED_MODULE_3__["UniformSpec"])('v4'), dEdgeThreshold: Object(_mol_gl_renderable_schema__WEBPACK_IMPORTED_MODULE_3__["DefineSpec"])('number') });
var EdgesShaderCode = Object(_mol_gl_shader_code__WEBPACK_IMPORTED_MODULE_4__["ShaderCode"])('smaa-edges', _mol_gl_shader_smaa_edges_vert__WEBPACK_IMPORTED_MODULE_14__["edges_vert"], _mol_gl_shader_smaa_edges_frag__WEBPACK_IMPORTED_MODULE_15__["edges_frag"]);
function getEdgesRenderable(ctx, colorTexture) {
    var width = colorTexture.getWidth();
    var height = colorTexture.getHeight();
    var values = Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, _mol_gl_compute_util__WEBPACK_IMPORTED_MODULE_1__["QuadValues"]), { tColor: _mol_util__WEBPACK_IMPORTED_MODULE_8__["ValueCell"].create(colorTexture), uTexSizeInv: _mol_util__WEBPACK_IMPORTED_MODULE_8__["ValueCell"].create(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_7__["Vec2"].create(1 / width, 1 / height)), uViewport: _mol_util__WEBPACK_IMPORTED_MODULE_8__["ValueCell"].create(Object(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_7__["Vec4"])()), dEdgeThreshold: _mol_util__WEBPACK_IMPORTED_MODULE_8__["ValueCell"].create(0.1) });
    var schema = Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, EdgesSchema);
    var renderItem = Object(_mol_gl_webgl_render_item__WEBPACK_IMPORTED_MODULE_5__["createComputeRenderItem"])(ctx, 'triangles', EdgesShaderCode, schema, values);
    return Object(_mol_gl_renderable__WEBPACK_IMPORTED_MODULE_2__["createComputeRenderable"])(renderItem, values);
}
//
var WeightsSchema = Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, _mol_gl_compute_util__WEBPACK_IMPORTED_MODULE_1__["QuadSchema"]), { tEdges: Object(_mol_gl_renderable_schema__WEBPACK_IMPORTED_MODULE_3__["TextureSpec"])('texture', 'rgba', 'ubyte', 'linear'), tArea: Object(_mol_gl_renderable_schema__WEBPACK_IMPORTED_MODULE_3__["TextureSpec"])('texture', 'rgb', 'ubyte', 'linear'), tSearch: Object(_mol_gl_renderable_schema__WEBPACK_IMPORTED_MODULE_3__["TextureSpec"])('texture', 'rgba', 'ubyte', 'nearest'), uTexSizeInv: Object(_mol_gl_renderable_schema__WEBPACK_IMPORTED_MODULE_3__["UniformSpec"])('v2'), uViewport: Object(_mol_gl_renderable_schema__WEBPACK_IMPORTED_MODULE_3__["UniformSpec"])('v4'), dMaxSearchSteps: Object(_mol_gl_renderable_schema__WEBPACK_IMPORTED_MODULE_3__["DefineSpec"])('number') });
var WeightsShaderCode = Object(_mol_gl_shader_code__WEBPACK_IMPORTED_MODULE_4__["ShaderCode"])('smaa-weights', _mol_gl_shader_smaa_weights_vert__WEBPACK_IMPORTED_MODULE_12__["weights_vert"], _mol_gl_shader_smaa_weights_frag__WEBPACK_IMPORTED_MODULE_13__["weights_frag"]);
function getWeightsRenderable(ctx, edgesTexture) {
    var width = edgesTexture.getWidth();
    var height = edgesTexture.getHeight();
    var areaTexture = Object(_mol_gl_webgl_texture__WEBPACK_IMPORTED_MODULE_6__["createTexture"])(ctx.gl, ctx.extensions, 'image-uint8', 'rgb', 'ubyte', 'linear');
    var searchTexture = Object(_mol_gl_webgl_texture__WEBPACK_IMPORTED_MODULE_6__["createTexture"])(ctx.gl, ctx.extensions, 'image-uint8', 'rgba', 'ubyte', 'nearest');
    var values = Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, _mol_gl_compute_util__WEBPACK_IMPORTED_MODULE_1__["QuadValues"]), { tEdges: _mol_util__WEBPACK_IMPORTED_MODULE_8__["ValueCell"].create(edgesTexture), tArea: _mol_util__WEBPACK_IMPORTED_MODULE_8__["ValueCell"].create(areaTexture), tSearch: _mol_util__WEBPACK_IMPORTED_MODULE_8__["ValueCell"].create(searchTexture), uTexSizeInv: _mol_util__WEBPACK_IMPORTED_MODULE_8__["ValueCell"].create(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_7__["Vec2"].create(1 / width, 1 / height)), uViewport: _mol_util__WEBPACK_IMPORTED_MODULE_8__["ValueCell"].create(Object(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_7__["Vec4"])()), dMaxSearchSteps: _mol_util__WEBPACK_IMPORTED_MODULE_8__["ValueCell"].create(8) });
    // Note: loading image textures requires `HTMLImageElement` to be available
    Object(_mol_gl_webgl_texture__WEBPACK_IMPORTED_MODULE_6__["loadImageTexture"])(getAreaTexture(), values.tArea, areaTexture);
    Object(_mol_gl_webgl_texture__WEBPACK_IMPORTED_MODULE_6__["loadImageTexture"])(getSearchTexture(), values.tSearch, searchTexture);
    var schema = Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, WeightsSchema);
    var renderItem = Object(_mol_gl_webgl_render_item__WEBPACK_IMPORTED_MODULE_5__["createComputeRenderItem"])(ctx, 'triangles', WeightsShaderCode, schema, values);
    return Object(_mol_gl_renderable__WEBPACK_IMPORTED_MODULE_2__["createComputeRenderable"])(renderItem, values);
}
//
var BlendSchema = Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, _mol_gl_compute_util__WEBPACK_IMPORTED_MODULE_1__["QuadSchema"]), { tColor: Object(_mol_gl_renderable_schema__WEBPACK_IMPORTED_MODULE_3__["TextureSpec"])('texture', 'rgba', 'ubyte', 'linear'), tWeights: Object(_mol_gl_renderable_schema__WEBPACK_IMPORTED_MODULE_3__["TextureSpec"])('texture', 'rgba', 'ubyte', 'linear'), uTexSizeInv: Object(_mol_gl_renderable_schema__WEBPACK_IMPORTED_MODULE_3__["UniformSpec"])('v2'), uViewport: Object(_mol_gl_renderable_schema__WEBPACK_IMPORTED_MODULE_3__["UniformSpec"])('v4') });
var BlendShaderCode = Object(_mol_gl_shader_code__WEBPACK_IMPORTED_MODULE_4__["ShaderCode"])('smaa-blend', _mol_gl_shader_smaa_blend_vert__WEBPACK_IMPORTED_MODULE_10__["blend_vert"], _mol_gl_shader_smaa_blend_frag__WEBPACK_IMPORTED_MODULE_11__["blend_frag"]);
function getBlendRenderable(ctx, colorTexture, weightsTexture) {
    var width = colorTexture.getWidth();
    var height = colorTexture.getHeight();
    var values = Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, _mol_gl_compute_util__WEBPACK_IMPORTED_MODULE_1__["QuadValues"]), { tColor: _mol_util__WEBPACK_IMPORTED_MODULE_8__["ValueCell"].create(colorTexture), tWeights: _mol_util__WEBPACK_IMPORTED_MODULE_8__["ValueCell"].create(weightsTexture), uTexSizeInv: _mol_util__WEBPACK_IMPORTED_MODULE_8__["ValueCell"].create(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_7__["Vec2"].create(1 / width, 1 / height)), uViewport: _mol_util__WEBPACK_IMPORTED_MODULE_8__["ValueCell"].create(Object(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_7__["Vec4"])()) });
    var schema = Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, BlendSchema);
    var renderItem = Object(_mol_gl_webgl_render_item__WEBPACK_IMPORTED_MODULE_5__["createComputeRenderItem"])(ctx, 'triangles', BlendShaderCode, schema, values);
    return Object(_mol_gl_renderable__WEBPACK_IMPORTED_MODULE_2__["createComputeRenderable"])(renderItem, values);
}
//
function getAreaTexture() {
    return 'data:image/png;base64,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';
}
function getSearchTexture() {
    return 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEIAAAAhCAAAAABIXyLAAAAAOElEQVRIx2NgGAWjYBSMglEwEICREYRgFBZBqDCSLA2MGPUIVQETE9iNUAqLR5gIeoQKRgwXjwAAGn4AtaFeYLEAAAAASUVORK5CYII=';
}
//# sourceMappingURL=smaa.js.map

/***/ }),

/***/ "./lib/mol-canvas3d/passes/wboit.js":
/*!******************************************!*\
  !*** ./lib/mol-canvas3d/passes/wboit.js ***!
  \******************************************/
/*! exports provided: WboitPass */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "WboitPass", function() { return WboitPass; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _mol_gl_compute_util__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../mol-gl/compute/util */ "./lib/mol-gl/compute/util.js");
/* harmony import */ var _mol_gl_renderable__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../mol-gl/renderable */ "./lib/mol-gl/renderable.js");
/* harmony import */ var _mol_gl_renderable_schema__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../mol-gl/renderable/schema */ "./lib/mol-gl/renderable/schema.js");
/* harmony import */ var _mol_gl_shader_code__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../mol-gl/shader-code */ "./lib/mol-gl/shader-code.js");
/* harmony import */ var _mol_gl_webgl_render_item__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../mol-gl/webgl/render-item */ "./lib/mol-gl/webgl/render-item.js");
/* harmony import */ var _mol_util__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../../mol-util */ "./lib/mol-util/index.js");
/* harmony import */ var _mol_gl_shader_quad_vert__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../../mol-gl/shader/quad.vert */ "./lib/mol-gl/shader/quad.vert.js");
/* harmony import */ var _mol_gl_shader_evaluate_wboit_frag__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ../../mol-gl/shader/evaluate-wboit.frag */ "./lib/mol-gl/shader/evaluate-wboit.frag.js");
/* harmony import */ var _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ../../mol-math/linear-algebra */ "./lib/mol-math/linear-algebra.js");
/* harmony import */ var _mol_util_debug__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ../../mol-util/debug */ "./lib/mol-util/debug.js");
/**
 * Copyright (c) 2020 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author Áron Samuel Kovács <aron.kovacs@mail.muni.cz>
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */











var EvaluateWboitSchema = Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, _mol_gl_compute_util__WEBPACK_IMPORTED_MODULE_1__["QuadSchema"]), { tWboitA: Object(_mol_gl_renderable_schema__WEBPACK_IMPORTED_MODULE_3__["TextureSpec"])('texture', 'rgba', 'float', 'nearest'), tWboitB: Object(_mol_gl_renderable_schema__WEBPACK_IMPORTED_MODULE_3__["TextureSpec"])('texture', 'rgba', 'float', 'nearest'), uTexSize: Object(_mol_gl_renderable_schema__WEBPACK_IMPORTED_MODULE_3__["UniformSpec"])('v2') });
var EvaluateWboitShaderCode = Object(_mol_gl_shader_code__WEBPACK_IMPORTED_MODULE_4__["ShaderCode"])('evaluate-wboit', _mol_gl_shader_quad_vert__WEBPACK_IMPORTED_MODULE_7__["default"], _mol_gl_shader_evaluate_wboit_frag__WEBPACK_IMPORTED_MODULE_8__["default"]);
function getEvaluateWboitRenderable(ctx, wboitATexture, wboitBTexture) {
    var values = Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, _mol_gl_compute_util__WEBPACK_IMPORTED_MODULE_1__["QuadValues"]), { tWboitA: _mol_util__WEBPACK_IMPORTED_MODULE_6__["ValueCell"].create(wboitATexture), tWboitB: _mol_util__WEBPACK_IMPORTED_MODULE_6__["ValueCell"].create(wboitBTexture), uTexSize: _mol_util__WEBPACK_IMPORTED_MODULE_6__["ValueCell"].create(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_9__["Vec2"].create(wboitATexture.getWidth(), wboitATexture.getHeight())) });
    var schema = Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, EvaluateWboitSchema);
    var renderItem = Object(_mol_gl_webgl_render_item__WEBPACK_IMPORTED_MODULE_5__["createComputeRenderItem"])(ctx, 'triangles', EvaluateWboitShaderCode, schema, values);
    return Object(_mol_gl_renderable__WEBPACK_IMPORTED_MODULE_2__["createComputeRenderable"])(renderItem, values);
}
//
var WboitPass = /** @class */ (function () {
    function WboitPass(webgl, width, height) {
        this.webgl = webgl;
        this._supported = false;
        if (!WboitPass.isSupported(webgl))
            return;
        var resources = webgl.resources;
        this.textureA = resources.texture('image-float32', 'rgba', 'float', 'nearest');
        this.textureA.define(width, height);
        this.textureB = resources.texture('image-float32', 'rgba', 'float', 'nearest');
        this.textureB.define(width, height);
        this.renderable = getEvaluateWboitRenderable(webgl, this.textureA, this.textureB);
        this.framebuffer = resources.framebuffer();
        this._supported = true;
        this._init();
    }
    Object.defineProperty(WboitPass.prototype, "supported", {
        get: function () {
            return this._supported;
        },
        enumerable: false,
        configurable: true
    });
    WboitPass.prototype.bind = function () {
        var _a = this.webgl, state = _a.state, gl = _a.gl;
        this.framebuffer.bind();
        state.clearColor(0, 0, 0, 1);
        gl.clear(gl.COLOR_BUFFER_BIT);
        state.disable(gl.DEPTH_TEST);
        state.blendFuncSeparate(gl.ONE, gl.ONE, gl.ZERO, gl.ONE_MINUS_SRC_ALPHA);
        state.enable(gl.BLEND);
    };
    WboitPass.prototype.render = function () {
        var _a = this.webgl, state = _a.state, gl = _a.gl;
        state.blendFuncSeparate(gl.SRC_ALPHA, gl.ONE_MINUS_SRC_ALPHA, gl.ONE, gl.ONE_MINUS_SRC_ALPHA);
        state.enable(gl.BLEND);
        this.renderable.update();
        this.renderable.render();
    };
    WboitPass.prototype.setSize = function (width, height) {
        var _a = this.renderable.values.uTexSize.ref.value, w = _a[0], h = _a[1];
        if (width !== w || height !== h) {
            this.textureA.define(width, height);
            this.textureB.define(width, height);
            _mol_util__WEBPACK_IMPORTED_MODULE_6__["ValueCell"].update(this.renderable.values.uTexSize, _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_9__["Vec2"].set(this.renderable.values.uTexSize.ref.value, width, height));
        }
    };
    WboitPass.prototype.reset = function () {
        if (this._supported)
            this._init();
    };
    WboitPass.prototype._init = function () {
        var drawBuffers = this.webgl.extensions.drawBuffers;
        this.framebuffer.bind();
        drawBuffers.drawBuffers([
            drawBuffers.COLOR_ATTACHMENT0,
            drawBuffers.COLOR_ATTACHMENT1,
        ]);
        this.textureA.attachFramebuffer(this.framebuffer, 'color0');
        this.textureB.attachFramebuffer(this.framebuffer, 'color1');
    };
    WboitPass.isSupported = function (webgl) {
        var _a = webgl.extensions, drawBuffers = _a.drawBuffers, textureFloat = _a.textureFloat, colorBufferFloat = _a.colorBufferFloat, depthTexture = _a.depthTexture;
        if (!textureFloat || !colorBufferFloat || !depthTexture || !drawBuffers) {
            if (_mol_util_debug__WEBPACK_IMPORTED_MODULE_10__["isDebugMode"]) {
                var missing = [];
                if (!textureFloat)
                    missing.push('textureFloat');
                if (!colorBufferFloat)
                    missing.push('colorBufferFloat');
                if (!depthTexture)
                    missing.push('depthTexture');
                if (!drawBuffers)
                    missing.push('drawBuffers');
                console.log("Missing \"" + missing.join('", "') + "\" extensions required for \"wboit\"");
            }
            return false;
        }
        else {
            return true;
        }
    };
    return WboitPass;
}());

//# sourceMappingURL=wboit.js.map

/***/ }),

/***/ "./lib/mol-canvas3d/util.js":
/*!**********************************!*\
  !*** ./lib/mol-canvas3d/util.js ***!
  \**********************************/
/*! exports provided: setCanvasSize, resizeCanvas, canvasToBlob */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setCanvasSize", function() { return setCanvasSize; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "resizeCanvas", function() { return resizeCanvas; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "canvasToBlob", function() { return canvasToBlob; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/**
 * Copyright (c) 2018 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */

/** Set canvas size taking `devicePixelRatio` into account */
function setCanvasSize(canvas, width, height, scale) {
    if (scale === void 0) { scale = 1; }
    canvas.width = Math.round(window.devicePixelRatio * scale * width);
    canvas.height = Math.round(window.devicePixelRatio * scale * height);
    Object.assign(canvas.style, { width: width + "px", height: height + "px" });
}
/** Resize canvas to container element taking `devicePixelRatio` into account */
function resizeCanvas(canvas, container, scale) {
    if (scale === void 0) { scale = 1; }
    var width = window.innerWidth;
    var height = window.innerHeight;
    if (container !== document.body) {
        var bounds = container.getBoundingClientRect();
        width = bounds.right - bounds.left;
        height = bounds.bottom - bounds.top;
    }
    setCanvasSize(canvas, width, height, scale);
}
function _canvasToBlob(canvas, callback, type, quality) {
    var bin = atob(canvas.toDataURL(type, quality).split(',')[1]);
    var len = bin.length;
    var len32 = len >> 2;
    var a8 = new Uint8Array(len);
    var a32 = new Uint32Array(a8.buffer, 0, len32);
    var j = 0;
    for (var i = 0; i < len32; ++i) {
        a32[i] = bin.charCodeAt(j++) |
            bin.charCodeAt(j++) << 8 |
            bin.charCodeAt(j++) << 16 |
            bin.charCodeAt(j++) << 24;
    }
    var tailLength = len & 3;
    while (tailLength--)
        a8[j] = bin.charCodeAt(j++);
    callback(new Blob([a8], { type: type || 'image/png' }));
}
function canvasToBlob(canvas, type, quality) {
    return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"])(this, void 0, void 0, function () {
        return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__generator"])(this, function (_a) {
            return [2 /*return*/, new Promise(function (resolve, reject) {
                    var callback = function (blob) {
                        if (blob)
                            resolve(blob);
                        else
                            reject('no blob returned');
                    };
                    if (!HTMLCanvasElement.prototype.toBlob) {
                        _canvasToBlob(canvas, callback, type, quality);
                    }
                    else {
                        canvas.toBlob(callback, type, quality);
                    }
                })];
        });
    });
}
//# sourceMappingURL=util.js.map

/***/ }),

/***/ "./lib/mol-data/db.js":
/*!****************************!*\
  !*** ./lib/mol-data/db.js ***!
  \****************************/
/*! exports provided: Database, Table, Column, ColumnHelpers */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _db_database__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./db/database */ "./lib/mol-data/db/database.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Database", function() { return _db_database__WEBPACK_IMPORTED_MODULE_0__["default"]; });

/* harmony import */ var _db_table__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./db/table */ "./lib/mol-data/db/table.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Table", function() { return _db_table__WEBPACK_IMPORTED_MODULE_1__["default"]; });

/* harmony import */ var _db_column__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./db/column */ "./lib/mol-data/db/column.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Column", function() { return _db_column__WEBPACK_IMPORTED_MODULE_2__["default"]; });

/* harmony import */ var _db_column_helpers__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./db/column-helpers */ "./lib/mol-data/db/column-helpers.js");
/* harmony reexport (module object) */ __webpack_require__.d(__webpack_exports__, "ColumnHelpers", function() { return _db_column_helpers__WEBPACK_IMPORTED_MODULE_3__; });
/**
 * Copyright (c) 2017 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author David Sehnal <david.sehnal@gmail.com>
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */





//# sourceMappingURL=db.js.map

/***/ }),

/***/ "./lib/mol-data/db/column-helpers.js":
/*!*******************************************!*\
  !*** ./lib/mol-data/db/column-helpers.js ***!
  \*******************************************/
/*! exports provided: getArrayBounds, createArray, fillArrayValues, createAndFillArray, isTypedArray, typedArrayWindow */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getArrayBounds", function() { return getArrayBounds; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createArray", function() { return createArray; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fillArrayValues", function() { return fillArrayValues; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createAndFillArray", function() { return createAndFillArray; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isTypedArray", function() { return isTypedArray; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "typedArrayWindow", function() { return typedArrayWindow; });
/**
 * Copyright (c) 2017 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author David Sehnal <david.sehnal@gmail.com>
 */
function getArrayBounds(rowCount, params) {
    var start = params && typeof params.start !== 'undefined' ? Math.max(Math.min(params.start, rowCount - 1), 0) : 0;
    var end = params && typeof params.end !== 'undefined' ? Math.min(params.end, rowCount) : rowCount;
    return { start: start, end: end };
}
function createArray(rowCount, params) {
    var c = params && typeof params.array !== 'undefined' ? params.array : Array;
    var _a = getArrayBounds(rowCount, params), start = _a.start, end = _a.end;
    return { array: new c(end - start), start: start, end: end };
}
function fillArrayValues(value, target, start) {
    for (var i = 0, _e = target.length; i < _e; i++)
        target[i] = value(start + i);
    return target;
}
function createAndFillArray(rowCount, value, params) {
    var _a = createArray(rowCount, params), array = _a.array, start = _a.start;
    return fillArrayValues(value, array, start);
}
function isTypedArray(data) {
    return !!data.buffer && typeof data.byteLength === 'number' && typeof data.BYTES_PER_ELEMENT === 'number';
}
function typedArrayWindow(data, params) {
    var constructor = data.constructor, buffer = data.buffer, length = data.length, byteOffset = data.byteOffset, BYTES_PER_ELEMENT = data.BYTES_PER_ELEMENT;
    var _a = getArrayBounds(length, params), start = _a.start, end = _a.end;
    if (start === 0 && end === length)
        return data;
    return new constructor(buffer, byteOffset + BYTES_PER_ELEMENT * start, Math.min(length, end - start));
}
//# sourceMappingURL=column-helpers.js.map

/***/ }),

/***/ "./lib/mol-data/db/column.js":
/*!***********************************!*\
  !*** ./lib/mol-data/db/column.js ***!
  \***********************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _column_helpers__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./column-helpers */ "./lib/mol-data/db/column-helpers.js");
/* harmony import */ var _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../mol-math/linear-algebra */ "./lib/mol-math/linear-algebra.js");
/* harmony import */ var _mol_io_reader_common_text_number_parser__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../mol-io/reader/common/text/number-parser */ "./lib/mol-io/reader/common/text/number-parser.js");
/**
 * Copyright (c) 2017-2019 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author David Sehnal <david.sehnal@gmail.com>
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */




var Column;
(function (Column) {
    var Schema;
    (function (Schema) {
        // T also serves as a default value for undefined columns
        Schema.str = { '@type': 'str', T: '', valueType: 'str' };
        Schema.int = { '@type': 'int', T: 0, valueType: 'int' };
        Schema.coord = { '@type': 'coord', T: 0, valueType: 'float' };
        Schema.float = { '@type': 'float', T: 0, valueType: 'float' };
        function Str(defaultValue) {
            if (defaultValue === void 0) { defaultValue = ''; }
            return { '@type': 'str', T: defaultValue, valueType: 'str' };
        }
        Schema.Str = Str;
        ;
        function Int(defaultValue) {
            if (defaultValue === void 0) { defaultValue = 0; }
            return { '@type': 'int', T: defaultValue, valueType: 'int' };
        }
        Schema.Int = Int;
        ;
        function Float(defaultValue) {
            if (defaultValue === void 0) { defaultValue = 0; }
            return { '@type': 'float', T: defaultValue, valueType: 'float' };
        }
        Schema.Float = Float;
        ;
        function Tensor(space, baseType) {
            if (baseType === void 0) { baseType = Schema.float; }
            return { '@type': 'tensor', T: space.create(), space: space, valueType: 'tensor', baseType: baseType };
        }
        Schema.Tensor = Tensor;
        function Vector(dim, baseType) {
            if (baseType === void 0) { baseType = Schema.float; }
            return Tensor(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_2__["Tensor"].Vector(dim, baseType['@type'] === 'int' ? Int32Array : Float64Array), baseType);
        }
        Schema.Vector = Vector;
        function Matrix(rows, cols, baseType) {
            if (baseType === void 0) { baseType = Schema.float; }
            return Tensor(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_2__["Tensor"].ColumnMajorMatrix(rows, cols, baseType['@type'] === 'int' ? Int32Array : Float64Array), baseType);
        }
        Schema.Matrix = Matrix;
        function Aliased(t, defaultValue) {
            if (typeof defaultValue !== 'undefined')
                return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, t), { T: defaultValue });
            return t;
        }
        Schema.Aliased = Aliased;
        function List(separator, itemParse, defaultValue) {
            if (defaultValue === void 0) { defaultValue = []; }
            return { '@type': 'list', T: defaultValue, separator: separator, itemParse: itemParse, valueType: 'list' };
        }
        Schema.List = List;
    })(Schema = Column.Schema || (Column.Schema = {}));
    function is(v) {
        return !!v && !!v.schema && !!v.value;
    }
    Column.is = is;
    function Undefined(rowCount, schema) {
        return constColumn(schema['T'], rowCount, schema, 1 /* NotPresent */);
    }
    Column.Undefined = Undefined;
    function ofConst(v, rowCount, type) {
        return constColumn(v, rowCount, type, 0 /* Present */);
    }
    Column.ofConst = ofConst;
    function ofLambda(spec) {
        return lambdaColumn(spec);
    }
    Column.ofLambda = ofLambda;
    /** values [min, max] (i.e. include both values) */
    function range(min, max) {
        return ofLambda({
            value: function (i) { return i + min; },
            rowCount: Math.max(max - min + 1, 0),
            schema: Schema.int
        });
    }
    Column.range = range;
    function ofArray(spec) {
        return arrayColumn(spec);
    }
    Column.ofArray = ofArray;
    function ofIntArray(array) {
        return arrayColumn({ array: array, schema: Schema.int });
    }
    Column.ofIntArray = ofIntArray;
    function ofFloatArray(array) {
        return arrayColumn({ array: array, schema: Schema.float });
    }
    Column.ofFloatArray = ofFloatArray;
    function ofStringArray(array) {
        return arrayColumn({ array: array, schema: Schema.str });
    }
    Column.ofStringArray = ofStringArray;
    function ofStringAliasArray(array) {
        return arrayColumn({ array: array, schema: Schema.Aliased(Schema.str) });
    }
    Column.ofStringAliasArray = ofStringAliasArray;
    function ofStringListArray(array, separator) {
        if (separator === void 0) { separator = ','; }
        return arrayColumn({ array: array, schema: Schema.List(separator, function (x) { return x; }) });
    }
    Column.ofStringListArray = ofStringListArray;
    function ofIntTokens(tokens) {
        var count = tokens.count, data = tokens.data, indices = tokens.indices;
        return lambdaColumn({
            value: function (row) { return Object(_mol_io_reader_common_text_number_parser__WEBPACK_IMPORTED_MODULE_3__["parseInt"])(data, indices[2 * row], indices[2 * row + 1]) || 0; },
            rowCount: count,
            schema: Schema.int,
        });
    }
    Column.ofIntTokens = ofIntTokens;
    function ofFloatTokens(tokens) {
        var count = tokens.count, data = tokens.data, indices = tokens.indices;
        return lambdaColumn({
            value: function (row) { return Object(_mol_io_reader_common_text_number_parser__WEBPACK_IMPORTED_MODULE_3__["parseFloat"])(data, indices[2 * row], indices[2 * row + 1]) || 0; },
            rowCount: count,
            schema: Schema.float,
        });
    }
    Column.ofFloatTokens = ofFloatTokens;
    function ofStringTokens(tokens) {
        var count = tokens.count, data = tokens.data, indices = tokens.indices;
        return lambdaColumn({
            value: function (row) {
                var ret = data.substring(indices[2 * row], indices[2 * row + 1]);
                if (ret === '.' || ret === '?')
                    return '';
                return ret;
            },
            rowCount: count,
            schema: Schema.str,
        });
    }
    Column.ofStringTokens = ofStringTokens;
    function window(column, start, end) {
        return windowColumn(column, start, end);
    }
    Column.window = window;
    function view(column, indices, checkIndentity) {
        if (checkIndentity === void 0) { checkIndentity = true; }
        return columnView(column, indices, checkIndentity);
    }
    Column.view = view;
    /** A map of the 1st occurence of each value. */
    function createFirstIndexMap(column) {
        return createFirstIndexMapOfColumn(column);
    }
    Column.createFirstIndexMap = createFirstIndexMap;
    function createIndexer(column) {
        return createIndexerOfColumn(column);
    }
    Column.createIndexer = createIndexer;
    function mapToArray(column, f, ctor) {
        return mapToArrayImpl(column, f, ctor || Array);
    }
    Column.mapToArray = mapToArray;
    function areEqual(a, b) {
        return areColumnsEqual(a, b);
    }
    Column.areEqual = areEqual;
    function indicesOf(c, test) {
        return columnIndicesOf(c, test);
    }
    Column.indicesOf = indicesOf;
    /** Makes the column backed by an array. Useful for columns that are accessed often. */
    function asArrayColumn(c, array) {
        if (c.__array)
            return c;
        if (!c.isDefined)
            return Undefined(c.rowCount, c.schema);
        return arrayColumn({ array: c.toArray({ array: array }), schema: c.schema, valueKind: c.valueKind });
    }
    Column.asArrayColumn = asArrayColumn;
    function copyToArray(c, array, offset) {
        if (offset === void 0) { offset = 0; }
        if (!c.isDefined)
            return;
        var cArray = c.__array;
        if (cArray) {
            for (var i = 0, _i = cArray.length; i < _i; i++)
                array[offset + i] = cArray[i];
        }
        else {
            for (var i = 0, _i = c.rowCount; i < _i; i++)
                array[offset + i] = c.value(i);
        }
    }
    Column.copyToArray = copyToArray;
    function isIdentity(c) {
        for (var i = 0, _i = c.rowCount; i < _i; i++) {
            if (i !== c.value(i))
                return false;
        }
        return true;
    }
    Column.isIdentity = isIdentity;
})(Column || (Column = {}));
/* harmony default export */ __webpack_exports__["default"] = (Column);
function createFirstIndexMapOfColumn(c) {
    var map = new Map();
    for (var i = 0, _i = c.rowCount; i < _i; i++) {
        var v = c.value(i);
        if (!map.has(v))
            map.set(c.value(i), i);
    }
    return map;
}
function createIndexerOfColumn(c) {
    var map = new Map();
    for (var i = 0, _i = c.rowCount; i < _i; i++) {
        var v = c.value(i);
        if (!map.has(v))
            map.set(c.value(i), i);
    }
    return function (v) { return map.has(v) ? map.get(v) : -1; };
}
function constColumn(v, rowCount, schema, valueKind) {
    var value = function (row) { return v; };
    return {
        schema: schema,
        __array: void 0,
        isDefined: valueKind === 0 /* Present */,
        rowCount: rowCount,
        value: value,
        valueKind: function (row) { return valueKind; },
        toArray: function (params) {
            var array = _column_helpers__WEBPACK_IMPORTED_MODULE_1__["createArray"](rowCount, params).array;
            for (var i = 0, _i = array.length; i < _i; i++)
                array[i] = v;
            return array;
        },
        areValuesEqual: function (rowA, rowB) { return true; }
    };
}
function lambdaColumn(_a) {
    var value = _a.value, valueKind = _a.valueKind, areValuesEqual = _a.areValuesEqual, rowCount = _a.rowCount, schema = _a.schema;
    return {
        schema: schema,
        __array: void 0,
        isDefined: true,
        rowCount: rowCount,
        value: value,
        valueKind: valueKind ? valueKind : function (row) { return 0 /* Present */; },
        toArray: function (params) {
            var _a = _column_helpers__WEBPACK_IMPORTED_MODULE_1__["createArray"](rowCount, params), array = _a.array, start = _a.start;
            for (var i = 0, _i = array.length; i < _i; i++)
                array[i] = value(i + start);
            return array;
        },
        areValuesEqual: areValuesEqual ? areValuesEqual : function (rowA, rowB) { return value(rowA) === value(rowB); }
    };
}
function arrayColumn(_a) {
    var array = _a.array, schema = _a.schema, valueKind = _a.valueKind;
    var rowCount = array.length;
    var value = schema.valueType === 'str'
        ? function (row) { var v = array[row]; return typeof v === 'string' ? v : '' + v; }
        : function (row) { return array[row]; };
    var isTyped = _column_helpers__WEBPACK_IMPORTED_MODULE_1__["isTypedArray"](array);
    return {
        schema: schema,
        __array: array,
        isDefined: true,
        rowCount: rowCount,
        value: value,
        valueKind: valueKind ? valueKind : function (row) { return 0 /* Present */; },
        toArray: schema.valueType === 'str'
            ? function (params) {
                var _a = _column_helpers__WEBPACK_IMPORTED_MODULE_1__["getArrayBounds"](rowCount, params), start = _a.start, end = _a.end;
                var ret = new (params && typeof params.array !== 'undefined' ? params.array : array.constructor)(end - start);
                for (var i = 0, _i = end - start; i < _i; i++) {
                    var v = array[start + i];
                    ret[i] = typeof v === 'string' ? v : '' + v;
                }
                return ret;
            }
            : isTyped
                ? function (params) { return _column_helpers__WEBPACK_IMPORTED_MODULE_1__["typedArrayWindow"](array, params); }
                : function (params) {
                    var _a = _column_helpers__WEBPACK_IMPORTED_MODULE_1__["getArrayBounds"](rowCount, params), start = _a.start, end = _a.end;
                    if (start === 0 && end === array.length)
                        return array;
                    var ret = new (params && typeof params.array !== 'undefined' ? params.array : array.constructor)(end - start);
                    for (var i = 0, _i = end - start; i < _i; i++)
                        ret[i] = array[start + i];
                    return ret;
                },
        areValuesEqual: function (rowA, rowB) { return array[rowA] === array[rowB]; }
    };
}
function windowColumn(column, start, end) {
    if (!column.isDefined)
        return Column.Undefined(end - start, column.schema);
    if (start === 0 && end === column.rowCount)
        return column;
    if (!!column.__array && _column_helpers__WEBPACK_IMPORTED_MODULE_1__["isTypedArray"](column.__array))
        return windowTyped(column, start, end);
    return windowFull(column, start, end);
}
function windowTyped(c, start, end) {
    var array = _column_helpers__WEBPACK_IMPORTED_MODULE_1__["typedArrayWindow"](c.__array, { start: start, end: end });
    var vk = c.valueKind;
    return arrayColumn({ array: array, schema: c.schema, valueKind: function (row) { return vk(start + row); } });
}
function windowFull(c, start, end) {
    var v = c.value, vk = c.valueKind, ave = c.areValuesEqual;
    var value = start === 0 ? v : function (row) { return v(row + start); };
    var rowCount = end - start;
    return {
        schema: c.schema,
        __array: void 0,
        isDefined: c.isDefined,
        rowCount: rowCount,
        value: value,
        valueKind: start === 0 ? vk : function (row) { return vk(row + start); },
        toArray: function (params) {
            var array = _column_helpers__WEBPACK_IMPORTED_MODULE_1__["createArray"](rowCount, params).array;
            for (var i = 0, _i = array.length; i < _i; i++)
                array[i] = v(i + start);
            return array;
        },
        areValuesEqual: start === 0 ? ave : function (rowA, rowB) { return ave(rowA + start, rowB + start); }
    };
}
function isIdentity(map, rowCount) {
    if (map.length !== rowCount)
        return false;
    for (var i = 0, _i = map.length; i < _i; i++) {
        if (map[i] !== i)
            return false;
    }
    return true;
}
function columnView(c, map, checkIdentity) {
    if (c.rowCount === 0)
        return c;
    if (checkIdentity && isIdentity(map, c.rowCount))
        return c;
    if (!!c.__array && typeof c.value(0) === typeof c.__array[0])
        return arrayView(c, map);
    return viewFull(c, map);
}
function arrayView(c, map) {
    var array = c.__array;
    var ret = new array.constructor(map.length);
    for (var i = 0, _i = map.length; i < _i; i++)
        ret[i] = array[map[i]];
    var vk = c.valueKind;
    return arrayColumn({ array: ret, schema: c.schema, valueKind: function (row) { return vk(map[row]); } });
}
function viewFull(c, map) {
    var v = c.value, vk = c.valueKind, ave = c.areValuesEqual;
    var value = function (row) { return v(map[row]); };
    var rowCount = map.length;
    return {
        schema: c.schema,
        __array: void 0,
        isDefined: c.isDefined,
        rowCount: rowCount,
        value: value,
        valueKind: function (row) { return vk(map[row]); },
        toArray: function (params) {
            var array = _column_helpers__WEBPACK_IMPORTED_MODULE_1__["createArray"](rowCount, params).array;
            for (var i = 0, _i = array.length; i < _i; i++)
                array[i] = v(map[i]);
            return array;
        },
        areValuesEqual: function (rowA, rowB) { return ave(map[rowA], map[rowB]); }
    };
}
function mapToArrayImpl(c, f, ctor) {
    var ret = new ctor(c.rowCount);
    for (var i = 0, _i = c.rowCount; i < _i; i++)
        ret[i] = f(c.value(i));
    return ret;
}
function areColumnsEqual(a, b) {
    if (a === b)
        return true;
    if (a.rowCount !== b.rowCount || a.isDefined !== b.isDefined || a.schema.valueType !== b.schema.valueType)
        return false;
    if (!!a.__array && !!b.__array)
        return areArraysEqual(a, b);
    return areValuesEqual(a, b);
}
function areArraysEqual(a, b) {
    var xs = a.__array, ys = b.__array;
    for (var i = 0, _i = a.rowCount; i < _i; i++) {
        if (xs[i] !== ys[i])
            return false;
    }
    return true;
}
function areValuesEqual(a, b) {
    var va = a.value, vb = b.value;
    for (var i = 0, _i = a.rowCount; i < _i; i++) {
        if (va(i) !== vb(i))
            return false;
    }
    return true;
}
function columnIndicesOf(c, test) {
    var ret = [], v = c.value;
    for (var i = 0, _i = c.rowCount; i < _i; i++) {
        if (test(v(i)))
            ret[ret.length] = i;
    }
    return ret;
}
//# sourceMappingURL=column.js.map

/***/ }),

/***/ "./lib/mol-data/db/database.js":
/*!*************************************!*\
  !*** ./lib/mol-data/db/database.js ***!
  \*************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _table__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./table */ "./lib/mol-data/db/table.js");
/**
 * Copyright (c) 2017 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author David Sehnal <david.sehnal@gmail.com>
 */

var Database;
(function (Database) {
    function ofTables(name, schema, tables) {
        var keys = Object.keys(tables);
        var ret = Object.create(null);
        var tableNames = [];
        ret._name = name;
        ret._tableNames = tableNames;
        ret._schema = schema;
        for (var _i = 0, keys_1 = keys; _i < keys_1.length; _i++) {
            var k = keys_1[_i];
            if (!_table__WEBPACK_IMPORTED_MODULE_0__["default"].is(tables[k]))
                continue;
            ret[k] = tables[k];
            tableNames[tableNames.length] = k;
        }
        return ret;
    }
    Database.ofTables = ofTables;
    function getTablesAsRows(database) {
        var ret = {};
        for (var _i = 0, _a = database._tableNames; _i < _a.length; _i++) {
            var k = _a[_i];
            ret[k] = _table__WEBPACK_IMPORTED_MODULE_0__["default"].getRows(database[k]);
        }
        return ret;
    }
    Database.getTablesAsRows = getTablesAsRows;
})(Database || (Database = {}));
/* harmony default export */ __webpack_exports__["default"] = (Database);
//# sourceMappingURL=database.js.map

/***/ }),

/***/ "./lib/mol-data/db/table.js":
/*!**********************************!*\
  !*** ./lib/mol-data/db/table.js ***!
  \**********************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _column__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./column */ "./lib/mol-data/db/column.js");
/* harmony import */ var _util_sort__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../util/sort */ "./lib/mol-data/util/sort.js");
/* harmony import */ var _mol_util__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../mol-util */ "./lib/mol-util/index.js");
/**
 * Copyright (c) 2017 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author David Sehnal <david.sehnal@gmail.com>
 */




/** An immutable table */
var Table;
(function (Table) {
    function is(t) {
        return t && typeof t._rowCount === 'number' && !!t._columns && !!t._schema;
    }
    Table.is = is;
    function pickColumns(schema, table, guard) {
        if (guard === void 0) { guard = {}; }
        var ret = Object.create(null);
        var keys = Object.keys(schema);
        ret._rowCount = table._rowCount;
        ret._columns = keys;
        ret._schema = schema;
        for (var _a = 0, keys_1 = keys; _a < keys_1.length; _a++) {
            var k = keys_1[_a];
            if (!!table[k])
                ret[k] = table[k];
            else if (!!guard[k])
                ret[k] = guard[k];
            else
                throw Error("Cannot find column '" + k + "'.");
        }
        return ret;
    }
    Table.pickColumns = pickColumns;
    function ofColumns(schema, columns) {
        var _columns = Object.keys(columns);
        var _rowCount = columns[_columns[0]].rowCount;
        return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({ _rowCount: _rowCount, _columns: _columns, _schema: schema }, columns);
    }
    Table.ofColumns = ofColumns;
    function ofPartialColumns(schema, partialColumns, rowCount) {
        var ret = Object.create(null);
        var columns = Object.keys(schema);
        ret._rowCount = rowCount;
        ret._columns = columns;
        ret._schema = schema;
        for (var _a = 0, columns_1 = columns; _a < columns_1.length; _a++) {
            var k = columns_1[_a];
            if (k in partialColumns)
                ret[k] = partialColumns[k];
            else
                ret[k] = _column__WEBPACK_IMPORTED_MODULE_1__["default"].Undefined(rowCount, schema[k]);
        }
        return ret;
    }
    Table.ofPartialColumns = ofPartialColumns;
    function ofUndefinedColumns(schema, rowCount) {
        var ret = Object.create(null);
        var columns = Object.keys(schema);
        ret._rowCount = rowCount;
        ret._columns = columns;
        ret._schema = schema;
        for (var _a = 0, columns_2 = columns; _a < columns_2.length; _a++) {
            var k = columns_2[_a];
            ret[k] = _column__WEBPACK_IMPORTED_MODULE_1__["default"].Undefined(rowCount, schema[k]);
        }
        return ret;
    }
    Table.ofUndefinedColumns = ofUndefinedColumns;
    function ofRows(schema, rows) {
        var ret = Object.create(null);
        var rowCount = rows.length;
        var columns = Object.keys(schema);
        ret._rowCount = rowCount;
        ret._columns = columns;
        ret._schema = schema;
        var _loop_1 = function (k) {
            ret[k] = _column__WEBPACK_IMPORTED_MODULE_1__["default"].ofLambda({
                rowCount: rowCount,
                schema: schema[k],
                value: function (r) { return rows[r][k]; },
                valueKind: function (r) { return typeof rows[r][k] === 'undefined' ? 1 /* NotPresent */ : 0 /* Present */; }
            });
        };
        for (var _a = 0, columns_3 = columns; _a < columns_3.length; _a++) {
            var k = columns_3[_a];
            _loop_1(k);
        }
        return ret;
    }
    Table.ofRows = ofRows;
    function ofArrays(schema, arrays) {
        var _a;
        var ret = Object.create(null);
        var columns = Object.keys(schema);
        ret._rowCount = 0;
        ret._columns = columns;
        ret._schema = schema;
        for (var _b = 0, columns_4 = columns; _b < columns_4.length; _b++) {
            var k = columns_4[_b];
            if (typeof arrays[k] !== 'undefined') {
                ret[k] = _column__WEBPACK_IMPORTED_MODULE_1__["default"].ofArray({ array: arrays[k], schema: schema[k] });
                ret._rowCount = (_a = arrays[k]) === null || _a === void 0 ? void 0 : _a.length;
            }
            else {
                ret[k] = _column__WEBPACK_IMPORTED_MODULE_1__["default"].Undefined(ret._rowCount, schema[k]);
            }
        }
        return ret;
    }
    Table.ofArrays = ofArrays;
    function view(table, schema, view) {
        var ret = Object.create(null);
        var columns = Object.keys(schema);
        ret._rowCount = view.length;
        ret._columns = columns;
        ret._schema = schema;
        for (var _a = 0, columns_5 = columns; _a < columns_5.length; _a++) {
            var k = columns_5[_a];
            ret[k] = _column__WEBPACK_IMPORTED_MODULE_1__["default"].view(table[k], view);
        }
        return ret;
    }
    Table.view = view;
    function pick(table, schema, test) {
        var _view = [];
        for (var i = 0, il = table._rowCount; i < il; ++i) {
            if (test(i))
                _view.push(i);
        }
        return view(table, schema, _view);
    }
    Table.pick = pick;
    function window(table, schema, start, end) {
        if (start === 0 && end === table._rowCount)
            return table;
        var ret = Object.create(null);
        var columns = Object.keys(schema);
        ret._rowCount = end - start;
        ret._columns = columns;
        ret._schema = schema;
        for (var _a = 0, columns_6 = columns; _a < columns_6.length; _a++) {
            var k = columns_6[_a];
            ret[k] = _column__WEBPACK_IMPORTED_MODULE_1__["default"].window(table[k], start, end);
        }
        return ret;
    }
    Table.window = window;
    function concat(tables, schema) {
        var ret = Object.create(null);
        var columns = Object.keys(schema);
        ret._rowCount = 0;
        for (var _a = 0, tables_1 = tables; _a < tables_1.length; _a++) {
            var table = tables_1[_a];
            ret._rowCount += table._rowCount;
        }
        var arrays = {};
        for (var _b = 0, columns_7 = columns; _b < columns_7.length; _b++) {
            var column = columns_7[_b];
            arrays[column] = new Array(ret._rowCount);
        }
        ret._columns = columns;
        ret._schema = schema;
        var offset = 0;
        for (var _c = 0, tables_2 = tables; _c < tables_2.length; _c++) {
            var table = tables_2[_c];
            for (var _d = 0, columns_8 = columns; _d < columns_8.length; _d++) {
                var k = columns_8[_d];
                _column__WEBPACK_IMPORTED_MODULE_1__["default"].copyToArray(table[k], arrays[k], offset);
            }
            offset += table._rowCount;
        }
        for (var _e = 0, columns_9 = columns; _e < columns_9.length; _e++) {
            var k = columns_9[_e];
            ret[k] = _column__WEBPACK_IMPORTED_MODULE_1__["default"].ofArray({ array: arrays[k], schema: schema[k] });
        }
        return ret;
    }
    Table.concat = concat;
    function columnToArray(table, name, array) {
        table[name] = _column__WEBPACK_IMPORTED_MODULE_1__["default"].asArrayColumn(table[name], array);
    }
    Table.columnToArray = columnToArray;
    /** Sort and return a new table */
    function sort(table, cmp) {
        var indices = new Int32Array(table._rowCount);
        for (var i = 0, _i = indices.length; i < _i; i++)
            indices[i] = i;
        Object(_util_sort__WEBPACK_IMPORTED_MODULE_2__["sortArray"])(indices, function (_, i, j) { return cmp(i, j); });
        var isIdentity = true;
        for (var i = 0, _i = indices.length; i < _i; i++) {
            if (indices[i] !== i) {
                isIdentity = false;
                break;
            }
        }
        if (isIdentity)
            return table;
        var ret = Object.create(null);
        ret._rowCount = table._rowCount;
        ret._columns = table._columns;
        ret._schema = table._schema;
        for (var _a = 0, _b = table._columns; _a < _b.length; _a++) {
            var c = _b[_a];
            ret[c] = _column__WEBPACK_IMPORTED_MODULE_1__["default"].view(table[c], indices, false);
        }
        return ret;
    }
    Table.sort = sort;
    function areEqual(a, b) {
        if (a._rowCount !== b._rowCount)
            return false;
        if (a._columns.length !== b._columns.length)
            return false;
        for (var _a = 0, _b = a._columns; _a < _b.length; _a++) {
            var c = _b[_a];
            if (!b[c])
                return false;
        }
        for (var _c = 0, _d = a._columns; _c < _d.length; _c++) {
            var c = _d[_c];
            if (!_column__WEBPACK_IMPORTED_MODULE_1__["default"].areEqual(a[c], b[c]))
                return false;
        }
        return true;
    }
    Table.areEqual = areEqual;
    /** Allocate a new object with the given row values. */
    function getRow(table, index) {
        var row = Object.create(null);
        var cols = table._columns;
        for (var i = 0; i < cols.length; i++) {
            var c = cols[i];
            row[c] = table[c].value(index);
        }
        return row;
    }
    Table.getRow = getRow;
    /** Pick the first row for which `test` evaluates to true */
    function pickRow(table, test) {
        for (var i = 0, il = table._rowCount; i < il; ++i) {
            if (test(i))
                return getRow(table, i);
        }
    }
    Table.pickRow = pickRow;
    function getRows(table) {
        var ret = [];
        var c = table._rowCount;
        for (var i = 0; i < c; i++) {
            ret[i] = getRow(table, i);
        }
        return ret;
    }
    Table.getRows = getRows;
    function toArrays(table) {
        var arrays = {};
        var _columns = table._columns;
        for (var i = 0; i < _columns.length; i++) {
            var c = _columns[i];
            arrays[c] = table[c].toArray();
        }
        return arrays;
    }
    Table.toArrays = toArrays;
    function formatToString(table) {
        var sb = _mol_util__WEBPACK_IMPORTED_MODULE_3__["StringBuilder"].create();
        var cols = table._columns, _rowCount = table._rowCount;
        var headerLength = 1;
        _mol_util__WEBPACK_IMPORTED_MODULE_3__["StringBuilder"].write(sb, '|');
        for (var i = 0; i < cols.length; i++) {
            _mol_util__WEBPACK_IMPORTED_MODULE_3__["StringBuilder"].write(sb, cols[i]);
            _mol_util__WEBPACK_IMPORTED_MODULE_3__["StringBuilder"].write(sb, '|');
            headerLength += cols[i].length + 1;
        }
        _mol_util__WEBPACK_IMPORTED_MODULE_3__["StringBuilder"].newline(sb);
        _mol_util__WEBPACK_IMPORTED_MODULE_3__["StringBuilder"].write(sb, new Array(headerLength + 1).join('-'));
        _mol_util__WEBPACK_IMPORTED_MODULE_3__["StringBuilder"].newline(sb);
        for (var r = 0; r < _rowCount; r++) {
            _mol_util__WEBPACK_IMPORTED_MODULE_3__["StringBuilder"].write(sb, '|');
            for (var i = 0; i < cols.length; i++) {
                var c = table[cols[i]];
                if (c.valueKind(r) === 0 /* Present */) {
                    _mol_util__WEBPACK_IMPORTED_MODULE_3__["StringBuilder"].write(sb, c.value(r));
                    _mol_util__WEBPACK_IMPORTED_MODULE_3__["StringBuilder"].write(sb, '|');
                }
                else {
                    _mol_util__WEBPACK_IMPORTED_MODULE_3__["StringBuilder"].write(sb, '.|');
                }
            }
            _mol_util__WEBPACK_IMPORTED_MODULE_3__["StringBuilder"].newline(sb);
        }
        return _mol_util__WEBPACK_IMPORTED_MODULE_3__["StringBuilder"].getString(sb);
    }
    Table.formatToString = formatToString;
})(Table || (Table = {}));
/* harmony default export */ __webpack_exports__["default"] = (Table);
//# sourceMappingURL=table.js.map

/***/ }),

/***/ "./lib/mol-data/generic.js":
/*!*********************************!*\
  !*** ./lib/mol-data/generic.js ***!
  \*********************************/
/*! exports provided: HashSet, LinkedList, UniqueArray */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _generic_hash_set__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./generic/hash-set */ "./lib/mol-data/generic/hash-set.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "HashSet", function() { return _generic_hash_set__WEBPACK_IMPORTED_MODULE_0__["HashSet"]; });

/* harmony import */ var _generic_linked_list__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./generic/linked-list */ "./lib/mol-data/generic/linked-list.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "LinkedList", function() { return _generic_linked_list__WEBPACK_IMPORTED_MODULE_1__["LinkedList"]; });

/* harmony import */ var _generic_unique_array__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./generic/unique-array */ "./lib/mol-data/generic/unique-array.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "UniqueArray", function() { return _generic_unique_array__WEBPACK_IMPORTED_MODULE_2__["UniqueArray"]; });

/**
 * Copyright (c) 2017 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author David Sehnal <david.sehnal@gmail.com>
 */



//# sourceMappingURL=generic.js.map

/***/ }),

/***/ "./lib/mol-data/generic/hash-set.js":
/*!******************************************!*\
  !*** ./lib/mol-data/generic/hash-set.js ***!
  \******************************************/
/*! exports provided: HashSet */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "HashSet", function() { return HashSet; });
/**
 * Copyright (c) 2017 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author David Sehnal <david.sehnal@gmail.com>
 */
var HashSetImpl = /** @class */ (function () {
    function HashSetImpl(getHash, areEqual) {
        this.getHash = getHash;
        this.areEqual = areEqual;
        this.size = 0;
        this.byHash = new Map();
    }
    HashSetImpl.prototype.add = function (a) {
        var hash = this.getHash(a);
        if (this.byHash.has(hash)) {
            var xs = this.byHash.get(hash);
            for (var i = 0, _i = xs.length; i < _i; i++) {
                if (this.areEqual(a, xs[i]))
                    return false;
            }
            xs[xs.length] = a;
            this.size++;
            return true;
        }
        else {
            this.byHash.set(hash, [a]);
            this.size++;
            return true;
        }
    };
    HashSetImpl.prototype.has = function (v) {
        var hash = this.getHash(v);
        if (!this.byHash.has(hash))
            return false;
        var xs = this.byHash.get(hash);
        for (var i = 0, _i = xs.length; i < _i; i++) {
            if (this.areEqual(v, xs[i]))
                return true;
        }
        return false;
    };
    return HashSetImpl;
}());
// TODO: add implementations with multilevel hashing support?
function HashSet(getHash, areEqual) {
    return new HashSetImpl(getHash, areEqual);
}
//# sourceMappingURL=hash-set.js.map

/***/ }),

/***/ "./lib/mol-data/generic/linked-list.js":
/*!*********************************************!*\
  !*** ./lib/mol-data/generic/linked-list.js ***!
  \*********************************************/
/*! exports provided: LinkedList */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "LinkedList", function() { return LinkedList; });
/**
 * Copyright (c) 2017 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author David Sehnal <david.sehnal@gmail.com>
 */
function LinkedList() {
    return new LinkedListImpl();
}
function createListNode(value) {
    return { previous: null, next: null, inList: true, value: value };
}
var LinkedListImpl = /** @class */ (function () {
    function LinkedListImpl() {
        this.count = 0;
        this.first = null;
        this.last = null;
    }
    LinkedListImpl.prototype.addFirst = function (value) {
        var node = createListNode(value);
        node.inList = true;
        if (this.first)
            this.first.previous = node;
        node.next = this.first;
        this.first = node;
        this.count++;
        if (!this.last)
            this.last = node;
        return node;
    };
    LinkedListImpl.prototype.addLast = function (value) {
        var node = createListNode(value);
        if (this.last !== null) {
            this.last.next = node;
        }
        node.previous = this.last;
        this.last = node;
        if (this.first === null) {
            this.first = node;
        }
        node.inList = true;
        this.count++;
        return node;
    };
    LinkedListImpl.prototype.removeFirst = function () {
        var fst = this.first;
        if (fst) {
            this.remove(fst);
            return fst.value;
        }
        return void 0;
    };
    LinkedListImpl.prototype.removeLast = function () {
        var last = this.last;
        if (last) {
            this.remove(last);
            return last.value;
        }
        return void 0;
    };
    LinkedListImpl.prototype.remove = function (node) {
        if (!node.inList)
            return;
        node.inList = false;
        if (node.previous !== null) {
            node.previous.next = node.next;
        }
        else if ( /* first == item*/node.previous === null) {
            this.first = node.next;
        }
        if (node.next !== null) {
            node.next.previous = node.previous;
        }
        else if ( /* last == item*/node.next === null) {
            this.last = node.previous;
        }
        node.next = null;
        node.previous = null;
        this.count--;
    };
    LinkedListImpl.prototype.find = function (value) {
        var current = this.first;
        while (current !== null) {
            if (current.value === value)
                return current;
            current = current.next;
        }
        return void 0;
    };
    return LinkedListImpl;
}());

//# sourceMappingURL=linked-list.js.map

/***/ }),

/***/ "./lib/mol-data/generic/unique-array.js":
/*!**********************************************!*\
  !*** ./lib/mol-data/generic/unique-array.js ***!
  \**********************************************/
/*! exports provided: UniqueArray */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "UniqueArray", function() { return UniqueArray; });
/**
 * Copyright (c) 2017 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author David Sehnal <david.sehnal@gmail.com>
 */
var UniqueArray;
(function (UniqueArray) {
    function create() {
        return { keys: new Set(), array: [] };
    }
    UniqueArray.create = create;
    function add(_a, key, value) {
        var keys = _a.keys, array = _a.array;
        if (keys.has(key))
            return false;
        keys.add(key);
        array[array.length] = value;
        return true;
    }
    UniqueArray.add = add;
    function has(_a, key) {
        var keys = _a.keys;
        return keys.has(key);
    }
    UniqueArray.has = has;
})(UniqueArray || (UniqueArray = {}));

//# sourceMappingURL=unique-array.js.map

/***/ }),

/***/ "./lib/mol-data/index.js":
/*!*******************************!*\
  !*** ./lib/mol-data/index.js ***!
  \*******************************/
/*! exports provided: DB, Int, Iterator, Util, Generic */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _db__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./db */ "./lib/mol-data/db.js");
/* harmony reexport (module object) */ __webpack_require__.d(__webpack_exports__, "DB", function() { return _db__WEBPACK_IMPORTED_MODULE_0__; });
/* harmony import */ var _int__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./int */ "./lib/mol-data/int.js");
/* harmony reexport (module object) */ __webpack_require__.d(__webpack_exports__, "Int", function() { return _int__WEBPACK_IMPORTED_MODULE_1__; });
/* harmony import */ var _iterator__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./iterator */ "./lib/mol-data/iterator.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Iterator", function() { return _iterator__WEBPACK_IMPORTED_MODULE_2__["default"]; });

/* harmony import */ var _util__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./util */ "./lib/mol-data/util.js");
/* harmony reexport (module object) */ __webpack_require__.d(__webpack_exports__, "Util", function() { return _util__WEBPACK_IMPORTED_MODULE_3__; });
/* harmony import */ var _generic__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./generic */ "./lib/mol-data/generic.js");
/* harmony reexport (module object) */ __webpack_require__.d(__webpack_exports__, "Generic", function() { return _generic__WEBPACK_IMPORTED_MODULE_4__; });
/**
 * Copyright (c) 2017 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author David Sehnal <david.sehnal@gmail.com>
 */






//# sourceMappingURL=index.js.map

/***/ }),

/***/ "./lib/mol-data/int.js":
/*!*****************************!*\
  !*** ./lib/mol-data/int.js ***!
  \*****************************/
/*! exports provided: Interval, OrderedSet, Segmentation, SortedArray, Tuple, LinkedIndex, IntMap, Iterator */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _int_interval__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./int/interval */ "./lib/mol-data/int/interval.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Interval", function() { return _int_interval__WEBPACK_IMPORTED_MODULE_0__["default"]; });

/* harmony import */ var _int_ordered_set__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./int/ordered-set */ "./lib/mol-data/int/ordered-set.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "OrderedSet", function() { return _int_ordered_set__WEBPACK_IMPORTED_MODULE_1__["default"]; });

/* harmony import */ var _int_segmentation__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./int/segmentation */ "./lib/mol-data/int/segmentation.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Segmentation", function() { return _int_segmentation__WEBPACK_IMPORTED_MODULE_2__["default"]; });

/* harmony import */ var _int_sorted_array__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./int/sorted-array */ "./lib/mol-data/int/sorted-array.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "SortedArray", function() { return _int_sorted_array__WEBPACK_IMPORTED_MODULE_3__["default"]; });

/* harmony import */ var _int_tuple__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./int/tuple */ "./lib/mol-data/int/tuple.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Tuple", function() { return _int_tuple__WEBPACK_IMPORTED_MODULE_4__["default"]; });

/* harmony import */ var _int_linked_index__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./int/linked-index */ "./lib/mol-data/int/linked-index.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "LinkedIndex", function() { return _int_linked_index__WEBPACK_IMPORTED_MODULE_5__["default"]; });

/* harmony import */ var _int_map__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ./int/map */ "./lib/mol-data/int/map.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "IntMap", function() { return _int_map__WEBPACK_IMPORTED_MODULE_6__["default"]; });

/* harmony import */ var _iterator__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ./iterator */ "./lib/mol-data/iterator.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Iterator", function() { return _iterator__WEBPACK_IMPORTED_MODULE_7__["default"]; });

/**
 * Copyright (c) 2017 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author David Sehnal <david.sehnal@gmail.com>
 */









//# sourceMappingURL=int.js.map

/***/ }),

/***/ "./lib/mol-data/int/impl/interval.js":
/*!*******************************************!*\
  !*** ./lib/mol-data/int/impl/interval.js ***!
  \*******************************************/
/*! exports provided: Empty, ofRange, ofBounds, ofLength, is, start, end, min, max, size, hashCode, toString, has, indexOf, getAt, areEqual, areIntersecting, isSubInterval, findPredecessorIndex, findPredecessorIndexInInterval, findRange, intersect, intersectionSize */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Empty", function() { return Empty; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ofRange", function() { return ofRange; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ofBounds", function() { return ofBounds; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ofLength", function() { return ofLength; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "is", function() { return is; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "start", function() { return start; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "end", function() { return end; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "min", function() { return min; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "max", function() { return max; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "size", function() { return size; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "hashCode", function() { return hashCode; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "toString", function() { return toString; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "has", function() { return has; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "indexOf", function() { return indexOf; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getAt", function() { return getAt; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "areEqual", function() { return areEqual; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "areIntersecting", function() { return areIntersecting; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isSubInterval", function() { return isSubInterval; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "findPredecessorIndex", function() { return findPredecessorIndex; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "findPredecessorIndexInInterval", function() { return findPredecessorIndexInInterval; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "findRange", function() { return findRange; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "intersect", function() { return intersect; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "intersectionSize", function() { return intersectionSize; });
/* harmony import */ var _tuple__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../tuple */ "./lib/mol-data/int/tuple.js");
/**
 * Copyright (c) 2017-2019 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author David Sehnal <david.sehnal@gmail.com>
 */

var Empty = _tuple__WEBPACK_IMPORTED_MODULE_0__["default"].Zero;
function ofRange(min, max) { return max < min ? _tuple__WEBPACK_IMPORTED_MODULE_0__["default"].create(min, min) : _tuple__WEBPACK_IMPORTED_MODULE_0__["default"].create(min, max + 1); }
function ofBounds(start, end) { return end <= start ? _tuple__WEBPACK_IMPORTED_MODULE_0__["default"].create(start, start) : _tuple__WEBPACK_IMPORTED_MODULE_0__["default"].create(start, end); }
function ofLength(length) { return length < 0 ? _tuple__WEBPACK_IMPORTED_MODULE_0__["default"].create(0, 0) : _tuple__WEBPACK_IMPORTED_MODULE_0__["default"].create(0, length); }
var is = _tuple__WEBPACK_IMPORTED_MODULE_0__["default"].is;
var start = _tuple__WEBPACK_IMPORTED_MODULE_0__["default"].fst;
var end = _tuple__WEBPACK_IMPORTED_MODULE_0__["default"].snd;
var min = _tuple__WEBPACK_IMPORTED_MODULE_0__["default"].fst;
function max(i) { return _tuple__WEBPACK_IMPORTED_MODULE_0__["default"].snd(i) - 1; }
function size(i) { return _tuple__WEBPACK_IMPORTED_MODULE_0__["default"].snd(i) - _tuple__WEBPACK_IMPORTED_MODULE_0__["default"].fst(i); }
var hashCode = _tuple__WEBPACK_IMPORTED_MODULE_0__["default"].hashCode;
var toString = _tuple__WEBPACK_IMPORTED_MODULE_0__["default"].toString;
function has(int, v) { return _tuple__WEBPACK_IMPORTED_MODULE_0__["default"].fst(int) <= v && v < _tuple__WEBPACK_IMPORTED_MODULE_0__["default"].snd(int); }
/** Returns the index of `x` in `set` or -1 if not found. */
function indexOf(int, x) { var m = start(int); return x >= m && x < end(int) ? x - m : -1; }
function getAt(int, i) { return _tuple__WEBPACK_IMPORTED_MODULE_0__["default"].fst(int) + i; }
var areEqual = _tuple__WEBPACK_IMPORTED_MODULE_0__["default"].areEqual;
function areIntersecting(a, b) {
    var sa = size(a), sb = size(b);
    if (sa === 0 && sb === 0)
        return true;
    return sa > 0 && sb > 0 && max(a) >= min(b) && min(a) <= max(b);
}
function isSubInterval(a, b) {
    if (!size(a))
        return size(b) === 0;
    if (!size(b))
        return true;
    return start(a) <= start(b) && end(a) >= end(b);
}
function findPredecessorIndex(int, v) {
    var s = start(int);
    if (v <= s)
        return 0;
    var e = end(int);
    if (v >= e)
        return e - s;
    return v - s;
}
function findPredecessorIndexInInterval(int, v, bounds) {
    var bS = start(bounds);
    var s = start(int);
    if (v <= bS + s)
        return bS;
    var bE = end(bounds);
    if (v >= bE + s)
        return bE;
    return v - s;
}
function findRange(int, min, max) {
    return ofBounds(findPredecessorIndex(int, min), findPredecessorIndex(int, max + 1));
}
function intersect(a, b) {
    if (!areIntersecting(a, b))
        return Empty;
    return ofBounds(Math.max(start(a), start(b)), Math.min(end(a), end(b)));
}
function intersectionSize(a, b) {
    return size(findRange(a, min(b), max(b)));
}
//# sourceMappingURL=interval.js.map

/***/ }),

/***/ "./lib/mol-data/int/impl/ordered-set.js":
/*!**********************************************!*\
  !*** ./lib/mol-data/int/impl/ordered-set.js ***!
  \**********************************************/
/*! exports provided: Empty, ofSingleton, ofRange, ofBounds, ofSortedArray, size, has, indexOf, getAt, min, max, start, end, hashCode, toString, areEqual, areIntersecting, isSubset, findPredecessorIndex, findPredecessorIndexInInterval, findRange, intersectionSize, union, intersect, subtract, forEach, forEachSegment, indexedIntersect */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Empty", function() { return Empty; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ofSingleton", function() { return ofSingleton; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ofRange", function() { return ofRange; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ofBounds", function() { return ofBounds; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ofSortedArray", function() { return ofSortedArray; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "size", function() { return size; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "has", function() { return has; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "indexOf", function() { return indexOf; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getAt", function() { return getAt; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "min", function() { return min; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "max", function() { return max; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "start", function() { return start; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "end", function() { return end; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "hashCode", function() { return hashCode; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "toString", function() { return toString; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "areEqual", function() { return areEqual; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "areIntersecting", function() { return areIntersecting; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isSubset", function() { return isSubset; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "findPredecessorIndex", function() { return findPredecessorIndex; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "findPredecessorIndexInInterval", function() { return findPredecessorIndexInInterval; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "findRange", function() { return findRange; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "intersectionSize", function() { return intersectionSize; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "union", function() { return union; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "intersect", function() { return intersect; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "subtract", function() { return subtract; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "forEach", function() { return forEach; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "forEachSegment", function() { return forEachSegment; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "indexedIntersect", function() { return indexedIntersect; });
/* harmony import */ var _sorted_array__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../sorted-array */ "./lib/mol-data/int/sorted-array.js");
/* harmony import */ var _interval__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../interval */ "./lib/mol-data/int/interval.js");
/**
 * Copyright (c) 2017-2019 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author David Sehnal <david.sehnal@gmail.com>
 */


var Empty = _interval__WEBPACK_IMPORTED_MODULE_1__["default"].Empty;
var ofSingleton = _interval__WEBPACK_IMPORTED_MODULE_1__["default"].ofSingleton;
var ofRange = _interval__WEBPACK_IMPORTED_MODULE_1__["default"].ofRange;
var ofBounds = _interval__WEBPACK_IMPORTED_MODULE_1__["default"].ofBounds;
function ofSortedArray(xs) {
    if (!xs.length)
        return Empty;
    // check if the array is just a range
    if (xs[xs.length - 1] - xs[0] + 1 === xs.length)
        return _interval__WEBPACK_IMPORTED_MODULE_1__["default"].ofRange(xs[0], xs[xs.length - 1]);
    return xs;
}
function size(set) { return _interval__WEBPACK_IMPORTED_MODULE_1__["default"].is(set) ? _interval__WEBPACK_IMPORTED_MODULE_1__["default"].size(set) : _sorted_array__WEBPACK_IMPORTED_MODULE_0__["default"].size(set); }
function has(set, x) { return _interval__WEBPACK_IMPORTED_MODULE_1__["default"].is(set) ? _interval__WEBPACK_IMPORTED_MODULE_1__["default"].has(set, x) : _sorted_array__WEBPACK_IMPORTED_MODULE_0__["default"].has(set, x); }
/** Returns the index of `x` in `set` or -1 if not found. */
function indexOf(set, x) { return _interval__WEBPACK_IMPORTED_MODULE_1__["default"].is(set) ? _interval__WEBPACK_IMPORTED_MODULE_1__["default"].indexOf(set, x) : _sorted_array__WEBPACK_IMPORTED_MODULE_0__["default"].indexOf(set, x); }
function getAt(set, i) { return _interval__WEBPACK_IMPORTED_MODULE_1__["default"].is(set) ? _interval__WEBPACK_IMPORTED_MODULE_1__["default"].getAt(set, i) : set[i]; }
function min(set) { return _interval__WEBPACK_IMPORTED_MODULE_1__["default"].is(set) ? _interval__WEBPACK_IMPORTED_MODULE_1__["default"].min(set) : _sorted_array__WEBPACK_IMPORTED_MODULE_0__["default"].min(set); }
function max(set) { return _interval__WEBPACK_IMPORTED_MODULE_1__["default"].is(set) ? _interval__WEBPACK_IMPORTED_MODULE_1__["default"].max(set) : _sorted_array__WEBPACK_IMPORTED_MODULE_0__["default"].max(set); }
function start(set) { return _interval__WEBPACK_IMPORTED_MODULE_1__["default"].is(set) ? _interval__WEBPACK_IMPORTED_MODULE_1__["default"].start(set) : _sorted_array__WEBPACK_IMPORTED_MODULE_0__["default"].start(set); }
function end(set) { return _interval__WEBPACK_IMPORTED_MODULE_1__["default"].is(set) ? _interval__WEBPACK_IMPORTED_MODULE_1__["default"].end(set) : _sorted_array__WEBPACK_IMPORTED_MODULE_0__["default"].end(set); }
function hashCode(set) { return _interval__WEBPACK_IMPORTED_MODULE_1__["default"].is(set) ? _interval__WEBPACK_IMPORTED_MODULE_1__["default"].hashCode(set) : _sorted_array__WEBPACK_IMPORTED_MODULE_0__["default"].hashCode(set); }
// TODO: possibly add more hash functions to allow for multilevel hashing.
function toString(set) { return _interval__WEBPACK_IMPORTED_MODULE_1__["default"].is(set) ? _interval__WEBPACK_IMPORTED_MODULE_1__["default"].toString(set) : _sorted_array__WEBPACK_IMPORTED_MODULE_0__["default"].toString(set); }
function areEqual(a, b) {
    if (_interval__WEBPACK_IMPORTED_MODULE_1__["default"].is(a)) {
        if (_interval__WEBPACK_IMPORTED_MODULE_1__["default"].is(b))
            return _interval__WEBPACK_IMPORTED_MODULE_1__["default"].areEqual(a, b);
        return areEqualIS(a, b);
    }
    else if (_interval__WEBPACK_IMPORTED_MODULE_1__["default"].is(b))
        return areEqualIS(b, a);
    return _sorted_array__WEBPACK_IMPORTED_MODULE_0__["default"].areEqual(a, b);
}
function areIntersecting(a, b) {
    if (_interval__WEBPACK_IMPORTED_MODULE_1__["default"].is(a)) {
        if (_interval__WEBPACK_IMPORTED_MODULE_1__["default"].is(b))
            return _interval__WEBPACK_IMPORTED_MODULE_1__["default"].areIntersecting(a, b);
        return areIntersectingSI(b, a);
    }
    else if (_interval__WEBPACK_IMPORTED_MODULE_1__["default"].is(b))
        return areIntersectingSI(a, b);
    return _sorted_array__WEBPACK_IMPORTED_MODULE_0__["default"].areIntersecting(a, b);
}
/** Check if the 2nd argument is a subset of the 1st */
function isSubset(a, b) {
    if (_interval__WEBPACK_IMPORTED_MODULE_1__["default"].is(a)) {
        if (_interval__WEBPACK_IMPORTED_MODULE_1__["default"].is(b))
            return _interval__WEBPACK_IMPORTED_MODULE_1__["default"].isSubInterval(a, b);
        return isSubsetIS(a, b);
    }
    else if (_interval__WEBPACK_IMPORTED_MODULE_1__["default"].is(b))
        return isSubsetSI(a, b);
    return _sorted_array__WEBPACK_IMPORTED_MODULE_0__["default"].isSubset(a, b);
}
function findPredecessorIndex(set, x) {
    return _interval__WEBPACK_IMPORTED_MODULE_1__["default"].is(set) ? _interval__WEBPACK_IMPORTED_MODULE_1__["default"].findPredecessorIndex(set, x) : _sorted_array__WEBPACK_IMPORTED_MODULE_0__["default"].findPredecessorIndex(set, x);
}
function findPredecessorIndexInInterval(set, x, bounds) {
    return _interval__WEBPACK_IMPORTED_MODULE_1__["default"].is(set) ? _interval__WEBPACK_IMPORTED_MODULE_1__["default"].findPredecessorIndexInInterval(set, x, bounds) : _sorted_array__WEBPACK_IMPORTED_MODULE_0__["default"].findPredecessorIndexInInterval(set, x, bounds);
}
function findRange(set, min, max) {
    return _interval__WEBPACK_IMPORTED_MODULE_1__["default"].is(set) ? _interval__WEBPACK_IMPORTED_MODULE_1__["default"].findRange(set, min, max) : _sorted_array__WEBPACK_IMPORTED_MODULE_0__["default"].findRange(set, min, max);
}
function intersectionSize(a, b) {
    if (_interval__WEBPACK_IMPORTED_MODULE_1__["default"].is(a)) {
        if (_interval__WEBPACK_IMPORTED_MODULE_1__["default"].is(b))
            return _interval__WEBPACK_IMPORTED_MODULE_1__["default"].intersectionSize(a, b);
        return intersectionSizeSI(b, a);
    }
    else if (_interval__WEBPACK_IMPORTED_MODULE_1__["default"].is(b))
        return intersectionSizeSI(a, b);
    return _sorted_array__WEBPACK_IMPORTED_MODULE_0__["default"].intersectionSize(a, b);
}
function union(a, b) {
    if (_interval__WEBPACK_IMPORTED_MODULE_1__["default"].is(a)) {
        if (_interval__WEBPACK_IMPORTED_MODULE_1__["default"].is(b))
            return unionII(a, b);
        return unionSI(b, a);
    }
    else if (_interval__WEBPACK_IMPORTED_MODULE_1__["default"].is(b))
        return unionSI(a, b);
    return ofSortedArray(_sorted_array__WEBPACK_IMPORTED_MODULE_0__["default"].union(a, b));
}
function intersect(a, b) {
    if (_interval__WEBPACK_IMPORTED_MODULE_1__["default"].is(a)) {
        if (_interval__WEBPACK_IMPORTED_MODULE_1__["default"].is(b))
            return _interval__WEBPACK_IMPORTED_MODULE_1__["default"].intersect(a, b);
        return intersectSI(b, a);
    }
    else if (_interval__WEBPACK_IMPORTED_MODULE_1__["default"].is(b))
        return intersectSI(a, b);
    return ofSortedArray(_sorted_array__WEBPACK_IMPORTED_MODULE_0__["default"].intersect(a, b));
}
function subtract(a, b) {
    if (_interval__WEBPACK_IMPORTED_MODULE_1__["default"].is(a)) {
        if (_interval__WEBPACK_IMPORTED_MODULE_1__["default"].is(b))
            return subtractII(a, b);
        return subtractIS(a, b);
    }
    else if (_interval__WEBPACK_IMPORTED_MODULE_1__["default"].is(b))
        return subtractSI(a, b);
    return ofSortedArray(_sorted_array__WEBPACK_IMPORTED_MODULE_0__["default"].subtract(a, b));
}
function areEqualIS(a, b) { return _interval__WEBPACK_IMPORTED_MODULE_1__["default"].size(a) === _sorted_array__WEBPACK_IMPORTED_MODULE_0__["default"].size(b) && _interval__WEBPACK_IMPORTED_MODULE_1__["default"].start(a) === _sorted_array__WEBPACK_IMPORTED_MODULE_0__["default"].start(b) && _interval__WEBPACK_IMPORTED_MODULE_1__["default"].end(a) === _sorted_array__WEBPACK_IMPORTED_MODULE_0__["default"].end(b); }
function areIntersectingSI(a, b) {
    return a.length !== 0 && _interval__WEBPACK_IMPORTED_MODULE_1__["default"].size(_sorted_array__WEBPACK_IMPORTED_MODULE_0__["default"].findRange(a, _interval__WEBPACK_IMPORTED_MODULE_1__["default"].min(b), _interval__WEBPACK_IMPORTED_MODULE_1__["default"].max(b))) !== 0;
}
function isSubsetSI(a, b) {
    var minB = _interval__WEBPACK_IMPORTED_MODULE_1__["default"].min(b), maxB = _interval__WEBPACK_IMPORTED_MODULE_1__["default"].max(b);
    if (maxB - minB + 1 === 0)
        return true;
    var minA = _sorted_array__WEBPACK_IMPORTED_MODULE_0__["default"].min(a), maxA = _sorted_array__WEBPACK_IMPORTED_MODULE_0__["default"].max(a);
    if (minB < minA || maxB > maxA)
        return false;
    var r = _sorted_array__WEBPACK_IMPORTED_MODULE_0__["default"].findRange(a, minB, maxB);
    return _interval__WEBPACK_IMPORTED_MODULE_1__["default"].size(r) === _interval__WEBPACK_IMPORTED_MODULE_1__["default"].size(b);
}
function isSubsetIS(a, b) {
    var minA = _interval__WEBPACK_IMPORTED_MODULE_1__["default"].min(a), maxA = _interval__WEBPACK_IMPORTED_MODULE_1__["default"].max(a);
    if (maxA - minA + 1 === 0)
        return false;
    var minB = _sorted_array__WEBPACK_IMPORTED_MODULE_0__["default"].min(b), maxB = _sorted_array__WEBPACK_IMPORTED_MODULE_0__["default"].max(b);
    return minB >= minA && maxB <= maxA;
}
function areRangesIntersecting(a, b) {
    var sa = size(a), sb = size(b);
    if (sa === 0 && sb === 0)
        return true;
    return sa > 0 && sb > 0 && max(a) >= min(b) && min(a) <= max(b);
}
function isRangeSubset(a, b) {
    if (!size(a))
        return size(b) === 0;
    if (!size(b))
        return true;
    return min(a) <= min(b) && max(a) >= max(b);
}
function unionII(a, b) {
    if (_interval__WEBPACK_IMPORTED_MODULE_1__["default"].areEqual(a, b))
        return a;
    var sizeA = _interval__WEBPACK_IMPORTED_MODULE_1__["default"].size(a), sizeB = _interval__WEBPACK_IMPORTED_MODULE_1__["default"].size(b);
    if (!sizeB)
        return a;
    if (!sizeA)
        return b;
    var minA = _interval__WEBPACK_IMPORTED_MODULE_1__["default"].min(a), minB = _interval__WEBPACK_IMPORTED_MODULE_1__["default"].min(b);
    if (areRangesIntersecting(a, b))
        return _interval__WEBPACK_IMPORTED_MODULE_1__["default"].ofRange(Math.min(minA, minB), Math.max(_interval__WEBPACK_IMPORTED_MODULE_1__["default"].max(a), _interval__WEBPACK_IMPORTED_MODULE_1__["default"].max(b)));
    var lSize, lMin, rSize, rMin;
    if (minA < minB) {
        lSize = sizeA;
        lMin = minA;
        rSize = sizeB;
        rMin = minB;
    }
    else {
        lSize = sizeB;
        lMin = minB;
        rSize = sizeA;
        rMin = minA;
    }
    var arr = new Int32Array(sizeA + sizeB);
    for (var i = 0; i < lSize; i++)
        arr[i] = i + lMin;
    for (var i = 0; i < rSize; i++)
        arr[i + lSize] = i + rMin;
    return ofSortedArray(arr);
}
function unionSI(a, b) {
    var bSize = _interval__WEBPACK_IMPORTED_MODULE_1__["default"].size(b);
    if (!bSize)
        return a;
    // is the array fully contained in the range?
    if (isRangeSubset(b, a))
        return b;
    var min = _interval__WEBPACK_IMPORTED_MODULE_1__["default"].min(b), max = _interval__WEBPACK_IMPORTED_MODULE_1__["default"].max(b);
    var r = _sorted_array__WEBPACK_IMPORTED_MODULE_0__["default"].findRange(a, min, max);
    var start = _interval__WEBPACK_IMPORTED_MODULE_1__["default"].start(r), end = _interval__WEBPACK_IMPORTED_MODULE_1__["default"].end(r);
    var indices = new Int32Array(start + (a.length - end) + bSize);
    var offset = 0;
    for (var i = 0; i < start; i++)
        indices[offset++] = a[i];
    for (var i = min; i <= max; i++)
        indices[offset++] = i;
    for (var i = end, _i = a.length; i < _i; i++)
        indices[offset++] = a[i];
    return ofSortedArray(indices);
}
function intersectionSizeSI(a, b) {
    if (!_interval__WEBPACK_IMPORTED_MODULE_1__["default"].size(b))
        return 0;
    var r = _sorted_array__WEBPACK_IMPORTED_MODULE_0__["default"].findRange(a, _interval__WEBPACK_IMPORTED_MODULE_1__["default"].min(b), _interval__WEBPACK_IMPORTED_MODULE_1__["default"].max(b));
    return _interval__WEBPACK_IMPORTED_MODULE_1__["default"].end(r) - _interval__WEBPACK_IMPORTED_MODULE_1__["default"].start(r);
}
function intersectSI(a, b) {
    if (!_interval__WEBPACK_IMPORTED_MODULE_1__["default"].size(b))
        return Empty;
    var r = _sorted_array__WEBPACK_IMPORTED_MODULE_0__["default"].findRange(a, _interval__WEBPACK_IMPORTED_MODULE_1__["default"].min(b), _interval__WEBPACK_IMPORTED_MODULE_1__["default"].max(b));
    var start = _interval__WEBPACK_IMPORTED_MODULE_1__["default"].start(r), end = _interval__WEBPACK_IMPORTED_MODULE_1__["default"].end(r);
    var resultSize = end - start;
    if (!resultSize)
        return Empty;
    if (resultSize === a.length)
        return a;
    var indices = new Int32Array(resultSize);
    var offset = 0;
    for (var i = start; i < end; i++) {
        indices[offset++] = a[i];
    }
    return ofSortedArray(indices);
}
function subtractII(a, b) {
    if (_interval__WEBPACK_IMPORTED_MODULE_1__["default"].areEqual(a, b))
        return Empty;
    if (!_interval__WEBPACK_IMPORTED_MODULE_1__["default"].areIntersecting(a, b))
        return a;
    var minA = _interval__WEBPACK_IMPORTED_MODULE_1__["default"].min(a), maxA = _interval__WEBPACK_IMPORTED_MODULE_1__["default"].max(a);
    var minB = _interval__WEBPACK_IMPORTED_MODULE_1__["default"].min(b), maxB = _interval__WEBPACK_IMPORTED_MODULE_1__["default"].max(b);
    if (maxA < minA || maxB < minB)
        return a;
    // is A subset of B? ==> Empty
    if (_interval__WEBPACK_IMPORTED_MODULE_1__["default"].isSubInterval(b, a))
        return Empty;
    if (_interval__WEBPACK_IMPORTED_MODULE_1__["default"].isSubInterval(a, b)) {
        // this splits the interval into two, gotta represent it as a set.
        var l = minB - minA, r = maxA - maxB;
        if (l <= 0)
            return _interval__WEBPACK_IMPORTED_MODULE_1__["default"].ofRange(maxB + 1, maxB + r);
        if (r <= 0)
            return _interval__WEBPACK_IMPORTED_MODULE_1__["default"].ofRange(minA, minA + l - 1);
        var ret = new Int32Array(l + r);
        var offset = 0;
        for (var i = 0; i < l; i++)
            ret[offset++] = minA + i;
        for (var i = 1; i <= r; i++)
            ret[offset++] = maxB + i;
        return ofSortedArray(ret);
    }
    if (minA < minB)
        return _interval__WEBPACK_IMPORTED_MODULE_1__["default"].ofRange(minA, minB - 1);
    return _interval__WEBPACK_IMPORTED_MODULE_1__["default"].ofRange(maxB + 1, maxA);
}
function subtractSI(a, b) {
    var min = _interval__WEBPACK_IMPORTED_MODULE_1__["default"].min(b), max = _interval__WEBPACK_IMPORTED_MODULE_1__["default"].max(b);
    // is empty?
    if (max < min)
        return a;
    var r = _sorted_array__WEBPACK_IMPORTED_MODULE_0__["default"].findRange(a, min, max);
    var start = _interval__WEBPACK_IMPORTED_MODULE_1__["default"].start(r), end = _interval__WEBPACK_IMPORTED_MODULE_1__["default"].end(r);
    var resultSize = a.length - (end - start);
    // A is subset of B
    if (resultSize <= 0)
        return Empty;
    // No common elements
    if (resultSize === a.length)
        return a;
    var ret = new Int32Array(resultSize);
    var offset = 0;
    for (var i = 0; i < start; i++)
        ret[offset++] = a[i];
    for (var i = end, _i = a.length; i < _i; i++)
        ret[offset++] = a[i];
    return ofSortedArray(ret);
}
function subtractIS(a, b) {
    var min = _interval__WEBPACK_IMPORTED_MODULE_1__["default"].min(a), max = _interval__WEBPACK_IMPORTED_MODULE_1__["default"].max(a);
    // is empty?
    if (max < min)
        return a;
    var rSize = max - min + 1;
    var interval = _sorted_array__WEBPACK_IMPORTED_MODULE_0__["default"].findRange(b, min, max);
    var start = _interval__WEBPACK_IMPORTED_MODULE_1__["default"].start(interval), end = _interval__WEBPACK_IMPORTED_MODULE_1__["default"].end(interval);
    var commonCount = end - start;
    // No common elements.
    if (commonCount === 0)
        return a;
    var resultSize = rSize - commonCount;
    // A is subset of B
    if (resultSize <= 0)
        return Empty;
    var ret = new Int32Array(resultSize);
    var li = b.length - 1;
    var fst = b[Math.min(start, li)], last = b[Math.min(end, li)];
    var offset = 0;
    for (var i = min; i < fst; i++)
        ret[offset++] = i;
    for (var i = fst; i <= last; i++) {
        if (_sorted_array__WEBPACK_IMPORTED_MODULE_0__["default"].indexOfInInterval(b, i, interval) < 0)
            ret[offset++] = i;
    }
    for (var i = last + 1; i <= max; i++)
        ret[offset++] = i;
    return ofSortedArray(ret);
}
function forEach(set, f, ctx) {
    if (_interval__WEBPACK_IMPORTED_MODULE_1__["default"].is(set)) {
        var start_1 = _interval__WEBPACK_IMPORTED_MODULE_1__["default"].min(set);
        for (var i = start_1, _i = _interval__WEBPACK_IMPORTED_MODULE_1__["default"].max(set); i <= _i; i++) {
            f(i, i - start_1, ctx);
        }
    }
    else {
        for (var i = 0, _i = set.length; i < _i; i++) {
            f(set[i], i, ctx);
        }
    }
    return ctx;
}
function forEachSegment(set, segment, f, ctx) {
    if (_interval__WEBPACK_IMPORTED_MODULE_1__["default"].is(set)) {
        var sI = 0;
        for (var i = _interval__WEBPACK_IMPORTED_MODULE_1__["default"].min(set), _i = _interval__WEBPACK_IMPORTED_MODULE_1__["default"].max(set); i <= _i; i++) {
            var s = segment(i);
            var endI = i + 1;
            while (endI < _i && segment(endI) === s)
                endI++;
            i = endI - 1;
            f(s, sI, ctx);
            sI++;
        }
    }
    else {
        var sI = 0;
        for (var i = 0, _i = set.length; i < _i; i++) {
            var s = segment(set[i]);
            var endI = i + 1;
            while (endI < _i && segment(set[endI]) === s)
                endI++;
            i = endI - 1;
            f(s, sI, ctx);
            sI++;
        }
    }
    return ctx;
}
function indexedIntersect(idxA, a, b) {
    if (a === b)
        return idxA;
    var lenI = size(idxA), lenA = a.length, lenB = b.length;
    if (lenI === 0 || lenA === 0 || lenB === 0)
        return Empty;
    var startJ = _sorted_array__WEBPACK_IMPORTED_MODULE_0__["default"].findPredecessorIndex(b, a[min(idxA)]);
    var endJ = _sorted_array__WEBPACK_IMPORTED_MODULE_0__["default"].findPredecessorIndex(b, a[max(idxA)] + 1);
    var commonCount = 0;
    var offset = 0;
    var O = 0;
    var j = startJ;
    while (O < lenI && j < endJ) {
        var x = a[getAt(idxA, O)], y = b[j];
        if (x < y) {
            O++;
        }
        else if (x > y) {
            j++;
        }
        else {
            commonCount++;
            O++;
            j++;
        }
    }
    // no common elements
    if (commonCount === 0)
        return Empty;
    // A === B
    if (commonCount === lenA && commonCount === lenB)
        return idxA;
    var indices = new Int32Array(commonCount);
    offset = 0;
    O = 0;
    j = startJ;
    while (O < lenI && j < endJ) {
        var x = a[getAt(idxA, O)], y = b[j];
        if (x < y) {
            O++;
        }
        else if (x > y) {
            j++;
        }
        else {
            indices[offset++] = j;
            O++;
            j++;
        }
    }
    return ofSortedArray(indices);
}
//# sourceMappingURL=ordered-set.js.map

/***/ }),

/***/ "./lib/mol-data/int/impl/segmentation.js":
/*!***********************************************!*\
  !*** ./lib/mol-data/int/impl/segmentation.js ***!
  \***********************************************/
/*! exports provided: create, ofOffsets, count, getSegment, projectValue, SegmentIterator, segments */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "create", function() { return create; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ofOffsets", function() { return ofOffsets; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "count", function() { return count; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getSegment", function() { return getSegment; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "projectValue", function() { return projectValue; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SegmentIterator", function() { return SegmentIterator; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "segments", function() { return segments; });
/* harmony import */ var _ordered_set__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../ordered-set */ "./lib/mol-data/int/ordered-set.js");
/* harmony import */ var _interval__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../interval */ "./lib/mol-data/int/interval.js");
/* harmony import */ var _sorted_array__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../sorted-array */ "./lib/mol-data/int/sorted-array.js");
/**
 * Copyright (c) 2017 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author David Sehnal <david.sehnal@gmail.com>
 */



function create(values) {
    var offsets = _sorted_array__WEBPACK_IMPORTED_MODULE_2__["default"].ofSortedArray(values);
    var max = _sorted_array__WEBPACK_IMPORTED_MODULE_2__["default"].max(offsets);
    var index = new Int32Array(max);
    for (var i = 0, _i = values.length - 1; i < _i; i++) {
        for (var j = values[i], _j = values[i + 1]; j < _j; j++) {
            index[j] = i;
        }
    }
    return { offsets: offsets, index: index, count: values.length - 1 };
}
function ofOffsets(offsets, bounds) {
    var s = _interval__WEBPACK_IMPORTED_MODULE_1__["default"].start(bounds);
    var segments = new Int32Array(offsets.length + 1);
    for (var i = 0, _i = offsets.length; i < _i; i++) {
        segments[i] = offsets[i] - s;
    }
    segments[offsets.length] = _interval__WEBPACK_IMPORTED_MODULE_1__["default"].end(bounds) - s;
    return create(segments);
}
/** Get number of segments in a segmentation */
function count(_a) {
    var count = _a.count;
    return count;
}
function getSegment(_a, value) {
    var index = _a.index;
    return index[value];
}
function projectValue(_a, set, value) {
    var offsets = _a.offsets;
    var last = _ordered_set__WEBPACK_IMPORTED_MODULE_0__["default"].max(offsets);
    var idx = value >= last ? -1 : _ordered_set__WEBPACK_IMPORTED_MODULE_0__["default"].findPredecessorIndex(offsets, value - 1);
    return _ordered_set__WEBPACK_IMPORTED_MODULE_0__["default"].findRange(set, _ordered_set__WEBPACK_IMPORTED_MODULE_0__["default"].getAt(offsets, idx), _ordered_set__WEBPACK_IMPORTED_MODULE_0__["default"].getAt(offsets, idx + 1) - 1);
}
var SegmentIterator = /** @class */ (function () {
    function SegmentIterator(segments, segmentMap, set, inputRange) {
        this.segments = segments;
        this.segmentMap = segmentMap;
        this.set = set;
        this.segmentMin = 0;
        this.segmentMax = 0;
        this.setRange = _interval__WEBPACK_IMPORTED_MODULE_1__["default"].Empty;
        this.value = { index: 0, start: 0, end: 0 };
        this.hasNext = false;
        this.setRange = inputRange;
        this.updateSegmentRange();
    }
    SegmentIterator.prototype.move = function () {
        while (this.hasNext) {
            if (this.updateValue()) {
                this.value.index = this.segmentMin++;
                this.hasNext = this.segmentMax >= this.segmentMin && _interval__WEBPACK_IMPORTED_MODULE_1__["default"].size(this.setRange) > 0;
                break;
            }
            else {
                this.updateSegmentRange();
            }
        }
        return this.value;
    };
    SegmentIterator.prototype.updateValue = function () {
        var segmentEnd = this.segments[this.segmentMin + 1];
        // TODO: add optimized version for interval and array?
        var setEnd = _ordered_set__WEBPACK_IMPORTED_MODULE_0__["default"].findPredecessorIndexInInterval(this.set, segmentEnd, this.setRange);
        this.value.start = _interval__WEBPACK_IMPORTED_MODULE_1__["default"].start(this.setRange);
        this.value.end = setEnd;
        this.setRange = _interval__WEBPACK_IMPORTED_MODULE_1__["default"].ofBounds(setEnd, _interval__WEBPACK_IMPORTED_MODULE_1__["default"].end(this.setRange));
        return setEnd > this.value.start;
    };
    SegmentIterator.prototype.updateSegmentRange = function () {
        var sMin = _interval__WEBPACK_IMPORTED_MODULE_1__["default"].min(this.setRange), sMax = _interval__WEBPACK_IMPORTED_MODULE_1__["default"].max(this.setRange);
        if (sMax < sMin) {
            this.hasNext = false;
            return;
        }
        this.segmentMin = this.segmentMap[_ordered_set__WEBPACK_IMPORTED_MODULE_0__["default"].getAt(this.set, sMin)];
        this.segmentMax = this.segmentMap[_ordered_set__WEBPACK_IMPORTED_MODULE_0__["default"].getAt(this.set, sMax)];
        this.hasNext = this.segmentMax >= this.segmentMin;
    };
    SegmentIterator.prototype.setSegment = function (segment) {
        this.setRange = _interval__WEBPACK_IMPORTED_MODULE_1__["default"].ofBounds(segment.start, segment.end);
        this.updateSegmentRange();
    };
    return SegmentIterator;
}());

function segments(segs, set, segment) {
    var int = typeof segment !== 'undefined' ? _interval__WEBPACK_IMPORTED_MODULE_1__["default"].ofBounds(segment.start, segment.end) : _interval__WEBPACK_IMPORTED_MODULE_1__["default"].ofBounds(0, _ordered_set__WEBPACK_IMPORTED_MODULE_0__["default"].size(set));
    return new SegmentIterator(segs.offsets, segs.index, set, int);
}
//# sourceMappingURL=segmentation.js.map

/***/ }),

/***/ "./lib/mol-data/int/impl/sorted-array.js":
/*!***********************************************!*\
  !*** ./lib/mol-data/int/impl/sorted-array.js ***!
  \***********************************************/
/*! exports provided: Empty, ofSingleton, ofSortedArray, ofUnsortedArray, ofRange, is, start, end, min, max, size, hashCode, toString, indexOf, indexOfInInterval, indexOfInRange, has, getAt, areEqual, findPredecessorIndex, findPredecessorIndexInInterval, findRange, areIntersecting, isSubset, union, intersectionSize, intersect, subtract, deduplicate, indicesOf */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Empty", function() { return Empty; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ofSingleton", function() { return ofSingleton; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ofSortedArray", function() { return ofSortedArray; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ofUnsortedArray", function() { return ofUnsortedArray; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ofRange", function() { return ofRange; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "is", function() { return is; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "start", function() { return start; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "end", function() { return end; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "min", function() { return min; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "max", function() { return max; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "size", function() { return size; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "hashCode", function() { return hashCode; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "toString", function() { return toString; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "indexOf", function() { return indexOf; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "indexOfInInterval", function() { return indexOfInInterval; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "indexOfInRange", function() { return indexOfInRange; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "has", function() { return has; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getAt", function() { return getAt; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "areEqual", function() { return areEqual; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "findPredecessorIndex", function() { return findPredecessorIndex; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "findPredecessorIndexInInterval", function() { return findPredecessorIndexInInterval; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "findRange", function() { return findRange; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "areIntersecting", function() { return areIntersecting; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isSubset", function() { return isSubset; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "union", function() { return union; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "intersectionSize", function() { return intersectionSize; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "intersect", function() { return intersect; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "subtract", function() { return subtract; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "deduplicate", function() { return deduplicate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "indicesOf", function() { return indicesOf; });
/* harmony import */ var _util__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../util */ "./lib/mol-data/util.js");
/* harmony import */ var _interval__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../interval */ "./lib/mol-data/int/interval.js");
/**
 * Copyright (c) 2017-2019 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author David Sehnal <david.sehnal@gmail.com>
 */


var Empty = [];
function ofSingleton(v) { return [v]; }
function ofSortedArray(xs) { return xs; }
function ofUnsortedArray(xs) { Object(_util__WEBPACK_IMPORTED_MODULE_0__["sortArray"])(xs); return xs; }
function ofRange(min, max) {
    if (max < min)
        return [];
    var ret = new Int32Array(max - min + 1);
    for (var i = min; i <= max; i++)
        ret[i - min] = i;
    return ret;
}
function is(xs) { return xs && (Array.isArray(xs) || !!xs.buffer); }
function start(xs) { return xs[0]; }
function end(xs) { return xs[xs.length - 1] + 1; }
function min(xs) { return xs[0]; }
function max(xs) { return xs[xs.length - 1]; }
function size(xs) { return xs.length; }
function hashCode(xs) {
    // hash of tuple (size, min, max, mid)
    var s = xs.length;
    if (!s)
        return 0;
    if (s > 2)
        return Object(_util__WEBPACK_IMPORTED_MODULE_0__["hash4"])(s, xs[0], xs[s - 1], xs[s >> 1]);
    return Object(_util__WEBPACK_IMPORTED_MODULE_0__["hash3"])(s, xs[0], xs[s - 1]);
}
function toString(xs) {
    var s = xs.length;
    if (s > 5)
        return "[" + xs[0] + ", " + xs[1] + ", ..., " + xs[s - 1] + "], length " + s;
    return "[" + xs.join(', ') + "]";
}
/** Returns the index of `x` in `set` or -1 if not found. */
function indexOf(xs, v) {
    var l = xs.length;
    return l === 0 ? -1 : xs[0] <= v && v <= xs[l - 1] ? binarySearchRange(xs, v, 0, l) : -1;
}
function indexOfInInterval(xs, v, bounds) {
    return indexOfInRange(xs, v, _interval__WEBPACK_IMPORTED_MODULE_1__["default"].start(bounds), _interval__WEBPACK_IMPORTED_MODULE_1__["default"].end(bounds));
}
function indexOfInRange(xs, v, s, e) {
    var l = xs.length;
    return l === 0 || e <= s ? -1 : xs[s] <= v && v <= xs[e - 1] ? binarySearchRange(xs, v, s, e) : -1;
}
function has(xs, v) { return indexOf(xs, v) >= 0; }
function getAt(xs, i) { return xs[i]; }
function areEqual(a, b) {
    if (a === b)
        return true;
    var aSize = a.length;
    if (aSize !== b.length || a[0] !== b[0] || a[aSize - 1] !== b[aSize - 1])
        return false;
    for (var i = 0; i < aSize; i++) {
        if (a[i] !== b[i])
            return false;
    }
    return true;
}
/**
 * Returns 0 if `v` is smaller or equal the first element of `xs`
 * Returns length of `xs` if `v` is bigger than the last element of `xs`
 * Otherwise returns the first index where the value of `xs` is equal or bigger than `v`
 */
function findPredecessorIndex(xs, v) {
    var len = xs.length;
    if (v <= xs[0])
        return 0;
    if (v > xs[len - 1])
        return len;
    return binarySearchPredIndexRange(xs, v, 0, len);
}
function findPredecessorIndexInInterval(xs, v, bounds) {
    var s = _interval__WEBPACK_IMPORTED_MODULE_1__["default"].start(bounds), e = _interval__WEBPACK_IMPORTED_MODULE_1__["default"].end(bounds);
    var sv = xs[s];
    if (v <= sv)
        return s;
    if (e > s && v > xs[e - 1])
        return e;
    // do a linear search if there are only 10 or less items remaining
    if (v - sv <= 11)
        return linearSearchPredInRange(xs, v, s + 1, e);
    return binarySearchPredIndexRange(xs, v, s, e);
}
function findRange(xs, min, max) {
    return _interval__WEBPACK_IMPORTED_MODULE_1__["default"].ofBounds(findPredecessorIndex(xs, min), findPredecessorIndex(xs, max + 1));
}
function binarySearchRange(xs, value, start, end) {
    var min = start, max = end - 1;
    while (min <= max) {
        // do a linear search if there are only 10 or less items remaining
        if (min + 11 > max) {
            for (var i = min; i <= max; i++) {
                if (value === xs[i])
                    return i;
            }
            return -1;
        }
        var mid = (min + max) >> 1;
        var v = xs[mid];
        if (value < v)
            max = mid - 1;
        else if (value > v)
            min = mid + 1;
        else
            return mid;
    }
    return -1;
}
function binarySearchPredIndexRange(xs, value, start, end) {
    var min = start, max = end - 1;
    while (min < max) {
        // do a linear search if there are only 10 or less items remaining
        if (min + 11 > max) {
            for (var i = min; i <= max; i++) {
                if (value <= xs[i])
                    return i;
            }
            return max + 1;
        }
        var mid = (min + max) >> 1;
        var v = xs[mid];
        if (value < v)
            max = mid - 1;
        else if (value > v)
            min = mid + 1;
        else
            return mid;
    }
    if (min > max)
        return max + 1;
    return xs[min] >= value ? min : min + 1;
}
function linearSearchPredInRange(xs, value, start, end) {
    for (var i = start; i < end; i++) {
        if (value <= xs[i])
            return i;
    }
    return end;
}
function areIntersecting(a, b) {
    if (a === b)
        return true;
    var _a = getSuitableIntersectionRange(a, b), i = _a.startI, j = _a.startJ, endI = _a.endI, endJ = _a.endJ;
    while (i < endI && j < endJ) {
        var x = a[i], y = b[j];
        if (x < y)
            i++;
        else if (x > y)
            j++;
        else
            return true;
    }
    return false;
}
function isSubset(a, b) {
    if (a === b)
        return true;
    var lenB = b.length;
    var _a = getSuitableIntersectionRange(a, b), i = _a.startI, j = _a.startJ, endI = _a.endI, endJ = _a.endJ;
    // must be able to advance by lenB elements
    if (endJ - j < lenB || endI - i < lenB)
        return false;
    var equal = 0;
    while (i < endI && j < endJ) {
        var x = a[i], y = b[j];
        if (x < y) {
            i++;
        }
        else if (x > y) {
            j++;
        }
        else {
            i++;
            j++;
            equal++;
        }
    }
    return equal === lenB;
}
function union(a, b) {
    if (a === b)
        return a;
    var lenA = a.length, lenB = b.length;
    if (lenA === 0)
        return b;
    if (lenB === 0)
        return a;
    if (a[0] > b[0])
        return union(b, a);
    var _a = getSuitableIntersectionRange(a, b), startI = _a.startI, startJ = _a.startJ, endI = _a.endI, endJ = _a.endJ;
    var commonCount = getCommonCount(a, b, startI, startJ, endI, endJ);
    // A === B || B is subset of A ==> A
    if ((commonCount === lenA && commonCount === lenB) || commonCount === lenB)
        return a;
    // A is subset of B ===> B
    if (commonCount === lenA)
        return b;
    var indices = new Int32Array(lenA + lenB - commonCount);
    var i = 0, j = 0, offset = 0;
    // insert the "prefixes"
    for (i = 0; i < startI; i++)
        indices[offset++] = a[i];
    while (j < endJ && a[startI] > b[j])
        indices[offset++] = b[j++];
    // insert the common part
    while (i < endI && j < endJ) {
        var x = a[i], y = b[j];
        if (x < y) {
            indices[offset++] = x;
            i++;
        }
        else if (x > y) {
            indices[offset++] = y;
            j++;
        }
        else {
            indices[offset++] = x;
            i++;
            j++;
        }
    }
    // insert the remaining common part
    for (; i < endI; i++)
        indices[offset++] = a[i];
    for (; j < endJ; j++)
        indices[offset++] = b[j];
    // insert the "tail"
    for (; i < lenA; i++)
        indices[offset++] = a[i];
    for (; j < lenB; j++)
        indices[offset++] = b[j];
    return ofSortedArray(indices);
}
function intersectionSize(a, b) {
    if (a === b)
        return size(a);
    var _a = getSuitableIntersectionRange(a, b), startI = _a.startI, startJ = _a.startJ, endI = _a.endI, endJ = _a.endJ;
    return getCommonCount(a, b, startI, startJ, endI, endJ);
}
function getCommonCount(a, b, startI, startJ, endI, endJ) {
    var i = startI, j = startJ;
    var commonCount = 0;
    while (i < endI && j < endJ) {
        var x = a[i], y = b[j];
        if (x < y) {
            i++;
        }
        else if (x > y) {
            j++;
        }
        else {
            i++;
            j++;
            commonCount++;
        }
    }
    return commonCount;
}
function intersect(a, b) {
    if (a === b)
        return a;
    var _a = getSuitableIntersectionRange(a, b), startI = _a.startI, startJ = _a.startJ, endI = _a.endI, endJ = _a.endJ;
    var commonCount = getCommonCount(a, b, startI, startJ, endI, endJ);
    var lenA = a.length, lenB = b.length;
    // no common elements
    if (!commonCount)
        return Empty;
    // A === B || B is subset of A ==> B
    if ((commonCount === lenA && commonCount === lenB) || commonCount === lenB)
        return b;
    // A is subset of B ==> A
    if (commonCount === lenA)
        return a;
    var indices = new Int32Array(commonCount);
    var offset = 0;
    var i = startI;
    var j = startJ;
    while (i < endI && j < endJ) {
        var x = a[i], y = b[j];
        if (x < y) {
            i++;
        }
        else if (x > y) {
            j++;
        }
        else {
            indices[offset++] = x;
            i++;
            j++;
        }
    }
    return ofSortedArray(indices);
}
function subtract(a, b) {
    if (a === b)
        return Empty;
    var lenA = a.length;
    var _a = getSuitableIntersectionRange(a, b), sI = _a.startI, sJ = _a.startJ, endI = _a.endI, endJ = _a.endJ;
    var i = sI, j = sJ;
    var commonCount = 0;
    while (i < endI && j < endJ) {
        var x = a[i], y = b[j];
        if (x < y) {
            i++;
        }
        else if (x > y) {
            j++;
        }
        else {
            i++;
            j++;
            commonCount++;
        }
    }
    // A isnt intersecting B ===> A
    if (!commonCount)
        return a;
    // A === B || A is subset of B ===> Empty
    if (commonCount >= lenA)
        return Empty;
    var indices = new Int32Array(lenA - commonCount);
    var offset = 0;
    // insert the "prefix"
    for (var k = 0; k < sI; k++)
        indices[offset++] = a[k];
    i = sI;
    j = sJ;
    while (i < endI && j < endJ) {
        var x = a[i], y = b[j];
        if (x < y) {
            indices[offset++] = x;
            i++;
        }
        else if (x > y) {
            j++;
        }
        else {
            i++;
            j++;
        }
    }
    // insert the "tail"
    for (; i < lenA; i++)
        indices[offset++] = a[i];
    return ofSortedArray(indices);
}
function deduplicate(xs) {
    if (xs.length < 2)
        return xs;
    var count = 1;
    for (var i = 0, _i = xs.length - 1; i < _i; i++) {
        if (xs[i] !== xs[i + 1])
            count++;
    }
    if (count === xs.length)
        return xs;
    var ret = new Int32Array(count);
    var o = 0;
    for (var i = 0, _i = xs.length - 1; i < _i; i++) {
        if (xs[i] !== xs[i + 1])
            ret[o++] = xs[i];
    }
    ret[o] = xs[xs.length - 1];
    return ret;
}
function indicesOf(a, b) {
    if (a === b)
        return ofSortedArray(Object(_util__WEBPACK_IMPORTED_MODULE_0__["createRangeArray"])(0, a.length - 1));
    var _a = getSuitableIntersectionRange(a, b), sI = _a.startI, sJ = _a.startJ, endI = _a.endI, endJ = _a.endJ;
    var i = sI, j = sJ;
    var commonCount = 0;
    while (i < endI && j < endJ) {
        var x = a[i], y = b[j];
        if (x < y) {
            i++;
        }
        else if (x > y) {
            j++;
        }
        else {
            i++;
            j++;
            commonCount++;
        }
    }
    var lenA = a.length;
    // no common elements
    if (!commonCount)
        return Empty;
    // A is subset of B ==> A
    if (commonCount === lenA)
        return ofSortedArray(Object(_util__WEBPACK_IMPORTED_MODULE_0__["createRangeArray"])(0, a.length - 1));
    var indices = new Int32Array(commonCount);
    var offset = 0;
    i = sI;
    j = sJ;
    while (i < endI && j < endJ) {
        var x = a[i], y = b[j];
        if (x < y) {
            i++;
        }
        else if (x > y) {
            j++;
        }
        else {
            indices[offset++] = i;
            i++;
            j++;
        }
    }
    return ofSortedArray(indices);
}
var _maxIntRangeRet = { startI: 0, startJ: 0, endI: 0, endJ: 0 };
// for small sets, just gets the whole range, for large sets does a bunch of binary searches
function getSuitableIntersectionRange(a, b) {
    var la = a.length, lb = b.length;
    var ratio = la / lb;
    if (la >= 128 || lb >= 128 || ratio <= 0.34 || ratio >= 2.99) {
        _maxIntRangeRet.startI = findPredecessorIndex(a, start(b));
        _maxIntRangeRet.startJ = findPredecessorIndex(b, start(a));
        _maxIntRangeRet.endI = findPredecessorIndex(a, end(b));
        _maxIntRangeRet.endJ = findPredecessorIndex(b, end(a));
    }
    else {
        _maxIntRangeRet.startI = 0;
        _maxIntRangeRet.startJ = 0;
        _maxIntRangeRet.endI = la;
        _maxIntRangeRet.endJ = lb;
    }
    return _maxIntRangeRet;
}
//# sourceMappingURL=sorted-array.js.map

/***/ }),

/***/ "./lib/mol-data/int/interval.js":
/*!**************************************!*\
  !*** ./lib/mol-data/int/interval.js ***!
  \**************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _impl_interval__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./impl/interval */ "./lib/mol-data/int/impl/interval.js");
/**
 * Copyright (c) 2017 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author David Sehnal <david.sehnal@gmail.com>
 */

var Interval;
(function (Interval) {
    Interval.Empty = _impl_interval__WEBPACK_IMPORTED_MODULE_0__["Empty"];
    Interval.ofSingleton = function (v) { return _impl_interval__WEBPACK_IMPORTED_MODULE_0__["ofRange"](v, v); };
    /** Create interval from range [min, max] */
    Interval.ofRange = _impl_interval__WEBPACK_IMPORTED_MODULE_0__["ofRange"];
    /** Create interval from bounds [start, end), i.e. [start, end - 1] */
    Interval.ofBounds = _impl_interval__WEBPACK_IMPORTED_MODULE_0__["ofBounds"];
    /** Create interval from length [0, length), i.e. [0, length - 1] */
    Interval.ofLength = _impl_interval__WEBPACK_IMPORTED_MODULE_0__["ofLength"];
    Interval.is = _impl_interval__WEBPACK_IMPORTED_MODULE_0__["is"];
    /** Test if a value is within the bounds of the interval */
    Interval.has = _impl_interval__WEBPACK_IMPORTED_MODULE_0__["has"];
    /** Returns the index of `x` in `set` or -1 if not found. */
    Interval.indexOf = _impl_interval__WEBPACK_IMPORTED_MODULE_0__["indexOf"];
    Interval.getAt = _impl_interval__WEBPACK_IMPORTED_MODULE_0__["getAt"];
    /** Start value of the Interval<T>, same as min value */
    Interval.start = _impl_interval__WEBPACK_IMPORTED_MODULE_0__["start"];
    /** End value of the Interval<T>, same as max + 1 */
    Interval.end = _impl_interval__WEBPACK_IMPORTED_MODULE_0__["end"];
    /** Min value of the Interval<T>, same as start value */
    Interval.min = _impl_interval__WEBPACK_IMPORTED_MODULE_0__["min"];
    /** Max value of the Interval<T>, same as end - 1 */
    Interval.max = _impl_interval__WEBPACK_IMPORTED_MODULE_0__["max"];
    /** Number of values in the interval */
    Interval.size = _impl_interval__WEBPACK_IMPORTED_MODULE_0__["size"];
    /** Hash code describing the interval */
    Interval.hashCode = _impl_interval__WEBPACK_IMPORTED_MODULE_0__["hashCode"];
    /** String representation of the interval */
    Interval.toString = _impl_interval__WEBPACK_IMPORTED_MODULE_0__["toString"];
    /** Test if two intervals are identical */
    Interval.areEqual = _impl_interval__WEBPACK_IMPORTED_MODULE_0__["areEqual"];
    /** Test if two intervals are intersecting, i.e. their bounds overlap */
    Interval.areIntersecting = _impl_interval__WEBPACK_IMPORTED_MODULE_0__["areIntersecting"];
    /** Test if interval b is fully included in interval a */
    Interval.isSubInterval = _impl_interval__WEBPACK_IMPORTED_MODULE_0__["isSubInterval"];
    Interval.findPredecessorIndex = _impl_interval__WEBPACK_IMPORTED_MODULE_0__["findPredecessorIndex"];
    Interval.findPredecessorIndexInInterval = _impl_interval__WEBPACK_IMPORTED_MODULE_0__["findPredecessorIndexInInterval"];
    Interval.findRange = _impl_interval__WEBPACK_IMPORTED_MODULE_0__["findRange"];
    /** Size of the intersection of the two intervals */
    Interval.intersectionSize = _impl_interval__WEBPACK_IMPORTED_MODULE_0__["intersectionSize"];
    /** Get a new interval that is the intersection of the two intervals */
    Interval.intersect = _impl_interval__WEBPACK_IMPORTED_MODULE_0__["intersect"];
})(Interval || (Interval = {}));
/* harmony default export */ __webpack_exports__["default"] = (Interval);
//# sourceMappingURL=interval.js.map

/***/ }),

/***/ "./lib/mol-data/int/linked-index.js":
/*!******************************************!*\
  !*** ./lib/mol-data/int/linked-index.js ***!
  \******************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/**
 * Copyright (c) 2017 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author David Sehnal <david.sehnal@gmail.com>
 */
function LinkedIndex(size) {
    return new LinkedIndexImpl(size);
}
var LinkedIndexImpl = /** @class */ (function () {
    function LinkedIndexImpl(size) {
        this.head = size > 0 ? 0 : -1;
        this.prev = new Int32Array(size);
        this.next = new Int32Array(size);
        for (var i = 0; i < size; i++) {
            this.next[i] = i + 1;
            this.prev[i] = i - 1;
        }
        this.prev[0] = -1;
        this.next[size - 1] = -1;
    }
    LinkedIndexImpl.prototype.remove = function (i) {
        var _a = this, prev = _a.prev, next = _a.next;
        var p = prev[i], n = next[i];
        if (p >= 0) {
            next[p] = n;
            prev[i] = -1;
        }
        if (n >= 0) {
            prev[n] = p;
            next[i] = -1;
        }
        if (i === this.head) {
            if (p < 0)
                this.head = n;
            else
                this.head = p;
        }
    };
    LinkedIndexImpl.prototype.has = function (i) {
        return this.prev[i] >= 0 || this.next[i] >= 0 || this.head === i;
    };
    return LinkedIndexImpl;
}());
/* harmony default export */ __webpack_exports__["default"] = (LinkedIndex);
//# sourceMappingURL=linked-index.js.map

/***/ }),

/***/ "./lib/mol-data/int/map.js":
/*!*********************************!*\
  !*** ./lib/mol-data/int/map.js ***!
  \*********************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _util__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../util */ "./lib/mol-data/util.js");
/**
 * Copyright (c) 2017 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author David Sehnal <david.sehnal@gmail.com>
 */

var IntMap;
(function (IntMap) {
    IntMap.Empty = new Map();
    function keyArray(map) {
        return Object(_util__WEBPACK_IMPORTED_MODULE_0__["iterableToArray"])(map.keys());
    }
    IntMap.keyArray = keyArray;
    function Mutable() {
        return new Map();
    }
    IntMap.Mutable = Mutable;
    function asImmutable(map) {
        return map;
    }
    IntMap.asImmutable = asImmutable;
    function copy(map) {
        var ret = Mutable();
        var it = map.keys();
        while (true) {
            var _a = it.next(), done = _a.done, value = _a.value;
            if (done)
                break;
            ret.set(value, map.get(value));
        }
        return ret;
    }
    IntMap.copy = copy;
    function addFrom(map, src) {
        var it = src.keys();
        while (true) {
            var _a = it.next(), done = _a.done, value = _a.value;
            if (done)
                break;
            map.set(value, src.get(value));
        }
        return map;
    }
    IntMap.addFrom = addFrom;
})(IntMap || (IntMap = {}));
/* harmony default export */ __webpack_exports__["default"] = (IntMap);
//# sourceMappingURL=map.js.map

/***/ }),

/***/ "./lib/mol-data/int/ordered-set.js":
/*!*****************************************!*\
  !*** ./lib/mol-data/int/ordered-set.js ***!
  \*****************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _impl_ordered_set__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./impl/ordered-set */ "./lib/mol-data/int/impl/ordered-set.js");
/* harmony import */ var _interval__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./interval */ "./lib/mol-data/int/interval.js");
/**
 * Copyright (c) 2017-2019 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author David Sehnal <david.sehnal@gmail.com>
 */


var OrderedSet;
(function (OrderedSet) {
    OrderedSet.Empty = _impl_ordered_set__WEBPACK_IMPORTED_MODULE_0__["Empty"];
    OrderedSet.ofSingleton = _impl_ordered_set__WEBPACK_IMPORTED_MODULE_0__["ofSingleton"];
    /** Create interval from range [min, max] */
    OrderedSet.ofRange = _impl_ordered_set__WEBPACK_IMPORTED_MODULE_0__["ofRange"];
    /** Create interval from bounds [start, end), i.e. [start, end - 1] */
    OrderedSet.ofBounds = _impl_ordered_set__WEBPACK_IMPORTED_MODULE_0__["ofBounds"];
    /** It is the responsibility of the caller to ensure the array is sorted and contains unique values. */
    OrderedSet.ofSortedArray = _impl_ordered_set__WEBPACK_IMPORTED_MODULE_0__["ofSortedArray"];
    OrderedSet.has = _impl_ordered_set__WEBPACK_IMPORTED_MODULE_0__["has"];
    /** Returns the index of `x` in `set` or -1 if not found. */
    OrderedSet.indexOf = _impl_ordered_set__WEBPACK_IMPORTED_MODULE_0__["indexOf"];
    /** Returns the value in `set` at index `i`. */
    OrderedSet.getAt = _impl_ordered_set__WEBPACK_IMPORTED_MODULE_0__["getAt"];
    OrderedSet.min = _impl_ordered_set__WEBPACK_IMPORTED_MODULE_0__["min"];
    OrderedSet.max = _impl_ordered_set__WEBPACK_IMPORTED_MODULE_0__["max"];
    OrderedSet.start = _impl_ordered_set__WEBPACK_IMPORTED_MODULE_0__["start"];
    OrderedSet.end = _impl_ordered_set__WEBPACK_IMPORTED_MODULE_0__["end"];
    /** Number of elements in the OrderedSet */
    OrderedSet.size = _impl_ordered_set__WEBPACK_IMPORTED_MODULE_0__["size"];
    OrderedSet.hashCode = _impl_ordered_set__WEBPACK_IMPORTED_MODULE_0__["hashCode"];
    OrderedSet.areEqual = _impl_ordered_set__WEBPACK_IMPORTED_MODULE_0__["areEqual"];
    OrderedSet.areIntersecting = _impl_ordered_set__WEBPACK_IMPORTED_MODULE_0__["areIntersecting"];
    /** Check if the 2nd argument is a subset of the 1st */
    OrderedSet.isSubset = _impl_ordered_set__WEBPACK_IMPORTED_MODULE_0__["isSubset"];
    OrderedSet.union = _impl_ordered_set__WEBPACK_IMPORTED_MODULE_0__["union"];
    OrderedSet.intersect = _impl_ordered_set__WEBPACK_IMPORTED_MODULE_0__["intersect"];
    OrderedSet.indexedIntersect = _impl_ordered_set__WEBPACK_IMPORTED_MODULE_0__["indexedIntersect"];
    /** Returns elements of `a` that are not in `b`, i.e `a` - `b` */
    OrderedSet.subtract = _impl_ordered_set__WEBPACK_IMPORTED_MODULE_0__["subtract"];
    /**
     * Returns 0 if `x` is smaller or equal the first element of `set`
     * Returns length of `set` if `x` is bigger than the last element of `set`
     * Otherwise returns the first index where the value of `set` is equal or bigger than `x`
     */
    OrderedSet.findPredecessorIndex = _impl_ordered_set__WEBPACK_IMPORTED_MODULE_0__["findPredecessorIndex"];
    OrderedSet.findPredecessorIndexInInterval = _impl_ordered_set__WEBPACK_IMPORTED_MODULE_0__["findPredecessorIndexInInterval"];
    OrderedSet.findRange = _impl_ordered_set__WEBPACK_IMPORTED_MODULE_0__["findRange"];
    OrderedSet.intersectionSize = _impl_ordered_set__WEBPACK_IMPORTED_MODULE_0__["intersectionSize"];
    function forEach(set, f, ctx) {
        return _impl_ordered_set__WEBPACK_IMPORTED_MODULE_0__["forEach"](set, f, ctx);
    }
    OrderedSet.forEach = forEach;
    function forEachSegment(set, segment, f, ctx) {
        return _impl_ordered_set__WEBPACK_IMPORTED_MODULE_0__["forEachSegment"](set, segment, f, ctx);
    }
    OrderedSet.forEachSegment = forEachSegment;
    function isInterval(set) {
        return _interval__WEBPACK_IMPORTED_MODULE_1__["default"].is(set);
    }
    OrderedSet.isInterval = isInterval;
    function isSortedArray(set) {
        return !_interval__WEBPACK_IMPORTED_MODULE_1__["default"].is(set);
    }
    OrderedSet.isSortedArray = isSortedArray;
    function toArray(set) {
        var array = [];
        OrderedSet.forEach(set, function (v) { return array.push(v); });
        return array;
    }
    OrderedSet.toArray = toArray;
    function toString(set) {
        return _impl_ordered_set__WEBPACK_IMPORTED_MODULE_0__["toString"](set);
    }
    OrderedSet.toString = toString;
})(OrderedSet || (OrderedSet = {}));
/* harmony default export */ __webpack_exports__["default"] = (OrderedSet);
//# sourceMappingURL=ordered-set.js.map

/***/ }),

/***/ "./lib/mol-data/int/segmentation.js":
/*!******************************************!*\
  !*** ./lib/mol-data/int/segmentation.js ***!
  \******************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _impl_segmentation__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./impl/segmentation */ "./lib/mol-data/int/impl/segmentation.js");
/**
 * Copyright (c) 2017 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author David Sehnal <david.sehnal@gmail.com>
 */

var Segmentation;
(function (Segmentation) {
    Segmentation.create = _impl_segmentation__WEBPACK_IMPORTED_MODULE_0__["create"];
    Segmentation.ofOffsets = _impl_segmentation__WEBPACK_IMPORTED_MODULE_0__["ofOffsets"];
    Segmentation.count = _impl_segmentation__WEBPACK_IMPORTED_MODULE_0__["count"];
    Segmentation.getSegment = _impl_segmentation__WEBPACK_IMPORTED_MODULE_0__["getSegment"];
    Segmentation.projectValue = _impl_segmentation__WEBPACK_IMPORTED_MODULE_0__["projectValue"];
    /** Segment iterator that mutates a single segment object to mark all the segments. */
    Segmentation.transientSegments = _impl_segmentation__WEBPACK_IMPORTED_MODULE_0__["segments"];
})(Segmentation || (Segmentation = {}));
/* harmony default export */ __webpack_exports__["default"] = (Segmentation);
//# sourceMappingURL=segmentation.js.map

/***/ }),

/***/ "./lib/mol-data/int/sorted-array.js":
/*!******************************************!*\
  !*** ./lib/mol-data/int/sorted-array.js ***!
  \******************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _impl_sorted_array__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./impl/sorted-array */ "./lib/mol-data/int/impl/sorted-array.js");
/**
 * Copyright (c) 2017-2019 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author David Sehnal <david.sehnal@gmail.com>
 */

var SortedArray;
(function (SortedArray) {
    SortedArray.Empty = _impl_sorted_array__WEBPACK_IMPORTED_MODULE_0__["Empty"];
    SortedArray.ofUnsortedArray = _impl_sorted_array__WEBPACK_IMPORTED_MODULE_0__["ofUnsortedArray"];
    SortedArray.ofSingleton = _impl_sorted_array__WEBPACK_IMPORTED_MODULE_0__["ofSingleton"];
    SortedArray.ofSortedArray = _impl_sorted_array__WEBPACK_IMPORTED_MODULE_0__["ofSortedArray"];
    /** create sorted array [min, max] (it DOES contain the max value) */
    SortedArray.ofRange = _impl_sorted_array__WEBPACK_IMPORTED_MODULE_0__["ofRange"];
    /** create sorted array [min, max) (it does NOT contain the max value) */
    SortedArray.ofBounds = function (min, max) { return _impl_sorted_array__WEBPACK_IMPORTED_MODULE_0__["ofRange"](min, max - 1); };
    SortedArray.is = _impl_sorted_array__WEBPACK_IMPORTED_MODULE_0__["is"];
    SortedArray.has = _impl_sorted_array__WEBPACK_IMPORTED_MODULE_0__["has"];
    /** Returns the index of `x` in `set` or -1 if not found. */
    SortedArray.indexOf = _impl_sorted_array__WEBPACK_IMPORTED_MODULE_0__["indexOf"];
    SortedArray.indexOfInInterval = _impl_sorted_array__WEBPACK_IMPORTED_MODULE_0__["indexOfInInterval"];
    SortedArray.indexOfInRange = _impl_sorted_array__WEBPACK_IMPORTED_MODULE_0__["indexOfInRange"];
    /** Returns `array[0]` */
    SortedArray.start = _impl_sorted_array__WEBPACK_IMPORTED_MODULE_0__["start"];
    /** Returns `array[array.length - 1] + 1` */
    SortedArray.end = _impl_sorted_array__WEBPACK_IMPORTED_MODULE_0__["end"];
    SortedArray.min = _impl_sorted_array__WEBPACK_IMPORTED_MODULE_0__["min"];
    SortedArray.max = _impl_sorted_array__WEBPACK_IMPORTED_MODULE_0__["max"];
    SortedArray.size = _impl_sorted_array__WEBPACK_IMPORTED_MODULE_0__["size"];
    SortedArray.hashCode = _impl_sorted_array__WEBPACK_IMPORTED_MODULE_0__["hashCode"];
    SortedArray.toString = _impl_sorted_array__WEBPACK_IMPORTED_MODULE_0__["toString"];
    SortedArray.areEqual = _impl_sorted_array__WEBPACK_IMPORTED_MODULE_0__["areEqual"];
    SortedArray.areIntersecting = _impl_sorted_array__WEBPACK_IMPORTED_MODULE_0__["areIntersecting"];
    SortedArray.isSubset = _impl_sorted_array__WEBPACK_IMPORTED_MODULE_0__["isSubset"];
    SortedArray.union = _impl_sorted_array__WEBPACK_IMPORTED_MODULE_0__["union"];
    SortedArray.intersect = _impl_sorted_array__WEBPACK_IMPORTED_MODULE_0__["intersect"];
    SortedArray.subtract = _impl_sorted_array__WEBPACK_IMPORTED_MODULE_0__["subtract"];
    SortedArray.findPredecessorIndex = _impl_sorted_array__WEBPACK_IMPORTED_MODULE_0__["findPredecessorIndex"];
    SortedArray.findPredecessorIndexInInterval = _impl_sorted_array__WEBPACK_IMPORTED_MODULE_0__["findPredecessorIndexInInterval"];
    SortedArray.findRange = _impl_sorted_array__WEBPACK_IMPORTED_MODULE_0__["findRange"];
    SortedArray.intersectionSize = _impl_sorted_array__WEBPACK_IMPORTED_MODULE_0__["intersectionSize"];
    SortedArray.deduplicate = _impl_sorted_array__WEBPACK_IMPORTED_MODULE_0__["deduplicate"];
    /** Returns indices of xs in the array. E.g. indicesOf([10, 11, 12], [10, 12]) ==> [0, 2] */
    SortedArray.indicesOf = _impl_sorted_array__WEBPACK_IMPORTED_MODULE_0__["indicesOf"];
})(SortedArray || (SortedArray = {}));
/* harmony default export */ __webpack_exports__["default"] = (SortedArray);
//# sourceMappingURL=sorted-array.js.map

/***/ }),

/***/ "./lib/mol-data/int/sorted-ranges.js":
/*!*******************************************!*\
  !*** ./lib/mol-data/int/sorted-ranges.js ***!
  \*******************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _int__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../int */ "./lib/mol-data/int.js");
/**
 * Copyright (c) 2018-2019 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */

var SortedRanges;
(function (SortedRanges) {
    function ofSortedRanges(array) { return _int__WEBPACK_IMPORTED_MODULE_0__["SortedArray"].ofSortedArray(array); }
    SortedRanges.ofSortedRanges = ofSortedRanges;
    function start(ranges) { return ranges[0]; }
    SortedRanges.start = start;
    function end(ranges) { return ranges[ranges.length - 1] + 1; }
    SortedRanges.end = end;
    function min(ranges) { return ranges[0]; }
    SortedRanges.min = min;
    function max(ranges) { return ranges[ranges.length - 1]; }
    SortedRanges.max = max;
    function size(ranges) {
        var size = 0;
        for (var i = 0, il = ranges.length; i < il; i += 2) {
            size += ranges[i + 1] - ranges[i] + 1;
        }
        return size;
    }
    SortedRanges.size = size;
    function count(ranges) { return ranges.length / 2; }
    SortedRanges.count = count;
    function startAt(ranges, index) {
        return ranges[index * 2];
    }
    SortedRanges.startAt = startAt;
    function endAt(ranges, index) {
        return ranges[index * 2 + 1] + 1;
    }
    SortedRanges.endAt = endAt;
    function minAt(ranges, index) {
        return ranges[index * 2];
    }
    SortedRanges.minAt = minAt;
    function maxAt(ranges, index) {
        return ranges[index * 2 + 1];
    }
    SortedRanges.maxAt = maxAt;
    function areEqual(a, b) {
        if (a.length !== b.length)
            return false;
        for (var i = 0, il = a.length; i < il; ++i) {
            if (a[i] !== b[i])
                return false;
        }
        return true;
    }
    SortedRanges.areEqual = areEqual;
    function forEach(ranges, f) {
        var k = 0;
        for (var i = 0, il = ranges.length; i < il; i += 2) {
            for (var j = ranges[i], jl = ranges[i + 1]; j <= jl; ++j) {
                f(j, k);
                ++k;
            }
        }
    }
    SortedRanges.forEach = forEach;
    /** Returns if a value of `set` is included in `ranges` */
    function has(ranges, set) {
        return firstIntersectionIndex(ranges, set) !== -1;
    }
    SortedRanges.has = has;
    /** Returns if a value of `set` is included in `ranges` from given index */
    function hasFrom(ranges, set, from) {
        return firstIntersectionIndexFrom(ranges, set, from) !== -1;
    }
    SortedRanges.hasFrom = hasFrom;
    function firstIntersectionIndex(ranges, set) {
        return firstIntersectionIndexFrom(ranges, set, 0);
    }
    SortedRanges.firstIntersectionIndex = firstIntersectionIndex;
    function firstIntersectionIndexFrom(ranges, set, from) {
        if (minAt(ranges, from) > _int__WEBPACK_IMPORTED_MODULE_0__["OrderedSet"].max(set) || max(ranges) < _int__WEBPACK_IMPORTED_MODULE_0__["OrderedSet"].min(set))
            return -1;
        for (var i = from, il = count(ranges); i < il; ++i) {
            var interval = _int__WEBPACK_IMPORTED_MODULE_0__["Interval"].ofRange(minAt(ranges, i), maxAt(ranges, i));
            if (_int__WEBPACK_IMPORTED_MODULE_0__["OrderedSet"].areIntersecting(interval, set))
                return i;
        }
        return -1;
    }
    SortedRanges.firstIntersectionIndexFrom = firstIntersectionIndexFrom;
    function transientSegments(ranges, set) {
        return new Iterator(ranges, set);
    }
    SortedRanges.transientSegments = transientSegments;
    var Iterator = /** @class */ (function () {
        function Iterator(ranges, set) {
            this.ranges = ranges;
            this.set = set;
            this.value = { index: 0, start: 0, end: 0 };
            this.curIndex = 0;
            this.hasNext = false;
            this.curIndex = firstIntersectionIndex(ranges, set);
            this.hasNext = this.curIndex !== -1;
        }
        Iterator.prototype.updateValue = function () {
            this.value.index = this.curIndex;
            this.value.start = _int__WEBPACK_IMPORTED_MODULE_0__["OrderedSet"].findPredecessorIndex(this.set, startAt(this.ranges, this.curIndex));
            this.value.end = _int__WEBPACK_IMPORTED_MODULE_0__["OrderedSet"].findPredecessorIndex(this.set, endAt(this.ranges, this.curIndex));
        };
        Iterator.prototype.move = function () {
            if (this.hasNext) {
                this.updateValue();
                this.curIndex = firstIntersectionIndexFrom(this.ranges, this.set, this.curIndex + 1);
                this.hasNext = this.curIndex !== -1;
            }
            return this.value;
        };
        return Iterator;
    }());
    SortedRanges.Iterator = Iterator;
})(SortedRanges || (SortedRanges = {}));
/* harmony default export */ __webpack_exports__["default"] = (SortedRanges);
//# sourceMappingURL=sorted-ranges.js.map

/***/ }),

/***/ "./lib/mol-data/int/tuple.js":
/*!***********************************!*\
  !*** ./lib/mol-data/int/tuple.js ***!
  \***********************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _util__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../util */ "./lib/mol-data/util.js");
/**
 * Copyright (c) 2017-2019 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author David Sehnal <david.sehnal@gmail.com>
 */

var IntTuple;
(function (IntTuple) {
    IntTuple.Zero = 0;
    var _a = (function () {
        var data = new ArrayBuffer(8);
        var data_1 = new ArrayBuffer(8);
        return {
            _int32: new Int32Array(data),
            _float64: new Float64Array(data),
            _int32_1: new Int32Array(data_1),
            _float64_1: new Float64Array(data_1)
        };
    }()), _int32 = _a._int32, _float64 = _a._float64, _int32_1 = _a._int32_1, _float64_1 = _a._float64_1;
    function is(x) {
        return typeof x === 'number';
    }
    IntTuple.is = is;
    function create(fst, snd) {
        _int32[0] = fst;
        _int32[1] = snd;
        return _float64[0];
    }
    IntTuple.create = create;
    function fst(t) {
        _float64[0] = t;
        return _int32[0];
    }
    IntTuple.fst = fst;
    function snd(t) {
        _float64[0] = t;
        return _int32[1];
    }
    IntTuple.snd = snd;
    /** Normal equality does not work, because NaN === NaN ~> false */
    function areEqual(a, b) {
        _float64[0] = a;
        _float64_1[0] = b;
        return _int32[0] === _int32_1[0] && _int32[1] === _int32_1[1];
    }
    IntTuple.areEqual = areEqual;
    function compare(a, b) {
        _float64[0] = a;
        _float64_1[0] = b;
        var x = _int32[0] - _int32_1[0];
        if (x !== 0)
            return x;
        return _int32[1] - _int32_1[1];
    }
    IntTuple.compare = compare;
    function compareInArray(xs, i, j) {
        _float64[0] = xs[i];
        _float64_1[0] = xs[j];
        var x = _int32[0] - _int32_1[0];
        if (x !== 0)
            return x;
        return _int32[1] - _int32_1[1];
    }
    IntTuple.compareInArray = compareInArray;
    function hashCode(t) {
        _float64[0] = t;
        return Object(_util__WEBPACK_IMPORTED_MODULE_0__["hash2"])(_int32[0], _int32[1]);
    }
    IntTuple.hashCode = hashCode;
    function toString(t) {
        _float64[0] = t;
        return "(" + _int32[0] + ", " + _int32[1] + ")";
    }
    IntTuple.toString = toString;
})(IntTuple || (IntTuple = {}));
/* harmony default export */ __webpack_exports__["default"] = (IntTuple);
//# sourceMappingURL=tuple.js.map

/***/ }),

/***/ "./lib/mol-data/iterator.js":
/*!**********************************!*\
  !*** ./lib/mol-data/iterator.js ***!
  \**********************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/**
 * Copyright (c) 2017 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author David Sehnal <david.sehnal@gmail.com>
 */
var ArrayIteratorImpl = /** @class */ (function () {
    function ArrayIteratorImpl(xs) {
        this.xs = [];
        this.index = -1;
        this.length = 0;
        this.hasNext = false;
        this.length = xs.length;
        this.hasNext = xs.length > 0;
        this.xs = xs;
        this.index = -1;
        // try to avoid deoptimization with undefined values
        this.lastValue = xs.length > 0 ? xs[0] : void 0;
    }
    ArrayIteratorImpl.prototype.move = function () {
        ++this.index;
        this.lastValue = this.xs[this.index];
        this.hasNext = this.index < this.length - 1;
        return this.lastValue;
    };
    return ArrayIteratorImpl;
}());
var RangeIteratorImpl = /** @class */ (function () {
    function RangeIteratorImpl(min, max) {
        this.max = max;
        this.value = 0;
        this.hasNext = false;
        this.value = min - 1;
        this.hasNext = max >= min;
    }
    RangeIteratorImpl.prototype.move = function () {
        ++this.value;
        this.hasNext = this.value < this.max;
        return this.value;
    };
    return RangeIteratorImpl;
}());
var ValueIterator = /** @class */ (function () {
    function ValueIterator(value) {
        this.value = value;
        this.hasNext = true;
    }
    ValueIterator.prototype.move = function () { this.hasNext = false; return this.value; };
    return ValueIterator;
}());
var MapIteratorImpl = /** @class */ (function () {
    function MapIteratorImpl(base, f) {
        this.base = base;
        this.f = f;
        this.hasNext = false;
        this.hasNext = base.hasNext;
    }
    MapIteratorImpl.prototype.move = function () {
        var v = this.f(this.base.move());
        this.hasNext = this.base.hasNext;
        return v;
    };
    return MapIteratorImpl;
}());
var FilterIteratorImpl = /** @class */ (function () {
    function FilterIteratorImpl(base, p) {
        this.base = base;
        this.p = p;
        this.hasNext = this.findNext();
    }
    FilterIteratorImpl.prototype.move = function () {
        var ret = this.next;
        this.hasNext = this.findNext();
        return ret;
    };
    FilterIteratorImpl.prototype.findNext = function () {
        while (this.base.hasNext) {
            this.next = this.base.move();
            if (this.p(this.next))
                return true;
        }
        return false;
    };
    return FilterIteratorImpl;
}());
var Iterator;
(function (Iterator) {
    Iterator.Empty = new RangeIteratorImpl(0, -1);
    function Array(xs) { return new ArrayIteratorImpl(xs); }
    Iterator.Array = Array;
    function Value(value) { return new ValueIterator(value); }
    Iterator.Value = Value;
    function Range(min, max) { return new RangeIteratorImpl(min, max); }
    Iterator.Range = Range;
    function map(base, f) { return new MapIteratorImpl(base, f); }
    Iterator.map = map;
    function filter(base, p) { return new FilterIteratorImpl(base, p); }
    Iterator.filter = filter;
    // Iterate until first truthy value is returned.
    function forEach(it, f, ctx) {
        while (it.hasNext) {
            var c = f(it.move(), ctx);
            if (c)
                return ctx;
        }
        return ctx;
    }
    Iterator.forEach = forEach;
})(Iterator || (Iterator = {}));
/* harmony default export */ __webpack_exports__["default"] = (Iterator);
//# sourceMappingURL=iterator.js.map

/***/ }),

/***/ "./lib/mol-data/util.js":
/*!******************************!*\
  !*** ./lib/mol-data/util.js ***!
  \******************************/
/*! exports provided: ChunkedArray, makeBuckets, EquivalenceClassesImpl, EquivalenceClasses, hash1, hash2, hash3, hash4, hashString, cantorPairing, sortedCantorPairing, hashFnv32a, arrayLess, arraySwap, sortArray, sortArrayRange, sort, Grouper, groupBy, arrayFind, iterableToArray, createRangeArray, arrayPickIndices, arrayGetCtor */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _util_chunked_array__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./util/chunked-array */ "./lib/mol-data/util/chunked-array.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ChunkedArray", function() { return _util_chunked_array__WEBPACK_IMPORTED_MODULE_0__["ChunkedArray"]; });

/* harmony import */ var _util_buckets__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./util/buckets */ "./lib/mol-data/util/buckets.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "makeBuckets", function() { return _util_buckets__WEBPACK_IMPORTED_MODULE_1__["makeBuckets"]; });

/* harmony import */ var _util_equivalence_classes__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./util/equivalence-classes */ "./lib/mol-data/util/equivalence-classes.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "EquivalenceClassesImpl", function() { return _util_equivalence_classes__WEBPACK_IMPORTED_MODULE_2__["EquivalenceClassesImpl"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "EquivalenceClasses", function() { return _util_equivalence_classes__WEBPACK_IMPORTED_MODULE_2__["EquivalenceClasses"]; });

/* harmony import */ var _util_hash_functions__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./util/hash-functions */ "./lib/mol-data/util/hash-functions.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "hash1", function() { return _util_hash_functions__WEBPACK_IMPORTED_MODULE_3__["hash1"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "hash2", function() { return _util_hash_functions__WEBPACK_IMPORTED_MODULE_3__["hash2"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "hash3", function() { return _util_hash_functions__WEBPACK_IMPORTED_MODULE_3__["hash3"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "hash4", function() { return _util_hash_functions__WEBPACK_IMPORTED_MODULE_3__["hash4"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "hashString", function() { return _util_hash_functions__WEBPACK_IMPORTED_MODULE_3__["hashString"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "cantorPairing", function() { return _util_hash_functions__WEBPACK_IMPORTED_MODULE_3__["cantorPairing"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "sortedCantorPairing", function() { return _util_hash_functions__WEBPACK_IMPORTED_MODULE_3__["sortedCantorPairing"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "hashFnv32a", function() { return _util_hash_functions__WEBPACK_IMPORTED_MODULE_3__["hashFnv32a"]; });

/* harmony import */ var _util_sort__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./util/sort */ "./lib/mol-data/util/sort.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "arrayLess", function() { return _util_sort__WEBPACK_IMPORTED_MODULE_4__["arrayLess"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "arraySwap", function() { return _util_sort__WEBPACK_IMPORTED_MODULE_4__["arraySwap"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "sortArray", function() { return _util_sort__WEBPACK_IMPORTED_MODULE_4__["sortArray"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "sortArrayRange", function() { return _util_sort__WEBPACK_IMPORTED_MODULE_4__["sortArrayRange"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "sort", function() { return _util_sort__WEBPACK_IMPORTED_MODULE_4__["sort"]; });

/* harmony import */ var _util_grouping__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./util/grouping */ "./lib/mol-data/util/grouping.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Grouper", function() { return _util_grouping__WEBPACK_IMPORTED_MODULE_5__["Grouper"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "groupBy", function() { return _util_grouping__WEBPACK_IMPORTED_MODULE_5__["groupBy"]; });

/* harmony import */ var _util_array__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ./util/array */ "./lib/mol-data/util/array.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "arrayFind", function() { return _util_array__WEBPACK_IMPORTED_MODULE_6__["arrayFind"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "iterableToArray", function() { return _util_array__WEBPACK_IMPORTED_MODULE_6__["iterableToArray"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "createRangeArray", function() { return _util_array__WEBPACK_IMPORTED_MODULE_6__["createRangeArray"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "arrayPickIndices", function() { return _util_array__WEBPACK_IMPORTED_MODULE_6__["arrayPickIndices"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "arrayGetCtor", function() { return _util_array__WEBPACK_IMPORTED_MODULE_6__["arrayGetCtor"]; });

/**
 * Copyright (c) 2017 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author David Sehnal <david.sehnal@gmail.com>
 */







//# sourceMappingURL=util.js.map

/***/ }),

/***/ "./lib/mol-data/util/array.js":
/*!************************************!*\
  !*** ./lib/mol-data/util/array.js ***!
  \************************************/
/*! exports provided: arrayFind, iterableToArray, createRangeArray, arrayPickIndices, arrayGetCtor */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "arrayFind", function() { return arrayFind; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "iterableToArray", function() { return iterableToArray; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createRangeArray", function() { return createRangeArray; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "arrayPickIndices", function() { return arrayPickIndices; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "arrayGetCtor", function() { return arrayGetCtor; });
/**
 * Copyright (c) 2017 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * from https://github.com/dsehnal/CIFTools.js
 * @author David Sehnal <david.sehnal@gmail.com>
 */
function arrayFind(array, f) {
    for (var i = 0, _i = array.length; i < _i; i++) {
        if (f(array[i]))
            return array[i];
    }
    return void 0;
}
function iterableToArray(it) {
    if (Array.from)
        return Array.from(it);
    var ret = [];
    while (true) {
        var _a = it.next(), done = _a.done, value = _a.value;
        if (done)
            break;
        ret[ret.length] = value;
    }
    return ret;
}
/** Fills the array so that array[0] = start and array[array.length - 1] = end */
function createRangeArray(start, end, ctor) {
    var len = end - start + 1;
    var array = ctor ? new ctor(len) : new Int32Array(len);
    for (var i = 0; i < len; i++) {
        array[i] = i + start;
    }
    return array;
}
function arrayPickIndices(array, indices) {
    var ret = new (arrayGetCtor(array))(indices.length);
    for (var i = 0, _i = indices.length; i < _i; i++) {
        ret[i] = array[indices[i]];
    }
    return ret;
}
function arrayGetCtor(data) {
    var ret = data.constructor;
    if (!ret)
        throw new Error('data does not define a constructor and it should');
    return ret;
}
//# sourceMappingURL=array.js.map

/***/ }),

/***/ "./lib/mol-data/util/buckets.js":
/*!**************************************!*\
  !*** ./lib/mol-data/util/buckets.js ***!
  \**************************************/
/*! exports provided: makeBuckets */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "makeBuckets", function() { return makeBuckets; });
/* harmony import */ var _sort__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./sort */ "./lib/mol-data/util/sort.js");
/**
 * Copyright (c) 2018 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author David Sehnal <david.sehnal@gmail.com>
 */

function sortAsc(bs, i, j) { return bs[i].key < bs[j].key ? -1 : 1; }
function _makeBuckets(indices, getKey, sortBuckets, start, end) {
    var buckets = new Map();
    var bucketList = [];
    var prevKey = getKey(indices[0]);
    var isBucketed = true;
    for (var i = start; i < end; i++) {
        var key = getKey(indices[i]);
        if (buckets.has(key)) {
            buckets.get(key).count++;
            if (prevKey !== key)
                isBucketed = false;
        }
        else {
            var bucket = { key: key, count: 1, offset: i };
            buckets.set(key, bucket);
            bucketList[bucketList.length] = bucket;
        }
        prevKey = key;
    }
    var bucketOffsets = new Int32Array(bucketList.length + 1);
    bucketOffsets[bucketList.length] = end;
    var sorted = true;
    if (sortBuckets) {
        for (var i = 1, _i = bucketList.length; i < _i; i++) {
            if (bucketList[i - 1].key > bucketList[i].key) {
                sorted = false;
                break;
            }
        }
    }
    if (isBucketed && sorted) {
        for (var i = 0; i < bucketList.length; i++)
            bucketOffsets[i] = bucketList[i].offset;
        return bucketOffsets;
    }
    if (sortBuckets && !sorted) {
        Object(_sort__WEBPACK_IMPORTED_MODULE_0__["sort"])(bucketList, 0, bucketList.length, sortAsc, _sort__WEBPACK_IMPORTED_MODULE_0__["arraySwap"]);
    }
    var offset = 0;
    for (var i = 0; i < bucketList.length; i++) {
        var b = bucketList[i];
        b.offset = offset;
        offset += b.count;
    }
    var reorderedIndices = new Int32Array(end - start);
    for (var i = start; i < end; i++) {
        var key = getKey(indices[i]);
        var bucket = buckets.get(key);
        reorderedIndices[bucket.offset++] = indices[i];
    }
    for (var i = 0, _i = reorderedIndices.length; i < _i; i++) {
        indices[i + start] = reorderedIndices[i];
    }
    bucketOffsets[0] = start;
    for (var i = 1; i < bucketList.length; i++)
        bucketOffsets[i] = bucketList[i - 1].offset + start;
    return bucketOffsets;
}
/**
 * Reorders indices so that the same keys are next to each other, [start, end)
 * Returns the offsets of buckets. So that [offsets[i], offsets[i + 1]) determines the range.
 */
function makeBuckets(indices, getKey, options) {
    var s = (options && options.start) || 0;
    var e = (options && options.end) || indices.length;
    if (e - s <= 0)
        throw new Error('Can only bucket non-empty collections.');
    return _makeBuckets(indices, getKey, !!(options && options.sort), s, e);
}
//# sourceMappingURL=buckets.js.map

/***/ }),

/***/ "./lib/mol-data/util/chunked-array.js":
/*!********************************************!*\
  !*** ./lib/mol-data/util/chunked-array.js ***!
  \********************************************/
/*! exports provided: ChunkedArray */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ChunkedArray", function() { return ChunkedArray; });
/**
 * Copyright (c) 2017 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * from https://github.com/dsehnal/CIFTools.js
 * @author David Sehnal <david.sehnal@gmail.com>
 */
var ChunkedArray;
(function (ChunkedArray) {
    function is(x) {
        return x.creator && x.chunkSize;
    }
    ChunkedArray.is = is;
    function allocateNext(array) {
        var nextSize = array.growBy * array.elementSize;
        array.currentSize = nextSize;
        array.currentIndex = 0;
        array.currentChunk = new array.ctor(nextSize);
        array.allocatedSize += nextSize;
        array.chunks[array.chunks.length] = array.currentChunk;
    }
    function add4(array, x, y, z, w) {
        if (array.currentIndex >= array.currentSize)
            allocateNext(array);
        var c = array.currentChunk;
        var i = array.currentIndex;
        c[i] = x;
        c[i + 1] = y;
        c[i + 2] = z;
        c[i + 3] = w;
        array.currentIndex += 4;
        return array.elementCount++;
    }
    ChunkedArray.add4 = add4;
    function add3(array, x, y, z) {
        if (array.currentIndex >= array.currentSize)
            allocateNext(array);
        var c = array.currentChunk;
        var i = array.currentIndex;
        c[i] = x;
        c[i + 1] = y;
        c[i + 2] = z;
        array.currentIndex += 3;
        return array.elementCount++;
    }
    ChunkedArray.add3 = add3;
    function add2(array, x, y) {
        if (array.currentIndex >= array.currentSize)
            allocateNext(array);
        var c = array.currentChunk;
        var i = array.currentIndex;
        c[i] = x;
        c[i + 1] = y;
        array.currentIndex += 2;
        return array.elementCount++;
    }
    ChunkedArray.add2 = add2;
    function add(array, x) {
        if (array.currentIndex >= array.currentSize)
            allocateNext(array);
        array.currentChunk[array.currentIndex] = x;
        array.currentIndex += 1;
        return array.elementCount++;
    }
    ChunkedArray.add = add;
    function addRepeat(array, n, x) {
        for (var i = 0; i < n; i++) {
            if (array.currentIndex >= array.currentSize)
                allocateNext(array);
            array.currentChunk[array.currentIndex++] = x;
            array.elementCount++;
        }
        return array.elementCount;
    }
    ChunkedArray.addRepeat = addRepeat;
    function addMany(array, data) {
        var elementSize = array.elementSize;
        for (var i = 0, _i = data.length; i < _i; i += elementSize) {
            if (array.currentIndex >= array.currentSize)
                allocateNext(array);
            var currentChunk = array.currentChunk;
            for (var j = 0; j < elementSize; j++) {
                currentChunk[array.currentIndex++] = data[i + j];
            }
            array.elementCount++;
        }
        return array.elementCount;
    }
    ChunkedArray.addMany = addMany;
    /** If doNotResizeSingleton = true and the data fit into a single chunk, do not resize it. */
    function compact(array, doNotResizeSingleton) {
        if (doNotResizeSingleton === void 0) { doNotResizeSingleton = false; }
        return _compact(array, doNotResizeSingleton);
    }
    ChunkedArray.compact = compact;
    function _compact(array, doNotResizeSingleton) {
        var ctor = array.ctor, chunks = array.chunks, currentIndex = array.currentIndex;
        if (!chunks.length)
            return new ctor(0);
        if (chunks.length === 1) {
            if (doNotResizeSingleton || currentIndex === array.allocatedSize) {
                return chunks[0];
            }
        }
        var size = 0;
        for (var i = 0, _i = chunks.length - 1; i < _i; i++)
            size += chunks[i].length;
        size += array.currentIndex;
        var ret = new ctor(size);
        var offset = 0;
        if (ret.buffer) {
            for (var i = 0, _i = chunks.length - 1; i < _i; i++) {
                ret.set(chunks[i], offset);
                offset += chunks[i].length;
            }
        }
        else {
            for (var i = 0, _i = chunks.length - 1; i < _i; i++) {
                var chunk = chunks[i];
                for (var j = 0, _j = chunk.length; j < _j; j++)
                    ret[offset + j] = chunk[j];
                offset += chunk.length;
            }
        }
        var lastChunk = chunks[chunks.length - 1];
        if (ret.buffer && currentIndex >= array.currentSize) {
            ret.set(lastChunk, offset);
        }
        else {
            for (var j = 0, _j = lastChunk.length; j < _j; j++)
                ret[offset + j] = lastChunk[j];
        }
        return ret;
    }
    ChunkedArray._compact = _compact;
    /**
     * The size of the initial chunk is elementSize * initialCount.
     * Use the provided array as the initial chunk. The size of the array must be divisible by the elementSize.
     */
    function create(ctor, elementSize, chunkSize, initialChunkOrCount) {
        var ret = {
            ctor: ctor,
            elementSize: elementSize,
            growBy: Math.max(1, Math.ceil(chunkSize)),
            allocatedSize: 0,
            elementCount: 0,
            currentSize: 0,
            currentChunk: void 0,
            currentIndex: 0,
            chunks: []
        };
        if (typeof initialChunkOrCount === 'undefined')
            return ret;
        if (typeof initialChunkOrCount === 'number') {
            ret.currentChunk = new ctor(initialChunkOrCount * elementSize);
            ret.allocatedSize = initialChunkOrCount * elementSize;
            ret.currentSize = ret.currentChunk.length;
            ret.chunks[0] = ret.currentChunk;
            return ret;
        }
        var initialChunk = initialChunkOrCount;
        if (initialChunk.length % elementSize !== 0)
            throw new Error('initialChunk length must be a multiple of the element size.');
        ret.currentChunk = initialChunk;
        ret.allocatedSize = initialChunk.length;
        ret.currentSize = initialChunk.length;
        ret.chunks[0] = initialChunk;
        return ret;
    }
    ChunkedArray.create = create;
})(ChunkedArray || (ChunkedArray = {}));

//# sourceMappingURL=chunked-array.js.map

/***/ }),

/***/ "./lib/mol-data/util/combination.js":
/*!******************************************!*\
  !*** ./lib/mol-data/util/combination.js ***!
  \******************************************/
/*! exports provided: CombinationIterator, combinations */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CombinationIterator", function() { return CombinationIterator; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "combinations", function() { return combinations; });
/**
 * Copyright (c) 2018-2019 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */
function P(m, n) {
    var p = 1;
    while (n--)
        p *= m--;
    return p;
}
function C(m, n) {
    if (n > m)
        return 0;
    return P(m, n) / P(n, n);
}
function nextIndex(n) {
    var smallest = n & -n;
    var ripple = n + smallest;
    var newSmallest = ripple & -ripple;
    var ones = ((newSmallest / smallest) >> 1) - 1;
    return ripple | ones;
}
;
var CombinationIterator = /** @class */ (function () {
    function CombinationIterator(array, count) {
        this.array = array;
        this.hasNext = false;
        this.index = (1 << count) - 1;
        this.size = C(array.length, count);
        this.maxIndex = 1 << array.length,
            this.value = new Array(count);
        this.hasNext = count > 0 && count <= array.length;
    }
    CombinationIterator.prototype.move = function () {
        if (this.hasNext) {
            var i = 0, j = 0, n = this.index;
            for (; n; n >>>= 1, i++) {
                if (n & 1)
                    this.value[j++] = this.array[i];
            }
            this.index = nextIndex(this.index);
            this.hasNext = this.index < this.maxIndex;
        }
        return this.value;
    };
    return CombinationIterator;
}());

function combinations(array, count) {
    var out = [];
    var combinationIt = new CombinationIterator(array, count);
    while (combinationIt.hasNext)
        out.push(combinationIt.move().slice());
    return out;
}
//# sourceMappingURL=combination.js.map

/***/ }),

/***/ "./lib/mol-data/util/equivalence-classes.js":
/*!**************************************************!*\
  !*** ./lib/mol-data/util/equivalence-classes.js ***!
  \**************************************************/
/*! exports provided: EquivalenceClassesImpl, EquivalenceClasses */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "EquivalenceClassesImpl", function() { return EquivalenceClassesImpl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "EquivalenceClasses", function() { return EquivalenceClasses; });
/**
 * Copyright (c) 2017 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author David Sehnal <david.sehnal@gmail.com>
 */
var EquivalenceClassesImpl = /** @class */ (function () {
    function EquivalenceClassesImpl(getHash, areEqual) {
        this.getHash = getHash;
        this.areEqual = areEqual;
        this.id = 0;
        this.byHash = new Map();
        this.groups = [];
    }
    EquivalenceClassesImpl.prototype.createGroup = function (key, value) {
        var id = this.id++;
        var keys = [key];
        this.groups[id] = keys;
        return { id: id, keys: keys, value: value };
    };
    // Return the group representative.
    EquivalenceClassesImpl.prototype.add = function (key, a) {
        var hash = this.getHash(a);
        if (this.byHash.has(hash)) {
            var groups = this.byHash.get(hash);
            for (var i = 0, _i = groups.length; i < _i; i++) {
                var group_1 = groups[i];
                if (this.areEqual(a, group_1.value)) {
                    group_1.keys[group_1.keys.length] = key;
                    return group_1.value;
                }
            }
            var group = this.createGroup(key, a);
            groups[groups.length] = group;
            return group.value;
        }
        else {
            var group = this.createGroup(key, a);
            this.byHash.set(hash, [group]);
            return group.value;
        }
    };
    return EquivalenceClassesImpl;
}());

function EquivalenceClasses(getHash, areEqual) {
    return new EquivalenceClassesImpl(getHash, areEqual);
}
//# sourceMappingURL=equivalence-classes.js.map

/***/ }),

/***/ "./lib/mol-data/util/grouping.js":
/*!***************************************!*\
  !*** ./lib/mol-data/util/grouping.js ***!
  \***************************************/
/*! exports provided: Grouper, groupBy */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Grouper", function() { return Grouper; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "groupBy", function() { return groupBy; });
/* harmony import */ var _db__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../db */ "./lib/mol-data/db.js");
/**
 * Copyright (c) 2017 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author David Sehnal <david.sehnal@gmail.com>
 */

var GroupingImpl = /** @class */ (function () {
    function GroupingImpl(getKey) {
        this.getKey = getKey;
        this.map = new Map();
        this.keys = [];
        this.groups = [];
    }
    GroupingImpl.prototype.add = function (a) {
        var key = this.getKey(a);
        if (!!this.map.has(key)) {
            var group = this.map.get(key);
            group[group.length] = a;
        }
        else {
            var group = [a];
            this.map.set(key, group);
            this.keys[this.keys.length] = key;
            this.groups[this.groups.length] = group;
        }
    };
    GroupingImpl.prototype.getGrouping = function () {
        return { keys: this.keys, groups: this.groups, map: this.map };
    };
    return GroupingImpl;
}());
function Grouper(getKey) {
    return new GroupingImpl(getKey);
}
function groupBy(values, getKey) {
    var gs = Grouper(getKey);
    if (_db__WEBPACK_IMPORTED_MODULE_0__["Column"].is(values)) {
        var v = values.value;
        for (var i = 0, _i = values.rowCount; i < _i; i++)
            gs.add(v(i));
    }
    else {
        for (var i = 0, _i = values.length; i < _i; i++)
            gs.add(values[i]);
    }
    return gs.getGrouping();
}
//# sourceMappingURL=grouping.js.map

/***/ }),

/***/ "./lib/mol-data/util/hash-functions.js":
/*!*********************************************!*\
  !*** ./lib/mol-data/util/hash-functions.js ***!
  \*********************************************/
/*! exports provided: hash1, hash2, hash3, hash4, hashString, cantorPairing, sortedCantorPairing, hashFnv32a */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "hash1", function() { return hash1; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "hash2", function() { return hash2; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "hash3", function() { return hash3; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "hash4", function() { return hash4; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "hashString", function() { return hashString; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "cantorPairing", function() { return cantorPairing; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "sortedCantorPairing", function() { return sortedCantorPairing; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "hashFnv32a", function() { return hashFnv32a; });
/**
 * Copyright (c) 2017-2018 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author David Sehnal <david.sehnal@gmail.com>
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */
// from http://burtleburtle.net/bob/hash/integer.html
function hash1(i) {
    var a = i ^ (i >> 4);
    a = (a ^ 0xdeadbeef) + (a << 5);
    a = a ^ (a >> 11);
    return a;
}
function hash2(i, j) {
    var a = 23;
    a = (31 * a + i) | 0;
    a = (31 * a + j) | 0;
    a = a ^ (a >> 4);
    a = (a ^ 0xdeadbeef) + (a << 5);
    a = a ^ (a >> 11);
    return a;
}
function hash3(i, j, k) {
    var a = 23;
    a = (31 * a + i) | 0;
    a = (31 * a + j) | 0;
    a = (31 * a + k) | 0;
    a = a ^ (a >> 4);
    a = (a ^ 0xdeadbeef) + (a << 5);
    a = a ^ (a >> 11);
    return a;
}
function hash4(i, j, k, l) {
    var a = 23;
    a = (31 * a + i) | 0;
    a = (31 * a + j) | 0;
    a = (31 * a + k) | 0;
    a = (31 * a + l) | 0;
    a = a ^ (a >> 4);
    a = (a ^ 0xdeadbeef) + (a << 5);
    a = a ^ (a >> 11);
    return a;
}
function hashString(s) {
    var h = 0;
    for (var i = 0, l = s.length; i < l; i++) {
        h = (h << 5) - h + s.charCodeAt(i++) | 0;
    }
    return h;
}
/**
 * A unique number for each pair of integers
 * Biggest representable pair is (67108863, 67108863) (limit imposed by Number.MAX_SAFE_INTEGER)
 */
function cantorPairing(a, b) {
    return (a + b) * (a + b + 1) / 2 + b;
}
/**
 * A unique number for each sorted pair of integers
 * Biggest representable pair is (67108863, 67108863) (limit imposed by Number.MAX_SAFE_INTEGER)
 */
function sortedCantorPairing(a, b) {
    return a < b ? cantorPairing(a, b) : cantorPairing(b, a);
}
/**
 * 32 bit FNV-1a hash, see http://isthe.com/chongo/tech/comp/fnv/
 */
function hashFnv32a(array) {
    var hval = 0x811c9dc5;
    for (var i = 0, il = array.length; i < il; ++i) {
        hval ^= array[i];
        hval += (hval << 1) + (hval << 4) + (hval << 7) + (hval << 8) + (hval << 24);
    }
    return hval >>> 0;
}
//# sourceMappingURL=hash-functions.js.map

/***/ }),

/***/ "./lib/mol-data/util/sort.js":
/*!***********************************!*\
  !*** ./lib/mol-data/util/sort.js ***!
  \***********************************/
/*! exports provided: arrayLess, arraySwap, sortArray, sortArrayRange, sort */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "arrayLess", function() { return arrayLess; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "arraySwap", function() { return arraySwap; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "sortArray", function() { return sortArray; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "sortArrayRange", function() { return sortArrayRange; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "sort", function() { return sort; });
/**
 * Copyright (c) 2017 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author David Sehnal <david.sehnal@gmail.com>
 */
function arrayLess(arr, i, j) {
    return arr[i] - arr[j];
}
function arraySwap(arr, i, j) {
    var temp = arr[i];
    arr[i] = arr[j];
    arr[j] = temp;
}
function medianPivotIndex(data, cmp, l, r) {
    var m = (l + r) >> 1;
    if (cmp(data, l, r) > 0)
        return cmp(data, l, m) > 0 ? cmp(data, m, r) > 0 ? m : r : l;
    else
        return cmp(data, r, m) > 0 ? cmp(data, m, l) > 0 ? m : l : r;
}
function partition(ctx, l, r) {
    var cmp = ctx.cmp, swap = ctx.swap, data = ctx.data, parts = ctx.parts;
    var equals = l + 1, tail = r;
    // move the median to the 1st spot
    swap(data, l, medianPivotIndex(data, cmp, l, r));
    while (cmp(data, tail, l) > 0) {
        --tail;
    }
    for (var i = l + 1; i <= tail; i++) {
        var c = cmp(data, i, l);
        if (c > 0) {
            swap(data, i, tail);
            --tail;
            while (cmp(data, tail, l) > 0) {
                --tail;
            }
            i--;
        }
        else if (c === 0) {
            swap(data, i, equals);
            equals++;
        }
    }
    // move the medians to the correct spots
    for (var i = l; i < equals; i++) {
        swap(data, i, l + tail - i);
    }
    parts[0] = tail - equals + l + 1;
    parts[1] = tail;
}
function insertionSort(_a, start, end) {
    var data = _a.data, cmp = _a.cmp, swap = _a.swap;
    for (var i = start + 1; i <= end; i++) {
        var j = i - 1;
        while (j >= start && cmp(data, j, j + 1) > 0) {
            swap(data, j, j + 1);
            j = j - 1;
        }
    }
}
function quickSort(ctx, low, high) {
    var parts = ctx.parts;
    while (low < high) {
        if (high - low < 16) {
            insertionSort(ctx, low, high);
            return;
        }
        partition(ctx, low, high);
        var li = parts[0], ri = parts[1];
        if (li - low < high - ri) {
            quickSort(ctx, low, li - 1);
            low = ri + 1;
        }
        else {
            quickSort(ctx, ri + 1, high);
            high = li - 1;
        }
    }
}
function partitionArrayAsc(data, parts, l, r) {
    var equals = l + 1, tail = r;
    // move the median to the 1st spot
    arraySwap(data, l, medianPivotIndex(data, arrayLess, l, r));
    var pivot = data[l];
    while (data[tail] > pivot) {
        --tail;
    }
    for (var i = l + 1; i <= tail; i++) {
        var v = data[i];
        if (v > pivot) {
            arraySwap(data, i, tail);
            --tail;
            while (data[tail] > pivot) {
                --tail;
            }
            i--;
        }
        else if (v === pivot) {
            arraySwap(data, i, equals);
            ++equals;
        }
    }
    // move all medians to the correct spots
    for (var i = l; i < equals; i++) {
        arraySwap(data, i, l + tail - i);
    }
    parts[0] = tail - equals + l + 1;
    parts[1] = tail;
}
function insertionSortArrayAsc(data, start, end) {
    for (var i = start + 1; i <= end; i++) {
        var key = data[i];
        var j = i - 1;
        while (j >= start && data[j] > key) {
            data[j + 1] = data[j];
            j = j - 1;
        }
        data[j + 1] = key;
    }
}
function quickSortArrayAsc(data, parts, low, high) {
    while (low < high) {
        if (high - low < 16) {
            insertionSortArrayAsc(data, low, high);
            return;
        }
        partitionArrayAsc(data, parts, low, high);
        var li = parts[0], ri = parts[1];
        if (li - low < high - ri) {
            quickSortArrayAsc(data, parts, low, li - 1);
            low = ri + 1;
        }
        else {
            quickSortArrayAsc(data, parts, ri + 1, high);
            high = li - 1;
        }
    }
}
function sortArray(data, cmp) {
    if (cmp === void 0) { cmp = arrayLess; }
    return sortArrayRange(data, 0, data.length, cmp);
}
function sortArrayRange(data, start, end, cmp) {
    if (cmp === void 0) { cmp = arrayLess; }
    if (cmp === arrayLess)
        quickSortArrayAsc(data, [0, 0], start, end - 1);
    else
        quickSort({ data: data, cmp: cmp, swap: arraySwap, parts: [0, 0] }, start, end - 1);
    return data;
}
function sort(data, start, end, cmp, swap) {
    var ctx = { data: data, cmp: cmp, swap: swap, parts: [0, 0] };
    quickSort(ctx, start, end - 1);
    return data;
}
//# sourceMappingURL=sort.js.map

/***/ }),

/***/ "./lib/mol-geo/geometry/base.js":
/*!**************************************!*\
  !*** ./lib/mol-geo/geometry/base.js ***!
  \**************************************/
/*! exports provided: VisualQualityInfo, VisualQualityNames, VisualQualityOptions, BaseGeometry */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "VisualQualityInfo", function() { return VisualQualityInfo; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "VisualQualityNames", function() { return VisualQualityNames; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "VisualQualityOptions", function() { return VisualQualityOptions; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "BaseGeometry", function() { return BaseGeometry; });
/* harmony import */ var _mol_util__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../mol-util */ "./lib/mol-util/index.js");
/* harmony import */ var _util_location_iterator__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../util/location-iterator */ "./lib/mol-geo/util/location-iterator.js");
/* harmony import */ var _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../mol-util/param-definition */ "./lib/mol-util/param-definition.js");
/* harmony import */ var _transform_data__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./transform-data */ "./lib/mol-geo/geometry/transform-data.js");
/* harmony import */ var _mol_util_color_names__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../mol-util/color/names */ "./lib/mol-util/color/names.js");
/* harmony import */ var _mol_model_location__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../mol-model/location */ "./lib/mol-model/location.js");
/* harmony import */ var _mol_theme_color_uniform__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../../mol-theme/color/uniform */ "./lib/mol-theme/color/uniform.js");
/* harmony import */ var _mol_theme_size_uniform__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../../mol-theme/size/uniform */ "./lib/mol-theme/size/uniform.js");
/**
 * Copyright (c) 2018 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */








var VisualQualityInfo = {
    'custom': {},
    'auto': {},
    'highest': {},
    'higher': {},
    'high': {},
    'medium': {},
    'low': {},
    'lower': {},
    'lowest': {},
};
var VisualQualityNames = Object.keys(VisualQualityInfo);
var VisualQualityOptions = _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_2__["ParamDefinition"].arrayToOptions(VisualQualityNames);
//
var BaseGeometry;
(function (BaseGeometry) {
    BaseGeometry.Params = {
        alpha: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_2__["ParamDefinition"].Numeric(1, { min: 0, max: 1, step: 0.01 }, { label: 'Opacity', isEssential: true, description: 'How opaque/transparent the representation is rendered.' }),
        quality: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_2__["ParamDefinition"].Select('auto', VisualQualityOptions, { isEssential: true, description: 'Visual/rendering quality of the representation.' }),
    };
    BaseGeometry.ShadingCategory = { category: 'Shading' };
    BaseGeometry.CustomQualityParamInfo = {
        category: 'Custom Quality',
        hideIf: function (params) { return typeof params.quality !== 'undefined' && params.quality !== 'custom'; }
    };
    function createSimple(colorValue, sizeValue, transform) {
        if (colorValue === void 0) { colorValue = _mol_util_color_names__WEBPACK_IMPORTED_MODULE_4__["ColorNames"].grey; }
        if (sizeValue === void 0) { sizeValue = 1; }
        if (!transform)
            transform = Object(_transform_data__WEBPACK_IMPORTED_MODULE_3__["createIdentityTransform"])();
        var locationIterator = Object(_util_location_iterator__WEBPACK_IMPORTED_MODULE_1__["LocationIterator"])(1, transform.instanceCount.ref.value, 1, function () { return _mol_model_location__WEBPACK_IMPORTED_MODULE_5__["NullLocation"]; }, false, function () { return false; });
        var theme = {
            color: Object(_mol_theme_color_uniform__WEBPACK_IMPORTED_MODULE_6__["UniformColorTheme"])({}, { value: colorValue }),
            size: Object(_mol_theme_size_uniform__WEBPACK_IMPORTED_MODULE_7__["UniformSizeTheme"])({}, { value: sizeValue })
        };
        return { transform: transform, locationIterator: locationIterator, theme: theme };
    }
    BaseGeometry.createSimple = createSimple;
    function createValues(props, counts) {
        return {
            alpha: _mol_util__WEBPACK_IMPORTED_MODULE_0__["ValueCell"].create(props.alpha),
            uAlpha: _mol_util__WEBPACK_IMPORTED_MODULE_0__["ValueCell"].create(props.alpha),
            uVertexCount: _mol_util__WEBPACK_IMPORTED_MODULE_0__["ValueCell"].create(counts.vertexCount),
            uGroupCount: _mol_util__WEBPACK_IMPORTED_MODULE_0__["ValueCell"].create(counts.groupCount),
            drawCount: _mol_util__WEBPACK_IMPORTED_MODULE_0__["ValueCell"].create(counts.drawCount),
        };
    }
    BaseGeometry.createValues = createValues;
    function updateValues(values, props) {
        _mol_util__WEBPACK_IMPORTED_MODULE_0__["ValueCell"].updateIfChanged(values.alpha, props.alpha); // `uAlpha` is set in renderable.render
    }
    BaseGeometry.updateValues = updateValues;
    function createRenderableState(props) {
        if (props === void 0) { props = {}; }
        var opaque = props.alpha === undefined ? true : props.alpha === 1;
        return {
            disposed: false,
            visible: true,
            alphaFactor: 1,
            pickable: true,
            colorOnly: false,
            opaque: opaque,
            writeDepth: opaque,
            noClip: false,
        };
    }
    BaseGeometry.createRenderableState = createRenderableState;
    function updateRenderableState(state, props) {
        state.opaque = props.alpha * state.alphaFactor >= 1;
        state.writeDepth = state.opaque;
    }
    BaseGeometry.updateRenderableState = updateRenderableState;
})(BaseGeometry || (BaseGeometry = {}));
//# sourceMappingURL=base.js.map

/***/ }),

/***/ "./lib/mol-geo/geometry/clipping-data.js":
/*!***********************************************!*\
  !*** ./lib/mol-geo/geometry/clipping-data.js ***!
  \***********************************************/
/*! exports provided: applyClippingGroups, clearClipping, createClipping, createEmptyClipping */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "applyClippingGroups", function() { return applyClippingGroups; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "clearClipping", function() { return clearClipping; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createClipping", function() { return createClipping; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createEmptyClipping", function() { return createEmptyClipping; });
/* harmony import */ var _mol_util_value_cell__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../mol-util/value-cell */ "./lib/mol-util/value-cell.js");
/* harmony import */ var _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../mol-math/linear-algebra */ "./lib/mol-math/linear-algebra.js");
/* harmony import */ var _mol_gl_renderable_util__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../mol-gl/renderable/util */ "./lib/mol-gl/renderable/util.js");
/**
 * Copyright (c) 2020 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */



function applyClippingGroups(array, start, end, groups) {
    for (var i = start; i < end; ++i) {
        array[i] = groups;
    }
    return true;
}
function clearClipping(array, start, end) {
    array.fill(0, start, end);
}
function createClipping(count, clippingData) {
    var clipping = Object(_mol_gl_renderable_util__WEBPACK_IMPORTED_MODULE_2__["createTextureImage"])(Math.max(1, count), 1, Uint8Array, clippingData && clippingData.tClipping.ref.value.array);
    if (clippingData) {
        _mol_util_value_cell__WEBPACK_IMPORTED_MODULE_0__["ValueCell"].update(clippingData.tClipping, clipping);
        _mol_util_value_cell__WEBPACK_IMPORTED_MODULE_0__["ValueCell"].update(clippingData.uClippingTexDim, _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_1__["Vec2"].create(clipping.width, clipping.height));
        _mol_util_value_cell__WEBPACK_IMPORTED_MODULE_0__["ValueCell"].updateIfChanged(clippingData.dClipping, count > 0);
        return clippingData;
    }
    else {
        return {
            dClipObjectCount: _mol_util_value_cell__WEBPACK_IMPORTED_MODULE_0__["ValueCell"].create(0),
            dClipVariant: _mol_util_value_cell__WEBPACK_IMPORTED_MODULE_0__["ValueCell"].create('instance'),
            tClipping: _mol_util_value_cell__WEBPACK_IMPORTED_MODULE_0__["ValueCell"].create(clipping),
            uClippingTexDim: _mol_util_value_cell__WEBPACK_IMPORTED_MODULE_0__["ValueCell"].create(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_1__["Vec2"].create(clipping.width, clipping.height)),
            dClipping: _mol_util_value_cell__WEBPACK_IMPORTED_MODULE_0__["ValueCell"].create(count > 0),
        };
    }
}
var emptyClippingTexture = { array: new Uint8Array(1), width: 1, height: 1 };
function createEmptyClipping(clippingData) {
    if (clippingData) {
        _mol_util_value_cell__WEBPACK_IMPORTED_MODULE_0__["ValueCell"].update(clippingData.tClipping, emptyClippingTexture);
        _mol_util_value_cell__WEBPACK_IMPORTED_MODULE_0__["ValueCell"].update(clippingData.uClippingTexDim, _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_1__["Vec2"].create(1, 1));
        return clippingData;
    }
    else {
        return {
            dClipObjectCount: _mol_util_value_cell__WEBPACK_IMPORTED_MODULE_0__["ValueCell"].create(0),
            dClipVariant: _mol_util_value_cell__WEBPACK_IMPORTED_MODULE_0__["ValueCell"].create('instance'),
            tClipping: _mol_util_value_cell__WEBPACK_IMPORTED_MODULE_0__["ValueCell"].create(emptyClippingTexture),
            uClippingTexDim: _mol_util_value_cell__WEBPACK_IMPORTED_MODULE_0__["ValueCell"].create(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_1__["Vec2"].create(1, 1)),
            dClipping: _mol_util_value_cell__WEBPACK_IMPORTED_MODULE_0__["ValueCell"].create(false),
        };
    }
}
//# sourceMappingURL=clipping-data.js.map

/***/ }),

/***/ "./lib/mol-geo/geometry/color-data.js":
/*!********************************************!*\
  !*** ./lib/mol-geo/geometry/color-data.js ***!
  \********************************************/
/*! exports provided: createColors, createValueColor, createUniformColor, createTextureColor, createInstanceColor, createGroupColor, createGroupInstanceColor, createVertexColor, createVertexInstanceColor */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createColors", function() { return createColors; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createValueColor", function() { return createValueColor; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createUniformColor", function() { return createUniformColor; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createTextureColor", function() { return createTextureColor; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createInstanceColor", function() { return createInstanceColor; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createGroupColor", function() { return createGroupColor; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createGroupInstanceColor", function() { return createGroupInstanceColor; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createVertexColor", function() { return createVertexColor; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createVertexInstanceColor", function() { return createVertexInstanceColor; });
/* harmony import */ var _mol_util__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../mol-util */ "./lib/mol-util/index.js");
/* harmony import */ var _mol_gl_renderable_util__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../mol-gl/renderable/util */ "./lib/mol-gl/renderable/util.js");
/* harmony import */ var _mol_util_color__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../mol-util/color */ "./lib/mol-util/color/index.js");
/* harmony import */ var _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../mol-math/linear-algebra */ "./lib/mol-math/linear-algebra.js");
/* harmony import */ var _mol_model_location__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../mol-model/location */ "./lib/mol-model/location.js");
/* harmony import */ var _geometry__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./geometry */ "./lib/mol-geo/geometry/geometry.js");
/**
 * Copyright (c) 2018-2020 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */






function createColors(locationIt, positionIt, colorTheme, colorData) {
    switch (_geometry__WEBPACK_IMPORTED_MODULE_5__["Geometry"].getGranularity(locationIt, colorTheme.granularity)) {
        case 'uniform': return createUniformColor(locationIt, colorTheme.color, colorData);
        case 'instance': return createInstanceColor(locationIt, colorTheme.color, colorData);
        case 'group': return createGroupColor(locationIt, colorTheme.color, colorData);
        case 'groupInstance': return createGroupInstanceColor(locationIt, colorTheme.color, colorData);
        case 'vertex': return createVertexColor(positionIt, colorTheme.color, colorData);
        case 'vertexInstance': return createVertexInstanceColor(positionIt, colorTheme.color, colorData);
    }
}
function createValueColor(value, colorData) {
    if (colorData) {
        _mol_util__WEBPACK_IMPORTED_MODULE_0__["ValueCell"].update(colorData.uColor, _mol_util_color__WEBPACK_IMPORTED_MODULE_2__["Color"].toVec3Normalized(colorData.uColor.ref.value, value));
        _mol_util__WEBPACK_IMPORTED_MODULE_0__["ValueCell"].updateIfChanged(colorData.dColorType, 'uniform');
        return colorData;
    }
    else {
        return {
            uColor: _mol_util__WEBPACK_IMPORTED_MODULE_0__["ValueCell"].create(_mol_util_color__WEBPACK_IMPORTED_MODULE_2__["Color"].toVec3Normalized(Object(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_3__["Vec3"])(), value)),
            tColor: _mol_util__WEBPACK_IMPORTED_MODULE_0__["ValueCell"].create({ array: new Uint8Array(3), width: 1, height: 1 }),
            uColorTexDim: _mol_util__WEBPACK_IMPORTED_MODULE_0__["ValueCell"].create(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_3__["Vec2"].create(1, 1)),
            dColorType: _mol_util__WEBPACK_IMPORTED_MODULE_0__["ValueCell"].create('uniform'),
        };
    }
}
/** Creates color uniform */
function createUniformColor(locationIt, color, colorData) {
    return createValueColor(color(_mol_model_location__WEBPACK_IMPORTED_MODULE_4__["NullLocation"], false), colorData);
}
function createTextureColor(colors, type, colorData) {
    if (colorData) {
        _mol_util__WEBPACK_IMPORTED_MODULE_0__["ValueCell"].update(colorData.tColor, colors);
        _mol_util__WEBPACK_IMPORTED_MODULE_0__["ValueCell"].update(colorData.uColorTexDim, _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_3__["Vec2"].create(colors.width, colors.height));
        _mol_util__WEBPACK_IMPORTED_MODULE_0__["ValueCell"].updateIfChanged(colorData.dColorType, type);
        return colorData;
    }
    else {
        return {
            uColor: _mol_util__WEBPACK_IMPORTED_MODULE_0__["ValueCell"].create(Object(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_3__["Vec3"])()),
            tColor: _mol_util__WEBPACK_IMPORTED_MODULE_0__["ValueCell"].create(colors),
            uColorTexDim: _mol_util__WEBPACK_IMPORTED_MODULE_0__["ValueCell"].create(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_3__["Vec2"].create(colors.width, colors.height)),
            dColorType: _mol_util__WEBPACK_IMPORTED_MODULE_0__["ValueCell"].create(type),
        };
    }
}
/** Creates color texture with color for each instance */
function createInstanceColor(locationIt, color, colorData) {
    var instanceCount = locationIt.instanceCount;
    var colors = Object(_mol_gl_renderable_util__WEBPACK_IMPORTED_MODULE_1__["createTextureImage"])(Math.max(1, instanceCount), 3, Uint8Array, colorData && colorData.tColor.ref.value.array);
    locationIt.reset();
    while (locationIt.hasNext) {
        var _a = locationIt.move(), location_1 = _a.location, isSecondary = _a.isSecondary, instanceIndex = _a.instanceIndex;
        _mol_util_color__WEBPACK_IMPORTED_MODULE_2__["Color"].toArray(color(location_1, isSecondary), colors.array, instanceIndex * 3);
        locationIt.skipInstance();
    }
    return createTextureColor(colors, 'instance', colorData);
}
/** Creates color texture with color for each group (i.e. shared across instances) */
function createGroupColor(locationIt, color, colorData) {
    var groupCount = locationIt.groupCount;
    var colors = Object(_mol_gl_renderable_util__WEBPACK_IMPORTED_MODULE_1__["createTextureImage"])(Math.max(1, groupCount), 3, Uint8Array, colorData && colorData.tColor.ref.value.array);
    locationIt.reset();
    while (locationIt.hasNext && !locationIt.isNextNewInstance) {
        var _a = locationIt.move(), location_2 = _a.location, isSecondary = _a.isSecondary, groupIndex = _a.groupIndex;
        _mol_util_color__WEBPACK_IMPORTED_MODULE_2__["Color"].toArray(color(location_2, isSecondary), colors.array, groupIndex * 3);
    }
    return createTextureColor(colors, 'group', colorData);
}
/** Creates color texture with color for each group in each instance */
function createGroupInstanceColor(locationIt, color, colorData) {
    var groupCount = locationIt.groupCount, instanceCount = locationIt.instanceCount;
    var count = instanceCount * groupCount;
    var colors = Object(_mol_gl_renderable_util__WEBPACK_IMPORTED_MODULE_1__["createTextureImage"])(Math.max(1, count), 3, Uint8Array, colorData && colorData.tColor.ref.value.array);
    locationIt.reset();
    while (locationIt.hasNext) {
        var _a = locationIt.move(), location_3 = _a.location, isSecondary = _a.isSecondary, index = _a.index;
        _mol_util_color__WEBPACK_IMPORTED_MODULE_2__["Color"].toArray(color(location_3, isSecondary), colors.array, index * 3);
    }
    return createTextureColor(colors, 'groupInstance', colorData);
}
/** Creates color texture with color for each vertex (i.e. shared across instances) */
function createVertexColor(locationIt, color, colorData) {
    var groupCount = locationIt.groupCount, stride = locationIt.stride;
    var colors = Object(_mol_gl_renderable_util__WEBPACK_IMPORTED_MODULE_1__["createTextureImage"])(Math.max(1, groupCount), 3, Uint8Array, colorData && colorData.tColor.ref.value.array);
    locationIt.reset();
    locationIt.voidInstances();
    while (locationIt.hasNext && !locationIt.isNextNewInstance) {
        var _a = locationIt.move(), location_4 = _a.location, isSecondary = _a.isSecondary, groupIndex = _a.groupIndex;
        var c = color(location_4, isSecondary);
        for (var i = 0; i < stride; ++i) {
            _mol_util_color__WEBPACK_IMPORTED_MODULE_2__["Color"].toArray(c, colors.array, (groupIndex + i) * 3);
        }
    }
    return createTextureColor(colors, 'vertex', colorData);
}
/** Creates color texture with color for each vertex in each instance */
function createVertexInstanceColor(locationIt, color, colorData) {
    var groupCount = locationIt.groupCount, instanceCount = locationIt.instanceCount, stride = locationIt.stride;
    var count = instanceCount * groupCount;
    var colors = Object(_mol_gl_renderable_util__WEBPACK_IMPORTED_MODULE_1__["createTextureImage"])(Math.max(1, count), 3, Uint8Array, colorData && colorData.tColor.ref.value.array);
    locationIt.reset();
    while (locationIt.hasNext) {
        var _a = locationIt.move(), location_5 = _a.location, isSecondary = _a.isSecondary, index = _a.index;
        var c = color(location_5, isSecondary);
        for (var i = 0; i < stride; ++i) {
            _mol_util_color__WEBPACK_IMPORTED_MODULE_2__["Color"].toArray(c, colors.array, (index + i) * 3);
        }
    }
    return createTextureColor(colors, 'vertexInstance', colorData);
}
//# sourceMappingURL=color-data.js.map

/***/ }),

/***/ "./lib/mol-geo/geometry/cylinders/cylinders-builder.js":
/*!*************************************************************!*\
  !*** ./lib/mol-geo/geometry/cylinders/cylinders-builder.js ***!
  \*************************************************************/
/*! exports provided: CylindersBuilder */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CylindersBuilder", function() { return CylindersBuilder; });
/* harmony import */ var _mol_data_util__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../../mol-data/util */ "./lib/mol-data/util.js");
/* harmony import */ var _cylinders__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./cylinders */ "./lib/mol-geo/geometry/cylinders/cylinders.js");
/* harmony import */ var _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../../mol-math/linear-algebra */ "./lib/mol-math/linear-algebra.js");
/**
 * Copyright (c) 2020 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */



var tmpVecA = Object(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_2__["Vec3"])();
var tmpVecB = Object(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_2__["Vec3"])();
var tmpDir = Object(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_2__["Vec3"])();
// avoiding namespace lookup improved performance in Chrome (Aug 2020)
var caAdd = _mol_data_util__WEBPACK_IMPORTED_MODULE_0__["ChunkedArray"].add;
var caAdd3 = _mol_data_util__WEBPACK_IMPORTED_MODULE_0__["ChunkedArray"].add3;
var CylindersBuilder;
(function (CylindersBuilder) {
    function create(initialCount, chunkSize, cylinders) {
        if (initialCount === void 0) { initialCount = 2048; }
        if (chunkSize === void 0) { chunkSize = 1024; }
        var groups = _mol_data_util__WEBPACK_IMPORTED_MODULE_0__["ChunkedArray"].create(Float32Array, 1, chunkSize, cylinders ? cylinders.groupBuffer.ref.value : initialCount);
        var starts = _mol_data_util__WEBPACK_IMPORTED_MODULE_0__["ChunkedArray"].create(Float32Array, 3, chunkSize, cylinders ? cylinders.startBuffer.ref.value : initialCount);
        var ends = _mol_data_util__WEBPACK_IMPORTED_MODULE_0__["ChunkedArray"].create(Float32Array, 3, chunkSize, cylinders ? cylinders.endBuffer.ref.value : initialCount);
        var scales = _mol_data_util__WEBPACK_IMPORTED_MODULE_0__["ChunkedArray"].create(Float32Array, 1, chunkSize, cylinders ? cylinders.scaleBuffer.ref.value : initialCount);
        var caps = _mol_data_util__WEBPACK_IMPORTED_MODULE_0__["ChunkedArray"].create(Float32Array, 1, chunkSize, cylinders ? cylinders.capBuffer.ref.value : initialCount);
        var add = function (startX, startY, startZ, endX, endY, endZ, radiusScale, topCap, bottomCap, group) {
            for (var i = 0; i < 6; ++i) {
                caAdd3(starts, startX, startY, startZ);
                caAdd3(ends, endX, endY, endZ);
                caAdd(groups, group);
                caAdd(scales, radiusScale);
                caAdd(caps, (topCap ? 1 : 0) + (bottomCap ? 2 : 0));
            }
        };
        var addFixedCountDashes = function (start, end, segmentCount, radiusScale, topCap, bottomCap, group) {
            var d = _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_2__["Vec3"].distance(start, end);
            var s = Math.floor(segmentCount / 2);
            var step = 1 / segmentCount;
            _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_2__["Vec3"].sub(tmpDir, end, start);
            for (var j = 0; j < s; ++j) {
                var f = step * (j * 2 + 1);
                _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_2__["Vec3"].setMagnitude(tmpDir, tmpDir, d * f);
                _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_2__["Vec3"].add(tmpVecA, start, tmpDir);
                _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_2__["Vec3"].setMagnitude(tmpDir, tmpDir, d * step * ((j + 1) * 2));
                _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_2__["Vec3"].add(tmpVecB, start, tmpDir);
                add(tmpVecA[0], tmpVecA[1], tmpVecA[2], tmpVecB[0], tmpVecB[1], tmpVecB[2], radiusScale, topCap, bottomCap, group);
            }
        };
        return {
            add: add,
            addFixedCountDashes: addFixedCountDashes,
            addFixedLengthDashes: function (start, end, segmentLength, radiusScale, topCap, bottomCap, group) {
                var d = _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_2__["Vec3"].distance(start, end);
                addFixedCountDashes(start, end, d / segmentLength, radiusScale, topCap, bottomCap, group);
            },
            getCylinders: function () {
                var cylinderCount = groups.elementCount / 6;
                var gb = _mol_data_util__WEBPACK_IMPORTED_MODULE_0__["ChunkedArray"].compact(groups, true);
                var sb = _mol_data_util__WEBPACK_IMPORTED_MODULE_0__["ChunkedArray"].compact(starts, true);
                var eb = _mol_data_util__WEBPACK_IMPORTED_MODULE_0__["ChunkedArray"].compact(ends, true);
                var ab = _mol_data_util__WEBPACK_IMPORTED_MODULE_0__["ChunkedArray"].compact(scales, true);
                var cb = _mol_data_util__WEBPACK_IMPORTED_MODULE_0__["ChunkedArray"].compact(caps, true);
                var mb = cylinders && cylinderCount <= cylinders.cylinderCount ? cylinders.mappingBuffer.ref.value : new Float32Array(cylinderCount * 18);
                var ib = cylinders && cylinderCount <= cylinders.cylinderCount ? cylinders.indexBuffer.ref.value : new Uint32Array(cylinderCount * 12);
                if (!cylinders || cylinderCount > cylinders.cylinderCount)
                    fillMappingAndIndices(cylinderCount, mb, ib);
                return _cylinders__WEBPACK_IMPORTED_MODULE_1__["Cylinders"].create(mb, ib, gb, sb, eb, ab, cb, cylinderCount, cylinders);
            }
        };
    }
    CylindersBuilder.create = create;
})(CylindersBuilder || (CylindersBuilder = {}));
function fillMappingAndIndices(n, mb, ib) {
    for (var i = 0; i < n; ++i) {
        var mo = i * 18;
        mb[mo] = -1;
        mb[mo + 1] = 1;
        mb[mo + 2] = -1;
        mb[mo + 3] = -1;
        mb[mo + 4] = -1;
        mb[mo + 5] = -1;
        mb[mo + 6] = 1;
        mb[mo + 7] = 1;
        mb[mo + 8] = -1;
        mb[mo + 9] = 1;
        mb[mo + 10] = 1;
        mb[mo + 11] = 1;
        mb[mo + 12] = 1;
        mb[mo + 13] = -1;
        mb[mo + 14] = -1;
        mb[mo + 15] = 1;
        mb[mo + 16] = -1;
        mb[mo + 17] = 1;
    }
    for (var i = 0; i < n; ++i) {
        var o = i * 6;
        var io = i * 12;
        ib[io] = o;
        ib[io + 1] = o + 1;
        ib[io + 2] = o + 2;
        ib[io + 3] = o + 1;
        ib[io + 4] = o + 4;
        ib[io + 5] = o + 2;
        ib[io + 6] = o + 2;
        ib[io + 7] = o + 4;
        ib[io + 8] = o + 3;
        ib[io + 9] = o + 4;
        ib[io + 10] = o + 5;
        ib[io + 11] = o + 3;
    }
}
//# sourceMappingURL=cylinders-builder.js.map

/***/ }),

/***/ "./lib/mol-geo/geometry/cylinders/cylinders.js":
/*!*****************************************************!*\
  !*** ./lib/mol-geo/geometry/cylinders/cylinders.js ***!
  \*****************************************************/
/*! exports provided: Cylinders */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Cylinders", function() { return Cylinders; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _mol_util__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../../mol-util */ "./lib/mol-util/index.js");
/* harmony import */ var _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../../mol-math/linear-algebra */ "./lib/mol-math/linear-algebra.js");
/* harmony import */ var _util__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../util */ "./lib/mol-geo/util.js");
/* harmony import */ var _color_data__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../color-data */ "./lib/mol-geo/geometry/color-data.js");
/* harmony import */ var _marker_data__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../marker-data */ "./lib/mol-geo/geometry/marker-data.js");
/* harmony import */ var _size_data__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../size-data */ "./lib/mol-geo/geometry/size-data.js");
/* harmony import */ var _util_location_iterator__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../../util/location-iterator */ "./lib/mol-geo/util/location-iterator.js");
/* harmony import */ var _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ../../../mol-util/param-definition */ "./lib/mol-util/param-definition.js");
/* harmony import */ var _mol_gl_renderable_util__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ../../../mol-gl/renderable/util */ "./lib/mol-gl/renderable/util.js");
/* harmony import */ var _mol_math_geometry__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ../../../mol-math/geometry */ "./lib/mol-math/geometry.js");
/* harmony import */ var _base__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ../base */ "./lib/mol-geo/geometry/base.js");
/* harmony import */ var _overpaint_data__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! ../overpaint-data */ "./lib/mol-geo/geometry/overpaint-data.js");
/* harmony import */ var _transparency_data__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! ../transparency-data */ "./lib/mol-geo/geometry/transparency-data.js");
/* harmony import */ var _mol_data_util__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! ../../../mol-data/util */ "./lib/mol-data/util.js");
/* harmony import */ var _clipping_data__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! ../clipping-data */ "./lib/mol-geo/geometry/clipping-data.js");
/**
 * Copyright (c) 2020 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */
















var Cylinders;
(function (Cylinders) {
    function create(mappings, indices, groups, starts, ends, scales, caps, cylinderCount, cylinders) {
        return cylinders ?
            update(mappings, indices, groups, starts, ends, scales, caps, cylinderCount, cylinders) :
            fromArrays(mappings, indices, groups, starts, ends, scales, caps, cylinderCount);
    }
    Cylinders.create = create;
    function createEmpty(cylinders) {
        var mb = cylinders ? cylinders.mappingBuffer.ref.value : new Float32Array(0);
        var ib = cylinders ? cylinders.indexBuffer.ref.value : new Uint32Array(0);
        var gb = cylinders ? cylinders.groupBuffer.ref.value : new Float32Array(0);
        var sb = cylinders ? cylinders.startBuffer.ref.value : new Float32Array(0);
        var eb = cylinders ? cylinders.endBuffer.ref.value : new Float32Array(0);
        var ab = cylinders ? cylinders.scaleBuffer.ref.value : new Float32Array(0);
        var cb = cylinders ? cylinders.capBuffer.ref.value : new Float32Array(0);
        return create(mb, ib, gb, sb, eb, ab, cb, 0, cylinders);
    }
    Cylinders.createEmpty = createEmpty;
    function hashCode(cylinders) {
        return Object(_mol_data_util__WEBPACK_IMPORTED_MODULE_14__["hashFnv32a"])([
            cylinders.cylinderCount, cylinders.mappingBuffer.ref.version, cylinders.indexBuffer.ref.version,
            cylinders.groupBuffer.ref.version, cylinders.startBuffer.ref.version, cylinders.endBuffer.ref.version, cylinders.scaleBuffer.ref.version, cylinders.capBuffer.ref.version
        ]);
    }
    function fromArrays(mappings, indices, groups, starts, ends, scales, caps, cylinderCount) {
        var boundingSphere = Object(_mol_math_geometry__WEBPACK_IMPORTED_MODULE_10__["Sphere3D"])();
        var groupMapping;
        var currentHash = -1;
        var currentGroup = -1;
        var cylinders = {
            kind: 'cylinders',
            cylinderCount: cylinderCount,
            mappingBuffer: _mol_util__WEBPACK_IMPORTED_MODULE_1__["ValueCell"].create(mappings),
            indexBuffer: _mol_util__WEBPACK_IMPORTED_MODULE_1__["ValueCell"].create(indices),
            groupBuffer: _mol_util__WEBPACK_IMPORTED_MODULE_1__["ValueCell"].create(groups),
            startBuffer: _mol_util__WEBPACK_IMPORTED_MODULE_1__["ValueCell"].create(starts),
            endBuffer: _mol_util__WEBPACK_IMPORTED_MODULE_1__["ValueCell"].create(ends),
            scaleBuffer: _mol_util__WEBPACK_IMPORTED_MODULE_1__["ValueCell"].create(scales),
            capBuffer: _mol_util__WEBPACK_IMPORTED_MODULE_1__["ValueCell"].create(caps),
            get boundingSphere() {
                var newHash = hashCode(cylinders);
                if (newHash !== currentHash) {
                    var s = Object(_mol_gl_renderable_util__WEBPACK_IMPORTED_MODULE_9__["calculateInvariantBoundingSphere"])(cylinders.startBuffer.ref.value, cylinders.cylinderCount * 6, 6);
                    var e = Object(_mol_gl_renderable_util__WEBPACK_IMPORTED_MODULE_9__["calculateInvariantBoundingSphere"])(cylinders.endBuffer.ref.value, cylinders.cylinderCount * 6, 6);
                    _mol_math_geometry__WEBPACK_IMPORTED_MODULE_10__["Sphere3D"].expandBySphere(boundingSphere, s, e);
                    currentHash = newHash;
                }
                return boundingSphere;
            },
            get groupMapping() {
                if (cylinders.groupBuffer.ref.version !== currentGroup) {
                    groupMapping = Object(_util__WEBPACK_IMPORTED_MODULE_3__["createGroupMapping"])(cylinders.groupBuffer.ref.value, cylinders.cylinderCount, 6);
                    currentGroup = cylinders.groupBuffer.ref.version;
                }
                return groupMapping;
            },
            setBoundingSphere: function (sphere) {
                _mol_math_geometry__WEBPACK_IMPORTED_MODULE_10__["Sphere3D"].copy(boundingSphere, sphere);
                currentHash = hashCode(cylinders);
            }
        };
        return cylinders;
    }
    function update(mappings, indices, groups, starts, ends, scales, caps, cylinderCount, cylinders) {
        if (cylinderCount > cylinders.cylinderCount) {
            _mol_util__WEBPACK_IMPORTED_MODULE_1__["ValueCell"].update(cylinders.mappingBuffer, mappings);
            _mol_util__WEBPACK_IMPORTED_MODULE_1__["ValueCell"].update(cylinders.indexBuffer, indices);
        }
        cylinders.cylinderCount = cylinderCount;
        _mol_util__WEBPACK_IMPORTED_MODULE_1__["ValueCell"].update(cylinders.groupBuffer, groups);
        _mol_util__WEBPACK_IMPORTED_MODULE_1__["ValueCell"].update(cylinders.startBuffer, starts);
        _mol_util__WEBPACK_IMPORTED_MODULE_1__["ValueCell"].update(cylinders.endBuffer, ends);
        _mol_util__WEBPACK_IMPORTED_MODULE_1__["ValueCell"].update(cylinders.scaleBuffer, scales);
        _mol_util__WEBPACK_IMPORTED_MODULE_1__["ValueCell"].update(cylinders.capBuffer, caps);
        return cylinders;
    }
    function transform(cylinders, t) {
        var start = cylinders.startBuffer.ref.value;
        Object(_util__WEBPACK_IMPORTED_MODULE_3__["transformPositionArray"])(t, start, 0, cylinders.cylinderCount * 6);
        _mol_util__WEBPACK_IMPORTED_MODULE_1__["ValueCell"].update(cylinders.startBuffer, start);
        var end = cylinders.endBuffer.ref.value;
        Object(_util__WEBPACK_IMPORTED_MODULE_3__["transformPositionArray"])(t, end, 0, cylinders.cylinderCount * 6);
        _mol_util__WEBPACK_IMPORTED_MODULE_1__["ValueCell"].update(cylinders.endBuffer, end);
    }
    Cylinders.transform = transform;
    //
    Cylinders.Params = Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, _base__WEBPACK_IMPORTED_MODULE_11__["BaseGeometry"].Params), { sizeFactor: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_8__["ParamDefinition"].Numeric(1, { min: 0, max: 10, step: 0.1 }), sizeAspectRatio: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_8__["ParamDefinition"].Numeric(1, { min: 0, max: 3, step: 0.01 }), doubleSided: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_8__["ParamDefinition"].Boolean(false, _base__WEBPACK_IMPORTED_MODULE_11__["BaseGeometry"].CustomQualityParamInfo), ignoreLight: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_8__["ParamDefinition"].Boolean(false, _base__WEBPACK_IMPORTED_MODULE_11__["BaseGeometry"].ShadingCategory), xrayShaded: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_8__["ParamDefinition"].Boolean(false, _base__WEBPACK_IMPORTED_MODULE_11__["BaseGeometry"].ShadingCategory) });
    Cylinders.Utils = {
        Params: Cylinders.Params,
        createEmpty: createEmpty,
        createValues: createValues,
        createValuesSimple: createValuesSimple,
        updateValues: updateValues,
        updateBoundingSphere: updateBoundingSphere,
        createRenderableState: createRenderableState,
        updateRenderableState: updateRenderableState,
        createPositionIterator: createPositionIterator
    };
    function createPositionIterator(cylinders, transform) {
        var groupCount = cylinders.cylinderCount * 6;
        var instanceCount = transform.instanceCount.ref.value;
        var location = Object(_util_location_iterator__WEBPACK_IMPORTED_MODULE_7__["PositionLocation"])();
        var p = location.position;
        var s = cylinders.startBuffer.ref.value;
        var e = cylinders.endBuffer.ref.value;
        var m = transform.aTransform.ref.value;
        var getLocation = function (groupIndex, instanceIndex) {
            var v = groupIndex % 6 === 0 ? s : e;
            if (instanceIndex < 0) {
                _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_2__["Vec3"].fromArray(p, v, groupIndex * 3);
            }
            else {
                _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_2__["Vec3"].transformMat4Offset(p, v, m, 0, groupIndex * 3, instanceIndex * 16);
            }
            return location;
        };
        return Object(_util_location_iterator__WEBPACK_IMPORTED_MODULE_7__["LocationIterator"])(groupCount, instanceCount, 2, getLocation);
    }
    function createValues(cylinders, transform, locationIt, theme, props) {
        var instanceCount = locationIt.instanceCount, groupCount = locationIt.groupCount;
        var positionIt = createPositionIterator(cylinders, transform);
        var color = Object(_color_data__WEBPACK_IMPORTED_MODULE_4__["createColors"])(locationIt, positionIt, theme.color);
        var size = Object(_size_data__WEBPACK_IMPORTED_MODULE_6__["createSizes"])(locationIt, theme.size);
        var marker = Object(_marker_data__WEBPACK_IMPORTED_MODULE_5__["createMarkers"])(instanceCount * groupCount);
        var overpaint = Object(_overpaint_data__WEBPACK_IMPORTED_MODULE_12__["createEmptyOverpaint"])();
        var transparency = Object(_transparency_data__WEBPACK_IMPORTED_MODULE_13__["createEmptyTransparency"])();
        var clipping = Object(_clipping_data__WEBPACK_IMPORTED_MODULE_15__["createEmptyClipping"])();
        var counts = { drawCount: cylinders.cylinderCount * 4 * 3, vertexCount: cylinders.cylinderCount * 6, groupCount: groupCount, instanceCount: instanceCount };
        var padding = Object(_size_data__WEBPACK_IMPORTED_MODULE_6__["getMaxSize"])(size) * props.sizeFactor;
        var invariantBoundingSphere = _mol_math_geometry__WEBPACK_IMPORTED_MODULE_10__["Sphere3D"].clone(cylinders.boundingSphere);
        var boundingSphere = Object(_mol_gl_renderable_util__WEBPACK_IMPORTED_MODULE_9__["calculateTransformBoundingSphere"])(invariantBoundingSphere, transform.aTransform.ref.value, instanceCount);
        return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({ aMapping: cylinders.mappingBuffer, aGroup: cylinders.groupBuffer, aStart: cylinders.startBuffer, aEnd: cylinders.endBuffer, aScale: cylinders.scaleBuffer, aCap: cylinders.capBuffer, elements: cylinders.indexBuffer, boundingSphere: _mol_util__WEBPACK_IMPORTED_MODULE_1__["ValueCell"].create(boundingSphere), invariantBoundingSphere: _mol_util__WEBPACK_IMPORTED_MODULE_1__["ValueCell"].create(invariantBoundingSphere), uInvariantBoundingSphere: _mol_util__WEBPACK_IMPORTED_MODULE_1__["ValueCell"].create(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_2__["Vec4"].ofSphere(invariantBoundingSphere)) }, color), size), marker), overpaint), transparency), clipping), transform), { padding: _mol_util__WEBPACK_IMPORTED_MODULE_1__["ValueCell"].create(padding) }), _base__WEBPACK_IMPORTED_MODULE_11__["BaseGeometry"].createValues(props, counts)), { uSizeFactor: _mol_util__WEBPACK_IMPORTED_MODULE_1__["ValueCell"].create(props.sizeFactor * props.sizeAspectRatio), dDoubleSided: _mol_util__WEBPACK_IMPORTED_MODULE_1__["ValueCell"].create(props.doubleSided), dIgnoreLight: _mol_util__WEBPACK_IMPORTED_MODULE_1__["ValueCell"].create(props.ignoreLight), dXrayShaded: _mol_util__WEBPACK_IMPORTED_MODULE_1__["ValueCell"].create(props.xrayShaded) });
    }
    function createValuesSimple(cylinders, props, colorValue, sizeValue, transform) {
        var s = _base__WEBPACK_IMPORTED_MODULE_11__["BaseGeometry"].createSimple(colorValue, sizeValue, transform);
        var p = Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_8__["ParamDefinition"].getDefaultValues(Cylinders.Params)), props);
        return createValues(cylinders, s.transform, s.locationIterator, s.theme, p);
    }
    function updateValues(values, props) {
        _base__WEBPACK_IMPORTED_MODULE_11__["BaseGeometry"].updateValues(values, props);
        _mol_util__WEBPACK_IMPORTED_MODULE_1__["ValueCell"].updateIfChanged(values.uSizeFactor, props.sizeFactor * props.sizeAspectRatio);
        _mol_util__WEBPACK_IMPORTED_MODULE_1__["ValueCell"].updateIfChanged(values.dDoubleSided, props.doubleSided);
        _mol_util__WEBPACK_IMPORTED_MODULE_1__["ValueCell"].updateIfChanged(values.dIgnoreLight, props.ignoreLight);
        _mol_util__WEBPACK_IMPORTED_MODULE_1__["ValueCell"].updateIfChanged(values.dXrayShaded, props.xrayShaded);
    }
    function updateBoundingSphere(values, cylinders) {
        var invariantBoundingSphere = _mol_math_geometry__WEBPACK_IMPORTED_MODULE_10__["Sphere3D"].clone(cylinders.boundingSphere);
        var boundingSphere = Object(_mol_gl_renderable_util__WEBPACK_IMPORTED_MODULE_9__["calculateTransformBoundingSphere"])(invariantBoundingSphere, values.aTransform.ref.value, values.instanceCount.ref.value);
        if (!_mol_math_geometry__WEBPACK_IMPORTED_MODULE_10__["Sphere3D"].equals(boundingSphere, values.boundingSphere.ref.value)) {
            _mol_util__WEBPACK_IMPORTED_MODULE_1__["ValueCell"].update(values.boundingSphere, boundingSphere);
        }
        if (!_mol_math_geometry__WEBPACK_IMPORTED_MODULE_10__["Sphere3D"].equals(invariantBoundingSphere, values.invariantBoundingSphere.ref.value)) {
            _mol_util__WEBPACK_IMPORTED_MODULE_1__["ValueCell"].update(values.invariantBoundingSphere, invariantBoundingSphere);
            _mol_util__WEBPACK_IMPORTED_MODULE_1__["ValueCell"].update(values.uInvariantBoundingSphere, _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_2__["Vec4"].fromSphere(values.uInvariantBoundingSphere.ref.value, invariantBoundingSphere));
        }
    }
    function createRenderableState(props) {
        var state = _base__WEBPACK_IMPORTED_MODULE_11__["BaseGeometry"].createRenderableState(props);
        updateRenderableState(state, props);
        return state;
    }
    function updateRenderableState(state, props) {
        _base__WEBPACK_IMPORTED_MODULE_11__["BaseGeometry"].updateRenderableState(state, props);
        state.opaque = state.opaque && !props.xrayShaded;
        state.writeDepth = state.opaque;
    }
})(Cylinders || (Cylinders = {}));
//# sourceMappingURL=cylinders.js.map

/***/ }),

/***/ "./lib/mol-geo/geometry/direct-volume/direct-volume.js":
/*!*************************************************************!*\
  !*** ./lib/mol-geo/geometry/direct-volume/direct-volume.js ***!
  \*************************************************************/
/*! exports provided: DirectVolume */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DirectVolume", function() { return DirectVolume; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _mol_data_util__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../../mol-data/util */ "./lib/mol-data/util.js");
/* harmony import */ var _mol_geo_util_location_iterator__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../../mol-geo/util/location-iterator */ "./lib/mol-geo/util/location-iterator.js");
/* harmony import */ var _mol_gl_renderable_util__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../../mol-gl/renderable/util */ "./lib/mol-gl/renderable/util.js");
/* harmony import */ var _mol_math_geometry__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../../mol-math/geometry */ "./lib/mol-math/geometry.js");
/* harmony import */ var _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../../mol-math/linear-algebra */ "./lib/mol-math/linear-algebra.js");
/* harmony import */ var _mol_util__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../../../mol-util */ "./lib/mol-util/index.js");
/* harmony import */ var _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../../../mol-util/param-definition */ "./lib/mol-util/param-definition.js");
/* harmony import */ var _primitive_box__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ../../primitive/box */ "./lib/mol-geo/primitive/box.js");
/* harmony import */ var _base__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ../base */ "./lib/mol-geo/geometry/base.js");
/* harmony import */ var _color_data__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ../color-data */ "./lib/mol-geo/geometry/color-data.js");
/* harmony import */ var _marker_data__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ../marker-data */ "./lib/mol-geo/geometry/marker-data.js");
/* harmony import */ var _overpaint_data__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! ../overpaint-data */ "./lib/mol-geo/geometry/overpaint-data.js");
/* harmony import */ var _transparency_data__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! ../transparency-data */ "./lib/mol-geo/geometry/transparency-data.js");
/* harmony import */ var _transfer_function__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! ./transfer-function */ "./lib/mol-geo/geometry/direct-volume/transfer-function.js");
/* harmony import */ var _clipping_data__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! ../clipping-data */ "./lib/mol-geo/geometry/clipping-data.js");
/* harmony import */ var _mol_model_volume__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(/*! ../../../mol-model/volume */ "./lib/mol-model/volume.js");
/* harmony import */ var _mol_util_color_names__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(/*! ../../../mol-util/color/names */ "./lib/mol-util/color/names.js");
/**
 * Copyright (c) 2018-2020 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */


















var VolumeBox = Object(_primitive_box__WEBPACK_IMPORTED_MODULE_8__["Box"])();
var DirectVolume;
(function (DirectVolume) {
    function create(bbox, gridDimension, transform, unitToCartn, cellDim, texture, stats, packedGroup, directVolume) {
        return directVolume ?
            update(bbox, gridDimension, transform, unitToCartn, cellDim, texture, stats, packedGroup, directVolume) :
            fromData(bbox, gridDimension, transform, unitToCartn, cellDim, texture, stats, packedGroup);
    }
    DirectVolume.create = create;
    function hashCode(directVolume) {
        return Object(_mol_data_util__WEBPACK_IMPORTED_MODULE_1__["hashFnv32a"])([
            directVolume.bboxSize.ref.version, directVolume.gridDimension.ref.version,
            directVolume.gridTexture.ref.version, directVolume.transform.ref.version,
            directVolume.gridStats.ref.version
        ]);
    }
    function fromData(bbox, gridDimension, transform, unitToCartn, cellDim, texture, stats, packedGroup) {
        var boundingSphere = Object(_mol_math_geometry__WEBPACK_IMPORTED_MODULE_4__["Sphere3D"])();
        var currentHash = -1;
        var width = texture.getWidth();
        var height = texture.getHeight();
        var depth = texture.getDepth();
        var directVolume = {
            kind: 'direct-volume',
            gridDimension: _mol_util__WEBPACK_IMPORTED_MODULE_6__["ValueCell"].create(gridDimension),
            gridTexture: _mol_util__WEBPACK_IMPORTED_MODULE_6__["ValueCell"].create(texture),
            gridTextureDim: _mol_util__WEBPACK_IMPORTED_MODULE_6__["ValueCell"].create(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_5__["Vec3"].create(width, height, depth)),
            gridStats: _mol_util__WEBPACK_IMPORTED_MODULE_6__["ValueCell"].create(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_5__["Vec4"].create(stats.min, stats.max, stats.mean, stats.sigma)),
            bboxMin: _mol_util__WEBPACK_IMPORTED_MODULE_6__["ValueCell"].create(bbox.min),
            bboxMax: _mol_util__WEBPACK_IMPORTED_MODULE_6__["ValueCell"].create(bbox.max),
            bboxSize: _mol_util__WEBPACK_IMPORTED_MODULE_6__["ValueCell"].create(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_5__["Vec3"].sub(Object(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_5__["Vec3"])(), bbox.max, bbox.min)),
            transform: _mol_util__WEBPACK_IMPORTED_MODULE_6__["ValueCell"].create(transform),
            cellDim: _mol_util__WEBPACK_IMPORTED_MODULE_6__["ValueCell"].create(cellDim),
            unitToCartn: _mol_util__WEBPACK_IMPORTED_MODULE_6__["ValueCell"].create(unitToCartn),
            cartnToUnit: _mol_util__WEBPACK_IMPORTED_MODULE_6__["ValueCell"].create(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_5__["Mat4"].invert(Object(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_5__["Mat4"])(), unitToCartn)),
            get boundingSphere() {
                var newHash = hashCode(directVolume);
                if (newHash !== currentHash) {
                    var b = getBoundingSphere(directVolume.gridDimension.ref.value, directVolume.transform.ref.value);
                    _mol_math_geometry__WEBPACK_IMPORTED_MODULE_4__["Sphere3D"].copy(boundingSphere, b);
                    currentHash = newHash;
                }
                return boundingSphere;
            },
            packedGroup: _mol_util__WEBPACK_IMPORTED_MODULE_6__["ValueCell"].create(packedGroup),
            setBoundingSphere: function (sphere) {
                _mol_math_geometry__WEBPACK_IMPORTED_MODULE_4__["Sphere3D"].copy(boundingSphere, sphere);
                currentHash = hashCode(directVolume);
            }
        };
        return directVolume;
    }
    function update(bbox, gridDimension, transform, unitToCartn, cellDim, texture, stats, packedGroup, directVolume) {
        var width = texture.getWidth();
        var height = texture.getHeight();
        var depth = texture.getDepth();
        _mol_util__WEBPACK_IMPORTED_MODULE_6__["ValueCell"].update(directVolume.gridDimension, gridDimension);
        _mol_util__WEBPACK_IMPORTED_MODULE_6__["ValueCell"].update(directVolume.gridTexture, texture);
        _mol_util__WEBPACK_IMPORTED_MODULE_6__["ValueCell"].update(directVolume.gridTextureDim, _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_5__["Vec3"].set(directVolume.gridTextureDim.ref.value, width, height, depth));
        _mol_util__WEBPACK_IMPORTED_MODULE_6__["ValueCell"].update(directVolume.gridStats, _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_5__["Vec4"].set(directVolume.gridStats.ref.value, stats.min, stats.max, stats.mean, stats.sigma));
        _mol_util__WEBPACK_IMPORTED_MODULE_6__["ValueCell"].update(directVolume.bboxMin, bbox.min);
        _mol_util__WEBPACK_IMPORTED_MODULE_6__["ValueCell"].update(directVolume.bboxMax, bbox.max);
        _mol_util__WEBPACK_IMPORTED_MODULE_6__["ValueCell"].update(directVolume.bboxSize, _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_5__["Vec3"].sub(directVolume.bboxSize.ref.value, bbox.max, bbox.min));
        _mol_util__WEBPACK_IMPORTED_MODULE_6__["ValueCell"].update(directVolume.transform, transform);
        _mol_util__WEBPACK_IMPORTED_MODULE_6__["ValueCell"].update(directVolume.cellDim, cellDim);
        _mol_util__WEBPACK_IMPORTED_MODULE_6__["ValueCell"].update(directVolume.unitToCartn, unitToCartn);
        _mol_util__WEBPACK_IMPORTED_MODULE_6__["ValueCell"].update(directVolume.cartnToUnit, _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_5__["Mat4"].invert(Object(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_5__["Mat4"])(), unitToCartn));
        _mol_util__WEBPACK_IMPORTED_MODULE_6__["ValueCell"].updateIfChanged(directVolume.packedGroup, packedGroup);
        return directVolume;
    }
    function createEmpty(directVolume) {
        return {}; // TODO
    }
    DirectVolume.createEmpty = createEmpty;
    function createRenderModeParam(stats) {
        var isoValueParam = stats
            ? _mol_model_volume__WEBPACK_IMPORTED_MODULE_16__["Volume"].createIsoValueParam(_mol_model_volume__WEBPACK_IMPORTED_MODULE_16__["Volume"].IsoValue.relative(2), stats)
            : _mol_model_volume__WEBPACK_IMPORTED_MODULE_16__["Volume"].IsoValueParam;
        return _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_7__["ParamDefinition"].MappedStatic('volume', {
            isosurface: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_7__["ParamDefinition"].Group({
                isoValue: isoValueParam,
                singleLayer: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_7__["ParamDefinition"].Boolean(false, { isEssential: true }),
            }, { isFlat: true }),
            volume: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_7__["ParamDefinition"].Group({
                controlPoints: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_7__["ParamDefinition"].LineGraph([
                    _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_5__["Vec2"].create(0.19, 0.0), _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_5__["Vec2"].create(0.2, 0.05), _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_5__["Vec2"].create(0.25, 0.05), _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_5__["Vec2"].create(0.26, 0.0),
                    _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_5__["Vec2"].create(0.79, 0.0), _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_5__["Vec2"].create(0.8, 0.05), _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_5__["Vec2"].create(0.85, 0.05), _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_5__["Vec2"].create(0.86, 0.0),
                ]),
                list: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_7__["ParamDefinition"].ColorList({
                    kind: 'interpolate',
                    colors: [
                        [_mol_util_color_names__WEBPACK_IMPORTED_MODULE_17__["ColorNames"].white, 0],
                        [_mol_util_color_names__WEBPACK_IMPORTED_MODULE_17__["ColorNames"].red, 0.25],
                        [_mol_util_color_names__WEBPACK_IMPORTED_MODULE_17__["ColorNames"].white, 0.5],
                        [_mol_util_color_names__WEBPACK_IMPORTED_MODULE_17__["ColorNames"].blue, 0.75],
                        [_mol_util_color_names__WEBPACK_IMPORTED_MODULE_17__["ColorNames"].white, 1]
                    ]
                }, { offsets: true }),
            }, { isFlat: true })
        }, { isEssential: true });
    }
    DirectVolume.createRenderModeParam = createRenderModeParam;
    DirectVolume.Params = Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, _base__WEBPACK_IMPORTED_MODULE_9__["BaseGeometry"].Params), { doubleSided: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_7__["ParamDefinition"].Boolean(false, _base__WEBPACK_IMPORTED_MODULE_9__["BaseGeometry"].CustomQualityParamInfo), flipSided: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_7__["ParamDefinition"].Boolean(false, _base__WEBPACK_IMPORTED_MODULE_9__["BaseGeometry"].ShadingCategory), flatShaded: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_7__["ParamDefinition"].Boolean(false, _base__WEBPACK_IMPORTED_MODULE_9__["BaseGeometry"].ShadingCategory), ignoreLight: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_7__["ParamDefinition"].Boolean(false, _base__WEBPACK_IMPORTED_MODULE_9__["BaseGeometry"].ShadingCategory), xrayShaded: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_7__["ParamDefinition"].Boolean(false, _base__WEBPACK_IMPORTED_MODULE_9__["BaseGeometry"].ShadingCategory), renderMode: createRenderModeParam(), stepsPerCell: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_7__["ParamDefinition"].Numeric(5, { min: 1, max: 20, step: 1 }), jumpLength: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_7__["ParamDefinition"].Numeric(0, { min: 0, max: 20, step: 0.1 }) });
    DirectVolume.Utils = {
        Params: DirectVolume.Params,
        createEmpty: createEmpty,
        createValues: createValues,
        createValuesSimple: createValuesSimple,
        updateValues: updateValues,
        updateBoundingSphere: updateBoundingSphere,
        createRenderableState: createRenderableState,
        updateRenderableState: updateRenderableState,
        createPositionIterator: createPositionIterator
    };
    function createPositionIterator(directVolume, transform) {
        var t = directVolume.transform.ref.value;
        var _a = directVolume.gridDimension.ref.value, x = _a[0], y = _a[1], z = _a[2];
        var groupCount = x * y * z;
        var instanceCount = transform.instanceCount.ref.value;
        var location = Object(_mol_geo_util_location_iterator__WEBPACK_IMPORTED_MODULE_2__["PositionLocation"])();
        var p = location.position;
        var m = transform.aTransform.ref.value;
        var getLocation = function (groupIndex, instanceIndex) {
            var k = Math.floor(groupIndex / z);
            p[0] = Math.floor(k / y);
            p[1] = k % y;
            p[2] = groupIndex % z;
            _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_5__["Vec3"].transformMat4(p, p, t);
            if (instanceIndex >= 0) {
                _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_5__["Vec3"].transformMat4Offset(p, p, m, 0, 0, instanceIndex * 16);
            }
            return location;
        };
        return Object(_mol_geo_util_location_iterator__WEBPACK_IMPORTED_MODULE_2__["LocationIterator"])(groupCount, instanceCount, 1, getLocation);
    }
    function getNormalizedIsoValue(out, isoValue, stats) {
        var min = stats[0], max = stats[1], mean = stats[2], sigma = stats[3];
        var value = _mol_model_volume__WEBPACK_IMPORTED_MODULE_16__["Volume"].IsoValue.toAbsolute(isoValue, { min: min, max: max, mean: mean, sigma: sigma }).absoluteValue;
        _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_5__["Vec2"].set(out, (value - min) / (max - min), (0 - min) / (max - min));
        return out;
    }
    function getMaxSteps(gridDim, stepsPerCell) {
        return Math.ceil(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_5__["Vec3"].magnitude(gridDim) * stepsPerCell);
    }
    function getStepScale(cellDim, stepsPerCell) {
        return Math.min.apply(Math, cellDim) * (1 / stepsPerCell);
    }
    function getTransferScale(stepsPerCell) {
        return (1 / stepsPerCell);
    }
    function createValues(directVolume, transform, locationIt, theme, props) {
        var gridTexture = directVolume.gridTexture, gridTextureDim = directVolume.gridTextureDim, gridStats = directVolume.gridStats;
        var bboxSize = directVolume.bboxSize, bboxMin = directVolume.bboxMin, bboxMax = directVolume.bboxMax, gridDimension = directVolume.gridDimension, gridTransform = directVolume.transform;
        var instanceCount = locationIt.instanceCount, groupCount = locationIt.groupCount;
        var positionIt = DirectVolume.Utils.createPositionIterator(directVolume, transform);
        var color = Object(_color_data__WEBPACK_IMPORTED_MODULE_10__["createColors"])(locationIt, positionIt, theme.color);
        var marker = Object(_marker_data__WEBPACK_IMPORTED_MODULE_11__["createMarkers"])(instanceCount * groupCount);
        var overpaint = Object(_overpaint_data__WEBPACK_IMPORTED_MODULE_12__["createEmptyOverpaint"])();
        var transparency = Object(_transparency_data__WEBPACK_IMPORTED_MODULE_13__["createEmptyTransparency"])();
        var clipping = Object(_clipping_data__WEBPACK_IMPORTED_MODULE_15__["createEmptyClipping"])();
        var _a = gridDimension.ref.value, x = _a[0], y = _a[1], z = _a[2];
        var counts = { drawCount: VolumeBox.indices.length, vertexCount: x * y * z, groupCount: groupCount, instanceCount: instanceCount };
        var invariantBoundingSphere = _mol_math_geometry__WEBPACK_IMPORTED_MODULE_4__["Sphere3D"].clone(directVolume.boundingSphere);
        var boundingSphere = Object(_mol_gl_renderable_util__WEBPACK_IMPORTED_MODULE_3__["calculateTransformBoundingSphere"])(invariantBoundingSphere, transform.aTransform.ref.value, instanceCount);
        var controlPoints = props.renderMode.name === 'volume' ? Object(_transfer_function__WEBPACK_IMPORTED_MODULE_14__["getControlPointsFromVec2Array"])(props.renderMode.params.controlPoints) : [];
        var transferTex = Object(_transfer_function__WEBPACK_IMPORTED_MODULE_14__["createTransferFunctionTexture"])(controlPoints, props.renderMode.name === 'volume' ? props.renderMode.params.list.colors : []);
        var isoValue = props.renderMode.name === 'isosurface'
            ? props.renderMode.params.isoValue
            : _mol_model_volume__WEBPACK_IMPORTED_MODULE_16__["Volume"].IsoValue.relative(2);
        var singleLayer = props.renderMode.name === 'isosurface'
            ? props.renderMode.params.singleLayer
            : false;
        return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, color), marker), overpaint), transparency), clipping), transform), _base__WEBPACK_IMPORTED_MODULE_9__["BaseGeometry"].createValues(props, counts)), { aPosition: _mol_util__WEBPACK_IMPORTED_MODULE_6__["ValueCell"].create(VolumeBox.vertices), elements: _mol_util__WEBPACK_IMPORTED_MODULE_6__["ValueCell"].create(VolumeBox.indices), boundingSphere: _mol_util__WEBPACK_IMPORTED_MODULE_6__["ValueCell"].create(boundingSphere), invariantBoundingSphere: _mol_util__WEBPACK_IMPORTED_MODULE_6__["ValueCell"].create(invariantBoundingSphere), uInvariantBoundingSphere: _mol_util__WEBPACK_IMPORTED_MODULE_6__["ValueCell"].create(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_5__["Vec4"].ofSphere(invariantBoundingSphere)), uIsoValue: _mol_util__WEBPACK_IMPORTED_MODULE_6__["ValueCell"].create(getNormalizedIsoValue(Object(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_5__["Vec2"])(), isoValue, directVolume.gridStats.ref.value)), uBboxMin: bboxMin, uBboxMax: bboxMax, uBboxSize: bboxSize, uMaxSteps: _mol_util__WEBPACK_IMPORTED_MODULE_6__["ValueCell"].create(getMaxSteps(gridDimension.ref.value, props.stepsPerCell)), uStepScale: _mol_util__WEBPACK_IMPORTED_MODULE_6__["ValueCell"].create(getStepScale(directVolume.cellDim.ref.value, props.stepsPerCell)), uJumpLength: _mol_util__WEBPACK_IMPORTED_MODULE_6__["ValueCell"].create(props.jumpLength), uTransform: gridTransform, uGridDim: gridDimension, dRenderMode: _mol_util__WEBPACK_IMPORTED_MODULE_6__["ValueCell"].create(props.renderMode.name), tTransferTex: transferTex, uTransferScale: _mol_util__WEBPACK_IMPORTED_MODULE_6__["ValueCell"].create(getTransferScale(props.stepsPerCell)), dGridTexType: _mol_util__WEBPACK_IMPORTED_MODULE_6__["ValueCell"].create(gridTexture.ref.value.getDepth() > 0 ? '3d' : '2d'), uGridTexDim: gridTextureDim, tGridTex: gridTexture, uGridStats: gridStats, uCellDim: directVolume.cellDim, uCartnToUnit: directVolume.cartnToUnit, uUnitToCartn: directVolume.unitToCartn, dPackedGroup: directVolume.packedGroup, dSingleLayer: _mol_util__WEBPACK_IMPORTED_MODULE_6__["ValueCell"].create(singleLayer), dDoubleSided: _mol_util__WEBPACK_IMPORTED_MODULE_6__["ValueCell"].create(props.doubleSided), dFlatShaded: _mol_util__WEBPACK_IMPORTED_MODULE_6__["ValueCell"].create(props.flatShaded), dFlipSided: _mol_util__WEBPACK_IMPORTED_MODULE_6__["ValueCell"].create(props.flipSided), dIgnoreLight: _mol_util__WEBPACK_IMPORTED_MODULE_6__["ValueCell"].create(props.ignoreLight), dXrayShaded: _mol_util__WEBPACK_IMPORTED_MODULE_6__["ValueCell"].create(props.xrayShaded) });
    }
    function createValuesSimple(directVolume, props, colorValue, sizeValue, transform) {
        var s = _base__WEBPACK_IMPORTED_MODULE_9__["BaseGeometry"].createSimple(colorValue, sizeValue, transform);
        var p = Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_7__["ParamDefinition"].getDefaultValues(DirectVolume.Params)), props);
        return createValues(directVolume, s.transform, s.locationIterator, s.theme, p);
    }
    function updateValues(values, props) {
        _mol_util__WEBPACK_IMPORTED_MODULE_6__["ValueCell"].updateIfChanged(values.alpha, props.alpha);
        _mol_util__WEBPACK_IMPORTED_MODULE_6__["ValueCell"].updateIfChanged(values.uAlpha, props.alpha);
        _mol_util__WEBPACK_IMPORTED_MODULE_6__["ValueCell"].updateIfChanged(values.dDoubleSided, props.doubleSided);
        _mol_util__WEBPACK_IMPORTED_MODULE_6__["ValueCell"].updateIfChanged(values.dFlatShaded, props.flatShaded);
        _mol_util__WEBPACK_IMPORTED_MODULE_6__["ValueCell"].updateIfChanged(values.dFlipSided, props.flipSided);
        _mol_util__WEBPACK_IMPORTED_MODULE_6__["ValueCell"].updateIfChanged(values.dIgnoreLight, props.ignoreLight);
        _mol_util__WEBPACK_IMPORTED_MODULE_6__["ValueCell"].updateIfChanged(values.dXrayShaded, props.xrayShaded);
        _mol_util__WEBPACK_IMPORTED_MODULE_6__["ValueCell"].updateIfChanged(values.dRenderMode, props.renderMode.name);
        if (props.renderMode.name === 'isosurface') {
            _mol_util__WEBPACK_IMPORTED_MODULE_6__["ValueCell"].updateIfChanged(values.uIsoValue, getNormalizedIsoValue(values.uIsoValue.ref.value, props.renderMode.params.isoValue, values.uGridStats.ref.value));
            _mol_util__WEBPACK_IMPORTED_MODULE_6__["ValueCell"].updateIfChanged(values.dSingleLayer, props.renderMode.params.singleLayer);
        }
        else if (props.renderMode.name === 'volume') {
            var controlPoints = Object(_transfer_function__WEBPACK_IMPORTED_MODULE_14__["getControlPointsFromVec2Array"])(props.renderMode.params.controlPoints);
            Object(_transfer_function__WEBPACK_IMPORTED_MODULE_14__["createTransferFunctionTexture"])(controlPoints, props.renderMode.params.list.colors, values.tTransferTex);
        }
        _mol_util__WEBPACK_IMPORTED_MODULE_6__["ValueCell"].updateIfChanged(values.uMaxSteps, getMaxSteps(values.uGridDim.ref.value, props.stepsPerCell));
        _mol_util__WEBPACK_IMPORTED_MODULE_6__["ValueCell"].updateIfChanged(values.uStepScale, getStepScale(values.uCellDim.ref.value, props.stepsPerCell));
        _mol_util__WEBPACK_IMPORTED_MODULE_6__["ValueCell"].updateIfChanged(values.uTransferScale, getTransferScale(props.stepsPerCell));
        _mol_util__WEBPACK_IMPORTED_MODULE_6__["ValueCell"].updateIfChanged(values.uJumpLength, props.jumpLength);
    }
    function updateBoundingSphere(values, directVolume) {
        var invariantBoundingSphere = _mol_math_geometry__WEBPACK_IMPORTED_MODULE_4__["Sphere3D"].clone(directVolume.boundingSphere);
        var boundingSphere = Object(_mol_gl_renderable_util__WEBPACK_IMPORTED_MODULE_3__["calculateTransformBoundingSphere"])(invariantBoundingSphere, values.aTransform.ref.value, values.instanceCount.ref.value);
        if (!_mol_math_geometry__WEBPACK_IMPORTED_MODULE_4__["Sphere3D"].equals(boundingSphere, values.boundingSphere.ref.value)) {
            _mol_util__WEBPACK_IMPORTED_MODULE_6__["ValueCell"].update(values.boundingSphere, boundingSphere);
        }
        if (!_mol_math_geometry__WEBPACK_IMPORTED_MODULE_4__["Sphere3D"].equals(invariantBoundingSphere, values.invariantBoundingSphere.ref.value)) {
            _mol_util__WEBPACK_IMPORTED_MODULE_6__["ValueCell"].update(values.invariantBoundingSphere, invariantBoundingSphere);
            _mol_util__WEBPACK_IMPORTED_MODULE_6__["ValueCell"].update(values.uInvariantBoundingSphere, _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_5__["Vec4"].fromSphere(values.uInvariantBoundingSphere.ref.value, invariantBoundingSphere));
        }
    }
    function createRenderableState(props) {
        var state = _base__WEBPACK_IMPORTED_MODULE_9__["BaseGeometry"].createRenderableState(props);
        state.opaque = false;
        state.writeDepth = props.renderMode.name === 'isosurface';
        return state;
    }
    function updateRenderableState(state, props) {
        _base__WEBPACK_IMPORTED_MODULE_9__["BaseGeometry"].updateRenderableState(state, props);
        state.opaque = false;
        state.writeDepth = props.renderMode.name === 'isosurface';
    }
})(DirectVolume || (DirectVolume = {}));
//
function getBoundingSphere(gridDimension, gridTransform) {
    return _mol_math_geometry__WEBPACK_IMPORTED_MODULE_4__["Sphere3D"].fromDimensionsAndTransform(Object(_mol_math_geometry__WEBPACK_IMPORTED_MODULE_4__["Sphere3D"])(), gridDimension, gridTransform);
}
//# sourceMappingURL=direct-volume.js.map

/***/ }),

/***/ "./lib/mol-geo/geometry/direct-volume/transfer-function.js":
/*!*****************************************************************!*\
  !*** ./lib/mol-geo/geometry/direct-volume/transfer-function.js ***!
  \*****************************************************************/
/*! exports provided: getControlPointsFromString, getControlPointsFromVec2Array, createTransferFunctionTexture */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getControlPointsFromString", function() { return getControlPointsFromString; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getControlPointsFromVec2Array", function() { return getControlPointsFromVec2Array; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createTransferFunctionTexture", function() { return createTransferFunctionTexture; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _mol_math_interpolate__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../../mol-math/interpolate */ "./lib/mol-math/interpolate.js");
/* harmony import */ var _mol_util_color__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../../mol-util/color */ "./lib/mol-util/color/index.js");
/* harmony import */ var _mol_util__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../../mol-util */ "./lib/mol-util/index.js");
/**
 * Copyright (c) 2018 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */




function getControlPointsFromString(s) {
    return s.split(/\s*,\s*/).map(function (p) {
        var ps = p.split(/\s*:\s*/);
        return { x: parseFloat(ps[0]), alpha: parseFloat(ps[1]) };
    });
}
function getControlPointsFromVec2Array(array) {
    return array.map(function (v) { return ({ x: v[0], alpha: v[1] }); });
}
function createTransferFunctionTexture(controlPoints, listOrName, texture) {
    var cp = Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__spreadArrays"])([
        { x: 0, alpha: 0 },
        { x: 0, alpha: 0 }
    ], controlPoints, [
        { x: 1, alpha: 0 },
        { x: 1, alpha: 0 },
    ]);
    var scale = _mol_util_color__WEBPACK_IMPORTED_MODULE_2__["ColorScale"].create({ domain: [0, 1], listOrName: listOrName });
    var n = 256;
    var array = texture ? texture.ref.value.array : new Uint8Array(n * 4);
    var k = 0;
    var x1, x2;
    var a0, a1, a2, a3;
    var il = controlPoints.length + 1;
    for (var i = 0; i < il; ++i) {
        x1 = cp[i + 1].x;
        x2 = cp[i + 2].x;
        a0 = cp[i].alpha;
        a1 = cp[i + 1].alpha;
        a2 = cp[i + 2].alpha;
        a3 = cp[i + 3].alpha;
        var jl = Math.round((x2 - x1) * n);
        for (var j = 0; j < jl; ++j) {
            var t = j / jl;
            array[k * 4 + 3] = Math.max(0, Object(_mol_math_interpolate__WEBPACK_IMPORTED_MODULE_1__["spline"])(a0, a1, a2, a3, t, 0.5) * 255);
            scale.colorToArray(k / 255, array, k * 4);
            ++k;
        }
    }
    var textureImage = { array: array, width: 256, height: 1 };
    if (texture) {
        _mol_util__WEBPACK_IMPORTED_MODULE_3__["ValueCell"].update(texture, textureImage);
        return texture;
    }
    else {
        return _mol_util__WEBPACK_IMPORTED_MODULE_3__["ValueCell"].create(textureImage);
    }
}
//# sourceMappingURL=transfer-function.js.map

/***/ }),

/***/ "./lib/mol-geo/geometry/geometry.js":
/*!******************************************!*\
  !*** ./lib/mol-geo/geometry/geometry.js ***!
  \******************************************/
/*! exports provided: Geometry */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Geometry", function() { return Geometry; });
/* harmony import */ var _mesh_mesh__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./mesh/mesh */ "./lib/mol-geo/geometry/mesh/mesh.js");
/* harmony import */ var _points_points__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./points/points */ "./lib/mol-geo/geometry/points/points.js");
/* harmony import */ var _text_text__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./text/text */ "./lib/mol-geo/geometry/text/text.js");
/* harmony import */ var _lines_lines__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./lines/lines */ "./lib/mol-geo/geometry/lines/lines.js");
/* harmony import */ var _direct_volume_direct_volume__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./direct-volume/direct-volume */ "./lib/mol-geo/geometry/direct-volume/direct-volume.js");
/* harmony import */ var _spheres_spheres__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./spheres/spheres */ "./lib/mol-geo/geometry/spheres/spheres.js");
/* harmony import */ var _mol_util_array__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../../mol-util/array */ "./lib/mol-util/array.js");
/* harmony import */ var _texture_mesh_texture_mesh__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ./texture-mesh/texture-mesh */ "./lib/mol-geo/geometry/texture-mesh/texture-mesh.js");
/* harmony import */ var _image_image__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ./image/image */ "./lib/mol-geo/geometry/image/image.js");
/* harmony import */ var _cylinders_cylinders__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ./cylinders/cylinders */ "./lib/mol-geo/geometry/cylinders/cylinders.js");
/**
 * Copyright (c) 2018-2020 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */










var Geometry;
(function (Geometry) {
    function getDrawCount(geometry) {
        switch (geometry.kind) {
            case 'mesh': return geometry.triangleCount * 3;
            case 'points': return geometry.pointCount;
            case 'spheres': return geometry.sphereCount * 2 * 3;
            case 'cylinders': return geometry.cylinderCount * 4 * 3;
            case 'text': return geometry.charCount * 2 * 3;
            case 'lines': return geometry.lineCount * 2 * 3;
            case 'direct-volume': return 12 * 3;
            case 'image': return 2 * 3;
            case 'texture-mesh': return geometry.vertexCount;
        }
    }
    Geometry.getDrawCount = getDrawCount;
    function getVertexCount(geometry) {
        switch (geometry.kind) {
            case 'mesh': return geometry.vertexCount;
            case 'points': return geometry.pointCount;
            case 'spheres': return geometry.sphereCount * 4;
            case 'cylinders': return geometry.cylinderCount * 6;
            case 'text': return geometry.charCount * 4;
            case 'lines': return geometry.lineCount * 4;
            case 'direct-volume':
                var _a = geometry.gridDimension.ref.value, x = _a[0], y = _a[1], z = _a[2];
                return x * y * z;
            case 'image': return 4;
            case 'texture-mesh': return geometry.vertexCount;
        }
    }
    Geometry.getVertexCount = getVertexCount;
    function getGroupCount(geometry) {
        switch (geometry.kind) {
            case 'mesh':
            case 'points':
            case 'spheres':
            case 'cylinders':
            case 'text':
            case 'lines':
                return getDrawCount(geometry) === 0 ? 0 : (Object(_mol_util_array__WEBPACK_IMPORTED_MODULE_6__["arrayMax"])(geometry.groupBuffer.ref.value) + 1);
            case 'direct-volume':
                return 1;
            case 'image':
                return Object(_mol_util_array__WEBPACK_IMPORTED_MODULE_6__["arrayMax"])(geometry.groupTexture.ref.value.array) + 1;
            case 'texture-mesh':
                return geometry.groupCount;
        }
    }
    Geometry.getGroupCount = getGroupCount;
    function getUtils(geometry) {
        // TODO avoid casting
        switch (geometry.kind) {
            case 'mesh': return _mesh_mesh__WEBPACK_IMPORTED_MODULE_0__["Mesh"].Utils;
            case 'points': return _points_points__WEBPACK_IMPORTED_MODULE_1__["Points"].Utils;
            case 'spheres': return _spheres_spheres__WEBPACK_IMPORTED_MODULE_5__["Spheres"].Utils;
            case 'cylinders': return _cylinders_cylinders__WEBPACK_IMPORTED_MODULE_9__["Cylinders"].Utils;
            case 'text': return _text_text__WEBPACK_IMPORTED_MODULE_2__["Text"].Utils;
            case 'lines': return _lines_lines__WEBPACK_IMPORTED_MODULE_3__["Lines"].Utils;
            case 'direct-volume': return _direct_volume_direct_volume__WEBPACK_IMPORTED_MODULE_4__["DirectVolume"].Utils;
            case 'image': return _image_image__WEBPACK_IMPORTED_MODULE_8__["Image"].Utils;
            case 'texture-mesh': return _texture_mesh_texture_mesh__WEBPACK_IMPORTED_MODULE_7__["TextureMesh"].Utils;
        }
    }
    Geometry.getUtils = getUtils;
    function getGranularity(locationIt, granularity) {
        return granularity === 'instance' && locationIt.nonInstanceable ? 'group' : granularity;
    }
    Geometry.getGranularity = getGranularity;
})(Geometry || (Geometry = {}));
//# sourceMappingURL=geometry.js.map

/***/ }),

/***/ "./lib/mol-geo/geometry/image/image.js":
/*!*********************************************!*\
  !*** ./lib/mol-geo/geometry/image/image.js ***!
  \*********************************************/
/*! exports provided: InterpolationTypes, InterpolationTypeNames, Image */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "InterpolationTypes", function() { return InterpolationTypes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "InterpolationTypeNames", function() { return InterpolationTypeNames; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Image", function() { return Image; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _mol_data_util__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../../mol-data/util */ "./lib/mol-data/util.js");
/* harmony import */ var _mol_geo_util_location_iterator__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../../mol-geo/util/location-iterator */ "./lib/mol-geo/util/location-iterator.js");
/* harmony import */ var _mol_gl_renderable_util__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../../mol-gl/renderable/util */ "./lib/mol-gl/renderable/util.js");
/* harmony import */ var _mol_math_geometry__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../../mol-math/geometry */ "./lib/mol-math/geometry.js");
/* harmony import */ var _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../../mol-math/linear-algebra */ "./lib/mol-math/linear-algebra.js");
/* harmony import */ var _mol_util__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../../../mol-util */ "./lib/mol-util/index.js");
/* harmony import */ var _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../../../mol-util/param-definition */ "./lib/mol-util/param-definition.js");
/* harmony import */ var _base__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ../base */ "./lib/mol-geo/geometry/base.js");
/* harmony import */ var _color_data__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ../color-data */ "./lib/mol-geo/geometry/color-data.js");
/* harmony import */ var _marker_data__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ../marker-data */ "./lib/mol-geo/geometry/marker-data.js");
/* harmony import */ var _overpaint_data__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ../overpaint-data */ "./lib/mol-geo/geometry/overpaint-data.js");
/* harmony import */ var _transparency_data__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! ../transparency-data */ "./lib/mol-geo/geometry/transparency-data.js");
/* harmony import */ var _mol_util_array__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! ../../../mol-util/array */ "./lib/mol-util/array.js");
/* harmony import */ var _clipping_data__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! ../clipping-data */ "./lib/mol-geo/geometry/clipping-data.js");
/* harmony import */ var _mol_model_location__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! ../../../mol-model/location */ "./lib/mol-model/location.js");
/* harmony import */ var _mol_gl_compute_util__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(/*! ../../../mol-gl/compute/util */ "./lib/mol-gl/compute/util.js");
/**
 * Copyright (c) 2020 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */

















var QuadIndices = new Uint32Array([
    0, 1, 2,
    1, 3, 2
]);
var QuadUvs = new Float32Array([
    0, 1,
    0, 0,
    1, 1,
    1, 0
]);
var InterpolationTypes = {
    'nearest': 'Nearest',
    'catmulrom': 'Catmulrom (Cubic)',
    'mitchell': 'Mitchell (Cubic)',
    'bspline': 'B-Spline (Cubic)'
};
var InterpolationTypeNames = Object.keys(InterpolationTypes);

var Image;
(function (Image) {
    function create(imageTexture, corners, groupTexture, image) {
        return image ?
            update(imageTexture, corners, groupTexture, image) :
            fromData(imageTexture, corners, groupTexture);
    }
    Image.create = create;
    function hashCode(image) {
        return Object(_mol_data_util__WEBPACK_IMPORTED_MODULE_1__["hashFnv32a"])([
            image.cornerBuffer.ref.version
        ]);
    }
    function fromData(imageTexture, corners, groupTexture) {
        var boundingSphere = Object(_mol_math_geometry__WEBPACK_IMPORTED_MODULE_4__["Sphere3D"])();
        var currentHash = -1;
        var width = imageTexture.width;
        var height = imageTexture.height;
        var image = {
            kind: 'image',
            imageTexture: _mol_util__WEBPACK_IMPORTED_MODULE_6__["ValueCell"].create(imageTexture),
            imageTextureDim: _mol_util__WEBPACK_IMPORTED_MODULE_6__["ValueCell"].create(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_5__["Vec2"].create(width, height)),
            cornerBuffer: _mol_util__WEBPACK_IMPORTED_MODULE_6__["ValueCell"].create(corners),
            groupTexture: _mol_util__WEBPACK_IMPORTED_MODULE_6__["ValueCell"].create(groupTexture),
            get boundingSphere() {
                var newHash = hashCode(image);
                if (newHash !== currentHash) {
                    var b = getBoundingSphere(image.cornerBuffer.ref.value);
                    _mol_math_geometry__WEBPACK_IMPORTED_MODULE_4__["Sphere3D"].copy(boundingSphere, b);
                    currentHash = newHash;
                }
                return boundingSphere;
            },
        };
        return image;
    }
    function update(imageTexture, corners, groupTexture, image) {
        var width = imageTexture.width;
        var height = imageTexture.height;
        _mol_util__WEBPACK_IMPORTED_MODULE_6__["ValueCell"].update(image.imageTexture, imageTexture);
        _mol_util__WEBPACK_IMPORTED_MODULE_6__["ValueCell"].update(image.imageTextureDim, _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_5__["Vec2"].set(image.imageTextureDim.ref.value, width, height));
        _mol_util__WEBPACK_IMPORTED_MODULE_6__["ValueCell"].update(image.cornerBuffer, corners);
        _mol_util__WEBPACK_IMPORTED_MODULE_6__["ValueCell"].update(image.groupTexture, groupTexture);
        return image;
    }
    function createEmpty(image) {
        return {}; // TODO
    }
    Image.createEmpty = createEmpty;
    Image.Params = Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, _base__WEBPACK_IMPORTED_MODULE_8__["BaseGeometry"].Params), { interpolation: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_7__["ParamDefinition"].Select('bspline', _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_7__["ParamDefinition"].objectToOptions(InterpolationTypes)) });
    Image.Utils = {
        Params: Image.Params,
        createEmpty: createEmpty,
        createValues: createValues,
        createValuesSimple: createValuesSimple,
        updateValues: updateValues,
        updateBoundingSphere: updateBoundingSphere,
        createRenderableState: createRenderableState,
        updateRenderableState: updateRenderableState,
        createPositionIterator: function () { return Object(_mol_geo_util_location_iterator__WEBPACK_IMPORTED_MODULE_2__["LocationIterator"])(1, 1, 1, function () { return _mol_model_location__WEBPACK_IMPORTED_MODULE_15__["NullLocation"]; }); }
    };
    function createValues(image, transform, locationIt, theme, props) {
        var instanceCount = locationIt.instanceCount, groupCount = locationIt.groupCount;
        var positionIt = Image.Utils.createPositionIterator(image, transform);
        var color = Object(_color_data__WEBPACK_IMPORTED_MODULE_9__["createColors"])(locationIt, positionIt, theme.color);
        var marker = Object(_marker_data__WEBPACK_IMPORTED_MODULE_10__["createMarkers"])(instanceCount * groupCount);
        var overpaint = Object(_overpaint_data__WEBPACK_IMPORTED_MODULE_11__["createEmptyOverpaint"])();
        var transparency = Object(_transparency_data__WEBPACK_IMPORTED_MODULE_12__["createEmptyTransparency"])();
        var clipping = Object(_clipping_data__WEBPACK_IMPORTED_MODULE_14__["createEmptyClipping"])();
        var counts = { drawCount: QuadIndices.length, vertexCount: _mol_gl_compute_util__WEBPACK_IMPORTED_MODULE_16__["QuadPositions"].length / 3, groupCount: groupCount, instanceCount: instanceCount };
        var invariantBoundingSphere = _mol_math_geometry__WEBPACK_IMPORTED_MODULE_4__["Sphere3D"].clone(image.boundingSphere);
        var boundingSphere = Object(_mol_gl_renderable_util__WEBPACK_IMPORTED_MODULE_3__["calculateTransformBoundingSphere"])(invariantBoundingSphere, transform.aTransform.ref.value, instanceCount);
        return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, color), marker), overpaint), transparency), clipping), transform), _base__WEBPACK_IMPORTED_MODULE_8__["BaseGeometry"].createValues(props, counts)), { aPosition: image.cornerBuffer, aUv: _mol_util__WEBPACK_IMPORTED_MODULE_6__["ValueCell"].create(QuadUvs), elements: _mol_util__WEBPACK_IMPORTED_MODULE_6__["ValueCell"].create(QuadIndices), 
            // aGroup is used as a vertex index here, group id is in tGroupTex
            aGroup: _mol_util__WEBPACK_IMPORTED_MODULE_6__["ValueCell"].create(Object(_mol_util_array__WEBPACK_IMPORTED_MODULE_13__["fillSerial"])(new Float32Array(4))), boundingSphere: _mol_util__WEBPACK_IMPORTED_MODULE_6__["ValueCell"].create(boundingSphere), invariantBoundingSphere: _mol_util__WEBPACK_IMPORTED_MODULE_6__["ValueCell"].create(invariantBoundingSphere), uInvariantBoundingSphere: _mol_util__WEBPACK_IMPORTED_MODULE_6__["ValueCell"].create(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_5__["Vec4"].ofSphere(invariantBoundingSphere)), dInterpolation: _mol_util__WEBPACK_IMPORTED_MODULE_6__["ValueCell"].create(props.interpolation), uImageTexDim: image.imageTextureDim, tImageTex: image.imageTexture, tGroupTex: image.groupTexture });
    }
    function createValuesSimple(image, props, colorValue, sizeValue, transform) {
        var s = _base__WEBPACK_IMPORTED_MODULE_8__["BaseGeometry"].createSimple(colorValue, sizeValue, transform);
        var p = Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_7__["ParamDefinition"].getDefaultValues(Image.Params)), props);
        return createValues(image, s.transform, s.locationIterator, s.theme, p);
    }
    function updateValues(values, props) {
        _base__WEBPACK_IMPORTED_MODULE_8__["BaseGeometry"].updateValues(values, props);
        _mol_util__WEBPACK_IMPORTED_MODULE_6__["ValueCell"].updateIfChanged(values.dInterpolation, props.interpolation);
    }
    function updateBoundingSphere(values, image) {
        var invariantBoundingSphere = _mol_math_geometry__WEBPACK_IMPORTED_MODULE_4__["Sphere3D"].clone(image.boundingSphere);
        var boundingSphere = Object(_mol_gl_renderable_util__WEBPACK_IMPORTED_MODULE_3__["calculateTransformBoundingSphere"])(invariantBoundingSphere, values.aTransform.ref.value, values.instanceCount.ref.value);
        if (!_mol_math_geometry__WEBPACK_IMPORTED_MODULE_4__["Sphere3D"].equals(boundingSphere, values.boundingSphere.ref.value)) {
            _mol_util__WEBPACK_IMPORTED_MODULE_6__["ValueCell"].update(values.boundingSphere, boundingSphere);
        }
        if (!_mol_math_geometry__WEBPACK_IMPORTED_MODULE_4__["Sphere3D"].equals(invariantBoundingSphere, values.invariantBoundingSphere.ref.value)) {
            _mol_util__WEBPACK_IMPORTED_MODULE_6__["ValueCell"].update(values.invariantBoundingSphere, invariantBoundingSphere);
            _mol_util__WEBPACK_IMPORTED_MODULE_6__["ValueCell"].update(values.uInvariantBoundingSphere, _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_5__["Vec4"].fromSphere(values.uInvariantBoundingSphere.ref.value, invariantBoundingSphere));
        }
    }
    function createRenderableState(props) {
        var state = _base__WEBPACK_IMPORTED_MODULE_8__["BaseGeometry"].createRenderableState(props);
        state.opaque = false;
        return state;
    }
    function updateRenderableState(state, props) {
        _base__WEBPACK_IMPORTED_MODULE_8__["BaseGeometry"].updateRenderableState(state, props);
        state.opaque = false;
    }
})(Image || (Image = {}));
//
function getBoundingSphere(corners) {
    var center = Object(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_5__["Vec3"])();
    var extrema = [];
    for (var i = 0, il = corners.length; i < il; i += 3) {
        var e = _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_5__["Vec3"].fromArray(Object(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_5__["Vec3"])(), corners, i);
        extrema.push(e);
        _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_5__["Vec3"].add(center, center, e);
    }
    _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_5__["Vec3"].scale(center, center, 1 / (corners.length / 3));
    var radius = 0;
    for (var _i = 0, extrema_1 = extrema; _i < extrema_1.length; _i++) {
        var e = extrema_1[_i];
        var d = _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_5__["Vec3"].distance(center, e);
        if (d > radius)
            radius = d;
    }
    var sphere = _mol_math_geometry__WEBPACK_IMPORTED_MODULE_4__["Sphere3D"].create(center, radius);
    _mol_math_geometry__WEBPACK_IMPORTED_MODULE_4__["Sphere3D"].setExtrema(sphere, extrema);
    return sphere;
}
//# sourceMappingURL=image.js.map

/***/ }),

/***/ "./lib/mol-geo/geometry/lines/lines-builder.js":
/*!*****************************************************!*\
  !*** ./lib/mol-geo/geometry/lines/lines-builder.js ***!
  \*****************************************************/
/*! exports provided: LinesBuilder */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "LinesBuilder", function() { return LinesBuilder; });
/* harmony import */ var _mol_data_util__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../../mol-data/util */ "./lib/mol-data/util.js");
/* harmony import */ var _lines__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./lines */ "./lib/mol-geo/geometry/lines/lines.js");
/* harmony import */ var _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../../mol-math/linear-algebra */ "./lib/mol-math/linear-algebra.js");
/**
 * Copyright (c) 2018-2020 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */



var tmpVecA = Object(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_2__["Vec3"])();
var tmpVecB = Object(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_2__["Vec3"])();
var tmpDir = Object(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_2__["Vec3"])();
// avoiding namespace lookup improved performance in Chrome (Aug 2020)
var caAdd = _mol_data_util__WEBPACK_IMPORTED_MODULE_0__["ChunkedArray"].add;
var caAdd3 = _mol_data_util__WEBPACK_IMPORTED_MODULE_0__["ChunkedArray"].add3;
var LinesBuilder;
(function (LinesBuilder) {
    function create(initialCount, chunkSize, lines) {
        if (initialCount === void 0) { initialCount = 2048; }
        if (chunkSize === void 0) { chunkSize = 1024; }
        var groups = _mol_data_util__WEBPACK_IMPORTED_MODULE_0__["ChunkedArray"].create(Float32Array, 1, chunkSize, lines ? lines.groupBuffer.ref.value : initialCount);
        var starts = _mol_data_util__WEBPACK_IMPORTED_MODULE_0__["ChunkedArray"].create(Float32Array, 3, chunkSize, lines ? lines.startBuffer.ref.value : initialCount);
        var ends = _mol_data_util__WEBPACK_IMPORTED_MODULE_0__["ChunkedArray"].create(Float32Array, 3, chunkSize, lines ? lines.endBuffer.ref.value : initialCount);
        var add = function (startX, startY, startZ, endX, endY, endZ, group) {
            for (var i = 0; i < 4; ++i) {
                caAdd3(starts, startX, startY, startZ);
                caAdd3(ends, endX, endY, endZ);
                caAdd(groups, group);
            }
        };
        var addVec = function (start, end, group) {
            for (var i = 0; i < 4; ++i) {
                caAdd3(starts, start[0], start[1], start[2]);
                caAdd3(ends, end[0], end[1], end[2]);
                caAdd(groups, group);
            }
        };
        var addFixedCountDashes = function (start, end, segmentCount, group) {
            var d = _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_2__["Vec3"].distance(start, end);
            var s = Math.floor(segmentCount / 2);
            var step = 1 / segmentCount;
            _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_2__["Vec3"].sub(tmpDir, end, start);
            for (var j = 0; j < s; ++j) {
                var f = step * (j * 2 + 1);
                _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_2__["Vec3"].setMagnitude(tmpDir, tmpDir, d * f);
                _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_2__["Vec3"].add(tmpVecA, start, tmpDir);
                _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_2__["Vec3"].setMagnitude(tmpDir, tmpDir, d * step * ((j + 1) * 2));
                _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_2__["Vec3"].add(tmpVecB, start, tmpDir);
                add(tmpVecA[0], tmpVecA[1], tmpVecA[2], tmpVecB[0], tmpVecB[1], tmpVecB[2], group);
            }
        };
        return {
            add: add,
            addVec: addVec,
            addFixedCountDashes: addFixedCountDashes,
            addFixedLengthDashes: function (start, end, segmentLength, group) {
                var d = _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_2__["Vec3"].distance(start, end);
                addFixedCountDashes(start, end, d / segmentLength, group);
            },
            addCage: function (t, cage, group) {
                var vertices = cage.vertices, edges = cage.edges;
                for (var i = 0, il = edges.length; i < il; i += 2) {
                    _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_2__["Vec3"].fromArray(tmpVecA, vertices, edges[i] * 3);
                    _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_2__["Vec3"].fromArray(tmpVecB, vertices, edges[i + 1] * 3);
                    _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_2__["Vec3"].transformMat4(tmpVecA, tmpVecA, t);
                    _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_2__["Vec3"].transformMat4(tmpVecB, tmpVecB, t);
                    add(tmpVecA[0], tmpVecA[1], tmpVecA[2], tmpVecB[0], tmpVecB[1], tmpVecB[2], group);
                }
            },
            getLines: function () {
                var lineCount = groups.elementCount / 4;
                var gb = _mol_data_util__WEBPACK_IMPORTED_MODULE_0__["ChunkedArray"].compact(groups, true);
                var sb = _mol_data_util__WEBPACK_IMPORTED_MODULE_0__["ChunkedArray"].compact(starts, true);
                var eb = _mol_data_util__WEBPACK_IMPORTED_MODULE_0__["ChunkedArray"].compact(ends, true);
                var mb = lines && lineCount <= lines.lineCount ? lines.mappingBuffer.ref.value : new Float32Array(lineCount * 8);
                var ib = lines && lineCount <= lines.lineCount ? lines.indexBuffer.ref.value : new Uint32Array(lineCount * 6);
                if (!lines || lineCount > lines.lineCount)
                    fillMappingAndIndices(lineCount, mb, ib);
                return _lines__WEBPACK_IMPORTED_MODULE_1__["Lines"].create(mb, ib, gb, sb, eb, lineCount, lines);
            }
        };
    }
    LinesBuilder.create = create;
})(LinesBuilder || (LinesBuilder = {}));
function fillMappingAndIndices(n, mb, ib) {
    for (var i = 0; i < n; ++i) {
        var mo = i * 8;
        mb[mo] = -1;
        mb[mo + 1] = -1;
        mb[mo + 2] = 1;
        mb[mo + 3] = -1;
        mb[mo + 4] = -1;
        mb[mo + 5] = 1;
        mb[mo + 6] = 1;
        mb[mo + 7] = 1;
    }
    for (var i = 0; i < n; ++i) {
        var o = i * 4;
        var io = i * 6;
        ib[io] = o;
        ib[io + 1] = o + 1;
        ib[io + 2] = o + 2;
        ib[io + 3] = o + 1;
        ib[io + 4] = o + 3;
        ib[io + 5] = o + 2;
    }
}
//# sourceMappingURL=lines-builder.js.map

/***/ }),

/***/ "./lib/mol-geo/geometry/lines/lines.js":
/*!*********************************************!*\
  !*** ./lib/mol-geo/geometry/lines/lines.js ***!
  \*********************************************/
/*! exports provided: Lines */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Lines", function() { return Lines; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _mol_util__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../../mol-util */ "./lib/mol-util/index.js");
/* harmony import */ var _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../../mol-math/linear-algebra */ "./lib/mol-math/linear-algebra.js");
/* harmony import */ var _util__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../util */ "./lib/mol-geo/util.js");
/* harmony import */ var _color_data__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../color-data */ "./lib/mol-geo/geometry/color-data.js");
/* harmony import */ var _marker_data__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../marker-data */ "./lib/mol-geo/geometry/marker-data.js");
/* harmony import */ var _size_data__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../size-data */ "./lib/mol-geo/geometry/size-data.js");
/* harmony import */ var _util_location_iterator__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../../util/location-iterator */ "./lib/mol-geo/util/location-iterator.js");
/* harmony import */ var _lines_builder__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ./lines-builder */ "./lib/mol-geo/geometry/lines/lines-builder.js");
/* harmony import */ var _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ../../../mol-util/param-definition */ "./lib/mol-util/param-definition.js");
/* harmony import */ var _mol_gl_renderable_util__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ../../../mol-gl/renderable/util */ "./lib/mol-gl/renderable/util.js");
/* harmony import */ var _mol_math_geometry__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ../../../mol-math/geometry */ "./lib/mol-math/geometry.js");
/* harmony import */ var _base__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! ../base */ "./lib/mol-geo/geometry/base.js");
/* harmony import */ var _overpaint_data__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! ../overpaint-data */ "./lib/mol-geo/geometry/overpaint-data.js");
/* harmony import */ var _transparency_data__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! ../transparency-data */ "./lib/mol-geo/geometry/transparency-data.js");
/* harmony import */ var _mol_data_util__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! ../../../mol-data/util */ "./lib/mol-data/util.js");
/* harmony import */ var _clipping_data__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(/*! ../clipping-data */ "./lib/mol-geo/geometry/clipping-data.js");
/**
 * Copyright (c) 2018-2020 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */

















var Lines;
(function (Lines) {
    function create(mappings, indices, groups, starts, ends, lineCount, lines) {
        return lines ?
            update(mappings, indices, groups, starts, ends, lineCount, lines) :
            fromArrays(mappings, indices, groups, starts, ends, lineCount);
    }
    Lines.create = create;
    function createEmpty(lines) {
        var mb = lines ? lines.mappingBuffer.ref.value : new Float32Array(0);
        var ib = lines ? lines.indexBuffer.ref.value : new Uint32Array(0);
        var gb = lines ? lines.groupBuffer.ref.value : new Float32Array(0);
        var sb = lines ? lines.startBuffer.ref.value : new Float32Array(0);
        var eb = lines ? lines.endBuffer.ref.value : new Float32Array(0);
        return create(mb, ib, gb, sb, eb, 0, lines);
    }
    Lines.createEmpty = createEmpty;
    function fromMesh(mesh, lines) {
        var vb = mesh.vertexBuffer.ref.value;
        var ib = mesh.indexBuffer.ref.value;
        var gb = mesh.groupBuffer.ref.value;
        var builder = _lines_builder__WEBPACK_IMPORTED_MODULE_8__["LinesBuilder"].create(mesh.triangleCount * 3, mesh.triangleCount / 10, lines);
        // TODO avoid duplicate lines
        for (var i = 0, il = mesh.triangleCount * 3; i < il; i += 3) {
            var i0 = ib[i], i1 = ib[i + 1], i2 = ib[i + 2];
            var x0 = vb[i0 * 3], y0 = vb[i0 * 3 + 1], z0 = vb[i0 * 3 + 2];
            var x1 = vb[i1 * 3], y1 = vb[i1 * 3 + 1], z1 = vb[i1 * 3 + 2];
            var x2 = vb[i2 * 3], y2 = vb[i2 * 3 + 1], z2 = vb[i2 * 3 + 2];
            builder.add(x0, y0, z0, x1, y1, z1, gb[i0]);
            builder.add(x0, y0, z0, x2, y2, z2, gb[i0]);
            builder.add(x1, y1, z1, x2, y2, z2, gb[i1]);
        }
        return builder.getLines();
    }
    Lines.fromMesh = fromMesh;
    function hashCode(lines) {
        return Object(_mol_data_util__WEBPACK_IMPORTED_MODULE_15__["hashFnv32a"])([
            lines.lineCount, lines.mappingBuffer.ref.version, lines.indexBuffer.ref.version,
            lines.groupBuffer.ref.version, lines.startBuffer.ref.version, lines.endBuffer.ref.version
        ]);
    }
    function fromArrays(mappings, indices, groups, starts, ends, lineCount) {
        var boundingSphere = Object(_mol_math_geometry__WEBPACK_IMPORTED_MODULE_11__["Sphere3D"])();
        var groupMapping;
        var currentHash = -1;
        var currentGroup = -1;
        var lines = {
            kind: 'lines',
            lineCount: lineCount,
            mappingBuffer: _mol_util__WEBPACK_IMPORTED_MODULE_1__["ValueCell"].create(mappings),
            indexBuffer: _mol_util__WEBPACK_IMPORTED_MODULE_1__["ValueCell"].create(indices),
            groupBuffer: _mol_util__WEBPACK_IMPORTED_MODULE_1__["ValueCell"].create(groups),
            startBuffer: _mol_util__WEBPACK_IMPORTED_MODULE_1__["ValueCell"].create(starts),
            endBuffer: _mol_util__WEBPACK_IMPORTED_MODULE_1__["ValueCell"].create(ends),
            get boundingSphere() {
                var newHash = hashCode(lines);
                if (newHash !== currentHash) {
                    var s = Object(_mol_gl_renderable_util__WEBPACK_IMPORTED_MODULE_10__["calculateInvariantBoundingSphere"])(lines.startBuffer.ref.value, lines.lineCount * 4, 4);
                    var e = Object(_mol_gl_renderable_util__WEBPACK_IMPORTED_MODULE_10__["calculateInvariantBoundingSphere"])(lines.endBuffer.ref.value, lines.lineCount * 4, 4);
                    _mol_math_geometry__WEBPACK_IMPORTED_MODULE_11__["Sphere3D"].expandBySphere(boundingSphere, s, e);
                    currentHash = newHash;
                }
                return boundingSphere;
            },
            get groupMapping() {
                if (lines.groupBuffer.ref.version !== currentGroup) {
                    groupMapping = Object(_util__WEBPACK_IMPORTED_MODULE_3__["createGroupMapping"])(lines.groupBuffer.ref.value, lines.lineCount, 4);
                    currentGroup = lines.groupBuffer.ref.version;
                }
                return groupMapping;
            },
            setBoundingSphere: function (sphere) {
                _mol_math_geometry__WEBPACK_IMPORTED_MODULE_11__["Sphere3D"].copy(boundingSphere, sphere);
                currentHash = hashCode(lines);
            }
        };
        return lines;
    }
    function update(mappings, indices, groups, starts, ends, lineCount, lines) {
        if (lineCount > lines.lineCount) {
            _mol_util__WEBPACK_IMPORTED_MODULE_1__["ValueCell"].update(lines.mappingBuffer, mappings);
            _mol_util__WEBPACK_IMPORTED_MODULE_1__["ValueCell"].update(lines.indexBuffer, indices);
        }
        lines.lineCount = lineCount;
        _mol_util__WEBPACK_IMPORTED_MODULE_1__["ValueCell"].update(lines.groupBuffer, groups);
        _mol_util__WEBPACK_IMPORTED_MODULE_1__["ValueCell"].update(lines.startBuffer, starts);
        _mol_util__WEBPACK_IMPORTED_MODULE_1__["ValueCell"].update(lines.endBuffer, ends);
        return lines;
    }
    function transform(lines, t) {
        var start = lines.startBuffer.ref.value;
        Object(_util__WEBPACK_IMPORTED_MODULE_3__["transformPositionArray"])(t, start, 0, lines.lineCount * 4);
        _mol_util__WEBPACK_IMPORTED_MODULE_1__["ValueCell"].update(lines.startBuffer, start);
        var end = lines.endBuffer.ref.value;
        Object(_util__WEBPACK_IMPORTED_MODULE_3__["transformPositionArray"])(t, end, 0, lines.lineCount * 4);
        _mol_util__WEBPACK_IMPORTED_MODULE_1__["ValueCell"].update(lines.endBuffer, end);
    }
    Lines.transform = transform;
    //
    Lines.Params = Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, _base__WEBPACK_IMPORTED_MODULE_12__["BaseGeometry"].Params), { sizeFactor: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_9__["ParamDefinition"].Numeric(1.5, { min: 0, max: 10, step: 0.1 }), lineSizeAttenuation: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_9__["ParamDefinition"].Boolean(false) });
    Lines.Utils = {
        Params: Lines.Params,
        createEmpty: createEmpty,
        createValues: createValues,
        createValuesSimple: createValuesSimple,
        updateValues: updateValues,
        updateBoundingSphere: updateBoundingSphere,
        createRenderableState: _base__WEBPACK_IMPORTED_MODULE_12__["BaseGeometry"].createRenderableState,
        updateRenderableState: _base__WEBPACK_IMPORTED_MODULE_12__["BaseGeometry"].updateRenderableState,
        createPositionIterator: createPositionIterator
    };
    function createPositionIterator(lines, transform) {
        var groupCount = lines.lineCount * 4;
        var instanceCount = transform.instanceCount.ref.value;
        var location = Object(_util_location_iterator__WEBPACK_IMPORTED_MODULE_7__["PositionLocation"])();
        var p = location.position;
        var s = lines.startBuffer.ref.value;
        var e = lines.endBuffer.ref.value;
        var m = transform.aTransform.ref.value;
        var getLocation = function (groupIndex, instanceIndex) {
            var v = groupIndex % 4 === 0 ? s : e;
            if (instanceIndex < 0) {
                _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_2__["Vec3"].fromArray(p, v, groupIndex * 3);
            }
            else {
                _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_2__["Vec3"].transformMat4Offset(p, v, m, 0, groupIndex * 3, instanceIndex * 16);
            }
            return location;
        };
        return Object(_util_location_iterator__WEBPACK_IMPORTED_MODULE_7__["LocationIterator"])(groupCount, instanceCount, 2, getLocation);
    }
    function createValues(lines, transform, locationIt, theme, props) {
        var instanceCount = locationIt.instanceCount, groupCount = locationIt.groupCount;
        var positionIt = createPositionIterator(lines, transform);
        var color = Object(_color_data__WEBPACK_IMPORTED_MODULE_4__["createColors"])(locationIt, positionIt, theme.color);
        var size = Object(_size_data__WEBPACK_IMPORTED_MODULE_6__["createSizes"])(locationIt, theme.size);
        var marker = Object(_marker_data__WEBPACK_IMPORTED_MODULE_5__["createMarkers"])(instanceCount * groupCount);
        var overpaint = Object(_overpaint_data__WEBPACK_IMPORTED_MODULE_13__["createEmptyOverpaint"])();
        var transparency = Object(_transparency_data__WEBPACK_IMPORTED_MODULE_14__["createEmptyTransparency"])();
        var clipping = Object(_clipping_data__WEBPACK_IMPORTED_MODULE_16__["createEmptyClipping"])();
        var counts = { drawCount: lines.lineCount * 2 * 3, vertexCount: lines.lineCount * 4, groupCount: groupCount, instanceCount: instanceCount };
        var invariantBoundingSphere = _mol_math_geometry__WEBPACK_IMPORTED_MODULE_11__["Sphere3D"].clone(lines.boundingSphere);
        var boundingSphere = Object(_mol_gl_renderable_util__WEBPACK_IMPORTED_MODULE_10__["calculateTransformBoundingSphere"])(invariantBoundingSphere, transform.aTransform.ref.value, instanceCount);
        return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({ aMapping: lines.mappingBuffer, aGroup: lines.groupBuffer, aStart: lines.startBuffer, aEnd: lines.endBuffer, elements: lines.indexBuffer, boundingSphere: _mol_util__WEBPACK_IMPORTED_MODULE_1__["ValueCell"].create(boundingSphere), invariantBoundingSphere: _mol_util__WEBPACK_IMPORTED_MODULE_1__["ValueCell"].create(invariantBoundingSphere), uInvariantBoundingSphere: _mol_util__WEBPACK_IMPORTED_MODULE_1__["ValueCell"].create(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_2__["Vec4"].ofSphere(invariantBoundingSphere)) }, color), size), marker), overpaint), transparency), clipping), transform), _base__WEBPACK_IMPORTED_MODULE_12__["BaseGeometry"].createValues(props, counts)), { uSizeFactor: _mol_util__WEBPACK_IMPORTED_MODULE_1__["ValueCell"].create(props.sizeFactor), dLineSizeAttenuation: _mol_util__WEBPACK_IMPORTED_MODULE_1__["ValueCell"].create(props.lineSizeAttenuation), dDoubleSided: _mol_util__WEBPACK_IMPORTED_MODULE_1__["ValueCell"].create(true), dFlipSided: _mol_util__WEBPACK_IMPORTED_MODULE_1__["ValueCell"].create(false) });
    }
    function createValuesSimple(lines, props, colorValue, sizeValue, transform) {
        var s = _base__WEBPACK_IMPORTED_MODULE_12__["BaseGeometry"].createSimple(colorValue, sizeValue, transform);
        var p = Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_9__["ParamDefinition"].getDefaultValues(Lines.Params)), props);
        return createValues(lines, s.transform, s.locationIterator, s.theme, p);
    }
    function updateValues(values, props) {
        _base__WEBPACK_IMPORTED_MODULE_12__["BaseGeometry"].updateValues(values, props);
        _mol_util__WEBPACK_IMPORTED_MODULE_1__["ValueCell"].updateIfChanged(values.uSizeFactor, props.sizeFactor);
        _mol_util__WEBPACK_IMPORTED_MODULE_1__["ValueCell"].updateIfChanged(values.dLineSizeAttenuation, props.lineSizeAttenuation);
    }
    function updateBoundingSphere(values, lines) {
        var invariantBoundingSphere = _mol_math_geometry__WEBPACK_IMPORTED_MODULE_11__["Sphere3D"].clone(lines.boundingSphere);
        var boundingSphere = Object(_mol_gl_renderable_util__WEBPACK_IMPORTED_MODULE_10__["calculateTransformBoundingSphere"])(invariantBoundingSphere, values.aTransform.ref.value, values.instanceCount.ref.value);
        if (!_mol_math_geometry__WEBPACK_IMPORTED_MODULE_11__["Sphere3D"].equals(boundingSphere, values.boundingSphere.ref.value)) {
            _mol_util__WEBPACK_IMPORTED_MODULE_1__["ValueCell"].update(values.boundingSphere, boundingSphere);
        }
        if (!_mol_math_geometry__WEBPACK_IMPORTED_MODULE_11__["Sphere3D"].equals(invariantBoundingSphere, values.invariantBoundingSphere.ref.value)) {
            _mol_util__WEBPACK_IMPORTED_MODULE_1__["ValueCell"].update(values.invariantBoundingSphere, invariantBoundingSphere);
            _mol_util__WEBPACK_IMPORTED_MODULE_1__["ValueCell"].update(values.uInvariantBoundingSphere, _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_2__["Vec4"].fromSphere(values.uInvariantBoundingSphere.ref.value, invariantBoundingSphere));
        }
    }
})(Lines || (Lines = {}));
//# sourceMappingURL=lines.js.map

/***/ }),

/***/ "./lib/mol-geo/geometry/marker-data.js":
/*!*********************************************!*\
  !*** ./lib/mol-geo/geometry/marker-data.js ***!
  \*********************************************/
/*! exports provided: createMarkers, createEmptyMarkers */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createMarkers", function() { return createMarkers; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createEmptyMarkers", function() { return createEmptyMarkers; });
/* harmony import */ var _mol_util_value_cell__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../mol-util/value-cell */ "./lib/mol-util/value-cell.js");
/* harmony import */ var _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../mol-math/linear-algebra */ "./lib/mol-math/linear-algebra.js");
/* harmony import */ var _mol_gl_renderable_util__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../mol-gl/renderable/util */ "./lib/mol-gl/renderable/util.js");
/**
 * Copyright (c) 2018 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */



function createMarkers(count, markerData) {
    var markers = Object(_mol_gl_renderable_util__WEBPACK_IMPORTED_MODULE_2__["createTextureImage"])(Math.max(1, count), 1, Uint8Array, markerData && markerData.tMarker.ref.value.array);
    if (markerData) {
        _mol_util_value_cell__WEBPACK_IMPORTED_MODULE_0__["ValueCell"].update(markerData.tMarker, markers);
        _mol_util_value_cell__WEBPACK_IMPORTED_MODULE_0__["ValueCell"].update(markerData.uMarkerTexDim, _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_1__["Vec2"].create(markers.width, markers.height));
        return markerData;
    }
    else {
        return {
            tMarker: _mol_util_value_cell__WEBPACK_IMPORTED_MODULE_0__["ValueCell"].create(markers),
            uMarkerTexDim: _mol_util_value_cell__WEBPACK_IMPORTED_MODULE_0__["ValueCell"].create(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_1__["Vec2"].create(markers.width, markers.height)),
        };
    }
}
var emptyMarkerTexture = { array: new Uint8Array(1), width: 1, height: 1 };
function createEmptyMarkers(markerData) {
    if (markerData) {
        _mol_util_value_cell__WEBPACK_IMPORTED_MODULE_0__["ValueCell"].update(markerData.tMarker, emptyMarkerTexture);
        _mol_util_value_cell__WEBPACK_IMPORTED_MODULE_0__["ValueCell"].update(markerData.uMarkerTexDim, _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_1__["Vec2"].create(1, 1));
        return markerData;
    }
    else {
        return {
            tMarker: _mol_util_value_cell__WEBPACK_IMPORTED_MODULE_0__["ValueCell"].create(emptyMarkerTexture),
            uMarkerTexDim: _mol_util_value_cell__WEBPACK_IMPORTED_MODULE_0__["ValueCell"].create(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_1__["Vec2"].create(1, 1)),
        };
    }
}
//# sourceMappingURL=marker-data.js.map

/***/ }),

/***/ "./lib/mol-geo/geometry/mesh/builder/axes.js":
/*!***************************************************!*\
  !*** ./lib/mol-geo/geometry/mesh/builder/axes.js ***!
  \***************************************************/
/*! exports provided: addAxes */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "addAxes", function() { return addAxes; });
/* harmony import */ var _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../../../mol-math/linear-algebra */ "./lib/mol-math/linear-algebra.js");
/* harmony import */ var _mesh_builder__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../mesh-builder */ "./lib/mol-geo/geometry/mesh/mesh-builder.js");
/* harmony import */ var _mol_math_geometry__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../../../mol-math/geometry */ "./lib/mol-math/geometry.js");
/* harmony import */ var _primitive_cage__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../../primitive/cage */ "./lib/mol-geo/primitive/cage.js");
/**
 * Copyright (c) 2019 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */




var tmpVec = Object(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"])();
var tmpMatrix = _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Mat4"].identity();
var tmpVertices = new Float32Array(6 * 3);
var tmpEdges = new Uint8Array([0, 1, 2, 3, 4, 5]);
function addAxes(state, axes, radiusScale, detail, radialSegments) {
    var origin = axes.origin, dirA = axes.dirA, dirB = axes.dirB, dirC = axes.dirC;
    _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"].add(tmpVec, origin, dirA);
    _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"].toArray(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"].add(tmpVec, origin, dirA), tmpVertices, 0);
    _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"].toArray(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"].sub(tmpVec, origin, dirA), tmpVertices, 3);
    _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"].toArray(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"].add(tmpVec, origin, dirB), tmpVertices, 6);
    _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"].toArray(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"].sub(tmpVec, origin, dirB), tmpVertices, 9);
    _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"].toArray(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"].add(tmpVec, origin, dirC), tmpVertices, 12);
    _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"].toArray(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"].sub(tmpVec, origin, dirC), tmpVertices, 15);
    var cage = Object(_primitive_cage__WEBPACK_IMPORTED_MODULE_3__["createCage"])(tmpVertices, tmpEdges);
    var volume = _mol_math_geometry__WEBPACK_IMPORTED_MODULE_2__["Axes3D"].volume(axes);
    var radius = (Math.cbrt(volume) / 300) * radiusScale;
    _mesh_builder__WEBPACK_IMPORTED_MODULE_1__["MeshBuilder"].addCage(state, tmpMatrix, cage, radius, detail, radialSegments);
}
//# sourceMappingURL=axes.js.map

/***/ }),

/***/ "./lib/mol-geo/geometry/mesh/builder/box.js":
/*!**************************************************!*\
  !*** ./lib/mol-geo/geometry/mesh/builder/box.js ***!
  \**************************************************/
/*! exports provided: addBoundingBox, addOrientedBox */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "addBoundingBox", function() { return addBoundingBox; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "addOrientedBox", function() { return addOrientedBox; });
/* harmony import */ var _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../../../mol-math/linear-algebra */ "./lib/mol-math/linear-algebra.js");
/* harmony import */ var _mol_math_geometry__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../../../mol-math/geometry */ "./lib/mol-math/geometry.js");
/* harmony import */ var _mesh_builder__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../mesh-builder */ "./lib/mol-geo/geometry/mesh/mesh-builder.js");
/* harmony import */ var _cylinder__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./cylinder */ "./lib/mol-geo/geometry/mesh/builder/cylinder.js");
/* harmony import */ var _sphere__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./sphere */ "./lib/mol-geo/geometry/mesh/builder/sphere.js");
/* harmony import */ var _primitive_cage__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../../primitive/cage */ "./lib/mol-geo/primitive/cage.js");
/**
 * Copyright (c) 2018-2019 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */






var tmpStart = _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"].zero();
var tmpEnd = _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"].zero();
var cylinderProps = {};
function addBoundingBox(state, box, radius, detail, radialSegments) {
    var min = box.min, max = box.max;
    cylinderProps.radiusTop = radius;
    cylinderProps.radiusBottom = radius;
    cylinderProps.radialSegments = radialSegments;
    _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"].set(tmpStart, max[0], max[1], max[2]);
    Object(_sphere__WEBPACK_IMPORTED_MODULE_4__["addSphere"])(state, tmpStart, radius, detail);
    _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"].set(tmpEnd, max[0], max[1], min[2]);
    Object(_cylinder__WEBPACK_IMPORTED_MODULE_3__["addCylinder"])(state, tmpStart, tmpEnd, 1, cylinderProps);
    _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"].set(tmpEnd, max[0], min[1], max[2]);
    Object(_cylinder__WEBPACK_IMPORTED_MODULE_3__["addCylinder"])(state, tmpStart, tmpEnd, 1, cylinderProps);
    _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"].set(tmpEnd, min[0], max[1], max[2]);
    Object(_cylinder__WEBPACK_IMPORTED_MODULE_3__["addCylinder"])(state, tmpStart, tmpEnd, 1, cylinderProps);
    _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"].set(tmpStart, min[0], min[1], min[2]);
    Object(_sphere__WEBPACK_IMPORTED_MODULE_4__["addSphere"])(state, tmpStart, radius, detail);
    _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"].set(tmpEnd, min[0], min[1], max[2]);
    Object(_cylinder__WEBPACK_IMPORTED_MODULE_3__["addCylinder"])(state, tmpStart, tmpEnd, 1, cylinderProps);
    _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"].set(tmpEnd, min[0], max[1], min[2]);
    Object(_cylinder__WEBPACK_IMPORTED_MODULE_3__["addCylinder"])(state, tmpStart, tmpEnd, 1, cylinderProps);
    _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"].set(tmpEnd, max[0], min[1], min[2]);
    Object(_cylinder__WEBPACK_IMPORTED_MODULE_3__["addCylinder"])(state, tmpStart, tmpEnd, 1, cylinderProps);
    _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"].set(tmpStart, max[0], min[1], min[2]);
    Object(_sphere__WEBPACK_IMPORTED_MODULE_4__["addSphere"])(state, tmpStart, radius, detail);
    _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"].set(tmpEnd, max[0], min[1], max[2]);
    Object(_cylinder__WEBPACK_IMPORTED_MODULE_3__["addCylinder"])(state, tmpStart, tmpEnd, 1, cylinderProps);
    _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"].set(tmpEnd, max[0], max[1], min[2]);
    Object(_cylinder__WEBPACK_IMPORTED_MODULE_3__["addCylinder"])(state, tmpStart, tmpEnd, 1, cylinderProps);
    _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"].set(tmpStart, min[0], min[1], max[2]);
    Object(_sphere__WEBPACK_IMPORTED_MODULE_4__["addSphere"])(state, tmpStart, radius, detail);
    _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"].set(tmpEnd, min[0], max[1], max[2]);
    Object(_cylinder__WEBPACK_IMPORTED_MODULE_3__["addCylinder"])(state, tmpStart, tmpEnd, 1, cylinderProps);
    _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"].set(tmpEnd, max[0], min[1], max[2]);
    Object(_cylinder__WEBPACK_IMPORTED_MODULE_3__["addCylinder"])(state, tmpStart, tmpEnd, 1, cylinderProps);
    _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"].set(tmpStart, min[0], max[1], min[2]);
    Object(_sphere__WEBPACK_IMPORTED_MODULE_4__["addSphere"])(state, tmpStart, radius, detail);
    _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"].set(tmpEnd, max[0], max[1], min[2]);
    Object(_sphere__WEBPACK_IMPORTED_MODULE_4__["addSphere"])(state, tmpEnd, radius, detail);
    Object(_cylinder__WEBPACK_IMPORTED_MODULE_3__["addCylinder"])(state, tmpStart, tmpEnd, 1, cylinderProps);
    _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"].set(tmpEnd, min[0], max[1], max[2]);
    Object(_sphere__WEBPACK_IMPORTED_MODULE_4__["addSphere"])(state, tmpEnd, radius, detail);
    Object(_cylinder__WEBPACK_IMPORTED_MODULE_3__["addCylinder"])(state, tmpStart, tmpEnd, 1, cylinderProps);
}
//
var tmpBoxVecCorner = Object(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"])();
var tmpBoxVecA = Object(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"])();
var tmpBoxVecB = Object(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"])();
var tmpBoxVecC = Object(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"])();
var tmpMatrix = _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Mat4"].identity();
var tmpVertices = new Float32Array(8 * 3);
var tmpEdges = new Uint8Array([
    0, 1, 0, 3, 0, 6, 1, 2, 1, 7, 2, 3,
    2, 4, 3, 5, 4, 5, 4, 7, 5, 6, 6, 7
]);
function addOrientedBox(state, axes, radiusScale, detail, radialSegments) {
    var origin = axes.origin, dirA = axes.dirA, dirB = axes.dirB, dirC = axes.dirC;
    var negDirA = _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"].negate(tmpBoxVecA, dirA);
    var negDirB = _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"].negate(tmpBoxVecB, dirB);
    var negDirC = _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"].negate(tmpBoxVecC, dirC);
    var offset = 0;
    var addCornerHelper = function (v1, v2, v3) {
        _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"].copy(tmpBoxVecCorner, origin);
        _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"].add(tmpBoxVecCorner, tmpBoxVecCorner, v1);
        _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"].add(tmpBoxVecCorner, tmpBoxVecCorner, v2);
        _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"].add(tmpBoxVecCorner, tmpBoxVecCorner, v3);
        _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"].toArray(tmpBoxVecCorner, tmpVertices, offset);
        offset += 3;
    };
    addCornerHelper(dirA, dirB, dirC);
    addCornerHelper(dirA, dirB, negDirC);
    addCornerHelper(dirA, negDirB, negDirC);
    addCornerHelper(dirA, negDirB, dirC);
    addCornerHelper(negDirA, negDirB, negDirC);
    addCornerHelper(negDirA, negDirB, dirC);
    addCornerHelper(negDirA, dirB, dirC);
    addCornerHelper(negDirA, dirB, negDirC);
    var cage = Object(_primitive_cage__WEBPACK_IMPORTED_MODULE_5__["createCage"])(tmpVertices, tmpEdges);
    var volume = _mol_math_geometry__WEBPACK_IMPORTED_MODULE_1__["Axes3D"].volume(axes);
    var radius = (Math.cbrt(volume) / 300) * radiusScale;
    _mesh_builder__WEBPACK_IMPORTED_MODULE_2__["MeshBuilder"].addCage(state, tmpMatrix, cage, radius, detail, radialSegments);
}
//# sourceMappingURL=box.js.map

/***/ }),

/***/ "./lib/mol-geo/geometry/mesh/builder/cylinder.js":
/*!*******************************************************!*\
  !*** ./lib/mol-geo/geometry/mesh/builder/cylinder.js ***!
  \*******************************************************/
/*! exports provided: addCylinder, addDoubleCylinder, addFixedCountDashedCylinder */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "addCylinder", function() { return addCylinder; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "addDoubleCylinder", function() { return addDoubleCylinder; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "addFixedCountDashedCylinder", function() { return addFixedCountDashedCylinder; });
/* harmony import */ var _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../../../mol-math/linear-algebra */ "./lib/mol-math/linear-algebra.js");
/* harmony import */ var _mesh_builder__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../mesh-builder */ "./lib/mol-geo/geometry/mesh/mesh-builder.js");
/* harmony import */ var _primitive_primitive__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../../primitive/primitive */ "./lib/mol-geo/primitive/primitive.js");
/* harmony import */ var _primitive_cylinder__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../../primitive/cylinder */ "./lib/mol-geo/primitive/cylinder.js");
/* harmony import */ var _primitive_prism__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../../primitive/prism */ "./lib/mol-geo/primitive/prism.js");
/* harmony import */ var _primitive_polygon__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../../primitive/polygon */ "./lib/mol-geo/primitive/polygon.js");
/* harmony import */ var _mol_data_util__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../../../../mol-data/util */ "./lib/mol-data/util.js");
/**
 * Copyright (c) 2018-2020 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */







var cylinderMap = new Map();
var up = _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"].create(0, 1, 0);
var tmpCylinderDir = Object(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"])();
var tmpCylinderMatDir = Object(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"])();
var tmpCylinderCenter = Object(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"])();
var tmpCylinderMat = Object(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Mat4"])();
var tmpCylinderMatRot = Object(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Mat4"])();
var tmpCylinderScale = Object(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"])();
var tmpCylinderMatScale = Object(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Mat4"])();
var tmpCylinderStart = Object(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"])();
var tmpUp = Object(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"])();
function setCylinderMat(m, start, dir, length) {
    _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"].setMagnitude(tmpCylinderMatDir, dir, length / 2);
    _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"].add(tmpCylinderCenter, start, tmpCylinderMatDir);
    // ensure the direction used to create the rotation is always pointing in the same
    // direction so the triangles of adjacent cylinder will line up
    _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"].matchDirection(tmpUp, up, tmpCylinderMatDir);
    _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Mat4"].fromScaling(tmpCylinderMatScale, _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"].set(tmpCylinderScale, 1, length, 1));
    _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"].makeRotation(tmpCylinderMatRot, tmpUp, tmpCylinderMatDir);
    _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Mat4"].mul(m, tmpCylinderMatRot, tmpCylinderMatScale);
    return _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Mat4"].setTranslation(m, tmpCylinderCenter);
}
var tmpPropValues = new Int32Array(9);
function getCylinderPropsKey(props) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j;
    tmpPropValues[0] = Math.round(1000 * ((_a = props.radiusTop) !== null && _a !== void 0 ? _a : _primitive_cylinder__WEBPACK_IMPORTED_MODULE_3__["DefaultCylinderProps"].radiusTop));
    tmpPropValues[1] = Math.round(1000 * ((_b = props.radiusBottom) !== null && _b !== void 0 ? _b : _primitive_cylinder__WEBPACK_IMPORTED_MODULE_3__["DefaultCylinderProps"].radiusBottom));
    tmpPropValues[2] = Math.round(1000 * ((_c = props.height) !== null && _c !== void 0 ? _c : _primitive_cylinder__WEBPACK_IMPORTED_MODULE_3__["DefaultCylinderProps"].height));
    tmpPropValues[3] = (_d = props.radialSegments) !== null && _d !== void 0 ? _d : _primitive_cylinder__WEBPACK_IMPORTED_MODULE_3__["DefaultCylinderProps"].radialSegments;
    tmpPropValues[4] = (_e = props.heightSegments) !== null && _e !== void 0 ? _e : _primitive_cylinder__WEBPACK_IMPORTED_MODULE_3__["DefaultCylinderProps"].heightSegments;
    tmpPropValues[5] = ((_f = props.topCap) !== null && _f !== void 0 ? _f : _primitive_cylinder__WEBPACK_IMPORTED_MODULE_3__["DefaultCylinderProps"].topCap) ? 1 : 0;
    tmpPropValues[6] = ((_g = props.bottomCap) !== null && _g !== void 0 ? _g : _primitive_cylinder__WEBPACK_IMPORTED_MODULE_3__["DefaultCylinderProps"].bottomCap) ? 1 : 0;
    tmpPropValues[7] = Math.round(1000 * ((_h = props.thetaStart) !== null && _h !== void 0 ? _h : _primitive_cylinder__WEBPACK_IMPORTED_MODULE_3__["DefaultCylinderProps"].thetaStart));
    tmpPropValues[8] = Math.round(1000 * ((_j = props.thetaLength) !== null && _j !== void 0 ? _j : _primitive_cylinder__WEBPACK_IMPORTED_MODULE_3__["DefaultCylinderProps"].thetaLength));
    return Object(_mol_data_util__WEBPACK_IMPORTED_MODULE_6__["hashFnv32a"])(tmpPropValues);
}
function getCylinder(props) {
    var key = getCylinderPropsKey(props);
    var cylinder = cylinderMap.get(key);
    if (cylinder === undefined) {
        if (props.radialSegments && props.radialSegments <= 4) {
            var sideCount = Math.max(3, props.radialSegments);
            var prism = Object(_primitive_prism__WEBPACK_IMPORTED_MODULE_4__["Prism"])(Object(_primitive_polygon__WEBPACK_IMPORTED_MODULE_5__["polygon"])(sideCount, true, props.radiusTop), props);
            cylinder = Object(_primitive_primitive__WEBPACK_IMPORTED_MODULE_2__["transformPrimitive"])(prism, _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Mat4"].rotX90);
        }
        else {
            cylinder = Object(_primitive_cylinder__WEBPACK_IMPORTED_MODULE_3__["Cylinder"])(props);
        }
        cylinderMap.set(key, cylinder);
    }
    return cylinder;
}
function addCylinder(state, start, end, lengthScale, props) {
    var d = _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"].distance(start, end) * lengthScale;
    _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"].sub(tmpCylinderDir, end, start);
    setCylinderMat(tmpCylinderMat, start, tmpCylinderDir, d);
    _mesh_builder__WEBPACK_IMPORTED_MODULE_1__["MeshBuilder"].addPrimitive(state, tmpCylinderMat, getCylinder(props));
}
function addDoubleCylinder(state, start, end, lengthScale, shift, props) {
    var d = _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"].distance(start, end) * lengthScale;
    var cylinder = getCylinder(props);
    _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"].sub(tmpCylinderDir, end, start);
    // positivly shifted cylinder
    _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"].add(tmpCylinderStart, start, shift);
    setCylinderMat(tmpCylinderMat, tmpCylinderStart, tmpCylinderDir, d);
    _mesh_builder__WEBPACK_IMPORTED_MODULE_1__["MeshBuilder"].addPrimitive(state, tmpCylinderMat, cylinder);
    // negativly shifted cylinder
    _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"].sub(tmpCylinderStart, start, shift);
    setCylinderMat(tmpCylinderMat, tmpCylinderStart, tmpCylinderDir, d);
    _mesh_builder__WEBPACK_IMPORTED_MODULE_1__["MeshBuilder"].addPrimitive(state, tmpCylinderMat, cylinder);
}
function addFixedCountDashedCylinder(state, start, end, lengthScale, segmentCount, props) {
    var s = Math.floor(segmentCount / 2);
    var step = 1 / segmentCount;
    // automatically adjust length so links/bonds that are rendered as two half cylinders
    // have evenly spaced dashed cylinders
    if (lengthScale < 1) {
        var bias = lengthScale / 2 / segmentCount;
        lengthScale += segmentCount % 2 === 1 ? bias : -bias;
    }
    var d = _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"].distance(start, end) * lengthScale;
    var cylinder = getCylinder(props);
    _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"].sub(tmpCylinderDir, end, start);
    for (var j = 0; j < s; ++j) {
        var f = step * (j * 2 + 1);
        _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"].setMagnitude(tmpCylinderDir, tmpCylinderDir, d * f);
        _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"].add(tmpCylinderStart, start, tmpCylinderDir);
        setCylinderMat(tmpCylinderMat, tmpCylinderStart, tmpCylinderDir, d * step);
        _mesh_builder__WEBPACK_IMPORTED_MODULE_1__["MeshBuilder"].addPrimitive(state, tmpCylinderMat, cylinder);
    }
}
//# sourceMappingURL=cylinder.js.map

/***/ }),

/***/ "./lib/mol-geo/geometry/mesh/builder/ellipsoid.js":
/*!********************************************************!*\
  !*** ./lib/mol-geo/geometry/mesh/builder/ellipsoid.js ***!
  \********************************************************/
/*! exports provided: addEllipsoid */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "addEllipsoid", function() { return addEllipsoid; });
/* harmony import */ var _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../../../mol-math/linear-algebra */ "./lib/mol-math/linear-algebra.js");
/* harmony import */ var _mesh_builder__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../mesh-builder */ "./lib/mol-geo/geometry/mesh/mesh-builder.js");
/* harmony import */ var _sphere__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./sphere */ "./lib/mol-geo/geometry/mesh/builder/sphere.js");
/**
 * Copyright (c) 2019 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */



var tmpEllipsoidMat = _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Mat4"].identity();
var tmpVec = Object(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"])();
function setEllipsoidMat(m, center, dirMajor, dirMinor, radiusScale) {
    _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"].add(tmpVec, center, dirMajor);
    _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Mat4"].targetTo(m, center, tmpVec, dirMinor);
    _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Mat4"].setTranslation(m, center);
    return _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Mat4"].scale(m, m, radiusScale);
}
function addEllipsoid(state, center, dirMajor, dirMinor, radiusScale, detail) {
    _mesh_builder__WEBPACK_IMPORTED_MODULE_1__["MeshBuilder"].addPrimitive(state, setEllipsoidMat(tmpEllipsoidMat, center, dirMajor, dirMinor, radiusScale), Object(_sphere__WEBPACK_IMPORTED_MODULE_2__["getSphere"])(detail));
}
//# sourceMappingURL=ellipsoid.js.map

/***/ }),

/***/ "./lib/mol-geo/geometry/mesh/builder/ribbon.js":
/*!*****************************************************!*\
  !*** ./lib/mol-geo/geometry/mesh/builder/ribbon.js ***!
  \*****************************************************/
/*! exports provided: addRibbon */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "addRibbon", function() { return addRibbon; });
/* harmony import */ var _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../../../mol-math/linear-algebra */ "./lib/mol-math/linear-algebra.js");
/* harmony import */ var _mol_data_util__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../../../mol-data/util */ "./lib/mol-data/util.js");
/**
 * Copyright (c) 2018-2020 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 * @author David Sehnal <david.sehnal@gmail.com>
 */


// avoiding namespace lookup improved performance in Chrome (Aug 2020)
var v3fromArray = _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"].fromArray;
var v3magnitude = _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"].magnitude;
var v3sub = _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"].sub;
var v3add = _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"].add;
var v3scale = _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"].scale;
var v3negate = _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"].negate;
var v3copy = _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"].copy;
var v3cross = _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"].cross;
var caAdd3 = _mol_data_util__WEBPACK_IMPORTED_MODULE_1__["ChunkedArray"].add3;
var caAdd = _mol_data_util__WEBPACK_IMPORTED_MODULE_1__["ChunkedArray"].add;
var tA = Object(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"])();
var tB = Object(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"])();
var tV = Object(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"])();
var horizontalVector = Object(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"])();
var verticalVector = Object(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"])();
var normalOffset = Object(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"])();
var positionVector = Object(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"])();
var normalVector = Object(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"])();
var torsionVector = Object(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"])();
/** set arrowHeight = 0 for no arrow */
function addRibbon(state, controlPoints, normalVectors, binormalVectors, linearSegments, widthValues, heightValues, arrowHeight) {
    var currentGroup = state.currentGroup, vertices = state.vertices, normals = state.normals, indices = state.indices, groups = state.groups;
    var vertexCount = vertices.elementCount;
    var offsetLength = 0;
    if (arrowHeight > 0) {
        v3fromArray(tA, controlPoints, 0);
        v3fromArray(tB, controlPoints, linearSegments * 3);
        offsetLength = arrowHeight / v3magnitude(v3sub(tV, tB, tA));
    }
    for (var i = 0; i <= linearSegments; ++i) {
        var width = widthValues[i];
        var height = heightValues[i];
        var actualHeight = arrowHeight === 0 ? height : arrowHeight * (1 - i / linearSegments);
        var i3 = i * 3;
        v3fromArray(verticalVector, normalVectors, i3);
        v3scale(verticalVector, verticalVector, actualHeight);
        v3fromArray(horizontalVector, binormalVectors, i3);
        v3scale(horizontalVector, horizontalVector, width);
        if (arrowHeight > 0) {
            v3fromArray(tA, normalVectors, i3);
            v3fromArray(tB, binormalVectors, i3);
            v3scale(normalOffset, v3cross(normalOffset, tA, tB), offsetLength);
        }
        v3fromArray(positionVector, controlPoints, i3);
        v3fromArray(normalVector, normalVectors, i3);
        v3fromArray(torsionVector, binormalVectors, i3);
        v3add(tA, positionVector, verticalVector);
        v3negate(tB, torsionVector);
        caAdd3(vertices, tA[0], tA[1], tA[2]);
        caAdd3(normals, tB[0], tB[1], tB[2]);
        v3sub(tA, positionVector, verticalVector);
        caAdd3(vertices, tA[0], tA[1], tA[2]);
        caAdd3(normals, tB[0], tB[1], tB[2]);
        v3add(tA, positionVector, verticalVector);
        v3copy(tB, torsionVector);
        caAdd3(vertices, tA[0], tA[1], tA[2]);
        caAdd3(normals, tB[0], tB[1], tB[2]);
        v3sub(tA, positionVector, verticalVector);
        caAdd3(vertices, tA[0], tA[1], tA[2]);
        caAdd3(normals, tB[0], tB[1], tB[2]);
    }
    for (var i = 0; i < linearSegments; ++i) {
        caAdd3(indices, vertexCount + i * 4, vertexCount + (i + 1) * 4 + 1, vertexCount + i * 4 + 1);
        caAdd3(indices, vertexCount + i * 4, vertexCount + (i + 1) * 4, vertexCount + (i + 1) * 4 + 1);
        caAdd3(indices, vertexCount + i * 4 + 2 + 1, vertexCount + (i + 1) * 4 + 2 + 1, vertexCount + i * 4 + 2);
        caAdd3(indices, vertexCount + i * 4 + 2, vertexCount + (i + 1) * 4 + 2 + 1, vertexCount + (i + 1) * 4 + 2);
    }
    var addedVertexCount = (linearSegments + 1) * 4;
    for (var i = 0, il = addedVertexCount; i < il; ++i)
        caAdd(groups, currentGroup);
}
//# sourceMappingURL=ribbon.js.map

/***/ }),

/***/ "./lib/mol-geo/geometry/mesh/builder/sheet.js":
/*!****************************************************!*\
  !*** ./lib/mol-geo/geometry/mesh/builder/sheet.js ***!
  \****************************************************/
/*! exports provided: addSheet */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "addSheet", function() { return addSheet; });
/* harmony import */ var _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../../../mol-math/linear-algebra */ "./lib/mol-math/linear-algebra.js");
/* harmony import */ var _mol_data_util__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../../../mol-data/util */ "./lib/mol-data/util.js");
/**
 * Copyright (c) 2018-2020 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 * @author David Sehnal <david.sehnal@gmail.com>
 */


var tA = Object(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"])();
var tB = Object(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"])();
var tV = Object(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"])();
var horizontalVector = Object(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"])();
var verticalVector = Object(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"])();
var verticalRightVector = Object(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"])();
var verticalLeftVector = Object(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"])();
var normalOffset = Object(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"])();
var positionVector = Object(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"])();
var normalVector = Object(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"])();
var torsionVector = Object(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"])();
var p1 = Object(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"])();
var p2 = Object(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"])();
var p3 = Object(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"])();
var p4 = Object(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"])();
// avoiding namespace lookup improved performance in Chrome (Aug 2020)
var v3fromArray = _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"].fromArray;
var v3scale = _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"].scale;
var v3add = _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"].add;
var v3sub = _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"].sub;
var v3magnitude = _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"].magnitude;
var v3negate = _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"].negate;
var v3copy = _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"].copy;
var v3cross = _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"].cross;
var caAdd3 = _mol_data_util__WEBPACK_IMPORTED_MODULE_1__["ChunkedArray"].add3;
var caAdd = _mol_data_util__WEBPACK_IMPORTED_MODULE_1__["ChunkedArray"].add;
function addCap(offset, state, controlPoints, normalVectors, binormalVectors, width, leftHeight, rightHeight) {
    var vertices = state.vertices, normals = state.normals, indices = state.indices;
    var vertexCount = vertices.elementCount;
    v3fromArray(verticalLeftVector, normalVectors, offset);
    v3scale(verticalLeftVector, verticalLeftVector, leftHeight);
    v3fromArray(verticalRightVector, normalVectors, offset);
    v3scale(verticalRightVector, verticalRightVector, rightHeight);
    v3fromArray(horizontalVector, binormalVectors, offset);
    v3scale(horizontalVector, horizontalVector, width);
    v3fromArray(positionVector, controlPoints, offset);
    v3add(p1, v3add(p1, positionVector, horizontalVector), verticalRightVector);
    v3sub(p2, v3add(p2, positionVector, horizontalVector), verticalLeftVector);
    v3sub(p3, v3sub(p3, positionVector, horizontalVector), verticalLeftVector);
    v3add(p4, v3sub(p4, positionVector, horizontalVector), verticalRightVector);
    if (leftHeight < rightHeight) {
        caAdd3(vertices, p4[0], p4[1], p4[2]);
        caAdd3(vertices, p3[0], p3[1], p3[2]);
        caAdd3(vertices, p2[0], p2[1], p2[2]);
        caAdd3(vertices, p1[0], p1[1], p1[2]);
        v3copy(verticalVector, verticalRightVector);
    }
    else {
        caAdd3(vertices, p1[0], p1[1], p1[2]);
        caAdd3(vertices, p2[0], p2[1], p2[2]);
        caAdd3(vertices, p3[0], p3[1], p3[2]);
        caAdd3(vertices, p4[0], p4[1], p4[2]);
        v3copy(verticalVector, verticalLeftVector);
    }
    v3cross(normalVector, horizontalVector, verticalVector);
    for (var i = 0; i < 4; ++i) {
        caAdd3(normals, normalVector[0], normalVector[1], normalVector[2]);
    }
    caAdd3(indices, vertexCount + 2, vertexCount + 1, vertexCount);
    caAdd3(indices, vertexCount, vertexCount + 3, vertexCount + 2);
}
/** set arrowHeight = 0 for no arrow */
function addSheet(state, controlPoints, normalVectors, binormalVectors, linearSegments, widthValues, heightValues, arrowHeight, startCap, endCap) {
    var currentGroup = state.currentGroup, vertices = state.vertices, normals = state.normals, indices = state.indices, groups = state.groups;
    var vertexCount = vertices.elementCount;
    var offsetLength = 0;
    if (arrowHeight > 0) {
        v3fromArray(tA, controlPoints, 0);
        v3fromArray(tB, controlPoints, linearSegments * 3);
        offsetLength = arrowHeight / v3magnitude(v3sub(tV, tB, tA));
    }
    for (var i = 0; i <= linearSegments; ++i) {
        var width = widthValues[i];
        var height = heightValues[i];
        var actualHeight = arrowHeight === 0 ? height : arrowHeight * (1 - i / linearSegments);
        var i3 = i * 3;
        v3fromArray(verticalVector, normalVectors, i3);
        v3scale(verticalVector, verticalVector, actualHeight);
        v3fromArray(horizontalVector, binormalVectors, i3);
        v3scale(horizontalVector, horizontalVector, width);
        if (arrowHeight > 0) {
            v3fromArray(tA, normalVectors, i3);
            v3fromArray(tB, binormalVectors, i3);
            v3scale(normalOffset, v3cross(normalOffset, tA, tB), offsetLength);
        }
        v3fromArray(positionVector, controlPoints, i3);
        v3fromArray(normalVector, normalVectors, i3);
        v3fromArray(torsionVector, binormalVectors, i3);
        v3add(tA, v3add(tA, positionVector, horizontalVector), verticalVector);
        v3copy(tB, normalVector);
        caAdd3(vertices, tA[0], tA[1], tA[2]);
        caAdd3(normals, tB[0], tB[1], tB[2]);
        v3add(tA, v3sub(tA, positionVector, horizontalVector), verticalVector);
        caAdd3(vertices, tA[0], tA[1], tA[2]);
        caAdd3(normals, tB[0], tB[1], tB[2]);
        // v3add(tA, v3sub(tA, positionVector, horizontalVector), verticalVector) // reuse tA
        v3add(tB, v3negate(tB, torsionVector), normalOffset);
        caAdd3(vertices, tA[0], tA[1], tA[2]);
        caAdd3(normals, tB[0], tB[1], tB[2]);
        v3sub(tA, v3sub(tA, positionVector, horizontalVector), verticalVector);
        caAdd3(vertices, tA[0], tA[1], tA[2]);
        caAdd3(normals, tB[0], tB[1], tB[2]);
        // v3sub(tA, v3sub(tA, positionVector, horizontalVector), verticalVector) // reuse tA
        v3negate(tB, normalVector);
        caAdd3(vertices, tA[0], tA[1], tA[2]);
        caAdd3(normals, tB[0], tB[1], tB[2]);
        v3sub(tA, v3add(tA, positionVector, horizontalVector), verticalVector);
        caAdd3(vertices, tA[0], tA[1], tA[2]);
        caAdd3(normals, tB[0], tB[1], tB[2]);
        // v3sub(tA, v3add(tA, positionVector, horizontalVector), verticalVector) // reuse tA
        v3add(tB, torsionVector, normalOffset);
        caAdd3(vertices, tA[0], tA[1], tA[2]);
        caAdd3(normals, tB[0], tB[1], tB[2]);
        v3add(tA, v3add(tA, positionVector, horizontalVector), verticalVector);
        caAdd3(vertices, tA[0], tA[1], tA[2]);
        caAdd3(normals, tB[0], tB[1], tB[2]);
    }
    for (var i = 0; i < linearSegments; ++i) {
        // the triangles are arranged such that opposing triangles of the sheet align
        // which prevents triangle intersection within tight curves
        for (var j = 0; j < 2; j++) {
            caAdd3(indices, vertexCount + i * 8 + 2 * j, // a
            vertexCount + (i + 1) * 8 + 2 * j + 1, // c
            vertexCount + i * 8 + 2 * j + 1 // b
            );
            caAdd3(indices, vertexCount + i * 8 + 2 * j, // a
            vertexCount + (i + 1) * 8 + 2 * j, // d
            vertexCount + (i + 1) * 8 + 2 * j + 1 // c
            );
        }
        for (var j = 2; j < 4; j++) {
            caAdd3(indices, vertexCount + i * 8 + 2 * j, // a
            vertexCount + (i + 1) * 8 + 2 * j, // d
            vertexCount + i * 8 + 2 * j + 1);
            caAdd3(indices, vertexCount + (i + 1) * 8 + 2 * j, // d
            vertexCount + (i + 1) * 8 + 2 * j + 1, // c
            vertexCount + i * 8 + 2 * j + 1);
        }
    }
    if (startCap) {
        var width = widthValues[0];
        var height = heightValues[0];
        var h = arrowHeight === 0 ? height : arrowHeight;
        addCap(0, state, controlPoints, normalVectors, binormalVectors, width, h, h);
    }
    else if (arrowHeight > 0) {
        var width = widthValues[0];
        var height = heightValues[0];
        addCap(0, state, controlPoints, normalVectors, binormalVectors, width, arrowHeight, -height);
        addCap(0, state, controlPoints, normalVectors, binormalVectors, width, -arrowHeight, height);
    }
    if (endCap && arrowHeight === 0) {
        var width = widthValues[linearSegments];
        var height = heightValues[linearSegments];
        // use negative height to flip the direction the cap's triangles are facing
        addCap(linearSegments * 3, state, controlPoints, normalVectors, binormalVectors, width, -height, -height);
    }
    var addedVertexCount = (linearSegments + 1) * 8 +
        (startCap ? 4 : (arrowHeight > 0 ? 8 : 0)) +
        (endCap && arrowHeight === 0 ? 4 : 0);
    for (var i = 0, il = addedVertexCount; i < il; ++i)
        caAdd(groups, currentGroup);
}
//# sourceMappingURL=sheet.js.map

/***/ }),

/***/ "./lib/mol-geo/geometry/mesh/builder/sphere.js":
/*!*****************************************************!*\
  !*** ./lib/mol-geo/geometry/mesh/builder/sphere.js ***!
  \*****************************************************/
/*! exports provided: getSphere, addSphere */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getSphere", function() { return getSphere; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "addSphere", function() { return addSphere; });
/* harmony import */ var _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../../../mol-math/linear-algebra */ "./lib/mol-math/linear-algebra.js");
/* harmony import */ var _mesh_builder__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../mesh-builder */ "./lib/mol-geo/geometry/mesh/mesh-builder.js");
/* harmony import */ var _primitive_sphere__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../../primitive/sphere */ "./lib/mol-geo/primitive/sphere.js");
/**
 * Copyright (c) 2018 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */



var sphereMap = new Map();
var tmpSphereMat = _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Mat4"].identity();
function setSphereMat(m, center, radius) {
    return _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Mat4"].scaleUniformly(m, _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Mat4"].fromTranslation(m, center), radius);
}
function getSphere(detail) {
    var sphere = sphereMap.get(detail);
    if (sphere === undefined) {
        sphere = Object(_primitive_sphere__WEBPACK_IMPORTED_MODULE_2__["Sphere"])(detail);
        sphereMap.set(detail, sphere);
    }
    return sphere;
}
function addSphere(state, center, radius, detail) {
    _mesh_builder__WEBPACK_IMPORTED_MODULE_1__["MeshBuilder"].addPrimitive(state, setSphereMat(tmpSphereMat, center, radius), getSphere(detail));
}
//# sourceMappingURL=sphere.js.map

/***/ }),

/***/ "./lib/mol-geo/geometry/mesh/builder/tube.js":
/*!***************************************************!*\
  !*** ./lib/mol-geo/geometry/mesh/builder/tube.js ***!
  \***************************************************/
/*! exports provided: addTube */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "addTube", function() { return addTube; });
/* harmony import */ var _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../../../mol-math/linear-algebra */ "./lib/mol-math/linear-algebra.js");
/* harmony import */ var _mol_data_util__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../../../mol-data/util */ "./lib/mol-data/util.js");
/**
 * Copyright (c) 2018-2020 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 * @author David Sehnal <david.sehnal@gmail.com>
 */


var normalVector = Object(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"])();
var surfacePoint = Object(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"])();
var controlPoint = Object(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"])();
var u = Object(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"])();
var v = Object(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"])();
function add2AndScale2(out, a, b, sa, sb) {
    out[0] = (a[0] * sa) + (b[0] * sb);
    out[1] = (a[1] * sa) + (b[1] * sb);
    out[2] = (a[2] * sa) + (b[2] * sb);
}
function add3AndScale2(out, a, b, c, sa, sb) {
    out[0] = (a[0] * sa) + (b[0] * sb) + c[0];
    out[1] = (a[1] * sa) + (b[1] * sb) + c[1];
    out[2] = (a[2] * sa) + (b[2] * sb) + c[2];
}
// avoiding namespace lookup improved performance in Chrome (Aug 2020)
var v3fromArray = _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"].fromArray;
var v3normalize = _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"].normalize;
var v3negate = _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"].negate;
var v3copy = _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"].copy;
var v3cross = _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"].cross;
var caAdd3 = _mol_data_util__WEBPACK_IMPORTED_MODULE_1__["ChunkedArray"].add3;
var CosSinCache = new Map();
function getCosSin(radialSegments) {
    if (!CosSinCache.has(radialSegments)) {
        var cos = [];
        var sin = [];
        for (var j = 0; j < radialSegments; ++j) {
            var t = 2 * Math.PI * j / radialSegments;
            cos[j] = Math.cos(t);
            sin[j] = Math.sin(t);
        }
        CosSinCache.set(radialSegments, { cos: cos, sin: sin });
    }
    return CosSinCache.get(radialSegments);
}
function addTube(state, controlPoints, normalVectors, binormalVectors, linearSegments, radialSegments, widthValues, heightValues, startCap, endCap) {
    var currentGroup = state.currentGroup, vertices = state.vertices, normals = state.normals, indices = state.indices, groups = state.groups;
    var vertexCount = vertices.elementCount;
    var _a = getCosSin(radialSegments), cos = _a.cos, sin = _a.sin;
    for (var i = 0; i <= linearSegments; ++i) {
        var i3 = i * 3;
        v3fromArray(u, normalVectors, i3);
        v3fromArray(v, binormalVectors, i3);
        v3fromArray(controlPoint, controlPoints, i3);
        var width = widthValues[i];
        var height = heightValues[i];
        for (var j = 0; j < radialSegments; ++j) {
            add3AndScale2(surfacePoint, u, v, controlPoint, height * cos[j], width * sin[j]);
            if (radialSegments === 2) {
                v3copy(normalVector, v);
                v3normalize(normalVector, normalVector);
                if (j !== 0 || i % 2 === 0)
                    v3negate(normalVector, normalVector);
            }
            else {
                add2AndScale2(normalVector, u, v, width * cos[j], height * sin[j]);
            }
            v3normalize(normalVector, normalVector);
            caAdd3(vertices, surfacePoint[0], surfacePoint[1], surfacePoint[2]);
            caAdd3(normals, normalVector[0], normalVector[1], normalVector[2]);
        }
    }
    for (var i = 0; i < linearSegments; ++i) {
        for (var j = 0; j < radialSegments; ++j) {
            caAdd3(indices, vertexCount + i * radialSegments + (j + 1) % radialSegments, vertexCount + (i + 1) * radialSegments + (j + 1) % radialSegments, vertexCount + i * radialSegments + j);
            caAdd3(indices, vertexCount + (i + 1) * radialSegments + (j + 1) % radialSegments, vertexCount + (i + 1) * radialSegments + j, vertexCount + i * radialSegments + j);
        }
    }
    if (startCap) {
        var offset = 0;
        var centerVertex = vertices.elementCount;
        v3fromArray(u, normalVectors, offset);
        v3fromArray(v, binormalVectors, offset);
        v3fromArray(controlPoint, controlPoints, offset);
        v3cross(normalVector, v, u);
        caAdd3(vertices, controlPoint[0], controlPoint[1], controlPoint[2]);
        caAdd3(normals, normalVector[0], normalVector[1], normalVector[2]);
        var width = widthValues[0];
        var height = heightValues[0];
        vertexCount = vertices.elementCount;
        for (var i = 0; i < radialSegments; ++i) {
            add3AndScale2(surfacePoint, u, v, controlPoint, height * cos[i], width * sin[i]);
            caAdd3(vertices, surfacePoint[0], surfacePoint[1], surfacePoint[2]);
            caAdd3(normals, normalVector[0], normalVector[1], normalVector[2]);
            caAdd3(indices, vertexCount + (i + 1) % radialSegments, vertexCount + i, centerVertex);
        }
    }
    if (endCap) {
        var offset = linearSegments * 3;
        var centerVertex = vertices.elementCount;
        v3fromArray(u, normalVectors, offset);
        v3fromArray(v, binormalVectors, offset);
        v3fromArray(controlPoint, controlPoints, offset);
        v3cross(normalVector, u, v);
        caAdd3(vertices, controlPoint[0], controlPoint[1], controlPoint[2]);
        caAdd3(normals, normalVector[0], normalVector[1], normalVector[2]);
        var width = widthValues[linearSegments];
        var height = heightValues[linearSegments];
        vertexCount = vertices.elementCount;
        for (var i = 0; i < radialSegments; ++i) {
            add3AndScale2(surfacePoint, u, v, controlPoint, height * cos[i], width * sin[i]);
            caAdd3(vertices, surfacePoint[0], surfacePoint[1], surfacePoint[2]);
            caAdd3(normals, normalVector[0], normalVector[1], normalVector[2]);
            caAdd3(indices, vertexCount + i, vertexCount + (i + 1) % radialSegments, centerVertex);
        }
    }
    var addedVertexCount = (linearSegments + 1) * radialSegments + (startCap ? radialSegments + 1 : 0) + (endCap ? radialSegments + 1 : 0);
    _mol_data_util__WEBPACK_IMPORTED_MODULE_1__["ChunkedArray"].addRepeat(groups, addedVertexCount, currentGroup);
}
//# sourceMappingURL=tube.js.map

/***/ }),

/***/ "./lib/mol-geo/geometry/mesh/mesh-builder.js":
/*!***************************************************!*\
  !*** ./lib/mol-geo/geometry/mesh/mesh-builder.js ***!
  \***************************************************/
/*! exports provided: MeshBuilder */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MeshBuilder", function() { return MeshBuilder; });
/* harmony import */ var _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../../mol-math/linear-algebra */ "./lib/mol-math/linear-algebra.js");
/* harmony import */ var _mol_data_util__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../../mol-data/util */ "./lib/mol-data/util.js");
/* harmony import */ var _mesh__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./mesh */ "./lib/mol-geo/geometry/mesh/mesh.js");
/* harmony import */ var _builder_sphere__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./builder/sphere */ "./lib/mol-geo/geometry/mesh/builder/sphere.js");
/* harmony import */ var _builder_cylinder__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./builder/cylinder */ "./lib/mol-geo/geometry/mesh/builder/cylinder.js");
/**
 * Copyright (c) 2018-2020 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */





var tmpV = Object(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"])();
var tmpMat3 = Object(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Mat3"])();
var tmpVecA = Object(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"])();
var tmpVecB = Object(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"])();
var tmpVecC = Object(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"])();
var tmpVecD = Object(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"])();
// avoiding namespace lookup improved performance in Chrome (Aug 2020)
var v3fromArray = _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"].fromArray;
var v3triangleNormal = _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"].triangleNormal;
var v3copy = _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"].copy;
var v3transformMat4 = _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"].transformMat4;
var v3transformMat3 = _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"].transformMat3;
var mat3directionTransform = _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Mat3"].directionTransform;
var caAdd3 = _mol_data_util__WEBPACK_IMPORTED_MODULE_1__["ChunkedArray"].add3;
var caAdd = _mol_data_util__WEBPACK_IMPORTED_MODULE_1__["ChunkedArray"].add;
var MeshBuilder;
(function (MeshBuilder) {
    function createState(initialCount, chunkSize, mesh) {
        if (initialCount === void 0) { initialCount = 2048; }
        if (chunkSize === void 0) { chunkSize = 1024; }
        return {
            currentGroup: -1,
            vertices: _mol_data_util__WEBPACK_IMPORTED_MODULE_1__["ChunkedArray"].create(Float32Array, 3, chunkSize, mesh ? mesh.vertexBuffer.ref.value : initialCount),
            normals: _mol_data_util__WEBPACK_IMPORTED_MODULE_1__["ChunkedArray"].create(Float32Array, 3, chunkSize, mesh ? mesh.normalBuffer.ref.value : initialCount),
            indices: _mol_data_util__WEBPACK_IMPORTED_MODULE_1__["ChunkedArray"].create(Uint32Array, 3, chunkSize * 3, mesh ? mesh.indexBuffer.ref.value : initialCount * 3),
            groups: _mol_data_util__WEBPACK_IMPORTED_MODULE_1__["ChunkedArray"].create(Float32Array, 1, chunkSize, mesh ? mesh.groupBuffer.ref.value : initialCount),
            mesh: mesh
        };
    }
    MeshBuilder.createState = createState;
    function addTriangle(state, a, b, c) {
        var vertices = state.vertices, normals = state.normals, indices = state.indices, groups = state.groups, currentGroup = state.currentGroup;
        var offset = vertices.elementCount;
        // positions
        caAdd3(vertices, a[0], a[1], a[2]);
        caAdd3(vertices, b[0], b[1], b[2]);
        caAdd3(vertices, c[0], c[1], c[2]);
        v3triangleNormal(tmpV, a, b, c);
        for (var i = 0; i < 3; ++i) {
            caAdd3(normals, tmpV[0], tmpV[1], tmpV[2]); // normal
            caAdd(groups, currentGroup); // group
        }
        caAdd3(indices, offset, offset + 1, offset + 2);
    }
    MeshBuilder.addTriangle = addTriangle;
    function addTriangleStrip(state, vertices, indices) {
        v3fromArray(tmpVecC, vertices, indices[0] * 3);
        v3fromArray(tmpVecD, vertices, indices[1] * 3);
        for (var i = 2, il = indices.length; i < il; i += 2) {
            v3copy(tmpVecA, tmpVecC);
            v3copy(tmpVecB, tmpVecD);
            v3fromArray(tmpVecC, vertices, indices[i] * 3);
            v3fromArray(tmpVecD, vertices, indices[i + 1] * 3);
            addTriangle(state, tmpVecA, tmpVecB, tmpVecC);
            addTriangle(state, tmpVecB, tmpVecD, tmpVecC);
        }
    }
    MeshBuilder.addTriangleStrip = addTriangleStrip;
    function addTriangleFan(state, vertices, indices) {
        v3fromArray(tmpVecA, vertices, indices[0] * 3);
        for (var i = 2, il = indices.length; i < il; ++i) {
            v3fromArray(tmpVecB, vertices, indices[i - 1] * 3);
            v3fromArray(tmpVecC, vertices, indices[i] * 3);
            addTriangle(state, tmpVecA, tmpVecC, tmpVecB);
        }
    }
    MeshBuilder.addTriangleFan = addTriangleFan;
    function addPrimitive(state, t, primitive) {
        var va = primitive.vertices, na = primitive.normals, ia = primitive.indices;
        var vertices = state.vertices, normals = state.normals, indices = state.indices, groups = state.groups, currentGroup = state.currentGroup;
        var offset = vertices.elementCount;
        var n = mat3directionTransform(tmpMat3, t);
        for (var i = 0, il = va.length; i < il; i += 3) {
            // position
            v3transformMat4(tmpV, v3fromArray(tmpV, va, i), t);
            caAdd3(vertices, tmpV[0], tmpV[1], tmpV[2]);
            // normal
            v3transformMat3(tmpV, v3fromArray(tmpV, na, i), n);
            caAdd3(normals, tmpV[0], tmpV[1], tmpV[2]);
            // group
            caAdd(groups, currentGroup);
        }
        for (var i = 0, il = ia.length; i < il; i += 3) {
            caAdd3(indices, ia[i] + offset, ia[i + 1] + offset, ia[i + 2] + offset);
        }
    }
    MeshBuilder.addPrimitive = addPrimitive;
    /** Flips triangle normals and winding order */
    function addPrimitiveFlipped(state, t, primitive) {
        var va = primitive.vertices, na = primitive.normals, ia = primitive.indices;
        var vertices = state.vertices, normals = state.normals, indices = state.indices, groups = state.groups, currentGroup = state.currentGroup;
        var offset = vertices.elementCount;
        var n = mat3directionTransform(tmpMat3, t);
        for (var i = 0, il = va.length; i < il; i += 3) {
            // position
            v3transformMat4(tmpV, v3fromArray(tmpV, va, i), t);
            caAdd3(vertices, tmpV[0], tmpV[1], tmpV[2]);
            // normal
            v3transformMat3(tmpV, v3fromArray(tmpV, na, i), n);
            caAdd3(normals, -tmpV[0], -tmpV[1], -tmpV[2]);
            // group
            caAdd(groups, currentGroup);
        }
        for (var i = 0, il = ia.length; i < il; i += 3) {
            caAdd3(indices, ia[i + 2] + offset, ia[i + 1] + offset, ia[i] + offset);
        }
    }
    MeshBuilder.addPrimitiveFlipped = addPrimitiveFlipped;
    function addCage(state, t, cage, radius, detail, radialSegments) {
        var va = cage.vertices, ea = cage.edges;
        var cylinderProps = { radiusTop: radius, radiusBottom: radius, radialSegments: radialSegments };
        for (var i = 0, il = ea.length; i < il; i += 2) {
            v3fromArray(tmpVecA, va, ea[i] * 3);
            v3fromArray(tmpVecB, va, ea[i + 1] * 3);
            v3transformMat4(tmpVecA, tmpVecA, t);
            v3transformMat4(tmpVecB, tmpVecB, t);
            Object(_builder_sphere__WEBPACK_IMPORTED_MODULE_3__["addSphere"])(state, tmpVecA, radius, detail);
            Object(_builder_sphere__WEBPACK_IMPORTED_MODULE_3__["addSphere"])(state, tmpVecB, radius, detail);
            Object(_builder_cylinder__WEBPACK_IMPORTED_MODULE_4__["addCylinder"])(state, tmpVecA, tmpVecB, 1, cylinderProps);
        }
    }
    MeshBuilder.addCage = addCage;
    function getMesh(state) {
        var vertices = state.vertices, normals = state.normals, indices = state.indices, groups = state.groups, mesh = state.mesh;
        var vb = _mol_data_util__WEBPACK_IMPORTED_MODULE_1__["ChunkedArray"].compact(vertices, true);
        var ib = _mol_data_util__WEBPACK_IMPORTED_MODULE_1__["ChunkedArray"].compact(indices, true);
        var nb = _mol_data_util__WEBPACK_IMPORTED_MODULE_1__["ChunkedArray"].compact(normals, true);
        var gb = _mol_data_util__WEBPACK_IMPORTED_MODULE_1__["ChunkedArray"].compact(groups, true);
        return _mesh__WEBPACK_IMPORTED_MODULE_2__["Mesh"].create(vb, ib, nb, gb, state.vertices.elementCount, state.indices.elementCount, mesh);
    }
    MeshBuilder.getMesh = getMesh;
})(MeshBuilder || (MeshBuilder = {}));
//# sourceMappingURL=mesh-builder.js.map

/***/ }),

/***/ "./lib/mol-geo/geometry/mesh/mesh.js":
/*!*******************************************!*\
  !*** ./lib/mol-geo/geometry/mesh/mesh.js ***!
  \*******************************************/
/*! exports provided: Mesh */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Mesh", function() { return Mesh; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _mol_util__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../../mol-util */ "./lib/mol-util/index.js");
/* harmony import */ var _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../../mol-math/linear-algebra */ "./lib/mol-math/linear-algebra.js");
/* harmony import */ var _mol_math_geometry__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../../mol-math/geometry */ "./lib/mol-math/geometry.js");
/* harmony import */ var _util__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../util */ "./lib/mol-geo/util.js");
/* harmony import */ var _marker_data__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../marker-data */ "./lib/mol-geo/geometry/marker-data.js");
/* harmony import */ var _util_location_iterator__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../../util/location-iterator */ "./lib/mol-geo/util/location-iterator.js");
/* harmony import */ var _color_data__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../color-data */ "./lib/mol-geo/geometry/color-data.js");
/* harmony import */ var _mol_data_util__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ../../../mol-data/util */ "./lib/mol-data/util.js");
/* harmony import */ var _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ../../../mol-util/param-definition */ "./lib/mol-util/param-definition.js");
/* harmony import */ var _mol_gl_renderable_util__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ../../../mol-gl/renderable/util */ "./lib/mol-gl/renderable/util.js");
/* harmony import */ var _base__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ../base */ "./lib/mol-geo/geometry/base.js");
/* harmony import */ var _overpaint_data__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! ../overpaint-data */ "./lib/mol-geo/geometry/overpaint-data.js");
/* harmony import */ var _transparency_data__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! ../transparency-data */ "./lib/mol-geo/geometry/transparency-data.js");
/* harmony import */ var _clipping_data__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! ../clipping-data */ "./lib/mol-geo/geometry/clipping-data.js");
/**
 * Copyright (c) 2018-2020 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 * @author David Sehnal <david.sehnal@gmail.com>
 */















var Mesh;
(function (Mesh) {
    function create(vertices, indices, normals, groups, vertexCount, triangleCount, mesh) {
        return mesh ?
            update(vertices, indices, normals, groups, vertexCount, triangleCount, mesh) :
            fromArrays(vertices, indices, normals, groups, vertexCount, triangleCount);
    }
    Mesh.create = create;
    function createEmpty(mesh) {
        var vb = mesh ? mesh.vertexBuffer.ref.value : new Float32Array(0);
        var ib = mesh ? mesh.indexBuffer.ref.value : new Uint32Array(0);
        var nb = mesh ? mesh.normalBuffer.ref.value : new Float32Array(0);
        var gb = mesh ? mesh.groupBuffer.ref.value : new Float32Array(0);
        return create(vb, ib, nb, gb, 0, 0, mesh);
    }
    Mesh.createEmpty = createEmpty;
    function hashCode(mesh) {
        return Object(_mol_data_util__WEBPACK_IMPORTED_MODULE_8__["hashFnv32a"])([
            mesh.vertexCount, mesh.triangleCount,
            mesh.vertexBuffer.ref.version, mesh.indexBuffer.ref.version,
            mesh.normalBuffer.ref.version, mesh.groupBuffer.ref.version
        ]);
    }
    function fromArrays(vertices, indices, normals, groups, vertexCount, triangleCount) {
        var boundingSphere = Object(_mol_math_geometry__WEBPACK_IMPORTED_MODULE_3__["Sphere3D"])();
        var groupMapping;
        var currentHash = -1;
        var currentGroup = -1;
        var mesh = {
            kind: 'mesh',
            vertexCount: vertexCount,
            triangleCount: triangleCount,
            vertexBuffer: _mol_util__WEBPACK_IMPORTED_MODULE_1__["ValueCell"].create(vertices),
            indexBuffer: _mol_util__WEBPACK_IMPORTED_MODULE_1__["ValueCell"].create(indices),
            normalBuffer: _mol_util__WEBPACK_IMPORTED_MODULE_1__["ValueCell"].create(normals),
            groupBuffer: _mol_util__WEBPACK_IMPORTED_MODULE_1__["ValueCell"].create(groups),
            get boundingSphere() {
                var newHash = hashCode(mesh);
                if (newHash !== currentHash) {
                    var b = Object(_mol_gl_renderable_util__WEBPACK_IMPORTED_MODULE_10__["calculateInvariantBoundingSphere"])(mesh.vertexBuffer.ref.value, mesh.vertexCount, 1);
                    _mol_math_geometry__WEBPACK_IMPORTED_MODULE_3__["Sphere3D"].copy(boundingSphere, b);
                    currentHash = newHash;
                }
                return boundingSphere;
            },
            get groupMapping() {
                if (mesh.groupBuffer.ref.version !== currentGroup) {
                    groupMapping = Object(_util__WEBPACK_IMPORTED_MODULE_4__["createGroupMapping"])(mesh.groupBuffer.ref.value, mesh.vertexCount);
                    currentGroup = mesh.groupBuffer.ref.version;
                }
                return groupMapping;
            },
            setBoundingSphere: function (sphere) {
                _mol_math_geometry__WEBPACK_IMPORTED_MODULE_3__["Sphere3D"].copy(boundingSphere, sphere);
                currentHash = hashCode(mesh);
            }
        };
        return mesh;
    }
    function update(vertices, indices, normals, groups, vertexCount, triangleCount, mesh) {
        mesh.vertexCount = vertexCount;
        mesh.triangleCount = triangleCount;
        _mol_util__WEBPACK_IMPORTED_MODULE_1__["ValueCell"].update(mesh.vertexBuffer, vertices);
        _mol_util__WEBPACK_IMPORTED_MODULE_1__["ValueCell"].update(mesh.indexBuffer, indices);
        _mol_util__WEBPACK_IMPORTED_MODULE_1__["ValueCell"].update(mesh.normalBuffer, normals);
        _mol_util__WEBPACK_IMPORTED_MODULE_1__["ValueCell"].update(mesh.groupBuffer, groups);
        return mesh;
    }
    function computeNormals(mesh) {
        var vertexCount = mesh.vertexCount, triangleCount = mesh.triangleCount;
        var vertices = mesh.vertexBuffer.ref.value;
        var indices = mesh.indexBuffer.ref.value;
        var normals = mesh.normalBuffer.ref.value.length >= vertexCount * 3
            ? mesh.normalBuffer.ref.value
            : new Float32Array(vertexCount * 3);
        if (normals === mesh.normalBuffer.ref.value) {
            normals.fill(0, 0, vertexCount * 3);
        }
        Object(_util__WEBPACK_IMPORTED_MODULE_4__["computeIndexedVertexNormals"])(vertices, indices, normals, vertexCount, triangleCount);
        _mol_util__WEBPACK_IMPORTED_MODULE_1__["ValueCell"].update(mesh.normalBuffer, normals);
    }
    Mesh.computeNormals = computeNormals;
    function checkForDuplicateVertices(mesh, fractionDigits) {
        if (fractionDigits === void 0) { fractionDigits = 3; }
        var v = mesh.vertexBuffer.ref.value;
        var map = new Map();
        var hash = function (v, d) { return v[0].toFixed(d) + "|" + v[1].toFixed(d) + "|" + v[2].toFixed(d); };
        var duplicates = 0;
        var a = Object(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_2__["Vec3"])();
        for (var i = 0, il = mesh.vertexCount; i < il; ++i) {
            _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_2__["Vec3"].fromArray(a, v, i * 3);
            var k = hash(a, fractionDigits);
            var count = map.get(k);
            if (count !== undefined) {
                duplicates += 1;
                map.set(k, count + 1);
            }
            else {
                map.set(k, 1);
            }
        }
        return duplicates;
    }
    Mesh.checkForDuplicateVertices = checkForDuplicateVertices;
    var tmpMat3 = Object(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_2__["Mat3"])();
    function transform(mesh, t) {
        var v = mesh.vertexBuffer.ref.value;
        Object(_util__WEBPACK_IMPORTED_MODULE_4__["transformPositionArray"])(t, v, 0, mesh.vertexCount);
        if (!_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_2__["Mat4"].isTranslationAndUniformScaling(t)) {
            var n = _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_2__["Mat3"].directionTransform(tmpMat3, t);
            Object(_util__WEBPACK_IMPORTED_MODULE_4__["transformDirectionArray"])(n, mesh.normalBuffer.ref.value, 0, mesh.vertexCount);
        }
        _mol_util__WEBPACK_IMPORTED_MODULE_1__["ValueCell"].update(mesh.vertexBuffer, v);
    }
    Mesh.transform = transform;
    /**
     * Ensure that each vertices of each triangle have the same group id.
     * Note that normals are copied over and can't be re-created from the new mesh.
     */
    function uniformTriangleGroup(mesh, splitTriangles) {
        if (splitTriangles === void 0) { splitTriangles = true; }
        var indexBuffer = mesh.indexBuffer, vertexBuffer = mesh.vertexBuffer, groupBuffer = mesh.groupBuffer, normalBuffer = mesh.normalBuffer, triangleCount = mesh.triangleCount, vertexCount = mesh.vertexCount;
        var ib = indexBuffer.ref.value;
        var vb = vertexBuffer.ref.value;
        var gb = groupBuffer.ref.value;
        var nb = normalBuffer.ref.value;
        // new
        var index = _mol_data_util__WEBPACK_IMPORTED_MODULE_8__["ChunkedArray"].create(Uint32Array, 3, 1024, triangleCount);
        // re-use
        var vertex = _mol_data_util__WEBPACK_IMPORTED_MODULE_8__["ChunkedArray"].create(Float32Array, 3, 1024, vb);
        vertex.currentIndex = vertexCount * 3;
        vertex.elementCount = vertexCount;
        var normal = _mol_data_util__WEBPACK_IMPORTED_MODULE_8__["ChunkedArray"].create(Float32Array, 3, 1024, nb);
        normal.currentIndex = vertexCount * 3;
        normal.elementCount = vertexCount;
        var group = _mol_data_util__WEBPACK_IMPORTED_MODULE_8__["ChunkedArray"].create(Float32Array, 1, 1024, gb);
        group.currentIndex = vertexCount;
        group.elementCount = vertexCount;
        var vi = Object(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_2__["Vec3"])();
        var vj = Object(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_2__["Vec3"])();
        var vk = Object(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_2__["Vec3"])();
        var ni = Object(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_2__["Vec3"])();
        var nj = Object(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_2__["Vec3"])();
        var nk = Object(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_2__["Vec3"])();
        function add(i) {
            _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_2__["Vec3"].fromArray(vi, vb, i * 3);
            _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_2__["Vec3"].fromArray(ni, nb, i * 3);
            _mol_data_util__WEBPACK_IMPORTED_MODULE_8__["ChunkedArray"].add3(vertex, vi[0], vi[1], vi[2]);
            _mol_data_util__WEBPACK_IMPORTED_MODULE_8__["ChunkedArray"].add3(normal, ni[0], ni[1], ni[2]);
        }
        function addMid(i, j) {
            _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_2__["Vec3"].fromArray(vi, vb, i * 3);
            _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_2__["Vec3"].fromArray(vj, vb, j * 3);
            _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_2__["Vec3"].scale(vi, _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_2__["Vec3"].add(vi, vi, vj), 0.5);
            _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_2__["Vec3"].fromArray(ni, nb, i * 3);
            _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_2__["Vec3"].fromArray(nj, nb, j * 3);
            _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_2__["Vec3"].scale(ni, _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_2__["Vec3"].add(ni, ni, nj), 0.5);
            _mol_data_util__WEBPACK_IMPORTED_MODULE_8__["ChunkedArray"].add3(vertex, vi[0], vi[1], vi[2]);
            _mol_data_util__WEBPACK_IMPORTED_MODULE_8__["ChunkedArray"].add3(normal, ni[0], ni[1], ni[2]);
        }
        function addCenter(i, j, k) {
            _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_2__["Vec3"].fromArray(vi, vb, i * 3);
            _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_2__["Vec3"].fromArray(vj, vb, j * 3);
            _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_2__["Vec3"].fromArray(vk, vb, k * 3);
            _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_2__["Vec3"].scale(vi, _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_2__["Vec3"].add(vi, _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_2__["Vec3"].add(vi, vi, vj), vk), 1 / 3);
            _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_2__["Vec3"].fromArray(ni, nb, i * 3);
            _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_2__["Vec3"].fromArray(nj, nb, j * 3);
            _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_2__["Vec3"].fromArray(nk, nb, k * 3);
            _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_2__["Vec3"].scale(ni, _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_2__["Vec3"].add(ni, _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_2__["Vec3"].add(ni, ni, nj), nk), 1 / 3);
            _mol_data_util__WEBPACK_IMPORTED_MODULE_8__["ChunkedArray"].add3(vertex, vi[0], vi[1], vi[2]);
            _mol_data_util__WEBPACK_IMPORTED_MODULE_8__["ChunkedArray"].add3(normal, ni[0], ni[1], ni[2]);
        }
        function split2(i0, i1, i2, g0, g1) {
            ++newTriangleCount;
            add(i0);
            addMid(i0, i1);
            addMid(i0, i2);
            _mol_data_util__WEBPACK_IMPORTED_MODULE_8__["ChunkedArray"].add3(index, newVertexCount, newVertexCount + 1, newVertexCount + 2);
            for (var j = 0; j < 3; ++j)
                _mol_data_util__WEBPACK_IMPORTED_MODULE_8__["ChunkedArray"].add(group, g0);
            newVertexCount += 3;
            newTriangleCount += 2;
            add(i1);
            add(i2);
            addMid(i0, i1);
            addMid(i0, i2);
            _mol_data_util__WEBPACK_IMPORTED_MODULE_8__["ChunkedArray"].add3(index, newVertexCount, newVertexCount + 1, newVertexCount + 3);
            _mol_data_util__WEBPACK_IMPORTED_MODULE_8__["ChunkedArray"].add3(index, newVertexCount, newVertexCount + 3, newVertexCount + 2);
            for (var j = 0; j < 4; ++j)
                _mol_data_util__WEBPACK_IMPORTED_MODULE_8__["ChunkedArray"].add(group, g1);
            newVertexCount += 4;
        }
        var newVertexCount = vertexCount;
        var newTriangleCount = 0;
        if (splitTriangles) {
            for (var i = 0, il = triangleCount; i < il; ++i) {
                var i0 = ib[i * 3], i1 = ib[i * 3 + 1], i2 = ib[i * 3 + 2];
                var g0 = gb[i0], g1 = gb[i1], g2 = gb[i2];
                if (g0 === g1 && g0 === g2) {
                    ++newTriangleCount;
                    _mol_data_util__WEBPACK_IMPORTED_MODULE_8__["ChunkedArray"].add3(index, i0, i1, i2);
                }
                else if (g0 === g1) {
                    split2(i2, i0, i1, g2, g0);
                }
                else if (g0 === g2) {
                    split2(i1, i2, i0, g1, g2);
                }
                else if (g1 === g2) {
                    split2(i0, i1, i2, g0, g1);
                }
                else {
                    newTriangleCount += 2;
                    add(i0);
                    addMid(i0, i1);
                    addMid(i0, i2);
                    addCenter(i0, i1, i2);
                    _mol_data_util__WEBPACK_IMPORTED_MODULE_8__["ChunkedArray"].add3(index, newVertexCount, newVertexCount + 1, newVertexCount + 3);
                    _mol_data_util__WEBPACK_IMPORTED_MODULE_8__["ChunkedArray"].add3(index, newVertexCount, newVertexCount + 3, newVertexCount + 2);
                    for (var j = 0; j < 4; ++j)
                        _mol_data_util__WEBPACK_IMPORTED_MODULE_8__["ChunkedArray"].add(group, g0);
                    newVertexCount += 4;
                    newTriangleCount += 2;
                    add(i1);
                    addMid(i1, i2);
                    addMid(i1, i0);
                    addCenter(i0, i1, i2);
                    _mol_data_util__WEBPACK_IMPORTED_MODULE_8__["ChunkedArray"].add3(index, newVertexCount, newVertexCount + 1, newVertexCount + 3);
                    _mol_data_util__WEBPACK_IMPORTED_MODULE_8__["ChunkedArray"].add3(index, newVertexCount, newVertexCount + 3, newVertexCount + 2);
                    for (var j = 0; j < 4; ++j)
                        _mol_data_util__WEBPACK_IMPORTED_MODULE_8__["ChunkedArray"].add(group, g1);
                    newVertexCount += 4;
                    newTriangleCount += 2;
                    add(i2);
                    addMid(i2, i1);
                    addMid(i2, i0);
                    addCenter(i0, i1, i2);
                    _mol_data_util__WEBPACK_IMPORTED_MODULE_8__["ChunkedArray"].add3(index, newVertexCount + 3, newVertexCount + 1, newVertexCount);
                    _mol_data_util__WEBPACK_IMPORTED_MODULE_8__["ChunkedArray"].add3(index, newVertexCount + 2, newVertexCount + 3, newVertexCount);
                    for (var j = 0; j < 4; ++j)
                        _mol_data_util__WEBPACK_IMPORTED_MODULE_8__["ChunkedArray"].add(group, g2);
                    newVertexCount += 4;
                }
            }
        }
        else {
            for (var i = 0, il = triangleCount; i < il; ++i) {
                var i0 = ib[i * 3], i1 = ib[i * 3 + 1], i2 = ib[i * 3 + 2];
                var g0 = gb[i0], g1 = gb[i1], g2 = gb[i2];
                if (g0 !== g1 || g0 !== g2) {
                    ++newTriangleCount;
                    add(i0);
                    add(i1);
                    add(i2);
                    _mol_data_util__WEBPACK_IMPORTED_MODULE_8__["ChunkedArray"].add3(index, newVertexCount, newVertexCount + 1, newVertexCount + 2);
                    var g = g1 === g2 ? g1 : g0;
                    for (var j = 0; j < 3; ++j)
                        _mol_data_util__WEBPACK_IMPORTED_MODULE_8__["ChunkedArray"].add(group, g);
                    newVertexCount += 3;
                }
                else {
                    ++newTriangleCount;
                    _mol_data_util__WEBPACK_IMPORTED_MODULE_8__["ChunkedArray"].add3(index, i0, i1, i2);
                }
            }
        }
        var newIb = _mol_data_util__WEBPACK_IMPORTED_MODULE_8__["ChunkedArray"].compact(index);
        var newVb = _mol_data_util__WEBPACK_IMPORTED_MODULE_8__["ChunkedArray"].compact(vertex);
        var newNb = _mol_data_util__WEBPACK_IMPORTED_MODULE_8__["ChunkedArray"].compact(normal);
        var newGb = _mol_data_util__WEBPACK_IMPORTED_MODULE_8__["ChunkedArray"].compact(group);
        mesh.vertexCount = newVertexCount;
        mesh.triangleCount = newTriangleCount;
        _mol_util__WEBPACK_IMPORTED_MODULE_1__["ValueCell"].update(vertexBuffer, newVb);
        _mol_util__WEBPACK_IMPORTED_MODULE_1__["ValueCell"].update(groupBuffer, newGb);
        _mol_util__WEBPACK_IMPORTED_MODULE_1__["ValueCell"].update(indexBuffer, newIb);
        _mol_util__WEBPACK_IMPORTED_MODULE_1__["ValueCell"].update(normalBuffer, newNb);
        return mesh;
    }
    Mesh.uniformTriangleGroup = uniformTriangleGroup;
    //
    Mesh.Params = Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, _base__WEBPACK_IMPORTED_MODULE_11__["BaseGeometry"].Params), { doubleSided: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_9__["ParamDefinition"].Boolean(false, _base__WEBPACK_IMPORTED_MODULE_11__["BaseGeometry"].CustomQualityParamInfo), flipSided: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_9__["ParamDefinition"].Boolean(false, _base__WEBPACK_IMPORTED_MODULE_11__["BaseGeometry"].ShadingCategory), flatShaded: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_9__["ParamDefinition"].Boolean(false, _base__WEBPACK_IMPORTED_MODULE_11__["BaseGeometry"].ShadingCategory), ignoreLight: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_9__["ParamDefinition"].Boolean(false, _base__WEBPACK_IMPORTED_MODULE_11__["BaseGeometry"].ShadingCategory), xrayShaded: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_9__["ParamDefinition"].Boolean(false, _base__WEBPACK_IMPORTED_MODULE_11__["BaseGeometry"].ShadingCategory) });
    Mesh.Utils = {
        Params: Mesh.Params,
        createEmpty: createEmpty,
        createValues: createValues,
        createValuesSimple: createValuesSimple,
        updateValues: updateValues,
        updateBoundingSphere: updateBoundingSphere,
        createRenderableState: createRenderableState,
        updateRenderableState: updateRenderableState,
        createPositionIterator: createPositionIterator
    };
    function createPositionIterator(mesh, transform) {
        var groupCount = mesh.vertexCount;
        var instanceCount = transform.instanceCount.ref.value;
        var location = Object(_util_location_iterator__WEBPACK_IMPORTED_MODULE_6__["PositionLocation"])();
        var p = location.position;
        var v = mesh.vertexBuffer.ref.value;
        var m = transform.aTransform.ref.value;
        var getLocation = function (groupIndex, instanceIndex) {
            if (instanceIndex < 0) {
                _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_2__["Vec3"].fromArray(p, v, groupIndex * 3);
            }
            else {
                _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_2__["Vec3"].transformMat4Offset(p, v, m, 0, groupIndex * 3, instanceIndex * 16);
            }
            return location;
        };
        return Object(_util_location_iterator__WEBPACK_IMPORTED_MODULE_6__["LocationIterator"])(groupCount, instanceCount, 1, getLocation);
    }
    function createValues(mesh, transform, locationIt, theme, props) {
        var instanceCount = locationIt.instanceCount, groupCount = locationIt.groupCount;
        if (instanceCount !== transform.instanceCount.ref.value) {
            throw new Error('instanceCount values in TransformData and LocationIterator differ');
        }
        var positionIt = createPositionIterator(mesh, transform);
        var color = Object(_color_data__WEBPACK_IMPORTED_MODULE_7__["createColors"])(locationIt, positionIt, theme.color);
        var marker = Object(_marker_data__WEBPACK_IMPORTED_MODULE_5__["createMarkers"])(instanceCount * groupCount);
        var overpaint = Object(_overpaint_data__WEBPACK_IMPORTED_MODULE_12__["createEmptyOverpaint"])();
        var transparency = Object(_transparency_data__WEBPACK_IMPORTED_MODULE_13__["createEmptyTransparency"])();
        var clipping = Object(_clipping_data__WEBPACK_IMPORTED_MODULE_14__["createEmptyClipping"])();
        var counts = { drawCount: mesh.triangleCount * 3, vertexCount: mesh.vertexCount, groupCount: groupCount, instanceCount: instanceCount };
        var invariantBoundingSphere = _mol_math_geometry__WEBPACK_IMPORTED_MODULE_3__["Sphere3D"].clone(mesh.boundingSphere);
        var boundingSphere = Object(_mol_gl_renderable_util__WEBPACK_IMPORTED_MODULE_10__["calculateTransformBoundingSphere"])(invariantBoundingSphere, transform.aTransform.ref.value, instanceCount);
        return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({ aPosition: mesh.vertexBuffer, aNormal: mesh.normalBuffer, aGroup: mesh.groupBuffer, elements: mesh.indexBuffer, boundingSphere: _mol_util__WEBPACK_IMPORTED_MODULE_1__["ValueCell"].create(boundingSphere), invariantBoundingSphere: _mol_util__WEBPACK_IMPORTED_MODULE_1__["ValueCell"].create(invariantBoundingSphere), uInvariantBoundingSphere: _mol_util__WEBPACK_IMPORTED_MODULE_1__["ValueCell"].create(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_2__["Vec4"].ofSphere(invariantBoundingSphere)) }, color), marker), overpaint), transparency), clipping), transform), _base__WEBPACK_IMPORTED_MODULE_11__["BaseGeometry"].createValues(props, counts)), { dDoubleSided: _mol_util__WEBPACK_IMPORTED_MODULE_1__["ValueCell"].create(props.doubleSided), dFlatShaded: _mol_util__WEBPACK_IMPORTED_MODULE_1__["ValueCell"].create(props.flatShaded), dFlipSided: _mol_util__WEBPACK_IMPORTED_MODULE_1__["ValueCell"].create(props.flipSided), dIgnoreLight: _mol_util__WEBPACK_IMPORTED_MODULE_1__["ValueCell"].create(props.ignoreLight), dXrayShaded: _mol_util__WEBPACK_IMPORTED_MODULE_1__["ValueCell"].create(props.xrayShaded) });
    }
    function createValuesSimple(mesh, props, colorValue, sizeValue, transform) {
        var s = _base__WEBPACK_IMPORTED_MODULE_11__["BaseGeometry"].createSimple(colorValue, sizeValue, transform);
        var p = Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_9__["ParamDefinition"].getDefaultValues(Mesh.Params)), props);
        return createValues(mesh, s.transform, s.locationIterator, s.theme, p);
    }
    function updateValues(values, props) {
        _base__WEBPACK_IMPORTED_MODULE_11__["BaseGeometry"].updateValues(values, props);
        _mol_util__WEBPACK_IMPORTED_MODULE_1__["ValueCell"].updateIfChanged(values.dDoubleSided, props.doubleSided);
        _mol_util__WEBPACK_IMPORTED_MODULE_1__["ValueCell"].updateIfChanged(values.dFlatShaded, props.flatShaded);
        _mol_util__WEBPACK_IMPORTED_MODULE_1__["ValueCell"].updateIfChanged(values.dFlipSided, props.flipSided);
        _mol_util__WEBPACK_IMPORTED_MODULE_1__["ValueCell"].updateIfChanged(values.dIgnoreLight, props.ignoreLight);
        _mol_util__WEBPACK_IMPORTED_MODULE_1__["ValueCell"].updateIfChanged(values.dXrayShaded, props.xrayShaded);
    }
    function updateBoundingSphere(values, mesh) {
        var invariantBoundingSphere = _mol_math_geometry__WEBPACK_IMPORTED_MODULE_3__["Sphere3D"].clone(mesh.boundingSphere);
        var boundingSphere = Object(_mol_gl_renderable_util__WEBPACK_IMPORTED_MODULE_10__["calculateTransformBoundingSphere"])(invariantBoundingSphere, values.aTransform.ref.value, values.instanceCount.ref.value);
        if (!_mol_math_geometry__WEBPACK_IMPORTED_MODULE_3__["Sphere3D"].equals(boundingSphere, values.boundingSphere.ref.value)) {
            _mol_util__WEBPACK_IMPORTED_MODULE_1__["ValueCell"].update(values.boundingSphere, boundingSphere);
        }
        if (!_mol_math_geometry__WEBPACK_IMPORTED_MODULE_3__["Sphere3D"].equals(invariantBoundingSphere, values.invariantBoundingSphere.ref.value)) {
            _mol_util__WEBPACK_IMPORTED_MODULE_1__["ValueCell"].update(values.invariantBoundingSphere, invariantBoundingSphere);
            _mol_util__WEBPACK_IMPORTED_MODULE_1__["ValueCell"].update(values.uInvariantBoundingSphere, _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_2__["Vec4"].fromSphere(values.uInvariantBoundingSphere.ref.value, invariantBoundingSphere));
        }
    }
    function createRenderableState(props) {
        var state = _base__WEBPACK_IMPORTED_MODULE_11__["BaseGeometry"].createRenderableState(props);
        updateRenderableState(state, props);
        return state;
    }
    function updateRenderableState(state, props) {
        _base__WEBPACK_IMPORTED_MODULE_11__["BaseGeometry"].updateRenderableState(state, props);
        state.opaque = state.opaque && !props.xrayShaded;
        state.writeDepth = state.opaque;
    }
})(Mesh || (Mesh = {}));
//# sourceMappingURL=mesh.js.map

/***/ }),

/***/ "./lib/mol-geo/geometry/overpaint-data.js":
/*!************************************************!*\
  !*** ./lib/mol-geo/geometry/overpaint-data.js ***!
  \************************************************/
/*! exports provided: applyOverpaintColor, clearOverpaint, createOverpaint, createEmptyOverpaint */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "applyOverpaintColor", function() { return applyOverpaintColor; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "clearOverpaint", function() { return clearOverpaint; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createOverpaint", function() { return createOverpaint; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createEmptyOverpaint", function() { return createEmptyOverpaint; });
/* harmony import */ var _mol_util_value_cell__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../mol-util/value-cell */ "./lib/mol-util/value-cell.js");
/* harmony import */ var _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../mol-math/linear-algebra */ "./lib/mol-math/linear-algebra.js");
/* harmony import */ var _mol_gl_renderable_util__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../mol-gl/renderable/util */ "./lib/mol-gl/renderable/util.js");
/* harmony import */ var _mol_util_color__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../mol-util/color */ "./lib/mol-util/color/index.js");
/**
 * Copyright (c) 2019-2020 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */




function applyOverpaintColor(array, start, end, color) {
    for (var i = start; i < end; ++i) {
        _mol_util_color__WEBPACK_IMPORTED_MODULE_3__["Color"].toArray(color, array, i * 4);
        array[i * 4 + 3] = 255;
    }
    return true;
}
function clearOverpaint(array, start, end) {
    array.fill(0, start * 4, end * 4);
    return true;
}
function createOverpaint(count, overpaintData) {
    var overpaint = Object(_mol_gl_renderable_util__WEBPACK_IMPORTED_MODULE_2__["createTextureImage"])(Math.max(1, count), 4, Uint8Array, overpaintData && overpaintData.tOverpaint.ref.value.array);
    if (overpaintData) {
        _mol_util_value_cell__WEBPACK_IMPORTED_MODULE_0__["ValueCell"].update(overpaintData.tOverpaint, overpaint);
        _mol_util_value_cell__WEBPACK_IMPORTED_MODULE_0__["ValueCell"].update(overpaintData.uOverpaintTexDim, _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_1__["Vec2"].create(overpaint.width, overpaint.height));
        _mol_util_value_cell__WEBPACK_IMPORTED_MODULE_0__["ValueCell"].updateIfChanged(overpaintData.dOverpaint, count > 0);
        return overpaintData;
    }
    else {
        return {
            tOverpaint: _mol_util_value_cell__WEBPACK_IMPORTED_MODULE_0__["ValueCell"].create(overpaint),
            uOverpaintTexDim: _mol_util_value_cell__WEBPACK_IMPORTED_MODULE_0__["ValueCell"].create(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_1__["Vec2"].create(overpaint.width, overpaint.height)),
            dOverpaint: _mol_util_value_cell__WEBPACK_IMPORTED_MODULE_0__["ValueCell"].create(count > 0),
        };
    }
}
var emptyOverpaintTexture = { array: new Uint8Array(4), width: 1, height: 1 };
function createEmptyOverpaint(overpaintData) {
    if (overpaintData) {
        _mol_util_value_cell__WEBPACK_IMPORTED_MODULE_0__["ValueCell"].update(overpaintData.tOverpaint, emptyOverpaintTexture);
        _mol_util_value_cell__WEBPACK_IMPORTED_MODULE_0__["ValueCell"].update(overpaintData.uOverpaintTexDim, _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_1__["Vec2"].create(1, 1));
        return overpaintData;
    }
    else {
        return {
            tOverpaint: _mol_util_value_cell__WEBPACK_IMPORTED_MODULE_0__["ValueCell"].create(emptyOverpaintTexture),
            uOverpaintTexDim: _mol_util_value_cell__WEBPACK_IMPORTED_MODULE_0__["ValueCell"].create(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_1__["Vec2"].create(1, 1)),
            dOverpaint: _mol_util_value_cell__WEBPACK_IMPORTED_MODULE_0__["ValueCell"].create(false),
        };
    }
}
//# sourceMappingURL=overpaint-data.js.map

/***/ }),

/***/ "./lib/mol-geo/geometry/points/points-builder.js":
/*!*******************************************************!*\
  !*** ./lib/mol-geo/geometry/points/points-builder.js ***!
  \*******************************************************/
/*! exports provided: PointsBuilder */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "PointsBuilder", function() { return PointsBuilder; });
/* harmony import */ var _mol_data_util__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../../mol-data/util */ "./lib/mol-data/util.js");
/* harmony import */ var _points__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./points */ "./lib/mol-geo/geometry/points/points.js");
/**
 * Copyright (c) 2018-2020 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */


// avoiding namespace lookup improved performance in Chrome (Aug 2020)
var caAdd3 = _mol_data_util__WEBPACK_IMPORTED_MODULE_0__["ChunkedArray"].add3;
var caAdd = _mol_data_util__WEBPACK_IMPORTED_MODULE_0__["ChunkedArray"].add;
var PointsBuilder;
(function (PointsBuilder) {
    function create(initialCount, chunkSize, points) {
        if (initialCount === void 0) { initialCount = 2048; }
        if (chunkSize === void 0) { chunkSize = 1024; }
        var centers = _mol_data_util__WEBPACK_IMPORTED_MODULE_0__["ChunkedArray"].create(Float32Array, 3, chunkSize, points ? points.centerBuffer.ref.value : initialCount);
        var groups = _mol_data_util__WEBPACK_IMPORTED_MODULE_0__["ChunkedArray"].create(Float32Array, 1, chunkSize, points ? points.groupBuffer.ref.value : initialCount);
        return {
            add: function (x, y, z, group) {
                caAdd3(centers, x, y, z);
                caAdd(groups, group);
            },
            getPoints: function () {
                var cb = _mol_data_util__WEBPACK_IMPORTED_MODULE_0__["ChunkedArray"].compact(centers, true);
                var gb = _mol_data_util__WEBPACK_IMPORTED_MODULE_0__["ChunkedArray"].compact(groups, true);
                return _points__WEBPACK_IMPORTED_MODULE_1__["Points"].create(cb, gb, centers.elementCount, points);
            }
        };
    }
    PointsBuilder.create = create;
})(PointsBuilder || (PointsBuilder = {}));
//# sourceMappingURL=points-builder.js.map

/***/ }),

/***/ "./lib/mol-geo/geometry/points/points.js":
/*!***********************************************!*\
  !*** ./lib/mol-geo/geometry/points/points.js ***!
  \***********************************************/
/*! exports provided: Points */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Points", function() { return Points; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _mol_util__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../../mol-util */ "./lib/mol-util/index.js");
/* harmony import */ var _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../../mol-math/linear-algebra */ "./lib/mol-math/linear-algebra.js");
/* harmony import */ var _util__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../util */ "./lib/mol-geo/util.js");
/* harmony import */ var _color_data__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../color-data */ "./lib/mol-geo/geometry/color-data.js");
/* harmony import */ var _marker_data__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../marker-data */ "./lib/mol-geo/geometry/marker-data.js");
/* harmony import */ var _size_data__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../size-data */ "./lib/mol-geo/geometry/size-data.js");
/* harmony import */ var _util_location_iterator__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../../util/location-iterator */ "./lib/mol-geo/util/location-iterator.js");
/* harmony import */ var _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ../../../mol-util/param-definition */ "./lib/mol-util/param-definition.js");
/* harmony import */ var _mol_gl_renderable_util__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ../../../mol-gl/renderable/util */ "./lib/mol-gl/renderable/util.js");
/* harmony import */ var _mol_math_geometry__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ../../../mol-math/geometry */ "./lib/mol-math/geometry.js");
/* harmony import */ var _base__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ../base */ "./lib/mol-geo/geometry/base.js");
/* harmony import */ var _overpaint_data__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! ../overpaint-data */ "./lib/mol-geo/geometry/overpaint-data.js");
/* harmony import */ var _transparency_data__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! ../transparency-data */ "./lib/mol-geo/geometry/transparency-data.js");
/* harmony import */ var _mol_data_util__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! ../../../mol-data/util */ "./lib/mol-data/util.js");
/* harmony import */ var _clipping_data__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! ../clipping-data */ "./lib/mol-geo/geometry/clipping-data.js");
/**
 * Copyright (c) 2018-2020 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */
















var Points;
(function (Points) {
    function create(centers, groups, pointCount, points) {
        return points ?
            update(centers, groups, pointCount, points) :
            fromArrays(centers, groups, pointCount);
    }
    Points.create = create;
    function createEmpty(points) {
        var cb = points ? points.centerBuffer.ref.value : new Float32Array(0);
        var gb = points ? points.groupBuffer.ref.value : new Float32Array(0);
        return create(cb, gb, 0, points);
    }
    Points.createEmpty = createEmpty;
    function hashCode(points) {
        return Object(_mol_data_util__WEBPACK_IMPORTED_MODULE_14__["hashFnv32a"])([
            points.pointCount, points.centerBuffer.ref.version, points.groupBuffer.ref.version,
        ]);
    }
    function fromArrays(centers, groups, pointCount) {
        var boundingSphere = Object(_mol_math_geometry__WEBPACK_IMPORTED_MODULE_10__["Sphere3D"])();
        var groupMapping;
        var currentHash = -1;
        var currentGroup = -1;
        var points = {
            kind: 'points',
            pointCount: pointCount,
            centerBuffer: _mol_util__WEBPACK_IMPORTED_MODULE_1__["ValueCell"].create(centers),
            groupBuffer: _mol_util__WEBPACK_IMPORTED_MODULE_1__["ValueCell"].create(groups),
            get boundingSphere() {
                var newHash = hashCode(points);
                if (newHash !== currentHash) {
                    var b = Object(_mol_gl_renderable_util__WEBPACK_IMPORTED_MODULE_9__["calculateInvariantBoundingSphere"])(points.centerBuffer.ref.value, points.pointCount, 1);
                    _mol_math_geometry__WEBPACK_IMPORTED_MODULE_10__["Sphere3D"].copy(boundingSphere, b);
                    currentHash = newHash;
                }
                return boundingSphere;
            },
            get groupMapping() {
                if (points.groupBuffer.ref.version !== currentGroup) {
                    groupMapping = Object(_util__WEBPACK_IMPORTED_MODULE_3__["createGroupMapping"])(points.groupBuffer.ref.value, points.pointCount);
                    currentGroup = points.groupBuffer.ref.version;
                }
                return groupMapping;
            },
            setBoundingSphere: function (sphere) {
                _mol_math_geometry__WEBPACK_IMPORTED_MODULE_10__["Sphere3D"].copy(boundingSphere, sphere);
                currentHash = hashCode(points);
            }
        };
        return points;
    }
    function update(centers, groups, pointCount, points) {
        points.pointCount = pointCount;
        _mol_util__WEBPACK_IMPORTED_MODULE_1__["ValueCell"].update(points.centerBuffer, centers);
        _mol_util__WEBPACK_IMPORTED_MODULE_1__["ValueCell"].update(points.groupBuffer, groups);
        return points;
    }
    function transform(points, t) {
        var c = points.centerBuffer.ref.value;
        Object(_util__WEBPACK_IMPORTED_MODULE_3__["transformPositionArray"])(t, c, 0, points.pointCount);
        _mol_util__WEBPACK_IMPORTED_MODULE_1__["ValueCell"].update(points.centerBuffer, c);
    }
    Points.transform = transform;
    //
    Points.Params = Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, _base__WEBPACK_IMPORTED_MODULE_11__["BaseGeometry"].Params), { sizeFactor: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_8__["ParamDefinition"].Numeric(1.5, { min: 0, max: 10, step: 0.1 }), pointSizeAttenuation: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_8__["ParamDefinition"].Boolean(false), pointFilledCircle: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_8__["ParamDefinition"].Boolean(false), pointEdgeBleach: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_8__["ParamDefinition"].Numeric(0.2, { min: 0, max: 1, step: 0.05 }) });
    Points.Utils = {
        Params: Points.Params,
        createEmpty: createEmpty,
        createValues: createValues,
        createValuesSimple: createValuesSimple,
        updateValues: updateValues,
        updateBoundingSphere: updateBoundingSphere,
        createRenderableState: createRenderableState,
        updateRenderableState: updateRenderableState,
        createPositionIterator: createPositionIterator
    };
    function createPositionIterator(points, transform) {
        var groupCount = points.pointCount;
        var instanceCount = transform.instanceCount.ref.value;
        var location = Object(_util_location_iterator__WEBPACK_IMPORTED_MODULE_7__["PositionLocation"])();
        var p = location.position;
        var v = points.centerBuffer.ref.value;
        var m = transform.aTransform.ref.value;
        var getLocation = function (groupIndex, instanceIndex) {
            if (instanceIndex < 0) {
                _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_2__["Vec3"].fromArray(p, v, groupIndex * 3);
            }
            else {
                _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_2__["Vec3"].transformMat4Offset(p, v, m, 0, groupIndex * 3, instanceIndex * 16);
            }
            return location;
        };
        return Object(_util_location_iterator__WEBPACK_IMPORTED_MODULE_7__["LocationIterator"])(groupCount, instanceCount, 1, getLocation);
    }
    function createValues(points, transform, locationIt, theme, props) {
        var instanceCount = locationIt.instanceCount, groupCount = locationIt.groupCount;
        var positionIt = createPositionIterator(points, transform);
        var color = Object(_color_data__WEBPACK_IMPORTED_MODULE_4__["createColors"])(locationIt, positionIt, theme.color);
        var size = Object(_size_data__WEBPACK_IMPORTED_MODULE_6__["createSizes"])(locationIt, theme.size);
        var marker = Object(_marker_data__WEBPACK_IMPORTED_MODULE_5__["createMarkers"])(instanceCount * groupCount);
        var overpaint = Object(_overpaint_data__WEBPACK_IMPORTED_MODULE_12__["createEmptyOverpaint"])();
        var transparency = Object(_transparency_data__WEBPACK_IMPORTED_MODULE_13__["createEmptyTransparency"])();
        var clipping = Object(_clipping_data__WEBPACK_IMPORTED_MODULE_15__["createEmptyClipping"])();
        var counts = { drawCount: points.pointCount, vertexCount: points.pointCount, groupCount: groupCount, instanceCount: instanceCount };
        var invariantBoundingSphere = _mol_math_geometry__WEBPACK_IMPORTED_MODULE_10__["Sphere3D"].clone(points.boundingSphere);
        var boundingSphere = Object(_mol_gl_renderable_util__WEBPACK_IMPORTED_MODULE_9__["calculateTransformBoundingSphere"])(invariantBoundingSphere, transform.aTransform.ref.value, instanceCount);
        return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({ aPosition: points.centerBuffer, aGroup: points.groupBuffer, boundingSphere: _mol_util__WEBPACK_IMPORTED_MODULE_1__["ValueCell"].create(boundingSphere), invariantBoundingSphere: _mol_util__WEBPACK_IMPORTED_MODULE_1__["ValueCell"].create(invariantBoundingSphere), uInvariantBoundingSphere: _mol_util__WEBPACK_IMPORTED_MODULE_1__["ValueCell"].create(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_2__["Vec4"].ofSphere(invariantBoundingSphere)) }, color), size), marker), overpaint), transparency), clipping), transform), _base__WEBPACK_IMPORTED_MODULE_11__["BaseGeometry"].createValues(props, counts)), { uSizeFactor: _mol_util__WEBPACK_IMPORTED_MODULE_1__["ValueCell"].create(props.sizeFactor), dPointSizeAttenuation: _mol_util__WEBPACK_IMPORTED_MODULE_1__["ValueCell"].create(props.pointSizeAttenuation), dPointFilledCircle: _mol_util__WEBPACK_IMPORTED_MODULE_1__["ValueCell"].create(props.pointFilledCircle), uPointEdgeBleach: _mol_util__WEBPACK_IMPORTED_MODULE_1__["ValueCell"].create(props.pointEdgeBleach) });
    }
    function createValuesSimple(points, props, colorValue, sizeValue, transform) {
        var s = _base__WEBPACK_IMPORTED_MODULE_11__["BaseGeometry"].createSimple(colorValue, sizeValue, transform);
        var p = Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_8__["ParamDefinition"].getDefaultValues(Points.Params)), props);
        return createValues(points, s.transform, s.locationIterator, s.theme, p);
    }
    function updateValues(values, props) {
        _base__WEBPACK_IMPORTED_MODULE_11__["BaseGeometry"].updateValues(values, props);
        _mol_util__WEBPACK_IMPORTED_MODULE_1__["ValueCell"].updateIfChanged(values.uSizeFactor, props.sizeFactor);
        _mol_util__WEBPACK_IMPORTED_MODULE_1__["ValueCell"].updateIfChanged(values.dPointSizeAttenuation, props.pointSizeAttenuation);
        _mol_util__WEBPACK_IMPORTED_MODULE_1__["ValueCell"].updateIfChanged(values.dPointFilledCircle, props.pointFilledCircle);
        _mol_util__WEBPACK_IMPORTED_MODULE_1__["ValueCell"].updateIfChanged(values.uPointEdgeBleach, props.pointEdgeBleach);
    }
    function updateBoundingSphere(values, points) {
        var invariantBoundingSphere = _mol_math_geometry__WEBPACK_IMPORTED_MODULE_10__["Sphere3D"].clone(points.boundingSphere);
        var boundingSphere = Object(_mol_gl_renderable_util__WEBPACK_IMPORTED_MODULE_9__["calculateTransformBoundingSphere"])(invariantBoundingSphere, values.aTransform.ref.value, values.instanceCount.ref.value);
        if (!_mol_math_geometry__WEBPACK_IMPORTED_MODULE_10__["Sphere3D"].equals(boundingSphere, values.boundingSphere.ref.value)) {
            _mol_util__WEBPACK_IMPORTED_MODULE_1__["ValueCell"].update(values.boundingSphere, boundingSphere);
        }
        if (!_mol_math_geometry__WEBPACK_IMPORTED_MODULE_10__["Sphere3D"].equals(invariantBoundingSphere, values.invariantBoundingSphere.ref.value)) {
            _mol_util__WEBPACK_IMPORTED_MODULE_1__["ValueCell"].update(values.invariantBoundingSphere, invariantBoundingSphere);
            _mol_util__WEBPACK_IMPORTED_MODULE_1__["ValueCell"].update(values.uInvariantBoundingSphere, _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_2__["Vec4"].fromSphere(values.uInvariantBoundingSphere.ref.value, invariantBoundingSphere));
        }
    }
    function createRenderableState(props) {
        var state = _base__WEBPACK_IMPORTED_MODULE_11__["BaseGeometry"].createRenderableState(props);
        updateRenderableState(state, props);
        return state;
    }
    function updateRenderableState(state, props) {
        _base__WEBPACK_IMPORTED_MODULE_11__["BaseGeometry"].updateRenderableState(state, props);
        state.opaque = state.opaque && (!props.pointFilledCircle ||
            (props.pointFilledCircle && props.pointEdgeBleach === 0));
        state.writeDepth = state.opaque;
    }
})(Points || (Points = {}));
//# sourceMappingURL=points.js.map

/***/ }),

/***/ "./lib/mol-geo/geometry/size-data.js":
/*!*******************************************!*\
  !*** ./lib/mol-geo/geometry/size-data.js ***!
  \*******************************************/
/*! exports provided: createSizes, getMaxSize, createValueSize, createUniformSize, createTextureSize, createInstanceSize, createGroupSize, createGroupInstanceSize */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createSizes", function() { return createSizes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getMaxSize", function() { return getMaxSize; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createValueSize", function() { return createValueSize; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createUniformSize", function() { return createUniformSize; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createTextureSize", function() { return createTextureSize; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createInstanceSize", function() { return createInstanceSize; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createGroupSize", function() { return createGroupSize; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createGroupInstanceSize", function() { return createGroupInstanceSize; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _mol_util__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../mol-util */ "./lib/mol-util/index.js");
/* harmony import */ var _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../mol-math/linear-algebra */ "./lib/mol-math/linear-algebra.js");
/* harmony import */ var _mol_gl_renderable_util__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../mol-gl/renderable/util */ "./lib/mol-gl/renderable/util.js");
/* harmony import */ var _mol_model_location__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../mol-model/location */ "./lib/mol-model/location.js");
/* harmony import */ var _geometry__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./geometry */ "./lib/mol-geo/geometry/geometry.js");
/* harmony import */ var _mol_util_float_packing__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../../mol-util/float-packing */ "./lib/mol-util/float-packing.js");
/**
 * Copyright (c) 2018-2020 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */







function createSizes(locationIt, sizeTheme, sizeData) {
    switch (_geometry__WEBPACK_IMPORTED_MODULE_5__["Geometry"].getGranularity(locationIt, sizeTheme.granularity)) {
        case 'uniform': return createUniformSize(locationIt, sizeTheme.size, sizeData);
        case 'group': return createGroupSize(locationIt, sizeTheme.size, sizeData);
        case 'groupInstance': return createGroupInstanceSize(locationIt, sizeTheme.size, sizeData);
        case 'instance': return createInstanceSize(locationIt, sizeTheme.size, sizeData);
    }
}
var sizeFactor = 100; // NOTE same factor is set in shaders
function getMaxSize(sizeData) {
    var type = sizeData.dSizeType.ref.value;
    switch (type) {
        case 'uniform':
            return sizeData.uSize.ref.value;
        case 'instance':
        case 'group':
        case 'groupInstance':
            var maxSize = 0;
            var array = sizeData.tSize.ref.value.array;
            for (var i = 0, il = array.length; i < il; i += 3) {
                var value = Object(_mol_util_float_packing__WEBPACK_IMPORTED_MODULE_6__["decodeFloatRGB"])(array[i], array[i + 1], array[i + 2]);
                if (maxSize < value)
                    maxSize = value;
            }
            return maxSize / sizeFactor;
    }
}
var emptySizeTexture = { array: new Uint8Array(3), width: 1, height: 1 };
function createEmptySizeTexture() {
    return {
        tSize: _mol_util__WEBPACK_IMPORTED_MODULE_1__["ValueCell"].create(emptySizeTexture),
        uSizeTexDim: _mol_util__WEBPACK_IMPORTED_MODULE_1__["ValueCell"].create(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_2__["Vec2"].create(1, 1))
    };
}
function createValueSize(value, sizeData) {
    if (sizeData) {
        _mol_util__WEBPACK_IMPORTED_MODULE_1__["ValueCell"].update(sizeData.uSize, value);
        _mol_util__WEBPACK_IMPORTED_MODULE_1__["ValueCell"].updateIfChanged(sizeData.dSizeType, 'uniform');
        return sizeData;
    }
    else {
        return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({ uSize: _mol_util__WEBPACK_IMPORTED_MODULE_1__["ValueCell"].create(value) }, createEmptySizeTexture()), { dSizeType: _mol_util__WEBPACK_IMPORTED_MODULE_1__["ValueCell"].create('uniform') });
    }
}
/** Creates size uniform */
function createUniformSize(locationIt, sizeFn, sizeData) {
    return createValueSize(sizeFn(_mol_model_location__WEBPACK_IMPORTED_MODULE_4__["NullLocation"]), sizeData);
}
function createTextureSize(sizes, type, sizeData) {
    if (sizeData) {
        _mol_util__WEBPACK_IMPORTED_MODULE_1__["ValueCell"].update(sizeData.tSize, sizes);
        _mol_util__WEBPACK_IMPORTED_MODULE_1__["ValueCell"].update(sizeData.uSizeTexDim, _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_2__["Vec2"].create(sizes.width, sizes.height));
        _mol_util__WEBPACK_IMPORTED_MODULE_1__["ValueCell"].updateIfChanged(sizeData.dSizeType, type);
        return sizeData;
    }
    else {
        return {
            uSize: _mol_util__WEBPACK_IMPORTED_MODULE_1__["ValueCell"].create(0),
            tSize: _mol_util__WEBPACK_IMPORTED_MODULE_1__["ValueCell"].create(sizes),
            uSizeTexDim: _mol_util__WEBPACK_IMPORTED_MODULE_1__["ValueCell"].create(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_2__["Vec2"].create(sizes.width, sizes.height)),
            dSizeType: _mol_util__WEBPACK_IMPORTED_MODULE_1__["ValueCell"].create(type),
        };
    }
}
/** Creates size texture with size for each instance/unit */
function createInstanceSize(locationIt, sizeFn, sizeData) {
    var instanceCount = locationIt.instanceCount;
    var sizes = Object(_mol_gl_renderable_util__WEBPACK_IMPORTED_MODULE_3__["createTextureImage"])(Math.max(1, instanceCount), 3, Uint8Array, sizeData && sizeData.tSize.ref.value.array);
    locationIt.reset();
    while (locationIt.hasNext && !locationIt.isNextNewInstance) {
        var v = locationIt.move();
        Object(_mol_util_float_packing__WEBPACK_IMPORTED_MODULE_6__["encodeFloatRGBtoArray"])(sizeFn(v.location) * sizeFactor, sizes.array, v.instanceIndex * 3);
        locationIt.skipInstance();
    }
    return createTextureSize(sizes, 'instance', sizeData);
}
/** Creates size texture with size for each group (i.e. shared across instances/units) */
function createGroupSize(locationIt, sizeFn, sizeData) {
    var groupCount = locationIt.groupCount;
    var sizes = Object(_mol_gl_renderable_util__WEBPACK_IMPORTED_MODULE_3__["createTextureImage"])(Math.max(1, groupCount), 3, Uint8Array, sizeData && sizeData.tSize.ref.value.array);
    locationIt.reset();
    while (locationIt.hasNext && !locationIt.isNextNewInstance) {
        var v = locationIt.move();
        Object(_mol_util_float_packing__WEBPACK_IMPORTED_MODULE_6__["encodeFloatRGBtoArray"])(sizeFn(v.location) * sizeFactor, sizes.array, v.groupIndex * 3);
    }
    return createTextureSize(sizes, 'group', sizeData);
}
/** Creates size texture with size for each group in each instance (i.e. for each unit) */
function createGroupInstanceSize(locationIt, sizeFn, sizeData) {
    var groupCount = locationIt.groupCount, instanceCount = locationIt.instanceCount;
    var count = instanceCount * groupCount;
    var sizes = Object(_mol_gl_renderable_util__WEBPACK_IMPORTED_MODULE_3__["createTextureImage"])(Math.max(1, count), 3, Uint8Array, sizeData && sizeData.tSize.ref.value.array);
    locationIt.reset();
    while (locationIt.hasNext) {
        var v = locationIt.move();
        Object(_mol_util_float_packing__WEBPACK_IMPORTED_MODULE_6__["encodeFloatRGBtoArray"])(sizeFn(v.location) * sizeFactor, sizes.array, v.index * 3);
    }
    return createTextureSize(sizes, 'groupInstance', sizeData);
}
//# sourceMappingURL=size-data.js.map

/***/ }),

/***/ "./lib/mol-geo/geometry/spheres/spheres-builder.js":
/*!*********************************************************!*\
  !*** ./lib/mol-geo/geometry/spheres/spheres-builder.js ***!
  \*********************************************************/
/*! exports provided: SpheresBuilder */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SpheresBuilder", function() { return SpheresBuilder; });
/* harmony import */ var _mol_data_util__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../../mol-data/util */ "./lib/mol-data/util.js");
/* harmony import */ var _spheres__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./spheres */ "./lib/mol-geo/geometry/spheres/spheres.js");
/**
 * Copyright (c) 2019-2020 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */


var quadMapping = new Float32Array([
    -1.0, 1.0,
    -1.0, -1.0,
    1.0, 1.0,
    1.0, -1.0
]);
var quadIndices = new Uint16Array([
    0, 1, 2,
    1, 3, 2
]);
// avoiding namespace lookup improved performance in Chrome (Aug 2020)
var caAdd3 = _mol_data_util__WEBPACK_IMPORTED_MODULE_0__["ChunkedArray"].add3;
var caAdd2 = _mol_data_util__WEBPACK_IMPORTED_MODULE_0__["ChunkedArray"].add2;
var caAdd = _mol_data_util__WEBPACK_IMPORTED_MODULE_0__["ChunkedArray"].add;
var SpheresBuilder;
(function (SpheresBuilder) {
    function create(initialCount, chunkSize, spheres) {
        if (initialCount === void 0) { initialCount = 2048; }
        if (chunkSize === void 0) { chunkSize = 1024; }
        initialCount *= 4;
        chunkSize *= 4;
        var centers = _mol_data_util__WEBPACK_IMPORTED_MODULE_0__["ChunkedArray"].create(Float32Array, 3, chunkSize, spheres ? spheres.centerBuffer.ref.value : initialCount);
        var mappings = _mol_data_util__WEBPACK_IMPORTED_MODULE_0__["ChunkedArray"].create(Float32Array, 2, chunkSize, spheres ? spheres.mappingBuffer.ref.value : initialCount);
        var indices = _mol_data_util__WEBPACK_IMPORTED_MODULE_0__["ChunkedArray"].create(Uint32Array, 3, chunkSize / 2, spheres ? spheres.indexBuffer.ref.value : initialCount / 2);
        var groups = _mol_data_util__WEBPACK_IMPORTED_MODULE_0__["ChunkedArray"].create(Float32Array, 1, chunkSize, spheres ? spheres.groupBuffer.ref.value : initialCount);
        return {
            add: function (x, y, z, group) {
                var offset = centers.elementCount;
                for (var i = 0; i < 4; ++i) {
                    caAdd3(centers, x, y, z);
                    caAdd2(mappings, quadMapping[i * 2], quadMapping[i * 2 + 1]);
                    caAdd(groups, group);
                }
                caAdd3(indices, offset + quadIndices[0], offset + quadIndices[1], offset + quadIndices[2]);
                caAdd3(indices, offset + quadIndices[3], offset + quadIndices[4], offset + quadIndices[5]);
            },
            getSpheres: function () {
                var cb = _mol_data_util__WEBPACK_IMPORTED_MODULE_0__["ChunkedArray"].compact(centers, true);
                var mb = _mol_data_util__WEBPACK_IMPORTED_MODULE_0__["ChunkedArray"].compact(mappings, true);
                var ib = _mol_data_util__WEBPACK_IMPORTED_MODULE_0__["ChunkedArray"].compact(indices, true);
                var gb = _mol_data_util__WEBPACK_IMPORTED_MODULE_0__["ChunkedArray"].compact(groups, true);
                return _spheres__WEBPACK_IMPORTED_MODULE_1__["Spheres"].create(cb, mb, ib, gb, centers.elementCount / 4, spheres);
            }
        };
    }
    SpheresBuilder.create = create;
})(SpheresBuilder || (SpheresBuilder = {}));
//# sourceMappingURL=spheres-builder.js.map

/***/ }),

/***/ "./lib/mol-geo/geometry/spheres/spheres.js":
/*!*************************************************!*\
  !*** ./lib/mol-geo/geometry/spheres/spheres.js ***!
  \*************************************************/
/*! exports provided: Spheres */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Spheres", function() { return Spheres; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _mol_util__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../../mol-util */ "./lib/mol-util/index.js");
/* harmony import */ var _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../../mol-util/param-definition */ "./lib/mol-util/param-definition.js");
/* harmony import */ var _mol_geo_util_location_iterator__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../../mol-geo/util/location-iterator */ "./lib/mol-geo/util/location-iterator.js");
/* harmony import */ var _color_data__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../color-data */ "./lib/mol-geo/geometry/color-data.js");
/* harmony import */ var _marker_data__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../marker-data */ "./lib/mol-geo/geometry/marker-data.js");
/* harmony import */ var _mol_gl_renderable_util__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../../../mol-gl/renderable/util */ "./lib/mol-gl/renderable/util.js");
/* harmony import */ var _mol_math_geometry__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../../../mol-math/geometry */ "./lib/mol-math/geometry.js");
/* harmony import */ var _size_data__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ../size-data */ "./lib/mol-geo/geometry/size-data.js");
/* harmony import */ var _base__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ../base */ "./lib/mol-geo/geometry/base.js");
/* harmony import */ var _overpaint_data__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ../overpaint-data */ "./lib/mol-geo/geometry/overpaint-data.js");
/* harmony import */ var _transparency_data__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ../transparency-data */ "./lib/mol-geo/geometry/transparency-data.js");
/* harmony import */ var _mol_data_util__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! ../../../mol-data/util */ "./lib/mol-data/util.js");
/* harmony import */ var _util__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! ../../util */ "./lib/mol-geo/util.js");
/* harmony import */ var _clipping_data__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! ../clipping-data */ "./lib/mol-geo/geometry/clipping-data.js");
/* harmony import */ var _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! ../../../mol-math/linear-algebra */ "./lib/mol-math/linear-algebra.js");
/**
 * Copyright (c) 2019-2020 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */
















var Spheres;
(function (Spheres) {
    function create(centers, mappings, indices, groups, sphereCount, spheres) {
        return spheres ?
            update(centers, mappings, indices, groups, sphereCount, spheres) :
            fromArrays(centers, mappings, indices, groups, sphereCount);
    }
    Spheres.create = create;
    function createEmpty(spheres) {
        var cb = spheres ? spheres.centerBuffer.ref.value : new Float32Array(0);
        var mb = spheres ? spheres.mappingBuffer.ref.value : new Float32Array(0);
        var ib = spheres ? spheres.indexBuffer.ref.value : new Uint32Array(0);
        var gb = spheres ? spheres.groupBuffer.ref.value : new Float32Array(0);
        return create(cb, mb, ib, gb, 0, spheres);
    }
    Spheres.createEmpty = createEmpty;
    function hashCode(spheres) {
        return Object(_mol_data_util__WEBPACK_IMPORTED_MODULE_12__["hashFnv32a"])([
            spheres.sphereCount,
            spheres.centerBuffer.ref.version, spheres.mappingBuffer.ref.version,
            spheres.indexBuffer.ref.version, spheres.groupBuffer.ref.version
        ]);
    }
    function fromArrays(centers, mappings, indices, groups, sphereCount) {
        var boundingSphere = Object(_mol_math_geometry__WEBPACK_IMPORTED_MODULE_7__["Sphere3D"])();
        var groupMapping;
        var currentHash = -1;
        var currentGroup = -1;
        var spheres = {
            kind: 'spheres',
            sphereCount: sphereCount,
            centerBuffer: _mol_util__WEBPACK_IMPORTED_MODULE_1__["ValueCell"].create(centers),
            mappingBuffer: _mol_util__WEBPACK_IMPORTED_MODULE_1__["ValueCell"].create(mappings),
            indexBuffer: _mol_util__WEBPACK_IMPORTED_MODULE_1__["ValueCell"].create(indices),
            groupBuffer: _mol_util__WEBPACK_IMPORTED_MODULE_1__["ValueCell"].create(groups),
            get boundingSphere() {
                var newHash = hashCode(spheres);
                if (newHash !== currentHash) {
                    var b = Object(_mol_gl_renderable_util__WEBPACK_IMPORTED_MODULE_6__["calculateInvariantBoundingSphere"])(spheres.centerBuffer.ref.value, spheres.sphereCount * 4, 4);
                    _mol_math_geometry__WEBPACK_IMPORTED_MODULE_7__["Sphere3D"].copy(boundingSphere, b);
                    currentHash = newHash;
                }
                return boundingSphere;
            },
            get groupMapping() {
                if (spheres.groupBuffer.ref.version !== currentGroup) {
                    groupMapping = Object(_util__WEBPACK_IMPORTED_MODULE_13__["createGroupMapping"])(spheres.groupBuffer.ref.value, spheres.sphereCount, 4);
                    currentGroup = spheres.groupBuffer.ref.version;
                }
                return groupMapping;
            },
            setBoundingSphere: function (sphere) {
                _mol_math_geometry__WEBPACK_IMPORTED_MODULE_7__["Sphere3D"].copy(boundingSphere, sphere);
                currentHash = hashCode(spheres);
            }
        };
        return spheres;
    }
    function update(centers, mappings, indices, groups, sphereCount, spheres) {
        if (sphereCount > spheres.sphereCount) {
            _mol_util__WEBPACK_IMPORTED_MODULE_1__["ValueCell"].update(spheres.mappingBuffer, mappings);
            _mol_util__WEBPACK_IMPORTED_MODULE_1__["ValueCell"].update(spheres.indexBuffer, indices);
        }
        spheres.sphereCount = sphereCount;
        _mol_util__WEBPACK_IMPORTED_MODULE_1__["ValueCell"].update(spheres.centerBuffer, centers);
        _mol_util__WEBPACK_IMPORTED_MODULE_1__["ValueCell"].update(spheres.groupBuffer, groups);
        return spheres;
    }
    Spheres.Params = Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, _base__WEBPACK_IMPORTED_MODULE_9__["BaseGeometry"].Params), { sizeFactor: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_2__["ParamDefinition"].Numeric(1, { min: 0, max: 10, step: 0.1 }), doubleSided: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_2__["ParamDefinition"].Boolean(false, _base__WEBPACK_IMPORTED_MODULE_9__["BaseGeometry"].CustomQualityParamInfo), ignoreLight: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_2__["ParamDefinition"].Boolean(false, _base__WEBPACK_IMPORTED_MODULE_9__["BaseGeometry"].ShadingCategory), xrayShaded: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_2__["ParamDefinition"].Boolean(false, _base__WEBPACK_IMPORTED_MODULE_9__["BaseGeometry"].ShadingCategory) });
    Spheres.Utils = {
        Params: Spheres.Params,
        createEmpty: createEmpty,
        createValues: createValues,
        createValuesSimple: createValuesSimple,
        updateValues: updateValues,
        updateBoundingSphere: updateBoundingSphere,
        createRenderableState: createRenderableState,
        updateRenderableState: updateRenderableState,
        createPositionIterator: createPositionIterator
    };
    function createPositionIterator(spheres, transform) {
        var groupCount = spheres.sphereCount * 4;
        var instanceCount = transform.instanceCount.ref.value;
        var location = Object(_mol_geo_util_location_iterator__WEBPACK_IMPORTED_MODULE_3__["PositionLocation"])();
        var p = location.position;
        var v = spheres.centerBuffer.ref.value;
        var m = transform.aTransform.ref.value;
        var getLocation = function (groupIndex, instanceIndex) {
            if (instanceIndex < 0) {
                _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_15__["Vec3"].fromArray(p, v, groupIndex * 3);
            }
            else {
                _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_15__["Vec3"].transformMat4Offset(p, v, m, 0, groupIndex * 3, instanceIndex * 16);
            }
            return location;
        };
        return Object(_mol_geo_util_location_iterator__WEBPACK_IMPORTED_MODULE_3__["LocationIterator"])(groupCount, instanceCount, 4, getLocation);
    }
    function createValues(spheres, transform, locationIt, theme, props) {
        var instanceCount = locationIt.instanceCount, groupCount = locationIt.groupCount;
        if (instanceCount !== transform.instanceCount.ref.value) {
            throw new Error('instanceCount values in TransformData and LocationIterator differ');
        }
        var positionIt = createPositionIterator(spheres, transform);
        var color = Object(_color_data__WEBPACK_IMPORTED_MODULE_4__["createColors"])(locationIt, positionIt, theme.color);
        var size = Object(_size_data__WEBPACK_IMPORTED_MODULE_8__["createSizes"])(locationIt, theme.size);
        var marker = Object(_marker_data__WEBPACK_IMPORTED_MODULE_5__["createMarkers"])(instanceCount * groupCount);
        var overpaint = Object(_overpaint_data__WEBPACK_IMPORTED_MODULE_10__["createEmptyOverpaint"])();
        var transparency = Object(_transparency_data__WEBPACK_IMPORTED_MODULE_11__["createEmptyTransparency"])();
        var clipping = Object(_clipping_data__WEBPACK_IMPORTED_MODULE_14__["createEmptyClipping"])();
        var counts = { drawCount: spheres.sphereCount * 2 * 3, vertexCount: spheres.sphereCount * 4, groupCount: groupCount, instanceCount: instanceCount };
        var padding = Object(_size_data__WEBPACK_IMPORTED_MODULE_8__["getMaxSize"])(size) * props.sizeFactor;
        var invariantBoundingSphere = _mol_math_geometry__WEBPACK_IMPORTED_MODULE_7__["Sphere3D"].expand(Object(_mol_math_geometry__WEBPACK_IMPORTED_MODULE_7__["Sphere3D"])(), spheres.boundingSphere, padding);
        var boundingSphere = Object(_mol_gl_renderable_util__WEBPACK_IMPORTED_MODULE_6__["calculateTransformBoundingSphere"])(invariantBoundingSphere, transform.aTransform.ref.value, instanceCount);
        return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({ aPosition: spheres.centerBuffer, aMapping: spheres.mappingBuffer, aGroup: spheres.groupBuffer, elements: spheres.indexBuffer, boundingSphere: _mol_util__WEBPACK_IMPORTED_MODULE_1__["ValueCell"].create(boundingSphere), invariantBoundingSphere: _mol_util__WEBPACK_IMPORTED_MODULE_1__["ValueCell"].create(invariantBoundingSphere), uInvariantBoundingSphere: _mol_util__WEBPACK_IMPORTED_MODULE_1__["ValueCell"].create(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_15__["Vec4"].ofSphere(invariantBoundingSphere)) }, color), size), marker), overpaint), transparency), clipping), transform), { padding: _mol_util__WEBPACK_IMPORTED_MODULE_1__["ValueCell"].create(padding) }), _base__WEBPACK_IMPORTED_MODULE_9__["BaseGeometry"].createValues(props, counts)), { uSizeFactor: _mol_util__WEBPACK_IMPORTED_MODULE_1__["ValueCell"].create(props.sizeFactor), dDoubleSided: _mol_util__WEBPACK_IMPORTED_MODULE_1__["ValueCell"].create(props.doubleSided), dIgnoreLight: _mol_util__WEBPACK_IMPORTED_MODULE_1__["ValueCell"].create(props.ignoreLight), dXrayShaded: _mol_util__WEBPACK_IMPORTED_MODULE_1__["ValueCell"].create(props.xrayShaded) });
    }
    function createValuesSimple(spheres, props, colorValue, sizeValue, transform) {
        var s = _base__WEBPACK_IMPORTED_MODULE_9__["BaseGeometry"].createSimple(colorValue, sizeValue, transform);
        var p = Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_2__["ParamDefinition"].getDefaultValues(Spheres.Params)), props);
        return createValues(spheres, s.transform, s.locationIterator, s.theme, p);
    }
    function updateValues(values, props) {
        _base__WEBPACK_IMPORTED_MODULE_9__["BaseGeometry"].updateValues(values, props);
        _mol_util__WEBPACK_IMPORTED_MODULE_1__["ValueCell"].updateIfChanged(values.uSizeFactor, props.sizeFactor);
        _mol_util__WEBPACK_IMPORTED_MODULE_1__["ValueCell"].updateIfChanged(values.dDoubleSided, props.doubleSided);
        _mol_util__WEBPACK_IMPORTED_MODULE_1__["ValueCell"].updateIfChanged(values.dIgnoreLight, props.ignoreLight);
        _mol_util__WEBPACK_IMPORTED_MODULE_1__["ValueCell"].updateIfChanged(values.dXrayShaded, props.xrayShaded);
    }
    function updateBoundingSphere(values, spheres) {
        var padding = Object(_size_data__WEBPACK_IMPORTED_MODULE_8__["getMaxSize"])(values) * values.uSizeFactor.ref.value;
        var invariantBoundingSphere = _mol_math_geometry__WEBPACK_IMPORTED_MODULE_7__["Sphere3D"].expand(Object(_mol_math_geometry__WEBPACK_IMPORTED_MODULE_7__["Sphere3D"])(), spheres.boundingSphere, padding);
        var boundingSphere = Object(_mol_gl_renderable_util__WEBPACK_IMPORTED_MODULE_6__["calculateTransformBoundingSphere"])(invariantBoundingSphere, values.aTransform.ref.value, values.instanceCount.ref.value);
        if (!_mol_math_geometry__WEBPACK_IMPORTED_MODULE_7__["Sphere3D"].equals(boundingSphere, values.boundingSphere.ref.value)) {
            _mol_util__WEBPACK_IMPORTED_MODULE_1__["ValueCell"].update(values.boundingSphere, boundingSphere);
        }
        if (!_mol_math_geometry__WEBPACK_IMPORTED_MODULE_7__["Sphere3D"].equals(invariantBoundingSphere, values.invariantBoundingSphere.ref.value)) {
            _mol_util__WEBPACK_IMPORTED_MODULE_1__["ValueCell"].update(values.invariantBoundingSphere, invariantBoundingSphere);
            _mol_util__WEBPACK_IMPORTED_MODULE_1__["ValueCell"].update(values.uInvariantBoundingSphere, _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_15__["Vec4"].fromSphere(values.uInvariantBoundingSphere.ref.value, invariantBoundingSphere));
        }
        _mol_util__WEBPACK_IMPORTED_MODULE_1__["ValueCell"].update(values.padding, padding);
    }
    function createRenderableState(props) {
        var state = _base__WEBPACK_IMPORTED_MODULE_9__["BaseGeometry"].createRenderableState(props);
        updateRenderableState(state, props);
        return state;
    }
    function updateRenderableState(state, props) {
        _base__WEBPACK_IMPORTED_MODULE_9__["BaseGeometry"].updateRenderableState(state, props);
        state.opaque = state.opaque && !props.xrayShaded;
        state.writeDepth = state.opaque;
    }
})(Spheres || (Spheres = {}));
//# sourceMappingURL=spheres.js.map

/***/ }),

/***/ "./lib/mol-geo/geometry/text/font-atlas.js":
/*!*************************************************!*\
  !*** ./lib/mol-geo/geometry/text/font-atlas.js ***!
  \*************************************************/
/*! exports provided: getFontAtlas, FontAtlasParams, FontAtlas */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getFontAtlas", function() { return getFontAtlas; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FontAtlasParams", function() { return FontAtlasParams; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FontAtlas", function() { return FontAtlas; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../../mol-util/param-definition */ "./lib/mol-util/param-definition.js");
/* harmony import */ var _mol_math_geometry_distance_transform__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../../mol-math/geometry/distance-transform */ "./lib/mol-math/geometry/distance-transform.js");
/* harmony import */ var _mol_gl_renderable_util__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../../mol-gl/renderable/util */ "./lib/mol-gl/renderable/util.js");
/**
 * Copyright (c) 2019 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */




var TextAtlasCache = {};
function getFontAtlas(props) {
    var hash = JSON.stringify(props);
    if (TextAtlasCache[hash] === undefined) {
        TextAtlasCache[hash] = new FontAtlas(props);
    }
    return TextAtlasCache[hash];
}
var FontAtlasParams = {
    fontFamily: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_1__["ParamDefinition"].Select('sans-serif', [['sans-serif', 'Sans Serif'], ['monospace', 'Monospace'], ['serif', 'Serif'], ['cursive', 'Cursive']]),
    fontQuality: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_1__["ParamDefinition"].Select(3, [[0, 'lower'], [1, 'low'], [2, 'medium'], [3, 'high'], [4, 'higher']]),
    fontStyle: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_1__["ParamDefinition"].Select('normal', [['normal', 'Normal'], ['italic', 'Italic'], ['oblique', 'Oblique']]),
    fontVariant: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_1__["ParamDefinition"].Select('normal', [['normal', 'Normal'], ['small-caps', 'Small Caps']]),
    fontWeight: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_1__["ParamDefinition"].Select('normal', [['normal', 'Normal'], ['bold', 'Bold']]),
};
var FontAtlas = /** @class */ (function () {
    function FontAtlas(props) {
        if (props === void 0) { props = {}; }
        this.mapped = {};
        this.scratchW = 0;
        this.scratchH = 0;
        this.currentX = 0;
        this.currentY = 0;
        this.cutoff = 0.5;
        var p = Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_1__["ParamDefinition"].getDefaultValues(FontAtlasParams)), props);
        this.props = p;
        // create measurements
        var fontSize = 32 * (p.fontQuality + 1);
        this.buffer = fontSize / 8;
        this.radius = fontSize / 3;
        this.lineHeight = Math.round(fontSize + 2 * this.buffer + this.radius);
        this.maxWidth = Math.round(this.lineHeight * 0.75);
        // create texture (for ~350 characters)
        this.texture = Object(_mol_gl_renderable_util__WEBPACK_IMPORTED_MODULE_3__["createTextureImage"])(350 * this.lineHeight * this.maxWidth, 1, Uint8Array);
        // prepare scratch canvas
        this.scratchCanvas = document.createElement('canvas');
        this.scratchCanvas.width = this.maxWidth;
        this.scratchCanvas.height = this.lineHeight;
        this.scratchContext = this.scratchCanvas.getContext('2d');
        this.scratchContext.font = p.fontStyle + " " + p.fontVariant + " " + p.fontWeight + " " + fontSize + "px " + p.fontFamily;
        this.scratchContext.fillStyle = 'black';
        this.scratchContext.textBaseline = 'middle';
        // SDF scratch values
        this.scratchData = new Uint8Array(this.lineHeight * this.maxWidth);
        // temporary arrays for the distance transform
        this.gridOuter = new Float64Array(this.lineHeight * this.maxWidth);
        this.gridInner = new Float64Array(this.lineHeight * this.maxWidth);
        this.f = new Float64Array(Math.max(this.lineHeight, this.maxWidth));
        this.d = new Float64Array(Math.max(this.lineHeight, this.maxWidth));
        this.z = new Float64Array(Math.max(this.lineHeight, this.maxWidth) + 1);
        this.v = new Int16Array(Math.max(this.lineHeight, this.maxWidth));
        this.middle = Math.ceil(this.lineHeight / 2);
        // replacement Character
        this.placeholder = this.get(String.fromCharCode(0xFFFD));
    }
    FontAtlas.prototype.get = function (char) {
        if (this.mapped[char] === undefined) {
            this.draw(char);
            var _a = this.texture, array = _a.array, width = _a.width, height = _a.height;
            var data = this.scratchData;
            if (this.currentX + this.scratchW > width) {
                this.currentX = 0;
                this.currentY += this.scratchH;
            }
            if (this.currentY + this.scratchH > height) {
                console.warn('canvas to small');
                return this.placeholder;
            }
            this.mapped[char] = {
                x: this.currentX, y: this.currentY,
                w: this.scratchW, h: this.scratchH,
                nw: this.scratchW / this.lineHeight, nh: this.scratchH / this.lineHeight
            };
            for (var y = 0; y < this.scratchH; ++y) {
                for (var x = 0; x < this.scratchW; ++x) {
                    array[width * (this.currentY + y) + this.currentX + x] = data[y * this.scratchW + x];
                }
            }
            this.currentX += this.scratchW;
        }
        return this.mapped[char];
    };
    FontAtlas.prototype.draw = function (char) {
        var h = this.lineHeight;
        var ctx = this.scratchContext;
        var data = this.scratchData;
        // measure text
        var m = ctx.measureText(char);
        var w = Math.min(this.maxWidth, Math.ceil(m.width + 2 * this.buffer));
        var n = w * h;
        ctx.clearRect(0, 0, w, h); // clear scratch area
        ctx.fillText(char, this.buffer, this.middle); // draw text
        var imageData = ctx.getImageData(0, 0, w, h);
        for (var i = 0; i < n; i++) {
            var a = imageData.data[i * 4 + 3] / 255; // alpha value
            this.gridOuter[i] = a === 1 ? 0 : a === 0 ? Number.MAX_SAFE_INTEGER : Math.pow(Math.max(0, 0.5 - a), 2);
            this.gridInner[i] = a === 1 ? Number.MAX_SAFE_INTEGER : a === 0 ? 0 : Math.pow(Math.max(0, a - 0.5), 2);
        }
        Object(_mol_math_geometry_distance_transform__WEBPACK_IMPORTED_MODULE_2__["edt"])(this.gridOuter, w, h, this.f, this.d, this.v, this.z);
        Object(_mol_math_geometry_distance_transform__WEBPACK_IMPORTED_MODULE_2__["edt"])(this.gridInner, w, h, this.f, this.d, this.v, this.z);
        for (var i = 0; i < n; i++) {
            var d = this.gridOuter[i] - this.gridInner[i];
            data[i] = Math.max(0, Math.min(255, Math.round(255 - 255 * (d / this.radius + this.cutoff))));
        }
        this.scratchW = w;
        this.scratchH = h;
    };
    return FontAtlas;
}());

//# sourceMappingURL=font-atlas.js.map

/***/ }),

/***/ "./lib/mol-geo/geometry/text/text-builder.js":
/*!***************************************************!*\
  !*** ./lib/mol-geo/geometry/text/text-builder.js ***!
  \***************************************************/
/*! exports provided: TextBuilder */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "TextBuilder", function() { return TextBuilder; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../../mol-util/param-definition */ "./lib/mol-util/param-definition.js");
/* harmony import */ var _mol_data_util__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../../mol-data/util */ "./lib/mol-data/util.js");
/* harmony import */ var _text__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./text */ "./lib/mol-geo/geometry/text/text.js");
/* harmony import */ var _font_atlas__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./font-atlas */ "./lib/mol-geo/geometry/text/font-atlas.js");
/**
 * Copyright (c) 2019-2020 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */





var quadIndices = new Uint16Array([
    0, 1, 2,
    1, 3, 2
]);
// avoiding namespace lookup improved performance in Chrome (Aug 2020)
var caAdd3 = _mol_data_util__WEBPACK_IMPORTED_MODULE_2__["ChunkedArray"].add3;
var caAdd2 = _mol_data_util__WEBPACK_IMPORTED_MODULE_2__["ChunkedArray"].add2;
var caAdd = _mol_data_util__WEBPACK_IMPORTED_MODULE_2__["ChunkedArray"].add;
var TextBuilder;
(function (TextBuilder) {
    function create(props, initialCount, chunkSize, text) {
        if (props === void 0) { props = {}; }
        if (initialCount === void 0) { initialCount = 2048; }
        if (chunkSize === void 0) { chunkSize = 1024; }
        initialCount *= 2;
        chunkSize *= 2;
        var centers = _mol_data_util__WEBPACK_IMPORTED_MODULE_2__["ChunkedArray"].create(Float32Array, 3, chunkSize, text ? text.centerBuffer.ref.value : initialCount);
        var mappings = _mol_data_util__WEBPACK_IMPORTED_MODULE_2__["ChunkedArray"].create(Float32Array, 2, chunkSize, text ? text.mappingBuffer.ref.value : initialCount);
        var depths = _mol_data_util__WEBPACK_IMPORTED_MODULE_2__["ChunkedArray"].create(Float32Array, 1, chunkSize, text ? text.depthBuffer.ref.value : initialCount);
        var indices = _mol_data_util__WEBPACK_IMPORTED_MODULE_2__["ChunkedArray"].create(Uint32Array, 3, chunkSize, text ? text.indexBuffer.ref.value : initialCount);
        var groups = _mol_data_util__WEBPACK_IMPORTED_MODULE_2__["ChunkedArray"].create(Float32Array, 1, chunkSize, text ? text.groupBuffer.ref.value : initialCount);
        var tcoords = _mol_data_util__WEBPACK_IMPORTED_MODULE_2__["ChunkedArray"].create(Float32Array, 2, chunkSize, text ? text.tcoordBuffer.ref.value : initialCount);
        var p = Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_1__["ParamDefinition"].getDefaultValues(_text__WEBPACK_IMPORTED_MODULE_3__["Text"].Params)), props);
        var attachment = p.attachment, background = p.background, backgroundMargin = p.backgroundMargin, tether = p.tether, tetherLength = p.tetherLength, tetherBaseWidth = p.tetherBaseWidth;
        var fontAtlas = Object(_font_atlas__WEBPACK_IMPORTED_MODULE_4__["getFontAtlas"])(p);
        var margin = (1 / 2.5) * backgroundMargin;
        var outline = fontAtlas.buffer / fontAtlas.lineHeight;
        var add = function (x, y, z, depth, group) {
            caAdd3(centers, x, y, z);
            caAdd(depths, depth);
            caAdd(groups, group);
        };
        return {
            add: function (str, x, y, z, depth, scale, group) {
                var bWidth = 0;
                var nChar = str.length;
                // calculate width
                for (var iChar = 0; iChar < nChar; ++iChar) {
                    var c = fontAtlas.get(str[iChar]);
                    bWidth += c.nw - 2 * outline;
                }
                var bHeight = 1 / 1.25;
                // attachment
                var yShift, xShift;
                // vertical
                if (attachment.startsWith('top')) {
                    yShift = bHeight;
                }
                else if (attachment.startsWith('middle')) {
                    yShift = bHeight / 2;
                }
                else {
                    yShift = 0; // "bottom"
                }
                // horizontal
                if (attachment.endsWith('right')) {
                    xShift = bWidth;
                }
                else if (attachment.endsWith('center')) {
                    xShift = bWidth / 2;
                }
                else {
                    xShift = 0; // "left"
                }
                if (tether) {
                    switch (attachment) {
                        case 'bottom-left':
                            xShift -= tetherLength / 2 + margin + 0.1;
                            yShift -= tetherLength / 2 + margin;
                            break;
                        case 'bottom-center':
                            yShift -= tetherLength + margin;
                            break;
                        case 'bottom-right':
                            xShift += tetherLength / 2 + margin + 0.1;
                            yShift -= tetherLength / 2 + margin;
                            break;
                        case 'middle-left':
                            xShift -= tetherLength + margin + 0.1;
                            break;
                        case 'middle-center':
                            break;
                        case 'middle-right':
                            xShift += tetherLength + margin + 0.1;
                            break;
                        case 'top-left':
                            xShift -= tetherLength / 2 + margin + 0.1;
                            yShift += tetherLength / 2 + margin;
                            break;
                        case 'top-center':
                            yShift += tetherLength + margin;
                            break;
                        case 'top-right':
                            xShift += tetherLength / 2 + margin + 0.1;
                            yShift += tetherLength / 2 + margin;
                            break;
                    }
                }
                var xLeft = (-xShift - margin - 0.1) * scale;
                var xRight = (bWidth - xShift + margin + 0.1) * scale;
                var yTop = (bHeight - yShift + margin) * scale;
                var yBottom = (-yShift - margin) * scale;
                // background
                if (background) {
                    caAdd2(mappings, xLeft, yTop); // top left
                    caAdd2(mappings, xLeft, yBottom); // bottom left
                    caAdd2(mappings, xRight, yTop); // top right
                    caAdd2(mappings, xRight, yBottom); // bottom right
                    var offset = centers.elementCount;
                    for (var i = 0; i < 4; ++i) {
                        caAdd2(tcoords, 10, 10);
                        add(x, y, z, depth, group);
                    }
                    caAdd3(indices, offset + quadIndices[0], offset + quadIndices[1], offset + quadIndices[2]);
                    caAdd3(indices, offset + quadIndices[3], offset + quadIndices[4], offset + quadIndices[5]);
                }
                if (tether) {
                    var xTip = void 0, yTip = void 0;
                    var xBaseA = void 0, yBaseA = void 0;
                    var xBaseB = void 0, yBaseB = void 0;
                    var xBaseCenter = void 0, yBaseCenter = void 0;
                    var scaledTetherLength = tetherLength * scale;
                    var scaledTetherBaseWidth = tetherBaseWidth * scale;
                    switch (attachment) {
                        case 'bottom-left':
                            xTip = xLeft - scaledTetherLength / 2;
                            xBaseA = xLeft + scaledTetherBaseWidth / 2;
                            xBaseB = xLeft;
                            xBaseCenter = xLeft;
                            yTip = yBottom - scaledTetherLength / 2;
                            yBaseA = yBottom;
                            yBaseB = yBottom + scaledTetherBaseWidth / 2;
                            yBaseCenter = yBottom;
                            break;
                        case 'bottom-center':
                            xTip = 0;
                            xBaseA = scaledTetherBaseWidth / 2;
                            xBaseB = -scaledTetherBaseWidth / 2;
                            xBaseCenter = 0;
                            yTip = yBottom - scaledTetherLength;
                            yBaseA = yBottom;
                            yBaseB = yBottom;
                            yBaseCenter = yBottom;
                            break;
                        case 'bottom-right':
                            xTip = xRight + scaledTetherLength / 2;
                            xBaseA = xRight;
                            xBaseB = xRight - scaledTetherBaseWidth / 2;
                            xBaseCenter = xRight;
                            yTip = yBottom - scaledTetherLength / 2;
                            yBaseA = yBottom + scaledTetherBaseWidth / 2;
                            yBaseB = yBottom;
                            yBaseCenter = yBottom;
                            break;
                        case 'middle-left':
                            xTip = xLeft - scaledTetherLength;
                            xBaseA = xLeft;
                            xBaseB = xLeft;
                            xBaseCenter = xLeft;
                            yTip = 0;
                            yBaseA = -scaledTetherBaseWidth / 2;
                            yBaseB = scaledTetherBaseWidth / 2;
                            yBaseCenter = 0;
                            break;
                        case 'middle-center':
                            xTip = 0;
                            xBaseA = 0;
                            xBaseB = 0;
                            xBaseCenter = 0;
                            yTip = 0;
                            yBaseA = 0;
                            yBaseB = 0;
                            yBaseCenter = 0;
                            break;
                        case 'middle-right':
                            xTip = xRight + scaledTetherLength;
                            xBaseA = xRight;
                            xBaseB = xRight;
                            xBaseCenter = xRight;
                            yTip = 0;
                            yBaseA = scaledTetherBaseWidth / 2;
                            yBaseB = -scaledTetherBaseWidth / 2;
                            yBaseCenter = 0;
                            break;
                        case 'top-left':
                            xTip = xLeft - scaledTetherLength / 2;
                            xBaseA = xLeft + scaledTetherBaseWidth / 2;
                            xBaseB = xLeft;
                            xBaseCenter = xLeft;
                            yTip = yTop + scaledTetherLength / 2;
                            yBaseA = yTop;
                            yBaseB = yTop - scaledTetherBaseWidth / 2;
                            yBaseCenter = yTop;
                            break;
                        case 'top-center':
                            xTip = 0;
                            xBaseA = scaledTetherBaseWidth / 2;
                            xBaseB = -scaledTetherBaseWidth / 2;
                            xBaseCenter = 0;
                            yTip = yTop + scaledTetherLength;
                            yBaseA = yTop;
                            yBaseB = yTop;
                            yBaseCenter = yTop;
                            break;
                        case 'top-right':
                            xTip = xRight + scaledTetherLength / 2;
                            xBaseA = xRight;
                            xBaseB = xRight - scaledTetherBaseWidth / 2;
                            xBaseCenter = xRight;
                            yTip = yTop + scaledTetherLength / 2;
                            yBaseA = yTop - scaledTetherBaseWidth / 2;
                            yBaseB = yTop;
                            yBaseCenter = yTop;
                            break;
                        default:
                            throw new Error('unsupported attachment');
                    }
                    caAdd2(mappings, xTip, yTip); // tip
                    caAdd2(mappings, xBaseA, yBaseA); // base A
                    caAdd2(mappings, xBaseB, yBaseB); // base B
                    caAdd2(mappings, xBaseCenter, yBaseCenter); // base center
                    var offset = centers.elementCount;
                    for (var i = 0; i < 4; ++i) {
                        caAdd2(tcoords, 10, 10);
                        add(x, y, z, depth, group);
                    }
                    caAdd3(indices, offset, offset + 1, offset + 3);
                    caAdd3(indices, offset, offset + 3, offset + 2);
                }
                xShift += outline;
                yShift += outline;
                var xadvance = 0;
                for (var iChar = 0; iChar < nChar; ++iChar) {
                    var c = fontAtlas.get(str[iChar]);
                    var left = (xadvance - xShift) * scale;
                    var right = (xadvance + c.nw - xShift) * scale;
                    var top_1 = (c.nh - yShift) * scale;
                    var bottom = (-yShift) * scale;
                    caAdd2(mappings, left, top_1);
                    caAdd2(mappings, left, bottom);
                    caAdd2(mappings, right, top_1);
                    caAdd2(mappings, right, bottom);
                    var texWidth = fontAtlas.texture.width;
                    var texHeight = fontAtlas.texture.height;
                    caAdd2(tcoords, c.x / texWidth, c.y / texHeight); // top left
                    caAdd2(tcoords, c.x / texWidth, (c.y + c.h) / texHeight); // bottom left
                    caAdd2(tcoords, (c.x + c.w) / texWidth, c.y / texHeight); // top right
                    caAdd2(tcoords, (c.x + c.w) / texWidth, (c.y + c.h) / texHeight); // bottom right
                    xadvance += c.nw - 2 * outline;
                    var offset = centers.elementCount;
                    for (var i = 0; i < 4; ++i)
                        add(x, y, z, depth, group);
                    caAdd3(indices, offset + quadIndices[0], offset + quadIndices[1], offset + quadIndices[2]);
                    caAdd3(indices, offset + quadIndices[3], offset + quadIndices[4], offset + quadIndices[5]);
                }
            },
            getText: function () {
                var ft = fontAtlas.texture;
                var cb = _mol_data_util__WEBPACK_IMPORTED_MODULE_2__["ChunkedArray"].compact(centers, true);
                var mb = _mol_data_util__WEBPACK_IMPORTED_MODULE_2__["ChunkedArray"].compact(mappings, true);
                var db = _mol_data_util__WEBPACK_IMPORTED_MODULE_2__["ChunkedArray"].compact(depths, true);
                var ib = _mol_data_util__WEBPACK_IMPORTED_MODULE_2__["ChunkedArray"].compact(indices, true);
                var gb = _mol_data_util__WEBPACK_IMPORTED_MODULE_2__["ChunkedArray"].compact(groups, true);
                var tb = _mol_data_util__WEBPACK_IMPORTED_MODULE_2__["ChunkedArray"].compact(tcoords, true);
                return _text__WEBPACK_IMPORTED_MODULE_3__["Text"].create(ft, cb, mb, db, ib, gb, tb, indices.elementCount / 2, text);
            }
        };
    }
    TextBuilder.create = create;
})(TextBuilder || (TextBuilder = {}));
//# sourceMappingURL=text-builder.js.map

/***/ }),

/***/ "./lib/mol-geo/geometry/text/text.js":
/*!*******************************************!*\
  !*** ./lib/mol-geo/geometry/text/text.js ***!
  \*******************************************/
/*! exports provided: Text */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Text", function() { return Text; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../../mol-util/param-definition */ "./lib/mol-util/param-definition.js");
/* harmony import */ var _mol_util__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../../mol-util */ "./lib/mol-util/index.js");
/* harmony import */ var _mol_geo_util_location_iterator__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../../mol-geo/util/location-iterator */ "./lib/mol-geo/util/location-iterator.js");
/* harmony import */ var _color_data__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../color-data */ "./lib/mol-geo/geometry/color-data.js");
/* harmony import */ var _size_data__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../size-data */ "./lib/mol-geo/geometry/size-data.js");
/* harmony import */ var _marker_data__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../marker-data */ "./lib/mol-geo/geometry/marker-data.js");
/* harmony import */ var _mol_util_color_names__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../../../mol-util/color/names */ "./lib/mol-util/color/names.js");
/* harmony import */ var _mol_math_geometry__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ../../../mol-math/geometry */ "./lib/mol-math/geometry.js");
/* harmony import */ var _mol_gl_renderable_util__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ../../../mol-gl/renderable/util */ "./lib/mol-gl/renderable/util.js");
/* harmony import */ var _mol_util_color__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ../../../mol-util/color */ "./lib/mol-util/color/index.js");
/* harmony import */ var _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ../../../mol-math/linear-algebra */ "./lib/mol-math/linear-algebra.js");
/* harmony import */ var _font_atlas__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! ./font-atlas */ "./lib/mol-geo/geometry/text/font-atlas.js");
/* harmony import */ var _mol_math_interpolate__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! ../../../mol-math/interpolate */ "./lib/mol-math/interpolate.js");
/* harmony import */ var _base__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! ../base */ "./lib/mol-geo/geometry/base.js");
/* harmony import */ var _overpaint_data__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! ../overpaint-data */ "./lib/mol-geo/geometry/overpaint-data.js");
/* harmony import */ var _transparency_data__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(/*! ../transparency-data */ "./lib/mol-geo/geometry/transparency-data.js");
/* harmony import */ var _mol_data_util__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(/*! ../../../mol-data/util */ "./lib/mol-data/util.js");
/* harmony import */ var _util__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(/*! ../../util */ "./lib/mol-geo/util.js");
/* harmony import */ var _clipping_data__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(/*! ../clipping-data */ "./lib/mol-geo/geometry/clipping-data.js");
/**
 * Copyright (c) 2019-2020 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */




















var Text;
(function (Text) {
    function create(fontTexture, centers, mappings, depths, indices, groups, tcoords, charCount, text) {
        return text ?
            update(fontTexture, centers, mappings, depths, indices, groups, tcoords, charCount, text) :
            fromData(fontTexture, centers, mappings, depths, indices, groups, tcoords, charCount);
    }
    Text.create = create;
    function createEmpty(text) {
        var ft = text ? text.fontTexture.ref.value : Object(_mol_gl_renderable_util__WEBPACK_IMPORTED_MODULE_9__["createTextureImage"])(0, 1, Uint8Array);
        var cb = text ? text.centerBuffer.ref.value : new Float32Array(0);
        var mb = text ? text.mappingBuffer.ref.value : new Float32Array(0);
        var db = text ? text.depthBuffer.ref.value : new Float32Array(0);
        var ib = text ? text.indexBuffer.ref.value : new Uint32Array(0);
        var gb = text ? text.groupBuffer.ref.value : new Float32Array(0);
        var tb = text ? text.tcoordBuffer.ref.value : new Float32Array(0);
        return create(ft, cb, mb, db, ib, gb, tb, 0, text);
    }
    Text.createEmpty = createEmpty;
    function hashCode(text) {
        return Object(_mol_data_util__WEBPACK_IMPORTED_MODULE_17__["hashFnv32a"])([
            text.charCount, text.fontTexture.ref.version,
            text.centerBuffer.ref.version, text.mappingBuffer.ref.version,
            text.depthBuffer.ref.version, text.indexBuffer.ref.version,
            text.groupBuffer.ref.version, text.tcoordBuffer.ref.version
        ]);
    }
    function fromData(fontTexture, centers, mappings, depths, indices, groups, tcoords, charCount) {
        var boundingSphere = Object(_mol_math_geometry__WEBPACK_IMPORTED_MODULE_8__["Sphere3D"])();
        var groupMapping;
        var currentHash = -1;
        var currentGroup = -1;
        var text = {
            kind: 'text',
            charCount: charCount,
            fontTexture: _mol_util__WEBPACK_IMPORTED_MODULE_2__["ValueCell"].create(fontTexture),
            centerBuffer: _mol_util__WEBPACK_IMPORTED_MODULE_2__["ValueCell"].create(centers),
            mappingBuffer: _mol_util__WEBPACK_IMPORTED_MODULE_2__["ValueCell"].create(mappings),
            depthBuffer: _mol_util__WEBPACK_IMPORTED_MODULE_2__["ValueCell"].create(depths),
            indexBuffer: _mol_util__WEBPACK_IMPORTED_MODULE_2__["ValueCell"].create(indices),
            groupBuffer: _mol_util__WEBPACK_IMPORTED_MODULE_2__["ValueCell"].create(groups),
            tcoordBuffer: _mol_util__WEBPACK_IMPORTED_MODULE_2__["ValueCell"].create(tcoords),
            get boundingSphere() {
                var newHash = hashCode(text);
                if (newHash !== currentHash) {
                    var b = Object(_mol_gl_renderable_util__WEBPACK_IMPORTED_MODULE_9__["calculateInvariantBoundingSphere"])(text.centerBuffer.ref.value, text.charCount * 4, 4);
                    _mol_math_geometry__WEBPACK_IMPORTED_MODULE_8__["Sphere3D"].copy(boundingSphere, b);
                    currentHash = newHash;
                }
                return boundingSphere;
            },
            get groupMapping() {
                if (text.groupBuffer.ref.version !== currentGroup) {
                    groupMapping = Object(_util__WEBPACK_IMPORTED_MODULE_18__["createGroupMapping"])(text.groupBuffer.ref.value, text.charCount, 4);
                    currentGroup = text.groupBuffer.ref.version;
                }
                return groupMapping;
            },
            setBoundingSphere: function (sphere) {
                _mol_math_geometry__WEBPACK_IMPORTED_MODULE_8__["Sphere3D"].copy(boundingSphere, sphere);
                currentHash = hashCode(text);
            }
        };
        return text;
    }
    function update(fontTexture, centers, mappings, depths, indices, groups, tcoords, charCount, text) {
        text.charCount = charCount;
        _mol_util__WEBPACK_IMPORTED_MODULE_2__["ValueCell"].update(text.fontTexture, fontTexture);
        _mol_util__WEBPACK_IMPORTED_MODULE_2__["ValueCell"].update(text.centerBuffer, centers);
        _mol_util__WEBPACK_IMPORTED_MODULE_2__["ValueCell"].update(text.mappingBuffer, mappings);
        _mol_util__WEBPACK_IMPORTED_MODULE_2__["ValueCell"].update(text.depthBuffer, depths);
        _mol_util__WEBPACK_IMPORTED_MODULE_2__["ValueCell"].update(text.indexBuffer, indices);
        _mol_util__WEBPACK_IMPORTED_MODULE_2__["ValueCell"].update(text.groupBuffer, groups);
        _mol_util__WEBPACK_IMPORTED_MODULE_2__["ValueCell"].update(text.tcoordBuffer, tcoords);
        return text;
    }
    Text.Params = Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, _base__WEBPACK_IMPORTED_MODULE_14__["BaseGeometry"].Params), _font_atlas__WEBPACK_IMPORTED_MODULE_12__["FontAtlasParams"]), { sizeFactor: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_1__["ParamDefinition"].Numeric(1, { min: 0, max: 10, step: 0.1 }), borderWidth: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_1__["ParamDefinition"].Numeric(0, { min: 0, max: 0.5, step: 0.01 }), borderColor: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_1__["ParamDefinition"].Color(_mol_util_color_names__WEBPACK_IMPORTED_MODULE_7__["ColorNames"].grey), offsetX: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_1__["ParamDefinition"].Numeric(0, { min: 0, max: 10, step: 0.1 }), offsetY: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_1__["ParamDefinition"].Numeric(0, { min: 0, max: 10, step: 0.1 }), offsetZ: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_1__["ParamDefinition"].Numeric(0, { min: 0, max: 10, step: 0.1 }), background: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_1__["ParamDefinition"].Boolean(false), backgroundMargin: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_1__["ParamDefinition"].Numeric(0.2, { min: 0, max: 1, step: 0.01 }), backgroundColor: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_1__["ParamDefinition"].Color(_mol_util_color_names__WEBPACK_IMPORTED_MODULE_7__["ColorNames"].grey), backgroundOpacity: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_1__["ParamDefinition"].Numeric(1, { min: 0, max: 1, step: 0.01 }), tether: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_1__["ParamDefinition"].Boolean(false), tetherLength: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_1__["ParamDefinition"].Numeric(1, { min: 0, max: 5, step: 0.1 }), tetherBaseWidth: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_1__["ParamDefinition"].Numeric(0.3, { min: 0, max: 1, step: 0.01 }), attachment: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_1__["ParamDefinition"].Select('middle-center', [
            ['bottom-left', 'bottom-left'], ['bottom-center', 'bottom-center'], ['bottom-right', 'bottom-right'],
            ['middle-left', 'middle-left'], ['middle-center', 'middle-center'], ['middle-right', 'middle-right'],
            ['top-left', 'top-left'], ['top-center', 'top-center'], ['top-right', 'top-right'],
        ]) });
    Text.Utils = {
        Params: Text.Params,
        createEmpty: createEmpty,
        createValues: createValues,
        createValuesSimple: createValuesSimple,
        updateValues: updateValues,
        updateBoundingSphere: updateBoundingSphere,
        createRenderableState: createRenderableState,
        updateRenderableState: updateRenderableState,
        createPositionIterator: createPositionIterator
    };
    function createPositionIterator(text, transform) {
        var groupCount = text.charCount * 4;
        var instanceCount = transform.instanceCount.ref.value;
        var location = Object(_mol_geo_util_location_iterator__WEBPACK_IMPORTED_MODULE_3__["PositionLocation"])();
        var p = location.position;
        var v = text.centerBuffer.ref.value;
        var m = transform.aTransform.ref.value;
        var getLocation = function (groupIndex, instanceIndex) {
            if (instanceIndex < 0) {
                _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_11__["Vec3"].fromArray(p, v, groupIndex * 3);
            }
            else {
                _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_11__["Vec3"].transformMat4Offset(p, v, m, 0, groupIndex * 3, instanceIndex * 16);
            }
            return location;
        };
        return Object(_mol_geo_util_location_iterator__WEBPACK_IMPORTED_MODULE_3__["LocationIterator"])(groupCount, instanceCount, 4, getLocation);
    }
    function createValues(text, transform, locationIt, theme, props) {
        var instanceCount = locationIt.instanceCount, groupCount = locationIt.groupCount;
        if (instanceCount !== transform.instanceCount.ref.value) {
            throw new Error('instanceCount values in TransformData and LocationIterator differ');
        }
        var positionIt = createPositionIterator(text, transform);
        var color = Object(_color_data__WEBPACK_IMPORTED_MODULE_4__["createColors"])(locationIt, positionIt, theme.color);
        var size = Object(_size_data__WEBPACK_IMPORTED_MODULE_5__["createSizes"])(locationIt, theme.size);
        var marker = Object(_marker_data__WEBPACK_IMPORTED_MODULE_6__["createMarkers"])(instanceCount * groupCount);
        var overpaint = Object(_overpaint_data__WEBPACK_IMPORTED_MODULE_15__["createEmptyOverpaint"])();
        var transparency = Object(_transparency_data__WEBPACK_IMPORTED_MODULE_16__["createEmptyTransparency"])();
        var clipping = Object(_clipping_data__WEBPACK_IMPORTED_MODULE_19__["createEmptyClipping"])();
        var counts = { drawCount: text.charCount * 2 * 3, vertexCount: text.charCount * 4, groupCount: groupCount, instanceCount: instanceCount };
        var padding = getPadding(text.mappingBuffer.ref.value, text.depthBuffer.ref.value, text.charCount, Object(_size_data__WEBPACK_IMPORTED_MODULE_5__["getMaxSize"])(size));
        var invariantBoundingSphere = _mol_math_geometry__WEBPACK_IMPORTED_MODULE_8__["Sphere3D"].expand(Object(_mol_math_geometry__WEBPACK_IMPORTED_MODULE_8__["Sphere3D"])(), text.boundingSphere, padding);
        var boundingSphere = Object(_mol_gl_renderable_util__WEBPACK_IMPORTED_MODULE_9__["calculateTransformBoundingSphere"])(invariantBoundingSphere, transform.aTransform.ref.value, instanceCount);
        return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({ aPosition: text.centerBuffer, aMapping: text.mappingBuffer, aDepth: text.depthBuffer, aGroup: text.groupBuffer, elements: text.indexBuffer, boundingSphere: _mol_util__WEBPACK_IMPORTED_MODULE_2__["ValueCell"].create(boundingSphere), invariantBoundingSphere: _mol_util__WEBPACK_IMPORTED_MODULE_2__["ValueCell"].create(invariantBoundingSphere), uInvariantBoundingSphere: _mol_util__WEBPACK_IMPORTED_MODULE_2__["ValueCell"].create(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_11__["Vec4"].ofSphere(invariantBoundingSphere)) }, color), size), marker), overpaint), transparency), clipping), transform), { aTexCoord: text.tcoordBuffer, tFont: text.fontTexture, padding: _mol_util__WEBPACK_IMPORTED_MODULE_2__["ValueCell"].create(padding) }), _base__WEBPACK_IMPORTED_MODULE_14__["BaseGeometry"].createValues(props, counts)), { uSizeFactor: _mol_util__WEBPACK_IMPORTED_MODULE_2__["ValueCell"].create(props.sizeFactor), uBorderWidth: _mol_util__WEBPACK_IMPORTED_MODULE_2__["ValueCell"].create(Object(_mol_math_interpolate__WEBPACK_IMPORTED_MODULE_13__["clamp"])(props.borderWidth / 2, 0, 0.5)), uBorderColor: _mol_util__WEBPACK_IMPORTED_MODULE_2__["ValueCell"].create(_mol_util_color__WEBPACK_IMPORTED_MODULE_10__["Color"].toArrayNormalized(props.borderColor, _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_11__["Vec3"].zero(), 0)), uOffsetX: _mol_util__WEBPACK_IMPORTED_MODULE_2__["ValueCell"].create(props.offsetX), uOffsetY: _mol_util__WEBPACK_IMPORTED_MODULE_2__["ValueCell"].create(props.offsetY), uOffsetZ: _mol_util__WEBPACK_IMPORTED_MODULE_2__["ValueCell"].create(props.offsetZ), uBackgroundColor: _mol_util__WEBPACK_IMPORTED_MODULE_2__["ValueCell"].create(_mol_util_color__WEBPACK_IMPORTED_MODULE_10__["Color"].toArrayNormalized(props.backgroundColor, _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_11__["Vec3"].zero(), 0)), uBackgroundOpacity: _mol_util__WEBPACK_IMPORTED_MODULE_2__["ValueCell"].create(props.backgroundOpacity) });
    }
    function createValuesSimple(text, props, colorValue, sizeValue, transform) {
        var s = _base__WEBPACK_IMPORTED_MODULE_14__["BaseGeometry"].createSimple(colorValue, sizeValue, transform);
        var p = Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_1__["ParamDefinition"].getDefaultValues(Text.Params)), props);
        return createValues(text, s.transform, s.locationIterator, s.theme, p);
    }
    function updateValues(values, props) {
        _base__WEBPACK_IMPORTED_MODULE_14__["BaseGeometry"].updateValues(values, props);
        _mol_util__WEBPACK_IMPORTED_MODULE_2__["ValueCell"].updateIfChanged(values.uSizeFactor, props.sizeFactor);
        _mol_util__WEBPACK_IMPORTED_MODULE_2__["ValueCell"].updateIfChanged(values.uBorderWidth, props.borderWidth);
        if (_mol_util_color__WEBPACK_IMPORTED_MODULE_10__["Color"].fromNormalizedArray(values.uBorderColor.ref.value, 0) !== props.borderColor) {
            _mol_util_color__WEBPACK_IMPORTED_MODULE_10__["Color"].toArrayNormalized(props.borderColor, values.uBorderColor.ref.value, 0);
            _mol_util__WEBPACK_IMPORTED_MODULE_2__["ValueCell"].update(values.uBorderColor, values.uBorderColor.ref.value);
        }
        _mol_util__WEBPACK_IMPORTED_MODULE_2__["ValueCell"].updateIfChanged(values.uOffsetX, props.offsetX);
        _mol_util__WEBPACK_IMPORTED_MODULE_2__["ValueCell"].updateIfChanged(values.uOffsetY, props.offsetY);
        _mol_util__WEBPACK_IMPORTED_MODULE_2__["ValueCell"].updateIfChanged(values.uOffsetZ, props.offsetZ);
        if (_mol_util_color__WEBPACK_IMPORTED_MODULE_10__["Color"].fromNormalizedArray(values.uBackgroundColor.ref.value, 0) !== props.backgroundColor) {
            _mol_util_color__WEBPACK_IMPORTED_MODULE_10__["Color"].toArrayNormalized(props.backgroundColor, values.uBackgroundColor.ref.value, 0);
            _mol_util__WEBPACK_IMPORTED_MODULE_2__["ValueCell"].update(values.uBackgroundColor, values.uBackgroundColor.ref.value);
        }
        _mol_util__WEBPACK_IMPORTED_MODULE_2__["ValueCell"].updateIfChanged(values.uBackgroundOpacity, props.backgroundOpacity);
    }
    function updateBoundingSphere(values, text) {
        var padding = getPadding(values.aMapping.ref.value, values.aDepth.ref.value, text.charCount, Object(_size_data__WEBPACK_IMPORTED_MODULE_5__["getMaxSize"])(values));
        var invariantBoundingSphere = _mol_math_geometry__WEBPACK_IMPORTED_MODULE_8__["Sphere3D"].expand(Object(_mol_math_geometry__WEBPACK_IMPORTED_MODULE_8__["Sphere3D"])(), text.boundingSphere, padding);
        var boundingSphere = Object(_mol_gl_renderable_util__WEBPACK_IMPORTED_MODULE_9__["calculateTransformBoundingSphere"])(invariantBoundingSphere, values.aTransform.ref.value, values.instanceCount.ref.value);
        if (!_mol_math_geometry__WEBPACK_IMPORTED_MODULE_8__["Sphere3D"].equals(boundingSphere, values.boundingSphere.ref.value)) {
            _mol_util__WEBPACK_IMPORTED_MODULE_2__["ValueCell"].update(values.boundingSphere, boundingSphere);
        }
        if (!_mol_math_geometry__WEBPACK_IMPORTED_MODULE_8__["Sphere3D"].equals(invariantBoundingSphere, values.invariantBoundingSphere.ref.value)) {
            _mol_util__WEBPACK_IMPORTED_MODULE_2__["ValueCell"].update(values.invariantBoundingSphere, invariantBoundingSphere);
            _mol_util__WEBPACK_IMPORTED_MODULE_2__["ValueCell"].update(values.uInvariantBoundingSphere, _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_11__["Vec4"].fromSphere(values.uInvariantBoundingSphere.ref.value, invariantBoundingSphere));
        }
        _mol_util__WEBPACK_IMPORTED_MODULE_2__["ValueCell"].update(values.padding, padding);
    }
    function createRenderableState(props) {
        var state = _base__WEBPACK_IMPORTED_MODULE_14__["BaseGeometry"].createRenderableState(props);
        updateRenderableState(state, props);
        return state;
    }
    function updateRenderableState(state, props) {
        _base__WEBPACK_IMPORTED_MODULE_14__["BaseGeometry"].updateRenderableState(state, props);
        state.pickable = false;
        state.opaque = false;
        state.writeDepth = true;
    }
})(Text || (Text = {}));
function getPadding(mappings, depths, charCount, maxSize) {
    var maxOffset = 0;
    var maxDepth = 0;
    for (var i = 0, il = charCount * 4; i < il; ++i) {
        var i2 = 2 * i;
        var ox = Math.abs(mappings[i2]);
        if (ox > maxOffset)
            maxOffset = ox;
        var oy = Math.abs(mappings[i2 + 1]);
        if (oy > maxOffset)
            maxOffset = oy;
        var d = Math.abs(depths[i]);
        if (d > maxDepth)
            maxDepth = d;
    }
    // console.log(maxDepth + maxSize, maxDepth, maxSize, maxSize + maxSize * maxOffset, depths)
    return Math.max(maxDepth, maxSize + maxSize * maxOffset);
    // return maxSize + maxSize * maxOffset + maxDepth
}
//# sourceMappingURL=text.js.map

/***/ }),

/***/ "./lib/mol-geo/geometry/texture-mesh/texture-mesh.js":
/*!***********************************************************!*\
  !*** ./lib/mol-geo/geometry/texture-mesh/texture-mesh.js ***!
  \***********************************************************/
/*! exports provided: TextureMesh */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "TextureMesh", function() { return TextureMesh; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _mol_util__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../../mol-util */ "./lib/mol-util/index.js");
/* harmony import */ var _mol_math_geometry__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../../mol-math/geometry */ "./lib/mol-math/geometry.js");
/* harmony import */ var _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../../mol-util/param-definition */ "./lib/mol-util/param-definition.js");
/* harmony import */ var _mol_geo_util_location_iterator__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../../mol-geo/util/location-iterator */ "./lib/mol-geo/util/location-iterator.js");
/* harmony import */ var _color_data__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../color-data */ "./lib/mol-geo/geometry/color-data.js");
/* harmony import */ var _marker_data__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../marker-data */ "./lib/mol-geo/geometry/marker-data.js");
/* harmony import */ var _base__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../base */ "./lib/mol-geo/geometry/base.js");
/* harmony import */ var _overpaint_data__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ../overpaint-data */ "./lib/mol-geo/geometry/overpaint-data.js");
/* harmony import */ var _transparency_data__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ../transparency-data */ "./lib/mol-geo/geometry/transparency-data.js");
/* harmony import */ var _mol_gl_renderable_util__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ../../../mol-gl/renderable/util */ "./lib/mol-gl/renderable/util.js");
/* harmony import */ var _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ../../../mol-math/linear-algebra */ "./lib/mol-math/linear-algebra.js");
/* harmony import */ var _mol_util_array__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! ../../../mol-util/array */ "./lib/mol-util/array.js");
/* harmony import */ var _clipping_data__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! ../clipping-data */ "./lib/mol-geo/geometry/clipping-data.js");
/* harmony import */ var _mol_model_location__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! ../../../mol-model/location */ "./lib/mol-model/location.js");
/**
 * Copyright (c) 2019-2020 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */















var TextureMesh;
(function (TextureMesh) {
    function create(vertexCount, groupCount, vertexGroupTexture, normalTexture, boundingSphere, textureMesh) {
        var width = vertexGroupTexture.getWidth();
        var height = vertexGroupTexture.getHeight();
        if (textureMesh) {
            textureMesh.vertexCount = vertexCount;
            textureMesh.groupCount = groupCount;
            _mol_util__WEBPACK_IMPORTED_MODULE_1__["ValueCell"].update(textureMesh.geoTextureDim, _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_11__["Vec2"].set(textureMesh.geoTextureDim.ref.value, width, height));
            _mol_util__WEBPACK_IMPORTED_MODULE_1__["ValueCell"].update(textureMesh.vertexGroupTexture, vertexGroupTexture);
            _mol_util__WEBPACK_IMPORTED_MODULE_1__["ValueCell"].update(textureMesh.normalTexture, normalTexture);
            _mol_math_geometry__WEBPACK_IMPORTED_MODULE_2__["Sphere3D"].copy(textureMesh.boundingSphere, boundingSphere);
            return textureMesh;
        }
        else {
            return {
                kind: 'texture-mesh',
                vertexCount: vertexCount,
                groupCount: groupCount,
                geoTextureDim: _mol_util__WEBPACK_IMPORTED_MODULE_1__["ValueCell"].create(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_11__["Vec2"].create(width, height)),
                vertexGroupTexture: _mol_util__WEBPACK_IMPORTED_MODULE_1__["ValueCell"].create(vertexGroupTexture),
                normalTexture: _mol_util__WEBPACK_IMPORTED_MODULE_1__["ValueCell"].create(normalTexture),
                boundingSphere: _mol_math_geometry__WEBPACK_IMPORTED_MODULE_2__["Sphere3D"].clone(boundingSphere),
            };
        }
    }
    TextureMesh.create = create;
    function createEmpty(textureMesh) {
        return {}; // TODO
    }
    TextureMesh.createEmpty = createEmpty;
    TextureMesh.Params = Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, _base__WEBPACK_IMPORTED_MODULE_7__["BaseGeometry"].Params), { doubleSided: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_3__["ParamDefinition"].Boolean(false, _base__WEBPACK_IMPORTED_MODULE_7__["BaseGeometry"].CustomQualityParamInfo), flipSided: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_3__["ParamDefinition"].Boolean(false, _base__WEBPACK_IMPORTED_MODULE_7__["BaseGeometry"].ShadingCategory), flatShaded: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_3__["ParamDefinition"].Boolean(false, _base__WEBPACK_IMPORTED_MODULE_7__["BaseGeometry"].ShadingCategory), ignoreLight: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_3__["ParamDefinition"].Boolean(false, _base__WEBPACK_IMPORTED_MODULE_7__["BaseGeometry"].ShadingCategory), xrayShaded: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_3__["ParamDefinition"].Boolean(false, _base__WEBPACK_IMPORTED_MODULE_7__["BaseGeometry"].ShadingCategory) });
    TextureMesh.Utils = {
        Params: TextureMesh.Params,
        createEmpty: createEmpty,
        createValues: createValues,
        createValuesSimple: createValuesSimple,
        updateValues: updateValues,
        updateBoundingSphere: updateBoundingSphere,
        createRenderableState: _base__WEBPACK_IMPORTED_MODULE_7__["BaseGeometry"].createRenderableState,
        updateRenderableState: _base__WEBPACK_IMPORTED_MODULE_7__["BaseGeometry"].updateRenderableState,
        createPositionIterator: function () { return Object(_mol_geo_util_location_iterator__WEBPACK_IMPORTED_MODULE_4__["LocationIterator"])(1, 1, 1, function () { return _mol_model_location__WEBPACK_IMPORTED_MODULE_14__["NullLocation"]; }); }
    };
    function createValues(textureMesh, transform, locationIt, theme, props) {
        var instanceCount = locationIt.instanceCount, groupCount = locationIt.groupCount;
        var positionIt = TextureMesh.Utils.createPositionIterator(textureMesh, transform);
        var color = Object(_color_data__WEBPACK_IMPORTED_MODULE_5__["createColors"])(locationIt, positionIt, theme.color);
        var marker = Object(_marker_data__WEBPACK_IMPORTED_MODULE_6__["createMarkers"])(instanceCount * groupCount);
        var overpaint = Object(_overpaint_data__WEBPACK_IMPORTED_MODULE_8__["createEmptyOverpaint"])();
        var transparency = Object(_transparency_data__WEBPACK_IMPORTED_MODULE_9__["createEmptyTransparency"])();
        var clipping = Object(_clipping_data__WEBPACK_IMPORTED_MODULE_13__["createEmptyClipping"])();
        var counts = { drawCount: textureMesh.vertexCount, vertexCount: textureMesh.vertexCount, groupCount: groupCount, instanceCount: instanceCount };
        var invariantBoundingSphere = _mol_math_geometry__WEBPACK_IMPORTED_MODULE_2__["Sphere3D"].clone(textureMesh.boundingSphere);
        var boundingSphere = Object(_mol_gl_renderable_util__WEBPACK_IMPORTED_MODULE_10__["calculateTransformBoundingSphere"])(invariantBoundingSphere, transform.aTransform.ref.value, instanceCount);
        return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({ uGeoTexDim: textureMesh.geoTextureDim, tPositionGroup: textureMesh.vertexGroupTexture, tNormal: textureMesh.normalTexture, 
            // aGroup is used as a vertex index here and the group id is retirieved from tPositionGroup
            aGroup: _mol_util__WEBPACK_IMPORTED_MODULE_1__["ValueCell"].create(Object(_mol_util_array__WEBPACK_IMPORTED_MODULE_12__["fillSerial"])(new Float32Array(textureMesh.vertexCount))), boundingSphere: _mol_util__WEBPACK_IMPORTED_MODULE_1__["ValueCell"].create(boundingSphere), invariantBoundingSphere: _mol_util__WEBPACK_IMPORTED_MODULE_1__["ValueCell"].create(invariantBoundingSphere), uInvariantBoundingSphere: _mol_util__WEBPACK_IMPORTED_MODULE_1__["ValueCell"].create(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_11__["Vec4"].ofSphere(invariantBoundingSphere)) }, color), marker), overpaint), transparency), clipping), transform), _base__WEBPACK_IMPORTED_MODULE_7__["BaseGeometry"].createValues(props, counts)), { dDoubleSided: _mol_util__WEBPACK_IMPORTED_MODULE_1__["ValueCell"].create(props.doubleSided), dFlatShaded: _mol_util__WEBPACK_IMPORTED_MODULE_1__["ValueCell"].create(props.flatShaded), dFlipSided: _mol_util__WEBPACK_IMPORTED_MODULE_1__["ValueCell"].create(props.flipSided), dIgnoreLight: _mol_util__WEBPACK_IMPORTED_MODULE_1__["ValueCell"].create(props.ignoreLight), dXrayShaded: _mol_util__WEBPACK_IMPORTED_MODULE_1__["ValueCell"].create(props.xrayShaded), dGeoTexture: _mol_util__WEBPACK_IMPORTED_MODULE_1__["ValueCell"].create(true) });
    }
    function createValuesSimple(textureMesh, props, colorValue, sizeValue, transform) {
        var s = _base__WEBPACK_IMPORTED_MODULE_7__["BaseGeometry"].createSimple(colorValue, sizeValue, transform);
        var p = Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_3__["ParamDefinition"].getDefaultValues(TextureMesh.Params)), props);
        return createValues(textureMesh, s.transform, s.locationIterator, s.theme, p);
    }
    function updateValues(values, props) {
        _base__WEBPACK_IMPORTED_MODULE_7__["BaseGeometry"].updateValues(values, props);
        _mol_util__WEBPACK_IMPORTED_MODULE_1__["ValueCell"].updateIfChanged(values.dDoubleSided, props.doubleSided);
        _mol_util__WEBPACK_IMPORTED_MODULE_1__["ValueCell"].updateIfChanged(values.dFlatShaded, props.flatShaded);
        _mol_util__WEBPACK_IMPORTED_MODULE_1__["ValueCell"].updateIfChanged(values.dFlipSided, props.flipSided);
        _mol_util__WEBPACK_IMPORTED_MODULE_1__["ValueCell"].updateIfChanged(values.dIgnoreLight, props.ignoreLight);
        _mol_util__WEBPACK_IMPORTED_MODULE_1__["ValueCell"].updateIfChanged(values.dXrayShaded, props.xrayShaded);
        if (values.drawCount.ref.value > values.aGroup.ref.value.length) {
            // console.log('updating vertex ids in aGroup to handle larger drawCount')
            _mol_util__WEBPACK_IMPORTED_MODULE_1__["ValueCell"].update(values.aGroup, Object(_mol_util_array__WEBPACK_IMPORTED_MODULE_12__["fillSerial"])(new Float32Array(values.drawCount.ref.value)));
        }
    }
    function updateBoundingSphere(values, textureMesh) {
        var invariantBoundingSphere = _mol_math_geometry__WEBPACK_IMPORTED_MODULE_2__["Sphere3D"].clone(textureMesh.boundingSphere);
        var boundingSphere = Object(_mol_gl_renderable_util__WEBPACK_IMPORTED_MODULE_10__["calculateTransformBoundingSphere"])(invariantBoundingSphere, values.aTransform.ref.value, values.instanceCount.ref.value);
        if (!_mol_math_geometry__WEBPACK_IMPORTED_MODULE_2__["Sphere3D"].equals(boundingSphere, values.boundingSphere.ref.value)) {
            _mol_util__WEBPACK_IMPORTED_MODULE_1__["ValueCell"].update(values.boundingSphere, boundingSphere);
        }
        if (!_mol_math_geometry__WEBPACK_IMPORTED_MODULE_2__["Sphere3D"].equals(invariantBoundingSphere, values.invariantBoundingSphere.ref.value)) {
            _mol_util__WEBPACK_IMPORTED_MODULE_1__["ValueCell"].update(values.invariantBoundingSphere, invariantBoundingSphere);
            _mol_util__WEBPACK_IMPORTED_MODULE_1__["ValueCell"].update(values.uInvariantBoundingSphere, _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_11__["Vec4"].fromSphere(values.uInvariantBoundingSphere.ref.value, invariantBoundingSphere));
        }
    }
})(TextureMesh || (TextureMesh = {}));
//# sourceMappingURL=texture-mesh.js.map

/***/ }),

/***/ "./lib/mol-geo/geometry/transform-data.js":
/*!************************************************!*\
  !*** ./lib/mol-geo/geometry/transform-data.js ***!
  \************************************************/
/*! exports provided: createTransform, createIdentityTransform, fillIdentityTransform, updateTransformData */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createTransform", function() { return createTransform; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createIdentityTransform", function() { return createIdentityTransform; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fillIdentityTransform", function() { return fillIdentityTransform; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "updateTransformData", function() { return updateTransformData; });
/* harmony import */ var _mol_util__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../mol-util */ "./lib/mol-util/index.js");
/* harmony import */ var _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../mol-math/linear-algebra */ "./lib/mol-math/linear-algebra.js");
/* harmony import */ var _mol_util_array__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../mol-util/array */ "./lib/mol-util/array.js");
/**
 * Copyright (c) 2018-2020 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */



var _m3 = Object(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_1__["Mat3"])();
var _m4 = Object(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_1__["Mat4"])();
function checkReflection(transformArray, instanceCount) {
    for (var i = 0; i < instanceCount; i++) {
        _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_1__["Mat3"].fromMat4(_m3, _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_1__["Mat4"].fromArray(_m4, transformArray, i * 16));
        if (_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_1__["Mat3"].determinant(_m3) < 0)
            return true;
    }
    return false;
}
function createTransform(transformArray, instanceCount, transformData) {
    var hasReflection = checkReflection(transformArray, instanceCount);
    if (transformData) {
        _mol_util__WEBPACK_IMPORTED_MODULE_0__["ValueCell"].update(transformData.matrix, transformData.matrix.ref.value);
        _mol_util__WEBPACK_IMPORTED_MODULE_0__["ValueCell"].update(transformData.transform, transformArray);
        _mol_util__WEBPACK_IMPORTED_MODULE_0__["ValueCell"].updateIfChanged(transformData.uInstanceCount, instanceCount);
        _mol_util__WEBPACK_IMPORTED_MODULE_0__["ValueCell"].updateIfChanged(transformData.instanceCount, instanceCount);
        var aTransform = transformData.aTransform.ref.value.length >= instanceCount * 16 ? transformData.aTransform.ref.value : new Float32Array(instanceCount * 16);
        aTransform.set(transformArray);
        _mol_util__WEBPACK_IMPORTED_MODULE_0__["ValueCell"].update(transformData.aTransform, aTransform);
        // Note that this sets `extraTransform` to identity transforms
        var extraTransform = transformData.extraTransform.ref.value.length >= instanceCount * 16 ? transformData.extraTransform.ref.value : new Float32Array(instanceCount * 16);
        _mol_util__WEBPACK_IMPORTED_MODULE_0__["ValueCell"].update(transformData.extraTransform, fillIdentityTransform(extraTransform, instanceCount));
        var aInstance = transformData.aInstance.ref.value.length >= instanceCount ? transformData.aInstance.ref.value : new Float32Array(instanceCount);
        _mol_util__WEBPACK_IMPORTED_MODULE_0__["ValueCell"].update(transformData.aInstance, Object(_mol_util_array__WEBPACK_IMPORTED_MODULE_2__["fillSerial"])(aInstance, instanceCount));
        _mol_util__WEBPACK_IMPORTED_MODULE_0__["ValueCell"].update(transformData.hasReflection, hasReflection);
        updateTransformData(transformData);
        return transformData;
    }
    else {
        return {
            aTransform: _mol_util__WEBPACK_IMPORTED_MODULE_0__["ValueCell"].create(new Float32Array(transformArray)),
            matrix: _mol_util__WEBPACK_IMPORTED_MODULE_0__["ValueCell"].create(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_1__["Mat4"].identity()),
            transform: _mol_util__WEBPACK_IMPORTED_MODULE_0__["ValueCell"].create(transformArray),
            extraTransform: _mol_util__WEBPACK_IMPORTED_MODULE_0__["ValueCell"].create(fillIdentityTransform(new Float32Array(instanceCount * 16), instanceCount)),
            uInstanceCount: _mol_util__WEBPACK_IMPORTED_MODULE_0__["ValueCell"].create(instanceCount),
            instanceCount: _mol_util__WEBPACK_IMPORTED_MODULE_0__["ValueCell"].create(instanceCount),
            aInstance: _mol_util__WEBPACK_IMPORTED_MODULE_0__["ValueCell"].create(Object(_mol_util_array__WEBPACK_IMPORTED_MODULE_2__["fillSerial"])(new Float32Array(instanceCount))),
            hasReflection: _mol_util__WEBPACK_IMPORTED_MODULE_0__["ValueCell"].create(hasReflection),
        };
    }
}
var identityTransform = new Float32Array(16);
_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_1__["Mat4"].toArray(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_1__["Mat4"].identity(), identityTransform, 0);
function createIdentityTransform(transformData) {
    return createTransform(new Float32Array(identityTransform), 1, transformData);
}
function fillIdentityTransform(transform, count) {
    for (var i = 0; i < count; i++) {
        transform.set(identityTransform, i * 16);
    }
    return transform;
}
/**
 * updates per-instance transform calculated for instance `i` as
 * `aTransform[i] = matrix * transform[i] * extraTransform[i]`
 */
function updateTransformData(transformData) {
    var aTransform = transformData.aTransform.ref.value;
    var instanceCount = transformData.instanceCount.ref.value;
    var matrix = transformData.matrix.ref.value;
    var transform = transformData.transform.ref.value;
    var extraTransform = transformData.extraTransform.ref.value;
    for (var i = 0; i < instanceCount; i++) {
        var i16 = i * 16;
        _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_1__["Mat4"].mulOffset(aTransform, extraTransform, transform, i16, i16, i16);
        _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_1__["Mat4"].mulOffset(aTransform, matrix, aTransform, i16, 0, i16);
    }
    _mol_util__WEBPACK_IMPORTED_MODULE_0__["ValueCell"].update(transformData.aTransform, aTransform);
}
//# sourceMappingURL=transform-data.js.map

/***/ }),

/***/ "./lib/mol-geo/geometry/transparency-data.js":
/*!***************************************************!*\
  !*** ./lib/mol-geo/geometry/transparency-data.js ***!
  \***************************************************/
/*! exports provided: applyTransparencyValue, getTransparencyAverage, clearTransparency, createTransparency, createEmptyTransparency */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "applyTransparencyValue", function() { return applyTransparencyValue; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getTransparencyAverage", function() { return getTransparencyAverage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "clearTransparency", function() { return clearTransparency; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createTransparency", function() { return createTransparency; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createEmptyTransparency", function() { return createEmptyTransparency; });
/* harmony import */ var _mol_util_value_cell__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../mol-util/value-cell */ "./lib/mol-util/value-cell.js");
/* harmony import */ var _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../mol-math/linear-algebra */ "./lib/mol-math/linear-algebra.js");
/* harmony import */ var _mol_gl_renderable_util__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../mol-gl/renderable/util */ "./lib/mol-gl/renderable/util.js");
/**
 * Copyright (c) 2019-2020 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */



function applyTransparencyValue(array, start, end, value) {
    for (var i = start; i < end; ++i) {
        array[i] = value * 255;
    }
    return true;
}
function getTransparencyAverage(array, count) {
    var sum = 0;
    for (var i = 0; i < count; ++i) {
        sum += array[i];
    }
    return sum / (255 * count);
}
function clearTransparency(array, start, end) {
    array.fill(0, start, end);
}
function createTransparency(count, transparencyData) {
    var transparency = Object(_mol_gl_renderable_util__WEBPACK_IMPORTED_MODULE_2__["createTextureImage"])(Math.max(1, count), 1, Uint8Array, transparencyData && transparencyData.tTransparency.ref.value.array);
    if (transparencyData) {
        _mol_util_value_cell__WEBPACK_IMPORTED_MODULE_0__["ValueCell"].update(transparencyData.tTransparency, transparency);
        _mol_util_value_cell__WEBPACK_IMPORTED_MODULE_0__["ValueCell"].update(transparencyData.uTransparencyTexDim, _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_1__["Vec2"].create(transparency.width, transparency.height));
        _mol_util_value_cell__WEBPACK_IMPORTED_MODULE_0__["ValueCell"].updateIfChanged(transparencyData.dTransparency, count > 0);
        _mol_util_value_cell__WEBPACK_IMPORTED_MODULE_0__["ValueCell"].updateIfChanged(transparencyData.transparencyAverage, getTransparencyAverage(transparency.array, count));
        return transparencyData;
    }
    else {
        return {
            tTransparency: _mol_util_value_cell__WEBPACK_IMPORTED_MODULE_0__["ValueCell"].create(transparency),
            uTransparencyTexDim: _mol_util_value_cell__WEBPACK_IMPORTED_MODULE_0__["ValueCell"].create(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_1__["Vec2"].create(transparency.width, transparency.height)),
            dTransparency: _mol_util_value_cell__WEBPACK_IMPORTED_MODULE_0__["ValueCell"].create(count > 0),
            transparencyAverage: _mol_util_value_cell__WEBPACK_IMPORTED_MODULE_0__["ValueCell"].create(0),
        };
    }
}
var emptyTransparencyTexture = { array: new Uint8Array(1), width: 1, height: 1 };
function createEmptyTransparency(transparencyData) {
    if (transparencyData) {
        _mol_util_value_cell__WEBPACK_IMPORTED_MODULE_0__["ValueCell"].update(transparencyData.tTransparency, emptyTransparencyTexture);
        _mol_util_value_cell__WEBPACK_IMPORTED_MODULE_0__["ValueCell"].update(transparencyData.uTransparencyTexDim, _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_1__["Vec2"].create(1, 1));
        return transparencyData;
    }
    else {
        return {
            tTransparency: _mol_util_value_cell__WEBPACK_IMPORTED_MODULE_0__["ValueCell"].create(emptyTransparencyTexture),
            uTransparencyTexDim: _mol_util_value_cell__WEBPACK_IMPORTED_MODULE_0__["ValueCell"].create(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_1__["Vec2"].create(1, 1)),
            dTransparency: _mol_util_value_cell__WEBPACK_IMPORTED_MODULE_0__["ValueCell"].create(false),
            transparencyAverage: _mol_util_value_cell__WEBPACK_IMPORTED_MODULE_0__["ValueCell"].create(0),
        };
    }
}
//# sourceMappingURL=transparency-data.js.map

/***/ }),

/***/ "./lib/mol-geo/primitive/box.js":
/*!**************************************!*\
  !*** ./lib/mol-geo/primitive/box.js ***!
  \**************************************/
/*! exports provided: Box, PerforatedBox, BoxCage */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Box", function() { return Box; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "PerforatedBox", function() { return PerforatedBox; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "BoxCage", function() { return BoxCage; });
/* harmony import */ var _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../mol-math/linear-algebra */ "./lib/mol-math/linear-algebra.js");
/* harmony import */ var _primitive__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./primitive */ "./lib/mol-geo/primitive/primitive.js");
/* harmony import */ var _polygon__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./polygon */ "./lib/mol-geo/primitive/polygon.js");
/* harmony import */ var _cage__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./cage */ "./lib/mol-geo/primitive/cage.js");
/**
 * Copyright (c) 2018-2020 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */




var a = Object(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"])(), b = Object(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"])(), c = Object(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"])(), d = Object(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"])();
var points = Object(_polygon__WEBPACK_IMPORTED_MODULE_2__["polygon"])(4, true);
/**
 * Create a box
 */
function createBox(perforated) {
    var triangleCount = 12;
    var vertexCount = perforated ? 12 * 3 : 6 * 4;
    var builder = Object(_primitive__WEBPACK_IMPORTED_MODULE_1__["PrimitiveBuilder"])(triangleCount, vertexCount);
    // create sides
    for (var i = 0; i < 4; ++i) {
        var ni = (i + 1) % 4;
        _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"].set(a, points[i * 3], points[i * 3 + 1], -0.5);
        _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"].set(b, points[ni * 3], points[ni * 3 + 1], -0.5);
        _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"].set(c, points[ni * 3], points[ni * 3 + 1], 0.5);
        _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"].set(d, points[i * 3], points[i * 3 + 1], 0.5);
        if (perforated) {
            builder.add(a, b, c);
        }
        else {
            builder.addQuad(a, b, c, d);
        }
    }
    // create bases
    _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"].set(a, points[0], points[1], -0.5);
    _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"].set(b, points[3], points[4], -0.5);
    _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"].set(c, points[6], points[7], -0.5);
    _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"].set(d, points[9], points[10], -0.5);
    if (perforated) {
        builder.add(c, b, a);
    }
    else {
        builder.addQuad(d, c, b, a);
    }
    _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"].set(a, points[0], points[1], 0.5);
    _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"].set(b, points[3], points[4], 0.5);
    _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"].set(c, points[6], points[7], 0.5);
    _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"].set(d, points[9], points[10], 0.5);
    if (perforated) {
        builder.add(a, b, c);
    }
    else {
        builder.addQuad(a, b, c, d);
    }
    return builder.getPrimitive();
}
var box;
function Box() {
    if (!box)
        box = createBox(false);
    return box;
}
var perforatedBox;
function PerforatedBox() {
    if (!perforatedBox)
        perforatedBox = createBox(true);
    return perforatedBox;
}
var boxCage;
function BoxCage() {
    if (!boxCage) {
        boxCage = Object(_cage__WEBPACK_IMPORTED_MODULE_3__["createCage"])([
            0.5, 0.5, -0.5,
            -0.5, 0.5, -0.5,
            -0.5, -0.5, -0.5,
            0.5, -0.5, -0.5,
            0.5, 0.5, 0.5,
            -0.5, 0.5, 0.5,
            -0.5, -0.5, 0.5,
            0.5, -0.5, 0.5
        ], [
            0, 4, 1, 5, 2, 6, 3, 7,
            0, 1, 1, 2, 2, 3, 3, 0,
            4, 5, 5, 6, 6, 7, 7, 4 // top base
        ]);
    }
    return boxCage;
}
//# sourceMappingURL=box.js.map

/***/ }),

/***/ "./lib/mol-geo/primitive/cage.js":
/*!***************************************!*\
  !*** ./lib/mol-geo/primitive/cage.js ***!
  \***************************************/
/*! exports provided: createCage, cloneCage, transformCage */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createCage", function() { return createCage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "cloneCage", function() { return cloneCage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "transformCage", function() { return transformCage; });
/* harmony import */ var _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../mol-math/linear-algebra */ "./lib/mol-math/linear-algebra.js");
/**
 * Copyright (c) 2019 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */

function createCage(vertices, edges) {
    return { vertices: vertices, edges: edges };
}
function cloneCage(cage) {
    return {
        vertices: new Float32Array(cage.vertices),
        edges: new Uint32Array(cage.edges)
    };
}
var tmpV = _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"].zero();
/** Transform primitive in-place */
function transformCage(cage, t) {
    var vertices = cage.vertices;
    for (var i = 0, il = vertices.length; i < il; i += 3) {
        // position
        _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"].transformMat4(tmpV, _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"].fromArray(tmpV, vertices, i), t);
        _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"].toArray(tmpV, vertices, i);
    }
    return cage;
}
//# sourceMappingURL=cage.js.map

/***/ }),

/***/ "./lib/mol-geo/primitive/circle.js":
/*!*****************************************!*\
  !*** ./lib/mol-geo/primitive/circle.js ***!
  \*****************************************/
/*! exports provided: DefaultCircleProps, Circle */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DefaultCircleProps", function() { return DefaultCircleProps; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Circle", function() { return Circle; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/**
 * Copyright (c) 2019 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */

var DefaultCircleProps = {
    radius: 1,
    segments: 36,
    thetaStart: 0,
    thetaLength: Math.PI * 2
};
function Circle(props) {
    var _a = Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, DefaultCircleProps), props), radius = _a.radius, segments = _a.segments, thetaStart = _a.thetaStart, thetaLength = _a.thetaLength;
    var isFull = thetaLength === Math.PI * 2;
    var count = isFull ? segments + 1 : segments + 2;
    var vertices = new Float32Array(count * 3);
    var normals = new Float32Array(count * 3);
    var indices = new Uint32Array(segments * 3);
    // center
    vertices[0] = 0;
    vertices[1] = 0;
    vertices[2] = 0;
    normals[0] = 0;
    normals[1] = 1;
    normals[2] = 0;
    // vertices & normals
    for (var s = 0, i = 3; s < segments; ++s, i += 3) {
        var segment = thetaStart + s / segments * thetaLength;
        vertices[i] = radius * Math.sin(segment);
        vertices[i + 1] = 0;
        vertices[i + 2] = radius * Math.cos(segment);
        normals[i] = 0;
        normals[i + 1] = 1;
        normals[i + 2] = 0;
    }
    // indices
    for (var s = 1, i = 0; s < segments; ++s, i += 3) {
        indices[i] = s;
        indices[i + 1] = s + 1;
        indices[i + 2] = 0;
    }
    if (isFull) {
        var j = (segments - 1) * 3;
        indices[j] = segments;
        indices[j + 1] = 1;
        indices[j + 2] = 0;
    }
    else {
        var segment = thetaStart + thetaLength;
        var i = (segments + 1) * 3;
        vertices[i] = radius * Math.sin(segment);
        vertices[i + 1] = 0;
        vertices[i + 2] = radius * Math.cos(segment);
        normals[i] = 0;
        normals[i + 1] = 1;
        normals[i + 2] = 0;
        var j = (segments - 1) * 3;
        indices[j] = segments;
        indices[j + 1] = segments + 1;
        indices[j + 2] = 0;
    }
    return { vertices: vertices, normals: normals, indices: indices };
}
//# sourceMappingURL=circle.js.map

/***/ }),

/***/ "./lib/mol-geo/primitive/cylinder.js":
/*!*******************************************!*\
  !*** ./lib/mol-geo/primitive/cylinder.js ***!
  \*******************************************/
/*! exports provided: DefaultCylinderProps, Cylinder */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DefaultCylinderProps", function() { return DefaultCylinderProps; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Cylinder", function() { return Cylinder; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../mol-math/linear-algebra */ "./lib/mol-math/linear-algebra.js");
/**
 * Copyright (c) 2018 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */

// adapted from three.js, MIT License Copyright 2010-2018 three.js authors

var DefaultCylinderProps = {
    radiusTop: 1,
    radiusBottom: 1,
    height: 1,
    radialSegments: 8,
    heightSegments: 1,
    topCap: false,
    bottomCap: false,
    thetaStart: 0.0,
    thetaLength: Math.PI * 2
};
function Cylinder(props) {
    var _a = Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, DefaultCylinderProps), props), radiusTop = _a.radiusTop, radiusBottom = _a.radiusBottom, height = _a.height, radialSegments = _a.radialSegments, heightSegments = _a.heightSegments, topCap = _a.topCap, bottomCap = _a.bottomCap, thetaStart = _a.thetaStart, thetaLength = _a.thetaLength;
    // buffers
    var indices = [];
    var vertices = [];
    var normals = [];
    // helper variables
    var index = 0;
    var indexArray = [];
    var halfHeight = height / 2;
    // generate geometry
    generateTorso();
    if (topCap && radiusTop > 0)
        generateCap(true);
    if (bottomCap && radiusBottom > 0)
        generateCap(false);
    return {
        vertices: new Float32Array(vertices),
        normals: new Float32Array(normals),
        indices: new Uint32Array(indices)
    };
    function generateTorso() {
        var normal = _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_1__["Vec3"].zero();
        // this will be used to calculate the normal
        var slope = (radiusBottom - radiusTop) / height;
        // generate vertices, normals and uvs
        for (var y = 0; y <= heightSegments; ++y) {
            var indexRow = [];
            var v = y / heightSegments;
            // calculate the radius of the current row
            var radius = v * (radiusBottom - radiusTop) + radiusTop;
            for (var x = 0; x <= radialSegments; ++x) {
                var u = x / radialSegments;
                var theta = u * thetaLength + thetaStart;
                var sinTheta = Math.sin(theta);
                var cosTheta = Math.cos(theta);
                // vertex
                vertices.push(radius * sinTheta, -v * height + halfHeight, radius * cosTheta);
                // normal
                _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_1__["Vec3"].normalize(normal, _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_1__["Vec3"].set(normal, sinTheta, slope, cosTheta));
                normals.push.apply(normals, normal);
                // save index of vertex in respective row
                indexRow.push(index++);
            }
            // now save vertices of the row in our index array
            indexArray.push(indexRow);
        }
        // generate indices
        for (var x = 0; x < radialSegments; ++x) {
            for (var y = 0; y < heightSegments; ++y) {
                // we use the index array to access the correct indices
                var a = indexArray[y][x];
                var b = indexArray[y + 1][x];
                var c = indexArray[y + 1][x + 1];
                var d = indexArray[y][x + 1];
                // faces
                indices.push(a, b, d);
                indices.push(b, c, d);
            }
        }
    }
    function generateCap(top) {
        var radius = (top === true) ? radiusTop : radiusBottom;
        var sign = (top === true) ? 1 : -1;
        // save the index of the first center vertex
        var centerIndexStart = index;
        // first we generate the center vertex data of the cap.
        // because the geometry needs one set of uvs per face,
        // we must generate a center vertex per face/segment
        for (var x = 1; x <= radialSegments; ++x) {
            // vertex
            vertices.push(0, halfHeight * sign, 0);
            // normal
            normals.push(0, sign, 0);
            // increase index
            ++index;
        }
        // save the index of the last center vertex
        var centerIndexEnd = index;
        // now we generate the surrounding vertices, normals and uvs
        for (var x = 0; x <= radialSegments; ++x) {
            var u = x / radialSegments;
            var theta = u * thetaLength + thetaStart;
            var cosTheta = Math.cos(theta);
            var sinTheta = Math.sin(theta);
            // vertex
            vertices.push(radius * sinTheta, halfHeight * sign, radius * cosTheta);
            // normal
            normals.push(0, sign, 0);
            // increase index
            ++index;
        }
        // generate indices
        for (var x = 0; x < radialSegments; ++x) {
            var c = centerIndexStart + x;
            var i = centerIndexEnd + x;
            if (top === true) {
                indices.push(i, i + 1, c); // face top
            }
            else {
                indices.push(i + 1, i, c); // face bottom
            }
        }
    }
}
//# sourceMappingURL=cylinder.js.map

/***/ }),

/***/ "./lib/mol-geo/primitive/icosahedron.js":
/*!**********************************************!*\
  !*** ./lib/mol-geo/primitive/icosahedron.js ***!
  \**********************************************/
/*! exports provided: Icosahedron, IcosahedronCage */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Icosahedron", function() { return Icosahedron; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "IcosahedronCage", function() { return IcosahedronCage; });
/* harmony import */ var _primitive__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./primitive */ "./lib/mol-geo/primitive/primitive.js");
/* harmony import */ var _cage__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./cage */ "./lib/mol-geo/primitive/cage.js");
/**
 * Copyright (c) 2018 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */


var t = (1 + Math.sqrt(5)) / 2;
var icosahedronVertices = [
    -1, t, 0, 1, t, 0, -1, -t, 0, 1, -t, 0,
    0, -1, t, 0, 1, t, 0, -1, -t, 0, 1, -t,
    t, 0, -1, t, 0, 1, -t, 0, -1, -t, 0, 1
];
var icosahedronIndices = [
    0, 11, 5, 0, 5, 1, 0, 1, 7, 0, 7, 10, 0, 10, 11,
    1, 5, 9, 5, 11, 4, 11, 10, 2, 10, 7, 6, 7, 1, 8,
    3, 9, 4, 3, 4, 2, 3, 2, 6, 3, 6, 8, 3, 8, 9,
    4, 9, 5, 2, 4, 11, 6, 2, 10, 8, 6, 7, 9, 8, 1
];
var icosahedronEdges = [
    0, 11, 5, 11, 0, 5, 1, 5, 0, 1, 1, 7, 0, 7, 7, 10, 0, 10, 10, 11,
    5, 9, 4, 11, 2, 10, 6, 7, 1, 8, 3, 9, 4, 9, 3, 4, 2, 4, 2, 3,
    2, 6, 3, 6, 6, 8, 3, 8, 8, 9, 4, 5, 2, 11, 6, 10, 7, 8, 1, 9
];
var icosahedron;
function Icosahedron() {
    if (!icosahedron)
        icosahedron = Object(_primitive__WEBPACK_IMPORTED_MODULE_0__["createPrimitive"])(icosahedronVertices, icosahedronIndices);
    return icosahedron;
}
var icosahedronCage = Object(_cage__WEBPACK_IMPORTED_MODULE_1__["createCage"])(icosahedronVertices, icosahedronEdges);
function IcosahedronCage() {
    return icosahedronCage;
}
//# sourceMappingURL=icosahedron.js.map

/***/ }),

/***/ "./lib/mol-geo/primitive/octahedron.js":
/*!*********************************************!*\
  !*** ./lib/mol-geo/primitive/octahedron.js ***!
  \*********************************************/
/*! exports provided: octahedronVertices, octahedronIndices, perforatedOctahedronIndices, Octahedron, PerforatedOctahedron, OctahedronCage */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "octahedronVertices", function() { return octahedronVertices; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "octahedronIndices", function() { return octahedronIndices; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "perforatedOctahedronIndices", function() { return perforatedOctahedronIndices; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Octahedron", function() { return Octahedron; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "PerforatedOctahedron", function() { return PerforatedOctahedron; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "OctahedronCage", function() { return OctahedronCage; });
/* harmony import */ var _primitive__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./primitive */ "./lib/mol-geo/primitive/primitive.js");
/* harmony import */ var _cage__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./cage */ "./lib/mol-geo/primitive/cage.js");
/**
 * Copyright (c) 2018-2019 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */


var octahedronVertices = [
    0.5, 0, 0, -0.5, 0, 0, 0, 0.5, 0,
    0, -0.5, 0, 0, 0, 0.5, 0, 0, -0.5
];
var octahedronIndices = [
    0, 2, 4, 0, 4, 3, 0, 3, 5,
    0, 5, 2, 1, 2, 5, 1, 5, 3,
    1, 3, 4, 1, 4, 2
];
var perforatedOctahedronIndices = [
    0, 2, 4, 0, 4, 3,
    // 0, 3, 5,   0, 5, 2,
    1, 2, 5, 1, 5, 3,
];
var octahedronEdges = [
    0, 2, 1, 3, 2, 1, 3, 0,
    0, 4, 1, 4, 2, 4, 3, 4,
    0, 5, 1, 5, 2, 5, 3, 5,
];
var octahedron;
function Octahedron() {
    if (!octahedron)
        octahedron = Object(_primitive__WEBPACK_IMPORTED_MODULE_0__["createPrimitive"])(octahedronVertices, octahedronIndices);
    return octahedron;
}
var perforatedOctahedron;
function PerforatedOctahedron() {
    if (!perforatedOctahedron)
        perforatedOctahedron = Object(_primitive__WEBPACK_IMPORTED_MODULE_0__["createPrimitive"])(octahedronVertices, perforatedOctahedronIndices);
    return perforatedOctahedron;
}
var octahedronCage = Object(_cage__WEBPACK_IMPORTED_MODULE_1__["createCage"])(octahedronVertices, octahedronEdges);
function OctahedronCage() {
    return octahedronCage;
}
//# sourceMappingURL=octahedron.js.map

/***/ }),

/***/ "./lib/mol-geo/primitive/polygon.js":
/*!******************************************!*\
  !*** ./lib/mol-geo/primitive/polygon.js ***!
  \******************************************/
/*! exports provided: polygon */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "polygon", function() { return polygon; });
/**
 * Copyright (c) 2018-2019 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */
/**
 * Create 3d points for a polygon:
 * 3 for a triangle, 4 for a rectangle, 5 for a pentagon, 6 for a hexagon...
 */
function polygon(sideCount, shift, radius) {
    if (radius === void 0) { radius = -1; }
    var points = new Float32Array(sideCount * 3);
    var r = radius === -1
        ? (sideCount <= 4 ? Math.sqrt(2) / 2 : 0.6)
        : radius;
    var offset = shift ? 1 : 0;
    for (var i = 0, il = sideCount; i < il; ++i) {
        var c = (i * 2 + offset) / sideCount * Math.PI;
        points[i * 3] = Math.cos(c) * r;
        points[i * 3 + 1] = Math.sin(c) * r;
        points[i * 3 + 2] = 0;
    }
    return points;
}
//# sourceMappingURL=polygon.js.map

/***/ }),

/***/ "./lib/mol-geo/primitive/polyhedron.js":
/*!*********************************************!*\
  !*** ./lib/mol-geo/primitive/polyhedron.js ***!
  \*********************************************/
/*! exports provided: DefaultPolyhedronProps, Polyhedron */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DefaultPolyhedronProps", function() { return DefaultPolyhedronProps; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Polyhedron", function() { return Polyhedron; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../mol-math/linear-algebra */ "./lib/mol-math/linear-algebra.js");
/* harmony import */ var _util__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../util */ "./lib/mol-geo/util.js");
/**
 * Copyright (c) 2018-2020 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */

// adapted from three.js, MIT License Copyright 2010-2018 three.js authors


var DefaultPolyhedronProps = {
    radius: 1,
    detail: 0
};
function Polyhedron(_vertices, _indices, props) {
    var _a = Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, DefaultPolyhedronProps), props), radius = _a.radius, detail = _a.detail;
    var builder = createBuilder();
    var vertices = builder.vertices, indices = builder.indices;
    // the subdivision creates the vertex buffer data
    subdivide(detail);
    // all vertices should lie on a conceptual sphere with a given radius
    Object(_util__WEBPACK_IMPORTED_MODULE_2__["appplyRadius"])(vertices, radius);
    var normals = new Float32Array(vertices.length);
    Object(_util__WEBPACK_IMPORTED_MODULE_2__["computeIndexedVertexNormals"])(vertices, indices, normals, vertices.length / 3, indices.length / 3);
    return {
        vertices: new Float32Array(vertices),
        normals: new Float32Array(normals),
        indices: new Uint32Array(indices)
    };
    // helper functions
    function subdivide(detail) {
        var a = Object(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_1__["Vec3"])();
        var b = Object(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_1__["Vec3"])();
        var c = Object(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_1__["Vec3"])();
        // iterate over all faces and apply a subdivison with the given detail value
        for (var i = 0; i < _indices.length; i += 3) {
            // get the vertices of the face
            _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_1__["Vec3"].fromArray(a, _vertices, _indices[i + 0] * 3);
            _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_1__["Vec3"].fromArray(b, _vertices, _indices[i + 1] * 3);
            _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_1__["Vec3"].fromArray(c, _vertices, _indices[i + 2] * 3);
            // perform subdivision
            subdivideFace(a, b, c, detail);
        }
    }
    function subdivideFace(a, b, c, detail) {
        var cols = Math.pow(2, detail);
        // we use this multidimensional array as a data structure for creating the subdivision
        var v = [];
        // construct all of the vertices for this subdivision
        for (var i = 0; i <= cols; ++i) {
            v[i] = [];
            var aj = Object(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_1__["Vec3"])();
            _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_1__["Vec3"].lerp(aj, a, c, i / cols);
            var bj = Object(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_1__["Vec3"])();
            _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_1__["Vec3"].lerp(bj, b, c, i / cols);
            var rows = cols - i;
            for (var j = 0; j <= rows; ++j) {
                if (j === 0 && i === cols) {
                    v[i][j] = aj;
                }
                else {
                    var abj = Object(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_1__["Vec3"])();
                    _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_1__["Vec3"].lerp(abj, aj, bj, j / rows);
                    v[i][j] = abj;
                }
            }
        }
        // construct all of the faces
        for (var i = 0; i < cols; ++i) {
            for (var j = 0; j < 2 * (cols - i) - 1; ++j) {
                var k = Math.floor(j / 2);
                if (j % 2 === 0) {
                    builder.add(v[i][k + 1], v[i + 1][k], v[i][k]);
                }
                else {
                    builder.add(v[i][k + 1], v[i + 1][k + 1], v[i + 1][k]);
                }
            }
        }
    }
}
function createBuilder() {
    var vertices = [];
    var indices = [];
    var vertexMap = new Map();
    function addVertex(v) {
        var key = v[0].toFixed(5) + "|" + v[1].toFixed(5) + "|" + v[2].toFixed(5);
        var idx = vertexMap.get(key);
        if (idx === undefined) {
            idx = vertices.length / 3;
            vertexMap.set(key, idx);
            vertices.push.apply(vertices, v);
        }
        return idx;
    }
    return {
        vertices: vertices,
        indices: indices,
        add: function (v1, v2, v3) {
            indices.push(addVertex(v1), addVertex(v2), addVertex(v3));
        }
    };
}
//# sourceMappingURL=polyhedron.js.map

/***/ }),

/***/ "./lib/mol-geo/primitive/primitive.js":
/*!********************************************!*\
  !*** ./lib/mol-geo/primitive/primitive.js ***!
  \********************************************/
/*! exports provided: createPrimitive, copyPrimitive, PrimitiveBuilder, transformPrimitive */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createPrimitive", function() { return createPrimitive; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "copyPrimitive", function() { return copyPrimitive; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "PrimitiveBuilder", function() { return PrimitiveBuilder; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "transformPrimitive", function() { return transformPrimitive; });
/* harmony import */ var _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../mol-math/linear-algebra */ "./lib/mol-math/linear-algebra.js");
/**
 * Copyright (c) 2018-2020 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */

var a = Object(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"])(), b = Object(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"])(), c = Object(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"])();
/** Create primitive with face normals from vertices and indices */
function createPrimitive(vertices, indices) {
    var count = indices.length;
    var builder = PrimitiveBuilder(count / 3);
    for (var i = 0; i < count; i += 3) {
        _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"].fromArray(a, vertices, indices[i] * 3);
        _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"].fromArray(b, vertices, indices[i + 1] * 3);
        _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"].fromArray(c, vertices, indices[i + 2] * 3);
        builder.add(a, b, c);
    }
    return builder.getPrimitive();
}
function copyPrimitive(primitive) {
    return {
        vertices: new Float32Array(primitive.vertices),
        normals: new Float32Array(primitive.normals),
        indices: new Uint32Array(primitive.indices)
    };
}
var vn = Object(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"])();
/** Builder to create primitive with face normals */
function PrimitiveBuilder(triangleCount, vertexCount) {
    if (vertexCount === undefined)
        vertexCount = triangleCount * 3;
    var vertices = new Float32Array(vertexCount * 3);
    var normals = new Float32Array(vertexCount * 3);
    var indices = new Uint32Array(triangleCount * 3);
    var vOffset = 0;
    var iOffset = 0;
    return {
        add: function (a, b, c) {
            _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"].toArray(a, vertices, vOffset);
            _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"].toArray(b, vertices, vOffset + 3);
            _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"].toArray(c, vertices, vOffset + 6);
            _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"].triangleNormal(vn, a, b, c);
            for (var j = 0; j < 3; ++j) {
                _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"].toArray(vn, normals, vOffset + 3 * j);
                indices[iOffset + j] = vOffset / 3 + j;
            }
            vOffset += 9;
            iOffset += 3;
        },
        addQuad: function (a, b, c, d) {
            _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"].toArray(a, vertices, vOffset);
            _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"].toArray(b, vertices, vOffset + 3);
            _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"].toArray(c, vertices, vOffset + 6);
            _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"].toArray(d, vertices, vOffset + 9);
            _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"].triangleNormal(vn, a, b, c);
            for (var j = 0; j < 4; ++j) {
                _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"].toArray(vn, normals, vOffset + 3 * j);
            }
            var vOffset3 = vOffset / 3;
            // a, b, c
            indices[iOffset] = vOffset3;
            indices[iOffset + 1] = vOffset3 + 1;
            indices[iOffset + 2] = vOffset3 + 2;
            // a, b, c
            indices[iOffset + 3] = vOffset3 + 2;
            indices[iOffset + 4] = vOffset3 + 3;
            indices[iOffset + 5] = vOffset3;
            vOffset += 12;
            iOffset += 6;
        },
        getPrimitive: function () { return ({ vertices: vertices, normals: normals, indices: indices }); }
    };
}
var tmpV = Object(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"])();
var tmpMat3 = Object(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Mat3"])();
/** Transform primitive in-place */
function transformPrimitive(primitive, t) {
    var vertices = primitive.vertices, normals = primitive.normals;
    var n = _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Mat3"].directionTransform(tmpMat3, t);
    for (var i = 0, il = vertices.length; i < il; i += 3) {
        // position
        _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"].transformMat4(tmpV, _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"].fromArray(tmpV, vertices, i), t);
        _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"].toArray(tmpV, vertices, i);
        // normal
        _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"].transformMat3(tmpV, _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"].fromArray(tmpV, normals, i), n);
        _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"].toArray(tmpV, normals, i);
    }
    return primitive;
}
//# sourceMappingURL=primitive.js.map

/***/ }),

/***/ "./lib/mol-geo/primitive/prism.js":
/*!****************************************!*\
  !*** ./lib/mol-geo/primitive/prism.js ***!
  \****************************************/
/*! exports provided: DefaultPrismProps, Prism, DiamondPrism, PentagonalPrism, HexagonalPrism, ShiftedHexagonalPrism, HeptagonalPrism, PrismCage, DiamondPrismCage, PentagonalPrismCage, HexagonalPrismCage */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DefaultPrismProps", function() { return DefaultPrismProps; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Prism", function() { return Prism; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DiamondPrism", function() { return DiamondPrism; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "PentagonalPrism", function() { return PentagonalPrism; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "HexagonalPrism", function() { return HexagonalPrism; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ShiftedHexagonalPrism", function() { return ShiftedHexagonalPrism; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "HeptagonalPrism", function() { return HeptagonalPrism; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "PrismCage", function() { return PrismCage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DiamondPrismCage", function() { return DiamondPrismCage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "PentagonalPrismCage", function() { return PentagonalPrismCage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "HexagonalPrismCage", function() { return HexagonalPrismCage; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../mol-math/linear-algebra */ "./lib/mol-math/linear-algebra.js");
/* harmony import */ var _primitive__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./primitive */ "./lib/mol-geo/primitive/primitive.js");
/* harmony import */ var _polygon__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./polygon */ "./lib/mol-geo/primitive/polygon.js");
/**
 * Copyright (c) 2018-2020 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */




var on = Object(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_1__["Vec3"])(), op = Object(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_1__["Vec3"])();
var a = Object(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_1__["Vec3"])(), b = Object(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_1__["Vec3"])(), c = Object(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_1__["Vec3"])(), d = Object(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_1__["Vec3"])();
var DefaultPrismProps = {
    height: 1,
    topCap: true,
    bottomCap: true,
};
/**
 * Create a prism with a base of 3 or more points
 */
function Prism(points, props) {
    var sideCount = points.length / 3;
    if (sideCount < 3)
        throw new Error('need at least 3 points to build a prism');
    var _a = Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, DefaultPrismProps), props), height = _a.height, topCap = _a.topCap, bottomCap = _a.bottomCap;
    var triangleCount = sideCount * 2;
    var vertexCount = sideCount * 4;
    var capCount = (topCap ? 1 : 0) + (bottomCap ? 1 : 0);
    if (sideCount === 3) {
        triangleCount += capCount;
        vertexCount += capCount * 3;
    }
    else if (sideCount === 4) {
        triangleCount += capCount * 2;
        vertexCount += capCount * 4;
    }
    else {
        triangleCount += capCount * sideCount;
        vertexCount += capCount * sideCount * 3;
    }
    var builder = Object(_primitive__WEBPACK_IMPORTED_MODULE_2__["PrimitiveBuilder"])(triangleCount, vertexCount);
    var halfHeight = height * 0.5;
    _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_1__["Vec3"].set(on, 0, 0, -halfHeight);
    _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_1__["Vec3"].set(op, 0, 0, halfHeight);
    // create sides
    for (var i = 0; i < sideCount; ++i) {
        var ni = (i + 1) % sideCount;
        _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_1__["Vec3"].set(a, points[i * 3], points[i * 3 + 1], -halfHeight);
        _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_1__["Vec3"].set(b, points[ni * 3], points[ni * 3 + 1], -halfHeight);
        _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_1__["Vec3"].set(c, points[ni * 3], points[ni * 3 + 1], halfHeight);
        _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_1__["Vec3"].set(d, points[i * 3], points[i * 3 + 1], halfHeight);
        builder.addQuad(a, b, c, d);
    }
    // create bases
    if (sideCount === 3) {
        if (topCap) {
            _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_1__["Vec3"].set(a, points[0], points[1], -halfHeight);
            _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_1__["Vec3"].set(b, points[3], points[4], -halfHeight);
            _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_1__["Vec3"].set(c, points[6], points[7], -halfHeight);
            builder.add(c, b, a);
        }
        if (bottomCap) {
            _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_1__["Vec3"].set(a, points[0], points[1], halfHeight);
            _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_1__["Vec3"].set(b, points[3], points[4], halfHeight);
            _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_1__["Vec3"].set(c, points[6], points[7], halfHeight);
            builder.add(a, b, c);
        }
    }
    else if (sideCount === 4) {
        if (topCap) {
            _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_1__["Vec3"].set(a, points[0], points[1], -halfHeight);
            _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_1__["Vec3"].set(b, points[3], points[4], -halfHeight);
            _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_1__["Vec3"].set(c, points[6], points[7], -halfHeight);
            _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_1__["Vec3"].set(d, points[9], points[10], -halfHeight);
            builder.addQuad(d, c, b, a);
        }
        if (bottomCap) {
            _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_1__["Vec3"].set(a, points[0], points[1], halfHeight);
            _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_1__["Vec3"].set(b, points[3], points[4], halfHeight);
            _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_1__["Vec3"].set(c, points[6], points[7], halfHeight);
            _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_1__["Vec3"].set(d, points[9], points[10], halfHeight);
            builder.addQuad(a, b, c, d);
        }
    }
    else {
        for (var i = 0; i < sideCount; ++i) {
            var ni = (i + 1) % sideCount;
            if (topCap) {
                _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_1__["Vec3"].set(a, points[i * 3], points[i * 3 + 1], -halfHeight);
                _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_1__["Vec3"].set(b, points[ni * 3], points[ni * 3 + 1], -halfHeight);
                builder.add(on, b, a);
            }
            if (bottomCap) {
                _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_1__["Vec3"].set(a, points[i * 3], points[i * 3 + 1], halfHeight);
                _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_1__["Vec3"].set(b, points[ni * 3], points[ni * 3 + 1], halfHeight);
                builder.add(a, b, op);
            }
        }
    }
    return builder.getPrimitive();
}
var diamond;
function DiamondPrism() {
    if (!diamond)
        diamond = Prism(Object(_polygon__WEBPACK_IMPORTED_MODULE_3__["polygon"])(4, false));
    return diamond;
}
var pentagonalPrism;
function PentagonalPrism() {
    if (!pentagonalPrism)
        pentagonalPrism = Prism(Object(_polygon__WEBPACK_IMPORTED_MODULE_3__["polygon"])(5, false));
    return pentagonalPrism;
}
var hexagonalPrism;
function HexagonalPrism() {
    if (!hexagonalPrism)
        hexagonalPrism = Prism(Object(_polygon__WEBPACK_IMPORTED_MODULE_3__["polygon"])(6, false));
    return hexagonalPrism;
}
var shiftedHexagonalPrism;
function ShiftedHexagonalPrism() {
    if (!shiftedHexagonalPrism)
        shiftedHexagonalPrism = Prism(Object(_polygon__WEBPACK_IMPORTED_MODULE_3__["polygon"])(6, true));
    return shiftedHexagonalPrism;
}
var heptagonalPrism;
function HeptagonalPrism() {
    if (!heptagonalPrism)
        heptagonalPrism = Prism(Object(_polygon__WEBPACK_IMPORTED_MODULE_3__["polygon"])(7, false));
    return heptagonalPrism;
}
//
/**
 * Create a prism cage
 */
function PrismCage(points, height) {
    if (height === void 0) { height = 1; }
    var sideCount = points.length / 3;
    var vertices = [];
    var edges = [];
    var halfHeight = height * 0.5;
    var offset = 0;
    // vertices and side edges
    for (var i = 0; i < sideCount; ++i) {
        vertices.push(points[i * 3], points[i * 3 + 1], -halfHeight, points[i * 3], points[i * 3 + 1], halfHeight);
        edges.push(offset, offset + 1);
        offset += 2;
    }
    // bases edges
    for (var i = 0; i < sideCount; ++i) {
        var ni = (i + 1) % sideCount;
        edges.push(i * 2, ni * 2, i * 2 + 1, ni * 2 + 1);
    }
    return { vertices: vertices, edges: edges };
}
var diamondCage;
function DiamondPrismCage() {
    if (!diamondCage)
        diamondCage = PrismCage(Object(_polygon__WEBPACK_IMPORTED_MODULE_3__["polygon"])(4, false));
    return diamondCage;
}
var pentagonalPrismCage;
function PentagonalPrismCage() {
    if (!pentagonalPrismCage)
        pentagonalPrismCage = PrismCage(Object(_polygon__WEBPACK_IMPORTED_MODULE_3__["polygon"])(5, false));
    return pentagonalPrismCage;
}
var hexagonalPrismCage;
function HexagonalPrismCage() {
    if (!hexagonalPrismCage)
        hexagonalPrismCage = PrismCage(Object(_polygon__WEBPACK_IMPORTED_MODULE_3__["polygon"])(6, false));
    return hexagonalPrismCage;
}
//# sourceMappingURL=prism.js.map

/***/ }),

/***/ "./lib/mol-geo/primitive/pyramid.js":
/*!******************************************!*\
  !*** ./lib/mol-geo/primitive/pyramid.js ***!
  \******************************************/
/*! exports provided: Pyramid, TriangularPyramid, OctagonalPyramid, PerforatedOctagonalPyramid, PyramidCage, OctagonalPyramidCage */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Pyramid", function() { return Pyramid; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "TriangularPyramid", function() { return TriangularPyramid; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "OctagonalPyramid", function() { return OctagonalPyramid; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "PerforatedOctagonalPyramid", function() { return PerforatedOctagonalPyramid; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "PyramidCage", function() { return PyramidCage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "OctagonalPyramidCage", function() { return OctagonalPyramidCage; });
/* harmony import */ var _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../mol-math/linear-algebra */ "./lib/mol-math/linear-algebra.js");
/* harmony import */ var _primitive__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./primitive */ "./lib/mol-geo/primitive/primitive.js");
/* harmony import */ var _polygon__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./polygon */ "./lib/mol-geo/primitive/polygon.js");
/**
 * Copyright (c) 2018-2020 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */



var on = _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"].create(0, 0, -0.5), op = _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"].create(0, 0, 0.5);
var a = Object(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"])(), b = Object(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"])(), c = Object(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"])(), d = Object(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"])();
/**
 * Create a pyramid with a polygonal base
 */
function Pyramid(points) {
    var sideCount = points.length / 3;
    var baseCount = sideCount === 3 ? 1 : sideCount === 4 ? 2 : sideCount;
    var triangleCount = baseCount + sideCount;
    var vertexCount = sideCount === 4 ? (sideCount * 3 + 4) : triangleCount * 3;
    var builder = Object(_primitive__WEBPACK_IMPORTED_MODULE_1__["PrimitiveBuilder"])(triangleCount, vertexCount);
    // create sides
    for (var i = 0; i < sideCount; ++i) {
        var ni = (i + 1) % sideCount;
        _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"].set(a, points[i * 3], points[i * 3 + 1], -0.5);
        _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"].set(b, points[ni * 3], points[ni * 3 + 1], -0.5);
        builder.add(a, b, op);
    }
    // create base
    if (sideCount === 3) {
        _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"].set(a, points[0], points[1], -0.5);
        _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"].set(b, points[3], points[4], -0.5);
        _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"].set(c, points[6], points[7], -0.5);
        builder.add(c, b, a);
    }
    else if (sideCount === 4) {
        _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"].set(a, points[0], points[1], -0.5);
        _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"].set(b, points[3], points[4], -0.5);
        _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"].set(c, points[6], points[7], -0.5);
        _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"].set(d, points[9], points[10], -0.5);
        builder.addQuad(d, c, b, a);
    }
    else {
        for (var i = 0; i < sideCount; ++i) {
            var ni = (i + 1) % sideCount;
            _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"].set(a, points[i * 3], points[i * 3 + 1], -0.5);
            _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"].set(b, points[ni * 3], points[ni * 3 + 1], -0.5);
            builder.add(on, b, a);
        }
    }
    return builder.getPrimitive();
}
var triangularPyramid;
function TriangularPyramid() {
    if (!triangularPyramid)
        triangularPyramid = Pyramid(Object(_polygon__WEBPACK_IMPORTED_MODULE_2__["polygon"])(3, true));
    return triangularPyramid;
}
var octagonalPyramid;
function OctagonalPyramid() {
    if (!octagonalPyramid)
        octagonalPyramid = Pyramid(Object(_polygon__WEBPACK_IMPORTED_MODULE_2__["polygon"])(8, true));
    return octagonalPyramid;
}
var perforatedOctagonalPyramid;
function PerforatedOctagonalPyramid() {
    if (!perforatedOctagonalPyramid) {
        var points = Object(_polygon__WEBPACK_IMPORTED_MODULE_2__["polygon"])(8, true);
        var vertices = new Float32Array(8 * 3 + 6);
        for (var i = 0; i < 8; ++i) {
            vertices[i * 3] = points[i * 3];
            vertices[i * 3 + 1] = points[i * 3 + 1];
            vertices[i * 3 + 2] = -0.5;
        }
        vertices[8 * 3] = 0;
        vertices[8 * 3 + 1] = 0;
        vertices[8 * 3 + 2] = -0.5;
        vertices[8 * 3 + 3] = 0;
        vertices[8 * 3 + 4] = 0;
        vertices[8 * 3 + 5] = 0.5;
        var indices = [
            0, 1, 8, 1, 2, 8, 4, 5, 8, 5, 6, 8,
            2, 3, 9, 3, 4, 9, 6, 7, 9, 7, 0, 9
        ];
        perforatedOctagonalPyramid = Object(_primitive__WEBPACK_IMPORTED_MODULE_1__["createPrimitive"])(vertices, indices);
    }
    return perforatedOctagonalPyramid;
}
//
/**
 * Create a prism cage
 */
function PyramidCage(points) {
    var sideCount = points.length / 3;
    // const count = 4 * sideCount
    var vertices = [];
    var edges = [];
    var offset = 1;
    vertices.push(op[0], op[1], op[2]);
    // vertices and side edges
    for (var i = 0; i < sideCount; ++i) {
        vertices.push(points[i * 3], points[i * 3 + 1], -0.5);
        edges.push(0, offset);
        offset += 1;
    }
    // bases edges
    for (var i = 0; i < sideCount; ++i) {
        var ni = (i + 1) % sideCount;
        edges.push(i + 1, ni + 1);
    }
    return { vertices: vertices, edges: edges };
}
var octagonalPyramidCage;
function OctagonalPyramidCage() {
    if (!octagonalPyramidCage)
        octagonalPyramidCage = PyramidCage(Object(_polygon__WEBPACK_IMPORTED_MODULE_2__["polygon"])(8, true));
    return octagonalPyramidCage;
}
//# sourceMappingURL=pyramid.js.map

/***/ }),

/***/ "./lib/mol-geo/primitive/sphere.js":
/*!*****************************************!*\
  !*** ./lib/mol-geo/primitive/sphere.js ***!
  \*****************************************/
/*! exports provided: sphereVertexCount, Sphere */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "sphereVertexCount", function() { return sphereVertexCount; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Sphere", function() { return Sphere; });
/* harmony import */ var _polyhedron__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./polyhedron */ "./lib/mol-geo/primitive/polyhedron.js");
/* harmony import */ var _icosahedron__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./icosahedron */ "./lib/mol-geo/primitive/icosahedron.js");
/**
 * Copyright (c) 2018 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */


var _a = Object(_icosahedron__WEBPACK_IMPORTED_MODULE_1__["Icosahedron"])(), vertices = _a.vertices, indices = _a.indices;
/** Calculate vertex count for subdived icosahedron */
function sphereVertexCount(detail) {
    return 10 * Math.pow(Math.pow(2, detail), 2) + 2;
}
/** Create sphere by subdividing an icosahedron */
function Sphere(detail) {
    return Object(_polyhedron__WEBPACK_IMPORTED_MODULE_0__["Polyhedron"])(vertices, indices, { detail: detail, radius: 1 });
}
//# sourceMappingURL=sphere.js.map

/***/ }),

/***/ "./lib/mol-geo/primitive/star.js":
/*!***************************************!*\
  !*** ./lib/mol-geo/primitive/star.js ***!
  \***************************************/
/*! exports provided: DefaultStarProps, Star */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DefaultStarProps", function() { return DefaultStarProps; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Star", function() { return Star; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../mol-math/linear-algebra */ "./lib/mol-math/linear-algebra.js");
/* harmony import */ var _primitive__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./primitive */ "./lib/mol-geo/primitive/primitive.js");
/**
 * Copyright (c) 2018 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */



var DefaultStarProps = {
    pointCount: 5,
    outerRadius: 1,
    innerRadius: 0.5,
    thickness: 0.3
};
var op = _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_1__["Vec3"].zero(), on = _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_1__["Vec3"].zero();
var a = _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_1__["Vec3"].zero(), b = _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_1__["Vec3"].zero(), c = _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_1__["Vec3"].zero();
function Star(props) {
    var _a = Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, DefaultStarProps), props), outerRadius = _a.outerRadius, innerRadius = _a.innerRadius, thickness = _a.thickness, pointCount = _a.pointCount;
    var triangleCount = pointCount * 2 * 2;
    var builder = Object(_primitive__WEBPACK_IMPORTED_MODULE_2__["PrimitiveBuilder"])(triangleCount);
    var innerPoints = new Float32Array(pointCount * 2);
    var outerPoints = new Float32Array(pointCount * 2);
    for (var i = 0; i < pointCount; ++i) {
        var io = i * 2, ii = i * 2 + 1;
        var co = (io + 1) / pointCount * Math.PI, ci = (ii + 1) / pointCount * Math.PI;
        outerPoints[io] = Math.cos(co) * outerRadius;
        outerPoints[ii] = Math.sin(co) * outerRadius;
        innerPoints[io] = Math.cos(ci) * innerRadius;
        innerPoints[ii] = Math.sin(ci) * innerRadius;
    }
    _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_1__["Vec3"].set(op, 0, 0, thickness / 2);
    _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_1__["Vec3"].set(on, 0, 0, -thickness / 2);
    for (var i = 0; i < pointCount; ++i) {
        var ni = (i + 1) % pointCount;
        _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_1__["Vec3"].set(a, outerPoints[i * 2], outerPoints[i * 2 + 1], 0);
        _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_1__["Vec3"].set(b, innerPoints[i * 2], innerPoints[i * 2 + 1], 0);
        _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_1__["Vec3"].set(c, outerPoints[ni * 2], outerPoints[ni * 2 + 1], 0);
        builder.add(op, a, b);
        builder.add(b, a, on);
        builder.add(op, b, c);
        builder.add(c, b, on);
    }
    return builder.getPrimitive();
}
//# sourceMappingURL=star.js.map

/***/ }),

/***/ "./lib/mol-geo/primitive/tetrahedron.js":
/*!**********************************************!*\
  !*** ./lib/mol-geo/primitive/tetrahedron.js ***!
  \**********************************************/
/*! exports provided: tetrahedronVertices, tetrahedronIndices, Tetrahedron, TetrahedronCage */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "tetrahedronVertices", function() { return tetrahedronVertices; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "tetrahedronIndices", function() { return tetrahedronIndices; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Tetrahedron", function() { return Tetrahedron; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "TetrahedronCage", function() { return TetrahedronCage; });
/* harmony import */ var _primitive__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./primitive */ "./lib/mol-geo/primitive/primitive.js");
/* harmony import */ var _cage__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./cage */ "./lib/mol-geo/primitive/cage.js");
/**
 * Copyright (c) 2019-2020 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */


var tetrahedronVertices = [
    0.5, 0.5, 0.5, -0.5, -0.5, 0.5, -0.5, 0.5, -0.5, 0.5, -0.5, -0.5
];
var tetrahedronIndices = [
    2, 1, 0, 0, 3, 2, 1, 3, 0, 2, 3, 1
];
var tetrahedronEdges = [
    0, 1, 1, 2, 2, 0,
    0, 3, 1, 3, 2, 3,
];
var tetrahedron;
function Tetrahedron() {
    if (!tetrahedron)
        tetrahedron = Object(_primitive__WEBPACK_IMPORTED_MODULE_0__["createPrimitive"])(tetrahedronVertices, tetrahedronIndices);
    return tetrahedron;
}
var tetrahedronCage = Object(_cage__WEBPACK_IMPORTED_MODULE_1__["createCage"])(tetrahedronVertices, tetrahedronEdges);
function TetrahedronCage() {
    return tetrahedronCage;
}
//# sourceMappingURL=tetrahedron.js.map

/***/ }),

/***/ "./lib/mol-geo/primitive/wedge.js":
/*!****************************************!*\
  !*** ./lib/mol-geo/primitive/wedge.js ***!
  \****************************************/
/*! exports provided: createWedge, Wedge, WedgeCage */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createWedge", function() { return createWedge; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Wedge", function() { return Wedge; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "WedgeCage", function() { return WedgeCage; });
/* harmony import */ var _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../mol-math/linear-algebra */ "./lib/mol-math/linear-algebra.js");
/* harmony import */ var _primitive__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./primitive */ "./lib/mol-geo/primitive/primitive.js");
/* harmony import */ var _polygon__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./polygon */ "./lib/mol-geo/primitive/polygon.js");
/* harmony import */ var _prism__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./prism */ "./lib/mol-geo/primitive/prism.js");
/**
 * Copyright (c) 2018-2019 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */




var a = _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"].zero(), b = _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"].zero(), c = _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"].zero(), d = _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"].zero();
var points = Object(_polygon__WEBPACK_IMPORTED_MODULE_2__["polygon"])(3, false);
/**
 * Create a prism with a triangular base
 */
function createWedge() {
    var builder = Object(_primitive__WEBPACK_IMPORTED_MODULE_1__["PrimitiveBuilder"])(8);
    // create sides
    for (var i = 0; i < 3; ++i) {
        var ni = (i + 1) % 3;
        _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"].set(a, points[i * 3], points[i * 3 + 1], -0.5);
        _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"].set(b, points[ni * 3], points[ni * 3 + 1], -0.5);
        _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"].set(c, points[ni * 3], points[ni * 3 + 1], 0.5);
        _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"].set(d, points[i * 3], points[i * 3 + 1], 0.5);
        builder.add(a, b, c);
        builder.add(c, d, a);
    }
    // create bases
    _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"].set(a, points[0], points[1], -0.5);
    _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"].set(b, points[3], points[4], -0.5);
    _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"].set(c, points[6], points[7], -0.5);
    builder.add(c, b, a);
    _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"].set(a, points[0], points[1], 0.5);
    _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"].set(b, points[3], points[4], 0.5);
    _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"].set(c, points[6], points[7], 0.5);
    builder.add(a, b, c);
    return builder.getPrimitive();
}
var wedge;
function Wedge() {
    if (!wedge)
        wedge = createWedge();
    return wedge;
}
var wedgeCage;
function WedgeCage() {
    if (!wedgeCage)
        wedgeCage = Object(_prism__WEBPACK_IMPORTED_MODULE_3__["PrismCage"])(points);
    return wedgeCage;
}
//# sourceMappingURL=wedge.js.map

/***/ }),

/***/ "./lib/mol-geo/util.js":
/*!*****************************!*\
  !*** ./lib/mol-geo/util.js ***!
  \*****************************/
/*! exports provided: normalizeVec3Array, transformPositionArray, transformDirectionArray, appplyRadius, computeIndexedVertexNormals, computeVertexNormals, createGroupMapping */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "normalizeVec3Array", function() { return normalizeVec3Array; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "transformPositionArray", function() { return transformPositionArray; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "transformDirectionArray", function() { return transformDirectionArray; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "appplyRadius", function() { return appplyRadius; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "computeIndexedVertexNormals", function() { return computeIndexedVertexNormals; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "computeVertexNormals", function() { return computeVertexNormals; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createGroupMapping", function() { return createGroupMapping; });
/* harmony import */ var _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../mol-math/linear-algebra */ "./lib/mol-math/linear-algebra.js");
/* harmony import */ var _mol_util_array__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../mol-util/array */ "./lib/mol-util/array.js");
/**
 * Copyright (c) 2018-2020 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */


function normalizeVec3Array(a, count) {
    for (var i = 0, il = count * 3; i < il; i += 3) {
        var x = a[i];
        var y = a[i + 1];
        var z = a[i + 2];
        var s = 1 / Math.sqrt(x * x + y * y + z * z);
        a[i] = x * s;
        a[i + 1] = y * s;
        a[i + 2] = z * s;
    }
    return a;
}
var tmpV3 = Object(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"])();
function transformPositionArray(t, array, offset, count) {
    for (var i = 0, il = count * 3; i < il; i += 3) {
        _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"].fromArray(tmpV3, array, offset + i);
        _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"].transformMat4(tmpV3, tmpV3, t);
        _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"].toArray(tmpV3, array, offset + i);
    }
}
function transformDirectionArray(n, array, offset, count) {
    for (var i = 0, il = count * 3; i < il; i += 3) {
        _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"].fromArray(tmpV3, array, offset + i);
        _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"].transformMat3(tmpV3, tmpV3, n);
        _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"].toArray(tmpV3, array, offset + i);
    }
}
/** iterate over the entire array and apply the radius to each vertex */
function appplyRadius(vertices, radius) {
    for (var i = 0, il = vertices.length; i < il; i += 3) {
        _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"].fromArray(tmpV3, vertices, i);
        _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"].normalize(tmpV3, tmpV3);
        _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"].scale(tmpV3, tmpV3, radius);
        _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"].toArray(tmpV3, vertices, i);
    }
}
var a = Object(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"])();
var b = Object(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"])();
var c = Object(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"])();
var cb = Object(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"])();
var ab = Object(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"])();
/**
 * indexed vertex normals weighted by triangle areas
 *      http://www.iquilezles.org/www/articles/normals/normals.htm
 * - normals array must contain only zeros
 */
function computeIndexedVertexNormals(vertices, indices, normals, vertexCount, triangleCount) {
    for (var i = 0, il = triangleCount * 3; i < il; i += 3) {
        var ai = indices[i] * 3;
        var bi = indices[i + 1] * 3;
        var ci = indices[i + 2] * 3;
        _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"].fromArray(a, vertices, ai);
        _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"].fromArray(b, vertices, bi);
        _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"].fromArray(c, vertices, ci);
        _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"].sub(cb, c, b);
        _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"].sub(ab, a, b);
        _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"].cross(cb, cb, ab);
        normals[ai] += cb[0];
        normals[ai + 1] += cb[1];
        normals[ai + 2] += cb[2];
        normals[bi] += cb[0];
        normals[bi + 1] += cb[1];
        normals[bi + 2] += cb[2];
        normals[ci] += cb[0];
        normals[ci + 1] += cb[1];
        normals[ci + 2] += cb[2];
    }
    return normalizeVec3Array(normals, vertexCount);
}
/**
 * vertex normals for unindexed triangle soup
 * - normals array must contain only zeros
 */
function computeVertexNormals(vertices, normals, vertexCount) {
    for (var i = 0, il = vertexCount * 3; i < il; i += 9) {
        _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"].fromArray(a, vertices, i);
        _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"].fromArray(b, vertices, i + 3);
        _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"].fromArray(c, vertices, i + 6);
        _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"].sub(cb, c, b);
        _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"].sub(ab, a, b);
        _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"].cross(cb, cb, ab);
        normals[i] = cb[0];
        normals[i + 1] = cb[1];
        normals[i + 2] = cb[2];
        normals[i + 3] = cb[0];
        normals[i + 4] = cb[1];
        normals[i + 5] = cb[2];
        normals[i + 6] = cb[0];
        normals[i + 7] = cb[1];
        normals[i + 8] = cb[2];
    }
    return normalizeVec3Array(normals, vertexCount);
}
/**
 * The `step` parameter allows to skip over repeated values in `groups`
 */
function createGroupMapping(groups, dataCount, step) {
    if (step === void 0) { step = 1; }
    var maxId = Object(_mol_util_array__WEBPACK_IMPORTED_MODULE_1__["arrayMax"])(groups);
    var offsets = new Int32Array(maxId + 2);
    var bucketFill = new Int32Array(dataCount);
    var bucketSizes = new Int32Array(dataCount);
    for (var i = 0, il = dataCount * step; i < il; i += step)
        ++bucketSizes[groups[i]];
    var offset = 0;
    for (var i = 0; i < dataCount; i++) {
        offsets[i] = offset;
        offset += bucketSizes[i];
    }
    offsets[dataCount] = offset;
    var indices = new Int32Array(offset);
    for (var i = 0, il = dataCount * step; i < il; i += step) {
        var g = groups[i];
        var og = offsets[g] + bucketFill[g];
        indices[og] = i;
        ++bucketFill[g];
    }
    return { indices: indices, offsets: offsets };
}
//# sourceMappingURL=util.js.map

/***/ }),

/***/ "./lib/mol-geo/util/location-iterator.js":
/*!***********************************************!*\
  !*** ./lib/mol-geo/util/location-iterator.js ***!
  \***********************************************/
/*! exports provided: LocationIterator, PositionLocation, isPositionLocation */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "LocationIterator", function() { return LocationIterator; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "PositionLocation", function() { return PositionLocation; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isPositionLocation", function() { return isPositionLocation; });
/* harmony import */ var _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../mol-math/linear-algebra */ "./lib/mol-math/linear-algebra.js");
/* harmony import */ var _mol_model_location__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../mol-model/location */ "./lib/mol-model/location.js");
/**
 * Copyright (c) 2018-2020 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */


function LocationIterator(groupCount, instanceCount, stride, getLocation, nonInstanceable, isSecondary) {
    if (nonInstanceable === void 0) { nonInstanceable = false; }
    if (isSecondary === void 0) { isSecondary = function () { return false; }; }
    if (groupCount % stride !== 0) {
        throw new Error('incompatible groupCount and stride');
    }
    var value = {
        location: _mol_model_location__WEBPACK_IMPORTED_MODULE_1__["NullLocation"],
        index: 0,
        groupIndex: 0,
        instanceIndex: 0,
        isSecondary: false
    };
    var hasNext = value.groupIndex < groupCount;
    var isNextNewInstance = false;
    var groupIndex = 0;
    var instanceIndex = 0;
    var voidInstances = false;
    return {
        get hasNext() { return hasNext; },
        get isNextNewInstance() { return isNextNewInstance; },
        groupCount: groupCount,
        instanceCount: instanceCount,
        count: groupCount * instanceCount,
        stride: stride,
        nonInstanceable: nonInstanceable,
        move: function () {
            if (hasNext) {
                value.groupIndex = groupIndex;
                value.instanceIndex = instanceIndex;
                value.index = instanceIndex * groupCount + groupIndex;
                value.location = getLocation(groupIndex, voidInstances ? -1 : instanceIndex);
                value.isSecondary = isSecondary(groupIndex, voidInstances ? -1 : instanceIndex);
                groupIndex += stride;
                if (groupIndex === groupCount) {
                    ++instanceIndex;
                    isNextNewInstance = true;
                    if (instanceIndex < instanceCount)
                        groupIndex = 0;
                }
                else {
                    isNextNewInstance = false;
                }
                hasNext = groupIndex < groupCount;
            }
            return value;
        },
        reset: function () {
            value.location = _mol_model_location__WEBPACK_IMPORTED_MODULE_1__["NullLocation"];
            value.index = 0;
            value.groupIndex = 0;
            value.instanceIndex = 0;
            value.isSecondary = false;
            hasNext = value.groupIndex < groupCount;
            isNextNewInstance = false;
            groupIndex = 0;
            instanceIndex = 0;
            voidInstances = false;
        },
        skipInstance: function () {
            if (hasNext && value.instanceIndex === instanceIndex) {
                ++instanceIndex;
                groupIndex = 0;
                hasNext = instanceIndex < instanceCount;
            }
        },
        voidInstances: function () {
            voidInstances = true;
        }
    };
}
function PositionLocation(position) {
    return { kind: 'position-location', position: position ? _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"].clone(position) : Object(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"])() };
}
function isPositionLocation(x) {
    return !!x && x.kind === 'position-location';
}
//# sourceMappingURL=location-iterator.js.map

/***/ }),

/***/ "./lib/mol-geo/util/marching-cubes/algorithm.js":
/*!******************************************************!*\
  !*** ./lib/mol-geo/util/marching-cubes/algorithm.js ***!
  \******************************************************/
/*! exports provided: computeMarchingCubesMesh, computeMarchingCubesLines */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "computeMarchingCubesMesh", function() { return computeMarchingCubesMesh; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "computeMarchingCubesLines", function() { return computeMarchingCubesLines; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _mol_task__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../../mol-task */ "./lib/mol-task/index.js");
/* harmony import */ var _tables__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./tables */ "./lib/mol-geo/util/marching-cubes/tables.js");
/* harmony import */ var _mol_util__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../../mol-util */ "./lib/mol-util/index.js");
/* harmony import */ var _builder__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./builder */ "./lib/mol-geo/util/marching-cubes/builder.js");
/**
 * Copyright (c) 2018-2020 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author David Sehnal <david.sehnal@gmail.com>
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */





function getInputParams(params) {
    return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, params), { bottomLeft: Object(_mol_util__WEBPACK_IMPORTED_MODULE_3__["defaults"])(params.bottomLeft, [0, 0, 0]), topRight: Object(_mol_util__WEBPACK_IMPORTED_MODULE_3__["defaults"])(params.topRight, params.scalarField.space.dimensions) });
}
function getExtent(inputParams) {
    return {
        dX: inputParams.topRight[0] - inputParams.bottomLeft[0],
        dY: inputParams.topRight[1] - inputParams.bottomLeft[1],
        dZ: inputParams.topRight[2] - inputParams.bottomLeft[2]
    };
}
function computeMarchingCubesMesh(params, mesh) {
    var _this = this;
    return _mol_task__WEBPACK_IMPORTED_MODULE_1__["Task"].create('Marching Cubes Mesh', function (ctx) { return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"])(_this, void 0, void 0, function () {
        var inputParams, _a, dX, dY, dZ, vertexChunkSize, builder;
        return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__generator"])(this, function (_b) {
            switch (_b.label) {
                case 0:
                    inputParams = getInputParams(params);
                    _a = getExtent(inputParams), dX = _a.dX, dY = _a.dY, dZ = _a.dZ;
                    vertexChunkSize = Math.min(262144, Math.max(dX * dY * dZ / 32, 1024));
                    builder = Object(_builder__WEBPACK_IMPORTED_MODULE_4__["MarchinCubesMeshBuilder"])(vertexChunkSize, mesh);
                    return [4 /*yield*/, (new MarchingCubesComputation(ctx, builder, inputParams)).run()];
                case 1:
                    _b.sent();
                    return [2 /*return*/, builder.get()];
            }
        });
    }); });
}
function computeMarchingCubesLines(params, lines) {
    var _this = this;
    return _mol_task__WEBPACK_IMPORTED_MODULE_1__["Task"].create('Marching Cubes Lines', function (ctx) { return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"])(_this, void 0, void 0, function () {
        var inputParams, _a, dX, dY, dZ, vertexChunkSize, builder;
        return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__generator"])(this, function (_b) {
            switch (_b.label) {
                case 0:
                    inputParams = getInputParams(params);
                    _a = getExtent(inputParams), dX = _a.dX, dY = _a.dY, dZ = _a.dZ;
                    vertexChunkSize = Math.min(262144, Math.max(dX * dY * dZ / 32, 1024));
                    builder = Object(_builder__WEBPACK_IMPORTED_MODULE_4__["MarchinCubesLinesBuilder"])(vertexChunkSize, lines);
                    return [4 /*yield*/, (new MarchingCubesComputation(ctx, builder, inputParams)).run()];
                case 1:
                    _b.sent();
                    return [2 /*return*/, builder.get()];
            }
        });
    }); });
}
var MarchingCubesComputation = /** @class */ (function () {
    function MarchingCubesComputation(ctx, builder, params) {
        this.ctx = ctx;
        this.minX = 0;
        this.minY = 0;
        this.minZ = 0;
        this.maxX = 0;
        this.maxY = 0;
        this.maxZ = 0;
        this.state = new MarchingCubesState(builder, params);
        this.minX = params.bottomLeft[0];
        this.minY = params.bottomLeft[1];
        this.minZ = params.bottomLeft[2];
        this.maxX = params.topRight[0] - 1;
        this.maxY = params.topRight[1] - 1;
        this.maxZ = params.topRight[2] - 1;
        this.size = (this.maxX - this.minX) * (this.maxY - this.minY) * (this.maxZ - this.minZ);
        this.sliceSize = (this.maxX - this.minX) * (this.maxY - this.minY);
    }
    MarchingCubesComputation.prototype.doSlices = function () {
        return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"])(this, void 0, void 0, function () {
            var done, k;
            return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__generator"])(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        done = 0;
                        this.edgeFilter = 15;
                        k = this.minZ;
                        _a.label = 1;
                    case 1:
                        if (!(k < this.maxZ)) return [3 /*break*/, 4];
                        this.slice(k);
                        done += this.sliceSize;
                        if (!this.ctx.shouldUpdate) return [3 /*break*/, 3];
                        return [4 /*yield*/, this.ctx.update({ message: 'Computing surface...', current: done, max: this.size })];
                    case 2:
                        _a.sent();
                        _a.label = 3;
                    case 3:
                        k++, this.edgeFilter &= ~4;
                        return [3 /*break*/, 1];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    MarchingCubesComputation.prototype.slice = function (k) {
        this.edgeFilter |= 2;
        for (var j = this.minY; j < this.maxY; j++, this.edgeFilter &= ~2) {
            this.edgeFilter |= 1;
            for (var i = this.minX; i < this.maxX; i++, this.edgeFilter &= ~1) {
                this.state.processCell(i, j, k, this.edgeFilter);
            }
        }
        this.state.clearEdgeVertexIndexSlice(k);
    };
    MarchingCubesComputation.prototype.run = function () {
        return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"])(this, void 0, void 0, function () {
            return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__generator"])(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.doSlices()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    return MarchingCubesComputation;
}());
var MarchingCubesState = /** @class */ (function () {
    function MarchingCubesState(builder, params) {
        this.builder = builder;
        this.vertList = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
        this.i = 0;
        this.j = 0;
        this.k = 0;
        var dims = params.scalarField.space.dimensions;
        this.nX = dims[0];
        this.nY = dims[1];
        this.nZ = dims[2];
        this.isoLevel = params.isoLevel;
        this.scalarFieldGet = params.scalarField.space.get;
        this.scalarField = params.scalarField.data;
        if (params.idField) {
            this.idField = params.idField.data;
            this.idFieldGet = params.idField.space.get;
        }
        // two layers of vertex indices. Each vertex has 3 edges associated.
        this.verticesOnEdges = new Int32Array(3 * this.nX * this.nY * 2);
    }
    MarchingCubesState.prototype.get3dOffsetFromEdgeInfo = function (index) {
        return (this.nX * (((this.k + index.k) % 2) * this.nY + this.j + index.j) + this.i + index.i);
    };
    /**
     * This clears the "vertex index buffer" for the slice that will not be accessed anymore.
     */
    MarchingCubesState.prototype.clearEdgeVertexIndexSlice = function (k) {
        // clear either the top or bottom half of the buffer...
        var start = k % 2 === 0 ? 0 : 3 * this.nX * this.nY;
        var end = k % 2 === 0 ? 3 * this.nX * this.nY : this.verticesOnEdges.length;
        this.verticesOnEdges.fill(0, start, end);
    };
    MarchingCubesState.prototype.interpolate = function (edgeNum) {
        var info = _tables__WEBPACK_IMPORTED_MODULE_2__["EdgeIdInfo"][edgeNum];
        var edgeId = 3 * this.get3dOffsetFromEdgeInfo(info) + info.e;
        var ret = this.verticesOnEdges[edgeId];
        if (ret > 0)
            return ret - 1;
        var sf = this.scalarField;
        var sfg = this.scalarFieldGet;
        var edge = _tables__WEBPACK_IMPORTED_MODULE_2__["CubeEdges"][edgeNum];
        var a = edge.a, b = edge.b;
        var li = a.i + this.i, lj = a.j + this.j, lk = a.k + this.k;
        var hi = b.i + this.i, hj = b.j + this.j, hk = b.k + this.k;
        var v0 = sfg(sf, li, lj, lk);
        var v1 = sfg(sf, hi, hj, hk);
        var t = (this.isoLevel - v0) / (v0 - v1);
        if (this.idField) {
            var u = this.idFieldGet(this.idField, li, lj, lk);
            var v = this.idFieldGet(this.idField, hi, hj, hk);
            var a_1 = t < 0.5 ? u : v;
            // -1 means 'no id', check if the other cell has an id
            if (a_1 === -1)
                a_1 = t < 0.5 ? v : u;
            // -2 means 'ignore this cell'
            if (a_1 === -2)
                return -1;
            this.builder.addGroup(a_1);
        }
        else {
            this.builder.addGroup(0);
        }
        var id = this.builder.addVertex(li + t * (li - hi), lj + t * (lj - hj), lk + t * (lk - hk));
        this.verticesOnEdges[edgeId] = id + 1;
        // TODO cache scalarField differences for slices
        // TODO make calculation optional
        var n0x = sfg(sf, Math.max(0, li - 1), lj, lk) - sfg(sf, Math.min(this.nX - 1, li + 1), lj, lk);
        var n0y = sfg(sf, li, Math.max(0, lj - 1), lk) - sfg(sf, li, Math.min(this.nY - 1, lj + 1), lk);
        var n0z = sfg(sf, li, lj, Math.max(0, lk - 1)) - sfg(sf, li, lj, Math.min(this.nZ, lk + 1));
        var n1x = sfg(sf, Math.max(0, hi - 1), hj, hk) - sfg(sf, Math.min(this.nX - 1, hi + 1), hj, hk);
        var n1y = sfg(sf, hi, Math.max(0, hj - 1), hk) - sfg(sf, hi, Math.min(this.nY - 1, hj + 1), hk);
        var n1z = sfg(sf, hi, hj, Math.max(0, hk - 1)) - sfg(sf, hi, hj, Math.min(this.nZ - 1, hk + 1));
        var nx = n0x + t * (n0x - n1x);
        var ny = n0y + t * (n0y - n1y);
        var nz = n0z + t * (n0z - n1z);
        // ensure normal-direction is the same for negative and positive iso-levels
        if (this.isoLevel >= 0) {
            this.builder.addNormal(nx, ny, nz);
        }
        else {
            this.builder.addNormal(-nx, -ny, -nz);
        }
        return id;
    };
    MarchingCubesState.prototype.get = function (i, j, k) {
        return this.scalarFieldGet(this.scalarField, i, j, k);
    };
    MarchingCubesState.prototype.processCell = function (i, j, k, edgeFilter) {
        var tableIndex = 0;
        if (this.get(i, j, k) < this.isoLevel)
            tableIndex |= 1;
        if (this.get(i + 1, j, k) < this.isoLevel)
            tableIndex |= 2;
        if (this.get(i + 1, j + 1, k) < this.isoLevel)
            tableIndex |= 4;
        if (this.get(i, j + 1, k) < this.isoLevel)
            tableIndex |= 8;
        if (this.get(i, j, k + 1) < this.isoLevel)
            tableIndex |= 16;
        if (this.get(i + 1, j, k + 1) < this.isoLevel)
            tableIndex |= 32;
        if (this.get(i + 1, j + 1, k + 1) < this.isoLevel)
            tableIndex |= 64;
        if (this.get(i, j + 1, k + 1) < this.isoLevel)
            tableIndex |= 128;
        if (tableIndex === 0 || tableIndex === 255)
            return;
        this.i = i;
        this.j = j;
        this.k = k;
        var edgeInfo = _tables__WEBPACK_IMPORTED_MODULE_2__["EdgeTable"][tableIndex];
        if ((edgeInfo & 1) > 0)
            this.vertList[0] = this.interpolate(0); // 0 1
        if ((edgeInfo & 2) > 0)
            this.vertList[1] = this.interpolate(1); // 1 2
        if ((edgeInfo & 4) > 0)
            this.vertList[2] = this.interpolate(2); // 2 3
        if ((edgeInfo & 8) > 0)
            this.vertList[3] = this.interpolate(3); // 0 3
        if ((edgeInfo & 16) > 0)
            this.vertList[4] = this.interpolate(4); // 4 5
        if ((edgeInfo & 32) > 0)
            this.vertList[5] = this.interpolate(5); // 5 6
        if ((edgeInfo & 64) > 0)
            this.vertList[6] = this.interpolate(6); // 6 7
        if ((edgeInfo & 128) > 0)
            this.vertList[7] = this.interpolate(7); // 4 7
        if ((edgeInfo & 256) > 0)
            this.vertList[8] = this.interpolate(8); // 0 4
        if ((edgeInfo & 512) > 0)
            this.vertList[9] = this.interpolate(9); // 1 5
        if ((edgeInfo & 1024) > 0)
            this.vertList[10] = this.interpolate(10); // 2 6
        if ((edgeInfo & 2048) > 0)
            this.vertList[11] = this.interpolate(11); // 3 7
        var triInfo = _tables__WEBPACK_IMPORTED_MODULE_2__["TriTable"][tableIndex];
        for (var t = 0; t < triInfo.length; t += 3) {
            var l = triInfo[t], m = triInfo[t + 1], n = triInfo[t + 2];
            // ensure winding-order is the same for negative and positive iso-levels
            if (this.isoLevel >= 0) {
                this.builder.addTriangle(this.vertList, l, m, n, edgeFilter);
            }
            else {
                this.builder.addTriangle(this.vertList, n, m, l, edgeFilter);
            }
        }
    };
    return MarchingCubesState;
}());
//# sourceMappingURL=algorithm.js.map

/***/ }),

/***/ "./lib/mol-geo/util/marching-cubes/builder.js":
/*!****************************************************!*\
  !*** ./lib/mol-geo/util/marching-cubes/builder.js ***!
  \****************************************************/
/*! exports provided: MarchinCubesMeshBuilder, MarchinCubesLinesBuilder */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MarchinCubesMeshBuilder", function() { return MarchinCubesMeshBuilder; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MarchinCubesLinesBuilder", function() { return MarchinCubesLinesBuilder; });
/* harmony import */ var _mol_data_util__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../../mol-data/util */ "./lib/mol-data/util.js");
/* harmony import */ var _mol_util__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../../mol-util */ "./lib/mol-util/index.js");
/* harmony import */ var _geometry_mesh_mesh__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../geometry/mesh/mesh */ "./lib/mol-geo/geometry/mesh/mesh.js");
/* harmony import */ var _tables__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./tables */ "./lib/mol-geo/util/marching-cubes/tables.js");
/* harmony import */ var _geometry_lines_lines_builder__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../geometry/lines/lines-builder */ "./lib/mol-geo/geometry/lines/lines-builder.js");
/**
 * Copyright (c) 2018-2020 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 * @author David Sehnal <david.sehnal@gmail.com>
 * @author Fred Ludlow <fred.ludlow@gmail.com>
 */





function MarchinCubesMeshBuilder(vertexChunkSize, mesh) {
    var triangleChunkSize = Math.min(1 << 16, vertexChunkSize * 4);
    var vertices = _mol_data_util__WEBPACK_IMPORTED_MODULE_0__["ChunkedArray"].create(Float32Array, 3, vertexChunkSize, mesh && mesh.vertexBuffer.ref.value);
    var normals = _mol_data_util__WEBPACK_IMPORTED_MODULE_0__["ChunkedArray"].create(Float32Array, 3, vertexChunkSize, mesh && mesh.normalBuffer.ref.value);
    var groups = _mol_data_util__WEBPACK_IMPORTED_MODULE_0__["ChunkedArray"].create(Float32Array, 1, vertexChunkSize, mesh && mesh.groupBuffer.ref.value);
    var indices = _mol_data_util__WEBPACK_IMPORTED_MODULE_0__["ChunkedArray"].create(Uint32Array, 3, triangleChunkSize, mesh && mesh.indexBuffer.ref.value);
    var vertexCount = 0;
    var triangleCount = 0;
    return {
        addVertex: function (x, y, z) {
            ++vertexCount;
            return _mol_data_util__WEBPACK_IMPORTED_MODULE_0__["ChunkedArray"].add3(vertices, x, y, z);
        },
        addNormal: function (x, y, z) {
            _mol_data_util__WEBPACK_IMPORTED_MODULE_0__["ChunkedArray"].add3(normals, x, y, z);
        },
        addGroup: function (group) {
            _mol_data_util__WEBPACK_IMPORTED_MODULE_0__["ChunkedArray"].add(groups, group);
        },
        addTriangle: function (vertList, a, b, c) {
            var i = vertList[a], j = vertList[b], k = vertList[c];
            // vertex indices <0 mean that the vertex was ignored and is not available
            // and hence we don't add a triangle when this occurs
            if (i >= 0 && j >= 0 && k >= 0) {
                ++triangleCount;
                _mol_data_util__WEBPACK_IMPORTED_MODULE_0__["ChunkedArray"].add3(indices, i, j, k);
            }
        },
        get: function () {
            var vb = _mol_data_util__WEBPACK_IMPORTED_MODULE_0__["ChunkedArray"].compact(vertices, true);
            var nb = _mol_data_util__WEBPACK_IMPORTED_MODULE_0__["ChunkedArray"].compact(normals, true);
            var ib = _mol_data_util__WEBPACK_IMPORTED_MODULE_0__["ChunkedArray"].compact(indices, true);
            var gb = _mol_data_util__WEBPACK_IMPORTED_MODULE_0__["ChunkedArray"].compact(groups, true);
            return _geometry_mesh_mesh__WEBPACK_IMPORTED_MODULE_2__["Mesh"].create(vb, ib, nb, gb, vertexCount, triangleCount, mesh);
        }
    };
}
function MarchinCubesLinesBuilder(vertexChunkSize, lines) {
    var vertices = _mol_data_util__WEBPACK_IMPORTED_MODULE_0__["ChunkedArray"].create(Float32Array, 3, vertexChunkSize);
    var groups = _mol_data_util__WEBPACK_IMPORTED_MODULE_0__["ChunkedArray"].create(Float32Array, 1, vertexChunkSize);
    var indices = _mol_data_util__WEBPACK_IMPORTED_MODULE_0__["ChunkedArray"].create(Float32Array, 2, vertexChunkSize);
    var linesCount = 0;
    return {
        addVertex: function (x, y, z) {
            return _mol_data_util__WEBPACK_IMPORTED_MODULE_0__["ChunkedArray"].add3(vertices, x, y, z);
        },
        addNormal: function () { return _mol_util__WEBPACK_IMPORTED_MODULE_1__["noop"]; },
        addGroup: function (group) {
            _mol_data_util__WEBPACK_IMPORTED_MODULE_0__["ChunkedArray"].add(groups, group);
        },
        addTriangle: function (vertList, a, b, c, edgeFilter) {
            var i = vertList[a], j = vertList[b], k = vertList[c];
            // vertex indices <0 mean that the vertex was ignored and is not available
            // and hence we don't add a triangle when this occurs
            if (i >= 0 && j >= 0 && k >= 0) {
                if (_tables__WEBPACK_IMPORTED_MODULE_3__["AllowedContours"][a][b] & edgeFilter) {
                    ++linesCount;
                    _mol_data_util__WEBPACK_IMPORTED_MODULE_0__["ChunkedArray"].add2(indices, vertList[a], vertList[b]);
                }
                if (_tables__WEBPACK_IMPORTED_MODULE_3__["AllowedContours"][b][c] & edgeFilter) {
                    ++linesCount;
                    _mol_data_util__WEBPACK_IMPORTED_MODULE_0__["ChunkedArray"].add2(indices, vertList[b], vertList[c]);
                }
                if (_tables__WEBPACK_IMPORTED_MODULE_3__["AllowedContours"][a][c] & edgeFilter) {
                    ++linesCount;
                    _mol_data_util__WEBPACK_IMPORTED_MODULE_0__["ChunkedArray"].add2(indices, vertList[a], vertList[c]);
                }
            }
        },
        get: function () {
            var vb = _mol_data_util__WEBPACK_IMPORTED_MODULE_0__["ChunkedArray"].compact(vertices, true);
            var ib = _mol_data_util__WEBPACK_IMPORTED_MODULE_0__["ChunkedArray"].compact(indices, true);
            var gb = _mol_data_util__WEBPACK_IMPORTED_MODULE_0__["ChunkedArray"].compact(groups, true);
            var builder = _geometry_lines_lines_builder__WEBPACK_IMPORTED_MODULE_4__["LinesBuilder"].create(linesCount, linesCount / 10, lines);
            for (var i = 0; i < linesCount; ++i) {
                var la = ib[i * 2], lb = ib[i * 2 + 1];
                builder.add(vb[la * 3], vb[la * 3 + 1], vb[la * 3 + 2], vb[lb * 3], vb[lb * 3 + 1], vb[lb * 3 + 2], gb[la]);
            }
            return builder.getLines();
        }
    };
}
//# sourceMappingURL=builder.js.map

/***/ }),

/***/ "./lib/mol-geo/util/marching-cubes/tables.js":
/*!***************************************************!*\
  !*** ./lib/mol-geo/util/marching-cubes/tables.js ***!
  \***************************************************/
/*! exports provided: Index, IndexPair, EdgesXY, EdgesXZ, EdgesYZ, CubeVertices, CubeEdges, EdgeIdInfo, EdgeTable, TriTable, AllowedContours */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Index", function() { return Index; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "IndexPair", function() { return IndexPair; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "EdgesXY", function() { return EdgesXY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "EdgesXZ", function() { return EdgesXZ; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "EdgesYZ", function() { return EdgesYZ; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CubeVertices", function() { return CubeVertices; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CubeEdges", function() { return CubeEdges; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "EdgeIdInfo", function() { return EdgeIdInfo; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "EdgeTable", function() { return EdgeTable; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "TriTable", function() { return TriTable; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "AllowedContours", function() { return AllowedContours; });
/**
 * Copyright (c) 2018 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author David Sehnal <david.sehnal@gmail.com>
 * @author Fred Ludlow <fred.ludlow@gmail.com>
 */
function Index(i, j, k) { return { i: i, j: j, k: k }; }
function IndexPair(a, b) { return { a: a, b: b }; }
var EdgesXY = [
    [],
    [0, 3],
    [0, 1],
    [1, 3],
    [1, 2],
    [0, 1, 1, 2, 2, 3, 0, 3],
    [0, 2],
    [2, 3],
    [2, 3],
    [0, 2],
    [0, 1, 1, 2, 2, 3, 0, 3],
    [1, 2],
    [1, 3],
    [0, 1],
    [0, 3],
    []
];
var EdgesXZ = [
    [],
    [0, 8],
    [0, 9],
    [9, 8],
    [9, 4],
    [0, 9, 9, 4, 4, 8, 0, 8],
    [0, 4],
    [4, 8],
    [4, 8],
    [0, 4],
    [0, 9, 9, 4, 4, 8, 0, 8],
    [9, 4],
    [9, 8],
    [0, 9],
    [0, 8],
    []
];
var EdgesYZ = [
    [],
    [3, 8],
    [3, 11],
    [11, 8],
    [11, 7],
    [3, 11, 11, 7, 7, 8, 3, 8],
    [3, 7],
    [7, 8],
    [7, 8],
    [3, 7],
    [3, 11, 11, 7, 7, 8, 3, 8],
    [11, 7],
    [11, 8],
    [3, 11],
    [3, 8],
    []
];
var CubeVertices = [
    Index(0, 0, 0),
    Index(1, 0, 0),
    Index(1, 1, 0),
    Index(0, 1, 0),
    Index(0, 0, 1),
    Index(1, 0, 1),
    Index(1, 1, 1),
    Index(0, 1, 1),
];
var CubeEdges = [
    IndexPair(CubeVertices[0], CubeVertices[1]),
    IndexPair(CubeVertices[1], CubeVertices[2]),
    IndexPair(CubeVertices[2], CubeVertices[3]),
    IndexPair(CubeVertices[3], CubeVertices[0]),
    IndexPair(CubeVertices[4], CubeVertices[5]),
    IndexPair(CubeVertices[5], CubeVertices[6]),
    IndexPair(CubeVertices[6], CubeVertices[7]),
    IndexPair(CubeVertices[7], CubeVertices[4]),
    IndexPair(CubeVertices[0], CubeVertices[4]),
    IndexPair(CubeVertices[1], CubeVertices[5]),
    IndexPair(CubeVertices[2], CubeVertices[6]),
    IndexPair(CubeVertices[3], CubeVertices[7]),
];
var EdgeIdInfo = [
    { i: 0, j: 0, k: 0, e: 0 },
    { i: 1, j: 0, k: 0, e: 1 },
    { i: 0, j: 1, k: 0, e: 0 },
    { i: 0, j: 0, k: 0, e: 1 },
    { i: 0, j: 0, k: 1, e: 0 },
    { i: 1, j: 0, k: 1, e: 1 },
    { i: 0, j: 1, k: 1, e: 0 },
    { i: 0, j: 0, k: 1, e: 1 },
    { i: 0, j: 0, k: 0, e: 2 },
    { i: 1, j: 0, k: 0, e: 2 },
    { i: 1, j: 1, k: 0, e: 2 },
    { i: 0, j: 1, k: 0, e: 2 }
];
// Tables EdgeTable and TriTable taken from http://paulbourke.net/geometry/polygonise/
var EdgeTable = [
    0x0, 0x109, 0x203, 0x30a, 0x406, 0x50f, 0x605, 0x70c,
    0x80c, 0x905, 0xa0f, 0xb06, 0xc0a, 0xd03, 0xe09, 0xf00,
    0x190, 0x99, 0x393, 0x29a, 0x596, 0x49f, 0x795, 0x69c,
    0x99c, 0x895, 0xb9f, 0xa96, 0xd9a, 0xc93, 0xf99, 0xe90,
    0x230, 0x339, 0x33, 0x13a, 0x636, 0x73f, 0x435, 0x53c,
    0xa3c, 0xb35, 0x83f, 0x936, 0xe3a, 0xf33, 0xc39, 0xd30,
    0x3a0, 0x2a9, 0x1a3, 0xaa, 0x7a6, 0x6af, 0x5a5, 0x4ac,
    0xbac, 0xaa5, 0x9af, 0x8a6, 0xfaa, 0xea3, 0xda9, 0xca0,
    0x460, 0x569, 0x663, 0x76a, 0x66, 0x16f, 0x265, 0x36c,
    0xc6c, 0xd65, 0xe6f, 0xf66, 0x86a, 0x963, 0xa69, 0xb60,
    0x5f0, 0x4f9, 0x7f3, 0x6fa, 0x1f6, 0xff, 0x3f5, 0x2fc,
    0xdfc, 0xcf5, 0xfff, 0xef6, 0x9fa, 0x8f3, 0xbf9, 0xaf0,
    0x650, 0x759, 0x453, 0x55a, 0x256, 0x35f, 0x55, 0x15c,
    0xe5c, 0xf55, 0xc5f, 0xd56, 0xa5a, 0xb53, 0x859, 0x950,
    0x7c0, 0x6c9, 0x5c3, 0x4ca, 0x3c6, 0x2cf, 0x1c5, 0xcc,
    0xfcc, 0xec5, 0xdcf, 0xcc6, 0xbca, 0xac3, 0x9c9, 0x8c0,
    0x8c0, 0x9c9, 0xac3, 0xbca, 0xcc6, 0xdcf, 0xec5, 0xfcc,
    0xcc, 0x1c5, 0x2cf, 0x3c6, 0x4ca, 0x5c3, 0x6c9, 0x7c0,
    0x950, 0x859, 0xb53, 0xa5a, 0xd56, 0xc5f, 0xf55, 0xe5c,
    0x15c, 0x55, 0x35f, 0x256, 0x55a, 0x453, 0x759, 0x650,
    0xaf0, 0xbf9, 0x8f3, 0x9fa, 0xef6, 0xfff, 0xcf5, 0xdfc,
    0x2fc, 0x3f5, 0xff, 0x1f6, 0x6fa, 0x7f3, 0x4f9, 0x5f0,
    0xb60, 0xa69, 0x963, 0x86a, 0xf66, 0xe6f, 0xd65, 0xc6c,
    0x36c, 0x265, 0x16f, 0x66, 0x76a, 0x663, 0x569, 0x460,
    0xca0, 0xda9, 0xea3, 0xfaa, 0x8a6, 0x9af, 0xaa5, 0xbac,
    0x4ac, 0x5a5, 0x6af, 0x7a6, 0xaa, 0x1a3, 0x2a9, 0x3a0,
    0xd30, 0xc39, 0xf33, 0xe3a, 0x936, 0x83f, 0xb35, 0xa3c,
    0x53c, 0x435, 0x73f, 0x636, 0x13a, 0x33, 0x339, 0x230,
    0xe90, 0xf99, 0xc93, 0xd9a, 0xa96, 0xb9f, 0x895, 0x99c,
    0x69c, 0x795, 0x49f, 0x596, 0x29a, 0x393, 0x99, 0x190,
    0xf00, 0xe09, 0xd03, 0xc0a, 0xb06, 0xa0f, 0x905, 0x80c,
    0x70c, 0x605, 0x50f, 0x406, 0x30a, 0x203, 0x109, 0x0
];
var TriTable = [
    [],
    [0, 8, 3],
    [0, 1, 9],
    [1, 8, 3, 9, 8, 1],
    [1, 2, 10],
    [0, 8, 3, 1, 2, 10],
    [9, 2, 10, 0, 2, 9],
    [2, 8, 3, 2, 10, 8, 10, 9, 8],
    [3, 11, 2],
    [0, 11, 2, 8, 11, 0],
    [1, 9, 0, 2, 3, 11],
    [1, 11, 2, 1, 9, 11, 9, 8, 11],
    [3, 10, 1, 11, 10, 3],
    [0, 10, 1, 0, 8, 10, 8, 11, 10],
    [3, 9, 0, 3, 11, 9, 11, 10, 9],
    [9, 8, 10, 10, 8, 11],
    [4, 7, 8],
    [4, 3, 0, 7, 3, 4],
    [0, 1, 9, 8, 4, 7],
    [4, 1, 9, 4, 7, 1, 7, 3, 1],
    [1, 2, 10, 8, 4, 7],
    [3, 4, 7, 3, 0, 4, 1, 2, 10],
    [9, 2, 10, 9, 0, 2, 8, 4, 7],
    [2, 10, 9, 2, 9, 7, 2, 7, 3, 7, 9, 4],
    [8, 4, 7, 3, 11, 2],
    [11, 4, 7, 11, 2, 4, 2, 0, 4],
    [9, 0, 1, 8, 4, 7, 2, 3, 11],
    [4, 7, 11, 9, 4, 11, 9, 11, 2, 9, 2, 1],
    [3, 10, 1, 3, 11, 10, 7, 8, 4],
    [1, 11, 10, 1, 4, 11, 1, 0, 4, 7, 11, 4],
    [4, 7, 8, 9, 0, 11, 9, 11, 10, 11, 0, 3],
    [4, 7, 11, 4, 11, 9, 9, 11, 10],
    [9, 5, 4],
    [9, 5, 4, 0, 8, 3],
    [0, 5, 4, 1, 5, 0],
    [8, 5, 4, 8, 3, 5, 3, 1, 5],
    [1, 2, 10, 9, 5, 4],
    [3, 0, 8, 1, 2, 10, 4, 9, 5],
    [5, 2, 10, 5, 4, 2, 4, 0, 2],
    [2, 10, 5, 3, 2, 5, 3, 5, 4, 3, 4, 8],
    [9, 5, 4, 2, 3, 11],
    [0, 11, 2, 0, 8, 11, 4, 9, 5],
    [0, 5, 4, 0, 1, 5, 2, 3, 11],
    [2, 1, 5, 2, 5, 8, 2, 8, 11, 4, 8, 5],
    [10, 3, 11, 10, 1, 3, 9, 5, 4],
    [4, 9, 5, 0, 8, 1, 8, 10, 1, 8, 11, 10],
    [5, 4, 0, 5, 0, 11, 5, 11, 10, 11, 0, 3],
    [5, 4, 8, 5, 8, 10, 10, 8, 11],
    [9, 7, 8, 5, 7, 9],
    [9, 3, 0, 9, 5, 3, 5, 7, 3],
    [0, 7, 8, 0, 1, 7, 1, 5, 7],
    [1, 5, 3, 3, 5, 7],
    [9, 7, 8, 9, 5, 7, 10, 1, 2],
    [10, 1, 2, 9, 5, 0, 5, 3, 0, 5, 7, 3],
    [8, 0, 2, 8, 2, 5, 8, 5, 7, 10, 5, 2],
    [2, 10, 5, 2, 5, 3, 3, 5, 7],
    [7, 9, 5, 7, 8, 9, 3, 11, 2],
    [9, 5, 7, 9, 7, 2, 9, 2, 0, 2, 7, 11],
    [2, 3, 11, 0, 1, 8, 1, 7, 8, 1, 5, 7],
    [11, 2, 1, 11, 1, 7, 7, 1, 5],
    [9, 5, 8, 8, 5, 7, 10, 1, 3, 10, 3, 11],
    [5, 7, 0, 5, 0, 9, 7, 11, 0, 1, 0, 10, 11, 10, 0],
    [11, 10, 0, 11, 0, 3, 10, 5, 0, 8, 0, 7, 5, 7, 0],
    [11, 10, 5, 7, 11, 5],
    [10, 6, 5],
    [0, 8, 3, 5, 10, 6],
    [9, 0, 1, 5, 10, 6],
    [1, 8, 3, 1, 9, 8, 5, 10, 6],
    [1, 6, 5, 2, 6, 1],
    [1, 6, 5, 1, 2, 6, 3, 0, 8],
    [9, 6, 5, 9, 0, 6, 0, 2, 6],
    [5, 9, 8, 5, 8, 2, 5, 2, 6, 3, 2, 8],
    [2, 3, 11, 10, 6, 5],
    [11, 0, 8, 11, 2, 0, 10, 6, 5],
    [0, 1, 9, 2, 3, 11, 5, 10, 6],
    [5, 10, 6, 1, 9, 2, 9, 11, 2, 9, 8, 11],
    [6, 3, 11, 6, 5, 3, 5, 1, 3],
    [0, 8, 11, 0, 11, 5, 0, 5, 1, 5, 11, 6],
    [3, 11, 6, 0, 3, 6, 0, 6, 5, 0, 5, 9],
    [6, 5, 9, 6, 9, 11, 11, 9, 8],
    [5, 10, 6, 4, 7, 8],
    [4, 3, 0, 4, 7, 3, 6, 5, 10],
    [1, 9, 0, 5, 10, 6, 8, 4, 7],
    [10, 6, 5, 1, 9, 7, 1, 7, 3, 7, 9, 4],
    [6, 1, 2, 6, 5, 1, 4, 7, 8],
    [1, 2, 5, 5, 2, 6, 3, 0, 4, 3, 4, 7],
    [8, 4, 7, 9, 0, 5, 0, 6, 5, 0, 2, 6],
    [7, 3, 9, 7, 9, 4, 3, 2, 9, 5, 9, 6, 2, 6, 9],
    [3, 11, 2, 7, 8, 4, 10, 6, 5],
    [5, 10, 6, 4, 7, 2, 4, 2, 0, 2, 7, 11],
    [0, 1, 9, 4, 7, 8, 2, 3, 11, 5, 10, 6],
    [9, 2, 1, 9, 11, 2, 9, 4, 11, 7, 11, 4, 5, 10, 6],
    [8, 4, 7, 3, 11, 5, 3, 5, 1, 5, 11, 6],
    [5, 1, 11, 5, 11, 6, 1, 0, 11, 7, 11, 4, 0, 4, 11],
    [0, 5, 9, 0, 6, 5, 0, 3, 6, 11, 6, 3, 8, 4, 7],
    [6, 5, 9, 6, 9, 11, 4, 7, 9, 7, 11, 9],
    [10, 4, 9, 6, 4, 10],
    [4, 10, 6, 4, 9, 10, 0, 8, 3],
    [10, 0, 1, 10, 6, 0, 6, 4, 0],
    [8, 3, 1, 8, 1, 6, 8, 6, 4, 6, 1, 10],
    [1, 4, 9, 1, 2, 4, 2, 6, 4],
    [3, 0, 8, 1, 2, 9, 2, 4, 9, 2, 6, 4],
    [0, 2, 4, 4, 2, 6],
    [8, 3, 2, 8, 2, 4, 4, 2, 6],
    [10, 4, 9, 10, 6, 4, 11, 2, 3],
    [0, 8, 2, 2, 8, 11, 4, 9, 10, 4, 10, 6],
    [3, 11, 2, 0, 1, 6, 0, 6, 4, 6, 1, 10],
    [6, 4, 1, 6, 1, 10, 4, 8, 1, 2, 1, 11, 8, 11, 1],
    [9, 6, 4, 9, 3, 6, 9, 1, 3, 11, 6, 3],
    [8, 11, 1, 8, 1, 0, 11, 6, 1, 9, 1, 4, 6, 4, 1],
    [3, 11, 6, 3, 6, 0, 0, 6, 4],
    [6, 4, 8, 11, 6, 8],
    [7, 10, 6, 7, 8, 10, 8, 9, 10],
    [0, 7, 3, 0, 10, 7, 0, 9, 10, 6, 7, 10],
    [10, 6, 7, 1, 10, 7, 1, 7, 8, 1, 8, 0],
    [10, 6, 7, 10, 7, 1, 1, 7, 3],
    [1, 2, 6, 1, 6, 8, 1, 8, 9, 8, 6, 7],
    [2, 6, 9, 2, 9, 1, 6, 7, 9, 0, 9, 3, 7, 3, 9],
    [7, 8, 0, 7, 0, 6, 6, 0, 2],
    [7, 3, 2, 6, 7, 2],
    [2, 3, 11, 10, 6, 8, 10, 8, 9, 8, 6, 7],
    [2, 0, 7, 2, 7, 11, 0, 9, 7, 6, 7, 10, 9, 10, 7],
    [1, 8, 0, 1, 7, 8, 1, 10, 7, 6, 7, 10, 2, 3, 11],
    [11, 2, 1, 11, 1, 7, 10, 6, 1, 6, 7, 1],
    [8, 9, 6, 8, 6, 7, 9, 1, 6, 11, 6, 3, 1, 3, 6],
    [0, 9, 1, 11, 6, 7],
    [7, 8, 0, 7, 0, 6, 3, 11, 0, 11, 6, 0],
    [7, 11, 6],
    [7, 6, 11],
    [3, 0, 8, 11, 7, 6],
    [0, 1, 9, 11, 7, 6],
    [8, 1, 9, 8, 3, 1, 11, 7, 6],
    [10, 1, 2, 6, 11, 7],
    [1, 2, 10, 3, 0, 8, 6, 11, 7],
    [2, 9, 0, 2, 10, 9, 6, 11, 7],
    [6, 11, 7, 2, 10, 3, 10, 8, 3, 10, 9, 8],
    [7, 2, 3, 6, 2, 7],
    [7, 0, 8, 7, 6, 0, 6, 2, 0],
    [2, 7, 6, 2, 3, 7, 0, 1, 9],
    [1, 6, 2, 1, 8, 6, 1, 9, 8, 8, 7, 6],
    [10, 7, 6, 10, 1, 7, 1, 3, 7],
    [10, 7, 6, 1, 7, 10, 1, 8, 7, 1, 0, 8],
    [0, 3, 7, 0, 7, 10, 0, 10, 9, 6, 10, 7],
    [7, 6, 10, 7, 10, 8, 8, 10, 9],
    [6, 8, 4, 11, 8, 6],
    [3, 6, 11, 3, 0, 6, 0, 4, 6],
    [8, 6, 11, 8, 4, 6, 9, 0, 1],
    [9, 4, 6, 9, 6, 3, 9, 3, 1, 11, 3, 6],
    [6, 8, 4, 6, 11, 8, 2, 10, 1],
    [1, 2, 10, 3, 0, 11, 0, 6, 11, 0, 4, 6],
    [4, 11, 8, 4, 6, 11, 0, 2, 9, 2, 10, 9],
    [10, 9, 3, 10, 3, 2, 9, 4, 3, 11, 3, 6, 4, 6, 3],
    [8, 2, 3, 8, 4, 2, 4, 6, 2],
    [0, 4, 2, 4, 6, 2],
    [1, 9, 0, 2, 3, 4, 2, 4, 6, 4, 3, 8],
    [1, 9, 4, 1, 4, 2, 2, 4, 6],
    [8, 1, 3, 8, 6, 1, 8, 4, 6, 6, 10, 1],
    [10, 1, 0, 10, 0, 6, 6, 0, 4],
    [4, 6, 3, 4, 3, 8, 6, 10, 3, 0, 3, 9, 10, 9, 3],
    [10, 9, 4, 6, 10, 4],
    [4, 9, 5, 7, 6, 11],
    [0, 8, 3, 4, 9, 5, 11, 7, 6],
    [5, 0, 1, 5, 4, 0, 7, 6, 11],
    [11, 7, 6, 8, 3, 4, 3, 5, 4, 3, 1, 5],
    [9, 5, 4, 10, 1, 2, 7, 6, 11],
    [6, 11, 7, 1, 2, 10, 0, 8, 3, 4, 9, 5],
    [7, 6, 11, 5, 4, 10, 4, 2, 10, 4, 0, 2],
    [3, 4, 8, 3, 5, 4, 3, 2, 5, 10, 5, 2, 11, 7, 6],
    [7, 2, 3, 7, 6, 2, 5, 4, 9],
    [9, 5, 4, 0, 8, 6, 0, 6, 2, 6, 8, 7],
    [3, 6, 2, 3, 7, 6, 1, 5, 0, 5, 4, 0],
    [6, 2, 8, 6, 8, 7, 2, 1, 8, 4, 8, 5, 1, 5, 8],
    [9, 5, 4, 10, 1, 6, 1, 7, 6, 1, 3, 7],
    [1, 6, 10, 1, 7, 6, 1, 0, 7, 8, 7, 0, 9, 5, 4],
    [4, 0, 10, 4, 10, 5, 0, 3, 10, 6, 10, 7, 3, 7, 10],
    [7, 6, 10, 7, 10, 8, 5, 4, 10, 4, 8, 10],
    [6, 9, 5, 6, 11, 9, 11, 8, 9],
    [3, 6, 11, 0, 6, 3, 0, 5, 6, 0, 9, 5],
    [0, 11, 8, 0, 5, 11, 0, 1, 5, 5, 6, 11],
    [6, 11, 3, 6, 3, 5, 5, 3, 1],
    [1, 2, 10, 9, 5, 11, 9, 11, 8, 11, 5, 6],
    [0, 11, 3, 0, 6, 11, 0, 9, 6, 5, 6, 9, 1, 2, 10],
    [11, 8, 5, 11, 5, 6, 8, 0, 5, 10, 5, 2, 0, 2, 5],
    [6, 11, 3, 6, 3, 5, 2, 10, 3, 10, 5, 3],
    [5, 8, 9, 5, 2, 8, 5, 6, 2, 3, 8, 2],
    [9, 5, 6, 9, 6, 0, 0, 6, 2],
    [1, 5, 8, 1, 8, 0, 5, 6, 8, 3, 8, 2, 6, 2, 8],
    [1, 5, 6, 2, 1, 6],
    [1, 3, 6, 1, 6, 10, 3, 8, 6, 5, 6, 9, 8, 9, 6],
    [10, 1, 0, 10, 0, 6, 9, 5, 0, 5, 6, 0],
    [0, 3, 8, 5, 6, 10],
    [10, 5, 6],
    [11, 5, 10, 7, 5, 11],
    [11, 5, 10, 11, 7, 5, 8, 3, 0],
    [5, 11, 7, 5, 10, 11, 1, 9, 0],
    [10, 7, 5, 10, 11, 7, 9, 8, 1, 8, 3, 1],
    [11, 1, 2, 11, 7, 1, 7, 5, 1],
    [0, 8, 3, 1, 2, 7, 1, 7, 5, 7, 2, 11],
    [9, 7, 5, 9, 2, 7, 9, 0, 2, 2, 11, 7],
    [7, 5, 2, 7, 2, 11, 5, 9, 2, 3, 2, 8, 9, 8, 2],
    [2, 5, 10, 2, 3, 5, 3, 7, 5],
    [8, 2, 0, 8, 5, 2, 8, 7, 5, 10, 2, 5],
    [9, 0, 1, 5, 10, 3, 5, 3, 7, 3, 10, 2],
    [9, 8, 2, 9, 2, 1, 8, 7, 2, 10, 2, 5, 7, 5, 2],
    [1, 3, 5, 3, 7, 5],
    [0, 8, 7, 0, 7, 1, 1, 7, 5],
    [9, 0, 3, 9, 3, 5, 5, 3, 7],
    [9, 8, 7, 5, 9, 7],
    [5, 8, 4, 5, 10, 8, 10, 11, 8],
    [5, 0, 4, 5, 11, 0, 5, 10, 11, 11, 3, 0],
    [0, 1, 9, 8, 4, 10, 8, 10, 11, 10, 4, 5],
    [10, 11, 4, 10, 4, 5, 11, 3, 4, 9, 4, 1, 3, 1, 4],
    [2, 5, 1, 2, 8, 5, 2, 11, 8, 4, 5, 8],
    [0, 4, 11, 0, 11, 3, 4, 5, 11, 2, 11, 1, 5, 1, 11],
    [0, 2, 5, 0, 5, 9, 2, 11, 5, 4, 5, 8, 11, 8, 5],
    [9, 4, 5, 2, 11, 3],
    [2, 5, 10, 3, 5, 2, 3, 4, 5, 3, 8, 4],
    [5, 10, 2, 5, 2, 4, 4, 2, 0],
    [3, 10, 2, 3, 5, 10, 3, 8, 5, 4, 5, 8, 0, 1, 9],
    [5, 10, 2, 5, 2, 4, 1, 9, 2, 9, 4, 2],
    [8, 4, 5, 8, 5, 3, 3, 5, 1],
    [0, 4, 5, 1, 0, 5],
    [8, 4, 5, 8, 5, 3, 9, 0, 5, 0, 3, 5],
    [9, 4, 5],
    [4, 11, 7, 4, 9, 11, 9, 10, 11],
    [0, 8, 3, 4, 9, 7, 9, 11, 7, 9, 10, 11],
    [1, 10, 11, 1, 11, 4, 1, 4, 0, 7, 4, 11],
    [3, 1, 4, 3, 4, 8, 1, 10, 4, 7, 4, 11, 10, 11, 4],
    [4, 11, 7, 9, 11, 4, 9, 2, 11, 9, 1, 2],
    [9, 7, 4, 9, 11, 7, 9, 1, 11, 2, 11, 1, 0, 8, 3],
    [11, 7, 4, 11, 4, 2, 2, 4, 0],
    [11, 7, 4, 11, 4, 2, 8, 3, 4, 3, 2, 4],
    [2, 9, 10, 2, 7, 9, 2, 3, 7, 7, 4, 9],
    [9, 10, 7, 9, 7, 4, 10, 2, 7, 8, 7, 0, 2, 0, 7],
    [3, 7, 10, 3, 10, 2, 7, 4, 10, 1, 10, 0, 4, 0, 10],
    [1, 10, 2, 8, 7, 4],
    [4, 9, 1, 4, 1, 7, 7, 1, 3],
    [4, 9, 1, 4, 1, 7, 0, 8, 1, 8, 7, 1],
    [4, 0, 3, 7, 4, 3],
    [4, 8, 7],
    [9, 10, 8, 10, 11, 8],
    [3, 0, 9, 3, 9, 11, 11, 9, 10],
    [0, 1, 10, 0, 10, 8, 8, 10, 11],
    [3, 1, 10, 11, 3, 10],
    [1, 2, 11, 1, 11, 9, 9, 11, 8],
    [3, 0, 9, 3, 9, 11, 1, 2, 9, 2, 11, 9],
    [0, 2, 11, 8, 0, 11],
    [3, 2, 11],
    [2, 3, 8, 2, 8, 10, 10, 8, 9],
    [9, 10, 2, 0, 9, 2],
    [2, 3, 8, 2, 8, 10, 0, 1, 8, 1, 10, 8],
    [1, 10, 2],
    [1, 3, 8, 9, 1, 8],
    [0, 9, 1],
    [0, 3, 8],
    []
];
/**
 * Triangles are constructed between points on cube edges.
 * AllowedContours[edge1][edge1] indicates which lines from a given
 * triangle should be shown in line mode.
 *
 * Values are bitmasks:
 * In loop over cubes we keep another bitmask indicating whether our current
 * cell is the first x-value (1),
 * first y-value (2) or first z-value (4) of the current loop.
 * We draw all lines on leading faces but only draw trailing face lines the first
 * time through the loop
 * A value of 8 below means the edge is always drawn (leading face)
 *
 * E.g. the first row, lines between edge0 and other edges in the bottom
 * x-y plane are only drawn for the first value of z, edges in the
 * x-z plane are only drawn for the first value of y. No other lines
 * are drawn as they're redundant
 * The line between edge 1 and 5 is always drawn as it's on the leading edge
 */
var AllowedContours = [
    [0, 4, 4, 4, 2, 0, 0, 0, 2, 2, 0, 0],
    [4, 0, 4, 4, 0, 8, 0, 0, 0, 8, 8, 0],
    [4, 4, 0, 4, 0, 0, 8, 0, 0, 0, 8, 8],
    [4, 4, 4, 0, 0, 0, 0, 1, 1, 0, 0, 1],
    [2, 0, 0, 0, 0, 8, 8, 8, 2, 2, 0, 0],
    [0, 8, 0, 0, 8, 0, 8, 8, 0, 8, 8, 0],
    [0, 0, 8, 0, 8, 8, 0, 8, 0, 0, 8, 8],
    [0, 0, 0, 1, 8, 8, 8, 0, 1, 0, 0, 1],
    [2, 0, 0, 1, 2, 0, 0, 1, 0, 2, 0, 1],
    [2, 8, 0, 0, 2, 8, 0, 0, 2, 0, 8, 0],
    [0, 8, 8, 0, 0, 8, 8, 0, 0, 8, 0, 8],
    [0, 0, 8, 1, 0, 0, 8, 1, 1, 0, 8, 0]
];
//# sourceMappingURL=tables.js.map

/***/ }),

/***/ "./lib/mol-gl/commit-queue.js":
/*!************************************!*\
  !*** ./lib/mol-gl/commit-queue.js ***!
  \************************************/
/*! exports provided: CommitQueue */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CommitQueue", function() { return CommitQueue; });
/* harmony import */ var _mol_data_generic__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../mol-data/generic */ "./lib/mol-data/generic.js");
/**
 * Copyright (c) 2020 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author David Sehnal <david.sehnal@gmail.com>
 */

var CommitQueue = /** @class */ (function () {
    function CommitQueue() {
        this.removeList = Object(_mol_data_generic__WEBPACK_IMPORTED_MODULE_0__["LinkedList"])();
        this.removeMap = new Map();
        this.addList = Object(_mol_data_generic__WEBPACK_IMPORTED_MODULE_0__["LinkedList"])();
        this.addMap = new Map();
    }
    Object.defineProperty(CommitQueue.prototype, "isEmpty", {
        get: function () {
            return this.removeList.count === 0 && this.addList.count === 0;
        },
        enumerable: false,
        configurable: true
    });
    CommitQueue.prototype.add = function (o) {
        if (this.removeMap.has(o)) {
            var a = this.removeMap.get(o);
            this.removeMap.delete(o);
            this.removeList.remove(a);
        }
        if (this.addMap.has(o))
            return;
        var b = this.addList.addLast(o);
        this.addMap.set(o, b);
    };
    CommitQueue.prototype.remove = function (o) {
        if (this.addMap.has(o)) {
            var a = this.addMap.get(o);
            this.addMap.delete(o);
            this.addList.remove(a);
        }
        if (this.removeMap.has(o))
            return;
        var b = this.removeList.addLast(o);
        this.removeMap.set(o, b);
    };
    CommitQueue.prototype.tryGetRemove = function () {
        var o = this.removeList.removeFirst();
        if (o)
            this.removeMap.delete(o);
        return o;
    };
    CommitQueue.prototype.tryGetAdd = function () {
        var o = this.addList.removeFirst();
        if (o)
            this.addMap.delete(o);
        return o;
    };
    return CommitQueue;
}());

//# sourceMappingURL=commit-queue.js.map

/***/ }),

/***/ "./lib/mol-gl/compute/histogram-pyramid/reduction.js":
/*!***********************************************************!*\
  !*** ./lib/mol-gl/compute/histogram-pyramid/reduction.js ***!
  \***********************************************************/
/*! exports provided: createHistogramPyramid */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createHistogramPyramid", function() { return createHistogramPyramid; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _renderable__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../renderable */ "./lib/mol-gl/renderable.js");
/* harmony import */ var _webgl_render_item__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../webgl/render-item */ "./lib/mol-gl/webgl/render-item.js");
/* harmony import */ var _renderable_schema__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../renderable/schema */ "./lib/mol-gl/renderable/schema.js");
/* harmony import */ var _mol_gl_shader_code__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../../mol-gl/shader-code */ "./lib/mol-gl/shader-code.js");
/* harmony import */ var _mol_util__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../../mol-util */ "./lib/mol-util/index.js");
/* harmony import */ var _util__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../util */ "./lib/mol-gl/compute/util.js");
/* harmony import */ var _sum__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ./sum */ "./lib/mol-gl/compute/histogram-pyramid/sum.js");
/* harmony import */ var _mol_math_misc__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ../../../mol-math/misc */ "./lib/mol-math/misc.js");
/* harmony import */ var _mol_gl_shader_quad_vert__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ../../../mol-gl/shader/quad.vert */ "./lib/mol-gl/shader/quad.vert.js");
/* harmony import */ var _mol_gl_shader_histogram_pyramid_reduction_frag__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ../../../mol-gl/shader/histogram-pyramid/reduction.frag */ "./lib/mol-gl/shader/histogram-pyramid/reduction.frag.js");
/**
 * Copyright (c) 2019-2021 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */











var HistopyramidReductionSchema = Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, _util__WEBPACK_IMPORTED_MODULE_6__["QuadSchema"]), { tPreviousLevel: Object(_renderable_schema__WEBPACK_IMPORTED_MODULE_3__["TextureSpec"])('texture', 'rgba', 'float', 'nearest'), uSize: Object(_renderable_schema__WEBPACK_IMPORTED_MODULE_3__["UniformSpec"])('f'), uTexSize: Object(_renderable_schema__WEBPACK_IMPORTED_MODULE_3__["UniformSpec"])('f'), uFirst: Object(_renderable_schema__WEBPACK_IMPORTED_MODULE_3__["UniformSpec"])('b') });
var HistogramPyramidName = 'histogram-pyramid';
function getHistopyramidReductionRenderable(ctx, initialTexture) {
    if (ctx.namedComputeRenderables[HistogramPyramidName]) {
        var v = ctx.namedComputeRenderables[HistogramPyramidName].values;
        _mol_util__WEBPACK_IMPORTED_MODULE_5__["ValueCell"].update(v.tPreviousLevel, initialTexture);
        ctx.namedComputeRenderables[HistogramPyramidName].update();
    }
    else {
        ctx.namedComputeRenderables[HistogramPyramidName] = createHistopyramidReductionRenderable(ctx, initialTexture);
    }
    return ctx.namedComputeRenderables[HistogramPyramidName];
}
function createHistopyramidReductionRenderable(ctx, initialTexture) {
    var values = Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, _util__WEBPACK_IMPORTED_MODULE_6__["QuadValues"]), { tPreviousLevel: _mol_util__WEBPACK_IMPORTED_MODULE_5__["ValueCell"].create(initialTexture), uSize: _mol_util__WEBPACK_IMPORTED_MODULE_5__["ValueCell"].create(0), uTexSize: _mol_util__WEBPACK_IMPORTED_MODULE_5__["ValueCell"].create(0), uFirst: _mol_util__WEBPACK_IMPORTED_MODULE_5__["ValueCell"].create(true) });
    var schema = Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, HistopyramidReductionSchema);
    var shaderCode = Object(_mol_gl_shader_code__WEBPACK_IMPORTED_MODULE_4__["ShaderCode"])('reduction', _mol_gl_shader_quad_vert__WEBPACK_IMPORTED_MODULE_9__["default"], _mol_gl_shader_histogram_pyramid_reduction_frag__WEBPACK_IMPORTED_MODULE_10__["default"]);
    var renderItem = Object(_webgl_render_item__WEBPACK_IMPORTED_MODULE_2__["createComputeRenderItem"])(ctx, 'triangles', shaderCode, schema, values);
    return Object(_renderable__WEBPACK_IMPORTED_MODULE_1__["createComputeRenderable"])(renderItem, values);
}
var LevelTexturesFramebuffers = [];
function getLevelTextureFramebuffer(ctx, level) {
    var textureFramebuffer = LevelTexturesFramebuffers[level];
    var size = Math.pow(2, level);
    if (textureFramebuffer === undefined) {
        var texture = getTexture("level" + level, ctx, 'image-float32', 'rgba', 'float', 'nearest');
        var framebuffer = getFramebuffer("level" + level, ctx);
        texture.attachFramebuffer(framebuffer, 0);
        textureFramebuffer = { texture: texture, framebuffer: framebuffer };
        textureFramebuffer.texture.define(size, size);
        LevelTexturesFramebuffers[level] = textureFramebuffer;
    }
    return textureFramebuffer;
}
function setRenderingDefaults(ctx) {
    var gl = ctx.gl, state = ctx.state;
    state.disable(gl.CULL_FACE);
    state.disable(gl.BLEND);
    state.disable(gl.DEPTH_TEST);
    state.enable(gl.SCISSOR_TEST);
    state.depthMask(false);
    state.colorMask(true, true, true, true);
    state.clearColor(0, 0, 0, 0);
}
function getFramebuffer(name, webgl) {
    var _name = HistogramPyramidName + "-" + name;
    if (!webgl.namedFramebuffers[_name]) {
        webgl.namedFramebuffers[_name] = webgl.resources.framebuffer();
    }
    return webgl.namedFramebuffers[_name];
}
function getTexture(name, webgl, kind, format, type, filter) {
    var _name = HistogramPyramidName + "-" + name;
    if (!webgl.namedTextures[_name]) {
        webgl.namedTextures[_name] = webgl.resources.texture(kind, format, type, filter);
    }
    return webgl.namedTextures[_name];
}
function createHistogramPyramid(ctx, inputTexture, scale, gridTexDim) {
    var gl = ctx.gl;
    var w = inputTexture.getWidth();
    var h = inputTexture.getHeight();
    // printTexture(ctx, inputTexture, 2)
    if (w !== h || !Object(_mol_math_misc__WEBPACK_IMPORTED_MODULE_8__["isPowerOfTwo"])(w)) {
        throw new Error('inputTexture must be of square power-of-two size');
    }
    // This part set the levels
    var levels = Math.ceil(Math.log(w) / Math.log(2));
    var maxSize = Math.pow(2, levels);
    // console.log('levels', levels, 'maxSize', maxSize, 'input', w);
    var pyramidTex = getTexture('pyramid', ctx, 'image-float32', 'rgba', 'float', 'nearest');
    pyramidTex.define(maxSize, maxSize);
    var framebuffer = getFramebuffer('pyramid', ctx);
    pyramidTex.attachFramebuffer(framebuffer, 0);
    gl.viewport(0, 0, maxSize, maxSize);
    gl.clear(gl.COLOR_BUFFER_BIT);
    var levelTexturesFramebuffers = [];
    for (var i = 0; i < levels; ++i)
        levelTexturesFramebuffers.push(getLevelTextureFramebuffer(ctx, i));
    var renderable = getHistopyramidReductionRenderable(ctx, inputTexture);
    ctx.state.currentRenderItemId = -1;
    setRenderingDefaults(ctx);
    var offset = 0;
    for (var i = 0; i < levels; i++) {
        var currLevel = levels - 1 - i;
        var tf = levelTexturesFramebuffers[currLevel];
        tf.framebuffer.bind();
        var size = Math.pow(2, currLevel);
        // console.log('size', size, 'draw-level', currLevel, 'read-level', levels - i)
        _mol_util__WEBPACK_IMPORTED_MODULE_5__["ValueCell"].update(renderable.values.uSize, Math.pow(2, i + 1) / maxSize);
        _mol_util__WEBPACK_IMPORTED_MODULE_5__["ValueCell"].update(renderable.values.uTexSize, size);
        _mol_util__WEBPACK_IMPORTED_MODULE_5__["ValueCell"].updateIfChanged(renderable.values.uFirst, i === 0);
        if (i > 0) {
            _mol_util__WEBPACK_IMPORTED_MODULE_5__["ValueCell"].update(renderable.values.tPreviousLevel, levelTexturesFramebuffers[levels - i].texture);
            renderable.update();
        }
        ctx.state.currentRenderItemId = -1;
        gl.viewport(0, 0, size, size);
        gl.scissor(0, 0, size, size);
        gl.clear(gl.COLOR_BUFFER_BIT);
        gl.scissor(0, 0, gridTexDim[0], gridTexDim[1]);
        renderable.render();
        pyramidTex.bind(0);
        gl.copyTexSubImage2D(gl.TEXTURE_2D, 0, offset, 0, 0, 0, size, size);
        pyramidTex.unbind(0);
        offset += size;
    }
    gl.finish();
    // printTexture(ctx, pyramidTex, 2)
    //
    // return at least a count of one to avoid issues downstram
    var count = Math.max(1, Object(_sum__WEBPACK_IMPORTED_MODULE_7__["getHistopyramidSum"])(ctx, levelTexturesFramebuffers[0].texture));
    var height = Math.ceil(count / Math.pow(2, levels));
    // const scale = Vec2.create(maxSize / inputTexture.width, maxSize / inputTexture.height);
    // console.log('height', height, 'finalCount', finalCount, 'scale', scale);
    return { pyramidTex: pyramidTex, count: count, height: height, levels: levels, scale: scale };
}
//# sourceMappingURL=reduction.js.map

/***/ }),

/***/ "./lib/mol-gl/compute/histogram-pyramid/sum.js":
/*!*****************************************************!*\
  !*** ./lib/mol-gl/compute/histogram-pyramid/sum.js ***!
  \*****************************************************/
/*! exports provided: getHistopyramidSum */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getHistopyramidSum", function() { return getHistopyramidSum; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _renderable__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../renderable */ "./lib/mol-gl/renderable.js");
/* harmony import */ var _webgl_render_item__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../webgl/render-item */ "./lib/mol-gl/webgl/render-item.js");
/* harmony import */ var _renderable_schema__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../renderable/schema */ "./lib/mol-gl/renderable/schema.js");
/* harmony import */ var _mol_gl_shader_code__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../../mol-gl/shader-code */ "./lib/mol-gl/shader-code.js");
/* harmony import */ var _mol_util__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../../mol-util */ "./lib/mol-util/index.js");
/* harmony import */ var _mol_util_float_packing__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../../../mol-util/float-packing */ "./lib/mol-util/float-packing.js");
/* harmony import */ var _util__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../util */ "./lib/mol-gl/compute/util.js");
/* harmony import */ var _mol_gl_shader_quad_vert__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ../../../mol-gl/shader/quad.vert */ "./lib/mol-gl/shader/quad.vert.js");
/* harmony import */ var _mol_gl_shader_histogram_pyramid_sum_frag__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ../../../mol-gl/shader/histogram-pyramid/sum.frag */ "./lib/mol-gl/shader/histogram-pyramid/sum.frag.js");
/**
 * Copyright (c) 2019-2020 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */










var HistopyramidSumSchema = Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, _util__WEBPACK_IMPORTED_MODULE_7__["QuadSchema"]), { tTexture: Object(_renderable_schema__WEBPACK_IMPORTED_MODULE_3__["TextureSpec"])('texture', 'rgba', 'float', 'nearest') });
var HistopyramidSumName = 'histopyramid-sum';
function getHistopyramidSumRenderable(ctx, texture) {
    if (ctx.namedComputeRenderables[HistopyramidSumName]) {
        var v = ctx.namedComputeRenderables[HistopyramidSumName].values;
        _mol_util__WEBPACK_IMPORTED_MODULE_5__["ValueCell"].update(v.tTexture, texture);
        ctx.namedComputeRenderables[HistopyramidSumName].update();
    }
    else {
        ctx.namedComputeRenderables[HistopyramidSumName] = createHistopyramidSumRenderable(ctx, texture);
    }
    return ctx.namedComputeRenderables[HistopyramidSumName];
}
function createHistopyramidSumRenderable(ctx, texture) {
    var values = Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, _util__WEBPACK_IMPORTED_MODULE_7__["QuadValues"]), { tTexture: _mol_util__WEBPACK_IMPORTED_MODULE_5__["ValueCell"].create(texture) });
    var schema = Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, HistopyramidSumSchema);
    var shaderCode = Object(_mol_gl_shader_code__WEBPACK_IMPORTED_MODULE_4__["ShaderCode"])('sum', _mol_gl_shader_quad_vert__WEBPACK_IMPORTED_MODULE_8__["default"], _mol_gl_shader_histogram_pyramid_sum_frag__WEBPACK_IMPORTED_MODULE_9__["default"]);
    var renderItem = Object(_webgl_render_item__WEBPACK_IMPORTED_MODULE_2__["createComputeRenderItem"])(ctx, 'triangles', shaderCode, schema, values);
    return Object(_renderable__WEBPACK_IMPORTED_MODULE_1__["createComputeRenderable"])(renderItem, values);
}
function setRenderingDefaults(ctx) {
    var gl = ctx.gl, state = ctx.state;
    state.disable(gl.CULL_FACE);
    state.disable(gl.BLEND);
    state.disable(gl.DEPTH_TEST);
    state.disable(gl.SCISSOR_TEST);
    state.depthMask(false);
    state.colorMask(true, true, true, true);
    state.clearColor(0, 0, 0, 0);
}
var sumArray = new Uint8Array(4);
function getHistopyramidSum(ctx, pyramidTopTexture) {
    var gl = ctx.gl, resources = ctx.resources;
    var renderable = getHistopyramidSumRenderable(ctx, pyramidTopTexture);
    ctx.state.currentRenderItemId = -1;
    if (!ctx.namedFramebuffers[HistopyramidSumName]) {
        ctx.namedFramebuffers[HistopyramidSumName] = resources.framebuffer();
    }
    var framebuffer = ctx.namedFramebuffers[HistopyramidSumName];
    if (!ctx.namedTextures[HistopyramidSumName]) {
        ctx.namedTextures[HistopyramidSumName] = resources.texture('image-uint8', 'rgba', 'ubyte', 'nearest');
        ctx.namedTextures[HistopyramidSumName].define(1, 1);
    }
    var sumTexture = ctx.namedTextures[HistopyramidSumName];
    sumTexture.attachFramebuffer(framebuffer, 0);
    setRenderingDefaults(ctx);
    gl.viewport(0, 0, 1, 1);
    renderable.render();
    gl.finish();
    ctx.readPixels(0, 0, 1, 1, sumArray);
    ctx.unbindFramebuffer();
    return Object(_mol_util_float_packing__WEBPACK_IMPORTED_MODULE_6__["decodeFloatRGB"])(sumArray[0], sumArray[1], sumArray[2]);
}
//# sourceMappingURL=sum.js.map

/***/ }),

/***/ "./lib/mol-gl/compute/marching-cubes/active-voxels.js":
/*!************************************************************!*\
  !*** ./lib/mol-gl/compute/marching-cubes/active-voxels.js ***!
  \************************************************************/
/*! exports provided: calcActiveVoxels */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "calcActiveVoxels", function() { return calcActiveVoxels; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _renderable__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../renderable */ "./lib/mol-gl/renderable.js");
/* harmony import */ var _webgl_render_item__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../webgl/render-item */ "./lib/mol-gl/webgl/render-item.js");
/* harmony import */ var _renderable_schema__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../renderable/schema */ "./lib/mol-gl/renderable/schema.js");
/* harmony import */ var _mol_gl_shader_code__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../../mol-gl/shader-code */ "./lib/mol-gl/shader-code.js");
/* harmony import */ var _mol_util__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../../mol-util */ "./lib/mol-util/index.js");
/* harmony import */ var _util__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../util */ "./lib/mol-gl/compute/util.js");
/* harmony import */ var _tables__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ./tables */ "./lib/mol-gl/compute/marching-cubes/tables.js");
/* harmony import */ var _mol_gl_shader_quad_vert__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ../../../mol-gl/shader/quad.vert */ "./lib/mol-gl/shader/quad.vert.js");
/* harmony import */ var _mol_gl_shader_marching_cubes_active_voxels_frag__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ../../../mol-gl/shader/marching-cubes/active-voxels.frag */ "./lib/mol-gl/shader/marching-cubes/active-voxels.frag.js");
/**
 * Copyright (c) 2019-2021 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */










var ActiveVoxelsSchema = Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, _util__WEBPACK_IMPORTED_MODULE_6__["QuadSchema"]), { tTriCount: Object(_renderable_schema__WEBPACK_IMPORTED_MODULE_3__["TextureSpec"])('image-uint8', 'alpha', 'ubyte', 'nearest'), tVolumeData: Object(_renderable_schema__WEBPACK_IMPORTED_MODULE_3__["TextureSpec"])('texture', 'rgba', 'ubyte', 'nearest'), uIsoValue: Object(_renderable_schema__WEBPACK_IMPORTED_MODULE_3__["UniformSpec"])('f'), uGridDim: Object(_renderable_schema__WEBPACK_IMPORTED_MODULE_3__["UniformSpec"])('v3'), uGridTexDim: Object(_renderable_schema__WEBPACK_IMPORTED_MODULE_3__["UniformSpec"])('v3'), uScale: Object(_renderable_schema__WEBPACK_IMPORTED_MODULE_3__["UniformSpec"])('v2') });
var ActiveVoxelsName = 'active-voxels';
function getActiveVoxelsRenderable(ctx, volumeData, gridDim, gridTexDim, isoValue, scale) {
    if (ctx.namedComputeRenderables[ActiveVoxelsName]) {
        var v = ctx.namedComputeRenderables[ActiveVoxelsName].values;
        _mol_util__WEBPACK_IMPORTED_MODULE_5__["ValueCell"].update(v.uQuadScale, scale);
        _mol_util__WEBPACK_IMPORTED_MODULE_5__["ValueCell"].update(v.tVolumeData, volumeData);
        _mol_util__WEBPACK_IMPORTED_MODULE_5__["ValueCell"].updateIfChanged(v.uIsoValue, isoValue);
        _mol_util__WEBPACK_IMPORTED_MODULE_5__["ValueCell"].update(v.uGridDim, gridDim);
        _mol_util__WEBPACK_IMPORTED_MODULE_5__["ValueCell"].update(v.uGridTexDim, gridTexDim);
        _mol_util__WEBPACK_IMPORTED_MODULE_5__["ValueCell"].update(v.uScale, scale);
        ctx.namedComputeRenderables[ActiveVoxelsName].update();
    }
    else {
        ctx.namedComputeRenderables[ActiveVoxelsName] = createActiveVoxelsRenderable(ctx, volumeData, gridDim, gridTexDim, isoValue, scale);
    }
    return ctx.namedComputeRenderables[ActiveVoxelsName];
}
function createActiveVoxelsRenderable(ctx, volumeData, gridDim, gridTexDim, isoValue, scale) {
    var values = Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, _util__WEBPACK_IMPORTED_MODULE_6__["QuadValues"]), { tTriCount: _mol_util__WEBPACK_IMPORTED_MODULE_5__["ValueCell"].create(Object(_tables__WEBPACK_IMPORTED_MODULE_7__["getTriCount"])()), uQuadScale: _mol_util__WEBPACK_IMPORTED_MODULE_5__["ValueCell"].create(scale), tVolumeData: _mol_util__WEBPACK_IMPORTED_MODULE_5__["ValueCell"].create(volumeData), uIsoValue: _mol_util__WEBPACK_IMPORTED_MODULE_5__["ValueCell"].create(isoValue), uGridDim: _mol_util__WEBPACK_IMPORTED_MODULE_5__["ValueCell"].create(gridDim), uGridTexDim: _mol_util__WEBPACK_IMPORTED_MODULE_5__["ValueCell"].create(gridTexDim), uScale: _mol_util__WEBPACK_IMPORTED_MODULE_5__["ValueCell"].create(scale) });
    var schema = Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, ActiveVoxelsSchema);
    var shaderCode = Object(_mol_gl_shader_code__WEBPACK_IMPORTED_MODULE_4__["ShaderCode"])('active-voxels', _mol_gl_shader_quad_vert__WEBPACK_IMPORTED_MODULE_8__["default"], _mol_gl_shader_marching_cubes_active_voxels_frag__WEBPACK_IMPORTED_MODULE_9__["default"]);
    var renderItem = Object(_webgl_render_item__WEBPACK_IMPORTED_MODULE_2__["createComputeRenderItem"])(ctx, 'triangles', shaderCode, schema, values);
    return Object(_renderable__WEBPACK_IMPORTED_MODULE_1__["createComputeRenderable"])(renderItem, values);
}
function setRenderingDefaults(ctx) {
    var gl = ctx.gl, state = ctx.state;
    state.disable(gl.CULL_FACE);
    state.disable(gl.BLEND);
    state.disable(gl.DEPTH_TEST);
    state.enable(gl.SCISSOR_TEST);
    state.depthMask(false);
    state.colorMask(true, true, true, true);
    state.clearColor(0, 0, 0, 0);
}
function calcActiveVoxels(ctx, volumeData, gridDim, gridTexDim, isoValue, gridScale) {
    var gl = ctx.gl, resources = ctx.resources;
    var width = volumeData.getWidth();
    var height = volumeData.getHeight();
    if (!ctx.namedFramebuffers[ActiveVoxelsName]) {
        ctx.namedFramebuffers[ActiveVoxelsName] = resources.framebuffer();
    }
    var framebuffer = ctx.namedFramebuffers[ActiveVoxelsName];
    framebuffer.bind();
    if (!ctx.namedTextures[ActiveVoxelsName]) {
        ctx.namedTextures[ActiveVoxelsName] = resources.texture('image-uint8', 'rgba', 'ubyte', 'nearest');
    }
    var activeVoxelsTex = ctx.namedTextures[ActiveVoxelsName];
    activeVoxelsTex.define(width, height);
    var renderable = getActiveVoxelsRenderable(ctx, volumeData, gridDim, gridTexDim, isoValue, gridScale);
    ctx.state.currentRenderItemId = -1;
    activeVoxelsTex.attachFramebuffer(framebuffer, 0);
    setRenderingDefaults(ctx);
    gl.viewport(0, 0, width, height);
    gl.scissor(0, 0, width, height);
    gl.clear(gl.COLOR_BUFFER_BIT);
    gl.scissor(0, 0, gridTexDim[0], gridTexDim[1]);
    renderable.render();
    // console.log('gridScale', gridScale, 'gridTexDim', gridTexDim, 'gridDim', gridDim);
    // console.log('volumeData', volumeData);
    // console.log('at', readTexture(ctx, activeVoxelsTex));
    gl.finish();
    return activeVoxelsTex;
}
//# sourceMappingURL=active-voxels.js.map

/***/ }),

/***/ "./lib/mol-gl/compute/marching-cubes/isosurface.js":
/*!*********************************************************!*\
  !*** ./lib/mol-gl/compute/marching-cubes/isosurface.js ***!
  \*********************************************************/
/*! exports provided: createIsosurfaceBuffers */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createIsosurfaceBuffers", function() { return createIsosurfaceBuffers; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _renderable__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../renderable */ "./lib/mol-gl/renderable.js");
/* harmony import */ var _webgl_render_item__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../webgl/render-item */ "./lib/mol-gl/webgl/render-item.js");
/* harmony import */ var _renderable_schema__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../renderable/schema */ "./lib/mol-gl/renderable/schema.js");
/* harmony import */ var _mol_gl_shader_code__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../../mol-gl/shader-code */ "./lib/mol-gl/shader-code.js");
/* harmony import */ var _mol_util__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../../mol-util */ "./lib/mol-util/index.js");
/* harmony import */ var _util__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../util */ "./lib/mol-gl/compute/util.js");
/* harmony import */ var _tables__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ./tables */ "./lib/mol-gl/compute/marching-cubes/tables.js");
/* harmony import */ var _mol_gl_shader_quad_vert__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ../../../mol-gl/shader/quad.vert */ "./lib/mol-gl/shader/quad.vert.js");
/* harmony import */ var _mol_gl_shader_marching_cubes_isosurface_frag__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ../../../mol-gl/shader/marching-cubes/isosurface.frag */ "./lib/mol-gl/shader/marching-cubes/isosurface.frag.js");
/**
 * Copyright (c) 2019-2021 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */










var IsosurfaceSchema = Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, _util__WEBPACK_IMPORTED_MODULE_6__["QuadSchema"]), { tTriIndices: Object(_renderable_schema__WEBPACK_IMPORTED_MODULE_3__["TextureSpec"])('image-uint8', 'alpha', 'ubyte', 'nearest'), tActiveVoxelsPyramid: Object(_renderable_schema__WEBPACK_IMPORTED_MODULE_3__["TextureSpec"])('texture', 'rgba', 'float', 'nearest'), tActiveVoxelsBase: Object(_renderable_schema__WEBPACK_IMPORTED_MODULE_3__["TextureSpec"])('texture', 'rgba', 'float', 'nearest'), tVolumeData: Object(_renderable_schema__WEBPACK_IMPORTED_MODULE_3__["TextureSpec"])('texture', 'rgba', 'ubyte', 'nearest'), uIsoValue: Object(_renderable_schema__WEBPACK_IMPORTED_MODULE_3__["UniformSpec"])('f'), uSize: Object(_renderable_schema__WEBPACK_IMPORTED_MODULE_3__["UniformSpec"])('f'), uLevels: Object(_renderable_schema__WEBPACK_IMPORTED_MODULE_3__["UniformSpec"])('f'), uCount: Object(_renderable_schema__WEBPACK_IMPORTED_MODULE_3__["UniformSpec"])('f'), uGridDim: Object(_renderable_schema__WEBPACK_IMPORTED_MODULE_3__["UniformSpec"])('v3'), uGridTexDim: Object(_renderable_schema__WEBPACK_IMPORTED_MODULE_3__["UniformSpec"])('v3'), uGridTransform: Object(_renderable_schema__WEBPACK_IMPORTED_MODULE_3__["UniformSpec"])('m4'), uScale: Object(_renderable_schema__WEBPACK_IMPORTED_MODULE_3__["UniformSpec"])('v2') });
var IsosurfaceName = 'isosurface';
function getIsosurfaceRenderable(ctx, activeVoxelsPyramid, activeVoxelsBase, volumeData, gridDim, gridTexDim, transform, isoValue, levels, scale, count, height) {
    if (ctx.namedComputeRenderables[IsosurfaceName]) {
        var v = ctx.namedComputeRenderables[IsosurfaceName].values;
        _mol_util__WEBPACK_IMPORTED_MODULE_5__["ValueCell"].update(v.tActiveVoxelsPyramid, activeVoxelsPyramid);
        _mol_util__WEBPACK_IMPORTED_MODULE_5__["ValueCell"].update(v.tActiveVoxelsBase, activeVoxelsBase);
        _mol_util__WEBPACK_IMPORTED_MODULE_5__["ValueCell"].update(v.tVolumeData, volumeData);
        _mol_util__WEBPACK_IMPORTED_MODULE_5__["ValueCell"].updateIfChanged(v.uIsoValue, isoValue);
        _mol_util__WEBPACK_IMPORTED_MODULE_5__["ValueCell"].updateIfChanged(v.uSize, Math.pow(2, levels));
        _mol_util__WEBPACK_IMPORTED_MODULE_5__["ValueCell"].updateIfChanged(v.uLevels, levels);
        _mol_util__WEBPACK_IMPORTED_MODULE_5__["ValueCell"].updateIfChanged(v.uCount, count);
        _mol_util__WEBPACK_IMPORTED_MODULE_5__["ValueCell"].update(v.uGridDim, gridDim);
        _mol_util__WEBPACK_IMPORTED_MODULE_5__["ValueCell"].update(v.uGridTexDim, gridTexDim);
        _mol_util__WEBPACK_IMPORTED_MODULE_5__["ValueCell"].update(v.uGridTransform, transform);
        _mol_util__WEBPACK_IMPORTED_MODULE_5__["ValueCell"].update(v.uScale, scale);
        ctx.namedComputeRenderables[IsosurfaceName].update();
    }
    else {
        ctx.namedComputeRenderables[IsosurfaceName] = createIsosurfaceRenderable(ctx, activeVoxelsPyramid, activeVoxelsBase, volumeData, gridDim, gridTexDim, transform, isoValue, levels, scale, count, height);
    }
    return ctx.namedComputeRenderables[IsosurfaceName];
}
function createIsosurfaceRenderable(ctx, activeVoxelsPyramid, activeVoxelsBase, volumeData, gridDim, gridTexDim, transform, isoValue, levels, scale, count, height) {
    // console.log('uSize', Math.pow(2, levels))
    var values = Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, _util__WEBPACK_IMPORTED_MODULE_6__["QuadValues"]), { tTriIndices: _mol_util__WEBPACK_IMPORTED_MODULE_5__["ValueCell"].create(Object(_tables__WEBPACK_IMPORTED_MODULE_7__["getTriIndices"])()), tActiveVoxelsPyramid: _mol_util__WEBPACK_IMPORTED_MODULE_5__["ValueCell"].create(activeVoxelsPyramid), tActiveVoxelsBase: _mol_util__WEBPACK_IMPORTED_MODULE_5__["ValueCell"].create(activeVoxelsBase), tVolumeData: _mol_util__WEBPACK_IMPORTED_MODULE_5__["ValueCell"].create(volumeData), uIsoValue: _mol_util__WEBPACK_IMPORTED_MODULE_5__["ValueCell"].create(isoValue), uSize: _mol_util__WEBPACK_IMPORTED_MODULE_5__["ValueCell"].create(Math.pow(2, levels)), uLevels: _mol_util__WEBPACK_IMPORTED_MODULE_5__["ValueCell"].create(levels), uCount: _mol_util__WEBPACK_IMPORTED_MODULE_5__["ValueCell"].create(count), uGridDim: _mol_util__WEBPACK_IMPORTED_MODULE_5__["ValueCell"].create(gridDim), uGridTexDim: _mol_util__WEBPACK_IMPORTED_MODULE_5__["ValueCell"].create(gridTexDim), uGridTransform: _mol_util__WEBPACK_IMPORTED_MODULE_5__["ValueCell"].create(transform), uScale: _mol_util__WEBPACK_IMPORTED_MODULE_5__["ValueCell"].create(scale) });
    var schema = Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, IsosurfaceSchema);
    var shaderCode = Object(_mol_gl_shader_code__WEBPACK_IMPORTED_MODULE_4__["ShaderCode"])('isosurface', _mol_gl_shader_quad_vert__WEBPACK_IMPORTED_MODULE_8__["default"], _mol_gl_shader_marching_cubes_isosurface_frag__WEBPACK_IMPORTED_MODULE_9__["default"], { drawBuffers: 'required' });
    var renderItem = Object(_webgl_render_item__WEBPACK_IMPORTED_MODULE_2__["createComputeRenderItem"])(ctx, 'triangles', shaderCode, schema, values);
    return Object(_renderable__WEBPACK_IMPORTED_MODULE_1__["createComputeRenderable"])(renderItem, values);
}
function setRenderingDefaults(ctx) {
    var gl = ctx.gl, state = ctx.state;
    state.disable(gl.CULL_FACE);
    state.disable(gl.BLEND);
    state.disable(gl.DEPTH_TEST);
    state.disable(gl.SCISSOR_TEST);
    state.depthMask(false);
    state.colorMask(true, true, true, true);
    state.clearColor(0, 0, 0, 0);
}
function createIsosurfaceBuffers(ctx, activeVoxelsBase, volumeData, histogramPyramid, gridDim, gridTexDim, transform, isoValue, vertexGroupTexture, normalTexture) {
    var gl = ctx.gl, resources = ctx.resources;
    var pyramidTex = histogramPyramid.pyramidTex, height = histogramPyramid.height, levels = histogramPyramid.levels, scale = histogramPyramid.scale, count = histogramPyramid.count;
    var width = pyramidTex.getWidth();
    // console.log('iso', 'gridDim', gridDim, 'scale', scale, 'gridTexDim', gridTexDim)
    // console.log('iso volumeData', volumeData)
    if (!ctx.namedFramebuffers[IsosurfaceName]) {
        ctx.namedFramebuffers[IsosurfaceName] = resources.framebuffer();
    }
    var framebuffer = ctx.namedFramebuffers[IsosurfaceName];
    if (!vertexGroupTexture) {
        vertexGroupTexture = resources.texture('image-float32', 'rgba', 'float', 'nearest');
    }
    vertexGroupTexture.define(width, height);
    if (!normalTexture) {
        normalTexture = resources.texture('image-float32', 'rgba', 'float', 'nearest');
    }
    normalTexture.define(width, height);
    // const infoTex = createTexture(ctx, 'image-float32', 'rgba', 'float', 'nearest')
    // infoTex.define(pyramidTex.width, pyramidTex.height)
    // const pointTexA = createTexture(ctx, 'image-float32', 'rgba', 'float', 'nearest')
    // pointTexA.define(pyramidTex.width, pyramidTex.height)
    // const pointTexB = createTexture(ctx, 'image-float32', 'rgba', 'float', 'nearest')
    // pointTexB.define(pyramidTex.width, pyramidTex.height)
    // const coordTex = createTexture(ctx, 'image-float32', 'rgba', 'float', 'nearest')
    // coordTex.define(pyramidTex.width, pyramidTex.height)
    // const indexTex = createTexture(ctx, 'image-float32', 'rgba', 'float', 'nearest')
    // indexTex.define(pyramidTex.width, pyramidTex.height)
    var renderable = getIsosurfaceRenderable(ctx, pyramidTex, activeVoxelsBase, volumeData, gridDim, gridTexDim, transform, isoValue, levels, scale, count, height);
    ctx.state.currentRenderItemId = -1;
    vertexGroupTexture.attachFramebuffer(framebuffer, 0);
    normalTexture.attachFramebuffer(framebuffer, 1);
    // infoTex.attachFramebuffer(framebuffer, 1)
    // pointTexA.attachFramebuffer(framebuffer, 2)
    // pointTexB.attachFramebuffer(framebuffer, 3)
    // coordTex.attachFramebuffer(framebuffer, 4)
    // indexTex.attachFramebuffer(framebuffer, 5)
    var drawBuffers = ctx.extensions.drawBuffers;
    if (!drawBuffers)
        throw new Error('need WebGL draw buffers');
    drawBuffers.drawBuffers([
        drawBuffers.COLOR_ATTACHMENT0,
        drawBuffers.COLOR_ATTACHMENT1,
    ]);
    setRenderingDefaults(ctx);
    gl.viewport(0, 0, width, height);
    gl.clear(gl.COLOR_BUFFER_BIT);
    renderable.render();
    gl.flush();
    // const vgt = readTexture(ctx, vertexGroupTexture, pyramidTex.width, height)
    // console.log('vertexGroupTexture', vgt.array.subarray(0, 4 * count))
    // const vt = readTexture(ctx, verticesTex, pyramidTex.width, height)
    // console.log('vt', vt)
    // const vertices = new Float32Array(3 * compacted.count)
    // for (let i = 0; i < compacted.count; ++i) {
    //     vertices[i * 3] = vt.array[i * 4]
    //     vertices[i * 3 + 1] = vt.array[i * 4 + 1]
    //     vertices[i * 3 + 2] = vt.array[i * 4 + 2]
    // }
    // console.log('vertices', vertices)
    // const it = readTexture(ctx, infoTex, pyramidTex.width, height)
    // console.log('info', it.array.subarray(0, 4 * compacted.count))
    // const pat = readTexture(ctx, pointTexA, pyramidTex.width, height)
    // console.log('point a', pat.array.subarray(0, 4 * compacted.count))
    // const pbt = readTexture(ctx, pointTexB, pyramidTex.width, height)
    // console.log('point b', pbt.array.subarray(0, 4 * compacted.count))
    // const ct = readTexture(ctx, coordTex, pyramidTex.width, height)
    // console.log('coord', ct.array.subarray(0, 4 * compacted.count))
    // const idxt = readTexture(ctx, indexTex, pyramidTex.width, height)
    // console.log('index', idxt.array.subarray(0, 4 * compacted.count))
    // const { field, idField } = await fieldFromTexture2d(ctx, volumeData, gridDimensions)
    // console.log({ field, idField })
    // const valuesA = new Float32Array(compacted.count)
    // const valuesB = new Float32Array(compacted.count)
    // for (let i = 0; i < compacted.count; ++i) {
    //     valuesA[i] = field.space.get(field.data, pat.array[i * 4], pat.array[i * 4 + 1], pat.array[i * 4 + 2])
    //     valuesB[i] = field.space.get(field.data, pbt.array[i * 4], pbt.array[i * 4 + 1], pbt.array[i * 4 + 2])
    // }
    // console.log('valuesA', valuesA)
    // console.log('valuesB', valuesB)
    return { vertexGroupTexture: vertexGroupTexture, normalTexture: normalTexture, vertexCount: count };
}
//# sourceMappingURL=isosurface.js.map

/***/ }),

/***/ "./lib/mol-gl/compute/marching-cubes/tables.js":
/*!*****************************************************!*\
  !*** ./lib/mol-gl/compute/marching-cubes/tables.js ***!
  \*****************************************************/
/*! exports provided: getTriCount, getTriIndices */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getTriCount", function() { return getTriCount; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getTriIndices", function() { return getTriIndices; });
/* harmony import */ var _mol_geo_util_marching_cubes_tables__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../../mol-geo/util/marching-cubes/tables */ "./lib/mol-geo/util/marching-cubes/tables.js");
/* harmony import */ var _mol_gl_renderable_util__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../../mol-gl/renderable/util */ "./lib/mol-gl/renderable/util.js");
/**
 * Copyright (c) 2019 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */


var TriCount;
function getTriCount() {
    if (TriCount !== undefined)
        return TriCount;
    TriCount = Object(_mol_gl_renderable_util__WEBPACK_IMPORTED_MODULE_1__["createTextureImage"])(16 * 16, 1, Uint8Array);
    var array = TriCount.array;
    for (var i = 0, il = _mol_geo_util_marching_cubes_tables__WEBPACK_IMPORTED_MODULE_0__["TriTable"].length; i < il; ++i) {
        array[i] = _mol_geo_util_marching_cubes_tables__WEBPACK_IMPORTED_MODULE_0__["TriTable"][i].length / 3;
    }
    return TriCount;
}
var TriIndices;
function getTriIndices() {
    if (TriIndices !== undefined)
        return TriIndices;
    TriIndices = Object(_mol_gl_renderable_util__WEBPACK_IMPORTED_MODULE_1__["createTextureImage"])(64 * 64, 1, Uint8Array);
    var array = TriIndices.array;
    for (var i = 0, il = _mol_geo_util_marching_cubes_tables__WEBPACK_IMPORTED_MODULE_0__["TriTable"].length; i < il; ++i) {
        for (var j = 0; j < 16; ++j) {
            if (j < _mol_geo_util_marching_cubes_tables__WEBPACK_IMPORTED_MODULE_0__["TriTable"][i].length) {
                array[i * 16 + j] = _mol_geo_util_marching_cubes_tables__WEBPACK_IMPORTED_MODULE_0__["TriTable"][i][j];
            }
            else {
                array[i * 16 + j] = 255;
            }
        }
    }
    return TriIndices;
}
//# sourceMappingURL=tables.js.map

/***/ }),

/***/ "./lib/mol-gl/compute/util.js":
/*!************************************!*\
  !*** ./lib/mol-gl/compute/util.js ***!
  \************************************/
/*! exports provided: QuadPositions, QuadSchema, QuadValues, readTexture, printTexture */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "QuadPositions", function() { return QuadPositions; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "QuadSchema", function() { return QuadSchema; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "QuadValues", function() { return QuadValues; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "readTexture", function() { return readTexture; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "printTexture", function() { return printTexture; });
/* harmony import */ var _mol_gl_renderable_util__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../mol-gl/renderable/util */ "./lib/mol-gl/renderable/util.js");
/* harmony import */ var _mol_util__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../mol-util */ "./lib/mol-util/index.js");
/* harmony import */ var _mol_gl_renderable_schema__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../mol-gl/renderable/schema */ "./lib/mol-gl/renderable/schema.js");
/* harmony import */ var _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../mol-math/linear-algebra */ "./lib/mol-math/linear-algebra.js");
/**
 * Copyright (c) 2020 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */




var QuadPositions = new Float32Array([
    1.0, 1.0, -1.0, 1.0, -1.0, -1.0,
    -1.0, -1.0, 1.0, -1.0, 1.0, 1.0 // Second triangle
]);
var QuadSchema = {
    drawCount: Object(_mol_gl_renderable_schema__WEBPACK_IMPORTED_MODULE_2__["ValueSpec"])('number'),
    instanceCount: Object(_mol_gl_renderable_schema__WEBPACK_IMPORTED_MODULE_2__["ValueSpec"])('number'),
    aPosition: Object(_mol_gl_renderable_schema__WEBPACK_IMPORTED_MODULE_2__["AttributeSpec"])('float32', 2, 0),
    uQuadScale: Object(_mol_gl_renderable_schema__WEBPACK_IMPORTED_MODULE_2__["UniformSpec"])('v2'),
};
var QuadValues = {
    drawCount: _mol_util__WEBPACK_IMPORTED_MODULE_1__["ValueCell"].create(6),
    instanceCount: _mol_util__WEBPACK_IMPORTED_MODULE_1__["ValueCell"].create(1),
    aPosition: _mol_util__WEBPACK_IMPORTED_MODULE_1__["ValueCell"].create(QuadPositions),
    uQuadScale: _mol_util__WEBPACK_IMPORTED_MODULE_1__["ValueCell"].create(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_3__["Vec2"].create(1, 1)),
};
//
function getArrayForTexture(gl, texture, size) {
    switch (texture.type) {
        case gl.UNSIGNED_BYTE: return new Uint8Array(size);
        case gl.FLOAT: return new Float32Array(size);
    }
    throw new Error('unknown/unsupported texture type');
}
function readTexture(ctx, texture, width, height) {
    var gl = ctx.gl, resources = ctx.resources;
    width = Object(_mol_util__WEBPACK_IMPORTED_MODULE_1__["defaults"])(width, texture.getWidth());
    height = Object(_mol_util__WEBPACK_IMPORTED_MODULE_1__["defaults"])(height, texture.getHeight());
    var size = width * height * 4;
    var framebuffer = resources.framebuffer();
    var array = getArrayForTexture(gl, texture, size);
    framebuffer.bind();
    texture.attachFramebuffer(framebuffer, 0);
    ctx.readPixels(0, 0, width, height, array);
    return { array: array, width: width, height: height };
}
function printTexture(ctx, texture, scale) {
    Object(_mol_gl_renderable_util__WEBPACK_IMPORTED_MODULE_0__["printTextureImage"])(readTexture(ctx, texture), scale);
}
//# sourceMappingURL=util.js.map

/***/ }),

/***/ "./lib/mol-gl/object3d.js":
/*!********************************!*\
  !*** ./lib/mol-gl/object3d.js ***!
  \********************************/
/*! exports provided: Object3D */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Object3D", function() { return Object3D; });
/* harmony import */ var _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../mol-math/linear-algebra */ "./lib/mol-math/linear-algebra.js");
/**
 * Copyright (c) 2018 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */

var Object3D;
(function (Object3D) {
    function create() {
        return {
            view: _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Mat4"].identity(),
            position: _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"].create(0, 0, 0),
            direction: _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"].create(0, 0, -1),
            up: _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"].create(0, 1, 0),
        };
    }
    Object3D.create = create;
    var center = _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"].zero();
    function update(object3d) {
        _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"].add(center, object3d.position, object3d.direction);
        _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Mat4"].lookAt(object3d.view, object3d.position, center, object3d.up);
    }
    Object3D.update = update;
})(Object3D || (Object3D = {}));
//# sourceMappingURL=object3d.js.map

/***/ }),

/***/ "./lib/mol-gl/render-object.js":
/*!*************************************!*\
  !*** ./lib/mol-gl/render-object.js ***!
  \*************************************/
/*! exports provided: getNextMaterialId, createRenderObject, createRenderable */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getNextMaterialId", function() { return getNextMaterialId; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createRenderObject", function() { return createRenderObject; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createRenderable", function() { return createRenderable; });
/* harmony import */ var _mol_util_id_factory__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../mol-util/id-factory */ "./lib/mol-util/id-factory.js");
/* harmony import */ var _renderable_direct_volume__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./renderable/direct-volume */ "./lib/mol-gl/renderable/direct-volume.js");
/* harmony import */ var _renderable_mesh__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./renderable/mesh */ "./lib/mol-gl/renderable/mesh.js");
/* harmony import */ var _renderable_points__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./renderable/points */ "./lib/mol-gl/renderable/points.js");
/* harmony import */ var _renderable_lines__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./renderable/lines */ "./lib/mol-gl/renderable/lines.js");
/* harmony import */ var _renderable_spheres__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./renderable/spheres */ "./lib/mol-gl/renderable/spheres.js");
/* harmony import */ var _renderable_text__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ./renderable/text */ "./lib/mol-gl/renderable/text.js");
/* harmony import */ var _renderable_texture_mesh__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ./renderable/texture-mesh */ "./lib/mol-gl/renderable/texture-mesh.js");
/* harmony import */ var _renderable_image__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ./renderable/image */ "./lib/mol-gl/renderable/image.js");
/* harmony import */ var _renderable_cylinders__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ./renderable/cylinders */ "./lib/mol-gl/renderable/cylinders.js");
/**
 * Copyright (c) 2018-2020 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */










var getNextId = Object(_mol_util_id_factory__WEBPACK_IMPORTED_MODULE_0__["idFactory"])(0, 0x7FFFFFFF);
var getNextMaterialId = Object(_mol_util_id_factory__WEBPACK_IMPORTED_MODULE_0__["idFactory"])(0, 0x7FFFFFFF);
//
function createRenderObject(type, values, state, materialId) {
    return { id: getNextId(), type: type, values: values, state: state, materialId: materialId };
}
function createRenderable(ctx, o) {
    switch (o.type) {
        case 'mesh': return Object(_renderable_mesh__WEBPACK_IMPORTED_MODULE_2__["MeshRenderable"])(ctx, o.id, o.values, o.state, o.materialId);
        case 'points': return Object(_renderable_points__WEBPACK_IMPORTED_MODULE_3__["PointsRenderable"])(ctx, o.id, o.values, o.state, o.materialId);
        case 'spheres': return Object(_renderable_spheres__WEBPACK_IMPORTED_MODULE_5__["SpheresRenderable"])(ctx, o.id, o.values, o.state, o.materialId);
        case 'cylinders': return Object(_renderable_cylinders__WEBPACK_IMPORTED_MODULE_9__["CylindersRenderable"])(ctx, o.id, o.values, o.state, o.materialId);
        case 'text': return Object(_renderable_text__WEBPACK_IMPORTED_MODULE_6__["TextRenderable"])(ctx, o.id, o.values, o.state, o.materialId);
        case 'lines': return Object(_renderable_lines__WEBPACK_IMPORTED_MODULE_4__["LinesRenderable"])(ctx, o.id, o.values, o.state, o.materialId);
        case 'direct-volume': return Object(_renderable_direct_volume__WEBPACK_IMPORTED_MODULE_1__["DirectVolumeRenderable"])(ctx, o.id, o.values, o.state, o.materialId);
        case 'image': return Object(_renderable_image__WEBPACK_IMPORTED_MODULE_8__["ImageRenderable"])(ctx, o.id, o.values, o.state, o.materialId);
        case 'texture-mesh': return Object(_renderable_texture_mesh__WEBPACK_IMPORTED_MODULE_7__["TextureMeshRenderable"])(ctx, o.id, o.values, o.state, o.materialId);
    }
    throw new Error('unsupported type');
}
//# sourceMappingURL=render-object.js.map

/***/ }),

/***/ "./lib/mol-gl/renderable.js":
/*!**********************************!*\
  !*** ./lib/mol-gl/renderable.js ***!
  \**********************************/
/*! exports provided: createRenderable, createComputeRenderable */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createRenderable", function() { return createRenderable; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createComputeRenderable", function() { return createComputeRenderable; });
/* harmony import */ var _mol_util__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../mol-util */ "./lib/mol-util/index.js");
/* harmony import */ var _mol_util_id_factory__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../mol-util/id-factory */ "./lib/mol-util/id-factory.js");
/* harmony import */ var _mol_math_interpolate__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../mol-math/interpolate */ "./lib/mol-math/interpolate.js");
/**
 * Copyright (c) 2018-2020 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */



var getNextRenderableId = Object(_mol_util_id_factory__WEBPACK_IMPORTED_MODULE_1__["idFactory"])();
function createRenderable(renderItem, values, state) {
    return {
        id: getNextRenderableId(),
        materialId: renderItem.materialId,
        values: values,
        state: state,
        render: function (variant, sharedTexturesList) {
            if (values.uAlpha && values.alpha) {
                _mol_util__WEBPACK_IMPORTED_MODULE_0__["ValueCell"].updateIfChanged(values.uAlpha, Object(_mol_math_interpolate__WEBPACK_IMPORTED_MODULE_2__["clamp"])(values.alpha.ref.value * state.alphaFactor, 0, 1));
            }
            renderItem.render(variant, sharedTexturesList);
        },
        getProgram: function (variant) { return renderItem.getProgram(variant); },
        update: function () { return renderItem.update(); },
        dispose: function () { return renderItem.destroy(); }
    };
}
function createComputeRenderable(renderItem, values) {
    return {
        id: getNextRenderableId(),
        values: values,
        render: function () { return renderItem.render('compute'); },
        update: function () { return renderItem.update(); },
        dispose: function () { return renderItem.destroy(); }
    };
}
//# sourceMappingURL=renderable.js.map

/***/ }),

/***/ "./lib/mol-gl/renderable/cylinders.js":
/*!********************************************!*\
  !*** ./lib/mol-gl/renderable/cylinders.js ***!
  \********************************************/
/*! exports provided: CylindersSchema, CylindersRenderable */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CylindersSchema", function() { return CylindersSchema; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CylindersRenderable", function() { return CylindersRenderable; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _renderable__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../renderable */ "./lib/mol-gl/renderable.js");
/* harmony import */ var _webgl_render_item__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../webgl/render-item */ "./lib/mol-gl/webgl/render-item.js");
/* harmony import */ var _schema__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./schema */ "./lib/mol-gl/renderable/schema.js");
/* harmony import */ var _shader_code__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../shader-code */ "./lib/mol-gl/shader-code.js");
/* harmony import */ var _mol_util__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../mol-util */ "./lib/mol-util/index.js");
/**
 * Copyright (c) 2020 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */






var CylindersSchema = Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, _schema__WEBPACK_IMPORTED_MODULE_3__["BaseSchema"]), _schema__WEBPACK_IMPORTED_MODULE_3__["SizeSchema"]), { aGroup: Object(_schema__WEBPACK_IMPORTED_MODULE_3__["AttributeSpec"])('float32', 1, 0), aStart: Object(_schema__WEBPACK_IMPORTED_MODULE_3__["AttributeSpec"])('float32', 3, 0), aEnd: Object(_schema__WEBPACK_IMPORTED_MODULE_3__["AttributeSpec"])('float32', 3, 0), aMapping: Object(_schema__WEBPACK_IMPORTED_MODULE_3__["AttributeSpec"])('float32', 3, 0), aScale: Object(_schema__WEBPACK_IMPORTED_MODULE_3__["AttributeSpec"])('float32', 1, 0), aCap: Object(_schema__WEBPACK_IMPORTED_MODULE_3__["AttributeSpec"])('float32', 1, 0), elements: Object(_schema__WEBPACK_IMPORTED_MODULE_3__["ElementsSpec"])('uint32'), padding: Object(_schema__WEBPACK_IMPORTED_MODULE_3__["ValueSpec"])('number'), dDoubleSided: Object(_schema__WEBPACK_IMPORTED_MODULE_3__["DefineSpec"])('boolean'), dIgnoreLight: Object(_schema__WEBPACK_IMPORTED_MODULE_3__["DefineSpec"])('boolean'), dXrayShaded: Object(_schema__WEBPACK_IMPORTED_MODULE_3__["DefineSpec"])('boolean') });
function CylindersRenderable(ctx, id, values, state, materialId) {
    var schema = Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, _schema__WEBPACK_IMPORTED_MODULE_3__["GlobalUniformSchema"]), _schema__WEBPACK_IMPORTED_MODULE_3__["GlobalTextureSchema"]), _schema__WEBPACK_IMPORTED_MODULE_3__["InternalSchema"]), CylindersSchema);
    var internalValues = {
        uObjectId: _mol_util__WEBPACK_IMPORTED_MODULE_5__["ValueCell"].create(id),
    };
    var shaderCode = _shader_code__WEBPACK_IMPORTED_MODULE_4__["CylindersShaderCode"];
    var renderItem = Object(_webgl_render_item__WEBPACK_IMPORTED_MODULE_2__["createGraphicsRenderItem"])(ctx, 'triangles', shaderCode, schema, Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, values), internalValues), materialId);
    return Object(_renderable__WEBPACK_IMPORTED_MODULE_1__["createRenderable"])(renderItem, values, state);
}
//# sourceMappingURL=cylinders.js.map

/***/ }),

/***/ "./lib/mol-gl/renderable/direct-volume.js":
/*!************************************************!*\
  !*** ./lib/mol-gl/renderable/direct-volume.js ***!
  \************************************************/
/*! exports provided: DirectVolumeSchema, DirectVolumeRenderable */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DirectVolumeSchema", function() { return DirectVolumeSchema; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DirectVolumeRenderable", function() { return DirectVolumeRenderable; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _renderable__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../renderable */ "./lib/mol-gl/renderable.js");
/* harmony import */ var _webgl_render_item__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../webgl/render-item */ "./lib/mol-gl/webgl/render-item.js");
/* harmony import */ var _schema__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./schema */ "./lib/mol-gl/renderable/schema.js");
/* harmony import */ var _shader_code__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../shader-code */ "./lib/mol-gl/shader-code.js");
/* harmony import */ var _mol_util__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../mol-util */ "./lib/mol-util/index.js");
/**
 * Copyright (c) 2018-2020 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */






var DirectVolumeSchema = Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, _schema__WEBPACK_IMPORTED_MODULE_3__["BaseSchema"]), { aPosition: Object(_schema__WEBPACK_IMPORTED_MODULE_3__["AttributeSpec"])('float32', 3, 0), elements: Object(_schema__WEBPACK_IMPORTED_MODULE_3__["ElementsSpec"])('uint32'), uColor: Object(_schema__WEBPACK_IMPORTED_MODULE_3__["UniformSpec"])('v3'), uColorTexDim: Object(_schema__WEBPACK_IMPORTED_MODULE_3__["UniformSpec"])('v2'), tColor: Object(_schema__WEBPACK_IMPORTED_MODULE_3__["TextureSpec"])('image-uint8', 'rgb', 'ubyte', 'nearest'), dColorType: Object(_schema__WEBPACK_IMPORTED_MODULE_3__["DefineSpec"])('string', ['uniform', 'attribute', 'instance', 'group', 'groupInstance', 'vertex', 'vertexInstance']), uIsoValue: Object(_schema__WEBPACK_IMPORTED_MODULE_3__["UniformSpec"])('v2'), uBboxMin: Object(_schema__WEBPACK_IMPORTED_MODULE_3__["UniformSpec"])('v3'), uBboxMax: Object(_schema__WEBPACK_IMPORTED_MODULE_3__["UniformSpec"])('v3'), uBboxSize: Object(_schema__WEBPACK_IMPORTED_MODULE_3__["UniformSpec"])('v3'), uMaxSteps: Object(_schema__WEBPACK_IMPORTED_MODULE_3__["UniformSpec"])('i'), uStepScale: Object(_schema__WEBPACK_IMPORTED_MODULE_3__["UniformSpec"])('f'), uJumpLength: Object(_schema__WEBPACK_IMPORTED_MODULE_3__["UniformSpec"])('f'), uTransform: Object(_schema__WEBPACK_IMPORTED_MODULE_3__["UniformSpec"])('m4'), uGridDim: Object(_schema__WEBPACK_IMPORTED_MODULE_3__["UniformSpec"])('v3'), dRenderMode: Object(_schema__WEBPACK_IMPORTED_MODULE_3__["DefineSpec"])('string', ['isosurface', 'volume']), dSingleLayer: Object(_schema__WEBPACK_IMPORTED_MODULE_3__["DefineSpec"])('boolean'), tTransferTex: Object(_schema__WEBPACK_IMPORTED_MODULE_3__["TextureSpec"])('image-uint8', 'rgba', 'ubyte', 'linear'), uTransferScale: Object(_schema__WEBPACK_IMPORTED_MODULE_3__["UniformSpec"])('f'), dGridTexType: Object(_schema__WEBPACK_IMPORTED_MODULE_3__["DefineSpec"])('string', ['2d', '3d']), uGridTexDim: Object(_schema__WEBPACK_IMPORTED_MODULE_3__["UniformSpec"])('v3'), tGridTex: Object(_schema__WEBPACK_IMPORTED_MODULE_3__["TextureSpec"])('texture', 'rgba', 'ubyte', 'linear'), uGridStats: Object(_schema__WEBPACK_IMPORTED_MODULE_3__["UniformSpec"])('v4'), uCellDim: Object(_schema__WEBPACK_IMPORTED_MODULE_3__["UniformSpec"])('v3'), uCartnToUnit: Object(_schema__WEBPACK_IMPORTED_MODULE_3__["UniformSpec"])('m4'), uUnitToCartn: Object(_schema__WEBPACK_IMPORTED_MODULE_3__["UniformSpec"])('m4'), dPackedGroup: Object(_schema__WEBPACK_IMPORTED_MODULE_3__["DefineSpec"])('boolean'), dDoubleSided: Object(_schema__WEBPACK_IMPORTED_MODULE_3__["DefineSpec"])('boolean'), dFlipSided: Object(_schema__WEBPACK_IMPORTED_MODULE_3__["DefineSpec"])('boolean'), dFlatShaded: Object(_schema__WEBPACK_IMPORTED_MODULE_3__["DefineSpec"])('boolean'), dIgnoreLight: Object(_schema__WEBPACK_IMPORTED_MODULE_3__["DefineSpec"])('boolean'), dXrayShaded: Object(_schema__WEBPACK_IMPORTED_MODULE_3__["DefineSpec"])('boolean') });
function DirectVolumeRenderable(ctx, id, values, state, materialId) {
    var schema = Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, _schema__WEBPACK_IMPORTED_MODULE_3__["GlobalUniformSchema"]), _schema__WEBPACK_IMPORTED_MODULE_3__["GlobalTextureSchema"]), _schema__WEBPACK_IMPORTED_MODULE_3__["InternalSchema"]), DirectVolumeSchema);
    if (!ctx.isWebGL2) {
        // workaround for webgl1 limitation that loop counters need to be `const`
        schema.uMaxSteps = Object(_schema__WEBPACK_IMPORTED_MODULE_3__["DefineSpec"])('number');
    }
    var internalValues = {
        uObjectId: _mol_util__WEBPACK_IMPORTED_MODULE_5__["ValueCell"].create(id),
    };
    var shaderCode = _shader_code__WEBPACK_IMPORTED_MODULE_4__["DirectVolumeShaderCode"];
    var renderItem = Object(_webgl_render_item__WEBPACK_IMPORTED_MODULE_2__["createGraphicsRenderItem"])(ctx, 'triangles', shaderCode, schema, Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, values), internalValues), materialId);
    return Object(_renderable__WEBPACK_IMPORTED_MODULE_1__["createRenderable"])(renderItem, values, state);
}
//# sourceMappingURL=direct-volume.js.map

/***/ }),

/***/ "./lib/mol-gl/renderable/image.js":
/*!****************************************!*\
  !*** ./lib/mol-gl/renderable/image.js ***!
  \****************************************/
/*! exports provided: ImageSchema, ImageRenderable */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ImageSchema", function() { return ImageSchema; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ImageRenderable", function() { return ImageRenderable; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _renderable__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../renderable */ "./lib/mol-gl/renderable.js");
/* harmony import */ var _webgl_render_item__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../webgl/render-item */ "./lib/mol-gl/webgl/render-item.js");
/* harmony import */ var _schema__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./schema */ "./lib/mol-gl/renderable/schema.js");
/* harmony import */ var _shader_code__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../shader-code */ "./lib/mol-gl/shader-code.js");
/* harmony import */ var _mol_util__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../mol-util */ "./lib/mol-util/index.js");
/* harmony import */ var _mol_geo_geometry_image_image__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../../mol-geo/geometry/image/image */ "./lib/mol-geo/geometry/image/image.js");
/**
 * Copyright (c) 2020 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */







var ImageSchema = Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, _schema__WEBPACK_IMPORTED_MODULE_3__["BaseSchema"]), { aGroup: Object(_schema__WEBPACK_IMPORTED_MODULE_3__["AttributeSpec"])('float32', 1, 0), aPosition: Object(_schema__WEBPACK_IMPORTED_MODULE_3__["AttributeSpec"])('float32', 3, 0), aUv: Object(_schema__WEBPACK_IMPORTED_MODULE_3__["AttributeSpec"])('float32', 2, 0), elements: Object(_schema__WEBPACK_IMPORTED_MODULE_3__["ElementsSpec"])('uint32'), uImageTexDim: Object(_schema__WEBPACK_IMPORTED_MODULE_3__["UniformSpec"])('v2'), tImageTex: Object(_schema__WEBPACK_IMPORTED_MODULE_3__["TextureSpec"])('image-uint8', 'rgba', 'ubyte', 'nearest'), tGroupTex: Object(_schema__WEBPACK_IMPORTED_MODULE_3__["TextureSpec"])('image-uint8', 'rgba', 'ubyte', 'nearest'), dInterpolation: Object(_schema__WEBPACK_IMPORTED_MODULE_3__["DefineSpec"])('string', _mol_geo_geometry_image_image__WEBPACK_IMPORTED_MODULE_6__["InterpolationTypeNames"]) });
function ImageRenderable(ctx, id, values, state, materialId) {
    var schema = Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, _schema__WEBPACK_IMPORTED_MODULE_3__["GlobalUniformSchema"]), _schema__WEBPACK_IMPORTED_MODULE_3__["GlobalTextureSchema"]), _schema__WEBPACK_IMPORTED_MODULE_3__["InternalSchema"]), ImageSchema);
    var internalValues = {
        uObjectId: _mol_util__WEBPACK_IMPORTED_MODULE_5__["ValueCell"].create(id),
    };
    var shaderCode = _shader_code__WEBPACK_IMPORTED_MODULE_4__["ImageShaderCode"];
    var renderItem = Object(_webgl_render_item__WEBPACK_IMPORTED_MODULE_2__["createGraphicsRenderItem"])(ctx, 'triangles', shaderCode, schema, Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, values), internalValues), materialId);
    return Object(_renderable__WEBPACK_IMPORTED_MODULE_1__["createRenderable"])(renderItem, values, state);
}
//# sourceMappingURL=image.js.map

/***/ }),

/***/ "./lib/mol-gl/renderable/lines.js":
/*!****************************************!*\
  !*** ./lib/mol-gl/renderable/lines.js ***!
  \****************************************/
/*! exports provided: LinesSchema, LinesRenderable */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "LinesSchema", function() { return LinesSchema; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "LinesRenderable", function() { return LinesRenderable; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _renderable__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../renderable */ "./lib/mol-gl/renderable.js");
/* harmony import */ var _webgl_render_item__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../webgl/render-item */ "./lib/mol-gl/webgl/render-item.js");
/* harmony import */ var _schema__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./schema */ "./lib/mol-gl/renderable/schema.js");
/* harmony import */ var _mol_util__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../mol-util */ "./lib/mol-util/index.js");
/* harmony import */ var _shader_code__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../shader-code */ "./lib/mol-gl/shader-code.js");
/**
 * Copyright (c) 2018 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */






var LinesSchema = Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, _schema__WEBPACK_IMPORTED_MODULE_3__["BaseSchema"]), _schema__WEBPACK_IMPORTED_MODULE_3__["SizeSchema"]), { aGroup: Object(_schema__WEBPACK_IMPORTED_MODULE_3__["AttributeSpec"])('float32', 1, 0), aMapping: Object(_schema__WEBPACK_IMPORTED_MODULE_3__["AttributeSpec"])('float32', 2, 0), aStart: Object(_schema__WEBPACK_IMPORTED_MODULE_3__["AttributeSpec"])('float32', 3, 0), aEnd: Object(_schema__WEBPACK_IMPORTED_MODULE_3__["AttributeSpec"])('float32', 3, 0), elements: Object(_schema__WEBPACK_IMPORTED_MODULE_3__["ElementsSpec"])('uint32'), dLineSizeAttenuation: Object(_schema__WEBPACK_IMPORTED_MODULE_3__["DefineSpec"])('boolean'), dDoubleSided: Object(_schema__WEBPACK_IMPORTED_MODULE_3__["DefineSpec"])('boolean'), dFlipSided: Object(_schema__WEBPACK_IMPORTED_MODULE_3__["DefineSpec"])('boolean') });
function LinesRenderable(ctx, id, values, state, materialId) {
    var schema = Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, _schema__WEBPACK_IMPORTED_MODULE_3__["GlobalUniformSchema"]), _schema__WEBPACK_IMPORTED_MODULE_3__["GlobalTextureSchema"]), _schema__WEBPACK_IMPORTED_MODULE_3__["InternalSchema"]), LinesSchema);
    var internalValues = {
        uObjectId: _mol_util__WEBPACK_IMPORTED_MODULE_4__["ValueCell"].create(id),
    };
    var shaderCode = _shader_code__WEBPACK_IMPORTED_MODULE_5__["LinesShaderCode"];
    var renderItem = Object(_webgl_render_item__WEBPACK_IMPORTED_MODULE_2__["createGraphicsRenderItem"])(ctx, 'triangles', shaderCode, schema, Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, values), internalValues), materialId);
    return Object(_renderable__WEBPACK_IMPORTED_MODULE_1__["createRenderable"])(renderItem, values, state);
}
//# sourceMappingURL=lines.js.map

/***/ }),

/***/ "./lib/mol-gl/renderable/mesh.js":
/*!***************************************!*\
  !*** ./lib/mol-gl/renderable/mesh.js ***!
  \***************************************/
/*! exports provided: MeshSchema, MeshRenderable */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MeshSchema", function() { return MeshSchema; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MeshRenderable", function() { return MeshRenderable; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _renderable__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../renderable */ "./lib/mol-gl/renderable.js");
/* harmony import */ var _webgl_render_item__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../webgl/render-item */ "./lib/mol-gl/webgl/render-item.js");
/* harmony import */ var _schema__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./schema */ "./lib/mol-gl/renderable/schema.js");
/* harmony import */ var _shader_code__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../shader-code */ "./lib/mol-gl/shader-code.js");
/* harmony import */ var _mol_util__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../mol-util */ "./lib/mol-util/index.js");
/**
 * Copyright (c) 2018-2020 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */






var MeshSchema = Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, _schema__WEBPACK_IMPORTED_MODULE_3__["BaseSchema"]), { aGroup: Object(_schema__WEBPACK_IMPORTED_MODULE_3__["AttributeSpec"])('float32', 1, 0), aPosition: Object(_schema__WEBPACK_IMPORTED_MODULE_3__["AttributeSpec"])('float32', 3, 0), aNormal: Object(_schema__WEBPACK_IMPORTED_MODULE_3__["AttributeSpec"])('float32', 3, 0), elements: Object(_schema__WEBPACK_IMPORTED_MODULE_3__["ElementsSpec"])('uint32'), dFlatShaded: Object(_schema__WEBPACK_IMPORTED_MODULE_3__["DefineSpec"])('boolean'), dDoubleSided: Object(_schema__WEBPACK_IMPORTED_MODULE_3__["DefineSpec"])('boolean'), dFlipSided: Object(_schema__WEBPACK_IMPORTED_MODULE_3__["DefineSpec"])('boolean'), dIgnoreLight: Object(_schema__WEBPACK_IMPORTED_MODULE_3__["DefineSpec"])('boolean'), dXrayShaded: Object(_schema__WEBPACK_IMPORTED_MODULE_3__["DefineSpec"])('boolean') });
function MeshRenderable(ctx, id, values, state, materialId) {
    var schema = Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, _schema__WEBPACK_IMPORTED_MODULE_3__["GlobalUniformSchema"]), _schema__WEBPACK_IMPORTED_MODULE_3__["GlobalTextureSchema"]), _schema__WEBPACK_IMPORTED_MODULE_3__["InternalSchema"]), MeshSchema);
    var internalValues = {
        uObjectId: _mol_util__WEBPACK_IMPORTED_MODULE_5__["ValueCell"].create(id),
    };
    var shaderCode = _shader_code__WEBPACK_IMPORTED_MODULE_4__["MeshShaderCode"];
    var renderItem = Object(_webgl_render_item__WEBPACK_IMPORTED_MODULE_2__["createGraphicsRenderItem"])(ctx, 'triangles', shaderCode, schema, Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, values), internalValues), materialId);
    return Object(_renderable__WEBPACK_IMPORTED_MODULE_1__["createRenderable"])(renderItem, values, state);
}
//# sourceMappingURL=mesh.js.map

/***/ }),

/***/ "./lib/mol-gl/renderable/points.js":
/*!*****************************************!*\
  !*** ./lib/mol-gl/renderable/points.js ***!
  \*****************************************/
/*! exports provided: PointsSchema, PointsRenderable */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "PointsSchema", function() { return PointsSchema; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "PointsRenderable", function() { return PointsRenderable; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _renderable__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../renderable */ "./lib/mol-gl/renderable.js");
/* harmony import */ var _webgl_render_item__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../webgl/render-item */ "./lib/mol-gl/webgl/render-item.js");
/* harmony import */ var _schema__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./schema */ "./lib/mol-gl/renderable/schema.js");
/* harmony import */ var _shader_code__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../shader-code */ "./lib/mol-gl/shader-code.js");
/* harmony import */ var _mol_util__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../mol-util */ "./lib/mol-util/index.js");
/**
 * Copyright (c) 2018 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */






var PointsSchema = Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, _schema__WEBPACK_IMPORTED_MODULE_3__["BaseSchema"]), _schema__WEBPACK_IMPORTED_MODULE_3__["SizeSchema"]), { aGroup: Object(_schema__WEBPACK_IMPORTED_MODULE_3__["AttributeSpec"])('float32', 1, 0), aPosition: Object(_schema__WEBPACK_IMPORTED_MODULE_3__["AttributeSpec"])('float32', 3, 0), dPointSizeAttenuation: Object(_schema__WEBPACK_IMPORTED_MODULE_3__["DefineSpec"])('boolean'), dPointFilledCircle: Object(_schema__WEBPACK_IMPORTED_MODULE_3__["DefineSpec"])('boolean'), uPointEdgeBleach: Object(_schema__WEBPACK_IMPORTED_MODULE_3__["UniformSpec"])('f') });
function PointsRenderable(ctx, id, values, state, materialId) {
    var schema = Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, _schema__WEBPACK_IMPORTED_MODULE_3__["GlobalUniformSchema"]), _schema__WEBPACK_IMPORTED_MODULE_3__["GlobalTextureSchema"]), _schema__WEBPACK_IMPORTED_MODULE_3__["InternalSchema"]), PointsSchema);
    var internalValues = {
        uObjectId: _mol_util__WEBPACK_IMPORTED_MODULE_5__["ValueCell"].create(id),
    };
    var shaderCode = _shader_code__WEBPACK_IMPORTED_MODULE_4__["PointsShaderCode"];
    var renderItem = Object(_webgl_render_item__WEBPACK_IMPORTED_MODULE_2__["createGraphicsRenderItem"])(ctx, 'points', shaderCode, schema, Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, values), internalValues), materialId);
    return Object(_renderable__WEBPACK_IMPORTED_MODULE_1__["createRenderable"])(renderItem, values, state);
}
//# sourceMappingURL=points.js.map

/***/ }),

/***/ "./lib/mol-gl/renderable/schema.js":
/*!*****************************************!*\
  !*** ./lib/mol-gl/renderable/schema.js ***!
  \*****************************************/
/*! exports provided: splitValues, getValueVersions, AttributeSpec, UniformSpec, TextureSpec, ElementsSpec, DefineSpec, ValueSpec, GlobalUniformSchema, GlobalTextureSchema, InternalSchema, ColorSchema, SizeSchema, MarkerSchema, OverpaintSchema, TransparencySchema, ClippingSchema, BaseSchema */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "splitValues", function() { return splitValues; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getValueVersions", function() { return getValueVersions; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "AttributeSpec", function() { return AttributeSpec; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "UniformSpec", function() { return UniformSpec; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "TextureSpec", function() { return TextureSpec; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ElementsSpec", function() { return ElementsSpec; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DefineSpec", function() { return DefineSpec; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ValueSpec", function() { return ValueSpec; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "GlobalUniformSchema", function() { return GlobalUniformSchema; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "GlobalTextureSchema", function() { return GlobalTextureSchema; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "InternalSchema", function() { return InternalSchema; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ColorSchema", function() { return ColorSchema; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SizeSchema", function() { return SizeSchema; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MarkerSchema", function() { return MarkerSchema; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "OverpaintSchema", function() { return OverpaintSchema; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "TransparencySchema", function() { return TransparencySchema; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ClippingSchema", function() { return ClippingSchema; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "BaseSchema", function() { return BaseSchema; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/**
 * Copyright (c) 2018-2020 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */

function splitValues(schema, values) {
    var attributeValues = {};
    var defineValues = {};
    var textureValues = {};
    var uniformValues = {};
    var materialUniformValues = {};
    Object.keys(schema).forEach(function (k) {
        var spec = schema[k];
        if (spec.type === 'attribute')
            attributeValues[k] = values[k];
        if (spec.type === 'define')
            defineValues[k] = values[k];
        // check if k exists in values to exclude global textures
        if (spec.type === 'texture' && values[k] !== undefined)
            textureValues[k] = values[k];
        // check if k exists in values to exclude global uniforms
        if (spec.type === 'uniform' && values[k] !== undefined) {
            if (spec.isMaterial)
                materialUniformValues[k] = values[k];
            else
                uniformValues[k] = values[k];
        }
    });
    return { attributeValues: attributeValues, defineValues: defineValues, textureValues: textureValues, uniformValues: uniformValues, materialUniformValues: materialUniformValues };
}
function getValueVersions(values) {
    var versions = {};
    Object.keys(values).forEach(function (k) {
        versions[k] = values[k].ref.version;
    });
    return versions;
}
function AttributeSpec(kind, itemSize, divisor) {
    return { type: 'attribute', kind: kind, itemSize: itemSize, divisor: divisor };
}
function UniformSpec(kind, isMaterial) {
    if (isMaterial === void 0) { isMaterial = false; }
    return { type: 'uniform', kind: kind, isMaterial: isMaterial };
}
function TextureSpec(kind, format, dataType, filter) {
    return { type: 'texture', kind: kind, format: format, dataType: dataType, filter: filter };
}
function ElementsSpec(kind) {
    return { type: 'elements', kind: kind };
}
function DefineSpec(kind, options) {
    return { type: 'define', kind: kind, options: options };
}
function ValueSpec(kind) {
    return { type: 'value', kind: kind };
}
//
var GlobalUniformSchema = {
    uModel: UniformSpec('m4'),
    uView: UniformSpec('m4'),
    uInvView: UniformSpec('m4'),
    uModelView: UniformSpec('m4'),
    uInvModelView: UniformSpec('m4'),
    uProjection: UniformSpec('m4'),
    uInvProjection: UniformSpec('m4'),
    uModelViewProjection: UniformSpec('m4'),
    uInvModelViewProjection: UniformSpec('m4'),
    uIsOrtho: UniformSpec('f'),
    uPixelRatio: UniformSpec('f'),
    uViewportHeight: UniformSpec('f'),
    uViewport: UniformSpec('v4'),
    uViewOffset: UniformSpec('v2'),
    uDrawingBufferSize: UniformSpec('v2'),
    uCameraPosition: UniformSpec('v3'),
    uCameraDir: UniformSpec('v3'),
    uNear: UniformSpec('f'),
    uFar: UniformSpec('f'),
    uFogNear: UniformSpec('f'),
    uFogFar: UniformSpec('f'),
    uFogColor: UniformSpec('v3'),
    uTransparentBackground: UniformSpec('b'),
    uClipObjectType: UniformSpec('i[]'),
    uClipObjectInvert: UniformSpec('b[]'),
    uClipObjectPosition: UniformSpec('v3[]'),
    uClipObjectRotation: UniformSpec('v4[]'),
    uClipObjectScale: UniformSpec('v3[]'),
    // all the following could in principle be per object
    // as a kind of 'material' parameter set
    // would need to test performance implications
    uLightIntensity: UniformSpec('f'),
    uAmbientIntensity: UniformSpec('f'),
    uMetalness: UniformSpec('f'),
    uRoughness: UniformSpec('f'),
    uReflectivity: UniformSpec('f'),
    uPickingAlphaThreshold: UniformSpec('f'),
    uInteriorDarkening: UniformSpec('f'),
    uInteriorColorFlag: UniformSpec('b'),
    uInteriorColor: UniformSpec('v3'),
    uHighlightColor: UniformSpec('v3'),
    uSelectColor: UniformSpec('v3'),
    uXrayEdgeFalloff: UniformSpec('f'),
    uRenderWboit: UniformSpec('b'),
};
var GlobalTextureSchema = {
    tDepth: TextureSpec('texture', 'depth', 'ushort', 'nearest'),
};
var InternalSchema = {
    uObjectId: UniformSpec('i'),
};
var ColorSchema = {
    // aColor: AttributeSpec('float32', 3, 0), // TODO
    uColor: UniformSpec('v3', true),
    uColorTexDim: UniformSpec('v2'),
    tColor: TextureSpec('image-uint8', 'rgb', 'ubyte', 'nearest'),
    dColorType: DefineSpec('string', ['uniform', 'attribute', 'instance', 'group', 'groupInstance', 'vertex', 'vertexInstance']),
};
var SizeSchema = {
    // aSize: AttributeSpec('float32', 1, 0), // TODO
    uSize: UniformSpec('f', true),
    uSizeTexDim: UniformSpec('v2'),
    tSize: TextureSpec('image-uint8', 'rgb', 'ubyte', 'nearest'),
    dSizeType: DefineSpec('string', ['uniform', 'attribute', 'instance', 'group', 'groupInstance']),
    uSizeFactor: UniformSpec('f'),
};
var MarkerSchema = {
    uMarkerTexDim: UniformSpec('v2'),
    tMarker: TextureSpec('image-uint8', 'alpha', 'ubyte', 'nearest'),
};
var OverpaintSchema = {
    uOverpaintTexDim: UniformSpec('v2'),
    tOverpaint: TextureSpec('image-uint8', 'rgba', 'ubyte', 'nearest'),
    dOverpaint: DefineSpec('boolean'),
};
var TransparencySchema = {
    uTransparencyTexDim: UniformSpec('v2'),
    tTransparency: TextureSpec('image-uint8', 'alpha', 'ubyte', 'nearest'),
    dTransparency: DefineSpec('boolean'),
    transparencyAverage: ValueSpec('number'),
};
var ClippingSchema = {
    dClipObjectCount: DefineSpec('number'),
    dClipVariant: DefineSpec('string', ['instance', 'pixel']),
    uClippingTexDim: UniformSpec('v2'),
    tClipping: TextureSpec('image-uint8', 'alpha', 'ubyte', 'nearest'),
    dClipping: DefineSpec('boolean'),
};
var BaseSchema = Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, ColorSchema), MarkerSchema), OverpaintSchema), TransparencySchema), ClippingSchema), { aInstance: AttributeSpec('float32', 1, 1), 
    /**
     * final per-instance transform calculated for instance `i` as
     * `aTransform[i] = matrix * transform[i] * extraTransform[i]`
     */
    aTransform: AttributeSpec('float32', 16, 1), 
    /**
     * final alpha, calculated as `values.alpha * state.alpha`
     */
    uAlpha: UniformSpec('f', true), uVertexCount: UniformSpec('i'), uInstanceCount: UniformSpec('i'), uGroupCount: UniformSpec('i'), uInvariantBoundingSphere: UniformSpec('v4'), drawCount: ValueSpec('number'), instanceCount: ValueSpec('number'), 
    /** base alpha, see uAlpha  */
    alpha: ValueSpec('number'), 
    /** global transform, see aTransform */
    matrix: ValueSpec('m4'), 
    /** base per-instance transform, see aTransform */
    transform: ValueSpec('float32'), 
    /** additional per-instance transform, see aTransform */
    extraTransform: ValueSpec('float32'), 
    /** denotes reflection in transform */
    hasReflection: ValueSpec('boolean'), 
    /** bounding sphere taking aTransform into account and encompases all instances */
    boundingSphere: ValueSpec('sphere'), 
    /** bounding sphere NOT taking aTransform into account */
    invariantBoundingSphere: ValueSpec('sphere') });
//# sourceMappingURL=schema.js.map

/***/ }),

/***/ "./lib/mol-gl/renderable/spheres.js":
/*!******************************************!*\
  !*** ./lib/mol-gl/renderable/spheres.js ***!
  \******************************************/
/*! exports provided: SpheresSchema, SpheresRenderable */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SpheresSchema", function() { return SpheresSchema; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SpheresRenderable", function() { return SpheresRenderable; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _renderable__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../renderable */ "./lib/mol-gl/renderable.js");
/* harmony import */ var _webgl_render_item__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../webgl/render-item */ "./lib/mol-gl/webgl/render-item.js");
/* harmony import */ var _schema__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./schema */ "./lib/mol-gl/renderable/schema.js");
/* harmony import */ var _shader_code__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../shader-code */ "./lib/mol-gl/shader-code.js");
/* harmony import */ var _mol_util__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../mol-util */ "./lib/mol-util/index.js");
/**
 * Copyright (c) 2019-2020 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */






var SpheresSchema = Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, _schema__WEBPACK_IMPORTED_MODULE_3__["BaseSchema"]), _schema__WEBPACK_IMPORTED_MODULE_3__["SizeSchema"]), { aGroup: Object(_schema__WEBPACK_IMPORTED_MODULE_3__["AttributeSpec"])('float32', 1, 0), aPosition: Object(_schema__WEBPACK_IMPORTED_MODULE_3__["AttributeSpec"])('float32', 3, 0), aMapping: Object(_schema__WEBPACK_IMPORTED_MODULE_3__["AttributeSpec"])('float32', 2, 0), elements: Object(_schema__WEBPACK_IMPORTED_MODULE_3__["ElementsSpec"])('uint32'), padding: Object(_schema__WEBPACK_IMPORTED_MODULE_3__["ValueSpec"])('number'), dDoubleSided: Object(_schema__WEBPACK_IMPORTED_MODULE_3__["DefineSpec"])('boolean'), dIgnoreLight: Object(_schema__WEBPACK_IMPORTED_MODULE_3__["DefineSpec"])('boolean'), dXrayShaded: Object(_schema__WEBPACK_IMPORTED_MODULE_3__["DefineSpec"])('boolean') });
function SpheresRenderable(ctx, id, values, state, materialId) {
    var schema = Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, _schema__WEBPACK_IMPORTED_MODULE_3__["GlobalUniformSchema"]), _schema__WEBPACK_IMPORTED_MODULE_3__["GlobalTextureSchema"]), _schema__WEBPACK_IMPORTED_MODULE_3__["InternalSchema"]), SpheresSchema);
    var internalValues = {
        uObjectId: _mol_util__WEBPACK_IMPORTED_MODULE_5__["ValueCell"].create(id),
    };
    var shaderCode = _shader_code__WEBPACK_IMPORTED_MODULE_4__["SpheresShaderCode"];
    var renderItem = Object(_webgl_render_item__WEBPACK_IMPORTED_MODULE_2__["createGraphicsRenderItem"])(ctx, 'triangles', shaderCode, schema, Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, values), internalValues), materialId);
    return Object(_renderable__WEBPACK_IMPORTED_MODULE_1__["createRenderable"])(renderItem, values, state);
}
//# sourceMappingURL=spheres.js.map

/***/ }),

/***/ "./lib/mol-gl/renderable/text.js":
/*!***************************************!*\
  !*** ./lib/mol-gl/renderable/text.js ***!
  \***************************************/
/*! exports provided: TextSchema, TextRenderable */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "TextSchema", function() { return TextSchema; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "TextRenderable", function() { return TextRenderable; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _renderable__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../renderable */ "./lib/mol-gl/renderable.js");
/* harmony import */ var _webgl_render_item__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../webgl/render-item */ "./lib/mol-gl/webgl/render-item.js");
/* harmony import */ var _schema__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./schema */ "./lib/mol-gl/renderable/schema.js");
/* harmony import */ var _shader_code__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../shader-code */ "./lib/mol-gl/shader-code.js");
/* harmony import */ var _mol_util__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../mol-util */ "./lib/mol-util/index.js");
/**
 * Copyright (c) 2019 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */






var TextSchema = Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, _schema__WEBPACK_IMPORTED_MODULE_3__["BaseSchema"]), _schema__WEBPACK_IMPORTED_MODULE_3__["SizeSchema"]), { aGroup: Object(_schema__WEBPACK_IMPORTED_MODULE_3__["AttributeSpec"])('float32', 1, 0), aPosition: Object(_schema__WEBPACK_IMPORTED_MODULE_3__["AttributeSpec"])('float32', 3, 0), aMapping: Object(_schema__WEBPACK_IMPORTED_MODULE_3__["AttributeSpec"])('float32', 2, 0), aDepth: Object(_schema__WEBPACK_IMPORTED_MODULE_3__["AttributeSpec"])('float32', 1, 0), elements: Object(_schema__WEBPACK_IMPORTED_MODULE_3__["ElementsSpec"])('uint32'), aTexCoord: Object(_schema__WEBPACK_IMPORTED_MODULE_3__["AttributeSpec"])('float32', 2, 0), tFont: Object(_schema__WEBPACK_IMPORTED_MODULE_3__["TextureSpec"])('image-uint8', 'alpha', 'ubyte', 'linear'), padding: Object(_schema__WEBPACK_IMPORTED_MODULE_3__["ValueSpec"])('number'), uBorderWidth: Object(_schema__WEBPACK_IMPORTED_MODULE_3__["UniformSpec"])('f'), uBorderColor: Object(_schema__WEBPACK_IMPORTED_MODULE_3__["UniformSpec"])('v3'), uOffsetX: Object(_schema__WEBPACK_IMPORTED_MODULE_3__["UniformSpec"])('f'), uOffsetY: Object(_schema__WEBPACK_IMPORTED_MODULE_3__["UniformSpec"])('f'), uOffsetZ: Object(_schema__WEBPACK_IMPORTED_MODULE_3__["UniformSpec"])('f'), uBackgroundColor: Object(_schema__WEBPACK_IMPORTED_MODULE_3__["UniformSpec"])('v3'), uBackgroundOpacity: Object(_schema__WEBPACK_IMPORTED_MODULE_3__["UniformSpec"])('f') });
function TextRenderable(ctx, id, values, state, materialId) {
    var schema = Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, _schema__WEBPACK_IMPORTED_MODULE_3__["GlobalUniformSchema"]), _schema__WEBPACK_IMPORTED_MODULE_3__["GlobalTextureSchema"]), _schema__WEBPACK_IMPORTED_MODULE_3__["InternalSchema"]), TextSchema);
    var internalValues = {
        uObjectId: _mol_util__WEBPACK_IMPORTED_MODULE_5__["ValueCell"].create(id),
    };
    var shaderCode = _shader_code__WEBPACK_IMPORTED_MODULE_4__["TextShaderCode"];
    var renderItem = Object(_webgl_render_item__WEBPACK_IMPORTED_MODULE_2__["createGraphicsRenderItem"])(ctx, 'triangles', shaderCode, schema, Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, values), internalValues), materialId);
    return Object(_renderable__WEBPACK_IMPORTED_MODULE_1__["createRenderable"])(renderItem, values, state);
}
//# sourceMappingURL=text.js.map

/***/ }),

/***/ "./lib/mol-gl/renderable/texture-mesh.js":
/*!***********************************************!*\
  !*** ./lib/mol-gl/renderable/texture-mesh.js ***!
  \***********************************************/
/*! exports provided: TextureMeshSchema, TextureMeshRenderable */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "TextureMeshSchema", function() { return TextureMeshSchema; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "TextureMeshRenderable", function() { return TextureMeshRenderable; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _renderable__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../renderable */ "./lib/mol-gl/renderable.js");
/* harmony import */ var _webgl_render_item__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../webgl/render-item */ "./lib/mol-gl/webgl/render-item.js");
/* harmony import */ var _schema__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./schema */ "./lib/mol-gl/renderable/schema.js");
/* harmony import */ var _shader_code__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../shader-code */ "./lib/mol-gl/shader-code.js");
/* harmony import */ var _mol_util__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../mol-util */ "./lib/mol-util/index.js");
/**
 * Copyright (c) 2019 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */






var TextureMeshSchema = Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, _schema__WEBPACK_IMPORTED_MODULE_3__["BaseSchema"]), { aGroup: Object(_schema__WEBPACK_IMPORTED_MODULE_3__["AttributeSpec"])('float32', 1, 0), uGeoTexDim: Object(_schema__WEBPACK_IMPORTED_MODULE_3__["UniformSpec"])('v2'), 
    /** texture has vertex positions in XYZ and group id in W */
    tPositionGroup: Object(_schema__WEBPACK_IMPORTED_MODULE_3__["TextureSpec"])('texture', 'rgba', 'float', 'nearest'), tNormal: Object(_schema__WEBPACK_IMPORTED_MODULE_3__["TextureSpec"])('texture', 'rgba', 'float', 'nearest'), dFlatShaded: Object(_schema__WEBPACK_IMPORTED_MODULE_3__["DefineSpec"])('boolean'), dDoubleSided: Object(_schema__WEBPACK_IMPORTED_MODULE_3__["DefineSpec"])('boolean'), dFlipSided: Object(_schema__WEBPACK_IMPORTED_MODULE_3__["DefineSpec"])('boolean'), dIgnoreLight: Object(_schema__WEBPACK_IMPORTED_MODULE_3__["DefineSpec"])('boolean'), dXrayShaded: Object(_schema__WEBPACK_IMPORTED_MODULE_3__["DefineSpec"])('boolean'), dGeoTexture: Object(_schema__WEBPACK_IMPORTED_MODULE_3__["DefineSpec"])('boolean') });
function TextureMeshRenderable(ctx, id, values, state, materialId) {
    var schema = Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, _schema__WEBPACK_IMPORTED_MODULE_3__["GlobalUniformSchema"]), _schema__WEBPACK_IMPORTED_MODULE_3__["GlobalTextureSchema"]), _schema__WEBPACK_IMPORTED_MODULE_3__["InternalSchema"]), TextureMeshSchema);
    var internalValues = {
        uObjectId: _mol_util__WEBPACK_IMPORTED_MODULE_5__["ValueCell"].create(id),
    };
    var shaderCode = _shader_code__WEBPACK_IMPORTED_MODULE_4__["MeshShaderCode"];
    var renderItem = Object(_webgl_render_item__WEBPACK_IMPORTED_MODULE_2__["createGraphicsRenderItem"])(ctx, 'triangles', shaderCode, schema, Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, values), internalValues), materialId);
    return Object(_renderable__WEBPACK_IMPORTED_MODULE_1__["createRenderable"])(renderItem, values, state);
}
//# sourceMappingURL=texture-mesh.js.map

/***/ }),

/***/ "./lib/mol-gl/renderable/util.js":
/*!***************************************!*\
  !*** ./lib/mol-gl/renderable/util.js ***!
  \***************************************/
/*! exports provided: calculateTextureInfo, createTextureImage, printTextureImage, printImageData, calculateInvariantBoundingSphere, calculateTransformBoundingSphere, calculateBoundingSphere */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "calculateTextureInfo", function() { return calculateTextureInfo; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createTextureImage", function() { return createTextureImage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "printTextureImage", function() { return printTextureImage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "printImageData", function() { return printImageData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "calculateInvariantBoundingSphere", function() { return calculateInvariantBoundingSphere; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "calculateTransformBoundingSphere", function() { return calculateTransformBoundingSphere; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "calculateBoundingSphere", function() { return calculateBoundingSphere; });
/* harmony import */ var _mol_math_geometry__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../mol-math/geometry */ "./lib/mol-math/geometry.js");
/* harmony import */ var _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../mol-math/linear-algebra */ "./lib/mol-math/linear-algebra.js");
/* harmony import */ var _mol_math_geometry_boundary_helper__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../mol-math/geometry/boundary-helper */ "./lib/mol-math/geometry/boundary-helper.js");
/**
 * Copyright (c) 2018-2020 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */



function calculateTextureInfo(n, itemSize) {
    n = Math.max(n, 2); // observed issues with 1 pixel textures
    var sqN = Math.sqrt(n);
    var width = Math.ceil(sqN);
    width = width + (itemSize - (width % itemSize)) % itemSize;
    var height = width > 0 ? Math.ceil(n / width) : 0;
    return { width: width, height: height, length: width * height * itemSize };
}
function createTextureImage(n, itemSize, arrayCtor, array) {
    var _a = calculateTextureInfo(n, itemSize), length = _a.length, width = _a.width, height = _a.height;
    array = array && array.length >= length ? array : new arrayCtor(length);
    return { array: array, width: width, height: height };
}
function printTextureImage(textureImage, scale) {
    if (scale === void 0) { scale = 1; }
    var array = textureImage.array, width = textureImage.width, height = textureImage.height;
    var itemSize = array.length / (width * height);
    var data = new Uint8ClampedArray(width * height * 4);
    if (itemSize === 1) {
        for (var y = 0; y < height; ++y) {
            for (var x = 0; x < width; ++x) {
                data[(y * width + x) * 4 + 3] = array[y * width + x];
            }
        }
    }
    else if (itemSize === 4) {
        data.set(array);
    }
    else {
        console.warn("itemSize '" + itemSize + "' not supported");
    }
    return printImageData(new ImageData(data, width, height), scale);
}
function printImageData(imageData, scale, pixelated) {
    if (scale === void 0) { scale = 1; }
    if (pixelated === void 0) { pixelated = false; }
    var canvas = document.createElement('canvas');
    canvas.width = imageData.width;
    canvas.height = imageData.height;
    var ctx = canvas.getContext('2d');
    if (!ctx)
        throw new Error('Could not create canvas 2d context');
    ctx.putImageData(imageData, 0, 0);
    canvas.toBlob(function (imgBlob) {
        var objectURL = window.URL.createObjectURL(imgBlob);
        var img = document.createElement('img');
        img.src = objectURL;
        img.style.width = imageData.width * scale + 'px';
        img.style.height = imageData.height * scale + 'px';
        if (pixelated) {
            // not supported in Firefox and IE
            img.style.imageRendering = 'pixelated';
        }
        img.style.position = 'absolute';
        img.style.top = '0px';
        img.style.left = '0px';
        img.style.border = 'solid grey';
        img.style.pointerEvents = 'none';
        document.body.appendChild(img);
    }, 'image/png');
}
//
var v = Object(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_1__["Vec3"])();
var boundaryHelperCoarse = new _mol_math_geometry_boundary_helper__WEBPACK_IMPORTED_MODULE_2__["BoundaryHelper"]('14');
var boundaryHelperFine = new _mol_math_geometry_boundary_helper__WEBPACK_IMPORTED_MODULE_2__["BoundaryHelper"]('98');
function getHelper(count) {
    return count > 100000 ? boundaryHelperCoarse : boundaryHelperFine;
}
function calculateInvariantBoundingSphere(position, positionCount, stepFactor) {
    var step = stepFactor * 3;
    var boundaryHelper = getHelper(positionCount);
    boundaryHelper.reset();
    for (var i = 0, _i = positionCount * 3; i < _i; i += step) {
        _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_1__["Vec3"].fromArray(v, position, i);
        boundaryHelper.includePosition(v);
    }
    boundaryHelper.finishedIncludeStep();
    for (var i = 0, _i = positionCount * 3; i < _i; i += step) {
        _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_1__["Vec3"].fromArray(v, position, i);
        boundaryHelper.radiusPosition(v);
    }
    var sphere = boundaryHelper.getSphere();
    if (positionCount <= 98) {
        var extrema = [];
        for (var i = 0, _i = positionCount * 3; i < _i; i += step) {
            extrema.push(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_1__["Vec3"].fromArray(Object(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_1__["Vec3"])(), position, i));
        }
        _mol_math_geometry__WEBPACK_IMPORTED_MODULE_0__["Sphere3D"].setExtrema(sphere, extrema);
    }
    return sphere;
}
var _mat4 = Object(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_1__["Mat4"])();
function calculateTransformBoundingSphere(invariantBoundingSphere, transform, transformCount) {
    if (transformCount === 1) {
        _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_1__["Mat4"].fromArray(_mat4, transform, 0);
        var s = _mol_math_geometry__WEBPACK_IMPORTED_MODULE_0__["Sphere3D"].clone(invariantBoundingSphere);
        return _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_1__["Mat4"].isIdentity(_mat4) ? s : _mol_math_geometry__WEBPACK_IMPORTED_MODULE_0__["Sphere3D"].transform(s, s, _mat4);
    }
    var boundaryHelper = getHelper(transformCount);
    boundaryHelper.reset();
    var center = invariantBoundingSphere.center, radius = invariantBoundingSphere.radius, extrema = invariantBoundingSphere.extrema;
    // only use extrema if there are not too many transforms
    if (extrema && transformCount < 50) {
        for (var i = 0, _i = transformCount; i < _i; ++i) {
            for (var _a = 0, extrema_1 = extrema; _a < extrema_1.length; _a++) {
                var e = extrema_1[_a];
                _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_1__["Vec3"].transformMat4Offset(v, e, transform, 0, 0, i * 16);
                boundaryHelper.includePosition(v);
            }
        }
        boundaryHelper.finishedIncludeStep();
        for (var i = 0, _i = transformCount; i < _i; ++i) {
            for (var _b = 0, extrema_2 = extrema; _b < extrema_2.length; _b++) {
                var e = extrema_2[_b];
                _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_1__["Vec3"].transformMat4Offset(v, e, transform, 0, 0, i * 16);
                boundaryHelper.radiusPosition(v);
            }
        }
    }
    else {
        for (var i = 0, _i = transformCount; i < _i; ++i) {
            _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_1__["Vec3"].transformMat4Offset(v, center, transform, 0, 0, i * 16);
            boundaryHelper.includePositionRadius(v, radius);
        }
        boundaryHelper.finishedIncludeStep();
        for (var i = 0, _i = transformCount; i < _i; ++i) {
            _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_1__["Vec3"].transformMat4Offset(v, center, transform, 0, 0, i * 16);
            boundaryHelper.radiusPositionRadius(v, radius);
        }
    }
    return boundaryHelper.getSphere();
}
function calculateBoundingSphere(position, positionCount, transform, transformCount, padding, stepFactor) {
    if (padding === void 0) { padding = 0; }
    if (stepFactor === void 0) { stepFactor = 1; }
    var invariantBoundingSphere = calculateInvariantBoundingSphere(position, positionCount, stepFactor);
    var boundingSphere = calculateTransformBoundingSphere(invariantBoundingSphere, transform, transformCount);
    _mol_math_geometry__WEBPACK_IMPORTED_MODULE_0__["Sphere3D"].expand(boundingSphere, boundingSphere, padding);
    _mol_math_geometry__WEBPACK_IMPORTED_MODULE_0__["Sphere3D"].expand(invariantBoundingSphere, invariantBoundingSphere, padding);
    return { boundingSphere: boundingSphere, invariantBoundingSphere: invariantBoundingSphere };
}
//# sourceMappingURL=util.js.map

/***/ }),

/***/ "./lib/mol-gl/renderer.js":
/*!********************************!*\
  !*** ./lib/mol-gl/renderer.js ***!
  \********************************/
/*! exports provided: RendererParams, default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "RendererParams", function() { return RendererParams; });
/* harmony import */ var _mol_canvas3d_camera_util__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../mol-canvas3d/camera/util */ "./lib/mol-canvas3d/camera/util.js");
/* harmony import */ var _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../mol-math/linear-algebra */ "./lib/mol-math/linear-algebra.js");
/* harmony import */ var _mol_util_color__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../mol-util/color */ "./lib/mol-util/color/index.js");
/* harmony import */ var _mol_util__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../mol-util */ "./lib/mol-util/index.js");
/* harmony import */ var _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../mol-util/param-definition */ "./lib/mol-util/param-definition.js");
/* harmony import */ var _mol_theme_clipping__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../mol-theme/clipping */ "./lib/mol-theme/clipping.js");
/* harmony import */ var _mol_util_string__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../mol-util/string */ "./lib/mol-util/string.js");
/* harmony import */ var _mol_math_misc__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../mol-math/misc */ "./lib/mol-math/misc.js");
/* harmony import */ var _webgl_texture__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ./webgl/texture */ "./lib/mol-gl/webgl/texture.js");
/* harmony import */ var _mol_util_array__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ../mol-util/array */ "./lib/mol-util/array.js");
/* harmony import */ var _mol_math_interpolate__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ../mol-math/interpolate */ "./lib/mol-math/interpolate.js");
/**
 * Copyright (c) 2018-2020 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */











var RendererParams = {
    backgroundColor: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_4__["ParamDefinition"].Color(Object(_mol_util_color__WEBPACK_IMPORTED_MODULE_2__["Color"])(0x000000), { description: 'Background color of the 3D canvas' }),
    // the following are general 'material' parameters
    pickingAlphaThreshold: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_4__["ParamDefinition"].Numeric(0.5, { min: 0.0, max: 1.0, step: 0.01 }, { description: 'The minimum opacity value needed for an object to be pickable.' }),
    interiorDarkening: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_4__["ParamDefinition"].Numeric(0.5, { min: 0.0, max: 1.0, step: 0.01 }),
    interiorColorFlag: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_4__["ParamDefinition"].Boolean(true, { label: 'Use Interior Color' }),
    interiorColor: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_4__["ParamDefinition"].Color(_mol_util_color__WEBPACK_IMPORTED_MODULE_2__["Color"].fromNormalizedRgb(0.3, 0.3, 0.3)),
    highlightColor: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_4__["ParamDefinition"].Color(_mol_util_color__WEBPACK_IMPORTED_MODULE_2__["Color"].fromNormalizedRgb(1.0, 0.4, 0.6)),
    selectColor: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_4__["ParamDefinition"].Color(_mol_util_color__WEBPACK_IMPORTED_MODULE_2__["Color"].fromNormalizedRgb(0.2, 1.0, 0.1)),
    xrayEdgeFalloff: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_4__["ParamDefinition"].Numeric(1, { min: 0.0, max: 3.0, step: 0.1 }),
    style: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_4__["ParamDefinition"].MappedStatic('matte', {
        custom: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_4__["ParamDefinition"].Group({
            lightIntensity: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_4__["ParamDefinition"].Numeric(0.6, { min: 0.0, max: 1.0, step: 0.01 }),
            ambientIntensity: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_4__["ParamDefinition"].Numeric(0.4, { min: 0.0, max: 1.0, step: 0.01 }),
            metalness: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_4__["ParamDefinition"].Numeric(0.0, { min: 0.0, max: 1.0, step: 0.01 }),
            roughness: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_4__["ParamDefinition"].Numeric(1.0, { min: 0.0, max: 1.0, step: 0.01 }),
            reflectivity: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_4__["ParamDefinition"].Numeric(0.5, { min: 0.0, max: 1.0, step: 0.01 }),
        }, { isExpanded: true }),
        flat: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_4__["ParamDefinition"].Group({}),
        matte: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_4__["ParamDefinition"].Group({}),
        glossy: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_4__["ParamDefinition"].Group({}),
        metallic: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_4__["ParamDefinition"].Group({}),
        plastic: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_4__["ParamDefinition"].Group({}),
    }, { label: 'Lighting', description: 'Style in which the 3D scene is rendered/lighted' }),
    clip: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_4__["ParamDefinition"].Group({
        variant: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_4__["ParamDefinition"].Select('instance', _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_4__["ParamDefinition"].arrayToOptions(['instance', 'pixel'])),
        objects: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_4__["ParamDefinition"].ObjectList({
            type: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_4__["ParamDefinition"].Select('plane', _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_4__["ParamDefinition"].objectToOptions(_mol_theme_clipping__WEBPACK_IMPORTED_MODULE_5__["Clipping"].Type, function (t) { return Object(_mol_util_string__WEBPACK_IMPORTED_MODULE_6__["stringToWords"])(t); })),
            invert: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_4__["ParamDefinition"].Boolean(false),
            position: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_4__["ParamDefinition"].Vec3(Object(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_1__["Vec3"])()),
            rotation: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_4__["ParamDefinition"].Group({
                axis: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_4__["ParamDefinition"].Vec3(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_1__["Vec3"].create(1, 0, 0)),
                angle: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_4__["ParamDefinition"].Numeric(0, { min: -180, max: 180, step: 1 }, { description: 'Angle in Degrees' }),
            }, { isExpanded: true }),
            scale: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_4__["ParamDefinition"].Vec3(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_1__["Vec3"].create(1, 1, 1)),
        }, function (o) { return Object(_mol_util_string__WEBPACK_IMPORTED_MODULE_6__["stringToWords"])(o.type); })
    })
};
function getStyle(props) {
    switch (props.name) {
        case 'custom':
            return props.params;
        case 'flat':
            return {
                lightIntensity: 0, ambientIntensity: 1,
                metalness: 0, roughness: 0.4, reflectivity: 0.5
            };
        case 'matte':
            return {
                lightIntensity: 0.7, ambientIntensity: 0.3,
                metalness: 0, roughness: 1, reflectivity: 0.5
            };
        case 'glossy':
            return {
                lightIntensity: 0.7, ambientIntensity: 0.3,
                metalness: 0, roughness: 0.4, reflectivity: 0.5
            };
        case 'metallic':
            return {
                lightIntensity: 0.7, ambientIntensity: 0.7,
                metalness: 0.6, roughness: 0.6, reflectivity: 0.5
            };
        case 'plastic':
            return {
                lightIntensity: 0.7, ambientIntensity: 0.3,
                metalness: 0, roughness: 0.2, reflectivity: 0.5
            };
    }
}
var tmpQuat = Object(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_1__["Quat"])();
function getClip(props, clip) {
    var _a = (clip === null || clip === void 0 ? void 0 : clip.objects) || {
        type: (new Array(5)).fill(1),
        invert: (new Array(5)).fill(false),
        position: (new Array(5 * 3)).fill(0),
        rotation: (new Array(5 * 4)).fill(0),
        scale: (new Array(5 * 3)).fill(1),
    }, type = _a.type, invert = _a.invert, position = _a.position, rotation = _a.rotation, scale = _a.scale;
    for (var i = 0, il = props.objects.length; i < il; ++i) {
        var p = props.objects[i];
        type[i] = _mol_theme_clipping__WEBPACK_IMPORTED_MODULE_5__["Clipping"].Type[p.type];
        invert[i] = p.invert;
        _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_1__["Vec3"].toArray(p.position, position, i * 3);
        _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_1__["Quat"].toArray(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_1__["Quat"].setAxisAngle(tmpQuat, p.rotation.axis, Object(_mol_math_misc__WEBPACK_IMPORTED_MODULE_7__["degToRad"])(p.rotation.angle)), rotation, i * 4);
        _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_1__["Vec3"].toArray(p.scale, scale, i * 3);
    }
    return {
        variant: props.variant,
        objects: { count: props.objects.length, type: type, invert: invert, position: position, rotation: rotation, scale: scale }
    };
}
var Renderer;
(function (Renderer) {
    function create(ctx, props) {
        if (props === void 0) { props = {}; }
        var gl = ctx.gl, state = ctx.state, stats = ctx.stats, fragDepth = ctx.extensions.fragDepth;
        var p = _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_4__["ParamDefinition"].merge(RendererParams, _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_4__["ParamDefinition"].getDefaultValues(RendererParams), props);
        var style = getStyle(p.style);
        var clip = getClip(p.clip);
        var viewport = Object(_mol_canvas3d_camera_util__WEBPACK_IMPORTED_MODULE_0__["Viewport"])();
        var drawingBufferSize = _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_1__["Vec2"].create(gl.drawingBufferWidth, gl.drawingBufferHeight);
        var bgColor = _mol_util_color__WEBPACK_IMPORTED_MODULE_2__["Color"].toVec3Normalized(Object(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_1__["Vec3"])(), p.backgroundColor);
        var transparentBackground = false;
        var nullDepthTexture = Object(_webgl_texture__WEBPACK_IMPORTED_MODULE_8__["createNullTexture"])(gl, 'image-depth');
        var sharedTexturesList = [
            ['tDepth', nullDepthTexture]
        ];
        var view = Object(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_1__["Mat4"])();
        var invView = Object(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_1__["Mat4"])();
        var modelView = Object(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_1__["Mat4"])();
        var invModelView = Object(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_1__["Mat4"])();
        var invProjection = Object(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_1__["Mat4"])();
        var modelViewProjection = Object(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_1__["Mat4"])();
        var invModelViewProjection = Object(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_1__["Mat4"])();
        var cameraDir = Object(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_1__["Vec3"])();
        var viewOffset = Object(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_1__["Vec2"])();
        var globalUniforms = {
            uModel: _mol_util__WEBPACK_IMPORTED_MODULE_3__["ValueCell"].create(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_1__["Mat4"].identity()),
            uView: _mol_util__WEBPACK_IMPORTED_MODULE_3__["ValueCell"].create(view),
            uInvView: _mol_util__WEBPACK_IMPORTED_MODULE_3__["ValueCell"].create(invView),
            uModelView: _mol_util__WEBPACK_IMPORTED_MODULE_3__["ValueCell"].create(modelView),
            uInvModelView: _mol_util__WEBPACK_IMPORTED_MODULE_3__["ValueCell"].create(invModelView),
            uInvProjection: _mol_util__WEBPACK_IMPORTED_MODULE_3__["ValueCell"].create(invProjection),
            uProjection: _mol_util__WEBPACK_IMPORTED_MODULE_3__["ValueCell"].create(Object(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_1__["Mat4"])()),
            uModelViewProjection: _mol_util__WEBPACK_IMPORTED_MODULE_3__["ValueCell"].create(modelViewProjection),
            uInvModelViewProjection: _mol_util__WEBPACK_IMPORTED_MODULE_3__["ValueCell"].create(invModelViewProjection),
            uIsOrtho: _mol_util__WEBPACK_IMPORTED_MODULE_3__["ValueCell"].create(1),
            uViewOffset: _mol_util__WEBPACK_IMPORTED_MODULE_3__["ValueCell"].create(viewOffset),
            uPixelRatio: _mol_util__WEBPACK_IMPORTED_MODULE_3__["ValueCell"].create(ctx.pixelRatio),
            uViewportHeight: _mol_util__WEBPACK_IMPORTED_MODULE_3__["ValueCell"].create(viewport.height),
            uViewport: _mol_util__WEBPACK_IMPORTED_MODULE_3__["ValueCell"].create(_mol_canvas3d_camera_util__WEBPACK_IMPORTED_MODULE_0__["Viewport"].toVec4(Object(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_1__["Vec4"])(), viewport)),
            uDrawingBufferSize: _mol_util__WEBPACK_IMPORTED_MODULE_3__["ValueCell"].create(drawingBufferSize),
            uCameraPosition: _mol_util__WEBPACK_IMPORTED_MODULE_3__["ValueCell"].create(Object(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_1__["Vec3"])()),
            uCameraDir: _mol_util__WEBPACK_IMPORTED_MODULE_3__["ValueCell"].create(cameraDir),
            uNear: _mol_util__WEBPACK_IMPORTED_MODULE_3__["ValueCell"].create(1),
            uFar: _mol_util__WEBPACK_IMPORTED_MODULE_3__["ValueCell"].create(10000),
            uFogNear: _mol_util__WEBPACK_IMPORTED_MODULE_3__["ValueCell"].create(1),
            uFogFar: _mol_util__WEBPACK_IMPORTED_MODULE_3__["ValueCell"].create(10000),
            uFogColor: _mol_util__WEBPACK_IMPORTED_MODULE_3__["ValueCell"].create(bgColor),
            uRenderWboit: _mol_util__WEBPACK_IMPORTED_MODULE_3__["ValueCell"].create(false),
            uTransparentBackground: _mol_util__WEBPACK_IMPORTED_MODULE_3__["ValueCell"].create(false),
            uClipObjectType: _mol_util__WEBPACK_IMPORTED_MODULE_3__["ValueCell"].create(clip.objects.type),
            uClipObjectInvert: _mol_util__WEBPACK_IMPORTED_MODULE_3__["ValueCell"].create(clip.objects.invert),
            uClipObjectPosition: _mol_util__WEBPACK_IMPORTED_MODULE_3__["ValueCell"].create(clip.objects.position),
            uClipObjectRotation: _mol_util__WEBPACK_IMPORTED_MODULE_3__["ValueCell"].create(clip.objects.rotation),
            uClipObjectScale: _mol_util__WEBPACK_IMPORTED_MODULE_3__["ValueCell"].create(clip.objects.scale),
            // the following are general 'material' uniforms
            uLightIntensity: _mol_util__WEBPACK_IMPORTED_MODULE_3__["ValueCell"].create(style.lightIntensity),
            uAmbientIntensity: _mol_util__WEBPACK_IMPORTED_MODULE_3__["ValueCell"].create(style.ambientIntensity),
            uMetalness: _mol_util__WEBPACK_IMPORTED_MODULE_3__["ValueCell"].create(style.metalness),
            uRoughness: _mol_util__WEBPACK_IMPORTED_MODULE_3__["ValueCell"].create(style.roughness),
            uReflectivity: _mol_util__WEBPACK_IMPORTED_MODULE_3__["ValueCell"].create(style.reflectivity),
            uPickingAlphaThreshold: _mol_util__WEBPACK_IMPORTED_MODULE_3__["ValueCell"].create(p.pickingAlphaThreshold),
            uInteriorDarkening: _mol_util__WEBPACK_IMPORTED_MODULE_3__["ValueCell"].create(p.interiorDarkening),
            uInteriorColorFlag: _mol_util__WEBPACK_IMPORTED_MODULE_3__["ValueCell"].create(p.interiorColorFlag),
            uInteriorColor: _mol_util__WEBPACK_IMPORTED_MODULE_3__["ValueCell"].create(_mol_util_color__WEBPACK_IMPORTED_MODULE_2__["Color"].toVec3Normalized(Object(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_1__["Vec3"])(), p.interiorColor)),
            uHighlightColor: _mol_util__WEBPACK_IMPORTED_MODULE_3__["ValueCell"].create(_mol_util_color__WEBPACK_IMPORTED_MODULE_2__["Color"].toVec3Normalized(Object(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_1__["Vec3"])(), p.highlightColor)),
            uSelectColor: _mol_util__WEBPACK_IMPORTED_MODULE_3__["ValueCell"].create(_mol_util_color__WEBPACK_IMPORTED_MODULE_2__["Color"].toVec3Normalized(Object(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_1__["Vec3"])(), p.selectColor)),
            uXrayEdgeFalloff: _mol_util__WEBPACK_IMPORTED_MODULE_3__["ValueCell"].create(p.xrayEdgeFalloff),
        };
        var globalUniformList = Object.entries(globalUniforms);
        var globalUniformsNeedUpdate = true;
        var renderObject = function (r, variant) {
            if (r.state.disposed || !r.state.visible || (!r.state.pickable && variant[0] === 'p')) {
                return;
            }
            var definesNeedUpdate = false;
            if (r.state.noClip) {
                if (r.values.dClipObjectCount.ref.value !== 0) {
                    _mol_util__WEBPACK_IMPORTED_MODULE_3__["ValueCell"].update(r.values.dClipObjectCount, 0);
                    definesNeedUpdate = true;
                }
            }
            else {
                if (r.values.dClipObjectCount.ref.value !== clip.objects.count) {
                    _mol_util__WEBPACK_IMPORTED_MODULE_3__["ValueCell"].update(r.values.dClipObjectCount, clip.objects.count);
                    definesNeedUpdate = true;
                }
                if (r.values.dClipVariant.ref.value !== clip.variant) {
                    _mol_util__WEBPACK_IMPORTED_MODULE_3__["ValueCell"].update(r.values.dClipVariant, clip.variant);
                    definesNeedUpdate = true;
                }
            }
            if (definesNeedUpdate)
                r.update();
            var program = r.getProgram(variant);
            if (state.currentProgramId !== program.id) {
                // console.log('new program')
                globalUniformsNeedUpdate = true;
                program.use();
            }
            if (globalUniformsNeedUpdate) {
                // console.log('globalUniformsNeedUpdate')
                program.setUniforms(globalUniformList);
                globalUniformsNeedUpdate = false;
            }
            if (r.values.dRenderMode) { // indicates direct-volume
                // culling done in fragment shader
                state.disable(gl.CULL_FACE);
                state.frontFace(gl.CCW);
                if (variant === 'colorBlended') {
                    // depth test done manually in shader against `depthTexture`
                    // still need to enable when fragDepth can be used to write depth
                    if (r.values.dRenderMode.ref.value === 'volume' || !fragDepth) {
                        state.disable(gl.DEPTH_TEST);
                        state.depthMask(false);
                    }
                    else {
                        state.enable(gl.DEPTH_TEST);
                        state.depthMask(r.values.uAlpha.ref.value === 1.0);
                    }
                }
            }
            else {
                if (r.values.dDoubleSided) {
                    if (r.values.dDoubleSided.ref.value || r.values.hasReflection.ref.value) {
                        state.disable(gl.CULL_FACE);
                    }
                    else {
                        state.enable(gl.CULL_FACE);
                    }
                }
                else {
                    // webgl default
                    state.disable(gl.CULL_FACE);
                }
                if (r.values.dFlipSided) {
                    if (r.values.dFlipSided.ref.value) {
                        state.frontFace(gl.CW);
                        state.cullFace(gl.FRONT);
                    }
                    else {
                        state.frontFace(gl.CCW);
                        state.cullFace(gl.BACK);
                    }
                }
                else {
                    // webgl default
                    state.frontFace(gl.CCW);
                    state.cullFace(gl.BACK);
                }
            }
            r.render(variant, sharedTexturesList);
        };
        var update = function (camera) {
            _mol_util__WEBPACK_IMPORTED_MODULE_3__["ValueCell"].update(globalUniforms.uView, camera.view);
            _mol_util__WEBPACK_IMPORTED_MODULE_3__["ValueCell"].update(globalUniforms.uInvView, _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_1__["Mat4"].invert(invView, camera.view));
            _mol_util__WEBPACK_IMPORTED_MODULE_3__["ValueCell"].update(globalUniforms.uProjection, camera.projection);
            _mol_util__WEBPACK_IMPORTED_MODULE_3__["ValueCell"].update(globalUniforms.uInvProjection, _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_1__["Mat4"].invert(invProjection, camera.projection));
            _mol_util__WEBPACK_IMPORTED_MODULE_3__["ValueCell"].updateIfChanged(globalUniforms.uIsOrtho, camera.state.mode === 'orthographic' ? 1 : 0);
            _mol_util__WEBPACK_IMPORTED_MODULE_3__["ValueCell"].update(globalUniforms.uViewOffset, camera.viewOffset.enabled ? _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_1__["Vec2"].set(viewOffset, camera.viewOffset.offsetX * 16, camera.viewOffset.offsetY * 16) : _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_1__["Vec2"].set(viewOffset, 0, 0));
            _mol_util__WEBPACK_IMPORTED_MODULE_3__["ValueCell"].update(globalUniforms.uCameraPosition, camera.state.position);
            _mol_util__WEBPACK_IMPORTED_MODULE_3__["ValueCell"].update(globalUniforms.uCameraDir, _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_1__["Vec3"].normalize(cameraDir, _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_1__["Vec3"].sub(cameraDir, camera.state.target, camera.state.position)));
            _mol_util__WEBPACK_IMPORTED_MODULE_3__["ValueCell"].updateIfChanged(globalUniforms.uFar, camera.far);
            _mol_util__WEBPACK_IMPORTED_MODULE_3__["ValueCell"].updateIfChanged(globalUniforms.uNear, camera.near);
            _mol_util__WEBPACK_IMPORTED_MODULE_3__["ValueCell"].updateIfChanged(globalUniforms.uFogFar, camera.fogFar);
            _mol_util__WEBPACK_IMPORTED_MODULE_3__["ValueCell"].updateIfChanged(globalUniforms.uFogNear, camera.fogNear);
            _mol_util__WEBPACK_IMPORTED_MODULE_3__["ValueCell"].updateIfChanged(globalUniforms.uTransparentBackground, transparentBackground);
        };
        var updateInternal = function (group, camera, depthTexture, renderWboit) {
            Object(_mol_util_array__WEBPACK_IMPORTED_MODULE_9__["arrayMapUpsert"])(sharedTexturesList, 'tDepth', depthTexture || nullDepthTexture);
            _mol_util__WEBPACK_IMPORTED_MODULE_3__["ValueCell"].update(globalUniforms.uModel, group.view);
            _mol_util__WEBPACK_IMPORTED_MODULE_3__["ValueCell"].update(globalUniforms.uModelView, _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_1__["Mat4"].mul(modelView, group.view, camera.view));
            _mol_util__WEBPACK_IMPORTED_MODULE_3__["ValueCell"].update(globalUniforms.uInvModelView, _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_1__["Mat4"].invert(invModelView, modelView));
            _mol_util__WEBPACK_IMPORTED_MODULE_3__["ValueCell"].update(globalUniforms.uModelViewProjection, _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_1__["Mat4"].mul(modelViewProjection, modelView, camera.projection));
            _mol_util__WEBPACK_IMPORTED_MODULE_3__["ValueCell"].update(globalUniforms.uInvModelViewProjection, _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_1__["Mat4"].invert(invModelViewProjection, modelViewProjection));
            _mol_util__WEBPACK_IMPORTED_MODULE_3__["ValueCell"].updateIfChanged(globalUniforms.uRenderWboit, renderWboit);
            state.enable(gl.SCISSOR_TEST);
            state.colorMask(true, true, true, true);
            var x = viewport.x, y = viewport.y, width = viewport.width, height = viewport.height;
            gl.viewport(x, y, width, height);
            gl.scissor(x, y, width, height);
            globalUniformsNeedUpdate = true;
            state.currentRenderItemId = -1;
        };
        var renderPick = function (group, camera, variant, depthTexture) {
            state.disable(gl.BLEND);
            state.enable(gl.DEPTH_TEST);
            state.depthMask(true);
            updateInternal(group, camera, depthTexture, false);
            var renderables = group.renderables;
            for (var i = 0, il = renderables.length; i < il; ++i) {
                if (!renderables[i].state.colorOnly) {
                    renderObject(renderables[i], variant);
                }
            }
        };
        var renderDepth = function (group, camera, depthTexture) {
            state.disable(gl.BLEND);
            state.enable(gl.DEPTH_TEST);
            state.depthMask(true);
            updateInternal(group, camera, depthTexture, false);
            var renderables = group.renderables;
            for (var i = 0, il = renderables.length; i < il; ++i) {
                renderObject(renderables[i], 'depth');
            }
        };
        var renderBlended = function (group, camera, depthTexture) {
            renderBlendedOpaque(group, camera, depthTexture);
            renderBlendedTransparent(group, camera, depthTexture);
        };
        var renderBlendedOpaque = function (group, camera, depthTexture) {
            state.disable(gl.BLEND);
            state.enable(gl.DEPTH_TEST);
            state.depthMask(true);
            updateInternal(group, camera, depthTexture, false);
            var renderables = group.renderables;
            for (var i = 0, il = renderables.length; i < il; ++i) {
                var r = renderables[i];
                if (r.state.opaque) {
                    renderObject(r, 'colorBlended');
                }
            }
        };
        var renderBlendedTransparent = function (group, camera, depthTexture) {
            state.enable(gl.DEPTH_TEST);
            updateInternal(group, camera, depthTexture, false);
            var renderables = group.renderables;
            if (transparentBackground) {
                state.blendFunc(gl.ONE, gl.ONE_MINUS_SRC_ALPHA);
            }
            else {
                state.blendFuncSeparate(gl.SRC_ALPHA, gl.ONE_MINUS_SRC_ALPHA, gl.ONE, gl.ONE_MINUS_SRC_ALPHA);
            }
            state.enable(gl.BLEND);
            state.depthMask(true);
            for (var i = 0, il = renderables.length; i < il; ++i) {
                var r = renderables[i];
                if (!r.state.opaque && r.state.writeDepth) {
                    renderObject(r, 'colorBlended');
                }
            }
            state.depthMask(false);
            for (var i = 0, il = renderables.length; i < il; ++i) {
                var r = renderables[i];
                if (!r.state.opaque && !r.state.writeDepth) {
                    renderObject(r, 'colorBlended');
                }
            }
        };
        var renderBlendedVolumeOpaque = function (group, camera, depthTexture) {
            var _a;
            state.blendFunc(gl.ONE, gl.ONE_MINUS_SRC_ALPHA);
            state.enable(gl.BLEND);
            updateInternal(group, camera, depthTexture, false);
            var renderables = group.renderables;
            for (var i = 0, il = renderables.length; i < il; ++i) {
                var r = renderables[i];
                // TODO: simplify, handle on renderable.state???
                // uAlpha is updated in "render" so we need to recompute it here
                var alpha = Object(_mol_math_interpolate__WEBPACK_IMPORTED_MODULE_10__["clamp"])(r.values.alpha.ref.value * r.state.alphaFactor, 0, 1);
                if (alpha === 1 && r.values.transparencyAverage.ref.value !== 1 && !((_a = r.values.dXrayShaded) === null || _a === void 0 ? void 0 : _a.ref.value)) {
                    renderObject(r, 'colorBlended');
                }
            }
        };
        var renderBlendedVolumeTransparent = function (group, camera, depthTexture) {
            var _a;
            state.blendFunc(gl.ONE, gl.ONE_MINUS_SRC_ALPHA);
            state.enable(gl.BLEND);
            updateInternal(group, camera, depthTexture, false);
            var renderables = group.renderables;
            for (var i = 0, il = renderables.length; i < il; ++i) {
                var r = renderables[i];
                // TODO: simplify, handle on renderable.state???
                // uAlpha is updated in "render" so we need to recompute it here
                var alpha = Object(_mol_math_interpolate__WEBPACK_IMPORTED_MODULE_10__["clamp"])(r.values.alpha.ref.value * r.state.alphaFactor, 0, 1);
                if (alpha < 1 || r.values.transparencyAverage.ref.value > 0 || ((_a = r.values.dXrayShaded) === null || _a === void 0 ? void 0 : _a.ref.value)) {
                    renderObject(r, 'colorBlended');
                }
            }
        };
        var renderWboitOpaque = function (group, camera, depthTexture) {
            var _a, _b, _c;
            state.disable(gl.BLEND);
            state.enable(gl.DEPTH_TEST);
            state.depthMask(true);
            updateInternal(group, camera, depthTexture, false);
            var renderables = group.renderables;
            for (var i = 0, il = renderables.length; i < il; ++i) {
                var r = renderables[i];
                // TODO: simplify, handle on renderable.state???
                // uAlpha is updated in "render" so we need to recompute it here
                var alpha = Object(_mol_math_interpolate__WEBPACK_IMPORTED_MODULE_10__["clamp"])(r.values.alpha.ref.value * r.state.alphaFactor, 0, 1);
                if (alpha === 1 && r.values.transparencyAverage.ref.value !== 1 && ((_a = r.values.dRenderMode) === null || _a === void 0 ? void 0 : _a.ref.value) !== 'volume' && !((_b = r.values.dPointFilledCircle) === null || _b === void 0 ? void 0 : _b.ref.value) && !((_c = r.values.dXrayShaded) === null || _c === void 0 ? void 0 : _c.ref.value)) {
                    renderObject(r, 'colorWboit');
                }
            }
        };
        var renderWboitTransparent = function (group, camera, depthTexture) {
            var _a, _b, _c;
            updateInternal(group, camera, depthTexture, true);
            var renderables = group.renderables;
            for (var i = 0, il = renderables.length; i < il; ++i) {
                var r = renderables[i];
                // TODO: simplify, handle on renderable.state???
                // uAlpha is updated in "render" so we need to recompute it here
                var alpha = Object(_mol_math_interpolate__WEBPACK_IMPORTED_MODULE_10__["clamp"])(r.values.alpha.ref.value * r.state.alphaFactor, 0, 1);
                if (alpha < 1 || r.values.transparencyAverage.ref.value > 0 || ((_a = r.values.dRenderMode) === null || _a === void 0 ? void 0 : _a.ref.value) === 'volume' || ((_b = r.values.dPointFilledCircle) === null || _b === void 0 ? void 0 : _b.ref.value) || !!r.values.uBackgroundColor || ((_c = r.values.dXrayShaded) === null || _c === void 0 ? void 0 : _c.ref.value)) {
                    renderObject(r, 'colorWboit');
                }
            }
        };
        return {
            clear: function (toBackgroundColor) {
                state.enable(gl.SCISSOR_TEST);
                state.enable(gl.DEPTH_TEST);
                state.colorMask(true, true, true, true);
                state.depthMask(true);
                if (transparentBackground) {
                    state.clearColor(0, 0, 0, 0);
                }
                else if (toBackgroundColor) {
                    state.clearColor(bgColor[0], bgColor[1], bgColor[2], 1);
                }
                else {
                    state.clearColor(1, 1, 1, 1);
                }
                gl.clear(gl.COLOR_BUFFER_BIT | gl.DEPTH_BUFFER_BIT);
            },
            clearDepth: function () {
                state.enable(gl.SCISSOR_TEST);
                state.enable(gl.DEPTH_TEST);
                state.depthMask(true);
                gl.clear(gl.DEPTH_BUFFER_BIT);
            },
            update: update,
            renderPick: renderPick,
            renderDepth: renderDepth,
            renderBlended: renderBlended,
            renderBlendedOpaque: renderBlendedOpaque,
            renderBlendedTransparent: renderBlendedTransparent,
            renderBlendedVolumeOpaque: renderBlendedVolumeOpaque,
            renderBlendedVolumeTransparent: renderBlendedVolumeTransparent,
            renderWboitOpaque: renderWboitOpaque,
            renderWboitTransparent: renderWboitTransparent,
            setProps: function (props) {
                if (props.backgroundColor !== undefined && props.backgroundColor !== p.backgroundColor) {
                    p.backgroundColor = props.backgroundColor;
                    _mol_util_color__WEBPACK_IMPORTED_MODULE_2__["Color"].toVec3Normalized(bgColor, p.backgroundColor);
                    _mol_util__WEBPACK_IMPORTED_MODULE_3__["ValueCell"].update(globalUniforms.uFogColor, _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_1__["Vec3"].copy(globalUniforms.uFogColor.ref.value, bgColor));
                }
                if (props.pickingAlphaThreshold !== undefined && props.pickingAlphaThreshold !== p.pickingAlphaThreshold) {
                    p.pickingAlphaThreshold = props.pickingAlphaThreshold;
                    _mol_util__WEBPACK_IMPORTED_MODULE_3__["ValueCell"].update(globalUniforms.uPickingAlphaThreshold, p.pickingAlphaThreshold);
                }
                if (props.interiorDarkening !== undefined && props.interiorDarkening !== p.interiorDarkening) {
                    p.interiorDarkening = props.interiorDarkening;
                    _mol_util__WEBPACK_IMPORTED_MODULE_3__["ValueCell"].update(globalUniforms.uInteriorDarkening, p.interiorDarkening);
                }
                if (props.interiorColorFlag !== undefined && props.interiorColorFlag !== p.interiorColorFlag) {
                    p.interiorColorFlag = props.interiorColorFlag;
                    _mol_util__WEBPACK_IMPORTED_MODULE_3__["ValueCell"].update(globalUniforms.uInteriorColorFlag, p.interiorColorFlag);
                }
                if (props.interiorColor !== undefined && props.interiorColor !== p.interiorColor) {
                    p.interiorColor = props.interiorColor;
                    _mol_util__WEBPACK_IMPORTED_MODULE_3__["ValueCell"].update(globalUniforms.uInteriorColor, _mol_util_color__WEBPACK_IMPORTED_MODULE_2__["Color"].toVec3Normalized(globalUniforms.uInteriorColor.ref.value, p.interiorColor));
                }
                if (props.highlightColor !== undefined && props.highlightColor !== p.highlightColor) {
                    p.highlightColor = props.highlightColor;
                    _mol_util__WEBPACK_IMPORTED_MODULE_3__["ValueCell"].update(globalUniforms.uHighlightColor, _mol_util_color__WEBPACK_IMPORTED_MODULE_2__["Color"].toVec3Normalized(globalUniforms.uHighlightColor.ref.value, p.highlightColor));
                }
                if (props.selectColor !== undefined && props.selectColor !== p.selectColor) {
                    p.selectColor = props.selectColor;
                    _mol_util__WEBPACK_IMPORTED_MODULE_3__["ValueCell"].update(globalUniforms.uSelectColor, _mol_util_color__WEBPACK_IMPORTED_MODULE_2__["Color"].toVec3Normalized(globalUniforms.uSelectColor.ref.value, p.selectColor));
                }
                if (props.xrayEdgeFalloff !== undefined && props.xrayEdgeFalloff !== p.xrayEdgeFalloff) {
                    p.xrayEdgeFalloff = props.xrayEdgeFalloff;
                    _mol_util__WEBPACK_IMPORTED_MODULE_3__["ValueCell"].update(globalUniforms.uXrayEdgeFalloff, p.xrayEdgeFalloff);
                }
                if (props.style !== undefined) {
                    p.style = props.style;
                    Object.assign(style, getStyle(props.style));
                    _mol_util__WEBPACK_IMPORTED_MODULE_3__["ValueCell"].updateIfChanged(globalUniforms.uLightIntensity, style.lightIntensity);
                    _mol_util__WEBPACK_IMPORTED_MODULE_3__["ValueCell"].updateIfChanged(globalUniforms.uAmbientIntensity, style.ambientIntensity);
                    _mol_util__WEBPACK_IMPORTED_MODULE_3__["ValueCell"].updateIfChanged(globalUniforms.uMetalness, style.metalness);
                    _mol_util__WEBPACK_IMPORTED_MODULE_3__["ValueCell"].updateIfChanged(globalUniforms.uRoughness, style.roughness);
                    _mol_util__WEBPACK_IMPORTED_MODULE_3__["ValueCell"].updateIfChanged(globalUniforms.uReflectivity, style.reflectivity);
                }
                if (props.clip !== undefined && !Object(_mol_util__WEBPACK_IMPORTED_MODULE_3__["deepEqual"])(props.clip, p.clip)) {
                    p.clip = props.clip;
                    Object.assign(clip, getClip(props.clip, clip));
                    _mol_util__WEBPACK_IMPORTED_MODULE_3__["ValueCell"].update(globalUniforms.uClipObjectPosition, clip.objects.position);
                    _mol_util__WEBPACK_IMPORTED_MODULE_3__["ValueCell"].update(globalUniforms.uClipObjectRotation, clip.objects.rotation);
                    _mol_util__WEBPACK_IMPORTED_MODULE_3__["ValueCell"].update(globalUniforms.uClipObjectScale, clip.objects.scale);
                    _mol_util__WEBPACK_IMPORTED_MODULE_3__["ValueCell"].update(globalUniforms.uClipObjectType, clip.objects.type);
                }
            },
            setViewport: function (x, y, width, height) {
                gl.viewport(x, y, width, height);
                gl.scissor(x, y, width, height);
                if (x !== viewport.x || y !== viewport.y || width !== viewport.width || height !== viewport.height) {
                    _mol_canvas3d_camera_util__WEBPACK_IMPORTED_MODULE_0__["Viewport"].set(viewport, x, y, width, height);
                    _mol_util__WEBPACK_IMPORTED_MODULE_3__["ValueCell"].update(globalUniforms.uViewportHeight, height);
                    _mol_util__WEBPACK_IMPORTED_MODULE_3__["ValueCell"].update(globalUniforms.uViewport, _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_1__["Vec4"].set(globalUniforms.uViewport.ref.value, x, y, width, height));
                }
            },
            setTransparentBackground: function (value) {
                transparentBackground = value;
            },
            setDrawingBufferSize: function (width, height) {
                if (width !== drawingBufferSize[0] || height !== drawingBufferSize[1]) {
                    _mol_util__WEBPACK_IMPORTED_MODULE_3__["ValueCell"].update(globalUniforms.uDrawingBufferSize, _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_1__["Vec2"].set(drawingBufferSize, width, height));
                }
            },
            props: p,
            get stats() {
                return {
                    programCount: ctx.stats.resourceCounts.program,
                    shaderCount: ctx.stats.resourceCounts.shader,
                    attributeCount: ctx.stats.resourceCounts.attribute,
                    elementsCount: ctx.stats.resourceCounts.elements,
                    framebufferCount: ctx.stats.resourceCounts.framebuffer,
                    renderbufferCount: ctx.stats.resourceCounts.renderbuffer,
                    textureCount: ctx.stats.resourceCounts.texture,
                    vertexArrayCount: ctx.stats.resourceCounts.vertexArray,
                    drawCount: stats.drawCount,
                    instanceCount: stats.instanceCount,
                    instancedDrawCount: stats.instancedDrawCount,
                };
            },
            dispose: function () {
                // TODO
            }
        };
    }
    Renderer.create = create;
})(Renderer || (Renderer = {}));
/* harmony default export */ __webpack_exports__["default"] = (Renderer);
//# sourceMappingURL=renderer.js.map

/***/ }),

/***/ "./lib/mol-gl/scene.js":
/*!*****************************!*\
  !*** ./lib/mol-gl/scene.js ***!
  \*****************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _render_object__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./render-object */ "./lib/mol-gl/render-object.js");
/* harmony import */ var _object3d__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./object3d */ "./lib/mol-gl/object3d.js");
/* harmony import */ var _mol_math_geometry__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../mol-math/geometry */ "./lib/mol-math/geometry.js");
/* harmony import */ var _commit_queue__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./commit-queue */ "./lib/mol-gl/commit-queue.js");
/* harmony import */ var _mol_util_now__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../mol-util/now */ "./lib/mol-util/now.js");
/* harmony import */ var _mol_util_array__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../mol-util/array */ "./lib/mol-util/array.js");
/* harmony import */ var _mol_math_geometry_boundary_helper__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../mol-math/geometry/boundary-helper */ "./lib/mol-math/geometry/boundary-helper.js");
/* harmony import */ var _mol_data_util__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../mol-data/util */ "./lib/mol-data/util.js");
/**
 * Copyright (c) 2018-2020 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 * @author David Sehnal <david.sehnal@gmail.com>
 */








var boundaryHelper = new _mol_math_geometry_boundary_helper__WEBPACK_IMPORTED_MODULE_6__["BoundaryHelper"]('98');
function calculateBoundingSphere(renderables, boundingSphere, onlyVisible) {
    boundaryHelper.reset();
    for (var i = 0, il = renderables.length; i < il; ++i) {
        if (onlyVisible && !renderables[i].state.visible)
            continue;
        var boundingSphere_1 = renderables[i].values.boundingSphere.ref.value;
        if (!boundingSphere_1.radius)
            continue;
        boundaryHelper.includeSphere(boundingSphere_1);
    }
    boundaryHelper.finishedIncludeStep();
    for (var i = 0, il = renderables.length; i < il; ++i) {
        if (onlyVisible && !renderables[i].state.visible)
            continue;
        var boundingSphere_2 = renderables[i].values.boundingSphere.ref.value;
        if (!boundingSphere_2.radius)
            continue;
        boundaryHelper.radiusSphere(boundingSphere_2);
    }
    return boundaryHelper.getSphere(boundingSphere);
}
function renderableSort(a, b) {
    var drawProgramIdA = a.getProgram('colorBlended').id;
    var drawProgramIdB = b.getProgram('colorBlended').id;
    var materialIdA = a.materialId;
    var materialIdB = b.materialId;
    if (drawProgramIdA !== drawProgramIdB) {
        // sort by program id to minimize gl state changes
        return drawProgramIdA - drawProgramIdB;
    }
    else if (materialIdA !== materialIdB) {
        // sort by material id to minimize gl state changes
        return materialIdA - materialIdB;
    }
    else {
        return a.id - b.id;
    }
}
var Scene;
(function (Scene) {
    function create(ctx) {
        var renderableMap = new Map();
        var renderables = [];
        var boundingSphere = Object(_mol_math_geometry__WEBPACK_IMPORTED_MODULE_2__["Sphere3D"])();
        var boundingSphereVisible = Object(_mol_math_geometry__WEBPACK_IMPORTED_MODULE_2__["Sphere3D"])();
        var primitives = [];
        var volumes = [];
        var boundingSphereDirty = true;
        var boundingSphereVisibleDirty = true;
        var object3d = _object3d__WEBPACK_IMPORTED_MODULE_1__["Object3D"].create();
        var view = object3d.view, position = object3d.position, direction = object3d.direction, up = object3d.up;
        function add(o) {
            if (!renderableMap.has(o)) {
                var renderable = Object(_render_object__WEBPACK_IMPORTED_MODULE_0__["createRenderable"])(ctx, o);
                renderables.push(renderable);
                if (o.type === 'direct-volume') {
                    volumes.push(renderable);
                }
                else {
                    primitives.push(renderable);
                }
                renderableMap.set(o, renderable);
                boundingSphereDirty = true;
                boundingSphereVisibleDirty = true;
                return renderable;
            }
            else {
                console.warn("RenderObject with id '" + o.id + "' already present");
                return renderableMap.get(o);
            }
        }
        function remove(o) {
            var renderable = renderableMap.get(o);
            if (renderable) {
                renderable.dispose();
                Object(_mol_util_array__WEBPACK_IMPORTED_MODULE_5__["arraySetRemove"])(renderables, renderable);
                Object(_mol_util_array__WEBPACK_IMPORTED_MODULE_5__["arraySetRemove"])(primitives, renderable);
                Object(_mol_util_array__WEBPACK_IMPORTED_MODULE_5__["arraySetRemove"])(volumes, renderable);
                renderableMap.delete(o);
                boundingSphereDirty = true;
                boundingSphereVisibleDirty = true;
            }
        }
        var commitBulkSize = 100;
        function commit(maxTimeMs) {
            var start = Object(_mol_util_now__WEBPACK_IMPORTED_MODULE_4__["now"])();
            var i = 0;
            while (true) {
                var o = commitQueue.tryGetRemove();
                if (!o)
                    break;
                remove(o);
                if (++i % commitBulkSize === 0 && Object(_mol_util_now__WEBPACK_IMPORTED_MODULE_4__["now"])() - start > maxTimeMs)
                    return false;
            }
            while (true) {
                var o = commitQueue.tryGetAdd();
                if (!o)
                    break;
                add(o);
                if (++i % commitBulkSize === 0 && Object(_mol_util_now__WEBPACK_IMPORTED_MODULE_4__["now"])() - start > maxTimeMs)
                    return false;
            }
            renderables.sort(renderableSort);
            return true;
        }
        var commitQueue = new _commit_queue__WEBPACK_IMPORTED_MODULE_3__["CommitQueue"]();
        var visibleHash = -1;
        function computeVisibleHash() {
            var hash = 23;
            for (var i = 0, il = renderables.length; i < il; ++i) {
                if (!renderables[i].state.visible)
                    continue;
                hash = (31 * hash + renderables[i].id) | 0;
            }
            hash = Object(_mol_data_util__WEBPACK_IMPORTED_MODULE_7__["hash1"])(hash);
            if (hash === -1)
                hash = 0;
            return hash;
        }
        function syncVisibility() {
            var newVisibleHash = computeVisibleHash();
            if (newVisibleHash !== visibleHash) {
                boundingSphereVisibleDirty = true;
                return true;
            }
            else {
                return false;
            }
        }
        return {
            view: view, position: position, direction: direction, up: up,
            renderables: renderables,
            primitives: { view: view, position: position, direction: direction, up: up, renderables: primitives },
            volumes: { view: view, position: position, direction: direction, up: up, renderables: volumes },
            syncVisibility: syncVisibility,
            update: function (objects, keepBoundingSphere) {
                var _a;
                _object3d__WEBPACK_IMPORTED_MODULE_1__["Object3D"].update(object3d);
                if (objects) {
                    for (var i = 0, il = objects.length; i < il; ++i) {
                        (_a = renderableMap.get(objects[i])) === null || _a === void 0 ? void 0 : _a.update();
                    }
                }
                else {
                    for (var i = 0, il = renderables.length; i < il; ++i) {
                        renderables[i].update();
                    }
                }
                if (!keepBoundingSphere) {
                    boundingSphereDirty = true;
                    boundingSphereVisibleDirty = true;
                }
                else {
                    syncVisibility();
                }
            },
            add: function (o) { return commitQueue.add(o); },
            remove: function (o) { return commitQueue.remove(o); },
            commit: function (maxTime) {
                if (maxTime === void 0) { maxTime = Number.MAX_VALUE; }
                return commit(maxTime);
            },
            get needsCommit() { return !commitQueue.isEmpty; },
            has: function (o) {
                return renderableMap.has(o);
            },
            clear: function () {
                for (var i = 0, il = renderables.length; i < il; ++i) {
                    renderables[i].dispose();
                }
                renderables.length = 0;
                renderableMap.clear();
                boundingSphereDirty = true;
                boundingSphereVisibleDirty = true;
            },
            forEach: function (callbackFn) {
                renderableMap.forEach(callbackFn);
            },
            get count() {
                return renderables.length;
            },
            get boundingSphere() {
                if (boundingSphereDirty) {
                    calculateBoundingSphere(renderables, boundingSphere, false);
                    boundingSphereDirty = false;
                }
                return boundingSphere;
            },
            get boundingSphereVisible() {
                if (boundingSphereVisibleDirty) {
                    calculateBoundingSphere(renderables, boundingSphereVisible, true);
                    boundingSphereVisibleDirty = false;
                    visibleHash = computeVisibleHash();
                }
                return boundingSphereVisible;
            }
        };
    }
    Scene.create = create;
})(Scene || (Scene = {}));
/* harmony default export */ __webpack_exports__["default"] = (Scene);
//# sourceMappingURL=scene.js.map

/***/ }),

/***/ "./lib/mol-gl/shader-code.js":
/*!***********************************!*\
  !*** ./lib/mol-gl/shader-code.js ***!
  \***********************************/
/*! exports provided: ShaderCode, PointsShaderCode, SpheresShaderCode, CylindersShaderCode, TextShaderCode, LinesShaderCode, MeshShaderCode, DirectVolumeShaderCode, ImageShaderCode, addShaderDefines */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ShaderCode", function() { return ShaderCode; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "PointsShaderCode", function() { return PointsShaderCode; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SpheresShaderCode", function() { return SpheresShaderCode; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CylindersShaderCode", function() { return CylindersShaderCode; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "TextShaderCode", function() { return TextShaderCode; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "LinesShaderCode", function() { return LinesShaderCode; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MeshShaderCode", function() { return MeshShaderCode; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DirectVolumeShaderCode", function() { return DirectVolumeShaderCode; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ImageShaderCode", function() { return ImageShaderCode; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "addShaderDefines", function() { return addShaderDefines; });
/* harmony import */ var _mol_util_id_factory__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../mol-util/id-factory */ "./lib/mol-util/id-factory.js");
/* harmony import */ var _webgl_compat__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./webgl/compat */ "./lib/mol-gl/webgl/compat.js");
/* harmony import */ var _shader_chunks_apply_fog_glsl__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./shader/chunks/apply-fog.glsl */ "./lib/mol-gl/shader/chunks/apply-fog.glsl.js");
/* harmony import */ var _shader_chunks_apply_interior_color_glsl__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./shader/chunks/apply-interior-color.glsl */ "./lib/mol-gl/shader/chunks/apply-interior-color.glsl.js");
/* harmony import */ var _shader_chunks_apply_light_color_glsl__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./shader/chunks/apply-light-color.glsl */ "./lib/mol-gl/shader/chunks/apply-light-color.glsl.js");
/* harmony import */ var _shader_chunks_apply_marker_color_glsl__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./shader/chunks/apply-marker-color.glsl */ "./lib/mol-gl/shader/chunks/apply-marker-color.glsl.js");
/* harmony import */ var _shader_chunks_assign_clipping_varying_glsl__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ./shader/chunks/assign-clipping-varying.glsl */ "./lib/mol-gl/shader/chunks/assign-clipping-varying.glsl.js");
/* harmony import */ var _shader_chunks_assign_color_varying_glsl__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ./shader/chunks/assign-color-varying.glsl */ "./lib/mol-gl/shader/chunks/assign-color-varying.glsl.js");
/* harmony import */ var _shader_chunks_assign_group_glsl__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ./shader/chunks/assign-group.glsl */ "./lib/mol-gl/shader/chunks/assign-group.glsl.js");
/* harmony import */ var _shader_chunks_assign_marker_varying_glsl__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ./shader/chunks/assign-marker-varying.glsl */ "./lib/mol-gl/shader/chunks/assign-marker-varying.glsl.js");
/* harmony import */ var _shader_chunks_assign_material_color_glsl__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ./shader/chunks/assign-material-color.glsl */ "./lib/mol-gl/shader/chunks/assign-material-color.glsl.js");
/* harmony import */ var _shader_chunks_assign_position_glsl__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ./shader/chunks/assign-position.glsl */ "./lib/mol-gl/shader/chunks/assign-position.glsl.js");
/* harmony import */ var _shader_chunks_assign_size_glsl__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! ./shader/chunks/assign-size.glsl */ "./lib/mol-gl/shader/chunks/assign-size.glsl.js");
/* harmony import */ var _shader_chunks_check_picking_alpha_glsl__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! ./shader/chunks/check-picking-alpha.glsl */ "./lib/mol-gl/shader/chunks/check-picking-alpha.glsl.js");
/* harmony import */ var _shader_chunks_clip_instance_glsl__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! ./shader/chunks/clip-instance.glsl */ "./lib/mol-gl/shader/chunks/clip-instance.glsl.js");
/* harmony import */ var _shader_chunks_clip_pixel_glsl__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! ./shader/chunks/clip-pixel.glsl */ "./lib/mol-gl/shader/chunks/clip-pixel.glsl.js");
/* harmony import */ var _shader_chunks_color_frag_params_glsl__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(/*! ./shader/chunks/color-frag-params.glsl */ "./lib/mol-gl/shader/chunks/color-frag-params.glsl.js");
/* harmony import */ var _shader_chunks_color_vert_params_glsl__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(/*! ./shader/chunks/color-vert-params.glsl */ "./lib/mol-gl/shader/chunks/color-vert-params.glsl.js");
/* harmony import */ var _shader_chunks_common_clip_glsl__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(/*! ./shader/chunks/common-clip.glsl */ "./lib/mol-gl/shader/chunks/common-clip.glsl.js");
/* harmony import */ var _shader_chunks_common_frag_params_glsl__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(/*! ./shader/chunks/common-frag-params.glsl */ "./lib/mol-gl/shader/chunks/common-frag-params.glsl.js");
/* harmony import */ var _shader_chunks_common_vert_params_glsl__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(/*! ./shader/chunks/common-vert-params.glsl */ "./lib/mol-gl/shader/chunks/common-vert-params.glsl.js");
/* harmony import */ var _shader_chunks_common_glsl__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(/*! ./shader/chunks/common.glsl */ "./lib/mol-gl/shader/chunks/common.glsl.js");
/* harmony import */ var _shader_chunks_float_to_rgba_glsl__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(/*! ./shader/chunks/float-to-rgba.glsl */ "./lib/mol-gl/shader/chunks/float-to-rgba.glsl.js");
/* harmony import */ var _shader_chunks_light_frag_params_glsl__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(/*! ./shader/chunks/light-frag-params.glsl */ "./lib/mol-gl/shader/chunks/light-frag-params.glsl.js");
/* harmony import */ var _shader_chunks_matrix_scale_glsl__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(/*! ./shader/chunks/matrix-scale.glsl */ "./lib/mol-gl/shader/chunks/matrix-scale.glsl.js");
/* harmony import */ var _shader_chunks_normal_frag_params_glsl__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__(/*! ./shader/chunks/normal-frag-params.glsl */ "./lib/mol-gl/shader/chunks/normal-frag-params.glsl.js");
/* harmony import */ var _shader_chunks_read_from_texture_glsl__WEBPACK_IMPORTED_MODULE_26__ = __webpack_require__(/*! ./shader/chunks/read-from-texture.glsl */ "./lib/mol-gl/shader/chunks/read-from-texture.glsl.js");
/* harmony import */ var _shader_chunks_rgba_to_float_glsl__WEBPACK_IMPORTED_MODULE_27__ = __webpack_require__(/*! ./shader/chunks/rgba-to-float.glsl */ "./lib/mol-gl/shader/chunks/rgba-to-float.glsl.js");
/* harmony import */ var _shader_chunks_size_vert_params_glsl__WEBPACK_IMPORTED_MODULE_28__ = __webpack_require__(/*! ./shader/chunks/size-vert-params.glsl */ "./lib/mol-gl/shader/chunks/size-vert-params.glsl.js");
/* harmony import */ var _shader_chunks_texture3d_from_1d_trilinear_glsl__WEBPACK_IMPORTED_MODULE_29__ = __webpack_require__(/*! ./shader/chunks/texture3d-from-1d-trilinear.glsl */ "./lib/mol-gl/shader/chunks/texture3d-from-1d-trilinear.glsl.js");
/* harmony import */ var _shader_chunks_texture3d_from_2d_linear_glsl__WEBPACK_IMPORTED_MODULE_30__ = __webpack_require__(/*! ./shader/chunks/texture3d-from-2d-linear.glsl */ "./lib/mol-gl/shader/chunks/texture3d-from-2d-linear.glsl.js");
/* harmony import */ var _shader_chunks_texture3d_from_2d_nearest_glsl__WEBPACK_IMPORTED_MODULE_31__ = __webpack_require__(/*! ./shader/chunks/texture3d-from-2d-nearest.glsl */ "./lib/mol-gl/shader/chunks/texture3d-from-2d-nearest.glsl.js");
/* harmony import */ var _shader_chunks_wboit_params_glsl__WEBPACK_IMPORTED_MODULE_32__ = __webpack_require__(/*! ./shader/chunks/wboit-params.glsl */ "./lib/mol-gl/shader/chunks/wboit-params.glsl.js");
/* harmony import */ var _shader_chunks_wboit_write_glsl__WEBPACK_IMPORTED_MODULE_33__ = __webpack_require__(/*! ./shader/chunks/wboit-write.glsl */ "./lib/mol-gl/shader/chunks/wboit-write.glsl.js");
/* harmony import */ var _shader_points_vert__WEBPACK_IMPORTED_MODULE_34__ = __webpack_require__(/*! ./shader/points.vert */ "./lib/mol-gl/shader/points.vert.js");
/* harmony import */ var _shader_points_frag__WEBPACK_IMPORTED_MODULE_35__ = __webpack_require__(/*! ./shader/points.frag */ "./lib/mol-gl/shader/points.frag.js");
/* harmony import */ var _shader_spheres_vert__WEBPACK_IMPORTED_MODULE_36__ = __webpack_require__(/*! ./shader/spheres.vert */ "./lib/mol-gl/shader/spheres.vert.js");
/* harmony import */ var _shader_spheres_frag__WEBPACK_IMPORTED_MODULE_37__ = __webpack_require__(/*! ./shader/spheres.frag */ "./lib/mol-gl/shader/spheres.frag.js");
/* harmony import */ var _shader_cylinders_vert__WEBPACK_IMPORTED_MODULE_38__ = __webpack_require__(/*! ./shader/cylinders.vert */ "./lib/mol-gl/shader/cylinders.vert.js");
/* harmony import */ var _shader_cylinders_frag__WEBPACK_IMPORTED_MODULE_39__ = __webpack_require__(/*! ./shader/cylinders.frag */ "./lib/mol-gl/shader/cylinders.frag.js");
/* harmony import */ var _shader_text_vert__WEBPACK_IMPORTED_MODULE_40__ = __webpack_require__(/*! ./shader/text.vert */ "./lib/mol-gl/shader/text.vert.js");
/* harmony import */ var _shader_text_frag__WEBPACK_IMPORTED_MODULE_41__ = __webpack_require__(/*! ./shader/text.frag */ "./lib/mol-gl/shader/text.frag.js");
/* harmony import */ var _shader_lines_vert__WEBPACK_IMPORTED_MODULE_42__ = __webpack_require__(/*! ./shader/lines.vert */ "./lib/mol-gl/shader/lines.vert.js");
/* harmony import */ var _shader_lines_frag__WEBPACK_IMPORTED_MODULE_43__ = __webpack_require__(/*! ./shader/lines.frag */ "./lib/mol-gl/shader/lines.frag.js");
/* harmony import */ var _shader_mesh_vert__WEBPACK_IMPORTED_MODULE_44__ = __webpack_require__(/*! ./shader/mesh.vert */ "./lib/mol-gl/shader/mesh.vert.js");
/* harmony import */ var _shader_mesh_frag__WEBPACK_IMPORTED_MODULE_45__ = __webpack_require__(/*! ./shader/mesh.frag */ "./lib/mol-gl/shader/mesh.frag.js");
/* harmony import */ var _shader_direct_volume_vert__WEBPACK_IMPORTED_MODULE_46__ = __webpack_require__(/*! ./shader/direct-volume.vert */ "./lib/mol-gl/shader/direct-volume.vert.js");
/* harmony import */ var _shader_direct_volume_frag__WEBPACK_IMPORTED_MODULE_47__ = __webpack_require__(/*! ./shader/direct-volume.frag */ "./lib/mol-gl/shader/direct-volume.frag.js");
/* harmony import */ var _shader_image_vert__WEBPACK_IMPORTED_MODULE_48__ = __webpack_require__(/*! ./shader/image.vert */ "./lib/mol-gl/shader/image.vert.js");
/* harmony import */ var _shader_image_frag__WEBPACK_IMPORTED_MODULE_49__ = __webpack_require__(/*! ./shader/image.frag */ "./lib/mol-gl/shader/image.frag.js");
/**
 * Copyright (c) 2018-2021 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */


var shaderCodeId = Object(_mol_util_id_factory__WEBPACK_IMPORTED_MODULE_0__["idFactory"])();
































var ShaderChunks = {
    apply_fog: _shader_chunks_apply_fog_glsl__WEBPACK_IMPORTED_MODULE_2__["default"],
    apply_interior_color: _shader_chunks_apply_interior_color_glsl__WEBPACK_IMPORTED_MODULE_3__["default"],
    apply_light_color: _shader_chunks_apply_light_color_glsl__WEBPACK_IMPORTED_MODULE_4__["default"],
    apply_marker_color: _shader_chunks_apply_marker_color_glsl__WEBPACK_IMPORTED_MODULE_5__["default"],
    assign_clipping_varying: _shader_chunks_assign_clipping_varying_glsl__WEBPACK_IMPORTED_MODULE_6__["default"],
    assign_color_varying: _shader_chunks_assign_color_varying_glsl__WEBPACK_IMPORTED_MODULE_7__["default"],
    assign_group: _shader_chunks_assign_group_glsl__WEBPACK_IMPORTED_MODULE_8__["default"],
    assign_marker_varying: _shader_chunks_assign_marker_varying_glsl__WEBPACK_IMPORTED_MODULE_9__["default"],
    assign_material_color: _shader_chunks_assign_material_color_glsl__WEBPACK_IMPORTED_MODULE_10__["default"],
    assign_position: _shader_chunks_assign_position_glsl__WEBPACK_IMPORTED_MODULE_11__["default"],
    assign_size: _shader_chunks_assign_size_glsl__WEBPACK_IMPORTED_MODULE_12__["default"],
    check_picking_alpha: _shader_chunks_check_picking_alpha_glsl__WEBPACK_IMPORTED_MODULE_13__["default"],
    clip_instance: _shader_chunks_clip_instance_glsl__WEBPACK_IMPORTED_MODULE_14__["default"],
    clip_pixel: _shader_chunks_clip_pixel_glsl__WEBPACK_IMPORTED_MODULE_15__["default"],
    color_frag_params: _shader_chunks_color_frag_params_glsl__WEBPACK_IMPORTED_MODULE_16__["default"],
    color_vert_params: _shader_chunks_color_vert_params_glsl__WEBPACK_IMPORTED_MODULE_17__["default"],
    common_clip: _shader_chunks_common_clip_glsl__WEBPACK_IMPORTED_MODULE_18__["default"],
    common_frag_params: _shader_chunks_common_frag_params_glsl__WEBPACK_IMPORTED_MODULE_19__["default"],
    common_vert_params: _shader_chunks_common_vert_params_glsl__WEBPACK_IMPORTED_MODULE_20__["default"],
    common: _shader_chunks_common_glsl__WEBPACK_IMPORTED_MODULE_21__["default"],
    float_to_rgba: _shader_chunks_float_to_rgba_glsl__WEBPACK_IMPORTED_MODULE_22__["default"],
    light_frag_params: _shader_chunks_light_frag_params_glsl__WEBPACK_IMPORTED_MODULE_23__["default"],
    matrix_scale: _shader_chunks_matrix_scale_glsl__WEBPACK_IMPORTED_MODULE_24__["default"],
    normal_frag_params: _shader_chunks_normal_frag_params_glsl__WEBPACK_IMPORTED_MODULE_25__["default"],
    read_from_texture: _shader_chunks_read_from_texture_glsl__WEBPACK_IMPORTED_MODULE_26__["default"],
    rgba_to_float: _shader_chunks_rgba_to_float_glsl__WEBPACK_IMPORTED_MODULE_27__["default"],
    size_vert_params: _shader_chunks_size_vert_params_glsl__WEBPACK_IMPORTED_MODULE_28__["default"],
    texture3d_from_1d_trilinear: _shader_chunks_texture3d_from_1d_trilinear_glsl__WEBPACK_IMPORTED_MODULE_29__["default"],
    texture3d_from_2d_linear: _shader_chunks_texture3d_from_2d_linear_glsl__WEBPACK_IMPORTED_MODULE_30__["default"],
    texture3d_from_2d_nearest: _shader_chunks_texture3d_from_2d_nearest_glsl__WEBPACK_IMPORTED_MODULE_31__["default"],
    wboit_params: _shader_chunks_wboit_params_glsl__WEBPACK_IMPORTED_MODULE_32__["default"],
    wboit_write: _shader_chunks_wboit_write_glsl__WEBPACK_IMPORTED_MODULE_33__["default"]
};
var reInclude = /^(?!\/\/)\s*#include\s+(\S+)/gmi;
var reSingleLineComment = /[ \t]*\/\/.*\n/g;
var reMultiLineComment = /[ \t]*\/\*[\s\S]*?\*\//g;
var reMultipleLinebreaks = /\n{2,}/g;
function addIncludes(text) {
    return text
        .replace(reInclude, function (_, p1) {
        var chunk = ShaderChunks[p1];
        if (!chunk)
            throw new Error("empty chunk, '" + p1 + "'");
        return chunk;
    })
        .trim()
        .replace(reSingleLineComment, '\n')
        .replace(reMultiLineComment, '\n')
        .replace(reMultipleLinebreaks, '\n');
}
function ShaderCode(name, vert, frag, extensions, outTypes) {
    if (extensions === void 0) { extensions = {}; }
    if (outTypes === void 0) { outTypes = {}; }
    return { id: shaderCodeId(), name: name, vert: addIncludes(vert), frag: addIncludes(frag), extensions: extensions, outTypes: outTypes };
}
// Note: `drawBuffers` need to be 'optional' for wboit


var PointsShaderCode = ShaderCode('points', _shader_points_vert__WEBPACK_IMPORTED_MODULE_34__["default"], _shader_points_frag__WEBPACK_IMPORTED_MODULE_35__["default"], { drawBuffers: 'optional' });


var SpheresShaderCode = ShaderCode('spheres', _shader_spheres_vert__WEBPACK_IMPORTED_MODULE_36__["default"], _shader_spheres_frag__WEBPACK_IMPORTED_MODULE_37__["default"], { fragDepth: 'required', drawBuffers: 'optional' });


var CylindersShaderCode = ShaderCode('cylinders', _shader_cylinders_vert__WEBPACK_IMPORTED_MODULE_38__["default"], _shader_cylinders_frag__WEBPACK_IMPORTED_MODULE_39__["default"], { fragDepth: 'required', drawBuffers: 'optional' });


var TextShaderCode = ShaderCode('text', _shader_text_vert__WEBPACK_IMPORTED_MODULE_40__["default"], _shader_text_frag__WEBPACK_IMPORTED_MODULE_41__["default"], { standardDerivatives: 'required', drawBuffers: 'optional' });


var LinesShaderCode = ShaderCode('lines', _shader_lines_vert__WEBPACK_IMPORTED_MODULE_42__["default"], _shader_lines_frag__WEBPACK_IMPORTED_MODULE_43__["default"], { drawBuffers: 'optional' });


var MeshShaderCode = ShaderCode('mesh', _shader_mesh_vert__WEBPACK_IMPORTED_MODULE_44__["default"], _shader_mesh_frag__WEBPACK_IMPORTED_MODULE_45__["default"], { standardDerivatives: 'optional', drawBuffers: 'optional' });


var DirectVolumeShaderCode = ShaderCode('direct-volume', _shader_direct_volume_vert__WEBPACK_IMPORTED_MODULE_46__["default"], _shader_direct_volume_frag__WEBPACK_IMPORTED_MODULE_47__["default"], { fragDepth: 'optional', drawBuffers: 'optional' });


var ImageShaderCode = ShaderCode('image', _shader_image_vert__WEBPACK_IMPORTED_MODULE_48__["default"], _shader_image_frag__WEBPACK_IMPORTED_MODULE_49__["default"], { drawBuffers: 'optional' });
function getDefinesCode(defines) {
    if (defines === undefined)
        return '';
    var lines = [];
    for (var name_1 in defines) {
        var define = defines[name_1];
        var v = define.ref.value;
        if (v !== undefined) {
            if (typeof v === 'string') {
                lines.push("#define " + name_1 + "_" + v);
            }
            else if (typeof v === 'number') {
                lines.push("#define " + name_1 + " " + v);
            }
            else if (typeof v === 'boolean') {
                if (v)
                    lines.push("#define " + name_1);
            }
            else {
                throw new Error('unknown define type');
            }
        }
    }
    return lines.join('\n') + '\n';
}
function getGlsl100FragPrefix(extensions, shaderExtensions) {
    var prefix = [];
    if (shaderExtensions.standardDerivatives) {
        prefix.push('#extension GL_OES_standard_derivatives : enable');
        prefix.push('#define enabledStandardDerivatives');
    }
    if (shaderExtensions.fragDepth) {
        if (extensions.fragDepth) {
            prefix.push('#extension GL_EXT_frag_depth : enable');
            prefix.push('#define enabledFragDepth');
        }
        else if (shaderExtensions.fragDepth === 'required') {
            throw new Error("required 'GL_EXT_frag_depth' extension not available");
        }
    }
    if (shaderExtensions.drawBuffers) {
        if (extensions.drawBuffers) {
            prefix.push('#extension GL_EXT_draw_buffers : require');
            prefix.push('#define requiredDrawBuffers');
            prefix.push('#define gl_FragColor gl_FragData[0]');
        }
        else if (shaderExtensions.drawBuffers === 'required') {
            throw new Error("required 'GL_EXT_draw_buffers' extension not available");
        }
    }
    if (shaderExtensions.shaderTextureLod) {
        if (extensions.shaderTextureLod) {
            prefix.push('#extension GL_EXT_shader_texture_lod : enable');
            prefix.push('#define enabledShaderTextureLod');
        }
        else if (shaderExtensions.shaderTextureLod === 'required') {
            throw new Error("required 'GL_EXT_shader_texture_lod' extension not available");
        }
    }
    if (extensions.depthTexture) {
        prefix.push('#define depthTextureSupport');
    }
    return prefix.join('\n') + '\n';
}
var glsl300VertPrefix = "#version 300 es\n#define attribute in\n#define varying out\n#define texture2D texture\n";
var glsl300FragPrefixCommon = "\n#define varying in\n#define texture2D texture\n#define texture2DLodEXT textureLod\n\n#define gl_FragColor out_FragData0\n#define gl_FragDepthEXT gl_FragDepth\n\n#define depthTextureSupport\n";
function getGlsl300FragPrefix(gl, extensions, shaderExtensions, outTypes) {
    var prefix = [
        '#version 300 es',
        "layout(location = 0) out highp " + (outTypes[0] || 'vec4') + " out_FragData0;"
    ];
    if (shaderExtensions.standardDerivatives) {
        prefix.push('#define enabledStandardDerivatives');
    }
    if (shaderExtensions.fragDepth) {
        prefix.push('#define enabledFragDepth');
    }
    if (shaderExtensions.drawBuffers) {
        prefix.push('#define requiredDrawBuffers');
        var maxDrawBuffers = gl.getParameter(gl.MAX_DRAW_BUFFERS);
        for (var i = 1, il = maxDrawBuffers; i < il; ++i) {
            prefix.push("layout(location = " + i + ") out highp " + (outTypes[i] || 'vec4') + " out_FragData" + i + ";");
        }
    }
    if (shaderExtensions.shaderTextureLod) {
        prefix.push('#define enabledShaderTextureLod');
    }
    prefix.push(glsl300FragPrefixCommon);
    return prefix.join('\n') + '\n';
}
function transformGlsl300Frag(frag) {
    return frag.replace(/gl_FragData\[([0-9]+)\]/g, 'out_FragData$1');
}
function addShaderDefines(gl, extensions, defines, shaders) {
    var header = getDefinesCode(defines);
    var vertPrefix = Object(_webgl_compat__WEBPACK_IMPORTED_MODULE_1__["isWebGL2"])(gl) ? glsl300VertPrefix : '';
    var fragPrefix = Object(_webgl_compat__WEBPACK_IMPORTED_MODULE_1__["isWebGL2"])(gl)
        ? getGlsl300FragPrefix(gl, extensions, shaders.extensions, shaders.outTypes)
        : getGlsl100FragPrefix(extensions, shaders.extensions);
    var frag = Object(_webgl_compat__WEBPACK_IMPORTED_MODULE_1__["isWebGL2"])(gl) ? transformGlsl300Frag(shaders.frag) : shaders.frag;
    return {
        id: shaderCodeId(),
        name: shaders.name,
        vert: "" + vertPrefix + header + shaders.vert,
        frag: "" + fragPrefix + header + frag,
        extensions: shaders.extensions,
        outTypes: shaders.outTypes
    };
}
//# sourceMappingURL=shader-code.js.map

/***/ }),

/***/ "./lib/mol-gl/shader/chunks/apply-fog.glsl.js":
/*!****************************************************!*\
  !*** ./lib/mol-gl/shader/chunks/apply-fog.glsl.js ***!
  \****************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("\nfloat viewZ = depthToViewZ(uIsOrtho, fragmentDepth, uNear, uFar);\nfloat fogFactor = smoothstep(uFogNear, uFogFar, abs(viewZ));\nfloat fogAlpha = (1.0 - fogFactor) * gl_FragColor.a;\nfloat preFogAlpha = gl_FragColor.a;\nif (!uTransparentBackground) {\n    if (gl_FragColor.a < 1.0) {\n        // transparent objects are blended with background color\n        gl_FragColor.a = fogAlpha;\n    } else {\n        // mix opaque objects with background color\n        gl_FragColor.rgb = mix(gl_FragColor.rgb, uFogColor, fogFactor);\n    }\n} else {\n    // pre-multiplied alpha expected for transparent background\n    gl_FragColor.rgb *= fogAlpha;\n    gl_FragColor.a = fogAlpha;\n}\n");
//# sourceMappingURL=apply-fog.glsl.js.map

/***/ }),

/***/ "./lib/mol-gl/shader/chunks/apply-interior-color.glsl.js":
/*!***************************************************************!*\
  !*** ./lib/mol-gl/shader/chunks/apply-interior-color.glsl.js ***!
  \***************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("\nif (interior) {\n    if (uInteriorColorFlag) {\n        gl_FragColor.rgb = uInteriorColor;\n    } else {\n        gl_FragColor.rgb *= 1.0 - uInteriorDarkening;\n    }\n}\n");
//# sourceMappingURL=apply-interior-color.glsl.js.map

/***/ }),

/***/ "./lib/mol-gl/shader/chunks/apply-light-color.glsl.js":
/*!************************************************************!*\
  !*** ./lib/mol-gl/shader/chunks/apply-light-color.glsl.js ***!
  \************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/**
 * Copyright (c) 2017-2019 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 *
 * adapted from three.js (https://github.com/mrdoob/three.js/)
 * which under the MIT License, Copyright © 2010-2019 three.js authors
 */
/* harmony default export */ __webpack_exports__["default"] = ("\n// inputs\n// - vec4 material\n// - vec3 vViewPosition\n// - vec3 normal\n// - float uMetalness\n// - float uRoughness\n// - float uReflectivity\n// - float uLightIntensity\n// - float uAmbientIntensity\n\n// outputs\n// - sets gl_FragColor\n\nvec4 color = material;\n\nReflectedLight reflectedLight = ReflectedLight(vec3(0.0), vec3(0.0), vec3(0.0));\n\nPhysicalMaterial physicalMaterial;\nphysicalMaterial.diffuseColor = color.rgb * (1.0 - uMetalness);\nphysicalMaterial.specularRoughness = clamp(uRoughness, 0.04, 1.0);\nphysicalMaterial.specularColor = mix(vec3(0.16 * pow2(uReflectivity)), color.rgb, uMetalness);\n\nGeometricContext geometry;\ngeometry.position = -vViewPosition;\ngeometry.normal = normal;\ngeometry.viewDir = normalize(vViewPosition);\n\nIncidentLight directLight;\ndirectLight.direction = vec3(0.0, 0.0, -1.0);\ndirectLight.color = vec3(uLightIntensity);\n\nRE_Direct_Physical(directLight, geometry, physicalMaterial, reflectedLight);\n\nvec3 irradiance = vec3(uAmbientIntensity) * PI;\nRE_IndirectDiffuse_Physical(irradiance, geometry, physicalMaterial, reflectedLight);\n\nvec3 outgoingLight = reflectedLight.directDiffuse + reflectedLight.indirectDiffuse + reflectedLight.directSpecular;\n\ngl_FragColor = vec4(outgoingLight, color.a);\n\n#ifdef dXrayShaded\n    gl_FragColor.a *= 1.0 - pow(abs(dot(normal, vec3(0, 0, 1))), uXrayEdgeFalloff);\n#endif\n");
//# sourceMappingURL=apply-light-color.glsl.js.map

/***/ }),

/***/ "./lib/mol-gl/shader/chunks/apply-marker-color.glsl.js":
/*!*************************************************************!*\
  !*** ./lib/mol-gl/shader/chunks/apply-marker-color.glsl.js ***!
  \*************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("\nfloat marker = floor(vMarker * 255.0 + 0.5); // rounding required to work on some cards on win\nif (marker > 0.1) {\n    if (intMod(marker, 2.0) > 0.1) {\n        gl_FragColor.rgb = mix(uHighlightColor, gl_FragColor.rgb, 0.3);\n        gl_FragColor.a = max(0.02, gl_FragColor.a); // for direct-volume rendering\n    } else {\n        gl_FragColor.rgb = mix(uSelectColor, gl_FragColor.rgb, 0.3);\n    }\n}\n");
//# sourceMappingURL=apply-marker-color.glsl.js.map

/***/ }),

/***/ "./lib/mol-gl/shader/chunks/assign-clipping-varying.glsl.js":
/*!******************************************************************!*\
  !*** ./lib/mol-gl/shader/chunks/assign-clipping-varying.glsl.js ***!
  \******************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("\n#if dClipObjectCount != 0 && defined(dClipping)\n    vClipping = readFromTexture(tClipping, aInstance * float(uGroupCount) + group, uClippingTexDim).a;\n#endif\n");
//# sourceMappingURL=assign-clipping-varying.glsl.js.map

/***/ }),

/***/ "./lib/mol-gl/shader/chunks/assign-color-varying.glsl.js":
/*!***************************************************************!*\
  !*** ./lib/mol-gl/shader/chunks/assign-color-varying.glsl.js ***!
  \***************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("\n#if defined(dRenderVariant_color)\n    #if defined(dColorType_attribute)\n        vColor.rgb = aColor;\n    #elif defined(dColorType_instance)\n        vColor.rgb = readFromTexture(tColor, aInstance, uColorTexDim).rgb;\n    #elif defined(dColorType_group)\n        vColor.rgb = readFromTexture(tColor, group, uColorTexDim).rgb;\n    #elif defined(dColorType_groupInstance)\n        vColor.rgb = readFromTexture(tColor, aInstance * float(uGroupCount) + group, uColorTexDim).rgb;\n    #elif defined(dColorType_vertex)\n        vColor.rgb = readFromTexture(tColor, aVertex, uColorTexDim).rgb;\n    #elif defined(dColorType_vertexInstance)\n        vColor.rgb = readFromTexture(tColor, aInstance * float(uVertexCount) + aVertex, uColorTexDim).rgb;\n    #endif\n\n    #ifdef dOverpaint\n        vOverpaint = readFromTexture(tOverpaint, aInstance * float(uGroupCount) + group, uOverpaintTexDim);\n    #endif\n#elif defined(dRenderVariant_pick)\n    #if defined(dRenderVariant_pickObject)\n        vColor = vec4(encodeFloatRGB(float(uObjectId)), 1.0);\n    #elif defined(dRenderVariant_pickInstance)\n        vColor = vec4(encodeFloatRGB(aInstance), 1.0);\n    #elif defined(dRenderVariant_pickGroup)\n        vColor = vec4(encodeFloatRGB(group), 1.0);\n    #endif\n#endif\n\n#ifdef dTransparency\n    vGroup = group;\n    vTransparency = readFromTexture(tTransparency, aInstance * float(uGroupCount) + group, uTransparencyTexDim).a;\n#endif\n");
//# sourceMappingURL=assign-color-varying.glsl.js.map

/***/ }),

/***/ "./lib/mol-gl/shader/chunks/assign-group.glsl.js":
/*!*******************************************************!*\
  !*** ./lib/mol-gl/shader/chunks/assign-group.glsl.js ***!
  \*******************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("\n#ifdef dGeoTexture\n    // aGroup is used as a vertex index here and the group id is retirieved from tPositionGroup\n    float group = readFromTexture(tPositionGroup, aGroup, uGeoTexDim).w;\n#else\n    float group = aGroup;\n#endif\n");
//# sourceMappingURL=assign-group.glsl.js.map

/***/ }),

/***/ "./lib/mol-gl/shader/chunks/assign-marker-varying.glsl.js":
/*!****************************************************************!*\
  !*** ./lib/mol-gl/shader/chunks/assign-marker-varying.glsl.js ***!
  \****************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("\nvMarker = readFromTexture(tMarker, aInstance * float(uGroupCount) + group, uMarkerTexDim).a;\n");
//# sourceMappingURL=assign-marker-varying.glsl.js.map

/***/ }),

/***/ "./lib/mol-gl/shader/chunks/assign-material-color.glsl.js":
/*!****************************************************************!*\
  !*** ./lib/mol-gl/shader/chunks/assign-material-color.glsl.js ***!
  \****************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("\n#if defined(dRenderVariant_color)\n    #if defined(dColorType_uniform)\n        vec4 material = vec4(uColor, uAlpha);\n    #elif defined(dColorType_varying)\n        vec4 material = vec4(vColor.rgb, uAlpha);\n    #endif\n\n    // mix material with overpaint\n    #if defined(dOverpaint)\n        material.rgb = mix(material.rgb, vOverpaint.rgb, vOverpaint.a);\n    #endif\n#elif defined(dRenderVariant_pick)\n    vec4 material = vColor;\n#elif defined(dRenderVariant_depth)\n    #ifdef enabledFragDepth\n        vec4 material = packDepthToRGBA(gl_FragDepthEXT);\n    #else\n        vec4 material = packDepthToRGBA(gl_FragCoord.z);\n    #endif\n#endif\n\n// apply screendoor transparency\n#if defined(dTransparency)\n    float ta = 1.0 - vTransparency;\n\n    #if defined(dRenderVariant_pick)\n        if (ta < uPickingAlphaThreshold)\n            discard; // ignore so the element below can be picked\n    #else\n        #if defined(dRenderVariant_colorBlended)\n            float at = 0.0;\n\n            // shift by view-offset during multi-sample rendering to allow for blending\n            vec2 coord = gl_FragCoord.xy + uViewOffset * 0.25;\n\n            const mat4 thresholdMatrix = mat4(\n                1.0 / 17.0,  9.0 / 17.0,  3.0 / 17.0, 11.0 / 17.0,\n                13.0 / 17.0,  5.0 / 17.0, 15.0 / 17.0,  7.0 / 17.0,\n                4.0 / 17.0, 12.0 / 17.0,  2.0 / 17.0, 10.0 / 17.0,\n                16.0 / 17.0,  8.0 / 17.0, 14.0 / 17.0,  6.0 / 17.0\n            );\n            int ci = int(intMod(coord.x, 4.0));\n            int ri = int(intMod(coord.y, 4.0));\n            #if __VERSION__ == 100\n                vec4 i = vec4(float(ci * 4 + ri));\n                vec4 v = thresholdMatrix[0] * vec4(equal(i, vec4(0.0, 1.0, 2.0, 3.0))) +\n                    thresholdMatrix[1] * vec4(equal(i, vec4(4.0, 5.0, 6.0, 7.0))) +\n                    thresholdMatrix[2] * vec4(equal(i, vec4(8.0, 9.0, 10.0, 11.0))) +\n                    thresholdMatrix[3] * vec4(equal(i, vec4(12.0, 13.0, 14.0, 15.0)));\n                at = v.x + v.y + v.z + v.w;\n            #else\n                at = thresholdMatrix[ci][ri];\n            #endif\n\n            if (ta < 0.99 && (ta < 0.01 || ta < at)) {\n                discard;\n            }\n        #elif defined(dRenderVariant_colorWboit)\n            material.a *= ta;\n        #endif\n    #endif\n#endif\n");
//# sourceMappingURL=assign-material-color.glsl.js.map

/***/ }),

/***/ "./lib/mol-gl/shader/chunks/assign-position.glsl.js":
/*!**********************************************************!*\
  !*** ./lib/mol-gl/shader/chunks/assign-position.glsl.js ***!
  \**********************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("\nmat4 model = uModel * aTransform;\nmat4 modelView = uView * model;\n#ifdef dGeoTexture\n    vec3 position = readFromTexture(tPositionGroup, aGroup, uGeoTexDim).xyz;\n#else\n    vec3 position = aPosition;\n#endif\nvec4 position4 = vec4(position, 1.0);\nvModelPosition = (model * position4).xyz; // for clipping in frag shader\nvec4 mvPosition = modelView * position4;\nvViewPosition = mvPosition.xyz;\ngl_Position = uProjection * mvPosition;\n");
//# sourceMappingURL=assign-position.glsl.js.map

/***/ }),

/***/ "./lib/mol-gl/shader/chunks/assign-size.glsl.js":
/*!******************************************************!*\
  !*** ./lib/mol-gl/shader/chunks/assign-size.glsl.js ***!
  \******************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("\n#if defined(dSizeType_uniform)\n    float size = uSize;\n#elif defined(dSizeType_attribute)\n    float size = aSize;\n#elif defined(dSizeType_instance)\n    float size = decodeFloatRGB(readFromTexture(tSize, aInstance, uSizeTexDim).rgb);\n#elif defined(dSizeType_group)\n    float size = decodeFloatRGB(readFromTexture(tSize, group, uSizeTexDim).rgb);\n#elif defined(dSizeType_groupInstance)\n    float size = decodeFloatRGB(readFromTexture(tSize, aInstance * float(uGroupCount) + group, uSizeTexDim).rgb);\n#endif\n\n#if defined(dSizeType_instance) || defined(dSizeType_group) || defined(dSizeType_groupInstance)\n    size /= 100.0; // NOTE factor also set in TypeScript\n#endif\n\nsize *= uSizeFactor;\n");
//# sourceMappingURL=assign-size.glsl.js.map

/***/ }),

/***/ "./lib/mol-gl/shader/chunks/check-picking-alpha.glsl.js":
/*!**************************************************************!*\
  !*** ./lib/mol-gl/shader/chunks/check-picking-alpha.glsl.js ***!
  \**************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("\nfloat viewZ = depthToViewZ(uIsOrtho, fragmentDepth, uNear, uFar);\nfloat fogFactor = smoothstep(uFogNear, uFogFar, abs(viewZ));\nfloat alpha = (1.0 - fogFactor) * uAlpha;\nif (uAlpha < uPickingAlphaThreshold || alpha < 0.1)\n    discard; // ignore so the element below can be picked\n");
//# sourceMappingURL=check-picking-alpha.glsl.js.map

/***/ }),

/***/ "./lib/mol-gl/shader/chunks/clip-instance.glsl.js":
/*!********************************************************!*\
  !*** ./lib/mol-gl/shader/chunks/clip-instance.glsl.js ***!
  \********************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("\n#if defined(dClipVariant_instance) && dClipObjectCount != 0\n    int flag = 0;\n    #if defined(dClipping)\n        flag = int(floor(vClipping * 255.0 + 0.5));\n    #endif\n\n    vec4 mCenter = uModel * aTransform * vec4(uInvariantBoundingSphere.xyz, 1.0);\n    if (clipTest(vec4(mCenter.xyz, uInvariantBoundingSphere.w), flag))\n        // move out of [ -w, +w ] to 'discard' in vert shader\n        gl_Position.z = 2.0 * gl_Position.w;\n#endif\n");
//# sourceMappingURL=clip-instance.glsl.js.map

/***/ }),

/***/ "./lib/mol-gl/shader/chunks/clip-pixel.glsl.js":
/*!*****************************************************!*\
  !*** ./lib/mol-gl/shader/chunks/clip-pixel.glsl.js ***!
  \*****************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("\n#if defined(dClipVariant_pixel) && dClipObjectCount != 0\n    #if defined(dClipping)\n        int clippingFlag = int(floor(vClipping * 255.0 + 0.5));\n    #else\n        int clippingFlag = 0;\n    #endif\n\n    if (clipTest(vec4(vModelPosition, 0.0), clippingFlag))\n        discard;\n#endif\n");
//# sourceMappingURL=clip-pixel.glsl.js.map

/***/ }),

/***/ "./lib/mol-gl/shader/chunks/color-frag-params.glsl.js":
/*!************************************************************!*\
  !*** ./lib/mol-gl/shader/chunks/color-frag-params.glsl.js ***!
  \************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("\n#if defined(dRenderVariant_color)\n    #if defined(dColorType_uniform)\n        uniform vec3 uColor;\n    #elif defined(dColorType_varying)\n        varying vec4 vColor;\n    #endif\n\n    #ifdef dOverpaint\n        varying vec4 vOverpaint;\n    #endif\n#elif defined(dRenderVariant_pick)\n    #if __VERSION__ == 100\n        varying vec4 vColor;\n    #else\n        flat in vec4 vColor;\n    #endif\n#endif\n\n#ifdef dTransparency\n    varying float vGroup;\n    varying float vTransparency;\n#endif\n");
//# sourceMappingURL=color-frag-params.glsl.js.map

/***/ }),

/***/ "./lib/mol-gl/shader/chunks/color-vert-params.glsl.js":
/*!************************************************************!*\
  !*** ./lib/mol-gl/shader/chunks/color-vert-params.glsl.js ***!
  \************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("\n#if defined(dRenderVariant_color)\n    #if defined(dColorType_uniform)\n        uniform vec3 uColor;\n    #elif defined(dColorType_attribute)\n        varying vec4 vColor;\n        attribute vec3 aColor;\n    #elif defined(dColorType_texture)\n        varying vec4 vColor;\n        uniform vec2 uColorTexDim;\n        uniform sampler2D tColor;\n    #endif\n\n    #if defined(dColorType_vertex) || defined(dColorType_vertexInstance)\n        #if __VERSION__ == 100\n            attribute float aVertex;\n        #else\n            #define aVertex float(gl_VertexID)\n        #endif\n    #endif\n\n    #ifdef dOverpaint\n        varying vec4 vOverpaint;\n        uniform vec2 uOverpaintTexDim;\n        uniform sampler2D tOverpaint;\n    #endif\n#elif defined(dRenderVariant_pick)\n    #if __VERSION__ == 100\n        varying vec4 vColor;\n    #else\n        flat out vec4 vColor;\n    #endif\n#endif\n\n#ifdef dTransparency\n    varying float vGroup;\n    varying float vTransparency;\n    uniform vec2 uTransparencyTexDim;\n    uniform sampler2D tTransparency;\n#endif\n");
//# sourceMappingURL=color-vert-params.glsl.js.map

/***/ }),

/***/ "./lib/mol-gl/shader/chunks/common-clip.glsl.js":
/*!******************************************************!*\
  !*** ./lib/mol-gl/shader/chunks/common-clip.glsl.js ***!
  \******************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/**
 * Copyright (c) 2020 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author Ludovic Autin <autin@scripps.edu>
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */
/* harmony default export */ __webpack_exports__["default"] = ("\n#if dClipObjectCount != 0\n    vec3 quaternionTransform(vec4 q, vec3 v) {\n        vec3 t = 2.0 * cross(q.xyz, v);\n        return v + q.w * t + cross(q.xyz, t);\n    }\n\n    vec4 computePlane(vec3 normal, vec3 inPoint) {\n        return vec4(normalize(normal), -dot(normal, inPoint));\n    }\n\n    float planeSD(vec4 plane, vec3 center) {\n        return -dot(plane.xyz, center - plane.xyz * -plane.w);\n    }\n\n    float sphereSD(vec3 position, vec4 rotation, vec3 size, vec3 center) {\n        return (\n            length(quaternionTransform(vec4(-rotation.x, -rotation.y, -rotation.z, rotation.w), center - position) / size) - 1.0\n        ) * min(min(size.x, size.y), size.z);\n    }\n\n    float cubeSD(vec3 position, vec4 rotation, vec3 size, vec3 center) {\n        vec3 d = abs(quaternionTransform(vec4(-rotation.x, -rotation.y, -rotation.z, rotation.w), center - position)) - size;\n        return min(max(d.x, max(d.y, d.z)), 0.0) + length(max(d, 0.0));\n    }\n\n    float cylinderSD(vec3 position, vec4 rotation, vec3 size, vec3 center) {\n        vec3 t = quaternionTransform(vec4(-rotation.x, -rotation.y, -rotation.z, rotation.w), center - position);\n\n        vec2 d = abs(vec2(length(t.xz), t.y)) - size.xy;\n        return min(max(d.x, d.y), 0.0) + length(max(d, 0.0));\n    }\n\n    float infiniteConeSD(vec3 position, vec4 rotation, vec3 size, vec3 center) {\n        vec3 t = quaternionTransform(vec4(-rotation.x, -rotation.y, -rotation.z, rotation.w), center - position);\n\n        float q = length(t.xy);\n        return dot(size.xy, vec2(q, t.z));\n    }\n\n    float getSignedDistance(vec3 center, int type, vec3 position, vec4 rotation, vec3 scale) {\n        if (type == 1) {\n            vec3 normal = quaternionTransform(rotation, vec3(0.0, 1.0, 0.0));\n            vec4 plane = computePlane(normal, position);\n            return planeSD(plane, center);\n        } else if (type == 2) {\n            return sphereSD(position, rotation, scale * 0.5, center);\n        } else if (type == 3) {\n            return cubeSD(position, rotation, scale * 0.5, center);\n        } else if (type == 4) {\n            return cylinderSD(position, rotation, scale * 0.5, center);\n        } else if (type == 5) {\n            return infiniteConeSD(position, rotation, scale * 0.5, center);\n        } else {\n            return 0.1;\n        }\n    }\n\n    #if __VERSION__ == 100\n        // 8-bit\n        int bitwiseAnd(int a, int b) {\n            int d = 128;\n            int result = 0;\n            for (int i = 0; i < 8; ++i) {\n                if (d <= 0) break;\n                if (a >= d && b >= d) result += d;\n                if (a >= d) a -= d;\n                if (b >= d) b -= d;\n                d /= 2;\n            }\n            return result;\n        }\n\n        bool hasBit(int mask, int bit) {\n            return bitwiseAnd(mask, bit) == 0;\n        }\n    #else\n        bool hasBit(int mask, int bit) {\n            return (mask & bit) == 0;\n        }\n    #endif\n\n    // flag is a bit-flag for clip-objects to ignore (note, object ids start at 1 not 0)\n    bool clipTest(vec4 sphere, int flag) {\n        for (int i = 0; i < dClipObjectCount; ++i) {\n            if (flag == 0 || hasBit(flag, i + 1)) {\n                // TODO take sphere radius into account?\n                bool test = getSignedDistance(sphere.xyz, uClipObjectType[i], uClipObjectPosition[i], uClipObjectRotation[i], uClipObjectScale[i]) <= 0.0;\n                if ((!uClipObjectInvert[i] && test) || (uClipObjectInvert[i] && !test)) {\n                    return true;\n                }\n            }\n        }\n        return false;\n    }\n#endif\n");
//# sourceMappingURL=common-clip.glsl.js.map

/***/ }),

/***/ "./lib/mol-gl/shader/chunks/common-frag-params.glsl.js":
/*!*************************************************************!*\
  !*** ./lib/mol-gl/shader/chunks/common-frag-params.glsl.js ***!
  \*************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("\nuniform int uObjectId;\nuniform int uInstanceCount;\nuniform int uGroupCount;\n\n#if dClipObjectCount != 0\n    uniform int uClipObjectType[dClipObjectCount];\n    uniform bool uClipObjectInvert[dClipObjectCount];\n    uniform vec3 uClipObjectPosition[dClipObjectCount];\n    uniform vec4 uClipObjectRotation[dClipObjectCount];\n    uniform vec3 uClipObjectScale[dClipObjectCount];\n\n    #if defined(dClipping)\n        #if __VERSION__ == 100\n            varying float vClipping;\n        #else\n            flat in float vClipping;\n        #endif\n    #endif\n#endif\n\nuniform vec3 uHighlightColor;\nuniform vec3 uSelectColor;\n#if __VERSION__ == 100\n    varying float vMarker;\n#else\n    flat in float vMarker;\n#endif\n\nvarying vec3 vModelPosition;\nvarying vec3 vViewPosition;\n\nuniform vec2 uViewOffset;\n\nuniform float uNear;\nuniform float uFar;\nuniform float uIsOrtho;\n\nuniform float uFogNear;\nuniform float uFogFar;\nuniform vec3 uFogColor;\n\nuniform float uAlpha;\nuniform float uPickingAlphaThreshold;\nuniform bool uTransparentBackground;\n\nuniform float uInteriorDarkening;\nuniform bool uInteriorColorFlag;\nuniform vec3 uInteriorColor;\nbool interior;\n\nuniform float uXrayEdgeFalloff;\n\nuniform mat4 uProjection;\n");
//# sourceMappingURL=common-frag-params.glsl.js.map

/***/ }),

/***/ "./lib/mol-gl/shader/chunks/common-vert-params.glsl.js":
/*!*************************************************************!*\
  !*** ./lib/mol-gl/shader/chunks/common-vert-params.glsl.js ***!
  \*************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("\nuniform mat4 uProjection, uModel, uView;\nuniform vec3 uCameraPosition;\n\nuniform int uObjectId;\nuniform int uVertexCount;\nuniform int uInstanceCount;\nuniform int uGroupCount;\nuniform vec4 uInvariantBoundingSphere;\n\n#if dClipObjectCount != 0\n    uniform int uClipObjectType[dClipObjectCount];\n    uniform bool uClipObjectInvert[dClipObjectCount];\n    uniform vec3 uClipObjectPosition[dClipObjectCount];\n    uniform vec4 uClipObjectRotation[dClipObjectCount];\n    uniform vec3 uClipObjectScale[dClipObjectCount];\n\n    #if defined(dClipping)\n        uniform vec2 uClippingTexDim;\n        uniform sampler2D tClipping;\n        #if __VERSION__ == 100\n            varying float vClipping;\n        #else\n            flat out float vClipping;\n        #endif\n    #endif\n#endif\n\nuniform vec2 uMarkerTexDim;\nuniform sampler2D tMarker;\n#if __VERSION__ == 100\n    varying float vMarker;\n#else\n    flat out float vMarker;\n#endif\n\nvarying vec3 vModelPosition;\nvarying vec3 vViewPosition;\n");
//# sourceMappingURL=common-vert-params.glsl.js.map

/***/ }),

/***/ "./lib/mol-gl/shader/chunks/common.glsl.js":
/*!*************************************************!*\
  !*** ./lib/mol-gl/shader/chunks/common.glsl.js ***!
  \*************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("\n// TODO find a better place for these convenience defines\n\n#if defined(dRenderVariant_colorBlended) || defined(dRenderVariant_colorWboit)\n    #define dRenderVariant_color\n#endif\n\n#if defined(dRenderVariant_pickObject) || defined(dRenderVariant_pickInstance) || defined(dRenderVariant_pickGroup)\n    #define dRenderVariant_pick\n#endif\n\n#if defined(dColorType_instance) || defined(dColorType_group) || defined(dColorType_groupInstance) || defined(dColorType_vertex) || defined(dColorType_vertexInstance)\n    #define dColorType_texture\n#endif\n\n#if defined(dColorType_attribute) || defined(dColorType_texture)\n    #define dColorType_varying\n#endif\n\n//\n\n#define PI 3.14159265\n#define RECIPROCAL_PI 0.31830988618\n#define EPSILON 1e-6\n\n#define saturate(a) clamp(a, 0.0, 1.0)\n\nfloat intDiv(const in float a, const in float b) { return float(int(a) / int(b)); }\nvec2 ivec2Div(const in vec2 a, const in vec2 b) { return vec2(ivec2(a) / ivec2(b)); }\nfloat intMod(const in float a, const in float b) { return a - b * float(int(a) / int(b)); }\n\nfloat pow2(const in float x) { return x * x; }\n\nconst float maxFloat = 10000.0; // NOTE constant also set in TypeScript\nconst float floatLogFactor = 9.210440366976517; // log(maxFloat + 1.0);\nfloat encodeFloatLog(const in float value) { return log(value + 1.0) / floatLogFactor; }\nfloat decodeFloatLog(const in float value) { return exp(value * floatLogFactor) - 1.0; }\n\nvec3 encodeFloatRGB(in float value) {\n    value = clamp(value, 0.0, 16777216.0 - 1.0) + 1.0;\n    vec3 c = vec3(0.0);\n    c.b = mod(value, 256.0);\n    value = floor(value / 256.0);\n    c.g = mod(value, 256.0);\n    value = floor(value / 256.0);\n    c.r = mod(value, 256.0);\n    return c / 255.0;\n}\nfloat decodeFloatRGB(const in vec3 rgb) {\n    return (rgb.r * 256.0 * 256.0 * 255.0 + rgb.g * 256.0 * 255.0 + rgb.b * 255.0) - 1.0;\n}\n\nvec2 packUnitIntervalToRG(const in float v) {\n    vec2 enc;\n    enc.xy = vec2(fract(v * 256.0), v);\n    enc.y -= enc.x * (1.0 / 256.0);\n    enc.xy *=  256.0 / 255.0;\n\n    return enc;\n}\n\nfloat unpackRGToUnitInterval(const in vec2 enc) {\n    return dot(enc, vec2(255.0 / (256.0 * 256.0), 255.0 / 256.0));\n}\n\nvec3 screenSpaceToViewSpace(const in vec3 ssPos, const in mat4 invProjection) {\n    vec4 p = vec4(ssPos * 2.0 - 1.0, 1.0);\n    p = invProjection * p;\n    return p.xyz / p.w;\n}\n\nconst float PackUpscale = 256.0 / 255.0; // fraction -> 0..1 (including 1)\nconst float UnpackDownscale = 255.0 / 256.0; // 0..1 -> fraction (excluding 1)\nconst vec3 PackFactors = vec3(256.0 * 256.0 * 256.0, 256.0 * 256.0,  256.0);\nconst vec4 UnpackFactors = UnpackDownscale / vec4(PackFactors, 1.0);\nconst float ShiftRight8 = 1.0 / 256.0;\n\nvec4 packDepthToRGBA(const in float v) {\n    vec4 r = vec4(fract(v * PackFactors), v);\n    r.yzw -= r.xyz * ShiftRight8; // tidy overflow\n    return r * PackUpscale;\n}\nfloat unpackRGBAToDepth(const in vec4 v) {\n    return dot(v, UnpackFactors);\n}\n\nvec4 sRGBToLinear(const in vec4 c) {\n    return vec4(mix(pow(c.rgb * 0.9478672986 + vec3(0.0521327014), vec3(2.4)), c.rgb * 0.0773993808, vec3(lessThanEqual(c.rgb, vec3(0.04045)))), c.a);\n}\nvec4 linearTosRGB(const in vec4 c) {\n    return vec4(mix(pow(c.rgb, vec3(0.41666)) * 1.055 - vec3(0.055), c.rgb * 12.92, vec3(lessThanEqual(c.rgb, vec3(0.0031308)))), c.a);\n}\n\nfloat linearizeDepth(const in float depth, const in float near, const in float far) {\n    return (2.0 * near) / (far + near - depth * (far - near));\n}\n\nfloat perspectiveDepthToViewZ(const in float invClipZ, const in float near, const in float far) {\n    return (near * far) / ((far - near) * invClipZ - far);\n}\n\nfloat orthographicDepthToViewZ(const in float linearClipZ, const in float near, const in float far) {\n    return linearClipZ * (near - far) - near;\n}\n\nfloat depthToViewZ(const in float isOrtho, const in float linearClipZ, const in float near, const in float far) {\n    return isOrtho == 1.0 ? orthographicDepthToViewZ(linearClipZ, near, far) : perspectiveDepthToViewZ(linearClipZ, near, far);\n}\n\n#if __VERSION__ == 100\n    // transpose\n\n    float transpose(const in float m) {\n        return m;\n    }\n\n    mat2 transpose2(const in mat2 m) {\n        return mat2(\n            m[0][0], m[1][0],\n            m[0][1], m[1][1]\n        );\n    }\n\n    mat3 transpose3(const in mat3 m) {\n        return mat3(\n            m[0][0], m[1][0], m[2][0],\n            m[0][1], m[1][1], m[2][1],\n            m[0][2], m[1][2], m[2][2]\n        );\n    }\n\n    mat4 transpose4(const in mat4 m) {\n        return mat4(\n            m[0][0], m[1][0], m[2][0], m[3][0],\n            m[0][1], m[1][1], m[2][1], m[3][1],\n            m[0][2], m[1][2], m[2][2], m[3][2],\n            m[0][3], m[1][3], m[2][3], m[3][3]\n        );\n    }\n\n    // inverse\n\n    float inverse(const in float m) {\n        return 1.0 / m;\n    }\n\n    mat2 inverse2(const in mat2 m) {\n        return mat2(m[1][1],-m[0][1],\n                -m[1][0], m[0][0]) / (m[0][0]*m[1][1] - m[0][1]*m[1][0]);\n    }\n\n    mat3 inverse3(const in mat3 m) {\n        float a00 = m[0][0], a01 = m[0][1], a02 = m[0][2];\n        float a10 = m[1][0], a11 = m[1][1], a12 = m[1][2];\n        float a20 = m[2][0], a21 = m[2][1], a22 = m[2][2];\n\n        float b01 = a22 * a11 - a12 * a21;\n        float b11 = -a22 * a10 + a12 * a20;\n        float b21 = a21 * a10 - a11 * a20;\n\n        float det = a00 * b01 + a01 * b11 + a02 * b21;\n\n        return mat3(b01, (-a22 * a01 + a02 * a21), (a12 * a01 - a02 * a11),\n                    b11, (a22 * a00 - a02 * a20), (-a12 * a00 + a02 * a10),\n                    b21, (-a21 * a00 + a01 * a20), (a11 * a00 - a01 * a10)) / det;\n    }\n\n    mat4 inverse4(const in mat4 m) {\n        float\n            a00 = m[0][0], a01 = m[0][1], a02 = m[0][2], a03 = m[0][3],\n            a10 = m[1][0], a11 = m[1][1], a12 = m[1][2], a13 = m[1][3],\n            a20 = m[2][0], a21 = m[2][1], a22 = m[2][2], a23 = m[2][3],\n            a30 = m[3][0], a31 = m[3][1], a32 = m[3][2], a33 = m[3][3],\n\n            b00 = a00 * a11 - a01 * a10,\n            b01 = a00 * a12 - a02 * a10,\n            b02 = a00 * a13 - a03 * a10,\n            b03 = a01 * a12 - a02 * a11,\n            b04 = a01 * a13 - a03 * a11,\n            b05 = a02 * a13 - a03 * a12,\n            b06 = a20 * a31 - a21 * a30,\n            b07 = a20 * a32 - a22 * a30,\n            b08 = a20 * a33 - a23 * a30,\n            b09 = a21 * a32 - a22 * a31,\n            b10 = a21 * a33 - a23 * a31,\n            b11 = a22 * a33 - a23 * a32,\n\n            det = b00 * b11 - b01 * b10 + b02 * b09 + b03 * b08 - b04 * b07 + b05 * b06;\n\n        return mat4(\n            a11 * b11 - a12 * b10 + a13 * b09,\n            a02 * b10 - a01 * b11 - a03 * b09,\n            a31 * b05 - a32 * b04 + a33 * b03,\n            a22 * b04 - a21 * b05 - a23 * b03,\n            a12 * b08 - a10 * b11 - a13 * b07,\n            a00 * b11 - a02 * b08 + a03 * b07,\n            a32 * b02 - a30 * b05 - a33 * b01,\n            a20 * b05 - a22 * b02 + a23 * b01,\n            a10 * b10 - a11 * b08 + a13 * b06,\n            a01 * b08 - a00 * b10 - a03 * b06,\n            a30 * b04 - a31 * b02 + a33 * b00,\n            a21 * b02 - a20 * b04 - a23 * b00,\n            a11 * b07 - a10 * b09 - a12 * b06,\n            a00 * b09 - a01 * b07 + a02 * b06,\n            a31 * b01 - a30 * b03 - a32 * b00,\n            a20 * b03 - a21 * b01 + a22 * b00) / det;\n    }\n#else\n    #define transpose2(m) transpose(m)\n    #define transpose3(m) transpose(m)\n    #define transpose4(m) transpose(m)\n\n    #define inverse2(m) inverse(m)\n    #define inverse3(m) inverse(m)\n    #define inverse4(m) inverse(m)\n#endif\n");
//# sourceMappingURL=common.glsl.js.map

/***/ }),

/***/ "./lib/mol-gl/shader/chunks/float-to-rgba.glsl.js":
/*!********************************************************!*\
  !*** ./lib/mol-gl/shader/chunks/float-to-rgba.glsl.js ***!
  \********************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/**
 * Copyright (c) 2020 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author David Sehnal <david.sehnal@gmail.com>
 */
/* harmony default export */ __webpack_exports__["default"] = ("\n    // floatToRgba adapted from https://github.com/equinor/glsl-float-to-rgba\n    // MIT License, Copyright (c) 2020 Equinor\n\n    float shiftRight (float v, float amt) {\n    v = floor(v) + 0.5;\n    return floor(v / exp2(amt));\n    }\n    float shiftLeft (float v, float amt) {\n        return floor(v * exp2(amt) + 0.5);\n    }\n    float maskLast (float v, float bits) {\n        return mod(v, shiftLeft(1.0, bits));\n    }\n    float extractBits (float num, float from, float to) {\n        from = floor(from + 0.5); to = floor(to + 0.5);\n        return maskLast(shiftRight(num, from), to - from);\n    }\n\n    vec4 floatToRgba(float texelFloat, bool littleEndian) {\n        if (texelFloat == 0.0) return vec4(0.0, 0.0, 0.0, 0.0);\n        float sign = texelFloat > 0.0 ? 0.0 : 1.0;\n        texelFloat = abs(texelFloat);\n        float exponent = floor(log2(texelFloat));\n        float biased_exponent = exponent + 127.0;\n        float fraction = ((texelFloat / exp2(exponent)) - 1.0) * 8388608.0;\n        float t = biased_exponent / 2.0;\n        float last_bit_of_biased_exponent = fract(t) * 2.0;\n        float remaining_bits_of_biased_exponent = floor(t);\n        float byte4 = extractBits(fraction, 0.0, 8.0) / 255.0;\n        float byte3 = extractBits(fraction, 8.0, 16.0) / 255.0;\n        float byte2 = (last_bit_of_biased_exponent * 128.0 + extractBits(fraction, 16.0, 23.0)) / 255.0;\n        float byte1 = (sign * 128.0 + remaining_bits_of_biased_exponent) / 255.0;\n        return (\n            littleEndian\n                ? vec4(byte4, byte3, byte2, byte1)\n                : vec4(byte1, byte2, byte3, byte4)\n        );\n    }\n");
//# sourceMappingURL=float-to-rgba.glsl.js.map

/***/ }),

/***/ "./lib/mol-gl/shader/chunks/light-frag-params.glsl.js":
/*!************************************************************!*\
  !*** ./lib/mol-gl/shader/chunks/light-frag-params.glsl.js ***!
  \************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/**
 * Copyright (c) 2017-2019 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 *
 * adapted from three.js (https://github.com/mrdoob/three.js/)
 * which under the MIT License, Copyright © 2010-2019 three.js authors
 */
/* harmony default export */ __webpack_exports__["default"] = ("\nuniform float uLightIntensity;\nuniform float uAmbientIntensity;\nuniform float uReflectivity;\nuniform float uMetalness;\nuniform float uRoughness;\n\nstruct PhysicalMaterial {\n    vec3 diffuseColor;\n    float specularRoughness;\n    vec3 specularColor;\n};\n\nstruct IncidentLight {\n    vec3 color;\n    vec3 direction;\n};\n\nstruct ReflectedLight {\n    vec3 directDiffuse;\n    vec3 directSpecular;\n    vec3 indirectDiffuse;\n};\n\nstruct GeometricContext {\n    vec3 position;\n    vec3 normal;\n    vec3 viewDir;\n};\n\nvec3 F_Schlick(const in vec3 specularColor, const in float dotLH) {\n    // Original approximation by Christophe Schlick '94\n    // float fresnel = pow( 1.0 - dotLH, 5.0 );\n    // Optimized variant (presented by Epic at SIGGRAPH '13)\n    // https://cdn2.unrealengine.com/Resources/files/2013SiggraphPresentationsNotes-26915738.pdf\n    float fresnel = exp2((-5.55473 * dotLH - 6.98316) * dotLH);\n    return (1.0 - specularColor) * fresnel + specularColor;\n}\n\n// Moving Frostbite to Physically Based Rendering 3.0 - page 12, listing 2\n// https://seblagarde.files.wordpress.com/2015/07/course_notes_moving_frostbite_to_pbr_v32.pdf\nfloat G_GGX_SmithCorrelated(const in float alpha, const in float dotNL, const in float dotNV) {\n    float a2 = pow2(alpha);\n    // dotNL and dotNV are explicitly swapped. This is not a mistake.\n    float gv = dotNL * sqrt(a2 + (1.0 - a2) * pow2(dotNV));\n    float gl = dotNV * sqrt(a2 + (1.0 - a2) * pow2(dotNL));\n    return 0.5 / max(gv + gl, EPSILON);\n}\n\n// Microfacet Models for Refraction through Rough Surfaces - equation (33)\n// http://graphicrants.blogspot.com/2013/08/specular-brdf-reference.html\n// alpha is \"roughness squared\" in Disney\u2019s reparameterization\nfloat D_GGX(const in float alpha, const in float dotNH) {\n    float a2 = pow2(alpha);\n    float denom = pow2(dotNH) * (a2 - 1.0) + 1.0; // avoid alpha = 0 with dotNH = 1\n    return RECIPROCAL_PI * a2 / pow2(denom);\n}\n\nvec3 BRDF_Diffuse_Lambert(const in vec3 diffuseColor) {\n    return RECIPROCAL_PI * diffuseColor;\n}\n\n// GGX Distribution, Schlick Fresnel, GGX-Smith Visibility\nvec3 BRDF_Specular_GGX(const in IncidentLight incidentLight, const in GeometricContext geometry, const in vec3 specularColor, const in float roughness) {\n    float alpha = pow2(roughness); // UE4's roughness\n    vec3 halfDir = normalize(incidentLight.direction + geometry.viewDir);\n\n    float dotNL = saturate(dot(geometry.normal, incidentLight.direction));\n    float dotNV = saturate(dot(geometry.normal, geometry.viewDir));\n    float dotNH = saturate(dot(geometry.normal, halfDir));\n    float dotLH = saturate(dot(incidentLight.direction, halfDir));\n\n    vec3 F = F_Schlick(specularColor, dotLH);\n    float G = G_GGX_SmithCorrelated(alpha, dotNL, dotNV);\n    float D = D_GGX(alpha, dotNH);\n    return F * (G * D);\n}\n\n// ref: https://www.unrealengine.com/blog/physically-based-shading-on-mobile - environmentBRDF for GGX on mobile\nvec3 BRDF_Specular_GGX_Environment(const in GeometricContext geometry, const in vec3 specularColor, const in float roughness) {\n    float dotNV = saturate(dot(geometry.normal, geometry.viewDir));\n    const vec4 c0 = vec4(-1, -0.0275, -0.572, 0.022);\n    const vec4 c1 = vec4(1, 0.0425, 1.04, -0.04);\n    vec4 r = roughness * c0 + c1;\n    float a004 = min(r.x * r.x, exp2(-9.28 * dotNV)) * r.x + r.y;\n    vec2 AB = vec2(-1.04, 1.04) * a004 + r.zw;\n    return specularColor * AB.x + AB.y;\n}\n\nvoid RE_Direct_Physical(const in IncidentLight directLight, const in GeometricContext geometry, const in PhysicalMaterial material, inout ReflectedLight reflectedLight) {\n    float dotNL = saturate(dot(geometry.normal, directLight.direction));\n    vec3 irradiance = dotNL * directLight.color;\n    irradiance *= PI; // punctual light\n\n    reflectedLight.directSpecular += irradiance * BRDF_Specular_GGX(directLight, geometry, material.specularColor, material.specularRoughness);\n    reflectedLight.directDiffuse += irradiance * BRDF_Diffuse_Lambert(material.diffuseColor);\n}\n\nvoid RE_IndirectDiffuse_Physical(const in vec3 irradiance, const in GeometricContext geometry, const in PhysicalMaterial material, inout ReflectedLight reflectedLight) {\n    reflectedLight.indirectDiffuse += irradiance * BRDF_Diffuse_Lambert(material.diffuseColor);\n}\n");
//# sourceMappingURL=light-frag-params.glsl.js.map

/***/ }),

/***/ "./lib/mol-gl/shader/chunks/matrix-scale.glsl.js":
/*!*******************************************************!*\
  !*** ./lib/mol-gl/shader/chunks/matrix-scale.glsl.js ***!
  \*******************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/**
 * Copyright (c) 2019 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */
/* harmony default export */ __webpack_exports__["default"] = ("\nfloat matrixScale(in mat4 m){\n    vec4 r = m[0];\n    return sqrt(r[0] * r[0] + r[1] * r[1] + r[2] * r[2]);\n}\n");
//# sourceMappingURL=matrix-scale.glsl.js.map

/***/ }),

/***/ "./lib/mol-gl/shader/chunks/normal-frag-params.glsl.js":
/*!*************************************************************!*\
  !*** ./lib/mol-gl/shader/chunks/normal-frag-params.glsl.js ***!
  \*************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("\nvarying vec3 vNormal;\n");
//# sourceMappingURL=normal-frag-params.glsl.js.map

/***/ }),

/***/ "./lib/mol-gl/shader/chunks/read-from-texture.glsl.js":
/*!************************************************************!*\
  !*** ./lib/mol-gl/shader/chunks/read-from-texture.glsl.js ***!
  \************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/**
 * Copyright (c) 2018 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */
/* harmony default export */ __webpack_exports__["default"] = ("\nvec4 readFromTexture (const in sampler2D tex, const in float i, const in vec2 dim) {\n    float x = intMod(i, dim.x);\n    float y = floor(intDiv(i, dim.x));\n    vec2 uv = (vec2(x, y) + 0.5) / dim;\n    return texture2D(tex, uv);\n}\n");
//# sourceMappingURL=read-from-texture.glsl.js.map

/***/ }),

/***/ "./lib/mol-gl/shader/chunks/rgba-to-float.glsl.js":
/*!********************************************************!*\
  !*** ./lib/mol-gl/shader/chunks/rgba-to-float.glsl.js ***!
  \********************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/**
 * Copyright (c) 2020 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author David Sehnal <david.sehnal@gmail.com>
 */
/* harmony default export */ __webpack_exports__["default"] = ("\n    // rgbaToFloat adapted from https://github.com/ihmeuw/glsl-rgba-to-float\n    // BSD 3-Clause License\n    //\n    // Copyright (c) 2019, Institute for Health Metrics and Evaluation All rights reserved.\n    // Redistribution and use in source and binary forms, with or without modification, are permitted provided that the following conditions are met:\n    //  - Redistributions of source code must retain the above copyright notice, this list of conditions and the following disclaimer.\n    //  - Redistributions in binary form must reproduce the above copyright notice, this list of conditions and the following disclaimer in the documentation and/or other materials provided with the distribution.\n    //  - Neither the name of the copyright holder nor the names of its contributors may be used to endorse or promote products derived from this software without specific prior written permission.\n    //\n    // THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS \"AS IS\" AND ANY EXPRESS OR IMPLIED WARRANTIES,\n    // INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.\n    // IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY,\n    // OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA,\n    // OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY,\n    // OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED\n    // OF THE POSSIBILITY OF SUCH DAMAGE.\n\n    ivec4 floatsToBytes(vec4 inputFloats, bool littleEndian) {\n        ivec4 bytes = ivec4(inputFloats * 255.0);\n        return (\n            littleEndian\n                ? bytes.abgr\n                : bytes\n        );\n    }\n\n    // Break the four bytes down into an array of 32 bits.\n    void bytesToBits(const in ivec4 bytes, out bool bits[32]) {\n        for (int channelIndex = 0; channelIndex < 4; ++channelIndex) {\n            float acc = float(bytes[channelIndex]);\n            for (int indexInByte = 7; indexInByte >= 0; --indexInByte) {\n                float powerOfTwo = exp2(float(indexInByte));\n                bool bit = acc >= powerOfTwo;\n                bits[channelIndex * 8 + (7 - indexInByte)] = bit;\n                acc = mod(acc, powerOfTwo);\n            }\n        }\n    }\n\n    // Compute the exponent of the 32-bit float.\n    float getExponent(bool bits[32]) {\n        const int startIndex = 1;\n        const int bitStringLength = 8;\n        const int endBeforeIndex = startIndex + bitStringLength;\n        float acc = 0.0;\n        int pow2 = bitStringLength - 1;\n        for (int bitIndex = startIndex; bitIndex < endBeforeIndex; ++bitIndex) {\n            acc += float(bits[bitIndex]) * exp2(float(pow2--));\n        }\n        return acc;\n    }\n\n    // Compute the mantissa of the 32-bit float.\n    float getMantissa(bool bits[32], bool subnormal) {\n        const int startIndex = 9;\n        const int bitStringLength = 23;\n        const int endBeforeIndex = startIndex + bitStringLength;\n        // Leading/implicit/hidden bit convention:\n        // If the number is not subnormal (with exponent 0), we add a leading 1 digit.\n        float acc = float(!subnormal) * exp2(float(bitStringLength));\n        int pow2 = bitStringLength - 1;\n        for (int bitIndex = startIndex; bitIndex < endBeforeIndex; ++bitIndex) {\n            acc += float(bits[bitIndex]) * exp2(float(pow2--));\n        }\n        return acc;\n    }\n\n    // Parse the float from its 32 bits.\n    float bitsToFloat(bool bits[32]) {\n        float signBit = float(bits[0]) * -2.0 + 1.0;\n        float exponent = getExponent(bits);\n        bool subnormal = abs(exponent - 0.0) < 0.01;\n        float mantissa = getMantissa(bits, subnormal);\n        float exponentBias = 127.0;\n        return signBit * mantissa * exp2(exponent - exponentBias - 23.0);\n    }\n\n    float rgbaToFloat(vec4 texelRGBA, bool littleEndian) {\n        ivec4 rgbaBytes = floatsToBytes(texelRGBA, littleEndian);\n        bool bits[32];\n        bytesToBits(rgbaBytes, bits);\n        return bitsToFloat(bits);\n    }\n");
//# sourceMappingURL=rgba-to-float.glsl.js.map

/***/ }),

/***/ "./lib/mol-gl/shader/chunks/size-vert-params.glsl.js":
/*!***********************************************************!*\
  !*** ./lib/mol-gl/shader/chunks/size-vert-params.glsl.js ***!
  \***********************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("\n#if defined(dSizeType_uniform)\n    uniform float uSize;\n#elif defined(dSizeType_attribute)\n    attribute float aSize;\n#elif defined(dSizeType_instance) || defined(dSizeType_group) || defined(dSizeType_groupInstance)\n    uniform vec2 uSizeTexDim;\n    uniform sampler2D tSize;\n#endif\n\nuniform float uSizeFactor;\n");
//# sourceMappingURL=size-vert-params.glsl.js.map

/***/ }),

/***/ "./lib/mol-gl/shader/chunks/texture3d-from-1d-trilinear.glsl.js":
/*!**********************************************************************!*\
  !*** ./lib/mol-gl/shader/chunks/texture3d-from-1d-trilinear.glsl.js ***!
  \**********************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/**
 * Copyright (c) 2020 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */
/* harmony default export */ __webpack_exports__["default"] = ("\nvec4 texture3dFrom1dTrilinear(const in sampler2D tex, const in vec3 pos, const in vec3 gridDim, const in vec2 texDim, const in float offset) {\n    float gdYZ = gridDim.z * gridDim.y;\n    float gdZ = gridDim.z;\n    vec3 p0 = floor(pos * gridDim);\n    vec3 p1 = ceil(pos * gridDim);\n    vec3 pd = (pos * gridDim - p0) / (p1 - p0);\n    vec4 s000 = readFromTexture(tex, offset + p0.z + p0.y * gdZ + p0.x * gdYZ, texDim);\n    vec4 s100 = readFromTexture(tex, offset + p0.z + p0.y * gdZ + p1.x * gdYZ, texDim);\n    vec4 s001 = readFromTexture(tex, offset + p1.z + p0.y * gdZ + p0.x * gdYZ, texDim);\n    vec4 s101 = readFromTexture(tex, offset + p1.z + p0.y * gdZ + p1.x * gdYZ, texDim);\n    vec4 s010 = readFromTexture(tex, offset + p0.z + p1.y * gdZ + p0.x * gdYZ, texDim);\n    vec4 s110 = readFromTexture(tex, offset + p0.z + p1.y * gdZ + p1.x * gdYZ, texDim);\n    vec4 s011 = readFromTexture(tex, offset + p1.z + p1.y * gdZ + p0.x * gdYZ, texDim);\n    vec4 s111 = readFromTexture(tex, offset + p1.z + p1.y * gdZ + p1.x * gdYZ, texDim);\n    vec4 s00 = mix(s000, s100, pd.x);\n    vec4 s01 = mix(s001, s101, pd.x);\n    vec4 s10 = mix(s010, s110, pd.x);\n    vec4 s11 = mix(s011, s111, pd.x);\n    vec4 s0 = mix(s00, s10, pd.y);\n    vec4 s1 = mix(s01, s11, pd.y);\n    return mix(s0, s1, pd.z);\n}\n");
//# sourceMappingURL=texture3d-from-1d-trilinear.glsl.js.map

/***/ }),

/***/ "./lib/mol-gl/shader/chunks/texture3d-from-2d-linear.glsl.js":
/*!*******************************************************************!*\
  !*** ./lib/mol-gl/shader/chunks/texture3d-from-2d-linear.glsl.js ***!
  \*******************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/**
 * Copyright (c) 2017-2018 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 * @author Michael Krone <michael.krone@uni-tuebingen.de>
 */
/* harmony default export */ __webpack_exports__["default"] = ("\nvec4 texture3dFrom2dLinear(sampler2D tex, vec3 pos, vec3 gridDim, vec2 texDim) {\n    float zSlice0 = floor(pos.z * gridDim.z);\n    float column0 = intMod(zSlice0 * gridDim.x, texDim.x) / gridDim.x;\n    float row0 = floor(intDiv(zSlice0 * gridDim.x, texDim.x));\n    vec2 coord0 = (vec2(column0 * gridDim.x, row0 * gridDim.y) + (pos.xy * gridDim.xy)) / texDim;\n    vec4 color0 = texture2D(tex, coord0);\n\n    float zSlice1 = zSlice0 + 1.0;\n    float column1 = intMod(zSlice1 * gridDim.x, texDim.x) / gridDim.x;\n    float row1 = floor(intDiv(zSlice1 * gridDim.x, texDim.x));\n    vec2 coord1 = (vec2(column1 * gridDim.x, row1 * gridDim.y) + (pos.xy * gridDim.xy)) / texDim;\n    vec4 color1 = texture2D(tex, coord1);\n\n    float delta0 = abs((pos.z * gridDim.z) - zSlice0);\n    return mix(color0, color1, delta0);\n}\n");
//# sourceMappingURL=texture3d-from-2d-linear.glsl.js.map

/***/ }),

/***/ "./lib/mol-gl/shader/chunks/texture3d-from-2d-nearest.glsl.js":
/*!********************************************************************!*\
  !*** ./lib/mol-gl/shader/chunks/texture3d-from-2d-nearest.glsl.js ***!
  \********************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/**
 * Copyright (c) 2017-2018 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 * @author Michael Krone <michael.krone@uni-tuebingen.de>
 */
/* harmony default export */ __webpack_exports__["default"] = ("\nvec4 texture3dFrom2dNearest(sampler2D tex, vec3 pos, vec3 gridDim, vec2 texDim) {\n    float zSlice = floor(pos.z * gridDim.z + 0.5); // round to nearest z-slice\n    float column = intMod(zSlice * gridDim.x, texDim.x) / gridDim.x;\n    float row = floor(intDiv(zSlice * gridDim.x, texDim.x));\n    vec2 coord = (vec2(column * gridDim.x, row * gridDim.y) + (pos.xy * gridDim.xy)) / texDim;\n    return texture2D(tex, coord);\n}\n");
//# sourceMappingURL=texture3d-from-2d-nearest.glsl.js.map

/***/ }),

/***/ "./lib/mol-gl/shader/chunks/wboit-params.glsl.js":
/*!*******************************************************!*\
  !*** ./lib/mol-gl/shader/chunks/wboit-params.glsl.js ***!
  \*******************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("\n#if defined(dRenderVariant_colorWboit)\n    #if !defined(dRenderMode_volume) && !defined(dRenderMode_isosurface)\n        uniform sampler2D tDepth;\n        uniform vec2 uDrawingBufferSize;\n\n        float getDepth(const in vec2 coords) {\n            // always packed due to merged depth from primitives and volumes\n            return unpackRGBAToDepth(texture2D(tDepth, coords));\n        }\n    #endif\n#endif\n\nuniform bool uRenderWboit;\n\nfloat calcDepth(const in vec3 pos) {\n    vec2 clipZW = pos.z * uProjection[2].zw + uProjection[3].zw;\n    return 0.5 + 0.5 * clipZW.x / clipZW.y;\n}\n");
//# sourceMappingURL=wboit-params.glsl.js.map

/***/ }),

/***/ "./lib/mol-gl/shader/chunks/wboit-write.glsl.js":
/*!******************************************************!*\
  !*** ./lib/mol-gl/shader/chunks/wboit-write.glsl.js ***!
  \******************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/**
 * Copyright (c) 2019-2020 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 * @author Áron Samuel Kovács <aron.kovacs@mail.muni.cz>
 */
/* harmony default export */ __webpack_exports__["default"] = ("\n#if defined(dRenderVariant_colorWboit)\n    if (!uRenderWboit) {\n        if (preFogAlpha < 1.0) {\n            discard;\n        }\n    } else if (uRenderWboit) {\n        // the 'fragmentDepth > 0.99' check is to handle precision issues with packed depth\n        if (preFogAlpha != 1.0 && !interior && (fragmentDepth < getDepth(gl_FragCoord.xy / uDrawingBufferSize) || fragmentDepth > 0.99)) {\n            float alpha = gl_FragColor.a;\n            float wboitWeight = alpha * clamp(pow(1.0 - fragmentDepth, 2.0), 0.01, 1.0);\n            gl_FragColor = vec4(gl_FragColor.rgb * alpha * wboitWeight, alpha);\n            // extra alpha is to handle pre-multiplied alpha\n            #if !defined(dRenderMode_volume) && !defined(dRenderMode_isosurface)\n                gl_FragData[1] = vec4((uTransparentBackground ? alpha : 1.0) * alpha * wboitWeight);\n            #else\n                gl_FragData[1] = vec4(alpha * alpha * wboitWeight);\n            #endif\n        } else {\n            discard;\n        }\n    }\n#endif\n");
//# sourceMappingURL=wboit-write.glsl.js.map

/***/ }),

/***/ "./lib/mol-gl/shader/compose.frag.js":
/*!*******************************************!*\
  !*** ./lib/mol-gl/shader/compose.frag.js ***!
  \*******************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("\nprecision highp float;\nprecision highp sampler2D;\n\nuniform sampler2D tColor;\nuniform vec2 uTexSize;\nuniform float uWeight;\n\nvoid main() {\n    vec2 coords = gl_FragCoord.xy / uTexSize;\n    gl_FragColor = texture2D(tColor, coords) * uWeight;\n}\n");
//# sourceMappingURL=compose.frag.js.map

/***/ }),

/***/ "./lib/mol-gl/shader/copy.frag.js":
/*!****************************************!*\
  !*** ./lib/mol-gl/shader/copy.frag.js ***!
  \****************************************/
/*! exports provided: copy_frag */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "copy_frag", function() { return copy_frag; });
var copy_frag = "\nprecision highp float;\nprecision highp sampler2D;\n\nuniform sampler2D tColor;\nuniform vec2 uTexSize;\n\nvoid main() {\n    vec2 coords = gl_FragCoord.xy / uTexSize;\n    gl_FragColor = texture2D(tColor, coords);\n}\n";
//# sourceMappingURL=copy.frag.js.map

/***/ }),

/***/ "./lib/mol-gl/shader/cylinders.frag.js":
/*!*********************************************!*\
  !*** ./lib/mol-gl/shader/cylinders.frag.js ***!
  \*********************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/**
 * Copyright (c) 2020 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */
/* harmony default export */ __webpack_exports__["default"] = ("\nprecision highp float;\nprecision highp int;\n\nuniform mat4 uView;\n\nvarying mat4 vTransform;\nvarying vec3 vStart;\nvarying vec3 vEnd;\nvarying float vSize;\nvarying float vCap;\n\nuniform vec3 uCameraDir;\nuniform vec3 uCameraPosition;\n\n#include common\n#include common_frag_params\n#include color_frag_params\n#include light_frag_params\n#include common_clip\n#include wboit_params\n\n// adapted from https://www.shadertoy.com/view/4lcSRn\n// The MIT License, Copyright 2016 Inigo Quilez\nbool CylinderImpostor(\n    in vec3 rayOrigin, in vec3 rayDir,\n    in vec3 start, in vec3 end, in float radius,\n    out vec4 intersection, out bool interior\n){\n    vec3 ba = end - start;\n    vec3 oc = rayOrigin - start;\n\n    float baba = dot(ba, ba);\n    float bard = dot(ba, rayDir);\n    float baoc = dot(ba, oc);\n\n    float k2 = baba - bard*bard;\n    float k1 = baba * dot(oc, rayDir) - baoc * bard;\n    float k0 = baba * dot(oc, oc) - baoc * baoc - radius * radius * baba;\n\n    float h = k1 * k1 - k2 * k0;\n    if (h < 0.0) return false;\n\n    bool topCap = (vCap > 0.9 && vCap < 1.1) || vCap >= 2.9;\n    bool bottomCap = (vCap > 1.9 && vCap < 2.1) || vCap >= 2.9;\n\n    // body outside\n    h = sqrt(h);\n    float t = (-k1 - h) / k2;\n    float y = baoc + t * bard;\n    if (y > 0.0 && y < baba) {\n        interior = false;\n        intersection = vec4(t, (oc + t * rayDir - ba * y / baba) / radius);\n        return true;\n    }\n\n    if (topCap && y < 0.0) {\n        // top cap\n        t = -baoc / bard;\n        if (abs(k1 + k2 * t) < h) {\n            interior = false;\n            intersection = vec4(t, ba * sign(y) / baba);\n            return true;\n        }\n    } else if(bottomCap && y >= 0.0) {\n        // bottom cap\n        t = (baba - baoc) / bard;\n        if (abs(k1 + k2 * t) < h) {\n            interior = false;\n            intersection = vec4(t, ba * sign(y) / baba);\n            return true;\n        }\n    }\n\n    #ifdef dDoubleSided\n        // body inside\n        h = -h;\n        t = (-k1 - h) / k2;\n        y = baoc + t * bard;\n        if (y > 0.0 && y < baba) {\n            interior = true;\n            intersection = vec4(t, (oc + t * rayDir - ba * y / baba) / radius);\n            return true;\n        }\n\n        // TODO: handle inside caps???\n    #endif\n\n    return false;\n}\n\nvoid main() {\n    #include clip_pixel\n\n    vec3 rayDir = mix(normalize(vModelPosition - uCameraPosition), uCameraDir, uIsOrtho);\n\n    vec4 intersection;\n    bool interior;\n    bool hit = CylinderImpostor(vModelPosition, rayDir, vStart, vEnd, vSize, intersection, interior);\n    if (!hit) discard;\n\n    vec3 vViewPosition = vModelPosition + intersection.x * rayDir;\n    vViewPosition = (uView * vec4(vViewPosition, 1.0)).xyz;\n    gl_FragDepthEXT = calcDepth(vViewPosition);\n\n    // bugfix (mac only?)\n    if (gl_FragDepthEXT < 0.0) discard;\n    if (gl_FragDepthEXT > 1.0) discard;\n\n    float fragmentDepth = gl_FragDepthEXT;\n    #include assign_material_color\n\n    #if defined(dRenderVariant_pick)\n        #include check_picking_alpha\n        gl_FragColor = material;\n    #elif defined(dRenderVariant_depth)\n        gl_FragColor = material;\n    #elif defined(dRenderVariant_color)\n        #ifdef dIgnoreLight\n            gl_FragColor = material;\n        #else\n            mat3 normalMatrix = transpose3(inverse3(mat3(uView)));\n            vec3 normal = normalize(normalMatrix * -normalize(intersection.yzw));\n            #include apply_light_color\n        #endif\n\n        #include apply_interior_color\n        #include apply_marker_color\n        #include apply_fog\n        #include wboit_write\n    #endif\n}\n");
//# sourceMappingURL=cylinders.frag.js.map

/***/ }),

/***/ "./lib/mol-gl/shader/cylinders.vert.js":
/*!*********************************************!*\
  !*** ./lib/mol-gl/shader/cylinders.vert.js ***!
  \*********************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/**
 * Copyright (c) 2020 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */
/* harmony default export */ __webpack_exports__["default"] = ("\nprecision highp float;\nprecision highp int;\n\n#include common\n#include read_from_texture\n#include common_vert_params\n#include color_vert_params\n#include size_vert_params\n#include common_clip\n\nuniform mat4 uModelView;\n\nattribute mat4 aTransform;\nattribute float aInstance;\nattribute float aGroup;\n\nattribute vec3 aMapping;\nattribute vec3 aStart;\nattribute vec3 aEnd;\nattribute float aScale;\nattribute float aCap;\n\nvarying mat4 vTransform;\nvarying vec3 vStart;\nvarying vec3 vEnd;\nvarying float vSize;\nvarying float vCap;\n\nuniform float uIsOrtho;\nuniform vec3 uCameraDir;\n\nvoid main() {\n    #include assign_group\n    #include assign_color_varying\n    #include assign_marker_varying\n    #include assign_clipping_varying\n    #include assign_size\n\n    mat4 modelTransform = uModel * aTransform;\n\n    vTransform = aTransform;\n    vStart = (modelTransform * vec4(aStart, 1.0)).xyz;\n    vEnd = (modelTransform * vec4(aEnd, 1.0)).xyz;\n    vSize = size * aScale;\n    vCap = aCap;\n\n    vModelPosition = (vStart + vEnd) * 0.5;\n    vec3 camDir = -mix(normalize(vModelPosition - uCameraPosition), uCameraDir, uIsOrtho);\n    vec3 dir = vEnd - vStart;\n    // ensure cylinder 'dir' is pointing towards the camera\n    if(dot(camDir, dir) < 0.0) dir = -dir;\n\n    vec3 left = cross(camDir, dir);\n    vec3 up = cross(left, dir);\n    left = vSize * normalize(left);\n    up = vSize * normalize(up);\n\n    // move vertex in object-space from center to corner\n    vModelPosition += aMapping.x * dir + aMapping.y * left + aMapping.z * up;\n\n    vec4 mvPosition = uView * vec4(vModelPosition, 1.0);\n    vViewPosition = mvPosition.xyz;\n    gl_Position = uProjection * mvPosition;\n\n    #include clip_instance\n}\n");
//# sourceMappingURL=cylinders.vert.js.map

/***/ }),

/***/ "./lib/mol-gl/shader/depth-merge.frag.js":
/*!***********************************************!*\
  !*** ./lib/mol-gl/shader/depth-merge.frag.js ***!
  \***********************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("\nprecision highp float;\nprecision highp sampler2D;\n\nuniform sampler2D tDepthPrimitives;\nuniform sampler2D tDepthVolumes;\nuniform vec2 uTexSize;\n\n#include common\n\nfloat getDepth(const in vec2 coords, sampler2D tDepth) {\n    #ifdef dPackedDepth\n        return unpackRGBAToDepth(texture2D(tDepth, coords));\n    #else\n        return texture2D(tDepth, coords).r;\n    #endif\n}\n\nvoid main() {\n    vec2 coords = gl_FragCoord.xy / uTexSize;\n    float depth = min(getDepth(coords, tDepthPrimitives), getDepth(coords, tDepthVolumes));\n    gl_FragColor = packDepthToRGBA(depth);\n}\n");
//# sourceMappingURL=depth-merge.frag.js.map

/***/ }),

/***/ "./lib/mol-gl/shader/direct-volume.frag.js":
/*!*************************************************!*\
  !*** ./lib/mol-gl/shader/direct-volume.frag.js ***!
  \*************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/**
 * Copyright (c) 2017-2021 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 * @author Michael Krone <michael.krone@uni-tuebingen.de>
 */
/* harmony default export */ __webpack_exports__["default"] = ("\nprecision highp float;\nprecision highp int;\n\n#include common\n#include light_frag_params\n\n#if dClipObjectCount != 0\n    uniform int uClipObjectType[dClipObjectCount];\n    uniform bool uClipObjectInvert[dClipObjectCount];\n    uniform vec3 uClipObjectPosition[dClipObjectCount];\n    uniform vec4 uClipObjectRotation[dClipObjectCount];\n    uniform vec3 uClipObjectScale[dClipObjectCount];\n#endif\n#include common_clip\n\n#include read_from_texture\n#include texture3d_from_1d_trilinear\n#include texture3d_from_2d_nearest\n#include texture3d_from_2d_linear\n\nuniform mat4 uProjection, uTransform, uModelView, uModel, uView;\nuniform vec3 uCameraDir;\n\nuniform sampler2D tDepth;\nuniform vec2 uDrawingBufferSize;\n\nvarying vec3 vOrigPos;\nvarying float vInstance;\nvarying vec4 vBoundingSphere;\nvarying mat4 vTransform;\n\nuniform mat4 uInvView;\nuniform vec2 uIsoValue;\nuniform vec3 uGridDim;\nuniform vec3 uBboxSize;\nuniform sampler2D tTransferTex;\nuniform float uTransferScale;\nuniform float uStepScale;\nuniform float uJumpLength;\n\nuniform int uObjectId;\nuniform int uVertexCount;\nuniform int uInstanceCount;\nuniform int uGroupCount;\n\nuniform vec3 uHighlightColor;\nuniform vec3 uSelectColor;\nuniform vec2 uMarkerTexDim;\nuniform sampler2D tMarker;\n\nuniform float uFogNear;\nuniform float uFogFar;\nuniform vec3 uFogColor;\n\nuniform float uAlpha;\nuniform float uPickingAlphaThreshold;\nuniform bool uTransparentBackground;\n\nuniform float uInteriorDarkening;\nuniform bool uInteriorColorFlag;\nuniform vec3 uInteriorColor;\nbool interior;\n\nuniform float uNear;\nuniform float uFar;\nuniform float uIsOrtho;\n\nuniform vec3 uCellDim;\nuniform vec3 uCameraPosition;\nuniform mat4 uCartnToUnit;\n\n#if __VERSION__ != 100\n    // for webgl1 this is given as a 'define'\n    uniform int uMaxSteps;\n#endif\n\n#if defined(dGridTexType_2d)\n    precision highp sampler2D;\n    uniform sampler2D tGridTex;\n    uniform vec3 uGridTexDim;\n#elif defined(dGridTexType_3d)\n    precision highp sampler3D;\n    uniform sampler3D tGridTex;\n#endif\n\n#if defined(dRenderVariant_color)\n    #if defined(dColorType_uniform)\n        uniform vec3 uColor;\n    #elif defined(dColorType_texture)\n        uniform vec2 uColorTexDim;\n        uniform sampler2D tColor;\n    #endif\n\n    #ifdef dOverpaint\n        varying vec4 vOverpaint;\n        uniform vec2 uOverpaintTexDim;\n        uniform sampler2D tOverpaint;\n    #endif\n#endif\n\n#if defined(dGridTexType_2d)\n    vec4 textureVal(vec3 pos) {\n        return texture3dFrom2dLinear(tGridTex, pos + (vec3(0.5, 0.5, 0.0) / uGridDim), uGridDim, uGridTexDim.xy);\n    }\n    vec4 textureGroup(vec3 pos) {\n        return texture3dFrom2dNearest(tGridTex, pos + (vec3(0.5, 0.5, 0.0) / uGridDim), uGridDim, uGridTexDim.xy);\n    }\n#elif defined(dGridTexType_3d)\n    vec4 textureVal(vec3 pos) {\n        return texture(tGridTex, pos + (vec3(0.5) / uGridDim));\n    }\n    vec4 textureGroup(vec3 pos) {\n        return texelFetch(tGridTex, ivec3(pos * uGridDim), 0);\n    }\n#endif\n\n#include wboit_params\n\nvec4 transferFunction(float value) {\n    return texture2D(tTransferTex, vec2(value, 0.0));\n}\n\nfloat getDepth(const in vec2 coords) {\n    #ifdef depthTextureSupport\n        if (!uRenderWboit) {\n            // in case of opaque volumes (and depth texture support)\n            return texture2D(tDepth, coords).r;\n        } else {\n            return unpackRGBAToDepth(texture2D(tDepth, coords));\n        }\n    #else\n        return unpackRGBAToDepth(texture2D(tDepth, coords));\n    #endif\n}\n\nconst float gradOffset = 0.5;\n\nvec3 v3m4(vec3 p, mat4 m) {\n    return (m * vec4(p, 1.0)).xyz;\n}\n\nfloat preFogAlphaBlended = 0.0;\n\nvec4 raymarch(vec3 startLoc, vec3 step, vec3 rayDir) {\n    #if defined(dRenderVariant_color) && !defined(dIgnoreLight)\n        mat3 normalMatrix = transpose3(inverse3(mat3(uModelView * vTransform)));\n    #endif\n    mat4 cartnToUnit = uCartnToUnit * inverse4(vTransform);\n    #if defined(dClipVariant_pixel) && dClipObjectCount != 0\n        mat4 modelTransform = uModel * vTransform * uTransform;\n    #endif\n    mat4 modelViewTransform = uModelView * vTransform * uTransform;\n\n    vec3 scaleVol = vec3(1.0) / uGridDim;\n    vec3 pos = startLoc;\n    vec4 cell;\n    float prevValue = -1.0;\n    float value = 0.0;\n    vec4 src = vec4(0.0);\n    vec4 dst = vec4(0.0);\n    bool hit = false;\n    float fragmentDepth;\n\n    vec3 posMin = vec3(0.0);\n    vec3 posMax = vec3(1.0) - vec3(1.0) / uGridDim;\n\n    vec3 unitPos;\n    vec3 isoPos;\n\n    vec3 nextPos;\n    float nextValue;\n\n    vec3 color = vec3(0.45, 0.55, 0.8);\n    vec3 gradient = vec3(1.0);\n    vec3 dx = vec3(gradOffset * scaleVol.x, 0.0, 0.0);\n    vec3 dy = vec3(0.0, gradOffset * scaleVol.y, 0.0);\n    vec3 dz = vec3(0.0, 0.0, gradOffset * scaleVol.z);\n\n    float maxDist = min(vBoundingSphere.w * 2.0, uFar - uNear);\n    float maxDistSq = maxDist * maxDist;\n\n    for (int i = 0; i < uMaxSteps; ++i) {\n        // break when beyond bounding-sphere or far-plane\n        vec3 distVec = startLoc - pos;\n        if (dot(distVec, distVec) > maxDistSq) break;\n\n        unitPos = v3m4(pos, cartnToUnit);\n\n        // continue when outside of grid\n        if (unitPos.x > posMax.x || unitPos.y > posMax.y || unitPos.z > posMax.z ||\n            unitPos.x < posMin.x || unitPos.y < posMin.y || unitPos.z < posMin.z\n        ) {\n            if (hit) break;\n            prevValue = value;\n            pos += step;\n            continue;\n        }\n\n        cell = textureVal(unitPos);\n        value = cell.a; // current voxel value\n\n        if (uJumpLength > 0.0 && value < 0.01) {\n            nextPos = pos + rayDir * uJumpLength;\n            nextValue = textureVal(v3m4(nextPos, cartnToUnit)).a;\n            if (nextValue < 0.01) {\n                prevValue = nextValue;\n                pos = nextPos;\n                continue;\n            }\n        }\n\n        #if defined(dRenderMode_isosurface)\n            if (prevValue > 0.0 && ( // there was a prev Value\n                (prevValue < uIsoValue.x && value > uIsoValue.x) || // entering isosurface\n                (prevValue > uIsoValue.x && value < uIsoValue.x) // leaving isosurface\n            )) {\n                isoPos = v3m4(mix(pos - step, pos, ((prevValue - uIsoValue.x) / ((prevValue - uIsoValue.x) - (value - uIsoValue.x)))), cartnToUnit);\n\n                vec4 mvPosition = modelViewTransform * vec4(isoPos * uGridDim, 1.0);\n\n                #if defined(dClipVariant_pixel) && dClipObjectCount != 0\n                    vec3 vModelPosition = v3m4(isoPos * uGridDim, modelTransform);\n                    if (clipTest(vec4(vModelPosition, 0.0), 0)) {\n                        prevValue = value;\n                        pos += step;\n                        continue;\n                    }\n                #endif\n\n                float depth = calcDepth(mvPosition.xyz);\n                if (depth > getDepth(gl_FragCoord.xy / uDrawingBufferSize))\n                    break;\n\n                #ifdef enabledFragDepth\n                    if (!hit) {\n                        gl_FragDepthEXT = depth;\n                    }\n                #endif\n\n                #if defined(dRenderVariant_pickObject)\n                    return vec4(encodeFloatRGB(float(uObjectId)), 1.0);\n                #elif defined(dRenderVariant_pickInstance)\n                    return vec4(encodeFloatRGB(vInstance), 1.0);\n                #elif defined(dRenderVariant_pickGroup)\n                    #ifdef dPackedGroup\n                        return vec4(textureGroup(floor(isoPos * uGridDim + 0.5) / uGridDim).rgb, 1.0);\n                    #else\n                        vec3 g = floor(isoPos * uGridDim + 0.5);\n                        return vec4(encodeFloatRGB(g.z + g.y * uGridDim.z + g.x * uGridDim.z * uGridDim.y), 1.0);\n                    #endif\n                #elif defined(dRenderVariant_depth)\n                    #ifdef enabledFragDepth\n                        return packDepthToRGBA(gl_FragDepthEXT);\n                    #else\n                        return packDepthToRGBA(depth);\n                    #endif\n                #elif defined(dRenderVariant_color)\n                    #ifdef dPackedGroup\n                        float group = decodeFloatRGB(textureGroup(floor(isoPos * uGridDim + 0.5) / uGridDim).rgb);\n                    #else\n                        vec3 g = floor(isoPos * uGridDim + 0.5);\n                        float group = g.z + g.y * uGridDim.z + g.x * uGridDim.z * uGridDim.y;\n                    #endif\n\n                    #if defined(dColorType_uniform)\n                        color = uColor;\n                    #elif defined(dColorType_instance)\n                        color = readFromTexture(tColor, vInstance, uColorTexDim).rgb;\n                    #elif defined(dColorType_group)\n                        color = readFromTexture(tColor, group, uColorTexDim).rgb;\n                    #elif defined(dColorType_groupInstance)\n                        color = readFromTexture(tColor, vInstance * float(uGroupCount) + group, uColorTexDim).rgb;\n                    #elif defined(dColorType_vertex)\n                        color = texture3dFrom1dTrilinear(tColor, isoPos, uGridDim, uColorTexDim, 0.0).rgb;\n                    #elif defined(dColorType_vertexInstance)\n                        color = texture3dFrom1dTrilinear(tColor, isoPos, uGridDim, uColorTexDim, vInstance * float(uVertexCount)).rgb;\n                    #endif\n\n                    // handle flipping and negative isosurfaces\n                    #ifdef dFlipSided\n                        bool flipped = value < uIsoValue.y; // flipped\n                    #else\n                        bool flipped = value > uIsoValue.y;\n                    #endif\n                    interior = value < uIsoValue.x && flipped;\n                    #ifndef dDoubleSided\n                        if (interior) {\n                            prevValue = value;\n                            pos += step;\n                            continue;\n                        }\n                    #endif\n                    vec3 vViewPosition = mvPosition.xyz;\n                    vec4 material = vec4(color, uAlpha);\n\n                    #ifdef dIgnoreLight\n                        gl_FragColor = material;\n                    #else\n                        #if defined(dFlatShaded)\n                            // nearest grid point\n                            isoPos = floor(isoPos * uGridDim + 0.5) / uGridDim;\n                        #endif\n                        #ifdef dPackedGroup\n                            // compute gradient by central differences\n                            gradient.x = textureVal(isoPos - dx).a - textureVal(isoPos + dx).a;\n                            gradient.y = textureVal(isoPos - dy).a - textureVal(isoPos + dy).a;\n                            gradient.z = textureVal(isoPos - dz).a - textureVal(isoPos + dz).a;\n                        #else\n                            gradient = textureVal(isoPos).xyz * 2.0 - 1.0;\n                        #endif\n                        vec3 normal = -normalize(normalMatrix * normalize(gradient));\n                        normal = normal * (float(flipped) * 2.0 - 1.0);\n                        normal = normal * -(float(interior) * 2.0 - 1.0);\n                        #include apply_light_color\n                    #endif\n\n                    float vMarker = readFromTexture(tMarker, vInstance * float(uGroupCount) + group, uMarkerTexDim).a;\n                    #include apply_interior_color\n                    #include apply_marker_color\n\n                    preFogAlphaBlended = (1.0 - preFogAlphaBlended) * gl_FragColor.a + preFogAlphaBlended;\n                    fragmentDepth = depth;\n                    #include apply_fog\n\n                    src = gl_FragColor;\n\n                    if (!uTransparentBackground) {\n                        // done in 'apply_fog' otherwise\n                        src.rgb *= src.a;\n                    }\n                    dst = (1.0 - dst.a) * src + dst; // standard blending\n                #endif\n\n                #ifdef dSingleLayer\n                    break;\n                #endif\n\n                hit = true;\n            }\n            prevValue = value;\n        #elif defined(dRenderMode_volume)\n            vec4 mvPosition = modelViewTransform * vec4(unitPos * uGridDim, 1.0);\n            if (calcDepth(mvPosition.xyz) > getDepth(gl_FragCoord.xy / uDrawingBufferSize))\n                break;\n\n            #if defined(dClipVariant_pixel) && dClipObjectCount != 0\n                vec3 vModelPosition = v3m4(unitPos * uGridDim, modelTransform);\n                if (clipTest(vec4(vModelPosition, 0.0), 0)) {\n                    prevValue = value;\n                    pos += step;\n                    continue;\n                }\n            #endif\n\n            #if defined(dRenderVariant_color)\n                vec3 vViewPosition = mvPosition.xyz;\n                vec4 material = transferFunction(value);\n\n                #ifdef dIgnoreLight\n                    gl_FragColor.rgb = material.rgb;\n                #else\n                    if (material.a >= 0.01) {\n                        #ifdef dPackedGroup\n                            // compute gradient by central differences\n                            gradient.x = textureVal(unitPos - dx).a - textureVal(unitPos + dx).a;\n                            gradient.y = textureVal(unitPos - dy).a - textureVal(unitPos + dy).a;\n                            gradient.z = textureVal(unitPos - dz).a - textureVal(unitPos + dz).a;\n                        #else\n                            gradient = cell.xyz * 2.0 - 1.0;\n                        #endif\n                        vec3 normal = -normalize(normalMatrix * normalize(gradient));\n                        #include apply_light_color\n                    } else {\n                        gl_FragColor.rgb = material.rgb;\n                    }\n                #endif\n\n                gl_FragColor.a = material.a * uAlpha * uTransferScale;\n\n                #ifdef dPackedGroup\n                    float group = decodeFloatRGB(textureGroup(floor(unitPos * uGridDim + 0.5) / uGridDim).rgb);\n                #else\n                    vec3 g = floor(unitPos * uGridDim + 0.5);\n                    float group = g.z + g.y * uGridDim.z + g.x * uGridDim.z * uGridDim.y;\n                #endif\n\n                float vMarker = readFromTexture(tMarker, vInstance * float(uGroupCount) + group, uMarkerTexDim).a;\n                #include apply_marker_color\n\n                preFogAlphaBlended = (1.0 - preFogAlphaBlended) * gl_FragColor.a + preFogAlphaBlended;\n                fragmentDepth = calcDepth(mvPosition.xyz);\n                #include apply_fog\n\n                src = gl_FragColor;\n\n                if (!uTransparentBackground) {\n                    // done in 'apply_fog' otherwise\n                    src.rgb *= src.a;\n                }\n                dst = (1.0 - dst.a) * src + dst; // standard blending\n            #endif\n        #endif\n\n        // break if the color is opaque enough\n        if (dst.a > 0.95)\n            break;\n\n        pos += step;\n    }\n\n    #if defined(dRenderMode_isosurface) && defined(enabledFragDepth)\n        // ensure depth is written everywhere\n        if (!hit)\n            gl_FragDepthEXT = 1.0;\n    #endif\n\n    return dst;\n}\n\n// TODO: support float texture for higher precision values???\n// TODO: support clipping exclusion texture support\n\nvoid main() {\n    if (gl_FrontFacing)\n        discard;\n\n    #if defined(dRenderVariant_pick) || defined(dRenderVariant_depth)\n        #if defined(dRenderMode_volume)\n            // always ignore pick & depth for volume\n            discard;\n        #elif defined(dRenderMode_isosurface)\n            if (uAlpha < uPickingAlphaThreshold)\n                discard; // ignore so the element below can be picked\n        #endif\n    #endif\n\n    vec3 rayDir = mix(normalize(vOrigPos - uCameraPosition), uCameraDir, uIsOrtho);\n    vec3 step = rayDir * uStepScale;\n\n    float boundingSphereNear = distance(vBoundingSphere.xyz, uCameraPosition) - vBoundingSphere.w;\n    float d = max(uNear, boundingSphereNear) - mix(0.0, distance(vOrigPos, uCameraPosition), uIsOrtho);\n    vec3 start = mix(uCameraPosition, vOrigPos, uIsOrtho) + (d * rayDir);\n    gl_FragColor = raymarch(start, step, rayDir);\n\n    #if defined(dRenderVariant_pick) || defined(dRenderVariant_depth)\n        // discard when nothing was hit\n        if (gl_FragColor == vec4(0.0))\n            discard;\n    #endif\n\n    #if defined(dRenderVariant_color)\n        #if defined(dRenderMode_isosurface) && defined(enabledFragDepth)\n            float fragmentDepth = gl_FragDepthEXT;\n        #else\n            float fragmentDepth = calcDepth((uModelView * vec4(start, 1.0)).xyz);\n        #endif\n        float preFogAlpha = clamp(preFogAlphaBlended, 0.0, 1.0);\n        interior = false;\n        #include wboit_write\n    #endif\n}\n");
//# sourceMappingURL=direct-volume.frag.js.map

/***/ }),

/***/ "./lib/mol-gl/shader/direct-volume.vert.js":
/*!*************************************************!*\
  !*** ./lib/mol-gl/shader/direct-volume.vert.js ***!
  \*************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/**
 * Copyright (c) 2017-2021 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 * @author Michael Krone <michael.krone@uni-tuebingen.de>
 */
/* harmony default export */ __webpack_exports__["default"] = ("\nprecision highp float;\n\nattribute vec3 aPosition;\nattribute mat4 aTransform;\nattribute float aInstance;\n\nuniform mat4 uModelView;\nuniform mat4 uProjection;\nuniform vec4 uInvariantBoundingSphere;\n\nvarying vec3 vOrigPos;\nvarying float vInstance;\nvarying vec4 vBoundingSphere;\nvarying mat4 vTransform;\n\nuniform vec3 uBboxSize;\nuniform vec3 uBboxMin;\nuniform vec3 uBboxMax;\nuniform vec3 uGridDim;\nuniform mat4 uTransform;\n\nuniform mat4 uUnitToCartn;\n\nvoid main() {\n    vec4 unitCoord = vec4(aPosition + vec3(0.5), 1.0);\n    vec4 mvPosition = uModelView * aTransform * uUnitToCartn * unitCoord;\n\n    vOrigPos = (aTransform * uUnitToCartn * unitCoord).xyz;\n    vInstance = aInstance;\n    vBoundingSphere = vec4(\n        (aTransform * vec4(uInvariantBoundingSphere.xyz, 1.0)).xyz,\n        uInvariantBoundingSphere.w\n    );\n    vTransform = aTransform;\n\n    gl_Position = uProjection * mvPosition;\n\n    // move z position to near clip plane (but not too close to get precision issues)\n    gl_Position.z = gl_Position.w - 0.01;\n}\n");
//# sourceMappingURL=direct-volume.vert.js.map

/***/ }),

/***/ "./lib/mol-gl/shader/evaluate-wboit.frag.js":
/*!**************************************************!*\
  !*** ./lib/mol-gl/shader/evaluate-wboit.frag.js ***!
  \**************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("\nprecision highp float;\n\nuniform sampler2D tWboitA;\nuniform sampler2D tWboitB;\nuniform vec2 uTexSize;\n\nvoid main() {\n    vec2 coords = gl_FragCoord.xy / uTexSize;\n\n    vec4 accum = texture2D(tWboitA, coords);\n    float r = 1.0 - accum.a;\n\n    accum.a = texture2D(tWboitB, coords).r;\n    // divisor needs to allow very small values for nice fading\n    gl_FragColor = vec4(accum.rgb / clamp(accum.a, 0.00000001, 50000.0), r);\n}\n");
//# sourceMappingURL=evaluate-wboit.frag.js.map

/***/ }),

/***/ "./lib/mol-gl/shader/fxaa.frag.js":
/*!****************************************!*\
  !*** ./lib/mol-gl/shader/fxaa.frag.js ***!
  \****************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("\nprecision highp float;\nprecision highp int;\nprecision highp sampler2D;\n\nuniform sampler2D tColor;\nuniform vec2 uTexSizeInv;\n\n// adapted from https://github.com/kosua20/Rendu\n// MIT License Copyright (c) 2017 Simon Rodriguez\n\n#define QUALITY(q) ((q) < 5 ? 1.0 : ((q) > 5 ? ((q) < 10 ? 2.0 : ((q) < 11 ? 4.0 : 8.0)) : 1.5))\n\nfloat rgb2luma(vec3 rgb){\n    return sqrt(dot(rgb, vec3(0.299, 0.587, 0.114)));\n}\n\nfloat sampleLuma(vec2 uv) {\n    return rgb2luma(texture2D(tColor, uv).rgb);\n}\n\nfloat sampleLuma(vec2 uv, float uOffset, float vOffset) {\n    uv += uTexSizeInv * vec2(uOffset, vOffset);\n    return sampleLuma(uv);\n}\n\nvoid main(void) {\n    vec2 coords = gl_FragCoord.xy * uTexSizeInv;\n    vec2 inverseScreenSize = uTexSizeInv;\n\n    vec4 colorCenter = texture2D(tColor, coords);\n\n    // Luma at the current fragment\n    float lumaCenter = rgb2luma(colorCenter.rgb);\n\n    // Luma at the four direct neighbours of the current fragment.\n    float lumaDown = sampleLuma(coords, 0.0, -1.0);\n    float lumaUp = sampleLuma(coords, 0.0, 1.0);\n    float lumaLeft = sampleLuma(coords, -1.0, 0.0);\n    float lumaRight = sampleLuma(coords, 1.0, 0.0);\n\n    // Find the maximum and minimum luma around the current fragment.\n    float lumaMin = min(lumaCenter, min(min(lumaDown, lumaUp), min(lumaLeft, lumaRight)));\n    float lumaMax = max(lumaCenter, max(max(lumaDown, lumaUp), max(lumaLeft, lumaRight)));\n\n    // Compute the delta.\n    float lumaRange = lumaMax - lumaMin;\n\n    // If the luma variation is lower that a threshold (or if we are in a really dark area),\n    // we are not on an edge, don't perform any AA.\n    if (lumaRange < max(dEdgeThresholdMin, lumaMax * dEdgeThresholdMax)) {\n        gl_FragColor = colorCenter;\n        return;\n    }\n\n    // Query the 4 remaining corners lumas.\n    float lumaDownLeft = sampleLuma(coords, -1.0, -1.0);\n    float lumaUpRight = sampleLuma(coords, 1.0, 1.0);\n    float lumaUpLeft = sampleLuma(coords, -1.0, 1.0);\n    float lumaDownRight = sampleLuma(coords, 1.0, -1.0);\n\n    // Combine the four edges lumas (using intermediary variables for future computations\n    // with the same values).\n    float lumaDownUp = lumaDown + lumaUp;\n    float lumaLeftRight = lumaLeft + lumaRight;\n\n    // Same for corners\n    float lumaLeftCorners = lumaDownLeft + lumaUpLeft;\n    float lumaDownCorners = lumaDownLeft + lumaDownRight;\n    float lumaRightCorners = lumaDownRight + lumaUpRight;\n    float lumaUpCorners = lumaUpRight + lumaUpLeft;\n\n    // Compute an estimation of the gradient along the horizontal and vertical axis.\n    float edgeHorizontal = abs(-2.0 * lumaLeft + lumaLeftCorners) + abs(-2.0 * lumaCenter + lumaDownUp) * 2.0 + abs(-2.0 * lumaRight + lumaRightCorners);\n    float edgeVertical = abs(-2.0 * lumaUp + lumaUpCorners) + abs(-2.0 * lumaCenter + lumaLeftRight) * 2.0 + abs(-2.0 * lumaDown + lumaDownCorners);\n\n    // Is the local edge horizontal or vertical ?\n    bool isHorizontal = (edgeHorizontal >= edgeVertical);\n\n    // Choose the step size (one pixel) accordingly.\n    float stepLength = isHorizontal ? inverseScreenSize.y : inverseScreenSize.x;\n\n    // Select the two neighboring texels lumas in the opposite direction to the local edge.\n    float luma1 = isHorizontal ? lumaDown : lumaLeft;\n    float luma2 = isHorizontal ? lumaUp : lumaRight;\n    // Compute gradients in this direction.\n    float gradient1 = luma1 - lumaCenter;\n    float gradient2 = luma2 - lumaCenter;\n\n    // Which direction is the steepest ?\n    bool is1Steepest = abs(gradient1) >= abs(gradient2);\n\n    // Gradient in the corresponding direction, normalized.\n    float gradientScaled = 0.25 * max(abs(gradient1), abs(gradient2));\n\n    // Average luma in the correct direction.\n    float lumaLocalAverage = 0.0;\n    if(is1Steepest){\n        // Switch the direction\n        stepLength = -stepLength;\n        lumaLocalAverage = 0.5 * (luma1 + lumaCenter);\n    } else {\n        lumaLocalAverage = 0.5 * (luma2 + lumaCenter);\n    }\n\n    // Shift UV in the correct direction by half a pixel.\n    vec2 currentUv = coords;\n    if(isHorizontal){\n        currentUv.y += stepLength * 0.5;\n    } else {\n        currentUv.x += stepLength * 0.5;\n    }\n\n    // Compute offset (for each iteration step) in the right direction.\n    vec2 offset = isHorizontal ? vec2(inverseScreenSize.x, 0.0) : vec2(0.0, inverseScreenSize.y);\n    // Compute UVs to explore on each side of the edge, orthogonally.\n    // The QUALITY allows us to step faster.\n    vec2 uv1 = currentUv - offset * QUALITY(0);\n    vec2 uv2 = currentUv + offset * QUALITY(0);\n\n    // Read the lumas at both current extremities of the exploration segment,\n    // and compute the delta wrt to the local average luma.\n    float lumaEnd1 = sampleLuma(uv1);\n    float lumaEnd2 = sampleLuma(uv2);\n    lumaEnd1 -= lumaLocalAverage;\n    lumaEnd2 -= lumaLocalAverage;\n\n    // If the luma deltas at the current extremities is larger than the local gradient,\n    // we have reached the side of the edge.\n    bool reached1 = abs(lumaEnd1) >= gradientScaled;\n    bool reached2 = abs(lumaEnd2) >= gradientScaled;\n    bool reachedBoth = reached1 && reached2;\n\n    // If the side is not reached, we continue to explore in this direction.\n    if(!reached1){\n        uv1 -= offset * QUALITY(1);\n    }\n    if(!reached2){\n        uv2 += offset * QUALITY(1);\n    }\n\n    // If both sides have not been reached, continue to explore.\n    if(!reachedBoth){\n        for(int i = 2; i < dIterations; i++){\n            // If needed, read luma in 1st direction, compute delta.\n            if(!reached1){\n                lumaEnd1 = sampleLuma(uv1);\n                lumaEnd1 = lumaEnd1 - lumaLocalAverage;\n            }\n            // If needed, read luma in opposite direction, compute delta.\n            if(!reached2){\n                lumaEnd2 = sampleLuma(uv2);\n                lumaEnd2 = lumaEnd2 - lumaLocalAverage;\n            }\n            // If the luma deltas at the current extremities is larger than the local gradient,\n            // we have reached the side of the edge.\n            reached1 = abs(lumaEnd1) >= gradientScaled;\n            reached2 = abs(lumaEnd2) >= gradientScaled;\n            reachedBoth = reached1 && reached2;\n\n            // If the side is not reached, we continue to explore in this direction,\n            // with a variable quality.\n            if(!reached1){\n                uv1 -= offset * QUALITY(i);\n            }\n            if(!reached2){\n                uv2 += offset * QUALITY(i);\n            }\n\n            // If both sides have been reached, stop the exploration.\n            if(reachedBoth){\n                break;\n            }\n        }\n    }\n\n    // Compute the distances to each side edge of the edge (!).\n    float distance1 = isHorizontal ? (coords.x - uv1.x) : (coords.y - uv1.y);\n    float distance2 = isHorizontal ? (uv2.x - coords.x) : (uv2.y - coords.y);\n\n    // In which direction is the side of the edge closer ?\n    bool isDirection1 = distance1 < distance2;\n    float distanceFinal = min(distance1, distance2);\n\n    // Thickness of the edge.\n    float edgeThickness = (distance1 + distance2);\n\n    // Is the luma at center smaller than the local average ?\n    bool isLumaCenterSmaller = lumaCenter < lumaLocalAverage;\n\n    // If the luma at center is smaller than at its neighbour,\n    // the delta luma at each end should be positive (same variation).\n    bool correctVariation1 = (lumaEnd1 < 0.0) != isLumaCenterSmaller;\n    bool correctVariation2 = (lumaEnd2 < 0.0) != isLumaCenterSmaller;\n\n    // Only keep the result in the direction of the closer side of the edge.\n    bool correctVariation = isDirection1 ? correctVariation1 : correctVariation2;\n\n    // UV offset: read in the direction of the closest side of the edge.\n    float pixelOffset = - distanceFinal / edgeThickness + 0.5;\n\n    // If the luma variation is incorrect, do not offset.\n    float finalOffset = correctVariation ? pixelOffset : 0.0;\n\n    // Sub-pixel shifting\n    // Full weighted average of the luma over the 3x3 neighborhood.\n    float lumaAverage = (1.0 / 12.0) * (2.0 * (lumaDownUp + lumaLeftRight) + lumaLeftCorners + lumaRightCorners);\n    // Ratio of the delta between the global average and the center luma,\n    // over the luma range in the 3x3 neighborhood.\n    float subPixelOffset1 = clamp(abs(lumaAverage - lumaCenter) / lumaRange, 0.0, 1.0);\n    float subPixelOffset2 = (-2.0 * subPixelOffset1 + 3.0) * subPixelOffset1 * subPixelOffset1;\n    // Compute a sub-pixel offset based on this delta.\n    float subPixelOffsetFinal = subPixelOffset2 * subPixelOffset2 * float(dSubpixelQuality);\n\n    // Pick the biggest of the two offsets.\n    finalOffset = max(finalOffset, subPixelOffsetFinal);\n\n    // Compute the final UV coordinates.\n    vec2 finalUv = coords;\n    if(isHorizontal){\n        finalUv.y += finalOffset * stepLength;\n    } else {\n        finalUv.x += finalOffset * stepLength;\n    }\n\n    // Read the color at the new UV coordinates, and use it.\n    gl_FragColor = texture2D(tColor, finalUv);\n}\n");
//# sourceMappingURL=fxaa.frag.js.map

/***/ }),

/***/ "./lib/mol-gl/shader/gaussian-density.frag.js":
/*!****************************************************!*\
  !*** ./lib/mol-gl/shader/gaussian-density.frag.js ***!
  \****************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/**
 * Copyright (c) 2018-2021 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 * @author Michael Krone <michael.krone@uni-tuebingen.de>
 */
/* harmony default export */ __webpack_exports__["default"] = ("\nprecision highp float;\n\nvarying vec3 vPosition;\nvarying float vRadiusSqInv;\n#if defined(dCalcType_groupId)\n    #if defined(dGridTexType_2d)\n        precision highp sampler2D;\n        uniform sampler2D tMinDistanceTex;\n        uniform vec3 uGridTexDim;\n    #elif defined(dGridTexType_3d)\n        precision highp sampler3D;\n        uniform sampler3D tMinDistanceTex;\n    #endif\n    varying float vGroup;\n#endif\n\n#include common\n\nuniform vec3 uGridDim;\nuniform vec2 uGridTexScale;\nuniform float uCurrentSlice;\nuniform float uCurrentX;\nuniform float uCurrentY;\nuniform float uAlpha;\nuniform float uResolution;\nuniform float uRadiusFactorInv;\n\nvoid main() {\n    vec2 v = gl_FragCoord.xy - vec2(uCurrentX, uCurrentY) - 0.5;\n    vec3 fragPos = vec3(v.x, v.y, uCurrentSlice);\n    float dist = distance(fragPos, vPosition) * uResolution;\n\n    #if defined(dCalcType_density)\n        float density = exp(-uAlpha * ((dist * dist) * vRadiusSqInv));\n        gl_FragColor.a = density * uRadiusFactorInv;\n    #elif defined(dCalcType_minDistance)\n        gl_FragColor.a = 1.0 - dist * uRadiusFactorInv;\n    #elif defined(dCalcType_groupId)\n        #if defined(dGridTexType_2d)\n            float minDistance = 1.0 - texture2D(tMinDistanceTex, (gl_FragCoord.xy) / (uGridTexDim.xy / uGridTexScale)).a;\n        #elif defined(dGridTexType_3d)\n            float minDistance = 1.0 - texelFetch(tMinDistanceTex, ivec3(gl_FragCoord.xy, uCurrentSlice), 0).a;\n        #endif\n        if (dist * uRadiusFactorInv > minDistance + uResolution * 0.05)\n            discard;\n        gl_FragColor.rgb = encodeFloatRGB(vGroup);\n    #endif\n}\n");
//# sourceMappingURL=gaussian-density.frag.js.map

/***/ }),

/***/ "./lib/mol-gl/shader/gaussian-density.vert.js":
/*!****************************************************!*\
  !*** ./lib/mol-gl/shader/gaussian-density.vert.js ***!
  \****************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/**
 * Copyright (c) 2018-2021 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 * @author Michael Krone <michael.krone@uni-tuebingen.de>
 */
/* harmony default export */ __webpack_exports__["default"] = ("\nprecision highp float;\n\nattribute vec3 aPosition;\nattribute float aRadius;\n\nvarying vec3 vPosition;\nvarying float vRadiusSqInv;\n\n#if defined(dCalcType_groupId)\n    attribute float aGroup;\n    varying float vGroup;\n#endif\n\nuniform vec3 uBboxSize;\nuniform vec3 uBboxMin;\nuniform float uResolution;\n\nvoid main() {\n    vRadiusSqInv = 1.0 / (aRadius * aRadius);\n    #if defined(dCalcType_groupId)\n        vGroup = aGroup;\n    #endif\n    gl_PointSize = ceil(((aRadius * 3.0) / uResolution) + uResolution);\n    vPosition = (aPosition - uBboxMin) / uResolution;\n    gl_Position = vec4(((aPosition - uBboxMin) / uBboxSize) * 2.0 - 1.0, 1.0);\n}\n");
//# sourceMappingURL=gaussian-density.vert.js.map

/***/ }),

/***/ "./lib/mol-gl/shader/histogram-pyramid/reduction.frag.js":
/*!***************************************************************!*\
  !*** ./lib/mol-gl/shader/histogram-pyramid/reduction.frag.js ***!
  \***************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("\nprecision highp float;\nprecision highp sampler2D;\n\n// input texture (previous level used to evaluate the new level)\nuniform sampler2D tPreviousLevel;\n\n// inverted size of the previous level texture.\nuniform float uSize;\nuniform float uTexSize;\nuniform bool uFirst;\n\nvoid main(void) {\n    float k = 0.5 * uSize;\n    vec2 position = floor((gl_FragCoord.xy / uTexSize) / uSize) * uSize;\n    float a, b, c, d;\n\n    if (uFirst) {\n        a = texture2D(tPreviousLevel, position).r * 255.0;\n        b = texture2D(tPreviousLevel, position + vec2(k, 0.0)).r * 255.0;\n        c = texture2D(tPreviousLevel, position + vec2(0.0, k)).r * 255.0;\n        d = texture2D(tPreviousLevel, position + vec2(k, k)).r * 255.0;\n    } else {\n        a = texture2D(tPreviousLevel, position).r;\n        b = texture2D(tPreviousLevel, position + vec2(k, 0.0)).r;\n        c = texture2D(tPreviousLevel, position + vec2(0.0, k)).r;\n        d = texture2D(tPreviousLevel, position + vec2(k, k)).r;\n    }\n\n    gl_FragColor.a = a;\n    gl_FragColor.b = a + b;\n    gl_FragColor.g = gl_FragColor.b + c;\n    gl_FragColor.r = gl_FragColor.g + d;\n}\n");
//# sourceMappingURL=reduction.frag.js.map

/***/ }),

/***/ "./lib/mol-gl/shader/histogram-pyramid/sum.frag.js":
/*!*********************************************************!*\
  !*** ./lib/mol-gl/shader/histogram-pyramid/sum.frag.js ***!
  \*********************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/**
 * Copyright (c) 2019 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */
/* harmony default export */ __webpack_exports__["default"] = ("\nprecision highp float;\nprecision highp sampler2D;\n\nuniform sampler2D tTexture;\n\n#include common\n\nvoid main(void) {\n    gl_FragColor = vec4(encodeFloatRGB(texture2D(tTexture, vec2(0.5)).r), 1.0);\n}\n");
//# sourceMappingURL=sum.frag.js.map

/***/ }),

/***/ "./lib/mol-gl/shader/image.frag.js":
/*!*****************************************!*\
  !*** ./lib/mol-gl/shader/image.frag.js ***!
  \*****************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/**
 * Copyright (c) 2020 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */
/* harmony default export */ __webpack_exports__["default"] = ("\nprecision highp float;\nprecision highp int;\n\n#include common\n#include read_from_texture\n#include common_frag_params\n#include common_clip\n#include wboit_params\n\nuniform vec2 uImageTexDim;\nuniform sampler2D tImageTex;\nuniform sampler2D tGroupTex;\n\nuniform vec2 uMarkerTexDim;\nuniform sampler2D tMarker;\n\nvarying vec2 vUv;\nvarying float vInstance;\n\n#if defined(dInterpolation_catmulrom) || defined(dInterpolation_mitchell) || defined(dInterpolation_bspline)\n    #define dInterpolation_cubic\n#endif\n\n#if defined(dInterpolation_cubic)\n    #if defined(dInterpolation_catmulrom) || defined(dInterpolation_mitchell)\n        #if defined(dInterpolation_catmulrom)\n            const float B = 0.0;\n            const float C = 0.5;\n        #elif defined(dInterpolation_mitchell)\n            const float B = 0.333;\n            const float C = 0.333;\n        #endif\n\n        float cubicFilter(float x){\n            float f = x;\n            if (f < 0.0) {\n                f = -f;\n            }\n            if (f < 1.0) {\n                return ((12.0 - 9.0 * B - 6.0 * C) * (f * f * f) +\n                    (-18.0 + 12.0 * B + 6.0 * C) * (f * f) +\n                    (6.0 - 2.0 * B)) / 6.0;\n            }else if (f >= 1.0 && f < 2.0){\n                return ((-B - 6.0 * C) * ( f * f * f)\n                    + (6.0 * B + 30.0 * C) * (f * f) +\n                    (-(12.0 * B) - 48.0 * C) * f +\n                    8.0 * B + 24.0 * C) / 6.0;\n            }else{\n                return 0.0;\n            }\n        }\n    #elif defined(dInterpolation_bspline)\n        float cubicFilter(float x) {\n            float f = x;\n            if (f < 0.0) {\n                f = -f;\n            }\n            if (f >= 0.0 && f <= 1.0){\n                return (2.0 / 3.0) + (0.5) * (f * f * f) - (f * f);\n            } else if (f > 1.0 && f <= 2.0) {\n                return 1.0 / 6.0 * pow((2.0 - f), 3.0);\n            }\n            return 1.0;\n        }\n    #endif\n\n    vec4 biCubic(sampler2D tex, vec2 texCoord) {\n        vec2 texelSize = 1.0 / uImageTexDim;\n        texCoord -= texelSize / 2.0;\n        vec4 nSum = vec4(0.0);\n        float nDenom = 0.0;\n        vec2 cell = fract(texCoord * uImageTexDim);\n        for (float m = -1.0; m <= 2.0; ++m) {\n            for (float n = -1.0; n <= 2.0; ++n) {\n                vec4 vecData = texture2D(tex, texCoord + texelSize * vec2(m, n));\n                float c = cubicFilter(m - cell.x) * cubicFilter(-n + cell.y);\n                nSum += vecData * c;\n                nDenom += c;\n            }\n        }\n        return nSum / nDenom;\n    }\n#endif\n\nvoid main() {\n    #include clip_pixel\n\n    #if defined(dInterpolation_cubic)\n        vec4 imageData = biCubic(tImageTex, vUv);\n    #else\n        vec4 imageData = texture2D(tImageTex, vUv);\n    #endif\n    imageData.a = clamp(imageData.a, 0.0, 1.0);\n    if (imageData.a > 0.9) imageData.a = 1.0;\n\n    float fragmentDepth = gl_FragCoord.z;\n    bool interior = false;\n\n    #if defined(dRenderVariant_pick)\n        if (imageData.a < 0.3)\n            discard;\n\n        #if defined(dRenderVariant_pickObject)\n            gl_FragColor = vec4(encodeFloatRGB(float(uObjectId)), 1.0);\n        #elif defined(dRenderVariant_pickInstance)\n            gl_FragColor = vec4(encodeFloatRGB(vInstance), 1.0);\n        #elif defined(dRenderVariant_pickGroup)\n            gl_FragColor = vec4(texture2D(tGroupTex, vUv).rgb, 1.0);\n        #endif\n    #elif defined(dRenderVariant_depth)\n        if (imageData.a < 0.05)\n            discard;\n\n        gl_FragColor = packDepthToRGBA(gl_FragCoord.z);\n    #elif defined(dRenderVariant_color)\n        if (imageData.a < 0.05)\n            discard;\n\n        gl_FragColor = imageData;\n        gl_FragColor.a *= uAlpha;\n\n        float group = decodeFloatRGB(texture2D(tGroupTex, vUv).rgb);\n        float vMarker = readFromTexture(tMarker, vInstance * float(uGroupCount) + group, uMarkerTexDim).a;\n\n        #include apply_marker_color\n        #include apply_fog\n        #include wboit_write\n    #endif\n}\n");
//# sourceMappingURL=image.frag.js.map

/***/ }),

/***/ "./lib/mol-gl/shader/image.vert.js":
/*!*****************************************!*\
  !*** ./lib/mol-gl/shader/image.vert.js ***!
  \*****************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/**
 * Copyright (c) 2020 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */
/* harmony default export */ __webpack_exports__["default"] = ("\nprecision highp float;\nprecision highp int;\n\n#include common\n#include common_vert_params\n\nattribute vec3 aPosition;\nattribute vec2 aUv;\nattribute mat4 aTransform;\nattribute float aInstance;\n\nvarying vec2 vUv;\nvarying float vInstance;\n\nvoid main() {\n    #include assign_position\n\n    vUv = aUv;\n    vInstance = aInstance;\n}\n");
//# sourceMappingURL=image.vert.js.map

/***/ }),

/***/ "./lib/mol-gl/shader/lines.frag.js":
/*!*****************************************!*\
  !*** ./lib/mol-gl/shader/lines.frag.js ***!
  \*****************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/**
 * Copyright (c) 2018-2020 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */
/* harmony default export */ __webpack_exports__["default"] = ("\nprecision highp float;\nprecision highp int;\n\n#include common\n#include common_frag_params\n#include color_frag_params\n#include common_clip\n#include wboit_params\n\nvoid main(){\n    #include clip_pixel\n\n    bool interior = false;\n    float fragmentDepth = gl_FragCoord.z;\n    #include assign_material_color\n\n    #if defined(dRenderVariant_pick)\n        #include check_picking_alpha\n        gl_FragColor = material;\n    #elif defined(dRenderVariant_depth)\n        gl_FragColor = material;\n    #elif defined(dRenderVariant_color)\n        gl_FragColor = material;\n\n        #include apply_marker_color\n        #include apply_fog\n        #include wboit_write\n    #endif\n}\n");
//# sourceMappingURL=lines.frag.js.map

/***/ }),

/***/ "./lib/mol-gl/shader/lines.vert.js":
/*!*****************************************!*\
  !*** ./lib/mol-gl/shader/lines.vert.js ***!
  \*****************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/**
 * Copyright (c) 2018-2020 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 *
 * heavily based on code by WestLangley from https://github.com/WestLangley/three.js/blob/af28b2fb706ac109771ecad0a7447fad90ab3210/examples/js/lines/LineMaterial.js
 */
/* harmony default export */ __webpack_exports__["default"] = ("\nprecision highp float;\nprecision highp int;\n\n#include common\n#include read_from_texture\n#include common_vert_params\n#include color_vert_params\n#include size_vert_params\n#include common_clip\n\nuniform float uPixelRatio;\nuniform float uViewportHeight;\n\nattribute mat4 aTransform;\nattribute float aInstance;\nattribute float aGroup;\n\nattribute vec2 aMapping;\nattribute vec3 aStart;\nattribute vec3 aEnd;\n\nvoid trimSegment(const in vec4 start, inout vec4 end) {\n    // trim end segment so it terminates between the camera plane and the near plane\n    // conservative estimate of the near plane\n    float a = uProjection[2][2];  // 3rd entry in 3rd column\n    float b = uProjection[3][2];  // 3rd entry in 4th column\n    float nearEstimate = -0.5 * b / a;\n    float alpha = (nearEstimate - start.z) / (end.z - start.z);\n    end.xyz = mix(start.xyz, end.xyz, alpha);\n}\n\nvoid main(){\n    #include assign_group\n    #include assign_color_varying\n    #include assign_marker_varying\n    #include assign_clipping_varying\n    #include assign_size\n\n    mat4 modelView = uView * uModel * aTransform;\n\n    // camera space\n    vec4 start = modelView * vec4(aStart, 1.0);\n    vec4 end = modelView * vec4(aEnd, 1.0);\n\n    // assign position\n    vec4 position4 = vec4((aMapping.y < 0.5) ? aStart : aEnd, 1.0);\n    vec4 mvPosition = modelView * position4;\n    vViewPosition = mvPosition.xyz;\n\n    vModelPosition = (uModel * aTransform * position4).xyz; // for clipping in frag shader\n\n    // special case for perspective projection, and segments that terminate either in, or behind, the camera plane\n    // clearly the gpu firmware has a way of addressing this issue when projecting into ndc space\n    // but we need to perform ndc-space calculations in the shader, so we must address this issue directly\n    // perhaps there is a more elegant solution -- WestLangley\n    bool perspective = (uProjection[2][3] == -1.0); // 4th entry in the 3rd column\n    if (perspective) {\n        if (start.z < 0.0 && end.z >= 0.0) {\n            trimSegment(start, end);\n        } else if (end.z < 0.0 && start.z >= 0.0) {\n            trimSegment(end, start);\n        }\n    }\n\n    // clip space\n    vec4 clipStart = uProjection * start;\n    vec4 clipEnd = uProjection * end;\n\n    // ndc space\n    vec2 ndcStart = clipStart.xy / clipStart.w;\n    vec2 ndcEnd = clipEnd.xy / clipEnd.w;\n\n    // direction\n    vec2 dir = ndcEnd - ndcStart;\n\n    // account for clip-space aspect ratio\n    dir.x *= uPixelRatio;\n    dir = normalize(dir);\n\n    // perpendicular to dir\n    vec2 offset = vec2(dir.y, - dir.x);\n\n    // undo aspect ratio adjustment\n    dir.x /= uPixelRatio;\n    offset.x /= uPixelRatio;\n\n    // sign flip\n    if (aMapping.x < 0.0) offset *= -1.0;\n\n    // calculate linewidth\n    float linewidth;\n    #ifdef dLineSizeAttenuation\n        linewidth = size * uPixelRatio * ((uViewportHeight / 2.0) / -start.z) * 5.0;\n    #else\n        linewidth = size * uPixelRatio;\n    #endif\n\n    // adjust for linewidth\n    offset *= linewidth;\n\n    // adjust for clip-space to screen-space conversion\n    offset /= uViewportHeight;\n\n    // select end\n    vec4 clip = (aMapping.y < 0.5) ? clipStart : clipEnd;\n\n    // back to clip space\n    offset *= clip.w;\n    clip.xy += offset;\n    gl_Position = clip;\n\n    #include clip_instance\n}\n");
//# sourceMappingURL=lines.vert.js.map

/***/ }),

/***/ "./lib/mol-gl/shader/marching-cubes/active-voxels.frag.js":
/*!****************************************************************!*\
  !*** ./lib/mol-gl/shader/marching-cubes/active-voxels.frag.js ***!
  \****************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("\nprecision highp float;\nprecision highp int;\nprecision highp sampler2D;\n\nuniform sampler2D tTriCount;\nuniform sampler2D tVolumeData;\n\nuniform float uIsoValue;\nuniform vec3 uGridDim;\nuniform vec3 uGridTexDim;\nuniform vec2 uScale;\n\n#include common\n\n// cube corners (excluding origin)\nconst vec3 c1 = vec3(1., 0., 0.);\nconst vec3 c2 = vec3(1., 1., 0.);\nconst vec3 c3 = vec3(0., 1., 0.);\nconst vec3 c4 = vec3(0., 0., 1.);\nconst vec3 c5 = vec3(1., 0., 1.);\nconst vec3 c6 = vec3(1., 1., 1.);\nconst vec3 c7 = vec3(0., 1., 1.);\n\nvec3 index3dFrom2d(vec2 coord) {\n    vec2 gridTexPos = coord * uGridTexDim.xy;\n    vec2 columnRow = ivec2Div(gridTexPos, uGridDim.xy);\n    vec2 posXY = gridTexPos - columnRow * uGridDim.xy;\n    float posZ = columnRow.y * intDiv(uGridTexDim.x, uGridDim.x) + columnRow.x;\n    return vec3(posXY, posZ);\n}\n\nvec4 texture3dFrom2dNearest(sampler2D tex, vec3 pos, vec3 gridDim, vec2 texDim) {\n    float zSlice = floor(pos.z * gridDim.z + 0.5); // round to nearest z-slice\n    float column = intDiv(intMod(zSlice * gridDim.x, texDim.x), gridDim.x);\n    float row = intDiv(zSlice * gridDim.x, texDim.x);\n    vec2 coord = (vec2(column * gridDim.x, row * gridDim.y) + (pos.xy * gridDim.xy)) / (texDim / uScale);\n    return texture2D(tex, coord);\n}\n\nvec4 voxel(vec3 pos) {\n    pos = min(max(vec3(0.0), pos), uGridDim - vec3(1.0));\n    return texture3dFrom2dNearest(tVolumeData, pos / uGridDim, uGridDim, uGridTexDim.xy);\n}\n\nvoid main(void) {\n    vec2 uv = gl_FragCoord.xy / uGridTexDim.xy;\n    vec3 posXYZ = index3dFrom2d(uv);\n\n    // get MC case as the sum of corners that are below the given iso level\n    float c = step(voxel(posXYZ).a, uIsoValue)\n        + 2. * step(voxel(posXYZ + c1).a, uIsoValue)\n        + 4. * step(voxel(posXYZ + c2).a, uIsoValue)\n        + 8. * step(voxel(posXYZ + c3).a, uIsoValue)\n        + 16. * step(voxel(posXYZ + c4).a, uIsoValue)\n        + 32. * step(voxel(posXYZ + c5).a, uIsoValue)\n        + 64. * step(voxel(posXYZ + c6).a, uIsoValue)\n        + 128. * step(voxel(posXYZ + c7).a, uIsoValue);\n    c *= step(c, 254.);\n\n    // handle out of bounds positions\n    posXYZ += 1.0;\n    posXYZ.xy += 1.0; // pixel padding (usually ok even if the texture has no padding)\n    if (posXYZ.x >= uGridDim.x || posXYZ.y >= uGridDim.y || posXYZ.z >= uGridDim.z)\n        c = 0.0;\n\n    // get total triangles to generate for calculated MC case from triCount texture\n    float totalTrianglesToGenerate = texture2D(tTriCount, vec2(intMod(c, 16.), floor(c / 16.)) / 16.).a;\n    gl_FragColor = vec4(vec3(totalTrianglesToGenerate * 3.0), c / 255.0);\n}\n");
//# sourceMappingURL=active-voxels.frag.js.map

/***/ }),

/***/ "./lib/mol-gl/shader/marching-cubes/isosurface.frag.js":
/*!*************************************************************!*\
  !*** ./lib/mol-gl/shader/marching-cubes/isosurface.frag.js ***!
  \*************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("\nprecision highp float;\nprecision highp int;\nprecision highp sampler2D;\n\nuniform sampler2D tActiveVoxelsPyramid;\nuniform sampler2D tActiveVoxelsBase;\nuniform sampler2D tVolumeData;\nuniform sampler2D tTriIndices;\n\nuniform float uIsoValue;\nuniform float uLevels;\nuniform float uSize;\nuniform float uCount;\n\nuniform vec3 uGridDim;\nuniform vec3 uGridTexDim;\nuniform mat4 uGridTransform;\n\n// scale to volume data coord\nuniform vec2 uScale;\n\n#include common\n\n// cube corners (excluding origin)\nconst vec3 c1 = vec3(1., 0., 0.);\nconst vec3 c2 = vec3(1., 1., 0.);\nconst vec3 c3 = vec3(0., 1., 0.);\nconst vec3 c4 = vec3(0., 0., 1.);\nconst vec3 c5 = vec3(1., 0., 1.);\nconst vec3 c6 = vec3(1., 1., 1.);\nconst vec3 c7 = vec3(0., 1., 1.);\n\nvec3 index3dFrom2d(vec2 coord) {\n    vec2 gridTexPos = coord * uGridTexDim.xy;\n    vec2 columnRow = ivec2Div(gridTexPos, uGridDim.xy);\n    vec2 posXY = gridTexPos - columnRow * uGridDim.xy;\n    float posZ = columnRow.y * intDiv(uGridTexDim.x, uGridDim.x) + columnRow.x;\n    return vec3(posXY, posZ);\n}\n\nvec4 texture3dFrom2dNearest(sampler2D tex, vec3 pos, vec3 gridDim, vec2 texDim) {\n    float zSlice = floor(pos.z * gridDim.z + 0.5); // round to nearest z-slice\n    float column = intDiv(intMod(zSlice * gridDim.x, texDim.x), gridDim.x);\n    float row = intDiv(zSlice * gridDim.x, texDim.x);\n    vec2 coord = (vec2(column * gridDim.x, row * gridDim.y) + (pos.xy * gridDim.xy)) / (texDim / uScale);\n    return texture2D(tex, coord + 0.5 / (texDim / uScale));\n}\n\nvec4 voxel(vec3 pos) {\n    pos = min(max(vec3(0.0), pos), uGridDim - vec3(1.0));\n    return texture3dFrom2dNearest(tVolumeData, pos / uGridDim, uGridDim, uGridTexDim.xy);\n}\n\nvec4 voxel2(vec3 pos) {\n    pos = min(max(vec3(0.0), pos), uGridDim - vec3(vec2(2.0), 1.0));\n    return texture3dFrom2dNearest(tVolumeData, pos / uGridDim, uGridDim, uGridTexDim.xy);\n}\n\nvoid main(void) {\n    // get 1D index\n    float vI = dot(floor(uSize * (gl_FragCoord.xy / uSize)), vec2(1.0, uSize));\n\n    // ignore 1D indices outside of the grid\n    if(vI >= uCount) discard;\n\n    float offset = uSize - 2.;\n    float k = 1. / uSize;\n\n    vec2 relativePosition = k * vec2(offset, 0.);\n    vec4 partialSums = texture2D(tActiveVoxelsPyramid, relativePosition);\n    float start = 0.;\n    vec4 starts = vec4(0.);\n    vec4 ends = vec4(0.);\n    float diff = 2.;\n    vec4 m = vec4(0.);\n    vec2 position = vec2(0.);\n    vec4 vI4 = vec4(vI);\n\n    // traverse the different levels of the pyramid\n    for(int i = 1; i < 14; i++) {\n        if(float(i) >= uLevels) break;\n\n        offset -= diff;\n        diff *= 2.;\n        relativePosition = position + k * vec2(offset, 0.);\n\n        ends = partialSums.wzyx + vec4(start);\n        starts = vec4(start, ends.xyz);\n        m = vec4(greaterThanEqual(vI4, starts)) * vec4(lessThan(vI4, ends));\n        relativePosition += m.y * vec2(k, 0.) + m.z * vec2(0., k) + m.w * vec2(k, k);\n\n        start = dot(m, starts);\n        position = 2. * (relativePosition - k * vec2(offset, 0.));\n        partialSums = texture2D(tActiveVoxelsPyramid, relativePosition);\n    }\n\n    ends = partialSums.wzyx + vec4(start);\n    starts = vec4(start, ends.xyz);\n    m = vec4(greaterThanEqual(vI4, starts)) * vec4(lessThan(vI4, ends));\n    position += m.y * vec2(k, 0.) + m.z * vec2(0., k) + m.w * vec2(k, k);\n\n    vec2 coord2d = position / uScale;\n    vec3 coord3d = floor(index3dFrom2d(coord2d) + 0.5);\n\n    float edgeIndex = floor(texture2D(tActiveVoxelsBase, position).a * 255.0 + 0.5);\n\n    // current vertex for the up to 15 MC cases\n    float currentVertex = vI - dot(m, starts);\n\n    // get index into triIndices table\n    float mcIndex = 16. * edgeIndex + currentVertex;\n    vec4 mcData = texture2D(tTriIndices, vec2(intMod(mcIndex, 64.), floor(mcIndex / 64.)) / 64.);\n\n    // bit mask to avoid conditionals (see comment below) for getting MC case corner\n    vec4 m0 = vec4(floor(mcData.a * 255.0 + 0.5));\n\n    // get edge value masks\n    vec4 m1 = vec4(equal(m0, vec4(0., 1., 2., 3.)));\n    vec4 m2 = vec4(equal(m0, vec4(4., 5., 6., 7.)));\n    vec4 m3 = vec4(equal(m0, vec4(8., 9., 10., 11.)));\n\n    // apply bit masks\n    vec3 b0 = coord3d +\n                m1.y * c1 +\n                m1.z * c2 +\n                m1.w * c3 +\n                m2.x * c4 +\n                m2.y * c5 +\n                m2.z * c6 +\n                m2.w * c7 +\n                m3.y * c1 +\n                m3.z * c2 +\n                m3.w * c3;\n    vec3 b1 = coord3d +\n                m1.x * c1 +\n                m1.y * c2 +\n                m1.z * c3 +\n                m2.x * c5 +\n                m2.y * c6 +\n                m2.z * c7 +\n                m2.w * c4 +\n                m3.x * c4 +\n                m3.y * c5 +\n                m3.z * c6 +\n                m3.w * c7;\n\n    // the conditionals that are avoided by above bitmasks\n    // vec3 b0 = coord3d;\n    // vec3 b1 = coord3d;\n    // if (mcIndex == 0.0) {\n    //     b1 += c1;\n    // } else if (mcIndex == 1.0) {\n    //     b0 += c1; b1 += c2;\n    // } else if (mcIndex == 2.0) {\n    //     b0 += c2; b1 += c3;\n    // } else if (mcIndex == 3.0) {\n    //     b0 += c3;\n    // } else if (mcIndex == 4.0) {\n    //     b0 += c4; b1 += c5;\n    // } else if (mcIndex == 5.0) {\n    //     b0 += c5; b1 += c6;\n    // } else if (mcIndex == 6.0) {\n    //     b0 += c6; b1 += c7;\n    // } else if (mcIndex == 7.0) {\n    //     b0 += c7; b1 += c4;\n    // } else if (mcIndex == 8.0) {\n    //     b1 += c4;\n    // } else if (mcIndex == 9.0) {\n    //     b0 += c1; b1 += c5;\n    // } else if (mcIndex == 10.0) {\n    //     b0 += c2; b1 += c6;\n    // } else if (mcIndex == 11.0) {\n    //     b0 += c3; b1 += c7;\n    // }\n    // b0 = floor(b0 + 0.5);\n    // b1 = floor(b1 + 0.5);\n\n    vec4 d0 = voxel(b0);\n    vec4 d1 = voxel(b1);\n\n    float v0 = d0.a;\n    float v1 = d1.a;\n\n    float t = (uIsoValue - v0) / (v0 - v1);\n    gl_FragData[0].xyz = (uGridTransform * vec4(b0 + t * (b0 - b1), 1.0)).xyz;\n\n    // group id\n    #if __VERSION__ == 100\n        // webgl1 does not support 'flat' interpolation (i.e. no interpolation)\n        // so we ensure a constant group id per triangle\n        gl_FragData[0].w = decodeFloatRGB(voxel(coord3d).rgb);\n    #else\n        gl_FragData[0].w = t < 0.5 ? decodeFloatRGB(d0.rgb) : decodeFloatRGB(d1.rgb);\n    #endif\n\n    // normals from gradients\n    vec3 n0 = -normalize(vec3(\n        voxel2(b0 - c1).a - voxel2(b0 + c1).a,\n        voxel2(b0 - c3).a - voxel2(b0 + c3).a,\n        voxel2(b0 - c4).a - voxel2(b0 + c4).a\n    ));\n    vec3 n1 = -normalize(vec3(\n        voxel2(b1 - c1).a - voxel2(b1 + c1).a,\n        voxel2(b1 - c3).a - voxel2(b1 + c3).a,\n        voxel2(b1 - c4).a - voxel2(b1 + c4).a\n    ));\n    gl_FragData[1].xyz = -vec3(\n        n0.x + t * (n0.x - n1.x),\n        n0.y + t * (n0.y - n1.y),\n        n0.z + t * (n0.z - n1.z)\n    );\n\n    mat3 normalMatrix = transpose3(inverse3(mat3(uGridTransform)));\n    gl_FragData[1].xyz = normalMatrix * gl_FragData[1].xyz;\n}\n");
//# sourceMappingURL=isosurface.frag.js.map

/***/ }),

/***/ "./lib/mol-gl/shader/mesh.frag.js":
/*!****************************************!*\
  !*** ./lib/mol-gl/shader/mesh.frag.js ***!
  \****************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/**
 * Copyright (c) 2018-2020 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */
/* harmony default export */ __webpack_exports__["default"] = ("\nprecision highp float;\nprecision highp int;\n\n#include common\n#include common_frag_params\n#include color_frag_params\n#include light_frag_params\n#include normal_frag_params\n#include common_clip\n#include wboit_params\n\nvoid main() {\n    #include clip_pixel\n\n    // Workaround for buggy gl_FrontFacing (e.g. on some integrated Intel GPUs)\n    #if defined(enabledStandardDerivatives)\n        vec3 fdx = dFdx(vViewPosition);\n        vec3 fdy = dFdy(vViewPosition);\n        vec3 faceNormal = normalize(cross(fdx,fdy));\n        bool frontFacing = dot(vNormal, faceNormal) > 0.0;\n    #else\n        bool frontFacing = dot(vNormal, vViewPosition) < 0.0;\n    #endif\n\n    #if defined(dFlipSided)\n        interior = frontFacing;\n    #else\n        interior = !frontFacing;\n    #endif\n\n    float fragmentDepth = gl_FragCoord.z;\n    #include assign_material_color\n\n    #if defined(dRenderVariant_pick)\n        #include check_picking_alpha\n        gl_FragColor = material;\n    #elif defined(dRenderVariant_depth)\n        gl_FragColor = material;\n    #elif defined(dRenderVariant_color)\n        #ifdef dIgnoreLight\n            gl_FragColor = material;\n        #else\n            #if defined(dFlatShaded) && defined(enabledStandardDerivatives)\n                vec3 normal = -faceNormal;\n            #else\n                vec3 normal = -normalize(vNormal);\n                #ifdef dDoubleSided\n                    normal = normal * (float(frontFacing) * 2.0 - 1.0);\n                #endif\n            #endif\n            #include apply_light_color\n        #endif\n\n        #include apply_interior_color\n        #include apply_marker_color\n        #include apply_fog\n        #include wboit_write\n    #endif\n}\n");
//# sourceMappingURL=mesh.frag.js.map

/***/ }),

/***/ "./lib/mol-gl/shader/mesh.vert.js":
/*!****************************************!*\
  !*** ./lib/mol-gl/shader/mesh.vert.js ***!
  \****************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/**
 * Copyright (c) 2018-2020 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */
/* harmony default export */ __webpack_exports__["default"] = ("\nprecision highp float;\nprecision highp int;\n\n#include common\n#include read_from_texture\n#include common_vert_params\n#include color_vert_params\n#include common_clip\n\n#ifdef dGeoTexture\n    uniform vec2 uGeoTexDim;\n    uniform sampler2D tPositionGroup;\n#else\n    attribute vec3 aPosition;\n#endif\nattribute mat4 aTransform;\nattribute float aInstance;\nattribute float aGroup;\n\n#ifdef dGeoTexture\n    uniform sampler2D tNormal;\n#else\n    attribute vec3 aNormal;\n#endif\nvarying vec3 vNormal;\n\nvoid main(){\n    #include assign_group\n    #include assign_color_varying\n    #include assign_marker_varying\n    #include assign_clipping_varying\n    #include assign_position\n    #include clip_instance\n\n    #ifdef dGeoTexture\n        vec3 normal = readFromTexture(tNormal, aGroup, uGeoTexDim).xyz;\n    #else\n        vec3 normal = aNormal;\n    #endif\n    mat3 normalMatrix = transpose3(inverse3(mat3(modelView)));\n    vec3 transformedNormal = normalize(normalMatrix * normalize(normal));\n    #if defined(dFlipSided) && !defined(dDoubleSided) // TODO checking dDoubleSided should not be required, ASR\n        transformedNormal = -transformedNormal;\n    #endif\n    vNormal = transformedNormal;\n}\n");
//# sourceMappingURL=mesh.vert.js.map

/***/ }),

/***/ "./lib/mol-gl/shader/outlines.frag.js":
/*!********************************************!*\
  !*** ./lib/mol-gl/shader/outlines.frag.js ***!
  \********************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/**
 * Copyright (c) 2019-2020 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author Áron Samuel Kovács <aron.kovacs@mail.muni.cz>
 */
/* harmony default export */ __webpack_exports__["default"] = ("\nprecision highp float;\nprecision highp int;\nprecision highp sampler2D;\n\nuniform sampler2D tDepth;\nuniform vec2 uTexSize;\n\nuniform float uNear;\nuniform float uFar;\n\nuniform float uMaxPossibleViewZDiff;\n\n#include common\n\nfloat getViewZ(const in float depth) {\n    #if dOrthographic == 1\n        return orthographicDepthToViewZ(depth, uNear, uFar);\n    #else\n        return perspectiveDepthToViewZ(depth, uNear, uFar);\n    #endif\n}\n\nfloat getDepth(const in vec2 coords) {\n    return unpackRGBAToDepth(texture2D(tDepth, coords));\n}\n\nbool isBackground(const in float depth) {\n    return depth == 1.0;\n}\n\nvoid main(void) {\n    float backgroundViewZ = uFar + 3.0 * uMaxPossibleViewZDiff;\n\n    vec2 coords = gl_FragCoord.xy / uTexSize;\n    vec2 invTexSize = 1.0 / uTexSize;\n\n    float selfDepth = getDepth(coords);\n    float selfViewZ = isBackground(selfDepth) ? backgroundViewZ : getViewZ(getDepth(coords));\n\n    float outline = 1.0;\n    float bestDepth = 1.0;\n\n    for (int y = -1; y <= 1; y++) {\n        for (int x = -1; x <= 1; x++) {\n            vec2 sampleCoords = coords + vec2(float(x), float(y)) * invTexSize;\n            float sampleDepth = getDepth(sampleCoords);\n            float sampleViewZ = isBackground(sampleDepth) ? backgroundViewZ : getViewZ(sampleDepth);\n\n            if (abs(selfViewZ - sampleViewZ) > uMaxPossibleViewZDiff && selfDepth > sampleDepth && sampleDepth <= bestDepth) {\n                outline = 0.0;\n                bestDepth = sampleDepth;\n            }\n        }\n    }\n\n    gl_FragColor = vec4(outline, packUnitIntervalToRG(bestDepth), 0.0);\n}\n");
//# sourceMappingURL=outlines.frag.js.map

/***/ }),

/***/ "./lib/mol-gl/shader/points.frag.js":
/*!******************************************!*\
  !*** ./lib/mol-gl/shader/points.frag.js ***!
  \******************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/**
 * Copyright (c) 2018-2020 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */
/* harmony default export */ __webpack_exports__["default"] = ("\nprecision highp float;\nprecision highp int;\n\n#include common\n#include common_frag_params\n#include color_frag_params\n#include common_clip\n#include wboit_params\n\n#ifdef dPointFilledCircle\n    uniform float uPointEdgeBleach;\n#endif\n\nconst vec2 center = vec2(0.5);\nconst float radius = 0.5;\n\nvoid main(){\n    #include clip_pixel\n\n    float fragmentDepth = gl_FragCoord.z;\n    bool interior = false;\n    #include assign_material_color\n\n    #if defined(dRenderVariant_pick)\n        #include check_picking_alpha\n        gl_FragColor = material;\n    #elif defined(dRenderVariant_depth)\n        gl_FragColor = material;\n    #elif defined(dRenderVariant_color)\n        gl_FragColor = material;\n\n        #ifdef dPointFilledCircle\n            float dist = distance(gl_PointCoord, center);\n            float alpha = 1.0 - smoothstep(radius - uPointEdgeBleach, radius, dist);\n            if (alpha < 0.0001) discard;\n            gl_FragColor.a *= alpha;\n        #endif\n\n        #include apply_marker_color\n        #include apply_fog\n        #include wboit_write\n    #endif\n}\n");
//# sourceMappingURL=points.frag.js.map

/***/ }),

/***/ "./lib/mol-gl/shader/points.vert.js":
/*!******************************************!*\
  !*** ./lib/mol-gl/shader/points.vert.js ***!
  \******************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/**
 * Copyright (c) 2018-2020 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */
/* harmony default export */ __webpack_exports__["default"] = ("\nprecision highp float;\nprecision highp int;\n\n#include common\n#include read_from_texture\n#include common_vert_params\n#include color_vert_params\n#include size_vert_params\n#include common_clip\n\nuniform float uPixelRatio;\nuniform float uViewportHeight;\n\nattribute vec3 aPosition;\nattribute mat4 aTransform;\nattribute float aInstance;\nattribute float aGroup;\n\nvoid main(){\n    #include assign_group\n    #include assign_color_varying\n    #include assign_marker_varying\n    #include assign_clipping_varying\n    #include assign_position\n    #include assign_size\n\n    #ifdef dPointSizeAttenuation\n        gl_PointSize = size * uPixelRatio * ((uViewportHeight / 2.0) / -mvPosition.z) * 5.0;\n    #else\n        gl_PointSize = size * uPixelRatio;\n    #endif\n\n    gl_Position = uProjection * mvPosition;\n\n    #include clip_instance\n}\n");
//# sourceMappingURL=points.vert.js.map

/***/ }),

/***/ "./lib/mol-gl/shader/postprocessing.frag.js":
/*!**************************************************!*\
  !*** ./lib/mol-gl/shader/postprocessing.frag.js ***!
  \**************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/**
 * Copyright (c) 2019-2020 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 * @author Áron Samuel Kovács <aron.kovacs@mail.muni.cz>
 */
/* harmony default export */ __webpack_exports__["default"] = ("\nprecision highp float;\nprecision highp int;\nprecision highp sampler2D;\n\nuniform sampler2D tSsaoDepth;\nuniform sampler2D tColor;\nuniform sampler2D tDepth;\nuniform sampler2D tOutlines;\nuniform vec2 uTexSize;\n\nuniform float uNear;\nuniform float uFar;\nuniform float uFogNear;\nuniform float uFogFar;\nuniform vec3 uFogColor;\nuniform bool uTransparentBackground;\n\nuniform float uOcclusionBias;\nuniform float uOcclusionRadius;\n\nuniform float uOutlineScale;\nuniform float uOutlineThreshold;\n\nuniform float uMaxPossibleViewZDiff;\n\nconst vec3 occlusionColor = vec3(0.0);\n\n#include common\n\nfloat getViewZ(const in float depth) {\n    #if dOrthographic == 1\n        return orthographicDepthToViewZ(depth, uNear, uFar);\n    #else\n        return perspectiveDepthToViewZ(depth, uNear, uFar);\n    #endif\n}\n\nfloat getDepth(const in vec2 coords) {\n    return unpackRGBAToDepth(texture2D(tDepth, coords));\n}\n\nbool isBackground(const in float depth) {\n    return depth == 1.0;\n}\n\nfloat getOutline(const in vec2 coords, out float closestTexel) {\n    float backgroundViewZ = uFar + 3.0 * uMaxPossibleViewZDiff;\n    vec2 invTexSize = 1.0 / uTexSize;\n\n    float selfDepth = getDepth(coords);\n    float selfViewZ = isBackground(selfDepth) ? backgroundViewZ : getViewZ(selfDepth);\n\n    float outline = 1.0;\n    closestTexel = 1.0;\n    for (int y = -dOutlineScale; y <= dOutlineScale; y++) {\n        for (int x = -dOutlineScale; x <= dOutlineScale; x++) {\n            if (x * x + y * y > dOutlineScale * dOutlineScale) {\n                continue;\n            }\n\n            vec2 sampleCoords = coords + vec2(float(x), float(y)) * invTexSize;\n\n            vec4 sampleOutlineCombined = texture2D(tOutlines, sampleCoords);\n            float sampleOutline = sampleOutlineCombined.r;\n            float sampleOutlineDepth = unpackRGToUnitInterval(sampleOutlineCombined.gb);\n\n            if (sampleOutline == 0.0 && sampleOutlineDepth < closestTexel && abs(selfViewZ - sampleOutlineDepth) > uMaxPossibleViewZDiff) {\n                outline = 0.0;\n                closestTexel = sampleOutlineDepth;\n            }\n        }\n    }\n    return outline;\n}\n\nfloat getSsao(vec2 coords) {\n    float rawSsao = unpackRGToUnitInterval(texture2D(tSsaoDepth, coords).xy);\n    if (rawSsao > 0.999) {\n        return 1.0;\n    } else if (rawSsao > 0.001) {\n        return rawSsao;\n    }\n    return 0.0;\n}\n\nvoid main(void) {\n    vec2 coords = gl_FragCoord.xy / uTexSize;\n    vec4 color = texture2D(tColor, coords);\n\n    float viewDist;\n    float fogFactor;\n\n    #ifdef dOcclusionEnable\n        float depth = getDepth(coords);\n        if (!isBackground(depth)) {\n            viewDist = abs(getViewZ(depth));\n            fogFactor = smoothstep(uFogNear, uFogFar, viewDist);\n            float occlusionFactor = getSsao(coords);\n            if (!uTransparentBackground) {\n                color.rgb = mix(mix(occlusionColor, uFogColor, fogFactor), color.rgb, occlusionFactor);\n            } else {\n                color.rgb = mix(occlusionColor * (1.0 - fogFactor), color.rgb, occlusionFactor);\n            }\n        }\n    #endif\n\n    // outline needs to be handled after occlusion to keep them clean\n    #ifdef dOutlineEnable\n        float closestTexel;\n        float outline = getOutline(coords, closestTexel);\n\n        if (outline == 0.0) {\n            color.rgb *= outline;\n            viewDist = abs(getViewZ(closestTexel));\n            fogFactor = smoothstep(uFogNear, uFogFar, viewDist);\n            if (!uTransparentBackground) {\n                color.rgb = mix(color.rgb, uFogColor, fogFactor);\n            } else {\n                color.a = 1.0 - fogFactor;\n            }\n        }\n    #endif\n\n    gl_FragColor = color;\n}\n");
//# sourceMappingURL=postprocessing.frag.js.map

/***/ }),

/***/ "./lib/mol-gl/shader/quad.vert.js":
/*!****************************************!*\
  !*** ./lib/mol-gl/shader/quad.vert.js ***!
  \****************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/**
 * Copyright (c) 2019 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */
/* harmony default export */ __webpack_exports__["default"] = ("\nprecision highp float;\n\nattribute vec2 aPosition;\nuniform vec2 uQuadScale;\n\nvoid main(void) {\n    vec2 position = aPosition * uQuadScale - vec2(1.0, 1.0) + uQuadScale;\n    gl_Position = vec4(position, 0.0, 1.0);\n}\n");
//# sourceMappingURL=quad.vert.js.map

/***/ }),

/***/ "./lib/mol-gl/shader/smaa/blend.frag.js":
/*!**********************************************!*\
  !*** ./lib/mol-gl/shader/smaa/blend.frag.js ***!
  \**********************************************/
/*! exports provided: blend_frag */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "blend_frag", function() { return blend_frag; });
/**
 * Slightly adapted from https://github.com/mrdoob/three.js
 * MIT License Copyright (c) 2010-2020 three.js authors
 *
 * WebGL port of Subpixel Morphological Antialiasing (SMAA) v2.8
 * Preset: SMAA 1x Medium (with color edge detection)
 * https://github.com/iryoku/smaa/releases/tag/v2.8
 */
var blend_frag = "\nprecision highp float;\nprecision highp int;\nprecision highp sampler2D;\n\nuniform sampler2D tWeights;\nuniform sampler2D tColor;\nuniform vec2 uTexSizeInv;\n\nvarying vec2 vUv;\nvarying vec4 vOffset[2];\n\nvec4 SMAANeighborhoodBlendingPS(vec2 texCoord, vec4 offset[2], sampler2D colorTex, sampler2D blendTex) {\n    // Fetch the blending weights for current pixel:\n    vec4 a;\n    a.xz = texture2D(blendTex, texCoord).xz;\n    a.y = texture2D(blendTex, offset[1].zw).g;\n    a.w = texture2D(blendTex, offset[1].xy).a;\n\n    // Is there any blending weight with a value greater than 0.0?\n    if (dot(a, vec4(1.0, 1.0, 1.0, 1.0)) < 1e-5) {\n        return texture2D(colorTex, texCoord, 0.0);\n    } else {\n        // Up to 4 lines can be crossing a pixel (one through each edge). We\n        // favor blending by choosing the line with the maximum weight for each\n        // direction:\n        vec2 offset;\n        offset.x = a.a > a.b ? a.a : -a.b; // left vs. right\n        offset.y = a.g > a.r ? -a.g : a.r; // top vs. bottom // WebGL port note: Changed signs\n\n        // Then we go in the direction that has the maximum weight:\n        if (abs(offset.x) > abs(offset.y)) { // horizontal vs. vertical\n            offset.y = 0.0;\n        } else {\n            offset.x = 0.0;\n        }\n\n        // Fetch the opposite color and lerp by hand:\n        vec4 C = texture2D(colorTex, texCoord, 0.0);\n        texCoord += sign(offset) * uTexSizeInv;\n        vec4 Cop = texture2D(colorTex, texCoord, 0.0);\n        float s = abs(offset.x) > abs(offset.y) ? abs(offset.x) : abs(offset.y);\n\n        // WebGL port note: Added gamma correction\n        C.xyz = pow(C.xyz, vec3(2.2));\n        Cop.xyz = pow(Cop.xyz, vec3(2.2));\n        vec4 mixed = mix(C, Cop, s);\n        mixed.xyz = pow(mixed.xyz, vec3(1.0 / 2.2));\n\n        return mixed;\n    }\n}\n\nvoid main() {\n    gl_FragColor = SMAANeighborhoodBlendingPS(vUv, vOffset, tColor, tWeights);\n}\n";
//# sourceMappingURL=blend.frag.js.map

/***/ }),

/***/ "./lib/mol-gl/shader/smaa/blend.vert.js":
/*!**********************************************!*\
  !*** ./lib/mol-gl/shader/smaa/blend.vert.js ***!
  \**********************************************/
/*! exports provided: blend_vert */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "blend_vert", function() { return blend_vert; });
/**
 * Slightly adapted from https://github.com/mrdoob/three.js
 * MIT License Copyright (c) 2010-2020 three.js authors
 *
 * WebGL port of Subpixel Morphological Antialiasing (SMAA) v2.8
 * Preset: SMAA 1x Medium (with color edge detection)
 * https://github.com/iryoku/smaa/releases/tag/v2.8
 */
var blend_vert = "\nprecision highp float;\n\nattribute vec2 aPosition;\nuniform vec2 uQuadScale;\n\nuniform vec2 uTexSizeInv;\nuniform vec4 uViewport;\n\nvarying vec2 vUv;\nvarying vec4 vOffset[2];\n\nvoid SMAANeighborhoodBlendingVS(vec2 texCoord) {\n    vOffset[0] = texCoord.xyxy + uTexSizeInv.xyxy * vec4(-1.0, 0.0, 0.0, 1.0); // WebGL port note: Changed sign in W component\n    vOffset[1] = texCoord.xyxy + uTexSizeInv.xyxy * vec4(1.0, 0.0, 0.0, -1.0); // WebGL port note: Changed sign in W component\n}\n\nvoid main() {\n    vec2 scale = uViewport.zw * uTexSizeInv;\n    vec2 shift = uViewport.xy * uTexSizeInv;\n    vUv = (aPosition + 1.0) * 0.5 * scale + shift;\n    SMAANeighborhoodBlendingVS(vUv);\n    vec2 position = aPosition * uQuadScale - vec2(1.0, 1.0) + uQuadScale;\n    gl_Position = vec4(position, 0.0, 1.0);\n}\n";
//# sourceMappingURL=blend.vert.js.map

/***/ }),

/***/ "./lib/mol-gl/shader/smaa/edges.frag.js":
/*!**********************************************!*\
  !*** ./lib/mol-gl/shader/smaa/edges.frag.js ***!
  \**********************************************/
/*! exports provided: edges_frag */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "edges_frag", function() { return edges_frag; });
/**
 * Slightly adapted from https://github.com/mrdoob/three.js
 * MIT License Copyright (c) 2010-2020 three.js authors
 *
 * WebGL port of Subpixel Morphological Antialiasing (SMAA) v2.8
 * Preset: SMAA 1x Medium (with color edge detection)
 * https://github.com/iryoku/smaa/releases/tag/v2.8
 */
var edges_frag = "\nprecision highp float;\nprecision highp int;\nprecision highp sampler2D;\n\nuniform sampler2D tColor;\nuniform vec2 uTexSizeInv;\n\nvarying vec2 vUv;\nvarying vec4 vOffset[3];\n\nvec4 SMAAColorEdgeDetectionPS(vec2 texcoord, vec4 offset[3], sampler2D colorTex) {\n    vec2 threshold = vec2(dEdgeThreshold, dEdgeThreshold);\n\n    // Calculate color deltas:\n    vec4 delta;\n    vec3 C = texture2D(colorTex, texcoord).rgb;\n\n    vec3 Cleft = texture2D(colorTex, offset[0].xy).rgb;\n    vec3 t = abs(C - Cleft);\n    delta.x = max(max(t.r, t.g), t.b);\n\n    vec3 Ctop = texture2D(colorTex, offset[0].zw).rgb;\n    t = abs(C - Ctop);\n    delta.y = max(max(t.r, t.g), t.b);\n\n    // We do the usual threshold:\n    vec2 edges = step(threshold, delta.xy);\n\n    // Then discard if there is no edge:\n    if (dot(edges, vec2(1.0, 1.0 )) == 0.0)\n        discard;\n\n    // Calculate right and bottom deltas:\n    vec3 Cright = texture2D(colorTex, offset[1].xy).rgb;\n    t = abs( C - Cright );\n    delta.z = max(max(t.r, t.g), t.b);\n\n    vec3 Cbottom  = texture2D(colorTex, offset[1].zw).rgb;\n    t = abs(C - Cbottom);\n    delta.w = max(max(t.r, t.g), t.b);\n\n    // Calculate the maximum delta in the direct neighborhood:\n    float maxDelta = max(max(max(delta.x, delta.y), delta.z), delta.w );\n\n    // Calculate left-left and top-top deltas:\n    vec3 Cleftleft  = texture2D(colorTex, offset[2].xy).rgb;\n    t = abs( C - Cleftleft );\n    delta.z = max(max(t.r, t.g), t.b);\n\n    vec3 Ctoptop = texture2D(colorTex, offset[2].zw).rgb;\n    t = abs(C - Ctoptop);\n    delta.w = max(max(t.r, t.g), t.b);\n\n    // Calculate the final maximum delta:\n    maxDelta = max(max(maxDelta, delta.z), delta.w);\n\n    // Local contrast adaptation in action:\n    edges.xy *= step(0.5 * maxDelta, delta.xy);\n\n    return vec4(edges, 0.0, 0.0);\n}\n\nvoid main() {\n    gl_FragColor = SMAAColorEdgeDetectionPS(vUv, vOffset, tColor);\n}\n";
//# sourceMappingURL=edges.frag.js.map

/***/ }),

/***/ "./lib/mol-gl/shader/smaa/edges.vert.js":
/*!**********************************************!*\
  !*** ./lib/mol-gl/shader/smaa/edges.vert.js ***!
  \**********************************************/
/*! exports provided: edges_vert */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "edges_vert", function() { return edges_vert; });
/**
 * Slightly adapted from https://github.com/mrdoob/three.js
 * MIT License Copyright (c) 2010-2020 three.js authors
 *
 * WebGL port of Subpixel Morphological Antialiasing (SMAA) v2.8
 * Preset: SMAA 1x Medium (with color edge detection)
 * https://github.com/iryoku/smaa/releases/tag/v2.8
 */
var edges_vert = "\nprecision highp float;\n\nattribute vec2 aPosition;\nuniform vec2 uQuadScale;\n\nuniform vec2 uTexSizeInv;\nuniform vec4 uViewport;\n\nvarying vec2 vUv;\nvarying vec4 vOffset[3];\n\nvoid SMAAEdgeDetectionVS(vec2 texCoord) {\n    vOffset[0] = texCoord.xyxy + uTexSizeInv.xyxy * vec4(-1.0, 0.0, 0.0, 1.0); // WebGL port note: Changed sign in W component\n    vOffset[1] = texCoord.xyxy + uTexSizeInv.xyxy * vec4(1.0, 0.0, 0.0, -1.0); // WebGL port note: Changed sign in W component\n    vOffset[2] = texCoord.xyxy + uTexSizeInv.xyxy * vec4(-2.0, 0.0, 0.0, 2.0); // WebGL port note: Changed sign in W component\n}\n\nvoid main() {\n    vec2 scale = uViewport.zw * uTexSizeInv;\n    vec2 shift = uViewport.xy * uTexSizeInv;\n    vUv = (aPosition + 1.0) * 0.5 * scale + shift;\n    SMAAEdgeDetectionVS(vUv);\n    vec2 position = aPosition * uQuadScale - vec2(1.0, 1.0) + uQuadScale;\n    gl_Position = vec4(position, 0.0, 1.0);\n}\n";
//# sourceMappingURL=edges.vert.js.map

/***/ }),

/***/ "./lib/mol-gl/shader/smaa/weights.frag.js":
/*!************************************************!*\
  !*** ./lib/mol-gl/shader/smaa/weights.frag.js ***!
  \************************************************/
/*! exports provided: weights_frag */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "weights_frag", function() { return weights_frag; });
/**
 * Slightly adapted from https://github.com/mrdoob/three.js
 * MIT License Copyright (c) 2010-2020 three.js authors
 *
 * WebGL port of Subpixel Morphological Antialiasing (SMAA) v2.8
 * Preset: SMAA 1x Medium (with color edge detection)
 * https://github.com/iryoku/smaa/releases/tag/v2.8
 */
var weights_frag = "\nprecision highp float;\nprecision highp int;\nprecision highp sampler2D;\n\n#define SMAASampleLevelZeroOffset(tex, coord, offset) texture2D(tex, coord + float(offset) * uTexSizeInv, 0.0)\n\n#define SMAA_AREATEX_MAX_DISTANCE 16\n#define SMAA_AREATEX_PIXEL_SIZE (1.0 / vec2(160.0, 560.0))\n#define SMAA_AREATEX_SUBTEX_SIZE (1.0 / 7.0)\n\nuniform sampler2D tEdges;\nuniform sampler2D tArea;\nuniform sampler2D tSearch;\nuniform vec2 uTexSizeInv;\n\nvarying vec2 vUv;\nvarying vec4 vOffset[3];\nvarying vec2 vPixCoord;\n\n#if __VERSION__ == 100\n    vec2 round(vec2 x) {\n        return sign(x) * floor(abs(x) + 0.5);\n    }\n#endif\n\nfloat SMAASearchLength(sampler2D searchTex, vec2 e, float bias, float scale) {\n    // Not required if searchTex accesses are set to point:\n    // float2 SEARCH_TEX_PIXEL_SIZE = 1.0 / float2(66.0, 33.0);\n    // e = float2(bias, 0.0) + 0.5 * SEARCH_TEX_PIXEL_SIZE +\n    //     e * float2(scale, 1.0) * float2(64.0, 32.0) * SEARCH_TEX_PIXEL_SIZE;\n    e.r = bias + e.r * scale;\n    return 255.0 * texture2D(searchTex, e, 0.0).r;\n}\n\nfloat SMAASearchXLeft(sampler2D edgesTex, sampler2D searchTex, vec2 texCoord, float end) {\n    /**\n     * @PSEUDO_GATHER4\n     * This texCoord has been offset by (-0.25, -0.125) in the vertex shader to\n     * sample between edge, thus fetching four edges in a row.\n     * Sampling with different offsets in each direction allows to disambiguate\n     * which edges are active from the four fetched ones.\n     */\n    vec2 e = vec2(0.0, 1.0);\n\n    for (int i = 0; i < dMaxSearchSteps; i++) { // WebGL port note: Changed while to for\n        e = texture2D( edgesTex, texCoord, 0.0).rg;\n        texCoord -= vec2(2.0, 0.0) * uTexSizeInv;\n        if (!(texCoord.x > end && e.g > 0.8281 && e.r == 0.0)) break;\n    }\n\n    // We correct the previous (-0.25, -0.125) offset we applied:\n    texCoord.x += 0.25 * uTexSizeInv.x;\n\n    // The searches are bias by 1, so adjust the coords accordingly:\n    texCoord.x += uTexSizeInv.x;\n\n    // Disambiguate the length added by the last step:\n    texCoord.x += 2.0 * uTexSizeInv.x; // Undo last step\n    texCoord.x -= uTexSizeInv.x * SMAASearchLength(searchTex, e, 0.0, 0.5);\n\n    return texCoord.x;\n}\n\nfloat SMAASearchXRight(sampler2D edgesTex, sampler2D searchTex, vec2 texCoord, float end) {\n    vec2 e = vec2( 0.0, 1.0 );\n\n    for (int i = 0; i < dMaxSearchSteps; i++) { // WebGL port note: Changed while to for\n        e = texture2D(edgesTex, texCoord, 0.0).rg;\n        texCoord += vec2(2.0, 0.0) * uTexSizeInv;\n        if (!(texCoord.x < end && e.g > 0.8281 && e.r == 0.0)) break;\n    }\n\n    texCoord.x -= 0.25 * uTexSizeInv.x;\n    texCoord.x -= uTexSizeInv.x;\n    texCoord.x -= 2.0 * uTexSizeInv.x;\n    texCoord.x += uTexSizeInv.x * SMAASearchLength( searchTex, e, 0.5, 0.5 );\n\n    return texCoord.x;\n}\n\nfloat SMAASearchYUp(sampler2D edgesTex, sampler2D searchTex, vec2 texCoord, float end) {\n    vec2 e = vec2( 1.0, 0.0 );\n\n    for (int i = 0; i < dMaxSearchSteps; i++) { // WebGL port note: Changed while to for\n        e = texture2D(edgesTex, texCoord, 0.0).rg;\n        texCoord += vec2(0.0, 2.0) * uTexSizeInv; // WebGL port note: Changed sign\n        if (!(texCoord.y > end && e.r > 0.8281 && e.g == 0.0)) break;\n    }\n\n    texCoord.y -= 0.25 * uTexSizeInv.y; // WebGL port note: Changed sign\n    texCoord.y -= uTexSizeInv.y; // WebGL port note: Changed sign\n    texCoord.y -= 2.0 * uTexSizeInv.y; // WebGL port note: Changed sign\n    texCoord.y += uTexSizeInv.y * SMAASearchLength(searchTex, e.gr, 0.0, 0.5); // WebGL port note: Changed sign\n\n    return texCoord.y;\n}\n\nfloat SMAASearchYDown(sampler2D edgesTex, sampler2D searchTex, vec2 texCoord, float end) {\n    vec2 e = vec2( 1.0, 0.0 );\n\n    for (int i = 0; i < dMaxSearchSteps; i++) { // WebGL port note: Changed while to for\n        e = texture2D(edgesTex, texCoord, 0.0).rg;\n        texCoord -= vec2( 0.0, 2.0 ) * uTexSizeInv; // WebGL port note: Changed sign\n        if (!(texCoord.y < end && e.r > 0.8281 && e.g == 0.0)) break;\n    }\n\n    texCoord.y += 0.25 * uTexSizeInv.y; // WebGL port note: Changed sign\n    texCoord.y += uTexSizeInv.y; // WebGL port note: Changed sign\n    texCoord.y += 2.0 * uTexSizeInv.y; // WebGL port note: Changed sign\n    texCoord.y -= uTexSizeInv.y * SMAASearchLength(searchTex, e.gr, 0.5, 0.5); // WebGL port note: Changed sign\n\n    return texCoord.y;\n}\n\nvec2 SMAAArea(sampler2D areaTex, vec2 dist, float e1, float e2, float offset) {\n    // Rounding prevents precision errors of bilinear filtering:\n    vec2 texCoord = float(SMAA_AREATEX_MAX_DISTANCE) * round(4.0 * vec2(e1, e2)) + dist;\n\n    // We do a scale and bias for mapping to texel space:\n    texCoord = SMAA_AREATEX_PIXEL_SIZE * texCoord + (0.5 * SMAA_AREATEX_PIXEL_SIZE);\n\n    // Move to proper place, according to the subpixel offset:\n    texCoord.y += SMAA_AREATEX_SUBTEX_SIZE * offset;\n\n    return texture2D(areaTex, texCoord, 0.0).rg;\n}\n\nvec4 SMAABlendingWeightCalculationPS(vec2 texCoord, vec2 pixCoord, vec4 offset[3], sampler2D edgesTex, sampler2D areaTex, sampler2D searchTex, ivec4 subsampleIndices) {\n    vec4 weights = vec4(0.0, 0.0, 0.0, 0.0);\n\n    vec2 e = texture2D(edgesTex, texCoord).rg;\n\n    if (e.g > 0.0) { // Edge at north\n        vec2 d;\n\n        // Find the distance to the left:\n        vec2 coords;\n        coords.x = SMAASearchXLeft(edgesTex, searchTex, offset[0].xy, offset[2].x );\n        coords.y = offset[1].y; // offset[1].y = texCoord.y - 0.25 * uTexSizeInv.y (@CROSSING_OFFSET)\n        d.x = coords.x;\n\n        // Now fetch the left crossing edges, two at a time using bilinear\n        // filtering. Sampling at -0.25 (see @CROSSING_OFFSET) enables to\n        // discern what value each edge has:\n        float e1 = texture2D(edgesTex, coords, 0.0).r;\n\n        // Find the distance to the right:\n        coords.x = SMAASearchXRight(edgesTex, searchTex, offset[0].zw, offset[2].y);\n        d.y = coords.x;\n\n        // We want the distances to be in pixel units (doing this here allow to\n        // better interleave arithmetic and memory accesses):\n        d = d / uTexSizeInv.x - pixCoord.x;\n\n        // SMAAArea below needs a sqrt, as the areas texture is compressed\n        // quadratically:\n        vec2 sqrt_d = sqrt(abs(d));\n\n        // Fetch the right crossing edges:\n        coords.y -= 1.0 * uTexSizeInv.y; // WebGL port note: Added\n        float e2 = SMAASampleLevelZeroOffset(edgesTex, coords, ivec2(1, 0)).r;\n\n        // Ok, we know how this pattern looks like, now it is time for getting\n        // the actual area:\n        weights.rg = SMAAArea(areaTex, sqrt_d, e1, e2, float(subsampleIndices.y));\n    }\n\n    if (e.r > 0.0) { // Edge at west\n        vec2 d;\n\n        // Find the distance to the top:\n        vec2 coords;\n\n        coords.y = SMAASearchYUp(edgesTex, searchTex, offset[1].xy, offset[2].z );\n        coords.x = offset[0].x; // offset[1].x = texCoord.x - 0.25 * uTexSizeInv.x;\n        d.x = coords.y;\n\n        // Fetch the top crossing edges:\n        float e1 = texture2D(edgesTex, coords, 0.0).g;\n\n        // Find the distance to the bottom:\n        coords.y = SMAASearchYDown(edgesTex, searchTex, offset[1].zw, offset[2].w);\n        d.y = coords.y;\n\n        // We want the distances to be in pixel units:\n        d = d / uTexSizeInv.y - pixCoord.y;\n\n        // SMAAArea below needs a sqrt, as the areas texture is compressed\n        // quadratically:\n        vec2 sqrt_d = sqrt(abs(d));\n\n        // Fetch the bottom crossing edges:\n        coords.y -= 1.0 * uTexSizeInv.y; // WebGL port note: Added\n        float e2 = SMAASampleLevelZeroOffset(edgesTex, coords, ivec2(0, 1)).g;\n\n        // Get the area for this direction:\n        weights.ba = SMAAArea(areaTex, sqrt_d, e1, e2, float(subsampleIndices.x));\n    }\n\n    return weights;\n}\n\nvoid main() {\n    gl_FragColor = SMAABlendingWeightCalculationPS(vUv, vPixCoord, vOffset, tEdges, tArea, tSearch, ivec4(0.0));\n}\n";
//# sourceMappingURL=weights.frag.js.map

/***/ }),

/***/ "./lib/mol-gl/shader/smaa/weights.vert.js":
/*!************************************************!*\
  !*** ./lib/mol-gl/shader/smaa/weights.vert.js ***!
  \************************************************/
/*! exports provided: weights_vert */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "weights_vert", function() { return weights_vert; });
/**
 * Slightly adapted from https://github.com/mrdoob/three.js
 * MIT License Copyright (c) 2010-2020 three.js authors
 *
 * WebGL port of Subpixel Morphological Antialiasing (SMAA) v2.8
 * Preset: SMAA 1x Medium (with color edge detection)
 * https://github.com/iryoku/smaa/releases/tag/v2.8
 */
var weights_vert = "\nprecision highp float;\n\nattribute vec2 aPosition;\nuniform vec2 uQuadScale;\n\nuniform vec2 uTexSizeInv;\nuniform vec4 uViewport;\n\nvarying vec2 vUv;\nvarying vec4 vOffset[3];\nvarying vec2 vPixCoord;\n\nvoid SMAABlendingWeightCalculationVS(vec2 texCoord) {\n    vPixCoord = texCoord / uTexSizeInv;\n\n    // We will use these offsets for the searches later on (see @PSEUDO_GATHER4):\n    vOffset[0] = texCoord.xyxy + uTexSizeInv.xyxy * vec4(-0.25, 0.125, 1.25, 0.125); // WebGL port note: Changed sign in Y and W components\n    vOffset[1] = texCoord.xyxy + uTexSizeInv.xyxy * vec4(-0.125, 0.25, -0.125, -1.25); // WebGL port note: Changed sign in Y and W components\n\n    // And these for the searches, they indicate the ends of the loops:\n    vOffset[2] = vec4(vOffset[0].xz, vOffset[1].yw) + vec4(-2.0, 2.0, -2.0, 2.0) * uTexSizeInv.xxyy * float(dMaxSearchSteps);\n}\n\nvoid main() {\n    vec2 scale = uViewport.zw * uTexSizeInv;\n    vec2 shift = uViewport.xy * uTexSizeInv;\n    vUv = (aPosition + 1.0) * 0.5 * scale + shift;\n    SMAABlendingWeightCalculationVS(vUv);\n    vec2 position = aPosition * uQuadScale - vec2(1.0, 1.0) + uQuadScale;\n    gl_Position = vec4(position, 0.0, 1.0);\n}\n";
//# sourceMappingURL=weights.vert.js.map

/***/ }),

/***/ "./lib/mol-gl/shader/spheres.frag.js":
/*!*******************************************!*\
  !*** ./lib/mol-gl/shader/spheres.frag.js ***!
  \*******************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/**
 * Copyright (c) 2019-2020 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */
/* harmony default export */ __webpack_exports__["default"] = ("\nprecision highp float;\nprecision highp int;\n\n#include common\n#include common_frag_params\n#include color_frag_params\n#include light_frag_params\n#include common_clip\n#include wboit_params\n\nvarying float vRadius;\nvarying float vRadiusSq;\nvarying vec3 vPoint;\nvarying vec3 vPointViewPosition;\n\nvec3 cameraPos;\nvec3 cameraNormal;\n\nbool Impostor(out vec3 cameraPos, out vec3 cameraNormal){\n    vec3 cameraSpherePos = -vPointViewPosition;\n    cameraSpherePos.z += vRadius;\n\n    vec3 rayOrigin = mix(vec3(0.0, 0.0, 0.0), vPoint, uIsOrtho);\n    vec3 rayDirection = mix(normalize(vPoint), vec3(0.0, 0.0, 1.0), uIsOrtho);\n    vec3 cameraSphereDir = mix(cameraSpherePos, rayOrigin - cameraSpherePos, uIsOrtho);\n\n    float B = dot(rayDirection, cameraSphereDir);\n    float det = B * B + vRadiusSq - dot(cameraSphereDir, cameraSphereDir);\n\n    if (det < 0.0){\n        discard;\n        return false;\n    }\n\n    float sqrtDet = sqrt(det);\n    float posT = mix(B + sqrtDet, B + sqrtDet, uIsOrtho);\n    float negT = mix(B - sqrtDet, sqrtDet - B, uIsOrtho);\n\n    cameraPos = rayDirection * negT + rayOrigin;\n\n\n    if (calcDepth(cameraPos) <= 0.0) {\n        cameraPos = rayDirection * posT + rayOrigin;\n        interior = true;\n    } else {\n        interior = false;\n    }\n\n    cameraNormal = normalize(cameraPos - cameraSpherePos);\n    cameraNormal *= float(!interior) * 2.0 - 1.0;\n\n    return !interior;\n}\n\nvoid main(void){\n    #include clip_pixel\n\n    bool flag = Impostor(cameraPos, cameraNormal);\n    #ifndef dDoubleSided\n        if (interior)\n            discard;\n    #endif\n\n    vec3 vViewPosition = cameraPos;\n    gl_FragDepthEXT = calcDepth(vViewPosition);\n    if (!flag && gl_FragDepthEXT >= 0.0) {\n        gl_FragDepthEXT = 0.0 + (0.0000001 / vRadius);\n    }\n\n    // bugfix (mac only?)\n    if (gl_FragDepthEXT < 0.0) discard;\n    if (gl_FragDepthEXT > 1.0) discard;\n\n    float fragmentDepth = gl_FragDepthEXT;\n    #include assign_material_color\n\n    #if defined(dRenderVariant_pick)\n        #include check_picking_alpha\n        gl_FragColor = material;\n    #elif defined(dRenderVariant_depth)\n        gl_FragColor = material;\n    #elif defined(dRenderVariant_color)\n        #ifdef dIgnoreLight\n            gl_FragColor = material;\n        #else\n            vec3 normal = -cameraNormal;\n            #include apply_light_color\n        #endif\n\n        #include apply_interior_color\n        #include apply_marker_color\n        #include apply_fog\n        #include wboit_write\n    #endif\n}\n");
//# sourceMappingURL=spheres.frag.js.map

/***/ }),

/***/ "./lib/mol-gl/shader/spheres.vert.js":
/*!*******************************************!*\
  !*** ./lib/mol-gl/shader/spheres.vert.js ***!
  \*******************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/**
 * Copyright (c) 2019-2020 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */
/* harmony default export */ __webpack_exports__["default"] = ("\nprecision highp float;\nprecision highp int;\n\n#include common\n#include read_from_texture\n#include common_vert_params\n#include color_vert_params\n#include size_vert_params\n#include common_clip\n\nuniform mat4 uModelView;\nuniform mat4 uInvProjection;\n\nattribute vec3 aPosition;\nattribute vec2 aMapping;\nattribute mat4 aTransform;\nattribute float aInstance;\nattribute float aGroup;\n\nvarying float vRadius;\nvarying float vRadiusSq;\nvarying vec3 vPoint;\nvarying vec3 vPointViewPosition;\n\n#include matrix_scale\n\nconst mat4 D = mat4(\n    1.0, 0.0, 0.0, 0.0,\n    0.0, 1.0, 0.0, 0.0,\n    0.0, 0.0, 1.0, 0.0,\n    0.0, 0.0, 0.0, -1.0\n);\n\n/**\n * Compute point size and center using the technique described in:\n * \"GPU-Based Ray-Casting of Quadratic Surfaces\" http://dl.acm.org/citation.cfm?id=2386396\n * by Christian Sigg, Tim Weyrich, Mario Botsch, Markus Gross.\n */\nvoid quadraticProjection(const in float radius, const in vec3 position){\n    vec2 xbc, ybc;\n\n    mat4 T = mat4(\n        radius, 0.0, 0.0, 0.0,\n        0.0, radius, 0.0, 0.0,\n        0.0, 0.0, radius, 0.0,\n        position.x, position.y, position.z, 1.0\n    );\n\n    mat4 R = transpose4(uProjection * uModelView * aTransform * T);\n    float A = dot(R[3], D * R[3]);\n    float B = -2.0 * dot(R[0], D * R[3]);\n    float C = dot(R[0], D * R[0]);\n    xbc[0] = (-B - sqrt(B * B - 4.0 * A * C)) / (2.0 * A);\n    xbc[1] = (-B + sqrt(B * B - 4.0 * A * C)) / (2.0 * A);\n    float sx = abs(xbc[0] - xbc[1]) * 0.5;\n\n    A = dot(R[3], D * R[3]);\n    B = -2.0 * dot(R[1], D * R[3]);\n    C = dot(R[1], D * R[1]);\n    ybc[0] = (-B - sqrt(B * B - 4.0 * A * C)) / (2.0 * A);\n    ybc[1] = (-B + sqrt(B * B - 4.0 * A * C)) / (2.0 * A);\n    float sy = abs(ybc[0] - ybc[1]) * 0.5;\n\n    gl_Position.xy = vec2(0.5 * (xbc.x + xbc.y), 0.5 * (ybc.x + ybc.y));\n    gl_Position.xy -= aMapping * vec2(sx, sy);\n    gl_Position.xy *= gl_Position.w;\n}\n\n\nvoid main(void){\n    #include assign_group\n    #include assign_color_varying\n    #include assign_marker_varying\n    #include assign_clipping_varying\n    #include assign_size\n\n    vRadius = size * matrixScale(uModelView);\n\n    vec4 position4 = vec4(aPosition, 1.0);\n    vec4 mvPosition = uModelView * aTransform * position4;\n    mvPosition.z -= vRadius; // avoid clipping, added again in fragment shader\n\n    gl_Position = uProjection * vec4(mvPosition.xyz, 1.0);\n    quadraticProjection(size, aPosition);\n\n    vRadiusSq = vRadius * vRadius;\n    vec4 vPoint4 = uInvProjection * gl_Position;\n    vPoint = vPoint4.xyz / vPoint4.w;\n    vPointViewPosition = -mvPosition.xyz / mvPosition.w;\n\n    vModelPosition = (uModel * aTransform * position4).xyz; // for clipping in frag shader\n\n    #include clip_instance\n}\n");
//# sourceMappingURL=spheres.vert.js.map

/***/ }),

/***/ "./lib/mol-gl/shader/ssao-blur.frag.js":
/*!*********************************************!*\
  !*** ./lib/mol-gl/shader/ssao-blur.frag.js ***!
  \*********************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/**
 * Copyright (c) 2019-2020 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author Áron Samuel Kovács <aron.kovacs@mail.muni.cz>
 */
/* harmony default export */ __webpack_exports__["default"] = ("\nprecision highp float;\nprecision highp int;\nprecision highp sampler2D;\n\nuniform sampler2D tSsaoDepth;\nuniform vec2 uTexSize;\n\nuniform float uKernel[dOcclusionKernelSize];\n\nuniform float uBlurDirectionX;\nuniform float uBlurDirectionY;\n\nuniform float uMaxPossibleViewZDiff;\n\nuniform float uNear;\nuniform float uFar;\n\n#include common\n\nfloat getViewZ(const in float depth) {\n    #if dOrthographic == 1\n        return orthographicDepthToViewZ(depth, uNear, uFar);\n    #else\n        return perspectiveDepthToViewZ(depth, uNear, uFar);\n    #endif\n}\n\nbool isBackground(const in float depth) {\n    return depth == 1.0;\n}\n\nvoid main(void) {\n    vec2 coords = gl_FragCoord.xy / uTexSize;\n\n    vec2 packedDepth = texture2D(tSsaoDepth, coords).zw;\n\n    float selfDepth = unpackRGToUnitInterval(packedDepth);\n    // if background and if second pass\n    if (isBackground(selfDepth) && uBlurDirectionY != 0.0) {\n       gl_FragColor = vec4(packUnitIntervalToRG(1.0), packedDepth);\n       return;\n    }\n\n    float selfViewZ = getViewZ(selfDepth);\n\n    vec2 offset = vec2(uBlurDirectionX, uBlurDirectionY) / uTexSize;\n\n    float sum = 0.0;\n    float kernelSum = 0.0;\n    // only if kernelSize is odd\n    for (int i = -dOcclusionKernelSize / 2; i <= dOcclusionKernelSize / 2; i++) {\n        vec2 sampleCoords = coords + float(i) * offset;\n\n        vec4 sampleSsaoDepth = texture2D(tSsaoDepth, sampleCoords);\n\n        float sampleDepth = unpackRGToUnitInterval(sampleSsaoDepth.zw);\n        if (isBackground(sampleDepth)) {\n            continue;\n        }\n\n        if (abs(float(i)) > 1.0) { // abs is not defined for int in webgl1\n            float sampleViewZ = getViewZ(sampleDepth);\n            if (abs(selfViewZ - sampleViewZ) > uMaxPossibleViewZDiff) {\n                continue;\n            }\n        }\n\n        float kernel = uKernel[int(abs(float(i)))]; // abs is not defined for int in webgl1\n        float sampleValue = unpackRGToUnitInterval(sampleSsaoDepth.xy);\n\n        sum += kernel * sampleValue;\n        kernelSum += kernel;\n    }\n\n    gl_FragColor = vec4(packUnitIntervalToRG(sum / kernelSum), packedDepth);\n}\n");
//# sourceMappingURL=ssao-blur.frag.js.map

/***/ }),

/***/ "./lib/mol-gl/shader/ssao.frag.js":
/*!****************************************!*\
  !*** ./lib/mol-gl/shader/ssao.frag.js ***!
  \****************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/**
 * Copyright (c) 2019-2020 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 * @author Áron Samuel Kovács <aron.kovacs@mail.muni.cz>
 */
/* harmony default export */ __webpack_exports__["default"] = ("\nprecision highp float;\nprecision highp int;\nprecision highp sampler2D;\n\n#include common\n\nuniform sampler2D tDepth;\n\nuniform vec3 uSamples[dNSamples];\n\nuniform mat4 uProjection;\nuniform mat4 uInvProjection;\n\nuniform vec2 uTexSize;\n\nuniform float uRadius;\nuniform float uBias;\n\nfloat smootherstep(float edge0, float edge1, float x) {\n    x = clamp((x - edge0) / (edge1 - edge0), 0.0, 1.0);\n    return x * x * x * (x * (x * 6.0 - 15.0) + 10.0);\n}\n\nfloat noise(const in vec2 coords) {\n    float a = 12.9898;\n    float b = 78.233;\n    float c = 43758.5453;\n    float dt = dot(coords, vec2(a,b));\n    float sn = mod(dt, PI);\n    return abs(fract(sin(sn) * c)); // is abs necessary?\n}\n\nvec2 getNoiseVec2(const in vec2 coords) {\n    return vec2(noise(coords), noise(coords + vec2(PI, 2.71828)));\n}\n\nbool isBackground(const in float depth) {\n    return depth == 1.0;\n}\n\nfloat getDepth(const in vec2 coords) {\n    return unpackRGBAToDepth(texture2D(tDepth, coords));\n}\n\nvec3 normalFromDepth(const in float depth, const in float depth1, const in float depth2, vec2 offset1, vec2 offset2) {\n    vec3 p1 = vec3(offset1, depth1 - depth);\n    vec3 p2 = vec3(offset2, depth2 - depth);\n\n    vec3 normal = cross(p1, p2);\n    normal.z = -normal.z;\n\n    return normalize(normal);\n}\n\n// StarCraft II Ambient Occlusion by [Filion and McNaughton 2008]\nvoid main(void) {\n    vec2 invTexSize = 1.0 / uTexSize;\n    vec2 selfCoords = gl_FragCoord.xy * invTexSize;\n\n    float selfDepth = getDepth(selfCoords);\n    vec2 selfPackedDepth = packUnitIntervalToRG(selfDepth);\n\n    if (isBackground(selfDepth)) {\n        gl_FragColor = vec4(packUnitIntervalToRG(0.0), selfPackedDepth);\n        return;\n    }\n\n    vec2 offset1 = vec2(0.0, invTexSize.y);\n    vec2 offset2 = vec2(invTexSize.x, 0.0);\n\n    float selfDepth1 = getDepth(selfCoords + offset1);\n    float selfDepth2 = getDepth(selfCoords + offset2);\n\n    vec3 selfViewNormal = normalFromDepth(selfDepth, selfDepth1, selfDepth2, offset1, offset2);\n    vec3 selfViewPos = screenSpaceToViewSpace(vec3(selfCoords, selfDepth), uInvProjection);\n\n    vec3 randomVec = normalize(vec3(getNoiseVec2(selfCoords) * 2.0 - 1.0, 0.0));\n\n    vec3 tangent = normalize(randomVec - selfViewNormal * dot(randomVec, selfViewNormal));\n    vec3 bitangent = cross(selfViewNormal, tangent);\n    mat3 TBN = mat3(tangent, bitangent, selfViewNormal);\n\n    float occlusion = 0.0;\n    for(int i = 0; i < dNSamples; i++){\n        vec3 sampleViewPos = TBN * uSamples[i];\n        sampleViewPos = selfViewPos + sampleViewPos * uRadius;\n\n        vec4 offset = vec4(sampleViewPos, 1.0);\n        offset = uProjection * offset;\n        offset.xyz = (offset.xyz / offset.w) * 0.5 + 0.5;\n\n        float sampleViewZ = screenSpaceToViewSpace(vec3(offset.xy, getDepth(offset.xy)), uInvProjection).z;\n\n        occlusion += step(sampleViewPos.z + 0.025, sampleViewZ) * smootherstep(0.0, 1.0, uRadius / abs(selfViewPos.z - sampleViewZ));\n    }\n    occlusion = 1.0 - (uBias * occlusion / float(dNSamples));\n\n    vec2 packedOcclusion = packUnitIntervalToRG(occlusion);\n\n    gl_FragColor = vec4(packedOcclusion, selfPackedDepth);\n}\n");
//# sourceMappingURL=ssao.frag.js.map

/***/ }),

/***/ "./lib/mol-gl/shader/text.frag.js":
/*!****************************************!*\
  !*** ./lib/mol-gl/shader/text.frag.js ***!
  \****************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/**
 * Copyright (c) 2019-2020 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */
/* harmony default export */ __webpack_exports__["default"] = ("\nprecision highp float;\nprecision highp int;\n\n#include common\n#include common_frag_params\n#include color_frag_params\n#include common_clip\n#include wboit_params\n\nuniform sampler2D tFont;\n\nuniform vec3 uBorderColor;\nuniform float uBorderWidth;\nuniform vec3 uBackgroundColor;\nuniform float uBackgroundOpacity;\n\nvarying vec2 vTexCoord;\n\nconst float smoothness = 32.0;\nconst float gamma = 2.2;\n\nvoid main2(){\n    gl_FragColor = vec4(1.0, 0.0, 0.0, 1.0);\n}\n\nvoid main(){\n    #include clip_pixel\n\n    float fragmentDepth = gl_FragCoord.z;\n    bool interior = false;\n    #include assign_material_color\n\n    if (vTexCoord.x > 1.0) {\n        gl_FragColor = vec4(uBackgroundColor, uBackgroundOpacity * material.a);\n    } else {\n        // retrieve signed distance\n        float sdf = texture2D(tFont, vTexCoord).a + uBorderWidth;\n\n        // perform adaptive anti-aliasing of the edges\n        float w = clamp(smoothness * (abs(dFdx(vTexCoord.x)) + abs(dFdy(vTexCoord.y))), 0.0, 0.5);\n        float a = smoothstep(0.5 - w, 0.5 + w, sdf);\n\n        // gamma correction for linear attenuation\n        a = pow(a, 1.0 / gamma);\n\n        if (a < 0.5) discard;\n        material.a *= a;\n\n        // add border\n        float t = 0.5 + uBorderWidth;\n        if (uBorderWidth > 0.0 && sdf < t) {\n            material.xyz = mix(uBorderColor, material.xyz, smoothstep(t - w, t, sdf));\n        }\n\n        gl_FragColor = material;\n    }\n\n    #if defined(dRenderVariant_pick)\n        #include check_picking_alpha\n    #elif defined(dRenderVariant_depth)\n        gl_FragColor = material;\n    #elif defined(dRenderVariant_color)\n        #include apply_marker_color\n        #include apply_fog\n        #include wboit_write\n    #endif\n}\n");
//# sourceMappingURL=text.frag.js.map

/***/ }),

/***/ "./lib/mol-gl/shader/text.vert.js":
/*!****************************************!*\
  !*** ./lib/mol-gl/shader/text.vert.js ***!
  \****************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/**
 * Copyright (c) 2019-2020 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */
/* harmony default export */ __webpack_exports__["default"] = ("\nprecision highp float;\nprecision highp int;\n\n#include common\n#include read_from_texture\n#include common_vert_params\n#include color_vert_params\n#include size_vert_params\n#include common_clip\n\nuniform mat4 uModelView;\n\nattribute vec3 aPosition;\nattribute vec2 aMapping;\nattribute float aDepth;\nattribute vec2 aTexCoord;\nattribute mat4 aTransform;\nattribute float aInstance;\nattribute float aGroup;\n\nuniform float uOffsetX;\nuniform float uOffsetY;\nuniform float uOffsetZ;\n\n// uniform bool ortho;\nuniform float uPixelRatio;\nuniform float uViewportHeight;\n\nvarying vec2 vTexCoord;\n\n#include matrix_scale\n\nvoid main(void){\n    #include assign_group\n    #include assign_color_varying\n    #include assign_marker_varying\n    #include assign_clipping_varying\n    #include assign_size\n\n    vTexCoord = aTexCoord;\n\n    float scale = matrixScale(uModelView);\n\n    float offsetX = uOffsetX * scale;\n    float offsetY = uOffsetY * scale;\n    float offsetZ = (uOffsetZ + aDepth * 0.95) * scale;\n\n    vec4 position4 = vec4(aPosition, 1.0);\n    vec4 mvPosition = uModelView * aTransform * position4;\n\n    vModelPosition = (uModel * aTransform * position4).xyz; // for clipping in frag shader\n\n    // TODO\n    // #ifdef FIXED_SIZE\n    //     if (ortho) {\n    //         scale /= pixelRatio * ((uViewportHeight / 2.0) / -uCameraPosition.z) * 0.1;\n    //     } else {\n    //         scale /= pixelRatio * ((uViewportHeight / 2.0) / -mvPosition.z) * 0.1;\n    //     }\n    // #endif\n\n    vec4 mvCorner = vec4(mvPosition.xyz, 1.0);\n\n    if (vTexCoord.x == 10.0) { // indicates background plane\n        // move a bit to the back, taking distance to camera into account to avoid z-fighting\n        offsetZ -= 0.001 * distance(uCameraPosition, (uProjection * mvCorner).xyz);\n    }\n\n    mvCorner.xy += aMapping * size * scale;\n    mvCorner.x += offsetX;\n    mvCorner.y += offsetY;\n\n    // TODO\n    // if(ortho){\n    //     mvCorner.xyz += normalize(-uCameraPosition) * offsetZ;\n    // } else {\n    //     mvCorner.xyz += normalize(-mvCorner.xyz) * offsetZ;\n    // }\n    mvCorner.xyz += normalize(-mvCorner.xyz) * offsetZ;\n\n    gl_Position = uProjection * mvCorner;\n\n    vViewPosition = -mvCorner.xyz;\n\n    #include clip_instance\n}\n");
//# sourceMappingURL=text.vert.js.map

/***/ }),

/***/ "./lib/mol-gl/webgl/buffer.js":
/*!************************************!*\
  !*** ./lib/mol-gl/webgl/buffer.js ***!
  \************************************/
/*! exports provided: getUsageHint, getDataType, getBufferType, getAttribType, createAttributeBuffer, createAttributeBuffers, createElementsBuffer */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getUsageHint", function() { return getUsageHint; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getDataType", function() { return getDataType; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getBufferType", function() { return getBufferType; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getAttribType", function() { return getAttribType; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createAttributeBuffer", function() { return createAttributeBuffer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createAttributeBuffers", function() { return createAttributeBuffers; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createElementsBuffer", function() { return createElementsBuffer; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _mol_util_id_factory__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../mol-util/id-factory */ "./lib/mol-util/id-factory.js");
/**
 * Copyright (c) 2018-2020 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */


var getNextBufferId = Object(_mol_util_id_factory__WEBPACK_IMPORTED_MODULE_1__["idFactory"])();
function getUsageHint(gl, usageHint) {
    switch (usageHint) {
        case 'static': return gl.STATIC_DRAW;
        case 'dynamic': return gl.DYNAMIC_DRAW;
        case 'stream': return gl.STREAM_DRAW;
    }
}
function getDataType(gl, dataType) {
    switch (dataType) {
        case 'uint8': return gl.UNSIGNED_BYTE;
        case 'int8': return gl.BYTE;
        case 'uint16': return gl.UNSIGNED_SHORT;
        case 'int16': return gl.SHORT;
        case 'uint32': return gl.UNSIGNED_INT;
        case 'int32': return gl.INT;
        case 'float32': return gl.FLOAT;
    }
}
function dataTypeFromArray(gl, array) {
    if (array instanceof Uint8Array) {
        return gl.UNSIGNED_BYTE;
    }
    else if (array instanceof Int8Array) {
        return gl.BYTE;
    }
    else if (array instanceof Uint16Array) {
        return gl.UNSIGNED_SHORT;
    }
    else if (array instanceof Int16Array) {
        return gl.SHORT;
    }
    else if (array instanceof Uint32Array) {
        return gl.UNSIGNED_INT;
    }
    else if (array instanceof Int32Array) {
        return gl.INT;
    }
    else if (array instanceof Float32Array) {
        return gl.FLOAT;
    }
    else {
        throw new Error('Should nevver happen');
    }
}
function getBufferType(gl, bufferType) {
    switch (bufferType) {
        case 'attribute': return gl.ARRAY_BUFFER;
        case 'elements': return gl.ELEMENT_ARRAY_BUFFER;
        case 'uniform': return gl.UNIFORM_BUFFER;
    }
}
function getBuffer(gl) {
    var buffer = gl.createBuffer();
    if (buffer === null) {
        throw new Error('Could not create WebGL buffer');
    }
    return buffer;
}
function createBuffer(gl, array, usageHint, bufferType) {
    var _buffer = getBuffer(gl);
    var _usageHint = getUsageHint(gl, usageHint);
    var _bufferType = getBufferType(gl, bufferType);
    var _dataType = dataTypeFromArray(gl, array);
    var _bpe = array.BYTES_PER_ELEMENT;
    var _length = array.length;
    function updateData(array) {
        gl.bindBuffer(_bufferType, _buffer);
        gl.bufferData(_bufferType, array, _usageHint);
    }
    updateData(array);
    var destroyed = false;
    return {
        id: getNextBufferId(),
        _usageHint: _usageHint,
        _bufferType: _bufferType,
        _dataType: _dataType,
        _bpe: _bpe,
        length: _length,
        getBuffer: function () { return _buffer; },
        updateData: updateData,
        updateSubData: function (array, offset, count) {
            gl.bindBuffer(_bufferType, _buffer);
            if (count - offset === array.length) {
                gl.bufferSubData(_bufferType, 0, array);
            }
            else {
                gl.bufferSubData(_bufferType, offset * _bpe, array.subarray(offset, offset + count));
            }
        },
        reset: function () {
            _buffer = getBuffer(gl);
            updateData(array);
        },
        destroy: function () {
            if (destroyed)
                return;
            gl.deleteBuffer(_buffer);
            destroyed = true;
        }
    };
}
function getAttribType(gl, kind, itemSize) {
    switch (kind) {
        case 'int32':
            switch (itemSize) {
                case 1: return gl.INT;
                case 2: return gl.INT_VEC2;
                case 3: return gl.INT_VEC3;
                case 4: return gl.INT_VEC4;
            }
            break;
        case 'float32':
            switch (itemSize) {
                case 1: return gl.FLOAT;
                case 2: return gl.FLOAT_VEC2;
                case 3: return gl.FLOAT_VEC3;
                case 4: return gl.FLOAT_VEC4;
                case 16: return gl.FLOAT_MAT4;
            }
            break;
    }
    throw new Error("unknown attribute type for kind '" + kind + "' and itemSize '" + itemSize + "'");
}
function createAttributeBuffer(gl, extensions, array, itemSize, divisor, usageHint) {
    if (usageHint === void 0) { usageHint = 'dynamic'; }
    var instancedArrays = extensions.instancedArrays;
    var buffer = createBuffer(gl, array, usageHint, 'attribute');
    var _bufferType = buffer._bufferType, _dataType = buffer._dataType, _bpe = buffer._bpe;
    return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, buffer), { bind: function (location) {
            gl.bindBuffer(_bufferType, buffer.getBuffer());
            if (itemSize === 16) {
                for (var i = 0; i < 4; ++i) {
                    gl.enableVertexAttribArray(location + i);
                    gl.vertexAttribPointer(location + i, 4, _dataType, false, 4 * 4 * _bpe, i * 4 * _bpe);
                    instancedArrays.vertexAttribDivisor(location + i, divisor);
                }
            }
            else {
                gl.enableVertexAttribArray(location);
                gl.vertexAttribPointer(location, itemSize, _dataType, false, 0, 0);
                instancedArrays.vertexAttribDivisor(location, divisor);
            }
        } });
}
function createAttributeBuffers(ctx, schema, values) {
    var buffers = [];
    Object.keys(schema).forEach(function (k) {
        var spec = schema[k];
        if (spec.type === 'attribute') {
            buffers[buffers.length] = [k, ctx.resources.attribute(values[k].ref.value, spec.itemSize, spec.divisor)];
        }
    });
    return buffers;
}
function createElementsBuffer(gl, array, usageHint) {
    if (usageHint === void 0) { usageHint = 'static'; }
    var buffer = createBuffer(gl, array, usageHint, 'elements');
    return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, buffer), { bind: function () {
            gl.bindBuffer(gl.ELEMENT_ARRAY_BUFFER, buffer.getBuffer());
        } });
}
//# sourceMappingURL=buffer.js.map

/***/ }),

/***/ "./lib/mol-gl/webgl/compat.js":
/*!************************************!*\
  !*** ./lib/mol-gl/webgl/compat.js ***!
  \************************************/
/*! exports provided: isWebGL, isWebGL2, getInstancedArrays, getStandardDerivatives, getElementIndexUint, getVertexArrayObject, getTextureFloat, getTextureFloatLinear, getTextureHalfFloat, getTextureHalfFloatLinear, getBlendMinMax, getFragDepth, getColorBufferFloat, getColorBufferHalfFloat, getDrawBuffers, getShaderTextureLod, getDepthTexture, getSRGB, testColorBuffer */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isWebGL", function() { return isWebGL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isWebGL2", function() { return isWebGL2; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getInstancedArrays", function() { return getInstancedArrays; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getStandardDerivatives", function() { return getStandardDerivatives; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getElementIndexUint", function() { return getElementIndexUint; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getVertexArrayObject", function() { return getVertexArrayObject; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getTextureFloat", function() { return getTextureFloat; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getTextureFloatLinear", function() { return getTextureFloatLinear; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getTextureHalfFloat", function() { return getTextureHalfFloat; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getTextureHalfFloatLinear", function() { return getTextureHalfFloatLinear; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getBlendMinMax", function() { return getBlendMinMax; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getFragDepth", function() { return getFragDepth; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getColorBufferFloat", function() { return getColorBufferFloat; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getColorBufferHalfFloat", function() { return getColorBufferHalfFloat; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getDrawBuffers", function() { return getDrawBuffers; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getShaderTextureLod", function() { return getShaderTextureLod; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getDepthTexture", function() { return getDepthTexture; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getSRGB", function() { return getSRGB; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "testColorBuffer", function() { return testColorBuffer; });
/* harmony import */ var _mol_util_debug__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../mol-util/debug */ "./lib/mol-util/debug.js");
/* harmony import */ var _context__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./context */ "./lib/mol-gl/webgl/context.js");
/* harmony import */ var _program__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./program */ "./lib/mol-gl/webgl/program.js");
/* harmony import */ var _shader__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./shader */ "./lib/mol-gl/webgl/shader.js");
/**
 * Copyright (c) 2018-2021 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */




function isWebGL(gl) {
    return typeof WebGLRenderingContext !== 'undefined' && gl instanceof WebGLRenderingContext;
}
function isWebGL2(gl) {
    return typeof WebGL2RenderingContext !== 'undefined' && gl instanceof WebGL2RenderingContext;
}
function getInstancedArrays(gl) {
    if (isWebGL2(gl)) {
        return {
            drawArraysInstanced: gl.drawArraysInstanced.bind(gl),
            drawElementsInstanced: gl.drawElementsInstanced.bind(gl),
            vertexAttribDivisor: gl.vertexAttribDivisor.bind(gl),
            VERTEX_ATTRIB_ARRAY_DIVISOR: gl.VERTEX_ATTRIB_ARRAY_DIVISOR
        };
    }
    else {
        var ext = gl.getExtension('ANGLE_instanced_arrays');
        if (ext === null)
            return null;
        return {
            drawArraysInstanced: ext.drawArraysInstancedANGLE.bind(ext),
            drawElementsInstanced: ext.drawElementsInstancedANGLE.bind(ext),
            vertexAttribDivisor: ext.vertexAttribDivisorANGLE.bind(ext),
            VERTEX_ATTRIB_ARRAY_DIVISOR: ext.VERTEX_ATTRIB_ARRAY_DIVISOR_ANGLE
        };
    }
}
function getStandardDerivatives(gl) {
    if (isWebGL2(gl)) {
        return { FRAGMENT_SHADER_DERIVATIVE_HINT: gl.FRAGMENT_SHADER_DERIVATIVE_HINT };
    }
    else {
        var ext = gl.getExtension('OES_standard_derivatives');
        if (ext === null)
            return null;
        return { FRAGMENT_SHADER_DERIVATIVE_HINT: ext.FRAGMENT_SHADER_DERIVATIVE_HINT_OES };
    }
}
function getElementIndexUint(gl) {
    return isWebGL2(gl) ? {} : gl.getExtension('OES_element_index_uint');
}
function getVertexArrayObject(gl) {
    if (isWebGL2(gl)) {
        return {
            VERTEX_ARRAY_BINDING: gl.VERTEX_ARRAY_BINDING,
            bindVertexArray: gl.bindVertexArray.bind(gl),
            createVertexArray: gl.createVertexArray.bind(gl),
            deleteVertexArray: gl.deleteVertexArray.bind(gl),
            isVertexArray: gl.isVertexArray.bind(gl)
        };
    }
    else {
        var ext = gl.getExtension('OES_vertex_array_object');
        if (ext === null)
            return null;
        return {
            VERTEX_ARRAY_BINDING: ext.VERTEX_ARRAY_BINDING_OES,
            bindVertexArray: ext.bindVertexArrayOES.bind(ext),
            createVertexArray: ext.createVertexArrayOES.bind(ext),
            deleteVertexArray: ext.deleteVertexArrayOES.bind(ext),
            isVertexArray: ext.isVertexArrayOES.bind(ext)
        };
    }
}
function getTextureFloat(gl) {
    return isWebGL2(gl) ? {} : gl.getExtension('OES_texture_float');
}
function getTextureFloatLinear(gl) {
    return gl.getExtension('OES_texture_float_linear');
}
function getTextureHalfFloat(gl) {
    if (isWebGL2(gl)) {
        return { HALF_FLOAT: gl.HALF_FLOAT };
    }
    else {
        var ext = gl.getExtension('OES_texture_half_float');
        if (ext === null)
            return null;
        return { HALF_FLOAT: ext.HALF_FLOAT_OES };
    }
}
function getTextureHalfFloatLinear(gl) {
    return gl.getExtension('OES_texture_half_float_linear');
}
function getBlendMinMax(gl) {
    if (isWebGL2(gl)) {
        return { MIN: gl.MIN, MAX: gl.MAX };
    }
    else {
        var ext = gl.getExtension('EXT_blend_minmax');
        if (ext === null)
            return null;
        return { MIN: ext.MIN_EXT, MAX: ext.MAX_EXT };
    }
}
function getFragDepth(gl) {
    return isWebGL2(gl) ? {} : gl.getExtension('EXT_frag_depth');
}
function getColorBufferFloat(gl) {
    if (isWebGL2(gl)) {
        if (gl.getExtension('EXT_color_buffer_float') === null)
            return null;
        gl.getExtension('EXT_float_blend');
        return { RGBA32F: gl.RGBA32F };
    }
    else {
        var ext = gl.getExtension('WEBGL_color_buffer_float');
        if (ext === null) {
            // test as support may not be advertised by browsers
            gl.getExtension('OES_texture_float');
            return testColorBuffer(gl, gl.FLOAT) ? { RGBA32F: 0x8814 } : null;
        }
        gl.getExtension('EXT_float_blend');
        return { RGBA32F: ext.RGBA32F_EXT };
    }
}
function getColorBufferHalfFloat(gl) {
    if (isWebGL2(gl)) {
        if (gl.getExtension('EXT_color_buffer_half_float') === null)
            return null;
        gl.getExtension('EXT_float_blend');
        return { RGBA16F: gl.RGBA16F };
    }
    else {
        var ext = gl.getExtension('EXT_color_buffer_half_float');
        if (ext === null) {
            // test as support may not be advertised by browsers
            gl.getExtension('OES_texture_half_float');
            return testColorBuffer(gl, 0x8D61) ? { RGBA16F: 0x881A } : null;
        }
        gl.getExtension('EXT_float_blend');
        return { RGBA16F: ext.RGBA16F_EXT };
    }
}
function getDrawBuffers(gl) {
    if (isWebGL2(gl)) {
        return {
            drawBuffers: gl.drawBuffers.bind(gl),
            COLOR_ATTACHMENT0: gl.COLOR_ATTACHMENT0,
            COLOR_ATTACHMENT1: gl.COLOR_ATTACHMENT1,
            COLOR_ATTACHMENT2: gl.COLOR_ATTACHMENT2,
            COLOR_ATTACHMENT3: gl.COLOR_ATTACHMENT3,
            COLOR_ATTACHMENT4: gl.COLOR_ATTACHMENT4,
            COLOR_ATTACHMENT5: gl.COLOR_ATTACHMENT5,
            COLOR_ATTACHMENT6: gl.COLOR_ATTACHMENT6,
            COLOR_ATTACHMENT7: gl.COLOR_ATTACHMENT7,
            DRAW_BUFFER0: gl.DRAW_BUFFER0,
            DRAW_BUFFER1: gl.DRAW_BUFFER1,
            DRAW_BUFFER2: gl.DRAW_BUFFER2,
            DRAW_BUFFER3: gl.DRAW_BUFFER3,
            DRAW_BUFFER4: gl.DRAW_BUFFER4,
            DRAW_BUFFER5: gl.DRAW_BUFFER5,
            DRAW_BUFFER6: gl.DRAW_BUFFER6,
            DRAW_BUFFER7: gl.DRAW_BUFFER7,
            MAX_COLOR_ATTACHMENTS: gl.MAX_COLOR_ATTACHMENTS,
            MAX_DRAW_BUFFERS: gl.MAX_DRAW_BUFFERS,
        };
    }
    else {
        var ext = gl.getExtension('WEBGL_draw_buffers');
        if (ext === null)
            return null;
        return {
            drawBuffers: ext.drawBuffersWEBGL.bind(ext),
            COLOR_ATTACHMENT0: ext.COLOR_ATTACHMENT0_WEBGL,
            COLOR_ATTACHMENT1: ext.COLOR_ATTACHMENT1_WEBGL,
            COLOR_ATTACHMENT2: ext.COLOR_ATTACHMENT2_WEBGL,
            COLOR_ATTACHMENT3: ext.COLOR_ATTACHMENT3_WEBGL,
            COLOR_ATTACHMENT4: ext.COLOR_ATTACHMENT4_WEBGL,
            COLOR_ATTACHMENT5: ext.COLOR_ATTACHMENT5_WEBGL,
            COLOR_ATTACHMENT6: ext.COLOR_ATTACHMENT6_WEBGL,
            COLOR_ATTACHMENT7: ext.COLOR_ATTACHMENT7_WEBGL,
            DRAW_BUFFER0: ext.DRAW_BUFFER0_WEBGL,
            DRAW_BUFFER1: ext.DRAW_BUFFER1_WEBGL,
            DRAW_BUFFER2: ext.DRAW_BUFFER2_WEBGL,
            DRAW_BUFFER3: ext.DRAW_BUFFER3_WEBGL,
            DRAW_BUFFER4: ext.DRAW_BUFFER4_WEBGL,
            DRAW_BUFFER5: ext.DRAW_BUFFER5_WEBGL,
            DRAW_BUFFER6: ext.DRAW_BUFFER6_WEBGL,
            DRAW_BUFFER7: ext.DRAW_BUFFER7_WEBGL,
            MAX_COLOR_ATTACHMENTS: ext.MAX_COLOR_ATTACHMENTS_WEBGL,
            MAX_DRAW_BUFFERS: ext.MAX_DRAW_BUFFERS_WEBGL,
        };
    }
}
function getShaderTextureLod(gl) {
    return isWebGL2(gl) ? {} : gl.getExtension('EXT_shader_texture_lod');
}
function getDepthTexture(gl) {
    if (isWebGL2(gl)) {
        return {
            UNSIGNED_INT_24_8: gl.UNSIGNED_INT_24_8
        };
    }
    else {
        var ext = gl.getExtension('WEBGL_depth_texture');
        if (ext === null)
            return null;
        return {
            UNSIGNED_INT_24_8: ext.UNSIGNED_INT_24_8_WEBGL
        };
    }
}
function getSRGB(gl) {
    if (isWebGL2(gl)) {
        return {
            FRAMEBUFFER_ATTACHMENT_COLOR_ENCODING: gl.FRAMEBUFFER_ATTACHMENT_COLOR_ENCODING,
            SRGB8_ALPHA8: gl.SRGB8_ALPHA8,
            SRGB8: gl.SRGB8,
            SRGB: gl.SRGB
        };
    }
    else {
        var ext = gl.getExtension('EXT_sRGB');
        if (ext === null)
            return null;
        return {
            FRAMEBUFFER_ATTACHMENT_COLOR_ENCODING: ext.FRAMEBUFFER_ATTACHMENT_COLOR_ENCODING_EXT,
            SRGB8_ALPHA8: ext.SRGB8_ALPHA8_EXT,
            SRGB8: ext.SRGB_ALPHA_EXT,
            SRGB: ext.SRGB_EXT
        };
    }
}
//
var TextureTestVertShader = "\nattribute vec4 aPosition;\n\nvoid main() {\n    gl_Position = aPosition;\n}";
var TextureTestFragShader = "\nprecision mediump float;\nuniform vec4 uColor;\nuniform sampler2D uTexture;\n\nvoid main() {\n    gl_FragColor = texture2D(uTexture, vec2(0.5, 0.5)) * uColor;\n}";
var TextureTestTexCoords = new Float32Array([
    -1.0, -1.0, 1.0, -1.0, -1.0, 1.0, -1.0, 1.0, 1.0, -1.0, 1.0, 1.0
]);
// adapted from https://stackoverflow.com/questions/28827511/
function testColorBuffer(gl, type) {
    // setup shaders
    var vertShader = Object(_shader__WEBPACK_IMPORTED_MODULE_3__["getShader"])(gl, { type: 'vert', source: TextureTestVertShader });
    var fragShader = Object(_shader__WEBPACK_IMPORTED_MODULE_3__["getShader"])(gl, { type: 'frag', source: TextureTestFragShader });
    if (!vertShader || !fragShader)
        return false;
    // setup program
    var program = Object(_program__WEBPACK_IMPORTED_MODULE_2__["getProgram"])(gl);
    gl.attachShader(program, vertShader);
    gl.attachShader(program, fragShader);
    gl.linkProgram(program);
    gl.useProgram(program);
    // look up where the vertex data needs to go.
    var positionLocation = gl.getAttribLocation(program, 'aPosition');
    var colorLoc = gl.getUniformLocation(program, 'uColor');
    if (!colorLoc) {
        if (_mol_util_debug__WEBPACK_IMPORTED_MODULE_0__["isDebugMode"]) {
            console.log("error getting 'uColor' uniform location");
        }
        return false;
    }
    // provide texture coordinates for the rectangle.
    var positionBuffer = gl.createBuffer();
    gl.bindBuffer(gl.ARRAY_BUFFER, positionBuffer);
    gl.bufferData(gl.ARRAY_BUFFER, TextureTestTexCoords, gl.STATIC_DRAW);
    gl.enableVertexAttribArray(positionLocation);
    gl.vertexAttribPointer(positionLocation, 2, gl.FLOAT, false, 0, 0);
    var whiteTex = gl.createTexture();
    var whiteData = new Uint8Array([255, 255, 255, 255]);
    gl.bindTexture(gl.TEXTURE_2D, whiteTex);
    gl.texImage2D(gl.TEXTURE_2D, 0, gl.RGBA, 1, 1, 0, gl.RGBA, gl.UNSIGNED_BYTE, whiteData);
    var tex = gl.createTexture();
    gl.bindTexture(gl.TEXTURE_2D, tex);
    gl.texImage2D(gl.TEXTURE_2D, 0, gl.RGBA, 1, 1, 0, gl.RGBA, type, null);
    gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MIN_FILTER, gl.NEAREST);
    gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MAG_FILTER, gl.NEAREST);
    var fb = gl.createFramebuffer();
    gl.bindFramebuffer(gl.FRAMEBUFFER, fb);
    gl.framebufferTexture2D(gl.FRAMEBUFFER, gl.COLOR_ATTACHMENT0, gl.TEXTURE_2D, tex, 0);
    var status = gl.checkFramebufferStatus(gl.FRAMEBUFFER);
    if (status !== gl.FRAMEBUFFER_COMPLETE) {
        if (_mol_util_debug__WEBPACK_IMPORTED_MODULE_0__["isDebugMode"]) {
            console.log("error creating framebuffer for '" + type + "'");
        }
        return false;
    }
    // Draw the rectangle.
    gl.bindTexture(gl.TEXTURE_2D, whiteTex);
    gl.uniform4fv(colorLoc, [0, 10, 20, 1]);
    gl.drawArrays(gl.TRIANGLES, 0, 6);
    gl.bindTexture(gl.TEXTURE_2D, tex);
    gl.bindFramebuffer(gl.FRAMEBUFFER, null);
    gl.clearColor(1, 0, 0, 1);
    gl.clear(gl.COLOR_BUFFER_BIT);
    gl.uniform4fv(colorLoc, [0, 1 / 10, 1 / 20, 1]);
    gl.drawArrays(gl.TRIANGLES, 0, 6);
    // Check if rendered correctly
    var pixel = new Uint8Array(4);
    gl.readPixels(0, 0, 1, 1, gl.RGBA, gl.UNSIGNED_BYTE, pixel);
    if (pixel[0] !== 0 || pixel[1] < 248 || pixel[2] < 248 || pixel[3] < 254) {
        if (_mol_util_debug__WEBPACK_IMPORTED_MODULE_0__["isDebugMode"]) {
            console.log("not able to actually render to '" + type + "' texture");
        }
        return false;
    }
    // Check reading from float texture
    if (type === gl.FLOAT) {
        gl.bindFramebuffer(gl.FRAMEBUFFER, fb);
        var floatPixel = new Float32Array(4);
        gl.readPixels(0, 0, 1, 1, gl.RGBA, gl.FLOAT, floatPixel);
        var error = gl.getError();
        if (error) {
            if (_mol_util_debug__WEBPACK_IMPORTED_MODULE_0__["isDebugMode"]) {
                console.log("error reading float pixels: '" + Object(_context__WEBPACK_IMPORTED_MODULE_1__["getErrorDescription"])(gl, error) + "'");
            }
            return false;
        }
    }
    return true;
}
//# sourceMappingURL=compat.js.map

/***/ }),

/***/ "./lib/mol-gl/webgl/context.js":
/*!*************************************!*\
  !*** ./lib/mol-gl/webgl/context.js ***!
  \*************************************/
/*! exports provided: getGLContext, getErrorDescription, checkError, readPixels, createContext */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getGLContext", function() { return getGLContext; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getErrorDescription", function() { return getErrorDescription; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "checkError", function() { return checkError; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "readPixels", function() { return readPixels; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createContext", function() { return createContext; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _compat__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./compat */ "./lib/mol-gl/webgl/compat.js");
/* harmony import */ var _framebuffer__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./framebuffer */ "./lib/mol-gl/webgl/framebuffer.js");
/* harmony import */ var _mol_task__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../mol-task */ "./lib/mol-task/index.js");
/* harmony import */ var _mol_util_debug__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../mol-util/debug */ "./lib/mol-util/debug.js");
/* harmony import */ var _extensions__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./extensions */ "./lib/mol-gl/webgl/extensions.js");
/* harmony import */ var _state__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ./state */ "./lib/mol-gl/webgl/state.js");
/* harmony import */ var _mol_util_image__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../../mol-util/image */ "./lib/mol-util/image.js");
/* harmony import */ var _resources__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ./resources */ "./lib/mol-gl/webgl/resources.js");
/* harmony import */ var _render_target__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ./render-target */ "./lib/mol-gl/webgl/render-target.js");
/* harmony import */ var rxjs__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! rxjs */ "./node_modules/rxjs/_esm5/index.js");
/* harmony import */ var _mol_util_now__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ../../mol-util/now */ "./lib/mol-util/now.js");
/**
 * Copyright (c) 2018-2021 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */












function getGLContext(canvas, attribs) {
    function get(id) {
        try {
            return canvas.getContext(id, attribs);
        }
        catch (e) {
            return null;
        }
    }
    var gl = get('webgl2') || get('webgl') || get('experimental-webgl');
    if (_mol_util_debug__WEBPACK_IMPORTED_MODULE_4__["isDebugMode"])
        console.log("isWebgl2: " + Object(_compat__WEBPACK_IMPORTED_MODULE_1__["isWebGL2"])(gl));
    return gl;
}
function getErrorDescription(gl, error) {
    switch (error) {
        case gl.NO_ERROR: return 'no error';
        case gl.INVALID_ENUM: return 'invalid enum';
        case gl.INVALID_VALUE: return 'invalid value';
        case gl.INVALID_OPERATION: return 'invalid operation';
        case gl.INVALID_FRAMEBUFFER_OPERATION: return 'invalid framebuffer operation';
        case gl.OUT_OF_MEMORY: return 'out of memory';
        case gl.CONTEXT_LOST_WEBGL: return 'context lost';
    }
    return 'unknown error';
}
function checkError(gl) {
    var error = gl.getError();
    if (error !== gl.NO_ERROR) {
        throw new Error("WebGL error: '" + getErrorDescription(gl, error) + "'");
    }
}
function unbindResources(gl) {
    // bind null to all texture units
    var maxTextureImageUnits = gl.getParameter(gl.MAX_TEXTURE_IMAGE_UNITS);
    for (var i = 0; i < maxTextureImageUnits; ++i) {
        gl.activeTexture(gl.TEXTURE0 + i);
        gl.bindTexture(gl.TEXTURE_2D, null);
        gl.bindTexture(gl.TEXTURE_CUBE_MAP, null);
        if (Object(_compat__WEBPACK_IMPORTED_MODULE_1__["isWebGL2"])(gl)) {
            gl.bindTexture(gl.TEXTURE_2D_ARRAY, null);
            gl.bindTexture(gl.TEXTURE_3D, null);
        }
    }
    // assign the smallest possible buffer to all attributes
    var buf = gl.createBuffer();
    gl.bindBuffer(gl.ARRAY_BUFFER, buf);
    var maxVertexAttribs = gl.getParameter(gl.MAX_VERTEX_ATTRIBS);
    for (var i = 0; i < maxVertexAttribs; ++i) {
        gl.vertexAttribPointer(i, 1, gl.FLOAT, false, 0, 0);
    }
    // bind null to all buffers
    gl.bindBuffer(gl.ARRAY_BUFFER, null);
    gl.bindBuffer(gl.ELEMENT_ARRAY_BUFFER, null);
    gl.bindRenderbuffer(gl.RENDERBUFFER, null);
    unbindFramebuffer(gl);
}
function unbindFramebuffer(gl) {
    gl.bindFramebuffer(gl.FRAMEBUFFER, null);
}
var tmpPixel = new Uint8Array(1 * 4);
function checkSync(gl, sync, resolve) {
    if (gl.getSyncParameter(sync, gl.SYNC_STATUS) === gl.SIGNALED) {
        gl.deleteSync(sync);
        resolve();
    }
    else {
        _mol_task__WEBPACK_IMPORTED_MODULE_3__["Scheduler"].setImmediate(checkSync, gl, sync, resolve);
    }
}
function fence(gl, resolve) {
    var sync = gl.fenceSync(gl.SYNC_GPU_COMMANDS_COMPLETE, 0);
    if (!sync) {
        console.warn('Could not create a WebGLSync object');
        gl.readPixels(0, 0, 1, 1, gl.RGBA, gl.UNSIGNED_BYTE, tmpPixel);
        resolve();
    }
    else {
        _mol_task__WEBPACK_IMPORTED_MODULE_3__["Scheduler"].setImmediate(checkSync, gl, sync, resolve);
    }
}
var SentWebglSyncObjectNotSupportedInWebglMessage = false;
function waitForGpuCommandsComplete(gl) {
    return new Promise(function (resolve) {
        if (Object(_compat__WEBPACK_IMPORTED_MODULE_1__["isWebGL2"])(gl)) {
            // TODO seems quite slow
            fence(gl, resolve);
        }
        else {
            if (!SentWebglSyncObjectNotSupportedInWebglMessage) {
                console.info('Sync object not supported in WebGL');
                SentWebglSyncObjectNotSupportedInWebglMessage = true;
            }
            waitForGpuCommandsCompleteSync(gl);
            resolve();
        }
    });
}
function waitForGpuCommandsCompleteSync(gl) {
    gl.bindFramebuffer(gl.FRAMEBUFFER, null);
    gl.readPixels(0, 0, 1, 1, gl.RGBA, gl.UNSIGNED_BYTE, tmpPixel);
}
function readPixels(gl, x, y, width, height, buffer) {
    if (_mol_util_debug__WEBPACK_IMPORTED_MODULE_4__["isDebugMode"])
        Object(_framebuffer__WEBPACK_IMPORTED_MODULE_2__["checkFramebufferStatus"])(gl);
    if (buffer instanceof Uint8Array) {
        gl.readPixels(x, y, width, height, gl.RGBA, gl.UNSIGNED_BYTE, buffer);
    }
    else if (buffer instanceof Float32Array) {
        gl.readPixels(x, y, width, height, gl.RGBA, gl.FLOAT, buffer);
    }
    else if (buffer instanceof Int32Array && Object(_compat__WEBPACK_IMPORTED_MODULE_1__["isWebGL2"])(gl)) {
        gl.readPixels(x, y, width, height, gl.RGBA_INTEGER, gl.INT, buffer);
    }
    else {
        throw new Error('unsupported readPixels buffer type');
    }
    if (_mol_util_debug__WEBPACK_IMPORTED_MODULE_4__["isDebugMode"])
        checkError(gl);
}
function getDrawingBufferPixelData(gl) {
    var w = gl.drawingBufferWidth;
    var h = gl.drawingBufferHeight;
    var buffer = new Uint8Array(w * h * 4);
    unbindFramebuffer(gl);
    gl.viewport(0, 0, w, h);
    readPixels(gl, 0, 0, w, h, buffer);
    return _mol_util_image__WEBPACK_IMPORTED_MODULE_7__["PixelData"].flipY(_mol_util_image__WEBPACK_IMPORTED_MODULE_7__["PixelData"].create(buffer, w, h));
}
//
function createStats() {
    return {
        resourceCounts: {
            attribute: 0,
            elements: 0,
            framebuffer: 0,
            program: 0,
            renderbuffer: 0,
            shader: 0,
            texture: 0,
            vertexArray: 0,
        },
        drawCount: 0,
        instanceCount: 0,
        instancedDrawCount: 0,
    };
}
function createContext(gl, props) {
    var _this = this;
    if (props === void 0) { props = {}; }
    var extensions = Object(_extensions__WEBPACK_IMPORTED_MODULE_5__["createExtensions"])(gl);
    var state = Object(_state__WEBPACK_IMPORTED_MODULE_6__["createState"])(gl);
    var stats = createStats();
    var resources = Object(_resources__WEBPACK_IMPORTED_MODULE_8__["createResources"])(gl, state, stats, extensions);
    var parameters = {
        maxTextureSize: gl.getParameter(gl.MAX_TEXTURE_SIZE),
        maxRenderbufferSize: gl.getParameter(gl.MAX_RENDERBUFFER_SIZE),
        maxDrawBuffers: extensions.drawBuffers ? gl.getParameter(extensions.drawBuffers.MAX_DRAW_BUFFERS) : 0,
        maxTextureImageUnits: gl.getParameter(gl.MAX_TEXTURE_IMAGE_UNITS),
        maxVertexTextureImageUnits: gl.getParameter(gl.MAX_VERTEX_TEXTURE_IMAGE_UNITS),
    };
    if (parameters.maxVertexTextureImageUnits < 8) {
        throw new Error('Need "MAX_VERTEX_TEXTURE_IMAGE_UNITS" >= 8');
    }
    var isContextLost = false;
    var contextRestored = new rxjs__WEBPACK_IMPORTED_MODULE_10__["BehaviorSubject"](0);
    var readPixelsAsync;
    if (Object(_compat__WEBPACK_IMPORTED_MODULE_1__["isWebGL2"])(gl)) {
        var pbo_1 = gl.createBuffer();
        var _buffer_1 = void 0;
        var _resolve_1 = void 0;
        var _reading_1 = false;
        var bindPBO_1 = function () {
            gl.bindBuffer(gl.PIXEL_PACK_BUFFER, pbo_1);
            gl.getBufferSubData(gl.PIXEL_PACK_BUFFER, 0, _buffer_1);
            gl.bindBuffer(gl.PIXEL_PACK_BUFFER, null);
            _reading_1 = false;
            _resolve_1();
            _resolve_1 = void 0;
            _buffer_1 = void 0;
        };
        readPixelsAsync = function (x, y, width, height, buffer) { return new Promise(function (resolve, reject) {
            if (_reading_1) {
                reject('Can not call multiple readPixelsAsync at the same time');
                return;
            }
            _reading_1 = true;
            gl.bindBuffer(gl.PIXEL_PACK_BUFFER, pbo_1);
            gl.bufferData(gl.PIXEL_PACK_BUFFER, width * height * 4, gl.STREAM_READ);
            gl.readPixels(x, y, width, height, gl.RGBA, gl.UNSIGNED_BYTE, 0);
            gl.bindBuffer(gl.PIXEL_PACK_BUFFER, null);
            // need to unbind/bind PBO before/after async awaiting the fence
            _resolve_1 = resolve;
            _buffer_1 = buffer;
            fence(gl, bindPBO_1);
        }); };
    }
    else {
        readPixelsAsync = function (x, y, width, height, buffer) { return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"])(_this, void 0, void 0, function () {
            return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__generator"])(this, function (_a) {
                readPixels(gl, x, y, width, height, buffer);
                return [2 /*return*/];
            });
        }); };
    }
    var renderTargets = new Set();
    return {
        gl: gl,
        isWebGL2: Object(_compat__WEBPACK_IMPORTED_MODULE_1__["isWebGL2"])(gl),
        get pixelRatio() {
            var dpr = (typeof window !== 'undefined') ? window.devicePixelRatio : 1;
            return dpr * (props.pixelScale || 1);
        },
        extensions: extensions,
        state: state,
        stats: stats,
        resources: resources,
        get maxTextureSize() { return parameters.maxTextureSize; },
        get maxRenderbufferSize() { return parameters.maxRenderbufferSize; },
        get maxDrawBuffers() { return parameters.maxDrawBuffers; },
        get maxTextureImageUnits() { return parameters.maxTextureImageUnits; },
        namedComputeRenderables: Object.create(null),
        namedFramebuffers: Object.create(null),
        namedTextures: Object.create(null),
        get isContextLost() {
            return isContextLost || gl.isContextLost();
        },
        contextRestored: contextRestored,
        setContextLost: function () {
            isContextLost = true;
        },
        handleContextRestored: function (extraResets) {
            Object.assign(extensions, Object(_extensions__WEBPACK_IMPORTED_MODULE_5__["createExtensions"])(gl));
            state.reset();
            state.currentMaterialId = -1;
            state.currentProgramId = -1;
            state.currentRenderItemId = -1;
            resources.reset();
            renderTargets.forEach(function (rt) { return rt.reset(); });
            extraResets === null || extraResets === void 0 ? void 0 : extraResets();
            isContextLost = false;
            contextRestored.next(Object(_mol_util_now__WEBPACK_IMPORTED_MODULE_11__["now"])());
        },
        createRenderTarget: function (width, height, depth, type, filter) {
            var renderTarget = Object(_render_target__WEBPACK_IMPORTED_MODULE_9__["createRenderTarget"])(gl, resources, width, height, depth, type, filter);
            renderTargets.add(renderTarget);
            return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, renderTarget), { destroy: function () {
                    renderTarget.destroy();
                    renderTargets.delete(renderTarget);
                } });
        },
        unbindFramebuffer: function () { return unbindFramebuffer(gl); },
        readPixels: function (x, y, width, height, buffer) {
            readPixels(gl, x, y, width, height, buffer);
        },
        readPixelsAsync: readPixelsAsync,
        waitForGpuCommandsComplete: function () { return waitForGpuCommandsComplete(gl); },
        waitForGpuCommandsCompleteSync: function () { return waitForGpuCommandsCompleteSync(gl); },
        getDrawingBufferPixelData: function () { return getDrawingBufferPixelData(gl); },
        clear: function (red, green, blue, alpha) {
            unbindFramebuffer(gl);
            state.enable(gl.SCISSOR_TEST);
            state.depthMask(true);
            state.colorMask(true, true, true, true);
            state.clearColor(red, green, blue, alpha);
            gl.viewport(0, 0, gl.drawingBufferWidth, gl.drawingBufferHeight);
            gl.scissor(0, 0, gl.drawingBufferWidth, gl.drawingBufferHeight);
            gl.clear(gl.COLOR_BUFFER_BIT | gl.DEPTH_BUFFER_BIT);
        },
        destroy: function (options) {
            var _a;
            resources.destroy();
            unbindResources(gl);
            // to aid GC
            if (!(options === null || options === void 0 ? void 0 : options.doNotForceWebGLContextLoss))
                (_a = gl.getExtension('WEBGL_lose_context')) === null || _a === void 0 ? void 0 : _a.loseContext();
        }
    };
}
//# sourceMappingURL=context.js.map

/***/ }),

/***/ "./lib/mol-gl/webgl/extensions.js":
/*!****************************************!*\
  !*** ./lib/mol-gl/webgl/extensions.js ***!
  \****************************************/
/*! exports provided: createExtensions */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createExtensions", function() { return createExtensions; });
/* harmony import */ var _compat__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./compat */ "./lib/mol-gl/webgl/compat.js");
/* harmony import */ var _mol_util_debug__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../mol-util/debug */ "./lib/mol-util/debug.js");
/**
 * Copyright (c) 2018-2021 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */


function createExtensions(gl) {
    var instancedArrays = Object(_compat__WEBPACK_IMPORTED_MODULE_0__["getInstancedArrays"])(gl);
    if (instancedArrays === null) {
        throw new Error('Could not find support for "instanced_arrays"');
    }
    var elementIndexUint = Object(_compat__WEBPACK_IMPORTED_MODULE_0__["getElementIndexUint"])(gl);
    if (elementIndexUint === null) {
        throw new Error('Could not find support for "element_index_uint"');
    }
    var standardDerivatives = Object(_compat__WEBPACK_IMPORTED_MODULE_0__["getStandardDerivatives"])(gl);
    if (_mol_util_debug__WEBPACK_IMPORTED_MODULE_1__["isDebugMode"] && standardDerivatives === null) {
        // - non-support handled downstream (flat shading option is ignored)
        // - can't be a required extension because it is not supported by `headless-gl`
        console.log('Could not find support for "standard_derivatives"');
    }
    var textureFloat = Object(_compat__WEBPACK_IMPORTED_MODULE_0__["getTextureFloat"])(gl);
    if (_mol_util_debug__WEBPACK_IMPORTED_MODULE_1__["isDebugMode"] && textureFloat === null) {
        console.log('Could not find support for "texture_float"');
    }
    var textureFloatLinear = Object(_compat__WEBPACK_IMPORTED_MODULE_0__["getTextureFloatLinear"])(gl);
    if (_mol_util_debug__WEBPACK_IMPORTED_MODULE_1__["isDebugMode"] && textureFloatLinear === null) {
        // TODO handle non-support downstream (no gpu gaussian calc, no gpu mc???)
        // - can't be a required extension because it is not supported by `headless-gl`
        console.log('Could not find support for "texture_float_linear"');
    }
    var textureHalfFloat = Object(_compat__WEBPACK_IMPORTED_MODULE_0__["getTextureHalfFloat"])(gl);
    if (_mol_util_debug__WEBPACK_IMPORTED_MODULE_1__["isDebugMode"] && textureHalfFloat === null) {
        console.log('Could not find support for "texture_half_float"');
    }
    var textureHalfFloatLinear = Object(_compat__WEBPACK_IMPORTED_MODULE_0__["getTextureHalfFloatLinear"])(gl);
    if (_mol_util_debug__WEBPACK_IMPORTED_MODULE_1__["isDebugMode"] && textureHalfFloatLinear === null) {
        // TODO handle non-support downstream (no gpu gaussian calc, no gpu mc???)
        // - can't be a required extension because it is not supported by `headless-gl`
        console.log('Could not find support for "texture_half_float_linear"');
    }
    var depthTexture = Object(_compat__WEBPACK_IMPORTED_MODULE_0__["getDepthTexture"])(gl);
    if (_mol_util_debug__WEBPACK_IMPORTED_MODULE_1__["isDebugMode"] && depthTexture === null) {
        console.log('Could not find support for "depth_texture"');
    }
    var blendMinMax = Object(_compat__WEBPACK_IMPORTED_MODULE_0__["getBlendMinMax"])(gl);
    if (_mol_util_debug__WEBPACK_IMPORTED_MODULE_1__["isDebugMode"] && blendMinMax === null) {
        // TODO handle non-support downstream (e.g. no gpu gaussian calc)
        // - can't be a required extension because it is not supported by `headless-gl`
        console.log('Could not find support for "blend_minmax"');
    }
    var vertexArrayObject = Object(_compat__WEBPACK_IMPORTED_MODULE_0__["getVertexArrayObject"])(gl);
    if (_mol_util_debug__WEBPACK_IMPORTED_MODULE_1__["isDebugMode"] && vertexArrayObject === null) {
        console.log('Could not find support for "vertex_array_object"');
    }
    var fragDepth = Object(_compat__WEBPACK_IMPORTED_MODULE_0__["getFragDepth"])(gl);
    if (_mol_util_debug__WEBPACK_IMPORTED_MODULE_1__["isDebugMode"] && fragDepth === null) {
        console.log('Could not find support for "frag_depth"');
    }
    var colorBufferFloat = Object(_compat__WEBPACK_IMPORTED_MODULE_0__["getColorBufferFloat"])(gl);
    if (_mol_util_debug__WEBPACK_IMPORTED_MODULE_1__["isDebugMode"] && colorBufferFloat === null) {
        console.log('Could not find support for "color_buffer_float"');
    }
    var colorBufferHalfFloat = Object(_compat__WEBPACK_IMPORTED_MODULE_0__["getColorBufferHalfFloat"])(gl);
    if (_mol_util_debug__WEBPACK_IMPORTED_MODULE_1__["isDebugMode"] && colorBufferHalfFloat === null) {
        console.log('Could not find support for "color_buffer_half_float"');
    }
    var drawBuffers = Object(_compat__WEBPACK_IMPORTED_MODULE_0__["getDrawBuffers"])(gl);
    if (_mol_util_debug__WEBPACK_IMPORTED_MODULE_1__["isDebugMode"] && drawBuffers === null) {
        console.log('Could not find support for "draw_buffers"');
    }
    var shaderTextureLod = Object(_compat__WEBPACK_IMPORTED_MODULE_0__["getShaderTextureLod"])(gl);
    if (_mol_util_debug__WEBPACK_IMPORTED_MODULE_1__["isDebugMode"] && shaderTextureLod === null) {
        console.log('Could not find support for "shader_texture_lod"');
    }
    var sRGB = Object(_compat__WEBPACK_IMPORTED_MODULE_0__["getSRGB"])(gl);
    if (_mol_util_debug__WEBPACK_IMPORTED_MODULE_1__["isDebugMode"] && sRGB === null) {
        console.log('Could not find support for "sRGB"');
    }
    return {
        instancedArrays: instancedArrays,
        standardDerivatives: standardDerivatives,
        textureFloat: textureFloat,
        textureFloatLinear: textureFloatLinear,
        textureHalfFloat: textureHalfFloat,
        textureHalfFloatLinear: textureHalfFloatLinear,
        elementIndexUint: elementIndexUint,
        depthTexture: depthTexture,
        blendMinMax: blendMinMax,
        vertexArrayObject: vertexArrayObject,
        fragDepth: fragDepth,
        colorBufferFloat: colorBufferFloat,
        colorBufferHalfFloat: colorBufferHalfFloat,
        drawBuffers: drawBuffers,
        shaderTextureLod: shaderTextureLod,
        sRGB: sRGB,
    };
}
//# sourceMappingURL=extensions.js.map

/***/ }),

/***/ "./lib/mol-gl/webgl/framebuffer.js":
/*!*****************************************!*\
  !*** ./lib/mol-gl/webgl/framebuffer.js ***!
  \*****************************************/
/*! exports provided: checkFramebufferStatus, createFramebuffer, createNullFramebuffer */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "checkFramebufferStatus", function() { return checkFramebufferStatus; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createFramebuffer", function() { return createFramebuffer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createNullFramebuffer", function() { return createNullFramebuffer; });
/* harmony import */ var _mol_util_id_factory__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../mol-util/id-factory */ "./lib/mol-util/id-factory.js");
/* harmony import */ var _compat__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./compat */ "./lib/mol-gl/webgl/compat.js");
/**
 * Copyright (c) 2018-2020 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */


var getNextFramebufferId = Object(_mol_util_id_factory__WEBPACK_IMPORTED_MODULE_0__["idFactory"])();
function getFramebufferStatusDescription(gl, status) {
    switch (status) {
        case gl.FRAMEBUFFER_COMPLETE: return 'complete';
        case gl.FRAMEBUFFER_INCOMPLETE_ATTACHMENT: return 'incomplete attachment';
        case gl.FRAMEBUFFER_INCOMPLETE_MISSING_ATTACHMENT: return 'incomplete missing attachment';
        case gl.FRAMEBUFFER_INCOMPLETE_DIMENSIONS: return 'incomplete dimensions';
        case gl.FRAMEBUFFER_UNSUPPORTED: return 'unsupported';
    }
    if (Object(_compat__WEBPACK_IMPORTED_MODULE_1__["isWebGL2"])(gl)) {
        switch (status) {
            case gl.FRAMEBUFFER_INCOMPLETE_MULTISAMPLE: return 'incomplete multisample';
            case gl.RENDERBUFFER_SAMPLES: return 'renderbuffer samples';
        }
    }
    return 'unknown error';
}
function checkFramebufferStatus(gl) {
    var status = gl.checkFramebufferStatus(gl.FRAMEBUFFER);
    if (status !== gl.FRAMEBUFFER_COMPLETE) {
        var description = getFramebufferStatusDescription(gl, status);
        throw new Error("Framebuffer status: " + description);
    }
}
function getFramebuffer(gl) {
    var framebuffer = gl.createFramebuffer();
    if (framebuffer === null) {
        throw new Error('Could not create WebGL framebuffer');
    }
    return framebuffer;
}
function createFramebuffer(gl) {
    var _framebuffer = getFramebuffer(gl);
    var destroyed = false;
    return {
        id: getNextFramebufferId(),
        bind: function () { return gl.bindFramebuffer(gl.FRAMEBUFFER, _framebuffer); },
        reset: function () {
            _framebuffer = getFramebuffer(gl);
        },
        destroy: function () {
            if (destroyed)
                return;
            gl.deleteFramebuffer(_framebuffer);
            destroyed = true;
        }
    };
}
//
function createNullFramebuffer() {
    return {
        id: getNextFramebufferId(),
        bind: function () { },
        reset: function () { },
        destroy: function () { }
    };
}
//# sourceMappingURL=framebuffer.js.map

/***/ }),

/***/ "./lib/mol-gl/webgl/program.js":
/*!*************************************!*\
  !*** ./lib/mol-gl/webgl/program.js ***!
  \*************************************/
/*! exports provided: getProgram, createProgram */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getProgram", function() { return getProgram; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createProgram", function() { return createProgram; });
/* harmony import */ var _shader_code__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../shader-code */ "./lib/mol-gl/shader-code.js");
/* harmony import */ var _uniform__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./uniform */ "./lib/mol-gl/webgl/uniform.js");
/* harmony import */ var _buffer__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./buffer */ "./lib/mol-gl/webgl/buffer.js");
/* harmony import */ var _mol_util_id_factory__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../mol-util/id-factory */ "./lib/mol-util/id-factory.js");
/* harmony import */ var _mol_util_debug__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../mol-util/debug */ "./lib/mol-util/debug.js");
/**
 * Copyright (c) 2018-2020 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */





var getNextProgramId = Object(_mol_util_id_factory__WEBPACK_IMPORTED_MODULE_3__["idFactory"])();
function getLocations(gl, program, schema) {
    var locations = {};
    Object.keys(schema).forEach(function (k) {
        var spec = schema[k];
        if (spec.type === 'attribute') {
            var loc = gl.getAttribLocation(program, k);
            // unused attributes will result in a `-1` location which is usually fine
            // if (loc === -1) console.info(`Could not get attribute location for '${k}'`)
            locations[k] = loc;
        }
        else if (spec.type === 'uniform' || spec.type === 'texture') {
            var loc = gl.getUniformLocation(program, k);
            // unused uniforms will result in a `null` location which is usually fine
            // if (loc === null) console.info(`Could not get uniform location for '${k}'`)
            locations[k] = loc;
        }
    });
    return locations;
}
function checkActiveAttributes(gl, program, schema) {
    var attribCount = gl.getProgramParameter(program, gl.ACTIVE_ATTRIBUTES);
    for (var i = 0; i < attribCount; ++i) {
        var info = gl.getActiveAttrib(program, i);
        if (info) {
            var name_1 = info.name, type = info.type;
            if (name_1.startsWith('__activeAttribute')) {
                // name assigned by `gl.shim.ts`, ignore for checks
                continue;
            }
            if (name_1 === 'gl_InstanceID')
                continue; // WebGL2 built-in
            if (name_1 === 'gl_VertexID')
                continue; // WebGL2 built-in
            var spec = schema[name_1];
            if (spec === undefined) {
                throw new Error("missing 'uniform' or 'texture' with name '" + name_1 + "' in schema");
            }
            if (spec.type !== 'attribute') {
                throw new Error("'" + name_1 + "' must be of type 'attribute' but is '" + spec.type + "'");
            }
            var attribType = Object(_buffer__WEBPACK_IMPORTED_MODULE_2__["getAttribType"])(gl, spec.kind, spec.itemSize);
            if (attribType !== type) {
                throw new Error("unexpected attribute type for " + name_1);
            }
        }
    }
}
function checkActiveUniforms(gl, program, schema) {
    var attribCount = gl.getProgramParameter(program, gl.ACTIVE_UNIFORMS);
    for (var i = 0; i < attribCount; ++i) {
        var info = gl.getActiveUniform(program, i);
        if (info) {
            var name_2 = info.name, type = info.type;
            if (name_2.startsWith('__activeUniform')) {
                // name assigned by `gl.shim.ts`, ignore for checks
                continue;
            }
            var baseName = name_2.replace(/[[0-9]+\]$/, ''); // 'array' uniforms
            var spec = schema[baseName];
            if (spec === undefined) {
                throw new Error("missing 'uniform' or 'texture' with name '" + name_2 + "' in schema");
            }
            if (spec.type === 'uniform') {
                var uniformType = Object(_uniform__WEBPACK_IMPORTED_MODULE_1__["getUniformType"])(gl, spec.kind);
                if (uniformType !== type) {
                    throw new Error("unexpected uniform type for " + name_2);
                }
            }
            else if (spec.type === 'texture') {
                if (spec.kind === 'image-float32' || spec.kind === 'image-uint8') {
                    if (type !== gl.SAMPLER_2D) {
                        throw new Error("unexpected sampler type for '" + name_2 + "'");
                    }
                }
                else if (spec.kind === 'volume-float32' || spec.kind === 'volume-uint8') {
                    if (type !== gl.SAMPLER_3D) {
                        throw new Error("unexpected sampler type for '" + name_2 + "'");
                    }
                }
                else {
                    // TODO
                }
            }
            else {
                throw new Error("'" + name_2 + "' must be of type 'uniform' or 'texture' but is '" + spec.type + "'");
            }
        }
    }
}
function checkProgram(gl, program) {
    // no-op in FF on Mac, see https://bugzilla.mozilla.org/show_bug.cgi?id=1284425
    // gl.validateProgram(program)
    if (!gl.getProgramParameter(program, gl.LINK_STATUS)) {
        throw new Error("Could not compile WebGL program. \n\n" + gl.getProgramInfoLog(program));
    }
}
function getProgram(gl) {
    var program = gl.createProgram();
    if (program === null) {
        throw new Error('Could not create WebGL program');
    }
    return program;
}
function createProgram(gl, state, extensions, getShader, props) {
    var defineValues = props.defineValues, _shaderCode = props.shaderCode, schema = props.schema;
    var program = getProgram(gl);
    var programId = getNextProgramId();
    var shaderCode = Object(_shader_code__WEBPACK_IMPORTED_MODULE_0__["addShaderDefines"])(gl, extensions, defineValues, _shaderCode);
    var vertShader = getShader('vert', shaderCode.vert);
    var fragShader = getShader('frag', shaderCode.frag);
    var locations;
    var uniformSetters;
    function init() {
        vertShader.attach(program);
        fragShader.attach(program);
        gl.linkProgram(program);
        if (_mol_util_debug__WEBPACK_IMPORTED_MODULE_4__["isDebugMode"]) {
            checkProgram(gl, program);
        }
        locations = getLocations(gl, program, schema);
        uniformSetters = Object(_uniform__WEBPACK_IMPORTED_MODULE_1__["getUniformSetters"])(schema);
        if (_mol_util_debug__WEBPACK_IMPORTED_MODULE_4__["isDebugMode"]) {
            checkActiveAttributes(gl, program, schema);
            checkActiveUniforms(gl, program, schema);
        }
    }
    init();
    var destroyed = false;
    return {
        id: programId,
        use: function () {
            // console.log('use', programId)
            state.currentProgramId = programId;
            gl.useProgram(program);
        },
        setUniforms: function (uniformValues) {
            for (var i = 0, il = uniformValues.length; i < il; ++i) {
                var _a = uniformValues[i], k = _a[0], v = _a[1];
                if (v) {
                    var l = locations[k];
                    if (l !== null)
                        uniformSetters[k](gl, l, v.ref.value);
                }
            }
        },
        bindAttributes: function (attributeBuffers) {
            for (var i = 0, il = attributeBuffers.length; i < il; ++i) {
                var _a = attributeBuffers[i], k = _a[0], buffer = _a[1];
                var l = locations[k];
                if (l !== -1)
                    buffer.bind(l);
            }
        },
        bindTextures: function (textures, startingTargetUnit) {
            for (var i = 0, il = textures.length; i < il; ++i) {
                var _a = textures[i], k = _a[0], texture = _a[1];
                var l = locations[k];
                if (l !== null && l !== undefined) {
                    texture.bind((i + startingTargetUnit));
                    uniformSetters[k](gl, l, (i + startingTargetUnit));
                }
            }
        },
        reset: function () {
            program = getProgram(gl);
            init();
        },
        destroy: function () {
            if (destroyed)
                return;
            vertShader.destroy();
            fragShader.destroy();
            gl.deleteProgram(program);
            destroyed = true;
        }
    };
}
//# sourceMappingURL=program.js.map

/***/ }),

/***/ "./lib/mol-gl/webgl/render-item.js":
/*!*****************************************!*\
  !*** ./lib/mol-gl/webgl/render-item.js ***!
  \*****************************************/
/*! exports provided: getDrawMode, createGraphicsRenderItem, createComputeRenderItem, createRenderItem */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getDrawMode", function() { return getDrawMode; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createGraphicsRenderItem", function() { return createGraphicsRenderItem; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createComputeRenderItem", function() { return createComputeRenderItem; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createRenderItem", function() { return createRenderItem; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _buffer__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./buffer */ "./lib/mol-gl/webgl/buffer.js");
/* harmony import */ var _texture__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./texture */ "./lib/mol-gl/webgl/texture.js");
/* harmony import */ var _context__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./context */ "./lib/mol-gl/webgl/context.js");
/* harmony import */ var _renderable_schema__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../renderable/schema */ "./lib/mol-gl/renderable/schema.js");
/* harmony import */ var _mol_util_id_factory__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../mol-util/id-factory */ "./lib/mol-util/id-factory.js");
/* harmony import */ var _mol_util__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../../mol-util */ "./lib/mol-util/index.js");
/* harmony import */ var _framebuffer__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ./framebuffer */ "./lib/mol-gl/webgl/framebuffer.js");
/* harmony import */ var _mol_util_debug__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ../../mol-util/debug */ "./lib/mol-util/debug.js");
/* harmony import */ var _mol_util_array__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ../../mol-util/array */ "./lib/mol-util/array.js");
/**
 * Copyright (c) 2018-2020 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */










var getNextRenderItemId = Object(_mol_util_id_factory__WEBPACK_IMPORTED_MODULE_5__["idFactory"])();
function getDrawMode(ctx, drawMode) {
    var gl = ctx.gl;
    switch (drawMode) {
        case 'points': return gl.POINTS;
        case 'lines': return gl.LINES;
        case 'line-strip': return gl.LINE_STRIP;
        case 'line-loop': return gl.LINE_LOOP;
        case 'triangles': return gl.TRIANGLES;
        case 'triangle-strip': return gl.TRIANGLE_STRIP;
        case 'triangle-fan': return gl.TRIANGLE_FAN;
    }
}
//
var GraphicsRenderVariant = { 'colorBlended': '', 'colorWboit': '', 'pickObject': '', 'pickInstance': '', 'pickGroup': '', 'depth': '' };
var GraphicsRenderVariants = Object.keys(GraphicsRenderVariant);
var ComputeRenderVariant = { 'compute': '' };
var ComputeRenderVariants = Object.keys(ComputeRenderVariant);
function createProgramVariant(ctx, variant, defineValues, shaderCode, schema) {
    defineValues = Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, defineValues), { dRenderVariant: _mol_util__WEBPACK_IMPORTED_MODULE_6__["ValueCell"].create(variant) });
    if (schema.dRenderVariant === undefined) {
        Object.defineProperty(schema, 'dRenderVariant', { value: Object(_renderable_schema__WEBPACK_IMPORTED_MODULE_4__["DefineSpec"])('string') });
    }
    return ctx.resources.program(defineValues, shaderCode, schema);
}
function createValueChanges() {
    return {
        attributes: false,
        defines: false,
        elements: false,
        textures: false,
    };
}
function resetValueChanges(valueChanges) {
    valueChanges.attributes = false;
    valueChanges.defines = false;
    valueChanges.elements = false;
    valueChanges.textures = false;
}
function createGraphicsRenderItem(ctx, drawMode, shaderCode, schema, values, materialId) {
    return createRenderItem(ctx, drawMode, shaderCode, schema, values, materialId, GraphicsRenderVariants);
}
function createComputeRenderItem(ctx, drawMode, shaderCode, schema, values, materialId) {
    if (materialId === void 0) { materialId = -1; }
    return createRenderItem(ctx, drawMode, shaderCode, schema, values, materialId, ComputeRenderVariants);
}
/**
 * Creates a render item
 *
 * - assumes that `values.drawCount` and `values.instanceCount` exist
 */
function createRenderItem(ctx, drawMode, shaderCode, schema, values, materialId, renderVariants) {
    var id = getNextRenderItemId();
    var stats = ctx.stats, state = ctx.state, resources = ctx.resources;
    var _a = ctx.extensions, instancedArrays = _a.instancedArrays, vertexArrayObject = _a.vertexArrayObject;
    // emulate gl_VertexID when needed
    if (!ctx.isWebGL2 && values.uVertexCount) {
        var vertexCount = values.uVertexCount.ref.value;
        values.aVertex = _mol_util__WEBPACK_IMPORTED_MODULE_6__["ValueCell"].create(Object(_mol_util_array__WEBPACK_IMPORTED_MODULE_9__["fillSerial"])(new Float32Array(vertexCount)));
        schema.aVertex = Object(_renderable_schema__WEBPACK_IMPORTED_MODULE_4__["AttributeSpec"])('float32', 1, 0);
    }
    var _b = Object(_renderable_schema__WEBPACK_IMPORTED_MODULE_4__["splitValues"])(schema, values), attributeValues = _b.attributeValues, defineValues = _b.defineValues, textureValues = _b.textureValues, uniformValues = _b.uniformValues, materialUniformValues = _b.materialUniformValues;
    var uniformValueEntries = Object.entries(uniformValues);
    var materialUniformValueEntries = Object.entries(materialUniformValues);
    var defineValueEntries = Object.entries(defineValues);
    var versions = Object(_renderable_schema__WEBPACK_IMPORTED_MODULE_4__["getValueVersions"])(values);
    var glDrawMode = getDrawMode(ctx, drawMode);
    var programs = {};
    for (var _i = 0, renderVariants_1 = renderVariants; _i < renderVariants_1.length; _i++) {
        var k = renderVariants_1[_i];
        programs[k] = createProgramVariant(ctx, k, defineValues, shaderCode, schema);
    }
    var textures = Object(_texture__WEBPACK_IMPORTED_MODULE_2__["createTextures"])(ctx, schema, textureValues);
    var attributeBuffers = Object(_buffer__WEBPACK_IMPORTED_MODULE_1__["createAttributeBuffers"])(ctx, schema, attributeValues);
    var elementsBuffer;
    var elements = values.elements;
    if (elements && elements.ref.value) {
        elementsBuffer = resources.elements(elements.ref.value);
    }
    var vertexArrays = {};
    for (var _c = 0, renderVariants_2 = renderVariants; _c < renderVariants_2.length; _c++) {
        var k = renderVariants_2[_c];
        vertexArrays[k] = vertexArrayObject ? resources.vertexArray(programs[k], attributeBuffers, elementsBuffer) : null;
    }
    var drawCount = values.drawCount.ref.value;
    var instanceCount = values.instanceCount.ref.value;
    stats.drawCount += drawCount;
    stats.instanceCount += instanceCount;
    stats.instancedDrawCount += instanceCount * drawCount;
    var valueChanges = createValueChanges();
    var destroyed = false;
    var currentProgramId = -1;
    return {
        id: id,
        materialId: materialId,
        getProgram: function (variant) { return programs[variant]; },
        render: function (variant, sharedTexturesList) {
            if (drawCount === 0 || instanceCount === 0 || ctx.isContextLost)
                return;
            var program = programs[variant];
            if (program.id === currentProgramId && state.currentRenderItemId === id) {
                program.setUniforms(uniformValueEntries);
                if (sharedTexturesList && sharedTexturesList.length > 0) {
                    program.bindTextures(sharedTexturesList, 0);
                    program.bindTextures(textures, sharedTexturesList.length);
                }
                else {
                    program.bindTextures(textures, 0);
                }
            }
            else {
                var vertexArray = vertexArrays[variant];
                if (program.id !== state.currentProgramId || program.id !== currentProgramId ||
                    materialId === -1 || materialId !== state.currentMaterialId) {
                    // console.log('program.id changed or materialId changed/-1', materialId)
                    if (program.id !== state.currentProgramId)
                        program.use();
                    program.setUniforms(materialUniformValueEntries);
                    state.currentMaterialId = materialId;
                    currentProgramId = program.id;
                }
                program.setUniforms(uniformValueEntries);
                if (sharedTexturesList && sharedTexturesList.length > 0) {
                    program.bindTextures(sharedTexturesList, 0);
                    program.bindTextures(textures, sharedTexturesList.length);
                }
                else {
                    program.bindTextures(textures, 0);
                }
                if (vertexArray) {
                    vertexArray.bind();
                    // need to bind elements buffer explicitly since it is not always recorded in the VAO
                    if (elementsBuffer)
                        elementsBuffer.bind();
                }
                else {
                    if (elementsBuffer)
                        elementsBuffer.bind();
                    program.bindAttributes(attributeBuffers);
                }
                state.currentRenderItemId = id;
            }
            if (_mol_util_debug__WEBPACK_IMPORTED_MODULE_8__["isDebugMode"]) {
                try {
                    Object(_framebuffer__WEBPACK_IMPORTED_MODULE_7__["checkFramebufferStatus"])(ctx.gl);
                }
                catch (e) {
                    throw new Error("Framebuffer error rendering item id " + id + ": '" + e + "'");
                }
            }
            if (elementsBuffer) {
                instancedArrays.drawElementsInstanced(glDrawMode, drawCount, elementsBuffer._dataType, 0, instanceCount);
            }
            else {
                instancedArrays.drawArraysInstanced(glDrawMode, 0, drawCount, instanceCount);
            }
            if (_mol_util_debug__WEBPACK_IMPORTED_MODULE_8__["isDebugMode"]) {
                try {
                    Object(_context__WEBPACK_IMPORTED_MODULE_3__["checkError"])(ctx.gl);
                }
                catch (e) {
                    throw new Error("Draw error rendering item id " + id + ": '" + e + "'");
                }
            }
        },
        update: function () {
            resetValueChanges(valueChanges);
            if (values.aVertex) {
                var vertexCount = values.uVertexCount.ref.value;
                if (values.aVertex.ref.value.length < vertexCount) {
                    _mol_util__WEBPACK_IMPORTED_MODULE_6__["ValueCell"].update(values.aVertex, Object(_mol_util_array__WEBPACK_IMPORTED_MODULE_9__["fillSerial"])(new Float32Array(vertexCount)));
                }
            }
            for (var i = 0, il = defineValueEntries.length; i < il; ++i) {
                var _a = defineValueEntries[i], k = _a[0], value = _a[1];
                if (value.ref.version !== versions[k]) {
                    // console.log('define version changed', k);
                    valueChanges.defines = true;
                    versions[k] = value.ref.version;
                }
            }
            if (valueChanges.defines) {
                // console.log('some defines changed, need to rebuild programs');
                for (var _i = 0, renderVariants_3 = renderVariants; _i < renderVariants_3.length; _i++) {
                    var k = renderVariants_3[_i];
                    programs[k].destroy();
                    programs[k] = createProgramVariant(ctx, k, defineValues, shaderCode, schema);
                }
            }
            if (values.drawCount.ref.version !== versions.drawCount) {
                // console.log('drawCount version changed');
                stats.drawCount += values.drawCount.ref.value - drawCount;
                stats.instancedDrawCount += instanceCount * values.drawCount.ref.value - instanceCount * drawCount;
                drawCount = values.drawCount.ref.value;
                versions.drawCount = values.drawCount.ref.version;
            }
            if (values.instanceCount.ref.version !== versions.instanceCount) {
                // console.log('instanceCount version changed');
                stats.instanceCount += values.instanceCount.ref.value - instanceCount;
                stats.instancedDrawCount += values.instanceCount.ref.value * drawCount - instanceCount * drawCount;
                instanceCount = values.instanceCount.ref.value;
                versions.instanceCount = values.instanceCount.ref.version;
            }
            for (var i = 0, il = attributeBuffers.length; i < il; ++i) {
                var _b = attributeBuffers[i], k = _b[0], buffer = _b[1];
                var value = attributeValues[k];
                if (value.ref.version !== versions[k]) {
                    if (buffer.length >= value.ref.value.length) {
                        // console.log('attribute array large enough to update', buffer.id, k, value.ref.id, value.ref.version);
                        buffer.updateSubData(value.ref.value, 0, buffer.length);
                    }
                    else {
                        // console.log('attribute array too small, need to create new attribute', buffer.id, k, value.ref.id, value.ref.version);
                        buffer.destroy();
                        var _c = schema[k], itemSize = _c.itemSize, divisor = _c.divisor;
                        attributeBuffers[i][1] = resources.attribute(value.ref.value, itemSize, divisor);
                        valueChanges.attributes = true;
                    }
                    versions[k] = value.ref.version;
                }
            }
            if (elementsBuffer && values.elements.ref.version !== versions.elements) {
                if (elementsBuffer.length >= values.elements.ref.value.length) {
                    // console.log('elements array large enough to update', values.elements.ref.id, values.elements.ref.version);
                    elementsBuffer.updateSubData(values.elements.ref.value, 0, elementsBuffer.length);
                }
                else {
                    // console.log('elements array to small, need to create new elements', values.elements.ref.id, values.elements.ref.version);
                    elementsBuffer.destroy();
                    elementsBuffer = resources.elements(values.elements.ref.value);
                    valueChanges.elements = true;
                }
                versions.elements = values.elements.ref.version;
            }
            if (valueChanges.attributes || valueChanges.defines || valueChanges.elements) {
                // console.log('program/defines or buffers changed, update vaos');
                for (var _d = 0, renderVariants_4 = renderVariants; _d < renderVariants_4.length; _d++) {
                    var k = renderVariants_4[_d];
                    var vertexArray = vertexArrays[k];
                    if (vertexArray)
                        vertexArray.destroy();
                    vertexArrays[k] = vertexArrayObject ? resources.vertexArray(programs[k], attributeBuffers, elementsBuffer) : null;
                }
            }
            for (var i = 0, il = textures.length; i < il; ++i) {
                var _e = textures[i], k = _e[0], texture = _e[1];
                var value = textureValues[k];
                if (value.ref.version !== versions[k]) {
                    // update of textures with kind 'texture' is done externally
                    if (schema[k].kind !== 'texture') {
                        // console.log('texture version changed, uploading image', k);
                        texture.load(value.ref.value);
                        versions[k] = value.ref.version;
                        valueChanges.textures = true;
                    }
                    else {
                        textures[i][1] = value.ref.value;
                    }
                }
            }
            return valueChanges;
        },
        destroy: function () {
            if (!destroyed) {
                for (var _i = 0, renderVariants_5 = renderVariants; _i < renderVariants_5.length; _i++) {
                    var k = renderVariants_5[_i];
                    programs[k].destroy();
                    var vertexArray = vertexArrays[k];
                    if (vertexArray)
                        vertexArray.destroy();
                }
                textures.forEach(function (_a) {
                    var k = _a[0], texture = _a[1];
                    // lifetime of textures with kind 'texture' is defined externally
                    if (schema[k].kind !== 'texture') {
                        texture.destroy();
                    }
                });
                attributeBuffers.forEach(function (_a) {
                    var _ = _a[0], buffer = _a[1];
                    return buffer.destroy();
                });
                if (elementsBuffer)
                    elementsBuffer.destroy();
                destroyed = true;
            }
        }
    };
}
//# sourceMappingURL=render-item.js.map

/***/ }),

/***/ "./lib/mol-gl/webgl/render-target.js":
/*!*******************************************!*\
  !*** ./lib/mol-gl/webgl/render-target.js ***!
  \*******************************************/
/*! exports provided: createRenderTarget, createNullRenderTarget */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createRenderTarget", function() { return createRenderTarget; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createNullRenderTarget", function() { return createNullRenderTarget; });
/* harmony import */ var _mol_util_id_factory__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../mol-util/id-factory */ "./lib/mol-util/id-factory.js");
/* harmony import */ var _texture__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./texture */ "./lib/mol-gl/webgl/texture.js");
/* harmony import */ var _framebuffer__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./framebuffer */ "./lib/mol-gl/webgl/framebuffer.js");
/**
 * Copyright (c) 2018-2021 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */



var getNextRenderTargetId = Object(_mol_util_id_factory__WEBPACK_IMPORTED_MODULE_0__["idFactory"])();
function createRenderTarget(gl, resources, _width, _height, depth, type, filter) {
    if (depth === void 0) { depth = true; }
    if (type === void 0) { type = 'uint8'; }
    if (filter === void 0) { filter = 'nearest'; }
    var framebuffer = resources.framebuffer();
    var targetTexture = type === 'fp16'
        ? resources.texture('image-float16', 'rgba', 'fp16', filter)
        : type === 'float32'
            ? resources.texture('image-float32', 'rgba', 'float', filter)
            : resources.texture('image-uint8', 'rgba', 'ubyte', filter);
    // make a depth renderbuffer of the same size as the targetTexture
    var depthRenderbuffer = depth
        ? resources.renderbuffer('depth16', 'depth', _width, _height)
        : null;
    function init() {
        targetTexture.define(_width, _height);
        targetTexture.attachFramebuffer(framebuffer, 'color0');
        if (depthRenderbuffer)
            depthRenderbuffer.attachFramebuffer(framebuffer);
    }
    init();
    var destroyed = false;
    return {
        id: getNextRenderTargetId(),
        texture: targetTexture,
        framebuffer: framebuffer,
        getWidth: function () { return _width; },
        getHeight: function () { return _height; },
        bind: function () {
            framebuffer.bind();
        },
        setSize: function (width, height) {
            if (_width === width && _height === height) {
                return;
            }
            _width = width;
            _height = height;
            targetTexture.define(_width, _height);
            if (depthRenderbuffer)
                depthRenderbuffer.setSize(_width, _height);
        },
        reset: function () {
            init();
        },
        destroy: function () {
            if (destroyed)
                return;
            targetTexture.destroy();
            framebuffer.destroy();
            if (depthRenderbuffer)
                depthRenderbuffer.destroy();
            destroyed = true;
        }
    };
}
//
function createNullRenderTarget(gl) {
    return {
        id: getNextRenderTargetId(),
        texture: Object(_texture__WEBPACK_IMPORTED_MODULE_1__["createNullTexture"])(gl, 'image-uint8'),
        framebuffer: Object(_framebuffer__WEBPACK_IMPORTED_MODULE_2__["createNullFramebuffer"])(),
        getWidth: function () { return 0; },
        getHeight: function () { return 0; },
        bind: function () {
            gl.bindFramebuffer(gl.FRAMEBUFFER, null);
        },
        setSize: function () { },
        reset: function () { },
        destroy: function () { }
    };
}
//# sourceMappingURL=render-target.js.map

/***/ }),

/***/ "./lib/mol-gl/webgl/renderbuffer.js":
/*!******************************************!*\
  !*** ./lib/mol-gl/webgl/renderbuffer.js ***!
  \******************************************/
/*! exports provided: getFormat, getAttachment, createRenderbuffer */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getFormat", function() { return getFormat; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getAttachment", function() { return getAttachment; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createRenderbuffer", function() { return createRenderbuffer; });
/* harmony import */ var _mol_util_id_factory__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../mol-util/id-factory */ "./lib/mol-util/id-factory.js");
/* harmony import */ var _framebuffer__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./framebuffer */ "./lib/mol-gl/webgl/framebuffer.js");
/* harmony import */ var _mol_util_debug__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../mol-util/debug */ "./lib/mol-util/debug.js");
/**
 * Copyright (c) 2018-2020 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */



var getNextRenderbufferId = Object(_mol_util_id_factory__WEBPACK_IMPORTED_MODULE_0__["idFactory"])();
function getFormat(gl, format) {
    switch (format) {
        case 'depth16': return gl.DEPTH_COMPONENT16;
        case 'stencil8': return gl.STENCIL_INDEX8;
        case 'rgba4': return gl.RGBA4;
        case 'depth-stencil': return gl.DEPTH_STENCIL;
    }
}
function getAttachment(gl, attachment) {
    switch (attachment) {
        case 'depth': return gl.DEPTH_ATTACHMENT;
        case 'stencil': return gl.STENCIL_ATTACHMENT;
        case 'depth-stencil': return gl.DEPTH_STENCIL_ATTACHMENT;
        case 'color0': return gl.COLOR_ATTACHMENT0;
    }
}
function getRenderbuffer(gl) {
    var renderbuffer = gl.createRenderbuffer();
    if (renderbuffer === null) {
        throw new Error('Could not create WebGL renderbuffer');
    }
    return renderbuffer;
}
function createRenderbuffer(gl, format, attachment, _width, _height) {
    var _renderbuffer = getRenderbuffer(gl);
    var bind = function () { return gl.bindRenderbuffer(gl.RENDERBUFFER, _renderbuffer); };
    var _format = getFormat(gl, format);
    var _attachment = getAttachment(gl, attachment);
    function init() {
        bind();
        gl.renderbufferStorage(gl.RENDERBUFFER, _format, _width, _height);
    }
    init();
    var destroyed = false;
    return {
        id: getNextRenderbufferId(),
        bind: bind,
        attachFramebuffer: function (framebuffer) {
            framebuffer.bind();
            bind();
            gl.framebufferRenderbuffer(gl.FRAMEBUFFER, _attachment, gl.RENDERBUFFER, _renderbuffer);
            if (_mol_util_debug__WEBPACK_IMPORTED_MODULE_2__["isDebugMode"])
                Object(_framebuffer__WEBPACK_IMPORTED_MODULE_1__["checkFramebufferStatus"])(gl);
        },
        setSize: function (width, height) {
            _width = width;
            _height = height;
            init();
        },
        reset: function () {
            _renderbuffer = getRenderbuffer(gl);
            init();
        },
        destroy: function () {
            if (destroyed)
                return;
            gl.deleteRenderbuffer(_renderbuffer);
            destroyed = true;
        }
    };
}
//# sourceMappingURL=renderbuffer.js.map

/***/ }),

/***/ "./lib/mol-gl/webgl/resources.js":
/*!***************************************!*\
  !*** ./lib/mol-gl/webgl/resources.js ***!
  \***************************************/
/*! exports provided: createResources */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createResources", function() { return createResources; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _program__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./program */ "./lib/mol-gl/webgl/program.js");
/* harmony import */ var _shader__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./shader */ "./lib/mol-gl/webgl/shader.js");
/* harmony import */ var _framebuffer__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./framebuffer */ "./lib/mol-gl/webgl/framebuffer.js");
/* harmony import */ var _buffer__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./buffer */ "./lib/mol-gl/webgl/buffer.js");
/* harmony import */ var _mol_util_reference_cache__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../mol-util/reference-cache */ "./lib/mol-util/reference-cache.js");
/* harmony import */ var _mol_data_util__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../../mol-data/util */ "./lib/mol-data/util.js");
/* harmony import */ var _renderbuffer__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ./renderbuffer */ "./lib/mol-gl/webgl/renderbuffer.js");
/* harmony import */ var _texture__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ./texture */ "./lib/mol-gl/webgl/texture.js");
/* harmony import */ var _vertex_array__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ./vertex-array */ "./lib/mol-gl/webgl/vertex-array.js");
/**
 * Copyright (c) 2020-2021 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */










function defineValueHash(v) {
    return typeof v === 'boolean' ? (v ? 1 : 0) :
        typeof v === 'number' ? (v * 10000) : Object(_mol_data_util__WEBPACK_IMPORTED_MODULE_6__["hashString"])(v);
}
function wrapCached(resourceItem) {
    var wrapped = Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, resourceItem.value), { destroy: function () {
            resourceItem.free();
        } });
    return wrapped;
}
function createResources(gl, state, stats, extensions) {
    var sets = {
        attribute: new Set(),
        elements: new Set(),
        framebuffer: new Set(),
        program: new Set(),
        renderbuffer: new Set(),
        shader: new Set(),
        texture: new Set(),
        vertexArray: new Set(),
    };
    function wrap(name, resource) {
        sets[name].add(resource);
        stats.resourceCounts[name] += 1;
        return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, resource), { destroy: function () {
                resource.destroy();
                sets[name].delete(resource);
                stats.resourceCounts[name] -= 1;
            } });
    }
    var shaderCache = Object(_mol_util_reference_cache__WEBPACK_IMPORTED_MODULE_5__["createReferenceCache"])(function (props) { return JSON.stringify(props); }, function (props) { return wrap('shader', Object(_shader__WEBPACK_IMPORTED_MODULE_2__["createShader"])(gl, props)); }, function (shader) { shader.destroy(); });
    function getShader(type, source) {
        return wrapCached(shaderCache.get({ type: type, source: source }));
    }
    var programCache = Object(_mol_util_reference_cache__WEBPACK_IMPORTED_MODULE_5__["createReferenceCache"])(function (props) {
        var array = [props.shaderCode.id];
        Object.keys(props.defineValues).forEach(function (k) { return array.push(Object(_mol_data_util__WEBPACK_IMPORTED_MODULE_6__["hashString"])(k), defineValueHash(props.defineValues[k].ref.value)); });
        return Object(_mol_data_util__WEBPACK_IMPORTED_MODULE_6__["hashFnv32a"])(array).toString();
    }, function (props) { return wrap('program', Object(_program__WEBPACK_IMPORTED_MODULE_1__["createProgram"])(gl, state, extensions, getShader, props)); }, function (program) { program.destroy(); });
    return {
        attribute: function (array, itemSize, divisor, usageHint) {
            return wrap('attribute', Object(_buffer__WEBPACK_IMPORTED_MODULE_4__["createAttributeBuffer"])(gl, extensions, array, itemSize, divisor, usageHint));
        },
        elements: function (array, usageHint) {
            return wrap('elements', Object(_buffer__WEBPACK_IMPORTED_MODULE_4__["createElementsBuffer"])(gl, array, usageHint));
        },
        framebuffer: function () {
            return wrap('framebuffer', Object(_framebuffer__WEBPACK_IMPORTED_MODULE_3__["createFramebuffer"])(gl));
        },
        program: function (defineValues, shaderCode, schema) {
            return wrapCached(programCache.get({ defineValues: defineValues, shaderCode: shaderCode, schema: schema }));
        },
        renderbuffer: function (format, attachment, width, height) {
            return wrap('renderbuffer', Object(_renderbuffer__WEBPACK_IMPORTED_MODULE_7__["createRenderbuffer"])(gl, format, attachment, width, height));
        },
        shader: getShader,
        texture: function (kind, format, type, filter) {
            return wrap('texture', Object(_texture__WEBPACK_IMPORTED_MODULE_8__["createTexture"])(gl, extensions, kind, format, type, filter));
        },
        vertexArray: function (program, attributeBuffers, elementsBuffer) {
            return wrap('vertexArray', Object(_vertex_array__WEBPACK_IMPORTED_MODULE_9__["createVertexArray"])(extensions, program, attributeBuffers, elementsBuffer));
        },
        getByteCounts: function () {
            var texture = 0;
            sets.texture.forEach(function (r) {
                texture += r.getByteCount();
            });
            var attribute = 0;
            sets.attribute.forEach(function (r) {
                attribute += r.length * 4;
            });
            var elements = 0;
            sets.elements.forEach(function (r) {
                elements += r.length * 4;
            });
            return { texture: texture, attribute: attribute, elements: elements };
        },
        reset: function () {
            sets.attribute.forEach(function (r) { return r.reset(); });
            sets.elements.forEach(function (r) { return r.reset(); });
            sets.framebuffer.forEach(function (r) { return r.reset(); });
            sets.renderbuffer.forEach(function (r) { return r.reset(); });
            sets.shader.forEach(function (r) { return r.reset(); });
            sets.program.forEach(function (r) { return r.reset(); });
            sets.vertexArray.forEach(function (r) { return r.reset(); });
            sets.texture.forEach(function (r) { return r.reset(); });
        },
        destroy: function () {
            sets.attribute.forEach(function (r) { return r.destroy(); });
            sets.elements.forEach(function (r) { return r.destroy(); });
            sets.framebuffer.forEach(function (r) { return r.destroy(); });
            sets.renderbuffer.forEach(function (r) { return r.destroy(); });
            sets.shader.forEach(function (r) { return r.destroy(); });
            sets.program.forEach(function (r) { return r.destroy(); });
            sets.vertexArray.forEach(function (r) { return r.destroy(); });
            sets.texture.forEach(function (r) { return r.destroy(); });
            shaderCache.clear();
            programCache.clear();
        }
    };
}
//# sourceMappingURL=resources.js.map

/***/ }),

/***/ "./lib/mol-gl/webgl/shader.js":
/*!************************************!*\
  !*** ./lib/mol-gl/webgl/shader.js ***!
  \************************************/
/*! exports provided: getShader, createShader */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getShader", function() { return getShader; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createShader", function() { return createShader; });
/* harmony import */ var _mol_util_id_factory__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../mol-util/id-factory */ "./lib/mol-util/id-factory.js");
/* harmony import */ var _mol_util_debug__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../mol-util/debug */ "./lib/mol-util/debug.js");
/**
 * Copyright (c) 2018-2020 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */


var getNextShaderId = Object(_mol_util_id_factory__WEBPACK_IMPORTED_MODULE_0__["idFactory"])();
function addLineNumbers(source) {
    var lines = source.split('\n');
    for (var i = 0; i < lines.length; ++i) {
        lines[i] = (i + 1) + ': ' + lines[i];
    }
    return lines.join('\n');
}
function getShader(gl, props) {
    var type = props.type, source = props.source;
    var shader = gl.createShader(type === 'vert' ? gl.VERTEX_SHADER : gl.FRAGMENT_SHADER);
    if (shader === null) {
        throw new Error("Error creating " + type + " shader");
    }
    gl.shaderSource(shader, source);
    gl.compileShader(shader);
    if (_mol_util_debug__WEBPACK_IMPORTED_MODULE_1__["isDebugMode"] && gl.getShaderParameter(shader, gl.COMPILE_STATUS) === false) {
        console.warn("'" + type + "' shader info log '" + gl.getShaderInfoLog(shader) + "'\n" + addLineNumbers(source));
        throw new Error("Error compiling " + type + " shader");
    }
    return shader;
}
function createShader(gl, props) {
    var shader = getShader(gl, props);
    return {
        id: getNextShaderId(),
        attach: function (program) {
            gl.attachShader(program, shader);
        },
        reset: function () {
            shader = getShader(gl, props);
        },
        destroy: function () {
            gl.deleteShader(shader);
        }
    };
}
//# sourceMappingURL=shader.js.map

/***/ }),

/***/ "./lib/mol-gl/webgl/state.js":
/*!***********************************!*\
  !*** ./lib/mol-gl/webgl/state.js ***!
  \***********************************/
/*! exports provided: createState */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createState", function() { return createState; });
/**
 * Copyright (c) 2018-2019 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */
function createState(gl) {
    var enabledCapabilities = {};
    var currentFrontFace = gl.getParameter(gl.FRONT_FACE);
    var currentCullFace = gl.getParameter(gl.CULL_FACE_MODE);
    var currentDepthMask = gl.getParameter(gl.DEPTH_WRITEMASK);
    var currentColorMask = gl.getParameter(gl.COLOR_WRITEMASK);
    var currentClearColor = gl.getParameter(gl.COLOR_CLEAR_VALUE);
    var currentBlendSrcRGB = gl.getParameter(gl.BLEND_SRC_RGB);
    var currentBlendDstRGB = gl.getParameter(gl.BLEND_DST_RGB);
    var currentBlendSrcAlpha = gl.getParameter(gl.BLEND_SRC_ALPHA);
    var currentBlendDstAlpha = gl.getParameter(gl.BLEND_DST_ALPHA);
    var currentBlendEqRGB = gl.getParameter(gl.BLEND_EQUATION_RGB);
    var currentBlendEqAlpha = gl.getParameter(gl.BLEND_EQUATION_ALPHA);
    return {
        currentProgramId: -1,
        currentMaterialId: -1,
        currentRenderItemId: -1,
        enable: function (cap) {
            if (enabledCapabilities[cap] !== true) {
                gl.enable(cap);
                enabledCapabilities[cap] = true;
            }
        },
        disable: function (cap) {
            if (enabledCapabilities[cap] !== false) {
                gl.disable(cap);
                enabledCapabilities[cap] = false;
            }
        },
        frontFace: function (mode) {
            if (mode !== currentFrontFace) {
                gl.frontFace(mode);
                currentFrontFace = mode;
            }
        },
        cullFace: function (mode) {
            if (mode !== currentCullFace) {
                gl.cullFace(mode);
                currentCullFace = mode;
            }
        },
        depthMask: function (flag) {
            if (flag !== currentDepthMask) {
                gl.depthMask(flag);
                currentDepthMask = flag;
            }
        },
        colorMask: function (red, green, blue, alpha) {
            if (red !== currentColorMask[0] || green !== currentColorMask[1] || blue !== currentColorMask[2] || alpha !== currentColorMask[3]) {
                gl.colorMask(red, green, blue, alpha);
                currentColorMask[0] = red;
                currentColorMask[1] = green;
                currentColorMask[2] = blue;
                currentColorMask[3] = alpha;
            }
        },
        clearColor: function (red, green, blue, alpha) {
            if (red !== currentClearColor[0] || green !== currentClearColor[1] || blue !== currentClearColor[2] || alpha !== currentClearColor[3]) {
                gl.clearColor(red, green, blue, alpha);
                currentClearColor[0] = red;
                currentClearColor[1] = green;
                currentClearColor[2] = blue;
                currentClearColor[3] = alpha;
            }
        },
        blendFunc: function (src, dst) {
            if (src !== currentBlendSrcRGB || dst !== currentBlendDstRGB || src !== currentBlendSrcAlpha || dst !== currentBlendDstAlpha) {
                gl.blendFunc(src, dst);
                currentBlendSrcRGB = src;
                currentBlendDstRGB = dst;
                currentBlendSrcAlpha = src;
                currentBlendDstAlpha = dst;
            }
        },
        blendFuncSeparate: function (srcRGB, dstRGB, srcAlpha, dstAlpha) {
            if (srcRGB !== currentBlendSrcRGB || dstRGB !== currentBlendDstRGB || srcAlpha !== currentBlendSrcAlpha || dstAlpha !== currentBlendDstAlpha) {
                gl.blendFuncSeparate(srcRGB, dstRGB, srcAlpha, dstAlpha);
                currentBlendSrcRGB = srcRGB;
                currentBlendDstRGB = dstRGB;
                currentBlendSrcAlpha = srcAlpha;
                currentBlendDstAlpha = dstAlpha;
            }
        },
        blendEquation: function (mode) {
            if (mode !== currentBlendEqRGB || mode !== currentBlendEqAlpha) {
                gl.blendEquation(mode);
                currentBlendEqRGB = mode;
                currentBlendEqAlpha = mode;
            }
        },
        blendEquationSeparate: function (modeRGB, modeAlpha) {
            if (modeRGB !== currentBlendEqRGB || modeAlpha !== currentBlendEqAlpha) {
                gl.blendEquationSeparate(modeRGB, modeAlpha);
                currentBlendEqRGB = modeRGB;
                currentBlendEqAlpha = modeAlpha;
            }
        },
        reset: function () {
            enabledCapabilities = {};
            currentFrontFace = gl.getParameter(gl.FRONT_FACE);
            currentCullFace = gl.getParameter(gl.CULL_FACE_MODE);
            currentDepthMask = gl.getParameter(gl.DEPTH_WRITEMASK);
            currentColorMask = gl.getParameter(gl.COLOR_WRITEMASK);
            currentClearColor = gl.getParameter(gl.COLOR_CLEAR_VALUE);
            currentBlendSrcRGB = gl.getParameter(gl.BLEND_SRC_RGB);
            currentBlendDstRGB = gl.getParameter(gl.BLEND_DST_RGB);
            currentBlendSrcAlpha = gl.getParameter(gl.BLEND_SRC_ALPHA);
            currentBlendDstAlpha = gl.getParameter(gl.BLEND_DST_ALPHA);
            currentBlendEqRGB = gl.getParameter(gl.BLEND_EQUATION_RGB);
            currentBlendEqAlpha = gl.getParameter(gl.BLEND_EQUATION_ALPHA);
        }
    };
}
//# sourceMappingURL=state.js.map

/***/ }),

/***/ "./lib/mol-gl/webgl/texture.js":
/*!*************************************!*\
  !*** ./lib/mol-gl/webgl/texture.js ***!
  \*************************************/
/*! exports provided: getTarget, getFormat, getInternalFormat, getType, getFilter, getAttachment, createTexture, createTextures, loadImageTexture, createNullTexture */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getTarget", function() { return getTarget; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getFormat", function() { return getFormat; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getInternalFormat", function() { return getInternalFormat; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getType", function() { return getType; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getFilter", function() { return getFilter; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getAttachment", function() { return getAttachment; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createTexture", function() { return createTexture; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createTextures", function() { return createTextures; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "loadImageTexture", function() { return loadImageTexture; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createNullTexture", function() { return createNullTexture; });
/* harmony import */ var _mol_util__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../mol-util */ "./lib/mol-util/index.js");
/* harmony import */ var _mol_util_id_factory__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../mol-util/id-factory */ "./lib/mol-util/id-factory.js");
/* harmony import */ var _compat__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./compat */ "./lib/mol-gl/webgl/compat.js");
/**
 * Copyright (c) 2018-2021 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */



var getNextTextureId = Object(_mol_util_id_factory__WEBPACK_IMPORTED_MODULE_1__["idFactory"])();
function getTarget(gl, kind) {
    switch (kind) {
        case 'image-uint8': return gl.TEXTURE_2D;
        case 'image-float32': return gl.TEXTURE_2D;
        case 'image-float16': return gl.TEXTURE_2D;
        case 'image-depth': return gl.TEXTURE_2D;
    }
    if (Object(_compat__WEBPACK_IMPORTED_MODULE_2__["isWebGL2"])(gl)) {
        switch (kind) {
            case 'image-int32': return gl.TEXTURE_2D;
            case 'volume-uint8': return gl.TEXTURE_3D;
            case 'volume-float32': return gl.TEXTURE_3D;
            case 'volume-float16': return gl.TEXTURE_3D;
        }
    }
    throw new Error("unknown texture kind '" + kind + "'");
}
function getFormat(gl, format, type) {
    switch (format) {
        case 'alpha':
            if (Object(_compat__WEBPACK_IMPORTED_MODULE_2__["isWebGL2"])(gl) && type === 'float')
                return gl.RED;
            else
                return gl.ALPHA;
        case 'rgb':
            if (Object(_compat__WEBPACK_IMPORTED_MODULE_2__["isWebGL2"])(gl) && type === 'int')
                return gl.RGB_INTEGER;
            return gl.RGB;
        case 'rgba':
            if (Object(_compat__WEBPACK_IMPORTED_MODULE_2__["isWebGL2"])(gl) && type === 'int')
                return gl.RGBA_INTEGER;
            return gl.RGBA;
        case 'depth': return gl.DEPTH_COMPONENT;
    }
}
function getInternalFormat(gl, format, type) {
    if (Object(_compat__WEBPACK_IMPORTED_MODULE_2__["isWebGL2"])(gl)) {
        switch (format) {
            case 'alpha':
                switch (type) {
                    case 'ubyte': return gl.ALPHA;
                    case 'float': return gl.R32F;
                    case 'fp16': return gl.R16F;
                    case 'int': return gl.R32I;
                }
            case 'rgb':
                switch (type) {
                    case 'ubyte': return gl.RGB;
                    case 'float': return gl.RGB32F;
                    case 'fp16': return gl.RGB16F;
                    case 'int': return gl.RGB32I;
                }
            case 'rgba':
                switch (type) {
                    case 'ubyte': return gl.RGBA;
                    case 'float': return gl.RGBA32F;
                    case 'fp16': return gl.RGBA16F;
                    case 'int': return gl.RGBA32I;
                }
            case 'depth':
                return gl.DEPTH_COMPONENT16;
        }
    }
    return getFormat(gl, format, type);
}
function getByteCount(format, type, width, height, depth) {
    var bpe = getFormatSize(format) * getTypeSize(type);
    return bpe * width * height * (depth || 1);
}
function getFormatSize(format) {
    switch (format) {
        case 'alpha': return 1;
        case 'rgb': return 3;
        case 'rgba': return 4;
        case 'depth': return 4;
    }
}
function getTypeSize(type) {
    switch (type) {
        case 'ubyte': return 1;
        case 'ushort': return 2;
        case 'float': return 4;
        case 'fp16': return 2;
        case 'int': return 4;
    }
}
function getType(gl, extensions, type) {
    switch (type) {
        case 'ubyte': return gl.UNSIGNED_BYTE;
        case 'ushort': return gl.UNSIGNED_SHORT;
        case 'float': return gl.FLOAT;
        case 'fp16':
            if (extensions.textureHalfFloat)
                return extensions.textureHalfFloat.HALF_FLOAT;
            else
                throw new Error('extension "texture_half_float" unavailable');
        case 'int':
            if (Object(_compat__WEBPACK_IMPORTED_MODULE_2__["isWebGL2"])(gl))
                return gl.INT;
            else
                throw new Error('texture type "int" requires webgl2');
    }
}
function getFilter(gl, type) {
    switch (type) {
        case 'nearest': return gl.NEAREST;
        case 'linear': return gl.LINEAR;
    }
}
function getAttachment(gl, extensions, attachment) {
    switch (attachment) {
        case 'depth': return gl.DEPTH_ATTACHMENT;
        case 'stencil': return gl.STENCIL_ATTACHMENT;
        case 'color0':
        case 0: return gl.COLOR_ATTACHMENT0;
    }
    if (extensions.drawBuffers) {
        switch (attachment) {
            case 'color1':
            case 1: return extensions.drawBuffers.COLOR_ATTACHMENT1;
            case 'color2':
            case 2: return extensions.drawBuffers.COLOR_ATTACHMENT2;
            case 'color3':
            case 3: return extensions.drawBuffers.COLOR_ATTACHMENT3;
            case 'color4':
            case 4: return extensions.drawBuffers.COLOR_ATTACHMENT4;
            case 'color5':
            case 5: return extensions.drawBuffers.COLOR_ATTACHMENT5;
            case 'color6':
            case 6: return extensions.drawBuffers.COLOR_ATTACHMENT6;
            case 'color7':
            case 7: return extensions.drawBuffers.COLOR_ATTACHMENT7;
        }
    }
    throw new Error('unknown texture attachment');
}
function isImage(x) {
    return typeof HTMLImageElement !== undefined && (x instanceof HTMLImageElement);
}
function isTexture2d(x, target, gl) {
    return target === gl.TEXTURE_2D;
}
function isTexture3d(x, target, gl) {
    return target === gl.TEXTURE_3D;
}
function getTexture(gl) {
    var texture = gl.createTexture();
    if (texture === null) {
        throw new Error('Could not create WebGL texture');
    }
    return texture;
}
function createTexture(gl, extensions, kind, _format, _type, _filter) {
    var id = getNextTextureId();
    var texture = getTexture(gl);
    // check texture kind and type compatability
    if ((kind.endsWith('float32') && _type !== 'float') ||
        (kind.endsWith('float16') && _type !== 'fp16') ||
        (kind.endsWith('uint8') && _type !== 'ubyte') ||
        (kind.endsWith('int32') && _type !== 'int') ||
        (kind.endsWith('depth') && _type !== 'ushort')) {
        throw new Error("texture kind '" + kind + "' and type '" + _type + "' are incompatible");
    }
    var target = getTarget(gl, kind);
    var filter = getFilter(gl, _filter);
    var format = getFormat(gl, _format, _type);
    var internalFormat = getInternalFormat(gl, _format, _type);
    var type = getType(gl, extensions, _type);
    function init() {
        gl.bindTexture(target, texture);
        gl.texParameteri(target, gl.TEXTURE_MAG_FILTER, filter);
        gl.texParameteri(target, gl.TEXTURE_MIN_FILTER, filter);
        // clamp-to-edge needed for non-power-of-two textures in webgl
        gl.texParameteri(target, gl.TEXTURE_WRAP_S, gl.CLAMP_TO_EDGE);
        gl.texParameteri(target, gl.TEXTURE_WRAP_T, gl.CLAMP_TO_EDGE);
        gl.bindTexture(target, null);
    }
    init();
    var width = 0, height = 0, depth = 0;
    var loadedData;
    var destroyed = false;
    function define(_width, _height, _depth) {
        if (width === _width && height === _height && depth === (_depth || 0))
            return;
        width = _width, height = _height, depth = _depth || 0;
        gl.bindTexture(target, texture);
        if (target === gl.TEXTURE_2D) {
            gl.texImage2D(target, 0, internalFormat, width, height, 0, format, type, null);
        }
        else if (Object(_compat__WEBPACK_IMPORTED_MODULE_2__["isWebGL2"])(gl) && target === gl.TEXTURE_3D && depth !== undefined) {
            gl.texImage3D(target, 0, internalFormat, width, height, depth, 0, format, type, null);
        }
        else {
            throw new Error('unknown texture target');
        }
    }
    function load(data, sub) {
        if (sub === void 0) { sub = false; }
        gl.bindTexture(target, texture);
        // unpack alignment of 1 since we use textures only for data
        gl.pixelStorei(gl.UNPACK_ALIGNMENT, 1);
        gl.pixelStorei(gl.UNPACK_COLORSPACE_CONVERSION_WEBGL, gl.NONE);
        gl.pixelStorei(gl.UNPACK_PREMULTIPLY_ALPHA_WEBGL, 0);
        if (isImage(data)) {
            gl.pixelStorei(gl.UNPACK_FLIP_Y_WEBGL, false);
            gl.bindTexture(gl.TEXTURE_2D, texture);
            gl.texImage2D(gl.TEXTURE_2D, 0, internalFormat, format, type, data);
        }
        else if (isTexture2d(data, target, gl)) {
            gl.pixelStorei(gl.UNPACK_FLIP_Y_WEBGL, !!data.flipY);
            if (sub) {
                gl.texSubImage2D(target, 0, 0, 0, data.width, data.height, format, type, data.array);
            }
            else {
                width = data.width, height = data.height;
                gl.texImage2D(target, 0, internalFormat, width, height, 0, format, type, data.array);
            }
        }
        else if (Object(_compat__WEBPACK_IMPORTED_MODULE_2__["isWebGL2"])(gl) && isTexture3d(data, target, gl)) {
            gl.pixelStorei(gl.UNPACK_FLIP_Y_WEBGL, false);
            if (sub) {
                gl.texSubImage3D(target, 0, 0, 0, 0, data.width, data.height, data.depth, format, type, data.array);
            }
            else {
                width = data.width, height = data.height, depth = data.depth;
                gl.texImage3D(target, 0, internalFormat, width, height, depth, 0, format, type, data.array);
            }
        }
        else {
            throw new Error('unknown texture target');
        }
        gl.bindTexture(target, null);
        loadedData = data;
    }
    function attachFramebuffer(framebuffer, attachment, layer) {
        framebuffer.bind();
        if (target === gl.TEXTURE_2D) {
            gl.framebufferTexture2D(gl.FRAMEBUFFER, getAttachment(gl, extensions, attachment), gl.TEXTURE_2D, texture, 0);
        }
        else if (Object(_compat__WEBPACK_IMPORTED_MODULE_2__["isWebGL2"])(gl) && target === gl.TEXTURE_3D) {
            if (layer === undefined)
                throw new Error('need `layer` to attach 3D texture');
            gl.framebufferTextureLayer(gl.FRAMEBUFFER, getAttachment(gl, extensions, attachment), texture, 0, layer);
        }
        else {
            throw new Error('unknown/unsupported texture target');
        }
    }
    return {
        id: id,
        target: target,
        format: format,
        internalFormat: internalFormat,
        type: type,
        getWidth: function () { return width; },
        getHeight: function () { return height; },
        getDepth: function () { return depth; },
        getByteCount: function () { return getByteCount(_format, _type, width, height, depth); },
        define: define,
        load: load,
        bind: function (id) {
            gl.activeTexture(gl.TEXTURE0 + id);
            gl.bindTexture(target, texture);
        },
        unbind: function (id) {
            gl.activeTexture(gl.TEXTURE0 + id);
            gl.bindTexture(target, null);
        },
        attachFramebuffer: attachFramebuffer,
        detachFramebuffer: function (framebuffer, attachment) {
            framebuffer.bind();
            if (target === gl.TEXTURE_2D) {
                gl.framebufferTexture2D(gl.FRAMEBUFFER, getAttachment(gl, extensions, attachment), gl.TEXTURE_2D, null, 0);
            }
            else if (Object(_compat__WEBPACK_IMPORTED_MODULE_2__["isWebGL2"])(gl) && target === gl.TEXTURE_3D) {
                gl.framebufferTextureLayer(gl.FRAMEBUFFER, getAttachment(gl, extensions, attachment), null, 0, 0);
            }
            else {
                throw new Error('unknown texture target');
            }
        },
        reset: function () {
            texture = getTexture(gl);
            init();
            var _a = [width, height, depth], _width = _a[0], _height = _a[1], _depth = _a[2];
            width = 0, height = 0, depth = 0; // set to zero to trigger resize
            define(_width, _height, _depth);
            if (loadedData)
                load(loadedData);
        },
        destroy: function () {
            if (destroyed)
                return;
            gl.deleteTexture(texture);
            destroyed = true;
        }
    };
}
function createTextures(ctx, schema, values) {
    var resources = ctx.resources;
    var textures = [];
    Object.keys(schema).forEach(function (k) {
        var spec = schema[k];
        if (spec.type === 'texture') {
            var value = values[k];
            if (value) {
                if (spec.kind === 'texture') {
                    textures[textures.length] = [k, value.ref.value];
                }
                else {
                    var texture = resources.texture(spec.kind, spec.format, spec.dataType, spec.filter);
                    texture.load(value.ref.value);
                    textures[textures.length] = [k, texture];
                }
            }
        }
    });
    return textures;
}
/**
 * Loads an image from a url to a textures and triggers update asynchronously.
 * This will not work on node.js with a polyfill for HTMLImageElement.
 */
function loadImageTexture(src, cell, texture) {
    var img = new Image();
    img.onload = function () {
        texture.load(img);
        _mol_util__WEBPACK_IMPORTED_MODULE_0__["ValueCell"].update(cell, texture);
    };
    img.src = src;
}
//
function createNullTexture(gl, kind) {
    var target = getTarget(gl, kind);
    return {
        id: getNextTextureId(),
        target: target,
        format: 0,
        internalFormat: 0,
        type: 0,
        getWidth: function () { return 0; },
        getHeight: function () { return 0; },
        getDepth: function () { return 0; },
        getByteCount: function () { return 0; },
        define: function () { },
        load: function () { },
        bind: function (id) {
            gl.activeTexture(gl.TEXTURE0 + id);
            gl.bindTexture(target, null);
        },
        unbind: function (id) {
            gl.activeTexture(gl.TEXTURE0 + id);
            gl.bindTexture(target, null);
        },
        attachFramebuffer: function () { },
        detachFramebuffer: function () { },
        reset: function () { },
        destroy: function () { },
    };
}
//# sourceMappingURL=texture.js.map

/***/ }),

/***/ "./lib/mol-gl/webgl/uniform.js":
/*!*************************************!*\
  !*** ./lib/mol-gl/webgl/uniform.js ***!
  \*************************************/
/*! exports provided: getUniformType, getUniformSetters, getUniformGlslType, isUniformValueScalar */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getUniformType", function() { return getUniformType; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getUniformSetters", function() { return getUniformSetters; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getUniformGlslType", function() { return getUniformGlslType; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isUniformValueScalar", function() { return isUniformValueScalar; });
/**
 * Copyright (c) 2018-2020 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */
function getUniformType(gl, kind) {
    switch (kind) {
        case 'b':
        case 'b[]': return gl.BOOL;
        case 'f':
        case 'f[]': return gl.FLOAT;
        case 'i':
        case 'i[]': return gl.INT;
        case 'v2':
        case 'v2[]': return gl.FLOAT_VEC2;
        case 'v3':
        case 'v3[]': return gl.FLOAT_VEC3;
        case 'v4':
        case 'v4[]': return gl.FLOAT_VEC4;
        case 'm3':
        case 'm3[]': return gl.FLOAT_MAT3;
        case 'm4':
        case 'm4[]': return gl.FLOAT_MAT4;
        default: console.error("unknown uniform kind '" + kind + "'");
    }
}
function uniform1f(gl, location, value) { gl.uniform1f(location, value); }
function uniform1fv(gl, location, value) { gl.uniform1fv(location, value); }
function uniform1i(gl, location, value) { gl.uniform1i(location, value); }
function uniform1iv(gl, location, value) { gl.uniform1iv(location, value); }
function uniform2fv(gl, location, value) { gl.uniform2fv(location, value); }
function uniform3fv(gl, location, value) { gl.uniform3fv(location, value); }
function uniform4fv(gl, location, value) { gl.uniform4fv(location, value); }
function uniformMatrix3fv(gl, location, value) { gl.uniformMatrix3fv(location, false, value); }
function uniformMatrix4fv(gl, location, value) { gl.uniformMatrix4fv(location, false, value); }
function getUniformSetter(kind) {
    switch (kind) {
        case 'f': return uniform1f;
        case 'f[]': return uniform1fv;
        case 'i':
        case 't':
        case 'b': return uniform1i;
        case 'i[]':
        case 't[]':
        case 'b[]': return uniform1iv;
        case 'v2':
        case 'v2[]': return uniform2fv;
        case 'v3':
        case 'v3[]': return uniform3fv;
        case 'v4':
        case 'v4[]': return uniform4fv;
        case 'm3':
        case 'm3[]': return uniformMatrix3fv;
        case 'm4':
        case 'm4[]': return uniformMatrix4fv;
    }
}
function getUniformSetters(schema) {
    var setters = {};
    Object.keys(schema).forEach(function (k) {
        var spec = schema[k];
        if (spec.type === 'uniform') {
            setters[k] = getUniformSetter(spec.kind);
        }
        else if (spec.type === 'texture') {
            setters[k] = getUniformSetter('t');
        }
    });
    return setters;
}
function getUniformGlslType(kind) {
    switch (kind) {
        case 'f': return 'float';
        case 'i': return 'int';
        case 't': return 'sampler2D';
        case 'b': return 'bool';
        case 'v2': return 'vec2';
        case 'v3': return 'vec3';
        case 'v4': return 'vec4';
        case 'm3': return 'mat3';
        case 'm4': return 'mat4';
    }
    throw new Error(kind + " has no primitive GLSL type.");
}
function isUniformValueScalar(kind) {
    switch (kind) {
        case 'f':
        case 'i':
        case 'b':
            return true;
        default:
            return false;
    }
}
//# sourceMappingURL=uniform.js.map

/***/ }),

/***/ "./lib/mol-gl/webgl/vertex-array.js":
/*!******************************************!*\
  !*** ./lib/mol-gl/webgl/vertex-array.js ***!
  \******************************************/
/*! exports provided: createVertexArray */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createVertexArray", function() { return createVertexArray; });
/* harmony import */ var _mol_util_id_factory__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../mol-util/id-factory */ "./lib/mol-util/id-factory.js");
/**
 * Copyright (c) 2018-2020 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */

var getNextVertexArrayId = Object(_mol_util_id_factory__WEBPACK_IMPORTED_MODULE_0__["idFactory"])();
function getVertexArray(extensions) {
    var vertexArrayObject = extensions.vertexArrayObject;
    if (!vertexArrayObject) {
        throw new Error('VertexArrayObject not supported');
    }
    var vertexArray = vertexArrayObject.createVertexArray();
    if (!vertexArray) {
        throw new Error('Could not create WebGL vertex array');
    }
    return vertexArray;
}
function getVertexArrayObject(extensions) {
    var vertexArrayObject = extensions.vertexArrayObject;
    if (vertexArrayObject === null) {
        throw new Error('VertexArrayObject not supported');
    }
    return vertexArrayObject;
}
function createVertexArray(extensions, program, attributeBuffers, elementsBuffer) {
    var id = getNextVertexArrayId();
    var vertexArray = getVertexArray(extensions);
    var vertexArrayObject = getVertexArrayObject(extensions);
    function update() {
        vertexArrayObject.bindVertexArray(vertexArray);
        if (elementsBuffer)
            elementsBuffer.bind();
        program.bindAttributes(attributeBuffers);
        vertexArrayObject.bindVertexArray(null);
    }
    update();
    var destroyed = false;
    return {
        id: id,
        bind: function () {
            vertexArrayObject.bindVertexArray(vertexArray);
        },
        update: update,
        reset: function () {
            vertexArray = getVertexArray(extensions);
            vertexArrayObject = getVertexArrayObject(extensions);
            update();
        },
        destroy: function () {
            if (destroyed)
                return;
            vertexArrayObject.deleteVertexArray(vertexArray);
            destroyed = true;
        }
    };
}
//# sourceMappingURL=vertex-array.js.map

/***/ }),

/***/ "./lib/mol-io/common/binary-cif.js":
/*!*****************************************!*\
  !*** ./lib/mol-io/common/binary-cif.js ***!
  \*****************************************/
/*! exports provided: VERSION, Encoding, ArrayEncoderImpl, ArrayEncoder, ArrayEncoding, classifyIntArray, classifyFloatArray, decode */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _binary_cif_decoder__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./binary-cif/decoder */ "./lib/mol-io/common/binary-cif/decoder.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "decode", function() { return _binary_cif_decoder__WEBPACK_IMPORTED_MODULE_0__["default"]; });

/* harmony import */ var _binary_cif_encoding__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./binary-cif/encoding */ "./lib/mol-io/common/binary-cif/encoding.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "VERSION", function() { return _binary_cif_encoding__WEBPACK_IMPORTED_MODULE_1__["VERSION"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Encoding", function() { return _binary_cif_encoding__WEBPACK_IMPORTED_MODULE_1__["Encoding"]; });

/* harmony import */ var _binary_cif_array_encoder__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./binary-cif/array-encoder */ "./lib/mol-io/common/binary-cif/array-encoder.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ArrayEncoderImpl", function() { return _binary_cif_array_encoder__WEBPACK_IMPORTED_MODULE_2__["ArrayEncoderImpl"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ArrayEncoder", function() { return _binary_cif_array_encoder__WEBPACK_IMPORTED_MODULE_2__["ArrayEncoder"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ArrayEncoding", function() { return _binary_cif_array_encoder__WEBPACK_IMPORTED_MODULE_2__["ArrayEncoding"]; });

/* harmony import */ var _binary_cif_classifier__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./binary-cif/classifier */ "./lib/mol-io/common/binary-cif/classifier.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "classifyIntArray", function() { return _binary_cif_classifier__WEBPACK_IMPORTED_MODULE_3__["classifyIntArray"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "classifyFloatArray", function() { return _binary_cif_classifier__WEBPACK_IMPORTED_MODULE_3__["classifyFloatArray"]; });

/**
 * Copyright (c) 2017 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author David Sehnal <david.sehnal@gmail.com>
 */





//# sourceMappingURL=binary-cif.js.map

/***/ }),

/***/ "./lib/mol-io/common/binary-cif/array-encoder.js":
/*!*******************************************************!*\
  !*** ./lib/mol-io/common/binary-cif/array-encoder.js ***!
  \*******************************************************/
/*! exports provided: ArrayEncoderImpl, ArrayEncoder, ArrayEncoding */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ArrayEncoderImpl", function() { return ArrayEncoderImpl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ArrayEncoder", function() { return ArrayEncoder; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ArrayEncoding", function() { return ArrayEncoding; });
/* harmony import */ var _mol_data_util__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../../mol-data/util */ "./lib/mol-data/util.js");
/* harmony import */ var _encoding__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./encoding */ "./lib/mol-io/common/binary-cif/encoding.js");
/* harmony import */ var _classifier__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./classifier */ "./lib/mol-io/common/binary-cif/classifier.js");
/**
 * Copyright (c) 2017 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * Adapted from CIFTools.js (https://github.com/dsehnal/CIFTools.js; MIT) and MMTF (https://github.com/rcsb/mmtf-javascript/; MIT)
 *
 * @author David Sehnal <david.sehnal@gmail.com>
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */



var ArrayEncoderImpl = /** @class */ (function () {
    function ArrayEncoderImpl(providers) {
        this.providers = providers;
    }
    ArrayEncoderImpl.prototype.and = function (f) {
        return new ArrayEncoderImpl(this.providers.concat([f]));
    };
    ArrayEncoderImpl.prototype.encode = function (data) {
        var encoding = [];
        for (var _i = 0, _a = this.providers; _i < _a.length; _i++) {
            var p = _a[_i];
            var t = p(data);
            if (!t.encodings.length) {
                throw new Error('Encodings must be non-empty.');
            }
            data = t.data;
            for (var _b = 0, _c = t.encodings; _b < _c.length; _b++) {
                var e = _c[_b];
                encoding.push(e);
            }
        }
        if (!(data instanceof Uint8Array)) {
            throw new Error('The encoding must result in a Uint8Array. Fix your encoding chain.');
        }
        return {
            encoding: encoding,
            data: data
        };
    };
    return ArrayEncoderImpl;
}());

var ArrayEncoder;
(function (ArrayEncoder) {
    function by(f) {
        return new ArrayEncoderImpl([f]);
    }
    ArrayEncoder.by = by;
    function fromEncoding(encoding) {
        var e = by(getProvider(encoding[0]));
        for (var i = 1; i < encoding.length; i++)
            e = e.and(getProvider(encoding[i]));
        return e;
    }
    ArrayEncoder.fromEncoding = fromEncoding;
    function getProvider(e) {
        switch (e.kind) {
            case 'ByteArray': return ArrayEncoding.byteArray;
            case 'FixedPoint': return ArrayEncoding.fixedPoint(e.factor);
            case 'IntervalQuantization': return ArrayEncoding.intervalQuantizaiton(e.min, e.max, e.numSteps);
            case 'RunLength': return ArrayEncoding.runLength;
            case 'Delta': return ArrayEncoding.delta;
            case 'IntegerPacking': return ArrayEncoding.integerPacking;
            case 'StringArray': return ArrayEncoding.stringArray;
        }
    }
})(ArrayEncoder || (ArrayEncoder = {}));
var ArrayEncoding;
(function (ArrayEncoding) {
    var _a, _b;
    function by(f) {
        return new ArrayEncoderImpl([f]);
    }
    ArrayEncoding.by = by;
    function uint8(data) {
        return {
            encodings: [{ kind: 'ByteArray', type: 4 /* Uint8 */ }],
            data: data
        };
    }
    function int8(data) {
        return {
            encodings: [{ kind: 'ByteArray', type: 1 /* Int8 */ }],
            data: new Uint8Array(data.buffer, data.byteOffset)
        };
    }
    var writers = (_a = {},
        _a[2 /* Int16 */] = function (v, i, a) { v.setInt16(2 * i, a, true); },
        _a[5 /* Uint16 */] = function (v, i, a) { v.setUint16(2 * i, a, true); },
        _a[3 /* Int32 */] = function (v, i, a) { v.setInt32(4 * i, a, true); },
        _a[6 /* Uint32 */] = function (v, i, a) { v.setUint32(4 * i, a, true); },
        _a[32 /* Float32 */] = function (v, i, a) { v.setFloat32(4 * i, a, true); },
        _a[33 /* Float64 */] = function (v, i, a) { v.setFloat64(8 * i, a, true); },
        _a);
    var byteSizes = (_b = {},
        _b[2 /* Int16 */] = 2,
        _b[5 /* Uint16 */] = 2,
        _b[3 /* Int32 */] = 4,
        _b[6 /* Uint32 */] = 4,
        _b[32 /* Float32 */] = 4,
        _b[33 /* Float64 */] = 8,
        _b);
    function byteArray(data) {
        var type = _encoding__WEBPACK_IMPORTED_MODULE_1__["Encoding"].getDataType(data);
        if (type === 1 /* Int8 */)
            return int8(data);
        else if (type === 4 /* Uint8 */)
            return uint8(data);
        var result = new Uint8Array(data.length * byteSizes[type]);
        var w = writers[type];
        var view = new DataView(result.buffer);
        for (var i = 0, n = data.length; i < n; i++) {
            w(view, i, data[i]);
        }
        return {
            encodings: [{ kind: 'ByteArray', type: type }],
            data: result
        };
    }
    ArrayEncoding.byteArray = byteArray;
    function _fixedPoint(data, factor) {
        var srcType = _encoding__WEBPACK_IMPORTED_MODULE_1__["Encoding"].getDataType(data);
        var result = new Int32Array(data.length);
        for (var i = 0, n = data.length; i < n; i++) {
            result[i] = Math.round(data[i] * factor);
        }
        return {
            encodings: [{ kind: 'FixedPoint', factor: factor, srcType: srcType }],
            data: result
        };
    }
    function fixedPoint(factor) { return function (data) { return _fixedPoint(data, factor); }; }
    ArrayEncoding.fixedPoint = fixedPoint;
    function _intervalQuantizaiton(data, min, max, numSteps, arrayType) {
        var srcType = _encoding__WEBPACK_IMPORTED_MODULE_1__["Encoding"].getDataType(data);
        if (!data.length) {
            return {
                encodings: [{ kind: 'IntervalQuantization', min: min, max: max, numSteps: numSteps, srcType: srcType }],
                data: new Int32Array(0)
            };
        }
        if (max < min) {
            var t = min;
            min = max;
            max = t;
        }
        var delta = (max - min) / (numSteps - 1);
        var output = new arrayType(data.length);
        for (var i = 0, n = data.length; i < n; i++) {
            var v = data[i];
            if (v <= min)
                output[i] = 0;
            else if (v >= max)
                output[i] = numSteps - 1;
            else
                output[i] = (Math.round((v - min) / delta)) | 0;
        }
        return {
            encodings: [{ kind: 'IntervalQuantization', min: min, max: max, numSteps: numSteps, srcType: srcType }],
            data: output
        };
    }
    function intervalQuantizaiton(min, max, numSteps, arrayType) {
        if (arrayType === void 0) { arrayType = Int32Array; }
        return function (data) { return _intervalQuantizaiton(data, min, max, numSteps, arrayType); };
    }
    ArrayEncoding.intervalQuantizaiton = intervalQuantizaiton;
    function runLength(data) {
        var srcType = _encoding__WEBPACK_IMPORTED_MODULE_1__["Encoding"].getDataType(data);
        if (srcType === void 0) {
            data = new Int32Array(data);
            srcType = 3 /* Int32 */;
        }
        if (!data.length) {
            return {
                encodings: [{ kind: 'RunLength', srcType: srcType, srcSize: 0 }],
                data: new Int32Array(0)
            };
        }
        // calculate output size
        var fullLength = 2;
        for (var i = 1, il = data.length; i < il; i++) {
            if (data[i - 1] !== data[i]) {
                fullLength += 2;
            }
        }
        var output = new Int32Array(fullLength);
        var offset = 0;
        var runLength = 1;
        for (var i = 1, il = data.length; i < il; i++) {
            if (data[i - 1] !== data[i]) {
                output[offset] = data[i - 1];
                output[offset + 1] = runLength;
                runLength = 1;
                offset += 2;
            }
            else {
                ++runLength;
            }
        }
        output[offset] = data[data.length - 1];
        output[offset + 1] = runLength;
        return {
            encodings: [{ kind: 'RunLength', srcType: srcType, srcSize: data.length }],
            data: output
        };
    }
    ArrayEncoding.runLength = runLength;
    function delta(data) {
        if (!_encoding__WEBPACK_IMPORTED_MODULE_1__["Encoding"].isSignedIntegerDataType(data)) {
            throw new Error('Only signed integer types can be encoded using delta encoding.');
        }
        var srcType = _encoding__WEBPACK_IMPORTED_MODULE_1__["Encoding"].getDataType(data);
        if (srcType === void 0) {
            data = new Int32Array(data);
            srcType = 3 /* Int32 */;
        }
        if (!data.length) {
            return {
                encodings: [{ kind: 'Delta', origin: 0, srcType: srcType }],
                data: new data.constructor(0)
            };
        }
        var output = new data.constructor(data.length);
        var origin = data[0];
        output[0] = data[0];
        for (var i = 1, n = data.length; i < n; i++) {
            output[i] = data[i] - data[i - 1];
        }
        output[0] = 0;
        return {
            encodings: [{ kind: 'Delta', origin: origin, srcType: srcType }],
            data: output
        };
    }
    ArrayEncoding.delta = delta;
    function isSigned(data) {
        for (var i = 0, n = data.length; i < n; i++) {
            if (data[i] < 0)
                return true;
        }
        return false;
    }
    function packingSize(data, upperLimit) {
        var lowerLimit = -upperLimit - 1;
        var size = 0;
        for (var i = 0, n = data.length; i < n; i++) {
            var value = data[i];
            if (value === 0) {
                size += 1;
            }
            else if (value > 0) {
                size += Math.ceil(value / upperLimit);
                if (value % upperLimit === 0)
                    size += 1;
            }
            else {
                size += Math.ceil(value / lowerLimit);
                if (value % lowerLimit === 0)
                    size += 1;
            }
        }
        return size;
    }
    function determinePacking(data) {
        var signed = isSigned(data);
        var size8 = signed ? packingSize(data, 0x7F) : packingSize(data, 0xFF);
        var size16 = signed ? packingSize(data, 0x7FFF) : packingSize(data, 0xFFFF);
        if (data.length * 4 < size16 * 2) {
            // 4 byte packing is the most effective
            return {
                isSigned: signed,
                size: data.length,
                bytesPerElement: 4
            };
        }
        else if (size16 * 2 < size8) {
            // 2 byte packing is the most effective
            return {
                isSigned: signed,
                size: size16,
                bytesPerElement: 2
            };
        }
        else {
            // 1 byte packing is the most effective
            return {
                isSigned: signed,
                size: size8,
                bytesPerElement: 1
            };
        }
        ;
    }
    function _integerPacking(data, packing) {
        var upperLimit = packing.isSigned
            ? (packing.bytesPerElement === 1 ? 0x7F : 0x7FFF)
            : (packing.bytesPerElement === 1 ? 0xFF : 0xFFFF);
        var lowerLimit = -upperLimit - 1;
        var n = data.length;
        var packed = packing.isSigned
            ? packing.bytesPerElement === 1 ? new Int8Array(packing.size) : new Int16Array(packing.size)
            : packing.bytesPerElement === 1 ? new Uint8Array(packing.size) : new Uint16Array(packing.size);
        var j = 0;
        for (var i = 0; i < n; i++) {
            var value = data[i];
            if (value >= 0) {
                while (value >= upperLimit) {
                    packed[j] = upperLimit;
                    ++j;
                    value -= upperLimit;
                }
            }
            else {
                while (value <= lowerLimit) {
                    packed[j] = lowerLimit;
                    ++j;
                    value -= lowerLimit;
                }
            }
            packed[j] = value;
            ++j;
        }
        var result = byteArray(packed);
        return {
            encodings: [{
                    kind: 'IntegerPacking',
                    byteCount: packing.bytesPerElement,
                    isUnsigned: !packing.isSigned,
                    srcSize: n
                },
                result.encodings[0]
            ],
            data: result.data
        };
    }
    /**
     * Packs Int32 array. The packing level is determined automatically to either 1-, 2-, or 4-byte words.
     */
    function integerPacking(data) {
        // if (!(data instanceof Int32Array)) {
        //     throw new Error('Integer packing can only be applied to Int32 data.');
        // }
        var packing = determinePacking(data);
        if (packing.bytesPerElement === 4) {
            // no packing done, Int32 encoding will be used
            return byteArray(data);
        }
        return _integerPacking(data, packing);
    }
    ArrayEncoding.integerPacking = integerPacking;
    function stringArray(data) {
        var map = Object.create(null);
        var strings = [];
        var output = new Int32Array(data.length);
        var offsets = _mol_data_util__WEBPACK_IMPORTED_MODULE_0__["ChunkedArray"].create(Int32Array, 1, Math.min(1024, data.length < 32 ? data.length + 1 : Math.round(data.length / 8) + 1));
        _mol_data_util__WEBPACK_IMPORTED_MODULE_0__["ChunkedArray"].add(offsets, 0);
        var accLength = 0;
        var i = 0;
        for (var _i = 0, data_1 = data; _i < data_1.length; _i++) {
            var s = data_1[_i];
            // handle null strings.
            if (s === null || s === void 0) {
                output[i++] = -1;
                continue;
            }
            var index = map[s];
            if (index === void 0) {
                // increment the length
                accLength += s.length;
                // store the string and index
                index = strings.length;
                strings[index] = s;
                map[s] = index;
                // write the offset
                _mol_data_util__WEBPACK_IMPORTED_MODULE_0__["ChunkedArray"].add(offsets, accLength);
            }
            output[i++] = index;
        }
        var offsetArray = _mol_data_util__WEBPACK_IMPORTED_MODULE_0__["ChunkedArray"].compact(offsets);
        var offsetEncoding = Object(_classifier__WEBPACK_IMPORTED_MODULE_2__["classifyIntArray"])(offsetArray);
        var encodedOddsets = offsetEncoding.encode(offsetArray);
        var dataEncoding = Object(_classifier__WEBPACK_IMPORTED_MODULE_2__["classifyIntArray"])(output);
        var encodedData = dataEncoding.encode(output);
        return {
            encodings: [{ kind: 'StringArray', dataEncoding: encodedData.encoding, stringData: strings.join(''), offsetEncoding: encodedOddsets.encoding, offsets: encodedOddsets.data }],
            data: encodedData.data
        };
    }
    ArrayEncoding.stringArray = stringArray;
})(ArrayEncoding || (ArrayEncoding = {}));
//# sourceMappingURL=array-encoder.js.map

/***/ }),

/***/ "./lib/mol-io/common/binary-cif/classifier.js":
/*!****************************************************!*\
  !*** ./lib/mol-io/common/binary-cif/classifier.js ***!
  \****************************************************/
/*! exports provided: classifyIntArray, classifyFloatArray */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "classifyIntArray", function() { return classifyIntArray; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "classifyFloatArray", function() { return classifyFloatArray; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _array_encoder__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./array-encoder */ "./lib/mol-io/common/binary-cif/array-encoder.js");
/* harmony import */ var _mol_util_number__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../../mol-util/number */ "./lib/mol-util/number.js");
/**
 * Copyright (c) 2018 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author David Sehnal <david.sehnal@gmail.com>
 */



function classifyIntArray(xs) {
    return IntClassifier.classify(xs);
}
function classifyFloatArray(xs) {
    return FloatClassifier.classify(xs);
}
var IntClassifier;
(function (IntClassifier) {
    function packSize(value, upperLimit) {
        return value >= 0
            ? Math.ceil((value + 1) / upperLimit)
            : Math.ceil((value + 1) / (-upperLimit - 1));
    }
    function getInfo(data) {
        var signed = false;
        for (var i = 0, n = data.length; i < n; i++) {
            if (data[i] < 0) {
                signed = true;
                break;
            }
        }
        return signed ? { signed: signed, limit8: 0x7F, limit16: 0x7FFF } : { signed: signed, limit8: 0xFF, limit16: 0xFFFF };
    }
    function SizeInfo() { return { pack8: 0, pack16: 0, count: 0 }; }
    ;
    function incSize(_a, info, value) {
        var limit8 = _a.limit8, limit16 = _a.limit16;
        info.pack8 += packSize(value, limit8);
        info.pack16 += packSize(value, limit16);
        info.count += 1;
    }
    function incSizeSigned(info, value) {
        info.pack8 += packSize(value, 0x7F);
        info.pack16 += packSize(value, 0x7FFF);
        info.count += 1;
    }
    function byteSize(info) {
        if (info.count * 4 < info.pack16 * 2)
            return { length: info.count * 4, elem: 4 };
        if (info.pack16 * 2 < info.pack8)
            return { length: info.pack16 * 2, elem: 2 };
        return { length: info.pack8, elem: 1 };
    }
    function packingSize(data, info) {
        var size = SizeInfo();
        for (var i = 0, n = data.length; i < n; i++) {
            incSize(info, size, data[i]);
        }
        return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, byteSize(size)), { kind: 'pack' });
    }
    function deltaSize(data, info) {
        var size = SizeInfo();
        var prev = data[0];
        for (var i = 1, n = data.length; i < n; i++) {
            incSizeSigned(size, data[i] - prev);
            prev = data[i];
        }
        return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, byteSize(size)), { kind: 'delta' });
    }
    function rleSize(data, info) {
        var size = SizeInfo();
        var run = 1;
        for (var i = 1, n = data.length; i < n; i++) {
            if (data[i - 1] !== data[i]) {
                incSize(info, size, data[i - 1]);
                incSize(info, size, run);
                run = 1;
            }
            else {
                run++;
            }
        }
        incSize(info, size, data[data.length - 1]);
        incSize(info, size, run);
        return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, byteSize(size)), { kind: 'rle' });
    }
    function deltaRleSize(data, info) {
        var size = SizeInfo();
        var run = 1, prev = 0, prevValue = 0;
        for (var i = 1, n = data.length; i < n; i++) {
            var v = data[i] - prev;
            if (prevValue !== v) {
                incSizeSigned(size, prevValue);
                incSizeSigned(size, run);
                run = 1;
            }
            else {
                run++;
            }
            prevValue = v;
            prev = data[i];
        }
        incSizeSigned(size, prevValue);
        incSizeSigned(size, run);
        return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, byteSize(size)), { kind: 'delta-rle' });
    }
    function getSize(data) {
        var info = getInfo(data);
        var sizes = [packingSize(data, info), rleSize(data, info), deltaSize(data, info), deltaRleSize(data, info)];
        sizes.sort(function (a, b) { return a.length - b.length; });
        return sizes;
    }
    IntClassifier.getSize = getSize;
    function classify(data) {
        if (data.length < 2)
            return _array_encoder__WEBPACK_IMPORTED_MODULE_1__["ArrayEncoding"].by(_array_encoder__WEBPACK_IMPORTED_MODULE_1__["ArrayEncoding"].byteArray);
        var sizes = getSize(data);
        var size = sizes[0];
        switch (size.kind) {
            case 'pack': return _array_encoder__WEBPACK_IMPORTED_MODULE_1__["ArrayEncoding"].by(_array_encoder__WEBPACK_IMPORTED_MODULE_1__["ArrayEncoding"].integerPacking);
            case 'rle': return _array_encoder__WEBPACK_IMPORTED_MODULE_1__["ArrayEncoding"].by(_array_encoder__WEBPACK_IMPORTED_MODULE_1__["ArrayEncoding"].runLength).and(_array_encoder__WEBPACK_IMPORTED_MODULE_1__["ArrayEncoding"].integerPacking);
            case 'delta': return _array_encoder__WEBPACK_IMPORTED_MODULE_1__["ArrayEncoding"].by(_array_encoder__WEBPACK_IMPORTED_MODULE_1__["ArrayEncoding"].delta).and(_array_encoder__WEBPACK_IMPORTED_MODULE_1__["ArrayEncoding"].integerPacking);
            case 'delta-rle': return _array_encoder__WEBPACK_IMPORTED_MODULE_1__["ArrayEncoding"].by(_array_encoder__WEBPACK_IMPORTED_MODULE_1__["ArrayEncoding"].delta).and(_array_encoder__WEBPACK_IMPORTED_MODULE_1__["ArrayEncoding"].runLength).and(_array_encoder__WEBPACK_IMPORTED_MODULE_1__["ArrayEncoding"].integerPacking);
        }
        throw new Error('should not happen :)');
    }
    IntClassifier.classify = classify;
})(IntClassifier || (IntClassifier = {}));
var FloatClassifier;
(function (FloatClassifier) {
    var delta = 1e-6;
    function classify(data) {
        var maxDigits = 4;
        var _a = Object(_mol_util_number__WEBPACK_IMPORTED_MODULE_2__["getArrayDigitCount"])(data, maxDigits, delta), mantissaDigits = _a.mantissaDigits, integerDigits = _a.integerDigits;
        // TODO: better check for overflows here?
        if (mantissaDigits < 0 || mantissaDigits + integerDigits > 10)
            return _array_encoder__WEBPACK_IMPORTED_MODULE_1__["ArrayEncoding"].by(_array_encoder__WEBPACK_IMPORTED_MODULE_1__["ArrayEncoding"].byteArray);
        // TODO: this needs a conversion to Int?Array?
        if (mantissaDigits === 0)
            return IntClassifier.classify(data);
        var multiplier = getMultiplier(mantissaDigits);
        var intArray = new Int32Array(data.length);
        for (var i = 0, n = data.length; i < n; i++) {
            intArray[i] = Math.round(multiplier * data[i]);
            // TODO: enable this again?
            // const v = Math.round(multiplier * data[i]);
            // if (Math.abs(Math.round(v) / multiplier - intArray[i] / multiplier) > delta) {
            //     return E.by(E.byteArray);
            // }
        }
        var sizes = IntClassifier.getSize(intArray);
        var size = sizes[0];
        var fp = _array_encoder__WEBPACK_IMPORTED_MODULE_1__["ArrayEncoding"].by(_array_encoder__WEBPACK_IMPORTED_MODULE_1__["ArrayEncoding"].fixedPoint(multiplier));
        switch (size.kind) {
            case 'pack': return fp.and(_array_encoder__WEBPACK_IMPORTED_MODULE_1__["ArrayEncoding"].integerPacking);
            case 'rle': return fp.and(_array_encoder__WEBPACK_IMPORTED_MODULE_1__["ArrayEncoding"].runLength).and(_array_encoder__WEBPACK_IMPORTED_MODULE_1__["ArrayEncoding"].integerPacking);
            case 'delta': return fp.and(_array_encoder__WEBPACK_IMPORTED_MODULE_1__["ArrayEncoding"].delta).and(_array_encoder__WEBPACK_IMPORTED_MODULE_1__["ArrayEncoding"].integerPacking);
            case 'delta-rle': return fp.and(_array_encoder__WEBPACK_IMPORTED_MODULE_1__["ArrayEncoding"].delta).and(_array_encoder__WEBPACK_IMPORTED_MODULE_1__["ArrayEncoding"].runLength).and(_array_encoder__WEBPACK_IMPORTED_MODULE_1__["ArrayEncoding"].integerPacking);
        }
        throw new Error('should not happen :)');
    }
    FloatClassifier.classify = classify;
    function getMultiplier(mantissaDigits) {
        var m = 1;
        for (var i = 0; i < mantissaDigits; i++)
            m *= 10;
        return m;
    }
})(FloatClassifier || (FloatClassifier = {}));
//# sourceMappingURL=classifier.js.map

/***/ }),

/***/ "./lib/mol-io/common/binary-cif/decoder.js":
/*!*************************************************!*\
  !*** ./lib/mol-io/common/binary-cif/decoder.js ***!
  \*************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return decode; });
/* harmony import */ var _binary__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../binary */ "./lib/mol-io/common/binary.js");
/**
 * Copyright (c) 2017 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * From CIFTools.js
 * @author David Sehnal <david.sehnal@gmail.com>
 */

/**
 * Fixed point, delta, RLE, integer packing adopted from https://github.com/rcsb/mmtf-javascript/
 * by Alexander Rose <alexander.rose@weirdbyte.de>, MIT License, Copyright (c) 2016
 */
function decode(data) {
    var current = data.data;
    for (var i = data.encoding.length - 1; i >= 0; i--) {
        current = decodeStep(current, data.encoding[i]);
    }
    return current;
}
function decodeStep(data, encoding) {
    switch (encoding.kind) {
        case 'ByteArray': {
            switch (encoding.type) {
                case 4 /* Uint8 */: return data;
                case 1 /* Int8 */: return int8(data);
                case 2 /* Int16 */: return int16(data);
                case 5 /* Uint16 */: return uint16(data);
                case 3 /* Int32 */: return int32(data);
                case 6 /* Uint32 */: return uint32(data);
                case 32 /* Float32 */: return float32(data);
                case 33 /* Float64 */: return float64(data);
                default: throw new Error('Unsupported ByteArray type.');
            }
        }
        case 'FixedPoint': return fixedPoint(data, encoding);
        case 'IntervalQuantization': return intervalQuantization(data, encoding);
        case 'RunLength': return runLength(data, encoding);
        case 'Delta': return delta(data, encoding);
        case 'IntegerPacking': return integerPacking(data, encoding);
        case 'StringArray': return stringArray(data, encoding);
    }
}
function getIntArray(type, size) {
    switch (type) {
        case 1 /* Int8 */: return new Int8Array(size);
        case 2 /* Int16 */: return new Int16Array(size);
        case 3 /* Int32 */: return new Int32Array(size);
        case 4 /* Uint8 */: return new Uint8Array(size);
        case 5 /* Uint16 */: return new Uint16Array(size);
        case 6 /* Uint32 */: return new Uint32Array(size);
        default: throw new Error('Unsupported integer data type.');
    }
}
function getFloatArray(type, size) {
    switch (type) {
        case 32 /* Float32 */: return new Float32Array(size);
        case 33 /* Float64 */: return new Float64Array(size);
        default: throw new Error('Unsupported floating data type.');
    }
}
function int8(data) { return new Int8Array(data.buffer, data.byteOffset); }
function view(data, byteSize, c) {
    if (_binary__WEBPACK_IMPORTED_MODULE_0__["IsNativeEndianLittle"])
        return new c(data.buffer);
    return new c(Object(_binary__WEBPACK_IMPORTED_MODULE_0__["flipByteOrder"])(data, byteSize));
}
function int16(data) { return view(data, 2, Int16Array); }
function uint16(data) { return view(data, 2, Uint16Array); }
function int32(data) { return view(data, 4, Int32Array); }
function uint32(data) { return view(data, 4, Uint32Array); }
function float32(data) { return view(data, 4, Float32Array); }
function float64(data) { return view(data, 8, Float64Array); }
function fixedPoint(data, encoding) {
    var n = data.length;
    var output = getFloatArray(encoding.srcType, n);
    var f = 1 / encoding.factor;
    for (var i = 0; i < n; i++) {
        output[i] = f * data[i];
    }
    return output;
}
function intervalQuantization(data, encoding) {
    var n = data.length;
    var output = getFloatArray(encoding.srcType, n);
    var delta = (encoding.max - encoding.min) / (encoding.numSteps - 1);
    var min = encoding.min;
    for (var i = 0; i < n; i++) {
        output[i] = min + delta * data[i];
    }
    return output;
}
function runLength(data, encoding) {
    var output = getIntArray(encoding.srcType, encoding.srcSize);
    var dataOffset = 0;
    for (var i = 0, il = data.length; i < il; i += 2) {
        var value = data[i]; // value to be repeated
        var length_1 = data[i + 1]; // number of repeats
        for (var j = 0; j < length_1; ++j) {
            output[dataOffset++] = value;
        }
    }
    return output;
}
function delta(data, encoding) {
    var n = data.length;
    var output = getIntArray(encoding.srcType, n);
    if (!n)
        return data;
    output[0] = data[0] + (encoding.origin | 0);
    for (var i = 1; i < n; ++i) {
        output[i] = data[i] + output[i - 1];
    }
    return output;
}
function integerPackingSigned(data, encoding) {
    var upperLimit = encoding.byteCount === 1 ? 0x7F : 0x7FFF;
    var lowerLimit = -upperLimit - 1;
    var n = data.length;
    var output = new Int32Array(encoding.srcSize);
    var i = 0;
    var j = 0;
    while (i < n) {
        var value = 0, t = data[i];
        while (t === upperLimit || t === lowerLimit) {
            value += t;
            i++;
            t = data[i];
        }
        value += t;
        output[j] = value;
        i++;
        j++;
    }
    return output;
}
function integerPackingUnsigned(data, encoding) {
    var upperLimit = encoding.byteCount === 1 ? 0xFF : 0xFFFF;
    var n = data.length;
    var output = new Int32Array(encoding.srcSize);
    var i = 0;
    var j = 0;
    while (i < n) {
        var value = 0, t = data[i];
        while (t === upperLimit) {
            value += t;
            i++;
            t = data[i];
        }
        value += t;
        output[j] = value;
        i++;
        j++;
    }
    return output;
}
function integerPacking(data, encoding) {
    if (data.length === encoding.srcSize)
        return data;
    return encoding.isUnsigned ? integerPackingUnsigned(data, encoding) : integerPackingSigned(data, encoding);
}
function stringArray(data, encoding) {
    var offsets = decode({ encoding: encoding.offsetEncoding, data: encoding.offsets });
    var indices = decode({ encoding: encoding.dataEncoding, data: data });
    var str = encoding.stringData;
    var strings = new Array(offsets.length);
    strings[0] = '';
    for (var i = 1, _i = offsets.length; i < _i; i++) {
        strings[i] = str.substring(offsets[i - 1], offsets[i]);
    }
    var offset = 0;
    var result = new Array(indices.length);
    for (var i = 0, _i = indices.length; i < _i; i++) {
        result[offset++] = strings[indices[i] + 1];
    }
    return result;
}
//# sourceMappingURL=decoder.js.map

/***/ }),

/***/ "./lib/mol-io/common/binary-cif/encoding.js":
/*!**************************************************!*\
  !*** ./lib/mol-io/common/binary-cif/encoding.js ***!
  \**************************************************/
/*! exports provided: VERSION, Encoding */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "VERSION", function() { return VERSION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Encoding", function() { return Encoding; });
/**
 * Copyright (c) 2017 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * From CIFTools.js
 * @author David Sehnal <david.sehnal@gmail.com>
 */
var VERSION = '0.3.0';
var Encoding;
(function (Encoding) {
    function getDataType(data) {
        var srcType;
        if (data instanceof Int8Array)
            srcType = 1 /* Int8 */;
        else if (data instanceof Int16Array)
            srcType = 2 /* Int16 */;
        else if (data instanceof Int32Array)
            srcType = 3 /* Int32 */;
        else if (data instanceof Uint8Array)
            srcType = 4 /* Uint8 */;
        else if (data instanceof Uint16Array)
            srcType = 5 /* Uint16 */;
        else if (data instanceof Uint32Array)
            srcType = 6 /* Uint32 */;
        else if (data instanceof Float32Array)
            srcType = 32 /* Float32 */;
        else if (data instanceof Float64Array)
            srcType = 33 /* Float64 */;
        else
            srcType = 3 /* Int32 */; // throw new Error('Unsupported integer data type.');
        return srcType;
    }
    Encoding.getDataType = getDataType;
    function isSignedIntegerDataType(data) {
        if (data instanceof Int8Array || data instanceof Int16Array || data instanceof Int32Array)
            return true;
        for (var i = 0, _i = data.length; i < _i; i++) {
            if (i < 0)
                return false;
        }
        return true;
    }
    Encoding.isSignedIntegerDataType = isSignedIntegerDataType;
})(Encoding || (Encoding = {}));
//# sourceMappingURL=encoding.js.map

/***/ }),

/***/ "./lib/mol-io/common/binary.js":
/*!*************************************!*\
  !*** ./lib/mol-io/common/binary.js ***!
  \*************************************/
/*! exports provided: IsNativeEndianLittle, flipByteOrder, uint8ToString */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "IsNativeEndianLittle", function() { return IsNativeEndianLittle; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "flipByteOrder", function() { return flipByteOrder; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "uint8ToString", function() { return uint8ToString; });
/**
 * Copyright (c) 2017-2019 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 * @author David Sehnal <david.sehnal@gmail.com>
 */
var IsNativeEndianLittle = new Uint16Array(new Uint8Array([0x12, 0x34]).buffer)[0] === 0x3412;
function flipByteOrder(data, bytes) {
    var buffer = new ArrayBuffer(data.length);
    var ret = new Uint8Array(buffer);
    for (var i = 0, n = data.length; i < n; i += bytes) {
        for (var j = 0; j < bytes; j++) {
            ret[i + bytes - j - 1] = data[i + j];
        }
    }
    return buffer;
}
var ChunkSize = 0x7000;
function uint8ToString(array) {
    if (array.length > ChunkSize) {
        var c = [];
        for (var i = 0; i < array.length; i += ChunkSize) {
            c.push(String.fromCharCode.apply(null, array.subarray(i, i + ChunkSize)));
        }
        return c.join('');
    }
    else {
        return String.fromCharCode.apply(null, array);
    }
}
//# sourceMappingURL=binary.js.map

/***/ }),

/***/ "./lib/mol-io/common/file-handle.js":
/*!******************************************!*\
  !*** ./lib/mol-io/common/file-handle.js ***!
  \******************************************/
/*! exports provided: FileHandle */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FileHandle", function() { return FileHandle; });
/* harmony import */ var _mol_util__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../mol-util */ "./lib/mol-util/index.js");
/* harmony import */ var _simple_buffer__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./simple-buffer */ "./lib/mol-io/common/simple-buffer.js");
/**
 * Copyright (c) 2018-2019 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 * @author David Sehnal <david.sehnal@gmail.com>
 */


// only import 'fs' in node.js
var fs = typeof document === 'undefined' ? __webpack_require__(/*! fs */ "./node_modules/node-libs-browser/mock/empty.js") : void 0;
var FileHandle;
(function (FileHandle) {
    function fromBuffer(buffer, name) {
        return {
            name: name,
            readBuffer: function (position, sizeOrBuffer, size, byteOffset) {
                var bytesRead;
                var outBuffer;
                if (typeof sizeOrBuffer === 'number') {
                    size = Object(_mol_util__WEBPACK_IMPORTED_MODULE_0__["defaults"])(size, sizeOrBuffer);
                    var start = position;
                    var end = Math.min(buffer.length, start + size);
                    bytesRead = end - start;
                    outBuffer = _simple_buffer__WEBPACK_IMPORTED_MODULE_1__["SimpleBuffer"].fromUint8Array(new Uint8Array(buffer.buffer, start, end - start));
                }
                else {
                    size = Object(_mol_util__WEBPACK_IMPORTED_MODULE_0__["defaults"])(size, sizeOrBuffer.length);
                    var start = position;
                    var end = Math.min(buffer.length, start + size);
                    sizeOrBuffer.set(buffer.subarray(start, end), byteOffset);
                    bytesRead = end - start;
                    outBuffer = sizeOrBuffer;
                }
                if (size !== bytesRead) {
                    console.warn("byteCount " + size + " and bytesRead " + bytesRead + " differ");
                }
                return Promise.resolve({ bytesRead: bytesRead, buffer: outBuffer });
            },
            writeBuffer: function (position, buffer, length) {
                length = Object(_mol_util__WEBPACK_IMPORTED_MODULE_0__["defaults"])(length, buffer.length);
                console.error('.writeBuffer not implemented for FileHandle.fromBuffer');
                return Promise.resolve(0);
            },
            writeBufferSync: function (position, buffer, length) {
                length = Object(_mol_util__WEBPACK_IMPORTED_MODULE_0__["defaults"])(length, buffer.length);
                console.error('.writeSync not implemented for FileHandle.fromBuffer');
                return 0;
            },
            close: _mol_util__WEBPACK_IMPORTED_MODULE_0__["noop"]
        };
    }
    FileHandle.fromBuffer = fromBuffer;
    function fromDescriptor(file, name) {
        if (fs === undefined)
            throw new Error('fs module not available');
        return {
            name: name,
            readBuffer: function (position, sizeOrBuffer, length, byteOffset) {
                return new Promise(function (res, rej) {
                    var outBuffer;
                    if (typeof sizeOrBuffer === 'number') {
                        byteOffset = Object(_mol_util__WEBPACK_IMPORTED_MODULE_0__["defaults"])(byteOffset, 0);
                        length = Object(_mol_util__WEBPACK_IMPORTED_MODULE_0__["defaults"])(length, sizeOrBuffer);
                        outBuffer = _simple_buffer__WEBPACK_IMPORTED_MODULE_1__["SimpleBuffer"].fromArrayBuffer(new ArrayBuffer(sizeOrBuffer));
                    }
                    else {
                        byteOffset = Object(_mol_util__WEBPACK_IMPORTED_MODULE_0__["defaults"])(byteOffset, 0);
                        length = Object(_mol_util__WEBPACK_IMPORTED_MODULE_0__["defaults"])(length, sizeOrBuffer.length);
                        outBuffer = sizeOrBuffer;
                    }
                    fs.read(file, outBuffer, byteOffset, length, position, function (err, bytesRead, buffer) {
                        if (err) {
                            rej(err);
                            return;
                        }
                        if (length !== bytesRead) {
                            console.warn("byteCount " + length + " and bytesRead " + bytesRead + " differ");
                        }
                        res({ bytesRead: bytesRead, buffer: buffer });
                    });
                });
            },
            writeBuffer: function (position, buffer, length) {
                length = Object(_mol_util__WEBPACK_IMPORTED_MODULE_0__["defaults"])(length, buffer.length);
                return new Promise(function (res, rej) {
                    fs.write(file, buffer, 0, length, position, function (err, written) {
                        if (err)
                            rej(err);
                        else
                            res(written);
                    });
                });
            },
            writeBufferSync: function (position, buffer, length) {
                length = Object(_mol_util__WEBPACK_IMPORTED_MODULE_0__["defaults"])(length, buffer.length);
                return fs.writeSync(file, buffer, 0, length, position);
            },
            close: function () {
                try {
                    if (file !== void 0)
                        fs.close(file, _mol_util__WEBPACK_IMPORTED_MODULE_0__["noop"]);
                }
                catch (e) {
                }
            }
        };
    }
    FileHandle.fromDescriptor = fromDescriptor;
})(FileHandle || (FileHandle = {}));
//# sourceMappingURL=file-handle.js.map

/***/ }),

/***/ "./lib/mol-io/common/msgpack/decode.js":
/*!*********************************************!*\
  !*** ./lib/mol-io/common/msgpack/decode.js ***!
  \*********************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return decode; });
/* harmony import */ var _utf8__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../utf8 */ "./lib/mol-io/common/utf8.js");
/*
 * Copyright (c) 2017-2018 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * Adapted from https://github.com/rcsb/mmtf-javascript
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 * @author David Sehnal <david.sehnal@gmail.com>
 */

function decode(buffer) {
    return parse({ buffer: buffer, offset: 0, dataView: new DataView(buffer.buffer) });
}
/**
 * decode all key-value pairs of a map into an object
 */
function map(state, length) {
    var value = {};
    for (var i = 0; i < length; i++) {
        var key = parse(state);
        value[key] = parse(state);
    }
    return value;
}
/**
 * decode binary array
 */
function bin(state, length) {
    // This approach to binary parsing wastes a bit of memory to trade for speed compared to:
    //
    //   let value = buffer.subarray(offset, offset + length); //new Uint8Array(buffer.buffer, offset, length);
    //
    // It turns out that using the view created by subarray probably uses DataView
    // in the background, which causes the element access to be several times slower
    // than creating the new byte array.
    var value = new Uint8Array(length);
    var o = state.offset;
    for (var i = 0; i < length; i++)
        value[i] = state.buffer[i + o];
    state.offset += length;
    return value;
}
/**
 * decode string
 */
function str(state, length) {
    var value = Object(_utf8__WEBPACK_IMPORTED_MODULE_0__["utf8Read"])(state.buffer, state.offset, length);
    state.offset += length;
    return value;
}
/**
 * decode array
 */
function array(state, length) {
    var value = new Array(length);
    for (var i = 0; i < length; i++) {
        value[i] = parse(state);
    }
    return value;
}
/**
 * recursively parse the MessagePack data and return decoded MessagePack data
 */
function parse(state) {
    var type = state.buffer[state.offset];
    var value, length;
    // Positive FixInt
    if ((type & 0x80) === 0x00) {
        state.offset++;
        return type;
    }
    // FixMap
    if ((type & 0xf0) === 0x80) {
        length = type & 0x0f;
        state.offset++;
        return map(state, length);
    }
    // FixArray
    if ((type & 0xf0) === 0x90) {
        length = type & 0x0f;
        state.offset++;
        return array(state, length);
    }
    // FixStr
    if ((type & 0xe0) === 0xa0) {
        length = type & 0x1f;
        state.offset++;
        return str(state, length);
    }
    // Negative FixInt
    if ((type & 0xe0) === 0xe0) {
        value = state.dataView.getInt8(state.offset);
        state.offset++;
        return value;
    }
    switch (type) {
        // nil
        case 0xc0:
            state.offset++;
            return null;
        // false
        case 0xc2:
            state.offset++;
            return false;
        // true
        case 0xc3:
            state.offset++;
            return true;
        // bin 8
        case 0xc4:
            length = state.dataView.getUint8(state.offset + 1);
            state.offset += 2;
            return bin(state, length);
        // bin 16
        case 0xc5:
            length = state.dataView.getUint16(state.offset + 1);
            state.offset += 3;
            return bin(state, length);
        // bin 32
        case 0xc6:
            length = state.dataView.getUint32(state.offset + 1);
            state.offset += 5;
            return bin(state, length);
        // float 32
        case 0xca:
            value = state.dataView.getFloat32(state.offset + 1);
            state.offset += 5;
            return value;
        // float 64
        case 0xcb:
            value = state.dataView.getFloat64(state.offset + 1);
            state.offset += 9;
            return value;
        // uint8
        case 0xcc:
            value = state.buffer[state.offset + 1];
            state.offset += 2;
            return value;
        // uint 16
        case 0xcd:
            value = state.dataView.getUint16(state.offset + 1);
            state.offset += 3;
            return value;
        // uint 32
        case 0xce:
            value = state.dataView.getUint32(state.offset + 1);
            state.offset += 5;
            return value;
        // int 8
        case 0xd0:
            value = state.dataView.getInt8(state.offset + 1);
            state.offset += 2;
            return value;
        // int 16
        case 0xd1:
            value = state.dataView.getInt16(state.offset + 1);
            state.offset += 3;
            return value;
        // int 32
        case 0xd2:
            value = state.dataView.getInt32(state.offset + 1);
            state.offset += 5;
            return value;
        // str 8
        case 0xd9:
            length = state.dataView.getUint8(state.offset + 1);
            state.offset += 2;
            return str(state, length);
        // str 16
        case 0xda:
            length = state.dataView.getUint16(state.offset + 1);
            state.offset += 3;
            return str(state, length);
        // str 32
        case 0xdb:
            length = state.dataView.getUint32(state.offset + 1);
            state.offset += 5;
            return str(state, length);
        // array 16
        case 0xdc:
            length = state.dataView.getUint16(state.offset + 1);
            state.offset += 3;
            return array(state, length);
        // array 32
        case 0xdd:
            length = state.dataView.getUint32(state.offset + 1);
            state.offset += 5;
            return array(state, length);
        // map 16:
        case 0xde:
            length = state.dataView.getUint16(state.offset + 1);
            state.offset += 3;
            return map(state, length);
        // map 32
        case 0xdf:
            length = state.dataView.getUint32(state.offset + 1);
            state.offset += 5;
            return map(state, length);
    }
    throw new Error('Unknown type 0x' + type.toString(16));
}
//# sourceMappingURL=decode.js.map

/***/ }),

/***/ "./lib/mol-io/common/msgpack/encode.js":
/*!*********************************************!*\
  !*** ./lib/mol-io/common/msgpack/encode.js ***!
  \*********************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return encode; });
/* harmony import */ var _utf8__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../utf8 */ "./lib/mol-io/common/utf8.js");
/*
 * Copyright (c) 2017 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * Adapted from https://github.com/rcsb/mmtf-javascript
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 * @author David Sehnal <david.sehnal@gmail.com>
 */

function encode(value) {
    var buffer = new ArrayBuffer(encodedSize(value));
    var view = new DataView(buffer);
    var bytes = new Uint8Array(buffer);
    encodeInternal(value, view, bytes, 0);
    return bytes;
}
function encodedSize(value) {
    var type = typeof value;
    // Raw Bytes
    if (type === 'string') {
        var length_1 = Object(_utf8__WEBPACK_IMPORTED_MODULE_0__["utf8ByteCount"])(value);
        if (length_1 < 0x20) {
            return 1 + length_1;
        }
        if (length_1 < 0x100) {
            return 2 + length_1;
        }
        if (length_1 < 0x10000) {
            return 3 + length_1;
        }
        if (length_1 < 0x100000000) {
            return 5 + length_1;
        }
    }
    if (value instanceof Uint8Array) {
        var length_2 = value.byteLength;
        if (length_2 < 0x100) {
            return 2 + length_2;
        }
        if (length_2 < 0x10000) {
            return 3 + length_2;
        }
        if (length_2 < 0x100000000) {
            return 5 + length_2;
        }
    }
    if (type === 'number') {
        // Floating Point
        // double
        if (Math.floor(value) !== value)
            return 9;
        // Integers
        if (value >= 0) {
            // positive fixnum
            if (value < 0x80)
                return 1;
            // uint 8
            if (value < 0x100)
                return 2;
            // uint 16
            if (value < 0x10000)
                return 3;
            // uint 32
            if (value < 0x100000000)
                return 5;
            throw new Error('Number too big 0x' + value.toString(16));
        }
        // negative fixnum
        if (value >= -0x20)
            return 1;
        // int 8
        if (value >= -0x80)
            return 2;
        // int 16
        if (value >= -0x8000)
            return 3;
        // int 32
        if (value >= -0x80000000)
            return 5;
        throw new Error('Number too small -0x' + value.toString(16).substr(1));
    }
    // Boolean, null
    if (type === 'boolean' || value === null || value === void 0)
        return 1;
    // Container Types
    if (type === 'object') {
        var length_3, size = 0;
        if (Array.isArray(value)) {
            length_3 = value.length;
            for (var i = 0; i < length_3; i++) {
                size += encodedSize(value[i]);
            }
        }
        else {
            var keys = Object.keys(value);
            length_3 = keys.length;
            for (var i = 0; i < length_3; i++) {
                var key = keys[i];
                size += encodedSize(key) + encodedSize(value[key]);
            }
        }
        if (length_3 < 0x10) {
            return 1 + size;
        }
        if (length_3 < 0x10000) {
            return 3 + size;
        }
        if (length_3 < 0x100000000) {
            return 5 + size;
        }
        throw new Error('Array or object too long 0x' + length_3.toString(16));
    }
    throw new Error('Unknown type ' + type);
}
function encodeInternal(value, view, bytes, offset) {
    var type = typeof value;
    // Strings Bytes
    if (type === 'string') {
        var length_4 = Object(_utf8__WEBPACK_IMPORTED_MODULE_0__["utf8ByteCount"])(value);
        // fix str
        if (length_4 < 0x20) {
            view.setUint8(offset, length_4 | 0xa0);
            Object(_utf8__WEBPACK_IMPORTED_MODULE_0__["utf8Write"])(bytes, offset + 1, value);
            return 1 + length_4;
        }
        // str 8
        if (length_4 < 0x100) {
            view.setUint8(offset, 0xd9);
            view.setUint8(offset + 1, length_4);
            Object(_utf8__WEBPACK_IMPORTED_MODULE_0__["utf8Write"])(bytes, offset + 2, value);
            return 2 + length_4;
        }
        // str 16
        if (length_4 < 0x10000) {
            view.setUint8(offset, 0xda);
            view.setUint16(offset + 1, length_4);
            Object(_utf8__WEBPACK_IMPORTED_MODULE_0__["utf8Write"])(bytes, offset + 3, value);
            return 3 + length_4;
        }
        // str 32
        if (length_4 < 0x100000000) {
            view.setUint8(offset, 0xdb);
            view.setUint32(offset + 1, length_4);
            Object(_utf8__WEBPACK_IMPORTED_MODULE_0__["utf8Write"])(bytes, offset + 5, value);
            return 5 + length_4;
        }
    }
    if (value instanceof Uint8Array) {
        var length_5 = value.byteLength;
        var bytes_1 = new Uint8Array(view.buffer);
        // bin 8
        if (length_5 < 0x100) {
            view.setUint8(offset, 0xc4);
            view.setUint8(offset + 1, length_5);
            bytes_1.set(value, offset + 2);
            return 2 + length_5;
        }
        // bin 16
        if (length_5 < 0x10000) {
            view.setUint8(offset, 0xc5);
            view.setUint16(offset + 1, length_5);
            bytes_1.set(value, offset + 3);
            return 3 + length_5;
        }
        // bin 32
        if (length_5 < 0x100000000) {
            view.setUint8(offset, 0xc6);
            view.setUint32(offset + 1, length_5);
            bytes_1.set(value, offset + 5);
            return 5 + length_5;
        }
    }
    if (type === 'number') {
        if (!isFinite(value)) {
            throw new Error('Number not finite: ' + value);
        }
        // Floating point
        if (Math.floor(value) !== value) {
            view.setUint8(offset, 0xcb);
            view.setFloat64(offset + 1, value);
            return 9;
        }
        // Integers
        if (value >= 0) {
            // positive fixnum
            if (value < 0x80) {
                view.setUint8(offset, value);
                return 1;
            }
            // uint 8
            if (value < 0x100) {
                view.setUint8(offset, 0xcc);
                view.setUint8(offset + 1, value);
                return 2;
            }
            // uint 16
            if (value < 0x10000) {
                view.setUint8(offset, 0xcd);
                view.setUint16(offset + 1, value);
                return 3;
            }
            // uint 32
            if (value < 0x100000000) {
                view.setUint8(offset, 0xce);
                view.setUint32(offset + 1, value);
                return 5;
            }
            throw new Error('Number too big 0x' + value.toString(16));
        }
        // negative fixnum
        if (value >= -0x20) {
            view.setInt8(offset, value);
            return 1;
        }
        // int 8
        if (value >= -0x80) {
            view.setUint8(offset, 0xd0);
            view.setInt8(offset + 1, value);
            return 2;
        }
        // int 16
        if (value >= -0x8000) {
            view.setUint8(offset, 0xd1);
            view.setInt16(offset + 1, value);
            return 3;
        }
        // int 32
        if (value >= -0x80000000) {
            view.setUint8(offset, 0xd2);
            view.setInt32(offset + 1, value);
            return 5;
        }
        throw new Error('Number too small -0x' + (-value).toString(16).substr(1));
    }
    // null
    if (value === null || value === undefined) {
        view.setUint8(offset, 0xc0);
        return 1;
    }
    // Boolean
    if (type === 'boolean') {
        view.setUint8(offset, value ? 0xc3 : 0xc2);
        return 1;
    }
    // Container Types
    if (type === 'object') {
        var length_6, size = 0;
        var isArray = Array.isArray(value);
        var keys = void 0;
        if (isArray) {
            length_6 = value.length;
        }
        else {
            keys = Object.keys(value);
            length_6 = keys.length;
        }
        if (length_6 < 0x10) {
            view.setUint8(offset, length_6 | (isArray ? 0x90 : 0x80));
            size = 1;
        }
        else if (length_6 < 0x10000) {
            view.setUint8(offset, isArray ? 0xdc : 0xde);
            view.setUint16(offset + 1, length_6);
            size = 3;
        }
        else if (length_6 < 0x100000000) {
            view.setUint8(offset, isArray ? 0xdd : 0xdf);
            view.setUint32(offset + 1, length_6);
            size = 5;
        }
        if (isArray) {
            for (var i = 0; i < length_6; i++) {
                size += encodeInternal(value[i], view, bytes, offset + size);
            }
        }
        else {
            for (var i = 0, _i = keys.length; i < _i; i++) {
                var key = keys[i];
                size += encodeInternal(key, view, bytes, offset + size);
                size += encodeInternal(value[key], view, bytes, offset + size);
            }
        }
        return size;
    }
    throw new Error('Unknown type ' + type);
}
//# sourceMappingURL=encode.js.map

/***/ }),

/***/ "./lib/mol-io/common/simple-buffer.js":
/*!********************************************!*\
  !*** ./lib/mol-io/common/simple-buffer.js ***!
  \********************************************/
/*! exports provided: SimpleBuffer */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SimpleBuffer", function() { return SimpleBuffer; });
/* harmony import */ var _mol_util__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../mol-util */ "./lib/mol-util/index.js");
/**
 * Copyright (c) 2019 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 * @author David Sehnal <david.sehnal@gmail.com>
 */

var SimpleBuffer;
(function (SimpleBuffer) {
    function fromUint8Array(array) {
        var dv = new DataView(array.buffer);
        return Object.assign(array.subarray(0), {
            readInt8: function (offset) { return dv.getInt8(offset); },
            readUInt8: function (offset) { return dv.getUint8(offset); },
            writeInt8: function (value, offset) { return dv.setInt8(offset, value); },
            writeUInt8: function (value, offset) { return dv.setUint8(offset, value); },
            readInt16LE: function (offset) { return dv.getInt16(offset, true); },
            readInt32LE: function (offset) { return dv.getInt32(offset, true); },
            readUInt16LE: function (offset) { return dv.getUint16(offset, true); },
            readUInt32LE: function (offset) { return dv.getUint32(offset, true); },
            readFloatLE: function (offset) { return dv.getFloat32(offset, true); },
            readDoubleLE: function (offset) { return dv.getFloat64(offset, true); },
            writeInt16LE: function (value, offset) { return dv.setInt16(offset, value, true); },
            writeInt32LE: function (value, offset) { return dv.setInt32(offset, value, true); },
            writeUInt16LE: function (value, offset) { return dv.setUint16(offset, value, true); },
            writeUInt32LE: function (value, offset) { return dv.setUint32(offset, value, true); },
            writeFloatLE: function (value, offset) { return dv.setFloat32(offset, value, true); },
            writeDoubleLE: function (value, offset) { return dv.setFloat64(offset, value, true); },
            readInt16BE: function (offset) { return dv.getInt16(offset, false); },
            readInt32BE: function (offset) { return dv.getInt32(offset, false); },
            readUInt16BE: function (offset) { return dv.getUint16(offset, false); },
            readUInt32BE: function (offset) { return dv.getUint32(offset, false); },
            readFloatBE: function (offset) { return dv.getFloat32(offset, false); },
            readDoubleBE: function (offset) { return dv.getFloat64(offset, false); },
            writeInt16BE: function (value, offset) { return dv.setInt16(offset, value, false); },
            writeInt32BE: function (value, offset) { return dv.setInt32(offset, value, false); },
            writeUInt16BE: function (value, offset) { return dv.setUint16(offset, value, false); },
            writeUInt32BE: function (value, offset) { return dv.setUint32(offset, value, false); },
            writeFloatBE: function (value, offset) { return dv.setFloat32(offset, value, false); },
            writeDoubleBE: function (value, offset) { return dv.setFloat64(offset, value, false); },
            copy: function (targetBuffer, targetStart, sourceStart, sourceEnd) {
                targetStart = Object(_mol_util__WEBPACK_IMPORTED_MODULE_0__["defaults"])(targetStart, 0);
                sourceStart = Object(_mol_util__WEBPACK_IMPORTED_MODULE_0__["defaults"])(sourceStart, 0);
                sourceEnd = Object(_mol_util__WEBPACK_IMPORTED_MODULE_0__["defaults"])(sourceEnd, array.length);
                targetBuffer.set(array.subarray(sourceStart, sourceEnd), targetStart);
                return sourceEnd - sourceStart;
            }
        });
    }
    SimpleBuffer.fromUint8Array = fromUint8Array;
    function fromArrayBuffer(arrayBuffer) {
        return fromUint8Array(new Uint8Array(arrayBuffer));
    }
    SimpleBuffer.fromArrayBuffer = fromArrayBuffer;
    function fromBuffer(buffer) {
        return buffer;
    }
    SimpleBuffer.fromBuffer = fromBuffer;
    SimpleBuffer.IsNativeEndianLittle = new Uint16Array(new Uint8Array([0x12, 0x34]).buffer)[0] === 0x3412;
    /** source and target can't be the same */
    function flipByteOrder(source, target, byteCount, elementByteSize, offset) {
        for (var i = 0, n = byteCount; i < n; i += elementByteSize) {
            for (var j = 0; j < elementByteSize; j++) {
                target[offset + i + elementByteSize - j - 1] = source[offset + i + j];
            }
        }
    }
    SimpleBuffer.flipByteOrder = flipByteOrder;
    function flipByteOrderInPlace2(buffer, byteOffset, length) {
        if (byteOffset === void 0) { byteOffset = 0; }
        var intView = new Int16Array(buffer, byteOffset, length);
        for (var i = 0, n = intView.length; i < n; ++i) {
            var val = intView[i];
            intView[i] = ((val & 0xff) << 8) | ((val >> 8) & 0xff);
        }
    }
    SimpleBuffer.flipByteOrderInPlace2 = flipByteOrderInPlace2;
    function ensureLittleEndian(source, target, byteCount, elementByteSize, offset) {
        if (SimpleBuffer.IsNativeEndianLittle)
            return;
        if (!byteCount || elementByteSize <= 1)
            return;
        flipByteOrder(source, target, byteCount, elementByteSize, offset);
    }
    SimpleBuffer.ensureLittleEndian = ensureLittleEndian;
})(SimpleBuffer || (SimpleBuffer = {}));
//# sourceMappingURL=simple-buffer.js.map

/***/ }),

/***/ "./lib/mol-io/common/typed-array.js":
/*!******************************************!*\
  !*** ./lib/mol-io/common/typed-array.js ***!
  \******************************************/
/*! exports provided: TypedArrayValueType, getElementByteSize, makeTypedArray, createTypedArray, createTypedArrayBufferContext, readTypedArray */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "TypedArrayValueType", function() { return TypedArrayValueType; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getElementByteSize", function() { return getElementByteSize; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "makeTypedArray", function() { return makeTypedArray; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createTypedArray", function() { return createTypedArray; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createTypedArrayBufferContext", function() { return createTypedArrayBufferContext; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "readTypedArray", function() { return readTypedArray; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _mol_io_common_simple_buffer__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../mol-io/common/simple-buffer */ "./lib/mol-io/common/simple-buffer.js");
/**
 * Copyright (c) 2018-2020 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * Taken/adapted from DensityServer (https://github.com/dsehnal/DensityServer)
 *
 * @author David Sehnal <david.sehnal@gmail.com>
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */


var TypedArrayValueType;
(function (TypedArrayValueType) {
    TypedArrayValueType.Float32 = 'float32';
    TypedArrayValueType.Int8 = 'int8';
    TypedArrayValueType.Int16 = 'int16';
    TypedArrayValueType.Uint16 = 'uint16';
})(TypedArrayValueType || (TypedArrayValueType = {}));
function getElementByteSize(type) {
    if (type === TypedArrayValueType.Float32)
        return 4;
    if (type === TypedArrayValueType.Int16)
        return 2;
    if (type === TypedArrayValueType.Uint16)
        return 2;
    return 1;
}
function makeTypedArray(type, buffer, byteOffset, length) {
    if (byteOffset === void 0) { byteOffset = 0; }
    if (type === TypedArrayValueType.Float32)
        return new Float32Array(buffer, byteOffset, length);
    if (type === TypedArrayValueType.Int16)
        return new Int16Array(buffer, byteOffset, length);
    if (type === TypedArrayValueType.Uint16)
        return new Uint16Array(buffer, byteOffset, length);
    return new Int8Array(buffer, byteOffset, length);
}
function createTypedArray(type, size) {
    switch (type) {
        case TypedArrayValueType.Float32: return new Float32Array(new ArrayBuffer(4 * size));
        case TypedArrayValueType.Int8: return new Int8Array(new ArrayBuffer(1 * size));
        case TypedArrayValueType.Int16: return new Int16Array(new ArrayBuffer(2 * size));
        case TypedArrayValueType.Uint16: return new Uint16Array(new ArrayBuffer(2 * size));
    }
    throw Error(type + " is not a supported value format.");
}
function createTypedArrayBufferContext(size, type) {
    var elementByteSize = getElementByteSize(type);
    var arrayBuffer = new ArrayBuffer(elementByteSize * size);
    var readBuffer = _mol_io_common_simple_buffer__WEBPACK_IMPORTED_MODULE_1__["SimpleBuffer"].fromArrayBuffer(arrayBuffer);
    var valuesBuffer = _mol_io_common_simple_buffer__WEBPACK_IMPORTED_MODULE_1__["SimpleBuffer"].IsNativeEndianLittle ? arrayBuffer : new ArrayBuffer(elementByteSize * size);
    return {
        type: type,
        elementByteSize: elementByteSize,
        readBuffer: readBuffer,
        valuesBuffer: new Uint8Array(valuesBuffer),
        values: makeTypedArray(type, valuesBuffer)
    };
}
function readTypedArray(ctx, file, position, byteCount, valueByteOffset, littleEndian) {
    return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"])(this, void 0, void 0, function () {
        return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__generator"])(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, file.readBuffer(position, ctx.readBuffer, byteCount, valueByteOffset)];
                case 1:
                    _a.sent();
                    if (ctx.elementByteSize > 1 && ((littleEndian !== void 0 && littleEndian !== _mol_io_common_simple_buffer__WEBPACK_IMPORTED_MODULE_1__["SimpleBuffer"].IsNativeEndianLittle) || !_mol_io_common_simple_buffer__WEBPACK_IMPORTED_MODULE_1__["SimpleBuffer"].IsNativeEndianLittle)) {
                        // fix the endian
                        _mol_io_common_simple_buffer__WEBPACK_IMPORTED_MODULE_1__["SimpleBuffer"].flipByteOrder(ctx.readBuffer, ctx.valuesBuffer, byteCount, ctx.elementByteSize, valueByteOffset);
                    }
                    return [2 /*return*/, ctx.values];
            }
        });
    });
}
//# sourceMappingURL=typed-array.js.map

/***/ }),

/***/ "./lib/mol-io/common/utf8.js":
/*!***********************************!*\
  !*** ./lib/mol-io/common/utf8.js ***!
  \***********************************/
/*! exports provided: utf8Write, utf8Read, utf8ByteCount */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "utf8Write", function() { return utf8Write; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "utf8Read", function() { return utf8Read; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "utf8ByteCount", function() { return utf8ByteCount; });
/**
 * Copyright (c) 2017-2020 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * Adapted from https://github.com/rcsb/mmtf-javascript
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 * @author David Sehnal <david.sehnal@gmail.com>
 */
function utf8Write(data, offset, str) {
    for (var i = 0, l = str.length; i < l; i++) {
        var codePoint = str.charCodeAt(i);
        // One byte of UTF-8
        if (codePoint < 0x80) {
            data[offset++] = codePoint >>> 0 & 0x7f | 0x00;
            continue;
        }
        // Two bytes of UTF-8
        if (codePoint < 0x800) {
            data[offset++] = codePoint >>> 6 & 0x1f | 0xc0;
            data[offset++] = codePoint >>> 0 & 0x3f | 0x80;
            continue;
        }
        // Three bytes of UTF-8.
        if (codePoint < 0x10000) {
            data[offset++] = codePoint >>> 12 & 0x0f | 0xe0;
            data[offset++] = codePoint >>> 6 & 0x3f | 0x80;
            data[offset++] = codePoint >>> 0 & 0x3f | 0x80;
            continue;
        }
        // Four bytes of UTF-8
        if (codePoint < 0x110000) {
            data[offset++] = codePoint >>> 18 & 0x07 | 0xf0;
            data[offset++] = codePoint >>> 12 & 0x3f | 0x80;
            data[offset++] = codePoint >>> 6 & 0x3f | 0x80;
            data[offset++] = codePoint >>> 0 & 0x3f | 0x80;
            continue;
        }
        throw new Error('bad codepoint ' + codePoint);
    }
}
var __chars = function () {
    var data = [];
    for (var i = 0; i < 1024; i++)
        data[i] = String.fromCharCode(i);
    return data;
}();
function throwError(err) {
    throw new Error(err);
}
function _utf8Read(data, offset, length) {
    var chars = __chars;
    var str = void 0, chunk = [], chunkSize = 512, chunkOffset = 0;
    for (var i = offset, end = offset + length; i < end; i++) {
        var byte = data[i];
        if ((byte & 0x80) === 0x00) {
            // One byte character
            chunk[chunkOffset++] = chars[byte];
        }
        else if ((byte & 0xe0) === 0xc0) {
            // Two byte character
            chunk[chunkOffset++] = chars[((byte & 0x0f) << 6) | (data[++i] & 0x3f)];
        }
        else if ((byte & 0xf0) === 0xe0) {
            // Three byte character
            chunk[chunkOffset++] = String.fromCharCode(((byte & 0x0f) << 12) |
                ((data[++i] & 0x3f) << 6) |
                ((data[++i] & 0x3f) << 0));
        }
        else if ((byte & 0xf8) === 0xf0) {
            // Four byte character
            chunk[chunkOffset++] = String.fromCharCode(((byte & 0x07) << 18) |
                ((data[++i] & 0x3f) << 12) |
                ((data[++i] & 0x3f) << 6) |
                ((data[++i] & 0x3f) << 0));
        }
        else
            throwError('Invalid byte ' + byte.toString(16));
        if (chunkOffset === chunkSize) {
            str = str || [];
            str[str.length] = chunk.join('');
            chunkOffset = 0;
        }
    }
    if (!str)
        return chunk.slice(0, chunkOffset).join('');
    if (chunkOffset > 0) {
        str[str.length] = chunk.slice(0, chunkOffset).join('');
    }
    return str.join('');
}
var utf8Decoder = (typeof TextDecoder !== 'undefined') ? new TextDecoder() : undefined;
function utf8Read(data, offset, length) {
    if (utf8Decoder) {
        var input = (offset || length !== data.length) ? data.subarray(offset, offset + length) : data;
        return utf8Decoder.decode(input);
    }
    else {
        return _utf8Read(data, offset, length);
    }
}
function utf8ByteCount(str) {
    var count = 0;
    for (var i = 0, l = str.length; i < l; i++) {
        var codePoint = str.charCodeAt(i);
        if (codePoint < 0x80) {
            count += 1;
            continue;
        }
        if (codePoint < 0x800) {
            count += 2;
            continue;
        }
        if (codePoint < 0x10000) {
            count += 3;
            continue;
        }
        if (codePoint < 0x110000) {
            count += 4;
            continue;
        }
        throwError('bad codepoint ' + codePoint);
    }
    return count;
}
//# sourceMappingURL=utf8.js.map

/***/ }),

/***/ "./lib/mol-io/reader/ccp4/parser.js":
/*!******************************************!*\
  !*** ./lib/mol-io/reader/ccp4/parser.js ***!
  \******************************************/
/*! exports provided: readCcp4Header, readCcp4Slices, getCcp4ValueType, getCcp4DataOffset, parseFile, parse */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "readCcp4Header", function() { return readCcp4Header; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "readCcp4Slices", function() { return readCcp4Slices; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getCcp4ValueType", function() { return getCcp4ValueType; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getCcp4DataOffset", function() { return getCcp4DataOffset; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "parseFile", function() { return parseFile; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "parse", function() { return parse; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _mol_task__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../../mol-task */ "./lib/mol-task/index.js");
/* harmony import */ var _result__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../result */ "./lib/mol-io/reader/result.js");
/* harmony import */ var _common_file_handle__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../common/file-handle */ "./lib/mol-io/common/file-handle.js");
/* harmony import */ var _mol_io_common_simple_buffer__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../../mol-io/common/simple-buffer */ "./lib/mol-io/common/simple-buffer.js");
/* harmony import */ var _mol_io_common_typed_array__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../../mol-io/common/typed-array */ "./lib/mol-io/common/typed-array.js");
/**
 * Copyright (c) 2018-2020 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */






function readCcp4Header(file) {
    return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"])(this, void 0, void 0, function () {
        var headerSize, buffer, MAP, MACHST, littleEndian, modeLE, readInt, readFloat, header;
        return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__generator"])(this, function (_a) {
            switch (_a.label) {
                case 0:
                    headerSize = 1024;
                    return [4 /*yield*/, file.readBuffer(0, headerSize)];
                case 1:
                    buffer = (_a.sent()).buffer;
                    MAP = String.fromCharCode(buffer.readUInt8(52 * 4), buffer.readUInt8(52 * 4 + 1), buffer.readUInt8(52 * 4 + 2), buffer.readUInt8(52 * 4 + 3));
                    if (MAP !== 'MAP ') {
                        throw new Error('ccp4 format error, missing "MAP " string');
                    }
                    MACHST = [buffer.readUInt8(53 * 4), buffer.readUInt8(53 * 4 + 1)];
                    littleEndian = false;
                    if (MACHST[0] === 68 && MACHST[1] === 65) {
                        littleEndian = true;
                    }
                    else if (MACHST[0] === 17 && MACHST[1] === 17) {
                        littleEndian = false;
                    }
                    else {
                        modeLE = buffer.readInt32LE(3 * 4);
                        if (modeLE <= 16)
                            littleEndian = true;
                    }
                    readInt = littleEndian ? function (o) { return buffer.readInt32LE(o * 4); } : function (o) { return buffer.readInt32BE(o * 4); };
                    readFloat = littleEndian ? function (o) { return buffer.readFloatLE(o * 4); } : function (o) { return buffer.readFloatBE(o * 4); };
                    header = {
                        NC: readInt(0),
                        NR: readInt(1),
                        NS: readInt(2),
                        MODE: readInt(3),
                        NCSTART: readInt(4),
                        NRSTART: readInt(5),
                        NSSTART: readInt(6),
                        NX: readInt(7),
                        NY: readInt(8),
                        NZ: readInt(9),
                        xLength: readFloat(10),
                        yLength: readFloat(11),
                        zLength: readFloat(12),
                        alpha: readFloat(13),
                        beta: readFloat(14),
                        gamma: readFloat(15),
                        MAPC: readInt(16),
                        MAPR: readInt(17),
                        MAPS: readInt(18),
                        AMIN: readFloat(19),
                        AMAX: readFloat(20),
                        AMEAN: readFloat(21),
                        ISPG: readInt(22),
                        NSYMBT: readInt(23),
                        LSKFLG: readInt(24),
                        SKWMAT: [],
                        SKWTRN: [],
                        userFlag1: readInt(39),
                        userFlag2: readInt(40),
                        // bytes 50-52 origin in X,Y,Z used for transforms
                        originX: readFloat(49),
                        originY: readFloat(50),
                        originZ: readFloat(51),
                        MAP: MAP,
                        MACHST: MACHST,
                        ARMS: readFloat(54),
                    };
                    return [2 /*return*/, { header: header, littleEndian: littleEndian }];
            }
        });
    });
}
function readCcp4Slices(header, buffer, file, byteOffset, length, littleEndian) {
    return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"])(this, void 0, void 0, function () {
        var valueByteOffset, int8, b1, b0, j, jl;
        return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__generator"])(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!isMapmode2to0(header)) return [3 /*break*/, 2];
                    valueByteOffset = 3 * length;
                    // read int8 data to last quarter of the read buffer
                    return [4 /*yield*/, file.readBuffer(byteOffset, buffer.readBuffer, length, valueByteOffset)];
                case 1:
                    // read int8 data to last quarter of the read buffer
                    _a.sent();
                    int8 = new Int8Array(buffer.valuesBuffer.buffer, valueByteOffset);
                    b1 = (header.AMAX - header.AMIN) / 255.0;
                    b0 = 0.5 * (header.AMIN + header.AMAX + b1);
                    for (j = 0, jl = length; j < jl; ++j) {
                        buffer.values[j] = b1 * int8[j] + b0;
                    }
                    return [3 /*break*/, 4];
                case 2: return [4 /*yield*/, Object(_mol_io_common_typed_array__WEBPACK_IMPORTED_MODULE_5__["readTypedArray"])(buffer, file, byteOffset, length, 0, littleEndian)];
                case 3:
                    _a.sent();
                    _a.label = 4;
                case 4: return [2 /*return*/];
            }
        });
    });
}
function getCcp4DataType(mode) {
    switch (mode) {
        case 0: return _mol_io_common_typed_array__WEBPACK_IMPORTED_MODULE_5__["TypedArrayValueType"].Int8;
        case 1: return _mol_io_common_typed_array__WEBPACK_IMPORTED_MODULE_5__["TypedArrayValueType"].Int16;
        case 2: return _mol_io_common_typed_array__WEBPACK_IMPORTED_MODULE_5__["TypedArrayValueType"].Float32;
        case 3: throw new Error('mode 3 unsupported, complex 16-bit integers');
        case 4: throw new Error('mode 4 unsupported, complex 32-bit reals');
        case 6: _mol_io_common_typed_array__WEBPACK_IMPORTED_MODULE_5__["TypedArrayValueType"].Uint16;
        case 16: throw new Error('mode 16 unsupported, unsigned char * 3 (for rgb data, non-standard)');
    }
    throw new Error("unknown mode '" + mode + "'");
}
/** check if the file was converted by mapmode2to0, see https://github.com/uglymol/uglymol */
function isMapmode2to0(header) {
    return header.userFlag1 === -128 && header.userFlag2 === 127;
}
function getCcp4ValueType(header) {
    return isMapmode2to0(header) ? _mol_io_common_typed_array__WEBPACK_IMPORTED_MODULE_5__["TypedArrayValueType"].Float32 : getCcp4DataType(header.MODE);
}
function getCcp4DataOffset(header) {
    return 256 * 4 + header.NSYMBT;
}
function parseInternal(file, size, ctx) {
    return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"])(this, void 0, void 0, function () {
        var _a, header, littleEndian, offset, dataType, valueType, count, elementByteSize, byteCount, buffer, result;
        return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__generator"])(this, function (_b) {
            switch (_b.label) {
                case 0: return [4 /*yield*/, ctx.update({ message: 'Parsing CCP4/MRC/MAP file...' })];
                case 1:
                    _b.sent();
                    return [4 /*yield*/, readCcp4Header(file)];
                case 2:
                    _a = _b.sent(), header = _a.header, littleEndian = _a.littleEndian;
                    offset = getCcp4DataOffset(header);
                    dataType = getCcp4DataType(header.MODE);
                    valueType = getCcp4ValueType(header);
                    count = header.NC * header.NR * header.NS;
                    elementByteSize = Object(_mol_io_common_typed_array__WEBPACK_IMPORTED_MODULE_5__["getElementByteSize"])(dataType);
                    byteCount = count * elementByteSize;
                    buffer = Object(_mol_io_common_typed_array__WEBPACK_IMPORTED_MODULE_5__["createTypedArrayBufferContext"])(count, valueType);
                    readCcp4Slices(header, buffer, file, offset, byteCount, littleEndian);
                    result = { header: header, values: buffer.values, name: file.name };
                    return [2 /*return*/, result];
            }
        });
    });
}
function parseFile(file, size) {
    var _this = this;
    return _mol_task__WEBPACK_IMPORTED_MODULE_1__["Task"].create('Parse CCP4/MRC/MAP', function (ctx) { return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"])(_this, void 0, void 0, function () {
        var _a, _b, e_1;
        return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__generator"])(this, function (_c) {
            switch (_c.label) {
                case 0:
                    _c.trys.push([0, 2, , 3]);
                    _b = (_a = _result__WEBPACK_IMPORTED_MODULE_2__["ReaderResult"]).success;
                    return [4 /*yield*/, parseInternal(file, size, ctx)];
                case 1: return [2 /*return*/, _b.apply(_a, [_c.sent()])];
                case 2:
                    e_1 = _c.sent();
                    return [2 /*return*/, _result__WEBPACK_IMPORTED_MODULE_2__["ReaderResult"].error(e_1)];
                case 3: return [2 /*return*/];
            }
        });
    }); });
}
function parse(buffer, name) {
    return parseFile(_common_file_handle__WEBPACK_IMPORTED_MODULE_3__["FileHandle"].fromBuffer(_mol_io_common_simple_buffer__WEBPACK_IMPORTED_MODULE_4__["SimpleBuffer"].fromUint8Array(buffer), name), buffer.length);
}
//# sourceMappingURL=parser.js.map

/***/ }),

/***/ "./lib/mol-io/reader/cif.js":
/*!**********************************!*\
  !*** ./lib/mol-io/reader/cif.js ***!
  \**********************************/
/*! exports provided: CIF, CifFile, CifBlock, CifSaveFrame, CifCategory, CifField, tensorFieldNameGetter, getTensor, getCifFieldType */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CIF", function() { return CIF; });
/* harmony import */ var _cif_text_parser__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./cif/text/parser */ "./lib/mol-io/reader/cif/text/parser.js");
/* harmony import */ var _cif_binary_parser__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./cif/binary/parser */ "./lib/mol-io/reader/cif/binary/parser.js");
/* harmony import */ var _cif_schema__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./cif/schema */ "./lib/mol-io/reader/cif/schema.js");
/* harmony import */ var _cif_schema_mmcif__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./cif/schema/mmcif */ "./lib/mol-io/reader/cif/schema/mmcif.js");
/* harmony import */ var _cif_schema_ccd__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./cif/schema/ccd */ "./lib/mol-io/reader/cif/schema/ccd.js");
/* harmony import */ var _cif_schema_bird__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./cif/schema/bird */ "./lib/mol-io/reader/cif/schema/bird.js");
/* harmony import */ var _cif_schema_dic__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ./cif/schema/dic */ "./lib/mol-io/reader/cif/schema/dic.js");
/* harmony import */ var _cif_schema_density_server__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ./cif/schema/density-server */ "./lib/mol-io/reader/cif/schema/density-server.js");
/* harmony import */ var _cif_schema_cif_core__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ./cif/schema/cif-core */ "./lib/mol-io/reader/cif/schema/cif-core.js");
/* harmony import */ var _cif_data_model__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ./cif/data-model */ "./lib/mol-io/reader/cif/data-model.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "CifFile", function() { return _cif_data_model__WEBPACK_IMPORTED_MODULE_9__["CifFile"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "CifBlock", function() { return _cif_data_model__WEBPACK_IMPORTED_MODULE_9__["CifBlock"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "CifSaveFrame", function() { return _cif_data_model__WEBPACK_IMPORTED_MODULE_9__["CifSaveFrame"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "CifCategory", function() { return _cif_data_model__WEBPACK_IMPORTED_MODULE_9__["CifCategory"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "CifField", function() { return _cif_data_model__WEBPACK_IMPORTED_MODULE_9__["CifField"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "tensorFieldNameGetter", function() { return _cif_data_model__WEBPACK_IMPORTED_MODULE_9__["tensorFieldNameGetter"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "getTensor", function() { return _cif_data_model__WEBPACK_IMPORTED_MODULE_9__["getTensor"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "getCifFieldType", function() { return _cif_data_model__WEBPACK_IMPORTED_MODULE_9__["getCifFieldType"]; });

/**
 * Copyright (c) 2017-2018 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author David Sehnal <david.sehnal@gmail.com>
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */









var CIF = {
    parse: function (data) { return typeof data === 'string' ? Object(_cif_text_parser__WEBPACK_IMPORTED_MODULE_0__["default"])(data) : Object(_cif_binary_parser__WEBPACK_IMPORTED_MODULE_1__["default"])(data); },
    parseText: _cif_text_parser__WEBPACK_IMPORTED_MODULE_0__["default"],
    parseBinary: _cif_binary_parser__WEBPACK_IMPORTED_MODULE_1__["default"],
    toDatabaseCollection: _cif_schema__WEBPACK_IMPORTED_MODULE_2__["toDatabaseCollection"],
    toDatabase: _cif_schema__WEBPACK_IMPORTED_MODULE_2__["toDatabase"],
    schema: {
        mmCIF: function (frame) { return Object(_cif_schema__WEBPACK_IMPORTED_MODULE_2__["toDatabase"])(_cif_schema_mmcif__WEBPACK_IMPORTED_MODULE_3__["mmCIF_Schema"], frame); },
        CCD: function (frame) { return Object(_cif_schema__WEBPACK_IMPORTED_MODULE_2__["toDatabase"])(_cif_schema_ccd__WEBPACK_IMPORTED_MODULE_4__["CCD_Schema"], frame); },
        BIRD: function (frame) { return Object(_cif_schema__WEBPACK_IMPORTED_MODULE_2__["toDatabase"])(_cif_schema_bird__WEBPACK_IMPORTED_MODULE_5__["BIRD_Schema"], frame); },
        dic: function (frame) { return Object(_cif_schema__WEBPACK_IMPORTED_MODULE_2__["toDatabase"])(_cif_schema_dic__WEBPACK_IMPORTED_MODULE_6__["dic_Schema"], frame); },
        cifCore: function (frame) { return Object(_cif_schema__WEBPACK_IMPORTED_MODULE_2__["toDatabase"])(_cif_schema_cif_core__WEBPACK_IMPORTED_MODULE_8__["CifCore_Schema"], frame, _cif_schema_cif_core__WEBPACK_IMPORTED_MODULE_8__["CifCore_Aliases"]); },
        densityServer: function (frame) { return Object(_cif_schema__WEBPACK_IMPORTED_MODULE_2__["toDatabase"])(_cif_schema_density_server__WEBPACK_IMPORTED_MODULE_7__["DensityServer_Data_Schema"], frame); },
    }
};

//# sourceMappingURL=cif.js.map

/***/ }),

/***/ "./lib/mol-io/reader/cif/binary/field.js":
/*!***********************************************!*\
  !*** ./lib/mol-io/reader/cif/binary/field.js ***!
  \***********************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return Field; });
/* harmony import */ var _mol_data_db__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../../../mol-data/db */ "./lib/mol-data/db.js");
/* harmony import */ var _common_binary_cif__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../../common/binary-cif */ "./lib/mol-io/common/binary-cif.js");
/* harmony import */ var _common_text_number_parser__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../common/text/number-parser */ "./lib/mol-io/reader/common/text/number-parser.js");
/**
 * Copyright (c) 2017-2018 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author David Sehnal <david.sehnal@gmail.com>
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */



function Field(column) {
    var mask = column.mask ? Object(_common_binary_cif__WEBPACK_IMPORTED_MODULE_1__["decode"])(column.mask) : void 0;
    var data = Object(_common_binary_cif__WEBPACK_IMPORTED_MODULE_1__["decode"])(column.data);
    var isNumeric = _mol_data_db__WEBPACK_IMPORTED_MODULE_0__["ColumnHelpers"].isTypedArray(data);
    var str = isNumeric
        ? mask
            ? function (row) { return mask[row] === 0 /* Present */ ? '' + data[row] : ''; }
            : function (row) { return '' + data[row]; }
        : mask
            ? function (row) { return mask[row] === 0 /* Present */ ? data[row] : ''; }
            : function (row) { return data[row]; };
    var int = isNumeric
        ? function (row) { return data[row]; }
        : function (row) { var v = data[row]; return Object(_common_text_number_parser__WEBPACK_IMPORTED_MODULE_2__["parseInt"])(v, 0, v.length); };
    var float = isNumeric
        ? function (row) { return data[row]; }
        : function (row) { var v = data[row]; return Object(_common_text_number_parser__WEBPACK_IMPORTED_MODULE_2__["parseFloat"])(v, 0, v.length); };
    var valueKind = mask
        ? function (row) { return mask[row]; }
        : function (row) { return 0 /* Present */; };
    var rowCount = data.length;
    return {
        __array: data,
        binaryEncoding: column.data.encoding,
        isDefined: true,
        rowCount: rowCount,
        str: str,
        int: int,
        float: float,
        valueKind: valueKind,
        areValuesEqual: function (rowA, rowB) { return data[rowA] === data[rowB]; },
        toStringArray: function (params) { return _mol_data_db__WEBPACK_IMPORTED_MODULE_0__["ColumnHelpers"].createAndFillArray(rowCount, str, params); },
        toIntArray: isNumeric
            ? function (params) { return _mol_data_db__WEBPACK_IMPORTED_MODULE_0__["ColumnHelpers"].typedArrayWindow(data, params); }
            : function (params) { return _mol_data_db__WEBPACK_IMPORTED_MODULE_0__["ColumnHelpers"].createAndFillArray(rowCount, int, params); },
        toFloatArray: isNumeric
            ? function (params) { return _mol_data_db__WEBPACK_IMPORTED_MODULE_0__["ColumnHelpers"].typedArrayWindow(data, params); }
            : function (params) { return _mol_data_db__WEBPACK_IMPORTED_MODULE_0__["ColumnHelpers"].createAndFillArray(rowCount, float, params); }
    };
}
//# sourceMappingURL=field.js.map

/***/ }),

/***/ "./lib/mol-io/reader/cif/binary/parser.js":
/*!************************************************!*\
  !*** ./lib/mol-io/reader/cif/binary/parser.js ***!
  \************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return parse; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _data_model__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../data-model */ "./lib/mol-io/reader/cif/data-model.js");
/* harmony import */ var _field__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./field */ "./lib/mol-io/reader/cif/binary/field.js");
/* harmony import */ var _result__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../result */ "./lib/mol-io/reader/result.js");
/* harmony import */ var _common_msgpack_decode__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../../common/msgpack/decode */ "./lib/mol-io/common/msgpack/decode.js");
/* harmony import */ var _mol_task__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../../../mol-task */ "./lib/mol-task/index.js");
/**
 * Copyright (c) 2017 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author David Sehnal <david.sehnal@gmail.com>
 */






function checkVersions(min, current) {
    for (var i = 0; i < 2; i++) {
        if (min[i] > current[i])
            return false;
    }
    return true;
}
function Category(data) {
    var map = Object.create(null);
    var cache = Object.create(null);
    for (var _i = 0, _a = data.columns; _i < _a.length; _i++) {
        var col = _a[_i];
        map[col.name] = col;
    }
    return {
        rowCount: data.rowCount,
        name: data.name.substr(1),
        fieldNames: data.columns.map(function (c) { return c.name; }),
        getField: function (name) {
            var col = map[name];
            if (!col)
                return void 0;
            if (!!cache[name])
                return cache[name];
            cache[name] = Object(_field__WEBPACK_IMPORTED_MODULE_2__["default"])(col);
            return cache[name];
        }
    };
}
function parse(data) {
    var _this = this;
    return _mol_task__WEBPACK_IMPORTED_MODULE_5__["Task"].create('Parse BinaryCIF', function (ctx) { return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"])(_this, void 0, void 0, function () {
        var minVersion, unpacked, file;
        return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__generator"])(this, function (_a) {
            minVersion = [0, 3];
            try {
                unpacked = Object(_common_msgpack_decode__WEBPACK_IMPORTED_MODULE_4__["default"])(data);
                if (!checkVersions(minVersion, unpacked.version.match(/(\d)\.(\d)\.\d/).slice(1).map(function (v) { return +v; }))) {
                    return [2 /*return*/, _result__WEBPACK_IMPORTED_MODULE_3__["ReaderResult"].error("Unsupported format version. Current " + unpacked.version + ", required " + minVersion.join('.') + ".")];
                }
                file = _data_model__WEBPACK_IMPORTED_MODULE_1__["CifFile"](unpacked.dataBlocks.map(function (block) {
                    var cats = Object.create(null);
                    for (var _i = 0, _a = block.categories; _i < _a.length; _i++) {
                        var cat = _a[_i];
                        cats[cat.name.substr(1)] = Category(cat);
                    }
                    return _data_model__WEBPACK_IMPORTED_MODULE_1__["CifBlock"](block.categories.map(function (c) { return c.name.substr(1); }), cats, block.header);
                }));
                return [2 /*return*/, _result__WEBPACK_IMPORTED_MODULE_3__["ReaderResult"].success(file)];
            }
            catch (e) {
                return [2 /*return*/, _result__WEBPACK_IMPORTED_MODULE_3__["ReaderResult"].error('' + e)];
            }
            return [2 /*return*/];
        });
    }); });
}
//# sourceMappingURL=parser.js.map

/***/ }),

/***/ "./lib/mol-io/reader/cif/data-model.js":
/*!*********************************************!*\
  !*** ./lib/mol-io/reader/cif/data-model.js ***!
  \*********************************************/
/*! exports provided: CifFile, CifBlock, CifSaveFrame, CifCategory, CifField, tensorFieldNameGetter, getTensor, getCifFieldType */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CifFile", function() { return CifFile; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CifBlock", function() { return CifBlock; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CifSaveFrame", function() { return CifSaveFrame; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CifCategory", function() { return CifCategory; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CifField", function() { return CifField; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "tensorFieldNameGetter", function() { return tensorFieldNameGetter; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getTensor", function() { return getTensor; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getCifFieldType", function() { return getCifFieldType; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _mol_data_db__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../../mol-data/db */ "./lib/mol-data/db.js");
/* harmony import */ var _common_text_number_parser__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../common/text/number-parser */ "./lib/mol-io/reader/common/text/number-parser.js");
/* harmony import */ var _common_text_column_token__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../common/text/column/token */ "./lib/mol-io/reader/common/text/column/token.js");
/**
 * Copyright (c) 2017-2019 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author David Sehnal <david.sehnal@gmail.com>
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */




function CifFile(blocks, name) {
    return { name: name, blocks: blocks };
}
function CifBlock(categoryNames, categories, header, saveFrames) {
    if (saveFrames === void 0) { saveFrames = []; }
    return {
        categoryNames: categoryNames, header: header, categories: categories, saveFrames: saveFrames,
        getField: function (name) {
            var _a = name.split('.'), category = _a[0], field = _a[1];
            return categories[category].getField(field || '');
        }
    };
}
function CifSaveFrame(categoryNames, categories, header) {
    return { categoryNames: categoryNames, header: header, categories: categories };
}
function CifCategory(name, rowCount, fieldNames, fields) {
    return { rowCount: rowCount, name: name, fieldNames: Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__spreadArrays"])(fieldNames), getField: function (name) { return fields[name]; } };
}
(function (CifCategory) {
    function empty(name) {
        return { rowCount: 0, name: name, fieldNames: [], getField: function (name) { return void 0; } };
    }
    CifCategory.empty = empty;
    ;
    function ofFields(name, fields) {
        var fieldNames = Object.keys(fields);
        return {
            rowCount: fieldNames.length > 0 ? fields[fieldNames[0]].rowCount : 0,
            name: name,
            fieldNames: fieldNames,
            getField: function (name) { return fields[name]; }
        };
    }
    CifCategory.ofFields = ofFields;
    function ofTable(name, table) {
        var fields = {};
        for (var _a = 0, _b = table._columns; _a < _b.length; _a++) {
            var name_1 = _b[_a];
            fields[name_1] = CifField.ofColumn(table[name_1]);
        }
        return ofFields(name, fields);
    }
    CifCategory.ofTable = ofTable;
})(CifCategory || (CifCategory = {}));
var CifField;
(function (CifField) {
    function ofString(value) {
        return ofStrings([value]);
    }
    CifField.ofString = ofString;
    function ofStrings(values) {
        var rowCount = values.length;
        var str = function (row) { var ret = values[row]; if (!ret || ret === '.' || ret === '?')
            return ''; return ret; };
        var int = function (row) { var v = values[row]; return Object(_common_text_number_parser__WEBPACK_IMPORTED_MODULE_2__["parseInt"])(v, 0, v.length) || 0; };
        var float = function (row) { var v = values[row]; return Object(_common_text_number_parser__WEBPACK_IMPORTED_MODULE_2__["parseFloat"])(v, 0, v.length) || 0; };
        var valueKind = function (row) {
            var v = values[row], l = v.length;
            if (l > 1)
                return 0 /* Present */;
            if (l === 0)
                return 1 /* NotPresent */;
            var c = v.charCodeAt(0);
            if (c === 46 /* . */)
                return 1 /* NotPresent */;
            if (c === 63 /* ? */)
                return 2 /* Unknown */;
            return 0 /* Present */;
        };
        return {
            __array: void 0,
            binaryEncoding: void 0,
            isDefined: true,
            rowCount: rowCount,
            str: str,
            int: int,
            float: float,
            valueKind: valueKind,
            areValuesEqual: function (rowA, rowB) { return values[rowA] === values[rowB]; },
            toStringArray: function (params) { return params ? _mol_data_db__WEBPACK_IMPORTED_MODULE_1__["ColumnHelpers"].createAndFillArray(rowCount, str, params) : values; },
            toIntArray: function (params) { return _mol_data_db__WEBPACK_IMPORTED_MODULE_1__["ColumnHelpers"].createAndFillArray(rowCount, int, params); },
            toFloatArray: function (params) { return _mol_data_db__WEBPACK_IMPORTED_MODULE_1__["ColumnHelpers"].createAndFillArray(rowCount, float, params); }
        };
    }
    CifField.ofStrings = ofStrings;
    function ofNumbers(values) {
        var rowCount = values.length;
        var str = function (row) { return '' + values[row]; };
        var float = function (row) { return values[row]; };
        var valueKind = function (row) { return 0 /* Present */; };
        var toFloatArray = function (params) {
            if (!params || params.array && values instanceof params.array) {
                return values;
            }
            else {
                return _mol_data_db__WEBPACK_IMPORTED_MODULE_1__["ColumnHelpers"].createAndFillArray(rowCount, float, params);
            }
        };
        return {
            __array: void 0,
            binaryEncoding: void 0,
            isDefined: true,
            rowCount: rowCount,
            str: str,
            int: float,
            float: float,
            valueKind: valueKind,
            areValuesEqual: function (rowA, rowB) { return values[rowA] === values[rowB]; },
            toStringArray: function (params) { return _mol_data_db__WEBPACK_IMPORTED_MODULE_1__["ColumnHelpers"].createAndFillArray(rowCount, str, params); },
            toIntArray: toFloatArray,
            toFloatArray: toFloatArray
        };
    }
    CifField.ofNumbers = ofNumbers;
    function ofTokens(tokens) {
        var data = tokens.data, indices = tokens.indices, rowCount = tokens.count;
        var str = function (row) {
            var ret = data.substring(indices[2 * row], indices[2 * row + 1]);
            if (ret === '.' || ret === '?')
                return '';
            return ret;
        };
        var int = function (row) {
            return Object(_common_text_number_parser__WEBPACK_IMPORTED_MODULE_2__["parseInt"])(data, indices[2 * row], indices[2 * row + 1]) || 0;
        };
        var float = function (row) {
            return Object(_common_text_number_parser__WEBPACK_IMPORTED_MODULE_2__["parseFloat"])(data, indices[2 * row], indices[2 * row + 1]) || 0;
        };
        var valueKind = function (row) {
            var s = indices[2 * row], l = indices[2 * row + 1] - s;
            if (l > 1)
                return 0 /* Present */;
            if (l === 0)
                return 1 /* NotPresent */;
            var v = data.charCodeAt(s);
            if (v === 46 /* . */)
                return 1 /* NotPresent */;
            if (v === 63 /* ? */)
                return 2 /* Unknown */;
            return 0 /* Present */;
        };
        return {
            __array: void 0,
            binaryEncoding: void 0,
            isDefined: true,
            rowCount: rowCount,
            str: str,
            int: int,
            float: float,
            valueKind: valueKind,
            areValuesEqual: Object(_common_text_column_token__WEBPACK_IMPORTED_MODULE_3__["areValuesEqualProvider"])(tokens),
            toStringArray: function (params) { return _mol_data_db__WEBPACK_IMPORTED_MODULE_1__["ColumnHelpers"].createAndFillArray(rowCount, str, params); },
            toIntArray: function (params) { return _mol_data_db__WEBPACK_IMPORTED_MODULE_1__["ColumnHelpers"].createAndFillArray(rowCount, int, params); },
            toFloatArray: function (params) { return _mol_data_db__WEBPACK_IMPORTED_MODULE_1__["ColumnHelpers"].createAndFillArray(rowCount, float, params); }
        };
    }
    CifField.ofTokens = ofTokens;
    function ofColumn(column) {
        var rowCount = column.rowCount, valueKind = column.valueKind, areValuesEqual = column.areValuesEqual, isDefined = column.isDefined;
        var str;
        var int;
        var float;
        switch (column.schema.valueType) {
            case 'float':
            case 'int':
                str = function (row) { return '' + column.value(row); };
                int = column.value;
                float = column.value;
                break;
            case 'str':
                str = column.value;
                int = function (row) { var v = column.value(row); return Object(_common_text_number_parser__WEBPACK_IMPORTED_MODULE_2__["parseInt"])(v, 0, v.length) || 0; };
                float = function (row) { var v = column.value(row); return Object(_common_text_number_parser__WEBPACK_IMPORTED_MODULE_2__["parseFloat"])(v, 0, v.length) || 0; };
                break;
            case 'list':
                var separator_1 = column.schema.separator;
                str = function (row) { return column.value(row).join(separator_1); };
                int = function (row) { return NaN; };
                float = function (row) { return NaN; };
                break;
            default:
                throw new Error("unsupported valueType '" + column.schema.valueType + "'");
        }
        return {
            __array: void 0,
            binaryEncoding: void 0,
            isDefined: isDefined,
            rowCount: rowCount,
            str: str,
            int: int,
            float: float,
            valueKind: valueKind,
            areValuesEqual: areValuesEqual,
            toStringArray: function (params) { return _mol_data_db__WEBPACK_IMPORTED_MODULE_1__["ColumnHelpers"].createAndFillArray(rowCount, str, params); },
            toIntArray: function (params) { return _mol_data_db__WEBPACK_IMPORTED_MODULE_1__["ColumnHelpers"].createAndFillArray(rowCount, int, params); },
            toFloatArray: function (params) { return _mol_data_db__WEBPACK_IMPORTED_MODULE_1__["ColumnHelpers"].createAndFillArray(rowCount, float, params); }
        };
    }
    CifField.ofColumn = ofColumn;
    function ofUndefined(rowCount, schema) {
        return ofColumn(_mol_data_db__WEBPACK_IMPORTED_MODULE_1__["Column"].Undefined(rowCount, schema));
    }
    CifField.ofUndefined = ofUndefined;
})(CifField || (CifField = {}));
function tensorFieldNameGetter(field, rank, zeroIndexed, namingVariant) {
    var offset = zeroIndexed ? 0 : 1;
    switch (rank) {
        case 1:
            return namingVariant === 'brackets'
                ? function (i) { return field + "[" + (i + offset) + "]"; }
                : function (i) { return field + "_" + (i + offset); };
        case 2:
            return namingVariant === 'brackets'
                ? function (i, j) { return field + "[" + (i + offset) + "][" + (j + offset) + "]"; }
                : function (i, j) { return field + "_" + (i + offset) + (j + offset); };
        case 3:
            return namingVariant === 'brackets'
                ? function (i, j, k) { return field + "[" + (i + offset) + "][" + (j + offset) + "][" + (k + offset) + "]"; }
                : function (i, j, k) { return field + "_" + (i + offset) + (j + offset) + (k + offset); };
        default:
            throw new Error('Tensors with rank > 3 or rank 0 are currently not supported.');
    }
}
function getTensor(category, space, row, getName) {
    var ret = space.create();
    if (space.rank === 1) {
        var rows = space.dimensions[0];
        for (var i = 0; i < rows; i++) {
            var f = category.getField(getName(i));
            space.set(ret, i, !!f ? f.float(row) : 0.0);
        }
    }
    else if (space.rank === 2) {
        var rows = space.dimensions[0], cols = space.dimensions[1];
        for (var i = 0; i < rows; i++) {
            for (var j = 0; j < cols; j++) {
                var f = category.getField(getName(i, j));
                space.set(ret, i, j, !!f ? f.float(row) : 0.0);
            }
        }
    }
    else if (space.rank === 3) {
        var d0 = space.dimensions[0], d1 = space.dimensions[1], d2 = space.dimensions[2];
        for (var i = 0; i < d0; i++) {
            for (var j = 0; j < d1; j++) {
                for (var k = 0; k < d2; k++) {
                    var f = category.getField(getName(i, j, k));
                    space.set(ret, i, j, k, !!f ? f.float(row) : 0.0);
                }
            }
        }
    }
    else {
        throw new Error('Tensors with rank > 3 or rank 0 are currently not supported.');
    }
    return ret;
}
function getCifFieldType(field) {
    var floatCount = 0, hasStringOrScientific = false, undefinedCount = 0;
    for (var i = 0, _i = field.rowCount; i < _i; i++) {
        var k = field.valueKind(i);
        if (k !== 0 /* Present */) {
            undefinedCount++;
            continue;
        }
        var type = Object(_common_text_number_parser__WEBPACK_IMPORTED_MODULE_2__["getNumberType"])(field.str(i));
        if (type === 0 /* Int */)
            continue;
        else if (type === 1 /* Float */)
            floatCount++;
        else {
            hasStringOrScientific = true;
            break;
        }
    }
    // numbers in scientific notation and plain text are not distinguishable
    if (hasStringOrScientific || undefinedCount === field.rowCount)
        return _mol_data_db__WEBPACK_IMPORTED_MODULE_1__["Column"].Schema.str;
    if (floatCount > 0)
        return _mol_data_db__WEBPACK_IMPORTED_MODULE_1__["Column"].Schema.float;
    return _mol_data_db__WEBPACK_IMPORTED_MODULE_1__["Column"].Schema.int;
}
//# sourceMappingURL=data-model.js.map

/***/ }),

/***/ "./lib/mol-io/reader/cif/schema.js":
/*!*****************************************!*\
  !*** ./lib/mol-io/reader/cif/schema.js ***!
  \*****************************************/
/*! exports provided: FieldPath, toDatabaseCollection, toDatabase, toTable */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FieldPath", function() { return FieldPath; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "toDatabaseCollection", function() { return toDatabaseCollection; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "toDatabase", function() { return toDatabase; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "toTable", function() { return toTable; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _mol_data_db__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../../mol-data/db */ "./lib/mol-data/db.js");
/* harmony import */ var _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../../mol-math/linear-algebra */ "./lib/mol-math/linear-algebra.js");
/* harmony import */ var _mol_util__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../../mol-util */ "./lib/mol-util/index.js");
/* harmony import */ var _data_model__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./data-model */ "./lib/mol-io/reader/cif/data-model.js");
/**
 * Copyright (c) 2017-2019 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author David Sehnal <david.sehnal@gmail.com>
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */





var FieldPath;
(function (FieldPath) {
    function canonical(path) {
        return path.replace('.', '_').replace(/\[/, '_').replace(/(\[|\])/g, '');
    }
    FieldPath.canonical = canonical;
    function equal(pathA, pathB) {
        return canonical(pathA) === canonical(pathB);
    }
    FieldPath.equal = equal;
    function create(category, field, asCanonical) {
        if (asCanonical === void 0) { asCanonical = false; }
        var p = "" + category + (field ? "." + field : '');
        return asCanonical ? canonical(p) : p;
    }
    FieldPath.create = create;
})(FieldPath || (FieldPath = {}));
function toDatabaseCollection(schema, file, aliases) {
    var dbc = {};
    for (var _i = 0, _a = file.blocks; _i < _a.length; _i++) {
        var data = _a[_i];
        dbc[data.header] = toDatabase(schema, data, aliases);
    }
    return dbc;
}
function toDatabase(schema, frame, aliases) {
    return createDatabase(schema, frame, aliases);
}
function toTable(schema, category) {
    return new CategoryTable(category, schema, true);
}
function getColumnCtor(t) {
    switch (t.valueType) {
        case 'str': return function (f, c, k) { return createColumn(t, f, f.str, f.toStringArray); };
        case 'int': return function (f, c, k) { return createColumn(t, f, f.int, f.toIntArray); };
        case 'float': return function (f, c, k) { return createColumn(t, f, f.float, f.toFloatArray); };
        case 'list': throw new Error('Use createListColumn instead.');
        case 'tensor': throw new Error('Use createTensorColumn instead.');
    }
}
function createColumn(schema, field, value, toArray) {
    return {
        schema: schema,
        __array: field.__array,
        isDefined: field.isDefined,
        rowCount: field.rowCount,
        value: value,
        valueKind: field.valueKind,
        areValuesEqual: field.areValuesEqual,
        toArray: toArray
    };
}
function createListColumn(schema, category, key) {
    var separator = schema.separator;
    var itemParse = schema.itemParse;
    var f = category.getField(key);
    var value = f ? function (row) { return f.str(row).split(separator).map(function (x) { return itemParse(x.trim()); }).filter(function (x) { return !!x; }); } : function (row) { return []; };
    var toArray = function (params) { return _mol_data_db__WEBPACK_IMPORTED_MODULE_1__["ColumnHelpers"].createAndFillArray(category.rowCount, value, params); };
    return {
        schema: schema,
        __array: void 0,
        isDefined: !!f,
        rowCount: category.rowCount,
        value: value,
        valueKind: f ? f.valueKind : function () { return 1 /* NotPresent */; },
        areValuesEqual: function (rowA, rowB) { return Object(_mol_util__WEBPACK_IMPORTED_MODULE_3__["arrayEqual"])(value(rowA), value(rowB)); },
        toArray: toArray
    };
}
function createTensorColumn(schema, category, key) {
    var space = schema.space;
    var zeroOffset = (category.fieldNames.includes(key + "[0]") ||
        category.fieldNames.includes(key + "[0][0]") ||
        category.fieldNames.includes(key + "[0][0][0]"));
    var fst = zeroOffset ? 0 : 1;
    var namingVariant = (category.fieldNames.includes(key + "_1") ||
        category.fieldNames.includes(key + "_11") ||
        category.fieldNames.includes(key + "_111")) ? 'underscore' : 'brackets';
    var getName = _data_model__WEBPACK_IMPORTED_MODULE_4__["tensorFieldNameGetter"](key, space.rank, zeroOffset, namingVariant);
    var first = category.getField(getName(fst, fst, fst)) || _mol_data_db__WEBPACK_IMPORTED_MODULE_1__["Column"].Undefined(category.rowCount, schema);
    var value = function (row) { return _data_model__WEBPACK_IMPORTED_MODULE_4__["getTensor"](category, space, row, getName); };
    var toArray = function (params) { return _mol_data_db__WEBPACK_IMPORTED_MODULE_1__["ColumnHelpers"].createAndFillArray(category.rowCount, value, params); };
    return {
        schema: schema,
        __array: void 0,
        isDefined: first.isDefined,
        rowCount: category.rowCount,
        value: value,
        valueKind: first.valueKind,
        areValuesEqual: function (rowA, rowB) { return _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_2__["Tensor"].areEqualExact(value(rowA), value(rowB)); },
        toArray: toArray
    };
}
var CategoryTable = /** @class */ (function () {
    function CategoryTable(category, schema, _isDefined) {
        this._isDefined = _isDefined;
        var fieldKeys = Object.keys(schema);
        this._rowCount = category.rowCount;
        this._columns = fieldKeys;
        this._schema = schema;
        var cache = Object.create(null);
        var _loop_1 = function (k) {
            Object.defineProperty(this_1, k, {
                get: function () {
                    if (cache[k])
                        return cache[k];
                    var fType = schema[k];
                    if (fType.valueType === 'list') {
                        cache[k] = createListColumn(fType, category, k);
                    }
                    else if (fType.valueType === 'tensor') {
                        cache[k] = createTensorColumn(fType, category, k);
                    }
                    else {
                        var ctor = getColumnCtor(fType);
                        var field = category.getField(k);
                        cache[k] = !!field ? ctor(field, category, k) : _mol_data_db__WEBPACK_IMPORTED_MODULE_1__["Column"].Undefined(category.rowCount, fType);
                    }
                    return cache[k];
                },
                enumerable: true,
                configurable: false
            });
        };
        var this_1 = this;
        for (var _i = 0, fieldKeys_1 = fieldKeys; _i < fieldKeys_1.length; _i++) {
            var k = fieldKeys_1[_i];
            _loop_1(k);
        }
    }
    return CategoryTable;
}());
function createDatabase(schema, frame, aliases) {
    var tables = Object.create(null);
    for (var _i = 0, _a = Object.keys(schema); _i < _a.length; _i++) {
        var k = _a[_i];
        tables[k] = createTable(k, schema[k], frame, aliases);
    }
    return _mol_data_db__WEBPACK_IMPORTED_MODULE_1__["Database"].ofTables(frame.header, schema, tables);
}
function flattenFrame(frame) {
    var flatFrame = Object.create(null);
    for (var _i = 0, _a = Object.keys(frame.categories); _i < _a.length; _i++) {
        var c = _a[_i];
        for (var _b = 0, _c = frame.categories[c].fieldNames; _b < _c.length; _b++) {
            var f = _c[_b];
            var p = FieldPath.create(c, f, true);
            flatFrame[p] = frame.categories[c].getField(f);
        }
    }
    return flatFrame;
}
function getField(field, category, flatFrame, aliases) {
    var path = FieldPath.create(category, field);
    var canonicalPath = FieldPath.canonical(path);
    if (canonicalPath in flatFrame)
        return flatFrame[canonicalPath];
    if (aliases && path in aliases) {
        for (var _i = 0, _a = aliases[path]; _i < _a.length; _i++) {
            var aliased = _a[_i];
            var canonicalAliased = FieldPath.canonical(aliased);
            if (canonicalAliased in flatFrame)
                return flatFrame[canonicalAliased];
        }
    }
}
function createTable(key, schema, frame, aliases) {
    var cat = frame.categories[key];
    if (aliases) {
        var flatFrame = flattenFrame(frame);
        var fields_1 = Object.create(null);
        var fieldNames = [];
        var rowCount = 0;
        for (var _i = 0, _a = Object.keys(schema); _i < _a.length; _i++) {
            var k = _a[_i];
            var field = getField(k, key, flatFrame, aliases);
            if (field) {
                fields_1[k] = field;
                fieldNames.push(k);
                rowCount = field.rowCount;
            }
        }
        cat = {
            rowCount: rowCount,
            name: key,
            fieldNames: Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__spreadArrays"])(fieldNames),
            getField: function (name) {
                return fields_1[name];
            }
        };
    }
    return new CategoryTable(cat || _data_model__WEBPACK_IMPORTED_MODULE_4__["CifCategory"].empty(key), schema, !!cat);
}
//# sourceMappingURL=schema.js.map

/***/ }),

/***/ "./lib/mol-io/reader/cif/schema/bird.js":
/*!**********************************************!*\
  !*** ./lib/mol-io/reader/cif/schema/bird.js ***!
  \**********************************************/
/*! exports provided: BIRD_Schema */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "BIRD_Schema", function() { return BIRD_Schema; });
/* harmony import */ var _mol_data_db__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../../../mol-data/db */ "./lib/mol-data/db.js");
/**
 * Copyright (c) 2017-2020 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * Code-generated 'BIRD' schema file. Dictionary versions: mmCIF 5.333, IHM 1.12, CARB draft.
 *
 * @author molstar/ciftools package
 */

var Schema = _mol_data_db__WEBPACK_IMPORTED_MODULE_0__["Column"].Schema;
var str = Schema.str;
var float = Schema.float;
var Aliased = Schema.Aliased;
var int = Schema.int;
var BIRD_Schema = {
    /**
     * Data items in the PDBX_REFERENCE_MOLECULE category record
     * reference information about small polymer molecules.
     */
    pdbx_reference_molecule: {
        /**
         * The value of _pdbx_reference_molecule.prd_id is the unique identifier
         * for the reference molecule in this family.
         *
         * By convention this ID uniquely identifies the reference molecule in
         * in the PDB reference dictionary.
         *
         * The ID has the template form PRD_dddddd (e.g. PRD_000001)
         */
        prd_id: str,
        /**
         * Formula mass in daltons of the entity.
         */
        formula_weight: float,
        /**
         * The formula for the reference entity. Formulae are written
         * according to the rules:
         *
         * 1. Only recognised element symbols may be used.
         *
         * 2. Each element symbol is followed by a 'count' number. A count
         * of '1' may be omitted.
         *
         * 3. A space or parenthesis must separate each element symbol and
         * its count, but in general parentheses are not used.
         *
         * 4. The order of elements depends on whether or not carbon is
         * present. If carbon is present, the order should be: C, then
         * H, then the other elements in alphabetical order of their
         * symbol. If carbon is not present, the elements are listed
         * purely in alphabetic order of their symbol. This is the
         * 'Hill' system used by Chemical Abstracts.
         */
        formula: str,
        /**
         * Defines the structural classification of the entity.
         */
        type: Aliased(str),
        /**
         * Evidence for the assignment of _pdbx_reference_molecule.type
         */
        type_evidence_code: str,
        /**
         * Broadly defines the function of the entity.
         */
        class: Aliased(str),
        /**
         * Evidence for the assignment of _pdbx_reference_molecule.class
         */
        class_evidence_code: str,
        /**
         * A name of the entity.
         */
        name: str,
        /**
         * Defines how this entity is represented in PDB data files.
         */
        represent_as: Aliased(str),
        /**
         * For entities represented as single molecules, the identifier
         * corresponding to the chemical definition for the molecule.
         */
        chem_comp_id: str,
        /**
         * Special details about this molecule.
         */
        compound_details: str,
        /**
         * Description of this molecule.
         */
        description: str,
        /**
         * The PDB accession code for the entry containing a representative example of this molecule.
         */
        representative_PDB_id_code: str,
        /**
         * Defines the current PDB release status for this molecule definition.
         */
        release_status: Aliased(str),
        /**
         * Assigns the identifier for the reference molecule which have been replaced
         * by this reference molecule.
         * Multiple molecule identifier codes should be separated by commas.
         */
        replaces: str,
        /**
         * Assigns the identifier of the reference molecule that has replaced this molecule.
         */
        replaced_by: str,
    },
    /**
     * Data items in the PDBX_REFERENCE_ENTITY_LIST category record
     * the list of entities within each reference molecule.
     */
    pdbx_reference_entity_list: {
        /**
         * The value of _pdbx_reference_entity_list.prd_id is a reference
         * _pdbx_reference_molecule.prd_id in the PDBX_REFERENCE_MOLECULE category.
         */
        prd_id: str,
        /**
         * The value of _pdbx_reference_entity_list.ref_entity_id is a unique identifier
         * the a constituent entity within this reference molecule.
         */
        ref_entity_id: str,
        /**
         * Defines the polymer characteristic of the entity.
         */
        type: Aliased(str),
        /**
         * Additional details about this entity.
         */
        details: str,
        /**
         * The component number of this entity within the molecule.
         */
        component_id: int,
    },
    /**
     * Data items in the PDBX_REFERENCE_ENTITY_NONPOLY category record
     * the list of entities within each reference molecule.
     */
    pdbx_reference_entity_nonpoly: {
        /**
         * The value of _pdbx_reference_entity_nonpoly.prd_id is a reference
         * _pdbx_reference_entity_list.prd_id in the PDBX_REFERENCE_ENTITY_LIST category.
         */
        prd_id: str,
        /**
         * The value of _pdbx_reference_entity_nonpoly.ref_entity_id is a reference
         * to _pdbx_reference_entity_list.ref_entity_id in PDBX_REFERENCE_ENTITY_LIST category.
         */
        ref_entity_id: str,
        /**
         * A name of the non-polymer entity.
         */
        name: str,
        /**
         * For non-polymer entities, the identifier corresponding
         * to the chemical definition for the molecule.
         */
        chem_comp_id: str,
    },
    /**
     * Data items in the PDBX_REFERENCE_ENTITY_LINK category give details about
     * the linkages between entities within reference molecules.
     */
    pdbx_reference_entity_link: {
        /**
         * The value of _pdbx_reference_entity_link.link_id uniquely identifies
         * linkages between entities with a molecule.
         */
        link_id: int,
        /**
         * The value of _pdbx_reference_entity_link.prd_id is a reference
         * _pdbx_reference_entity_list.prd_id in the PDBX_REFERENCE_ENTITY_LIST category.
         */
        prd_id: str,
        /**
         * A description of special aspects of a linkage between
         * chemical components in the structure.
         */
        details: str,
        /**
         * The reference entity id of the first of the two entities joined by the
         * linkage.
         *
         * This data item is a pointer to _pdbx_reference_entity_list.ref_entity_id
         * in the PDBX_REFERENCE_ENTITY_LIST category.
         */
        ref_entity_id_1: str,
        /**
         * The reference entity id of the second of the two entities joined by the
         * linkage.
         *
         * This data item is a pointer to _pdbx_reference_entity_list.ref_entity_id
         * in the PDBX_REFERENCE_ENTITY_LIST category.
         */
        ref_entity_id_2: str,
        /**
         * For a polymer entity, the sequence number in the first of
         * the two entities containing the linkage.
         *
         * This data item is a pointer to _pdbx_reference_entity_poly_seq.num
         * in the PDBX_REFERENCE_ENTITY_POLY_SEQ category.
         */
        entity_seq_num_1: int,
        /**
         * For a polymer entity, the sequence number in the second of
         * the two entities containing the linkage.
         *
         * This data item is a pointer to _pdbx_reference_entity_poly_seq.num
         * in the PDBX_REFERENCE_ENTITY_POLY_SEQ category.
         */
        entity_seq_num_2: int,
        /**
         * The component identifier in the first of the two entities containing the linkage.
         *
         * For polymer entities, this data item is a pointer to _pdbx_reference_entity_poly_seq.mon_id
         * in the PDBX_REFERENCE_ENTITY_POLY_SEQ category.
         *
         * For non-polymer entities, this data item is a pointer to
         * _pdbx_reference_entity_nonpoly.chem_comp_id in the
         * PDBX_REFERENCE_ENTITY_NONPOLY category.
         */
        comp_id_1: str,
        /**
         * The component identifier in the second of the two entities containing the linkage.
         *
         * For polymer entities, this data item is a pointer to _pdbx_reference_entity_poly_seq.mon_id
         * in the PDBX_REFERENCE_ENTITY_POLY_SEQ category.
         *
         * For non-polymer entities, this data item is a pointer to
         * _pdbx_reference_entity_nonpoly.chem_comp_id in the
         * PDBX_REFERENCE_ENTITY_NONPOLY category.
         */
        comp_id_2: str,
        /**
         * The atom identifier/name in the first of the two entities containing the linkage.
         */
        atom_id_1: str,
        /**
         * The atom identifier/name in the second of the two entities containing the linkage.
         */
        atom_id_2: str,
        /**
         * The bond order target for the chemical linkage.
         */
        value_order: Aliased(str),
        /**
         * The entity component identifier for the first of two entities containing the linkage.
         */
        component_1: int,
        /**
         * The entity component identifier for the second of two entities containing the linkage.
         */
        component_2: int,
        /**
         * A code indicating the entity types involved in the linkage.
         */
        link_class: Aliased(str),
    },
    /**
     * Data items in the PDBX_REFERENCE_ENTITY_POLY_LINK category give details about
     * polymer linkages including both standard and non-standard linkages between
     * polymer componnents.
     */
    pdbx_reference_entity_poly_link: {
        /**
         * The value of _pdbx_reference_entity_poly_link.link_id uniquely identifies
         * a linkage within a polymer entity.
         */
        link_id: int,
        /**
         * The value of _pdbx_reference_entity_poly_link.prd_id is a reference
         * _pdbx_reference_entity_list.prd_id in the PDBX_REFERENCE_ENTITY_POLY category.
         */
        prd_id: str,
        /**
         * The reference entity id of the polymer entity containing the linkage.
         *
         * This data item is a pointer to _pdbx_reference_entity_poly.ref_entity_id
         * in the PDBX_REFERENCE_ENTITY_POLY category.
         */
        ref_entity_id: str,
        /**
         * The entity component identifier entity containing the linkage.
         */
        component_id: int,
        /**
         * For a polymer entity, the sequence number in the first of
         * the two components making the linkage.
         *
         * This data item is a pointer to _pdbx_reference_entity_poly_seq.num
         * in the PDBX_REFERENCE_ENTITY_POLY_SEQ category.
         */
        entity_seq_num_1: int,
        /**
         * For a polymer entity, the sequence number in the second of
         * the two components making the linkage.
         *
         * This data item is a pointer to _pdbx_reference_entity_poly_seq.num
         * in the PDBX_REFERENCE_ENTITY_POLY_SEQ category.
         */
        entity_seq_num_2: int,
        /**
         * The component identifier in the first of the two components making the
         * linkage.
         *
         * This data item is a pointer to _pdbx_reference_entity_poly_seq.mon_id
         * in the PDBX_REFERENCE_ENTITY_POLY_SEQ category.
         */
        comp_id_1: str,
        /**
         * The component identifier in the second of the two components making the
         * linkage.
         *
         * This data item is a pointer to _pdbx_reference_entity_poly_seq.mon_id
         * in the PDBX_REFERENCE_ENTITY_POLY_SEQ category.
         */
        comp_id_2: str,
        /**
         * The atom identifier/name in the first of the two components making
         * the linkage.
         */
        atom_id_1: str,
        /**
         * The atom identifier/name in the second of the two components making
         * the linkage.
         */
        atom_id_2: str,
        /**
         * The bond order target for the non-standard linkage.
         */
        value_order: Aliased(str),
    },
    /**
     * Data items in the PDBX_REFERENCE_ENTITY_POLY category record details about
     * the polymer, such as the type of the polymer, the number of
     * monomers and whether it has nonstandard features.
     */
    pdbx_reference_entity_poly: {
        /**
         * The value of _pdbx_reference_entity_poly.prd_id is a reference
         * _pdbx_reference_entity_list.prd_id in the  PDBX_REFERENCE_ENTITY_LIST category.
         */
        prd_id: str,
        /**
         * The value of _pdbx_reference_entity_poly.ref_entity_id is a reference
         * to _pdbx_reference_entity_list.ref_entity_id in PDBX_REFERENCE_ENTITY_LIST category.
         */
        ref_entity_id: str,
        /**
         * The type of the polymer.
         */
        type: Aliased(str),
        /**
         * The database code for this source information
         */
        db_code: str,
        /**
         * The database name for this source information
         */
        db_name: str,
    },
    /**
     * Data items in the PDBX_REFERENCE_ENTITY_POLY_SEQ category specify the sequence
     * of monomers in a polymer.
     */
    pdbx_reference_entity_poly_seq: {
        /**
         * The value of _pdbx_reference_entity_poly_seq.prd_id is a reference
         * _pdbx_reference_entity_poly.prd_id in the  PDBX_REFERENCE_ENTITY_POLY category.
         */
        prd_id: str,
        /**
         * The value of _pdbx_reference_entity_poly_seq.ref_entity_id is a reference
         * to _pdbx_reference_entity_poly.ref_entity_id in PDBX_REFERENCE_ENTITY_POLY category.
         */
        ref_entity_id: str,
        /**
         * This data item is the chemical component identifier of monomer.
         */
        mon_id: str,
        /**
         * This data item is the chemical component identifier for the parent component corresponding to this monomer.
         */
        parent_mon_id: str,
        /**
         * The value of _pdbx_reference_entity_poly_seq.num must uniquely and sequentially
         * identify a record in the PDBX_REFERENCE_ENTITY_POLY_SEQ list.
         *
         * This value is conforms to author numbering conventions and does not map directly
         * to the numbering conventions used for _entity_poly_seq.num.
         */
        num: int,
        /**
         * A flag to indicate that this monomer is observed in the instance example.
         */
        observed: Aliased(str),
        /**
         * A flag to indicate that sequence heterogeneity at this monomer position.
         */
        hetero: Aliased(str),
    },
    /**
     * Additional features associated with the reference entity.
     */
    pdbx_reference_entity_sequence: {
        /**
         * The value of _pdbx_reference_entity_sequence.prd_id is a reference
         * _pdbx_reference_entity_list.prd_id in the  PDBX_REFERENCE_ENTITY_LIST category.
         */
        prd_id: str,
        /**
         * The value of _pdbx_reference_entity_sequence.ref_entity_id is a reference
         * to _pdbx_reference_entity_list.ref_entity_id in PDBX_REFERENCE_ENTITY_LIST category.
         */
        ref_entity_id: str,
        /**
         * The monomer type for the sequence.
         */
        type: Aliased(str),
        /**
         * A flag to indicate a non-ribosomal entity.
         */
        NRP_flag: Aliased(str),
        /**
         * The one-letter-code sequence for this entity.  Non-standard monomers are represented as 'X'.
         */
        one_letter_codes: str,
    },
    /**
     * Data items in the PDBX_REFERENCE_ENTITY_SRC_NAT category record
     * details of the source from which the entity was obtained.
     */
    pdbx_reference_entity_src_nat: {
        /**
         * The value of _pdbx_reference_entity_src_nat.prd_id is a reference
         * _pdbx_reference_entity_list.prd_id in the  PDBX_REFERENCE_ENTITY_LIST category.
         */
        prd_id: str,
        /**
         * The value of _pdbx_reference_entity_src_nat.ref_entity_id is a reference
         * to _pdbx_reference_entity_list.ref_entity_id in PDBX_REFERENCE_ENTITY_LIST category.
         */
        ref_entity_id: str,
        /**
         * The value of _pdbx_reference_entity_src_nat.ordinal distinguishes
         * source details for this entity.
         */
        ordinal: int,
        /**
         * The scientific name of the organism from which the entity was isolated.
         */
        organism_scientific: str,
        /**
         * The NCBI TaxId of the organism from which the entity was isolated.
         */
        taxid: str,
        /**
         * The database code for this source information
         */
        db_code: str,
        /**
         * The database name for this source information
         */
        db_name: str,
    },
    /**
     * Data items in the PDBX_PRD_AUDIT category records
     * the status and tracking information for this molecule.
     */
    pdbx_prd_audit: {
        /**
         * This data item is a pointer to _pdbx_reference_molecule.prd_id in the
         * pdbx_reference_molecule category.
         */
        prd_id: str,
        /**
         * The date associated with this audit record.
         */
        date: str,
        /**
         * An identifier for the wwPDB site creating or modifying the molecule.
         */
        processing_site: Aliased(str),
        /**
         * The action associated with this audit record.
         */
        action_type: Aliased(str),
    },
};
;
//# sourceMappingURL=bird.js.map

/***/ }),

/***/ "./lib/mol-io/reader/cif/schema/ccd.js":
/*!*********************************************!*\
  !*** ./lib/mol-io/reader/cif/schema/ccd.js ***!
  \*********************************************/
/*! exports provided: CCD_Schema */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CCD_Schema", function() { return CCD_Schema; });
/* harmony import */ var _mol_data_db__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../../../mol-data/db */ "./lib/mol-data/db.js");
/**
 * Copyright (c) 2017-2020 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * Code-generated 'CCD' schema file. Dictionary versions: mmCIF 5.333, IHM 1.12, CARB draft.
 *
 * @author molstar/ciftools package
 */

var Schema = _mol_data_db__WEBPACK_IMPORTED_MODULE_0__["Column"].Schema;
var str = Schema.str;
var float = Schema.float;
var List = Schema.List;
var Aliased = Schema.Aliased;
var int = Schema.int;
var coord = Schema.coord;
var CCD_Schema = {
    /**
     * Data items in the CHEM_COMP category give details about each
     * of the chemical components from which the relevant chemical
     * structures can be constructed, such as name, mass or charge.
     *
     * The related categories CHEM_COMP_ATOM, CHEM_COMP_BOND,
     * CHEM_COMP_ANGLE etc. describe the detailed geometry of these
     * chemical components.
     */
    chem_comp: {
        /**
         * The formula for the chemical component. Formulae are written
         * according to the following rules:
         *
         * (1) Only recognized element symbols may be used.
         *
         * (2) Each element symbol is followed by a 'count' number. A count
         * of '1' may be omitted.
         *
         * (3) A space or parenthesis must separate each cluster of
         * (element symbol + count), but in general parentheses are
         * not used.
         *
         * (4) The order of elements depends on whether carbon is
         * present or not. If carbon is present, the order should be:
         * C, then H, then the other elements in alphabetical order
         * of their symbol. If carbon is not present, the elements
         * are listed purely in alphabetic order of their symbol. This
         * is the 'Hill' system used by Chemical Abstracts.
         */
        formula: str,
        /**
         * Formula mass in daltons of the chemical component.
         */
        formula_weight: float,
        /**
         * The value of _chem_comp.id must uniquely identify each item in
         * the CHEM_COMP list.
         *
         * For protein polymer entities, this is the three-letter code for
         * the amino acid.
         *
         * For nucleic acid polymer entities, this is the one-letter code
         * for the base.
         */
        id: str,
        /**
         * The identifier for the parent component of the nonstandard
         * component. May be be a comma separated list if this component
         * is derived from multiple components.
         *
         * Items in this indirectly point to _chem_comp.id in
         * the CHEM_COMP category.
         */
        mon_nstd_parent_comp_id: List(',', function (x) { return x; }),
        /**
         * The full name of the component.
         */
        name: str,
        /**
         * For standard polymer components, the one-letter code for
         * the component.   For non-standard polymer components, the
         * one-letter code for parent component if this exists;
         * otherwise, the one-letter code should be given as 'X'.
         *
         * Components that derived from multiple parents components
         * are described by a sequence of one-letter-codes.
         */
        one_letter_code: str,
        /**
         * For standard polymer components, the common three-letter code for
         * the component.   Non-standard polymer components and non-polymer
         * components are also assigned three-letter-codes.
         *
         * For ambiguous polymer components three-letter code should
         * be given as 'UNK'.  Ambiguous ions are assigned the code 'UNX'.
         * Ambiguous non-polymer components are assigned the code 'UNL'.
         */
        three_letter_code: str,
        /**
         * For standard polymer components, the type of the monomer.
         * Note that monomers that will form polymers are of three types:
         * linking monomers, monomers with some type of N-terminal (or 5')
         * cap and monomers with some type of C-terminal (or 3') cap.
         */
        type: Aliased(str),
        /**
         * Synonym list for the component.
         */
        pdbx_synonyms: List(';', function (x) { return x; }),
        /**
         * A preliminary classification used by PDB.
         */
        pdbx_type: str,
        /**
         * A preliminary classification used by PDB to indicate
         * that the chemistry of this component while described
         * as clearly as possible is still ambiguous.  Software
         * tools may not be able to process this component
         * definition.
         */
        pdbx_ambiguous_flag: str,
        /**
         * Identifies the _chem_comp.id of the component that
         * has replaced this component.
         */
        pdbx_replaced_by: str,
        /**
         * Identifies the _chem_comp.id's of the components
         * which have been replaced by this component.
         * Multiple id codes should be separated by commas.
         */
        pdbx_replaces: str,
        /**
         * The net integer charge assigned to this component. This is the
         * formal charge assignment normally found in chemical diagrams.
         */
        pdbx_formal_charge: int,
        /**
         * This data item provides additional details about the model coordinates
         * in the component definition.
         */
        pdbx_model_coordinates_details: str,
        /**
         * This data item identifies the PDB database code from which the heavy
         * atom model coordinates were obtained.
         */
        pdbx_model_coordinates_db_code: str,
        /**
         * This data item identifies the source of the ideal coordinates in the
         * component definition.
         */
        pdbx_ideal_coordinates_details: str,
        /**
         * This data item identifies if ideal coordinates are missing in this definition.
         */
        pdbx_ideal_coordinates_missing_flag: Aliased(str),
        /**
         * This data item identifies if model coordinates are missing in this definition.
         */
        pdbx_model_coordinates_missing_flag: Aliased(str),
        /**
         * Date component was added to database.
         */
        pdbx_initial_date: str,
        /**
         * Date component was last modified.
         */
        pdbx_modified_date: str,
        /**
         * This data item holds the current release status for the component.
         */
        pdbx_release_status: Aliased(str),
        /**
         * This data item identifies the deposition site that processed
         * this chemical component defintion.
         */
        pdbx_processing_site: Aliased(str),
    },
    /**
     * Data items in the CHEM_COMP_ATOM category record details about
     * the atoms in a chemical component. Specifying the atomic
     * coordinates for the components in this category is an
     * alternative to specifying the structure of the component
     * via bonds, angles, planes etc. in the appropriate
     * CHEM_COMP subcategories.
     */
    chem_comp_atom: {
        /**
         * An alternative identifier for the atom. This data item would be
         * used in cases where alternative nomenclatures exist for labelling
         * atoms in a group.
         */
        alt_atom_id: str,
        /**
         * The value of _chem_comp_atom.atom_id must uniquely identify
         * each atom in each monomer in the CHEM_COMP_ATOM list.
         *
         * The atom identifiers need not be unique over all atoms in the
         * data block; they need only be unique for each atom in a
         * component.
         *
         * Note that this item need not be a number; it can be any unique
         * identifier.
         */
        atom_id: str,
        /**
         * The net integer charge assigned to this atom. This is the
         * formal charge assignment normally found in chemical diagrams.
         */
        charge: int,
        /**
         * The x component of the coordinates for this atom in this
         * component specified as orthogonal angstroms. The choice of
         * reference axis frame for the coordinates is arbitrary.
         *
         * The set of coordinates input for the entity here is intended to
         * correspond to the atomic model used to generate restraints for
         * structure refinement, not to atom sites in the ATOM_SITE
         * list.
         */
        model_Cartn_x: coord,
        /**
         * The y component of the coordinates for this atom in this
         * component specified as orthogonal angstroms. The choice of
         * reference axis frame for the coordinates is arbitrary.
         *
         * The set of coordinates input for the entity here is intended to
         * correspond to the atomic model used to generate restraints for
         * structure refinement, not to atom sites in the ATOM_SITE
         * list.
         */
        model_Cartn_y: coord,
        /**
         * The z component of the coordinates for this atom in this
         * component specified as orthogonal angstroms. The choice of
         * reference axis frame for the coordinates is arbitrary.
         *
         * The set of coordinates input for the entity here is intended to
         * correspond to the atomic model used to generate restraints for
         * structure refinement, not to atom sites in the ATOM_SITE
         * list.
         */
        model_Cartn_z: coord,
        /**
         * This data item is a pointer to _chem_comp.id in the CHEM_COMP
         * category.
         */
        comp_id: str,
        /**
         * The code used to identify the atom species representing
         * this atom type. Normally this code is the element
         * symbol.
         */
        type_symbol: str,
        /**
         * Atom name alignment offset in PDB atom field.
         */
        pdbx_align: int,
        /**
         * Ordinal index for the component atom list.
         */
        pdbx_ordinal: int,
        /**
         * An alternative x component of the coordinates for this atom in this
         * component specified as orthogonal angstroms.
         */
        pdbx_model_Cartn_x_ideal: coord,
        /**
         * An alternative y component of the coordinates for this atom in this
         * component specified as orthogonal angstroms.
         */
        pdbx_model_Cartn_y_ideal: coord,
        /**
         * An alternative z component of the coordinates for this atom in this
         * component specified as orthogonal angstroms.
         */
        pdbx_model_Cartn_z_ideal: coord,
        /**
         * The chiral configuration of the atom that is a chiral center.
         */
        pdbx_stereo_config: Aliased(str),
        /**
         * A flag indicating an aromatic atom.
         */
        pdbx_aromatic_flag: Aliased(str),
        /**
         * A flag indicating a leaving atom.
         */
        pdbx_leaving_atom_flag: Aliased(str),
    },
    /**
     * Data items in the CHEM_COMP_BOND category record details about
     * the bonds between atoms in a chemical component. Target values
     * may be specified as bond orders, as a distance between the two
     * atoms, or both.
     */
    chem_comp_bond: {
        /**
         * The ID of the first of the two atoms that define the bond.
         *
         * This data item is a pointer to _chem_comp_atom.atom_id in the
         * CHEM_COMP_ATOM category.
         */
        atom_id_1: str,
        /**
         * The ID of the second of the two atoms that define the bond.
         *
         * This data item is a pointer to _chem_comp_atom.atom_id in the
         * CHEM_COMP_ATOM category.
         */
        atom_id_2: str,
        /**
         * This data item is a pointer to _chem_comp.id in the CHEM_COMP
         * category.
         */
        comp_id: str,
        /**
         * The value that should be taken as the target for the chemical
         * bond associated with the specified atoms, expressed as a bond
         * order.
         */
        value_order: Aliased(str),
        /**
         * Ordinal index for the component bond list.
         */
        pdbx_ordinal: int,
        /**
         * Stereochemical configuration across a double bond.
         */
        pdbx_stereo_config: Aliased(str),
        /**
         * A flag indicating an aromatic bond.
         */
        pdbx_aromatic_flag: Aliased(str),
    },
    /**
     * Data items in the CHEM_COMP_DESCRIPTOR category provide
     * string descriptors of component chemical structure.
     */
    pdbx_chem_comp_descriptor: {
        /**
         * This data item is a pointer to _chem_comp.id in the CHEM_COMP
         * category.
         */
        comp_id: str,
        /**
         * This data item contains the descriptor value for this
         * component.
         */
        descriptor: str,
        /**
         * This data item contains the descriptor type.
         */
        type: Aliased(str),
        /**
         * This data item contains the name of the program
         * or library used to compute the descriptor.
         */
        program: str,
        /**
         * This data item contains the version of the program
         * or library used to compute the descriptor.
         */
        program_version: str,
    },
    /**
     * Data items in the CHEM_COMP_IDENTIFIER category provide
     * identifiers for chemical components.
     */
    pdbx_chem_comp_identifier: {
        /**
         * This data item is a pointer to _chem_comp.id in the CHEM_COMP
         * category.
         */
        comp_id: str,
        /**
         * This data item contains the identifier value for this
         * component.
         */
        identifier: str,
        /**
         * This data item contains the identifier type.
         */
        type: Aliased(str),
        /**
         * This data item contains the name of the program
         * or library used to compute the identifier.
         */
        program: str,
        /**
         * This data item contains the version of the program
         * or library used to compute the identifier.
         */
        program_version: str,
    },
};
;
//# sourceMappingURL=ccd.js.map

/***/ }),

/***/ "./lib/mol-io/reader/cif/schema/cif-core.js":
/*!**************************************************!*\
  !*** ./lib/mol-io/reader/cif/schema/cif-core.js ***!
  \**************************************************/
/*! exports provided: CifCore_Schema, CifCore_Aliases */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CifCore_Schema", function() { return CifCore_Schema; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CifCore_Aliases", function() { return CifCore_Aliases; });
/* harmony import */ var _mol_data_db__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../../../mol-data/db */ "./lib/mol-data/db.js");
/**
 * Copyright (c) 2017-2020 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * Code-generated 'CifCore' schema file. Dictionary versions: CifCore 3.0.14.
 *
 * @author molstar/ciftools package
 */

var Schema = _mol_data_db__WEBPACK_IMPORTED_MODULE_0__["Column"].Schema;
var int = Schema.int;
var float = Schema.float;
var str = Schema.str;
var Matrix = Schema.Matrix;
var CifCore_Schema = {
    /**
     * The CATEGORY of data items used to describe the parameters of
     * the crystal unit cell and their measurement.
     */
    cell: {
        /**
         * The number of the formula units in the unit cell as specified
         * by _chemical_formula.structural, _chemical_formula.moiety or
         * _chemical_formula.sum.
         */
        formula_units_Z: int,
        /**
         * Volume of the crystal unit cell.
         */
        volume: float,
        /**
         * The angle between the bounding cell axes.
         */
        angle_alpha: float,
        /**
         * The angle between the bounding cell axes.
         */
        angle_beta: float,
        /**
         * The angle between the bounding cell axes.
         */
        angle_gamma: float,
        /**
         * The length of each cell axis.
         */
        length_a: float,
        /**
         * The length of each cell axis.
         */
        length_b: float,
        /**
         * The length of each cell axis.
         */
        length_c: float,
    },
    /**
     * The CATEGORY of data items which describe the composition and
     * chemical properties of the compound under study. The formula data
     * items must be consistent with the density, unit-cell and Z values.
     */
    chemical: {
        /**
         * The temperature at which a crystalline solid changes to a liquid.
         */
        melting_point: float,
        /**
         * Trivial name by which the compound is commonly known.
         */
        name_common: str,
        /**
         * IUPAC or Chemical Abstracts full name of compound.
         */
        name_systematic: str,
    },
    /**
     * The CATEGORY of data items which specify the composition and chemical
     * properties of the compound. The formula data items must agree
     * with those that specify the density, unit-cell and Z values.
     *
     * The following rules apply to the construction of the data items
     * _chemical_formula.analytical, *.structural and *.sum. For the
     * data item *.moiety the formula construction is broken up into
     * residues or moieties, i.e. groups of atoms that form a molecular
     * unit or molecular ion. The  rules given below apply within each
     * moiety but different requirements apply to the way that moieties
     * are connected (see _chemical_formula.moiety).
     *
     * 1. Only recognized element symbols may be used.
     *
     * 2. Each element symbol is followed by a 'count' number. A count of
     * '1' may be omitted.
     *
     * 3. A space or parenthesis must separate each cluster of (element
     * symbol + count).
     *
     * 4. Where a group of elements is enclosed in parentheses, the
     * multiplier for the group must follow the closing parentheses.
     * That is, all element and group multipliers are assumed to be
     * printed as subscripted numbers. [An exception to this rule
     * exists for *.moiety formulae where pre- and post-multipliers
     * are permitted for molecular units].
     *
     * 5. Unless the elements are ordered in a manner that corresponds to
     * their chemical structure, as in _chemical_formula.structural,
     * the order of the elements within any group or moiety
     * depends on whether or not carbon is present. If carbon is
     * present, the order should be: C, then H, then the other
     * elements in alphabetical order of their symbol. If carbon is
     * not present, the elements are listed purely in alphabetic order
     * of their symbol. This is the 'Hill' system used by Chemical
     * Abstracts. This ordering is used in _chemical_formula.moiety
     * and _chemical_formula.sum.
     *
     * _chemical_formula.iupac      '[Mo (C O)4 (C18 H33 P)2]'
     * _chemical_formula.moiety     'C40 H66 Mo O4 P2'
     * _chemical_formula.structural '((C O)4 (P (C6 H11)3)2)Mo'
     * _chemical_formula.sum         'C40 H66 Mo O4 P2'
     * _chemical_formula.weight      768.81
     */
    chemical_formula: {
        /**
         * Formula with each discrete bonded residue or ion shown as a
         * separate moiety. See above CHEMICAL_FORMULA for rules
         * for writing chemical formulae. In addition to the general
         * formulae requirements, the following rules apply:
         * 1. Moieties are separated by commas ','.
         * 2. The order of elements within a moiety follows general rule
         * 5 in CHEMICAL_FORMULA.
         * 3. Parentheses are not used within moieties but may surround
         * a moiety. Parentheses may not be nested.
         * 4. Charges should be placed at the end of the moiety. The
         * Singlege '+' or '-' may be preceded by a numerical multiplier
         * and should be separated from the last (element symbol +
         * count) by a space. Pre- or post-multipliers may be used for
         * individual moieties.
         */
        moiety: str,
        /**
         * Chemical formulae in which all discrete bonded residues and ions are
         * summed over the constituent elements, following the ordering given
         * in rule 5 of the CATEGORY description. Parentheses normally not used.
         */
        sum: str,
        /**
         * Mass corresponding to the formulae _chemical_formula.structural,
         * *_iupac, *_moiety or *_sum and, together with the Z value and cell
         * parameters yield the density given as _exptl_crystal.density_diffrn.
         */
        weight: float,
    },
    /**
     * The CATEGORY of data items used to specify space group
     * information about the crystal used in the diffraction measurements.
     *
     * Space-group types are identified by their number as listed in
     * International Tables for Crystallography Volume A, or by their
     * Schoenflies symbol. Specific settings of the space groups can
     * be identified by their Hall symbol, by specifying their
     * symmetry operations or generators, or by giving the
     * transformation that relates the specific setting to the
     * reference setting based on International Tables Volume A and
     * stored in this dictionary.
     *
     * The commonly used Hermann-Mauguin symbol determines the
     * space-group type uniquely but several different Hermann-Mauguin
     * symbols may refer to the same space-group type. A
     * Hermann-Mauguin symbol contains information on the choice of
     * the basis, but not on the choice of origin.
     *
     * Ref: International Tables for Crystallography (2002). Volume A,
     * Space-group symmetry, edited by Th. Hahn, 5th ed.
     * Dordrecht: Kluwer Academic Publishers.
     */
    space_group: {
        /**
         * The name of the system of geometric crystal classes of space
         * groups (crystal system) to which the space group belongs.
         * Note that rhombohedral space groups belong to the
         * trigonal system.
         */
        crystal_system: str,
        /**
         * The number as assigned in International Tables for Crystallography
         * Vol A, specifying the proper affine class (i.e. the orientation
         * preserving affine class) of space groups (crystallographic space
         * group type) to which the space group belongs. This number defines
         * the space group type but not the coordinate system expressed.
         */
        IT_number: int,
        /**
         * The full international Hermann-Mauguin space-group symbol as
         * defined in Section 2.2.3 and given as the second item of the
         * second line of each of the space-group tables of Part 7 of
         * International Tables for Crystallography Volume A (2002).
         *
         * Each component of the space-group name is separated by a
         * space or an underscore character. The use of a space is
         * strongly recommended.  The underscore is only retained
         * because it was used in old CIFs. It should not be used in
         * new CIFs.
         *
         * Subscripts should appear without special symbols. Bars should
         * be given as negative signs before the numbers to which they
         * apply. The commonly used Hermann-Mauguin symbol determines the
         * space-group type uniquely but a given space-group type may
         * be described by more than one Hermann-Mauguin symbol. The
         * space-group type is best described using
         * _space_group.IT_number or _space_group.name_Schoenflies. The
         * full international Hermann-Mauguin symbol contains information
         * about the choice of basis for monoclinic and orthorhombic
         * space groups but does not give information about the choice
         * of origin. To define the setting uniquely use
         * _space_group.name_Hall, or list the symmetry operations
         * or generators.
         *
         * Ref: International Tables for Crystallography (2002). Volume A,
         * Space-group symmetry, edited by Th. Hahn, 5th ed.
         * Dordrecht: Kluwer Academic Publishers.
         */
        'name_H-M_full': str,
    },
    /**
     * The CATEGORY of data items used to describe symmetry equivalent sites
     * in the crystal unit cell.
     */
    space_group_symop: {
        /**
         * A parsable string giving one of the symmetry operations of the
         * space group in algebraic form.  If W is a matrix representation
         * of the rotational part of the symmetry operation defined by the
         * positions and signs of x, y and z, and w is a column of
         * translations defined by fractions, an equivalent position
         * X' is generated from a given position X by the equation
         *
         * X' = WX + w
         *
         * (Note: X is used to represent bold_italics_x in International
         * Tables for Crystallography Vol. A, Part 5)
         *
         * When a list of symmetry operations is given, it must contain
         * a complete set of coordinate representatives which generates
         * all the operations of the space group by the addition of
         * all primitive translations of the space group. Such
         * representatives are to be found as the coordinates of
         * the general-equivalent position in International Tables for
         * Crystallography Vol. A (2002), to which it is necessary to
         * add any centring translations shown above the
         * general-equivalent position.
         *
         * That is to say, it is necessary to list explicitly all the
         * symmetry operations required to generate all the atoms in
         * the unit cell defined by the setting used.
         */
        operation_xyz: str,
    },
    /**
     * The CATEGORY of data items used to specify the geometry bonds in the
     * structural model as derived from the atomic sites.
     */
    geom_bond: {
        /**
         * This label is a unique identifier for a particular site in the
         * asymmetric unit of the crystal unit cell.
         */
        atom_site_label_1: str,
        /**
         * This label is a unique identifier for a particular site in the
         * asymmetric unit of the crystal unit cell.
         */
        atom_site_label_2: str,
        /**
         * Intramolecular bond distance between the sites identified
         * by _geom_bond.id
         */
        distance: float,
        /**
         * This code signals whether the angle is referred to in a
         * publication or should be placed in a table of significant angles.
         */
        publ_flag: str,
        /**
         * The set of data items which specify the symmetry operation codes
         * which must be applied to the atom sites involved in the geometry angle.
         *
         * The symmetry code of each atom site as the symmetry-equivalent position
         * number 'n' and the cell translation number 'pqr'. These numbers are
         * combined to form the code 'n pqr' or n_pqr.
         *
         * The character string n_pqr is composed as follows:
         *
         * n refers to the symmetry operation that is applied to the
         * coordinates stored in _atom_site.fract_xyz. It must match a
         * number given in _symmetry_equiv.pos_site_id.
         *
         * p, q and r refer to the translations that are subsequently
         * applied to the symmetry transformed coordinates to generate
         * the atom used in calculating the angle. These translations
         * (x,y,z) are related to (p,q,r) by the relations
         * p = 5 + x
         * q = 5 + y
         * r = 5 + z
         */
        site_symmetry_1: str,
        /**
         * The set of data items which specify the symmetry operation codes
         * which must be applied to the atom sites involved in the geometry angle.
         *
         * The symmetry code of each atom site as the symmetry-equivalent position
         * number 'n' and the cell translation number 'pqr'. These numbers are
         * combined to form the code 'n pqr' or n_pqr.
         *
         * The character string n_pqr is composed as follows:
         *
         * n refers to the symmetry operation that is applied to the
         * coordinates stored in _atom_site.fract_xyz. It must match a
         * number given in _symmetry_equiv.pos_site_id.
         *
         * p, q and r refer to the translations that are subsequently
         * applied to the symmetry transformed coordinates to generate
         * the atom used in calculating the angle. These translations
         * (x,y,z) are related to (p,q,r) by the relations
         * p = 5 + x
         * q = 5 + y
         * r = 5 + z
         */
        site_symmetry_2: str,
        /**
         * Bond valence calculated from the bond distance.
         */
        valence: float,
    },
    /**
     * The CATEGORY of data items used to record details about the
     * creation and subsequent updating of the data block.
     */
    audit: {
        /**
         * The digital object identifier (DOI) registered to identify
         * the data set publication represented by the current
         * datablock. This can be used as a unique identifier for
         * the datablock so long as the code used is a valid DOI
         * (i.e. begins with a valid publisher prefix assigned by a
         * Registration Agency and a suffix guaranteed to be unique
         * by the publisher) and has had its metadata deposited
         * with a DOI Registration Agency.
         *
         * A DOI is a unique character string identifying any
         * object of intellectual property. It provides a
         * persistent identifier for an object on a digital network
         * and permits the association of related current data in a
         * structured extensible way. A DOI is an implementation
         * of the Internet concepts of Uniform Resource Name and
         * Universal Resource Locator managed according to the
         * specifications of the International DOI Foundation (see
         * http://www.doi.org).
         */
        block_doi: str,
    },
    /**
     * The CATEGORY of data items recording database deposition. These data items
     * are assigned by database managers and should only appear in a CIF if they
     * originate from that source.
     */
    database_code: {
        /**
         * Code assigned by Crystallography Open Database (COD).
         */
        COD: str,
        /**
         * Code assigned by the Cambridge Structural Database.
         */
        CSD: str,
        /**
         * Deposition numbers assigned by the Cambridge Crystallographic
         * Data Centre (CCDC) to files containing structural information
         * archived by the CCDC.
         */
        depnum_ccdc_archive: str,
        /**
         * Deposition numbers assigned by the Fachinformationszentrum
         * Karlsruhe (FIZ) to files containing structural information
         * archived by the Cambridge Crystallographic Data Centre (CCDC).
         */
        depnum_ccdc_fiz: str,
        /**
         * Code assigned by the Inorganic Crystal Structure Database.
         */
        ICSD: str,
        /**
         * Code assigned in the Metals Data File.
         */
        MDF: str,
        /**
         * Code assigned by the NBS (NIST) Crystal Data Database.
         */
        NBS: str,
    },
    /**
     * The CATEGORY of data items used to describe atom site information
     * used in crystallographic structure studies.
     */
    atom_site: {
        /**
         * Code for type of atomic displacement parameters used for the site.
         */
        adp_type: str,
        /**
         * A standard code to signal if the site coordinates have been
         * determined from the intensities or calculated from the geometry
         * of surrounding sites, or have been assigned dummy coordinates.
         */
        calc_flag: str,
        /**
         * A code which identifies a cluster of atoms that show long range
         * positional disorder but are locally ordered. Within each such
         * cluster of atoms, _atom_site.disorder_group is used to identify
         * the sites that are simultaneously occupied. This field is only
         * needed if there is more than one cluster of disordered atoms
         * showing independent local order.
         */
        disorder_assembly: str,
        /**
         * A code that identifies a group of positionally disordered atom
         * sites that are locally simultaneously occupied. Atoms that are
         * positionally disordered over two or more sites (e.g. the H
         * atoms of a methyl group that exists in two orientations) can
         * be assigned to two or more groups. Sites belonging to the same
         * group are simultaneously occupied, but those belonging to
         * different groups are not. A minus prefix (e.g. "-1") is used to
         * indicate sites disordered about a special position.
         */
        disorder_group: str,
        /**
         * Atom site coordinates as fractions of the cell length values.
         */
        fract_x: float,
        /**
         * Atom site coordinates as fractions of the cell length values.
         */
        fract_y: float,
        /**
         * Atom site coordinates as fractions of the cell length values.
         */
        fract_z: float,
        /**
         * This label is a unique identifier for a particular site in the
         * asymmetric unit of the crystal unit cell. It is made up of
         * components, _atom_site.label_component_0 to *_6, which may be
         * specified as separate data items. Component 0 usually matches one
         * of the specified _atom_type.symbol codes. This is not mandatory
         * if an _atom_site.type_symbol item is included in the atom site
         * list. The _atom_site.type_symbol always takes precedence over
         * an _atom_site.label in the identification of the atom type. The
         * label components 1 to 6 are optional, and normally only
         * components 0 and 1 are used. Note that components 0 and 1 are
         * concatenated, while all other components, if specified, are
         * separated by an underline character. Underline separators are
         * only used if higher-order components exist. If an intermediate
         * component is not used it may be omitted provided the underline
         * separators are inserted. For example the label 'C233__ggg' is
         * acceptable and represents the components C, 233, '', and ggg.
         * Each label may have a different number of components.
         */
        label: str,
        /**
         * The fraction of the atom type present at this site.
         * The sum of the occupancies of all the atom types at this site
         * may not significantly exceed 1.0 unless it is a dummy site. The
         * value must lie in the 99.97% Gaussian confidence interval
         * -3u =< x =< 1 + 3u. The _enumeration.range of 0.0:1.0 is thus
         * correctly interpreted as meaning (0.0 - 3u) =< x =< (1.0 + 3u).
         */
        occupancy: float,
        /**
         * A concatenated series of single-letter codes which indicate the
         * refinement restraints or constraints applied to this site. This
         * item should not be used. It has been replaced by
         * _atom_site.refinement_flags_posn, _adp and _occupancy. It is
         * retained in this dictionary only to provide compatibility with
         * legacy CIFs.
         */
        refinement_flags: str,
        /**
         * The number of different sites that are generated by the
         * application of the space-group symmetry to the coordinates
         * given for this site. It is equal to the multiplicity given
         * for this Wyckoff site in International Tables for Cryst.
         * Vol. A (2002). It is equal to the multiplicity of the general
         * position divided by the order of the site symmetry given in
         * _atom_site.site_symmetry_order.
         */
        site_symmetry_multiplicity: int,
        /**
         * A code to identify the atom specie(s) occupying this site.
         * This code must match a corresponding _atom_type.symbol. The
         * specification of this code is optional if component_0 of the
         * _atom_site.label is used for this purpose. See _atom_type.symbol.
         */
        type_symbol: str,
        /**
         * Isotropic atomic displacement parameter, or equivalent isotropic
         * atomic  displacement parameter, U(equiv), in angstroms squared,
         * calculated from anisotropic atomic displacement  parameters.
         *
         * U(equiv) = (1/3) sum~i~[sum~j~(U^ij^ a*~i~ a*~j~ a~i~ a~j~)]
         *
         * a  = the real-space cell lengths
         * a* = the reciprocal-space cell lengths
         * Ref: Fischer, R. X. & Tillmanns, E. (1988). Acta Cryst. C44, 775-776.
         */
        U_iso_or_equiv: float,
    },
    /**
     * The CATEGORY of data items used to describe the anisotropic
     * thermal parameters of the atomic sites in a crystal structure.
     */
    atom_site_aniso: {
        /**
         * Anisotropic atomic displacement parameters are usually looped in
         * a separate list. If this is the case, this code must match the
         * _atom_site.label of the associated atom in the atom coordinate
         * list and conform with the same rules described in _atom_site.label.
         */
        label: str,
        /**
         * These are the standard anisotropic atomic displacement
         * components in angstroms squared which appear in the
         * structure factor term:
         *
         * T = exp{-2pi^2^ sum~i~ [sum~j~ (U^ij^ h~i~ h~j~ a*~i~ a*~j~) ] }
         *
         * h = the Miller indices
         * a* = the reciprocal-space cell lengths
         *
         * The unique elements of the real symmetric matrix are entered by row.
         */
        U_11: float,
        /**
         * These are the standard anisotropic atomic displacement
         * components in angstroms squared which appear in the
         * structure factor term:
         *
         * T = exp{-2pi^2^ sum~i~ [sum~j~ (U^ij^ h~i~ h~j~ a*~i~ a*~j~) ] }
         *
         * h = the Miller indices
         * a* = the reciprocal-space cell lengths
         *
         * The unique elements of the real symmetric matrix are entered by row.
         */
        U: Matrix(3, 3),
        /**
         * These are the standard uncertainty values (SU) for the standard
         * form of the Uij anisotropic atomic displacement components (see
         * _aniso_UIJ. Because these values are TYPE measurand, the su values
         * may in practice be auto generated as part of the Uij calculation.
         */
        U_11_su: float,
        /**
         * These are the standard uncertainty values (SU) for the standard
         * form of the Uij anisotropic atomic displacement components (see
         * _aniso_UIJ. Because these values are TYPE measurand, the su values
         * may in practice be auto generated as part of the Uij calculation.
         */
        U_su: Matrix(3, 3),
        /**
         * These are the standard anisotropic atomic displacement
         * components in angstroms squared which appear in the
         * structure factor term:
         *
         * T = exp{-2pi^2^ sum~i~ [sum~j~ (U^ij^ h~i~ h~j~ a*~i~ a*~j~) ] }
         *
         * h = the Miller indices
         * a* = the reciprocal-space cell lengths
         *
         * The unique elements of the real symmetric matrix are entered by row.
         */
        U_12: float,
        /**
         * These are the standard uncertainty values (SU) for the standard
         * form of the Uij anisotropic atomic displacement components (see
         * _aniso_UIJ. Because these values are TYPE measurand, the su values
         * may in practice be auto generated as part of the Uij calculation.
         */
        U_12_su: float,
        /**
         * These are the standard anisotropic atomic displacement
         * components in angstroms squared which appear in the
         * structure factor term:
         *
         * T = exp{-2pi^2^ sum~i~ [sum~j~ (U^ij^ h~i~ h~j~ a*~i~ a*~j~) ] }
         *
         * h = the Miller indices
         * a* = the reciprocal-space cell lengths
         *
         * The unique elements of the real symmetric matrix are entered by row.
         */
        U_13: float,
        /**
         * These are the standard uncertainty values (SU) for the standard
         * form of the Uij anisotropic atomic displacement components (see
         * _aniso_UIJ. Because these values are TYPE measurand, the su values
         * may in practice be auto generated as part of the Uij calculation.
         */
        U_13_su: float,
        /**
         * These are the standard anisotropic atomic displacement
         * components in angstroms squared which appear in the
         * structure factor term:
         *
         * T = exp{-2pi^2^ sum~i~ [sum~j~ (U^ij^ h~i~ h~j~ a*~i~ a*~j~) ] }
         *
         * h = the Miller indices
         * a* = the reciprocal-space cell lengths
         *
         * The unique elements of the real symmetric matrix are entered by row.
         */
        U_22: float,
        /**
         * These are the standard uncertainty values (SU) for the standard
         * form of the Uij anisotropic atomic displacement components (see
         * _aniso_UIJ. Because these values are TYPE measurand, the su values
         * may in practice be auto generated as part of the Uij calculation.
         */
        U_22_su: float,
        /**
         * These are the standard anisotropic atomic displacement
         * components in angstroms squared which appear in the
         * structure factor term:
         *
         * T = exp{-2pi^2^ sum~i~ [sum~j~ (U^ij^ h~i~ h~j~ a*~i~ a*~j~) ] }
         *
         * h = the Miller indices
         * a* = the reciprocal-space cell lengths
         *
         * The unique elements of the real symmetric matrix are entered by row.
         */
        U_23: float,
        /**
         * These are the standard uncertainty values (SU) for the standard
         * form of the Uij anisotropic atomic displacement components (see
         * _aniso_UIJ. Because these values are TYPE measurand, the su values
         * may in practice be auto generated as part of the Uij calculation.
         */
        U_23_su: float,
        /**
         * These are the standard anisotropic atomic displacement
         * components in angstroms squared which appear in the
         * structure factor term:
         *
         * T = exp{-2pi^2^ sum~i~ [sum~j~ (U^ij^ h~i~ h~j~ a*~i~ a*~j~) ] }
         *
         * h = the Miller indices
         * a* = the reciprocal-space cell lengths
         *
         * The unique elements of the real symmetric matrix are entered by row.
         */
        U_33: float,
        /**
         * These are the standard uncertainty values (SU) for the standard
         * form of the Uij anisotropic atomic displacement components (see
         * _aniso_UIJ. Because these values are TYPE measurand, the su values
         * may in practice be auto generated as part of the Uij calculation.
         */
        U_33_su: float,
    },
    /**
     * The CATEGORY of data items used to describe atomic type information
     * used in crystallographic structure studies.
     */
    atom_type: {
        /**
         * A description of the atom(s) designated by this atom type. In
         * most cases this will be the element name and oxidation state of
         * a single atom  species. For disordered or nonstoichiometric
         * structures it will describe a combination of atom species.
         */
        description: str,
        /**
         * The identity of the atom specie(s) representing this atom type.
         * Normally this code is the element symbol followed by the charge
         * if there is one. The symbol may be composed of any character except
         * an underline or a blank, with the proviso that digits designate an
         * oxidation state and must be followed by a + or - character.
         */
        symbol: str,
    },
    /**
     * The CATEGORY of data items used to describe atomic scattering
     * information used in crystallographic structure studies.
     */
    atom_type_scat: {
        /**
         * The imaginary component of the anomalous dispersion scattering factors
         * for this atom type and radiation by _diffrn_radiation_wavelength.value
         */
        dispersion_imag: float,
        /**
         * The real component of the anomalous dispersion scattering factors
         * for this atom type and radiation by _diffrn_radiation_wavelength.value
         */
        dispersion_real: float,
        /**
         * Reference to source of scattering factors used for this atom type.
         */
        source: str,
    },
};
var CifCore_Aliases = {
    'atom_site_aniso.U': [
        'atom_site_anisotrop_U',
    ],
    'atom_site_aniso.U_su': [
        'atom_site_aniso_U_esd',
        'atom_site_anisotrop_U_esd',
    ],
    'space_group.IT_number': [
        'symmetry_Int_Tables_number',
    ],
    'space_group.name_H-M_full': [
        'symmetry_space_group_name_H-M',
    ],
    'space_group_symop.operation_xyz': [
        'symmetry_equiv_pos_as_xyz',
    ],
    'geom_bond.atom_site_label_1': [
        'geom_bond_atom_site_id_1',
    ],
    'geom_bond.atom_site_label_2': [
        'geom_bond_atom_site_id_2',
    ],
    'geom_bond.distance': [
        'geom_bond_dist',
    ],
    'atom_site.adp_type': [
        'atom_site_thermal_displace_type',
    ],
    'atom_site.label': [
        'atom_site_id',
    ],
    'atom_site.site_symmetry_multiplicity': [
        'atom_site_symmetry_multiplicity',
    ],
    'atom_site_aniso.label': [
        'atom_site_anisotrop_id',
    ],
    'atom_site_aniso.U_11': [
        'atom_site_anisotrop_U_11',
    ],
    'atom_site_aniso.U_11_su': [
        'atom_site_aniso_U_11_esd',
        'atom_site_anisotrop_U_11_esd',
    ],
    'atom_site_aniso.U_12': [
        'atom_site_anisotrop_U_12',
    ],
    'atom_site_aniso.U_12_su': [
        'atom_site_aniso_U_12_esd',
        'atom_site_anisotrop_U_12_esd',
    ],
    'atom_site_aniso.U_13': [
        'atom_site_anisotrop_U_13',
    ],
    'atom_site_aniso.U_13_su': [
        'atom_site_aniso_U_13_esd',
        'atom_site_anisotrop_U_13_esd',
    ],
    'atom_site_aniso.U_22': [
        'atom_site_anisotrop_U_22',
    ],
    'atom_site_aniso.U_22_su': [
        'atom_site_aniso_U_22_esd',
        'atom_site_anisotrop_U_22_esd',
    ],
    'atom_site_aniso.U_23': [
        'atom_site_anisotrop_U_23',
    ],
    'atom_site_aniso.U_23_su': [
        'atom_site_aniso_U_23_esd',
        'atom_site_anisotrop_U_23_esd',
    ],
    'atom_site_aniso.U_33': [
        'atom_site_anisotrop_U_33',
    ],
    'atom_site_aniso.U_33_su': [
        'atom_site_aniso_U_33_esd',
        'atom_site_anisotrop_U_33_esd',
    ],
};
;
//# sourceMappingURL=cif-core.js.map

/***/ }),

/***/ "./lib/mol-io/reader/cif/schema/density-server.js":
/*!********************************************************!*\
  !*** ./lib/mol-io/reader/cif/schema/density-server.js ***!
  \********************************************************/
/*! exports provided: DensityServer_Header_Schema, DensityServer_Data_Schema */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DensityServer_Header_Schema", function() { return DensityServer_Header_Schema; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DensityServer_Data_Schema", function() { return DensityServer_Data_Schema; });
/* harmony import */ var _mol_data_db__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../../../mol-data/db */ "./lib/mol-data/db.js");
/**
 * Copyright (c) 2018 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author David Sehnal <david.sehnal@gmail.com>
 */

var Schema = _mol_data_db__WEBPACK_IMPORTED_MODULE_0__["Column"].Schema;
var str = Schema.str;
var int = Schema.int;
var float = Schema.float;
var Aliased = Schema.Aliased;
var Vector = Schema.Vector;
var DensityServer_Header_Schema = {
    density_server_result: {
        'server_version': str,
        'datetime_utc': str,
        'guid': str,
        'is_empty': Aliased(str),
        'has_error': Aliased(str),
        'error': str,
        'query_source_id': str,
        'query_type': Aliased(str),
        'query_box_type': Aliased(str),
        'query_box_a': Vector(3),
        'query_box_b': Vector(3)
    }
};
var DensityServer_Data_Schema = {
    volume_data_3d_info: {
        'name': str,
        // zero indexed axis order of the data
        'axis_order': Vector(3, int),
        // Origin in fractional coords
        'origin': Vector(3),
        // Dimension in fractional coords
        'dimensions': Vector(3),
        'sample_rate': int,
        // number of samples along each axis
        'sample_count': Vector(3, int),
        'spacegroup_number': int,
        'spacegroup_cell_size': Vector(3),
        // angles in degrees
        'spacegroup_cell_angles': Vector(3),
        'mean_source': float,
        'mean_sampled': float,
        'sigma_source': float,
        'sigma_sampled': float,
        'min_source': float,
        'min_sampled': float,
        'max_source': float,
        'max_sampled': float
    },
    volume_data_3d: {
        values: float
    }
};
//# sourceMappingURL=density-server.js.map

/***/ }),

/***/ "./lib/mol-io/reader/cif/schema/dic.js":
/*!*********************************************!*\
  !*** ./lib/mol-io/reader/cif/schema/dic.js ***!
  \*********************************************/
/*! exports provided: dic_Schema */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "dic_Schema", function() { return dic_Schema; });
/* harmony import */ var _mol_data_db__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../../../mol-data/db */ "./lib/mol-data/db.js");
/**
 * Copyright (c) 2017-2018 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */

var Schema = _mol_data_db__WEBPACK_IMPORTED_MODULE_0__["Column"].Schema;
var str = Schema.str;
var float = Schema.float;
var datablock = {
    id: str,
    description: str
};
var dictionary = {
    title: str,
    datablock_id: str,
    version: str
};
var dictionary_history = {
    version: str,
    update: str,
    revision: str
};
var sub_category = {
    id: str,
    description: str
};
var category_group_list = {
    id: str,
    parent_id: str,
    description: str
};
var item_type_list = {
    code: str,
    primitive_code: str,
    construct: str,
    detail: str
};
var item_units_list = {
    code: str,
    detail: str
};
var item_units_conversion = {
    from_code: str,
    to_code: str,
    operator: str,
    factor: float
};
// TODO save frame dic schema
var dic_Schema = {
    datablock: datablock,
    dictionary: dictionary,
    dictionary_history: dictionary_history,
    sub_category: sub_category,
    category_group_list: category_group_list,
    item_type_list: item_type_list,
    item_units_list: item_units_list,
    item_units_conversion: item_units_conversion
};
//# sourceMappingURL=dic.js.map

/***/ }),

/***/ "./lib/mol-io/reader/cif/schema/mmcif-extras.js":
/*!******************************************************!*\
  !*** ./lib/mol-io/reader/cif/schema/mmcif-extras.js ***!
  \******************************************************/
/*! exports provided: mmCIF_residueId_schema, mmCIF_chemCompBond_schema, mmCIF_chemComp_schema */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "mmCIF_residueId_schema", function() { return mmCIF_residueId_schema; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "mmCIF_chemCompBond_schema", function() { return mmCIF_chemCompBond_schema; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "mmCIF_chemComp_schema", function() { return mmCIF_chemComp_schema; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _mmcif__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./mmcif */ "./lib/mol-io/reader/cif/schema/mmcif.js");
/* harmony import */ var _mol_data_db__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../../../mol-data/db */ "./lib/mol-data/db.js");
/**
 * Copyright (c) 2018-2020 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author David Sehnal <david.sehnal@gmail.com>
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */



var mmCIF_residueId_schema = {
    label_comp_id: _mmcif__WEBPACK_IMPORTED_MODULE_1__["mmCIF_Schema"].atom_site.label_comp_id,
    label_seq_id: _mmcif__WEBPACK_IMPORTED_MODULE_1__["mmCIF_Schema"].atom_site.label_seq_id,
    pdbx_PDB_ins_code: _mmcif__WEBPACK_IMPORTED_MODULE_1__["mmCIF_Schema"].atom_site.pdbx_PDB_ins_code,
    label_asym_id: _mmcif__WEBPACK_IMPORTED_MODULE_1__["mmCIF_Schema"].atom_site.label_asym_id,
    label_entity_id: _mmcif__WEBPACK_IMPORTED_MODULE_1__["mmCIF_Schema"].atom_site.label_entity_id,
    auth_comp_id: _mmcif__WEBPACK_IMPORTED_MODULE_1__["mmCIF_Schema"].atom_site.auth_atom_id,
    auth_seq_id: _mmcif__WEBPACK_IMPORTED_MODULE_1__["mmCIF_Schema"].atom_site.auth_seq_id,
    auth_asym_id: _mmcif__WEBPACK_IMPORTED_MODULE_1__["mmCIF_Schema"].atom_site.auth_asym_id
};
var mmCIF_chemCompBond_schema = Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, _mmcif__WEBPACK_IMPORTED_MODULE_1__["mmCIF_Schema"].chem_comp_bond), { 
    /** Indicates if the bond entry was taken from the protonation variant dictionary */
    molstar_protonation_variant: _mol_data_db__WEBPACK_IMPORTED_MODULE_2__["Column"].Schema.Str() });
/** Has `type` extended with 'Ion' and 'Lipid' */
var mmCIF_chemComp_schema = Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, _mmcif__WEBPACK_IMPORTED_MODULE_1__["mmCIF_Schema"].chem_comp), { type: _mol_data_db__WEBPACK_IMPORTED_MODULE_2__["Column"].Schema.Aliased(_mol_data_db__WEBPACK_IMPORTED_MODULE_2__["Column"].Schema.str) });
//# sourceMappingURL=mmcif-extras.js.map

/***/ }),

/***/ "./lib/mol-io/reader/cif/schema/mmcif.js":
/*!***********************************************!*\
  !*** ./lib/mol-io/reader/cif/schema/mmcif.js ***!
  \***********************************************/
/*! exports provided: mmCIF_Schema */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "mmCIF_Schema", function() { return mmCIF_Schema; });
/* harmony import */ var _mol_data_db__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../../../mol-data/db */ "./lib/mol-data/db.js");
/**
 * Copyright (c) 2017-2020 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * Code-generated 'mmCIF' schema file. Dictionary versions: mmCIF 5.333, IHM 1.12, CARB draft.
 *
 * @author molstar/ciftools package
 */

var Schema = _mol_data_db__WEBPACK_IMPORTED_MODULE_0__["Column"].Schema;
var str = Schema.str;
var int = Schema.int;
var float = Schema.float;
var coord = Schema.coord;
var Aliased = Schema.Aliased;
var Matrix = Schema.Matrix;
var Vector = Schema.Vector;
var List = Schema.List;
var mmCIF_Schema = {
    /**
     * Data items in the ATOM_SITE category record details about
     * the atom sites in a macromolecular crystal structure, such as
     * the positional coordinates, atomic displacement parameters,
     * magnetic moments and directions.
     *
     * The data items for describing anisotropic atomic
     * displacement factors are only used if the corresponding items
     * are not given in the ATOM_SITE_ANISOTROP category.
     */
    atom_site: {
        /**
         * An alternative identifier for _atom_site.label_asym_id that
         * may be provided by an author in order to match the identification
         * used in the publication that describes the structure.
         */
        auth_asym_id: str,
        /**
         * An alternative identifier for _atom_site.label_atom_id that
         * may be provided by an author in order to match the identification
         * used in the publication that describes the structure.
         */
        auth_atom_id: str,
        /**
         * An alternative identifier for _atom_site.label_comp_id that
         * may be provided by an author in order to match the identification
         * used in the publication that describes the structure.
         */
        auth_comp_id: str,
        /**
         * An alternative identifier for _atom_site.label_seq_id that
         * may be provided by an author in order to match the identification
         * used in the publication that describes the structure.
         *
         * Note that this is not necessarily a number, that the values do
         * not have to be positive, and that the value does not have to
         * correspond to the value of _atom_site.label_seq_id. The value
         * of _atom_site.label_seq_id is required to be a sequential list
         * of positive integers.
         *
         * The author may assign values to _atom_site.auth_seq_id in any
         * desired way. For instance, the values may be used to relate
         * this structure to a numbering scheme in a homologous structure,
         * including sequence gaps or insertion codes. Alternatively, a
         * scheme may be used for a truncated polymer that maintains the
         * numbering scheme of the full length polymer. In all cases, the
         * scheme used here must match the scheme used in the publication
         * that describes the structure.
         */
        auth_seq_id: int,
        /**
         * Isotropic atomic displacement parameter, or equivalent isotropic
         * atomic displacement parameter, B~eq~, calculated from the
         * anisotropic displacement parameters.
         *
         * B~eq~ = (1/3) sum~i~[sum~j~(B^ij^ A~i~ A~j~ a*~i~ a*~j~)]
         *
         * A     = the real space cell lengths
         * a*    = the reciprocal space cell lengths
         * B^ij^ = 8 pi^2^ U^ij^
         *
         * Ref: Fischer, R. X. & Tillmanns, E. (1988). Acta Cryst. C44,
         * 775-776.
         *
         * The IUCr Commission on Nomenclature recommends against the use
         * of B for reporting atomic displacement parameters. U, being
         * directly proportional to B, is preferred.
         *
         * Note -
         *
         * The particular type of ADP stored in this item is qualified
         * by item _refine.pdbx_adp_type.
         */
        B_iso_or_equiv: float,
        /**
         * The x atom-site coordinate in angstroms specified according to
         * a set of orthogonal Cartesian axes related to the cell axes as
         * specified by the description given in
         * _atom_sites.Cartn_transform_axes.
         */
        Cartn_x: coord,
        /**
         * The y atom-site coordinate in angstroms specified according to
         * a set of orthogonal Cartesian axes related to the cell axes as
         * specified by the description given in
         * _atom_sites.Cartn_transform_axes.
         */
        Cartn_y: coord,
        /**
         * The z atom-site coordinate in angstroms specified according to
         * a set of orthogonal Cartesian axes related to the cell axes as
         * specified by the description given in
         * _atom_sites.Cartn_transform_axes.
         */
        Cartn_z: coord,
        /**
         * The group of atoms to which the atom site belongs. This data
         * item is provided for compatibility with the original Protein
         * Data Bank format, and only for that purpose.
         */
        group_PDB: Aliased(str),
        /**
         * The value of _atom_site.id must uniquely identify a record in the
         * ATOM_SITE list.
         *
         * Note that this item need not be a number; it can be any unique
         * identifier.
         *
         * This data item was introduced to provide compatibility between
         * small-molecule and macromolecular CIFs. In a small-molecule
         * CIF, _atom_site_label is the identifier for the atom. In a
         * macromolecular CIF, the atom identifier is the aggregate of
         * _atom_site.label_alt_id, _atom_site.label_asym_id,
         * _atom_site.label_atom_id, _atom_site.label_comp_id and
         * _atom_site.label_seq_id. For the two types of files to be
         * compatible, a formal identifier for the category had to be
         * introduced that was independent of the different modes of
         * identifying the atoms. For compatibility with older CIFs,
         * _atom_site_label is aliased to _atom_site.id.
         *
         * In general, this aggregate identifier does not uniquely
         * identify an atom site as for non-polymers _atom_site.label_seq_id
         * is '.'.
         */
        id: int,
        /**
         * A place holder to indicate alternate conformation. The alternate conformation
         * can be an entire polymer chain, or several residues or
         * partial residue (several atoms within one residue). If
         * an atom is provided in more than one position, then a
         * non-blank alternate location indicator must be used for
         * each of the atomic positions.
         */
        label_alt_id: str,
        /**
         * A component of the identifier for this atom site.
         * For further details, see the definition of the STRUCT_ASYM
         * category.
         *
         * This data item is a pointer to _struct_asym.id in the
         * STRUCT_ASYM category.
         */
        label_asym_id: str,
        /**
         * A component of the identifier for this atom site.
         *
         * This data item is a pointer to _chem_comp_atom.atom_id in the
         * CHEM_COMP_ATOM category.
         */
        label_atom_id: str,
        /**
         * A component of the identifier for this atom site.
         *
         * This data item is a pointer to _chem_comp.id in the CHEM_COMP
         * category.
         */
        label_comp_id: str,
        /**
         * This data item is a pointer to _entity.id in the ENTITY category.
         */
        label_entity_id: str,
        /**
         * This data item is a pointer to _entity_poly_seq.num in the
         * ENTITY_POLY_SEQ category.
         */
        label_seq_id: int,
        /**
         * The fraction of the atom type present at this site.
         * The sum of the occupancies of all the atom types at this site
         * may not exceed 1.0 unless it is a dummy site.
         */
        occupancy: float,
        /**
         * This data item is a pointer to _atom_type.symbol in the
         * ATOM_TYPE category.
         */
        type_symbol: str,
        /**
         * PDB insertion code.
         */
        pdbx_PDB_ins_code: str,
        /**
         * PDB model number.
         */
        pdbx_PDB_model_num: int,
        /**
         * The net integer charge assigned to this atom. This is the
         * formal charge assignment normally found in chemical diagrams.
         */
        pdbx_formal_charge: int,
        /**
         * The model id corresponding to the atom site.
         * This data item is a pointer to _ihm_model_list.model_id
         * in the IHM_MODEL_LIST category.
         */
        ihm_model_id: int,
    },
    /**
     * Data items in the ATOM_SITE_ANISOTROP category record details
     * about anisotropic displacement parameters.
     * If the ATOM_SITE_ANISOTROP category is used for storing these
     * data, the corresponding ATOM_SITE data items are not used.
     */
    atom_site_anisotrop: {
        /**
         * This data item is a pointer to _atom_site.id in the ATOM_SITE
         * category.
         */
        id: int,
        /**
         * This data item is a pointer to _atom_type.symbol in the
         * ATOM_TYPE category.
         */
        type_symbol: str,
        /**
         * The elements of the standard anisotropic atomic
         * displacement matrix U, which appears in the structure-factor
         * term as:
         *
         * T = exp{-2 pi^2^ sum~i~[sum~j~(U^ij^ h~i~ h~j~ a*~i~ a*~j~)]}
         *
         * h  = the Miller indices
         * a* = the reciprocal space cell lengths
         *
         * These matrix elements may appear with atomic coordinates
         * in the ATOM_SITE category, or they may appear in the separate
         * ATOM_SITE_ANISOTROP category, but they may not appear in both
         * places. Similarly, anisotropic displacements may appear as
         * either B's or U's, but not as both.
         *
         * The unique elements of the real symmetric matrix are
         * entered by row.
         */
        U: Matrix(3, 3),
        /**
         * The standard uncertainty (estimated standard deviation)
         * of _atom_site_anisotrop.U.
         */
        U_esd: Matrix(3, 3),
        /**
         * Pointer to _atom_site.auth_seq_id
         */
        pdbx_auth_seq_id: str,
        /**
         * Pointer to _atom_site.auth_asym_id
         */
        pdbx_auth_asym_id: str,
        /**
         * Pointer to _atom_site.auth_atom_id
         */
        pdbx_auth_atom_id: str,
        /**
         * Pointer to _atom_site.auth_comp_id
         */
        pdbx_auth_comp_id: str,
        /**
         * Pointer to _atom_site.label_seq_id
         */
        pdbx_label_seq_id: int,
        /**
         * Pointer to _atom_site.label_alt_id.
         */
        pdbx_label_alt_id: str,
        /**
         * Pointer to _atom_site.label_asym_id
         */
        pdbx_label_asym_id: str,
        /**
         * Pointer to _atom_site.label_atom_id
         */
        pdbx_label_atom_id: str,
        /**
         * Pointer to _atom_site.label_comp_id
         */
        pdbx_label_comp_id: str,
        /**
         * Pointer to _atom_site.pdbx_PDB_ins_code
         */
        pdbx_PDB_ins_code: str,
    },
    /**
     * Data items in the ATOM_SITES category record details about
     * the crystallographic cell and cell transformations, which are
     * common to all atom sites.
     */
    atom_sites: {
        /**
         * This data item is a pointer to _entry.id in the ENTRY category.
         */
        entry_id: str,
        /**
         * The elements of the 3x3 matrix used to transform Cartesian
         * coordinates in the ATOM_SITE category to fractional coordinates
         * in the same category. The axial alignments of this
         * transformation are described in _atom_sites.Cartn_transform_axes.
         * The 3x1 translation is defined in
         * _atom_sites.fract_transf_vector[].
         *
         * |x'|               |11 12 13| |x|              |1|
         * |y'|~fractional~ = |21 22 23| |y|~Cartesian~ + |2|
         * |z'|               |31 32 33| |z|              |3|
         */
        fract_transf_matrix: Matrix(3, 3),
        /**
         * The elements of the three-element vector used to transform
         * Cartesian coordinates in the ATOM_SITE category to fractional
         * coordinates in the same category. The axial alignments of this
         * transformation are described in _atom_sites.Cartn_transform_axes.
         * The 3x3 rotation is defined in
         * _atom_sites.fract_transf_matrix[][].
         *
         * |x'|               |11 12 13| |x|              |1|
         * |y'|~fractional~ = |21 22 23| |y|~Cartesian~ + |2|
         * |z'|               |31 32 33| |z|              |3|
         */
        fract_transf_vector: Vector(3),
    },
    /**
     * Data items in the AUDIT_AUTHOR category record details about
     * the author(s) of the data block.
     */
    audit_author: {
        /**
         * The name of an author of this data block. If there are multiple
         * authors, _audit_author.name is looped with _audit_author.address.
         * The family name(s), followed by a comma and including any
         * dynastic components, precedes the first name(s) or initial(s).
         */
        name: str,
        /**
         * This data item defines the order of the author's name in the
         * list of audit authors.
         */
        pdbx_ordinal: int,
        /**
         * The Open Researcher and Contributor ID (ORCID).
         */
        identifier_ORCID: str,
    },
    /**
     * Data items in the AUDIT_CONFORM category describe the
     * dictionary versions against which the data names appearing in
     * the current data block are conformant.
     */
    audit_conform: {
        /**
         * A file name or uniform resource locator (URL) for the
         * dictionary to which the current data block conforms.
         */
        dict_location: str,
        /**
         * The string identifying the highest-level dictionary defining
         * data names used in this file.
         */
        dict_name: str,
        /**
         * The version number of the dictionary to which the current
         * data block conforms.
         */
        dict_version: str,
    },
    /**
     * Data items in the CELL category record details about the
     * crystallographic cell parameters.
     */
    cell: {
        /**
         * Unit-cell angle alpha of the reported structure in degrees.
         */
        angle_alpha: float,
        /**
         * Unit-cell angle beta of the reported structure in degrees.
         */
        angle_beta: float,
        /**
         * Unit-cell angle gamma of the reported structure in degrees.
         */
        angle_gamma: float,
        /**
         * This data item is a pointer to _entry.id in the ENTRY category.
         */
        entry_id: str,
        /**
         * Unit-cell length a corresponding to the structure reported in
         * angstroms.
         */
        length_a: float,
        /**
         * Unit-cell length b corresponding to the structure reported in
         * angstroms.
         */
        length_b: float,
        /**
         * Unit-cell length c corresponding to the structure reported in
         * angstroms.
         */
        length_c: float,
        /**
         * The number of the polymeric chains in a unit cell. In the case
         * of heteropolymers, Z is the number of occurrences of the most
         * populous chain.
         *
         * This data item is provided for compatibility with the original
         * Protein Data Bank format, and only for that purpose.
         */
        Z_PDB: int,
        /**
         * To further identify unique axis if necessary.  E.g., P 21 with
         * an unique C axis will have 'C' in this field.
         */
        pdbx_unique_axis: str,
    },
    /**
     * Data items in the CHEM_COMP category give details about each
     * of the chemical components from which the relevant chemical
     * structures can be constructed, such as name, mass or charge.
     *
     * The related categories CHEM_COMP_ATOM, CHEM_COMP_BOND,
     * CHEM_COMP_ANGLE etc. describe the detailed geometry of these
     * chemical components.
     */
    chem_comp: {
        /**
         * The formula for the chemical component. Formulae are written
         * according to the following rules:
         *
         * (1) Only recognized element symbols may be used.
         *
         * (2) Each element symbol is followed by a 'count' number. A count
         * of '1' may be omitted.
         *
         * (3) A space or parenthesis must separate each cluster of
         * (element symbol + count), but in general parentheses are
         * not used.
         *
         * (4) The order of elements depends on whether carbon is
         * present or not. If carbon is present, the order should be:
         * C, then H, then the other elements in alphabetical order
         * of their symbol. If carbon is not present, the elements
         * are listed purely in alphabetic order of their symbol. This
         * is the 'Hill' system used by Chemical Abstracts.
         */
        formula: str,
        /**
         * Formula mass in daltons of the chemical component.
         */
        formula_weight: float,
        /**
         * The value of _chem_comp.id must uniquely identify each item in
         * the CHEM_COMP list.
         *
         * For protein polymer entities, this is the three-letter code for
         * the amino acid.
         *
         * For nucleic acid polymer entities, this is the one-letter code
         * for the base.
         */
        id: str,
        /**
         * 'yes' indicates that this is a 'standard' monomer, 'no'
         * indicates that it is 'nonstandard'. Nonstandard monomers
         * should be described in more detail using the
         * _chem_comp.mon_nstd_parent, _chem_comp.mon_nstd_class and
         * _chem_comp.mon_nstd_details data items.
         */
        mon_nstd_flag: Aliased(str),
        /**
         * The full name of the component.
         */
        name: str,
        /**
         * For standard polymer components, the type of the monomer.
         * Note that monomers that will form polymers are of three types:
         * linking monomers, monomers with some type of N-terminal (or 5')
         * cap and monomers with some type of C-terminal (or 3') cap.
         */
        type: Aliased(str),
        /**
         * Synonym list for the component.
         */
        pdbx_synonyms: List(';', function (x) { return x; }),
    },
    /**
     * Data items in the CHEM_COMP_BOND category record details about
     * the bonds between atoms in a chemical component. Target values
     * may be specified as bond orders, as a distance between the two
     * atoms, or both.
     */
    chem_comp_bond: {
        /**
         * The ID of the first of the two atoms that define the bond.
         *
         * This data item is a pointer to _chem_comp_atom.atom_id in the
         * CHEM_COMP_ATOM category.
         */
        atom_id_1: str,
        /**
         * The ID of the second of the two atoms that define the bond.
         *
         * This data item is a pointer to _chem_comp_atom.atom_id in the
         * CHEM_COMP_ATOM category.
         */
        atom_id_2: str,
        /**
         * This data item is a pointer to _chem_comp.id in the CHEM_COMP
         * category.
         */
        comp_id: str,
        /**
         * The value that should be taken as the target for the chemical
         * bond associated with the specified atoms, expressed as a bond
         * order.
         */
        value_order: Aliased(str),
        /**
         * Ordinal index for the component bond list.
         */
        pdbx_ordinal: int,
        /**
         * Stereochemical configuration across a double bond.
         */
        pdbx_stereo_config: Aliased(str),
        /**
         * A flag indicating an aromatic bond.
         */
        pdbx_aromatic_flag: Aliased(str),
    },
    /**
     * Data items in the CITATION category record details about the
     * literature cited as being relevant to the contents of the data
     * block.
     */
    citation: {
        /**
         * The name of the publisher of the citation; relevant
         * for books or book chapters.
         */
        book_publisher: str,
        /**
         * The country/region of publication; relevant for books
         * and book chapters.
         */
        country: str,
        /**
         * The value of _citation.id must uniquely identify a record in the
         * CITATION list.
         *
         * The _citation.id 'primary' should be used to indicate the
         * citation that the author(s) consider to be the most pertinent to
         * the contents of the data block.
         *
         * Note that this item need not be a number; it can be any unique
         * identifier.
         */
        id: str,
        /**
         * Abbreviated name of the cited journal as given in the
         * Chemical Abstracts Service Source Index.
         */
        journal_abbrev: str,
        /**
         * The American Society for Testing and Materials (ASTM) code
         * assigned to the journal cited (also referred to as the CODEN
         * designator of the Chemical Abstracts Service); relevant for
         * journal articles.
         */
        journal_id_ASTM: str,
        /**
         * The Cambridge Structural Database (CSD) code assigned to the
         * journal cited; relevant for journal articles. This is also the
         * system used at the Protein Data Bank (PDB).
         */
        journal_id_CSD: str,
        /**
         * The International Standard Serial Number (ISSN) code assigned to
         * the journal cited; relevant for journal articles.
         */
        journal_id_ISSN: str,
        /**
         * Volume number of the journal cited; relevant for journal
         * articles.
         */
        journal_volume: str,
        /**
         * The first page of the citation; relevant for journal
         * articles, books and book chapters.
         */
        page_first: str,
        /**
         * The last page of the citation; relevant for journal
         * articles, books and book chapters.
         */
        page_last: str,
        /**
         * The title of the citation; relevant for journal articles, books
         * and book chapters.
         */
        title: str,
        /**
         * The year of the citation; relevant for journal articles, books
         * and book chapters.
         */
        year: int,
        /**
         * Document Object Identifier used by doi.org to uniquely
         * specify bibliographic entry.
         */
        pdbx_database_id_DOI: str,
        /**
         * Ascession number used by PubMed to categorize a specific
         * bibliographic entry.
         */
        pdbx_database_id_PubMed: int,
    },
    /**
     * Data items in the CITATION_AUTHOR category record details
     * about the authors associated with the citations in the
     * CITATION list.
     */
    citation_author: {
        /**
         * This data item is a pointer to _citation.id in the CITATION
         * category.
         */
        citation_id: str,
        /**
         * Name of an author of the citation; relevant for journal
         * articles, books and book chapters.
         *
         * The family name(s), followed by a comma and including any
         * dynastic components, precedes the first name(s) or initial(s).
         */
        name: str,
        /**
         * This data item defines the order of the author's name in the
         * list of authors of a citation.
         */
        ordinal: int,
    },
    /**
     * Data items in the DATABASE_2 category record details about the
     * database identifiers of the data block.
     *
     * These data items are assigned by database managers and should
     * only appear in a data block if they originate from that source.
     *
     * The name of this category, DATABASE_2, arose because the
     * category name DATABASE was already in use in the core CIF
     * dictionary, but was used differently from the way it needed
     * to be used in the mmCIF dictionary. Since CIF data names
     * cannot be changed once they have been adopted, a new category
     * had to be created.
     */
    database_2: {
        /**
         * An abbreviation that identifies the database.
         */
        database_id: Aliased(str),
        /**
         * The code assigned by the database identified in
         * _database_2.database_id.
         */
        database_code: str,
    },
    /**
     * Data items in the ENTITY category record details (such as
     * chemical composition, name and source) about the molecular
     * entities that are present in the crystallographic structure.
     *
     * Items in the various ENTITY subcategories provide a full
     * chemical description of these molecular entities.
     *
     * Entities are of three types:  polymer, non-polymer and water.
     * Note that the water category includes only water;  ordered
     * solvent such as sulfate ion or acetone would be described as
     * individual non-polymer entities.
     *
     * The ENTITY category is specific to macromolecular CIF
     * applications and replaces the function of the CHEMICAL category
     * in the CIF core.
     *
     * It is important to remember that the ENTITY data are not the
     * result of the crystallographic experiment;  those results are
     * represented by the ATOM_SITE data items. ENTITY data items
     * describe the chemistry of the molecules under investigation
     * and can most usefully be thought of as the ideal groups to which
     * the structure is restrained or constrained during refinement.
     *
     * It is also important to remember that entities do not correspond
     * directly to the enumeration of the contents of the asymmetric
     * unit. Entities are described only once, even in those structures
     * that contain multiple observations of an entity. The
     * STRUCT_ASYM data items, which reference the entity list,
     * describe and label the contents of the asymmetric unit.
     */
    entity: {
        /**
         * A description of special aspects of the entity.
         */
        details: str,
        /**
         * Formula mass in daltons of the entity.
         */
        formula_weight: float,
        /**
         * The value of _entity.id must uniquely identify a record in the
         * ENTITY list.
         *
         * Note that this item need not be a number; it can be any unique
         * identifier.
         */
        id: str,
        /**
         * The method by which the sample for the entity was produced.
         * Entities isolated directly from natural sources (tissues, soil
         * samples etc.) are expected to have further information in the
         * ENTITY_SRC_NAT category. Entities isolated from genetically
         * manipulated sources are expected to have further information in
         * the ENTITY_SRC_GEN category.
         */
        src_method: Aliased(str),
        /**
         * Defines the type of the entity.
         *
         * Polymer entities are expected to have corresponding
         * ENTITY_POLY and associated entries.
         *
         * Non-polymer entities are expected to have corresponding
         * CHEM_COMP and associated entries.
         *
         * Water entities are not expected to have corresponding
         * entries in the ENTITY category.
         */
        type: Aliased(str),
        /**
         * A description of the entity.
         *
         * Corresponds to the compound name in the PDB format.
         */
        pdbx_description: List(',', function (x) { return x; }),
        /**
         * A place holder for the number of molecules of the entity in
         * the entry.
         */
        pdbx_number_of_molecules: int,
        /**
         * Details about any entity mutation(s).
         */
        pdbx_mutation: str,
        /**
         * Entity fragment description(s).
         */
        pdbx_fragment: str,
        /**
         * Enzyme Commission (EC) number(s)
         */
        pdbx_ec: List(',', function (x) { return x; }),
    },
    /**
     * Data items in the ENTITY_POLY category record details about the
     * polymer, such as the type of the polymer, the number of
     * monomers and whether it has nonstandard features.
     */
    entity_poly: {
        /**
         * This data item is a pointer to _entity.id in the ENTITY category.
         */
        entity_id: str,
        /**
         * A flag to indicate whether the polymer contains at least
         * one monomer-to-monomer link different from that implied by
         * _entity_poly.type.
         */
        nstd_linkage: Aliased(str),
        /**
         * A flag to indicate whether the polymer contains at least
         * one monomer that is not considered standard.
         */
        nstd_monomer: Aliased(str),
        /**
         * The type of the polymer.
         */
        type: Aliased(str),
        /**
         * The PDB strand/chain id(s) corresponding to this polymer entity.
         */
        pdbx_strand_id: List(',', function (x) { return x; }),
        /**
         * Chemical sequence expressed as string of one-letter
         * amino acid codes. Modifications and non-standard
         * amino acids are coded as X.
         */
        pdbx_seq_one_letter_code: str,
        /**
         * Cannonical chemical sequence expressed as string of
         * one-letter amino acid codes. Modifications are coded
         * as the parent amino acid where possible.
         *
         * A  for alanine or adenine
         * B  for ambiguous asparagine/aspartic-acid
         * R  for arginine
         * N  for asparagine
         * D  for aspartic-acid
         * C  for cysteine or cystine or cytosine
         * Q  for glutamine
         * E  for glutamic-acid
         * Z  for ambiguous glutamine/glutamic acid
         * G  for glycine or guanine
         * H  for histidine
         * I  for isoleucine
         * L  for leucine
         * K  for lysine
         * M  for methionine
         * F  for phenylalanine
         * P  for proline
         * S  for serine
         * T  for threonine or thymine
         * W  for tryptophan
         * Y  for tyrosine
         * V  for valine
         * U  for uracil
         */
        pdbx_seq_one_letter_code_can: str,
        /**
         * For Structural Genomics entries, the sequence's target identifier registered at the TargetTrack database.
         */
        pdbx_target_identifier: str,
    },
    /**
     * Data items in the ENTITY_POLY_SEQ category specify the sequence
     * of monomers in a polymer. Allowance is made for the possibility
     * of microheterogeneity in a sample by allowing a given sequence
     * number to be correlated with more than one monomer ID. The
     * corresponding ATOM_SITE entries should reflect this
     * heterogeneity.
     */
    entity_poly_seq: {
        /**
         * This data item is a pointer to _entity_poly.entity_id in the
         * ENTITY_POLY category.
         */
        entity_id: str,
        /**
         * A flag to indicate whether this monomer in the polymer is
         * heterogeneous in sequence.
         */
        hetero: Aliased(str),
        /**
         * This data item is a pointer to _chem_comp.id in the CHEM_COMP
         * category.
         */
        mon_id: str,
        /**
         * The value of _entity_poly_seq.num must uniquely and sequentially
         * identify a record in the ENTITY_POLY_SEQ list.
         *
         * Note that this item must be a number and that the sequence
         * numbers must progress in increasing numerical order.
         */
        num: int,
    },
    /**
     * There is only one item in the ENTRY category, _entry.id. This
     * data item gives a name to this entry and is indirectly a key to
     * the categories (such as CELL, GEOM, EXPTL) that describe
     * information pertinent to the entire data block.
     */
    entry: {
        /**
         * The value of _entry.id identifies the data block.
         *
         * Note that this item need not be a number; it can be any unique
         * identifier.
         */
        id: str,
    },
    /**
     * Data items in the EXPTL category record details about the
     * experimental work prior to the intensity measurements and
     * details about the absorption-correction technique employed.
     */
    exptl: {
        /**
         * This data item is a pointer to _entry.id in the ENTRY category.
         */
        entry_id: str,
        /**
         * The method used in the experiment.
         */
        method: Aliased(str),
    },
    /**
     * Data items in the STRUCT category record details about the
     * description of the crystallographic structure.
     */
    struct: {
        /**
         * This data item is a pointer to _entry.id in the ENTRY category.
         */
        entry_id: str,
        /**
         * A title for the data block. The author should attempt to convey
         * the essence of the structure archived in the CIF in the title,
         * and to distinguish this structural result from others.
         */
        title: str,
        /**
         * An automatically generated descriptor for an NDB structure or
         * the unstructured content of the PDB COMPND record.
         */
        pdbx_descriptor: str,
    },
    /**
     * Data items in the STRUCT_ASYM category record details about the
     * structural elements in the asymmetric unit.
     */
    struct_asym: {
        /**
         * A description of special aspects of this portion of the contents
         * of the asymmetric unit.
         */
        details: str,
        /**
         * This data item is a pointer to _entity.id in the ENTITY category.
         */
        entity_id: str,
        /**
         * The value of _struct_asym.id must uniquely identify a record in
         * the STRUCT_ASYM list.
         *
         * Note that this item need not be a number; it can be any unique
         * identifier.
         */
        id: str,
        /**
         * This data item indicates whether the structural elements are modified.
         */
        pdbx_modified: str,
        /**
         * A flag indicating that this entity was originally labeled
         * with a blank PDB chain id.
         */
        pdbx_blank_PDB_chainid_flag: Aliased(str),
    },
    /**
     * Data items in the STRUCT_CONF category record details about
     * the backbone conformation of a segment of polymer.
     *
     * Data items in the STRUCT_CONF_TYPE category define the
     * criteria used to identify the backbone conformations.
     */
    struct_conf: {
        /**
         * A component of the identifier for the residue at which the
         * conformation segment begins.
         *
         * This data item is a pointer to _atom_site.label_asym_id in the
         * ATOM_SITE category.
         */
        beg_label_asym_id: str,
        /**
         * A component of the identifier for the residue at which the
         * conformation segment begins.
         *
         * This data item is a pointer to _atom_site.label_comp_id in
         * the ATOM_SITE category.
         */
        beg_label_comp_id: str,
        /**
         * A component of the identifier for the residue at which the
         * conformation segment begins.
         *
         * This data item is a pointer to _atom_site.label_seq_id in the
         * ATOM_SITE category.
         */
        beg_label_seq_id: int,
        /**
         * A component of the identifier for the residue at which the
         * conformation segment begins.
         *
         * This data item is a pointer to _atom_site.auth_asym_id in the
         * ATOM_SITE category.
         */
        beg_auth_asym_id: str,
        /**
         * A component of the identifier for the residue at which the
         * conformation segment begins.
         *
         * This data item is a pointer to _atom_site.auth_comp_id in
         * the ATOM_SITE category.
         */
        beg_auth_comp_id: str,
        /**
         * A component of the identifier for the residue at which the
         * conformation segment begins.
         *
         * This data item is a pointer to _atom_site.auth_seq_id in the
         * ATOM_SITE category.
         */
        beg_auth_seq_id: int,
        /**
         * This data item is a pointer to _struct_conf_type.id in the
         * STRUCT_CONF_TYPE category.
         */
        conf_type_id: Aliased(str),
        /**
         * A description of special aspects of the conformation assignment.
         */
        details: str,
        /**
         * A component of the identifier for the residue at which the
         * conformation segment ends.
         *
         * This data item is a pointer to _atom_site.label_asym_id in the
         * ATOM_SITE category.
         */
        end_label_asym_id: str,
        /**
         * A component of the identifier for the residue at which the
         * conformation segment ends.
         *
         * This data item is a pointer to _atom_site.label_comp_id in the
         * ATOM_SITE category.
         */
        end_label_comp_id: str,
        /**
         * A component of the identifier for the residue at which the
         * conformation segment ends.
         *
         * This data item is a pointer to _atom_site.label_seq_id in the
         * ATOM_SITE category.
         */
        end_label_seq_id: int,
        /**
         * A component of the identifier for the residue at which the
         * conformation segment ends.
         *
         * This data item is a pointer to _atom_site.auth_asym_id in the
         * ATOM_SITE category.
         */
        end_auth_asym_id: str,
        /**
         * A component of the identifier for the residue at which the
         * conformation segment ends.
         *
         * This data item is a pointer to _atom_site.auth_comp_id in the
         * ATOM_SITE category.
         */
        end_auth_comp_id: str,
        /**
         * A component of the identifier for the residue at which the
         * conformation segment ends.
         *
         * This data item is a pointer to _atom_site.auth_seq_id in the
         * ATOM_SITE category.
         */
        end_auth_seq_id: int,
        /**
         * The value of _struct_conf.id must uniquely identify a record in
         * the STRUCT_CONF list.
         *
         * Note that this item need not be a number; it can be any unique
         * identifier.
         */
        id: str,
        /**
         * A component of the identifier for the residue at which the
         * conformation segment starts.
         */
        pdbx_beg_PDB_ins_code: str,
        /**
         * A component of the identifier for the residue at which the
         * conformation segment ends.
         */
        pdbx_end_PDB_ins_code: str,
        /**
         * This item is a place holder for the helix class used in the PDB
         * HELIX record.
         */
        pdbx_PDB_helix_class: str,
        /**
         * A placeholder for the lengths of the helix of the PDB
         * HELIX record.
         */
        pdbx_PDB_helix_length: int,
        /**
         * A placeholder for the helix identifier of the PDB
         * HELIX record.
         */
        pdbx_PDB_helix_id: str,
    },
    /**
     * Data items in the STRUCT_CONN category record details about
     * the connections between portions of the structure. These can be
     * hydrogen bonds, salt bridges, disulfide bridges and so on.
     *
     * The STRUCT_CONN_TYPE records define the criteria used to
     * identify these connections.
     */
    struct_conn: {
        /**
         * This data item is a pointer to _struct_conn_type.id in the
         * STRUCT_CONN_TYPE category.
         */
        conn_type_id: Aliased(str),
        /**
         * A description of special aspects of the connection.
         */
        details: str,
        /**
         * The value of _struct_conn.id must uniquely identify a record in
         * the STRUCT_CONN list.
         *
         * Note that this item need not be a number; it can be any unique
         * identifier.
         */
        id: str,
        /**
         * A component of the identifier for partner 1 of the structure
         * connection.
         *
         * This data item is a pointer to _atom_site.label_asym_id in the
         * ATOM_SITE category.
         */
        ptnr1_label_asym_id: str,
        /**
         * A component of the identifier for partner 1 of the structure
         * connection.
         *
         * This data item is a pointer to _chem_comp_atom.atom_id in the
         * CHEM_COMP_ATOM category.
         */
        ptnr1_label_atom_id: str,
        /**
         * A component of the identifier for partner 1 of the structure
         * connection.
         *
         * This data item is a pointer to _atom_site.label_comp_id in the
         * ATOM_SITE category.
         */
        ptnr1_label_comp_id: str,
        /**
         * A component of the identifier for partner 1 of the structure
         * connection.
         *
         * This data item is a pointer to _atom_site.label_seq_id in the
         * ATOM_SITE category.
         */
        ptnr1_label_seq_id: int,
        /**
         * A component of the identifier for partner 1 of the structure
         * connection.
         *
         * This data item is a pointer to _atom_site.auth_asym_id in the
         * ATOM_SITE category.
         */
        ptnr1_auth_asym_id: str,
        /**
         * A component of the identifier for partner 1 of the structure
         * connection.
         *
         * This data item is a pointer to _atom_site.auth_comp_id in the
         * ATOM_SITE category.
         */
        ptnr1_auth_comp_id: str,
        /**
         * A component of the identifier for partner 1 of the structure
         * connection.
         *
         * This data item is a pointer to _atom_site.auth_seq_id in the
         * ATOM_SITE category.
         */
        ptnr1_auth_seq_id: int,
        /**
         * Describes the symmetry operation that should be applied to the
         * atom set specified by _struct_conn.ptnr1_label* to generate the
         * first partner in the structure connection.
         */
        ptnr1_symmetry: str,
        /**
         * A component of the identifier for partner 2 of the structure
         * connection.
         *
         * This data item is a pointer to _atom_site.label_asym_id in the
         * ATOM_SITE category.
         */
        ptnr2_label_asym_id: str,
        /**
         * A component of the identifier for partner 2 of the structure
         * connection.
         *
         * This data item is a pointer to _chem_comp_atom.atom_id in the
         * CHEM_COMP_ATOM category.
         */
        ptnr2_label_atom_id: str,
        /**
         * A component of the identifier for partner 2 of the structure
         * connection.
         *
         * This data item is a pointer to _atom_site.label_comp_id in the
         * ATOM_SITE category.
         */
        ptnr2_label_comp_id: str,
        /**
         * A component of the identifier for partner 2 of the structure
         * connection.
         *
         * This data item is a pointer to _atom_site.label_seq_id in the
         * ATOM_SITE category.
         */
        ptnr2_label_seq_id: int,
        /**
         * A component of the identifier for partner 2 of the structure
         * connection.
         *
         * This data item is a pointer to _atom_site.auth_asym_id in the
         * ATOM_SITE category.
         */
        ptnr2_auth_asym_id: str,
        /**
         * A component of the identifier for partner 2 of the structure
         * connection.
         *
         * This data item is a pointer to _atom_site.auth_comp_id in the
         * ATOM_SITE category.
         */
        ptnr2_auth_comp_id: str,
        /**
         * A component of the identifier for partner 2 of the structure
         * connection.
         *
         * This data item is a pointer to _atom_site.auth_seq_id in the
         * ATOM_SITE category.
         */
        ptnr2_auth_seq_id: int,
        /**
         * Describes the symmetry operation that should be applied to the
         * atom set specified by _struct_conn.ptnr2_label* to generate the
         * second partner in the structure connection.
         */
        ptnr2_symmetry: str,
        /**
         * A component of the identifier for partner 1 of the structure
         * connection.
         *
         * This data item is a pointer to _atom_site.pdbx_PDB_ins_code in the
         * ATOM_SITE category.
         */
        pdbx_ptnr1_PDB_ins_code: str,
        /**
         * A component of the identifier for partner 1 of the
         * structure connection. This data item is a pointer to
         * _atom_site.label_alt_id in the ATOM_SITE category.
         */
        pdbx_ptnr1_label_alt_id: str,
        /**
         * A placeholder for the standard residue name found in
         * the MODRES record of a PDB file.
         */
        pdbx_ptnr1_standard_comp_id: str,
        /**
         * A component of the identifier for partner 1 of the structure
         * connection.
         *
         * This data item is a pointer to _atom_site.pdbx_PDB_ins_code in the
         * ATOM_SITE category.
         */
        pdbx_ptnr2_PDB_ins_code: str,
        /**
         * A component of the identifier for partner 2 of the
         * structure connection. This data item is a pointer to
         * _atom_site.label_alt_id in the ATOM_SITE category.
         */
        pdbx_ptnr2_label_alt_id: str,
        /**
         * A component of the identifier for partner 3 of the
         * structure connection. This data item is a pointer to
         * _atom_site.pdbx_PDB_ins_code in the ATOM_SITE category.
         */
        pdbx_ptnr3_PDB_ins_code: str,
        /**
         * A component of the identifier for partner 3 of the
         * structure connection. This data item is a pointer to
         * _atom_site.label_alt_id in the ATOM_SITE category.
         */
        pdbx_ptnr3_label_alt_id: str,
        /**
         * A component of the identifier for partner 3 of the
         * structure connection. This data item is a pointer to
         * _atom_site.label_asym_id in the ATOM_SITE category.
         */
        pdbx_ptnr3_label_asym_id: str,
        /**
         * A component of the identifier for partner 3 of the
         * structure connection. This data item is a pointer to
         * _atom_site.label_atom_id in the ATOM_SITE category.
         */
        pdbx_ptnr3_label_atom_id: str,
        /**
         * A component of the identifier for partner 3 of the
         * structure connection. This data item is a pointer to
         * _atom_site.label_comp_id in the ATOM_SITE category.
         */
        pdbx_ptnr3_label_comp_id: str,
        /**
         * A component of the identifier for partner 1 of the
         * structure connection. This data item is a pointer to
         * _atom_site.label_seq_id in the ATOM_SITE category.
         */
        pdbx_ptnr3_label_seq_id: int,
        /**
         * A placeholder for the PDB id in the case the category
         * is used to hold the information of the MODRES record of
         * a PDB file.
         */
        pdbx_PDB_id: str,
        /**
         * Distance value for this contact.
         */
        pdbx_dist_value: float,
        /**
         * The chemical bond order associated with the specified atoms in
         * this contact.
         */
        pdbx_value_order: Aliased(str),
    },
    /**
     * Data items in the STRUCT_CONN_TYPE category record details
     * about the criteria used to identify interactions between
     * portions of the structure.
     */
    struct_conn_type: {
        /**
         * The criteria used to define the interaction.
         */
        criteria: str,
        /**
         * The chemical or structural type of the interaction.
         */
        id: Aliased(str),
        /**
         * A reference that specifies the criteria used to define the
         * interaction.
         */
        reference: str,
    },
    /**
     * Data items in the STRUCT_KEYWORDS category specify keywords
     * that describe the chemical structure in this entry.
     */
    struct_keywords: {
        /**
         * This data item is a pointer to _entry.id in the ENTRY category.
         */
        entry_id: str,
        /**
         * Keywords describing this structure.
         */
        text: List(',', function (x) { return x; }),
        /**
         * Terms characterizing the macromolecular structure.
         */
        pdbx_keywords: str,
    },
    /**
     * Data items in the STRUCT_NCS_OPER category describe the
     * noncrystallographic symmetry operations.
     *
     * Each operator is specified as a matrix and a subsequent
     * translation vector. Operators need not represent proper
     * rotations.
     */
    struct_ncs_oper: {
        /**
         * A code to indicate whether this operator describes a
         * relationship between coordinates all of which are given in the
         * data block (in which case the value of code is 'given'), or
         * whether the operator is used to generate new coordinates from
         * those that are given in the data block (in which case the value
         * of code is 'generate').
         */
        code: Aliased(str),
        /**
         * A description of special aspects of the noncrystallographic
         * symmetry operator.
         */
        details: str,
        /**
         * The value of _struct_ncs_oper.id must uniquely identify a
         * record in the STRUCT_NCS_OPER list.
         *
         * Note that for PDB _struct_ncs_oper.id must be a number.
         */
        id: int,
        /**
         * The elements of the 3x3 matrix component of a
         * noncrystallographic symmetry operation.
         */
        matrix: Matrix(3, 3),
        /**
         * The elements of the three-element vector component of a
         * noncrystallographic symmetry operation.
         */
        vector: Vector(3),
    },
    /**
     * Data items in the STRUCT_SHEET_RANGE category record details
     * about the residue ranges that form a beta-sheet. Residues are
     * included in a range if they made beta-sheet-type hydrogen-bonding
     * interactions with at least one adjacent strand and if there are
     * at least two residues in the range.
     */
    struct_sheet_range: {
        /**
         * A component of the identifier for the residue at which the
         * beta-sheet range begins.
         *
         * This data item is a pointer to _struct_asym.id in the
         * STRUCT_ASYM category.
         */
        beg_label_asym_id: str,
        /**
         * A component of the identifier for the residue at which the
         * beta-sheet range begins.
         *
         * This data item is a pointer to _chem_comp.id in the CHEM_COMP
         * category.
         */
        beg_label_comp_id: str,
        /**
         * A component of the identifier for the residue at which the
         * beta-sheet range begins.
         *
         * This data item is a pointer to _atom_site.label_seq_id in the
         * ATOM_SITE category.
         */
        beg_label_seq_id: int,
        /**
         * A component of the identifier for the residue at which the
         * beta-sheet range ends.
         *
         * This data item is a pointer to _struct_asym.id in the
         * STRUCT_ASYM category.
         */
        end_label_asym_id: str,
        /**
         * A component of the identifier for the residue at which the
         * beta-sheet range ends.
         *
         * This data item is a pointer to _chem_comp.id in the CHEM_COMP
         * category.
         */
        end_label_comp_id: str,
        /**
         * A component of the identifier for the residue at which the
         * beta-sheet range ends.
         *
         * This data item is a pointer to _atom_site.label_seq_id in the
         * ATOM_SITE category.
         */
        end_label_seq_id: int,
        /**
         * A component of the identifier for the residue at which the
         * beta-sheet range begins.
         *
         * This data item is a pointer to _atom_site.auth_asym_id in the
         * ATOM_SITE category.
         */
        beg_auth_asym_id: str,
        /**
         * A component of the identifier for the residue at which the
         * beta-sheet range begins.
         *
         * This data item is a pointer to _atom_site.auth_comp_id in
         * the ATOM_SITE category.
         */
        beg_auth_comp_id: str,
        /**
         * A component of the identifier for the residue at which the
         * beta-sheet range begins.
         *
         * This data item is a pointer to _atom_site.auth_seq_id in the
         * ATOM_SITE category.
         */
        beg_auth_seq_id: int,
        /**
         * A component of the identifier for the residue at which the
         * beta-sheet range ends.
         *
         * This data item is a pointer to _atom_site.auth_asym_id in the
         * ATOM_SITE category.
         */
        end_auth_asym_id: str,
        /**
         * A component of the identifier for the residue at which the
         * beta-sheet range ends.
         *
         * This data item is a pointer to _atom_site.auth_comp_id in the
         * ATOM_SITE category.
         */
        end_auth_comp_id: str,
        /**
         * A component of the identifier for the residue at which the
         * beta-sheet range ends.
         *
         * This data item is a pointer to _atom_site.auth_seq_id in the
         * ATOM_SITE category.
         */
        end_auth_seq_id: int,
        /**
         * The value of _struct_sheet_range.id must uniquely identify a
         * range in a given sheet in the STRUCT_SHEET_RANGE list.
         *
         * Note that this item need not be a number; it can be any unique
         * identifier.
         */
        id: str,
        /**
         * This data item is a pointer to _struct_sheet.id in the
         * STRUCT_SHEET category.
         */
        sheet_id: str,
        /**
         * A component of the identifier for the residue at which the
         * beta sheet range begins.  Insertion code.
         */
        pdbx_beg_PDB_ins_code: str,
        /**
         * A component of the identifier for the residue at which the
         * beta sheet range ends. Insertion code.
         */
        pdbx_end_PDB_ins_code: str,
    },
    /**
     * Data items in the STRUCT_SITE category record details about
     * portions of the structure that contribute to structurally
     * relevant sites (e.g. active sites, substrate-binding subsites,
     * metal-coordination sites).
     */
    struct_site: {
        /**
         * A description of special aspects of the site.
         */
        details: str,
        /**
         * The value of _struct_site.id must uniquely identify a record in
         * the STRUCT_SITE list.
         *
         * Note that this item need not be a number; it can be any unique
         * identifier.
         */
        id: str,
        /**
         * Number of residues in the site.
         */
        pdbx_num_residues: int,
        /**
         * Source of evidence supporting the assignment of this site.
         */
        pdbx_evidence_code: str,
        /**
         * A component of the identifier for the ligand in the site.
         *
         * This data item is a pointer to _atom_site.auth_asym_id in the
         * ATOM_SITE category.
         */
        pdbx_auth_asym_id: str,
        /**
         * A component of the identifier for the ligand in the site.
         *
         * This data item is a pointer to _atom_site.auth_comp_id in the
         * ATOM_SITE category.
         */
        pdbx_auth_comp_id: str,
        /**
         * A component of the identifier for the ligand in the site.
         *
         * This data item is a pointer to _atom_site.auth_seq_id in the
         * ATOM_SITE category.
         */
        pdbx_auth_seq_id: str,
        /**
         * PDB insertion code for the ligand in the site.
         */
        pdbx_auth_ins_code: str,
    },
    /**
     * Data items in the STRUCT_SITE_GEN category record details about
     * the generation of portions of the structure that contribute to
     * structurally relevant sites.
     */
    struct_site_gen: {
        /**
         * A description of special aspects of the symmetry generation of
         * this portion of the structural site.
         */
        details: str,
        /**
         * The value of _struct_site_gen.id must uniquely identify a record
         * in the STRUCT_SITE_GEN list.
         *
         * Note that this item need not be a number; it can be any unique
         * identifier.
         */
        id: str,
        /**
         * A component of the identifier for participants in the site.
         *
         * This data item is a pointer to _atom_sites_alt.id in the
         * ATOM_SITES_ALT category.
         */
        label_alt_id: str,
        /**
         * A component of the identifier for participants in the site.
         *
         * This data item is a pointer to _atom_site.label_asym_id in the
         * ATOM_SITE category.
         */
        label_asym_id: str,
        /**
         * A component of the identifier for participants in the site.
         *
         * This data item is a pointer to _chem_comp_atom.atom_id in the
         * CHEM_COMP_ATOM category.
         */
        label_atom_id: str,
        /**
         * A component of the identifier for participants in the site.
         *
         * This data item is a pointer to _atom_site.label_comp_id in the
         * ATOM_SITE category.
         */
        label_comp_id: str,
        /**
         * A component of the identifier for participants in the site.
         *
         * This data item is a pointer to _atom_site.label_seq_id in the
         * ATOM_SITE category.
         */
        label_seq_id: int,
        /**
         * A component of the identifier for participants in the site.
         *
         * This data item is a pointer to _atom_site.auth_asym_id in the
         * ATOM_SITE category.
         */
        auth_asym_id: str,
        /**
         * A component of the identifier for participants in the site.
         *
         * This data item is a pointer to _atom_site.auth_comp_id in the
         * ATOM_SITE category.
         */
        auth_comp_id: str,
        /**
         * A component of the identifier for participants in the site.
         *
         * This data item is a pointer to _atom_site.auth_seq_id in the
         * ATOM_SITE category.
         */
        auth_seq_id: str,
        /**
         * This data item is a pointer to _struct_site.id in the STRUCT_SITE
         * category.
         */
        site_id: str,
        /**
         * Describes the symmetry operation that should be applied to the
         * atom set specified by _struct_site_gen.label* to generate a
         * portion of the site.
         */
        symmetry: str,
        /**
         * PDB insertion code.
         */
        pdbx_auth_ins_code: str,
        /**
         * Number of residues in the site.
         */
        pdbx_num_res: int,
    },
    /**
     * Data items in the SYMMETRY category record details about the
     * space-group symmetry.
     */
    symmetry: {
        /**
         * This data item is a pointer to _entry.id in the ENTRY category.
         */
        entry_id: str,
        /**
         * The cell settings for this space-group symmetry.
         */
        cell_setting: Aliased(str),
        /**
         * Space-group number from International Tables for Crystallography
         * Vol. A (2002).
         */
        Int_Tables_number: int,
        /**
         * Space-group symbol as described by Hall (1981). This symbol
         * gives the space-group setting explicitly. Leave spaces between
         * the separate components of the symbol.
         *
         * Ref: Hall, S. R. (1981). Acta Cryst. A37, 517-525; erratum
         * (1981) A37, 921.
         */
        space_group_name_Hall: str,
        /**
         * Hermann-Mauguin space-group symbol. Note that the
         * Hermann-Mauguin symbol does not necessarily contain complete
         * information about the symmetry and the space-group origin. If
         * used, always supply the FULL symbol from International Tables
         * for Crystallography Vol. A (2002) and indicate the origin and
         * the setting if it is not implicit. If there is any doubt that
         * the equivalent positions can be uniquely deduced from this
         * symbol, specify the  _symmetry_equiv.pos_as_xyz or
         * _symmetry.space_group_name_Hall  data items as well. Leave
         * spaces between symbols referring to
         * different axes.
         */
        'space_group_name_H-M': str,
    },
    /**
     * These are internal RCSB records to keep track of data processing
     * and status of the entry.
     */
    pdbx_database_status: {
        /**
         * Code for status of file.
         */
        status_code: Aliased(str),
        /**
         * Code for status of structure factor file.
         */
        status_code_sf: Aliased(str),
        /**
         * Code for status of NMR constraints file.
         */
        status_code_mr: Aliased(str),
        /**
         * The value of _pdbx_database_status.entry_id identifies the data block.
         */
        entry_id: str,
        /**
         * The date of initial deposition.  (The first message for
         * deposition has been received.)
         */
        recvd_initial_deposition_date: str,
        /**
         * This code indicates whether the entry belongs to
         * Structural Genomics Project.
         */
        SG_entry: Aliased(str),
        /**
         * The site where the file was deposited.
         */
        deposit_site: Aliased(str),
        /**
         * The site where the file was deposited.
         */
        process_site: Aliased(str),
        /**
         * Code for status of chemical shift data file.
         */
        status_code_cs: Aliased(str),
        /**
         * The methods development category in which this
         * entry has been placed.
         */
        methods_development_category: Aliased(str),
        /**
         * A flag indicating that the entry is compatible with the PDB format.
         *
         * A value of 'N' indicates that the no PDB format data file is
         * corresponding to this entry is available in the PDB archive.
         */
        pdb_format_compatible: Aliased(str),
    },
    /**
     * The PDBX_NONPOLY_SCHEME category provides residue level nomenclature
     * mapping for non-polymer entities.
     */
    pdbx_nonpoly_scheme: {
        /**
         * Pointer to _atom_site.label_asym_id.
         */
        asym_id: str,
        /**
         * Pointer to _atom_site.label_entity_id.
         */
        entity_id: str,
        /**
         * Pointer to _atom_site.label_comp_id.
         */
        mon_id: str,
        /**
         * PDB strand/chain id.
         */
        pdb_strand_id: str,
        /**
         * NDB/RCSB residue number.
         */
        ndb_seq_num: str,
        /**
         * PDB residue number.
         */
        pdb_seq_num: str,
        /**
         * Author provided residue numbering.   This value may differ from the PDB residue
         * number and may not correspond to residue numbering within the coordinate records.
         */
        auth_seq_num: str,
        /**
         * PDB residue identifier.
         */
        pdb_mon_id: str,
        /**
         * Author provided residue identifier.   This value may differ from the PDB residue
         * identifier and may not correspond to residue identification within the coordinate records.
         */
        auth_mon_id: str,
        /**
         * PDB insertion code.
         */
        pdb_ins_code: str,
    },
    /**
     * Data items in PDBX_DATABASE_RELATED contain references to entries
     * that are related to the this entry.
     */
    pdbx_database_related: {
        /**
         * The name of the database containing the related entry.
         */
        db_name: str,
        /**
         * A description of the related entry.
         */
        details: str,
        /**
         * The identifying code in the related database.
         */
        db_id: str,
        /**
         * The identifying content type of the related entry.
         */
        content_type: Aliased(str),
    },
    pdbx_entity_nonpoly: {
        /**
         * This data item is a pointer to _entity.id in the ENTITY category.
         */
        entity_id: str,
        /**
         * This data item is a pointer to _chem_comp.id in the CHEM_COMP category.
         */
        comp_id: str,
        /**
         * A name for the non-polymer entity
         */
        name: str,
    },
    /**
     * PDBX_CHEM_COMP_SYNONYMS holds chemical name and synonym correspondences.
     */
    pdbx_chem_comp_synonyms: {
        /**
         * The synonym of this particular chemical component.
         */
        name: str,
        /**
         * The chemical component for which this synonym applies.
         */
        comp_id: str,
        /**
         * The provenance of this synonym.
         */
        provenance: Aliased(str),
    },
    /**
     * Data items in the CHEM_COMP_IDENTIFIER category provide
     * identifiers for chemical components.
     */
    pdbx_chem_comp_identifier: {
        /**
         * This data item is a pointer to _chem_comp.id in the CHEM_COMP
         * category.
         */
        comp_id: str,
        /**
         * This data item contains the identifier value for this
         * component.
         */
        identifier: str,
        /**
         * This data item contains the identifier type.
         */
        type: Aliased(str),
        /**
         * This data item contains the name of the program
         * or library used to compute the identifier.
         */
        program: str,
        /**
         * This data item contains the version of the program
         * or library used to compute the identifier.
         */
        program_version: str,
    },
    /**
     * Data items in the PDBX_UNOBS_OR_ZERO_OCC_RESIDUES category list the
     * residues within the entry that are not observed or have zero occupancy.
     */
    pdbx_unobs_or_zero_occ_residues: {
        /**
         * The value of _pdbx_unobs_or_zero_occ_residues.id must uniquely identify
         * each item in the PDBX_UNOBS_OR_ZERO_OCC_RESIDUES list.
         *
         * This is an integer serial number.
         */
        id: int,
        /**
         * The value of polymer flag indicates whether the unobserved or
         * zero occupancy residue is part of a polymer chain or not
         */
        polymer_flag: Aliased(str),
        /**
         * The value of occupancy flag indicates whether the residue
         * is unobserved (= 1) or the coordinates have an occupancy of zero (=0)
         */
        occupancy_flag: Aliased(int),
        /**
         * Part of the identifier for the unobserved or zero occupancy residue.
         *
         * This data item is a pointer to _atom_site.pdbx_PDB_model_num in the
         * ATOM_SITE category.
         */
        PDB_model_num: int,
        /**
         * Part of the identifier for the unobserved or zero occupancy residue.
         *
         * This data item is a pointer to _atom_site.auth_asym_id in the
         * ATOM_SITE category.
         */
        auth_asym_id: str,
        /**
         * Part of the identifier for the unobserved or zero occupancy residue.
         *
         * This data item is a pointer to _atom_site.auth_comp_id in the
         * ATOM_SITE category.
         */
        auth_comp_id: str,
        /**
         * Part of the identifier for the unobserved or zero occupancy residue.
         *
         * This data item is a pointer to _atom_site.auth_seq_id in the
         * ATOM_SITE category.
         */
        auth_seq_id: str,
        /**
         * Part of the identifier for the unobserved or zero occupancy residue.
         *
         * This data item is a pointer to _atom_site.pdbx_PDB_ins_code in the
         * ATOM_SITE category.
         */
        PDB_ins_code: str,
        /**
         * Part of the identifier for the unobserved or zero occupancy residue.
         *
         * This data item is a pointer to _atom_site.label_asym_id in the
         * ATOM_SITE category.
         */
        label_asym_id: str,
        /**
         * Part of the identifier for the unobserved or zero occupancy residue.
         *
         * This data item is a pointer to _atom_site.label_comp_id in the
         * ATOM_SITE category.
         */
        label_comp_id: str,
        /**
         * Part of the identifier for the unobserved or zero occupancy residue.
         *
         * This data item is a pointer to _atom_site.label_seq_id in the
         * ATOM_SITE category.
         */
        label_seq_id: int,
    },
    /**
     * Data items in the PDBX_STRUCT_MOD_RESIDUE category list the
     * modified polymer components in the entry and provide some
     * details describing the nature of the modification.
     */
    pdbx_struct_mod_residue: {
        /**
         * The value of _pdbx_struct_mod_residue.id must uniquely identify
         * each item in the PDBX_STRUCT_MOD_RESIDUE list.
         *
         * This is an integer serial number.
         */
        id: int,
        /**
         * Part of the identifier for the modified polymer component.
         *
         * This data item is a pointer to _atom_site.auth_asym_id in the
         * ATOM_SITE category.
         */
        auth_asym_id: str,
        /**
         * Part of the identifier for the modified polymer component.
         *
         * This data item is a pointer to _atom_site.auth_comp_id in the
         * ATOM_SITE category.
         */
        auth_comp_id: str,
        /**
         * Part of the identifier for the modified polymer component.
         *
         * This data item is a pointer to _atom_site.auth_seq_id in the
         * ATOM_SITE category.
         */
        auth_seq_id: int,
        /**
         * Part of the identifier for the modified polymer component.
         *
         * This data item is a pointer to _atom_site.pdbx_PDB_ins_code in the
         * ATOM_SITE category.
         */
        PDB_ins_code: str,
        /**
         * Part of the identifier for the modified polymer component.
         *
         * This data item is a pointer to _atom_site.label_asym_id in the
         * ATOM_SITE category.
         */
        label_asym_id: str,
        /**
         * Part of the identifier for the modified polymer component.
         *
         * This data item is a pointer to _atom_site.label_comp_id in the
         * ATOM_SITE category.
         */
        label_comp_id: str,
        /**
         * Part of the identifier for the unobserved or zero occupancy residue.
         *
         * This data item is a pointer to _atom_site.label_seq_id in the
         * ATOM_SITE category.
         */
        label_seq_id: int,
        /**
         * The parent component identifier for this modified polymer component.
         */
        parent_comp_id: str,
        /**
         * Details of the modification for this polymer component.
         */
        details: str,
    },
    /**
     * Data items in the PDBX_STRUCT_OPER_LIST category describe
     * Cartesian rotation and translation operations required to
     * generate or transform the coordinates deposited with this entry.
     */
    pdbx_struct_oper_list: {
        /**
         * This identifier code must uniquely identify a
         * record in the PDBX_STRUCT_OPER_LIST list.
         */
        id: str,
        /**
         * A code to indicate the type of operator.
         */
        type: Aliased(str),
        /**
         * A descriptive name for the transformation operation.
         */
        name: str,
        /**
         * The symmetry operation corresponding to the transformation operation.
         */
        symmetry_operation: str,
        /**
         * The elements of the 3x3 matrix component of the
         * transformation operation.
         */
        matrix: Matrix(3, 3),
        /**
         * The elements of the three-element vector component of the
         * transformation operation.
         */
        vector: Vector(3),
    },
    /**
     * Data items in the PDBX_STRUCT_ASSEMBLY category record details about
     * the structural elements that form macromolecular assemblies.
     */
    pdbx_struct_assembly: {
        /**
         * Provides details of the method used to determine or
         * compute the assembly.
         */
        method_details: str,
        /**
         * Provides the details of the oligomeric state of the assembly.
         */
        oligomeric_details: str,
        /**
         * The number of polymer molecules in the assembly.
         */
        oligomeric_count: int,
        /**
         * A description of special aspects of the macromolecular assembly.
         */
        details: str,
        /**
         * The value of _pdbx_struct_assembly.id must uniquely identify a record in
         * the PDBX_STRUCT_ASSEMBLY list.
         */
        id: str,
    },
    /**
     * Data items in the PDBX_STRUCT_ASSEMBLY_GEN category record details about
     * the generation of each macromolecular assemblies. The PDBX_STRUCT_ASSEMBLY_GEN
     * data items provide the specifications of the components that
     * constitute that assembly in terms of cartesian transformations.
     */
    pdbx_struct_assembly_gen: {
        /**
         * This data item is a pointer to _struct_asym.id in
         * the STRUCT_ASYM category.
         *
         * This item may be expressed as a comma separated list of identifiers.
         */
        asym_id_list: List(',', function (x) { return x; }),
        /**
         * This data item is a pointer to _pdbx_struct_assembly.id in the
         * PDBX_STRUCT_ASSEMBLY category.
         */
        assembly_id: str,
        /**
         * Identifies the operation of collection of operations
         * from category PDBX_STRUCT_OPER_LIST.
         *
         * Operation expressions may have the forms:
         *
         * (1)        the single operation 1
         * (1,2,5)    the operations 1, 2, 5
         * (1-4)      the operations 1,2,3 and 4
         * (1,2)(3,4) the combinations of operations
         * 3 and 4 followed by 1 and 2 (i.e.
         * the cartesian product of parenthetical
         * groups applied from right to left)
         */
        oper_expression: str,
    },
    /**
     * Data items in the PDBX_REFERENCE_ENTITY_LIST category record
     * the list of entities within each reference molecule.
     */
    pdbx_reference_entity_list: {
        /**
         * The value of _pdbx_reference_entity_list.prd_id is a reference
         * _pdbx_reference_molecule.prd_id in the PDBX_REFERENCE_MOLECULE category.
         */
        prd_id: str,
        /**
         * The value of _pdbx_reference_entity_list.ref_entity_id is a unique identifier
         * the a constituent entity within this reference molecule.
         */
        ref_entity_id: str,
        /**
         * Defines the polymer characteristic of the entity.
         */
        type: Aliased(str),
        /**
         * Additional details about this entity.
         */
        details: str,
        /**
         * The component number of this entity within the molecule.
         */
        component_id: int,
    },
    /**
     * Data items in the PDBX_REFERENCE_ENTITY_LINK category give details about
     * the linkages between entities within reference molecules.
     */
    pdbx_reference_entity_link: {
        /**
         * The value of _pdbx_reference_entity_link.link_id uniquely identifies
         * linkages between entities with a molecule.
         */
        link_id: int,
        /**
         * The value of _pdbx_reference_entity_link.prd_id is a reference
         * _pdbx_reference_entity_list.prd_id in the PDBX_REFERENCE_ENTITY_LIST category.
         */
        prd_id: str,
        /**
         * A description of special aspects of a linkage between
         * chemical components in the structure.
         */
        details: str,
        /**
         * The reference entity id of the first of the two entities joined by the
         * linkage.
         *
         * This data item is a pointer to _pdbx_reference_entity_list.ref_entity_id
         * in the PDBX_REFERENCE_ENTITY_LIST category.
         */
        ref_entity_id_1: str,
        /**
         * The reference entity id of the second of the two entities joined by the
         * linkage.
         *
         * This data item is a pointer to _pdbx_reference_entity_list.ref_entity_id
         * in the PDBX_REFERENCE_ENTITY_LIST category.
         */
        ref_entity_id_2: str,
        /**
         * For a polymer entity, the sequence number in the first of
         * the two entities containing the linkage.
         *
         * This data item is a pointer to _pdbx_reference_entity_poly_seq.num
         * in the PDBX_REFERENCE_ENTITY_POLY_SEQ category.
         */
        entity_seq_num_1: int,
        /**
         * For a polymer entity, the sequence number in the second of
         * the two entities containing the linkage.
         *
         * This data item is a pointer to _pdbx_reference_entity_poly_seq.num
         * in the PDBX_REFERENCE_ENTITY_POLY_SEQ category.
         */
        entity_seq_num_2: int,
        /**
         * The component identifier in the first of the two entities containing the linkage.
         *
         * For polymer entities, this data item is a pointer to _pdbx_reference_entity_poly_seq.mon_id
         * in the PDBX_REFERENCE_ENTITY_POLY_SEQ category.
         *
         * For non-polymer entities, this data item is a pointer to
         * _pdbx_reference_entity_nonpoly.chem_comp_id in the
         * PDBX_REFERENCE_ENTITY_NONPOLY category.
         */
        comp_id_1: str,
        /**
         * The component identifier in the second of the two entities containing the linkage.
         *
         * For polymer entities, this data item is a pointer to _pdbx_reference_entity_poly_seq.mon_id
         * in the PDBX_REFERENCE_ENTITY_POLY_SEQ category.
         *
         * For non-polymer entities, this data item is a pointer to
         * _pdbx_reference_entity_nonpoly.chem_comp_id in the
         * PDBX_REFERENCE_ENTITY_NONPOLY category.
         */
        comp_id_2: str,
        /**
         * The atom identifier/name in the first of the two entities containing the linkage.
         */
        atom_id_1: str,
        /**
         * The atom identifier/name in the second of the two entities containing the linkage.
         */
        atom_id_2: str,
        /**
         * The bond order target for the chemical linkage.
         */
        value_order: Aliased(str),
        /**
         * The entity component identifier for the first of two entities containing the linkage.
         */
        component_1: int,
        /**
         * The entity component identifier for the second of two entities containing the linkage.
         */
        component_2: int,
        /**
         * A code indicating the entity types involved in the linkage.
         */
        link_class: Aliased(str),
    },
    /**
     * Data items in the PDBX_REFERENCE_ENTITY_POLY_LINK category give details about
     * polymer linkages including both standard and non-standard linkages between
     * polymer componnents.
     */
    pdbx_reference_entity_poly_link: {
        /**
         * The value of _pdbx_reference_entity_poly_link.link_id uniquely identifies
         * a linkage within a polymer entity.
         */
        link_id: int,
        /**
         * The value of _pdbx_reference_entity_poly_link.prd_id is a reference
         * _pdbx_reference_entity_list.prd_id in the PDBX_REFERENCE_ENTITY_POLY category.
         */
        prd_id: str,
        /**
         * The reference entity id of the polymer entity containing the linkage.
         *
         * This data item is a pointer to _pdbx_reference_entity_poly.ref_entity_id
         * in the PDBX_REFERENCE_ENTITY_POLY category.
         */
        ref_entity_id: str,
        /**
         * The entity component identifier entity containing the linkage.
         */
        component_id: int,
        /**
         * For a polymer entity, the sequence number in the first of
         * the two components making the linkage.
         *
         * This data item is a pointer to _pdbx_reference_entity_poly_seq.num
         * in the PDBX_REFERENCE_ENTITY_POLY_SEQ category.
         */
        entity_seq_num_1: int,
        /**
         * For a polymer entity, the sequence number in the second of
         * the two components making the linkage.
         *
         * This data item is a pointer to _pdbx_reference_entity_poly_seq.num
         * in the PDBX_REFERENCE_ENTITY_POLY_SEQ category.
         */
        entity_seq_num_2: int,
        /**
         * The component identifier in the first of the two components making the
         * linkage.
         *
         * This data item is a pointer to _pdbx_reference_entity_poly_seq.mon_id
         * in the PDBX_REFERENCE_ENTITY_POLY_SEQ category.
         */
        comp_id_1: str,
        /**
         * The component identifier in the second of the two components making the
         * linkage.
         *
         * This data item is a pointer to _pdbx_reference_entity_poly_seq.mon_id
         * in the PDBX_REFERENCE_ENTITY_POLY_SEQ category.
         */
        comp_id_2: str,
        /**
         * The atom identifier/name in the first of the two components making
         * the linkage.
         */
        atom_id_1: str,
        /**
         * The atom identifier/name in the second of the two components making
         * the linkage.
         */
        atom_id_2: str,
        /**
         * The bond order target for the non-standard linkage.
         */
        value_order: Aliased(str),
    },
    /**
     * Data items in the PDBX_MOLECULE category identify reference molecules
     * within a PDB entry.
     */
    pdbx_molecule: {
        /**
         * The value of _pdbx_molecule.prd_id is the PDB accession code for this
         * reference molecule.
         */
        prd_id: str,
        /**
         * The value of _pdbx_molecule.instance_id is identifies a particular molecule
         * in the molecule list.
         */
        instance_id: int,
        /**
         * A reference to _struct_asym.id in the STRUCT_ASYM category.
         */
        asym_id: str,
    },
    /**
     * Data items in the PDBX_MOLECULE_FEATURES category record features of molecules
     * within a PDB entry.
     */
    pdbx_molecule_features: {
        /**
         * The value of _pdbx_molecule_features.prd_id is the PDB accession code for this
         * reference molecule.
         */
        prd_id: str,
        /**
         * Broadly defines the function of the molecule.
         */
        class: Aliased(str),
        /**
         * Defines the structural classification of the molecule.
         */
        type: Aliased(str),
        /**
         * A name of the molecule.
         */
        name: str,
        /**
         * Additional details describing the molecule.
         */
        details: str,
    },
    /**
     * Data items in the ENTITY_SRC_NAT category record details of
     * the source from which the entity was obtained in cases
     * where the entity was isolated directly from a natural tissue.
     */
    entity_src_nat: {
        /**
         * This data item is a pointer to _entity.id in the ENTITY category.
         */
        entity_id: str,
        /**
         * Scientific name of the organism of the natural source.
         */
        pdbx_organism_scientific: str,
        /**
         * The plasmid containing the gene.
         */
        pdbx_plasmid_name: str,
        /**
         * This data item is an ordinal identifier for entity_src_nat data records.
         */
        pdbx_src_id: int,
        /**
         * The beginning polymer sequence position for the polymer section corresponding
         * to this source.
         *
         * A reference to the sequence position in the entity_poly category.
         */
        pdbx_beg_seq_num: int,
        /**
         * The ending polymer sequence position for the polymer section corresponding
         * to this source.
         *
         * A reference to the sequence position in the entity_poly category.
         */
        pdbx_end_seq_num: int,
    },
    /**
     * Data items in the ENTITY_SRC_GEN category record details of
     * the source from which the entity was obtained in cases
     * where the source was genetically manipulated.  The
     * following are treated separately:  items pertaining to the tissue
     * from which the gene was obtained, items pertaining to the host
     * organism for gene expression and items pertaining to the actual
     * producing organism (plasmid).
     */
    entity_src_gen: {
        /**
         * This data item is a pointer to _entity.id in the ENTITY category.
         */
        entity_id: str,
        /**
         * Identifies the gene.
         */
        pdbx_gene_src_gene: List(',', function (x) { return x; }),
        /**
         * Scientific name of the organism.
         */
        pdbx_gene_src_scientific_name: str,
        /**
         * The name of the plasmid that produced the entity in the host
         * organism. Where full details of the protein production are available
         * it would be expected that this item would be derived from
         * _pdbx_construct.name of the construct pointed to from
         * _entity_src_gen_express.plasmid_id.
         */
        plasmid_name: str,
        /**
         * This data item is an ordinal identifier for entity_src_gen data records.
         */
        pdbx_src_id: int,
        /**
         * The beginning polymer sequence position for the polymer section corresponding
         * to this source.
         *
         * A reference to the sequence position in the entity_poly category.
         */
        pdbx_beg_seq_num: int,
        /**
         * The ending polymer sequence position for the polymer section corresponding
         * to this source.
         *
         * A reference to the sequence position in the entity_poly category.
         */
        pdbx_end_seq_num: int,
    },
    /**
     * The data items in category PDBX_ENTITY_SRC_SYN record the source details
     * about chemically synthesized molecules.
     */
    pdbx_entity_src_syn: {
        /**
         * The scientific name of the organism from which the sequence of
         * the synthetic entity was derived.
         */
        organism_scientific: str,
        /**
         * This data item is a pointer to _entity.id in the ENTITY category.
         */
        entity_id: str,
        /**
         * This data item is an ordinal identifier for pdbx_entity_src_syn data records.
         */
        pdbx_src_id: int,
        /**
         * The beginning polymer sequence position for the polymer section corresponding
         * to this source.
         *
         * A reference to the sequence position in the entity_poly category.
         */
        pdbx_beg_seq_num: int,
        /**
         * The ending polymer sequence position for the polymer section corresponding
         * to this source.
         *
         * A reference to the sequence position in the entity_poly category.
         */
        pdbx_end_seq_num: int,
    },
    /**
     * Data items in the PDBX_ENTITY_BRANCH_DESCRIPTOR category provide
     * string descriptors of entity chemical structure.
     */
    pdbx_entity_branch_descriptor: {
        /**
         * This data item is a pointer to _entity_poly.entity_id in the ENTITY
         * category.
         */
        entity_id: str,
        /**
         * This data item contains the descriptor value for this
         * entity.
         */
        descriptor: str,
        /**
         * This data item contains the descriptor type.
         */
        type: Aliased(str),
        /**
         * This data item contains the name of the program
         * or library used to compute the descriptor.
         */
        program: str,
        /**
         * This data item contains the version of the program
         * or library used to compute the descriptor.
         */
        program_version: str,
        /**
         * Ordinal index for this category.
         */
        ordinal: int,
    },
    /**
     * Data items in the pdbx_entity_instance_feature category records
     * special features of selected entity instances.
     */
    pdbx_entity_instance_feature: {
        /**
         * Special structural details about this entity instance.
         */
        details: str,
        /**
         * A feature type associated with entity instance.
         */
        feature_type: Aliased(str),
        /**
         * Author instance identifier (formerly PDB Chain ID)
         */
        auth_asym_id: str,
        /**
         * Instance identifier for this entity.
         */
        asym_id: str,
        /**
         * Author provided residue number.
         */
        auth_seq_num: str,
        /**
         * Position in the sequence.
         */
        seq_num: int,
        /**
         * Chemical component identifier
         */
        comp_id: str,
        /**
         * The author provided chemical component identifier
         */
        auth_comp_id: str,
        /**
         * An ordinal index for this category
         */
        ordinal: int,
    },
    /**
     * Data items in the PDBX_ENTITY_BRANCH_LIST category specify the list
     * of monomers in a branched entity.  Allowance is made for the possibility
     * of microheterogeneity in a sample by allowing a given sequence
     * number to be correlated with more than one monomer ID. The
     * corresponding ATOM_SITE entries should reflect this
     * heterogeneity.
     */
    pdbx_entity_branch_list: {
        /**
         * This data item is a pointer to _entity.id in the ENTITY category.
         */
        entity_id: str,
        /**
         * A flag to indicate whether this monomer in the entity is
         * heterogeneous in sequence.
         */
        hetero: Aliased(str),
        /**
         * This data item is a pointer to _chem_comp.id in the CHEM_COMP
         * category.
         */
        comp_id: str,
        /**
         * The value pair  _pdbx_entity_branch_list.num and _pdbx_entity_branch_list.comp_id
         * must uniquely identify a record in the PDBX_ENTITY_BRANCH_LIST list.
         */
        num: int,
    },
    /**
     * Data items in the PDBX_ENTITY_BRANCH_LINK category give details about
     * the linkages between components within a branched entity.
     */
    pdbx_entity_branch_link: {
        /**
         * The value of _pdbx_entity_branch_link.link_id uniquely identifies
         * linkages within the branched entity.
         */
        link_id: int,
        /**
         * A description of special aspects of this linkage.
         */
        details: str,
        /**
         * The entity id for this branched entity.
         *
         * This data item is a pointer to _pdbx_entity_branch_list.entity_id
         * in the PDBX_ENTITY_BRANCH_LIST category.
         */
        entity_id: str,
        /**
         * The component number for the first component making the linkage.
         *
         * This data item is a pointer to _pdbx_entity_branch_list.num
         * in the PDBX_ENTITY_BRANCH_LIST category.
         */
        entity_branch_list_num_1: int,
        /**
         * The component number for the second component making the linkage.
         *
         * This data item is a pointer to _pdbx_entity_branch_list.num
         * in the PDBX_ENTITY_BRANCH_LIST category.
         */
        entity_branch_list_num_2: int,
        /**
         * The component identifier for the first component making the linkage.
         *
         * This data item is a pointer to _pdbx_entity_branch_list.comp_id
         * in the PDBX_ENTITY_BRANCH_LIST category.
         */
        comp_id_1: str,
        /**
         * The component identifier for the second component making the linkage.
         *
         * This data item is a pointer to _pdbx_entity_branch_list.comp_id
         * in the PDBX_ENTITY_BRANCH_LIST category.
         */
        comp_id_2: str,
        /**
         * The atom identifier/name for the first atom making the linkage.
         */
        atom_id_1: str,
        /**
         * The leaving atom identifier/name bonded to the first atom making the linkage.
         */
        leaving_atom_id_1: str,
        /**
         * The chiral configuration of the first atom making the linkage.
         */
        atom_stereo_config_1: Aliased(str),
        /**
         * The atom identifier/name for the second atom making the linkage.
         */
        atom_id_2: str,
        /**
         * The leaving atom identifier/name bonded to the second atom making the linkage.
         */
        leaving_atom_id_2: str,
        /**
         * The chiral configuration of the second atom making the linkage.
         */
        atom_stereo_config_2: Aliased(str),
        /**
         * The bond order target for the chemical linkage.
         */
        value_order: Aliased(str),
    },
    /**
     * Data items in the PDBX_ENTITY_BRANCH category specify the list
     * of branched entities and the type.
     */
    pdbx_entity_branch: {
        /**
         * The entity id for this branched entity.
         *
         * This data item is a pointer to _entity.id
         */
        entity_id: str,
        /**
         * The type of this branched oligosaccharide.
         */
        type: Aliased(str),
    },
    /**
     * The PDBX_BRANCH_SCHEME category provides residue level nomenclature
     * mapping for branch chain entities.
     */
    pdbx_branch_scheme: {
        /**
         * This data item is a pointer to _entity.id in the ENTITY category.
         */
        entity_id: str,
        /**
         * A flag to indicate whether this monomer in the entity is
         * heterogeneous in sequence.
         */
        hetero: Aliased(str),
        /**
         * Pointer to _atom_site.label_asym_id.
         */
        asym_id: str,
        /**
         * This data item is a pointer to _atom_site.label_comp_id in the
         * PDBX_ENTITY_BRANCH_LIST category.
         */
        mon_id: str,
        /**
         * This data item is a pointer to _pdbx_entity_branch_list.num in the
         * PDBX_ENTITY_BRANCH_LIST category.
         */
        num: int,
        /**
         * This data item is a pointer to _atom_site.auth_asym_id in the
         * ATOM_SITE category.
         */
        pdb_asym_id: str,
        /**
         * This data item is a pointer to _atom_site.auth_seq_id in the
         * ATOM_SITE category.
         */
        pdb_seq_num: str,
        /**
         * This data item is a pointer to _atom_site.auth_comp_id in the
         * ATOM_SITE category.
         */
        pdb_mon_id: str,
        /**
         * This data item is a pointer to _atom_site.pdbx_auth_asym_id in the
         * ATOM_SITE category.
         */
        auth_asym_id: str,
        /**
         * This data item is a pointer to _atom_site.pdbx_auth_seq_id in the
         * ATOM_SITE category.
         */
        auth_seq_num: str,
        /**
         * This data item is a pointer to _atom_site.pdbx_auth_comp_id in the
         * ATOM_SITE category.
         */
        auth_mon_id: str,
    },
    /**
     * PDBX_CHEM_COMP_RELATED describes the relationship between two chemical components.
     */
    pdbx_chem_comp_related: {
        /**
         * The chemical component for which this relationship applies.
         */
        comp_id: str,
        /**
         * The related chemical component for which this chemical component is based.
         */
        related_comp_id: str,
        /**
         * Describes the type of relationship
         */
        relationship_type: Aliased(str),
        /**
         * Describes the type of relationship
         */
        details: str,
    },
    /**
     * Data items in the IHM_STARTING_MODEL_DETAILS category records the
     * details about structural models used as starting inputs in
     * the integrative model building process.
     */
    ihm_starting_model_details: {
        /**
         * A unique identifier for the starting structural model.
         */
        starting_model_id: str,
        /**
         * A unique identifier for the distinct molecular entities.
         * This data item is a pointer to _entity.id in the ENTITY category.
         */
        entity_id: str,
        /**
         * A text description of the molecular entity
         */
        entity_description: str,
        /**
         * An asym/strand identifier for the entity molecule.
         * This data item is a pointer to _struct_asym.id in the
         * STRUCT_ASYM category.
         */
        asym_id: str,
        /**
         * The identifier for the polymeric segment modeled using this starting model.
         * This data item is a pointer to _ihm_entity_poly_segment.id in the
         * IHM_ENTITY_POLY_SEGMENT category.
         */
        entity_poly_segment_id: int,
        /**
         * The source of the starting model.
         */
        starting_model_source: Aliased(str),
        /**
         * The author assigned chainId/auth_asym_id corresponding to this starting model.
         * This corresponds to the chainId/auth_asym_id of the experimental models in the
         * PDB or comparative models in the Model Archive or the starting models referenced
         * via a DOI. If starting models are included in IHM_STARTING_MODEL_COORD, then
         * this will be the same as _ihm_starting_model_details.asym_id.
         */
        starting_model_auth_asym_id: str,
        /**
         * The offset in residue numbering between the starting model and the deposited I/H model, if applicable.
         * I/H model residue number = Starting model residue number + offset
         */
        starting_model_sequence_offset: int,
        /**
         * Identifier to the starting model (comparative, experimental or integrative)
         * used as input in the integrative modeling.
         * This data item is a pointer to the _ihm_dataset_list.id in the
         * IHM_DATASET_LIST category.
         */
        dataset_list_id: int,
    },
    /**
     * Data items in the IHM_STARTING_COMPARATIVE_MODELS category records
     * additional details about comparative models used as starting inputs in
     * the integrative model building process.
     */
    ihm_starting_comparative_models: {
        /**
         * A unique identifier for the starting comparative model.
         */
        id: int,
        /**
         * The identifier for the starting structural model.
         * This data item is a pointer to _ihm_starting_model_details.starting_model_id
         * in the IHM_STARTING_MODEL_DETAILS category.
         */
        starting_model_id: str,
        /**
         * The chainId/auth_asym_id corresponding to the starting model.
         */
        starting_model_auth_asym_id: str,
        /**
         * The starting residue index of the starting model.
         */
        starting_model_seq_id_begin: int,
        /**
         * The ending residue index of the starting model.
         */
        starting_model_seq_id_end: int,
        /**
         * The chainId/auth_asym_id corresponding to the template.
         */
        template_auth_asym_id: str,
        /**
         * The starting residue index of the template.
         */
        template_seq_id_begin: int,
        /**
         * The ending residue index of the template.
         */
        template_seq_id_end: int,
        /**
         * The percentage sequence identity between the template sequence and the comparative model sequence.
         */
        template_sequence_identity: float,
        /**
         * The denominator used while calculating the sequence identity provided in
         * _ihm_starting_comparative_models.template_sequence_identity.
         */
        template_sequence_identity_denominator: Aliased(int),
        /**
         * The dataset list id corresponding to the template used to obtain the comparative model.
         * This data item is a pointer to _ihm_dataset_list.id in the IHM_DATASET_LIST category.
         */
        template_dataset_list_id: int,
        /**
         * The file id corresponding to the sequence alignment of the template sequence and the comparative model sequence.
         * This data item is a pointer to _ihm_external_files.id in the IHM_EXTERNAL_FILES category.
         */
        alignment_file_id: int,
    },
    /**
     * Data items in the IHM_STARTING_MODEL_SEQ_DIF category provide a
     * mechanism for indicating and annotating point differences
     * between the sequence of the entity or biological unit described
     * in the data block and the sequence of the starting model used in
     * the integrative modeling referenced from a database. The point
     * differences may be due to point mutations introduced in the
     * starting model or the presence of modified amino acid residues.
     */
    ihm_starting_model_seq_dif: {
        /**
         * A unique identifier for the entry.
         */
        id: int,
        /**
         * A unique identifier for the distinct molecular entities.
         * This data item is a pointer to _entity_poly_seq.entity_id in the ENTITY_POLY category.
         */
        entity_id: str,
        /**
         * An asym/strand identifier for the entity molecule.
         * This data item is a pointer to _struct_asym.id in the
         * STRUCT_ASYM category.
         */
        asym_id: str,
        /**
         * The residue index.
         * This data item is a pointer to _entity_poly_seq.num in the ENTITY_POLY_SEQ category.
         */
        seq_id: int,
        /**
         * The component identifier for the residue.
         * This data item is a pointer to _entity_poly_seq.mon_id in the ENTITY_POLY_SEQ category.
         */
        comp_id: str,
        /**
         * Unique identifier for the starting model record.
         * This data item is a pointer to _ihm_starting_model_details.starting_model_id in the
         * IHM_STARTING_MODEL_DETAILS category.
         */
        starting_model_id: str,
        /**
         * The asym/strand identifier for the entity molecule of the database starting model.
         */
        db_asym_id: str,
        /**
         * The corresponding residue index of the database starting model.
         */
        db_seq_id: int,
        /**
         * The correspinding component identifier for the residue in the database starting model.
         */
        db_comp_id: str,
        /**
         * A description of special aspects of the point differences
         * between the sequence of the entity or biological unit described
         * in the data block and that in the starting model referenced
         * from a database.
         */
        details: str,
    },
    /**
     * Data items in the IHM_MODEL_REPRESENTATION category lists the
     * various mono or multi-scale model representations used in the
     * integrative modeling study.
     */
    ihm_model_representation: {
        /**
         * A unique identifier for the model representation.
         */
        id: int,
        /**
         * Name/brief description for the model representation.
         */
        name: str,
        /**
         * Additional details about the model representation.
         */
        details: str,
    },
    /**
     * Data items in the IHM_MODEL_REPRESENTATION_DETAILS category records the
     * details about the architecture and representation of structural
     * models involved in the integrative modeling study.
     */
    ihm_model_representation_details: {
        /**
         * A unique identifier for the category.
         */
        id: int,
        /**
         * An identifier that collects or groups together a set of representations.
         * This data item is a pointer to _ihm_model_representation.id in the
         * IHM_MODEL_REPRESENTATION category.
         */
        representation_id: int,
        /**
         * The identifier for the polymeric segment in the representation.
         * This data item is a pointer to _ihm_entity_poly_segment.id in the
         * IHM_ENTITY_POLY_SEGMENT category.
         */
        entity_poly_segment_id: int,
        /**
         * A unique identifier distinct molecular entities.
         * This data item is a pointer to _entity.id in the
         * ENTITY category.
         */
        entity_id: str,
        /**
         * A text description of the molecular entity
         */
        entity_description: str,
        /**
         * An asym/strand identifier for the entity molecule.
         * This data item is a pointer to _struct_asym.id in the
         * STRUCT_ASYM category.
         */
        entity_asym_id: str,
        /**
         * The primitive object used to model this segment.
         */
        model_object_primitive: Aliased(str),
        /**
         * The identifier for the starting structural model.
         * This data item is a pointer to _ihm_starting_model_details.starting_model_id
         * in the IHM_STARTING_MODEL_DETAILS category.
         */
        starting_model_id: str,
        /**
         * The manner in which the segment is modeled.
         */
        model_mode: Aliased(str),
        /**
         * The level of detail at which model primitive objects are applied to the structure.
         */
        model_granularity: Aliased(str),
        /**
         * The number of primitive objects used to model a feature in the case of 'by-feature' granularity.
         */
        model_object_count: int,
    },
    /**
     * Data items in the IHM_STRUCT_ASSEMBLY_DETAILS category records
     * the details of the structural assemblies and used in the
     * integrative modeling.
     */
    ihm_struct_assembly_details: {
        /**
         * A unique identifier for the structural assembly description.
         */
        id: int,
        /**
         * An identifier for the structural assembly.
         * This data item will remain the same for all components
         * of an assembly.
         * This data item is a pointer to _ihm_struct_assembly.id
         * in the IHM_STRUCT_ASSEMBLY category.
         */
        assembly_id: int,
        /**
         * The parent of this assembly in a hierarchy.
         * This data item is a pointer to _ihm_struct_assembly.id in the
         * IHM_STRUCT_ASSEMBLY category.
         * This data item should point to the assembly id of the immediate
         * parent in a hierarchy.
         * By convention, the full assembly (top of hierarchy) is assigned parent id 0 (zero).
         * In case of assemblies that do not conform to a hierarchy,
         * _ihm_struct_assembly_details.parent_assembly_id is the same as
         * _ihm_struct_assembly_details.assembly_id indicating a self-parent.
         */
        parent_assembly_id: int,
        /**
         * A text description of the molecular entity
         */
        entity_description: str,
        /**
         * A unique identifier for distinct molecular entities.
         * This data item is a pointer to _entity.id in the
         * ENTITY category.
         */
        entity_id: str,
        /**
         * An asym/strand identifier for the component in the assembly.
         * This data item is a pointer to _struct_asym.id in the
         * STRUCT_ASYM category.
         */
        asym_id: str,
        /**
         * The identifier for the polymeric segment in the assembly.
         * This data item is a pointer to _ihm_entity_poly_segment.id in the
         * IHM_ENTITY_POLY_SEGMENT category.
         */
        entity_poly_segment_id: int,
    },
    /**
     * Data items in the IHM_STRUCT_ASSEMBLY category lists
     * all the structural assemblies used in the integrative
     * modeling study.
     */
    ihm_struct_assembly: {
        /**
         * A unique identifier for the structural assembly.
         */
        id: int,
        /**
         * A name for the structural assembly.
         */
        name: str,
        /**
         * Description of the structural assembly.
         */
        description: str,
    },
    /**
     * Data items in the IHM_MODELING_PROTOCOL category lists all
     * modeling protocols used in the integrative modeling study.
     */
    ihm_modeling_protocol: {
        /**
         * A unique identifier for the modeling protocol.
         */
        id: int,
        /**
         * Number of independent steps in the modeling protocol.
         */
        num_steps: int,
        /**
         * The name for the modeling protocol.
         */
        protocol_name: str,
    },
    /**
     * Data items in the IHM_MODELING_PROTOCOL_DETAILS category records the
     * step-wise details of the integrative modeling workflow.
     */
    ihm_modeling_protocol_details: {
        /**
         * A unique identifier for the modeling protocol/step combination.
         */
        id: int,
        /**
         * An index for the modeling protocol carried out.
         * This data item is a pointer to _ihm_modeling_protocol.id in the
         * IHM_MODELING_PROTOCOL category.
         */
        protocol_id: int,
        /**
         * An index for a particular step within the modeling protocol.
         */
        step_id: int,
        /**
         * An index for the structural assembly being modeled.
         * This is an indicator to whether the whole assembly is modeled
         * or if only a subset of the structural assembly is modeled.
         * This data item is a pointer to _ihm_struct_assembly.id in the
         * IHM_STRUCT_ASSEMBLY category. The IHM_STRUCT_ASSEMBLY category provides the
         * details regarding the different structural assemblies used in the modeling.
         * The default value for this data item is "1", indicating that the entire
         * assembly is being modeled.
         */
        struct_assembly_id: int,
        /**
         * An index for the dataset group being used in the modeling protocol.
         * This data item is a pointer to the _ihm_dataset_group.id in the
         * IHM_DATASET_GROUP category.
         */
        dataset_group_id: int,
        /**
         * A textual description of the structural assembly being modeled.
         */
        struct_assembly_description: str,
        /**
         * The name or type of the modeling step.
         */
        step_name: str,
        /**
         * Description of the method involved in the modeling step.
         */
        step_method: str,
        /**
         * The number of models in the beginning of the step.
         */
        num_models_begin: int,
        /**
         * The number of models at the end of the step.
         */
        num_models_end: int,
        /**
         * A flag to indicate if the modeling is multi scale.
         */
        multi_scale_flag: Aliased(str),
        /**
         * A flag to indicate if the modeling is multi state.
         */
        multi_state_flag: Aliased(str),
        /**
         * A flag to indicate if the modeling involves an ensemble ordered by time or other order.
         */
        ordered_flag: Aliased(str),
        /**
         * The file id corresponding to the script used in the modeling protocol step.
         * This data item is a pointer to _ihm_external_files.id in the IHM_EXTERNAL_FILES category.
         */
        script_file_id: int,
        /**
         * Identifier to the software used in the modeling protocol step.
         * This data item is a pointer to the _software.pdbx_ordinal in the
         * SOFTWARE category.
         */
        software_id: int,
    },
    /**
     * Data items in the IHM_MULTI_STATE_MODELING category records the
     * details of the multi-state modeling protocol, if applicable.
     */
    ihm_multi_state_modeling: {
        /**
         * A unique identifier for a particular state in the multi-state modeling.
         */
        state_id: int,
        /**
         * An identifier for a collections of states in the multi-state modeling.
         * This data item can be used when structural models belong to diffent
         * multi-state modeling types.
         */
        state_group_id: int,
        /**
         * A fraction representing the population of the particular state.
         */
        population_fraction: float,
        /**
         * The standard deviation of the population fraction.
         */
        population_fraction_sd: float,
        /**
         * The type that the multiple states being modeled belong to.
         */
        state_type: str,
        /**
         * A descriptive name for the state.
         */
        state_name: str,
        /**
         * The type of multi-state modeling experiment carried out.
         */
        experiment_type: Aliased(str),
        /**
         * Additional textual details of the multi-state modeling, if required.
         */
        details: str,
    },
    /**
     * Data items in the IHM_MODELING_POST_PROCESS category records
     * the details of the post processing of the models/results of
     * the modeling protocol.
     */
    ihm_modeling_post_process: {
        /**
         * A unique identifier for the post modeling analysis/step combination.
         */
        id: int,
        /**
         * An identifier for the modeling protocol, whose post modeling analysis
         * is being carried out.
         * This data item is a pointer to the _ihm_modeling_protocol.id
         * in the IHM_MODELING_PROTOCOL category.
         */
        protocol_id: int,
        /**
         * An identifier for the post modeling analysis. This data item accounts for
         * multiple post-modeling analyses that can be carried out.
         */
        analysis_id: int,
        /**
         * In a multi-step process, this identifier denotes the particular
         * step in the post modeling analysis.
         */
        step_id: int,
        /**
         * The type of post modeling analysis being carried out.
         */
        type: Aliased(str),
        /**
         * The parameter/feature used in the post modeling analysis.
         */
        feature: Aliased(str),
        /**
         * The number of models at the beginning of the post processing step.
         */
        num_models_begin: int,
        /**
         * The number of models the the end of the post processing step.
         */
        num_models_end: int,
    },
    /**
     * Data items in the IHM_ENSEMBLE_INFO category records the
     * details of the model clusters or ensembles obtained after
     * sampling.
     */
    ihm_ensemble_info: {
        /**
         * A unique id for the ensemble.
         */
        ensemble_id: int,
        /**
         * An optional name for the cluster or ensemble for better description.
         */
        ensemble_name: str,
        /**
         * An identifier for the post modeling analyses carried out.
         * This data item is a pointer to _ihm_modeling_post_process.id in
         * the IHM_MODELING_POST_PROCESS category.
         */
        post_process_id: int,
        /**
         * An identifier for the cluster or group of models being deposited.
         * This data item is a pointer to the _ihm_model_group.id
         * in the IHM_MODEL_GROUP category.
         */
        model_group_id: int,
        /**
         * The clustering method used to obtain the ensemble, if applicable.
         */
        ensemble_clustering_method: Aliased(str),
        /**
         * The parameter/feature used for clustering the models, if applicable.
         */
        ensemble_clustering_feature: Aliased(str),
        /**
         * The number of models in the current ensemble being described.
         */
        num_ensemble_models: int,
        /**
         * The number of models from the current ensemble that is deposited.
         */
        num_ensemble_models_deposited: int,
        /**
         * The precision of each cluster or ensemble is calculated as dRMSD, which
         * is the average C-alpha distance root mean square deviation (dRMSD)
         * between the individual models in the cluster and the cluster centroid.
         * The cluster centroid is defined as the model with the minimal sum of
         * dRMSDs to the other models in the cluster or ensemble.
         */
        ensemble_precision_value: float,
        /**
         * A reference to the external file containing the structural models
         * in the ensemble. The number of models in the external file should
         * correspond to the number of models in the ensemble. This data item
         * is a pointer to _ihm_external_files.id in the IHM_EXTERNAL_FILES
         * category.
         * It is recommended that the large ensemble files be stored as separate
         * zip files within the same DOI. It is also recommended that large sphere
         * model ensembles be in binary format, which facilitates faster access.
         * Currently, a binary dump of co-ordinates in dcd format is suggested.
         * The topology can be inferred from the IHM_SPHERE_OBJ_SITE and the
         * ATOM_SITE categories in the corresponding mmCIF file.
         */
        ensemble_file_id: int,
    },
    /**
     * Data items in the IHM_MODEL_LIST category record the
     * details of the models being deposited.
     */
    ihm_model_list: {
        /**
         * A unique identifier for the structural model being deposited.
         */
        model_id: int,
        /**
         * A decsriptive name for the model.
         */
        model_name: str,
        /**
         * An identifier to the structure assembly corresponding to the model.
         * This data item is a pointer to the _ihm_struct_assembly.id
         * in the IHM_STRUCT_ASSEMBLY category.
         */
        assembly_id: int,
        /**
         * An identifier to the modeling protocol that produced the model.
         * This data item is a pointer to the _ihm_modeling_protocol.id
         * in the IHM_MODELING_PROTOCOL category.
         */
        protocol_id: int,
        /**
         * An identifier to the multi-scale model representation id of the model.
         * This data item is a pointer to the _ihm_model_representation.id
         * in the IHM_MODEL_REPRESENTATION category.
         */
        representation_id: int,
    },
    /**
     * IHM_MODEL_GROUP category defines collections or groups of integrative
     * structural models.
     */
    ihm_model_group: {
        /**
         * A unique identifier for a collection or group of structural models.
         * This data item can be used to group models into structural clusters
         * or using other criteria based on experimental data or other
         * relationships such as those belonging to the same state or time stamp.
         * An ensemble of models and its representative can either be grouped together
         * or can be separate groups in the ihm_model_group table. The choice between
         * the two options should be decided based on how the modeling was carried out
         * and how the representative was chosen. If the representative is a member of
         * the ensemble (i.e., best scoring model), then it is recommended that the
         * representative and the ensemble belong to the same model group. If the
         * representative is calculated from the ensemble (i.e., centroid), then it is
         * recommended that the representative be separated into a different group.
         */
        id: int,
        /**
         * A name for the collection of models.
         */
        name: str,
        /**
         * Additional details about the collection of models.
         */
        details: str,
    },
    /**
     * IHM_MODEL_GROUP_LINK category provides the list of models present in
     * a particular model group.
     */
    ihm_model_group_link: {
        /**
         * An identifier for the structural model.
         * This data item is a pointer to _ihm_model_list.model_id in the
         * IHM_MODEL_LIST category.
         */
        model_id: int,
        /**
         * An identifier for the structural model group.
         * This data item is a pointer to _ihm_model_group.id in the
         * IHM_MODEL_GROUP category.
         */
        group_id: int,
    },
    /**
     * Data items in the IHM_MODEL_REPRESENTATIVE category record the
     * details of the representative model in an ensemble or cluster.
     */
    ihm_model_representative: {
        /**
         * A unique identifier for the representative of the model group.
         */
        id: int,
        /**
         * The model group identifier corresponding to the representative model.
         * This data item is a pointer to _ihm_model_group.id in the
         * IHM_MODEL_GROUP category.
         */
        model_group_id: int,
        /**
         * The model identifier corresponding to the representative model.
         * This data item is a pointer to _ihm_model_list.model_id in the
         * IHM_MODEL_LIST category.
         */
        model_id: int,
        /**
         * The selection criteria based on which the representative is chosen.
         */
        selection_criteria: Aliased(str),
    },
    /**
     * Category holds the list of all datasets used in the IHM modeling.
     * These can be datasets archived in other related databases such as
     * BMRB, EMDB, EMPIAR, SASBDB, PRIDE etc., or can be hosted in other
     * places such as the authors website, github etc. These datasets are
     * elaborated in detail in the IHM_DATASET_RELATED_DB_REFERENCE and/or
     * the IHM_DATASET_EXTERNAL_REFERENCE categories. This category
     * holds the list of all datasets used.
     */
    ihm_dataset_list: {
        /**
         * A unique identifier for the dataset.
         */
        id: int,
        /**
         * The type of data held in the dataset.
         */
        data_type: Aliased(str),
        /**
         * A flag that indicates whether the dataset is archived in
         * an IHM related database or elsewhere.
         */
        database_hosted: Aliased(str),
    },
    /**
     * Category to define groups or collections of input datasets.
     */
    ihm_dataset_group: {
        /**
         * A unique identifier for the dataset group.
         */
        id: int,
        /**
         * A name for the dataset group.
         */
        name: str,
        /**
         * The application / utilization of the dataset group in modeling.
         */
        application: Aliased(str),
        /**
         * Additional details regarding the dataset group.
         */
        details: str,
    },
    /**
     * IHM_DATASET_GROUP_LINK category provides the list of datasets present in
     * a particular group.
     */
    ihm_dataset_group_link: {
        /**
         * An identifier for the dataset.
         * This data item is a pointer to _ihm_dataset_list.id in the
         * IHM_DATASET_LIST category.
         */
        dataset_list_id: int,
        /**
         * An identifier for the dataset group.
         * This data item is a pointer to _ihm_dataset_group.id in the
         * IHM_DATASET_GROUP category.
         */
        group_id: int,
    },
    /**
     * Category holds information about related datasets, where one is derived from the other.
     */
    ihm_related_datasets: {
        /**
         * The dataset list id corresponding to the derived dataset.
         * This data item is a pointer to _ihm_dataset_list.id in the
         * IHM_DATASET_LIST category.
         */
        dataset_list_id_derived: int,
        /**
         * The primary dataset list id from which the corresponding derived dataset is obtained.
         * This data item is a pointer to _ihm_dataset_list.id in the
         * IHM_DATASET_LIST category.
         */
        dataset_list_id_primary: int,
    },
    /**
     * Category holds information related to data sources for the entry.
     * These can be datasets archived in other related databases such as
     * BMRB, EMDB, EMPIAR, SASBDB, PRIDE etc.
     */
    ihm_dataset_related_db_reference: {
        /**
         * A unique identifier for the related database entry.
         */
        id: int,
        /**
         * Identifier to the dataset list used in the IHM modeling.
         * This data item is a pointer to the _ihm_dataset_list.id in the
         * IHM_DATASET_LIST category.
         */
        dataset_list_id: int,
        /**
         * The name of the database containing the dataset entry.
         */
        db_name: Aliased(str),
        /**
         * The accession code for the database entry.
         */
        accession_code: str,
        /**
         * Version of the database entry, if the database allows versioning.
         */
        version: str,
        /**
         * Details regarding the dataset entry.
         */
        details: str,
    },
    /**
     * Category holds links to other external data sources for the I/H model entry.
     * Input datasets held in other databases such as EMDB, BMRB, SASBDB etc.
     * are referenced in the IHM_DATASET_RELATED_DB_REFERENCE category.
     * This data category, along with IHM_EXTERNAL_FILES category, holds information
     * regarding other non-database external data sources, such as  DOIs (digital
     * object identifiers) or supplementary files stored locally. The DOIs can either
     * lead to the external data file(s) directly (as in case of DOIs provided by the PDB)
     * or might lead to an HTML landing page (as provided by Zenodo). In the latter case,
     * additional URL (Uniform Resource Locator) information is required to retrieve
     * the external data file(s).
     */
    ihm_external_reference_info: {
        /**
         * A unique identifier for the external reference.
         */
        reference_id: int,
        /**
         * The name of the reference provider.
         */
        reference_provider: str,
        /**
         * The type of external reference.
         * Currently, only Digital Object Identifiers (DOIs) and supplementary files
         * stored locally are supported.
         */
        reference_type: Aliased(str),
        /**
         * The external reference or the Digital Object Identifier (DOI).
         * This field is not relevant for local files.
         */
        reference: str,
        /**
         * The type of object that the external reference points to, usually
         * a single file or an archive.
         */
        refers_to: Aliased(str),
        /**
         * The Uniform Resource Locator (URL) corresponding to the external reference (DOI).
         * This URL should link to the corresponding downloadable file or archive and is provided
         * to enable automated software to download the referenced file or archive.
         */
        associated_url: str,
    },
    /**
     * Category provides details regarding external files. The IHM_EXTERNAL_REFERENCE_INFO
     * category captures the top-level details regarding external data sources.
     * This category captures the specific details regarding externally stored files
     * related to the particular I/H model entry.
     */
    ihm_external_files: {
        /**
         * A unique identifier for each external file.
         */
        id: int,
        /**
         * A pointer to the source of the external file - either DOI or locally stored.
         * This data item is a pointer to _ihm_external_reference_info.reference_id in the
         * IHM_EXTERNAL_REFERENCE_INFO category.
         */
        reference_id: int,
        /**
         * The relative path (including filename) for each external file.
         * Absolute paths (starting with "/") are not permitted.
         * This is required for identifying individual files from within
         * a tar-zipped archive file or for identifying supplementary local
         * files organized within a directory structure.
         * This data item assumes a POSIX-like directory structure or file path.
         */
        file_path: str,
        /**
         * The type of content in the file.
         */
        content_type: Aliased(str),
        /**
         * Storage size of the external file in bytes.
         */
        file_size_bytes: float,
        /**
         * Additional textual details regarding the external file.
         */
        details: str,
    },
    /**
     * Category provides additional details regarding input data hosted externally
     * at other resources.
     */
    ihm_dataset_external_reference: {
        /**
         * A unique identifier for the external data.
         */
        id: int,
        /**
         * Identifier to the dataset list used in the I/H modeling.
         * This data item is a pointer to the _ihm_dataset_list.id in the
         * IHM_DATASET_LIST category.
         */
        dataset_list_id: int,
        /**
         * The file id corresponding to this external data file.
         * This data item is a pointer to _ihm_external_files.id
         * in the IHM_EXTERNAL_FILES category.
         */
        file_id: int,
    },
    /**
     * Data items in the IHM_LOCALIZATION_DENSITY_FILES category records the
     * details of files that provide information regarding localization densities
     * of ensembles. These may be stored externally as local files or linked via
     * DOI and can be in any accepted format that provides volume information
     * (CCP4, MRC, etc.).
     */
    ihm_localization_density_files: {
        /**
         * A unique identifier.
         */
        id: int,
        /**
         * The file id for the externally stored localization density file.
         * This data item is a pointer to _ihm_external_files.id
         * in the IHM_EXTERNAL_FILES category.
         */
        file_id: int,
        /**
         * The ensemble identifier for the ensemble, for which the localization density is provided.
         * This data item is a pointer to _ihm_ensemble_info.ensemble_id in the IHM_ENSEMBLE_INFO category.
         */
        ensemble_id: int,
        /**
         * The entity identifier corresponding to this localization density.
         * This data item is a pointer to _entity.id in the ENTITY category.
         */
        entity_id: str,
        /**
         * The identifier for the polymeric segment corresponding to this
         * localization density.
         * This data item is a pointer to _ihm_entity_poly_segment.id in the
         * IHM_ENTITY_POLY_SEGMENT category.
         */
        entity_poly_segment_id: int,
        /**
         * An asym/strand identifier corresponding to this localization density.
         * This data item is a pointer to _struct_asym.id in the STRUCT_ASYM category.
         */
        asym_id: str,
    },
    /**
     * Data items in the IHM_PREDICTED_CONTACT_RESTRAINT category records the
     * list of predicted contacts used in the integrative modeling experiment.
     * This has been adapted from the widely used CASP RR format
     * (http://www.predictioncenter.org/casp8/index.cgi?page=format#RR).
     * These contacts may be derived from various computational tools.
     * The software information can be provided in the SOFTWARE category.
     */
    ihm_predicted_contact_restraint: {
        /**
         * A unique identifier for the predicted contact restraint.
         */
        id: int,
        /**
         * An identifier to group the predicted contacts.
         */
        group_id: int,
        /**
         * The entity identifier for the first monomer partner in the predicted contact.
         * This data item is a pointer to _entity_poly_seq.entity_id in the ENTITY_POLY_SEQ category.
         */
        entity_id_1: str,
        /**
         * The entity identifier for the second monomer partner in the predicted contact.
         * This data item is a pointer to _entity_poly_seq.entity_id in the ENTITY_POLY_SEQ category.
         */
        entity_id_2: str,
        /**
         * An asym/strand identifier for the first monomer partner in the predicted contact.
         * This data item is a pointer to _struct_asym.id in the
         * STRUCT_ASYM category.
         */
        asym_id_1: str,
        /**
         * An asym/strand identifier for the second monomer partner in the predicted contact.
         * This data item is a pointer to _struct_asym.id in the
         * STRUCT_ASYM category.
         */
        asym_id_2: str,
        /**
         * The component identifier for the first monomer partner in the predicted contact.
         * This data item is a pointer to _entity_poly_seq.mon_id in the ENTITY_POLY_SEQ category.
         */
        comp_id_1: str,
        /**
         * The component identifier for the second monomer partner in the predicted contact.
         * This data item is a pointer to _entity_poly_seq.mon_id in the ENTITY_POLY_SEQ category.
         */
        comp_id_2: str,
        /**
         * The sequence index for the first monomer partner in the predicted contact.
         * This data item is a pointer to _entity_poly_seq.num in the ENTITY_POLY_SEQ category.
         */
        seq_id_1: int,
        /**
         * The sequence index for the second monomer partner in the predicted contact.
         * This data item is a pointer to _entity_poly_seq.num in the ENTITY_POLY_SEQ category.
         */
        seq_id_2: int,
        /**
         * If _ihm_predicted_contact_restraint.model_granularity is by-residue, then indicate the atom
         * used to represent the first monomer partner in three-dimension. Default is the C-alpha atom.
         */
        rep_atom_1: Aliased(str),
        /**
         * If _ihm_predicted_contact_restraint.model_granularity is by-residue, then indicate the atom
         * used to represent the second monomer partner in three-dimension. Default is the C-alpha atom.
         */
        rep_atom_2: Aliased(str),
        /**
         * The lower limit to the distance threshold applied to this predicted contact restraint
         * in the integrative modeling task.
         */
        distance_lower_limit: float,
        /**
         * The upper limit to the distance threshold applied to this predicted contact restraint
         * in the integrative modeling task.
         */
        distance_upper_limit: float,
        /**
         * The real number that indicates the probability that the predicted distance restraint
         * is correct. This number should fall between 0.0 and 1.0.
         */
        probability: float,
        /**
         * The type of distance restraint applied.
         */
        restraint_type: Aliased(str),
        /**
         * The granularity of the predicted contact as applied to the multi-scale model.
         */
        model_granularity: Aliased(str),
        /**
         * Identifier to the predicted contacts dataset.
         * This data item is a pointer to the _ihm_dataset_list.id in the
         * IHM_DATASET_LIST category.
         */
        dataset_list_id: int,
        /**
         * Identifier to the software used to obtain the predicted contacts dataset.
         * This data item is a pointer to the _software.pdbx_ordinal in the
         * SOFTWARE category.
         */
        software_id: int,
    },
    /**
     * Data items in the IHM_CROSS_LINK_LIST category records the
     * list of spatial restraints derived from chemical crosslinking
     * experiment.
     */
    ihm_cross_link_list: {
        /**
         * A unique identifier for the cross link restraint.
         */
        id: int,
        /**
         * An identifier for a set of ambiguous crosslink restraints.
         * Handles experimental uncertainties in the identities of
         * crosslinked residues.
         */
        group_id: int,
        /**
         * A text description of molecular entity 1.
         */
        entity_description_1: str,
        /**
         * A text description of molecular entity 2.
         */
        entity_description_2: str,
        /**
         * The entity identifier for the first monomer partner in the cross link
         * This data item is a pointer to _entity_poly_seq.entity_id in the ENTITY_POLY_SEQ category.
         */
        entity_id_1: str,
        /**
         * The entity identifier for the second monomer partner in the cross link
         *
         * This data item is a pointer to _entity_poly_seq.entity_id in the ENTITY_POLY_SEQ category.
         */
        entity_id_2: str,
        /**
         * The component identifier for the first monomer partner in the cross link.
         *
         * This data item is a pointer to _entity_poly_seq.mon_id in the ENTITY_POLY_SEQ category.
         */
        comp_id_1: str,
        /**
         * The component identifier for the second monomer partner in the cross link.
         *
         * This data item is a pointer to _entity_poly_seq.mon_id in the ENTITY_POLY_SEQ category.
         */
        comp_id_2: str,
        /**
         * The sequence index for the first monomer partner in the cross link.
         *
         * This data item is a pointer to _entity_poly_seq.num in the ENTITY_POLY_SEQ category.
         */
        seq_id_1: int,
        /**
         * The sequence index for the second monomer partner in the cross link.
         *
         * This data item is a pointer to _entity_poly_seq.num in the ENTITY_POLY_SEQ category.
         */
        seq_id_2: int,
        /**
         * The type of crosslinker used.
         */
        linker_type: Aliased(str),
        /**
         * Identifier to the crosslinking dataset.
         * This data item is a pointer to the _ihm_dataset_list.id in the
         * IHM_DATASET_LIST category.
         */
        dataset_list_id: int,
    },
    /**
     * Data items in the IHM_CROSS_LINK_RESTRAINT category enumerates the
     * implementation details of the chemical crosslinking restraints in
     * the integrative modeling. This category holds the details of how
     * the experimentally derived crosslinks are applied in the modeling.
     */
    ihm_cross_link_restraint: {
        /**
         * A unique identifier for the cross link record.
         */
        id: int,
        /**
         * An identifier for a set of ambiguous cross-links.
         * Handles implementation uncertainties related to multiple copies of subunit.
         * This data item is a pointer to _ihm_cross_link_list.id in the
         * IHM_CROSS_LINK_LIST category.
         */
        group_id: int,
        /**
         * The entity identifier for the first monomer partner in the cross link
         *
         * This data item is a pointer to _entity_poly_seq.entity_id in the ENTITY_POLY_SEQ category
         * and the _ihm_cross_link_restraint.entity_id_1 in the IHM_CROSS_LINK_RESTRAINT category.
         */
        entity_id_1: str,
        /**
         * The entity identifier for the second monomer partner in the cross link
         *
         * This data item is a pointer to _entity_poly_seq.entity_id in the ENTITY_POLY_SEQ category
         * and the _ihm_cross_link_restraint.entity_id_2 in the IHM_CROSS_LINK_RESTRAINT category.
         */
        entity_id_2: str,
        /**
         * An asym/strand identifier for the first monomer partner in the cross-link.
         *
         * This data item is a pointer to _struct_asym.id in the
         * STRUCT_ASYM category.
         */
        asym_id_1: str,
        /**
         * An asym/strand identifier for the second monomer partner in the cross-link.
         *
         * This data item is a pointer to _struct_asym.id in the
         * STRUCT_ASYM category.
         */
        asym_id_2: str,
        /**
         * The component identifier for the first monomer partner in the cross link.
         *
         * This data item is a pointer to _entity_poly_seq.mon_id in the ENTITY_POLY_SEQ category
         * and the _ihm_cross_link_restraint.comp_id_1 in the IHM_CROSS_LINK_RESTRAINT category.
         */
        comp_id_1: str,
        /**
         * The component identifier for the second monomer partner in the cross link.
         *
         * This data item is a pointer to _entity_poly_seq.mon_id in the ENTITY_POLY_SEQ category
         * and the _ihm_cross_link_restraint.comp_id_2 in the IHM_CROSS_LINK_RESTRAINT category.
         */
        comp_id_2: str,
        /**
         * The sequence index for the first monomer partner in the cross link.
         *
         * This data item is a pointer to _entity_poly_seq.num in the ENTITY_POLY_SEQ category
         * and the _ihm_cross_link_restraint.seq_id_1 in the IHM_CROSS_LINK_RESTRAINT category.
         */
        seq_id_1: int,
        /**
         * The sequence index for the second monomer partner in the cross link.
         *
         * This data item is a pointer to _entity_poly_seq.num in the ENTITY_POLY_SEQ category
         * and the _ihm_cross_link_restraint.seq_id_2 in the IHM_CROSS_LINK_RESTRAINT category.
         */
        seq_id_2: int,
        /**
         * The atom identifier for the first monomer partner in the cross link.
         * This data item is a pointer to _chem_comp_atom.atom_id in the
         * CHEM_COMP_ATOM category.
         */
        atom_id_1: str,
        /**
         * The atom identifier for the second monomer partner in the cross link.
         * This data item is a pointer to _chem_comp_atom.atom_id in the
         * CHEM_COMP_ATOM category.
         */
        atom_id_2: str,
        /**
         * The type of the cross link restraint applied.
         */
        restraint_type: Aliased(str),
        /**
         * The cross link conditionality.
         */
        conditional_crosslink_flag: Aliased(str),
        /**
         * The coarse-graining information for the crosslink implementation.
         */
        model_granularity: Aliased(str),
        /**
         * The distance threshold applied to this crosslink in the integrative modeling task.
         */
        distance_threshold: float,
        /**
         * The uncertainty in the crosslinking experimental data;
         * may be approximated to the false positive rate.
         */
        psi: float,
        /**
         * The uncertainty in the position of residue 1 in the crosslink
         * arising due to the multi-scale nature of the model represention.
         */
        sigma_1: float,
        /**
         * The uncertainty in the position of residue 2 in the crosslink
         * arising due to the multi-scale nature of the model represention.
         */
        sigma_2: float,
    },
    /**
     * Data items in the IHM_CROSS_LINK_RESULT_PARAMETERS category records the
     * results of the crosslinking restraint parameters in the IHM modeling.
     */
    ihm_cross_link_result_parameters: {
        /**
         * A unique identifier for the restraint/model combination.
         */
        id: int,
        /**
         * An identifier for the crosslink restraint between a pair of residues.
         * This data item is a pointer to _ihm_cross_link_restraint.id in the
         * IHM_CROSS_LINK_RESTRAINT category.
         */
        restraint_id: int,
        /**
         * The model number corresponding to the cross link result presented.
         * This data item is a pointer to _ihm_model_list.model_id in the
         * IHM_MODEL_LIST category.
         */
        model_id: int,
        /**
         * The uncertainty in the crosslinking experimental data;
         * May be approximated to the false positive rate.
         */
        psi: float,
        /**
         * The uncertainty in the position of residue 1 in the crosslink
         * arising due to the multi-scale nature of the model represention.
         */
        sigma_1: float,
        /**
         * The uncertainty in the position of residue 2 in the crosslink
         * arising due to the multi-scale nature of the model represention.
         */
        sigma_2: float,
    },
    /**
     * Data items in the IHM_2DEM_CLASS_AVERAGE_RESTRAINT category records the
     * details of the 2DEM class averages used in the IHM modeling.
     */
    ihm_2dem_class_average_restraint: {
        /**
         * A unique identifier for the 2dem class average.
         */
        id: int,
        /**
         * Identifier to the 2dem class average dataset.
         * This data item is a pointer to the _ihm_dataset_list.id in the
         * IHM_DATASET_LIST category.
         */
        dataset_list_id: int,
        /**
         * The number of raw micrographs used to obtain the class average.
         */
        number_raw_micrographs: int,
        /**
         * Pixel size width of the 2dem class average image.
         * While fitting the model to the image, _ihm_2dem_class_average_restraint.pixel_size_width
         * is used along with _ihm_2dem_class_average_restraint.pixel_size_height to scale the image.
         */
        pixel_size_width: float,
        /**
         * Pixel size height of the 2dem class average image.
         * While fitting the model to the image, _ihm_2dem_class_average_restraint.pixel_size_height
         * is used along with _ihm_2dem_class_average_restraint.pixel_size_width to scale the image.
         */
        pixel_size_height: float,
        /**
         * Resolution of the 2dem class average.
         */
        image_resolution: float,
        /**
         * A flag that indicates whether or not the 2DEM class average image is segmented i.e.,
         * whether the whole image is used or only a portion of it is used (by masking
         * or by other means) as restraint in the modeling.
         */
        image_segment_flag: Aliased(str),
        /**
         * Number of 2D projections of the model used in the fitting.
         */
        number_of_projections: int,
        /**
         * An indicator to whether the whole assembly that is modeled is fit into the image
         * or if only a subset of the structural assembly is fit into the image.
         * This data item is a pointer to _ihm_struct_assembly.id in the
         * IHM_STRUCT_ASSEMBLY category. The IHM_STRUCT_ASSEMBLY category provides the
         * details regarding the different structural assemblies used in the modeling.
         * The default value for this data item is "1" indicating that the entire assembly
         * being modeled is fit into the EM data.
         */
        struct_assembly_id: int,
        /**
         * Details of how the 2DEM restraint is applied in the modeling algorithm.
         */
        details: str,
    },
    /**
     * Data items in the IHM_2DEM_CLASS_AVERAGE_FITTING category records the
     * details of the fitting of the model to the 2DEM class averages
     * used in the IHM modeling. The following conventions are recommended
     * while generating the rotation matrix and translation vector for
     * transformation.
     *
     * - The model is rotated and translated to fit to the 2DEM image.
     * - The 2DEM image should be in the XY plane.
     * - The lower left image corner (image pixel index 0,0) should be at x,y,z = (0,0,0).
     * - The 2D image is scaled by the _ihm_2dem_class_average_restraint.pixel_size_width
     * and _ihm_2dem_class_average_restraint.pixel_size_height from the
     * IHM_2DEM_CLASS_AVERAGE_RESTRAINT table.
     * - The transformation is applied after the scaling and hence the translation vector
     * should account for the scaling.
     * - There are no specifications for Z translations i.e., how far the image should be
     * from the model while projecting. It may be set to zero.
     */
    ihm_2dem_class_average_fitting: {
        /**
         * A unique identifier for the 2dem class average fitting data.
         */
        id: int,
        /**
         * Identifier to the 2dem class average restraint.
         * This data item is a pointer to the _ihm_2dem_class_average_restraint.id in the
         * IHM_2DEM_CLASS_AVERAGE_RESTRAINT category.
         */
        restraint_id: int,
        /**
         * The model number corresponding to the 2DEM fitting result presented.
         * This data item is a pointer to _ihm_model_list.model_id in the
         * IHM_MODEL_LIST category.
         */
        model_id: int,
        /**
         * The cross correlation coefficient corresponding to the model to image fitting.
         */
        cross_correlation_coefficient: float,
        /**
         * Data item  of the rotation matrix used in the fitting of the model to the image.
         */
        rot_matrix: Matrix(3, 3),
        /**
         * Data item  of the tranlation vector used in the fitting of the model to the image.
         */
        tr_vector: Vector(3),
    },
    /**
     * Data items in the IHM_3DEM_RESTRAINT category records the
     * details of the 3DEM maps used as restraints in the
     * IHM modeling.
     */
    ihm_3dem_restraint: {
        /**
         * A unique identifier for the 3DEM restraint description.
         */
        id: int,
        /**
         * Identifier to the 3DEM map used.
         * This data item is a pointer to the _ihm_dataset_list.id in the
         * IHM_DATASET_LIST category.
         */
        dataset_list_id: int,
        /**
         * The model number corresponding to the 3DEM fitting result presented.
         * This data item is a pointer to _ihm_model_list.model_id in the
         * IHM_MODEL_LIST category.
         */
        model_id: int,
        /**
         * An indicator to whether the whole assembly that is modeled is fit into the 3DEM map
         * or if only a subset of the structural assembly is fit into the map.
         * This data item is a pointer to _ihm_struct_assembly.id in the
         * IHM_STRUCT_ASSEMBLY category. The IHM_STRUCT_ASSEMBLY category provides the
         * details regarding the different structural assemblies used in the modeling.
         * The default value for this data item is "1" indicating that the entire assembly
         * being modeled is fit into the EM map.
         */
        struct_assembly_id: int,
        /**
         * Method used to fit the model to the 3DEM map.
         */
        fitting_method: str,
        /**
         * In case of Gaussian mixture models, the number of gaussians
         * is a parameter used to covert the 3DEM maps and models into
         * GMMs. This captures the level of granularity used in
         * representing the maps and/or models as 3D Gaussians.
         */
        number_of_gaussians: int,
        /**
         * The cross correlation coefficient corresponding to the model to map fitting.
         */
        cross_correlation_coefficient: float,
    },
    /**
     * Data items in the IHM_SAS_RESTRAINT category records the
     * details of the SAS data used as restraints in the
     * IHM modeling.
     */
    ihm_sas_restraint: {
        /**
         * A unique identifier for the SAS restraint description.
         */
        id: int,
        /**
         * Identifier to the SAS data used.
         * This data item is a pointer to the _ihm_dataset_list.id in the
         * IHM_DATASET_LIST category.
         */
        dataset_list_id: int,
        /**
         * The model number corresponding to the SAS fitting result presented.
         * This data item is a pointer to _ihm_model_list.model_id in the
         * IHM_MODEL_LIST category.
         */
        model_id: int,
        /**
         * An indicator to whether the whole assembly that is modeled is fit into the SAS data
         * or if only a subset of the structural assembly is fit into the data.
         * This data item is a pointer to _ihm_struct_assembly.id in the
         * IHM_STRUCT_ASSEMBLY category. The IHM_STRUCT_ASSEMBLY category provides the
         * details regarding the different structural assemblies used in the modeling.
         * The default value for this data item is "1" indicating that the entire assembly
         * being modeled is fit into the SAS data.
         */
        struct_assembly_id: int,
        /**
         * A flag that indicates whether or not the SAS profile is segmented i.e.,
         * whether the whole SAS profile is used or only a portion of it is used
         * (by masking or by other means) as restraint in the modeling.
         */
        profile_segment_flag: Aliased(str),
        /**
         * The type of atoms in the model fit to the SAS data.
         */
        fitting_atom_type: str,
        /**
         * The method used for fitting the model to the SAS data.
         */
        fitting_method: str,
        /**
         * An indicator to single or multiple state fitting.
         */
        fitting_state: Aliased(str),
        /**
         * Radius of gyration obtained from the SAS profile, if used as input restraint.
         */
        radius_of_gyration: float,
        /**
         * The chi value resulting from fitting the model to the SAS data.
         */
        chi_value: float,
        /**
         * Additional details regarding the SAS restraint used.
         */
        details: str,
    },
    /**
     * Data items in the IHM_STARTING_MODEL_COORD category records the coordinates
     * for structural templates used as starting inputs in the integrative model
     * building tasks.
     */
    ihm_starting_model_coord: {
        /**
         * A unique identifier for this coordinate position.
         */
        ordinal_id: int,
        /**
         * The identifier for the starting structural model.
         * This data item is a pointer to _ihm_starting_model_details.starting_model_id
         * in the IHM_STARTING_MODEL_DETAILS category.
         */
        starting_model_id: str,
        /**
         * The group of atoms to which the atom site in the starting model belongs. This data
         * item is provided for compatibility with the original Protein Data Bank format,
         * and only for that purpose.
         */
        group_PDB: Aliased(str),
        /**
         * The serial number for this coordinate position.
         */
        id: int,
        /**
         * The atom type symbol(element symbol) corresponding to this coordinate position.
         */
        type_symbol: str,
        /**
         * The entity identifier corresponding to this coordinate position.
         * This data item is a pointer to _entity.id in the ENTITY category.
         */
        entity_id: str,
        /**
         * The atom identifier/name corresponding to this coordinate position.
         * This data item is a pointer to _chem_comp_atom.atom_id in the
         * CHEM_COMP_ATOM category.
         */
        atom_id: str,
        /**
         * The component identifier corresponding to this coordinate position.
         * This data item is a pointer to _chem_comp.id in the
         * CHEM_COMP category.
         */
        comp_id: str,
        /**
         * The sequence index corresponding this to coordinate position.
         * This data item is a pointer to _entity_poly_seq.num in the ENTITY_POLY_SEQ category.
         */
        seq_id: int,
        /**
         * The asym/strand id corresponding to this coordinate position.
         *
         * This data item is a pointer to _struct_asym.id in the STRUCT_ASYM category.
         */
        asym_id: str,
        /**
         * The Cartesian X component corresponding to this coordinate position.
         */
        Cartn_x: float,
        /**
         * The Cartesian Y component corresponding to this coordinate position.
         */
        Cartn_y: float,
        /**
         * The Cartesian Z component corresponding to this coordinate position.
         */
        Cartn_z: float,
        /**
         * The isotropic temperature factor corresponding to this coordinate position.
         */
        B_iso_or_equiv: float,
    },
    /**
     * Data items in the IHM_SPHERE_OBJ_SITE category records the details
     * of the spherical objects modeled in the integrative structural model.
     */
    ihm_sphere_obj_site: {
        /**
         * A unique identifier for this pseudo atom / sphere object.
         */
        id: int,
        /**
         * The entity identifier corresponding to this sphere object.
         * This data item is a pointer to _entity.id in the ENTITY category.
         */
        entity_id: str,
        /**
         * The leading sequence index corresponding to this sphere object.
         * This data item is a pointer to _entity_poly_seq.num in the ENTITY_POLY_SEQ category.
         */
        seq_id_begin: int,
        /**
         * The trailing sequence index corresponding to this sphere object.
         * This data item is a pointer to _entity_poly_seq.num in the ENTITY_POLY_SEQ category.
         */
        seq_id_end: int,
        /**
         * An asym/strand identifier corresponding to this sphere object.
         * This data item is a pointer to _struct_asym.id in the STRUCT_ASYM category.
         */
        asym_id: str,
        /**
         * The Cartesian X component corresponding to this sphere object.
         */
        Cartn_x: float,
        /**
         * The Cartesian Y component corresponding to this sphere object.
         */
        Cartn_y: float,
        /**
         * The Cartesian Z component corresponding to this sphere object.
         */
        Cartn_z: float,
        /**
         * The radius associated with the primitive sphere object at this position.
         */
        object_radius: float,
        /**
         * The Root Mean Square Fluctuation (RMSF) observed in the primitive
         * sphere object at this position.
         */
        rmsf: float,
        /**
         * The model id corresponding to the sphere object.
         * This data item is a pointer to _ihm_model_list.model_id
         * in the IHM_MODEL_LIST category.
         */
        model_id: int,
    },
    /**
     * Data items in the IHM_GAUSSIAN_OBJ_SITE category records the details
     * of the gaussian objects modeled in the integrative structural model.
     */
    ihm_gaussian_obj_site: {
        /**
         * A unique identifier for this gaussian object in the model.
         */
        id: int,
        /**
         * The entity identifier corresponding to this gaussian object.
         * This data item is a pointer to _entity.id in the ENTITY category.
         */
        entity_id: str,
        /**
         * The leading sequence index corresponding to this gaussian object.
         * This data item is a pointer to _entity_poly_seq.num in the ENTITY_POLY_SEQ category.
         */
        seq_id_begin: int,
        /**
         * The trailing sequence index corresponding to this gaussian object.
         * This data item is a pointer to _entity_poly_seq.num in the ENTITY_POLY_SEQ category.
         */
        seq_id_end: int,
        /**
         * An asym/strand identifier corresponding to this gaussian object.
         * This data item is a pointer to _struct_asym.id in the STRUCT_ASYM category.
         */
        asym_id: str,
        /**
         * The mean Cartesian X component corresponding to this gaussian object.
         */
        mean_Cartn_x: float,
        /**
         * The mean Cartesian Y component corresponding to this gaussian object.
         */
        mean_Cartn_y: float,
        /**
         * The mean Cartesian Z component corresponding to this gaussian object.
         */
        mean_Cartn_z: float,
        /**
         * The weight of the gaussian object.
         */
        weight: float,
        /**
         * Data item  of the covariance matrix representing the Gaussian object.
         */
        covariance_matrix: Matrix(3, 3),
        /**
         * The model id corresponding to the gaussian object.
         * This data item is a pointer to _ihm_model_list.model_id
         * in the IHM_MODEL_LIST category.
         */
        model_id: int,
    },
    /**
     * Data items in the IHM_GAUSSIAN_OBJ_ENSEMBLE category records the details
     * of the gaussian objects representing an ensemble or cluster of models.
     */
    ihm_gaussian_obj_ensemble: {
        /**
         * A unique identifier for this gaussian object.
         */
        id: int,
        /**
         * The entity identifier corresponding to this gaussian object.
         * This data item is a pointer to _entity.id in the ENTITY category.
         */
        entity_id: str,
        /**
         * The leading sequence index corresponding to this gaussian object.
         * This data item is a pointer to _entity_poly_seq.num in the ENTITY_POLY_SEQ category.
         */
        seq_id_begin: int,
        /**
         * The trailing sequence index corresponding to this gaussian object.
         * This data item is a pointer to _entity_poly_seq.num in the ENTITY_POLY_SEQ category.
         */
        seq_id_end: int,
        /**
         * An asym/strand identifier corresponding to this gaussian object.
         * This data item is a pointer to _struct_asym.id in the STRUCT_ASYM category.
         */
        asym_id: str,
        /**
         * The mean Cartesian X component corresponding to this gaussian object.
         */
        mean_Cartn_x: float,
        /**
         * The mean Cartesian Y component corresponding to this gaussian object.
         */
        mean_Cartn_y: float,
        /**
         * The mean Cartesian Z component corresponding to this gaussian object.
         */
        mean_Cartn_z: float,
        /**
         * The weight of the gaussian object.
         */
        weight: float,
        /**
         * Data item  of the covariance matrix representing the Gaussian object.
         */
        covariance_matrix: Matrix(3, 3),
        /**
         * The ensemble id corresponding to the gaussian object.
         * This data item is a pointer to _ihm_ensemble_info.ensemble_id
         * in the IHM_ENSEMBLE_INFO category.
         */
        ensemble_id: int,
    },
    /**
     * IHM_FEATURE_LIST is the high level category that provides defintions
     * to select atoms/residues from polymeric and non-polymeric entities.
     */
    ihm_feature_list: {
        /**
         * A unique identifier for the feature.
         */
        feature_id: int,
        /**
         * The type of feature.
         */
        feature_type: Aliased(str),
        /**
         * The type of entity.
         */
        entity_type: Aliased(str),
    },
    /**
     * Data items in the IHM_POLY_RESIDUE_FEATURE category provides the defintions
     * required to select a specific residue or a set of residues that may or may not be
     * in a contiguous range.
     */
    ihm_poly_residue_feature: {
        /**
         * A unique identifier for the category.
         */
        ordinal_id: int,
        /**
         * An identifier for the selected residue / residue range feature.
         * This data item is a pointer to _ihm_feature_list.feature_id in the
         * IHM_FEATURE_LIST category.
         */
        feature_id: int,
        /**
         * The entity identifier for residue / residue range.
         * This data item is a pointer to _entity_poly_seq.entity_id in the
         * ENTITY_POLY_SEQ category.
         */
        entity_id: str,
        /**
         * An asym/strand identifier for the residue / residue range, if applicable.
         * This data item is a pointer to _struct_asym.id in the
         * STRUCT_ASYM category.
         */
        asym_id: str,
        /**
         * The component identifier of the beginning residue / residue range.
         * This data item is a pointer to _entity_poly_seq.mon_id in the ENTITY_POLY_SEQ category.
         */
        comp_id_begin: str,
        /**
         * The component identifier of the ending residue / residue range.
         * This data item is a pointer to _entity_poly_seq.mon_id in the ENTITY_POLY_SEQ category.
         */
        comp_id_end: str,
        /**
         * The sequence index of the beginning residue / residue range.
         * This data item is a pointer to _entity_poly_seq.num in the ENTITY_POLY_SEQ category.
         */
        seq_id_begin: int,
        /**
         * The sequence index of the ending residue / residue range.
         * This data item is a pointer to _entity_poly_seq.num in the ENTITY_POLY_SEQ category.
         */
        seq_id_end: int,
    },
    /**
     * Data items in the IHM_DERIVED_DISTANCE_RESTRAINT category records the
     * list of distance restraints used in the integrative modeling experiment.
     * These distance redistance restraints may be derived from various kinds of experiments.
     */
    ihm_derived_distance_restraint: {
        /**
         * A unique identifier for the derived distance restraint.
         */
        id: int,
        /**
         * An identifier to group the distance restraints.
         * This can be the same as the _ihm_derived_distance_restraint.id in case
         * the some of the restraints are not grouped.
         */
        group_id: int,
        /**
         * The feature identifier for the first partner in the distance restraint.
         * This data item is a pointer to _ihm_feature_list.feature_id in the
         * IHM_FEATURE_LIST category.
         */
        feature_id_1: int,
        /**
         * The feature identifier for the second partner in the distance restraint.
         * This data item is a pointer to _ihm_feature_list.feature_id in the
         * IHM_FEATURE_LIST category.
         */
        feature_id_2: int,
        /**
         * If a group of atoms or residues are restrained, this data item defines
         * the conditionality based on which the restraint is applied in the modeling.
         */
        group_conditionality: Aliased(str),
        /**
         * The fraction of randomly excluded distance restraints during modeling.
         * In HADDOCK, this is used along with ambiguous interface restraints (AIRs)
         * to account for uncertainties in AIRs.
         */
        random_exclusion_fraction: float,
        /**
         * The upper limit to the distance threshold applied to this distance restraint
         * in the integrative modeling task.
         */
        distance_upper_limit: float,
        /**
         * The type of distance restraint applied.
         */
        restraint_type: Aliased(str),
        /**
         * Identifier to the input data from which the distance restraint is derived.
         * This data item is a pointer to the _ihm_dataset_list.id in the
         * IHM_DATASET_LIST category.
         * This data item may not be applicable for all cases. For example, in case of
         * ambiguous interface restraints where the interface residues are identified
         * from multiple experiments, the reference to the _ihm_dataset_list.id is
         * handled in the IHM_INTERFACE_RESIDUE_FEATURE category rather than here.
         */
        dataset_list_id: int,
    },
};
;
//# sourceMappingURL=mmcif.js.map

/***/ }),

/***/ "./lib/mol-io/reader/cif/text/parser.js":
/*!**********************************************!*\
  !*** ./lib/mol-io/reader/cif/text/parser.js ***!
  \**********************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return parse; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _data_model__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../data-model */ "./lib/mol-io/reader/cif/data-model.js");
/* harmony import */ var _common_text_tokenizer__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../common/text/tokenizer */ "./lib/mol-io/reader/common/text/tokenizer.js");
/* harmony import */ var _result__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../result */ "./lib/mol-io/reader/result.js");
/* harmony import */ var _mol_task__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../../../mol-task */ "./lib/mol-task/index.js");
/**
 * Copyright (c) 2017-2019 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author David Sehnal <david.sehnal@gmail.com>
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */

/**
 * mmCIF parser.
 *
 * Trying to be as close to the specification http://www.iucr.org/resources/cif/spec/version1.1/cifsyntax
 *
 * Differences I'm aware of:
 * - Except keywords (data_, loop_, save_) everything is case sensitive.
 * - The tokens . and ? are treated the same as the values '.' and '?'.
 * - Ignores \ in the multiline values:
 *     ;abc\
 *     efg
 *     ;
 *   should have the value 'abcefg' but will have the value 'abc\\nefg' instead.
 *   Post processing of this is left to the consumer of the data.
 * - Similarly, things like punctuation (\', ..) are left to be processed by the user if needed.
 *
 */




/**
 * Eat everything until a whitespace/newline occurs.
 */
function eatValue(state) {
    while (state.position < state.length) {
        switch (state.data.charCodeAt(state.position)) {
            case 9: // \t
            case 10: // \n
            case 13: // \r
            case 32: // ' '
                state.tokenEnd = state.position;
                return;
            default:
                ++state.position;
                break;
        }
    }
    state.tokenEnd = state.position;
}
/**
 * Eats an escaped value. Handles the "degenerate" cases as well.
 *
 * "Degenerate" cases:
 * - 'xx'x' => xx'x
 * - 'xxxNEWLINE => 'xxx
 *
 */
function eatEscaped(state, esc) {
    var next, c;
    ++state.position;
    while (state.position < state.length) {
        c = state.data.charCodeAt(state.position);
        if (c === esc) {
            next = state.data.charCodeAt(state.position + 1);
            switch (next) {
                case 9: // \t
                case 10: // \n
                case 13: // \r
                case 32: // ' '
                    // get rid of the quotes.
                    state.tokenStart++;
                    state.tokenEnd = state.position;
                    state.isEscaped = true;
                    ++state.position;
                    return;
                default:
                    if (next === void 0) { // = "end of stream"
                        // get rid of the quotes.
                        state.tokenStart++;
                        state.tokenEnd = state.position;
                        state.isEscaped = true;
                        ++state.position;
                        return;
                    }
                    ++state.position;
                    break;
            }
        }
        else {
            // handle 'xxxNEWLINE => 'xxx
            if (c === 10 || c === 13) {
                state.tokenEnd = state.position;
                return;
            }
            ++state.position;
        }
    }
    state.tokenEnd = state.position;
}
/**
 * Eats an escaped value "triple quote" (''') value.
 */
function eatTripleQuote(state) {
    // skip the '''
    state.position += 3;
    while (state.position < state.length) {
        if (state.data.charCodeAt(state.position) === 39 /* ' */ && isTripleQuoteAtPosition(state)) {
            // get rid of the quotes.
            state.tokenStart += 3;
            state.tokenEnd = state.position;
            state.isEscaped = true;
            state.position += 3;
            return;
        }
        ++state.position;
    }
    state.tokenEnd = state.position;
}
/**
 * Eats a multiline token of the form NL;....NL;
 */
function eatMultiline(state) {
    var prev = 59, pos = state.position + 1, c;
    while (pos < state.length) {
        c = state.data.charCodeAt(pos);
        if (c === 59 && (prev === 10 || prev === 13)) { // ;, \n \r
            state.position = pos + 1;
            // get rid of the ;
            state.tokenStart++;
            // remove trailing newlines
            pos--;
            c = state.data.charCodeAt(pos);
            while (c === 10 || c === 13) {
                pos--;
                c = state.data.charCodeAt(pos);
            }
            state.tokenEnd = pos + 1;
            state.isEscaped = true;
            return;
        }
        else {
            // handle line numbers
            if (c === 13) { // \r
                state.lineNumber++;
            }
            else if (c === 10 && prev !== 13) { // \r\n
                state.lineNumber++;
            }
            prev = c;
            ++pos;
        }
    }
    state.position = pos;
    return prev;
}
function eatImportGet(state) {
    // _import.get [{'save':orient_matrix  'file':templ_attr.cif}]
    // skipWhitespace(state)
    while (state.position < state.length) {
        switch (state.data.charCodeAt(state.position)) {
            case 93: // ]
                ++state.position;
                state.tokenEnd = state.position;
                state.isImportGet = false;
                return;
            default:
                ++state.position;
                break;
        }
    }
}
/**
 * Skips until \n or \r occurs -- therefore the newlines get handled by the "skipWhitespace" function.
 */
function skipCommentLine(state) {
    while (state.position < state.length) {
        var c = state.data.charCodeAt(state.position);
        if (c === 10 || c === 13) {
            return;
        }
        ++state.position;
    }
}
/**
 * Skips all the whitespace - space, tab, newline, CR
 * Handles incrementing line count.
 */
function skipWhitespace(state) {
    var prev = 10;
    while (state.position < state.length) {
        var c = state.data.charCodeAt(state.position);
        switch (c) {
            case 9: // '\t'
            case 32: // ' '
                prev = c;
                ++state.position;
                break;
            case 10: // \n
                // handle \r\n
                if (prev !== 13) {
                    ++state.lineNumber;
                }
                prev = c;
                ++state.position;
                break;
            case 13: // \r
                prev = c;
                ++state.position;
                ++state.lineNumber;
                break;
            default:
                return prev;
        }
    }
    return prev;
}
/**
 * Returns true if there are two consecutive ' in +1 and +2 positions.
 */
function isTripleQuoteAtPosition(state) {
    if (state.length - state.position < 2)
        return false;
    if (state.data.charCodeAt(state.position + 1) !== 39)
        return false; // '
    if (state.data.charCodeAt(state.position + 2) !== 39)
        return false; // '
    return true;
}
function isData(state) {
    // here we already assume the 5th char is _ and that the length >= 5
    // d/D
    var c = state.data.charCodeAt(state.tokenStart);
    if (c !== 68 && c !== 100)
        return false;
    // a/A
    c = state.data.charCodeAt(state.tokenStart + 1);
    if (c !== 65 && c !== 97)
        return false;
    // t/t
    c = state.data.charCodeAt(state.tokenStart + 2);
    if (c !== 84 && c !== 116)
        return false;
    // a/A
    c = state.data.charCodeAt(state.tokenStart + 3);
    if (c !== 65 && c !== 97)
        return false;
    return true;
}
function isSave(state) {
    // here we already assume the 5th char is _ and that the length >= 5
    // s/S
    var c = state.data.charCodeAt(state.tokenStart);
    if (c !== 83 && c !== 115)
        return false;
    // a/A
    c = state.data.charCodeAt(state.tokenStart + 1);
    if (c !== 65 && c !== 97)
        return false;
    // v/V
    c = state.data.charCodeAt(state.tokenStart + 2);
    if (c !== 86 && c !== 118)
        return false;
    // e/E
    c = state.data.charCodeAt(state.tokenStart + 3);
    if (c !== 69 && c !== 101)
        return false;
    return true;
}
function isLoop(state) {
    // here we already assume the 5th char is _ and that the length >= 5
    if (state.tokenEnd - state.tokenStart !== 5)
        return false;
    // l/L
    var c = state.data.charCodeAt(state.tokenStart);
    if (c !== 76 && c !== 108)
        return false;
    // o/O
    c = state.data.charCodeAt(state.tokenStart + 1);
    if (c !== 79 && c !== 111)
        return false;
    // o/O
    c = state.data.charCodeAt(state.tokenStart + 2);
    if (c !== 79 && c !== 111)
        return false;
    // p/P
    c = state.data.charCodeAt(state.tokenStart + 3);
    if (c !== 80 && c !== 112)
        return false;
    return true;
}
function isImportGet(state) {
    // _import.get [{'save':orient_matrix  'file':templ_attr.cif}]
    if (state.tokenEnd - state.tokenStart !== 11)
        return false;
    if (state.data.charCodeAt(state.tokenStart + 1) !== 105)
        return false; // i
    if (state.data.charCodeAt(state.tokenStart + 2) !== 109)
        return false; // m
    if (state.data.charCodeAt(state.tokenStart + 3) !== 112)
        return false; // p
    if (state.data.charCodeAt(state.tokenStart + 4) !== 111)
        return false; // o
    if (state.data.charCodeAt(state.tokenStart + 5) !== 114)
        return false; // r
    if (state.data.charCodeAt(state.tokenStart + 6) !== 116)
        return false; // t
    if (state.data.charCodeAt(state.tokenStart + 7) !== 46)
        return false; // .
    if (state.data.charCodeAt(state.tokenStart + 8) !== 103)
        return false; // g
    if (state.data.charCodeAt(state.tokenStart + 9) !== 101)
        return false; // e
    if (state.data.charCodeAt(state.tokenStart + 10) !== 116)
        return false; // t
    return true;
}
/**
 * Checks if the current token shares the namespace with string at <start,end).
 */
function isNamespace(state, start, end) {
    var i, nsLen = end - start, offset = state.tokenStart - start, tokenLen = state.tokenEnd - state.tokenStart;
    if (tokenLen < nsLen)
        return false;
    for (i = start; i < end; ++i) {
        if (state.data.charCodeAt(i) !== state.data.charCodeAt(i + offset))
            return false;
    }
    if (nsLen === tokenLen)
        return true;
    if (state.data.charCodeAt(i + offset) === 46) { // .
        return true;
    }
    return false;
}
/**
 * Returns the index of '.' in the current token. If no '.' is present, returns currentTokenEnd.
 */
function getNamespaceEnd(state) {
    var i;
    for (i = state.tokenStart; i < state.tokenEnd; ++i) {
        if (state.data.charCodeAt(i) === 46)
            return i;
    }
    return i;
}
/**
 * Get the namespace string. endIndex is obtained by the getNamespaceEnd() function.
 */
function getNamespace(state, endIndex) {
    return state.data.substring(state.tokenStart, endIndex);
}
/**
 * Returns true if the current token contain no '.', otherwise returns false.
 */
function isFlatNamespace(state) {
    var i;
    for (i = state.tokenStart; i < state.tokenEnd; ++i) {
        if (state.data.charCodeAt(i) === 46)
            return false;
    }
    return true;
}
/**
 * String representation of the current token.
 */
function getTokenString(state) {
    return state.data.substring(state.tokenStart, state.tokenEnd);
}
/**
 * Move to the next token.
 */
function moveNextInternal(state) {
    var prev = skipWhitespace(state);
    if (state.position >= state.length) {
        state.tokenType = 6 /* End */;
        return;
    }
    state.tokenStart = state.position;
    state.tokenEnd = state.position;
    state.isEscaped = false;
    var c = state.data.charCodeAt(state.position);
    switch (c) {
        case 35: // #, comment
            skipCommentLine(state);
            state.tokenType = 5 /* Comment */;
            break;
        case 39: // ', escaped value
            if (isTripleQuoteAtPosition(state)) {
                eatTripleQuote(state);
                state.tokenType = 3 /* Value */;
                break;
            }
        case 34: // ", escaped value
            eatEscaped(state, c);
            state.tokenType = 3 /* Value */;
            break;
        case 59: // ;, possible multiline value
            // multiline value must start at the beginning of the line.
            if (prev === 10 || prev === 13) { // /n or /r
                eatMultiline(state);
            }
            else {
                eatValue(state);
            }
            state.tokenType = 3 /* Value */;
            break;
        default:
            if (state.isImportGet) {
                eatImportGet(state);
            }
            else {
                eatValue(state);
            }
            // escaped is always Value
            if (state.isEscaped) {
                state.tokenType = 3 /* Value */;
                // _ means column name, including _import.get
            }
            else if (state.data.charCodeAt(state.tokenStart) === 95) { // _
                if (state.inSaveFrame && isImportGet(state)) {
                    state.isImportGet = true;
                }
                state.tokenType = 4 /* ColumnName */;
                // 5th char needs to be _ for data_, save_ or loop_
            }
            else if (state.tokenEnd - state.tokenStart >= 5 && state.data.charCodeAt(state.tokenStart + 4) === 95) {
                if (isData(state))
                    state.tokenType = 0 /* Data */;
                else if (isSave(state))
                    state.tokenType = 1 /* Save */;
                else if (isLoop(state))
                    state.tokenType = 2 /* Loop */;
                else
                    state.tokenType = 3 /* Value */;
                // all other tests failed, we are at Value token.
            }
            else {
                state.tokenType = 3 /* Value */;
            }
            break;
    }
}
/**
 * Moves to the next non-comment token.
 */
function moveNext(state) {
    moveNextInternal(state);
    while (state.tokenType === 5 /* Comment */)
        moveNextInternal(state);
}
function createTokenizer(data, runtimeCtx) {
    return {
        data: data,
        length: data.length,
        position: 0,
        tokenStart: 0,
        tokenEnd: 0,
        tokenType: 6 /* End */,
        lineNumber: 1,
        isEscaped: false,
        isImportGet: false,
        inSaveFrame: false,
        runtimeCtx: runtimeCtx
    };
}
function FrameContext() {
    return { categoryNames: [], categoryData: Object.create(null) };
}
function CifCategories(categoryNames, categoryData) {
    var categories = Object.create(null);
    for (var _i = 0, categoryNames_1 = categoryNames; _i < categoryNames_1.length; _i++) {
        var name_1 = categoryNames_1[_i];
        var d = categoryData[name_1];
        categories[name_1] = _data_model__WEBPACK_IMPORTED_MODULE_1__["CifCategory"](d.name, d.rowCount, d.fieldNames, d.fields);
    }
    return categories;
}
function CifBlock(ctx, header, saveFrames) {
    return _data_model__WEBPACK_IMPORTED_MODULE_1__["CifBlock"](ctx.categoryNames, CifCategories(ctx.categoryNames, ctx.categoryData), header, saveFrames);
}
function CifSaveFrame(ctx, header) {
    return _data_model__WEBPACK_IMPORTED_MODULE_1__["CifBlock"](ctx.categoryNames, CifCategories(ctx.categoryNames, ctx.categoryData), header);
}
function addFields(ctx, name, rowCount, fieldNames, fields) {
    var _a;
    if (name in ctx.categoryData) {
        var cat = ctx.categoryData[name];
        (_a = cat.fieldNames).push.apply(_a, fieldNames);
        Object.assign(cat.fields, fields);
    }
    else {
        ctx.categoryData[name] = { name: name, rowCount: rowCount, fieldNames: fieldNames, fields: fields };
        ctx.categoryNames.push(name);
    }
}
/**
 * Reads a category containing a single row.
 */
function handleSingle(tokenizer, ctx) {
    var nsStart = tokenizer.tokenStart, nsEnd = getNamespaceEnd(tokenizer);
    var name = getNamespace(tokenizer, nsEnd);
    var fields = Object.create(null);
    var fieldNames = [];
    var readingNames = true;
    while (readingNames) {
        if (tokenizer.tokenType !== 4 /* ColumnName */ || !isNamespace(tokenizer, nsStart, nsEnd)) {
            readingNames = false;
            break;
        }
        var fieldName = getTokenString(tokenizer).substring(name.length + 1);
        moveNext(tokenizer);
        if (tokenizer.tokenType !== 3 /* Value */) {
            return {
                hasError: true,
                errorLine: tokenizer.lineNumber,
                errorMessage: 'Expected value.'
            };
        }
        fields[fieldName] = _data_model__WEBPACK_IMPORTED_MODULE_1__["CifField"].ofTokens({ data: tokenizer.data, indices: [tokenizer.tokenStart, tokenizer.tokenEnd], count: 1 });
        fieldNames[fieldNames.length] = fieldName;
        moveNext(tokenizer);
    }
    addFields(ctx, name.substr(1), 1, fieldNames, fields);
    return {
        hasError: false,
        errorLine: 0,
        errorMessage: ''
    };
}
function readLoopChunk(chunkSize, state) {
    var tokenizer = state.tokenizer, tokens = state.tokens, fieldCount = state.fieldCount;
    var tokenCount = state.tokenCount;
    var counter = 0;
    while (tokenizer.tokenType === 3 /* Value */ && counter < chunkSize) {
        _common_text_tokenizer__WEBPACK_IMPORTED_MODULE_2__["TokenBuilder"].add(tokens[(tokenCount++) % fieldCount], tokenizer.tokenStart, tokenizer.tokenEnd);
        moveNext(tokenizer);
        counter++;
    }
    state.tokenCount = tokenCount;
    return counter;
}
function updateLoopChunk(ctx, state) {
    return ctx.update({ message: 'Parsing...', current: state.tokenizer.position, max: state.tokenizer.data.length });
}
// const readLoopChunks = ChunkedSubtask(1000000,
//     (size, state: LoopReadState) => readLoopChunk(state, size),
//     (ctx, state) => ctx.update({ message: 'Parsing...', current: state.tokenizer.position, max: state.tokenizer.data.length }));
/**
 * Reads a loop.
 */
function handleLoop(tokenizer, ctx) {
    return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"])(this, void 0, void 0, function () {
        var loopLine, name, isFlat, fieldNames, rowCountEstimate, tokens, fieldCount, i, state, rowCount, i, fields, fields, i;
        return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__generator"])(this, function (_a) {
            switch (_a.label) {
                case 0:
                    loopLine = tokenizer.lineNumber;
                    moveNext(tokenizer);
                    name = getNamespace(tokenizer, getNamespaceEnd(tokenizer));
                    isFlat = isFlatNamespace(tokenizer);
                    fieldNames = [];
                    while (tokenizer.tokenType === 4 /* ColumnName */) {
                        fieldNames[fieldNames.length] = isFlat
                            ? getTokenString(tokenizer)
                            : getTokenString(tokenizer).substring(name.length + 1);
                        moveNext(tokenizer);
                    }
                    rowCountEstimate = name === '_atom_site' ? (tokenizer.data.length / 100) | 0 : 32;
                    tokens = [];
                    fieldCount = fieldNames.length;
                    for (i = 0; i < fieldCount; i++)
                        tokens[i] = _common_text_tokenizer__WEBPACK_IMPORTED_MODULE_2__["TokenBuilder"].create(tokenizer.data, rowCountEstimate);
                    state = {
                        fieldCount: fieldCount,
                        tokenCount: 0,
                        tokenizer: tokenizer,
                        tokens: tokens
                    };
                    return [4 /*yield*/, Object(_mol_task__WEBPACK_IMPORTED_MODULE_4__["chunkedSubtask"])(tokenizer.runtimeCtx, 1000000, state, readLoopChunk, updateLoopChunk)];
                case 1:
                    _a.sent();
                    if (state.tokenCount % fieldCount !== 0) {
                        return [2 /*return*/, {
                                hasError: true,
                                errorLine: tokenizer.lineNumber,
                                errorMessage: "The number of values for loop starting at line " + loopLine + " is not a multiple of the number of columns."
                            }];
                    }
                    rowCount = (state.tokenCount / fieldCount) | 0;
                    if (isFlat) {
                        for (i = 0; i < fieldCount; i++) {
                            fields = { '': _data_model__WEBPACK_IMPORTED_MODULE_1__["CifField"].ofTokens(tokens[i]) };
                            addFields(ctx, fieldNames[i].substr(1), rowCount, [''], fields);
                        }
                    }
                    else {
                        fields = Object.create(null);
                        for (i = 0; i < fieldCount; i++) {
                            fields[fieldNames[i]] = _data_model__WEBPACK_IMPORTED_MODULE_1__["CifField"].ofTokens(tokens[i]);
                        }
                        addFields(ctx, name.substr(1), rowCount, fieldNames, fields);
                    }
                    return [2 /*return*/, {
                            hasError: false,
                            errorLine: 0,
                            errorMessage: ''
                        }];
            }
        });
    });
}
/**
 * Creates an error result.
 */
function error(line, message) {
    return _result__WEBPACK_IMPORTED_MODULE_3__["ReaderResult"].error(message, line);
}
/**
 * Creates a data result.
 */
function result(data) {
    return _result__WEBPACK_IMPORTED_MODULE_3__["ReaderResult"].success(data);
}
/**
 * Parses an mmCIF file.
 *
 * @returns CifParserResult wrapper of the result.
 */
function parseInternal(data, runtimeCtx) {
    return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"])(this, void 0, void 0, function () {
        var dataBlocks, tokenizer, blockHeader, blockCtx, saveFrames, saveCtx, saveFrame, saveHeader, token, cat, cat;
        return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__generator"])(this, function (_a) {
            switch (_a.label) {
                case 0:
                    dataBlocks = [];
                    tokenizer = createTokenizer(data, runtimeCtx);
                    blockHeader = '';
                    blockCtx = FrameContext();
                    saveFrames = [];
                    saveCtx = FrameContext();
                    saveFrame = _data_model__WEBPACK_IMPORTED_MODULE_1__["CifSaveFrame"](saveCtx.categoryNames, CifCategories(saveCtx.categoryNames, saveCtx.categoryData), '');
                    saveHeader = '';
                    runtimeCtx.update({ message: 'Parsing...', current: 0, max: data.length });
                    moveNext(tokenizer);
                    _a.label = 1;
                case 1:
                    if (!(tokenizer.tokenType !== 6 /* End */)) return [3 /*break*/, 7];
                    token = tokenizer.tokenType;
                    if (!(token === 0 /* Data */)) return [3 /*break*/, 2];
                    if (tokenizer.inSaveFrame) {
                        return [2 /*return*/, error(tokenizer.lineNumber, 'Unexpected data block inside a save frame.')];
                    }
                    if (blockCtx.categoryNames.length > 0) {
                        dataBlocks.push(CifBlock(blockCtx, blockHeader, saveFrames));
                    }
                    blockHeader = data.substring(tokenizer.tokenStart + 5, tokenizer.tokenEnd);
                    blockCtx = FrameContext();
                    saveFrames = [];
                    moveNext(tokenizer);
                    return [3 /*break*/, 6];
                case 2:
                    if (!(token === 1 /* Save */)) return [3 /*break*/, 3];
                    if (tokenizer.tokenEnd - tokenizer.tokenStart === 5) { // end of save frame
                        if (saveCtx.categoryNames.length > 0) {
                            saveFrames[saveFrames.length] = CifSaveFrame(saveCtx, saveHeader);
                        }
                        tokenizer.inSaveFrame = false;
                    }
                    else { // start of save frame
                        if (tokenizer.inSaveFrame) {
                            return [2 /*return*/, error(tokenizer.lineNumber, 'Save frames cannot be nested.')];
                        }
                        tokenizer.inSaveFrame = true;
                        saveHeader = data.substring(tokenizer.tokenStart + 5, tokenizer.tokenEnd);
                        saveCtx = FrameContext();
                        // saveFrame = CifSaveFrame(saveCtx, saveHeader);
                    }
                    moveNext(tokenizer);
                    return [3 /*break*/, 6];
                case 3:
                    if (!(token === 2 /* Loop */)) return [3 /*break*/, 5];
                    return [4 /*yield*/, handleLoop(tokenizer, tokenizer.inSaveFrame ? saveCtx : blockCtx)];
                case 4:
                    cat = _a.sent();
                    if (cat.hasError) {
                        return [2 /*return*/, error(cat.errorLine, cat.errorMessage)];
                    }
                    return [3 /*break*/, 6];
                case 5:
                    if (token === 4 /* ColumnName */) {
                        cat = handleSingle(tokenizer, tokenizer.inSaveFrame ? saveCtx : blockCtx);
                        if (cat.hasError) {
                            return [2 /*return*/, error(cat.errorLine, cat.errorMessage)];
                        }
                        // Out of options
                    }
                    else {
                        console.log(tokenizer.tokenType, _common_text_tokenizer__WEBPACK_IMPORTED_MODULE_2__["Tokenizer"].getTokenString(tokenizer));
                        return [2 /*return*/, error(tokenizer.lineNumber, 'Unexpected token. Expected data_, loop_, or data name.')];
                    }
                    _a.label = 6;
                case 6: return [3 /*break*/, 1];
                case 7:
                    // Check if the latest save frame was closed.
                    if (tokenizer.inSaveFrame) {
                        return [2 /*return*/, error(tokenizer.lineNumber, "Unfinished save frame (" + saveFrame.header + ").")];
                    }
                    if (blockCtx.categoryNames.length > 0 || saveFrames.length > 0) {
                        dataBlocks.push(CifBlock(blockCtx, blockHeader, saveFrames));
                    }
                    return [2 /*return*/, result(_data_model__WEBPACK_IMPORTED_MODULE_1__["CifFile"](dataBlocks))];
            }
        });
    });
}
function parse(data) {
    var _this = this;
    return _mol_task__WEBPACK_IMPORTED_MODULE_4__["Task"].create('Parse CIF', function (ctx) { return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"])(_this, void 0, void 0, function () {
        return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__generator"])(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, parseInternal(data, ctx)];
                case 1: return [2 /*return*/, _a.sent()];
            }
        });
    }); });
}
//# sourceMappingURL=parser.js.map

/***/ }),

/***/ "./lib/mol-io/reader/common/text/column/fixed.js":
/*!*******************************************************!*\
  !*** ./lib/mol-io/reader/common/text/column/fixed.js ***!
  \*******************************************************/
/*! exports provided: default, FixedColumn */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return FixedColumnProvider; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FixedColumn", function() { return FixedColumn; });
/* harmony import */ var _mol_data_db__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../../../../mol-data/db */ "./lib/mol-data/db.js");
/* harmony import */ var _tokenizer__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../tokenizer */ "./lib/mol-io/reader/common/text/tokenizer.js");
/* harmony import */ var _number_parser__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../number-parser */ "./lib/mol-io/reader/common/text/number-parser.js");
/**
 * Copyright (c) 2017 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author David Sehnal <david.sehnal@gmail.com>
 */



function FixedColumnProvider(lines) {
    return function (offset, width, type) {
        return FixedColumn(lines, offset, width, type);
    };
}
function FixedColumn(lines, offset, width, schema) {
    var data = lines.data, indices = lines.indices, rowCount = lines.count;
    var type = schema.valueType;
    var value = type === 'str' ? function (row) {
        var s = indices[2 * row] + offset, le = indices[2 * row + 1];
        if (s >= le)
            return '';
        var e = s + width;
        if (e > le)
            e = le;
        return Object(_tokenizer__WEBPACK_IMPORTED_MODULE_1__["trimStr"])(data, s, e);
    } : type === 'int' ? function (row) {
        var s = indices[2 * row] + offset;
        if (s > indices[2 * row + 1])
            return 0;
        return Object(_number_parser__WEBPACK_IMPORTED_MODULE_2__["parseIntSkipLeadingWhitespace"])(data, s, s + width);
    } : function (row) {
        var s = indices[2 * row] + offset;
        if (s > indices[2 * row + 1])
            return 0;
        return Object(_number_parser__WEBPACK_IMPORTED_MODULE_2__["parseFloatSkipLeadingWhitespace"])(data, s, s + width);
    };
    return {
        schema: schema,
        __array: void 0,
        isDefined: true,
        rowCount: rowCount,
        value: value,
        valueKind: function (row) { return 0 /* Present */; },
        toArray: function (params) { return _mol_data_db__WEBPACK_IMPORTED_MODULE_0__["ColumnHelpers"].createAndFillArray(rowCount, value, params); },
        areValuesEqual: function (rowA, rowB) { return value(rowA) === value(rowB); }
    };
}
//# sourceMappingURL=fixed.js.map

/***/ }),

/***/ "./lib/mol-io/reader/common/text/column/token.js":
/*!*******************************************************!*\
  !*** ./lib/mol-io/reader/common/text/column/token.js ***!
  \*******************************************************/
/*! exports provided: default, TokenColumn, areValuesEqualProvider */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return TokenColumnProvider; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "TokenColumn", function() { return TokenColumn; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "areValuesEqualProvider", function() { return areValuesEqualProvider; });
/* harmony import */ var _mol_data_db__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../../../../mol-data/db */ "./lib/mol-data/db.js");
/* harmony import */ var _number_parser__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../number-parser */ "./lib/mol-io/reader/common/text/number-parser.js");
/**
 * Copyright (c) 2017 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author David Sehnal <david.sehnal@gmail.com>
 */


function TokenColumnProvider(tokens) {
    return function (type) {
        return TokenColumn(tokens, type);
    };
}
function TokenColumn(tokens, schema) {
    var data = tokens.data, indices = tokens.indices, rowCount = tokens.count;
    var type = schema.valueType;
    var value = type === 'str'
        ? function (row) { return data.substring(indices[2 * row], indices[2 * row + 1]); }
        : type === 'int'
            ? function (row) { return Object(_number_parser__WEBPACK_IMPORTED_MODULE_1__["parseInt"])(data, indices[2 * row], indices[2 * row + 1]) || 0; }
            : function (row) { return Object(_number_parser__WEBPACK_IMPORTED_MODULE_1__["parseFloat"])(data, indices[2 * row], indices[2 * row + 1]) || 0; };
    return {
        schema: schema,
        __array: void 0,
        isDefined: true,
        rowCount: rowCount,
        value: value,
        valueKind: function (row) { return 0 /* Present */; },
        toArray: function (params) { return _mol_data_db__WEBPACK_IMPORTED_MODULE_0__["ColumnHelpers"].createAndFillArray(rowCount, value, params); },
        areValuesEqual: areValuesEqualProvider(tokens)
    };
}
function areValuesEqualProvider(tokens) {
    var data = tokens.data, indices = tokens.indices;
    return function (rowA, rowB) {
        var aS = indices[2 * rowA], bS = indices[2 * rowB];
        var len = indices[2 * rowA + 1] - aS;
        if (len !== indices[2 * rowB + 1] - bS)
            return false;
        for (var i = 0; i < len; i++) {
            if (data.charCodeAt(i + aS) !== data.charCodeAt(i + bS)) {
                return false;
            }
        }
        return true;
    };
}
//# sourceMappingURL=token.js.map

/***/ }),

/***/ "./lib/mol-io/reader/common/text/number-parser.js":
/*!********************************************************!*\
  !*** ./lib/mol-io/reader/common/text/number-parser.js ***!
  \********************************************************/
/*! exports provided: parseIntSkipLeadingWhitespace, parseInt, parseFloatSkipLeadingWhitespace, parseFloat, getNumberType */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "parseIntSkipLeadingWhitespace", function() { return parseIntSkipLeadingWhitespace; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "parseInt", function() { return parseInt; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "parseFloatSkipLeadingWhitespace", function() { return parseFloatSkipLeadingWhitespace; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "parseFloat", function() { return parseFloat; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getNumberType", function() { return getNumberType; });
/**
 * Copyright (c) 2017-2020 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author David Sehnal <david.sehnal@gmail.com>
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 *
 * based in part on https://github.com/dsehnal/CIFTools.js
 */
/**
 * Efficient integer and float parsers.
 *
 * For the purposes of parsing numbers from the mmCIF data representations,
 * up to 4 times faster than JS parseInt/parseFloat.
 */
function parseIntSkipLeadingWhitespace(str, start, end) {
    while (start < end && str.charCodeAt(start) === 32)
        start++;
    return parseInt(str, start, end);
}
function parseInt(str, start, end) {
    var _start = start, ret = 0, neg = 1;
    if (str.charCodeAt(_start) === 45 /* - */) {
        neg = -1;
        ++_start;
    }
    else if (str.charCodeAt(_start) === 43 /* + */) {
        ++_start;
    }
    for (; _start < end; _start++) {
        var c = str.charCodeAt(_start) - 48;
        if (c > 9 || c < 0)
            return (neg * ret) | 0;
        else
            ret = (10 * ret + c) | 0;
    }
    return neg * ret;
}
function parseScientific(main, str, start, end) {
    // handle + in '1e+1' separately.
    if (str.charCodeAt(start) === 43 /* + */)
        start++;
    return main * Math.pow(10.0, parseInt(str, start, end));
}
function parseFloatSkipLeadingWhitespace(str, start, end) {
    while (start < end && str.charCodeAt(start) === 32)
        start++;
    return parseFloat(str, start, end);
}
function parseFloat(str, start, end) {
    var _start = start, neg = 1.0, ret = 0.0, point = 0.0, div = 1.0;
    if (str.charCodeAt(_start) === 45 /* - */) {
        neg = -1;
        ++_start;
    }
    else if (str.charCodeAt(_start) === 43 /* + */) {
        ++_start;
    }
    while (_start < end) {
        var c = str.charCodeAt(_start) - 48;
        if (c >= 0 && c < 10) {
            ret = ret * 10 + c;
            ++_start;
        }
        else if (c === -2) { // .
            ++_start;
            while (_start < end) {
                c = str.charCodeAt(_start) - 48;
                if (c >= 0 && c < 10) {
                    point = 10.0 * point + c;
                    div = 10.0 * div;
                    ++_start;
                }
                else if (c === 53 || c === 21) { // 'e'/'E'
                    return parseScientific(neg * (ret + point / div), str, _start + 1, end);
                }
                else {
                    return neg * (ret + point / div);
                }
            }
            return neg * (ret + point / div);
        }
        else if (c === 53 || c === 21) { // 'e'/'E'
            return parseScientific(neg * ret, str, _start + 1, end);
        }
        else {
            break;
        }
    }
    return neg * ret;
}
function isInt(str, start, end) {
    if (str.charCodeAt(start) === 45 /* - */) {
        start++;
    }
    for (; start < end; start++) {
        var c = str.charCodeAt(start) - 48;
        if (c > 9 || c < 0)
            return false;
    }
    return true;
}
// TODO: check for "scientific integers?"
function getNumberTypeScientific(str, start, end) {
    // handle + in '1e+1' separately.
    if (str.charCodeAt(start) === 43 /* + */)
        start++;
    return isInt(str, start, end) ? 2 /* Scientific */ : 3 /* NaN */;
}
/** The whole range must match, otherwise returns NaN */
function getNumberType(str) {
    var start = 0, end = str.length;
    if (str.charCodeAt(start) === 45) { // -
        ++start;
    }
    // string is . or -.
    if (str.charCodeAt(start) === 46 && end - start === 1) {
        return 3 /* NaN */;
    }
    while (start < end) {
        var c = str.charCodeAt(start) - 48;
        if (c >= 0 && c < 10) {
            ++start;
        }
        else if (c === -2) { // .
            ++start;
            var hasDigit = false;
            while (start < end) {
                c = str.charCodeAt(start) - 48;
                if (c >= 0 && c < 10) {
                    hasDigit = true;
                    ++start;
                }
                else if (c === 53 || c === 21) { // 'e'/'E'
                    return getNumberTypeScientific(str, start + 1, end);
                }
                else {
                    return 3 /* NaN */;
                }
            }
            return hasDigit ? 1 /* Float */ : 0 /* Int */;
        }
        else if (c === 53 || c === 21) { // 'e'/'E'
            if (start === 0 || start === 1 && str.charCodeAt(0) === 45) {
                return 3 /* NaN */; // string starts with e/E or -e/-E
            }
            return getNumberTypeScientific(str, start + 1, end);
        }
        else {
            break;
        }
    }
    return start === end ? 0 /* Int */ : 3 /* NaN */;
}
//# sourceMappingURL=number-parser.js.map

/***/ }),

/***/ "./lib/mol-io/reader/common/text/tokenizer.js":
/*!****************************************************!*\
  !*** ./lib/mol-io/reader/common/text/tokenizer.js ***!
  \****************************************************/
/*! exports provided: Tokenizer, trimStr, TokenBuilder */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Tokenizer", function() { return Tokenizer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "trimStr", function() { return trimStr; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "TokenBuilder", function() { return TokenBuilder; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _mol_task__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../../../mol-task */ "./lib/mol-task/index.js");
/**
 * Copyright (c) 2017 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * mostly from https://github.com/dsehnal/CIFTools.js
 * @author David Sehnal <david.sehnal@gmail.com>
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */



function Tokenizer(data) {
    return {
        data: data,
        position: 0,
        length: data.length,
        lineNumber: 1,
        tokenStart: 0,
        tokenEnd: 0
    };
}
(function (Tokenizer) {
    function getTokenString(state) {
        return state.data.substring(state.tokenStart, state.tokenEnd);
    }
    Tokenizer.getTokenString = getTokenString;
    /** Resets the state */
    function reset(state) {
        state.position = 0;
        state.lineNumber = 1;
        state.tokenStart = 0;
        state.tokenEnd = 0;
    }
    Tokenizer.reset = reset;
    /**
     * Eat everything until a newline occurs.
     */
    function eatLine(state) {
        var data = state.data;
        while (state.position < state.length) {
            switch (data.charCodeAt(state.position)) {
                case 10: // \n
                    state.tokenEnd = state.position;
                    ++state.position;
                    ++state.lineNumber;
                    return true;
                case 13: // \r
                    state.tokenEnd = state.position;
                    ++state.position;
                    ++state.lineNumber;
                    if (data.charCodeAt(state.position) === 10) {
                        ++state.position;
                    }
                    return true;
                default:
                    ++state.position;
                    break;
            }
        }
        state.tokenEnd = state.position;
        return state.tokenStart !== state.tokenEnd;
    }
    Tokenizer.eatLine = eatLine;
    /** Sets the current token start to the current position */
    function markStart(state) {
        state.tokenStart = state.position;
    }
    Tokenizer.markStart = markStart;
    /** Sets the current token start to current position and moves to the next line. */
    function markLine(state) {
        state.tokenStart = state.position;
        return eatLine(state);
    }
    Tokenizer.markLine = markLine;
    /** Advance the state by the given number of lines and return line as string. */
    function readLine(state) {
        markLine(state);
        return getTokenString(state);
    }
    Tokenizer.readLine = readLine;
    function readLinesChunk(state, count, tokens) {
        var read = 0;
        for (var i = 0; i < count; i++) {
            if (!markLine(state))
                return read;
            TokenBuilder.addUnchecked(tokens, state.tokenStart, state.tokenEnd);
            read++;
        }
        return read;
    }
    /** Advance the state by the given number of lines and return them*/
    function markLines(state, count) {
        var lineTokens = TokenBuilder.create(state.data, count * 2);
        readLinesChunk(state, count, lineTokens);
        return lineTokens;
    }
    Tokenizer.markLines = markLines;
    /** Advance the state by the given number of lines and return them */
    function readLines(state, count) {
        var ret = [];
        for (var i = 0; i < count; i++) {
            ret.push(Tokenizer.readLine(state));
        }
        return ret;
    }
    Tokenizer.readLines = readLines;
    /** Advance the state by the given number of lines and return line starts/ends as tokens. */
    function readLinesAsync(state, count, ctx, initialLineCount) {
        if (initialLineCount === void 0) { initialLineCount = 100000; }
        return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"])(this, void 0, void 0, function () {
            var length, lineTokens, linesAlreadyRead;
            return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__generator"])(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        length = state.length;
                        lineTokens = TokenBuilder.create(state.data, count * 2);
                        linesAlreadyRead = 0;
                        return [4 /*yield*/, Object(_mol_task__WEBPACK_IMPORTED_MODULE_1__["chunkedSubtask"])(ctx, initialLineCount, state, function (chunkSize, state) {
                                var linesToRead = Math.min(count - linesAlreadyRead, chunkSize);
                                readLinesChunk(state, linesToRead, lineTokens);
                                linesAlreadyRead += linesToRead;
                                return linesToRead;
                            }, function (ctx, state) { return ctx.update({ message: 'Parsing...', current: state.position, max: length }); })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/, lineTokens];
                }
            });
        });
    }
    Tokenizer.readLinesAsync = readLinesAsync;
    function readAllLines(data) {
        var state = Tokenizer(data);
        var tokens = TokenBuilder.create(state.data, Math.max(data.length / 80, 2));
        while (markLine(state)) {
            TokenBuilder.add(tokens, state.tokenStart, state.tokenEnd);
        }
        return tokens;
    }
    Tokenizer.readAllLines = readAllLines;
    function readLinesChunkChecked(state, count, tokens) {
        var read = 0;
        for (var i = 0; i < count; i++) {
            if (!markLine(state))
                return read;
            TokenBuilder.add(tokens, state.tokenStart, state.tokenEnd);
            read++;
        }
        return read;
    }
    function readAllLinesAsync(data, ctx, chunkSize) {
        if (chunkSize === void 0) { chunkSize = 100000; }
        return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"])(this, void 0, void 0, function () {
            var state, tokens;
            return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__generator"])(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        state = Tokenizer(data);
                        tokens = TokenBuilder.create(state.data, Math.max(data.length / 80, 2));
                        return [4 /*yield*/, Object(_mol_task__WEBPACK_IMPORTED_MODULE_1__["chunkedSubtask"])(ctx, chunkSize, state, function (chunkSize, state) {
                                readLinesChunkChecked(state, chunkSize, tokens);
                                return state.position < state.length ? chunkSize : 0;
                            }, function (ctx, state) { return ctx.update({ message: 'Parsing...', current: state.position, max: length }); })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/, tokens];
                }
            });
        });
    }
    Tokenizer.readAllLinesAsync = readAllLinesAsync;
    /**
     * Eat everything until a whitespace/newline occurs.
     */
    function eatValue(state) {
        while (state.position < state.length) {
            switch (state.data.charCodeAt(state.position)) {
                case 9: // \t
                case 10: // \n
                case 13: // \r
                case 32: // ' '
                    state.tokenEnd = state.position;
                    return;
                default:
                    ++state.position;
                    break;
            }
        }
        state.tokenEnd = state.position;
    }
    Tokenizer.eatValue = eatValue;
    /**
     * Skips all the whitespace - space, tab, newline, CR
     * Handles incrementing line count.
     */
    function skipWhitespace(state) {
        var prev = -1;
        while (state.position < state.length) {
            var c = state.data.charCodeAt(state.position);
            switch (c) {
                case 9: // '\t'
                case 32: // ' '
                    prev = c;
                    ++state.position;
                    break;
                case 10: // \n
                    // handle \r\n
                    if (prev !== 13) {
                        ++state.lineNumber;
                    }
                    prev = c;
                    ++state.position;
                    break;
                case 13: // \r
                    prev = c;
                    ++state.position;
                    ++state.lineNumber;
                    break;
                default:
                    return prev;
            }
        }
        return prev;
    }
    Tokenizer.skipWhitespace = skipWhitespace;
    /** Trims spaces and tabs */
    function trim(state, start, end) {
        var data = state.data;
        var s = start, e = end - 1;
        var c = data.charCodeAt(s);
        while ((c === 9 || c === 32) && s <= e)
            c = data.charCodeAt(++s);
        c = data.charCodeAt(e);
        while ((c === 9 || c === 32) && e >= s)
            c = data.charCodeAt(--e);
        state.tokenStart = s;
        state.tokenEnd = e + 1;
        state.position = end;
        return state;
    }
    Tokenizer.trim = trim;
})(Tokenizer || (Tokenizer = {}));
function trimStr(data, start, end) {
    var s = start, e = end - 1;
    var c = data.charCodeAt(s);
    while ((c === 9 || c === 32) && s <= e)
        c = data.charCodeAt(++s);
    c = data.charCodeAt(e);
    while ((c === 9 || c === 32) && e >= s)
        c = data.charCodeAt(--e);
    return data.substring(s, e + 1);
}
var TokenBuilder;
(function (TokenBuilder) {
    function resize(builder) {
        // scale the size using golden ratio, because why not.
        var newBuffer = new Uint32Array((1.61 * builder.indices.length) | 0);
        newBuffer.set(builder.indices);
        builder.indices = newBuffer;
        builder.indicesLenMinus2 = (newBuffer.length - 2) | 0;
    }
    function add(tokens, start, end) {
        var builder = tokens;
        if (builder.offset > builder.indicesLenMinus2) {
            resize(builder);
        }
        builder.indices[builder.offset++] = start;
        builder.indices[builder.offset++] = end;
        tokens.count++;
    }
    TokenBuilder.add = add;
    function addToken(tokens, tokenizer) {
        add(tokens, tokenizer.tokenStart, tokenizer.tokenEnd);
    }
    TokenBuilder.addToken = addToken;
    function addUnchecked(tokens, start, end) {
        tokens.indices[tokens.offset++] = start;
        tokens.indices[tokens.offset++] = end;
        tokens.count++;
    }
    TokenBuilder.addUnchecked = addUnchecked;
    function create(data, size) {
        size = Math.max(10, size);
        return {
            data: data,
            indicesLenMinus2: (size - 2) | 0,
            count: 0,
            offset: 0,
            indices: new Uint32Array(size)
        };
    }
    TokenBuilder.create = create;
})(TokenBuilder || (TokenBuilder = {}));
//# sourceMappingURL=tokenizer.js.map

/***/ }),

/***/ "./lib/mol-io/reader/cube/parser.js":
/*!******************************************!*\
  !*** ./lib/mol-io/reader/cube/parser.js ***!
  \******************************************/
/*! exports provided: parseCube */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "parseCube", function() { return parseCube; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../../mol-math/linear-algebra */ "./lib/mol-math/linear-algebra.js");
/* harmony import */ var _common_text_tokenizer__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../common/text/tokenizer */ "./lib/mol-io/reader/common/text/tokenizer.js");
/* harmony import */ var _mol_data_db__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../../mol-data/db */ "./lib/mol-data/db.js");
/* harmony import */ var _mol_task__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../../mol-task */ "./lib/mol-task/index.js");
/* harmony import */ var _result__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../result */ "./lib/mol-io/reader/result.js");
/* harmony import */ var _common_text_number_parser__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../common/text/number-parser */ "./lib/mol-io/reader/common/text/number-parser.js");
/**
 * Copyright (c) 2020 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * Adapted from NGL.
 *
 * @author David Sehnal <david.sehnal@gmail.com>
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */







var bohrToAngstromFactor = 0.529177210859;
function readHeader(tokenizer) {
    var headerLines = _common_text_tokenizer__WEBPACK_IMPORTED_MODULE_2__["Tokenizer"].readLines(tokenizer, 6);
    var h = function (k, l) {
        var field = +headerLines[k].trim().split(/\s+/g)[l];
        return Number.isNaN(field) ? 0 : field;
    };
    var basis = function (i) {
        var n = h(i + 2, 0);
        var s = bohrToAngstromFactor;
        return [Math.abs(n), _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_1__["Vec3"].create(h(i + 2, 1) * s, h(i + 2, 2) * s, h(i + 2, 3) * s), n];
    };
    var comment1 = headerLines[0].trim();
    var comment2 = headerLines[1].trim();
    var _a = basis(0), atomCount = _a[0], origin = _a[1], rawAtomCount = _a[2];
    var _b = basis(1), NVX = _b[0], basisX = _b[1];
    var _c = basis(2), NVY = _c[0], basisY = _c[1];
    var _d = basis(3), NVZ = _d[0], basisZ = _d[1];
    var atoms = readAtoms(tokenizer, atomCount, bohrToAngstromFactor);
    var dataSetIds = [];
    if (rawAtomCount >= 0) {
        var nVal = h(2, 4);
        if (nVal === 0)
            nVal = 1;
        for (var i = 0; i < nVal; i++)
            dataSetIds.push(i);
    }
    else {
        var counts = _common_text_tokenizer__WEBPACK_IMPORTED_MODULE_2__["Tokenizer"].readLine(tokenizer).trim().split(/\s+/g);
        for (var i = 0, _i = +counts[0]; i < _i; i++)
            dataSetIds.push(+counts[i + 1]);
    }
    var header = { orbitals: rawAtomCount < 0, comment1: comment1, comment2: comment2, atomCount: atomCount, origin: origin, dim: _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_1__["Vec3"].create(NVX, NVY, NVZ), basisX: basisX, basisY: basisY, basisZ: basisZ, dataSetIds: dataSetIds };
    return { header: header, atoms: atoms };
}
function readAtoms(tokenizer, count, scaleFactor) {
    var number = new Int32Array(count);
    var value = new Float64Array(count);
    var x = new Float32Array(count);
    var y = new Float32Array(count);
    var z = new Float32Array(count);
    for (var i = 0; i < count; i++) {
        var fields = _common_text_tokenizer__WEBPACK_IMPORTED_MODULE_2__["Tokenizer"].readLine(tokenizer).trim().split(/\s+/g);
        number[i] = +fields[0];
        value[i] = +fields[1];
        x[i] = +fields[2] * scaleFactor;
        y[i] = +fields[3] * scaleFactor;
        z[i] = +fields[4] * scaleFactor;
    }
    return {
        count: count,
        number: _mol_data_db__WEBPACK_IMPORTED_MODULE_3__["Column"].ofArray({ array: number, schema: _mol_data_db__WEBPACK_IMPORTED_MODULE_3__["Column"].Schema.int }),
        nuclearCharge: _mol_data_db__WEBPACK_IMPORTED_MODULE_3__["Column"].ofArray({ array: value, schema: _mol_data_db__WEBPACK_IMPORTED_MODULE_3__["Column"].Schema.float }),
        x: _mol_data_db__WEBPACK_IMPORTED_MODULE_3__["Column"].ofArray({ array: x, schema: _mol_data_db__WEBPACK_IMPORTED_MODULE_3__["Column"].Schema.float }),
        y: _mol_data_db__WEBPACK_IMPORTED_MODULE_3__["Column"].ofArray({ array: y, schema: _mol_data_db__WEBPACK_IMPORTED_MODULE_3__["Column"].Schema.float }),
        z: _mol_data_db__WEBPACK_IMPORTED_MODULE_3__["Column"].ofArray({ array: z, schema: _mol_data_db__WEBPACK_IMPORTED_MODULE_3__["Column"].Schema.float })
    };
}
function readValues(ctx, tokenizer, header) {
    var N = header.dim[0] * header.dim[1] * header.dim[2] * header.dataSetIds.length;
    var chunkSize = 100 * 100 * 100;
    var data = new Float64Array(N);
    var offset = 0;
    return Object(_mol_task__WEBPACK_IMPORTED_MODULE_4__["chunkedSubtask"])(ctx, chunkSize, data, function (count, data) {
        var max = Math.min(N, offset + count);
        for (var i = offset; i < max; i++) {
            _common_text_tokenizer__WEBPACK_IMPORTED_MODULE_2__["Tokenizer"].skipWhitespace(tokenizer);
            tokenizer.tokenStart = tokenizer.position;
            _common_text_tokenizer__WEBPACK_IMPORTED_MODULE_2__["Tokenizer"].eatValue(tokenizer);
            data[i] = Object(_common_text_number_parser__WEBPACK_IMPORTED_MODULE_6__["parseFloat"])(tokenizer.data, tokenizer.tokenStart, tokenizer.tokenEnd);
        }
        offset = max;
        return max === N ? 0 : chunkSize;
    }, function (ctx, _, i) { return ctx.update({ current: Math.min(i, N), max: N }); });
}
function parseCube(data, name) {
    var _this = this;
    return _mol_task__WEBPACK_IMPORTED_MODULE_4__["Task"].create('Parse Cube', function (taskCtx) { return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"])(_this, void 0, void 0, function () {
        var tokenizer, _a, header, atoms, values;
        return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__generator"])(this, function (_b) {
            switch (_b.label) {
                case 0: return [4 /*yield*/, taskCtx.update('Reading header...')];
                case 1:
                    _b.sent();
                    tokenizer = Object(_common_text_tokenizer__WEBPACK_IMPORTED_MODULE_2__["Tokenizer"])(data);
                    _a = readHeader(tokenizer), header = _a.header, atoms = _a.atoms;
                    return [4 /*yield*/, readValues(taskCtx, tokenizer, header)];
                case 2:
                    values = _b.sent();
                    return [2 /*return*/, _result__WEBPACK_IMPORTED_MODULE_5__["ReaderResult"].success({ header: header, atoms: atoms, values: values, name: name })];
            }
        });
    }); });
}
//# sourceMappingURL=parser.js.map

/***/ }),

/***/ "./lib/mol-io/reader/dcd/parser.js":
/*!*****************************************!*\
  !*** ./lib/mol-io/reader/dcd/parser.js ***!
  \*****************************************/
/*! exports provided: _parseDcd, parseDcd */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_parseDcd", function() { return _parseDcd; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "parseDcd", function() { return parseDcd; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _result__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../result */ "./lib/mol-io/reader/result.js");
/* harmony import */ var _mol_task__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../../mol-task */ "./lib/mol-task/index.js");
/* harmony import */ var _common_binary__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../common/binary */ "./lib/mol-io/common/binary.js");
/**
 * Copyright (c) 2019-2020 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */




function _parseDcd(data) {
    // http://www.ks.uiuc.edu/Research/vmd/plugins/molfile/dcdplugin.html
    // The DCD format is structured as follows
    //   (FORTRAN UNFORMATTED, with Fortran data type descriptions):
    // HDR     NSET    ISTRT   NSAVC   5-ZEROS NATOM-NFREAT    DELTA   9-ZEROS
    // `CORD'  #files  step 1  step    zeroes  (zero)          timestep  (zeroes)
    //                         interval
    // C*4     INT     INT     INT     5INT    INT             DOUBLE  9INT
    // ==========================================================================
    // NTITLE          TITLE
    // INT (=2)        C*MAXTITL
    //                 (=32)
    // ==========================================================================
    // NATOM
    // #atoms
    // INT
    // ==========================================================================
    // X(I), I=1,NATOM         (DOUBLE)
    // Y(I), I=1,NATOM
    // Z(I), I=1,NATOM
    // ==========================================================================
    var dv = new DataView(data.buffer);
    var header = Object.create(null);
    var frames = [];
    var nextPos = 0;
    // header block
    var intView = new Int32Array(data.buffer, 0, 23);
    var ef = intView[0] !== dv.getInt32(0); // endianess flag
    // swap byte order when big endian (84 indicates little endian)
    if (intView[0] !== 84) {
        var n = data.byteLength;
        for (var i = 0; i < n; i += 4) {
            dv.setFloat32(i, dv.getFloat32(i), true);
        }
    }
    if (intView[0] !== 84) {
        throw new Error('dcd bad format, header block start');
    }
    // format indicator, should read 'CORD'
    var formatString = String.fromCharCode(dv.getUint8(4), dv.getUint8(5), dv.getUint8(6), dv.getUint8(7));
    if (formatString !== 'CORD') {
        throw new Error('dcd bad format, format string');
    }
    var isCharmm = false;
    var extraBlock = false;
    var fourDims = false;
    // version field in charmm, unused in X-PLOR
    if (intView[22] !== 0) {
        isCharmm = true;
        if (intView[12] !== 0)
            extraBlock = true;
        if (intView[13] === 1)
            fourDims = true;
    }
    header.NSET = intView[2];
    header.ISTART = intView[3];
    header.NSAVC = intView[4];
    header.NAMNF = intView[10];
    if (isCharmm) {
        header.DELTA = dv.getFloat32(44, ef);
    }
    else {
        header.DELTA = dv.getFloat64(44, ef);
    }
    if (intView[22] !== 84) {
        throw new Error('dcd bad format, header block end');
    }
    nextPos = nextPos + 21 * 4 + 8;
    // title block
    var titleEnd = dv.getInt32(nextPos, ef);
    var titleStart = nextPos + 1;
    if ((titleEnd - 4) % 80 !== 0) {
        throw new Error('dcd bad format, title block start');
    }
    header.TITLE = Object(_common_binary__WEBPACK_IMPORTED_MODULE_3__["uint8ToString"])(data.subarray(titleStart, titleEnd));
    if (dv.getInt32(titleStart + titleEnd + 4 - 1, ef) !== titleEnd) {
        throw new Error('dcd bad format, title block end');
    }
    nextPos = nextPos + titleEnd + 8;
    // natom block
    if (dv.getInt32(nextPos, ef) !== 4) {
        throw new Error('dcd bad format, natom block start');
    }
    header.NATOM = dv.getInt32(nextPos + 4, ef);
    if (dv.getInt32(nextPos + 8, ef) !== 4) {
        throw new Error('dcd bad format, natom block end');
    }
    nextPos = nextPos + 4 + 8;
    // fixed atoms block
    if (header.NAMNF > 0) {
        // TODO read coordinates and indices of fixed atoms
        throw new Error('dcd format with fixed atoms unsupported, aborting');
    }
    // frames
    var natom = header.NATOM;
    var natom4 = natom * 4;
    for (var i = 0, n = header.NSET; i < n; ++i) {
        var frame = Object.create(null);
        frame.elementCount = natom;
        if (extraBlock) {
            nextPos += 4; // block start
            frame.cell = [
                dv.getFloat64(nextPos, ef),
                dv.getFloat64(nextPos + 1, ef),
                dv.getFloat64(nextPos + 2 * 8, ef),
                dv.getFloat64(nextPos + 3 * 8, ef),
                dv.getFloat64(nextPos + 4 * 8, ef),
                dv.getFloat64(nextPos + 5 * 8, ef)
            ];
            nextPos += 48;
            nextPos += 4; // block end
        }
        // xyz coordinates
        for (var j = 0; j < 3; ++j) {
            if (dv.getInt32(nextPos, ef) !== natom4) {
                throw new Error("dcd bad format, coord block start: " + i + ", " + j);
            }
            nextPos += 4; // block start
            var c = new Float32Array(data.buffer, nextPos, natom);
            if (j === 0)
                frame.x = c;
            else if (j === 1)
                frame.y = c;
            else
                frame.z = c;
            nextPos += natom4;
            if (dv.getInt32(nextPos, ef) !== natom4) {
                throw new Error("dcd bad format, coord block end: " + i + ", " + j);
            }
            nextPos += 4; // block end
        }
        if (fourDims) {
            var bytes = dv.getInt32(nextPos, ef);
            nextPos += 4 + bytes + 4; // block start + skip + block end
        }
        frames.push(frame);
    }
    return { header: header, frames: frames };
}
function parseDcd(data) {
    var _this = this;
    return _mol_task__WEBPACK_IMPORTED_MODULE_2__["Task"].create('Parse DCD', function (ctx) { return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"])(_this, void 0, void 0, function () {
        var dcdFile;
        return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__generator"])(this, function (_a) {
            try {
                dcdFile = _parseDcd(data);
                return [2 /*return*/, _result__WEBPACK_IMPORTED_MODULE_1__["ReaderResult"].success(dcdFile)];
            }
            catch (e) {
                return [2 /*return*/, _result__WEBPACK_IMPORTED_MODULE_1__["ReaderResult"].error(e)];
            }
            return [2 /*return*/];
        });
    }); });
}
//# sourceMappingURL=parser.js.map

/***/ }),

/***/ "./lib/mol-io/reader/dsn6/parser.js":
/*!******************************************!*\
  !*** ./lib/mol-io/reader/dsn6/parser.js ***!
  \******************************************/
/*! exports provided: dsn6HeaderSize, readDsn6Header, parseDsn6Values, getDsn6Counts, parseFile, parse */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "dsn6HeaderSize", function() { return dsn6HeaderSize; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "readDsn6Header", function() { return readDsn6Header; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "parseDsn6Values", function() { return parseDsn6Values; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getDsn6Counts", function() { return getDsn6Counts; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "parseFile", function() { return parseFile; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "parse", function() { return parse; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _mol_task__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../../mol-task */ "./lib/mol-task/index.js");
/* harmony import */ var _result__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../result */ "./lib/mol-io/reader/result.js");
/* harmony import */ var _common_file_handle__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../common/file-handle */ "./lib/mol-io/common/file-handle.js");
/* harmony import */ var _mol_io_common_simple_buffer__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../../mol-io/common/simple-buffer */ "./lib/mol-io/common/simple-buffer.js");
/**
 * Copyright (c) 2019 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */





var dsn6HeaderSize = 512;
function parseBrixHeader(str) {
    return {
        xStart: parseInt(str.substr(10, 5)),
        yStart: parseInt(str.substr(15, 5)),
        zStart: parseInt(str.substr(20, 5)),
        xExtent: parseInt(str.substr(32, 5)),
        yExtent: parseInt(str.substr(38, 5)),
        zExtent: parseInt(str.substr(42, 5)),
        xRate: parseInt(str.substr(52, 5)),
        yRate: parseInt(str.substr(58, 5)),
        zRate: parseInt(str.substr(62, 5)),
        xlen: parseFloat(str.substr(73, 10)),
        ylen: parseFloat(str.substr(83, 10)),
        zlen: parseFloat(str.substr(93, 10)),
        alpha: parseFloat(str.substr(103, 10)),
        beta: parseFloat(str.substr(113, 10)),
        gamma: parseFloat(str.substr(123, 10)),
        divisor: parseFloat(str.substr(138, 12)),
        summand: parseInt(str.substr(155, 8)),
        sigma: parseFloat(str.substr(170, 12))
    };
}
function parseDsn6Header(buffer, littleEndian) {
    var readInt = littleEndian ? function (o) { return buffer.readInt16LE(o * 2); } : function (o) { return buffer.readInt16BE(o * 2); };
    var factor = 1 / readInt(17);
    return {
        xStart: readInt(0),
        yStart: readInt(1),
        zStart: readInt(2),
        xExtent: readInt(3),
        yExtent: readInt(4),
        zExtent: readInt(5),
        xRate: readInt(6),
        yRate: readInt(7),
        zRate: readInt(8),
        xlen: readInt(9) * factor,
        ylen: readInt(10) * factor,
        zlen: readInt(11) * factor,
        alpha: readInt(12) * factor,
        beta: readInt(13) * factor,
        gamma: readInt(14) * factor,
        divisor: readInt(15) / 100,
        summand: readInt(16),
        sigma: undefined
    };
}
function getBlocks(header) {
    var xExtent = header.xExtent, yExtent = header.yExtent, zExtent = header.zExtent;
    var xBlocks = Math.ceil(xExtent / 8);
    var yBlocks = Math.ceil(yExtent / 8);
    var zBlocks = Math.ceil(zExtent / 8);
    return { xBlocks: xBlocks, yBlocks: yBlocks, zBlocks: zBlocks };
}
function readDsn6Header(file) {
    return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"])(this, void 0, void 0, function () {
        var buffer, brixStr, isBrix, littleEndian, header;
        return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__generator"])(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, file.readBuffer(0, dsn6HeaderSize)];
                case 1:
                    buffer = (_a.sent()).buffer;
                    brixStr = String.fromCharCode.apply(null, buffer);
                    isBrix = brixStr.startsWith(':-)');
                    littleEndian = isBrix || buffer.readInt16LE(18 * 2) === 100;
                    header = isBrix ? parseBrixHeader(brixStr) : parseDsn6Header(buffer, littleEndian);
                    return [2 /*return*/, { header: header, littleEndian: littleEndian }];
            }
        });
    });
}
function parseDsn6Values(header, source, target, littleEndian) {
    return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"])(this, void 0, void 0, function () {
        var divisor, summand, xExtent, yExtent, zExtent, _a, xBlocks, yBlocks, zBlocks, offset, zz, yy, xx, k, z, j, y, i, x, idx;
        return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__generator"])(this, function (_b) {
            if (!littleEndian) {
                // even though the values are one byte they need to be swapped like they are 2
                _mol_io_common_simple_buffer__WEBPACK_IMPORTED_MODULE_4__["SimpleBuffer"].flipByteOrderInPlace2(source.buffer);
            }
            divisor = header.divisor, summand = header.summand, xExtent = header.xExtent, yExtent = header.yExtent, zExtent = header.zExtent;
            _a = getBlocks(header), xBlocks = _a.xBlocks, yBlocks = _a.yBlocks, zBlocks = _a.zBlocks;
            offset = 0;
            // loop over blocks
            for (zz = 0; zz < zBlocks; ++zz) {
                for (yy = 0; yy < yBlocks; ++yy) {
                    for (xx = 0; xx < xBlocks; ++xx) {
                        // loop inside block
                        for (k = 0; k < 8; ++k) {
                            z = 8 * zz + k;
                            for (j = 0; j < 8; ++j) {
                                y = 8 * yy + j;
                                for (i = 0; i < 8; ++i) {
                                    x = 8 * xx + i;
                                    // check if remaining slice-part contains values
                                    if (x < xExtent && y < yExtent && z < zExtent) {
                                        idx = ((((x * yExtent) + y) * zExtent) + z);
                                        target[idx] = (source[offset] - summand) / divisor;
                                        ++offset;
                                    }
                                    else {
                                        offset += 8 - i;
                                        break;
                                    }
                                }
                            }
                        }
                    }
                }
            }
            return [2 /*return*/];
        });
    });
}
function getDsn6Counts(header) {
    var xExtent = header.xExtent, yExtent = header.yExtent, zExtent = header.zExtent;
    var _a = getBlocks(header), xBlocks = _a.xBlocks, yBlocks = _a.yBlocks, zBlocks = _a.zBlocks;
    var valueCount = xExtent * yExtent * zExtent;
    var count = xBlocks * 8 * yBlocks * 8 * zBlocks * 8;
    var elementByteSize = 1;
    var byteCount = count * elementByteSize;
    return { count: count, byteCount: byteCount, valueCount: valueCount };
}
function parseInternal(file, size, ctx) {
    return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"])(this, void 0, void 0, function () {
        var _a, header, littleEndian, buffer, valueCount, values, result;
        return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__generator"])(this, function (_b) {
            switch (_b.label) {
                case 0: return [4 /*yield*/, ctx.update({ message: 'Parsing DSN6/BRIX file...' })];
                case 1:
                    _b.sent();
                    return [4 /*yield*/, readDsn6Header(file)];
                case 2:
                    _a = _b.sent(), header = _a.header, littleEndian = _a.littleEndian;
                    return [4 /*yield*/, file.readBuffer(dsn6HeaderSize, size - dsn6HeaderSize)];
                case 3:
                    buffer = (_b.sent()).buffer;
                    valueCount = getDsn6Counts(header).valueCount;
                    values = new Float32Array(valueCount);
                    return [4 /*yield*/, parseDsn6Values(header, buffer, values, littleEndian)];
                case 4:
                    _b.sent();
                    result = { header: header, values: values, name: file.name };
                    return [2 /*return*/, result];
            }
        });
    });
}
function parseFile(file, size) {
    var _this = this;
    return _mol_task__WEBPACK_IMPORTED_MODULE_1__["Task"].create('Parse DSN6/BRIX', function (ctx) { return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"])(_this, void 0, void 0, function () {
        var _a, _b, e_1;
        return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__generator"])(this, function (_c) {
            switch (_c.label) {
                case 0:
                    _c.trys.push([0, 2, , 3]);
                    _b = (_a = _result__WEBPACK_IMPORTED_MODULE_2__["ReaderResult"]).success;
                    return [4 /*yield*/, parseInternal(file, size, ctx)];
                case 1: return [2 /*return*/, _b.apply(_a, [_c.sent()])];
                case 2:
                    e_1 = _c.sent();
                    return [2 /*return*/, _result__WEBPACK_IMPORTED_MODULE_2__["ReaderResult"].error(e_1)];
                case 3: return [2 /*return*/];
            }
        });
    }); });
}
function parse(buffer, name) {
    return parseFile(_common_file_handle__WEBPACK_IMPORTED_MODULE_3__["FileHandle"].fromBuffer(_mol_io_common_simple_buffer__WEBPACK_IMPORTED_MODULE_4__["SimpleBuffer"].fromUint8Array(buffer), name), buffer.length);
}
//# sourceMappingURL=parser.js.map

/***/ }),

/***/ "./lib/mol-io/reader/dx/parser.js":
/*!****************************************!*\
  !*** ./lib/mol-io/reader/dx/parser.js ***!
  \****************************************/
/*! exports provided: parseDx */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "parseDx", function() { return parseDx; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../../mol-math/linear-algebra */ "./lib/mol-math/linear-algebra.js");
/* harmony import */ var _mol_task__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../../mol-task */ "./lib/mol-task/index.js");
/* harmony import */ var _common_text_number_parser__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../common/text/number-parser */ "./lib/mol-io/reader/common/text/number-parser.js");
/* harmony import */ var _common_text_tokenizer__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../common/text/tokenizer */ "./lib/mol-io/reader/common/text/tokenizer.js");
/* harmony import */ var _result__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../result */ "./lib/mol-io/reader/result.js");
/* harmony import */ var _common_utf8__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../../common/utf8 */ "./lib/mol-io/common/utf8.js");
/**
 * Copyright (c) 2020 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * Adapted from NGL.
 *
 * @author David Sehnal <david.sehnal@gmail.com>
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */







function readHeader(tokenizer) {
    var header = { h: Object(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_1__["Vec3"])() };
    var headerByteCount = 0;
    var deltaLineCount = 0;
    var reWhitespace = /\s+/g;
    while (true) {
        var line = _common_text_tokenizer__WEBPACK_IMPORTED_MODULE_4__["Tokenizer"].readLine(tokenizer);
        var ls = void 0;
        if (line.startsWith('object 1')) {
            ls = line.split(reWhitespace);
            header.dim = _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_1__["Vec3"].create(parseInt(ls[5]), parseInt(ls[6]), parseInt(ls[7]));
        }
        else if (line.startsWith('origin')) {
            ls = line.split(reWhitespace);
            header.min = _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_1__["Vec3"].create(parseFloat(ls[1]), parseFloat(ls[2]), parseFloat(ls[3]));
        }
        else if (line.startsWith('delta')) {
            ls = line.split(reWhitespace);
            if (deltaLineCount === 0) {
                header.h[0] = parseFloat(ls[1]);
            }
            else if (deltaLineCount === 1) {
                header.h[1] = parseFloat(ls[2]);
            }
            else if (deltaLineCount === 2) {
                header.h[2] = parseFloat(ls[3]);
            }
            deltaLineCount += 1;
        }
        else if (line.startsWith('object 3')) {
            headerByteCount += line.length + 1;
            break;
        }
        headerByteCount += line.length + 1;
    }
    return { header: header, headerByteCount: headerByteCount };
}
function readValuesText(ctx, tokenizer, header) {
    var N = header.dim[0] * header.dim[1] * header.dim[2];
    var chunkSize = 100 * 100 * 100;
    var data = new Float64Array(N);
    var offset = 0;
    return Object(_mol_task__WEBPACK_IMPORTED_MODULE_2__["chunkedSubtask"])(ctx, chunkSize, data, function (count, data) {
        var max = Math.min(N, offset + count);
        for (var i = offset; i < max; i++) {
            _common_text_tokenizer__WEBPACK_IMPORTED_MODULE_4__["Tokenizer"].skipWhitespace(tokenizer);
            tokenizer.tokenStart = tokenizer.position;
            _common_text_tokenizer__WEBPACK_IMPORTED_MODULE_4__["Tokenizer"].eatValue(tokenizer);
            data[i] = Object(_common_text_number_parser__WEBPACK_IMPORTED_MODULE_3__["parseFloat"])(tokenizer.data, tokenizer.tokenStart, tokenizer.tokenEnd);
        }
        offset = max;
        return max === N ? 0 : chunkSize;
    }, function (ctx, _, i) { return ctx.update({ current: Math.min(i, N), max: N }); });
}
function parseText(taskCtx, data, name) {
    return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"])(this, void 0, void 0, function () {
        var tokenizer, header, values;
        return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__generator"])(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, taskCtx.update('Reading header...')];
                case 1:
                    _a.sent();
                    tokenizer = Object(_common_text_tokenizer__WEBPACK_IMPORTED_MODULE_4__["Tokenizer"])(data);
                    header = readHeader(tokenizer).header;
                    return [4 /*yield*/, taskCtx.update('Reading values...')];
                case 2:
                    _a.sent();
                    return [4 /*yield*/, readValuesText(taskCtx, tokenizer, header)];
                case 3:
                    values = _a.sent();
                    return [2 /*return*/, _result__WEBPACK_IMPORTED_MODULE_5__["ReaderResult"].success({ header: header, values: values, name: name })];
            }
        });
    });
}
function parseBinary(taskCtx, data, name) {
    return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"])(this, void 0, void 0, function () {
        var headerString, tokenizer, _a, header, headerByteCount, size, dv, values, i;
        return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__generator"])(this, function (_b) {
            switch (_b.label) {
                case 0: return [4 /*yield*/, taskCtx.update('Reading header...')];
                case 1:
                    _b.sent();
                    headerString = Object(_common_utf8__WEBPACK_IMPORTED_MODULE_6__["utf8Read"])(data, 0, 1000);
                    tokenizer = Object(_common_text_tokenizer__WEBPACK_IMPORTED_MODULE_4__["Tokenizer"])(headerString);
                    _a = readHeader(tokenizer), header = _a.header, headerByteCount = _a.headerByteCount;
                    return [4 /*yield*/, taskCtx.update('Reading values...')];
                case 2:
                    _b.sent();
                    size = header.dim[0] * header.dim[1] * header.dim[2];
                    dv = new DataView(data.buffer, data.byteOffset + headerByteCount);
                    values = new Float64Array(size);
                    for (i = 0; i < size; i++) {
                        values[i] = dv.getFloat64(i * 8, true);
                    }
                    // TODO: why doesnt this work? throw "attempting to construct out-of-bounds TypedArray"
                    // const values = new Float64Array(data.buffer, data.byteOffset + headerByteCount, header.dim[0] * header.dim[1] * header.dim[2]);
                    return [2 /*return*/, _result__WEBPACK_IMPORTED_MODULE_5__["ReaderResult"].success({ header: header, values: values, name: name })];
            }
        });
    });
}
function parseDx(data, name) {
    return _mol_task__WEBPACK_IMPORTED_MODULE_2__["Task"].create('Parse Cube', function (taskCtx) {
        if (typeof data === 'string')
            return parseText(taskCtx, data, name);
        return parseBinary(taskCtx, data, name);
    });
}
//# sourceMappingURL=parser.js.map

/***/ }),

/***/ "./lib/mol-io/reader/gro/parser.js":
/*!*****************************************!*\
  !*** ./lib/mol-io/reader/gro/parser.js ***!
  \*****************************************/
/*! exports provided: parseGRO */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "parseGRO", function() { return parseGRO; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _mol_data_db__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../../mol-data/db */ "./lib/mol-data/db.js");
/* harmony import */ var _common_text_tokenizer__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../common/text/tokenizer */ "./lib/mol-io/reader/common/text/tokenizer.js");
/* harmony import */ var _common_text_column_fixed__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../common/text/column/fixed */ "./lib/mol-io/reader/common/text/column/fixed.js");
/* harmony import */ var _result__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../result */ "./lib/mol-io/reader/result.js");
/* harmony import */ var _mol_task__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../../mol-task */ "./lib/mol-task/index.js");
/**
 * Copyright (c) 2017 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 * @author David Sehnal <david.sehnal@gmail.com>
 */






function createEmptyHeader() {
    return {
        title: '',
        timeInPs: 0,
        hasVelocities: false,
        precision: { position: 0, velocity: 0 },
        box: [0, 0, 0]
    };
}
function State(tokenizer, runtimeCtx) {
    return {
        tokenizer: tokenizer,
        header: createEmptyHeader(),
        numberOfAtoms: 0,
        runtimeCtx: runtimeCtx
    };
}
/**
 * title string (free format string, optional time in ps after 't=')
 */
function handleTitleString(state) {
    var tokenizer = state.tokenizer, header = state.header;
    var line = _common_text_tokenizer__WEBPACK_IMPORTED_MODULE_2__["Tokenizer"].readLine(tokenizer);
    // skip potential empty lines...
    if (line.trim().length === 0) {
        line = _common_text_tokenizer__WEBPACK_IMPORTED_MODULE_2__["Tokenizer"].readLine(tokenizer);
    }
    var timeOffset = line.lastIndexOf('t=');
    if (timeOffset >= 0) {
        header.timeInPs = parseFloat(line.substring(timeOffset + 2));
        header.title = line.substring(0, timeOffset).trim();
        if (header.title && header.title[header.title.length - 1] === ',') {
            header.title = header.title.substring(0, header.title.length - 1);
        }
    }
    else {
        header.title = line;
    }
}
/**
 * number of atoms (free format integer)
 */
function handleNumberOfAtoms(state) {
    var tokenizer = state.tokenizer;
    _common_text_tokenizer__WEBPACK_IMPORTED_MODULE_2__["Tokenizer"].markLine(tokenizer);
    var line = _common_text_tokenizer__WEBPACK_IMPORTED_MODULE_2__["Tokenizer"].getTokenString(tokenizer);
    state.numberOfAtoms = parseInt(line);
}
/**
 * This format is fixed, ie. all columns are in a fixed position.
 * Optionally (for now only yet with trjconv) you can write gro files
 * with any number of decimal places, the format will then be n+5
 * positions with n decimal places (n+1 for velocities) in stead
 * of 8 with 3 (with 4 for velocities). Upon reading, the precision
 * will be inferred from the distance between the decimal points
 * (which will be n+5). Columns contain the following information
 * (from left to right):
 *     residue number (5 positions, integer)
 *     residue name (5 characters)
 *     atom name (5 characters)
 *     atom number (5 positions, integer)
 *     position (in nm, x y z in 3 columns, each 8 positions with 3 decimal places)
 *     velocity (in nm/ps (or km/s), x y z in 3 columns, each 8 positions with 4 decimal places)
 */
function handleAtoms(state) {
    return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"])(this, void 0, void 0, function () {
        var tokenizer, numberOfAtoms, lines, positionSample, precisions, hasVelocities, pO, pW, vO, vW, col, undef, ret;
        return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__generator"])(this, function (_a) {
            switch (_a.label) {
                case 0:
                    tokenizer = state.tokenizer, numberOfAtoms = state.numberOfAtoms;
                    return [4 /*yield*/, _common_text_tokenizer__WEBPACK_IMPORTED_MODULE_2__["Tokenizer"].readLinesAsync(tokenizer, numberOfAtoms, state.runtimeCtx, 100000)];
                case 1:
                    lines = _a.sent();
                    positionSample = tokenizer.data.substring(lines.indices[0], lines.indices[1]).substring(20);
                    precisions = positionSample.match(/\.\d+/g);
                    hasVelocities = precisions.length === 6;
                    state.header.hasVelocities = hasVelocities;
                    state.header.precision.position = precisions[0].length - 1;
                    state.header.precision.velocity = hasVelocities ? precisions[3].length - 1 : 0;
                    pO = 20;
                    pW = state.header.precision.position + 5;
                    vO = pO + 3 * pW;
                    vW = state.header.precision.velocity + 4;
                    col = Object(_common_text_column_fixed__WEBPACK_IMPORTED_MODULE_3__["default"])(lines);
                    undef = _mol_data_db__WEBPACK_IMPORTED_MODULE_1__["Column"].Undefined(state.numberOfAtoms, _mol_data_db__WEBPACK_IMPORTED_MODULE_1__["Column"].Schema.float);
                    ret = {
                        count: state.numberOfAtoms,
                        residueNumber: col(0, 5, _mol_data_db__WEBPACK_IMPORTED_MODULE_1__["Column"].Schema.int),
                        residueName: col(5, 5, _mol_data_db__WEBPACK_IMPORTED_MODULE_1__["Column"].Schema.str),
                        atomName: col(10, 5, _mol_data_db__WEBPACK_IMPORTED_MODULE_1__["Column"].Schema.str),
                        atomNumber: col(15, 5, _mol_data_db__WEBPACK_IMPORTED_MODULE_1__["Column"].Schema.int),
                        x: col(pO, pW, _mol_data_db__WEBPACK_IMPORTED_MODULE_1__["Column"].Schema.float),
                        y: col(pO + pW, pW, _mol_data_db__WEBPACK_IMPORTED_MODULE_1__["Column"].Schema.float),
                        z: col(pO + 2 * pW, pW, _mol_data_db__WEBPACK_IMPORTED_MODULE_1__["Column"].Schema.float),
                        vx: hasVelocities ? col(vO, vW, _mol_data_db__WEBPACK_IMPORTED_MODULE_1__["Column"].Schema.float) : undef,
                        vy: hasVelocities ? col(vO + vW, vW, _mol_data_db__WEBPACK_IMPORTED_MODULE_1__["Column"].Schema.float) : undef,
                        vz: hasVelocities ? col(vO + 2 * vW, vW, _mol_data_db__WEBPACK_IMPORTED_MODULE_1__["Column"].Schema.float) : undef,
                    };
                    return [2 /*return*/, ret];
            }
        });
    });
}
/**
 * box vectors (free format, space separated reals), values:
 * v1(x) v2(y) v3(z) v1(y) v1(z) v2(x) v2(z) v3(x) v3(y),
 * the last 6 values may be omitted (they will be set to zero).
 * Gromacs only supports boxes with v1(y)=v1(z)=v2(z)=0.
 */
function handleBoxVectors(state) {
    var tokenizer = state.tokenizer;
    var values = _common_text_tokenizer__WEBPACK_IMPORTED_MODULE_2__["Tokenizer"].readLine(tokenizer).trim().split(/\s+/g);
    state.header.box = [+values[0], +values[1], +values[2]];
}
function parseInternal(data, ctx) {
    return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"])(this, void 0, void 0, function () {
        var tokenizer, structures, state, atoms, result;
        return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__generator"])(this, function (_a) {
            switch (_a.label) {
                case 0:
                    tokenizer = Object(_common_text_tokenizer__WEBPACK_IMPORTED_MODULE_2__["Tokenizer"])(data);
                    return [4 /*yield*/, ctx.update({ message: 'Parsing...', current: 0, max: data.length })];
                case 1:
                    _a.sent();
                    structures = [];
                    _a.label = 2;
                case 2:
                    if (!(tokenizer.position < data.length)) return [3 /*break*/, 4];
                    state = State(tokenizer, ctx);
                    handleTitleString(state);
                    handleNumberOfAtoms(state);
                    return [4 /*yield*/, handleAtoms(state)];
                case 3:
                    atoms = _a.sent();
                    handleBoxVectors(state);
                    structures.push({ header: state.header, atoms: atoms });
                    return [3 /*break*/, 2];
                case 4:
                    result = { structures: structures };
                    return [2 /*return*/, _result__WEBPACK_IMPORTED_MODULE_4__["ReaderResult"].success(result)];
            }
        });
    });
}
function parseGRO(data) {
    var _this = this;
    return _mol_task__WEBPACK_IMPORTED_MODULE_5__["Task"].create('Parse GRO', function (ctx) { return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"])(_this, void 0, void 0, function () {
        return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__generator"])(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, parseInternal(data, ctx)];
                case 1: return [2 /*return*/, _a.sent()];
            }
        });
    }); });
}
//# sourceMappingURL=parser.js.map

/***/ }),

/***/ "./lib/mol-io/reader/mol/parser.js":
/*!*****************************************!*\
  !*** ./lib/mol-io/reader/mol/parser.js ***!
  \*****************************************/
/*! exports provided: handleAtoms, handleBonds, parseMol */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "handleAtoms", function() { return handleAtoms; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "handleBonds", function() { return handleBonds; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "parseMol", function() { return parseMol; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _mol_data_db__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../../mol-data/db */ "./lib/mol-data/db.js");
/* harmony import */ var _mol_task__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../../mol-task */ "./lib/mol-task/index.js");
/* harmony import */ var _common_text_column_token__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../common/text/column/token */ "./lib/mol-io/reader/common/text/column/token.js");
/* harmony import */ var _common_text_tokenizer__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../common/text/tokenizer */ "./lib/mol-io/reader/common/text/tokenizer.js");
/* harmony import */ var _result__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../result */ "./lib/mol-io/reader/result.js");
/**
 * Copyright (c) 2020 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author David Sehnal <david.sehnal@gmail.com>
 */






function handleAtoms(tokenizer, count) {
    var x = _common_text_tokenizer__WEBPACK_IMPORTED_MODULE_4__["TokenBuilder"].create(tokenizer.data, count * 2);
    var y = _common_text_tokenizer__WEBPACK_IMPORTED_MODULE_4__["TokenBuilder"].create(tokenizer.data, count * 2);
    var z = _common_text_tokenizer__WEBPACK_IMPORTED_MODULE_4__["TokenBuilder"].create(tokenizer.data, count * 2);
    var type_symbol = _common_text_tokenizer__WEBPACK_IMPORTED_MODULE_4__["TokenBuilder"].create(tokenizer.data, count * 2);
    for (var i = 0; i < count; ++i) {
        _common_text_tokenizer__WEBPACK_IMPORTED_MODULE_4__["Tokenizer"].markLine(tokenizer);
        var s = tokenizer.tokenStart, position = tokenizer.position;
        _common_text_tokenizer__WEBPACK_IMPORTED_MODULE_4__["Tokenizer"].trim(tokenizer, s, s + 10);
        _common_text_tokenizer__WEBPACK_IMPORTED_MODULE_4__["TokenBuilder"].addUnchecked(x, tokenizer.tokenStart, tokenizer.tokenEnd);
        _common_text_tokenizer__WEBPACK_IMPORTED_MODULE_4__["Tokenizer"].trim(tokenizer, s + 10, s + 20);
        _common_text_tokenizer__WEBPACK_IMPORTED_MODULE_4__["TokenBuilder"].addUnchecked(y, tokenizer.tokenStart, tokenizer.tokenEnd);
        _common_text_tokenizer__WEBPACK_IMPORTED_MODULE_4__["Tokenizer"].trim(tokenizer, s + 20, s + 30);
        _common_text_tokenizer__WEBPACK_IMPORTED_MODULE_4__["TokenBuilder"].addUnchecked(z, tokenizer.tokenStart, tokenizer.tokenEnd);
        _common_text_tokenizer__WEBPACK_IMPORTED_MODULE_4__["Tokenizer"].trim(tokenizer, s + 31, s + 34);
        _common_text_tokenizer__WEBPACK_IMPORTED_MODULE_4__["TokenBuilder"].addUnchecked(type_symbol, tokenizer.tokenStart, tokenizer.tokenEnd);
        tokenizer.position = position;
    }
    return {
        count: count,
        x: Object(_common_text_column_token__WEBPACK_IMPORTED_MODULE_3__["default"])(x)(_mol_data_db__WEBPACK_IMPORTED_MODULE_1__["Column"].Schema.float),
        y: Object(_common_text_column_token__WEBPACK_IMPORTED_MODULE_3__["default"])(y)(_mol_data_db__WEBPACK_IMPORTED_MODULE_1__["Column"].Schema.float),
        z: Object(_common_text_column_token__WEBPACK_IMPORTED_MODULE_3__["default"])(z)(_mol_data_db__WEBPACK_IMPORTED_MODULE_1__["Column"].Schema.float),
        type_symbol: Object(_common_text_column_token__WEBPACK_IMPORTED_MODULE_3__["default"])(type_symbol)(_mol_data_db__WEBPACK_IMPORTED_MODULE_1__["Column"].Schema.str)
    };
}
function handleBonds(tokenizer, count) {
    var atomIdxA = _common_text_tokenizer__WEBPACK_IMPORTED_MODULE_4__["TokenBuilder"].create(tokenizer.data, count * 2);
    var atomIdxB = _common_text_tokenizer__WEBPACK_IMPORTED_MODULE_4__["TokenBuilder"].create(tokenizer.data, count * 2);
    var order = _common_text_tokenizer__WEBPACK_IMPORTED_MODULE_4__["TokenBuilder"].create(tokenizer.data, count * 2);
    for (var i = 0; i < count; ++i) {
        _common_text_tokenizer__WEBPACK_IMPORTED_MODULE_4__["Tokenizer"].markLine(tokenizer);
        var s = tokenizer.tokenStart, position = tokenizer.position;
        _common_text_tokenizer__WEBPACK_IMPORTED_MODULE_4__["Tokenizer"].trim(tokenizer, s, s + 3);
        _common_text_tokenizer__WEBPACK_IMPORTED_MODULE_4__["TokenBuilder"].addUnchecked(atomIdxA, tokenizer.tokenStart, tokenizer.tokenEnd);
        _common_text_tokenizer__WEBPACK_IMPORTED_MODULE_4__["Tokenizer"].trim(tokenizer, s + 3, s + 6);
        _common_text_tokenizer__WEBPACK_IMPORTED_MODULE_4__["TokenBuilder"].addUnchecked(atomIdxB, tokenizer.tokenStart, tokenizer.tokenEnd);
        _common_text_tokenizer__WEBPACK_IMPORTED_MODULE_4__["Tokenizer"].trim(tokenizer, s + 6, s + 9);
        _common_text_tokenizer__WEBPACK_IMPORTED_MODULE_4__["TokenBuilder"].addUnchecked(order, tokenizer.tokenStart, tokenizer.tokenEnd);
        tokenizer.position = position;
    }
    return {
        count: count,
        atomIdxA: Object(_common_text_column_token__WEBPACK_IMPORTED_MODULE_3__["default"])(atomIdxA)(_mol_data_db__WEBPACK_IMPORTED_MODULE_1__["Column"].Schema.int),
        atomIdxB: Object(_common_text_column_token__WEBPACK_IMPORTED_MODULE_3__["default"])(atomIdxB)(_mol_data_db__WEBPACK_IMPORTED_MODULE_1__["Column"].Schema.int),
        order: Object(_common_text_column_token__WEBPACK_IMPORTED_MODULE_3__["default"])(order)(_mol_data_db__WEBPACK_IMPORTED_MODULE_1__["Column"].Schema.int)
    };
}
function parseInternal(data) {
    var tokenizer = Object(_common_text_tokenizer__WEBPACK_IMPORTED_MODULE_4__["Tokenizer"])(data);
    var title = _common_text_tokenizer__WEBPACK_IMPORTED_MODULE_4__["Tokenizer"].readLine(tokenizer).trim();
    var program = _common_text_tokenizer__WEBPACK_IMPORTED_MODULE_4__["Tokenizer"].readLine(tokenizer).trim();
    var comment = _common_text_tokenizer__WEBPACK_IMPORTED_MODULE_4__["Tokenizer"].readLine(tokenizer).trim();
    var counts = _common_text_tokenizer__WEBPACK_IMPORTED_MODULE_4__["Tokenizer"].readLine(tokenizer);
    var atomCount = +counts.substr(0, 3), bondCount = +counts.substr(3, 3);
    var atoms = handleAtoms(tokenizer, atomCount);
    var bonds = handleBonds(tokenizer, bondCount);
    var result = {
        title: title,
        program: program,
        comment: comment,
        atoms: atoms,
        bonds: bonds
    };
    return _result__WEBPACK_IMPORTED_MODULE_5__["ReaderResult"].success(result);
}
function parseMol(data) {
    var _this = this;
    return _mol_task__WEBPACK_IMPORTED_MODULE_2__["Task"].create('Parse Mol', function () { return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"])(_this, void 0, void 0, function () {
        return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__generator"])(this, function (_a) {
            return [2 /*return*/, parseInternal(data)];
        });
    }); });
}
//# sourceMappingURL=parser.js.map

/***/ }),

/***/ "./lib/mol-io/reader/mol2/parser.js":
/*!******************************************!*\
  !*** ./lib/mol-io/reader/mol2/parser.js ***!
  \******************************************/
/*! exports provided: parseMol2 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "parseMol2", function() { return parseMol2; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _mol_data_db__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../../mol-data/db */ "./lib/mol-data/db.js");
/* harmony import */ var _common_text_tokenizer__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../common/text/tokenizer */ "./lib/mol-io/reader/common/text/tokenizer.js");
/* harmony import */ var _common_text_column_token__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../common/text/column/token */ "./lib/mol-io/reader/common/text/column/token.js");
/* harmony import */ var _result__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../result */ "./lib/mol-io/reader/result.js");
/* harmony import */ var _mol_task__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../../mol-task */ "./lib/mol-task/index.js");
/**
 * Copyright (c) 2017-2020 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author Zepei Xu <xuzepei19950617@gmail.com>
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */

//               NOTES
// When want to created undefined string column, must use
// undefStr = UndefinedColumn(molecule.num_atoms, ColumnType.str)
// but not
// const undefPooledStr = UndefinedColumn(molecule.num_atoms, ColumnType.pooledStr);
// because latter actuall return a column of zeros





var skipWhitespace = _common_text_tokenizer__WEBPACK_IMPORTED_MODULE_2__["Tokenizer"].skipWhitespace, eatValue = _common_text_tokenizer__WEBPACK_IMPORTED_MODULE_2__["Tokenizer"].eatValue, markLine = _common_text_tokenizer__WEBPACK_IMPORTED_MODULE_2__["Tokenizer"].markLine, getTokenString = _common_text_tokenizer__WEBPACK_IMPORTED_MODULE_2__["Tokenizer"].getTokenString, readLine = _common_text_tokenizer__WEBPACK_IMPORTED_MODULE_2__["Tokenizer"].readLine;
function createEmptyMolecule() {
    return {
        mol_name: '',
        num_atoms: 0,
        num_bonds: 0,
        num_subst: 0,
        num_feat: 0,
        num_sets: 0,
        mol_type: '',
        charge_type: '',
        status_bits: '',
        mol_comment: ''
    };
}
function State(tokenizer, runtimeCtx) {
    return {
        tokenizer: tokenizer,
        molecule: createEmptyMolecule(),
        runtimeCtx: runtimeCtx
    };
}
var reWhitespace = /\s+/g;
function handleMolecule(state) {
    var tokenizer = state.tokenizer, molecule = state.molecule;
    while (getTokenString(tokenizer) !== '@<TRIPOS>MOLECULE' && tokenizer.position < tokenizer.data.length) {
        markLine(tokenizer);
    }
    markLine(tokenizer);
    molecule.mol_name = getTokenString(tokenizer);
    markLine(tokenizer);
    var values = getTokenString(tokenizer).trim().split(reWhitespace);
    molecule.num_atoms = parseInt(values[0]);
    molecule.num_bonds = parseInt(values[1]);
    molecule.num_subst = parseInt(values[2]);
    molecule.num_feat = parseInt(values[3]);
    molecule.num_sets = parseInt(values[4]);
    markLine(tokenizer);
    var mol_type = getTokenString(tokenizer);
    if (mol_type.startsWith('@<TRIPOS>'))
        return;
    molecule.mol_type = mol_type;
    markLine(tokenizer);
    var charge_type = getTokenString(tokenizer);
    if (charge_type.startsWith('@<TRIPOS>'))
        return;
    molecule.charge_type = charge_type;
    markLine(tokenizer);
    var status_bits = getTokenString(tokenizer);
    if (status_bits.startsWith('@<TRIPOS>'))
        return;
    molecule.status_bits = status_bits;
    markLine(tokenizer);
    var mol_comment = getTokenString(tokenizer);
    if (mol_comment.startsWith('@<TRIPOS>'))
        return;
    molecule.mol_comment = mol_comment;
}
function handleAtoms(state) {
    return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"])(this, void 0, void 0, function () {
        var tokenizer, molecule, initialTokenizerPosition, initialTokenizerLineNumber, firstLine, firstLineArray, columnCount, atom_idTokens, atom_nameTokens, xTokens, yTokens, zTokens, atom_typeTokens, subst_idTokens, subst_nameTokens, chargeTokens, status_bitTokens, undefFloat, undefInt, undefStr, length, linesAlreadyRead, ret;
        return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__generator"])(this, function (_a) {
            switch (_a.label) {
                case 0:
                    tokenizer = state.tokenizer, molecule = state.molecule;
                    // skip empty lines and '@<TRIPOS>ATOM'
                    while (getTokenString(tokenizer) !== '@<TRIPOS>ATOM' && tokenizer.position < tokenizer.data.length) {
                        markLine(tokenizer);
                    }
                    initialTokenizerPosition = tokenizer.position;
                    initialTokenizerLineNumber = tokenizer.lineNumber;
                    firstLine = readLine(tokenizer);
                    firstLineArray = firstLine.trim().split(/\s+/g);
                    columnCount = firstLineArray.length;
                    atom_idTokens = _common_text_tokenizer__WEBPACK_IMPORTED_MODULE_2__["TokenBuilder"].create(tokenizer.data, molecule.num_atoms * 2);
                    atom_nameTokens = _common_text_tokenizer__WEBPACK_IMPORTED_MODULE_2__["TokenBuilder"].create(tokenizer.data, molecule.num_atoms * 2);
                    xTokens = _common_text_tokenizer__WEBPACK_IMPORTED_MODULE_2__["TokenBuilder"].create(tokenizer.data, molecule.num_atoms * 2);
                    yTokens = _common_text_tokenizer__WEBPACK_IMPORTED_MODULE_2__["TokenBuilder"].create(tokenizer.data, molecule.num_atoms * 2);
                    zTokens = _common_text_tokenizer__WEBPACK_IMPORTED_MODULE_2__["TokenBuilder"].create(tokenizer.data, molecule.num_atoms * 2);
                    atom_typeTokens = _common_text_tokenizer__WEBPACK_IMPORTED_MODULE_2__["TokenBuilder"].create(tokenizer.data, molecule.num_atoms * 2);
                    subst_idTokens = _common_text_tokenizer__WEBPACK_IMPORTED_MODULE_2__["TokenBuilder"].create(tokenizer.data, molecule.num_atoms * 2);
                    subst_nameTokens = _common_text_tokenizer__WEBPACK_IMPORTED_MODULE_2__["TokenBuilder"].create(tokenizer.data, molecule.num_atoms * 2);
                    chargeTokens = _common_text_tokenizer__WEBPACK_IMPORTED_MODULE_2__["TokenBuilder"].create(tokenizer.data, molecule.num_atoms * 2);
                    status_bitTokens = _common_text_tokenizer__WEBPACK_IMPORTED_MODULE_2__["TokenBuilder"].create(tokenizer.data, molecule.num_atoms * 2);
                    undefFloat = _mol_data_db__WEBPACK_IMPORTED_MODULE_1__["Column"].Undefined(molecule.num_atoms, _mol_data_db__WEBPACK_IMPORTED_MODULE_1__["Column"].Schema.float);
                    undefInt = _mol_data_db__WEBPACK_IMPORTED_MODULE_1__["Column"].Undefined(molecule.num_atoms, _mol_data_db__WEBPACK_IMPORTED_MODULE_1__["Column"].Schema.int);
                    undefStr = _mol_data_db__WEBPACK_IMPORTED_MODULE_1__["Column"].Undefined(molecule.num_atoms, _mol_data_db__WEBPACK_IMPORTED_MODULE_1__["Column"].Schema.str);
                    tokenizer.position = initialTokenizerPosition;
                    tokenizer.lineNumber = initialTokenizerLineNumber;
                    length = tokenizer.length;
                    linesAlreadyRead = 0;
                    return [4 /*yield*/, Object(_mol_task__WEBPACK_IMPORTED_MODULE_5__["chunkedSubtask"])(state.runtimeCtx, 100000, void 0, function (chunkSize) {
                            var linesToRead = Math.min(molecule.num_atoms - linesAlreadyRead, chunkSize);
                            for (var i = 0; i < linesToRead; i++) {
                                for (var j = 0; j < columnCount; j++) {
                                    skipWhitespace(tokenizer);
                                    tokenizer.tokenStart = tokenizer.position;
                                    eatValue(tokenizer);
                                    switch (j) {
                                        case 0:
                                            _common_text_tokenizer__WEBPACK_IMPORTED_MODULE_2__["TokenBuilder"].addUnchecked(atom_idTokens, tokenizer.tokenStart, tokenizer.tokenEnd);
                                            break;
                                        case 1:
                                            _common_text_tokenizer__WEBPACK_IMPORTED_MODULE_2__["TokenBuilder"].addUnchecked(atom_nameTokens, tokenizer.tokenStart, tokenizer.tokenEnd);
                                            break;
                                        case 2:
                                            _common_text_tokenizer__WEBPACK_IMPORTED_MODULE_2__["TokenBuilder"].addUnchecked(xTokens, tokenizer.tokenStart, tokenizer.tokenEnd);
                                            break;
                                        case 3:
                                            _common_text_tokenizer__WEBPACK_IMPORTED_MODULE_2__["TokenBuilder"].addUnchecked(yTokens, tokenizer.tokenStart, tokenizer.tokenEnd);
                                            break;
                                        case 4:
                                            _common_text_tokenizer__WEBPACK_IMPORTED_MODULE_2__["TokenBuilder"].addUnchecked(zTokens, tokenizer.tokenStart, tokenizer.tokenEnd);
                                            break;
                                        case 5:
                                            _common_text_tokenizer__WEBPACK_IMPORTED_MODULE_2__["TokenBuilder"].addUnchecked(atom_typeTokens, tokenizer.tokenStart, tokenizer.tokenEnd);
                                            break;
                                        case 6:
                                            _common_text_tokenizer__WEBPACK_IMPORTED_MODULE_2__["TokenBuilder"].addUnchecked(subst_idTokens, tokenizer.tokenStart, tokenizer.tokenEnd);
                                            break;
                                        case 7:
                                            _common_text_tokenizer__WEBPACK_IMPORTED_MODULE_2__["TokenBuilder"].addUnchecked(subst_nameTokens, tokenizer.tokenStart, tokenizer.tokenEnd);
                                            break;
                                        case 8:
                                            _common_text_tokenizer__WEBPACK_IMPORTED_MODULE_2__["TokenBuilder"].addUnchecked(chargeTokens, tokenizer.tokenStart, tokenizer.tokenEnd);
                                            break;
                                        case 9:
                                            _common_text_tokenizer__WEBPACK_IMPORTED_MODULE_2__["TokenBuilder"].addUnchecked(status_bitTokens, tokenizer.tokenStart, tokenizer.tokenEnd);
                                            break;
                                    }
                                }
                            }
                            linesAlreadyRead += linesToRead;
                            return linesToRead;
                        }, function (ctx) { return ctx.update({ message: 'Parsing...', current: tokenizer.position, max: length }); })];
                case 1:
                    _a.sent();
                    ret = {
                        count: molecule.num_atoms,
                        atom_id: Object(_common_text_column_token__WEBPACK_IMPORTED_MODULE_3__["default"])(atom_idTokens)(_mol_data_db__WEBPACK_IMPORTED_MODULE_1__["Column"].Schema.int),
                        atom_name: Object(_common_text_column_token__WEBPACK_IMPORTED_MODULE_3__["default"])(atom_nameTokens)(_mol_data_db__WEBPACK_IMPORTED_MODULE_1__["Column"].Schema.str),
                        x: Object(_common_text_column_token__WEBPACK_IMPORTED_MODULE_3__["default"])(xTokens)(_mol_data_db__WEBPACK_IMPORTED_MODULE_1__["Column"].Schema.float),
                        y: Object(_common_text_column_token__WEBPACK_IMPORTED_MODULE_3__["default"])(yTokens)(_mol_data_db__WEBPACK_IMPORTED_MODULE_1__["Column"].Schema.float),
                        z: Object(_common_text_column_token__WEBPACK_IMPORTED_MODULE_3__["default"])(zTokens)(_mol_data_db__WEBPACK_IMPORTED_MODULE_1__["Column"].Schema.float),
                        atom_type: columnCount > 5 ? Object(_common_text_column_token__WEBPACK_IMPORTED_MODULE_3__["default"])(atom_typeTokens)(_mol_data_db__WEBPACK_IMPORTED_MODULE_1__["Column"].Schema.str) : undefStr,
                        subst_id: columnCount > 6 ? Object(_common_text_column_token__WEBPACK_IMPORTED_MODULE_3__["default"])(subst_idTokens)(_mol_data_db__WEBPACK_IMPORTED_MODULE_1__["Column"].Schema.int) : undefInt,
                        subst_name: columnCount > 7 ? Object(_common_text_column_token__WEBPACK_IMPORTED_MODULE_3__["default"])(subst_nameTokens)(_mol_data_db__WEBPACK_IMPORTED_MODULE_1__["Column"].Schema.str) : undefStr,
                        charge: columnCount > 8 ? Object(_common_text_column_token__WEBPACK_IMPORTED_MODULE_3__["default"])(chargeTokens)(_mol_data_db__WEBPACK_IMPORTED_MODULE_1__["Column"].Schema.float) : undefFloat,
                        status_bit: columnCount > 9 ? Object(_common_text_column_token__WEBPACK_IMPORTED_MODULE_3__["default"])(status_bitTokens)(_mol_data_db__WEBPACK_IMPORTED_MODULE_1__["Column"].Schema.str) : undefStr,
                    };
                    return [2 /*return*/, ret];
            }
        });
    });
}
function handleBonds(state) {
    return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"])(this, void 0, void 0, function () {
        var tokenizer, molecule, initialTokenizerPosition, initialTokenizerLineNumber, firstLine, firstLineArray, columnCount, bond_idTokens, origin_bond_idTokens, target_bond_idTokens, bondTypeTokens, status_bitTokens, length, linesAlreadyRead, ret;
        return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__generator"])(this, function (_a) {
            switch (_a.label) {
                case 0:
                    tokenizer = state.tokenizer, molecule = state.molecule;
                    while (getTokenString(tokenizer) !== '@<TRIPOS>BOND' && tokenizer.position < tokenizer.data.length) {
                        markLine(tokenizer);
                    }
                    initialTokenizerPosition = tokenizer.position;
                    initialTokenizerLineNumber = tokenizer.lineNumber;
                    firstLine = readLine(tokenizer);
                    firstLineArray = firstLine.trim().split(/\s+/g);
                    columnCount = firstLineArray.length;
                    bond_idTokens = _common_text_tokenizer__WEBPACK_IMPORTED_MODULE_2__["TokenBuilder"].create(tokenizer.data, molecule.num_bonds * 2);
                    origin_bond_idTokens = _common_text_tokenizer__WEBPACK_IMPORTED_MODULE_2__["TokenBuilder"].create(tokenizer.data, molecule.num_bonds * 2);
                    target_bond_idTokens = _common_text_tokenizer__WEBPACK_IMPORTED_MODULE_2__["TokenBuilder"].create(tokenizer.data, molecule.num_bonds * 2);
                    bondTypeTokens = _common_text_tokenizer__WEBPACK_IMPORTED_MODULE_2__["TokenBuilder"].create(tokenizer.data, molecule.num_bonds * 2);
                    status_bitTokens = _common_text_tokenizer__WEBPACK_IMPORTED_MODULE_2__["TokenBuilder"].create(tokenizer.data, molecule.num_bonds * 2);
                    tokenizer.position = initialTokenizerPosition;
                    tokenizer.lineNumber = initialTokenizerLineNumber;
                    length = tokenizer.length;
                    linesAlreadyRead = 0;
                    return [4 /*yield*/, Object(_mol_task__WEBPACK_IMPORTED_MODULE_5__["chunkedSubtask"])(state.runtimeCtx, 100000, void 0, function (chunkSize) {
                            var linesToRead = Math.min(molecule.num_bonds - linesAlreadyRead, chunkSize);
                            for (var i = 0; i < linesToRead; i++) {
                                for (var j = 0; j < columnCount; j++) {
                                    skipWhitespace(tokenizer);
                                    tokenizer.tokenStart = tokenizer.position;
                                    eatValue(tokenizer);
                                    switch (j) {
                                        case 0:
                                            _common_text_tokenizer__WEBPACK_IMPORTED_MODULE_2__["TokenBuilder"].addUnchecked(bond_idTokens, tokenizer.tokenStart, tokenizer.tokenEnd);
                                            break;
                                        case 1:
                                            _common_text_tokenizer__WEBPACK_IMPORTED_MODULE_2__["TokenBuilder"].addUnchecked(origin_bond_idTokens, tokenizer.tokenStart, tokenizer.tokenEnd);
                                            break;
                                        case 2:
                                            _common_text_tokenizer__WEBPACK_IMPORTED_MODULE_2__["TokenBuilder"].addUnchecked(target_bond_idTokens, tokenizer.tokenStart, tokenizer.tokenEnd);
                                            break;
                                        case 3:
                                            _common_text_tokenizer__WEBPACK_IMPORTED_MODULE_2__["TokenBuilder"].addUnchecked(bondTypeTokens, tokenizer.tokenStart, tokenizer.tokenEnd);
                                            break;
                                        default:
                                            _common_text_tokenizer__WEBPACK_IMPORTED_MODULE_2__["TokenBuilder"].addUnchecked(status_bitTokens, tokenizer.tokenStart, tokenizer.tokenEnd);
                                            break;
                                    }
                                }
                            }
                            linesAlreadyRead += linesToRead;
                            return linesToRead;
                        }, function (ctx) { return ctx.update({ message: 'Parsing...', current: tokenizer.position, max: length }); })];
                case 1:
                    _a.sent();
                    ret = {
                        count: molecule.num_bonds,
                        bond_id: Object(_common_text_column_token__WEBPACK_IMPORTED_MODULE_3__["default"])(bond_idTokens)(_mol_data_db__WEBPACK_IMPORTED_MODULE_1__["Column"].Schema.int),
                        origin_atom_id: Object(_common_text_column_token__WEBPACK_IMPORTED_MODULE_3__["default"])(origin_bond_idTokens)(_mol_data_db__WEBPACK_IMPORTED_MODULE_1__["Column"].Schema.int),
                        target_atom_id: Object(_common_text_column_token__WEBPACK_IMPORTED_MODULE_3__["default"])(target_bond_idTokens)(_mol_data_db__WEBPACK_IMPORTED_MODULE_1__["Column"].Schema.int),
                        bond_type: Object(_common_text_column_token__WEBPACK_IMPORTED_MODULE_3__["default"])(bondTypeTokens)(_mol_data_db__WEBPACK_IMPORTED_MODULE_1__["Column"].Schema.str),
                        status_bits: columnCount > 4
                            ? Object(_common_text_column_token__WEBPACK_IMPORTED_MODULE_3__["default"])(status_bitTokens)(_mol_data_db__WEBPACK_IMPORTED_MODULE_1__["Column"].Schema.str)
                            : _mol_data_db__WEBPACK_IMPORTED_MODULE_1__["Column"].Undefined(molecule.num_bonds, _mol_data_db__WEBPACK_IMPORTED_MODULE_1__["Column"].Schema.str),
                    };
                    return [2 /*return*/, ret];
            }
        });
    });
}
function parseInternal(ctx, data, name) {
    return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"])(this, void 0, void 0, function () {
        var tokenizer, structures, state, atoms, bonds, result;
        return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__generator"])(this, function (_a) {
            switch (_a.label) {
                case 0:
                    tokenizer = Object(_common_text_tokenizer__WEBPACK_IMPORTED_MODULE_2__["Tokenizer"])(data);
                    ctx.update({ message: 'Parsing...', current: 0, max: data.length });
                    structures = [];
                    _a.label = 1;
                case 1:
                    if (!(tokenizer.position < data.length)) return [3 /*break*/, 4];
                    state = State(tokenizer, ctx);
                    handleMolecule(state);
                    return [4 /*yield*/, handleAtoms(state)];
                case 2:
                    atoms = _a.sent();
                    return [4 /*yield*/, handleBonds(state)];
                case 3:
                    bonds = _a.sent();
                    structures.push({ molecule: state.molecule, atoms: atoms, bonds: bonds });
                    skipWhitespace(tokenizer);
                    while (getTokenString(tokenizer) !== '@<TRIPOS>MOLECULE' && tokenizer.position < tokenizer.data.length) {
                        markLine(tokenizer);
                    }
                    return [3 /*break*/, 1];
                case 4:
                    result = { name: name, structures: structures };
                    return [2 /*return*/, _result__WEBPACK_IMPORTED_MODULE_4__["ReaderResult"].success(result)];
            }
        });
    });
}
function parseMol2(data, name) {
    var _this = this;
    return _mol_task__WEBPACK_IMPORTED_MODULE_5__["Task"].create('Parse MOL2', function (ctx) { return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"])(_this, void 0, void 0, function () {
        return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__generator"])(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, parseInternal(ctx, data, name)];
                case 1: return [2 /*return*/, _a.sent()];
            }
        });
    }); });
}
//# sourceMappingURL=parser.js.map

/***/ }),

/***/ "./lib/mol-io/reader/pdb/parser.js":
/*!*****************************************!*\
  !*** ./lib/mol-io/reader/pdb/parser.js ***!
  \*****************************************/
/*! exports provided: parsePDB */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "parsePDB", function() { return parsePDB; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _mol_task__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../../mol-task */ "./lib/mol-task/index.js");
/* harmony import */ var _result__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../result */ "./lib/mol-io/reader/result.js");
/* harmony import */ var _common_text_tokenizer__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../common/text/tokenizer */ "./lib/mol-io/reader/common/text/tokenizer.js");
/**
 * Copyright (c) 2019-2020 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author David Sehnal <david.sehnal@gmail.com>
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */




function parsePDB(data, id, isPdbqt) {
    var _this = this;
    if (isPdbqt === void 0) { isPdbqt = false; }
    return _mol_task__WEBPACK_IMPORTED_MODULE_1__["Task"].create('Parse PDB', function (ctx) { return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"])(_this, void 0, void 0, function () {
        var _a, _b;
        var _c;
        return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__generator"])(this, function (_d) {
            switch (_d.label) {
                case 0:
                    _b = (_a = _result__WEBPACK_IMPORTED_MODULE_2__["ReaderResult"]).success;
                    _c = {};
                    return [4 /*yield*/, _common_text_tokenizer__WEBPACK_IMPORTED_MODULE_3__["Tokenizer"].readAllLinesAsync(data, ctx)];
                case 1: return [2 /*return*/, _b.apply(_a, [(_c.lines = _d.sent(),
                            _c.id = id,
                            _c.isPdbqt = isPdbqt,
                            _c)])];
            }
        });
    }); });
}
//# sourceMappingURL=parser.js.map

/***/ }),

/***/ "./lib/mol-io/reader/ply/parser.js":
/*!*****************************************!*\
  !*** ./lib/mol-io/reader/ply/parser.js ***!
  \*****************************************/
/*! exports provided: parse, default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "parse", function() { return parse; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _result__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../result */ "./lib/mol-io/reader/result.js");
/* harmony import */ var _mol_task__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../../mol-task */ "./lib/mol-task/index.js");
/* harmony import */ var _schema__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./schema */ "./lib/mol-io/reader/ply/schema.js");
/* harmony import */ var _common_text_tokenizer__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../common/text/tokenizer */ "./lib/mol-io/reader/common/text/tokenizer.js");
/* harmony import */ var _mol_data_db__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../../mol-data/db */ "./lib/mol-data/db.js");
/* harmony import */ var _common_text_column_token__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../common/text/column/token */ "./lib/mol-io/reader/common/text/column/token.js");
/**
 * Copyright (c) 2019-2020 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */







function State(data, runtimeCtx) {
    var tokenizer = Object(_common_text_tokenizer__WEBPACK_IMPORTED_MODULE_4__["Tokenizer"])(data);
    return {
        data: data,
        tokenizer: tokenizer,
        runtimeCtx: runtimeCtx,
        comments: [],
        elementSpecs: [],
        elements: []
    };
}
function markHeader(tokenizer) {
    var endHeaderIndex = tokenizer.data.indexOf('end_header', tokenizer.position);
    if (endHeaderIndex === -1)
        throw new Error("no 'end_header' record found");
    // TODO set `tokenizer.lineNumber` correctly
    tokenizer.tokenStart = tokenizer.position;
    tokenizer.tokenEnd = endHeaderIndex;
    tokenizer.position = endHeaderIndex;
    _common_text_tokenizer__WEBPACK_IMPORTED_MODULE_4__["Tokenizer"].eatLine(tokenizer);
}
function parseHeader(state) {
    var tokenizer = state.tokenizer, comments = state.comments, elementSpecs = state.elementSpecs;
    markHeader(tokenizer);
    var headerLines = _common_text_tokenizer__WEBPACK_IMPORTED_MODULE_4__["Tokenizer"].getTokenString(tokenizer).split(/\r?\n/);
    if (headerLines[0] !== 'ply')
        throw new Error("data not starting with 'ply'");
    if (headerLines[1] !== 'format ascii 1.0')
        throw new Error("format not 'ascii 1.0'");
    var currentName;
    var currentCount;
    var currentProperties;
    function addCurrentElementSchema() {
        if (currentName !== undefined && currentCount !== undefined && currentProperties !== undefined) {
            var isList = false;
            for (var i = 0, il = currentProperties.length; i < il; ++i) {
                var p = currentProperties[i];
                if (p.kind === 'list') {
                    isList = true;
                    break;
                }
            }
            if (isList && currentProperties.length !== 1) {
                // TODO handle lists with appended properties
                //      currently only the list part will be accessible
            }
            if (isList) {
                elementSpecs.push({
                    kind: 'list',
                    name: currentName,
                    count: currentCount,
                    property: currentProperties[0]
                });
            }
            else {
                elementSpecs.push({
                    kind: 'table',
                    name: currentName,
                    count: currentCount,
                    properties: currentProperties
                });
            }
        }
    }
    for (var i = 2, il = headerLines.length; i < il; ++i) {
        var l = headerLines[i];
        var ls = l.split(' ');
        if (l.startsWith('comment')) {
            comments.push(l.substr(8));
        }
        else if (l.startsWith('element')) {
            addCurrentElementSchema();
            currentProperties = [];
            currentName = ls[1];
            currentCount = parseInt(ls[2]);
        }
        else if (l.startsWith('property')) {
            if (currentProperties === undefined)
                throw new Error("properties outside of element");
            if (ls[1] === 'list') {
                currentProperties.push({
                    kind: 'list',
                    countType: Object(_schema__WEBPACK_IMPORTED_MODULE_3__["PlyType"])(ls[2]),
                    dataType: Object(_schema__WEBPACK_IMPORTED_MODULE_3__["PlyType"])(ls[3]),
                    name: ls[4]
                });
            }
            else {
                currentProperties.push({
                    kind: 'column',
                    type: Object(_schema__WEBPACK_IMPORTED_MODULE_3__["PlyType"])(ls[1]),
                    name: ls[2]
                });
            }
        }
        else if (l.startsWith('end_header')) {
            addCurrentElementSchema();
        }
        else {
            console.warn('unknown header line');
        }
    }
}
function parseElements(state) {
    var elementSpecs = state.elementSpecs;
    for (var i = 0, il = elementSpecs.length; i < il; ++i) {
        var spec = elementSpecs[i];
        if (spec.kind === 'table')
            parseTableElement(state, spec);
        else if (spec.kind === 'list')
            parseListElement(state, spec);
    }
}
function getColumnSchema(type) {
    switch (type) {
        case 'char':
        case 'uchar':
        case 'int8':
        case 'uint8':
        case 'short':
        case 'ushort':
        case 'int16':
        case 'uint16':
        case 'int':
        case 'uint':
        case 'int32':
        case 'uint32':
            return _mol_data_db__WEBPACK_IMPORTED_MODULE_5__["Column"].Schema.int;
        case 'float':
        case 'double':
        case 'float32':
        case 'float64':
            return _mol_data_db__WEBPACK_IMPORTED_MODULE_5__["Column"].Schema.float;
    }
}
function parseTableElement(state, spec) {
    var elements = state.elements, tokenizer = state.tokenizer;
    var count = spec.count, properties = spec.properties;
    var propertyCount = properties.length;
    var propertyNames = [];
    var propertyTypes = [];
    var propertyTokens = [];
    var propertyColumns = new Map();
    for (var i = 0, il = propertyCount; i < il; ++i) {
        var tokens = _common_text_tokenizer__WEBPACK_IMPORTED_MODULE_4__["TokenBuilder"].create(tokenizer.data, count * 2);
        propertyTokens.push(tokens);
    }
    for (var i = 0, il = count; i < il; ++i) {
        for (var j = 0, jl = propertyCount; j < jl; ++j) {
            _common_text_tokenizer__WEBPACK_IMPORTED_MODULE_4__["Tokenizer"].skipWhitespace(tokenizer);
            _common_text_tokenizer__WEBPACK_IMPORTED_MODULE_4__["Tokenizer"].markStart(tokenizer);
            _common_text_tokenizer__WEBPACK_IMPORTED_MODULE_4__["Tokenizer"].eatValue(tokenizer);
            _common_text_tokenizer__WEBPACK_IMPORTED_MODULE_4__["TokenBuilder"].addUnchecked(propertyTokens[j], tokenizer.tokenStart, tokenizer.tokenEnd);
        }
    }
    for (var i = 0, il = propertyCount; i < il; ++i) {
        var _a = properties[i], type = _a.type, name_1 = _a.name;
        var column = Object(_common_text_column_token__WEBPACK_IMPORTED_MODULE_6__["TokenColumn"])(propertyTokens[i], getColumnSchema(type));
        propertyNames.push(name_1);
        propertyTypes.push(type);
        propertyColumns.set(name_1, column);
    }
    elements.push({
        kind: 'table',
        rowCount: count,
        propertyNames: propertyNames,
        propertyTypes: propertyTypes,
        getProperty: function (name) { return propertyColumns.get(name); }
    });
}
function parseListElement(state, spec) {
    var elements = state.elements, tokenizer = state.tokenizer;
    var count = spec.count, property = spec.property;
    // initial tokens size assumes triangle index data
    var tokens = _common_text_tokenizer__WEBPACK_IMPORTED_MODULE_4__["TokenBuilder"].create(tokenizer.data, count * 2 * 3);
    var offsets = new Uint32Array(count + 1);
    var entryCount = 0;
    for (var i = 0, il = count; i < il; ++i) {
        _common_text_tokenizer__WEBPACK_IMPORTED_MODULE_4__["Tokenizer"].skipWhitespace(tokenizer);
        _common_text_tokenizer__WEBPACK_IMPORTED_MODULE_4__["Tokenizer"].markStart(tokenizer);
        while (_common_text_tokenizer__WEBPACK_IMPORTED_MODULE_4__["Tokenizer"].skipWhitespace(tokenizer) !== 10) {
            ++entryCount;
            _common_text_tokenizer__WEBPACK_IMPORTED_MODULE_4__["Tokenizer"].markStart(tokenizer);
            _common_text_tokenizer__WEBPACK_IMPORTED_MODULE_4__["Tokenizer"].eatValue(tokenizer);
            _common_text_tokenizer__WEBPACK_IMPORTED_MODULE_4__["TokenBuilder"].addToken(tokens, tokenizer);
        }
        offsets[i + 1] = entryCount;
    }
    /** holds row value entries transiently */
    var listValue = {
        entries: [],
        count: 0
    };
    var column = Object(_common_text_column_token__WEBPACK_IMPORTED_MODULE_6__["TokenColumn"])(tokens, getColumnSchema(property.dataType));
    elements.push({
        kind: 'list',
        rowCount: count,
        name: property.name,
        type: property.dataType,
        value: function (row) {
            var offset = offsets[row] + 1;
            var count = column.value(offset - 1);
            for (var i = offset, il = offset + count; i < il; ++i) {
                listValue.entries[i - offset] = column.value(i);
            }
            listValue.count = count;
            return listValue;
        }
    });
}
function parseInternal(data, ctx) {
    return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"])(this, void 0, void 0, function () {
        var state, elements, elementSpecs, comments, elementNames, result;
        return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__generator"])(this, function (_a) {
            state = State(data, ctx);
            ctx.update({ message: 'Parsing...', current: 0, max: data.length });
            parseHeader(state);
            parseElements(state);
            elements = state.elements, elementSpecs = state.elementSpecs, comments = state.comments;
            elementNames = elementSpecs.map(function (s) { return s.name; });
            result = Object(_schema__WEBPACK_IMPORTED_MODULE_3__["PlyFile"])(elements, elementNames, comments);
            return [2 /*return*/, _result__WEBPACK_IMPORTED_MODULE_1__["ReaderResult"].success(result)];
        });
    });
}
function parse(data) {
    var _this = this;
    return _mol_task__WEBPACK_IMPORTED_MODULE_2__["Task"].create('Parse PLY', function (ctx) { return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"])(_this, void 0, void 0, function () {
        return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__generator"])(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, parseInternal(data, ctx)];
                case 1: return [2 /*return*/, _a.sent()];
            }
        });
    }); });
}
/* harmony default export */ __webpack_exports__["default"] = (parse);
//# sourceMappingURL=parser.js.map

/***/ }),

/***/ "./lib/mol-io/reader/ply/schema.js":
/*!*****************************************!*\
  !*** ./lib/mol-io/reader/ply/schema.js ***!
  \*****************************************/
/*! exports provided: PlyTypeByteLength, PlyTypes, PlyType, PlyFile */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "PlyTypeByteLength", function() { return PlyTypeByteLength; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "PlyTypes", function() { return PlyTypes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "PlyType", function() { return PlyType; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "PlyFile", function() { return PlyFile; });
/**
 * Copyright (c) 2019 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */
// http://paulbourke.net/dataformats/ply/
// https://en.wikipedia.org/wiki/PLY_(file_format)
var PlyTypeByteLength = {
    'char': 1,
    'uchar': 1,
    'short': 2,
    'ushort': 2,
    'int': 4,
    'uint': 4,
    'float': 4,
    'double': 8,
    'int8': 1,
    'uint8': 1,
    'int16': 2,
    'uint16': 2,
    'int32': 4,
    'uint32': 4,
    'float32': 4,
    'float64': 8
};
var PlyTypes = new Set(Object.keys(PlyTypeByteLength));
function PlyType(str) {
    if (!PlyTypes.has(str))
        throw new Error("unknown ply type '" + str + "'");
    return str;
}
function PlyFile(elements, elementNames, comments) {
    var elementMap = new Map();
    for (var i = 0, il = elementNames.length; i < il; ++i) {
        elementMap.set(elementNames[i], elements[i]);
    }
    return {
        comments: comments,
        elementNames: elementNames,
        getElement: function (name) {
            return elementMap.get(name);
        }
    };
}
//# sourceMappingURL=schema.js.map

/***/ }),

/***/ "./lib/mol-io/reader/psf/parser.js":
/*!*****************************************!*\
  !*** ./lib/mol-io/reader/psf/parser.js ***!
  \*****************************************/
/*! exports provided: parsePsf */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "parsePsf", function() { return parsePsf; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _mol_task__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../../mol-task */ "./lib/mol-task/index.js");
/* harmony import */ var _common_text_tokenizer__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../common/text/tokenizer */ "./lib/mol-io/reader/common/text/tokenizer.js");
/* harmony import */ var _result__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../result */ "./lib/mol-io/reader/result.js");
/* harmony import */ var _common_text_column_token__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../common/text/column/token */ "./lib/mol-io/reader/common/text/column/token.js");
/* harmony import */ var _mol_data_db__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../../mol-data/db */ "./lib/mol-data/db.js");
/**
 * Copyright (c) 2019 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */






var readLine = _common_text_tokenizer__WEBPACK_IMPORTED_MODULE_2__["Tokenizer"].readLine, skipWhitespace = _common_text_tokenizer__WEBPACK_IMPORTED_MODULE_2__["Tokenizer"].skipWhitespace, eatValue = _common_text_tokenizer__WEBPACK_IMPORTED_MODULE_2__["Tokenizer"].eatValue, eatLine = _common_text_tokenizer__WEBPACK_IMPORTED_MODULE_2__["Tokenizer"].eatLine, markStart = _common_text_tokenizer__WEBPACK_IMPORTED_MODULE_2__["Tokenizer"].markStart;
var reWhitespace = /\s+/;
var reTitle = /(^\*|REMARK)*/;
function State(tokenizer, runtimeCtx) {
    return {
        tokenizer: tokenizer,
        runtimeCtx: runtimeCtx,
    };
}
function handleAtoms(state, count) {
    return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"])(this, void 0, void 0, function () {
        var tokenizer, atomId, segmentName, residueId, residueName, atomName, atomType, charge, mass, length, linesAlreadyRead;
        return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__generator"])(this, function (_a) {
            switch (_a.label) {
                case 0:
                    tokenizer = state.tokenizer;
                    atomId = _common_text_tokenizer__WEBPACK_IMPORTED_MODULE_2__["TokenBuilder"].create(tokenizer.data, count * 2);
                    segmentName = _common_text_tokenizer__WEBPACK_IMPORTED_MODULE_2__["TokenBuilder"].create(tokenizer.data, count * 2);
                    residueId = _common_text_tokenizer__WEBPACK_IMPORTED_MODULE_2__["TokenBuilder"].create(tokenizer.data, count * 2);
                    residueName = _common_text_tokenizer__WEBPACK_IMPORTED_MODULE_2__["TokenBuilder"].create(tokenizer.data, count * 2);
                    atomName = _common_text_tokenizer__WEBPACK_IMPORTED_MODULE_2__["TokenBuilder"].create(tokenizer.data, count * 2);
                    atomType = _common_text_tokenizer__WEBPACK_IMPORTED_MODULE_2__["TokenBuilder"].create(tokenizer.data, count * 2);
                    charge = _common_text_tokenizer__WEBPACK_IMPORTED_MODULE_2__["TokenBuilder"].create(tokenizer.data, count * 2);
                    mass = _common_text_tokenizer__WEBPACK_IMPORTED_MODULE_2__["TokenBuilder"].create(tokenizer.data, count * 2);
                    length = tokenizer.length;
                    linesAlreadyRead = 0;
                    return [4 /*yield*/, Object(_mol_task__WEBPACK_IMPORTED_MODULE_1__["chunkedSubtask"])(state.runtimeCtx, 10, void 0, function (chunkSize) {
                            var linesToRead = Math.min(count - linesAlreadyRead, chunkSize);
                            for (var i = 0; i < linesToRead; ++i) {
                                for (var j = 0; j < 8; ++j) {
                                    skipWhitespace(tokenizer);
                                    markStart(tokenizer);
                                    eatValue(tokenizer);
                                    switch (j) {
                                        case 0:
                                            _common_text_tokenizer__WEBPACK_IMPORTED_MODULE_2__["TokenBuilder"].addUnchecked(atomId, tokenizer.tokenStart, tokenizer.tokenEnd);
                                            break;
                                        case 1:
                                            _common_text_tokenizer__WEBPACK_IMPORTED_MODULE_2__["TokenBuilder"].addUnchecked(segmentName, tokenizer.tokenStart, tokenizer.tokenEnd);
                                            break;
                                        case 2:
                                            _common_text_tokenizer__WEBPACK_IMPORTED_MODULE_2__["TokenBuilder"].addUnchecked(residueId, tokenizer.tokenStart, tokenizer.tokenEnd);
                                            break;
                                        case 3:
                                            _common_text_tokenizer__WEBPACK_IMPORTED_MODULE_2__["TokenBuilder"].addUnchecked(residueName, tokenizer.tokenStart, tokenizer.tokenEnd);
                                            break;
                                        case 4:
                                            _common_text_tokenizer__WEBPACK_IMPORTED_MODULE_2__["TokenBuilder"].addUnchecked(atomName, tokenizer.tokenStart, tokenizer.tokenEnd);
                                            break;
                                        case 5:
                                            _common_text_tokenizer__WEBPACK_IMPORTED_MODULE_2__["TokenBuilder"].addUnchecked(atomType, tokenizer.tokenStart, tokenizer.tokenEnd);
                                            break;
                                        case 6:
                                            _common_text_tokenizer__WEBPACK_IMPORTED_MODULE_2__["TokenBuilder"].addUnchecked(charge, tokenizer.tokenStart, tokenizer.tokenEnd);
                                            break;
                                        case 7:
                                            _common_text_tokenizer__WEBPACK_IMPORTED_MODULE_2__["TokenBuilder"].addUnchecked(mass, tokenizer.tokenStart, tokenizer.tokenEnd);
                                            break;
                                    }
                                }
                                // ignore any extra columns
                                eatLine(tokenizer);
                                markStart(tokenizer);
                            }
                            linesAlreadyRead += linesToRead;
                            return linesToRead;
                        }, function (ctx) { return ctx.update({ message: 'Parsing...', current: tokenizer.position, max: length }); })];
                case 1:
                    _a.sent();
                    return [2 /*return*/, {
                            count: count,
                            atomId: Object(_common_text_column_token__WEBPACK_IMPORTED_MODULE_4__["default"])(atomId)(_mol_data_db__WEBPACK_IMPORTED_MODULE_5__["Column"].Schema.int),
                            segmentName: Object(_common_text_column_token__WEBPACK_IMPORTED_MODULE_4__["default"])(segmentName)(_mol_data_db__WEBPACK_IMPORTED_MODULE_5__["Column"].Schema.str),
                            residueId: Object(_common_text_column_token__WEBPACK_IMPORTED_MODULE_4__["default"])(residueId)(_mol_data_db__WEBPACK_IMPORTED_MODULE_5__["Column"].Schema.int),
                            residueName: Object(_common_text_column_token__WEBPACK_IMPORTED_MODULE_4__["default"])(residueName)(_mol_data_db__WEBPACK_IMPORTED_MODULE_5__["Column"].Schema.str),
                            atomName: Object(_common_text_column_token__WEBPACK_IMPORTED_MODULE_4__["default"])(atomName)(_mol_data_db__WEBPACK_IMPORTED_MODULE_5__["Column"].Schema.str),
                            atomType: Object(_common_text_column_token__WEBPACK_IMPORTED_MODULE_4__["default"])(atomType)(_mol_data_db__WEBPACK_IMPORTED_MODULE_5__["Column"].Schema.str),
                            charge: Object(_common_text_column_token__WEBPACK_IMPORTED_MODULE_4__["default"])(charge)(_mol_data_db__WEBPACK_IMPORTED_MODULE_5__["Column"].Schema.float),
                            mass: Object(_common_text_column_token__WEBPACK_IMPORTED_MODULE_4__["default"])(mass)(_mol_data_db__WEBPACK_IMPORTED_MODULE_5__["Column"].Schema.float)
                        }];
            }
        });
    });
}
function handleBonds(state, count) {
    return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"])(this, void 0, void 0, function () {
        var tokenizer, atomIdA, atomIdB, length, bondsAlreadyRead;
        return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__generator"])(this, function (_a) {
            switch (_a.label) {
                case 0:
                    tokenizer = state.tokenizer;
                    atomIdA = _common_text_tokenizer__WEBPACK_IMPORTED_MODULE_2__["TokenBuilder"].create(tokenizer.data, count * 2);
                    atomIdB = _common_text_tokenizer__WEBPACK_IMPORTED_MODULE_2__["TokenBuilder"].create(tokenizer.data, count * 2);
                    length = tokenizer.length;
                    bondsAlreadyRead = 0;
                    return [4 /*yield*/, Object(_mol_task__WEBPACK_IMPORTED_MODULE_1__["chunkedSubtask"])(state.runtimeCtx, 10, void 0, function (chunkSize) {
                            var bondsToRead = Math.min(count - bondsAlreadyRead, chunkSize);
                            for (var i = 0; i < bondsToRead; ++i) {
                                for (var j = 0; j < 2; ++j) {
                                    skipWhitespace(tokenizer);
                                    markStart(tokenizer);
                                    eatValue(tokenizer);
                                    switch (j) {
                                        case 0:
                                            _common_text_tokenizer__WEBPACK_IMPORTED_MODULE_2__["TokenBuilder"].addUnchecked(atomIdA, tokenizer.tokenStart, tokenizer.tokenEnd);
                                            break;
                                        case 1:
                                            _common_text_tokenizer__WEBPACK_IMPORTED_MODULE_2__["TokenBuilder"].addUnchecked(atomIdB, tokenizer.tokenStart, tokenizer.tokenEnd);
                                            break;
                                    }
                                }
                            }
                            bondsAlreadyRead += bondsToRead;
                            return bondsToRead;
                        }, function (ctx) { return ctx.update({ message: 'Parsing...', current: tokenizer.position, max: length }); })];
                case 1:
                    _a.sent();
                    return [2 /*return*/, {
                            count: count,
                            atomIdA: Object(_common_text_column_token__WEBPACK_IMPORTED_MODULE_4__["default"])(atomIdA)(_mol_data_db__WEBPACK_IMPORTED_MODULE_5__["Column"].Schema.int),
                            atomIdB: Object(_common_text_column_token__WEBPACK_IMPORTED_MODULE_4__["default"])(atomIdB)(_mol_data_db__WEBPACK_IMPORTED_MODULE_5__["Column"].Schema.int),
                        }];
            }
        });
    });
}
function parseTitle(state, count) {
    var title = [];
    for (var i = 0; i < count; ++i) {
        var line = readLine(state.tokenizer);
        title.push(line.replace(reTitle, '').trim());
    }
    return title;
}
function parseInternal(data, ctx) {
    return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"])(this, void 0, void 0, function () {
        var tokenizer, state, title, atoms, bonds, id, line, numTitle, numAtoms, numBonds, result;
        return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__generator"])(this, function (_a) {
            switch (_a.label) {
                case 0:
                    tokenizer = Object(_common_text_tokenizer__WEBPACK_IMPORTED_MODULE_2__["Tokenizer"])(data);
                    state = State(tokenizer, ctx);
                    title = undefined;
                    atoms = undefined;
                    bonds = undefined;
                    id = readLine(state.tokenizer).trim();
                    _a.label = 1;
                case 1:
                    if (!(tokenizer.tokenEnd < tokenizer.length)) return [3 /*break*/, 8];
                    line = readLine(state.tokenizer).trim();
                    if (!line.includes('!NTITLE')) return [3 /*break*/, 2];
                    numTitle = parseInt(line.split(reWhitespace)[0]);
                    title = parseTitle(state, numTitle);
                    return [3 /*break*/, 7];
                case 2:
                    if (!line.includes('!NATOM')) return [3 /*break*/, 4];
                    numAtoms = parseInt(line.split(reWhitespace)[0]);
                    return [4 /*yield*/, handleAtoms(state, numAtoms)];
                case 3:
                    atoms = _a.sent();
                    return [3 /*break*/, 7];
                case 4:
                    if (!line.includes('!NBOND')) return [3 /*break*/, 6];
                    numBonds = parseInt(line.split(reWhitespace)[0]);
                    return [4 /*yield*/, handleBonds(state, numBonds)];
                case 5:
                    bonds = _a.sent();
                    return [3 /*break*/, 8]; // TODO: don't break when the below are implemented
                case 6:
                    if (line.includes('!NTHETA')) {
                        // TODO
                    }
                    else if (line.includes('!NPHI')) {
                        // TODO
                    }
                    else if (line.includes('!NIMPHI')) {
                        // TODO
                    }
                    else if (line.includes('!NDON')) {
                        // TODO
                    }
                    else if (line.includes('!NACC')) {
                        // TODO
                    }
                    else if (line.includes('!NNB')) {
                        // TODO
                    }
                    else if (line.includes('!NGRP NST2')) {
                        // TODO
                    }
                    else if (line.includes('!MOLNT')) {
                        // TODO
                    }
                    else if (line.includes('!NUMLP NUMLPH')) {
                        // TODO
                    }
                    else if (line.includes('!NCRTERM')) {
                        // TODO
                    }
                    _a.label = 7;
                case 7: return [3 /*break*/, 1];
                case 8:
                    if (title === undefined) {
                        title = [];
                    }
                    if (atoms === undefined) {
                        return [2 /*return*/, _result__WEBPACK_IMPORTED_MODULE_3__["ReaderResult"].error('no atoms data')];
                    }
                    if (bonds === undefined) {
                        return [2 /*return*/, _result__WEBPACK_IMPORTED_MODULE_3__["ReaderResult"].error('no bonds data')];
                    }
                    result = {
                        id: id,
                        title: title,
                        atoms: atoms,
                        bonds: bonds
                    };
                    return [2 /*return*/, _result__WEBPACK_IMPORTED_MODULE_3__["ReaderResult"].success(result)];
            }
        });
    });
}
function parsePsf(data) {
    var _this = this;
    return _mol_task__WEBPACK_IMPORTED_MODULE_1__["Task"].create('Parse PSF', function (ctx) { return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"])(_this, void 0, void 0, function () {
        return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__generator"])(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, parseInternal(data, ctx)];
                case 1: return [2 /*return*/, _a.sent()];
            }
        });
    }); });
}
//# sourceMappingURL=parser.js.map

/***/ }),

/***/ "./lib/mol-io/reader/result.js":
/*!*************************************!*\
  !*** ./lib/mol-io/reader/result.js ***!
  \*************************************/
/*! exports provided: ReaderResult */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ReaderResult", function() { return ReaderResult; });
/*
 * Copyright (c) 2017 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * from https://github.com/dsehnal/CIFTools.js
 * @author David Sehnal <david.sehnal@gmail.com>
 */
var ReaderResult;
(function (ReaderResult) {
    function error(message, line) {
        if (line === void 0) { line = -1; }
        return new Error(message, line);
    }
    ReaderResult.error = error;
    function success(result, warnings) {
        if (warnings === void 0) { warnings = []; }
        return new Success(result, warnings);
    }
    ReaderResult.success = success;
    var Error = /** @class */ (function () {
        function Error(message, line) {
            this.message = message;
            this.line = line;
            this.isError = true;
        }
        Error.prototype.toString = function () {
            if (this.line >= 0) {
                return "[Line " + this.line + "] " + this.message;
            }
            return this.message;
        };
        return Error;
    }());
    ReaderResult.Error = Error;
    var Success = /** @class */ (function () {
        function Success(result, warnings) {
            this.result = result;
            this.warnings = warnings;
            this.isError = false;
        }
        return Success;
    }());
    ReaderResult.Success = Success;
})(ReaderResult || (ReaderResult = {}));

//# sourceMappingURL=result.js.map

/***/ }),

/***/ "./lib/mol-io/reader/xtc/parser.js":
/*!*****************************************!*\
  !*** ./lib/mol-io/reader/xtc/parser.js ***!
  \*****************************************/
/*! exports provided: parseXtc */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "parseXtc", function() { return parseXtc; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _mol_task__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../../mol-task */ "./lib/mol-task/index.js");
/* harmony import */ var _result__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../result */ "./lib/mol-io/reader/result.js");
/**
 * Copyright (c) 2020 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * Adapted from NGL.
 *
 * @author David Sehnal <david.sehnal@gmail.com>
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */



var MagicInts = new Uint32Array([
    0, 0, 0, 0, 0, 0, 0, 0, 0, 8, 10, 12, 16, 20, 25, 32, 40, 50, 64,
    80, 101, 128, 161, 203, 256, 322, 406, 512, 645, 812, 1024, 1290,
    1625, 2048, 2580, 3250, 4096, 5060, 6501, 8192, 10321, 13003,
    16384, 20642, 26007, 32768, 41285, 52015, 65536, 82570, 104031,
    131072, 165140, 208063, 262144, 330280, 416127, 524287, 660561,
    832255, 1048576, 1321122, 1664510, 2097152, 2642245, 3329021,
    4194304, 5284491, 6658042, 8388607, 10568983, 13316085, 16777216
]);
var FirstIdx = 9;
// const LastIdx = MagicInts.length
var Decoder;
(function (Decoder) {
    function sizeOfInt(size) {
        var num = 1;
        var numOfBits = 0;
        while (size >= num && numOfBits < 32) {
            numOfBits++;
            num <<= 1;
        }
        return numOfBits;
    }
    Decoder.sizeOfInt = sizeOfInt;
    var _tmpBytes = new Uint8Array(32);
    function sizeOfInts(numOfInts, sizes) {
        var numOfBytes = 1;
        var numOfBits = 0;
        _tmpBytes[0] = 1;
        for (var i = 0; i < numOfInts; i++) {
            var bytecnt = void 0;
            var tmp = 0;
            for (bytecnt = 0; bytecnt < numOfBytes; bytecnt++) {
                tmp += _tmpBytes[bytecnt] * sizes[i];
                _tmpBytes[bytecnt] = tmp & 0xff;
                tmp >>= 8;
            }
            while (tmp !== 0) {
                _tmpBytes[bytecnt++] = tmp & 0xff;
                tmp >>= 8;
            }
            numOfBytes = bytecnt;
        }
        var num = 1;
        numOfBytes--;
        while (_tmpBytes[numOfBytes] >= num) {
            numOfBits++;
            num *= 2;
        }
        return numOfBits + numOfBytes * 8;
    }
    Decoder.sizeOfInts = sizeOfInts;
    var _buffer = new ArrayBuffer(8 * 3);
    Decoder.buf = new Int32Array(_buffer);
    var uint32view = new Uint32Array(_buffer);
    function decodeBits(cbuf, offset, numOfBits1) {
        var numOfBits = numOfBits1;
        var mask = (1 << numOfBits) - 1;
        var lastBB0 = uint32view[1];
        var lastBB1 = uint32view[2];
        var cnt = Decoder.buf[0];
        var num = 0;
        while (numOfBits >= 8) {
            lastBB1 = (lastBB1 << 8) | cbuf[offset + cnt++];
            num |= (lastBB1 >> lastBB0) << (numOfBits - 8);
            numOfBits -= 8;
        }
        if (numOfBits > 0) {
            if (lastBB0 < numOfBits) {
                lastBB0 += 8;
                lastBB1 = (lastBB1 << 8) | cbuf[offset + cnt++];
            }
            lastBB0 -= numOfBits;
            num |= (lastBB1 >> lastBB0) & ((1 << numOfBits) - 1);
        }
        num &= mask;
        Decoder.buf[0] = cnt;
        Decoder.buf[1] = lastBB0;
        Decoder.buf[2] = lastBB1;
        return num;
    }
    Decoder.decodeBits = decodeBits;
    function decodeByte(cbuf, offset) {
        // special version of decodeBits with numOfBits = 8
        // const mask = 0xff; // (1 << 8) - 1;
        // let lastBB0 = uint32view[1];
        var lastBB1 = uint32view[2];
        var cnt = Decoder.buf[0];
        lastBB1 = (lastBB1 << 8) | cbuf[offset + cnt];
        Decoder.buf[0] = cnt + 1;
        // buf[1] = lastBB0;
        Decoder.buf[2] = lastBB1;
        return (lastBB1 >> uint32view[1]) & 0xff;
    }
    var intBytes = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
    // new Int32Array(32);
    function decodeInts(cbuf, offset, numOfBits1, sizes, nums) {
        var numOfBits = numOfBits1;
        var numOfBytes = 0;
        intBytes[0] = 0;
        intBytes[1] = 0;
        intBytes[2] = 0;
        intBytes[3] = 0;
        while (numOfBits > 8) {
            // this is inversed??? why??? because of the endiannness???
            intBytes[numOfBytes++] = decodeByte(cbuf, offset);
            numOfBits -= 8;
        }
        if (numOfBits > 0) {
            intBytes[numOfBytes++] = decodeBits(cbuf, offset, numOfBits);
        }
        for (var i = 2; i > 0; i--) {
            var num = 0;
            var s = sizes[i];
            for (var j = numOfBytes - 1; j >= 0; j--) {
                num = (num << 8) | intBytes[j];
                var t = (num / s) | 0;
                intBytes[j] = t;
                num = num - t * s;
            }
            nums[i] = num;
        }
        nums[0] = intBytes[0] | (intBytes[1] << 8) | (intBytes[2] << 16) | (intBytes[3] << 24);
    }
    Decoder.decodeInts = decodeInts;
})(Decoder || (Decoder = {}));
function undefinedError() {
    throw new Error('(xdrfile error) Undefined error.');
}
function parseInternal(ctx, data) {
    return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"])(this, void 0, void 0, function () {
        var dv, f, coordinates, boxes, times, minMaxInt, sizeint, bitsizeint, sizesmall, thiscoord, prevcoord, offset, buf, frameCoords, natoms, box, i, i, lfp, lsize, precision, bitsize, smallidx, tmpIdx, smaller, smallnum, adz, invPrecision, run_1, i, flag, isSmaller, k, tmpSwap, c;
        return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__generator"])(this, function (_a) {
            switch (_a.label) {
                case 0:
                    dv = new DataView(data.buffer, data.byteOffset);
                    f = {
                        frames: [],
                        boxes: [],
                        times: [],
                        timeOffset: 0,
                        deltaTime: 0
                    };
                    coordinates = f.frames;
                    boxes = f.boxes;
                    times = f.times;
                    minMaxInt = [0, 0, 0, 0, 0, 0];
                    sizeint = [0, 0, 0];
                    bitsizeint = [0, 0, 0];
                    sizesmall = [0, 0, 0];
                    thiscoord = [0.1, 0.1, 0.1];
                    prevcoord = [0.1, 0.1, 0.1];
                    offset = 0;
                    buf = Decoder.buf;
                    _a.label = 1;
                case 1:
                    if (false) {}
                    frameCoords = void 0;
                    natoms = dv.getInt32(offset + 4);
                    // const step = dv.getInt32(offset + 8)
                    offset += 12;
                    times.push(dv.getFloat32(offset));
                    offset += 4;
                    box = new Float32Array(9);
                    for (i = 0; i < 9; ++i) {
                        box[i] = dv.getFloat32(offset) * 10;
                        offset += 4;
                    }
                    boxes.push(box);
                    if (natoms <= 9) { // no compression
                        frameCoords = { count: natoms / 3, x: new Float32Array(natoms / 3), y: new Float32Array(natoms / 3), z: new Float32Array(natoms / 3) };
                        for (i = 0; i < natoms / 3; ++i) {
                            frameCoords.x[i] = dv.getFloat32(offset);
                            frameCoords.y[i] = dv.getFloat32(offset);
                            frameCoords.z[i] = dv.getFloat32(offset);
                            offset += 4;
                        }
                    }
                    else {
                        buf[0] = buf[1] = buf[2] = 0;
                        sizeint[0] = sizeint[1] = sizeint[2] = 0;
                        sizesmall[0] = sizesmall[1] = sizesmall[2] = 0;
                        bitsizeint[0] = bitsizeint[1] = bitsizeint[2] = 0;
                        thiscoord[0] = thiscoord[1] = thiscoord[2] = 0;
                        prevcoord[0] = prevcoord[1] = prevcoord[2] = 0;
                        frameCoords = { count: natoms, x: new Float32Array(natoms), y: new Float32Array(natoms), z: new Float32Array(natoms) };
                        lfp = 0;
                        lsize = dv.getInt32(offset);
                        offset += 4;
                        precision = dv.getFloat32(offset);
                        offset += 4;
                        minMaxInt[0] = dv.getInt32(offset);
                        minMaxInt[1] = dv.getInt32(offset + 4);
                        minMaxInt[2] = dv.getInt32(offset + 8);
                        minMaxInt[3] = dv.getInt32(offset + 12);
                        minMaxInt[4] = dv.getInt32(offset + 16);
                        minMaxInt[5] = dv.getInt32(offset + 20);
                        sizeint[0] = minMaxInt[3] - minMaxInt[0] + 1;
                        sizeint[1] = minMaxInt[4] - minMaxInt[1] + 1;
                        sizeint[2] = minMaxInt[5] - minMaxInt[2] + 1;
                        offset += 24;
                        bitsize = void 0;
                        if ((sizeint[0] | sizeint[1] | sizeint[2]) > 0xffffff) {
                            bitsizeint[0] = Decoder.sizeOfInt(sizeint[0]);
                            bitsizeint[1] = Decoder.sizeOfInt(sizeint[1]);
                            bitsizeint[2] = Decoder.sizeOfInt(sizeint[2]);
                            bitsize = 0; // flag the use of large sizes
                        }
                        else {
                            bitsize = Decoder.sizeOfInts(3, sizeint);
                        }
                        smallidx = dv.getInt32(offset);
                        offset += 4;
                        tmpIdx = smallidx - 1;
                        tmpIdx = (FirstIdx > tmpIdx) ? FirstIdx : tmpIdx;
                        smaller = (MagicInts[tmpIdx] / 2) | 0;
                        smallnum = (MagicInts[smallidx] / 2) | 0;
                        sizesmall[0] = sizesmall[1] = sizesmall[2] = MagicInts[smallidx];
                        adz = Math.ceil(dv.getInt32(offset) / 4) * 4;
                        offset += 4;
                        invPrecision = 1.0 / precision;
                        run_1 = 0;
                        i = 0;
                        // const buf8 = new Uint8Array(data.buffer, data.byteOffset + offset, 32 * 4); // 229...
                        thiscoord[0] = thiscoord[1] = thiscoord[2] = 0;
                        while (i < lsize) {
                            if (bitsize === 0) {
                                thiscoord[0] = Decoder.decodeBits(data, offset, bitsizeint[0]);
                                thiscoord[1] = Decoder.decodeBits(data, offset, bitsizeint[1]);
                                thiscoord[2] = Decoder.decodeBits(data, offset, bitsizeint[2]);
                            }
                            else {
                                Decoder.decodeInts(data, offset, bitsize, sizeint, thiscoord);
                            }
                            i++;
                            thiscoord[0] += minMaxInt[0];
                            thiscoord[1] += minMaxInt[1];
                            thiscoord[2] += minMaxInt[2];
                            prevcoord[0] = thiscoord[0];
                            prevcoord[1] = thiscoord[1];
                            prevcoord[2] = thiscoord[2];
                            flag = Decoder.decodeBits(data, offset, 1);
                            isSmaller = 0;
                            if (flag === 1) {
                                run_1 = Decoder.decodeBits(data, offset, 5);
                                isSmaller = run_1 % 3;
                                run_1 -= isSmaller;
                                isSmaller--;
                            }
                            // if ((lfp-ptrstart)+run > size3){
                            //   fprintf(stderr, "(xdrfile error) Buffer overrun during decompression.\n");
                            //   return 0;
                            // }
                            if (run_1 > 0) {
                                thiscoord[0] = thiscoord[1] = thiscoord[2] = 0;
                                for (k = 0; k < run_1; k += 3) {
                                    Decoder.decodeInts(data, offset, smallidx, sizesmall, thiscoord);
                                    i++;
                                    thiscoord[0] += prevcoord[0] - smallnum;
                                    thiscoord[1] += prevcoord[1] - smallnum;
                                    thiscoord[2] += prevcoord[2] - smallnum;
                                    if (k === 0) {
                                        tmpSwap = thiscoord[0];
                                        thiscoord[0] = prevcoord[0];
                                        prevcoord[0] = tmpSwap;
                                        tmpSwap = thiscoord[1];
                                        thiscoord[1] = prevcoord[1];
                                        prevcoord[1] = tmpSwap;
                                        tmpSwap = thiscoord[2];
                                        thiscoord[2] = prevcoord[2];
                                        prevcoord[2] = tmpSwap;
                                        frameCoords.x[lfp] = prevcoord[0] * invPrecision;
                                        frameCoords.y[lfp] = prevcoord[1] * invPrecision;
                                        frameCoords.z[lfp] = prevcoord[2] * invPrecision;
                                        lfp++;
                                    }
                                    else {
                                        prevcoord[0] = thiscoord[0];
                                        prevcoord[1] = thiscoord[1];
                                        prevcoord[2] = thiscoord[2];
                                    }
                                    frameCoords.x[lfp] = thiscoord[0] * invPrecision;
                                    frameCoords.y[lfp] = thiscoord[1] * invPrecision;
                                    frameCoords.z[lfp] = thiscoord[2] * invPrecision;
                                    lfp++;
                                }
                            }
                            else {
                                frameCoords.x[lfp] = thiscoord[0] * invPrecision;
                                frameCoords.y[lfp] = thiscoord[1] * invPrecision;
                                frameCoords.z[lfp] = thiscoord[2] * invPrecision;
                                lfp++;
                            }
                            smallidx += isSmaller;
                            if (isSmaller < 0) {
                                smallnum = smaller;
                                if (smallidx > FirstIdx) {
                                    smaller = (MagicInts[smallidx - 1] / 2) | 0;
                                }
                                else {
                                    smaller = 0;
                                }
                            }
                            else if (isSmaller > 0) {
                                smaller = smallnum;
                                smallnum = (MagicInts[smallidx] / 2) | 0;
                            }
                            sizesmall[0] = sizesmall[1] = sizesmall[2] = MagicInts[smallidx];
                            if (sizesmall[0] === 0 || sizesmall[1] === 0 || sizesmall[2] === 0) {
                                undefinedError();
                            }
                        }
                        offset += adz;
                    }
                    for (c = 0; c < natoms; c++) {
                        frameCoords.x[c] *= 10;
                        frameCoords.y[c] *= 10;
                        frameCoords.z[c] *= 10;
                    }
                    coordinates.push(frameCoords);
                    if (!ctx.shouldUpdate) return [3 /*break*/, 3];
                    return [4 /*yield*/, ctx.update({ current: offset, max: data.length })];
                case 2:
                    _a.sent();
                    _a.label = 3;
                case 3:
                    if (offset >= data.length)
                        return [3 /*break*/, 4];
                    return [3 /*break*/, 1];
                case 4:
                    if (times.length >= 1) {
                        f.timeOffset = times[0];
                    }
                    if (times.length >= 2) {
                        f.deltaTime = times[1] - times[0];
                    }
                    return [2 /*return*/, f];
            }
        });
    });
}
function parseXtc(data) {
    var _this = this;
    return _mol_task__WEBPACK_IMPORTED_MODULE_1__["Task"].create('Parse XTC', function (ctx) { return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"])(_this, void 0, void 0, function () {
        var file, e_1;
        return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__generator"])(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    ctx.update({ canAbort: true, message: 'Parsing trajectory...' });
                    return [4 /*yield*/, parseInternal(ctx, data)];
                case 1:
                    file = _a.sent();
                    return [2 /*return*/, _result__WEBPACK_IMPORTED_MODULE_2__["ReaderResult"].success(file)];
                case 2:
                    e_1 = _a.sent();
                    return [2 /*return*/, _result__WEBPACK_IMPORTED_MODULE_2__["ReaderResult"].error('' + e_1)];
                case 3: return [2 /*return*/];
            }
        });
    }); });
}
//# sourceMappingURL=parser.js.map

/***/ }),

/***/ "./lib/mol-io/writer/cif.js":
/*!**********************************!*\
  !*** ./lib/mol-io/writer/cif.js ***!
  \**********************************/
/*! exports provided: CifWriter */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CifWriter", function() { return CifWriter; });
/* harmony import */ var _cif_encoder_text__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./cif/encoder/text */ "./lib/mol-io/writer/cif/encoder/text.js");
/* harmony import */ var _cif_encoder_binary__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./cif/encoder/binary */ "./lib/mol-io/writer/cif/encoder/binary.js");
/* harmony import */ var _cif_encoder__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./cif/encoder */ "./lib/mol-io/writer/cif/encoder.js");
/* harmony import */ var _common_binary_cif__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../common/binary-cif */ "./lib/mol-io/common/binary-cif.js");
/**
 * Copyright (c) 2017 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author David Sehnal <david.sehnal@gmail.com>
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */




var CifWriter;
(function (CifWriter) {
    CifWriter.Encoder = _cif_encoder__WEBPACK_IMPORTED_MODULE_2__["Encoder"];
    CifWriter.Category = _cif_encoder__WEBPACK_IMPORTED_MODULE_2__["Category"];
    CifWriter.Field = _cif_encoder__WEBPACK_IMPORTED_MODULE_2__["Field"];
    CifWriter.Encoding = _common_binary_cif__WEBPACK_IMPORTED_MODULE_3__["ArrayEncoding"];
    function createEncoder(params) {
        var _a = params || {}, _b = _a.binary, binary = _b === void 0 ? false : _b, _c = _a.encoderName, encoderName = _c === void 0 ? 'mol*' : _c;
        return binary ? new _cif_encoder_binary__WEBPACK_IMPORTED_MODULE_1__["default"](encoderName, params ? params.binaryEncodingPovider : void 0, params ? !!params.binaryAutoClassifyEncoding : false) : new _cif_encoder_text__WEBPACK_IMPORTED_MODULE_0__["default"]();
    }
    CifWriter.createEncoder = createEncoder;
    function fields() {
        return CifWriter.Field.build();
    }
    CifWriter.fields = fields;
    var E = CifWriter.Encoding;
    CifWriter.Encodings = {
        deltaRLE: E.by(E.delta).and(E.runLength).and(E.integerPacking),
        fixedPoint2: E.by(E.fixedPoint(100)).and(E.delta).and(E.integerPacking),
        fixedPoint3: E.by(E.fixedPoint(1000)).and(E.delta).and(E.integerPacking),
    };
    function categoryInstance(fields, source) {
        return { fields: fields, source: [source] };
    }
    CifWriter.categoryInstance = categoryInstance;
    function createEncodingProviderFromCifFrame(frame) {
        return {
            get: function (c, f) {
                var cat = frame.categories[c];
                if (!cat)
                    return void 0;
                var ff = cat.getField(f);
                return ff && ff.binaryEncoding ? _common_binary_cif__WEBPACK_IMPORTED_MODULE_3__["ArrayEncoder"].fromEncoding(ff.binaryEncoding) : void 0;
            }
        };
    }
    CifWriter.createEncodingProviderFromCifFrame = createEncodingProviderFromCifFrame;
    ;
    function createEncodingProviderFromJsonConfig(hints) {
        return {
            get: function (c, f) {
                for (var i = 0; i < hints.length; i++) {
                    var hint = hints[i];
                    if (hint.categoryName === c && hint.columnName === f) {
                        return resolveEncoding(hint);
                    }
                }
            }
        };
    }
    CifWriter.createEncodingProviderFromJsonConfig = createEncodingProviderFromJsonConfig;
    function resolveEncoding(hint) {
        var precision = hint.precision;
        if (precision !== void 0) {
            var multiplier = Math.pow(10, precision);
            var fixedPoint = E.by(E.fixedPoint(multiplier));
            switch (hint.encoding) {
                case 'pack':
                    return fixedPoint.and(E.integerPacking);
                case 'rle':
                    return fixedPoint.and(E.runLength).and(E.integerPacking);
                case 'delta':
                    return fixedPoint.and(E.delta).and(E.integerPacking);
                case 'delta-rle':
                    return fixedPoint.and(E.delta).and(E.runLength).and(E.integerPacking);
            }
            ;
        }
        else {
            switch (hint.encoding) {
                case 'pack':
                    return E.by(E.integerPacking);
                case 'rle':
                    return E.by(E.runLength).and(E.integerPacking);
                case 'delta':
                    return E.by(E.delta).and(E.integerPacking);
                case 'delta-rle':
                    return E.by(E.delta).and(E.runLength).and(E.integerPacking);
            }
        }
        throw new Error('cannot be reached');
    }
})(CifWriter || (CifWriter = {}));
//# sourceMappingURL=cif.js.map

/***/ }),

/***/ "./lib/mol-io/writer/cif/encoder.js":
/*!******************************************!*\
  !*** ./lib/mol-io/writer/cif/encoder.js ***!
  \******************************************/
/*! exports provided: Field, Category, Encoder */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Field", function() { return Field; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Category", function() { return Category; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Encoder", function() { return Encoder; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _mol_data_iterator__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../../mol-data/iterator */ "./lib/mol-data/iterator.js");
/* harmony import */ var _common_binary_cif__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../common/binary-cif */ "./lib/mol-io/common/binary-cif.js");
/**
 * Copyright (c) 2017-2018 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author David Sehnal <david.sehnal@gmail.com>
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */



var Field;
(function (Field) {
    function str(name, value, params) {
        return { name: name, type: 0 /* Str */, value: value, valueKind: params && params.valueKind, defaultFormat: params && params.encoder ? { encoder: params.encoder } : void 0, shouldInclude: params && params.shouldInclude };
    }
    Field.str = str;
    function int(name, value, params) {
        return {
            name: name,
            type: 1 /* Int */,
            value: value,
            valueKind: params && params.valueKind,
            defaultFormat: params ? { encoder: params.encoder, typedArray: params.typedArray } : void 0,
            shouldInclude: params && params.shouldInclude
        };
    }
    Field.int = int;
    function float(name, value, params) {
        return {
            name: name,
            type: 2 /* Float */,
            value: value,
            valueKind: params && params.valueKind,
            defaultFormat: params ? { encoder: params.encoder, typedArray: params.typedArray, digitCount: typeof params.digitCount !== 'undefined' ? params.digitCount : void 0 } : void 0,
            shouldInclude: params && params.shouldInclude
        };
    }
    Field.float = float;
    function index(name) {
        return int(name, function (e, d, i) { return i + 1; }, { typedArray: Int32Array, encoder: _common_binary_cif__WEBPACK_IMPORTED_MODULE_2__["ArrayEncoding"].by(_common_binary_cif__WEBPACK_IMPORTED_MODULE_2__["ArrayEncoding"].delta).and(_common_binary_cif__WEBPACK_IMPORTED_MODULE_2__["ArrayEncoding"].runLength).and(_common_binary_cif__WEBPACK_IMPORTED_MODULE_2__["ArrayEncoding"].integerPacking) });
    }
    Field.index = index;
    var Builder = /** @class */ (function () {
        function Builder() {
            this.fields = [];
        }
        Builder.prototype.index = function (name) {
            this.fields.push(Field.index(name));
            return this;
        };
        Builder.prototype.str = function (name, value, params) {
            this.fields.push(Field.str(name, value, params));
            return this;
        };
        Builder.prototype.int = function (name, value, params) {
            this.fields.push(Field.int(name, value, params));
            return this;
        };
        Builder.prototype.vec = function (name, values, params) {
            for (var i = 0; i < values.length; i++) {
                this.fields.push(Field.int(name + "[" + (i + 1) + "]", values[i], params));
            }
            return this;
        };
        Builder.prototype.float = function (name, value, params) {
            this.fields.push(Field.float(name, value, params));
            return this;
        };
        Builder.prototype.many = function (fields) {
            for (var i = 0; i < fields.length; i++)
                this.fields.push(fields[i]);
            return this;
        };
        Builder.prototype.add = function (field) {
            this.fields.push(field);
            return this;
        };
        Builder.prototype.getFields = function () { return this.fields; };
        return Builder;
    }());
    Field.Builder = Builder;
    function build() {
        return new Builder();
    }
    Field.build = build;
})(Field || (Field = {}));
var Category;
(function (Category) {
    Category.Empty = { fields: [], source: [] };
    function filterOf(directives) {
        var cat_whitelist = [];
        var cat_blacklist = [];
        var field_whitelist = [];
        var field_blacklist = [];
        for (var _i = 0, _a = directives.split(/[\r\n]+/); _i < _a.length; _i++) {
            var d = _a[_i];
            d = d.trim();
            // allow for empty lines in config
            if (d.length === 0)
                continue;
            // let ! denote blacklisted entries
            var blacklist = /^!/.test(d);
            if (blacklist)
                d = d.substr(1);
            var split = d.split(/\./);
            var field = split[1];
            var list = blacklist ? (field ? field_blacklist : cat_blacklist) : (field ? field_whitelist : cat_whitelist);
            list[list.length] = d;
            // ensure categories are aware about whitelisted columns
            if (field && !cat_whitelist.includes(split[0])) {
                cat_whitelist[cat_whitelist.length] = split[0];
            }
        }
        var wlcatcol = field_whitelist.map(function (it) { return it.split('.')[0]; });
        // blacklist has higher priority
        return {
            includeCategory: function (cat) {
                // block if category in black
                if (cat_blacklist.includes(cat)) {
                    return false;
                }
                else {
                    // if there is a whitelist, the category has to be explicitly allowed
                    return cat_whitelist.length <= 0 ||
                        // otherwise include if whitelist contains category
                        cat_whitelist.indexOf(cat) !== -1;
                }
            },
            includeField: function (cat, field) {
                // column names are assumed to follow the pattern 'category_name.column_name'
                var full = cat + '.' + field;
                if (field_blacklist.includes(full)) {
                    return false;
                }
                else {
                    // if for this category no whitelist entries exist
                    return !wlcatcol.includes(cat) ||
                        // otherwise must be specifically allowed
                        field_whitelist.includes(full);
                }
            }
        };
    }
    Category.filterOf = filterOf;
    Category.DefaultFilter = {
        includeCategory: function (cat) { return true; },
        includeField: function (cat, field) { return true; }
    };
    Category.DefaultFormatter = {
        getFormat: function (cat, field) { return void 0; }
    };
    function ofTable(table, indices) {
        if (indices) {
            return {
                fields: cifFieldsFromTableSchema(table._schema),
                source: [{ data: table, rowCount: indices.length, keys: function () { return _mol_data_iterator__WEBPACK_IMPORTED_MODULE_1__["default"].Array(indices); } }]
            };
        }
        return {
            fields: cifFieldsFromTableSchema(table._schema),
            source: [{ data: table, rowCount: table._rowCount }]
        };
    }
    Category.ofTable = ofTable;
})(Category || (Category = {}));
var Encoder;
(function (Encoder) {
    function writeDatabase(encoder, name, database) {
        encoder.startDataBlock(name);
        var _loop_1 = function (table) {
            encoder.writeCategory({ name: table, instance: function () { return Category.ofTable(database[table]); } });
        };
        for (var _i = 0, _a = database._tableNames; _i < _a.length; _i++) {
            var table = _a[_i];
            _loop_1(table);
        }
    }
    Encoder.writeDatabase = writeDatabase;
    function writeDatabaseCollection(encoder, collection) {
        for (var _i = 0, _a = Object.keys(collection); _i < _a.length; _i++) {
            var name_1 = _a[_i];
            writeDatabase(encoder, name_1, collection[name_1]);
        }
    }
    Encoder.writeDatabaseCollection = writeDatabaseCollection;
})(Encoder || (Encoder = {}));
function columnValue(k) {
    return function (i, d) { return d[k].value(i); };
}
function columnListValue(k) {
    return function (i, d) { return d[k].value(i).join(d[k].schema.separator); };
}
function columnTensorValue(k) {
    var coords = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        coords[_i - 1] = arguments[_i];
    }
    return function (i, d) {
        var _a;
        return (_a = d[k].schema.space).get.apply(_a, Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__spreadArrays"])([d[k].value(i)], coords));
    };
}
function columnValueKind(k) {
    return function (i, d) { return d[k].valueKind(i); };
}
function getTensorDefinitions(field, space) {
    var fieldDefinitions = [];
    var type = 2 /* Float */;
    var valueKind = columnValueKind(field);
    if (space.rank === 1) {
        var rows = space.dimensions[0];
        for (var i = 0; i < rows; i++) {
            var name_2 = field + "[" + (i + 1) + "]";
            fieldDefinitions.push({ name: name_2, type: type, value: columnTensorValue(field, i), valueKind: valueKind });
        }
    }
    else if (space.rank === 2) {
        var rows = space.dimensions[0], cols = space.dimensions[1];
        for (var i = 0; i < rows; i++) {
            for (var j = 0; j < cols; j++) {
                var name_3 = field + "[" + (i + 1) + "][" + (j + 1) + "]";
                fieldDefinitions.push({ name: name_3, type: type, value: columnTensorValue(field, i, j), valueKind: valueKind });
            }
        }
    }
    else if (space.rank === 3) {
        var d0 = space.dimensions[0], d1 = space.dimensions[1], d2 = space.dimensions[2];
        for (var i = 0; i < d0; i++) {
            for (var j = 0; j < d1; j++) {
                for (var k = 0; k < d2; k++) {
                    var name_4 = field + "[" + (i + 1) + "][" + (j + 1) + "][" + (k + 1) + "]";
                    fieldDefinitions.push({ name: name_4, type: type, value: columnTensorValue(field, i, j, k), valueKind: valueKind });
                }
            }
        }
    }
    else {
        throw new Error('Tensors with rank > 3 or rank 0 are currently not supported.');
    }
    return fieldDefinitions;
}
function cifFieldsFromTableSchema(schema) {
    var fields = [];
    for (var _i = 0, _a = Object.keys(schema); _i < _a.length; _i++) {
        var k = _a[_i];
        var t = schema[k];
        if (t.valueType === 'int') {
            fields.push({ name: k, type: 1 /* Int */, value: columnValue(k), valueKind: columnValueKind(k) });
        }
        else if (t.valueType === 'float') {
            fields.push({ name: k, type: 2 /* Float */, value: columnValue(k), valueKind: columnValueKind(k) });
        }
        else if (t.valueType === 'str') {
            fields.push({ name: k, type: 0 /* Str */, value: columnValue(k), valueKind: columnValueKind(k) });
        }
        else if (t.valueType === 'list') {
            fields.push({ name: k, type: 0 /* Str */, value: columnListValue(k), valueKind: columnValueKind(k) });
        }
        else if (t.valueType === 'tensor') {
            fields.push.apply(fields, getTensorDefinitions(k, t.space));
        }
        else {
            throw new Error("Unknown valueType " + t.valueType);
        }
    }
    return fields;
}
//# sourceMappingURL=encoder.js.map

/***/ }),

/***/ "./lib/mol-io/writer/cif/encoder/binary.js":
/*!*************************************************!*\
  !*** ./lib/mol-io/writer/cif/encoder/binary.js ***!
  \*************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _common_msgpack_encode__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../../common/msgpack/encode */ "./lib/mol-io/common/msgpack/encode.js");
/* harmony import */ var _common_binary_cif__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../../common/binary-cif */ "./lib/mol-io/common/binary-cif.js");
/* harmony import */ var _encoder__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../encoder */ "./lib/mol-io/writer/cif/encoder.js");
/* harmony import */ var _util__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./util */ "./lib/mol-io/writer/cif/encoder/util.js");
/* harmony import */ var _common_binary_cif_classifier__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../../common/binary-cif/classifier */ "./lib/mol-io/common/binary-cif/classifier.js");
/**
 * Copyright (c) 2017 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * Adapted from CIFTools.js (https://github.com/dsehnal/CIFTools.js)
 *
 * @author David Sehnal <david.sehnal@gmail.com>
 */





var BinaryEncoder = /** @class */ (function () {
    function BinaryEncoder(encoder, encodingProvider, autoClassify) {
        this.autoClassify = autoClassify;
        this.dataBlocks = [];
        this.filter = _encoder__WEBPACK_IMPORTED_MODULE_2__["Category"].DefaultFilter;
        this.formatter = _encoder__WEBPACK_IMPORTED_MODULE_2__["Category"].DefaultFormatter;
        this.isBinary = true;
        this.binaryEncodingProvider = void 0;
        this.binaryEncodingProvider = encodingProvider;
        this.data = {
            encoder: encoder,
            version: _common_binary_cif__WEBPACK_IMPORTED_MODULE_1__["VERSION"],
            dataBlocks: this.dataBlocks
        };
    }
    BinaryEncoder.prototype.setFilter = function (filter) {
        this.filter = filter || _encoder__WEBPACK_IMPORTED_MODULE_2__["Category"].DefaultFilter;
    };
    BinaryEncoder.prototype.isCategoryIncluded = function (name) {
        return this.filter.includeCategory(name);
    };
    BinaryEncoder.prototype.setFormatter = function (formatter) {
        this.formatter = formatter || _encoder__WEBPACK_IMPORTED_MODULE_2__["Category"].DefaultFormatter;
    };
    BinaryEncoder.prototype.startDataBlock = function (header) {
        this.dataBlocks.push({
            header: (header || '').replace(/[ \n\t]/g, '').toUpperCase(),
            categories: []
        });
    };
    BinaryEncoder.prototype.writeCategory = function (category, context, options) {
        if (!this.data) {
            throw new Error('The writer contents have already been encoded, no more writing.');
        }
        if (!this.dataBlocks.length) {
            throw new Error('No data block created.');
        }
        if (!(options === null || options === void 0 ? void 0 : options.ignoreFilter) && !this.filter.includeCategory(category.name))
            return;
        var _a = Object(_util__WEBPACK_IMPORTED_MODULE_3__["getCategoryInstanceData"])(category, context), instance = _a.instance, rowCount = _a.rowCount, source = _a.source;
        if (!rowCount)
            return;
        var cat = { name: '_' + category.name, columns: [], rowCount: rowCount };
        var fields = Object(_util__WEBPACK_IMPORTED_MODULE_3__["getIncludedFields"])(instance);
        for (var _i = 0, fields_1 = fields; _i < fields_1.length; _i++) {
            var f = fields_1[_i];
            if (!this.filter.includeField(category.name, f.name))
                continue;
            var format = this.formatter.getFormat(category.name, f.name);
            cat.columns.push(encodeField(category.name, f, source, rowCount, format, this.binaryEncodingProvider, this.autoClassify));
        }
        // no columns included.
        if (!cat.columns.length)
            return;
        this.dataBlocks[this.dataBlocks.length - 1].categories.push(cat);
    };
    BinaryEncoder.prototype.encode = function () {
        if (this.encodedData)
            return;
        this.encodedData = Object(_common_msgpack_encode__WEBPACK_IMPORTED_MODULE_0__["default"])(this.data);
        this.data = null;
        this.dataBlocks = null;
    };
    BinaryEncoder.prototype.writeTo = function (writer) {
        writer.writeBinary(this.encodedData);
    };
    BinaryEncoder.prototype.getData = function () {
        this.encode();
        return this.encodedData;
    };
    BinaryEncoder.prototype.getSize = function () {
        return this.encodedData.length;
    };
    return BinaryEncoder;
}());
/* harmony default export */ __webpack_exports__["default"] = (BinaryEncoder);
function getArrayCtor(field, format) {
    if (format && format.typedArray)
        return format.typedArray;
    if (field.defaultFormat && field.defaultFormat.typedArray)
        return field.defaultFormat.typedArray;
    if (field.type === 0 /* Str */)
        return Array;
    if (field.type === 1 /* Int */)
        return Int32Array;
    return Float64Array;
}
function getDefaultEncoder(type) {
    if (type === 0 /* Str */)
        return _common_binary_cif__WEBPACK_IMPORTED_MODULE_1__["ArrayEncoder"].by(_common_binary_cif__WEBPACK_IMPORTED_MODULE_1__["ArrayEncoding"].stringArray);
    return _common_binary_cif__WEBPACK_IMPORTED_MODULE_1__["ArrayEncoder"].by(_common_binary_cif__WEBPACK_IMPORTED_MODULE_1__["ArrayEncoding"].byteArray);
}
function tryGetEncoder(categoryName, field, format, provider) {
    if (format && format.encoder) {
        return format.encoder;
    }
    else if (field.defaultFormat && field.defaultFormat.encoder) {
        return field.defaultFormat.encoder;
    }
    else if (provider) {
        return provider.get(categoryName, field.name);
    }
    else {
        return void 0;
    }
}
function classify(type, data) {
    if (type === 0 /* Str */)
        return _common_binary_cif__WEBPACK_IMPORTED_MODULE_1__["ArrayEncoder"].by(_common_binary_cif__WEBPACK_IMPORTED_MODULE_1__["ArrayEncoding"].stringArray);
    if (type === 1 /* Int */)
        return Object(_common_binary_cif_classifier__WEBPACK_IMPORTED_MODULE_4__["classifyIntArray"])(data);
    return Object(_common_binary_cif_classifier__WEBPACK_IMPORTED_MODULE_4__["classifyFloatArray"])(data);
}
function encodeField(categoryName, field, data, totalCount, format, encoderProvider, autoClassify) {
    var _a = getFieldData(field, getArrayCtor(field, format), totalCount, data), array = _a.array, allPresent = _a.allPresent, mask = _a.mask;
    var encoder = tryGetEncoder(categoryName, field, format, encoderProvider);
    if (!encoder) {
        if (autoClassify)
            encoder = classify(field.type, array);
        else
            encoder = getDefaultEncoder(field.type);
    }
    var encoded = encoder.encode(array);
    var maskData = void 0;
    if (!allPresent) {
        var maskRLE = _common_binary_cif__WEBPACK_IMPORTED_MODULE_1__["ArrayEncoder"].by(_common_binary_cif__WEBPACK_IMPORTED_MODULE_1__["ArrayEncoding"].runLength).and(_common_binary_cif__WEBPACK_IMPORTED_MODULE_1__["ArrayEncoding"].byteArray).encode(mask);
        if (maskRLE.data.length < mask.length) {
            maskData = maskRLE;
        }
        else {
            maskData = _common_binary_cif__WEBPACK_IMPORTED_MODULE_1__["ArrayEncoder"].by(_common_binary_cif__WEBPACK_IMPORTED_MODULE_1__["ArrayEncoding"].byteArray).encode(mask);
        }
    }
    return {
        name: field.name,
        data: encoded,
        mask: maskData
    };
}
function getFieldData(field, arrayCtor, totalCount, data) {
    var isStr = field.type === 0 /* Str */;
    var array = new arrayCtor(totalCount);
    var mask = new Uint8Array(totalCount);
    var valueKind = field.valueKind;
    var getter = field.value;
    var allPresent = true;
    var offset = 0;
    for (var _d = 0; _d < data.length; _d++) {
        var d = data[_d].data;
        var keys = data[_d].keys();
        while (keys.hasNext) {
            var key = keys.move();
            var p = valueKind ? valueKind(key, d) : 0 /* Present */;
            if (p !== 0 /* Present */) {
                mask[offset] = p;
                if (isStr)
                    array[offset] = '';
                allPresent = false;
            }
            else {
                mask[offset] = 0 /* Present */;
                array[offset] = getter(key, d, offset);
            }
            offset++;
        }
    }
    return { array: array, allPresent: allPresent, mask: mask };
}
//# sourceMappingURL=binary.js.map

/***/ }),

/***/ "./lib/mol-io/writer/cif/encoder/text.js":
/*!***********************************************!*\
  !*** ./lib/mol-io/writer/cif/encoder/text.js ***!
  \***********************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _mol_util_string_builder__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../../../mol-util/string-builder */ "./lib/mol-util/string-builder.js");
/* harmony import */ var _encoder__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../encoder */ "./lib/mol-io/writer/cif/encoder.js");
/* harmony import */ var _util__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./util */ "./lib/mol-io/writer/cif/encoder/util.js");
/**
 * Copyright (c) 2017 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * Adapted from CIFTools.js (https://github.com/dsehnal/CIFTools.js)
 *
 * @author David Sehnal <david.sehnal@gmail.com>
 */



var TextEncoder = /** @class */ (function () {
    function TextEncoder() {
        this.builder = _mol_util_string_builder__WEBPACK_IMPORTED_MODULE_0__["default"].create();
        this.encoded = false;
        this.dataBlockCreated = false;
        this.filter = _encoder__WEBPACK_IMPORTED_MODULE_1__["Category"].DefaultFilter;
        this.formatter = _encoder__WEBPACK_IMPORTED_MODULE_1__["Category"].DefaultFormatter;
        this.isBinary = false;
        this.binaryEncodingProvider = void 0;
    }
    TextEncoder.prototype.setFilter = function (filter) {
        this.filter = filter || _encoder__WEBPACK_IMPORTED_MODULE_1__["Category"].DefaultFilter;
    };
    TextEncoder.prototype.isCategoryIncluded = function (name) {
        return this.filter.includeCategory(name);
    };
    TextEncoder.prototype.setFormatter = function (formatter) {
        this.formatter = formatter || _encoder__WEBPACK_IMPORTED_MODULE_1__["Category"].DefaultFormatter;
    };
    TextEncoder.prototype.startDataBlock = function (header) {
        this.dataBlockCreated = true;
        _mol_util_string_builder__WEBPACK_IMPORTED_MODULE_0__["default"].write(this.builder, "data_" + (header || '').replace(/[ \n\t]/g, '').toUpperCase() + "\n#\n");
    };
    TextEncoder.prototype.writeCategory = function (category, context, options) {
        if (this.encoded) {
            throw new Error('The writer contents have already been encoded, no more writing.');
        }
        if (!this.dataBlockCreated) {
            throw new Error('No data block created.');
        }
        if (!(options === null || options === void 0 ? void 0 : options.ignoreFilter) && !this.filter.includeCategory(category.name))
            return;
        var _a = Object(_util__WEBPACK_IMPORTED_MODULE_2__["getCategoryInstanceData"])(category, context), instance = _a.instance, rowCount = _a.rowCount, source = _a.source;
        if (!rowCount)
            return;
        if (rowCount === 1) {
            writeCifSingleRecord(category, instance, source, this.builder, this.filter, this.formatter);
        }
        else {
            writeCifLoop(category, instance, source, this.builder, this.filter, this.formatter);
        }
    };
    TextEncoder.prototype.encode = function () {
        this.encoded = true;
    };
    TextEncoder.prototype.writeTo = function (stream) {
        var chunks = _mol_util_string_builder__WEBPACK_IMPORTED_MODULE_0__["default"].getChunks(this.builder);
        for (var i = 0, _i = chunks.length; i < _i; i++) {
            stream.writeString(chunks[i]);
        }
    };
    TextEncoder.prototype.getSize = function () {
        return _mol_util_string_builder__WEBPACK_IMPORTED_MODULE_0__["default"].getSize(this.builder);
    };
    TextEncoder.prototype.getData = function () {
        return _mol_util_string_builder__WEBPACK_IMPORTED_MODULE_0__["default"].getString(this.builder);
    };
    return TextEncoder;
}());
/* harmony default export */ __webpack_exports__["default"] = (TextEncoder);
function writeValue(builder, data, key, f, floatPrecision, index) {
    var kind = f.valueKind;
    var p = kind ? kind(key, data) : 0 /* Present */;
    if (p !== 0 /* Present */) {
        if (p === 1 /* NotPresent */)
            writeNotPresent(builder);
        else
            writeUnknown(builder);
    }
    else {
        var val = f.value(key, data, index);
        var t = f.type;
        if (t === 0 /* Str */) {
            if (isMultiline(val)) {
                writeMultiline(builder, val);
                return true;
            }
            else {
                return writeChecked(builder, val);
            }
        }
        else if (t === 1 /* Int */) {
            writeInteger(builder, val);
        }
        else {
            writeFloat(builder, val, floatPrecision);
        }
    }
    return false;
}
function getFloatPrecisions(categoryName, fields, formatter) {
    var ret = [];
    for (var _a = 0, fields_1 = fields; _a < fields_1.length; _a++) {
        var f = fields_1[_a];
        var format = formatter.getFormat(categoryName, f.name);
        if (format && typeof format.digitCount !== 'undefined')
            ret[ret.length] = f.type === 2 /* Float */ ? Math.pow(10, Math.max(0, Math.min(format.digitCount, 15))) : 0;
        else
            ret[ret.length] = f.type === 2 /* Float */ ? Math.pow(10, Object(_util__WEBPACK_IMPORTED_MODULE_2__["getFieldDigitCount"])(f)) : 0;
    }
    return ret;
}
function writeCifSingleRecord(category, instance, source, builder, filter, formatter) {
    var fields = Object(_util__WEBPACK_IMPORTED_MODULE_2__["getIncludedFields"])(instance);
    var src = source[0];
    var data = src.data;
    var width = fields.reduce(function (w, f) { return filter.includeField(category.name, f.name) ? Math.max(w, f.name.length) : 0; }, 0);
    // this means no field from this category is included.
    if (width === 0)
        return;
    width += category.name.length + 6;
    var it = src.keys();
    var key = it.move();
    var precisions = getFloatPrecisions(category.name, instance.fields, formatter);
    for (var _f = 0; _f < fields.length; _f++) {
        var f = fields[_f];
        if (!filter.includeField(category.name, f.name))
            continue;
        _mol_util_string_builder__WEBPACK_IMPORTED_MODULE_0__["default"].writePadRight(builder, "_" + category.name + "." + f.name, width);
        var multiline = writeValue(builder, data, key, f, precisions[_f], 0);
        if (!multiline)
            _mol_util_string_builder__WEBPACK_IMPORTED_MODULE_0__["default"].newline(builder);
    }
    _mol_util_string_builder__WEBPACK_IMPORTED_MODULE_0__["default"].write(builder, '#\n');
}
function writeCifLoop(category, instance, source, builder, filter, formatter) {
    var fieldSource = Object(_util__WEBPACK_IMPORTED_MODULE_2__["getIncludedFields"])(instance);
    var fields = filter === _encoder__WEBPACK_IMPORTED_MODULE_1__["Category"].DefaultFilter ? fieldSource : fieldSource.filter(function (f) { return filter.includeField(category.name, f.name); });
    var fieldCount = fields.length;
    if (fieldCount === 0)
        return;
    var precisions = getFloatPrecisions(category.name, fields, formatter);
    writeLine(builder, 'loop_');
    for (var i = 0; i < fieldCount; i++) {
        writeLine(builder, "_" + category.name + "." + fields[i].name);
    }
    var index = 0;
    for (var _c = 0; _c < source.length; _c++) {
        var src = source[_c];
        var data = src.data;
        if (src.rowCount === 0)
            continue;
        var it_1 = src.keys();
        while (it_1.hasNext) {
            var key = it_1.move();
            var multiline = false;
            for (var _f = 0; _f < fieldCount; _f++) {
                multiline = writeValue(builder, data, key, fields[_f], precisions[_f], index);
            }
            if (!multiline)
                _mol_util_string_builder__WEBPACK_IMPORTED_MODULE_0__["default"].newline(builder);
            index++;
        }
    }
    _mol_util_string_builder__WEBPACK_IMPORTED_MODULE_0__["default"].write(builder, '#\n');
}
function isMultiline(value) {
    return typeof value === 'string' && value.indexOf('\n') >= 0;
}
function writeLine(builder, val) {
    _mol_util_string_builder__WEBPACK_IMPORTED_MODULE_0__["default"].write(builder, val);
    _mol_util_string_builder__WEBPACK_IMPORTED_MODULE_0__["default"].newline(builder);
}
function writeInteger(builder, val) {
    _mol_util_string_builder__WEBPACK_IMPORTED_MODULE_0__["default"].writeInteger(builder, val);
    _mol_util_string_builder__WEBPACK_IMPORTED_MODULE_0__["default"].whitespace1(builder);
}
function writeFloat(builder, val, precisionMultiplier) {
    _mol_util_string_builder__WEBPACK_IMPORTED_MODULE_0__["default"].writeFloat(builder, val, precisionMultiplier);
    _mol_util_string_builder__WEBPACK_IMPORTED_MODULE_0__["default"].whitespace1(builder);
}
function writeNotPresent(builder) {
    _mol_util_string_builder__WEBPACK_IMPORTED_MODULE_0__["default"].writeSafe(builder, '. ');
}
function writeUnknown(builder) {
    _mol_util_string_builder__WEBPACK_IMPORTED_MODULE_0__["default"].writeSafe(builder, '? ');
}
function writeChecked(builder, val) {
    if (!val) {
        _mol_util_string_builder__WEBPACK_IMPORTED_MODULE_0__["default"].writeSafe(builder, '. ');
        return false;
    }
    var escape = val.charCodeAt(0) === 95 /* _ */, escapeCharStart = '\'', escapeCharEnd = '\' ';
    var hasWhitespace = false;
    var hasSingle = false;
    var hasDouble = false;
    for (var i = 0, _l = val.length - 1; i < _l; i++) {
        var c = val.charCodeAt(i);
        switch (c) {
            case 9:
                hasWhitespace = true;
                break; // \t
            case 10: // \n
                writeMultiline(builder, val);
                return true;
            case 32:
                hasWhitespace = true;
                break; // ' '
            case 34: // "
                if (hasSingle) {
                    writeMultiline(builder, val);
                    return true;
                }
                hasDouble = true;
                escape = true;
                escapeCharStart = '\'';
                escapeCharEnd = '\' ';
                break;
            case 39: // '
                if (hasDouble) {
                    writeMultiline(builder, val);
                    return true;
                }
                escape = true;
                hasSingle = true;
                escapeCharStart = '"';
                escapeCharEnd = '" ';
                break;
        }
    }
    var fst = val.charCodeAt(0);
    if (!escape && (fst === 35 /* # */ || fst === 36 /* $ */ || fst === 59 /* ; */ || fst === 91 /* [ */ || fst === 93 /* ] */ || hasWhitespace)) {
        escapeCharStart = '\'';
        escapeCharEnd = '\' ';
        escape = true;
    }
    if (escape) {
        _mol_util_string_builder__WEBPACK_IMPORTED_MODULE_0__["default"].writeSafe(builder, escapeCharStart);
        _mol_util_string_builder__WEBPACK_IMPORTED_MODULE_0__["default"].writeSafe(builder, val);
        _mol_util_string_builder__WEBPACK_IMPORTED_MODULE_0__["default"].writeSafe(builder, escapeCharEnd);
    }
    else {
        _mol_util_string_builder__WEBPACK_IMPORTED_MODULE_0__["default"].writeSafe(builder, val);
        _mol_util_string_builder__WEBPACK_IMPORTED_MODULE_0__["default"].writeSafe(builder, ' ');
    }
    return false;
}
function writeMultiline(builder, val) {
    _mol_util_string_builder__WEBPACK_IMPORTED_MODULE_0__["default"].writeSafe(builder, '\n;' + val);
    _mol_util_string_builder__WEBPACK_IMPORTED_MODULE_0__["default"].writeSafe(builder, '\n;\n');
}
//# sourceMappingURL=text.js.map

/***/ }),

/***/ "./lib/mol-io/writer/cif/encoder/util.js":
/*!***********************************************!*\
  !*** ./lib/mol-io/writer/cif/encoder/util.js ***!
  \***********************************************/
/*! exports provided: getFieldDigitCount, getIncludedFields, getCategoryInstanceData */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getFieldDigitCount", function() { return getFieldDigitCount; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getIncludedFields", function() { return getIncludedFields; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getCategoryInstanceData", function() { return getCategoryInstanceData; });
/* harmony import */ var _mol_data__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../../../mol-data */ "./lib/mol-data/index.js");
/**
 * Copyright (c) 2018 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author David Sehnal <david.sehnal@gmail.com>
 */

function getFieldDigitCount(field) {
    if (field.defaultFormat && typeof field.defaultFormat.digitCount !== 'undefined')
        return Math.max(0, Math.min(field.defaultFormat.digitCount, 16));
    return 6;
}
function getIncludedFields(category) {
    return category.fields.some(function (f) { return !!f.shouldInclude; })
        ? category.fields.filter(function (f) { return !f.shouldInclude || category.source.some(function (src) { return f.shouldInclude(src.data); }); })
        : category.fields;
}
function getCategoryInstanceData(category, ctx) {
    var instance = category.instance(ctx);
    var sources = instance.source.filter(function (s) { return s.rowCount > 0; });
    if (!sources.length)
        return { instance: instance, rowCount: 0, source: [] };
    var rowCount = sources.reduce(function (a, c) { return a + c.rowCount; }, 0);
    var source = sources.map(function (c) { return ({
        data: c.data,
        keys: function () { return c.keys ? c.keys() : _mol_data__WEBPACK_IMPORTED_MODULE_0__["Iterator"].Range(0, c.rowCount - 1); },
        rowCount: c.rowCount
    }); });
    return { instance: instance, rowCount: rowCount, source: source };
}
//# sourceMappingURL=util.js.map

/***/ }),

/***/ "./lib/mol-math/approx.js":
/*!********************************!*\
  !*** ./lib/mol-math/approx.js ***!
  \********************************/
/*! exports provided: fastPow2, fasterPow2, fastExp, fasterExp, fastLog2, fasterLog2, fastLog, fasterLog, fastLog10, fasterLog10, fastSinh, fasterSinh, fastCosh, fasterCosh, fastTanh, fasterTanh, fastSin, fasterSin, fastCos, fasterCos, fastTan, fasterTan, fastAtan, fastAtan2 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fastPow2", function() { return fastPow2; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fasterPow2", function() { return fasterPow2; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fastExp", function() { return fastExp; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fasterExp", function() { return fasterExp; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fastLog2", function() { return fastLog2; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fasterLog2", function() { return fasterLog2; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fastLog", function() { return fastLog; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fasterLog", function() { return fasterLog; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fastLog10", function() { return fastLog10; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fasterLog10", function() { return fasterLog10; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fastSinh", function() { return fastSinh; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fasterSinh", function() { return fasterSinh; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fastCosh", function() { return fastCosh; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fasterCosh", function() { return fasterCosh; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fastTanh", function() { return fastTanh; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fasterTanh", function() { return fasterTanh; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fastSin", function() { return fastSin; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fasterSin", function() { return fasterSin; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fastCos", function() { return fastCos; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fasterCos", function() { return fasterCos; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fastTan", function() { return fastTan; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fasterTan", function() { return fasterTan; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fastAtan", function() { return fastAtan; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fastAtan2", function() { return fastAtan2; });
/**
 * Copyright (c) 2020 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 *
 * mostly adapted from https://gist.github.com/imbcmdth/6338194
 * which is ported from https://code.google.com/archive/p/fastapprox/ (BSD licensed)
 */
var _a_fastPow2 = new ArrayBuffer(4);
var _i_fastPow2 = new Int32Array(_a_fastPow2);
var _f_fastPow2 = new Float32Array(_a_fastPow2);
function fastPow2(v) {
    var offset = (v < 0) ? 1 : 0;
    var clipNumber = (v < -126) ? -126 : v;
    var w = clipNumber | 0;
    var z = clipNumber - w + offset;
    _i_fastPow2[0] = ((1 << 23) * (clipNumber + 121.2740575 + 27.7280233 / (4.84252568 - z) - 1.49012907 * z));
    return _f_fastPow2[0];
}
var _a_fasterPow2 = new ArrayBuffer(4);
var _i_fasterPow2 = new Int32Array(_a_fasterPow2);
var _f_fasterPow2 = new Float32Array(_a_fasterPow2);
function fasterPow2(v) {
    var clipNumber = (v < -126) ? -126 : v;
    _i_fasterPow2[0] = ((1 << 23) * (clipNumber + 126.94269504));
    return _f_fasterPow2[0];
}
function fastExp(v) {
    return fastPow2(1.442695040 * v);
}
function fasterExp(v) {
    return fasterPow2(1.442695040 * v);
}
var _a_fastLog2 = new ArrayBuffer(8);
var _i_fastLog2 = new Int32Array(_a_fastLog2);
var _f_fastLog2 = new Float32Array(_a_fastLog2);
function fastLog2(v) {
    _f_fastLog2[0] = v;
    _i_fastLog2[1] = (_i_fastLog2[0] & 0x007FFFFF) | 0x3f000000;
    var t = _i_fastLog2[0] * 1.1920928955078125e-7;
    return t - 124.22551499 - 1.498030302 * _f_fastLog2[1] - 1.72587999 / (0.3520887068 + _f_fastLog2[1]);
}
;
var _a_fasterLog2 = new ArrayBuffer(4);
var _i_fasterLog2 = new Int32Array(_a_fasterLog2);
var _f_fasterLog2 = new Float32Array(_a_fasterLog2);
function fasterLog2(v) {
    _f_fasterLog2[0] = v;
    var t = _i_fasterLog2[0] * 1.1920928955078125e-7;
    return t - 126.94269504;
}
function fastLog(v) {
    return 0.6931471805599453 * fastLog2(v);
}
function fasterLog(v) {
    return 0.6931471805599453 * fasterLog2(v);
}
function fastLog10(v) {
    return 0.30102999566398114 * fastLog2(v);
}
function fasterLog10(v) {
    return 0.30102999566398114 * fasterLog2(v);
}
function fastSinh(v) {
    return 0.5 * (fastExp(v) - fastExp(-v));
}
function fasterSinh(v) {
    return 0.5 * (fasterExp(v) - fasterExp(-v));
}
function fastCosh(v) {
    return 0.5 * (fastExp(v) + fastExp(-v));
}
function fasterCosh(v) {
    return 0.5 * (fasterExp(v) + fasterExp(-v));
}
function fastTanh(v) {
    return -1.0 + 2.0 / (1.0 + fastExp(-2.0 * v));
}
function fasterTanh(v) {
    return -1.0 + 2.0 / (1.0 + fasterExp(-2.0 * v));
}
var halfPi = Math.PI / 2;
var twoPi = 2 * Math.PI;
var invTwoPi = 1 / (2 * Math.PI);
var twoOverPi = 2 / Math.PI;
var fourOverPi = 4 / Math.PI;
var fourOverPiSq = 4 / (Math.PI * Math.PI);
var halfPiMinusTwoPi = Math.PI / 2 - 2 * Math.PI;
var _q_fastHalfSin = 0.78444488374548933;
var _a_fastHalfSin = new ArrayBuffer(16);
var _i_fastHalfSin = new Int32Array(_a_fastHalfSin);
var _f_fastHalfSin = new Float32Array(_a_fastHalfSin);
function fastHalfSin(v) {
    _f_fastHalfSin[0] = 0.20363937680730309;
    _f_fastHalfSin[1] = 0.015124940802184233;
    _f_fastHalfSin[2] = -0.0032225901625579573;
    _f_fastHalfSin[3] = v;
    var sign = _i_fastHalfSin[3] & 0x80000000;
    _i_fastHalfSin[3] = _i_fastHalfSin[3] & 0x7FFFFFFF;
    var qpprox = fourOverPi * v - fourOverPiSq * v * _f_fastHalfSin[3];
    var qpproxsq = qpprox * qpprox;
    _i_fastHalfSin[0] |= sign;
    _i_fastHalfSin[1] |= sign;
    _i_fastHalfSin[2] ^= sign;
    return _q_fastHalfSin * qpprox + qpproxsq * (_f_fastHalfSin[0] + qpproxsq * (_f_fastHalfSin[1] + qpproxsq * _f_fastHalfSin[2]));
}
var _q_fasterHalfSin = 0.78444488374548933;
var _a_fasterHalfSin = new ArrayBuffer(8);
var _i_fasterHalfSin = new Int32Array(_a_fasterHalfSin);
var _f_fasterHalfSin = new Float32Array(_a_fasterHalfSin);
function fasterHalfSin(v) {
    _f_fasterHalfSin[0] = 0.22308510060189463;
    _f_fasterHalfSin[1] = v;
    var sign = _i_fasterHalfSin[1] & 0x80000000;
    _i_fasterHalfSin[1] &= 0x7FFFFFFF;
    var qpprox = fourOverPi * v - fourOverPiSq * v * _f_fasterHalfSin[1];
    _i_fasterHalfSin[0] |= sign;
    return qpprox * (_q_fasterHalfSin + _f_fasterHalfSin[0] * qpprox);
}
function fastSin(v) {
    var k = (v * invTwoPi) | 0;
    var half = (v < 0) ? -0.5 : 0.5;
    return fastHalfSin((half + k) * twoPi - v);
}
function fasterSin(v) {
    var k = (v * invTwoPi) | 0;
    var half = (v < 0) ? -0.5 : 0.5;
    return fasterHalfSin((half + k) * twoPi - v);
}
function fastCos(v) {
    return fastSin(v + halfPi);
}
function fasterCos(v) {
    return fasterSin(v + halfPi);
}
function fastHalfCos(v) {
    var offset = (v > halfPi) ? halfPiMinusTwoPi : halfPi;
    return fastHalfSin(v + offset);
}
var _p_fasterHalfCos = 0.54641335845679634;
var _a_fasterHalfCos = new ArrayBuffer(4);
var _i_fasterHalfCos = new Int32Array(_a_fasterHalfCos);
var _f_fasterHalfCos = new Float32Array(_a_fasterHalfCos);
function fasterHalfCos(v) {
    _f_fasterHalfCos[0] = v;
    _i_fasterHalfCos[0] &= 0x7FFFFFFF;
    var qpprox = 1.0 - twoOverPi * _f_fasterHalfCos[0];
    return qpprox + _p_fasterHalfCos * qpprox * (1.0 - qpprox * qpprox);
}
function fastTan(v) {
    var k = (v * invTwoPi) | 0;
    var half = (v < 0) ? -0.5 : 0.5;
    var x = v - (half + k) * twoPi;
    return fastHalfSin(x) / fastHalfCos(x);
}
function fasterTan(v) {
    var k = (v * invTwoPi) | 0;
    var half = (v < 0) ? -0.5 : 0.5;
    var x = v - (half + k) * twoPi;
    return fasterHalfSin(x) / fasterHalfCos(x);
}
var piOverFour = Math.PI / 4;
/**
 * Adapted from:
 * "Efficient approximations for the arctangent function"
 * Rajan, S. Sichun Wang Inkol, R. Joyal, A., May 2006
 */
function fastAtan(v) {
    return piOverFour * v - v * (Math.abs(v) - 1) * (0.2447 + 0.0663 * Math.abs(v));
}
function fastAtan2(y, x) {
    // reduce range to [-1, 1] by flipping y/x so the larger is up
    var t = Math.abs(x); // used to undo flipping
    var opposite = Math.abs(y);
    var adjacent = Math.max(t, opposite);
    opposite = Math.min(t, opposite);
    t = fastAtan(opposite / adjacent);
    // undo flipping
    t = Math.abs(y) > Math.abs(x) ? halfPi - t : t;
    t = x < 0.0 ? Math.PI - t : t;
    t = y < 0.0 ? -t : t;
    return t;
}
//# sourceMappingURL=approx.js.map

/***/ }),

/***/ "./lib/mol-math/geometry.js":
/*!**********************************!*\
  !*** ./lib/mol-math/geometry.js ***!
  \**********************************/
/*! exports provided: getRegularGrid3dDelta, fillGridDim, SymmetryOperator, Spacegroup, SpacegroupCell, Result, GridLookup3D, Box3D, Sphere3D, Axes3D */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _geometry_common__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./geometry/common */ "./lib/mol-math/geometry/common.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "getRegularGrid3dDelta", function() { return _geometry_common__WEBPACK_IMPORTED_MODULE_0__["getRegularGrid3dDelta"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "fillGridDim", function() { return _geometry_common__WEBPACK_IMPORTED_MODULE_0__["fillGridDim"]; });

/* harmony import */ var _geometry_symmetry_operator__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./geometry/symmetry-operator */ "./lib/mol-math/geometry/symmetry-operator.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "SymmetryOperator", function() { return _geometry_symmetry_operator__WEBPACK_IMPORTED_MODULE_1__["SymmetryOperator"]; });

/* harmony import */ var _geometry_spacegroup_construction__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./geometry/spacegroup/construction */ "./lib/mol-math/geometry/spacegroup/construction.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Spacegroup", function() { return _geometry_spacegroup_construction__WEBPACK_IMPORTED_MODULE_2__["Spacegroup"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "SpacegroupCell", function() { return _geometry_spacegroup_construction__WEBPACK_IMPORTED_MODULE_2__["SpacegroupCell"]; });

/* harmony import */ var _geometry_lookup3d_common__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./geometry/lookup3d/common */ "./lib/mol-math/geometry/lookup3d/common.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Result", function() { return _geometry_lookup3d_common__WEBPACK_IMPORTED_MODULE_3__["Result"]; });

/* harmony import */ var _geometry_lookup3d_grid__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./geometry/lookup3d/grid */ "./lib/mol-math/geometry/lookup3d/grid.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "GridLookup3D", function() { return _geometry_lookup3d_grid__WEBPACK_IMPORTED_MODULE_4__["GridLookup3D"]; });

/* harmony import */ var _geometry_primitives_box3d__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./geometry/primitives/box3d */ "./lib/mol-math/geometry/primitives/box3d.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Box3D", function() { return _geometry_primitives_box3d__WEBPACK_IMPORTED_MODULE_5__["Box3D"]; });

/* harmony import */ var _geometry_primitives_sphere3d__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ./geometry/primitives/sphere3d */ "./lib/mol-math/geometry/primitives/sphere3d.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Sphere3D", function() { return _geometry_primitives_sphere3d__WEBPACK_IMPORTED_MODULE_6__["Sphere3D"]; });

/* harmony import */ var _geometry_primitives_axes3d__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ./geometry/primitives/axes3d */ "./lib/mol-math/geometry/primitives/axes3d.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Axes3D", function() { return _geometry_primitives_axes3d__WEBPACK_IMPORTED_MODULE_7__["Axes3D"]; });

/**
 * Copyright (c) 2018-2019 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author David Sehnal <david.sehnal@gmail.com>
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */








//# sourceMappingURL=geometry.js.map

/***/ }),

/***/ "./lib/mol-math/geometry/boundary-helper.js":
/*!**************************************************!*\
  !*** ./lib/mol-math/geometry/boundary-helper.js ***!
  \**************************************************/
/*! exports provided: BoundaryHelper */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "BoundaryHelper", function() { return BoundaryHelper; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _linear_algebra_3d__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../linear-algebra/3d */ "./lib/mol-math/linear-algebra/3d.js");
/* harmony import */ var _centroid_helper__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./centroid-helper */ "./lib/mol-math/geometry/centroid-helper.js");
/* harmony import */ var _geometry__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../geometry */ "./lib/mol-math/geometry.js");
/* harmony import */ var _primitives_box3d__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./primitives/box3d */ "./lib/mol-math/geometry/primitives/box3d.js");
/**
 * Copyright (c) 2020 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */





// implementing http://www.ep.liu.se/ecp/034/009/ecp083409.pdf
var BoundaryHelper = /** @class */ (function () {
    function BoundaryHelper(quality) {
        this.minDist = [];
        this.maxDist = [];
        this.extrema = [];
        this.centroidHelper = new _centroid_helper__WEBPACK_IMPORTED_MODULE_2__["CentroidHelper"]();
        this.dir = getEposDir(quality);
        this.reset();
    }
    BoundaryHelper.prototype.computeExtrema = function (i, p) {
        var d = _linear_algebra_3d__WEBPACK_IMPORTED_MODULE_1__["Vec3"].dot(this.dir[i], p);
        if (d < this.minDist[i]) {
            this.minDist[i] = d;
            _linear_algebra_3d__WEBPACK_IMPORTED_MODULE_1__["Vec3"].copy(this.extrema[i * 2], p);
        }
        if (d > this.maxDist[i]) {
            this.maxDist[i] = d;
            _linear_algebra_3d__WEBPACK_IMPORTED_MODULE_1__["Vec3"].copy(this.extrema[i * 2 + 1], p);
        }
    };
    BoundaryHelper.prototype.computeSphereExtrema = function (i, center, radius) {
        var d = _linear_algebra_3d__WEBPACK_IMPORTED_MODULE_1__["Vec3"].dot(this.dir[i], center);
        if (d - radius < this.minDist[i]) {
            this.minDist[i] = d - radius;
            _linear_algebra_3d__WEBPACK_IMPORTED_MODULE_1__["Vec3"].scaleAndSub(this.extrema[i * 2], center, this.dir[i], radius);
        }
        if (d + radius > this.maxDist[i]) {
            this.maxDist[i] = d + radius;
            _linear_algebra_3d__WEBPACK_IMPORTED_MODULE_1__["Vec3"].scaleAndAdd(this.extrema[i * 2 + 1], center, this.dir[i], radius);
        }
    };
    BoundaryHelper.prototype.includeSphere = function (s) {
        if (_geometry__WEBPACK_IMPORTED_MODULE_3__["Sphere3D"].hasExtrema(s) && s.extrema.length > 1) {
            for (var _i = 0, _a = s.extrema; _i < _a.length; _i++) {
                var e = _a[_i];
                this.includePosition(e);
            }
        }
        else {
            this.includePositionRadius(s.center, s.radius);
        }
    };
    BoundaryHelper.prototype.includePosition = function (p) {
        for (var i = 0, il = this.dir.length; i < il; ++i) {
            this.computeExtrema(i, p);
        }
    };
    BoundaryHelper.prototype.includePositionRadius = function (center, radius) {
        for (var i = 0, il = this.dir.length; i < il; ++i) {
            this.computeSphereExtrema(i, center, radius);
        }
    };
    BoundaryHelper.prototype.finishedIncludeStep = function () {
        for (var i = 0; i < this.extrema.length; i++) {
            this.centroidHelper.includeStep(this.extrema[i]);
        }
        this.centroidHelper.finishedIncludeStep();
    };
    BoundaryHelper.prototype.radiusSphere = function (s) {
        if (_geometry__WEBPACK_IMPORTED_MODULE_3__["Sphere3D"].hasExtrema(s) && s.extrema.length > 1) {
            for (var _i = 0, _a = s.extrema; _i < _a.length; _i++) {
                var e = _a[_i];
                this.radiusPosition(e);
            }
        }
        else {
            this.radiusPositionRadius(s.center, s.radius);
        }
    };
    BoundaryHelper.prototype.radiusPosition = function (p) {
        this.centroidHelper.radiusStep(p);
    };
    BoundaryHelper.prototype.radiusPositionRadius = function (center, radius) {
        this.centroidHelper.radiusSphereStep(center, radius);
    };
    BoundaryHelper.prototype.getSphere = function (sphere) {
        return _geometry__WEBPACK_IMPORTED_MODULE_3__["Sphere3D"].setExtrema(this.centroidHelper.getSphere(sphere), Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__spreadArrays"])(this.extrema));
    };
    BoundaryHelper.prototype.getBox = function (box) {
        return _primitives_box3d__WEBPACK_IMPORTED_MODULE_4__["Box3D"].fromVec3Array(box || Object(_primitives_box3d__WEBPACK_IMPORTED_MODULE_4__["Box3D"])(), this.extrema);
    };
    BoundaryHelper.prototype.reset = function () {
        for (var i = 0, il = this.dir.length; i < il; ++i) {
            this.minDist[i] = Infinity;
            this.maxDist[i] = -Infinity;
            this.extrema[i * 2] = Object(_linear_algebra_3d__WEBPACK_IMPORTED_MODULE_1__["Vec3"])();
            this.extrema[i * 2 + 1] = Object(_linear_algebra_3d__WEBPACK_IMPORTED_MODULE_1__["Vec3"])();
        }
        this.centroidHelper.reset();
    };
    return BoundaryHelper;
}());

function getEposDir(quality) {
    var dir;
    switch (quality) {
        case '6':
            dir = Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__spreadArrays"])(Type001);
            break;
        case '14':
            dir = Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__spreadArrays"])(Type001, Type111);
            break;
        case '26':
            dir = Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__spreadArrays"])(Type001, Type111, Type011);
            break;
        case '98':
            dir = Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__spreadArrays"])(Type001, Type111, Type011, Type012, Type112, Type122);
            break;
    }
    return dir.map(function (a) {
        var v = _linear_algebra_3d__WEBPACK_IMPORTED_MODULE_1__["Vec3"].create(a[0], a[1], a[2]);
        return _linear_algebra_3d__WEBPACK_IMPORTED_MODULE_1__["Vec3"].normalize(v, v);
    });
}
var Type001 = [
    [1, 0, 0], [0, 1, 0], [0, 0, 1]
];
var Type111 = [
    [1, 1, 1], [-1, 1, 1], [-1, -1, 1], [1, -1, 1]
];
var Type011 = [
    [1, 1, 0], [1, -1, 0], [1, 0, 1], [1, 0, -1], [0, 1, 1], [0, 1, -1]
];
var Type012 = [
    [0, 1, 2], [0, 2, 1], [1, 0, 2], [2, 0, 1], [1, 2, 0], [2, 1, 0],
    [0, 1, -2], [0, 2, -1], [1, 0, -2], [2, 0, -1], [1, -2, 0], [2, -1, 0]
];
var Type112 = [
    [1, 1, 2], [2, 1, 1], [1, 2, 1], [1, -1, 2], [1, 1, -2], [1, -1, -2],
    [2, -1, 1], [2, 1, -1], [2, -1, -1], [1, -2, 1], [1, 2, -1], [1, -2, -1]
];
var Type122 = [
    [2, 2, 1], [1, 2, 2], [2, 1, 2], [2, -2, 1], [2, 2, -1], [2, -2, -1],
    [1, -2, 2], [1, 2, -2], [1, -2, -2], [2, -1, 2], [2, 1, -2], [2, -1, -2]
];
//# sourceMappingURL=boundary-helper.js.map

/***/ }),

/***/ "./lib/mol-math/geometry/boundary.js":
/*!*******************************************!*\
  !*** ./lib/mol-math/geometry/boundary.js ***!
  \*******************************************/
/*! exports provided: getBoundary */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getBoundary", function() { return getBoundary; });
/* harmony import */ var _linear_algebra__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../linear-algebra */ "./lib/mol-math/linear-algebra.js");
/* harmony import */ var _mol_data_int__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../mol-data/int */ "./lib/mol-data/int.js");
/* harmony import */ var _boundary_helper__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./boundary-helper */ "./lib/mol-math/geometry/boundary-helper.js");
/* harmony import */ var _geometry__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../geometry */ "./lib/mol-math/geometry.js");
/**
 * Copyright (c) 2018-2020 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author David Sehnal <david.sehnal@gmail.com>
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */




// avoiding namespace lookup improved performance in Chrome (Aug 2020)
var v3set = _linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"].set;
var boundaryHelperCoarse = new _boundary_helper__WEBPACK_IMPORTED_MODULE_2__["BoundaryHelper"]('14');
var boundaryHelperFine = new _boundary_helper__WEBPACK_IMPORTED_MODULE_2__["BoundaryHelper"]('98');
function getBoundaryHelper(count) {
    return count > 10000 ? boundaryHelperCoarse : boundaryHelperFine;
}
var p = Object(_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"])();
function getBoundary(data) {
    var x = data.x, y = data.y, z = data.z, radius = data.radius, indices = data.indices;
    var n = _mol_data_int__WEBPACK_IMPORTED_MODULE_1__["OrderedSet"].size(indices);
    if (n > 250000) {
        var box = _geometry__WEBPACK_IMPORTED_MODULE_3__["Box3D"].computeBounding(data);
        return { box: box, sphere: _geometry__WEBPACK_IMPORTED_MODULE_3__["Sphere3D"].fromBox3D(Object(_geometry__WEBPACK_IMPORTED_MODULE_3__["Sphere3D"])(), box) };
    }
    var boundaryHelper = getBoundaryHelper(n);
    boundaryHelper.reset();
    for (var t = 0; t < n; t++) {
        var i = _mol_data_int__WEBPACK_IMPORTED_MODULE_1__["OrderedSet"].getAt(indices, t);
        v3set(p, x[i], y[i], z[i]);
        boundaryHelper.includePositionRadius(p, (radius && radius[i]) || 0);
    }
    boundaryHelper.finishedIncludeStep();
    for (var t = 0; t < n; t++) {
        var i = _mol_data_int__WEBPACK_IMPORTED_MODULE_1__["OrderedSet"].getAt(indices, t);
        v3set(p, x[i], y[i], z[i]);
        boundaryHelper.radiusPositionRadius(p, (radius && radius[i]) || 0);
    }
    var sphere = boundaryHelper.getSphere();
    if (!radius && _geometry__WEBPACK_IMPORTED_MODULE_3__["Sphere3D"].hasExtrema(sphere) && n <= sphere.extrema.length) {
        var extrema = [];
        for (var t = 0; t < n; t++) {
            var i = _mol_data_int__WEBPACK_IMPORTED_MODULE_1__["OrderedSet"].getAt(indices, t);
            extrema.push(_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"].create(x[i], y[i], z[i]));
        }
        _geometry__WEBPACK_IMPORTED_MODULE_3__["Sphere3D"].setExtrema(sphere, extrema);
    }
    return { box: boundaryHelper.getBox(), sphere: sphere };
}
//# sourceMappingURL=boundary.js.map

/***/ }),

/***/ "./lib/mol-math/geometry/centroid-helper.js":
/*!**************************************************!*\
  !*** ./lib/mol-math/geometry/centroid-helper.js ***!
  \**************************************************/
/*! exports provided: CentroidHelper */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CentroidHelper", function() { return CentroidHelper; });
/* harmony import */ var _mol_math_linear_algebra_3d__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../mol-math/linear-algebra/3d */ "./lib/mol-math/linear-algebra/3d.js");
/* harmony import */ var _primitives_sphere3d__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./primitives/sphere3d */ "./lib/mol-math/geometry/primitives/sphere3d.js");
/**
 * Copyright (c) 2018-2020 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author David Sehnal <david.sehnal@gmail.com>
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */



var CentroidHelper = /** @class */ (function () {
    function CentroidHelper() {
        this.count = 0;
        this.center = Object(_mol_math_linear_algebra_3d__WEBPACK_IMPORTED_MODULE_0__["Vec3"])();
        this.radiusSq = 0;
    }
    CentroidHelper.prototype.reset = function () {
        _mol_math_linear_algebra_3d__WEBPACK_IMPORTED_MODULE_0__["Vec3"].set(this.center, 0, 0, 0);
        this.radiusSq = 0;
        this.count = 0;
    };
    CentroidHelper.prototype.includeStep = function (p) {
        _mol_math_linear_algebra_3d__WEBPACK_IMPORTED_MODULE_0__["Vec3"].add(this.center, this.center, p);
        this.count++;
    };
    CentroidHelper.prototype.finishedIncludeStep = function () {
        if (this.count === 0)
            return;
        _mol_math_linear_algebra_3d__WEBPACK_IMPORTED_MODULE_0__["Vec3"].scale(this.center, this.center, 1 / this.count);
    };
    CentroidHelper.prototype.radiusStep = function (p) {
        var d = _mol_math_linear_algebra_3d__WEBPACK_IMPORTED_MODULE_0__["Vec3"].squaredDistance(p, this.center);
        if (d > this.radiusSq)
            this.radiusSq = d;
    };
    CentroidHelper.prototype.radiusSphereStep = function (center, radius) {
        var _d = _mol_math_linear_algebra_3d__WEBPACK_IMPORTED_MODULE_0__["Vec3"].distance(center, this.center) + radius;
        var d = _d * _d;
        if (d > this.radiusSq)
            this.radiusSq = d;
    };
    CentroidHelper.prototype.getSphere = function (sphere) {
        if (!sphere)
            sphere = Object(_primitives_sphere3d__WEBPACK_IMPORTED_MODULE_1__["Sphere3D"])();
        _mol_math_linear_algebra_3d__WEBPACK_IMPORTED_MODULE_0__["Vec3"].copy(sphere.center, this.center);
        sphere.radius = Math.sqrt(this.radiusSq);
        return sphere;
    };
    CentroidHelper.prototype.getCount = function () {
        return this.count;
    };
    return CentroidHelper;
}());
(function (CentroidHelper) {
    var helper = new CentroidHelper();
    var posA = Object(_mol_math_linear_algebra_3d__WEBPACK_IMPORTED_MODULE_0__["Vec3"])();
    var posB = Object(_mol_math_linear_algebra_3d__WEBPACK_IMPORTED_MODULE_0__["Vec3"])();
    function fromArrays(_a, to) {
        var x = _a.x, y = _a.y, z = _a.z;
        helper.reset();
        var n = x.length;
        for (var i = 0; i < n; i++) {
            _mol_math_linear_algebra_3d__WEBPACK_IMPORTED_MODULE_0__["Vec3"].set(posA, x[i], y[i], z[i]);
            helper.includeStep(posA);
        }
        helper.finishedIncludeStep();
        for (var i = 0; i < n; i++) {
            _mol_math_linear_algebra_3d__WEBPACK_IMPORTED_MODULE_0__["Vec3"].set(posA, x[i], y[i], z[i]);
            helper.radiusStep(posA);
        }
        _mol_math_linear_algebra_3d__WEBPACK_IMPORTED_MODULE_0__["Vec3"].copy(to.center, helper.center);
        to.radius = Math.sqrt(helper.radiusSq);
        return to;
    }
    CentroidHelper.fromArrays = fromArrays;
    function fromProvider(count, getter, to) {
        helper.reset();
        for (var i = 0; i < count; i++) {
            getter(i, posA);
            helper.includeStep(posA);
        }
        helper.finishedIncludeStep();
        for (var i = 0; i < count; i++) {
            getter(i, posA);
            helper.radiusStep(posA);
        }
        _mol_math_linear_algebra_3d__WEBPACK_IMPORTED_MODULE_0__["Vec3"].copy(to.center, helper.center);
        to.radius = Math.sqrt(helper.radiusSq);
        return to;
    }
    CentroidHelper.fromProvider = fromProvider;
    function fromPairProvider(count, getter, to) {
        helper.reset();
        for (var i = 0; i < count; i++) {
            getter(i, posA, posB);
            helper.includeStep(posA);
            helper.includeStep(posB);
        }
        helper.finishedIncludeStep();
        for (var i = 0; i < count; i++) {
            getter(i, posA, posB);
            helper.radiusStep(posA);
            helper.radiusStep(posB);
        }
        _mol_math_linear_algebra_3d__WEBPACK_IMPORTED_MODULE_0__["Vec3"].copy(to.center, helper.center);
        to.radius = Math.sqrt(helper.radiusSq);
        return to;
    }
    CentroidHelper.fromPairProvider = fromPairProvider;
})(CentroidHelper || (CentroidHelper = {}));
//# sourceMappingURL=centroid-helper.js.map

/***/ }),

/***/ "./lib/mol-math/geometry/common.js":
/*!*****************************************!*\
  !*** ./lib/mol-math/geometry/common.js ***!
  \*****************************************/
/*! exports provided: getRegularGrid3dDelta, fillGridDim */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getRegularGrid3dDelta", function() { return getRegularGrid3dDelta; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fillGridDim", function() { return fillGridDim; });
/* harmony import */ var _linear_algebra__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../linear-algebra */ "./lib/mol-math/linear-algebra.js");
/* harmony import */ var _geometry__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../geometry */ "./lib/mol-math/geometry.js");
/**
 * Copyright (c) 2018-2019 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author David Sehnal <david.sehnal@gmail.com>
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */


function getRegularGrid3dDelta(_a) {
    var box = _a.box, dimensions = _a.dimensions;
    return _linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"].div(Object(_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"])(), _geometry__WEBPACK_IMPORTED_MODULE_1__["Box3D"].size(Object(_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"])(), box), _linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"].subScalar(Object(_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"])(), dimensions, 1));
}
function fillGridDim(length, start, step) {
    var a = new Float32Array(length);
    for (var i = 0; i < a.length; i++) {
        a[i] = start + (step * i);
    }
    return a;
}
//# sourceMappingURL=common.js.map

/***/ }),

/***/ "./lib/mol-math/geometry/distance-transform.js":
/*!*****************************************************!*\
  !*** ./lib/mol-math/geometry/distance-transform.js ***!
  \*****************************************************/
/*! exports provided: edt */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "edt", function() { return edt; });
/**
 * Copyright (c) 2019 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */
/**
 * 2D Euclidean distance transform by Felzenszwalb & Huttenlocher https://cs.brown.edu/~pff/papers/dt-final.pdf
 */
function edt(data, width, height, f, d, v, z) {
    for (var x = 0; x < width; x++) {
        for (var y = 0; y < height; y++) {
            f[y] = data[y * width + x];
        }
        edt1d(f, d, v, z, height);
        for (var y = 0; y < height; y++) {
            data[y * width + x] = d[y];
        }
    }
    for (var y = 0; y < height; y++) {
        for (var x = 0; x < width; x++) {
            f[x] = data[y * width + x];
        }
        edt1d(f, d, v, z, width);
        for (var x = 0; x < width; x++) {
            data[y * width + x] = Math.sqrt(d[x]);
        }
    }
}
/**
 * 1D squared distance transform
 */
function edt1d(f, d, v, z, n) {
    v[0] = 0;
    z[0] = Number.MIN_SAFE_INTEGER;
    z[1] = Number.MAX_SAFE_INTEGER;
    for (var q = 1, k = 0; q < n; q++) {
        var s = ((f[q] + q * q) - (f[v[k]] + v[k] * v[k])) / (2 * q - 2 * v[k]);
        while (s <= z[k]) {
            k--;
            s = ((f[q] + q * q) - (f[v[k]] + v[k] * v[k])) / (2 * q - 2 * v[k]);
        }
        k++;
        v[k] = q;
        z[k] = s;
        z[k + 1] = Number.MAX_SAFE_INTEGER;
    }
    for (var q = 0, k = 0; q < n; q++) {
        while (z[k + 1] < q)
            k++;
        d[q] = (q - v[k]) * (q - v[k]) + f[v[k]];
    }
}
//# sourceMappingURL=distance-transform.js.map

/***/ }),

/***/ "./lib/mol-math/geometry/gaussian-density/cpu.js":
/*!*******************************************************!*\
  !*** ./lib/mol-math/geometry/gaussian-density/cpu.js ***!
  \*******************************************************/
/*! exports provided: GaussianDensityCPU */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "GaussianDensityCPU", function() { return GaussianDensityCPU; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _geometry__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../geometry */ "./lib/mol-math/geometry.js");
/* harmony import */ var _linear_algebra__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../linear-algebra */ "./lib/mol-math/linear-algebra.js");
/* harmony import */ var _mol_data_int__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../../mol-data/int */ "./lib/mol-data/int.js");
/* harmony import */ var _approx__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../approx */ "./lib/mol-math/approx.js");
/**
 * Copyright (c) 2018-2020 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */





function GaussianDensityCPU(ctx, position, box, radius, props) {
    return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"])(this, void 0, void 0, function () {
        function accumulateRange(begI, endI) {
            for (var i = begI; i < endI; ++i) {
                var j = _mol_data_int__WEBPACK_IMPORTED_MODULE_3__["OrderedSet"].getAt(indices, i);
                var vx = x[j], vy = y[j], vz = z[j];
                var rad = radii[i];
                var rSq = rad * rad;
                var rSqInv = 1 / rSq;
                var r2 = rad * 2;
                var r2sq = r2 * r2;
                // Number of grid points, round this up...
                var ng = Math.ceil(r2 * scaleFactor);
                // Center of the atom, mapped to grid points (take floor)
                var iax = Math.floor(scaleFactor * (vx - min[0]));
                var iay = Math.floor(scaleFactor * (vy - min[1]));
                var iaz = Math.floor(scaleFactor * (vz - min[2]));
                // Extents of grid to consider for this atom
                var begX = Math.max(0, iax - ng);
                var begY = Math.max(0, iay - ng);
                var begZ = Math.max(0, iaz - ng);
                // Add two to these points:
                // - iax are floor'd values so this ensures coverage
                // - these are loop limits (exclusive)
                var endX = Math.min(dimX, iax + ng + 2);
                var endY = Math.min(dimY, iay + ng + 2);
                var endZ = Math.min(dimZ, iaz + ng + 2);
                for (var xi = begX; xi < endX; ++xi) {
                    var dx = gridx[xi] - vx;
                    var xIdx = xi * iuv;
                    for (var yi = begY; yi < endY; ++yi) {
                        var dy = gridy[yi] - vy;
                        var dxySq = dx * dx + dy * dy;
                        var xyIdx = yi * iu + xIdx;
                        for (var zi = begZ; zi < endZ; ++zi) {
                            var dz = gridz[zi] - vz;
                            var dSq = dxySq + dz * dz;
                            if (dSq <= r2sq) {
                                var dens = Object(_approx__WEBPACK_IMPORTED_MODULE_4__["fasterExp"])(-alpha * (dSq * rSqInv));
                                var idx = zi + xyIdx;
                                data[idx] += dens;
                                if (dens > densData[idx]) {
                                    densData[idx] = dens;
                                    idData[idx] = id ? id[i] : i;
                                }
                            }
                        }
                    }
                }
            }
        }
        function accumulate() {
            return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"])(this, void 0, void 0, function () {
                var i;
                return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__generator"])(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            i = 0;
                            _a.label = 1;
                        case 1:
                            if (!(i < n)) return [3 /*break*/, 4];
                            accumulateRange(i, Math.min(i + updateChunk, n));
                            if (!ctx.shouldUpdate) return [3 /*break*/, 3];
                            return [4 /*yield*/, ctx.update({ message: 'filling density grid', current: i, max: n })];
                        case 2:
                            _a.sent();
                            _a.label = 3;
                        case 3:
                            i += updateChunk;
                            return [3 /*break*/, 1];
                        case 4: return [2 /*return*/];
                    }
                });
            });
        }
        var resolution, radiusOffset, smoothness, scaleFactor, indices, x, y, z, id, n, radii, maxRadius, i, r, pad, expandedBox, min, scaledBox, dim, space, data, field, idData, idField, dimX, dimY, dimZ, iu, iv, iuv, gridx, gridy, gridz, densData, alpha, updateChunk, transform;
        return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__generator"])(this, function (_a) {
            switch (_a.label) {
                case 0:
                    resolution = props.resolution, radiusOffset = props.radiusOffset, smoothness = props.smoothness;
                    scaleFactor = 1 / resolution;
                    indices = position.indices, x = position.x, y = position.y, z = position.z, id = position.id;
                    n = _mol_data_int__WEBPACK_IMPORTED_MODULE_3__["OrderedSet"].size(indices);
                    radii = new Float32Array(n);
                    maxRadius = 0;
                    for (i = 0; i < n; ++i) {
                        r = radius(_mol_data_int__WEBPACK_IMPORTED_MODULE_3__["OrderedSet"].getAt(indices, i)) + radiusOffset;
                        if (maxRadius < r)
                            maxRadius = r;
                        radii[i] = r;
                    }
                    pad = maxRadius * 2 + resolution;
                    expandedBox = _geometry__WEBPACK_IMPORTED_MODULE_1__["Box3D"].expand(Object(_geometry__WEBPACK_IMPORTED_MODULE_1__["Box3D"])(), box, _linear_algebra__WEBPACK_IMPORTED_MODULE_2__["Vec3"].create(pad, pad, pad));
                    min = expandedBox.min;
                    scaledBox = _geometry__WEBPACK_IMPORTED_MODULE_1__["Box3D"].scale(Object(_geometry__WEBPACK_IMPORTED_MODULE_1__["Box3D"])(), expandedBox, scaleFactor);
                    dim = _geometry__WEBPACK_IMPORTED_MODULE_1__["Box3D"].size(Object(_linear_algebra__WEBPACK_IMPORTED_MODULE_2__["Vec3"])(), scaledBox);
                    _linear_algebra__WEBPACK_IMPORTED_MODULE_2__["Vec3"].ceil(dim, dim);
                    space = _linear_algebra__WEBPACK_IMPORTED_MODULE_2__["Tensor"].Space(dim, [0, 1, 2], Float32Array);
                    data = space.create();
                    field = _linear_algebra__WEBPACK_IMPORTED_MODULE_2__["Tensor"].create(space, data);
                    idData = space.create();
                    idData.fill(-1);
                    idField = _linear_algebra__WEBPACK_IMPORTED_MODULE_2__["Tensor"].create(space, idData);
                    dimX = dim[0], dimY = dim[1], dimZ = dim[2];
                    iu = dimZ, iv = dimY, iuv = iu * iv;
                    gridx = Object(_geometry__WEBPACK_IMPORTED_MODULE_1__["fillGridDim"])(dim[0], min[0], resolution);
                    gridy = Object(_geometry__WEBPACK_IMPORTED_MODULE_1__["fillGridDim"])(dim[1], min[1], resolution);
                    gridz = Object(_geometry__WEBPACK_IMPORTED_MODULE_1__["fillGridDim"])(dim[2], min[2], resolution);
                    densData = space.create();
                    alpha = smoothness;
                    updateChunk = Math.ceil(100000 / ((Math.pow(Math.pow(maxRadius, 3), 3) * scaleFactor)));
                    // console.time('gaussian density cpu')
                    return [4 /*yield*/, accumulate()];
                case 1:
                    // console.time('gaussian density cpu')
                    _a.sent();
                    transform = _linear_algebra__WEBPACK_IMPORTED_MODULE_2__["Mat4"].identity();
                    _linear_algebra__WEBPACK_IMPORTED_MODULE_2__["Mat4"].fromScaling(transform, _linear_algebra__WEBPACK_IMPORTED_MODULE_2__["Vec3"].create(resolution, resolution, resolution));
                    _linear_algebra__WEBPACK_IMPORTED_MODULE_2__["Mat4"].setTranslation(transform, expandedBox.min);
                    return [2 /*return*/, { field: field, idField: idField, transform: transform, radiusFactor: 1 }];
            }
        });
    });
}
//# sourceMappingURL=cpu.js.map

/***/ }),

/***/ "./lib/mol-math/geometry/gaussian-density/gpu.js":
/*!*******************************************************!*\
  !*** ./lib/mol-math/geometry/gaussian-density/gpu.js ***!
  \*******************************************************/
/*! exports provided: GaussianDensitySchema, GaussianDensityGPU, GaussianDensityTexture, GaussianDensityTexture2d, GaussianDensityTexture3d, fieldFromTexture2d */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "GaussianDensitySchema", function() { return GaussianDensitySchema; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "GaussianDensityGPU", function() { return GaussianDensityGPU; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "GaussianDensityTexture", function() { return GaussianDensityTexture; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "GaussianDensityTexture2d", function() { return GaussianDensityTexture2d; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "GaussianDensityTexture3d", function() { return GaussianDensityTexture3d; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fieldFromTexture2d", function() { return fieldFromTexture2d; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _geometry__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../geometry */ "./lib/mol-math/geometry.js");
/* harmony import */ var _mol_data_int__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../../mol-data/int */ "./lib/mol-data/int.js");
/* harmony import */ var _linear_algebra__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../linear-algebra */ "./lib/mol-math/linear-algebra.js");
/* harmony import */ var _mol_util__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../../mol-util */ "./lib/mol-util/index.js");
/* harmony import */ var _mol_gl_renderable__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../../mol-gl/renderable */ "./lib/mol-gl/renderable.js");
/* harmony import */ var _mol_util_float_packing__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../../../mol-util/float-packing */ "./lib/mol-util/float-packing.js");
/* harmony import */ var _mol_gl_shader_code__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../../../mol-gl/shader-code */ "./lib/mol-gl/shader-code.js");
/* harmony import */ var _mol_gl_webgl_render_item__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ../../../mol-gl/webgl/render-item */ "./lib/mol-gl/webgl/render-item.js");
/* harmony import */ var _mol_gl_renderable_schema__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ../../../mol-gl/renderable/schema */ "./lib/mol-gl/renderable/schema.js");
/* harmony import */ var _mol_gl_shader_gaussian_density_vert__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ../../../mol-gl/shader/gaussian-density.vert */ "./lib/mol-gl/shader/gaussian-density.vert.js");
/* harmony import */ var _mol_gl_shader_gaussian_density_frag__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ../../../mol-gl/shader/gaussian-density.frag */ "./lib/mol-gl/shader/gaussian-density.frag.js");
/**
 * Copyright (c) 2017-2021 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 * @author Michael Krone <michael.krone@uni-tuebingen.de>
 */












var GaussianDensitySchema = {
    drawCount: Object(_mol_gl_renderable_schema__WEBPACK_IMPORTED_MODULE_9__["ValueSpec"])('number'),
    instanceCount: Object(_mol_gl_renderable_schema__WEBPACK_IMPORTED_MODULE_9__["ValueSpec"])('number'),
    aRadius: Object(_mol_gl_renderable_schema__WEBPACK_IMPORTED_MODULE_9__["AttributeSpec"])('float32', 1, 0),
    aPosition: Object(_mol_gl_renderable_schema__WEBPACK_IMPORTED_MODULE_9__["AttributeSpec"])('float32', 3, 0),
    aGroup: Object(_mol_gl_renderable_schema__WEBPACK_IMPORTED_MODULE_9__["AttributeSpec"])('float32', 1, 0),
    uCurrentSlice: Object(_mol_gl_renderable_schema__WEBPACK_IMPORTED_MODULE_9__["UniformSpec"])('f'),
    uCurrentX: Object(_mol_gl_renderable_schema__WEBPACK_IMPORTED_MODULE_9__["UniformSpec"])('f'),
    uCurrentY: Object(_mol_gl_renderable_schema__WEBPACK_IMPORTED_MODULE_9__["UniformSpec"])('f'),
    uBboxMin: Object(_mol_gl_renderable_schema__WEBPACK_IMPORTED_MODULE_9__["UniformSpec"])('v3', true),
    uBboxSize: Object(_mol_gl_renderable_schema__WEBPACK_IMPORTED_MODULE_9__["UniformSpec"])('v3', true),
    uGridDim: Object(_mol_gl_renderable_schema__WEBPACK_IMPORTED_MODULE_9__["UniformSpec"])('v3', true),
    uGridTexDim: Object(_mol_gl_renderable_schema__WEBPACK_IMPORTED_MODULE_9__["UniformSpec"])('v3', true),
    uGridTexScale: Object(_mol_gl_renderable_schema__WEBPACK_IMPORTED_MODULE_9__["UniformSpec"])('v2', true),
    uAlpha: Object(_mol_gl_renderable_schema__WEBPACK_IMPORTED_MODULE_9__["UniformSpec"])('f', true),
    uResolution: Object(_mol_gl_renderable_schema__WEBPACK_IMPORTED_MODULE_9__["UniformSpec"])('f', true),
    uRadiusFactorInv: Object(_mol_gl_renderable_schema__WEBPACK_IMPORTED_MODULE_9__["UniformSpec"])('f', true),
    tMinDistanceTex: Object(_mol_gl_renderable_schema__WEBPACK_IMPORTED_MODULE_9__["TextureSpec"])('texture', 'rgba', 'float', 'nearest'),
    dGridTexType: Object(_mol_gl_renderable_schema__WEBPACK_IMPORTED_MODULE_9__["DefineSpec"])('string', ['2d', '3d']),
    dCalcType: Object(_mol_gl_renderable_schema__WEBPACK_IMPORTED_MODULE_9__["DefineSpec"])('string', ['density', 'minDistance', 'groupId']),
};
var GaussianDensityName = 'gaussian-density';
var GaussianDensityShaderCode = Object(_mol_gl_shader_code__WEBPACK_IMPORTED_MODULE_7__["ShaderCode"])(GaussianDensityName, _mol_gl_shader_gaussian_density_vert__WEBPACK_IMPORTED_MODULE_10__["default"], _mol_gl_shader_gaussian_density_frag__WEBPACK_IMPORTED_MODULE_11__["default"]);
function getFramebuffer(webgl) {
    if (!webgl.namedFramebuffers[GaussianDensityName]) {
        webgl.namedFramebuffers[GaussianDensityName] = webgl.resources.framebuffer();
    }
    return webgl.namedFramebuffers[GaussianDensityName];
}
function getTexture(name, webgl, kind, format, type, filter) {
    var _name = GaussianDensityName + "-" + name;
    if (!webgl.namedTextures[_name]) {
        webgl.namedTextures[_name] = webgl.resources.texture(kind, format, type, filter);
    }
    return webgl.namedTextures[_name];
}
function GaussianDensityGPU(position, box, radius, props, webgl) {
    // always use texture2d when the gaussian density needs to be downloaded from the GPU,
    // it's faster than texture3d
    // console.time('GaussianDensityTexture2d')
    var tmpTexture = getTexture('tmp', webgl, 'image-uint8', 'rgba', 'ubyte', 'linear');
    var _a = calcGaussianDensityTexture2d(webgl, position, box, radius, false, props, tmpTexture), scale = _a.scale, bbox = _a.bbox, texture = _a.texture, gridDim = _a.gridDim, gridTexDim = _a.gridTexDim, radiusFactor = _a.radiusFactor;
    // webgl.waitForGpuCommandsCompleteSync()
    // console.timeEnd('GaussianDensityTexture2d')
    var _b = fieldFromTexture2d(webgl, texture, gridDim, gridTexDim), field = _b.field, idField = _b.idField;
    return { field: field, idField: idField, transform: getTransform(scale, bbox), radiusFactor: radiusFactor };
}
function GaussianDensityTexture(webgl, position, box, radius, props, oldTexture) {
    return webgl.isWebGL2 ?
        GaussianDensityTexture3d(webgl, position, box, radius, props, oldTexture) :
        GaussianDensityTexture2d(webgl, position, box, radius, false, props, oldTexture);
}
function GaussianDensityTexture2d(webgl, position, box, radius, powerOfTwo, props, oldTexture) {
    return finalizeGaussianDensityTexture(calcGaussianDensityTexture2d(webgl, position, box, radius, powerOfTwo, props, oldTexture));
}
function GaussianDensityTexture3d(webgl, position, box, radius, props, oldTexture) {
    return finalizeGaussianDensityTexture(calcGaussianDensityTexture3d(webgl, position, box, radius, props, oldTexture));
}
function finalizeGaussianDensityTexture(_a) {
    var texture = _a.texture, scale = _a.scale, bbox = _a.bbox, gridDim = _a.gridDim, gridTexDim = _a.gridTexDim, gridTexScale = _a.gridTexScale, radiusFactor = _a.radiusFactor;
    return { transform: getTransform(scale, bbox), texture: texture, bbox: bbox, gridDim: gridDim, gridTexDim: gridTexDim, gridTexScale: gridTexScale, radiusFactor: radiusFactor };
}
function getTransform(scale, bbox) {
    var transform = _linear_algebra__WEBPACK_IMPORTED_MODULE_3__["Mat4"].identity();
    _linear_algebra__WEBPACK_IMPORTED_MODULE_3__["Mat4"].fromScaling(transform, scale);
    _linear_algebra__WEBPACK_IMPORTED_MODULE_3__["Mat4"].setTranslation(transform, bbox.min);
    return transform;
}
function calcGaussianDensityTexture2d(webgl, position, box, radius, powerOfTwo, props, texture) {
    // console.log('2d');
    var gl = webgl.gl, resources = webgl.resources, state = webgl.state, _a = webgl.extensions, colorBufferFloat = _a.colorBufferFloat, textureFloat = _a.textureFloat, colorBufferHalfFloat = _a.colorBufferHalfFloat, textureHalfFloat = _a.textureHalfFloat;
    var smoothness = props.smoothness, resolution = props.resolution;
    var _b = prepareGaussianDensityData(position, box, radius, props), drawCount = _b.drawCount, positions = _b.positions, radii = _b.radii, groups = _b.groups, scale = _b.scale, expandedBox = _b.expandedBox, dim = _b.dim, maxRadius = _b.maxRadius;
    var dx = dim[0], dy = dim[1], dz = dim[2];
    var _c = getTexture2dSize(dim), texDimX = _c.texDimX, texDimY = _c.texDimY, texCols = _c.texCols, powerOfTwoSize = _c.powerOfTwoSize;
    // console.log({ texDimX, texDimY, texCols, powerOfTwoSize, dim });
    var gridTexDim = _linear_algebra__WEBPACK_IMPORTED_MODULE_3__["Vec3"].create(texDimX, texDimY, 0);
    var gridTexScale = _linear_algebra__WEBPACK_IMPORTED_MODULE_3__["Vec2"].create(texDimX / powerOfTwoSize, texDimY / powerOfTwoSize);
    var radiusFactor = maxRadius * 2;
    var width = powerOfTwo ? powerOfTwoSize : texDimX;
    var height = powerOfTwo ? powerOfTwoSize : texDimY;
    var minDistTex = getTexture('min-dist-2d', webgl, 'image-uint8', 'rgba', 'ubyte', 'nearest');
    minDistTex.define(width, height);
    var renderable = getGaussianDensityRenderable(webgl, drawCount, positions, radii, groups, minDistTex, expandedBox, dim, gridTexDim, gridTexScale, smoothness, resolution, radiusFactor);
    //
    var _d = renderable.values, uCurrentSlice = _d.uCurrentSlice, uCurrentX = _d.uCurrentX, uCurrentY = _d.uCurrentY;
    var framebuffer = getFramebuffer(webgl);
    framebuffer.bind();
    setRenderingDefaults(webgl);
    if (!texture)
        texture = colorBufferHalfFloat && textureHalfFloat
            ? resources.texture('image-float16', 'rgba', 'fp16', 'linear')
            : colorBufferFloat && textureFloat
                ? resources.texture('image-float32', 'rgba', 'float', 'linear')
                : resources.texture('image-uint8', 'rgba', 'ubyte', 'linear');
    texture.define(width, height);
    // console.log(renderable)
    function render(fbTex, clear) {
        state.currentRenderItemId = -1;
        fbTex.attachFramebuffer(framebuffer, 0);
        if (clear) {
            gl.viewport(0, 0, width, height);
            gl.scissor(0, 0, width, height);
            gl.clear(gl.COLOR_BUFFER_BIT);
        }
        _mol_util__WEBPACK_IMPORTED_MODULE_4__["ValueCell"].update(uCurrentY, 0);
        var currCol = 0;
        var currY = 0;
        var currX = 0;
        for (var i = 0; i < dz; ++i) {
            if (currCol >= texCols) {
                currCol -= texCols;
                currY += dy;
                currX = 0;
                _mol_util__WEBPACK_IMPORTED_MODULE_4__["ValueCell"].update(uCurrentY, currY);
            }
            // console.log({ i, currX, currY });
            _mol_util__WEBPACK_IMPORTED_MODULE_4__["ValueCell"].update(uCurrentX, currX);
            _mol_util__WEBPACK_IMPORTED_MODULE_4__["ValueCell"].update(uCurrentSlice, i);
            gl.viewport(currX, currY, dx, dy);
            gl.scissor(currX, currY, dx, dy);
            renderable.render();
            ++currCol;
            currX += dx;
        }
        gl.flush();
    }
    setupDensityRendering(webgl, renderable);
    render(texture, true);
    setupMinDistanceRendering(webgl, renderable);
    render(minDistTex, true);
    setupGroupIdRendering(webgl, renderable);
    render(texture, false);
    // printTexture(webgl, minDistTex, 0.75);
    return { texture: texture, scale: scale, bbox: expandedBox, gridDim: dim, gridTexDim: gridTexDim, gridTexScale: gridTexScale, radiusFactor: radiusFactor };
}
function calcGaussianDensityTexture3d(webgl, position, box, radius, props, texture) {
    // console.log('3d');
    var gl = webgl.gl, resources = webgl.resources, state = webgl.state, _a = webgl.extensions, colorBufferFloat = _a.colorBufferFloat, textureFloat = _a.textureFloat, colorBufferHalfFloat = _a.colorBufferHalfFloat, textureHalfFloat = _a.textureHalfFloat;
    var smoothness = props.smoothness, resolution = props.resolution;
    var _b = prepareGaussianDensityData(position, box, radius, props), drawCount = _b.drawCount, positions = _b.positions, radii = _b.radii, groups = _b.groups, scale = _b.scale, expandedBox = _b.expandedBox, dim = _b.dim, maxRadius = _b.maxRadius;
    var dx = dim[0], dy = dim[1], dz = dim[2];
    var minDistTex = getTexture('min-dist-3d', webgl, 'volume-uint8', 'rgba', 'ubyte', 'nearest');
    minDistTex.define(dx, dy, dz);
    var gridTexScale = _linear_algebra__WEBPACK_IMPORTED_MODULE_3__["Vec2"].create(1, 1);
    var radiusFactor = maxRadius * 2;
    var renderable = getGaussianDensityRenderable(webgl, drawCount, positions, radii, groups, minDistTex, expandedBox, dim, dim, gridTexScale, smoothness, resolution, radiusFactor);
    //
    var uCurrentSlice = renderable.values.uCurrentSlice;
    var framebuffer = getFramebuffer(webgl);
    framebuffer.bind();
    setRenderingDefaults(webgl);
    gl.viewport(0, 0, dx, dy);
    gl.scissor(0, 0, dx, dy);
    if (!texture)
        texture = colorBufferHalfFloat && textureHalfFloat
            ? resources.texture('volume-float16', 'rgba', 'fp16', 'linear')
            : colorBufferFloat && textureFloat
                ? resources.texture('volume-float32', 'rgba', 'float', 'linear')
                : resources.texture('volume-uint8', 'rgba', 'ubyte', 'linear');
    texture.define(dx, dy, dz);
    function render(fbTex, clear) {
        state.currentRenderItemId = -1;
        for (var i = 0; i < dz; ++i) {
            _mol_util__WEBPACK_IMPORTED_MODULE_4__["ValueCell"].update(uCurrentSlice, i);
            fbTex.attachFramebuffer(framebuffer, 0, i);
            if (clear)
                gl.clear(gl.COLOR_BUFFER_BIT);
            renderable.render();
        }
        gl.flush();
    }
    setupDensityRendering(webgl, renderable);
    render(texture, true);
    setupMinDistanceRendering(webgl, renderable);
    render(minDistTex, true);
    setupGroupIdRendering(webgl, renderable);
    render(texture, false);
    return { texture: texture, scale: scale, bbox: expandedBox, gridDim: dim, gridTexDim: dim, gridTexScale: gridTexScale, radiusFactor: radiusFactor };
}
//
function prepareGaussianDensityData(position, box, radius, props) {
    var resolution = props.resolution, radiusOffset = props.radiusOffset;
    var scaleFactor = 1 / resolution;
    var indices = position.indices, x = position.x, y = position.y, z = position.z, id = position.id;
    var n = _mol_data_int__WEBPACK_IMPORTED_MODULE_2__["OrderedSet"].size(indices);
    var positions = new Float32Array(n * 3);
    var radii = new Float32Array(n);
    var groups = new Float32Array(n);
    var maxRadius = 0;
    for (var i = 0; i < n; ++i) {
        var j = _mol_data_int__WEBPACK_IMPORTED_MODULE_2__["OrderedSet"].getAt(indices, i);
        positions[i * 3] = x[j];
        positions[i * 3 + 1] = y[j];
        positions[i * 3 + 2] = z[j];
        var r = radius(j) + radiusOffset;
        if (maxRadius < r)
            maxRadius = r;
        radii[i] = r;
        groups[i] = id ? id[i] : i;
    }
    var pad = maxRadius * 2 + resolution * 4;
    var expandedBox = _geometry__WEBPACK_IMPORTED_MODULE_1__["Box3D"].expand(Object(_geometry__WEBPACK_IMPORTED_MODULE_1__["Box3D"])(), box, _linear_algebra__WEBPACK_IMPORTED_MODULE_3__["Vec3"].create(pad, pad, pad));
    var scaledBox = _geometry__WEBPACK_IMPORTED_MODULE_1__["Box3D"].scale(Object(_geometry__WEBPACK_IMPORTED_MODULE_1__["Box3D"])(), expandedBox, scaleFactor);
    var dim = _geometry__WEBPACK_IMPORTED_MODULE_1__["Box3D"].size(Object(_linear_algebra__WEBPACK_IMPORTED_MODULE_3__["Vec3"])(), scaledBox);
    _linear_algebra__WEBPACK_IMPORTED_MODULE_3__["Vec3"].ceil(dim, dim);
    var scale = _linear_algebra__WEBPACK_IMPORTED_MODULE_3__["Vec3"].create(resolution, resolution, resolution);
    return { drawCount: n, positions: positions, radii: radii, groups: groups, scale: scale, expandedBox: expandedBox, dim: dim, maxRadius: maxRadius };
}
function getGaussianDensityRenderable(webgl, drawCount, positions, radii, groups, minDistanceTexture, box, gridDim, gridTexDim, gridTexScale, smoothness, resolution, radiusFactor) {
    // console.log('radiusFactor', radiusFactor);
    if (webgl.namedComputeRenderables[GaussianDensityName]) {
        var extent = _linear_algebra__WEBPACK_IMPORTED_MODULE_3__["Vec3"].sub(Object(_linear_algebra__WEBPACK_IMPORTED_MODULE_3__["Vec3"])(), box.max, box.min);
        var v = webgl.namedComputeRenderables[GaussianDensityName].values;
        _mol_util__WEBPACK_IMPORTED_MODULE_4__["ValueCell"].updateIfChanged(v.drawCount, drawCount);
        _mol_util__WEBPACK_IMPORTED_MODULE_4__["ValueCell"].updateIfChanged(v.instanceCount, 1);
        _mol_util__WEBPACK_IMPORTED_MODULE_4__["ValueCell"].update(v.aRadius, radii);
        _mol_util__WEBPACK_IMPORTED_MODULE_4__["ValueCell"].update(v.aPosition, positions);
        _mol_util__WEBPACK_IMPORTED_MODULE_4__["ValueCell"].update(v.aGroup, groups);
        _mol_util__WEBPACK_IMPORTED_MODULE_4__["ValueCell"].updateIfChanged(v.uCurrentSlice, 0);
        _mol_util__WEBPACK_IMPORTED_MODULE_4__["ValueCell"].updateIfChanged(v.uCurrentX, 0);
        _mol_util__WEBPACK_IMPORTED_MODULE_4__["ValueCell"].updateIfChanged(v.uCurrentY, 0);
        _mol_util__WEBPACK_IMPORTED_MODULE_4__["ValueCell"].update(v.uBboxMin, box.min);
        _mol_util__WEBPACK_IMPORTED_MODULE_4__["ValueCell"].update(v.uBboxSize, extent);
        _mol_util__WEBPACK_IMPORTED_MODULE_4__["ValueCell"].update(v.uGridDim, gridDim);
        _mol_util__WEBPACK_IMPORTED_MODULE_4__["ValueCell"].update(v.uGridTexDim, gridTexDim);
        _mol_util__WEBPACK_IMPORTED_MODULE_4__["ValueCell"].update(v.uGridTexScale, gridTexScale);
        _mol_util__WEBPACK_IMPORTED_MODULE_4__["ValueCell"].updateIfChanged(v.uAlpha, smoothness);
        _mol_util__WEBPACK_IMPORTED_MODULE_4__["ValueCell"].updateIfChanged(v.uResolution, resolution);
        _mol_util__WEBPACK_IMPORTED_MODULE_4__["ValueCell"].updateIfChanged(v.uRadiusFactorInv, 1 / radiusFactor);
        _mol_util__WEBPACK_IMPORTED_MODULE_4__["ValueCell"].update(v.tMinDistanceTex, minDistanceTexture);
        _mol_util__WEBPACK_IMPORTED_MODULE_4__["ValueCell"].updateIfChanged(v.dGridTexType, minDistanceTexture.getDepth() > 0 ? '3d' : '2d');
        _mol_util__WEBPACK_IMPORTED_MODULE_4__["ValueCell"].updateIfChanged(v.dCalcType, 'density');
        webgl.namedComputeRenderables[GaussianDensityName].update();
    }
    else {
        webgl.namedComputeRenderables[GaussianDensityName] = createGaussianDensityRenderable(webgl, drawCount, positions, radii, groups, minDistanceTexture, box, gridDim, gridTexDim, gridTexScale, smoothness, resolution, radiusFactor);
    }
    return webgl.namedComputeRenderables[GaussianDensityName];
}
function createGaussianDensityRenderable(webgl, drawCount, positions, radii, groups, minDistanceTexture, box, gridDim, gridTexDim, gridTexScale, smoothness, resolution, radiusFactor) {
    var extent = _linear_algebra__WEBPACK_IMPORTED_MODULE_3__["Vec3"].sub(Object(_linear_algebra__WEBPACK_IMPORTED_MODULE_3__["Vec3"])(), box.max, box.min);
    var values = {
        drawCount: _mol_util__WEBPACK_IMPORTED_MODULE_4__["ValueCell"].create(drawCount),
        instanceCount: _mol_util__WEBPACK_IMPORTED_MODULE_4__["ValueCell"].create(1),
        aRadius: _mol_util__WEBPACK_IMPORTED_MODULE_4__["ValueCell"].create(radii),
        aPosition: _mol_util__WEBPACK_IMPORTED_MODULE_4__["ValueCell"].create(positions),
        aGroup: _mol_util__WEBPACK_IMPORTED_MODULE_4__["ValueCell"].create(groups),
        uCurrentSlice: _mol_util__WEBPACK_IMPORTED_MODULE_4__["ValueCell"].create(0),
        uCurrentX: _mol_util__WEBPACK_IMPORTED_MODULE_4__["ValueCell"].create(0),
        uCurrentY: _mol_util__WEBPACK_IMPORTED_MODULE_4__["ValueCell"].create(0),
        uBboxMin: _mol_util__WEBPACK_IMPORTED_MODULE_4__["ValueCell"].create(box.min),
        uBboxSize: _mol_util__WEBPACK_IMPORTED_MODULE_4__["ValueCell"].create(extent),
        uGridDim: _mol_util__WEBPACK_IMPORTED_MODULE_4__["ValueCell"].create(gridDim),
        uGridTexDim: _mol_util__WEBPACK_IMPORTED_MODULE_4__["ValueCell"].create(gridTexDim),
        uGridTexScale: _mol_util__WEBPACK_IMPORTED_MODULE_4__["ValueCell"].create(gridTexScale),
        uAlpha: _mol_util__WEBPACK_IMPORTED_MODULE_4__["ValueCell"].create(smoothness),
        uResolution: _mol_util__WEBPACK_IMPORTED_MODULE_4__["ValueCell"].create(resolution),
        uRadiusFactorInv: _mol_util__WEBPACK_IMPORTED_MODULE_4__["ValueCell"].create(1 / radiusFactor),
        tMinDistanceTex: _mol_util__WEBPACK_IMPORTED_MODULE_4__["ValueCell"].create(minDistanceTexture),
        dGridTexType: _mol_util__WEBPACK_IMPORTED_MODULE_4__["ValueCell"].create(minDistanceTexture.getDepth() > 0 ? '3d' : '2d'),
        dCalcType: _mol_util__WEBPACK_IMPORTED_MODULE_4__["ValueCell"].create('density'),
    };
    var schema = Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, GaussianDensitySchema);
    var renderItem = Object(_mol_gl_webgl_render_item__WEBPACK_IMPORTED_MODULE_8__["createComputeRenderItem"])(webgl, 'points', GaussianDensityShaderCode, schema, values);
    return Object(_mol_gl_renderable__WEBPACK_IMPORTED_MODULE_5__["createComputeRenderable"])(renderItem, values);
}
function setRenderingDefaults(ctx) {
    var gl = ctx.gl, state = ctx.state;
    state.disable(gl.CULL_FACE);
    state.enable(gl.BLEND);
    state.disable(gl.DEPTH_TEST);
    state.enable(gl.SCISSOR_TEST);
    state.depthMask(false);
    state.clearColor(0, 0, 0, 0);
}
function setupMinDistanceRendering(webgl, renderable) {
    var gl = webgl.gl, state = webgl.state;
    _mol_util__WEBPACK_IMPORTED_MODULE_4__["ValueCell"].update(renderable.values.dCalcType, 'minDistance');
    renderable.update();
    state.colorMask(false, false, false, true);
    state.blendFunc(gl.ONE, gl.ONE);
    // the shader writes 1 - dist so we set blending to MAX
    if (!webgl.extensions.blendMinMax) {
        throw new Error('GPU gaussian surface calculation requires EXT_blend_minmax');
    }
    state.blendEquation(webgl.extensions.blendMinMax.MAX);
}
function setupDensityRendering(webgl, renderable) {
    var gl = webgl.gl, state = webgl.state;
    _mol_util__WEBPACK_IMPORTED_MODULE_4__["ValueCell"].update(renderable.values.dCalcType, 'density');
    renderable.update();
    state.colorMask(false, false, false, true);
    state.blendFunc(gl.ONE, gl.ONE);
    state.blendEquation(gl.FUNC_ADD);
}
function setupGroupIdRendering(webgl, renderable) {
    var gl = webgl.gl, state = webgl.state;
    _mol_util__WEBPACK_IMPORTED_MODULE_4__["ValueCell"].update(renderable.values.dCalcType, 'groupId');
    renderable.update();
    // overwrite color, don't change alpha
    state.colorMask(true, true, true, false);
    state.blendFunc(gl.ONE, gl.ZERO);
    state.blendEquation(gl.FUNC_ADD);
}
function getTexture2dSize(gridDim) {
    var area = gridDim[0] * gridDim[1] * gridDim[2];
    var squareDim = Math.sqrt(area);
    var powerOfTwoSize = Math.pow(2, Math.ceil(Math.log(squareDim) / Math.log(2)));
    var texDimX = 0;
    var texDimY = gridDim[1];
    var texRows = 1;
    var texCols = gridDim[2];
    if (powerOfTwoSize < gridDim[0] * gridDim[2]) {
        texCols = Math.floor(powerOfTwoSize / gridDim[0]);
        texRows = Math.ceil(gridDim[2] / texCols);
        texDimX = texCols * gridDim[0];
        texDimY *= texRows;
    }
    else {
        texDimX = gridDim[0] * gridDim[2];
    }
    // console.log(texDimX, texDimY, texDimY < powerOfTwoSize ? powerOfTwoSize : powerOfTwoSize * 2);
    return { texDimX: texDimX, texDimY: texDimY, texRows: texRows, texCols: texCols, powerOfTwoSize: texDimY < powerOfTwoSize ? powerOfTwoSize : powerOfTwoSize * 2 };
}
function fieldFromTexture2d(ctx, texture, dim, texDim) {
    // console.time('fieldFromTexture2d')
    var dx = dim[0], dy = dim[1], dz = dim[2];
    var width = texDim[0], height = texDim[1];
    var fboTexCols = Math.floor(width / dx);
    var space = _linear_algebra__WEBPACK_IMPORTED_MODULE_3__["Tensor"].Space(dim, [2, 1, 0], Float32Array);
    var data = space.create();
    var field = _linear_algebra__WEBPACK_IMPORTED_MODULE_3__["Tensor"].create(space, data);
    var idData = space.create();
    var idField = _linear_algebra__WEBPACK_IMPORTED_MODULE_3__["Tensor"].create(space, idData);
    var image = new Uint8Array(width * height * 4);
    var framebuffer = getFramebuffer(ctx);
    framebuffer.bind();
    texture.attachFramebuffer(framebuffer, 0);
    ctx.readPixels(0, 0, width, height, image);
    // printImageData(createImageData(image, width, height), 1/3)
    var j = 0;
    var tmpCol = 0;
    var tmpRow = 0;
    for (var iz = 0; iz < dz; ++iz) {
        if (tmpCol >= fboTexCols) {
            tmpCol = 0;
            tmpRow += dy;
        }
        for (var iy = 0; iy < dy; ++iy) {
            for (var ix = 0; ix < dx; ++ix) {
                var idx = 4 * (tmpCol * dx + (iy + tmpRow) * width + ix);
                data[j] = image[idx + 3] / 255;
                idData[j] = Object(_mol_util_float_packing__WEBPACK_IMPORTED_MODULE_6__["decodeFloatRGB"])(image[idx], image[idx + 1], image[idx + 2]);
                j++;
            }
        }
        tmpCol++;
    }
    // console.timeEnd('fieldFromTexture2d')
    return { field: field, idField: idField };
}
//# sourceMappingURL=gpu.js.map

/***/ }),

/***/ "./lib/mol-math/geometry/lookup3d/common.js":
/*!**************************************************!*\
  !*** ./lib/mol-math/geometry/lookup3d/common.js ***!
  \**************************************************/
/*! exports provided: Result */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Result", function() { return Result; });
/**
 * Copyright (c) 2018-2019 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author David Sehnal <david.sehnal@gmail.com>
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */
var Result;
(function (Result) {
    function add(result, index, distSq) {
        result.squaredDistances[result.count] = distSq;
        result.indices[result.count++] = index;
    }
    Result.add = add;
    function reset(result) {
        result.count = 0;
    }
    Result.reset = reset;
    function create() {
        return { count: 0, indices: [], squaredDistances: [] };
    }
    Result.create = create;
    function copy(out, result) {
        for (var i = 0; i < result.count; ++i) {
            out.indices[i] = result.indices[i];
            out.squaredDistances[i] = result.squaredDistances[i];
        }
        out.count = result.count;
        return out;
    }
    Result.copy = copy;
})(Result || (Result = {}));
//# sourceMappingURL=common.js.map

/***/ }),

/***/ "./lib/mol-math/geometry/lookup3d/grid.js":
/*!************************************************!*\
  !*** ./lib/mol-math/geometry/lookup3d/grid.js ***!
  \************************************************/
/*! exports provided: GridLookup3D */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "GridLookup3D", function() { return GridLookup3D; });
/* harmony import */ var _common__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./common */ "./lib/mol-math/geometry/lookup3d/common.js");
/* harmony import */ var _primitives_box3d__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../primitives/box3d */ "./lib/mol-math/geometry/primitives/box3d.js");
/* harmony import */ var _linear_algebra__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../linear-algebra */ "./lib/mol-math/linear-algebra.js");
/* harmony import */ var _mol_data_int__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../../mol-data/int */ "./lib/mol-data/int.js");
/**
 * Copyright (c) 2018-2020 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author David Sehnal <david.sehnal@gmail.com>
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */




function GridLookup3D(data, boundary, cellSizeOrCount) {
    return new GridLookup3DImpl(data, boundary, cellSizeOrCount);
}

var GridLookup3DImpl = /** @class */ (function () {
    function GridLookup3DImpl(data, boundary, cellSizeOrCount) {
        var structure = build(data, boundary, cellSizeOrCount);
        this.ctx = createContext(structure);
        this.boundary = { box: structure.boundingBox, sphere: structure.boundingSphere };
        this.buckets = { offset: structure.bucketOffset, count: structure.bucketCounts, array: structure.bucketArray };
        this.result = this.ctx.result;
    }
    GridLookup3DImpl.prototype.find = function (x, y, z, radius) {
        this.ctx.x = x;
        this.ctx.y = y;
        this.ctx.z = z;
        this.ctx.radius = radius;
        this.ctx.isCheck = false;
        query(this.ctx);
        return this.ctx.result;
    };
    GridLookup3DImpl.prototype.check = function (x, y, z, radius) {
        this.ctx.x = x;
        this.ctx.y = y;
        this.ctx.z = z;
        this.ctx.radius = radius;
        this.ctx.isCheck = true;
        return query(this.ctx);
    };
    return GridLookup3DImpl;
}());
function _build(state) {
    var expandedBox = state.expandedBox, _a = state.size, sX = _a[0], sY = _a[1], sZ = _a[2], _b = state.data, px = _b.x, py = _b.y, pz = _b.z, radius = _b.radius, indices = _b.indices, elementCount = state.elementCount, delta = state.delta;
    var n = sX * sY * sZ;
    var _c = expandedBox.min, minX = _c[0], minY = _c[1], minZ = _c[2];
    var maxRadius = 0;
    var bucketCount = 0;
    var grid = new Uint32Array(n);
    var bucketIndex = new Int32Array(elementCount);
    for (var t = 0; t < elementCount; t++) {
        var i = _mol_data_int__WEBPACK_IMPORTED_MODULE_3__["OrderedSet"].getAt(indices, t);
        var x = Math.floor((px[i] - minX) / delta[0]);
        var y = Math.floor((py[i] - minY) / delta[1]);
        var z = Math.floor((pz[i] - minZ) / delta[2]);
        var idx = (((x * sY) + y) * sZ) + z;
        if ((grid[idx] += 1) === 1) {
            bucketCount += 1;
        }
        bucketIndex[t] = idx;
    }
    if (radius) {
        for (var t = 0; t < elementCount; t++) {
            var i = _mol_data_int__WEBPACK_IMPORTED_MODULE_3__["OrderedSet"].getAt(indices, t);
            if (radius[i] > maxRadius)
                maxRadius = radius[i];
        }
    }
    var bucketCounts = new Int32Array(bucketCount);
    for (var i = 0, j = 0; i < n; i++) {
        var c = grid[i];
        if (c > 0) {
            grid[i] = j + 1;
            bucketCounts[j] = c;
            j += 1;
        }
    }
    var bucketOffset = new Uint32Array(bucketCount);
    for (var i = 1; i < bucketCount; ++i) {
        bucketOffset[i] += bucketOffset[i - 1] + bucketCounts[i - 1];
    }
    var bucketFill = new Int32Array(bucketCount);
    var bucketArray = new Int32Array(elementCount);
    for (var i = 0; i < elementCount; i++) {
        var bucketIdx = grid[bucketIndex[i]];
        if (bucketIdx > 0) {
            var k = bucketIdx - 1;
            bucketArray[bucketOffset[k] + bucketFill[k]] = i;
            bucketFill[k] += 1;
        }
    }
    return {
        size: state.size,
        bucketArray: bucketArray,
        bucketCounts: bucketCounts,
        bucketOffset: bucketOffset,
        grid: grid,
        delta: delta,
        min: state.expandedBox.min,
        data: state.data,
        maxRadius: maxRadius,
        expandedBox: state.expandedBox,
        boundingBox: state.boundingBox,
        boundingSphere: state.boundingSphere
    };
}
function build(data, boundary, cellSizeOrCount) {
    // need to expand the grid bounds to avoid rounding errors
    var expandedBox = _primitives_box3d__WEBPACK_IMPORTED_MODULE_1__["Box3D"].expand(Object(_primitives_box3d__WEBPACK_IMPORTED_MODULE_1__["Box3D"])(), boundary.box, _linear_algebra__WEBPACK_IMPORTED_MODULE_2__["Vec3"].create(0.5, 0.5, 0.5));
    var indices = data.indices;
    var S = _primitives_box3d__WEBPACK_IMPORTED_MODULE_1__["Box3D"].size(_linear_algebra__WEBPACK_IMPORTED_MODULE_2__["Vec3"].zero(), expandedBox);
    var delta, size;
    var elementCount = _mol_data_int__WEBPACK_IMPORTED_MODULE_3__["OrderedSet"].size(indices);
    var cellCount = typeof cellSizeOrCount === 'number' ? cellSizeOrCount : 32;
    var cellSize = Array.isArray(cellSizeOrCount) && cellSizeOrCount;
    if (cellSize) {
        size = [Math.ceil(S[0] / cellSize[0]), Math.ceil(S[1] / cellSize[1]), Math.ceil(S[2] / cellSize[2])];
        delta = cellSize;
    }
    else if (elementCount > 0) {
        // size of the box
        // required "grid volume" so that each cell contains on average 'cellCount' elements.
        var V = Math.ceil(elementCount / cellCount);
        var f = Math.pow(V / (S[0] * S[1] * S[2]), 1 / 3);
        size = [Math.ceil(S[0] * f), Math.ceil(S[1] * f), Math.ceil(S[2] * f)];
        delta = [S[0] / size[0], S[1] / size[1], S[2] / size[2]];
    }
    else {
        delta = S;
        size = [1, 1, 1];
    }
    var inputData = {
        x: data.x,
        y: data.y,
        z: data.z,
        indices: indices,
        radius: data.radius
    };
    var state = {
        size: size,
        data: inputData,
        expandedBox: expandedBox,
        boundingBox: boundary.box,
        boundingSphere: boundary.sphere,
        elementCount: elementCount,
        delta: delta
    };
    return _build(state);
}
function createContext(grid) {
    return { grid: grid, x: 0.1, y: 0.1, z: 0.1, radius: 0.1, result: _common__WEBPACK_IMPORTED_MODULE_0__["Result"].create(), isCheck: false };
}
function query(ctx) {
    var _a = ctx.grid, min = _a.min, _b = _a.size, sX = _b[0], sY = _b[1], sZ = _b[2], bucketOffset = _a.bucketOffset, bucketCounts = _a.bucketCounts, bucketArray = _a.bucketArray, grid = _a.grid, _c = _a.data, px = _c.x, py = _c.y, pz = _c.z, indices = _c.indices, radius = _c.radius, delta = _a.delta, maxRadius = _a.maxRadius;
    var inputRadius = ctx.radius, isCheck = ctx.isCheck, x = ctx.x, y = ctx.y, z = ctx.z, result = ctx.result;
    var r = inputRadius + maxRadius;
    var rSq = r * r;
    _common__WEBPACK_IMPORTED_MODULE_0__["Result"].reset(result);
    var loX = Math.max(0, Math.floor((x - r - min[0]) / delta[0]));
    var loY = Math.max(0, Math.floor((y - r - min[1]) / delta[1]));
    var loZ = Math.max(0, Math.floor((z - r - min[2]) / delta[2]));
    var hiX = Math.min(sX - 1, Math.floor((x + r - min[0]) / delta[0]));
    var hiY = Math.min(sY - 1, Math.floor((y + r - min[1]) / delta[1]));
    var hiZ = Math.min(sZ - 1, Math.floor((z + r - min[2]) / delta[2]));
    if (loX > hiX || loY > hiY || loZ > hiZ)
        return false;
    for (var ix = loX; ix <= hiX; ix++) {
        for (var iy = loY; iy <= hiY; iy++) {
            for (var iz = loZ; iz <= hiZ; iz++) {
                var bucketIdx = grid[(((ix * sY) + iy) * sZ) + iz];
                if (bucketIdx === 0)
                    continue;
                var k = bucketIdx - 1;
                var offset = bucketOffset[k];
                var count = bucketCounts[k];
                var end = offset + count;
                for (var i = offset; i < end; i++) {
                    var idx = _mol_data_int__WEBPACK_IMPORTED_MODULE_3__["OrderedSet"].getAt(indices, bucketArray[i]);
                    var dx = px[idx] - x;
                    var dy = py[idx] - y;
                    var dz = pz[idx] - z;
                    var distSq = dx * dx + dy * dy + dz * dz;
                    if (distSq <= rSq) {
                        if (maxRadius > 0 && Math.sqrt(distSq) - radius[idx] > inputRadius)
                            continue;
                        if (isCheck)
                            return true;
                        _common__WEBPACK_IMPORTED_MODULE_0__["Result"].add(result, bucketArray[i], distSq);
                    }
                }
            }
        }
    }
    return result.count > 0;
}
//# sourceMappingURL=grid.js.map

/***/ }),

/***/ "./lib/mol-math/geometry/molecular-surface.js":
/*!****************************************************!*\
  !*** ./lib/mol-math/geometry/molecular-surface.js ***!
  \****************************************************/
/*! exports provided: MolecularSurfaceCalculationParams, DefaultMolecularSurfaceCalculationProps, calcMolecularSurface */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MolecularSurfaceCalculationParams", function() { return MolecularSurfaceCalculationParams; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DefaultMolecularSurfaceCalculationProps", function() { return DefaultMolecularSurfaceCalculationProps; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "calcMolecularSurface", function() { return calcMolecularSurface; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../mol-math/linear-algebra */ "./lib/mol-math/linear-algebra.js");
/* harmony import */ var _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../mol-util/param-definition */ "./lib/mol-util/param-definition.js");
/* harmony import */ var _mol_data_int__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../mol-data/int */ "./lib/mol-data/int.js");
/* harmony import */ var _mol_math_linear_algebra_3d__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../mol-math/linear-algebra/3d */ "./lib/mol-math/linear-algebra/3d.js");
/* harmony import */ var _mol_math_geometry__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../mol-math/geometry */ "./lib/mol-math/geometry.js");
/* harmony import */ var _mol_geo_geometry_base__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../../mol-geo/geometry/base */ "./lib/mol-geo/geometry/base.js");
/**
 * Copyright (c) 2019-2020 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author Fred Ludlow <fred.ludlow@gmail.com>
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 *
 * ported from NGL (https://github.com/arose/ngl), licensed under MIT
 */







function normalToLine(out, p) {
    out[0] = out[1] = out[2] = 1.0;
    if (p[0] !== 0) {
        out[0] = (p[1] + p[2]) / -p[0];
    }
    else if (p[1] !== 0) {
        out[1] = (p[0] + p[2]) / -p[1];
    }
    else if (p[2] !== 0) {
        out[2] = (p[0] + p[1]) / -p[2];
    }
    return out;
}
function getAngleTables(probePositions) {
    var theta = 0.0;
    var step = 2 * Math.PI / probePositions;
    var cosTable = new Float32Array(probePositions);
    var sinTable = new Float32Array(probePositions);
    for (var i = 0; i < probePositions; i++) {
        cosTable[i] = Math.cos(theta);
        sinTable[i] = Math.sin(theta);
        theta += step;
    }
    return { cosTable: cosTable, sinTable: sinTable };
}
//
var MolecularSurfaceCalculationParams = {
    probeRadius: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_2__["ParamDefinition"].Numeric(1.4, { min: 0, max: 10, step: 0.1 }, { description: 'Radius of the probe tracing the molecular surface.' }),
    resolution: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_2__["ParamDefinition"].Numeric(0.5, { min: 0.01, max: 20, step: 0.01 }, Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({ description: 'Grid resolution/cell spacing.' }, _mol_geo_geometry_base__WEBPACK_IMPORTED_MODULE_6__["BaseGeometry"].CustomQualityParamInfo)),
    probePositions: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_2__["ParamDefinition"].Numeric(30, { min: 12, max: 90, step: 1 }, Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({ description: 'Number of positions tested for probe target intersection.' }, _mol_geo_geometry_base__WEBPACK_IMPORTED_MODULE_6__["BaseGeometry"].CustomQualityParamInfo)),
};
var DefaultMolecularSurfaceCalculationProps = _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_2__["ParamDefinition"].getDefaultValues(MolecularSurfaceCalculationParams);
function calcMolecularSurface(ctx, position, boundary, maxRadius, box, props) {
    return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"])(this, void 0, void 0, function () {
        /**
         * Is the point at x,y,z obscured by any of the atoms specifeid by indices in neighbours.
         * Ignore indices a and b (these are the relevant atoms in projectPoints/Torii)
         *
         * Cache the last clipped atom (as very often the same one in subsequent calls)
         *
         * `a` and `b` must be resolved indices
         */
        function obscured(x, y, z, a, b) {
            if (lastClip !== -1) {
                var ai = lastClip;
                if (ai !== a && ai !== b && singleAtomObscures(ai, x, y, z)) {
                    return ai;
                }
                else {
                    lastClip = -1;
                }
            }
            for (var j = 0, jl = neighbours.count; j < jl; ++j) {
                var ai = _mol_data_int__WEBPACK_IMPORTED_MODULE_3__["OrderedSet"].getAt(indices, neighbours.indices[j]);
                if (ai !== a && ai !== b && singleAtomObscures(ai, x, y, z)) {
                    lastClip = ai;
                    return ai;
                }
            }
            return -1;
        }
        /**
         * `ai` must be a resolved index
         */
        function singleAtomObscures(ai, x, y, z) {
            var r = radius[ai];
            var dx = px[ai] - x;
            var dy = py[ai] - y;
            var dz = pz[ai] - z;
            var dSq = dx * dx + dy * dy + dz * dz;
            return dSq < (r * r);
        }
        /**
         * For each atom:
         *     Iterate over a subsection of the grid, for each point:
         *         If current value < 0.0, unvisited, set positive
         *
         *         In any case: Project this point onto surface of the atomic sphere
         *         If this projected point is not obscured by any other atom
         *             Calculate delta distance and set grid value to minimum of
         *             itself and delta
         */
        function projectPointsRange(begI, endI) {
            for (var i = begI; i < endI; ++i) {
                var j = _mol_data_int__WEBPACK_IMPORTED_MODULE_3__["OrderedSet"].getAt(indices, i);
                var vx = px[j], vy = py[j], vz = pz[j];
                var rad = radius[j];
                var rSq = rad * rad;
                lookup3d.find(vx, vy, vz, rad);
                // Number of grid points, round this up...
                var ng = Math.ceil(rad * scaleFactor);
                // Center of the atom, mapped to grid points (take floor)
                var iax = Math.floor(scaleFactor * (vx - minX));
                var iay = Math.floor(scaleFactor * (vy - minY));
                var iaz = Math.floor(scaleFactor * (vz - minZ));
                // Extents of grid to consider for this atom
                var begX = Math.max(0, iax - ng);
                var begY = Math.max(0, iay - ng);
                var begZ = Math.max(0, iaz - ng);
                // Add two to these points:
                // - iax are floor'd values so this ensures coverage
                // - these are loop limits (exclusive)
                var endX = Math.min(dimX, iax + ng + 2);
                var endY = Math.min(dimY, iay + ng + 2);
                var endZ = Math.min(dimZ, iaz + ng + 2);
                for (var xi = begX; xi < endX; ++xi) {
                    var dx = gridx[xi] - vx;
                    var xIdx = xi * iuv;
                    for (var yi = begY; yi < endY; ++yi) {
                        var dy = gridy[yi] - vy;
                        var dxySq = dx * dx + dy * dy;
                        var xyIdx = yi * iu + xIdx;
                        for (var zi = begZ; zi < endZ; ++zi) {
                            var dz = gridz[zi] - vz;
                            var dSq = dxySq + dz * dz;
                            if (dSq < rSq) {
                                var idx = zi + xyIdx;
                                // if unvisited, make positive
                                if (data[idx] < 0.0)
                                    data[idx] *= -1;
                                // Project on to the surface of the sphere
                                // sp is the projected point ( dx, dy, dz ) * ( ra / d )
                                var d = Math.sqrt(dSq);
                                var ap = rad / d;
                                var spx = dx * ap + vx;
                                var spy = dy * ap + vy;
                                var spz = dz * ap + vz;
                                if (obscured(spx, spy, spz, j, -1) === -1) {
                                    var dd = rad - d;
                                    if (dd < data[idx]) {
                                        data[idx] = dd;
                                        idData[idx] = id[i];
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
        function projectPoints() {
            return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"])(this, void 0, void 0, function () {
                var i;
                return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__generator"])(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            i = 0;
                            _a.label = 1;
                        case 1:
                            if (!(i < n)) return [3 /*break*/, 4];
                            projectPointsRange(i, Math.min(i + updateChunk, n));
                            if (!ctx.shouldUpdate) return [3 /*break*/, 3];
                            return [4 /*yield*/, ctx.update({ message: 'projecting points', current: i, max: n })];
                        case 2:
                            _a.sent();
                            _a.label = 3;
                        case 3:
                            i += updateChunk;
                            return [3 /*break*/, 1];
                        case 4: return [2 /*return*/];
                    }
                });
            });
        }
        /**
         * `a` and `b` must be resolved indices
         */
        function projectTorus(a, b) {
            var rA = radius[a];
            var rB = radius[b];
            var dx = atob[0] = px[b] - px[a];
            var dy = atob[1] = py[b] - py[a];
            var dz = atob[2] = pz[b] - pz[a];
            var dSq = dx * dx + dy * dy + dz * dz;
            // This check now redundant as already done in AVHash.withinRadii
            // if (dSq > ((rA + rB) * (rA + rB))) { return }
            var d = Math.sqrt(dSq);
            // Find angle between a->b vector and the circle
            // of their intersection by cosine rule
            var cosA = (rA * rA + d * d - rB * rB) / (2.0 * rA * d);
            // distance along a->b at intersection
            var dmp = rA * cosA;
            _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_1__["Vec3"].normalize(atob, atob);
            // Create normal to line
            normalToLine(n1, atob);
            _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_1__["Vec3"].normalize(n1, n1);
            // Cross together for second normal vector
            _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_1__["Vec3"].cross(n2, atob, n1);
            _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_1__["Vec3"].normalize(n2, n2);
            // r is radius of circle of intersection
            var rInt = Math.sqrt(rA * rA - dmp * dmp);
            _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_1__["Vec3"].scale(n1, n1, rInt);
            _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_1__["Vec3"].scale(n2, n2, rInt);
            _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_1__["Vec3"].scale(atob, atob, dmp);
            mid[0] = atob[0] + px[a];
            mid[1] = atob[1] + py[a];
            mid[2] = atob[2] + pz[a];
            lastClip = -1;
            for (var i = 0; i < probePositions; ++i) {
                var cost = cosTable[i];
                var sint = sinTable[i];
                var px_1 = mid[0] + cost * n1[0] + sint * n2[0];
                var py_1 = mid[1] + cost * n1[1] + sint * n2[1];
                var pz_1 = mid[2] + cost * n1[2] + sint * n2[2];
                if (obscured(px_1, py_1, pz_1, a, b) === -1) {
                    var iax = Math.floor(scaleFactor * (px_1 - minX));
                    var iay = Math.floor(scaleFactor * (py_1 - minY));
                    var iaz = Math.floor(scaleFactor * (pz_1 - minZ));
                    var begX = Math.max(0, iax - ngTorus);
                    var begY = Math.max(0, iay - ngTorus);
                    var begZ = Math.max(0, iaz - ngTorus);
                    var endX = Math.min(dimX, iax + ngTorus + 2);
                    var endY = Math.min(dimY, iay + ngTorus + 2);
                    var endZ = Math.min(dimZ, iaz + ngTorus + 2);
                    for (var xi = begX; xi < endX; ++xi) {
                        var dx_1 = px_1 - gridx[xi];
                        var xIdx = xi * iuv;
                        for (var yi = begY; yi < endY; ++yi) {
                            var dy_1 = py_1 - gridy[yi];
                            var dxySq = dx_1 * dx_1 + dy_1 * dy_1;
                            var xyIdx = yi * iu + xIdx;
                            for (var zi = begZ; zi < endZ; ++zi) {
                                var dz_1 = pz_1 - gridz[zi];
                                var dSq_1 = dxySq + dz_1 * dz_1;
                                var idx = zi + xyIdx;
                                var current = data[idx];
                                if (current > 0.0 && dSq_1 < (current * current)) {
                                    data[idx] = Math.sqrt(dSq_1);
                                    // Is this grid point closer to a or b?
                                    // Take dot product of atob and gridpoint->p (dx, dy, dz)
                                    var dp = dx_1 * atob[0] + dy_1 * atob[1] + dz_1 * atob[2];
                                    idData[idx] = id[_mol_data_int__WEBPACK_IMPORTED_MODULE_3__["OrderedSet"].indexOf(indices, dp < 0.0 ? b : a)];
                                }
                            }
                        }
                    }
                }
            }
        }
        function projectToriiRange(begI, endI) {
            for (var i = begI; i < endI; ++i) {
                var k = _mol_data_int__WEBPACK_IMPORTED_MODULE_3__["OrderedSet"].getAt(indices, i);
                lookup3d.find(px[k], py[k], pz[k], radius[k]);
                for (var j = 0, jl = neighbours.count; j < jl; ++j) {
                    var l = _mol_data_int__WEBPACK_IMPORTED_MODULE_3__["OrderedSet"].getAt(indices, neighbours.indices[j]);
                    if (k < l)
                        projectTorus(k, l);
                }
            }
        }
        function projectTorii() {
            return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"])(this, void 0, void 0, function () {
                var i;
                return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__generator"])(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            i = 0;
                            _a.label = 1;
                        case 1:
                            if (!(i < n)) return [3 /*break*/, 4];
                            projectToriiRange(i, Math.min(i + updateChunk, n));
                            if (!ctx.shouldUpdate) return [3 /*break*/, 3];
                            return [4 /*yield*/, ctx.update({ message: 'projecting torii', current: i, max: n })];
                        case 2:
                            _a.sent();
                            _a.label = 3;
                        case 3:
                            i += updateChunk;
                            return [3 /*break*/, 1];
                        case 4: return [2 /*return*/];
                    }
                });
            });
        }
        var lastClip, atob, mid, n1, n2, resolution, probeRadius, probePositions, scaleFactor, ngTorus, cellSize, lookup3d, neighbours, indices, px, py, pz, id, radius, n, pad, expandedBox, _a, minX, minY, minZ, scaledBox, dim, dimX, dimY, dimZ, iu, iv, iuv, _b, cosTable, sinTable, space, data, idData, gridx, gridy, gridz, updateChunk, field, idField, transform;
        return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__generator"])(this, function (_c) {
            switch (_c.label) {
                case 0:
                    lastClip = -1;
                    atob = Object(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_1__["Vec3"])();
                    mid = Object(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_1__["Vec3"])();
                    n1 = Object(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_1__["Vec3"])();
                    n2 = Object(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_1__["Vec3"])();
                    resolution = props.resolution, probeRadius = props.probeRadius, probePositions = props.probePositions;
                    scaleFactor = 1 / resolution;
                    ngTorus = Math.max(5, 2 + Math.floor(probeRadius * scaleFactor));
                    cellSize = _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_1__["Vec3"].create(maxRadius, maxRadius, maxRadius);
                    _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_1__["Vec3"].scale(cellSize, cellSize, 2);
                    lookup3d = Object(_mol_math_geometry__WEBPACK_IMPORTED_MODULE_5__["GridLookup3D"])(position, boundary, cellSize);
                    neighbours = lookup3d.result;
                    if (box === null)
                        box = lookup3d.boundary.box;
                    indices = position.indices, px = position.x, py = position.y, pz = position.z, id = position.id, radius = position.radius;
                    n = _mol_data_int__WEBPACK_IMPORTED_MODULE_3__["OrderedSet"].size(indices);
                    pad = maxRadius + resolution;
                    expandedBox = _mol_math_geometry__WEBPACK_IMPORTED_MODULE_5__["Box3D"].expand(Object(_mol_math_geometry__WEBPACK_IMPORTED_MODULE_5__["Box3D"])(), box, _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_1__["Vec3"].create(pad, pad, pad));
                    _a = expandedBox.min, minX = _a[0], minY = _a[1], minZ = _a[2];
                    scaledBox = _mol_math_geometry__WEBPACK_IMPORTED_MODULE_5__["Box3D"].scale(Object(_mol_math_geometry__WEBPACK_IMPORTED_MODULE_5__["Box3D"])(), expandedBox, scaleFactor);
                    dim = _mol_math_geometry__WEBPACK_IMPORTED_MODULE_5__["Box3D"].size(Object(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_1__["Vec3"])(), scaledBox);
                    _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_1__["Vec3"].ceil(dim, dim);
                    dimX = dim[0], dimY = dim[1], dimZ = dim[2];
                    iu = dimZ, iv = dimY, iuv = iu * iv;
                    _b = getAngleTables(probePositions), cosTable = _b.cosTable, sinTable = _b.sinTable;
                    space = _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_1__["Tensor"].Space(dim, [0, 1, 2], Float32Array);
                    data = space.create();
                    idData = space.create();
                    data.fill(-1001.0);
                    idData.fill(-1);
                    gridx = Object(_mol_math_geometry__WEBPACK_IMPORTED_MODULE_5__["fillGridDim"])(dimX, minX, resolution);
                    gridy = Object(_mol_math_geometry__WEBPACK_IMPORTED_MODULE_5__["fillGridDim"])(dimY, minY, resolution);
                    gridz = Object(_mol_math_geometry__WEBPACK_IMPORTED_MODULE_5__["fillGridDim"])(dimZ, minZ, resolution);
                    updateChunk = Math.ceil(100000 / ((Math.pow(Math.pow(maxRadius, 3), 3) * scaleFactor)));
                    // console.timeEnd('MolecularSurface createState')
                    // console.time('MolecularSurface projectPoints')
                    return [4 /*yield*/, projectPoints()];
                case 1:
                    // console.timeEnd('MolecularSurface createState')
                    // console.time('MolecularSurface projectPoints')
                    _c.sent();
                    // console.timeEnd('MolecularSurface projectPoints')
                    // console.time('MolecularSurface projectTorii')
                    return [4 /*yield*/, projectTorii()];
                case 2:
                    // console.timeEnd('MolecularSurface projectPoints')
                    // console.time('MolecularSurface projectTorii')
                    _c.sent();
                    field = _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_1__["Tensor"].create(space, data);
                    idField = _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_1__["Tensor"].create(space, idData);
                    transform = _mol_math_linear_algebra_3d__WEBPACK_IMPORTED_MODULE_4__["Mat4"].identity();
                    _mol_math_linear_algebra_3d__WEBPACK_IMPORTED_MODULE_4__["Mat4"].fromScaling(transform, _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_1__["Vec3"].create(resolution, resolution, resolution));
                    _mol_math_linear_algebra_3d__WEBPACK_IMPORTED_MODULE_4__["Mat4"].setTranslation(transform, expandedBox.min);
                    // console.log({ field, idField, transform, updateChunk })
                    return [2 /*return*/, { field: field, idField: idField, transform: transform }];
            }
        });
    });
}
//# sourceMappingURL=molecular-surface.js.map

/***/ }),

/***/ "./lib/mol-math/geometry/primitives/axes3d.js":
/*!****************************************************!*\
  !*** ./lib/mol-math/geometry/primitives/axes3d.js ***!
  \****************************************************/
/*! exports provided: Axes3D */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Axes3D", function() { return Axes3D; });
/* harmony import */ var _linear_algebra__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../linear-algebra */ "./lib/mol-math/linear-algebra.js");
/**
 * Copyright (c) 2019 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */

function Axes3D() {
    return Axes3D.empty();
}
(function (Axes3D) {
    function create(origin, dirA, dirB, dirC) { return { origin: origin, dirA: dirA, dirB: dirB, dirC: dirC }; }
    Axes3D.create = create;
    function empty() { return { origin: Object(_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"])(), dirA: Object(_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"])(), dirB: Object(_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"])(), dirC: Object(_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"])() }; }
    Axes3D.empty = empty;
    function copy(out, a) {
        _linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"].copy(out.origin, a.origin);
        _linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"].copy(out.dirA, a.dirA);
        _linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"].copy(out.dirB, a.dirB);
        _linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"].copy(out.dirC, a.dirC);
        return out;
    }
    Axes3D.copy = copy;
    function clone(a) {
        return copy(empty(), a);
    }
    Axes3D.clone = clone;
    /** Get size of each direction */
    function size(size, axes) {
        return _linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"].set(size, _linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"].magnitude(axes.dirA) * 2, _linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"].magnitude(axes.dirB) * 2, _linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"].magnitude(axes.dirC) * 2);
    }
    Axes3D.size = size;
    var tmpSizeV = Object(_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"])();
    /** Get volume of the oriented box wrapping the axes */
    function volume(axes) {
        size(tmpSizeV, axes);
        return tmpSizeV[0] * tmpSizeV[1] * tmpSizeV[2];
    }
    Axes3D.volume = volume;
    function normalize(out, a) {
        _linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"].copy(out.origin, a.origin);
        _linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"].normalize(out.dirA, a.dirA);
        _linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"].normalize(out.dirB, a.dirB);
        _linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"].normalize(out.dirC, a.dirC);
        return out;
    }
    Axes3D.normalize = normalize;
    var tmpTransformMat3 = _linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Mat3"].zero();
    /** Transform axes with a Mat4 */
    function transform(out, a, m) {
        _linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"].transformMat4(out.origin, a.origin, m);
        var n = _linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Mat3"].directionTransform(tmpTransformMat3, m);
        _linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"].transformMat3(out.dirA, a.dirA, n);
        _linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"].transformMat3(out.dirB, a.dirB, n);
        _linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"].transformMat3(out.dirC, a.dirC, n);
        return out;
    }
    Axes3D.transform = transform;
})(Axes3D || (Axes3D = {}));

//# sourceMappingURL=axes3d.js.map

/***/ }),

/***/ "./lib/mol-math/geometry/primitives/box3d.js":
/*!***************************************************!*\
  !*** ./lib/mol-math/geometry/primitives/box3d.js ***!
  \***************************************************/
/*! exports provided: Box3D */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Box3D", function() { return Box3D; });
/* harmony import */ var _linear_algebra__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../linear-algebra */ "./lib/mol-math/linear-algebra.js");
/* harmony import */ var _mol_data_int__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../../mol-data/int */ "./lib/mol-data/int.js");
/* harmony import */ var _sphere3d__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./sphere3d */ "./lib/mol-math/geometry/primitives/sphere3d.js");
/**
 * Copyright (c) 2018-2020 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author David Sehnal <david.sehnal@gmail.com>
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */



function Box3D() {
    return Box3D.zero();
}
(function (Box3D) {
    function create(min, max) { return { min: min, max: max }; }
    Box3D.create = create;
    function zero() { return { min: Object(_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"])(), max: Object(_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"])() }; }
    Box3D.zero = zero;
    function copy(out, a) {
        _linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"].copy(out.min, a.min);
        _linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"].copy(out.max, a.max);
        return out;
    }
    Box3D.copy = copy;
    function clone(a) {
        return copy(zero(), a);
    }
    Box3D.clone = clone;
    /** Get box from sphere, uses extrema if available */
    function fromSphere3D(out, sphere) {
        if (_sphere3d__WEBPACK_IMPORTED_MODULE_2__["Sphere3D"].hasExtrema(sphere))
            return fromVec3Array(out, sphere.extrema);
        var r = _linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"].create(sphere.radius, sphere.radius, sphere.radius);
        _linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"].sub(out.min, sphere.center, r);
        _linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"].add(out.max, sphere.center, r);
        return out;
    }
    Box3D.fromSphere3D = fromSphere3D;
    /** Get box from sphere, uses extrema if available */
    function fromVec3Array(out, array) {
        Box3D.setEmpty(out);
        for (var i = 0, il = array.length; i < il; i++) {
            Box3D.add(out, array[i]);
        }
        return out;
    }
    Box3D.fromVec3Array = fromVec3Array;
    function computeBounding(data) {
        var min = _linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"].create(Number.MAX_VALUE, Number.MAX_VALUE, Number.MAX_VALUE);
        var max = _linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"].create(-Number.MAX_VALUE, -Number.MAX_VALUE, -Number.MAX_VALUE);
        var x = data.x, y = data.y, z = data.z, indices = data.indices;
        for (var t = 0, _t = _mol_data_int__WEBPACK_IMPORTED_MODULE_1__["OrderedSet"].size(indices); t < _t; t++) {
            var i = _mol_data_int__WEBPACK_IMPORTED_MODULE_1__["OrderedSet"].getAt(indices, t);
            min[0] = Math.min(x[i], min[0]);
            min[1] = Math.min(y[i], min[1]);
            min[2] = Math.min(z[i], min[2]);
            max[0] = Math.max(x[i], max[0]);
            max[1] = Math.max(y[i], max[1]);
            max[2] = Math.max(z[i], max[2]);
        }
        return { min: min, max: max };
    }
    Box3D.computeBounding = computeBounding;
    /** Get size/extent of the box */
    function size(size, box) {
        return _linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"].sub(size, box.max, box.min);
    }
    Box3D.size = size;
    var tmpSizeV = Object(_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"])();
    /** Get volume of the box */
    function volume(box) {
        size(tmpSizeV, box);
        return tmpSizeV[0] * tmpSizeV[1] * tmpSizeV[2];
    }
    Box3D.volume = volume;
    /** Sets min to Number.MAX_VALUE and max to -Number.MAX_VALUE */
    function setEmpty(box) {
        _linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"].set(box.min, Number.MAX_VALUE, Number.MAX_VALUE, Number.MAX_VALUE);
        _linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"].set(box.max, -Number.MAX_VALUE, -Number.MAX_VALUE, -Number.MAX_VALUE);
        return box;
    }
    Box3D.setEmpty = setEmpty;
    /** Add point to box */
    function add(box, point) {
        _linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"].min(box.min, box.min, point);
        _linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"].max(box.max, box.max, point);
        return box;
    }
    Box3D.add = add;
    /** Expand box by delta */
    function expand(out, box, delta) {
        _linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"].sub(out.min, box.min, delta);
        _linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"].add(out.max, box.max, delta);
        return out;
    }
    Box3D.expand = expand;
    function scale(out, box, scale) {
        _linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"].scale(out.min, box.min, scale);
        _linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"].scale(out.max, box.max, scale);
        return out;
    }
    Box3D.scale = scale;
    var tmpTransformV = Object(_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"])();
    /** Transform box with a Mat4 */
    function transform(out, box, m) {
        var _a = box.min, minX = _a[0], minY = _a[1], minZ = _a[2];
        var _b = box.max, maxX = _b[0], maxY = _b[1], maxZ = _b[2];
        setEmpty(out);
        add(out, _linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"].transformMat4(tmpTransformV, _linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"].set(tmpTransformV, minX, minY, minZ), m));
        add(out, _linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"].transformMat4(tmpTransformV, _linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"].set(tmpTransformV, minX, minY, maxZ), m));
        add(out, _linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"].transformMat4(tmpTransformV, _linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"].set(tmpTransformV, minX, maxY, minZ), m));
        add(out, _linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"].transformMat4(tmpTransformV, _linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"].set(tmpTransformV, minX, maxY, maxZ), m));
        add(out, _linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"].transformMat4(tmpTransformV, _linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"].set(tmpTransformV, maxX, minY, minZ), m));
        add(out, _linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"].transformMat4(tmpTransformV, _linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"].set(tmpTransformV, maxX, minY, maxZ), m));
        add(out, _linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"].transformMat4(tmpTransformV, _linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"].set(tmpTransformV, maxX, maxY, minZ), m));
        add(out, _linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"].transformMat4(tmpTransformV, _linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"].set(tmpTransformV, maxX, maxY, maxZ), m));
        return out;
    }
    Box3D.transform = transform;
    function containsVec3(box, v) {
        return (v[0] < box.min[0] || v[0] > box.max[0] ||
            v[1] < box.min[1] || v[1] > box.max[1] ||
            v[2] < box.min[2] || v[2] > box.max[2]) ? false : true;
    }
    Box3D.containsVec3 = containsVec3;
})(Box3D || (Box3D = {}));

//# sourceMappingURL=box3d.js.map

/***/ }),

/***/ "./lib/mol-math/geometry/primitives/sphere3d.js":
/*!******************************************************!*\
  !*** ./lib/mol-math/geometry/primitives/sphere3d.js ***!
  \******************************************************/
/*! exports provided: Sphere3D */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Sphere3D", function() { return Sphere3D; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _linear_algebra__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../linear-algebra */ "./lib/mol-math/linear-algebra.js");
/* harmony import */ var _mol_data_int__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../../mol-data/int */ "./lib/mol-data/int.js");
/**
 * Copyright (c) 2018-2020 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author David Sehnal <david.sehnal@gmail.com>
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */



function Sphere3D() {
    return Sphere3D.zero();
}
(function (Sphere3D) {
    function hasExtrema(sphere) {
        return sphere.extrema !== undefined;
    }
    Sphere3D.hasExtrema = hasExtrema;
    function create(center, radius) { return { center: center, radius: radius }; }
    Sphere3D.create = create;
    function zero() { return { center: Object(_linear_algebra__WEBPACK_IMPORTED_MODULE_1__["Vec3"])(), radius: 0 }; }
    Sphere3D.zero = zero;
    function clone(a) {
        var out = create(_linear_algebra__WEBPACK_IMPORTED_MODULE_1__["Vec3"].clone(a.center), a.radius);
        if (hasExtrema(a))
            out.extrema = a.extrema.map(function (e) { return _linear_algebra__WEBPACK_IMPORTED_MODULE_1__["Vec3"].clone(e); });
        return out;
    }
    Sphere3D.clone = clone;
    function set(out, center, radius) {
        _linear_algebra__WEBPACK_IMPORTED_MODULE_1__["Vec3"].copy(out.center, center);
        out.radius = radius;
        return out;
    }
    Sphere3D.set = set;
    function copy(out, a) {
        _linear_algebra__WEBPACK_IMPORTED_MODULE_1__["Vec3"].copy(out.center, a.center);
        out.radius = a.radius;
        if (hasExtrema(a))
            setExtrema(out, a.extrema.map(function (e) { return _linear_algebra__WEBPACK_IMPORTED_MODULE_1__["Vec3"].clone(e); }));
        return out;
    }
    Sphere3D.copy = copy;
    /** Note that `extrema` must not be reused elsewhere */
    function setExtrema(out, extrema) {
        var _a;
        if (out.extrema !== undefined) {
            out.extrema.length = 0;
            (_a = out.extrema).push.apply(_a, extrema);
        }
        else {
            out.extrema = extrema;
        }
        return out;
    }
    Sphere3D.setExtrema = setExtrema;
    function computeBounding(data) {
        var x = data.x, y = data.y, z = data.z, indices = data.indices;
        var cx = 0, cy = 0, cz = 0;
        var radiusSq = 0;
        var size = _mol_data_int__WEBPACK_IMPORTED_MODULE_2__["OrderedSet"].size(indices);
        for (var t = 0; t < size; t++) {
            var i = _mol_data_int__WEBPACK_IMPORTED_MODULE_2__["OrderedSet"].getAt(indices, t);
            cx += x[i];
            cy += y[i];
            cz += z[i];
        }
        if (size > 0) {
            cx /= size;
            cy /= size;
            cz /= size;
        }
        for (var t = 0; t < size; t++) {
            var i = _mol_data_int__WEBPACK_IMPORTED_MODULE_2__["OrderedSet"].getAt(indices, t);
            var dx = x[i] - cx, dy = y[i] - cy, dz = z[i] - cz;
            var d = dx * dx + dy * dy + dz * dz;
            if (d > radiusSq)
                radiusSq = d;
        }
        return { center: _linear_algebra__WEBPACK_IMPORTED_MODULE_1__["Vec3"].create(cx, cy, cz), radius: Math.sqrt(radiusSq) };
    }
    Sphere3D.computeBounding = computeBounding;
    /** Transform sphere with a Mat4 */
    function transform(out, sphere, m) {
        _linear_algebra__WEBPACK_IMPORTED_MODULE_1__["Vec3"].transformMat4(out.center, sphere.center, m);
        out.radius = sphere.radius * _linear_algebra__WEBPACK_IMPORTED_MODULE_1__["Mat4"].getMaxScaleOnAxis(m);
        if (hasExtrema(sphere)) {
            setExtrema(out, sphere.extrema.map(function (e) { return _linear_algebra__WEBPACK_IMPORTED_MODULE_1__["Vec3"].transformMat4(Object(_linear_algebra__WEBPACK_IMPORTED_MODULE_1__["Vec3"])(), e, m); }));
        }
        return out;
    }
    Sphere3D.transform = transform;
    /** Translate sphere by Vec3 */
    function translate(out, sphere, v) {
        _linear_algebra__WEBPACK_IMPORTED_MODULE_1__["Vec3"].add(out.center, sphere.center, v);
        if (hasExtrema(sphere)) {
            setExtrema(out, sphere.extrema.map(function (e) { return _linear_algebra__WEBPACK_IMPORTED_MODULE_1__["Vec3"].add(Object(_linear_algebra__WEBPACK_IMPORTED_MODULE_1__["Vec3"])(), e, v); }));
        }
        return out;
    }
    Sphere3D.translate = translate;
    function toArray(s, out, offset) {
        _linear_algebra__WEBPACK_IMPORTED_MODULE_1__["Vec3"].toArray(s.center, out, offset);
        out[offset + 3] = s.radius;
    }
    Sphere3D.toArray = toArray;
    function fromArray(out, array, offset) {
        _linear_algebra__WEBPACK_IMPORTED_MODULE_1__["Vec3"].fromArray(out.center, array, offset);
        out.radius = array[offset + 3];
        return out;
    }
    Sphere3D.fromArray = fromArray;
    function fromBox3D(out, box) {
        _linear_algebra__WEBPACK_IMPORTED_MODULE_1__["Vec3"].scale(out.center, _linear_algebra__WEBPACK_IMPORTED_MODULE_1__["Vec3"].add(out.center, box.max, box.min), 0.5);
        out.radius = _linear_algebra__WEBPACK_IMPORTED_MODULE_1__["Vec3"].distance(out.center, box.max);
        Sphere3D.setExtrema(out, [
            _linear_algebra__WEBPACK_IMPORTED_MODULE_1__["Vec3"].create(box.min[0], box.min[1], box.min[2]),
            _linear_algebra__WEBPACK_IMPORTED_MODULE_1__["Vec3"].create(box.max[0], box.max[1], box.max[2]),
            _linear_algebra__WEBPACK_IMPORTED_MODULE_1__["Vec3"].create(box.max[0], box.min[1], box.min[2]),
            _linear_algebra__WEBPACK_IMPORTED_MODULE_1__["Vec3"].create(box.min[0], box.max[1], box.max[2]),
            _linear_algebra__WEBPACK_IMPORTED_MODULE_1__["Vec3"].create(box.min[0], box.min[1], box.max[2]),
            _linear_algebra__WEBPACK_IMPORTED_MODULE_1__["Vec3"].create(box.max[0], box.min[1], box.max[2]),
            _linear_algebra__WEBPACK_IMPORTED_MODULE_1__["Vec3"].create(box.max[0], box.max[1], box.min[2]),
            _linear_algebra__WEBPACK_IMPORTED_MODULE_1__["Vec3"].create(box.min[0], box.max[1], box.min[2]),
        ]);
        return out;
    }
    Sphere3D.fromBox3D = fromBox3D;
    function fromAxes3D(out, axes) {
        _linear_algebra__WEBPACK_IMPORTED_MODULE_1__["Vec3"].copy(out.center, axes.origin);
        out.radius = Math.max(_linear_algebra__WEBPACK_IMPORTED_MODULE_1__["Vec3"].magnitude(axes.dirA), _linear_algebra__WEBPACK_IMPORTED_MODULE_1__["Vec3"].magnitude(axes.dirB), _linear_algebra__WEBPACK_IMPORTED_MODULE_1__["Vec3"].magnitude(axes.dirC));
        return out;
    }
    Sphere3D.fromAxes3D = fromAxes3D;
    var tmpCenter = Object(_linear_algebra__WEBPACK_IMPORTED_MODULE_1__["Vec3"])();
    /** Get a tight sphere around a transformed box */
    function fromDimensionsAndTransform(out, dimensions, transform) {
        var x = dimensions[0], y = dimensions[1], z = dimensions[2];
        var cpA = _linear_algebra__WEBPACK_IMPORTED_MODULE_1__["Vec3"].create(0, 0, 0);
        _linear_algebra__WEBPACK_IMPORTED_MODULE_1__["Vec3"].transformMat4(cpA, cpA, transform);
        var cpB = _linear_algebra__WEBPACK_IMPORTED_MODULE_1__["Vec3"].create(x, y, z);
        _linear_algebra__WEBPACK_IMPORTED_MODULE_1__["Vec3"].transformMat4(cpB, cpB, transform);
        var cpC = _linear_algebra__WEBPACK_IMPORTED_MODULE_1__["Vec3"].create(x, 0, 0);
        _linear_algebra__WEBPACK_IMPORTED_MODULE_1__["Vec3"].transformMat4(cpC, cpC, transform);
        var cpD = _linear_algebra__WEBPACK_IMPORTED_MODULE_1__["Vec3"].create(0, y, z);
        _linear_algebra__WEBPACK_IMPORTED_MODULE_1__["Vec3"].transformMat4(cpD, cpD, transform);
        var cpE = _linear_algebra__WEBPACK_IMPORTED_MODULE_1__["Vec3"].create(0, 0, z);
        _linear_algebra__WEBPACK_IMPORTED_MODULE_1__["Vec3"].transformMat4(cpE, cpE, transform);
        var cpF = _linear_algebra__WEBPACK_IMPORTED_MODULE_1__["Vec3"].create(x, 0, z);
        _linear_algebra__WEBPACK_IMPORTED_MODULE_1__["Vec3"].transformMat4(cpF, cpF, transform);
        var cpG = _linear_algebra__WEBPACK_IMPORTED_MODULE_1__["Vec3"].create(x, y, 0);
        _linear_algebra__WEBPACK_IMPORTED_MODULE_1__["Vec3"].transformMat4(cpG, cpG, transform);
        var cpH = _linear_algebra__WEBPACK_IMPORTED_MODULE_1__["Vec3"].create(0, y, 0);
        _linear_algebra__WEBPACK_IMPORTED_MODULE_1__["Vec3"].transformMat4(cpH, cpH, transform);
        _linear_algebra__WEBPACK_IMPORTED_MODULE_1__["Vec3"].add(tmpCenter, cpA, cpB);
        _linear_algebra__WEBPACK_IMPORTED_MODULE_1__["Vec3"].scale(tmpCenter, tmpCenter, 0.5);
        var d = Math.max(_linear_algebra__WEBPACK_IMPORTED_MODULE_1__["Vec3"].distance(cpA, cpB), _linear_algebra__WEBPACK_IMPORTED_MODULE_1__["Vec3"].distance(cpC, cpD));
        Sphere3D.set(out, tmpCenter, d / 2);
        Sphere3D.setExtrema(out, [cpA, cpB, cpC, cpD, cpE, cpF, cpG, cpH]);
        return out;
    }
    Sphere3D.fromDimensionsAndTransform = fromDimensionsAndTransform;
    var tmpAddVec3 = Object(_linear_algebra__WEBPACK_IMPORTED_MODULE_1__["Vec3"])();
    function addVec3(out, s, v) {
        var d = _linear_algebra__WEBPACK_IMPORTED_MODULE_1__["Vec3"].distance(s.center, v);
        if (d < s.radius)
            return Sphere3D.copy(out, s);
        _linear_algebra__WEBPACK_IMPORTED_MODULE_1__["Vec3"].sub(tmpAddVec3, s.center, v);
        _linear_algebra__WEBPACK_IMPORTED_MODULE_1__["Vec3"].sub(tmpAddVec3, s.center, tmpAddVec3);
        _linear_algebra__WEBPACK_IMPORTED_MODULE_1__["Vec3"].setMagnitude(tmpAddVec3, tmpAddVec3, s.radius);
        _linear_algebra__WEBPACK_IMPORTED_MODULE_1__["Vec3"].scale(out.center, _linear_algebra__WEBPACK_IMPORTED_MODULE_1__["Vec3"].add(tmpAddVec3, tmpAddVec3, v), 0.5);
        out.radius = _linear_algebra__WEBPACK_IMPORTED_MODULE_1__["Vec3"].distance(out.center, v);
        return out;
    }
    Sphere3D.addVec3 = addVec3;
    /** Expand sphere radius by another sphere */
    function expandBySphere(out, sphere, by) {
        _linear_algebra__WEBPACK_IMPORTED_MODULE_1__["Vec3"].copy(out.center, sphere.center);
        out.radius = Math.max(sphere.radius, _linear_algebra__WEBPACK_IMPORTED_MODULE_1__["Vec3"].distance(sphere.center, by.center) + by.radius);
        if (hasExtrema(sphere) && hasExtrema(by)) {
            setExtrema(out, Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__spreadArrays"])(sphere.extrema.map(function (e) { return _linear_algebra__WEBPACK_IMPORTED_MODULE_1__["Vec3"].clone(e); }), by.extrema.map(function (e) { return _linear_algebra__WEBPACK_IMPORTED_MODULE_1__["Vec3"].clone(e); })));
        }
        return out;
    }
    Sphere3D.expandBySphere = expandBySphere;
    var tmpDir = Object(_linear_algebra__WEBPACK_IMPORTED_MODULE_1__["Vec3"])();
    /** Expand sphere radius by delta */
    function expand(out, sphere, delta) {
        var _a, _b;
        _linear_algebra__WEBPACK_IMPORTED_MODULE_1__["Vec3"].copy(out.center, sphere.center);
        out.radius = sphere.radius + delta;
        if (sphere.radius < 1e-12 || ((_b = (_a = sphere.extrema) === null || _a === void 0 ? void 0 : _a.length) !== null && _b !== void 0 ? _b : 0) <= 1) {
            out.extrema = void 0;
            return out;
        }
        if (hasExtrema(sphere)) {
            setExtrema(out, sphere.extrema.map(function (e) {
                _linear_algebra__WEBPACK_IMPORTED_MODULE_1__["Vec3"].sub(tmpDir, e, sphere.center);
                var dist = _linear_algebra__WEBPACK_IMPORTED_MODULE_1__["Vec3"].distance(sphere.center, e);
                _linear_algebra__WEBPACK_IMPORTED_MODULE_1__["Vec3"].normalize(tmpDir, tmpDir);
                return _linear_algebra__WEBPACK_IMPORTED_MODULE_1__["Vec3"].scaleAndAdd(Object(_linear_algebra__WEBPACK_IMPORTED_MODULE_1__["Vec3"])(), sphere.center, tmpDir, dist + delta);
            }));
        }
        return out;
    }
    Sphere3D.expand = expand;
    /**
     * Returns whether or not the spheres have exactly the same center and radius (when compared with ===)
     */
    function exactEquals(a, b) {
        return a.radius === b.radius && _linear_algebra__WEBPACK_IMPORTED_MODULE_1__["Vec3"].exactEquals(a.center, b.center);
    }
    Sphere3D.exactEquals = exactEquals;
    /**
     * Returns whether or not the spheres have approximately the same center and radius.
     */
    function equals(a, b) {
        var ar = a.radius;
        var br = b.radius;
        return (Math.abs(ar - br) <= _linear_algebra__WEBPACK_IMPORTED_MODULE_1__["EPSILON"] * Math.max(1.0, Math.abs(ar), Math.abs(br)) &&
            _linear_algebra__WEBPACK_IMPORTED_MODULE_1__["Vec3"].equals(a.center, b.center));
    }
    Sphere3D.equals = equals;
    /**
     * Check if `a` includes `b`, use `extrema` of `b` when available
     */
    function includes(a, b) {
        if (hasExtrema(b)) {
            for (var _i = 0, _a = b.extrema; _i < _a.length; _i++) {
                var e = _a[_i];
                if (_linear_algebra__WEBPACK_IMPORTED_MODULE_1__["Vec3"].distance(a.center, e) > a.radius)
                    return false;
            }
            return true;
        }
        else {
            return _linear_algebra__WEBPACK_IMPORTED_MODULE_1__["Vec3"].distance(a.center, b.center) + b.radius <= a.radius;
        }
    }
    Sphere3D.includes = includes;
    /** Check if `a` and `b` are overlapping */
    function overlaps(a, b) {
        return _linear_algebra__WEBPACK_IMPORTED_MODULE_1__["Vec3"].distance(a.center, b.center) <= a.radius + b.radius;
    }
    Sphere3D.overlaps = overlaps;
    /** Get the signed distance of `a` and `b` */
    function distance(a, b) {
        return _linear_algebra__WEBPACK_IMPORTED_MODULE_1__["Vec3"].distance(a.center, b.center) - a.radius + b.radius;
    }
    Sphere3D.distance = distance;
})(Sphere3D || (Sphere3D = {}));

//# sourceMappingURL=sphere3d.js.map

/***/ }),

/***/ "./lib/mol-math/geometry/spacegroup/cell.js":
/*!**************************************************!*\
  !*** ./lib/mol-math/geometry/spacegroup/cell.js ***!
  \**************************************************/
/*! exports provided: Cell */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Cell", function() { return Cell; });
/* harmony import */ var _linear_algebra__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../linear-algebra */ "./lib/mol-math/linear-algebra.js");
/**
 * Copyright (c) 2019-2020 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */


function Cell() {
    return Cell.empty();
}
(function (Cell) {
    function create(size, anglesInRadians) {
        return { size: size, anglesInRadians: anglesInRadians };
    }
    Cell.create = create;
    function empty() {
        return create(Object(_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"])(), Object(_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"])());
    }
    Cell.empty = empty;
    function fromBasis(x, y, z) {
        var a = _linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"].magnitude(x);
        var b = _linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"].magnitude(y);
        var c = _linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"].magnitude(z);
        var alpha = Math.acos(_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"].dot(y, z) / (b * c));
        var beta = Math.acos(_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"].dot(x, z) / (a * c));
        var gamma = Math.acos(_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"].dot(x, y) / (a * b));
        if (a <= 0 || b <= 0 || c <= 0 || alpha >= Math.PI || beta >= Math.PI || gamma >= Math.PI) {
            return empty();
        }
        else {
            return create(_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"].create(a, b, c), _linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"].create(alpha, beta, gamma));
        }
    }
    Cell.fromBasis = fromBasis;
})(Cell || (Cell = {}));
//# sourceMappingURL=cell.js.map

/***/ }),

/***/ "./lib/mol-math/geometry/spacegroup/construction.js":
/*!**********************************************************!*\
  !*** ./lib/mol-math/geometry/spacegroup/construction.js ***!
  \**********************************************************/
/*! exports provided: Spacegroup, SpacegroupCell */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Spacegroup", function() { return Spacegroup; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SpacegroupCell", function() { return SpacegroupCell; });
/* harmony import */ var _linear_algebra__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../linear-algebra */ "./lib/mol-math/linear-algebra.js");
/* harmony import */ var _tables__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./tables */ "./lib/mol-math/geometry/spacegroup/tables.js");
/* harmony import */ var _geometry__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../geometry */ "./lib/mol-math/geometry.js");
/**
 * Copyright (c) 2018-2020 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author David Sehnal <david.sehnal@gmail.com>
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */



var SpacegroupCell;
(function (SpacegroupCell) {
    /** Create a 'P 1' with cellsize [1, 1, 1] */
    SpacegroupCell.Zero = create('P 1', _linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"].create(1, 1, 1), _linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"].create(Math.PI / 2, Math.PI / 2, Math.PI / 2));
    /** True if 'P 1' with cellsize [1, 1, 1] */
    function isZero(cell) {
        if (!cell)
            return true;
        return cell.index === 0 && cell.size[0] === 1 && cell.size[1] === 1 && cell.size[1] === 1;
    }
    SpacegroupCell.isZero = isZero;
    /** Returns Zero cell if the spacegroup does not exist */
    function create(nameOrNumber, size, anglesInRadians) {
        var index = Object(_tables__WEBPACK_IMPORTED_MODULE_1__["getSpacegroupIndex"])(nameOrNumber);
        if (index < 0) {
            console.warn("Unknown spacegroup '" + nameOrNumber + "', returning a 'P 1' with cellsize [1, 1, 1]");
            return SpacegroupCell.Zero;
        }
        var volume = size[0] * size[1] * size[2];
        var alpha = anglesInRadians[0];
        var beta = anglesInRadians[1];
        var gamma = anglesInRadians[2];
        var xScale = size[0], yScale = size[1], zScale = size[2];
        var z1 = Math.cos(beta);
        var z2 = (Math.cos(alpha) - Math.cos(beta) * Math.cos(gamma)) / Math.sin(gamma);
        var z3 = Math.sqrt(1.0 - z1 * z1 - z2 * z2);
        var x = [xScale, 0.0, 0.0];
        var y = [Math.cos(gamma) * yScale, Math.sin(gamma) * yScale, 0.0];
        var z = [z1 * zScale, z2 * zScale, z3 * zScale];
        var fromFractional = _linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Mat4"].ofRows([
            [x[0], y[0], z[0], 0],
            [0, y[1], z[1], 0],
            [0, 0, z[2], 0],
            [0, 0, 0, 1.0]
        ]);
        var toFractional = _linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Mat4"].invert(_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Mat4"].zero(), fromFractional);
        return { index: index, size: size, volume: volume, anglesInRadians: anglesInRadians, toFractional: toFractional, fromFractional: fromFractional };
    }
    SpacegroupCell.create = create;
})(SpacegroupCell || (SpacegroupCell = {}));
var Spacegroup;
(function (Spacegroup) {
    /** P1 with [1, 1, 1] cell */
    Spacegroup.ZeroP1 = create(SpacegroupCell.Zero);
    function create(cell) {
        var operators = _tables__WEBPACK_IMPORTED_MODULE_1__["GroupData"][cell.index].map(function (i) { return getOperatorMatrix(_tables__WEBPACK_IMPORTED_MODULE_1__["OperatorData"][i]); });
        var name = _tables__WEBPACK_IMPORTED_MODULE_1__["SpacegroupName"][cell.index];
        var num = _tables__WEBPACK_IMPORTED_MODULE_1__["SpacegroupNumber"][cell.index];
        return { name: name, num: num, cell: cell, operators: operators };
    }
    Spacegroup.create = create;
    var _ijkVec = Object(_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"])();
    var _tempMat = Object(_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Mat4"])();
    function setOperatorMatrix(spacegroup, index, i, j, k, target) {
        _linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"].set(_ijkVec, i, j, k);
        _linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Mat4"].fromTranslation(_tempMat, _ijkVec);
        return _linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Mat4"].mul(target, _linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Mat4"].mul(target, _linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Mat4"].mul(target, spacegroup.cell.fromFractional, _tempMat), spacegroup.operators[index]), spacegroup.cell.toFractional);
    }
    Spacegroup.setOperatorMatrix = setOperatorMatrix;
    function getSymmetryOperator(spacegroup, spgrOp, i, j, k) {
        var operator = setOperatorMatrix(spacegroup, spgrOp, i, j, k, _linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Mat4"].zero());
        return _geometry__WEBPACK_IMPORTED_MODULE_2__["SymmetryOperator"].create(spgrOp + 1 + "_" + (5 + i) + (5 + j) + (5 + k), operator, { hkl: _linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"].create(i, j, k), spgrOp: spgrOp });
    }
    Spacegroup.getSymmetryOperator = getSymmetryOperator;
    var _translationRef = Object(_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"])();
    var _translationRefSymop = Object(_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"])();
    var _translationSymop = Object(_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"])();
    function setOperatorMatrixRef(spacegroup, index, i, j, k, ref, target) {
        _linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"].set(_ijkVec, i, j, k);
        _linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"].floor(_translationRef, ref);
        _linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Mat4"].copy(target, spacegroup.operators[index]);
        _linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"].floor(_translationRefSymop, _linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"].transformMat4(_translationRefSymop, ref, target));
        _linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Mat4"].getTranslation(_translationSymop, target);
        _linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"].sub(_translationSymop, _translationSymop, _translationRefSymop);
        _linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"].add(_translationSymop, _translationSymop, _translationRef);
        _linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"].add(_translationSymop, _translationSymop, _ijkVec);
        _linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Mat4"].setTranslation(target, _translationSymop);
        _linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Mat4"].mul(target, spacegroup.cell.fromFractional, target);
        _linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Mat4"].mul(target, target, spacegroup.cell.toFractional);
        return target;
    }
    Spacegroup.setOperatorMatrixRef = setOperatorMatrixRef;
    /**
     * Get Symmetry operator for transformation around the given
     * reference point `ref` in fractional coordinates
     */
    function getSymmetryOperatorRef(spacegroup, spgrOp, i, j, k, ref) {
        var operator = setOperatorMatrixRef(spacegroup, spgrOp, i, j, k, ref, _linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Mat4"].zero());
        return _geometry__WEBPACK_IMPORTED_MODULE_2__["SymmetryOperator"].create(spgrOp + 1 + "_" + (5 + i) + (5 + j) + (5 + k), operator, { hkl: _linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"].create(i, j, k), spgrOp: spgrOp });
    }
    Spacegroup.getSymmetryOperatorRef = getSymmetryOperatorRef;
    function getOperatorMatrix(ids) {
        var r1 = _tables__WEBPACK_IMPORTED_MODULE_1__["TransformData"][ids[0]];
        var r2 = _tables__WEBPACK_IMPORTED_MODULE_1__["TransformData"][ids[1]];
        var r3 = _tables__WEBPACK_IMPORTED_MODULE_1__["TransformData"][ids[2]];
        return _linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Mat4"].ofRows([r1, r2, r3, [0, 0, 0, 1]]);
    }
    function getOperatorXyz(op) {
        return [
            formatElement(getRotation(op[0], op[4], op[8]), getShift(op[12])),
            formatElement(getRotation(op[1], op[5], op[9]), getShift(op[13])),
            formatElement(getRotation(op[2], op[6], op[10]), getShift(op[14]))
        ].join(',');
    }
    Spacegroup.getOperatorXyz = getOperatorXyz;
    function getRotation(x, y, z) {
        var r = [];
        if (x > 0)
            r.push('+X');
        else if (x < 0)
            r.push('-X');
        if (y > 0)
            r.push('+Y');
        else if (y < 0)
            r.push('-Y');
        if (z > 0)
            r.push('+Z');
        else if (z < 0)
            r.push('-Z');
        if (r.length === 1) {
            return r[0].charAt(0) === '+' ? r[0].substr(1) : r[0];
        }
        if (r.length === 2) {
            var s0 = r[0].charAt(0);
            var s1 = r[1].charAt(0);
            if (s0 === '+')
                return "" + r[0].substr(1) + r[1];
            if (s1 === '+')
                return "" + r[1].substr(1) + r[0];
        }
        throw new Error("unknown rotation '" + r + "', " + x + " " + y + " " + z);
    }
    function getShift(s) {
        switch (s) {
            case 1 / 2: return '1/2';
            case 1 / 4: return '1/4';
            case 3 / 4: return '3/4';
            case 1 / 3: return '1/3';
            case 2 / 3: return '2/3';
            case 1 / 6: return '1/6';
            case 5 / 6: return '5/6';
        }
        return '';
    }
    function formatElement(rotation, shift) {
        if (shift === '')
            return rotation;
        if (rotation.length > 2)
            return rotation + "+" + shift;
        return rotation.charAt(0) === '-' ? "" + shift + rotation : shift + "+" + rotation;
    }
})(Spacegroup || (Spacegroup = {}));

//# sourceMappingURL=construction.js.map

/***/ }),

/***/ "./lib/mol-math/geometry/spacegroup/tables.js":
/*!****************************************************!*\
  !*** ./lib/mol-math/geometry/spacegroup/tables.js ***!
  \****************************************************/
/*! exports provided: TransformData, OperatorData, GroupData, SpacegroupNameToIndexMap, getSpacegroupIndexFromNumber, getSpacegroupNumberFromIndex, SpacegroupName, SpacegroupNumber, getSpacegroupIndex */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "TransformData", function() { return TransformData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "OperatorData", function() { return OperatorData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "GroupData", function() { return GroupData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SpacegroupNameToIndexMap", function() { return SpacegroupNameToIndexMap; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getSpacegroupIndexFromNumber", function() { return getSpacegroupIndexFromNumber; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getSpacegroupNumberFromIndex", function() { return getSpacegroupNumberFromIndex; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SpacegroupName", function() { return SpacegroupName; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SpacegroupNumber", function() { return SpacegroupNumber; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getSpacegroupIndex", function() { return getSpacegroupIndex; });
/**
 * Copyright (c) 2018-2019 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author David Sehnal <david.sehnal@gmail.com>
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */
var TransformData = [
    [1.0, 0.0, 0.0, 0.0],
    [0.0, 1.0, 0.0, 0.0],
    [0.0, 0.0, 1.0, 0.0],
    [-1.0, 0.0, 0.0, 0.0],
    [0.0, -1.0, 0.0, 0.0],
    [0.0, 0.0, -1.0, 0.0],
    [0.0, 1.0, 0.0, 0.5],
    [1.0, 0.0, 0.0, 0.5],
    [-1.0, 0.0, 0.0, 0.5],
    [0.0, 0.0, 1.0, 0.5],
    [0.0, -1.0, 0.0, 0.5],
    [0.0, 0.0, -1.0, 0.5],
    [1.0, 0.0, 0.0, 0.25],
    [0.0, -1.0, 0.0, 0.25],
    [0.0, 0.0, 1.0, 0.25],
    [-1.0, 0.0, 0.0, 0.25],
    [0.0, 1.0, 0.0, 0.25],
    [0.0, -1.0, 0.0, 0.75],
    [0.0, 0.0, 1.0, 0.75],
    [0.0, 1.0, 0.0, 0.75],
    [1.0, 0.0, 0.0, 0.75],
    [-1.0, 0.0, 0.0, 0.75],
    [0.0, 0.0, -1.0, 0.25],
    [0.0, 0.0, -1.0, 0.75],
    [1.0, -1.0, 0.0, 0.0],
    [-1.0, 1.0, 0.0, 0.0],
    [0.0, 0.0, 1.0, 1 / 3],
    [0.0, 0.0, 1.0, 2 / 3],
    [1.0, 0.0, 0.0, 2 / 3],
    [0.0, 1.0, 0.0, 1 / 3],
    [0.0, -1.0, 0.0, 2 / 3],
    [1.0, -1.0, 0.0, 1 / 3],
    [-1.0, 1.0, 0.0, 2 / 3],
    [-1.0, 0.0, 0.0, 1 / 3],
    [1.0, 0.0, 0.0, 1 / 3],
    [0.0, 1.0, 0.0, 2 / 3],
    [0.0, -1.0, 0.0, 1 / 3],
    [1.0, -1.0, 0.0, 2 / 3],
    [-1.0, 1.0, 0.0, 1 / 3],
    [-1.0, 0.0, 0.0, 2 / 3],
    [0.0, 0.0, -1.0, 1 / 3],
    [0.0, 0.0, -1.0, 2 / 3],
    [0.0, 0.0, 1.0, 5 / 6],
    [0.0, 0.0, 1.0, 1 / 6],
    [0.0, 0.0, -1.0, 5 / 6],
    [0.0, 0.0, -1.0, 1 / 6],
];
var OperatorData = [
    [0, 1, 2],
    [3, 4, 5],
    [3, 1, 5],
    [3, 6, 5],
    [7, 6, 2],
    [8, 6, 5],
    [0, 4, 2],
    [0, 4, 9],
    [7, 10, 2],
    [7, 10, 9],
    [0, 10, 2],
    [8, 10, 5],
    [3, 1, 11],
    [3, 6, 11],
    [0, 10, 9],
    [8, 6, 11],
    [3, 4, 2],
    [0, 4, 5],
    [3, 4, 9],
    [7, 10, 5],
    [8, 4, 9],
    [8, 10, 9],
    [8, 10, 2],
    [0, 6, 9],
    [3, 10, 9],
    [0, 10, 11],
    [7, 1, 9],
    [8, 1, 11],
    [7, 4, 11],
    [7, 6, 9],
    [7, 10, 11],
    [3, 10, 2],
    [8, 1, 5],
    [0, 4, 11],
    [3, 1, 2],
    [3, 1, 9],
    [7, 4, 2],
    [8, 1, 2],
    [8, 1, 9],
    [3, 6, 9],
    [7, 4, 9],
    [8, 6, 2],
    [8, 6, 9],
    [3, 6, 2],
    [12, 13, 14],
    [15, 16, 14],
    [12, 17, 18],
    [15, 19, 18],
    [20, 13, 18],
    [21, 16, 18],
    [20, 17, 14],
    [21, 19, 14],
    [0, 1, 5],
    [8, 10, 11],
    [7, 6, 11],
    [7, 6, 5],
    [8, 4, 2],
    [7, 4, 5],
    [7, 1, 5],
    [7, 1, 11],
    [0, 10, 5],
    [0, 1, 11],
    [0, 6, 11],
    [0, 6, 5],
    [3, 10, 11],
    [8, 4, 11],
    [15, 13, 22],
    [12, 16, 22],
    [15, 17, 23],
    [12, 19, 23],
    [21, 13, 23],
    [20, 16, 23],
    [21, 17, 22],
    [20, 19, 22],
    [4, 0, 2],
    [1, 3, 2],
    [4, 0, 14],
    [1, 3, 18],
    [4, 0, 9],
    [1, 3, 9],
    [4, 0, 18],
    [1, 3, 14],
    [10, 7, 9],
    [6, 8, 9],
    [4, 7, 14],
    [6, 3, 18],
    [10, 0, 18],
    [1, 8, 14],
    [1, 3, 5],
    [4, 0, 5],
    [6, 8, 11],
    [10, 7, 11],
    [1, 3, 11],
    [4, 0, 11],
    [10, 7, 2],
    [6, 8, 2],
    [3, 10, 22],
    [7, 1, 23],
    [8, 4, 23],
    [0, 6, 22],
    [1, 0, 5],
    [4, 3, 5],
    [1, 0, 23],
    [4, 3, 22],
    [10, 7, 14],
    [6, 8, 18],
    [8, 6, 22],
    [7, 10, 23],
    [4, 3, 11],
    [1, 0, 11],
    [1, 0, 22],
    [4, 3, 23],
    [10, 7, 18],
    [6, 8, 14],
    [8, 6, 23],
    [7, 10, 22],
    [6, 7, 11],
    [10, 8, 11],
    [8, 1, 23],
    [0, 10, 22],
    [3, 6, 22],
    [7, 4, 23],
    [4, 3, 2],
    [1, 0, 2],
    [10, 8, 2],
    [6, 7, 2],
    [4, 3, 9],
    [1, 0, 9],
    [10, 8, 9],
    [6, 7, 9],
    [4, 8, 14],
    [6, 0, 18],
    [10, 3, 18],
    [1, 7, 14],
    [4, 8, 18],
    [6, 0, 14],
    [10, 3, 14],
    [1, 7, 18],
    [6, 7, 5],
    [10, 8, 5],
    [6, 8, 5],
    [10, 7, 5],
    [8, 1, 22],
    [0, 10, 23],
    [3, 6, 23],
    [7, 4, 22],
    [4, 24, 2],
    [25, 3, 2],
    [4, 24, 26],
    [25, 3, 27],
    [4, 24, 27],
    [25, 3, 26],
    [28, 29, 26],
    [30, 31, 26],
    [32, 33, 26],
    [34, 35, 27],
    [36, 37, 27],
    [38, 39, 27],
    [2, 0, 1],
    [1, 2, 0],
    [1, 25, 5],
    [24, 0, 5],
    [39, 36, 40],
    [35, 38, 40],
    [37, 34, 40],
    [33, 30, 41],
    [29, 32, 41],
    [31, 28, 41],
    [5, 3, 4],
    [4, 5, 3],
    [25, 1, 5],
    [0, 24, 5],
    [24, 4, 5],
    [3, 25, 5],
    [4, 3, 41],
    [25, 1, 40],
    [24, 4, 41],
    [3, 25, 40],
    [4, 3, 40],
    [25, 1, 41],
    [24, 4, 40],
    [3, 25, 41],
    [35, 34, 40],
    [37, 36, 40],
    [39, 38, 40],
    [29, 28, 41],
    [31, 30, 41],
    [33, 32, 41],
    [3, 5, 4],
    [5, 4, 3],
    [25, 1, 2],
    [0, 24, 2],
    [24, 4, 2],
    [3, 25, 2],
    [25, 1, 9],
    [0, 24, 9],
    [24, 4, 9],
    [3, 25, 9],
    [30, 33, 26],
    [32, 29, 26],
    [28, 31, 26],
    [36, 39, 27],
    [38, 35, 27],
    [34, 37, 27],
    [0, 2, 1],
    [2, 1, 0],
    [30, 33, 42],
    [32, 29, 42],
    [28, 31, 42],
    [36, 39, 43],
    [38, 35, 43],
    [34, 37, 43],
    [7, 9, 6],
    [9, 6, 7],
    [25, 1, 11],
    [0, 24, 11],
    [24, 4, 11],
    [3, 25, 11],
    [35, 34, 44],
    [37, 36, 44],
    [39, 38, 44],
    [29, 28, 45],
    [31, 30, 45],
    [33, 32, 45],
    [8, 11, 10],
    [11, 10, 8],
    [1, 25, 2],
    [24, 0, 2],
    [1, 25, 42],
    [24, 0, 43],
    [1, 25, 43],
    [24, 0, 42],
    [1, 25, 27],
    [24, 0, 26],
    [1, 25, 26],
    [24, 0, 27],
    [1, 25, 9],
    [24, 0, 9],
    [4, 24, 5],
    [25, 3, 5],
    [4, 24, 11],
    [25, 3, 11],
    [1, 0, 40],
    [4, 3, 44],
    [0, 24, 45],
    [1, 0, 41],
    [4, 3, 45],
    [0, 24, 44],
    [0, 24, 40],
    [0, 24, 41],
    [2, 3, 4],
    [5, 3, 1],
    [5, 0, 4],
    [4, 2, 3],
    [1, 5, 3],
    [4, 5, 0],
    [2, 7, 6],
    [2, 8, 10],
    [5, 8, 6],
    [5, 7, 10],
    [1, 9, 7],
    [4, 9, 8],
    [1, 11, 8],
    [4, 11, 7],
    [9, 0, 6],
    [9, 3, 10],
    [11, 3, 6],
    [11, 0, 10],
    [6, 2, 7],
    [10, 2, 8],
    [6, 5, 8],
    [10, 5, 7],
    [9, 7, 1],
    [9, 8, 4],
    [11, 8, 1],
    [11, 7, 4],
    [6, 9, 0],
    [10, 9, 3],
    [6, 11, 3],
    [10, 11, 0],
    [9, 7, 6],
    [9, 8, 10],
    [11, 8, 6],
    [11, 7, 10],
    [6, 9, 7],
    [10, 9, 8],
    [6, 11, 8],
    [10, 11, 7],
    [2, 3, 10],
    [5, 8, 1],
    [11, 0, 4],
    [10, 2, 3],
    [1, 5, 8],
    [4, 11, 0],
    [5, 0, 1],
    [2, 0, 4],
    [2, 3, 1],
    [1, 5, 0],
    [4, 2, 0],
    [1, 2, 3],
    [11, 8, 10],
    [11, 7, 6],
    [9, 7, 10],
    [9, 8, 6],
    [10, 11, 8],
    [6, 11, 7],
    [10, 9, 7],
    [6, 9, 8],
    [5, 8, 10],
    [5, 7, 6],
    [2, 7, 10],
    [2, 8, 6],
    [4, 11, 8],
    [1, 11, 7],
    [4, 9, 7],
    [1, 9, 8],
    [11, 3, 10],
    [11, 0, 6],
    [9, 0, 10],
    [9, 3, 6],
    [10, 5, 8],
    [6, 5, 7],
    [10, 2, 7],
    [6, 2, 8],
    [11, 8, 4],
    [11, 7, 1],
    [9, 7, 4],
    [9, 8, 1],
    [10, 11, 3],
    [6, 11, 0],
    [10, 9, 0],
    [6, 9, 3],
    [22, 15, 13],
    [22, 12, 16],
    [14, 12, 13],
    [14, 15, 16],
    [13, 22, 15],
    [16, 22, 12],
    [13, 14, 12],
    [16, 14, 15],
    [22, 21, 17],
    [22, 20, 19],
    [14, 20, 17],
    [14, 21, 19],
    [13, 23, 21],
    [16, 23, 20],
    [13, 18, 20],
    [16, 18, 21],
    [23, 15, 17],
    [23, 12, 19],
    [18, 12, 17],
    [18, 15, 19],
    [17, 22, 21],
    [19, 22, 20],
    [17, 14, 20],
    [19, 14, 21],
    [23, 21, 13],
    [23, 20, 16],
    [18, 20, 13],
    [18, 21, 16],
    [17, 23, 15],
    [19, 23, 12],
    [17, 18, 12],
    [19, 18, 15],
    [5, 0, 6],
    [2, 7, 4],
    [9, 3, 1],
    [6, 5, 0],
    [4, 2, 7],
    [1, 9, 3],
    [0, 2, 4],
    [3, 2, 1],
    [0, 5, 1],
    [2, 1, 3],
    [2, 4, 0],
    [5, 1, 0],
    [7, 9, 10],
    [8, 9, 6],
    [7, 11, 6],
    [9, 6, 8],
    [9, 10, 7],
    [11, 6, 7],
    [1, 7, 11],
    [4, 8, 11],
    [1, 8, 9],
    [4, 7, 9],
    [0, 9, 10],
    [3, 9, 6],
    [3, 11, 10],
    [0, 11, 6],
    [2, 6, 8],
    [2, 10, 7],
    [5, 6, 7],
    [5, 10, 8],
    [6, 0, 11],
    [10, 3, 11],
    [6, 3, 9],
    [10, 0, 9],
    [7, 2, 10],
    [8, 2, 6],
    [8, 5, 10],
    [7, 5, 6],
    [9, 1, 8],
    [9, 4, 7],
    [11, 1, 7],
    [11, 4, 8],
    [7, 9, 4],
    [8, 9, 1],
    [8, 11, 4],
    [7, 11, 1],
    [9, 6, 3],
    [9, 10, 0],
    [11, 6, 0],
    [11, 10, 3],
    [19, 12, 23],
    [13, 15, 22],
    [16, 21, 18],
    [17, 20, 14],
    [20, 14, 17],
    [21, 18, 16],
    [15, 22, 13],
    [12, 23, 19],
    [18, 16, 21],
    [14, 17, 20],
    [23, 19, 12],
    [22, 13, 15],
    [19, 20, 22],
    [13, 21, 23],
    [16, 15, 14],
    [17, 12, 18],
    [20, 18, 13],
    [21, 14, 19],
    [15, 23, 17],
    [12, 22, 16],
    [18, 19, 15],
    [14, 13, 12],
    [23, 16, 20],
    [22, 17, 21],
    [16, 12, 22],
    [17, 15, 23],
    [19, 21, 14],
    [13, 20, 18],
    [12, 14, 13],
    [15, 18, 19],
    [21, 22, 17],
    [20, 23, 16],
    [14, 16, 15],
    [18, 17, 12],
    [22, 19, 20],
    [23, 13, 21],
    [16, 20, 23],
    [17, 21, 22],
    [19, 15, 18],
    [13, 12, 14],
    [12, 18, 17],
    [15, 14, 16],
    [21, 23, 13],
    [20, 22, 19],
    [14, 19, 21],
    [18, 13, 20],
    [22, 16, 12],
    [23, 17, 15],
    [19, 12, 22],
    [17, 21, 23],
    [16, 15, 18],
    [13, 20, 14],
    [20, 14, 13],
    [15, 18, 16],
    [21, 23, 17],
    [12, 22, 19],
    [18, 16, 15],
    [14, 13, 20],
    [22, 19, 12],
    [23, 17, 21],
    [3, 2, 4],
    [3, 5, 1],
    [0, 5, 4],
    [2, 4, 3],
    [5, 1, 3],
    [5, 4, 0],
    [1, 7, 9],
    [4, 8, 9],
    [1, 8, 11],
    [4, 7, 11],
    [0, 9, 6],
    [3, 9, 10],
    [3, 11, 6],
    [0, 11, 10],
    [2, 6, 7],
    [2, 10, 8],
    [5, 6, 8],
    [5, 10, 7],
    [6, 0, 9],
    [10, 3, 9],
    [6, 3, 11],
    [10, 0, 11],
    [7, 2, 6],
    [8, 2, 10],
    [8, 5, 6],
    [7, 5, 10],
    [9, 1, 7],
    [9, 4, 8],
    [11, 1, 8],
    [11, 4, 7],
    [7, 9, 1],
    [8, 9, 4],
    [8, 11, 1],
    [7, 11, 4],
    [9, 6, 0],
    [9, 10, 3],
    [11, 6, 3],
    [11, 10, 0],
    [8, 9, 10],
    [8, 11, 6],
    [7, 11, 10],
    [9, 10, 8],
    [11, 6, 8],
    [11, 10, 7],
    [6, 0, 2],
    [10, 3, 2],
    [6, 3, 5],
    [10, 0, 5],
    [7, 2, 1],
    [8, 2, 4],
    [8, 5, 1],
    [7, 5, 4],
    [9, 1, 0],
    [9, 4, 3],
    [11, 1, 3],
    [11, 4, 0],
    [1, 7, 2],
    [4, 8, 2],
    [1, 8, 5],
    [4, 7, 5],
    [0, 9, 1],
    [3, 9, 4],
    [3, 11, 1],
    [0, 11, 4],
    [2, 6, 0],
    [2, 10, 3],
    [5, 6, 3],
    [5, 10, 0],
    [0, 2, 6],
    [3, 2, 10],
    [3, 5, 6],
    [0, 5, 10],
    [2, 1, 7],
    [2, 4, 8],
    [5, 1, 8],
    [5, 4, 7],
    [16, 12, 14],
    [13, 21, 18],
    [19, 15, 23],
    [17, 20, 22],
    [12, 14, 16],
    [21, 18, 13],
    [15, 23, 19],
    [20, 22, 17],
    [14, 16, 12],
    [18, 13, 21],
    [23, 19, 15],
    [22, 17, 20],
    [19, 20, 18],
    [17, 15, 14],
    [16, 21, 22],
    [13, 12, 23],
    [20, 18, 19],
    [15, 14, 17],
    [21, 22, 16],
    [12, 23, 13],
    [18, 19, 20],
    [14, 17, 15],
    [22, 16, 21],
    [23, 13, 12],
    [6, 0, 5],
    [10, 3, 5],
    [6, 3, 2],
    [10, 0, 2],
    [7, 2, 4],
    [8, 2, 1],
    [8, 5, 4],
    [7, 5, 1],
    [9, 1, 3],
    [9, 4, 0],
    [11, 1, 0],
    [11, 4, 3],
    [1, 7, 5],
    [4, 8, 5],
    [1, 8, 2],
    [4, 7, 2],
    [0, 9, 4],
    [3, 9, 1],
    [3, 11, 4],
    [0, 11, 1],
    [2, 6, 3],
    [2, 10, 0],
    [5, 6, 0],
    [5, 10, 3],
    [0, 2, 10],
    [3, 2, 6],
    [3, 5, 10],
    [0, 5, 6],
    [2, 1, 8],
    [2, 4, 7],
    [5, 1, 7],
    [5, 4, 8],
    [21, 17, 23],
    [20, 16, 22],
    [12, 13, 18],
    [15, 19, 14],
    [23, 21, 17],
    [22, 20, 16],
    [18, 12, 13],
    [14, 15, 19],
    [17, 23, 21],
    [16, 22, 20],
    [13, 18, 12],
    [19, 14, 15],
    [21, 13, 22],
    [20, 19, 23],
    [12, 17, 14],
    [15, 16, 18],
    [23, 15, 13],
    [22, 12, 19],
    [18, 20, 17],
    [14, 21, 16],
    [17, 22, 15],
    [16, 23, 12],
    [13, 14, 20],
    [19, 18, 21],
    [15, 17, 22],
    [12, 16, 23],
    [20, 13, 14],
    [21, 19, 18],
    [22, 21, 13],
    [23, 20, 19],
    [14, 12, 17],
    [18, 15, 16],
    [13, 23, 15],
    [19, 22, 12],
    [17, 18, 20],
    [16, 14, 21],
    [15, 13, 23],
    [12, 19, 22],
    [20, 17, 18],
    [21, 16, 14],
    [22, 15, 17],
    [23, 12, 16],
    [14, 20, 13],
    [18, 21, 19],
    [13, 22, 21],
    [19, 23, 20],
    [17, 14, 12],
    [16, 18, 15],
    [6, 5, 3],
    [4, 9, 3],
    [9, 3, 4],
    [5, 7, 4],
    [4, 5, 7],
    [5, 3, 6],
];
var GroupData = [
    [0],
    [0, 1],
    [0, 2],
    [0, 3],
    [0, 2, 4, 5],
    [0, 6],
    [0, 7],
    [0, 6, 4, 8],
    [0, 7, 4, 9],
    [0, 6, 2, 1],
    [0, 3, 1, 10],
    [0, 6, 2, 1, 4, 8, 5, 11],
    [0, 12, 1, 7],
    [0, 1, 13, 14],
    [0, 12, 1, 7, 4, 15, 11, 9],
    [0, 16, 2, 17],
    [0, 18, 12, 17],
    [0, 16, 5, 19],
    [0, 20, 13, 19],
    [0, 18, 12, 17, 4, 21, 15, 19],
    [0, 16, 2, 17, 4, 22, 5, 19],
    [0, 16, 2, 17, 23, 24, 13, 25, 26, 20, 27, 28, 4, 22, 5, 19],
    [0, 16, 17, 2, 29, 21, 30, 15],
    [0, 20, 13, 19, 29, 31, 32, 33],
    [0, 16, 6, 34],
    [0, 18, 7, 34],
    [0, 16, 7, 35],
    [0, 16, 36, 37],
    [0, 18, 36, 38],
    [0, 16, 14, 39],
    [0, 20, 40, 34],
    [0, 16, 8, 41],
    [0, 18, 8, 42],
    [0, 16, 9, 42],
    [0, 16, 6, 34, 4, 22, 8, 41],
    [0, 18, 7, 34, 4, 21, 9, 41],
    [0, 16, 7, 35, 4, 22, 9, 42],
    [0, 16, 6, 34, 23, 24, 14, 39],
    [0, 16, 10, 43, 23, 24, 7, 35],
    [0, 16, 36, 37, 23, 24, 9, 42],
    [0, 16, 8, 41, 23, 24, 40, 38],
    [0, 16, 6, 34, 23, 24, 14, 39, 26, 20, 40, 38, 4, 22, 8, 41],
    [0, 16, 44, 45, 23, 24, 46, 47, 26, 20, 48, 49, 4, 22, 50, 51],
    [0, 16, 6, 34, 29, 21, 9, 42],
    [0, 16, 8, 41, 29, 21, 7, 35],
    [0, 16, 36, 37, 29, 21, 14, 39],
    [0, 16, 2, 17, 1, 52, 6, 34],
    [0, 16, 2, 17, 53, 54, 9, 42],
    [0, 16, 12, 33, 1, 52, 7, 35],
    [0, 16, 2, 17, 11, 55, 8, 41],
    [0, 56, 2, 57, 1, 58, 6, 37],
    [0, 56, 15, 25, 1, 58, 9, 39],
    [0, 20, 27, 17, 1, 59, 40, 34],
    [0, 56, 12, 28, 1, 58, 7, 38],
    [0, 16, 5, 19, 1, 52, 8, 41],
    [0, 22, 13, 28, 1, 55, 14, 38],
    [0, 18, 13, 60, 1, 61, 14, 43],
    [0, 16, 15, 30, 1, 52, 9, 42],
    [0, 16, 5, 19, 11, 55, 6, 34],
    [0, 21, 12, 19, 1, 54, 7, 41],
    [0, 20, 13, 19, 1, 59, 14, 41],
    [0, 20, 3, 30, 1, 59, 10, 42],
    [0, 18, 12, 17, 1, 61, 7, 34, 4, 21, 15, 19, 11, 54, 9, 41],
    [0, 24, 13, 17, 1, 62, 14, 34, 4, 20, 27, 19, 11, 59, 40, 41],
    [0, 16, 2, 17, 1, 52, 6, 34, 4, 22, 5, 19, 11, 55, 8, 41],
    [0, 16, 12, 33, 1, 52, 7, 35, 4, 22, 15, 30, 11, 55, 9, 42],
    [0, 31, 3, 17, 1, 63, 10, 34, 4, 56, 32, 19, 11, 58, 36, 41],
    [0, 22, 2, 19, 64, 59, 14, 38, 4, 16, 5, 17, 65, 62, 40, 39],
    [0, 16, 2, 17, 1, 52, 6, 34, 23, 24, 13, 25, 64, 62, 14, 39, 26, 20, 27, 28, 65, 59, 40, 38, 4, 22, 5, 19, 11, 55, 8, 41],
    [0, 16, 2, 17, 66, 67, 44, 45, 23, 24, 13, 25, 68, 69, 46, 47, 26, 20, 27, 28, 70, 71, 48, 49, 4, 22, 5, 19, 72, 73, 50, 51],
    [0, 16, 2, 17, 1, 52, 6, 34, 29, 21, 15, 30, 53, 54, 9, 42],
    [0, 16, 5, 19, 1, 52, 8, 41, 29, 21, 12, 33, 53, 54, 7, 35],
    [0, 20, 13, 19, 1, 59, 14, 41, 29, 31, 32, 33, 53, 63, 36, 35],
    [0, 31, 3, 17, 1, 63, 10, 34, 29, 20, 27, 30, 53, 59, 40, 42],
    [0, 16, 74, 75],
    [0, 18, 76, 77],
    [0, 16, 78, 79],
    [0, 18, 80, 81],
    [0, 16, 74, 75, 29, 21, 82, 83],
    [0, 21, 84, 85, 29, 16, 86, 87],
    [0, 16, 88, 89],
    [0, 16, 88, 89, 29, 21, 90, 91],
    [0, 16, 74, 75, 1, 52, 88, 89],
    [0, 16, 78, 79, 1, 52, 92, 93],
    [0, 16, 94, 95, 11, 55, 88, 89],
    [0, 16, 82, 83, 53, 54, 88, 89],
    [0, 16, 74, 75, 1, 52, 88, 89, 29, 21, 82, 83, 53, 54, 90, 91],
    [0, 21, 84, 85, 96, 97, 88, 91, 29, 16, 86, 87, 98, 99, 90, 89],
    [0, 16, 74, 75, 2, 17, 100, 101],
    [0, 16, 94, 95, 5, 19, 100, 101],
    [0, 18, 76, 77, 2, 33, 102, 103],
    [0, 18, 104, 105, 106, 107, 100, 108],
    [0, 16, 78, 79, 2, 17, 109, 108],
    [0, 16, 82, 83, 15, 30, 100, 101],
    [0, 18, 80, 81, 2, 33, 110, 111],
    [0, 18, 112, 113, 114, 115, 100, 108],
    [0, 16, 74, 75, 2, 17, 100, 101, 29, 21, 82, 83, 15, 30, 116, 117],
    [0, 21, 84, 85, 118, 119, 116, 101, 29, 16, 86, 87, 120, 121, 100, 117],
    [0, 16, 74, 75, 6, 34, 122, 123],
    [0, 16, 74, 75, 8, 41, 124, 125],
    [0, 16, 78, 79, 7, 35, 122, 123],
    [0, 16, 82, 83, 9, 42, 122, 123],
    [0, 16, 74, 75, 7, 35, 126, 127],
    [0, 16, 74, 75, 9, 42, 128, 129],
    [0, 16, 78, 79, 6, 34, 126, 127],
    [0, 16, 78, 79, 8, 41, 128, 129],
    [0, 16, 74, 75, 6, 34, 122, 123, 29, 21, 82, 83, 9, 42, 128, 129],
    [0, 16, 74, 75, 7, 35, 126, 127, 29, 21, 82, 83, 8, 41, 124, 125],
    [0, 21, 84, 85, 6, 42, 130, 131, 29, 16, 86, 87, 9, 34, 132, 133],
    [0, 21, 84, 85, 7, 41, 134, 135, 29, 16, 86, 87, 8, 35, 136, 137],
    [0, 16, 89, 88, 2, 17, 122, 123],
    [0, 16, 89, 88, 12, 33, 126, 127],
    [0, 16, 89, 88, 5, 19, 124, 125],
    [0, 16, 89, 88, 15, 30, 128, 129],
    [0, 16, 88, 89, 6, 34, 100, 101],
    [0, 16, 89, 88, 7, 35, 109, 108],
    [0, 16, 89, 88, 8, 41, 138, 139],
    [0, 16, 89, 88, 9, 42, 116, 117],
    [0, 16, 89, 88, 6, 34, 100, 101, 29, 21, 91, 90, 9, 42, 116, 117],
    [0, 16, 89, 88, 7, 35, 109, 108, 29, 21, 91, 90, 8, 41, 138, 139],
    [0, 16, 89, 88, 2, 17, 122, 123, 29, 21, 91, 90, 15, 30, 128, 129],
    [0, 16, 89, 88, 118, 121, 132, 131, 29, 21, 91, 90, 120, 119, 130, 133],
    [0, 16, 74, 75, 2, 17, 100, 101, 1, 52, 88, 89, 6, 34, 122, 123],
    [0, 16, 74, 75, 12, 33, 109, 108, 1, 52, 88, 89, 7, 35, 126, 127],
    [0, 16, 74, 75, 2, 17, 100, 101, 11, 55, 140, 141, 8, 41, 124, 125],
    [0, 16, 74, 75, 2, 17, 100, 101, 53, 54, 90, 91, 9, 42, 128, 129],
    [0, 16, 74, 75, 5, 19, 138, 139, 1, 52, 88, 89, 8, 41, 124, 125],
    [0, 16, 74, 75, 15, 30, 116, 117, 1, 52, 88, 89, 9, 42, 128, 129],
    [0, 16, 94, 95, 5, 19, 100, 101, 11, 55, 88, 89, 6, 34, 124, 125],
    [0, 16, 94, 95, 15, 30, 109, 108, 11, 55, 88, 89, 7, 35, 128, 129],
    [0, 16, 78, 79, 2, 17, 109, 108, 1, 52, 92, 93, 6, 34, 126, 127],
    [0, 16, 78, 79, 12, 33, 100, 101, 1, 52, 92, 93, 7, 35, 122, 123],
    [0, 16, 82, 83, 12, 33, 138, 139, 53, 54, 88, 89, 8, 41, 126, 127],
    [0, 16, 82, 83, 2, 17, 116, 117, 53, 54, 88, 89, 9, 42, 122, 123],
    [0, 16, 78, 79, 5, 19, 116, 117, 1, 52, 92, 93, 8, 41, 128, 129],
    [0, 16, 82, 83, 15, 30, 100, 101, 1, 52, 90, 91, 9, 42, 122, 123],
    [0, 16, 82, 83, 15, 30, 100, 101, 53, 54, 88, 89, 6, 34, 128, 129],
    [0, 16, 82, 83, 5, 19, 109, 108, 53, 54, 88, 89, 7, 35, 124, 125],
    [0, 16, 74, 75, 2, 17, 100, 101, 1, 52, 88, 89, 6, 34, 122, 123, 29, 21, 82, 83, 15, 30, 116, 117, 53, 54, 90, 91, 9, 42, 128, 129],
    [0, 16, 74, 75, 12, 33, 109, 108, 1, 52, 88, 89, 7, 35, 126, 127, 29, 21, 82, 83, 5, 19, 138, 139, 53, 54, 90, 91, 8, 41, 124, 125],
    [0, 21, 84, 85, 118, 119, 116, 101, 96, 97, 88, 91, 9, 34, 132, 133, 29, 16, 86, 87, 120, 121, 100, 117, 98, 99, 90, 89, 6, 42, 130, 131],
    [0, 21, 84, 85, 142, 143, 138, 108, 96, 97, 88, 91, 8, 35, 136, 137, 29, 16, 86, 87, 144, 145, 109, 139, 98, 99, 90, 89, 7, 41, 134, 135],
    [0, 146, 147],
    [0, 148, 149],
    [0, 150, 151],
    [0, 146, 147, 152, 153, 154, 155, 156, 157],
    [0, 158, 159],
    [0, 146, 147, 1, 160, 161],
    [0, 146, 147, 1, 160, 161, 152, 153, 154, 162, 163, 164, 155, 156, 157, 165, 166, 167],
    [0, 158, 159, 1, 168, 169],
    [0, 146, 147, 101, 170, 171],
    [0, 146, 147, 100, 172, 173],
    [0, 148, 149, 174, 175, 171],
    [0, 148, 149, 100, 176, 177],
    [0, 150, 151, 178, 179, 171],
    [0, 150, 151, 100, 180, 181],
    [0, 146, 147, 100, 172, 173, 152, 153, 154, 182, 183, 184, 155, 156, 157, 185, 186, 187],
    [0, 158, 159, 101, 188, 189],
    [0, 146, 147, 122, 190, 191],
    [0, 146, 147, 123, 192, 193],
    [0, 146, 147, 126, 194, 195],
    [0, 146, 147, 127, 196, 197],
    [0, 146, 147, 122, 190, 191, 152, 153, 154, 198, 199, 200, 155, 156, 157, 201, 202, 203],
    [0, 158, 159, 123, 204, 205],
    [0, 146, 147, 126, 194, 195, 152, 153, 154, 206, 207, 208, 155, 156, 157, 209, 210, 211],
    [0, 158, 159, 129, 212, 213],
    [0, 146, 147, 101, 170, 171, 1, 160, 161, 123, 192, 193],
    [0, 146, 147, 108, 214, 215, 1, 160, 161, 127, 196, 197],
    [0, 146, 147, 100, 172, 173, 1, 160, 161, 122, 190, 191],
    [0, 146, 147, 109, 216, 217, 1, 160, 161, 126, 194, 195],
    [0, 146, 147, 100, 172, 173, 1, 160, 161, 122, 190, 191, 152, 153, 154, 182, 183, 184, 162, 163, 164, 198, 199, 200, 155, 156, 157, 185, 186, 187, 165, 166, 167, 201, 202, 203],
    [0, 158, 159, 101, 188, 189, 1, 168, 169, 123, 204, 205],
    [0, 146, 147, 109, 216, 217, 1, 160, 161, 126, 194, 195, 152, 153, 154, 218, 219, 220, 162, 163, 164, 206, 207, 208, 155, 156, 157, 221, 222, 223, 165, 166, 167, 209, 210, 211],
    [0, 158, 159, 117, 224, 225, 1, 168, 169, 129, 212, 213],
    [0, 146, 147, 16, 226, 227],
    [0, 148, 149, 18, 228, 229],
    [0, 150, 151, 18, 230, 231],
    [0, 150, 151, 16, 232, 233],
    [0, 148, 149, 16, 234, 235],
    [0, 146, 147, 18, 236, 237],
    [0, 146, 147, 52, 238, 239],
    [0, 146, 147, 16, 226, 227, 1, 160, 161, 52, 238, 239],
    [0, 146, 147, 18, 236, 237, 1, 160, 161, 61, 240, 241],
    [0, 146, 147, 16, 226, 227, 100, 172, 173, 101, 170, 171],
    [0, 148, 149, 18, 228, 229, 242, 172, 181, 243, 214, 244],
    [0, 150, 151, 18, 230, 231, 245, 172, 177, 246, 214, 247],
    [0, 150, 151, 16, 232, 233, 245, 172, 177, 174, 170, 248],
    [0, 148, 149, 16, 234, 235, 242, 172, 181, 178, 170, 249],
    [0, 146, 147, 18, 236, 237, 100, 172, 173, 108, 214, 215],
    [0, 146, 147, 16, 226, 227, 122, 190, 191, 123, 192, 193],
    [0, 146, 147, 16, 226, 227, 126, 194, 195, 127, 196, 197],
    [0, 146, 147, 18, 236, 237, 126, 194, 195, 123, 192, 193],
    [0, 146, 147, 18, 236, 237, 122, 190, 191, 127, 196, 197],
    [0, 146, 147, 52, 238, 239, 122, 190, 191, 101, 170, 171],
    [0, 146, 147, 61, 240, 241, 126, 194, 195, 101, 170, 171],
    [0, 146, 147, 52, 238, 239, 100, 172, 173, 123, 192, 193],
    [0, 146, 147, 61, 240, 241, 100, 172, 173, 127, 196, 197],
    [0, 146, 147, 16, 226, 227, 100, 172, 173, 101, 170, 171, 1, 160, 161, 52, 239, 238, 122, 190, 191, 123, 192, 193],
    [0, 146, 147, 16, 226, 227, 109, 216, 217, 108, 214, 215, 1, 160, 161, 52, 239, 238, 126, 194, 195, 127, 196, 197],
    [0, 146, 147, 18, 236, 237, 109, 216, 217, 101, 170, 171, 1, 160, 161, 61, 241, 240, 126, 194, 195, 123, 192, 193],
    [0, 146, 147, 18, 236, 237, 100, 172, 173, 108, 214, 215, 1, 160, 161, 61, 241, 240, 122, 190, 191, 127, 196, 197],
    [0, 16, 2, 17, 158, 250, 251, 252, 159, 253, 254, 255],
    [0, 16, 2, 17, 158, 250, 251, 252, 159, 253, 254, 255, 23, 24, 13, 25, 256, 257, 258, 259, 260, 261, 262, 263, 26, 20, 27, 28, 264, 265, 266, 267, 268, 269, 270, 271, 4, 22, 5, 19, 272, 273, 274, 275, 276, 277, 278, 279],
    [0, 16, 2, 17, 158, 250, 251, 252, 159, 253, 254, 255, 29, 21, 15, 30, 280, 281, 282, 283, 284, 285, 286, 287],
    [0, 20, 13, 19, 158, 273, 266, 259, 159, 261, 278, 271],
    [0, 20, 13, 19, 158, 273, 266, 259, 159, 261, 278, 271, 29, 31, 32, 33, 280, 288, 289, 290, 284, 291, 292, 293],
    [0, 16, 2, 17, 158, 250, 251, 252, 159, 253, 254, 255, 1, 52, 6, 34, 168, 294, 295, 296, 169, 297, 298, 299],
    [0, 16, 2, 17, 158, 250, 251, 252, 159, 253, 254, 255, 53, 54, 9, 42, 300, 301, 302, 303, 304, 305, 306, 307],
    [0, 16, 2, 17, 158, 250, 251, 252, 159, 253, 254, 255, 1, 52, 6, 34, 168, 294, 295, 296, 169, 297, 298, 299, 23, 24, 13, 25, 256, 257, 258, 259, 260, 261, 262, 263, 64, 62, 14, 39, 308, 309, 310, 311, 312, 313, 314, 315, 26, 20, 27, 28, 264, 265, 266, 267, 268, 269, 270, 271, 65, 59, 40, 38, 316, 317, 318, 319, 320, 321, 322, 323, 4, 22, 5, 19, 272, 273, 274, 275, 276, 277, 278, 279, 11, 55, 8, 41, 324, 325, 326, 327, 328, 329, 330, 331],
    [0, 16, 2, 17, 158, 250, 251, 252, 159, 253, 254, 255, 66, 67, 44, 45, 332, 333, 334, 335, 336, 337, 338, 339, 23, 24, 13, 25, 256, 257, 258, 259, 260, 261, 262, 263, 68, 69, 46, 47, 340, 341, 342, 343, 344, 345, 346, 347, 26, 20, 27, 28, 264, 265, 266, 267, 268, 269, 270, 271, 70, 71, 48, 49, 348, 349, 350, 351, 352, 353, 354, 355, 4, 22, 5, 19, 272, 273, 274, 275, 276, 277, 278, 279, 72, 73, 50, 51, 356, 357, 358, 359, 360, 361, 362, 363],
    [0, 16, 2, 17, 158, 250, 251, 252, 159, 253, 254, 255, 1, 52, 6, 34, 168, 294, 295, 296, 169, 297, 298, 299, 29, 21, 15, 30, 280, 281, 282, 283, 284, 285, 286, 287, 53, 54, 9, 42, 300, 301, 302, 303, 304, 305, 306, 307],
    [0, 20, 13, 19, 158, 273, 266, 259, 159, 261, 278, 271, 1, 59, 14, 41, 168, 325, 318, 311, 169, 313, 330, 323],
    [0, 20, 13, 19, 158, 273, 266, 259, 159, 261, 278, 271, 1, 59, 14, 41, 168, 325, 318, 311, 169, 313, 330, 323, 29, 31, 32, 33, 280, 288, 289, 290, 284, 291, 292, 293, 53, 63, 36, 35, 300, 364, 365, 366, 304, 367, 368, 369],
    [0, 16, 2, 17, 158, 250, 251, 252, 159, 253, 254, 255, 100, 101, 75, 74, 370, 371, 188, 372, 373, 374, 375, 189],
    [0, 16, 2, 17, 158, 250, 251, 252, 159, 253, 254, 255, 116, 117, 83, 82, 376, 377, 224, 378, 379, 380, 381, 225],
    [0, 16, 2, 17, 158, 250, 251, 252, 159, 253, 254, 255, 100, 101, 75, 74, 370, 371, 188, 372, 373, 374, 375, 189, 23, 24, 13, 25, 256, 257, 258, 259, 260, 261, 262, 263, 382, 383, 384, 385, 386, 387, 388, 389, 390, 391, 392, 393, 26, 20, 27, 28, 264, 265, 266, 267, 268, 269, 270, 271, 394, 395, 396, 397, 398, 399, 400, 401, 402, 403, 404, 405, 4, 22, 5, 19, 272, 273, 274, 275, 276, 277, 278, 279, 138, 139, 95, 94, 406, 407, 408, 409, 410, 411, 412, 413],
    [0, 24, 5, 28, 158, 265, 258, 275, 159, 277, 270, 263, 414, 415, 416, 417, 418, 419, 420, 421, 422, 423, 424, 425, 23, 16, 27, 19, 256, 273, 251, 267, 260, 269, 278, 255, 426, 427, 428, 429, 430, 431, 432, 433, 434, 435, 436, 437, 26, 22, 13, 17, 264, 250, 274, 259, 268, 261, 254, 279, 438, 439, 440, 441, 442, 443, 444, 445, 446, 447, 448, 449, 4, 20, 2, 25, 272, 257, 266, 252, 276, 253, 262, 271, 450, 451, 452, 453, 454, 455, 456, 457, 458, 459, 460, 461],
    [0, 16, 2, 17, 158, 250, 251, 252, 159, 253, 254, 255, 100, 101, 75, 74, 370, 371, 188, 372, 373, 374, 375, 189, 29, 21, 15, 30, 280, 281, 282, 283, 284, 285, 286, 287, 116, 117, 83, 82, 376, 377, 224, 378, 379, 380, 381, 225],
    [0, 20, 13, 19, 158, 273, 266, 259, 159, 261, 278, 271, 450, 415, 440, 429, 454, 431, 420, 445, 458, 447, 436, 425],
    [0, 20, 13, 19, 158, 273, 266, 259, 159, 261, 278, 271, 462, 463, 464, 465, 466, 467, 468, 469, 470, 471, 472, 473],
    [0, 20, 13, 19, 158, 273, 266, 259, 159, 261, 278, 271, 462, 463, 464, 465, 466, 467, 468, 469, 470, 471, 472, 473, 29, 31, 32, 33, 280, 288, 289, 290, 284, 291, 292, 293, 450, 415, 440, 429, 454, 431, 420, 445, 458, 447, 436, 425],
    [0, 16, 2, 17, 158, 250, 251, 252, 159, 253, 254, 255, 123, 122, 88, 89, 204, 474, 475, 476, 205, 477, 478, 479],
    [0, 16, 2, 17, 158, 250, 251, 252, 159, 253, 254, 255, 123, 122, 88, 89, 204, 474, 475, 476, 205, 477, 478, 479, 23, 24, 13, 25, 256, 257, 258, 259, 260, 261, 262, 263, 480, 481, 482, 483, 484, 485, 486, 487, 488, 489, 490, 491, 26, 20, 27, 28, 264, 265, 266, 267, 268, 269, 270, 271, 492, 493, 494, 495, 496, 497, 498, 499, 500, 501, 502, 503, 4, 22, 5, 19, 272, 273, 274, 275, 276, 277, 278, 279, 125, 124, 140, 141, 504, 505, 506, 507, 508, 509, 510, 511],
    [0, 16, 2, 17, 158, 250, 251, 252, 159, 253, 254, 255, 123, 122, 88, 89, 204, 474, 475, 476, 205, 477, 478, 479, 29, 21, 15, 30, 280, 281, 282, 283, 284, 285, 286, 287, 129, 128, 90, 91, 212, 512, 513, 514, 213, 515, 516, 517],
    [0, 16, 2, 17, 158, 250, 251, 252, 159, 253, 254, 255, 129, 128, 90, 91, 212, 512, 513, 514, 213, 515, 516, 517],
    [0, 16, 2, 17, 158, 250, 251, 252, 159, 253, 254, 255, 129, 128, 90, 91, 212, 512, 513, 514, 213, 515, 516, 517, 23, 24, 13, 25, 256, 257, 258, 259, 260, 261, 262, 263, 518, 519, 520, 521, 522, 523, 524, 525, 526, 527, 528, 529, 26, 20, 27, 28, 264, 265, 266, 267, 268, 269, 270, 271, 530, 531, 532, 533, 534, 535, 536, 537, 538, 539, 540, 541, 4, 22, 5, 19, 272, 273, 274, 275, 276, 277, 278, 279, 127, 126, 92, 93, 542, 543, 544, 545, 546, 547, 548, 549],
    [0, 20, 13, 19, 158, 273, 266, 259, 159, 261, 278, 271, 550, 551, 552, 553, 554, 555, 556, 557, 558, 559, 560, 561, 29, 31, 32, 33, 280, 288, 289, 290, 284, 291, 292, 293, 562, 563, 564, 565, 566, 567, 568, 569, 570, 571, 572, 573],
    [0, 16, 2, 17, 158, 250, 251, 252, 159, 253, 254, 255, 100, 101, 75, 74, 370, 371, 188, 372, 373, 374, 375, 189, 1, 52, 6, 34, 168, 294, 295, 296, 169, 297, 298, 299, 122, 123, 89, 88, 475, 476, 204, 474, 479, 478, 477, 205],
    [0, 16, 2, 17, 158, 250, 251, 252, 159, 253, 254, 255, 100, 101, 75, 74, 370, 371, 188, 372, 373, 374, 375, 189, 53, 54, 9, 42, 300, 301, 302, 303, 304, 305, 306, 307, 128, 129, 91, 90, 513, 514, 212, 512, 517, 516, 515, 213],
    [0, 16, 2, 17, 158, 250, 251, 252, 159, 253, 254, 255, 116, 117, 83, 82, 376, 377, 224, 378, 379, 380, 381, 225, 1, 52, 6, 34, 168, 294, 295, 296, 169, 297, 298, 299, 128, 129, 91, 90, 513, 514, 212, 512, 517, 516, 515, 213],
    [0, 16, 2, 17, 158, 250, 251, 252, 159, 253, 254, 255, 116, 117, 83, 82, 376, 377, 224, 378, 379, 380, 381, 225, 53, 54, 9, 42, 300, 301, 302, 303, 304, 305, 306, 307, 122, 123, 89, 88, 475, 476, 204, 474, 479, 478, 477, 205],
    [0, 16, 2, 17, 158, 250, 251, 252, 159, 253, 254, 255, 100, 101, 75, 74, 370, 371, 188, 372, 373, 374, 375, 189, 1, 52, 6, 34, 168, 294, 295, 296, 169, 297, 298, 299, 122, 123, 89, 88, 475, 476, 204, 474, 479, 478, 477, 205, 23, 24, 13, 25, 256, 257, 258, 259, 260, 261, 262, 263, 382, 383, 384, 385, 386, 387, 388, 389, 390, 391, 392, 393, 64, 62, 14, 39, 308, 309, 310, 311, 312, 313, 314, 315, 481, 480, 483, 482, 486, 487, 484, 485, 491, 490, 489, 488, 26, 20, 27, 28, 264, 265, 266, 267, 268, 269, 270, 271, 394, 395, 396, 397, 398, 399, 400, 401, 402, 403, 404, 405, 65, 59, 40, 38, 316, 317, 318, 319, 320, 321, 322, 323, 493, 492, 495, 494, 498, 499, 496, 497, 503, 502, 501, 500, 4, 22, 5, 19, 272, 273, 274, 275, 276, 277, 278, 279, 138, 139, 95, 94, 406, 407, 408, 409, 410, 411, 412, 413, 11, 55, 8, 41, 324, 325, 326, 327, 328, 329, 330, 331, 124, 125, 141, 140, 506, 507, 504, 505, 511, 510, 509, 508],
    [0, 16, 2, 17, 158, 250, 251, 252, 159, 253, 254, 255, 116, 117, 83, 82, 376, 377, 224, 378, 379, 380, 381, 225, 1, 52, 6, 34, 168, 294, 295, 296, 169, 297, 298, 299, 128, 129, 91, 90, 513, 514, 212, 512, 517, 516, 515, 213, 23, 24, 13, 25, 256, 257, 258, 259, 260, 261, 262, 263, 574, 575, 576, 577, 578, 579, 580, 581, 582, 583, 584, 585, 64, 62, 14, 39, 308, 309, 310, 311, 312, 313, 314, 315, 519, 518, 521, 520, 524, 525, 522, 523, 529, 528, 527, 526, 26, 20, 27, 28, 264, 265, 266, 267, 268, 269, 270, 271, 586, 587, 588, 589, 590, 591, 592, 593, 594, 595, 596, 597, 65, 59, 40, 38, 316, 317, 318, 319, 320, 321, 322, 323, 531, 530, 533, 532, 536, 537, 534, 535, 541, 540, 539, 538, 4, 22, 5, 19, 272, 273, 274, 275, 276, 277, 278, 279, 109, 108, 79, 78, 598, 599, 600, 601, 602, 603, 604, 605, 11, 55, 8, 41, 324, 325, 326, 327, 328, 329, 330, 331, 126, 127, 93, 92, 544, 545, 542, 543, 549, 548, 547, 546],
    [0, 24, 5, 28, 158, 265, 258, 275, 159, 277, 270, 263, 414, 415, 416, 417, 418, 419, 420, 421, 422, 423, 424, 425, 66, 69, 50, 49, 332, 349, 342, 359, 336, 361, 354, 347, 493, 123, 483, 140, 498, 507, 204, 485, 503, 490, 509, 205, 23, 16, 27, 19, 256, 273, 251, 267, 260, 269, 278, 255, 426, 427, 428, 429, 430, 431, 432, 433, 434, 435, 436, 437, 68, 67, 48, 51, 340, 357, 334, 351, 344, 353, 362, 339, 124, 480, 89, 494, 506, 499, 484, 474, 511, 478, 501, 488, 26, 22, 13, 17, 264, 250, 274, 259, 268, 261, 254, 279, 438, 439, 440, 441, 442, 443, 444, 445, 446, 447, 448, 449, 70, 73, 46, 45, 348, 333, 358, 343, 352, 345, 338, 363, 122, 492, 141, 482, 475, 487, 496, 505, 479, 510, 489, 500, 4, 20, 2, 25, 272, 257, 266, 252, 276, 253, 262, 271, 450, 451, 452, 453, 454, 455, 456, 457, 458, 459, 460, 461, 72, 71, 44, 47, 356, 341, 350, 335, 360, 337, 346, 355, 481, 125, 495, 88, 486, 476, 504, 497, 491, 502, 477, 508],
    [0, 24, 5, 28, 158, 265, 258, 275, 159, 277, 270, 263, 414, 415, 416, 417, 418, 419, 420, 421, 422, 423, 424, 425, 606, 607, 608, 609, 610, 611, 612, 613, 614, 615, 616, 617, 531, 129, 521, 92, 536, 545, 212, 523, 541, 528, 547, 213, 23, 16, 27, 19, 256, 273, 251, 267, 260, 269, 278, 255, 426, 427, 428, 429, 430, 431, 432, 433, 434, 435, 436, 437, 618, 619, 620, 621, 622, 623, 624, 625, 626, 627, 628, 629, 126, 518, 91, 532, 544, 537, 522, 512, 549, 516, 539, 526, 26, 22, 13, 17, 264, 250, 274, 259, 268, 261, 254, 279, 438, 439, 440, 441, 442, 443, 444, 445, 446, 447, 448, 449, 630, 631, 632, 633, 634, 635, 636, 637, 638, 639, 640, 641, 128, 530, 93, 520, 513, 525, 534, 543, 517, 548, 527, 538, 4, 20, 2, 25, 272, 257, 266, 252, 276, 253, 262, 271, 450, 451, 452, 453, 454, 455, 456, 457, 458, 459, 460, 461, 642, 643, 644, 645, 646, 647, 648, 649, 650, 651, 652, 653, 519, 127, 533, 90, 524, 514, 542, 535, 529, 540, 515, 546],
    [0, 16, 2, 17, 158, 250, 251, 252, 159, 253, 254, 255, 100, 101, 75, 74, 370, 371, 188, 372, 373, 374, 375, 189, 1, 52, 6, 34, 168, 294, 295, 296, 169, 297, 298, 299, 122, 123, 89, 88, 475, 476, 204, 474, 479, 478, 477, 205, 29, 21, 15, 30, 280, 281, 282, 283, 284, 285, 286, 287, 116, 117, 83, 82, 376, 377, 224, 378, 379, 380, 381, 225, 53, 54, 9, 42, 300, 301, 302, 303, 304, 305, 306, 307, 128, 129, 91, 90, 513, 514, 212, 512, 517, 516, 515, 213],
    [0, 20, 13, 19, 158, 273, 266, 259, 159, 261, 278, 271, 462, 463, 464, 465, 466, 467, 468, 469, 470, 471, 472, 473, 1, 59, 14, 41, 168, 325, 318, 311, 169, 313, 330, 323, 551, 550, 553, 552, 556, 557, 554, 555, 561, 560, 559, 558, 29, 31, 32, 33, 280, 288, 289, 290, 284, 291, 292, 293, 450, 415, 440, 429, 454, 431, 420, 445, 458, 447, 436, 425, 53, 63, 36, 35, 300, 364, 365, 366, 304, 367, 368, 369, 563, 562, 565, 564, 568, 569, 566, 567, 573, 572, 571, 570],
    [0, 16],
    [0, 18],
    [0, 16, 26, 20],
    [0, 2, 23, 13],
    [0, 3, 4, 32],
    [0, 2, 29, 15],
    [0, 3, 29, 27],
    [0, 52],
    [0, 63],
    [0, 52, 26, 59],
    [0, 63, 26, 54],
    [0, 52, 16, 1],
    [0, 18, 1, 61],
    [0, 52, 16, 1, 26, 59, 20, 65],
    [0, 31, 1, 63],
    [0, 1, 24, 62],
    [0, 15, 1, 9],
    // X,Y,Z
    // -X+1/2,Y+1/2,-Z+1/2
    // -X,-Y,-Z
    // X+1/2,-Y+1/2,Z+1/2
    [0, 5, 1, 8],
    // X,Y,Z
    // -X+1/2,Y+1/2,-Z
    // -X,-Y,-Z
    // X+1/2,-Y+1/2,Z
    [0, 31, 1, 63, 26, 21, 65, 54],
    [0, 2, 57, 56],
    [0, 60, 3, 16],
    [0, 22, 57, 3],
    [0, 2, 28, 20],
    [0, 17, 13, 24],
    [0, 20, 19, 13, 4, 24, 17, 27],
    [0, 22, 57, 3, 4, 16, 60, 32],
    [0, 22, 57, 3, 23, 20, 30, 12, 26, 24, 33, 15, 4, 16, 60, 32],
    [0, 22, 57, 3, 29, 18, 27, 25],
    [0, 22, 3, 57, 1, 55, 10, 37],
    [0, 22, 385, 396, 3, 57, 109, 117],
    [0, 22, 57, 3, 159, 279, 654, 655, 158, 274, 656, 657, 29, 18, 25, 27, 284, 658, 262, 269, 280, 659, 257, 267],
];
var SpacegroupNameToIndexMap = {
    'P 1': 0,
    'P -1': 1,
    'P 1 2 1': 2,
    'P 1 21 1': 3,
    'C 1 2 1': 4,
    'P 1 m 1': 5,
    'P 1 c 1': 6,
    'C 1 m 1': 7,
    'C 1 c 1': 8,
    'P 1 2/m 1': 9,
    'P 1 21/m 1': 10,
    'C 1 2/m 1': 11,
    'P 1 2/c 1': 12,
    'P 1 21/c 1': 13,
    'C 1 2/c 1': 14,
    'P 2 2 2': 15,
    'P 2 2 21': 16,
    'P 21 21 2': 17,
    'P 21 21 21': 18,
    'C 2 2 21': 19,
    'C 2 2 2': 20,
    'F 2 2 2': 21,
    'I 2 2 2': 22,
    'I 21 21 21': 23,
    'P m m 2': 24,
    'P m c 21': 25,
    'P c c 2': 26,
    'P m a 2': 27,
    'P c a 21': 28,
    'P n c 2': 29,
    'P m n 21': 30,
    'P b a 2': 31,
    'P n a 21': 32,
    'P n n 2': 33,
    'C m m 2': 34,
    'C m c 21': 35,
    'C c c 2': 36,
    'A m m 2': 37,
    'A b m 2': 38,
    'A m a 2': 39,
    'A b a 2': 40,
    'F m m 2': 41,
    'F d d 2': 42,
    'I m m 2': 43,
    'I b a 2': 44,
    'I m a 2': 45,
    'P 2/m 2/m 2/m': 46,
    'P m m m': 46,
    'P 2/n 2/n 2/n': 47,
    'P n n n': 47,
    'P 2/c 2/c 2/m': 48,
    'P c c m': 48,
    'P 2/b 2/a 2/n': 49,
    'P b a n': 49,
    'P 21/m 2/m 2/a': 50,
    'P m m a': 50,
    'P 2/n 21/n 2/a': 51,
    'P n n a': 51,
    'P 2/m 2/n 21/a': 52,
    'P m n a': 52,
    'P 21/c 2/c 2/a': 53,
    'P c c a': 53,
    'P 21/b 21/a 2/m': 54,
    'P b a m': 54,
    'P 21/c 21/c 2/n': 55,
    'P c c n': 55,
    'P 2/b 21/c 21/m': 56,
    'P b c m': 56,
    'P 21/n 21/n 2/m': 57,
    'P n n m': 57,
    'P 21/m 21/m 2/n': 58,
    'P m m n': 58,
    'P 21/b 2/c 21/n': 59,
    'P b c n': 59,
    'P 21/b 21/c 21/a': 60,
    'P b c a': 60,
    'P 21/n 21/m 21/a': 61,
    'P n m a': 61,
    'C 2/m 2/c 21/m': 62,
    'C m c m': 62,
    'C 2/m 2/c 21/a': 63,
    'C m c a': 63,
    'C 2/m 2/m 2/m': 64,
    'C m m m': 64,
    'C 2/c 2/c 2/m': 65,
    'C c c m': 65,
    'C 2/m 2/m 2/a': 66,
    'C m m a': 66,
    'C 2/c 2/c 2/a': 67,
    'C c c a': 67,
    'F 2/m 2/m 2/m': 68,
    'F m m m': 68,
    'F 2/d 2/d 2/d': 69,
    'F d d d': 69,
    'I 2/m 2/m 2/m': 70,
    'I m m m': 70,
    'I 2/b 2/a 2/m': 71,
    'I b a m': 71,
    'I 21/b 21/c 21/a': 72,
    'I b c a': 72,
    'I 21/m 21/m 21/a': 73,
    'I m m a': 73,
    'P 4': 74,
    'P 41': 75,
    'P 42': 76,
    'P 43': 77,
    'I 4': 78,
    'I 41': 79,
    'P -4': 80,
    'I -4': 81,
    'P 4/m': 82,
    'P 42/m': 83,
    'P 4/n': 84,
    'P 42/n': 85,
    'I 4/m': 86,
    'I 41/a': 87,
    'P 4 2 2': 88,
    'P 4 21 2': 89,
    'P 41 2 2': 90,
    'P 41 21 2': 91,
    'P 42 2 2': 92,
    'P 42 21 2': 93,
    'P 43 2 2': 94,
    'P 43 21 2': 95,
    'I 4 2 2': 96,
    'I 41 2 2': 97,
    'P 4 m m': 98,
    'P 4 b m': 99,
    'P 42 c m': 100,
    'P 42 n m': 101,
    'P 4 c c': 102,
    'P 4 n c': 103,
    'P 42 m c': 104,
    'P 42 b c': 105,
    'I 4 m m': 106,
    'I 4 c m': 107,
    'I 41 m d': 108,
    'I 41 c d': 109,
    'P -4 2 m': 110,
    'P -4 2 c': 111,
    'P -4 21 m': 112,
    'P -4 21 c': 113,
    'P -4 m 2': 114,
    'P -4 c 2': 115,
    'P -4 b 2': 116,
    'P -4 n 2': 117,
    'I -4 m 2': 118,
    'I -4 c 2': 119,
    'I -4 2 m': 120,
    'I -4 2 d': 121,
    'P 4/m 2/m 2/m': 122,
    'P4/m m m': 122,
    'P 4/m 2/c 2/c': 123,
    'P4/m c c': 123,
    'P 4/n 2/b 2/m': 124,
    'P4/n b m': 124,
    'P 4/n 2/n 2/c': 125,
    'P4/n n c': 125,
    'P 4/m 21/b 2/m': 126,
    'P4/m b m': 126,
    'P 4/m 21/n 2/c': 127,
    'P4/m n c': 127,
    'P 4/n 21/m 2/m': 128,
    'P4/n m m': 128,
    'P 4/n 2/c 2/c': 129,
    'P4/n c c': 129,
    'P 42/m 2/m 2/c': 130,
    'P42/m m c': 130,
    'P 42/m 2/c 2/m': 131,
    'P42/m c m': 131,
    'P 42/n 2/b 2/c': 132,
    'P42/n b c': 132,
    'P 42/n 2/n 2/m': 133,
    'P42/n n m': 133,
    'P 42/m 21/b 2/c': 134,
    'P42/m b c': 134,
    'P 42/m 21/n 2/m': 135,
    'P42/m n m': 135,
    'P 42/n 21/m 2/c': 136,
    'P42/n m c': 136,
    'P 42/n 21/c 2/m': 137,
    'P42/n c m': 137,
    'I 4/m 2/m 2/m': 138,
    'I4/m m m': 138,
    'I 4/m 2/c 2/m': 139,
    'I4/m c m': 139,
    'I 41/a 2/m 2/d': 140,
    'I41/a m d': 140,
    'I 41/a 2/c 2/d': 141,
    'I41/a c d': 141,
    'P 3': 142,
    'P 31': 143,
    'P 32': 144,
    'H 3': 145,
    'R 3': 146,
    'P -3': 147,
    'H -3': 148,
    'R -3': 149,
    'P 3 1 2': 150,
    'P 3 2 1': 151,
    'P 31 1 2': 152,
    'P 31 2 1': 153,
    'P 32 1 2': 154,
    'P 32 2 1': 155,
    'H 3 2': 156,
    'R 3 2': 157,
    'P 3 m 1': 158,
    'P 3 1 m': 159,
    'P 3 c 1': 160,
    'P 3 1 c': 161,
    'H 3 m': 162,
    'R 3 m': 163,
    'H 3 c': 164,
    'R 3 c': 165,
    'P -3 1 2/m': 166,
    'P -3 1 m': 166,
    'P -3 1 2/c': 167,
    'P -3 1 c': 167,
    'P -3 2/m 1': 168,
    'P -3 m 1': 168,
    'P -3 2/c 1': 169,
    'P -3 c 1': 169,
    'H -3 2/m': 170,
    'H -3 m': 170,
    'R -3 2/m': 171,
    'R -3 m': 171,
    'H -3 2/c': 172,
    'H -3 c': 172,
    'R -3 2/c': 173,
    'R -3 c': 173,
    'P 6': 174,
    'P 61': 175,
    'P 65': 176,
    'P 62': 177,
    'P 64': 178,
    'P 63': 179,
    'P -6': 180,
    'P 6/m': 181,
    'P 63/m': 182,
    'P 6 2 2': 183,
    'P 61 2 2': 184,
    'P 65 2 2': 185,
    'P 62 2 2': 186,
    'P 64 2 2': 187,
    'P 63 2 2': 188,
    'P 6 m m': 189,
    'P 6 c c': 190,
    'P 63 c m': 191,
    'P 63 m c': 192,
    'P -6 m 2': 193,
    'P -6 c 2': 194,
    'P -6 2 m': 195,
    'P -6 2 c': 196,
    'P 6/m 2/m 2/m': 197,
    'P 6/m m m': 197,
    'P 6/m 2/c 2/c': 198,
    'P 6/m c c': 198,
    'P 63/m 2/c 2/m': 199,
    'P 63/m c m': 199,
    'P 63/m 2/m 2/c': 200,
    'P 63/m m c': 200,
    'P 2 3': 201,
    'F 2 3': 202,
    'I 2 3': 203,
    'P 21 3': 204,
    'I 21 3': 205,
    'P 2/m -3': 206,
    'P m -3': 206,
    'P 2/n -3': 207,
    'P n -3': 207,
    'F 2/m -3': 208,
    'F m -3': 208,
    'F 2/d -3': 209,
    'F d -3': 209,
    'I 2/m -3': 210,
    'I m -3': 210,
    'P 21/a -3': 211,
    'P a -3': 211,
    'I 21/a -3': 212,
    'I a -3': 212,
    'P 4 3 2': 213,
    'P 42 3 2': 214,
    'F 4 3 2': 215,
    'F 41 3 2': 216,
    'I 4 3 2': 217,
    'P 43 3 2': 218,
    'P 41 3 2': 219,
    'I 41 3 2': 220,
    'P -4 3 m': 221,
    'F -4 3 m': 222,
    'I -4 3 m': 223,
    'P -4 3 n': 224,
    'F -4 3 c': 225,
    'I -4 3 d': 226,
    'P 4/m -3 2/m': 227,
    'P m -3 m': 227,
    'P 4/n -3 2/n': 228,
    'P n -3 n': 228,
    'P 42/m -3 2/n': 229,
    'P m -3 n': 229,
    'P 42/n -3 2/m': 230,
    'P n -3 m': 230,
    'F 4/m -3 2/m': 231,
    'F m -3 m': 231,
    'F 4/m -3 2/c': 232,
    'F m -3 c': 232,
    'F 41/d -3 2/m': 233,
    'F d -3 m': 233,
    'F 41/d -3 2/c': 234,
    'F d -3 c': 234,
    'I 4/m -3 2/m': 235,
    'I m -3 m': 235,
    'I 41/a -3 2/d': 236,
    'I a -3 d': 236,
    'P 1 1 2': 237,
    'P 1 1 21': 238,
    'B 1 1 2': 239,
    'B 2': 239,
    'A 1 2 1': 240,
    'C 1 21 1': 241,
    'I 1 2 1': 242,
    'I 2': 242,
    'I 1 21 1': 243,
    'P 1 1 m': 244,
    'P 1 1 b': 245,
    'B 1 1 m': 246,
    'B 1 1 b': 247,
    'P 1 1 2/m': 248,
    'P 1 1 21/m': 249,
    'B 1 1 2/m': 250,
    'P 1 1 2/b': 251,
    'P 1 1 21/b': 252,
    'P 1 21/n 1': 253,
    'P 1 21/a 1': 254,
    'B 1 1 2/b': 255,
    'P 21 2 2': 256,
    'P 2 21 2': 257,
    'P 21 21 2 (a)': 258,
    'P 21 2 21': 259,
    'P 2 21 21': 260,
    'C 2 2 21a)': 261,
    'C 2 2 2a': 262,
    'F 2 2 2a': 263,
    'I 2 2 2a': 264,
    'P 21/m 21/m 2/n a': 265,
    'P 42 21 2a': 266,
    'I 2 3a': 267,
};
function getSpacegroupIndexFromNumber(num) {
    // 38 spacegroup variants as given CCP4s symop.lib
    switch (num) {
        case 1146: return 146;
        case 1148: return 149;
        case 1155: return 157;
        case 1160: return 163;
        case 1161: return 165;
        case 1166: return 171;
        case 1167: return 173;
        case 1003: return 237; // 'P 1 1 2'  !(dyad along z)
        case 1004: return 238; // 'P 1 1 21'  !(unique axis c)
        case 1005: return 239; // 'B 1 1 2' 'B 2'
        case 2005: return 240; // 'A 1 2 1'
        case 3005: return 241; // 'C 1 21 1' ! (Origin on screw at 1/4X)
        case 4005: return 242; // 'I 1 2 1' 'I 2' !!! GJK @ 2003-06-02
        case 5005: return 243; // 'I 1 21 1'
        case 1006: return 244; // 'P 1 1 m'
        case 1007: return 245; // 'P 1 1 b'
        case 1008: return 246; // 'B 1 1 m'
        case 1009: return 247; // 'B 1 1 b'
        case 1010: return 248; // 'P 1 1 2/m'
        case 1011: return 249; // 'P 1 1 21/m'
        case 1012: return 250; // 'B 1 1 2/m'
        case 1013: return 251; // 'P 1 1 2/b'
        case 1014: return 252; // 'P 1 1 21/b'
        case 2014: return 253; // 'P 1 21/n 1'
        case 3014: return 254; // 'P 1 21/a 1'
        case 1015: return 255; // 'B 1 1 2/b'
        case 1017: return 256; // 'P 21 2 2' !(unique axis a)
        case 2017: return 257; // 'P 2 21 2' !(unique axis b)
        case 1018: return 258; // 'P 21 21 2 (a)' ! origin on 21 21, shift (1/4,1/4,0)
        case 2018: return 259; // 'P 21 2 21'  !(unique axis b)
        case 3018: return 260; // 'P 2 21 21'  !(unique axis a)
        case 1020: return 261; // 'C 2 2 21a)' ! P212121 with C centring, shift(1/4,0,0)
        case 1021: return 262; // 'C 2 2 2a'  ! C21212a origin on 21 21
        case 1022: return 263; // 'F 2 2 2a' ! same as 1018 with face centring  shift (1/4,0,0)
        case 1023: return 264; // 'I 2 2 2a'  ! as 1018 with origin shift (1/4,1/4,1/4)
        case 1059: return 265; // 'P 21/m 21/m 2/n a'
        case 1094: return 266; // 'P 42 21 2a' ! (as P21212a) origin on 21 21 ie Shift 1/4,1/4,1/4
        case 1197: return 267; // 'I 2 3a' ! Expansion of 1023 which is an expansion of 1018
    }
    var offset = 0;
    if (num > 146)
        ++offset;
    if (num > 148)
        ++offset;
    if (num > 155)
        ++offset;
    if (num > 160)
        ++offset;
    if (num > 161)
        ++offset;
    if (num > 166)
        ++offset;
    if (num > 167)
        ++offset;
    return num - 1 + offset;
}
function getSpacegroupNumberFromIndex(idx) {
    if (idx < 146)
        return idx + 1;
    if (idx === 146)
        return 1146;
    if (idx < 149)
        return idx + 1 - 1;
    if (idx === 149)
        return 1148;
    if (idx < 157)
        return idx + 1 - 2;
    if (idx === 157)
        return 1155;
    if (idx < 163)
        return idx + 1 - 3;
    if (idx === 163)
        return 1160;
    if (idx < 165)
        return idx + 1 - 4;
    if (idx === 165)
        return 1161;
    if (idx < 171)
        return idx + 1 - 5;
    if (idx === 171)
        return 1166;
    if (idx < 173)
        return idx + 1 - 6;
    if (idx === 173)
        return 1167;
    if (idx < 237)
        return idx + 1 - 7;
    if (idx === 237)
        return 1003;
    if (idx === 238)
        return 1004;
    if (idx === 239)
        return 1005;
    if (idx === 240)
        return 2005;
    if (idx === 241)
        return 3005;
    if (idx === 242)
        return 4005;
    if (idx === 243)
        return 5005;
    if (idx === 244)
        return 1006;
    if (idx === 245)
        return 1007;
    if (idx === 246)
        return 1008;
    if (idx === 247)
        return 1009;
    if (idx === 248)
        return 1010;
    if (idx === 249)
        return 1011;
    if (idx === 250)
        return 1012;
    if (idx === 251)
        return 1013;
    if (idx === 252)
        return 1014;
    if (idx === 253)
        return 2014;
    if (idx === 254)
        return 3014;
    if (idx === 255)
        return 1015;
    if (idx === 256)
        return 1017;
    if (idx === 257)
        return 2017;
    if (idx === 258)
        return 1018;
    if (idx === 259)
        return 2018;
    if (idx === 260)
        return 3018;
    if (idx === 261)
        return 1020;
    if (idx === 262)
        return 1021;
    if (idx === 263)
        return 1022;
    if (idx === 264)
        return 1023;
    if (idx === 265)
        return 1059;
    if (idx === 266)
        return 1094;
    if (idx === 267)
        return 1197;
    throw new Error("unknown spacegroup index '" + idx + "'");
}
/** Maps spacegroup index to Hermann-Mauguin spacegroup name */
var SpacegroupName = (function () {
    var names = Object.create(null);
    for (var _i = 0, _a = Object.keys(SpacegroupNameToIndexMap); _i < _a.length; _i++) {
        var n = _a[_i];
        names[SpacegroupNameToIndexMap[n]] = n;
    }
    return names;
}());
/** Maps spacegroup index to spacegroup number from International Tables for Crystallography */
var SpacegroupNumber = (function () {
    var numbers = Object.create(null);
    for (var _i = 0, _a = Object.keys(SpacegroupNameToIndexMap); _i < _a.length; _i++) {
        var n = _a[_i];
        var idx = SpacegroupNameToIndexMap[n];
        numbers[idx] = getSpacegroupNumberFromIndex(idx);
    }
    return numbers;
}());
/** return -1 if the spacegroup does not exist */
function getSpacegroupIndex(nameOrNumber) {
    var index = typeof nameOrNumber === 'number'
        ? getSpacegroupIndexFromNumber(nameOrNumber)
        : SpacegroupNameToIndexMap[nameOrNumber];
    if (typeof index === 'undefined' || typeof SpacegroupName[index] === 'undefined')
        return -1;
    return index;
}
//# sourceMappingURL=tables.js.map

/***/ }),

/***/ "./lib/mol-math/geometry/symmetry-operator.js":
/*!****************************************************!*\
  !*** ./lib/mol-math/geometry/symmetry-operator.js ***!
  \****************************************************/
/*! exports provided: SymmetryOperator */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SymmetryOperator", function() { return SymmetryOperator; });
/* harmony import */ var _linear_algebra_3d__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../linear-algebra/3d */ "./lib/mol-math/linear-algebra/3d.js");
/* harmony import */ var _mol_math_interpolate__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../mol-math/interpolate */ "./lib/mol-math/interpolate.js");
/* harmony import */ var _mol_util__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../mol-util */ "./lib/mol-util/index.js");
/**
 * Copyright (c) 2017 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author David Sehnal <david.sehnal@gmail.com>
 */



var SymmetryOperator;
(function (SymmetryOperator) {
    SymmetryOperator.DefaultName = '1_555';
    SymmetryOperator.Default = create(SymmetryOperator.DefaultName, _linear_algebra_3d__WEBPACK_IMPORTED_MODULE_0__["Mat4"].identity());
    SymmetryOperator.RotationTranslationEpsilon = 0.005;
    function create(name, matrix, info) {
        var _a = info || {}, assembly = _a.assembly, ncsId = _a.ncsId, hkl = _a.hkl, spgrOp = _a.spgrOp;
        var _hkl = hkl ? _linear_algebra_3d__WEBPACK_IMPORTED_MODULE_0__["Vec3"].clone(hkl) : _linear_algebra_3d__WEBPACK_IMPORTED_MODULE_0__["Vec3"].zero();
        spgrOp = Object(_mol_util__WEBPACK_IMPORTED_MODULE_2__["defaults"])(spgrOp, -1);
        ncsId = ncsId || -1;
        var suffix = getSuffix(info);
        if (_linear_algebra_3d__WEBPACK_IMPORTED_MODULE_0__["Mat4"].isIdentity(matrix))
            return { name: name, assembly: assembly, matrix: matrix, inverse: _linear_algebra_3d__WEBPACK_IMPORTED_MODULE_0__["Mat4"].identity(), isIdentity: true, hkl: _hkl, spgrOp: spgrOp, ncsId: ncsId, suffix: suffix };
        if (!_linear_algebra_3d__WEBPACK_IMPORTED_MODULE_0__["Mat4"].isRotationAndTranslation(matrix, SymmetryOperator.RotationTranslationEpsilon))
            throw new Error("Symmetry operator (" + name + ") must be a composition of rotation and translation.");
        return { name: name, assembly: assembly, matrix: matrix, inverse: _linear_algebra_3d__WEBPACK_IMPORTED_MODULE_0__["Mat4"].invert(_linear_algebra_3d__WEBPACK_IMPORTED_MODULE_0__["Mat4"].zero(), matrix), isIdentity: false, hkl: _hkl, spgrOp: spgrOp, ncsId: ncsId, suffix: suffix };
    }
    SymmetryOperator.create = create;
    function getSuffix(info) {
        if (!info)
            return '';
        if (info.assembly) {
            return "_" + info.assembly.operId;
        }
        if (typeof info.spgrOp !== 'undefined' && typeof info.hkl !== 'undefined' && info.spgrOp !== -1) {
            var _a = info.hkl, i = _a[0], j = _a[1], k = _a[2];
            return "-" + (info.spgrOp + 1) + "_" + (5 + i) + (5 + j) + (5 + k);
        }
        if (info.ncsId !== -1) {
            return "_" + info.ncsId;
        }
        return '';
    }
    function checkIfRotationAndTranslation(rot, offset) {
        var matrix = _linear_algebra_3d__WEBPACK_IMPORTED_MODULE_0__["Mat4"].identity();
        for (var i = 0; i < 3; i++) {
            for (var j = 0; j < 3; j++) {
                _linear_algebra_3d__WEBPACK_IMPORTED_MODULE_0__["Mat4"].setValue(matrix, i, j, _linear_algebra_3d__WEBPACK_IMPORTED_MODULE_0__["Mat3"].getValue(rot, i, j));
            }
        }
        _linear_algebra_3d__WEBPACK_IMPORTED_MODULE_0__["Mat4"].setTranslation(matrix, offset);
        return _linear_algebra_3d__WEBPACK_IMPORTED_MODULE_0__["Mat4"].isRotationAndTranslation(matrix, SymmetryOperator.RotationTranslationEpsilon);
    }
    SymmetryOperator.checkIfRotationAndTranslation = checkIfRotationAndTranslation;
    function ofRotationAndOffset(name, rot, offset, ncsId) {
        var t = _linear_algebra_3d__WEBPACK_IMPORTED_MODULE_0__["Mat4"].identity();
        for (var i = 0; i < 3; i++) {
            for (var j = 0; j < 3; j++) {
                _linear_algebra_3d__WEBPACK_IMPORTED_MODULE_0__["Mat4"].setValue(t, i, j, _linear_algebra_3d__WEBPACK_IMPORTED_MODULE_0__["Mat3"].getValue(rot, i, j));
            }
        }
        _linear_algebra_3d__WEBPACK_IMPORTED_MODULE_0__["Mat4"].setTranslation(t, offset);
        return create(name, t, { ncsId: ncsId });
    }
    SymmetryOperator.ofRotationAndOffset = ofRotationAndOffset;
    var _q1 = _linear_algebra_3d__WEBPACK_IMPORTED_MODULE_0__["Quat"].identity(), _q2 = _linear_algebra_3d__WEBPACK_IMPORTED_MODULE_0__["Quat"].zero(), _q3 = _linear_algebra_3d__WEBPACK_IMPORTED_MODULE_0__["Quat"].zero(), _axis = _linear_algebra_3d__WEBPACK_IMPORTED_MODULE_0__["Vec3"].zero();
    function lerpFromIdentity(out, op, t) {
        var m = op.inverse;
        if (op.isIdentity)
            return _linear_algebra_3d__WEBPACK_IMPORTED_MODULE_0__["Mat4"].copy(out, m);
        var _t = 1 - t;
        // interpolate rotation
        _linear_algebra_3d__WEBPACK_IMPORTED_MODULE_0__["Mat4"].getRotation(_q2, m);
        _linear_algebra_3d__WEBPACK_IMPORTED_MODULE_0__["Quat"].slerp(_q2, _q1, _q2, _t);
        var angle = _linear_algebra_3d__WEBPACK_IMPORTED_MODULE_0__["Quat"].getAxisAngle(_axis, _q2);
        _linear_algebra_3d__WEBPACK_IMPORTED_MODULE_0__["Mat4"].fromRotation(out, angle, _axis);
        // interpolate translation
        _linear_algebra_3d__WEBPACK_IMPORTED_MODULE_0__["Mat4"].setValue(out, 0, 3, _t * _linear_algebra_3d__WEBPACK_IMPORTED_MODULE_0__["Mat4"].getValue(m, 0, 3));
        _linear_algebra_3d__WEBPACK_IMPORTED_MODULE_0__["Mat4"].setValue(out, 1, 3, _t * _linear_algebra_3d__WEBPACK_IMPORTED_MODULE_0__["Mat4"].getValue(m, 1, 3));
        _linear_algebra_3d__WEBPACK_IMPORTED_MODULE_0__["Mat4"].setValue(out, 2, 3, _t * _linear_algebra_3d__WEBPACK_IMPORTED_MODULE_0__["Mat4"].getValue(m, 2, 3));
        return out;
    }
    SymmetryOperator.lerpFromIdentity = lerpFromIdentity;
    function slerp(out, src, tar, t) {
        if (Math.abs(t) <= 0.00001)
            return _linear_algebra_3d__WEBPACK_IMPORTED_MODULE_0__["Mat4"].copy(out, src);
        if (Math.abs(t - 1) <= 0.00001)
            return _linear_algebra_3d__WEBPACK_IMPORTED_MODULE_0__["Mat4"].copy(out, tar);
        // interpolate rotation
        _linear_algebra_3d__WEBPACK_IMPORTED_MODULE_0__["Mat4"].getRotation(_q2, src);
        _linear_algebra_3d__WEBPACK_IMPORTED_MODULE_0__["Mat4"].getRotation(_q3, tar);
        _linear_algebra_3d__WEBPACK_IMPORTED_MODULE_0__["Quat"].slerp(_q3, _q2, _q3, t);
        var angle = _linear_algebra_3d__WEBPACK_IMPORTED_MODULE_0__["Quat"].getAxisAngle(_axis, _q3);
        _linear_algebra_3d__WEBPACK_IMPORTED_MODULE_0__["Mat4"].fromRotation(out, angle, _axis);
        // interpolate translation
        _linear_algebra_3d__WEBPACK_IMPORTED_MODULE_0__["Mat4"].setValue(out, 0, 3, Object(_mol_math_interpolate__WEBPACK_IMPORTED_MODULE_1__["lerp"])(_linear_algebra_3d__WEBPACK_IMPORTED_MODULE_0__["Mat4"].getValue(src, 0, 3), _linear_algebra_3d__WEBPACK_IMPORTED_MODULE_0__["Mat4"].getValue(tar, 0, 3), t));
        _linear_algebra_3d__WEBPACK_IMPORTED_MODULE_0__["Mat4"].setValue(out, 1, 3, Object(_mol_math_interpolate__WEBPACK_IMPORTED_MODULE_1__["lerp"])(_linear_algebra_3d__WEBPACK_IMPORTED_MODULE_0__["Mat4"].getValue(src, 1, 3), _linear_algebra_3d__WEBPACK_IMPORTED_MODULE_0__["Mat4"].getValue(tar, 1, 3), t));
        _linear_algebra_3d__WEBPACK_IMPORTED_MODULE_0__["Mat4"].setValue(out, 2, 3, Object(_mol_math_interpolate__WEBPACK_IMPORTED_MODULE_1__["lerp"])(_linear_algebra_3d__WEBPACK_IMPORTED_MODULE_0__["Mat4"].getValue(src, 2, 3), _linear_algebra_3d__WEBPACK_IMPORTED_MODULE_0__["Mat4"].getValue(tar, 2, 3), t));
        return out;
    }
    SymmetryOperator.slerp = slerp;
    /**
     * Apply the 1st and then 2nd operator. ( = second.matrix * first.matrix).
     * Keep `name`, `assembly`, `ncsId`, `hkl` and `spgrOpId` properties from second.
     */
    function compose(first, second) {
        var matrix = _linear_algebra_3d__WEBPACK_IMPORTED_MODULE_0__["Mat4"].mul(_linear_algebra_3d__WEBPACK_IMPORTED_MODULE_0__["Mat4"].zero(), second.matrix, first.matrix);
        return create(second.name, matrix, second);
    }
    SymmetryOperator.compose = compose;
    function createMapping(operator, coords, radius) {
        var invariantPosition = SymmetryOperator.createCoordinateMapper(SymmetryOperator.Default, coords);
        var position = operator.isIdentity ? invariantPosition : SymmetryOperator.createCoordinateMapper(operator, coords);
        var _a = createProjections(operator, coords), x = _a.x, y = _a.y, z = _a.z;
        return { operator: operator, coordinates: coords, invariantPosition: invariantPosition, position: position, x: x, y: y, z: z, r: radius ? radius : _zeroRadius };
    }
    SymmetryOperator.createMapping = createMapping;
    function createCoordinateMapper(t, coords) {
        if (t.isIdentity)
            return identityPosition(coords);
        return generalPosition(t, coords);
    }
    SymmetryOperator.createCoordinateMapper = createCoordinateMapper;
})(SymmetryOperator || (SymmetryOperator = {}));

function _zeroRadius(i) { return 0; }
function createProjections(t, coords) {
    if (t.isIdentity)
        return { x: projectCoord(coords.x), y: projectCoord(coords.y), z: projectCoord(coords.z) };
    return { x: projectX(t, coords), y: projectY(t, coords), z: projectZ(t, coords) };
}
function projectCoord(xs) {
    return function projectCoord(i) {
        return xs[i];
    };
}
function isW1(m) {
    return m[3] === 0 && m[7] === 0 && m[11] === 0 && m[15] === 1;
}
function projectX(_a, _b) {
    var m = _a.matrix;
    var xs = _b.x, ys = _b.y, zs = _b.z;
    var xx = m[0], yy = m[4], zz = m[8], tx = m[12];
    if (isW1(m)) {
        // this should always be the case.
        return function projectX_W1(i) {
            return xx * xs[i] + yy * ys[i] + zz * zs[i] + tx;
        };
    }
    return function projectX(i) {
        var x = xs[i], y = ys[i], z = zs[i], w = (m[3] * x + m[7] * y + m[11] * z + m[15]) || 1.0;
        return (xx * x + yy * y + zz * z + tx) / w;
    };
}
function projectY(_a, _b) {
    var m = _a.matrix;
    var xs = _b.x, ys = _b.y, zs = _b.z;
    var xx = m[1], yy = m[5], zz = m[9], ty = m[13];
    if (isW1(m)) {
        // this should always be the case.
        return function projectY_W1(i) {
            return xx * xs[i] + yy * ys[i] + zz * zs[i] + ty;
        };
    }
    return function projectY(i) {
        var x = xs[i], y = ys[i], z = zs[i], w = (m[3] * x + m[7] * y + m[11] * z + m[15]) || 1.0;
        return (xx * x + yy * y + zz * z + ty) / w;
    };
}
function projectZ(_a, _b) {
    var m = _a.matrix;
    var xs = _b.x, ys = _b.y, zs = _b.z;
    var xx = m[2], yy = m[6], zz = m[10], tz = m[14];
    if (isW1(m)) {
        // this should always be the case.
        return function projectZ_W1(i) {
            return xx * xs[i] + yy * ys[i] + zz * zs[i] + tz;
        };
    }
    return function projectZ(i) {
        var x = xs[i], y = ys[i], z = zs[i], w = (m[3] * x + m[7] * y + m[11] * z + m[15]) || 1.0;
        return (xx * x + yy * y + zz * z + tz) / w;
    };
}
function identityPosition(_a) {
    var x = _a.x, y = _a.y, z = _a.z;
    return function identityPosition(i, s) {
        s[0] = x[i];
        s[1] = y[i];
        s[2] = z[i];
        return s;
    };
}
function generalPosition(_a, _b) {
    var m = _a.matrix;
    var xs = _b.x, ys = _b.y, zs = _b.z;
    if (isW1(m)) {
        // this should always be the case.
        return function generalPosition_W1(i, r) {
            var x = xs[i], y = ys[i], z = zs[i];
            r[0] = m[0] * x + m[4] * y + m[8] * z + m[12];
            r[1] = m[1] * x + m[5] * y + m[9] * z + m[13];
            r[2] = m[2] * x + m[6] * y + m[10] * z + m[14];
            return r;
        };
    }
    return function generalPosition(i, r) {
        r[0] = xs[i];
        r[1] = ys[i];
        r[2] = zs[i];
        _linear_algebra_3d__WEBPACK_IMPORTED_MODULE_0__["Vec3"].transformMat4(r, r, m);
        return r;
    };
}
//# sourceMappingURL=symmetry-operator.js.map

/***/ }),

/***/ "./lib/mol-math/graph.js":
/*!*******************************!*\
  !*** ./lib/mol-math/graph.js ***!
  \*******************************/
/*! exports provided: IntAdjacencyGraph */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _graph_int_adjacency_graph__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./graph/int-adjacency-graph */ "./lib/mol-math/graph/int-adjacency-graph.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "IntAdjacencyGraph", function() { return _graph_int_adjacency_graph__WEBPACK_IMPORTED_MODULE_0__["IntAdjacencyGraph"]; });

/**
 * Copyright (c) 2018 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author David Sehnal <david.sehnal@gmail.com>
 */

//# sourceMappingURL=graph.js.map

/***/ }),

/***/ "./lib/mol-math/graph/int-adjacency-graph.js":
/*!***************************************************!*\
  !*** ./lib/mol-math/graph/int-adjacency-graph.js ***!
  \***************************************************/
/*! exports provided: IntAdjacencyGraph */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "IntAdjacencyGraph", function() { return IntAdjacencyGraph; });
/* harmony import */ var _mol_data_util__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../mol-data/util */ "./lib/mol-data/util.js");
/* harmony import */ var _mol_data_int__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../mol-data/int */ "./lib/mol-data/int.js");
/**
 * Copyright (c) 2018-2020 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author David Sehnal <david.sehnal@gmail.com>
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */


var IntAdjacencyGraph;
(function (IntAdjacencyGraph) {
    function areEqual(a, b) {
        if (a === b)
            return true;
        if (a.vertexCount !== b.vertexCount || a.edgeCount !== b.edgeCount)
            return false;
        var aa = a.a, ab = a.b, ao = a.offset;
        var ba = b.a, bb = b.b, bo = b.offset;
        for (var i = 0, _i = a.a.length; i < _i; i++) {
            if (aa[i] !== ba[i])
                return false;
        }
        for (var i = 0, _i = a.b.length; i < _i; i++) {
            if (ab[i] !== bb[i])
                return false;
        }
        for (var i = 0, _i = a.offset.length; i < _i; i++) {
            if (ao[i] !== bo[i])
                return false;
        }
        for (var _a = 0, _b = Object.keys(a.edgeProps); _a < _b.length; _a++) {
            var k = _b[_a];
            var pa = a.edgeProps[k], pb = b.edgeProps[k];
            if (!pb)
                return false;
            for (var i = 0, _i = pa.length; i < _i; i++) {
                if (pa[i] !== pb[i])
                    return false;
            }
        }
        return true;
    }
    IntAdjacencyGraph.areEqual = areEqual;
    var IntGraphImpl = /** @class */ (function () {
        function IntGraphImpl(offset, a, b, edgeCount, edgeProps, props) {
            this.offset = offset;
            this.a = a;
            this.b = b;
            this.edgeCount = edgeCount;
            this.props = props;
            this.vertexCount = offset.length - 1;
            this.edgeProps = (edgeProps || {});
        }
        IntGraphImpl.prototype.getEdgeIndex = function (i, j) {
            var a, b;
            if (i < j) {
                a = i;
                b = j;
            }
            else {
                a = j;
                b = i;
            }
            for (var t = this.offset[a], _t = this.offset[a + 1]; t < _t; t++) {
                if (this.b[t] === b)
                    return t;
            }
            return -1;
        };
        IntGraphImpl.prototype.getDirectedEdgeIndex = function (i, j) {
            for (var t = this.offset[i], _t = this.offset[i + 1]; t < _t; t++) {
                if (this.b[t] === j)
                    return t;
            }
            return -1;
        };
        IntGraphImpl.prototype.getVertexEdgeCount = function (i) {
            return this.offset[i + 1] - this.offset[i];
        };
        return IntGraphImpl;
    }());
    function create(offset, a, b, edgeCount, edgeProps, props) {
        return new IntGraphImpl(offset, a, b, edgeCount, edgeProps, props);
    }
    IntAdjacencyGraph.create = create;
    var EdgeBuilder = /** @class */ (function () {
        function EdgeBuilder(vertexCount, xs, ys) {
            this.vertexCount = vertexCount;
            this.xs = xs;
            this.ys = ys;
            this.current = 0;
            this.curA = 0;
            this.curB = 0;
            this.edgeCount = xs.length;
            this.offsets = new Int32Array(this.vertexCount + 1);
            this.bucketFill = new Int32Array(this.vertexCount);
            var bucketSizes = new Int32Array(this.vertexCount);
            for (var i = 0, _i = this.xs.length; i < _i; i++)
                bucketSizes[this.xs[i]]++;
            for (var i = 0, _i = this.ys.length; i < _i; i++)
                bucketSizes[this.ys[i]]++;
            var offset = 0;
            for (var i = 0; i < this.vertexCount; i++) {
                this.offsets[i] = offset;
                offset += bucketSizes[i];
            }
            this.offsets[this.vertexCount] = offset;
            this.slotCount = offset;
            this.a = new Int32Array(offset);
            this.b = new Int32Array(offset);
        }
        EdgeBuilder.prototype.createGraph = function (edgeProps, props) {
            return create(this.offsets, this.a, this.b, this.edgeCount, edgeProps, props);
        };
        /**
         * @example
         *   const property = new Int32Array(builder.slotCount);
         *   for (let i = 0; i < builder.edgeCount; i++) {
         *     builder.addNextEdge();
         *     builder.assignProperty(property, srcProp[i]);
         *   }
         *   return builder.createGraph({ property });
         */
        EdgeBuilder.prototype.addNextEdge = function () {
            var a = this.xs[this.current], b = this.ys[this.current];
            var oa = this.offsets[a] + this.bucketFill[a];
            var ob = this.offsets[b] + this.bucketFill[b];
            this.a[oa] = a;
            this.b[oa] = b;
            this.bucketFill[a]++;
            this.a[ob] = b;
            this.b[ob] = a;
            this.bucketFill[b]++;
            this.current++;
            this.curA = oa;
            this.curB = ob;
        };
        /** Builds property-less graph */
        EdgeBuilder.prototype.addAllEdges = function () {
            for (var i = 0; i < this.edgeCount; i++) {
                this.addNextEdge();
            }
        };
        EdgeBuilder.prototype.assignProperty = function (prop, value) {
            prop[this.curA] = value;
            prop[this.curB] = value;
        };
        return EdgeBuilder;
    }());
    IntAdjacencyGraph.EdgeBuilder = EdgeBuilder;
    var DirectedEdgeBuilder = /** @class */ (function () {
        function DirectedEdgeBuilder(vertexCount, xs, ys) {
            this.vertexCount = vertexCount;
            this.xs = xs;
            this.ys = ys;
            this.current = 0;
            this.curA = 0;
            this.edgeCount = xs.length;
            this.offsets = new Int32Array(this.vertexCount + 1);
            this.bucketFill = new Int32Array(this.vertexCount);
            var bucketSizes = new Int32Array(this.vertexCount);
            for (var i = 0, _i = this.xs.length; i < _i; i++)
                bucketSizes[this.xs[i]]++;
            var offset = 0;
            for (var i = 0; i < this.vertexCount; i++) {
                this.offsets[i] = offset;
                offset += bucketSizes[i];
            }
            this.offsets[this.vertexCount] = offset;
            this.slotCount = offset;
            this.a = new Int32Array(offset);
            this.b = new Int32Array(offset);
        }
        DirectedEdgeBuilder.prototype.createGraph = function (edgeProps) {
            return create(this.offsets, this.a, this.b, this.edgeCount, edgeProps);
        };
        /**
         * @example
         *   const property = new Int32Array(builder.slotCount);
         *   for (let i = 0; i < builder.edgeCount; i++) {
         *     builder.addNextEdge();
         *     builder.assignProperty(property, srcProp[i]);
         *   }
         *   return builder.createGraph({ property });
         */
        DirectedEdgeBuilder.prototype.addNextEdge = function () {
            var a = this.xs[this.current], b = this.ys[this.current];
            var oa = this.offsets[a] + this.bucketFill[a];
            this.a[oa] = a;
            this.b[oa] = b;
            this.bucketFill[a]++;
            this.current++;
            this.curA = oa;
        };
        /** Builds property-less graph */
        DirectedEdgeBuilder.prototype.addAllEdges = function () {
            for (var i = 0; i < this.edgeCount; i++) {
                this.addNextEdge();
            }
        };
        DirectedEdgeBuilder.prototype.assignProperty = function (prop, value) {
            prop[this.curA] = value;
        };
        return DirectedEdgeBuilder;
    }());
    IntAdjacencyGraph.DirectedEdgeBuilder = DirectedEdgeBuilder;
    var UniqueEdgeBuilder = /** @class */ (function () {
        function UniqueEdgeBuilder(vertexCount) {
            this.vertexCount = vertexCount;
            this.xs = [];
            this.ys = [];
            this.included = new Set();
        }
        UniqueEdgeBuilder.prototype.addEdge = function (i, j) {
            var u = i, v = j;
            if (i > j) {
                u = j;
                v = i;
            }
            var id = Object(_mol_data_util__WEBPACK_IMPORTED_MODULE_0__["cantorPairing"])(u, v);
            if (this.included.has(id))
                return false;
            this.included.add(id);
            this.xs[this.xs.length] = u;
            this.ys[this.ys.length] = v;
            return true;
        };
        UniqueEdgeBuilder.prototype.getGraph = function () {
            return fromVertexPairs(this.vertexCount, this.xs, this.ys);
        };
        // if we cant to add custom props as well
        UniqueEdgeBuilder.prototype.getEdgeBuiler = function () {
            return new EdgeBuilder(this.vertexCount, this.xs, this.ys);
        };
        return UniqueEdgeBuilder;
    }());
    IntAdjacencyGraph.UniqueEdgeBuilder = UniqueEdgeBuilder;
    function fromVertexPairs(vertexCount, xs, ys) {
        var graphBuilder = new IntAdjacencyGraph.EdgeBuilder(vertexCount, xs, ys);
        graphBuilder.addAllEdges();
        return graphBuilder.createGraph({});
    }
    IntAdjacencyGraph.fromVertexPairs = fromVertexPairs;
    function induceByVertices(graph, vertexIndices) {
        var b = graph.b, offset = graph.offset, vertexCount = graph.vertexCount, edgeProps = graph.edgeProps;
        var vertexMap = new Int32Array(vertexCount);
        for (var i = 0, _i = vertexIndices.length; i < _i; i++)
            vertexMap[vertexIndices[i]] = i + 1;
        var newEdgeCount = 0;
        for (var i = 0; i < vertexCount; i++) {
            if (vertexMap[i] === 0)
                continue;
            for (var j = offset[i], _j = offset[i + 1]; j < _j; j++) {
                if (b[j] > i && vertexMap[b[j]] !== 0)
                    newEdgeCount++;
            }
        }
        var newOffsets = new Int32Array(vertexIndices.length + 1);
        var edgeIndices = new Int32Array(2 * newEdgeCount);
        var newA = new Int32Array(2 * newEdgeCount);
        var newB = new Int32Array(2 * newEdgeCount);
        var eo = 0, vo = 0;
        for (var i = 0; i < vertexCount; i++) {
            if (vertexMap[i] === 0)
                continue;
            var aa = vertexMap[i] - 1;
            for (var j = offset[i], _j = offset[i + 1]; j < _j; j++) {
                var bb = vertexMap[b[j]];
                if (bb === 0)
                    continue;
                newA[eo] = aa;
                newB[eo] = bb - 1;
                edgeIndices[eo] = j;
                eo++;
            }
            newOffsets[++vo] = eo;
        }
        var newEdgeProps = {};
        for (var _a = 0, _b = Object.keys(edgeProps); _a < _b.length; _a++) {
            var key = _b[_a];
            newEdgeProps[key] = Object(_mol_data_util__WEBPACK_IMPORTED_MODULE_0__["arrayPickIndices"])(edgeProps[key], edgeIndices);
        }
        return create(newOffsets, newA, newB, newEdgeCount, newEdgeProps);
    }
    IntAdjacencyGraph.induceByVertices = induceByVertices;
    function connectedComponents(graph) {
        var vCount = graph.vertexCount;
        if (vCount === 0)
            return { componentCount: 0, componentIndex: new Int32Array(0) };
        if (graph.edgeCount === 0) {
            var componentIndex_1 = new Int32Array(vCount);
            for (var i = 0, _i = vCount; i < _i; i++) {
                componentIndex_1[i] = i;
            }
            return { componentCount: vCount, componentIndex: componentIndex_1 };
        }
        var componentIndex = new Int32Array(vCount);
        for (var i = 0, _i = vCount; i < _i; i++)
            componentIndex[i] = -1;
        var currentComponent = 0;
        componentIndex[0] = currentComponent;
        var offset = graph.offset, neighbor = graph.b;
        var stack = [0];
        var list = Object(_mol_data_int__WEBPACK_IMPORTED_MODULE_1__["LinkedIndex"])(vCount);
        list.remove(0);
        while (stack.length > 0) {
            var v = stack.pop();
            var cIdx = componentIndex[v];
            for (var eI = offset[v], _eI = offset[v + 1]; eI < _eI; eI++) {
                var n = neighbor[eI];
                if (!list.has(n))
                    continue;
                list.remove(n);
                stack.push(n);
                componentIndex[n] = cIdx;
            }
            // check if we visited all vertices.
            // If not, create a new component and continue.
            if (stack.length === 0 && list.head >= 0) {
                stack.push(list.head);
                componentIndex[list.head] = ++currentComponent;
                list.remove(list.head);
            }
        }
        return { componentCount: vCount, componentIndex: componentIndex };
    }
    IntAdjacencyGraph.connectedComponents = connectedComponents;
    /**
     * Check if any vertex in `verticesA` is connected to any vertex in `verticesB`
     * via at most `maxDistance` edges.
     *
     * Returns true if verticesA and verticesB are intersecting.
     */
    function areVertexSetsConnected(graph, verticesA, verticesB, maxDistance) {
        // check if A and B are intersecting, this handles maxDistance = 0
        if (_mol_data_int__WEBPACK_IMPORTED_MODULE_1__["SortedArray"].areIntersecting(verticesA, verticesB))
            return true;
        if (maxDistance < 1)
            return false;
        var visited = new Set();
        for (var i = 0, il = verticesA.length; i < il; ++i) {
            visited.add(verticesA[i]);
        }
        return areVertexSetsConnectedImpl(graph, verticesA, verticesB, maxDistance, visited);
    }
    IntAdjacencyGraph.areVertexSetsConnected = areVertexSetsConnected;
})(IntAdjacencyGraph || (IntAdjacencyGraph = {}));
function areVertexSetsConnectedImpl(graph, frontier, target, distance, visited) {
    var neighbor = graph.b, offset = graph.offset;
    var newFrontier = [];
    for (var i = 0, il = frontier.length; i < il; ++i) {
        var src = frontier[i];
        for (var j = offset[src], jl = offset[src + 1]; j < jl; ++j) {
            var other = neighbor[j];
            if (visited.has(other))
                continue;
            if (_mol_data_int__WEBPACK_IMPORTED_MODULE_1__["SortedArray"].has(target, other))
                return true;
            visited.add(other);
            newFrontier[newFrontier.length] = other;
        }
    }
    return distance > 1 ? areVertexSetsConnectedImpl(graph, newFrontier, target, distance - 1, visited) : false;
}
//# sourceMappingURL=int-adjacency-graph.js.map

/***/ }),

/***/ "./lib/mol-math/graph/inter-unit-graph.js":
/*!************************************************!*\
  !*** ./lib/mol-math/graph/inter-unit-graph.js ***!
  \************************************************/
/*! exports provided: InterUnitGraph */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "InterUnitGraph", function() { return InterUnitGraph; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _mol_data_generic__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../mol-data/generic */ "./lib/mol-data/generic.js");
/**
 * Copyright (c) 2017-2020 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author David Sehnal <david.sehnal@gmail.com>
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */



var InterUnitGraph = /** @class */ (function () {
    function InterUnitGraph(map) {
        this.map = map;
        var count = 0;
        var edges = [];
        var edgeKeyIndex = new Map();
        var vertexKeyIndex = new Map();
        this.map.forEach(function (pairEdgesArray) {
            pairEdgesArray.forEach(function (pairEdges) {
                count += pairEdges.edgeCount;
                pairEdges.connectedIndices.forEach(function (indexA) {
                    pairEdges.getEdges(indexA).forEach(function (edgeInfo) {
                        var unitA = pairEdges.unitA, unitB = pairEdges.unitB;
                        var edgeKey = InterUnitGraph.getEdgeKey(indexA, unitA, edgeInfo.indexB, unitB);
                        edgeKeyIndex.set(edgeKey, edges.length);
                        var vertexKey = InterUnitGraph.getVertexKey(indexA, unitA);
                        var e = vertexKeyIndex.get(vertexKey);
                        if (e === undefined)
                            vertexKeyIndex.set(vertexKey, [edges.length]);
                        else
                            e.push(edges.length);
                        edges.push(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, edgeInfo), { indexA: indexA, unitA: unitA, unitB: unitB }));
                    });
                });
            });
        });
        this.edgeCount = count;
        this.edges = edges;
        this.edgeKeyIndex = edgeKeyIndex;
        this.vertexKeyIndex = vertexKeyIndex;
    }
    /** Get an array of unit-pair-edges that are connected to the given unit */
    InterUnitGraph.prototype.getConnectedUnits = function (unit) {
        if (!this.map.has(unit))
            return emptyArray;
        return this.map.get(unit);
    };
    /** Index into this.edges */
    InterUnitGraph.prototype.getEdgeIndex = function (indexA, unitA, indexB, unitB) {
        var edgeKey = InterUnitGraph.getEdgeKey(indexA, unitA, indexB, unitB);
        var index = this.edgeKeyIndex.get(edgeKey);
        return index !== undefined ? index : -1;
    };
    /** Check if edge exists */
    InterUnitGraph.prototype.hasEdge = function (indexA, unitA, indexB, unitB) {
        return this.getEdgeIndex(indexA, unitA, indexB, unitB) !== -1;
    };
    /** Get inter-unit edge given a pair of indices and units */
    InterUnitGraph.prototype.getEdge = function (indexA, unitA, indexB, unitB) {
        var index = this.getEdgeIndex(indexA, unitA, indexB, unitB);
        return index !== -1 ? this.edges[index] : undefined;
    };
    /** Indices into this.edges */
    InterUnitGraph.prototype.getEdgeIndices = function (index, unit) {
        return this.vertexKeyIndex.get(InterUnitGraph.getVertexKey(index, unit)) || [];
    };
    return InterUnitGraph;
}());
(function (InterUnitGraph) {
    var UnitPairEdges = /** @class */ (function () {
        function UnitPairEdges(unitA, unitB, edgeCount, connectedIndices, edgeMap) {
            this.unitA = unitA;
            this.unitB = unitB;
            this.edgeCount = edgeCount;
            this.connectedIndices = connectedIndices;
            this.edgeMap = edgeMap;
        }
        UnitPairEdges.prototype.hasEdges = function (indexA) {
            return this.edgeMap.has(indexA);
        };
        UnitPairEdges.prototype.getEdges = function (indexA) {
            if (!this.edgeMap.has(indexA))
                return emptyArray;
            return this.edgeMap.get(indexA);
        };
        Object.defineProperty(UnitPairEdges.prototype, "areUnitsOrdered", {
            get: function () {
                return this.unitA < this.unitB;
            },
            enumerable: false,
            configurable: true
        });
        return UnitPairEdges;
    }());
    InterUnitGraph.UnitPairEdges = UnitPairEdges;
    function getEdgeKey(indexA, unitA, indexB, unitB) {
        return indexA + "|" + unitA + "|" + indexB + "|" + unitB;
    }
    InterUnitGraph.getEdgeKey = getEdgeKey;
    function getVertexKey(index, unit) {
        return index + "|" + unit;
    }
    InterUnitGraph.getVertexKey = getVertexKey;
    //
    function addMapEntry(map, a, b) {
        if (map.has(a))
            map.get(a).push(b);
        else
            map.set(a, [b]);
    }
    var Builder = /** @class */ (function () {
        function Builder() {
            this.map = new Map();
        }
        Builder.prototype.startUnitPair = function (unitA, unitB) {
            this.uA = unitA;
            this.uB = unitB;
            this.mapAB = new Map();
            this.mapBA = new Map();
            this.linkedA = _mol_data_generic__WEBPACK_IMPORTED_MODULE_1__["UniqueArray"].create();
            this.linkedB = _mol_data_generic__WEBPACK_IMPORTED_MODULE_1__["UniqueArray"].create();
            this.linkCount = 0;
        };
        Builder.prototype.finishUnitPair = function () {
            if (this.linkCount === 0)
                return;
            addMapEntry(this.map, this.uA, new UnitPairEdges(this.uA, this.uB, this.linkCount, this.linkedA.array, this.mapAB));
            addMapEntry(this.map, this.uB, new UnitPairEdges(this.uB, this.uA, this.linkCount, this.linkedB.array, this.mapBA));
        };
        Builder.prototype.add = function (indexA, indexB, props) {
            addMapEntry(this.mapAB, indexA, { indexB: indexB, props: props });
            addMapEntry(this.mapBA, indexB, { indexB: indexA, props: props });
            _mol_data_generic__WEBPACK_IMPORTED_MODULE_1__["UniqueArray"].add(this.linkedA, indexA, indexA);
            _mol_data_generic__WEBPACK_IMPORTED_MODULE_1__["UniqueArray"].add(this.linkedB, indexB, indexB);
            this.linkCount += 1;
        };
        Builder.prototype.getMap = function () {
            return this.map;
        };
        return Builder;
    }());
    InterUnitGraph.Builder = Builder;
})(InterUnitGraph || (InterUnitGraph = {}));
var emptyArray = [];
//# sourceMappingURL=inter-unit-graph.js.map

/***/ }),

/***/ "./lib/mol-math/histogram.js":
/*!***********************************!*\
  !*** ./lib/mol-math/histogram.js ***!
  \***********************************/
/*! exports provided: calculateHistogram */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "calculateHistogram", function() { return calculateHistogram; });
/* harmony import */ var _mol_util_array__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../mol-util/array */ "./lib/mol-util/array.js");
/**
 * Copyright (c) 2018-2019 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */

function calculateHistogram(data, binCount, options) {
    if (!options) {
        var _a = Object(_mol_util_array__WEBPACK_IMPORTED_MODULE_0__["arrayMinMax"])(data), min = _a[0], max = _a[1];
        return _calcHistogram(data, binCount, min, max);
    }
    else {
        return _calcHistogram(data, binCount, options.min, options.max);
    }
}
function _calcHistogram(data, binCount, min, max) {
    var binWidth = (max - min) / binCount;
    if (binWidth === 0)
        binWidth = 1;
    var counts = new Int32Array(binCount);
    for (var i = 0, _i = data.length; i < _i; i++) {
        var bin = Math.floor((data[i] - min) / binWidth);
        if (bin >= binCount)
            bin = binCount - 1;
        else if (bin < 0)
            bin = 0;
        counts[bin]++;
    }
    return { min: min, max: max, binWidth: binWidth, counts: counts };
}
//# sourceMappingURL=histogram.js.map

/***/ }),

/***/ "./lib/mol-math/interpolate.js":
/*!*************************************!*\
  !*** ./lib/mol-math/interpolate.js ***!
  \*************************************/
/*! exports provided: normalize, clamp, pclamp, saturate, damp, lerp, spline, quadraticBezier, smoothstep, smootherstep, smootheststep, almostIdentity */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "normalize", function() { return normalize; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "clamp", function() { return clamp; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "pclamp", function() { return pclamp; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "saturate", function() { return saturate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "damp", function() { return damp; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "lerp", function() { return lerp; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "spline", function() { return spline; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "quadraticBezier", function() { return quadraticBezier; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "smoothstep", function() { return smoothstep; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "smootherstep", function() { return smootherstep; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "smootheststep", function() { return smootheststep; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "almostIdentity", function() { return almostIdentity; });
/**
 * Copyright (c) 2018 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */
function normalize(value, min, max) {
    return (value - min) / (max - min);
}
function clamp(value, min, max) {
    return Math.max(min, Math.min(max, value));
}
function pclamp(value) {
    return clamp(value, 0, 100);
}
function saturate(value) {
    return clamp(value, 0, 1);
}
function damp(value, dampingFactor) {
    var dampedValue = value * dampingFactor;
    return Math.abs(dampedValue) < 0.1 ? 0 : dampedValue;
}
function lerp(start, stop, alpha) {
    return start + (stop - start) * alpha;
}
/** Catmul-Rom spline */
function spline(p0, p1, p2, p3, t, tension) {
    var v0 = (p2 - p0) * tension;
    var v1 = (p3 - p1) * tension;
    var t2 = t * t;
    var t3 = t * t2;
    return (2 * p1 - 2 * p2 + v0 + v1) * t3 + (-3 * p1 + 3 * p2 - 2 * v0 - v1) * t2 + v0 * t + p1;
}
function quadraticBezier(p0, p1, p2, t) {
    var k = 1 - t;
    return (k * k * p0) + (2 * k * t * p1) + (t * t * p2);
}
function smoothstep(min, max, x) {
    x = saturate(normalize(x, min, max));
    return x * x * (3 - 2 * x);
}
function smootherstep(min, max, x) {
    x = saturate(normalize(x, min, max));
    return x * x * x * (x * (x * 6 - 15) + 10);
}
function smootheststep(min, max, x) {
    x = saturate(normalize(x, min, max));
    return -20 * Math.pow(x, 7) + 70 * Math.pow(x, 6) - 84 * Math.pow(x, 5) + 35 * Math.pow(x, 4);
}
function almostIdentity(value, start, stop) {
    if (value > start)
        return value;
    var a = 2 * stop - start;
    var b = 2 * start - 3 * stop;
    var t = value / start;
    return (a * t + b) * t * t + stop;
}
//# sourceMappingURL=interpolate.js.map

/***/ }),

/***/ "./lib/mol-math/linear-algebra.js":
/*!****************************************!*\
  !*** ./lib/mol-math/linear-algebra.js ***!
  \****************************************/
/*! exports provided: Mat4, Mat3, Vec2, Vec3, Vec4, Quat, EPSILON, Tensor */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _linear_algebra_3d__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./linear-algebra/3d */ "./lib/mol-math/linear-algebra/3d.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Mat4", function() { return _linear_algebra_3d__WEBPACK_IMPORTED_MODULE_0__["Mat4"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Mat3", function() { return _linear_algebra_3d__WEBPACK_IMPORTED_MODULE_0__["Mat3"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Vec2", function() { return _linear_algebra_3d__WEBPACK_IMPORTED_MODULE_0__["Vec2"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Vec3", function() { return _linear_algebra_3d__WEBPACK_IMPORTED_MODULE_0__["Vec3"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Vec4", function() { return _linear_algebra_3d__WEBPACK_IMPORTED_MODULE_0__["Vec4"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Quat", function() { return _linear_algebra_3d__WEBPACK_IMPORTED_MODULE_0__["Quat"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "EPSILON", function() { return _linear_algebra_3d__WEBPACK_IMPORTED_MODULE_0__["EPSILON"]; });

/* harmony import */ var _linear_algebra_tensor__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./linear-algebra/tensor */ "./lib/mol-math/linear-algebra/tensor.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Tensor", function() { return _linear_algebra_tensor__WEBPACK_IMPORTED_MODULE_1__["Tensor"]; });

/**
 * Copyright (c) 2017 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author David Sehnal <david.sehnal@gmail.com>
 */


//# sourceMappingURL=linear-algebra.js.map

/***/ }),

/***/ "./lib/mol-math/linear-algebra/3d.js":
/*!*******************************************!*\
  !*** ./lib/mol-math/linear-algebra/3d.js ***!
  \*******************************************/
/*! exports provided: Mat4, Mat3, Vec2, Vec3, Vec4, Quat, EPSILON */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _3d_mat4__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./3d/mat4 */ "./lib/mol-math/linear-algebra/3d/mat4.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Mat4", function() { return _3d_mat4__WEBPACK_IMPORTED_MODULE_0__["default"]; });

/* harmony import */ var _3d_mat3__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./3d/mat3 */ "./lib/mol-math/linear-algebra/3d/mat3.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Mat3", function() { return _3d_mat3__WEBPACK_IMPORTED_MODULE_1__["default"]; });

/* harmony import */ var _3d_vec2__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./3d/vec2 */ "./lib/mol-math/linear-algebra/3d/vec2.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Vec2", function() { return _3d_vec2__WEBPACK_IMPORTED_MODULE_2__["default"]; });

/* harmony import */ var _3d_vec3__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./3d/vec3 */ "./lib/mol-math/linear-algebra/3d/vec3.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Vec3", function() { return _3d_vec3__WEBPACK_IMPORTED_MODULE_3__["default"]; });

/* harmony import */ var _3d_vec4__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./3d/vec4 */ "./lib/mol-math/linear-algebra/3d/vec4.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Vec4", function() { return _3d_vec4__WEBPACK_IMPORTED_MODULE_4__["default"]; });

/* harmony import */ var _3d_quat__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./3d/quat */ "./lib/mol-math/linear-algebra/3d/quat.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Quat", function() { return _3d_quat__WEBPACK_IMPORTED_MODULE_5__["default"]; });

/* harmony import */ var _3d_common__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ./3d/common */ "./lib/mol-math/linear-algebra/3d/common.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "EPSILON", function() { return _3d_common__WEBPACK_IMPORTED_MODULE_6__["EPSILON"]; });

/**
 * Copyright (c) 2017-2019 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author David Sehnal <david.sehnal@gmail.com>
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */
/*
 * This code has been modified from https://github.com/toji/gl-matrix/,
 * copyright (c) 2015, Brandon Jones, Colin MacKenzie IV.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 */








//# sourceMappingURL=3d.js.map

/***/ }),

/***/ "./lib/mol-math/linear-algebra/3d/common.js":
/*!**************************************************!*\
  !*** ./lib/mol-math/linear-algebra/3d/common.js ***!
  \**************************************************/
/*! exports provided: EPSILON, equalEps */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "EPSILON", function() { return EPSILON; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "equalEps", function() { return equalEps; });
/**
 * Copyright (c) 2017-2019 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author David Sehnal <david.sehnal@gmail.com>
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */
/*
 * This code has been modified from https://github.com/toji/gl-matrix/,
 * copyright (c) 2015, Brandon Jones, Colin MacKenzie IV.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 */
var EPSILON = 0.000001;
function equalEps(a, b, eps) {
    return Math.abs(a - b) <= eps;
}
//# sourceMappingURL=common.js.map

/***/ }),

/***/ "./lib/mol-math/linear-algebra/3d/mat3.js":
/*!************************************************!*\
  !*** ./lib/mol-math/linear-algebra/3d/mat3.js ***!
  \************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _3d__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../3d */ "./lib/mol-math/linear-algebra/3d.js");
/**
 * Copyright (c) 2017-2019 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author David Sehnal <david.sehnal@gmail.com>
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */
/*
 * This code has been modified from https://github.com/toji/gl-matrix/,
 * copyright (c) 2015, Brandon Jones, Colin MacKenzie IV.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 */

function Mat3() {
    return Mat3.zero();
}
(function (Mat3) {
    function zero() {
        // force double backing array by 0.1.
        var ret = [0.1, 0, 0, 0, 0, 0, 0, 0, 0];
        ret[0] = 0.0;
        return ret;
    }
    Mat3.zero = zero;
    function identity() {
        var out = zero();
        out[0] = 1;
        out[1] = 0;
        out[2] = 0;
        out[3] = 0;
        out[4] = 1;
        out[5] = 0;
        out[6] = 0;
        out[7] = 0;
        out[8] = 1;
        return out;
    }
    Mat3.identity = identity;
    function setIdentity(mat) {
        mat[0] = 1;
        mat[1] = 0;
        mat[2] = 0;
        mat[3] = 0;
        mat[4] = 1;
        mat[5] = 0;
        mat[6] = 0;
        mat[7] = 0;
        mat[8] = 1;
        return mat;
    }
    Mat3.setIdentity = setIdentity;
    function toArray(a, out, offset) {
        out[offset + 0] = a[0];
        out[offset + 1] = a[1];
        out[offset + 2] = a[2];
        out[offset + 3] = a[3];
        out[offset + 4] = a[4];
        out[offset + 5] = a[5];
        out[offset + 6] = a[6];
        out[offset + 7] = a[7];
        out[offset + 8] = a[8];
        return out;
    }
    Mat3.toArray = toArray;
    function fromArray(a, array, offset) {
        a[0] = array[offset + 0];
        a[1] = array[offset + 1];
        a[2] = array[offset + 2];
        a[3] = array[offset + 3];
        a[4] = array[offset + 4];
        a[5] = array[offset + 5];
        a[6] = array[offset + 6];
        a[7] = array[offset + 7];
        a[8] = array[offset + 8];
        return a;
    }
    Mat3.fromArray = fromArray;
    /**
     * Copies the upper-left 3x3 values into the given mat3.
     */
    function fromMat4(out, a) {
        out[0] = a[0];
        out[1] = a[1];
        out[2] = a[2];
        out[3] = a[4];
        out[4] = a[5];
        out[5] = a[6];
        out[6] = a[8];
        out[7] = a[9];
        out[8] = a[10];
        return out;
    }
    Mat3.fromMat4 = fromMat4;
    function create(a00, a01, a02, a10, a11, a12, a20, a21, a22) {
        var out = zero();
        out[0] = a00;
        out[1] = a01;
        out[2] = a02;
        out[3] = a10;
        out[4] = a11;
        out[5] = a12;
        out[6] = a20;
        out[7] = a21;
        out[8] = a22;
        return out;
    }
    Mat3.create = create;
    var _id = identity();
    function isIdentity(m, eps) {
        return areEqual(m, _id, typeof eps === 'undefined' ? _3d__WEBPACK_IMPORTED_MODULE_0__["EPSILON"] : eps);
    }
    Mat3.isIdentity = isIdentity;
    function hasNaN(m) {
        for (var i = 0; i < 9; i++)
            if (isNaN(m[i]))
                return true;
        return false;
    }
    Mat3.hasNaN = hasNaN;
    /**
     * Creates a new Mat3 initialized with values from an existing matrix
     */
    function clone(a) {
        return Mat3.copy(Mat3.zero(), a);
    }
    Mat3.clone = clone;
    function areEqual(a, b, eps) {
        for (var i = 0; i < 9; i++) {
            if (Math.abs(a[i] - b[i]) > eps)
                return false;
        }
        return true;
    }
    Mat3.areEqual = areEqual;
    function setValue(a, i, j, value) {
        a[3 * j + i] = value;
    }
    Mat3.setValue = setValue;
    function getValue(a, i, j) {
        return a[3 * j + i];
    }
    Mat3.getValue = getValue;
    /**
     * Copy the values from one Mat3 to another
     */
    function copy(out, a) {
        out[0] = a[0];
        out[1] = a[1];
        out[2] = a[2];
        out[3] = a[3];
        out[4] = a[4];
        out[5] = a[5];
        out[6] = a[6];
        out[7] = a[7];
        out[8] = a[8];
        return out;
    }
    Mat3.copy = copy;
    /**
     * Transpose the values of a Mat3
     */
    function transpose(out, a) {
        // If we are transposing ourselves we can skip a few steps but have to cache some values
        if (out === a) {
            var a01 = a[1], a02 = a[2], a12 = a[5];
            out[1] = a[3];
            out[2] = a[6];
            out[3] = a01;
            out[5] = a[7];
            out[6] = a02;
            out[7] = a12;
        }
        else {
            out[0] = a[0];
            out[1] = a[3];
            out[2] = a[6];
            out[3] = a[1];
            out[4] = a[4];
            out[5] = a[7];
            out[6] = a[2];
            out[7] = a[5];
            out[8] = a[8];
        }
        return out;
    }
    Mat3.transpose = transpose;
    /**
     * Inverts a Mat3
     */
    function invert(out, a) {
        var a00 = a[0], a01 = a[1], a02 = a[2];
        var a10 = a[3], a11 = a[4], a12 = a[5];
        var a20 = a[6], a21 = a[7], a22 = a[8];
        var b01 = a22 * a11 - a12 * a21;
        var b11 = -a22 * a10 + a12 * a20;
        var b21 = a21 * a10 - a11 * a20;
        // Calculate the determinant
        var det = a00 * b01 + a01 * b11 + a02 * b21;
        if (!det) {
            console.warn('non-invertible matrix.', a);
            return out;
        }
        det = 1.0 / det;
        out[0] = b01 * det;
        out[1] = (-a22 * a01 + a02 * a21) * det;
        out[2] = (a12 * a01 - a02 * a11) * det;
        out[3] = b11 * det;
        out[4] = (a22 * a00 - a02 * a20) * det;
        out[5] = (-a12 * a00 + a02 * a10) * det;
        out[6] = b21 * det;
        out[7] = (-a21 * a00 + a01 * a20) * det;
        out[8] = (a11 * a00 - a01 * a10) * det;
        return out;
    }
    Mat3.invert = invert;
    function symmtricFromUpper(out, a) {
        if (out === a) {
            out[3] = a[1];
            out[6] = a[2];
            out[7] = a[5];
        }
        else {
            out[0] = a[0];
            out[1] = a[1];
            out[2] = a[2];
            out[3] = a[1];
            out[4] = a[4];
            out[5] = a[5];
            out[6] = a[2];
            out[7] = a[5];
            out[8] = a[8];
        }
        return out;
    }
    Mat3.symmtricFromUpper = symmtricFromUpper;
    function symmtricFromLower(out, a) {
        if (out === a) {
            out[1] = a[3];
            out[2] = a[6];
            out[5] = a[7];
        }
        else {
            out[0] = a[0];
            out[1] = a[3];
            out[2] = a[6];
            out[3] = a[3];
            out[4] = a[4];
            out[5] = a[7];
            out[6] = a[6];
            out[7] = a[7];
            out[8] = a[8];
        }
        return out;
    }
    Mat3.symmtricFromLower = symmtricFromLower;
    function determinant(a) {
        var a00 = a[0], a01 = a[1], a02 = a[2];
        var a10 = a[3], a11 = a[4], a12 = a[5];
        var a20 = a[6], a21 = a[7], a22 = a[8];
        var b01 = a22 * a11 - a12 * a21;
        var b11 = -a22 * a10 + a12 * a20;
        var b21 = a21 * a10 - a11 * a20;
        // Calculate the determinant
        return a00 * b01 + a01 * b11 + a02 * b21;
    }
    Mat3.determinant = determinant;
    function trace(a) {
        return a[0] + a[4] + a[8];
    }
    Mat3.trace = trace;
    function sub(out, a, b) {
        out[0] = a[0] - b[0];
        out[1] = a[1] - b[1];
        out[2] = a[2] - b[2];
        out[3] = a[3] - b[3];
        out[4] = a[4] - b[4];
        out[5] = a[5] - b[5];
        out[6] = a[6] - b[6];
        out[7] = a[7] - b[7];
        out[8] = a[8] - b[8];
        return out;
    }
    Mat3.sub = sub;
    function add(out, a, b) {
        out[0] = a[0] + b[0];
        out[1] = a[1] + b[1];
        out[2] = a[2] + b[2];
        out[3] = a[3] + b[3];
        out[4] = a[4] + b[4];
        out[5] = a[5] + b[5];
        out[6] = a[6] + b[6];
        out[7] = a[7] + b[7];
        out[8] = a[8] + b[8];
        return out;
    }
    Mat3.add = add;
    function mul(out, a, b) {
        var a00 = a[0], a01 = a[1], a02 = a[2], a10 = a[3], a11 = a[4], a12 = a[5], a20 = a[6], a21 = a[7], a22 = a[8];
        var b00 = b[0], b01 = b[1], b02 = b[2], b10 = b[3], b11 = b[4], b12 = b[5], b20 = b[6], b21 = b[7], b22 = b[8];
        out[0] = b00 * a00 + b01 * a10 + b02 * a20;
        out[1] = b00 * a01 + b01 * a11 + b02 * a21;
        out[2] = b00 * a02 + b01 * a12 + b02 * a22;
        out[3] = b10 * a00 + b11 * a10 + b12 * a20;
        out[4] = b10 * a01 + b11 * a11 + b12 * a21;
        out[5] = b10 * a02 + b11 * a12 + b12 * a22;
        out[6] = b20 * a00 + b21 * a10 + b22 * a20;
        out[7] = b20 * a01 + b21 * a11 + b22 * a21;
        out[8] = b20 * a02 + b21 * a12 + b22 * a22;
        return out;
    }
    Mat3.mul = mul;
    function subScalar(out, a, s) {
        out[0] = a[0] - s;
        out[1] = a[1] - s;
        out[2] = a[2] - s;
        out[3] = a[3] - s;
        out[4] = a[4] - s;
        out[5] = a[5] - s;
        out[6] = a[6] - s;
        out[7] = a[7] - s;
        out[8] = a[8] - s;
        return out;
    }
    Mat3.subScalar = subScalar;
    function addScalar(out, a, s) {
        out[0] = a[0] + s;
        out[1] = a[1] + s;
        out[2] = a[2] + s;
        out[3] = a[3] + s;
        out[4] = a[4] + s;
        out[5] = a[5] + s;
        out[6] = a[6] + s;
        out[7] = a[7] + s;
        out[8] = a[8] + s;
        return out;
    }
    Mat3.addScalar = addScalar;
    function mulScalar(out, a, s) {
        out[0] = a[0] * s;
        out[1] = a[1] * s;
        out[2] = a[2] * s;
        out[3] = a[3] * s;
        out[4] = a[4] * s;
        out[5] = a[5] * s;
        out[6] = a[6] * s;
        out[7] = a[7] * s;
        out[8] = a[8] * s;
        return out;
    }
    Mat3.mulScalar = mulScalar;
    var piThird = Math.PI / 3;
    var tmpB = Mat3();
    /**
     * Given a real symmetric 3x3 matrix A, compute the eigenvalues
     *
     * From https://en.wikipedia.org/wiki/Eigenvalue_algorithm#3.C3.973_matrices
     */
    function symmetricEigenvalues(out, a) {
        var p1 = a[1] * a[1] + a[2] * a[2] + a[5] * a[5];
        if (p1 === 0) {
            out[0] = a[0];
            out[1] = a[4];
            out[2] = a[8];
        }
        else {
            var q = trace(a) / 3;
            var a1 = a[0] - q;
            var a2 = a[4] - q;
            var a3 = a[8] - q;
            var p2 = a1 * a1 + a2 * a2 + a3 * a3 + 2 * p1;
            var p = Math.sqrt(p2 / 6);
            mulScalar(tmpB, Mat3.Identity, q);
            sub(tmpB, a, tmpB);
            mulScalar(tmpB, tmpB, (1 / p));
            var r = determinant(tmpB) / 2;
            // In exact arithmetic for a symmetric matrix  -1 <= r <= 1
            // but computation error can leave it slightly outside this range.
            var phi = r <= -1 ? piThird : r >= 1 ?
                0 : Math.acos(r) / 3;
            // the eigenvalues satisfy eig3 <= eig2 <= eig1
            out[0] = q + 2 * p * Math.cos(phi);
            out[2] = q + 2 * p * Math.cos(phi + (2 * piThird));
            out[1] = 3 * q - out[0] - out[2]; // since trace(A) = eig1 + eig2 + eig3
        }
        return out;
    }
    Mat3.symmetricEigenvalues = symmetricEigenvalues;
    var tmpR0 = [0.1, 0.0, 0.0];
    var tmpR1 = [0.1, 0.0, 0.0];
    var tmpR2 = [0.1, 0.0, 0.0];
    var tmpR0xR1 = [0.1, 0.0, 0.0];
    var tmpR0xR2 = [0.1, 0.0, 0.0];
    var tmpR1xR2 = [0.1, 0.0, 0.0];
    /**
     * Calculates the eigenvector for the given eigenvalue `e` of matrix `a`
     */
    function eigenvector(out, a, e) {
        _3d__WEBPACK_IMPORTED_MODULE_0__["Vec3"].set(tmpR0, a[0] - e, a[1], a[2]);
        _3d__WEBPACK_IMPORTED_MODULE_0__["Vec3"].set(tmpR1, a[1], a[4] - e, a[5]);
        _3d__WEBPACK_IMPORTED_MODULE_0__["Vec3"].set(tmpR2, a[2], a[5], a[8] - e);
        _3d__WEBPACK_IMPORTED_MODULE_0__["Vec3"].cross(tmpR0xR1, tmpR0, tmpR1);
        _3d__WEBPACK_IMPORTED_MODULE_0__["Vec3"].cross(tmpR0xR2, tmpR0, tmpR2);
        _3d__WEBPACK_IMPORTED_MODULE_0__["Vec3"].cross(tmpR1xR2, tmpR1, tmpR2);
        var d0 = _3d__WEBPACK_IMPORTED_MODULE_0__["Vec3"].dot(tmpR0xR1, tmpR0xR1);
        var d1 = _3d__WEBPACK_IMPORTED_MODULE_0__["Vec3"].dot(tmpR0xR2, tmpR0xR2);
        var d2 = _3d__WEBPACK_IMPORTED_MODULE_0__["Vec3"].dot(tmpR1xR2, tmpR1xR2);
        var dmax = d0;
        var imax = 0;
        if (d1 > dmax) {
            dmax = d1;
            imax = 1;
        }
        if (d2 > dmax)
            imax = 2;
        if (imax === 0) {
            _3d__WEBPACK_IMPORTED_MODULE_0__["Vec3"].scale(out, tmpR0xR1, 1 / Math.sqrt(d0));
        }
        else if (imax === 1) {
            _3d__WEBPACK_IMPORTED_MODULE_0__["Vec3"].scale(out, tmpR0xR2, 1 / Math.sqrt(d1));
        }
        else {
            _3d__WEBPACK_IMPORTED_MODULE_0__["Vec3"].scale(out, tmpR1xR2, 1 / Math.sqrt(d2));
        }
        return out;
    }
    Mat3.eigenvector = eigenvector;
    /**
     * Get matrix to transform directions, e.g. normals
     */
    function directionTransform(out, t) {
        Mat3.fromMat4(out, t);
        Mat3.invert(out, out);
        Mat3.transpose(out, out);
        return out;
    }
    Mat3.directionTransform = directionTransform;
    Mat3.Identity = identity();
})(Mat3 || (Mat3 = {}));
/* harmony default export */ __webpack_exports__["default"] = (Mat3);
//# sourceMappingURL=mat3.js.map

/***/ }),

/***/ "./lib/mol-math/linear-algebra/3d/mat4.js":
/*!************************************************!*\
  !*** ./lib/mol-math/linear-algebra/3d/mat4.js ***!
  \************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _common__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./common */ "./lib/mol-math/linear-algebra/3d/common.js");
/* harmony import */ var _vec3__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./vec3 */ "./lib/mol-math/linear-algebra/3d/vec3.js");
/* harmony import */ var _misc__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../misc */ "./lib/mol-math/misc.js");
/**
 * Copyright (c) 2017-2020 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author David Sehnal <david.sehnal@gmail.com>
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */
/*
 * This code has been modified from https://github.com/toji/gl-matrix/,
 * copyright (c) 2015, Brandon Jones, Colin MacKenzie IV.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 */



function Mat4() {
    return Mat4.zero();
}
/**
 * Stores a 4x4 matrix in a column major (j * 4 + i indexing) format.
 */
(function (Mat4) {
    function zero() {
        // force double backing array by 0.1.
        var ret = [0.1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
        ret[0] = 0.0;
        return ret;
    }
    Mat4.zero = zero;
    function identity() {
        var out = zero();
        out[0] = 1;
        out[1] = 0;
        out[2] = 0;
        out[3] = 0;
        out[4] = 0;
        out[5] = 1;
        out[6] = 0;
        out[7] = 0;
        out[8] = 0;
        out[9] = 0;
        out[10] = 1;
        out[11] = 0;
        out[12] = 0;
        out[13] = 0;
        out[14] = 0;
        out[15] = 1;
        return out;
    }
    Mat4.identity = identity;
    function setIdentity(mat) {
        mat[0] = 1;
        mat[1] = 0;
        mat[2] = 0;
        mat[3] = 0;
        mat[4] = 0;
        mat[5] = 1;
        mat[6] = 0;
        mat[7] = 0;
        mat[8] = 0;
        mat[9] = 0;
        mat[10] = 1;
        mat[11] = 0;
        mat[12] = 0;
        mat[13] = 0;
        mat[14] = 0;
        mat[15] = 1;
        return mat;
    }
    Mat4.setIdentity = setIdentity;
    function setZero(mat) {
        for (var i = 0; i < 16; i++)
            mat[i] = 0;
        return mat;
    }
    Mat4.setZero = setZero;
    function ofRows(rows) {
        var out = zero();
        for (var i = 0; i < 4; i++) {
            var r = rows[i];
            for (var j = 0; j < 4; j++) {
                out[4 * j + i] = r[j];
            }
        }
        return out;
    }
    Mat4.ofRows = ofRows;
    var _id = identity();
    function isIdentity(m, eps) {
        return areEqual(m, _id, typeof eps === 'undefined' ? _common__WEBPACK_IMPORTED_MODULE_0__["EPSILON"] : eps);
    }
    Mat4.isIdentity = isIdentity;
    function hasNaN(m) {
        for (var i = 0; i < 16; i++)
            if (isNaN(m[i]))
                return true;
        return false;
    }
    Mat4.hasNaN = hasNaN;
    function areEqual(a, b, eps) {
        for (var i = 0; i < 16; i++) {
            if (Math.abs(a[i] - b[i]) > eps)
                return false;
        }
        return true;
    }
    Mat4.areEqual = areEqual;
    function setValue(a, i, j, value) {
        a[4 * j + i] = value;
    }
    Mat4.setValue = setValue;
    function getValue(a, i, j) {
        return a[4 * j + i];
    }
    Mat4.getValue = getValue;
    function toArray(a, out, offset) {
        out[offset + 0] = a[0];
        out[offset + 1] = a[1];
        out[offset + 2] = a[2];
        out[offset + 3] = a[3];
        out[offset + 4] = a[4];
        out[offset + 5] = a[5];
        out[offset + 6] = a[6];
        out[offset + 7] = a[7];
        out[offset + 8] = a[8];
        out[offset + 9] = a[9];
        out[offset + 10] = a[10];
        out[offset + 11] = a[11];
        out[offset + 12] = a[12];
        out[offset + 13] = a[13];
        out[offset + 14] = a[14];
        out[offset + 15] = a[15];
        return out;
    }
    Mat4.toArray = toArray;
    function fromArray(a, array, offset) {
        a[0] = array[offset + 0];
        a[1] = array[offset + 1];
        a[2] = array[offset + 2];
        a[3] = array[offset + 3];
        a[4] = array[offset + 4];
        a[5] = array[offset + 5];
        a[6] = array[offset + 6];
        a[7] = array[offset + 7];
        a[8] = array[offset + 8];
        a[9] = array[offset + 9];
        a[10] = array[offset + 10];
        a[11] = array[offset + 11];
        a[12] = array[offset + 12];
        a[13] = array[offset + 13];
        a[14] = array[offset + 14];
        a[15] = array[offset + 15];
        return a;
    }
    Mat4.fromArray = fromArray;
    function fromBasis(a, x, y, z) {
        Mat4.setZero(a);
        Mat4.setValue(a, 0, 0, x[0]);
        Mat4.setValue(a, 1, 0, x[1]);
        Mat4.setValue(a, 2, 0, x[2]);
        Mat4.setValue(a, 0, 1, y[0]);
        Mat4.setValue(a, 1, 1, y[1]);
        Mat4.setValue(a, 2, 1, y[2]);
        Mat4.setValue(a, 0, 2, z[0]);
        Mat4.setValue(a, 1, 2, z[1]);
        Mat4.setValue(a, 2, 2, z[2]);
        Mat4.setValue(a, 3, 3, 1);
        return a;
    }
    Mat4.fromBasis = fromBasis;
    function copy(out, a) {
        out[0] = a[0];
        out[1] = a[1];
        out[2] = a[2];
        out[3] = a[3];
        out[4] = a[4];
        out[5] = a[5];
        out[6] = a[6];
        out[7] = a[7];
        out[8] = a[8];
        out[9] = a[9];
        out[10] = a[10];
        out[11] = a[11];
        out[12] = a[12];
        out[13] = a[13];
        out[14] = a[14];
        out[15] = a[15];
        return out;
    }
    Mat4.copy = copy;
    function clone(a) {
        return Mat4.copy(Mat4.zero(), a);
    }
    Mat4.clone = clone;
    /**
     * Returns the translation vector component of a transformation matrix.
     */
    function getTranslation(out, mat) {
        out[0] = mat[12];
        out[1] = mat[13];
        out[2] = mat[14];
        return out;
    }
    Mat4.getTranslation = getTranslation;
    /**
     * Returns the scaling factor component of a transformation matrix.
     */
    function getScaling(out, mat) {
        var m11 = mat[0];
        var m12 = mat[1];
        var m13 = mat[2];
        var m21 = mat[4];
        var m22 = mat[5];
        var m23 = mat[6];
        var m31 = mat[8];
        var m32 = mat[9];
        var m33 = mat[10];
        out[0] = Math.sqrt(m11 * m11 + m12 * m12 + m13 * m13);
        out[1] = Math.sqrt(m21 * m21 + m22 * m22 + m23 * m23);
        out[2] = Math.sqrt(m31 * m31 + m32 * m32 + m33 * m33);
        return out;
    }
    Mat4.getScaling = getScaling;
    /**
     * Returns a quaternion representing the rotational component of a transformation matrix.
     */
    function getRotation(out, mat) {
        // Algorithm taken from http://www.euclideanspace.com/maths/geometry/rotations/conversions/matrixToQuaternion/index.htm
        var trace = mat[0] + mat[5] + mat[10];
        var S = 0;
        if (trace > 0) {
            S = Math.sqrt(trace + 1.0) * 2;
            out[3] = 0.25 * S;
            out[0] = (mat[6] - mat[9]) / S;
            out[1] = (mat[8] - mat[2]) / S;
            out[2] = (mat[1] - mat[4]) / S;
        }
        else if ((mat[0] > mat[5]) && (mat[0] > mat[10])) {
            S = Math.sqrt(1.0 + mat[0] - mat[5] - mat[10]) * 2;
            out[3] = (mat[6] - mat[9]) / S;
            out[0] = 0.25 * S;
            out[1] = (mat[1] + mat[4]) / S;
            out[2] = (mat[8] + mat[2]) / S;
        }
        else if (mat[5] > mat[10]) {
            S = Math.sqrt(1.0 + mat[5] - mat[0] - mat[10]) * 2;
            out[3] = (mat[8] - mat[2]) / S;
            out[0] = (mat[1] + mat[4]) / S;
            out[1] = 0.25 * S;
            out[2] = (mat[6] + mat[9]) / S;
        }
        else {
            S = Math.sqrt(1.0 + mat[10] - mat[0] - mat[5]) * 2;
            out[3] = (mat[1] - mat[4]) / S;
            out[0] = (mat[8] + mat[2]) / S;
            out[1] = (mat[6] + mat[9]) / S;
            out[2] = 0.25 * S;
        }
        return out;
    }
    Mat4.getRotation = getRotation;
    function extractRotation(out, mat) {
        var scaleX = 1 / Math.sqrt(mat[0] * mat[0] + mat[1] * mat[1] + mat[2] * mat[2]);
        var scaleY = 1 / Math.sqrt(mat[4] * mat[4] + mat[5] * mat[5] + mat[6] * mat[6]);
        var scaleZ = 1 / Math.sqrt(mat[8] * mat[8] + mat[9] * mat[9] + mat[10] * mat[10]);
        out[0] = mat[0] * scaleX;
        out[1] = mat[1] * scaleX;
        out[2] = mat[2] * scaleX;
        out[3] = 0;
        out[4] = mat[4] * scaleY;
        out[5] = mat[5] * scaleY;
        out[6] = mat[6] * scaleY;
        out[7] = 0;
        out[8] = mat[8] * scaleZ;
        out[9] = mat[9] * scaleZ;
        out[10] = mat[10] * scaleZ;
        out[11] = 0;
        out[12] = 0;
        out[13] = 0;
        out[14] = 0;
        out[15] = 1;
        return out;
    }
    Mat4.extractRotation = extractRotation;
    function transpose(out, a) {
        // If we are transposing ourselves we can skip a few steps but have to cache some values
        if (out === a) {
            var a01 = a[1], a02 = a[2], a03 = a[3];
            var a12 = a[6], a13 = a[7];
            var a23 = a[11];
            out[1] = a[4];
            out[2] = a[8];
            out[3] = a[12];
            out[4] = a01;
            out[6] = a[9];
            out[7] = a[13];
            out[8] = a02;
            out[9] = a12;
            out[11] = a[14];
            out[12] = a03;
            out[13] = a13;
            out[14] = a23;
        }
        else {
            out[0] = a[0];
            out[1] = a[4];
            out[2] = a[8];
            out[3] = a[12];
            out[4] = a[1];
            out[5] = a[5];
            out[6] = a[9];
            out[7] = a[13];
            out[8] = a[2];
            out[9] = a[6];
            out[10] = a[10];
            out[11] = a[14];
            out[12] = a[3];
            out[13] = a[7];
            out[14] = a[11];
            out[15] = a[15];
        }
        return out;
    }
    Mat4.transpose = transpose;
    function invert(out, a) {
        var a00 = a[0], a01 = a[1], a02 = a[2], a03 = a[3], a10 = a[4], a11 = a[5], a12 = a[6], a13 = a[7], a20 = a[8], a21 = a[9], a22 = a[10], a23 = a[11], a30 = a[12], a31 = a[13], a32 = a[14], a33 = a[15], b00 = a00 * a11 - a01 * a10, b01 = a00 * a12 - a02 * a10, b02 = a00 * a13 - a03 * a10, b03 = a01 * a12 - a02 * a11, b04 = a01 * a13 - a03 * a11, b05 = a02 * a13 - a03 * a12, b06 = a20 * a31 - a21 * a30, b07 = a20 * a32 - a22 * a30, b08 = a20 * a33 - a23 * a30, b09 = a21 * a32 - a22 * a31, b10 = a21 * a33 - a23 * a31, b11 = a22 * a33 - a23 * a32;
        // Calculate the determinant
        var det = b00 * b11 - b01 * b10 + b02 * b09 + b03 * b08 - b04 * b07 + b05 * b06;
        if (!det) {
            console.warn('non-invertible matrix.', a);
            return out;
        }
        det = 1.0 / det;
        out[0] = (a11 * b11 - a12 * b10 + a13 * b09) * det;
        out[1] = (a02 * b10 - a01 * b11 - a03 * b09) * det;
        out[2] = (a31 * b05 - a32 * b04 + a33 * b03) * det;
        out[3] = (a22 * b04 - a21 * b05 - a23 * b03) * det;
        out[4] = (a12 * b08 - a10 * b11 - a13 * b07) * det;
        out[5] = (a00 * b11 - a02 * b08 + a03 * b07) * det;
        out[6] = (a32 * b02 - a30 * b05 - a33 * b01) * det;
        out[7] = (a20 * b05 - a22 * b02 + a23 * b01) * det;
        out[8] = (a10 * b10 - a11 * b08 + a13 * b06) * det;
        out[9] = (a01 * b08 - a00 * b10 - a03 * b06) * det;
        out[10] = (a30 * b04 - a31 * b02 + a33 * b00) * det;
        out[11] = (a21 * b02 - a20 * b04 - a23 * b00) * det;
        out[12] = (a11 * b07 - a10 * b09 - a12 * b06) * det;
        out[13] = (a00 * b09 - a01 * b07 + a02 * b06) * det;
        out[14] = (a31 * b01 - a30 * b03 - a32 * b00) * det;
        out[15] = (a20 * b03 - a21 * b01 + a22 * b00) * det;
        return out;
    }
    Mat4.invert = invert;
    function mul(out, a, b) {
        var a00 = a[0], a01 = a[1], a02 = a[2], a03 = a[3], a10 = a[4], a11 = a[5], a12 = a[6], a13 = a[7], a20 = a[8], a21 = a[9], a22 = a[10], a23 = a[11], a30 = a[12], a31 = a[13], a32 = a[14], a33 = a[15];
        // Cache only the current line of the second matrix
        var b0 = b[0], b1 = b[1], b2 = b[2], b3 = b[3];
        out[0] = b0 * a00 + b1 * a10 + b2 * a20 + b3 * a30;
        out[1] = b0 * a01 + b1 * a11 + b2 * a21 + b3 * a31;
        out[2] = b0 * a02 + b1 * a12 + b2 * a22 + b3 * a32;
        out[3] = b0 * a03 + b1 * a13 + b2 * a23 + b3 * a33;
        b0 = b[4];
        b1 = b[5];
        b2 = b[6];
        b3 = b[7];
        out[4] = b0 * a00 + b1 * a10 + b2 * a20 + b3 * a30;
        out[5] = b0 * a01 + b1 * a11 + b2 * a21 + b3 * a31;
        out[6] = b0 * a02 + b1 * a12 + b2 * a22 + b3 * a32;
        out[7] = b0 * a03 + b1 * a13 + b2 * a23 + b3 * a33;
        b0 = b[8];
        b1 = b[9];
        b2 = b[10];
        b3 = b[11];
        out[8] = b0 * a00 + b1 * a10 + b2 * a20 + b3 * a30;
        out[9] = b0 * a01 + b1 * a11 + b2 * a21 + b3 * a31;
        out[10] = b0 * a02 + b1 * a12 + b2 * a22 + b3 * a32;
        out[11] = b0 * a03 + b1 * a13 + b2 * a23 + b3 * a33;
        b0 = b[12];
        b1 = b[13];
        b2 = b[14];
        b3 = b[15];
        out[12] = b0 * a00 + b1 * a10 + b2 * a20 + b3 * a30;
        out[13] = b0 * a01 + b1 * a11 + b2 * a21 + b3 * a31;
        out[14] = b0 * a02 + b1 * a12 + b2 * a22 + b3 * a32;
        out[15] = b0 * a03 + b1 * a13 + b2 * a23 + b3 * a33;
        return out;
    }
    Mat4.mul = mul;
    /**
     * Like `mul` but with offsets into arrays
     */
    function mulOffset(out, a, b, oOut, oA, oB) {
        var a00 = a[0 + oA], a01 = a[1 + oA], a02 = a[2 + oA], a03 = a[3 + oA], a10 = a[4 + oA], a11 = a[5 + oA], a12 = a[6 + oA], a13 = a[7 + oA], a20 = a[8 + oA], a21 = a[9 + oA], a22 = a[10 + oA], a23 = a[11 + oA], a30 = a[12 + oA], a31 = a[13 + oA], a32 = a[14 + oA], a33 = a[15 + oA];
        // Cache only the current line of the second matrix
        var b0 = b[0 + oB], b1 = b[1 + oB], b2 = b[2 + oB], b3 = b[3 + oB];
        out[0 + oOut] = b0 * a00 + b1 * a10 + b2 * a20 + b3 * a30;
        out[1 + oOut] = b0 * a01 + b1 * a11 + b2 * a21 + b3 * a31;
        out[2 + oOut] = b0 * a02 + b1 * a12 + b2 * a22 + b3 * a32;
        out[3 + oOut] = b0 * a03 + b1 * a13 + b2 * a23 + b3 * a33;
        b0 = b[4 + oB];
        b1 = b[5 + oB];
        b2 = b[6 + oB];
        b3 = b[7 + oB];
        out[4 + oOut] = b0 * a00 + b1 * a10 + b2 * a20 + b3 * a30;
        out[5 + oOut] = b0 * a01 + b1 * a11 + b2 * a21 + b3 * a31;
        out[6 + oOut] = b0 * a02 + b1 * a12 + b2 * a22 + b3 * a32;
        out[7 + oOut] = b0 * a03 + b1 * a13 + b2 * a23 + b3 * a33;
        b0 = b[8 + oB];
        b1 = b[9 + oB];
        b2 = b[10 + oB];
        b3 = b[11 + oB];
        out[8 + oOut] = b0 * a00 + b1 * a10 + b2 * a20 + b3 * a30;
        out[9 + oOut] = b0 * a01 + b1 * a11 + b2 * a21 + b3 * a31;
        out[10 + oOut] = b0 * a02 + b1 * a12 + b2 * a22 + b3 * a32;
        out[11 + oOut] = b0 * a03 + b1 * a13 + b2 * a23 + b3 * a33;
        b0 = b[12 + oB];
        b1 = b[13 + oB];
        b2 = b[14 + oB];
        b3 = b[15 + oB];
        out[12 + oOut] = b0 * a00 + b1 * a10 + b2 * a20 + b3 * a30;
        out[13 + oOut] = b0 * a01 + b1 * a11 + b2 * a21 + b3 * a31;
        out[14 + oOut] = b0 * a02 + b1 * a12 + b2 * a22 + b3 * a32;
        out[15 + oOut] = b0 * a03 + b1 * a13 + b2 * a23 + b3 * a33;
        return out;
    }
    Mat4.mulOffset = mulOffset;
    function mul3(out, a, b, c) {
        return mul(out, mul(out, a, b), c);
    }
    Mat4.mul3 = mul3;
    /** Translate a Mat4 by the given Vec3 */
    function translate(out, a, v) {
        var x = v[0], y = v[1], z = v[2];
        var a00, a01, a02, a03, a10, a11, a12, a13, a20, a21, a22, a23;
        if (a === out) {
            out[12] = a[0] * x + a[4] * y + a[8] * z + a[12];
            out[13] = a[1] * x + a[5] * y + a[9] * z + a[13];
            out[14] = a[2] * x + a[6] * y + a[10] * z + a[14];
            out[15] = a[3] * x + a[7] * y + a[11] * z + a[15];
        }
        else {
            a00 = a[0];
            a01 = a[1];
            a02 = a[2];
            a03 = a[3];
            a10 = a[4];
            a11 = a[5];
            a12 = a[6];
            a13 = a[7];
            a20 = a[8];
            a21 = a[9];
            a22 = a[10];
            a23 = a[11];
            out[0] = a00;
            out[1] = a01;
            out[2] = a02;
            out[3] = a03;
            out[4] = a10;
            out[5] = a11;
            out[6] = a12;
            out[7] = a13;
            out[8] = a20;
            out[9] = a21;
            out[10] = a22;
            out[11] = a23;
            out[12] = a00 * x + a10 * y + a20 * z + a[12];
            out[13] = a01 * x + a11 * y + a21 * z + a[13];
            out[14] = a02 * x + a12 * y + a22 * z + a[14];
            out[15] = a03 * x + a13 * y + a23 * z + a[15];
        }
        return out;
    }
    Mat4.translate = translate;
    function fromTranslation(out, v) {
        out[0] = 1;
        out[1] = 0;
        out[2] = 0;
        out[3] = 0;
        out[4] = 0;
        out[5] = 1;
        out[6] = 0;
        out[7] = 0;
        out[8] = 0;
        out[9] = 0;
        out[10] = 1;
        out[11] = 0;
        out[12] = v[0];
        out[13] = v[1];
        out[14] = v[2];
        out[15] = 1;
        return out;
    }
    Mat4.fromTranslation = fromTranslation;
    function setTranslation(out, v) {
        out[12] = v[0];
        out[13] = v[1];
        out[14] = v[2];
        return out;
    }
    Mat4.setTranslation = setTranslation;
    /**
     * Sets the specified quaternion with values corresponding to the given
     * axes. Each axis is a vec3 and is expected to be unit length and
     * perpendicular to all other specified axes.
     */
    function setAxes(out, view, right, up) {
        out[0] = right[0];
        out[4] = right[1];
        out[8] = right[2];
        out[1] = up[0];
        out[5] = up[1];
        out[9] = up[2];
        out[2] = view[0];
        out[6] = view[1];
        out[10] = view[2];
        return out;
    }
    Mat4.setAxes = setAxes;
    function rotate(out, a, rad, axis) {
        var x = axis[0], y = axis[1], z = axis[2], len = Math.sqrt(x * x + y * y + z * z), s, c, t, a00, a01, a02, a03, a10, a11, a12, a13, a20, a21, a22, a23, b00, b01, b02, b10, b11, b12, b20, b21, b22;
        if (Math.abs(len) < _common__WEBPACK_IMPORTED_MODULE_0__["EPSILON"]) {
            return Mat4.identity();
        }
        len = 1 / len;
        x *= len;
        y *= len;
        z *= len;
        s = Math.sin(rad);
        c = Math.cos(rad);
        t = 1 - c;
        a00 = a[0];
        a01 = a[1];
        a02 = a[2];
        a03 = a[3];
        a10 = a[4];
        a11 = a[5];
        a12 = a[6];
        a13 = a[7];
        a20 = a[8];
        a21 = a[9];
        a22 = a[10];
        a23 = a[11];
        // Construct the elements of the rotation matrix
        b00 = x * x * t + c;
        b01 = y * x * t + z * s;
        b02 = z * x * t - y * s;
        b10 = x * y * t - z * s;
        b11 = y * y * t + c;
        b12 = z * y * t + x * s;
        b20 = x * z * t + y * s;
        b21 = y * z * t - x * s;
        b22 = z * z * t + c;
        // Perform rotation-specific matrix multiplication
        out[0] = a00 * b00 + a10 * b01 + a20 * b02;
        out[1] = a01 * b00 + a11 * b01 + a21 * b02;
        out[2] = a02 * b00 + a12 * b01 + a22 * b02;
        out[3] = a03 * b00 + a13 * b01 + a23 * b02;
        out[4] = a00 * b10 + a10 * b11 + a20 * b12;
        out[5] = a01 * b10 + a11 * b11 + a21 * b12;
        out[6] = a02 * b10 + a12 * b11 + a22 * b12;
        out[7] = a03 * b10 + a13 * b11 + a23 * b12;
        out[8] = a00 * b20 + a10 * b21 + a20 * b22;
        out[9] = a01 * b20 + a11 * b21 + a21 * b22;
        out[10] = a02 * b20 + a12 * b21 + a22 * b22;
        out[11] = a03 * b20 + a13 * b21 + a23 * b22;
        if (a !== out) { // If the source and destination differ, copy the unchanged last row
            out[12] = a[12];
            out[13] = a[13];
            out[14] = a[14];
            out[15] = a[15];
        }
        return out;
    }
    Mat4.rotate = rotate;
    function fromRotation(out, rad, axis) {
        var x = axis[0], y = axis[1], z = axis[2], len = Math.sqrt(x * x + y * y + z * z), s, c, t;
        if (Math.abs(len) < _common__WEBPACK_IMPORTED_MODULE_0__["EPSILON"]) {
            return setIdentity(out);
        }
        len = 1 / len;
        x *= len;
        y *= len;
        z *= len;
        s = Math.sin(rad);
        c = Math.cos(rad);
        t = 1 - c;
        // Perform rotation-specific matrix multiplication
        out[0] = x * x * t + c;
        out[1] = y * x * t + z * s;
        out[2] = z * x * t - y * s;
        out[3] = 0;
        out[4] = x * y * t - z * s;
        out[5] = y * y * t + c;
        out[6] = z * y * t + x * s;
        out[7] = 0;
        out[8] = x * z * t + y * s;
        out[9] = y * z * t - x * s;
        out[10] = z * z * t + c;
        out[11] = 0;
        out[12] = 0;
        out[13] = 0;
        out[14] = 0;
        out[15] = 1;
        return out;
    }
    Mat4.fromRotation = fromRotation;
    function scale(out, a, v) {
        var x = v[0], y = v[1], z = v[2];
        out[0] = a[0] * x;
        out[1] = a[1] * x;
        out[2] = a[2] * x;
        out[3] = a[3] * x;
        out[4] = a[4] * y;
        out[5] = a[5] * y;
        out[6] = a[6] * y;
        out[7] = a[7] * y;
        out[8] = a[8] * z;
        out[9] = a[9] * z;
        out[10] = a[10] * z;
        out[11] = a[11] * z;
        out[12] = a[12];
        out[13] = a[13];
        out[14] = a[14];
        out[15] = a[15];
        return out;
    }
    Mat4.scale = scale;
    function scaleUniformly(out, a, scale) {
        out[0] = a[0] * scale;
        out[1] = a[1] * scale;
        out[2] = a[2] * scale;
        out[3] = a[3] * scale;
        out[4] = a[4] * scale;
        out[5] = a[5] * scale;
        out[6] = a[6] * scale;
        out[7] = a[7] * scale;
        out[8] = a[8] * scale;
        out[9] = a[9] * scale;
        out[10] = a[10] * scale;
        out[11] = a[11] * scale;
        out[12] = a[12];
        out[13] = a[13];
        out[14] = a[14];
        out[15] = a[15];
        return out;
    }
    Mat4.scaleUniformly = scaleUniformly;
    function fromScaling(out, v) {
        out[0] = v[0];
        out[1] = 0;
        out[2] = 0;
        out[3] = 0;
        out[4] = 0;
        out[5] = v[1];
        out[6] = 0;
        out[7] = 0;
        out[8] = 0;
        out[9] = 0;
        out[10] = v[2];
        out[11] = 0;
        out[12] = 0;
        out[13] = 0;
        out[14] = 0;
        out[15] = 1;
        return out;
    }
    Mat4.fromScaling = fromScaling;
    function fromUniformScaling(out, scale) {
        out[0] = scale;
        out[1] = 0;
        out[2] = 0;
        out[3] = 0;
        out[4] = 0;
        out[5] = scale;
        out[6] = 0;
        out[7] = 0;
        out[8] = 0;
        out[9] = 0;
        out[10] = scale;
        out[11] = 0;
        out[12] = 0;
        out[13] = 0;
        out[14] = 0;
        out[15] = 1;
        return out;
    }
    Mat4.fromUniformScaling = fromUniformScaling;
    /**
     * Copies the mat3 into upper-left 3x3 values.
     */
    function fromMat3(out, a) {
        out[0] = a[0];
        out[1] = a[1];
        out[2] = a[2];
        out[4] = a[3];
        out[5] = a[4];
        out[6] = a[5];
        out[8] = a[6];
        out[9] = a[7];
        out[10] = a[8];
        return out;
    }
    Mat4.fromMat3 = fromMat3;
    function makeTable(m) {
        var ret = '';
        for (var i = 0; i < 4; i++) {
            for (var j = 0; j < 4; j++) {
                ret += m[4 * j + i].toString();
                if (j < 3)
                    ret += ' ';
            }
            if (i < 3)
                ret += '\n';
        }
        return ret;
    }
    Mat4.makeTable = makeTable;
    function determinant(a) {
        var a00 = a[0], a01 = a[1], a02 = a[2], a03 = a[3], a10 = a[4], a11 = a[5], a12 = a[6], a13 = a[7], a20 = a[8], a21 = a[9], a22 = a[10], a23 = a[11], a30 = a[12], a31 = a[13], a32 = a[14], a33 = a[15], b00 = a00 * a11 - a01 * a10, b01 = a00 * a12 - a02 * a10, b02 = a00 * a13 - a03 * a10, b03 = a01 * a12 - a02 * a11, b04 = a01 * a13 - a03 * a11, b05 = a02 * a13 - a03 * a12, b06 = a20 * a31 - a21 * a30, b07 = a20 * a32 - a22 * a30, b08 = a20 * a33 - a23 * a30, b09 = a21 * a32 - a22 * a31, b10 = a21 * a33 - a23 * a31, b11 = a22 * a33 - a23 * a32;
        // Calculate the determinant
        return b00 * b11 - b01 * b10 + b02 * b09 + b03 * b08 - b04 * b07 + b05 * b06;
    }
    Mat4.determinant = determinant;
    /**
     * Check if the matrix has the form
     * [ Rotation    Translation ]
     * [ 0           1           ]
     *
     * Allows for improper rotations
     */
    function isRotationAndTranslation(a, eps) {
        return _isRotationAndTranslation(a, typeof eps !== 'undefined' ? eps : _common__WEBPACK_IMPORTED_MODULE_0__["EPSILON"]);
    }
    Mat4.isRotationAndTranslation = isRotationAndTranslation;
    function _isRotationAndTranslation(a, eps) {
        var a00 = a[0], a01 = a[1], a02 = a[2], a03 = a[3], a10 = a[4], a11 = a[5], a12 = a[6], a13 = a[7], a20 = a[8], a21 = a[9], a22 = a[10], a23 = a[11], a33 = a[15];
        if (!Object(_common__WEBPACK_IMPORTED_MODULE_0__["equalEps"])(a33, 1, eps) || !Object(_common__WEBPACK_IMPORTED_MODULE_0__["equalEps"])(a03, 0, eps) || !Object(_common__WEBPACK_IMPORTED_MODULE_0__["equalEps"])(a13, 0, eps) || !Object(_common__WEBPACK_IMPORTED_MODULE_0__["equalEps"])(a23, 0, eps)) {
            return false;
        }
        // use `abs` to allow for improper rotations
        var det3x3 = Math.abs(a00 * (a11 * a22 - a12 * a21) - a01 * (a10 * a22 - a12 * a20) + a02 * (a10 * a21 - a11 * a20));
        if (!Object(_common__WEBPACK_IMPORTED_MODULE_0__["equalEps"])(det3x3, 1, eps)) {
            return false;
        }
        return true;
    }
    /**
     * Check if the matrix has only translation and uniform scaling
     * [ S  0  0  X ]
     * [ 0  S  0  Y ]
     * [ 0  0  S  Z ]
     * [ 0  0  0  1 ]
     */
    function isTranslationAndUniformScaling(a, eps) {
        return _isTranslationAndUniformScaling(a, typeof eps !== 'undefined' ? eps : _common__WEBPACK_IMPORTED_MODULE_0__["EPSILON"]);
    }
    Mat4.isTranslationAndUniformScaling = isTranslationAndUniformScaling;
    function _isTranslationAndUniformScaling(a, eps) {
        var a00 = a[0];
        return (
        // 0 base scaling
        Object(_common__WEBPACK_IMPORTED_MODULE_0__["equalEps"])(a[1], 0, eps) &&
            Object(_common__WEBPACK_IMPORTED_MODULE_0__["equalEps"])(a[2], 0, eps) &&
            Object(_common__WEBPACK_IMPORTED_MODULE_0__["equalEps"])(a[3], 0, eps) &&
            Object(_common__WEBPACK_IMPORTED_MODULE_0__["equalEps"])(a[4], 0, eps) &&
            Object(_common__WEBPACK_IMPORTED_MODULE_0__["equalEps"])(a[5], a00, eps) &&
            Object(_common__WEBPACK_IMPORTED_MODULE_0__["equalEps"])(a[6], 0, eps) &&
            Object(_common__WEBPACK_IMPORTED_MODULE_0__["equalEps"])(a[7], 0, eps) &&
            Object(_common__WEBPACK_IMPORTED_MODULE_0__["equalEps"])(a[8], 0, eps) &&
            Object(_common__WEBPACK_IMPORTED_MODULE_0__["equalEps"])(a[9], 0, eps) &&
            Object(_common__WEBPACK_IMPORTED_MODULE_0__["equalEps"])(a[10], a00, eps) &&
            Object(_common__WEBPACK_IMPORTED_MODULE_0__["equalEps"])(a[11], 0, eps) &&
            // 12, 13, 14 translation can be anything
            Object(_common__WEBPACK_IMPORTED_MODULE_0__["equalEps"])(a[15], 1, eps));
    }
    function fromQuat(out, q) {
        var x = q[0], y = q[1], z = q[2], w = q[3];
        var x2 = x + x;
        var y2 = y + y;
        var z2 = z + z;
        var xx = x * x2;
        var yx = y * x2;
        var yy = y * y2;
        var zx = z * x2;
        var zy = z * y2;
        var zz = z * z2;
        var wx = w * x2;
        var wy = w * y2;
        var wz = w * z2;
        out[0] = 1 - yy - zz;
        out[1] = yx + wz;
        out[2] = zx - wy;
        out[3] = 0;
        out[4] = yx - wz;
        out[5] = 1 - xx - zz;
        out[6] = zy + wx;
        out[7] = 0;
        out[8] = zx + wy;
        out[9] = zy - wx;
        out[10] = 1 - xx - yy;
        out[11] = 0;
        out[12] = 0;
        out[13] = 0;
        out[14] = 0;
        out[15] = 1;
        return out;
    }
    Mat4.fromQuat = fromQuat;
    /**
     * Generates a perspective projection (frustum) matrix with the given bounds
     */
    function perspective(out, left, right, top, bottom, near, far) {
        var x = 2 * near / (right - left);
        var y = 2 * near / (top - bottom);
        var a = (right + left) / (right - left);
        var b = (top + bottom) / (top - bottom);
        var c = -(far + near) / (far - near);
        var d = -2 * far * near / (far - near);
        out[0] = x;
        out[1] = 0;
        out[2] = 0;
        out[3] = 0;
        out[4] = 0;
        out[5] = y;
        out[6] = 0;
        out[7] = 0;
        out[8] = a;
        out[9] = b;
        out[10] = c;
        out[11] = -1;
        out[12] = 0;
        out[13] = 0;
        out[14] = d;
        out[15] = 0;
        return out;
    }
    Mat4.perspective = perspective;
    /**
     * Generates a orthogonal projection matrix with the given bounds
     */
    function ortho(out, left, right, top, bottom, near, far) {
        var w = 1.0 / (right - left);
        var h = 1.0 / (top - bottom);
        var p = 1.0 / (far - near);
        var x = (right + left) * w;
        var y = (top + bottom) * h;
        var z = (far + near) * p;
        out[0] = 2 * w;
        out[1] = 0;
        out[2] = 0;
        out[3] = 0;
        out[4] = 0;
        out[5] = 2 * h;
        out[6] = 0;
        out[7] = 0;
        out[8] = 0;
        out[9] = 0;
        out[10] = -2 * p;
        out[11] = 0;
        out[12] = -x;
        out[13] = -y;
        out[14] = -z;
        out[15] = 1;
        return out;
    }
    Mat4.ortho = ortho;
    /**
     * Generates a look-at matrix with the given eye position, focal point, and up axis
     */
    function lookAt(out, eye, center, up) {
        var x0, x1, x2, y0, y1, y2, z0, z1, z2, len;
        var eyex = eye[0];
        var eyey = eye[1];
        var eyez = eye[2];
        var upx = up[0];
        var upy = up[1];
        var upz = up[2];
        var centerx = center[0];
        var centery = center[1];
        var centerz = center[2];
        if (Math.abs(eyex - centerx) < _common__WEBPACK_IMPORTED_MODULE_0__["EPSILON"] &&
            Math.abs(eyey - centery) < _common__WEBPACK_IMPORTED_MODULE_0__["EPSILON"] &&
            Math.abs(eyez - centerz) < _common__WEBPACK_IMPORTED_MODULE_0__["EPSILON"]) {
            return setIdentity(out);
        }
        z0 = eyex - centerx;
        z1 = eyey - centery;
        z2 = eyez - centerz;
        len = 1 / Math.sqrt(z0 * z0 + z1 * z1 + z2 * z2);
        z0 *= len;
        z1 *= len;
        z2 *= len;
        x0 = upy * z2 - upz * z1;
        x1 = upz * z0 - upx * z2;
        x2 = upx * z1 - upy * z0;
        len = Math.sqrt(x0 * x0 + x1 * x1 + x2 * x2);
        if (!len) {
            x0 = 0;
            x1 = 0;
            x2 = 0;
        }
        else {
            len = 1 / len;
            x0 *= len;
            x1 *= len;
            x2 *= len;
        }
        y0 = z1 * x2 - z2 * x1;
        y1 = z2 * x0 - z0 * x2;
        y2 = z0 * x1 - z1 * x0;
        len = Math.sqrt(y0 * y0 + y1 * y1 + y2 * y2);
        if (!len) {
            y0 = 0;
            y1 = 0;
            y2 = 0;
        }
        else {
            len = 1 / len;
            y0 *= len;
            y1 *= len;
            y2 *= len;
        }
        out[0] = x0;
        out[1] = y0;
        out[2] = z0;
        out[3] = 0;
        out[4] = x1;
        out[5] = y1;
        out[6] = z1;
        out[7] = 0;
        out[8] = x2;
        out[9] = y2;
        out[10] = z2;
        out[11] = 0;
        out[12] = -(x0 * eyex + x1 * eyey + x2 * eyez);
        out[13] = -(y0 * eyex + y1 * eyey + y2 * eyez);
        out[14] = -(z0 * eyex + z1 * eyey + z2 * eyez);
        out[15] = 1;
        return out;
    }
    Mat4.lookAt = lookAt;
    /**
     * Generates a matrix that makes something look at something else.
     */
    function targetTo(out, eye, target, up) {
        var eyex = eye[0], eyey = eye[1], eyez = eye[2], upx = up[0], upy = up[1], upz = up[2];
        var z0 = eyex - target[0], z1 = eyey - target[1], z2 = eyez - target[2];
        var len = z0 * z0 + z1 * z1 + z2 * z2;
        if (len > 0) {
            len = 1 / Math.sqrt(len);
            z0 *= len;
            z1 *= len;
            z2 *= len;
        }
        var x0 = upy * z2 - upz * z1, x1 = upz * z0 - upx * z2, x2 = upx * z1 - upy * z0;
        len = x0 * x0 + x1 * x1 + x2 * x2;
        if (len > 0) {
            len = 1 / Math.sqrt(len);
            x0 *= len;
            x1 *= len;
            x2 *= len;
        }
        out[0] = x0;
        out[1] = x1;
        out[2] = x2;
        out[3] = 0;
        out[4] = z1 * x2 - z2 * x1;
        out[5] = z2 * x0 - z0 * x2;
        out[6] = z0 * x1 - z1 * x0;
        out[7] = 0;
        out[8] = z0;
        out[9] = z1;
        out[10] = z2;
        out[11] = 0;
        out[12] = eyex;
        out[13] = eyey;
        out[14] = eyez;
        out[15] = 1;
        return out;
    }
    Mat4.targetTo = targetTo;
    /**
     * Perm is 0-indexed permutation
     */
    function fromPermutation(out, perm) {
        setZero(out);
        for (var i = 0; i < 4; i++) {
            var p = perm[i];
            setValue(out, i, p, 1);
        }
        return out;
    }
    Mat4.fromPermutation = fromPermutation;
    function getMaxScaleOnAxis(m) {
        var scaleXSq = m[0] * m[0] + m[1] * m[1] + m[2] * m[2];
        var scaleYSq = m[4] * m[4] + m[5] * m[5] + m[6] * m[6];
        var scaleZSq = m[8] * m[8] + m[9] * m[9] + m[10] * m[10];
        return Math.sqrt(Math.max(scaleXSq, scaleYSq, scaleZSq));
    }
    Mat4.getMaxScaleOnAxis = getMaxScaleOnAxis;
    var xAxis = _vec3__WEBPACK_IMPORTED_MODULE_1__["default"].create(1, 0, 0);
    var yAxis = _vec3__WEBPACK_IMPORTED_MODULE_1__["default"].create(0, 1, 0);
    var zAxis = _vec3__WEBPACK_IMPORTED_MODULE_1__["default"].create(0, 0, 1);
    /** Rotation matrix for 90deg around x-axis */
    Mat4.rotX90 = Mat4.fromRotation(Mat4(), Object(_misc__WEBPACK_IMPORTED_MODULE_2__["degToRad"])(90), xAxis);
    /** Rotation matrix for 180deg around x-axis */
    Mat4.rotX180 = Mat4.fromRotation(Mat4(), Object(_misc__WEBPACK_IMPORTED_MODULE_2__["degToRad"])(180), xAxis);
    /** Rotation matrix for 90deg around y-axis */
    Mat4.rotY90 = Mat4.fromRotation(Mat4(), Object(_misc__WEBPACK_IMPORTED_MODULE_2__["degToRad"])(90), yAxis);
    /** Rotation matrix for 180deg around y-axis */
    Mat4.rotY180 = Mat4.fromRotation(Mat4(), Object(_misc__WEBPACK_IMPORTED_MODULE_2__["degToRad"])(180), yAxis);
    /** Rotation matrix for 270deg around y-axis */
    Mat4.rotY270 = Mat4.fromRotation(Mat4(), Object(_misc__WEBPACK_IMPORTED_MODULE_2__["degToRad"])(270), yAxis);
    /** Rotation matrix for 90deg around z-axis */
    Mat4.rotZ90 = Mat4.fromRotation(Mat4(), Object(_misc__WEBPACK_IMPORTED_MODULE_2__["degToRad"])(90), zAxis);
    /** Rotation matrix for 180deg around z-axis */
    Mat4.rotZ180 = Mat4.fromRotation(Mat4(), Object(_misc__WEBPACK_IMPORTED_MODULE_2__["degToRad"])(180), zAxis);
    /** Rotation matrix for 90deg around first x-axis and then y-axis */
    Mat4.rotXY90 = Mat4.mul(Mat4(), Mat4.rotX90, Mat4.rotY90);
    /** Rotation matrix for 90deg around first z-axis and then y-axis */
    Mat4.rotZY90 = Mat4.mul(Mat4(), Mat4.rotZ90, Mat4.rotY90);
    /** Rotation matrix for 90deg around first z-axis and then y-axis and then z-axis */
    Mat4.rotZYZ90 = Mat4.mul(Mat4(), Mat4.rotZY90, Mat4.rotZ90);
    /** Rotation matrix for 90deg around first z-axis and then 180deg around x-axis */
    Mat4.rotZ90X180 = Mat4.mul(Mat4(), Mat4.rotZ90, Mat4.rotX180);
    /** Rotation matrix for 90deg around first y-axis and then 180deg around z-axis */
    Mat4.rotY90Z180 = Mat4.mul(Mat4(), Mat4.rotY90, Mat4.rotZ180);
    /** Identity matrix */
    Mat4.id = Mat4.identity();
})(Mat4 || (Mat4 = {}));
/* harmony default export */ __webpack_exports__["default"] = (Mat4);
//# sourceMappingURL=mat4.js.map

/***/ }),

/***/ "./lib/mol-math/linear-algebra/3d/minimize-rmsd.js":
/*!*********************************************************!*\
  !*** ./lib/mol-math/linear-algebra/3d/minimize-rmsd.js ***!
  \*********************************************************/
/*! exports provided: MinimizeRmsd */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MinimizeRmsd", function() { return MinimizeRmsd; });
/* harmony import */ var _mat4__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./mat4 */ "./lib/mol-math/linear-algebra/3d/mat4.js");
/* harmony import */ var _matrix_evd__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../matrix/evd */ "./lib/mol-math/linear-algebra/matrix/evd.js");
/* harmony import */ var _mol_math_geometry_centroid_helper__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../../mol-math/geometry/centroid-helper */ "./lib/mol-math/geometry/centroid-helper.js");
/* harmony import */ var _matrix_matrix__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../matrix/matrix */ "./lib/mol-math/linear-algebra/matrix/matrix.js");
/* harmony import */ var _geometry_primitives_sphere3d__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../geometry/primitives/sphere3d */ "./lib/mol-math/geometry/primitives/sphere3d.js");
/**
 * Copyright (c) 2019 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author David Sehnal <david.sehnal@gmail.com>
 */






var MinimizeRmsd;
(function (MinimizeRmsd) {
    var Positions;
    (function (Positions) {
        function empty(n) {
            return { x: new Float64Array(n), y: new Float64Array(n), z: new Float64Array(n) };
        }
        Positions.empty = empty;
    })(Positions = MinimizeRmsd.Positions || (MinimizeRmsd.Positions = {}));
    function compute(data, result) {
        if (typeof result === 'undefined')
            result = { bTransform: _mat4__WEBPACK_IMPORTED_MODULE_0__["default"].zero(), rmsd: 0.0 };
        findMinimalRmsdTransformImpl(new RmsdTransformState(data, result));
        return result;
    }
    MinimizeRmsd.compute = compute;
})(MinimizeRmsd || (MinimizeRmsd = {}));
var RmsdTransformState = /** @class */ (function () {
    function RmsdTransformState(data, into) {
        this.evdCache = _matrix_evd__WEBPACK_IMPORTED_MODULE_1__["EVD"].createCache(4);
        this.translateB = _mat4__WEBPACK_IMPORTED_MODULE_0__["default"].identity();
        this.rotateB = _mat4__WEBPACK_IMPORTED_MODULE_0__["default"].identity();
        this.tempMatrix = _mat4__WEBPACK_IMPORTED_MODULE_0__["default"].identity();
        this.a = data.a;
        this.b = data.b;
        if (data.centerA)
            this.centerA = data.centerA;
        else
            this.centerA = data.centerA = _mol_math_geometry_centroid_helper__WEBPACK_IMPORTED_MODULE_2__["CentroidHelper"].fromArrays(data.a, Object(_geometry_primitives_sphere3d__WEBPACK_IMPORTED_MODULE_4__["Sphere3D"])()).center;
        if (data.centerB)
            this.centerB = data.centerB;
        else
            this.centerB = data.centerB = _mol_math_geometry_centroid_helper__WEBPACK_IMPORTED_MODULE_2__["CentroidHelper"].fromArrays(data.b, Object(_geometry_primitives_sphere3d__WEBPACK_IMPORTED_MODULE_4__["Sphere3D"])()).center;
        this.result = into;
    }
    return RmsdTransformState;
}());
function computeN(state) {
    var N = state.evdCache.matrix;
    _matrix_matrix__WEBPACK_IMPORTED_MODULE_3__["default"].makeZero(N);
    var xsA = state.a.x, ysA = state.a.y, zsA = state.a.z;
    var xsB = state.b.x, ysB = state.b.y, zsB = state.b.z;
    var cA = state.centerA;
    var cB = state.centerB;
    var sizeSq = 0.0;
    for (var i = 0, _l = state.a.x.length; i < _l; i++) {
        var aX = xsA[i] - cA[0], aY = ysA[i] - cA[1], aZ = zsA[i] - cA[2];
        var bX = xsB[i] - cB[0], bY = ysB[i] - cB[1], bZ = zsB[i] - cB[2];
        sizeSq += aX * aX + aY * aY + aZ * aZ + bX * bX + bY * bY + bZ * bZ;
        _matrix_matrix__WEBPACK_IMPORTED_MODULE_3__["default"].add(N, 0, 0, aX * bX + aY * bY + aZ * bZ);
        _matrix_matrix__WEBPACK_IMPORTED_MODULE_3__["default"].add(N, 0, 1, -(aZ * bY) + aY * bZ);
        _matrix_matrix__WEBPACK_IMPORTED_MODULE_3__["default"].add(N, 0, 2, aZ * bX - aX * bZ);
        _matrix_matrix__WEBPACK_IMPORTED_MODULE_3__["default"].add(N, 0, 3, -(aY * bX) + aX * bY);
        _matrix_matrix__WEBPACK_IMPORTED_MODULE_3__["default"].add(N, 1, 0, -(aZ * bY) + aY * bZ);
        _matrix_matrix__WEBPACK_IMPORTED_MODULE_3__["default"].add(N, 1, 1, aX * bX - aY * bY - aZ * bZ);
        _matrix_matrix__WEBPACK_IMPORTED_MODULE_3__["default"].add(N, 1, 2, aY * bX + aX * bY);
        _matrix_matrix__WEBPACK_IMPORTED_MODULE_3__["default"].add(N, 1, 3, aZ * bX + aX * bZ);
        _matrix_matrix__WEBPACK_IMPORTED_MODULE_3__["default"].add(N, 2, 0, aZ * bX - aX * bZ);
        _matrix_matrix__WEBPACK_IMPORTED_MODULE_3__["default"].add(N, 2, 1, aY * bX + aX * bY);
        _matrix_matrix__WEBPACK_IMPORTED_MODULE_3__["default"].add(N, 2, 2, -(aX * bX) + aY * bY - aZ * bZ);
        _matrix_matrix__WEBPACK_IMPORTED_MODULE_3__["default"].add(N, 2, 3, aZ * bY + aY * bZ);
        _matrix_matrix__WEBPACK_IMPORTED_MODULE_3__["default"].add(N, 3, 0, -(aY * bX) + aX * bY);
        _matrix_matrix__WEBPACK_IMPORTED_MODULE_3__["default"].add(N, 3, 1, aZ * bX + aX * bZ);
        _matrix_matrix__WEBPACK_IMPORTED_MODULE_3__["default"].add(N, 3, 2, aZ * bY + aY * bZ);
        _matrix_matrix__WEBPACK_IMPORTED_MODULE_3__["default"].add(N, 3, 3, -(aX * bX) - aY * bY + aZ * bZ);
        // conjugate instead of transpose.
        // var l = new Quaternion(-a.X, -a.Y, -a.Z, 0).RightMultiplicationToMatrix();
        // l.Transpose();
        // var r = new Quaternion(b.X, b.Y, b.Z, 0).LeftMultiplicationToMatrix();
        // N += l * r;
    }
    return sizeSq;
}
function makeTransformMatrix(state) {
    var ev = state.evdCache.matrix;
    var qX = _matrix_matrix__WEBPACK_IMPORTED_MODULE_3__["default"].get(ev, 1, 3);
    var qY = _matrix_matrix__WEBPACK_IMPORTED_MODULE_3__["default"].get(ev, 2, 3);
    var qZ = _matrix_matrix__WEBPACK_IMPORTED_MODULE_3__["default"].get(ev, 3, 3);
    var qW = _matrix_matrix__WEBPACK_IMPORTED_MODULE_3__["default"].get(ev, 0, 3);
    var n1 = 2 * qY * qY;
    var n2 = 2 * qZ * qZ;
    var n3 = 2 * qX * qX;
    var n4 = 2 * qX * qY;
    var n5 = 2 * qW * qZ;
    var n6 = 2 * qX * qZ;
    var n7 = 2 * qW * qY;
    var n8 = 2 * qY * qZ;
    var n9 = 2 * qW * qX;
    var m = state.translateB;
    // translation to center
    _mat4__WEBPACK_IMPORTED_MODULE_0__["default"].setValue(m, 0, 3, -state.centerB[0]);
    _mat4__WEBPACK_IMPORTED_MODULE_0__["default"].setValue(m, 1, 3, -state.centerB[1]);
    _mat4__WEBPACK_IMPORTED_MODULE_0__["default"].setValue(m, 2, 3, -state.centerB[2]);
    m = state.rotateB;
    // rotation
    _mat4__WEBPACK_IMPORTED_MODULE_0__["default"].setValue(m, 0, 0, 1 - n1 - n2);
    _mat4__WEBPACK_IMPORTED_MODULE_0__["default"].setValue(m, 0, 1, n4 + n5);
    _mat4__WEBPACK_IMPORTED_MODULE_0__["default"].setValue(m, 0, 2, n6 - n7);
    _mat4__WEBPACK_IMPORTED_MODULE_0__["default"].setValue(m, 1, 0, n4 - n5);
    _mat4__WEBPACK_IMPORTED_MODULE_0__["default"].setValue(m, 1, 1, 1 - n3 - n2);
    _mat4__WEBPACK_IMPORTED_MODULE_0__["default"].setValue(m, 1, 2, n8 + n9);
    _mat4__WEBPACK_IMPORTED_MODULE_0__["default"].setValue(m, 2, 0, n6 + n7);
    _mat4__WEBPACK_IMPORTED_MODULE_0__["default"].setValue(m, 2, 1, n8 - n9);
    _mat4__WEBPACK_IMPORTED_MODULE_0__["default"].setValue(m, 2, 2, 1 - n3 - n1);
    _mat4__WEBPACK_IMPORTED_MODULE_0__["default"].setValue(m, 3, 3, 1);
    _mat4__WEBPACK_IMPORTED_MODULE_0__["default"].mul(state.tempMatrix, state.rotateB, state.translateB);
    m = state.translateB;
    // translation to center
    _mat4__WEBPACK_IMPORTED_MODULE_0__["default"].setValue(m, 0, 3, state.centerA[0]);
    _mat4__WEBPACK_IMPORTED_MODULE_0__["default"].setValue(m, 1, 3, state.centerA[1]);
    _mat4__WEBPACK_IMPORTED_MODULE_0__["default"].setValue(m, 2, 3, state.centerA[2]);
    _mat4__WEBPACK_IMPORTED_MODULE_0__["default"].mul(state.result.bTransform, state.translateB, state.tempMatrix);
}
function findMinimalRmsdTransformImpl(state) {
    var sizeSq = computeN(state);
    _matrix_evd__WEBPACK_IMPORTED_MODULE_1__["EVD"].compute(state.evdCache);
    var rmsd = sizeSq - 2.0 * state.evdCache.eigenValues[3];
    rmsd = rmsd < 0.0 ? 0.0 : Math.sqrt(rmsd / state.a.x.length);
    makeTransformMatrix(state);
    state.result.rmsd = rmsd;
}
//# sourceMappingURL=minimize-rmsd.js.map

/***/ }),

/***/ "./lib/mol-math/linear-algebra/3d/quat.js":
/*!************************************************!*\
  !*** ./lib/mol-math/linear-algebra/3d/quat.js ***!
  \************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _mat3__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./mat3 */ "./lib/mol-math/linear-algebra/3d/mat3.js");
/* harmony import */ var _vec3__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./vec3 */ "./lib/mol-math/linear-algebra/3d/vec3.js");
/* harmony import */ var _common__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./common */ "./lib/mol-math/linear-algebra/3d/common.js");
/**
 * Copyright (c) 2017-2018 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author David Sehnal <david.sehnal@gmail.com>
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */
/*
 * This code has been modified from https://github.com/toji/gl-matrix/,
 * copyright (c) 2015, Brandon Jones, Colin MacKenzie IV.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 */
/*
 * Quat.fromUnitVec3 has been modified from https://github.com/Jam3/quat-from-unit-vec3,
 * copyright (c) 2015 Jam3. MIT License
 */



function Quat() {
    return Quat.zero();
}
(function (Quat) {
    function zero() {
        // force double backing array by 0.1.
        var ret = [0.1, 0, 0, 0];
        ret[0] = 0.0;
        return ret;
    }
    Quat.zero = zero;
    function identity() {
        var out = zero();
        out[3] = 1;
        return out;
    }
    Quat.identity = identity;
    function setIdentity(out) {
        out[0] = 0;
        out[1] = 0;
        out[2] = 0;
        out[3] = 1;
    }
    Quat.setIdentity = setIdentity;
    function hasNaN(q) {
        return isNaN(q[0]) || isNaN(q[1]) || isNaN(q[2]) || isNaN(q[3]);
    }
    Quat.hasNaN = hasNaN;
    function create(x, y, z, w) {
        var out = identity();
        out[0] = x;
        out[1] = y;
        out[2] = z;
        out[3] = w;
        return out;
    }
    Quat.create = create;
    function setAxisAngle(out, axis, rad) {
        rad = rad * 0.5;
        var s = Math.sin(rad);
        out[0] = s * axis[0];
        out[1] = s * axis[1];
        out[2] = s * axis[2];
        out[3] = Math.cos(rad);
        return out;
    }
    Quat.setAxisAngle = setAxisAngle;
    /**
     * Gets the rotation axis and angle for a given
     *  quaternion. If a quaternion is created with
     *  setAxisAngle, this method will return the same
     *  values as providied in the original parameter list
     *  OR functionally equivalent values.
     * Example: The quaternion formed by axis [0, 0, 1] and
     *  angle -90 is the same as the quaternion formed by
     *  [0, 0, 1] and 270. This method favors the latter.
     */
    function getAxisAngle(out_axis, q) {
        var rad = Math.acos(q[3]) * 2.0;
        var s = Math.sin(rad / 2.0);
        if (s !== 0.0) {
            out_axis[0] = q[0] / s;
            out_axis[1] = q[1] / s;
            out_axis[2] = q[2] / s;
        }
        else {
            // If s is zero, return any axis (no rotation - axis does not matter)
            out_axis[0] = 1;
            out_axis[1] = 0;
            out_axis[2] = 0;
        }
        return rad;
    }
    Quat.getAxisAngle = getAxisAngle;
    function multiply(out, a, b) {
        var ax = a[0], ay = a[1], az = a[2], aw = a[3];
        var bx = b[0], by = b[1], bz = b[2], bw = b[3];
        out[0] = ax * bw + aw * bx + ay * bz - az * by;
        out[1] = ay * bw + aw * by + az * bx - ax * bz;
        out[2] = az * bw + aw * bz + ax * by - ay * bx;
        out[3] = aw * bw - ax * bx - ay * by - az * bz;
        return out;
    }
    Quat.multiply = multiply;
    function rotateX(out, a, rad) {
        rad *= 0.5;
        var ax = a[0], ay = a[1], az = a[2], aw = a[3];
        var bx = Math.sin(rad), bw = Math.cos(rad);
        out[0] = ax * bw + aw * bx;
        out[1] = ay * bw + az * bx;
        out[2] = az * bw - ay * bx;
        out[3] = aw * bw - ax * bx;
        return out;
    }
    Quat.rotateX = rotateX;
    function rotateY(out, a, rad) {
        rad *= 0.5;
        var ax = a[0], ay = a[1], az = a[2], aw = a[3];
        var by = Math.sin(rad), bw = Math.cos(rad);
        out[0] = ax * bw - az * by;
        out[1] = ay * bw + aw * by;
        out[2] = az * bw + ax * by;
        out[3] = aw * bw - ay * by;
        return out;
    }
    Quat.rotateY = rotateY;
    function rotateZ(out, a, rad) {
        rad *= 0.5;
        var ax = a[0], ay = a[1], az = a[2], aw = a[3];
        var bz = Math.sin(rad), bw = Math.cos(rad);
        out[0] = ax * bw + ay * bz;
        out[1] = ay * bw - ax * bz;
        out[2] = az * bw + aw * bz;
        out[3] = aw * bw - az * bz;
        return out;
    }
    Quat.rotateZ = rotateZ;
    /**
     * Calculates the W component of a quat from the X, Y, and Z components.
     * Assumes that quaternion is 1 unit in length.
     * Any existing W component will be ignored.
     */
    function calculateW(out, a) {
        var x = a[0], y = a[1], z = a[2];
        out[0] = x;
        out[1] = y;
        out[2] = z;
        out[3] = Math.sqrt(Math.abs(1.0 - x * x - y * y - z * z));
        return out;
    }
    Quat.calculateW = calculateW;
    /**
     * Performs a spherical linear interpolation between two quat
     */
    function slerp(out, a, b, t) {
        // benchmarks:
        //    http://jsperf.com/quaternion-slerp-implementations
        var ax = a[0], ay = a[1], az = a[2], aw = a[3];
        var bx = b[0], by = b[1], bz = b[2], bw = b[3];
        var omega, cosom, sinom, scale0, scale1;
        // calc cosine
        cosom = ax * bx + ay * by + az * bz + aw * bw;
        // adjust signs (if necessary)
        if (cosom < 0.0) {
            cosom = -cosom;
            bx = -bx;
            by = -by;
            bz = -bz;
            bw = -bw;
        }
        // calculate coefficients
        if ((1.0 - cosom) > 0.000001) {
            // standard case (slerp)
            omega = Math.acos(cosom);
            sinom = Math.sin(omega);
            scale0 = Math.sin((1.0 - t) * omega) / sinom;
            scale1 = Math.sin(t * omega) / sinom;
        }
        else {
            // "from" and "to" quaternions are very close
            //  ... so we can do a linear interpolation
            scale0 = 1.0 - t;
            scale1 = t;
        }
        // calculate final values
        out[0] = scale0 * ax + scale1 * bx;
        out[1] = scale0 * ay + scale1 * by;
        out[2] = scale0 * az + scale1 * bz;
        out[3] = scale0 * aw + scale1 * bw;
        return out;
    }
    Quat.slerp = slerp;
    function invert(out, a) {
        var a0 = a[0], a1 = a[1], a2 = a[2], a3 = a[3];
        var dot = a0 * a0 + a1 * a1 + a2 * a2 + a3 * a3;
        var invDot = dot ? 1.0 / dot : 0;
        // TODO: Would be faster to return [0,0,0,0] immediately if dot == 0
        out[0] = -a0 * invDot;
        out[1] = -a1 * invDot;
        out[2] = -a2 * invDot;
        out[3] = a3 * invDot;
        return out;
    }
    Quat.invert = invert;
    /**
     * Calculates the conjugate of a quat
     * If the quaternion is normalized, this function is faster than quat.inverse and produces the same result.
     */
    function conjugate(out, a) {
        out[0] = -a[0];
        out[1] = -a[1];
        out[2] = -a[2];
        out[3] = a[3];
        return out;
    }
    Quat.conjugate = conjugate;
    /**
     * Creates a quaternion from the given 3x3 rotation matrix.
     *
     * NOTE: The resultant quaternion is not normalized, so you should be sure
     * to renormalize the quaternion yourself where necessary.
     */
    function fromMat3(out, m) {
        // Algorithm in Ken Shoemake's article in 1987 SIGGRAPH course notes
        // article "Quaternion Calculus and Fast Animation".
        var fTrace = m[0] + m[4] + m[8];
        var fRoot;
        if (fTrace > 0.0) {
            // |w| > 1/2, may as well choose w > 1/2
            fRoot = Math.sqrt(fTrace + 1.0); // 2w
            out[3] = 0.5 * fRoot;
            fRoot = 0.5 / fRoot; // 1/(4w)
            out[0] = (m[5] - m[7]) * fRoot;
            out[1] = (m[6] - m[2]) * fRoot;
            out[2] = (m[1] - m[3]) * fRoot;
        }
        else {
            // |w| <= 1/2
            var i = 0;
            if (m[4] > m[0])
                i = 1;
            if (m[8] > m[i * 3 + i])
                i = 2;
            var j = (i + 1) % 3;
            var k = (i + 2) % 3;
            fRoot = Math.sqrt(m[i * 3 + i] - m[j * 3 + j] - m[k * 3 + k] + 1.0);
            out[i] = 0.5 * fRoot;
            fRoot = 0.5 / fRoot;
            out[3] = (m[j * 3 + k] - m[k * 3 + j]) * fRoot;
            out[j] = (m[j * 3 + i] + m[i * 3 + j]) * fRoot;
            out[k] = (m[k * 3 + i] + m[i * 3 + k]) * fRoot;
        }
        return out;
    }
    Quat.fromMat3 = fromMat3;
    var fromUnitVec3Temp = Object(_vec3__WEBPACK_IMPORTED_MODULE_1__["default"])();
    /** Quaternion from two normalized unit vectors. */
    function fromUnitVec3(out, a, b) {
        // assumes a and b are normalized
        var r = _vec3__WEBPACK_IMPORTED_MODULE_1__["default"].dot(a, b) + 1;
        if (r < _common__WEBPACK_IMPORTED_MODULE_2__["EPSILON"]) {
            // If u and v are exactly opposite, rotate 180 degrees
            // around an arbitrary orthogonal axis. Axis normalisation
            // can happen later, when we normalise the quaternion.
            r = 0;
            if (Math.abs(a[0]) > Math.abs(a[2])) {
                _vec3__WEBPACK_IMPORTED_MODULE_1__["default"].set(fromUnitVec3Temp, -a[1], a[0], 0);
            }
            else {
                _vec3__WEBPACK_IMPORTED_MODULE_1__["default"].set(fromUnitVec3Temp, 0, -a[2], a[1]);
            }
        }
        else {
            // Otherwise, build quaternion the standard way.
            _vec3__WEBPACK_IMPORTED_MODULE_1__["default"].cross(fromUnitVec3Temp, a, b);
        }
        out[0] = fromUnitVec3Temp[0];
        out[1] = fromUnitVec3Temp[1];
        out[2] = fromUnitVec3Temp[2];
        out[3] = r;
        normalize(out, out);
        return out;
    }
    Quat.fromUnitVec3 = fromUnitVec3;
    function clone(a) {
        var out = zero();
        out[0] = a[0];
        out[1] = a[1];
        out[2] = a[2];
        out[3] = a[3];
        return out;
    }
    Quat.clone = clone;
    function toArray(a, out, offset) {
        out[offset + 0] = a[0];
        out[offset + 1] = a[1];
        out[offset + 2] = a[2];
        out[offset + 3] = a[3];
        return out;
    }
    Quat.toArray = toArray;
    function fromArray(a, array, offset) {
        a[0] = array[offset + 0];
        a[1] = array[offset + 1];
        a[2] = array[offset + 2];
        a[3] = array[offset + 3];
        return a;
    }
    Quat.fromArray = fromArray;
    function copy(out, a) {
        out[0] = a[0];
        out[1] = a[1];
        out[2] = a[2];
        out[3] = a[3];
        return out;
    }
    Quat.copy = copy;
    function set(out, x, y, z, w) {
        out[0] = x;
        out[1] = y;
        out[2] = z;
        out[3] = w;
        return out;
    }
    Quat.set = set;
    function add(out, a, b) {
        out[0] = a[0] + b[0];
        out[1] = a[1] + b[1];
        out[2] = a[2] + b[2];
        out[3] = a[3] + b[3];
        return out;
    }
    Quat.add = add;
    function normalize(out, a) {
        var x = a[0];
        var y = a[1];
        var z = a[2];
        var w = a[3];
        var len = x * x + y * y + z * z + w * w;
        if (len > 0) {
            len = 1 / Math.sqrt(len);
            out[0] = x * len;
            out[1] = y * len;
            out[2] = z * len;
            out[3] = w * len;
        }
        return out;
    }
    Quat.normalize = normalize;
    /**
     * Sets a quaternion to represent the shortest rotation from one
     * vector to another.
     *
     * Both vectors are assumed to be unit length.
     */
    var rotTmpVec3 = Object(_vec3__WEBPACK_IMPORTED_MODULE_1__["default"])();
    var rotTmpVec3UnitX = _vec3__WEBPACK_IMPORTED_MODULE_1__["default"].create(1, 0, 0);
    var rotTmpVec3UnitY = _vec3__WEBPACK_IMPORTED_MODULE_1__["default"].create(0, 1, 0);
    function rotationTo(out, a, b) {
        var dot = _vec3__WEBPACK_IMPORTED_MODULE_1__["default"].dot(a, b);
        if (dot < -0.999999) {
            _vec3__WEBPACK_IMPORTED_MODULE_1__["default"].cross(rotTmpVec3, rotTmpVec3UnitX, a);
            if (_vec3__WEBPACK_IMPORTED_MODULE_1__["default"].magnitude(rotTmpVec3) < 0.000001)
                _vec3__WEBPACK_IMPORTED_MODULE_1__["default"].cross(rotTmpVec3, rotTmpVec3UnitY, a);
            _vec3__WEBPACK_IMPORTED_MODULE_1__["default"].normalize(rotTmpVec3, rotTmpVec3);
            setAxisAngle(out, rotTmpVec3, Math.PI);
            return out;
        }
        else if (dot > 0.999999) {
            out[0] = 0;
            out[1] = 0;
            out[2] = 0;
            out[3] = 1;
            return out;
        }
        else {
            _vec3__WEBPACK_IMPORTED_MODULE_1__["default"].cross(rotTmpVec3, a, b);
            out[0] = rotTmpVec3[0];
            out[1] = rotTmpVec3[1];
            out[2] = rotTmpVec3[2];
            out[3] = 1 + dot;
            return normalize(out, out);
        }
    }
    Quat.rotationTo = rotationTo;
    /**
     * Performs a spherical linear interpolation with two control points
     */
    var sqlerpTemp1 = Quat();
    var sqlerpTemp2 = Quat();
    function sqlerp(out, a, b, c, d, t) {
        slerp(sqlerpTemp1, a, d, t);
        slerp(sqlerpTemp2, b, c, t);
        slerp(out, sqlerpTemp1, sqlerpTemp2, 2 * t * (1 - t));
        return out;
    }
    Quat.sqlerp = sqlerp;
    /**
     * Sets the specified quaternion with values corresponding to the given
     * axes. Each axis is a vec3 and is expected to be unit length and
     * perpendicular to all other specified axes.
     */
    var axesTmpMat = Object(_mat3__WEBPACK_IMPORTED_MODULE_0__["default"])();
    function setAxes(out, view, right, up) {
        axesTmpMat[0] = right[0];
        axesTmpMat[3] = right[1];
        axesTmpMat[6] = right[2];
        axesTmpMat[1] = up[0];
        axesTmpMat[4] = up[1];
        axesTmpMat[7] = up[2];
        axesTmpMat[2] = -view[0];
        axesTmpMat[5] = -view[1];
        axesTmpMat[8] = -view[2];
        return normalize(out, Quat.fromMat3(out, axesTmpMat));
    }
    Quat.setAxes = setAxes;
    function toString(a, precision) {
        return "[" + a[0].toPrecision(precision) + " " + a[1].toPrecision(precision) + " " + a[2].toPrecision(precision) + "  " + a[3].toPrecision(precision) + "]";
    }
    Quat.toString = toString;
    Quat.Identity = identity();
})(Quat || (Quat = {}));
/* harmony default export */ __webpack_exports__["default"] = (Quat);
//# sourceMappingURL=quat.js.map

/***/ }),

/***/ "./lib/mol-math/linear-algebra/3d/vec2.js":
/*!************************************************!*\
  !*** ./lib/mol-math/linear-algebra/3d/vec2.js ***!
  \************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/**
 * Copyright (c) 2018 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */
function Vec2() {
    return Vec2.zero();
}
(function (Vec2) {
    function zero() {
        // force double backing array by 0.1.
        var ret = [0.1, 0];
        ret[0] = 0.0;
        return ret;
    }
    Vec2.zero = zero;
    function clone(a) {
        var out = zero();
        out[0] = a[0];
        out[1] = a[1];
        return out;
    }
    Vec2.clone = clone;
    function create(x, y) {
        var out = zero();
        out[0] = x;
        out[1] = y;
        return out;
    }
    Vec2.create = create;
    function hasNaN(a) {
        return isNaN(a[0]) || isNaN(a[1]);
    }
    Vec2.hasNaN = hasNaN;
    function toArray(a, out, offset) {
        out[offset + 0] = a[0];
        out[offset + 1] = a[1];
        return out;
    }
    Vec2.toArray = toArray;
    function fromArray(a, array, offset) {
        a[0] = array[offset + 0];
        a[1] = array[offset + 1];
        return a;
    }
    Vec2.fromArray = fromArray;
    function copy(out, a) {
        out[0] = a[0];
        out[1] = a[1];
        return out;
    }
    Vec2.copy = copy;
    function set(out, x, y) {
        out[0] = x;
        out[1] = y;
        return out;
    }
    Vec2.set = set;
    function add(out, a, b) {
        out[0] = a[0] + b[0];
        out[1] = a[1] + b[1];
        return out;
    }
    Vec2.add = add;
    function sub(out, a, b) {
        out[0] = a[0] - b[0];
        out[1] = a[1] - b[1];
        return out;
    }
    Vec2.sub = sub;
    function mul(out, a, b) {
        out[0] = a[0] * b[0];
        out[1] = a[1] * b[1];
        return out;
    }
    Vec2.mul = mul;
    function div(out, a, b) {
        out[0] = a[0] / b[0];
        out[1] = a[1] / b[1];
        return out;
    }
    Vec2.div = div;
    function scale(out, a, b) {
        out[0] = a[0] * b;
        out[1] = a[1] * b;
        return out;
    }
    Vec2.scale = scale;
    /**
     * Math.round the components of a Vec2
     */
    function round(out, a) {
        out[0] = Math.round(a[0]);
        out[1] = Math.round(a[1]);
        return out;
    }
    Vec2.round = round;
    /**
     * Math.ceil the components of a Vec2
     */
    function ceil(out, a) {
        out[0] = Math.ceil(a[0]);
        out[1] = Math.ceil(a[1]);
        return out;
    }
    Vec2.ceil = ceil;
    /**
     * Math.floor the components of a Vec2
     */
    function floor(out, a) {
        out[0] = Math.floor(a[0]);
        out[1] = Math.floor(a[1]);
        return out;
    }
    Vec2.floor = floor;
    function distance(a, b) {
        var x = b[0] - a[0], y = b[1] - a[1];
        return Math.sqrt(x * x + y * y);
    }
    Vec2.distance = distance;
    function squaredDistance(a, b) {
        var x = b[0] - a[0], y = b[1] - a[1];
        return x * x + y * y;
    }
    Vec2.squaredDistance = squaredDistance;
    function magnitude(a) {
        var x = a[0], y = a[1];
        return Math.sqrt(x * x + y * y);
    }
    Vec2.magnitude = magnitude;
    function squaredMagnitude(a) {
        var x = a[0], y = a[1];
        return x * x + y * y;
    }
    Vec2.squaredMagnitude = squaredMagnitude;
    /**
     * Returns the inverse of the components of a Vec2
     */
    function inverse(out, a) {
        out[0] = 1.0 / a[0];
        out[1] = 1.0 / a[1];
        return out;
    }
    Vec2.inverse = inverse;
    function areEqual(a, b) {
        return a[0] === b[0] && a[1] === b[1];
    }
    Vec2.areEqual = areEqual;
    function toString(a, precision) {
        return "[" + a[0].toPrecision(precision) + " " + a[1].toPrecision(precision) + "}]";
    }
    Vec2.toString = toString;
})(Vec2 || (Vec2 = {}));
/* harmony default export */ __webpack_exports__["default"] = (Vec2);
//# sourceMappingURL=vec2.js.map

/***/ }),

/***/ "./lib/mol-math/linear-algebra/3d/vec3.js":
/*!************************************************!*\
  !*** ./lib/mol-math/linear-algebra/3d/vec3.js ***!
  \************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _mat4__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./mat4 */ "./lib/mol-math/linear-algebra/3d/mat4.js");
/* harmony import */ var _3d__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../3d */ "./lib/mol-math/linear-algebra/3d.js");
/* harmony import */ var _interpolate__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../interpolate */ "./lib/mol-math/interpolate.js");
/**
 * Copyright (c) 2017-2020 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author David Sehnal <david.sehnal@gmail.com>
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */
/*
 * This code has been modified from https://github.com/toji/gl-matrix/,
 * copyright (c) 2015, Brandon Jones, Colin MacKenzie IV.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 */



function Vec3() {
    return Vec3.zero();
}
(function (Vec3) {
    function zero() {
        var out = [0.1, 0.0, 0.0];
        out[0] = 0;
        return out;
    }
    Vec3.zero = zero;
    function clone(a) {
        var out = zero();
        out[0] = a[0];
        out[1] = a[1];
        out[2] = a[2];
        return out;
    }
    Vec3.clone = clone;
    function hasNaN(a) {
        return isNaN(a[0]) || isNaN(a[1]) || isNaN(a[2]);
    }
    Vec3.hasNaN = hasNaN;
    function setNaN(out) {
        out[0] = NaN;
        out[1] = NaN;
        out[2] = NaN;
        return out;
    }
    Vec3.setNaN = setNaN;
    function fromObj(v) {
        return create(v.x, v.y, v.z);
    }
    Vec3.fromObj = fromObj;
    function toObj(v) {
        return { x: v[0], y: v[1], z: v[2] };
    }
    Vec3.toObj = toObj;
    function fromArray(v, array, offset) {
        v[0] = array[offset + 0];
        v[1] = array[offset + 1];
        v[2] = array[offset + 2];
        return v;
    }
    Vec3.fromArray = fromArray;
    function toArray(v, out, offset) {
        out[offset + 0] = v[0];
        out[offset + 1] = v[1];
        out[offset + 2] = v[2];
        return out;
    }
    Vec3.toArray = toArray;
    function create(x, y, z) {
        var out = zero();
        out[0] = x;
        out[1] = y;
        out[2] = z;
        return out;
    }
    Vec3.create = create;
    function ofArray(array) {
        var out = zero();
        out[0] = array[0];
        out[1] = array[1];
        out[2] = array[2];
        return out;
    }
    Vec3.ofArray = ofArray;
    function set(out, x, y, z) {
        out[0] = x;
        out[1] = y;
        out[2] = z;
        return out;
    }
    Vec3.set = set;
    function copy(out, a) {
        out[0] = a[0];
        out[1] = a[1];
        out[2] = a[2];
        return out;
    }
    Vec3.copy = copy;
    function add(out, a, b) {
        out[0] = a[0] + b[0];
        out[1] = a[1] + b[1];
        out[2] = a[2] + b[2];
        return out;
    }
    Vec3.add = add;
    function sub(out, a, b) {
        out[0] = a[0] - b[0];
        out[1] = a[1] - b[1];
        out[2] = a[2] - b[2];
        return out;
    }
    Vec3.sub = sub;
    function mul(out, a, b) {
        out[0] = a[0] * b[0];
        out[1] = a[1] * b[1];
        out[2] = a[2] * b[2];
        return out;
    }
    Vec3.mul = mul;
    function div(out, a, b) {
        out[0] = a[0] / b[0];
        out[1] = a[1] / b[1];
        out[2] = a[2] / b[2];
        return out;
    }
    Vec3.div = div;
    function scale(out, a, b) {
        out[0] = a[0] * b;
        out[1] = a[1] * b;
        out[2] = a[2] * b;
        return out;
    }
    Vec3.scale = scale;
    /** Scales b, then adds a and b together */
    function scaleAndAdd(out, a, b, scale) {
        out[0] = a[0] + (b[0] * scale);
        out[1] = a[1] + (b[1] * scale);
        out[2] = a[2] + (b[2] * scale);
        return out;
    }
    Vec3.scaleAndAdd = scaleAndAdd;
    /** Scales b, then subtracts b from a */
    function scaleAndSub(out, a, b, scale) {
        out[0] = a[0] - (b[0] * scale);
        out[1] = a[1] - (b[1] * scale);
        out[2] = a[2] - (b[2] * scale);
        return out;
    }
    Vec3.scaleAndSub = scaleAndSub;
    function addScalar(out, a, b) {
        out[0] = a[0] + b;
        out[1] = a[1] + b;
        out[2] = a[2] + b;
        return out;
    }
    Vec3.addScalar = addScalar;
    function subScalar(out, a, b) {
        out[0] = a[0] - b;
        out[1] = a[1] - b;
        out[2] = a[2] - b;
        return out;
    }
    Vec3.subScalar = subScalar;
    /**
     * Math.round the components of a Vec3
     */
    function round(out, a) {
        out[0] = Math.round(a[0]);
        out[1] = Math.round(a[1]);
        out[2] = Math.round(a[2]);
        return out;
    }
    Vec3.round = round;
    /**
     * Math.ceil the components of a Vec3
     */
    function ceil(out, a) {
        out[0] = Math.ceil(a[0]);
        out[1] = Math.ceil(a[1]);
        out[2] = Math.ceil(a[2]);
        return out;
    }
    Vec3.ceil = ceil;
    /**
     * Math.floor the components of a Vec3
     */
    function floor(out, a) {
        out[0] = Math.floor(a[0]);
        out[1] = Math.floor(a[1]);
        out[2] = Math.floor(a[2]);
        return out;
    }
    Vec3.floor = floor;
    /**
     * Math.trunc the components of a Vec3
     */
    function trunc(out, a) {
        out[0] = Math.trunc(a[0]);
        out[1] = Math.trunc(a[1]);
        out[2] = Math.trunc(a[2]);
        return out;
    }
    Vec3.trunc = trunc;
    /**
     * Math.abs the components of a Vec3
     */
    function abs(out, a) {
        out[0] = Math.abs(a[0]);
        out[1] = Math.abs(a[1]);
        out[2] = Math.abs(a[2]);
        return out;
    }
    Vec3.abs = abs;
    /**
     * Returns the minimum of two Vec3's
     */
    function min(out, a, b) {
        out[0] = Math.min(a[0], b[0]);
        out[1] = Math.min(a[1], b[1]);
        out[2] = Math.min(a[2], b[2]);
        return out;
    }
    Vec3.min = min;
    /**
     * Returns the maximum of two Vec3's
     */
    function max(out, a, b) {
        out[0] = Math.max(a[0], b[0]);
        out[1] = Math.max(a[1], b[1]);
        out[2] = Math.max(a[2], b[2]);
        return out;
    }
    Vec3.max = max;
    function distance(a, b) {
        var x = b[0] - a[0], y = b[1] - a[1], z = b[2] - a[2];
        return Math.sqrt(x * x + y * y + z * z);
    }
    Vec3.distance = distance;
    function squaredDistance(a, b) {
        var x = b[0] - a[0], y = b[1] - a[1], z = b[2] - a[2];
        return x * x + y * y + z * z;
    }
    Vec3.squaredDistance = squaredDistance;
    function magnitude(a) {
        var x = a[0], y = a[1], z = a[2];
        return Math.sqrt(x * x + y * y + z * z);
    }
    Vec3.magnitude = magnitude;
    function squaredMagnitude(a) {
        var x = a[0], y = a[1], z = a[2];
        return x * x + y * y + z * z;
    }
    Vec3.squaredMagnitude = squaredMagnitude;
    function setMagnitude(out, a, l) {
        return Vec3.scale(out, Vec3.normalize(out, a), l);
    }
    Vec3.setMagnitude = setMagnitude;
    /**
     * Negates the components of a vec3
     */
    function negate(out, a) {
        out[0] = -a[0];
        out[1] = -a[1];
        out[2] = -a[2];
        return out;
    }
    Vec3.negate = negate;
    /**
     * Returns the inverse of the components of a Vec3
     */
    function inverse(out, a) {
        out[0] = 1.0 / a[0];
        out[1] = 1.0 / a[1];
        out[2] = 1.0 / a[2];
        return out;
    }
    Vec3.inverse = inverse;
    function normalize(out, a) {
        var x = a[0], y = a[1], z = a[2];
        var len = x * x + y * y + z * z;
        if (len > 0) {
            len = 1 / Math.sqrt(len);
            out[0] = a[0] * len;
            out[1] = a[1] * len;
            out[2] = a[2] * len;
        }
        return out;
    }
    Vec3.normalize = normalize;
    function dot(a, b) {
        return a[0] * b[0] + a[1] * b[1] + a[2] * b[2];
    }
    Vec3.dot = dot;
    function cross(out, a, b) {
        var ax = a[0], ay = a[1], az = a[2], bx = b[0], by = b[1], bz = b[2];
        out[0] = ay * bz - az * by;
        out[1] = az * bx - ax * bz;
        out[2] = ax * by - ay * bx;
        return out;
    }
    Vec3.cross = cross;
    /**
     * Performs a linear interpolation between two Vec3's
     */
    function lerp(out, a, b, t) {
        var ax = a[0], ay = a[1], az = a[2];
        out[0] = ax + t * (b[0] - ax);
        out[1] = ay + t * (b[1] - ay);
        out[2] = az + t * (b[2] - az);
        return out;
    }
    Vec3.lerp = lerp;
    var slerpRelVec = zero();
    function slerp(out, a, b, t) {
        var dot = Object(_interpolate__WEBPACK_IMPORTED_MODULE_2__["clamp"])(Vec3.dot(a, b), -1, 1);
        var theta = Math.acos(dot) * t;
        Vec3.scaleAndAdd(slerpRelVec, b, a, -dot);
        Vec3.normalize(slerpRelVec, slerpRelVec);
        return Vec3.add(out, Vec3.scale(out, a, Math.cos(theta)), Vec3.scale(slerpRelVec, slerpRelVec, Math.sin(theta)));
    }
    Vec3.slerp = slerp;
    /**
     * Performs a hermite interpolation with two control points
     */
    function hermite(out, a, b, c, d, t) {
        var factorTimes2 = t * t;
        var factor1 = factorTimes2 * (2 * t - 3) + 1;
        var factor2 = factorTimes2 * (t - 2) + t;
        var factor3 = factorTimes2 * (t - 1);
        var factor4 = factorTimes2 * (3 - 2 * t);
        out[0] = a[0] * factor1 + b[0] * factor2 + c[0] * factor3 + d[0] * factor4;
        out[1] = a[1] * factor1 + b[1] * factor2 + c[1] * factor3 + d[1] * factor4;
        out[2] = a[2] * factor1 + b[2] * factor2 + c[2] * factor3 + d[2] * factor4;
        return out;
    }
    Vec3.hermite = hermite;
    /**
     * Performs a bezier interpolation with two control points
     */
    function bezier(out, a, b, c, d, t) {
        var inverseFactor = 1 - t;
        var inverseFactorTimesTwo = inverseFactor * inverseFactor;
        var factorTimes2 = t * t;
        var factor1 = inverseFactorTimesTwo * inverseFactor;
        var factor2 = 3 * t * inverseFactorTimesTwo;
        var factor3 = 3 * factorTimes2 * inverseFactor;
        var factor4 = factorTimes2 * t;
        out[0] = a[0] * factor1 + b[0] * factor2 + c[0] * factor3 + d[0] * factor4;
        out[1] = a[1] * factor1 + b[1] * factor2 + c[1] * factor3 + d[1] * factor4;
        out[2] = a[2] * factor1 + b[2] * factor2 + c[2] * factor3 + d[2] * factor4;
        return out;
    }
    Vec3.bezier = bezier;
    function quadraticBezier(out, a, b, c, t) {
        out[0] = Object(_interpolate__WEBPACK_IMPORTED_MODULE_2__["quadraticBezier"])(a[0], b[0], c[0], t);
        out[1] = Object(_interpolate__WEBPACK_IMPORTED_MODULE_2__["quadraticBezier"])(a[1], b[1], c[1], t);
        out[2] = Object(_interpolate__WEBPACK_IMPORTED_MODULE_2__["quadraticBezier"])(a[2], b[2], c[2], t);
        return out;
    }
    Vec3.quadraticBezier = quadraticBezier;
    /**
     * Performs a spline interpolation with two control points and a tension parameter
     */
    function spline(out, a, b, c, d, t, tension) {
        out[0] = Object(_interpolate__WEBPACK_IMPORTED_MODULE_2__["spline"])(a[0], b[0], c[0], d[0], t, tension);
        out[1] = Object(_interpolate__WEBPACK_IMPORTED_MODULE_2__["spline"])(a[1], b[1], c[1], d[1], t, tension);
        out[2] = Object(_interpolate__WEBPACK_IMPORTED_MODULE_2__["spline"])(a[2], b[2], c[2], d[2], t, tension);
        return out;
    }
    Vec3.spline = spline;
    /**
     * Generates a random vector with the given scale
     */
    function random(out, scale) {
        var r = Math.random() * 2.0 * Math.PI;
        var z = (Math.random() * 2.0) - 1.0;
        var zScale = Math.sqrt(1.0 - z * z) * scale;
        out[0] = Math.cos(r) * zScale;
        out[1] = Math.sin(r) * zScale;
        out[2] = z * scale;
        return out;
    }
    Vec3.random = random;
    /**
     * Transforms the Vec3 with a Mat4. 4th vector component is implicitly '1'
     */
    function transformMat4(out, a, m) {
        var x = a[0], y = a[1], z = a[2], w = 1 / ((m[3] * x + m[7] * y + m[11] * z + m[15]) || 1.0);
        out[0] = (m[0] * x + m[4] * y + m[8] * z + m[12]) * w;
        out[1] = (m[1] * x + m[5] * y + m[9] * z + m[13]) * w;
        out[2] = (m[2] * x + m[6] * y + m[10] * z + m[14]) * w;
        return out;
    }
    Vec3.transformMat4 = transformMat4;
    /**
     * Like `transformMat4` but with offsets into arrays
     */
    function transformMat4Offset(out, a, m, outO, aO, oM) {
        var x = a[0 + aO], y = a[1 + aO], z = a[2 + aO], w = 1 / ((m[3 + oM] * x + m[7 + oM] * y + m[11 + oM] * z + m[15 + oM]) || 1.0);
        out[0 + outO] = (m[0 + oM] * x + m[4 + oM] * y + m[8 + oM] * z + m[12 + oM]) * w;
        out[1 + outO] = (m[1 + oM] * x + m[5 + oM] * y + m[9 + oM] * z + m[13 + oM]) * w;
        out[2 + outO] = (m[2 + oM] * x + m[6 + oM] * y + m[10 + oM] * z + m[14 + oM]) * w;
        return out;
    }
    Vec3.transformMat4Offset = transformMat4Offset;
    /**
     * Transforms the Vec3 with a Mat3.
     */
    function transformMat3(out, a, m) {
        var x = a[0], y = a[1], z = a[2];
        out[0] = x * m[0] + y * m[3] + z * m[6];
        out[1] = x * m[1] + y * m[4] + z * m[7];
        out[2] = x * m[2] + y * m[5] + z * m[8];
        return out;
    }
    Vec3.transformMat3 = transformMat3;
    /** Transforms the Vec3 with a quat */
    function transformQuat(out, a, q) {
        // benchmarks: http://jsperf.com/quaternion-transform-vec3-implementations
        var x = a[0], y = a[1], z = a[2];
        var qx = q[0], qy = q[1], qz = q[2], qw = q[3];
        // calculate quat * vec
        var ix = qw * x + qy * z - qz * y;
        var iy = qw * y + qz * x - qx * z;
        var iz = qw * z + qx * y - qy * x;
        var iw = -qx * x - qy * y - qz * z;
        // calculate result * inverse quat
        out[0] = ix * qw + iw * -qx + iy * -qz - iz * -qy;
        out[1] = iy * qw + iw * -qy + iz * -qx - ix * -qz;
        out[2] = iz * qw + iw * -qz + ix * -qy - iy * -qx;
        return out;
    }
    Vec3.transformQuat = transformQuat;
    /** Computes the angle between 2 vectors, reports in radians. */
    function angle(a, b) {
        var theta = dot(a, b) / Math.sqrt(squaredMagnitude(a) * squaredMagnitude(b));
        return Math.acos(Object(_interpolate__WEBPACK_IMPORTED_MODULE_2__["clamp"])(theta, -1, 1)); // clamp to avoid numerical problems
    }
    Vec3.angle = angle;
    var tmp_dh_ab = zero();
    var tmp_dh_cb = zero();
    var tmp_dh_bc = zero();
    var tmp_dh_dc = zero();
    var tmp_dh_abc = zero();
    var tmp_dh_bcd = zero();
    var tmp_dh_cross = zero();
    /**
     * Computes the dihedral angles of 4 points, reports in radians.
     */
    function dihedralAngle(a, b, c, d) {
        sub(tmp_dh_ab, a, b);
        sub(tmp_dh_cb, c, b);
        sub(tmp_dh_bc, b, c);
        sub(tmp_dh_dc, d, c);
        cross(tmp_dh_abc, tmp_dh_ab, tmp_dh_cb);
        cross(tmp_dh_bcd, tmp_dh_bc, tmp_dh_dc);
        var _angle = angle(tmp_dh_abc, tmp_dh_bcd);
        cross(tmp_dh_cross, tmp_dh_abc, tmp_dh_bcd);
        return dot(tmp_dh_cb, tmp_dh_cross) > 0 ? _angle : -_angle;
    }
    Vec3.dihedralAngle = dihedralAngle;
    /**
     * Returns whether or not the vectors have exactly the same elements in the same position (when compared with ===)
     */
    function exactEquals(a, b) {
        return a[0] === b[0] && a[1] === b[1] && a[2] === b[2];
    }
    Vec3.exactEquals = exactEquals;
    /**
     * Returns whether or not the vectors have approximately the same elements in the same position.
     */
    function equals(a, b) {
        var a0 = a[0], a1 = a[1], a2 = a[2];
        var b0 = b[0], b1 = b[1], b2 = b[2];
        return (Math.abs(a0 - b0) <= _3d__WEBPACK_IMPORTED_MODULE_1__["EPSILON"] * Math.max(1.0, Math.abs(a0), Math.abs(b0)) &&
            Math.abs(a1 - b1) <= _3d__WEBPACK_IMPORTED_MODULE_1__["EPSILON"] * Math.max(1.0, Math.abs(a1), Math.abs(b1)) &&
            Math.abs(a2 - b2) <= _3d__WEBPACK_IMPORTED_MODULE_1__["EPSILON"] * Math.max(1.0, Math.abs(a2), Math.abs(b2)));
    }
    Vec3.equals = equals;
    var rotTemp = zero();
    function makeRotation(mat, a, b) {
        var by = angle(a, b);
        if (Math.abs(by) < 0.0001)
            return _mat4__WEBPACK_IMPORTED_MODULE_0__["default"].setIdentity(mat);
        if (Math.abs(by - Math.PI) < _3d__WEBPACK_IMPORTED_MODULE_1__["EPSILON"]) {
            // here, axis can be [0,0,0] but the rotation is a simple flip
            return _mat4__WEBPACK_IMPORTED_MODULE_0__["default"].fromScaling(mat, Vec3.negUnit);
        }
        var axis = cross(rotTemp, a, b);
        return _mat4__WEBPACK_IMPORTED_MODULE_0__["default"].fromRotation(mat, by, axis);
    }
    Vec3.makeRotation = makeRotation;
    function isZero(v) {
        return v[0] === 0 && v[1] === 0 && v[2] === 0;
    }
    Vec3.isZero = isZero;
    /** Project `point` onto `vector` starting from `origin` */
    function projectPointOnVector(out, point, vector, origin) {
        sub(out, copy(out, point), origin);
        var scalar = dot(vector, out) / squaredMagnitude(vector);
        return add(out, scale(out, copy(out, vector), scalar), origin);
    }
    Vec3.projectPointOnVector = projectPointOnVector;
    function projectOnVector(out, p, vector) {
        var scalar = dot(vector, p) / squaredMagnitude(vector);
        return scale(out, vector, scalar);
    }
    Vec3.projectOnVector = projectOnVector;
    var tmpProject = zero();
    function projectOnPlane(out, p, normal) {
        projectOnVector(tmpProject, p, normal);
        return sub(out, p, tmpProject);
    }
    Vec3.projectOnPlane = projectOnPlane;
    /** Get a vector that is similar to `b` but orthogonal to `a` */
    function orthogonalize(out, a, b) {
        return normalize(out, cross(out, cross(out, a, b), a));
    }
    Vec3.orthogonalize = orthogonalize;
    /**
     * Get a vector like `a` that point into the same general direction as `b`,
     * i.e. where the dot product is > 0
     */
    function matchDirection(out, a, b) {
        if (Vec3.dot(a, b) > 0)
            Vec3.copy(out, a);
        else
            Vec3.negate(out, Vec3.copy(out, a));
        return out;
    }
    Vec3.matchDirection = matchDirection;
    var triangleNormalTmpAB = zero();
    var triangleNormalTmpAC = zero();
    /** Calculate normal for the triangle defined by `a`, `b` and `c` */
    function triangleNormal(out, a, b, c) {
        sub(triangleNormalTmpAB, b, a);
        sub(triangleNormalTmpAC, c, a);
        return normalize(out, cross(out, triangleNormalTmpAB, triangleNormalTmpAC));
    }
    Vec3.triangleNormal = triangleNormal;
    function toString(a, precision) {
        return "[" + a[0].toPrecision(precision) + " " + a[1].toPrecision(precision) + " " + a[2].toPrecision(precision) + "]";
    }
    Vec3.toString = toString;
    Vec3.origin = Vec3.create(0, 0, 0);
    Vec3.unit = Vec3.create(1, 1, 1);
    Vec3.negUnit = Vec3.create(-1, -1, -1);
    Vec3.unitX = Vec3.create(1, 0, 0);
    Vec3.unitY = Vec3.create(0, 1, 0);
    Vec3.unitZ = Vec3.create(0, 0, 1);
})(Vec3 || (Vec3 = {}));
/* harmony default export */ __webpack_exports__["default"] = (Vec3);
//# sourceMappingURL=vec3.js.map

/***/ }),

/***/ "./lib/mol-math/linear-algebra/3d/vec4.js":
/*!************************************************!*\
  !*** ./lib/mol-math/linear-algebra/3d/vec4.js ***!
  \************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _3d__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../3d */ "./lib/mol-math/linear-algebra/3d.js");
/**
 * Copyright (c) 2017-2018 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author David Sehnal <david.sehnal@gmail.com>
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */

function Vec4() {
    return Vec4.zero();
}
(function (Vec4) {
    function zero() {
        // force double backing array by 0.1.
        var ret = [0.1, 0, 0, 0];
        ret[0] = 0.0;
        return ret;
    }
    Vec4.zero = zero;
    function clone(a) {
        var out = zero();
        out[0] = a[0];
        out[1] = a[1];
        out[2] = a[2];
        out[3] = a[3];
        return out;
    }
    Vec4.clone = clone;
    function create(x, y, z, w) {
        var out = zero();
        out[0] = x;
        out[1] = y;
        out[2] = z;
        out[3] = w;
        return out;
    }
    Vec4.create = create;
    function fromSphere(out, sphere) {
        out[0] = sphere.center[0];
        out[1] = sphere.center[1];
        out[2] = sphere.center[2];
        out[3] = sphere.radius;
        return out;
    }
    Vec4.fromSphere = fromSphere;
    function ofSphere(sphere) {
        return fromSphere(zero(), sphere);
    }
    Vec4.ofSphere = ofSphere;
    function hasNaN(a) {
        return isNaN(a[0]) || isNaN(a[1]) || isNaN(a[2]) || isNaN(a[3]);
    }
    Vec4.hasNaN = hasNaN;
    function toArray(a, out, offset) {
        out[offset + 0] = a[0];
        out[offset + 1] = a[1];
        out[offset + 2] = a[2];
        out[offset + 3] = a[3];
        return out;
    }
    Vec4.toArray = toArray;
    function fromArray(a, array, offset) {
        a[0] = array[offset + 0];
        a[1] = array[offset + 1];
        a[2] = array[offset + 2];
        a[3] = array[offset + 3];
        return a;
    }
    Vec4.fromArray = fromArray;
    function toVec3Array(a, out, offset) {
        out[offset + 0] = a[0];
        out[offset + 1] = a[1];
        out[offset + 2] = a[2];
    }
    Vec4.toVec3Array = toVec3Array;
    function fromVec3Array(a, array, offset) {
        a[0] = array[offset + 0];
        a[1] = array[offset + 1];
        a[2] = array[offset + 2];
        a[3] = 0;
        return a;
    }
    Vec4.fromVec3Array = fromVec3Array;
    function copy(out, a) {
        out[0] = a[0];
        out[1] = a[1];
        out[2] = a[2];
        out[3] = a[3];
        return out;
    }
    Vec4.copy = copy;
    function set(out, x, y, z, w) {
        out[0] = x;
        out[1] = y;
        out[2] = z;
        out[3] = w;
        return out;
    }
    Vec4.set = set;
    function add(out, a, b) {
        out[0] = a[0] + b[0];
        out[1] = a[1] + b[1];
        out[2] = a[2] + b[2];
        out[3] = a[3] + b[3];
        return out;
    }
    Vec4.add = add;
    function distance(a, b) {
        var x = b[0] - a[0], y = b[1] - a[1], z = b[2] - a[2], w = b[3] - a[3];
        return Math.sqrt(x * x + y * y + z * z + w * w);
    }
    Vec4.distance = distance;
    function scale(out, a, b) {
        out[0] = a[0] * b;
        out[1] = a[1] * b;
        out[2] = a[2] * b;
        out[4] = a[4] * b;
        return out;
    }
    Vec4.scale = scale;
    /**
     * Math.round the components of a Vec4
     */
    function round(out, a) {
        out[0] = Math.round(a[0]);
        out[1] = Math.round(a[1]);
        out[2] = Math.round(a[2]);
        out[3] = Math.round(a[3]);
        return out;
    }
    Vec4.round = round;
    /**
     * Math.ceil the components of a Vec4
     */
    function ceil(out, a) {
        out[0] = Math.ceil(a[0]);
        out[1] = Math.ceil(a[1]);
        out[2] = Math.ceil(a[2]);
        out[3] = Math.ceil(a[3]);
        return out;
    }
    Vec4.ceil = ceil;
    /**
     * Math.floor the components of a Vec3
     */
    function floor(out, a) {
        out[0] = Math.floor(a[0]);
        out[1] = Math.floor(a[1]);
        out[2] = Math.floor(a[2]);
        out[3] = Math.floor(a[3]);
        return out;
    }
    Vec4.floor = floor;
    function squaredDistance(a, b) {
        var x = b[0] - a[0], y = b[1] - a[1], z = b[2] - a[2], w = b[3] - a[3];
        return x * x + y * y + z * z + w * w;
    }
    Vec4.squaredDistance = squaredDistance;
    function norm(a) {
        var x = a[0], y = a[1], z = a[2], w = a[3];
        return Math.sqrt(x * x + y * y + z * z + w * w);
    }
    Vec4.norm = norm;
    function squaredNorm(a) {
        var x = a[0], y = a[1], z = a[2], w = a[3];
        return x * x + y * y + z * z + w * w;
    }
    Vec4.squaredNorm = squaredNorm;
    function transformMat4(out, a, m) {
        var x = a[0], y = a[1], z = a[2], w = a[3];
        out[0] = m[0] * x + m[4] * y + m[8] * z + m[12] * w;
        out[1] = m[1] * x + m[5] * y + m[9] * z + m[13] * w;
        out[2] = m[2] * x + m[6] * y + m[10] * z + m[14] * w;
        out[3] = m[3] * x + m[7] * y + m[11] * z + m[15] * w;
        return out;
    }
    Vec4.transformMat4 = transformMat4;
    function dot(a, b) {
        return a[0] * b[0] + a[1] * b[1] + a[2] * b[2] + a[3] * b[3];
    }
    Vec4.dot = dot;
    /**
     * Returns the inverse of the components of a Vec4
     */
    function inverse(out, a) {
        out[0] = 1.0 / a[0];
        out[1] = 1.0 / a[1];
        out[2] = 1.0 / a[2];
        out[3] = 1.0 / a[3];
        return out;
    }
    Vec4.inverse = inverse;
    /**
     * Returns whether or not the vectors have exactly the same elements in the same position (when compared with ===)
     */
    function exactEquals(a, b) {
        return a[0] === b[0] && a[1] === b[1] && a[2] === b[2] && a[3] === b[3];
    }
    Vec4.exactEquals = exactEquals;
    /**
     * Returns whether or not the vectors have approximately the same elements in the same position.
     */
    function equals(a, b) {
        var a0 = a[0], a1 = a[1], a2 = a[2], a3 = a[3];
        var b0 = b[0], b1 = b[1], b2 = b[2], b3 = b[3];
        return (Math.abs(a0 - b0) <= _3d__WEBPACK_IMPORTED_MODULE_0__["EPSILON"] * Math.max(1.0, Math.abs(a0), Math.abs(b0)) &&
            Math.abs(a1 - b1) <= _3d__WEBPACK_IMPORTED_MODULE_0__["EPSILON"] * Math.max(1.0, Math.abs(a1), Math.abs(b1)) &&
            Math.abs(a2 - b2) <= _3d__WEBPACK_IMPORTED_MODULE_0__["EPSILON"] * Math.max(1.0, Math.abs(a2), Math.abs(b2)) &&
            Math.abs(a3 - b3) <= _3d__WEBPACK_IMPORTED_MODULE_0__["EPSILON"] * Math.max(1.0, Math.abs(a3), Math.abs(b3)));
    }
    Vec4.equals = equals;
    function toString(a, precision) {
        return "[" + a[0].toPrecision(precision) + " " + a[1].toPrecision(precision) + " " + a[2].toPrecision(precision) + "  " + a[3].toPrecision(precision) + "]";
    }
    Vec4.toString = toString;
})(Vec4 || (Vec4 = {}));
/* harmony default export */ __webpack_exports__["default"] = (Vec4);
//# sourceMappingURL=vec4.js.map

/***/ }),

/***/ "./lib/mol-math/linear-algebra/matrix/evd.js":
/*!***************************************************!*\
  !*** ./lib/mol-math/linear-algebra/matrix/evd.js ***!
  \***************************************************/
/*! exports provided: EVD */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "EVD", function() { return EVD; });
/* harmony import */ var _matrix__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./matrix */ "./lib/mol-math/linear-algebra/matrix/matrix.js");
/**
 * Copyright (c) 2019 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author David Sehnal <david.sehnal@gmail.com>
 */

var EVD;
(function (EVD) {
    function createCache(size) {
        return {
            size: size,
            matrix: _matrix__WEBPACK_IMPORTED_MODULE_0__["default"].create(size, size),
            eigenValues: new Float64Array(size),
            D: new Float64Array(size),
            E: new Float64Array(size)
        };
    }
    EVD.createCache = createCache;
    /**
     * Computes EVD and stores the result in the cache.
     */
    function compute(cache) {
        symmetricEigenDecomp(cache.size, cache.matrix.data, cache.eigenValues, cache.D, cache.E);
    }
    EVD.compute = compute;
})(EVD || (EVD = {}));
// The EVD code has been adapted from Math.NET, MIT license, Copyright (c) 2002-2015 Math.NET
//
// THE SOFTWARE IS PROVIDED 'AS IS', WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED,
// INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR
// PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE
// FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE,
// ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
function symmetricEigenDecomp(order, matrixEv, vectorEv, d, e) {
    for (var i = 0; i < order; i++) {
        e[i] = 0.0;
    }
    var om1 = order - 1;
    for (var i = 0; i < order; i++) {
        d[i] = matrixEv[i * order + om1];
    }
    symmetricTridiagonalize(matrixEv, d, e, order);
    symmetricDiagonalize(matrixEv, d, e, order);
    for (var i = 0; i < order; i++) {
        vectorEv[i] = d[i];
    }
}
function symmetricTridiagonalize(a, d, e, order) {
    // Householder reduction to tridiagonal form.
    for (var i = order - 1; i > 0; i--) {
        // Scale to avoid under/overflow.
        var scale = 0.0;
        var h = 0.0;
        for (var k = 0; k < i; k++) {
            scale = scale + Math.abs(d[k]);
        }
        if (scale === 0.0) {
            e[i] = d[i - 1];
            for (var j = 0; j < i; j++) {
                d[j] = a[(j * order) + i - 1];
                a[(j * order) + i] = 0.0;
                a[(i * order) + j] = 0.0;
            }
        }
        else {
            // Generate Householder vector.
            for (var k = 0; k < i; k++) {
                d[k] /= scale;
                h += d[k] * d[k];
            }
            var f = d[i - 1];
            var g = Math.sqrt(h);
            if (f > 0) {
                g = -g;
            }
            e[i] = scale * g;
            h = h - (f * g);
            d[i - 1] = f - g;
            for (var j = 0; j < i; j++) {
                e[j] = 0.0;
            }
            // Apply similarity transformation to remaining columns.
            for (var j = 0; j < i; j++) {
                f = d[j];
                a[(i * order) + j] = f;
                g = e[j] + (a[(j * order) + j] * f);
                for (var k = j + 1; k <= i - 1; k++) {
                    g += a[(j * order) + k] * d[k];
                    e[k] += a[(j * order) + k] * f;
                }
                e[j] = g;
            }
            f = 0.0;
            for (var j = 0; j < i; j++) {
                e[j] /= h;
                f += e[j] * d[j];
            }
            var hh = f / (h + h);
            for (var j = 0; j < i; j++) {
                e[j] -= hh * d[j];
            }
            for (var j = 0; j < i; j++) {
                f = d[j];
                g = e[j];
                for (var k = j; k <= i - 1; k++) {
                    a[(j * order) + k] -= (f * e[k]) + (g * d[k]);
                }
                d[j] = a[(j * order) + i - 1];
                a[(j * order) + i] = 0.0;
            }
        }
        d[i] = h;
    }
    // Accumulate transformations.
    for (var i = 0; i < order - 1; i++) {
        a[(i * order) + order - 1] = a[(i * order) + i];
        a[(i * order) + i] = 1.0;
        var h = d[i + 1];
        if (h !== 0.0) {
            for (var k = 0; k <= i; k++) {
                d[k] = a[((i + 1) * order) + k] / h;
            }
            for (var j = 0; j <= i; j++) {
                var g = 0.0;
                for (var k = 0; k <= i; k++) {
                    g += a[((i + 1) * order) + k] * a[(j * order) + k];
                }
                for (var k = 0; k <= i; k++) {
                    a[(j * order) + k] -= g * d[k];
                }
            }
        }
        for (var k = 0; k <= i; k++) {
            a[((i + 1) * order) + k] = 0.0;
        }
    }
    for (var j = 0; j < order; j++) {
        d[j] = a[(j * order) + order - 1];
        a[(j * order) + order - 1] = 0.0;
    }
    a[(order * order) - 1] = 1.0;
    e[0] = 0.0;
}
function symmetricDiagonalize(a, d, e, order) {
    var maxiter = 1000;
    for (var i = 1; i < order; i++) {
        e[i - 1] = e[i];
    }
    e[order - 1] = 0.0;
    var f = 0.0;
    var tst1 = 0.0;
    var eps = Math.pow(2, -53); // DoubleWidth = 53
    for (var l = 0; l < order; l++) {
        // Find small subdiagonal element
        tst1 = Math.max(tst1, Math.abs(d[l]) + Math.abs(e[l]));
        var m = l;
        while (m < order) {
            if (Math.abs(e[m]) <= eps * tst1) {
                break;
            }
            m++;
        }
        // If m == l, d[l] is an eigenvalue,
        // otherwise, iterate.
        if (m > l) {
            var iter = 0;
            do {
                iter = iter + 1; // (Could check iteration count here.)
                // Compute implicit shift
                var g = d[l];
                var p = (d[l + 1] - g) / (2.0 * e[l]);
                var r = hypotenuse(p, 1.0);
                if (p < 0) {
                    r = -r;
                }
                d[l] = e[l] / (p + r);
                d[l + 1] = e[l] * (p + r);
                var dl1 = d[l + 1];
                var h = g - d[l];
                for (var i = l + 2; i < order; i++) {
                    d[i] -= h;
                }
                f = f + h;
                // Implicit QL transformation.
                p = d[m];
                var c = 1.0;
                var c2 = c;
                var c3 = c;
                var el1 = e[l + 1];
                var s = 0.0;
                var s2 = 0.0;
                for (var i = m - 1; i >= l; i--) {
                    c3 = c2;
                    c2 = c;
                    s2 = s;
                    g = c * e[i];
                    h = c * p;
                    r = hypotenuse(p, e[i]);
                    e[i + 1] = s * r;
                    s = e[i] / r;
                    c = p / r;
                    p = (c * d[i]) - (s * g);
                    d[i + 1] = h + (s * ((c * g) + (s * d[i])));
                    // Accumulate transformation.
                    for (var k = 0; k < order; k++) {
                        h = a[((i + 1) * order) + k];
                        a[((i + 1) * order) + k] = (s * a[(i * order) + k]) + (c * h);
                        a[(i * order) + k] = (c * a[(i * order) + k]) - (s * h);
                    }
                }
                p = (-s) * s2 * c3 * el1 * e[l] / dl1;
                e[l] = s * p;
                d[l] = c * p;
                // Check for convergence. If too many iterations have been performed,
                // throw exception that Convergence Failed
                if (iter >= maxiter) {
                    throw 'SVD: Not converging.';
                }
            } while (Math.abs(e[l]) > eps * tst1);
        }
        d[l] = d[l] + f;
        e[l] = 0.0;
    }
    // Sort eigenvalues and corresponding vectors.
    for (var i = 0; i < order - 1; i++) {
        var k = i;
        var p = d[i];
        for (var j = i + 1; j < order; j++) {
            if (d[j] < p) {
                k = j;
                p = d[j];
            }
        }
        if (k !== i) {
            d[k] = d[i];
            d[i] = p;
            for (var j = 0; j < order; j++) {
                p = a[(i * order) + j];
                a[(i * order) + j] = a[(k * order) + j];
                a[(k * order) + j] = p;
            }
        }
    }
}
function hypotenuse(a, b) {
    if (Math.abs(a) > Math.abs(b)) {
        var r = b / a;
        return Math.abs(a) * Math.sqrt(1 + (r * r));
    }
    if (b !== 0.0) {
        var r = a / b;
        return Math.abs(b) * Math.sqrt(1 + (r * r));
    }
    return 0.0;
}
//# sourceMappingURL=evd.js.map

/***/ }),

/***/ "./lib/mol-math/linear-algebra/matrix/matrix.js":
/*!******************************************************!*\
  !*** ./lib/mol-math/linear-algebra/matrix/matrix.js ***!
  \******************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/**
 * Copyright (c) 2018-2019 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */
var Matrix;
(function (Matrix) {
    function create(cols, rows, ctor) {
        if (ctor === void 0) { ctor = Float32Array; }
        var size = cols * rows;
        return { data: new ctor(size), size: size, cols: cols, rows: rows };
    }
    Matrix.create = create;
    /** Get element assuming data are stored in column-major order */
    function get(m, i, j) {
        return m.data[m.rows * j + i];
    }
    Matrix.get = get;
    /** Set element assuming data are stored in column-major order */
    function set(m, i, j, value) {
        m.data[m.rows * j + i] = value;
        return m;
    }
    Matrix.set = set;
    /** Add to element assuming data are stored in column-major order */
    function add(m, i, j, value) {
        m.data[m.rows * j + i] += value;
        return m;
    }
    Matrix.add = add;
    /** Zero out the matrix */
    function makeZero(m) {
        m.data.fill(0.0);
        return m;
    }
    Matrix.makeZero = makeZero;
    function clone(m) {
        return { data: m.data.slice(), size: m.size, cols: m.cols, rows: m.rows };
    }
    Matrix.clone = clone;
    function fromArray(data, cols, rows) {
        return { data: data, size: cols * rows, cols: cols, rows: rows };
    }
    Matrix.fromArray = fromArray;
    function transpose(out, mat) {
        if (out.cols !== mat.rows || out.rows !== mat.cols) {
            throw new Error('transpose: matrix dimensions incompatible');
        }
        if (out.data === mat.data) {
            throw new Error('transpose: matrices share memory');
        }
        var nrows = mat.rows, ncols = mat.cols;
        var md = mat.data, mtd = out.data;
        for (var i = 0, mi = 0, mti = 0; i < nrows; mti += 1, mi += ncols, ++i) {
            var ri = mti;
            for (var j = 0; j < ncols; ri += nrows, j++)
                mtd[ri] = md[mi + j];
        }
        return out;
    }
    Matrix.transpose = transpose;
    /** out = matA * matB' */
    function multiplyABt(out, matA, matB) {
        var ncols = matA.cols, nrows = matA.rows, mrows = matB.rows;
        var ad = matA.data, bd = matB.data, cd = out.data;
        for (var i = 0, matAp = 0, outP = 0; i < nrows; matAp += ncols, i++) {
            for (var pB = 0, j = 0; j < mrows; outP++, j++) {
                var sum = 0.0;
                var pMatA = matAp;
                for (var k = 0; k < ncols; pMatA++, pB++, k++) {
                    sum += ad[pMatA] * bd[pB];
                }
                cd[outP] = sum;
            }
        }
        return out;
    }
    Matrix.multiplyABt = multiplyABt;
    /** Get the mean of rows in `mat` */
    function meanRows(mat) {
        var nrows = mat.rows, ncols = mat.cols;
        var md = mat.data;
        var mean = new Array(ncols);
        for (var j = 0; j < ncols; ++j)
            mean[j] = 0.0;
        for (var i = 0, p = 0; i < nrows; ++i) {
            for (var j = 0; j < ncols; ++j, ++p)
                mean[j] += md[p];
        }
        for (var j = 0; j < ncols; ++j)
            mean[j] /= nrows;
        return mean;
    }
    Matrix.meanRows = meanRows;
    /** Subtract `row` from all rows in `mat` */
    function subRows(mat, row) {
        var nrows = mat.rows, ncols = mat.cols;
        var md = mat.data;
        for (var i = 0, p = 0; i < nrows; ++i) {
            for (var j = 0; j < ncols; ++j, ++p)
                md[p] -= row[j];
        }
        return mat;
    }
    Matrix.subRows = subRows;
})(Matrix || (Matrix = {}));
/* harmony default export */ __webpack_exports__["default"] = (Matrix);
//# sourceMappingURL=matrix.js.map

/***/ }),

/***/ "./lib/mol-math/linear-algebra/matrix/principal-axes.js":
/*!**************************************************************!*\
  !*** ./lib/mol-math/linear-algebra/matrix/principal-axes.js ***!
  \**************************************************************/
/*! exports provided: PrincipalAxes */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "PrincipalAxes", function() { return PrincipalAxes; });
/* harmony import */ var _matrix__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./matrix */ "./lib/mol-math/linear-algebra/matrix/matrix.js");
/* harmony import */ var _3d__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../3d */ "./lib/mol-math/linear-algebra/3d.js");
/* harmony import */ var _svd__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./svd */ "./lib/mol-math/linear-algebra/matrix/svd.js");
/* harmony import */ var _geometry__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../geometry */ "./lib/mol-math/geometry.js");
/**
 * Copyright (c) 2018-2019 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */





var PrincipalAxes;
(function (PrincipalAxes) {
    function ofPositions(positions) {
        var momentsAxes = calculateMomentsAxes(positions);
        var boxAxes = calculateBoxAxes(positions, momentsAxes);
        return { momentsAxes: momentsAxes, boxAxes: boxAxes };
    }
    PrincipalAxes.ofPositions = ofPositions;
    function calculateMomentsAxes(positions) {
        if (positions.length === 3) {
            return _geometry__WEBPACK_IMPORTED_MODULE_3__["Axes3D"].create(_3d__WEBPACK_IMPORTED_MODULE_1__["Vec3"].fromArray(Object(_3d__WEBPACK_IMPORTED_MODULE_1__["Vec3"])(), positions, 0), _3d__WEBPACK_IMPORTED_MODULE_1__["Vec3"].create(1, 0, 0), _3d__WEBPACK_IMPORTED_MODULE_1__["Vec3"].create(0, 1, 0), _3d__WEBPACK_IMPORTED_MODULE_1__["Vec3"].create(0, 1, 0));
        }
        var points = _matrix__WEBPACK_IMPORTED_MODULE_0__["default"].fromArray(positions, 3, positions.length / 3);
        var n = points.rows;
        var n3 = n / 3;
        var A = _matrix__WEBPACK_IMPORTED_MODULE_0__["default"].create(3, 3);
        var W = _matrix__WEBPACK_IMPORTED_MODULE_0__["default"].create(1, 3);
        var U = _matrix__WEBPACK_IMPORTED_MODULE_0__["default"].create(3, 3);
        var V = _matrix__WEBPACK_IMPORTED_MODULE_0__["default"].create(3, 3);
        // calculate
        var mean = _matrix__WEBPACK_IMPORTED_MODULE_0__["default"].meanRows(points);
        var pointsM = _matrix__WEBPACK_IMPORTED_MODULE_0__["default"].subRows(_matrix__WEBPACK_IMPORTED_MODULE_0__["default"].clone(points), mean);
        var pointsT = _matrix__WEBPACK_IMPORTED_MODULE_0__["default"].transpose(_matrix__WEBPACK_IMPORTED_MODULE_0__["default"].create(n, 3), pointsM);
        _matrix__WEBPACK_IMPORTED_MODULE_0__["default"].multiplyABt(A, pointsT, pointsT);
        Object(_svd__WEBPACK_IMPORTED_MODULE_2__["svd"])(A, W, U, V);
        // origin
        var origin = _3d__WEBPACK_IMPORTED_MODULE_1__["Vec3"].create(mean[0], mean[1], mean[2]);
        // directions
        var dirA = _3d__WEBPACK_IMPORTED_MODULE_1__["Vec3"].create(U.data[0], U.data[3], U.data[6]);
        var dirB = _3d__WEBPACK_IMPORTED_MODULE_1__["Vec3"].create(U.data[1], U.data[4], U.data[7]);
        var dirC = _3d__WEBPACK_IMPORTED_MODULE_1__["Vec3"].create(U.data[2], U.data[5], U.data[8]);
        _3d__WEBPACK_IMPORTED_MODULE_1__["Vec3"].scale(dirA, dirA, Math.sqrt(W.data[0] / n3));
        _3d__WEBPACK_IMPORTED_MODULE_1__["Vec3"].scale(dirB, dirB, Math.sqrt(W.data[1] / n3));
        _3d__WEBPACK_IMPORTED_MODULE_1__["Vec3"].scale(dirC, dirC, Math.sqrt(W.data[2] / n3));
        return _geometry__WEBPACK_IMPORTED_MODULE_3__["Axes3D"].create(origin, dirA, dirB, dirC);
    }
    PrincipalAxes.calculateMomentsAxes = calculateMomentsAxes;
    var tmpBoxVec = Object(_3d__WEBPACK_IMPORTED_MODULE_1__["Vec3"])();
    var tmpBoxVecA = Object(_3d__WEBPACK_IMPORTED_MODULE_1__["Vec3"])();
    var tmpBoxVecB = Object(_3d__WEBPACK_IMPORTED_MODULE_1__["Vec3"])();
    var tmpBoxVecC = Object(_3d__WEBPACK_IMPORTED_MODULE_1__["Vec3"])();
    /**
     * Get the scale/length for each dimension for a box around the axes
     * to enclose the given positions
     */
    function calculateBoxAxes(positions, momentsAxes) {
        if (positions.length === 3) {
            return _geometry__WEBPACK_IMPORTED_MODULE_3__["Axes3D"].clone(momentsAxes);
        }
        var d1a = -Infinity;
        var d1b = -Infinity;
        var d2a = -Infinity;
        var d2b = -Infinity;
        var d3a = -Infinity;
        var d3b = -Infinity;
        var p = Object(_3d__WEBPACK_IMPORTED_MODULE_1__["Vec3"])();
        var t = Object(_3d__WEBPACK_IMPORTED_MODULE_1__["Vec3"])();
        var center = momentsAxes.origin;
        var normVecA = _3d__WEBPACK_IMPORTED_MODULE_1__["Vec3"].normalize(tmpBoxVecA, momentsAxes.dirA);
        var normVecB = _3d__WEBPACK_IMPORTED_MODULE_1__["Vec3"].normalize(tmpBoxVecB, momentsAxes.dirB);
        var normVecC = _3d__WEBPACK_IMPORTED_MODULE_1__["Vec3"].normalize(tmpBoxVecC, momentsAxes.dirC);
        for (var i = 0, il = positions.length; i < il; i += 3) {
            _3d__WEBPACK_IMPORTED_MODULE_1__["Vec3"].projectPointOnVector(p, _3d__WEBPACK_IMPORTED_MODULE_1__["Vec3"].fromArray(p, positions, i), normVecA, center);
            var dp1 = _3d__WEBPACK_IMPORTED_MODULE_1__["Vec3"].dot(normVecA, _3d__WEBPACK_IMPORTED_MODULE_1__["Vec3"].normalize(t, _3d__WEBPACK_IMPORTED_MODULE_1__["Vec3"].sub(t, p, center)));
            var dt1 = _3d__WEBPACK_IMPORTED_MODULE_1__["Vec3"].distance(p, center);
            if (dp1 > 0) {
                if (dt1 > d1a)
                    d1a = dt1;
            }
            else {
                if (dt1 > d1b)
                    d1b = dt1;
            }
            _3d__WEBPACK_IMPORTED_MODULE_1__["Vec3"].projectPointOnVector(p, _3d__WEBPACK_IMPORTED_MODULE_1__["Vec3"].fromArray(p, positions, i), normVecB, center);
            var dp2 = _3d__WEBPACK_IMPORTED_MODULE_1__["Vec3"].dot(normVecB, _3d__WEBPACK_IMPORTED_MODULE_1__["Vec3"].normalize(t, _3d__WEBPACK_IMPORTED_MODULE_1__["Vec3"].sub(t, p, center)));
            var dt2 = _3d__WEBPACK_IMPORTED_MODULE_1__["Vec3"].distance(p, center);
            if (dp2 > 0) {
                if (dt2 > d2a)
                    d2a = dt2;
            }
            else {
                if (dt2 > d2b)
                    d2b = dt2;
            }
            _3d__WEBPACK_IMPORTED_MODULE_1__["Vec3"].projectPointOnVector(p, _3d__WEBPACK_IMPORTED_MODULE_1__["Vec3"].fromArray(p, positions, i), normVecC, center);
            var dp3 = _3d__WEBPACK_IMPORTED_MODULE_1__["Vec3"].dot(normVecC, _3d__WEBPACK_IMPORTED_MODULE_1__["Vec3"].normalize(t, _3d__WEBPACK_IMPORTED_MODULE_1__["Vec3"].sub(t, p, center)));
            var dt3 = _3d__WEBPACK_IMPORTED_MODULE_1__["Vec3"].distance(p, center);
            if (dp3 > 0) {
                if (dt3 > d3a)
                    d3a = dt3;
            }
            else {
                if (dt3 > d3b)
                    d3b = dt3;
            }
        }
        var dirA = _3d__WEBPACK_IMPORTED_MODULE_1__["Vec3"].setMagnitude(Object(_3d__WEBPACK_IMPORTED_MODULE_1__["Vec3"])(), normVecA, (d1a + d1b) / 2);
        var dirB = _3d__WEBPACK_IMPORTED_MODULE_1__["Vec3"].setMagnitude(Object(_3d__WEBPACK_IMPORTED_MODULE_1__["Vec3"])(), normVecB, (d2a + d2b) / 2);
        var dirC = _3d__WEBPACK_IMPORTED_MODULE_1__["Vec3"].setMagnitude(Object(_3d__WEBPACK_IMPORTED_MODULE_1__["Vec3"])(), normVecC, (d3a + d3b) / 2);
        var origin = Object(_3d__WEBPACK_IMPORTED_MODULE_1__["Vec3"])();
        var addCornerHelper = function (d1, d2, d3) {
            _3d__WEBPACK_IMPORTED_MODULE_1__["Vec3"].copy(tmpBoxVec, center);
            _3d__WEBPACK_IMPORTED_MODULE_1__["Vec3"].scaleAndAdd(tmpBoxVec, tmpBoxVec, normVecA, d1);
            _3d__WEBPACK_IMPORTED_MODULE_1__["Vec3"].scaleAndAdd(tmpBoxVec, tmpBoxVec, normVecB, d2);
            _3d__WEBPACK_IMPORTED_MODULE_1__["Vec3"].scaleAndAdd(tmpBoxVec, tmpBoxVec, normVecC, d3);
            _3d__WEBPACK_IMPORTED_MODULE_1__["Vec3"].add(origin, origin, tmpBoxVec);
        };
        addCornerHelper(d1a, d2a, d3a);
        addCornerHelper(d1a, d2a, -d3b);
        addCornerHelper(d1a, -d2b, -d3b);
        addCornerHelper(d1a, -d2b, d3a);
        addCornerHelper(-d1b, -d2b, -d3b);
        addCornerHelper(-d1b, -d2b, d3a);
        addCornerHelper(-d1b, d2a, d3a);
        addCornerHelper(-d1b, d2a, -d3b);
        _3d__WEBPACK_IMPORTED_MODULE_1__["Vec3"].scale(origin, origin, 1 / 8);
        return _geometry__WEBPACK_IMPORTED_MODULE_3__["Axes3D"].create(origin, dirA, dirB, dirC);
    }
    PrincipalAxes.calculateBoxAxes = calculateBoxAxes;
})(PrincipalAxes || (PrincipalAxes = {}));
//# sourceMappingURL=principal-axes.js.map

/***/ }),

/***/ "./lib/mol-math/linear-algebra/matrix/svd.js":
/*!***************************************************!*\
  !*** ./lib/mol-math/linear-algebra/matrix/svd.js ***!
  \***************************************************/
/*! exports provided: swap, hypot, JacobiSVDImpl, svd */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "swap", function() { return swap; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "hypot", function() { return hypot; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "JacobiSVDImpl", function() { return JacobiSVDImpl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "svd", function() { return svd; });
/* harmony import */ var _matrix__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./matrix */ "./lib/mol-math/linear-algebra/matrix/matrix.js");
/**
 * Copyright (c) 2018 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */

// svd method adapted from http://inspirit.github.io/jsfeat/ MIT Eugene Zatepyakin
function swap(A, i0, i1, t) {
    t = A[i0];
    A[i0] = A[i1];
    A[i1] = t;
}
function hypot(a, b) {
    a = Math.abs(a);
    b = Math.abs(b);
    if (a > b) {
        b /= a;
        return a * Math.sqrt(1.0 + b * b);
    }
    if (b > 0) {
        a /= b;
        return b * Math.sqrt(1.0 + a * a);
    }
    return 0.0;
}
var EPSILON = 0.0000001192092896;
var FLT_MIN = 1E-37;
function JacobiSVDImpl(At, astep, _W, Vt, vstep, m, n, n1) {
    var eps = EPSILON * 2.0;
    var minval = FLT_MIN;
    var i = 0;
    var j = 0;
    var k = 0;
    var iter = 0;
    var maxIter = Math.max(m, 30);
    var Ai = 0;
    var Aj = 0;
    var Vi = 0;
    var Vj = 0;
    var changed = 0;
    var c = 0.0;
    var s = 0.0;
    var t = 0.0;
    var t0 = 0.0;
    var t1 = 0.0;
    var sd = 0.0;
    var beta = 0.0;
    var gamma = 0.0;
    var delta = 0.0;
    var a = 0.0;
    var p = 0.0;
    var b = 0.0;
    var seed = 0x1234;
    var val = 0.0;
    var val0 = 0.0;
    var asum = 0.0;
    var W = new Float64Array(n << 3);
    for (; i < n; i++) {
        for (k = 0, sd = 0; k < m; k++) {
            t = At[i * astep + k];
            sd += t * t;
        }
        W[i] = sd;
        if (Vt) {
            for (k = 0; k < n; k++) {
                Vt[i * vstep + k] = 0;
            }
            Vt[i * vstep + i] = 1;
        }
    }
    for (; iter < maxIter; iter++) {
        changed = 0;
        for (i = 0; i < n - 1; i++) {
            for (j = i + 1; j < n; j++) {
                Ai = (i * astep) | 0;
                Aj = (j * astep) | 0;
                a = W[i];
                p = 0;
                b = W[j];
                k = 2;
                p += At[Ai] * At[Aj];
                p += At[Ai + 1] * At[Aj + 1];
                for (; k < m; k++) {
                    p += At[Ai + k] * At[Aj + k];
                }
                if (Math.abs(p) <= eps * Math.sqrt(a * b))
                    continue;
                p *= 2.0;
                beta = a - b;
                gamma = hypot(p, beta);
                if (beta < 0) {
                    delta = (gamma - beta) * 0.5;
                    s = Math.sqrt(delta / gamma);
                    c = (p / (gamma * s * 2.0));
                }
                else {
                    c = Math.sqrt((gamma + beta) / (gamma * 2.0));
                    s = (p / (gamma * c * 2.0));
                }
                a = 0.0;
                b = 0.0;
                k = 2; // unroll
                t0 = c * At[Ai] + s * At[Aj];
                t1 = -s * At[Ai] + c * At[Aj];
                At[Ai] = t0;
                At[Aj] = t1;
                a += t0 * t0;
                b += t1 * t1;
                t0 = c * At[Ai + 1] + s * At[Aj + 1];
                t1 = -s * At[Ai + 1] + c * At[Aj + 1];
                At[Ai + 1] = t0;
                At[Aj + 1] = t1;
                a += t0 * t0;
                b += t1 * t1;
                for (; k < m; k++) {
                    t0 = c * At[Ai + k] + s * At[Aj + k];
                    t1 = -s * At[Ai + k] + c * At[Aj + k];
                    At[Ai + k] = t0;
                    At[Aj + k] = t1;
                    a += t0 * t0;
                    b += t1 * t1;
                }
                W[i] = a;
                W[j] = b;
                changed = 1;
                if (Vt) {
                    Vi = (i * vstep) | 0;
                    Vj = (j * vstep) | 0;
                    k = 2;
                    t0 = c * Vt[Vi] + s * Vt[Vj];
                    t1 = -s * Vt[Vi] + c * Vt[Vj];
                    Vt[Vi] = t0;
                    Vt[Vj] = t1;
                    t0 = c * Vt[Vi + 1] + s * Vt[Vj + 1];
                    t1 = -s * Vt[Vi + 1] + c * Vt[Vj + 1];
                    Vt[Vi + 1] = t0;
                    Vt[Vj + 1] = t1;
                    for (; k < n; k++) {
                        t0 = c * Vt[Vi + k] + s * Vt[Vj + k];
                        t1 = -s * Vt[Vi + k] + c * Vt[Vj + k];
                        Vt[Vi + k] = t0;
                        Vt[Vj + k] = t1;
                    }
                }
            }
        }
        if (changed === 0)
            break;
    }
    for (i = 0; i < n; i++) {
        for (k = 0, sd = 0; k < m; k++) {
            t = At[i * astep + k];
            sd += t * t;
        }
        W[i] = Math.sqrt(sd);
    }
    for (i = 0; i < n - 1; i++) {
        j = i;
        for (k = i + 1; k < n; k++) {
            if (W[j] < W[k]) {
                j = k;
            }
        }
        if (i !== j) {
            swap(W, i, j, sd);
            if (Vt) {
                for (k = 0; k < m; k++) {
                    swap(At, i * astep + k, j * astep + k, t);
                }
                for (k = 0; k < n; k++) {
                    swap(Vt, i * vstep + k, j * vstep + k, t);
                }
            }
        }
    }
    for (i = 0; i < n; i++) {
        _W[i] = W[i];
    }
    if (!Vt) {
        return;
    }
    for (i = 0; i < n1; i++) {
        sd = i < n ? W[i] : 0;
        while (sd <= minval) {
            // if we got a zero singular value, then in order to get the corresponding left singular vector
            // we generate a random vector, project it to the previously computed left singular vectors,
            // subtract the projection and normalize the difference.
            val0 = (1.0 / m);
            for (k = 0; k < m; k++) {
                seed = (seed * 214013 + 2531011);
                val = (((seed >> 16) & 0x7fff) & 256) !== 0 ? val0 : -val0;
                At[i * astep + k] = val;
            }
            for (iter = 0; iter < 2; iter++) {
                for (j = 0; j < i; j++) {
                    sd = 0;
                    for (k = 0; k < m; k++) {
                        sd += At[i * astep + k] * At[j * astep + k];
                    }
                    asum = 0.0;
                    for (k = 0; k < m; k++) {
                        t = (At[i * astep + k] - sd * At[j * astep + k]);
                        At[i * astep + k] = t;
                        asum += Math.abs(t);
                    }
                    asum = asum ? 1.0 / asum : 0;
                    for (k = 0; k < m; k++) {
                        At[i * astep + k] *= asum;
                    }
                }
            }
            sd = 0;
            for (k = 0; k < m; k++) {
                t = At[i * astep + k];
                sd += t * t;
            }
            sd = Math.sqrt(sd);
        }
        s = (1.0 / sd);
        for (k = 0; k < m; k++) {
            At[i * astep + k] *= s;
        }
    }
}
function svd(A, W, U, V) {
    var at = 0;
    var i = 0;
    var _m = A.rows;
    var _n = A.cols;
    var m = _m;
    var n = _n;
    if (m < n) {
        at = 1;
        i = m;
        m = n;
        n = i;
    }
    var amt = _matrix__WEBPACK_IMPORTED_MODULE_0__["default"].create(m, m);
    var wmt = _matrix__WEBPACK_IMPORTED_MODULE_0__["default"].create(1, n);
    var vmt = _matrix__WEBPACK_IMPORTED_MODULE_0__["default"].create(n, n);
    if (at === 0) {
        _matrix__WEBPACK_IMPORTED_MODULE_0__["default"].transpose(amt, A);
    }
    else {
        for (i = 0; i < _n * _m; i++) {
            amt.data[i] = A.data[i];
        }
        for (; i < n * m; i++) {
            amt.data[i] = 0;
        }
    }
    JacobiSVDImpl(amt.data, m, wmt.data, vmt.data, n, m, n, m);
    if (W) {
        for (i = 0; i < n; i++) {
            W.data[i] = wmt.data[i];
        }
        for (; i < _n; i++) {
            W.data[i] = 0;
        }
    }
    if (at === 0) {
        if (U)
            _matrix__WEBPACK_IMPORTED_MODULE_0__["default"].transpose(U, amt);
        if (V)
            _matrix__WEBPACK_IMPORTED_MODULE_0__["default"].transpose(V, vmt);
    }
    else {
        if (U)
            _matrix__WEBPACK_IMPORTED_MODULE_0__["default"].transpose(U, vmt);
        if (V)
            _matrix__WEBPACK_IMPORTED_MODULE_0__["default"].transpose(V, amt);
    }
}
//# sourceMappingURL=svd.js.map

/***/ }),

/***/ "./lib/mol-math/linear-algebra/tensor.js":
/*!***********************************************!*\
  !*** ./lib/mol-math/linear-algebra/tensor.js ***!
  \***********************************************/
/*! exports provided: Tensor */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Tensor", function() { return Tensor; });
/* harmony import */ var _3d__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./3d */ "./lib/mol-math/linear-algebra/3d.js");
/**
 * Copyright (c) 2017-2020 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author David Sehnal <david.sehnal@gmail.com>
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */

var Tensor;
(function (Tensor) {
    function Layout(dimensions, axisOrderSlowToFast, ctor) {
        // need to reverse the axis order for better access.
        var axisOrderFastToSlow = [];
        for (var i = 0; i < axisOrderSlowToFast.length; i++)
            axisOrderFastToSlow[i] = axisOrderSlowToFast[axisOrderSlowToFast.length - i - 1];
        var accessDimensions = [1];
        for (var i = 1; i < dimensions.length; i++)
            accessDimensions[i] = dimensions[axisOrderFastToSlow[i - 1]];
        return { dimensions: dimensions, axisOrderFastToSlow: axisOrderFastToSlow, axisOrderSlowToFast: axisOrderSlowToFast, accessDimensions: accessDimensions, defaultCtor: ctor || Float64Array };
    }
    function create(space, data) { return { space: space, data: data }; }
    Tensor.create = create;
    function Space(dimensions, axisOrderSlowToFast, ctor) {
        var layout = Layout(dimensions, axisOrderSlowToFast, ctor);
        var _a = accessors(layout), get = _a.get, set = _a.set, add = _a.add, dataOffset = _a.dataOffset, getCoords = _a.getCoords;
        return { rank: dimensions.length, dimensions: dimensions, axisOrderSlowToFast: axisOrderSlowToFast, create: creator(layout), get: get, set: set, add: add, dataOffset: dataOffset, getCoords: getCoords };
    }
    Tensor.Space = Space;
    function Data1(values) { return values; }
    Tensor.Data1 = Data1;
    function Vector(d, ctor) { return Space([d], [0], ctor); }
    Tensor.Vector = Vector;
    function ColumnMajorMatrix(rows, cols, ctor) { return Space([rows, cols], [1, 0], ctor); }
    Tensor.ColumnMajorMatrix = ColumnMajorMatrix;
    function RowMajorMatrix(rows, cols, ctor) { return Space([rows, cols], [0, 1], ctor); }
    Tensor.RowMajorMatrix = RowMajorMatrix;
    function toMat4(out, space, data) {
        if (space.rank !== 2)
            throw new Error('Invalid tensor rank');
        var d0 = Math.min(4, space.dimensions[0]), d1 = Math.min(4, space.dimensions[1]);
        for (var i = 0; i < d0; i++) {
            for (var j = 0; j < d1; j++)
                _3d__WEBPACK_IMPORTED_MODULE_0__["Mat4"].setValue(out, i, j, space.get(data, i, j));
        }
        return out;
    }
    Tensor.toMat4 = toMat4;
    function toMat3(out, space, data) {
        if (space.rank !== 2)
            throw new Error('Invalid tensor rank');
        var d0 = Math.min(3, space.dimensions[0]), d1 = Math.min(3, space.dimensions[1]);
        for (var i = 0; i < d0; i++) {
            for (var j = 0; j < d1; j++)
                _3d__WEBPACK_IMPORTED_MODULE_0__["Mat3"].setValue(out, i, j, space.get(data, i, j));
        }
        return out;
    }
    Tensor.toMat3 = toMat3;
    function toVec3(out, space, data) {
        if (space.rank !== 1)
            throw new Error('Invalid tensor rank');
        var d0 = Math.min(3, space.dimensions[0]);
        for (var i = 0; i < d0; i++)
            out[i] = data[i];
        return out;
    }
    Tensor.toVec3 = toVec3;
    function toVec4(out, space, data) {
        if (space.rank !== 1)
            throw new Error('Invalid tensor rank');
        var d0 = Math.min(4, space.dimensions[0]);
        for (var i = 0; i < d0; i++)
            out[i] = data[i];
        return out;
    }
    Tensor.toVec4 = toVec4;
    function areEqualExact(a, b) {
        var len = a.length;
        if (len !== b.length)
            return false;
        for (var i = 0; i < len; i++)
            if (a[i] !== b[i])
                return false;
        return true;
    }
    Tensor.areEqualExact = areEqualExact;
    function accessors(layout) {
        var dimensions = layout.dimensions, ao = layout.axisOrderFastToSlow;
        switch (dimensions.length) {
            case 1: return {
                get: function (t, d) { return t[d]; },
                set: function (t, d, x) { return t[d] = x; },
                add: function (t, d, x) { return t[d] += x; },
                dataOffset: function (d) { return d; },
                getCoords: function (o, c) { c[0] = o; return c; }
            };
            case 2: {
                // column major
                if (ao[0] === 0 && ao[1] === 1) {
                    var rows_1 = dimensions[0];
                    return {
                        get: function (t, i, j) { return t[j * rows_1 + i]; },
                        set: function (t, i, j, x) { return t[j * rows_1 + i] = x; },
                        add: function (t, i, j, x) { return t[j * rows_1 + i] += x; },
                        dataOffset: function (i, j) { return j * rows_1 + i; },
                        getCoords: function (o, c) { c[0] = o % rows_1; c[1] = Math.floor(o / rows_1); return c; }
                    };
                }
                if (ao[0] === 1 && ao[1] === 0) {
                    var cols_1 = dimensions[1];
                    return {
                        get: function (t, i, j) { return t[i * cols_1 + j]; },
                        set: function (t, i, j, x) { return t[i * cols_1 + j] = x; },
                        add: function (t, i, j, x) { return t[i * cols_1 + j] += x; },
                        dataOffset: function (i, j) { return i * cols_1 + j; },
                        getCoords: function (o, c) { c[0] = Math.floor(o / cols_1); c[1] = o % cols_1; return c; }
                    };
                }
                throw new Error('bad axis order');
            }
            case 3: {
                if (ao[0] === 0 && ao[1] === 1 && ao[2] === 2) { // 012 ijk
                    var u_1 = dimensions[0], v_1 = dimensions[1], uv_1 = u_1 * v_1;
                    return {
                        get: function (t, i, j, k) { return t[i + j * u_1 + k * uv_1]; },
                        set: function (t, i, j, k, x) { return t[i + j * u_1 + k * uv_1] = x; },
                        add: function (t, i, j, k, x) { return t[i + j * u_1 + k * uv_1] += x; },
                        dataOffset: function (i, j, k) { return i + j * u_1 + k * uv_1; },
                        getCoords: function (o, c) {
                            var p = Math.floor(o / u_1);
                            c[0] = o % u_1;
                            c[1] = p % v_1;
                            c[2] = Math.floor(p / v_1);
                            return c;
                        }
                    };
                }
                if (ao[0] === 0 && ao[1] === 2 && ao[2] === 1) { // 021 ikj
                    var u_2 = dimensions[0], v_2 = dimensions[2], uv_2 = u_2 * v_2;
                    return {
                        get: function (t, i, j, k) { return t[i + k * u_2 + j * uv_2]; },
                        set: function (t, i, j, k, x) { return t[i + k * u_2 + j * uv_2] = x; },
                        add: function (t, i, j, k, x) { return t[i + k * u_2 + j * uv_2] += x; },
                        dataOffset: function (i, j, k) { return i + k * u_2 + j * uv_2; },
                        getCoords: function (o, c) {
                            var p = Math.floor(o / u_2);
                            c[0] = o % u_2;
                            c[1] = Math.floor(p / v_2);
                            c[2] = p % v_2;
                            return c;
                        }
                    };
                }
                if (ao[0] === 1 && ao[1] === 0 && ao[2] === 2) { // 102 jik
                    var u_3 = dimensions[1], v_3 = dimensions[0], uv_3 = u_3 * v_3;
                    return {
                        get: function (t, i, j, k) { return t[j + i * u_3 + k * uv_3]; },
                        set: function (t, i, j, k, x) { return t[j + i * u_3 + k * uv_3] = x; },
                        add: function (t, i, j, k, x) { return t[j + i * u_3 + k * uv_3] += x; },
                        dataOffset: function (i, j, k) { return j + i * u_3 + k * uv_3; },
                        getCoords: function (o, c) {
                            var p = Math.floor(o / u_3);
                            c[0] = p % v_3;
                            c[1] = o % u_3;
                            c[2] = Math.floor(p / v_3);
                            return c;
                        }
                    };
                }
                if (ao[0] === 1 && ao[1] === 2 && ao[2] === 0) { // 120 jki
                    var u_4 = dimensions[1], v_4 = dimensions[2], uv_4 = u_4 * v_4;
                    return {
                        get: function (t, i, j, k) { return t[j + k * u_4 + i * uv_4]; },
                        set: function (t, i, j, k, x) { return t[j + k * u_4 + i * uv_4] = x; },
                        add: function (t, i, j, k, x) { return t[j + k * u_4 + i * uv_4] += x; },
                        dataOffset: function (i, j, k) { return j + k * u_4 + i * uv_4; },
                        getCoords: function (o, c) {
                            var p = Math.floor(o / u_4);
                            c[0] = Math.floor(p / v_4);
                            c[1] = o % u_4;
                            c[2] = p % v_4;
                            return c;
                        }
                    };
                }
                if (ao[0] === 2 && ao[1] === 0 && ao[2] === 1) { // 201 kij
                    var u_5 = dimensions[2], v_5 = dimensions[0], uv_5 = u_5 * v_5;
                    return {
                        get: function (t, i, j, k) { return t[k + i * u_5 + j * uv_5]; },
                        set: function (t, i, j, k, x) { return t[k + i * u_5 + j * uv_5] = x; },
                        add: function (t, i, j, k, x) { return t[k + i * u_5 + j * uv_5] += x; },
                        dataOffset: function (i, j, k) { return k + i * u_5 + j * uv_5; },
                        getCoords: function (o, c) {
                            var p = Math.floor(o / u_5);
                            c[0] = p % v_5;
                            c[1] = Math.floor(p / v_5);
                            c[2] = o % u_5;
                            return c;
                        }
                    };
                }
                if (ao[0] === 2 && ao[1] === 1 && ao[2] === 0) { // 210 kji
                    var u_6 = dimensions[2], v_6 = dimensions[1], uv_6 = u_6 * v_6;
                    return {
                        get: function (t, i, j, k) { return t[k + j * u_6 + i * uv_6]; },
                        set: function (t, i, j, k, x) { return t[k + j * u_6 + i * uv_6] = x; },
                        add: function (t, i, j, k, x) { return t[k + j * u_6 + i * uv_6] += x; },
                        dataOffset: function (i, j, k) { return k + j * u_6 + i * uv_6; },
                        getCoords: function (o, c) {
                            var p = Math.floor(o / u_6);
                            c[0] = Math.floor(p / v_6);
                            c[1] = p % v_6;
                            c[2] = o % u_6;
                            return c;
                        }
                    };
                }
                throw new Error('bad axis order');
            }
            default: return {
                get: function (t) {
                    var c = [];
                    for (var _a = 1; _a < arguments.length; _a++) {
                        c[_a - 1] = arguments[_a];
                    }
                    return t[dataOffset(layout, c)];
                },
                set: function (t) {
                    var c = [];
                    for (var _a = 1; _a < arguments.length; _a++) {
                        c[_a - 1] = arguments[_a];
                    }
                    return t[dataOffset(layout, c)] = c[c.length - 1];
                },
                add: function (t) {
                    var c = [];
                    for (var _a = 1; _a < arguments.length; _a++) {
                        c[_a - 1] = arguments[_a];
                    }
                    return t[dataOffset(layout, c)] += c[c.length - 1];
                },
                dataOffset: function () {
                    var c = [];
                    for (var _a = 0; _a < arguments.length; _a++) {
                        c[_a] = arguments[_a];
                    }
                    return dataOffset(layout, c);
                },
                getCoords: function (o, c) { return getCoords(layout, o, c); },
            };
        }
    }
    function creator(layout) {
        var ds = layout.dimensions;
        var size = 1;
        for (var i = 0, _i = ds.length; i < _i; i++)
            size *= ds[i];
        return function (ctor) { return new (ctor || layout.defaultCtor)(size); };
    }
    function dataOffset(layout, coord) {
        var acc = layout.accessDimensions, ao = layout.axisOrderFastToSlow;
        var d = acc.length - 1;
        var o = acc[d] * coord[ao[d]];
        for (var i = d - 1; i >= 0; i--) {
            o = (o + coord[ao[i]]) * acc[i];
        }
        return o;
    }
    function getCoords(layout, o, coords) {
        var dim = layout.dimensions, ao = layout.axisOrderFastToSlow;
        var d = dim.length;
        var c = o;
        for (var i = 0; i < d; i++) {
            var d_1 = dim[ao[i]];
            coords[ao[i]] = c % d_1;
            c = Math.floor(c / d_1);
        }
        coords[ao[d + 1]] = c;
        return coords;
    }
    // Convers "slow to fast" axis order to "fast to slow" and vice versa.
    function invertAxisOrder(v) {
        var ret = [];
        for (var i = 0; i < v.length; i++) {
            ret[i] = v[v.length - i - 1];
        }
        return ret;
    }
    Tensor.invertAxisOrder = invertAxisOrder;
    function reorder(xs, indices) {
        var ret = [];
        for (var i = 0; i < xs.length; i++)
            ret[i] = xs[indices[i]];
        return ret;
    }
    function convertToCanonicalAxisIndicesFastToSlow(order) {
        var indices = new Int32Array(order.length);
        for (var i = 0; i < order.length; i++)
            indices[order[i]] = i;
        return function (xs) { return reorder(xs, indices); };
    }
    Tensor.convertToCanonicalAxisIndicesFastToSlow = convertToCanonicalAxisIndicesFastToSlow;
    function convertToCanonicalAxisIndicesSlowToFast(order) {
        var indices = new Int32Array(order.length);
        for (var i = 0; i < order.length; i++)
            indices[order[order.length - i - 1]] = i;
        return function (xs) { return reorder(xs, indices); };
    }
    Tensor.convertToCanonicalAxisIndicesSlowToFast = convertToCanonicalAxisIndicesSlowToFast;
})(Tensor || (Tensor = {}));
//# sourceMappingURL=tensor.js.map

/***/ }),

/***/ "./lib/mol-math/misc.js":
/*!******************************!*\
  !*** ./lib/mol-math/misc.js ***!
  \******************************/
/*! exports provided: halfPI, PiDiv180, degToRad, radToDeg, isPowerOfTwo, absMax, arcLength */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "halfPI", function() { return halfPI; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "PiDiv180", function() { return PiDiv180; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "degToRad", function() { return degToRad; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "radToDeg", function() { return radToDeg; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isPowerOfTwo", function() { return isPowerOfTwo; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "absMax", function() { return absMax; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "arcLength", function() { return arcLength; });
/**
 * Copyright (c) 2018-2019 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */
var halfPI = Math.PI / 2;
var PiDiv180 = Math.PI / 180;
function degToRad(deg) {
    return deg * PiDiv180; // deg * Math.PI / 180
}
function radToDeg(rad) {
    return rad / PiDiv180; // rad * 180 / Math.PI
}
function isPowerOfTwo(x) {
    return (x !== 0) && (x & (x - 1)) === 0;
}
/** return the value that has the largest absolute value */
function absMax() {
    var values = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        values[_i] = arguments[_i];
    }
    var max = 0;
    var absMax = 0;
    for (var i = 0, il = values.length; i < il; ++i) {
        var value = values[i];
        var abs = Math.abs(value);
        if (abs > absMax) {
            max = value;
            absMax = abs;
        }
    }
    return max;
}
/** Length of an arc with angle in radians */
function arcLength(angle, radius) {
    return angle * radius;
}
//# sourceMappingURL=misc.js.map

/***/ }),

/***/ "./lib/mol-model-formats/shape/ply.js":
/*!********************************************!*\
  !*** ./lib/mol-model-formats/shape/ply.js ***!
  \********************************************/
/*! exports provided: PlyShapeParams, shapeFromPly */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "PlyShapeParams", function() { return PlyShapeParams; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "shapeFromPly", function() { return shapeFromPly; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _mol_task__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../mol-task */ "./lib/mol-task/index.js");
/* harmony import */ var _mol_util_color__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../mol-util/color */ "./lib/mol-util/color/index.js");
/* harmony import */ var _mol_geo_geometry_mesh_mesh_builder__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../mol-geo/geometry/mesh/mesh-builder */ "./lib/mol-geo/geometry/mesh/mesh-builder.js");
/* harmony import */ var _mol_geo_geometry_mesh_mesh__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../mol-geo/geometry/mesh/mesh */ "./lib/mol-geo/geometry/mesh/mesh.js");
/* harmony import */ var _mol_model_shape__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../mol-model/shape */ "./lib/mol-model/shape.js");
/* harmony import */ var _mol_data_util__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../../mol-data/util */ "./lib/mol-data/util.js");
/* harmony import */ var _mol_util_array__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../../mol-util/array */ "./lib/mol-util/array.js");
/* harmony import */ var _mol_data_db__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ../../mol-data/db */ "./lib/mol-data/db.js");
/* harmony import */ var _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ../../mol-util/param-definition */ "./lib/mol-util/param-definition.js");
/* harmony import */ var _mol_util_color_names__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ../../mol-util/color/names */ "./lib/mol-util/color/names.js");
/* harmony import */ var _mol_util_object__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ../../mol-util/object */ "./lib/mol-util/object.js");
/* harmony import */ var _mol_util_string__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! ../../mol-util/string */ "./lib/mol-util/string.js");
/**
 * Copyright (c) 2019-2020 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author Schäfer, Marco <marco.schaefer@uni-tuebingen.de>
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */













// TODO support 'edge' element, see https://www.mathworks.com/help/vision/ug/the-ply-format.html
// TODO support missing face element
function createPlyShapeParams(plyFile) {
    var vertex = plyFile && plyFile.getElement('vertex');
    var material = plyFile && plyFile.getElement('material');
    var defaultValues = { group: '', vRed: '', vGreen: '', vBlue: '', mRed: '', mGreen: '', mBlue: '' };
    var groupOptions = [['', '']];
    var colorOptions = [['', '']];
    if (vertex) {
        for (var i = 0, il = vertex.propertyNames.length; i < il; ++i) {
            var name_1 = vertex.propertyNames[i];
            var type = vertex.propertyTypes[i];
            if (type === 'uchar' || type === 'uint8' ||
                type === 'ushort' || type === 'uint16' ||
                type === 'uint' || type === 'uint32' ||
                type === 'int')
                groupOptions.push([name_1, name_1]);
            if (type === 'uchar' || type === 'uint8')
                colorOptions.push([name_1, name_1]);
        }
        // TODO hardcoded as convenience for data provided by MegaMol
        if (vertex.propertyNames.includes('atomid'))
            defaultValues.group = 'atomid';
        else if (vertex.propertyNames.includes('material_index'))
            defaultValues.group = 'material_index';
        if (vertex.propertyNames.includes('red'))
            defaultValues.vRed = 'red';
        if (vertex.propertyNames.includes('green'))
            defaultValues.vGreen = 'green';
        if (vertex.propertyNames.includes('blue'))
            defaultValues.vBlue = 'blue';
    }
    var materialOptions = [['', '']];
    if (material) {
        for (var i = 0, il = material.propertyNames.length; i < il; ++i) {
            var name_2 = material.propertyNames[i];
            var type = material.propertyTypes[i];
            if (type === 'uchar' || type === 'uint8')
                materialOptions.push([name_2, name_2]);
        }
        if (material.propertyNames.includes('red'))
            defaultValues.mRed = 'red';
        if (material.propertyNames.includes('green'))
            defaultValues.mGreen = 'green';
        if (material.propertyNames.includes('blue'))
            defaultValues.mBlue = 'blue';
    }
    var defaultColoring = defaultValues.vRed && defaultValues.vGreen && defaultValues.vBlue ? 'vertex' :
        defaultValues.mRed && defaultValues.mGreen && defaultValues.mBlue ? 'material' : 'uniform';
    return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, _mol_geo_geometry_mesh_mesh__WEBPACK_IMPORTED_MODULE_4__["Mesh"].Params), { coloring: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_9__["ParamDefinition"].MappedStatic(defaultColoring, {
            vertex: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_9__["ParamDefinition"].Group({
                red: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_9__["ParamDefinition"].Select(defaultValues.vRed, colorOptions, { label: 'Red Property' }),
                green: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_9__["ParamDefinition"].Select(defaultValues.vGreen, colorOptions, { label: 'Green Property' }),
                blue: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_9__["ParamDefinition"].Select(defaultValues.vBlue, colorOptions, { label: 'Blue Property' }),
            }, { isFlat: true }),
            material: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_9__["ParamDefinition"].Group({
                red: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_9__["ParamDefinition"].Select(defaultValues.mRed, materialOptions, { label: 'Red Property' }),
                green: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_9__["ParamDefinition"].Select(defaultValues.mGreen, materialOptions, { label: 'Green Property' }),
                blue: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_9__["ParamDefinition"].Select(defaultValues.mBlue, materialOptions, { label: 'Blue Property' }),
            }, { isFlat: true }),
            uniform: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_9__["ParamDefinition"].Group({
                color: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_9__["ParamDefinition"].Color(_mol_util_color_names__WEBPACK_IMPORTED_MODULE_10__["ColorNames"].grey)
            }, { isFlat: true })
        }), grouping: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_9__["ParamDefinition"].MappedStatic(defaultValues.group ? 'vertex' : 'none', {
            vertex: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_9__["ParamDefinition"].Group({
                group: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_9__["ParamDefinition"].Select(defaultValues.group, groupOptions, { label: 'Group Property' }),
            }, { isFlat: true }),
            none: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_9__["ParamDefinition"].Group({})
        }) });
}
var PlyShapeParams = createPlyShapeParams();
function addVerticesRange(begI, endI, state, vertex, groupIds) {
    var vertices = state.vertices, normals = state.normals, groups = state.groups;
    var x = vertex.getProperty('x');
    var y = vertex.getProperty('y');
    var z = vertex.getProperty('z');
    if (!x || !y || !z)
        throw new Error('missing coordinate properties');
    var nx = vertex.getProperty('nx');
    var ny = vertex.getProperty('ny');
    var nz = vertex.getProperty('nz');
    var hasNormals = !!nx && !!ny && !!nz;
    for (var i = begI; i < endI; ++i) {
        _mol_data_util__WEBPACK_IMPORTED_MODULE_6__["ChunkedArray"].add3(vertices, x.value(i), y.value(i), z.value(i));
        if (hasNormals)
            _mol_data_util__WEBPACK_IMPORTED_MODULE_6__["ChunkedArray"].add3(normals, nx.value(i), ny.value(i), nz.value(i));
        _mol_data_util__WEBPACK_IMPORTED_MODULE_6__["ChunkedArray"].add(groups, groupIds[i]);
    }
}
function addFacesRange(begI, endI, state, face) {
    var indices = state.indices;
    for (var i = begI; i < endI; ++i) {
        var _a = face.value(i), entries = _a.entries, count = _a.count;
        if (count === 3) {
            // triangle
            _mol_data_util__WEBPACK_IMPORTED_MODULE_6__["ChunkedArray"].add3(indices, entries[0], entries[1], entries[2]);
        }
        else if (count === 4) {
            // quadrilateral
            _mol_data_util__WEBPACK_IMPORTED_MODULE_6__["ChunkedArray"].add3(indices, entries[2], entries[1], entries[0]);
            _mol_data_util__WEBPACK_IMPORTED_MODULE_6__["ChunkedArray"].add3(indices, entries[2], entries[0], entries[3]);
        }
    }
}
function getMesh(ctx, vertex, face, groupIds, mesh) {
    return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"])(this, void 0, void 0, function () {
        var builderState, x, y, z, nx, ny, nz, hasNormals, updateChunk, i, il, i, il, m;
        return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__generator"])(this, function (_a) {
            switch (_a.label) {
                case 0:
                    builderState = _mol_geo_geometry_mesh_mesh_builder__WEBPACK_IMPORTED_MODULE_3__["MeshBuilder"].createState(vertex.rowCount, vertex.rowCount / 4, mesh);
                    x = vertex.getProperty('x');
                    y = vertex.getProperty('y');
                    z = vertex.getProperty('z');
                    if (!x || !y || !z)
                        throw new Error('missing coordinate properties');
                    nx = vertex.getProperty('nx');
                    ny = vertex.getProperty('ny');
                    nz = vertex.getProperty('nz');
                    hasNormals = !!nx && !!ny && !!nz;
                    updateChunk = 100000;
                    i = 0, il = vertex.rowCount;
                    _a.label = 1;
                case 1:
                    if (!(i < il)) return [3 /*break*/, 4];
                    addVerticesRange(i, Math.min(i + updateChunk, il), builderState, vertex, groupIds);
                    if (!ctx.shouldUpdate) return [3 /*break*/, 3];
                    return [4 /*yield*/, ctx.update({ message: 'adding ply mesh vertices', current: i, max: il })];
                case 2:
                    _a.sent();
                    _a.label = 3;
                case 3:
                    i += updateChunk;
                    return [3 /*break*/, 1];
                case 4:
                    i = 0, il = face.rowCount;
                    _a.label = 5;
                case 5:
                    if (!(i < il)) return [3 /*break*/, 8];
                    addFacesRange(i, Math.min(i + updateChunk, il), builderState, face);
                    if (!ctx.shouldUpdate) return [3 /*break*/, 7];
                    return [4 /*yield*/, ctx.update({ message: 'adding ply mesh faces', current: i, max: il })];
                case 6:
                    _a.sent();
                    _a.label = 7;
                case 7:
                    i += updateChunk;
                    return [3 /*break*/, 5];
                case 8:
                    m = _mol_geo_geometry_mesh_mesh_builder__WEBPACK_IMPORTED_MODULE_3__["MeshBuilder"].getMesh(builderState);
                    if (!hasNormals)
                        _mol_geo_geometry_mesh_mesh__WEBPACK_IMPORTED_MODULE_4__["Mesh"].computeNormals(m);
                    return [2 /*return*/, m];
            }
        });
    });
}
var int = _mol_data_db__WEBPACK_IMPORTED_MODULE_8__["Column"].Schema.int;
function getGrouping(vertex, props) {
    var grouping = props.grouping;
    var rowCount = vertex.rowCount;
    var column = grouping.name === 'vertex' ? vertex.getProperty(grouping.params.group) : undefined;
    var label = grouping.name === 'vertex' ? Object(_mol_util_string__WEBPACK_IMPORTED_MODULE_12__["stringToWords"])(grouping.params.group) : 'Vertex';
    var ids = column ? column.toArray({ array: Uint32Array }) : Object(_mol_util_array__WEBPACK_IMPORTED_MODULE_7__["fillSerial"])(new Uint32Array(rowCount));
    var maxId = column ? Object(_mol_util_array__WEBPACK_IMPORTED_MODULE_7__["arrayMax"])(ids) : rowCount - 1; // assumes uint ids
    var map = new Uint32Array(maxId + 1);
    for (var i = 0, il = ids.length; i < il; ++i)
        map[ids[i]] = i;
    return { ids: ids, map: map, label: label };
}
function getColoring(vertex, material, props) {
    var coloring = props.coloring;
    var rowCount = vertex.rowCount;
    var red, green, blue;
    if (coloring.name === 'vertex') {
        red = vertex.getProperty(coloring.params.red) || _mol_data_db__WEBPACK_IMPORTED_MODULE_8__["Column"].ofConst(127, rowCount, int);
        green = vertex.getProperty(coloring.params.green) || _mol_data_db__WEBPACK_IMPORTED_MODULE_8__["Column"].ofConst(127, rowCount, int);
        blue = vertex.getProperty(coloring.params.blue) || _mol_data_db__WEBPACK_IMPORTED_MODULE_8__["Column"].ofConst(127, rowCount, int);
    }
    else if (coloring.name === 'material') {
        red = (material && material.getProperty(coloring.params.red)) || _mol_data_db__WEBPACK_IMPORTED_MODULE_8__["Column"].ofConst(127, rowCount, int);
        green = (material && material.getProperty(coloring.params.green)) || _mol_data_db__WEBPACK_IMPORTED_MODULE_8__["Column"].ofConst(127, rowCount, int);
        blue = (material && material.getProperty(coloring.params.blue)) || _mol_data_db__WEBPACK_IMPORTED_MODULE_8__["Column"].ofConst(127, rowCount, int);
    }
    else {
        var _a = _mol_util_color__WEBPACK_IMPORTED_MODULE_2__["Color"].toRgb(coloring.params.color), r = _a[0], g = _a[1], b = _a[2];
        red = _mol_data_db__WEBPACK_IMPORTED_MODULE_8__["Column"].ofConst(r, rowCount, int);
        green = _mol_data_db__WEBPACK_IMPORTED_MODULE_8__["Column"].ofConst(g, rowCount, int);
        blue = _mol_data_db__WEBPACK_IMPORTED_MODULE_8__["Column"].ofConst(b, rowCount, int);
    }
    return { kind: coloring.name, red: red, green: green, blue: blue };
}
function createShape(plyFile, mesh, coloring, grouping) {
    var kind = coloring.kind, red = coloring.red, green = coloring.green, blue = coloring.blue;
    var ids = grouping.ids, map = grouping.map, label = grouping.label;
    return _mol_model_shape__WEBPACK_IMPORTED_MODULE_5__["Shape"].create('ply-mesh', plyFile, mesh, function (groupId) {
        var idx = kind === 'material' ? groupId : map[groupId];
        return _mol_util_color__WEBPACK_IMPORTED_MODULE_2__["Color"].fromRgb(red.value(idx), green.value(idx), blue.value(idx));
    }, function () { return 1; }, // size: constant
    function (groupId) {
        return label + " " + ids[groupId];
    });
}
function makeShapeGetter() {
    var _this = this;
    var _plyFile;
    var _props;
    var _shape;
    var _mesh;
    var _coloring;
    var _grouping;
    var getShape = function (ctx, plyFile, props, shape) { return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"])(_this, void 0, void 0, function () {
        var vertex, face, material, newMesh, newColor;
        return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__generator"])(this, function (_a) {
            switch (_a.label) {
                case 0:
                    vertex = plyFile.getElement('vertex');
                    if (!vertex)
                        throw new Error('missing vertex element');
                    face = plyFile.getElement('face');
                    if (!face)
                        throw new Error('missing face element');
                    material = plyFile.getElement('material');
                    newMesh = false;
                    newColor = false;
                    if (!_plyFile || _plyFile !== plyFile) {
                        newMesh = true;
                    }
                    if (!_props || !_mol_util_param_definition__WEBPACK_IMPORTED_MODULE_9__["ParamDefinition"].isParamEqual(PlyShapeParams.grouping, _props.grouping, props.grouping)) {
                        newMesh = true;
                    }
                    if (!_props || !_mol_util_param_definition__WEBPACK_IMPORTED_MODULE_9__["ParamDefinition"].isParamEqual(PlyShapeParams.coloring, _props.coloring, props.coloring)) {
                        newColor = true;
                    }
                    if (!newMesh) return [3 /*break*/, 2];
                    _coloring = getColoring(vertex, material, props);
                    _grouping = getGrouping(vertex, props);
                    return [4 /*yield*/, getMesh(ctx, vertex, face, _grouping.ids, shape && shape.geometry)];
                case 1:
                    _mesh = _a.sent();
                    _shape = createShape(plyFile, _mesh, _coloring, _grouping);
                    return [3 /*break*/, 3];
                case 2:
                    if (newColor) {
                        _coloring = getColoring(vertex, material, props);
                        _shape = createShape(plyFile, _mesh, _coloring, _grouping);
                    }
                    _a.label = 3;
                case 3:
                    _plyFile = plyFile;
                    _props = Object(_mol_util_object__WEBPACK_IMPORTED_MODULE_11__["deepClone"])(props);
                    return [2 /*return*/, _shape];
            }
        });
    }); };
    return getShape;
}
function shapeFromPly(source, params) {
    var _this = this;
    return _mol_task__WEBPACK_IMPORTED_MODULE_1__["Task"].create('Shape Provider', function (ctx) { return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"])(_this, void 0, void 0, function () {
        return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__generator"])(this, function (_a) {
            return [2 /*return*/, {
                    label: 'Mesh',
                    data: source,
                    params: createPlyShapeParams(source),
                    getShape: makeShapeGetter(),
                    geometryUtils: _mol_geo_geometry_mesh_mesh__WEBPACK_IMPORTED_MODULE_4__["Mesh"].Utils
                }];
        });
    }); });
}
//# sourceMappingURL=ply.js.map

/***/ }),

/***/ "./lib/mol-model-formats/structure/basic/atomic.js":
/*!*********************************************************!*\
  !*** ./lib/mol-model-formats/structure/basic/atomic.js ***!
  \*********************************************************/
/*! exports provided: getAtomicHierarchyAndConformation */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getAtomicHierarchyAndConformation", function() { return getAtomicHierarchyAndConformation; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _mol_data_db__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../../mol-data/db */ "./lib/mol-data/db.js");
/* harmony import */ var _mol_data_int__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../../mol-data/int */ "./lib/mol-data/int.js");
/* harmony import */ var _mol_util_uuid__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../../mol-util/uuid */ "./lib/mol-util/uuid.js");
/* harmony import */ var _mol_model_structure_model_properties_atomic__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../../mol-model/structure/model/properties/atomic */ "./lib/mol-model/structure/model/properties/atomic.js");
/* harmony import */ var _mol_model_structure_model_properties_utils_atomic_index__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../../mol-model/structure/model/properties/utils/atomic-index */ "./lib/mol-model/structure/model/properties/utils/atomic-index.js");
/* harmony import */ var _mol_model_structure_model_types__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../../../mol-model/structure/model/types */ "./lib/mol-model/structure/model/types.js");
/* harmony import */ var _mol_model_structure_model_properties_utils_atomic_derived__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../../../mol-model/structure/model/properties/utils/atomic-derived */ "./lib/mol-model/structure/model/properties/utils/atomic-derived.js");
/* harmony import */ var _mol_math_geometry__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ../../../mol-math/geometry */ "./lib/mol-math/geometry.js");
/* harmony import */ var _mmcif__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ../mmcif */ "./lib/mol-model-formats/structure/mmcif.js");
/* harmony import */ var _mol_model_structure_export_categories_atom_site_operator_mapping__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ../../../mol-model/structure/export/categories/atom_site_operator_mapping */ "./lib/mol-model/structure/export/categories/atom_site_operator_mapping.js");
/* harmony import */ var _mol_io_reader_cif_schema__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ../../../mol-io/reader/cif/schema */ "./lib/mol-io/reader/cif/schema.js");
/* harmony import */ var _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! ../../../mol-math/linear-algebra */ "./lib/mol-math/linear-algebra.js");
/**
 * Copyright (c) 2017-2020 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author David Sehnal <david.sehnal@gmail.com>
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */













function findHierarchyOffsets(atom_site) {
    if (atom_site._rowCount === 0)
        return { residues: [], chains: [] };
    var start = 0, end = atom_site._rowCount;
    var residues = [start], chains = [start];
    var label_entity_id = atom_site.label_entity_id, label_asym_id = atom_site.label_asym_id, label_seq_id = atom_site.label_seq_id, auth_seq_id = atom_site.auth_seq_id, pdbx_PDB_ins_code = atom_site.pdbx_PDB_ins_code;
    for (var i = start + 1; i < end; i++) {
        var newChain = !label_entity_id.areValuesEqual(i - 1, i) || !label_asym_id.areValuesEqual(i - 1, i);
        var newResidue = newChain
            || !label_seq_id.areValuesEqual(i - 1, i)
            || !auth_seq_id.areValuesEqual(i - 1, i)
            || !pdbx_PDB_ins_code.areValuesEqual(i - 1, i);
        // not checking label_comp_id to allow for MICROHETEROGENEITY
        if (newResidue)
            residues[residues.length] = i;
        if (newChain)
            chains[chains.length] = i;
    }
    return { residues: residues, chains: chains };
}
function substUndefinedColumn(table, a, b) {
    if (!table[a].isDefined) {
        table[a] = table[b];
    }
    if (!table[b].isDefined) {
        table[b] = table[a];
    }
}
function createHierarchyData(atom_site, sourceIndex, offsets) {
    var atoms = _mol_data_db__WEBPACK_IMPORTED_MODULE_1__["Table"].ofColumns(_mol_model_structure_model_properties_atomic__WEBPACK_IMPORTED_MODULE_4__["AtomsSchema"], {
        type_symbol: _mol_data_db__WEBPACK_IMPORTED_MODULE_1__["Column"].ofArray({ array: _mol_data_db__WEBPACK_IMPORTED_MODULE_1__["Column"].mapToArray(atom_site.type_symbol, _mol_model_structure_model_types__WEBPACK_IMPORTED_MODULE_6__["ElementSymbol"]), schema: _mol_data_db__WEBPACK_IMPORTED_MODULE_1__["Column"].Schema.Aliased(_mol_data_db__WEBPACK_IMPORTED_MODULE_1__["Column"].Schema.str) }),
        label_atom_id: atom_site.label_atom_id,
        auth_atom_id: atom_site.auth_atom_id,
        label_alt_id: atom_site.label_alt_id,
        label_comp_id: atom_site.label_comp_id,
        auth_comp_id: atom_site.auth_comp_id,
        pdbx_formal_charge: atom_site.pdbx_formal_charge
    });
    var residues = _mol_data_db__WEBPACK_IMPORTED_MODULE_1__["Table"].view(atom_site, _mol_model_structure_model_properties_atomic__WEBPACK_IMPORTED_MODULE_4__["ResiduesSchema"], offsets.residues);
    var chains = _mol_data_db__WEBPACK_IMPORTED_MODULE_1__["Table"].view(atom_site, _mol_model_structure_model_properties_atomic__WEBPACK_IMPORTED_MODULE_4__["ChainsSchema"], offsets.chains);
    if (!residues.label_seq_id.isDefined) {
        var seqIds = new Int32Array(residues.label_seq_id.rowCount);
        var residueOffsets = offsets.residues, chainOffsets = offsets.chains;
        var cI = 0;
        var seqId = 0;
        for (var i = 0, il = seqIds.length; i < il; ++i) {
            if (residueOffsets[i] > chainOffsets[cI + 1]) {
                cI += 1;
                seqId = 0;
            }
            seqIds[i] = ++seqId; // start id on one
        }
        residues.label_seq_id = _mol_data_db__WEBPACK_IMPORTED_MODULE_1__["Column"].ofIntArray(seqIds);
    }
    // Optimize the numeric columns
    _mol_data_db__WEBPACK_IMPORTED_MODULE_1__["Table"].columnToArray(residues, 'label_seq_id', Int32Array);
    _mol_data_db__WEBPACK_IMPORTED_MODULE_1__["Table"].columnToArray(residues, 'auth_seq_id', Int32Array);
    // Fix possibly missing auth_/label_ columns
    substUndefinedColumn(atoms, 'label_atom_id', 'auth_atom_id');
    substUndefinedColumn(atoms, 'label_comp_id', 'auth_comp_id');
    substUndefinedColumn(residues, 'label_seq_id', 'auth_seq_id');
    substUndefinedColumn(chains, 'label_asym_id', 'auth_asym_id');
    return { atoms: atoms, residues: residues, chains: chains, atomSourceIndex: sourceIndex };
}
function getConformation(atom_site) {
    return {
        id: _mol_util_uuid__WEBPACK_IMPORTED_MODULE_3__["default"].create22(),
        atomId: atom_site.id,
        occupancy: atom_site.occupancy,
        B_iso_or_equiv: atom_site.B_iso_or_equiv,
        xyzDefined: atom_site.Cartn_x.isDefined && atom_site.Cartn_y.isDefined && atom_site.Cartn_z.isDefined,
        x: atom_site.Cartn_x.toArray({ array: Float32Array }),
        y: atom_site.Cartn_y.toArray({ array: Float32Array }),
        z: atom_site.Cartn_z.toArray({ array: Float32Array }),
    };
}
function isHierarchyDataEqual(a, b) {
    return _mol_data_db__WEBPACK_IMPORTED_MODULE_1__["Table"].areEqual(a.chains, b.chains)
        && _mol_data_db__WEBPACK_IMPORTED_MODULE_1__["Table"].areEqual(a.residues, b.residues)
        && _mol_data_db__WEBPACK_IMPORTED_MODULE_1__["Table"].areEqual(a.atoms, b.atoms);
}
function createChainOperatorMappingAndSubstituteNames(hierarchy, format) {
    var mapping = new Map();
    if (!_mmcif__WEBPACK_IMPORTED_MODULE_9__["MmcifFormat"].is(format))
        return mapping;
    var entries = Object(_mol_io_reader_cif_schema__WEBPACK_IMPORTED_MODULE_11__["toDatabase"])(_mol_model_structure_export_categories_atom_site_operator_mapping__WEBPACK_IMPORTED_MODULE_10__["AtomSiteOperatorMappingSchema"], format.data.frame).molstar_atom_site_operator_mapping;
    if (entries._rowCount === 0)
        return mapping;
    var labelMap = new Map();
    var authMap = new Map();
    for (var i = 0; i < entries._rowCount; i++) {
        var assembly = entries.assembly_operator_id.valueKind(i) === 0 /* Present */
            ? { id: entries.assembly_id.value(i), operList: [], operId: entries.assembly_operator_id.value(i) }
            : void 0;
        var operator = _mol_math_geometry__WEBPACK_IMPORTED_MODULE_8__["SymmetryOperator"].create(entries.operator_name.value(i), _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_12__["Mat4"].identity(), {
            assembly: assembly,
            spgrOp: entries.symmetry_operator_index.valueKind(i) === 0 /* Present */ ? entries.symmetry_operator_index.value(i) : void 0,
            hkl: _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_12__["Vec3"].ofArray(entries.symmetry_hkl.value(i)),
            ncsId: entries.ncs_id.value(i)
        });
        var suffix = entries.suffix.value(i);
        var label = entries.label_asym_id.value(i);
        labelMap.set("" + label + suffix, { name: label, operator: operator });
        var auth = entries.auth_asym_id.value(i);
        authMap.set("" + auth + suffix, auth);
    }
    var _a = hierarchy.chains, label_asym_id = _a.label_asym_id, auth_asym_id = _a.auth_asym_id;
    var mappedLabel = new Array(label_asym_id.rowCount);
    var mappedAuth = new Array(label_asym_id.rowCount);
    for (var i = 0; i < label_asym_id.rowCount; i++) {
        var label = label_asym_id.value(i), auth = auth_asym_id.value(i);
        if (!labelMap.has(label)) {
            mappedLabel[i] = label;
            mappedAuth[i] = auth;
            continue;
        }
        var _b = labelMap.get(label), name_1 = _b.name, operator = _b.operator;
        mapping.set(i, operator);
        mappedLabel[i] = name_1;
        mappedAuth[i] = authMap.get(auth) || auth;
    }
    hierarchy.chains.label_asym_id = _mol_data_db__WEBPACK_IMPORTED_MODULE_1__["Column"].ofArray({ array: mappedLabel, valueKind: hierarchy.chains.label_asym_id.valueKind, schema: hierarchy.chains.label_asym_id.schema });
    hierarchy.chains.auth_asym_id = _mol_data_db__WEBPACK_IMPORTED_MODULE_1__["Column"].ofArray({ array: mappedAuth, valueKind: hierarchy.chains.auth_asym_id.valueKind, schema: hierarchy.chains.auth_asym_id.schema });
    return mapping;
}
function getAtomicHierarchy(atom_site, sourceIndex, entities, chemicalComponentMap, format, previous) {
    var hierarchyOffsets = findHierarchyOffsets(atom_site);
    var hierarchyData = createHierarchyData(atom_site, sourceIndex, hierarchyOffsets);
    var chainOperatorMapping = createChainOperatorMappingAndSubstituteNames(hierarchyData, format);
    if (previous && isHierarchyDataEqual(previous.atomicHierarchy, hierarchyData)) {
        return {
            sameAsPrevious: true,
            hierarchy: previous.atomicHierarchy,
            chainOperatorMapping: chainOperatorMapping
        };
    }
    var hierarchySegments = {
        residueAtomSegments: _mol_data_int__WEBPACK_IMPORTED_MODULE_2__["Segmentation"].ofOffsets(hierarchyOffsets.residues, _mol_data_int__WEBPACK_IMPORTED_MODULE_2__["Interval"].ofBounds(0, atom_site._rowCount)),
        chainAtomSegments: _mol_data_int__WEBPACK_IMPORTED_MODULE_2__["Segmentation"].ofOffsets(hierarchyOffsets.chains, _mol_data_int__WEBPACK_IMPORTED_MODULE_2__["Interval"].ofBounds(0, atom_site._rowCount)),
    };
    var index = Object(_mol_model_structure_model_properties_utils_atomic_index__WEBPACK_IMPORTED_MODULE_5__["getAtomicIndex"])(hierarchyData, entities, hierarchySegments);
    var derived = Object(_mol_model_structure_model_properties_utils_atomic_derived__WEBPACK_IMPORTED_MODULE_7__["getAtomicDerivedData"])(hierarchyData, hierarchySegments, index, chemicalComponentMap);
    var hierarchy = Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, hierarchyData), hierarchySegments), { index: index, derived: derived });
    return { sameAsPrevious: false, hierarchy: hierarchy, chainOperatorMapping: chainOperatorMapping };
}
function getAtomicHierarchyAndConformation(atom_site, sourceIndex, entities, chemicalComponentMap, format, previous) {
    var _a = getAtomicHierarchy(atom_site, sourceIndex, entities, chemicalComponentMap, format, previous), sameAsPrevious = _a.sameAsPrevious, hierarchy = _a.hierarchy, chainOperatorMapping = _a.chainOperatorMapping;
    var conformation = getConformation(atom_site);
    return { sameAsPrevious: sameAsPrevious, hierarchy: hierarchy, conformation: conformation, chainOperatorMapping: chainOperatorMapping };
}
//# sourceMappingURL=atomic.js.map

/***/ }),

/***/ "./lib/mol-model-formats/structure/basic/coarse.js":
/*!*********************************************************!*\
  !*** ./lib/mol-model-formats/structure/basic/coarse.js ***!
  \*********************************************************/
/*! exports provided: EmptyCoarse, getCoarse */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "EmptyCoarse", function() { return EmptyCoarse; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getCoarse", function() { return getCoarse; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _mol_model_structure_model_properties_coarse__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../../mol-model/structure/model/properties/coarse */ "./lib/mol-model/structure/model/properties/coarse.js");
/* harmony import */ var _mol_model_structure_model_properties_utils_coarse_keys__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../../mol-model/structure/model/properties/utils/coarse-keys */ "./lib/mol-model/structure/model/properties/utils/coarse-keys.js");
/* harmony import */ var _mol_util__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../../mol-util */ "./lib/mol-util/index.js");
/* harmony import */ var _mol_data_int__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../../mol-data/int */ "./lib/mol-data/int.js");
/* harmony import */ var _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../../mol-math/linear-algebra */ "./lib/mol-math/linear-algebra.js");
/* harmony import */ var _mol_model_structure_model_properties_utils_coarse_ranges__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../../../mol-model/structure/model/properties/utils/coarse-ranges */ "./lib/mol-model/structure/model/properties/utils/coarse-ranges.js");
/* harmony import */ var _schema__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ./schema */ "./lib/mol-model-formats/structure/basic/schema.js");
/**
 * Copyright (c) 2018-2020 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author David Sehnal <david.sehnal@gmail.com>
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */








var EmptyCoarse = { hierarchy: _mol_model_structure_model_properties_coarse__WEBPACK_IMPORTED_MODULE_1__["CoarseHierarchy"].Empty, conformation: void 0 };
function getCoarse(data, properties) {
    var ihm_sphere_obj_site = data.ihm_sphere_obj_site, ihm_gaussian_obj_site = data.ihm_gaussian_obj_site;
    if (ihm_sphere_obj_site._rowCount === 0 && ihm_gaussian_obj_site._rowCount === 0)
        return EmptyCoarse;
    var sphereData = getData(ihm_sphere_obj_site);
    var sphereConformation = getSphereConformation(ihm_sphere_obj_site);
    var sphereKeys = Object(_mol_model_structure_model_properties_utils_coarse_keys__WEBPACK_IMPORTED_MODULE_2__["getCoarseKeys"])(sphereData, data.entities);
    var sphereRanges = Object(_mol_model_structure_model_properties_utils_coarse_ranges__WEBPACK_IMPORTED_MODULE_6__["getCoarseRanges"])(sphereData, properties.chemicalComponentMap);
    var gaussianData = getData(ihm_gaussian_obj_site);
    var gaussianConformation = getGaussianConformation(ihm_gaussian_obj_site);
    var gaussianKeys = Object(_mol_model_structure_model_properties_utils_coarse_keys__WEBPACK_IMPORTED_MODULE_2__["getCoarseKeys"])(gaussianData, data.entities);
    var gaussianRanges = Object(_mol_model_structure_model_properties_utils_coarse_ranges__WEBPACK_IMPORTED_MODULE_6__["getCoarseRanges"])(gaussianData, properties.chemicalComponentMap);
    return {
        hierarchy: {
            isDefined: true,
            spheres: Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, sphereData), sphereKeys), sphereRanges),
            gaussians: Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, gaussianData), gaussianKeys), gaussianRanges),
        },
        conformation: {
            id: _mol_util__WEBPACK_IMPORTED_MODULE_3__["UUID"].create22(),
            spheres: sphereConformation,
            gaussians: gaussianConformation
        }
    };
}
function getSphereConformation(data) {
    return {
        x: data.Cartn_x.toArray({ array: Float32Array }),
        y: data.Cartn_y.toArray({ array: Float32Array }),
        z: data.Cartn_z.toArray({ array: Float32Array }),
        radius: data.object_radius.toArray({ array: Float32Array }),
        rmsf: data.rmsf.toArray({ array: Float32Array })
    };
}
function getGaussianConformation(data) {
    var matrix_space = _schema__WEBPACK_IMPORTED_MODULE_7__["BasicSchema"].ihm_gaussian_obj_site.covariance_matrix.space;
    var covariance_matrix = [];
    var cm = data.covariance_matrix;
    for (var i = 0, _i = cm.rowCount; i < _i; i++) {
        covariance_matrix[i] = _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_5__["Tensor"].toMat3(Object(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_5__["Mat3"])(), matrix_space, cm.value(i));
    }
    return {
        x: data.mean_Cartn_x.toArray({ array: Float32Array }),
        y: data.mean_Cartn_y.toArray({ array: Float32Array }),
        z: data.mean_Cartn_z.toArray({ array: Float32Array }),
        weight: data.weight.toArray({ array: Float32Array }),
        covariance_matrix: covariance_matrix
    };
}
function getSegments(asym_id, seq_id_begin, seq_id_end) {
    var chainOffsets = [0];
    for (var i = 1, _i = asym_id.rowCount; i < _i; i++) {
        var newChain = !asym_id.areValuesEqual(i - 1, i);
        if (newChain)
            chainOffsets[chainOffsets.length] = i;
    }
    return {
        chainElementSegments: _mol_data_int__WEBPACK_IMPORTED_MODULE_4__["Segmentation"].ofOffsets(chainOffsets, _mol_data_int__WEBPACK_IMPORTED_MODULE_4__["Interval"].ofBounds(0, asym_id.rowCount))
    };
}
function getData(data) {
    var entity_id = data.entity_id, seq_id_begin = data.seq_id_begin, seq_id_end = data.seq_id_end, asym_id = data.asym_id;
    return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({ count: entity_id.rowCount, entity_id: entity_id, asym_id: asym_id, seq_id_begin: seq_id_begin, seq_id_end: seq_id_end }, getSegments(asym_id, seq_id_begin, seq_id_end));
}
//# sourceMappingURL=coarse.js.map

/***/ }),

/***/ "./lib/mol-model-formats/structure/basic/entities.js":
/*!***********************************************************!*\
  !*** ./lib/mol-model-formats/structure/basic/entities.js ***!
  \***********************************************************/
/*! exports provided: getEntities */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getEntities", function() { return getEntities; });
/* harmony import */ var _mol_data_db__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../../mol-data/db */ "./lib/mol-data/db.js");
/* harmony import */ var _mol_model_structure_model_properties_common__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../../mol-model/structure/model/properties/common */ "./lib/mol-model/structure/model/properties/common.js");
/* harmony import */ var _mol_model_structure_model_types__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../../mol-model/structure/model/types */ "./lib/mol-model/structure/model/types.js");
/* harmony import */ var _schema__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./schema */ "./lib/mol-model-formats/structure/basic/schema.js");
/**
 * Copyright (c) 2017-2020 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author David Sehnal <david.sehnal@gmail.com>
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */




function getEntities(data, properties) {
    var _a;
    var entityData;
    if (!data.entity.id.isDefined) {
        var entityIds_1 = new Set();
        var ids = [];
        var types = [];
        var _b = data.atom_site, label_entity_id = _b.label_entity_id, label_comp_id = _b.label_comp_id;
        for (var i = 0, il = data.atom_site._rowCount; i < il; i++) {
            var entityId = label_entity_id.value(i);
            if (!entityIds_1.has(entityId)) {
                ids.push(entityId);
                types.push(Object(_mol_model_structure_model_types__WEBPACK_IMPORTED_MODULE_2__["getEntityType"])(label_comp_id.value(i)));
                entityIds_1.add(entityId);
            }
        }
        var sphere_entity_id = data.ihm_sphere_obj_site.entity_id;
        for (var i = 0, il = data.ihm_sphere_obj_site._rowCount; i < il; i++) {
            var entityId = sphere_entity_id.value(i);
            if (!entityIds_1.has(entityId)) {
                ids.push(entityId);
                types.push('polymer');
                entityIds_1.add(entityId);
            }
        }
        var gaussian_entity_id = data.ihm_gaussian_obj_site.entity_id;
        for (var i = 0, il = data.ihm_gaussian_obj_site._rowCount; i < il; i++) {
            var entityId = gaussian_entity_id.value(i);
            if (!entityIds_1.has(entityId)) {
                ids.push(entityId);
                types.push('polymer');
                entityIds_1.add(entityId);
            }
        }
        entityData = _mol_data_db__WEBPACK_IMPORTED_MODULE_0__["Table"].ofPartialColumns(_schema__WEBPACK_IMPORTED_MODULE_3__["BasicSchema"].entity, {
            id: _mol_data_db__WEBPACK_IMPORTED_MODULE_0__["Column"].ofArray({ array: ids, schema: _schema__WEBPACK_IMPORTED_MODULE_3__["BasicSchema"].entity.id }),
            type: _mol_data_db__WEBPACK_IMPORTED_MODULE_0__["Column"].ofArray({ array: types, schema: _schema__WEBPACK_IMPORTED_MODULE_3__["BasicSchema"].entity.type }),
        }, ids.length);
    }
    else {
        entityData = data.entity;
    }
    var getEntityIndex = _mol_data_db__WEBPACK_IMPORTED_MODULE_0__["Column"].createIndexer(entityData.id);
    //
    var subtypes = new Array(entityData._rowCount);
    subtypes.fill('other');
    var entityIds = new Set();
    var assignSubtype = false;
    if (data.entity_poly && data.entity_poly.type.isDefined) {
        var _c = data.entity_poly, entity_id = _c.entity_id, type = _c.type, _rowCount = _c._rowCount;
        for (var i = 0; i < _rowCount; ++i) {
            var entityId = entity_id.value(i);
            subtypes[getEntityIndex(entityId)] = type.value(i);
            entityIds.add(entityId);
        }
    }
    else {
        assignSubtype = true;
    }
    if (data.pdbx_entity_branch && data.pdbx_entity_branch.entity_id.isDefined) {
        var _d = data.pdbx_entity_branch, entity_id = _d.entity_id, type = _d.type, _rowCount = _d._rowCount;
        for (var i = 0; i < _rowCount; ++i) {
            var entityId = entity_id.value(i);
            subtypes[getEntityIndex(entityId)] = type.value(i);
            entityIds.add(entityId);
        }
    }
    else {
        assignSubtype = true;
    }
    if (entityIds.size < subtypes.length) {
        // still unassigned subtypes, need to derive from component id/type
        assignSubtype = true;
    }
    if (assignSubtype) {
        var chemCompType = new Map();
        if (data.chem_comp) {
            var _e = data.chem_comp, id = _e.id, type = _e.type;
            for (var i = 0, il = data.chem_comp._rowCount; i < il; i++) {
                chemCompType.set(id.value(i), type.value(i));
            }
        }
        if (data.atom_site) {
            var _f = data.atom_site, label_entity_id = _f.label_entity_id, label_comp_id = _f.label_comp_id;
            for (var i = 0, il = data.atom_site._rowCount; i < il; i++) {
                var entityId = label_entity_id.value(i);
                if (!entityIds.has(entityId)) {
                    var compId = label_comp_id.value(i);
                    var compType = chemCompType.get(compId) || '';
                    subtypes[getEntityIndex(entityId)] = Object(_mol_model_structure_model_types__WEBPACK_IMPORTED_MODULE_2__["getEntitySubtype"])(compId, compType);
                    entityIds.add(entityId);
                }
            }
        }
        // TODO how to handle coarse?
    }
    var subtypeColumn = _mol_data_db__WEBPACK_IMPORTED_MODULE_0__["Column"].ofArray({ array: subtypes, schema: _mol_model_structure_model_properties_common__WEBPACK_IMPORTED_MODULE_1__["EntitySubtype"] });
    //
    var prdIds = new Array(entityData._rowCount);
    prdIds.fill('');
    if (data.pdbx_molecule && data.pdbx_molecule.prd_id.isDefined) {
        var _g = data.pdbx_molecule, asym_id = _g.asym_id, prd_id = _g.prd_id, _rowCount = _g._rowCount;
        for (var i = 0; i < _rowCount; ++i) {
            var asymId = asym_id.value(i);
            var entityId = (_a = properties.structAsymMap.get(asymId)) === null || _a === void 0 ? void 0 : _a.entity_id;
            if (entityId !== undefined) {
                prdIds[getEntityIndex(entityId)] = prd_id.value(i);
            }
        }
    }
    var prdIdColumn = _mol_data_db__WEBPACK_IMPORTED_MODULE_0__["Column"].ofArray({ array: prdIds, schema: _mol_data_db__WEBPACK_IMPORTED_MODULE_0__["Column"].Schema.str });
    return {
        data: entityData,
        subtype: subtypeColumn,
        prd_id: prdIdColumn,
        getEntityIndex: getEntityIndex
    };
}
//# sourceMappingURL=entities.js.map

/***/ }),

/***/ "./lib/mol-model-formats/structure/basic/parser.js":
/*!*********************************************************!*\
  !*** ./lib/mol-model-formats/structure/basic/parser.js ***!
  \*********************************************************/
/*! exports provided: createModels */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createModels", function() { return createModels; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _mol_data_db__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../../mol-data/db */ "./lib/mol-data/db.js");
/* harmony import */ var _mol_util_uuid__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../../mol-util/uuid */ "./lib/mol-util/uuid.js");
/* harmony import */ var _mol_model_structure_model_model__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../../mol-model/structure/model/model */ "./lib/mol-model/structure/model/model.js");
/* harmony import */ var _mol_model_custom_property__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../../mol-model/custom-property */ "./lib/mol-model/custom-property.js");
/* harmony import */ var _atomic__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./atomic */ "./lib/mol-model-formats/structure/basic/atomic.js");
/* harmony import */ var _coarse__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ./coarse */ "./lib/mol-model-formats/structure/basic/coarse.js");
/* harmony import */ var _sequence__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ./sequence */ "./lib/mol-model-formats/structure/basic/sequence.js");
/* harmony import */ var _sort__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ./sort */ "./lib/mol-model-formats/structure/basic/sort.js");
/* harmony import */ var _mol_model_structure_model_properties_utils_atomic_ranges__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ../../../mol-model/structure/model/properties/utils/atomic-ranges */ "./lib/mol-model/structure/model/properties/utils/atomic-ranges.js");
/* harmony import */ var _properties__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ./properties */ "./lib/mol-model-formats/structure/basic/properties.js");
/* harmony import */ var _entities__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ./entities */ "./lib/mol-model-formats/structure/basic/entities.js");
/* harmony import */ var _util__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! ./util */ "./lib/mol-model-formats/structure/basic/util.js");
/* harmony import */ var _mol_model_structure_trajectory__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! ../../../mol-model/structure/trajectory */ "./lib/mol-model/structure/trajectory.js");
/**
 * Copyright (c) 2017-2020 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author David Sehnal <david.sehnal@gmail.com>
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */














function createModels(data, format, ctx) {
    return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"])(this, void 0, void 0, function () {
        var properties, models, _a, i;
        return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__generator"])(this, function (_b) {
            switch (_b.label) {
                case 0:
                    properties = Object(_properties__WEBPACK_IMPORTED_MODULE_10__["getProperties"])(data);
                    if (!(data.ihm_model_list._rowCount > 0)) return [3 /*break*/, 2];
                    return [4 /*yield*/, readIntegrative(ctx, data, properties, format)];
                case 1:
                    _a = _b.sent();
                    return [3 /*break*/, 4];
                case 2: return [4 /*yield*/, readStandard(ctx, data, properties, format)];
                case 3:
                    _a = _b.sent();
                    _b.label = 4;
                case 4:
                    models = _a;
                    for (i = 0; i < models.length; i++) {
                        _mol_model_structure_model_model__WEBPACK_IMPORTED_MODULE_3__["Model"].TrajectoryInfo.set(models[i], { index: i, size: models.length });
                    }
                    return [2 /*return*/, new _mol_model_structure_trajectory__WEBPACK_IMPORTED_MODULE_13__["ArrayTrajectory"](models)];
            }
        });
    });
}
/** Standard atomic model */
function createStandardModel(data, atom_site, sourceIndex, entities, properties, format, previous) {
    var atomic = Object(_atomic__WEBPACK_IMPORTED_MODULE_5__["getAtomicHierarchyAndConformation"])(atom_site, sourceIndex, entities, properties.chemicalComponentMap, format, previous);
    var modelNum = atom_site.pdbx_PDB_model_num.value(0);
    if (previous && atomic.sameAsPrevious) {
        return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, previous), { id: _mol_util_uuid__WEBPACK_IMPORTED_MODULE_2__["default"].create22(), modelNum: modelNum, atomicConformation: atomic.conformation, _dynamicPropertyData: Object.create(null) });
    }
    var coarse = _coarse__WEBPACK_IMPORTED_MODULE_6__["EmptyCoarse"];
    var sequence = Object(_sequence__WEBPACK_IMPORTED_MODULE_7__["getSequence"])(data, entities, atomic.hierarchy, coarse.hierarchy);
    var atomicRanges = Object(_mol_model_structure_model_properties_utils_atomic_ranges__WEBPACK_IMPORTED_MODULE_9__["getAtomicRanges"])(atomic.hierarchy, entities, atomic.conformation, sequence);
    var entry = data.entry.id.valueKind(0) === 0 /* Present */
        ? data.entry.id.value(0) : format.name;
    var label = [];
    if (entry)
        label.push(entry);
    if (data.struct.title.valueKind(0) === 0 /* Present */)
        label.push(data.struct.title.value(0));
    return {
        id: _mol_util_uuid__WEBPACK_IMPORTED_MODULE_2__["default"].create22(),
        entryId: entry,
        label: label.join(' | '),
        entry: entry,
        sourceData: format,
        modelNum: modelNum,
        parent: undefined,
        entities: entities,
        sequence: sequence,
        atomicHierarchy: atomic.hierarchy,
        atomicConformation: atomic.conformation,
        atomicRanges: atomicRanges,
        atomicChainOperatorMappinng: atomic.chainOperatorMapping,
        coarseHierarchy: coarse.hierarchy,
        coarseConformation: coarse.conformation,
        properties: properties,
        customProperties: new _mol_model_custom_property__WEBPACK_IMPORTED_MODULE_4__["CustomProperties"](),
        _staticPropertyData: Object.create(null),
        _dynamicPropertyData: Object.create(null)
    };
}
/** Integrative model with atomic/coarse parts */
function createIntegrativeModel(data, ihm, properties, format) {
    var atomic = Object(_atomic__WEBPACK_IMPORTED_MODULE_5__["getAtomicHierarchyAndConformation"])(ihm.atom_site, ihm.atom_site_sourceIndex, ihm.entities, properties.chemicalComponentMap, format);
    var coarse = Object(_coarse__WEBPACK_IMPORTED_MODULE_6__["getCoarse"])(ihm, properties);
    var sequence = Object(_sequence__WEBPACK_IMPORTED_MODULE_7__["getSequence"])(data, ihm.entities, atomic.hierarchy, coarse.hierarchy);
    var atomicRanges = Object(_mol_model_structure_model_properties_utils_atomic_ranges__WEBPACK_IMPORTED_MODULE_9__["getAtomicRanges"])(atomic.hierarchy, ihm.entities, atomic.conformation, sequence);
    var entry = data.entry.id.valueKind(0) === 0 /* Present */
        ? data.entry.id.value(0) : format.name;
    var label = [];
    if (entry)
        label.push(entry);
    if (data.struct.title.valueKind(0) === 0 /* Present */)
        label.push(data.struct.title.value(0));
    if (ihm.model_name)
        label.push(ihm.model_name);
    if (ihm.model_group_name)
        label.push(ihm.model_group_name);
    return {
        id: _mol_util_uuid__WEBPACK_IMPORTED_MODULE_2__["default"].create22(),
        entryId: entry,
        label: label.join(' | '),
        entry: entry,
        sourceData: format,
        modelNum: ihm.model_id,
        parent: undefined,
        entities: ihm.entities,
        sequence: sequence,
        atomicHierarchy: atomic.hierarchy,
        atomicConformation: atomic.conformation,
        atomicRanges: atomicRanges,
        atomicChainOperatorMappinng: atomic.chainOperatorMapping,
        coarseHierarchy: coarse.hierarchy,
        coarseConformation: coarse.conformation,
        properties: properties,
        customProperties: new _mol_model_custom_property__WEBPACK_IMPORTED_MODULE_4__["CustomProperties"](),
        _staticPropertyData: Object.create(null),
        _dynamicPropertyData: Object.create(null)
    };
}
function findModelEnd(num, startIndex) {
    var rowCount = num.rowCount;
    if (!num.isDefined)
        return rowCount;
    var endIndex = startIndex + 1;
    while (endIndex < rowCount && num.areValuesEqual(startIndex, endIndex))
        endIndex++;
    return endIndex;
}
function readStandard(ctx, data, properties, format) {
    return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"])(this, void 0, void 0, function () {
        var models, atomCount, entities, modelStart, modelEnd, _a, atom_site, sourceIndex, model;
        return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__generator"])(this, function (_b) {
            switch (_b.label) {
                case 0:
                    models = [];
                    if (!data.atom_site) return [3 /*break*/, 3];
                    atomCount = data.atom_site.id.rowCount;
                    entities = Object(_entities__WEBPACK_IMPORTED_MODULE_11__["getEntities"])(data, properties);
                    modelStart = 0;
                    _b.label = 1;
                case 1:
                    if (!(modelStart < atomCount)) return [3 /*break*/, 3];
                    modelEnd = findModelEnd(data.atom_site.pdbx_PDB_model_num, modelStart);
                    return [4 /*yield*/, Object(_sort__WEBPACK_IMPORTED_MODULE_8__["sortAtomSite"])(ctx, data.atom_site, modelStart, modelEnd)];
                case 2:
                    _a = _b.sent(), atom_site = _a.atom_site, sourceIndex = _a.sourceIndex;
                    model = createStandardModel(data, atom_site, sourceIndex, entities, properties, format, models.length > 0 ? models[models.length - 1] : void 0);
                    models.push(model);
                    modelStart = modelEnd;
                    return [3 /*break*/, 1];
                case 3: return [2 /*return*/, models];
            }
        });
    });
}
function splitTable(table, col) {
    var ret = new Map();
    var rowCount = table._rowCount;
    var modelStart = 0;
    while (modelStart < rowCount) {
        var modelEnd = findModelEnd(col, modelStart);
        var id = col.value(modelStart);
        ret.set(id, {
            table: _mol_data_db__WEBPACK_IMPORTED_MODULE_1__["Table"].window(table, table._schema, modelStart, modelEnd),
            start: modelStart,
            end: modelEnd
        });
        modelStart = modelEnd;
    }
    return ret;
}
function readIntegrative(ctx, data, properties, format) {
    return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"])(this, void 0, void 0, function () {
        var entities, atom_sites_modelColumn, atom_sites, sphere_sites, gauss_sites, models, _a, model_id, model_name, i, id, atom_site, atom_site_sourceIndex, e, _b, sorted, sourceIndex, ihm, model;
        return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__generator"])(this, function (_c) {
            switch (_c.label) {
                case 0:
                    entities = Object(_entities__WEBPACK_IMPORTED_MODULE_11__["getEntities"])(data, properties);
                    atom_sites_modelColumn = data.atom_site.ihm_model_id.isDefined
                        ? data.atom_site.ihm_model_id : data.atom_site.pdbx_PDB_model_num;
                    atom_sites = splitTable(data.atom_site, atom_sites_modelColumn);
                    sphere_sites = splitTable(data.ihm_sphere_obj_site, data.ihm_sphere_obj_site.model_id);
                    gauss_sites = splitTable(data.ihm_gaussian_obj_site, data.ihm_gaussian_obj_site.model_id);
                    models = [];
                    if (!data.ihm_model_list) return [3 /*break*/, 6];
                    _a = data.ihm_model_list, model_id = _a.model_id, model_name = _a.model_name;
                    i = 0;
                    _c.label = 1;
                case 1:
                    if (!(i < data.ihm_model_list._rowCount)) return [3 /*break*/, 6];
                    id = model_id.value(i);
                    atom_site = void 0, atom_site_sourceIndex = void 0;
                    if (!atom_sites.has(id)) return [3 /*break*/, 3];
                    e = atom_sites.get(id);
                    return [4 /*yield*/, Object(_sort__WEBPACK_IMPORTED_MODULE_8__["sortAtomSite"])(ctx, data.atom_site, e.start, e.end)];
                case 2:
                    _b = _c.sent(), sorted = _b.atom_site, sourceIndex = _b.sourceIndex;
                    atom_site = sorted;
                    atom_site_sourceIndex = sourceIndex;
                    return [3 /*break*/, 4];
                case 3:
                    atom_site = _mol_data_db__WEBPACK_IMPORTED_MODULE_1__["Table"].window(data.atom_site, data.atom_site._schema, 0, 0);
                    atom_site_sourceIndex = _mol_data_db__WEBPACK_IMPORTED_MODULE_1__["Column"].ofIntArray([]);
                    _c.label = 4;
                case 4:
                    ihm = {
                        model_id: id,
                        model_name: model_name.value(i),
                        model_group_name: Object(_util__WEBPACK_IMPORTED_MODULE_12__["getModelGroupName"])(id, data),
                        entities: entities,
                        atom_site: atom_site,
                        atom_site_sourceIndex: atom_site_sourceIndex,
                        ihm_sphere_obj_site: sphere_sites.has(id) ? sphere_sites.get(id).table : _mol_data_db__WEBPACK_IMPORTED_MODULE_1__["Table"].window(data.ihm_sphere_obj_site, data.ihm_sphere_obj_site._schema, 0, 0),
                        ihm_gaussian_obj_site: gauss_sites.has(id) ? gauss_sites.get(id).table : _mol_data_db__WEBPACK_IMPORTED_MODULE_1__["Table"].window(data.ihm_gaussian_obj_site, data.ihm_gaussian_obj_site._schema, 0, 0)
                    };
                    model = createIntegrativeModel(data, ihm, properties, format);
                    models.push(model);
                    _c.label = 5;
                case 5:
                    i++;
                    return [3 /*break*/, 1];
                case 6: return [2 /*return*/, models];
            }
        });
    });
}
//# sourceMappingURL=parser.js.map

/***/ }),

/***/ "./lib/mol-model-formats/structure/basic/properties.js":
/*!*************************************************************!*\
  !*** ./lib/mol-model-formats/structure/basic/properties.js ***!
  \*************************************************************/
/*! exports provided: getProperties */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getProperties", function() { return getProperties; });
/* harmony import */ var _mol_model_structure_model_types__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../../mol-model/structure/model/types */ "./lib/mol-model/structure/model/types.js");
/* harmony import */ var _mol_model_structure_structure_carbohydrates_constants__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../../mol-model/structure/structure/carbohydrates/constants */ "./lib/mol-model/structure/structure/carbohydrates/constants.js");
/* harmony import */ var _mol_util_memoize__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../../mol-util/memoize */ "./lib/mol-util/memoize.js");
/* harmony import */ var _mol_data_db__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../../mol-data/db */ "./lib/mol-data/db.js");
/**
 * Copyright (c) 2017-2020 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author David Sehnal <david.sehnal@gmail.com>
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */




function getMissingResidues(data) {
    var map = new Map();
    var getKey = function (model_num, asym_id, seq_id) {
        return model_num + "|" + asym_id + "|" + seq_id;
    };
    var c = data.pdbx_unobs_or_zero_occ_residues;
    for (var i = 0, il = c._rowCount; i < il; ++i) {
        var key = getKey(c.PDB_model_num.value(i), c.label_asym_id.value(i), c.label_seq_id.value(i));
        map.set(key, { polymer_flag: c.polymer_flag.value(i), occupancy_flag: c.occupancy_flag.value(i) });
    }
    return {
        has: function (model_num, asym_id, seq_id) {
            return map.has(getKey(model_num, asym_id, seq_id));
        },
        get: function (model_num, asym_id, seq_id) {
            return map.get(getKey(model_num, asym_id, seq_id));
        },
        size: map.size
    };
}
function getChemicalComponentMap(data) {
    var map = new Map();
    if (data.chem_comp._rowCount > 0) {
        var id = data.chem_comp.id;
        for (var i = 0, il = id.rowCount; i < il; ++i) {
            map.set(id.value(i), _mol_data_db__WEBPACK_IMPORTED_MODULE_3__["Table"].getRow(data.chem_comp, i));
        }
    }
    else {
        var uniqueNames = getUniqueComponentNames(data);
        uniqueNames.forEach(function (n) {
            map.set(n, Object(_mol_model_structure_model_types__WEBPACK_IMPORTED_MODULE_0__["getDefaultChemicalComponent"])(n));
        });
    }
    return map;
}
function getSaccharideComponentMap(data) {
    var map = new Map();
    if (data.pdbx_chem_comp_identifier._rowCount > 0) {
        // note that `pdbx_chem_comp_identifier` does not contain
        // a 'SNFG CARBOHYDRATE SYMBOL' entry for 'Unknown' saccharide components
        // so we always need to check `chem_comp` for those
        var _a = data.pdbx_chem_comp_identifier, comp_id = _a.comp_id, type = _a.type, identifier = _a.identifier;
        for (var i = 0, il = comp_id.rowCount; i < il; ++i) {
            if (type.value(i) === 'SNFG CARBOHYDRATE SYMBOL' ||
                type.value(i) === 'SNFG CARB SYMBOL' // legacy, to be removed from mmCIF dictionary
            ) {
                var snfgName = identifier.value(i);
                var saccharideComp = _mol_model_structure_structure_carbohydrates_constants__WEBPACK_IMPORTED_MODULE_1__["SaccharidesSnfgMap"].get(snfgName);
                if (saccharideComp) {
                    map.set(comp_id.value(i), saccharideComp);
                }
                else {
                    console.warn("Unknown SNFG name '" + snfgName + "'");
                }
            }
        }
    }
    if (data.chem_comp._rowCount > 0) {
        var _b = data.chem_comp, id = _b.id, type = _b.type;
        for (var i = 0, il = id.rowCount; i < il; ++i) {
            var _id = id.value(i);
            if (map.has(_id))
                continue;
            var _type = type.value(i);
            if (_mol_model_structure_structure_carbohydrates_constants__WEBPACK_IMPORTED_MODULE_1__["SaccharideCompIdMap"].has(_id)) {
                map.set(_id, _mol_model_structure_structure_carbohydrates_constants__WEBPACK_IMPORTED_MODULE_1__["SaccharideCompIdMap"].get(_id));
            }
            else if (Object(_mol_model_structure_model_types__WEBPACK_IMPORTED_MODULE_0__["getMoleculeType"])(_type, _id) === 9 /* Saccharide */) {
                map.set(_id, _mol_model_structure_structure_carbohydrates_constants__WEBPACK_IMPORTED_MODULE_1__["UnknownSaccharideComponent"]);
            }
        }
    }
    else {
        var uniqueNames_1 = getUniqueComponentNames(data);
        _mol_model_structure_structure_carbohydrates_constants__WEBPACK_IMPORTED_MODULE_1__["SaccharideCompIdMap"].forEach(function (v, k) {
            if (!map.has(k) && uniqueNames_1.has(k))
                map.set(k, v);
        });
    }
    return map;
}
var getUniqueComponentNames = Object(_mol_util_memoize__WEBPACK_IMPORTED_MODULE_2__["memoize1"])(function (data) {
    var uniqueNames = new Set();
    var _a = data.atom_site, label_comp_id = _a.label_comp_id, auth_comp_id = _a.auth_comp_id;
    var comp_id = label_comp_id.isDefined ? label_comp_id : auth_comp_id;
    for (var i = 0, il = comp_id.rowCount; i < il; ++i) {
        uniqueNames.add(comp_id.value(i));
    }
    return uniqueNames;
});
function getStructAsymMap(data) {
    var map = new Map();
    var _a = data.atom_site, label_asym_id = _a.label_asym_id, auth_asym_id = _a.auth_asym_id, label_entity_id = _a.label_entity_id;
    for (var i = 0, il = label_asym_id.rowCount; i < il; ++i) {
        var id = label_asym_id.value(i);
        if (!map.has(id)) {
            map.set(id, {
                id: id,
                auth_id: auth_asym_id.value(i),
                entity_id: label_entity_id.value(i)
            });
        }
    }
    if (data.struct_asym._rowCount > 0) {
        var _b = data.struct_asym, id = _b.id, entity_id = _b.entity_id;
        for (var i = 0, il = id.rowCount; i < il; ++i) {
            var _id = id.value(i);
            if (!map.has(_id)) {
                map.set(_id, {
                    id: _id,
                    auth_id: '',
                    entity_id: entity_id.value(i)
                });
            }
        }
    }
    return map;
}
function getProperties(data) {
    return {
        missingResidues: getMissingResidues(data),
        chemicalComponentMap: getChemicalComponentMap(data),
        saccharideComponentMap: getSaccharideComponentMap(data),
        structAsymMap: getStructAsymMap(data)
    };
}
//# sourceMappingURL=properties.js.map

/***/ }),

/***/ "./lib/mol-model-formats/structure/basic/schema.js":
/*!*********************************************************!*\
  !*** ./lib/mol-model-formats/structure/basic/schema.js ***!
  \*********************************************************/
/*! exports provided: BasicSchema, createBasic */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "BasicSchema", function() { return BasicSchema; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createBasic", function() { return createBasic; });
/* harmony import */ var _mol_io_reader_cif_schema_mmcif__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../../mol-io/reader/cif/schema/mmcif */ "./lib/mol-io/reader/cif/schema/mmcif.js");
/* harmony import */ var _mol_data_db__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../../mol-data/db */ "./lib/mol-data/db.js");
/* harmony import */ var _mol_io_reader_cif_schema_mmcif_extras__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../../mol-io/reader/cif/schema/mmcif-extras */ "./lib/mol-io/reader/cif/schema/mmcif-extras.js");
/**
 * Copyright (c) 2020 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */



var BasicSchema = {
    entry: _mol_io_reader_cif_schema_mmcif__WEBPACK_IMPORTED_MODULE_0__["mmCIF_Schema"].entry,
    struct: _mol_io_reader_cif_schema_mmcif__WEBPACK_IMPORTED_MODULE_0__["mmCIF_Schema"].struct,
    struct_asym: _mol_io_reader_cif_schema_mmcif__WEBPACK_IMPORTED_MODULE_0__["mmCIF_Schema"].struct_asym,
    ihm_model_list: _mol_io_reader_cif_schema_mmcif__WEBPACK_IMPORTED_MODULE_0__["mmCIF_Schema"].ihm_model_list,
    ihm_model_group: _mol_io_reader_cif_schema_mmcif__WEBPACK_IMPORTED_MODULE_0__["mmCIF_Schema"].ihm_model_group,
    ihm_model_group_link: _mol_io_reader_cif_schema_mmcif__WEBPACK_IMPORTED_MODULE_0__["mmCIF_Schema"].ihm_model_group_link,
    entity: _mol_io_reader_cif_schema_mmcif__WEBPACK_IMPORTED_MODULE_0__["mmCIF_Schema"].entity,
    entity_poly: _mol_io_reader_cif_schema_mmcif__WEBPACK_IMPORTED_MODULE_0__["mmCIF_Schema"].entity_poly,
    entity_poly_seq: _mol_io_reader_cif_schema_mmcif__WEBPACK_IMPORTED_MODULE_0__["mmCIF_Schema"].entity_poly_seq,
    pdbx_entity_branch: _mol_io_reader_cif_schema_mmcif__WEBPACK_IMPORTED_MODULE_0__["mmCIF_Schema"].pdbx_entity_branch,
    chem_comp: _mol_io_reader_cif_schema_mmcif_extras__WEBPACK_IMPORTED_MODULE_2__["mmCIF_chemComp_schema"],
    pdbx_chem_comp_identifier: _mol_io_reader_cif_schema_mmcif__WEBPACK_IMPORTED_MODULE_0__["mmCIF_Schema"].pdbx_chem_comp_identifier,
    atom_site: _mol_io_reader_cif_schema_mmcif__WEBPACK_IMPORTED_MODULE_0__["mmCIF_Schema"].atom_site,
    ihm_sphere_obj_site: _mol_io_reader_cif_schema_mmcif__WEBPACK_IMPORTED_MODULE_0__["mmCIF_Schema"].ihm_sphere_obj_site,
    ihm_gaussian_obj_site: _mol_io_reader_cif_schema_mmcif__WEBPACK_IMPORTED_MODULE_0__["mmCIF_Schema"].ihm_gaussian_obj_site,
    pdbx_unobs_or_zero_occ_residues: _mol_io_reader_cif_schema_mmcif__WEBPACK_IMPORTED_MODULE_0__["mmCIF_Schema"].pdbx_unobs_or_zero_occ_residues,
    pdbx_molecule: _mol_io_reader_cif_schema_mmcif__WEBPACK_IMPORTED_MODULE_0__["mmCIF_Schema"].pdbx_molecule,
};
function createBasic(data) {
    var basic = Object.create(null);
    for (var _i = 0, _a = Object.keys(BasicSchema); _i < _a.length; _i++) {
        var name_1 = _a[_i];
        if (name_1 in data) {
            basic[name_1] = data[name_1];
        }
        else {
            basic[name_1] = _mol_data_db__WEBPACK_IMPORTED_MODULE_1__["Table"].ofUndefinedColumns(BasicSchema[name_1], 0);
        }
    }
    return basic;
}
//# sourceMappingURL=schema.js.map

/***/ }),

/***/ "./lib/mol-model-formats/structure/basic/sequence.js":
/*!***********************************************************!*\
  !*** ./lib/mol-model-formats/structure/basic/sequence.js ***!
  \***********************************************************/
/*! exports provided: getSequence */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getSequence", function() { return getSequence; });
/* harmony import */ var _mol_model_structure_model_properties_sequence__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../../mol-model/structure/model/properties/sequence */ "./lib/mol-model/structure/model/properties/sequence.js");
/* harmony import */ var _mol_data_db__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../../mol-data/db */ "./lib/mol-data/db.js");
/* harmony import */ var _mol_model_sequence__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../../mol-model/sequence */ "./lib/mol-model/sequence.js");
/**
 * Copyright (c) 2018-2020 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author David Sehnal <david.sehnal@gmail.com>
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */



function getSequence(data, entities, atomicHierarchy, coarseHierarchy) {
    if (!data.entity_poly_seq || !data.entity_poly_seq._rowCount) {
        return _mol_model_structure_model_properties_sequence__WEBPACK_IMPORTED_MODULE_0__["default"].fromHierarchy(entities, atomicHierarchy, coarseHierarchy);
    }
    var _a = data.entity_poly_seq, entity_id = _a.entity_id, num = _a.num, mon_id = _a.mon_id;
    var byEntityKey = {};
    var sequences = [];
    var count = entity_id.rowCount;
    var i = 0;
    while (i < count) {
        var start = i;
        while (i < count - 1 && entity_id.areValuesEqual(i, i + 1))
            i++;
        i++;
        var id = entity_id.value(start);
        var compId = _mol_data_db__WEBPACK_IMPORTED_MODULE_1__["Column"].window(mon_id, start, i);
        var seqId = _mol_data_db__WEBPACK_IMPORTED_MODULE_1__["Column"].window(num, start, i);
        var entityKey = entities.getEntityIndex(id);
        byEntityKey[entityKey] = {
            entityId: id,
            sequence: _mol_model_sequence__WEBPACK_IMPORTED_MODULE_2__["Sequence"].ofResidueNames(compId, seqId)
        };
        sequences.push(byEntityKey[entityKey]);
    }
    return { byEntityKey: byEntityKey, sequences: sequences };
}
//# sourceMappingURL=sequence.js.map

/***/ }),

/***/ "./lib/mol-model-formats/structure/basic/sort.js":
/*!*******************************************************!*\
  !*** ./lib/mol-model-formats/structure/basic/sort.js ***!
  \*******************************************************/
/*! exports provided: sortAtomSite */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "sortAtomSite", function() { return sortAtomSite; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _mol_data_util__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../../mol-data/util */ "./lib/mol-data/util.js");
/* harmony import */ var _mol_data_db__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../../mol-data/db */ "./lib/mol-data/db.js");
/* harmony import */ var _mol_util_array__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../../mol-util/array */ "./lib/mol-util/array.js");
/**
 * Copyright (c) 2018 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author David Sehnal <david.sehnal@gmail.com>
 */




function sortAtomSite(ctx, atom_site, start, end) {
    return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"])(this, void 0, void 0, function () {
        var indices, label_entity_id, label_asym_id, label_seq_id, entityBuckets, ei, _eI, chainBuckets, cI, _cI, aI;
        return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__generator"])(this, function (_a) {
            switch (_a.label) {
                case 0:
                    indices = Object(_mol_data_util__WEBPACK_IMPORTED_MODULE_1__["createRangeArray"])(start, end - 1);
                    label_entity_id = atom_site.label_entity_id, label_asym_id = atom_site.label_asym_id, label_seq_id = atom_site.label_seq_id;
                    entityBuckets = Object(_mol_data_util__WEBPACK_IMPORTED_MODULE_1__["makeBuckets"])(indices, label_entity_id.value);
                    if (!ctx.shouldUpdate) return [3 /*break*/, 2];
                    return [4 /*yield*/, ctx.update()];
                case 1:
                    _a.sent();
                    _a.label = 2;
                case 2:
                    ei = 0, _eI = entityBuckets.length - 1;
                    _a.label = 3;
                case 3:
                    if (!(ei < _eI)) return [3 /*break*/, 10];
                    chainBuckets = Object(_mol_data_util__WEBPACK_IMPORTED_MODULE_1__["makeBuckets"])(indices, label_asym_id.value, { start: entityBuckets[ei], end: entityBuckets[ei + 1] });
                    cI = 0, _cI = chainBuckets.length - 1;
                    _a.label = 4;
                case 4:
                    if (!(cI < _cI)) return [3 /*break*/, 7];
                    aI = chainBuckets[cI];
                    // are we in HETATM territory?
                    if (label_seq_id.valueKind(aI) !== 0 /* Present */)
                        return [3 /*break*/, 6];
                    Object(_mol_data_util__WEBPACK_IMPORTED_MODULE_1__["makeBuckets"])(indices, label_seq_id.value, { sort: true, start: aI, end: chainBuckets[cI + 1] });
                    if (!ctx.shouldUpdate) return [3 /*break*/, 6];
                    return [4 /*yield*/, ctx.update()];
                case 5:
                    _a.sent();
                    _a.label = 6;
                case 6:
                    cI++;
                    return [3 /*break*/, 4];
                case 7:
                    if (!ctx.shouldUpdate) return [3 /*break*/, 9];
                    return [4 /*yield*/, ctx.update()];
                case 8:
                    _a.sent();
                    _a.label = 9;
                case 9:
                    ei++;
                    return [3 /*break*/, 3];
                case 10:
                    if (Object(_mol_util_array__WEBPACK_IMPORTED_MODULE_3__["arrayIsIdentity"])(indices) && indices.length === atom_site._rowCount) {
                        return [2 /*return*/, { atom_site: atom_site, sourceIndex: _mol_data_db__WEBPACK_IMPORTED_MODULE_2__["Column"].ofIntArray(indices) }];
                    }
                    return [2 /*return*/, {
                            atom_site: _mol_data_db__WEBPACK_IMPORTED_MODULE_2__["Table"].view(atom_site, atom_site._schema, indices),
                            sourceIndex: _mol_data_db__WEBPACK_IMPORTED_MODULE_2__["Column"].ofIntArray(indices)
                        }];
            }
        });
    });
}
//# sourceMappingURL=sort.js.map

/***/ }),

/***/ "./lib/mol-model-formats/structure/basic/util.js":
/*!*******************************************************!*\
  !*** ./lib/mol-model-formats/structure/basic/util.js ***!
  \*******************************************************/
/*! exports provided: getModelGroupName */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getModelGroupName", function() { return getModelGroupName; });
/* harmony import */ var _mol_data_db__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../../mol-data/db */ "./lib/mol-data/db.js");
/**
 * Copyright (c) 2017-2020 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author David Sehnal <david.sehnal@gmail.com>
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */

function getModelGroupName(model_id, data) {
    var ihm_model_group = data.ihm_model_group, ihm_model_group_link = data.ihm_model_group_link;
    var link = _mol_data_db__WEBPACK_IMPORTED_MODULE_0__["Table"].pickRow(ihm_model_group_link, function (i) { return ihm_model_group_link.model_id.value(i) === model_id; });
    if (link) {
        var group = _mol_data_db__WEBPACK_IMPORTED_MODULE_0__["Table"].pickRow(ihm_model_group, function (i) { return ihm_model_group.id.value(i) === link.group_id; });
        if (group)
            return group.name;
    }
    return '';
}
//# sourceMappingURL=util.js.map

/***/ }),

/***/ "./lib/mol-model-formats/structure/cif-core.js":
/*!*****************************************************!*\
  !*** ./lib/mol-model-formats/structure/cif-core.js ***!
  \*****************************************************/
/*! exports provided: CifCoreFormat, trajectoryFromCifCore */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CifCoreFormat", function() { return CifCoreFormat; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "trajectoryFromCifCore", function() { return trajectoryFromCifCore; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _mol_data_db__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../mol-data/db */ "./lib/mol-data/db.js");
/* harmony import */ var _mol_task__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../mol-task */ "./lib/mol-task/index.js");
/* harmony import */ var _basic_parser__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./basic/parser */ "./lib/mol-model-formats/structure/basic/parser.js");
/* harmony import */ var _basic_schema__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./basic/schema */ "./lib/mol-model-formats/structure/basic/schema.js");
/* harmony import */ var _common_component__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./common/component */ "./lib/mol-model-formats/structure/common/component.js");
/* harmony import */ var _common_entity__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ./common/entity */ "./lib/mol-model-formats/structure/common/entity.js");
/* harmony import */ var _mol_io_reader_cif__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../../mol-io/reader/cif */ "./lib/mol-io/reader/cif.js");
/* harmony import */ var _mol_math_geometry__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ../../mol-math/geometry */ "./lib/mol-math/geometry.js");
/* harmony import */ var _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ../../mol-math/linear-algebra */ "./lib/mol-math/linear-algebra.js");
/* harmony import */ var _property_symmetry__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ./property/symmetry */ "./lib/mol-model-formats/structure/property/symmetry.js");
/* harmony import */ var _property_bonds_index_pair__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ./property/bonds/index-pair */ "./lib/mol-model-formats/structure/property/bonds/index-pair.js");
/* harmony import */ var _property_anisotropic__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! ./property/anisotropic */ "./lib/mol-model-formats/structure/property/anisotropic.js");
/* harmony import */ var _util__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! ./util */ "./lib/mol-model-formats/structure/util.js");
/* harmony import */ var _mol_data_util__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! ../../mol-data/util */ "./lib/mol-data/util.js");
/**
 * Copyright (c) 2020 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */















function getSpacegroupNameOrNumber(space_group) {
    var groupNumber = space_group.IT_number.value(0);
    var groupName = space_group['name_H-M_full'].value(0);
    if (!space_group.IT_number.isDefined)
        return groupName;
    if (!space_group['name_H-M_full'].isDefined)
        return groupNumber;
    return groupNumber;
}
function getSymmetry(db) {
    var cell = db.cell, space_group = db.space_group;
    var nameOrNumber = getSpacegroupNameOrNumber(space_group);
    var spaceCell = _mol_math_geometry__WEBPACK_IMPORTED_MODULE_8__["SpacegroupCell"].create(nameOrNumber, _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_9__["Vec3"].create(cell.length_a.value(0), cell.length_b.value(0), cell.length_c.value(0)), _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_9__["Vec3"].scale(Object(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_9__["Vec3"])(), _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_9__["Vec3"].create(cell.angle_alpha.value(0), cell.angle_beta.value(0), cell.angle_gamma.value(0)), Math.PI / 180));
    return {
        spacegroup: _mol_math_geometry__WEBPACK_IMPORTED_MODULE_8__["Spacegroup"].create(spaceCell),
        assemblies: [],
        isNonStandardCrystalFrame: false,
        ncsOperators: []
    };
}
function getModels(db, format, ctx) {
    var _a;
    return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"])(this, void 0, void 0, function () {
        var atomCount, MOL, A, seq_id, symmetry, m, _b, fract_x, fract_y, fract_z, x, y, z, v, i, _c, type_symbol, label, typeSymbol, formalCharge, element_symbol, formal_charge, i, ts, n, element_symbol, i, atom_site, name, entityBuilder, componentBuilder, basics, models, first, bondCount, labelIndexMap, label_1, i, il, bond_type, indexA, indexB, order, dist, flag, included, j, _d, atom_site_label_1, atom_site_label_2, valence, distance, i, iA, iB, id, t;
        return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__generator"])(this, function (_e) {
            switch (_e.label) {
                case 0:
                    atomCount = db.atom_site._rowCount;
                    MOL = _mol_data_db__WEBPACK_IMPORTED_MODULE_1__["Column"].ofConst('MOL', atomCount, _mol_data_db__WEBPACK_IMPORTED_MODULE_1__["Column"].Schema.str);
                    A = _mol_data_db__WEBPACK_IMPORTED_MODULE_1__["Column"].ofConst('A', atomCount, _mol_data_db__WEBPACK_IMPORTED_MODULE_1__["Column"].Schema.str);
                    seq_id = _mol_data_db__WEBPACK_IMPORTED_MODULE_1__["Column"].ofConst(1, atomCount, _mol_data_db__WEBPACK_IMPORTED_MODULE_1__["Column"].Schema.int);
                    symmetry = getSymmetry(db);
                    m = symmetry.spacegroup.cell.fromFractional;
                    _b = db.atom_site, fract_x = _b.fract_x, fract_y = _b.fract_y, fract_z = _b.fract_z;
                    x = new Float32Array(atomCount);
                    y = new Float32Array(atomCount);
                    z = new Float32Array(atomCount);
                    v = Object(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_9__["Vec3"])();
                    for (i = 0; i < atomCount; ++i) {
                        _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_9__["Vec3"].set(v, fract_x.value(i), fract_y.value(i), fract_z.value(i));
                        _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_9__["Vec3"].transformMat4(v, v, m);
                        x[i] = v[0], y[i] = v[1], z[i] = v[2];
                    }
                    _c = db.atom_site, type_symbol = _c.type_symbol, label = _c.label;
                    if (type_symbol.isDefined) {
                        element_symbol = new Array(atomCount);
                        formal_charge = new Int8Array(atomCount);
                        for (i = 0; i < atomCount; ++i) {
                            ts = type_symbol.value(i);
                            n = ts.length;
                            if (ts[n - 1] === '+') {
                                element_symbol[i] = ts.substring(0, n - 2);
                                formal_charge[i] = parseInt(ts[n - 2]);
                            }
                            else if (ts[n - 2] === '+') {
                                element_symbol[i] = ts.substring(0, n - 2);
                                formal_charge[i] = parseInt(ts[n - 1]);
                            }
                            else if (ts[n - 1] === '-') {
                                element_symbol[i] = ts.substring(0, n - 2);
                                formal_charge[i] = -parseInt(ts[n - 2]);
                            }
                            else if (ts[n - 2] === '-') {
                                element_symbol[i] = ts.substring(0, n - 2);
                                formal_charge[i] = -parseInt(ts[n - 1]);
                            }
                            else {
                                element_symbol[i] = ts;
                                formal_charge[i] = 0;
                            }
                        }
                        typeSymbol = _mol_data_db__WEBPACK_IMPORTED_MODULE_1__["Column"].ofStringArray(element_symbol);
                        formalCharge = _mol_data_db__WEBPACK_IMPORTED_MODULE_1__["Column"].ofIntArray(formal_charge);
                    }
                    else {
                        element_symbol = new Array(atomCount);
                        for (i = 0; i < atomCount; ++i) {
                            // TODO can take as is if type_symbol not given?
                            element_symbol[i] = Object(_util__WEBPACK_IMPORTED_MODULE_13__["guessElementSymbolString"])(label.value(i));
                        }
                        typeSymbol = _mol_data_db__WEBPACK_IMPORTED_MODULE_1__["Column"].ofStringArray(element_symbol);
                        formalCharge = _mol_data_db__WEBPACK_IMPORTED_MODULE_1__["Column"].Undefined(atomCount, _mol_data_db__WEBPACK_IMPORTED_MODULE_1__["Column"].Schema.int);
                    }
                    atom_site = _mol_data_db__WEBPACK_IMPORTED_MODULE_1__["Table"].ofPartialColumns(_basic_schema__WEBPACK_IMPORTED_MODULE_4__["BasicSchema"].atom_site, {
                        auth_asym_id: A,
                        auth_atom_id: label,
                        auth_comp_id: MOL,
                        auth_seq_id: seq_id,
                        Cartn_x: _mol_data_db__WEBPACK_IMPORTED_MODULE_1__["Column"].ofFloatArray(x),
                        Cartn_y: _mol_data_db__WEBPACK_IMPORTED_MODULE_1__["Column"].ofFloatArray(y),
                        Cartn_z: _mol_data_db__WEBPACK_IMPORTED_MODULE_1__["Column"].ofFloatArray(z),
                        id: _mol_data_db__WEBPACK_IMPORTED_MODULE_1__["Column"].range(0, atomCount - 1),
                        label_asym_id: A,
                        label_atom_id: label,
                        label_comp_id: MOL,
                        label_seq_id: seq_id,
                        label_entity_id: _mol_data_db__WEBPACK_IMPORTED_MODULE_1__["Column"].ofConst('1', atomCount, _mol_data_db__WEBPACK_IMPORTED_MODULE_1__["Column"].Schema.str),
                        occupancy: db.atom_site.occupancy.isDefined
                            ? db.atom_site.occupancy
                            : _mol_data_db__WEBPACK_IMPORTED_MODULE_1__["Column"].ofConst(1, atomCount, _mol_data_db__WEBPACK_IMPORTED_MODULE_1__["Column"].Schema.float),
                        type_symbol: typeSymbol,
                        pdbx_formal_charge: formalCharge,
                        pdbx_PDB_model_num: _mol_data_db__WEBPACK_IMPORTED_MODULE_1__["Column"].ofConst(1, atomCount, _mol_data_db__WEBPACK_IMPORTED_MODULE_1__["Column"].Schema.int),
                        B_iso_or_equiv: db.atom_site.U_iso_or_equiv,
                    }, atomCount);
                    name = (db.chemical.name_common.value(0) ||
                        db.chemical.name_systematic.value(0) ||
                        db.chemical_formula.sum.value(0));
                    entityBuilder = new _common_entity__WEBPACK_IMPORTED_MODULE_6__["EntityBuilder"]();
                    entityBuilder.setNames([['MOL', name || 'Unknown Entity']]);
                    entityBuilder.getEntityId('MOL', 0 /* Unknown */, 'A');
                    componentBuilder = new _common_component__WEBPACK_IMPORTED_MODULE_5__["ComponentBuilder"](seq_id, db.atom_site.type_symbol);
                    componentBuilder.setNames([['MOL', name || 'Unknown Molecule']]);
                    componentBuilder.add('MOL', 0);
                    basics = Object(_basic_schema__WEBPACK_IMPORTED_MODULE_4__["createBasic"])({
                        entity: entityBuilder.getEntityTable(),
                        chem_comp: componentBuilder.getChemCompTable(),
                        atom_site: atom_site
                    });
                    return [4 /*yield*/, Object(_basic_parser__WEBPACK_IMPORTED_MODULE_3__["createModels"])(basics, format, ctx)];
                case 1:
                    models = _e.sent();
                    if (models.frameCount > 0) {
                        first = models.representative;
                        _property_symmetry__WEBPACK_IMPORTED_MODULE_10__["ModelSymmetry"].Provider.set(first, symmetry);
                        bondCount = db.geom_bond._rowCount;
                        if (bondCount > 0) {
                            labelIndexMap = {};
                            label_1 = db.atom_site.label;
                            for (i = 0, il = label_1.rowCount; i < il; ++i) {
                                labelIndexMap[label_1.value(i)] = i;
                            }
                            bond_type = (_a = format.data.frame.categories.ccdc_geom_bond_type) === null || _a === void 0 ? void 0 : _a.getField('');
                            indexA = [];
                            indexB = [];
                            order = [];
                            dist = [];
                            flag = [];
                            included = new Set();
                            j = 0;
                            _d = db.geom_bond, atom_site_label_1 = _d.atom_site_label_1, atom_site_label_2 = _d.atom_site_label_2, valence = _d.valence, distance = _d.distance;
                            for (i = 0; i < bondCount; ++i) {
                                iA = labelIndexMap[atom_site_label_1.value(i)];
                                iB = labelIndexMap[atom_site_label_2.value(i)];
                                id = iA < iB ? Object(_mol_data_util__WEBPACK_IMPORTED_MODULE_14__["cantorPairing"])(iA, iB) : Object(_mol_data_util__WEBPACK_IMPORTED_MODULE_14__["cantorPairing"])(iB, iA);
                                if (included.has(id))
                                    continue;
                                included.add(id);
                                indexA[j] = iA;
                                indexB[j] = iB;
                                dist[j] = distance.value(i) || -1;
                                if (bond_type) {
                                    t = bond_type.str(i);
                                    if (t === 'D') {
                                        order[j] = 2;
                                        flag[j] = 1 /* Covalent */;
                                    }
                                    else if (t === 'A') {
                                        order[j] = 1;
                                        flag[j] = 1 /* Covalent */ | 16 /* Aromatic */;
                                    }
                                    else if (t === 'S') {
                                        order[j] = 1;
                                        flag[j] = 1 /* Covalent */;
                                    }
                                    else {
                                        order[j] = 1;
                                        flag[j] = 1 /* Covalent */;
                                    }
                                }
                                else {
                                    flag[j] = 1 /* Covalent */;
                                    // TODO derive order from bond length if undefined
                                    order[j] = valence.isDefined ? valence.value(i) : 1;
                                }
                                j += 1;
                            }
                            _property_bonds_index_pair__WEBPACK_IMPORTED_MODULE_11__["IndexPairBonds"].Provider.set(first, _property_bonds_index_pair__WEBPACK_IMPORTED_MODULE_11__["IndexPairBonds"].fromData({ pairs: {
                                    indexA: _mol_data_db__WEBPACK_IMPORTED_MODULE_1__["Column"].ofIntArray(indexA),
                                    indexB: _mol_data_db__WEBPACK_IMPORTED_MODULE_1__["Column"].ofIntArray(indexB),
                                    order: _mol_data_db__WEBPACK_IMPORTED_MODULE_1__["Column"].ofIntArray(order),
                                    distance: _mol_data_db__WEBPACK_IMPORTED_MODULE_1__["Column"].ofFloatArray(dist),
                                    flag: _mol_data_db__WEBPACK_IMPORTED_MODULE_1__["Column"].ofIntArray(flag)
                                }, count: atomCount }));
                        }
                    }
                    return [2 /*return*/, models];
            }
        });
    });
}
function atomSiteAnisotropFromCifCore(model) {
    if (!CifCoreFormat.is(model.sourceData))
        return;
    var _a = model.sourceData.data.db, atom_site = _a.atom_site, atom_site_aniso = _a.atom_site_aniso;
    var data = _mol_data_db__WEBPACK_IMPORTED_MODULE_1__["Table"].ofPartialColumns(_property_anisotropic__WEBPACK_IMPORTED_MODULE_12__["AtomSiteAnisotrop"].Schema, {
        U: atom_site_aniso.U,
        U_esd: atom_site_aniso.U_su
    }, atom_site_aniso._rowCount);
    var elementToAnsiotrop = _property_anisotropic__WEBPACK_IMPORTED_MODULE_12__["AtomSiteAnisotrop"].getElementToAnsiotropFromLabel(atom_site.label, atom_site_aniso.label);
    return { data: data, elementToAnsiotrop: elementToAnsiotrop };
}
function atomSiteAnisotropApplicableCifCore(model) {
    if (!CifCoreFormat.is(model.sourceData))
        return false;
    return model.sourceData.data.db.atom_site_aniso.U.isDefined;
}
_property_anisotropic__WEBPACK_IMPORTED_MODULE_12__["AtomSiteAnisotrop"].Provider.formatRegistry.add('cifCore', atomSiteAnisotropFromCifCore, atomSiteAnisotropApplicableCifCore);
//

var CifCoreFormat;
(function (CifCoreFormat) {
    function is(x) {
        return (x === null || x === void 0 ? void 0 : x.kind) === 'cifCore';
    }
    CifCoreFormat.is = is;
    function fromFrame(frame, db) {
        if (!db)
            db = _mol_io_reader_cif__WEBPACK_IMPORTED_MODULE_7__["CIF"].schema.cifCore(frame);
        var name = (db.database_code.depnum_ccdc_archive.value(0) ||
            db.database_code.depnum_ccdc_fiz.value(0) ||
            db.database_code.ICSD.value(0) ||
            db.database_code.MDF.value(0) ||
            db.database_code.NBS.value(0) ||
            db.database_code.CSD.value(0) ||
            db.database_code.COD.value(0) ||
            db._name);
        return { kind: 'cifCore', name: name, data: { db: db, frame: frame } };
    }
    CifCoreFormat.fromFrame = fromFrame;
})(CifCoreFormat || (CifCoreFormat = {}));
function trajectoryFromCifCore(frame) {
    var format = CifCoreFormat.fromFrame(frame);
    return _mol_task__WEBPACK_IMPORTED_MODULE_2__["Task"].create('Parse CIF Core', function (ctx) { return getModels(format.data.db, format, ctx); });
}
//# sourceMappingURL=cif-core.js.map

/***/ }),

/***/ "./lib/mol-model-formats/structure/common/component.js":
/*!*************************************************************!*\
  !*** ./lib/mol-model-formats/structure/common/component.js ***!
  \*************************************************************/
/*! exports provided: ComponentBuilder */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ComponentBuilder", function() { return ComponentBuilder; });
/* harmony import */ var _mol_data_db__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../../mol-data/db */ "./lib/mol-data/db.js");
/* harmony import */ var _mol_model_structure_model_types__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../../mol-model/structure/model/types */ "./lib/mol-model/structure/model/types.js");
/* harmony import */ var _mol_util_set__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../../mol-util/set */ "./lib/mol-util/set.js");
/* harmony import */ var _basic_schema__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../basic/schema */ "./lib/mol-model-formats/structure/basic/schema.js");
/**
 * Copyright (c) 2019-2020 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */




var ProteinAtomIdsList = [
    new Set(['CA']),
    new Set(['C']),
    new Set(['N'])
];
var RnaAtomIdsList = [
    new Set(['P', 'O3\'', 'O3*']),
    new Set(['C4\'', 'C4*']),
    new Set(['O2\'', 'O2*', 'F2\'', 'F2*'])
];
var DnaAtomIdsList = [
    new Set(['P', 'O3\'', 'O3*']),
    new Set(['C3\'', 'C3*']),
    new Set(['O2\'', 'O2*', 'F2\'', 'F2*'])
];
var StandardComponents = (function () {
    var map = new Map();
    var components = [
        { id: 'HIS', name: 'HISTIDINE', type: 'L-peptide linking' },
        { id: 'ARG', name: 'ARGININE', type: 'L-peptide linking' },
        { id: 'LYS', name: 'LYSINE', type: 'L-peptide linking' },
        { id: 'ILE', name: 'ISOLEUCINE', type: 'L-peptide linking' },
        { id: 'PHE', name: 'PHENYLALANINE', type: 'L-peptide linking' },
        { id: 'LEU', name: 'LEUCINE', type: 'L-peptide linking' },
        { id: 'TRP', name: 'TRYPTOPHAN', type: 'L-peptide linking' },
        { id: 'ALA', name: 'ALANINE', type: 'L-peptide linking' },
        { id: 'MET', name: 'METHIONINE', type: 'L-peptide linking' },
        { id: 'CYS', name: 'CYSTEINE', type: 'L-peptide linking' },
        { id: 'ASN', name: 'ASPARAGINE', type: 'L-peptide linking' },
        { id: 'VAL', name: 'VALINE', type: 'L-peptide linking' },
        { id: 'GLY', name: 'GLYCINE', type: 'peptide linking' },
        { id: 'SER', name: 'SERINE', type: 'L-peptide linking' },
        { id: 'GLN', name: 'GLUTAMINE', type: 'L-peptide linking' },
        { id: 'TYR', name: 'TYROSINE', type: 'L-peptide linking' },
        { id: 'ASP', name: 'ASPARTIC ACID', type: 'L-peptide linking' },
        { id: 'GLU', name: 'GLUTAMIC ACID', type: 'L-peptide linking' },
        { id: 'THR', name: 'THREONINE', type: 'L-peptide linking' },
        { id: 'SEC', name: 'SELENOCYSTEINE', type: 'L-peptide linking' },
        { id: 'PYL', name: 'PYRROLYSINE', type: 'L-peptide linking' },
        { id: 'A', name: 'ADENOSINE-5\'-MONOPHOSPHATE', type: 'RNA linking' },
        { id: 'C', name: 'CYTIDINE-5\'-MONOPHOSPHATE', type: 'RNA linking' },
        { id: 'T', name: 'THYMIDINE-5\'-MONOPHOSPHATE', type: 'RNA linking' },
        { id: 'G', name: 'GUANOSINE-5\'-MONOPHOSPHATE', type: 'RNA linking' },
        { id: 'I', name: 'INOSINIC ACID', type: 'RNA linking' },
        { id: 'U', name: 'URIDINE-5\'-MONOPHOSPHATE', type: 'RNA linking' },
        { id: 'DA', name: '2\'-DEOXYADENOSINE-5\'-MONOPHOSPHATE', type: 'DNA linking' },
        { id: 'DC', name: '2\'-DEOXYCYTIDINE-5\'-MONOPHOSPHATE', type: 'DNA linking' },
        { id: 'DT', name: 'THYMIDINE-5\'-MONOPHOSPHATE', type: 'DNA linking' },
        { id: 'DG', name: '2\'-DEOXYGUANOSINE-5\'-MONOPHOSPHATE', type: 'DNA linking' },
        { id: 'DI', name: '2\'-DEOXYINOSINE-5\'-MONOPHOSPHATE', type: 'DNA linking' },
        { id: 'DU', name: '2\'-DEOXYURIDINE-5\'-MONOPHOSPHATE', type: 'DNA linking' },
    ];
    components.forEach(function (c) { return map.set(c.id, c); });
    return map;
})();
var CharmmIonComponents = (function () {
    var map = new Map();
    var components = [
        { id: 'ZN2', name: 'ZINC ION', type: 'Ion' },
        { id: 'SOD', name: 'SODIUM ION', type: 'Ion' },
        { id: 'CES', name: 'CESIUM ION', type: 'Ion' },
        { id: 'CLA', name: 'CHLORIDE ION', type: 'Ion' },
        { id: 'CAL', name: 'CALCIUM ION', type: 'Ion' },
        { id: 'POT', name: 'POTASSIUM ION', type: 'Ion' },
    ];
    components.forEach(function (c) { return map.set(c.id, c); });
    return map;
})();
var ComponentBuilder = /** @class */ (function () {
    function ComponentBuilder(seqId, atomId) {
        this.seqId = seqId;
        this.atomId = atomId;
        this.namesMap = new Map();
        this.comps = new Map();
        this.ids = [];
        this.names = [];
        this.types = [];
        this.mon_nstd_flags = [];
    }
    ComponentBuilder.prototype.set = function (c) {
        this.comps.set(c.id, c);
        this.ids.push(c.id);
        this.names.push(c.name);
        this.types.push(c.type);
        this.mon_nstd_flags.push(_mol_model_structure_model_types__WEBPACK_IMPORTED_MODULE_1__["PolymerNames"].has(c.id) ? 'y' : 'n');
    };
    ComponentBuilder.prototype.getAtomIds = function (index) {
        var atomIds = new Set();
        var prevSeqId = this.seqId.value(index);
        while (index < this.seqId.rowCount) {
            var seqId = this.seqId.value(index);
            if (seqId !== prevSeqId)
                break;
            atomIds.add(this.atomId.value(index));
            prevSeqId - seqId;
            index += 1;
        }
        return atomIds;
    };
    ComponentBuilder.prototype.hasAtomIds = function (atomIds, atomIdsList) {
        for (var i = 0, il = atomIdsList.length; i < il; ++i) {
            if (!_mol_util_set__WEBPACK_IMPORTED_MODULE_2__["SetUtils"].areIntersecting(atomIds, atomIdsList[i])) {
                return false;
            }
        }
        return true;
    };
    ComponentBuilder.prototype.getType = function (atomIds) {
        if (this.hasAtomIds(atomIds, ProteinAtomIdsList)) {
            return 'peptide linking';
        }
        else if (this.hasAtomIds(atomIds, RnaAtomIdsList)) {
            return 'RNA linking';
        }
        else if (this.hasAtomIds(atomIds, DnaAtomIdsList)) {
            return 'DNA linking';
        }
        else {
            return 'other';
        }
    };
    ComponentBuilder.prototype.has = function (compId) { return this.comps.has(compId); };
    ComponentBuilder.prototype.get = function (compId) { return this.comps.get(compId); };
    ComponentBuilder.prototype.add = function (compId, index) {
        if (!this.has(compId)) {
            if (StandardComponents.has(compId)) {
                this.set(StandardComponents.get(compId));
            }
            else if (_mol_model_structure_model_types__WEBPACK_IMPORTED_MODULE_1__["WaterNames"].has(compId)) {
                this.set({ id: compId, name: 'WATER', type: 'non-polymer' });
            }
            else {
                var atomIds = this.getAtomIds(index);
                if (CharmmIonComponents.has(compId) && atomIds.size === 1) {
                    this.set(CharmmIonComponents.get(compId));
                }
                else {
                    var type = this.getType(atomIds);
                    this.set({ id: compId, name: this.namesMap.get(compId) || compId, type: type });
                }
            }
        }
        return this.get(compId);
    };
    ComponentBuilder.prototype.getChemCompTable = function () {
        return _mol_data_db__WEBPACK_IMPORTED_MODULE_0__["Table"].ofPartialColumns(_basic_schema__WEBPACK_IMPORTED_MODULE_3__["BasicSchema"].chem_comp, {
            id: _mol_data_db__WEBPACK_IMPORTED_MODULE_0__["Column"].ofStringArray(this.ids),
            name: _mol_data_db__WEBPACK_IMPORTED_MODULE_0__["Column"].ofStringArray(this.names),
            type: _mol_data_db__WEBPACK_IMPORTED_MODULE_0__["Column"].ofStringAliasArray(this.types),
            mon_nstd_flag: _mol_data_db__WEBPACK_IMPORTED_MODULE_0__["Column"].ofStringAliasArray(this.mon_nstd_flags),
        }, this.ids.length);
    };
    ComponentBuilder.prototype.setNames = function (names) {
        var _this = this;
        names.forEach(function (n) { return _this.namesMap.set(n[0], n[1]); });
    };
    return ComponentBuilder;
}());

//# sourceMappingURL=component.js.map

/***/ }),

/***/ "./lib/mol-model-formats/structure/common/entity.js":
/*!**********************************************************!*\
  !*** ./lib/mol-model-formats/structure/common/entity.js ***!
  \**********************************************************/
/*! exports provided: EntityBuilder */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "EntityBuilder", function() { return EntityBuilder; });
/* harmony import */ var _mol_model_structure_model_types__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../../mol-model/structure/model/types */ "./lib/mol-model/structure/model/types.js");
/* harmony import */ var _mol_data_db__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../../mol-data/db */ "./lib/mol-data/db.js");
/* harmony import */ var _basic_schema__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../basic/schema */ "./lib/mol-model-formats/structure/basic/schema.js");
/**
 * Copyright (c) 2019-2020 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */



var EntityBuilder = /** @class */ (function () {
    function EntityBuilder() {
        this.count = 0;
        this.ids = [];
        this.types = [];
        this.descriptions = [];
        this.compoundsMap = new Map();
        this.namesMap = new Map();
        this.heteroMap = new Map();
        this.chainMap = new Map();
    }
    EntityBuilder.prototype.set = function (type, description) {
        this.count += 1;
        this.ids.push("" + this.count);
        this.types.push(type);
        this.descriptions.push([description]);
    };
    EntityBuilder.prototype.getEntityId = function (compId, moleculeType, chainId, options) {
        if (moleculeType === 2 /* Water */) {
            if (this.waterId === undefined) {
                this.set('water', (options === null || options === void 0 ? void 0 : options.customName) || 'Water');
                this.waterId = "" + this.count;
            }
            return this.waterId;
        }
        else if (Object(_mol_model_structure_model_types__WEBPACK_IMPORTED_MODULE_0__["isPolymer"])(moleculeType)) {
            if (this.compoundsMap.has(chainId)) {
                return this.compoundsMap.get(chainId);
            }
            else {
                if (!this.chainMap.has(chainId)) {
                    this.set('polymer', (options === null || options === void 0 ? void 0 : options.customName) || "Polymer " + (this.chainMap.size + 1));
                    this.chainMap.set(chainId, "" + this.count);
                }
                return this.chainMap.get(chainId);
            }
        }
        else {
            if (!this.heteroMap.has(compId)) {
                this.set('non-polymer', (options === null || options === void 0 ? void 0 : options.customName) || this.namesMap.get(compId) || compId);
                this.heteroMap.set(compId, "" + this.count);
            }
            return this.heteroMap.get(compId);
        }
    };
    EntityBuilder.prototype.getEntityTable = function () {
        return _mol_data_db__WEBPACK_IMPORTED_MODULE_1__["Table"].ofPartialColumns(_basic_schema__WEBPACK_IMPORTED_MODULE_2__["BasicSchema"].entity, {
            id: _mol_data_db__WEBPACK_IMPORTED_MODULE_1__["Column"].ofStringArray(this.ids),
            type: _mol_data_db__WEBPACK_IMPORTED_MODULE_1__["Column"].ofStringAliasArray(this.types),
            pdbx_description: _mol_data_db__WEBPACK_IMPORTED_MODULE_1__["Column"].ofStringListArray(this.descriptions),
        }, this.count);
    };
    EntityBuilder.prototype.setCompounds = function (compounds) {
        for (var i = 0, il = compounds.length; i < il; ++i) {
            var _a = compounds[i], chains = _a.chains, description = _a.description;
            this.set('polymer', description);
            for (var j = 0, jl = chains.length; j < jl; ++j) {
                this.compoundsMap.set(chains[j], "" + this.count);
            }
        }
    };
    EntityBuilder.prototype.setNames = function (names) {
        var _this = this;
        names.forEach(function (n) { return _this.namesMap.set(n[0], n[1]); });
    };
    return EntityBuilder;
}());

//# sourceMappingURL=entity.js.map

/***/ }),

/***/ "./lib/mol-model-formats/structure/common/property.js":
/*!************************************************************!*\
  !*** ./lib/mol-model-formats/structure/common/property.js ***!
  \************************************************************/
/*! exports provided: FormatPropertyProvider */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FormatPropertyProvider", function() { return FormatPropertyProvider; });
/**
 * Copyright (c) 2020 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */
var FormatRegistry = /** @class */ (function () {
    function FormatRegistry() {
        this.map = new Map();
        this.applicable = new Map();
    }
    FormatRegistry.prototype.add = function (kind, obtain, applicable) {
        this.map.set(kind, obtain);
        if (applicable)
            this.applicable.set(kind, applicable);
    };
    FormatRegistry.prototype.remove = function (kind) {
        this.map.delete(kind);
        this.applicable.delete(kind);
    };
    FormatRegistry.prototype.get = function (kind) {
        return this.map.get(kind);
    };
    FormatRegistry.prototype.isApplicable = function (model) {
        var isApplicable = this.applicable.get(model.sourceData.kind);
        return isApplicable ? isApplicable(model) : true;
    };
    return FormatRegistry;
}());

var FormatPropertyProvider;
(function (FormatPropertyProvider) {
    function create(descriptor) {
        var name = descriptor.name;
        var formatRegistry = new FormatRegistry();
        return {
            descriptor: descriptor,
            formatRegistry: formatRegistry,
            isApplicable: function (model) {
                return formatRegistry.isApplicable(model);
            },
            get: function (model) {
                if (model._staticPropertyData[name])
                    return model._staticPropertyData[name];
                if (model.customProperties.has(descriptor))
                    return;
                var obtain = formatRegistry.get(model.sourceData.kind);
                if (!obtain)
                    return;
                model._staticPropertyData[name] = obtain(model);
                model.customProperties.add(descriptor);
                return model._staticPropertyData[name];
            },
            set: function (model, value) {
                model._staticPropertyData[name] = value;
            },
            delete: function (model) {
                delete model._staticPropertyData[name];
            }
        };
    }
    FormatPropertyProvider.create = create;
})(FormatPropertyProvider || (FormatPropertyProvider = {}));
//# sourceMappingURL=property.js.map

/***/ }),

/***/ "./lib/mol-model-formats/structure/common/util.js":
/*!********************************************************!*\
  !*** ./lib/mol-model-formats/structure/common/util.js ***!
  \********************************************************/
/*! exports provided: getChainId */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getChainId", function() { return getChainId; });
/* harmony import */ var _mol_util_memoize__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../../mol-util/memoize */ "./lib/mol-util/memoize.js");
/**
 * Copyright (c) 2019 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */

var ChainIdAlphabet = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
function _getChainId(index) {
    var n = ChainIdAlphabet.length;
    var j = index;
    var k = 0;
    var chainId = ChainIdAlphabet[j % n];
    while (j >= n) {
        j = Math.floor(j / n);
        chainId += ChainIdAlphabet[j % n];
        k += 1;
    }
    if (k >= 5) {
        console.warn('getChainId overflow');
    }
    return chainId;
}
var getChainId = Object(_mol_util_memoize__WEBPACK_IMPORTED_MODULE_0__["memoize1"])(_getChainId);
//# sourceMappingURL=util.js.map

/***/ }),

/***/ "./lib/mol-model-formats/structure/cube.js":
/*!*************************************************!*\
  !*** ./lib/mol-model-formats/structure/cube.js ***!
  \*************************************************/
/*! exports provided: trajectoryFromCube */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "trajectoryFromCube", function() { return trajectoryFromCube; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _mol_data_db__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../mol-data/db */ "./lib/mol-data/db.js");
/* harmony import */ var _mol_model_structure_model_types__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../mol-model/structure/model/types */ "./lib/mol-model/structure/model/types.js");
/* harmony import */ var _mol_task__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../mol-task */ "./lib/mol-task/index.js");
/* harmony import */ var _basic_parser__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./basic/parser */ "./lib/mol-model-formats/structure/basic/parser.js");
/* harmony import */ var _basic_schema__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./basic/schema */ "./lib/mol-model-formats/structure/basic/schema.js");
/* harmony import */ var _common_component__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ./common/component */ "./lib/mol-model-formats/structure/common/component.js");
/* harmony import */ var _common_entity__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ./common/entity */ "./lib/mol-model-formats/structure/common/entity.js");
/**
 * Copyright (c) 2020 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author David Sehnal <david.sehnal@gmail.com>
 */








function getModels(cube, ctx) {
    return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"])(this, void 0, void 0, function () {
        var atoms, MOL, A, type_symbol, seq_id, atom_site, entityBuilder, componentBuilder, basics;
        return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__generator"])(this, function (_a) {
            switch (_a.label) {
                case 0:
                    atoms = cube.atoms;
                    MOL = _mol_data_db__WEBPACK_IMPORTED_MODULE_1__["Column"].ofConst('MOL', cube.atoms.count, _mol_data_db__WEBPACK_IMPORTED_MODULE_1__["Column"].Schema.str);
                    A = _mol_data_db__WEBPACK_IMPORTED_MODULE_1__["Column"].ofConst('A', cube.atoms.count, _mol_data_db__WEBPACK_IMPORTED_MODULE_1__["Column"].Schema.str);
                    type_symbol = _mol_data_db__WEBPACK_IMPORTED_MODULE_1__["Column"].ofArray({ array: _mol_data_db__WEBPACK_IMPORTED_MODULE_1__["Column"].mapToArray(atoms.number, function (n) { return Object(_mol_model_structure_model_types__WEBPACK_IMPORTED_MODULE_2__["getElementFromAtomicNumber"])(n); }), schema: _mol_data_db__WEBPACK_IMPORTED_MODULE_1__["Column"].Schema.Aliased(_mol_data_db__WEBPACK_IMPORTED_MODULE_1__["Column"].Schema.str) });
                    seq_id = _mol_data_db__WEBPACK_IMPORTED_MODULE_1__["Column"].ofConst(1, atoms.count, _mol_data_db__WEBPACK_IMPORTED_MODULE_1__["Column"].Schema.int);
                    atom_site = _mol_data_db__WEBPACK_IMPORTED_MODULE_1__["Table"].ofPartialColumns(_basic_schema__WEBPACK_IMPORTED_MODULE_5__["BasicSchema"].atom_site, {
                        auth_asym_id: A,
                        auth_atom_id: type_symbol,
                        auth_comp_id: MOL,
                        auth_seq_id: seq_id,
                        Cartn_x: _mol_data_db__WEBPACK_IMPORTED_MODULE_1__["Column"].asArrayColumn(atoms.x, Float32Array),
                        Cartn_y: _mol_data_db__WEBPACK_IMPORTED_MODULE_1__["Column"].asArrayColumn(atoms.y, Float32Array),
                        Cartn_z: _mol_data_db__WEBPACK_IMPORTED_MODULE_1__["Column"].asArrayColumn(atoms.z, Float32Array),
                        id: _mol_data_db__WEBPACK_IMPORTED_MODULE_1__["Column"].range(0, atoms.count - 1),
                        label_asym_id: A,
                        label_atom_id: type_symbol,
                        label_comp_id: MOL,
                        label_seq_id: seq_id,
                        label_entity_id: _mol_data_db__WEBPACK_IMPORTED_MODULE_1__["Column"].ofConst('1', atoms.count, _mol_data_db__WEBPACK_IMPORTED_MODULE_1__["Column"].Schema.str),
                        occupancy: _mol_data_db__WEBPACK_IMPORTED_MODULE_1__["Column"].ofConst(1, atoms.count, _mol_data_db__WEBPACK_IMPORTED_MODULE_1__["Column"].Schema.float),
                        type_symbol: type_symbol,
                        pdbx_PDB_model_num: _mol_data_db__WEBPACK_IMPORTED_MODULE_1__["Column"].ofConst(1, atoms.count, _mol_data_db__WEBPACK_IMPORTED_MODULE_1__["Column"].Schema.int),
                    }, atoms.count);
                    entityBuilder = new _common_entity__WEBPACK_IMPORTED_MODULE_7__["EntityBuilder"]();
                    entityBuilder.setNames([['MOL', 'Unknown Entity']]);
                    entityBuilder.getEntityId('MOL', 0 /* Unknown */, 'A');
                    componentBuilder = new _common_component__WEBPACK_IMPORTED_MODULE_6__["ComponentBuilder"](seq_id, type_symbol);
                    componentBuilder.setNames([['MOL', 'Unknown Molecule']]);
                    componentBuilder.add('MOL', 0);
                    basics = Object(_basic_schema__WEBPACK_IMPORTED_MODULE_5__["createBasic"])({
                        entity: entityBuilder.getEntityTable(),
                        chem_comp: componentBuilder.getChemCompTable(),
                        atom_site: atom_site
                    });
                    return [4 /*yield*/, Object(_basic_parser__WEBPACK_IMPORTED_MODULE_4__["createModels"])(basics, MolFormat.create(cube), ctx)];
                case 1: return [2 /*return*/, _a.sent()];
            }
        });
    });
}
var MolFormat;
(function (MolFormat) {
    function is(x) {
        return (x === null || x === void 0 ? void 0 : x.kind) === 'cube';
    }
    MolFormat.is = is;
    function create(cube) {
        return { kind: 'cube', name: cube.header.comment1, data: cube };
    }
    MolFormat.create = create;
})(MolFormat || (MolFormat = {}));
function trajectoryFromCube(cube) {
    return _mol_task__WEBPACK_IMPORTED_MODULE_3__["Task"].create('Parse Cube', function (ctx) { return getModels(cube, ctx); });
}
//# sourceMappingURL=cube.js.map

/***/ }),

/***/ "./lib/mol-model-formats/structure/dcd.js":
/*!************************************************!*\
  !*** ./lib/mol-model-formats/structure/dcd.js ***!
  \************************************************/
/*! exports provided: coordinatesFromDcd */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "coordinatesFromDcd", function() { return coordinatesFromDcd; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _mol_task__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../mol-task */ "./lib/mol-task/index.js");
/* harmony import */ var _mol_model_structure_coordinates__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../mol-model/structure/coordinates */ "./lib/mol-model/structure/coordinates.js");
/* harmony import */ var _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../mol-math/linear-algebra */ "./lib/mol-math/linear-algebra.js");
/* harmony import */ var _mol_math_misc__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../mol-math/misc */ "./lib/mol-math/misc.js");
/* harmony import */ var _mol_math_geometry_spacegroup_cell__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../mol-math/geometry/spacegroup/cell */ "./lib/mol-math/geometry/spacegroup/cell.js");
/**
 * Copyright (c) 2019-2020 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */






var charmmTimeUnitFactor = 20.45482949774598;
function coordinatesFromDcd(dcdFile) {
    var _this = this;
    return _mol_task__WEBPACK_IMPORTED_MODULE_1__["Task"].create('Parse DCD', function (ctx) { return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"])(_this, void 0, void 0, function () {
        var header, deltaTime, offsetTime, frames, i, il, dcdFrame, frame, c;
        return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__generator"])(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, ctx.update('Converting to coordinates')];
                case 1:
                    _a.sent();
                    header = dcdFile.header;
                    deltaTime = header.DELTA
                        ? Object(_mol_model_structure_coordinates__WEBPACK_IMPORTED_MODULE_2__["Time"])(header.DELTA * charmmTimeUnitFactor, 'ps')
                        : Object(_mol_model_structure_coordinates__WEBPACK_IMPORTED_MODULE_2__["Time"])(1, 'step');
                    offsetTime = header.ISTART >= 1
                        ? Object(_mol_model_structure_coordinates__WEBPACK_IMPORTED_MODULE_2__["Time"])((header.ISTART - 1) * deltaTime.value, deltaTime.unit)
                        : Object(_mol_model_structure_coordinates__WEBPACK_IMPORTED_MODULE_2__["Time"])(0, deltaTime.unit);
                    frames = [];
                    for (i = 0, il = dcdFile.frames.length; i < il; ++i) {
                        dcdFrame = dcdFile.frames[i];
                        frame = {
                            elementCount: dcdFrame.elementCount,
                            time: Object(_mol_model_structure_coordinates__WEBPACK_IMPORTED_MODULE_2__["Time"])(offsetTime.value + deltaTime.value * i, deltaTime.unit),
                            x: dcdFrame.x,
                            y: dcdFrame.y,
                            z: dcdFrame.z,
                        };
                        if (dcdFrame.cell) {
                            c = dcdFrame.cell;
                            if (c[1] >= -1 && c[1] <= 1 && c[3] >= -1 && c[3] <= 1 && c[4] >= -1 && c[4] <= 1) {
                                frame.cell = _mol_math_geometry_spacegroup_cell__WEBPACK_IMPORTED_MODULE_5__["Cell"].create(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_3__["Vec3"].create(c[0], c[2], c[5]), _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_3__["Vec3"].create(Object(_mol_math_misc__WEBPACK_IMPORTED_MODULE_4__["degToRad"])(90 - Math.asin(c[1]) * 90 / _mol_math_misc__WEBPACK_IMPORTED_MODULE_4__["halfPI"]), Object(_mol_math_misc__WEBPACK_IMPORTED_MODULE_4__["degToRad"])(90 - Math.asin(c[3]) * 90 / _mol_math_misc__WEBPACK_IMPORTED_MODULE_4__["halfPI"]), Object(_mol_math_misc__WEBPACK_IMPORTED_MODULE_4__["degToRad"])(90 - Math.asin(c[4]) * 90 / _mol_math_misc__WEBPACK_IMPORTED_MODULE_4__["halfPI"])));
                            }
                            else if (c[0] < 0 || c[1] < 0 || c[2] < 0 || c[3] < 0 || c[4] < 0 || c[5] < 0 ||
                                c[3] > 180 || c[4] > 180 || c[5] > 180) {
                                frame.cell = _mol_math_geometry_spacegroup_cell__WEBPACK_IMPORTED_MODULE_5__["Cell"].fromBasis(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_3__["Vec3"].create(c[0], c[1], c[3]), _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_3__["Vec3"].create(c[1], c[2], c[4]), _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_3__["Vec3"].create(c[3], c[4], c[5]));
                            }
                            else {
                                frame.cell = _mol_math_geometry_spacegroup_cell__WEBPACK_IMPORTED_MODULE_5__["Cell"].create(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_3__["Vec3"].create(c[0], c[2], c[5]), _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_3__["Vec3"].create(Object(_mol_math_misc__WEBPACK_IMPORTED_MODULE_4__["degToRad"])(c[1]), Object(_mol_math_misc__WEBPACK_IMPORTED_MODULE_4__["degToRad"])(c[3]), Object(_mol_math_misc__WEBPACK_IMPORTED_MODULE_4__["degToRad"])(c[4])));
                            }
                        }
                        frames.push(frame);
                    }
                    return [2 /*return*/, _mol_model_structure_coordinates__WEBPACK_IMPORTED_MODULE_2__["Coordinates"].create(frames, deltaTime, offsetTime)];
            }
        });
    }); });
}
//# sourceMappingURL=dcd.js.map

/***/ }),

/***/ "./lib/mol-model-formats/structure/gro.js":
/*!************************************************!*\
  !*** ./lib/mol-model-formats/structure/gro.js ***!
  \************************************************/
/*! exports provided: GroFormat, trajectoryFromGRO */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "GroFormat", function() { return GroFormat; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "trajectoryFromGRO", function() { return trajectoryFromGRO; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _mol_task__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../mol-task */ "./lib/mol-task/index.js");
/* harmony import */ var _mol_data_db__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../mol-data/db */ "./lib/mol-data/db.js");
/* harmony import */ var _util__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./util */ "./lib/mol-model-formats/structure/util.js");
/* harmony import */ var _mol_model_structure_model_types__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../mol-model/structure/model/types */ "./lib/mol-model/structure/model/types.js");
/* harmony import */ var _common_component__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./common/component */ "./lib/mol-model-formats/structure/common/component.js");
/* harmony import */ var _common_util__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ./common/util */ "./lib/mol-model-formats/structure/common/util.js");
/* harmony import */ var _common_entity__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ./common/entity */ "./lib/mol-model-formats/structure/common/entity.js");
/* harmony import */ var _basic_schema__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ./basic/schema */ "./lib/mol-model-formats/structure/basic/schema.js");
/* harmony import */ var _basic_parser__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ./basic/parser */ "./lib/mol-model-formats/structure/basic/parser.js");
/* harmony import */ var _mol_model_structure_trajectory__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ../../mol-model/structure/trajectory */ "./lib/mol-model/structure/trajectory.js");
/**
 * Copyright (c) 2019-2020 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */











function getBasic(atoms, modelNum) {
    var auth_atom_id = atoms.atomName;
    var auth_comp_id = atoms.residueName;
    var entityIds = new Array(atoms.count);
    var asymIds = new Array(atoms.count);
    var seqIds = new Uint32Array(atoms.count);
    var ids = new Uint32Array(atoms.count);
    var entityBuilder = new _common_entity__WEBPACK_IMPORTED_MODULE_7__["EntityBuilder"]();
    var componentBuilder = new _common_component__WEBPACK_IMPORTED_MODULE_5__["ComponentBuilder"](atoms.residueNumber, atoms.atomName);
    var currentEntityId = '';
    var currentAsymIndex = 0;
    var currentAsymId = '';
    var currentSeqId = 0;
    var prevMoleculeType = 0 /* Unknown */;
    var prevResidueNumber = -1;
    for (var i = 0, il = atoms.count; i < il; ++i) {
        var residueNumber = atoms.residueNumber.value(i);
        if (residueNumber !== prevResidueNumber) {
            var compId = atoms.residueName.value(i);
            var moleculeType = Object(_mol_model_structure_model_types__WEBPACK_IMPORTED_MODULE_4__["getMoleculeType"])(componentBuilder.add(compId, i).type, compId);
            if (moleculeType !== prevMoleculeType || (residueNumber !== prevResidueNumber + 1 && !(
            // gro format allows only for 5 character residueNumbers, handle overflow here
            prevResidueNumber === 99999 && residueNumber === 0))) {
                currentAsymId = Object(_common_util__WEBPACK_IMPORTED_MODULE_6__["getChainId"])(currentAsymIndex);
                currentAsymIndex += 1;
                currentSeqId = 0;
            }
            currentEntityId = entityBuilder.getEntityId(compId, moleculeType, currentAsymId);
            currentSeqId += 1;
            prevResidueNumber = residueNumber;
            prevMoleculeType = moleculeType;
        }
        entityIds[i] = currentEntityId;
        asymIds[i] = currentAsymId;
        seqIds[i] = currentSeqId;
        ids[i] = i;
    }
    var auth_asym_id = _mol_data_db__WEBPACK_IMPORTED_MODULE_2__["Column"].ofStringArray(asymIds);
    var atom_site = _mol_data_db__WEBPACK_IMPORTED_MODULE_2__["Table"].ofPartialColumns(_basic_schema__WEBPACK_IMPORTED_MODULE_8__["BasicSchema"].atom_site, {
        auth_asym_id: auth_asym_id,
        auth_atom_id: auth_atom_id,
        auth_comp_id: auth_comp_id,
        auth_seq_id: atoms.residueNumber,
        Cartn_x: _mol_data_db__WEBPACK_IMPORTED_MODULE_2__["Column"].ofFloatArray(_mol_data_db__WEBPACK_IMPORTED_MODULE_2__["Column"].mapToArray(atoms.x, function (x) { return x * 10; }, Float32Array)),
        Cartn_y: _mol_data_db__WEBPACK_IMPORTED_MODULE_2__["Column"].ofFloatArray(_mol_data_db__WEBPACK_IMPORTED_MODULE_2__["Column"].mapToArray(atoms.y, function (y) { return y * 10; }, Float32Array)),
        Cartn_z: _mol_data_db__WEBPACK_IMPORTED_MODULE_2__["Column"].ofFloatArray(_mol_data_db__WEBPACK_IMPORTED_MODULE_2__["Column"].mapToArray(atoms.z, function (z) { return z * 10; }, Float32Array)),
        id: _mol_data_db__WEBPACK_IMPORTED_MODULE_2__["Column"].ofIntArray(ids),
        label_asym_id: auth_asym_id,
        label_atom_id: auth_atom_id,
        label_comp_id: auth_comp_id,
        label_seq_id: _mol_data_db__WEBPACK_IMPORTED_MODULE_2__["Column"].ofIntArray(seqIds),
        label_entity_id: _mol_data_db__WEBPACK_IMPORTED_MODULE_2__["Column"].ofStringArray(entityIds),
        occupancy: _mol_data_db__WEBPACK_IMPORTED_MODULE_2__["Column"].ofConst(1, atoms.count, _mol_data_db__WEBPACK_IMPORTED_MODULE_2__["Column"].Schema.float),
        type_symbol: _mol_data_db__WEBPACK_IMPORTED_MODULE_2__["Column"].ofStringArray(_mol_data_db__WEBPACK_IMPORTED_MODULE_2__["Column"].mapToArray(atoms.atomName, function (s) { return Object(_util__WEBPACK_IMPORTED_MODULE_3__["guessElementSymbolString"])(s); })),
        pdbx_PDB_model_num: _mol_data_db__WEBPACK_IMPORTED_MODULE_2__["Column"].ofConst(modelNum, atoms.count, _mol_data_db__WEBPACK_IMPORTED_MODULE_2__["Column"].Schema.int),
    }, atoms.count);
    return Object(_basic_schema__WEBPACK_IMPORTED_MODULE_8__["createBasic"])({
        entity: entityBuilder.getEntityTable(),
        chem_comp: componentBuilder.getChemCompTable(),
        atom_site: atom_site
    });
}
//

var GroFormat;
(function (GroFormat) {
    function is(x) {
        return (x === null || x === void 0 ? void 0 : x.kind) === 'gro';
    }
    GroFormat.is = is;
    function fromGro(gro) {
        return { kind: 'gro', name: gro.structures[0].header.title, data: gro };
    }
    GroFormat.fromGro = fromGro;
})(GroFormat || (GroFormat = {}));
// TODO reuse static model parts when hierarchy is identical
//      need to pass all gro.structures as one table into createModels
function trajectoryFromGRO(gro) {
    var _this = this;
    return _mol_task__WEBPACK_IMPORTED_MODULE_1__["Task"].create('Parse GRO', function (ctx) { return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"])(_this, void 0, void 0, function () {
        var format, models, i, il, basic, m;
        return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__generator"])(this, function (_a) {
            switch (_a.label) {
                case 0:
                    format = GroFormat.fromGro(gro);
                    models = [];
                    i = 0, il = gro.structures.length;
                    _a.label = 1;
                case 1:
                    if (!(i < il)) return [3 /*break*/, 4];
                    basic = getBasic(gro.structures[i].atoms, i + 1);
                    return [4 /*yield*/, Object(_basic_parser__WEBPACK_IMPORTED_MODULE_9__["createModels"])(basic, format, ctx)];
                case 2:
                    m = _a.sent();
                    if (m.frameCount === 1) {
                        models.push(m.representative);
                    }
                    _a.label = 3;
                case 3:
                    ++i;
                    return [3 /*break*/, 1];
                case 4: return [2 /*return*/, new _mol_model_structure_trajectory__WEBPACK_IMPORTED_MODULE_10__["ArrayTrajectory"](models)];
            }
        });
    }); });
}
//# sourceMappingURL=gro.js.map

/***/ }),

/***/ "./lib/mol-model-formats/structure/mmcif.js":
/*!**************************************************!*\
  !*** ./lib/mol-model-formats/structure/mmcif.js ***!
  \**************************************************/
/*! exports provided: MmcifFormat, trajectoryFromMmCIF */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MmcifFormat", function() { return MmcifFormat; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "trajectoryFromMmCIF", function() { return trajectoryFromMmCIF; });
/* harmony import */ var _mol_task__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../mol-task */ "./lib/mol-task/index.js");
/* harmony import */ var _mol_io_reader_cif__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../mol-io/reader/cif */ "./lib/mol-io/reader/cif.js");
/* harmony import */ var _basic_parser__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./basic/parser */ "./lib/mol-model-formats/structure/basic/parser.js");
/* harmony import */ var _property_symmetry__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./property/symmetry */ "./lib/mol-model-formats/structure/property/symmetry.js");
/* harmony import */ var _property_secondary_structure__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./property/secondary-structure */ "./lib/mol-model-formats/structure/property/secondary-structure.js");
/* harmony import */ var _mol_data_db__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../mol-data/db */ "./lib/mol-data/db.js");
/* harmony import */ var _property_anisotropic__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ./property/anisotropic */ "./lib/mol-model-formats/structure/property/anisotropic.js");
/* harmony import */ var _property_bonds_chem_comp__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ./property/bonds/chem_comp */ "./lib/mol-model-formats/structure/property/bonds/chem_comp.js");
/* harmony import */ var _property_bonds_struct_conn__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ./property/bonds/struct_conn */ "./lib/mol-model-formats/structure/property/bonds/struct_conn.js");
/* harmony import */ var _mol_model_structure_model_properties_global_transform__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ../../mol-model/structure/model/properties/global-transform */ "./lib/mol-model/structure/model/properties/global-transform.js");
/**
 * Copyright (c) 2017-2021 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author David Sehnal <david.sehnal@gmail.com>
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */










function modelSymmetryFromMmcif(model) {
    if (!MmcifFormat.is(model.sourceData))
        return;
    return _property_symmetry__WEBPACK_IMPORTED_MODULE_3__["ModelSymmetry"].fromData(model.sourceData.data.db);
}
_property_symmetry__WEBPACK_IMPORTED_MODULE_3__["ModelSymmetry"].Provider.formatRegistry.add('mmCIF', modelSymmetryFromMmcif);
function secondaryStructureFromMmcif(model) {
    if (!MmcifFormat.is(model.sourceData))
        return;
    var _a = model.sourceData.data.db, struct_conf = _a.struct_conf, struct_sheet_range = _a.struct_sheet_range;
    return _property_secondary_structure__WEBPACK_IMPORTED_MODULE_4__["ModelSecondaryStructure"].fromStruct(struct_conf, struct_sheet_range, model.atomicHierarchy);
}
_property_secondary_structure__WEBPACK_IMPORTED_MODULE_4__["ModelSecondaryStructure"].Provider.formatRegistry.add('mmCIF', secondaryStructureFromMmcif);
function atomSiteAnisotropFromMmcif(model) {
    if (!MmcifFormat.is(model.sourceData))
        return;
    var atom_site_anisotrop = model.sourceData.data.db.atom_site_anisotrop;
    var data = _mol_data_db__WEBPACK_IMPORTED_MODULE_5__["Table"].ofColumns(_property_anisotropic__WEBPACK_IMPORTED_MODULE_6__["AtomSiteAnisotrop"].Schema, atom_site_anisotrop);
    var elementToAnsiotrop = _property_anisotropic__WEBPACK_IMPORTED_MODULE_6__["AtomSiteAnisotrop"].getElementToAnsiotrop(model.atomicConformation.atomId, atom_site_anisotrop.id);
    return { data: data, elementToAnsiotrop: elementToAnsiotrop };
}
function atomSiteAnisotropApplicableMmcif(model) {
    if (!MmcifFormat.is(model.sourceData))
        return false;
    return model.sourceData.data.db.atom_site_anisotrop.U.isDefined;
}
_property_anisotropic__WEBPACK_IMPORTED_MODULE_6__["AtomSiteAnisotrop"].Provider.formatRegistry.add('mmCIF', atomSiteAnisotropFromMmcif, atomSiteAnisotropApplicableMmcif);
function componentBondFromMmcif(model) {
    if (!MmcifFormat.is(model.sourceData))
        return;
    var chem_comp_bond = model.sourceData.data.db.chem_comp_bond;
    if (chem_comp_bond._rowCount === 0)
        return;
    return {
        data: chem_comp_bond,
        entries: _property_bonds_chem_comp__WEBPACK_IMPORTED_MODULE_7__["ComponentBond"].getEntriesFromChemCompBond(chem_comp_bond)
    };
}
_property_bonds_chem_comp__WEBPACK_IMPORTED_MODULE_7__["ComponentBond"].Provider.formatRegistry.add('mmCIF', componentBondFromMmcif);
function structConnFromMmcif(model) {
    if (!MmcifFormat.is(model.sourceData))
        return;
    var struct_conn = model.sourceData.data.db.struct_conn;
    if (struct_conn._rowCount === 0)
        return;
    var entries = _property_bonds_struct_conn__WEBPACK_IMPORTED_MODULE_8__["StructConn"].getEntriesFromStructConn(struct_conn, model);
    return {
        data: struct_conn,
        byAtomIndex: _property_bonds_struct_conn__WEBPACK_IMPORTED_MODULE_8__["StructConn"].getAtomIndexFromEntries(entries),
        entries: entries,
    };
}
_property_bonds_struct_conn__WEBPACK_IMPORTED_MODULE_8__["StructConn"].Provider.formatRegistry.add('mmCIF', structConnFromMmcif);
_mol_model_structure_model_properties_global_transform__WEBPACK_IMPORTED_MODULE_9__["GlobalModelTransformInfo"].Provider.formatRegistry.add('mmCIF', _mol_model_structure_model_properties_global_transform__WEBPACK_IMPORTED_MODULE_9__["GlobalModelTransformInfo"].fromMmCif, _mol_model_structure_model_properties_global_transform__WEBPACK_IMPORTED_MODULE_9__["GlobalModelTransformInfo"].hasData);
//

var MmcifFormat;
(function (MmcifFormat) {
    function is(x) {
        return (x === null || x === void 0 ? void 0 : x.kind) === 'mmCIF';
    }
    MmcifFormat.is = is;
    function fromFrame(frame, db, source) {
        if (!db)
            db = _mol_io_reader_cif__WEBPACK_IMPORTED_MODULE_1__["CIF"].schema.mmCIF(frame);
        return { kind: 'mmCIF', name: db._name, data: { db: db, frame: frame, source: source } };
    }
    MmcifFormat.fromFrame = fromFrame;
})(MmcifFormat || (MmcifFormat = {}));
function trajectoryFromMmCIF(frame) {
    var format = MmcifFormat.fromFrame(frame);
    return _mol_task__WEBPACK_IMPORTED_MODULE_0__["Task"].create('Create mmCIF Model', function (ctx) { return Object(_basic_parser__WEBPACK_IMPORTED_MODULE_2__["createModels"])(format.data.db, format, ctx); });
}
//# sourceMappingURL=mmcif.js.map

/***/ }),

/***/ "./lib/mol-model-formats/structure/mol.js":
/*!************************************************!*\
  !*** ./lib/mol-model-formats/structure/mol.js ***!
  \************************************************/
/*! exports provided: MolFormat, trajectoryFromMol */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MolFormat", function() { return MolFormat; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "trajectoryFromMol", function() { return trajectoryFromMol; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _mol_data_db__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../mol-data/db */ "./lib/mol-data/db.js");
/* harmony import */ var _mol_task__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../mol-task */ "./lib/mol-task/index.js");
/* harmony import */ var _basic_parser__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./basic/parser */ "./lib/mol-model-formats/structure/basic/parser.js");
/* harmony import */ var _basic_schema__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./basic/schema */ "./lib/mol-model-formats/structure/basic/schema.js");
/* harmony import */ var _common_component__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./common/component */ "./lib/mol-model-formats/structure/common/component.js");
/* harmony import */ var _common_entity__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ./common/entity */ "./lib/mol-model-formats/structure/common/entity.js");
/* harmony import */ var _property_bonds_index_pair__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ./property/bonds/index-pair */ "./lib/mol-model-formats/structure/property/bonds/index-pair.js");
/**
 * Copyright (c) 2019-2020 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author David Sehnal <david.sehnal@gmail.com>
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */








function getModels(mol, ctx) {
    return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"])(this, void 0, void 0, function () {
        var atoms, bonds, MOL, A, type_symbol, seq_id, atom_site, entityBuilder, componentBuilder, basics, models, indexA, indexB, order, pairBonds;
        return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__generator"])(this, function (_a) {
            switch (_a.label) {
                case 0:
                    atoms = mol.atoms, bonds = mol.bonds;
                    MOL = _mol_data_db__WEBPACK_IMPORTED_MODULE_1__["Column"].ofConst('MOL', mol.atoms.count, _mol_data_db__WEBPACK_IMPORTED_MODULE_1__["Column"].Schema.str);
                    A = _mol_data_db__WEBPACK_IMPORTED_MODULE_1__["Column"].ofConst('A', mol.atoms.count, _mol_data_db__WEBPACK_IMPORTED_MODULE_1__["Column"].Schema.str);
                    type_symbol = _mol_data_db__WEBPACK_IMPORTED_MODULE_1__["Column"].asArrayColumn(atoms.type_symbol);
                    seq_id = _mol_data_db__WEBPACK_IMPORTED_MODULE_1__["Column"].ofConst(1, atoms.count, _mol_data_db__WEBPACK_IMPORTED_MODULE_1__["Column"].Schema.int);
                    atom_site = _mol_data_db__WEBPACK_IMPORTED_MODULE_1__["Table"].ofPartialColumns(_basic_schema__WEBPACK_IMPORTED_MODULE_4__["BasicSchema"].atom_site, {
                        auth_asym_id: A,
                        auth_atom_id: type_symbol,
                        auth_comp_id: MOL,
                        auth_seq_id: seq_id,
                        Cartn_x: _mol_data_db__WEBPACK_IMPORTED_MODULE_1__["Column"].asArrayColumn(atoms.x, Float32Array),
                        Cartn_y: _mol_data_db__WEBPACK_IMPORTED_MODULE_1__["Column"].asArrayColumn(atoms.y, Float32Array),
                        Cartn_z: _mol_data_db__WEBPACK_IMPORTED_MODULE_1__["Column"].asArrayColumn(atoms.z, Float32Array),
                        id: _mol_data_db__WEBPACK_IMPORTED_MODULE_1__["Column"].range(0, atoms.count - 1),
                        label_asym_id: A,
                        label_atom_id: type_symbol,
                        label_comp_id: MOL,
                        label_seq_id: seq_id,
                        label_entity_id: _mol_data_db__WEBPACK_IMPORTED_MODULE_1__["Column"].ofConst('1', atoms.count, _mol_data_db__WEBPACK_IMPORTED_MODULE_1__["Column"].Schema.str),
                        occupancy: _mol_data_db__WEBPACK_IMPORTED_MODULE_1__["Column"].ofConst(1, atoms.count, _mol_data_db__WEBPACK_IMPORTED_MODULE_1__["Column"].Schema.float),
                        type_symbol: type_symbol,
                        pdbx_PDB_model_num: _mol_data_db__WEBPACK_IMPORTED_MODULE_1__["Column"].ofConst(1, atoms.count, _mol_data_db__WEBPACK_IMPORTED_MODULE_1__["Column"].Schema.int),
                    }, atoms.count);
                    entityBuilder = new _common_entity__WEBPACK_IMPORTED_MODULE_6__["EntityBuilder"]();
                    entityBuilder.setNames([['MOL', 'Unknown Entity']]);
                    entityBuilder.getEntityId('MOL', 0 /* Unknown */, 'A');
                    componentBuilder = new _common_component__WEBPACK_IMPORTED_MODULE_5__["ComponentBuilder"](seq_id, type_symbol);
                    componentBuilder.setNames([['MOL', 'Unknown Molecule']]);
                    componentBuilder.add('MOL', 0);
                    basics = Object(_basic_schema__WEBPACK_IMPORTED_MODULE_4__["createBasic"])({
                        entity: entityBuilder.getEntityTable(),
                        chem_comp: componentBuilder.getChemCompTable(),
                        atom_site: atom_site
                    });
                    return [4 /*yield*/, Object(_basic_parser__WEBPACK_IMPORTED_MODULE_3__["createModels"])(basics, MolFormat.create(mol), ctx)];
                case 1:
                    models = _a.sent();
                    if (models.frameCount > 0) {
                        indexA = _mol_data_db__WEBPACK_IMPORTED_MODULE_1__["Column"].ofIntArray(_mol_data_db__WEBPACK_IMPORTED_MODULE_1__["Column"].mapToArray(bonds.atomIdxA, function (x) { return x - 1; }, Int32Array));
                        indexB = _mol_data_db__WEBPACK_IMPORTED_MODULE_1__["Column"].ofIntArray(_mol_data_db__WEBPACK_IMPORTED_MODULE_1__["Column"].mapToArray(bonds.atomIdxB, function (x) { return x - 1; }, Int32Array));
                        order = _mol_data_db__WEBPACK_IMPORTED_MODULE_1__["Column"].asArrayColumn(bonds.order, Int32Array);
                        pairBonds = _property_bonds_index_pair__WEBPACK_IMPORTED_MODULE_7__["IndexPairBonds"].fromData({ pairs: { indexA: indexA, indexB: indexB, order: order }, count: atoms.count });
                        _property_bonds_index_pair__WEBPACK_IMPORTED_MODULE_7__["IndexPairBonds"].Provider.set(models.representative, pairBonds);
                    }
                    return [2 /*return*/, models];
            }
        });
    });
}
//

var MolFormat;
(function (MolFormat) {
    function is(x) {
        return (x === null || x === void 0 ? void 0 : x.kind) === 'mol';
    }
    MolFormat.is = is;
    function create(mol) {
        return { kind: 'mol', name: mol.title, data: mol };
    }
    MolFormat.create = create;
})(MolFormat || (MolFormat = {}));
function trajectoryFromMol(mol) {
    return _mol_task__WEBPACK_IMPORTED_MODULE_2__["Task"].create('Parse MOL', function (ctx) { return getModels(mol, ctx); });
}
//# sourceMappingURL=mol.js.map

/***/ }),

/***/ "./lib/mol-model-formats/structure/mol2.js":
/*!*************************************************!*\
  !*** ./lib/mol-model-formats/structure/mol2.js ***!
  \*************************************************/
/*! exports provided: Mol2Format, trajectoryFromMol2 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Mol2Format", function() { return Mol2Format; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "trajectoryFromMol2", function() { return trajectoryFromMol2; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _mol_data_db__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../mol-data/db */ "./lib/mol-data/db.js");
/* harmony import */ var _mol_task__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../mol-task */ "./lib/mol-task/index.js");
/* harmony import */ var _basic_parser__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./basic/parser */ "./lib/mol-model-formats/structure/basic/parser.js");
/* harmony import */ var _basic_schema__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./basic/schema */ "./lib/mol-model-formats/structure/basic/schema.js");
/* harmony import */ var _common_component__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./common/component */ "./lib/mol-model-formats/structure/common/component.js");
/* harmony import */ var _common_entity__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ./common/entity */ "./lib/mol-model-formats/structure/common/entity.js");
/* harmony import */ var _property_bonds_index_pair__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ./property/bonds/index-pair */ "./lib/mol-model-formats/structure/property/bonds/index-pair.js");
/* harmony import */ var _property_partial_charge__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ./property/partial-charge */ "./lib/mol-model-formats/structure/property/partial-charge.js");
/* harmony import */ var _mol_model_structure__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ../../mol-model/structure */ "./lib/mol-model/structure.js");
/* harmony import */ var _util__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ./util */ "./lib/mol-model-formats/structure/util.js");
/**
 * Copyright (c) 2020 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */











function getModels(mol2, ctx) {
    return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"])(this, void 0, void 0, function () {
        var models, i, il, _a, atoms, bonds, molecule, A, type_symbol, i_1, atom_site, entityBuilder, componentBuilder, i_2, il_1, basics, _models, indexA, indexB, order, pairBonds, first;
        return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__generator"])(this, function (_b) {
            switch (_b.label) {
                case 0:
                    models = [];
                    i = 0, il = mol2.structures.length;
                    _b.label = 1;
                case 1:
                    if (!(i < il)) return [3 /*break*/, 4];
                    _a = mol2.structures[i], atoms = _a.atoms, bonds = _a.bonds, molecule = _a.molecule;
                    A = _mol_data_db__WEBPACK_IMPORTED_MODULE_1__["Column"].ofConst('A', atoms.count, _mol_data_db__WEBPACK_IMPORTED_MODULE_1__["Column"].Schema.str);
                    type_symbol = new Array(atoms.count);
                    for (i_1 = 0; i_1 < atoms.count; ++i_1) {
                        type_symbol[i_1] = Object(_util__WEBPACK_IMPORTED_MODULE_10__["guessElementSymbolString"])(atoms.atom_name.value(i_1));
                    }
                    atom_site = _mol_data_db__WEBPACK_IMPORTED_MODULE_1__["Table"].ofPartialColumns(_basic_schema__WEBPACK_IMPORTED_MODULE_4__["BasicSchema"].atom_site, {
                        auth_asym_id: A,
                        auth_atom_id: _mol_data_db__WEBPACK_IMPORTED_MODULE_1__["Column"].asArrayColumn(atoms.atom_name),
                        auth_comp_id: atoms.subst_name,
                        auth_seq_id: atoms.subst_id,
                        Cartn_x: _mol_data_db__WEBPACK_IMPORTED_MODULE_1__["Column"].asArrayColumn(atoms.x, Float32Array),
                        Cartn_y: _mol_data_db__WEBPACK_IMPORTED_MODULE_1__["Column"].asArrayColumn(atoms.y, Float32Array),
                        Cartn_z: _mol_data_db__WEBPACK_IMPORTED_MODULE_1__["Column"].asArrayColumn(atoms.z, Float32Array),
                        id: _mol_data_db__WEBPACK_IMPORTED_MODULE_1__["Column"].asArrayColumn(atoms.atom_id),
                        label_asym_id: A,
                        label_atom_id: _mol_data_db__WEBPACK_IMPORTED_MODULE_1__["Column"].asArrayColumn(atoms.atom_name),
                        label_comp_id: atoms.subst_name,
                        label_seq_id: atoms.subst_id,
                        label_entity_id: _mol_data_db__WEBPACK_IMPORTED_MODULE_1__["Column"].ofConst('1', atoms.count, _mol_data_db__WEBPACK_IMPORTED_MODULE_1__["Column"].Schema.str),
                        occupancy: _mol_data_db__WEBPACK_IMPORTED_MODULE_1__["Column"].ofConst(1, atoms.count, _mol_data_db__WEBPACK_IMPORTED_MODULE_1__["Column"].Schema.float),
                        type_symbol: _mol_data_db__WEBPACK_IMPORTED_MODULE_1__["Column"].ofStringArray(type_symbol),
                        pdbx_PDB_model_num: _mol_data_db__WEBPACK_IMPORTED_MODULE_1__["Column"].ofConst(i, atoms.count, _mol_data_db__WEBPACK_IMPORTED_MODULE_1__["Column"].Schema.int),
                    }, atoms.count);
                    entityBuilder = new _common_entity__WEBPACK_IMPORTED_MODULE_6__["EntityBuilder"]();
                    entityBuilder.setNames([['MOL', molecule.mol_name || 'Unknown Entity']]);
                    entityBuilder.getEntityId('MOL', 0 /* Unknown */, 'A');
                    componentBuilder = new _common_component__WEBPACK_IMPORTED_MODULE_5__["ComponentBuilder"](atoms.subst_id, atoms.atom_name);
                    for (i_2 = 0, il_1 = atoms.subst_name.rowCount; i_2 < il_1; ++i_2) {
                        componentBuilder.add(atoms.subst_name.value(i_2), i_2);
                    }
                    basics = Object(_basic_schema__WEBPACK_IMPORTED_MODULE_4__["createBasic"])({
                        entity: entityBuilder.getEntityTable(),
                        chem_comp: componentBuilder.getChemCompTable(),
                        atom_site: atom_site
                    });
                    return [4 /*yield*/, Object(_basic_parser__WEBPACK_IMPORTED_MODULE_3__["createModels"])(basics, Mol2Format.create(mol2), ctx)];
                case 2:
                    _models = _b.sent();
                    if (_models.frameCount > 0) {
                        indexA = _mol_data_db__WEBPACK_IMPORTED_MODULE_1__["Column"].ofIntArray(_mol_data_db__WEBPACK_IMPORTED_MODULE_1__["Column"].mapToArray(bonds.origin_atom_id, function (x) { return x - 1; }, Int32Array));
                        indexB = _mol_data_db__WEBPACK_IMPORTED_MODULE_1__["Column"].ofIntArray(_mol_data_db__WEBPACK_IMPORTED_MODULE_1__["Column"].mapToArray(bonds.target_atom_id, function (x) { return x - 1; }, Int32Array));
                        order = _mol_data_db__WEBPACK_IMPORTED_MODULE_1__["Column"].ofIntArray(_mol_data_db__WEBPACK_IMPORTED_MODULE_1__["Column"].mapToArray(bonds.bond_type, function (x) { return x === 'ar' ? 1 : parseInt(x); }, Int8Array));
                        pairBonds = _property_bonds_index_pair__WEBPACK_IMPORTED_MODULE_7__["IndexPairBonds"].fromData({ pairs: { indexA: indexA, indexB: indexB, order: order }, count: atoms.count });
                        first = _models.representative;
                        _property_bonds_index_pair__WEBPACK_IMPORTED_MODULE_7__["IndexPairBonds"].Provider.set(first, pairBonds);
                        _property_partial_charge__WEBPACK_IMPORTED_MODULE_8__["AtomPartialCharge"].Provider.set(first, {
                            data: atoms.charge,
                            type: molecule.charge_type
                        });
                        models.push(first);
                    }
                    _b.label = 3;
                case 3:
                    ++i;
                    return [3 /*break*/, 1];
                case 4: return [2 /*return*/, new _mol_model_structure__WEBPACK_IMPORTED_MODULE_9__["ArrayTrajectory"](models)];
            }
        });
    });
}
//

var Mol2Format;
(function (Mol2Format) {
    function is(x) {
        return (x === null || x === void 0 ? void 0 : x.kind) === 'mol2';
    }
    Mol2Format.is = is;
    function create(mol2) {
        return { kind: 'mol2', name: mol2.name, data: mol2 };
    }
    Mol2Format.create = create;
})(Mol2Format || (Mol2Format = {}));
function trajectoryFromMol2(mol2) {
    return _mol_task__WEBPACK_IMPORTED_MODULE_2__["Task"].create('Parse MOL2', function (ctx) { return getModels(mol2, ctx); });
}
//# sourceMappingURL=mol2.js.map

/***/ }),

/***/ "./lib/mol-model-formats/structure/pdb.js":
/*!************************************************!*\
  !*** ./lib/mol-model-formats/structure/pdb.js ***!
  \************************************************/
/*! exports provided: PdbFormat, trajectoryFromPDB */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "PdbFormat", function() { return PdbFormat; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "trajectoryFromPDB", function() { return trajectoryFromPDB; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _pdb_to_cif__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./pdb/to-cif */ "./lib/mol-model-formats/structure/pdb/to-cif.js");
/* harmony import */ var _mol_task__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../mol-task */ "./lib/mol-task/index.js");
/* harmony import */ var _mmcif__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./mmcif */ "./lib/mol-model-formats/structure/mmcif.js");
/* harmony import */ var _basic_parser__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./basic/parser */ "./lib/mol-model-formats/structure/basic/parser.js");
/* harmony import */ var _mol_data_db__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../mol-data/db */ "./lib/mol-data/db.js");
/* harmony import */ var _property_partial_charge__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ./property/partial-charge */ "./lib/mol-model-formats/structure/property/partial-charge.js");
/**
 * Copyright (c) 2019-2020 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author David Sehnal <david.sehnal@gmail.com>
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */








var PdbFormat;
(function (PdbFormat) {
    function is(x) {
        return (x === null || x === void 0 ? void 0 : x.kind) === 'pdb';
    }
    PdbFormat.is = is;
    function create(pdb) {
        return { kind: 'pdb', name: pdb.id || '', data: pdb };
    }
    PdbFormat.create = create;
})(PdbFormat || (PdbFormat = {}));
function trajectoryFromPDB(pdb) {
    var _this = this;
    return _mol_task__WEBPACK_IMPORTED_MODULE_2__["Task"].create('Parse PDB', function (ctx) { return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"])(_this, void 0, void 0, function () {
        var cif, format, models, partial_charge, first, srcIndex, isIdentity, srcIndexArray, q_1, partialCharge;
        var _a;
        return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__generator"])(this, function (_b) {
            switch (_b.label) {
                case 0: return [4 /*yield*/, ctx.update('Converting to mmCIF')];
                case 1:
                    _b.sent();
                    return [4 /*yield*/, Object(_pdb_to_cif__WEBPACK_IMPORTED_MODULE_1__["pdbToMmCif"])(pdb)];
                case 2:
                    cif = _b.sent();
                    format = _mmcif__WEBPACK_IMPORTED_MODULE_3__["MmcifFormat"].fromFrame(cif, undefined, PdbFormat.create(pdb));
                    return [4 /*yield*/, Object(_basic_parser__WEBPACK_IMPORTED_MODULE_4__["createModels"])(format.data.db, format, ctx)];
                case 3:
                    models = _b.sent();
                    partial_charge = (_a = cif.categories['atom_site']) === null || _a === void 0 ? void 0 : _a.getField('partial_charge');
                    if (partial_charge) {
                        // TODO works only for single, unsorted model, to work generally
                        //      would need to do model splitting again
                        if (models.frameCount === 1) {
                            first = models.representative;
                            srcIndex = first.atomicHierarchy.atomSourceIndex;
                            isIdentity = _mol_data_db__WEBPACK_IMPORTED_MODULE_5__["Column"].isIdentity(srcIndex);
                            srcIndexArray = isIdentity ? void 0 : srcIndex.toArray({ array: Int32Array });
                            q_1 = partial_charge.toFloatArray();
                            partialCharge = srcIndexArray
                                ? _mol_data_db__WEBPACK_IMPORTED_MODULE_5__["Column"].ofFloatArray(_mol_data_db__WEBPACK_IMPORTED_MODULE_5__["Column"].mapToArray(srcIndex, function (i) { return q_1[i]; }, Float32Array))
                                : _mol_data_db__WEBPACK_IMPORTED_MODULE_5__["Column"].ofFloatArray(q_1);
                            _property_partial_charge__WEBPACK_IMPORTED_MODULE_6__["AtomPartialCharge"].Provider.set(first, {
                                data: partialCharge,
                                type: 'GASTEIGER' // from PDBQT
                            });
                        }
                    }
                    return [2 /*return*/, models];
            }
        });
    }); });
}
//# sourceMappingURL=pdb.js.map

/***/ }),

/***/ "./lib/mol-model-formats/structure/pdb/anisotropic.js":
/*!************************************************************!*\
  !*** ./lib/mol-model-formats/structure/pdb/anisotropic.js ***!
  \************************************************************/
/*! exports provided: getAnisotropicTemplate, getAnisotropic, addAnisotropic */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getAnisotropicTemplate", function() { return getAnisotropicTemplate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getAnisotropic", function() { return getAnisotropic; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "addAnisotropic", function() { return addAnisotropic; });
/* harmony import */ var _mol_io_reader_cif__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../../mol-io/reader/cif */ "./lib/mol-io/reader/cif.js");
/* harmony import */ var _mol_io_reader_common_text_tokenizer__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../../mol-io/reader/common/text/tokenizer */ "./lib/mol-io/reader/common/text/tokenizer.js");
/* harmony import */ var _util__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../util */ "./lib/mol-model-formats/structure/util.js");
/* harmony import */ var _mol_io_reader_common_text_number_parser__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../../mol-io/reader/common/text/number-parser */ "./lib/mol-io/reader/common/text/number-parser.js");
/**
 * Copyright (c) 2019 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */




function getAnisotropicTemplate(data, count) {
    var str = function () { return []; };
    var float = function () { return new Float32Array(count); };
    var ts = function () { return _mol_io_reader_common_text_tokenizer__WEBPACK_IMPORTED_MODULE_1__["TokenBuilder"].create(data, 2 * count); };
    return {
        index: 0,
        count: count,
        id: str(),
        type_symbol: ts(),
        pdbx_label_atom_id: ts(),
        pdbx_label_alt_id: ts(),
        pdbx_label_comp_id: ts(),
        pdbx_label_asym_id: ts(),
        pdbx_label_seq_id: ts(),
        pdbx_PDB_ins_code: ts(),
        'U[1][1]': float(),
        'U[2][2]': float(),
        'U[3][3]': float(),
        'U[1][2]': float(),
        'U[1][3]': float(),
        'U[2][3]': float(),
        pdbx_auth_seq_id: ts(),
        pdbx_auth_comp_id: ts(),
        pdbx_auth_asym_id: ts(),
        pdbx_auth_atom_id: ts(),
    };
}
function getAnisotropic(sites) {
    var pdbx_auth_seq_id = _mol_io_reader_cif__WEBPACK_IMPORTED_MODULE_0__["CifField"].ofTokens(sites.pdbx_auth_seq_id);
    var pdbx_auth_comp_id = _mol_io_reader_cif__WEBPACK_IMPORTED_MODULE_0__["CifField"].ofTokens(sites.pdbx_auth_comp_id);
    var pdbx_auth_asym_id = _mol_io_reader_cif__WEBPACK_IMPORTED_MODULE_0__["CifField"].ofTokens(sites.pdbx_auth_asym_id);
    var pdbx_auth_atom_id = _mol_io_reader_cif__WEBPACK_IMPORTED_MODULE_0__["CifField"].ofTokens(sites.pdbx_auth_atom_id);
    var fields = {
        id: _mol_io_reader_cif__WEBPACK_IMPORTED_MODULE_0__["CifField"].ofStrings(sites.id),
        type_symbol: _mol_io_reader_cif__WEBPACK_IMPORTED_MODULE_0__["CifField"].ofTokens(sites.type_symbol),
        pdbx_label_atom_id: pdbx_auth_atom_id,
        pdbx_label_alt_id: _mol_io_reader_cif__WEBPACK_IMPORTED_MODULE_0__["CifField"].ofTokens(sites.pdbx_label_alt_id),
        pdbx_label_comp_id: pdbx_auth_comp_id,
        pdbx_label_asym_id: pdbx_auth_asym_id,
        pdbx_label_seq_id: pdbx_auth_seq_id,
        pdbx_PDB_ins_code: _mol_io_reader_cif__WEBPACK_IMPORTED_MODULE_0__["CifField"].ofTokens(sites.pdbx_PDB_ins_code),
        pdbx_auth_seq_id: pdbx_auth_seq_id,
        pdbx_auth_comp_id: pdbx_auth_comp_id,
        pdbx_auth_asym_id: pdbx_auth_asym_id,
        pdbx_auth_atom_id: pdbx_auth_atom_id,
    };
    fields['U[1][1]'] = _mol_io_reader_cif__WEBPACK_IMPORTED_MODULE_0__["CifField"].ofNumbers(sites['U[1][1]']);
    fields['U[2][2]'] = _mol_io_reader_cif__WEBPACK_IMPORTED_MODULE_0__["CifField"].ofNumbers(sites['U[2][2]']);
    fields['U[3][3]'] = _mol_io_reader_cif__WEBPACK_IMPORTED_MODULE_0__["CifField"].ofNumbers(sites['U[3][3]']);
    fields['U[1][2]'] = _mol_io_reader_cif__WEBPACK_IMPORTED_MODULE_0__["CifField"].ofNumbers(sites['U[1][2]']);
    fields['U[1][3]'] = _mol_io_reader_cif__WEBPACK_IMPORTED_MODULE_0__["CifField"].ofNumbers(sites['U[1][3]']);
    fields['U[2][3]'] = _mol_io_reader_cif__WEBPACK_IMPORTED_MODULE_0__["CifField"].ofNumbers(sites['U[2][3]']);
    return fields;
}
function addAnisotropic(sites, model, data, s, e) {
    var str = data.data;
    var length = e - s;
    // COLUMNS       DATA  TYPE    FIELD          DEFINITION
    // -----------------------------------------------------------------
    // 1 - 6        Record name   "ANISOU"
    // 7 - 11       Integer       serial         Atom serial number.
    _mol_io_reader_common_text_tokenizer__WEBPACK_IMPORTED_MODULE_1__["Tokenizer"].trim(data, s + 6, s + 11);
    sites.id[sites.index] = str.substring(data.tokenStart, data.tokenEnd);
    // 13 - 16       Atom          name           Atom name.
    _mol_io_reader_common_text_tokenizer__WEBPACK_IMPORTED_MODULE_1__["TokenBuilder"].addToken(sites.pdbx_auth_atom_id, _mol_io_reader_common_text_tokenizer__WEBPACK_IMPORTED_MODULE_1__["Tokenizer"].trim(data, s + 12, s + 16));
    // 17            Character     altLoc         Alternate location indicator
    if (str.charCodeAt(s + 16) === 32) { // ' '
        _mol_io_reader_common_text_tokenizer__WEBPACK_IMPORTED_MODULE_1__["TokenBuilder"].add(sites.pdbx_label_alt_id, 0, 0);
    }
    else {
        _mol_io_reader_common_text_tokenizer__WEBPACK_IMPORTED_MODULE_1__["TokenBuilder"].add(sites.pdbx_label_alt_id, s + 16, s + 17);
    }
    // 18 - 20       Residue name  resName        Residue name.
    _mol_io_reader_common_text_tokenizer__WEBPACK_IMPORTED_MODULE_1__["TokenBuilder"].addToken(sites.pdbx_auth_comp_id, _mol_io_reader_common_text_tokenizer__WEBPACK_IMPORTED_MODULE_1__["Tokenizer"].trim(data, s + 17, s + 20));
    // 22            Character     chainID        Chain identifier.
    _mol_io_reader_common_text_tokenizer__WEBPACK_IMPORTED_MODULE_1__["TokenBuilder"].add(sites.pdbx_auth_asym_id, s + 21, s + 22);
    // 23 - 26       Integer       resSeq         Residue sequence number.
    _mol_io_reader_common_text_tokenizer__WEBPACK_IMPORTED_MODULE_1__["TokenBuilder"].addToken(sites.pdbx_auth_seq_id, _mol_io_reader_common_text_tokenizer__WEBPACK_IMPORTED_MODULE_1__["Tokenizer"].trim(data, s + 22, s + 26));
    // 27            AChar         iCode          Insertion code.
    if (str.charCodeAt(s + 26) === 32) { // ' '
        _mol_io_reader_common_text_tokenizer__WEBPACK_IMPORTED_MODULE_1__["TokenBuilder"].add(sites.pdbx_PDB_ins_code, 0, 0);
    }
    else {
        _mol_io_reader_common_text_tokenizer__WEBPACK_IMPORTED_MODULE_1__["TokenBuilder"].add(sites.pdbx_PDB_ins_code, s + 26, s + 27);
    }
    // 29 - 35       Integer       u[0][0]        U(1,1)
    sites['U[1][1]'][sites.index] = Object(_mol_io_reader_common_text_number_parser__WEBPACK_IMPORTED_MODULE_3__["parseIntSkipLeadingWhitespace"])(str, s + 28, s + 35) / 10000;
    // 36 - 42       Integer       u[1][1]        U(2,2)
    sites['U[2][2]'][sites.index] = Object(_mol_io_reader_common_text_number_parser__WEBPACK_IMPORTED_MODULE_3__["parseIntSkipLeadingWhitespace"])(str, s + 35, s + 42) / 10000;
    // 43 - 49       Integer       u[2][2]        U(3,3)
    sites['U[3][3]'][sites.index] = Object(_mol_io_reader_common_text_number_parser__WEBPACK_IMPORTED_MODULE_3__["parseIntSkipLeadingWhitespace"])(str, s + 42, s + 49) / 10000;
    // 50 - 56       Integer       u[0][1]        U(1,2)
    sites['U[1][2]'][sites.index] = Object(_mol_io_reader_common_text_number_parser__WEBPACK_IMPORTED_MODULE_3__["parseIntSkipLeadingWhitespace"])(str, s + 49, s + 56) / 10000;
    // 57 - 63       Integer       u[0][2]        U(1,3)
    sites['U[1][3]'][sites.index] = Object(_mol_io_reader_common_text_number_parser__WEBPACK_IMPORTED_MODULE_3__["parseIntSkipLeadingWhitespace"])(str, s + 56, s + 63) / 10000;
    // 64 - 70       Integer       u[1][2]        U(2,3)
    sites['U[2][3]'][sites.index] = Object(_mol_io_reader_common_text_number_parser__WEBPACK_IMPORTED_MODULE_3__["parseIntSkipLeadingWhitespace"])(str, s + 63, s + 70) / 10000;
    // 77 - 78       LString(2)    element        Element symbol, right-justified.
    if (length >= 78) {
        _mol_io_reader_common_text_tokenizer__WEBPACK_IMPORTED_MODULE_1__["Tokenizer"].trim(data, s + 76, s + 78);
        if (data.tokenStart < data.tokenEnd) {
            _mol_io_reader_common_text_tokenizer__WEBPACK_IMPORTED_MODULE_1__["TokenBuilder"].addToken(sites.type_symbol, data);
        }
        else {
            Object(_util__WEBPACK_IMPORTED_MODULE_2__["guessElementSymbolTokens"])(sites.type_symbol, str, s + 12, s + 16);
        }
    }
    else {
        Object(_util__WEBPACK_IMPORTED_MODULE_2__["guessElementSymbolTokens"])(sites.type_symbol, str, s + 12, s + 16);
    }
    // 79 - 80       LString(2)    charge         Charge on the atom.
    // TODO
    sites.index++;
}
//# sourceMappingURL=anisotropic.js.map

/***/ }),

/***/ "./lib/mol-model-formats/structure/pdb/assembly.js":
/*!*********************************************************!*\
  !*** ./lib/mol-model-formats/structure/pdb/assembly.js ***!
  \*********************************************************/
/*! exports provided: parseCryst1, parseRemark350, parseMtrix */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "parseCryst1", function() { return parseCryst1; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "parseRemark350", function() { return parseRemark350; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "parseMtrix", function() { return parseMtrix; });
/* harmony import */ var _mol_io_reader_cif__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../../mol-io/reader/cif */ "./lib/mol-io/reader/cif.js");
/* harmony import */ var _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../../mol-math/linear-algebra */ "./lib/mol-math/linear-algebra.js");
/**
 * Copyright (c) 2019 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author David Sehnal <david.sehnal@gmail.com>
 */


function parseCryst1(id, record) {
    // COLUMNS       DATA TYPE      CONTENTS
    // --------------------------------------------------------------------------------
    //  1 -  6       Record name    "CRYST1"
    //  7 - 15       Real(9.3)      a (Angstroms)
    // 16 - 24       Real(9.3)      b (Angstroms)
    // 25 - 33       Real(9.3)      c (Angstroms)
    // 34 - 40       Real(7.2)      alpha (degrees)
    // 41 - 47       Real(7.2)      beta (degrees)
    // 48 - 54       Real(7.2)      gamma (degrees)
    // 56 - 66       LString        Space group
    // 67 - 70       Integer        Z value
    var get = function (s, l) { return (record.substr(s, l) || '').trim(); };
    var cell = {
        entry_id: _mol_io_reader_cif__WEBPACK_IMPORTED_MODULE_0__["CifField"].ofString(id),
        length_a: _mol_io_reader_cif__WEBPACK_IMPORTED_MODULE_0__["CifField"].ofString(get(6, 9)),
        length_b: _mol_io_reader_cif__WEBPACK_IMPORTED_MODULE_0__["CifField"].ofString(get(15, 9)),
        length_c: _mol_io_reader_cif__WEBPACK_IMPORTED_MODULE_0__["CifField"].ofString(get(24, 9)),
        angle_alpha: _mol_io_reader_cif__WEBPACK_IMPORTED_MODULE_0__["CifField"].ofString(get(33, 7)),
        angle_beta: _mol_io_reader_cif__WEBPACK_IMPORTED_MODULE_0__["CifField"].ofString(get(40, 7)),
        angle_gamma: _mol_io_reader_cif__WEBPACK_IMPORTED_MODULE_0__["CifField"].ofString(get(47, 7)),
        Z_PDB: _mol_io_reader_cif__WEBPACK_IMPORTED_MODULE_0__["CifField"].ofString(get(66, 4)),
        pdbx_unique_axis: _mol_io_reader_cif__WEBPACK_IMPORTED_MODULE_0__["CifField"].ofString('?')
    };
    var symmetry = {
        entry_id: _mol_io_reader_cif__WEBPACK_IMPORTED_MODULE_0__["CifField"].ofString(id),
        'space_group_name_H-M': _mol_io_reader_cif__WEBPACK_IMPORTED_MODULE_0__["CifField"].ofString(get(55, 11)),
        Int_Tables_number: _mol_io_reader_cif__WEBPACK_IMPORTED_MODULE_0__["CifField"].ofString('?'),
        cell_setting: _mol_io_reader_cif__WEBPACK_IMPORTED_MODULE_0__["CifField"].ofString('?'),
        space_group_name_Hall: _mol_io_reader_cif__WEBPACK_IMPORTED_MODULE_0__["CifField"].ofString('?')
    };
    return [_mol_io_reader_cif__WEBPACK_IMPORTED_MODULE_0__["CifCategory"].ofFields('cell', cell), _mol_io_reader_cif__WEBPACK_IMPORTED_MODULE_0__["CifCategory"].ofFields('symmetry', symmetry)];
}
function PdbAssembly(id, details) {
    return { id: id, details: details, groups: [] };
}
function parseRemark350(lines, lineStart, lineEnd) {
    var assemblies = [];
    // Read the assemblies
    var current, group, matrix, operId = 1, asmId = 1;
    var getLine = function (n) { return lines.data.substring(lines.indices[2 * n], lines.indices[2 * n + 1]); };
    for (var i = lineStart; i < lineEnd; i++) {
        var line = getLine(i);
        if (line.substr(11, 12) === 'BIOMOLECULE:') {
            var id = line.substr(23).trim();
            var details = "Biomolecule " + id;
            line = getLine(i + 1);
            if (line.substr(11, 30) !== 'APPLY THE FOLLOWING TO CHAINS:') {
                i++;
                details = line.substr(11).trim();
            }
            current = PdbAssembly(id, details);
            assemblies.push(current);
        }
        else if (line.substr(13, 5) === 'BIOMT') {
            var biomt = line.split(/\s+/);
            var row = parseInt(line[18]) - 1;
            if (row === 0) {
                matrix = _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_1__["Mat4"].identity();
                group.operators.push({ id: operId++, matrix: matrix });
            }
            _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_1__["Mat4"].setValue(matrix, row, 0, parseFloat(biomt[4]));
            _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_1__["Mat4"].setValue(matrix, row, 1, parseFloat(biomt[5]));
            _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_1__["Mat4"].setValue(matrix, row, 2, parseFloat(biomt[6]));
            _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_1__["Mat4"].setValue(matrix, row, 3, parseFloat(biomt[7]));
        }
        else if (line.substr(11, 30) === 'APPLY THE FOLLOWING TO CHAINS:' ||
            line.substr(11, 30) === '                   AND CHAINS:') {
            if (line.substr(11, 5) === 'APPLY') {
                group = { chains: [], operators: [] };
                current.groups.push(group);
            }
            var chainList = line.substr(41, 30).split(',');
            for (var j = 0, jl = chainList.length; j < jl; ++j) {
                var c = chainList[j].trim();
                if (c)
                    group.chains.push(c);
            }
        }
        else if (line.substr(11, 33) === 'APPLYING THE FOLLOWING TO CHAINS:') {
            // variant in older PDB format version
            current = PdbAssembly("" + asmId, "Biomolecule " + asmId);
            assemblies.push(current);
            asmId += 1;
            group = { chains: [], operators: [] };
            current.groups.push(group);
            i++;
            line = getLine(i);
            var chainList = line.substr(11, 69).split(',');
            for (var j = 0, jl = chainList.length; j < jl; ++j) {
                var c = chainList[j].trim();
                if (c)
                    group.chains.push(c);
            }
        }
    }
    if (assemblies.length === 0)
        return [];
    // Generate CIF
    // pdbx_struct_assembly
    var pdbx_struct_assembly = {
        id: _mol_io_reader_cif__WEBPACK_IMPORTED_MODULE_0__["CifField"].ofStrings(assemblies.map(function (a) { return a.id; })),
        details: _mol_io_reader_cif__WEBPACK_IMPORTED_MODULE_0__["CifField"].ofStrings(assemblies.map(function (a) { return a.details; }))
    };
    // pdbx_struct_assembly_gen
    var pdbx_struct_assembly_gen_rows = [];
    for (var _i = 0, assemblies_1 = assemblies; _i < assemblies_1.length; _i++) {
        var asm = assemblies_1[_i];
        for (var _a = 0, _b = asm.groups; _a < _b.length; _a++) {
            var group_1 = _b[_a];
            pdbx_struct_assembly_gen_rows.push({
                assembly_id: asm.id,
                oper_expression: group_1.operators.map(function (o) { return o.id; }).join(','),
                asym_id_list: group_1.chains.join(',')
            });
        }
    }
    var pdbx_struct_assembly_gen = {
        assembly_id: _mol_io_reader_cif__WEBPACK_IMPORTED_MODULE_0__["CifField"].ofStrings(pdbx_struct_assembly_gen_rows.map(function (r) { return r.assembly_id; })),
        oper_expression: _mol_io_reader_cif__WEBPACK_IMPORTED_MODULE_0__["CifField"].ofStrings(pdbx_struct_assembly_gen_rows.map(function (r) { return r.oper_expression; })),
        asym_id_list: _mol_io_reader_cif__WEBPACK_IMPORTED_MODULE_0__["CifField"].ofStrings(pdbx_struct_assembly_gen_rows.map(function (r) { return r.asym_id_list; }))
    };
    // pdbx_struct_oper_list
    var pdbx_struct_oper_list_rows = [];
    for (var _c = 0, assemblies_2 = assemblies; _c < assemblies_2.length; _c++) {
        var asm = assemblies_2[_c];
        for (var _d = 0, _e = asm.groups; _d < _e.length; _d++) {
            var group_2 = _e[_d];
            for (var _f = 0, _g = group_2.operators; _f < _g.length; _f++) {
                var oper = _g[_f];
                var row = {
                    id: '' + oper.id,
                    type: '?',
                    name: '?',
                    symmetry_operation: '?'
                };
                for (var i = 0; i < 3; i++) {
                    for (var j = 0; j < 3; j++) {
                        row["matrix[" + (i + 1) + "][" + (j + 1) + "]"] = '' + _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_1__["Mat4"].getValue(oper.matrix, i, j);
                    }
                    row["vector[" + (i + 1) + "]"] = '' + _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_1__["Mat4"].getValue(oper.matrix, i, 3);
                }
                pdbx_struct_oper_list_rows.push(row);
            }
        }
    }
    var pdbx_struct_oper_list = {
        id: _mol_io_reader_cif__WEBPACK_IMPORTED_MODULE_0__["CifField"].ofStrings(pdbx_struct_oper_list_rows.map(function (r) { return r.id; })),
        type: _mol_io_reader_cif__WEBPACK_IMPORTED_MODULE_0__["CifField"].ofStrings(pdbx_struct_oper_list_rows.map(function (r) { return r.type; })),
        name: _mol_io_reader_cif__WEBPACK_IMPORTED_MODULE_0__["CifField"].ofStrings(pdbx_struct_oper_list_rows.map(function (r) { return r.name; })),
        symmetry_operation: _mol_io_reader_cif__WEBPACK_IMPORTED_MODULE_0__["CifField"].ofStrings(pdbx_struct_oper_list_rows.map(function (r) { return r.symmetry_operation; }))
    };
    var _loop_1 = function (i) {
        var _loop_2 = function (j) {
            var k_1 = "matrix[" + (i + 1) + "][" + (j + 1) + "]";
            pdbx_struct_oper_list[k_1] = _mol_io_reader_cif__WEBPACK_IMPORTED_MODULE_0__["CifField"].ofStrings(pdbx_struct_oper_list_rows.map(function (r) { return r[k_1]; }));
        };
        for (var j = 0; j < 3; j++) {
            _loop_2(j);
        }
        var k = "vector[" + (i + 1) + "]";
        pdbx_struct_oper_list[k] = _mol_io_reader_cif__WEBPACK_IMPORTED_MODULE_0__["CifField"].ofStrings(pdbx_struct_oper_list_rows.map(function (r) { return r[k]; }));
    };
    for (var i = 0; i < 3; i++) {
        _loop_1(i);
    }
    return [
        _mol_io_reader_cif__WEBPACK_IMPORTED_MODULE_0__["CifCategory"].ofFields('pdbx_struct_assembly', pdbx_struct_assembly),
        _mol_io_reader_cif__WEBPACK_IMPORTED_MODULE_0__["CifCategory"].ofFields('pdbx_struct_assembly_gen', pdbx_struct_assembly_gen),
        _mol_io_reader_cif__WEBPACK_IMPORTED_MODULE_0__["CifCategory"].ofFields('pdbx_struct_oper_list', pdbx_struct_oper_list)
    ];
}
function parseMtrix(lines, lineStart, lineEnd) {
    var matrices = [];
    var matrix;
    var getLine = function (n) { return lines.data.substring(lines.indices[2 * n], lines.indices[2 * n + 1]); };
    for (var i = lineStart; i < lineEnd; i++) {
        var line = getLine(i);
        var ncs = line.split(/\s+/);
        var row = parseInt(line[5]) - 1;
        if (row === 0) {
            matrix = _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_1__["Mat4"].identity();
            matrices.push(matrix);
        }
        _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_1__["Mat4"].setValue(matrix, row, 0, parseFloat(ncs[2]));
        _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_1__["Mat4"].setValue(matrix, row, 1, parseFloat(ncs[3]));
        _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_1__["Mat4"].setValue(matrix, row, 2, parseFloat(ncs[4]));
        _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_1__["Mat4"].setValue(matrix, row, 3, parseFloat(ncs[5]));
    }
    if (matrices.length === 0)
        return [];
    var struct_ncs_oper_rows = [];
    var id = 1;
    for (var _i = 0, matrices_1 = matrices; _i < matrices_1.length; _i++) {
        var oper = matrices_1[_i];
        var row = {
            id: 'ncsop' + (id++),
            code: '.',
            details: '.'
        };
        for (var i = 0; i < 3; i++) {
            for (var j = 0; j < 3; j++) {
                row["matrix[" + (i + 1) + "][" + (j + 1) + "]"] = '' + _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_1__["Mat4"].getValue(oper, i, j);
            }
            row["vector[" + (i + 1) + "]"] = '' + _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_1__["Mat4"].getValue(oper, i, 3);
        }
        struct_ncs_oper_rows.push(row);
    }
    var struct_ncs_oper = {
        id: _mol_io_reader_cif__WEBPACK_IMPORTED_MODULE_0__["CifField"].ofStrings(struct_ncs_oper_rows.map(function (r) { return r.id; })),
        code: _mol_io_reader_cif__WEBPACK_IMPORTED_MODULE_0__["CifField"].ofStrings(struct_ncs_oper_rows.map(function (r) { return r.code; })),
        details: _mol_io_reader_cif__WEBPACK_IMPORTED_MODULE_0__["CifField"].ofStrings(struct_ncs_oper_rows.map(function (r) { return r.details; })),
    };
    var _loop_3 = function (i) {
        var _loop_4 = function (j) {
            var k_2 = "matrix[" + (i + 1) + "][" + (j + 1) + "]";
            struct_ncs_oper[k_2] = _mol_io_reader_cif__WEBPACK_IMPORTED_MODULE_0__["CifField"].ofStrings(struct_ncs_oper_rows.map(function (r) { return r[k_2]; }));
        };
        for (var j = 0; j < 3; j++) {
            _loop_4(j);
        }
        var k = "vector[" + (i + 1) + "]";
        struct_ncs_oper[k] = _mol_io_reader_cif__WEBPACK_IMPORTED_MODULE_0__["CifField"].ofStrings(struct_ncs_oper_rows.map(function (r) { return r[k]; }));
    };
    for (var i = 0; i < 3; i++) {
        _loop_3(i);
    }
    return [_mol_io_reader_cif__WEBPACK_IMPORTED_MODULE_0__["CifCategory"].ofFields('struct_ncs_oper', struct_ncs_oper)];
}
//# sourceMappingURL=assembly.js.map

/***/ }),

/***/ "./lib/mol-model-formats/structure/pdb/atom-site.js":
/*!**********************************************************!*\
  !*** ./lib/mol-model-formats/structure/pdb/atom-site.js ***!
  \**********************************************************/
/*! exports provided: getAtomSiteTemplate, getAtomSite, addAtom */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getAtomSiteTemplate", function() { return getAtomSiteTemplate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getAtomSite", function() { return getAtomSite; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "addAtom", function() { return addAtom; });
/* harmony import */ var _mol_io_reader_cif__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../../mol-io/reader/cif */ "./lib/mol-io/reader/cif.js");
/* harmony import */ var _mol_io_reader_common_text_tokenizer__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../../mol-io/reader/common/text/tokenizer */ "./lib/mol-io/reader/common/text/tokenizer.js");
/* harmony import */ var _util__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../util */ "./lib/mol-model-formats/structure/util.js");
/* harmony import */ var _mol_data_db__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../../mol-data/db */ "./lib/mol-data/db.js");
/**
 * Copyright (c) 2019-2020 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author David Sehnal <david.sehnal@gmail.com>
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */




function getAtomSiteTemplate(data, count) {
    var str = function () { return []; };
    var ts = function () { return _mol_io_reader_common_text_tokenizer__WEBPACK_IMPORTED_MODULE_1__["TokenBuilder"].create(data, 2 * count); };
    return {
        index: 0,
        group_PDB: ts(),
        id: str(),
        auth_atom_id: ts(),
        label_alt_id: ts(),
        auth_comp_id: ts(),
        auth_asym_id: ts(),
        auth_seq_id: ts(),
        pdbx_PDB_ins_code: ts(),
        Cartn_x: ts(),
        Cartn_y: ts(),
        Cartn_z: ts(),
        occupancy: ts(),
        B_iso_or_equiv: ts(),
        type_symbol: ts(),
        pdbx_PDB_model_num: str(),
        label_entity_id: str(),
        partial_charge: ts(),
    };
}
function getAtomSite(sites) {
    var auth_asym_id = _mol_io_reader_cif__WEBPACK_IMPORTED_MODULE_0__["CifField"].ofTokens(sites.auth_asym_id);
    var auth_atom_id = _mol_io_reader_cif__WEBPACK_IMPORTED_MODULE_0__["CifField"].ofTokens(sites.auth_atom_id);
    var auth_comp_id = _mol_io_reader_cif__WEBPACK_IMPORTED_MODULE_0__["CifField"].ofTokens(sites.auth_comp_id);
    return {
        auth_asym_id: auth_asym_id,
        auth_atom_id: auth_atom_id,
        auth_comp_id: auth_comp_id,
        auth_seq_id: _mol_io_reader_cif__WEBPACK_IMPORTED_MODULE_0__["CifField"].ofTokens(sites.auth_seq_id),
        B_iso_or_equiv: _mol_io_reader_cif__WEBPACK_IMPORTED_MODULE_0__["CifField"].ofTokens(sites.B_iso_or_equiv),
        Cartn_x: _mol_io_reader_cif__WEBPACK_IMPORTED_MODULE_0__["CifField"].ofTokens(sites.Cartn_x),
        Cartn_y: _mol_io_reader_cif__WEBPACK_IMPORTED_MODULE_0__["CifField"].ofTokens(sites.Cartn_y),
        Cartn_z: _mol_io_reader_cif__WEBPACK_IMPORTED_MODULE_0__["CifField"].ofTokens(sites.Cartn_z),
        group_PDB: _mol_io_reader_cif__WEBPACK_IMPORTED_MODULE_0__["CifField"].ofTokens(sites.group_PDB),
        id: _mol_io_reader_cif__WEBPACK_IMPORTED_MODULE_0__["CifField"].ofStrings(sites.id),
        label_alt_id: _mol_io_reader_cif__WEBPACK_IMPORTED_MODULE_0__["CifField"].ofTokens(sites.label_alt_id),
        label_asym_id: auth_asym_id,
        label_atom_id: auth_atom_id,
        label_comp_id: auth_comp_id,
        label_seq_id: _mol_io_reader_cif__WEBPACK_IMPORTED_MODULE_0__["CifField"].ofUndefined(sites.index, _mol_data_db__WEBPACK_IMPORTED_MODULE_3__["Column"].Schema.int),
        label_entity_id: _mol_io_reader_cif__WEBPACK_IMPORTED_MODULE_0__["CifField"].ofStrings(sites.label_entity_id),
        occupancy: _mol_io_reader_cif__WEBPACK_IMPORTED_MODULE_0__["CifField"].ofTokens(sites.occupancy),
        type_symbol: _mol_io_reader_cif__WEBPACK_IMPORTED_MODULE_0__["CifField"].ofTokens(sites.type_symbol),
        pdbx_PDB_ins_code: _mol_io_reader_cif__WEBPACK_IMPORTED_MODULE_0__["CifField"].ofTokens(sites.pdbx_PDB_ins_code),
        pdbx_PDB_model_num: _mol_io_reader_cif__WEBPACK_IMPORTED_MODULE_0__["CifField"].ofStrings(sites.pdbx_PDB_model_num),
        partial_charge: _mol_io_reader_cif__WEBPACK_IMPORTED_MODULE_0__["CifField"].ofTokens(sites.partial_charge)
    };
}
function addAtom(sites, model, data, s, e, isPdbqt) {
    var str = data.data;
    var length = e - s;
    // TODO: filter invalid atoms
    // COLUMNS        DATA TYPE       CONTENTS
    // --------------------------------------------------------------------------------
    // 1 -  6        Record name     "ATOM  "
    _mol_io_reader_common_text_tokenizer__WEBPACK_IMPORTED_MODULE_1__["TokenBuilder"].addToken(sites.group_PDB, _mol_io_reader_common_text_tokenizer__WEBPACK_IMPORTED_MODULE_1__["Tokenizer"].trim(data, s, s + 6));
    // 7 - 11        Integer         Atom serial number.
    // TODO: support HEX
    _mol_io_reader_common_text_tokenizer__WEBPACK_IMPORTED_MODULE_1__["Tokenizer"].trim(data, s + 6, s + 11);
    sites.id[sites.index] = data.data.substring(data.tokenStart, data.tokenEnd);
    // 13 - 16        Atom            Atom name.
    _mol_io_reader_common_text_tokenizer__WEBPACK_IMPORTED_MODULE_1__["TokenBuilder"].addToken(sites.auth_atom_id, _mol_io_reader_common_text_tokenizer__WEBPACK_IMPORTED_MODULE_1__["Tokenizer"].trim(data, s + 12, s + 16));
    // 17             Character       Alternate location indicator.
    if (str.charCodeAt(s + 16) === 32) { // ' '
        _mol_io_reader_common_text_tokenizer__WEBPACK_IMPORTED_MODULE_1__["TokenBuilder"].add(sites.label_alt_id, 0, 0);
    }
    else {
        _mol_io_reader_common_text_tokenizer__WEBPACK_IMPORTED_MODULE_1__["TokenBuilder"].add(sites.label_alt_id, s + 16, s + 17);
    }
    // 18 - 20        Residue name    Residue name.
    _mol_io_reader_common_text_tokenizer__WEBPACK_IMPORTED_MODULE_1__["TokenBuilder"].addToken(sites.auth_comp_id, _mol_io_reader_common_text_tokenizer__WEBPACK_IMPORTED_MODULE_1__["Tokenizer"].trim(data, s + 17, s + 20));
    // 22             Character       Chain identifier.
    _mol_io_reader_common_text_tokenizer__WEBPACK_IMPORTED_MODULE_1__["TokenBuilder"].add(sites.auth_asym_id, s + 21, s + 22);
    // 23 - 26        Integer         Residue sequence number.
    // TODO: support HEX
    _mol_io_reader_common_text_tokenizer__WEBPACK_IMPORTED_MODULE_1__["TokenBuilder"].addToken(sites.auth_seq_id, _mol_io_reader_common_text_tokenizer__WEBPACK_IMPORTED_MODULE_1__["Tokenizer"].trim(data, s + 22, s + 26));
    // 27             AChar           Code for insertion of residues.
    if (str.charCodeAt(s + 26) === 32) { // ' '
        _mol_io_reader_common_text_tokenizer__WEBPACK_IMPORTED_MODULE_1__["TokenBuilder"].add(sites.pdbx_PDB_ins_code, 0, 0);
    }
    else {
        _mol_io_reader_common_text_tokenizer__WEBPACK_IMPORTED_MODULE_1__["TokenBuilder"].add(sites.pdbx_PDB_ins_code, s + 26, s + 27);
    }
    // 31 - 38        Real(8.3)       Orthogonal coordinates for X in Angstroms.
    _mol_io_reader_common_text_tokenizer__WEBPACK_IMPORTED_MODULE_1__["TokenBuilder"].addToken(sites.Cartn_x, _mol_io_reader_common_text_tokenizer__WEBPACK_IMPORTED_MODULE_1__["Tokenizer"].trim(data, s + 30, s + 38));
    // 39 - 46        Real(8.3)       Orthogonal coordinates for Y in Angstroms.
    _mol_io_reader_common_text_tokenizer__WEBPACK_IMPORTED_MODULE_1__["TokenBuilder"].addToken(sites.Cartn_y, _mol_io_reader_common_text_tokenizer__WEBPACK_IMPORTED_MODULE_1__["Tokenizer"].trim(data, s + 38, s + 46));
    // 47 - 54        Real(8.3)       Orthogonal coordinates for Z in Angstroms.
    _mol_io_reader_common_text_tokenizer__WEBPACK_IMPORTED_MODULE_1__["TokenBuilder"].addToken(sites.Cartn_z, _mol_io_reader_common_text_tokenizer__WEBPACK_IMPORTED_MODULE_1__["Tokenizer"].trim(data, s + 46, s + 54));
    // 55 - 60        Real(6.2)       Occupancy.
    _mol_io_reader_common_text_tokenizer__WEBPACK_IMPORTED_MODULE_1__["TokenBuilder"].addToken(sites.occupancy, _mol_io_reader_common_text_tokenizer__WEBPACK_IMPORTED_MODULE_1__["Tokenizer"].trim(data, s + 54, s + 60));
    // 61 - 66        Real(6.2)       Temperature factor (Default = 0.0).
    if (length >= 66) {
        _mol_io_reader_common_text_tokenizer__WEBPACK_IMPORTED_MODULE_1__["TokenBuilder"].addToken(sites.B_iso_or_equiv, _mol_io_reader_common_text_tokenizer__WEBPACK_IMPORTED_MODULE_1__["Tokenizer"].trim(data, s + 60, s + 66));
    }
    else {
        _mol_io_reader_common_text_tokenizer__WEBPACK_IMPORTED_MODULE_1__["TokenBuilder"].add(sites.B_iso_or_equiv, 0, 0);
    }
    // 73 - 76        LString(4)      Segment identifier, left-justified.
    if (isPdbqt) {
        _mol_io_reader_common_text_tokenizer__WEBPACK_IMPORTED_MODULE_1__["TokenBuilder"].addToken(sites.partial_charge, _mol_io_reader_common_text_tokenizer__WEBPACK_IMPORTED_MODULE_1__["Tokenizer"].trim(data, s + 70, s + 76));
    }
    else {
        // ignored
    }
    // 77 - 78        LString(2)      Element symbol, right-justified.
    if (length >= 78 && !isPdbqt) {
        _mol_io_reader_common_text_tokenizer__WEBPACK_IMPORTED_MODULE_1__["Tokenizer"].trim(data, s + 76, s + 78);
        if (data.tokenStart < data.tokenEnd) {
            _mol_io_reader_common_text_tokenizer__WEBPACK_IMPORTED_MODULE_1__["TokenBuilder"].addToken(sites.type_symbol, data);
        }
        else {
            Object(_util__WEBPACK_IMPORTED_MODULE_2__["guessElementSymbolTokens"])(sites.type_symbol, str, s + 12, s + 16);
        }
    }
    else {
        Object(_util__WEBPACK_IMPORTED_MODULE_2__["guessElementSymbolTokens"])(sites.type_symbol, str, s + 12, s + 16);
    }
    // 79 - 80        LString(2)    charge       Charge  on the atom.
    // TODO
    sites.pdbx_PDB_model_num[sites.index] = model;
    sites.index++;
}
//# sourceMappingURL=atom-site.js.map

/***/ }),

/***/ "./lib/mol-model-formats/structure/pdb/conect.js":
/*!*******************************************************!*\
  !*** ./lib/mol-model-formats/structure/pdb/conect.js ***!
  \*******************************************************/
/*! exports provided: parseConect */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "parseConect", function() { return parseConect; });
/* harmony import */ var _mol_io_reader_cif__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../../mol-io/reader/cif */ "./lib/mol-io/reader/cif.js");
/**
 * Copyright (c) 2021 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */

function parseConect(lines, lineStart, lineEnd, sites) {
    var idMap = {};
    for (var i = 0, il = sites.id.rowCount; i < il; ++i) {
        idMap[sites.id.str(i)] = i;
    }
    var getLine = function (n) { return lines.data.substring(lines.indices[2 * n], lines.indices[2 * n + 1]); };
    var id = [];
    var conn_type_id = [];
    var ptnr1_label_asym_id = [];
    var ptnr1_label_seq_id = [];
    var ptnr1_auth_seq_id = [];
    var ptnr1_label_atom_id = [];
    var ptnr2_label_asym_id = [];
    var ptnr2_label_seq_id = [];
    var ptnr2_auth_seq_id = [];
    var ptnr2_label_atom_id = [];
    var pos = [11, 16, 21, 26];
    var k = 1;
    for (var i = lineStart; i < lineEnd; i++) {
        var line = getLine(i);
        var idxA = idMap[parseInt(line.substr(6, 5))];
        var bondIndex = {};
        if (idxA === undefined)
            continue;
        for (var j = 0; j < 4; ++j) {
            var idB = parseInt(line.substr(pos[j], 5));
            if (Number.isNaN(idB))
                continue;
            var idxB = idMap[idB];
            if (idxB === undefined)
                continue;
            if (idxA > idxB)
                continue;
            // TODO: interpret records where a 'idxB' atom is given multiple times
            // as double/triple bonds, e.g. CONECT 1529 1528 1528 is a double bond
            if (bondIndex[idxB] !== undefined)
                continue;
            id.push("covale" + k);
            conn_type_id.push('covale');
            ptnr1_label_asym_id.push(sites.label_asym_id.str(idxA));
            ptnr1_auth_seq_id.push(sites.auth_seq_id.int(idxA));
            ptnr1_label_seq_id.push(sites.label_seq_id.int(idxA));
            ptnr1_label_atom_id.push(sites.label_atom_id.str(idxA));
            ptnr2_label_asym_id.push(sites.label_asym_id.str(idxB));
            ptnr2_auth_seq_id.push(sites.auth_seq_id.int(idxB));
            ptnr2_label_seq_id.push(sites.label_seq_id.int(idxB));
            ptnr2_label_atom_id.push(sites.label_atom_id.str(idxB));
            k += 1;
        }
    }
    var struct_conn = {
        id: _mol_io_reader_cif__WEBPACK_IMPORTED_MODULE_0__["CifField"].ofStrings(id),
        conn_type_id: _mol_io_reader_cif__WEBPACK_IMPORTED_MODULE_0__["CifField"].ofStrings(conn_type_id),
        ptnr1_label_asym_id: _mol_io_reader_cif__WEBPACK_IMPORTED_MODULE_0__["CifField"].ofStrings(ptnr1_label_asym_id),
        ptnr1_auth_seq_id: _mol_io_reader_cif__WEBPACK_IMPORTED_MODULE_0__["CifField"].ofNumbers(ptnr1_auth_seq_id),
        ptnr1_label_seq_id: _mol_io_reader_cif__WEBPACK_IMPORTED_MODULE_0__["CifField"].ofNumbers(ptnr1_label_seq_id),
        ptnr1_label_atom_id: _mol_io_reader_cif__WEBPACK_IMPORTED_MODULE_0__["CifField"].ofStrings(ptnr1_label_atom_id),
        ptnr2_label_asym_id: _mol_io_reader_cif__WEBPACK_IMPORTED_MODULE_0__["CifField"].ofStrings(ptnr2_label_asym_id),
        ptnr2_label_seq_id: _mol_io_reader_cif__WEBPACK_IMPORTED_MODULE_0__["CifField"].ofNumbers(ptnr2_label_seq_id),
        ptnr2_auth_seq_id: _mol_io_reader_cif__WEBPACK_IMPORTED_MODULE_0__["CifField"].ofNumbers(ptnr2_auth_seq_id),
        ptnr2_label_atom_id: _mol_io_reader_cif__WEBPACK_IMPORTED_MODULE_0__["CifField"].ofStrings(ptnr2_label_atom_id),
    };
    return _mol_io_reader_cif__WEBPACK_IMPORTED_MODULE_0__["CifCategory"].ofFields('struct_conn', struct_conn);
}
//# sourceMappingURL=conect.js.map

/***/ }),

/***/ "./lib/mol-model-formats/structure/pdb/entity.js":
/*!*******************************************************!*\
  !*** ./lib/mol-model-formats/structure/pdb/entity.js ***!
  \*******************************************************/
/*! exports provided: parseCmpnd, parseHetnam */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "parseCmpnd", function() { return parseCmpnd; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "parseHetnam", function() { return parseHetnam; });
/**
 * Copyright (c) 2019 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */
var Spec = {
    'MOL_ID': '',
    'MOLECULE': '',
    'CHAIN': '',
    'FRAGMENT': '',
    'SYNONYM': '',
    'EC': '',
    'ENGINEERED': '',
    'MUTATION': '',
    'OTHER_DETAILS': ''
};
function parseCmpnd(lines, lineStart, lineEnd) {
    var getLine = function (n) { return lines.data.substring(lines.indices[2 * n], lines.indices[2 * n + 1]); };
    var currentSpec;
    var currentCompound = { chains: [], description: '' };
    var Compounds = [];
    for (var i = lineStart; i < lineEnd; i++) {
        var line = getLine(i);
        // COLUMNS       DATA TYPE       FIELD         DEFINITION
        // ----------------------------------------------------------------------------------
        //  1 -  6       Record name     "COMPND"
        //  8 - 10       Continuation    continuation  Allows concatenation of multiple records.
        // 11 - 80       Specification   compound      Description of the molecular components.
        //               list
        var cmpnd = line.substr(10, 70).trim();
        var cmpndSpecEnd = cmpnd.indexOf(':');
        var cmpndSpec = cmpnd.substring(0, cmpndSpecEnd);
        var value = void 0;
        if (cmpndSpec in Spec) {
            currentSpec = cmpndSpec;
            value = cmpnd.substring(cmpndSpecEnd + 2);
        }
        else {
            value = cmpnd;
        }
        value = value.replace(/;$/, '');
        if (currentSpec === 'MOL_ID') {
            currentCompound = {
                chains: [],
                description: ''
            };
            Compounds.push(currentCompound);
        }
        else if (currentSpec === 'MOLECULE') {
            if (currentCompound.description)
                currentCompound.description += ' ';
            currentCompound.description += value;
        }
        else if (currentSpec === 'CHAIN') {
            Array.prototype.push.apply(currentCompound.chains, value.split(/\s*,\s*/));
        }
    }
    return Compounds;
}
function parseHetnam(lines, lineStart, lineEnd) {
    var getLine = function (n) { return lines.data.substring(lines.indices[2 * n], lines.indices[2 * n + 1]); };
    var hetnams = new Map();
    for (var i = lineStart; i < lineEnd; i++) {
        var line = getLine(i);
        // COLUMNS       DATA  TYPE    FIELD           DEFINITION
        // ----------------------------------------------------------------------------
        //  1 -  6       Record name   "HETNAM"
        //  9 - 10       Continuation  continuation    Allows concatenation of multiple records.
        // 12 - 14       LString(3)    hetID           Het identifier, right-justified.
        // 16 - 70       String        text            Chemical name.
        var het = line.substr(11, 3).trim();
        var name_1 = line.substr(15).trim();
        if (hetnams.has(het)) {
            hetnams.set(het, hetnams.get(het) + " " + name_1);
        }
        else {
            hetnams.set(het, name_1);
        }
    }
    return hetnams;
}
//# sourceMappingURL=entity.js.map

/***/ }),

/***/ "./lib/mol-model-formats/structure/pdb/secondary-structure.js":
/*!********************************************************************!*\
  !*** ./lib/mol-model-formats/structure/pdb/secondary-structure.js ***!
  \********************************************************************/
/*! exports provided: parseHelix, parseSheet */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "parseHelix", function() { return parseHelix; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "parseSheet", function() { return parseSheet; });
/* harmony import */ var _mol_io_reader_cif__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../../mol-io/reader/cif */ "./lib/mol-io/reader/cif.js");
/* harmony import */ var _mol_data_db__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../../mol-data/db */ "./lib/mol-data/db.js");
/**
 * Copyright (c) 2019 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */


var HelixTypes = {
    // CLASS NUMBER
    // TYPE OF  HELIX                     (COLUMNS 39 - 40)
    // --------------------------------------------------------------
    // Right-handed alpha (default)                1
    // Right-handed omega                          2
    // Right-handed pi                             3
    // Right-handed gamma                          4
    // Right-handed 3 - 10                         5
    // Left-handed alpha                           6
    // Left-handed omega                           7
    // Left-handed gamma                           8
    // 2 - 7 ribbon/helix                          9
    // Polyproline                                10
    1: 'HELX_RH_AL_P',
    2: 'HELX_RH_OM_P',
    3: 'HELX_RH_PI_P',
    4: 'HELX_RH_GA_P',
    5: 'HELX_RH_3T_P',
    6: 'HELX_LH_AL_P',
    7: 'HELX_LH_OM_P',
    8: 'HELX_LH_GA_P',
    9: 'HELX_RH_27_P',
    10: 'HELX_RH_PP_P',
};
function getStructConfTypeId(type) {
    return HelixTypes[type] || 'HELX_P';
}
function parseHelix(lines, lineStart, lineEnd) {
    var helices = [];
    var getLine = function (n) { return lines.data.substring(lines.indices[2 * n], lines.indices[2 * n + 1]); };
    for (var i = lineStart; i < lineEnd; i++) {
        var line = getLine(i);
        // COLUMNS        DATA  TYPE     FIELD         DEFINITION
        // -----------------------------------------------------------------------------------
        // 1 -  6        Record name    "HELIX "
        // 8 - 10        Integer        serNum        Serial number of the helix. This starts
        //                                             at 1  and increases incrementally.
        // 12 - 14        LString(3)     helixID       Helix  identifier. In addition to a serial
        //                                             number, each helix is given an
        //                                             alphanumeric character helix identifier.
        // 16 - 18        Residue name   initResName   Name of the initial residue.
        // 20             Character      initChainID   Chain identifier for the chain containing
        //                                             this  helix.
        // 22 - 25        Integer        initSeqNum    Sequence number of the initial residue.
        // 26             AChar          initICode     Insertion code of the initial residue.
        // 28 - 30        Residue  name  endResName    Name of the terminal residue of the helix.
        // 32             Character      endChainID    Chain identifier for the chain containing
        //                                             this  helix.
        // 34 - 37        Integer        endSeqNum     Sequence number of the terminal residue.
        // 38             AChar          endICode      Insertion code of the terminal residue.
        // 39 - 40        Integer        helixClass    Helix class (see below).
        // 41 - 70        String         comment       Comment about this helix.
        // 72 - 76        Integer        length        Length of this helix.
        helices.push({
            serNum: line.substr(7, 3).trim(),
            helixID: line.substr(11, 3).trim(),
            initResName: line.substr(15, 3).trim(),
            initChainID: line.substr(19, 1).trim(),
            initSeqNum: line.substr(21, 4).trim(),
            initICode: line.substr(25, 1).trim(),
            endResName: line.substr(27, 3).trim(),
            endChainID: line.substr(31, 3).trim(),
            endSeqNum: line.substr(33, 4).trim(),
            endICode: line.substr(37, 1).trim(),
            helixClass: line.substr(38, 2).trim(),
            comment: line.substr(40, 30).trim(),
            length: line.substr(71, 5).trim()
        });
    }
    var beg_auth_asym_id = _mol_io_reader_cif__WEBPACK_IMPORTED_MODULE_0__["CifField"].ofStrings(helices.map(function (h) { return h.initChainID; }));
    var beg_auth_comp_id = _mol_io_reader_cif__WEBPACK_IMPORTED_MODULE_0__["CifField"].ofStrings(helices.map(function (h) { return h.initResName; }));
    var end_auth_asym_id = _mol_io_reader_cif__WEBPACK_IMPORTED_MODULE_0__["CifField"].ofStrings(helices.map(function (h) { return h.endChainID; }));
    var end_auth_comp_id = _mol_io_reader_cif__WEBPACK_IMPORTED_MODULE_0__["CifField"].ofStrings(helices.map(function (h) { return h.endResName; }));
    ;
    var struct_conf = {
        beg_label_asym_id: beg_auth_asym_id,
        beg_label_comp_id: beg_auth_comp_id,
        beg_label_seq_id: _mol_io_reader_cif__WEBPACK_IMPORTED_MODULE_0__["CifField"].ofUndefined(helices.length, _mol_data_db__WEBPACK_IMPORTED_MODULE_1__["Column"].Schema.int),
        beg_auth_asym_id: beg_auth_asym_id,
        beg_auth_comp_id: beg_auth_comp_id,
        beg_auth_seq_id: _mol_io_reader_cif__WEBPACK_IMPORTED_MODULE_0__["CifField"].ofStrings(helices.map(function (h) { return h.initSeqNum; })),
        conf_type_id: _mol_io_reader_cif__WEBPACK_IMPORTED_MODULE_0__["CifField"].ofStrings(helices.map(function (h) { return getStructConfTypeId(h.helixClass); })),
        details: _mol_io_reader_cif__WEBPACK_IMPORTED_MODULE_0__["CifField"].ofStrings(helices.map(function (h) { return h.comment; })),
        end_label_asym_id: end_auth_asym_id,
        end_label_comp_id: end_auth_comp_id,
        end_label_seq_id: _mol_io_reader_cif__WEBPACK_IMPORTED_MODULE_0__["CifField"].ofUndefined(helices.length, _mol_data_db__WEBPACK_IMPORTED_MODULE_1__["Column"].Schema.int),
        end_auth_asym_id: end_auth_asym_id,
        end_auth_comp_id: end_auth_comp_id,
        end_auth_seq_id: _mol_io_reader_cif__WEBPACK_IMPORTED_MODULE_0__["CifField"].ofStrings(helices.map(function (h) { return h.endSeqNum; })),
        id: _mol_io_reader_cif__WEBPACK_IMPORTED_MODULE_0__["CifField"].ofStrings(helices.map(function (h) { return h.serNum; })),
        pdbx_beg_PDB_ins_code: _mol_io_reader_cif__WEBPACK_IMPORTED_MODULE_0__["CifField"].ofStrings(helices.map(function (h) { return h.initICode; })),
        pdbx_end_PDB_ins_code: _mol_io_reader_cif__WEBPACK_IMPORTED_MODULE_0__["CifField"].ofStrings(helices.map(function (h) { return h.endICode; })),
        pdbx_PDB_helix_class: _mol_io_reader_cif__WEBPACK_IMPORTED_MODULE_0__["CifField"].ofStrings(helices.map(function (h) { return h.helixClass; })),
        pdbx_PDB_helix_length: _mol_io_reader_cif__WEBPACK_IMPORTED_MODULE_0__["CifField"].ofStrings(helices.map(function (h) { return h.length; })),
        pdbx_PDB_helix_id: _mol_io_reader_cif__WEBPACK_IMPORTED_MODULE_0__["CifField"].ofStrings(helices.map(function (h) { return h.helixID; })),
    };
    return _mol_io_reader_cif__WEBPACK_IMPORTED_MODULE_0__["CifCategory"].ofFields('struct_conf', struct_conf);
}
function parseSheet(lines, lineStart, lineEnd) {
    var sheets = [];
    var getLine = function (n) { return lines.data.substring(lines.indices[2 * n], lines.indices[2 * n + 1]); };
    for (var i = lineStart; i < lineEnd; i++) {
        var line = getLine(i);
        // COLUMNS       DATA  TYPE     FIELD          DEFINITION
        // -------------------------------------------------------------------------------------
        // 1 -  6        Record name   "SHEET "
        // 8 - 10        Integer       strand         Strand  number which starts at 1 for each
        //                                             strand within a sheet and increases by one.
        // 12 - 14        LString(3)    sheetID        Sheet  identifier.
        // 15 - 16        Integer       numStrands     Number  of strands in sheet.
        // 18 - 20        Residue name  initResName    Residue  name of initial residue.
        // 22             Character     initChainID    Chain identifier of initial residue
        //                                             in strand.
        // 23 - 26        Integer       initSeqNum     Sequence number of initial residue
        //                                             in strand.
        // 27             AChar         initICode      Insertion code of initial residue
        //                                             in  strand.
        // 29 - 31        Residue name  endResName     Residue name of terminal residue.
        // 33             Character     endChainID     Chain identifier of terminal residue.
        // 34 - 37        Integer       endSeqNum      Sequence number of terminal residue.
        // 38             AChar         endICode       Insertion code of terminal residue.
        // 39 - 40        Integer       sense          Sense of strand with respect to previous
        //                                             strand in the sheet. 0 if first strand,
        //                                             1 if  parallel,and -1 if anti-parallel.
        // 42 - 45        Atom          curAtom        Registration.  Atom name in current strand.
        // 46 - 48        Residue name  curResName     Registration.  Residue name in current strand
        // 50             Character     curChainId     Registration. Chain identifier in
        //                                             current strand.
        // 51 - 54        Integer       curResSeq      Registration.  Residue sequence number
        //                                             in current strand.
        // 55             AChar         curICode       Registration. Insertion code in
        //                                             current strand.
        // 57 - 60        Atom          prevAtom       Registration.  Atom name in previous strand.
        // 61 - 63        Residue name  prevResName    Registration.  Residue name in
        //                                             previous strand.
        // 65             Character     prevChainId    Registration.  Chain identifier in
        //                                             previous  strand.
        // 66 - 69        Integer       prevResSeq     Registration. Residue sequence number
        //                                             in previous strand.
        // 70             AChar         prevICode      Registration.  Insertion code in
        //                                             previous strand.
        sheets.push({
            strand: line.substr(7, 3).trim(),
            sheetID: line.substr(11, 3).trim(),
            numStrands: line.substr(14, 2).trim(),
            initResName: line.substr(17, 3).trim(),
            initChainID: line.substr(21, 1).trim(),
            initSeqNum: line.substr(22, 4).trim(),
            initICode: line.substr(26, 1).trim(),
            endResName: line.substr(28, 3).trim(),
            endChainID: line.substr(32, 1).trim(),
            endSeqNum: line.substr(33, 4).trim(),
            endICode: line.substr(37, 1).trim(),
            sense: line.substr(38, 2).trim(),
            curAtom: line.substr(41, 4).trim(),
            curResName: line.substr(45, 3).trim(),
            curChainId: line.substr(49, 1).trim(),
            curResSeq: line.substr(50, 4).trim(),
            curICode: line.substr(54, 1).trim(),
            prevAtom: line.substr(56, 4).trim(),
            prevResName: line.substr(60, 3).trim(),
            prevChainId: line.substr(64, 1).trim(),
            prevResSeq: line.substr(65, 4).trim(),
            prevICode: line.substr(69, 1).trim(),
        });
    }
    var beg_auth_asym_id = _mol_io_reader_cif__WEBPACK_IMPORTED_MODULE_0__["CifField"].ofStrings(sheets.map(function (s) { return s.initChainID; }));
    var beg_auth_comp_id = _mol_io_reader_cif__WEBPACK_IMPORTED_MODULE_0__["CifField"].ofStrings(sheets.map(function (s) { return s.initResName; }));
    var beg_auth_seq_id = _mol_io_reader_cif__WEBPACK_IMPORTED_MODULE_0__["CifField"].ofStrings(sheets.map(function (s) { return s.initSeqNum; }));
    var end_auth_asym_id = _mol_io_reader_cif__WEBPACK_IMPORTED_MODULE_0__["CifField"].ofStrings(sheets.map(function (s) { return s.endChainID; }));
    var end_auth_comp_id = _mol_io_reader_cif__WEBPACK_IMPORTED_MODULE_0__["CifField"].ofStrings(sheets.map(function (s) { return s.endResName; }));
    var end_auth_seq_id = _mol_io_reader_cif__WEBPACK_IMPORTED_MODULE_0__["CifField"].ofStrings(sheets.map(function (s) { return s.endSeqNum; }));
    var struct_sheet_range = {
        beg_label_asym_id: beg_auth_asym_id,
        beg_label_comp_id: beg_auth_comp_id,
        beg_label_seq_id: beg_auth_seq_id,
        beg_auth_asym_id: beg_auth_asym_id,
        beg_auth_comp_id: beg_auth_comp_id,
        beg_auth_seq_id: beg_auth_seq_id,
        end_label_asym_id: end_auth_asym_id,
        end_label_comp_id: end_auth_asym_id,
        end_label_seq_id: end_auth_seq_id,
        end_auth_asym_id: end_auth_asym_id,
        end_auth_comp_id: end_auth_comp_id,
        end_auth_seq_id: end_auth_seq_id,
        id: _mol_io_reader_cif__WEBPACK_IMPORTED_MODULE_0__["CifField"].ofStrings(sheets.map(function (s) { return s.strand; })),
        sheet_id: _mol_io_reader_cif__WEBPACK_IMPORTED_MODULE_0__["CifField"].ofStrings(sheets.map(function (s) { return s.sheetID; })),
        pdbx_beg_PDB_ins_code: _mol_io_reader_cif__WEBPACK_IMPORTED_MODULE_0__["CifField"].ofStrings(sheets.map(function (s) { return s.initICode; })),
        pdbx_end_PDB_ins_code: _mol_io_reader_cif__WEBPACK_IMPORTED_MODULE_0__["CifField"].ofStrings(sheets.map(function (s) { return s.endICode; })),
    };
    return _mol_io_reader_cif__WEBPACK_IMPORTED_MODULE_0__["CifCategory"].ofFields('struct_sheet_range', struct_sheet_range);
}
//# sourceMappingURL=secondary-structure.js.map

/***/ }),

/***/ "./lib/mol-model-formats/structure/pdb/to-cif.js":
/*!*******************************************************!*\
  !*** ./lib/mol-model-formats/structure/pdb/to-cif.js ***!
  \*******************************************************/
/*! exports provided: pdbToMmCif */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "pdbToMmCif", function() { return pdbToMmCif; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _mol_util_string__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../../mol-util/string */ "./lib/mol-util/string.js");
/* harmony import */ var _mol_io_reader_cif__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../../mol-io/reader/cif */ "./lib/mol-io/reader/cif.js");
/* harmony import */ var _mol_io_reader_common_text_tokenizer__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../../mol-io/reader/common/text/tokenizer */ "./lib/mol-io/reader/common/text/tokenizer.js");
/* harmony import */ var _assembly__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./assembly */ "./lib/mol-model-formats/structure/pdb/assembly.js");
/* harmony import */ var _secondary_structure__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./secondary-structure */ "./lib/mol-model-formats/structure/pdb/secondary-structure.js");
/* harmony import */ var _entity__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ./entity */ "./lib/mol-model-formats/structure/pdb/entity.js");
/* harmony import */ var _common_component__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../common/component */ "./lib/mol-model-formats/structure/common/component.js");
/* harmony import */ var _common_entity__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ../common/entity */ "./lib/mol-model-formats/structure/common/entity.js");
/* harmony import */ var _mol_data_db__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ../../../mol-data/db */ "./lib/mol-data/db.js");
/* harmony import */ var _mol_model_structure_model_types__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ../../../mol-model/structure/model/types */ "./lib/mol-model/structure/model/types.js");
/* harmony import */ var _atom_site__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ./atom-site */ "./lib/mol-model-formats/structure/pdb/atom-site.js");
/* harmony import */ var _anisotropic__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! ./anisotropic */ "./lib/mol-model-formats/structure/pdb/anisotropic.js");
/* harmony import */ var _conect__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! ./conect */ "./lib/mol-model-formats/structure/pdb/conect.js");
/* harmony import */ var _mol_util_debug__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! ../../../mol-util/debug */ "./lib/mol-util/debug.js");
/**
 * Copyright (c) 2019-2021 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author David Sehnal <david.sehnal@gmail.com>
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */















function pdbToMmCif(pdb) {
    return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"])(this, void 0, void 0, function () {
        var lines, data, indices, tokenizer, isPdbqt, atomCount, anisotropicCount, i, _i, s, e, atomSite, anisotropic, entityBuilder, helperCategories, heteroNames, modelNum, modelStr, conectRange, i, _i, s, e, j, j, j, j, j, j, j, seqIds, atomIds, compIds, asymIds, componentBuilder, i, il, compId, moleculeType, atom_site, categories, _a, helperCategories_1, c;
        return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__generator"])(this, function (_b) {
            lines = pdb.lines;
            data = lines.data, indices = lines.indices;
            tokenizer = Object(_mol_io_reader_common_text_tokenizer__WEBPACK_IMPORTED_MODULE_3__["Tokenizer"])(data);
            isPdbqt = !!pdb.isPdbqt;
            atomCount = 0;
            anisotropicCount = 0;
            for (i = 0, _i = lines.count; i < _i; i++) {
                s = indices[2 * i], e = indices[2 * i + 1];
                switch (data[s]) {
                    case 'A':
                        if (Object(_mol_util_string__WEBPACK_IMPORTED_MODULE_1__["substringStartsWith"])(data, s, e, 'ATOM  '))
                            atomCount++;
                        else if (Object(_mol_util_string__WEBPACK_IMPORTED_MODULE_1__["substringStartsWith"])(data, s, e, 'ANISOU'))
                            anisotropicCount++;
                        break;
                    case 'H':
                        if (Object(_mol_util_string__WEBPACK_IMPORTED_MODULE_1__["substringStartsWith"])(data, s, e, 'HETATM'))
                            atomCount++;
                        break;
                }
            }
            atomSite = Object(_atom_site__WEBPACK_IMPORTED_MODULE_11__["getAtomSiteTemplate"])(data, atomCount);
            anisotropic = Object(_anisotropic__WEBPACK_IMPORTED_MODULE_12__["getAnisotropicTemplate"])(data, anisotropicCount);
            entityBuilder = new _common_entity__WEBPACK_IMPORTED_MODULE_8__["EntityBuilder"]();
            helperCategories = [];
            heteroNames = [];
            modelNum = 0, modelStr = '';
            conectRange = undefined;
            for (i = 0, _i = lines.count; i < _i; i++) {
                s = indices[2 * i], e = indices[2 * i + 1];
                switch (data[s]) {
                    case 'A':
                        if (Object(_mol_util_string__WEBPACK_IMPORTED_MODULE_1__["substringStartsWith"])(data, s, e, 'ATOM  ')) {
                            if (!modelNum) {
                                modelNum++;
                                modelStr = '' + modelNum;
                            }
                            Object(_atom_site__WEBPACK_IMPORTED_MODULE_11__["addAtom"])(atomSite, modelStr, tokenizer, s, e, isPdbqt);
                        }
                        else if (Object(_mol_util_string__WEBPACK_IMPORTED_MODULE_1__["substringStartsWith"])(data, s, e, 'ANISOU')) {
                            Object(_anisotropic__WEBPACK_IMPORTED_MODULE_12__["addAnisotropic"])(anisotropic, modelStr, tokenizer, s, e);
                        }
                        break;
                    case 'C':
                        if (Object(_mol_util_string__WEBPACK_IMPORTED_MODULE_1__["substringStartsWith"])(data, s, e, 'CRYST1')) {
                            helperCategories.push.apply(helperCategories, Object(_assembly__WEBPACK_IMPORTED_MODULE_4__["parseCryst1"])(pdb.id || '?', data.substring(s, e)));
                        }
                        else if (Object(_mol_util_string__WEBPACK_IMPORTED_MODULE_1__["substringStartsWith"])(data, s, e, 'CONECT')) {
                            j = i + 1;
                            while (true) {
                                s = indices[2 * j];
                                e = indices[2 * j + 1];
                                if (!Object(_mol_util_string__WEBPACK_IMPORTED_MODULE_1__["substringStartsWith"])(data, s, e, 'CONECT'))
                                    break;
                                j++;
                            }
                            if (conectRange) {
                                if (_mol_util_debug__WEBPACK_IMPORTED_MODULE_14__["isDebugMode"]) {
                                    console.log('only single CONECT block allowed, ignoring others');
                                }
                            }
                            else {
                                conectRange = [i, j];
                            }
                            i = j - 1;
                        }
                        else if (Object(_mol_util_string__WEBPACK_IMPORTED_MODULE_1__["substringStartsWith"])(data, s, e, 'COMPND')) {
                            j = i + 1;
                            while (true) {
                                s = indices[2 * j];
                                e = indices[2 * j + 1];
                                if (!Object(_mol_util_string__WEBPACK_IMPORTED_MODULE_1__["substringStartsWith"])(data, s, e, 'COMPND'))
                                    break;
                                j++;
                            }
                            entityBuilder.setCompounds(Object(_entity__WEBPACK_IMPORTED_MODULE_6__["parseCmpnd"])(lines, i, j));
                            i = j - 1;
                        }
                        break;
                    case 'H':
                        if (Object(_mol_util_string__WEBPACK_IMPORTED_MODULE_1__["substringStartsWith"])(data, s, e, 'HETATM')) {
                            if (!modelNum) {
                                modelNum++;
                                modelStr = '' + modelNum;
                            }
                            Object(_atom_site__WEBPACK_IMPORTED_MODULE_11__["addAtom"])(atomSite, modelStr, tokenizer, s, e, isPdbqt);
                        }
                        else if (Object(_mol_util_string__WEBPACK_IMPORTED_MODULE_1__["substringStartsWith"])(data, s, e, 'HELIX')) {
                            j = i + 1;
                            while (true) {
                                s = indices[2 * j];
                                e = indices[2 * j + 1];
                                if (!Object(_mol_util_string__WEBPACK_IMPORTED_MODULE_1__["substringStartsWith"])(data, s, e, 'HELIX'))
                                    break;
                                j++;
                            }
                            helperCategories.push(Object(_secondary_structure__WEBPACK_IMPORTED_MODULE_5__["parseHelix"])(lines, i, j));
                            i = j - 1;
                        }
                        else if (Object(_mol_util_string__WEBPACK_IMPORTED_MODULE_1__["substringStartsWith"])(data, s, e, 'HETNAM')) {
                            j = i + 1;
                            while (true) {
                                s = indices[2 * j];
                                e = indices[2 * j + 1];
                                if (!Object(_mol_util_string__WEBPACK_IMPORTED_MODULE_1__["substringStartsWith"])(data, s, e, 'HETNAM'))
                                    break;
                                j++;
                            }
                            heteroNames.push.apply(heteroNames, Array.from(Object(_entity__WEBPACK_IMPORTED_MODULE_6__["parseHetnam"])(lines, i, j).entries()));
                            i = j - 1;
                        }
                        break;
                    case 'M':
                        if (Object(_mol_util_string__WEBPACK_IMPORTED_MODULE_1__["substringStartsWith"])(data, s, e, 'MODEL ')) {
                            modelNum++;
                            modelStr = '' + modelNum;
                        }
                        if (Object(_mol_util_string__WEBPACK_IMPORTED_MODULE_1__["substringStartsWith"])(data, s, e, 'MTRIX')) {
                            j = i + 1;
                            while (true) {
                                s = indices[2 * j];
                                e = indices[2 * j + 1];
                                if (!Object(_mol_util_string__WEBPACK_IMPORTED_MODULE_1__["substringStartsWith"])(data, s, e, 'MTRIX'))
                                    break;
                                j++;
                            }
                            helperCategories.push.apply(helperCategories, Object(_assembly__WEBPACK_IMPORTED_MODULE_4__["parseMtrix"])(lines, i, j));
                            i = j - 1;
                        }
                        // TODO: MODRES records => pdbx_struct_mod_residue
                        break;
                    case 'O':
                        // TODO: ORIGX record => cif.database_PDB_matrix.origx, cif.database_PDB_matrix.origx_vector
                        break;
                    case 'R':
                        if (Object(_mol_util_string__WEBPACK_IMPORTED_MODULE_1__["substringStartsWith"])(data, s, e, 'REMARK 350')) {
                            j = i + 1;
                            while (true) {
                                s = indices[2 * j];
                                e = indices[2 * j + 1];
                                if (!Object(_mol_util_string__WEBPACK_IMPORTED_MODULE_1__["substringStartsWith"])(data, s, e, 'REMARK 350'))
                                    break;
                                j++;
                            }
                            helperCategories.push.apply(helperCategories, Object(_assembly__WEBPACK_IMPORTED_MODULE_4__["parseRemark350"])(lines, i, j));
                            i = j - 1;
                        }
                        break;
                    case 'S':
                        if (Object(_mol_util_string__WEBPACK_IMPORTED_MODULE_1__["substringStartsWith"])(data, s, e, 'SHEET')) {
                            j = i + 1;
                            while (true) {
                                s = indices[2 * j];
                                e = indices[2 * j + 1];
                                if (!Object(_mol_util_string__WEBPACK_IMPORTED_MODULE_1__["substringStartsWith"])(data, s, e, 'SHEET'))
                                    break;
                                j++;
                            }
                            helperCategories.push(Object(_secondary_structure__WEBPACK_IMPORTED_MODULE_5__["parseSheet"])(lines, i, j));
                            i = j - 1;
                        }
                        // TODO: SCALE record => cif.atom_sites.fract_transf_matrix, cif.atom_sites.fract_transf_vector
                        break;
                }
            }
            seqIds = _mol_data_db__WEBPACK_IMPORTED_MODULE_9__["Column"].ofIntTokens(atomSite.auth_seq_id);
            atomIds = _mol_data_db__WEBPACK_IMPORTED_MODULE_9__["Column"].ofStringTokens(atomSite.auth_atom_id);
            compIds = _mol_data_db__WEBPACK_IMPORTED_MODULE_9__["Column"].ofStringTokens(atomSite.auth_comp_id);
            asymIds = _mol_data_db__WEBPACK_IMPORTED_MODULE_9__["Column"].ofStringTokens(atomSite.auth_asym_id);
            componentBuilder = new _common_component__WEBPACK_IMPORTED_MODULE_7__["ComponentBuilder"](seqIds, atomIds);
            componentBuilder.setNames(heteroNames);
            entityBuilder.setNames(heteroNames);
            for (i = 0, il = compIds.rowCount; i < il; ++i) {
                compId = compIds.value(i);
                moleculeType = Object(_mol_model_structure_model_types__WEBPACK_IMPORTED_MODULE_10__["getMoleculeType"])(componentBuilder.add(compId, i).type, compId);
                atomSite.label_entity_id[i] = entityBuilder.getEntityId(compId, moleculeType, asymIds.value(i));
            }
            atom_site = Object(_atom_site__WEBPACK_IMPORTED_MODULE_11__["getAtomSite"])(atomSite);
            if (!isPdbqt)
                delete atom_site.partial_charge;
            if (conectRange) {
                helperCategories.push(Object(_conect__WEBPACK_IMPORTED_MODULE_13__["parseConect"])(lines, conectRange[0], conectRange[1], atom_site));
            }
            categories = {
                entity: _mol_io_reader_cif__WEBPACK_IMPORTED_MODULE_2__["CifCategory"].ofTable('entity', entityBuilder.getEntityTable()),
                chem_comp: _mol_io_reader_cif__WEBPACK_IMPORTED_MODULE_2__["CifCategory"].ofTable('chem_comp', componentBuilder.getChemCompTable()),
                atom_site: _mol_io_reader_cif__WEBPACK_IMPORTED_MODULE_2__["CifCategory"].ofFields('atom_site', atom_site),
                atom_site_anisotrop: _mol_io_reader_cif__WEBPACK_IMPORTED_MODULE_2__["CifCategory"].ofFields('atom_site_anisotrop', Object(_anisotropic__WEBPACK_IMPORTED_MODULE_12__["getAnisotropic"])(anisotropic))
            };
            for (_a = 0, helperCategories_1 = helperCategories; _a < helperCategories_1.length; _a++) {
                c = helperCategories_1[_a];
                categories[c.name] = c;
            }
            return [2 /*return*/, {
                    header: pdb.id || 'PDB',
                    categoryNames: Object.keys(categories),
                    categories: categories
                }];
        });
    });
}
//# sourceMappingURL=to-cif.js.map

/***/ }),

/***/ "./lib/mol-model-formats/structure/property/anisotropic.js":
/*!*****************************************************************!*\
  !*** ./lib/mol-model-formats/structure/property/anisotropic.js ***!
  \*****************************************************************/
/*! exports provided: AtomSiteAnisotrop */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "AtomSiteAnisotrop", function() { return AtomSiteAnisotrop; });
/* harmony import */ var _mol_io_reader_cif_schema_mmcif__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../../mol-io/reader/cif/schema/mmcif */ "./lib/mol-io/reader/cif/schema/mmcif.js");
/* harmony import */ var _mol_io_writer_cif__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../../mol-io/writer/cif */ "./lib/mol-io/writer/cif.js");
/* harmony import */ var _common_property__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../common/property */ "./lib/mol-model-formats/structure/common/property.js");
/* harmony import */ var _mmcif__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../mmcif */ "./lib/mol-model-formats/structure/mmcif.js");
/**
 * Copyright (c) 2019-2020 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */





var Anisotrop = {
    U: _mol_io_reader_cif_schema_mmcif__WEBPACK_IMPORTED_MODULE_0__["mmCIF_Schema"].atom_site_anisotrop.U,
    U_esd: _mol_io_reader_cif_schema_mmcif__WEBPACK_IMPORTED_MODULE_0__["mmCIF_Schema"].atom_site_anisotrop.U_esd
};
var AtomSiteAnisotrop;
(function (AtomSiteAnisotrop) {
    AtomSiteAnisotrop.Schema = Anisotrop;
    AtomSiteAnisotrop.Descriptor = {
        name: 'atom_site_anisotrop',
        cifExport: {
            prefix: '',
            categories: [{
                    name: 'atom_site_anisotrop',
                    instance: function (ctx) {
                        var p = AtomSiteAnisotrop.Provider.get(ctx.firstModel);
                        if (!p)
                            return _mol_io_writer_cif__WEBPACK_IMPORTED_MODULE_1__["CifWriter"].Category.Empty;
                        if (!_mmcif__WEBPACK_IMPORTED_MODULE_3__["MmcifFormat"].is(ctx.firstModel.sourceData))
                            return _mol_io_writer_cif__WEBPACK_IMPORTED_MODULE_1__["CifWriter"].Category.Empty;
                        // TODO filter to write only data for elements that exist in model
                        return _mol_io_writer_cif__WEBPACK_IMPORTED_MODULE_1__["CifWriter"].Category.ofTable(ctx.firstModel.sourceData.data.db.atom_site_anisotrop);
                    }
                }]
        }
    };
    AtomSiteAnisotrop.Provider = _common_property__WEBPACK_IMPORTED_MODULE_2__["FormatPropertyProvider"].create(AtomSiteAnisotrop.Descriptor);
    function getElementToAnsiotrop(atomId, ansioId) {
        var atomIdToElement = new Int32Array(atomId.rowCount);
        atomIdToElement.fill(-1);
        for (var i = 0, il = atomId.rowCount; i < il; i++) {
            atomIdToElement[atomId.value(i)] = i;
        }
        var elementToAnsiotrop = new Int32Array(atomId.rowCount);
        elementToAnsiotrop.fill(-1);
        for (var i = 0, il = ansioId.rowCount; i < il; ++i) {
            var ei = atomIdToElement[ansioId.value(i)];
            if (ei !== -1)
                elementToAnsiotrop[ei] = i;
        }
        return elementToAnsiotrop;
    }
    AtomSiteAnisotrop.getElementToAnsiotrop = getElementToAnsiotrop;
    function getElementToAnsiotropFromLabel(atomLabel, ansioLabel) {
        var atomLabelToElement = {};
        for (var i = 0, il = atomLabel.rowCount; i < il; i++) {
            atomLabelToElement[atomLabel.value(i)] = i;
        }
        var elementToAnsiotrop = new Int32Array(atomLabel.rowCount);
        elementToAnsiotrop.fill(-1);
        for (var i = 0, il = ansioLabel.rowCount; i < il; ++i) {
            var ei = atomLabelToElement[ansioLabel.value(i)];
            if (ei !== undefined)
                elementToAnsiotrop[ei] = i;
        }
        return elementToAnsiotrop;
    }
    AtomSiteAnisotrop.getElementToAnsiotropFromLabel = getElementToAnsiotropFromLabel;
})(AtomSiteAnisotrop || (AtomSiteAnisotrop = {}));
//# sourceMappingURL=anisotropic.js.map

/***/ }),

/***/ "./lib/mol-model-formats/structure/property/assembly.js":
/*!**************************************************************!*\
  !*** ./lib/mol-model-formats/structure/property/assembly.js ***!
  \**************************************************************/
/*! exports provided: createAssemblies */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createAssemblies", function() { return createAssemblies; });
/* harmony import */ var _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../../mol-math/linear-algebra */ "./lib/mol-math/linear-algebra.js");
/* harmony import */ var _mol_math_geometry_symmetry_operator__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../../mol-math/geometry/symmetry-operator */ "./lib/mol-math/geometry/symmetry-operator.js");
/* harmony import */ var _mol_model_structure_model_properties_symmetry__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../../mol-model/structure/model/properties/symmetry */ "./lib/mol-model/structure/model/properties/symmetry.js");
/* harmony import */ var _mol_model_structure__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../../mol-model/structure */ "./lib/mol-model/structure.js");
/**
 * Copyright (c) 2017 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author David Sehnal <david.sehnal@gmail.com>
 */





function createAssemblies(pdbx_struct_assembly, pdbx_struct_assembly_gen, pdbx_struct_oper_list) {
    if (!pdbx_struct_assembly._rowCount)
        return [];
    var matrices = getMatrices(pdbx_struct_oper_list);
    var assemblies = [];
    for (var i = 0; i < pdbx_struct_assembly._rowCount; i++) {
        assemblies[assemblies.length] = createAssembly(pdbx_struct_assembly, pdbx_struct_assembly_gen, i, matrices);
    }
    return assemblies;
}
function createAssembly(pdbx_struct_assembly, pdbx_struct_assembly_gen, index, matrices) {
    var id = pdbx_struct_assembly.id.value(index);
    var details = pdbx_struct_assembly.details.value(index);
    var generators = [];
    var assembly_id = pdbx_struct_assembly_gen.assembly_id, oper_expression = pdbx_struct_assembly_gen.oper_expression, asym_id_list = pdbx_struct_assembly_gen.asym_id_list;
    for (var i = 0, _i = pdbx_struct_assembly_gen._rowCount; i < _i; i++) {
        if (assembly_id.value(i) !== id)
            continue;
        generators[generators.length] = {
            assemblyId: id,
            expression: oper_expression.value(i),
            asymIds: asym_id_list.value(i)
        };
    }
    return _mol_model_structure_model_properties_symmetry__WEBPACK_IMPORTED_MODULE_2__["Assembly"].create(id, details, operatorGroupsProvider(generators, matrices));
}
function operatorGroupsProvider(generators, matrices) {
    return function () {
        var groups = [];
        var operatorOffset = 0;
        for (var i = 0; i < generators.length; i++) {
            var gen = generators[i];
            var operatorList = parseOperatorList(gen.expression);
            var operatorNames = expandOperators(operatorList);
            var operators = getAssemblyOperators(matrices, operatorNames, operatorOffset, gen.assemblyId);
            var selector = _mol_model_structure__WEBPACK_IMPORTED_MODULE_3__["Queries"].generators.atoms({ chainTest: _mol_model_structure__WEBPACK_IMPORTED_MODULE_3__["Queries"].pred.and(_mol_model_structure__WEBPACK_IMPORTED_MODULE_3__["Queries"].pred.eq(function (ctx) { return _mol_model_structure__WEBPACK_IMPORTED_MODULE_3__["StructureProperties"].unit.operator_name(ctx.element); }, _mol_math_geometry_symmetry_operator__WEBPACK_IMPORTED_MODULE_1__["SymmetryOperator"].DefaultName), _mol_model_structure__WEBPACK_IMPORTED_MODULE_3__["Queries"].pred.inSet(function (ctx) { return _mol_model_structure__WEBPACK_IMPORTED_MODULE_3__["StructureProperties"].chain.label_asym_id(ctx.element); }, gen.asymIds)) });
            groups[groups.length] = { selector: selector, operators: operators };
            operatorOffset += operators.length;
        }
        return groups;
    };
}
function getMatrices(pdbx_struct_oper_list) {
    var id = pdbx_struct_oper_list.id, matrix = pdbx_struct_oper_list.matrix, vector = pdbx_struct_oper_list.vector, _schema = pdbx_struct_oper_list._schema;
    var matrices = new Map();
    for (var i = 0, _i = pdbx_struct_oper_list._rowCount; i < _i; i++) {
        var m = _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Tensor"].toMat4(Object(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Mat4"])(), _schema.matrix.space, matrix.value(i));
        var t = _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Tensor"].toVec3(Object(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"])(), _schema.vector.space, vector.value(i));
        _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Mat4"].setTranslation(m, t);
        _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Mat4"].setValue(m, 3, 3, 1);
        matrices.set(id.value(i), m);
    }
    return matrices;
}
function expandOperators(operatorList) {
    var ops = [];
    var currentOp = [];
    for (var i = 0; i < operatorList.length; i++)
        currentOp[i] = '';
    expandOperators1(operatorList, ops, operatorList.length - 1, currentOp);
    return ops;
}
function expandOperators1(operatorNames, list, i, current) {
    if (i < 0) {
        list[list.length] = current.slice(0);
        return;
    }
    var ops = operatorNames[i], len = ops.length;
    for (var j = 0; j < len; j++) {
        current[i] = ops[j];
        expandOperators1(operatorNames, list, i - 1, current);
    }
}
function getAssemblyOperators(matrices, operatorNames, startIndex, assemblyId) {
    var operators = [];
    var index = startIndex;
    for (var _a = 0, operatorNames_1 = operatorNames; _a < operatorNames_1.length; _a++) {
        var op = operatorNames_1[_a];
        var m = _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Mat4"].identity();
        for (var i = 0; i < op.length; i++) {
            _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Mat4"].mul(m, m, matrices.get(op[i]));
        }
        index++;
        operators[operators.length] = _mol_math_geometry_symmetry_operator__WEBPACK_IMPORTED_MODULE_1__["SymmetryOperator"].create("ASM_" + index, m, { assembly: { id: assemblyId, operId: index, operList: op } });
    }
    return operators;
}
function parseOperatorList(value) {
    // '(X0)(1-5)' becomes [['X0'], ['1', '2', '3', '4', '5']]
    // kudos to Glen van Ginkel.
    var oeRegex = /\(?([^\(\)]+)\)?]*/g, groups = [], ret = [];
    var g;
    while (g = oeRegex.exec(value))
        groups[groups.length] = g[1];
    groups.forEach(function (g) {
        var group = [];
        g.split(',').forEach(function (e) {
            var dashIndex = e.indexOf('-');
            if (dashIndex > 0) {
                var from = parseInt(e.substring(0, dashIndex)), to = parseInt(e.substr(dashIndex + 1));
                for (var i = from; i <= to; i++)
                    group[group.length] = i.toString();
            }
            else {
                group[group.length] = e.trim();
            }
        });
        ret[ret.length] = group;
    });
    return ret;
}
//# sourceMappingURL=assembly.js.map

/***/ }),

/***/ "./lib/mol-model-formats/structure/property/bonds/chem_comp.js":
/*!*********************************************************************!*\
  !*** ./lib/mol-model-formats/structure/property/bonds/chem_comp.js ***!
  \*********************************************************************/
/*! exports provided: ComponentBond */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ComponentBond", function() { return ComponentBond; });
/* harmony import */ var _mol_io_reader_cif_schema_mmcif__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../../../mol-io/reader/cif/schema/mmcif */ "./lib/mol-io/reader/cif/schema/mmcif.js");
/* harmony import */ var _mol_io_writer_cif__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../../../mol-io/writer/cif */ "./lib/mol-io/writer/cif.js");
/* harmony import */ var _mol_data_db__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../../../mol-data/db */ "./lib/mol-data/db.js");
/* harmony import */ var _common_property__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../common/property */ "./lib/mol-model-formats/structure/common/property.js");
/**
 * Copyright (c) 2017-2020 Mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author David Sehnal <david.sehnal@gmail.com>
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */




var ComponentBond;
(function (ComponentBond) {
    ComponentBond.Descriptor = {
        name: 'chem_comp_bond',
        cifExport: {
            prefix: '',
            categories: [{
                    name: 'chem_comp_bond',
                    instance: function (ctx) {
                        var p = ComponentBond.Provider.get(ctx.firstModel);
                        if (!p)
                            return _mol_io_writer_cif__WEBPACK_IMPORTED_MODULE_1__["CifWriter"].Category.Empty;
                        var chem_comp_bond = p.data;
                        if (!chem_comp_bond)
                            return _mol_io_writer_cif__WEBPACK_IMPORTED_MODULE_1__["CifWriter"].Category.Empty;
                        var comp_names = ctx.structures[0].uniqueResidueNames;
                        var comp_id = chem_comp_bond.comp_id, _rowCount = chem_comp_bond._rowCount;
                        var indices = [];
                        for (var i = 0; i < _rowCount; i++) {
                            if (comp_names.has(comp_id.value(i)))
                                indices[indices.length] = i;
                        }
                        return _mol_io_writer_cif__WEBPACK_IMPORTED_MODULE_1__["CifWriter"].Category.ofTable(chem_comp_bond, indices);
                    }
                }]
        }
    };
    ComponentBond.Provider = _common_property__WEBPACK_IMPORTED_MODULE_3__["FormatPropertyProvider"].create(ComponentBond.Descriptor);
    function chemCompBondFromTable(model, table) {
        return _mol_data_db__WEBPACK_IMPORTED_MODULE_2__["Table"].pick(table, _mol_io_reader_cif_schema_mmcif__WEBPACK_IMPORTED_MODULE_0__["mmCIF_Schema"].chem_comp_bond, function (i) {
            return model.properties.chemicalComponentMap.has(table.comp_id.value(i));
        });
    }
    ComponentBond.chemCompBondFromTable = chemCompBondFromTable;
    function getEntriesFromChemCompBond(data) {
        var entries = new Map();
        function addEntry(id) {
            // weird behavior when 'PRO' is requested - will report a single bond between N and H because a later operation would override real content
            if (entries.has(id)) {
                return entries.get(id);
            }
            var e = new Entry(id);
            entries.set(id, e);
            return e;
        }
        var comp_id = data.comp_id, atom_id_1 = data.atom_id_1, atom_id_2 = data.atom_id_2, value_order = data.value_order, pdbx_aromatic_flag = data.pdbx_aromatic_flag, _rowCount = data._rowCount;
        var entry = addEntry(comp_id.value(0));
        for (var i = 0; i < _rowCount; i++) {
            var id = comp_id.value(i);
            var nameA = atom_id_1.value(i);
            var nameB = atom_id_2.value(i);
            var order = value_order.value(i);
            var aromatic = pdbx_aromatic_flag.value(i) === 'Y';
            if (entry.id !== id) {
                entry = addEntry(id);
            }
            var flags = 1 /* Covalent */;
            var ord = 1;
            if (aromatic)
                flags |= 16 /* Aromatic */;
            switch (order.toLowerCase()) {
                case 'doub':
                case 'delo':
                    ord = 2;
                    break;
                case 'trip':
                    ord = 3;
                    break;
                case 'quad':
                    ord = 4;
                    break;
            }
            entry.add(nameA, nameB, ord, flags);
        }
        return entries;
    }
    ComponentBond.getEntriesFromChemCompBond = getEntriesFromChemCompBond;
    var Entry = /** @class */ (function () {
        function Entry(id) {
            this.id = id;
            this.map = new Map();
        }
        Entry.prototype.add = function (a, b, order, flags, swap) {
            if (swap === void 0) { swap = true; }
            var e = this.map.get(a);
            if (e !== void 0) {
                var f = e.get(b);
                if (f === void 0) {
                    e.set(b, { order: order, flags: flags });
                }
            }
            else {
                var map = new Map();
                map.set(b, { order: order, flags: flags });
                this.map.set(a, map);
            }
            if (swap)
                this.add(b, a, order, flags, false);
        };
        return Entry;
    }());
    ComponentBond.Entry = Entry;
})(ComponentBond || (ComponentBond = {}));
//# sourceMappingURL=chem_comp.js.map

/***/ }),

/***/ "./lib/mol-model-formats/structure/property/bonds/index-pair.js":
/*!**********************************************************************!*\
  !*** ./lib/mol-model-formats/structure/property/bonds/index-pair.js ***!
  \**********************************************************************/
/*! exports provided: IndexPairBonds */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "IndexPairBonds", function() { return IndexPairBonds; });
/* harmony import */ var _mol_math_graph__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../../../mol-math/graph */ "./lib/mol-math/graph.js");
/* harmony import */ var _common_property__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../common/property */ "./lib/mol-model-formats/structure/common/property.js");
/**
 * Copyright (c) 2019-2020 Mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */


function getGraph(indexA, indexB, props, count) {
    var builder = new _mol_math_graph__WEBPACK_IMPORTED_MODULE_0__["IntAdjacencyGraph"].EdgeBuilder(count, indexA, indexB);
    var order = new Int8Array(builder.slotCount);
    var distance = new Array(builder.slotCount);
    var flag = new Array(builder.slotCount);
    for (var i = 0, _i = builder.edgeCount; i < _i; i++) {
        builder.addNextEdge();
        builder.assignProperty(order, props.order ? props.order[i] : 1);
        builder.assignProperty(distance, props.distance ? props.distance[i] : -1);
        builder.assignProperty(flag, props.flag ? props.flag[i] : 1 /* Covalent */);
    }
    return builder.createGraph({ order: order, distance: distance, flag: flag });
}
var IndexPairBonds;
(function (IndexPairBonds) {
    IndexPairBonds.Descriptor = {
        name: 'index_pair_bonds',
    };
    IndexPairBonds.Provider = _common_property__WEBPACK_IMPORTED_MODULE_1__["FormatPropertyProvider"].create(IndexPairBonds.Descriptor);
    function fromData(data) {
        var pairs = data.pairs, count = data.count;
        var indexA = pairs.indexA.toArray();
        var indexB = pairs.indexB.toArray();
        var order = pairs.order && pairs.order.toArray();
        var distance = pairs.distance && pairs.distance.toArray();
        var flag = pairs.flag && pairs.flag.toArray();
        return getGraph(indexA, indexB, { order: order, distance: distance, flag: flag }, count);
    }
    IndexPairBonds.fromData = fromData;
})(IndexPairBonds || (IndexPairBonds = {}));
//# sourceMappingURL=index-pair.js.map

/***/ }),

/***/ "./lib/mol-model-formats/structure/property/bonds/struct_conn.js":
/*!***********************************************************************!*\
  !*** ./lib/mol-model-formats/structure/property/bonds/struct_conn.js ***!
  \***********************************************************************/
/*! exports provided: StructConn */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "StructConn", function() { return StructConn; });
/* harmony import */ var _mol_data_int__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../../../mol-data/int */ "./lib/mol-data/int.js");
/* harmony import */ var _mol_io_writer_cif__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../../../mol-io/writer/cif */ "./lib/mol-io/writer/cif.js");
/* harmony import */ var _mol_model_structure_model_properties_atomic_bonds__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../../../mol-model/structure/model/properties/atomic/bonds */ "./lib/mol-model/structure/model/properties/atomic/bonds.js");
/* harmony import */ var _common_property__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../common/property */ "./lib/mol-model-formats/structure/common/property.js");
/**
 * Copyright (c) 2017-2021 Mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author David Sehnal <david.sehnal@gmail.com>
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */




var StructConn;
(function (StructConn) {
    StructConn.Descriptor = {
        name: 'struct_conn',
        cifExport: {
            prefix: '',
            categories: [{
                    name: 'struct_conn',
                    instance: function (ctx) {
                        var p = StructConn.Provider.get(ctx.firstModel);
                        if (!p || p.entries.length === 0)
                            return _mol_io_writer_cif__WEBPACK_IMPORTED_MODULE_1__["CifWriter"].Category.Empty;
                        var structure = ctx.structures[0];
                        var indices = [];
                        for (var _a = 0, _b = p.entries; _a < _b.length; _a++) {
                            var e = _b[_a];
                            if (hasAtom(structure, e.partnerA.atomIndex) &&
                                hasAtom(structure, e.partnerB.atomIndex)) {
                                indices[indices.length] = e.rowIndex;
                            }
                        }
                        return _mol_io_writer_cif__WEBPACK_IMPORTED_MODULE_1__["CifWriter"].Category.ofTable(p.data, indices);
                    }
                }]
        }
    };
    StructConn.Provider = _common_property__WEBPACK_IMPORTED_MODULE_3__["FormatPropertyProvider"].create(StructConn.Descriptor);
    /**
     * Heuristic to test if StructConn likely provides all atomic bonds by
     * checking if the fraction of bonds and atoms is high (> 0.95).
     */
    function isExhaustive(model) {
        var structConn = StructConn.Provider.get(model);
        return !!structConn && (structConn.data.id.rowCount / model.atomicConformation.atomId.rowCount) > 0.95;
    }
    StructConn.isExhaustive = isExhaustive;
    function hasAtom(_a, element) {
        var units = _a.units;
        for (var i = 0, _i = units.length; i < _i; i++) {
            if (_mol_data_int__WEBPACK_IMPORTED_MODULE_0__["SortedArray"].indexOf(units[i].elements, element) >= 0)
                return true;
        }
        return false;
    }
    function getAtomIndexFromEntries(entries) {
        var m = new Map();
        for (var _a = 0, entries_1 = entries; _a < entries_1.length; _a++) {
            var e = entries_1[_a];
            var iA = e.partnerA.atomIndex, iB = e.partnerB.atomIndex;
            if (m.has(iA))
                m.get(iA).push(e);
            else
                m.set(iA, [e]);
            if (m.has(iB))
                m.get(iB).push(e);
            else
                m.set(iB, [e]);
        }
        return m;
    }
    StructConn.getAtomIndexFromEntries = getAtomIndexFromEntries;
    function getEntriesFromStructConn(struct_conn, model) {
        var conn_type_id = struct_conn.conn_type_id, pdbx_dist_value = struct_conn.pdbx_dist_value, pdbx_value_order = struct_conn.pdbx_value_order;
        var p1 = {
            label_asym_id: struct_conn.ptnr1_label_asym_id,
            label_seq_id: struct_conn.ptnr1_label_seq_id,
            auth_seq_id: struct_conn.ptnr1_auth_seq_id,
            label_atom_id: struct_conn.ptnr1_label_atom_id,
            label_alt_id: struct_conn.pdbx_ptnr1_label_alt_id,
            ins_code: struct_conn.pdbx_ptnr1_PDB_ins_code,
            symmetry: struct_conn.ptnr1_symmetry
        };
        var p2 = {
            label_asym_id: struct_conn.ptnr2_label_asym_id,
            label_seq_id: struct_conn.ptnr2_label_seq_id,
            auth_seq_id: struct_conn.ptnr2_auth_seq_id,
            label_atom_id: struct_conn.ptnr2_label_atom_id,
            label_alt_id: struct_conn.pdbx_ptnr2_label_alt_id,
            ins_code: struct_conn.pdbx_ptnr2_PDB_ins_code,
            symmetry: struct_conn.ptnr2_symmetry
        };
        var _p = function (row, ps) {
            if (ps.label_asym_id.valueKind(row) !== 0 /* Present */)
                return void 0;
            var asymId = ps.label_asym_id.value(row);
            var entityIndex = model.atomicHierarchy.index.findEntity(asymId);
            if (entityIndex < 0)
                return void 0;
            var residueIndex = model.atomicHierarchy.index.findResidue(model.entities.data.id.value(entityIndex), asymId, ps.auth_seq_id.value(row), ps.ins_code.value(row));
            if (residueIndex < 0)
                return void 0;
            var atomName = ps.label_atom_id.value(row);
            // turns out "mismat" records might not have atom name value
            if (!atomName)
                return void 0;
            var atomIndex = model.atomicHierarchy.index.findAtomOnResidue(residueIndex, atomName, ps.label_alt_id.value(row));
            if (atomIndex < 0)
                return void 0;
            return { residueIndex: residueIndex, atomIndex: atomIndex, symmetry: ps.symmetry.value(row) };
        };
        var entries = [];
        for (var i = 0; i < struct_conn._rowCount; i++) {
            var partnerA = _p(i, p1);
            var partnerB = _p(i, p2);
            if (partnerA === undefined || partnerB === undefined)
                continue;
            var type = conn_type_id.value(i);
            var orderType = (pdbx_value_order.value(i) || '').toLowerCase();
            var flags = 0 /* None */;
            var order = 1;
            switch (orderType) {
                case 'sing':
                    order = 1;
                    break;
                case 'doub':
                    order = 2;
                    break;
                case 'trip':
                    order = 3;
                    break;
                case 'quad':
                    order = 4;
                    break;
                default:
                    order = Object(_mol_model_structure_model_properties_atomic_bonds__WEBPACK_IMPORTED_MODULE_2__["getInterBondOrderFromTable"])(struct_conn.ptnr1_label_comp_id.value(i), struct_conn.ptnr1_label_atom_id.value(i), struct_conn.ptnr2_label_comp_id.value(i), struct_conn.ptnr2_label_atom_id.value(i));
            }
            switch (type) {
                case 'covale':
                    flags = 1 /* Covalent */;
                    break;
                case 'disulf':
                    flags = 1 /* Covalent */ | 8 /* Disulfide */;
                    break;
                case 'hydrog':
                    flags = 4 /* HydrogenBond */;
                    break;
                case 'metalc':
                    flags = 2 /* MetallicCoordination */;
                    break;
            }
            entries.push({
                rowIndex: i,
                flags: flags, order: order,
                distance: pdbx_dist_value.value(i),
                partnerA: partnerA, partnerB: partnerB
            });
        }
        return entries;
    }
    StructConn.getEntriesFromStructConn = getEntriesFromStructConn;
})(StructConn || (StructConn = {}));
//# sourceMappingURL=struct_conn.js.map

/***/ }),

/***/ "./lib/mol-model-formats/structure/property/partial-charge.js":
/*!********************************************************************!*\
  !*** ./lib/mol-model-formats/structure/property/partial-charge.js ***!
  \********************************************************************/
/*! exports provided: AtomPartialCharge */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "AtomPartialCharge", function() { return AtomPartialCharge; });
/* harmony import */ var _common_property__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../common/property */ "./lib/mol-model-formats/structure/common/property.js");
/**
 * Copyright (c) 2020 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */


var AtomPartialCharge;
(function (AtomPartialCharge) {
    AtomPartialCharge.Descriptor = {
        name: 'atom_partial_charge',
    };
    AtomPartialCharge.Provider = _common_property__WEBPACK_IMPORTED_MODULE_0__["FormatPropertyProvider"].create(AtomPartialCharge.Descriptor);
})(AtomPartialCharge || (AtomPartialCharge = {}));
//# sourceMappingURL=partial-charge.js.map

/***/ }),

/***/ "./lib/mol-model-formats/structure/property/secondary-structure.js":
/*!*************************************************************************!*\
  !*** ./lib/mol-model-formats/structure/property/secondary-structure.js ***!
  \*************************************************************************/
/*! exports provided: ModelSecondaryStructure */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ModelSecondaryStructure", function() { return ModelSecondaryStructure; });
/* harmony import */ var _mol_model_structure_model_types__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../../mol-model/structure/model/types */ "./lib/mol-model/structure/model/types.js");
/* harmony import */ var _mol_model_structure_model_properties_atomic__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../../mol-model/structure/model/properties/atomic */ "./lib/mol-model/structure/model/properties/atomic.js");
/* harmony import */ var _mol_model_structure_model_properties_seconday_structure__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../../mol-model/structure/model/properties/seconday-structure */ "./lib/mol-model/structure/model/properties/seconday-structure.js");
/* harmony import */ var _common_property__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../common/property */ "./lib/mol-model-formats/structure/common/property.js");
/**
 * Copyright (c) 2018-2020 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author David Sehnal <david.sehnal@gmail.com>
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */





var ModelSecondaryStructure;
(function (ModelSecondaryStructure) {
    ModelSecondaryStructure.Descriptor = {
        name: 'model_secondary_structure',
    };
    ModelSecondaryStructure.Provider = _common_property__WEBPACK_IMPORTED_MODULE_3__["FormatPropertyProvider"].create(ModelSecondaryStructure.Descriptor);
    function fromStruct(conf, sheetRange, hierarchy) {
        var map = new Map();
        var elements = [{ kind: 'none' }];
        addHelices(conf, map, elements);
        // must add Helices 1st because of 'key' value assignment.
        addSheets(sheetRange, map, conf._rowCount, elements);
        var n = hierarchy.residues._rowCount;
        var getIndex = function (rI) { return rI; };
        var secStruct = {
            type: new Int32Array(n),
            key: new Int32Array(n),
            elements: elements
        };
        if (map.size > 0)
            assignSecondaryStructureRanges(hierarchy, map, secStruct);
        return Object(_mol_model_structure_model_properties_seconday_structure__WEBPACK_IMPORTED_MODULE_2__["SecondaryStructure"])(secStruct.type, secStruct.key, secStruct.elements, getIndex);
    }
    ModelSecondaryStructure.fromStruct = fromStruct;
})(ModelSecondaryStructure || (ModelSecondaryStructure = {}));
function addHelices(cat, map, elements) {
    if (!cat._rowCount)
        return;
    var beg_label_asym_id = cat.beg_label_asym_id, beg_auth_seq_id = cat.beg_auth_seq_id, pdbx_beg_PDB_ins_code = cat.pdbx_beg_PDB_ins_code;
    var end_auth_seq_id = cat.end_auth_seq_id, pdbx_end_PDB_ins_code = cat.pdbx_end_PDB_ins_code;
    var pdbx_PDB_helix_class = cat.pdbx_PDB_helix_class, conf_type_id = cat.conf_type_id, details = cat.details;
    for (var i = 0, _i = cat._rowCount; i < _i; i++) {
        var type = _mol_model_structure_model_types__WEBPACK_IMPORTED_MODULE_0__["SecondaryStructureType"].create(pdbx_PDB_helix_class.valueKind(i) === 0 /* Present */
            ? _mol_model_structure_model_types__WEBPACK_IMPORTED_MODULE_0__["SecondaryStructureType"].SecondaryStructurePdb[pdbx_PDB_helix_class.value(i)]
            : conf_type_id.valueKind(i) === 0 /* Present */
                ? _mol_model_structure_model_types__WEBPACK_IMPORTED_MODULE_0__["SecondaryStructureType"].SecondaryStructureMmcif[conf_type_id.value(i)]
                : 536870912 /* NA */);
        var element = {
            kind: 'helix',
            flags: type,
            type_id: conf_type_id.valueKind(i) === 0 /* Present */ ? conf_type_id.value(i) : 'HELIX_P',
            helix_class: pdbx_PDB_helix_class.value(i),
            details: details.valueKind(i) === 0 /* Present */ ? details.value(i) : void 0
        };
        var entry = {
            startSeqNumber: beg_auth_seq_id.value(i),
            startInsCode: pdbx_beg_PDB_ins_code.value(i),
            endSeqNumber: end_auth_seq_id.value(i),
            endInsCode: pdbx_end_PDB_ins_code.value(i),
            type: type,
            key: elements.length
        };
        elements[elements.length] = element;
        var asymId = beg_label_asym_id.value(i);
        if (map.has(asymId)) {
            var entries = map.get(asymId);
            if (entries.has(entry.startSeqNumber)) {
                entries.get(entry.startSeqNumber).push(entry);
            }
            else {
                entries.set(entry.startSeqNumber, [entry]);
            }
        }
        else {
            map.set(asymId, new Map([[entry.startSeqNumber, [entry]]]));
        }
    }
}
function addSheets(cat, map, sheetCount, elements) {
    if (!cat._rowCount)
        return;
    var beg_label_asym_id = cat.beg_label_asym_id, beg_auth_seq_id = cat.beg_auth_seq_id, pdbx_beg_PDB_ins_code = cat.pdbx_beg_PDB_ins_code;
    var end_auth_seq_id = cat.end_auth_seq_id, pdbx_end_PDB_ins_code = cat.pdbx_end_PDB_ins_code;
    var sheet_id = cat.sheet_id;
    var sheet_id_key = new Map();
    var currentKey = sheetCount + 1;
    for (var i = 0, _i = cat._rowCount; i < _i; i++) {
        var id = sheet_id.value(i);
        var key = void 0;
        if (sheet_id_key.has(id))
            key = sheet_id_key.get(id);
        else {
            key = currentKey++;
            sheet_id_key.set(id, key);
        }
        var type = _mol_model_structure_model_types__WEBPACK_IMPORTED_MODULE_0__["SecondaryStructureType"].create(4 /* Beta */ | 8388608 /* BetaSheet */);
        var element = {
            kind: 'sheet',
            flags: type,
            sheet_id: id,
            symmetry: void 0
        };
        var entry = {
            startSeqNumber: beg_auth_seq_id.value(i),
            startInsCode: pdbx_beg_PDB_ins_code.value(i),
            endSeqNumber: end_auth_seq_id.value(i),
            endInsCode: pdbx_end_PDB_ins_code.value(i),
            type: type,
            key: elements.length
        };
        elements[elements.length] = element;
        var asymId = beg_label_asym_id.value(i);
        if (map.has(asymId)) {
            var entries = map.get(asymId);
            if (entries.has(entry.startSeqNumber)) {
                entries.get(entry.startSeqNumber).push(entry);
            }
            else {
                entries.set(entry.startSeqNumber, [entry]);
            }
        }
        else {
            map.set(asymId, new Map([[entry.startSeqNumber, [entry]]]));
        }
    }
    return;
}
function assignSecondaryStructureEntry(hierarchy, entry, resStart, resEnd, data) {
    var _a = hierarchy.residues, auth_seq_id = _a.auth_seq_id, pdbx_PDB_ins_code = _a.pdbx_PDB_ins_code;
    var endSeqNumber = entry.endSeqNumber, endInsCode = entry.endInsCode, key = entry.key, type = entry.type;
    var rI = resStart;
    while (rI < resEnd) {
        var seqNumber = auth_seq_id.value(rI);
        data.type[rI] = type;
        data.key[rI] = key;
        if ((seqNumber > endSeqNumber) ||
            (seqNumber === endSeqNumber && pdbx_PDB_ins_code.value(rI) === endInsCode)) {
            break;
        }
        rI++;
    }
}
function assignSecondaryStructureRanges(hierarchy, map, data) {
    var chainCount = hierarchy.chainAtomSegments.count;
    var label_asym_id = hierarchy.chains.label_asym_id;
    var _a = hierarchy.residues, auth_seq_id = _a.auth_seq_id, pdbx_PDB_ins_code = _a.pdbx_PDB_ins_code;
    for (var cI = 0; cI < chainCount; cI++) {
        var resStart = _mol_model_structure_model_properties_atomic__WEBPACK_IMPORTED_MODULE_1__["AtomicHierarchy"].chainStartResidueIndex(hierarchy, cI), resEnd = _mol_model_structure_model_properties_atomic__WEBPACK_IMPORTED_MODULE_1__["AtomicHierarchy"].chainEndResidueIndexExcl(hierarchy, cI);
        var asymId = label_asym_id.value(cI);
        if (map.has(asymId)) {
            var entries = map.get(asymId);
            for (var rI = resStart; rI < resEnd; rI++) {
                var seqNumber = auth_seq_id.value(rI);
                if (entries.has(seqNumber)) {
                    var entryList = entries.get(seqNumber);
                    for (var _b = 0, entryList_1 = entryList; _b < entryList_1.length; _b++) {
                        var entry = entryList_1[_b];
                        var insCode = pdbx_PDB_ins_code.value(rI);
                        if (entry.startInsCode !== insCode)
                            continue;
                        assignSecondaryStructureEntry(hierarchy, entry, rI, resEnd, data);
                    }
                }
            }
        }
    }
}
//# sourceMappingURL=secondary-structure.js.map

/***/ }),

/***/ "./lib/mol-model-formats/structure/property/symmetry.js":
/*!**************************************************************!*\
  !*** ./lib/mol-model-formats/structure/property/symmetry.js ***!
  \**************************************************************/
/*! exports provided: ModelSymmetry */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ModelSymmetry", function() { return ModelSymmetry; });
/* harmony import */ var _mol_io_reader_cif_schema_mmcif__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../../mol-io/reader/cif/schema/mmcif */ "./lib/mol-io/reader/cif/schema/mmcif.js");
/* harmony import */ var _mol_math_geometry__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../../mol-math/geometry */ "./lib/mol-math/geometry.js");
/* harmony import */ var _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../../mol-math/linear-algebra */ "./lib/mol-math/linear-algebra.js");
/* harmony import */ var _assembly__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./assembly */ "./lib/mol-model-formats/structure/property/assembly.js");
/* harmony import */ var _common_property__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../common/property */ "./lib/mol-model-formats/structure/common/property.js");
/**
 * Copyright (c) 2017-2020 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author David Sehnal <david.sehnal@gmail.com>
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */






var ModelSymmetry;
(function (ModelSymmetry) {
    ModelSymmetry.Descriptor = {
        name: 'model_symmetry',
    };
    ModelSymmetry.Provider = _common_property__WEBPACK_IMPORTED_MODULE_4__["FormatPropertyProvider"].create(ModelSymmetry.Descriptor);
    function fromData(data) {
        var assemblies = Object(_assembly__WEBPACK_IMPORTED_MODULE_3__["createAssemblies"])(data.pdbx_struct_assembly, data.pdbx_struct_assembly_gen, data.pdbx_struct_oper_list);
        var spacegroup = getSpacegroup(data.symmetry, data.cell);
        var isNonStandardCrystalFrame = checkNonStandardCrystalFrame(data.atom_sites, spacegroup);
        return { assemblies: assemblies, spacegroup: spacegroup, isNonStandardCrystalFrame: isNonStandardCrystalFrame, ncsOperators: getNcsOperators(data.struct_ncs_oper) };
    }
    ModelSymmetry.fromData = fromData;
    function fromCell(size, anglesInRadians) {
        var spaceCell = _mol_math_geometry__WEBPACK_IMPORTED_MODULE_1__["SpacegroupCell"].create('P 1', size, anglesInRadians);
        var spacegroup = _mol_math_geometry__WEBPACK_IMPORTED_MODULE_1__["Spacegroup"].create(spaceCell);
        return { assemblies: [], spacegroup: spacegroup, isNonStandardCrystalFrame: false };
    }
    ModelSymmetry.fromCell = fromCell;
})(ModelSymmetry || (ModelSymmetry = {}));
function checkNonStandardCrystalFrame(atom_sites, spacegroup) {
    if (atom_sites._rowCount === 0)
        return false;
    // TODO: parse atom_sites transform and check if it corresponds to the toFractional matrix
    return false;
}
function getSpacegroupNameOrNumber(symmetry) {
    var groupNumber = symmetry['Int_Tables_number'].value(0);
    var groupName = symmetry['space_group_name_H-M'].value(0);
    if (!symmetry['Int_Tables_number'].isDefined)
        return groupName;
    if (!symmetry['space_group_name_H-M'].isDefined)
        return groupNumber;
    return groupName;
}
function getSpacegroup(symmetry, cell) {
    if (symmetry._rowCount === 0 || cell._rowCount === 0)
        return _mol_math_geometry__WEBPACK_IMPORTED_MODULE_1__["Spacegroup"].ZeroP1;
    var nameOrNumber = getSpacegroupNameOrNumber(symmetry);
    var spaceCell = _mol_math_geometry__WEBPACK_IMPORTED_MODULE_1__["SpacegroupCell"].create(nameOrNumber, _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_2__["Vec3"].create(cell.length_a.value(0), cell.length_b.value(0), cell.length_c.value(0)), _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_2__["Vec3"].scale(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_2__["Vec3"].zero(), _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_2__["Vec3"].create(cell.angle_alpha.value(0), cell.angle_beta.value(0), cell.angle_gamma.value(0)), Math.PI / 180));
    return _mol_math_geometry__WEBPACK_IMPORTED_MODULE_1__["Spacegroup"].create(spaceCell);
}
function getNcsOperators(struct_ncs_oper) {
    if (struct_ncs_oper._rowCount === 0)
        return void 0;
    var id = struct_ncs_oper.id, matrix = struct_ncs_oper.matrix, vector = struct_ncs_oper.vector;
    var matrixSpace = _mol_io_reader_cif_schema_mmcif__WEBPACK_IMPORTED_MODULE_0__["mmCIF_Schema"].struct_ncs_oper.matrix.space, vectorSpace = _mol_io_reader_cif_schema_mmcif__WEBPACK_IMPORTED_MODULE_0__["mmCIF_Schema"].struct_ncs_oper.vector.space;
    var opers = [];
    for (var i = 0; i < struct_ncs_oper._rowCount; i++) {
        var m = _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_2__["Tensor"].toMat3(Object(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_2__["Mat3"])(), matrixSpace, matrix.value(i));
        var v = _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_2__["Tensor"].toVec3(Object(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_2__["Vec3"])(), vectorSpace, vector.value(i));
        if (!_mol_math_geometry__WEBPACK_IMPORTED_MODULE_1__["SymmetryOperator"].checkIfRotationAndTranslation(m, v))
            continue;
        // ignore non-identity 'given' NCS operators
        if (struct_ncs_oper.code.value(i) === 'given' && !_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_2__["Mat3"].isIdentity(m) && !_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_2__["Vec3"].isZero(v))
            continue;
        var ncsId = id.value(i);
        opers[opers.length] = _mol_math_geometry__WEBPACK_IMPORTED_MODULE_1__["SymmetryOperator"].ofRotationAndOffset("ncs_" + ncsId, m, v, ncsId);
    }
    return opers;
}
//# sourceMappingURL=symmetry.js.map

/***/ }),

/***/ "./lib/mol-model-formats/structure/psf.js":
/*!************************************************!*\
  !*** ./lib/mol-model-formats/structure/psf.js ***!
  \************************************************/
/*! exports provided: PsfFormat, topologyFromPsf */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "PsfFormat", function() { return PsfFormat; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "topologyFromPsf", function() { return topologyFromPsf; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _mol_data_db__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../mol-data/db */ "./lib/mol-data/db.js");
/* harmony import */ var _mol_model_structure_model_types__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../mol-model/structure/model/types */ "./lib/mol-model/structure/model/types.js");
/* harmony import */ var _mol_model_structure_topology_topology__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../mol-model/structure/topology/topology */ "./lib/mol-model/structure/topology/topology.js");
/* harmony import */ var _mol_task__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../mol-task */ "./lib/mol-task/index.js");
/* harmony import */ var _basic_schema__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./basic/schema */ "./lib/mol-model-formats/structure/basic/schema.js");
/* harmony import */ var _common_component__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ./common/component */ "./lib/mol-model-formats/structure/common/component.js");
/* harmony import */ var _common_entity__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ./common/entity */ "./lib/mol-model-formats/structure/common/entity.js");
/* harmony import */ var _common_util__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ./common/util */ "./lib/mol-model-formats/structure/common/util.js");
/* harmony import */ var _util__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ./util */ "./lib/mol-model-formats/structure/util.js");
/**
 * Copyright (c) 2019-2020 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */










function getBasic(atoms) {
    var entityIds = new Array(atoms.count);
    var asymIds = new Array(atoms.count);
    var seqIds = new Uint32Array(atoms.count);
    var ids = new Uint32Array(atoms.count);
    var entityBuilder = new _common_entity__WEBPACK_IMPORTED_MODULE_7__["EntityBuilder"]();
    var componentBuilder = new _common_component__WEBPACK_IMPORTED_MODULE_6__["ComponentBuilder"](atoms.residueId, atoms.atomName);
    var currentEntityId = '';
    var currentAsymIndex = 0;
    var currentAsymId = '';
    var currentSeqId = 0;
    var currentSegmentName = atoms.segmentName.value(0), segmentChanged = false;
    var prevMoleculeType = 0 /* Unknown */;
    var prevResidueNumber = -1;
    for (var i = 0, il = atoms.count; i < il; ++i) {
        var residueNumber = atoms.residueId.value(i);
        var segmentName = atoms.segmentName.value(i);
        if (currentSegmentName !== segmentName) {
            currentAsymId = Object(_common_util__WEBPACK_IMPORTED_MODULE_8__["getChainId"])(currentAsymIndex);
            currentAsymIndex += 1;
            currentSeqId = 0;
            segmentChanged = true;
            currentSegmentName = segmentName;
        }
        else {
            segmentChanged = false;
        }
        if (segmentChanged || residueNumber !== prevResidueNumber) {
            var compId = atoms.residueName.value(i);
            var moleculeType = Object(_mol_model_structure_model_types__WEBPACK_IMPORTED_MODULE_2__["getMoleculeType"])(componentBuilder.add(compId, i).type, compId);
            if (!segmentChanged && (moleculeType !== prevMoleculeType || residueNumber !== prevResidueNumber + 1)) {
                currentAsymId = Object(_common_util__WEBPACK_IMPORTED_MODULE_8__["getChainId"])(currentAsymIndex);
                currentAsymIndex += 1;
                currentSeqId = 0;
            }
            currentEntityId = entityBuilder.getEntityId(compId, moleculeType, currentAsymId);
            currentSeqId += 1;
            prevResidueNumber = residueNumber;
            prevMoleculeType = moleculeType;
        }
        entityIds[i] = currentEntityId;
        asymIds[i] = currentAsymId;
        seqIds[i] = currentSeqId;
        ids[i] = i;
    }
    var atom_site = _mol_data_db__WEBPACK_IMPORTED_MODULE_1__["Table"].ofPartialColumns(_basic_schema__WEBPACK_IMPORTED_MODULE_5__["BasicSchema"].atom_site, {
        auth_asym_id: atoms.segmentName,
        auth_atom_id: atoms.atomName,
        auth_comp_id: atoms.residueName,
        auth_seq_id: atoms.residueId,
        id: _mol_data_db__WEBPACK_IMPORTED_MODULE_1__["Column"].ofIntArray(ids),
        label_asym_id: _mol_data_db__WEBPACK_IMPORTED_MODULE_1__["Column"].ofStringArray(asymIds),
        label_atom_id: atoms.atomName,
        label_comp_id: atoms.residueName,
        label_seq_id: _mol_data_db__WEBPACK_IMPORTED_MODULE_1__["Column"].ofIntArray(seqIds),
        label_entity_id: _mol_data_db__WEBPACK_IMPORTED_MODULE_1__["Column"].ofStringArray(entityIds),
        occupancy: _mol_data_db__WEBPACK_IMPORTED_MODULE_1__["Column"].ofConst(1, atoms.count, _mol_data_db__WEBPACK_IMPORTED_MODULE_1__["Column"].Schema.float),
        type_symbol: _mol_data_db__WEBPACK_IMPORTED_MODULE_1__["Column"].ofStringArray(_mol_data_db__WEBPACK_IMPORTED_MODULE_1__["Column"].mapToArray(atoms.atomName, function (s) { return Object(_util__WEBPACK_IMPORTED_MODULE_9__["guessElementSymbolString"])(s); })),
        pdbx_PDB_model_num: _mol_data_db__WEBPACK_IMPORTED_MODULE_1__["Column"].ofConst(1, atoms.count, _mol_data_db__WEBPACK_IMPORTED_MODULE_1__["Column"].Schema.int),
    }, atoms.count);
    return Object(_basic_schema__WEBPACK_IMPORTED_MODULE_5__["createBasic"])({
        entity: entityBuilder.getEntityTable(),
        chem_comp: componentBuilder.getChemCompTable(),
        atom_site: atom_site
    });
}
//

var PsfFormat;
(function (PsfFormat) {
    function is(x) {
        return (x === null || x === void 0 ? void 0 : x.kind) === 'psf';
    }
    PsfFormat.is = is;
    function fromPsf(psf) {
        return { kind: 'psf', name: psf.id, data: psf };
    }
    PsfFormat.fromPsf = fromPsf;
})(PsfFormat || (PsfFormat = {}));
function topologyFromPsf(psf) {
    var _this = this;
    return _mol_task__WEBPACK_IMPORTED_MODULE_4__["Task"].create('Parse PSF', function (ctx) { return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"])(_this, void 0, void 0, function () {
        var format, basic, _a, atomIdA, atomIdB, bonds;
        return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__generator"])(this, function (_b) {
            format = PsfFormat.fromPsf(psf);
            basic = getBasic(psf.atoms);
            _a = psf.bonds, atomIdA = _a.atomIdA, atomIdB = _a.atomIdB;
            bonds = {
                indexA: _mol_data_db__WEBPACK_IMPORTED_MODULE_1__["Column"].ofLambda({
                    value: function (row) { return atomIdA.value(row) - 1; },
                    rowCount: atomIdA.rowCount,
                    schema: atomIdA.schema,
                }),
                indexB: _mol_data_db__WEBPACK_IMPORTED_MODULE_1__["Column"].ofLambda({
                    value: function (row) { return atomIdB.value(row) - 1; },
                    rowCount: atomIdB.rowCount,
                    schema: atomIdB.schema,
                }),
                order: _mol_data_db__WEBPACK_IMPORTED_MODULE_1__["Column"].ofConst(1, psf.bonds.count, _mol_data_db__WEBPACK_IMPORTED_MODULE_1__["Column"].Schema.int)
            };
            return [2 /*return*/, _mol_model_structure_topology_topology__WEBPACK_IMPORTED_MODULE_3__["Topology"].create(psf.id, basic, bonds, format)];
        });
    }); });
}
//# sourceMappingURL=psf.js.map

/***/ }),

/***/ "./lib/mol-model-formats/structure/util.js":
/*!*************************************************!*\
  !*** ./lib/mol-model-formats/structure/util.js ***!
  \*************************************************/
/*! exports provided: guessElementSymbolTokens, guessElementSymbolString */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "guessElementSymbolTokens", function() { return guessElementSymbolTokens; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "guessElementSymbolString", function() { return guessElementSymbolString; });
/* harmony import */ var _mol_io_reader_common_text_tokenizer__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../mol-io/reader/common/text/tokenizer */ "./lib/mol-io/reader/common/text/tokenizer.js");
/**
 * Copyright (c) 2019-2020 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */

function guessElementSymbolTokens(tokens, str, start, end) {
    var s = start, e = end - 1;
    // trim spaces and numbers
    var c = str.charCodeAt(s);
    while ((c === 32 || (c >= 48 && c <= 57)) && s <= e)
        c = str.charCodeAt(++s);
    c = str.charCodeAt(e);
    while ((c === 32 || (c >= 48 && c <= 57)) && e >= s)
        c = str.charCodeAt(--e);
    ++e;
    if (s === e)
        return _mol_io_reader_common_text_tokenizer__WEBPACK_IMPORTED_MODULE_0__["TokenBuilder"].add(tokens, s, e); // empty
    if (s + 1 === e)
        return _mol_io_reader_common_text_tokenizer__WEBPACK_IMPORTED_MODULE_0__["TokenBuilder"].add(tokens, s, e); // one char
    c = str.charCodeAt(s);
    if (s + 2 === e) { // two chars
        var c2 = str.charCodeAt(s + 1);
        if (((c === 78 || c === 110) && (c2 === 65 || c2 === 97)) || // NA na Na nA
            ((c === 67 || c === 99) && (c2 === 76 || c2 === 108)) || // CL
            ((c === 70 || c === 102) && (c2 === 69 || c2 === 101)) || // FE
            ((c === 83 || c === 115) && (c2 === 73 || c2 === 105)) || // SI
            ((c === 66 || c === 98) && (c2 === 82 || c2 === 114)) || // BR
            ((c === 65 || c === 97) && (c2 === 83 || c2 === 115)) // AS
        )
            return _mol_io_reader_common_text_tokenizer__WEBPACK_IMPORTED_MODULE_0__["TokenBuilder"].add(tokens, s, s + 2);
    }
    if (c === 67 || c === 99 || // C c
        c === 72 || c === 104 || // H h
        c === 78 || c === 110 || // N n
        c === 79 || c === 111 || // O o
        c === 80 || c === 112 || // P p
        c === 83 || c === 115 // S s
    )
        return _mol_io_reader_common_text_tokenizer__WEBPACK_IMPORTED_MODULE_0__["TokenBuilder"].add(tokens, s, s + 1);
    _mol_io_reader_common_text_tokenizer__WEBPACK_IMPORTED_MODULE_0__["TokenBuilder"].add(tokens, s, s); // no reasonable guess, add empty token
}
var reTrimSpacesAndNumbers = /^[\s\d]+|[\s\d]+$/g;
function guessElementSymbolString(str) {
    // trim spaces and numbers, convert to upper case
    str = str.replace(reTrimSpacesAndNumbers, '').toUpperCase();
    var l = str.length;
    if (l === 0)
        return str; // empty
    if (l === 1)
        return str; // one char
    if (l === 2) { // two chars
        if (str === 'NA' || str === 'CL' || str === 'FE' || str === 'SI' ||
            str === 'BR' || str === 'AS')
            return str;
    }
    var c = str[0];
    if (c === 'C' || c === 'H' || c === 'N' || c === 'O' || c === 'P' || c === 'S')
        return c;
    return ''; // no reasonable guess, return empty string
}
//# sourceMappingURL=util.js.map

/***/ }),

/***/ "./lib/mol-model-formats/structure/xtc.js":
/*!************************************************!*\
  !*** ./lib/mol-model-formats/structure/xtc.js ***!
  \************************************************/
/*! exports provided: coordinatesFromXtc */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "coordinatesFromXtc", function() { return coordinatesFromXtc; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _mol_task__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../mol-task */ "./lib/mol-task/index.js");
/* harmony import */ var _mol_model_structure_coordinates__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../mol-model/structure/coordinates */ "./lib/mol-model/structure/coordinates.js");
/* harmony import */ var _mol_math_geometry_spacegroup_cell__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../mol-math/geometry/spacegroup/cell */ "./lib/mol-math/geometry/spacegroup/cell.js");
/* harmony import */ var _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../mol-math/linear-algebra */ "./lib/mol-math/linear-algebra.js");
/**
 * Copyright (c) 2020 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author David Sehnal <david.sehnal@gmail.com>
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */





function coordinatesFromXtc(file) {
    var _this = this;
    return _mol_task__WEBPACK_IMPORTED_MODULE_1__["Task"].create('Parse XTC', function (ctx) { return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"])(_this, void 0, void 0, function () {
        var deltaTime, offsetTime, frames, i, il, box, x, y, z;
        return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__generator"])(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, ctx.update('Converting to coordinates')];
                case 1:
                    _a.sent();
                    deltaTime = Object(_mol_model_structure_coordinates__WEBPACK_IMPORTED_MODULE_2__["Time"])(file.deltaTime, 'step');
                    offsetTime = Object(_mol_model_structure_coordinates__WEBPACK_IMPORTED_MODULE_2__["Time"])(file.timeOffset, deltaTime.unit);
                    frames = [];
                    for (i = 0, il = file.frames.length; i < il; ++i) {
                        box = file.boxes[i];
                        x = _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_4__["Vec3"].fromArray(Object(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_4__["Vec3"])(), box, 0);
                        y = _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_4__["Vec3"].fromArray(Object(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_4__["Vec3"])(), box, 3);
                        z = _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_4__["Vec3"].fromArray(Object(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_4__["Vec3"])(), box, 6);
                        frames.push({
                            elementCount: file.frames[i].count,
                            cell: _mol_math_geometry_spacegroup_cell__WEBPACK_IMPORTED_MODULE_3__["Cell"].fromBasis(x, y, z),
                            x: file.frames[i].x,
                            y: file.frames[i].y,
                            z: file.frames[i].z,
                            time: Object(_mol_model_structure_coordinates__WEBPACK_IMPORTED_MODULE_2__["Time"])(offsetTime.value + deltaTime.value * i, deltaTime.unit)
                        });
                    }
                    return [2 /*return*/, _mol_model_structure_coordinates__WEBPACK_IMPORTED_MODULE_2__["Coordinates"].create(frames, deltaTime, offsetTime)];
            }
        });
    }); });
}
//# sourceMappingURL=xtc.js.map

/***/ }),

/***/ "./lib/mol-model-formats/volume/ccp4.js":
/*!**********************************************!*\
  !*** ./lib/mol-model-formats/volume/ccp4.js ***!
  \**********************************************/
/*! exports provided: getCcp4Origin, volumeFromCcp4, Ccp4Format */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getCcp4Origin", function() { return getCcp4Origin; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "volumeFromCcp4", function() { return volumeFromCcp4; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Ccp4Format", function() { return Ccp4Format; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _mol_task__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../mol-task */ "./lib/mol-task/index.js");
/* harmony import */ var _mol_math_geometry__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../mol-math/geometry */ "./lib/mol-math/geometry.js");
/* harmony import */ var _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../mol-math/linear-algebra */ "./lib/mol-math/linear-algebra.js");
/* harmony import */ var _mol_math_misc__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../mol-math/misc */ "./lib/mol-math/misc.js");
/* harmony import */ var _mol_io_reader_ccp4_parser__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../mol-io/reader/ccp4/parser */ "./lib/mol-io/reader/ccp4/parser.js");
/* harmony import */ var _mol_io_common_typed_array__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../../mol-io/common/typed-array */ "./lib/mol-io/common/typed-array.js");
/* harmony import */ var _mol_util_array__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../../mol-util/array */ "./lib/mol-util/array.js");
/* harmony import */ var _mol_model_custom_property__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ../../mol-model/custom-property */ "./lib/mol-model/custom-property.js");
/**
 * Copyright (c) 2018-2020 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */









/** When available (e.g. in MRC files) use ORIGIN records instead of N[CRS]START */
function getCcp4Origin(header) {
    if (header.originX === 0.0 && header.originY === 0.0 && header.originZ === 0.0) {
        return _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_3__["Vec3"].create(header.NCSTART, header.NRSTART, header.NSSTART);
    }
    else {
        return _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_3__["Vec3"].create(header.originX / (header.xLength / header.NX), header.originY / (header.yLength / header.NY), header.originZ / (header.zLength / header.NZ));
    }
}
function getTypedArrayCtor(header) {
    var valueType = Object(_mol_io_reader_ccp4_parser__WEBPACK_IMPORTED_MODULE_5__["getCcp4ValueType"])(header);
    switch (valueType) {
        case _mol_io_common_typed_array__WEBPACK_IMPORTED_MODULE_6__["TypedArrayValueType"].Float32: return Float32Array;
        case _mol_io_common_typed_array__WEBPACK_IMPORTED_MODULE_6__["TypedArrayValueType"].Int8: return Int8Array;
        case _mol_io_common_typed_array__WEBPACK_IMPORTED_MODULE_6__["TypedArrayValueType"].Int16: return Int16Array;
        case _mol_io_common_typed_array__WEBPACK_IMPORTED_MODULE_6__["TypedArrayValueType"].Uint16: return Uint16Array;
    }
    throw Error(valueType + " is not a supported value format.");
}
function volumeFromCcp4(source, params) {
    var _this = this;
    return _mol_task__WEBPACK_IMPORTED_MODULE_1__["Task"].create('Create Volume', function (ctx) { return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"])(_this, void 0, void 0, function () {
        var header, values, size, angles, spacegroup, cell, axis_order_fast_to_slow, normalizeOrder, grid, extent, origin, gridOrigin, origin_frac, dimensions_frac, space, data, calcStats;
        return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__generator"])(this, function (_a) {
            header = source.header, values = source.values;
            size = _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_3__["Vec3"].create(header.xLength, header.yLength, header.zLength);
            if (params && params.voxelSize)
                _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_3__["Vec3"].mul(size, size, params.voxelSize);
            angles = _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_3__["Vec3"].create(Object(_mol_math_misc__WEBPACK_IMPORTED_MODULE_4__["degToRad"])(header.alpha), Object(_mol_math_misc__WEBPACK_IMPORTED_MODULE_4__["degToRad"])(header.beta), Object(_mol_math_misc__WEBPACK_IMPORTED_MODULE_4__["degToRad"])(header.gamma));
            spacegroup = header.ISPG > 65536 ? 0 : header.ISPG;
            cell = _mol_math_geometry__WEBPACK_IMPORTED_MODULE_2__["SpacegroupCell"].create(spacegroup || 'P 1', size, angles);
            axis_order_fast_to_slow = _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_3__["Vec3"].create(header.MAPC - 1, header.MAPR - 1, header.MAPS - 1);
            normalizeOrder = _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_3__["Tensor"].convertToCanonicalAxisIndicesFastToSlow(axis_order_fast_to_slow);
            grid = [header.NX, header.NY, header.NZ];
            extent = normalizeOrder([header.NC, header.NR, header.NS]);
            origin = getCcp4Origin(header);
            if (params === null || params === void 0 ? void 0 : params.offset)
                _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_3__["Vec3"].add(origin, origin, params.offset);
            gridOrigin = normalizeOrder(origin);
            origin_frac = _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_3__["Vec3"].create(gridOrigin[0] / grid[0], gridOrigin[1] / grid[1], gridOrigin[2] / grid[2]);
            dimensions_frac = _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_3__["Vec3"].create(extent[0] / grid[0], extent[1] / grid[1], extent[2] / grid[2]);
            space = _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_3__["Tensor"].Space(extent, _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_3__["Tensor"].invertAxisOrder(axis_order_fast_to_slow), getTypedArrayCtor(header));
            data = _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_3__["Tensor"].create(space, _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_3__["Tensor"].Data1(values));
            calcStats = header.AMIN === 0 && header.AMAX === 0 && header.AMEAN === 0 && header.ARMS === 0;
            return [2 /*return*/, {
                    label: params === null || params === void 0 ? void 0 : params.label,
                    entryId: params === null || params === void 0 ? void 0 : params.entryId,
                    grid: {
                        transform: { kind: 'spacegroup', cell: cell, fractionalBox: _mol_math_geometry__WEBPACK_IMPORTED_MODULE_2__["Box3D"].create(origin_frac, _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_3__["Vec3"].add(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_3__["Vec3"].zero(), origin_frac, dimensions_frac)) },
                        cells: data,
                        stats: {
                            min: (isNaN(header.AMIN) || calcStats) ? Object(_mol_util_array__WEBPACK_IMPORTED_MODULE_7__["arrayMin"])(values) : header.AMIN,
                            max: (isNaN(header.AMAX) || calcStats) ? Object(_mol_util_array__WEBPACK_IMPORTED_MODULE_7__["arrayMax"])(values) : header.AMAX,
                            mean: (isNaN(header.AMEAN) || calcStats) ? Object(_mol_util_array__WEBPACK_IMPORTED_MODULE_7__["arrayMean"])(values) : header.AMEAN,
                            sigma: (isNaN(header.ARMS) || header.ARMS === 0) ? Object(_mol_util_array__WEBPACK_IMPORTED_MODULE_7__["arrayRms"])(values) : header.ARMS
                        },
                    },
                    sourceData: Ccp4Format.create(source),
                    customProperties: new _mol_model_custom_property__WEBPACK_IMPORTED_MODULE_8__["CustomProperties"](),
                    _propertyData: Object.create(null),
                }];
        });
    }); });
}
//

var Ccp4Format;
(function (Ccp4Format) {
    function is(x) {
        return (x === null || x === void 0 ? void 0 : x.kind) === 'ccp4';
    }
    Ccp4Format.is = is;
    function create(ccp4) {
        return { kind: 'ccp4', name: ccp4.name, data: ccp4 };
    }
    Ccp4Format.create = create;
})(Ccp4Format || (Ccp4Format = {}));
//# sourceMappingURL=ccp4.js.map

/***/ }),

/***/ "./lib/mol-model-formats/volume/cube.js":
/*!**********************************************!*\
  !*** ./lib/mol-model-formats/volume/cube.js ***!
  \**********************************************/
/*! exports provided: volumeFromCube, CubeFormat */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "volumeFromCube", function() { return volumeFromCube; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CubeFormat", function() { return CubeFormat; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../mol-math/linear-algebra */ "./lib/mol-math/linear-algebra.js");
/* harmony import */ var _mol_task__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../mol-task */ "./lib/mol-task/index.js");
/* harmony import */ var _mol_util_array__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../mol-util/array */ "./lib/mol-util/array.js");
/* harmony import */ var _mol_model_custom_property__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../mol-model/custom-property */ "./lib/mol-model/custom-property.js");
/**
 * Copyright (c) 2020 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author David Sehnal <david.sehnal@gmail.com>
 */





function volumeFromCube(source, params) {
    var _this = this;
    return _mol_task__WEBPACK_IMPORTED_MODULE_2__["Task"].create('Create Volume', function () { return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"])(_this, void 0, void 0, function () {
        var header, sourceValues, space, values, _a, h, k, l, nth, o, s, u, v, w, data, matrix, basis;
        return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__generator"])(this, function (_b) {
            header = source.header, sourceValues = source.values;
            space = _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_1__["Tensor"].Space(header.dim, [0, 1, 2], Float64Array);
            if (header.dataSetIds.length === 0) {
                values = sourceValues;
            }
            else {
                _a = header.dim, h = _a[0], k = _a[1], l = _a[2];
                nth = ((params === null || params === void 0 ? void 0 : params.dataIndex) || 0) + 1;
                o = 0, s = 0;
                values = new Float64Array(h * k * l);
                for (u = 0; u < h; u++) {
                    for (v = 0; v < k; v++) {
                        for (w = 0; w < l; w++) {
                            values[o++] = sourceValues[s];
                            s += nth;
                        }
                    }
                }
            }
            data = _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_1__["Tensor"].create(space, _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_1__["Tensor"].Data1(values));
            matrix = _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_1__["Mat4"].fromTranslation(Object(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_1__["Mat4"])(), header.origin);
            basis = _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_1__["Mat4"].fromBasis(Object(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_1__["Mat4"])(), header.basisX, header.basisY, header.basisZ);
            _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_1__["Mat4"].mul(matrix, matrix, basis);
            return [2 /*return*/, {
                    label: params === null || params === void 0 ? void 0 : params.label,
                    entryId: params === null || params === void 0 ? void 0 : params.entryId,
                    grid: {
                        transform: { kind: 'matrix', matrix: matrix },
                        cells: data,
                        stats: {
                            min: Object(_mol_util_array__WEBPACK_IMPORTED_MODULE_3__["arrayMin"])(values),
                            max: Object(_mol_util_array__WEBPACK_IMPORTED_MODULE_3__["arrayMax"])(values),
                            mean: Object(_mol_util_array__WEBPACK_IMPORTED_MODULE_3__["arrayMean"])(values),
                            sigma: Object(_mol_util_array__WEBPACK_IMPORTED_MODULE_3__["arrayRms"])(values)
                        },
                    },
                    sourceData: CubeFormat.create(source),
                    customProperties: new _mol_model_custom_property__WEBPACK_IMPORTED_MODULE_4__["CustomProperties"](),
                    _propertyData: Object.create(null),
                }];
        });
    }); });
}
//

var CubeFormat;
(function (CubeFormat) {
    function is(x) {
        return (x === null || x === void 0 ? void 0 : x.kind) === 'cube';
    }
    CubeFormat.is = is;
    function create(cube) {
        return { kind: 'cube', name: cube.name, data: cube };
    }
    CubeFormat.create = create;
})(CubeFormat || (CubeFormat = {}));
//# sourceMappingURL=cube.js.map

/***/ }),

/***/ "./lib/mol-model-formats/volume/density-server.js":
/*!********************************************************!*\
  !*** ./lib/mol-model-formats/volume/density-server.js ***!
  \********************************************************/
/*! exports provided: volumeFromDensityServerData, DscifFormat */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "volumeFromDensityServerData", function() { return volumeFromDensityServerData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DscifFormat", function() { return DscifFormat; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _mol_task__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../mol-task */ "./lib/mol-task/index.js");
/* harmony import */ var _mol_math_geometry__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../mol-math/geometry */ "./lib/mol-math/geometry.js");
/* harmony import */ var _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../mol-math/linear-algebra */ "./lib/mol-math/linear-algebra.js");
/* harmony import */ var _mol_model_custom_property__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../mol-model/custom-property */ "./lib/mol-model/custom-property.js");
/**
 * Copyright (c) 2018 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author David Sehnal <david.sehnal@gmail.com>
 */





function volumeFromDensityServerData(source, params) {
    var _this = this;
    return _mol_task__WEBPACK_IMPORTED_MODULE_1__["Task"].create('Create Volume', function (ctx) { return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"])(_this, void 0, void 0, function () {
        var info, values, cell, axis_order_fast_to_slow, normalizeOrder, sample_count, tensorSpace, data, origin, dimensions;
        return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__generator"])(this, function (_a) {
            info = source.volume_data_3d_info, values = source.volume_data_3d;
            cell = _mol_math_geometry__WEBPACK_IMPORTED_MODULE_2__["SpacegroupCell"].create(info.spacegroup_number.value(0), _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_3__["Vec3"].ofArray(info.spacegroup_cell_size.value(0)), _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_3__["Vec3"].scale(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_3__["Vec3"].zero(), _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_3__["Vec3"].ofArray(info.spacegroup_cell_angles.value(0)), Math.PI / 180));
            axis_order_fast_to_slow = info.axis_order.value(0);
            normalizeOrder = _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_3__["Tensor"].convertToCanonicalAxisIndicesFastToSlow(axis_order_fast_to_slow);
            sample_count = normalizeOrder(info.sample_count.value(0));
            tensorSpace = _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_3__["Tensor"].Space(sample_count, _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_3__["Tensor"].invertAxisOrder(axis_order_fast_to_slow), Float32Array);
            data = _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_3__["Tensor"].create(tensorSpace, _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_3__["Tensor"].Data1(values.values.toArray({ array: Float32Array })));
            origin = _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_3__["Vec3"].ofArray(normalizeOrder(info.origin.value(0)));
            dimensions = _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_3__["Vec3"].ofArray(normalizeOrder(info.dimensions.value(0)));
            return [2 /*return*/, {
                    label: params === null || params === void 0 ? void 0 : params.label,
                    entryId: params === null || params === void 0 ? void 0 : params.entryId,
                    grid: {
                        transform: { kind: 'spacegroup', cell: cell, fractionalBox: _mol_math_geometry__WEBPACK_IMPORTED_MODULE_2__["Box3D"].create(origin, _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_3__["Vec3"].add(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_3__["Vec3"].zero(), origin, dimensions)) },
                        cells: data,
                        stats: {
                            min: info.min_sampled.value(0),
                            max: info.max_sampled.value(0),
                            mean: info.mean_sampled.value(0),
                            sigma: info.sigma_sampled.value(0)
                        },
                    },
                    sourceData: DscifFormat.create(source),
                    customProperties: new _mol_model_custom_property__WEBPACK_IMPORTED_MODULE_4__["CustomProperties"](),
                    _propertyData: Object.create(null),
                }];
        });
    }); });
}
//

var DscifFormat;
(function (DscifFormat) {
    function is(x) {
        return (x === null || x === void 0 ? void 0 : x.kind) === 'dscif';
    }
    DscifFormat.is = is;
    function create(dscif) {
        return { kind: 'dscif', name: dscif._name, data: dscif };
    }
    DscifFormat.create = create;
})(DscifFormat || (DscifFormat = {}));
//# sourceMappingURL=density-server.js.map

/***/ }),

/***/ "./lib/mol-model-formats/volume/dsn6.js":
/*!**********************************************!*\
  !*** ./lib/mol-model-formats/volume/dsn6.js ***!
  \**********************************************/
/*! exports provided: volumeFromDsn6, Dsn6Format */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "volumeFromDsn6", function() { return volumeFromDsn6; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Dsn6Format", function() { return Dsn6Format; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _mol_task__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../mol-task */ "./lib/mol-task/index.js");
/* harmony import */ var _mol_math_geometry__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../mol-math/geometry */ "./lib/mol-math/geometry.js");
/* harmony import */ var _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../mol-math/linear-algebra */ "./lib/mol-math/linear-algebra.js");
/* harmony import */ var _mol_math_misc__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../mol-math/misc */ "./lib/mol-math/misc.js");
/* harmony import */ var _mol_util_array__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../mol-util/array */ "./lib/mol-util/array.js");
/* harmony import */ var _mol_model_custom_property__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../../mol-model/custom-property */ "./lib/mol-model/custom-property.js");
/**
 * Copyright (c) 2019 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */







function volumeFromDsn6(source, params) {
    var _this = this;
    return _mol_task__WEBPACK_IMPORTED_MODULE_1__["Task"].create('Create Volume', function (ctx) { return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"])(_this, void 0, void 0, function () {
        var header, values, size, angles, cell, grid, extent, gridOrigin, origin_frac, dimensions_frac, space, data;
        return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__generator"])(this, function (_a) {
            header = source.header, values = source.values;
            size = _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_3__["Vec3"].create(header.xlen, header.ylen, header.zlen);
            if (params && params.voxelSize)
                _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_3__["Vec3"].mul(size, size, params.voxelSize);
            angles = _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_3__["Vec3"].create(Object(_mol_math_misc__WEBPACK_IMPORTED_MODULE_4__["degToRad"])(header.alpha), Object(_mol_math_misc__WEBPACK_IMPORTED_MODULE_4__["degToRad"])(header.beta), Object(_mol_math_misc__WEBPACK_IMPORTED_MODULE_4__["degToRad"])(header.gamma));
            cell = _mol_math_geometry__WEBPACK_IMPORTED_MODULE_2__["SpacegroupCell"].create('P 1', size, angles);
            grid = [header.xRate, header.yRate, header.zRate];
            extent = [header.xExtent, header.yExtent, header.zExtent];
            gridOrigin = [header.xStart, header.yStart, header.zStart];
            origin_frac = _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_3__["Vec3"].create(gridOrigin[0] / grid[0], gridOrigin[1] / grid[1], gridOrigin[2] / grid[2]);
            dimensions_frac = _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_3__["Vec3"].create(extent[0] / grid[0], extent[1] / grid[1], extent[2] / grid[2]);
            space = _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_3__["Tensor"].Space(extent, [0, 1, 2], Float32Array);
            data = _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_3__["Tensor"].create(space, _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_3__["Tensor"].Data1(values));
            return [2 /*return*/, {
                    label: params === null || params === void 0 ? void 0 : params.label,
                    entryId: params === null || params === void 0 ? void 0 : params.entryId,
                    grid: {
                        transform: { kind: 'spacegroup', cell: cell, fractionalBox: _mol_math_geometry__WEBPACK_IMPORTED_MODULE_2__["Box3D"].create(origin_frac, _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_3__["Vec3"].add(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_3__["Vec3"].zero(), origin_frac, dimensions_frac)) },
                        cells: data,
                        stats: {
                            min: Object(_mol_util_array__WEBPACK_IMPORTED_MODULE_5__["arrayMin"])(values),
                            max: Object(_mol_util_array__WEBPACK_IMPORTED_MODULE_5__["arrayMax"])(values),
                            mean: Object(_mol_util_array__WEBPACK_IMPORTED_MODULE_5__["arrayMean"])(values),
                            sigma: header.sigma !== undefined ? header.sigma : Object(_mol_util_array__WEBPACK_IMPORTED_MODULE_5__["arrayRms"])(values)
                        },
                    },
                    sourceData: Dsn6Format.create(source),
                    customProperties: new _mol_model_custom_property__WEBPACK_IMPORTED_MODULE_6__["CustomProperties"](),
                    _propertyData: Object.create(null),
                }];
        });
    }); });
}
//

var Dsn6Format;
(function (Dsn6Format) {
    function is(x) {
        return (x === null || x === void 0 ? void 0 : x.kind) === 'dsn6';
    }
    Dsn6Format.is = is;
    function create(dsn6) {
        return { kind: 'dsn6', name: dsn6.name, data: dsn6 };
    }
    Dsn6Format.create = create;
})(Dsn6Format || (Dsn6Format = {}));
//# sourceMappingURL=dsn6.js.map

/***/ }),

/***/ "./lib/mol-model-formats/volume/dx.js":
/*!********************************************!*\
  !*** ./lib/mol-model-formats/volume/dx.js ***!
  \********************************************/
/*! exports provided: volumeFromDx, DxFormat */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "volumeFromDx", function() { return volumeFromDx; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DxFormat", function() { return DxFormat; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../mol-math/linear-algebra */ "./lib/mol-math/linear-algebra.js");
/* harmony import */ var _mol_task__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../mol-task */ "./lib/mol-task/index.js");
/* harmony import */ var _mol_util_array__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../mol-util/array */ "./lib/mol-util/array.js");
/* harmony import */ var _mol_model_custom_property__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../mol-model/custom-property */ "./lib/mol-model/custom-property.js");
/**
 * Copyright (c) 2020 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author David Sehnal <david.sehnal@gmail.com>
 */





function volumeFromDx(source, params) {
    var _this = this;
    return _mol_task__WEBPACK_IMPORTED_MODULE_2__["Task"].create('Create Volume', function () { return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"])(_this, void 0, void 0, function () {
        var header, values, space, data, matrix, basis;
        return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__generator"])(this, function (_a) {
            header = source.header, values = source.values;
            space = _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_1__["Tensor"].Space(header.dim, [0, 1, 2], Float64Array);
            data = _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_1__["Tensor"].create(space, _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_1__["Tensor"].Data1(values));
            matrix = _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_1__["Mat4"].fromTranslation(Object(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_1__["Mat4"])(), header.min);
            basis = _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_1__["Mat4"].fromScaling(Object(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_1__["Mat4"])(), header.h);
            _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_1__["Mat4"].mul(matrix, matrix, basis);
            return [2 /*return*/, {
                    label: params === null || params === void 0 ? void 0 : params.label,
                    entryId: params === null || params === void 0 ? void 0 : params.entryId,
                    grid: {
                        transform: { kind: 'matrix', matrix: matrix },
                        cells: data,
                        stats: {
                            min: Object(_mol_util_array__WEBPACK_IMPORTED_MODULE_3__["arrayMin"])(values),
                            max: Object(_mol_util_array__WEBPACK_IMPORTED_MODULE_3__["arrayMax"])(values),
                            mean: Object(_mol_util_array__WEBPACK_IMPORTED_MODULE_3__["arrayMean"])(values),
                            sigma: Object(_mol_util_array__WEBPACK_IMPORTED_MODULE_3__["arrayRms"])(values)
                        },
                    },
                    sourceData: DxFormat.create(source),
                    customProperties: new _mol_model_custom_property__WEBPACK_IMPORTED_MODULE_4__["CustomProperties"](),
                    _propertyData: Object.create(null),
                }];
        });
    }); });
}
//

var DxFormat;
(function (DxFormat) {
    function is(x) {
        return (x === null || x === void 0 ? void 0 : x.kind) === 'dx';
    }
    DxFormat.is = is;
    function create(dx) {
        return { kind: 'dx', name: dx.name, data: dx };
    }
    DxFormat.create = create;
})(DxFormat || (DxFormat = {}));
//# sourceMappingURL=dx.js.map

/***/ }),

/***/ "./lib/mol-model-formats/volume/property.js":
/*!**************************************************!*\
  !*** ./lib/mol-model-formats/volume/property.js ***!
  \**************************************************/
/*! exports provided: PropertyProvider, RecommendedIsoValue */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "PropertyProvider", function() { return PropertyProvider; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "RecommendedIsoValue", function() { return RecommendedIsoValue; });
/**
 * Copyright (c) 2020 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */

var PropertyProvider;
(function (PropertyProvider) {
    function create(descriptor) {
        var name = descriptor.name;
        return {
            descriptor: descriptor,
            get: function (volume) {
                return volume._propertyData[name];
            },
            set: function (volume, value) {
                volume.customProperties.add(descriptor);
                volume._propertyData[name] = value;
            }
        };
    }
    PropertyProvider.create = create;
})(PropertyProvider || (PropertyProvider = {}));
//

var RecommendedIsoValue;
(function (RecommendedIsoValue) {
    RecommendedIsoValue.Descriptor = {
        name: 'recommended_iso_value',
    };
    RecommendedIsoValue.Provider = PropertyProvider.create(RecommendedIsoValue.Descriptor);
})(RecommendedIsoValue || (RecommendedIsoValue = {}));
//# sourceMappingURL=property.js.map

/***/ }),

/***/ "./lib/mol-model-props/common/custom-model-property.js":
/*!*************************************************************!*\
  !*** ./lib/mol-model-props/common/custom-model-property.js ***!
  \*************************************************************/
/*! exports provided: CustomModelProperty */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CustomModelProperty", function() { return CustomModelProperty; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../mol-util/param-definition */ "./lib/mol-util/param-definition.js");
/* harmony import */ var _mol_util__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../mol-util */ "./lib/mol-util/index.js");
/* harmony import */ var _mol_model_custom_property__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../mol-model/custom-property */ "./lib/mol-model/custom-property.js");
/* harmony import */ var _mol_util_string__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../mol-util/string */ "./lib/mol-util/string.js");
/**
 * Copyright (c) 2019-2020 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */






var CustomModelProperty;
(function (CustomModelProperty) {
    function createProvider(builder) {
        var _this = this;
        var descriptorName = builder.descriptor.name;
        var propertyDataName = builder.type === 'static' ? '_staticPropertyData' : '_dynamicPropertyData';
        var get = function (data) {
            if (!(descriptorName in data[propertyDataName])) {
                data[propertyDataName][descriptorName] = {
                    props: Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_1__["ParamDefinition"].getDefaultValues(builder.getParams(data))),
                    data: _mol_util__WEBPACK_IMPORTED_MODULE_2__["ValueBox"].create(undefined)
                };
            }
            return data[propertyDataName][descriptorName];
        };
        var set = function (data, props, value) {
            var property = get(data);
            data[propertyDataName][descriptorName] = {
                props: props,
                data: _mol_util__WEBPACK_IMPORTED_MODULE_2__["ValueBox"].withValue(property.data, value)
            };
        };
        return {
            label: builder.label,
            descriptor: builder.descriptor,
            isHidden: builder.isHidden,
            getParams: function (data) {
                var params = _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_1__["ParamDefinition"].clone(builder.getParams(data));
                _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_1__["ParamDefinition"].setDefaultValues(params, get(data).props);
                return params;
            },
            defaultParams: builder.defaultParams,
            isApplicable: builder.isApplicable,
            attach: function (ctx, data, props, addRef) {
                if (props === void 0) { props = {}; }
                return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"])(_this, void 0, void 0, function () {
                    var property, p, _a, value, assets;
                    return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__generator"])(this, function (_b) {
                        switch (_b.label) {
                            case 0:
                                if (addRef)
                                    data.customProperties.reference(builder.descriptor, true);
                                property = get(data);
                                p = _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_1__["ParamDefinition"].merge(builder.defaultParams, property.props, props);
                                if (property.data.value && _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_1__["ParamDefinition"].areEqual(builder.defaultParams, property.props, p))
                                    return [2 /*return*/];
                                return [4 /*yield*/, builder.obtain(ctx, data, p)];
                            case 1:
                                _a = _b.sent(), value = _a.value, assets = _a.assets;
                                data.customProperties.add(builder.descriptor);
                                data.customProperties.assets(builder.descriptor, assets);
                                set(data, p, value);
                                return [2 /*return*/];
                        }
                    });
                });
            },
            ref: function (data, add) { return data.customProperties.reference(builder.descriptor, add); },
            get: function (data) { var _a; return (_a = get(data)) === null || _a === void 0 ? void 0 : _a.data; },
            set: function (data, props) {
                if (props === void 0) { props = {}; }
                var property = get(data);
                var p = _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_1__["ParamDefinition"].merge(builder.defaultParams, property.props, props);
                if (!_mol_util_param_definition__WEBPACK_IMPORTED_MODULE_1__["ParamDefinition"].areEqual(builder.defaultParams, property.props, p)) {
                    // this invalidates property.value
                    set(data, p, undefined);
                    // dispose of assets
                    data.customProperties.assets(builder.descriptor);
                }
            },
            props: function (data) { return get(data).props; },
        };
    }
    CustomModelProperty.createProvider = createProvider;
    function createSimple(name, type, defaultValue) {
        var _this = this;
        var defaultParams = { value: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_1__["ParamDefinition"].Value(defaultValue, { isHidden: true }) };
        return createProvider({
            label: Object(_mol_util_string__WEBPACK_IMPORTED_MODULE_4__["stringToWords"])(name),
            descriptor: Object(_mol_model_custom_property__WEBPACK_IMPORTED_MODULE_3__["CustomPropertyDescriptor"])({ name: name }),
            isHidden: true,
            type: type,
            defaultParams: defaultParams,
            getParams: function () { return ({ value: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_1__["ParamDefinition"].Value(defaultValue, { isHidden: true }) }); },
            isApplicable: function () { return true; },
            obtain: function (ctx, data, props) { return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"])(_this, void 0, void 0, function () {
                var _a;
                return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__generator"])(this, function (_b) {
                    return [2 /*return*/, { value: (_a = props.value) !== null && _a !== void 0 ? _a : defaultValue }];
                });
            }); }
        });
    }
    CustomModelProperty.createSimple = createSimple;
})(CustomModelProperty || (CustomModelProperty = {}));
//# sourceMappingURL=custom-model-property.js.map

/***/ }),

/***/ "./lib/mol-model-props/common/custom-property.js":
/*!*******************************************************!*\
  !*** ./lib/mol-model-props/common/custom-property.js ***!
  \*******************************************************/
/*! exports provided: CustomProperty */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CustomProperty", function() { return CustomProperty; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../mol-util/param-definition */ "./lib/mol-util/param-definition.js");
/* harmony import */ var immutable__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! immutable */ "./node_modules/immutable/dist/immutable.js");
/* harmony import */ var immutable__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(immutable__WEBPACK_IMPORTED_MODULE_2__);
/**
 * Copyright (c) 2019-2020 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */




var CustomProperty;
(function (CustomProperty) {
    var Registry = /** @class */ (function () {
        function Registry() {
            this.providers = Object(immutable__WEBPACK_IMPORTED_MODULE_2__["OrderedMap"])().asMutable();
            this.defaultAutoAttachValues = new Map();
        }
        /** Get params for all applicable property providers */
        Registry.prototype.getParams = function (data) {
            var propertiesParams = {};
            var autoAttachOptions = [];
            var autoAttachDefault = [];
            if (data) {
                var values = this.providers.values();
                while (true) {
                    var v = values.next();
                    if (v.done)
                        break;
                    var provider = v.value;
                    if (!provider.isApplicable(data))
                        continue;
                    if (!provider.isHidden) {
                        autoAttachOptions.push([provider.descriptor.name, provider.label]);
                        if (this.defaultAutoAttachValues.get(provider.descriptor.name)) {
                            autoAttachDefault.push(provider.descriptor.name);
                        }
                    }
                    propertiesParams[provider.descriptor.name] = _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_1__["ParamDefinition"].Group(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, provider.getParams(data)), { label: provider.label, isHidden: provider.isHidden });
                }
            }
            return {
                autoAttach: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_1__["ParamDefinition"].MultiSelect(autoAttachDefault, autoAttachOptions),
                properties: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_1__["ParamDefinition"].Group(propertiesParams, { isFlat: true })
            };
        };
        Registry.prototype.setDefaultAutoAttach = function (name, value) {
            this.defaultAutoAttachValues.set(name, value);
        };
        Registry.prototype.get = function (name) {
            var prop = this.providers.get(name);
            if (!prop) {
                throw new Error("Custom property '" + name + "' is not registered.");
            }
            return this.providers.get(name);
        };
        Registry.prototype.register = function (provider, defaultAutoAttach) {
            this.providers.set(provider.descriptor.name, provider);
            this.defaultAutoAttachValues.set(provider.descriptor.name, defaultAutoAttach);
        };
        Registry.prototype.unregister = function (name) {
            this.providers.delete(name);
            this.defaultAutoAttachValues.delete(name);
        };
        return Registry;
    }());
    CustomProperty.Registry = Registry;
})(CustomProperty || (CustomProperty = {}));
//# sourceMappingURL=custom-property.js.map

/***/ }),

/***/ "./lib/mol-model-props/common/custom-structure-property.js":
/*!*****************************************************************!*\
  !*** ./lib/mol-model-props/common/custom-structure-property.js ***!
  \*****************************************************************/
/*! exports provided: CustomStructureProperty */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CustomStructureProperty", function() { return CustomStructureProperty; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../mol-util/param-definition */ "./lib/mol-util/param-definition.js");
/* harmony import */ var _mol_util__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../mol-util */ "./lib/mol-util/index.js");
/* harmony import */ var _mol_model_custom_property__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../mol-model/custom-property */ "./lib/mol-model/custom-property.js");
/* harmony import */ var _mol_util_string__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../mol-util/string */ "./lib/mol-util/string.js");
/**
 * Copyright (c) 2019-2020 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */






var CustomStructureProperty;
(function (CustomStructureProperty) {
    function createProvider(builder) {
        var _this = this;
        var descriptorName = builder.descriptor.name;
        var propertyDataName = builder.type === 'root' ? 'inheritedPropertyData' : 'currentPropertyData';
        var get = function (data) {
            if (!(descriptorName in data[propertyDataName])) {
                data[propertyDataName][descriptorName] = {
                    props: Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_1__["ParamDefinition"].getDefaultValues(builder.getParams(data))),
                    data: _mol_util__WEBPACK_IMPORTED_MODULE_2__["ValueBox"].create(undefined)
                };
            }
            return data[propertyDataName][descriptorName];
        };
        var set = function (data, props, value) {
            var property = get(data);
            data[propertyDataName][descriptorName] = {
                props: props,
                data: _mol_util__WEBPACK_IMPORTED_MODULE_2__["ValueBox"].withValue(property.data, value)
            };
        };
        return {
            label: builder.label,
            descriptor: builder.descriptor,
            isHidden: builder.isHidden,
            getParams: function (data) {
                var params = _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_1__["ParamDefinition"].clone(builder.getParams(data));
                _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_1__["ParamDefinition"].setDefaultValues(params, get(data).props);
                return params;
            },
            defaultParams: builder.defaultParams,
            isApplicable: builder.isApplicable,
            attach: function (ctx, data, props, addRef) {
                if (props === void 0) { props = {}; }
                return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"])(_this, void 0, void 0, function () {
                    var rootProps, property, p, _a, value, assets;
                    return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__generator"])(this, function (_b) {
                        switch (_b.label) {
                            case 0:
                                if (addRef)
                                    data.customPropertyDescriptors.reference(builder.descriptor, true);
                                if (builder.type === 'root')
                                    data = data.root;
                                rootProps = get(data.root).props;
                                property = get(data);
                                p = _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_1__["ParamDefinition"].merge(builder.defaultParams, rootProps, props);
                                if (property.data.value && _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_1__["ParamDefinition"].areEqual(builder.defaultParams, property.props, p))
                                    return [2 /*return*/];
                                return [4 /*yield*/, builder.obtain(ctx, data, p)];
                            case 1:
                                _a = _b.sent(), value = _a.value, assets = _a.assets;
                                data.customPropertyDescriptors.add(builder.descriptor);
                                data.customPropertyDescriptors.assets(builder.descriptor, assets);
                                set(data, p, value);
                                return [2 /*return*/];
                        }
                    });
                });
            },
            ref: function (data, add) { return data.customPropertyDescriptors.reference(builder.descriptor, add); },
            get: function (data) { return get(data).data; },
            set: function (data, props, value) {
                if (props === void 0) { props = {}; }
                if (builder.type === 'root')
                    data = data.root;
                var property = get(data);
                var p = _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_1__["ParamDefinition"].merge(builder.defaultParams, property.props, props);
                if (!_mol_util_param_definition__WEBPACK_IMPORTED_MODULE_1__["ParamDefinition"].areEqual(builder.defaultParams, property.props, p)) {
                    // this invalidates property.value
                    set(data, p, value);
                    // dispose of assets
                    data.customPropertyDescriptors.assets(builder.descriptor);
                }
            },
            props: function (data) { return get(data).props; },
        };
    }
    CustomStructureProperty.createProvider = createProvider;
    function createSimple(name, type, defaultValue) {
        var _this = this;
        var defaultParams = { value: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_1__["ParamDefinition"].Value(defaultValue, { isHidden: true }) };
        return createProvider({
            label: Object(_mol_util_string__WEBPACK_IMPORTED_MODULE_4__["stringToWords"])(name),
            descriptor: Object(_mol_model_custom_property__WEBPACK_IMPORTED_MODULE_3__["CustomPropertyDescriptor"])({ name: name }),
            isHidden: true,
            type: type,
            defaultParams: defaultParams,
            getParams: function () { return ({ value: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_1__["ParamDefinition"].Value(defaultValue, { isHidden: true }) }); },
            isApplicable: function () { return true; },
            obtain: function (ctx, data, props) { return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"])(_this, void 0, void 0, function () {
                return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__generator"])(this, function (_a) {
                    return [2 /*return*/, Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_1__["ParamDefinition"].getDefaultValues(defaultParams)), props)];
                });
            }); }
        });
    }
    CustomStructureProperty.createSimple = createSimple;
})(CustomStructureProperty || (CustomStructureProperty = {}));
//# sourceMappingURL=custom-structure-property.js.map

/***/ }),

/***/ "./lib/mol-model-props/common/wrapper.js":
/*!***********************************************!*\
  !*** ./lib/mol-model-props/common/wrapper.js ***!
  \***********************************************/
/*! exports provided: PropertyWrapper */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "PropertyWrapper", function() { return PropertyWrapper; });
/* harmony import */ var _mol_io_writer_cif__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../mol-io/writer/cif */ "./lib/mol-io/writer/cif.js");
/* harmony import */ var _mol_util_date__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../mol-util/date */ "./lib/mol-util/date.js");
/* harmony import */ var _mol_model_formats_structure_mmcif__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../mol-model-formats/structure/mmcif */ "./lib/mol-model-formats/structure/mmcif.js");
/**
 * Copyright (c) 2018 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author David Sehnal <david.sehnal@gmail.com>
 */



var PropertyWrapper;
(function (PropertyWrapper) {
    function createInfo() {
        return { timestamp_utc: Object(_mol_util_date__WEBPACK_IMPORTED_MODULE_1__["dateToUtcString"])(new Date()) };
    }
    PropertyWrapper.createInfo = createInfo;
    function defaultInfoCategory(name, getter) {
        return {
            name: name,
            instance: function (ctx) {
                var info = getter(ctx);
                return {
                    fields: _info_fields,
                    source: [{ data: info, rowCount: 1 }]
                };
            }
        };
    }
    PropertyWrapper.defaultInfoCategory = defaultInfoCategory;
    var _info_fields = [
        _mol_io_writer_cif__WEBPACK_IMPORTED_MODULE_0__["CifWriter"].Field.str('updated_datetime_utc', function (_, date) { return date.timestamp_utc; })
    ];
    function tryGetInfoFromCif(categoryName, model) {
        if (!_mol_model_formats_structure_mmcif__WEBPACK_IMPORTED_MODULE_2__["MmcifFormat"].is(model.sourceData) || !model.sourceData.data.frame.categoryNames.includes(categoryName)) {
            return;
        }
        var timestampField = model.sourceData.data.frame.categories[categoryName].getField('updated_datetime_utc');
        if (!timestampField || timestampField.rowCount === 0)
            return;
        return { timestamp_utc: timestampField.str(0) || Object(_mol_util_date__WEBPACK_IMPORTED_MODULE_1__["dateToUtcString"])(new Date()) };
    }
    PropertyWrapper.tryGetInfoFromCif = tryGetInfoFromCif;
})(PropertyWrapper || (PropertyWrapper = {}));

//# sourceMappingURL=wrapper.js.map

/***/ }),

/***/ "./lib/mol-model-props/computed/accessible-surface-area.js":
/*!*****************************************************************!*\
  !*** ./lib/mol-model-props/computed/accessible-surface-area.js ***!
  \*****************************************************************/
/*! exports provided: AccessibleSurfaceAreaParams, AccessibleSurfaceAreaSymbols, AccessibleSurfaceAreaProvider */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "AccessibleSurfaceAreaParams", function() { return AccessibleSurfaceAreaParams; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "AccessibleSurfaceAreaSymbols", function() { return AccessibleSurfaceAreaSymbols; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "AccessibleSurfaceAreaProvider", function() { return AccessibleSurfaceAreaProvider; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../mol-util/param-definition */ "./lib/mol-util/param-definition.js");
/* harmony import */ var _accessible_surface_area_shrake_rupley__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./accessible-surface-area/shrake-rupley */ "./lib/mol-model-props/computed/accessible-surface-area/shrake-rupley.js");
/* harmony import */ var _mol_model_structure__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../mol-model/structure */ "./lib/mol-model/structure.js");
/* harmony import */ var _common_custom_structure_property__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../common/custom-structure-property */ "./lib/mol-model-props/common/custom-structure-property.js");
/* harmony import */ var _mol_script_runtime_query_compiler__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../mol-script/runtime/query/compiler */ "./lib/mol-script/runtime/query/compiler.js");
/* harmony import */ var _mol_script_language_symbol__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../../mol-script/language/symbol */ "./lib/mol-script/language/symbol.js");
/* harmony import */ var _mol_script_language_type__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../../mol-script/language/type */ "./lib/mol-script/language/type.js");
/* harmony import */ var _mol_model_custom_property__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ../../mol-model/custom-property */ "./lib/mol-model/custom-property.js");
/**
 * Copyright (c) 2019-2020 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author Sebastian Bittrich <sebastian.bittrich@rcsb.org>
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */









var AccessibleSurfaceAreaParams = Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, _accessible_surface_area_shrake_rupley__WEBPACK_IMPORTED_MODULE_2__["ShrakeRupleyComputationParams"]);
var AccessibleSurfaceAreaSymbols = {
    isBuried: _mol_script_runtime_query_compiler__WEBPACK_IMPORTED_MODULE_5__["QuerySymbolRuntime"].Dynamic(Object(_mol_script_language_symbol__WEBPACK_IMPORTED_MODULE_6__["CustomPropSymbol"])('computed', 'accessible-surface-area.is-buried', _mol_script_language_type__WEBPACK_IMPORTED_MODULE_7__["default"].Bool), function (ctx) {
        if (!_mol_model_structure__WEBPACK_IMPORTED_MODULE_3__["Unit"].isAtomic(ctx.element.unit))
            return false;
        var accessibleSurfaceArea = AccessibleSurfaceAreaProvider.get(ctx.element.structure).value;
        if (!accessibleSurfaceArea)
            return false;
        return _accessible_surface_area_shrake_rupley__WEBPACK_IMPORTED_MODULE_2__["AccessibleSurfaceArea"].getFlag(ctx.element, accessibleSurfaceArea) === 1 /* Buried */;
    }),
    isAccessible: _mol_script_runtime_query_compiler__WEBPACK_IMPORTED_MODULE_5__["QuerySymbolRuntime"].Dynamic(Object(_mol_script_language_symbol__WEBPACK_IMPORTED_MODULE_6__["CustomPropSymbol"])('computed', 'accessible-surface-area.is-accessible', _mol_script_language_type__WEBPACK_IMPORTED_MODULE_7__["default"].Bool), function (ctx) {
        if (!_mol_model_structure__WEBPACK_IMPORTED_MODULE_3__["Unit"].isAtomic(ctx.element.unit))
            return false;
        var accessibleSurfaceArea = AccessibleSurfaceAreaProvider.get(ctx.element.structure).value;
        if (!accessibleSurfaceArea)
            return false;
        return _accessible_surface_area_shrake_rupley__WEBPACK_IMPORTED_MODULE_2__["AccessibleSurfaceArea"].getFlag(ctx.element, accessibleSurfaceArea) === 2 /* Accessible */;
    }),
};
var AccessibleSurfaceAreaProvider = _common_custom_structure_property__WEBPACK_IMPORTED_MODULE_4__["CustomStructureProperty"].createProvider({
    label: 'Accessible Surface Area',
    descriptor: Object(_mol_model_custom_property__WEBPACK_IMPORTED_MODULE_8__["CustomPropertyDescriptor"])({
        name: 'molstar_accessible_surface_area',
        symbols: AccessibleSurfaceAreaSymbols,
    }),
    type: 'root',
    defaultParams: AccessibleSurfaceAreaParams,
    getParams: function (data) { return AccessibleSurfaceAreaParams; },
    isApplicable: function (data) { return true; },
    obtain: function (ctx, data, props) { return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"])(void 0, void 0, void 0, function () {
        var p;
        var _a;
        return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__generator"])(this, function (_b) {
            switch (_b.label) {
                case 0:
                    p = Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_1__["ParamDefinition"].getDefaultValues(AccessibleSurfaceAreaParams)), props);
                    _a = {};
                    return [4 /*yield*/, _accessible_surface_area_shrake_rupley__WEBPACK_IMPORTED_MODULE_2__["AccessibleSurfaceArea"].compute(data, p).runInContext(ctx.runtime)];
                case 1: return [2 /*return*/, (_a.value = _b.sent(), _a)];
            }
        });
    }); }
});
//# sourceMappingURL=accessible-surface-area.js.map

/***/ }),

/***/ "./lib/mol-model-props/computed/accessible-surface-area/shrake-rupley.js":
/*!*******************************************************************************!*\
  !*** ./lib/mol-model-props/computed/accessible-surface-area/shrake-rupley.js ***!
  \*******************************************************************************/
/*! exports provided: ShrakeRupleyComputationParams, AccessibleSurfaceArea */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ShrakeRupleyComputationParams", function() { return ShrakeRupleyComputationParams; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "AccessibleSurfaceArea", function() { return AccessibleSurfaceArea; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _mol_task__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../../mol-task */ "./lib/mol-task/index.js");
/* harmony import */ var _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../../mol-util/param-definition */ "./lib/mol-util/param-definition.js");
/* harmony import */ var _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../../mol-math/linear-algebra */ "./lib/mol-math/linear-algebra.js");
/* harmony import */ var _mol_model_structure__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../../mol-model/structure */ "./lib/mol-model/structure.js");
/* harmony import */ var _shrake_rupley_radii__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./shrake-rupley/radii */ "./lib/mol-model-props/computed/accessible-surface-area/shrake-rupley/radii.js");
/* harmony import */ var _shrake_rupley_common__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ./shrake-rupley/common */ "./lib/mol-model-props/computed/accessible-surface-area/shrake-rupley/common.js");
/* harmony import */ var _shrake_rupley_area__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ./shrake-rupley/area */ "./lib/mol-model-props/computed/accessible-surface-area/shrake-rupley/area.js");
/**
 * Copyright (c) 2019 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author Sebastian Bittrich <sebastian.bittrich@rcsb.org>
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */


// import { BitFlags } from '../../../mol-util';






var ShrakeRupleyComputationParams = {
    numberOfSpherePoints: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_2__["ParamDefinition"].Numeric(92, { min: 12, max: 360, step: 1 }, { description: 'Number of sphere points to sample per atom: 92 (original paper), 960 (BioJava), 3000 (EPPIC) - see Shrake A, Rupley JA: Environment and exposure to solvent of protein atoms. Lysozyme and insulin. J Mol Biol 1973.' }),
    probeSize: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_2__["ParamDefinition"].Numeric(1.4, { min: 0.1, max: 4, step: 0.01 }, { description: 'Corresponds to the size of a water molecule: 1.4 (original paper), 1.5 (occassionally used)' }),
    // buriedRasaThreshold: PD.Numeric(0.16, { min: 0.0, max: 1.0 }, { description: 'below this cutoff of relative accessible surface area a residue will be considered buried - see: Rost B, Sander C: Conservation and prediction of solvent accessibility in protein families. Proteins 1994.' }),
    nonPolymer: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_2__["ParamDefinition"].Boolean(false, { description: 'Include non-polymer atoms as occluders.' })
};
// TODO
// - add back buried and relative asa

var AccessibleSurfaceArea;
(function (AccessibleSurfaceArea) {
    /**
     * Adapts the BioJava implementation by Jose Duarte. That implementation is based on the publication by Shrake, A., and
     * J. A. Rupley. "Environment and Exposure to Solvent of Protein Atoms. Lysozyme and Insulin." JMB (1973).
     */
    function compute(structure, props) {
        var _this = this;
        if (props === void 0) { props = {}; }
        var p = Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_2__["ParamDefinition"].getDefaultValues(ShrakeRupleyComputationParams)), props);
        return _mol_task__WEBPACK_IMPORTED_MODULE_1__["Task"].create('Compute Accessible Surface Area', function (runtime) { return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"])(_this, void 0, void 0, function () {
            return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__generator"])(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, calculate(runtime, structure, p)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        }); });
    }
    AccessibleSurfaceArea.compute = compute;
    function calculate(runtime, structure, props) {
        return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"])(this, void 0, void 0, function () {
            var ctx, area, serialResidueIndex;
            return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__generator"])(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        ctx = initialize(structure, props);
                        Object(_shrake_rupley_radii__WEBPACK_IMPORTED_MODULE_5__["assignRadiusForHeavyAtoms"])(ctx);
                        return [4 /*yield*/, Object(_shrake_rupley_area__WEBPACK_IMPORTED_MODULE_7__["computeArea"])(runtime, ctx)];
                    case 1:
                        _a.sent();
                        area = ctx.area, serialResidueIndex = ctx.serialResidueIndex;
                        return [2 /*return*/, { area: area, serialResidueIndex: serialResidueIndex }];
                }
            });
        });
    }
    function initialize(structure, props) {
        var elementCount = structure.elementCount, atomicResidueCount = structure.atomicResidueCount;
        var probeSize = props.probeSize, nonPolymer = props.nonPolymer, numberOfSpherePoints = props.numberOfSpherePoints;
        return {
            structure: structure,
            probeSize: probeSize,
            nonPolymer: nonPolymer,
            spherePoints: generateSpherePoints(numberOfSpherePoints),
            scalingConstant: 4.0 * Math.PI / numberOfSpherePoints,
            maxLookupRadius: 2 * props.probeSize + 2 * _shrake_rupley_common__WEBPACK_IMPORTED_MODULE_6__["VdWLookup"][2],
            atomRadiusType: new Int8Array(elementCount),
            serialResidueIndex: new Int32Array(elementCount),
            area: new Float32Array(atomicResidueCount)
        };
    }
    /** Creates a collection of points on a sphere by the Golden Section Spiral algorithm. */
    function generateSpherePoints(numberOfSpherePoints) {
        var points = [];
        var inc = Math.PI * (3.0 - Math.sqrt(5.0));
        var offset = 2.0 / numberOfSpherePoints;
        for (var k = 0; k < numberOfSpherePoints; ++k) {
            var y = k * offset - 1.0 + (offset / 2.0);
            var r = Math.sqrt(1.0 - y * y);
            var phi = k * inc;
            points[points.length] = _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_3__["Vec3"].create(Math.cos(phi) * r, y, Math.sin(phi) * r);
        }
        return points;
    }
    /** Get relative area for a given component id */
    function normalize(compId, asa) {
        var maxAsa = _shrake_rupley_common__WEBPACK_IMPORTED_MODULE_6__["MaxAsa"][compId] || _shrake_rupley_common__WEBPACK_IMPORTED_MODULE_6__["DefaultMaxAsa"];
        return asa / maxAsa;
    }
    AccessibleSurfaceArea.normalize = normalize;
    function getValue(location, accessibleSurfaceArea) {
        var getSerialIndex = location.structure.root.serialMapping.getSerialIndex;
        var area = accessibleSurfaceArea.area, serialResidueIndex = accessibleSurfaceArea.serialResidueIndex;
        var rSI = serialResidueIndex[getSerialIndex(location.unit, location.element)];
        if (rSI === -1)
            return -1;
        return area[rSI];
    }
    AccessibleSurfaceArea.getValue = getValue;
    function getNormalizedValue(location, accessibleSurfaceArea) {
        var value = getValue(location, accessibleSurfaceArea);
        return value === -1 ? -1 : normalize(_mol_model_structure__WEBPACK_IMPORTED_MODULE_4__["StructureProperties"].atom.label_comp_id(location), value);
    }
    AccessibleSurfaceArea.getNormalizedValue = getNormalizedValue;
    function getFlag(location, accessibleSurfaceArea) {
        var value = getNormalizedValue(location, accessibleSurfaceArea);
        return value === -1 ? 0 /* NA */ :
            value < 0.16 ? 1 /* Buried */ :
                2 /* Accessible */;
    }
    AccessibleSurfaceArea.getFlag = getFlag;
})(AccessibleSurfaceArea || (AccessibleSurfaceArea = {}));
//# sourceMappingURL=shrake-rupley.js.map

/***/ }),

/***/ "./lib/mol-model-props/computed/accessible-surface-area/shrake-rupley/area.js":
/*!************************************************************************************!*\
  !*** ./lib/mol-model-props/computed/accessible-surface-area/shrake-rupley/area.js ***!
  \************************************************************************************/
/*! exports provided: computeArea */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "computeArea", function() { return computeArea; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _common__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./common */ "./lib/mol-model-props/computed/accessible-surface-area/shrake-rupley/common.js");
/* harmony import */ var _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../../../mol-math/linear-algebra */ "./lib/mol-math/linear-algebra.js");
/* harmony import */ var _mol_model_structure_structure__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../../../mol-model/structure/structure */ "./lib/mol-model/structure/structure.js");
/**
 * Copyright (c) 2019 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author Sebastian Bittrich <sebastian.bittrich@rcsb.org>
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */




// TODO
// - iterate over units and elements
// - avoid using serial-element index whenever possible
// - calculate atomRadiusType only for invariant units
// - factor serialResidueIndex out
var updateChunk = 5000;
function computeArea(runtime, ctx) {
    return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"])(this, void 0, void 0, function () {
        var atomRadius, i;
        return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__generator"])(this, function (_a) {
            switch (_a.label) {
                case 0:
                    atomRadius = ctx.atomRadiusType;
                    i = 0;
                    _a.label = 1;
                case 1:
                    if (!(i < atomRadius.length)) return [3 /*break*/, 5];
                    if (!runtime.shouldUpdate) return [3 /*break*/, 3];
                    return [4 /*yield*/, runtime.update({ message: 'Computing per residue surface accessibility...', current: i, max: atomRadius.length })];
                case 2:
                    _a.sent();
                    _a.label = 3;
                case 3:
                    computeRange(ctx, i, Math.min(i + updateChunk, atomRadius.length));
                    _a.label = 4;
                case 4:
                    i += updateChunk;
                    return [3 /*break*/, 1];
                case 5: return [2 /*return*/];
            }
        });
    });
}
var aPos = Object(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_2__["Vec3"])();
var bPos = Object(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_2__["Vec3"])();
var testPoint = Object(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_2__["Vec3"])();
var aLoc = _mol_model_structure_structure__WEBPACK_IMPORTED_MODULE_3__["StructureElement"].Location.create(void 0);
var bLoc = _mol_model_structure_structure__WEBPACK_IMPORTED_MODULE_3__["StructureElement"].Location.create(void 0);
function setLocation(l, structure, serialIndex) {
    l.structure = structure;
    l.unit = structure.units[structure.serialMapping.unitIndices[serialIndex]];
    l.element = structure.serialMapping.elementIndices[serialIndex];
    return l;
}
function computeRange(ctx, begin, end) {
    var structure = ctx.structure, atomRadiusType = ctx.atomRadiusType, serialResidueIndex = ctx.serialResidueIndex, area = ctx.area, spherePoints = ctx.spherePoints, scalingConstant = ctx.scalingConstant, maxLookupRadius = ctx.maxLookupRadius, probeSize = ctx.probeSize;
    var _a = _mol_model_structure_structure__WEBPACK_IMPORTED_MODULE_3__["StructureProperties"].atom, x = _a.x, y = _a.y, z = _a.z;
    var lookup3d = structure.lookup3d, serialMapping = structure.serialMapping, unitIndexMap = structure.unitIndexMap;
    var cumulativeUnitElementCount = serialMapping.cumulativeUnitElementCount;
    for (var aI = begin; aI < end; ++aI) {
        var radius1 = _common__WEBPACK_IMPORTED_MODULE_1__["VdWLookup"][atomRadiusType[aI]];
        if (radius1 === _common__WEBPACK_IMPORTED_MODULE_1__["VdWLookup"][0])
            continue;
        setLocation(aLoc, structure, aI);
        var aX = x(aLoc);
        var aY = y(aLoc);
        var aZ = z(aLoc);
        // pre-filter by lookup3d (provides >10x speed-up compared to naive evaluation)
        var _b = lookup3d.find(aX, aY, aZ, maxLookupRadius), count = _b.count, units = _b.units, indices = _b.indices, squaredDistances = _b.squaredDistances;
        // collect neighbors for each atom
        var cutoff1 = probeSize + probeSize + radius1;
        var neighbors = []; // TODO reuse
        for (var iI = 0; iI < count; ++iI) {
            var bUnit = units[iI];
            _mol_model_structure_structure__WEBPACK_IMPORTED_MODULE_3__["StructureElement"].Location.set(bLoc, ctx.structure, bUnit, bUnit.elements[indices[iI]]);
            var bI = cumulativeUnitElementCount[unitIndexMap.get(bUnit.id)] + indices[iI];
            var radius2 = _common__WEBPACK_IMPORTED_MODULE_1__["VdWLookup"][atomRadiusType[bI]];
            if (_mol_model_structure_structure__WEBPACK_IMPORTED_MODULE_3__["StructureElement"].Location.areEqual(aLoc, bLoc) || radius2 === _common__WEBPACK_IMPORTED_MODULE_1__["VdWLookup"][0])
                continue;
            var cutoff2 = (cutoff1 + radius2) * (cutoff1 + radius2);
            if (squaredDistances[iI] < cutoff2) {
                neighbors[neighbors.length] = bI;
            }
        }
        // for all neighbors: test all sphere points
        _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_2__["Vec3"].set(aPos, aX, aY, aZ);
        var scale = probeSize + radius1;
        var accessiblePointCount = 0;
        for (var sI = 0; sI < spherePoints.length; ++sI) {
            _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_2__["Vec3"].scaleAndAdd(testPoint, aPos, spherePoints[sI], scale);
            var accessible = true;
            for (var _nI = 0; _nI < neighbors.length; ++_nI) {
                var nI = neighbors[_nI];
                setLocation(bLoc, structure, nI);
                _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_2__["Vec3"].set(bPos, x(bLoc), y(bLoc), z(bLoc));
                var radius3 = _common__WEBPACK_IMPORTED_MODULE_1__["VdWLookup"][atomRadiusType[nI]];
                var cutoff3 = (radius3 + probeSize) * (radius3 + probeSize);
                if (_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_2__["Vec3"].squaredDistance(testPoint, bPos) < cutoff3) {
                    accessible = false;
                    break;
                }
            }
            if (accessible)
                ++accessiblePointCount;
        }
        area[serialResidueIndex[aI]] += scalingConstant * accessiblePointCount * scale * scale;
    }
}
//# sourceMappingURL=area.js.map

/***/ }),

/***/ "./lib/mol-model-props/computed/accessible-surface-area/shrake-rupley/common.js":
/*!**************************************************************************************!*\
  !*** ./lib/mol-model-props/computed/accessible-surface-area/shrake-rupley/common.js ***!
  \**************************************************************************************/
/*! exports provided: VdWLookup, MaxAsa, DefaultMaxAsa */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "VdWLookup", function() { return VdWLookup; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MaxAsa", function() { return MaxAsa; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DefaultMaxAsa", function() { return DefaultMaxAsa; });
/**
 * Copyright (c) 2019 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author Sebastian Bittrich <sebastian.bittrich@rcsb.org>
 */
/** Chothia's amino acid and nucleotide atom vdw radii */
var VdWLookup = [
    -1.0,
    1.76,
    1.87,
    1.65,
    1.50,
    1.40,
    1.85,
    1.80,
    1.60,
    1.40 // 9: P (nucleic)
]; // can still be appended on-the-fly for rare elements like selenium
/** Maximum accessible surface area observed for amino acids. Taken from: http://dx.doi.org/10.1371/journal.pone.0080635 */
var MaxAsa = {
    'ALA': 121.0,
    'ARG': 265.0,
    'ASN': 187.0,
    'ASP': 187.0,
    'CYS': 148.0,
    'GLU': 214.0,
    'GLN': 214.0,
    'GLY': 97.0,
    'HIS': 216.0,
    'ILE': 195.0,
    'LEU': 191.0,
    'LYS': 230.0,
    'MET': 203.0,
    'PHE': 228.0,
    'PRO': 154.0,
    'SER': 143.0,
    'THR': 163.0,
    'TRP': 264.0,
    'TYR': 255.0,
    'VAL': 165.0
};
var DefaultMaxAsa = 121.0;
//# sourceMappingURL=common.js.map

/***/ }),

/***/ "./lib/mol-model-props/computed/accessible-surface-area/shrake-rupley/radii.js":
/*!*************************************************************************************!*\
  !*** ./lib/mol-model-props/computed/accessible-surface-area/shrake-rupley/radii.js ***!
  \*************************************************************************************/
/*! exports provided: assignRadiusForHeavyAtoms */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "assignRadiusForHeavyAtoms", function() { return assignRadiusForHeavyAtoms; });
/* harmony import */ var _common__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./common */ "./lib/mol-model-props/computed/accessible-surface-area/shrake-rupley/common.js");
/* harmony import */ var _mol_model_structure_structure_unit_bonds_common__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../../../mol-model/structure/structure/unit/bonds/common */ "./lib/mol-model/structure/structure/unit/bonds/common.js");
/* harmony import */ var _mol_model_structure_model_types__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../../../mol-model/structure/model/types */ "./lib/mol-model/structure/model/types.js");
/* harmony import */ var _mol_model_structure_model_properties_atomic__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../../../mol-model/structure/model/properties/atomic */ "./lib/mol-model/structure/model/properties/atomic.js");
/* harmony import */ var _mol_model_structure_structure__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../../../mol-model/structure/structure */ "./lib/mol-model/structure/structure.js");
/* harmony import */ var _mol_model_structure_util__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../../../mol-model/structure/util */ "./lib/mol-model/structure/util.js");
/**
 * Copyright (c) 2019 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author Sebastian Bittrich <sebastian.bittrich@rcsb.org>
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */






var l = _mol_model_structure_structure__WEBPACK_IMPORTED_MODULE_4__["StructureElement"].Location.create(void 0);
function assignRadiusForHeavyAtoms(ctx) {
    var key = _mol_model_structure_structure__WEBPACK_IMPORTED_MODULE_4__["StructureProperties"].residue.key;
    var _a = _mol_model_structure_structure__WEBPACK_IMPORTED_MODULE_4__["StructureProperties"].atom, type_symbol = _a.type_symbol, label_atom_id = _a.label_atom_id, label_comp_id = _a.label_comp_id;
    var structure = ctx.structure, atomRadiusType = ctx.atomRadiusType, serialResidueIndex = ctx.serialResidueIndex;
    var prevResidueIdx = 0;
    var residueIdx = 0;
    var serialResidueIdx = -1;
    l.structure = structure;
    for (var i = 0, m = 0, il = structure.units.length; i < il; ++i) {
        var unit = structure.units[i];
        var elements = unit.elements;
        l.unit = unit;
        prevResidueIdx = -1;
        for (var j = 0, jl = elements.length; j < jl; ++j) {
            var eI = elements[j];
            var mj = m + j;
            l.element = eI;
            residueIdx = key(l);
            if (prevResidueIdx !== residueIdx)
                ++serialResidueIdx;
            prevResidueIdx = residueIdx;
            var element = type_symbol(l);
            var elementIdx = Object(_mol_model_structure_structure_unit_bonds_common__WEBPACK_IMPORTED_MODULE_1__["getElementIdx"])(element);
            // skip hydrogen atoms
            if (Object(_mol_model_structure_structure_unit_bonds_common__WEBPACK_IMPORTED_MODULE_1__["isHydrogen"])(elementIdx)) {
                atomRadiusType[mj] = _common__WEBPACK_IMPORTED_MODULE_0__["VdWLookup"][0];
                serialResidueIndex[mj] = -1;
                continue;
            }
            var moleculeType = Object(_mol_model_structure_util__WEBPACK_IMPORTED_MODULE_5__["getElementMoleculeType"])(unit, eI);
            // skip water and optionally non-polymer groups
            if (moleculeType === 2 /* Water */ || (!ctx.nonPolymer && !Object(_mol_model_structure_model_types__WEBPACK_IMPORTED_MODULE_2__["isPolymer"])(moleculeType))) {
                atomRadiusType[mj] = _common__WEBPACK_IMPORTED_MODULE_0__["VdWLookup"][0];
                serialResidueIndex[mj] = -1;
                continue;
            }
            var atomId = label_atom_id(l);
            var compId = label_comp_id(l);
            if (Object(_mol_model_structure_model_types__WEBPACK_IMPORTED_MODULE_2__["isNucleic"])(moleculeType)) {
                atomRadiusType[mj] = determineRadiusNucl(atomId, element, compId);
            }
            else if (moleculeType === 5 /* Protein */) {
                atomRadiusType[mj] = determineRadiusAmino(atomId, element, compId);
            }
            else {
                atomRadiusType[mj] = handleNonStandardCase(element);
            }
            serialResidueIndex[mj] = serialResidueIdx;
        }
        m += elements.length;
    }
}
/**
 * Gets the van der Waals radius of the given atom following the values defined by Chothia (1976)
 * J.Mol.Biol.105,1-14. NOTE: the vdw values defined by the paper assume no Hydrogens and thus "inflates" slightly
 * the heavy atoms to account for Hydrogens.
 */
function determineRadiusAmino(atomId, element, compId) {
    switch (element) {
        case 'O':
            return 5;
        case 'S':
            return 6;
        case 'N':
            return atomId === 'NZ' ? 4 : 3;
        case 'C':
            switch (atomId) {
                case 'C':
                case 'CE1':
                case 'CE2':
                case 'CE3':
                case 'CH2':
                case 'CZ':
                case 'CZ2':
                case 'CZ3':
                    return 1;
                case 'CA':
                case 'CB':
                case 'CE':
                case 'CG1':
                case 'CG2':
                    return 2;
                default:
                    switch (compId) {
                        case 'PHE':
                        case 'TRP':
                        case 'TYR':
                        case 'HIS':
                        case 'ASP':
                        case 'ASN':
                            return 1;
                        case 'PRO':
                        case 'LYS':
                        case 'ARG':
                        case 'MET':
                        case 'ILE':
                        case 'LEU':
                            return 2;
                        case 'GLU':
                        case 'GLN':
                            return atomId === 'CD' ? 1 : 2;
                    }
            }
    }
    return handleNonStandardCase(element);
}
function determineRadiusNucl(atomId, element, compId) {
    switch (element) {
        case 'C': return 7;
        case 'N': return 8;
        case 'P': return 9;
        case 'O': return 5;
    }
    return handleNonStandardCase(element);
}
function handleNonStandardCase(element) {
    var radius = Object(_mol_model_structure_model_properties_atomic__WEBPACK_IMPORTED_MODULE_3__["VdwRadius"])(element);
    var index = _common__WEBPACK_IMPORTED_MODULE_0__["VdWLookup"].indexOf(radius);
    if (index === -1) {
        // add novel value to lookup array
        index = _common__WEBPACK_IMPORTED_MODULE_0__["VdWLookup"].length;
        _common__WEBPACK_IMPORTED_MODULE_0__["VdWLookup"][index] = radius;
    }
    return index;
}
//# sourceMappingURL=radii.js.map

/***/ }),

/***/ "./lib/mol-model-props/computed/chemistry/functional-group.js":
/*!********************************************************************!*\
  !*** ./lib/mol-model-props/computed/chemistry/functional-group.js ***!
  \********************************************************************/
/*! exports provided: isQuaternaryAmine, isTertiaryAmine, isImide, isAmide, isSulfonium, isSulfonicAcid, isSulfate, isPhosphate, isHalocarbon, isCarbonyl, isCarboxylate, isGuanidine, isAcetamidine, isPolar, hasPolarNeighbour, hasAromaticNeighbour */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isQuaternaryAmine", function() { return isQuaternaryAmine; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isTertiaryAmine", function() { return isTertiaryAmine; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isImide", function() { return isImide; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isAmide", function() { return isAmide; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isSulfonium", function() { return isSulfonium; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isSulfonicAcid", function() { return isSulfonicAcid; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isSulfate", function() { return isSulfate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isPhosphate", function() { return isPhosphate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isHalocarbon", function() { return isHalocarbon; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isCarbonyl", function() { return isCarbonyl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isCarboxylate", function() { return isCarboxylate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isGuanidine", function() { return isGuanidine; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isAcetamidine", function() { return isAcetamidine; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isPolar", function() { return isPolar; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "hasPolarNeighbour", function() { return hasPolarNeighbour; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "hasAromaticNeighbour", function() { return hasAromaticNeighbour; });
/* harmony import */ var _mol_model_structure_model_properties_atomic_types__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../../mol-model/structure/model/properties/atomic/types */ "./lib/mol-model/structure/model/properties/atomic/types.js");
/* harmony import */ var _mol_model_structure_model_types__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../../mol-model/structure/model/types */ "./lib/mol-model/structure/model/types.js");
/* harmony import */ var _util__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./util */ "./lib/mol-model-props/computed/chemistry/util.js");
/**
 * Copyright (c) 2019 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */



function isAromatic(unit, index) {
    // TODO also extend unit.rings with geometry/composition-based aromaticity detection and use it here in addition
    var _a = unit.bonds, offset = _a.offset, edgeProps = _a.edgeProps;
    for (var i = offset[index], il = offset[index + 1]; i < il; ++i) {
        if (_mol_model_structure_model_types__WEBPACK_IMPORTED_MODULE_1__["BondType"].is(16 /* Aromatic */, edgeProps.flags[i]))
            return true;
    }
    return false;
}
function bondToCarbonylCount(structure, unit, index) {
    var carbonylCount = 0;
    Object(_util__WEBPACK_IMPORTED_MODULE_2__["eachBondedAtom"])(structure, unit, index, function (unit, index) {
        if (isCarbonyl(structure, unit, index))
            carbonylCount += 1;
    });
    return carbonylCount;
}
//
/**
 * Nitrogen in a quaternary amine
 */
function isQuaternaryAmine(structure, unit, index) {
    return (Object(_util__WEBPACK_IMPORTED_MODULE_2__["typeSymbol"])(unit, index) === "N" /* N */ &&
        Object(_util__WEBPACK_IMPORTED_MODULE_2__["bondCount"])(structure, unit, index) === 4 &&
        Object(_util__WEBPACK_IMPORTED_MODULE_2__["bondToElementCount"])(structure, unit, index, "H" /* H */) === 0);
}
/**
 * Nitrogen in a tertiary amine
 */
function isTertiaryAmine(structure, unit, index, idealValence) {
    return (Object(_util__WEBPACK_IMPORTED_MODULE_2__["typeSymbol"])(unit, index) === "N" /* N */ &&
        Object(_util__WEBPACK_IMPORTED_MODULE_2__["bondCount"])(structure, unit, index) === 4 &&
        idealValence === 3);
}
/**
 * Nitrogen in an imide
 */
function isImide(structure, unit, index) {
    var flag = false;
    if (Object(_util__WEBPACK_IMPORTED_MODULE_2__["typeSymbol"])(unit, index) === "N" /* N */ &&
        (Object(_util__WEBPACK_IMPORTED_MODULE_2__["bondCount"])(structure, unit, index) - Object(_util__WEBPACK_IMPORTED_MODULE_2__["bondToElementCount"])(structure, unit, index, "H" /* H */)) === 2) {
        flag = bondToCarbonylCount(structure, unit, index) === 2;
    }
    return flag;
}
/**
 * Nitrogen in an amide
 */
function isAmide(structure, unit, index) {
    var flag = false;
    if (Object(_util__WEBPACK_IMPORTED_MODULE_2__["typeSymbol"])(unit, index) === "N" /* N */ &&
        (Object(_util__WEBPACK_IMPORTED_MODULE_2__["bondCount"])(structure, unit, index) - Object(_util__WEBPACK_IMPORTED_MODULE_2__["bondToElementCount"])(structure, unit, index, "H" /* H */)) === 2) {
        flag = bondToCarbonylCount(structure, unit, index) === 1;
    }
    return flag;
}
/**
 * Sulfur in a sulfonium group
 */
function isSulfonium(structure, unit, index) {
    return (Object(_util__WEBPACK_IMPORTED_MODULE_2__["typeSymbol"])(unit, index) === "S" /* S */ &&
        Object(_util__WEBPACK_IMPORTED_MODULE_2__["bondCount"])(structure, unit, index) === 3 &&
        Object(_util__WEBPACK_IMPORTED_MODULE_2__["bondToElementCount"])(structure, unit, index, "H" /* H */) === 0);
}
/**
 * Sulfur in a sulfonic acid or sulfonate group
 */
function isSulfonicAcid(structure, unit, index) {
    return (Object(_util__WEBPACK_IMPORTED_MODULE_2__["typeSymbol"])(unit, index) === "S" /* S */ &&
        Object(_util__WEBPACK_IMPORTED_MODULE_2__["bondToElementCount"])(structure, unit, index, "O" /* O */) === 3);
}
/**
 * Sulfur in a sulfate group
 */
function isSulfate(structure, unit, index) {
    return (Object(_util__WEBPACK_IMPORTED_MODULE_2__["typeSymbol"])(unit, index) === "S" /* S */ &&
        Object(_util__WEBPACK_IMPORTED_MODULE_2__["bondToElementCount"])(structure, unit, index, "O" /* O */) === 4);
}
/**
 * Phosphor in a phosphate group
 */
function isPhosphate(structure, unit, index) {
    return (Object(_util__WEBPACK_IMPORTED_MODULE_2__["typeSymbol"])(unit, index) === "P" /* P */ &&
        Object(_util__WEBPACK_IMPORTED_MODULE_2__["bondToElementCount"])(structure, unit, index, "O" /* O */) === Object(_util__WEBPACK_IMPORTED_MODULE_2__["bondCount"])(structure, unit, index));
}
/**
 * Halogen with one bond to a carbon
 */
function isHalocarbon(structure, unit, index) {
    return (Object(_mol_model_structure_model_properties_atomic_types__WEBPACK_IMPORTED_MODULE_0__["isHalogen"])(Object(_util__WEBPACK_IMPORTED_MODULE_2__["typeSymbol"])(unit, index)) &&
        Object(_util__WEBPACK_IMPORTED_MODULE_2__["bondCount"])(structure, unit, index) === 1 &&
        Object(_util__WEBPACK_IMPORTED_MODULE_2__["bondToElementCount"])(structure, unit, index, "C" /* C */) === 1);
}
/**
 * Carbon in a carbonyl/acyl group
 *
 * TODO currently only checks intra bonds for group detection
 */
function isCarbonyl(structure, unit, index) {
    var flag = false;
    if (Object(_util__WEBPACK_IMPORTED_MODULE_2__["typeSymbol"])(unit, index) === "C" /* C */) {
        var _a = unit.bonds, offset = _a.offset, edgeProps = _a.edgeProps, b = _a.b;
        for (var i = offset[index], il = offset[index + 1]; i < il; ++i) {
            if (edgeProps.order[i] === 2 && Object(_util__WEBPACK_IMPORTED_MODULE_2__["typeSymbol"])(unit, b[i]) === "O" /* O */) {
                flag = true;
                break;
            }
        }
    }
    return flag;
}
/**
 * Carbon in a carboxylate group
 */
function isCarboxylate(structure, unit, index) {
    var terminalOxygenCount = 0;
    if (Object(_util__WEBPACK_IMPORTED_MODULE_2__["typeSymbol"])(unit, index) === "C" /* C */ &&
        Object(_util__WEBPACK_IMPORTED_MODULE_2__["bondToElementCount"])(structure, unit, index, "O" /* O */) === 2 &&
        Object(_util__WEBPACK_IMPORTED_MODULE_2__["bondToElementCount"])(structure, unit, index, "C" /* C */) === 1) {
        Object(_util__WEBPACK_IMPORTED_MODULE_2__["eachBondedAtom"])(structure, unit, index, function (unit, index) {
            if (Object(_util__WEBPACK_IMPORTED_MODULE_2__["typeSymbol"])(unit, index) === "O" /* O */ &&
                Object(_util__WEBPACK_IMPORTED_MODULE_2__["bondCount"])(structure, unit, index) - Object(_util__WEBPACK_IMPORTED_MODULE_2__["bondToElementCount"])(structure, unit, index, "H" /* H */) === 1) {
                terminalOxygenCount += 1;
            }
        });
    }
    return terminalOxygenCount === 2;
}
/**
 * Carbon in a guanidine group
 */
function isGuanidine(structure, unit, index) {
    var terminalNitrogenCount = 0;
    if (Object(_util__WEBPACK_IMPORTED_MODULE_2__["typeSymbol"])(unit, index) === "C" /* C */ &&
        Object(_util__WEBPACK_IMPORTED_MODULE_2__["bondCount"])(structure, unit, index) === 3 &&
        Object(_util__WEBPACK_IMPORTED_MODULE_2__["bondToElementCount"])(structure, unit, index, "N" /* N */) === 3) {
        Object(_util__WEBPACK_IMPORTED_MODULE_2__["eachBondedAtom"])(structure, unit, index, function (unit, index) {
            if (Object(_util__WEBPACK_IMPORTED_MODULE_2__["bondCount"])(structure, unit, index) - Object(_util__WEBPACK_IMPORTED_MODULE_2__["bondToElementCount"])(structure, unit, index, "H" /* H */) === 1) {
                terminalNitrogenCount += 1;
            }
        });
    }
    return terminalNitrogenCount === 2;
}
/**
 * Carbon in a acetamidine group
 */
function isAcetamidine(structure, unit, index) {
    var terminalNitrogenCount = 0;
    if (Object(_util__WEBPACK_IMPORTED_MODULE_2__["typeSymbol"])(unit, index) === "C" /* C */ &&
        Object(_util__WEBPACK_IMPORTED_MODULE_2__["bondCount"])(structure, unit, index) === 3 &&
        Object(_util__WEBPACK_IMPORTED_MODULE_2__["bondToElementCount"])(structure, unit, index, "N" /* N */) === 2 &&
        Object(_util__WEBPACK_IMPORTED_MODULE_2__["bondToElementCount"])(structure, unit, index, "C" /* C */) === 1) {
        Object(_util__WEBPACK_IMPORTED_MODULE_2__["eachBondedAtom"])(structure, unit, index, function (unit, index) {
            if (Object(_util__WEBPACK_IMPORTED_MODULE_2__["bondCount"])(structure, unit, index) - Object(_util__WEBPACK_IMPORTED_MODULE_2__["bondToElementCount"])(structure, unit, index, "H" /* H */) === 1) {
                terminalNitrogenCount += 1;
            }
        });
    }
    return terminalNitrogenCount === 2;
}
var PolarElements = new Set(['N', 'O', 'S', 'F', 'CL', 'BR', 'I']);
function isPolar(element) { return PolarElements.has(element); }
function hasPolarNeighbour(structure, unit, index) {
    var flag = false;
    Object(_util__WEBPACK_IMPORTED_MODULE_2__["eachBondedAtom"])(structure, unit, index, function (unit, index) {
        if (isPolar(Object(_util__WEBPACK_IMPORTED_MODULE_2__["typeSymbol"])(unit, index)))
            flag = true;
    });
    return flag;
}
function hasAromaticNeighbour(structure, unit, index) {
    var flag = false;
    Object(_util__WEBPACK_IMPORTED_MODULE_2__["eachBondedAtom"])(structure, unit, index, function (unit, index) {
        if (isAromatic(unit, index))
            flag = true;
    });
    return flag;
}
//# sourceMappingURL=functional-group.js.map

/***/ }),

/***/ "./lib/mol-model-props/computed/chemistry/geometry.js":
/*!************************************************************!*\
  !*** ./lib/mol-model-props/computed/chemistry/geometry.js ***!
  \************************************************************/
/*! exports provided: geometryLabel, assignGeometry, AtomGeometryAngles, calcAngles, calcPlaneAngle */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "geometryLabel", function() { return geometryLabel; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "assignGeometry", function() { return assignGeometry; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "AtomGeometryAngles", function() { return AtomGeometryAngles; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "calcAngles", function() { return calcAngles; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "calcPlaneAngle", function() { return calcPlaneAngle; });
/* harmony import */ var _mol_math_misc__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../../mol-math/misc */ "./lib/mol-math/misc.js");
/* harmony import */ var _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../../mol-math/linear-algebra */ "./lib/mol-math/linear-algebra.js");
/* harmony import */ var _util__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./util */ "./lib/mol-model-props/computed/chemistry/util.js");
/**
 * Copyright (c) 2017-2019 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author Fred Ludlow <Fred.Ludlow@astx.com>
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */



function geometryLabel(geometry) {
    switch (geometry) {
        case 0 /* Spherical */:
            return 'Spherical';
        case 1 /* Terminal */:
            return 'Terminal';
        case 2 /* Linear */:
            return 'Linear';
        case 3 /* Trigonal */:
            return 'Trigonal';
        case 4 /* Tetrahedral */:
            return 'Tetrahedral';
        case 5 /* TrigonalBiPyramidal */:
            return 'Trigonal Bi-Pyramidal';
        case 6 /* Octahedral */:
            return 'Octahedral';
        case 7 /* SquarePlanar */:
            return 'Square Planar';
        case 8 /* Unknown */:
            return 'Unknown';
    }
}
function assignGeometry(totalCoordination) {
    switch (totalCoordination) {
        case 0: return 0 /* Spherical */;
        case 1: return 1 /* Terminal */;
        case 2: return 2 /* Linear */;
        case 3: return 3 /* Trigonal */;
        case 4: return 4 /* Tetrahedral */;
        default: return 8 /* Unknown */;
    }
}
var AtomGeometryAngles = new Map([
    [2 /* Linear */, Object(_mol_math_misc__WEBPACK_IMPORTED_MODULE_0__["degToRad"])(180)],
    [3 /* Trigonal */, Object(_mol_math_misc__WEBPACK_IMPORTED_MODULE_0__["degToRad"])(120)],
    [4 /* Tetrahedral */, Object(_mol_math_misc__WEBPACK_IMPORTED_MODULE_0__["degToRad"])(109.4721)],
    [6 /* Octahedral */, Object(_mol_math_misc__WEBPACK_IMPORTED_MODULE_0__["degToRad"])(90)]
]);
// tmp objects for `calcAngles` and `calcPlaneAngle`
var tmpDir1 = Object(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_1__["Vec3"])();
var tmpDir2 = Object(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_1__["Vec3"])();
var tmpPosA = Object(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_1__["Vec3"])();
var tmpPosB = Object(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_1__["Vec3"])();
var tmpPosX = Object(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_1__["Vec3"])();
/**
 * Calculate the angles x-a1-a2 for all x where x is a heavy atom (not H) bonded to ap1.
 */
function calcAngles(structure, unitA, indexA, unitB, indexB) {
    var angles = [];
    unitA.conformation.position(unitA.elements[indexA], tmpPosA);
    unitB.conformation.position(unitB.elements[indexB], tmpPosB);
    _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_1__["Vec3"].sub(tmpDir1, tmpPosB, tmpPosA);
    Object(_util__WEBPACK_IMPORTED_MODULE_2__["eachBondedAtom"])(structure, unitA, indexA, function (unitX, indexX) {
        if (Object(_util__WEBPACK_IMPORTED_MODULE_2__["typeSymbol"])(unitX, indexX) !== "H" /* H */) {
            unitX.conformation.position(unitX.elements[indexX], tmpPosX);
            _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_1__["Vec3"].sub(tmpDir2, tmpPosX, tmpPosA);
            angles.push(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_1__["Vec3"].angle(tmpDir1, tmpDir2));
        }
    });
    return angles;
}
/**
 * Find two neighbours of ap1 to define a plane (if possible) and
 * measure angle out of plane to ap2
 * @param  {AtomProxy} ap1 First atom (angle centre)
 * @param  {AtomProxy} ap2 Second atom (out-of-plane)
 * @return {number}        Angle from plane to second atom
 */
function calcPlaneAngle(structure, unitA, indexA, unitB, indexB) {
    unitA.conformation.position(unitA.elements[indexA], tmpPosA);
    unitB.conformation.position(unitB.elements[indexB], tmpPosB);
    _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_1__["Vec3"].sub(tmpDir1, tmpPosB, tmpPosA);
    var neighbours = [Object(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_1__["Vec3"])(), Object(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_1__["Vec3"])()];
    var ni = 0;
    var unitX1;
    var indexX1;
    Object(_util__WEBPACK_IMPORTED_MODULE_2__["eachBondedAtom"])(structure, unitA, indexA, function (unitX, indexX) {
        if (ni > 1)
            return;
        if (Object(_util__WEBPACK_IMPORTED_MODULE_2__["typeSymbol"])(unitX, indexX) !== "H" /* H */) {
            unitX1 = unitX;
            indexX1 = indexX;
            unitX.conformation.position(unitX.elements[indexX], tmpPosX);
            _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_1__["Vec3"].sub(neighbours[ni++], tmpPosX, tmpPosA);
        }
    });
    if (ni === 1 && unitX1 && indexX1) {
        Object(_util__WEBPACK_IMPORTED_MODULE_2__["eachBondedAtom"])(structure, unitX1, indexX1, function (unitX, indexX) {
            if (ni > 1)
                return;
            if (unitX === unitA && indexX === indexA)
                return;
            if (Object(_util__WEBPACK_IMPORTED_MODULE_2__["typeSymbol"])(unitX, indexX) !== "H" /* H */) {
                unitX.conformation.position(unitX.elements[indexX], tmpPosX);
                _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_1__["Vec3"].sub(neighbours[ni++], tmpPosX, tmpPosA);
            }
        });
    }
    if (ni !== 2) {
        return;
    }
    _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_1__["Vec3"].cross(tmpDir2, neighbours[0], neighbours[1]);
    return Math.abs((Math.PI / 2) - _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_1__["Vec3"].angle(tmpDir2, tmpDir1));
}
//# sourceMappingURL=geometry.js.map

/***/ }),

/***/ "./lib/mol-model-props/computed/chemistry/util.js":
/*!********************************************************!*\
  !*** ./lib/mol-model-props/computed/chemistry/util.js ***!
  \********************************************************/
/*! exports provided: typeSymbol, formalCharge, atomId, altLoc, compId, interBondCount, intraBondCount, bondCount, bondToElementCount, intraConnectedTo, interConnectedTo, connectedTo, eachInterBondedAtom, eachIntraBondedAtom, eachBondedAtom, eachResidueAtom */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "typeSymbol", function() { return typeSymbol; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "formalCharge", function() { return formalCharge; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "atomId", function() { return atomId; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "altLoc", function() { return altLoc; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "compId", function() { return compId; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "interBondCount", function() { return interBondCount; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "intraBondCount", function() { return intraBondCount; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "bondCount", function() { return bondCount; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "bondToElementCount", function() { return bondToElementCount; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "intraConnectedTo", function() { return intraConnectedTo; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "interConnectedTo", function() { return interConnectedTo; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "connectedTo", function() { return connectedTo; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "eachInterBondedAtom", function() { return eachInterBondedAtom; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "eachIntraBondedAtom", function() { return eachIntraBondedAtom; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "eachBondedAtom", function() { return eachBondedAtom; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "eachResidueAtom", function() { return eachResidueAtom; });
/* harmony import */ var _mol_model_structure_model_types__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../../mol-model/structure/model/types */ "./lib/mol-model/structure/model/types.js");
/* harmony import */ var _mol_data_int__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../../mol-data/int */ "./lib/mol-data/int.js");
/**
 * Copyright (c) 2019-2020 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */


function typeSymbol(unit, index) {
    return unit.model.atomicHierarchy.atoms.type_symbol.value(unit.elements[index]);
}
function formalCharge(unit, index) {
    return unit.model.atomicHierarchy.atoms.pdbx_formal_charge.value(unit.elements[index]);
}
function atomId(unit, index) {
    return unit.model.atomicHierarchy.atoms.label_atom_id.value(unit.elements[index]);
}
function altLoc(unit, index) {
    return unit.model.atomicHierarchy.atoms.label_alt_id.value(unit.elements[index]);
}
function compId(unit, index) {
    return unit.model.atomicHierarchy.atoms.label_comp_id.value(unit.elements[index]);
}
//
function interBondCount(structure, unit, index) {
    var count = 0;
    var indices = structure.interUnitBonds.getEdgeIndices(index, unit.id);
    for (var i = 0, il = indices.length; i < il; ++i) {
        var b = structure.interUnitBonds.edges[indices[i]];
        if (_mol_model_structure_model_types__WEBPACK_IMPORTED_MODULE_0__["BondType"].isCovalent(b.props.flag))
            count += 1;
    }
    return count;
}
function intraBondCount(unit, index) {
    var count = 0;
    var _a = unit.bonds, offset = _a.offset, flags = _a.edgeProps.flags;
    for (var i = offset[index], il = offset[index + 1]; i < il; ++i) {
        if (_mol_model_structure_model_types__WEBPACK_IMPORTED_MODULE_0__["BondType"].isCovalent(flags[i]))
            count += 1;
    }
    return count;
}
function bondCount(structure, unit, index) {
    return interBondCount(structure, unit, index) + intraBondCount(unit, index);
}
function bondToElementCount(structure, unit, index, element) {
    var count = 0;
    eachBondedAtom(structure, unit, index, function (unit, index) {
        if (typeSymbol(unit, index) === element)
            count += 1;
    });
    return count;
}
//
function intraConnectedTo(unit, indexA, indexB) {
    var _a = unit.bonds, offset = _a.offset, b = _a.b, flags = _a.edgeProps.flags;
    _mol_model_structure_model_types__WEBPACK_IMPORTED_MODULE_0__["BondType"].is;
    for (var i = offset[indexA], il = offset[indexA + 1]; i < il; ++i) {
        if (b[i] === indexB && _mol_model_structure_model_types__WEBPACK_IMPORTED_MODULE_0__["BondType"].isCovalent(flags[i]))
            return true;
    }
    return false;
}
function interConnectedTo(structure, unitA, indexA, unitB, indexB) {
    var b = structure.interUnitBonds.getEdge(indexA, unitA.id, indexB, unitB.id);
    return b && _mol_model_structure_model_types__WEBPACK_IMPORTED_MODULE_0__["BondType"].isCovalent(b.props.flag);
}
function connectedTo(structure, unitA, indexA, unitB, indexB) {
    return unitA === unitB ? intraConnectedTo(unitA, indexA, indexB) : interConnectedTo(structure, unitA, indexA, unitB, indexB);
}
//
function eachInterBondedAtom(structure, unit, index, cb) {
    var indices = structure.interUnitBonds.getEdgeIndices(index, unit.id);
    for (var i = 0, il = indices.length; i < il; ++i) {
        var b = structure.interUnitBonds.edges[indices[i]];
        var uB = structure.unitMap.get(b.unitB);
        if (_mol_model_structure_model_types__WEBPACK_IMPORTED_MODULE_0__["BondType"].isCovalent(b.props.flag))
            cb(uB, b.indexB);
    }
}
function eachIntraBondedAtom(unit, index, cb) {
    var _a = unit.bonds, offset = _a.offset, b = _a.b, flags = _a.edgeProps.flags;
    for (var i = offset[index], il = offset[index + 1]; i < il; ++i) {
        if (_mol_model_structure_model_types__WEBPACK_IMPORTED_MODULE_0__["BondType"].isCovalent(flags[i]))
            cb(unit, b[i]);
    }
}
function eachBondedAtom(structure, unit, index, cb) {
    eachInterBondedAtom(structure, unit, index, cb);
    eachIntraBondedAtom(unit, index, cb);
}
//
function eachResidueAtom(unit, index, cb) {
    var offsets = unit.model.atomicHierarchy.residueAtomSegments.offsets;
    var rI = unit.getResidueIndex(index);
    for (var i = offsets[rI], il = offsets[rI + 1]; i < il; ++i) {
        // TODO optimize, avoid search with .indexOf
        var idx = _mol_data_int__WEBPACK_IMPORTED_MODULE_1__["SortedArray"].indexOf(unit.elements, i);
        if (idx !== -1)
            cb(idx);
    }
}
//# sourceMappingURL=util.js.map

/***/ }),

/***/ "./lib/mol-model-props/computed/chemistry/valence-model.js":
/*!*****************************************************************!*\
  !*** ./lib/mol-model-props/computed/chemistry/valence-model.js ***!
  \*****************************************************************/
/*! exports provided: explicitValence, calculateHydrogensCharge, ValenceModelParams, calcValenceModel */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "explicitValence", function() { return explicitValence; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "calculateHydrogensCharge", function() { return calculateHydrogensCharge; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ValenceModelParams", function() { return ValenceModelParams; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "calcValenceModel", function() { return calcValenceModel; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _mol_model_structure__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../../mol-model/structure */ "./lib/mol-model/structure.js");
/* harmony import */ var _mol_model_structure_model_properties_atomic_types__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../../mol-model/structure/model/properties/atomic/types */ "./lib/mol-model/structure/model/properties/atomic/types.js");
/* harmony import */ var _geometry__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./geometry */ "./lib/mol-model-props/computed/chemistry/geometry.js");
/* harmony import */ var _util__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./util */ "./lib/mol-model-props/computed/chemistry/util.js");
/* harmony import */ var _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../../mol-util/param-definition */ "./lib/mol-util/param-definition.js");
/* harmony import */ var _mol_util_debug__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../../../mol-util/debug */ "./lib/mol-util/debug.js");
/* harmony import */ var _mol_data_int__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../../../mol-data/int */ "./lib/mol-data/int.js");
/* harmony import */ var _mol_model_structure_model_types__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ../../../mol-model/structure/model/types */ "./lib/mol-model/structure/model/types.js");
/**
 * Copyright (c) 2019 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author Fred Ludlow <Fred.Ludlow@astx.com>
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */









/**
 * TODO:
 *   Ensure proper treatment of disorder/models. e.g. V257 N in 5vim
 *   Formal charge of 255 for SO4 anion (e.g. 5ghl)
 *   Have removed a lot of explicit features (as I think they're more
 *   generally captured by better VM).
 *     Could we instead have a "delocalised negative/positive" charge
 *     feature and flag these up?
 *
 */
var tmpConjBondItA = new _mol_model_structure__WEBPACK_IMPORTED_MODULE_1__["Bond"].ElementBondIterator();
var tmpConjBondItB = new _mol_model_structure__WEBPACK_IMPORTED_MODULE_1__["Bond"].ElementBondIterator();
/**
 * Are we involved in some kind of pi system. Either explicitly forming
 * double bond or N, O next to a double bond, except:
 *
 *   N,O with degree 4 cannot be conjugated.
 *   N,O adjacent to P=O or S=O do not qualify (keeps sulfonamide N sp3 geom)
 */
function isConjugated(structure, unit, index) {
    var element = Object(_util__WEBPACK_IMPORTED_MODULE_4__["typeSymbol"])(unit, index);
    var hetero = element === "O" /* O */ || element === "N" /* N */;
    if (hetero && Object(_util__WEBPACK_IMPORTED_MODULE_4__["bondCount"])(structure, unit, index) === 4)
        return false;
    tmpConjBondItA.setElement(structure, unit, index);
    while (tmpConjBondItA.hasNext) {
        var bA = tmpConjBondItA.move();
        if (bA.order > 1)
            return true;
        if (hetero) {
            var elementB = Object(_util__WEBPACK_IMPORTED_MODULE_4__["typeSymbol"])(bA.otherUnit, bA.otherIndex);
            tmpConjBondItB.setElement(structure, bA.otherUnit, bA.otherIndex);
            while (tmpConjBondItB.hasNext) {
                var bB = tmpConjBondItB.move();
                if (bB.order > 1) {
                    if ((elementB === "P" /* P */ || elementB === "S" /* S */) &&
                        Object(_util__WEBPACK_IMPORTED_MODULE_4__["typeSymbol"])(bB.otherUnit, bB.otherIndex) === "O" /* O */) {
                        continue;
                    }
                    return true;
                }
            }
        }
    }
    return false;
}
function explicitValence(structure, unit, index) {
    var v = 0;
    // intra-unit bonds
    var _a = unit.bonds, offset = _a.offset, _b = _a.edgeProps, flags = _b.flags, order = _b.order;
    for (var i = offset[index], il = offset[index + 1]; i < il; ++i) {
        if (_mol_model_structure_model_types__WEBPACK_IMPORTED_MODULE_8__["BondType"].isCovalent(flags[i]))
            v += order[i];
    }
    // inter-unit bonds
    structure.interUnitBonds.getEdgeIndices(index, unit.id).forEach(function (i) {
        var b = structure.interUnitBonds.edges[i];
        if (_mol_model_structure_model_types__WEBPACK_IMPORTED_MODULE_8__["BondType"].isCovalent(b.props.flag))
            v += b.props.order;
    });
    return v;
}
var tmpChargeBondItA = new _mol_model_structure__WEBPACK_IMPORTED_MODULE_1__["Bond"].ElementBondIterator();
var tmpChargeBondItB = new _mol_model_structure__WEBPACK_IMPORTED_MODULE_1__["Bond"].ElementBondIterator();
/**
 * Attempts to produce a consistent charge and implicit
 * H-count for an atom.
 *
 * If both props.assignCharge and props.assignH, this
 * approximately follows the rules described in
 * https://docs.eyesopen.com/toolkits/python/oechemtk/valence.html#openeye-hydrogen-count-model
 *
 * If only charge or hydrogens are to be assigned it takes
 * a much simpler view and deduces one from the other
 */
function calculateHydrogensCharge(structure, unit, index, props) {
    var hydrogenCount = Object(_util__WEBPACK_IMPORTED_MODULE_4__["bondToElementCount"])(structure, unit, index, "H" /* H */);
    var element = Object(_util__WEBPACK_IMPORTED_MODULE_4__["typeSymbol"])(unit, index);
    var charge = Object(_util__WEBPACK_IMPORTED_MODULE_4__["formalCharge"])(unit, index);
    var assignCharge = (props.assignCharge === 'always' || (props.assignCharge === 'auto' && charge === 0));
    var assignH = (props.assignH === 'always' || (props.assignH === 'auto' && hydrogenCount === 0));
    var degree = Object(_util__WEBPACK_IMPORTED_MODULE_4__["bondCount"])(structure, unit, index);
    var valence = explicitValence(structure, unit, index);
    var conjugated = isConjugated(structure, unit, index);
    var multiBond = (valence - degree > 0);
    var implicitHCount = 0;
    var geom = 8 /* Unknown */;
    switch (element) {
        case "H" /* H */:
            if (assignCharge) {
                if (degree === 0) {
                    charge = 1;
                    geom = 0 /* Spherical */;
                }
                else if (degree === 1) {
                    charge = 0;
                    geom = 1 /* Terminal */;
                }
            }
            break;
        case "C" /* C */:
            // TODO: Isocyanide?
            if (assignCharge) {
                charge = 0; // Assume carbon always neutral
            }
            if (assignH) {
                // Carbocation/carbanion are 3-valent
                implicitHCount = Math.max(0, 4 - valence - Math.abs(charge));
            }
            // Carbocation is planar, carbanion is tetrahedral
            geom = Object(_geometry__WEBPACK_IMPORTED_MODULE_3__["assignGeometry"])(degree + implicitHCount + Math.max(0, -charge));
            break;
        case "N" /* N */:
            if (assignCharge) {
                if (!assignH) { // Trust input H explicitly:
                    charge = valence - 3;
                }
                else if (conjugated && valence < 4) {
                    // Neutral unless amidine/guanidine double-bonded N:
                    if (degree - hydrogenCount === 1 && valence - hydrogenCount === 2) {
                        charge = 1;
                    }
                    else {
                        charge = 0;
                    }
                }
                else {
                    // Sulfonamide nitrogen and classed as sp3 in conjugation model but
                    // they won't be charged
                    // Don't assign charge to nitrogens bound to metals
                    tmpChargeBondItA.setElement(structure, unit, index);
                    while (tmpChargeBondItA.hasNext) {
                        var b = tmpChargeBondItA.move();
                        var elementB = Object(_util__WEBPACK_IMPORTED_MODULE_4__["typeSymbol"])(b.otherUnit, b.otherIndex);
                        if (elementB === "S" /* S */ || Object(_mol_model_structure_model_properties_atomic_types__WEBPACK_IMPORTED_MODULE_2__["isMetal"])(elementB)) {
                            charge = 0;
                            break;
                        }
                        else {
                            charge = 1;
                        }
                    }
                    // TODO: Planarity sanity check?
                }
            }
            if (assignH) {
                // NH4+ -> 4, 1' amide -> 2, nitro N/N+ depiction -> 0
                implicitHCount = Math.max(0, 3 - valence + charge);
            }
            if (conjugated && !multiBond) {
                // Amide, anilinic N etc. cannot consider lone-pair for geometry purposes
                // Anilinic N geometry is depenent on ring electronics, for our purposes we
                // assume it's trigonal!
                geom = Object(_geometry__WEBPACK_IMPORTED_MODULE_3__["assignGeometry"])(degree + implicitHCount - charge);
            }
            else {
                // Everything else, pyridine, amine, nitrile, lp plays normal role:
                geom = Object(_geometry__WEBPACK_IMPORTED_MODULE_3__["assignGeometry"])(degree + implicitHCount + 1 - charge);
            }
            break;
        case "O" /* O */:
            if (assignCharge) {
                if (!assignH) {
                    charge = valence - 2;
                }
                if (valence === 1) {
                    tmpChargeBondItA.setElement(structure, unit, index);
                    b1: while (tmpChargeBondItA.hasNext) {
                        var bA = tmpChargeBondItA.move();
                        tmpChargeBondItB.setElement(structure, bA.otherUnit, bA.otherIndex);
                        while (tmpChargeBondItB.hasNext) {
                            var bB = tmpChargeBondItB.move();
                            if (!(bB.otherUnit === unit && bB.otherIndex === index) &&
                                Object(_util__WEBPACK_IMPORTED_MODULE_4__["typeSymbol"])(bB.otherUnit, bB.otherIndex) === "O" /* O */ &&
                                bB.order === 2) {
                                charge = -1;
                                break b1;
                            }
                        }
                    }
                }
            }
            if (assignH) {
                // ethanol -> 1, carboxylate -> -1
                implicitHCount = Math.max(0, 2 - valence + charge);
            }
            if (conjugated && !multiBond) {
                // carboxylate OH, phenol OH, one lone-pair taken up with conjugation
                geom = Object(_geometry__WEBPACK_IMPORTED_MODULE_3__["assignGeometry"])(degree + implicitHCount - charge + 1);
            }
            else {
                // Carbonyl (trigonal)
                geom = Object(_geometry__WEBPACK_IMPORTED_MODULE_3__["assignGeometry"])(degree + implicitHCount - charge + 2);
            }
            break;
        // Only handles thiols/thiolates/thioether/sulfonium. Sulfoxides and higher
        // oxidiation states are assumed neutral S (charge carried on O if required)
        case "S" /* S */:
            if (assignCharge) {
                if (!assignH) {
                    if (valence <= 3 && Object(_util__WEBPACK_IMPORTED_MODULE_4__["bondToElementCount"])(structure, unit, index, "O" /* O */) === 0) {
                        charge = valence - 2; // e.g. explicitly deprotonated thiol
                    }
                    else {
                        charge = 0;
                    }
                }
            }
            if (assignH) {
                if (valence < 2) {
                    implicitHCount = Math.max(0, 2 - valence + charge);
                }
            }
            if (valence <= 3) {
                // Thiol, thiolate, tioether -> tetrahedral
                geom = Object(_geometry__WEBPACK_IMPORTED_MODULE_3__["assignGeometry"])(degree + implicitHCount - charge + 2);
            }
            break;
        case "F" /* F */:
        case "CL" /* CL */:
        case "BR" /* BR */:
        case "I" /* I */:
        case "AT" /* AT */:
            // Never implicitly protonate halides
            if (assignCharge) {
                charge = valence - 1;
            }
            break;
        case "LI" /* LI */:
        case "NA" /* NA */:
        case "K" /* K */:
        case "RB" /* RB */:
        case "CS" /* CS */:
        case "FR" /* FR */:
            if (assignCharge) {
                charge = 1 - valence;
            }
            break;
        case "BE" /* BE */:
        case "MG" /* MG */:
        case "CA" /* CA */:
        case "SR" /* SR */:
        case "BA" /* BA */:
        case "RA" /* RA */:
            if (assignCharge) {
                charge = 2 - valence;
            }
            break;
        default:
            if (_mol_util_debug__WEBPACK_IMPORTED_MODULE_6__["isDebugMode"]) {
                console.warn('Requested charge, protonation for an unhandled element', element);
            }
    }
    return [charge, implicitHCount, implicitHCount + hydrogenCount, geom];
}
function calcUnitValenceModel(structure, unit, props) {
    var n = unit.elements.length;
    var charge = new Int8Array(n);
    var implicitH = new Int8Array(n);
    var totalH = new Int8Array(n);
    var idealGeometry = new Int8Array(n);
    // always use root UnitIndex to take the topology of the whole structure in account
    var hasParent = !!structure.parent;
    var mapping;
    if (hasParent) {
        var rootUnit = structure.root.unitMap.get(unit.id);
        mapping = _mol_data_int__WEBPACK_IMPORTED_MODULE_7__["SortedArray"].indicesOf(rootUnit.elements, unit.elements);
        if (mapping.length !== unit.elements.length) {
            throw new Error('expected to find an index for every element');
        }
        unit = rootUnit;
        structure = structure.root;
    }
    for (var i = 0; i < n; ++i) {
        var j = (hasParent ? mapping[i] : i);
        var _a = calculateHydrogensCharge(structure, unit, j, props), chg = _a[0], implH = _a[1], totH = _a[2], geom = _a[3];
        charge[i] = chg;
        implicitH[i] = implH;
        totalH[i] = totH;
        idealGeometry[i] = geom;
    }
    return { charge: charge, implicitH: implicitH, totalH: totalH, idealGeometry: idealGeometry };
}
var ValenceModelParams = {
    assignCharge: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_5__["ParamDefinition"].Select('auto', [['always', 'always'], ['auto', 'auto'], ['never', 'never']]),
    assignH: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_5__["ParamDefinition"].Select('auto', [['always', 'always'], ['auto', 'auto'], ['never', 'never']]),
};
function calcValenceModel(ctx, structure, props) {
    return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"])(this, void 0, void 0, function () {
        var p, map, i, il, u, valenceModel;
        return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__generator"])(this, function (_a) {
            p = Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_5__["ParamDefinition"].getDefaultValues(ValenceModelParams)), props);
            map = new Map();
            for (i = 0, il = structure.units.length; i < il; ++i) {
                u = structure.units[i];
                if (_mol_model_structure__WEBPACK_IMPORTED_MODULE_1__["Unit"].isAtomic(u)) {
                    valenceModel = calcUnitValenceModel(structure, u, p);
                    map.set(u.id, valenceModel);
                }
            }
            return [2 /*return*/, map];
        });
    });
}
//# sourceMappingURL=valence-model.js.map

/***/ }),

/***/ "./lib/mol-model-props/computed/interactions.js":
/*!******************************************************!*\
  !*** ./lib/mol-model-props/computed/interactions.js ***!
  \******************************************************/
/*! exports provided: InteractionsParams, InteractionsProvider */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "InteractionsParams", function() { return InteractionsParams; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "InteractionsProvider", function() { return InteractionsProvider; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../mol-util/param-definition */ "./lib/mol-util/param-definition.js");
/* harmony import */ var _interactions_interactions__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./interactions/interactions */ "./lib/mol-model-props/computed/interactions/interactions.js");
/* harmony import */ var _common_custom_structure_property__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../common/custom-structure-property */ "./lib/mol-model-props/common/custom-structure-property.js");
/* harmony import */ var _mol_model_custom_property__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../mol-model/custom-property */ "./lib/mol-model/custom-property.js");
/**
 * Copyright (c) 2019 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */





var InteractionsParams = Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, _interactions_interactions__WEBPACK_IMPORTED_MODULE_2__["InteractionsParams"]);
var InteractionsProvider = _common_custom_structure_property__WEBPACK_IMPORTED_MODULE_3__["CustomStructureProperty"].createProvider({
    label: 'Interactions',
    descriptor: Object(_mol_model_custom_property__WEBPACK_IMPORTED_MODULE_4__["CustomPropertyDescriptor"])({
        name: 'molstar_computed_interactions',
    }),
    type: 'local',
    defaultParams: InteractionsParams,
    getParams: function (data) { return InteractionsParams; },
    isApplicable: function (data) { return true; },
    obtain: function (ctx, data, props) { return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"])(void 0, void 0, void 0, function () {
        var p;
        var _a;
        return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__generator"])(this, function (_b) {
            switch (_b.label) {
                case 0:
                    p = Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_1__["ParamDefinition"].getDefaultValues(InteractionsParams)), props);
                    _a = {};
                    return [4 /*yield*/, Object(_interactions_interactions__WEBPACK_IMPORTED_MODULE_2__["computeInteractions"])(ctx, data, p)];
                case 1: return [2 /*return*/, (_a.value = _b.sent(), _a)];
            }
        });
    }); }
});
//# sourceMappingURL=interactions.js.map

/***/ }),

/***/ "./lib/mol-model-props/computed/interactions/charged.js":
/*!**************************************************************!*\
  !*** ./lib/mol-model-props/computed/interactions/charged.js ***!
  \**************************************************************/
/*! exports provided: NegativChargeProvider, PositiveChargeProvider, AromaticRingProvider, IonicProvider, PiStackingProvider, CationPiProvider */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "NegativChargeProvider", function() { return NegativChargeProvider; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "PositiveChargeProvider", function() { return PositiveChargeProvider; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "AromaticRingProvider", function() { return AromaticRingProvider; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "IonicProvider", function() { return IonicProvider; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "PiStackingProvider", function() { return PiStackingProvider; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CationPiProvider", function() { return CationPiProvider; });
/* harmony import */ var _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../../mol-util/param-definition */ "./lib/mol-util/param-definition.js");
/* harmony import */ var _features__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./features */ "./lib/mol-model-props/computed/interactions/features.js");
/* harmony import */ var _mol_model_structure_model_types__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../../mol-model/structure/model/types */ "./lib/mol-model/structure/model/types.js");
/* harmony import */ var _chemistry_util__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../chemistry/util */ "./lib/mol-model-props/computed/chemistry/util.js");
/* harmony import */ var _valence_model__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../valence-model */ "./lib/mol-model-props/computed/valence-model.js");
/* harmony import */ var _mol_math_misc__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../../mol-math/misc */ "./lib/mol-math/misc.js");
/* harmony import */ var _mol_data_int__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../../../mol-data/int */ "./lib/mol-data/int.js");
/* harmony import */ var _chemistry_functional_group__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../chemistry/functional-group */ "./lib/mol-model-props/computed/chemistry/functional-group.js");
/* harmony import */ var _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ../../../mol-math/linear-algebra */ "./lib/mol-math/linear-algebra.js");
/**
 * Copyright (c) 2019 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 * @author Fred Ludlow <Fred.Ludlow@astx.com>
 *
 * based in part on NGL (https://github.com/arose/ngl)
 */









var IonicParams = {
    distanceMax: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_0__["ParamDefinition"].Numeric(5.0, { min: 0, max: 8, step: 0.1 }),
};
var PiStackingParams = {
    distanceMax: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_0__["ParamDefinition"].Numeric(5.5, { min: 1, max: 8, step: 0.1 }),
    offsetMax: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_0__["ParamDefinition"].Numeric(2.0, { min: 0, max: 4, step: 0.1 }),
    angleDevMax: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_0__["ParamDefinition"].Numeric(30, { min: 0, max: 180, step: 1 }),
};
var CationPiParams = {
    distanceMax: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_0__["ParamDefinition"].Numeric(6.0, { min: 1, max: 8, step: 0.1 }),
    offsetMax: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_0__["ParamDefinition"].Numeric(2.0, { min: 0, max: 4, step: 0.1 }),
};
//
var PositvelyCharged = ['ARG', 'HIS', 'LYS'];
var NegativelyCharged = ['GLU', 'ASP'];
function getUnitValenceModel(structure, unit) {
    var valenceModel = _valence_model__WEBPACK_IMPORTED_MODULE_4__["ValenceModelProvider"].get(structure).value;
    if (!valenceModel)
        throw Error('expected valence model to be available');
    var unitValenceModel = valenceModel.get(unit.id);
    if (!unitValenceModel)
        throw Error('expected valence model for unit to be available');
    return unitValenceModel;
}
function addUnitPositiveCharges(structure, unit, builder) {
    var charge = getUnitValenceModel(structure, unit).charge;
    var elements = unit.elements;
    var _a = unit.model.atomicConformation, x = _a.x, y = _a.y, z = _a.z;
    var addedElements = new Set();
    var label_comp_id = unit.model.atomicHierarchy.atoms.label_comp_id;
    var residueIt = _mol_data_int__WEBPACK_IMPORTED_MODULE_6__["Segmentation"].transientSegments(unit.model.atomicHierarchy.residueAtomSegments, elements);
    while (residueIt.hasNext) {
        var _b = residueIt.move(), residueIndex = _b.index, start = _b.start, end = _b.end;
        var compId = label_comp_id.value(unit.model.atomicHierarchy.residueAtomSegments.offsets[residueIndex]);
        if (PositvelyCharged.includes(compId)) {
            builder.startState();
            for (var j = start; j < end; ++j) {
                if (Object(_chemistry_util__WEBPACK_IMPORTED_MODULE_3__["typeSymbol"])(unit, j) === "N" /* N */ && !_mol_model_structure_model_types__WEBPACK_IMPORTED_MODULE_2__["ProteinBackboneAtoms"].has(Object(_chemistry_util__WEBPACK_IMPORTED_MODULE_3__["atomId"])(unit, j))) {
                    builder.pushMember(x[elements[j]], y[elements[j]], z[elements[j]], j);
                }
            }
            builder.finishState(1 /* PositiveCharge */, 0 /* None */);
        }
        else if (!_mol_model_structure_model_types__WEBPACK_IMPORTED_MODULE_2__["PolymerNames"].has(compId)) {
            addedElements.clear();
            for (var j = start; j < end; ++j) {
                var group = 0 /* None */;
                if (Object(_chemistry_functional_group__WEBPACK_IMPORTED_MODULE_7__["isGuanidine"])(structure, unit, j)) {
                    group = 8 /* Guanidine */;
                }
                else if (Object(_chemistry_functional_group__WEBPACK_IMPORTED_MODULE_7__["isAcetamidine"])(structure, unit, j)) {
                    group = 9 /* Acetamidine */;
                }
                if (group) {
                    builder.startState();
                    Object(_chemistry_util__WEBPACK_IMPORTED_MODULE_3__["eachBondedAtom"])(structure, unit, j, function (_, k) {
                        if (Object(_chemistry_util__WEBPACK_IMPORTED_MODULE_3__["typeSymbol"])(unit, k) === "N" /* N */) {
                            addedElements.add(k);
                            builder.pushMember(x[elements[k]], y[elements[k]], z[elements[k]], k);
                        }
                    });
                    builder.finishState(1 /* PositiveCharge */, group);
                }
            }
            for (var j = start; j < end; ++j) {
                if (charge[j] > 0 && !addedElements.has(j)) {
                    builder.add(1 /* PositiveCharge */, 0 /* None */, x[elements[j]], y[elements[j]], z[elements[j]], j);
                }
            }
        }
    }
}
function addUnitNegativeCharges(structure, unit, builder) {
    var charge = getUnitValenceModel(structure, unit).charge;
    var elements = unit.elements;
    var _a = unit.model.atomicConformation, x = _a.x, y = _a.y, z = _a.z;
    var addedElements = new Set();
    var label_comp_id = unit.model.atomicHierarchy.atoms.label_comp_id;
    var residueIt = _mol_data_int__WEBPACK_IMPORTED_MODULE_6__["Segmentation"].transientSegments(unit.model.atomicHierarchy.residueAtomSegments, elements);
    while (residueIt.hasNext) {
        var _b = residueIt.move(), residueIndex = _b.index, start = _b.start, end = _b.end;
        var compId = label_comp_id.value(unit.model.atomicHierarchy.residueAtomSegments.offsets[residueIndex]);
        if (NegativelyCharged.includes(compId)) {
            builder.startState();
            for (var j = start; j < end; ++j) {
                if (Object(_chemistry_util__WEBPACK_IMPORTED_MODULE_3__["typeSymbol"])(unit, j) === "O" /* O */ && !_mol_model_structure_model_types__WEBPACK_IMPORTED_MODULE_2__["ProteinBackboneAtoms"].has(Object(_chemistry_util__WEBPACK_IMPORTED_MODULE_3__["atomId"])(unit, j))) {
                    builder.pushMember(x[elements[j]], y[elements[j]], z[elements[j]], j);
                }
            }
            builder.finishState(2 /* NegativeCharge */, 0 /* None */);
        }
        else if (_mol_model_structure_model_types__WEBPACK_IMPORTED_MODULE_2__["BaseNames"].has(compId)) {
            for (var j = start; j < end; ++j) {
                if (Object(_chemistry_functional_group__WEBPACK_IMPORTED_MODULE_7__["isPhosphate"])(structure, unit, j)) {
                    builder.startState();
                    Object(_chemistry_util__WEBPACK_IMPORTED_MODULE_3__["eachBondedAtom"])(structure, unit, j, function (_, k) {
                        if (Object(_chemistry_util__WEBPACK_IMPORTED_MODULE_3__["typeSymbol"])(unit, k) === "O" /* O */) {
                            builder.pushMember(x[elements[k]], y[elements[k]], z[elements[k]], k);
                        }
                    });
                    builder.finishState(2 /* NegativeCharge */, 6 /* Phosphate */);
                }
            }
        }
        else if (!_mol_model_structure_model_types__WEBPACK_IMPORTED_MODULE_2__["PolymerNames"].has(compId)) {
            for (var j = start; j < end; ++j) {
                builder.startState();
                if (Object(_chemistry_util__WEBPACK_IMPORTED_MODULE_3__["typeSymbol"])(unit, j) === "N" /* N */ && !_mol_model_structure_model_types__WEBPACK_IMPORTED_MODULE_2__["ProteinBackboneAtoms"].has(Object(_chemistry_util__WEBPACK_IMPORTED_MODULE_3__["atomId"])(unit, j))) {
                    builder.pushMember(x[elements[j]], y[elements[j]], z[elements[j]], j);
                }
                builder.finishState(2 /* NegativeCharge */, 0 /* None */);
                var group = 0 /* None */;
                if (Object(_chemistry_functional_group__WEBPACK_IMPORTED_MODULE_7__["isSulfonicAcid"])(structure, unit, j)) {
                    group = 4 /* SulfonicAcid */;
                }
                else if (Object(_chemistry_functional_group__WEBPACK_IMPORTED_MODULE_7__["isPhosphate"])(structure, unit, j)) {
                    group = 6 /* Phosphate */;
                }
                else if (Object(_chemistry_functional_group__WEBPACK_IMPORTED_MODULE_7__["isSulfate"])(structure, unit, j)) {
                    group = 5 /* Sulfate */;
                }
                else if (Object(_chemistry_functional_group__WEBPACK_IMPORTED_MODULE_7__["isCarboxylate"])(structure, unit, j)) {
                    group = 10 /* Carboxylate */;
                }
                if (group) {
                    builder.startState();
                    Object(_chemistry_util__WEBPACK_IMPORTED_MODULE_3__["eachBondedAtom"])(structure, unit, j, function (_, k) {
                        if (Object(_chemistry_util__WEBPACK_IMPORTED_MODULE_3__["typeSymbol"])(unit, k) === "O" /* O */) {
                            addedElements.add(k);
                            builder.pushMember(x[elements[k]], y[elements[k]], z[elements[k]], k);
                        }
                    });
                    builder.finishState(2 /* NegativeCharge */, group);
                }
            }
            for (var j = start; j < end; ++j) {
                if (charge[j] < 0 && !addedElements.has(j)) {
                    builder.add(2 /* NegativeCharge */, 0 /* None */, x[elements[j]], y[elements[j]], z[elements[j]], j);
                }
            }
        }
    }
}
function addUnitAromaticRings(structure, unit, builder) {
    var elements = unit.elements;
    var _a = unit.model.atomicConformation, x = _a.x, y = _a.y, z = _a.z;
    for (var _i = 0, _b = unit.rings.aromaticRings; _i < _b.length; _i++) {
        var ringIndex = _b[_i];
        var ring = unit.rings.all[ringIndex];
        builder.startState();
        for (var i = 0, il = ring.length; i < il; ++i) {
            var j = ring[i];
            builder.pushMember(x[elements[j]], y[elements[j]], z[elements[j]], j);
        }
        builder.finishState(3 /* AromaticRing */, 0 /* None */);
    }
}
function isIonic(ti, tj) {
    return ((ti === 2 /* NegativeCharge */ && tj === 1 /* PositiveCharge */) ||
        (ti === 1 /* PositiveCharge */ && tj === 2 /* NegativeCharge */));
}
function isPiStacking(ti, tj) {
    return ti === 3 /* AromaticRing */ && tj === 3 /* AromaticRing */;
}
function isCationPi(ti, tj) {
    return ((ti === 3 /* AromaticRing */ && tj === 1 /* PositiveCharge */) ||
        (ti === 1 /* PositiveCharge */ && tj === 3 /* AromaticRing */));
}
var tmpPointA = Object(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_8__["Vec3"])();
var tmpPointB = Object(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_8__["Vec3"])();
function areFeaturesWithinDistanceSq(infoA, infoB, distanceSq) {
    var featureA = infoA.feature, offsetsA = infoA.offsets, membersA = infoA.members;
    var featureB = infoB.feature, offsetsB = infoB.offsets, membersB = infoB.members;
    for (var i = offsetsA[featureA], il = offsetsA[featureA + 1]; i < il; ++i) {
        var elementA = membersA[i];
        infoA.unit.conformation.position(infoA.unit.elements[elementA], tmpPointA);
        for (var j = offsetsB[featureB], jl = offsetsB[featureB + 1]; j < jl; ++j) {
            var elementB = membersB[j];
            infoB.unit.conformation.position(infoB.unit.elements[elementB], tmpPointB);
            if (_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_8__["Vec3"].squaredDistance(tmpPointA, tmpPointB) < distanceSq)
                return true;
        }
    }
    return false;
}
var tmpVecA = Object(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_8__["Vec3"])();
var tmpVecB = Object(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_8__["Vec3"])();
var tmpVecC = Object(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_8__["Vec3"])();
var tmpVecD = Object(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_8__["Vec3"])();
function getNormal(out, info) {
    var unit = info.unit, feature = info.feature, offsets = info.offsets, members = info.members;
    var elements = unit.elements;
    var i = offsets[feature];
    info.unit.conformation.position(elements[members[i]], tmpVecA);
    info.unit.conformation.position(elements[members[i + 1]], tmpVecB);
    info.unit.conformation.position(elements[members[i + 2]], tmpVecC);
    return _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_8__["Vec3"].triangleNormal(out, tmpVecA, tmpVecB, tmpVecC);
}
var getOffset = function (infoA, infoB, normal) {
    _features__WEBPACK_IMPORTED_MODULE_1__["Features"].position(tmpVecA, infoA);
    _features__WEBPACK_IMPORTED_MODULE_1__["Features"].position(tmpVecB, infoB);
    _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_8__["Vec3"].sub(tmpVecC, tmpVecA, tmpVecB);
    _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_8__["Vec3"].projectOnPlane(tmpVecD, tmpVecC, normal);
    _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_8__["Vec3"].add(tmpVecD, tmpVecD, tmpVecB);
    return _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_8__["Vec3"].distance(tmpVecD, tmpVecB);
};
function getIonicOptions(props) {
    return {
        distanceMaxSq: props.distanceMax * props.distanceMax,
    };
}
function getPiStackingOptions(props) {
    return {
        offsetMax: props.offsetMax,
        angleDevMax: Object(_mol_math_misc__WEBPACK_IMPORTED_MODULE_5__["degToRad"])(props.angleDevMax),
    };
}
function getCationPiOptions(props) {
    return {
        offsetMax: props.offsetMax
    };
}
var deg180InRad = Object(_mol_math_misc__WEBPACK_IMPORTED_MODULE_5__["degToRad"])(180);
var deg90InRad = Object(_mol_math_misc__WEBPACK_IMPORTED_MODULE_5__["degToRad"])(90);
var tmpNormalA = Object(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_8__["Vec3"])();
var tmpNormalB = Object(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_8__["Vec3"])();
function testIonic(structure, infoA, infoB, distanceSq, opts) {
    var typeA = infoA.types[infoA.feature];
    var typeB = infoB.types[infoB.feature];
    if (isIonic(typeA, typeB)) {
        if (areFeaturesWithinDistanceSq(infoA, infoB, opts.distanceMaxSq)) {
            return 1 /* Ionic */;
        }
    }
}
function testPiStacking(structure, infoA, infoB, distanceSq, opts) {
    var typeA = infoA.types[infoA.feature];
    var typeB = infoB.types[infoB.feature];
    if (isPiStacking(typeA, typeB)) {
        getNormal(tmpNormalA, infoA);
        getNormal(tmpNormalB, infoB);
        var angle = _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_8__["Vec3"].angle(tmpNormalA, tmpNormalB);
        var offset = Math.min(getOffset(infoA, infoB, tmpNormalB), getOffset(infoB, infoA, tmpNormalA));
        if (offset <= opts.offsetMax) {
            if (angle <= opts.angleDevMax || angle >= deg180InRad - opts.angleDevMax) {
                return 3 /* PiStacking */; // parallel
            }
            else if (angle <= opts.angleDevMax + deg90InRad && angle >= deg90InRad - opts.angleDevMax) {
                return 3 /* PiStacking */; // t-shaped
            }
        }
    }
}
function testCationPi(structure, infoA, infoB, distanceSq, opts) {
    var typeA = infoA.types[infoA.feature];
    var typeB = infoB.types[infoB.feature];
    if (isCationPi(typeA, typeB)) {
        var _a = typeA === 3 /* AromaticRing */ ? [infoA, infoB] : [infoB, infoA], infoR = _a[0], infoC = _a[1];
        getNormal(tmpNormalA, infoR);
        var offset = getOffset(infoC, infoR, tmpNormalA);
        if (offset <= opts.offsetMax) {
            return 2 /* CationPi */;
        }
    }
}
//
var NegativChargeProvider = _features__WEBPACK_IMPORTED_MODULE_1__["Features"].Provider([2 /* NegativeCharge */], addUnitNegativeCharges);
var PositiveChargeProvider = _features__WEBPACK_IMPORTED_MODULE_1__["Features"].Provider([1 /* PositiveCharge */], addUnitPositiveCharges);
var AromaticRingProvider = _features__WEBPACK_IMPORTED_MODULE_1__["Features"].Provider([3 /* AromaticRing */], addUnitAromaticRings);
var IonicProvider = {
    name: 'ionic',
    params: IonicParams,
    createTester: function (props) {
        var opts = getIonicOptions(props);
        return {
            maxDistance: props.distanceMax,
            requiredFeatures: new Set([2 /* NegativeCharge */, 1 /* PositiveCharge */]),
            getType: function (structure, infoA, infoB, distanceSq) { return testIonic(structure, infoA, infoB, distanceSq, opts); }
        };
    }
};
var PiStackingProvider = {
    name: 'pi-stacking',
    params: PiStackingParams,
    createTester: function (props) {
        var opts = getPiStackingOptions(props);
        return {
            maxDistance: props.distanceMax,
            requiredFeatures: new Set([3 /* AromaticRing */]),
            getType: function (structure, infoA, infoB, distanceSq) { return testPiStacking(structure, infoA, infoB, distanceSq, opts); }
        };
    }
};
var CationPiProvider = {
    name: 'cation-pi',
    params: CationPiParams,
    createTester: function (props) {
        var opts = getCationPiOptions(props);
        return {
            maxDistance: props.distanceMax,
            requiredFeatures: new Set([3 /* AromaticRing */, 1 /* PositiveCharge */]),
            getType: function (structure, infoA, infoB, distanceSq) { return testCationPi(structure, infoA, infoB, distanceSq, opts); }
        };
    }
};
//# sourceMappingURL=charged.js.map

/***/ }),

/***/ "./lib/mol-model-props/computed/interactions/common.js":
/*!*************************************************************!*\
  !*** ./lib/mol-model-props/computed/interactions/common.js ***!
  \*************************************************************/
/*! exports provided: InteractionsIntraContacts, InteractionsInterContacts, interactionTypeLabel, featureTypeLabel, featureGroupLabel */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "InteractionsIntraContacts", function() { return InteractionsIntraContacts; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "InteractionsInterContacts", function() { return InteractionsInterContacts; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "interactionTypeLabel", function() { return interactionTypeLabel; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "featureTypeLabel", function() { return featureTypeLabel; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "featureGroupLabel", function() { return featureGroupLabel; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _mol_math_graph_inter_unit_graph__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../../mol-math/graph/inter-unit-graph */ "./lib/mol-math/graph/inter-unit-graph.js");
/**
 * Copyright (c) 2019-2020 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */



var InteractionsIntraContacts;
(function (InteractionsIntraContacts) {
    /**
     * Note: assumes that feature members of a contact are non-overlapping
     */
    function createElementsIndex(contacts, features, elementsCount) {
        var offsets = new Int32Array(elementsCount + 1);
        var bucketFill = new Int32Array(elementsCount);
        var bucketSizes = new Int32Array(elementsCount);
        var members = features.members, featureOffsets = features.offsets;
        for (var i = 0, il = contacts.edgeCount * 2; i < il; ++i) {
            var aI = contacts.a[i];
            var bI = contacts.b[i];
            if (aI > bI)
                continue;
            for (var j = featureOffsets[aI], jl = featureOffsets[aI + 1]; j < jl; ++j) {
                ++bucketSizes[members[j]];
            }
            for (var j = featureOffsets[bI], jl = featureOffsets[bI + 1]; j < jl; ++j) {
                ++bucketSizes[members[j]];
            }
        }
        var offset = 0;
        for (var i = 0; i < elementsCount; i++) {
            offsets[i] = offset;
            offset += bucketSizes[i];
        }
        offsets[elementsCount] = offset;
        var indices = new Int32Array(offset);
        for (var i = 0, il = contacts.edgeCount * 2; i < il; ++i) {
            var aI = contacts.a[i];
            var bI = contacts.b[i];
            if (aI > bI)
                continue;
            for (var j = featureOffsets[aI], jl = featureOffsets[aI + 1]; j < jl; ++j) {
                var m = members[j];
                var om = offsets[m] + bucketFill[m];
                indices[om] = i;
                ++bucketFill[m];
            }
            for (var j = featureOffsets[bI], jl = featureOffsets[bI + 1]; j < jl; ++j) {
                var m = members[j];
                var om = offsets[m] + bucketFill[m];
                indices[om] = i;
                ++bucketFill[m];
            }
        }
        return { indices: indices, offsets: offsets };
    }
    InteractionsIntraContacts.createElementsIndex = createElementsIndex;
})(InteractionsIntraContacts || (InteractionsIntraContacts = {}));

var InteractionsInterContacts = /** @class */ (function (_super) {
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__extends"])(InteractionsInterContacts, _super);
    function InteractionsInterContacts(map, unitsFeatures) {
        var _this = _super.call(this, map) || this;
        var count = 0;
        var elementKeyIndex = new Map();
        var add = function (index, unitId) {
            var vertexKey = _this.getElementKey(index, unitId);
            var e = elementKeyIndex.get(vertexKey);
            if (e === undefined)
                elementKeyIndex.set(vertexKey, [count]);
            else
                e.push(count);
        };
        _this.map.forEach(function (pairEdgesArray) {
            pairEdgesArray.forEach(function (_a) {
                var unitA = _a.unitA, connectedIndices = _a.connectedIndices;
                connectedIndices.forEach(function (indexA) {
                    var _a = unitsFeatures.get(unitA), offsetsA = _a.offsets, membersA = _a.members;
                    for (var j = offsetsA[indexA], jl = offsetsA[indexA + 1]; j < jl; ++j) {
                        add(membersA[j], unitA);
                    }
                    count += 1;
                });
            });
        });
        _this.elementKeyIndex = elementKeyIndex;
        return _this;
    }
    InteractionsInterContacts.prototype.getContactIndicesForElement = function (index, unit) {
        return this.elementKeyIndex.get(this.getElementKey(index, unit.id)) || [];
    };
    InteractionsInterContacts.prototype.getElementKey = function (index, unitId) {
        return index + "|" + unitId;
    };
    return InteractionsInterContacts;
}(_mol_math_graph_inter_unit_graph__WEBPACK_IMPORTED_MODULE_1__["InterUnitGraph"]));
function interactionTypeLabel(type) {
    switch (type) {
        case 4 /* HydrogenBond */:
            return 'Hydrogen Bond';
        case 6 /* Hydrophobic */:
            return 'Hydrophobic Contact';
        case 5 /* HalogenBond */:
            return 'Halogen Bond';
        case 1 /* Ionic */:
            return 'Ionic Interaction';
        case 7 /* MetalCoordination */:
            return 'Metal Coordination';
        case 2 /* CationPi */:
            return 'Cation-Pi Interaction';
        case 3 /* PiStacking */:
            return 'Pi Stacking';
        case 8 /* WeakHydrogenBond */:
            return 'Weak Hydrogen Bond';
        case 0 /* Unknown */:
            return 'Unknown Interaction';
    }
}
function featureTypeLabel(type) {
    switch (type) {
        case 0 /* None */:
            return 'None';
        case 1 /* PositiveCharge */:
            return 'Positive Charge';
        case 2 /* NegativeCharge */:
            return 'Negative Charge';
        case 3 /* AromaticRing */:
            return 'Aromatic Ring';
        case 4 /* HydrogenDonor */:
            return 'Hydrogen Donor';
        case 5 /* HydrogenAcceptor */:
            return 'Hydrogen Acceptor';
        case 6 /* HalogenDonor */:
            return 'Halogen Donor';
        case 7 /* HalogenAcceptor */:
            return 'Halogen Acceptor';
        case 8 /* HydrophobicAtom */:
            return 'HydrophobicAtom';
        case 9 /* WeakHydrogenDonor */:
            return 'Weak Hydrogen Donor';
        case 10 /* IonicTypePartner */:
            return 'Ionic Type Partner';
        case 11 /* DativeBondPartner */:
            return 'Dative Bond Partner';
        case 12 /* TransitionMetal */:
            return 'Transition Metal';
        case 13 /* IonicTypeMetal */:
            return 'Ionic Type Metal';
    }
}
function featureGroupLabel(group) {
    switch (group) {
        case 0 /* None */:
            return 'None';
        case 1 /* QuaternaryAmine */:
            return 'Quaternary Amine';
        case 2 /* TertiaryAmine */:
            return 'Tertiary Amine';
        case 3 /* Sulfonium */:
            return 'Sulfonium';
        case 4 /* SulfonicAcid */:
            return 'Sulfonic Acid';
        case 5 /* Sulfate */:
            return 'Sulfate';
        case 6 /* Phosphate */:
            return 'Phosphate';
        case 7 /* Halocarbon */:
            return 'Halocarbon';
        case 8 /* Guanidine */:
            return 'Guanidine';
        case 9 /* Acetamidine */:
            return 'Acetamidine';
        case 10 /* Carboxylate */:
            return 'Carboxylate';
    }
}
//# sourceMappingURL=common.js.map

/***/ }),

/***/ "./lib/mol-model-props/computed/interactions/contacts-builder.js":
/*!***********************************************************************!*\
  !*** ./lib/mol-model-props/computed/interactions/contacts-builder.js ***!
  \***********************************************************************/
/*! exports provided: IntraContactsBuilder, InterContactsBuilder */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "IntraContactsBuilder", function() { return IntraContactsBuilder; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "InterContactsBuilder", function() { return InterContactsBuilder; });
/* harmony import */ var _mol_math_graph__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../../mol-math/graph */ "./lib/mol-math/graph.js");
/* harmony import */ var _common__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./common */ "./lib/mol-model-props/computed/interactions/common.js");
/* harmony import */ var _mol_math_graph_inter_unit_graph__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../../mol-math/graph/inter-unit-graph */ "./lib/mol-math/graph/inter-unit-graph.js");
/**
 * Copyright (c) 2019-2020 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */




var IntraContactsBuilder;
(function (IntraContactsBuilder) {
    function create(features, elementsCount) {
        var aIndices = [];
        var bIndices = [];
        var types = [];
        return {
            add: function (indexA, indexB, type) {
                aIndices[aIndices.length] = indexA;
                bIndices[bIndices.length] = indexB;
                types[types.length] = type;
            },
            getContacts: function () {
                var builder = new _mol_math_graph__WEBPACK_IMPORTED_MODULE_0__["IntAdjacencyGraph"].EdgeBuilder(features.count, aIndices, bIndices);
                var type = new Int8Array(builder.slotCount);
                var flag = new Int8Array(builder.slotCount);
                for (var i = 0, _i = builder.edgeCount; i < _i; i++) {
                    builder.addNextEdge();
                    builder.assignProperty(type, types[i]);
                }
                var graph = builder.createGraph({ type: type, flag: flag });
                var elementsIndex;
                var contacts = Object.defineProperty(graph, 'elementsIndex', {
                    get: function () {
                        return elementsIndex || (elementsIndex = _common__WEBPACK_IMPORTED_MODULE_1__["InteractionsIntraContacts"].createElementsIndex(graph, features, elementsCount));
                    }
                });
                return contacts;
            }
        };
    }
    IntraContactsBuilder.create = create;
})(IntraContactsBuilder || (IntraContactsBuilder = {}));

var InterContactsBuilder;
(function (InterContactsBuilder) {
    function create() {
        var builder = new _mol_math_graph_inter_unit_graph__WEBPACK_IMPORTED_MODULE_2__["InterUnitGraph"].Builder();
        return {
            startUnitPair: function (unitA, unitB) {
                builder.startUnitPair(unitA.id, unitB.id);
            },
            finishUnitPair: function () {
                builder.finishUnitPair();
            },
            add: function (indexA, indexB, type) {
                builder.add(indexA, indexB, { type: type, flag: 0 /* None */ });
            },
            getContacts: function (unitsFeatures) {
                return new _common__WEBPACK_IMPORTED_MODULE_1__["InteractionsInterContacts"](builder.getMap(), unitsFeatures);
            }
        };
    }
    InterContactsBuilder.create = create;
})(InterContactsBuilder || (InterContactsBuilder = {}));
//# sourceMappingURL=contacts-builder.js.map

/***/ }),

/***/ "./lib/mol-model-props/computed/interactions/contacts.js":
/*!***************************************************************!*\
  !*** ./lib/mol-model-props/computed/interactions/contacts.js ***!
  \***************************************************************/
/*! exports provided: ContactsParams, addUnitContacts, addStructureContacts */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ContactsParams", function() { return ContactsParams; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "addUnitContacts", function() { return addUnitContacts; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "addStructureContacts", function() { return addStructureContacts; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../../mol-util/param-definition */ "./lib/mol-util/param-definition.js");
/* harmony import */ var _mol_model_structure__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../../mol-model/structure */ "./lib/mol-model/structure.js");
/* harmony import */ var _features__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./features */ "./lib/mol-model-props/computed/interactions/features.js");
/* harmony import */ var _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../../mol-math/linear-algebra */ "./lib/mol-math/linear-algebra.js");
/* harmony import */ var _chemistry_util__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../chemistry/util */ "./lib/mol-model-props/computed/chemistry/util.js");
/* harmony import */ var _mol_data_int__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../../../mol-data/int */ "./lib/mol-data/int.js");
/* harmony import */ var _mol_model_structure_model_properties_atomic__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../../../mol-model/structure/model/properties/atomic */ "./lib/mol-model/structure/model/properties/atomic.js");
/**
 * Copyright (c) 2019 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */








var ContactsParams = {
    lineOfSightDistFactor: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_1__["ParamDefinition"].Numeric(1.0, { min: 0, max: 3, step: 0.1 }),
};
var MAX_LINE_OF_SIGHT_DISTANCE = 3;
function validPair(structure, infoA, infoB) {
    var indexA = infoA.members[infoA.offsets[infoA.feature]];
    var indexB = infoB.members[infoB.offsets[infoB.feature]];
    if (indexA === indexB && infoA.unit === infoB.unit)
        return false; // no self interaction
    var altA = Object(_chemistry_util__WEBPACK_IMPORTED_MODULE_5__["altLoc"])(infoA.unit, indexA);
    var altB = Object(_chemistry_util__WEBPACK_IMPORTED_MODULE_5__["altLoc"])(infoB.unit, indexB);
    if (altA && altB && altA !== altB)
        return false; // incompatible alternate location id
    if (infoA.unit.residueIndex[infoA.unit.elements[indexA]] === infoB.unit.residueIndex[infoB.unit.elements[indexB]] && infoA.unit === infoB.unit)
        return false; // same residue
    // e.g. no hbond if donor and acceptor are bonded
    if (Object(_chemistry_util__WEBPACK_IMPORTED_MODULE_5__["connectedTo"])(structure, infoA.unit, indexA, infoB.unit, indexB))
        return false;
    return true;
}
//
function invalidAltLoc(unitA, indexA, unitB, indexB) {
    var altA = Object(_chemistry_util__WEBPACK_IMPORTED_MODULE_5__["altLoc"])(unitA, indexA);
    var altB = Object(_chemistry_util__WEBPACK_IMPORTED_MODULE_5__["altLoc"])(unitB, indexB);
    return altA && altB && altA !== altB;
}
function isMember(element, info) {
    var feature = info.feature, offsets = info.offsets, members = info.members;
    for (var i = offsets[feature], il = offsets[feature + 1]; i < il; ++i) {
        if (members[i] === element)
            return true;
    }
    return false;
}
var tmpVec = Object(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_4__["Vec3"])();
var tmpVecA = Object(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_4__["Vec3"])();
var tmpVecB = Object(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_4__["Vec3"])();
function checkLineOfSight(structure, infoA, infoB, distFactor) {
    var featureA = infoA.feature;
    var featureB = infoB.feature;
    var indexA = infoA.members[infoA.offsets[featureA]];
    var indexB = infoB.members[infoB.offsets[featureB]];
    _features__WEBPACK_IMPORTED_MODULE_3__["Features"].position(tmpVecA, infoA);
    _features__WEBPACK_IMPORTED_MODULE_3__["Features"].position(tmpVecB, infoB);
    _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_4__["Vec3"].scale(tmpVec, _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_4__["Vec3"].add(tmpVec, tmpVecA, tmpVecB), 0.5);
    var distMax = distFactor * MAX_LINE_OF_SIGHT_DISTANCE;
    var _a = structure.lookup3d.find(tmpVec[0], tmpVec[1], tmpVec[2], distMax), count = _a.count, indices = _a.indices, units = _a.units, squaredDistances = _a.squaredDistances;
    if (count === 0)
        return true;
    for (var r = 0; r < count; ++r) {
        var i = indices[r];
        var unit = units[r];
        if (!_mol_model_structure__WEBPACK_IMPORTED_MODULE_2__["Unit"].isAtomic(unit))
            continue;
        var element = Object(_chemistry_util__WEBPACK_IMPORTED_MODULE_5__["typeSymbol"])(unit, i);
        // allow hydrogens
        if (element === "H" /* H */)
            continue;
        var vdw = Object(_mol_model_structure_model_properties_atomic__WEBPACK_IMPORTED_MODULE_7__["VdwRadius"])(element);
        // check distance
        if (vdw * vdw * distFactor * distFactor <= squaredDistances[r])
            continue;
        // allow different altlocs
        if (invalidAltLoc(unit, i, infoA.unit, indexA) || invalidAltLoc(unit, i, infoB.unit, indexB))
            continue;
        // allow member atoms
        if ((infoA.unit === unit && isMember(i, infoA)) || (infoB.unit === unit && isMember(i, infoB)))
            continue;
        unit.conformation.position(unit.elements[i], tmpVec);
        // allow atoms at the center of functional groups
        if (_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_4__["Vec3"].squaredDistance(tmpVec, tmpVecA) < 1 || _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_4__["Vec3"].squaredDistance(tmpVec, tmpVecB) < 1)
            continue;
        return false;
    }
    return true;
}
/**
 * Add all intra-unit contacts, i.e. pairs of features
 */
function addUnitContacts(structure, unit, features, builder, testers, props) {
    for (var _i = 0, testers_1 = testers; _i < testers_1.length; _i++) {
        var tester = testers_1[_i];
        _addUnitContacts(structure, unit, features, builder, tester, props);
    }
}
function _addUnitContacts(structure, unit, features, builder, tester, props) {
    var x = features.x, y = features.y, z = features.z;
    var _a = features.subset(tester.requiredFeatures), lookup3d = _a.lookup3d, subsetIndices = _a.indices;
    var infoA = _features__WEBPACK_IMPORTED_MODULE_3__["Features"].Info(structure, unit, features);
    var infoB = Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, infoA);
    var distFactor = props.lineOfSightDistFactor;
    for (var t = 0, tl = _mol_data_int__WEBPACK_IMPORTED_MODULE_6__["OrderedSet"].size(subsetIndices); t < tl; ++t) {
        var i = _mol_data_int__WEBPACK_IMPORTED_MODULE_6__["OrderedSet"].getAt(subsetIndices, t);
        var _b = lookup3d.find(x[i], y[i], z[i], tester.maxDistance), count = _b.count, indices = _b.indices, squaredDistances = _b.squaredDistances;
        if (count === 0)
            continue;
        infoA.feature = i;
        for (var r = 0; r < count; ++r) {
            var j = _mol_data_int__WEBPACK_IMPORTED_MODULE_6__["OrderedSet"].getAt(subsetIndices, indices[r]);
            if (j <= i)
                continue;
            infoB.feature = j;
            if (!validPair(structure, infoA, infoB))
                continue;
            var type = tester.getType(structure, infoA, infoB, squaredDistances[r]);
            if (type && checkLineOfSight(structure, infoA, infoB, distFactor)) {
                builder.add(i, j, type);
            }
        }
    }
}
var _imageTransform = Object(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_4__["Mat4"])();
/**
 * Add all inter-unit contacts, i.e. pairs of features
 */
function addStructureContacts(structure, unitA, featuresA, unitB, featuresB, builder, testers, props) {
    var countA = featuresA.count, xA = featuresA.x, yA = featuresA.y, zA = featuresA.z;
    var lookup3d = featuresB.lookup3d;
    // the lookup queries need to happen in the "unitB space".
    // that means imageA = inverseOperB(operA(i))
    var imageTransform = _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_4__["Mat4"].mul(_imageTransform, unitB.conformation.operator.inverse, unitA.conformation.operator.matrix);
    var isNotIdentity = !_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_4__["Mat4"].isIdentity(imageTransform);
    var imageA = Object(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_4__["Vec3"])();
    var maxDistance = Math.max.apply(Math, testers.map(function (t) { return t.maxDistance; }));
    var _a = lookup3d.boundary.sphere, center = _a.center, radius = _a.radius;
    var testDistanceSq = (radius + maxDistance) * (radius + maxDistance);
    var distFactor = props.lineOfSightDistFactor;
    var infoA = _features__WEBPACK_IMPORTED_MODULE_3__["Features"].Info(structure, unitA, featuresA);
    var infoB = _features__WEBPACK_IMPORTED_MODULE_3__["Features"].Info(structure, unitB, featuresB);
    builder.startUnitPair(unitA, unitB);
    for (var i = 0; i < countA; ++i) {
        _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_4__["Vec3"].set(imageA, xA[i], yA[i], zA[i]);
        if (isNotIdentity)
            _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_4__["Vec3"].transformMat4(imageA, imageA, imageTransform);
        if (_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_4__["Vec3"].squaredDistance(imageA, center) > testDistanceSq)
            continue;
        var _b = lookup3d.find(imageA[0], imageA[1], imageA[2], maxDistance), indices = _b.indices, count = _b.count, squaredDistances = _b.squaredDistances;
        if (count === 0)
            continue;
        infoA.feature = i;
        for (var r = 0; r < count; ++r) {
            var j = indices[r];
            infoB.feature = j;
            if (!validPair(structure, infoA, infoB))
                continue;
            var distanceSq = squaredDistances[r];
            for (var _i = 0, testers_2 = testers; _i < testers_2.length; _i++) {
                var tester = testers_2[_i];
                if (distanceSq < tester.maxDistance * tester.maxDistance) {
                    var type = tester.getType(structure, infoA, infoB, distanceSq);
                    if (type && checkLineOfSight(structure, infoA, infoB, distFactor)) {
                        builder.add(i, j, type);
                        break;
                    }
                }
            }
        }
    }
    builder.finishUnitPair();
}
//# sourceMappingURL=contacts.js.map

/***/ }),

/***/ "./lib/mol-model-props/computed/interactions/features.js":
/*!***************************************************************!*\
  !*** ./lib/mol-model-props/computed/interactions/features.js ***!
  \***************************************************************/
/*! exports provided: Features, FeaturesBuilder */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Features", function() { return Features; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FeaturesBuilder", function() { return FeaturesBuilder; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _mol_data_util__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../../mol-data/util */ "./lib/mol-data/util.js");
/* harmony import */ var _mol_math_geometry__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../../mol-math/geometry */ "./lib/mol-math/geometry.js");
/* harmony import */ var _mol_data_int__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../../mol-data/int */ "./lib/mol-data/int.js");
/* harmony import */ var _valence_model__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../valence-model */ "./lib/mol-model-props/computed/valence-model.js");
/* harmony import */ var _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../../mol-math/linear-algebra */ "./lib/mol-math/linear-algebra.js");
/* harmony import */ var _mol_math_geometry_boundary__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../../../mol-math/geometry/boundary */ "./lib/mol-math/geometry/boundary.js");
/**
 * Copyright (c) 2019-2020 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */








var Features;
(function (Features) {
    function setPosition(out, unit, index, features) {
        _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_5__["Vec3"].set(out, features.x[index], features.y[index], features.z[index]);
        _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_5__["Vec3"].transformMat4(out, out, unit.conformation.operator.matrix);
        return out;
    }
    Features.setPosition = setPosition;
    function createElementsIndex(data, elementsCount) {
        var offsets = new Int32Array(elementsCount + 1);
        var bucketFill = new Int32Array(elementsCount);
        var bucketSizes = new Int32Array(elementsCount);
        var members = data.members, count = data.count, featureOffsets = data.offsets;
        for (var i = 0, il = featureOffsets[count]; i < il; ++i)
            ++bucketSizes[members[i]];
        var offset = 0;
        for (var i = 0; i < elementsCount; i++) {
            offsets[i] = offset;
            offset += bucketSizes[i];
        }
        offsets[elementsCount] = offset;
        var indices = new Int32Array(offset);
        for (var i = 0; i < count; ++i) {
            for (var j = featureOffsets[i], jl = featureOffsets[i + 1]; j < jl; ++j) {
                var a = members[j];
                var oa = offsets[a] + bucketFill[a];
                indices[oa] = i;
                ++bucketFill[a];
            }
        }
        return { indices: indices, offsets: offsets };
    }
    Features.createElementsIndex = createElementsIndex;
    function create(elementsCount, data) {
        var lookup3d;
        var elementsIndex;
        return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, data), { get lookup3d() {
                if (!lookup3d) {
                    var position_1 = { x: data.x, y: data.y, z: data.z, indices: _mol_data_int__WEBPACK_IMPORTED_MODULE_3__["OrderedSet"].ofBounds(0, data.count) };
                    lookup3d = Object(_mol_math_geometry__WEBPACK_IMPORTED_MODULE_2__["GridLookup3D"])(position_1, Object(_mol_math_geometry_boundary__WEBPACK_IMPORTED_MODULE_6__["getBoundary"])(position_1));
                }
                return lookup3d;
            }, get elementsIndex() {
                return elementsIndex || (elementsIndex = createElementsIndex(data, elementsCount));
            }, subset: function (types) { return createSubset(data, types); } });
    }
    Features.create = create;
    function createSubset(data, types) {
        var lookup3d;
        var count = data.count, _types = data.types;
        var _indices = [];
        for (var i = 0; i < count; ++i) {
            if (types.has(_types[i]))
                _indices.push(i);
        }
        var indices = _mol_data_int__WEBPACK_IMPORTED_MODULE_3__["SortedArray"].ofSortedArray(_indices);
        return {
            indices: indices,
            get lookup3d() {
                if (!lookup3d) {
                    var position_2 = { x: data.x, y: data.y, z: data.z, indices: indices };
                    lookup3d = Object(_mol_math_geometry__WEBPACK_IMPORTED_MODULE_2__["GridLookup3D"])(position_2, Object(_mol_math_geometry_boundary__WEBPACK_IMPORTED_MODULE_6__["getBoundary"])(position_2));
                }
                return lookup3d;
            }
        };
    }
    Features.createSubset = createSubset;
    function Info(structure, unit, features) {
        var valenceModel = _valence_model__WEBPACK_IMPORTED_MODULE_4__["ValenceModelProvider"].get(structure).value;
        if (!valenceModel || !valenceModel.has(unit.id))
            throw new Error('valence model required');
        return {
            unit: unit,
            types: features.types,
            feature: -1,
            x: features.x,
            y: features.y,
            z: features.z,
            members: features.members,
            offsets: features.offsets,
            idealGeometry: valenceModel.get(unit.id).idealGeometry
        };
    }
    Features.Info = Info;
    function position(out, info) {
        _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_5__["Vec3"].set(out, info.x[info.feature], info.y[info.feature], info.z[info.feature]);
        _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_5__["Vec3"].transformMat4(out, out, info.unit.conformation.operator.matrix);
        return out;
    }
    Features.position = position;
    var tmpVecA = Object(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_5__["Vec3"])();
    var tmpVecB = Object(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_5__["Vec3"])();
    function distance(infoA, infoB) {
        var elementA = infoA.members[infoA.offsets[infoA.feature]];
        var elementB = infoB.members[infoB.offsets[infoB.feature]];
        infoA.unit.conformation.position(infoA.unit.elements[elementA], tmpVecA);
        infoB.unit.conformation.position(infoB.unit.elements[elementB], tmpVecB);
        return _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_5__["Vec3"].distance(tmpVecA, tmpVecB);
    }
    Features.distance = distance;
    function Provider(types, add) {
        return { types: new Set(types), add: add };
    }
    Features.Provider = Provider;
})(Features || (Features = {}));

var FeaturesBuilder;
(function (FeaturesBuilder) {
    function create(initialCount, chunkSize, features) {
        if (initialCount === void 0) { initialCount = 2048; }
        if (chunkSize === void 0) { chunkSize = 1024; }
        var xCenters = _mol_data_util__WEBPACK_IMPORTED_MODULE_1__["ChunkedArray"].create(Float32Array, 1, chunkSize, features ? features.x : initialCount);
        var yCenters = _mol_data_util__WEBPACK_IMPORTED_MODULE_1__["ChunkedArray"].create(Float32Array, 1, chunkSize, features ? features.y : initialCount);
        var zCenters = _mol_data_util__WEBPACK_IMPORTED_MODULE_1__["ChunkedArray"].create(Float32Array, 1, chunkSize, features ? features.z : initialCount);
        var types = _mol_data_util__WEBPACK_IMPORTED_MODULE_1__["ChunkedArray"].create(Uint8Array, 1, chunkSize, features ? features.types : initialCount);
        var groups = _mol_data_util__WEBPACK_IMPORTED_MODULE_1__["ChunkedArray"].create(Uint8Array, 1, chunkSize, features ? features.groups : initialCount);
        var offsets = _mol_data_util__WEBPACK_IMPORTED_MODULE_1__["ChunkedArray"].create(Uint32Array, 1, chunkSize, features ? features.offsets : initialCount);
        var members = _mol_data_util__WEBPACK_IMPORTED_MODULE_1__["ChunkedArray"].create(Uint32Array, 1, chunkSize, features ? features.members : initialCount);
        var state = { x: 0, y: 0, z: 0, offset: 0, count: 0 };
        return {
            startState: function () {
                state.x = 0;
                state.y = 0;
                state.z = 0;
                state.offset = members.elementCount;
                state.count = 0;
            },
            pushMember: function (x, y, z, member) {
                _mol_data_util__WEBPACK_IMPORTED_MODULE_1__["ChunkedArray"].add(members, member);
                state.x += x;
                state.y += y;
                state.z += z;
                state.count += 1;
            },
            finishState: function (type, group) {
                var count = state.count;
                if (count === 0)
                    return;
                _mol_data_util__WEBPACK_IMPORTED_MODULE_1__["ChunkedArray"].add(types, type);
                _mol_data_util__WEBPACK_IMPORTED_MODULE_1__["ChunkedArray"].add(groups, group);
                _mol_data_util__WEBPACK_IMPORTED_MODULE_1__["ChunkedArray"].add(xCenters, state.x / count);
                _mol_data_util__WEBPACK_IMPORTED_MODULE_1__["ChunkedArray"].add(yCenters, state.y / count);
                _mol_data_util__WEBPACK_IMPORTED_MODULE_1__["ChunkedArray"].add(zCenters, state.z / count);
                _mol_data_util__WEBPACK_IMPORTED_MODULE_1__["ChunkedArray"].add(offsets, state.offset);
            },
            add: function (type, group, x, y, z, member) {
                _mol_data_util__WEBPACK_IMPORTED_MODULE_1__["ChunkedArray"].add(types, type);
                _mol_data_util__WEBPACK_IMPORTED_MODULE_1__["ChunkedArray"].add(groups, group);
                _mol_data_util__WEBPACK_IMPORTED_MODULE_1__["ChunkedArray"].add(xCenters, x);
                _mol_data_util__WEBPACK_IMPORTED_MODULE_1__["ChunkedArray"].add(yCenters, y);
                _mol_data_util__WEBPACK_IMPORTED_MODULE_1__["ChunkedArray"].add(zCenters, z);
                _mol_data_util__WEBPACK_IMPORTED_MODULE_1__["ChunkedArray"].add(offsets, members.elementCount);
                _mol_data_util__WEBPACK_IMPORTED_MODULE_1__["ChunkedArray"].add(members, member);
            },
            getFeatures: function (elementsCount) {
                _mol_data_util__WEBPACK_IMPORTED_MODULE_1__["ChunkedArray"].add(offsets, members.elementCount);
                var x = _mol_data_util__WEBPACK_IMPORTED_MODULE_1__["ChunkedArray"].compact(xCenters, true);
                var y = _mol_data_util__WEBPACK_IMPORTED_MODULE_1__["ChunkedArray"].compact(yCenters, true);
                var z = _mol_data_util__WEBPACK_IMPORTED_MODULE_1__["ChunkedArray"].compact(zCenters, true);
                var count = xCenters.elementCount;
                return Features.create(elementsCount, {
                    x: x, y: y, z: z, count: count,
                    types: _mol_data_util__WEBPACK_IMPORTED_MODULE_1__["ChunkedArray"].compact(types, true),
                    groups: _mol_data_util__WEBPACK_IMPORTED_MODULE_1__["ChunkedArray"].compact(groups, true),
                    offsets: _mol_data_util__WEBPACK_IMPORTED_MODULE_1__["ChunkedArray"].compact(offsets, true),
                    members: _mol_data_util__WEBPACK_IMPORTED_MODULE_1__["ChunkedArray"].compact(members, true),
                });
            }
        };
    }
    FeaturesBuilder.create = create;
})(FeaturesBuilder || (FeaturesBuilder = {}));
//# sourceMappingURL=features.js.map

/***/ }),

/***/ "./lib/mol-model-props/computed/interactions/halogen-bonds.js":
/*!********************************************************************!*\
  !*** ./lib/mol-model-props/computed/interactions/halogen-bonds.js ***!
  \********************************************************************/
/*! exports provided: HalogenDonorProvider, HalogenAcceptorProvider, HalogenBondsProvider */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "HalogenDonorProvider", function() { return HalogenDonorProvider; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "HalogenAcceptorProvider", function() { return HalogenAcceptorProvider; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "HalogenBondsProvider", function() { return HalogenBondsProvider; });
/* harmony import */ var _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../../mol-util/param-definition */ "./lib/mol-util/param-definition.js");
/* harmony import */ var _chemistry_geometry__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../chemistry/geometry */ "./lib/mol-model-props/computed/chemistry/geometry.js");
/* harmony import */ var _features__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./features */ "./lib/mol-model-props/computed/interactions/features.js");
/* harmony import */ var _chemistry_util__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../chemistry/util */ "./lib/mol-model-props/computed/chemistry/util.js");
/* harmony import */ var _mol_math_misc__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../../mol-math/misc */ "./lib/mol-math/misc.js");
/**
 * Copyright (c) 2019 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 * @author Fred Ludlow <Fred.Ludlow@astx.com>
 *
 * based in part on NGL (https://github.com/arose/ngl)
 */





var HalogenBondsParams = {
    distanceMax: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_0__["ParamDefinition"].Numeric(4.0, { min: 1, max: 5, step: 0.1 }),
    angleMax: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_0__["ParamDefinition"].Numeric(30, { min: 0, max: 60, step: 1 }),
};
var halBondElements = ["CL" /* CL */, "BR" /* BR */, "I" /* I */, "AT" /* AT */];
/**
 * Halogen bond donors (X-C, with X one of Cl, Br, I or At) not F!
 */
function addUnitHalogenDonors(structure, unit, builder) {
    var elements = unit.elements;
    var _a = unit.model.atomicConformation, x = _a.x, y = _a.y, z = _a.z;
    for (var i = 0, il = elements.length; i < il; ++i) {
        var element = Object(_chemistry_util__WEBPACK_IMPORTED_MODULE_3__["typeSymbol"])(unit, i);
        if (halBondElements.includes(element)) {
            builder.add(6 /* HalogenDonor */, 0 /* None */, x[elements[i]], y[elements[i]], z[elements[i]], i);
        }
    }
}
var X = ["N" /* N */, "O" /* O */, "S" /* S */];
var Y = ["C" /* C */, "N" /* N */, "P" /* P */, "S" /* S */];
/**
 * Halogen bond acceptors (Y-{O|N|S}, with Y=C,P,N,S)
 */
function addUnitHalogenAcceptors(structure, unit, builder) {
    var elements = unit.elements;
    var _a = unit.model.atomicConformation, x = _a.x, y = _a.y, z = _a.z;
    var _loop_1 = function (i, il) {
        var element = Object(_chemistry_util__WEBPACK_IMPORTED_MODULE_3__["typeSymbol"])(unit, i);
        if (X.includes(element)) {
            var flag_1 = false;
            Object(_chemistry_util__WEBPACK_IMPORTED_MODULE_3__["eachBondedAtom"])(structure, unit, i, function (unitB, indexB) {
                if (Y.includes(Object(_chemistry_util__WEBPACK_IMPORTED_MODULE_3__["typeSymbol"])(unitB, indexB))) {
                    flag_1 = true;
                }
            });
            if (flag_1) {
                builder.add(7 /* HalogenAcceptor */, 0 /* None */, x[elements[i]], y[elements[i]], z[elements[i]], i);
            }
        }
    };
    for (var i = 0, il = elements.length; i < il; ++i) {
        _loop_1(i, il);
    }
}
function isHalogenBond(ti, tj) {
    return ((ti === 7 /* HalogenAcceptor */ && tj === 6 /* HalogenDonor */) ||
        (ti === 6 /* HalogenDonor */ && tj === 7 /* HalogenAcceptor */));
}
// http://www.pnas.org/content/101/48/16789.full
var OptimalHalogenAngle = Object(_mol_math_misc__WEBPACK_IMPORTED_MODULE_4__["degToRad"])(180); // adjusted from 165 to account for spherical statistics
var OptimalAcceptorAngle = Object(_mol_math_misc__WEBPACK_IMPORTED_MODULE_4__["degToRad"])(120);
function getOptions(props) {
    return {
        angleMax: Object(_mol_math_misc__WEBPACK_IMPORTED_MODULE_4__["degToRad"])(props.angleMax),
    };
}
function testHalogenBond(structure, infoA, infoB, opts) {
    var typeA = infoA.types[infoA.feature];
    var typeB = infoB.types[infoB.feature];
    if (!isHalogenBond(typeA, typeB))
        return;
    var _a = typeA === 6 /* HalogenDonor */ ? [infoA, infoB] : [infoB, infoA], don = _a[0], acc = _a[1];
    var donIndex = don.members[don.offsets[don.feature]];
    var accIndex = acc.members[acc.offsets[acc.feature]];
    var halogenAngles = Object(_chemistry_geometry__WEBPACK_IMPORTED_MODULE_1__["calcAngles"])(structure, don.unit, donIndex, acc.unit, accIndex);
    // Singly bonded halogen only (not bromide ion for example)
    if (halogenAngles.length !== 1)
        return;
    if (OptimalHalogenAngle - halogenAngles[0] > opts.angleMax)
        return;
    var acceptorAngles = Object(_chemistry_geometry__WEBPACK_IMPORTED_MODULE_1__["calcAngles"])(structure, acc.unit, accIndex, don.unit, donIndex);
    // Angle must be defined. Excludes water as acceptor. Debatable
    if (acceptorAngles.length === 0)
        return;
    if (acceptorAngles.some(function (acceptorAngle) { return OptimalAcceptorAngle - acceptorAngle > opts.angleMax; }))
        return;
    return 5 /* HalogenBond */;
}
//
var HalogenDonorProvider = _features__WEBPACK_IMPORTED_MODULE_2__["Features"].Provider([6 /* HalogenDonor */], addUnitHalogenDonors);
var HalogenAcceptorProvider = _features__WEBPACK_IMPORTED_MODULE_2__["Features"].Provider([7 /* HalogenAcceptor */], addUnitHalogenAcceptors);
var HalogenBondsProvider = {
    name: 'halogen-bonds',
    params: HalogenBondsParams,
    createTester: function (props) {
        var opts = getOptions(props);
        return {
            maxDistance: props.distanceMax,
            requiredFeatures: new Set([6 /* HalogenDonor */, 7 /* HalogenAcceptor */]),
            getType: function (structure, infoA, infoB) { return testHalogenBond(structure, infoA, infoB, opts); }
        };
    }
};
//# sourceMappingURL=halogen-bonds.js.map

/***/ }),

/***/ "./lib/mol-model-props/computed/interactions/hydrogen-bonds.js":
/*!*********************************************************************!*\
  !*** ./lib/mol-model-props/computed/interactions/hydrogen-bonds.js ***!
  \*********************************************************************/
/*! exports provided: HydrogenDonorProvider, WeakHydrogenDonorProvider, HydrogenAcceptorProvider, HydrogenBondsProvider, WeakHydrogenBondsProvider */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "HydrogenDonorProvider", function() { return HydrogenDonorProvider; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "WeakHydrogenDonorProvider", function() { return WeakHydrogenDonorProvider; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "HydrogenAcceptorProvider", function() { return HydrogenAcceptorProvider; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "HydrogenBondsProvider", function() { return HydrogenBondsProvider; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "WeakHydrogenBondsProvider", function() { return WeakHydrogenBondsProvider; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../../mol-util/param-definition */ "./lib/mol-util/param-definition.js");
/* harmony import */ var _chemistry_geometry__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../chemistry/geometry */ "./lib/mol-model-props/computed/chemistry/geometry.js");
/* harmony import */ var _features__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./features */ "./lib/mol-model-props/computed/interactions/features.js");
/* harmony import */ var _chemistry_util__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../chemistry/util */ "./lib/mol-model-props/computed/chemistry/util.js");
/* harmony import */ var _valence_model__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../valence-model */ "./lib/mol-model-props/computed/valence-model.js");
/* harmony import */ var _mol_math_misc__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../../../mol-math/misc */ "./lib/mol-math/misc.js");
/* harmony import */ var _mol_model_structure_model_types__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../../../mol-model/structure/model/types */ "./lib/mol-model/structure/model/types.js");
/**
 * Copyright (c) 2019-2020 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 * @author Fred Ludlow <Fred.Ludlow@astx.com>
 *
 * based in part on NGL (https://github.com/arose/ngl)
 */








var GeometryParams = {
    distanceMax: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_1__["ParamDefinition"].Numeric(3.5, { min: 1, max: 5, step: 0.1 }),
    backbone: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_1__["ParamDefinition"].Boolean(true, { description: 'Include backbone-to-backbone hydrogen bonds' }),
    accAngleDevMax: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_1__["ParamDefinition"].Numeric(45, { min: 0, max: 180, step: 1 }, { description: 'Max deviation from ideal acceptor angle' }),
    donAngleDevMax: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_1__["ParamDefinition"].Numeric(45, { min: 0, max: 180, step: 1 }, { description: 'Max deviation from ideal donor angle' }),
    accOutOfPlaneAngleMax: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_1__["ParamDefinition"].Numeric(90, { min: 0, max: 180, step: 1 }),
    donOutOfPlaneAngleMax: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_1__["ParamDefinition"].Numeric(45, { min: 0, max: 180, step: 1 }),
};
var HydrogenBondsParams = Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, GeometryParams), { water: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_1__["ParamDefinition"].Boolean(false, { description: 'Include water-to-water hydrogen bonds' }), sulfurDistanceMax: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_1__["ParamDefinition"].Numeric(4.1, { min: 1, max: 5, step: 0.1 }) });
var WeakHydrogenBondsParams = Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, GeometryParams);
//
// Geometric characteristics of hydrogen bonds involving sulfur atoms in proteins
// https://doi.org/10.1002/prot.22327
// Satisfying Hydrogen Bonding Potential in Proteins (HBPLUS)
// https://doi.org/10.1006/jmbi.1994.1334
// http://www.csb.yale.edu/userguides/datamanip/hbplus/hbplus_descrip.html
function getUnitValenceModel(structure, unit) {
    var valenceModel = _valence_model__WEBPACK_IMPORTED_MODULE_5__["ValenceModelProvider"].get(structure).value;
    if (!valenceModel)
        throw Error('expected valence model to be available');
    var unitValenceModel = valenceModel.get(unit.id);
    if (!unitValenceModel)
        throw Error('expected valence model for unit to be available');
    return unitValenceModel;
}
/**
 * Potential hydrogen donor
 */
function addUnitHydrogenDonors(structure, unit, builder) {
    var totalH = getUnitValenceModel(structure, unit).totalH;
    var elements = unit.elements;
    var _a = unit.model.atomicConformation, x = _a.x, y = _a.y, z = _a.z;
    var elementAromaticRingIndices = unit.rings.elementAromaticRingIndices;
    for (var i = 0, il = elements.length; i < il; ++i) {
        if (elementAromaticRingIndices.has(i))
            continue;
        var element = Object(_chemistry_util__WEBPACK_IMPORTED_MODULE_4__["typeSymbol"])(unit, i);
        if ((
        // include both nitrogen atoms in histidine due to
        // their often ambiguous protonation assignment
        isHistidineNitrogen(unit, i)) || (totalH[i] > 0 &&
            (element === "N" /* N */ || element === "O" /* O */ || element === "S" /* S */))) {
            builder.add(4 /* HydrogenDonor */, 0 /* None */, x[elements[i]], y[elements[i]], z[elements[i]], i);
        }
    }
}
/**
 * Weak hydrogen donor.
 */
function addUnitWeakHydrogenDonors(structure, unit, builder) {
    var totalH = getUnitValenceModel(structure, unit).totalH;
    var elements = unit.elements;
    var _a = unit.model.atomicConformation, x = _a.x, y = _a.y, z = _a.z;
    for (var i = 0, il = elements.length; i < il; ++i) {
        if (Object(_chemistry_util__WEBPACK_IMPORTED_MODULE_4__["typeSymbol"])(unit, i) === "C" /* C */ &&
            totalH[i] > 0 &&
            (Object(_chemistry_util__WEBPACK_IMPORTED_MODULE_4__["bondToElementCount"])(structure, unit, i, "N" /* N */) > 0 ||
                Object(_chemistry_util__WEBPACK_IMPORTED_MODULE_4__["bondToElementCount"])(structure, unit, i, "O" /* O */) > 0 ||
                inAromaticRingWithElectronNegativeElement(unit, i))) {
            builder.add(9 /* WeakHydrogenDonor */, 0 /* None */, x[elements[i]], y[elements[i]], z[elements[i]], i);
        }
    }
}
function inAromaticRingWithElectronNegativeElement(unit, index) {
    var _a = unit.rings, elementAromaticRingIndices = _a.elementAromaticRingIndices, all = _a.all;
    var ringIndices = elementAromaticRingIndices.get(index);
    if (ringIndices === undefined)
        return false;
    for (var i = 0, il = ringIndices.length; i < il; ++i) {
        var ring = all[ringIndices[i]];
        for (var j = 0, jl = ring.length; j < jl; ++j) {
            var element = Object(_chemistry_util__WEBPACK_IMPORTED_MODULE_4__["typeSymbol"])(unit, ring[j]);
            if (element === "N" /* N */ || element === "O" /* O */) {
                return true;
            }
        }
    }
    return false;
}
/**
 * Potential hydrogen acceptor
 */
function addUnitHydrogenAcceptors(structure, unit, builder) {
    var _a = getUnitValenceModel(structure, unit), charge = _a.charge, implicitH = _a.implicitH, idealGeometry = _a.idealGeometry;
    var elements = unit.elements;
    var _b = unit.model.atomicConformation, x = _b.x, y = _b.y, z = _b.z;
    var elementAromaticRingIndices = unit.rings.elementAromaticRingIndices;
    var add = function (i) {
        builder.add(5 /* HydrogenAcceptor */, 0 /* None */, x[elements[i]], y[elements[i]], z[elements[i]], i);
    };
    for (var i = 0, il = elements.length; i < il; ++i) {
        if (elementAromaticRingIndices.has(i))
            continue;
        var element = Object(_chemistry_util__WEBPACK_IMPORTED_MODULE_4__["typeSymbol"])(unit, i);
        if (element === "O" /* O */) {
            // Basically assume all oxygen atoms are acceptors!
            add(i);
        }
        else if (element === "N" /* N */) {
            if (isHistidineNitrogen(unit, i)) {
                // include both nitrogen atoms in histidine due to
                // their often ambiguous protonation assignment
                add(i);
            }
            else if (charge[i] < 1) {
                // Neutral nitrogen might be an acceptor
                // It must have at least one lone pair not conjugated
                var totalBonds = Object(_chemistry_util__WEBPACK_IMPORTED_MODULE_4__["bondCount"])(structure, unit, i) + implicitH[i];
                var ig = idealGeometry[i];
                if ((ig === 4 /* Tetrahedral */ && totalBonds < 4) ||
                    (ig === 3 /* Trigonal */ && totalBonds < 3) ||
                    (ig === 2 /* Linear */ && totalBonds < 2)) {
                    add(i);
                }
            }
        }
        else if (element === "S" /* S */) {
            var resname = Object(_chemistry_util__WEBPACK_IMPORTED_MODULE_4__["compId"])(unit, i);
            if (resname === 'CYS' || resname === 'MET' || Object(_chemistry_util__WEBPACK_IMPORTED_MODULE_4__["formalCharge"])(unit, i) === -1) {
                add(i);
            }
        }
    }
}
function isWater(unit, index) {
    return unit.model.atomicHierarchy.derived.residue.moleculeType[unit.residueIndex[unit.elements[index]]] === 2 /* Water */;
}
function isBackbone(unit, index) {
    return _mol_model_structure_model_types__WEBPACK_IMPORTED_MODULE_7__["ProteinBackboneAtoms"].has(Object(_chemistry_util__WEBPACK_IMPORTED_MODULE_4__["atomId"])(unit, index));
}
function isRing(unit, index) {
    return unit.rings.elementRingIndices.has(index);
}
function isHistidineNitrogen(unit, index) {
    return Object(_chemistry_util__WEBPACK_IMPORTED_MODULE_4__["compId"])(unit, index) === 'HIS' && Object(_chemistry_util__WEBPACK_IMPORTED_MODULE_4__["typeSymbol"])(unit, index) === "N" /* N */ && isRing(unit, index);
}
function isBackboneHydrogenBond(unitA, indexA, unitB, indexB) {
    return isBackbone(unitA, indexA) && isBackbone(unitB, indexB);
}
function isWaterHydrogenBond(unitA, indexA, unitB, indexB) {
    return isWater(unitA, indexA) && isWater(unitB, indexB);
}
function isHydrogenBond(ti, tj) {
    return ((ti === 5 /* HydrogenAcceptor */ && tj === 4 /* HydrogenDonor */) ||
        (ti === 4 /* HydrogenDonor */ && tj === 5 /* HydrogenAcceptor */));
}
function isWeakHydrogenBond(ti, tj) {
    return ((ti === 9 /* WeakHydrogenDonor */ && tj === 5 /* HydrogenAcceptor */) ||
        (ti === 5 /* HydrogenAcceptor */ && tj === 9 /* WeakHydrogenDonor */));
}
function getGeometryOptions(props) {
    return {
        includeBackbone: props.backbone,
        maxAccAngleDev: Object(_mol_math_misc__WEBPACK_IMPORTED_MODULE_6__["degToRad"])(props.accAngleDevMax),
        maxDonAngleDev: Object(_mol_math_misc__WEBPACK_IMPORTED_MODULE_6__["degToRad"])(props.donAngleDevMax),
        maxAccOutOfPlaneAngle: Object(_mol_math_misc__WEBPACK_IMPORTED_MODULE_6__["degToRad"])(props.accOutOfPlaneAngleMax),
        maxDonOutOfPlaneAngle: Object(_mol_math_misc__WEBPACK_IMPORTED_MODULE_6__["degToRad"])(props.donOutOfPlaneAngleMax),
    };
}
function getHydrogenBondsOptions(props) {
    return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, getGeometryOptions(props)), { includeWater: props.water, maxSulfurDistSq: props.sulfurDistanceMax * props.sulfurDistanceMax, maxDistSq: props.distanceMax * props.distanceMax });
}
var deg120InRad = Object(_mol_math_misc__WEBPACK_IMPORTED_MODULE_6__["degToRad"])(120);
function checkGeometry(structure, don, acc, opts) {
    var donIndex = don.members[don.offsets[don.feature]];
    var accIndex = acc.members[acc.offsets[acc.feature]];
    if (!opts.includeBackbone && isBackboneHydrogenBond(don.unit, donIndex, acc.unit, accIndex))
        return;
    var donAngles = Object(_chemistry_geometry__WEBPACK_IMPORTED_MODULE_2__["calcAngles"])(structure, don.unit, donIndex, acc.unit, accIndex);
    var idealDonAngle = _chemistry_geometry__WEBPACK_IMPORTED_MODULE_2__["AtomGeometryAngles"].get(don.idealGeometry[donIndex]) || deg120InRad;
    if (donAngles.some(function (donAngle) { return Math.abs(idealDonAngle - donAngle) > opts.maxDonAngleDev; }))
        return;
    if (don.idealGeometry[donIndex] === 3 /* Trigonal */) {
        var outOfPlane = Object(_chemistry_geometry__WEBPACK_IMPORTED_MODULE_2__["calcPlaneAngle"])(structure, don.unit, donIndex, acc.unit, accIndex);
        if (outOfPlane !== undefined && outOfPlane > opts.maxDonOutOfPlaneAngle)
            return;
    }
    var accAngles = Object(_chemistry_geometry__WEBPACK_IMPORTED_MODULE_2__["calcAngles"])(structure, acc.unit, accIndex, don.unit, donIndex);
    var idealAccAngle = _chemistry_geometry__WEBPACK_IMPORTED_MODULE_2__["AtomGeometryAngles"].get(acc.idealGeometry[accIndex]) || deg120InRad;
    // Do not limit large acceptor angles
    if (accAngles.some(function (accAngle) { return idealAccAngle - accAngle > opts.maxAccAngleDev; }))
        return;
    if (acc.idealGeometry[accIndex] === 3 /* Trigonal */) {
        var outOfPlane = Object(_chemistry_geometry__WEBPACK_IMPORTED_MODULE_2__["calcPlaneAngle"])(structure, acc.unit, accIndex, don.unit, donIndex);
        if (outOfPlane !== undefined && outOfPlane > opts.maxAccOutOfPlaneAngle)
            return;
    }
    return true;
}
function testHydrogenBond(structure, infoA, infoB, distanceSq, opts) {
    var typeA = infoA.types[infoA.feature];
    var typeB = infoB.types[infoB.feature];
    if (!isHydrogenBond(typeA, typeB))
        return;
    var _a = typeB === 5 /* HydrogenAcceptor */ ? [infoA, infoB] : [infoB, infoA], don = _a[0], acc = _a[1];
    var donIndex = don.members[don.offsets[don.feature]];
    var accIndex = acc.members[acc.offsets[acc.feature]];
    // check if distance is ok depending on non-sulfur-containing hbond
    var maxDistSq = Object(_chemistry_util__WEBPACK_IMPORTED_MODULE_4__["typeSymbol"])(don.unit, donIndex) === "S" /* S */ || Object(_chemistry_util__WEBPACK_IMPORTED_MODULE_4__["typeSymbol"])(acc.unit, accIndex) === "S" /* S */ ? opts.maxSulfurDistSq : opts.maxDistSq;
    if (distanceSq > maxDistSq)
        return;
    if (!opts.includeWater && isWaterHydrogenBond(don.unit, donIndex, acc.unit, accIndex))
        return;
    if (!checkGeometry(structure, don, acc, opts))
        return;
    return 4 /* HydrogenBond */;
}
function testWeakHydrogenBond(structure, infoA, infoB, distanceSq, opts) {
    var typeA = infoA.types[infoA.feature];
    var typeB = infoB.types[infoB.feature];
    if (!isWeakHydrogenBond(typeA, typeB))
        return;
    var _a = typeB === 5 /* HydrogenAcceptor */ ? [infoA, infoB] : [infoB, infoA], don = _a[0], acc = _a[1];
    if (!checkGeometry(structure, don, acc, opts))
        return;
    return 8 /* WeakHydrogenBond */;
}
//
var HydrogenDonorProvider = _features__WEBPACK_IMPORTED_MODULE_3__["Features"].Provider([4 /* HydrogenDonor */], addUnitHydrogenDonors);
var WeakHydrogenDonorProvider = _features__WEBPACK_IMPORTED_MODULE_3__["Features"].Provider([9 /* WeakHydrogenDonor */], addUnitWeakHydrogenDonors);
var HydrogenAcceptorProvider = _features__WEBPACK_IMPORTED_MODULE_3__["Features"].Provider([5 /* HydrogenAcceptor */], addUnitHydrogenAcceptors);
var HydrogenBondsProvider = {
    name: 'hydrogen-bonds',
    params: HydrogenBondsParams,
    createTester: function (props) {
        var maxDistance = Math.max(props.distanceMax, props.sulfurDistanceMax);
        var opts = getHydrogenBondsOptions(props);
        return {
            maxDistance: maxDistance,
            requiredFeatures: new Set([4 /* HydrogenDonor */, 5 /* HydrogenAcceptor */]),
            getType: function (structure, infoA, infoB, distanceSq) { return testHydrogenBond(structure, infoA, infoB, distanceSq, opts); }
        };
    }
};
var WeakHydrogenBondsProvider = {
    name: 'weak-hydrogen-bonds',
    params: WeakHydrogenBondsParams,
    createTester: function (props) {
        var opts = getGeometryOptions(props);
        return {
            maxDistance: props.distanceMax,
            requiredFeatures: new Set([9 /* WeakHydrogenDonor */, 5 /* HydrogenAcceptor */]),
            getType: function (structure, infoA, infoB, distanceSq) { return testWeakHydrogenBond(structure, infoA, infoB, distanceSq, opts); }
        };
    }
};
//# sourceMappingURL=hydrogen-bonds.js.map

/***/ }),

/***/ "./lib/mol-model-props/computed/interactions/hydrophobic.js":
/*!******************************************************************!*\
  !*** ./lib/mol-model-props/computed/interactions/hydrophobic.js ***!
  \******************************************************************/
/*! exports provided: HydrophobicAtomProvider, HydrophobicProvider */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "HydrophobicAtomProvider", function() { return HydrophobicAtomProvider; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "HydrophobicProvider", function() { return HydrophobicProvider; });
/* harmony import */ var _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../../mol-util/param-definition */ "./lib/mol-util/param-definition.js");
/* harmony import */ var _features__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./features */ "./lib/mol-model-props/computed/interactions/features.js");
/* harmony import */ var _chemistry_util__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../chemistry/util */ "./lib/mol-model-props/computed/chemistry/util.js");
/**
 * Copyright (c) 2019 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 * @author Fred Ludlow <Fred.Ludlow@astx.com>
 *
 * based in part on NGL (https://github.com/arose/ngl)
 */



var HydrophobicParams = {
    distanceMax: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_0__["ParamDefinition"].Numeric(4.0, { min: 1, max: 5, step: 0.1 }),
};
/**
 * Hydropbobic atoms
 * - Carbon only bonded to carbon or hydrogen
 * - Fluorine
 */
function addHydrophobicAtom(structure, unit, builder) {
    var elements = unit.elements;
    var _a = unit.model.atomicConformation, x = _a.x, y = _a.y, z = _a.z;
    var _loop_1 = function (i, il) {
        var element = Object(_chemistry_util__WEBPACK_IMPORTED_MODULE_2__["typeSymbol"])(unit, i);
        var flag = false;
        if (element === "C" /* C */) {
            flag = true;
            Object(_chemistry_util__WEBPACK_IMPORTED_MODULE_2__["eachBondedAtom"])(structure, unit, i, function (unitB, indexB) {
                var elementB = Object(_chemistry_util__WEBPACK_IMPORTED_MODULE_2__["typeSymbol"])(unitB, indexB);
                if (elementB !== "C" /* C */ && elementB !== "H" /* H */)
                    flag = false;
            });
        }
        else if (element === "F" /* F */) {
            flag = true;
        }
        if (flag) {
            builder.add(8 /* HydrophobicAtom */, 0 /* None */, x[elements[i]], y[elements[i]], z[elements[i]], i);
        }
    };
    for (var i = 0, il = elements.length; i < il; ++i) {
        _loop_1(i, il);
    }
}
function isHydrophobicContact(ti, tj) {
    return ti === 8 /* HydrophobicAtom */ && tj === 8 /* HydrophobicAtom */;
}
function testHydrophobic(structure, infoA, infoB, distanceSq) {
    var typeA = infoA.types[infoA.feature];
    var typeB = infoB.types[infoB.feature];
    if (!isHydrophobicContact(typeA, typeB))
        return;
    var indexA = infoA.members[infoA.offsets[infoA.feature]];
    var indexB = infoB.members[infoB.offsets[infoB.feature]];
    if (Object(_chemistry_util__WEBPACK_IMPORTED_MODULE_2__["typeSymbol"])(infoA.unit, indexA) === "F" /* F */ && Object(_chemistry_util__WEBPACK_IMPORTED_MODULE_2__["typeSymbol"])(infoB.unit, indexB) === "F" /* F */)
        return;
    return 6 /* Hydrophobic */;
}
//
var HydrophobicAtomProvider = _features__WEBPACK_IMPORTED_MODULE_1__["Features"].Provider([8 /* HydrophobicAtom */], addHydrophobicAtom);
var HydrophobicProvider = {
    name: 'hydrophobic',
    params: HydrophobicParams,
    createTester: function (props) {
        return {
            maxDistance: props.distanceMax,
            requiredFeatures: new Set([8 /* HydrophobicAtom */]),
            getType: function (structure, infoA, infoB, distanceSq) { return testHydrophobic(structure, infoA, infoB, distanceSq); }
        };
    }
};
//# sourceMappingURL=hydrophobic.js.map

/***/ }),

/***/ "./lib/mol-model-props/computed/interactions/interactions.js":
/*!*******************************************************************!*\
  !*** ./lib/mol-model-props/computed/interactions/interactions.js ***!
  \*******************************************************************/
/*! exports provided: Interactions, ContactProviderParams, InteractionsParams, computeInteractions */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Interactions", function() { return Interactions; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ContactProviderParams", function() { return ContactProviderParams; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "InteractionsParams", function() { return InteractionsParams; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "computeInteractions", function() { return computeInteractions; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../../mol-util/param-definition */ "./lib/mol-util/param-definition.js");
/* harmony import */ var _mol_model_structure__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../../mol-model/structure */ "./lib/mol-model/structure.js");
/* harmony import */ var _features__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./features */ "./lib/mol-model-props/computed/interactions/features.js");
/* harmony import */ var _valence_model__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../valence-model */ "./lib/mol-model-props/computed/valence-model.js");
/* harmony import */ var _common__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./common */ "./lib/mol-model-props/computed/interactions/common.js");
/* harmony import */ var _contacts_builder__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ./contacts-builder */ "./lib/mol-model-props/computed/interactions/contacts-builder.js");
/* harmony import */ var _mol_data_int__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../../../mol-data/int */ "./lib/mol-data/int.js");
/* harmony import */ var _contacts__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ./contacts */ "./lib/mol-model-props/computed/interactions/contacts.js");
/* harmony import */ var _halogen_bonds__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ./halogen-bonds */ "./lib/mol-model-props/computed/interactions/halogen-bonds.js");
/* harmony import */ var _hydrogen_bonds__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ./hydrogen-bonds */ "./lib/mol-model-props/computed/interactions/hydrogen-bonds.js");
/* harmony import */ var _charged__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ./charged */ "./lib/mol-model-props/computed/interactions/charged.js");
/* harmony import */ var _hydrophobic__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! ./hydrophobic */ "./lib/mol-model-props/computed/interactions/hydrophobic.js");
/* harmony import */ var _mol_util_set__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! ../../../mol-util/set */ "./lib/mol-util/set.js");
/* harmony import */ var _metal__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! ./metal */ "./lib/mol-model-props/computed/interactions/metal.js");
/* harmony import */ var _refine__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! ./refine */ "./lib/mol-model-props/computed/interactions/refine.js");
/* harmony import */ var _mol_model_location__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(/*! ../../../mol-model/location */ "./lib/mol-model/location.js");
/* harmony import */ var _mol_math_geometry_centroid_helper__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(/*! ../../../mol-math/geometry/centroid-helper */ "./lib/mol-math/geometry/centroid-helper.js");
/* harmony import */ var _mol_model_loci__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(/*! ../../../mol-model/loci */ "./lib/mol-model/loci.js");
/* harmony import */ var _mol_theme_label__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(/*! ../../../mol-theme/label */ "./lib/mol-theme/label.js");
/* harmony import */ var _mol_util_type_helpers__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(/*! ../../../mol-util/type-helpers */ "./lib/mol-util/type-helpers.js");
/**
 * Copyright (c) 2019-2020 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */






















var Interactions;
(function (Interactions) {
    function Location(interactions, structure, unitA, indexA, unitB, indexB) {
        return Object(_mol_model_location__WEBPACK_IMPORTED_MODULE_16__["DataLocation"])('interactions', { structure: structure, interactions: interactions }, { unitA: unitA, indexA: indexA, unitB: unitB, indexB: indexB });
    }
    Interactions.Location = Location;
    function isLocation(x) {
        return !!x && x.kind === 'data-location' && x.tag === 'interactions';
    }
    Interactions.isLocation = isLocation;
    function areLocationsEqual(locA, locB) {
        return (locA.data.structure === locB.data.structure &&
            locA.data.interactions === locB.data.interactions &&
            locA.element.indexA === locB.element.indexA &&
            locA.element.indexB === locB.element.indexB &&
            locA.element.unitA === locB.element.unitA &&
            locA.element.unitB === locB.element.unitB);
    }
    Interactions.areLocationsEqual = areLocationsEqual;
    function _label(interactions, element) {
        var unitA = element.unitA, indexA = element.indexA, unitB = element.unitB, indexB = element.indexB;
        var contacts = interactions.contacts, unitsContacts = interactions.unitsContacts;
        if (unitA === unitB) {
            var contacts_1 = unitsContacts.get(unitA.id);
            var idx = contacts_1.getDirectedEdgeIndex(indexA, indexB);
            return Object(_common__WEBPACK_IMPORTED_MODULE_5__["interactionTypeLabel"])(contacts_1.edgeProps.type[idx]);
        }
        else {
            var idx = contacts.getEdgeIndex(indexA, unitA.id, indexB, unitB.id);
            return Object(_common__WEBPACK_IMPORTED_MODULE_5__["interactionTypeLabel"])(contacts.edges[idx].props.type);
        }
    }
    function locationLabel(location) {
        return _label(location.data.interactions, location.element);
    }
    Interactions.locationLabel = locationLabel;
    function Loci(structure, interactions, elements) {
        return Object(_mol_model_loci__WEBPACK_IMPORTED_MODULE_18__["DataLoci"])('interactions', { structure: structure, interactions: interactions }, elements, function (boundingSphere) { return getBoundingSphere(interactions, elements, boundingSphere); }, function () { return getLabel(structure, interactions, elements); });
    }
    Interactions.Loci = Loci;
    function isLoci(x) {
        return !!x && x.kind === 'data-loci' && x.tag === 'interactions';
    }
    Interactions.isLoci = isLoci;
    function getBoundingSphere(interactions, elements, boundingSphere) {
        var unitsFeatures = interactions.unitsFeatures;
        return _mol_math_geometry_centroid_helper__WEBPACK_IMPORTED_MODULE_17__["CentroidHelper"].fromPairProvider(elements.length, function (i, pA, pB) {
            var e = elements[i];
            _features__WEBPACK_IMPORTED_MODULE_3__["Features"].setPosition(pA, e.unitA, e.indexA, unitsFeatures.get(e.unitA.id));
            _features__WEBPACK_IMPORTED_MODULE_3__["Features"].setPosition(pB, e.unitB, e.indexB, unitsFeatures.get(e.unitB.id));
        }, boundingSphere);
    }
    Interactions.getBoundingSphere = getBoundingSphere;
    function getLabel(structure, interactions, elements) {
        var element = elements[0];
        if (element === undefined)
            return '';
        var unitA = element.unitA, indexA = element.indexA, unitB = element.unitB, indexB = element.indexB;
        var unitsFeatures = interactions.unitsFeatures;
        var _a = unitsFeatures.get(unitA.id), mA = _a.members, oA = _a.offsets;
        var _b = unitsFeatures.get(unitB.id), mB = _b.members, oB = _b.offsets;
        var options = { granularity: 'element' };
        if (oA[indexA + 1] - oA[indexA] > 1 || oB[indexB + 1] - oB[indexB] > 1) {
            options.granularity = 'residue';
        }
        return [
            _label(interactions, element),
            Object(_mol_theme_label__WEBPACK_IMPORTED_MODULE_19__["bondLabel"])(_mol_model_structure__WEBPACK_IMPORTED_MODULE_2__["Bond"].Location(structure, unitA, mA[oA[indexA]], structure, unitB, mB[oB[indexB]]), options)
        ].join('</br>');
    }
    Interactions.getLabel = getLabel;
})(Interactions || (Interactions = {}));
var FeatureProviders = [
    _hydrogen_bonds__WEBPACK_IMPORTED_MODULE_10__["HydrogenDonorProvider"], _hydrogen_bonds__WEBPACK_IMPORTED_MODULE_10__["WeakHydrogenDonorProvider"], _hydrogen_bonds__WEBPACK_IMPORTED_MODULE_10__["HydrogenAcceptorProvider"],
    _charged__WEBPACK_IMPORTED_MODULE_11__["NegativChargeProvider"], _charged__WEBPACK_IMPORTED_MODULE_11__["PositiveChargeProvider"], _charged__WEBPACK_IMPORTED_MODULE_11__["AromaticRingProvider"],
    _halogen_bonds__WEBPACK_IMPORTED_MODULE_9__["HalogenDonorProvider"], _halogen_bonds__WEBPACK_IMPORTED_MODULE_9__["HalogenAcceptorProvider"],
    _hydrophobic__WEBPACK_IMPORTED_MODULE_12__["HydrophobicAtomProvider"],
    _metal__WEBPACK_IMPORTED_MODULE_14__["MetalProvider"], _metal__WEBPACK_IMPORTED_MODULE_14__["MetalBindingProvider"],
];
var ContactProviders = {
    'ionic': _charged__WEBPACK_IMPORTED_MODULE_11__["IonicProvider"],
    'pi-stacking': _charged__WEBPACK_IMPORTED_MODULE_11__["PiStackingProvider"],
    'cation-pi': _charged__WEBPACK_IMPORTED_MODULE_11__["CationPiProvider"],
    'halogen-bonds': _halogen_bonds__WEBPACK_IMPORTED_MODULE_9__["HalogenBondsProvider"],
    'hydrogen-bonds': _hydrogen_bonds__WEBPACK_IMPORTED_MODULE_10__["HydrogenBondsProvider"],
    'weak-hydrogen-bonds': _hydrogen_bonds__WEBPACK_IMPORTED_MODULE_10__["WeakHydrogenBondsProvider"],
    'hydrophobic': _hydrophobic__WEBPACK_IMPORTED_MODULE_12__["HydrophobicProvider"],
    'metal-coordination': _metal__WEBPACK_IMPORTED_MODULE_14__["MetalCoordinationProvider"],
};
function getProvidersParams(defaultOn) {
    if (defaultOn === void 0) { defaultOn = []; }
    var params = Object.create(null);
    Object.keys(ContactProviders).forEach(function (k) {
        params[k] = _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_1__["ParamDefinition"].MappedStatic(defaultOn.includes(k) ? 'on' : 'off', {
            on: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_1__["ParamDefinition"].Group(ContactProviders[k].params),
            off: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_1__["ParamDefinition"].Group({})
        }, { cycle: true });
    });
    return params;
}
var ContactProviderParams = getProvidersParams([
    // 'ionic',
    'cation-pi',
    'pi-stacking',
    'hydrogen-bonds',
    'halogen-bonds',
    // 'hydrophobic',
    'metal-coordination',
]);
var InteractionsParams = {
    providers: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_1__["ParamDefinition"].Group(ContactProviderParams, { isFlat: true }),
    contacts: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_1__["ParamDefinition"].Group(_contacts__WEBPACK_IMPORTED_MODULE_8__["ContactsParams"], { label: 'Advanced Options' }),
};
function computeInteractions(ctx, structure, props) {
    return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"])(this, void 0, void 0, function () {
        var p, contactTesters, requiredFeatures, featureProviders, unitsFeatures, unitsContacts, i, il, group, features, intraUnitContacts, j, jl, u, contacts, interactions;
        return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__generator"])(this, function (_a) {
            switch (_a.label) {
                case 0:
                    p = Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_1__["ParamDefinition"].getDefaultValues(InteractionsParams)), props);
                    return [4 /*yield*/, _valence_model__WEBPACK_IMPORTED_MODULE_4__["ValenceModelProvider"].attach(ctx, structure)];
                case 1:
                    _a.sent();
                    contactTesters = [];
                    Object(_mol_util_type_helpers__WEBPACK_IMPORTED_MODULE_20__["ObjectKeys"])(ContactProviders).forEach(function (k) {
                        var _a = p.providers[k], name = _a.name, params = _a.params;
                        if (name === 'on') {
                            contactTesters.push(ContactProviders[k].createTester(params));
                        }
                    });
                    requiredFeatures = new Set();
                    contactTesters.forEach(function (l) { return _mol_util_set__WEBPACK_IMPORTED_MODULE_13__["SetUtils"].add(requiredFeatures, l.requiredFeatures); });
                    featureProviders = FeatureProviders.filter(function (f) { return _mol_util_set__WEBPACK_IMPORTED_MODULE_13__["SetUtils"].areIntersecting(requiredFeatures, f.types); });
                    unitsFeatures = _mol_data_int__WEBPACK_IMPORTED_MODULE_7__["IntMap"].Mutable();
                    unitsContacts = _mol_data_int__WEBPACK_IMPORTED_MODULE_7__["IntMap"].Mutable();
                    i = 0, il = structure.unitSymmetryGroups.length;
                    _a.label = 2;
                case 2:
                    if (!(i < il)) return [3 /*break*/, 6];
                    group = structure.unitSymmetryGroups[i];
                    if (!ctx.runtime.shouldUpdate) return [3 /*break*/, 4];
                    return [4 /*yield*/, ctx.runtime.update({ message: 'computing interactions', current: i, max: il })];
                case 3:
                    _a.sent();
                    _a.label = 4;
                case 4:
                    features = findUnitFeatures(structure, group.units[0], featureProviders);
                    intraUnitContacts = findIntraUnitContacts(structure, group.units[0], features, contactTesters, p.contacts);
                    for (j = 0, jl = group.units.length; j < jl; ++j) {
                        u = group.units[j];
                        unitsFeatures.set(u.id, features);
                        unitsContacts.set(u.id, intraUnitContacts);
                    }
                    _a.label = 5;
                case 5:
                    ++i;
                    return [3 /*break*/, 2];
                case 6:
                    contacts = findInterUnitContacts(structure, unitsFeatures, contactTesters, p.contacts);
                    interactions = { unitsFeatures: unitsFeatures, unitsContacts: unitsContacts, contacts: contacts };
                    Object(_refine__WEBPACK_IMPORTED_MODULE_15__["refineInteractions"])(structure, interactions);
                    return [2 /*return*/, interactions];
            }
        });
    });
}
function findUnitFeatures(structure, unit, featureProviders) {
    var count = unit.elements.length;
    var featuresBuilder = _features__WEBPACK_IMPORTED_MODULE_3__["FeaturesBuilder"].create(count, count / 2);
    if (_mol_model_structure__WEBPACK_IMPORTED_MODULE_2__["Unit"].isAtomic(unit)) {
        for (var _i = 0, featureProviders_1 = featureProviders; _i < featureProviders_1.length; _i++) {
            var fp = featureProviders_1[_i];
            fp.add(structure, unit, featuresBuilder);
        }
    }
    return featuresBuilder.getFeatures(count);
}
function findIntraUnitContacts(structure, unit, features, contactTesters, props) {
    var builder = _contacts_builder__WEBPACK_IMPORTED_MODULE_6__["IntraContactsBuilder"].create(features, unit.elements.length);
    if (_mol_model_structure__WEBPACK_IMPORTED_MODULE_2__["Unit"].isAtomic(unit)) {
        Object(_contacts__WEBPACK_IMPORTED_MODULE_8__["addUnitContacts"])(structure, unit, features, builder, contactTesters, props);
    }
    return builder.getContacts();
}
function findInterUnitContacts(structure, unitsFeatures, contactTesters, props) {
    var builder = _contacts_builder__WEBPACK_IMPORTED_MODULE_6__["InterContactsBuilder"].create();
    _mol_model_structure__WEBPACK_IMPORTED_MODULE_2__["Structure"].eachUnitPair(structure, function (unitA, unitB) {
        var featuresA = unitsFeatures.get(unitA.id);
        var featuresB = unitsFeatures.get(unitB.id);
        Object(_contacts__WEBPACK_IMPORTED_MODULE_8__["addStructureContacts"])(structure, unitA, featuresA, unitB, featuresB, builder, contactTesters, props);
    }, {
        maxRadius: Math.max.apply(Math, contactTesters.map(function (t) { return t.maxDistance; })),
        validUnit: function (unit) { return _mol_model_structure__WEBPACK_IMPORTED_MODULE_2__["Unit"].isAtomic(unit); },
        validUnitPair: function (unitA, unitB) { return _mol_model_structure__WEBPACK_IMPORTED_MODULE_2__["Structure"].validUnitPair(structure, unitA, unitB); }
    });
    return builder.getContacts(unitsFeatures);
}
//# sourceMappingURL=interactions.js.map

/***/ }),

/***/ "./lib/mol-model-props/computed/interactions/metal.js":
/*!************************************************************!*\
  !*** ./lib/mol-model-props/computed/interactions/metal.js ***!
  \************************************************************/
/*! exports provided: MetalCoordinationParams, MetalProvider, MetalBindingProvider, MetalCoordinationProvider */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MetalCoordinationParams", function() { return MetalCoordinationParams; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MetalProvider", function() { return MetalProvider; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MetalBindingProvider", function() { return MetalBindingProvider; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MetalCoordinationProvider", function() { return MetalCoordinationProvider; });
/* harmony import */ var _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../../mol-util/param-definition */ "./lib/mol-util/param-definition.js");
/* harmony import */ var _features__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./features */ "./lib/mol-model-props/computed/interactions/features.js");
/* harmony import */ var _chemistry_util__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../chemistry/util */ "./lib/mol-model-props/computed/chemistry/util.js");
/* harmony import */ var _mol_model_structure_model_properties_atomic_types__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../../mol-model/structure/model/properties/atomic/types */ "./lib/mol-model/structure/model/properties/atomic/types.js");
/* harmony import */ var _mol_model_structure_model_types__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../../mol-model/structure/model/types */ "./lib/mol-model/structure/model/types.js");
/**
 * Copyright (c) 2019 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 *
 * based in part on NGL (https://github.com/arose/ngl)
 */





var MetalCoordinationParams = {
    distanceMax: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_0__["ParamDefinition"].Numeric(3.0, { min: 1, max: 5, step: 0.1 }),
};
var IonicTypeMetals = [
    "LI" /* LI */, "NA" /* NA */, "K" /* K */, "RB" /* RB */, "CS" /* CS */,
    "MG" /* MG */, "CA" /* CA */, "SR" /* SR */, "BA" /* BA */, "AL" /* AL */,
    "GA" /* GA */, "IN" /* IN */, "TL" /* TL */, "SC" /* SC */, "SN" /* SN */,
    "PB" /* PB */, "BI" /* BI */, "SB" /* SB */, "HG" /* HG */
];
function addMetal(structure, unit, builder) {
    var elements = unit.elements;
    var _a = unit.model.atomicConformation, x = _a.x, y = _a.y, z = _a.z;
    for (var i = 0, il = elements.length; i < il; ++i) {
        var element = Object(_chemistry_util__WEBPACK_IMPORTED_MODULE_2__["typeSymbol"])(unit, i);
        var type = 0 /* None */;
        if (IonicTypeMetals.includes(element)) {
            type = 13 /* IonicTypeMetal */;
        }
        else if (Object(_mol_model_structure_model_properties_atomic_types__WEBPACK_IMPORTED_MODULE_3__["isTransitionMetal"])(element) || element === "ZN" /* ZN */ || element === "CD" /* CD */) {
            type = 12 /* TransitionMetal */;
        }
        if (type) {
            builder.add(type, 0 /* None */, x[elements[i]], y[elements[i]], z[elements[i]], i);
        }
    }
}
function isProteinSidechain(atomname) {
    return !_mol_model_structure_model_types__WEBPACK_IMPORTED_MODULE_4__["ProteinBackboneAtoms"].has(atomname);
}
function isProteinBackbone(atomname) {
    return _mol_model_structure_model_types__WEBPACK_IMPORTED_MODULE_4__["ProteinBackboneAtoms"].has(atomname);
}
function isNucleicBackbone(atomname) {
    return _mol_model_structure_model_types__WEBPACK_IMPORTED_MODULE_4__["NucleicBackboneAtoms"].has(atomname);
}
/**
 * Metal binding partners (dative bond or ionic-type interaction)
 */
function addMetalBinding(structure, unit, builder) {
    var elements = unit.elements;
    var _a = unit.model.atomicConformation, x = _a.x, y = _a.y, z = _a.z;
    for (var i = 0, il = elements.length; i < il; ++i) {
        var element = Object(_chemistry_util__WEBPACK_IMPORTED_MODULE_2__["typeSymbol"])(unit, i);
        var resname = Object(_chemistry_util__WEBPACK_IMPORTED_MODULE_2__["compId"])(unit, i);
        var atomname = Object(_chemistry_util__WEBPACK_IMPORTED_MODULE_2__["atomId"])(unit, i);
        var dative = false;
        var ionic = false;
        var isStandardAminoacid = _mol_model_structure_model_types__WEBPACK_IMPORTED_MODULE_4__["AminoAcidNames"].has(resname);
        var isStandardBase = _mol_model_structure_model_types__WEBPACK_IMPORTED_MODULE_4__["BaseNames"].has(resname);
        if (!isStandardAminoacid && !isStandardBase) {
            if (Object(_mol_model_structure_model_properties_atomic_types__WEBPACK_IMPORTED_MODULE_3__["isHalogen"])(element) || element === "O" /* O */ || element === "S" /* S */) {
                dative = true;
                ionic = true;
            }
            else if (element === "N" /* N */) {
                dative = true;
            }
        }
        else if (isStandardAminoacid) {
            // main chain oxygen atom or oxygen, nitrogen and sulfur from specific amino acids
            if (element === "O" /* O */) {
                if (['ASP', 'GLU', 'SER', 'THR', 'TYR', 'ASN', 'GLN'].includes(resname) && isProteinSidechain(atomname)) {
                    dative = true;
                    ionic = true;
                }
                else if (isProteinBackbone(atomname)) {
                    dative = true;
                    ionic = true;
                }
            }
            else if (element === "S" /* S */ && (resname === 'CYS' || resname === 'MET')) {
                dative = true;
                ionic = true;
            }
            else if (element === "N" /* N */) {
                if (resname === 'HIS' && isProteinSidechain(atomname)) {
                    dative = true;
                }
            }
        }
        else if (isStandardBase) {
            // http://pubs.acs.org/doi/pdf/10.1021/acs.accounts.6b00253
            // http://onlinelibrary.wiley.com/doi/10.1002/anie.200900399/full
            if (element === "O" /* O */ && isNucleicBackbone(atomname)) {
                dative = true;
                ionic = true;
            }
            else if (['N3', 'N4', 'N7'].includes(atomname)) {
                dative = true;
            }
            else if (['O2', 'O4', 'O6'].includes(atomname)) {
                dative = true;
                ionic = true;
            }
        }
        if (dative) {
            builder.add(11 /* DativeBondPartner */, 0 /* None */, x[elements[i]], y[elements[i]], z[elements[i]], i);
        }
        if (ionic) {
            builder.add(10 /* IonicTypePartner */, 0 /* None */, x[elements[i]], y[elements[i]], z[elements[i]], i);
        }
    }
}
function isMetalCoordination(ti, tj) {
    if (ti === 12 /* TransitionMetal */) {
        return (tj === 11 /* DativeBondPartner */ ||
            tj === 12 /* TransitionMetal */);
    }
    else if (ti === 13 /* IonicTypeMetal */) {
        return (tj === 10 /* IonicTypePartner */);
    }
}
function testMetalCoordination(structure, infoA, infoB, distanceSq) {
    var typeA = infoA.types[infoA.feature];
    var typeB = infoB.types[infoB.feature];
    if (!isMetalCoordination(typeA, typeB) && !isMetalCoordination(typeB, typeA))
        return;
    return 7 /* MetalCoordination */;
}
//
var MetalProvider = _features__WEBPACK_IMPORTED_MODULE_1__["Features"].Provider([13 /* IonicTypeMetal */, 12 /* TransitionMetal */], addMetal);
var MetalBindingProvider = _features__WEBPACK_IMPORTED_MODULE_1__["Features"].Provider([10 /* IonicTypePartner */, 11 /* DativeBondPartner */], addMetalBinding);
var MetalCoordinationProvider = {
    name: 'metal-coordination',
    params: MetalCoordinationParams,
    createTester: function (props) {
        return {
            maxDistance: props.distanceMax,
            requiredFeatures: new Set([13 /* IonicTypeMetal */, 12 /* TransitionMetal */, 10 /* IonicTypePartner */, 11 /* DativeBondPartner */]),
            getType: function (structure, infoA, infoB, distanceSq) { return testMetalCoordination(structure, infoA, infoB, distanceSq); }
        };
    }
};
//# sourceMappingURL=metal.js.map

/***/ }),

/***/ "./lib/mol-model-props/computed/interactions/refine.js":
/*!*************************************************************!*\
  !*** ./lib/mol-model-props/computed/interactions/refine.js ***!
  \*************************************************************/
/*! exports provided: refineInteractions */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "refineInteractions", function() { return refineInteractions; });
/* harmony import */ var _mol_model_structure__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../../mol-model/structure */ "./lib/mol-model/structure.js");
/* harmony import */ var _features__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./features */ "./lib/mol-model-props/computed/interactions/features.js");
/**
 * Copyright (c) 2019-2020 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 *
 * based in part on NGL (https://github.com/arose/ngl)
 */


function refineInteractions(structure, interactions) {
    var contacts = interactions.contacts, unitsContacts = interactions.unitsContacts, unitsFeatures = interactions.unitsFeatures;
    var contactRefiners = [
        hydrophobicRefiner(structure, interactions),
        weakHydrogenBondsRefiner(structure, interactions),
        saltBridgeRefiner(structure, interactions),
        piStackingRefiner(structure, interactions),
        metalCoordinationRefiner(structure, interactions),
    ];
    for (var i = 0, il = contacts.edgeCount; i < il; ++i) {
        var e = contacts.edges[i];
        var uA = structure.unitMap.get(e.unitA);
        var uB = structure.unitMap.get(e.unitB);
        var infoA = _features__WEBPACK_IMPORTED_MODULE_1__["Features"].Info(structure, uA, unitsFeatures.get(e.unitA));
        infoA.feature = e.indexA;
        var infoB = _features__WEBPACK_IMPORTED_MODULE_1__["Features"].Info(structure, uB, unitsFeatures.get(e.unitB));
        infoB.feature = e.indexB;
        for (var _i = 0, contactRefiners_1 = contactRefiners; _i < contactRefiners_1.length; _i++) {
            var refiner = contactRefiners_1[_i];
            if (refiner.isApplicable(e.props.type))
                refiner.handleInterContact(i, infoA, infoB);
        }
    }
    //
    var ucKeys = unitsContacts.keys();
    while (true) {
        var _a = ucKeys.next(), done = _a.done, value = _a.value;
        if (done)
            break;
        var contacts_1 = unitsContacts.get(value);
        var features = unitsFeatures.get(value);
        var unit = structure.unitMap.get(value);
        if (!_mol_model_structure__WEBPACK_IMPORTED_MODULE_0__["Unit"].isAtomic(unit))
            continue;
        var infoA = _features__WEBPACK_IMPORTED_MODULE_1__["Features"].Info(structure, unit, features);
        var infoB = _features__WEBPACK_IMPORTED_MODULE_1__["Features"].Info(structure, unit, features);
        for (var _b = 0, contactRefiners_2 = contactRefiners; _b < contactRefiners_2.length; _b++) {
            var refiner = contactRefiners_2[_b];
            refiner.startUnit(unit, contacts_1, features);
        }
        for (var i = 0, il = contacts_1.edgeCount * 2; i < il; ++i) {
            infoA.feature = contacts_1.a[i];
            infoB.feature = contacts_1.b[i];
            // console.log(i, contacts.a[i], contacts.b[i])
            for (var _c = 0, contactRefiners_3 = contactRefiners; _c < contactRefiners_3.length; _c++) {
                var refiner = contactRefiners_3[_c];
                if (refiner.isApplicable(contacts_1.edgeProps.type[i]))
                    refiner.handleIntraContact(i, infoA, infoB);
            }
        }
    }
}
/**
 * For atoms interacting with several atoms in the same residue
 * only the one with the closest distance is kept.
 */
function hydrophobicRefiner(structure, interactions) {
    var contacts = interactions.contacts;
    /* keep only closest contact between residues */
    var handleResidueContact = function (dist, edge, key, map, set) {
        var _a = map.get(key) || [Infinity, -1], minDist = _a[0], minIndex = _a[1];
        if (dist < minDist) {
            if (minIndex !== -1)
                set(minIndex);
            map.set(key, [dist, edge]);
        }
        else {
            set(edge);
        }
    };
    function handleEdge(edge, infoA, infoB, map, set) {
        var elementA = infoA.members[infoA.offsets[infoA.feature]];
        var elementB = infoB.members[infoB.offsets[infoB.feature]];
        var residueA = infoA.unit.getResidueIndex(elementA);
        var residueB = infoB.unit.getResidueIndex(elementB);
        var keyA = elementA + "|" + infoA.unit.id + "|" + residueB + "|" + infoB.unit.id + "|A";
        var keyB = elementB + "|" + infoB.unit.id + "|" + residueA + "|" + infoA.unit.id + "|B";
        var dist = _features__WEBPACK_IMPORTED_MODULE_1__["Features"].distance(infoA, infoB);
        handleResidueContact(dist, edge, keyA, map, set);
        handleResidueContact(dist, edge, keyB, map, set);
    }
    var residueInterMap = new Map();
    var setInterFiltered = function (i) { return contacts.edges[i].props.flag = 1 /* Filtered */; };
    var residueIntraMap;
    var setIntraFiltered;
    return {
        isApplicable: function (type) { return type === 6 /* Hydrophobic */; },
        handleInterContact: function (index, infoA, infoB) {
            handleEdge(index, infoA, infoB, residueInterMap, setInterFiltered);
        },
        startUnit: function (unit, contacts, features) {
            residueIntraMap = new Map();
            setIntraFiltered = function (i) { return contacts.edgeProps.flag[i] = 1 /* Filtered */; };
        },
        handleIntraContact: function (index, infoA, infoB) {
            handleEdge(index, infoA, infoB, residueIntraMap, setIntraFiltered);
        }
    };
}
/**
 * Remove weak hydrogen bonds when the acceptor is involved in
 * a normal/strong hydrogen bond
 */
function weakHydrogenBondsRefiner(structure, interactions) {
    var contacts = interactions.contacts;
    var hasHydrogenBond = function (infoA, infoB) {
        var acc = infoA.types[infoA.feature] === 9 /* WeakHydrogenDonor */ ? infoB : infoA;
        // check intra
        var eI = acc.members[acc.offsets[acc.feature]];
        var _a = interactions.unitsContacts.get(acc.unit.id), type = _a.edgeProps.type, _b = _a.elementsIndex, offsets = _b.offsets, indices = _b.indices;
        for (var i = offsets[eI], il = offsets[eI + 1]; i < il; ++i) {
            if (type[indices[i]] === 4 /* HydrogenBond */)
                return true;
        }
        // check inter
        var interIndices = contacts.getEdgeIndices(acc.feature, acc.unit.id);
        for (var i = 0, il = interIndices.length; i < il; ++i) {
            if (contacts.edges[interIndices[i]].props.type === 4 /* HydrogenBond */)
                return true;
        }
        return false;
    };
    return {
        isApplicable: function (type) { return type === 8 /* WeakHydrogenBond */; },
        handleInterContact: function (index, infoA, infoB) {
            if (hasHydrogenBond(infoA, infoB)) {
                contacts.edges[index].props.flag = 1 /* Filtered */;
            }
        },
        startUnit: function () { },
        handleIntraContact: function (index, infoA, infoB) {
            if (hasHydrogenBond(infoA, infoB)) {
                var flag = interactions.unitsContacts.get(infoA.unit.id).edgeProps.flag;
                flag[index] = 1 /* Filtered */;
            }
        }
    };
}
/**
 * Filter inter-unit contact `index` if there is a contact of `types` between its members
 */
function filterInter(types, index, infoA, infoB, contacts) {
    var offsetsA = infoA.offsets, featureA = infoA.feature;
    var offsetsB = infoB.offsets, featureB = infoB.feature;
    for (var i = offsetsA[featureA], il = offsetsA[featureA + 1]; i < il; ++i) {
        var aI = infoA.members[i];
        var indices = contacts.getContactIndicesForElement(aI, infoA.unit);
        for (var k = 0, kl = indices.length; k < kl; ++k) {
            var cI = indices[k];
            if (types.includes(contacts.edges[cI].props.type)) {
                for (var j = offsetsB[featureB], jl = offsetsB[featureB + 1]; j < jl; ++j) {
                    var bI = infoB.members[j];
                    if (contacts.getContactIndicesForElement(bI, infoB.unit).includes(cI)) {
                        contacts.edges[index].props.flag = 1 /* Filtered */;
                        return;
                    }
                }
            }
        }
    }
}
/**
 * Filter intra-unit contact `index` if there is a contact of `types` between its members
 */
function filterIntra(types, index, infoA, infoB, contacts) {
    var _a = contacts.edgeProps, type = _a.type, flag = _a.flag, _b = contacts.elementsIndex, offsets = _b.offsets, indices = _b.indices;
    var offsetsA = infoA.offsets, featureA = infoA.feature;
    var offsetsB = infoB.offsets, featureB = infoB.feature;
    for (var i = offsetsA[featureA], il = offsetsA[featureA + 1]; i < il; ++i) {
        var aI = infoA.members[i];
        for (var k = offsets[aI], kl = offsets[aI + 1]; k < kl; ++k) {
            var cI = indices[k];
            if (types.includes(type[cI])) {
                for (var j = offsetsB[featureB], jl = offsetsB[featureB + 1]; j < jl; ++j) {
                    var bI = infoB.members[j];
                    for (var l = offsets[bI], ll = offsets[bI + 1]; l < ll; ++l) {
                        if (cI === indices[l]) {
                            flag[index] = 1 /* Filtered */;
                            return;
                        }
                    }
                }
            }
        }
    }
}
/**
 * Remove hydrogen bonds (normal and weak) between groups that also form
 * an ionic interaction between each other
 */
function saltBridgeRefiner(structure, interactions) {
    var contacts = interactions.contacts;
    return {
        isApplicable: function (type) { return type === 1 /* Ionic */; },
        handleInterContact: function (index, infoA, infoB) {
            filterInter([4 /* HydrogenBond */, 8 /* WeakHydrogenBond */], index, infoA, infoB, contacts);
        },
        startUnit: function () { },
        handleIntraContact: function (index, infoA, infoB) {
            filterIntra([4 /* HydrogenBond */, 8 /* WeakHydrogenBond */], index, infoA, infoB, interactions.unitsContacts.get(infoA.unit.id));
        }
    };
}
/**
 * Remove hydrophobic and cation-pi interactions between groups that also form
 * a pi-stacking interaction between each other
 */
function piStackingRefiner(structure, interactions) {
    var contacts = interactions.contacts;
    return {
        isApplicable: function (type) { return type === 6 /* Hydrophobic */ || type === 2 /* CationPi */; },
        handleInterContact: function (index, infoA, infoB) {
            filterInter([3 /* PiStacking */], index, infoA, infoB, contacts);
        },
        startUnit: function () { },
        handleIntraContact: function (index, infoA, infoB) {
            filterIntra([3 /* PiStacking */], index, infoA, infoB, interactions.unitsContacts.get(infoA.unit.id));
        }
    };
}
/**
 * Remove ionic interactions between groups that also form
 * a metal coordination between each other
 */
function metalCoordinationRefiner(structure, interactions) {
    var contacts = interactions.contacts;
    return {
        isApplicable: function (type) { return type === 1 /* Ionic */; },
        handleInterContact: function (index, infoA, infoB) {
            filterInter([7 /* MetalCoordination */], index, infoA, infoB, contacts);
        },
        startUnit: function () { },
        handleIntraContact: function (index, infoA, infoB) {
            filterIntra([7 /* MetalCoordination */], index, infoA, infoB, interactions.unitsContacts.get(infoA.unit.id));
        }
    };
}
//# sourceMappingURL=refine.js.map

/***/ }),

/***/ "./lib/mol-model-props/computed/representations/interactions-inter-unit-cylinder.js":
/*!******************************************************************************************!*\
  !*** ./lib/mol-model-props/computed/representations/interactions-inter-unit-cylinder.js ***!
  \******************************************************************************************/
/*! exports provided: InteractionsInterUnitParams, InteractionsInterUnitVisual */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "InteractionsInterUnitParams", function() { return InteractionsInterUnitParams; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "InteractionsInterUnitVisual", function() { return InteractionsInterUnitVisual; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../../mol-util/param-definition */ "./lib/mol-util/param-definition.js");
/* harmony import */ var _mol_model_structure__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../../mol-model/structure */ "./lib/mol-model/structure.js");
/* harmony import */ var _mol_geo_geometry_mesh_mesh__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../../mol-geo/geometry/mesh/mesh */ "./lib/mol-geo/geometry/mesh/mesh.js");
/* harmony import */ var _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../../mol-math/linear-algebra */ "./lib/mol-math/linear-algebra.js");
/* harmony import */ var _mol_repr_structure_visual_util_link__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../../mol-repr/structure/visual/util/link */ "./lib/mol-repr/structure/visual/util/link.js");
/* harmony import */ var _mol_repr_structure_complex_visual__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../../../mol-repr/structure/complex-visual */ "./lib/mol-repr/structure/complex-visual.js");
/* harmony import */ var _mol_model_loci__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../../../mol-model/loci */ "./lib/mol-model/loci.js");
/* harmony import */ var _mol_data_int__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ../../../mol-data/int */ "./lib/mol-data/int.js");
/* harmony import */ var _interactions_interactions__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ../interactions/interactions */ "./lib/mol-model-props/computed/interactions/interactions.js");
/* harmony import */ var _interactions__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ../interactions */ "./lib/mol-model-props/computed/interactions.js");
/* harmony import */ var _mol_geo_util_location_iterator__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ../../../mol-geo/util/location-iterator */ "./lib/mol-geo/util/location-iterator.js");
/* harmony import */ var _mol_model_structure_structure__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! ../../../mol-model/structure/structure */ "./lib/mol-model/structure/structure.js");
/* harmony import */ var _mol_math_geometry__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! ../../../mol-math/geometry */ "./lib/mol-math/geometry.js");
/**
 * Copyright (c) 2019-2020 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */














var tmpLoc = _mol_model_structure__WEBPACK_IMPORTED_MODULE_2__["StructureElement"].Location.create(void 0);
function createInterUnitInteractionCylinderMesh(ctx, structure, theme, props, mesh) {
    if (!structure.hasAtomic)
        return _mol_geo_geometry_mesh_mesh__WEBPACK_IMPORTED_MODULE_3__["Mesh"].createEmpty(mesh);
    var interactions = _interactions__WEBPACK_IMPORTED_MODULE_10__["InteractionsProvider"].get(structure).value;
    var contacts = interactions.contacts, unitsFeatures = interactions.unitsFeatures;
    var edgeCount = contacts.edgeCount, edges = contacts.edges;
    var sizeFactor = props.sizeFactor;
    if (!edgeCount)
        return _mol_geo_geometry_mesh_mesh__WEBPACK_IMPORTED_MODULE_3__["Mesh"].createEmpty(mesh);
    var builderProps = {
        linkCount: edgeCount,
        position: function (posA, posB, edgeIndex) {
            var _a = edges[edgeIndex], unitA = _a.unitA, indexA = _a.indexA, unitB = _a.unitB, indexB = _a.indexB;
            var fA = unitsFeatures.get(unitA);
            var fB = unitsFeatures.get(unitB);
            var uA = structure.unitMap.get(unitA);
            var uB = structure.unitMap.get(unitB);
            _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_4__["Vec3"].set(posA, fA.x[indexA], fA.y[indexA], fA.z[indexA]);
            _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_4__["Vec3"].transformMat4(posA, posA, uA.conformation.operator.matrix);
            _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_4__["Vec3"].set(posB, fB.x[indexB], fB.y[indexB], fB.z[indexB]);
            _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_4__["Vec3"].transformMat4(posB, posB, uB.conformation.operator.matrix);
        },
        style: function (edgeIndex) { return 1 /* Dashed */; },
        radius: function (edgeIndex) {
            var b = edges[edgeIndex];
            var fA = unitsFeatures.get(b.unitA);
            tmpLoc.structure = structure;
            tmpLoc.unit = structure.unitMap.get(b.unitA);
            tmpLoc.element = tmpLoc.unit.elements[fA.members[fA.offsets[b.indexA]]];
            var sizeA = theme.size.size(tmpLoc);
            var fB = unitsFeatures.get(b.unitB);
            tmpLoc.unit = structure.unitMap.get(b.unitB);
            tmpLoc.element = tmpLoc.unit.elements[fB.members[fB.offsets[b.indexB]]];
            var sizeB = theme.size.size(tmpLoc);
            return Math.min(sizeA, sizeB) * sizeFactor;
        },
        ignore: function (edgeIndex) { return edges[edgeIndex].props.flag === 1 /* Filtered */; }
    };
    var m = Object(_mol_repr_structure_visual_util_link__WEBPACK_IMPORTED_MODULE_5__["createLinkCylinderMesh"])(ctx, builderProps, props, mesh);
    var sphere = _mol_math_geometry__WEBPACK_IMPORTED_MODULE_13__["Sphere3D"].expand(Object(_mol_math_geometry__WEBPACK_IMPORTED_MODULE_13__["Sphere3D"])(), structure.boundary.sphere, 1 * sizeFactor);
    m.setBoundingSphere(sphere);
    return m;
}
var InteractionsInterUnitParams = Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, _mol_repr_structure_complex_visual__WEBPACK_IMPORTED_MODULE_6__["ComplexMeshParams"]), _mol_repr_structure_visual_util_link__WEBPACK_IMPORTED_MODULE_5__["LinkCylinderParams"]), { sizeFactor: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_1__["ParamDefinition"].Numeric(0.3, { min: 0, max: 10, step: 0.01 }), dashCount: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_1__["ParamDefinition"].Numeric(6, { min: 2, max: 10, step: 2 }), dashScale: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_1__["ParamDefinition"].Numeric(0.4, { min: 0, max: 2, step: 0.1 }) });
function InteractionsInterUnitVisual(materialId) {
    return Object(_mol_repr_structure_complex_visual__WEBPACK_IMPORTED_MODULE_6__["ComplexMeshVisual"])({
        defaultProps: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_1__["ParamDefinition"].getDefaultValues(InteractionsInterUnitParams),
        createGeometry: createInterUnitInteractionCylinderMesh,
        createLocationIterator: createInteractionsIterator,
        getLoci: getInteractionLoci,
        eachLocation: eachInteraction,
        setUpdateState: function (state, newProps, currentProps, newTheme, currentTheme, newStructure, currentStructure) {
            state.createGeometry = (newProps.sizeFactor !== currentProps.sizeFactor ||
                newProps.dashCount !== currentProps.dashCount ||
                newProps.dashScale !== currentProps.dashScale ||
                newProps.dashCap !== currentProps.dashCap ||
                newProps.radialSegments !== currentProps.radialSegments);
            var interactionsHash = _interactions__WEBPACK_IMPORTED_MODULE_10__["InteractionsProvider"].get(newStructure).version;
            if (state.info.interactionsHash !== interactionsHash) {
                state.createGeometry = true;
                state.updateTransform = true;
                state.updateColor = true;
                state.info.interactionsHash = interactionsHash;
            }
        }
    }, materialId);
}
function getInteractionLoci(pickingId, structure, id) {
    var objectId = pickingId.objectId, groupId = pickingId.groupId;
    if (id === objectId) {
        var interactions = _interactions__WEBPACK_IMPORTED_MODULE_10__["InteractionsProvider"].get(structure).value;
        var c = interactions.contacts.edges[groupId];
        var unitA = structure.unitMap.get(c.unitA);
        var unitB = structure.unitMap.get(c.unitB);
        return _interactions_interactions__WEBPACK_IMPORTED_MODULE_9__["Interactions"].Loci(structure, interactions, [
            { unitA: unitA, indexA: c.indexA, unitB: unitB, indexB: c.indexB },
            { unitA: unitB, indexA: c.indexB, unitB: unitA, indexB: c.indexA },
        ]);
    }
    return _mol_model_loci__WEBPACK_IMPORTED_MODULE_7__["EmptyLoci"];
}
function eachInteraction(loci, structure, apply, isMarking) {
    var _a;
    var changed = false;
    if (_interactions_interactions__WEBPACK_IMPORTED_MODULE_9__["Interactions"].isLoci(loci)) {
        if (!_mol_model_structure__WEBPACK_IMPORTED_MODULE_2__["Structure"].areEquivalent(loci.data.structure, structure))
            return false;
        var interactions = _interactions__WEBPACK_IMPORTED_MODULE_10__["InteractionsProvider"].get(structure).value;
        if (loci.data.interactions !== interactions)
            return false;
        var contacts = interactions.contacts;
        for (var _i = 0, _b = loci.elements; _i < _b.length; _i++) {
            var c = _b[_i];
            var idx = contacts.getEdgeIndex(c.indexA, c.unitA.id, c.indexB, c.unitB.id);
            if (idx !== -1) {
                if (apply(_mol_data_int__WEBPACK_IMPORTED_MODULE_8__["Interval"].ofSingleton(idx)))
                    changed = true;
            }
        }
    }
    else if (_mol_model_structure__WEBPACK_IMPORTED_MODULE_2__["StructureElement"].Loci.is(loci)) {
        if (!_mol_model_structure__WEBPACK_IMPORTED_MODULE_2__["Structure"].areEquivalent(loci.structure, structure))
            return false;
        if (isMarking && loci.elements.length === 1)
            return false; // only a single unit
        var contacts_1 = (_a = _interactions__WEBPACK_IMPORTED_MODULE_10__["InteractionsProvider"].get(structure).value) === null || _a === void 0 ? void 0 : _a.contacts;
        if (!contacts_1)
            return false;
        var _loop_1 = function (e) {
            var unit = e.unit;
            if (!_mol_model_structure_structure__WEBPACK_IMPORTED_MODULE_12__["Unit"].isAtomic(unit))
                return "continue";
            if (isMarking && _mol_data_int__WEBPACK_IMPORTED_MODULE_8__["OrderedSet"].size(e.indices) === 1)
                return "continue";
            _mol_data_int__WEBPACK_IMPORTED_MODULE_8__["OrderedSet"].forEach(e.indices, function (v) {
                for (var _i = 0, _a = contacts_1.getContactIndicesForElement(v, unit); _i < _a.length; _i++) {
                    var idx = _a[_i];
                    if (apply(_mol_data_int__WEBPACK_IMPORTED_MODULE_8__["Interval"].ofSingleton(idx)))
                        changed = true;
                }
            });
        };
        // TODO when isMarking, all elements of contact features need to be in the loci
        for (var _c = 0, _d = loci.elements; _c < _d.length; _c++) {
            var e = _d[_c];
            _loop_1(e);
        }
    }
    return changed;
}
function createInteractionsIterator(structure) {
    var interactions = _interactions__WEBPACK_IMPORTED_MODULE_10__["InteractionsProvider"].get(structure).value;
    var contacts = interactions.contacts;
    var groupCount = contacts.edgeCount;
    var instanceCount = 1;
    var location = _interactions_interactions__WEBPACK_IMPORTED_MODULE_9__["Interactions"].Location(interactions, structure);
    var element = location.element;
    var getLocation = function (groupIndex) {
        var c = contacts.edges[groupIndex];
        element.unitA = structure.unitMap.get(c.unitA);
        element.indexA = c.indexA;
        element.unitB = structure.unitMap.get(c.unitB);
        element.indexB = c.indexB;
        return location;
    };
    return Object(_mol_geo_util_location_iterator__WEBPACK_IMPORTED_MODULE_11__["LocationIterator"])(groupCount, instanceCount, 1, getLocation, true);
}
//# sourceMappingURL=interactions-inter-unit-cylinder.js.map

/***/ }),

/***/ "./lib/mol-model-props/computed/representations/interactions-intra-unit-cylinder.js":
/*!******************************************************************************************!*\
  !*** ./lib/mol-model-props/computed/representations/interactions-intra-unit-cylinder.js ***!
  \******************************************************************************************/
/*! exports provided: InteractionsIntraUnitParams, InteractionsIntraUnitVisual */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "InteractionsIntraUnitParams", function() { return InteractionsIntraUnitParams; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "InteractionsIntraUnitVisual", function() { return InteractionsIntraUnitVisual; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _mol_model_structure__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../../mol-model/structure */ "./lib/mol-model/structure.js");
/* harmony import */ var _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../../mol-math/linear-algebra */ "./lib/mol-math/linear-algebra.js");
/* harmony import */ var _mol_model_loci__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../../mol-model/loci */ "./lib/mol-model/loci.js");
/* harmony import */ var _mol_data_int__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../../mol-data/int */ "./lib/mol-data/int.js");
/* harmony import */ var _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../../mol-util/param-definition */ "./lib/mol-util/param-definition.js");
/* harmony import */ var _mol_geo_geometry_mesh_mesh__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../../../mol-geo/geometry/mesh/mesh */ "./lib/mol-geo/geometry/mesh/mesh.js");
/* harmony import */ var _interactions__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../interactions */ "./lib/mol-model-props/computed/interactions.js");
/* harmony import */ var _mol_repr_structure_visual_util_link__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ../../../mol-repr/structure/visual/util/link */ "./lib/mol-repr/structure/visual/util/link.js");
/* harmony import */ var _mol_repr_structure_units_visual__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ../../../mol-repr/structure/units-visual */ "./lib/mol-repr/structure/units-visual.js");
/* harmony import */ var _mol_geo_util_location_iterator__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ../../../mol-geo/util/location-iterator */ "./lib/mol-geo/util/location-iterator.js");
/* harmony import */ var _interactions_interactions__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ../interactions/interactions */ "./lib/mol-model-props/computed/interactions/interactions.js");
/* harmony import */ var _mol_math_geometry__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! ../../../mol-math/geometry */ "./lib/mol-math/geometry.js");
/**
 * Copyright (c) 2019-2020 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */













function createIntraUnitInteractionsCylinderMesh(ctx, unit, structure, theme, props, mesh) {
    return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"])(this, void 0, void 0, function () {
        var location, interactions, features, contacts, x, y, z, members, offsets, edgeCount, a, b, flag, sizeFactor, builderProps, m, sphere;
        return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__generator"])(this, function (_a) {
            if (!_mol_model_structure__WEBPACK_IMPORTED_MODULE_1__["Unit"].isAtomic(unit))
                return [2 /*return*/, _mol_geo_geometry_mesh_mesh__WEBPACK_IMPORTED_MODULE_6__["Mesh"].createEmpty(mesh)];
            location = _mol_model_structure__WEBPACK_IMPORTED_MODULE_1__["StructureElement"].Location.create(structure, unit);
            interactions = _interactions__WEBPACK_IMPORTED_MODULE_7__["InteractionsProvider"].get(structure).value;
            features = interactions.unitsFeatures.get(unit.id);
            contacts = interactions.unitsContacts.get(unit.id);
            x = features.x, y = features.y, z = features.z, members = features.members, offsets = features.offsets;
            edgeCount = contacts.edgeCount, a = contacts.a, b = contacts.b, flag = contacts.edgeProps.flag;
            sizeFactor = props.sizeFactor;
            if (!edgeCount)
                return [2 /*return*/, _mol_geo_geometry_mesh_mesh__WEBPACK_IMPORTED_MODULE_6__["Mesh"].createEmpty(mesh)];
            builderProps = {
                linkCount: edgeCount * 2,
                position: function (posA, posB, edgeIndex) {
                    _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_2__["Vec3"].set(posA, x[a[edgeIndex]], y[a[edgeIndex]], z[a[edgeIndex]]);
                    _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_2__["Vec3"].set(posB, x[b[edgeIndex]], y[b[edgeIndex]], z[b[edgeIndex]]);
                },
                style: function (edgeIndex) { return 1 /* Dashed */; },
                radius: function (edgeIndex) {
                    location.element = unit.elements[members[offsets[a[edgeIndex]]]];
                    var sizeA = theme.size.size(location);
                    location.element = unit.elements[members[offsets[b[edgeIndex]]]];
                    var sizeB = theme.size.size(location);
                    return Math.min(sizeA, sizeB) * sizeFactor;
                },
                ignore: function (edgeIndex) { return flag[edgeIndex] === 1 /* Filtered */; }
            };
            m = Object(_mol_repr_structure_visual_util_link__WEBPACK_IMPORTED_MODULE_8__["createLinkCylinderMesh"])(ctx, builderProps, props, mesh);
            sphere = _mol_math_geometry__WEBPACK_IMPORTED_MODULE_12__["Sphere3D"].expand(Object(_mol_math_geometry__WEBPACK_IMPORTED_MODULE_12__["Sphere3D"])(), unit.boundary.sphere, 1 * sizeFactor);
            m.setBoundingSphere(sphere);
            return [2 /*return*/, m];
        });
    });
}
var InteractionsIntraUnitParams = Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, _mol_repr_structure_units_visual__WEBPACK_IMPORTED_MODULE_9__["UnitsMeshParams"]), _mol_repr_structure_visual_util_link__WEBPACK_IMPORTED_MODULE_8__["LinkCylinderParams"]), { sizeFactor: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_5__["ParamDefinition"].Numeric(0.3, { min: 0, max: 10, step: 0.01 }), dashCount: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_5__["ParamDefinition"].Numeric(6, { min: 2, max: 10, step: 2 }), dashScale: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_5__["ParamDefinition"].Numeric(0.4, { min: 0, max: 2, step: 0.1 }) });
function InteractionsIntraUnitVisual(materialId) {
    return Object(_mol_repr_structure_units_visual__WEBPACK_IMPORTED_MODULE_9__["UnitsMeshVisual"])({
        defaultProps: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_5__["ParamDefinition"].getDefaultValues(InteractionsIntraUnitParams),
        createGeometry: createIntraUnitInteractionsCylinderMesh,
        createLocationIterator: createInteractionsIterator,
        getLoci: getInteractionLoci,
        eachLocation: eachInteraction,
        setUpdateState: function (state, newProps, currentProps, newTheme, currentTheme, newStructureGroup, currentStructureGroup) {
            state.createGeometry = (newProps.sizeFactor !== currentProps.sizeFactor ||
                newProps.dashCount !== currentProps.dashCount ||
                newProps.dashScale !== currentProps.dashScale ||
                newProps.dashCap !== currentProps.dashCap ||
                newProps.radialSegments !== currentProps.radialSegments);
            var interactionsHash = _interactions__WEBPACK_IMPORTED_MODULE_7__["InteractionsProvider"].get(newStructureGroup.structure).version;
            if (state.info.interactionsHash !== interactionsHash) {
                state.createGeometry = true;
                state.updateTransform = true;
                state.updateColor = true;
                state.info.interactionsHash = interactionsHash;
            }
        }
    }, materialId);
}
function getInteractionLoci(pickingId, structureGroup, id) {
    var objectId = pickingId.objectId, instanceId = pickingId.instanceId, groupId = pickingId.groupId;
    if (id === objectId) {
        var structure = structureGroup.structure, group = structureGroup.group;
        var unit = structure.unitMap.get(group.units[instanceId].id);
        var interactions = _interactions__WEBPACK_IMPORTED_MODULE_7__["InteractionsProvider"].get(structure).value;
        var _a = interactions.unitsContacts.get(unit.id), a = _a.a, b = _a.b;
        return _interactions_interactions__WEBPACK_IMPORTED_MODULE_11__["Interactions"].Loci(structure, interactions, [
            { unitA: unit, indexA: a[groupId], unitB: unit, indexB: b[groupId] },
            { unitA: unit, indexA: b[groupId], unitB: unit, indexB: a[groupId] },
        ]);
    }
    return _mol_model_loci__WEBPACK_IMPORTED_MODULE_3__["EmptyLoci"];
}
function eachInteraction(loci, structureGroup, apply, isMarking) {
    var changed = false;
    if (_interactions_interactions__WEBPACK_IMPORTED_MODULE_11__["Interactions"].isLoci(loci)) {
        var structure = structureGroup.structure, group = structureGroup.group;
        if (!_mol_model_structure__WEBPACK_IMPORTED_MODULE_1__["Structure"].areEquivalent(loci.data.structure, structure))
            return false;
        var interactions = _interactions__WEBPACK_IMPORTED_MODULE_7__["InteractionsProvider"].get(structure).value;
        if (loci.data.interactions !== interactions)
            return false;
        var unit = group.units[0];
        var contacts = interactions.unitsContacts.get(unit.id);
        var groupCount = contacts.edgeCount * 2;
        for (var _i = 0, _a = loci.elements; _i < _a.length; _i++) {
            var e = _a[_i];
            if (e.unitA !== e.unitB)
                continue;
            var unitIdx = group.unitIndexMap.get(e.unitA.id);
            if (unitIdx !== undefined) {
                var idx = contacts.getDirectedEdgeIndex(e.indexA, e.indexB);
                if (idx !== -1) {
                    if (apply(_mol_data_int__WEBPACK_IMPORTED_MODULE_4__["Interval"].ofSingleton(unitIdx * groupCount + idx)))
                        changed = true;
                }
            }
        }
    }
    else if (_mol_model_structure__WEBPACK_IMPORTED_MODULE_1__["StructureElement"].Loci.is(loci)) {
        var structure = structureGroup.structure, group = structureGroup.group;
        if (!_mol_model_structure__WEBPACK_IMPORTED_MODULE_1__["Structure"].areEquivalent(loci.structure, structure))
            return false;
        var interactions = _interactions__WEBPACK_IMPORTED_MODULE_7__["InteractionsProvider"].get(structure).value;
        if (!interactions)
            return false;
        var unit = group.units[0];
        var contacts = interactions.unitsContacts.get(unit.id);
        var features = interactions.unitsFeatures.get(unit.id);
        var groupCount_1 = contacts.edgeCount * 2;
        var offset_1 = contacts.offset;
        var _b = features.elementsIndex, fOffsets_1 = _b.offsets, fIndices_1 = _b.indices;
        var _loop_1 = function (e) {
            var unitIdx = group.unitIndexMap.get(e.unit.id);
            if (unitIdx !== undefined)
                return "continue";
            if (isMarking && _mol_data_int__WEBPACK_IMPORTED_MODULE_4__["OrderedSet"].size(e.indices) === 1)
                return "continue";
            _mol_data_int__WEBPACK_IMPORTED_MODULE_4__["OrderedSet"].forEach(e.indices, function (v) {
                for (var i = fOffsets_1[v], il = fOffsets_1[v + 1]; i < il; ++i) {
                    var fI = fIndices_1[i];
                    for (var j = offset_1[fI], jl = offset_1[fI + 1]; j < jl; ++j) {
                        if (apply(_mol_data_int__WEBPACK_IMPORTED_MODULE_4__["Interval"].ofSingleton(unitIdx * groupCount_1 + j)))
                            changed = true;
                    }
                }
            });
        };
        // TODO when isMarking, all elements of contact features need to be in the loci
        for (var _c = 0, _d = loci.elements; _c < _d.length; _c++) {
            var e = _d[_c];
            _loop_1(e);
        }
    }
    return changed;
}
function createInteractionsIterator(structureGroup) {
    var structure = structureGroup.structure, group = structureGroup.group;
    var unit = group.units[0];
    var interactions = _interactions__WEBPACK_IMPORTED_MODULE_7__["InteractionsProvider"].get(structure).value;
    var contacts = interactions.unitsContacts.get(unit.id);
    var groupCount = contacts.edgeCount * 2;
    var instanceCount = group.units.length;
    var location = _interactions_interactions__WEBPACK_IMPORTED_MODULE_11__["Interactions"].Location(interactions, structure);
    var element = location.element;
    var getLocation = function (groupIndex, instanceIndex) {
        var instanceUnit = group.units[instanceIndex];
        element.unitA = instanceUnit;
        element.indexA = contacts.a[groupIndex];
        element.unitB = instanceUnit;
        element.indexB = contacts.b[groupIndex];
        return location;
    };
    return Object(_mol_geo_util_location_iterator__WEBPACK_IMPORTED_MODULE_10__["LocationIterator"])(groupCount, instanceCount, 1, getLocation);
}
//# sourceMappingURL=interactions-intra-unit-cylinder.js.map

/***/ }),

/***/ "./lib/mol-model-props/computed/representations/interactions.js":
/*!**********************************************************************!*\
  !*** ./lib/mol-model-props/computed/representations/interactions.js ***!
  \**********************************************************************/
/*! exports provided: InteractionsParams, getInteractionParams, InteractionRepresentation, InteractionsRepresentationProvider */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "InteractionsParams", function() { return InteractionsParams; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getInteractionParams", function() { return getInteractionParams; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "InteractionRepresentation", function() { return InteractionRepresentation; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "InteractionsRepresentationProvider", function() { return InteractionsRepresentationProvider; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../../mol-util/param-definition */ "./lib/mol-util/param-definition.js");
/* harmony import */ var _mol_repr_representation__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../../mol-repr/representation */ "./lib/mol-repr/representation.js");
/* harmony import */ var _mol_repr_structure_representation__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../../mol-repr/structure/representation */ "./lib/mol-repr/structure/representation.js");
/* harmony import */ var _interactions_intra_unit_cylinder__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./interactions-intra-unit-cylinder */ "./lib/mol-model-props/computed/representations/interactions-intra-unit-cylinder.js");
/* harmony import */ var _interactions__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../interactions */ "./lib/mol-model-props/computed/interactions.js");
/* harmony import */ var _interactions_inter_unit_cylinder__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ./interactions-inter-unit-cylinder */ "./lib/mol-model-props/computed/representations/interactions-inter-unit-cylinder.js");
/* harmony import */ var _mol_repr_structure_params__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../../../mol-repr/structure/params */ "./lib/mol-repr/structure/params.js");
/**
 * Copyright (c) 2019 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */








var InteractionsVisuals = {
    'intra-unit': function (ctx, getParams) { return Object(_mol_repr_structure_representation__WEBPACK_IMPORTED_MODULE_3__["UnitsRepresentation"])('Intra-unit interactions cylinder', ctx, getParams, _interactions_intra_unit_cylinder__WEBPACK_IMPORTED_MODULE_4__["InteractionsIntraUnitVisual"]); },
    'inter-unit': function (ctx, getParams) { return Object(_mol_repr_structure_representation__WEBPACK_IMPORTED_MODULE_3__["ComplexRepresentation"])('Inter-unit interactions cylinder', ctx, getParams, _interactions_inter_unit_cylinder__WEBPACK_IMPORTED_MODULE_6__["InteractionsInterUnitVisual"]); },
};
var InteractionsParams = Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, _interactions_intra_unit_cylinder__WEBPACK_IMPORTED_MODULE_4__["InteractionsIntraUnitParams"]), _interactions_inter_unit_cylinder__WEBPACK_IMPORTED_MODULE_6__["InteractionsInterUnitParams"]), { unitKinds: Object(_mol_repr_structure_params__WEBPACK_IMPORTED_MODULE_7__["getUnitKindsParam"])(['atomic']), sizeFactor: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_1__["ParamDefinition"].Numeric(0.2, { min: 0.01, max: 1, step: 0.01 }), visuals: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_1__["ParamDefinition"].MultiSelect(['intra-unit', 'inter-unit'], _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_1__["ParamDefinition"].objectToOptions(InteractionsVisuals)) });
function getInteractionParams(ctx, structure) {
    return _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_1__["ParamDefinition"].clone(InteractionsParams);
}
function InteractionRepresentation(ctx, getParams) {
    return _mol_repr_representation__WEBPACK_IMPORTED_MODULE_2__["Representation"].createMulti('Interactions', ctx, getParams, _mol_repr_structure_representation__WEBPACK_IMPORTED_MODULE_3__["StructureRepresentationStateBuilder"], InteractionsVisuals);
}
var InteractionsRepresentationProvider = Object(_mol_repr_structure_representation__WEBPACK_IMPORTED_MODULE_3__["StructureRepresentationProvider"])({
    name: 'interactions',
    label: 'Non-covalent Interactions',
    description: 'Displays non-covalent interactions as dashed cylinders.',
    factory: InteractionRepresentation,
    getParams: getInteractionParams,
    defaultValues: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_1__["ParamDefinition"].getDefaultValues(InteractionsParams),
    defaultColorTheme: { name: 'interaction-type' },
    defaultSizeTheme: { name: 'uniform' },
    isApplicable: function (structure) { return structure.elementCount > 0; },
    ensureCustomProperties: {
        attach: function (ctx, structure) { return _interactions__WEBPACK_IMPORTED_MODULE_5__["InteractionsProvider"].attach(ctx, structure, void 0, true); },
        detach: function (data) { return _interactions__WEBPACK_IMPORTED_MODULE_5__["InteractionsProvider"].ref(data, false); }
    }
});
//# sourceMappingURL=interactions.js.map

/***/ }),

/***/ "./lib/mol-model-props/computed/secondary-structure.js":
/*!*************************************************************!*\
  !*** ./lib/mol-model-props/computed/secondary-structure.js ***!
  \*************************************************************/
/*! exports provided: SecondaryStructureParams, SecondaryStructureProvider */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SecondaryStructureParams", function() { return SecondaryStructureParams; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SecondaryStructureProvider", function() { return SecondaryStructureProvider; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _secondary_structure_dssp__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./secondary-structure/dssp */ "./lib/mol-model-props/computed/secondary-structure/dssp.js");
/* harmony import */ var _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../mol-util/param-definition */ "./lib/mol-util/param-definition.js");
/* harmony import */ var _mol_model_structure_structure__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../mol-model/structure/structure */ "./lib/mol-model/structure/structure.js");
/* harmony import */ var _common_custom_structure_property__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../common/custom-structure-property */ "./lib/mol-model-props/common/custom-structure-property.js");
/* harmony import */ var _mol_model_formats_structure_property_secondary_structure__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../mol-model-formats/structure/property/secondary-structure */ "./lib/mol-model-formats/structure/property/secondary-structure.js");
/* harmony import */ var _mol_model_custom_property__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../../mol-model/custom-property */ "./lib/mol-model/custom-property.js");
/* harmony import */ var _mol_model_structure_model__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../../mol-model/structure/model */ "./lib/mol-model/structure/model.js");
/**
 * Copyright (c) 2019-2020 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */








function getSecondaryStructureParams(data) {
    var defaultType = 'model';
    if (data) {
        defaultType = 'dssp';
        for (var i = 0, il = data.models.length; i < il; ++i) {
            var m = data.models[i];
            if (_mol_model_structure_model__WEBPACK_IMPORTED_MODULE_7__["Model"].isFromPdbArchive(m) || _mol_model_structure_model__WEBPACK_IMPORTED_MODULE_7__["Model"].hasSecondaryStructure(m)) {
                // if there is any secondary structure definition given or if there is
                // an archival model, don't calculate dssp by default
                defaultType = 'model';
                break;
            }
        }
    }
    return {
        type: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_2__["ParamDefinition"].MappedStatic(defaultType, {
            'model': _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_2__["ParamDefinition"].EmptyGroup({ label: 'Model' }),
            'dssp': _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_2__["ParamDefinition"].Group(_secondary_structure_dssp__WEBPACK_IMPORTED_MODULE_1__["DSSPComputationParams"], { label: 'DSSP', isFlat: true })
        }, { options: [['model', 'Model'], ['dssp', 'DSSP']] })
    };
}
var SecondaryStructureParams = getSecondaryStructureParams();
var SecondaryStructureProvider = _common_custom_structure_property__WEBPACK_IMPORTED_MODULE_4__["CustomStructureProperty"].createProvider({
    label: 'Secondary Structure',
    descriptor: Object(_mol_model_custom_property__WEBPACK_IMPORTED_MODULE_6__["CustomPropertyDescriptor"])({
        name: 'molstar_computed_secondary_structure',
    }),
    type: 'root',
    defaultParams: SecondaryStructureParams,
    getParams: getSecondaryStructureParams,
    isApplicable: function (data) { return true; },
    obtain: function (ctx, data, props) { return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"])(void 0, void 0, void 0, function () {
        var p, _a;
        var _b, _c;
        return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__generator"])(this, function (_d) {
            switch (_d.label) {
                case 0:
                    p = Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_2__["ParamDefinition"].getDefaultValues(SecondaryStructureParams)), props);
                    _a = p.type.name;
                    switch (_a) {
                        case 'dssp': return [3 /*break*/, 1];
                        case 'model': return [3 /*break*/, 3];
                    }
                    return [3 /*break*/, 5];
                case 1:
                    _b = {};
                    return [4 /*yield*/, computeDssp(data, p.type.params)];
                case 2: return [2 /*return*/, (_b.value = _d.sent(), _b)];
                case 3:
                    _c = {};
                    return [4 /*yield*/, computeModel(data)];
                case 4: return [2 /*return*/, (_c.value = _d.sent(), _c)];
                case 5: return [2 /*return*/];
            }
        });
    }); }
});
function computeDssp(structure, props) {
    return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"])(this, void 0, void 0, function () {
        var map, i, il, u, secondaryStructure;
        return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__generator"])(this, function (_a) {
            switch (_a.label) {
                case 0:
                    map = new Map();
                    i = 0, il = structure.unitSymmetryGroups.length;
                    _a.label = 1;
                case 1:
                    if (!(i < il)) return [3 /*break*/, 4];
                    u = structure.unitSymmetryGroups[i].units[0];
                    if (!_mol_model_structure_structure__WEBPACK_IMPORTED_MODULE_3__["Unit"].isAtomic(u)) return [3 /*break*/, 3];
                    return [4 /*yield*/, Object(_secondary_structure_dssp__WEBPACK_IMPORTED_MODULE_1__["computeUnitDSSP"])(u, props)];
                case 2:
                    secondaryStructure = _a.sent();
                    map.set(u.invariantId, secondaryStructure);
                    _a.label = 3;
                case 3:
                    ++i;
                    return [3 /*break*/, 1];
                case 4: return [2 /*return*/, map];
            }
        });
    });
}
function computeModel(structure) {
    return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"])(this, void 0, void 0, function () {
        var map, i, il, u, secondaryStructure;
        return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__generator"])(this, function (_a) {
            map = new Map();
            for (i = 0, il = structure.unitSymmetryGroups.length; i < il; ++i) {
                u = structure.unitSymmetryGroups[i].units[0];
                if (_mol_model_structure_structure__WEBPACK_IMPORTED_MODULE_3__["Unit"].isAtomic(u)) {
                    secondaryStructure = _mol_model_formats_structure_property_secondary_structure__WEBPACK_IMPORTED_MODULE_5__["ModelSecondaryStructure"].Provider.get(u.model);
                    if (secondaryStructure) {
                        map.set(u.invariantId, secondaryStructure);
                    }
                }
            }
            return [2 /*return*/, map];
        });
    });
}
//# sourceMappingURL=secondary-structure.js.map

/***/ }),

/***/ "./lib/mol-model-props/computed/secondary-structure/dssp.js":
/*!******************************************************************!*\
  !*** ./lib/mol-model-props/computed/secondary-structure/dssp.js ***!
  \******************************************************************/
/*! exports provided: DSSPComputationParams, computeUnitDSSP */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DSSPComputationParams", function() { return DSSPComputationParams; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "computeUnitDSSP", function() { return computeUnitDSSP; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _mol_model_structure_model_properties_seconday_structure__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../../mol-model/structure/model/properties/seconday-structure */ "./lib/mol-model/structure/model/properties/seconday-structure.js");
/* harmony import */ var _mol_model_structure_model_types__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../../mol-model/structure/model/types */ "./lib/mol-model/structure/model/types.js");
/* harmony import */ var _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../../mol-util/param-definition */ "./lib/mol-util/param-definition.js");
/* harmony import */ var _dssp_bends__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./dssp/bends */ "./lib/mol-model-props/computed/secondary-structure/dssp/bends.js");
/* harmony import */ var _dssp_backbone_hbonds__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./dssp/backbone-hbonds */ "./lib/mol-model-props/computed/secondary-structure/dssp/backbone-hbonds.js");
/* harmony import */ var _dssp_common__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ./dssp/common */ "./lib/mol-model-props/computed/secondary-structure/dssp/common.js");
/* harmony import */ var _dssp_turns__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ./dssp/turns */ "./lib/mol-model-props/computed/secondary-structure/dssp/turns.js");
/* harmony import */ var _dssp_helices__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ./dssp/helices */ "./lib/mol-model-props/computed/secondary-structure/dssp/helices.js");
/* harmony import */ var _dssp_ladders__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ./dssp/ladders */ "./lib/mol-model-props/computed/secondary-structure/dssp/ladders.js");
/* harmony import */ var _dssp_bridges__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ./dssp/bridges */ "./lib/mol-model-props/computed/secondary-structure/dssp/bridges.js");
/* harmony import */ var _dssp_sheets__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ./dssp/sheets */ "./lib/mol-model-props/computed/secondary-structure/dssp/sheets.js");
/* harmony import */ var _dssp_dihedral_angles__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! ./dssp/dihedral-angles */ "./lib/mol-model-props/computed/secondary-structure/dssp/dihedral-angles.js");
/* harmony import */ var _dssp_trace_lookup__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! ./dssp/trace-lookup */ "./lib/mol-model-props/computed/secondary-structure/dssp/trace-lookup.js");
/* harmony import */ var _dssp_protein_info__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! ./dssp/protein-info */ "./lib/mol-model-props/computed/secondary-structure/dssp/protein-info.js");
/* harmony import */ var _mol_data_int__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! ../../../mol-data/int */ "./lib/mol-data/int.js");
/**
 * Copyright (c) 2019 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 * @author Sebastian Bittrich <sebastian.bittrich@rcsb.org>
 */
















/**
 * TODO bugs to fix:
 * - some turns are not detected correctly: see e.g. pdb:1acj - maybe more than 2 hbonds require some residue to donate electrons
 * - some sheets are not extended correctly: see e.g. pdb:1acj
 * - validate new helix definition
 * - validate new ordering of secondary structure elements
 */
var DSSPComputationParams = {
    oldDefinition: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_3__["ParamDefinition"].Boolean(true, { description: 'Whether to use the old DSSP convention for the annotation of turns and helices, causes them to be two residues shorter' }),
    oldOrdering: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_3__["ParamDefinition"].Boolean(true, { description: 'Alpha-helices are preferred over 3-10 helices' })
};
function computeUnitDSSP(unit, params) {
    return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"])(this, void 0, void 0, function () {
        var proteinInfo, residueIndices, lookup3d, hbonds, residueCount, flags, torsionAngles, ladders, bridges, getResidueFlag, getFlagName, ctx, assignment, type, keys, elements, getIndex, i, il, assign, flag;
        return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__generator"])(this, function (_a) {
            proteinInfo = Object(_dssp_protein_info__WEBPACK_IMPORTED_MODULE_14__["getUnitProteinInfo"])(unit);
            residueIndices = proteinInfo.residueIndices;
            lookup3d = Object(_dssp_trace_lookup__WEBPACK_IMPORTED_MODULE_13__["calcUnitProteinTraceLookup3D"])(unit, residueIndices);
            hbonds = Object(_dssp_backbone_hbonds__WEBPACK_IMPORTED_MODULE_5__["calcUnitBackboneHbonds"])(unit, proteinInfo, lookup3d);
            residueCount = residueIndices.length;
            flags = new Uint32Array(residueCount);
            torsionAngles = Object(_dssp_dihedral_angles__WEBPACK_IMPORTED_MODULE_12__["calculateUnitDihedralAngles"])(unit, proteinInfo);
            ladders = [];
            bridges = [];
            getResidueFlag = params.oldDefinition ? getOriginalResidueFlag : getUpdatedResidueFlag;
            getFlagName = params.oldOrdering ? getOriginalFlagName : getUpdatedFlagName;
            ctx = {
                params: params,
                getResidueFlag: getResidueFlag,
                getFlagName: getFlagName,
                unit: unit,
                proteinInfo: proteinInfo,
                flags: flags,
                hbonds: hbonds,
                torsionAngles: torsionAngles,
                ladders: ladders,
                bridges: bridges
            };
            Object(_dssp_turns__WEBPACK_IMPORTED_MODULE_7__["assignTurns"])(ctx);
            Object(_dssp_helices__WEBPACK_IMPORTED_MODULE_8__["assignHelices"])(ctx);
            Object(_dssp_bends__WEBPACK_IMPORTED_MODULE_4__["assignBends"])(ctx);
            Object(_dssp_bridges__WEBPACK_IMPORTED_MODULE_10__["assignBridges"])(ctx);
            Object(_dssp_ladders__WEBPACK_IMPORTED_MODULE_9__["assignLadders"])(ctx);
            Object(_dssp_sheets__WEBPACK_IMPORTED_MODULE_11__["assignSheets"])(ctx);
            assignment = getDSSPAssignment(flags, getResidueFlag);
            type = new Uint32Array(residueCount);
            keys = [];
            elements = [];
            getIndex = function (rI) { return _mol_data_int__WEBPACK_IMPORTED_MODULE_15__["SortedArray"].indexOf(residueIndices, rI); };
            for (i = 0, il = residueIndices.length; i < il; ++i) {
                assign = assignment[i];
                type[i] = assign;
                flag = getResidueFlag(flags[i]);
                // console.log(i, SortedArray.indexOf(residueIndices, i), getFlagName(flags[i]))
                // TODO is this expected behavior? elements will be strictly split depending on 'winning' flag
                if (elements.length === 0 /* would fail at very start */ || flag !== elements[elements.length - 1].flags /* flag changed */) {
                    elements[elements.length] = createElement(mapToKind(assign), flags[i], getResidueFlag);
                }
                keys[i] = elements.length - 1;
            }
            return [2 /*return*/, Object(_mol_model_structure_model_properties_seconday_structure__WEBPACK_IMPORTED_MODULE_1__["SecondaryStructure"])(type, keys, elements, getIndex)];
        });
    });
}
function createElement(kind, flag, getResidueFlag) {
    // TODO would be nice to add more detailed information
    if (kind === 'helix') {
        return {
            kind: 'helix',
            flags: getResidueFlag(flag)
        };
    }
    else if (kind === 'sheet') {
        return {
            kind: 'sheet',
            flags: getResidueFlag(flag)
        };
    }
    else if (kind === 'turn' || kind === 'bend') {
        return {
            kind: 'turn',
            flags: getResidueFlag(flag)
        };
    }
    else {
        return {
            kind: 'none'
        };
    }
}
function mapToKind(assignment) {
    if (assignment === _mol_model_structure_model_types__WEBPACK_IMPORTED_MODULE_2__["SecondaryStructureType"].SecondaryStructureDssp.H || assignment === _mol_model_structure_model_types__WEBPACK_IMPORTED_MODULE_2__["SecondaryStructureType"].SecondaryStructureDssp.G || assignment === _mol_model_structure_model_types__WEBPACK_IMPORTED_MODULE_2__["SecondaryStructureType"].SecondaryStructureDssp.I) {
        return 'helix';
    }
    else if (assignment === _mol_model_structure_model_types__WEBPACK_IMPORTED_MODULE_2__["SecondaryStructureType"].SecondaryStructureDssp.B || assignment === _mol_model_structure_model_types__WEBPACK_IMPORTED_MODULE_2__["SecondaryStructureType"].SecondaryStructureDssp.E) {
        return 'sheet';
    }
    else if (assignment === _mol_model_structure_model_types__WEBPACK_IMPORTED_MODULE_2__["SecondaryStructureType"].SecondaryStructureDssp.T) {
        return 'turn';
    }
    else if (assignment === _mol_model_structure_model_types__WEBPACK_IMPORTED_MODULE_2__["SecondaryStructureType"].SecondaryStructureDssp.S) {
        return 'bend';
    }
    else {
        return 'none';
    }
}
/** Original priority: H,B,E,G,I,T,S */
function getOriginalResidueFlag(f) {
    if (_dssp_common__WEBPACK_IMPORTED_MODULE_6__["DSSPType"].is(f, 1 /* H */))
        return _mol_model_structure_model_types__WEBPACK_IMPORTED_MODULE_2__["SecondaryStructureType"].SecondaryStructureDssp.H;
    if (_dssp_common__WEBPACK_IMPORTED_MODULE_6__["DSSPType"].is(f, 4 /* E */))
        return _mol_model_structure_model_types__WEBPACK_IMPORTED_MODULE_2__["SecondaryStructureType"].SecondaryStructureDssp.E;
    if (_dssp_common__WEBPACK_IMPORTED_MODULE_6__["DSSPType"].is(f, 2 /* B */))
        return _mol_model_structure_model_types__WEBPACK_IMPORTED_MODULE_2__["SecondaryStructureType"].SecondaryStructureDssp.B;
    if (_dssp_common__WEBPACK_IMPORTED_MODULE_6__["DSSPType"].is(f, 8 /* G */))
        return _mol_model_structure_model_types__WEBPACK_IMPORTED_MODULE_2__["SecondaryStructureType"].SecondaryStructureDssp.G;
    if (_dssp_common__WEBPACK_IMPORTED_MODULE_6__["DSSPType"].is(f, 16 /* I */))
        return _mol_model_structure_model_types__WEBPACK_IMPORTED_MODULE_2__["SecondaryStructureType"].SecondaryStructureDssp.I;
    if (_dssp_common__WEBPACK_IMPORTED_MODULE_6__["DSSPType"].is(f, 64 /* T */))
        return _mol_model_structure_model_types__WEBPACK_IMPORTED_MODULE_2__["SecondaryStructureType"].SecondaryStructureDssp.T;
    if (_dssp_common__WEBPACK_IMPORTED_MODULE_6__["DSSPType"].is(f, 32 /* S */))
        return _mol_model_structure_model_types__WEBPACK_IMPORTED_MODULE_2__["SecondaryStructureType"].SecondaryStructureDssp.S;
    return 0 /* None */;
}
function getOriginalFlagName(f) {
    if (_dssp_common__WEBPACK_IMPORTED_MODULE_6__["DSSPType"].is(f, 1 /* H */))
        return 'H';
    if (_dssp_common__WEBPACK_IMPORTED_MODULE_6__["DSSPType"].is(f, 4 /* E */))
        return 'E';
    if (_dssp_common__WEBPACK_IMPORTED_MODULE_6__["DSSPType"].is(f, 2 /* B */))
        return 'B';
    if (_dssp_common__WEBPACK_IMPORTED_MODULE_6__["DSSPType"].is(f, 8 /* G */))
        return 'G';
    if (_dssp_common__WEBPACK_IMPORTED_MODULE_6__["DSSPType"].is(f, 16 /* I */))
        return 'I';
    if (_dssp_common__WEBPACK_IMPORTED_MODULE_6__["DSSPType"].is(f, 64 /* T */))
        return 'T';
    if (_dssp_common__WEBPACK_IMPORTED_MODULE_6__["DSSPType"].is(f, 32 /* S */))
        return 'S';
    return '-';
}
/** Version 2.1.0 priority: I,H,B,E,G,T,S */
function getUpdatedResidueFlag(f) {
    if (_dssp_common__WEBPACK_IMPORTED_MODULE_6__["DSSPType"].is(f, 16 /* I */))
        return _mol_model_structure_model_types__WEBPACK_IMPORTED_MODULE_2__["SecondaryStructureType"].SecondaryStructureDssp.I;
    if (_dssp_common__WEBPACK_IMPORTED_MODULE_6__["DSSPType"].is(f, 1 /* H */))
        return _mol_model_structure_model_types__WEBPACK_IMPORTED_MODULE_2__["SecondaryStructureType"].SecondaryStructureDssp.H;
    if (_dssp_common__WEBPACK_IMPORTED_MODULE_6__["DSSPType"].is(f, 4 /* E */))
        return _mol_model_structure_model_types__WEBPACK_IMPORTED_MODULE_2__["SecondaryStructureType"].SecondaryStructureDssp.E;
    if (_dssp_common__WEBPACK_IMPORTED_MODULE_6__["DSSPType"].is(f, 2 /* B */))
        return _mol_model_structure_model_types__WEBPACK_IMPORTED_MODULE_2__["SecondaryStructureType"].SecondaryStructureDssp.B;
    if (_dssp_common__WEBPACK_IMPORTED_MODULE_6__["DSSPType"].is(f, 8 /* G */))
        return _mol_model_structure_model_types__WEBPACK_IMPORTED_MODULE_2__["SecondaryStructureType"].SecondaryStructureDssp.G;
    if (_dssp_common__WEBPACK_IMPORTED_MODULE_6__["DSSPType"].is(f, 64 /* T */))
        return _mol_model_structure_model_types__WEBPACK_IMPORTED_MODULE_2__["SecondaryStructureType"].SecondaryStructureDssp.T;
    if (_dssp_common__WEBPACK_IMPORTED_MODULE_6__["DSSPType"].is(f, 32 /* S */))
        return _mol_model_structure_model_types__WEBPACK_IMPORTED_MODULE_2__["SecondaryStructureType"].SecondaryStructureDssp.S;
    return 0 /* None */;
}
function getUpdatedFlagName(f) {
    if (_dssp_common__WEBPACK_IMPORTED_MODULE_6__["DSSPType"].is(f, 16 /* I */))
        return 'I';
    if (_dssp_common__WEBPACK_IMPORTED_MODULE_6__["DSSPType"].is(f, 1 /* H */))
        return 'H';
    if (_dssp_common__WEBPACK_IMPORTED_MODULE_6__["DSSPType"].is(f, 4 /* E */))
        return 'E';
    if (_dssp_common__WEBPACK_IMPORTED_MODULE_6__["DSSPType"].is(f, 2 /* B */))
        return 'B';
    if (_dssp_common__WEBPACK_IMPORTED_MODULE_6__["DSSPType"].is(f, 8 /* G */))
        return 'G';
    if (_dssp_common__WEBPACK_IMPORTED_MODULE_6__["DSSPType"].is(f, 64 /* T */))
        return 'T';
    if (_dssp_common__WEBPACK_IMPORTED_MODULE_6__["DSSPType"].is(f, 32 /* S */))
        return 'S';
    return '-';
}
function getDSSPAssignment(flags, getResidueFlag) {
    var type = new Uint32Array(flags.length);
    for (var i = 0, il = flags.length; i < il; ++i) {
        var f = _dssp_common__WEBPACK_IMPORTED_MODULE_6__["DSSPType"].create(flags[i]);
        type[i] = getResidueFlag(f);
    }
    return type;
}
//# sourceMappingURL=dssp.js.map

/***/ }),

/***/ "./lib/mol-model-props/computed/secondary-structure/dssp/backbone-hbonds.js":
/*!**********************************************************************************!*\
  !*** ./lib/mol-model-props/computed/secondary-structure/dssp/backbone-hbonds.js ***!
  \**********************************************************************************/
/*! exports provided: calcUnitBackboneHbonds */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "calcUnitBackboneHbonds", function() { return calcUnitBackboneHbonds; });
/* harmony import */ var _mol_math_graph__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../../../mol-math/graph */ "./lib/mol-math/graph.js");
/* harmony import */ var _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../../../mol-math/linear-algebra */ "./lib/mol-math/linear-algebra.js");
/**
 * Copyright (c) 2019 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 * @author Sebastian Bittrich <sebastian.bittrich@rcsb.org>
 */


/** max distance between two C-alpha atoms to check for hbond */
var caMaxDist = 9.0;
/**
 * Constant for electrostatic energy in kcal/mol
 *      f  *  q1 *   q2
 * Q = -332 * 0.42 * 0.20
 *
 * f is the dimensional factor
 *
 * q1 and q2 are partial charges which are placed on the C,O
 * (+q1,-q1) and N,H (-q2,+q2)
 */
var Q = -27.888;
/** cutoff for hbonds in kcal/mol, must be lower to be consider as an hbond */
var hbondEnergyCutoff = -0.5;
/** prevent extremely low hbond energies */
var hbondEnergyMinimal = -9.9;
/**
 * E = Q * (1/r(ON) + l/r(CH) - l/r(OH) - l/r(CN))
 */
function calcHbondEnergy(oPos, cPos, nPos, hPos) {
    var distOH = _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_1__["Vec3"].distance(oPos, hPos);
    var distCH = _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_1__["Vec3"].distance(cPos, hPos);
    var distCN = _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_1__["Vec3"].distance(cPos, nPos);
    var distON = _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_1__["Vec3"].distance(oPos, nPos);
    var e1 = Q / distOH - Q / distCH;
    var e2 = Q / distCN - Q / distON;
    var e = e1 + e2;
    // cap lowest possible energy
    if (e < hbondEnergyMinimal)
        return hbondEnergyMinimal;
    return e;
}
function calcUnitBackboneHbonds(unit, proteinInfo, lookup3d) {
    var residueIndices = proteinInfo.residueIndices, cIndices = proteinInfo.cIndices, hIndices = proteinInfo.hIndices, nIndices = proteinInfo.nIndices, oIndices = proteinInfo.oIndices;
    var index = unit.model.atomicHierarchy.index;
    var invariantPosition = unit.conformation.invariantPosition;
    var traceElementIndex = unit.model.atomicHierarchy.derived.residue.traceElementIndex;
    var residueCount = residueIndices.length;
    var oAtomResidues = [];
    var nAtomResidues = [];
    var energies = [];
    var oPos = Object(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_1__["Vec3"])();
    var cPos = Object(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_1__["Vec3"])();
    var caPos = Object(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_1__["Vec3"])();
    var nPos = Object(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_1__["Vec3"])();
    var hPos = Object(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_1__["Vec3"])();
    var cPosPrev = Object(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_1__["Vec3"])();
    var oPosPrev = Object(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_1__["Vec3"])();
    for (var i = 0, il = residueIndices.length; i < il; ++i) {
        var oPI = i;
        var oRI = residueIndices[i];
        var oAtom = oIndices[oPI];
        var cAtom = cIndices[oPI];
        var caAtom = traceElementIndex[oRI];
        // continue if residue is missing O or C atom
        if (oAtom === -1 || cAtom === -1)
            continue;
        // ignore C-terminal residue as acceptor
        if (index.findAtomOnResidue(oRI, 'OXT') !== -1)
            continue;
        invariantPosition(oAtom, oPos);
        invariantPosition(cAtom, cPos);
        invariantPosition(caAtom, caPos);
        var _a = lookup3d.find(caPos[0], caPos[1], caPos[2], caMaxDist), indices = _a.indices, count = _a.count;
        for (var j = 0; j < count; ++j) {
            var nPI = indices[j];
            // ignore bonds within a residue or to prev or next residue
            if (nPI === oPI || nPI - 1 === oPI || nPI + 1 === oPI)
                continue;
            var nAtom = nIndices[nPI];
            if (nAtom === -1)
                continue;
            invariantPosition(nAtom, nPos);
            var hAtom = hIndices[nPI];
            if (hAtom === -1) {
                // approximate calculation of H position, TODO factor out
                if (nPI === 0)
                    continue;
                var nPIprev = nPI - 1;
                var oAtomPrev = oIndices[nPIprev];
                var cAtomPrev = cIndices[nPIprev];
                if (oAtomPrev === -1 || cAtomPrev === -1)
                    continue;
                invariantPosition(oAtomPrev, oPosPrev);
                invariantPosition(cAtomPrev, cPosPrev);
                _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_1__["Vec3"].sub(hPos, cPosPrev, oPosPrev);
                var dist = _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_1__["Vec3"].distance(oPosPrev, cPosPrev);
                _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_1__["Vec3"].scaleAndAdd(hPos, nPos, hPos, 1 / dist);
            }
            else {
                invariantPosition(hAtom, hPos);
            }
            var e = calcHbondEnergy(oPos, cPos, nPos, hPos);
            if (e > hbondEnergyCutoff)
                continue;
            oAtomResidues[oAtomResidues.length] = oPI;
            nAtomResidues[nAtomResidues.length] = nPI;
            energies[energies.length] = e;
        }
    }
    return buildHbondGraph(residueCount, oAtomResidues, nAtomResidues, energies);
}
function buildHbondGraph(residueCount, oAtomResidues, nAtomResidues, energies) {
    var builder = new _mol_math_graph__WEBPACK_IMPORTED_MODULE_0__["IntAdjacencyGraph"].DirectedEdgeBuilder(residueCount, oAtomResidues, nAtomResidues);
    var _energies = new Float32Array(builder.slotCount);
    for (var i = 0, _i = builder.edgeCount; i < _i; i++) {
        builder.addNextEdge();
        builder.assignProperty(_energies, energies[i]);
    }
    return builder.createGraph({ energies: energies });
}
//# sourceMappingURL=backbone-hbonds.js.map

/***/ }),

/***/ "./lib/mol-model-props/computed/secondary-structure/dssp/bends.js":
/*!************************************************************************!*\
  !*** ./lib/mol-model-props/computed/secondary-structure/dssp/bends.js ***!
  \************************************************************************/
/*! exports provided: assignBends */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "assignBends", function() { return assignBends; });
/* harmony import */ var _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../../../mol-math/linear-algebra */ "./lib/mol-math/linear-algebra.js");
/* harmony import */ var _mol_math_misc__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../../../mol-math/misc */ "./lib/mol-math/misc.js");
/**
 * Copyright (c) 2019 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 * @author Sebastian Bittrich <sebastian.bittrich@rcsb.org>
 */


/**
 * Bend(i) =: [angle ((CW - Ca(i - 2)),(C"(i + 2) - C"(i))) > 70"]
 *
 * Type: S
 */
function assignBends(ctx) {
    var unit = ctx.unit, flags = ctx.flags, proteinInfo = ctx.proteinInfo;
    var position = unit.conformation.position;
    var traceElementIndex = unit.model.atomicHierarchy.derived.residue.traceElementIndex;
    var residueIndices = proteinInfo.residueIndices, nIndices = proteinInfo.nIndices;
    var residueCount = residueIndices.length;
    // const position = (i: number, v: Vec3) => Vec3.set(v, x[i], y[i], z[i])
    var p = function (i, v) { return i === -1 ? _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"].setNaN(v) : position(i, v); };
    var caPosPrev2 = Object(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"])();
    var caPos = Object(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"])();
    var caPosNext2 = Object(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"])();
    var cPos = Object(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"])();
    var nPosNext = Object(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"])();
    var caMinus2 = Object(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"])();
    var caPlus2 = Object(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"])();
    f1: for (var i = 2; i < residueCount - 2; i++) {
        // check for peptide bond
        for (var k = 0; k < 4; k++) {
            var index = i + k - 2;
            p(traceElementIndex[index], cPos);
            p(nIndices[index + 1], nPosNext);
            if (_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"].squaredDistance(cPos, nPosNext) > 6.25 /* max squared peptide bond distance allowed */) {
                continue f1;
            }
        }
        var oRIprev2 = residueIndices[i - 2];
        var oRI = residueIndices[i];
        var oRInext2 = residueIndices[i + 2];
        var caAtomPrev2 = traceElementIndex[oRIprev2];
        var caAtom = traceElementIndex[oRI];
        var caAtomNext2 = traceElementIndex[oRInext2];
        p(caAtomPrev2, caPosPrev2);
        p(caAtom, caPos);
        p(caAtomNext2, caPosNext2);
        _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"].sub(caMinus2, caPosPrev2, caPos);
        _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"].sub(caPlus2, caPos, caPosNext2);
        var angle = Object(_mol_math_misc__WEBPACK_IMPORTED_MODULE_1__["radToDeg"])(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"].angle(caMinus2, caPlus2));
        if (angle && angle > 70.00) {
            flags[i] |= 32 /* S */;
        }
    }
}
//# sourceMappingURL=bends.js.map

/***/ }),

/***/ "./lib/mol-model-props/computed/secondary-structure/dssp/bridges.js":
/*!**************************************************************************!*\
  !*** ./lib/mol-model-props/computed/secondary-structure/dssp/bridges.js ***!
  \**************************************************************************/
/*! exports provided: assignBridges */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "assignBridges", function() { return assignBridges; });
/* harmony import */ var _common__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./common */ "./lib/mol-model-props/computed/secondary-structure/dssp/common.js");
/**
 * Copyright (c) 2019 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 * @author Sebastian Bittrich <sebastian.bittrich@rcsb.org>
 */

/**
 * Two nonoverlapping stretches of three residues each, i - 1, i, i + 1 and j - 1, j, j + 1,
 * form either a parallel or antiparallel bridge, depending on which of
 * two basic patterns is matched. We assign a bridge between residues i and j
 * if there are two H bonds characteristic of P-structure; in particular,
 *
 * Parallel Bridge(i, j) =:
 *      [Hbond(i - 1, j) and Hbond(j, i + 1)] or
 *      [Hbond(j - 1, i) and Hbond(i, j + 1)]
 *
 * Antiparallel Bridge(i, j) =:
 *      [Hbond(i, j) and Hbond(j, i)] or
 *      [Hbond(i - 1, j + 1) and Hbond(j - 1, i + l)]
 *
 * Type: B
 */
function assignBridges(ctx) {
    var proteinInfo = ctx.proteinInfo, hbonds = ctx.hbonds, flags = ctx.flags, bridges = ctx.bridges;
    var offset = hbonds.offset, b = hbonds.b;
    var i, j;
    for (var k = 0, kl = proteinInfo.residueIndices.length; k < kl; ++k) {
        for (var t = offset[k], _t = offset[k + 1]; t < _t; t++) {
            var l = b[t];
            if (k > l)
                continue;
            // Parallel Bridge(i, j) =: [Hbond(i - 1, j) and Hbond(j, i + 1)]
            i = k + 1; // k is i - 1
            j = l;
            if (i !== j && hbonds.getDirectedEdgeIndex(j, i + 1) !== -1) {
                flags[i] |= 2 /* B */;
                flags[j] |= 2 /* B */;
                // TODO move to constructor, actually omit object all together
                bridges[bridges.length] = new _common__WEBPACK_IMPORTED_MODULE_0__["Bridge"](i, j, 0 /* PARALLEL */);
            }
            // Parallel Bridge(i, j) =: [Hbond(j - 1, i) and Hbond(i, j + 1)]
            i = k;
            j = l - 1; // l is j + 1
            if (i !== j && hbonds.getDirectedEdgeIndex(j - 1, i) !== -1) {
                flags[i] |= 2 /* B */;
                flags[j] |= 2 /* B */;
                bridges[bridges.length] = new _common__WEBPACK_IMPORTED_MODULE_0__["Bridge"](j, i, 0 /* PARALLEL */);
            }
            // Antiparallel Bridge(i, j) =: [Hbond(i, j) and Hbond(j, i)]
            i = k;
            j = l;
            if (i !== j && hbonds.getDirectedEdgeIndex(j, i) !== -1) {
                flags[i] |= 2 /* B */;
                flags[j] |= 2 /* B */;
                bridges[bridges.length] = new _common__WEBPACK_IMPORTED_MODULE_0__["Bridge"](j, i, 1 /* ANTI_PARALLEL */);
            }
            // Antiparallel Bridge(i, j) =: [Hbond(i - 1, j + 1) and Hbond(j - 1, i + l)]
            i = k + 1;
            j = l - 1;
            if (i !== j && hbonds.getDirectedEdgeIndex(j - 1, i + 1) !== -1) {
                flags[i] |= 2 /* B */;
                flags[j] |= 2 /* B */;
                bridges[bridges.length] = new _common__WEBPACK_IMPORTED_MODULE_0__["Bridge"](j, i, 1 /* ANTI_PARALLEL */);
            }
        }
    }
    bridges.sort(function (a, b) { return a.partner1 > b.partner1 ? 1 : a.partner1 < b.partner1 ? -1 : 0; });
}
//# sourceMappingURL=bridges.js.map

/***/ }),

/***/ "./lib/mol-model-props/computed/secondary-structure/dssp/common.js":
/*!*************************************************************************!*\
  !*** ./lib/mol-model-props/computed/secondary-structure/dssp/common.js ***!
  \*************************************************************************/
/*! exports provided: DSSPType, Bridge */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DSSPType", function() { return DSSPType; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Bridge", function() { return Bridge; });
/* harmony import */ var _mol_util__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../../../mol-util */ "./lib/mol-util/index.js");
/**
 * Copyright (c) 2019 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 * @author Sebastian Bittrich <sebastian.bittrich@rcsb.org>
 */


var DSSPType;
(function (DSSPType) {
    DSSPType.is = _mol_util__WEBPACK_IMPORTED_MODULE_0__["BitFlags"].has;
    DSSPType.create = _mol_util__WEBPACK_IMPORTED_MODULE_0__["BitFlags"].create;
})(DSSPType || (DSSPType = {}));
var Bridge = /** @class */ (function () {
    function Bridge(p1, p2, type) {
        this.partner1 = Math.min(p1, p2);
        this.partner2 = Math.max(p1, p2);
        this.type = type;
    }
    return Bridge;
}());

//# sourceMappingURL=common.js.map

/***/ }),

/***/ "./lib/mol-model-props/computed/secondary-structure/dssp/dihedral-angles.js":
/*!**********************************************************************************!*\
  !*** ./lib/mol-model-props/computed/secondary-structure/dssp/dihedral-angles.js ***!
  \**********************************************************************************/
/*! exports provided: calculateUnitDihedralAngles */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "calculateUnitDihedralAngles", function() { return calculateUnitDihedralAngles; });
/* harmony import */ var _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../../../mol-math/linear-algebra */ "./lib/mol-math/linear-algebra.js");
/* harmony import */ var _mol_math_misc__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../../../mol-math/misc */ "./lib/mol-math/misc.js");
/**
 * Copyright (c) 2019 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 * @author Sebastian Bittrich <sebastian.bittrich@rcsb.org>
 */


function calculateUnitDihedralAngles(unit, proteinInfo) {
    var cIndices = proteinInfo.cIndices, nIndices = proteinInfo.nIndices, residueIndices = proteinInfo.residueIndices;
    var position = unit.conformation.position;
    var index = unit.model.atomicHierarchy.index;
    var traceElementIndex = unit.model.atomicHierarchy.derived.residue.traceElementIndex;
    var residueCount = residueIndices.length;
    var p = function (i, v) { return i === -1 ? _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"].setNaN(v) : position(i, v); };
    var cPosPrev = Object(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"])(), caPosPrev = Object(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"])(), nPosPrev = Object(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"])();
    var cPos = Object(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"])(), caPos = Object(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"])(), nPos = Object(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"])();
    var cPosNext = Object(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"])(), caPosNext = Object(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"])(), nPosNext = Object(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"])();
    if (residueCount === 0)
        return { phi: new Float32Array(0), psi: new Float32Array(0) };
    var phi = new Float32Array(residueCount - 1);
    var psi = new Float32Array(residueCount - 1);
    p(-1, cPosPrev);
    p(-1, caPosPrev);
    p(-1, nPosPrev);
    p(cIndices[0], cPos);
    p(traceElementIndex[residueIndices[0]], caPos);
    p(nIndices[0], nPos);
    p(cIndices[1], cPosNext);
    p(traceElementIndex[residueIndices[1]], caPosNext);
    p(nIndices[1], nPosNext);
    for (var i = 0; i < residueCount - 1; ++i) {
        // ignore C-terminal residue as acceptor
        if (index.findAtomOnResidue(residueIndices[i], 'OXT') !== -1)
            continue;
        // returns NaN for missing atoms
        phi[i] = Object(_mol_math_misc__WEBPACK_IMPORTED_MODULE_1__["radToDeg"])(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"].dihedralAngle(cPosPrev, nPos, caPos, cPos));
        psi[i] = Object(_mol_math_misc__WEBPACK_IMPORTED_MODULE_1__["radToDeg"])(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"].dihedralAngle(nPos, caPos, cPos, nPosNext));
        cPosPrev = cPos, caPosPrev = caPos, nPosPrev = nPos;
        cPos = cPosNext, caPos = caPosNext, nPos = nPosNext;
        p(cIndices[i + 1], cPosNext);
        p(traceElementIndex[residueIndices[i + 1]], caPosNext);
        p(nIndices[i + 1], nPosNext);
    }
    return { phi: phi, psi: psi };
}
//# sourceMappingURL=dihedral-angles.js.map

/***/ }),

/***/ "./lib/mol-model-props/computed/secondary-structure/dssp/helices.js":
/*!**************************************************************************!*\
  !*** ./lib/mol-model-props/computed/secondary-structure/dssp/helices.js ***!
  \**************************************************************************/
/*! exports provided: assignHelices */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "assignHelices", function() { return assignHelices; });
/* harmony import */ var _common__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./common */ "./lib/mol-model-props/computed/secondary-structure/dssp/common.js");
/**
 * Copyright (c) 2019 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 * @author Sebastian Bittrich <sebastian.bittrich@rcsb.org>
 */

/**
 * A minimal helix is defined by two consecutive n-turns.
 * For example, a 4-helix, of minimal length 4 from residues i to i + 3,
 * requires 4-turns at residues i - 1 and i,
 *
 *      3-helix(i,i + 2)=: [3-turn(i - 1) and 3-turn(i)]
 *      4-helix(i,i + 3)=: [4-turn(i - 1) and 4-turn(i)]
 *      5-helix(i,i + 4)=: [5-turn(i - 1) and 5-turn(i)]
 *
 * Type: G (n=3), H (n=4), I (n=5)
 */
function assignHelices(ctx) {
    var proteinInfo = ctx.proteinInfo, flags = ctx.flags;
    var residueCount = proteinInfo.residueIndices.length;
    var turnFlag = [1024 /* T3S */, 2048 /* T4S */, 4096 /* T5S */, 128 /* T3 */, 256 /* T4 */, 512 /* T5 */];
    var helixFlag = [0, 0, 0, 8 /* G */, 1 /* H */, 16 /* I */];
    var helixCheckOrder = ctx.params.oldOrdering ? [4, 3, 5] : [3, 4, 5];
    for (var ni = 0; ni < helixCheckOrder.length; ni++) {
        var n = helixCheckOrder[ni];
        for (var i = 1, il = residueCount - n; i < il; i++) {
            var fI = _common__WEBPACK_IMPORTED_MODULE_0__["DSSPType"].create(flags[i]);
            var fI1 = _common__WEBPACK_IMPORTED_MODULE_0__["DSSPType"].create(flags[i - 1]);
            var fI2 = _common__WEBPACK_IMPORTED_MODULE_0__["DSSPType"].create(flags[i + 1]);
            // TODO rework to elegant solution which will not break instantly
            if (ctx.params.oldOrdering) {
                if ((n === 3 && (_common__WEBPACK_IMPORTED_MODULE_0__["DSSPType"].is(fI, 1 /* H */) || _common__WEBPACK_IMPORTED_MODULE_0__["DSSPType"].is(fI2, 1 /* H */)) || // for 3-10 yield to alpha helix
                    (n === 5 && ((_common__WEBPACK_IMPORTED_MODULE_0__["DSSPType"].is(fI, 1 /* H */) || _common__WEBPACK_IMPORTED_MODULE_0__["DSSPType"].is(fI, 8 /* G */)) || (_common__WEBPACK_IMPORTED_MODULE_0__["DSSPType"].is(fI2, 1 /* H */) || _common__WEBPACK_IMPORTED_MODULE_0__["DSSPType"].is(fI2, 8 /* G */)))))) { // for pi yield to all other helices
                    continue;
                }
            }
            else {
                if ((n === 4 && (_common__WEBPACK_IMPORTED_MODULE_0__["DSSPType"].is(fI, 8 /* G */) || _common__WEBPACK_IMPORTED_MODULE_0__["DSSPType"].is(fI2, 8 /* G */)) || // for alpha helix yield to 3-10
                    (n === 5 && ((_common__WEBPACK_IMPORTED_MODULE_0__["DSSPType"].is(fI, 1 /* H */) || _common__WEBPACK_IMPORTED_MODULE_0__["DSSPType"].is(fI, 8 /* G */)) || (_common__WEBPACK_IMPORTED_MODULE_0__["DSSPType"].is(fI2, 1 /* H */) || _common__WEBPACK_IMPORTED_MODULE_0__["DSSPType"].is(fI2, 8 /* G */)))))) { // for pi yield to all other helices
                    continue;
                }
            }
            if (_common__WEBPACK_IMPORTED_MODULE_0__["DSSPType"].is(fI, turnFlag[n]) && _common__WEBPACK_IMPORTED_MODULE_0__["DSSPType"].is(fI, turnFlag[n - 3]) && // check fI for turn start of proper type
                _common__WEBPACK_IMPORTED_MODULE_0__["DSSPType"].is(fI1, turnFlag[n]) && _common__WEBPACK_IMPORTED_MODULE_0__["DSSPType"].is(fI1, turnFlag[n - 3])) { // check fI1 accordingly
                if (ctx.params.oldDefinition) {
                    for (var k = 0; k < n; k++) {
                        flags[i + k] |= helixFlag[n];
                    }
                }
                else {
                    for (var k = -1; k <= n; k++) {
                        flags[i + k] |= helixFlag[n];
                    }
                }
            }
        }
    }
}
//# sourceMappingURL=helices.js.map

/***/ }),

/***/ "./lib/mol-model-props/computed/secondary-structure/dssp/ladders.js":
/*!**************************************************************************!*\
  !*** ./lib/mol-model-props/computed/secondary-structure/dssp/ladders.js ***!
  \**************************************************************************/
/*! exports provided: assignLadders */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "assignLadders", function() { return assignLadders; });
/**
 * Copyright (c) 2019 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 * @author Sebastian Bittrich <sebastian.bittrich@rcsb.org>
 */
function shouldExtendLadder(ladder, bridge) {
    // in order to extend ladders, same type must be present
    if (bridge.type !== ladder.type)
        return false;
    // only extend if residue 1 is sequence neighbor with regard to ladder
    if (bridge.partner1 !== ladder.firstEnd + 1)
        return false;
    if (bridge.type === 0 /* PARALLEL */) {
        if (bridge.partner2 === ladder.secondEnd + 1) {
            return true;
        }
    }
    else {
        if (bridge.partner2 === ladder.secondStart - 1) {
            return true;
        }
    }
    return false;
}
/**
 * For beta structures, we define: a bulge-linked ladder consists of two ladders or bridges of the same type
 * connected by at most one extra residue of one strand and at most four extra residues  on the other strand,
 * all residues in bulge-linked ladders are marked E, including any extra residues.
 */
function resemblesBulge(ladder1, ladder2) {
    if (!(ladder1.type === ladder2.type && ladder2.firstStart - ladder1.firstEnd < 6 &&
        ladder1.firstStart < ladder2.firstStart && ladder2.nextLadder === 0))
        return false;
    if (ladder1.type === 0 /* PARALLEL */) {
        return bulgeCriterion2(ladder1, ladder2);
    }
    else {
        return bulgeCriterion2(ladder2, ladder1);
    }
}
function bulgeCriterion2(ladder1, ladder2) {
    return ladder2.secondStart - ladder1.secondEnd > 0 && ((ladder2.secondStart - ladder1.secondEnd < 6 &&
        ladder2.firstStart - ladder1.firstEnd < 3) || ladder2.secondStart - ladder1.secondEnd < 3);
}
/**
 * ladder=: set of one or more consecutive bridges of identical type
 *
 * Type: E
 */
function assignLadders(ctx) {
    var bridges = ctx.bridges, ladders = ctx.ladders;
    // create ladders
    for (var bridgeIndex = 0; bridgeIndex < bridges.length; bridgeIndex++) {
        var bridge = bridges[bridgeIndex];
        var found = false;
        for (var ladderIndex = 0; ladderIndex < ladders.length; ladderIndex++) {
            var ladder = ladders[ladderIndex];
            if (shouldExtendLadder(ladder, bridge)) {
                found = true;
                ladder.firstEnd++;
                if (bridge.type === 0 /* PARALLEL */) {
                    ladder.secondEnd++;
                }
                else {
                    ladder.secondStart--;
                }
            }
        }
        // no suitable assignment: create new ladder with single bridge as content
        if (!found) {
            ladders[ladders.length] = {
                previousLadder: 0,
                nextLadder: 0,
                firstStart: bridge.partner1,
                firstEnd: bridge.partner1,
                secondStart: bridge.partner2,
                secondEnd: bridge.partner2,
                type: bridge.type
            };
        }
    }
    // connect ladders
    for (var ladderIndex1 = 0; ladderIndex1 < ladders.length; ladderIndex1++) {
        var ladder1 = ladders[ladderIndex1];
        for (var ladderIndex2 = ladderIndex1; ladderIndex2 < ladders.length; ladderIndex2++) {
            var ladder2 = ladders[ladderIndex2];
            if (resemblesBulge(ladder1, ladder2)) {
                ladder1.nextLadder = ladderIndex2;
                ladder2.previousLadder = ladderIndex1;
            }
        }
    }
}
//# sourceMappingURL=ladders.js.map

/***/ }),

/***/ "./lib/mol-model-props/computed/secondary-structure/dssp/protein-info.js":
/*!*******************************************************************************!*\
  !*** ./lib/mol-model-props/computed/secondary-structure/dssp/protein-info.js ***!
  \*******************************************************************************/
/*! exports provided: getUnitProteinInfo */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getUnitProteinInfo", function() { return getUnitProteinInfo; });
/* harmony import */ var _mol_data_int__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../../../mol-data/int */ "./lib/mol-data/int.js");
/**
 * Copyright (c) 2019 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 * @author Sebastian Bittrich <sebastian.bittrich@rcsb.org>
 */

function getUnitProteinInfo(unit) {
    var index = unit.model.atomicHierarchy.index;
    var proteinElements = unit.proteinElements, residueIndex = unit.residueIndex;
    var residueCount = proteinElements.length;
    var unitProteinResidues = new Uint32Array(residueCount);
    var c = new Int32Array(residueCount);
    var h = new Int32Array(residueCount);
    var o = new Int32Array(residueCount);
    var n = new Int32Array(residueCount);
    for (var i = 0; i < residueCount; ++i) {
        var rI = residueIndex[proteinElements[i]];
        unitProteinResidues[i] = rI;
        c[i] = index.findAtomOnResidue(rI, 'C');
        h[i] = index.findAtomOnResidue(rI, 'H');
        o[i] = index.findAtomOnResidue(rI, 'O');
        n[i] = index.findAtomOnResidue(rI, 'N');
    }
    return {
        residueIndices: _mol_data_int__WEBPACK_IMPORTED_MODULE_0__["SortedArray"].ofSortedArray(unitProteinResidues),
        cIndices: c,
        hIndices: h,
        oIndices: o,
        nIndices: n,
    };
}
//# sourceMappingURL=protein-info.js.map

/***/ }),

/***/ "./lib/mol-model-props/computed/secondary-structure/dssp/sheets.js":
/*!*************************************************************************!*\
  !*** ./lib/mol-model-props/computed/secondary-structure/dssp/sheets.js ***!
  \*************************************************************************/
/*! exports provided: assignSheets */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "assignSheets", function() { return assignSheets; });
/* harmony import */ var _common__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./common */ "./lib/mol-model-props/computed/secondary-structure/dssp/common.js");
/**
 * Copyright (c) 2019 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 * @author Sebastian Bittrich <sebastian.bittrich@rcsb.org>
 */

function isHelixType(f) {
    return _common__WEBPACK_IMPORTED_MODULE_0__["DSSPType"].is(f, 8 /* G */) || _common__WEBPACK_IMPORTED_MODULE_0__["DSSPType"].is(f, 1 /* H */) || _common__WEBPACK_IMPORTED_MODULE_0__["DSSPType"].is(f, 16 /* I */);
}
/**
 * sheet=: set of one or more ladders connected by shared residues
 *
 * Type: E
 */
function assignSheets(ctx) {
    var ladders = ctx.ladders, flags = ctx.flags;
    for (var ladderIndex = 0; ladderIndex < ladders.length; ladderIndex++) {
        var ladder = ladders[ladderIndex];
        for (var lcount = ladder.firstStart; lcount <= ladder.firstEnd; lcount++) {
            var diff = ladder.firstStart - lcount;
            var l2count = ladder.secondStart - diff;
            if (ladder.firstStart !== ladder.firstEnd) {
                flags[lcount] |= 4 /* E */;
                flags[l2count] |= 4 /* E */;
            }
            else {
                if (!isHelixType(flags[lcount]) && _common__WEBPACK_IMPORTED_MODULE_0__["DSSPType"].is(flags[lcount], 4 /* E */)) {
                    flags[lcount] |= 2 /* B */;
                }
                if (!isHelixType(flags[l2count]) && _common__WEBPACK_IMPORTED_MODULE_0__["DSSPType"].is(flags[l2count], 4 /* E */)) {
                    flags[l2count] |= 2 /* B */;
                }
            }
        }
        if (ladder.nextLadder === 0)
            continue;
        var conladder = ladders[ladder.nextLadder];
        for (var lcount = ladder.firstStart; lcount <= conladder.firstEnd; lcount++) {
            flags[lcount] |= 4 /* E */;
        }
        if (ladder.type === 0 /* PARALLEL */) {
            for (var lcount = ladder.secondStart; lcount <= conladder.secondEnd; lcount++) {
                flags[lcount] |= 4 /* E */;
            }
        }
        else {
            for (var lcount = conladder.secondEnd; lcount <= ladder.secondStart; lcount++) {
                flags[lcount] |= 4 /* E */;
            }
        }
    }
}
//# sourceMappingURL=sheets.js.map

/***/ }),

/***/ "./lib/mol-model-props/computed/secondary-structure/dssp/trace-lookup.js":
/*!*******************************************************************************!*\
  !*** ./lib/mol-model-props/computed/secondary-structure/dssp/trace-lookup.js ***!
  \*******************************************************************************/
/*! exports provided: calcUnitProteinTraceLookup3D */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "calcUnitProteinTraceLookup3D", function() { return calcUnitProteinTraceLookup3D; });
/* harmony import */ var _mol_math_geometry__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../../../mol-math/geometry */ "./lib/mol-math/geometry.js");
/* harmony import */ var _mol_data_int__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../../../mol-data/int */ "./lib/mol-data/int.js");
/* harmony import */ var _mol_math_geometry_boundary__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../../../mol-math/geometry/boundary */ "./lib/mol-math/geometry/boundary.js");
/**
 * Copyright (c) 2019-2020 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */



function calcUnitProteinTraceLookup3D(unit, unitProteinResidues) {
    var _a = unit.model.atomicConformation, x = _a.x, y = _a.y, z = _a.z;
    var traceElementIndex = unit.model.atomicHierarchy.derived.residue.traceElementIndex;
    var indices = new Uint32Array(unitProteinResidues.length);
    for (var i = 0, il = unitProteinResidues.length; i < il; ++i) {
        indices[i] = traceElementIndex[unitProteinResidues[i]];
    }
    var position = { x: x, y: y, z: z, indices: _mol_data_int__WEBPACK_IMPORTED_MODULE_1__["SortedArray"].ofSortedArray(indices) };
    return Object(_mol_math_geometry__WEBPACK_IMPORTED_MODULE_0__["GridLookup3D"])(position, Object(_mol_math_geometry_boundary__WEBPACK_IMPORTED_MODULE_2__["getBoundary"])(position));
}
//# sourceMappingURL=trace-lookup.js.map

/***/ }),

/***/ "./lib/mol-model-props/computed/secondary-structure/dssp/turns.js":
/*!************************************************************************!*\
  !*** ./lib/mol-model-props/computed/secondary-structure/dssp/turns.js ***!
  \************************************************************************/
/*! exports provided: assignTurns */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "assignTurns", function() { return assignTurns; });
/**
 * Copyright (c) 2019 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 * @author Sebastian Bittrich <sebastian.bittrich@rcsb.org>
 */
/**
 * The basic turn pattern is a single H bond of type (i, i + n).
 * We assign an n-turn at residue i if there is an H bond from CO(i) to NH(i + n),
 * i.e., “n-turn(i)=: Hbond(i, i + n), n = 3, 4, 5.”
 *
 * Type: T
 */
function assignTurns(ctx) {
    var proteinInfo = ctx.proteinInfo, hbonds = ctx.hbonds, flags = ctx.flags;
    var turnFlag = [1024 /* T3S */, 2048 /* T4S */, 4096 /* T5S */, 128 /* T3 */, 256 /* T4 */, 512 /* T5 */];
    for (var idx = 0; idx < 3; idx++) {
        for (var i = 0, il = proteinInfo.residueIndices.length - 1; i < il; ++i) {
            // check if hbond exists
            if (hbonds.getDirectedEdgeIndex(i, i + idx + 3) !== -1) {
                flags[i] |= turnFlag[idx + 3] | turnFlag[idx];
                if (ctx.params.oldDefinition) {
                    for (var k = 1; k < idx + 3; ++k) {
                        flags[i + k] |= turnFlag[idx + 3] | 64 /* T */;
                    }
                }
                else {
                    for (var k = 0; k <= idx + 3; ++k) {
                        flags[i + k] |= turnFlag[idx + 3] | 64 /* T */;
                    }
                }
            }
        }
    }
}
//# sourceMappingURL=turns.js.map

/***/ }),

/***/ "./lib/mol-model-props/computed/themes/accessible-surface-area.js":
/*!************************************************************************!*\
  !*** ./lib/mol-model-props/computed/themes/accessible-surface-area.js ***!
  \************************************************************************/
/*! exports provided: AccessibleSurfaceAreaColorThemeParams, getAccessibleSurfaceAreaColorThemeParams, AccessibleSurfaceAreaColorTheme, AccessibleSurfaceAreaColorThemeProvider */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "AccessibleSurfaceAreaColorThemeParams", function() { return AccessibleSurfaceAreaColorThemeParams; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getAccessibleSurfaceAreaColorThemeParams", function() { return getAccessibleSurfaceAreaColorThemeParams; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "AccessibleSurfaceAreaColorTheme", function() { return AccessibleSurfaceAreaColorTheme; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "AccessibleSurfaceAreaColorThemeProvider", function() { return AccessibleSurfaceAreaColorThemeProvider; });
/* harmony import */ var _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../../mol-util/param-definition */ "./lib/mol-util/param-definition.js");
/* harmony import */ var _mol_util_color__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../../mol-util/color */ "./lib/mol-util/color/index.js");
/* harmony import */ var _mol_model_structure__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../../mol-model/structure */ "./lib/mol-model/structure.js");
/* harmony import */ var _accessible_surface_area__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../accessible-surface-area */ "./lib/mol-model-props/computed/accessible-surface-area.js");
/* harmony import */ var _accessible_surface_area_shrake_rupley__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../accessible-surface-area/shrake-rupley */ "./lib/mol-model-props/computed/accessible-surface-area/shrake-rupley.js");
/* harmony import */ var _mol_data_util__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../../mol-data/util */ "./lib/mol-data/util.js");
/**
 * Copyright (c) 2019-2020 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author Sebastian Bittrich <sebastian.bittrich@rcsb.org>
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */






var DefaultColor = Object(_mol_util_color__WEBPACK_IMPORTED_MODULE_1__["Color"])(0xFAFAFA);
var Description = 'Assigns a color based on the relative accessible surface area of a residue.';
var AccessibleSurfaceAreaColorThemeParams = {
    list: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_0__["ParamDefinition"].ColorList('rainbow', { presetKind: 'scale' })
};
function getAccessibleSurfaceAreaColorThemeParams(ctx) {
    return AccessibleSurfaceAreaColorThemeParams; // TODO return copy
}
function AccessibleSurfaceAreaColorTheme(ctx, props) {
    var color;
    var scale = _mol_util_color__WEBPACK_IMPORTED_MODULE_1__["ColorScale"].create({
        listOrName: props.list.colors,
        minLabel: 'buried',
        maxLabel: 'exposed',
        domain: [0.0, 1.0]
    });
    var accessibleSurfaceArea = ctx.structure && _accessible_surface_area__WEBPACK_IMPORTED_MODULE_3__["AccessibleSurfaceAreaProvider"].get(ctx.structure);
    var contextHash = accessibleSurfaceArea ? Object(_mol_data_util__WEBPACK_IMPORTED_MODULE_5__["hash2"])(accessibleSurfaceArea.id, accessibleSurfaceArea.version) : -1;
    if ((accessibleSurfaceArea === null || accessibleSurfaceArea === void 0 ? void 0 : accessibleSurfaceArea.value) && ctx.structure) {
        var l_1 = _mol_model_structure__WEBPACK_IMPORTED_MODULE_2__["StructureElement"].Location.create(ctx.structure);
        var asa_1 = accessibleSurfaceArea.value;
        var getColor_1 = function (location) {
            var value = _accessible_surface_area_shrake_rupley__WEBPACK_IMPORTED_MODULE_4__["AccessibleSurfaceArea"].getNormalizedValue(location, asa_1);
            return value === -1 ? DefaultColor : scale.color(value);
        };
        color = function (location) {
            if (_mol_model_structure__WEBPACK_IMPORTED_MODULE_2__["StructureElement"].Location.is(location) && _mol_model_structure__WEBPACK_IMPORTED_MODULE_2__["Unit"].isAtomic(location.unit)) {
                return getColor_1(location);
            }
            else if (_mol_model_structure__WEBPACK_IMPORTED_MODULE_2__["Bond"].isLocation(location)) {
                l_1.unit = location.aUnit;
                l_1.element = location.aUnit.elements[location.aIndex];
                return getColor_1(l_1);
            }
            return DefaultColor;
        };
    }
    else {
        color = function () { return DefaultColor; };
    }
    return {
        factory: AccessibleSurfaceAreaColorTheme,
        granularity: 'group',
        color: color,
        props: props,
        contextHash: contextHash,
        description: Description,
        legend: scale ? scale.legend : undefined
    };
}
var AccessibleSurfaceAreaColorThemeProvider = {
    name: 'accessible-surface-area',
    label: 'Accessible Surface Area',
    category: "Residue Property" /* Residue */,
    factory: AccessibleSurfaceAreaColorTheme,
    getParams: getAccessibleSurfaceAreaColorThemeParams,
    defaultValues: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_0__["ParamDefinition"].getDefaultValues(AccessibleSurfaceAreaColorThemeParams),
    isApplicable: function (ctx) { return !!ctx.structure; },
    ensureCustomProperties: {
        attach: function (ctx, data) { return data.structure ? _accessible_surface_area__WEBPACK_IMPORTED_MODULE_3__["AccessibleSurfaceAreaProvider"].attach(ctx, data.structure, void 0, true) : Promise.resolve(); },
        detach: function (data) { return data.structure && data.structure.customPropertyDescriptors.reference(_accessible_surface_area__WEBPACK_IMPORTED_MODULE_3__["AccessibleSurfaceAreaProvider"].descriptor, false); }
    }
};
//# sourceMappingURL=accessible-surface-area.js.map

/***/ }),

/***/ "./lib/mol-model-props/computed/themes/interaction-type.js":
/*!*****************************************************************!*\
  !*** ./lib/mol-model-props/computed/themes/interaction-type.js ***!
  \*****************************************************************/
/*! exports provided: InteractionTypeColorThemeParams, getInteractionTypeColorThemeParams, InteractionTypeColorTheme, InteractionTypeColorThemeProvider */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "InteractionTypeColorThemeParams", function() { return InteractionTypeColorThemeParams; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getInteractionTypeColorThemeParams", function() { return getInteractionTypeColorThemeParams; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "InteractionTypeColorTheme", function() { return InteractionTypeColorTheme; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "InteractionTypeColorThemeProvider", function() { return InteractionTypeColorThemeProvider; });
/* harmony import */ var _mol_util_color__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../../mol-util/color */ "./lib/mol-util/color/index.js");
/* harmony import */ var _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../../mol-util/param-definition */ "./lib/mol-util/param-definition.js");
/* harmony import */ var _interactions__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../interactions */ "./lib/mol-model-props/computed/interactions.js");
/* harmony import */ var _mol_util_legend__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../../mol-util/legend */ "./lib/mol-util/legend.js");
/* harmony import */ var _interactions_interactions__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../interactions/interactions */ "./lib/mol-model-props/computed/interactions/interactions.js");
/* harmony import */ var _mol_data_util__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../../mol-data/util */ "./lib/mol-data/util.js");
/**
 * Copyright (c) 2019-2020 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */






var DefaultColor = Object(_mol_util_color__WEBPACK_IMPORTED_MODULE_0__["Color"])(0xCCCCCC);
var Description = 'Assigns colors according the interaction type of a link.';
var InteractionTypeColors = Object(_mol_util_color__WEBPACK_IMPORTED_MODULE_0__["ColorMap"])({
    HydrogenBond: 0x2B83BA,
    Hydrophobic: 0x808080,
    HalogenBond: 0x40FFBF,
    Ionic: 0xF0C814,
    MetalCoordination: 0x8C4099,
    CationPi: 0xFF8000,
    PiStacking: 0x8CB366,
    WeakHydrogenBond: 0xC5DDEC,
});
var InteractionTypeColorTable = [
    ['Hydrogen Bond', InteractionTypeColors.HydrogenBond],
    ['Hydrophobic', InteractionTypeColors.Hydrophobic],
    ['Halogen Bond', InteractionTypeColors.HalogenBond],
    ['Ionic', InteractionTypeColors.Ionic],
    ['Metal Coordination', InteractionTypeColors.MetalCoordination],
    ['Cation Pi', InteractionTypeColors.CationPi],
    ['Pi Stacking', InteractionTypeColors.PiStacking],
    ['Weak HydrogenBond', InteractionTypeColors.WeakHydrogenBond],
];
function typeColor(type) {
    switch (type) {
        case 4 /* HydrogenBond */:
            return InteractionTypeColors.HydrogenBond;
        case 6 /* Hydrophobic */:
            return InteractionTypeColors.Hydrophobic;
        case 5 /* HalogenBond */:
            return InteractionTypeColors.HalogenBond;
        case 1 /* Ionic */:
            return InteractionTypeColors.Ionic;
        case 7 /* MetalCoordination */:
            return InteractionTypeColors.MetalCoordination;
        case 2 /* CationPi */:
            return InteractionTypeColors.CationPi;
        case 3 /* PiStacking */:
            return InteractionTypeColors.PiStacking;
        case 8 /* WeakHydrogenBond */:
            return InteractionTypeColors.WeakHydrogenBond;
        case 0 /* Unknown */:
            return DefaultColor;
    }
}
var InteractionTypeColorThemeParams = {};
function getInteractionTypeColorThemeParams(ctx) {
    return InteractionTypeColorThemeParams; // TODO return copy
}
function InteractionTypeColorTheme(ctx, props) {
    var color;
    var interactions = ctx.structure ? _interactions__WEBPACK_IMPORTED_MODULE_2__["InteractionsProvider"].get(ctx.structure) : undefined;
    var contextHash = interactions ? Object(_mol_data_util__WEBPACK_IMPORTED_MODULE_5__["hash2"])(interactions.id, interactions.version) : -1;
    if (interactions && interactions.value) {
        color = function (location) {
            if (_interactions_interactions__WEBPACK_IMPORTED_MODULE_4__["Interactions"].isLocation(location)) {
                var _a = location.data.interactions, unitsContacts = _a.unitsContacts, contacts = _a.contacts;
                var _b = location.element, unitA = _b.unitA, unitB = _b.unitB, indexA = _b.indexA, indexB = _b.indexB;
                if (unitA === unitB) {
                    var links = unitsContacts.get(unitA.id);
                    var idx = links.getDirectedEdgeIndex(indexA, indexB);
                    return typeColor(links.edgeProps.type[idx]);
                }
                else {
                    var idx = contacts.getEdgeIndex(indexA, unitA.id, indexB, unitB.id);
                    return typeColor(contacts.edges[idx].props.type);
                }
            }
            return DefaultColor;
        };
    }
    else {
        color = function () { return DefaultColor; };
    }
    return {
        factory: InteractionTypeColorTheme,
        granularity: 'group',
        color: color,
        props: props,
        contextHash: contextHash,
        description: Description,
        legend: Object(_mol_util_legend__WEBPACK_IMPORTED_MODULE_3__["TableLegend"])(InteractionTypeColorTable)
    };
}
var InteractionTypeColorThemeProvider = {
    name: 'interaction-type',
    label: 'Interaction Type',
    category: "Miscellaneous" /* Misc */,
    factory: InteractionTypeColorTheme,
    getParams: getInteractionTypeColorThemeParams,
    defaultValues: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_1__["ParamDefinition"].getDefaultValues(InteractionTypeColorThemeParams),
    isApplicable: function (ctx) { return !!ctx.structure; },
    ensureCustomProperties: {
        attach: function (ctx, data) { return data.structure ? _interactions__WEBPACK_IMPORTED_MODULE_2__["InteractionsProvider"].attach(ctx, data.structure, void 0, true) : Promise.resolve(); },
        detach: function (data) { return data.structure && data.structure.customPropertyDescriptors.reference(_interactions__WEBPACK_IMPORTED_MODULE_2__["InteractionsProvider"].descriptor, false); }
    }
};
//# sourceMappingURL=interaction-type.js.map

/***/ }),

/***/ "./lib/mol-model-props/computed/valence-model.js":
/*!*******************************************************!*\
  !*** ./lib/mol-model-props/computed/valence-model.js ***!
  \*******************************************************/
/*! exports provided: ValenceModelParams, ValenceModelProvider */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ValenceModelParams", function() { return ValenceModelParams; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ValenceModelProvider", function() { return ValenceModelProvider; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../mol-util/param-definition */ "./lib/mol-util/param-definition.js");
/* harmony import */ var _chemistry_valence_model__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./chemistry/valence-model */ "./lib/mol-model-props/computed/chemistry/valence-model.js");
/* harmony import */ var _common_custom_structure_property__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../common/custom-structure-property */ "./lib/mol-model-props/common/custom-structure-property.js");
/* harmony import */ var _mol_model_custom_property__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../mol-model/custom-property */ "./lib/mol-model/custom-property.js");
/**
 * Copyright (c) 2019 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */





var ValenceModelParams = Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, _chemistry_valence_model__WEBPACK_IMPORTED_MODULE_2__["ValenceModelParams"]);
var ValenceModelProvider = _common_custom_structure_property__WEBPACK_IMPORTED_MODULE_3__["CustomStructureProperty"].createProvider({
    label: 'Valence Model',
    descriptor: Object(_mol_model_custom_property__WEBPACK_IMPORTED_MODULE_4__["CustomPropertyDescriptor"])({
        name: 'molstar_computed_valence_model',
    }),
    type: 'local',
    defaultParams: ValenceModelParams,
    getParams: function (data) { return ValenceModelParams; },
    isApplicable: function (data) { return true; },
    obtain: function (ctx, data, props) { return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"])(void 0, void 0, void 0, function () {
        var p;
        var _a;
        return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__generator"])(this, function (_b) {
            switch (_b.label) {
                case 0:
                    p = Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_1__["ParamDefinition"].getDefaultValues(ValenceModelParams)), props);
                    _a = {};
                    return [4 /*yield*/, Object(_chemistry_valence_model__WEBPACK_IMPORTED_MODULE_2__["calcValenceModel"])(ctx.runtime, data, p)];
                case 1: return [2 /*return*/, (_a.value = _b.sent(), _a)];
            }
        });
    }); }
});
//# sourceMappingURL=valence-model.js.map

/***/ }),

/***/ "./lib/mol-model-props/integrative/cross-link-restraint/color.js":
/*!***********************************************************************!*\
  !*** ./lib/mol-model-props/integrative/cross-link-restraint/color.js ***!
  \***********************************************************************/
/*! exports provided: CrossLinkColorThemeParams, getCrossLinkColorThemeParams, CrossLinkColorTheme, CrossLinkColorThemeProvider */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CrossLinkColorThemeParams", function() { return CrossLinkColorThemeParams; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getCrossLinkColorThemeParams", function() { return getCrossLinkColorThemeParams; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CrossLinkColorTheme", function() { return CrossLinkColorTheme; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CrossLinkColorThemeProvider", function() { return CrossLinkColorThemeProvider; });
/* harmony import */ var _mol_util_color__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../../mol-util/color */ "./lib/mol-util/color/index.js");
/* harmony import */ var _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../../mol-util/param-definition */ "./lib/mol-util/param-definition.js");
/* harmony import */ var _property__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./property */ "./lib/mol-model-props/integrative/cross-link-restraint/property.js");
/**
 * Copyright (c) 2018-2020 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */



var DefaultColor = Object(_mol_util_color__WEBPACK_IMPORTED_MODULE_0__["Color"])(0xCCCCCC);
var Description = 'Colors cross-links by the deviation of the observed distance versus the modeled distance (e.g. modeled / `ihm_cross_link_restraint.distance_threshold`).';
var CrossLinkColorThemeParams = {
    domain: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_1__["ParamDefinition"].Interval([0.5, 1.5], { step: 0.01 }),
    list: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_1__["ParamDefinition"].ColorList('red-grey', { presetKind: 'scale' }),
};
function getCrossLinkColorThemeParams(ctx) {
    return CrossLinkColorThemeParams; // TODO return copy
}
function CrossLinkColorTheme(ctx, props) {
    var color;
    var scale = undefined;
    var crossLinkRestraints = ctx.structure && _property__WEBPACK_IMPORTED_MODULE_2__["CrossLinkRestraintProvider"].get(ctx.structure).value;
    if (crossLinkRestraints) {
        scale = _mol_util_color__WEBPACK_IMPORTED_MODULE_0__["ColorScale"].create({
            domain: props.domain,
            listOrName: props.list.colors
        });
        var scaleColor_1 = scale.color;
        color = function (location) {
            if (_property__WEBPACK_IMPORTED_MODULE_2__["CrossLinkRestraint"].isLocation(location)) {
                var pair = crossLinkRestraints.pairs[location.element];
                if (pair) {
                    return scaleColor_1(_property__WEBPACK_IMPORTED_MODULE_2__["CrossLinkRestraint"].distance(pair) / pair.distanceThreshold);
                }
            }
            return DefaultColor;
        };
    }
    else {
        color = function () { return DefaultColor; };
    }
    return {
        factory: CrossLinkColorTheme,
        granularity: 'group',
        color: color,
        props: props,
        description: Description,
        legend: scale ? scale.legend : undefined
    };
}
var CrossLinkColorThemeProvider = {
    name: 'cross-link',
    label: 'Cross Link',
    category: "Miscellaneous" /* Misc */,
    factory: CrossLinkColorTheme,
    getParams: getCrossLinkColorThemeParams,
    defaultValues: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_1__["ParamDefinition"].getDefaultValues(CrossLinkColorThemeParams),
    isApplicable: function (ctx) { return !!ctx.structure && _property__WEBPACK_IMPORTED_MODULE_2__["CrossLinkRestraint"].isApplicable(ctx.structure); },
    ensureCustomProperties: {
        attach: function (ctx, data) { return data.structure ? _property__WEBPACK_IMPORTED_MODULE_2__["CrossLinkRestraintProvider"].attach(ctx, data.structure, void 0, true) : Promise.resolve(); },
        detach: function (data) { return data.structure && data.structure.customPropertyDescriptors.reference(_property__WEBPACK_IMPORTED_MODULE_2__["CrossLinkRestraintProvider"].descriptor, false); }
    }
};
//# sourceMappingURL=color.js.map

/***/ }),

/***/ "./lib/mol-model-props/integrative/cross-link-restraint/format.js":
/*!************************************************************************!*\
  !*** ./lib/mol-model-props/integrative/cross-link-restraint/format.js ***!
  \************************************************************************/
/*! exports provided: ModelCrossLinkRestraint */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ModelCrossLinkRestraint", function() { return ModelCrossLinkRestraint; });
/* harmony import */ var _mol_model_formats_structure_common_property__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../../mol-model-formats/structure/common/property */ "./lib/mol-model-formats/structure/common/property.js");
/**
 * Copyright (c) 2018-2020 Mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */


var ModelCrossLinkRestraint;
(function (ModelCrossLinkRestraint) {
    ModelCrossLinkRestraint.Descriptor = {
        name: 'ihm_cross_link_restraint',
    };
    ModelCrossLinkRestraint.Provider = _mol_model_formats_structure_common_property__WEBPACK_IMPORTED_MODULE_0__["FormatPropertyProvider"].create(ModelCrossLinkRestraint.Descriptor);
    function fromTable(table, model) {
        var p1 = {
            entity_id: table.entity_id_1,
            asym_id: table.asym_id_1,
            seq_id: table.seq_id_1,
            atom_id: table.atom_id_1,
        };
        var p2 = {
            entity_id: table.entity_id_2,
            asym_id: table.asym_id_2,
            seq_id: table.seq_id_2,
            atom_id: table.atom_id_2,
        };
        function _add(map, element, row) {
            var indices = map.get(element);
            if (indices)
                indices.push(row);
            else
                map.set(element, [row]);
        }
        function add(row, ps) {
            var entityId = ps.entity_id.value(row);
            var asymId = ps.asym_id.value(row);
            var seqId = ps.seq_id.value(row);
            if (table.model_granularity.value(row) === 'by-atom') {
                var atomicElement = model.atomicHierarchy.index.findAtom({
                    auth_seq_id: seqId,
                    label_asym_id: asymId,
                    label_atom_id: ps.atom_id.value(row),
                    label_entity_id: entityId,
                });
                if (atomicElement >= 0)
                    _add(atomicElementMap, atomicElement, row);
            }
            else if (model.coarseHierarchy.isDefined) {
                var sphereElement = model.coarseHierarchy.spheres.findSequenceKey(entityId, asymId, seqId);
                if (sphereElement >= 0) {
                    _add(sphereElementMap, sphereElement, row);
                }
                else {
                    var gaussianElement = model.coarseHierarchy.gaussians.findSequenceKey(entityId, asymId, seqId);
                    if (gaussianElement >= 0)
                        _add(gaussianElementMap, gaussianElement, row);
                }
            }
        }
        function getMapByKind(kind) {
            switch (kind) {
                case 0 /* Atomic */: return atomicElementMap;
                case 1 /* Spheres */: return sphereElementMap;
                case 2 /* Gaussians */: return gaussianElementMap;
            }
        }
        /** map from atomic element to cross link indices */
        var atomicElementMap = new Map();
        /** map from sphere element to cross link indices */
        var sphereElementMap = new Map();
        /** map from gaussian element to cross link indices */
        var gaussianElementMap = new Map();
        var emptyIndexArray = [];
        for (var i = 0; i < table._rowCount; ++i) {
            add(i, p1);
            add(i, p2);
        }
        return {
            getIndicesByElement: function (element, kind) {
                var map = getMapByKind(kind);
                var idx = map.get(element);
                return idx !== undefined ? idx : emptyIndexArray;
            },
            data: table
        };
    }
    ModelCrossLinkRestraint.fromTable = fromTable;
})(ModelCrossLinkRestraint || (ModelCrossLinkRestraint = {}));
//# sourceMappingURL=format.js.map

/***/ }),

/***/ "./lib/mol-model-props/integrative/cross-link-restraint/property.js":
/*!**************************************************************************!*\
  !*** ./lib/mol-model-props/integrative/cross-link-restraint/property.js ***!
  \**************************************************************************/
/*! exports provided: CrossLinkRestraintProvider, CrossLinkRestraint */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CrossLinkRestraintProvider", function() { return CrossLinkRestraintProvider; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CrossLinkRestraint", function() { return CrossLinkRestraint; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _format__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./format */ "./lib/mol-model-props/integrative/cross-link-restraint/format.js");
/* harmony import */ var _mol_model_structure__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../../mol-model/structure */ "./lib/mol-model/structure.js");
/* harmony import */ var _pair_restraints__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../pair-restraints */ "./lib/mol-model-props/integrative/pair-restraints.js");
/* harmony import */ var _common_custom_structure_property__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../common/custom-structure-property */ "./lib/mol-model-props/common/custom-structure-property.js");
/* harmony import */ var _mol_model_location__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../../mol-model/location */ "./lib/mol-model/location.js");
/* harmony import */ var _mol_model_loci__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../../../mol-model/loci */ "./lib/mol-model/loci.js");
/* harmony import */ var _mol_math_geometry_centroid_helper__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../../../mol-math/geometry/centroid-helper */ "./lib/mol-math/geometry/centroid-helper.js");
/* harmony import */ var _mol_theme_label__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ../../../mol-theme/label */ "./lib/mol-theme/label.js");
/* harmony import */ var _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ../../../mol-math/linear-algebra */ "./lib/mol-math/linear-algebra.js");
/* harmony import */ var _mol_model_custom_property__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ../../../mol-model/custom-property */ "./lib/mol-model/custom-property.js");
/**
 * Copyright (c) 2018-2020 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */











var CrossLinkRestraintProvider = _common_custom_structure_property__WEBPACK_IMPORTED_MODULE_4__["CustomStructureProperty"].createProvider({
    label: 'Cross Link Restraint',
    descriptor: Object(_mol_model_custom_property__WEBPACK_IMPORTED_MODULE_10__["CustomPropertyDescriptor"])({
        name: 'integrative-cross-link-restraint',
    }),
    type: 'local',
    defaultParams: {},
    getParams: function (data) { return ({}); },
    isApplicable: function (data) { return data.models.some(function (m) { return !!_format__WEBPACK_IMPORTED_MODULE_1__["ModelCrossLinkRestraint"].Provider.get(m); }); },
    obtain: function (ctx, data, props) { return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"])(void 0, void 0, void 0, function () {
        return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__generator"])(this, function (_a) {
            return [2 /*return*/, { value: extractCrossLinkRestraints(data) }];
        });
    }); }
});

var CrossLinkRestraint;
(function (CrossLinkRestraint) {
    var Tag;
    (function (Tag) {
        Tag["CrossLinkRestraint"] = "cross-link-restraint";
    })(Tag = CrossLinkRestraint.Tag || (CrossLinkRestraint.Tag = {}));
    function isApplicable(structure) {
        return structure.models.some(function (m) { return !!_format__WEBPACK_IMPORTED_MODULE_1__["ModelCrossLinkRestraint"].Provider.get(m); });
    }
    CrossLinkRestraint.isApplicable = isApplicable;
    var distVecA = Object(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_9__["Vec3"])(), distVecB = Object(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_9__["Vec3"])();
    function distance(pair) {
        pair.unitA.conformation.position(pair.unitA.elements[pair.indexA], distVecA);
        pair.unitB.conformation.position(pair.unitB.elements[pair.indexB], distVecB);
        return _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_9__["Vec3"].distance(distVecA, distVecB);
    }
    CrossLinkRestraint.distance = distance;
    function Location(crossLinkRestraints, structure, index) {
        return Object(_mol_model_location__WEBPACK_IMPORTED_MODULE_5__["DataLocation"])('cross-link-restraints', { structure: structure, crossLinkRestraints: crossLinkRestraints }, index);
    }
    CrossLinkRestraint.Location = Location;
    function isLocation(x) {
        return !!x && x.kind === 'data-location' && x.tag === 'cross-link-restraints';
    }
    CrossLinkRestraint.isLocation = isLocation;
    function areLocationsEqual(locA, locB) {
        return (locA.data.structure === locB.data.structure &&
            locA.data.crossLinkRestraints === locB.data.crossLinkRestraints &&
            locA.element === locB.element);
    }
    CrossLinkRestraint.areLocationsEqual = areLocationsEqual;
    function _label(crossLinkRestraints, element) {
        var p = crossLinkRestraints.pairs[element];
        return "Cross Link Restraint | Type: " + p.restraintType + " | Threshold: " + p.distanceThreshold + " \u212B | Psi: " + p.psi + " | Sigma 1: " + p.sigma1 + " | Sigma 2: " + p.sigma2 + " | Distance: " + distance(p).toFixed(2) + " \u212B";
    }
    function locationLabel(location) {
        return _label(location.data.crossLinkRestraints, location.element);
    }
    CrossLinkRestraint.locationLabel = locationLabel;
    function Loci(structure, crossLinkRestraints, elements) {
        return Object(_mol_model_loci__WEBPACK_IMPORTED_MODULE_6__["DataLoci"])('cross-link-restraints', { structure: structure, crossLinkRestraints: crossLinkRestraints }, elements, function (boundingSphere) { return getBoundingSphere(crossLinkRestraints, elements, boundingSphere); }, function () { return getLabel(structure, crossLinkRestraints, elements); });
    }
    CrossLinkRestraint.Loci = Loci;
    function isLoci(x) {
        return !!x && x.kind === 'data-loci' && x.tag === 'interactions';
    }
    CrossLinkRestraint.isLoci = isLoci;
    function getBoundingSphere(crossLinkRestraints, elements, boundingSphere) {
        return _mol_math_geometry_centroid_helper__WEBPACK_IMPORTED_MODULE_7__["CentroidHelper"].fromPairProvider(elements.length, function (i, pA, pB) {
            var p = crossLinkRestraints.pairs[elements[i]];
            p.unitA.conformation.position(p.unitA.elements[p.indexA], pA);
            p.unitB.conformation.position(p.unitB.elements[p.indexB], pB);
        }, boundingSphere);
    }
    CrossLinkRestraint.getBoundingSphere = getBoundingSphere;
    function getLabel(structure, crossLinkRestraints, elements) {
        var element = elements[0];
        if (element === undefined)
            return '';
        var p = crossLinkRestraints.pairs[element];
        return [
            _label(crossLinkRestraints, element),
            Object(_mol_theme_label__WEBPACK_IMPORTED_MODULE_8__["bondLabel"])(_mol_model_structure__WEBPACK_IMPORTED_MODULE_2__["Bond"].Location(structure, p.unitA, p.indexA, structure, p.unitB, p.indexB))
        ].join('</br>');
    }
    CrossLinkRestraint.getLabel = getLabel;
})(CrossLinkRestraint || (CrossLinkRestraint = {}));
//
function _addRestraints(map, unit, restraints) {
    var elements = unit.elements;
    var elementCount = elements.length;
    var kind = unit.kind;
    var _loop_1 = function (i) {
        var e = elements[i];
        restraints.getIndicesByElement(e, kind).forEach(function (ri) { return map.set(ri, i); });
    };
    for (var i = 0; i < elementCount; i++) {
        _loop_1(i);
    }
}
function extractInter(pairs, unitA, unitB) {
    if (unitA.model !== unitB.model)
        return;
    if (unitA.model.sourceData.kind !== 'mmCIF')
        return;
    var restraints = _format__WEBPACK_IMPORTED_MODULE_1__["ModelCrossLinkRestraint"].Provider.get(unitA.model);
    if (!restraints)
        return;
    var rA = new Map();
    var rB = new Map();
    _addRestraints(rA, unitA, restraints);
    _addRestraints(rB, unitB, restraints);
    rA.forEach(function (indexA, ri) {
        var indexB = rB.get(ri);
        if (indexB !== undefined) {
            pairs.push(createCrossLinkRestraint(unitA, indexA, unitB, indexB, restraints, ri), createCrossLinkRestraint(unitB, indexB, unitA, indexA, restraints, ri));
        }
    });
}
function extractIntra(pairs, unit) {
    if (unit.model.sourceData.kind !== 'mmCIF')
        return;
    var restraints = _format__WEBPACK_IMPORTED_MODULE_1__["ModelCrossLinkRestraint"].Provider.get(unit.model);
    if (!restraints)
        return;
    var elements = unit.elements;
    var elementCount = elements.length;
    var kind = unit.kind;
    var r = new Map();
    var _loop_2 = function (i) {
        var e = elements[i];
        restraints.getIndicesByElement(e, kind).forEach(function (ri) {
            var il = r.get(ri);
            if (il)
                il.push(i);
            else
                r.set(ri, [i]);
        });
    };
    for (var i = 0; i < elementCount; i++) {
        _loop_2(i);
    }
    r.forEach(function (il, ri) {
        if (il.length < 2)
            return;
        var indexA = il[0], indexB = il[1];
        pairs.push(createCrossLinkRestraint(unit, indexA, unit, indexB, restraints, ri), createCrossLinkRestraint(unit, indexB, unit, indexA, restraints, ri));
    });
}
function createCrossLinkRestraint(unitA, indexA, unitB, indexB, restraints, row) {
    return {
        unitA: unitA, indexA: indexA, unitB: unitB, indexB: indexB,
        restraintType: restraints.data.restraint_type.value(row),
        distanceThreshold: restraints.data.distance_threshold.value(row),
        psi: restraints.data.psi.value(row),
        sigma1: restraints.data.sigma_1.value(row),
        sigma2: restraints.data.sigma_2.value(row),
    };
}
function extractCrossLinkRestraints(structure) {
    var pairs = [];
    if (!structure.models.some(function (m) { return _format__WEBPACK_IMPORTED_MODULE_1__["ModelCrossLinkRestraint"].Provider.get(m); })) {
        return new _pair_restraints__WEBPACK_IMPORTED_MODULE_3__["PairRestraints"](pairs);
    }
    var n = structure.units.length;
    for (var i = 0; i < n; ++i) {
        var unitA = structure.units[i];
        extractIntra(pairs, unitA);
        for (var j = i + 1; j < n; ++j) {
            var unitB = structure.units[j];
            if (unitA.model === unitB.model) {
                extractInter(pairs, unitA, unitB);
            }
        }
    }
    return new _pair_restraints__WEBPACK_IMPORTED_MODULE_3__["PairRestraints"](pairs);
}
//# sourceMappingURL=property.js.map

/***/ }),

/***/ "./lib/mol-model-props/integrative/cross-link-restraint/representation.js":
/*!********************************************************************************!*\
  !*** ./lib/mol-model-props/integrative/cross-link-restraint/representation.js ***!
  \********************************************************************************/
/*! exports provided: CrossLinkRestraintCylinderParams, CrossLinkRestraintVisual, CrossLinkRestraintParams, getCrossLinkRestraintParams, CrossLinkRestraintRepresentation, CrossLinkRestraintRepresentationProvider */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CrossLinkRestraintCylinderParams", function() { return CrossLinkRestraintCylinderParams; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CrossLinkRestraintVisual", function() { return CrossLinkRestraintVisual; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CrossLinkRestraintParams", function() { return CrossLinkRestraintParams; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getCrossLinkRestraintParams", function() { return getCrossLinkRestraintParams; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CrossLinkRestraintRepresentation", function() { return CrossLinkRestraintRepresentation; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CrossLinkRestraintRepresentationProvider", function() { return CrossLinkRestraintRepresentationProvider; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _mol_repr_representation__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../../mol-repr/representation */ "./lib/mol-repr/representation.js");
/* harmony import */ var _mol_geo_geometry_mesh_mesh__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../../mol-geo/geometry/mesh/mesh */ "./lib/mol-geo/geometry/mesh/mesh.js");
/* harmony import */ var _mol_geo_util_location_iterator__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../../mol-geo/util/location-iterator */ "./lib/mol-geo/util/location-iterator.js");
/* harmony import */ var _mol_model_loci__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../../mol-model/loci */ "./lib/mol-model/loci.js");
/* harmony import */ var _mol_data_int__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../../mol-data/int */ "./lib/mol-data/int.js");
/* harmony import */ var _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../../../mol-util/param-definition */ "./lib/mol-util/param-definition.js");
/* harmony import */ var _mol_model_structure__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../../../mol-model/structure */ "./lib/mol-model/structure.js");
/* harmony import */ var _mol_repr_structure_visual_util_link__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ../../../mol-repr/structure/visual/util/link */ "./lib/mol-repr/structure/visual/util/link.js");
/* harmony import */ var _mol_repr_structure_complex_visual__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ../../../mol-repr/structure/complex-visual */ "./lib/mol-repr/structure/complex-visual.js");
/* harmony import */ var _mol_repr_structure_representation__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ../../../mol-repr/structure/representation */ "./lib/mol-repr/structure/representation.js");
/* harmony import */ var _property__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ./property */ "./lib/mol-model-props/integrative/cross-link-restraint/property.js");
/**
 * Copyright (c) 2018-2020 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */












function createCrossLinkRestraintCylinderMesh(ctx, structure, theme, props, mesh) {
    var crossLinks = _property__WEBPACK_IMPORTED_MODULE_11__["CrossLinkRestraintProvider"].get(structure).value;
    if (!crossLinks.count)
        return _mol_geo_geometry_mesh_mesh__WEBPACK_IMPORTED_MODULE_2__["Mesh"].createEmpty(mesh);
    var sizeFactor = props.sizeFactor;
    var location = _mol_model_structure__WEBPACK_IMPORTED_MODULE_7__["StructureElement"].Location.create(structure);
    var builderProps = {
        linkCount: crossLinks.count,
        position: function (posA, posB, edgeIndex) {
            var b = crossLinks.pairs[edgeIndex];
            var uA = b.unitA, uB = b.unitB;
            uA.conformation.position(uA.elements[b.indexA], posA);
            uB.conformation.position(uB.elements[b.indexB], posB);
        },
        radius: function (edgeIndex) {
            var b = crossLinks.pairs[edgeIndex];
            location.unit = b.unitA;
            location.element = b.unitA.elements[b.indexA];
            return theme.size.size(location) * sizeFactor;
        },
    };
    return Object(_mol_repr_structure_visual_util_link__WEBPACK_IMPORTED_MODULE_8__["createLinkCylinderMesh"])(ctx, builderProps, props, mesh);
}
var CrossLinkRestraintCylinderParams = Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, _mol_repr_structure_complex_visual__WEBPACK_IMPORTED_MODULE_9__["ComplexMeshParams"]), _mol_repr_structure_visual_util_link__WEBPACK_IMPORTED_MODULE_8__["LinkCylinderParams"]), { sizeFactor: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_6__["ParamDefinition"].Numeric(0.5, { min: 0, max: 10, step: 0.1 }) });
function CrossLinkRestraintVisual(materialId) {
    return Object(_mol_repr_structure_complex_visual__WEBPACK_IMPORTED_MODULE_9__["ComplexMeshVisual"])({
        defaultProps: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_6__["ParamDefinition"].getDefaultValues(CrossLinkRestraintCylinderParams),
        createGeometry: createCrossLinkRestraintCylinderMesh,
        createLocationIterator: createCrossLinkRestraintIterator,
        getLoci: getLinkLoci,
        eachLocation: eachCrossLink,
        setUpdateState: function (state, newProps, currentProps) {
            state.createGeometry = (newProps.sizeFactor !== currentProps.sizeFactor ||
                newProps.radialSegments !== currentProps.radialSegments ||
                newProps.linkCap !== currentProps.linkCap);
        }
    }, materialId);
}
function createCrossLinkRestraintIterator(structure) {
    var crossLinkRestraints = _property__WEBPACK_IMPORTED_MODULE_11__["CrossLinkRestraintProvider"].get(structure).value;
    var pairs = crossLinkRestraints.pairs;
    var groupCount = pairs.length;
    var instanceCount = 1;
    var location = _property__WEBPACK_IMPORTED_MODULE_11__["CrossLinkRestraint"].Location(crossLinkRestraints, structure);
    var getLocation = function (groupIndex) {
        location.element = groupIndex;
        return location;
    };
    return Object(_mol_geo_util_location_iterator__WEBPACK_IMPORTED_MODULE_3__["LocationIterator"])(groupCount, instanceCount, 1, getLocation, true);
}
function getLinkLoci(pickingId, structure, id) {
    var objectId = pickingId.objectId, groupId = pickingId.groupId;
    if (id === objectId) {
        var crossLinkRestraints = _property__WEBPACK_IMPORTED_MODULE_11__["CrossLinkRestraintProvider"].get(structure).value;
        var pair = crossLinkRestraints.pairs[groupId];
        if (pair) {
            return _property__WEBPACK_IMPORTED_MODULE_11__["CrossLinkRestraint"].Loci(structure, crossLinkRestraints, [groupId]);
        }
    }
    return _mol_model_loci__WEBPACK_IMPORTED_MODULE_4__["EmptyLoci"];
}
function eachCrossLink(loci, structure, apply) {
    var changed = false;
    if (_property__WEBPACK_IMPORTED_MODULE_11__["CrossLinkRestraint"].isLoci(loci)) {
        if (!_mol_model_structure__WEBPACK_IMPORTED_MODULE_7__["Structure"].areEquivalent(loci.data.structure, structure))
            return false;
        var crossLinkRestraints = _property__WEBPACK_IMPORTED_MODULE_11__["CrossLinkRestraintProvider"].get(structure).value;
        if (loci.data.crossLinkRestraints !== crossLinkRestraints)
            return false;
        for (var _i = 0, _a = loci.elements; _i < _a.length; _i++) {
            var e = _a[_i];
            if (apply(_mol_data_int__WEBPACK_IMPORTED_MODULE_5__["Interval"].ofSingleton(e)))
                changed = true;
        }
    }
    return changed;
}
//
var CrossLinkRestraintVisuals = {
    'cross-link-restraint': function (ctx, getParams) { return Object(_mol_repr_structure_representation__WEBPACK_IMPORTED_MODULE_10__["ComplexRepresentation"])('Cross-link restraint', ctx, getParams, CrossLinkRestraintVisual); },
};
var CrossLinkRestraintParams = Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, CrossLinkRestraintCylinderParams);
function getCrossLinkRestraintParams(ctx, structure) {
    return _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_6__["ParamDefinition"].clone(CrossLinkRestraintParams);
}
function CrossLinkRestraintRepresentation(ctx, getParams) {
    return _mol_repr_representation__WEBPACK_IMPORTED_MODULE_1__["Representation"].createMulti('CrossLinkRestraint', ctx, getParams, _mol_repr_structure_representation__WEBPACK_IMPORTED_MODULE_10__["StructureRepresentationStateBuilder"], CrossLinkRestraintVisuals);
}
var CrossLinkRestraintRepresentationProvider = Object(_mol_repr_structure_representation__WEBPACK_IMPORTED_MODULE_10__["StructureRepresentationProvider"])({
    name: _property__WEBPACK_IMPORTED_MODULE_11__["CrossLinkRestraint"].Tag.CrossLinkRestraint,
    label: 'Cross Link Restraint',
    description: 'Displays cross-link restraints.',
    factory: CrossLinkRestraintRepresentation,
    getParams: getCrossLinkRestraintParams,
    defaultValues: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_6__["ParamDefinition"].getDefaultValues(CrossLinkRestraintParams),
    defaultColorTheme: { name: _property__WEBPACK_IMPORTED_MODULE_11__["CrossLinkRestraint"].Tag.CrossLinkRestraint },
    defaultSizeTheme: { name: 'uniform' },
    isApplicable: function (structure) { return _property__WEBPACK_IMPORTED_MODULE_11__["CrossLinkRestraint"].isApplicable(structure); },
    ensureCustomProperties: {
        attach: function (ctx, structure) { return _property__WEBPACK_IMPORTED_MODULE_11__["CrossLinkRestraintProvider"].attach(ctx, structure, void 0, true); },
        detach: function (data) { return _property__WEBPACK_IMPORTED_MODULE_11__["CrossLinkRestraintProvider"].ref(data, false); }
    }
});
//# sourceMappingURL=representation.js.map

/***/ }),

/***/ "./lib/mol-model-props/integrative/pair-restraints.js":
/*!************************************************************!*\
  !*** ./lib/mol-model-props/integrative/pair-restraints.js ***!
  \************************************************************/
/*! exports provided: PairRestraints */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "PairRestraints", function() { return PairRestraints; });
/**
 * Copyright (c) 2018-2020 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */
var emptyArray = [];
function getPairKey(indexA, unitA, indexB, unitB) {
    return indexA + "|" + unitA.id + "|" + indexB + "|" + unitB.id;
}
var PairRestraints = /** @class */ (function () {
    function PairRestraints(pairs) {
        this.pairs = pairs;
        var pairKeyIndices = new Map();
        this.pairs.forEach(function (p, i) {
            var key = getPairKey(p.indexA, p.unitA, p.indexB, p.unitB);
            var indices = pairKeyIndices.get(key);
            if (indices)
                indices.push(i);
            else
                pairKeyIndices.set(key, [i]);
        });
        this.count = pairs.length;
        this.pairKeyIndices = pairKeyIndices;
    }
    /** Indices into this.pairs */
    PairRestraints.prototype.getPairIndices = function (indexA, unitA, indexB, unitB) {
        var key = getPairKey(indexA, unitA, indexB, unitB);
        return this.pairKeyIndices.get(key) || emptyArray;
    };
    PairRestraints.prototype.getPairs = function (indexA, unitA, indexB, unitB) {
        var _this = this;
        var indices = this.getPairIndices(indexA, unitA, indexB, unitB);
        return indices.map(function (idx) { return _this.pairs[idx]; });
    };
    return PairRestraints;
}());

//# sourceMappingURL=pair-restraints.js.map

/***/ }),

/***/ "./lib/mol-model/custom-property.js":
/*!******************************************!*\
  !*** ./lib/mol-model/custom-property.js ***!
  \******************************************/
/*! exports provided: CustomPropertyDescriptor, CustomProperties */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CustomPropertyDescriptor", function() { return CustomPropertyDescriptor; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CustomProperties", function() { return CustomProperties; });
/* harmony import */ var _mol_util__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../mol-util */ "./lib/mol-util/index.js");
/**
 * Copyright (c) 2018-2021 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author David Sehnal <david.sehnal@gmail.com>
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */


function CustomPropertyDescriptor(desc) {
    return desc;
}
(function (CustomPropertyDescriptor) {
    function getUUID(prop) {
        if (!prop.__key) {
            prop.__key = _mol_util__WEBPACK_IMPORTED_MODULE_0__["UUID"].create22();
        }
        return prop.__key;
    }
    CustomPropertyDescriptor.getUUID = getUUID;
})(CustomPropertyDescriptor || (CustomPropertyDescriptor = {}));
var CustomProperties = /** @class */ (function () {
    function CustomProperties() {
        this._list = [];
        this._set = new Set();
        this._refs = new Map();
        this._assets = new Map();
    }
    Object.defineProperty(CustomProperties.prototype, "all", {
        get: function () {
            return this._list;
        },
        enumerable: false,
        configurable: true
    });
    CustomProperties.prototype.add = function (desc) {
        if (this._set.has(desc))
            return;
        this._list.push(desc);
        this._set.add(desc);
    };
    CustomProperties.prototype.reference = function (desc, add) {
        var refs = this._refs.get(desc) || 0;
        refs += add ? 1 : -1;
        this._refs.set(desc, Math.max(refs, 0));
    };
    CustomProperties.prototype.hasReference = function (desc) {
        return (this._refs.get(desc) || 0) > 0;
    };
    CustomProperties.prototype.has = function (desc) {
        return this._set.has(desc);
    };
    /** Sets assets for a prop, disposes of existing assets for that prop */
    CustomProperties.prototype.assets = function (desc, assets) {
        var prevAssets = this._assets.get(desc);
        if (prevAssets) {
            for (var _i = 0, prevAssets_1 = prevAssets; _i < prevAssets_1.length; _i++) {
                var a = prevAssets_1[_i];
                a.dispose();
            }
        }
        if (assets)
            this._assets.set(desc, assets);
        else
            this._assets.delete(desc);
    };
    /** Disposes of all assets of all props */
    CustomProperties.prototype.dispose = function () {
        this._assets.forEach(function (assets) {
            for (var _i = 0, assets_1 = assets; _i < assets_1.length; _i++) {
                var a = assets_1[_i];
                a.dispose();
            }
        });
    };
    return CustomProperties;
}());
//# sourceMappingURL=custom-property.js.map

/***/ }),

/***/ "./lib/mol-model/location.js":
/*!***********************************!*\
  !*** ./lib/mol-model/location.js ***!
  \***********************************/
/*! exports provided: NullLocation, isNullLocation, DataLocation, isDataLocation */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "NullLocation", function() { return NullLocation; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isNullLocation", function() { return isNullLocation; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DataLocation", function() { return DataLocation; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isDataLocation", function() { return isDataLocation; });
/**
 * Copyright (c) 2018-2020 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */
/** A null value Location */
var NullLocation = { kind: 'null-location' };
function isNullLocation(x) {
    return !!x && x.kind === 'null-location';
}
function DataLocation(tag, data, element) {
    return { kind: 'data-location', tag: tag, data: data, element: element };
}
function isDataLocation(x) {
    return !!x && x.kind === 'data-location';
}
//# sourceMappingURL=location.js.map

/***/ }),

/***/ "./lib/mol-model/loci.js":
/*!*******************************!*\
  !*** ./lib/mol-model/loci.js ***!
  \*******************************/
/*! exports provided: EveryLoci, isEveryLoci, EmptyLoci, isEmptyLoci, isDataLoci, areDataLociEqual, isDataLociEmpty, DataLoci, Loci */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "EveryLoci", function() { return EveryLoci; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isEveryLoci", function() { return isEveryLoci; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "EmptyLoci", function() { return EmptyLoci; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isEmptyLoci", function() { return isEmptyLoci; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isDataLoci", function() { return isDataLoci; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "areDataLociEqual", function() { return areDataLociEqual; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isDataLociEmpty", function() { return isDataLociEmpty; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DataLoci", function() { return DataLoci; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Loci", function() { return Loci; });
/* harmony import */ var _structure__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./structure */ "./lib/mol-model/structure.js");
/* harmony import */ var _structure_structure_unit_bonds__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./structure/structure/unit/bonds */ "./lib/mol-model/structure/structure/unit/bonds.js");
/* harmony import */ var _shape__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./shape */ "./lib/mol-model/shape.js");
/* harmony import */ var _mol_math_geometry__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../mol-math/geometry */ "./lib/mol-math/geometry.js");
/* harmony import */ var _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../mol-math/linear-algebra */ "./lib/mol-math/linear-algebra.js");
/* harmony import */ var _structure_structure__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./structure/structure */ "./lib/mol-model/structure/structure.js");
/* harmony import */ var _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../mol-util/param-definition */ "./lib/mol-util/param-definition.js");
/* harmony import */ var _mol_util__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../mol-util */ "./lib/mol-util/index.js");
/* harmony import */ var _mol_math_geometry_boundary_helper__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ../mol-math/geometry/boundary-helper */ "./lib/mol-math/geometry/boundary-helper.js");
/* harmony import */ var _mol_util_string__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ../mol-util/string */ "./lib/mol-util/string.js");
/* harmony import */ var _volume_volume__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ./volume/volume */ "./lib/mol-model/volume/volume.js");
/**
 * Copyright (c) 2018-2020 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */











/** A Loci that includes every loci */
var EveryLoci = { kind: 'every-loci' };
function isEveryLoci(x) {
    return !!x && x.kind === 'every-loci';
}
/** A Loci that is empty */
var EmptyLoci = { kind: 'empty-loci' };
function isEmptyLoci(x) {
    return !!x && x.kind === 'empty-loci';
}
function isDataLoci(x) {
    return !!x && x.kind === 'data-loci';
}
function areDataLociEqual(a, b) {
    // use shallowEqual to allow simple data objects that are contructed on-the-fly
    if (!Object(_mol_util__WEBPACK_IMPORTED_MODULE_7__["shallowEqual"])(a.data, b.data) || a.tag !== b.tag)
        return false;
    if (a.elements.length !== b.elements.length)
        return false;
    for (var i = 0, il = a.elements.length; i < il; ++i) {
        if (!Object(_mol_util__WEBPACK_IMPORTED_MODULE_7__["shallowEqual"])(a.elements[i], b.elements[i]))
            return false;
    }
    return true;
}
function isDataLociEmpty(loci) {
    return loci.elements.length === 0 ? true : false;
}
function DataLoci(tag, data, elements, getBoundingSphere, getLabel) {
    return { kind: 'data-loci', tag: tag, data: data, elements: elements, getBoundingSphere: getBoundingSphere, getLabel: getLabel };
}

var Loci;
(function (Loci) {
    var boundaryHelper = new _mol_math_geometry_boundary_helper__WEBPACK_IMPORTED_MODULE_8__["BoundaryHelper"]('98');
    function getBundleBoundingSphere(bundle) {
        var spheres = bundle.loci.map(function (l) { return getBoundingSphere(l); }).filter(function (s) { return !!s; });
        boundaryHelper.reset();
        for (var _i = 0, spheres_1 = spheres; _i < spheres_1.length; _i++) {
            var s = spheres_1[_i];
            boundaryHelper.includePositionRadius(s.center, s.radius);
        }
        boundaryHelper.finishedIncludeStep();
        for (var _a = 0, spheres_2 = spheres; _a < spheres_2.length; _a++) {
            var s = spheres_2[_a];
            boundaryHelper.radiusPositionRadius(s.center, s.radius);
        }
        return boundaryHelper.getSphere();
    }
    Loci.getBundleBoundingSphere = getBundleBoundingSphere;
    function areEqual(lociA, lociB) {
        if (isEveryLoci(lociA) && isEveryLoci(lociB))
            return true;
        if (isEmptyLoci(lociA) && isEmptyLoci(lociB))
            return true;
        if (isDataLoci(lociA) && isDataLoci(lociB)) {
            return areDataLociEqual(lociA, lociB);
        }
        if (_structure_structure__WEBPACK_IMPORTED_MODULE_5__["Structure"].isLoci(lociA) && _structure_structure__WEBPACK_IMPORTED_MODULE_5__["Structure"].isLoci(lociB)) {
            return _structure_structure__WEBPACK_IMPORTED_MODULE_5__["Structure"].areLociEqual(lociA, lociB);
        }
        if (_structure__WEBPACK_IMPORTED_MODULE_0__["StructureElement"].Loci.is(lociA) && _structure__WEBPACK_IMPORTED_MODULE_0__["StructureElement"].Loci.is(lociB)) {
            return _structure__WEBPACK_IMPORTED_MODULE_0__["StructureElement"].Loci.areEqual(lociA, lociB);
        }
        if (_structure_structure_unit_bonds__WEBPACK_IMPORTED_MODULE_1__["Bond"].isLoci(lociA) && _structure_structure_unit_bonds__WEBPACK_IMPORTED_MODULE_1__["Bond"].isLoci(lociB)) {
            return _structure_structure_unit_bonds__WEBPACK_IMPORTED_MODULE_1__["Bond"].areLociEqual(lociA, lociB);
        }
        if (_shape__WEBPACK_IMPORTED_MODULE_2__["Shape"].isLoci(lociA) && _shape__WEBPACK_IMPORTED_MODULE_2__["Shape"].isLoci(lociB)) {
            return _shape__WEBPACK_IMPORTED_MODULE_2__["Shape"].areLociEqual(lociA, lociB);
        }
        if (_shape__WEBPACK_IMPORTED_MODULE_2__["ShapeGroup"].isLoci(lociA) && _shape__WEBPACK_IMPORTED_MODULE_2__["ShapeGroup"].isLoci(lociB)) {
            return _shape__WEBPACK_IMPORTED_MODULE_2__["ShapeGroup"].areLociEqual(lociA, lociB);
        }
        if (_volume_volume__WEBPACK_IMPORTED_MODULE_10__["Volume"].isLoci(lociA) && _volume_volume__WEBPACK_IMPORTED_MODULE_10__["Volume"].isLoci(lociB)) {
            return _volume_volume__WEBPACK_IMPORTED_MODULE_10__["Volume"].areLociEqual(lociA, lociB);
        }
        if (_volume_volume__WEBPACK_IMPORTED_MODULE_10__["Volume"].Isosurface.isLoci(lociA) && _volume_volume__WEBPACK_IMPORTED_MODULE_10__["Volume"].Isosurface.isLoci(lociB)) {
            return _volume_volume__WEBPACK_IMPORTED_MODULE_10__["Volume"].Isosurface.areLociEqual(lociA, lociB);
        }
        if (_volume_volume__WEBPACK_IMPORTED_MODULE_10__["Volume"].Cell.isLoci(lociA) && _volume_volume__WEBPACK_IMPORTED_MODULE_10__["Volume"].Cell.isLoci(lociB)) {
            return _volume_volume__WEBPACK_IMPORTED_MODULE_10__["Volume"].Cell.areLociEqual(lociA, lociB);
        }
        return false;
    }
    Loci.areEqual = areEqual;
    function isEvery(loci) {
        return !!loci && loci.kind === 'every-loci';
    }
    Loci.isEvery = isEvery;
    function isEmpty(loci) {
        if (isEveryLoci(loci))
            return false;
        if (isEmptyLoci(loci))
            return true;
        if (isDataLoci(loci))
            return isDataLociEmpty(loci);
        if (_structure_structure__WEBPACK_IMPORTED_MODULE_5__["Structure"].isLoci(loci))
            return _structure_structure__WEBPACK_IMPORTED_MODULE_5__["Structure"].isLociEmpty(loci);
        if (_structure__WEBPACK_IMPORTED_MODULE_0__["StructureElement"].Loci.is(loci))
            return _structure__WEBPACK_IMPORTED_MODULE_0__["StructureElement"].Loci.isEmpty(loci);
        if (_structure_structure_unit_bonds__WEBPACK_IMPORTED_MODULE_1__["Bond"].isLoci(loci))
            return _structure_structure_unit_bonds__WEBPACK_IMPORTED_MODULE_1__["Bond"].isLociEmpty(loci);
        if (_shape__WEBPACK_IMPORTED_MODULE_2__["Shape"].isLoci(loci))
            return _shape__WEBPACK_IMPORTED_MODULE_2__["Shape"].isLociEmpty(loci);
        if (_shape__WEBPACK_IMPORTED_MODULE_2__["ShapeGroup"].isLoci(loci))
            return _shape__WEBPACK_IMPORTED_MODULE_2__["ShapeGroup"].isLociEmpty(loci);
        if (_volume_volume__WEBPACK_IMPORTED_MODULE_10__["Volume"].isLoci(loci))
            return _volume_volume__WEBPACK_IMPORTED_MODULE_10__["Volume"].isLociEmpty(loci);
        if (_volume_volume__WEBPACK_IMPORTED_MODULE_10__["Volume"].Isosurface.isLoci(loci))
            return _volume_volume__WEBPACK_IMPORTED_MODULE_10__["Volume"].Isosurface.isLociEmpty(loci);
        if (_volume_volume__WEBPACK_IMPORTED_MODULE_10__["Volume"].Cell.isLoci(loci))
            return _volume_volume__WEBPACK_IMPORTED_MODULE_10__["Volume"].Cell.isLociEmpty(loci);
        return false;
    }
    Loci.isEmpty = isEmpty;
    function remap(loci, data) {
        if (data instanceof _structure_structure__WEBPACK_IMPORTED_MODULE_5__["Structure"]) {
            if (_structure__WEBPACK_IMPORTED_MODULE_0__["StructureElement"].Loci.is(loci)) {
                loci = _structure__WEBPACK_IMPORTED_MODULE_0__["StructureElement"].Loci.remap(loci, data);
            }
            else if (_structure_structure__WEBPACK_IMPORTED_MODULE_5__["Structure"].isLoci(loci)) {
                loci = _structure_structure__WEBPACK_IMPORTED_MODULE_5__["Structure"].remapLoci(loci, data);
            }
            else if (_structure_structure_unit_bonds__WEBPACK_IMPORTED_MODULE_1__["Bond"].isLoci(loci)) {
                loci = _structure_structure_unit_bonds__WEBPACK_IMPORTED_MODULE_1__["Bond"].remapLoci(loci, data);
            }
        }
        return loci;
    }
    Loci.remap = remap;
    function getBoundingSphere(loci, boundingSphere) {
        if (loci.kind === 'every-loci' || loci.kind === 'empty-loci')
            return void 0;
        if (!boundingSphere)
            boundingSphere = Object(_mol_math_geometry__WEBPACK_IMPORTED_MODULE_3__["Sphere3D"])();
        if (loci.kind === 'structure-loci') {
            return _mol_math_geometry__WEBPACK_IMPORTED_MODULE_3__["Sphere3D"].copy(boundingSphere, loci.structure.boundary.sphere);
        }
        else if (loci.kind === 'element-loci') {
            return _mol_math_geometry__WEBPACK_IMPORTED_MODULE_3__["Sphere3D"].copy(boundingSphere, _structure__WEBPACK_IMPORTED_MODULE_0__["StructureElement"].Loci.getBoundary(loci).sphere);
        }
        else if (loci.kind === 'bond-loci') {
            return _structure_structure_unit_bonds__WEBPACK_IMPORTED_MODULE_1__["Bond"].getBoundingSphere(loci, boundingSphere);
        }
        else if (loci.kind === 'shape-loci') {
            return _mol_math_geometry__WEBPACK_IMPORTED_MODULE_3__["Sphere3D"].copy(boundingSphere, loci.shape.geometry.boundingSphere);
        }
        else if (loci.kind === 'group-loci') {
            return _shape__WEBPACK_IMPORTED_MODULE_2__["ShapeGroup"].getBoundingSphere(loci, boundingSphere);
        }
        else if (loci.kind === 'data-loci') {
            return loci.getBoundingSphere(boundingSphere);
        }
        else if (loci.kind === 'volume-loci') {
            return _volume_volume__WEBPACK_IMPORTED_MODULE_10__["Volume"].getBoundingSphere(loci.volume, boundingSphere);
        }
        else if (loci.kind === 'isosurface-loci') {
            return _volume_volume__WEBPACK_IMPORTED_MODULE_10__["Volume"].Isosurface.getBoundingSphere(loci.volume, loci.isoValue, boundingSphere);
        }
        else if (loci.kind === 'cell-loci') {
            return _volume_volume__WEBPACK_IMPORTED_MODULE_10__["Volume"].Cell.getBoundingSphere(loci.volume, loci.indices, boundingSphere);
        }
    }
    Loci.getBoundingSphere = getBoundingSphere;
    var tmpSphere3D = _mol_math_geometry__WEBPACK_IMPORTED_MODULE_3__["Sphere3D"].zero();
    function getCenter(loci, center) {
        var boundingSphere = getBoundingSphere(loci, tmpSphere3D);
        return boundingSphere ? _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_4__["Vec3"].copy(center || Object(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_4__["Vec3"])(), boundingSphere.center) : undefined;
    }
    Loci.getCenter = getCenter;
    function getPrincipalAxes(loci) {
        if (loci.kind === 'every-loci' || loci.kind === 'empty-loci')
            return void 0;
        if (loci.kind === 'structure-loci') {
            return _structure__WEBPACK_IMPORTED_MODULE_0__["StructureElement"].Loci.getPrincipalAxes(_structure_structure__WEBPACK_IMPORTED_MODULE_5__["Structure"].toStructureElementLoci(loci.structure));
        }
        else if (loci.kind === 'element-loci') {
            return _structure__WEBPACK_IMPORTED_MODULE_0__["StructureElement"].Loci.getPrincipalAxes(loci);
        }
        else if (loci.kind === 'bond-loci') {
            // TODO
            return void 0;
        }
        else if (loci.kind === 'shape-loci') {
            // TODO
            return void 0;
        }
        else if (loci.kind === 'group-loci') {
            // TODO
            return void 0;
        }
        else if (loci.kind === 'data-loci') {
            // TODO maybe add loci.getPrincipalAxes()???
            return void 0;
        }
        else if (loci.kind === 'volume-loci') {
            // TODO
            return void 0;
        }
        else if (loci.kind === 'isosurface-loci') {
            // TODO
            return void 0;
        }
        else if (loci.kind === 'cell-loci') {
            // TODO
            return void 0;
        }
    }
    Loci.getPrincipalAxes = getPrincipalAxes;
    //
    var Granularity = {
        'element': function (loci) { return loci; },
        'residue': function (loci) {
            return _structure__WEBPACK_IMPORTED_MODULE_0__["StructureElement"].Loci.is(loci)
                ? _structure__WEBPACK_IMPORTED_MODULE_0__["StructureElement"].Loci.extendToWholeResidues(loci, true)
                : loci;
        },
        'chain': function (loci) {
            return _structure__WEBPACK_IMPORTED_MODULE_0__["StructureElement"].Loci.is(loci)
                ? _structure__WEBPACK_IMPORTED_MODULE_0__["StructureElement"].Loci.extendToWholeChains(loci)
                : loci;
        },
        'entity': function (loci) {
            return _structure__WEBPACK_IMPORTED_MODULE_0__["StructureElement"].Loci.is(loci)
                ? _structure__WEBPACK_IMPORTED_MODULE_0__["StructureElement"].Loci.extendToWholeEntities(loci)
                : loci;
        },
        'model': function (loci) {
            return _structure__WEBPACK_IMPORTED_MODULE_0__["StructureElement"].Loci.is(loci)
                ? _structure__WEBPACK_IMPORTED_MODULE_0__["StructureElement"].Loci.extendToWholeModels(loci)
                : loci;
        },
        'structure': function (loci) {
            return _structure__WEBPACK_IMPORTED_MODULE_0__["StructureElement"].Loci.is(loci)
                ? _structure_structure__WEBPACK_IMPORTED_MODULE_5__["Structure"].toStructureElementLoci(loci.structure)
                : _shape__WEBPACK_IMPORTED_MODULE_2__["ShapeGroup"].isLoci(loci)
                    ? _shape__WEBPACK_IMPORTED_MODULE_2__["Shape"].Loci(loci.shape)
                    : loci;
        },
        'elementInstances': function (loci) {
            return _structure__WEBPACK_IMPORTED_MODULE_0__["StructureElement"].Loci.is(loci)
                ? _structure__WEBPACK_IMPORTED_MODULE_0__["StructureElement"].Loci.extendToAllInstances(loci)
                : loci;
        },
        'residueInstances': function (loci) {
            return _structure__WEBPACK_IMPORTED_MODULE_0__["StructureElement"].Loci.is(loci)
                ? _structure__WEBPACK_IMPORTED_MODULE_0__["StructureElement"].Loci.extendToAllInstances(_structure__WEBPACK_IMPORTED_MODULE_0__["StructureElement"].Loci.extendToWholeResidues(loci, true))
                : loci;
        },
        'chainInstances': function (loci) {
            return _structure__WEBPACK_IMPORTED_MODULE_0__["StructureElement"].Loci.is(loci)
                ? _structure__WEBPACK_IMPORTED_MODULE_0__["StructureElement"].Loci.extendToAllInstances(_structure__WEBPACK_IMPORTED_MODULE_0__["StructureElement"].Loci.extendToWholeChains(loci))
                : loci;
        },
    };
    Loci.GranularityOptions = _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_6__["ParamDefinition"].objectToOptions(Granularity, function (k) {
        switch (k) {
            case 'element': return 'Atom/Coarse Element';
            case 'elementInstances': return ['Atom/Coarse Element Instances', 'With Symmetry'];
            case 'structure': return 'Structure/Shape';
            default: return k.indexOf('Instances')
                ? [Object(_mol_util_string__WEBPACK_IMPORTED_MODULE_9__["stringToWords"])(k), 'With Symmetry'] : Object(_mol_util_string__WEBPACK_IMPORTED_MODULE_9__["stringToWords"])(k);
        }
    });
    /** Exclude `Instances` granularity kinds */
    function simpleGranularity(granularity) {
        return granularity.replace('Instances', '');
    }
    Loci.simpleGranularity = simpleGranularity;
    function applyGranularity(loci, granularity) {
        return Granularity[granularity](loci);
    }
    Loci.applyGranularity = applyGranularity;
    /**
     * Converts structure related loci to StructureElement.Loci and applies
     * granularity if given
     */
    function normalize(loci, granularity) {
        if (granularity !== 'element' && _structure_structure_unit_bonds__WEBPACK_IMPORTED_MODULE_1__["Bond"].isLoci(loci)) {
            // convert Bond.Loci to a StructureElement.Loci so granularity can be applied
            loci = _structure_structure_unit_bonds__WEBPACK_IMPORTED_MODULE_1__["Bond"].toStructureElementLoci(loci);
        }
        if (_structure_structure__WEBPACK_IMPORTED_MODULE_5__["Structure"].isLoci(loci)) {
            // convert to StructureElement.Loci
            loci = _structure_structure__WEBPACK_IMPORTED_MODULE_5__["Structure"].toStructureElementLoci(loci.structure);
        }
        if (_structure__WEBPACK_IMPORTED_MODULE_0__["StructureElement"].Loci.is(loci)) {
            // ensure the root structure is used
            loci = _structure__WEBPACK_IMPORTED_MODULE_0__["StructureElement"].Loci.remap(loci, loci.structure.root);
        }
        if (granularity) {
            // needs to be applied AFTER remapping to root
            loci = applyGranularity(loci, granularity);
        }
        return loci;
    }
    Loci.normalize = normalize;
})(Loci || (Loci = {}));
//# sourceMappingURL=loci.js.map

/***/ }),

/***/ "./lib/mol-model/sequence.js":
/*!***********************************!*\
  !*** ./lib/mol-model/sequence.js ***!
  \***********************************/
/*! exports provided: Sequence */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _sequence_sequence__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./sequence/sequence */ "./lib/mol-model/sequence/sequence.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Sequence", function() { return _sequence_sequence__WEBPACK_IMPORTED_MODULE_0__["Sequence"]; });

/**
 * Copyright (c) 2018 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author David Sehnal <david.sehnal@gmail.com>
 */

//# sourceMappingURL=sequence.js.map

/***/ }),

/***/ "./lib/mol-model/sequence/alignment/alignment.js":
/*!*******************************************************!*\
  !*** ./lib/mol-model/sequence/alignment/alignment.js ***!
  \*******************************************************/
/*! exports provided: align */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "align", function() { return align; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _substitution_matrix__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./substitution-matrix */ "./lib/mol-model/sequence/alignment/substitution-matrix.js");
/**
 * Copyright (c) 2020 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */


var DefaultAlignmentOptions = {
    gapPenalty: -11,
    gapExtensionPenalty: -1,
    substMatrix: 'default'
};
function align(seqA, seqB, options) {
    if (options === void 0) { options = {}; }
    var o = Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, DefaultAlignmentOptions), options);
    var alignment = new Alignment(seqA, seqB, o);
    alignment.calculate();
    return alignment.trace();
}
var Alignment = /** @class */ (function () {
    function Alignment(seqA, seqB, options) {
        this.seqA = seqA;
        this.seqB = seqB;
        this.S = [];
        this.V = [];
        this.H = [];
        this.gapPenalty = options.gapPenalty;
        this.gapExtensionPenalty = options.gapExtensionPenalty;
        this.substMatrix = options.substMatrix === 'default' ? undefined : _substitution_matrix__WEBPACK_IMPORTED_MODULE_1__["SubstitutionMatrices"][options.substMatrix];
        this.n = this.seqA.length;
        this.m = this.seqB.length;
    }
    Alignment.prototype.initMatrices = function () {
        var _a = this, n = _a.n, m = _a.m, gapPenalty = _a.gapPenalty, S = _a.S, V = _a.V, H = _a.H;
        for (var i = 0; i <= n; ++i) {
            S[i] = [], V[i] = [], H[i] = [];
            for (var j = 0; j <= m; ++j) {
                S[i][j] = 0, V[i][j] = 0, H[i][j] = 0;
            }
        }
        for (var i = 0; i <= n; ++i) {
            S[i][0] = gapPenalty;
            H[i][0] = -Infinity;
        }
        for (var j = 0; j <= m; ++j) {
            S[0][j] = gapPenalty;
            V[0][j] = -Infinity;
        }
        S[0][0] = 0;
    };
    Alignment.prototype.makeScoreFn = function () {
        var _a = this, seqA = _a.seqA, seqB = _a.seqB, substMatrix = _a.substMatrix;
        if (substMatrix) {
            return function score(i, j) {
                var _a, _b;
                var cA = seqA[i];
                var cB = seqB[j];
                return (_b = (_a = substMatrix[cA]) === null || _a === void 0 ? void 0 : _a[cB]) !== null && _b !== void 0 ? _b : -4;
            };
        }
        else {
            return function scoreNoSubstMat(i, j) {
                var cA = seqA[i];
                var cB = seqB[j];
                return cA === cB ? 5 : -3;
            };
        }
    };
    Alignment.prototype.calculate = function () {
        this.initMatrices();
        var scoreFn = this.makeScoreFn();
        var _a = this, V = _a.V, H = _a.H, S = _a.S, n = _a.n, m = _a.m, gapExtensionPenalty = _a.gapExtensionPenalty, gapPenalty = _a.gapPenalty;
        var Vi1, Si1, Vi, Hi, Si;
        for (var i = 1; i <= n; ++i) {
            Si1 = S[i - 1], Vi1 = V[i - 1];
            Vi = V[i], Hi = H[i], Si = S[i];
            for (var j = 1; j <= m; ++j) {
                Vi[j] = Math.max(Si1[j] + gapPenalty, Vi1[j] + gapExtensionPenalty);
                Hi[j] = Math.max(Si[j - 1] + gapPenalty, Hi[j - 1] + gapExtensionPenalty);
                Si[j] = Math.max(Si1[j - 1] + scoreFn(i - 1, j - 1), // match
                Vi[j], // del
                Hi[j] // ins
                );
            }
        }
    };
    Alignment.prototype.trace = function () {
        var scoreFn = this.makeScoreFn();
        var _a = this, V = _a.V, H = _a.H, S = _a.S, seqA = _a.seqA, seqB = _a.seqB, gapExtensionPenalty = _a.gapExtensionPenalty, gapPenalty = _a.gapPenalty;
        var i = this.n;
        var j = this.m;
        var mat;
        var score;
        var aliA = '';
        var aliB = '';
        if (S[i][j] >= V[i][j]) {
            mat = 'S';
            score = S[i][j];
        }
        else if (V[i][j] >= H[i][j]) {
            mat = 'V';
            score = V[i][j];
        }
        else {
            mat = 'H';
            score = H[i][j];
        }
        while (i > 0 && j > 0) {
            if (mat === 'S') {
                if (S[i][j] === S[i - 1][j - 1] + scoreFn(i - 1, j - 1)) {
                    aliA = seqA[i - 1] + aliA;
                    aliB = seqB[j - 1] + aliB;
                    --i;
                    --j;
                    mat = 'S';
                }
                else if (S[i][j] === V[i][j]) {
                    mat = 'V';
                }
                else if (S[i][j] === H[i][j]) {
                    mat = 'H';
                }
                else {
                    --i;
                    --j;
                }
            }
            else if (mat === 'V') {
                if (V[i][j] === V[i - 1][j] + gapExtensionPenalty) {
                    aliA = seqA[i - 1] + aliA;
                    aliB = '-' + aliB;
                    --i;
                    mat = 'V';
                }
                else if (V[i][j] === S[i - 1][j] + gapPenalty) {
                    aliA = seqA[i - 1] + aliA;
                    aliB = '-' + aliB;
                    --i;
                    mat = 'S';
                }
                else {
                    --i;
                }
            }
            else if (mat === 'H') {
                if (H[i][j] === H[i][j - 1] + gapExtensionPenalty) {
                    aliA = '-' + aliA;
                    aliB = seqB[j - 1] + aliB;
                    --j;
                    mat = 'H';
                }
                else if (H[i][j] === S[i][j - 1] + gapPenalty) {
                    aliA = '-' + aliA;
                    aliB = seqB[j - 1] + aliB;
                    --j;
                    mat = 'S';
                }
                else {
                    --j;
                }
            }
        }
        while (i > 0) {
            aliA = seqA[i - 1] + aliA;
            aliB = '-' + aliB;
            --i;
        }
        while (j > 0) {
            aliA = '-' + aliA;
            aliB = seqB[j - 1] + aliB;
            --j;
        }
        return { aliA: aliA, aliB: aliB, score: score };
    };
    return Alignment;
}());
//# sourceMappingURL=alignment.js.map

/***/ }),

/***/ "./lib/mol-model/sequence/alignment/sequence.js":
/*!******************************************************!*\
  !*** ./lib/mol-model/sequence/alignment/sequence.js ***!
  \******************************************************/
/*! exports provided: AlignSequences */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "AlignSequences", function() { return AlignSequences; });
/* harmony import */ var _structure_structure__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../structure/structure */ "./lib/mol-model/structure/structure.js");
/* harmony import */ var _alignment__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./alignment */ "./lib/mol-model/sequence/alignment/alignment.js");
/* harmony import */ var _mol_data_int__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../../mol-data/int */ "./lib/mol-data/int.js");
/**
 * Copyright (c) 2020 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */




var AlignSequences;
(function (AlignSequences) {
    function createSeqIdIndicesMap(element) {
        var seqIds = new Map();
        if (_structure_structure__WEBPACK_IMPORTED_MODULE_0__["Unit"].isAtomic(element.unit)) {
            var label_seq_id = element.unit.model.atomicHierarchy.residues.label_seq_id;
            var residueIndex = element.unit.residueIndex;
            for (var i = 0, il = _mol_data_int__WEBPACK_IMPORTED_MODULE_2__["OrderedSet"].size(element.indices); i < il; ++i) {
                var uI = _mol_data_int__WEBPACK_IMPORTED_MODULE_2__["OrderedSet"].getAt(element.indices, i);
                var eI = element.unit.elements[uI];
                var seqId = label_seq_id.value(residueIndex[eI]);
                if (seqIds.has(seqId))
                    seqIds.get(seqId).push(uI);
                else
                    seqIds.set(seqId, [uI]);
            }
        }
        else if (_structure_structure__WEBPACK_IMPORTED_MODULE_0__["Unit"].isCoarse(element.unit)) {
            var seq_id_begin = (_structure_structure__WEBPACK_IMPORTED_MODULE_0__["Unit"].isSpheres(element.unit)
                ? element.unit.model.coarseHierarchy.spheres
                : element.unit.model.coarseHierarchy.gaussians).seq_id_begin;
            for (var i = 0, il = _mol_data_int__WEBPACK_IMPORTED_MODULE_2__["OrderedSet"].size(element.indices); i < il; ++i) {
                var uI = _mol_data_int__WEBPACK_IMPORTED_MODULE_2__["OrderedSet"].getAt(element.indices, i);
                var eI = element.unit.elements[uI];
                var seqId = seq_id_begin.value(eI);
                seqIds.set(seqId, [uI]);
            }
        }
        return seqIds;
    }
    function compute(input, options) {
        if (options === void 0) { options = {}; }
        var seqA = getSequence(input.a.unit);
        var seqB = getSequence(input.b.unit);
        var seqIdIndicesA = createSeqIdIndicesMap(input.a);
        var seqIdIndicesB = createSeqIdIndicesMap(input.b);
        var indicesA = [];
        var indicesB = [];
        var _a = Object(_alignment__WEBPACK_IMPORTED_MODULE_1__["align"])(seqA.code.toArray(), seqB.code.toArray(), options), aliA = _a.aliA, aliB = _a.aliB, score = _a.score;
        var seqIdxA = 0, seqIdxB = 0;
        for (var i = 0, il = aliA.length; i < il; ++i) {
            if (aliA[i] === '-' || aliB[i] === '-') {
                if (aliA[i] !== '-')
                    seqIdxA += 1;
                if (aliB[i] !== '-')
                    seqIdxB += 1;
                continue;
            }
            var seqIdA = seqA.seqId.value(seqIdxA);
            var seqIdB = seqB.seqId.value(seqIdxB);
            if (seqIdIndicesA.has(seqIdA) && seqIdIndicesB.has(seqIdB)) {
                var iA = seqIdIndicesA.get(seqIdA);
                var iB = seqIdIndicesB.get(seqIdB);
                // use min length to guard against alternate locations
                for (var j = 0, jl = Math.min(iA.length, iB.length); j < jl; ++j) {
                    indicesA.push(iA[j]);
                    indicesB.push(iB[j]);
                }
            }
            seqIdxA += 1, seqIdxB += 1;
        }
        var outA = _mol_data_int__WEBPACK_IMPORTED_MODULE_2__["OrderedSet"].intersect(_mol_data_int__WEBPACK_IMPORTED_MODULE_2__["OrderedSet"].ofSortedArray(indicesA), input.a.indices);
        var outB = _mol_data_int__WEBPACK_IMPORTED_MODULE_2__["OrderedSet"].intersect(_mol_data_int__WEBPACK_IMPORTED_MODULE_2__["OrderedSet"].ofSortedArray(indicesB), input.b.indices);
        return {
            a: { unit: input.a.unit, indices: outA },
            b: { unit: input.b.unit, indices: outB },
            score: score
        };
    }
    AlignSequences.compute = compute;
})(AlignSequences || (AlignSequences = {}));
function entityKey(unit) {
    switch (unit.kind) {
        case 0 /* Atomic */:
            return unit.model.atomicHierarchy.index.getEntityFromChain(unit.chainIndex[unit.elements[0]]);
        case 1 /* Spheres */:
            return unit.model.coarseHierarchy.spheres.entityKey[unit.elements[0]];
        case 2 /* Gaussians */:
            return unit.model.coarseHierarchy.gaussians.entityKey[unit.elements[0]];
    }
}
function getSequence(unit) {
    return unit.model.sequence.byEntityKey[entityKey(unit)].sequence;
}
//# sourceMappingURL=sequence.js.map

/***/ }),

/***/ "./lib/mol-model/sequence/alignment/substitution-matrix.js":
/*!*****************************************************************!*\
  !*** ./lib/mol-model/sequence/alignment/substitution-matrix.js ***!
  \*****************************************************************/
/*! exports provided: SubstitutionMatrices */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SubstitutionMatrices", function() { return SubstitutionMatrices; });
/**
 * Copyright (c) 2020 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */
var aminoacidsX = 'ACDEFGHIKLMNPQRSTVWY';
var aminoacids = 'ARNDCQEGHILKMFPSTWYVBZX';
var blosum62x = [
    [4, 0, -2, -1, -2, 0, -2, -1, -1, -1, -1, -2, -1, -1, -1, 1, 0, 0, -3, -2],
    [0, 9, -3, -4, -2, -3, -3, -1, -3, -1, -1, -3, -3, -3, -3, -1, -1, -1, -2, -2],
    [-2, -3, 6, 2, -3, -1, -1, -3, -1, -4, -3, 1, -1, 0, -2, 0, -1, -3, -4, -3],
    [-1, -4, 2, 5, -3, -2, 0, -3, 1, -3, -2, 0, -1, 2, 0, 0, -1, -2, -3, -2],
    [-2, -2, -3, -3, 6, -3, -1, 0, -3, 0, 0, -3, -4, -3, -3, -2, -2, -1, 1, 3],
    [0, -3, -1, -2, -3, 6, -2, -4, -2, -4, -3, 0, -2, -2, -2, 0, -2, -3, -2, -3],
    [-2, -3, -1, 0, -1, -2, 8, -3, -1, -3, -2, 1, -2, 0, 0, -1, -2, -3, -2, 2],
    [-1, -1, -3, -3, 0, -4, -3, 4, -3, 2, 1, -3, -3, -3, -3, -2, -1, 3, -3, -1],
    [-1, -3, -1, 1, -3, -2, -1, -3, 5, -2, -1, 0, -1, 1, 2, 0, -1, -2, -3, -2],
    [-1, -1, -4, -3, 0, -4, -3, 2, -2, 4, 2, -3, -3, -2, -2, -2, -1, 1, -2, -1],
    [-1, -1, -3, -2, 0, -3, -2, 1, -1, 2, 5, -2, -2, 0, -1, -1, -1, 1, -1, -1],
    [-2, -3, 1, 0, -3, 0, 1, -3, 0, -3, -2, 6, -2, 0, 0, 1, 0, -3, -4, -2],
    [-1, -3, -1, -1, -4, -2, -2, -3, -1, -3, -2, -2, 7, -1, -2, -1, -1, -2, -4, -3],
    [-1, -3, 0, 2, -3, -2, 0, -3, 1, -2, 0, 0, -1, 5, 1, 0, -1, -2, -2, -1],
    [-1, -3, -2, 0, -3, -2, 0, -3, 2, -2, -1, 0, -2, 1, 5, -1, -1, -3, -3, -2],
    [1, -1, 0, 0, -2, 0, -1, -2, 0, -2, -1, 1, -1, 0, -1, 4, 1, -2, -3, -2],
    [0, -1, -1, -1, -2, -2, -2, -1, -1, -1, -1, 0, -1, -1, -1, 1, 5, 0, -2, -2],
    [0, -1, -3, -2, -1, -3, -3, 3, -2, 1, 1, -3, -2, -2, -3, -2, 0, 4, -3, -1],
    [-3, -2, -4, -3, 1, -2, -2, -3, -3, -2, -1, -4, -4, -2, -3, -3, -2, -3, 11, 2],
    [-2, -2, -3, -2, 3, -3, 2, -1, -2, -1, -1, -2, -3, -1, -2, -2, -2, -1, 2, 7] // Y
];
var blosum62 = [
    // A  R  N  D  C  Q  E  G  H  I  L  K  M  F  P  S  T  W  Y  V  B  Z  X
    [4, -1, -2, -2, 0, -1, -1, 0, -2, -1, -1, -1, -1, -2, -1, 1, 0, -3, -2, 0, -2, -1, 0],
    [-1, 5, 0, -2, -3, 1, 0, -2, 0, -3, -2, 2, -1, -3, -2, -1, -1, -3, -2, -3, -1, 0, -1],
    [-2, 0, 6, 1, -3, 0, 0, 0, 1, -3, -3, 0, -2, -3, -2, 1, 0, -4, -2, -3, 3, 0, -1],
    [-2, -2, 1, 6, -3, 0, 2, -1, -1, -3, -4, -1, -3, -3, -1, 0, -1, -4, -3, -3, 4, 1, -1],
    [0, -3, -3, -3, 9, -3, -4, -3, -3, -1, -1, -3, -1, -2, -3, -1, -1, -2, -2, -1, -3, -3, -2],
    [-1, 1, 0, 0, -3, 5, 2, -2, 0, -3, -2, 1, 0, -3, -1, 0, -1, -2, -1, -2, 0, 3, -1],
    [-1, 0, 0, 2, -4, 2, 5, -2, 0, -3, -3, 1, -2, -3, -1, 0, -1, -3, -2, -2, 1, 4, -1],
    [0, -2, 0, -1, -3, -2, -2, 6, -2, -4, -4, -2, -3, -3, -2, 0, -2, -2, -3, -3, -1, -2, -1],
    [-2, 0, 1, -1, -3, 0, 0, -2, 8, -3, -3, -1, -2, -1, -2, -1, -2, -2, 2, -3, 0, 0, -1],
    [-1, -3, -3, -3, -1, -3, -3, -4, -3, 4, 2, -3, 1, 0, -3, -2, -1, -3, -1, 3, -3, -3, -1],
    [-1, -2, -3, -4, -1, -2, -3, -4, -3, 2, 4, -2, 2, 0, -3, -2, -1, -2, -1, 1, -4, -3, -1],
    [-1, 2, 0, -1, -3, 1, 1, -2, -1, -3, -2, 5, -1, -3, -1, 0, -1, -3, -2, -2, 0, 1, -1],
    [-1, -1, -2, -3, -1, 0, -2, -3, -2, 1, 2, -1, 5, 0, -2, -1, -1, -1, -1, 1, -3, -1, -1],
    [-2, -3, -3, -3, -2, -3, -3, -3, -1, 0, 0, -3, 0, 6, -4, -2, -2, 1, 3, -1, -3, -3, -1],
    [-1, -2, -2, -1, -3, -1, -1, -2, -2, -3, -3, -1, -2, -4, 7, -1, -1, -4, -3, -2, -2, -1, -2],
    [1, -1, 1, 0, -1, 0, 0, 0, -1, -2, -2, 0, -1, -2, -1, 4, 1, -3, -2, -2, 0, 0, 0],
    [0, -1, 0, -1, -1, -1, -1, -2, -2, -1, -1, -1, -1, -2, -1, 1, 5, -2, -2, 0, -1, -1, 0],
    [-3, -3, -4, -4, -2, -2, -3, -2, -2, -3, -2, -3, -1, 1, -4, -3, -2, 11, 2, -3, -4, -3, -2],
    [-2, -2, -2, -3, -2, -1, -2, -3, 2, -1, -1, -2, -1, 3, -3, -2, -2, 2, 7, -1, -3, -2, -1],
    [0, -3, -3, -3, -1, -2, -2, -3, -3, 3, 1, -2, 1, -1, -2, -2, 0, -3, -1, 4, -3, -2, -1],
    [-2, -1, 3, 4, -3, 0, 1, -1, 0, -3, -4, 0, -3, -3, -2, 0, -1, -4, -3, -3, 4, 1, -1],
    [-1, 0, 0, 1, -3, 3, 4, -2, 0, -3, -3, 1, -1, -3, -1, 0, -1, -3, -2, -2, 1, 4, -1],
    [0, -1, -1, -1, -2, -1, -1, -1, -1, -1, -1, -1, -1, -1, -2, 0, 0, -2, -1, -1, -1, -1, -1] // X
];
function prepareMatrix(cellNames, mat) {
    var j;
    var i = 0;
    var matDict = {};
    mat.forEach(function (row) {
        j = 0;
        var rowDict = {};
        row.forEach(function (elm) { return rowDict[cellNames[j++]] = elm; });
        matDict[cellNames[i++]] = rowDict;
    });
    return matDict;
}
var SubstitutionMatrices = (function () { return ({
    blosum62: prepareMatrix(aminoacids, blosum62),
    blosum62x: prepareMatrix(aminoacidsX, blosum62x)
}); })();
//# sourceMappingURL=substitution-matrix.js.map

/***/ }),

/***/ "./lib/mol-model/sequence/constants.js":
/*!*********************************************!*\
  !*** ./lib/mol-model/sequence/constants.js ***!
  \*********************************************/
/*! exports provided: getProteinOneLetterCode, getRnaOneLetterCode, getDnaOneLetterCode */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getProteinOneLetterCode", function() { return getProteinOneLetterCode; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getRnaOneLetterCode", function() { return getRnaOneLetterCode; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getDnaOneLetterCode", function() { return getDnaOneLetterCode; });
/**
 * Copyright (c) 2018 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author David Sehnal <david.sehnal@gmail.com>
 */
// from NGL
var ProteinOneLetterCodes = {
    'HIS': 'H',
    'ARG': 'R',
    'LYS': 'K',
    'ILE': 'I',
    'PHE': 'F',
    'LEU': 'L',
    'TRP': 'W',
    'ALA': 'A',
    'MET': 'M',
    'PRO': 'P',
    'CYS': 'C',
    'ASN': 'N',
    'VAL': 'V',
    'GLY': 'G',
    'SER': 'S',
    'GLN': 'Q',
    'TYR': 'Y',
    'ASP': 'D',
    'GLU': 'E',
    'THR': 'T',
    'SEC': 'U',
    'PYL': 'O',
};
var DnaOneLetterCodes = {
    'DA': 'A',
    'DC': 'C',
    'DG': 'G',
    'DT': 'T',
    'DU': 'U'
};
var RnaOneLetterCodes = {
    'A': 'A',
    'C': 'C',
    'G': 'G',
    'T': 'T',
    'U': 'U'
};
function getProteinOneLetterCode(residueName) {
    var code = ProteinOneLetterCodes[residueName];
    return code || 'X';
}
function getRnaOneLetterCode(residueName) {
    var code = RnaOneLetterCodes[residueName];
    return code || 'X';
}
function getDnaOneLetterCode(residueName) {
    var code = DnaOneLetterCodes[residueName];
    return code || 'X';
}
//# sourceMappingURL=constants.js.map

/***/ }),

/***/ "./lib/mol-model/sequence/sequence.js":
/*!********************************************!*\
  !*** ./lib/mol-model/sequence/sequence.js ***!
  \********************************************/
/*! exports provided: Sequence */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Sequence", function() { return Sequence; });
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./constants */ "./lib/mol-model/sequence/constants.js");
/* harmony import */ var _mol_data_db__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../mol-data/db */ "./lib/mol-data/db.js");
/**
 * Copyright (c) 2018-2020 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author David Sehnal <david.sehnal@gmail.com>
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */


var Sequence;
(function (Sequence) {
    function getSequenceString(seq) {
        var array = seq.code.toArray();
        return (array instanceof Array ? array : Array.from(array)).join('');
    }
    Sequence.getSequenceString = getSequenceString;
    function determineKind(names) {
        for (var i = 0, _i = Math.min(names.rowCount, 10); i < _i; i++) {
            var name_1 = names.value(i) || '';
            if (Object(_constants__WEBPACK_IMPORTED_MODULE_0__["getProteinOneLetterCode"])(name_1) !== 'X')
                return "protein" /* Protein */;
            if (Object(_constants__WEBPACK_IMPORTED_MODULE_0__["getRnaOneLetterCode"])(name_1) !== 'X')
                return "RNA" /* RNA */;
            if (Object(_constants__WEBPACK_IMPORTED_MODULE_0__["getDnaOneLetterCode"])(name_1) !== 'X')
                return "DNA" /* DNA */;
        }
        return "generic" /* Generic */;
    }
    function codeProvider(kind, map) {
        var code;
        switch (kind) {
            case "protein" /* Protein */:
                code = _constants__WEBPACK_IMPORTED_MODULE_0__["getProteinOneLetterCode"];
                break;
            case "DNA" /* DNA */:
                code = _constants__WEBPACK_IMPORTED_MODULE_0__["getDnaOneLetterCode"];
                break;
            case "RNA" /* RNA */:
                code = _constants__WEBPACK_IMPORTED_MODULE_0__["getRnaOneLetterCode"];
                break;
            case "generic" /* Generic */:
                code = function () { return 'X'; };
                break;
            default: throw new Error("unknown kind '" + kind + "'");
        }
        if (map && map.size > 0) {
            return function (name) {
                var ret = code(name);
                if (ret !== 'X' || !map.has(name))
                    return ret;
                return code(map.get(name));
            };
        }
        return code;
    }
    function ofResidueNames(compId, seqId) {
        if (seqId.rowCount === 0)
            throw new Error('cannot be empty');
        var kind = determineKind(compId);
        return new ResidueNamesImpl(kind, compId, seqId);
    }
    Sequence.ofResidueNames = ofResidueNames;
    var ResidueNamesImpl = /** @class */ (function () {
        function ResidueNamesImpl(kind, compId, seqId) {
            this.kind = kind;
            this.microHet = new Map();
            var codeFromName = codeProvider(kind);
            var codes = [];
            var compIds = [];
            var seqIds = [];
            var microHet = new Map();
            var idx = 0;
            var indexMap = new Map();
            for (var i = 0, il = seqId.rowCount; i < il; ++i) {
                var seq_id = seqId.value(i);
                if (!indexMap.has(seq_id)) {
                    indexMap.set(seq_id, idx);
                    var comp_id = compId.value(i);
                    compIds[idx] = comp_id;
                    seqIds[idx] = seq_id;
                    codes[idx] = codeFromName(comp_id);
                    idx += 1;
                }
                else {
                    // micro-heterogeneity
                    if (!microHet.has(seq_id)) {
                        microHet.set(seq_id, [compIds[indexMap.get(seq_id)], compId.value(i)]);
                    }
                    else {
                        microHet.get(seq_id).push(compId.value(i));
                    }
                }
            }
            var labels = [];
            for (var i = 0, il = idx; i < il; ++i) {
                var mh = microHet.get(seqIds[i]);
                if (mh) {
                    var l = mh.map(function (id) {
                        var c = codeFromName(id);
                        return c === 'X' ? id : c;
                    });
                    labels[i] = "(" + l.join('|') + ")";
                }
                else {
                    labels[i] = codes[i] === 'X' ? compIds[i] : codes[i];
                }
            }
            this.length = idx;
            this.code = _mol_data_db__WEBPACK_IMPORTED_MODULE_1__["Column"].ofStringArray(codes);
            this.compId = _mol_data_db__WEBPACK_IMPORTED_MODULE_1__["Column"].ofStringArray(compIds);
            this.seqId = _mol_data_db__WEBPACK_IMPORTED_MODULE_1__["Column"].ofIntArray(seqIds);
            this.label = _mol_data_db__WEBPACK_IMPORTED_MODULE_1__["Column"].ofStringArray(labels);
            this.microHet = microHet;
            this.indexMap = indexMap;
        }
        ResidueNamesImpl.prototype.index = function (seqId) {
            return this.indexMap.get(seqId);
        };
        return ResidueNamesImpl;
    }());
    function ofSequenceRanges(seqIdBegin, seqIdEnd) {
        var kind = "generic" /* Generic */;
        return new SequenceRangesImpl(kind, seqIdBegin, seqIdEnd);
    }
    Sequence.ofSequenceRanges = ofSequenceRanges;
    var SequenceRangesImpl = /** @class */ (function () {
        function SequenceRangesImpl(kind, seqIdStart, seqIdEnd) {
            this.kind = kind;
            this.seqIdStart = seqIdStart;
            this.seqIdEnd = seqIdEnd;
            this.microHet = new Map();
            var maxSeqId = 0, minSeqId = Number.MAX_SAFE_INTEGER;
            for (var i = 0, _i = this.seqIdStart.rowCount; i < _i; i++) {
                var idStart = this.seqIdStart.value(i);
                var idEnd = this.seqIdEnd.value(i);
                if (idStart < minSeqId)
                    minSeqId = idStart;
                if (maxSeqId < idEnd)
                    maxSeqId = idEnd;
            }
            var count = maxSeqId - minSeqId + 1;
            this.code = _mol_data_db__WEBPACK_IMPORTED_MODULE_1__["Column"].ofConst('X', count, _mol_data_db__WEBPACK_IMPORTED_MODULE_1__["Column"].Schema.str);
            this.label = _mol_data_db__WEBPACK_IMPORTED_MODULE_1__["Column"].ofConst('', count, _mol_data_db__WEBPACK_IMPORTED_MODULE_1__["Column"].Schema.str);
            this.seqId = _mol_data_db__WEBPACK_IMPORTED_MODULE_1__["Column"].ofLambda({
                value: function (row) { return row + minSeqId + 1; },
                rowCount: count,
                schema: _mol_data_db__WEBPACK_IMPORTED_MODULE_1__["Column"].Schema.int
            });
            this.compId = _mol_data_db__WEBPACK_IMPORTED_MODULE_1__["Column"].ofConst('', count, _mol_data_db__WEBPACK_IMPORTED_MODULE_1__["Column"].Schema.str);
            this.length = count;
            this.minSeqId = minSeqId;
        }
        SequenceRangesImpl.prototype.index = function (seqId) {
            return seqId - this.minSeqId;
        };
        return SequenceRangesImpl;
    }());
})(Sequence || (Sequence = {}));

//# sourceMappingURL=sequence.js.map

/***/ }),

/***/ "./lib/mol-model/shape.js":
/*!********************************!*\
  !*** ./lib/mol-model/shape.js ***!
  \********************************/
/*! exports provided: Shape, ShapeGroup */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _shape_shape__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./shape/shape */ "./lib/mol-model/shape/shape.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Shape", function() { return _shape_shape__WEBPACK_IMPORTED_MODULE_0__["Shape"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ShapeGroup", function() { return _shape_shape__WEBPACK_IMPORTED_MODULE_0__["ShapeGroup"]; });

/**
 * Copyright (c) 2018 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */

//# sourceMappingURL=shape.js.map

/***/ }),

/***/ "./lib/mol-model/shape/shape.js":
/*!**************************************!*\
  !*** ./lib/mol-model/shape/shape.js ***!
  \**************************************/
/*! exports provided: Shape, ShapeGroup */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Shape", function() { return Shape; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ShapeGroup", function() { return ShapeGroup; });
/* harmony import */ var _mol_util__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../mol-util */ "./lib/mol-util/index.js");
/* harmony import */ var _mol_data_int__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../mol-data/int */ "./lib/mol-data/int.js");
/* harmony import */ var _mol_geo_geometry_geometry__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../mol-geo/geometry/geometry */ "./lib/mol-geo/geometry/geometry.js");
/* harmony import */ var _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../mol-math/linear-algebra */ "./lib/mol-math/linear-algebra.js");
/* harmony import */ var _mol_math_geometry__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../mol-math/geometry */ "./lib/mol-math/geometry.js");
/* harmony import */ var _mol_math_geometry_centroid_helper__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../mol-math/geometry/centroid-helper */ "./lib/mol-math/geometry/centroid-helper.js");
/* harmony import */ var _mol_theme_size_shape_group__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../../mol-theme/size/shape-group */ "./lib/mol-theme/size/shape-group.js");
/* harmony import */ var _mol_theme_color_shape_group__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../../mol-theme/color/shape-group */ "./lib/mol-theme/color/shape-group.js");
/* harmony import */ var _mol_geo_geometry_transform_data__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ../../mol-geo/geometry/transform-data */ "./lib/mol-geo/geometry/transform-data.js");
/* harmony import */ var _mol_gl_render_object__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ../../mol-gl/render-object */ "./lib/mol-gl/render-object.js");
/* harmony import */ var _mol_geo_util_location_iterator__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ../../mol-geo/util/location-iterator */ "./lib/mol-geo/util/location-iterator.js");
/**
 * Copyright (c) 2018-2020 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */











var Shape;
(function (Shape) {
    function create(name, sourceData, geometry, getColor, getSize, getLabel, transforms) {
        return {
            id: _mol_util__WEBPACK_IMPORTED_MODULE_0__["UUID"].create22(),
            name: name,
            sourceData: sourceData,
            geometry: geometry,
            transforms: transforms || [_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_3__["Mat4"].identity()],
            get groupCount() { return _mol_geo_geometry_geometry__WEBPACK_IMPORTED_MODULE_2__["Geometry"].getGroupCount(geometry); },
            getColor: getColor,
            getSize: getSize,
            getLabel: getLabel
        };
    }
    Shape.create = create;
    function getTheme(shape) {
        return {
            color: Object(_mol_theme_color_shape_group__WEBPACK_IMPORTED_MODULE_7__["ShapeGroupColorTheme"])({ shape: shape }, {}),
            size: Object(_mol_theme_size_shape_group__WEBPACK_IMPORTED_MODULE_6__["ShapeGroupSizeTheme"])({ shape: shape }, {})
        };
    }
    Shape.getTheme = getTheme;
    function groupIterator(shape) {
        var instanceCount = shape.transforms.length;
        var location = ShapeGroup.Location(shape);
        var getLocation = function (groupIndex, instanceIndex) {
            location.group = groupIndex;
            location.instance = instanceIndex;
            return location;
        };
        return Object(_mol_geo_util_location_iterator__WEBPACK_IMPORTED_MODULE_10__["LocationIterator"])(shape.groupCount, instanceCount, 1, getLocation);
    }
    Shape.groupIterator = groupIterator;
    function createTransform(transforms, transformData) {
        var transformArray = transformData && transformData.aTransform.ref.value.length >= transforms.length * 16 ? transformData.aTransform.ref.value : new Float32Array(transforms.length * 16);
        for (var i = 0, il = transforms.length; i < il; ++i) {
            _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_3__["Mat4"].toArray(transforms[i], transformArray, i * 16);
        }
        return Object(_mol_geo_geometry_transform_data__WEBPACK_IMPORTED_MODULE_8__["createTransform"])(transformArray, transforms.length, transformData);
    }
    Shape.createTransform = createTransform;
    function createRenderObject(shape, props) {
        props;
        var theme = Shape.getTheme(shape);
        var utils = _mol_geo_geometry_geometry__WEBPACK_IMPORTED_MODULE_2__["Geometry"].getUtils(shape.geometry);
        var materialId = Object(_mol_gl_render_object__WEBPACK_IMPORTED_MODULE_9__["getNextMaterialId"])();
        var locationIt = groupIterator(shape);
        var transform = Shape.createTransform(shape.transforms);
        var values = utils.createValues(shape.geometry, transform, locationIt, theme, props);
        var state = utils.createRenderableState(props);
        return Object(_mol_gl_render_object__WEBPACK_IMPORTED_MODULE_9__["createRenderObject"])(shape.geometry.kind, values, state, materialId);
    }
    Shape.createRenderObject = createRenderObject;
    function Loci(shape) { return { kind: 'shape-loci', shape: shape }; }
    Shape.Loci = Loci;
    function isLoci(x) { return !!x && x.kind === 'shape-loci'; }
    Shape.isLoci = isLoci;
    function areLociEqual(a, b) { return a.shape === b.shape; }
    Shape.areLociEqual = areLociEqual;
    function isLociEmpty(loci) { return loci.shape.groupCount === 0; }
    Shape.isLociEmpty = isLociEmpty;
})(Shape || (Shape = {}));
var ShapeGroup;
(function (ShapeGroup) {
    function Location(shape, group, instance) {
        if (group === void 0) { group = 0; }
        if (instance === void 0) { instance = 0; }
        return { kind: 'group-location', shape: shape, group: group, instance: instance };
    }
    ShapeGroup.Location = Location;
    function isLocation(x) {
        return !!x && x.kind === 'group-location';
    }
    ShapeGroup.isLocation = isLocation;
    function Loci(shape, groups) {
        return { kind: 'group-loci', shape: shape, groups: groups };
    }
    ShapeGroup.Loci = Loci;
    function isLoci(x) {
        return !!x && x.kind === 'group-loci';
    }
    ShapeGroup.isLoci = isLoci;
    function areLociEqual(a, b) {
        if (a.shape !== b.shape)
            return false;
        if (a.groups.length !== b.groups.length)
            return false;
        for (var i = 0, il = a.groups.length; i < il; ++i) {
            var _a = a.groups[i], idsA = _a.ids, instanceA = _a.instance;
            var _b = b.groups[i], idsB = _b.ids, instanceB = _b.instance;
            if (instanceA !== instanceB)
                return false;
            if (!_mol_data_int__WEBPACK_IMPORTED_MODULE_1__["OrderedSet"].areEqual(idsA, idsB))
                return false;
        }
        return true;
    }
    ShapeGroup.areLociEqual = areLociEqual;
    function isLociEmpty(loci) {
        return size(loci) === 0 ? true : false;
    }
    ShapeGroup.isLociEmpty = isLociEmpty;
    function size(loci) {
        var size = 0;
        for (var _i = 0, _a = loci.groups; _i < _a.length; _i++) {
            var group = _a[_i];
            size += _mol_data_int__WEBPACK_IMPORTED_MODULE_1__["OrderedSet"].size(group.ids);
        }
        return size;
    }
    ShapeGroup.size = size;
    var sphereHelper = new _mol_math_geometry_centroid_helper__WEBPACK_IMPORTED_MODULE_5__["CentroidHelper"](), tmpPos = _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_3__["Vec3"].zero();
    function sphereHelperInclude(groups, mapping, positions, transforms) {
        var indices = mapping.indices, offsets = mapping.offsets;
        var _loop_1 = function (ids, instance) {
            _mol_data_int__WEBPACK_IMPORTED_MODULE_1__["OrderedSet"].forEach(ids, function (v) {
                for (var i = offsets[v], il = offsets[v + 1]; i < il; ++i) {
                    _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_3__["Vec3"].fromArray(tmpPos, positions, indices[i] * 3);
                    _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_3__["Vec3"].transformMat4(tmpPos, tmpPos, transforms[instance]);
                    sphereHelper.includeStep(tmpPos);
                }
            });
        };
        for (var _i = 0, groups_1 = groups; _i < groups_1.length; _i++) {
            var _a = groups_1[_i], ids = _a.ids, instance = _a.instance;
            _loop_1(ids, instance);
        }
    }
    function sphereHelperRadius(groups, mapping, positions, transforms) {
        var indices = mapping.indices, offsets = mapping.offsets;
        var _loop_2 = function (ids, instance) {
            _mol_data_int__WEBPACK_IMPORTED_MODULE_1__["OrderedSet"].forEach(ids, function (v) {
                for (var i = offsets[v], il = offsets[v + 1]; i < il; ++i) {
                    _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_3__["Vec3"].fromArray(tmpPos, positions, indices[i] * 3);
                    _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_3__["Vec3"].transformMat4(tmpPos, tmpPos, transforms[instance]);
                    sphereHelper.radiusStep(tmpPos);
                }
            });
        };
        for (var _i = 0, groups_2 = groups; _i < groups_2.length; _i++) {
            var _a = groups_2[_i], ids = _a.ids, instance = _a.instance;
            _loop_2(ids, instance);
        }
    }
    function getBoundingSphere(loci, boundingSphere) {
        if (!boundingSphere)
            boundingSphere = Object(_mol_math_geometry__WEBPACK_IMPORTED_MODULE_4__["Sphere3D"])();
        sphereHelper.reset();
        var padding = 0;
        var _a = loci.shape, geometry = _a.geometry, transforms = _a.transforms;
        if (geometry.kind === 'mesh' || geometry.kind === 'points') {
            var positions = geometry.kind === 'mesh'
                ? geometry.vertexBuffer.ref.value
                : geometry.centerBuffer.ref.value;
            sphereHelperInclude(loci.groups, geometry.groupMapping, positions, transforms);
            sphereHelper.finishedIncludeStep();
            sphereHelperRadius(loci.groups, geometry.groupMapping, positions, transforms);
        }
        else if (geometry.kind === 'lines') {
            var start = geometry.startBuffer.ref.value;
            var end = geometry.endBuffer.ref.value;
            sphereHelperInclude(loci.groups, geometry.groupMapping, start, transforms);
            sphereHelperInclude(loci.groups, geometry.groupMapping, end, transforms);
            sphereHelper.finishedIncludeStep();
            sphereHelperRadius(loci.groups, geometry.groupMapping, start, transforms);
            sphereHelperRadius(loci.groups, geometry.groupMapping, end, transforms);
        }
        else if (geometry.kind === 'spheres' || geometry.kind === 'text') {
            var positions = geometry.centerBuffer.ref.value;
            sphereHelperInclude(loci.groups, geometry.groupMapping, positions, transforms);
            sphereHelper.finishedIncludeStep();
            sphereHelperRadius(loci.groups, geometry.groupMapping, positions, transforms);
            var _loop_3 = function (ids, instance) {
                _mol_data_int__WEBPACK_IMPORTED_MODULE_1__["OrderedSet"].forEach(ids, function (v) {
                    var value = loci.shape.getSize(v, instance);
                    if (padding < value)
                        padding = value;
                });
            };
            for (var _i = 0, _b = loci.groups; _i < _b.length; _i++) {
                var _c = _b[_i], ids = _c.ids, instance = _c.instance;
                _loop_3(ids, instance);
            }
        }
        else {
            // use whole shape bounding-sphere for other geometry kinds
            return _mol_math_geometry__WEBPACK_IMPORTED_MODULE_4__["Sphere3D"].copy(boundingSphere, geometry.boundingSphere);
        }
        _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_3__["Vec3"].copy(boundingSphere.center, sphereHelper.center);
        boundingSphere.radius = Math.sqrt(sphereHelper.radiusSq);
        _mol_math_geometry__WEBPACK_IMPORTED_MODULE_4__["Sphere3D"].expand(boundingSphere, boundingSphere, padding);
        return boundingSphere;
    }
    ShapeGroup.getBoundingSphere = getBoundingSphere;
})(ShapeGroup || (ShapeGroup = {}));
//# sourceMappingURL=shape.js.map

/***/ }),

/***/ "./lib/mol-model/structure.js":
/*!************************************!*\
  !*** ./lib/mol-model/structure.js ***!
  \************************************/
/*! exports provided: Time, Coordinates, Topology, IndexedCustomProperty, Model, Types, Symmetry, StructureSequence, StructureElement, Bond, Structure, Unit, StructureSymmetry, StructureProperties, UnitRing, UnitRings, CifExportContext, mmCIF_Export_Filters, encode_mmCIF_categories, QueryContext, Queries, StructureSelection, StructureQuery, ArrayTrajectory */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _structure_coordinates__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./structure/coordinates */ "./lib/mol-model/structure/coordinates.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Time", function() { return _structure_coordinates__WEBPACK_IMPORTED_MODULE_0__["Time"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Coordinates", function() { return _structure_coordinates__WEBPACK_IMPORTED_MODULE_0__["Coordinates"]; });

/* harmony import */ var _structure_topology__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./structure/topology */ "./lib/mol-model/structure/topology.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Topology", function() { return _structure_topology__WEBPACK_IMPORTED_MODULE_1__["Topology"]; });

/* harmony import */ var _structure_model__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./structure/model */ "./lib/mol-model/structure/model.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "IndexedCustomProperty", function() { return _structure_model__WEBPACK_IMPORTED_MODULE_2__["IndexedCustomProperty"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Model", function() { return _structure_model__WEBPACK_IMPORTED_MODULE_2__["Model"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Types", function() { return _structure_model__WEBPACK_IMPORTED_MODULE_2__["Types"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Symmetry", function() { return _structure_model__WEBPACK_IMPORTED_MODULE_2__["Symmetry"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "StructureSequence", function() { return _structure_model__WEBPACK_IMPORTED_MODULE_2__["StructureSequence"]; });

/* harmony import */ var _structure_structure__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./structure/structure */ "./lib/mol-model/structure/structure.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "StructureElement", function() { return _structure_structure__WEBPACK_IMPORTED_MODULE_3__["StructureElement"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Bond", function() { return _structure_structure__WEBPACK_IMPORTED_MODULE_3__["Bond"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Structure", function() { return _structure_structure__WEBPACK_IMPORTED_MODULE_3__["Structure"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Unit", function() { return _structure_structure__WEBPACK_IMPORTED_MODULE_3__["Unit"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "StructureSymmetry", function() { return _structure_structure__WEBPACK_IMPORTED_MODULE_3__["StructureSymmetry"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "StructureProperties", function() { return _structure_structure__WEBPACK_IMPORTED_MODULE_3__["StructureProperties"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "UnitRing", function() { return _structure_structure__WEBPACK_IMPORTED_MODULE_3__["UnitRing"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "UnitRings", function() { return _structure_structure__WEBPACK_IMPORTED_MODULE_3__["UnitRings"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "CifExportContext", function() { return _structure_structure__WEBPACK_IMPORTED_MODULE_3__["CifExportContext"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "mmCIF_Export_Filters", function() { return _structure_structure__WEBPACK_IMPORTED_MODULE_3__["mmCIF_Export_Filters"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "encode_mmCIF_categories", function() { return _structure_structure__WEBPACK_IMPORTED_MODULE_3__["encode_mmCIF_categories"]; });

/* harmony import */ var _structure_query__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./structure/query */ "./lib/mol-model/structure/query.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "QueryContext", function() { return _structure_query__WEBPACK_IMPORTED_MODULE_4__["QueryContext"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Queries", function() { return _structure_query__WEBPACK_IMPORTED_MODULE_4__["Queries"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "StructureSelection", function() { return _structure_query__WEBPACK_IMPORTED_MODULE_4__["StructureSelection"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "StructureQuery", function() { return _structure_query__WEBPACK_IMPORTED_MODULE_4__["StructureQuery"]; });

/* harmony import */ var _structure_trajectory__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./structure/trajectory */ "./lib/mol-model/structure/trajectory.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ArrayTrajectory", function() { return _structure_trajectory__WEBPACK_IMPORTED_MODULE_5__["ArrayTrajectory"]; });

/**
 * Copyright (c) 2017-2019 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author David Sehnal <david.sehnal@gmail.com>
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */






//# sourceMappingURL=structure.js.map

/***/ }),

/***/ "./lib/mol-model/structure/coordinates.js":
/*!************************************************!*\
  !*** ./lib/mol-model/structure/coordinates.js ***!
  \************************************************/
/*! exports provided: Time, Coordinates */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _coordinates_coordinates__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./coordinates/coordinates */ "./lib/mol-model/structure/coordinates/coordinates.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Time", function() { return _coordinates_coordinates__WEBPACK_IMPORTED_MODULE_0__["Time"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Coordinates", function() { return _coordinates_coordinates__WEBPACK_IMPORTED_MODULE_0__["Coordinates"]; });

/**
 * Copyright (c) 2019 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */

//# sourceMappingURL=coordinates.js.map

/***/ }),

/***/ "./lib/mol-model/structure/coordinates/coordinates.js":
/*!************************************************************!*\
  !*** ./lib/mol-model/structure/coordinates/coordinates.js ***!
  \************************************************************/
/*! exports provided: Time, Coordinates */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Time", function() { return Time; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Coordinates", function() { return Coordinates; });
/* harmony import */ var _mol_util__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../../mol-util */ "./lib/mol-util/index.js");
/* harmony import */ var _mol_data_db__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../../mol-data/db */ "./lib/mol-data/db.js");
/**
 * Copyright (c) 2019-2020 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */


//

function Time(value, unit) {
    return { value: value, unit: unit };
}
//

var Coordinates;
(function (Coordinates) {
    function create(frames, deltaTime, timeOffset) {
        var hasCell = !!frames[0].cell;
        var hasVelocities = !!frames[0].velocities;
        var hasForces = !!frames[0].forces;
        return {
            id: _mol_util__WEBPACK_IMPORTED_MODULE_0__["UUID"].create22(),
            frames: frames,
            hasCell: hasCell,
            hasVelocities: hasVelocities,
            hasForces: hasForces,
            deltaTime: deltaTime,
            timeOffset: timeOffset
        };
    }
    Coordinates.create = create;
    function getAtomicConformation(frame, atomId) {
        return {
            id: _mol_util__WEBPACK_IMPORTED_MODULE_0__["UUID"].create22(),
            atomId: atomId,
            occupancy: _mol_data_db__WEBPACK_IMPORTED_MODULE_1__["Column"].ofConst(1, frame.elementCount, _mol_data_db__WEBPACK_IMPORTED_MODULE_1__["Column"].Schema.int),
            B_iso_or_equiv: _mol_data_db__WEBPACK_IMPORTED_MODULE_1__["Column"].ofConst(0, frame.elementCount, _mol_data_db__WEBPACK_IMPORTED_MODULE_1__["Column"].Schema.float),
            xyzDefined: true,
            x: frame.x,
            y: frame.y,
            z: frame.z,
        };
    }
    Coordinates.getAtomicConformation = getAtomicConformation;
    function reorderCoords(xs, index) {
        var ret = new Float32Array(xs.length);
        for (var i = 0, _i = xs.length; i < _i; i++) {
            ret[i] = xs[index[i]];
        }
        return ret;
    }
    function getAtomicConformationReordered(frame, atomId, srcIndex) {
        return {
            id: _mol_util__WEBPACK_IMPORTED_MODULE_0__["UUID"].create22(),
            atomId: atomId,
            occupancy: _mol_data_db__WEBPACK_IMPORTED_MODULE_1__["Column"].ofConst(1, frame.elementCount, _mol_data_db__WEBPACK_IMPORTED_MODULE_1__["Column"].Schema.int),
            B_iso_or_equiv: _mol_data_db__WEBPACK_IMPORTED_MODULE_1__["Column"].ofConst(0, frame.elementCount, _mol_data_db__WEBPACK_IMPORTED_MODULE_1__["Column"].Schema.float),
            xyzDefined: true,
            x: reorderCoords(frame.x, srcIndex),
            y: reorderCoords(frame.y, srcIndex),
            z: reorderCoords(frame.z, srcIndex)
        };
    }
    Coordinates.getAtomicConformationReordered = getAtomicConformationReordered;
})(Coordinates || (Coordinates = {}));
//# sourceMappingURL=coordinates.js.map

/***/ }),

/***/ "./lib/mol-model/structure/export/categories/atom_site.js":
/*!****************************************************************!*\
  !*** ./lib/mol-model/structure/export/categories/atom_site.js ***!
  \****************************************************************/
/*! exports provided: _atom_site, residueIdFields, chainIdFields, entityIdFields, atomIdFields */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_atom_site", function() { return _atom_site; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "residueIdFields", function() { return residueIdFields; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "chainIdFields", function() { return chainIdFields; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "entityIdFields", function() { return entityIdFields; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "atomIdFields", function() { return atomIdFields; });
/* harmony import */ var _mol_io_writer_cif__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../../../mol-io/writer/cif */ "./lib/mol-io/writer/cif.js");
/* harmony import */ var _structure__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../structure */ "./lib/mol-model/structure/structure.js");
/**
 * Copyright (c) 2017-2018 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author David Sehnal <david.sehnal@gmail.com>
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */


var CifField = _mol_io_writer_cif__WEBPACK_IMPORTED_MODULE_0__["CifWriter"].Field;
var E = _mol_io_writer_cif__WEBPACK_IMPORTED_MODULE_0__["CifWriter"].Encodings;
var _label_asym_id = _structure__WEBPACK_IMPORTED_MODULE_1__["StructureProperties"].chain.label_asym_id;
function atom_site_label_asym_id(e) {
    var l = _label_asym_id(e);
    var suffix = e.unit.conformation.operator.suffix;
    if (!suffix)
        return l;
    return l + suffix;
}
var _auth_asym_id = _structure__WEBPACK_IMPORTED_MODULE_1__["StructureProperties"].chain.auth_asym_id;
function atom_site_auth_asym_id(e) {
    var l = _auth_asym_id(e);
    var suffix = e.unit.conformation.operator.suffix;
    if (!suffix)
        return l;
    return l + suffix;
}
var atom_site_fields = _mol_io_writer_cif__WEBPACK_IMPORTED_MODULE_0__["CifWriter"].fields()
    .str('group_PDB', _structure__WEBPACK_IMPORTED_MODULE_1__["StructureProperties"].residue.group_PDB)
    .index('id')
    .str('type_symbol', _structure__WEBPACK_IMPORTED_MODULE_1__["StructureProperties"].atom.type_symbol)
    .str('label_atom_id', _structure__WEBPACK_IMPORTED_MODULE_1__["StructureProperties"].atom.label_atom_id)
    .str('label_comp_id', _structure__WEBPACK_IMPORTED_MODULE_1__["StructureProperties"].atom.label_comp_id)
    .int('label_seq_id', _structure__WEBPACK_IMPORTED_MODULE_1__["StructureProperties"].residue.label_seq_id, {
    encoder: E.deltaRLE,
    valueKind: function (k, d) {
        var m = k.unit.model;
        return m.atomicHierarchy.residues.label_seq_id.valueKind(m.atomicHierarchy.residueAtomSegments.index[k.element]);
    }
})
    .str('label_alt_id', _structure__WEBPACK_IMPORTED_MODULE_1__["StructureProperties"].atom.label_alt_id)
    .str('pdbx_PDB_ins_code', _structure__WEBPACK_IMPORTED_MODULE_1__["StructureProperties"].residue.pdbx_PDB_ins_code)
    .str('label_asym_id', atom_site_label_asym_id)
    .str('label_entity_id', _structure__WEBPACK_IMPORTED_MODULE_1__["StructureProperties"].chain.label_entity_id)
    .float('Cartn_x', _structure__WEBPACK_IMPORTED_MODULE_1__["StructureProperties"].atom.x, { digitCount: 3, encoder: E.fixedPoint3 })
    .float('Cartn_y', _structure__WEBPACK_IMPORTED_MODULE_1__["StructureProperties"].atom.y, { digitCount: 3, encoder: E.fixedPoint3 })
    .float('Cartn_z', _structure__WEBPACK_IMPORTED_MODULE_1__["StructureProperties"].atom.z, { digitCount: 3, encoder: E.fixedPoint3 })
    .float('occupancy', _structure__WEBPACK_IMPORTED_MODULE_1__["StructureProperties"].atom.occupancy, { digitCount: 2, encoder: E.fixedPoint2 })
    .float('B_iso_or_equiv', _structure__WEBPACK_IMPORTED_MODULE_1__["StructureProperties"].atom.B_iso_or_equiv, { digitCount: 2, encoder: E.fixedPoint2 })
    .int('pdbx_formal_charge', _structure__WEBPACK_IMPORTED_MODULE_1__["StructureProperties"].atom.pdbx_formal_charge, {
    encoder: E.deltaRLE,
    valueKind: function (k, d) { return k.unit.model.atomicHierarchy.atoms.pdbx_formal_charge.valueKind(k.element); }
})
    .str('auth_atom_id', _structure__WEBPACK_IMPORTED_MODULE_1__["StructureProperties"].atom.auth_atom_id)
    .str('auth_comp_id', _structure__WEBPACK_IMPORTED_MODULE_1__["StructureProperties"].atom.auth_comp_id)
    .int('auth_seq_id', _structure__WEBPACK_IMPORTED_MODULE_1__["StructureProperties"].residue.auth_seq_id, { encoder: E.deltaRLE })
    .str('auth_asym_id', atom_site_auth_asym_id)
    .int('pdbx_PDB_model_num', _structure__WEBPACK_IMPORTED_MODULE_1__["StructureProperties"].unit.model_num, { encoder: E.deltaRLE })
    // .str('operator_name', P.unit.operator_name, {
    //     shouldInclude: structure => structure.units.some(u => !u.conformation.operator.isIdentity)
    // })
    .getFields();
var _atom_site = {
    name: 'atom_site',
    instance: function (_a) {
        var structures = _a.structures;
        return {
            fields: atom_site_fields,
            source: structures.map(function (s) { return ({
                data: s,
                rowCount: s.elementCount,
                keys: function () { return s.elementLocations(); }
            }); })
        };
    }
};
function prepostfixed(prefix, name) {
    if (prefix)
        return prefix + "_" + name;
    return name;
}
function prefixedInsCode(prefix) {
    if (!prefix)
        return 'pdbx_PDB_ins_code';
    return "pdbx_" + prefix + "_PDB_ins_code";
}
function mappedProp(loc, prop) {
    return function (k, d) { return prop(loc(k, d)); };
}
function addModelNum(fields, getLocation, options) {
    if (options && options.includeModelNum) {
        fields.int('pdbx_PDB_model_num', mappedProp(getLocation, _structure__WEBPACK_IMPORTED_MODULE_1__["StructureProperties"].unit.model_num));
    }
}
function residueIdFields(getLocation, options) {
    var prefix = options && options.prefix;
    var ret = _mol_io_writer_cif__WEBPACK_IMPORTED_MODULE_0__["CifWriter"].fields()
        .str(prepostfixed(prefix, "label_comp_id"), mappedProp(getLocation, _structure__WEBPACK_IMPORTED_MODULE_1__["StructureProperties"].atom.label_comp_id))
        .int(prepostfixed(prefix, "label_seq_id"), mappedProp(getLocation, _structure__WEBPACK_IMPORTED_MODULE_1__["StructureProperties"].residue.label_seq_id), {
        encoder: E.deltaRLE,
        valueKind: function (k, d) {
            var e = getLocation(k, d);
            var m = e.unit.model;
            return m.atomicHierarchy.residues.label_seq_id.valueKind(m.atomicHierarchy.residueAtomSegments.index[e.element]);
        }
    })
        .str(prefixedInsCode(prefix), mappedProp(getLocation, _structure__WEBPACK_IMPORTED_MODULE_1__["StructureProperties"].residue.pdbx_PDB_ins_code))
        .str(prepostfixed(prefix, "label_asym_id"), mappedProp(getLocation, _structure__WEBPACK_IMPORTED_MODULE_1__["StructureProperties"].chain.label_asym_id))
        .str(prepostfixed(prefix, "label_entity_id"), mappedProp(getLocation, _structure__WEBPACK_IMPORTED_MODULE_1__["StructureProperties"].chain.label_entity_id))
        .str(prepostfixed(prefix, "auth_comp_id"), mappedProp(getLocation, _structure__WEBPACK_IMPORTED_MODULE_1__["StructureProperties"].atom.auth_comp_id))
        .int(prepostfixed(prefix, "auth_seq_id"), mappedProp(getLocation, _structure__WEBPACK_IMPORTED_MODULE_1__["StructureProperties"].residue.auth_seq_id), { encoder: E.deltaRLE })
        .str(prepostfixed(prefix, "auth_asym_id"), mappedProp(getLocation, _structure__WEBPACK_IMPORTED_MODULE_1__["StructureProperties"].chain.auth_asym_id));
    addModelNum(ret, getLocation, options);
    return ret.getFields();
}
function chainIdFields(getLocation, options) {
    var prefix = options && options.prefix;
    var ret = CifField.build()
        .str(prepostfixed(prefix, "label_asym_id"), mappedProp(getLocation, _structure__WEBPACK_IMPORTED_MODULE_1__["StructureProperties"].chain.label_asym_id))
        .str(prepostfixed(prefix, "label_entity_id"), mappedProp(getLocation, _structure__WEBPACK_IMPORTED_MODULE_1__["StructureProperties"].chain.label_entity_id))
        .str(prepostfixed(prefix, "auth_asym_id"), mappedProp(getLocation, _structure__WEBPACK_IMPORTED_MODULE_1__["StructureProperties"].chain.auth_asym_id));
    addModelNum(ret, getLocation, options);
    return ret.getFields();
}
function entityIdFields(getLocation, options) {
    var prefix = options && options.prefix;
    var ret = CifField.build()
        .str(prepostfixed(prefix, "label_entity_id"), mappedProp(getLocation, _structure__WEBPACK_IMPORTED_MODULE_1__["StructureProperties"].chain.label_entity_id));
    addModelNum(ret, getLocation, options);
    return ret.getFields();
}
function atomIdFields(getLocation, options) {
    var prefix = options && options.prefix;
    var ret = _mol_io_writer_cif__WEBPACK_IMPORTED_MODULE_0__["CifWriter"].fields()
        .str(prepostfixed(prefix, "label_atom_id"), mappedProp(getLocation, _structure__WEBPACK_IMPORTED_MODULE_1__["StructureProperties"].atom.label_atom_id))
        .str(prepostfixed(prefix, "label_comp_id"), mappedProp(getLocation, _structure__WEBPACK_IMPORTED_MODULE_1__["StructureProperties"].atom.label_comp_id))
        .int(prepostfixed(prefix, "label_seq_id"), mappedProp(getLocation, _structure__WEBPACK_IMPORTED_MODULE_1__["StructureProperties"].residue.label_seq_id), {
        encoder: E.deltaRLE,
        valueKind: function (k, d) {
            var e = getLocation(k, d);
            var m = e.unit.model;
            return m.atomicHierarchy.residues.label_seq_id.valueKind(m.atomicHierarchy.residueAtomSegments.index[e.element]);
        }
    })
        .str(prepostfixed(prefix, "label_alt_id"), mappedProp(getLocation, _structure__WEBPACK_IMPORTED_MODULE_1__["StructureProperties"].atom.label_alt_id))
        .str(prefixedInsCode(prefix), mappedProp(getLocation, _structure__WEBPACK_IMPORTED_MODULE_1__["StructureProperties"].residue.pdbx_PDB_ins_code))
        .str(prepostfixed(prefix, "label_asym_id"), mappedProp(getLocation, _structure__WEBPACK_IMPORTED_MODULE_1__["StructureProperties"].chain.label_asym_id))
        .str(prepostfixed(prefix, "label_entity_id"), mappedProp(getLocation, _structure__WEBPACK_IMPORTED_MODULE_1__["StructureProperties"].chain.label_entity_id))
        .str(prepostfixed(prefix, "auth_atom_id"), mappedProp(getLocation, _structure__WEBPACK_IMPORTED_MODULE_1__["StructureProperties"].atom.auth_atom_id))
        .str(prepostfixed(prefix, "auth_comp_id"), mappedProp(getLocation, _structure__WEBPACK_IMPORTED_MODULE_1__["StructureProperties"].atom.auth_comp_id))
        .int(prepostfixed(prefix, "auth_seq_id"), mappedProp(getLocation, _structure__WEBPACK_IMPORTED_MODULE_1__["StructureProperties"].residue.auth_seq_id), { encoder: E.deltaRLE })
        .str(prepostfixed(prefix, "auth_asym_id"), mappedProp(getLocation, _structure__WEBPACK_IMPORTED_MODULE_1__["StructureProperties"].chain.auth_asym_id));
    addModelNum(ret, getLocation, options);
    return ret.getFields();
}
//# sourceMappingURL=atom_site.js.map

/***/ }),

/***/ "./lib/mol-model/structure/export/categories/atom_site_operator_mapping.js":
/*!*********************************************************************************!*\
  !*** ./lib/mol-model/structure/export/categories/atom_site_operator_mapping.js ***!
  \*********************************************************************************/
/*! exports provided: atom_site_operator_mapping, AtomSiteOperatorMappingCategoryName, AtomSiteOperatorMappingSchema */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "atom_site_operator_mapping", function() { return atom_site_operator_mapping; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "AtomSiteOperatorMappingCategoryName", function() { return AtomSiteOperatorMappingCategoryName; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "AtomSiteOperatorMappingSchema", function() { return AtomSiteOperatorMappingSchema; });
/* harmony import */ var _structure__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../structure */ "./lib/mol-model/structure/structure.js");
/* harmony import */ var _mol_data_int__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../../../mol-data/int */ "./lib/mol-data/int.js");
/* harmony import */ var _mol_io_writer_cif__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../../../mol-io/writer/cif */ "./lib/mol-io/writer/cif.js");
/* harmony import */ var _mol_data_db__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../../../mol-data/db */ "./lib/mol-data/db.js");
/**
 * Copyright (c) 2020 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author David Sehnal <david.sehnal@gmail.com>
 */




function atom_site_operator_mapping(ctx) {
    var entries = getEntries(ctx);
    if (entries.length === 0)
        return;
    return [Category, entries, { ignoreFilter: true }];
}
var AtomSiteOperatorMappingCategoryName = 'molstar_atom_site_operator_mapping';
var AtomSiteOperatorMappingSchema = {
    molstar_atom_site_operator_mapping: {
        label_asym_id: _mol_data_db__WEBPACK_IMPORTED_MODULE_3__["Column"].Schema.Str(),
        auth_asym_id: _mol_data_db__WEBPACK_IMPORTED_MODULE_3__["Column"].Schema.Str(),
        operator_name: _mol_data_db__WEBPACK_IMPORTED_MODULE_3__["Column"].Schema.Str(),
        suffix: _mol_data_db__WEBPACK_IMPORTED_MODULE_3__["Column"].Schema.Str(),
        // assembly
        assembly_id: _mol_data_db__WEBPACK_IMPORTED_MODULE_3__["Column"].Schema.Str(),
        assembly_operator_id: _mol_data_db__WEBPACK_IMPORTED_MODULE_3__["Column"].Schema.Int(),
        // symmetry
        symmetry_operator_index: _mol_data_db__WEBPACK_IMPORTED_MODULE_3__["Column"].Schema.Int(),
        symmetry_hkl: _mol_data_db__WEBPACK_IMPORTED_MODULE_3__["Column"].Schema.Vector(3),
        // NCS
        ncs_id: _mol_data_db__WEBPACK_IMPORTED_MODULE_3__["Column"].Schema.Int(),
    }
};
var asmValueKind = function (i, xs) { return typeof xs[i].operator.assembly === 'undefined' ? 1 /* NotPresent */ : 0 /* Present */; };
var symmetryValueKind = function (i, xs) { return xs[i].operator.spgrOp === -1 ? 1 /* NotPresent */ : 0 /* Present */; };
var Fields = _mol_io_writer_cif__WEBPACK_IMPORTED_MODULE_2__["CifWriter"].fields()
    .str('label_asym_id', function (i, xs) { return xs[i].label_asym_id; })
    .str('auth_asym_id', function (i, xs) { return xs[i].auth_asym_id; })
    .str('operator_name', function (i, xs) { return xs[i].operator.name; })
    .str('suffix', function (i, xs) { return xs[i].operator.suffix; })
    // assembly
    // TODO: include oper list as well?
    .str('assembly_id', function (i, xs) { var _a; return ((_a = xs[i].operator.assembly) === null || _a === void 0 ? void 0 : _a.id) || ''; }, { valueKind: asmValueKind })
    .int('assembly_operator_id', function (i, xs) { var _a; return ((_a = xs[i].operator.assembly) === null || _a === void 0 ? void 0 : _a.operId) || 0; }, { valueKind: asmValueKind })
    // symmetry
    .int('symmetry_operator_index', function (i, xs) { return xs[i].operator.spgrOp; }, { valueKind: symmetryValueKind })
    .vec('symmetry_hkl', [function (i, xs) { return xs[i].operator.hkl[0]; }, function (i, xs) { return xs[i].operator.hkl[1]; }, function (i, xs) { return xs[i].operator.hkl[2]; }], { valueKind: symmetryValueKind })
    // NCS
    .int('ncs_id', function (i, xs) { return xs[i].operator.ncsId; }, { valueKind: symmetryValueKind })
    .getFields();
var Category = {
    name: 'molstar_atom_site_operator_mapping',
    instance: function (entries) {
        return { fields: Fields, source: [{ data: entries, rowCount: entries.length }] };
    }
};
function getEntries(ctx) {
    var existing = new Set();
    var entries = [];
    for (var _i = 0, _a = ctx.structures; _i < _a.length; _i++) {
        var s = _a[_i];
        var l = _structure__WEBPACK_IMPORTED_MODULE_0__["StructureElement"].Location.create(s);
        for (var _b = 0, _c = s.units; _b < _c.length; _b++) {
            var unit = _c[_b];
            var operator = unit.conformation.operator;
            if (!operator.suffix || unit.kind !== 0 /* Atomic */)
                continue;
            l.unit = unit;
            var elements = unit.elements;
            var chainsIt = _mol_data_int__WEBPACK_IMPORTED_MODULE_1__["Segmentation"].transientSegments(unit.model.atomicHierarchy.chainAtomSegments, elements);
            while (chainsIt.hasNext) {
                var chainSegment = chainsIt.move();
                l.element = elements[chainSegment.start];
                var label_asym_id = _structure__WEBPACK_IMPORTED_MODULE_0__["StructureProperties"].chain.label_asym_id(l);
                var key = "" + label_asym_id + operator.suffix;
                if (existing.has(key))
                    continue;
                existing.add(key);
                var auth_asym_id = _structure__WEBPACK_IMPORTED_MODULE_0__["StructureProperties"].chain.label_asym_id(l);
                entries.push({ label_asym_id: label_asym_id, auth_asym_id: auth_asym_id, operator: operator });
            }
        }
    }
    return entries;
}
//# sourceMappingURL=atom_site_operator_mapping.js.map

/***/ }),

/***/ "./lib/mol-model/structure/export/categories/misc.js":
/*!***********************************************************!*\
  !*** ./lib/mol-model/structure/export/categories/misc.js ***!
  \***********************************************************/
/*! exports provided: _chem_comp, _pdbx_chem_comp_identifier, _pdbx_nonpoly_scheme */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_chem_comp", function() { return _chem_comp; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_pdbx_chem_comp_identifier", function() { return _pdbx_chem_comp_identifier; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_pdbx_nonpoly_scheme", function() { return _pdbx_nonpoly_scheme; });
/* harmony import */ var _mol_data_db__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../../../mol-data/db */ "./lib/mol-data/db.js");
/* harmony import */ var _mol_io_writer_cif__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../../../mol-io/writer/cif */ "./lib/mol-io/writer/cif.js");
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./utils */ "./lib/mol-model/structure/export/categories/utils.js");
/**
 * Copyright (c) 2017-2018 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author David Sehnal <david.sehnal@gmail.com>
 */



var CifCategory = _mol_io_writer_cif__WEBPACK_IMPORTED_MODULE_1__["CifWriter"].Category;
var _chem_comp = {
    name: 'chem_comp',
    instance: function (_a) {
        var firstModel = _a.firstModel, structures = _a.structures, cache = _a.cache;
        var chem_comp = Object(_utils__WEBPACK_IMPORTED_MODULE_2__["getModelMmCifCategory"])(structures[0].model, 'chem_comp');
        if (!chem_comp)
            return CifCategory.Empty;
        var id = chem_comp.id;
        var names = cache.uniqueResidueNames || (cache.uniqueResidueNames = Object(_utils__WEBPACK_IMPORTED_MODULE_2__["getUniqueResidueNamesFromStructures"])(structures));
        var indices = _mol_data_db__WEBPACK_IMPORTED_MODULE_0__["Column"].indicesOf(id, function (id) { return names.has(id); });
        return CifCategory.ofTable(chem_comp, indices);
    }
};
var _pdbx_chem_comp_identifier = {
    name: 'pdbx_chem_comp_identifier',
    instance: function (_a) {
        var firstModel = _a.firstModel, structures = _a.structures, cache = _a.cache;
        var pdbx_chem_comp_identifier = Object(_utils__WEBPACK_IMPORTED_MODULE_2__["getModelMmCifCategory"])(firstModel, 'pdbx_chem_comp_identifier');
        if (!pdbx_chem_comp_identifier)
            return CifCategory.Empty;
        var comp_id = pdbx_chem_comp_identifier.comp_id;
        var names = cache.uniqueResidueNames || (cache.uniqueResidueNames = Object(_utils__WEBPACK_IMPORTED_MODULE_2__["getUniqueResidueNamesFromStructures"])(structures));
        var indices = _mol_data_db__WEBPACK_IMPORTED_MODULE_0__["Column"].indicesOf(comp_id, function (id) { return names.has(id); });
        return CifCategory.ofTable(pdbx_chem_comp_identifier, indices);
    }
};
var _pdbx_nonpoly_scheme = {
    name: 'pdbx_nonpoly_scheme',
    instance: function (_a) {
        var firstModel = _a.firstModel, structures = _a.structures, cache = _a.cache;
        var pdbx_nonpoly_scheme = Object(_utils__WEBPACK_IMPORTED_MODULE_2__["getModelMmCifCategory"])(firstModel, 'pdbx_nonpoly_scheme');
        if (!pdbx_nonpoly_scheme)
            return CifCategory.Empty;
        // TODO: filter?
        return CifCategory.ofTable(pdbx_nonpoly_scheme);
    }
};
//# sourceMappingURL=misc.js.map

/***/ }),

/***/ "./lib/mol-model/structure/export/categories/secondary-structure.js":
/*!**************************************************************************!*\
  !*** ./lib/mol-model/structure/export/categories/secondary-structure.js ***!
  \**************************************************************************/
/*! exports provided: _struct_conf, _struct_sheet_range */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_struct_conf", function() { return _struct_conf; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_struct_sheet_range", function() { return _struct_sheet_range; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _mol_data_int__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../../../mol-data/int */ "./lib/mol-data/int.js");
/* harmony import */ var _mol_io_writer_cif__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../../../mol-io/writer/cif */ "./lib/mol-io/writer/cif.js");
/* harmony import */ var _structure__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../structure */ "./lib/mol-model/structure/structure.js");
/* harmony import */ var _atom_site__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./atom_site */ "./lib/mol-model/structure/export/categories/atom_site.js");
/* harmony import */ var _mol_model_formats_structure_property_secondary_structure__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../../../mol-model-formats/structure/property/secondary-structure */ "./lib/mol-model-formats/structure/property/secondary-structure.js");
/**
 * Copyright (c) 2018 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author David Sehnal <david.sehnal@gmail.com>
 */




var CifField = _mol_io_writer_cif__WEBPACK_IMPORTED_MODULE_2__["CifWriter"].Field;


var _struct_conf = {
    name: 'struct_conf',
    instance: function (ctx) {
        var elements = findElements(ctx, 'helix');
        return {
            fields: struct_conf_fields,
            source: [{ data: elements, rowCount: elements.length }]
        };
    }
};
var _struct_sheet_range = {
    name: 'struct_sheet_range',
    instance: function (ctx) {
        var elements = findElements(ctx, 'sheet').sort(compare_ssr);
        return {
            fields: struct_sheet_range_fields,
            source: [{ data: elements, rowCount: elements.length }]
        };
    }
};
function compare_ssr(x, y) {
    var a = x.element, b = y.element;
    return a.sheet_id < b.sheet_id ? -1 : a.sheet_id === b.sheet_id ? x.start.element - y.start.element : 1;
}
;
var struct_conf_fields = Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__spreadArrays"])([
    CifField.str('conf_type_id', function (i, data) { return data[i].element.type_id; }),
    CifField.str('id', function (i, data, idx) { return "" + data[i].element.type_id + (idx + 1); })
], Object(_atom_site__WEBPACK_IMPORTED_MODULE_4__["residueIdFields"])(function (i, e) { return e[i].start; }, { prefix: 'beg' }), Object(_atom_site__WEBPACK_IMPORTED_MODULE_4__["residueIdFields"])(function (i, e) { return e[i].end; }, { prefix: 'end' }), [
    CifField.str('pdbx_PDB_helix_class', function (i, data) { return data[i].element.helix_class; }),
    CifField.str('details', function (i, data) { return data[i].element.details || ''; }, {
        valueKind: function (i, d) { return !!d[i].element.details ? 0 /* Present */ : 2 /* Unknown */; }
    }),
    CifField.int('pdbx_PDB_helix_length', function (i, data) { return data[i].length; })
]);
var struct_sheet_range_fields = Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__spreadArrays"])([
    CifField.str('sheet_id', function (i, data) { return data[i].element.sheet_id; }),
    CifField.index('id')
], Object(_atom_site__WEBPACK_IMPORTED_MODULE_4__["residueIdFields"])(function (i, e) { return e[i].start; }, { prefix: 'beg' }), Object(_atom_site__WEBPACK_IMPORTED_MODULE_4__["residueIdFields"])(function (i, e) { return e[i].end; }, { prefix: 'end' }), [
    CifField.str('symmetry', function (i, data) { return ''; }, { valueKind: function (i, d) { return 2 /* Unknown */; } })
]);
function findElements(ctx, kind) {
    // TODO: encode secondary structure for different models?
    var secondaryStructure = _mol_model_formats_structure_property_secondary_structure__WEBPACK_IMPORTED_MODULE_5__["ModelSecondaryStructure"].Provider.get(ctx.firstModel);
    if (!secondaryStructure)
        return [];
    var key = secondaryStructure.key, elements = secondaryStructure.elements;
    var ssElements = [];
    var structure = ctx.structures[0];
    for (var _i = 0, _a = structure.units; _i < _a.length; _i++) {
        var unit = _a[_i];
        // currently can only support this for "identity" operators.
        if (!_structure__WEBPACK_IMPORTED_MODULE_3__["Unit"].isAtomic(unit) || !unit.conformation.operator.isIdentity)
            continue;
        var segs = unit.model.atomicHierarchy.residueAtomSegments;
        var residues = _mol_data_int__WEBPACK_IMPORTED_MODULE_1__["Segmentation"].transientSegments(segs, unit.elements);
        var current = void 0, move = true;
        while (residues.hasNext) {
            if (move)
                current = residues.move();
            var start = current.index;
            var startIdx = key[start];
            var element = elements[startIdx];
            if (element.kind !== kind) {
                move = true;
                continue;
            }
            var prev = start;
            while (residues.hasNext) {
                prev = current.index;
                current = residues.move();
                if (startIdx !== key[current.index]) {
                    move = false;
                    ssElements[ssElements.length] = {
                        start: _structure__WEBPACK_IMPORTED_MODULE_3__["StructureElement"].Location.create(structure, unit, segs.offsets[start]),
                        end: _structure__WEBPACK_IMPORTED_MODULE_3__["StructureElement"].Location.create(structure, unit, segs.offsets[prev]),
                        length: prev - start + 1,
                        element: element
                    };
                    break;
                }
            }
        }
    }
    return ssElements;
}
//# sourceMappingURL=secondary-structure.js.map

/***/ }),

/***/ "./lib/mol-model/structure/export/categories/sequence.js":
/*!***************************************************************!*\
  !*** ./lib/mol-model/structure/export/categories/sequence.js ***!
  \***************************************************************/
/*! exports provided: _struct_asym, _entity_poly, _entity_poly_seq */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_struct_asym", function() { return _struct_asym; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_entity_poly", function() { return _entity_poly; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_entity_poly_seq", function() { return _entity_poly_seq; });
/* harmony import */ var _mol_data_db__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../../../mol-data/db */ "./lib/mol-data/db.js");
/* harmony import */ var _mol_io_writer_cif__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../../../mol-io/writer/cif */ "./lib/mol-io/writer/cif.js");
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./utils */ "./lib/mol-model/structure/export/categories/utils.js");
/**
 * Copyright (c) 2017-2018 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author David Sehnal <david.sehnal@gmail.com>
 */



var CifCategory = _mol_io_writer_cif__WEBPACK_IMPORTED_MODULE_1__["CifWriter"].Category;
var _struct_asym = createCategory('struct_asym');
var _entity_poly = createCategory('entity_poly');
var _entity_poly_seq = createCategory('entity_poly_seq');
function createCategory(categoryName) {
    return {
        name: categoryName,
        instance: function (_a) {
            var structures = _a.structures, cache = _a.cache;
            return getCategoryInstance(structures, categoryName, cache);
        }
    };
}
function getCategoryInstance(structures, categoryName, cache) {
    var category = Object(_utils__WEBPACK_IMPORTED_MODULE_2__["getModelMmCifCategory"])(structures[0].model, categoryName);
    if (!category)
        return CifCategory.Empty;
    var entity_id = category.entity_id;
    var names = cache.uniqueEntityIds || (cache.uniqueEntityIds = Object(_utils__WEBPACK_IMPORTED_MODULE_2__["getUniqueEntityIdsFromStructures"])(structures));
    var indices = _mol_data_db__WEBPACK_IMPORTED_MODULE_0__["Column"].indicesOf(entity_id, function (id) { return names.has(id); });
    return CifCategory.ofTable(category, indices);
}
//# sourceMappingURL=sequence.js.map

/***/ }),

/***/ "./lib/mol-model/structure/export/categories/utils.js":
/*!************************************************************!*\
  !*** ./lib/mol-model/structure/export/categories/utils.js ***!
  \************************************************************/
/*! exports provided: getModelMmCifCategory, getUniqueResidueNamesFromStructures, getUniqueEntityIdsFromStructures, getUniqueEntityIndicesFromStructures, copy_mmCif_category, copy_source_mmCifCategory */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getModelMmCifCategory", function() { return getModelMmCifCategory; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getUniqueResidueNamesFromStructures", function() { return getUniqueResidueNamesFromStructures; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getUniqueEntityIdsFromStructures", function() { return getUniqueEntityIdsFromStructures; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getUniqueEntityIndicesFromStructures", function() { return getUniqueEntityIndicesFromStructures; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "copy_mmCif_category", function() { return copy_mmCif_category; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "copy_source_mmCifCategory", function() { return copy_source_mmCifCategory; });
/* harmony import */ var _mol_util_set__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../../../mol-util/set */ "./lib/mol-util/set.js");
/* harmony import */ var _mol_data_generic__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../../../mol-data/generic */ "./lib/mol-data/generic.js");
/* harmony import */ var _mol_data_util__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../../../mol-data/util */ "./lib/mol-data/util.js");
/* harmony import */ var _mol_io_writer_cif__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../../../mol-io/writer/cif */ "./lib/mol-io/writer/cif.js");
/* harmony import */ var _mol_model_formats_structure_mmcif__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../../../mol-model-formats/structure/mmcif */ "./lib/mol-model-formats/structure/mmcif.js");
/* harmony import */ var _mol_io_reader_cif__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../../../mol-io/reader/cif */ "./lib/mol-io/reader/cif.js");
/**
 * Copyright (c) 2017-2018 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author David Sehnal <david.sehnal@gmail.com>
 */






function getModelMmCifCategory(model, name) {
    if (!_mol_model_formats_structure_mmcif__WEBPACK_IMPORTED_MODULE_4__["MmcifFormat"].is(model.sourceData))
        return;
    return model.sourceData.data.db[name];
}
function getUniqueResidueNamesFromStructures(structures) {
    return _mol_util_set__WEBPACK_IMPORTED_MODULE_0__["SetUtils"].unionMany.apply(_mol_util_set__WEBPACK_IMPORTED_MODULE_0__["SetUtils"], structures.map(function (s) { return s.uniqueResidueNames; }));
}
function getUniqueEntityIdsFromStructures(structures) {
    if (structures.length === 0)
        return new Set();
    var names = structures[0].model.entities.data.id;
    return new Set(getUniqueEntityIndicesFromStructures(structures).map(function (i) { return names.value(i); }));
}
function getUniqueEntityIndicesFromStructures(structures) {
    if (structures.length === 0)
        return [];
    if (structures.length === 1)
        return structures[0].entityIndices;
    var ret = _mol_data_generic__WEBPACK_IMPORTED_MODULE_1__["UniqueArray"].create();
    for (var _i = 0, structures_1 = structures; _i < structures_1.length; _i++) {
        var s = structures_1[_i];
        for (var _a = 0, _b = s.entityIndices; _a < _b.length; _a++) {
            var e = _b[_a];
            _mol_data_generic__WEBPACK_IMPORTED_MODULE_1__["UniqueArray"].add(ret, e, e);
        }
    }
    Object(_mol_data_util__WEBPACK_IMPORTED_MODULE_2__["sortArray"])(ret.array);
    return ret.array;
}
function copy_mmCif_category(name, condition) {
    return {
        name: name,
        instance: function (_a) {
            var structures = _a.structures;
            if (condition && !condition(structures[0]))
                return _mol_io_writer_cif__WEBPACK_IMPORTED_MODULE_3__["CifWriter"].Category.Empty;
            var model = structures[0].model;
            if (!_mol_model_formats_structure_mmcif__WEBPACK_IMPORTED_MODULE_4__["MmcifFormat"].is(model.sourceData))
                return _mol_io_writer_cif__WEBPACK_IMPORTED_MODULE_3__["CifWriter"].Category.Empty;
            var table = model.sourceData.data.db[name];
            if (!table || !table._rowCount)
                return _mol_io_writer_cif__WEBPACK_IMPORTED_MODULE_3__["CifWriter"].Category.Empty;
            return _mol_io_writer_cif__WEBPACK_IMPORTED_MODULE_3__["CifWriter"].Category.ofTable(table);
        }
    };
}
function copy_source_mmCifCategory(encoder, ctx, category) {
    if (!_mol_model_formats_structure_mmcif__WEBPACK_IMPORTED_MODULE_4__["MmcifFormat"].is(ctx.firstModel.sourceData))
        return;
    var fs = _mol_io_writer_cif__WEBPACK_IMPORTED_MODULE_3__["CifWriter"].fields();
    if (encoder.isBinary) {
        for (var _i = 0, _a = category.fieldNames; _i < _a.length; _i++) {
            var f = _a[_i];
            // TODO: this could be optimized
            var field = classifyField(f, category.getField(f));
            fs.add(field);
        }
    }
    else {
        var _loop_1 = function (f) {
            var field = category.getField(f);
            fs.str(f, function (row) { return field.str(row); });
        };
        for (var _b = 0, _c = category.fieldNames; _b < _c.length; _b++) {
            var f = _c[_b];
            _loop_1(f);
        }
    }
    var fields = fs.getFields();
    return {
        name: category.name,
        instance: function () {
            return { fields: fields, source: [{ data: void 0, rowCount: category.rowCount }] };
        }
    };
}
function classifyField(name, field) {
    var type = Object(_mol_io_reader_cif__WEBPACK_IMPORTED_MODULE_5__["getCifFieldType"])(field);
    if (type['@type'] === 'str') {
        return { name: name, type: 0 /* Str */, value: field.str, valueKind: field.valueKind };
    }
    else if (type['@type'] === 'float') {
        return _mol_io_writer_cif__WEBPACK_IMPORTED_MODULE_3__["CifWriter"].Field.float(name, field.float, { valueKind: field.valueKind, typedArray: Float64Array });
    }
    else {
        return _mol_io_writer_cif__WEBPACK_IMPORTED_MODULE_3__["CifWriter"].Field.int(name, field.int, { valueKind: field.valueKind, typedArray: Int32Array });
    }
}
//# sourceMappingURL=utils.js.map

/***/ }),

/***/ "./lib/mol-model/structure/export/mmcif.js":
/*!*************************************************!*\
  !*** ./lib/mol-model/structure/export/mmcif.js ***!
  \*************************************************/
/*! exports provided: CifExportContext, mmCIF_Export_Filters, encode_mmCIF_categories, default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CifExportContext", function() { return CifExportContext; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "mmCIF_Export_Filters", function() { return mmCIF_Export_Filters; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "encode_mmCIF_categories", function() { return encode_mmCIF_categories; });
/* harmony import */ var _mol_io_writer_cif__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../../mol-io/writer/cif */ "./lib/mol-io/writer/cif.js");
/* harmony import */ var _categories_atom_site__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./categories/atom_site */ "./lib/mol-model/structure/export/categories/atom_site.js");
/* harmony import */ var _categories_secondary_structure__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./categories/secondary-structure */ "./lib/mol-model/structure/export/categories/secondary-structure.js");
/* harmony import */ var _categories_misc__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./categories/misc */ "./lib/mol-model/structure/export/categories/misc.js");
/* harmony import */ var _categories_utils__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./categories/utils */ "./lib/mol-model/structure/export/categories/utils.js");
/* harmony import */ var _categories_sequence__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./categories/sequence */ "./lib/mol-model/structure/export/categories/sequence.js");
/* harmony import */ var _custom_property__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../../custom-property */ "./lib/mol-model/custom-property.js");
/* harmony import */ var _categories_atom_site_operator_mapping__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ./categories/atom_site_operator_mapping */ "./lib/mol-model/structure/export/categories/atom_site_operator_mapping.js");
/* harmony import */ var _mol_model_formats_structure_mmcif__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ../../../mol-model-formats/structure/mmcif */ "./lib/mol-model-formats/structure/mmcif.js");
/**
 * Copyright (c) 2017-2018 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author David Sehnal <david.sehnal@gmail.com>
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */


var CifCategory = _mol_io_writer_cif__WEBPACK_IMPORTED_MODULE_0__["CifWriter"].Category;







var CifExportContext;
(function (CifExportContext) {
    function create(structures) {
        var structureArray = Array.isArray(structures) ? structures : [structures];
        return {
            structures: structureArray,
            firstModel: structureArray[0].model,
            cache: Object.create(null)
        };
    }
    CifExportContext.create = create;
})(CifExportContext || (CifExportContext = {}));
var _entity = {
    name: 'entity',
    instance: function (_a) {
        var structures = _a.structures;
        var indices = Object(_categories_utils__WEBPACK_IMPORTED_MODULE_4__["getUniqueEntityIndicesFromStructures"])(structures);
        return CifCategory.ofTable(structures[0].model.entities.data, indices);
    }
};
function isWithoutSymmetry(structure) {
    return structure.units.every(function (u) { return u.conformation.operator.isIdentity; });
}
var Categories = [
    // Basics
    Object(_categories_utils__WEBPACK_IMPORTED_MODULE_4__["copy_mmCif_category"])('entry'),
    Object(_categories_utils__WEBPACK_IMPORTED_MODULE_4__["copy_mmCif_category"])('exptl'),
    _entity,
    // Symmetry
    Object(_categories_utils__WEBPACK_IMPORTED_MODULE_4__["copy_mmCif_category"])('cell', isWithoutSymmetry),
    Object(_categories_utils__WEBPACK_IMPORTED_MODULE_4__["copy_mmCif_category"])('symmetry', isWithoutSymmetry),
    // Assemblies
    Object(_categories_utils__WEBPACK_IMPORTED_MODULE_4__["copy_mmCif_category"])('pdbx_struct_assembly', isWithoutSymmetry),
    Object(_categories_utils__WEBPACK_IMPORTED_MODULE_4__["copy_mmCif_category"])('pdbx_struct_assembly_gen', isWithoutSymmetry),
    Object(_categories_utils__WEBPACK_IMPORTED_MODULE_4__["copy_mmCif_category"])('pdbx_struct_oper_list', isWithoutSymmetry),
    // Secondary structure
    _categories_secondary_structure__WEBPACK_IMPORTED_MODULE_2__["_struct_conf"],
    _categories_secondary_structure__WEBPACK_IMPORTED_MODULE_2__["_struct_sheet_range"],
    // Sequence
    _categories_sequence__WEBPACK_IMPORTED_MODULE_5__["_struct_asym"],
    _categories_sequence__WEBPACK_IMPORTED_MODULE_5__["_entity_poly"],
    _categories_sequence__WEBPACK_IMPORTED_MODULE_5__["_entity_poly_seq"],
    // Branch
    Object(_categories_utils__WEBPACK_IMPORTED_MODULE_4__["copy_mmCif_category"])('pdbx_entity_branch'),
    Object(_categories_utils__WEBPACK_IMPORTED_MODULE_4__["copy_mmCif_category"])('pdbx_entity_branch_link'),
    Object(_categories_utils__WEBPACK_IMPORTED_MODULE_4__["copy_mmCif_category"])('pdbx_branch_scheme'),
    // Misc
    // TODO: filter for actual present residues?
    _categories_misc__WEBPACK_IMPORTED_MODULE_3__["_chem_comp"],
    _categories_misc__WEBPACK_IMPORTED_MODULE_3__["_pdbx_chem_comp_identifier"],
    Object(_categories_utils__WEBPACK_IMPORTED_MODULE_4__["copy_mmCif_category"])('atom_sites'),
    _categories_misc__WEBPACK_IMPORTED_MODULE_3__["_pdbx_nonpoly_scheme"],
    // Atoms
    _categories_atom_site__WEBPACK_IMPORTED_MODULE_1__["_atom_site"]
];
var _Filters;
(function (_Filters) {
    _Filters.AtomSitePositionsFieldNames = new Set(['id', 'Cartn_x', 'Cartn_y', 'Cartn_z']);
})(_Filters || (_Filters = {}));
var mmCIF_Export_Filters = {
    onlyPositions: {
        includeCategory: function (name) { return name === 'atom_site'; },
        includeField: function (cat, field) { return _Filters.AtomSitePositionsFieldNames.has(field); }
    }
};
function getCustomPropCategories(customProp, ctx, params) {
    var _a;
    if (!customProp.cifExport || customProp.cifExport.categories.length === 0)
        return [];
    var prefix = customProp.cifExport.prefix;
    var cats = customProp.cifExport.categories;
    var propCtx = ctx;
    if (customProp.cifExport.context) {
        var propId = _custom_property__WEBPACK_IMPORTED_MODULE_6__["CustomPropertyDescriptor"].getUUID(customProp);
        if (ctx.cache[propId + '__ctx'])
            propCtx = ctx.cache[propId + '__ctx'];
        else {
            propCtx = customProp.cifExport.context(ctx) || ctx;
            ctx.cache[propId + '__ctx'] = propCtx;
        }
    }
    var ret = [];
    for (var _i = 0, cats_1 = cats; _i < cats_1.length; _i++) {
        var cat = cats_1[_i];
        if ((_a = params === null || params === void 0 ? void 0 : params.skipCategoryNames) === null || _a === void 0 ? void 0 : _a.has(cat.name))
            continue;
        if (cat.name.indexOf(prefix) !== 0)
            throw new Error("Custom category '" + cat.name + "' name must start with prefix '" + prefix + ".'");
        ret.push([cat, propCtx]);
    }
    return ret;
}
/** Doesn't start a data block */
function encode_mmCIF_categories(encoder, structures, params) {
    var first = Array.isArray(structures) ? structures[0] : structures;
    var models = first.models;
    if (models.length !== 1)
        throw 'Can\'t export stucture composed from multiple models.';
    var ctx = (params === null || params === void 0 ? void 0 : params.exportCtx) || CifExportContext.create(structures);
    if ((params === null || params === void 0 ? void 0 : params.copyAllCategories) && _mol_model_formats_structure_mmcif__WEBPACK_IMPORTED_MODULE_8__["MmcifFormat"].is(models[0].sourceData)) {
        encode_mmCIF_categories_copyAll(encoder, ctx, params);
    }
    else {
        encode_mmCIF_categories_default(encoder, ctx, params);
    }
}
function encode_mmCIF_categories_default(encoder, ctx, params) {
    var _a;
    for (var _i = 0, Categories_1 = Categories; _i < Categories_1.length; _i++) {
        var cat = Categories_1[_i];
        if ((params === null || params === void 0 ? void 0 : params.skipCategoryNames) && (params === null || params === void 0 ? void 0 : params.skipCategoryNames.has(cat.name)))
            continue;
        encoder.writeCategory(cat, ctx);
    }
    if (!((_a = params === null || params === void 0 ? void 0 : params.skipCategoryNames) === null || _a === void 0 ? void 0 : _a.has('atom_site')) && encoder.isCategoryIncluded('atom_site')) {
        var info = Object(_categories_atom_site_operator_mapping__WEBPACK_IMPORTED_MODULE_7__["atom_site_operator_mapping"])(ctx);
        if (info)
            encoder.writeCategory(info[0], info[1], info[2]);
    }
    var _params = params || {};
    for (var _b = 0, _c = ctx.firstModel.customProperties.all; _b < _c.length; _b++) {
        var customProp = _c[_b];
        for (var _d = 0, _e = getCustomPropCategories(customProp, ctx, _params); _d < _e.length; _d++) {
            var _f = _e[_d], cat = _f[0], propCtx = _f[1];
            encoder.writeCategory(cat, propCtx);
        }
    }
    if (params === null || params === void 0 ? void 0 : params.customProperties) {
        for (var _g = 0, _h = params === null || params === void 0 ? void 0 : params.customProperties; _g < _h.length; _g++) {
            var customProp = _h[_g];
            for (var _j = 0, _k = getCustomPropCategories(customProp, ctx, _params); _j < _k.length; _j++) {
                var _l = _k[_j], cat = _l[0], propCtx = _l[1];
                encoder.writeCategory(cat, propCtx);
            }
        }
    }
    for (var _m = 0, _o = ctx.structures; _m < _o.length; _m++) {
        var s = _o[_m];
        if (!s.hasCustomProperties)
            continue;
        for (var _p = 0, _q = s.customPropertyDescriptors.all; _p < _q.length; _p++) {
            var customProp = _q[_p];
            for (var _r = 0, _s = getCustomPropCategories(customProp, ctx, _params); _r < _s.length; _r++) {
                var _t = _s[_r], cat = _t[0], propCtx = _t[1];
                encoder.writeCategory(cat, propCtx);
            }
        }
    }
}
function encode_mmCIF_categories_copyAll(encoder, ctx, params) {
    var providedCategories = new Map();
    for (var _i = 0, Categories_2 = Categories; _i < Categories_2.length; _i++) {
        var cat = Categories_2[_i];
        providedCategories.set(cat.name, [cat, ctx]);
    }
    var mapping = Object(_categories_atom_site_operator_mapping__WEBPACK_IMPORTED_MODULE_7__["atom_site_operator_mapping"])(ctx);
    if (mapping)
        providedCategories.set(mapping[0].name, mapping);
    var _params = params || {};
    for (var _a = 0, _b = ctx.firstModel.customProperties.all; _a < _b.length; _a++) {
        var customProp = _b[_a];
        for (var _c = 0, _d = getCustomPropCategories(customProp, ctx, _params); _c < _d.length; _c++) {
            var info = _d[_c];
            providedCategories.set(info[0].name, info);
        }
    }
    if (params === null || params === void 0 ? void 0 : params.customProperties) {
        for (var _e = 0, _f = params === null || params === void 0 ? void 0 : params.customProperties; _e < _f.length; _e++) {
            var customProp = _f[_e];
            for (var _g = 0, _h = getCustomPropCategories(customProp, ctx, _params); _g < _h.length; _g++) {
                var info = _h[_g];
                providedCategories.set(info[0].name, info);
            }
        }
    }
    for (var _j = 0, _k = ctx.structures; _j < _k.length; _j++) {
        var s = _k[_j];
        if (!s.hasCustomProperties)
            continue;
        for (var _l = 0, _m = s.customPropertyDescriptors.all; _l < _m.length; _l++) {
            var customProp = _m[_l];
            for (var _o = 0, _p = getCustomPropCategories(customProp, ctx); _o < _p.length; _o++) {
                var info = _p[_o];
                providedCategories.set(info[0].name, info);
            }
        }
    }
    var handled = new Set();
    var data = ctx.firstModel.sourceData.data;
    for (var _q = 0, _r = data.frame.categoryNames; _q < _r.length; _q++) {
        var catName = _r[_q];
        handled.add(catName);
        if (providedCategories.has(catName)) {
            var info = providedCategories.get(catName);
            encoder.writeCategory(info[0], info[1], info[2]);
        }
        else {
            if (data.db[catName]) {
                var cat = Object(_categories_utils__WEBPACK_IMPORTED_MODULE_4__["copy_mmCif_category"])(catName);
                encoder.writeCategory(cat, ctx);
            }
            else {
                var cat = Object(_categories_utils__WEBPACK_IMPORTED_MODULE_4__["copy_source_mmCifCategory"])(encoder, ctx, data.frame.categories[catName]);
                if (cat)
                    encoder.writeCategory(cat);
            }
        }
    }
    providedCategories.forEach(function (info, name) {
        if (!handled.has(name))
            encoder.writeCategory(info[0], info[1], info[2]);
    });
}
function to_mmCIF(name, structure, asBinary) {
    if (asBinary === void 0) { asBinary = false; }
    var enc = _mol_io_writer_cif__WEBPACK_IMPORTED_MODULE_0__["CifWriter"].createEncoder({ binary: asBinary });
    enc.startDataBlock(name);
    encode_mmCIF_categories(enc, structure);
    return enc.getData();
}
/* harmony default export */ __webpack_exports__["default"] = (to_mmCIF);
//# sourceMappingURL=mmcif.js.map

/***/ }),

/***/ "./lib/mol-model/structure/model.js":
/*!******************************************!*\
  !*** ./lib/mol-model/structure/model.js ***!
  \******************************************/
/*! exports provided: IndexedCustomProperty, Model, Types, Symmetry, StructureSequence */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _model_model__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./model/model */ "./lib/mol-model/structure/model/model.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Model", function() { return _model_model__WEBPACK_IMPORTED_MODULE_0__["Model"]; });

/* harmony import */ var _model_types__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./model/types */ "./lib/mol-model/structure/model/types.js");
/* harmony reexport (module object) */ __webpack_require__.d(__webpack_exports__, "Types", function() { return _model_types__WEBPACK_IMPORTED_MODULE_1__; });
/* harmony import */ var _model_properties_symmetry__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./model/properties/symmetry */ "./lib/mol-model/structure/model/properties/symmetry.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Symmetry", function() { return _model_properties_symmetry__WEBPACK_IMPORTED_MODULE_2__["Symmetry"]; });

/* harmony import */ var _model_properties_sequence__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./model/properties/sequence */ "./lib/mol-model/structure/model/properties/sequence.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "StructureSequence", function() { return _model_properties_sequence__WEBPACK_IMPORTED_MODULE_3__["default"]; });

/* harmony import */ var _model_properties_custom_indexed__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./model/properties/custom/indexed */ "./lib/mol-model/structure/model/properties/custom/indexed.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "IndexedCustomProperty", function() { return _model_properties_custom_indexed__WEBPACK_IMPORTED_MODULE_4__["IndexedCustomProperty"]; });

/* harmony import */ var _model_indexing__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./model/indexing */ "./lib/mol-model/structure/model/indexing.js");
/* empty/unused harmony star reexport *//**
 * Copyright (c) 2017 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author David Sehnal <david.sehnal@gmail.com>
 */







//# sourceMappingURL=model.js.map

/***/ }),

/***/ "./lib/mol-model/structure/model/indexing.js":
/*!***************************************************!*\
  !*** ./lib/mol-model/structure/model/indexing.js ***!
  \***************************************************/
/*! no exports provided */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/**
 * Copyright (c) 2018 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author David Sehnal <david.sehnal@gmail.com>
 */

//# sourceMappingURL=indexing.js.map

/***/ }),

/***/ "./lib/mol-model/structure/model/model.js":
/*!************************************************!*\
  !*** ./lib/mol-model/structure/model/model.js ***!
  \************************************************/
/*! exports provided: Model */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Model", function() { return Model; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _mol_util_uuid__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../../mol-util/uuid */ "./lib/mol-util/uuid.js");
/* harmony import */ var _custom_property__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../custom-property */ "./lib/mol-model/custom-property.js");
/* harmony import */ var _util__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./util */ "./lib/mol-model/structure/model/util.js");
/* harmony import */ var _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../../mol-math/linear-algebra */ "./lib/mol-math/linear-algebra.js");
/* harmony import */ var _coordinates__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../coordinates */ "./lib/mol-model/structure/coordinates.js");
/* harmony import */ var _mol_task__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../../../mol-task */ "./lib/mol-task/index.js");
/* harmony import */ var _mol_model_formats_structure_property_bonds_index_pair__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../../../mol-model-formats/structure/property/bonds/index-pair */ "./lib/mol-model-formats/structure/property/bonds/index-pair.js");
/* harmony import */ var _mol_model_formats_structure_basic_parser__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ../../../mol-model-formats/structure/basic/parser */ "./lib/mol-model-formats/structure/basic/parser.js");
/* harmony import */ var _mol_model_formats_structure_mmcif__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ../../../mol-model-formats/structure/mmcif */ "./lib/mol-model-formats/structure/mmcif.js");
/* harmony import */ var _mol_model_formats_structure_property_symmetry__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ../../../mol-model-formats/structure/property/symmetry */ "./lib/mol-model-formats/structure/property/symmetry.js");
/* harmony import */ var _mol_data_db__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ../../../mol-data/db */ "./lib/mol-data/db.js");
/* harmony import */ var _mol_model_props_common_custom_model_property__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! ../../../mol-model-props/common/custom-model-property */ "./lib/mol-model-props/common/custom-model-property.js");
/* harmony import */ var _trajectory__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! ../trajectory */ "./lib/mol-model/structure/trajectory.js");
/**
 * Copyright (c) 2017-2020 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author David Sehnal <david.sehnal@gmail.com>
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */














{ }
var Model;
(function (Model) {
    function _trajectoryFromModelAndCoordinates(model, coordinates) {
        var trajectory = [];
        var frames = coordinates.frames;
        var srcIndex = model.atomicHierarchy.atomSourceIndex;
        var isIdentity = _mol_data_db__WEBPACK_IMPORTED_MODULE_11__["Column"].isIdentity(srcIndex);
        var srcIndexArray = isIdentity ? void 0 : srcIndex.toArray({ array: Int32Array });
        for (var i = 0, il = frames.length; i < il; ++i) {
            var f = frames[i];
            var m = Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, model), { id: _mol_util_uuid__WEBPACK_IMPORTED_MODULE_1__["default"].create22(), modelNum: i, atomicConformation: isIdentity
                    ? _coordinates__WEBPACK_IMPORTED_MODULE_5__["Coordinates"].getAtomicConformation(f, model.atomicConformation.atomId)
                    : _coordinates__WEBPACK_IMPORTED_MODULE_5__["Coordinates"].getAtomicConformationReordered(f, model.atomicConformation.atomId, srcIndexArray), 
                // TODO: add support for supplying sphere and gaussian coordinates in addition to atomic coordinates?
                // coarseConformation: coarse.conformation,
                customProperties: new _custom_property__WEBPACK_IMPORTED_MODULE_2__["CustomProperties"](), _staticPropertyData: Object.create(null), _dynamicPropertyData: Object.create(null) });
            if (f.cell) {
                var symmetry = _mol_model_formats_structure_property_symmetry__WEBPACK_IMPORTED_MODULE_10__["ModelSymmetry"].fromCell(f.cell.size, f.cell.anglesInRadians);
                _mol_model_formats_structure_property_symmetry__WEBPACK_IMPORTED_MODULE_10__["ModelSymmetry"].Provider.set(m, symmetry);
            }
            trajectory.push(m);
        }
        return { trajectory: trajectory, srcIndexArray: srcIndexArray };
    }
    function trajectoryFromModelAndCoordinates(model, coordinates) {
        return new _trajectory__WEBPACK_IMPORTED_MODULE_13__["ArrayTrajectory"](_trajectoryFromModelAndCoordinates(model, coordinates).trajectory);
    }
    Model.trajectoryFromModelAndCoordinates = trajectoryFromModelAndCoordinates;
    function invertIndex(xs) {
        var ret = new Int32Array(xs.length);
        for (var i = 0, _i = xs.length; i < _i; i++) {
            ret[xs[i]] = i;
        }
        return ret;
    }
    Model.invertIndex = invertIndex;
    function trajectoryFromTopologyAndCoordinates(topology, coordinates) {
        var _this = this;
        return _mol_task__WEBPACK_IMPORTED_MODULE_6__["Task"].create('Create Trajectory', function (ctx) { return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"])(_this, void 0, void 0, function () {
            var models, model, _a, trajectory, srcIndexArray, invertedIndex, pairs, bondData, indexPairBonds, index, _b, trajectory_1, m;
            return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__generator"])(this, function (_c) {
                switch (_c.label) {
                    case 0: return [4 /*yield*/, Object(_mol_model_formats_structure_basic_parser__WEBPACK_IMPORTED_MODULE_8__["createModels"])(topology.basic, topology.sourceData, ctx)];
                    case 1:
                        models = _c.sent();
                        if (models.frameCount === 0)
                            throw new Error('found no model');
                        model = models.representative;
                        _a = _trajectoryFromModelAndCoordinates(model, coordinates), trajectory = _a.trajectory, srcIndexArray = _a.srcIndexArray;
                        invertedIndex = srcIndexArray ? invertIndex(srcIndexArray) : void 0;
                        pairs = srcIndexArray
                            ? {
                                indexA: _mol_data_db__WEBPACK_IMPORTED_MODULE_11__["Column"].ofIntArray(_mol_data_db__WEBPACK_IMPORTED_MODULE_11__["Column"].mapToArray(topology.bonds.indexA, function (i) { return invertedIndex[i]; }, Int32Array)),
                                indexB: _mol_data_db__WEBPACK_IMPORTED_MODULE_11__["Column"].ofIntArray(_mol_data_db__WEBPACK_IMPORTED_MODULE_11__["Column"].mapToArray(topology.bonds.indexB, function (i) { return invertedIndex[i]; }, Int32Array)),
                                order: topology.bonds.order
                            }
                            : topology.bonds;
                        bondData = { pairs: pairs, count: model.atomicHierarchy.atoms._rowCount };
                        indexPairBonds = _mol_model_formats_structure_property_bonds_index_pair__WEBPACK_IMPORTED_MODULE_7__["IndexPairBonds"].fromData(bondData);
                        index = 0;
                        for (_b = 0, trajectory_1 = trajectory; _b < trajectory_1.length; _b++) {
                            m = trajectory_1[_b];
                            _mol_model_formats_structure_property_bonds_index_pair__WEBPACK_IMPORTED_MODULE_7__["IndexPairBonds"].Provider.set(m, indexPairBonds);
                            Model.TrajectoryInfo.set(m, { index: index++, size: trajectory.length });
                        }
                        return [2 /*return*/, new _trajectory__WEBPACK_IMPORTED_MODULE_13__["ArrayTrajectory"](trajectory)];
                }
            });
        }); });
    }
    Model.trajectoryFromTopologyAndCoordinates = trajectoryFromTopologyAndCoordinates;
    var CenterProp = '__Center__';
    function getCenter(model) {
        if (model._dynamicPropertyData[CenterProp])
            return model._dynamicPropertyData[CenterProp];
        var center = Object(_util__WEBPACK_IMPORTED_MODULE_3__["calcModelCenter"])(model.atomicConformation, model.coarseConformation);
        model._dynamicPropertyData[CenterProp] = center;
        return center;
    }
    Model.getCenter = getCenter;
    var TrajectoryInfoProp = '__TrajectoryInfo__';
    Model.TrajectoryInfo = {
        get: function (model) {
            return model._dynamicPropertyData[TrajectoryInfoProp] || { index: 0, size: 1 };
        },
        set: function (model, trajectoryInfo) {
            return model._dynamicPropertyData[TrajectoryInfoProp] = trajectoryInfo;
        }
    };
    var AsymIdCountProp = '__AsymIdCount__';
    Model.AsymIdCount = {
        get: function (model) {
            if (model._dynamicPropertyData[AsymIdCountProp])
                return model._dynamicPropertyData[AsymIdCountProp];
            var asymIdCount = Object(_util__WEBPACK_IMPORTED_MODULE_3__["getAsymIdCount"])(model);
            model._dynamicPropertyData[AsymIdCountProp] = asymIdCount;
            return asymIdCount;
        },
    };
    Model.AsymIdOffset = _mol_model_props_common_custom_model_property__WEBPACK_IMPORTED_MODULE_12__["CustomModelProperty"].createSimple('asym_id_offset', 'static');
    Model.Index = _mol_model_props_common_custom_model_property__WEBPACK_IMPORTED_MODULE_12__["CustomModelProperty"].createSimple('index', 'static');
    function getRoot(model) {
        return model.parent || model;
    }
    Model.getRoot = getRoot;
    function areHierarchiesEqual(a, b) {
        return a.atomicHierarchy === b.atomicHierarchy && a.coarseHierarchy === b.coarseHierarchy;
    }
    Model.areHierarchiesEqual = areHierarchiesEqual;
    var CoordinatesHistoryProp = '__CoordinatesHistory__';
    Model.CoordinatesHistory = {
        get: function (model) {
            return model._staticPropertyData[CoordinatesHistoryProp];
        },
        set: function (model, coordinatesHistory) {
            return model._staticPropertyData[CoordinatesHistoryProp] = coordinatesHistory;
        }
    };
    //
    function hasCarbohydrate(model) {
        return model.properties.saccharideComponentMap.size > 0;
    }
    Model.hasCarbohydrate = hasCarbohydrate;
    function hasProtein(model) {
        var subtype = model.entities.subtype;
        for (var i = 0, il = subtype.rowCount; i < il; ++i) {
            if (subtype.value(i).startsWith('polypeptide'))
                return true;
        }
        return false;
    }
    Model.hasProtein = hasProtein;
    function hasNucleic(model) {
        var subtype = model.entities.subtype;
        for (var i = 0, il = subtype.rowCount; i < il; ++i) {
            var s = subtype.value(i);
            if (s.endsWith('ribonucleotide hybrid') || s.endsWith('ribonucleotide'))
                return true;
        }
        return false;
    }
    Model.hasNucleic = hasNucleic;
    function isFromPdbArchive(model) {
        if (!_mol_model_formats_structure_mmcif__WEBPACK_IMPORTED_MODULE_9__["MmcifFormat"].is(model.sourceData))
            return false;
        var db = model.sourceData.data.db;
        return (db.database_2.database_id.isDefined ||
            // 4 character PDB id
            model.entryId.match(/^[1-9][a-z0-9]{3,3}$/i) !== null ||
            // long PDB id
            model.entryId.match(/^pdb_[0-9]{4,4}[1-9][a-z0-9]{3,3}$/i) !== null);
    }
    Model.isFromPdbArchive = isFromPdbArchive;
    function hasSecondaryStructure(model) {
        if (!_mol_model_formats_structure_mmcif__WEBPACK_IMPORTED_MODULE_9__["MmcifFormat"].is(model.sourceData))
            return false;
        var db = model.sourceData.data.db;
        return (db.struct_conf.id.isDefined ||
            db.struct_sheet_range.id.isDefined);
    }
    Model.hasSecondaryStructure = hasSecondaryStructure;
    var tmpAngles90 = _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_4__["Vec3"].create(1.5707963, 1.5707963, 1.5707963); // in radians
    var tmpLengths1 = _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_4__["Vec3"].create(1, 1, 1);
    function hasCrystalSymmetry(model) {
        var _a;
        var spacegroup = (_a = _mol_model_formats_structure_property_symmetry__WEBPACK_IMPORTED_MODULE_10__["ModelSymmetry"].Provider.get(model)) === null || _a === void 0 ? void 0 : _a.spacegroup;
        return !!spacegroup && !(spacegroup.num === 1 &&
            _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_4__["Vec3"].equals(spacegroup.cell.anglesInRadians, tmpAngles90) &&
            _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_4__["Vec3"].equals(spacegroup.cell.size, tmpLengths1));
    }
    Model.hasCrystalSymmetry = hasCrystalSymmetry;
    function isFromXray(model) {
        if (!_mol_model_formats_structure_mmcif__WEBPACK_IMPORTED_MODULE_9__["MmcifFormat"].is(model.sourceData))
            return false;
        var db = model.sourceData.data.db;
        for (var i = 0; i < db.exptl.method.rowCount; i++) {
            var v = db.exptl.method.value(i).toUpperCase();
            if (v.indexOf('DIFFRACTION') >= 0)
                return true;
        }
        return false;
    }
    Model.isFromXray = isFromXray;
    function isFromEm(model) {
        if (!_mol_model_formats_structure_mmcif__WEBPACK_IMPORTED_MODULE_9__["MmcifFormat"].is(model.sourceData))
            return false;
        var db = model.sourceData.data.db;
        for (var i = 0; i < db.exptl.method.rowCount; i++) {
            var v = db.exptl.method.value(i).toUpperCase();
            if (v.indexOf('MICROSCOPY') >= 0)
                return true;
        }
        return false;
    }
    Model.isFromEm = isFromEm;
    function isFromNmr(model) {
        if (!_mol_model_formats_structure_mmcif__WEBPACK_IMPORTED_MODULE_9__["MmcifFormat"].is(model.sourceData))
            return false;
        var db = model.sourceData.data.db;
        for (var i = 0; i < db.exptl.method.rowCount; i++) {
            var v = db.exptl.method.value(i).toUpperCase();
            if (v.indexOf('NMR') >= 0)
                return true;
        }
        return false;
    }
    Model.isFromNmr = isFromNmr;
    function hasXrayMap(model) {
        if (!_mol_model_formats_structure_mmcif__WEBPACK_IMPORTED_MODULE_9__["MmcifFormat"].is(model.sourceData))
            return false;
        // Check exprimental method to exclude models solved with
        // 'ELECTRON CRYSTALLOGRAPHY' which also have structure factors
        if (!isFromXray(model))
            return false;
        var db = model.sourceData.data.db;
        var status_code_sf = db.pdbx_database_status.status_code_sf;
        return status_code_sf.isDefined && status_code_sf.value(0) === 'REL';
    }
    Model.hasXrayMap = hasXrayMap;
    /**
     * Also checks for `content_type` of 'associated EM volume' to exclude cases
     * like 6TEK which are solved with 'X-RAY DIFFRACTION' but have an related
     * EMDB entry of type 'other EM volume'.
     */
    function hasEmMap(model) {
        if (!_mol_model_formats_structure_mmcif__WEBPACK_IMPORTED_MODULE_9__["MmcifFormat"].is(model.sourceData))
            return false;
        var db = model.sourceData.data.db;
        var _a = db.pdbx_database_related, db_name = _a.db_name, content_type = _a.content_type;
        for (var i = 0, il = db.pdbx_database_related._rowCount; i < il; ++i) {
            if (db_name.value(i).toUpperCase() === 'EMDB' && content_type.value(i) === 'associated EM volume') {
                return true;
            }
        }
        return false;
    }
    Model.hasEmMap = hasEmMap;
    function hasDensityMap(model) {
        if (!_mol_model_formats_structure_mmcif__WEBPACK_IMPORTED_MODULE_9__["MmcifFormat"].is(model.sourceData))
            return false;
        return hasXrayMap(model) || hasEmMap(model);
    }
    Model.hasDensityMap = hasDensityMap;
    function probablyHasDensityMap(model) {
        if (!_mol_model_formats_structure_mmcif__WEBPACK_IMPORTED_MODULE_9__["MmcifFormat"].is(model.sourceData))
            return false;
        var db = model.sourceData.data.db;
        return hasDensityMap(model) || (
        // check if from pdb archive but missing relevant meta data
        isFromPdbArchive(model) && (!db.exptl.method.isDefined ||
            (isFromXray(model) && (!db.pdbx_database_status.status_code_sf.isDefined ||
                db.pdbx_database_status.status_code_sf.valueKind(0) === 2 /* Unknown */)) ||
            (isFromEm(model) && (!db.pdbx_database_related.db_name.isDefined))));
    }
    Model.probablyHasDensityMap = probablyHasDensityMap;
})(Model || (Model = {}));
//# sourceMappingURL=model.js.map

/***/ }),

/***/ "./lib/mol-model/structure/model/properties/atomic.js":
/*!************************************************************!*\
  !*** ./lib/mol-model/structure/model/properties/atomic.js ***!
  \************************************************************/
/*! exports provided: AtomsSchema, ResiduesSchema, ChainsSchema, AtomicIndex, AtomicHierarchy, AtomicNumbers, ElementVdwRadii, ElementAtomWeights, DefaultVdwRadius, DefaultAtomWeight, DefaultAtomNumber, VdwRadius, AtomWeight, AtomNumber */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _atomic_conformation__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./atomic/conformation */ "./lib/mol-model/structure/model/properties/atomic/conformation.js");
/* empty/unused harmony star reexport *//* harmony import */ var _atomic_hierarchy__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./atomic/hierarchy */ "./lib/mol-model/structure/model/properties/atomic/hierarchy.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "AtomsSchema", function() { return _atomic_hierarchy__WEBPACK_IMPORTED_MODULE_1__["AtomsSchema"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ResiduesSchema", function() { return _atomic_hierarchy__WEBPACK_IMPORTED_MODULE_1__["ResiduesSchema"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ChainsSchema", function() { return _atomic_hierarchy__WEBPACK_IMPORTED_MODULE_1__["ChainsSchema"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "AtomicIndex", function() { return _atomic_hierarchy__WEBPACK_IMPORTED_MODULE_1__["AtomicIndex"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "AtomicHierarchy", function() { return _atomic_hierarchy__WEBPACK_IMPORTED_MODULE_1__["AtomicHierarchy"]; });

/* harmony import */ var _atomic_measures__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./atomic/measures */ "./lib/mol-model/structure/model/properties/atomic/measures.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "AtomicNumbers", function() { return _atomic_measures__WEBPACK_IMPORTED_MODULE_2__["AtomicNumbers"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ElementVdwRadii", function() { return _atomic_measures__WEBPACK_IMPORTED_MODULE_2__["ElementVdwRadii"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ElementAtomWeights", function() { return _atomic_measures__WEBPACK_IMPORTED_MODULE_2__["ElementAtomWeights"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "DefaultVdwRadius", function() { return _atomic_measures__WEBPACK_IMPORTED_MODULE_2__["DefaultVdwRadius"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "DefaultAtomWeight", function() { return _atomic_measures__WEBPACK_IMPORTED_MODULE_2__["DefaultAtomWeight"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "DefaultAtomNumber", function() { return _atomic_measures__WEBPACK_IMPORTED_MODULE_2__["DefaultAtomNumber"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "VdwRadius", function() { return _atomic_measures__WEBPACK_IMPORTED_MODULE_2__["VdwRadius"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "AtomWeight", function() { return _atomic_measures__WEBPACK_IMPORTED_MODULE_2__["AtomWeight"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "AtomNumber", function() { return _atomic_measures__WEBPACK_IMPORTED_MODULE_2__["AtomNumber"]; });

/**
 * Copyright (c) 2017 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author David Sehnal <david.sehnal@gmail.com>
 */



//# sourceMappingURL=atomic.js.map

/***/ }),

/***/ "./lib/mol-model/structure/model/properties/atomic/bonds.js":
/*!******************************************************************!*\
  !*** ./lib/mol-model/structure/model/properties/atomic/bonds.js ***!
  \******************************************************************/
/*! exports provided: getIntraBondOrderFromTable, getInterBondOrderFromTable */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getIntraBondOrderFromTable", function() { return getIntraBondOrderFromTable; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getInterBondOrderFromTable", function() { return getInterBondOrderFromTable; });
/* harmony import */ var _types__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../types */ "./lib/mol-model/structure/model/types.js");
/**
 * Copyright (c) 2019 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */

/**
 * Map of intra component bond orders in aminoacids and nucleotides assuming standard IUPAC naming.
 * The key is constructed as `${compId}|${atomId1}|${atomId2}` with `atomId1 < atomId2`.
 */
var IntraBondOrderTable = new Map([
    ['HIS|CD2|CG', 2],
    ['HIS|CE1|ND1', 2],
    ['ARG|CZ|NH2', 2],
    ['PHE|CE1|CZ', 2],
    ['PHE|CD2|CE2', 2],
    ['PHE|CD1|CG', 2],
    ['TRP|CD1|CG', 2],
    ['TRP|CD2|CE2', 2],
    ['TRP|CE3|CZ3', 2],
    ['TRP|CH2|CZ2', 2],
    ['ASN|CG|OD1', 2],
    ['GLN|CD|OE1', 2],
    ['TYR|CD1|CG', 2],
    ['TYR|CD2|CE2', 2],
    ['TYR|CE1|CZ', 2],
    ['ASP|CG|OD1', 2],
    ['GLU|CD|OE1', 2],
    ['G|C8|N7', 2],
    ['G|C4|C5', 2],
    ['G|C2|N3', 2],
    ['G|C6|O6', 2],
    ['C|C4|N3', 2],
    ['C|C5|C6', 2],
    ['C|C2|O2', 2],
    ['A|C2|N3', 2],
    ['A|C6|N1', 2],
    ['A|C4|C5', 2],
    ['A|C8|N7', 2],
    ['U|C5|C6', 2],
    ['U|C2|O2', 2],
    ['U|C4|O4', 2],
    ['DG|C8|N7', 2],
    ['DG|C4|C5', 2],
    ['DG|C2|N3', 2],
    ['DG|C6|O6', 2],
    ['DC|C4|N3', 2],
    ['DC|C5|C6', 2],
    ['DC|C2|O2', 2],
    ['DA|C2|N3', 2],
    ['DA|C6|N1', 2],
    ['DA|C4|C5', 2],
    ['DA|C8|N7', 2],
    ['DT|C5|C6', 2],
    ['DT|C2|O2', 2],
    ['DT|C4|O4', 2]
]);
/**
 * Get order for bonds in aminoacids and nucleotides assuming standard IUPAC naming
 */
function getIntraBondOrderFromTable(compId, atomId1, atomId2) {
    var _a;
    _a = atomId1 < atomId2 ? [atomId1, atomId2] : [atomId2, atomId1], atomId1 = _a[0], atomId2 = _a[1];
    if (_types__WEBPACK_IMPORTED_MODULE_0__["AminoAcidNames"].has(compId) && atomId1 === 'C' && atomId2 === 'O')
        return 2;
    if (_types__WEBPACK_IMPORTED_MODULE_0__["BaseNames"].has(compId) && atomId1 === 'OP1' && atomId2 === 'P')
        return 2;
    return IntraBondOrderTable.get(compId + "|" + atomId1 + "|" + atomId2) || 1;
}
/**
 * Map of inter component bond orders assuming PDBx/mmCIF naming.
 * The key is constructed as `${compId1}|${compId2}|${atomId1}|${atomId2}` with `compId1 < compId2`.
 */
var InterBondOrderTable = new Map([
    ['LYS|NZ|RET|C15', 2] // Schiff base in Rhodopsin and Bacteriorhodopsin
]);
/**
 * Get order for bonds between component assuming PDBx/mmCIF naming.
 */
function getInterBondOrderFromTable(compId1, atomId1, compId2, atomId2) {
    var _a, _b;
    if (compId1 > compId2) {
        _a = [compId2, compId1], compId1 = _a[0], compId2 = _a[1];
        _b = [atomId2, atomId1], atomId1 = _b[0], atomId2 = _b[1];
    }
    return InterBondOrderTable.get(compId1 + "|" + atomId1 + "|" + compId2 + "|" + atomId2) || 1;
}
//# sourceMappingURL=bonds.js.map

/***/ }),

/***/ "./lib/mol-model/structure/model/properties/atomic/conformation.js":
/*!*************************************************************************!*\
  !*** ./lib/mol-model/structure/model/properties/atomic/conformation.js ***!
  \*************************************************************************/
/*! no exports provided */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/**
 * Copyright (c) 2017-2018 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author David Sehnal <david.sehnal@gmail.com>
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */

//# sourceMappingURL=conformation.js.map

/***/ }),

/***/ "./lib/mol-model/structure/model/properties/atomic/hierarchy.js":
/*!**********************************************************************!*\
  !*** ./lib/mol-model/structure/model/properties/atomic/hierarchy.js ***!
  \**********************************************************************/
/*! exports provided: AtomsSchema, ResiduesSchema, ChainsSchema, AtomicIndex, AtomicHierarchy */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "AtomsSchema", function() { return AtomsSchema; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ResiduesSchema", function() { return ResiduesSchema; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ChainsSchema", function() { return ChainsSchema; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "AtomicIndex", function() { return AtomicIndex; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "AtomicHierarchy", function() { return AtomicHierarchy; });
/* harmony import */ var _mol_data_db__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../../../../mol-data/db */ "./lib/mol-data/db.js");
/* harmony import */ var _mol_io_reader_cif_schema_mmcif__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../../../../mol-io/reader/cif/schema/mmcif */ "./lib/mol-io/reader/cif/schema/mmcif.js");
/**
 * Copyright (c) 2017-2019 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author David Sehnal <david.sehnal@gmail.com>
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */


var AtomsSchema = {
    /**
     * The chemical element of this atom site.
     * For mmCIF files, this points to atom_type.symbol in the ATOM_TYPE category.
     */
    type_symbol: _mol_data_db__WEBPACK_IMPORTED_MODULE_0__["Column"].Schema.Aliased(_mol_io_reader_cif_schema_mmcif__WEBPACK_IMPORTED_MODULE_1__["mmCIF_Schema"].atom_site.type_symbol),
    /**
     * A component of the identifier for this atom site.
     * This is a standardized name for the atom within its residue.
     * For mmCIF files, this points to chem_comp_atom.atom_id in the CHEM_COMP_ATOM category.
     */
    label_atom_id: _mol_io_reader_cif_schema_mmcif__WEBPACK_IMPORTED_MODULE_1__["mmCIF_Schema"].atom_site.label_atom_id,
    /**
     * An alternative identifier for label_atom_id that may be provided by an author
     * in order to match the identification used in the publication that describes the structure.
     */
    auth_atom_id: _mol_io_reader_cif_schema_mmcif__WEBPACK_IMPORTED_MODULE_1__["mmCIF_Schema"].atom_site.auth_atom_id,
    /**
     * A component of the identifier for this atom site.
     * Identifies an alternative conformation for this atom site.
     */
    label_alt_id: _mol_io_reader_cif_schema_mmcif__WEBPACK_IMPORTED_MODULE_1__["mmCIF_Schema"].atom_site.label_alt_id,
    /**
     * A component of the identifier for this atom site.
     * For mmCIF files, this points to chem_comp.id in the CHEM_COMP category.
     */
    label_comp_id: _mol_io_reader_cif_schema_mmcif__WEBPACK_IMPORTED_MODULE_1__["mmCIF_Schema"].atom_site.label_comp_id,
    /**
     * An alternative identifier for atom_site.label_comp_id that may be provided by an author
     * in order to match the identification used in the publication that describes the structure.
     */
    auth_comp_id: _mol_io_reader_cif_schema_mmcif__WEBPACK_IMPORTED_MODULE_1__["mmCIF_Schema"].atom_site.auth_comp_id,
    /**
     * The net integer charge assigned to this atom.
     * This is the formal charge assignment normally found in chemical diagrams.
     */
    pdbx_formal_charge: _mol_io_reader_cif_schema_mmcif__WEBPACK_IMPORTED_MODULE_1__["mmCIF_Schema"].atom_site.pdbx_formal_charge,
};
var ResiduesSchema = {
    /**
     * The group of atoms to which the atom site belongs. This data item is provided for
     * compatibility with the original Protein Data Bank format, and only for that purpose.
     */
    group_PDB: _mol_io_reader_cif_schema_mmcif__WEBPACK_IMPORTED_MODULE_1__["mmCIF_Schema"].atom_site.group_PDB,
    /**
     * For mmCIF files, this points to entity_poly_seq.num in the ENTITY_POLY_SEQ category.
     */
    label_seq_id: _mol_io_reader_cif_schema_mmcif__WEBPACK_IMPORTED_MODULE_1__["mmCIF_Schema"].atom_site.label_seq_id,
    /**
     * An alternative identifier for atom_site.label_seq_id that may be provided by an author
     * in order to match the identification used in the publication that describes the structure.
     */
    auth_seq_id: _mol_io_reader_cif_schema_mmcif__WEBPACK_IMPORTED_MODULE_1__["mmCIF_Schema"].atom_site.auth_seq_id,
    /**
     * PDB insertion code.
     */
    pdbx_PDB_ins_code: _mol_io_reader_cif_schema_mmcif__WEBPACK_IMPORTED_MODULE_1__["mmCIF_Schema"].atom_site.pdbx_PDB_ins_code,
};
var ChainsSchema = {
    /**
     * A component of the identifier for this atom site.
     * For mmCIF files, this points to struct_asym.id in the STRUCT_ASYM category.
     */
    label_asym_id: _mol_io_reader_cif_schema_mmcif__WEBPACK_IMPORTED_MODULE_1__["mmCIF_Schema"].atom_site.label_asym_id,
    /**
     * An alternative identifier for atomsite.label_asym_id that may be provided by an author
     * in order to match the identification used in the publication that describes the structure.
     */
    auth_asym_id: _mol_io_reader_cif_schema_mmcif__WEBPACK_IMPORTED_MODULE_1__["mmCIF_Schema"].atom_site.auth_asym_id,
    /**
     * For mmCIF files, this points to _entity.id in the ENTITY category.
     */
    label_entity_id: _mol_io_reader_cif_schema_mmcif__WEBPACK_IMPORTED_MODULE_1__["mmCIF_Schema"].atom_site.label_entity_id
};
var AtomicIndex;
(function (AtomicIndex) {
    function EmptyResidueKey() { return { label_entity_id: '', label_asym_id: '', auth_seq_id: 0, pdbx_PDB_ins_code: void 0 }; }
    AtomicIndex.EmptyResidueKey = EmptyResidueKey;
})(AtomicIndex || (AtomicIndex = {}));
var AtomicHierarchy;
(function (AtomicHierarchy) {
    /** Start residue inclusive */
    function chainStartResidueIndex(segs, cI) {
        return segs.residueAtomSegments.index[segs.chainAtomSegments.offsets[cI]];
    }
    AtomicHierarchy.chainStartResidueIndex = chainStartResidueIndex;
    /** End residue exclusive */
    function chainEndResidueIndexExcl(segs, cI) {
        return segs.residueAtomSegments.index[segs.chainAtomSegments.offsets[cI + 1] - 1] + 1;
    }
    AtomicHierarchy.chainEndResidueIndexExcl = chainEndResidueIndexExcl;
    function chainResidueCount(segs, cI) {
        return chainEndResidueIndexExcl(segs, cI) - chainStartResidueIndex(segs, cI);
    }
    AtomicHierarchy.chainResidueCount = chainResidueCount;
})(AtomicHierarchy || (AtomicHierarchy = {}));
//# sourceMappingURL=hierarchy.js.map

/***/ }),

/***/ "./lib/mol-model/structure/model/properties/atomic/measures.js":
/*!*********************************************************************!*\
  !*** ./lib/mol-model/structure/model/properties/atomic/measures.js ***!
  \*********************************************************************/
/*! exports provided: AtomicNumbers, ElementVdwRadii, ElementAtomWeights, DefaultVdwRadius, DefaultAtomWeight, DefaultAtomNumber, VdwRadius, AtomWeight, AtomNumber */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "AtomicNumbers", function() { return AtomicNumbers; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ElementVdwRadii", function() { return ElementVdwRadii; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ElementAtomWeights", function() { return ElementAtomWeights; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DefaultVdwRadius", function() { return DefaultVdwRadius; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DefaultAtomWeight", function() { return DefaultAtomWeight; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DefaultAtomNumber", function() { return DefaultAtomNumber; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "VdwRadius", function() { return VdwRadius; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "AtomWeight", function() { return AtomWeight; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "AtomNumber", function() { return AtomNumber; });
/**
 * Copyright (c) 2018-2019 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */
var AtomicNumbers = {
    'H': 1, 'D': 1, 'T': 1, 'HE': 2, 'LI': 3, 'BE': 4, 'B': 5, 'C': 6, 'N': 7, 'O': 8, 'F': 9, 'NE': 10, 'NA': 11, 'MG': 12, 'AL': 13, 'SI': 14, 'P': 15, 'S': 16, 'CL': 17, 'AR': 18, 'K': 19, 'CA': 20, 'SC': 21, 'TI': 22, 'V': 23, 'CR': 24, 'MN': 25, 'FE': 26, 'CO': 27, 'NI': 28, 'CU': 29, 'ZN': 30, 'GA': 31, 'GE': 32, 'AS': 33, 'SE': 34, 'BR': 35, 'KR': 36, 'RB': 37, 'SR': 38, 'Y': 39, 'ZR': 40, 'NB': 41, 'MO': 42, 'TC': 43, 'RU': 44, 'RH': 45, 'PD': 46, 'AG': 47, 'CD': 48, 'IN': 49, 'SN': 50, 'SB': 51, 'TE': 52, 'I': 53, 'XE': 54, 'CS': 55, 'BA': 56, 'LA': 57, 'CE': 58, 'PR': 59, 'ND': 60, 'PM': 61, 'SM': 62, 'EU': 63, 'GD': 64, 'TB': 65, 'DY': 66, 'HO': 67, 'ER': 68, 'TM': 69, 'YB': 70, 'LU': 71, 'HF': 72, 'TA': 73, 'W': 74, 'RE': 75, 'OS': 76, 'IR': 77, 'PT': 78, 'AU': 79, 'HG': 80, 'TL': 81, 'PB': 82, 'BI': 83, 'PO': 84, 'AT': 85, 'RN': 86, 'FR': 87, 'RA': 88, 'AC': 89, 'TH': 90, 'PA': 91, 'U': 92, 'NP': 93, 'PU': 94, 'AM': 95, 'CM': 96, 'BK': 97, 'CF': 98, 'ES': 99, 'FM': 100, 'MD': 101, 'NO': 102, 'LR': 103, 'RF': 104, 'DB': 105, 'SG': 106, 'BH': 107, 'HS': 108, 'MT': 109
};
// http://dx.doi.org/10.1021/jp8111556 (or 2.0)
var ElementVdwRadii = {
    1: 1.1, 2: 1.4, 3: 1.81, 4: 1.53, 5: 1.92, 6: 1.7, 7: 1.55, 8: 1.52, 9: 1.47, 10: 1.54, 11: 2.27, 12: 1.73, 13: 1.84, 14: 2.1, 15: 1.8, 16: 1.8, 17: 1.75, 18: 1.88, 19: 2.75, 20: 2.31, 21: 2.3, 22: 2.15, 23: 2.05, 24: 2.05, 25: 2.05, 26: 2.05, 27: 2.0, 28: 2.0, 29: 2.0, 30: 2.1, 31: 1.87, 32: 2.11, 33: 1.85, 34: 1.9, 35: 1.83, 36: 2.02, 37: 3.03, 38: 2.49, 39: 2.4, 40: 2.3, 41: 2.15, 42: 2.1, 43: 2.05, 44: 2.05, 45: 2.0, 46: 2.05, 47: 2.1, 48: 2.2, 49: 2.2, 50: 1.93, 51: 2.17, 52: 2.06, 53: 1.98, 54: 2.16, 55: 3.43, 56: 2.68, 57: 2.5, 58: 2.48, 59: 2.47, 60: 2.45, 61: 2.43, 62: 2.42, 63: 2.4, 64: 2.38, 65: 2.37, 66: 2.35, 67: 2.33, 68: 2.32, 69: 2.3, 70: 2.28, 71: 2.27, 72: 2.25, 73: 2.2, 74: 2.1, 75: 2.05, 76: 2.0, 77: 2.0, 78: 2.05, 79: 2.1, 80: 2.05, 81: 1.96, 82: 2.02, 83: 2.07, 84: 1.97, 85: 2.02, 86: 2.2, 87: 3.48, 88: 2.83, 89: 2.0, 90: 2.4, 91: 2.0, 92: 2.3, 93: 2.0, 94: 2.0, 95: 2.0, 96: 2.0, 97: 2.0, 98: 2.0, 99: 2.0, 100: 2.0, 101: 2.0, 102: 2.0, 103: 2.0, 104: 2.0, 105: 2.0, 106: 2.0, 107: 2.0, 108: 2.0, 109: 2.0
};
// https://doi.org/10.1515/pac-2015-0305 (table 2, 3, and 4)
var ElementAtomWeights = {
    1: 1.008, 2: 4.0026, 3: 6.94, 4: 9.0122, 5: 10.81, 6: 10.81, 7: 14.007, 8: 15.999, 9: 18.998, 10: 20.180, 11: 22.990, 12: 24.305, 13: 26.982, 14: 28.085, 15: 30.974, 16: 32.06, 17: 35.45, 18: 39.948, 19: 39.098, 20: 40.078, 21: 44.956, 22: 47.867, 23: 50.942, 24: 51.996, 25: 54.938, 26: 55.845, 27: 58.933, 28: 58.693, 29: 63.546, 30: 65.38, 31: 69.723, 32: 72.630, 33: 74.922, 34: 78.971, 35: 79.904, 36: 83.798, 37: 85.468, 38: 87.62, 39: 88.906, 40: 91.224, 41: 92.906, 42: 95.95, 43: 96.906, 44: 101.07, 45: 102.91, 46: 106.42, 47: 107.87, 48: 112.41, 49: 114.82, 50: 118.71, 51: 121.76, 52: 127.60, 53: 127.60, 54: 131.29, 55: 132.91, 56: 137.33, 57: 138.91, 58: 140.12, 59: 140.91, 60: 144.24, 61: 144.912, 62: 150.36, 63: 151.96, 64: 157.25, 65: 158.93, 66: 162.50, 67: 164.93, 68: 167.26, 69: 168.93, 70: 173.05, 71: 174.97, 72: 178.49, 73: 180.95, 74: 183.84, 75: 186.21, 76: 190.23, 77: 192.22, 78: 195.08, 79: 196.97, 80: 200.59, 81: 204.38, 82: 207.2, 83: 208.98, 84: 1.97, 85: 2.02, 86: 2.2, 87: 3.48, 88: 2.83, 89: 2.0, 90: 232.04, 91: 231.04, 92: 238.03, 93: 237.048, 94: 244.064, 95: 243.061, 96: 247.070, 97: 247.070, 98: 251.079, 99: 252.083, 100: 257.095, 101: 258.098, 102: 259.101, 103: 262.110, 104: 267.122, 105: 270.131, 106: 271.134, 107: 270.133, 108: 270.134, 109: 278.156
};
var DefaultVdwRadius = 1.7; // C
var DefaultAtomWeight = 10.81; // C
var DefaultAtomNumber = 0;
function VdwRadius(element) {
    var i = AtomicNumbers[element];
    return i === void 0 ? DefaultVdwRadius : ElementVdwRadii[i];
}
function AtomWeight(element) {
    var i = AtomicNumbers[element];
    return i === void 0 ? DefaultAtomWeight : ElementAtomWeights[i];
}
function AtomNumber(element) {
    var i = AtomicNumbers[element];
    return i === void 0 ? DefaultAtomNumber : i;
}
//# sourceMappingURL=measures.js.map

/***/ }),

/***/ "./lib/mol-model/structure/model/properties/atomic/types.js":
/*!******************************************************************!*\
  !*** ./lib/mol-model/structure/model/properties/atomic/types.js ***!
  \******************************************************************/
/*! exports provided: ElementNames, AlkaliMetals, isAlkaliMetal, AlkalineEarthMetals, isAlkalineEarthMetal, PolyatomicNonmetals, isPolyatomicNonmetal, DiatomicNonmetals, isDiatomicNonmetal, NobleGases, isNobleGas, PostTransitionMetals, isPostTransitionMetal, Metalloids, isMetalloid, Halogens, isHalogen, isTransitionMetal, isLanthanide, isActinide, isMetal, isNonmetal */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ElementNames", function() { return ElementNames; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "AlkaliMetals", function() { return AlkaliMetals; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isAlkaliMetal", function() { return isAlkaliMetal; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "AlkalineEarthMetals", function() { return AlkalineEarthMetals; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isAlkalineEarthMetal", function() { return isAlkalineEarthMetal; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "PolyatomicNonmetals", function() { return PolyatomicNonmetals; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isPolyatomicNonmetal", function() { return isPolyatomicNonmetal; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DiatomicNonmetals", function() { return DiatomicNonmetals; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isDiatomicNonmetal", function() { return isDiatomicNonmetal; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "NobleGases", function() { return NobleGases; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isNobleGas", function() { return isNobleGas; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "PostTransitionMetals", function() { return PostTransitionMetals; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isPostTransitionMetal", function() { return isPostTransitionMetal; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Metalloids", function() { return Metalloids; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isMetalloid", function() { return isMetalloid; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Halogens", function() { return Halogens; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isHalogen", function() { return isHalogen; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isTransitionMetal", function() { return isTransitionMetal; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isLanthanide", function() { return isLanthanide; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isActinide", function() { return isActinide; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isMetal", function() { return isMetal; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isNonmetal", function() { return isNonmetal; });
/* harmony import */ var _measures__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./measures */ "./lib/mol-model/structure/model/properties/atomic/measures.js");
/**
 * Copyright (c) 2019 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */

var ElementNames = {
    H: 'Hydrogen', HE: 'Helium', LI: 'Lithium', BE: 'Beryllium', B: 'Boron', C: 'Carbon', N: 'Nitrogen', O: 'Oxygen', F: 'Fluorine', NE: 'Neon', NA: 'Sodium', MG: 'Magnesium', AL: 'Aluminum', SI: 'Silicon', P: 'Phosphorus', S: 'Sulfur', CL: 'Chlorine', AR: 'Argon', K: 'Potassium', CA: 'Calcium', SC: 'Scandium', TI: 'Titanium', V: 'Vanadium', CR: 'Chromium', MN: 'Manganese', FE: 'Iron', CO: 'Cobalt', NI: 'Nickel', CU: 'Copper', ZN: 'Zinc', GA: 'Gallium', GE: 'Germanium', AS: 'Arsenic', SE: 'Selenium', BR: 'Bromine', KR: 'Krypton', RB: 'Rubidium', SR: 'Strontium', Y: 'Yttrium', ZR: 'Zirconium', NB: 'Niobium', MO: 'Molybdenum', TC: 'Technetium', RU: 'Ruthenium', RH: 'Rhodium', PD: 'Palladium', AG: 'Silver', CD: 'Cadmium', IN: 'Indium', SN: 'Tin', SB: 'Antimony', TE: 'Tellurium', I: 'Iodine', XE: 'Xenon', CS: 'Cesium', BA: 'Barium', LA: 'Lanthanum', CE: 'Cerium', PR: 'Praseodymium', ND: 'Neodymium', PM: 'Promethium', SM: 'Samarium', EU: 'Europium', GD: 'Gadolinium', TB: 'Terbium', DY: 'Dysprosium', HO: 'Holmium', ER: 'Erbium', TM: 'Thulium', YB: 'Ytterbium', LU: 'Lutetium', HF: 'Hafnium', TA: 'Tantalum', W: 'Wolfram', RE: 'Rhenium', OS: 'Osmium', IR: 'Iridium', PT: 'Platinum', AU: 'Gold', HG: 'Mercury', TL: 'Thallium', PB: 'Lead', BI: 'Bismuth', PO: 'Polonium', AT: 'Astatine', RN: 'Radon', FR: 'Francium', RA: 'Radium', AC: 'Actinium', TH: 'Thorium', PA: 'Protactinium', U: 'Uranium', NP: 'Neptunium', PU: 'Plutonium', AM: 'Americium', CM: 'Curium', BK: 'Berkelium', CF: 'Californium', ES: 'Einsteinium', FM: 'Fermium', MD: 'Mendelevium', NO: 'Nobelium', LR: 'Lawrencium', RF: 'Rutherfordium', DB: 'Dubnium', SG: 'Seaborgium', BH: 'Bohrium', HS: 'Hassium', MT: 'Meitnerium', DS: 'Darmstadtium', RG: 'Roentgenium', CN: 'Copernicium', NH: 'Nihonium', FL: 'Flerovium', MC: 'Moscovium', LV: 'Livermorium', TS: 'Tennessine', OG: 'Oganesson'
};
var AlkaliMetals = new Set(['LI', 'NA', 'K', 'RB', 'CS', 'FR']);
function isAlkaliMetal(element) { return AlkaliMetals.has(element); }
var AlkalineEarthMetals = new Set(['BE', 'MG', 'CA', 'SR', 'BA', 'RA']);
function isAlkalineEarthMetal(element) { return AlkalineEarthMetals.has(element); }
var PolyatomicNonmetals = new Set(['C', 'P', 'S', 'SE']);
function isPolyatomicNonmetal(element) { return PolyatomicNonmetals.has(element); }
var DiatomicNonmetals = new Set(['H', 'N', 'O', 'F', 'CL', 'BR', 'I']);
function isDiatomicNonmetal(element) { return DiatomicNonmetals.has(element); }
var NobleGases = new Set(['HE', 'NE', 'AR', 'KR', 'XE', 'RN']);
function isNobleGas(element) { return NobleGases.has(element); }
var PostTransitionMetals = new Set(['ZN', 'GA', 'CD', 'IN', 'SN', 'HG', 'TI', 'PB', 'BI', 'PO', 'CN']);
function isPostTransitionMetal(element) { return PostTransitionMetals.has(element); }
var Metalloids = new Set(['B', 'SI', 'GE', 'AS', 'SB', 'TE', 'AT']);
function isMetalloid(element) { return Metalloids.has(element); }
var Halogens = new Set(['F', 'CL', 'BR', 'I', 'AT']);
function isHalogen(element) { return Halogens.has(element); }
function isTransitionMetal(element) {
    var no = Object(_measures__WEBPACK_IMPORTED_MODULE_0__["AtomNumber"])(element);
    return ((no >= 21 && no <= 29) ||
        (no >= 39 && no <= 47) ||
        (no >= 72 && no <= 79) ||
        (no >= 104 && no <= 108));
}
function isLanthanide(element) {
    var no = Object(_measures__WEBPACK_IMPORTED_MODULE_0__["AtomNumber"])(element);
    return no >= 57 && no <= 71;
}
function isActinide(element) {
    var no = Object(_measures__WEBPACK_IMPORTED_MODULE_0__["AtomNumber"])(element);
    return no >= 89 && no <= 103;
}
function isMetal(element) {
    return (isAlkaliMetal(element) ||
        isAlkalineEarthMetal(element) ||
        isLanthanide(element) ||
        isActinide(element) ||
        isTransitionMetal(element) ||
        isPostTransitionMetal(element));
}
function isNonmetal(element) {
    return (isDiatomicNonmetal(element) ||
        isPolyatomicNonmetal(element) ||
        isNobleGas(element));
}
//# sourceMappingURL=types.js.map

/***/ }),

/***/ "./lib/mol-model/structure/model/properties/coarse.js":
/*!************************************************************!*\
  !*** ./lib/mol-model/structure/model/properties/coarse.js ***!
  \************************************************************/
/*! exports provided: CoarseHierarchy */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _coarse_conformation__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./coarse/conformation */ "./lib/mol-model/structure/model/properties/coarse/conformation.js");
/* empty/unused harmony star reexport *//* harmony import */ var _coarse_hierarchy__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./coarse/hierarchy */ "./lib/mol-model/structure/model/properties/coarse/hierarchy.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "CoarseHierarchy", function() { return _coarse_hierarchy__WEBPACK_IMPORTED_MODULE_1__["CoarseHierarchy"]; });

/**
 * Copyright (c) 2017 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author David Sehnal <david.sehnal@gmail.com>
 */


//# sourceMappingURL=coarse.js.map

/***/ }),

/***/ "./lib/mol-model/structure/model/properties/coarse/conformation.js":
/*!*************************************************************************!*\
  !*** ./lib/mol-model/structure/model/properties/coarse/conformation.js ***!
  \*************************************************************************/
/*! no exports provided */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/**
 * Copyright (c) 2018 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author David Sehnal <david.sehnal@gmail.com>
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */

//# sourceMappingURL=conformation.js.map

/***/ }),

/***/ "./lib/mol-model/structure/model/properties/coarse/hierarchy.js":
/*!**********************************************************************!*\
  !*** ./lib/mol-model/structure/model/properties/coarse/hierarchy.js ***!
  \**********************************************************************/
/*! exports provided: CoarseHierarchy */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CoarseHierarchy", function() { return CoarseHierarchy; });
/**
 * Copyright (c) 2018 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author David Sehnal <david.sehnal@gmail.com>
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */
var CoarseHierarchy;
(function (CoarseHierarchy) {
    CoarseHierarchy.Empty = { isDefined: false };
})(CoarseHierarchy || (CoarseHierarchy = {}));
//# sourceMappingURL=hierarchy.js.map

/***/ }),

/***/ "./lib/mol-model/structure/model/properties/common.js":
/*!************************************************************!*\
  !*** ./lib/mol-model/structure/model/properties/common.js ***!
  \************************************************************/
/*! exports provided: EntitySubtype */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "EntitySubtype", function() { return EntitySubtype; });
/* harmony import */ var _mol_data_db__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../../../mol-data/db */ "./lib/mol-data/db.js");
/**
 * Copyright (c) 2018-2021 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 * @author David Sehnal <david.sehnal@gmail.com>
 */

var EntitySubtype = _mol_data_db__WEBPACK_IMPORTED_MODULE_0__["Column"].Schema.Aliased(_mol_data_db__WEBPACK_IMPORTED_MODULE_0__["Column"].Schema.Str(''));
//# sourceMappingURL=common.js.map

/***/ }),

/***/ "./lib/mol-model/structure/model/properties/custom/indexed.js":
/*!********************************************************************!*\
  !*** ./lib/mol-model/structure/model/properties/custom/indexed.js ***!
  \********************************************************************/
/*! exports provided: IndexedCustomProperty */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "IndexedCustomProperty", function() { return IndexedCustomProperty; });
/* harmony import */ var _structure__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../../structure */ "./lib/mol-model/structure/structure.js");
/* harmony import */ var _mol_data_int__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../../../../mol-data/int */ "./lib/mol-data/int.js");
/* harmony import */ var _mol_util__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../../../../mol-util */ "./lib/mol-util/index.js");
/**
 * Copyright (c) 2018 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author David Sehnal <david.sehnal@gmail.com>
 */



var IndexedCustomProperty;
(function (IndexedCustomProperty) {
    function getCifDataSource(structure, prop, cache) {
        if (!prop)
            return { rowCount: 0 };
        if (cache && cache[prop.id])
            return cache[prop.id];
        var data = prop.getElements(structure);
        var ret = { data: data, rowCount: data.elements.length };
        if (cache)
            cache[prop.id] = ret;
        return ret;
    }
    IndexedCustomProperty.getCifDataSource = getCifDataSource;
    function fromAtomMap(map) {
        return new ElementMappedCustomProperty(map);
    }
    IndexedCustomProperty.fromAtomMap = fromAtomMap;
    function fromAtomArray(array) {
        // TODO: create "array based custom property" as optimization
        return new ElementMappedCustomProperty(arrayToMap(array));
    }
    IndexedCustomProperty.fromAtomArray = fromAtomArray;
    var getResidueSegments = function (model) { return model.atomicHierarchy.residueAtomSegments; };
    function fromResidueMap(map) {
        return new SegmentedMappedIndexedCustomProperty('residue', map, getResidueSegments, 0 /* Atomic */);
    }
    IndexedCustomProperty.fromResidueMap = fromResidueMap;
    function fromResidueArray(array) {
        // TODO: create "array based custom property" as optimization
        return new SegmentedMappedIndexedCustomProperty('residue', arrayToMap(array), getResidueSegments, 0 /* Atomic */);
    }
    IndexedCustomProperty.fromResidueArray = fromResidueArray;
    var getChainSegments = function (model) { return model.atomicHierarchy.chainAtomSegments; };
    function fromChainMap(map) {
        return new SegmentedMappedIndexedCustomProperty('chain', map, getChainSegments, 0 /* Atomic */);
    }
    IndexedCustomProperty.fromChainMap = fromChainMap;
    function fromChainArray(array) {
        // TODO: create "array based custom property" as optimization
        return new SegmentedMappedIndexedCustomProperty('chain', arrayToMap(array), getChainSegments, 0 /* Atomic */);
    }
    IndexedCustomProperty.fromChainArray = fromChainArray;
    function fromEntityMap(map) {
        return new EntityMappedCustomProperty(map);
    }
    IndexedCustomProperty.fromEntityMap = fromEntityMap;
})(IndexedCustomProperty || (IndexedCustomProperty = {}));
function arrayToMap(array) {
    var ret = new Map();
    for (var i = 0, _i = array.length; i < _i; i++)
        ret.set(i, array[i]);
    return ret;
}
var SegmentedMappedIndexedCustomProperty = /** @class */ (function () {
    function SegmentedMappedIndexedCustomProperty(level, map, segmentGetter, kind) {
        this.level = level;
        this.map = map;
        this.segmentGetter = segmentGetter;
        this.id = _mol_util__WEBPACK_IMPORTED_MODULE_2__["UUID"].create22();
        this.kind = kind;
    }
    SegmentedMappedIndexedCustomProperty.prototype.has = function (idx) { return this.map.has(idx); };
    SegmentedMappedIndexedCustomProperty.prototype.get = function (idx) { return this.map.get(idx); };
    SegmentedMappedIndexedCustomProperty.prototype.getStructureElements = function (structure) {
        var models = structure.models;
        if (models.length !== 1)
            throw new Error("Only works on structures with a single model.");
        var seenIndices = new Set();
        var unitGroups = structure.unitSymmetryGroups;
        var loci = [];
        var segments = this.segmentGetter(models[0]);
        for (var _a = 0, unitGroups_1 = unitGroups; _a < unitGroups_1.length; _a++) {
            var unitGroup = unitGroups_1[_a];
            var unit = unitGroup.units[0];
            if (unit.kind !== this.kind) {
                continue;
            }
            var chains = _mol_data_int__WEBPACK_IMPORTED_MODULE_1__["Segmentation"].transientSegments(segments, unit.elements);
            while (chains.hasNext) {
                var seg = chains.move();
                if (!this.has(seg.index) || seenIndices.has(seg.index))
                    continue;
                seenIndices.add(seg.index);
                loci[loci.length] = _structure__WEBPACK_IMPORTED_MODULE_0__["StructureElement"].Location.create(structure, unit, unit.elements[seg.start]);
            }
        }
        loci.sort(function (x, y) { return x.element - y.element; });
        return loci;
    };
    SegmentedMappedIndexedCustomProperty.prototype.getElements = function (structure) {
        var _this = this;
        var index = this.segmentGetter(structure.model).index;
        var elements = this.getStructureElements(structure);
        return { elements: elements, property: function (i) { return _this.get(index[elements[i].element]); } };
    };
    return SegmentedMappedIndexedCustomProperty;
}());
var ElementMappedCustomProperty = /** @class */ (function () {
    function ElementMappedCustomProperty(map) {
        this.map = map;
        this.id = _mol_util__WEBPACK_IMPORTED_MODULE_2__["UUID"].create22();
        this.level = 'atom';
        this.kind = 0 /* Atomic */;
    }
    ElementMappedCustomProperty.prototype.has = function (idx) { return this.map.has(idx); };
    ElementMappedCustomProperty.prototype.get = function (idx) { return this.map.get(idx); };
    ElementMappedCustomProperty.prototype.getStructureElements = function (structure) {
        var models = structure.models;
        if (models.length !== 1)
            throw new Error("Only works on structures with a single model.");
        var seenIndices = new Set();
        var unitGroups = structure.unitSymmetryGroups;
        var loci = [];
        for (var _a = 0, unitGroups_2 = unitGroups; _a < unitGroups_2.length; _a++) {
            var unitGroup = unitGroups_2[_a];
            var unit = unitGroup.units[0];
            if (unit.kind !== this.kind) {
                continue;
            }
            var elements = unit.elements;
            for (var i = 0, _i = elements.length; i < _i; i++) {
                var e = elements[i];
                if (!this.has(e) || seenIndices.has(e))
                    continue;
                seenIndices.add(elements[i]);
                loci[loci.length] = _structure__WEBPACK_IMPORTED_MODULE_0__["StructureElement"].Location.create(structure, unit, e);
            }
        }
        loci.sort(function (x, y) { return x.element - y.element; });
        return loci;
    };
    ElementMappedCustomProperty.prototype.getElements = function (structure) {
        var _this = this;
        var elements = this.getStructureElements(structure);
        return { elements: elements, property: function (i) { return _this.get(elements[i].element); } };
    };
    return ElementMappedCustomProperty;
}());
var EntityMappedCustomProperty = /** @class */ (function () {
    function EntityMappedCustomProperty(map) {
        this.map = map;
        this.id = _mol_util__WEBPACK_IMPORTED_MODULE_2__["UUID"].create22();
        this.level = 'entity';
        this.kind = 0 /* Atomic */;
    }
    EntityMappedCustomProperty.prototype.has = function (idx) { return this.map.has(idx); };
    EntityMappedCustomProperty.prototype.get = function (idx) { return this.map.get(idx); };
    EntityMappedCustomProperty.prototype.getStructureElements = function (structure) {
        var models = structure.models;
        if (models.length !== 1)
            throw new Error("Only works on structures with a single model.");
        var index = models[0].atomicHierarchy.index;
        var seenIndices = new Set();
        var unitGroups = structure.unitSymmetryGroups;
        var loci = [];
        var segments = models[0].atomicHierarchy.chainAtomSegments;
        for (var _a = 0, unitGroups_3 = unitGroups; _a < unitGroups_3.length; _a++) {
            var unitGroup = unitGroups_3[_a];
            var unit = unitGroup.units[0];
            if (unit.kind !== this.kind) {
                continue;
            }
            var chains = _mol_data_int__WEBPACK_IMPORTED_MODULE_1__["Segmentation"].transientSegments(segments, unit.elements);
            while (chains.hasNext) {
                var seg = chains.move();
                var eI = index.getEntityFromChain(seg.index);
                if (!this.has(eI) || seenIndices.has(eI))
                    continue;
                seenIndices.add(eI);
                loci[loci.length] = _structure__WEBPACK_IMPORTED_MODULE_0__["StructureElement"].Location.create(structure, unit, unit.elements[seg.start]);
            }
        }
        loci.sort(function (x, y) { return x.element - y.element; });
        return loci;
    };
    EntityMappedCustomProperty.prototype.getElements = function (structure) {
        var _this = this;
        var elements = this.getStructureElements(structure);
        var chainIndex = structure.model.atomicHierarchy.chainAtomSegments.index;
        var index = structure.model.atomicHierarchy.index;
        return { elements: elements, property: function (i) { return _this.get(index.getEntityFromChain(chainIndex[elements[i].element])); } };
    };
    return EntityMappedCustomProperty;
}());
//# sourceMappingURL=indexed.js.map

/***/ }),

/***/ "./lib/mol-model/structure/model/properties/global-transform.js":
/*!**********************************************************************!*\
  !*** ./lib/mol-model/structure/model/properties/global-transform.js ***!
  \**********************************************************************/
/*! exports provided: GlobalModelTransformInfo */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "GlobalModelTransformInfo", function() { return GlobalModelTransformInfo; });
/* harmony import */ var _mol_model_formats_structure_common_property__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../../../mol-model-formats/structure/common/property */ "./lib/mol-model-formats/structure/common/property.js");
/* harmony import */ var _custom_property__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../../custom-property */ "./lib/mol-model/custom-property.js");
/* harmony import */ var _mol_data_db__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../../../mol-data/db */ "./lib/mol-data/db.js");
/* harmony import */ var _mol_io_writer_cif__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../../../mol-io/writer/cif */ "./lib/mol-io/writer/cif.js");
/* harmony import */ var _mol_model_formats_structure_mmcif__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../../../mol-model-formats/structure/mmcif */ "./lib/mol-model-formats/structure/mmcif.js");
/* harmony import */ var _mol_io_reader_cif_schema__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../../../mol-io/reader/cif/schema */ "./lib/mol-io/reader/cif/schema.js");
/**
 * Copyright (c) 2020 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author David Sehnal <david.sehnal@gmail.com>
 */






var GlobalModelTransformInfo;
(function (GlobalModelTransformInfo) {
    var _a;
    var CategoryName = 'molstar_global_model_transform_info';
    GlobalModelTransformInfo.Schema = (_a = {},
        _a[CategoryName] = {
            matrix: _mol_data_db__WEBPACK_IMPORTED_MODULE_2__["Column"].Schema.Matrix(4, 4, _mol_data_db__WEBPACK_IMPORTED_MODULE_2__["Column"].Schema.float)
        },
        _a);
    GlobalModelTransformInfo.Descriptor = Object(_custom_property__WEBPACK_IMPORTED_MODULE_1__["CustomPropertyDescriptor"])({
        name: CategoryName,
        cifExport: {
            categories: [{
                    name: CategoryName,
                    instance: function (ctx) {
                        var mat = get(ctx.firstModel);
                        if (!mat)
                            return _mol_io_writer_cif__WEBPACK_IMPORTED_MODULE_3__["CifWriter"].Category.Empty;
                        var table = _mol_data_db__WEBPACK_IMPORTED_MODULE_2__["Table"].ofRows(GlobalModelTransformInfo.Schema.molstar_global_model_transform_info, [{ matrix: mat }]);
                        return _mol_io_writer_cif__WEBPACK_IMPORTED_MODULE_3__["CifWriter"].Category.ofTable(table);
                    }
                }],
            prefix: 'molstar'
        }
    });
    GlobalModelTransformInfo.Provider = _mol_model_formats_structure_common_property__WEBPACK_IMPORTED_MODULE_0__["FormatPropertyProvider"].create(GlobalModelTransformInfo.Descriptor);
    function attach(model, matrix) {
        if (!model.customProperties.has(GlobalModelTransformInfo.Descriptor)) {
            model.customProperties.add(GlobalModelTransformInfo.Descriptor);
        }
        GlobalModelTransformInfo.Provider.set(model, matrix);
    }
    GlobalModelTransformInfo.attach = attach;
    function get(model) {
        return GlobalModelTransformInfo.Provider.get(model);
    }
    GlobalModelTransformInfo.get = get;
    function fromMmCif(model) {
        if (!_mol_model_formats_structure_mmcif__WEBPACK_IMPORTED_MODULE_4__["MmcifFormat"].is(model.sourceData))
            return;
        var cat = model.sourceData.data.frame.categories[CategoryName];
        if (!cat)
            return;
        var table = Object(_mol_io_reader_cif_schema__WEBPACK_IMPORTED_MODULE_5__["toTable"])(GlobalModelTransformInfo.Schema[CategoryName], cat);
        if (table._rowCount === 0)
            return;
        return table.matrix.value(0);
    }
    GlobalModelTransformInfo.fromMmCif = fromMmCif;
    function hasData(model) {
        if (!_mol_model_formats_structure_mmcif__WEBPACK_IMPORTED_MODULE_4__["MmcifFormat"].is(model.sourceData))
            return false;
        var cat = model.sourceData.data.frame.categories[CategoryName];
        return !!cat && cat.rowCount > 0;
    }
    GlobalModelTransformInfo.hasData = hasData;
    function writeMmCif(encoder, matrix) {
        encoder.writeCategory({
            name: CategoryName,
            instance: function () {
                var table = _mol_data_db__WEBPACK_IMPORTED_MODULE_2__["Table"].ofRows(GlobalModelTransformInfo.Schema.molstar_global_model_transform_info, [{ matrix: matrix }]);
                return _mol_io_writer_cif__WEBPACK_IMPORTED_MODULE_3__["CifWriter"].Category.ofTable(table);
            }
        });
    }
    GlobalModelTransformInfo.writeMmCif = writeMmCif;
})(GlobalModelTransformInfo || (GlobalModelTransformInfo = {}));
//# sourceMappingURL=global-transform.js.map

/***/ }),

/***/ "./lib/mol-model/structure/model/properties/seconday-structure.js":
/*!************************************************************************!*\
  !*** ./lib/mol-model/structure/model/properties/seconday-structure.js ***!
  \************************************************************************/
/*! exports provided: SecondaryStructure */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SecondaryStructure", function() { return SecondaryStructure; });
/**
 * Copyright (c) 2017-2019 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author David Sehnal <david.sehnal@gmail.com>
 */
function SecondaryStructure(type, key, elements, getIndex) {
    return { type: type, key: key, elements: elements, getIndex: getIndex };
}

//# sourceMappingURL=seconday-structure.js.map

/***/ }),

/***/ "./lib/mol-model/structure/model/properties/sequence.js":
/*!**************************************************************!*\
  !*** ./lib/mol-model/structure/model/properties/sequence.js ***!
  \**************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _mol_data_db__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../../../mol-data/db */ "./lib/mol-data/db.js");
/* harmony import */ var _sequence__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../../sequence */ "./lib/mol-model/sequence.js");
/**
 * Copyright (c) 2018-2019 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author David Sehnal <david.sehnal@gmail.com>
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */


var StructureSequence;
(function (StructureSequence) {
    var Empty = { byEntityKey: {}, sequences: [] };
    function merge() {
        var entitySeqs = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            entitySeqs[_i] = arguments[_i];
        }
        var sequences = [];
        var byEntityKey = {};
        for (var i = 0, il = entitySeqs.length; i < il; ++i) {
            sequences.push.apply(sequences, entitySeqs[i].sequences);
            Object.assign(byEntityKey, entitySeqs[i].byEntityKey);
        }
        return { sequences: sequences, byEntityKey: byEntityKey };
    }
    function fromHierarchy(entities, atomicHierarchy, coarseHierarchy) {
        var atomic = fromAtomicHierarchy(entities, atomicHierarchy);
        var coarse = coarseHierarchy.isDefined ? fromCoarseHierarchy(entities, coarseHierarchy) : Empty;
        return merge(atomic, coarse);
    }
    StructureSequence.fromHierarchy = fromHierarchy;
    function fromAtomicHierarchy(entities, hierarchy) {
        var label_comp_id = hierarchy.atoms.label_comp_id;
        var label_seq_id = hierarchy.residues.label_seq_id;
        var chainAtomSegments = hierarchy.chainAtomSegments, residueAtomSegments = hierarchy.residueAtomSegments;
        var count = chainAtomSegments.count, offsets = chainAtomSegments.offsets;
        var byEntityKey = {};
        var sequences = [];
        // check if chain segments are empty
        if (count === 1 && offsets[0] === 0 && offsets[1] === 0) {
            return { byEntityKey: byEntityKey, sequences: sequences };
        }
        for (var cI = 0, _cI = hierarchy.chains._rowCount; cI < _cI; cI++) {
            var entityKey = hierarchy.index.getEntityFromChain(cI);
            // Only for polymers, trying to mirror _entity_poly_seq
            if (byEntityKey[entityKey] !== void 0 || entities.data.type.value(entityKey) !== 'polymer')
                continue;
            var start = cI;
            cI++;
            while (cI < _cI && entityKey === hierarchy.index.getEntityFromChain(cI) && entities.data.type.value(entityKey) !== 'polymer') {
                cI++;
            }
            cI--;
            var rStart = residueAtomSegments.index[offsets[start]];
            var rEnd = residueAtomSegments.index[offsets[cI + 1] - 1] + 1;
            var seqId = _mol_data_db__WEBPACK_IMPORTED_MODULE_0__["Column"].window(label_seq_id, rStart, rEnd);
            var _compId = [];
            for (var rI = rStart; rI < rEnd; ++rI) {
                _compId.push(label_comp_id.value(residueAtomSegments.offsets[rI]));
            }
            var compId = _mol_data_db__WEBPACK_IMPORTED_MODULE_0__["Column"].ofStringArray(_compId);
            byEntityKey[entityKey] = {
                entityId: entities.data.id.value(entityKey),
                sequence: _sequence__WEBPACK_IMPORTED_MODULE_1__["Sequence"].ofResidueNames(compId, seqId)
            };
            sequences.push(byEntityKey[entityKey]);
        }
        return { byEntityKey: byEntityKey, sequences: sequences };
    }
    StructureSequence.fromAtomicHierarchy = fromAtomicHierarchy;
    function fromCoarseHierarchy(entities, hierarchy) {
        var spheres = fromCoarseElements(entities, hierarchy.spheres);
        var gaussians = fromCoarseElements(entities, hierarchy.gaussians);
        return merge(spheres, gaussians);
    }
    StructureSequence.fromCoarseHierarchy = fromCoarseHierarchy;
    function fromCoarseElements(entities, elements) {
        var chainElementSegments = elements.chainElementSegments, seq_id_begin = elements.seq_id_begin, seq_id_end = elements.seq_id_end;
        var count = chainElementSegments.count, offsets = chainElementSegments.offsets;
        var byEntityKey = {};
        var sequences = [];
        // check if chain segments are empty
        if (count === 1 && offsets[0] === 0 && offsets[1] === 0) {
            return { byEntityKey: byEntityKey, sequences: sequences };
        }
        for (var cI = 0, _cI = count; cI < _cI; cI++) {
            var eK = elements.getEntityFromChain(cI);
            if (byEntityKey[eK] !== void 0)
                continue;
            var start = cI;
            cI++;
            while (cI < _cI && eK === elements.getEntityFromChain(cI)) {
                cI++;
            }
            cI--;
            var eStart = offsets[start];
            var eEnd = offsets[cI + 1] - 1;
            var seqIdBegin = _mol_data_db__WEBPACK_IMPORTED_MODULE_0__["Column"].window(seq_id_begin, eStart, eEnd);
            var seqIdEnd = _mol_data_db__WEBPACK_IMPORTED_MODULE_0__["Column"].window(seq_id_end, eStart, eEnd);
            byEntityKey[eK] = {
                entityId: entities.data.id.value(eK),
                sequence: _sequence__WEBPACK_IMPORTED_MODULE_1__["Sequence"].ofSequenceRanges(seqIdBegin, seqIdEnd)
            };
            sequences.push(byEntityKey[eK]);
        }
        return { byEntityKey: byEntityKey, sequences: sequences };
    }
    StructureSequence.fromCoarseElements = fromCoarseElements;
})(StructureSequence || (StructureSequence = {}));
/* harmony default export */ __webpack_exports__["default"] = (StructureSequence);
//# sourceMappingURL=sequence.js.map

/***/ }),

/***/ "./lib/mol-model/structure/model/properties/symmetry.js":
/*!**************************************************************!*\
  !*** ./lib/mol-model/structure/model/properties/symmetry.js ***!
  \**************************************************************/
/*! exports provided: Assembly, Symmetry */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Assembly", function() { return Assembly; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Symmetry", function() { return Symmetry; });
/* harmony import */ var _mol_data_util__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../../../mol-data/util */ "./lib/mol-data/util.js");
/* harmony import */ var _mol_math_geometry__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../../../mol-math/geometry */ "./lib/mol-math/geometry.js");
/* harmony import */ var _mol_model_formats_structure_property_symmetry__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../../../mol-model-formats/structure/property/symmetry */ "./lib/mol-model-formats/structure/property/symmetry.js");
/* harmony import */ var _mol_math_misc__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../../../mol-math/misc */ "./lib/mol-math/misc.js");
/**
 * Copyright (c) 2017-2019 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author David Sehnal <david.sehnal@gmail.com>
 */




var Assembly = /** @class */ (function () {
    function Assembly(id, details, operatorsProvider) {
        this.operatorsProvider = operatorsProvider;
        this.id = id;
        this.details = details;
    }
    Object.defineProperty(Assembly.prototype, "operatorGroups", {
        get: function () {
            if (this._operators)
                return this._operators;
            this._operators = this.operatorsProvider();
            return this._operators;
        },
        enumerable: false,
        configurable: true
    });
    return Assembly;
}());

(function (Assembly) {
    function create(id, details, operatorsProvider) {
        return new Assembly(id, details, operatorsProvider);
    }
    Assembly.create = create;
})(Assembly || (Assembly = {}));
var Symmetry;
(function (Symmetry) {
    Symmetry.Default = { assemblies: [], spacegroup: _mol_math_geometry__WEBPACK_IMPORTED_MODULE_1__["Spacegroup"].ZeroP1, isNonStandardCrystalFrame: false };
    function findAssembly(model, id) {
        var _id = id.toLocaleLowerCase();
        var symmetry = _mol_model_formats_structure_property_symmetry__WEBPACK_IMPORTED_MODULE_2__["ModelSymmetry"].Provider.get(model);
        return symmetry ? Object(_mol_data_util__WEBPACK_IMPORTED_MODULE_0__["arrayFind"])(symmetry.assemblies, function (a) { return a.id.toLowerCase() === _id; }) : undefined;
    }
    Symmetry.findAssembly = findAssembly;
    function getUnitcellLabel(symmetry) {
        var _a = symmetry.spacegroup, cell = _a.cell, name = _a.name, num = _a.num;
        var size = cell.size, anglesInRadians = cell.anglesInRadians;
        var a = size[0].toFixed(2);
        var b = size[1].toFixed(2);
        var c = size[2].toFixed(2);
        var alpha = Object(_mol_math_misc__WEBPACK_IMPORTED_MODULE_3__["radToDeg"])(anglesInRadians[0]).toFixed(2);
        var beta = Object(_mol_math_misc__WEBPACK_IMPORTED_MODULE_3__["radToDeg"])(anglesInRadians[1]).toFixed(2);
        var gamma = Object(_mol_math_misc__WEBPACK_IMPORTED_MODULE_3__["radToDeg"])(anglesInRadians[2]).toFixed(2);
        var label = [];
        // name
        label.push("Unit Cell <b>" + name + "</b> #" + num);
        // sizes
        label.push(a + "\u00D7" + b + "\u00D7" + c + " \u212B");
        // angles
        label.push("\u03B1=" + alpha + "\u00B0 \u03B2=" + beta + "\u00B0 \u03B3=" + gamma + "\u00B0");
        return label.join(' | ');
    }
    Symmetry.getUnitcellLabel = getUnitcellLabel;
})(Symmetry || (Symmetry = {}));

//# sourceMappingURL=symmetry.js.map

/***/ }),

/***/ "./lib/mol-model/structure/model/properties/utils/atomic-derived.js":
/*!**************************************************************************!*\
  !*** ./lib/mol-model/structure/model/properties/utils/atomic-derived.js ***!
  \**************************************************************************/
/*! exports provided: getAtomicDerivedData */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getAtomicDerivedData", function() { return getAtomicDerivedData; });
/* harmony import */ var _atomic__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../atomic */ "./lib/mol-model/structure/model/properties/atomic.js");
/* harmony import */ var _types__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../types */ "./lib/mol-model/structure/model/types.js");
/* harmony import */ var _mol_model_structure_util__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../../../../mol-model/structure/util */ "./lib/mol-model/structure/util.js");
/* harmony import */ var _mol_util_debug__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../../../../mol-util/debug */ "./lib/mol-util/debug.js");
/**
 * Copyright (c) 2018-2020 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */




function getAtomicDerivedData(data, segments, index, chemicalComponentMap) {
    var _a = data.atoms, label_comp_id = _a.label_comp_id, type_symbol = _a.type_symbol, atomCount = _a._rowCount;
    var residueCount = data.residues._rowCount;
    var offsets = segments.residueAtomSegments.offsets;
    var atomicNumber = new Uint8Array(atomCount);
    for (var i = 0; i < atomCount; ++i) {
        atomicNumber[i] = Object(_atomic__WEBPACK_IMPORTED_MODULE_0__["AtomNumber"])(type_symbol.value(i));
    }
    var traceElementIndex = new Int32Array(residueCount);
    var directionFromElementIndex = new Int32Array(residueCount);
    var directionToElementIndex = new Int32Array(residueCount);
    var moleculeType = new Uint8Array(residueCount);
    var polymerType = new Uint8Array(residueCount);
    var moleculeTypeMap = new Map();
    var polymerTypeMap = new Map();
    for (var i = 0; i < residueCount; ++i) {
        var compId = label_comp_id.value(offsets[i]);
        var chemCompMap = chemicalComponentMap;
        var molType = void 0;
        var polyType = void 0;
        if (moleculeTypeMap.has(compId)) {
            molType = moleculeTypeMap.get(compId);
            polyType = polymerTypeMap.get(compId);
        }
        else {
            var type = void 0;
            if (chemCompMap.has(compId)) {
                type = chemCompMap.get(compId).type;
            }
            else {
                if (!_mol_util_debug__WEBPACK_IMPORTED_MODULE_3__["isProductionMode"])
                    console.info('chemComp not found', compId);
                type = Object(_types__WEBPACK_IMPORTED_MODULE_1__["getComponentType"])(compId);
            }
            molType = Object(_types__WEBPACK_IMPORTED_MODULE_1__["getMoleculeType"])(type, compId);
            // TODO if unknown molecule type, use atom names to guess molecule type
            polyType = Object(_types__WEBPACK_IMPORTED_MODULE_1__["getPolymerType"])(type, molType);
            moleculeTypeMap.set(compId, molType);
            polymerTypeMap.set(compId, polyType);
        }
        moleculeType[i] = molType;
        polymerType[i] = polyType;
        var traceAtomId = Object(_mol_model_structure_util__WEBPACK_IMPORTED_MODULE_2__["getAtomIdForAtomRole"])(polyType, 'trace');
        var traceIndex = index.findAtomsOnResidue(i, traceAtomId);
        if (traceIndex === -1) {
            var coarseAtomId = Object(_mol_model_structure_util__WEBPACK_IMPORTED_MODULE_2__["getAtomIdForAtomRole"])(polyType, 'coarseBackbone');
            traceIndex = index.findAtomsOnResidue(i, coarseAtomId);
        }
        traceElementIndex[i] = traceIndex;
        var directionFromAtomId = Object(_mol_model_structure_util__WEBPACK_IMPORTED_MODULE_2__["getAtomIdForAtomRole"])(polyType, 'directionFrom');
        directionFromElementIndex[i] = index.findAtomsOnResidue(i, directionFromAtomId);
        var directionToAtomId = Object(_mol_model_structure_util__WEBPACK_IMPORTED_MODULE_2__["getAtomIdForAtomRole"])(polyType, 'directionTo');
        directionToElementIndex[i] = index.findAtomsOnResidue(i, directionToAtomId);
    }
    return {
        atom: {
            atomicNumber: atomicNumber
        },
        residue: {
            traceElementIndex: traceElementIndex,
            directionFromElementIndex: directionFromElementIndex,
            directionToElementIndex: directionToElementIndex,
            moleculeType: moleculeType,
            polymerType: polymerType,
        }
    };
}
//# sourceMappingURL=atomic-derived.js.map

/***/ }),

/***/ "./lib/mol-model/structure/model/properties/utils/atomic-index.js":
/*!************************************************************************!*\
  !*** ./lib/mol-model/structure/model/properties/utils/atomic-index.js ***!
  \************************************************************************/
/*! exports provided: getAtomicIndex */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getAtomicIndex", function() { return getAtomicIndex; });
/* harmony import */ var _mol_data_int__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../../../../mol-data/int */ "./lib/mol-data/int.js");
/* harmony import */ var _atomic_hierarchy__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../atomic/hierarchy */ "./lib/mol-model/structure/model/properties/atomic/hierarchy.js");
/* harmony import */ var _mol_data_util__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../../../../mol-data/util */ "./lib/mol-data/util.js");
/**
 * Copyright (c) 2017-2020 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author David Sehnal <david.sehnal@gmail.com>
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */



function getResidueId(seq_id, ins_code) {
    if (!ins_code)
        return seq_id;
    if (ins_code.length === 1)
        return Object(_mol_data_util__WEBPACK_IMPORTED_MODULE_2__["cantorPairing"])(ins_code.charCodeAt(0), seq_id);
    if (ins_code.length === 2)
        return Object(_mol_data_util__WEBPACK_IMPORTED_MODULE_2__["cantorPairing"])(ins_code.charCodeAt(0), Object(_mol_data_util__WEBPACK_IMPORTED_MODULE_2__["cantorPairing"])(ins_code.charCodeAt(1), seq_id));
    return seq_id + " " + ins_code;
}
function updateMapMapIndex(map, key0, key1, index) {
    if (map.has(key0)) {
        var submap = map.get(key0);
        if (!submap.has(key1)) {
            submap.set(key1, index);
        }
    }
    else {
        var submap = new Map();
        map.set(key0, submap);
        submap.set(key1, index);
    }
}
function missingEntity(k) {
    throw new Error("Missing entity entry for entity id '" + k + "'.");
}
function createMapping(entities, data, segments) {
    return {
        entities: entities,
        segments: segments,
        label_seq_id: _mol_data_int__WEBPACK_IMPORTED_MODULE_0__["SortedArray"].ofSortedArray(data.residues.label_seq_id.toArray({ array: Int32Array })),
        label_atom_id: data.atoms.label_atom_id,
        auth_atom_id: data.atoms.auth_atom_id,
        label_alt_id: data.atoms.label_alt_id,
        chain_index_entity_index: new Int32Array(data.chains._rowCount),
        entity_index_label_asym_id: new Map(),
        chain_index_label_seq_id: new Map(),
        auth_asym_id_auth_seq_id: new Map(),
        chain_index_auth_seq_id: new Map(),
        label_asym_id: new Map(),
    };
}
var _tempResidueKey = _atomic_hierarchy__WEBPACK_IMPORTED_MODULE_1__["AtomicIndex"].EmptyResidueKey();
var Index = /** @class */ (function () {
    function Index(map) {
        this.map = map;
        this.entityIndex = map.entities.getEntityIndex;
        this.residueOffsets = this.map.segments.residueAtomSegments.offsets;
    }
    Index.prototype.getEntityFromChain = function (cI) {
        return this.map.chain_index_entity_index[cI];
    };
    Index.prototype.findEntity = function (label_asym_id) {
        var entityIndex = this.map.label_asym_id.get(label_asym_id);
        return entityIndex !== undefined ? entityIndex : -1;
    };
    Index.prototype.findChainLabel = function (key) {
        var eI = this.entityIndex(key.label_entity_id);
        if (eI < 0 || !this.map.entity_index_label_asym_id.has(eI))
            return -1;
        var cm = this.map.entity_index_label_asym_id.get(eI);
        if (!cm)
            return -1;
        return cm.has(key.label_asym_id) ? cm.get(key.label_asym_id) : -1;
    };
    Index.prototype.findChainAuth = function (key) {
        if (!this.map.auth_asym_id_auth_seq_id.has(key.auth_asym_id))
            return -1;
        var rm = this.map.auth_asym_id_auth_seq_id.get(key.auth_asym_id);
        return rm.has(key.auth_seq_id) ? rm.get(key.auth_seq_id) : -1;
    };
    Index.prototype.findResidue = function (label_entity_id_or_key, label_asym_id, auth_seq_id, pdbx_PDB_ins_code) {
        var key;
        if (arguments.length === 1) {
            key = label_entity_id_or_key;
        }
        else {
            _tempResidueKey.label_entity_id = label_entity_id_or_key;
            _tempResidueKey.label_asym_id = label_asym_id;
            _tempResidueKey.auth_seq_id = auth_seq_id;
            _tempResidueKey.pdbx_PDB_ins_code = pdbx_PDB_ins_code;
            key = _tempResidueKey;
        }
        var cI = this.findChainLabel(key);
        if (cI < 0)
            return -1;
        var rm = this.map.chain_index_auth_seq_id.get(cI);
        var id = getResidueId(key.auth_seq_id, key.pdbx_PDB_ins_code || '');
        return rm.has(id) ? rm.get(id) : -1;
    };
    Index.prototype.findResidueAuth = function (key) {
        var cI = this.findChainAuth(key);
        if (cI < 0)
            return -1;
        var rm = this.map.chain_index_auth_seq_id.get(cI);
        var id = getResidueId(key.auth_seq_id, key.pdbx_PDB_ins_code || '');
        return rm.has(id) ? rm.get(id) : -1;
    };
    Index.prototype.findResidueInsertion = function (key) {
        var cI = this.findChainLabel(key);
        if (cI < 0)
            return -1;
        var rm = this.map.chain_index_label_seq_id.get(cI);
        var id = getResidueId(key.label_seq_id, key.pdbx_PDB_ins_code || '');
        if (rm.has(id))
            return rm.get(id);
        var idx = _mol_data_int__WEBPACK_IMPORTED_MODULE_0__["SortedArray"].findPredecessorIndex(this.map.label_seq_id, key.label_seq_id);
        var start = _atomic_hierarchy__WEBPACK_IMPORTED_MODULE_1__["AtomicHierarchy"].chainStartResidueIndex(this.map.segments, cI);
        if (idx < start)
            return start;
        var end = _atomic_hierarchy__WEBPACK_IMPORTED_MODULE_1__["AtomicHierarchy"].chainEndResidueIndexExcl(this.map.segments, cI) - 1;
        if (idx >= end)
            return end;
        return idx;
    };
    Index.prototype.findAtom = function (key) {
        var rI = this.findResidue(key);
        if (rI < 0)
            return -1;
        if (typeof key.label_alt_id === 'undefined') {
            return findAtomByName(this.residueOffsets[rI], this.residueOffsets[rI + 1], this.map.label_atom_id, key.label_atom_id);
        }
        return findAtomByNameAndAltLoc(this.residueOffsets[rI], this.residueOffsets[rI + 1], this.map.label_atom_id, this.map.label_alt_id, key.label_atom_id, key.label_alt_id);
    };
    Index.prototype.findAtomAuth = function (key) {
        var rI = this.findResidueAuth(key);
        if (rI < 0)
            return -1;
        if (typeof key.label_alt_id === 'undefined') {
            return findAtomByName(this.residueOffsets[rI], this.residueOffsets[rI + 1], this.map.auth_atom_id, key.auth_atom_id);
        }
        return findAtomByNameAndAltLoc(this.residueOffsets[rI], this.residueOffsets[rI + 1], this.map.auth_atom_id, this.map.label_alt_id, key.auth_atom_id, key.label_alt_id);
    };
    Index.prototype.findAtomOnResidue = function (rI, label_atom_id, label_alt_id) {
        if (typeof label_alt_id === 'undefined') {
            return findAtomByName(this.residueOffsets[rI], this.residueOffsets[rI + 1], this.map.label_atom_id, label_atom_id);
        }
        return findAtomByNameAndAltLoc(this.residueOffsets[rI], this.residueOffsets[rI + 1], this.map.label_atom_id, this.map.label_alt_id, label_atom_id, label_alt_id);
    };
    Index.prototype.findAtomsOnResidue = function (rI, label_atom_ids) {
        return findAtomByNames(this.residueOffsets[rI], this.residueOffsets[rI + 1], this.map.label_atom_id, label_atom_ids);
    };
    return Index;
}());
function findAtomByName(start, end, data, atomName) {
    for (var i = start; i < end; i++) {
        if (data.value(i) === atomName)
            return i;
    }
    return -1;
}
function findAtomByNames(start, end, data, atomNames) {
    for (var i = start; i < end; i++) {
        if (atomNames.has(data.value(i)))
            return i;
    }
    return -1;
}
function findAtomByNameAndAltLoc(start, end, nameData, altLocData, atomName, altLoc) {
    for (var i = start; i < end; i++) {
        if (nameData.value(i) === atomName && altLocData.value(i) === altLoc)
            return i;
    }
    return -1;
}
function getAtomicIndex(data, entities, segments) {
    var map = createMapping(entities, data, segments);
    var _a = data.residues, label_seq_id = _a.label_seq_id, auth_seq_id = _a.auth_seq_id, pdbx_PDB_ins_code = _a.pdbx_PDB_ins_code;
    var _b = data.chains, label_entity_id = _b.label_entity_id, label_asym_id = _b.label_asym_id, auth_asym_id = _b.auth_asym_id;
    var atomSet = _mol_data_int__WEBPACK_IMPORTED_MODULE_0__["Interval"].ofBounds(0, data.atoms._rowCount);
    var chainsIt = _mol_data_int__WEBPACK_IMPORTED_MODULE_0__["Segmentation"].transientSegments(segments.chainAtomSegments, atomSet);
    while (chainsIt.hasNext) {
        var chainSegment = chainsIt.move();
        var chainIndex = chainSegment.index;
        var entityIndex = entities.getEntityIndex(label_entity_id.value(chainIndex));
        if (entityIndex < 0)
            missingEntity(label_entity_id.value(chainIndex));
        map.chain_index_entity_index[chainIndex] = entityIndex;
        var authAsymId = auth_asym_id.value(chainIndex);
        var auth_asym_id_auth_seq_id = map.auth_asym_id_auth_seq_id.get(authAsymId);
        if (!auth_asym_id_auth_seq_id) {
            auth_asym_id_auth_seq_id = new Map();
            map.auth_asym_id_auth_seq_id.set(authAsymId, auth_asym_id_auth_seq_id);
        }
        var labelAsymId = label_asym_id.value(chainIndex);
        if (!map.label_asym_id.has(labelAsymId))
            map.label_asym_id.set(labelAsymId, entityIndex);
        updateMapMapIndex(map.entity_index_label_asym_id, entityIndex, labelAsymId, chainIndex);
        var chain_index_label_seq_id = new Map();
        var chain_index_auth_seq_id = new Map();
        map.chain_index_label_seq_id.set(chainIndex, chain_index_label_seq_id);
        map.chain_index_auth_seq_id.set(chainIndex, chain_index_auth_seq_id);
        var residuesIt = _mol_data_int__WEBPACK_IMPORTED_MODULE_0__["Segmentation"].transientSegments(segments.residueAtomSegments, atomSet, chainSegment);
        while (residuesIt.hasNext) {
            var residueSegment = residuesIt.move();
            var rI = residueSegment.index;
            var authSeqId = auth_seq_id.value(rI);
            var insCode = pdbx_PDB_ins_code.value(rI);
            chain_index_label_seq_id.set(getResidueId(label_seq_id.value(rI), insCode), rI);
            chain_index_auth_seq_id.set(getResidueId(authSeqId, insCode), rI);
            auth_asym_id_auth_seq_id.set(authSeqId, chainIndex);
        }
    }
    return new Index(map);
}
//# sourceMappingURL=atomic-index.js.map

/***/ }),

/***/ "./lib/mol-model/structure/model/properties/utils/atomic-ranges.js":
/*!*************************************************************************!*\
  !*** ./lib/mol-model/structure/model/properties/utils/atomic-ranges.js ***!
  \*************************************************************************/
/*! exports provided: getAtomicRanges */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getAtomicRanges", function() { return getAtomicRanges; });
/* harmony import */ var _mol_data_int__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../../../../mol-data/int */ "./lib/mol-data/int.js");
/* harmony import */ var _mol_data_int_sorted_ranges__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../../../../mol-data/int/sorted-ranges */ "./lib/mol-data/int/sorted-ranges.js");
/* harmony import */ var _types__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../types */ "./lib/mol-model/structure/model/types.js");
/* harmony import */ var _util__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../../util */ "./lib/mol-model/structure/util.js");
/* harmony import */ var _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../../../../mol-math/linear-algebra */ "./lib/mol-math/linear-algebra.js");
/**
 * Copyright (c) 2018-2019 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */





function areBackboneConnected(riStart, riEnd, conformation, index, derived) {
    var _a = derived.residue, polymerType = _a.polymerType, traceElementIndex = _a.traceElementIndex, directionFromElementIndex = _a.directionFromElementIndex, directionToElementIndex = _a.directionToElementIndex;
    var ptStart = polymerType[riStart];
    var ptEnd = polymerType[riEnd];
    if (ptStart === 0 /* NA */ || ptEnd === 0 /* NA */)
        return false;
    if (traceElementIndex[riStart] === -1 || traceElementIndex[riEnd] === -1)
        return false;
    var eiStart = index.findAtomsOnResidue(riStart, Object(_util__WEBPACK_IMPORTED_MODULE_3__["getAtomIdForAtomRole"])(ptStart, 'backboneStart'));
    var eiEnd = index.findAtomsOnResidue(riEnd, Object(_util__WEBPACK_IMPORTED_MODULE_3__["getAtomIdForAtomRole"])(ptEnd, 'backboneEnd'));
    if (eiStart === -1 || eiEnd === -1) {
        eiStart = index.findAtomsOnResidue(riStart, Object(_util__WEBPACK_IMPORTED_MODULE_3__["getAtomIdForAtomRole"])(ptStart, 'coarseBackbone'));
        eiEnd = index.findAtomsOnResidue(riEnd, Object(_util__WEBPACK_IMPORTED_MODULE_3__["getAtomIdForAtomRole"])(ptEnd, 'coarseBackbone'));
    }
    var x = conformation.x, y = conformation.y, z = conformation.z;
    var pStart = _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_4__["Vec3"].create(x[eiStart], y[eiStart], z[eiStart]);
    var pEnd = _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_4__["Vec3"].create(x[eiEnd], y[eiEnd], z[eiEnd]);
    var isCoarse = directionFromElementIndex[riStart] === -1 || directionToElementIndex[riStart] === -1 || directionFromElementIndex[riEnd] === -1 || directionToElementIndex[riEnd] === -1;
    return _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_4__["Vec3"].distance(pStart, pEnd) < (isCoarse ? 10 : 3);
}
function getAtomicRanges(hierarchy, entities, conformation, sequence) {
    var polymerRanges = [];
    var gapRanges = [];
    var cyclicPolymerMap = new Map();
    var chainIt = _mol_data_int__WEBPACK_IMPORTED_MODULE_0__["Segmentation"].transientSegments(hierarchy.chainAtomSegments, _mol_data_int__WEBPACK_IMPORTED_MODULE_0__["Interval"].ofBounds(0, hierarchy.atoms._rowCount));
    var residueIt = _mol_data_int__WEBPACK_IMPORTED_MODULE_0__["Segmentation"].transientSegments(hierarchy.residueAtomSegments, _mol_data_int__WEBPACK_IMPORTED_MODULE_0__["Interval"].ofBounds(0, hierarchy.atoms._rowCount));
    var index = hierarchy.index, derived = hierarchy.derived;
    var label_seq_id = hierarchy.residues.label_seq_id;
    var label_entity_id = hierarchy.chains.label_entity_id;
    var _a = derived.residue, moleculeType = _a.moleculeType, traceElementIndex = _a.traceElementIndex;
    var prevSeqId;
    var prevStart;
    var prevEnd;
    var startIndex;
    while (chainIt.hasNext) {
        var chainSegment = chainIt.move();
        residueIt.setSegment(chainSegment);
        prevSeqId = -1;
        prevStart = -1;
        prevEnd = -1;
        startIndex = -1;
        var eI = entities.getEntityIndex(label_entity_id.value(chainSegment.index));
        var seq = sequence.byEntityKey[eI];
        var maxSeqId = seq ? seq.sequence.seqId.value(seq.sequence.seqId.rowCount - 1) : -1;
        // check cyclic peptides, seqIds and distance must be compatible
        var riStart = hierarchy.residueAtomSegments.index[chainSegment.start];
        var riEnd = hierarchy.residueAtomSegments.index[chainSegment.end - 1];
        var seqIdStart = label_seq_id.value(riStart);
        var seqIdEnd = label_seq_id.value(riEnd);
        if (seqIdStart === 1 && seqIdEnd === maxSeqId && conformation.xyzDefined && areBackboneConnected(riStart, riEnd, conformation, index, derived)) {
            cyclicPolymerMap.set(riStart, riEnd);
            cyclicPolymerMap.set(riEnd, riStart);
        }
        while (residueIt.hasNext) {
            var residueSegment = residueIt.move();
            var residueIndex = residueSegment.index;
            var seqId = label_seq_id.value(residueIndex);
            // treat polymers residues that don't have a trace element resolved as gaps
            if (Object(_types__WEBPACK_IMPORTED_MODULE_2__["isPolymer"])(moleculeType[residueIndex]) && traceElementIndex[residueIndex] !== -1) {
                if (startIndex !== -1) {
                    if (seqId !== prevSeqId + 1) {
                        polymerRanges.push(startIndex, prevEnd - 1);
                        gapRanges.push(prevStart, residueSegment.end - 1);
                        startIndex = residueSegment.start;
                    }
                    else if (!residueIt.hasNext) {
                        polymerRanges.push(startIndex, residueSegment.end - 1);
                        // TODO store terminal gaps
                    }
                    else {
                        var riStart_1 = hierarchy.residueAtomSegments.index[residueSegment.start];
                        var riEnd_1 = hierarchy.residueAtomSegments.index[prevEnd - 1];
                        if (conformation.xyzDefined && !areBackboneConnected(riStart_1, riEnd_1, conformation, hierarchy.index, derived)) {
                            polymerRanges.push(startIndex, prevEnd - 1);
                            // add gap even for consecutive residues if they are not connected
                            gapRanges.push(prevStart, residueSegment.end - 1);
                            startIndex = residueSegment.start;
                        }
                    }
                }
                else {
                    startIndex = residueSegment.start; // start polymer
                    // TODO store terminal gaps
                }
            }
            else {
                if (startIndex !== -1) {
                    polymerRanges.push(startIndex, prevEnd - 1);
                    startIndex = -1;
                }
            }
            prevStart = residueSegment.start;
            prevEnd = residueSegment.end;
            prevSeqId = seqId;
        }
    }
    return {
        polymerRanges: _mol_data_int_sorted_ranges__WEBPACK_IMPORTED_MODULE_1__["default"].ofSortedRanges(polymerRanges),
        gapRanges: _mol_data_int_sorted_ranges__WEBPACK_IMPORTED_MODULE_1__["default"].ofSortedRanges(gapRanges),
        cyclicPolymerMap: cyclicPolymerMap
    };
}
//# sourceMappingURL=atomic-ranges.js.map

/***/ }),

/***/ "./lib/mol-model/structure/model/properties/utils/coarse-keys.js":
/*!***********************************************************************!*\
  !*** ./lib/mol-model/structure/model/properties/utils/coarse-keys.js ***!
  \***********************************************************************/
/*! exports provided: getCoarseKeys */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getCoarseKeys", function() { return getCoarseKeys; });
/* harmony import */ var _mol_data_int_sorted_ranges__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../../../../mol-data/int/sorted-ranges */ "./lib/mol-data/int/sorted-ranges.js");
/* harmony import */ var _mol_data_int__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../../../../mol-data/int */ "./lib/mol-data/int.js");
/**
 * Copyright (c) 2017-2018 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author David Sehnal <david.sehnal@gmail.com>
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */


function getElementKey(map, key, counter) {
    if (map.has(key))
        return map.get(key);
    var ret = counter.index++;
    map.set(key, ret);
    return ret;
}
function getElementSubstructureKeyMap(map, key) {
    if (map.has(key))
        return map.get(key);
    var ret = new Map();
    map.set(key, ret);
    return ret;
}
function createLookUp(entities, chain, seq) {
    var getEntKey = entities.getEntityIndex;
    var findChainKey = function (e, c) {
        var eKey = getEntKey(e);
        if (eKey < 0)
            return -1;
        var cm = chain.get(eKey);
        if (!cm.has(c))
            return -1;
        return cm.get(c);
    };
    var findSequenceKey = function (e, c, s) {
        var eKey = getEntKey(e);
        if (eKey < 0)
            return -1;
        var cm = chain.get(eKey);
        if (cm === undefined)
            return -1;
        var cKey = cm.get(c);
        if (cKey === undefined)
            return -1;
        var sm = seq.get(cKey);
        var elementIndices = sm.elementIndices, seqRanges = sm.seqRanges;
        var idx = _mol_data_int_sorted_ranges__WEBPACK_IMPORTED_MODULE_0__["default"].firstIntersectionIndex(seqRanges, _mol_data_int__WEBPACK_IMPORTED_MODULE_1__["OrderedSet"].ofSingleton(s));
        return (idx !== -1 ? elementIndices[idx] : -1);
    };
    return { findChainKey: findChainKey, findSequenceKey: findSequenceKey };
}
function missingEntity(k) {
    throw new Error("Missing entity entry for entity id '" + k + "'.");
}
function getCoarseKeys(data, entities) {
    var entity_id = data.entity_id, asym_id = data.asym_id, seq_id_begin = data.seq_id_begin, seq_id_end = data.seq_id_end, count = data.count, chainElementSegments = data.chainElementSegments;
    var seqMaps = new Map();
    var chainMaps = new Map(), chainCounter = { index: 0 };
    var chainKey = new Int32Array(count);
    var entityKey = new Int32Array(count);
    var chainToEntity = new Int32Array(chainElementSegments.count);
    for (var i = 0; i < count; i++) {
        entityKey[i] = entities.getEntityIndex(entity_id.value(i));
        if (entityKey[i] < 0)
            missingEntity(entity_id.value(i));
    }
    for (var cI = 0; cI < chainElementSegments.count; cI++) {
        var start = chainElementSegments.offsets[cI];
        var end = chainElementSegments.offsets[cI + 1];
        var eK = entityKey[start];
        chainToEntity[cI] = eK;
        var map = getElementSubstructureKeyMap(chainMaps, eK);
        var key = getElementKey(map, asym_id.value(start), chainCounter);
        for (var i = start; i < end; i++)
            chainKey[i] = key;
        // create seq_id map for the ranges defined by seq_id_begin and seq_id_end
        var elementIndices = [];
        var seqRanges = [];
        for (var i = start; i < end; i++) {
            var seqStart = seq_id_begin.value(i);
            var seqEnd = seq_id_end.value(i);
            elementIndices.push(i);
            seqRanges.push(seqStart, seqEnd);
        }
        var seqMap = { elementIndices: elementIndices, seqRanges: _mol_data_int_sorted_ranges__WEBPACK_IMPORTED_MODULE_0__["default"].ofSortedRanges(seqRanges) };
        seqMaps.set(key, seqMap);
    }
    var _a = createLookUp(entities, chainMaps, seqMaps), findChainKey = _a.findChainKey, findSequenceKey = _a.findSequenceKey;
    var getEntityFromChain = function (c) {
        return chainToEntity[c];
    };
    return { chainKey: chainKey, entityKey: entityKey, findSequenceKey: findSequenceKey, findChainKey: findChainKey, getEntityFromChain: getEntityFromChain };
}
//# sourceMappingURL=coarse-keys.js.map

/***/ }),

/***/ "./lib/mol-model/structure/model/properties/utils/coarse-ranges.js":
/*!*************************************************************************!*\
  !*** ./lib/mol-model/structure/model/properties/utils/coarse-ranges.js ***!
  \*************************************************************************/
/*! exports provided: getCoarseRanges */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getCoarseRanges", function() { return getCoarseRanges; });
/* harmony import */ var _mol_data_int__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../../../../mol-data/int */ "./lib/mol-data/int.js");
/* harmony import */ var _mol_data_int_sorted_ranges__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../../../../mol-data/int/sorted-ranges */ "./lib/mol-data/int/sorted-ranges.js");
/**
 * Copyright (c) 2018 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */


// TODO assumes all coarse elements are part of a polymer
// TODO add gaps at the ends of the chains by comparing to the polymer sequence data
function getCoarseRanges(data, chemicalComponentMap) {
    var polymerRanges = [];
    var gapRanges = [];
    var chainIt = _mol_data_int__WEBPACK_IMPORTED_MODULE_0__["Segmentation"].transientSegments(data.chainElementSegments, _mol_data_int__WEBPACK_IMPORTED_MODULE_0__["Interval"].ofBounds(0, data.count));
    var seq_id_begin = data.seq_id_begin, seq_id_end = data.seq_id_end;
    while (chainIt.hasNext) {
        var _a = chainIt.move(), start = _a.start, end = _a.end;
        var startIndex = -1;
        var prevSeqEnd = -1;
        for (var i = start; i < end; ++i) {
            var seqEnd = seq_id_end.value(i);
            if (i === start) {
                startIndex = i;
                prevSeqEnd = seq_id_end.value(i);
            }
            else {
                if (seq_id_begin.value(i) - prevSeqEnd > 1) {
                    polymerRanges.push(startIndex, i - 1);
                    gapRanges.push(i - 1, i);
                    startIndex = i;
                }
            }
            if (i === end - 1) {
                polymerRanges.push(startIndex, i);
            }
            prevSeqEnd = seqEnd;
        }
    }
    return {
        polymerRanges: _mol_data_int_sorted_ranges__WEBPACK_IMPORTED_MODULE_1__["default"].ofSortedRanges(polymerRanges),
        gapRanges: _mol_data_int_sorted_ranges__WEBPACK_IMPORTED_MODULE_1__["default"].ofSortedRanges(gapRanges)
    };
}
//# sourceMappingURL=coarse-ranges.js.map

/***/ }),

/***/ "./lib/mol-model/structure/model/types.js":
/*!************************************************!*\
  !*** ./lib/mol-model/structure/model/types.js ***!
  \************************************************/
/*! exports provided: ElementSymbol, getElementFromAtomicNumber, PolymerTypeAtomRoleId, ProteinBackboneAtoms, NucleicBackboneAtoms, DProteinComponentTypeNames, LProteinComponentTypeNames, GammaProteinComponentTypeNames, BetaProteinComponentTypeNames, ProteinTerminusComponentTypeNames, OtherProteinComponentTypeNames, ProteinComponentTypeNames, DNAComponentTypeNames, RNAComponentTypeNames, SaccharideComponentTypeNames, OtherComponentTypeNames, IonComponentTypeNames, LipidComponentTypeNames, WaterNames, AminoAcidNamesL, AminoAcidNamesD, AminoAcidNames, RnaBaseNames, DnaBaseNames, PeptideBaseNames, PurineBaseNames, PyrimidineBaseNames, BaseNames, isPurineBase, isPyrimidineBase, PolymerNames, getMoleculeType, getPolymerType, getComponentType, getDefaultChemicalComponent, getEntityType, getEntitySubtype, isPolymer, isNucleic, isProtein, SecondaryStructureType, MaxAsa, DefaultMaxAsa, BondType, ResidueHydrophobicity, DefaultResidueHydrophobicity */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ElementSymbol", function() { return ElementSymbol; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getElementFromAtomicNumber", function() { return getElementFromAtomicNumber; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "PolymerTypeAtomRoleId", function() { return PolymerTypeAtomRoleId; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ProteinBackboneAtoms", function() { return ProteinBackboneAtoms; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "NucleicBackboneAtoms", function() { return NucleicBackboneAtoms; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DProteinComponentTypeNames", function() { return DProteinComponentTypeNames; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "LProteinComponentTypeNames", function() { return LProteinComponentTypeNames; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "GammaProteinComponentTypeNames", function() { return GammaProteinComponentTypeNames; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "BetaProteinComponentTypeNames", function() { return BetaProteinComponentTypeNames; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ProteinTerminusComponentTypeNames", function() { return ProteinTerminusComponentTypeNames; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "OtherProteinComponentTypeNames", function() { return OtherProteinComponentTypeNames; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ProteinComponentTypeNames", function() { return ProteinComponentTypeNames; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DNAComponentTypeNames", function() { return DNAComponentTypeNames; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "RNAComponentTypeNames", function() { return RNAComponentTypeNames; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SaccharideComponentTypeNames", function() { return SaccharideComponentTypeNames; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "OtherComponentTypeNames", function() { return OtherComponentTypeNames; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "IonComponentTypeNames", function() { return IonComponentTypeNames; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "LipidComponentTypeNames", function() { return LipidComponentTypeNames; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "WaterNames", function() { return WaterNames; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "AminoAcidNamesL", function() { return AminoAcidNamesL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "AminoAcidNamesD", function() { return AminoAcidNamesD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "AminoAcidNames", function() { return AminoAcidNames; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "RnaBaseNames", function() { return RnaBaseNames; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DnaBaseNames", function() { return DnaBaseNames; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "PeptideBaseNames", function() { return PeptideBaseNames; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "PurineBaseNames", function() { return PurineBaseNames; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "PyrimidineBaseNames", function() { return PyrimidineBaseNames; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "BaseNames", function() { return BaseNames; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isPurineBase", function() { return isPurineBase; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isPyrimidineBase", function() { return isPyrimidineBase; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "PolymerNames", function() { return PolymerNames; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getMoleculeType", function() { return getMoleculeType; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getPolymerType", function() { return getPolymerType; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getComponentType", function() { return getComponentType; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getDefaultChemicalComponent", function() { return getDefaultChemicalComponent; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getEntityType", function() { return getEntityType; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getEntitySubtype", function() { return getEntitySubtype; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isPolymer", function() { return isPolymer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isNucleic", function() { return isNucleic; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isProtein", function() { return isProtein; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SecondaryStructureType", function() { return SecondaryStructureType; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MaxAsa", function() { return MaxAsa; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DefaultMaxAsa", function() { return DefaultMaxAsa; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "BondType", function() { return BondType; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ResidueHydrophobicity", function() { return ResidueHydrophobicity; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DefaultResidueHydrophobicity", function() { return DefaultResidueHydrophobicity; });
/* harmony import */ var _mol_util_bit_flags__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../../mol-util/bit-flags */ "./lib/mol-util/bit-flags.js");
/* harmony import */ var _structure_carbohydrates_constants__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../structure/carbohydrates/constants */ "./lib/mol-model/structure/structure/carbohydrates/constants.js");
/* harmony import */ var _mol_util_set__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../../mol-util/set */ "./lib/mol-util/set.js");
/* harmony import */ var _types_lipids__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./types/lipids */ "./lib/mol-model/structure/model/types/lipids.js");
/* harmony import */ var _types_ions__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./types/ions */ "./lib/mol-model/structure/model/types/ions.js");
/**
 * Copyright (c) 2017-2021 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 * @author David Sehnal <david.sehnal@gmail.com>
 */
var _a;





var _esCache = (function () {
    var cache = Object.create(null);
    var letters = [];
    for (var i = 'A'.charCodeAt(0); i <= 'Z'.charCodeAt(0); i++)
        letters[letters.length] = String.fromCharCode(i);
    for (var i = 'a'.charCodeAt(0); i <= 'z'.charCodeAt(0); i++)
        letters[letters.length] = String.fromCharCode(i);
    for (var i = '0'.charCodeAt(0); i <= '9'.charCodeAt(0); i++)
        letters[letters.length] = String.fromCharCode(i);
    for (var _i = 0, letters_1 = letters; _i < letters_1.length; _i++) {
        var k = letters_1[_i];
        cache[k] = k.toUpperCase();
        for (var _a = 0, letters_2 = letters; _a < letters_2.length; _a++) {
            var l = letters_2[_a];
            cache[k + l] = (k + l).toUpperCase();
            for (var _b = 0, letters_3 = letters; _b < letters_3.length; _b++) {
                var m = letters_3[_b];
                cache[k + l + m] = (k + l + m).toUpperCase();
            }
        }
    }
    return cache;
}());
function ElementSymbol(s) {
    return _esCache[s] || s.toUpperCase();
}
var _elementByAtomicNumber = new Map([[1, 'H'], [2, 'He'], [3, 'Li'], [4, 'Be'], [5, 'B'], [6, 'C'], [7, 'N'], [8, 'O'], [9, 'F'], [10, 'Ne'], [11, 'Na'], [12, 'Mg'], [13, 'Al'], [14, 'Si'], [15, 'P'], [16, 'S'], [17, 'Cl'], [18, 'Ar'], [19, 'K'], [20, 'Ca'], [21, 'Sc'], [22, 'Ti'], [23, 'V'], [24, 'Cr'], [25, 'Mn'], [26, 'Fe'], [27, 'Co'], [28, 'Ni'], [29, 'Cu'], [30, 'Zn'], [31, 'Ga'], [32, 'Ge'], [33, 'As'], [34, 'Se'], [35, 'Br'], [36, 'Kr'], [37, 'Rb'], [38, 'Sr'], [39, 'Y'], [40, 'Zr'], [41, 'Nb'], [42, 'Mo'], [43, 'Tc'], [44, 'Ru'], [45, 'Rh'], [46, 'Pd'], [47, 'Ag'], [48, 'Cd'], [49, 'In'], [50, 'Sn'], [51, 'Sb'], [52, 'Te'], [53, 'I'], [54, 'Xe'], [55, 'Cs'], [56, 'Ba'], [57, 'La'], [58, 'Ce'], [59, 'Pr'], [60, 'Nd'], [61, 'Pm'], [62, 'Sm'], [63, 'Eu'], [64, 'Gd'], [65, 'Tb'], [66, 'Dy'], [67, 'Ho'], [68, 'Er'], [69, 'Tm'], [70, 'Yb'], [71, 'Lu'], [72, 'Hf'], [73, 'Ta'], [74, 'W'], [75, 'Re'], [76, 'Os'], [77, 'Ir'], [78, 'Pt'], [79, 'Au'], [80, 'Hg'], [81, 'Tl'], [82, 'Pb'], [83, 'Bi'], [84, 'Po'], [85, 'At'], [86, 'Rn'], [87, 'Fr'], [88, 'Ra'], [89, 'Ac'], [90, 'Th'], [91, 'Pa'], [92, 'U'], [93, 'Np'], [94, 'Pu'], [95, 'Am'], [96, 'Cm'], [97, 'Bk'], [98, 'Cf'], [99, 'Es'], [100, 'Fm'], [101, 'Md'], [102, 'No'], [103, 'Lr'], [104, 'Rf'], [105, 'Db'], [106, 'Sg'], [107, 'Bh'], [108, 'Hs'], [109, 'Mt'], [110, 'Ds'], [111, 'Rg'], [112, 'Cn'], [113, 'Uut'], [114, 'Fl'], [115, 'Uup'], [116, 'Lv'], [117, 'Uus'], [118, 'Uuo']]
    .map(function (e) { return [e[0], ElementSymbol(e[1])]; }));
function getElementFromAtomicNumber(n) {
    if (_elementByAtomicNumber.has(n))
        return _elementByAtomicNumber.get(n);
    return ElementSymbol('H');
}
var PolymerTypeAtomRoleId = (_a = {},
    _a[0 /* NA */] = {
        trace: new Set(),
        directionFrom: new Set(),
        directionTo: new Set(),
        backboneStart: new Set(),
        backboneEnd: new Set(),
        coarseBackbone: new Set()
    },
    _a[1 /* Protein */] = {
        trace: new Set(['CA']),
        directionFrom: new Set(['C']),
        directionTo: new Set(['O', 'OC1', 'O1', 'OX1', 'OXT']),
        backboneStart: new Set(['N']),
        backboneEnd: new Set(['C']),
        // CA1 is used e.g. in GFP chromophores
        // BB is often used for coarse grained models
        coarseBackbone: new Set(['CA', 'BB', 'CA1'])
    },
    _a[2 /* GammaProtein */] = {
        trace: new Set(['CA']),
        directionFrom: new Set(['C']),
        directionTo: new Set(['O']),
        backboneStart: new Set(['N']),
        backboneEnd: new Set(['CD']),
        coarseBackbone: new Set(['CA'])
    },
    _a[3 /* BetaProtein */] = {
        trace: new Set(['CA']),
        directionFrom: new Set(['C']),
        directionTo: new Set(['O']),
        backboneStart: new Set(['N']),
        backboneEnd: new Set(['CG']),
        coarseBackbone: new Set(['CA'])
    },
    _a[4 /* RNA */] = {
        trace: new Set(['O3\'', 'O3*']),
        directionFrom: new Set(['C4\'', 'C4*']),
        directionTo: new Set(['C3\'', 'C3*']),
        backboneStart: new Set(['P']),
        backboneEnd: new Set(['O3\'', 'O3*']),
        coarseBackbone: new Set(['P'])
    },
    _a[5 /* DNA */] = {
        trace: new Set(['O3\'', 'O3*']),
        directionFrom: new Set(['C3\'', 'C3*']),
        directionTo: new Set(['C1\'', 'C1*']),
        backboneStart: new Set(['P']),
        backboneEnd: new Set(['O3\'', 'O3*']),
        coarseBackbone: new Set(['P'])
    },
    _a[6 /* PNA */] = {
        trace: new Set(['N4\'', 'N4*']),
        directionFrom: new Set(['N4\'', 'N4*']),
        directionTo: new Set(['C7\'', 'C7*']),
        backboneStart: new Set(['N1\'', 'N1*']),
        backboneEnd: new Set(['C\'', 'C*']),
        coarseBackbone: new Set(['P'])
    },
    _a);
var ProteinBackboneAtoms = new Set([
    'CA', 'C', 'N', 'O',
    'O1', 'O2', 'OC1', 'OC2', 'OT1', 'OT2', 'OX1', 'OXT',
    'H', 'H1', 'H2', 'H3', 'HA', 'HN', 'HXT',
    'BB'
]);
var NucleicBackboneAtoms = new Set([
    'P', 'OP1', 'OP2', 'HOP2', 'HOP3',
    'O2\'', 'O3\'', 'O4\'', 'O5\'', 'C1\'', 'C2\'', 'C3\'', 'C4\'', 'C5\'',
    'H1\'', 'H2\'', 'H2\'\'', 'HO2\'', 'H3\'', 'H4\'', 'H5\'', 'H5\'\'', 'HO3\'', 'HO5\'',
    'O2*', 'O3*', 'O4*', 'O5*', 'C1*', 'C2*', 'C3*', 'C4*', 'C5*'
]);
/** Chemical component type names for D-linked protein */
var DProteinComponentTypeNames = new Set([
    'D-PEPTIDE LINKING', 'D-PEPTIDE NH3 AMINO TERMINUS',
    'D-PEPTIDE COOH CARBOXY TERMINUS', 'D-GAMMA-PEPTIDE, C-DELTA LINKING',
    'D-BETA-PEPTIDE, C-GAMMA LINKING'
]);
/** Chemical component type names for L-linked protein */
var LProteinComponentTypeNames = new Set([
    'L-PEPTIDE LINKING', 'L-PEPTIDE NH3 AMINO TERMINUS',
    'L-PEPTIDE COOH CARBOXY TERMINUS', 'L-GAMMA-PEPTIDE, C-DELTA LINKING',
    'L-BETA-PEPTIDE, C-GAMMA LINKING'
]);
/** Chemical component type names for gamma protein, overlaps with D/L-linked */
var GammaProteinComponentTypeNames = new Set([
    'D-GAMMA-PEPTIDE, C-DELTA LINKING', 'L-GAMMA-PEPTIDE, C-DELTA LINKING'
]);
/** Chemical component type names for beta protein, overlaps with D/L-linked */
var BetaProteinComponentTypeNames = new Set([
    'D-BETA-PEPTIDE, C-GAMMA LINKING', 'L-BETA-PEPTIDE, C-GAMMA LINKING'
]);
/** Chemical component type names for protein termini, overlaps with D/L-linked */
var ProteinTerminusComponentTypeNames = new Set([
    'D-PEPTIDE NH3 AMINO TERMINUS', 'D-PEPTIDE COOH CARBOXY TERMINUS',
    'L-PEPTIDE NH3 AMINO TERMINUS', 'L-PEPTIDE COOH CARBOXY TERMINUS'
]);
/** Chemical component type names for peptide-like protein */
var OtherProteinComponentTypeNames = new Set([
    'PEPTIDE LINKING', 'PEPTIDE-LIKE',
]);
/** Chemical component type names for protein */
var ProteinComponentTypeNames = _mol_util_set__WEBPACK_IMPORTED_MODULE_2__["SetUtils"].unionMany(DProteinComponentTypeNames, LProteinComponentTypeNames, OtherProteinComponentTypeNames);
/** Chemical component type names for DNA */
var DNAComponentTypeNames = new Set([
    'DNA LINKING', 'L-DNA LINKING', 'DNA OH 5 PRIME TERMINUS', 'DNA OH 3 PRIME TERMINUS',
]);
/** Chemical component type names for RNA */
var RNAComponentTypeNames = new Set([
    'RNA LINKING', 'L-RNA LINKING', 'RNA OH 5 PRIME TERMINUS', 'RNA OH 3 PRIME TERMINUS',
]);
/** Chemical component type names for saccharide */
var SaccharideComponentTypeNames = new Set([
    'D-SACCHARIDE, BETA LINKING', 'L-SACCHARIDE, BETA LINKING',
    'D-SACCHARIDE, ALPHA LINKING', 'L-SACCHARIDE, ALPHA LINKING',
    'L-SACCHARIDE', 'D-SACCHARIDE', 'SACCHARIDE',
    // the following four are marked to be deprecated in the mmCIF dictionary
    'D-SACCHARIDE 1,4 AND 1,4 LINKING', 'L-SACCHARIDE 1,4 AND 1,4 LINKING',
    'D-SACCHARIDE 1,4 AND 1,6 LINKING', 'L-SACCHARIDE 1,4 AND 1,6 LINKING',
]);
/** Chemical component type names for other */
var OtherComponentTypeNames = new Set([
    'NON-POLYMER', 'OTHER'
]);
/** Chemical component type names for ion (extension to mmcif) */
var IonComponentTypeNames = new Set([
    'ION'
]);
/** Chemical component type names for lipid (extension to mmcif) */
var LipidComponentTypeNames = new Set([
    'LIPID'
]);
/** Common names for water molecules */
var WaterNames = new Set([
    'SOL', 'WAT', 'HOH', 'H2O', 'W', 'DOD', 'D3O', 'TIP', 'TIP3', 'TIP4', 'SPC'
]);
var AminoAcidNamesL = new Set([
    'HIS', 'ARG', 'LYS', 'ILE', 'PHE', 'LEU', 'TRP', 'ALA', 'MET', 'PRO', 'CYS',
    'ASN', 'VAL', 'GLY', 'SER', 'GLN', 'TYR', 'ASP', 'GLU', 'THR', 'SEC', 'PYL',
    'UNK' // unknown amino acid from CCD
]);
var AminoAcidNamesD = new Set([
    'DAL',
    'DAR',
    'DSG',
    'DAS',
    'DCY',
    'DGL',
    'DGN',
    'DHI',
    'DIL',
    'DLE',
    'DLY',
    'MED',
    'DPN',
    'DPR',
    'DSN',
    'DTH',
    'DTR',
    'DTY',
    'DVA',
    'DNE' // D-NORLEUCINE
    // ???  // D-SELENOCYSTEINE
]);
var AminoAcidNames = _mol_util_set__WEBPACK_IMPORTED_MODULE_2__["SetUtils"].unionMany(AminoAcidNamesL, AminoAcidNamesD);
var RnaBaseNames = new Set([
    'A', 'C', 'T', 'G', 'I', 'U',
    'N' // unknown RNA base from CCD
]);
var DnaBaseNames = new Set([
    'DA', 'DC', 'DT', 'DG', 'DI', 'DU',
    'DN' // unknown DNA base from CCD
]);
var PeptideBaseNames = new Set(['APN', 'CPN', 'TPN', 'GPN']);
var PurineBaseNames = new Set(['A', 'G', 'I', 'DA', 'DG', 'DI', 'APN', 'GPN']);
var PyrimidineBaseNames = new Set(['C', 'T', 'U', 'DC', 'DT', 'DU', 'CPN', 'TPN']);
var BaseNames = _mol_util_set__WEBPACK_IMPORTED_MODULE_2__["SetUtils"].unionMany(RnaBaseNames, DnaBaseNames, PeptideBaseNames);
var isPurineBase = function (compId) { return PurineBaseNames.has(compId.toUpperCase()); };
var isPyrimidineBase = function (compId) { return PyrimidineBaseNames.has(compId.toUpperCase()); };
var PolymerNames = _mol_util_set__WEBPACK_IMPORTED_MODULE_2__["SetUtils"].unionMany(AminoAcidNames, BaseNames);
/** get the molecule type from component type and id */
function getMoleculeType(compType, compId) {
    compType = compType.toUpperCase();
    compId = compId.toUpperCase();
    if (PeptideBaseNames.has(compId)) {
        return 8 /* PNA */;
    }
    else if (ProteinComponentTypeNames.has(compType)) {
        return 5 /* Protein */;
    }
    else if (RNAComponentTypeNames.has(compType)) {
        return 6 /* RNA */;
    }
    else if (DNAComponentTypeNames.has(compType)) {
        return 7 /* DNA */;
    }
    else if (SaccharideComponentTypeNames.has(compType)) {
        return 9 /* Saccharide */;
    }
    else if (WaterNames.has(compId)) {
        return 2 /* Water */;
    }
    else if (_types_ions__WEBPACK_IMPORTED_MODULE_4__["IonNames"].has(compId)) {
        return 3 /* Ion */;
    }
    else if (_types_lipids__WEBPACK_IMPORTED_MODULE_3__["LipidNames"].has(compId)) {
        return 4 /* Lipid */;
    }
    else if (OtherComponentTypeNames.has(compType)) {
        if (_structure_carbohydrates_constants__WEBPACK_IMPORTED_MODULE_1__["SaccharideCompIdMap"].has(compId)) {
            // trust our saccharide table more than given 'non-polymer' or 'other' component type
            return 9 /* Saccharide */;
        }
        else {
            return 1 /* Other */;
        }
    }
    else {
        return 0 /* Unknown */;
    }
}
function getPolymerType(compType, molType) {
    compType = compType.toUpperCase();
    if (molType === 5 /* Protein */) {
        if (GammaProteinComponentTypeNames.has(compType)) {
            return 2 /* GammaProtein */;
        }
        else if (BetaProteinComponentTypeNames.has(compType)) {
            return 3 /* BetaProtein */;
        }
        else if (ProteinTerminusComponentTypeNames.has(compType)) {
            return 0 /* NA */;
        }
        else {
            return 1 /* Protein */;
        }
    }
    else if (molType === 6 /* RNA */) {
        return 4 /* RNA */;
    }
    else if (molType === 7 /* DNA */) {
        return 5 /* DNA */;
    }
    else if (molType === 8 /* PNA */) {
        return 6 /* PNA */;
    }
    else {
        return 0 /* NA */;
    }
}
function getComponentType(compId) {
    compId = compId.toUpperCase();
    if (AminoAcidNames.has(compId)) {
        return 'peptide linking';
    }
    else if (RnaBaseNames.has(compId)) {
        return 'RNA linking';
    }
    else if (DnaBaseNames.has(compId)) {
        return 'DNA linking';
    }
    else if (_structure_carbohydrates_constants__WEBPACK_IMPORTED_MODULE_1__["SaccharideCompIdMap"].has(compId)) {
        return 'saccharide';
    }
    else {
        return 'other';
    }
}
function getDefaultChemicalComponent(compId) {
    // TODO: this is to make the chem_comp_type property work if chem_comp category is not present.
    // should we try to set the formula etc better?
    return {
        formula: '',
        formula_weight: 0,
        id: compId,
        name: compId,
        mon_nstd_flag: PolymerNames.has(compId) ? 'y' : 'n',
        pdbx_synonyms: [],
        type: getComponentType(compId)
    };
}
function getEntityType(compId) {
    compId = compId.toUpperCase();
    if (WaterNames.has(compId)) {
        return 'water';
    }
    else if (PolymerNames.has(compId)) {
        return 'polymer';
    }
    else if (_structure_carbohydrates_constants__WEBPACK_IMPORTED_MODULE_1__["SaccharideCompIdMap"].has(compId)) {
        return 'branched';
    }
    else {
        return 'non-polymer';
    }
}
function getEntitySubtype(compId, compType) {
    compId = compId.toUpperCase();
    compType = compType.toUpperCase();
    if (LProteinComponentTypeNames.has(compType)) {
        return 'polypeptide(L)';
    }
    else if (DProteinComponentTypeNames.has(compType)) {
        return 'polypeptide(D)';
    }
    else if (RNAComponentTypeNames.has(compType)) {
        return 'polyribonucleotide';
    }
    else if (DNAComponentTypeNames.has(compType)) {
        return 'polydeoxyribonucleotide';
    }
    else if (SaccharideComponentTypeNames.has(compType)) {
        return 'oligosaccharide';
    }
    else if (_structure_carbohydrates_constants__WEBPACK_IMPORTED_MODULE_1__["SaccharideCompIdMap"].has(compId)) {
        return 'oligosaccharide';
    }
    else if (PeptideBaseNames.has(compId)) {
        return 'peptide nucleic acid';
    }
    else if (AminoAcidNamesL.has(compId)) {
        return 'polypeptide(L)';
    }
    else if (AminoAcidNamesD.has(compId)) {
        return 'polypeptide(D)';
    }
    else if (RnaBaseNames.has(compId)) {
        return 'polyribonucleotide';
    }
    else if (DnaBaseNames.has(compId)) {
        return 'polydeoxyribonucleotide';
    }
    else if (IonComponentTypeNames.has(compType) || _types_ions__WEBPACK_IMPORTED_MODULE_4__["IonNames"].has(compId)) {
        return 'ion';
    }
    else if (LipidComponentTypeNames.has(compType) || _types_lipids__WEBPACK_IMPORTED_MODULE_3__["LipidNames"].has(compId)) {
        return 'lipid';
    }
    else if (OtherProteinComponentTypeNames.has(compType)) {
        return 'peptide-like';
    }
    else {
        return 'other';
    }
}
function isPolymer(moleculeType) {
    return isNucleic(moleculeType) || isProtein(moleculeType);
}
function isNucleic(moleculeType) {
    return moleculeType === 7 /* DNA */ || moleculeType === 6 /* RNA */ || moleculeType === 8 /* PNA */;
}
function isProtein(moleculeType) {
    return moleculeType === 5 /* Protein */;
}
var SecondaryStructureType;
(function (SecondaryStructureType) {
    SecondaryStructureType.is = _mol_util_bit_flags__WEBPACK_IMPORTED_MODULE_0__["default"].has;
    SecondaryStructureType.create = _mol_util_bit_flags__WEBPACK_IMPORTED_MODULE_0__["default"].create;
    SecondaryStructureType.SecondaryStructureMmcif = {
        HELX_LH_27_P: 2 /* Helix */ | 32 /* LeftHanded */ | 1024 /* Helix27 */,
        HELX_LH_3T_P: 2 /* Helix */ | 32 /* LeftHanded */ | 2048 /* Helix3Ten */,
        HELX_LH_AL_P: 2 /* Helix */ | 32 /* LeftHanded */ | 4096 /* HelixAlpha */,
        HELX_LH_A_N: 1 /* DoubleHelix */ | 32 /* LeftHanded */ | 524288 /* DoubleHelixA */,
        HELX_LH_B_N: 1 /* DoubleHelix */ | 32 /* LeftHanded */ | 1048576 /* DoubleHelixB */,
        HELX_LH_GA_P: 2 /* Helix */ | 32 /* LeftHanded */ | 8192 /* HelixGamma */,
        HELX_LH_N: 1 /* DoubleHelix */ | 32 /* LeftHanded */,
        HELX_LH_OM_P: 2 /* Helix */ | 32 /* LeftHanded */ | 16384 /* HelixOmega */,
        HELX_LH_OT_N: 1 /* DoubleHelix */ | 32 /* LeftHanded */ | 131072 /* DoubleHelixOther */,
        HELX_LH_OT_P: 2 /* Helix */ | 32 /* LeftHanded */ | 512 /* HelixOther */,
        HELX_LH_P: 2 /* Helix */ | 32 /* LeftHanded */,
        HELX_LH_PI_P: 2 /* Helix */ | 32 /* LeftHanded */ | 32768 /* HelixPi */,
        HELX_LH_PP_P: 2 /* Helix */ | 32 /* LeftHanded */ | 65536 /* HelixPolyproline */,
        HELX_LH_Z_N: 1 /* DoubleHelix */ | 32 /* LeftHanded */ | 262144 /* DoubleHelixZ */,
        HELX_N: 1 /* DoubleHelix */,
        HELX_OT_N: 1 /* DoubleHelix */,
        HELX_OT_P: 2 /* Helix */,
        HELX_P: 2 /* Helix */,
        HELX_RH_27_P: 2 /* Helix */ | 64 /* RightHanded */ | 1024 /* Helix27 */,
        HELX_RH_3T_P: 2 /* Helix */ | 64 /* RightHanded */ | 2048 /* Helix3Ten */,
        HELX_RH_AL_P: 2 /* Helix */ | 64 /* RightHanded */ | 4096 /* HelixAlpha */,
        HELX_RH_A_N: 1 /* DoubleHelix */ | 64 /* RightHanded */ | 524288 /* DoubleHelixA */,
        HELX_RH_B_N: 1 /* DoubleHelix */ | 64 /* RightHanded */ | 1048576 /* DoubleHelixB */,
        HELX_RH_GA_P: 2 /* Helix */ | 64 /* RightHanded */ | 8192 /* HelixGamma */,
        HELX_RH_N: 1 /* DoubleHelix */ | 64 /* RightHanded */,
        HELX_RH_OM_P: 2 /* Helix */ | 64 /* RightHanded */ | 16384 /* HelixOmega */,
        HELX_RH_OT_N: 1 /* DoubleHelix */ | 64 /* RightHanded */ | 131072 /* DoubleHelixOther */,
        HELX_RH_OT_P: 2 /* Helix */ | 64 /* RightHanded */ | 512 /* HelixOther */,
        HELX_RH_P: 2 /* Helix */ | 64 /* RightHanded */,
        HELX_RH_PI_P: 2 /* Helix */ | 64 /* RightHanded */ | 32768 /* HelixPi */,
        HELX_RH_PP_P: 2 /* Helix */ | 64 /* RightHanded */ | 65536 /* HelixPolyproline */,
        HELX_RH_Z_N: 1 /* DoubleHelix */ | 64 /* RightHanded */ | 262144 /* DoubleHelixZ */,
        STRN: 4 /* Beta */ | 4194304 /* BetaStrand */,
        TURN_OT_P: 16 /* Turn */ | 33554432 /* TurnOther */,
        TURN_P: 16 /* Turn */,
        TURN_TY1P_P: 16 /* Turn */ | 256 /* InverseTurn */ | 67108864 /* Turn1 */,
        TURN_TY1_P: 16 /* Turn */ | 128 /* ClassicTurn */ | 67108864 /* Turn1 */,
        TURN_TY2P_P: 16 /* Turn */ | 256 /* InverseTurn */ | 134217728 /* Turn2 */,
        TURN_TY2_P: 16 /* Turn */ | 128 /* ClassicTurn */ | 134217728 /* Turn2 */,
        TURN_TY3P_P: 16 /* Turn */ | 256 /* InverseTurn */ | 268435456 /* Turn3 */,
        TURN_TY3_P: 16 /* Turn */ | 128 /* ClassicTurn */ | 268435456 /* Turn3 */,
    };
    SecondaryStructureType.SecondaryStructurePdb = {
        1: 2 /* Helix */ | 64 /* RightHanded */ | 4096 /* HelixAlpha */,
        2: 2 /* Helix */ | 64 /* RightHanded */ | 16384 /* HelixOmega */,
        3: 2 /* Helix */ | 64 /* RightHanded */ | 32768 /* HelixPi */,
        4: 2 /* Helix */ | 64 /* RightHanded */ | 8192 /* HelixGamma */,
        5: 2 /* Helix */ | 64 /* RightHanded */ | 2048 /* Helix3Ten */,
        6: 2 /* Helix */ | 32 /* LeftHanded */ | 4096 /* HelixAlpha */,
        7: 2 /* Helix */ | 32 /* LeftHanded */ | 16384 /* HelixOmega */,
        8: 2 /* Helix */ | 32 /* LeftHanded */ | 8192 /* HelixGamma */,
        9: 2 /* Helix */ | 1024 /* Helix27 */,
        10: 2 /* Helix */ | 65536 /* HelixPolyproline */,
    };
    SecondaryStructureType.SecondaryStructureStride = {
        H: 2 /* Helix */ | 4096 /* HelixAlpha */,
        G: 2 /* Helix */ | 2048 /* Helix3Ten */,
        I: 2 /* Helix */ | 32768 /* HelixPi */,
        E: 4 /* Beta */ | 8388608 /* BetaSheet */,
        B: 4 /* Beta */ | 4194304 /* BetaStrand */,
        T: 16 /* Turn */,
        C: 536870912 /* NA */,
    };
    SecondaryStructureType.SecondaryStructureDssp = {
        H: 2 /* Helix */ | 4096 /* HelixAlpha */,
        B: 4 /* Beta */ | 4194304 /* BetaStrand */,
        E: 4 /* Beta */ | 8388608 /* BetaSheet */,
        G: 2 /* Helix */ | 2048 /* Helix3Ten */,
        I: 2 /* Helix */ | 32768 /* HelixPi */,
        T: 16 /* Turn */,
        S: 8 /* Bend */,
    };
})(SecondaryStructureType || (SecondaryStructureType = {}));
/** Maximum accessible surface area observed for amino acids. Taken from: http://dx.doi.org/10.1371/journal.pone.0080635 */
var MaxAsa = {
    'ALA': 121.0,
    'ARG': 265.0,
    'ASN': 187.0,
    'ASP': 187.0,
    'CYS': 148.0,
    'GLU': 214.0,
    'GLN': 214.0,
    'GLY': 97.0,
    'HIS': 216.0,
    'ILE': 195.0,
    'LEU': 191.0,
    'LYS': 230.0,
    'MET': 203.0,
    'PHE': 228.0,
    'PRO': 154.0,
    'SER': 143.0,
    'THR': 163.0,
    'TRP': 264.0,
    'TYR': 255.0,
    'VAL': 165.0
};
var DefaultMaxAsa = 121.0;
var BondType;
(function (BondType) {
    BondType.is = _mol_util_bit_flags__WEBPACK_IMPORTED_MODULE_0__["default"].has;
    function create(flags) {
        return _mol_util_bit_flags__WEBPACK_IMPORTED_MODULE_0__["default"].create(flags);
    }
    BondType.create = create;
    function isCovalent(flags) {
        return (flags & 1 /* Covalent */) !== 0;
    }
    BondType.isCovalent = isCovalent;
    function isAll(flags) {
        return flags === Math.pow(2, 6) - 1;
    }
    BondType.isAll = isAll;
    BondType.Names = {
        'covalent': 1 /* Covalent */,
        'metal-coordination': 2 /* MetallicCoordination */,
        'hydrogen-bond': 4 /* HydrogenBond */,
        'disulfide': 4 /* HydrogenBond */,
        'aromatic': 4 /* HydrogenBond */,
        'computed': 4 /* HydrogenBond */,
    };
    function isName(name) {
        return name in BondType.Names;
    }
    BondType.isName = isName;
    function fromName(name) {
        switch (name) {
            case 'covalent': return 1 /* Covalent */;
            case 'metal-coordination': return 2 /* MetallicCoordination */;
            case 'hydrogen-bond': return 4 /* HydrogenBond */;
            case 'disulfide': return 8 /* Disulfide */;
            case 'aromatic': return 16 /* Aromatic */;
            case 'computed': return 32 /* Computed */;
        }
    }
    BondType.fromName = fromName;
    function fromNames(names) {
        var f = 0 /* None */;
        for (var i = 0, il = names.length; i < il; ++i) {
            f |= fromName(names[i]);
        }
        return f;
    }
    BondType.fromNames = fromNames;
})(BondType || (BondType = {}));
/**
 * "Experimentally determined hydrophobicity scale for proteins at membrane interfaces"
 * by Wimely and White (doi:10.1038/nsb1096-842)
 * http://blanco.biomol.uci.edu/Whole_residue_HFscales.txt
 * https://www.nature.com/articles/nsb1096-842
 */
var ResidueHydrophobicity = {
    // AA  DGwif   DGwoct  Oct-IF
    'ALA': [0.17, 0.50, 0.33],
    'ARG': [0.81, 1.81, 1.00],
    'ASN': [0.42, 0.85, 0.43],
    'ASP': [1.23, 3.64, 2.41],
    'ASH': [-0.07, 0.43, 0.50],
    'CYS': [-0.24, -0.02, 0.22],
    'GLN': [0.58, 0.77, 0.19],
    'GLU': [2.02, 3.63, 1.61],
    'GLH': [-0.01, 0.11, 0.12],
    'GLY': [0.01, 1.15, 1.14],
    // "His+": [  0.96,  2.33,  1.37 ],
    'HIS': [0.17, 0.11, -0.06],
    'ILE': [-0.31, -1.12, -0.81],
    'LEU': [-0.56, -1.25, -0.69],
    'LYS': [0.99, 2.80, 1.81],
    'MET': [-0.23, -0.67, -0.44],
    'PHE': [-1.13, -1.71, -0.58],
    'PRO': [0.45, 0.14, -0.31],
    'SER': [0.13, 0.46, 0.33],
    'THR': [0.14, 0.25, 0.11],
    'TRP': [-1.85, -2.09, -0.24],
    'TYR': [-0.94, -0.71, 0.23],
    'VAL': [0.07, -0.46, -0.53]
};
var DefaultResidueHydrophobicity = [0.00, 0.00, 0.00];
//# sourceMappingURL=types.js.map

/***/ }),

/***/ "./lib/mol-model/structure/model/types/ions.js":
/*!*****************************************************!*\
  !*** ./lib/mol-model/structure/model/types/ions.js ***!
  \*****************************************************/
/*! exports provided: IonNames */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "IonNames", function() { return IonNames; });
/**
 * Copyright (c) 2020 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * Code-generated ion names params file. Names extracted from CCD components.
 *
 * @author molstar/chem-comp-dict/create-table cli
 */
var IonNames = new Set(['118', '119', '543', '1AL', '1CU', '2FK', '2HP', '2OF', '3CO', '3MT', '3NI', '3OF', '3P8', '4MO', '4PU', '4TI', '6MO', 'ACT', 'AG', 'AL', 'ALF', 'AM', 'ATH', 'AU', 'AU3', 'AUC', 'AZI', 'BA', 'BCT', 'BEF', 'BF4', 'BO4', 'BR', 'BS3', 'BSY', 'CA', 'CAC', 'CD', 'CD1', 'CD3', 'CD5', 'CE', 'CF', 'CHT', 'CL', 'CO', 'CO3', 'CO5', 'CON', 'CR', 'CS', 'CSB', 'CU', 'CU1', 'CU3', 'CUA', 'CUZ', 'CYN', 'DME', 'DMI', 'DSC', 'DTI', 'DY', 'E4N', 'EDR', 'EMC', 'ER3', 'EU', 'EU3', 'F', 'FE', 'FE2', 'FPO', 'GA', 'GD3', 'GEP', 'HAI', 'HG', 'HGC', 'IN', 'IOD', 'IR', 'IR3', 'IRI', 'IUM', 'K', 'KO4', 'LA', 'LCO', 'LCP', 'LI', 'LU', 'MAC', 'MG', 'MH2', 'MH3', 'MLI', 'MMC', 'MN', 'MN3', 'MN5', 'MN6', 'MO1', 'MO2', 'MO3', 'MO4', 'MO5', 'MO6', 'MOO', 'MOS', 'MOW', 'MW1', 'MW2', 'MW3', 'NA', 'NA2', 'NA5', 'NA6', 'NAO', 'NAW', 'NET', 'NH4', 'NI', 'NI1', 'NI2', 'NI3', 'NO2', 'NO3', 'NRU', 'O4M', 'OAA', 'OC1', 'OC2', 'OC3', 'OC4', 'OC5', 'OC6', 'OC7', 'OC8', 'OCL', 'OCM', 'OCN', 'OCO', 'OF1', 'OF2', 'OF3', 'OH', 'OS', 'OS4', 'OXL', 'PB', 'PBM', 'PD', 'PDV', 'PER', 'PI', 'PO3', 'PO4', 'PR', 'PT', 'PT4', 'PTN', 'RB', 'RH3', 'RHD', 'RU', 'SB', 'SCN', 'SE4', 'SEK', 'SM', 'SMO', 'SO3', 'SO4', 'SR', 'T1A', 'TB', 'TBA', 'TCN', 'TEA', 'TH', 'THE', 'TL', 'TMA', 'TRA', 'UNX', 'V', 'VN3', 'VO4', 'W', 'WO5', 'Y1', 'YB', 'YB2', 'YH', 'YT3', 'ZCM', 'ZN', 'ZN2', 'ZN3', 'ZNO', 'ZO3', 'ZR', 'NCO', 'OHX']);
//# sourceMappingURL=ions.js.map

/***/ }),

/***/ "./lib/mol-model/structure/model/types/lipids.js":
/*!*******************************************************!*\
  !*** ./lib/mol-model/structure/model/types/lipids.js ***!
  \*******************************************************/
/*! exports provided: LipidNames */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "LipidNames", function() { return LipidNames; });
/**
 * Copyright (c) 2020 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * Code-generated lipid params file. Names extracted from Martini FF lipids itp.
 *
 * @author molstar/lipid-params cli
 */
var LipidNames = new Set(['DAPC', 'DBPC', 'DFPC', 'DGPC', 'DIPC', 'DLPC', 'DNPC', 'DOPC', 'DPPC', 'DRPC', 'DTPC', 'DVPC', 'DXPC', 'DYPC', 'LPPC', 'PAPC', 'PEPC', 'PGPC', 'PIPC', 'POPC', 'PRPC', 'PUPC', 'DAPE', 'DBPE', 'DFPE', 'DGPE', 'DIPE', 'DLPE', 'DNPE', 'DOPE', 'DPPE', 'DRPE', 'DTPE', 'DUPE', 'DVPE', 'DXPE', 'DYPE', 'LPPE', 'PAPE', 'PGPE', 'PIPE', 'POPE', 'PQPE', 'PRPE', 'PUPE', 'DAPS', 'DBPS', 'DFPS', 'DGPS', 'DIPS', 'DLPS', 'DNPS', 'DOPS', 'DPPS', 'DRPS', 'DTPS', 'DUPS', 'DVPS', 'DXPS', 'DYPS', 'LPPS', 'PAPS', 'PGPS', 'PIPS', 'POPS', 'PQPS', 'PRPS', 'PUPS', 'DAPG', 'DBPG', 'DFPG', 'DGPG', 'DIPG', 'DLPG', 'DNPG', 'DOPG', 'DPPG', 'DRPG', 'DTPG', 'DVPG', 'DXPG', 'DYPG', 'LPPG', 'PAPG', 'PGPG', 'PIPG', 'POPG', 'PRPG', 'DAPA', 'DBPA', 'DFPA', 'DGPA', 'DIPA', 'DLPA', 'DNPA', 'DOPA', 'DPPA', 'DRPA', 'DTPA', 'DVPA', 'DXPA', 'DYPA', 'LPPA', 'PAPA', 'PGPA', 'PIPA', 'POPA', 'PRPA', 'PUPA', 'DPP', 'DPPI', 'PAPI', 'PIPI', 'POP', 'POPI', 'PUPI', 'PVP', 'PVPI', 'PADG', 'PIDG', 'PODG', 'PUDG', 'PVDG', 'APC', 'CPC', 'IPC', 'LPC', 'OPC', 'PPC', 'TPC', 'UPC', 'VPC', 'BNSM', 'DBSM', 'DPSM', 'DXSM', 'PGSM', 'PNSM', 'POSM', 'PVSM', 'XNSM', 'DPCE', 'DXCE', 'PNCE', 'XNCE', 'DMPC']);
//# sourceMappingURL=lipids.js.map

/***/ }),

/***/ "./lib/mol-model/structure/model/util.js":
/*!***********************************************!*\
  !*** ./lib/mol-model/structure/model/util.js ***!
  \***********************************************/
/*! exports provided: calcModelCenter, getAsymIdCount */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "calcModelCenter", function() { return calcModelCenter; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getAsymIdCount", function() { return getAsymIdCount; });
/* harmony import */ var _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../../mol-math/linear-algebra */ "./lib/mol-math/linear-algebra.js");
/* harmony import */ var _mol_util_array__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../../mol-util/array */ "./lib/mol-util/array.js");
/**
 * Copyright (c) 2019-2020 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */


function calcModelCenter(atomicConformation, coarseConformation) {
    var rangesX = [];
    var rangesY = [];
    var rangesZ = [];
    if (atomicConformation.x.length) {
        rangesX.push.apply(rangesX, Object(_mol_util_array__WEBPACK_IMPORTED_MODULE_1__["arrayMinMax"])(atomicConformation.x));
        rangesY.push.apply(rangesY, Object(_mol_util_array__WEBPACK_IMPORTED_MODULE_1__["arrayMinMax"])(atomicConformation.y));
        rangesZ.push.apply(rangesZ, Object(_mol_util_array__WEBPACK_IMPORTED_MODULE_1__["arrayMinMax"])(atomicConformation.z));
    }
    if (coarseConformation) {
        if (coarseConformation.spheres.x.length) {
            rangesX.push.apply(rangesX, Object(_mol_util_array__WEBPACK_IMPORTED_MODULE_1__["arrayMinMax"])(coarseConformation.spheres.x));
            rangesY.push.apply(rangesY, Object(_mol_util_array__WEBPACK_IMPORTED_MODULE_1__["arrayMinMax"])(coarseConformation.spheres.y));
            rangesZ.push.apply(rangesZ, Object(_mol_util_array__WEBPACK_IMPORTED_MODULE_1__["arrayMinMax"])(coarseConformation.spheres.z));
        }
        if (coarseConformation.gaussians.x.length) {
            rangesX.push.apply(rangesX, Object(_mol_util_array__WEBPACK_IMPORTED_MODULE_1__["arrayMinMax"])(coarseConformation.gaussians.x));
            rangesY.push.apply(rangesY, Object(_mol_util_array__WEBPACK_IMPORTED_MODULE_1__["arrayMinMax"])(coarseConformation.gaussians.y));
            rangesZ.push.apply(rangesZ, Object(_mol_util_array__WEBPACK_IMPORTED_MODULE_1__["arrayMinMax"])(coarseConformation.gaussians.z));
        }
    }
    var _a = Object(_mol_util_array__WEBPACK_IMPORTED_MODULE_1__["arrayMinMax"])(rangesX), minX = _a[0], maxX = _a[1];
    var _b = Object(_mol_util_array__WEBPACK_IMPORTED_MODULE_1__["arrayMinMax"])(rangesY), minY = _b[0], maxY = _b[1];
    var _c = Object(_mol_util_array__WEBPACK_IMPORTED_MODULE_1__["arrayMinMax"])(rangesZ), minZ = _c[0], maxZ = _c[1];
    var x = minX + (maxX - minX) / 2;
    var y = minY + (maxY - minY) / 2;
    var z = minZ + (maxZ - minZ) / 2;
    return _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"].create(x, y, z);
}
function getAsymIdCount(model) {
    var auth = new Set();
    var label = new Set();
    model.properties.structAsymMap.forEach(function (_a, label_id) {
        var auth_id = _a.auth_id;
        auth.add(auth_id);
        label.add(label_id);
    });
    return { auth: auth.size, label: label.size };
}
//# sourceMappingURL=util.js.map

/***/ }),

/***/ "./lib/mol-model/structure/query.js":
/*!******************************************!*\
  !*** ./lib/mol-model/structure/query.js ***!
  \******************************************/
/*! exports provided: QueryContext, Queries, StructureSelection, StructureQuery */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Queries", function() { return Queries; });
/* harmony import */ var _query_selection__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./query/selection */ "./lib/mol-model/structure/query/selection.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "StructureSelection", function() { return _query_selection__WEBPACK_IMPORTED_MODULE_0__["StructureSelection"]; });

/* harmony import */ var _query_query__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./query/query */ "./lib/mol-model/structure/query/query.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "StructureQuery", function() { return _query_query__WEBPACK_IMPORTED_MODULE_1__["StructureQuery"]; });

/* harmony import */ var _query_context__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./query/context */ "./lib/mol-model/structure/query/context.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "QueryContext", function() { return _query_context__WEBPACK_IMPORTED_MODULE_2__["QueryContext"]; });

/* harmony import */ var _query_queries_generators__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./query/queries/generators */ "./lib/mol-model/structure/query/queries/generators.js");
/* harmony import */ var _query_queries_modifiers__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./query/queries/modifiers */ "./lib/mol-model/structure/query/queries/modifiers.js");
/* harmony import */ var _query_queries_filters__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./query/queries/filters */ "./lib/mol-model/structure/query/queries/filters.js");
/* harmony import */ var _query_queries_combinators__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ./query/queries/combinators */ "./lib/mol-model/structure/query/queries/combinators.js");
/* harmony import */ var _query_queries_internal__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ./query/queries/internal */ "./lib/mol-model/structure/query/queries/internal.js");
/* harmony import */ var _query_predicates__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ./query/predicates */ "./lib/mol-model/structure/query/predicates.js");
/**
 * Copyright (c) 2017 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author David Sehnal <david.sehnal@gmail.com>
 */









var Queries = {
    generators: _query_queries_generators__WEBPACK_IMPORTED_MODULE_3__,
    filters: _query_queries_filters__WEBPACK_IMPORTED_MODULE_5__,
    modifiers: _query_queries_modifiers__WEBPACK_IMPORTED_MODULE_4__,
    combinators: _query_queries_combinators__WEBPACK_IMPORTED_MODULE_6__,
    pred: _query_predicates__WEBPACK_IMPORTED_MODULE_8__["default"],
    internal: _query_queries_internal__WEBPACK_IMPORTED_MODULE_7__
};

//# sourceMappingURL=query.js.map

/***/ }),

/***/ "./lib/mol-model/structure/query/context.js":
/*!**************************************************!*\
  !*** ./lib/mol-model/structure/query/context.js ***!
  \**************************************************/
/*! exports provided: QueryContext */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "QueryContext", function() { return QueryContext; });
/* harmony import */ var _structure__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../structure */ "./lib/mol-model/structure/structure.js");
/* harmony import */ var _mol_util_now__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../../mol-util/now */ "./lib/mol-util/now.js");
/* harmony import */ var _queries_internal__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./queries/internal */ "./lib/mol-model/structure/query/queries/internal.js");
/**
 * Copyright (c) 2018 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author David Sehnal <david.sehnal@gmail.com>
 */



var QueryContext = /** @class */ (function () {
    function QueryContext(structure, options) {
        this.currentElementStack = [];
        this.currentAtomicBondStack = [];
        this.currentStructureStack = [];
        this.inputStructureStack = [];
        this.timeCreated = Object(_mol_util_now__WEBPACK_IMPORTED_MODULE_1__["now"])();
        /** Current element */
        this.element = _structure__WEBPACK_IMPORTED_MODULE_0__["StructureElement"].Location.create(void 0);
        this.currentStructure = void 0;
        /** Current bond between atoms */
        this.atomicBond = new QueryContextBondInfo();
        /** Supply this from the outside. Used by the internal.generator.current symbol */
        this.currentSelection = void 0;
        this.inputStructure = structure;
        this.timeoutMs = (options && options.timeoutMs) || 0;
        this.currentSelection = options && options.currentSelection;
    }
    QueryContext.prototype.pushCurrentElement = function () {
        this.currentElementStack[this.currentElementStack.length] = this.element;
        this.element = _structure__WEBPACK_IMPORTED_MODULE_0__["StructureElement"].Location.create(void 0);
        return this.element;
    };
    QueryContext.prototype.popCurrentElement = function () {
        this.element = this.currentElementStack.pop();
    };
    QueryContext.prototype.pushCurrentBond = function () {
        if (this.atomicBond)
            this.currentAtomicBondStack.push(this.atomicBond);
        this.atomicBond = new QueryContextBondInfo();
        return this.atomicBond;
    };
    QueryContext.prototype.popCurrentBond = function () {
        if (this.currentAtomicBondStack.length > 0) {
            this.atomicBond = this.currentAtomicBondStack.pop();
        }
        else {
            this.atomicBond = void 0;
        }
    };
    QueryContext.prototype.pushCurrentStructure = function () {
        if (this.currentStructure)
            this.currentStructureStack.push(this.currentStructure);
    };
    QueryContext.prototype.popCurrentStructure = function () {
        if (this.currentStructureStack.length)
            this.currentStructure = this.currentStructureStack.pop();
        else
            this.currentStructure = void 0;
    };
    QueryContext.prototype.pushInputStructure = function (structure) {
        this.inputStructureStack.push(this.inputStructure);
        this.inputStructure = structure;
    };
    QueryContext.prototype.popInputStructure = function () {
        if (this.inputStructureStack.length === 0)
            throw new Error('Must push before pop.');
        this.inputStructure = this.inputStructureStack.pop();
    };
    QueryContext.prototype.throwIfTimedOut = function () {
        if (this.timeoutMs === 0)
            return;
        if (Object(_mol_util_now__WEBPACK_IMPORTED_MODULE_1__["now"])() - this.timeCreated > this.timeoutMs) {
            throw new Error("The query took too long to execute (> " + this.timeoutMs / 1000 + "s).");
        }
    };
    QueryContext.prototype.tryGetCurrentSelection = function () {
        if (!this.currentSelection)
            throw new Error('The current selection is not assigned.');
        return this.currentSelection;
    };
    return QueryContext;
}());

var QueryContextBondInfo = /** @class */ (function () {
    function QueryContextBondInfo() {
        this.a = _structure__WEBPACK_IMPORTED_MODULE_0__["StructureElement"].Location.create(void 0);
        this.aIndex = 0;
        this.b = _structure__WEBPACK_IMPORTED_MODULE_0__["StructureElement"].Location.create(void 0);
        this.bIndex = 0;
        this.type = 0 /* None */;
        this.order = 0;
        this.testFn = _queries_internal__WEBPACK_IMPORTED_MODULE_2__["defaultBondTest"];
    }
    QueryContextBondInfo.prototype.setStructure = function (s) {
        this.a.structure = s;
        this.b.structure = s;
    };
    QueryContextBondInfo.prototype.setTestFn = function (fn) {
        this.testFn = fn || _queries_internal__WEBPACK_IMPORTED_MODULE_2__["defaultBondTest"];
    };
    QueryContextBondInfo.prototype.test = function (ctx, trySwap) {
        if (this.testFn(ctx))
            return true;
        if (trySwap) {
            this.swap();
            return this.testFn(ctx);
        }
        return false;
    };
    QueryContextBondInfo.prototype.swap = function () {
        // const sA = this.a.structure;
        // this.a.structure = this.b.structure;
        // this.b.structure = sA;
        var idxA = this.aIndex;
        this.aIndex = this.bIndex;
        this.bIndex = idxA;
        var unitA = this.a.unit;
        this.a.unit = this.b.unit;
        this.b.unit = unitA;
        var eA = this.a.element;
        this.a.element = this.b.element;
        this.b.element = eA;
    };
    Object.defineProperty(QueryContextBondInfo.prototype, "length", {
        get: function () {
            return _structure__WEBPACK_IMPORTED_MODULE_0__["StructureElement"].Location.distance(this.a, this.b);
        },
        enumerable: false,
        configurable: true
    });
    return QueryContextBondInfo;
}());
//# sourceMappingURL=context.js.map

/***/ }),

/***/ "./lib/mol-model/structure/query/predicates.js":
/*!*****************************************************!*\
  !*** ./lib/mol-model/structure/query/predicates.js ***!
  \*****************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/**
 * Copyright (c) 2017 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author David Sehnal <david.sehnal@gmail.com>
 */
var Predicates;
(function (Predicates) {
    function isSetLike(x) { return !!x && !!x.has; }
    function eq(p, value) { return function (l) { return p(l) === value; }; }
    Predicates.eq = eq;
    function lt(p, value) { return function (l) { return p(l) < value; }; }
    Predicates.lt = lt;
    function lte(p, value) { return function (l) { return p(l) <= value; }; }
    Predicates.lte = lte;
    function gt(p, value) { return function (l) { return p(l) > value; }; }
    Predicates.gt = gt;
    function gte(p, value) { return function (l) { return p(l) >= value; }; }
    Predicates.gte = gte;
    function _true(ctx) { return true; }
    function _false(ctx) { return false; }
    function inSet(p, values) {
        if (isSetLike(values)) {
            return function (l) { return values.has(p(l)); };
        }
        else {
            if (values.length === 0)
                return _false;
            var set_1 = new Set();
            for (var i = 0; i < values.length; i++)
                set_1.add(values[i]);
            return function (l) { return set_1.has(p(l)); };
        }
    }
    Predicates.inSet = inSet;
    function and() {
        var ps = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            ps[_i] = arguments[_i];
        }
        switch (ps.length) {
            case 0: return _true;
            case 1: return ps[0];
            case 2: {
                var a_1 = ps[0], b_1 = ps[1];
                return function (l) { return a_1(l) && b_1(l); };
            }
            case 3: {
                var a_2 = ps[0], b_2 = ps[1], c_1 = ps[2];
                return function (l) { return a_2(l) && b_2(l) && c_1(l); };
            }
            case 4: {
                var a_3 = ps[0], b_3 = ps[1], c_2 = ps[2], d_1 = ps[3];
                return function (l) { return a_3(l) && b_3(l) && c_2(l) && d_1(l); };
            }
            case 5: {
                var a_4 = ps[0], b_4 = ps[1], c_3 = ps[2], d_2 = ps[3], e_1 = ps[4];
                return function (l) { return a_4(l) && b_4(l) && c_3(l) && d_2(l) && e_1(l); };
            }
            case 6: {
                var a_5 = ps[0], b_5 = ps[1], c_4 = ps[2], d_3 = ps[3], e_2 = ps[4], f_1 = ps[5];
                return function (l) { return a_5(l) && b_5(l) && c_4(l) && d_3(l) && e_2(l) && f_1(l); };
            }
            default: {
                var count_1 = ps.length;
                return function (l) {
                    for (var i = 0; i < count_1; i++)
                        if (!ps[i])
                            return false;
                    return true;
                };
            }
        }
    }
    Predicates.and = and;
    function or() {
        var ps = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            ps[_i] = arguments[_i];
        }
        switch (ps.length) {
            case 0: return _false;
            case 1: return ps[0];
            case 2: {
                var a_6 = ps[0], b_6 = ps[1];
                return function (l) { return a_6(l) || b_6(l); };
            }
            case 3: {
                var a_7 = ps[0], b_7 = ps[1], c_5 = ps[2];
                return function (l) { return a_7(l) || b_7(l) || c_5(l); };
            }
            case 4: {
                var a_8 = ps[0], b_8 = ps[1], c_6 = ps[2], d_4 = ps[3];
                return function (l) { return a_8(l) || b_8(l) || c_6(l) || d_4(l); };
            }
            case 5: {
                var a_9 = ps[0], b_9 = ps[1], c_7 = ps[2], d_5 = ps[3], e_3 = ps[4];
                return function (l) { return a_9(l) || b_9(l) || c_7(l) || d_5(l) || e_3(l); };
            }
            case 6: {
                var a_10 = ps[0], b_10 = ps[1], c_8 = ps[2], d_6 = ps[3], e_4 = ps[4], f_2 = ps[5];
                return function (l) { return a_10(l) || b_10(l) || c_8(l) || d_6(l) || e_4(l) || f_2(l); };
            }
            default: {
                var count_2 = ps.length;
                return function (l) {
                    for (var i = 0; i < count_2; i++)
                        if (ps[i])
                            return true;
                    return false;
                };
            }
        }
    }
    Predicates.or = or;
})(Predicates || (Predicates = {}));
/* harmony default export */ __webpack_exports__["default"] = (Predicates);
//# sourceMappingURL=predicates.js.map

/***/ }),

/***/ "./lib/mol-model/structure/query/queries/combinators.js":
/*!**************************************************************!*\
  !*** ./lib/mol-model/structure/query/queries/combinators.js ***!
  \**************************************************************/
/*! exports provided: merge, intersect */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "merge", function() { return merge; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "intersect", function() { return intersect; });
/* harmony import */ var _selection__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../selection */ "./lib/mol-model/structure/query/selection.js");
/* harmony import */ var _generators__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./generators */ "./lib/mol-model/structure/query/queries/generators.js");
/* harmony import */ var _mol_data_generic__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../../../mol-data/generic */ "./lib/mol-data/generic.js");
/* harmony import */ var _structure__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../structure */ "./lib/mol-model/structure/structure.js");
/**
 * Copyright (c) 2018 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author David Sehnal <david.sehnal@gmail.com>
 */




function merge(queries) {
    if (queries.length === 0) {
        return _generators__WEBPACK_IMPORTED_MODULE_1__["none"];
    }
    else if (queries.length === 1) {
        return queries[0];
    }
    return function (ctx) {
        var ret = _selection__WEBPACK_IMPORTED_MODULE_0__["StructureSelection"].UniqueBuilder(ctx.inputStructure);
        var _loop_1 = function (i) {
            _selection__WEBPACK_IMPORTED_MODULE_0__["StructureSelection"].forEach(queries[i](ctx), function (s, j) {
                ret.add(s);
                if (i % 100)
                    ctx.throwIfTimedOut();
            });
        };
        for (var i = 0; i < queries.length; i++) {
            _loop_1(i);
        }
        return ret.getSelection();
    };
}
function intersect(queries) {
    if (queries.length === 0) {
        return _generators__WEBPACK_IMPORTED_MODULE_1__["none"];
    }
    else if (queries.length === 1) {
        return queries[0];
    }
    return function (ctx) {
        var selections = [];
        for (var i = 0; i < queries.length; i++)
            selections.push(queries[i](ctx));
        var pivotIndex = 0, pivotLength = _selection__WEBPACK_IMPORTED_MODULE_0__["StructureSelection"].structureCount(selections[0]);
        for (var i = 1; i < selections.length; i++) {
            var len = _selection__WEBPACK_IMPORTED_MODULE_0__["StructureSelection"].structureCount(selections[i]);
            if (len < pivotLength) {
                pivotIndex = i;
                pivotLength = len;
            }
        }
        ctx.throwIfTimedOut();
        var pivotSet = Object(_mol_data_generic__WEBPACK_IMPORTED_MODULE_2__["HashSet"])(function (s) { return s.hashCode; }, _structure__WEBPACK_IMPORTED_MODULE_3__["Structure"].areUnitIdsAndIndicesEqual);
        _selection__WEBPACK_IMPORTED_MODULE_0__["StructureSelection"].forEach(selections[pivotIndex], function (s) { return pivotSet.add(s); });
        var ret = _selection__WEBPACK_IMPORTED_MODULE_0__["StructureSelection"].UniqueBuilder(ctx.inputStructure);
        for (var pI = 0; pI < selections.length; pI++) {
            if (pI === pivotIndex)
                continue;
            _selection__WEBPACK_IMPORTED_MODULE_0__["StructureSelection"].forEach(selections[pI], function (s) {
                if (pivotSet.has(s))
                    ret.add(s);
            });
            ctx.throwIfTimedOut();
        }
        return ret.getSelection();
    };
}
// TODO: distanceCluster
//# sourceMappingURL=combinators.js.map

/***/ }),

/***/ "./lib/mol-model/structure/query/queries/filters.js":
/*!**********************************************************!*\
  !*** ./lib/mol-model/structure/query/queries/filters.js ***!
  \**********************************************************/
/*! exports provided: pick, first, getCurrentStructureProperties, withSameAtomProperties, areIntersectedBy, within, isConnectedTo */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "pick", function() { return pick; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "first", function() { return first; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getCurrentStructureProperties", function() { return getCurrentStructureProperties; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "withSameAtomProperties", function() { return withSameAtomProperties; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "areIntersectedBy", function() { return areIntersectedBy; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "within", function() { return within; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isConnectedTo", function() { return isConnectedTo; });
/* harmony import */ var _mol_util_set__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../../../mol-util/set */ "./lib/mol-util/set.js");
/* harmony import */ var _structure__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../structure */ "./lib/mol-model/structure/structure.js");
/* harmony import */ var _selection__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../selection */ "./lib/mol-model/structure/query/selection.js");
/* harmony import */ var _utils_structure_set__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../utils/structure-set */ "./lib/mol-model/structure/query/utils/structure-set.js");
/* harmony import */ var _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../../../mol-math/linear-algebra */ "./lib/mol-math/linear-algebra.js");
/* harmony import */ var _utils_structure_distance__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../utils/structure-distance */ "./lib/mol-model/structure/query/utils/structure-distance.js");
/* harmony import */ var _structure_structure__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../../structure/structure */ "./lib/mol-model/structure/structure/structure.js");
/* harmony import */ var _mol_data_int__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../../../../mol-data/int */ "./lib/mol-data/int.js");
/**
 * Copyright (c) 2018 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author David Sehnal <david.sehnal@gmail.com>
 */








function pick(query, pred) {
    return function (ctx) {
        var sel = query(ctx);
        var ret = _selection__WEBPACK_IMPORTED_MODULE_2__["StructureSelection"].LinearBuilder(ctx.inputStructure);
        ctx.pushCurrentElement();
        _selection__WEBPACK_IMPORTED_MODULE_2__["StructureSelection"].forEach(sel, function (s, i) {
            ctx.currentStructure = s;
            if (pred(ctx))
                ret.add(s);
            if (i % 100)
                ctx.throwIfTimedOut();
        });
        ctx.popCurrentStructure();
        return ret.getSelection();
    };
}
function first(query) {
    return function (ctx) {
        var sel = query(ctx);
        var ret = _selection__WEBPACK_IMPORTED_MODULE_2__["StructureSelection"].LinearBuilder(ctx.inputStructure);
        if (sel.kind === 'singletons') {
            if (sel.structure.elementCount > 0) {
                var u = sel.structure.units[0];
                var s = _structure_structure__WEBPACK_IMPORTED_MODULE_6__["default"].create([u.getChild(_mol_data_int__WEBPACK_IMPORTED_MODULE_7__["SortedArray"].ofSingleton(u.elements[0]))], { parent: ctx.inputStructure });
                ret.add(s);
            }
        }
        else {
            if (sel.structures.length > 0) {
                ret.add(sel.structures[0]);
            }
        }
        return ret.getSelection();
    };
}
function getCurrentStructureProperties(ctx, props, set) {
    var units = ctx.currentStructure.units;
    var l = ctx.pushCurrentElement();
    l.structure = ctx.currentStructure;
    for (var _a = 0, units_1 = units; _a < units_1.length; _a++) {
        var unit = units_1[_a];
        l.unit = unit;
        var elements = unit.elements;
        var fn = void 0;
        if (_structure__WEBPACK_IMPORTED_MODULE_1__["Unit"].isAtomic(unit))
            fn = props.atomic;
        else
            fn = props.coarse;
        if (!fn)
            continue;
        for (var j = 0, _j = elements.length; j < _j; j++) {
            l.element = elements[j];
            set.add(fn(ctx));
        }
        ctx.throwIfTimedOut();
    }
    ctx.popCurrentElement();
    return set;
}
function getSelectionProperties(ctx, query, props) {
    var set = new Set();
    var sel = query(ctx);
    ctx.pushCurrentElement();
    _selection__WEBPACK_IMPORTED_MODULE_2__["StructureSelection"].forEach(sel, function (s, i) {
        ctx.currentStructure = s;
        getCurrentStructureProperties(ctx, props, set);
        if (i % 10)
            ctx.throwIfTimedOut();
    });
    ctx.popCurrentElement();
    return set;
}
function withSameAtomProperties(query, propertySource, props) {
    return function (ctx) {
        var sel = query(ctx);
        var propSet = getSelectionProperties(ctx, propertySource, props);
        var ret = _selection__WEBPACK_IMPORTED_MODULE_2__["StructureSelection"].LinearBuilder(ctx.inputStructure);
        ctx.pushCurrentStructure();
        _selection__WEBPACK_IMPORTED_MODULE_2__["StructureSelection"].forEach(sel, function (s, i) {
            ctx.currentStructure = s;
            var currentProps = getCurrentStructureProperties(ctx, props, new Set());
            if (_mol_util_set__WEBPACK_IMPORTED_MODULE_0__["SetUtils"].isSuperset(currentProps, propSet)) {
                ret.add(s);
            }
            if (i % 10)
                ctx.throwIfTimedOut();
        });
        ctx.popCurrentStructure();
        return ret.getSelection();
    };
}
function areIntersectedBy(query, by) {
    return function (ctx) {
        var mask = _selection__WEBPACK_IMPORTED_MODULE_2__["StructureSelection"].unionStructure(by(ctx));
        var ret = _selection__WEBPACK_IMPORTED_MODULE_2__["StructureSelection"].LinearBuilder(ctx.inputStructure);
        _selection__WEBPACK_IMPORTED_MODULE_2__["StructureSelection"].forEach(query(ctx), function (s, i) {
            if (Object(_utils_structure_set__WEBPACK_IMPORTED_MODULE_3__["structureAreIntersecting"])(mask, s))
                ret.add(s);
            if (i % 10)
                ctx.throwIfTimedOut();
        });
        return ret.getSelection();
    };
}
function within(params) {
    return function (queryCtx) {
        var ctx = {
            queryCtx: queryCtx,
            selection: params.query(queryCtx),
            target: params.target(queryCtx),
            maxRadius: params.maxRadius,
            minRadius: params.minRadius ? Math.max(0, params.minRadius) : 0,
            elementRadius: params.elementRadius,
            invert: !!params.invert,
        };
        if (ctx.minRadius === 0 && typeof params.minRadius === 'undefined') {
            return withinMaxRadiusLookup(ctx);
        }
        else if (ctx.minRadius === 0) {
            return withinMaxRadius(ctx);
        }
        else {
            return withinMinMaxRadius(ctx);
        }
    };
}
function withinMaxRadiusLookup(_a) {
    var queryCtx = _a.queryCtx, selection = _a.selection, target = _a.target, maxRadius = _a.maxRadius, invert = _a.invert;
    var targetLookup = _selection__WEBPACK_IMPORTED_MODULE_2__["StructureSelection"].unionStructure(target).lookup3d;
    var ret = _selection__WEBPACK_IMPORTED_MODULE_2__["StructureSelection"].LinearBuilder(queryCtx.inputStructure);
    var pos = _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_4__["Vec3"].zero();
    _selection__WEBPACK_IMPORTED_MODULE_2__["StructureSelection"].forEach(selection, function (s, sI) {
        var units = s.units;
        var withinRadius = false;
        for (var i = 0, _i = units.length; i < _i; i++) {
            var unit = units[i];
            var elements = unit.elements, _a = unit.conformation, position = _a.position, r = _a.r;
            for (var i_1 = 0, _i_1 = elements.length; i_1 < _i_1; i_1++) {
                var e = elements[i_1];
                position(e, pos);
                if (targetLookup.check(pos[0], pos[1], pos[2], maxRadius + r(e))) {
                    withinRadius = true;
                    break;
                }
            }
            if (withinRadius)
                break;
        }
        if (invert)
            withinRadius = !withinRadius;
        if (withinRadius)
            ret.add(s);
        if (sI % 10 === 0)
            queryCtx.throwIfTimedOut();
    });
    return ret.getSelection();
}
function withinMaxRadius(_a) {
    var queryCtx = _a.queryCtx, selection = _a.selection, target = _a.target, maxRadius = _a.maxRadius, invert = _a.invert, elementRadius = _a.elementRadius;
    var targetStructure = _selection__WEBPACK_IMPORTED_MODULE_2__["StructureSelection"].unionStructure(target);
    var ret = _selection__WEBPACK_IMPORTED_MODULE_2__["StructureSelection"].LinearBuilder(queryCtx.inputStructure);
    queryCtx.pushCurrentElement();
    _selection__WEBPACK_IMPORTED_MODULE_2__["StructureSelection"].forEach(selection, function (s, sI) {
        var withinRadius = Object(_utils_structure_distance__WEBPACK_IMPORTED_MODULE_5__["checkStructureMaxRadiusDistance"])(queryCtx, targetStructure, s, maxRadius, elementRadius);
        if (invert)
            withinRadius = !withinRadius;
        if (withinRadius)
            ret.add(s);
        if (sI % 10 === 0)
            queryCtx.throwIfTimedOut();
    });
    queryCtx.popCurrentElement();
    return ret.getSelection();
}
function withinMinMaxRadius(_a) {
    var queryCtx = _a.queryCtx, selection = _a.selection, target = _a.target, minRadius = _a.minRadius, maxRadius = _a.maxRadius, invert = _a.invert, elementRadius = _a.elementRadius;
    var targetStructure = _selection__WEBPACK_IMPORTED_MODULE_2__["StructureSelection"].unionStructure(target);
    var ret = _selection__WEBPACK_IMPORTED_MODULE_2__["StructureSelection"].LinearBuilder(queryCtx.inputStructure);
    queryCtx.pushCurrentElement();
    _selection__WEBPACK_IMPORTED_MODULE_2__["StructureSelection"].forEach(selection, function (s, sI) {
        var withinRadius = Object(_utils_structure_distance__WEBPACK_IMPORTED_MODULE_5__["checkStructureMinMaxDistance"])(queryCtx, targetStructure, s, minRadius, maxRadius, elementRadius);
        if (invert)
            withinRadius = !withinRadius;
        if (withinRadius)
            ret.add(s);
        if (sI % 10 === 0)
            queryCtx.throwIfTimedOut();
    });
    queryCtx.popCurrentElement();
    return ret.getSelection();
}
function checkConnected(ctx, structure) {
    var queryCtx = ctx.queryCtx, input = ctx.input, target = ctx.target, disjunct = ctx.disjunct;
    var atomicBond = queryCtx.atomicBond;
    var interBonds = input.interUnitBonds;
    atomicBond.setStructure(input);
    for (var _a = 0, _b = structure.units; _a < _b.length; _a++) {
        var unit = _b[_a];
        if (!_structure__WEBPACK_IMPORTED_MODULE_1__["Unit"].isAtomic(unit))
            continue;
        var inputUnit = input.unitMap.get(unit.id);
        var _c = inputUnit.bonds, offset = _c.offset, b = _c.b, _d = _c.edgeProps, flags = _d.flags, order = _d.order;
        var bondedUnits = interBonds.getConnectedUnits(unit.id);
        var buCount = bondedUnits.length;
        var srcElements = unit.elements;
        var inputElements = inputUnit.elements;
        for (var i = 0, _i = srcElements.length; i < _i; i++) {
            var inputIndex = _mol_data_int__WEBPACK_IMPORTED_MODULE_7__["SortedArray"].indexOf(inputElements, srcElements[i]);
            atomicBond.a.unit = inputUnit;
            atomicBond.b.unit = inputUnit;
            // tElement.unit = unit;
            for (var l = offset[inputIndex], _l = offset[inputIndex + 1]; l < _l; l++) {
                // tElement.element = inputElements[b[l]];
                atomicBond.b.element = inputUnit.elements[b[l]];
                if (disjunct && _mol_data_int__WEBPACK_IMPORTED_MODULE_7__["SortedArray"].has(unit.elements, atomicBond.b.element))
                    continue;
                if (!target.hasElement(atomicBond.b))
                    continue;
                atomicBond.aIndex = inputIndex;
                atomicBond.a.element = srcElements[i];
                atomicBond.bIndex = b[l];
                atomicBond.type = flags[l];
                atomicBond.order = order[l];
                if (atomicBond.test(queryCtx, true))
                    return true;
            }
            for (var li = 0; li < buCount; li++) {
                var lu = bondedUnits[li];
                var bUnit = structure.unitMap.get(lu.unitB);
                var bElements = bUnit.elements;
                var bonds = lu.getEdges(inputIndex);
                for (var bi = 0, _bi = bonds.length; bi < _bi; bi++) {
                    var bond = bonds[bi];
                    atomicBond.b.unit = bUnit;
                    atomicBond.b.element = bElements[bond.indexB];
                    if (!target.hasElement(atomicBond.b))
                        continue;
                    if (disjunct && structure.hasElement(atomicBond.b))
                        continue;
                    atomicBond.a.unit = inputUnit;
                    atomicBond.aIndex = inputIndex;
                    atomicBond.a.element = srcElements[i];
                    atomicBond.bIndex = bond.indexB;
                    atomicBond.type = bond.props.flag;
                    atomicBond.order = bond.props.order;
                    if (atomicBond.test(queryCtx, true))
                        return true;
                }
            }
        }
    }
    return false;
}
function isConnectedTo(_a) {
    var query = _a.query, target = _a.target, disjunct = _a.disjunct, invert = _a.invert, bondTest = _a.bondTest;
    return function (ctx) {
        var targetSel = target(ctx);
        if (_selection__WEBPACK_IMPORTED_MODULE_2__["StructureSelection"].isEmpty(targetSel))
            return targetSel;
        var selection = query(ctx);
        if (_selection__WEBPACK_IMPORTED_MODULE_2__["StructureSelection"].isEmpty(selection))
            return selection;
        var connCtx = {
            queryCtx: ctx,
            input: ctx.inputStructure,
            disjunct: disjunct,
            target: _selection__WEBPACK_IMPORTED_MODULE_2__["StructureSelection"].unionStructure(targetSel)
        };
        var ret = _selection__WEBPACK_IMPORTED_MODULE_2__["StructureSelection"].LinearBuilder(ctx.inputStructure);
        ctx.pushCurrentBond();
        ctx.atomicBond.setTestFn(bondTest);
        _selection__WEBPACK_IMPORTED_MODULE_2__["StructureSelection"].forEach(selection, function (s, sI) {
            if (checkConnected(connCtx, s)) {
                ret.add(s);
            }
            else if (invert) {
                ret.add(s);
            }
            if (sI % 5 === 0)
                ctx.throwIfTimedOut();
        });
        ctx.popCurrentBond();
        return ret.getSelection();
    };
}
//# sourceMappingURL=filters.js.map

/***/ }),

/***/ "./lib/mol-model/structure/query/queries/generators.js":
/*!*************************************************************!*\
  !*** ./lib/mol-model/structure/query/queries/generators.js ***!
  \*************************************************************/
/*! exports provided: none, all, residues, chains, atoms, rings, querySelection, bondedAtomicPairs */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "none", function() { return none; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "all", function() { return all; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "residues", function() { return residues; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "chains", function() { return chains; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "atoms", function() { return atoms; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "rings", function() { return rings; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "querySelection", function() { return querySelection; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "bondedAtomicPairs", function() { return bondedAtomicPairs; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _mol_data_generic__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../../../mol-data/generic */ "./lib/mol-data/generic.js");
/* harmony import */ var _mol_data_int__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../../../mol-data/int */ "./lib/mol-data/int.js");
/* harmony import */ var _structure__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../structure */ "./lib/mol-model/structure/structure.js");
/* harmony import */ var _structure_structure__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../structure/structure */ "./lib/mol-model/structure/structure/structure.js");
/* harmony import */ var _selection__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../selection */ "./lib/mol-model/structure/query/selection.js");
/* harmony import */ var _utils_builders__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../utils/builders */ "./lib/mol-model/structure/query/utils/builders.js");
/* harmony import */ var _utils_structure_set__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../utils/structure-set */ "./lib/mol-model/structure/query/utils/structure-set.js");
/**
 * Copyright (c) 2017-2019 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author David Sehnal <david.sehnal@gmail.com>
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */








var none = function (ctx) { return _selection__WEBPACK_IMPORTED_MODULE_5__["StructureSelection"].Sequence(ctx.inputStructure, []); };
var all = function (ctx) { return _selection__WEBPACK_IMPORTED_MODULE_5__["StructureSelection"].Singletons(ctx.inputStructure, ctx.inputStructure); };
function residues(params) { return atoms(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, params), { groupBy: function (ctx) { return _structure__WEBPACK_IMPORTED_MODULE_3__["StructureProperties"].residue.key(ctx.element); } })); }
function chains(params) { return atoms(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, params), { groupBy: function (ctx) { return _structure__WEBPACK_IMPORTED_MODULE_3__["StructureProperties"].chain.key(ctx.element); } })); }
function _true(ctx) { return true; }
function _zero(ctx) { return 0; }
function atoms(params) {
    if (!params || (!params.atomTest && !params.residueTest && !params.chainTest && !params.entityTest && !params.unitTest && !params.groupBy))
        return all;
    if (!!params.atomTest && !params.residueTest && !params.chainTest && !params.entityTest && !params.unitTest && !params.groupBy)
        return atomGroupsLinear(params.atomTest);
    var normalized = {
        unitTest: params.unitTest || _true,
        entityTest: params.entityTest || _true,
        chainTest: params.chainTest || _true,
        residueTest: params.residueTest || _true,
        atomTest: params.atomTest || _true,
        groupBy: params.groupBy || _zero,
    };
    if (!params.groupBy)
        return atomGroupsSegmented(normalized);
    return atomGroupsGrouped(normalized);
}
function atomGroupsLinear(atomTest) {
    return function query_atomGroupsLinear(ctx) {
        var inputStructure = ctx.inputStructure;
        var units = inputStructure.units;
        var l = ctx.pushCurrentElement();
        var builder = inputStructure.subsetBuilder(true);
        l.structure = inputStructure;
        for (var _a = 0, units_1 = units; _a < units_1.length; _a++) {
            var unit = units_1[_a];
            l.unit = unit;
            var elements = unit.elements;
            builder.beginUnit(unit.id);
            for (var j = 0, _j = elements.length; j < _j; j++) {
                l.element = elements[j];
                if (atomTest(ctx))
                    builder.addElement(l.element);
            }
            builder.commitUnit();
            ctx.throwIfTimedOut();
        }
        ctx.popCurrentElement();
        return _selection__WEBPACK_IMPORTED_MODULE_5__["StructureSelection"].Singletons(inputStructure, builder.getStructure());
    };
}
function atomGroupsSegmented(_a) {
    var unitTest = _a.unitTest, entityTest = _a.entityTest, chainTest = _a.chainTest, residueTest = _a.residueTest, atomTest = _a.atomTest;
    return function query_atomGroupsSegmented(ctx) {
        var inputStructure = ctx.inputStructure;
        var units = inputStructure.units;
        var l = ctx.pushCurrentElement();
        var builder = inputStructure.subsetBuilder(true);
        var chainLevel = residueTest === _true && atomTest === _true;
        var residueLevel = atomTest === _true;
        l.structure = inputStructure;
        for (var _a = 0, units_2 = units; _a < units_2.length; _a++) {
            var unit = units_2[_a];
            l.unit = unit;
            if (!unitTest(ctx))
                continue;
            var elements = unit.elements, model = unit.model;
            builder.beginUnit(unit.id);
            if (unit.kind === 0 /* Atomic */) {
                var chainsIt = _mol_data_int__WEBPACK_IMPORTED_MODULE_2__["Segmentation"].transientSegments(unit.model.atomicHierarchy.chainAtomSegments, elements);
                var residuesIt = _mol_data_int__WEBPACK_IMPORTED_MODULE_2__["Segmentation"].transientSegments(unit.model.atomicHierarchy.residueAtomSegments, elements);
                while (chainsIt.hasNext) {
                    var chainSegment = chainsIt.move();
                    l.element = elements[chainSegment.start];
                    // test entity and chain
                    if (!entityTest(ctx) || !chainTest(ctx))
                        continue;
                    if (chainLevel) {
                        builder.addElementRange(elements, chainSegment.start, chainSegment.end);
                        continue;
                    }
                    residuesIt.setSegment(chainSegment);
                    while (residuesIt.hasNext) {
                        var residueSegment = residuesIt.move();
                        l.element = elements[residueSegment.start];
                        // test residue
                        if (!residueTest(ctx))
                            continue;
                        if (residueLevel) {
                            builder.addElementRange(elements, residueSegment.start, residueSegment.end);
                            continue;
                        }
                        for (var j = residueSegment.start, _j = residueSegment.end; j < _j; j++) {
                            l.element = elements[j];
                            // test atom
                            if (atomTest(ctx)) {
                                builder.addElement(l.element);
                            }
                        }
                    }
                }
            }
            else {
                var chainElementSegments = (1 /* Spheres */ ? model.coarseHierarchy.spheres : undefined).chainElementSegments;
                var chainsIt = _mol_data_int__WEBPACK_IMPORTED_MODULE_2__["Segmentation"].transientSegments(chainElementSegments, elements);
                while (chainsIt.hasNext) {
                    var chainSegment = chainsIt.move();
                    l.element = elements[chainSegment.start];
                    // test entity and chain
                    if (!entityTest(ctx) || !chainTest(ctx))
                        continue;
                    if (chainLevel) {
                        builder.addElementRange(elements, chainSegment.start, chainSegment.end);
                        continue;
                    }
                    for (var j = chainSegment.start, _j = chainSegment.end; j < _j; j++) {
                        l.element = elements[j];
                        // test residue/coarse element
                        if (residueTest(ctx)) {
                            builder.addElement(l.element);
                        }
                    }
                }
            }
            builder.commitUnit();
            ctx.throwIfTimedOut();
        }
        ctx.popCurrentElement();
        return _selection__WEBPACK_IMPORTED_MODULE_5__["StructureSelection"].Singletons(inputStructure, builder.getStructure());
    };
}
function atomGroupsGrouped(_a) {
    var unitTest = _a.unitTest, entityTest = _a.entityTest, chainTest = _a.chainTest, residueTest = _a.residueTest, atomTest = _a.atomTest, groupBy = _a.groupBy;
    return function query_atomGroupsGrouped(ctx) {
        var inputStructure = ctx.inputStructure;
        var units = inputStructure.units;
        var l = ctx.pushCurrentElement();
        var builder = new _utils_builders__WEBPACK_IMPORTED_MODULE_6__["LinearGroupingBuilder"](inputStructure);
        l.structure = inputStructure;
        for (var _a = 0, units_3 = units; _a < units_3.length; _a++) {
            var unit = units_3[_a];
            l.unit = unit;
            if (!unitTest(ctx))
                continue;
            var elements = unit.elements, model = unit.model;
            if (unit.kind === 0 /* Atomic */) {
                var chainsIt = _mol_data_int__WEBPACK_IMPORTED_MODULE_2__["Segmentation"].transientSegments(model.atomicHierarchy.chainAtomSegments, elements);
                var residuesIt = _mol_data_int__WEBPACK_IMPORTED_MODULE_2__["Segmentation"].transientSegments(model.atomicHierarchy.residueAtomSegments, elements);
                while (chainsIt.hasNext) {
                    var chainSegment = chainsIt.move();
                    l.element = elements[chainSegment.start];
                    // test entity and chain
                    if (!entityTest(ctx) || !chainTest(ctx))
                        continue;
                    residuesIt.setSegment(chainSegment);
                    while (residuesIt.hasNext) {
                        var residueSegment = residuesIt.move();
                        l.element = elements[residueSegment.start];
                        // test residue
                        if (!residueTest(ctx))
                            continue;
                        for (var j = residueSegment.start, _j = residueSegment.end; j < _j; j++) {
                            l.element = elements[j];
                            // test atom
                            if (atomTest(ctx)) {
                                builder.add(groupBy(ctx), unit.id, l.element);
                            }
                        }
                    }
                }
            }
            else {
                var chainElementSegments = (1 /* Spheres */ ? model.coarseHierarchy.spheres : undefined).chainElementSegments;
                var chainsIt = _mol_data_int__WEBPACK_IMPORTED_MODULE_2__["Segmentation"].transientSegments(chainElementSegments, elements);
                while (chainsIt.hasNext) {
                    var chainSegment = chainsIt.move();
                    l.element = elements[chainSegment.start];
                    // test entity and chain
                    if (!entityTest(ctx) || !chainTest(ctx))
                        continue;
                    for (var j = chainSegment.start, _j = chainSegment.end; j < _j; j++) {
                        l.element = elements[j];
                        // test residue/coarse element
                        if (residueTest(ctx)) {
                            builder.add(groupBy(ctx), unit.id, l.element);
                        }
                    }
                }
            }
            ctx.throwIfTimedOut();
        }
        ctx.popCurrentElement();
        return builder.getSelection();
    };
}
function getRingStructure(unit, ring, inputStructure) {
    var elements = new Int32Array(ring.length);
    for (var i = 0, _i = ring.length; i < _i; i++)
        elements[i] = unit.elements[ring[i]];
    return _structure_structure__WEBPACK_IMPORTED_MODULE_4__["default"].create([unit.getChild(_mol_data_int__WEBPACK_IMPORTED_MODULE_2__["SortedArray"].ofSortedArray(elements))], { parent: inputStructure });
}
function rings(fingerprints, onlyAromatic) {
    return function query_rings(ctx) {
        var units = ctx.inputStructure.units;
        var ret = _selection__WEBPACK_IMPORTED_MODULE_5__["StructureSelection"].LinearBuilder(ctx.inputStructure);
        if (!fingerprints || fingerprints.length === 0) {
            for (var _a = 0, units_4 = units; _a < units_4.length; _a++) {
                var u = units_4[_a];
                if (!_structure__WEBPACK_IMPORTED_MODULE_3__["Unit"].isAtomic(u))
                    continue;
                if (onlyAromatic) {
                    for (var _b = 0, _c = u.rings.aromaticRings; _b < _c.length; _b++) {
                        var r = _c[_b];
                        ret.add(getRingStructure(u, u.rings.all[r], ctx.inputStructure));
                    }
                }
                else {
                    for (var _d = 0, _e = u.rings.all; _d < _e.length; _d++) {
                        var r = _e[_d];
                        ret.add(getRingStructure(u, r, ctx.inputStructure));
                    }
                }
            }
        }
        else {
            var uniqueFps = _mol_data_generic__WEBPACK_IMPORTED_MODULE_1__["UniqueArray"].create();
            for (var i = 0; i < fingerprints.length; i++)
                _mol_data_generic__WEBPACK_IMPORTED_MODULE_1__["UniqueArray"].add(uniqueFps, fingerprints[i], fingerprints[i]);
            for (var _f = 0, units_5 = units; _f < units_5.length; _f++) {
                var u = units_5[_f];
                if (!_structure__WEBPACK_IMPORTED_MODULE_3__["Unit"].isAtomic(u))
                    continue;
                var rings_1 = u.rings;
                for (var _g = 0, _h = uniqueFps.array; _g < _h.length; _g++) {
                    var fp = _h[_g];
                    if (!rings_1.byFingerprint.has(fp))
                        continue;
                    for (var _k = 0, _l = rings_1.byFingerprint.get(fp); _k < _l.length; _k++) {
                        var r = _l[_k];
                        if (onlyAromatic && !rings_1.aromaticRings.includes(r))
                            continue;
                        ret.add(getRingStructure(u, rings_1.all[r], ctx.inputStructure));
                    }
                }
            }
        }
        return ret.getSelection();
    };
}
function querySelection(selection, query, inComplement) {
    if (inComplement === void 0) { inComplement = false; }
    return function query_querySelection(ctx) {
        var targetSel = selection(ctx);
        if (_selection__WEBPACK_IMPORTED_MODULE_5__["StructureSelection"].structureCount(targetSel) === 0)
            return targetSel;
        var target = inComplement
            ? Object(_utils_structure_set__WEBPACK_IMPORTED_MODULE_7__["structureSubtract"])(ctx.inputStructure, _selection__WEBPACK_IMPORTED_MODULE_5__["StructureSelection"].unionStructure(targetSel))
            : _selection__WEBPACK_IMPORTED_MODULE_5__["StructureSelection"].unionStructure(targetSel);
        if (target.elementCount === 0)
            return _selection__WEBPACK_IMPORTED_MODULE_5__["StructureSelection"].Empty(ctx.inputStructure);
        ctx.throwIfTimedOut();
        ctx.pushInputStructure(target);
        var result = query(ctx);
        ctx.popInputStructure();
        return _selection__WEBPACK_IMPORTED_MODULE_5__["StructureSelection"].withInputStructure(result, ctx.inputStructure);
    };
}
function bondedAtomicPairs(bondTest) {
    return function query_bondedAtomicPairs(ctx) {
        var structure = ctx.inputStructure;
        var interBonds = structure.interUnitBonds;
        // Note: each bond is called twice, that's why we need the unique builder.
        var ret = _selection__WEBPACK_IMPORTED_MODULE_5__["StructureSelection"].UniqueBuilder(ctx.inputStructure);
        ctx.pushCurrentBond();
        var atomicBond = ctx.atomicBond;
        atomicBond.setTestFn(bondTest);
        atomicBond.setStructure(structure);
        // Process intra unit bonds
        for (var _a = 0, _b = structure.units; _a < _b.length; _a++) {
            var unit = _b[_a];
            if (unit.kind !== 0 /* Atomic */)
                continue;
            var _c = unit.bonds, intraBondOffset = _c.offset, intraBondB = _c.b, _d = _c.edgeProps, flags = _d.flags, order = _d.order;
            atomicBond.a.unit = unit;
            atomicBond.b.unit = unit;
            for (var i = 0, _i = unit.elements.length; i < _i; i++) {
                atomicBond.aIndex = i;
                atomicBond.a.element = unit.elements[i];
                // check intra unit bonds
                for (var lI = intraBondOffset[i], _lI = intraBondOffset[i + 1]; lI < _lI; lI++) {
                    atomicBond.bIndex = intraBondB[lI];
                    atomicBond.b.element = unit.elements[intraBondB[lI]];
                    atomicBond.type = flags[lI];
                    atomicBond.order = order[lI];
                    // No need to "swap test" because each bond direction will be visited eventually.
                    if (atomicBond.test(ctx, false)) {
                        var b = structure.subsetBuilder(false);
                        b.beginUnit(unit.id);
                        b.addElement(atomicBond.a.element);
                        b.addElement(atomicBond.b.element);
                        b.commitUnit();
                        ret.add(b.getStructure());
                    }
                }
            }
        }
        // Process inter unit bonds
        for (var _e = 0, _f = interBonds.edges; _e < _f.length; _e++) {
            var bond = _f[_e];
            atomicBond.a.unit = structure.unitMap.get(bond.unitA);
            atomicBond.a.element = atomicBond.a.unit.elements[bond.indexA];
            atomicBond.aIndex = bond.indexA;
            atomicBond.b.unit = structure.unitMap.get(bond.unitA);
            atomicBond.b.element = atomicBond.b.unit.elements[bond.indexB];
            atomicBond.bIndex = bond.indexB;
            atomicBond.order = bond.props.order;
            atomicBond.type = bond.props.flag;
            // No need to "swap test" because each bond direction will be visited eventually.
            if (atomicBond.test(ctx, false)) {
                var b = structure.subsetBuilder(false);
                b.addToUnit(atomicBond.a.unit.id, atomicBond.a.element);
                b.addToUnit(atomicBond.b.unit.id, atomicBond.b.element);
                ret.add(b.getStructure());
            }
        }
        ctx.popCurrentBond();
        return ret.getSelection();
    };
}
//# sourceMappingURL=generators.js.map

/***/ }),

/***/ "./lib/mol-model/structure/query/queries/internal.js":
/*!***********************************************************!*\
  !*** ./lib/mol-model/structure/query/queries/internal.js ***!
  \***********************************************************/
/*! exports provided: defaultBondTest, atomicSequence, water, atomicHet, spheres, bundleElementImpl, bundleGenerator */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "defaultBondTest", function() { return defaultBondTest; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "atomicSequence", function() { return atomicSequence; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "water", function() { return water; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "atomicHet", function() { return atomicHet; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "spheres", function() { return spheres; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "bundleElementImpl", function() { return bundleElementImpl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "bundleGenerator", function() { return bundleGenerator; });
/* harmony import */ var _mol_data_int__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../../../mol-data/int */ "./lib/mol-data/int.js");
/* harmony import */ var _mol_model_structure_structure_element__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../../../mol-model/structure/structure/element */ "./lib/mol-model/structure/structure/element.js");
/* harmony import */ var _structure__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../structure */ "./lib/mol-model/structure/structure.js");
/* harmony import */ var _structure_structure__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../structure/structure */ "./lib/mol-model/structure/structure/structure.js");
/* harmony import */ var _selection__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../selection */ "./lib/mol-model/structure/query/selection.js");
/* harmony import */ var _model_types__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../model/types */ "./lib/mol-model/structure/model/types.js");
/* harmony import */ var _structure_element_bundle__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../../structure/element/bundle */ "./lib/mol-model/structure/structure/element/bundle.js");
/**
 * Copyright (c) 2017 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author David Sehnal <david.sehnal@gmail.com>
 */







function defaultBondTest(ctx) {
    return _model_types__WEBPACK_IMPORTED_MODULE_5__["BondType"].isCovalent(ctx.atomicBond.type);
}
function atomicSequence() {
    return function query_atomicSequence(ctx) {
        var inputStructure = ctx.inputStructure;
        var l = _mol_model_structure_structure_element__WEBPACK_IMPORTED_MODULE_1__["default"].Location.create(inputStructure);
        var units = [];
        for (var _i = 0, _a = inputStructure.units; _i < _a.length; _i++) {
            var unit = _a[_i];
            if (unit.kind !== 0 /* Atomic */)
                continue;
            l.unit = unit;
            var elements = unit.elements;
            l.element = elements[0];
            if (_structure__WEBPACK_IMPORTED_MODULE_2__["StructureProperties"].entity.type(l) !== 'polymer')
                continue;
            var residuesIt = _mol_data_int__WEBPACK_IMPORTED_MODULE_0__["Segmentation"].transientSegments(unit.model.atomicHierarchy.residueAtomSegments, elements);
            var residueCount = 0;
            while (residuesIt.hasNext) {
                residueCount++;
                residuesIt.move();
            }
            if (residueCount < 8)
                continue;
            units.push(unit);
        }
        return _selection__WEBPACK_IMPORTED_MODULE_4__["StructureSelection"].Singletons(inputStructure, new _structure_structure__WEBPACK_IMPORTED_MODULE_3__["default"](units, { parent: inputStructure }));
    };
}
function water() {
    return function query_water(ctx) {
        var inputStructure = ctx.inputStructure;
        var l = _mol_model_structure_structure_element__WEBPACK_IMPORTED_MODULE_1__["default"].Location.create(inputStructure);
        var units = [];
        for (var _i = 0, _a = inputStructure.units; _i < _a.length; _i++) {
            var unit = _a[_i];
            if (unit.kind !== 0 /* Atomic */)
                continue;
            l.unit = unit;
            var elements = unit.elements;
            l.element = elements[0];
            if (_structure__WEBPACK_IMPORTED_MODULE_2__["StructureProperties"].entity.type(l) !== 'water')
                continue;
            units.push(unit);
        }
        return _selection__WEBPACK_IMPORTED_MODULE_4__["StructureSelection"].Singletons(inputStructure, new _structure_structure__WEBPACK_IMPORTED_MODULE_3__["default"](units, { parent: inputStructure }));
    };
}
function atomicHet() {
    return function query_atomicHet(ctx) {
        var inputStructure = ctx.inputStructure;
        var l = _mol_model_structure_structure_element__WEBPACK_IMPORTED_MODULE_1__["default"].Location.create(inputStructure);
        var units = [];
        for (var _i = 0, _a = inputStructure.units; _i < _a.length; _i++) {
            var unit = _a[_i];
            if (unit.kind !== 0 /* Atomic */)
                continue;
            l.unit = unit;
            var elements = unit.elements;
            l.element = elements[0];
            if (_structure__WEBPACK_IMPORTED_MODULE_2__["StructureProperties"].entity.type(l) === 'water')
                continue;
            if (_structure__WEBPACK_IMPORTED_MODULE_2__["StructureProperties"].entity.type(l) === 'polymer') {
                var residuesIt = _mol_data_int__WEBPACK_IMPORTED_MODULE_0__["Segmentation"].transientSegments(unit.model.atomicHierarchy.residueAtomSegments, elements);
                var residueCount = 0;
                while (residuesIt.hasNext) {
                    residueCount++;
                    residuesIt.move();
                }
                if (residueCount >= 8)
                    continue;
            }
            units.push(unit);
        }
        return _selection__WEBPACK_IMPORTED_MODULE_4__["StructureSelection"].Singletons(inputStructure, new _structure_structure__WEBPACK_IMPORTED_MODULE_3__["default"](units, { parent: inputStructure }));
    };
}
function spheres() {
    return function query_spheres(ctx) {
        var inputStructure = ctx.inputStructure;
        var units = [];
        for (var _i = 0, _a = inputStructure.units; _i < _a.length; _i++) {
            var unit = _a[_i];
            if (unit.kind !== 1 /* Spheres */)
                continue;
            units.push(unit);
        }
        return _selection__WEBPACK_IMPORTED_MODULE_4__["StructureSelection"].Singletons(inputStructure, new _structure_structure__WEBPACK_IMPORTED_MODULE_3__["default"](units, { parent: inputStructure }));
    };
}
function bundleElementImpl(groupedUnits, ranges, set) {
    return {
        groupedUnits: groupedUnits,
        ranges: ranges,
        set: set
    };
}
function bundleGenerator(elements) {
    return function query_bundleGenerator(ctx) {
        var bundle = {
            hash: ctx.inputStructure.hashCode,
            elements: elements
        };
        return _selection__WEBPACK_IMPORTED_MODULE_4__["StructureSelection"].Sequence(ctx.inputStructure, [_structure_element_bundle__WEBPACK_IMPORTED_MODULE_6__["Bundle"].toStructure(bundle, ctx.inputStructure)]);
    };
}
//# sourceMappingURL=internal.js.map

/***/ }),

/***/ "./lib/mol-model/structure/query/queries/modifiers.js":
/*!************************************************************!*\
  !*** ./lib/mol-model/structure/query/queries/modifiers.js ***!
  \************************************************************/
/*! exports provided: wholeResidues, includeSurroundings, querySelection, intersectBy, exceptBy, union, expandProperty, includeConnected */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "wholeResidues", function() { return wholeResidues; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "includeSurroundings", function() { return includeSurroundings; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "querySelection", function() { return querySelection; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "intersectBy", function() { return intersectBy; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "exceptBy", function() { return exceptBy; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "union", function() { return union; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "expandProperty", function() { return expandProperty; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "includeConnected", function() { return includeConnected; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _mol_data_int__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../../../mol-data/int */ "./lib/mol-data/int.js");
/* harmony import */ var _selection__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../selection */ "./lib/mol-model/structure/query/selection.js");
/* harmony import */ var _utils_builders__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../utils/builders */ "./lib/mol-model/structure/query/utils/builders.js");
/* harmony import */ var _structure_util_unique_subset_builder__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../structure/util/unique-subset-builder */ "./lib/mol-model/structure/structure/util/unique-subset-builder.js");
/* harmony import */ var _utils_structure_set__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../utils/structure-set */ "./lib/mol-model/structure/query/utils/structure-set.js");
/* harmony import */ var _mol_data_generic__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../../../../mol-data/generic */ "./lib/mol-data/generic.js");
/**
 * Copyright (c) 2017-2020 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author David Sehnal <david.sehnal@gmail.com>
 */







function getWholeResidues(ctx, source, structure) {
    var builder = source.subsetBuilder(true);
    for (var _a = 0, _b = structure.units; _a < _b.length; _a++) {
        var unit = _b[_a];
        if (unit.kind !== 0 /* Atomic */) {
            // just copy non-atomic units.
            builder.setUnit(unit.id, unit.elements);
            continue;
        }
        var residueAtomSegments = unit.model.atomicHierarchy.residueAtomSegments;
        var sourceElements = source.unitMap.get(unit.id).elements;
        var elements = unit.elements;
        builder.beginUnit(unit.id);
        var residuesIt = _mol_data_int__WEBPACK_IMPORTED_MODULE_1__["Segmentation"].transientSegments(residueAtomSegments, elements);
        while (residuesIt.hasNext) {
            var rI = residuesIt.move().index;
            for (var j = residueAtomSegments.offsets[rI], _j = residueAtomSegments.offsets[rI + 1]; j < _j; j++) {
                if (_mol_data_int__WEBPACK_IMPORTED_MODULE_1__["SortedArray"].has(sourceElements, j))
                    builder.addElement(j);
            }
        }
        builder.commitUnit();
        ctx.throwIfTimedOut();
    }
    return builder.getStructure();
}
function wholeResidues(query) {
    return function query_wholeResidues(ctx) {
        var inner = query(ctx);
        if (_selection__WEBPACK_IMPORTED_MODULE_2__["StructureSelection"].isSingleton(inner)) {
            return _selection__WEBPACK_IMPORTED_MODULE_2__["StructureSelection"].Singletons(ctx.inputStructure, getWholeResidues(ctx, ctx.inputStructure, inner.structure));
        }
        else {
            var builder = new _utils_builders__WEBPACK_IMPORTED_MODULE_3__["UniqueStructuresBuilder"](ctx.inputStructure);
            for (var _a = 0, _b = inner.structures; _a < _b.length; _a++) {
                var s = _b[_a];
                builder.add(getWholeResidues(ctx, ctx.inputStructure, s));
            }
            return builder.getSelection();
        }
    };
}
function getIncludeSurroundings(ctx, source, structure, params) {
    var builder = new _structure_util_unique_subset_builder__WEBPACK_IMPORTED_MODULE_4__["StructureUniqueSubsetBuilder"](source);
    var lookup = source.lookup3d;
    var r = params.radius;
    for (var _a = 0, _b = structure.units; _a < _b.length; _a++) {
        var unit = _b[_a];
        var _c = unit.conformation, x = _c.x, y = _c.y, z = _c.z;
        var elements = unit.elements;
        for (var i = 0, _i = elements.length; i < _i; i++) {
            var e = elements[i];
            lookup.findIntoBuilder(x(e), y(e), z(e), r, builder);
        }
        ctx.throwIfTimedOut();
    }
    return !!params.wholeResidues ? getWholeResidues(ctx, source, builder.getStructure()) : builder.getStructure();
}
function getIncludeSurroundingsWithRadius(ctx, source, structure, params) {
    var builder = new _structure_util_unique_subset_builder__WEBPACK_IMPORTED_MODULE_4__["StructureUniqueSubsetBuilder"](source);
    var lookup = source.lookup3d;
    var elementRadius = params.elementRadius, elementRadiusClosure = params.elementRadiusClosure, sourceMaxRadius = params.sourceMaxRadius, radius = params.radius;
    ctx.pushCurrentElement();
    ctx.element.structure = structure;
    for (var _a = 0, _b = structure.units; _a < _b.length; _a++) {
        var unit = _b[_a];
        ctx.element.unit = unit;
        var _c = unit.conformation, x = _c.x, y = _c.y, z = _c.z;
        var elements = unit.elements;
        for (var i = 0, _i = elements.length; i < _i; i++) {
            var e = elements[i];
            ctx.element.element = e;
            var eRadius = elementRadius(ctx);
            lookup.findIntoBuilderWithRadius(x(e), y(e), z(e), eRadius, sourceMaxRadius, radius, elementRadiusClosure, builder);
        }
        ctx.throwIfTimedOut();
    }
    ctx.popCurrentElement();
    return !!params.wholeResidues ? getWholeResidues(ctx, source, builder.getStructure()) : builder.getStructure();
}
function createElementRadiusFn(ctx, eRadius) {
    return function (e) {
        ctx.element.structure = e.structure;
        ctx.element.unit = e.unit;
        ctx.element.element = e.element;
        return eRadius(ctx);
    };
}
function findStructureRadius(ctx, eRadius) {
    var r = 0;
    ctx.element.structure = ctx.inputStructure;
    for (var _a = 0, _b = ctx.inputStructure.units; _a < _b.length; _a++) {
        var unit = _b[_a];
        ctx.element.unit = unit;
        var elements = unit.elements;
        for (var i = 0, _i = elements.length; i < _i; i++) {
            var e = elements[i];
            ctx.element.element = e;
            var eR = eRadius(ctx);
            if (eR > r)
                r = eR;
        }
    }
    ctx.throwIfTimedOut();
    return r;
}
function includeSurroundings(query, params) {
    return function query_includeSurroundings(ctx) {
        var inner = query(ctx);
        if (params.elementRadius) {
            var prms = Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, params), { elementRadius: params.elementRadius, elementRadiusClosure: createElementRadiusFn(ctx, params.elementRadius), sourceMaxRadius: findStructureRadius(ctx, params.elementRadius) });
            if (_selection__WEBPACK_IMPORTED_MODULE_2__["StructureSelection"].isSingleton(inner)) {
                var surr = getIncludeSurroundingsWithRadius(ctx, ctx.inputStructure, inner.structure, prms);
                var ret = _selection__WEBPACK_IMPORTED_MODULE_2__["StructureSelection"].Singletons(ctx.inputStructure, surr);
                return ret;
            }
            else {
                var builder = new _utils_builders__WEBPACK_IMPORTED_MODULE_3__["UniqueStructuresBuilder"](ctx.inputStructure);
                for (var _a = 0, _b = inner.structures; _a < _b.length; _a++) {
                    var s = _b[_a];
                    builder.add(getIncludeSurroundingsWithRadius(ctx, ctx.inputStructure, s, prms));
                }
                return builder.getSelection();
            }
        }
        if (_selection__WEBPACK_IMPORTED_MODULE_2__["StructureSelection"].isSingleton(inner)) {
            var surr = getIncludeSurroundings(ctx, ctx.inputStructure, inner.structure, params);
            var ret = _selection__WEBPACK_IMPORTED_MODULE_2__["StructureSelection"].Singletons(ctx.inputStructure, surr);
            return ret;
        }
        else {
            var builder = new _utils_builders__WEBPACK_IMPORTED_MODULE_3__["UniqueStructuresBuilder"](ctx.inputStructure);
            for (var _c = 0, _d = inner.structures; _c < _d.length; _c++) {
                var s = _d[_c];
                builder.add(getIncludeSurroundings(ctx, ctx.inputStructure, s, params));
            }
            return builder.getSelection();
        }
    };
}
function querySelection(selection, query) {
    return function query_querySelection(ctx) {
        var targetSel = selection(ctx);
        if (_selection__WEBPACK_IMPORTED_MODULE_2__["StructureSelection"].structureCount(targetSel) === 0)
            return targetSel;
        var ret = _selection__WEBPACK_IMPORTED_MODULE_2__["StructureSelection"].UniqueBuilder(ctx.inputStructure);
        var add = function (s) { return ret.add(s); };
        _selection__WEBPACK_IMPORTED_MODULE_2__["StructureSelection"].forEach(targetSel, function (s, sI) {
            ctx.pushInputStructure(s);
            _selection__WEBPACK_IMPORTED_MODULE_2__["StructureSelection"].forEach(query(ctx), add);
            ctx.popInputStructure();
            if (sI % 10 === 0)
                ctx.throwIfTimedOut();
        });
        return ret.getSelection();
    };
}
function intersectBy(query, by) {
    return function query_intersectBy(ctx) {
        var selection = query(ctx);
        if (_selection__WEBPACK_IMPORTED_MODULE_2__["StructureSelection"].structureCount(selection) === 0)
            return selection;
        var bySel = by(ctx);
        if (_selection__WEBPACK_IMPORTED_MODULE_2__["StructureSelection"].structureCount(bySel) === 0)
            return _selection__WEBPACK_IMPORTED_MODULE_2__["StructureSelection"].Empty(ctx.inputStructure);
        var unionBy = _selection__WEBPACK_IMPORTED_MODULE_2__["StructureSelection"].unionStructure(bySel);
        var ret = _selection__WEBPACK_IMPORTED_MODULE_2__["StructureSelection"].UniqueBuilder(ctx.inputStructure);
        _selection__WEBPACK_IMPORTED_MODULE_2__["StructureSelection"].forEach(selection, function (s, sI) {
            var ii = Object(_utils_structure_set__WEBPACK_IMPORTED_MODULE_5__["structureIntersect"])(unionBy, s);
            if (ii.elementCount !== 0)
                ret.add(ii);
            if (sI % 50 === 0)
                ctx.throwIfTimedOut();
        });
        return ret.getSelection();
    };
}
function exceptBy(query, by) {
    return function query_exceptBy(ctx) {
        var selection = query(ctx);
        if (_selection__WEBPACK_IMPORTED_MODULE_2__["StructureSelection"].structureCount(selection) === 0)
            return selection;
        var bySel = by(ctx);
        if (_selection__WEBPACK_IMPORTED_MODULE_2__["StructureSelection"].structureCount(bySel) === 0)
            return selection;
        var subtractBy = _selection__WEBPACK_IMPORTED_MODULE_2__["StructureSelection"].unionStructure(bySel);
        var ret = _selection__WEBPACK_IMPORTED_MODULE_2__["StructureSelection"].UniqueBuilder(ctx.inputStructure);
        _selection__WEBPACK_IMPORTED_MODULE_2__["StructureSelection"].forEach(selection, function (s, sI) {
            var diff = Object(_utils_structure_set__WEBPACK_IMPORTED_MODULE_5__["structureSubtract"])(s, subtractBy);
            if (diff.elementCount !== 0)
                ret.add(diff);
            if (sI % 50 === 0)
                ctx.throwIfTimedOut();
        });
        return ret.getSelection();
    };
}
function union(query) {
    return function query_union(ctx) {
        var ret = _selection__WEBPACK_IMPORTED_MODULE_2__["StructureSelection"].LinearBuilder(ctx.inputStructure);
        ret.add(_selection__WEBPACK_IMPORTED_MODULE_2__["StructureSelection"].unionStructure(query(ctx)));
        return ret.getSelection();
    };
}
function expandProperty(query, property) {
    return function query_expandProperty(ctx) {
        var src = query(ctx);
        var propertyToStructureIndexMap = new Map();
        var builders = [];
        ctx.pushCurrentElement();
        _selection__WEBPACK_IMPORTED_MODULE_2__["StructureSelection"].forEach(src, function (s, sI) {
            ctx.element.structure = s;
            for (var _a = 0, _b = s.units; _a < _b.length; _a++) {
                var unit = _b[_a];
                ctx.element.unit = unit;
                var elements = unit.elements;
                for (var i = 0, _i = elements.length; i < _i; i++) {
                    ctx.element.element = elements[i];
                    var p = property(ctx);
                    var arr = void 0;
                    if (propertyToStructureIndexMap.has(p))
                        arr = propertyToStructureIndexMap.get(p);
                    else {
                        arr = _mol_data_generic__WEBPACK_IMPORTED_MODULE_6__["UniqueArray"].create();
                        propertyToStructureIndexMap.set(p, arr);
                    }
                    _mol_data_generic__WEBPACK_IMPORTED_MODULE_6__["UniqueArray"].add(arr, sI, sI);
                }
            }
            builders[sI] = ctx.inputStructure.subsetBuilder(true);
            if (sI % 10 === 0)
                ctx.throwIfTimedOut();
        });
        ctx.element.structure = ctx.inputStructure;
        for (var _a = 0, _b = ctx.inputStructure.units; _a < _b.length; _a++) {
            var unit = _b[_a];
            ctx.element.unit = unit;
            var elements = unit.elements;
            for (var i = 0, _i = elements.length; i < _i; i++) {
                ctx.element.element = elements[i];
                var p = property(ctx);
                if (!propertyToStructureIndexMap.has(p))
                    continue;
                var indices = propertyToStructureIndexMap.get(p).array;
                for (var _sI = 0, __sI = indices.length; _sI < __sI; _sI++) {
                    builders[indices[_sI]].addToUnit(unit.id, elements[i]);
                }
            }
        }
        ctx.popCurrentElement();
        var ret = _selection__WEBPACK_IMPORTED_MODULE_2__["StructureSelection"].UniqueBuilder(ctx.inputStructure);
        for (var _c = 0, builders_1 = builders; _c < builders_1.length; _c++) {
            var b = builders_1[_c];
            ret.add(b.getStructure());
        }
        return ret.getSelection();
    };
}
function includeConnected(_a) {
    var query = _a.query, layerCount = _a.layerCount, wholeResidues = _a.wholeResidues, bondTest = _a.bondTest;
    var lc = Math.max(layerCount, 0);
    return function query_includeConnected(ctx) {
        var builder = _selection__WEBPACK_IMPORTED_MODULE_2__["StructureSelection"].UniqueBuilder(ctx.inputStructure);
        var src = query(ctx);
        ctx.pushCurrentBond();
        ctx.atomicBond.setTestFn(bondTest);
        _selection__WEBPACK_IMPORTED_MODULE_2__["StructureSelection"].forEach(src, function (s, sI) {
            var incl = s;
            for (var i = 0; i < lc; i++) {
                incl = includeConnectedStep(ctx, wholeResidues, incl);
            }
            builder.add(incl);
            if (sI % 10 === 0)
                ctx.throwIfTimedOut();
        });
        ctx.popCurrentBond();
        return builder.getSelection();
    };
}
function includeConnectedStep(ctx, wholeResidues, structure) {
    var expanded = expandConnected(ctx, structure);
    if (wholeResidues)
        return getWholeResidues(ctx, ctx.inputStructure, expanded);
    return expanded;
}
function expandConnected(ctx, structure) {
    var inputStructure = ctx.inputStructure;
    var interBonds = inputStructure.interUnitBonds;
    var builder = new _structure_util_unique_subset_builder__WEBPACK_IMPORTED_MODULE_4__["StructureUniqueSubsetBuilder"](inputStructure);
    var atomicBond = ctx.atomicBond;
    // Process intra unit bonds
    for (var _a = 0, _b = structure.units; _a < _b.length; _a++) {
        var unit = _b[_a];
        if (unit.kind !== 0 /* Atomic */) {
            // add the whole unit
            builder.beginUnit(unit.id);
            for (var i = 0, _i = unit.elements.length; i < _i; i++) {
                builder.addElement(unit.elements[i]);
            }
            builder.commitUnit();
            continue;
        }
        var inputUnitA = inputStructure.unitMap.get(unit.id);
        var _c = inputUnitA.bonds, intraBondOffset = _c.offset, intraBondB = _c.b, _d = _c.edgeProps, flags = _d.flags, order = _d.order;
        atomicBond.setStructure(inputStructure);
        // Process intra unit bonds
        atomicBond.a.unit = inputUnitA;
        atomicBond.b.unit = inputUnitA;
        for (var i = 0, _i = unit.elements.length; i < _i; i++) {
            // add the current element
            builder.addToUnit(unit.id, unit.elements[i]);
            var aIndex = _mol_data_int__WEBPACK_IMPORTED_MODULE_1__["SortedArray"].indexOf(inputUnitA.elements, unit.elements[i]);
            // check intra unit bonds
            for (var lI = intraBondOffset[aIndex], _lI = intraBondOffset[aIndex + 1]; lI < _lI; lI++) {
                var bIndex = intraBondB[lI];
                var bElement = inputUnitA.elements[bIndex];
                // Check if the element is already present:
                if (_mol_data_int__WEBPACK_IMPORTED_MODULE_1__["SortedArray"].has(unit.elements, bElement) || builder.has(unit.id, bElement))
                    continue;
                atomicBond.aIndex = aIndex;
                atomicBond.a.element = unit.elements[i];
                atomicBond.bIndex = bIndex;
                atomicBond.b.element = bElement;
                atomicBond.type = flags[lI];
                atomicBond.order = order[lI];
                if (atomicBond.test(ctx, true)) {
                    builder.addToUnit(unit.id, bElement);
                }
            }
        }
        // Process inter unit bonds
        for (var _e = 0, _f = interBonds.getConnectedUnits(inputUnitA.id); _e < _f.length; _e++) {
            var bondedUnit = _f[_e];
            var currentUnitB = structure.unitMap.get(bondedUnit.unitB);
            var inputUnitB = inputStructure.unitMap.get(bondedUnit.unitB);
            for (var _g = 0, _h = bondedUnit.connectedIndices; _g < _h.length; _g++) {
                var aI = _h[_g];
                // check if the element is in the expanded structure
                if (!_mol_data_int__WEBPACK_IMPORTED_MODULE_1__["SortedArray"].has(unit.elements, inputUnitA.elements[aI]))
                    continue;
                for (var _k = 0, _l = bondedUnit.getEdges(aI); _k < _l.length; _k++) {
                    var bond = _l[_k];
                    var bElement = inputUnitB.elements[bond.indexB];
                    // Check if the element is already present:
                    if ((currentUnitB && _mol_data_int__WEBPACK_IMPORTED_MODULE_1__["SortedArray"].has(currentUnitB.elements, bElement)) || builder.has(bondedUnit.unitB, bElement))
                        continue;
                    atomicBond.a.unit = inputUnitA;
                    atomicBond.aIndex = aI;
                    atomicBond.a.element = inputUnitA.elements[aI];
                    atomicBond.b.unit = inputUnitB;
                    atomicBond.bIndex = bond.indexB;
                    atomicBond.b.element = bElement;
                    atomicBond.type = bond.props.flag;
                    atomicBond.order = bond.props.order;
                    if (atomicBond.test(ctx, true)) {
                        builder.addToUnit(bondedUnit.unitB, bElement);
                    }
                }
            }
        }
    }
    return builder.getStructure();
}
// TODO: unionBy (skip this one?), cluster
//# sourceMappingURL=modifiers.js.map

/***/ }),

/***/ "./lib/mol-model/structure/query/query.js":
/*!************************************************!*\
  !*** ./lib/mol-model/structure/query/query.js ***!
  \************************************************/
/*! exports provided: StructureQuery */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "StructureQuery", function() { return StructureQuery; });
/* harmony import */ var _context__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./context */ "./lib/mol-model/structure/query/context.js");
/**
 * Copyright (c) 2017 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author David Sehnal <david.sehnal@gmail.com>
 */

var StructureQuery;
(function (StructureQuery) {
    function run(query, structure, options) {
        return query(new _context__WEBPACK_IMPORTED_MODULE_0__["QueryContext"](structure, options));
    }
    StructureQuery.run = run;
})(StructureQuery || (StructureQuery = {}));

//# sourceMappingURL=query.js.map

/***/ }),

/***/ "./lib/mol-model/structure/query/selection.js":
/*!****************************************************!*\
  !*** ./lib/mol-model/structure/query/selection.js ***!
  \****************************************************/
/*! exports provided: StructureSelection */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "StructureSelection", function() { return StructureSelection; });
/* harmony import */ var _mol_data_generic__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../../mol-data/generic */ "./lib/mol-data/generic.js");
/* harmony import */ var _structure__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../structure */ "./lib/mol-model/structure/structure.js");
/* harmony import */ var _utils_structure_set__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./utils/structure-set */ "./lib/mol-model/structure/query/utils/structure-set.js");
/* harmony import */ var _mol_data_int__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../../mol-data/int */ "./lib/mol-data/int.js");
/**
 * Copyright (c) 2017 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author David Sehnal <david.sehnal@gmail.com>
 */




var StructureSelection;
(function (StructureSelection) {
    function Singletons(source, structure) { return { kind: 'singletons', source: source, structure: structure }; }
    StructureSelection.Singletons = Singletons;
    function Sequence(source, structures) { return { kind: 'sequence', source: source, structures: structures }; }
    StructureSelection.Sequence = Sequence;
    function Empty(source) { return Singletons(source, _structure__WEBPACK_IMPORTED_MODULE_1__["Structure"].Empty); }
    StructureSelection.Empty = Empty;
    ;
    function isSingleton(s) { return s.kind === 'singletons'; }
    StructureSelection.isSingleton = isSingleton;
    function isEmpty(s) { return isSingleton(s) ? s.structure.units.length === 0 : s.structures.length === 0; }
    StructureSelection.isEmpty = isEmpty;
    function structureCount(sel) {
        if (isSingleton(sel))
            return sel.structure.elementCount;
        return sel.structures.length;
    }
    StructureSelection.structureCount = structureCount;
    function unionStructure(sel) {
        if (isEmpty(sel))
            return _structure__WEBPACK_IMPORTED_MODULE_1__["Structure"].Empty;
        if (isSingleton(sel))
            return sel.structure;
        return Object(_utils_structure_set__WEBPACK_IMPORTED_MODULE_2__["structureUnion"])(sel.source, sel.structures);
    }
    StructureSelection.unionStructure = unionStructure;
    /** Convert selection to loci and use "current structure units" in Loci elements */
    function toLociWithCurrentUnits(sel) {
        var elements = [];
        var unitMap = sel.source.unitMap;
        for (var _a = 0, _b = unionStructure(sel).units; _a < _b.length; _a++) {
            var unit = _b[_a];
            if (unit === unitMap.get(unit.id)) {
                elements[elements.length] = {
                    unit: unit,
                    indices: _mol_data_int__WEBPACK_IMPORTED_MODULE_3__["OrderedSet"].ofBounds(0, unit.elements.length)
                };
            }
            else {
                elements[elements.length] = {
                    unit: unit,
                    indices: _mol_data_int__WEBPACK_IMPORTED_MODULE_3__["OrderedSet"].ofSortedArray(_mol_data_int__WEBPACK_IMPORTED_MODULE_3__["SortedArray"].indicesOf(unitMap.get(unit.id).elements, unit.elements))
                };
            }
        }
        return _structure__WEBPACK_IMPORTED_MODULE_1__["StructureElement"].Loci(sel.source, elements);
    }
    StructureSelection.toLociWithCurrentUnits = toLociWithCurrentUnits;
    /** use source unit in loci.elements */
    function toLociWithSourceUnits(sel) {
        var elements = [];
        var unitMap = sel.source.unitMap;
        for (var _a = 0, _b = unionStructure(sel).units; _a < _b.length; _a++) {
            var _unit = _b[_a];
            var unit = unitMap.get(_unit.id);
            if (unit === _unit) {
                elements[elements.length] = {
                    unit: unit,
                    indices: _mol_data_int__WEBPACK_IMPORTED_MODULE_3__["OrderedSet"].ofBounds(0, unit.elements.length)
                };
            }
            else {
                elements[elements.length] = {
                    unit: unit,
                    indices: _mol_data_int__WEBPACK_IMPORTED_MODULE_3__["OrderedSet"].ofSortedArray(_mol_data_int__WEBPACK_IMPORTED_MODULE_3__["SortedArray"].indicesOf(unit.elements, _unit.elements))
                };
            }
        }
        return _structure__WEBPACK_IMPORTED_MODULE_1__["StructureElement"].Loci(sel.source, elements);
    }
    StructureSelection.toLociWithSourceUnits = toLociWithSourceUnits;
    function getSelection(source, structures, allSingletons) {
        var len = structures.length;
        if (len === 0)
            return Empty(source);
        if (allSingletons)
            return Singletons(source, Object(_utils_structure_set__WEBPACK_IMPORTED_MODULE_2__["structureUnion"])(source, structures));
        return Sequence(source, structures);
    }
    var LinearBuilderImpl = /** @class */ (function () {
        function LinearBuilderImpl(source) {
            this.source = source;
            this.structures = [];
            this.allSingletons = true;
        }
        LinearBuilderImpl.prototype.add = function (structure) {
            var elementCount = structure.elementCount;
            if (elementCount === 0)
                return;
            this.structures[this.structures.length] = structure;
            if (elementCount !== 1)
                this.allSingletons = false;
        };
        LinearBuilderImpl.prototype.getSelection = function () { return getSelection(this.source, this.structures, this.allSingletons); };
        return LinearBuilderImpl;
    }());
    var HashBuilderImpl = /** @class */ (function () {
        function HashBuilderImpl(structure) {
            this.structure = structure;
            this.structures = [];
            this.allSingletons = true;
            this.uniqueSets = Object(_mol_data_generic__WEBPACK_IMPORTED_MODULE_0__["HashSet"])(_structure__WEBPACK_IMPORTED_MODULE_1__["Structure"].hashCode, _structure__WEBPACK_IMPORTED_MODULE_1__["Structure"].areUnitIdsAndIndicesEqual);
        }
        HashBuilderImpl.prototype.add = function (structure) {
            var atomCount = structure.elementCount;
            if (atomCount === 0 || !this.uniqueSets.add(structure))
                return;
            this.structures[this.structures.length] = structure;
            if (atomCount !== 1)
                this.allSingletons = false;
        };
        HashBuilderImpl.prototype.getSelection = function () { return getSelection(this.structure, this.structures, this.allSingletons); };
        return HashBuilderImpl;
    }());
    function LinearBuilder(structure) { return new LinearBuilderImpl(structure); }
    StructureSelection.LinearBuilder = LinearBuilder;
    function UniqueBuilder(structure) { return new HashBuilderImpl(structure); }
    StructureSelection.UniqueBuilder = UniqueBuilder;
    // TODO: build timeout checking into this?
    function forEach(sel, fn) {
        var idx = 0;
        if (StructureSelection.isSingleton(sel)) {
            for (var _a = 0, _b = sel.structure.units; _a < _b.length; _a++) {
                var unit = _b[_a];
                var elements = unit.elements;
                for (var i = 0, _i = elements.length; i < _i; i++) {
                    // TODO: optimize this somehow???
                    var s = _structure__WEBPACK_IMPORTED_MODULE_1__["Structure"].create([unit.getChild(_mol_data_int__WEBPACK_IMPORTED_MODULE_3__["SortedArray"].ofSingleton(elements[i]))], { parent: sel.source });
                    fn(s, idx++);
                }
            }
        }
        else {
            for (var _c = 0, _d = sel.structures; _c < _d.length; _c++) {
                var s = _d[_c];
                fn(s, idx++);
            }
        }
    }
    StructureSelection.forEach = forEach;
    function withInputStructure(selection, structure) {
        if (isSingleton(selection))
            return Singletons(structure, selection.structure);
        return Sequence(structure, selection.structures);
    }
    StructureSelection.withInputStructure = withInputStructure;
    // TODO: spatial lookup?
})(StructureSelection || (StructureSelection = {}));

//# sourceMappingURL=selection.js.map

/***/ }),

/***/ "./lib/mol-model/structure/query/utils/builders.js":
/*!*********************************************************!*\
  !*** ./lib/mol-model/structure/query/utils/builders.js ***!
  \*********************************************************/
/*! exports provided: UniqueStructuresBuilder, LinearGroupingBuilder */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "UniqueStructuresBuilder", function() { return UniqueStructuresBuilder; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "LinearGroupingBuilder", function() { return LinearGroupingBuilder; });
/* harmony import */ var _structure__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../structure */ "./lib/mol-model/structure/structure.js");
/* harmony import */ var _selection__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../selection */ "./lib/mol-model/structure/query/selection.js");
/* harmony import */ var _mol_data_generic__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../../../mol-data/generic */ "./lib/mol-data/generic.js");
/* harmony import */ var _structure_set__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./structure-set */ "./lib/mol-model/structure/query/utils/structure-set.js");
/**
 * Copyright (c) 2017 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author David Sehnal <david.sehnal@gmail.com>
 */




var UniqueStructuresBuilder = /** @class */ (function () {
    function UniqueStructuresBuilder(source) {
        this.source = source;
        this.set = Object(_mol_data_generic__WEBPACK_IMPORTED_MODULE_2__["HashSet"])(_structure__WEBPACK_IMPORTED_MODULE_0__["Structure"].hashCode, _structure__WEBPACK_IMPORTED_MODULE_0__["Structure"].areUnitIdsAndIndicesEqual);
        this.structures = [];
        this.allSingletons = true;
    }
    UniqueStructuresBuilder.prototype.add = function (s) {
        if (!s.elementCount)
            return;
        if (s.elementCount !== 1)
            this.allSingletons = false;
        if (this.set.add(s)) {
            this.structures[this.structures.length] = s;
        }
    };
    UniqueStructuresBuilder.prototype.getSelection = function () {
        if (this.allSingletons)
            return _selection__WEBPACK_IMPORTED_MODULE_1__["StructureSelection"].Singletons(this.source, Object(_structure_set__WEBPACK_IMPORTED_MODULE_3__["structureUnion"])(this.source, this.structures));
        return _selection__WEBPACK_IMPORTED_MODULE_1__["StructureSelection"].Sequence(this.source, this.structures);
    };
    return UniqueStructuresBuilder;
}());

var LinearGroupingBuilder = /** @class */ (function () {
    function LinearGroupingBuilder(source) {
        this.source = source;
        this.builders = [];
        this.builderMap = new Map();
    }
    LinearGroupingBuilder.prototype.add = function (key, unit, element) {
        var b = this.builderMap.get(key);
        if (!b) {
            b = this.source.subsetBuilder(true);
            this.builders[this.builders.length] = b;
            this.builderMap.set(key, b);
        }
        b.addToUnit(unit, element);
    };
    LinearGroupingBuilder.prototype.allSingletons = function () {
        for (var i = 0, _i = this.builders.length; i < _i; i++) {
            if (this.builders[i].elementCount > 1)
                return false;
        }
        return true;
    };
    LinearGroupingBuilder.prototype.singletonSelection = function () {
        var builder = this.source.subsetBuilder(true);
        var loc = _structure__WEBPACK_IMPORTED_MODULE_0__["StructureElement"].Location.create(this.source);
        for (var i = 0, _i = this.builders.length; i < _i; i++) {
            this.builders[i].setSingletonLocation(loc);
            builder.addToUnit(loc.unit.id, loc.element);
        }
        return _selection__WEBPACK_IMPORTED_MODULE_1__["StructureSelection"].Singletons(this.source, builder.getStructure());
    };
    LinearGroupingBuilder.prototype.fullSelection = function () {
        var structures = new Array(this.builders.length);
        for (var i = 0, _i = this.builders.length; i < _i; i++) {
            structures[i] = this.builders[i].getStructure();
        }
        return _selection__WEBPACK_IMPORTED_MODULE_1__["StructureSelection"].Sequence(this.source, structures);
    };
    LinearGroupingBuilder.prototype.getSelection = function () {
        var len = this.builders.length;
        if (len === 0)
            return _selection__WEBPACK_IMPORTED_MODULE_1__["StructureSelection"].Empty(this.source);
        if (this.allSingletons())
            return this.singletonSelection();
        return this.fullSelection();
    };
    return LinearGroupingBuilder;
}());

//# sourceMappingURL=builders.js.map

/***/ }),

/***/ "./lib/mol-model/structure/query/utils/structure-distance.js":
/*!*******************************************************************!*\
  !*** ./lib/mol-model/structure/query/utils/structure-distance.js ***!
  \*******************************************************************/
/*! exports provided: checkStructureMinMaxDistance, checkStructureMaxRadiusDistance */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "checkStructureMinMaxDistance", function() { return checkStructureMinMaxDistance; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "checkStructureMaxRadiusDistance", function() { return checkStructureMaxRadiusDistance; });
/* harmony import */ var _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../../../mol-math/linear-algebra */ "./lib/mol-math/linear-algebra.js");
/**
 * Copyright (c) 2017 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author David Sehnal <david.sehnal@gmail.com>
 */

function checkStructureMinMaxDistance(ctx, a, b, minDist, maxDist, elementRadius) {
    if (a.elementCount === 0 || b.elementCount === 0)
        return true;
    if (a.elementCount <= b.elementCount)
        return MinMaxDist.check(ctx, a, b, minDist, maxDist, elementRadius);
    return MinMaxDist.check(ctx, b, a, minDist, maxDist, elementRadius);
}
function checkStructureMaxRadiusDistance(ctx, a, b, maxDist, elementRadius) {
    if (a.elementCount === 0 || b.elementCount === 0)
        return true;
    if (a.elementCount <= b.elementCount)
        return MaxRadiusDist.check(ctx, a, b, maxDist, elementRadius);
    return MaxRadiusDist.check(ctx, b, a, maxDist, elementRadius);
}
var MinMaxDist;
(function (MinMaxDist) {
    var distVec = _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"].zero();
    function inUnit(ctx, unit, p, eRadius, minDist, maxDist, elementRadius) {
        var elements = unit.elements, position = unit.conformation.position, dV = distVec;
        ctx.element.unit = unit;
        var withinRange = false;
        for (var i = 0, _i = elements.length; i < _i; i++) {
            var e = elements[i];
            ctx.element.element = e;
            var d = Math.max(0, _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"].distance(p, position(e, dV)) - eRadius - elementRadius(ctx));
            if (d < minDist)
                return 0 /* BelowMin */;
            if (d < maxDist)
                withinRange = true;
        }
        return withinRange ? 1 /* WithinMax */ : 2 /* Miss */;
    }
    function toPoint(ctx, s, point, radius, minDist, maxDist, elementRadius) {
        var units = s.units;
        var withinRange = false;
        for (var i = 0, _i = units.length; i < _i; i++) {
            var iu = inUnit(ctx, units[i], point, radius, minDist, maxDist, elementRadius);
            if (iu === 0 /* BelowMin */)
                return 0 /* BelowMin */;
            if (iu === 1 /* WithinMax */)
                withinRange = true;
        }
        return withinRange ? 1 /* WithinMax */ : 2 /* Miss */;
    }
    MinMaxDist.toPoint = toPoint;
    var distPivot = _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"].zero();
    function check(ctx, a, b, minDist, maxDist, elementRadius) {
        if (a.elementCount === 0 || b.elementCount === 0)
            return 0;
        var units = a.units;
        var withinRange = false;
        ctx.element.structure = a;
        for (var i = 0, _i = units.length; i < _i; i++) {
            var unit = units[i];
            var elements = unit.elements, position = unit.conformation.position;
            ctx.element.unit = unit;
            for (var i_1 = 0, _i_1 = elements.length; i_1 < _i_1; i_1++) {
                var e = elements[i_1];
                ctx.element.element = e;
                var tp = toPoint(ctx, b, position(e, distPivot), elementRadius(ctx), minDist, maxDist, elementRadius);
                if (tp === 0 /* BelowMin */)
                    return 0 /* BelowMin */;
                if (tp === 1 /* WithinMax */)
                    withinRange = true;
            }
        }
        return withinRange;
    }
    MinMaxDist.check = check;
})(MinMaxDist || (MinMaxDist = {}));
var MaxRadiusDist;
(function (MaxRadiusDist) {
    var distVec = _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"].zero();
    function inUnit(ctx, unit, p, eRadius, maxDist, elementRadius) {
        var elements = unit.elements, position = unit.conformation.position, dV = distVec;
        ctx.element.unit = unit;
        for (var i = 0, _i = elements.length; i < _i; i++) {
            var e = elements[i];
            ctx.element.element = e;
            if (Math.max(0, _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"].distance(p, position(e, dV)) - eRadius - elementRadius(ctx)) <= maxDist)
                return true;
        }
        return false;
    }
    function toPoint(ctx, s, point, radius, maxDist, elementRadius) {
        var units = s.units;
        for (var i = 0, _i = units.length; i < _i; i++) {
            if (inUnit(ctx, units[i], point, radius, maxDist, elementRadius))
                return true;
        }
        return false;
    }
    MaxRadiusDist.toPoint = toPoint;
    var distPivot = _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"].zero();
    function check(ctx, a, b, maxDist, elementRadius) {
        if (a.elementCount === 0 || b.elementCount === 0)
            return 0;
        var units = a.units;
        ctx.element.structure = a;
        for (var i = 0, _i = units.length; i < _i; i++) {
            var unit = units[i];
            ctx.element.unit = unit;
            var elements = unit.elements, position = unit.conformation.position;
            for (var i_2 = 0, _i_2 = elements.length; i_2 < _i_2; i_2++) {
                var e = elements[i_2];
                ctx.element.element = e;
                if (toPoint(ctx, b, position(e, distPivot), elementRadius(ctx), maxDist, elementRadius))
                    return true;
            }
        }
        return false;
    }
    MaxRadiusDist.check = check;
})(MaxRadiusDist || (MaxRadiusDist = {}));
//# sourceMappingURL=structure-distance.js.map

/***/ }),

/***/ "./lib/mol-model/structure/query/utils/structure-set.js":
/*!**************************************************************!*\
  !*** ./lib/mol-model/structure/query/utils/structure-set.js ***!
  \**************************************************************/
/*! exports provided: structureUnion, structureAreEqual, structureAreIntersecting, structureIntersect, structureSubtract */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "structureUnion", function() { return structureUnion; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "structureAreEqual", function() { return structureAreEqual; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "structureAreIntersecting", function() { return structureAreIntersecting; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "structureIntersect", function() { return structureIntersect; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "structureSubtract", function() { return structureSubtract; });
/* harmony import */ var _structure__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../structure */ "./lib/mol-model/structure/structure.js");
/* harmony import */ var _mol_data_int__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../../../mol-data/int */ "./lib/mol-data/int.js");
/**
 * Copyright (c) 2017 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author David Sehnal <david.sehnal@gmail.com>
 */


function structureUnion(source, structures) {
    if (structures.length === 0)
        return _structure__WEBPACK_IMPORTED_MODULE_0__["Structure"].Empty;
    if (structures.length === 1)
        return structures[0];
    var unitMap = new Map();
    var fullUnits = new Set();
    for (var _a = 0, structures_1 = structures; _a < structures_1.length; _a++) {
        var units = structures_1[_a].units;
        for (var i = 0, _i = units.length; i < _i; i++) {
            var u = units[i];
            if (unitMap.has(u.id)) {
                // check if there is anything more to union in this particual unit.
                if (fullUnits.has(u.id))
                    continue;
                var merged = _mol_data_int__WEBPACK_IMPORTED_MODULE_1__["SortedArray"].union(unitMap.get(u.id), u.elements);
                unitMap.set(u.id, merged);
                if (merged.length === source.unitMap.get(u.id).elements.length)
                    fullUnits.add(u.id);
            }
            else {
                unitMap.set(u.id, u.elements);
                if (u.elements.length === source.unitMap.get(u.id).elements.length)
                    fullUnits.add(u.id);
            }
        }
    }
    var builder = source.subsetBuilder(true);
    unitMap.forEach(buildUnion, builder);
    return builder.getStructure();
}
function buildUnion(elements, id) {
    this.setUnit(id, elements);
}
function structureAreEqual(sA, sB) {
    if (sA === sB)
        return true;
    if (sA.units.length !== sB.units.length)
        return false;
    var aU = sA.units, bU = sB.unitMap;
    for (var i = 0, _i = aU.length; i < _i; i++) {
        var u = aU[i];
        if (!bU.has(u.id))
            return false;
        var v = bU.get(u.id);
        if (!_mol_data_int__WEBPACK_IMPORTED_MODULE_1__["SortedArray"].areEqual(u.elements, v.elements))
            return false;
    }
    return true;
}
function structureAreIntersecting(sA, sB) {
    if (sA === sB)
        return true;
    var a, b;
    if (sA.units.length < sB.units.length) {
        a = sA;
        b = sB;
    }
    else {
        a = sB;
        b = sA;
    }
    var aU = a.units, bU = b.unitMap;
    for (var i = 0, _i = aU.length; i < _i; i++) {
        var u = aU[i];
        if (!bU.has(u.id))
            continue;
        var v = bU.get(u.id);
        if (_mol_data_int__WEBPACK_IMPORTED_MODULE_1__["SortedArray"].areIntersecting(u.elements, v.elements))
            return true;
    }
    return false;
}
function structureIntersect(sA, sB) {
    if (sA === sB)
        return sA;
    if (!structureAreIntersecting(sA, sB))
        return _structure__WEBPACK_IMPORTED_MODULE_0__["Structure"].Empty;
    var a, b;
    if (sA.units.length < sB.units.length) {
        a = sA;
        b = sB;
    }
    else {
        a = sB;
        b = sA;
    }
    var aU = a.units, bU = b.unitMap;
    var units = [];
    for (var i = 0, _i = aU.length; i < _i; i++) {
        var u = aU[i];
        if (!bU.has(u.id))
            continue;
        var v = bU.get(u.id);
        if (_mol_data_int__WEBPACK_IMPORTED_MODULE_1__["SortedArray"].areIntersecting(u.elements, v.elements)) {
            var int = _mol_data_int__WEBPACK_IMPORTED_MODULE_1__["SortedArray"].intersect(u.elements, v.elements);
            units[units.length] = u.getChild(int);
        }
    }
    return _structure__WEBPACK_IMPORTED_MODULE_0__["Structure"].create(units, { parent: sA.parent || sB.parent });
}
function structureSubtract(a, b) {
    if (a === b)
        return _structure__WEBPACK_IMPORTED_MODULE_0__["Structure"].Empty;
    if (!structureAreIntersecting(a, b))
        return a;
    var aU = a.units, bU = b.unitMap;
    var units = [];
    for (var i = 0, _i = aU.length; i < _i; i++) {
        var u = aU[i];
        if (!bU.has(u.id)) {
            units[units.length] = u;
            continue;
        }
        var v = bU.get(u.id);
        var sub = _mol_data_int__WEBPACK_IMPORTED_MODULE_1__["SortedArray"].subtract(u.elements, v.elements);
        if (sub.length > 0) {
            units[units.length] = u.getChild(sub);
        }
    }
    return _structure__WEBPACK_IMPORTED_MODULE_0__["Structure"].create(units, { parent: a.parent || b.parent });
}
//# sourceMappingURL=structure-set.js.map

/***/ }),

/***/ "./lib/mol-model/structure/structure.js":
/*!**********************************************!*\
  !*** ./lib/mol-model/structure/structure.js ***!
  \**********************************************/
/*! exports provided: StructureElement, Bond, Structure, Unit, StructureSymmetry, StructureProperties, UnitRing, UnitRings, CifExportContext, mmCIF_Export_Filters, encode_mmCIF_categories */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _structure_element__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./structure/element */ "./lib/mol-model/structure/structure/element.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "StructureElement", function() { return _structure_element__WEBPACK_IMPORTED_MODULE_0__["default"]; });

/* harmony import */ var _structure_structure__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./structure/structure */ "./lib/mol-model/structure/structure/structure.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Structure", function() { return _structure_structure__WEBPACK_IMPORTED_MODULE_1__["default"]; });

/* harmony import */ var _structure_unit__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./structure/unit */ "./lib/mol-model/structure/structure/unit.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Unit", function() { return _structure_unit__WEBPACK_IMPORTED_MODULE_2__["default"]; });

/* harmony import */ var _structure_symmetry__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./structure/symmetry */ "./lib/mol-model/structure/structure/symmetry.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "StructureSymmetry", function() { return _structure_symmetry__WEBPACK_IMPORTED_MODULE_3__["default"]; });

/* harmony import */ var _structure_unit_bonds__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./structure/unit/bonds */ "./lib/mol-model/structure/structure/unit/bonds.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Bond", function() { return _structure_unit_bonds__WEBPACK_IMPORTED_MODULE_4__["Bond"]; });

/* harmony import */ var _structure_properties__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./structure/properties */ "./lib/mol-model/structure/structure/properties.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "StructureProperties", function() { return _structure_properties__WEBPACK_IMPORTED_MODULE_5__["default"]; });

/* harmony import */ var _structure_unit_rings__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ./structure/unit/rings */ "./lib/mol-model/structure/structure/unit/rings.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "UnitRing", function() { return _structure_unit_rings__WEBPACK_IMPORTED_MODULE_6__["UnitRing"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "UnitRings", function() { return _structure_unit_rings__WEBPACK_IMPORTED_MODULE_6__["UnitRings"]; });

/* harmony import */ var _export_mmcif__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ./export/mmcif */ "./lib/mol-model/structure/export/mmcif.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "CifExportContext", function() { return _export_mmcif__WEBPACK_IMPORTED_MODULE_7__["CifExportContext"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "mmCIF_Export_Filters", function() { return _export_mmcif__WEBPACK_IMPORTED_MODULE_7__["mmCIF_Export_Filters"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "encode_mmCIF_categories", function() { return _export_mmcif__WEBPACK_IMPORTED_MODULE_7__["encode_mmCIF_categories"]; });

/**
 * Copyright (c) 2017-2018 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author David Sehnal <david.sehnal@gmail.com>
 */









//# sourceMappingURL=structure.js.map

/***/ }),

/***/ "./lib/mol-model/structure/structure/carbohydrates/compute.js":
/*!********************************************************************!*\
  !*** ./lib/mol-model/structure/structure/carbohydrates/compute.js ***!
  \********************************************************************/
/*! exports provided: computeCarbohydrates */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "computeCarbohydrates", function() { return computeCarbohydrates; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _mol_data_int__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../../../mol-data/int */ "./lib/mol-data/int.js");
/* harmony import */ var _mol_data_util_combination__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../../../mol-data/util/combination */ "./lib/mol-data/util/combination.js");
/* harmony import */ var _mol_math_graph__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../../../mol-math/graph */ "./lib/mol-math/graph.js");
/* harmony import */ var _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../../../mol-math/linear-algebra */ "./lib/mol-math/linear-algebra.js");
/* harmony import */ var _mol_math_linear_algebra_matrix_principal_axes__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../../../mol-math/linear-algebra/matrix/principal-axes */ "./lib/mol-math/linear-algebra/matrix/principal-axes.js");
/* harmony import */ var _mol_util_array__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../../../../mol-util/array */ "./lib/mol-util/array.js");
/* harmony import */ var _model_types__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../../model/types */ "./lib/mol-model/structure/model/types.js");
/* harmony import */ var _util__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ../../util */ "./lib/mol-model/structure/util.js");
/* harmony import */ var _unit__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ../unit */ "./lib/mol-model/structure/structure/unit.js");
/* harmony import */ var _data__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ./data */ "./lib/mol-model/structure/structure/carbohydrates/data.js");
/* harmony import */ var _unit_rings__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ../unit/rings */ "./lib/mol-model/structure/structure/unit/rings.js");
/* harmony import */ var _mol_data_util__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! ../../../../mol-data/util */ "./lib/mol-data/util.js");
/**
 * Copyright (c) 2018-2020 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 * @author David Sehnal <david.sehnal@gmail.com>
 */













var C = Object(_model_types__WEBPACK_IMPORTED_MODULE_7__["ElementSymbol"])('C'), O = Object(_model_types__WEBPACK_IMPORTED_MODULE_7__["ElementSymbol"])('O');
var SugarRingFps = [
    _unit_rings__WEBPACK_IMPORTED_MODULE_11__["UnitRing"].elementFingerprint([C, C, C, O]),
    _unit_rings__WEBPACK_IMPORTED_MODULE_11__["UnitRing"].elementFingerprint([C, C, C, C, O]),
    _unit_rings__WEBPACK_IMPORTED_MODULE_11__["UnitRing"].elementFingerprint([C, C, C, C, C, O]),
    _unit_rings__WEBPACK_IMPORTED_MODULE_11__["UnitRing"].elementFingerprint([C, C, C, C, C, C, O]),
];
function getAnomericCarbon(unit, ringAtoms) {
    var indexHasTwoOxygen = -1, indexHasOxygenAndCarbon = -1, indexHasC1Name = -1, indexIsCarbon = -1;
    var elements = unit.elements;
    var _a = unit.model.atomicHierarchy.atoms, type_symbol = _a.type_symbol, label_atom_id = _a.label_atom_id;
    var _b = unit.bonds, neighbor = _b.b, offset = _b.offset;
    for (var i = 0, il = ringAtoms.length; i < il; ++i) {
        var ei = elements[ringAtoms[i]];
        if (type_symbol.value(ei) !== C)
            continue;
        var linkedOxygenCount = 0;
        var linkedCarbonCount = 0;
        for (var j = offset[ringAtoms[i]], jl = offset[ringAtoms[i] + 1]; j < jl; ++j) {
            var ej = elements[neighbor[j]];
            var typeSymbol = type_symbol.value(ej);
            if (typeSymbol === O)
                ++linkedOxygenCount;
            else if (typeSymbol === C)
                ++linkedCarbonCount;
        }
        if (linkedOxygenCount === 2) {
            // found anomeric carbon
            indexHasTwoOxygen = ei;
            break;
        }
        else if (linkedOxygenCount === 1 && linkedCarbonCount === 1) {
            // possibly an anomeric carbon if this is a mono-saccharide without a glycosidic bond
            indexHasOxygenAndCarbon = ei;
        }
        else if (label_atom_id.value(ei).startsWith('C1')) {
            // likely the anomeric carbon as it is named C1 by convention
            indexHasC1Name = ei;
        }
        else {
            // use any carbon as a fallback
            indexIsCarbon = ei;
        }
    }
    return (indexHasTwoOxygen !== -1 ? indexHasTwoOxygen
        : indexHasOxygenAndCarbon !== -1 ? indexHasOxygenAndCarbon
            : indexHasC1Name !== -1 ? indexHasC1Name
                : indexIsCarbon !== -1 ? indexIsCarbon
                    : elements[ringAtoms[0]]);
}
function getAltId(unit, index) {
    var elements = unit.elements;
    var label_alt_id = unit.model.atomicHierarchy.atoms.label_alt_id;
    return label_alt_id.value(elements[index]);
}
function getDirection(direction, unit, index, center) {
    var position = unit.conformation.position;
    _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_4__["Vec3"].normalize(direction, _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_4__["Vec3"].sub(direction, center, position(index, direction)));
    return direction;
}
function getAtomId(unit, index) {
    var elements = unit.elements;
    var label_atom_id = unit.model.atomicHierarchy.atoms.label_atom_id;
    return label_atom_id.value(elements[index]);
}
function filterFusedRings(unitRings, rings) {
    if (!rings || !rings.length)
        return;
    var unit = unitRings.unit, all = unitRings.all;
    var fusedRings = new Set();
    var ringCombinations = Object(_mol_data_util_combination__WEBPACK_IMPORTED_MODULE_2__["combinations"])(Object(_mol_util_array__WEBPACK_IMPORTED_MODULE_6__["fillSerial"])(new Array(rings.length)), 2);
    for (var i = 0, il = ringCombinations.length; i < il; ++i) {
        var rc = ringCombinations[i];
        var r0 = all[rings[rc[0]]], r1 = all[rings[rc[1]]];
        if (_mol_data_int__WEBPACK_IMPORTED_MODULE_1__["SortedArray"].areIntersecting(r0, r1) &&
            _unit_rings__WEBPACK_IMPORTED_MODULE_11__["UnitRing"].getAltId(unit, r0) === _unit_rings__WEBPACK_IMPORTED_MODULE_11__["UnitRing"].getAltId(unit, r1)) {
            fusedRings.add(rings[rc[0]]);
            fusedRings.add(rings[rc[1]]);
        }
    }
    if (fusedRings.size) {
        var filteredRings = [];
        for (var i = 0, il = rings.length; i < il; ++i) {
            if (!fusedRings.has(rings[i]))
                filteredRings.push(rings[i]);
        }
        return filteredRings;
    }
    else {
        return rings;
    }
}
function getSaccharideComp(compId, model) {
    return model.properties.saccharideComponentMap.get(compId);
}
function computeCarbohydrates(structure) {
    // skip computation if there are no saccharide components in any model
    if (structure.models.reduce(function (a, v) { return a + v.properties.saccharideComponentMap.size; }, 0) === 0)
        return _data__WEBPACK_IMPORTED_MODULE_10__["EmptyCarbohydrates"];
    var links = [];
    var terminalLinks = [];
    var elements = [];
    var partialElements = [];
    var elementsWithRingMap = new Map();
    function ringElementKey(residueIndex, unitId, altId) {
        return residueIndex + "|" + unitId + "|" + altId;
    }
    function addRingElement(key, elementIndex) {
        if (elementsWithRingMap.has(key))
            elementsWithRingMap.get(key).push(elementIndex);
        else
            elementsWithRingMap.set(key, [elementIndex]);
    }
    function fixLinkDirection(iA, iB) {
        _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_4__["Vec3"].sub(elements[iA].geometry.direction, elements[iB].geometry.center, elements[iA].geometry.center);
        _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_4__["Vec3"].normalize(elements[iA].geometry.direction, elements[iA].geometry.direction);
    }
    var tmpV = _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_4__["Vec3"].zero();
    function fixTerminalLinkDirection(iA, indexB, unitB) {
        var pos = unitB.conformation.position, geo = elements[iA].geometry;
        _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_4__["Vec3"].sub(geo.direction, pos(unitB.elements[indexB], tmpV), geo.center);
        _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_4__["Vec3"].normalize(geo.direction, geo.direction);
    }
    // get carbohydrate elements and carbohydrate links induced by intra-residue bonds
    for (var i = 0, il = structure.units.length; i < il; ++i) {
        var unit = structure.units[i];
        if (!_unit__WEBPACK_IMPORTED_MODULE_9__["default"].isAtomic(unit))
            continue;
        var model = unit.model, rings = unit.rings;
        var _a = model.atomicHierarchy, chainAtomSegments = _a.chainAtomSegments, residueAtomSegments = _a.residueAtomSegments, atoms = _a.atoms;
        var label_comp_id = atoms.label_comp_id;
        var chainIt = _mol_data_int__WEBPACK_IMPORTED_MODULE_1__["Segmentation"].transientSegments(chainAtomSegments, unit.elements);
        var residueIt = _mol_data_int__WEBPACK_IMPORTED_MODULE_1__["Segmentation"].transientSegments(residueAtomSegments, unit.elements);
        var sugarResidueMap = void 0;
        while (chainIt.hasNext) {
            residueIt.setSegment(chainIt.move());
            while (residueIt.hasNext) {
                var residueIndex = residueIt.move().index;
                var saccharideComp = getSaccharideComp(label_comp_id.value(residueAtomSegments.offsets[residueIndex]), model);
                if (!saccharideComp)
                    continue;
                if (!sugarResidueMap) {
                    sugarResidueMap = _unit_rings__WEBPACK_IMPORTED_MODULE_11__["UnitRings"].byFingerprintAndResidue(rings, SugarRingFps);
                }
                var sugarRings = filterFusedRings(rings, sugarResidueMap.get(residueIndex));
                if (!sugarRings || !sugarRings.length) {
                    partialElements.push({ unit: unit, residueIndex: residueIndex, component: saccharideComp });
                    continue;
                }
                var ringElements = [];
                for (var j = 0, jl = sugarRings.length; j < jl; ++j) {
                    var ringAtoms = rings.all[sugarRings[j]];
                    var anomericCarbon = getAnomericCarbon(unit, ringAtoms);
                    var ma = _mol_math_linear_algebra_matrix_principal_axes__WEBPACK_IMPORTED_MODULE_5__["PrincipalAxes"].calculateMomentsAxes(Object(_util__WEBPACK_IMPORTED_MODULE_8__["getPositions"])(unit, ringAtoms));
                    var center = _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_4__["Vec3"].copy(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_4__["Vec3"].zero(), ma.origin);
                    var normal = _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_4__["Vec3"].copy(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_4__["Vec3"].zero(), ma.dirC);
                    var direction = getDirection(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_4__["Vec3"].zero(), unit, anomericCarbon, center);
                    _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_4__["Vec3"].orthogonalize(direction, normal, direction);
                    var ringAltId = _unit_rings__WEBPACK_IMPORTED_MODULE_11__["UnitRing"].getAltId(unit, ringAtoms);
                    var elementIndex = elements.length;
                    ringElements.push(elementIndex);
                    addRingElement(ringElementKey(residueIndex, unit.id, ringAltId), elementIndex);
                    if (ringAltId)
                        addRingElement(ringElementKey(residueIndex, unit.id, ''), elementIndex);
                    elements.push({
                        geometry: { center: center, normal: normal, direction: direction },
                        component: saccharideComp,
                        ringIndex: sugarRings[j],
                        altId: ringAltId,
                        unit: unit, residueIndex: residueIndex
                    });
                }
                // add carbohydrate links induced by intra-residue bonds
                // (e.g. for structures from the PDB archive __before__ carbohydrate remediation)
                var ringCombinations = Object(_mol_data_util_combination__WEBPACK_IMPORTED_MODULE_2__["combinations"])(Object(_mol_util_array__WEBPACK_IMPORTED_MODULE_6__["fillSerial"])(new Array(sugarRings.length)), 2);
                for (var j = 0, jl = ringCombinations.length; j < jl; ++j) {
                    var rc = ringCombinations[j];
                    var r0 = rings.all[sugarRings[rc[0]]], r1 = rings.all[sugarRings[rc[1]]];
                    // 1,6 glycosidic links are distance 3 and 1,4 glycosidic links are distance 2
                    if (_mol_math_graph__WEBPACK_IMPORTED_MODULE_3__["IntAdjacencyGraph"].areVertexSetsConnected(unit.bonds, r0, r1, 3)) {
                        var re0 = ringElements[rc[0]];
                        var re1 = ringElements[rc[1]];
                        if (elements[re0].altId === elements[re1].altId) {
                            // TODO handle better, for now fix both directions as it is unclear where the C1 atom is
                            //      would need to know the path connecting the two rings
                            fixLinkDirection(re0, re1);
                            fixLinkDirection(re1, re0);
                            links.push({ carbohydrateIndexA: re0, carbohydrateIndexB: re1 });
                            links.push({ carbohydrateIndexA: re1, carbohydrateIndexB: re0 });
                        }
                    }
                }
            }
        }
    }
    function getRingElementIndices(unit, index) {
        return elementsWithRingMap.get(ringElementKey(unit.getResidueIndex(index), unit.id, getAltId(unit, index))) || [];
    }
    // add carbohydrate links induced by intra-unit bonds
    // (e.g. for structures from the PDB archive __after__ carbohydrate remediation)
    for (var i = 0, il = elements.length; i < il; ++i) {
        var cA = elements[i];
        var unit = cA.unit;
        for (var j = i + 1; j < il; ++j) {
            var cB = elements[j];
            if (unit !== cB.unit || cA.residueIndex === cB.residueIndex)
                continue;
            var rA = unit.rings.all[cA.ringIndex];
            var rB = unit.rings.all[cB.ringIndex];
            if (_mol_math_graph__WEBPACK_IMPORTED_MODULE_3__["IntAdjacencyGraph"].areVertexSetsConnected(unit.bonds, rA, rB, 3)) {
                // TODO handle better, for now fix both directions as it is unclear where the C1 atom is
                //      would need to know the path connecting the two rings
                fixLinkDirection(i, j);
                fixLinkDirection(j, i);
                links.push({ carbohydrateIndexA: i, carbohydrateIndexB: j });
                links.push({ carbohydrateIndexA: j, carbohydrateIndexB: i });
            }
        }
    }
    // get carbohydrate links induced by inter-unit bonds, that is
    // inter monosaccharide links for structures from the
    // PDB archive __before__ carbohydrate remediation
    // plus terminal links for __before__ and __after__
    for (var i = 0, il = structure.units.length; i < il; ++i) {
        var unit = structure.units[i];
        if (!_unit__WEBPACK_IMPORTED_MODULE_9__["default"].isAtomic(unit))
            continue;
        structure.interUnitBonds.getConnectedUnits(unit.id).forEach(function (pairBonds) {
            pairBonds.connectedIndices.forEach(function (indexA) {
                pairBonds.getEdges(indexA).forEach(function (_a) {
                    var props = _a.props, indexB = _a.indexB;
                    if (!_model_types__WEBPACK_IMPORTED_MODULE_7__["BondType"].isCovalent(props.flag))
                        return;
                    var unitA = structure.unitMap.get(pairBonds.unitA);
                    var unitB = structure.unitMap.get(pairBonds.unitB);
                    var ringElementIndicesA = getRingElementIndices(unitA, indexA);
                    var ringElementIndicesB = getRingElementIndices(unitB, indexB);
                    if (ringElementIndicesA.length > 0 && ringElementIndicesB.length > 0) {
                        var lA = ringElementIndicesA.length;
                        var lB = ringElementIndicesB.length;
                        for (var j = 0, jl = Math.max(lA, lB); j < jl; ++j) {
                            var ringElementIndexA = ringElementIndicesA[Math.min(j, lA - 1)];
                            var ringElementIndexB = ringElementIndicesB[Math.min(j, lB - 1)];
                            var atomIdA = getAtomId(unitA, indexA);
                            if (atomIdA.startsWith('O1') || atomIdA.startsWith('C1')) {
                                fixLinkDirection(ringElementIndexA, ringElementIndexB);
                            }
                            links.push({
                                carbohydrateIndexA: ringElementIndexA,
                                carbohydrateIndexB: ringElementIndexB
                            });
                        }
                    }
                    else if (ringElementIndicesB.length === 0) {
                        for (var _i = 0, ringElementIndicesA_1 = ringElementIndicesA; _i < ringElementIndicesA_1.length; _i++) {
                            var ringElementIndexA = ringElementIndicesA_1[_i];
                            var atomIdA = getAtomId(unitA, indexA);
                            if (atomIdA.startsWith('O1') || atomIdA.startsWith('C1')) {
                                fixTerminalLinkDirection(ringElementIndexA, indexB, unitB);
                            }
                            terminalLinks.push({
                                carbohydrateIndex: ringElementIndexA,
                                elementIndex: indexB,
                                elementUnit: unitB,
                                fromCarbohydrate: true
                            });
                        }
                    }
                    else if (ringElementIndicesA.length === 0) {
                        for (var _b = 0, ringElementIndicesB_1 = ringElementIndicesB; _b < ringElementIndicesB_1.length; _b++) {
                            var ringElementIndexB = ringElementIndicesB_1[_b];
                            terminalLinks.push({
                                carbohydrateIndex: ringElementIndexB,
                                elementIndex: indexA,
                                elementUnit: unitA,
                                fromCarbohydrate: false
                            });
                        }
                    }
                });
            });
        });
    }
    return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({ links: links, terminalLinks: terminalLinks, elements: elements, partialElements: partialElements }, buildLookups(elements, links, terminalLinks));
}
function buildLookups(elements, links, terminalLinks) {
    function key(unit, element) {
        return Object(_mol_data_util__WEBPACK_IMPORTED_MODULE_12__["cantorPairing"])(unit.id, element);
    }
    function getIndices(map, unit, index) {
        var indices = [];
        var il = map.get(key(unit, index));
        if (il !== undefined) {
            for (var _i = 0, il_1 = il; _i < il_1.length; _i++) {
                var i = il_1[_i];
                Object(_mol_util_array__WEBPACK_IMPORTED_MODULE_6__["arraySetAdd"])(indices, i);
            }
        }
        return indices;
    }
    // elements
    var elementsMap = new Map();
    for (var i = 0, il = elements.length; i < il; ++i) {
        var _a = elements[i], unit = _a.unit, ringIndex = _a.ringIndex;
        var ring = unit.rings.all[ringIndex];
        for (var j = 0, jl = ring.length; j < jl; ++j) {
            var k = key(unit, unit.elements[ring[j]]);
            var e = elementsMap.get(k);
            if (e === undefined)
                elementsMap.set(k, [i]);
            else
                e.push(i);
        }
    }
    function getElementIndices(unit, index) {
        return getIndices(elementsMap, unit, index);
    }
    // links
    var linksMap = new Map();
    for (var i = 0, il = links.length; i < il; ++i) {
        var l = links[i];
        var _b = elements[l.carbohydrateIndexA], unit = _b.unit, ringIndex = _b.ringIndex;
        var ring = unit.rings.all[ringIndex];
        for (var j = 0, jl = ring.length; j < jl; ++j) {
            var k = key(unit, unit.elements[ring[j]]);
            var e = linksMap.get(k);
            if (e === undefined)
                linksMap.set(k, [i]);
            else
                e.push(i);
        }
    }
    function getLinkIndices(unit, index) {
        return getIndices(linksMap, unit, index);
    }
    // terminal links
    var terminalLinksMap = new Map();
    for (var i = 0, il = terminalLinks.length; i < il; ++i) {
        var _c = terminalLinks[i], fromCarbohydrate = _c.fromCarbohydrate, carbohydrateIndex = _c.carbohydrateIndex, elementUnit = _c.elementUnit, elementIndex = _c.elementIndex;
        if (fromCarbohydrate) {
            var _d = elements[carbohydrateIndex], unit = _d.unit, ringIndex = _d.ringIndex;
            var ring = unit.rings.all[ringIndex];
            for (var j = 0, jl = ring.length; j < jl; ++j) {
                var k = key(unit, unit.elements[ring[j]]);
                var e = terminalLinksMap.get(k);
                if (e === undefined)
                    terminalLinksMap.set(k, [i]);
                else
                    e.push(i);
            }
        }
        else {
            var k = key(elementUnit, elementUnit.elements[elementIndex]);
            var e = terminalLinksMap.get(k);
            if (e === undefined)
                terminalLinksMap.set(k, [i]);
            else
                e.push(i);
        }
    }
    function getTerminalLinkIndices(unit, index) {
        return getIndices(terminalLinksMap, unit, index);
    }
    return { getElementIndices: getElementIndices, getLinkIndices: getLinkIndices, getTerminalLinkIndices: getTerminalLinkIndices };
}
//# sourceMappingURL=compute.js.map

/***/ }),

/***/ "./lib/mol-model/structure/structure/carbohydrates/constants.js":
/*!**********************************************************************!*\
  !*** ./lib/mol-model/structure/structure/carbohydrates/constants.js ***!
  \**********************************************************************/
/*! exports provided: SaccharideColors, getSaccharideName, getSaccharideShape, UnknownSaccharideComponent, SaccharidesSnfgMap, MonosaccharidesColorTable, SaccharideCompIdMap */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SaccharideColors", function() { return SaccharideColors; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getSaccharideName", function() { return getSaccharideName; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getSaccharideShape", function() { return getSaccharideShape; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "UnknownSaccharideComponent", function() { return UnknownSaccharideComponent; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SaccharidesSnfgMap", function() { return SaccharidesSnfgMap; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MonosaccharidesColorTable", function() { return MonosaccharidesColorTable; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SaccharideCompIdMap", function() { return SaccharideCompIdMap; });
/* harmony import */ var _mol_util_color__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../../../mol-util/color */ "./lib/mol-util/color/index.js");
/**
 * Copyright (c) 2018-2019 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 * @author David Sehnal <david.sehnal@gmail.com>
 */
var _a, _b;

var SaccharideColors = Object(_mol_util_color__WEBPACK_IMPORTED_MODULE_0__["ColorMap"])({
    Blue: 0x0090bc,
    Green: 0x00a651,
    Yellow: 0xffd400,
    Orange: 0xf47920,
    Pink: 0xf69ea1,
    Purple: 0xa54399,
    LightBlue: 0x8fcce9,
    Brown: 0xa17a4d,
    Red: 0xed1c24,
    Secondary: 0xf1ece1
});
var SaccharideTypeNameMap = (_a = {},
    _a[0 /* Hexose */] = 'Hexose',
    _a[1 /* HexNAc */] = 'HexNAc',
    _a[2 /* Hexosamine */] = 'Hexosamine',
    _a[3 /* Hexuronate */] = 'Hexuronate',
    _a[4 /* Deoxyhexose */] = 'Deoxyhexose',
    _a[5 /* DeoxyhexNAc */] = 'DeoxyhexNAc',
    _a[6 /* DiDeoxyhexose */] = 'Di-deoxyhexose',
    _a[7 /* Pentose */] = 'Pentose',
    _a[8 /* Deoxynonulosonate */] = 'Deoxynonulosonate',
    _a[9 /* DiDeoxynonulosonate */] = 'Di-deoxynonulosonate',
    _a[10 /* Unknown */] = 'Unknown',
    _a[11 /* Assigned */] = 'Assigned',
    _a);
function getSaccharideName(type) {
    return SaccharideTypeNameMap[type];
}
var SaccharideTypeShapeMap = (_b = {},
    _b[0 /* Hexose */] = 0 /* FilledSphere */,
    _b[1 /* HexNAc */] = 1 /* FilledCube */,
    _b[2 /* Hexosamine */] = 2 /* CrossedCube */,
    _b[3 /* Hexuronate */] = 3 /* DividedDiamond */,
    _b[4 /* Deoxyhexose */] = 4 /* FilledCone */,
    _b[5 /* DeoxyhexNAc */] = 5 /* DevidedCone */,
    _b[6 /* DiDeoxyhexose */] = 6 /* FlatBox */,
    _b[7 /* Pentose */] = 7 /* FilledStar */,
    _b[8 /* Deoxynonulosonate */] = 8 /* FilledDiamond */,
    _b[9 /* DiDeoxynonulosonate */] = 9 /* FlatDiamond */,
    _b[10 /* Unknown */] = 10 /* FlatHexagon */,
    _b[11 /* Assigned */] = 11 /* Pentagon */,
    _b);
function getSaccharideShape(type, ringMemberCount) {
    if (type === 10 /* Unknown */) {
        if (ringMemberCount === 4)
            return 12 /* DiamondPrism */;
        else if (ringMemberCount === 5)
            return 13 /* PentagonalPrism */;
        else if (ringMemberCount === 6)
            return 14 /* HexagonalPrism */;
        else if (ringMemberCount === 7)
            return 15 /* HeptagonalPrism */;
        else
            return 10 /* FlatHexagon */;
    }
    else {
        return SaccharideTypeShapeMap[type];
    }
}
var UnknownSaccharideComponent = {
    abbr: 'Unk',
    name: 'Unknown',
    color: SaccharideColors.Secondary,
    type: 10 /* Unknown */
};
var Monosaccharides = [
    { abbr: 'Glc', name: 'Glucose', color: SaccharideColors.Blue, type: 0 /* Hexose */ },
    { abbr: 'Man', name: 'Mannose', color: SaccharideColors.Green, type: 0 /* Hexose */ },
    { abbr: 'Gal', name: 'Galactose', color: SaccharideColors.Yellow, type: 0 /* Hexose */ },
    { abbr: 'Gul', name: 'Gulose', color: SaccharideColors.Orange, type: 0 /* Hexose */ },
    { abbr: 'Alt', name: 'Altrose', color: SaccharideColors.Pink, type: 0 /* Hexose */ },
    { abbr: 'All', name: 'Allose', color: SaccharideColors.Purple, type: 0 /* Hexose */ },
    { abbr: 'Tal', name: 'Talose', color: SaccharideColors.LightBlue, type: 0 /* Hexose */ },
    { abbr: 'Ido', name: 'Idose', color: SaccharideColors.Brown, type: 0 /* Hexose */ },
    { abbr: 'GlcNAc', name: 'N-Acetyl Glucosamine', color: SaccharideColors.Blue, type: 1 /* HexNAc */ },
    { abbr: 'ManNAc', name: 'N-Acetyl Mannosamine', color: SaccharideColors.Green, type: 1 /* HexNAc */ },
    { abbr: 'GalNAc', name: 'N-Acetyl Galactosamine', color: SaccharideColors.Yellow, type: 1 /* HexNAc */ },
    { abbr: 'GulNAc', name: 'N-Acetyl Gulosamine', color: SaccharideColors.Orange, type: 1 /* HexNAc */ },
    { abbr: 'AltNAc', name: 'N-Acetyl Altrosamine', color: SaccharideColors.Pink, type: 1 /* HexNAc */ },
    { abbr: 'AllNAc', name: 'N-Acetyl Allosamine', color: SaccharideColors.Purple, type: 1 /* HexNAc */ },
    { abbr: 'TalNAc', name: 'N-Acetyl Talosamine', color: SaccharideColors.LightBlue, type: 1 /* HexNAc */ },
    { abbr: 'IdoNAc', name: 'N-Acetyl Idosamine', color: SaccharideColors.Brown, type: 1 /* HexNAc */ },
    { abbr: 'GlcN', name: 'Glucosamine', color: SaccharideColors.Blue, type: 2 /* Hexosamine */ },
    { abbr: 'ManN', name: 'Mannosamine', color: SaccharideColors.Green, type: 2 /* Hexosamine */ },
    { abbr: 'GalN', name: 'Galactosamine', color: SaccharideColors.Yellow, type: 2 /* Hexosamine */ },
    { abbr: 'GulN', name: 'Gulosamine', color: SaccharideColors.Orange, type: 2 /* Hexosamine */ },
    { abbr: 'AltN', name: 'Altrosamine', color: SaccharideColors.Pink, type: 2 /* Hexosamine */ },
    { abbr: 'AllN', name: 'Allosamine', color: SaccharideColors.Purple, type: 2 /* Hexosamine */ },
    { abbr: 'TalN', name: 'Talosamine', color: SaccharideColors.LightBlue, type: 2 /* Hexosamine */ },
    { abbr: 'IdoN', name: 'Idosamine', color: SaccharideColors.Brown, type: 2 /* Hexosamine */ },
    { abbr: 'GlcA', name: 'Glucuronic Acid', color: SaccharideColors.Blue, type: 3 /* Hexuronate */ },
    { abbr: 'ManA', name: 'Mannuronic Acid', color: SaccharideColors.Green, type: 3 /* Hexuronate */ },
    { abbr: 'GalA', name: 'Galacturonic Acid', color: SaccharideColors.Yellow, type: 3 /* Hexuronate */ },
    { abbr: 'GulA', name: 'Guluronic Acid', color: SaccharideColors.Orange, type: 3 /* Hexuronate */ },
    { abbr: 'AltA', name: 'Altruronic Acid', color: SaccharideColors.Pink, type: 3 /* Hexuronate */ },
    { abbr: 'AllA', name: 'Alluronic Acid', color: SaccharideColors.Purple, type: 3 /* Hexuronate */ },
    { abbr: 'TalA', name: 'Taluronic Acid', color: SaccharideColors.LightBlue, type: 3 /* Hexuronate */ },
    { abbr: 'IdoA', name: 'Iduronic Acid', color: SaccharideColors.Brown, type: 3 /* Hexuronate */ },
    { abbr: 'Qui', name: 'Quinovose', color: SaccharideColors.Blue, type: 4 /* Deoxyhexose */ },
    { abbr: 'Rha', name: 'Rhamnose', color: SaccharideColors.Green, type: 4 /* Deoxyhexose */ },
    { abbr: '6dGul', name: '6-Deoxy Gulose', color: SaccharideColors.Orange, type: 4 /* Deoxyhexose */ },
    { abbr: '6dAlt', name: '6-Deoxy Altrose', color: SaccharideColors.Pink, type: 4 /* Deoxyhexose */ },
    { abbr: '6dTal', name: '6-Deoxy Talose', color: SaccharideColors.LightBlue, type: 4 /* Deoxyhexose */ },
    { abbr: 'Fuc', name: 'Fucose', color: SaccharideColors.Red, type: 4 /* Deoxyhexose */ },
    { abbr: 'QuiNAc', name: 'N-Acetyl Quinovosamine', color: SaccharideColors.Blue, type: 5 /* DeoxyhexNAc */ },
    { abbr: 'RhaNAc', name: 'N-Acetyl Rhamnosamine', color: SaccharideColors.Green, type: 5 /* DeoxyhexNAc */ },
    { abbr: '6dAltNAc', name: 'N-Acetyl 6-Deoxy Altrosamine', color: SaccharideColors.Pink, type: 5 /* DeoxyhexNAc */ },
    { abbr: '6dTalNAc', name: 'N-Acetyl 6-Deoxy Talosamine', color: SaccharideColors.LightBlue, type: 5 /* DeoxyhexNAc */ },
    { abbr: 'FucNAc', name: 'N-Acetyl Fucosamine', color: SaccharideColors.Red, type: 5 /* DeoxyhexNAc */ },
    { abbr: 'Oli', name: 'Olivose', color: SaccharideColors.Blue, type: 6 /* DiDeoxyhexose */ },
    { abbr: 'Tyv', name: 'Tyvelose', color: SaccharideColors.Green, type: 6 /* DiDeoxyhexose */ },
    { abbr: 'Abe', name: 'Abequose', color: SaccharideColors.Orange, type: 6 /* DiDeoxyhexose */ },
    { abbr: 'Par', name: 'Paratose', color: SaccharideColors.Pink, type: 6 /* DiDeoxyhexose */ },
    { abbr: 'Dig', name: 'Digitoxose', color: SaccharideColors.Purple, type: 6 /* DiDeoxyhexose */ },
    { abbr: 'Col', name: 'Colitose', color: SaccharideColors.LightBlue, type: 6 /* DiDeoxyhexose */ },
    { abbr: 'Ara', name: 'Arabinose', color: SaccharideColors.Green, type: 7 /* Pentose */ },
    { abbr: 'Lyx', name: 'Lyxose', color: SaccharideColors.Yellow, type: 7 /* Pentose */ },
    { abbr: 'Xyl', name: 'Xylose', color: SaccharideColors.Orange, type: 7 /* Pentose */ },
    { abbr: 'Rib', name: 'Ribose', color: SaccharideColors.Pink, type: 7 /* Pentose */ },
    { abbr: 'Kdn', name: 'Keto-Deoxy Nonulonic Acid', color: SaccharideColors.Green, type: 8 /* Deoxynonulosonate */ },
    { abbr: 'Neu5Ac', name: 'N-Acetyl Neuraminic Acid', color: SaccharideColors.Purple, type: 8 /* Deoxynonulosonate */ },
    { abbr: 'Neu5Gc', name: 'N-Glycolyl Neuraminic Acid', color: SaccharideColors.LightBlue, type: 8 /* Deoxynonulosonate */ },
    { abbr: 'Neu', name: 'Neuraminic Acid', color: SaccharideColors.Brown, type: 8 /* Deoxynonulosonate */ },
    { abbr: 'Sia', name: 'Sialic acid', color: SaccharideColors.Red, type: 8 /* Deoxynonulosonate */ },
    { abbr: 'Pse', name: 'Pseudaminic Acid', color: SaccharideColors.Green, type: 9 /* DiDeoxynonulosonate */ },
    { abbr: 'Leg', name: 'Legionaminic Acid', color: SaccharideColors.Yellow, type: 9 /* DiDeoxynonulosonate */ },
    { abbr: 'Aci', name: 'Acinetaminic Acid', color: SaccharideColors.Pink, type: 9 /* DiDeoxynonulosonate */ },
    { abbr: '4eLeg', name: '4-Epilegionaminic Acid', color: SaccharideColors.LightBlue, type: 9 /* DiDeoxynonulosonate */ },
    { abbr: 'Bac', name: 'Bacillosamine', color: SaccharideColors.Blue, type: 10 /* Unknown */ },
    { abbr: 'LDmanHep', name: 'L-Glycero-D-Manno Heptose', color: SaccharideColors.Green, type: 10 /* Unknown */ },
    { abbr: 'Kdo', name: 'Keto-Deoxy Octulonic Acid', color: SaccharideColors.Yellow, type: 10 /* Unknown */ },
    { abbr: 'Dha', name: '3-Deoxy Lyxo-Heptulosaric Acid', color: SaccharideColors.Orange, type: 10 /* Unknown */ },
    { abbr: 'DDmanHep', name: 'D-Glycero-D-Manno-Heptose', color: SaccharideColors.Pink, type: 10 /* Unknown */ },
    { abbr: 'MurNAc', name: 'N-Acetyl Muramic Acid', color: SaccharideColors.Purple, type: 10 /* Unknown */ },
    { abbr: 'MurNGc', name: 'N-Glycolyl Muramic Acid', color: SaccharideColors.LightBlue, type: 10 /* Unknown */ },
    { abbr: 'Mur', name: 'Muramic Acid', color: SaccharideColors.Brown, type: 10 /* Unknown */ },
    { abbr: 'Api', name: 'Apicose', color: SaccharideColors.Green, type: 11 /* Assigned */ },
    { abbr: 'Fru', name: 'Fructose', color: SaccharideColors.Green, type: 11 /* Assigned */ },
    { abbr: 'Tag', name: 'Tagatose', color: SaccharideColors.Yellow, type: 11 /* Assigned */ },
    { abbr: 'Sor', name: 'Sorbose', color: SaccharideColors.Orange, type: 11 /* Assigned */ },
    { abbr: 'Psi', name: 'Psicose', color: SaccharideColors.Pink, type: 11 /* Assigned */ },
];
var SaccharidesSnfgMap = (function () {
    var map = new Map();
    for (var i = 0, il = Monosaccharides.length; i < il; ++i) {
        var saccharide = Monosaccharides[i];
        map.set(saccharide.abbr, saccharide);
    }
    return map;
})();
var MonosaccharidesColorTable = [
    ['Glc-family', SaccharideColors.Blue],
    ['Man-family', SaccharideColors.Green],
    ['Gal-family', SaccharideColors.Yellow],
    ['Gul-family', SaccharideColors.Orange],
    ['Alt-family', SaccharideColors.Pink],
    ['All-family', SaccharideColors.Purple],
    ['Tal-family', SaccharideColors.LightBlue],
    ['Ido-family', SaccharideColors.Brown],
    ['Fuc-family', SaccharideColors.Red],
    ['Generic/Unknown/Secondary', SaccharideColors.Secondary],
];
var CommonSaccharideNames = {
    // Hexose
    Glc: [
        'GLC', 'BGC', 'Z8T',
        'TRE',
        'MLR',
    ],
    Man: ['MAN', 'BMA'],
    Gal: ['GLA', 'GAL', 'GZL', 'GXL', 'GIV'],
    Gul: ['4GL', 'GL0', 'GUP', 'Z8H'],
    Alt: ['Z6H', '3MK', 'SHD'],
    All: ['AFD', 'ALL', 'WOO', 'Z2D'],
    Tal: ['ZEE', 'A5C', 'SDY'],
    Ido: ['ZCD', 'Z0F', '4N2'],
    // HexNAc
    GlcNAc: ['NDG', 'NAG', 'NGZ'],
    ManNAc: ['BM3', 'BM7'],
    GalNAc: ['A2G', 'NGA', 'YYQ'],
    GulNAc: ['LXB'],
    AltNAc: [],
    AllNAc: ['NAA'],
    TalNAc: [],
    IdoNAc: ['LXZ', 'HSQ'],
    // Hexosamine
    GlcN: ['PA1', 'GCS'],
    ManN: ['95Z'],
    GalN: ['X6X', '1GN'],
    GulN: [],
    AltN: [],
    AllN: [],
    TalN: [],
    IdoN: [],
    // Hexuronate
    GlcA: ['GCU', 'BDP'],
    ManA: ['MAV', 'BEM'],
    GalA: ['ADA', 'GTR', 'GTK'],
    GulA: ['LGU'],
    AltA: [],
    AllA: [],
    TalA: ['X1X', 'X0X'],
    IdoA: ['IDR'],
    // Deoxyhexose
    Qui: ['G6D', 'YYK'],
    Rha: ['RAM', 'RM4', 'XXR'],
    '6dGul': ['66O'],
    '6dAlt': [],
    '6dTal': [],
    Fuc: ['FUC', 'FUL', 'FCA', 'FCB', 'GYE'],
    // DeoxyhexNAc
    QuiNAc: ['Z9W'],
    RhaNAc: [],
    '6dAltNAc': [],
    '6dTalNAc': [],
    FucNAc: ['49T'],
    // Di-deoxyhexose
    Oli: ['DDA', 'RAE', 'Z5J'],
    Tyv: ['TYV'],
    Abe: ['ABE'],
    Par: ['PZU'],
    Dig: ['Z3U'],
    Col: [],
    // Pentose
    Ara: ['64K', 'ARA', 'ARB', 'AHR', 'FUB', 'BXY', 'BXX', 'SEJ'],
    Lyx: ['LDY', 'Z4W'],
    Xyl: ['XYS', 'XYP', 'XYZ', 'HSY', 'LXC'],
    Rib: ['YYM', 'RIP', 'RIB', 'BDR', '0MK', 'Z6J', '32O'],
    // Deoxynonulosonate
    Kdn: ['KDM', 'KDN'],
    Neu5Ac: ['SIA', 'SLB'],
    Neu5Gc: ['NGC', 'NGE'],
    Neu: [],
    Sia: [],
    // Di-deoxynonulosonate
    Pse: [],
    Leg: [],
    Aci: [],
    '4eLeg': [],
    // Unknown
    Bac: [],
    LDmanHep: ['GMH'],
    Kdo: ['KDO'],
    Dha: [],
    DDmanHep: ['289'],
    MurNAc: ['MUB', 'AMU'],
    MurNGc: [],
    Mur: ['1S4', 'MUR'],
    // Assigned
    Api: ['XXM'],
    Fru: ['BDF', 'Z9N', 'FRU', 'LFR'],
    Tag: ['T6T'],
    Sor: ['SOE', 'UEA'],
    Psi: ['PSV', 'SF6', 'SF9', 'TTV'],
};
var UnknownSaccharideNames = [
    'NGZ',
    'LAT',
    'PUF', 'GDA', '9WJ',
];
var SaccharideCompIdMap = (function () {
    var map = new Map();
    for (var i = 0, il = Monosaccharides.length; i < il; ++i) {
        var saccharide = Monosaccharides[i];
        var names = CommonSaccharideNames[saccharide.abbr];
        if (names) {
            for (var j = 0, jl = names.length; j < jl; ++j) {
                map.set(names[j], saccharide);
            }
        }
    }
    for (var i = 0, il = UnknownSaccharideNames.length; i < il; ++i) {
        map.set(UnknownSaccharideNames[i], UnknownSaccharideComponent);
    }
    return map;
})();
//# sourceMappingURL=constants.js.map

/***/ }),

/***/ "./lib/mol-model/structure/structure/carbohydrates/data.js":
/*!*****************************************************************!*\
  !*** ./lib/mol-model/structure/structure/carbohydrates/data.js ***!
  \*****************************************************************/
/*! exports provided: EmptyCarbohydrates */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "EmptyCarbohydrates", function() { return EmptyCarbohydrates; });
/**
 * Copyright (c) 2018-2020 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */
var EmptyArray = [];
var EmptyCarbohydrates = {
    links: EmptyArray,
    terminalLinks: EmptyArray,
    elements: EmptyArray,
    partialElements: EmptyArray,
    getElementIndices: function () { return EmptyArray; },
    getLinkIndices: function () { return EmptyArray; },
    getTerminalLinkIndices: function () { return EmptyArray; },
};
//# sourceMappingURL=data.js.map

/***/ }),

/***/ "./lib/mol-model/structure/structure/element.js":
/*!******************************************************!*\
  !*** ./lib/mol-model/structure/structure/element.js ***!
  \******************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _element_index__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./element/index */ "./lib/mol-model/structure/structure/element/index.js");
/**
 * Copyright (c) 2017-2019 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author David Sehnal <david.sehnal@gmail.com>
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */

/* harmony default export */ __webpack_exports__["default"] = (_element_index__WEBPACK_IMPORTED_MODULE_0__);
//# sourceMappingURL=element.js.map

/***/ }),

/***/ "./lib/mol-model/structure/structure/element/bundle.js":
/*!*************************************************************!*\
  !*** ./lib/mol-model/structure/structure/element/bundle.js ***!
  \*************************************************************/
/*! exports provided: Bundle */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Bundle", function() { return Bundle; });
/* harmony import */ var _mol_data_int__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../../../mol-data/int */ "./lib/mol-data/int.js");
/* harmony import */ var _structure__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../structure */ "./lib/mol-model/structure/structure/structure.js");
/* harmony import */ var _mol_data_util__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../../../mol-data/util */ "./lib/mol-data/util.js");
/* harmony import */ var _mol_data_int_sorted_ranges__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../../../mol-data/int/sorted-ranges */ "./lib/mol-data/int/sorted-ranges.js");
/* harmony import */ var _loci__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./loci */ "./lib/mol-model/structure/structure/element/loci.js");
/* harmony import */ var _mol_script_language_builder__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../../../mol-script/language/builder */ "./lib/mol-script/language/builder.js");
/* harmony import */ var _query__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../../query */ "./lib/mol-model/structure/query.js");
/**
 * Copyright (c) 2019 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */







var Bundle;
(function (Bundle) {
    Bundle.Empty = { hash: -1, elements: [] };
    function fromSubStructure(parent, structure) {
        return fromLoci(_query__WEBPACK_IMPORTED_MODULE_6__["StructureSelection"].toLociWithSourceUnits(_query__WEBPACK_IMPORTED_MODULE_6__["StructureSelection"].Singletons(parent, structure)));
    }
    Bundle.fromSubStructure = fromSubStructure;
    function fromSelection(selection) {
        return fromLoci(_query__WEBPACK_IMPORTED_MODULE_6__["StructureSelection"].toLociWithSourceUnits(selection));
    }
    Bundle.fromSelection = fromSelection;
    function fromLoci(loci) {
        var _elements = [];
        for (var _i = 0, _a = loci.elements; _i < _a.length; _i++) {
            var e = _a[_i];
            var unit = e.unit, indices = e.indices;
            if (_mol_data_int__WEBPACK_IMPORTED_MODULE_0__["OrderedSet"].size(indices) === 0)
                continue;
            var ranges = [];
            var set = [];
            if (_mol_data_int__WEBPACK_IMPORTED_MODULE_0__["OrderedSet"].isInterval(indices)) {
                if (_mol_data_int__WEBPACK_IMPORTED_MODULE_0__["OrderedSet"].size(indices) === 1) {
                    set.push(_mol_data_int__WEBPACK_IMPORTED_MODULE_0__["Interval"].min(indices));
                }
                else {
                    ranges.push(_mol_data_int__WEBPACK_IMPORTED_MODULE_0__["Interval"].min(indices), _mol_data_int__WEBPACK_IMPORTED_MODULE_0__["Interval"].max(indices));
                }
            }
            else {
                var i = 0, len = indices.length;
                while (i < len) {
                    var start = i;
                    i++;
                    while (i < len && indices[i - 1] + 1 === indices[i])
                        i++;
                    var end = i;
                    if (end - start > 2) {
                        ranges.push(indices[start], indices[end - 1]);
                    }
                    else {
                        for (var j = start; j < end; j++) {
                            set[set.length] = indices[j];
                        }
                    }
                }
            }
            _elements.push({
                unit: unit,
                set: _mol_data_int__WEBPACK_IMPORTED_MODULE_0__["SortedArray"].ofSortedArray(set),
                ranges: _mol_data_int_sorted_ranges__WEBPACK_IMPORTED_MODULE_3__["default"].ofSortedRanges(ranges)
            });
        }
        var elementGroups = new Map();
        for (var i = 0, il = _elements.length; i < il; ++i) {
            var e = _elements[i];
            var key = Object(_mol_data_util__WEBPACK_IMPORTED_MODULE_2__["hash2"])(Object(_mol_data_util__WEBPACK_IMPORTED_MODULE_2__["hashFnv32a"])(e.ranges), Object(_mol_data_util__WEBPACK_IMPORTED_MODULE_2__["hashFnv32a"])(e.set));
            if (elementGroups.has(key)) {
                var groupedUnits = elementGroups.get(key).groupedUnits;
                if (groupedUnits.has(e.unit.invariantId)) {
                    groupedUnits.get(e.unit.invariantId).push(e.unit.id);
                }
                else {
                    groupedUnits.set(e.unit.invariantId, [e.unit.id]);
                }
            }
            else {
                var groupedUnits = new Map();
                groupedUnits.set(e.unit.invariantId, [e.unit.id]);
                elementGroups.set(key, { groupedUnits: groupedUnits, set: e.set, ranges: e.ranges });
            }
        }
        var elements = [];
        elementGroups.forEach(function (e) {
            var groupedUnits = [];
            e.groupedUnits.forEach(function (g) { return groupedUnits.push(_mol_data_int__WEBPACK_IMPORTED_MODULE_0__["SortedArray"].ofUnsortedArray(g)); });
            groupedUnits.sort(function (a, b) { return a[0] - b[0]; }); // sort by first unit id of each group
            elements.push({ groupedUnits: groupedUnits, set: e.set, ranges: e.ranges });
        });
        return { hash: loci.structure.hashCode, elements: elements };
    }
    Bundle.fromLoci = fromLoci;
    function getUnitsFromIds(unitIds, structure) {
        var units = [];
        for (var i = 0, il = unitIds.length; i < il; ++i) {
            var unitId = unitIds[i];
            if (structure.unitMap.has(unitId))
                units.push(structure.unitMap.get(unitId));
        }
        return units;
    }
    function toLoci(bundle, structure) {
        if (bundle.hash !== -1 && bundle.hash !== structure.hashCode) {
            new Error('Bundle not compatible with given structure');
        }
        var elements = [];
        for (var _i = 0, _a = bundle.elements; _i < _a.length; _i++) {
            var e = _a[_i];
            var _loop_1 = function (g) {
                var units = getUnitsFromIds(g, structure);
                if (units.length === 0)
                    return "continue";
                var indices = void 0;
                if (e.ranges.length === 0) {
                    indices = e.set;
                }
                else if (e.set.length === 0) {
                    if (e.ranges.length === 2) {
                        indices = _mol_data_int__WEBPACK_IMPORTED_MODULE_0__["Interval"].ofRange(e.ranges[0], e.ranges[1]);
                    }
                    else {
                        var _indices_1 = new Int32Array(_mol_data_int_sorted_ranges__WEBPACK_IMPORTED_MODULE_3__["default"].size(e.ranges));
                        _mol_data_int_sorted_ranges__WEBPACK_IMPORTED_MODULE_3__["default"].forEach(e.ranges, function (v, i) { return _indices_1[i] = v; });
                        indices = _mol_data_int__WEBPACK_IMPORTED_MODULE_0__["SortedArray"].ofSortedArray(_indices_1);
                    }
                }
                else {
                    var rangesSize = _mol_data_int_sorted_ranges__WEBPACK_IMPORTED_MODULE_3__["default"].size(e.ranges);
                    var _indices_2 = new Int32Array(e.set.length + rangesSize);
                    _mol_data_int_sorted_ranges__WEBPACK_IMPORTED_MODULE_3__["default"].forEach(e.ranges, function (v, i) { return _indices_2[i] = v; });
                    _indices_2.set(e.set, rangesSize);
                    indices = _mol_data_int__WEBPACK_IMPORTED_MODULE_0__["SortedArray"].ofUnsortedArray(_indices_2); // requires sort
                }
                for (var _i = 0, units_1 = units; _i < units_1.length; _i++) {
                    var unit = units_1[_i];
                    elements.push({ unit: unit, indices: indices });
                }
            };
            for (var _b = 0, _c = e.groupedUnits; _b < _c.length; _b++) {
                var g = _c[_b];
                _loop_1(g);
            }
        }
        return Object(_loci__WEBPACK_IMPORTED_MODULE_4__["Loci"])(structure, elements);
    }
    Bundle.toLoci = toLoci;
    function toStructure(bundle, parent) {
        if (bundle.hash !== -1 && bundle.hash !== parent.hashCode) {
            new Error('Bundle not compatible with given structure');
        }
        var units = [];
        for (var _i = 0, _a = bundle.elements; _i < _a.length; _i++) {
            var e = _a[_i];
            var _loop_2 = function (g) {
                var _units = getUnitsFromIds(g, parent);
                if (_units.length === 0)
                    return "continue";
                var ue = _units[0].elements; // the elements are grouped by unit.invariantId
                var rangesSize = _mol_data_int_sorted_ranges__WEBPACK_IMPORTED_MODULE_3__["default"].size(e.ranges);
                var setSize = e.set.length;
                var _indices = new Int32Array(setSize + rangesSize);
                var indices = void 0;
                if (rangesSize === 0) {
                    for (var i = 0, il = setSize; i < il; ++i) {
                        _indices[i] = ue[e.set[i]];
                    }
                    indices = _mol_data_int__WEBPACK_IMPORTED_MODULE_0__["SortedArray"].ofSortedArray(_indices);
                }
                else if (setSize === 0) {
                    _mol_data_int_sorted_ranges__WEBPACK_IMPORTED_MODULE_3__["default"].forEach(e.ranges, function (v, i) { return _indices[i] = ue[v]; });
                    indices = _mol_data_int__WEBPACK_IMPORTED_MODULE_0__["SortedArray"].ofSortedArray(_indices);
                }
                else {
                    if (_mol_data_int__WEBPACK_IMPORTED_MODULE_0__["SortedArray"].min(e.set) > _mol_data_int_sorted_ranges__WEBPACK_IMPORTED_MODULE_3__["default"].max(e.ranges)) {
                        _mol_data_int_sorted_ranges__WEBPACK_IMPORTED_MODULE_3__["default"].forEach(e.ranges, function (v, i) { return _indices[i] = ue[v]; });
                        for (var i = 0, il = setSize; i < il; ++i) {
                            _indices[i + rangesSize] = ue[e.set[i]];
                        }
                        indices = _mol_data_int__WEBPACK_IMPORTED_MODULE_0__["SortedArray"].ofSortedArray(_indices);
                    }
                    else if (_mol_data_int_sorted_ranges__WEBPACK_IMPORTED_MODULE_3__["default"].min(e.ranges) > _mol_data_int__WEBPACK_IMPORTED_MODULE_0__["SortedArray"].max(e.set)) {
                        for (var i = 0, il = setSize; i < il; ++i) {
                            _indices[i] = ue[e.set[i]];
                        }
                        _mol_data_int_sorted_ranges__WEBPACK_IMPORTED_MODULE_3__["default"].forEach(e.ranges, function (v, i) { return _indices[i + setSize] = ue[v]; });
                        indices = _mol_data_int__WEBPACK_IMPORTED_MODULE_0__["SortedArray"].ofSortedArray(_indices);
                    }
                    else {
                        _mol_data_int_sorted_ranges__WEBPACK_IMPORTED_MODULE_3__["default"].forEach(e.ranges, function (v, i) { return _indices[i] = ue[v]; });
                        for (var i = 0, il = setSize; i < il; ++i) {
                            _indices[i + rangesSize] = ue[e.set[i]];
                        }
                        indices = _mol_data_int__WEBPACK_IMPORTED_MODULE_0__["SortedArray"].ofUnsortedArray(_indices); // requires sort
                    }
                }
                for (var _i = 0, _units_1 = _units; _i < _units_1.length; _i++) {
                    var unit = _units_1[_i];
                    units.push(unit.getChild(indices));
                }
            };
            for (var _b = 0, _c = e.groupedUnits; _b < _c.length; _b++) {
                var g = _c[_b];
                _loop_2(g);
            }
        }
        return _structure__WEBPACK_IMPORTED_MODULE_1__["default"].create(units, { parent: parent });
    }
    Bundle.toStructure = toStructure;
    function elementToExpression(e) {
        return _mol_script_language_builder__WEBPACK_IMPORTED_MODULE_5__["MolScriptBuilder"].internal.generator.bundleElement({
            groupedUnits: _mol_script_language_builder__WEBPACK_IMPORTED_MODULE_5__["MolScriptBuilder"].core.type.list(e.groupedUnits.map(function (u) { return _mol_script_language_builder__WEBPACK_IMPORTED_MODULE_5__["MolScriptBuilder"].core.type.list(u); })),
            ranges: _mol_script_language_builder__WEBPACK_IMPORTED_MODULE_5__["MolScriptBuilder"].core.type.list(e.ranges),
            set: _mol_script_language_builder__WEBPACK_IMPORTED_MODULE_5__["MolScriptBuilder"].core.type.list(e.set),
        });
    }
    function toExpression(bundle) {
        return _mol_script_language_builder__WEBPACK_IMPORTED_MODULE_5__["MolScriptBuilder"].internal.generator.bundle({
            elements: _mol_script_language_builder__WEBPACK_IMPORTED_MODULE_5__["MolScriptBuilder"].core.type.list(bundle.elements.map(elementToExpression))
        });
    }
    Bundle.toExpression = toExpression;
    function areEqual(a, b) {
        if (a.elements.length !== b.elements.length)
            return false;
        for (var i = 0, il = a.elements.length; i < il; ++i) {
            var elementA = a.elements[i], elementB = b.elements[i];
            if (elementA.groupedUnits.length !== elementB.groupedUnits.length)
                return false;
            for (var j = 0, jl = elementB.groupedUnits.length; j < jl; ++j) {
                if (!_mol_data_int__WEBPACK_IMPORTED_MODULE_0__["SortedArray"].areEqual(elementA.groupedUnits[j], elementB.groupedUnits[j]))
                    return false;
            }
            if (!_mol_data_int__WEBPACK_IMPORTED_MODULE_0__["SortedArray"].areEqual(elementA.set, elementB.set))
                return false;
            if (!_mol_data_int_sorted_ranges__WEBPACK_IMPORTED_MODULE_3__["default"].areEqual(elementA.ranges, elementB.ranges))
                return false;
        }
        return true;
    }
    Bundle.areEqual = areEqual;
})(Bundle || (Bundle = {}));
//# sourceMappingURL=bundle.js.map

/***/ }),

/***/ "./lib/mol-model/structure/structure/element/element.js":
/*!**************************************************************!*\
  !*** ./lib/mol-model/structure/structure/element/element.js ***!
  \**************************************************************/
/*! exports provided: property, atomicProperty, coarseProperty, residueIndex, chainIndex, entityIndex */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "property", function() { return property; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "atomicProperty", function() { return atomicProperty; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "coarseProperty", function() { return coarseProperty; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "residueIndex", function() { return residueIndex; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "chainIndex", function() { return chainIndex; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "entityIndex", function() { return entityIndex; });
/* harmony import */ var _unit__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../unit */ "./lib/mol-model/structure/structure/unit.js");
/* harmony import */ var _properties__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../properties */ "./lib/mol-model/structure/structure/properties.js");
/**
 * Copyright (c) 2017-2019 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author David Sehnal <david.sehnal@gmail.com>
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */


function property(p) { return p; }
function _wrongUnitKind(kind) { throw new Error("Property only available for " + kind + " models."); }
function atomicProperty(p) {
    return property(function (l) { return _unit__WEBPACK_IMPORTED_MODULE_0__["default"].isAtomic(l.unit) ? p(l) : _wrongUnitKind('atomic'); });
}
function coarseProperty(p) {
    return property(function (l) { return _unit__WEBPACK_IMPORTED_MODULE_0__["default"].isCoarse(l.unit) ? p(l) : _wrongUnitKind('coarse'); });
}
function residueIndex(e) {
    if (_unit__WEBPACK_IMPORTED_MODULE_0__["default"].isAtomic(e.unit)) {
        return e.unit.residueIndex[e.element];
    }
    else {
        // TODO: throw error instead?
        return -1;
    }
}
function chainIndex(e) {
    if (_unit__WEBPACK_IMPORTED_MODULE_0__["default"].isAtomic(e.unit)) {
        return e.unit.chainIndex[e.element];
    }
    else {
        // TODO: throw error instead?
        return -1;
    }
}
function entityIndex(l) {
    return _properties__WEBPACK_IMPORTED_MODULE_1__["default"].entity.key(l);
}
//# sourceMappingURL=element.js.map

/***/ }),

/***/ "./lib/mol-model/structure/structure/element/index.js":
/*!************************************************************!*\
  !*** ./lib/mol-model/structure/structure/element/index.js ***!
  \************************************************************/
/*! exports provided: Location, Loci, Bundle, Stats, property, atomicProperty, coarseProperty, residueIndex, chainIndex, entityIndex */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _location__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./location */ "./lib/mol-model/structure/structure/element/location.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Location", function() { return _location__WEBPACK_IMPORTED_MODULE_0__["Location"]; });

/* harmony import */ var _loci__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./loci */ "./lib/mol-model/structure/structure/element/loci.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Loci", function() { return _loci__WEBPACK_IMPORTED_MODULE_1__["Loci"]; });

/* harmony import */ var _bundle__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./bundle */ "./lib/mol-model/structure/structure/element/bundle.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Bundle", function() { return _bundle__WEBPACK_IMPORTED_MODULE_2__["Bundle"]; });

/* harmony import */ var _stats__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./stats */ "./lib/mol-model/structure/structure/element/stats.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Stats", function() { return _stats__WEBPACK_IMPORTED_MODULE_3__["Stats"]; });

/* harmony import */ var _element__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./element */ "./lib/mol-model/structure/structure/element/element.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "property", function() { return _element__WEBPACK_IMPORTED_MODULE_4__["property"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "atomicProperty", function() { return _element__WEBPACK_IMPORTED_MODULE_4__["atomicProperty"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "coarseProperty", function() { return _element__WEBPACK_IMPORTED_MODULE_4__["coarseProperty"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "residueIndex", function() { return _element__WEBPACK_IMPORTED_MODULE_4__["residueIndex"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "chainIndex", function() { return _element__WEBPACK_IMPORTED_MODULE_4__["chainIndex"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "entityIndex", function() { return _element__WEBPACK_IMPORTED_MODULE_4__["entityIndex"]; });

/**
 * Copyright (c) 2017-2019 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author David Sehnal <david.sehnal@gmail.com>
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */





//# sourceMappingURL=index.js.map

/***/ }),

/***/ "./lib/mol-model/structure/structure/element/location.js":
/*!***************************************************************!*\
  !*** ./lib/mol-model/structure/structure/element/location.js ***!
  \***************************************************************/
/*! exports provided: Location */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Location", function() { return Location; });
/* harmony import */ var _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../../../mol-math/linear-algebra */ "./lib/mol-math/linear-algebra.js");
/**
 * Copyright (c) 2017-2020 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author David Sehnal <david.sehnal@gmail.com>
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */


var Location;
(function (Location) {
    function create(structure, unit, element) {
        return {
            kind: 'element-location',
            structure: structure,
            unit: unit,
            element: element || 0
        };
    }
    Location.create = create;
    function clone(l) {
        return create(l.structure, l.unit, l.element);
    }
    Location.clone = clone;
    function set(a, structure, unit, element) {
        if (structure)
            a.structure = structure;
        if (unit)
            a.unit = unit;
        if (element !== undefined)
            a.element = element;
        return a;
    }
    Location.set = set;
    function copy(out, a) {
        out.unit = a.unit;
        out.element = a.element;
        return out;
    }
    Location.copy = copy;
    function is(x) {
        return !!x && x.kind === 'element-location';
    }
    Location.is = is;
    function areEqual(a, b) {
        return a.unit === b.unit && a.element === b.element;
    }
    Location.areEqual = areEqual;
    var pA = _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"].zero(), pB = _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"].zero();
    function distance(a, b) {
        a.unit.conformation.position(a.element, pA);
        b.unit.conformation.position(b.element, pB);
        return _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"].distance(pA, pB);
    }
    Location.distance = distance;
    function residueIndex(l) {
        return l.unit.model.atomicHierarchy.residueAtomSegments.index[l.element];
    }
    Location.residueIndex = residueIndex;
    function chainIndex(l) {
        return l.unit.model.atomicHierarchy.chainAtomSegments.index[l.element];
    }
    Location.chainIndex = chainIndex;
})(Location || (Location = {}));
//# sourceMappingURL=location.js.map

/***/ }),

/***/ "./lib/mol-model/structure/structure/element/loci.js":
/*!***********************************************************!*\
  !*** ./lib/mol-model/structure/structure/element/loci.js ***!
  \***********************************************************/
/*! exports provided: Loci */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Loci", function() { return Loci; });
/* harmony import */ var _mol_data_generic__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../../../mol-data/generic */ "./lib/mol-data/generic.js");
/* harmony import */ var _mol_data_int__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../../../mol-data/int */ "./lib/mol-data/int.js");
/* harmony import */ var _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../../../mol-math/linear-algebra */ "./lib/mol-math/linear-algebra.js");
/* harmony import */ var _mol_script_language_builder__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../../../mol-script/language/builder */ "./lib/mol-script/language/builder.js");
/* harmony import */ var _structure__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../structure */ "./lib/mol-model/structure/structure/structure.js");
/* harmony import */ var _unit__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../unit */ "./lib/mol-model/structure/structure/unit.js");
/* harmony import */ var _mol_data_util__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../../../../mol-data/util */ "./lib/mol-data/util.js");
/* harmony import */ var _location__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ./location */ "./lib/mol-model/structure/structure/element/location.js");
/* harmony import */ var _mol_math_linear_algebra_matrix_principal_axes__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ../../../../mol-math/linear-algebra/matrix/principal-axes */ "./lib/mol-math/linear-algebra/matrix/principal-axes.js");
/* harmony import */ var _properties__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ../properties */ "./lib/mol-model/structure/structure/properties.js");
/* harmony import */ var _mol_math_geometry_boundary_helper__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ../../../../mol-math/geometry/boundary-helper */ "./lib/mol-math/geometry/boundary-helper.js");
/**
 * Copyright (c) 2017-2020 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author David Sehnal <david.sehnal@gmail.com>
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */











function Loci(structure, elements) {
    return { kind: 'element-loci', structure: structure, elements: elements };
}
(function (Loci) {
    function is(x) {
        return !!x && x.kind === 'element-loci';
    }
    Loci.is = is;
    function areEqual(a, b) {
        if (a.structure !== b.structure)
            return false;
        if (a.elements.length !== b.elements.length)
            return false;
        for (var i = 0, il = a.elements.length; i < il; ++i) {
            var elementA = a.elements[i];
            var elementB = b.elements[i];
            if (elementA.unit.id !== elementB.unit.id)
                return false;
            if (!_mol_data_int__WEBPACK_IMPORTED_MODULE_1__["OrderedSet"].areEqual(elementA.indices, elementB.indices))
                return false;
        }
        return true;
    }
    Loci.areEqual = areEqual;
    function isEmpty(loci) {
        return size(loci) === 0;
    }
    Loci.isEmpty = isEmpty;
    function isWholeStructure(loci) {
        return size(loci) === loci.structure.elementCount;
    }
    Loci.isWholeStructure = isWholeStructure;
    function size(loci) {
        var s = 0;
        for (var _a = 0, _b = loci.elements; _a < _b.length; _a++) {
            var u = _b[_a];
            s += _mol_data_int__WEBPACK_IMPORTED_MODULE_1__["OrderedSet"].size(u.indices);
        }
        return s;
    }
    Loci.size = size;
    function all(structure) {
        return Loci(structure, structure.units.map(function (unit) { return ({
            unit: unit,
            indices: _mol_data_int__WEBPACK_IMPORTED_MODULE_1__["OrderedSet"].ofBounds(0, unit.elements.length)
        }); }));
    }
    Loci.all = all;
    function none(structure) {
        return Loci(structure, []);
    }
    Loci.none = none;
    function getFirstLocation(loci, e) {
        if (isEmpty(loci))
            return void 0;
        var unit = loci.elements[0].unit;
        var element = unit.elements[_mol_data_int__WEBPACK_IMPORTED_MODULE_1__["OrderedSet"].getAt(loci.elements[0].indices, 0)];
        if (e) {
            e.structure = loci.structure;
            e.unit = loci.elements[0].unit;
            e.element = element;
            return e;
        }
        return _location__WEBPACK_IMPORTED_MODULE_7__["Location"].create(loci.structure, unit, element);
    }
    Loci.getFirstLocation = getFirstLocation;
    function firstElement(loci) {
        if (isEmpty(loci))
            return loci;
        return Loci(loci.structure, [{
                unit: loci.elements[0].unit,
                indices: _mol_data_int__WEBPACK_IMPORTED_MODULE_1__["OrderedSet"].ofSingleton(_mol_data_int__WEBPACK_IMPORTED_MODULE_1__["OrderedSet"].start(loci.elements[0].indices))
            }]);
    }
    Loci.firstElement = firstElement;
    function firstResidue(loci) {
        if (isEmpty(loci))
            return loci;
        return extendToWholeResidues(firstElement(loci));
    }
    Loci.firstResidue = firstResidue;
    function firstChain(loci) {
        if (isEmpty(loci))
            return loci;
        return extendToWholeChains(firstElement(loci));
    }
    Loci.firstChain = firstChain;
    function toStructure(loci) {
        var units = [];
        var _loop_1 = function (e) {
            var unit = e.unit, indices = e.indices;
            var elements = new Int32Array(_mol_data_int__WEBPACK_IMPORTED_MODULE_1__["OrderedSet"].size(indices));
            _mol_data_int__WEBPACK_IMPORTED_MODULE_1__["OrderedSet"].forEach(indices, function (v, i) { return elements[i] = unit.elements[v]; });
            units.push(unit.getChild(_mol_data_int__WEBPACK_IMPORTED_MODULE_1__["SortedArray"].ofSortedArray(elements)));
        };
        for (var _a = 0, _b = loci.elements; _a < _b.length; _a++) {
            var e = _b[_a];
            _loop_1(e);
        }
        return _structure__WEBPACK_IMPORTED_MODULE_4__["default"].create(units, { parent: loci.structure.parent });
    }
    Loci.toStructure = toStructure;
    // TODO: there should be a version that property supports partitioned units
    function remap(loci, structure) {
        if (structure === loci.structure)
            return loci;
        var elements = [];
        loci.elements.forEach(function (e) {
            if (!structure.unitMap.has(e.unit.id))
                return;
            var unit = structure.unitMap.get(e.unit.id);
            var indices = _mol_data_int__WEBPACK_IMPORTED_MODULE_1__["OrderedSet"].indexedIntersect(e.indices, e.unit.elements, unit.elements);
            if (_mol_data_int__WEBPACK_IMPORTED_MODULE_1__["OrderedSet"].size(indices) > 0)
                elements.push({ unit: unit, indices: indices });
        });
        return Loci(structure, elements);
    }
    Loci.remap = remap;
    /** Create union of `xs` and `ys` */
    function union(xs, ys) {
        if (xs.elements.length > ys.elements.length)
            return union(ys, xs);
        if (Loci.isEmpty(xs))
            return ys;
        var map = new Map();
        for (var _a = 0, _b = xs.elements; _a < _b.length; _a++) {
            var e = _b[_a];
            map.set(e.unit.id, e.indices);
        }
        var elements = [];
        for (var _c = 0, _d = ys.elements; _c < _d.length; _c++) {
            var e = _d[_c];
            if (map.has(e.unit.id)) {
                elements[elements.length] = { unit: e.unit, indices: _mol_data_int__WEBPACK_IMPORTED_MODULE_1__["OrderedSet"].union(map.get(e.unit.id), e.indices) };
                map.delete(e.unit.id);
            }
            else {
                elements[elements.length] = e;
            }
        }
        map.forEach(function (indices, id) {
            elements[elements.length] = { unit: xs.structure.unitMap.get(id), indices: indices };
        });
        return Loci(xs.structure, elements);
    }
    Loci.union = union;
    /** Subtract `ys` from `xs` */
    function subtract(xs, ys) {
        var map = new Map();
        for (var _a = 0, _b = ys.elements; _a < _b.length; _a++) {
            var e = _b[_a];
            map.set(e.unit.id, e.indices);
        }
        var elements = [];
        for (var _c = 0, _d = xs.elements; _c < _d.length; _c++) {
            var e = _d[_c];
            if (map.has(e.unit.id)) {
                var indices = _mol_data_int__WEBPACK_IMPORTED_MODULE_1__["OrderedSet"].subtract(e.indices, map.get(e.unit.id));
                if (_mol_data_int__WEBPACK_IMPORTED_MODULE_1__["OrderedSet"].size(indices) === 0)
                    continue;
                elements[elements.length] = { unit: e.unit, indices: indices };
            }
            else {
                elements[elements.length] = e;
            }
        }
        return Loci(xs.structure, elements);
    }
    Loci.subtract = subtract;
    /** Intersect `xs` and `ys` */
    function intersect(xs, ys) {
        var map = new Map();
        for (var _a = 0, _b = xs.elements; _a < _b.length; _a++) {
            var e = _b[_a];
            map.set(e.unit.id, e.indices);
        }
        var elements = [];
        for (var _c = 0, _d = ys.elements; _c < _d.length; _c++) {
            var e = _d[_c];
            if (!map.has(e.unit.id))
                continue;
            var indices = _mol_data_int__WEBPACK_IMPORTED_MODULE_1__["OrderedSet"].intersect(map.get(e.unit.id), e.indices);
            if (_mol_data_int__WEBPACK_IMPORTED_MODULE_1__["OrderedSet"].size(indices) === 0)
                continue;
            elements[elements.length] = { unit: e.unit, indices: indices };
        }
        return Loci(xs.structure, elements);
    }
    Loci.intersect = intersect;
    function areIntersecting(xs, ys) {
        if (xs.elements.length > ys.elements.length)
            return areIntersecting(ys, xs);
        if (Loci.isEmpty(xs))
            return Loci.isEmpty(ys);
        var map = new Map();
        for (var _a = 0, _b = xs.elements; _a < _b.length; _a++) {
            var e = _b[_a];
            map.set(e.unit.id, e.indices);
        }
        for (var _c = 0, _d = ys.elements; _c < _d.length; _c++) {
            var e = _d[_c];
            if (!map.has(e.unit.id))
                continue;
            if (_mol_data_int__WEBPACK_IMPORTED_MODULE_1__["OrderedSet"].areIntersecting(map.get(e.unit.id), e.indices))
                return true;
        }
        return false;
    }
    Loci.areIntersecting = areIntersecting;
    /** Check if second loci is a subset of the first */
    function isSubset(xs, ys) {
        if (Loci.isEmpty(xs))
            return Loci.isEmpty(ys);
        var map = new Map();
        for (var _a = 0, _b = xs.elements; _a < _b.length; _a++) {
            var e = _b[_a];
            map.set(e.unit.id, e.indices);
        }
        var isSubset = false;
        for (var _c = 0, _d = ys.elements; _c < _d.length; _c++) {
            var e = _d[_c];
            if (!map.has(e.unit.id))
                continue;
            if (!_mol_data_int__WEBPACK_IMPORTED_MODULE_1__["OrderedSet"].isSubset(map.get(e.unit.id), e.indices))
                return false;
            else
                isSubset = true;
        }
        return isSubset;
    }
    Loci.isSubset = isSubset;
    function extendToWholeResidues(loci, restrictToConformation) {
        var elements = [];
        var residueAltIds = new Set();
        for (var _a = 0, _b = loci.elements; _a < _b.length; _a++) {
            var lociElement = _b[_a];
            if (isWholeUnit(lociElement)) {
                elements[elements.length] = lociElement;
                continue;
            }
            if (lociElement.unit.kind === 0 /* Atomic */) {
                var unitElements = lociElement.unit.elements;
                var h = lociElement.unit.model.atomicHierarchy;
                var label_alt_id = lociElement.unit.model.atomicHierarchy.atoms.label_alt_id;
                var _c = h.residueAtomSegments, residueIndex = _c.index, residueOffsets = _c.offsets;
                var newIndices = [];
                var indices = lociElement.indices, len = _mol_data_int__WEBPACK_IMPORTED_MODULE_1__["OrderedSet"].size(indices);
                var i = 0;
                while (i < len) {
                    residueAltIds.clear();
                    var eI = unitElements[_mol_data_int__WEBPACK_IMPORTED_MODULE_1__["OrderedSet"].getAt(indices, i)];
                    var rI = residueIndex[eI];
                    residueAltIds.add(label_alt_id.value(eI));
                    i++;
                    while (i < len) {
                        var eI_1 = unitElements[_mol_data_int__WEBPACK_IMPORTED_MODULE_1__["OrderedSet"].getAt(indices, i)];
                        if (residueIndex[eI_1] !== rI)
                            break;
                        residueAltIds.add(label_alt_id.value(eI_1));
                        i++;
                    }
                    var hasSharedAltId = residueAltIds.has('');
                    for (var j = residueOffsets[rI], _j = residueOffsets[rI + 1]; j < _j; j++) {
                        var idx = _mol_data_int__WEBPACK_IMPORTED_MODULE_1__["OrderedSet"].indexOf(unitElements, j);
                        if (idx >= 0) {
                            var altId = label_alt_id.value(j);
                            if (!restrictToConformation || hasSharedAltId || !altId || residueAltIds.has(altId)) {
                                newIndices[newIndices.length] = idx;
                            }
                        }
                    }
                }
                elements[elements.length] = { unit: lociElement.unit, indices: _mol_data_int__WEBPACK_IMPORTED_MODULE_1__["SortedArray"].ofSortedArray(newIndices) };
            }
            else {
                // coarse elements are already by-residue
                elements[elements.length] = lociElement;
            }
        }
        return Loci(loci.structure, elements);
    }
    Loci.extendToWholeResidues = extendToWholeResidues;
    function getChainSegments(unit) {
        switch (unit.kind) {
            case 0 /* Atomic */: return unit.model.atomicHierarchy.chainAtomSegments;
            case 1 /* Spheres */: return unit.model.coarseHierarchy.spheres.chainElementSegments;
            case 2 /* Gaussians */: return unit.model.coarseHierarchy.gaussians.chainElementSegments;
        }
    }
    function isWholeUnit(element) {
        return element.unit.elements.length === _mol_data_int__WEBPACK_IMPORTED_MODULE_1__["OrderedSet"].size(element.indices);
    }
    function makeIndexSet(newIndices) {
        if (newIndices.length > 12 && newIndices[newIndices.length - 1] - newIndices[0] === newIndices.length - 1) {
            return _mol_data_int__WEBPACK_IMPORTED_MODULE_1__["Interval"].ofRange(newIndices[0], newIndices[newIndices.length - 1]);
        }
        else {
            return _mol_data_int__WEBPACK_IMPORTED_MODULE_1__["SortedArray"].ofSortedArray(newIndices);
        }
    }
    function collectChains(unit, chainIndices, elements) {
        var index = getChainSegments(unit).index;
        var xs = unit.elements;
        var size = 0;
        for (var i = 0, _i = xs.length; i < _i; i++) {
            var eI = xs[i];
            var cI = index[eI];
            if (!chainIndices.has(cI))
                continue;
            size++;
        }
        if (size === unit.elements.length) {
            elements[elements.length] = { unit: unit, indices: _mol_data_int__WEBPACK_IMPORTED_MODULE_1__["Interval"].ofBounds(0, size) };
            return;
        }
        var newIndices = new Int32Array(size);
        size = 0;
        for (var i = 0, _i = xs.length; i < _i; i++) {
            var eI = xs[i];
            var cI = index[eI];
            if (!chainIndices.has(cI))
                continue;
            newIndices[size++] = i;
        }
        if (newIndices.length > 0) {
            elements[elements.length] = { unit: unit, indices: makeIndexSet(newIndices) };
        }
    }
    function extendGroupToWholeChains(loci, start, end, isPartitioned, elements) {
        var chainIndex = getChainSegments(loci.elements[0].unit).index;
        var chainIndices = new Set();
        for (var lI = start; lI < end; lI++) {
            var lociElement = loci.elements[lI];
            var indices = lociElement.indices;
            var unitElements = lociElement.unit.elements;
            for (var i = 0, _i = _mol_data_int__WEBPACK_IMPORTED_MODULE_1__["OrderedSet"].size(indices); i < _i; i++) {
                chainIndices.add(chainIndex[unitElements[_mol_data_int__WEBPACK_IMPORTED_MODULE_1__["OrderedSet"].getAt(indices, i)]]);
            }
        }
        if (isPartitioned) {
            var baseUnit = loci.elements[0].unit;
            // TODO: check for accidental quadratic for really large structures (but should be ok).
            for (var _a = 0, _b = loci.structure.units; _a < _b.length; _a++) {
                var unit = _b[_a];
                if (!_unit__WEBPACK_IMPORTED_MODULE_5__["default"].areSameChainOperatorGroup(unit, baseUnit))
                    continue;
                collectChains(unit, chainIndices, elements);
            }
        }
        else {
            for (var lI = start; lI < end; lI++) {
                collectChains(loci.elements[lI].unit, chainIndices, elements);
            }
        }
    }
    function extendToWholeChains(loci) {
        var elements = [];
        for (var i = 0, len = loci.elements.length; i < len; i++) {
            var e = loci.elements[i];
            if (_unit__WEBPACK_IMPORTED_MODULE_5__["default"].Traits.is(e.unit.traits, 2 /* Partitioned */)) {
                var start = i;
                while (i < len && _unit__WEBPACK_IMPORTED_MODULE_5__["default"].areSameChainOperatorGroup(loci.elements[i].unit, e.unit)) {
                    i++;
                }
                var end = i;
                i--;
                extendGroupToWholeChains(loci, start, end, true, elements);
            }
            else {
                if (isWholeUnit(e)) {
                    elements[elements.length] = e;
                }
                else {
                    extendGroupToWholeChains(loci, i, i + 1, false, elements);
                }
            }
        }
        return Loci(loci.structure, elements);
    }
    Loci.extendToWholeChains = extendToWholeChains;
    function entityModelKey(location) {
        return location.unit.model.id + "|" + _properties__WEBPACK_IMPORTED_MODULE_9__["default"].entity.id(location);
    }
    function extendToWholeEntities(loci) {
        var elements = [];
        var l = _location__WEBPACK_IMPORTED_MODULE_7__["Location"].create(loci.structure);
        var entities = new Set();
        var units = loci.structure.units;
        for (var i = 0, len = loci.elements.length; i < len; i++) {
            var e = loci.elements[i];
            l.unit = e.unit;
            l.element = e.unit.elements[0];
            entities.add(entityModelKey(l));
        }
        for (var i = 0, il = units.length; i < il; ++i) {
            var unit = units[i];
            l.unit = unit;
            l.element = unit.elements[0];
            if (entities.has(entityModelKey(l))) {
                var indices = _mol_data_int__WEBPACK_IMPORTED_MODULE_1__["OrderedSet"].ofBounds(0, unit.elements.length);
                elements[elements.length] = { unit: unit, indices: indices };
            }
        }
        return Loci(loci.structure, elements);
    }
    Loci.extendToWholeEntities = extendToWholeEntities;
    function extendToWholeModels(loci) {
        var elements = [];
        var models = new Set();
        var units = loci.structure.units;
        for (var i = 0, len = loci.elements.length; i < len; i++) {
            var e = loci.elements[i];
            models.add(e.unit.model.id);
        }
        for (var i = 0, il = units.length; i < il; ++i) {
            var unit = units[i];
            if (models.has(unit.model.id)) {
                var indices = _mol_data_int__WEBPACK_IMPORTED_MODULE_1__["OrderedSet"].ofBounds(0, unit.elements.length);
                elements[elements.length] = { unit: unit, indices: indices };
            }
        }
        return Loci(loci.structure, elements);
    }
    Loci.extendToWholeModels = extendToWholeModels;
    function getElementIndices(elements, indices) {
        var elementIndices = [];
        for (var i = 0, il = _mol_data_int__WEBPACK_IMPORTED_MODULE_1__["OrderedSet"].size(indices); i < il; ++i) {
            elementIndices.push(elements[_mol_data_int__WEBPACK_IMPORTED_MODULE_1__["OrderedSet"].getAt(indices, i)]);
        }
        return _mol_data_int__WEBPACK_IMPORTED_MODULE_1__["SortedArray"].ofSortedArray(elementIndices);
    }
    function getUnitIndices(elements, indices) {
        return _mol_data_int__WEBPACK_IMPORTED_MODULE_1__["SortedArray"].indicesOf(elements, indices);
    }
    function extendToAllInstances(loci) {
        var elements = [];
        var byModel = new Map();
        for (var i = 0, len = loci.elements.length; i < len; i++) {
            var e = loci.elements[i];
            var model = e.unit.model;
            var elementIndices = getElementIndices(e.unit.elements, e.indices);
            if (byModel.has(model)) {
                byModel.set(model, _mol_data_int__WEBPACK_IMPORTED_MODULE_1__["SortedArray"].union(elementIndices, byModel.get(model)));
            }
            else {
                byModel.set(model, elementIndices);
            }
        }
        for (var i = 0, il = loci.structure.units.length; i < il; ++i) {
            var unit = loci.structure.units[i];
            var elementIndices = byModel.get(unit.model);
            if (!elementIndices)
                continue;
            var indices = getUnitIndices(unit.elements, elementIndices);
            elements[elements.length] = { unit: unit, indices: indices };
        }
        return Loci(loci.structure, elements);
    }
    Loci.extendToAllInstances = extendToAllInstances;
    //
    var boundaryHelper = new _mol_math_geometry_boundary_helper__WEBPACK_IMPORTED_MODULE_10__["BoundaryHelper"]('98');
    var tempPosBoundary = Object(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_2__["Vec3"])();
    function getBoundary(loci, transform) {
        boundaryHelper.reset();
        for (var _a = 0, _b = loci.elements; _a < _b.length; _a++) {
            var e = _b[_a];
            var indices = e.indices;
            var pos = e.unit.conformation.position, r = e.unit.conformation.r;
            var elements = e.unit.elements;
            for (var i = 0, _i = _mol_data_int__WEBPACK_IMPORTED_MODULE_1__["OrderedSet"].size(indices); i < _i; i++) {
                var eI = elements[_mol_data_int__WEBPACK_IMPORTED_MODULE_1__["OrderedSet"].getAt(indices, i)];
                pos(eI, tempPosBoundary);
                if (transform)
                    _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_2__["Vec3"].transformMat4(tempPosBoundary, tempPosBoundary, transform);
                boundaryHelper.includePositionRadius(tempPosBoundary, r(eI));
            }
        }
        boundaryHelper.finishedIncludeStep();
        for (var _c = 0, _d = loci.elements; _c < _d.length; _c++) {
            var e = _d[_c];
            var indices = e.indices;
            var pos = e.unit.conformation.position, r = e.unit.conformation.r;
            var elements = e.unit.elements;
            for (var i = 0, _i = _mol_data_int__WEBPACK_IMPORTED_MODULE_1__["OrderedSet"].size(indices); i < _i; i++) {
                var eI = elements[_mol_data_int__WEBPACK_IMPORTED_MODULE_1__["OrderedSet"].getAt(indices, i)];
                pos(eI, tempPosBoundary);
                if (transform)
                    _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_2__["Vec3"].transformMat4(tempPosBoundary, tempPosBoundary, transform);
                boundaryHelper.radiusPositionRadius(tempPosBoundary, r(eI));
            }
        }
        return { box: boundaryHelper.getBox(), sphere: boundaryHelper.getSphere() };
    }
    Loci.getBoundary = getBoundary;
    var tempPos = Object(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_2__["Vec3"])();
    function toPositionsArray(loci, positions, offset) {
        if (offset === void 0) { offset = 0; }
        var m = offset;
        for (var _a = 0, _b = loci.elements; _a < _b.length; _a++) {
            var e = _b[_a];
            var indices = e.indices;
            var pos = e.unit.conformation.position;
            var elements = e.unit.elements;
            var indexCount = _mol_data_int__WEBPACK_IMPORTED_MODULE_1__["OrderedSet"].size(indices);
            for (var i = 0; i < indexCount; i++) {
                var eI = elements[_mol_data_int__WEBPACK_IMPORTED_MODULE_1__["OrderedSet"].getAt(indices, i)];
                pos(eI, tempPos);
                _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_2__["Vec3"].toArray(tempPos, positions, m + i * 3);
            }
            m += indexCount * 3;
        }
        return positions;
    }
    Loci.toPositionsArray = toPositionsArray;
    function getPrincipalAxes(loci) {
        var elementCount = size(loci);
        var positions = toPositionsArray(loci, new Float32Array(3 * elementCount));
        return _mol_math_linear_algebra_matrix_principal_axes__WEBPACK_IMPORTED_MODULE_8__["PrincipalAxes"].ofPositions(positions);
    }
    Loci.getPrincipalAxes = getPrincipalAxes;
    function sourceIndex(unit, element) {
        return _unit__WEBPACK_IMPORTED_MODULE_5__["default"].isAtomic(unit)
            ? unit.model.atomicHierarchy.atomSourceIndex.value(element)
            // TODO: when implemented, this should map to the source index.
            : element;
    }
    function toExpression(loci) {
        var _a;
        if (Loci.isEmpty(loci))
            return _mol_script_language_builder__WEBPACK_IMPORTED_MODULE_3__["MolScriptBuilder"].struct.generator.empty();
        var models = loci.structure.models;
        var sourceIndexMap = new Map();
        for (var _b = 0, _c = loci.elements; _b < _c.length; _b++) {
            var e = _c[_b];
            var indices = e.indices;
            var elements = e.unit.elements;
            var key = e.unit.conformation.operator.name;
            var sourceIndices = void 0;
            if (sourceIndexMap.has(key))
                sourceIndices = sourceIndexMap.get(key).xs;
            else {
                sourceIndices = _mol_data_generic__WEBPACK_IMPORTED_MODULE_0__["UniqueArray"].create();
                sourceIndexMap.set(key, { modelLabel: e.unit.model.label, modelIndex: e.unit.model.modelNum, xs: sourceIndices });
            }
            for (var i = 0, _i = _mol_data_int__WEBPACK_IMPORTED_MODULE_1__["OrderedSet"].size(indices); i < _i; i++) {
                var idx = sourceIndex(e.unit, elements[_mol_data_int__WEBPACK_IMPORTED_MODULE_1__["OrderedSet"].getAt(indices, i)]);
                _mol_data_generic__WEBPACK_IMPORTED_MODULE_0__["UniqueArray"].add(sourceIndices, idx, idx);
            }
        }
        var opData = [];
        var keys = sourceIndexMap.keys();
        while (true) {
            var k = keys.next();
            if (k.done)
                break;
            var e = sourceIndexMap.get(k.value);
            opData.push(getOpData(k.value, e.xs.array, models.length > 1, e.modelLabel, e.modelIndex));
        }
        var opGroups = new Map();
        for (var i = 0, il = opData.length; i < il; ++i) {
            var d = opData[i];
            var hash = Object(_mol_data_util__WEBPACK_IMPORTED_MODULE_6__["hash2"])(Object(_mol_data_util__WEBPACK_IMPORTED_MODULE_6__["hashFnv32a"])(d.atom.ranges), Object(_mol_data_util__WEBPACK_IMPORTED_MODULE_6__["hashFnv32a"])(d.atom.set));
            var key = hash + "|" + (d.entity ? (d.entity.modelLabel + d.entity.modelIndex) : '');
            if (opGroups.has(key)) {
                (_a = opGroups.get(key).chain.opName).push.apply(_a, d.chain.opName);
            }
            else {
                opGroups.set(key, d);
            }
        }
        var opQueries = [];
        opGroups.forEach(function (d) {
            var _a = d.atom, ranges = _a.ranges, set = _a.set;
            var opName = d.chain.opName;
            var opProp = _mol_script_language_builder__WEBPACK_IMPORTED_MODULE_3__["MolScriptBuilder"].struct.atomProperty.core.operatorName();
            var siProp = _mol_script_language_builder__WEBPACK_IMPORTED_MODULE_3__["MolScriptBuilder"].struct.atomProperty.core.sourceIndex();
            var tests = [];
            // TODO: add set.ofRanges constructor to MolQL???
            if (set.length > 0) {
                tests[tests.length] = _mol_script_language_builder__WEBPACK_IMPORTED_MODULE_3__["MolScriptBuilder"].core.set.has([_mol_script_language_builder__WEBPACK_IMPORTED_MODULE_3__["MolScriptBuilder"].core.type.set(set), siProp]);
            }
            for (var rI = 0, _rI = ranges.length / 2; rI < _rI; rI++) {
                tests[tests.length] = _mol_script_language_builder__WEBPACK_IMPORTED_MODULE_3__["MolScriptBuilder"].core.rel.inRange([siProp, ranges[2 * rI], ranges[2 * rI + 1]]);
            }
            if (d.entity) {
                var _b = d.entity, modelLabel = _b.modelLabel, modelIndex = _b.modelIndex;
                opQueries.push(_mol_script_language_builder__WEBPACK_IMPORTED_MODULE_3__["MolScriptBuilder"].struct.generator.atomGroups({
                    'atom-test': tests.length > 1 ? _mol_script_language_builder__WEBPACK_IMPORTED_MODULE_3__["MolScriptBuilder"].core.logic.or(tests) : tests[0],
                    'chain-test': opName.length > 1
                        ? _mol_script_language_builder__WEBPACK_IMPORTED_MODULE_3__["MolScriptBuilder"].core.set.has([_mol_script_language_builder__WEBPACK_IMPORTED_MODULE_3__["MolScriptBuilder"].core.type.set(opName), opProp])
                        : _mol_script_language_builder__WEBPACK_IMPORTED_MODULE_3__["MolScriptBuilder"].core.rel.eq([opProp, opName[0]]),
                    'entity-test': _mol_script_language_builder__WEBPACK_IMPORTED_MODULE_3__["MolScriptBuilder"].core.logic.and([
                        _mol_script_language_builder__WEBPACK_IMPORTED_MODULE_3__["MolScriptBuilder"].core.rel.eq([_mol_script_language_builder__WEBPACK_IMPORTED_MODULE_3__["MolScriptBuilder"].struct.atomProperty.core.modelLabel(), modelLabel]),
                        _mol_script_language_builder__WEBPACK_IMPORTED_MODULE_3__["MolScriptBuilder"].core.rel.eq([_mol_script_language_builder__WEBPACK_IMPORTED_MODULE_3__["MolScriptBuilder"].struct.atomProperty.core.modelIndex(), modelIndex]),
                    ])
                }));
            }
            else {
                opQueries.push(_mol_script_language_builder__WEBPACK_IMPORTED_MODULE_3__["MolScriptBuilder"].struct.generator.atomGroups({
                    'atom-test': tests.length > 1 ? _mol_script_language_builder__WEBPACK_IMPORTED_MODULE_3__["MolScriptBuilder"].core.logic.or(tests) : tests[0],
                    'chain-test': opName.length > 1
                        ? _mol_script_language_builder__WEBPACK_IMPORTED_MODULE_3__["MolScriptBuilder"].core.set.has([_mol_script_language_builder__WEBPACK_IMPORTED_MODULE_3__["MolScriptBuilder"].core.type.set(opName), opProp])
                        : _mol_script_language_builder__WEBPACK_IMPORTED_MODULE_3__["MolScriptBuilder"].core.rel.eq([opProp, opName[0]])
                }));
            }
        });
        return _mol_script_language_builder__WEBPACK_IMPORTED_MODULE_3__["MolScriptBuilder"].struct.modifier.union([
            opQueries.length === 1
                ? opQueries[0]
                // Need to union before merge for fast performance
                : _mol_script_language_builder__WEBPACK_IMPORTED_MODULE_3__["MolScriptBuilder"].struct.combinator.merge(opQueries.map(function (q) { return _mol_script_language_builder__WEBPACK_IMPORTED_MODULE_3__["MolScriptBuilder"].struct.modifier.union([q]); }))
        ]);
    }
    Loci.toExpression = toExpression;
    function getOpData(opName, xs, multimodel, modelLabel, modelIndex) {
        Object(_mol_data_util__WEBPACK_IMPORTED_MODULE_6__["sortArray"])(xs);
        var ranges = [];
        var set = [];
        var i = 0, len = xs.length;
        while (i < len) {
            var start = i;
            i++;
            while (i < len && xs[i - 1] + 1 === xs[i])
                i++;
            var end = i;
            // TODO: is this a good value?
            if (end - start > 12) {
                ranges[ranges.length] = xs[start];
                ranges[ranges.length] = xs[end - 1];
            }
            else {
                for (var j = start; j < end; j++) {
                    set[set.length] = xs[j];
                }
            }
        }
        return multimodel
            ? {
                atom: { set: set, ranges: ranges },
                chain: { opName: [opName] },
                entity: { modelLabel: modelLabel, modelIndex: modelIndex }
            }
            : {
                atom: { set: set, ranges: ranges },
                chain: { opName: [opName] },
            };
    }
})(Loci || (Loci = {}));
//# sourceMappingURL=loci.js.map

/***/ }),

/***/ "./lib/mol-model/structure/structure/element/stats.js":
/*!************************************************************!*\
  !*** ./lib/mol-model/structure/structure/element/stats.js ***!
  \************************************************************/
/*! exports provided: Stats */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Stats", function() { return Stats; });
/* harmony import */ var _mol_data_int__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../../../mol-data/int */ "./lib/mol-data/int.js");
/* harmony import */ var _unit__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../unit */ "./lib/mol-model/structure/structure/unit.js");
/* harmony import */ var _loci__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./loci */ "./lib/mol-model/structure/structure/element/loci.js");
/* harmony import */ var _location__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./location */ "./lib/mol-model/structure/structure/element/location.js");
/**
 * Copyright (c) 2019 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 * @author David Sehnal <david.sehnal@gmail.com>
 */




var Stats;
(function (Stats) {
    function create() {
        return {
            elementCount: 0,
            conformationCount: 0,
            residueCount: 0,
            chainCount: 0,
            unitCount: 0,
            structureCount: 0,
            firstElementLoc: _location__WEBPACK_IMPORTED_MODULE_3__["Location"].create(void 0),
            firstConformationLoc: _location__WEBPACK_IMPORTED_MODULE_3__["Location"].create(void 0),
            firstResidueLoc: _location__WEBPACK_IMPORTED_MODULE_3__["Location"].create(void 0),
            firstChainLoc: _location__WEBPACK_IMPORTED_MODULE_3__["Location"].create(void 0),
            firstUnitLoc: _location__WEBPACK_IMPORTED_MODULE_3__["Location"].create(void 0),
            firstStructureLoc: _location__WEBPACK_IMPORTED_MODULE_3__["Location"].create(void 0),
        };
    }
    Stats.create = create;
    function addCountHelper(map, key, inc) {
        var count = map.get(key) || 0;
        map.set(key, count + inc);
    }
    function handleElement(stats, structure, element) {
        var indices = element.indices, unit = element.unit;
        var elements = unit.elements;
        var size = _mol_data_int__WEBPACK_IMPORTED_MODULE_0__["OrderedSet"].size(indices);
        var lociResidueAltIdCounts = new Map();
        var residueAltIdCounts = new Map();
        if (size > 0) {
            _location__WEBPACK_IMPORTED_MODULE_3__["Location"].set(stats.firstElementLoc, structure, unit, elements[_mol_data_int__WEBPACK_IMPORTED_MODULE_0__["OrderedSet"].start(indices)]);
        }
        // count single element unit as unit not element
        if (size === elements.length) {
            stats.unitCount += 1;
            if (stats.unitCount === 1) {
                _location__WEBPACK_IMPORTED_MODULE_3__["Location"].set(stats.firstUnitLoc, structure, unit, elements[_mol_data_int__WEBPACK_IMPORTED_MODULE_0__["OrderedSet"].start(indices)]);
            }
        }
        else if (size === 1) {
            if (_unit__WEBPACK_IMPORTED_MODULE_1__["default"].Traits.is(unit.traits, 1 /* MultiChain */)) {
                return;
            }
            else {
                stats.elementCount += 1;
                if (stats.elementCount === 1) {
                    _location__WEBPACK_IMPORTED_MODULE_3__["Location"].set(stats.firstElementLoc, structure, unit, elements[_mol_data_int__WEBPACK_IMPORTED_MODULE_0__["OrderedSet"].start(indices)]);
                }
            }
        }
        else {
            if (_unit__WEBPACK_IMPORTED_MODULE_1__["default"].isAtomic(unit)) {
                var _a = unit.model.atomicHierarchy.residueAtomSegments, index = _a.index, offsets_1 = _a.offsets;
                var label_alt_id_1 = unit.model.atomicHierarchy.atoms.label_alt_id;
                var i = 0;
                var _loop_1 = function () {
                    lociResidueAltIdCounts.clear();
                    var j = 0;
                    var eI = elements[_mol_data_int__WEBPACK_IMPORTED_MODULE_0__["OrderedSet"].getAt(indices, i)];
                    var rI = index[eI];
                    addCountHelper(lociResidueAltIdCounts, label_alt_id_1.value(eI), 1);
                    ++i;
                    ++j;
                    while (i < size) {
                        var eI_1 = elements[_mol_data_int__WEBPACK_IMPORTED_MODULE_0__["OrderedSet"].getAt(indices, i)];
                        if (index[eI_1] !== rI)
                            break;
                        addCountHelper(lociResidueAltIdCounts, label_alt_id_1.value(eI_1), 1);
                        ++i;
                        ++j;
                    }
                    if (offsets_1[rI + 1] - offsets_1[rI] === j) {
                        // full residue
                        stats.residueCount += 1;
                        if (stats.residueCount === 1) {
                            _location__WEBPACK_IMPORTED_MODULE_3__["Location"].set(stats.firstResidueLoc, structure, unit, offsets_1[rI]);
                        }
                    }
                    else {
                        // partial residue
                        residueAltIdCounts.clear();
                        for (var l = offsets_1[rI], _l = offsets_1[rI + 1]; l < _l; ++l) {
                            addCountHelper(residueAltIdCounts, label_alt_id_1.value(l), 1);
                        }
                        // check if shared atom count match
                        if (residueAltIdCounts.get('') === lociResidueAltIdCounts.get('')) {
                            lociResidueAltIdCounts.forEach(function (v, k) {
                                if (residueAltIdCounts.get(k) !== v)
                                    return;
                                if (k !== '') {
                                    stats.conformationCount += 1;
                                    if (stats.conformationCount === 1) {
                                        for (var l = offsets_1[rI], _l = offsets_1[rI + 1]; l < _l; ++l) {
                                            if (k === label_alt_id_1.value(l)) {
                                                _location__WEBPACK_IMPORTED_MODULE_3__["Location"].set(stats.firstConformationLoc, structure, unit, l);
                                                break;
                                            }
                                        }
                                    }
                                }
                                j -= v;
                            });
                        }
                        stats.elementCount += j;
                    }
                };
                while (i < size) {
                    _loop_1();
                }
            }
            else {
                stats.elementCount += size;
                if (stats.elementCount === 1) {
                    _location__WEBPACK_IMPORTED_MODULE_3__["Location"].set(stats.firstElementLoc, structure, unit, elements[_mol_data_int__WEBPACK_IMPORTED_MODULE_0__["OrderedSet"].start(indices)]);
                }
            }
        }
    }
    function handleUnitChainsSimple(stats, structure, element) {
        var indices = element.indices, unit = element.unit;
        var size = _mol_data_int__WEBPACK_IMPORTED_MODULE_0__["OrderedSet"].size(indices);
        if (size === 0)
            return;
        var elements = unit.elements;
        if (!_unit__WEBPACK_IMPORTED_MODULE_1__["default"].Traits.is(unit.traits, 1 /* MultiChain */)) {
            if (size === elements.length) {
                stats.chainCount += 1;
                if (stats.chainCount === 1) {
                    _location__WEBPACK_IMPORTED_MODULE_3__["Location"].set(stats.firstChainLoc, structure, unit, elements[_mol_data_int__WEBPACK_IMPORTED_MODULE_0__["OrderedSet"].start(indices)]);
                }
            }
            return;
        }
        var segments = _unit__WEBPACK_IMPORTED_MODULE_1__["default"].isAtomic(unit)
            ? unit.model.atomicHierarchy.chainAtomSegments
            : _unit__WEBPACK_IMPORTED_MODULE_1__["default"].isSpheres(unit)
                ? unit.model.coarseHierarchy.spheres.chainElementSegments
                : _unit__WEBPACK_IMPORTED_MODULE_1__["default"].isGaussians(unit)
                    ? unit.model.coarseHierarchy.gaussians.chainElementSegments
                    : void 0;
        if (!segments) {
            console.warn('StructureElement loci stats: unknown unit type');
            return;
        }
        var index = segments.index, offsets = segments.offsets;
        var i = 0;
        while (i < size) {
            var j = 0;
            var eI = elements[_mol_data_int__WEBPACK_IMPORTED_MODULE_0__["OrderedSet"].getAt(indices, i)];
            var cI = index[eI];
            ++i;
            ++j;
            while (i < size) {
                var eI_2 = elements[_mol_data_int__WEBPACK_IMPORTED_MODULE_0__["OrderedSet"].getAt(indices, i)];
                if (index[eI_2] !== cI)
                    break;
                ++i;
                ++j;
            }
            if (offsets[cI + 1] - offsets[cI] === j) {
                // full chain
                stats.chainCount += 1;
                if (stats.chainCount === 1) {
                    _location__WEBPACK_IMPORTED_MODULE_3__["Location"].set(stats.firstChainLoc, structure, unit, offsets[cI]);
                }
            }
        }
    }
    function handleUnitChainsPartitioned(stats, structure, lociElements, start, end) {
        var element = lociElements[start];
        // all the elements have the same model since they are part of the same group so this is ok.
        var segments = _unit__WEBPACK_IMPORTED_MODULE_1__["default"].isAtomic(element.unit)
            ? element.unit.model.atomicHierarchy.chainAtomSegments
            : _unit__WEBPACK_IMPORTED_MODULE_1__["default"].isSpheres(element.unit)
                ? element.unit.model.coarseHierarchy.spheres.chainElementSegments
                : _unit__WEBPACK_IMPORTED_MODULE_1__["default"].isGaussians(element.unit)
                    ? element.unit.model.coarseHierarchy.gaussians.chainElementSegments
                    : void 0;
        if (!segments) {
            console.warn('StructureElement loci stats: unknown unit type');
            return;
        }
        var index = segments.index, offsets = segments.offsets;
        var chainCounts = new Map();
        for (var elIndex = start; elIndex < end; elIndex++) {
            element = lociElements[elIndex];
            var indices = element.indices, unit = element.unit;
            var size = _mol_data_int__WEBPACK_IMPORTED_MODULE_0__["OrderedSet"].size(indices);
            if (size === 0)
                continue;
            var elements = unit.elements;
            if (!_unit__WEBPACK_IMPORTED_MODULE_1__["default"].Traits.is(unit.traits, 1 /* MultiChain */)) {
                var eI = elements[_mol_data_int__WEBPACK_IMPORTED_MODULE_0__["OrderedSet"].start(indices)];
                addCountHelper(chainCounts, index[eI], elements.length);
                continue;
            }
            var i = 0;
            while (i < size) {
                var j = 0;
                var eI = elements[_mol_data_int__WEBPACK_IMPORTED_MODULE_0__["OrderedSet"].getAt(indices, i)];
                var cI = index[eI];
                ++i;
                ++j;
                while (i < size) {
                    var eI_3 = elements[_mol_data_int__WEBPACK_IMPORTED_MODULE_0__["OrderedSet"].getAt(indices, i)];
                    if (index[eI_3] !== cI)
                        break;
                    ++i;
                    ++j;
                }
                addCountHelper(chainCounts, cI, j);
            }
        }
        var firstCI = -1;
        chainCounts.forEach(function (count, cI) {
            if (offsets[cI + 1] - offsets[cI] === count) {
                // full chain
                stats.chainCount += 1;
                if (stats.chainCount === 1) {
                    firstCI = cI;
                }
            }
        });
        if (firstCI < 0)
            return;
        for (var elIndex = start; elIndex < end; elIndex++) {
            element = lociElements[elIndex];
            var indices = element.indices, unit = element.unit;
            var size = _mol_data_int__WEBPACK_IMPORTED_MODULE_0__["OrderedSet"].size(indices);
            if (size === 0)
                continue;
            var elements = unit.elements;
            var i = 0;
            while (i < size) {
                var eI = elements[_mol_data_int__WEBPACK_IMPORTED_MODULE_0__["OrderedSet"].getAt(indices, i)];
                var cI = index[eI];
                if (cI === firstCI) {
                    _location__WEBPACK_IMPORTED_MODULE_3__["Location"].set(stats.firstChainLoc, structure, unit, eI);
                    return;
                }
            }
        }
    }
    function ofLoci(loci) {
        var stats = create();
        if (_loci__WEBPACK_IMPORTED_MODULE_2__["Loci"].isEmpty(loci))
            return stats;
        var hasPartitions = false;
        if (_loci__WEBPACK_IMPORTED_MODULE_2__["Loci"].isWholeStructure(loci)) {
            stats.structureCount += 1;
            if (stats.structureCount === 1) {
                var _a = loci.elements[0], unit = _a.unit, indices = _a.indices;
                _location__WEBPACK_IMPORTED_MODULE_3__["Location"].set(stats.firstStructureLoc, loci.structure, unit, unit.elements[_mol_data_int__WEBPACK_IMPORTED_MODULE_0__["OrderedSet"].min(indices)]);
            }
        }
        else {
            for (var _i = 0, _b = loci.elements; _i < _b.length; _i++) {
                var e = _b[_i];
                handleElement(stats, loci.structure, e);
                if (!_unit__WEBPACK_IMPORTED_MODULE_1__["default"].Traits.is(e.unit.traits, 2 /* Partitioned */)) {
                    handleUnitChainsSimple(stats, loci.structure, e);
                }
                else {
                    hasPartitions = true;
                }
            }
        }
        if (hasPartitions) {
            for (var i = 0, len = loci.elements.length; i < len; i++) {
                var e = loci.elements[i];
                if (!_unit__WEBPACK_IMPORTED_MODULE_1__["default"].Traits.is(e.unit.traits, 2 /* Partitioned */))
                    continue;
                var start = i;
                while (i < len && _unit__WEBPACK_IMPORTED_MODULE_1__["default"].areSameChainOperatorGroup(loci.elements[i].unit, e.unit)) {
                    i++;
                }
                var end = i;
                i--;
                if (end - start === 1) {
                    handleUnitChainsSimple(stats, loci.structure, e);
                }
                else {
                    handleUnitChainsPartitioned(stats, loci.structure, loci.elements, start, end);
                }
            }
        }
        return stats;
    }
    Stats.ofLoci = ofLoci;
    /** Adds counts of two Stats objects together, assumes they describe different structures */
    function add(out, a, b) {
        if (a.elementCount === 1 && b.elementCount === 0) {
            _location__WEBPACK_IMPORTED_MODULE_3__["Location"].copy(out.firstElementLoc, a.firstElementLoc);
        }
        else if (a.elementCount === 0 && b.elementCount === 1) {
            _location__WEBPACK_IMPORTED_MODULE_3__["Location"].copy(out.firstElementLoc, b.firstElementLoc);
        }
        if (a.conformationCount === 1 && b.conformationCount === 0) {
            _location__WEBPACK_IMPORTED_MODULE_3__["Location"].copy(out.firstConformationLoc, a.firstConformationLoc);
        }
        else if (a.conformationCount === 0 && b.conformationCount === 1) {
            _location__WEBPACK_IMPORTED_MODULE_3__["Location"].copy(out.firstConformationLoc, b.firstConformationLoc);
        }
        if (a.residueCount === 1 && b.residueCount === 0) {
            _location__WEBPACK_IMPORTED_MODULE_3__["Location"].copy(out.firstResidueLoc, a.firstResidueLoc);
        }
        else if (a.residueCount === 0 && b.residueCount === 1) {
            _location__WEBPACK_IMPORTED_MODULE_3__["Location"].copy(out.firstResidueLoc, b.firstResidueLoc);
        }
        if (a.chainCount === 1 && b.chainCount === 0) {
            _location__WEBPACK_IMPORTED_MODULE_3__["Location"].copy(out.firstChainLoc, a.firstChainLoc);
        }
        else if (a.chainCount === 0 && b.chainCount === 1) {
            _location__WEBPACK_IMPORTED_MODULE_3__["Location"].copy(out.firstChainLoc, b.firstChainLoc);
        }
        if (a.unitCount === 1 && b.unitCount === 0) {
            _location__WEBPACK_IMPORTED_MODULE_3__["Location"].copy(out.firstUnitLoc, a.firstUnitLoc);
        }
        else if (a.unitCount === 0 && b.unitCount === 1) {
            _location__WEBPACK_IMPORTED_MODULE_3__["Location"].copy(out.firstUnitLoc, b.firstUnitLoc);
        }
        if (a.structureCount === 1 && b.structureCount === 0) {
            _location__WEBPACK_IMPORTED_MODULE_3__["Location"].copy(out.firstStructureLoc, a.firstStructureLoc);
        }
        else if (a.structureCount === 0 && b.structureCount === 1) {
            _location__WEBPACK_IMPORTED_MODULE_3__["Location"].copy(out.firstStructureLoc, b.firstStructureLoc);
        }
        out.elementCount = a.elementCount + b.elementCount;
        out.conformationCount = a.conformationCount + b.conformationCount;
        out.residueCount = a.residueCount + b.residueCount;
        out.chainCount = a.chainCount + b.chainCount;
        out.unitCount = a.unitCount + b.unitCount;
        out.structureCount = a.structureCount + b.structureCount;
        return out;
    }
    Stats.add = add;
})(Stats || (Stats = {}));
//# sourceMappingURL=stats.js.map

/***/ }),

/***/ "./lib/mol-model/structure/structure/properties.js":
/*!*********************************************************!*\
  !*** ./lib/mol-model/structure/structure/properties.js ***!
  \*********************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _unit__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./unit */ "./lib/mol-model/structure/structure/unit.js");
/* harmony import */ var _model_properties_atomic__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../model/properties/atomic */ "./lib/mol-model/structure/model/properties/atomic.js");
/* harmony import */ var _mol_model_props_computed_secondary_structure__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../../mol-model-props/computed/secondary-structure */ "./lib/mol-model-props/computed/secondary-structure.js");
/* harmony import */ var _mol_math_geometry__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../../mol-math/geometry */ "./lib/mol-math/geometry.js");
/**
 * Copyright (c) 2017-2020 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author David Sehnal <david.sehnal@gmail.com>
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */




function p(p) { return p; }
var constant = {
    true: p(function (l) { return true; }),
    false: p(function (l) { return false; }),
    zero: p(function (l) { return 0; })
};
function notAtomic() {
    throw 'Property only available for atomic models.';
}
function notCoarse(kind) {
    if (!!kind)
        throw "Property only available for coarse models (" + kind + ").";
    throw "Property only available for coarse models.";
}
// TODO: remove the type checks?
var atom = {
    key: p(function (l) { return l.element; }),
    // Conformation
    x: p(function (l) { return l.unit.conformation.x(l.element); }),
    y: p(function (l) { return l.unit.conformation.y(l.element); }),
    z: p(function (l) { return l.unit.conformation.z(l.element); }),
    id: p(function (l) { return !_unit__WEBPACK_IMPORTED_MODULE_0__["default"].isAtomic(l.unit) ? notAtomic() : l.unit.model.atomicConformation.atomId.value(l.element); }),
    occupancy: p(function (l) { return !_unit__WEBPACK_IMPORTED_MODULE_0__["default"].isAtomic(l.unit) ? notAtomic() : l.unit.model.atomicConformation.occupancy.value(l.element); }),
    B_iso_or_equiv: p(function (l) { return !_unit__WEBPACK_IMPORTED_MODULE_0__["default"].isAtomic(l.unit) ? notAtomic() : l.unit.model.atomicConformation.B_iso_or_equiv.value(l.element); }),
    sourceIndex: p(function (l) { return _unit__WEBPACK_IMPORTED_MODULE_0__["default"].isAtomic(l.unit)
        ? l.unit.model.atomicHierarchy.atomSourceIndex.value(l.element)
        // TODO: when implemented, this should map to the source index.
        : l.element; }),
    // Hierarchy
    type_symbol: p(function (l) { return !_unit__WEBPACK_IMPORTED_MODULE_0__["default"].isAtomic(l.unit) ? notAtomic() : l.unit.model.atomicHierarchy.atoms.type_symbol.value(l.element); }),
    label_atom_id: p(function (l) { return !_unit__WEBPACK_IMPORTED_MODULE_0__["default"].isAtomic(l.unit) ? notAtomic() : l.unit.model.atomicHierarchy.atoms.label_atom_id.value(l.element); }),
    auth_atom_id: p(function (l) { return !_unit__WEBPACK_IMPORTED_MODULE_0__["default"].isAtomic(l.unit) ? notAtomic() : l.unit.model.atomicHierarchy.atoms.auth_atom_id.value(l.element); }),
    label_alt_id: p(function (l) { return !_unit__WEBPACK_IMPORTED_MODULE_0__["default"].isAtomic(l.unit) ? notAtomic() : l.unit.model.atomicHierarchy.atoms.label_alt_id.value(l.element); }),
    label_comp_id: p(compId),
    auth_comp_id: p(function (l) { return !_unit__WEBPACK_IMPORTED_MODULE_0__["default"].isAtomic(l.unit) ? notAtomic() : l.unit.model.atomicHierarchy.atoms.auth_comp_id.value(l.element); }),
    pdbx_formal_charge: p(function (l) { return !_unit__WEBPACK_IMPORTED_MODULE_0__["default"].isAtomic(l.unit) ? notAtomic() : l.unit.model.atomicHierarchy.atoms.pdbx_formal_charge.value(l.element); }),
    // Derived
    vdw_radius: p(function (l) { return !_unit__WEBPACK_IMPORTED_MODULE_0__["default"].isAtomic(l.unit) ? notAtomic() : Object(_model_properties_atomic__WEBPACK_IMPORTED_MODULE_1__["VdwRadius"])(l.unit.model.atomicHierarchy.atoms.type_symbol.value(l.element)); }),
};
function compId(l) {
    if (!_unit__WEBPACK_IMPORTED_MODULE_0__["default"].isAtomic(l.unit))
        notAtomic();
    return l.unit.model.atomicHierarchy.atoms.label_comp_id.value(l.element);
}
function seqId(l) {
    return !_unit__WEBPACK_IMPORTED_MODULE_0__["default"].isAtomic(l.unit) ? notAtomic() : l.unit.model.atomicHierarchy.residues.label_seq_id.value(l.unit.residueIndex[l.element]);
}
function hasMicroheterogeneity(l) {
    if (!_unit__WEBPACK_IMPORTED_MODULE_0__["default"].isAtomic(l.unit))
        notAtomic();
    var entitySeq = l.unit.model.sequence.byEntityKey[eK(l)];
    return entitySeq && entitySeq.sequence.microHet.has(seqId(l));
}
function microheterogeneityCompIds(l) {
    if (!_unit__WEBPACK_IMPORTED_MODULE_0__["default"].isAtomic(l.unit))
        notAtomic();
    var entitySeq = l.unit.model.sequence.byEntityKey[eK(l)];
    if (entitySeq) {
        return entitySeq.sequence.microHet.get(seqId(l)) || [compId(l)];
    }
    else {
        return [compId(l)];
    }
}
var residue = {
    key: p(function (l) { return !_unit__WEBPACK_IMPORTED_MODULE_0__["default"].isAtomic(l.unit) ? notAtomic() : l.unit.residueIndex[l.element]; }),
    group_PDB: p(function (l) { return !_unit__WEBPACK_IMPORTED_MODULE_0__["default"].isAtomic(l.unit) ? notAtomic() : l.unit.model.atomicHierarchy.residues.group_PDB.value(l.unit.residueIndex[l.element]); }),
    label_seq_id: p(seqId),
    auth_seq_id: p(function (l) { return !_unit__WEBPACK_IMPORTED_MODULE_0__["default"].isAtomic(l.unit) ? notAtomic() : l.unit.model.atomicHierarchy.residues.auth_seq_id.value(l.unit.residueIndex[l.element]); }),
    pdbx_PDB_ins_code: p(function (l) { return !_unit__WEBPACK_IMPORTED_MODULE_0__["default"].isAtomic(l.unit) ? notAtomic() : l.unit.model.atomicHierarchy.residues.pdbx_PDB_ins_code.value(l.unit.residueIndex[l.element]); }),
    // Properties
    isNonStandard: p(function (l) { return !_unit__WEBPACK_IMPORTED_MODULE_0__["default"].isAtomic(l.unit) ? notAtomic() : microheterogeneityCompIds(l).some(function (c) { return l.unit.model.properties.chemicalComponentMap.get(c).mon_nstd_flag[0] === 'n'; }); }),
    hasMicroheterogeneity: p(hasMicroheterogeneity),
    microheterogeneityCompIds: p(microheterogeneityCompIds),
    secondary_structure_type: p(function (l) {
        var _a, _b;
        if (!_unit__WEBPACK_IMPORTED_MODULE_0__["default"].isAtomic(l.unit))
            notAtomic();
        var secStruc = (_a = _mol_model_props_computed_secondary_structure__WEBPACK_IMPORTED_MODULE_2__["SecondaryStructureProvider"].get(l.structure).value) === null || _a === void 0 ? void 0 : _a.get(l.unit.id);
        return (_b = secStruc === null || secStruc === void 0 ? void 0 : secStruc.type[l.unit.residueIndex[l.element]]) !== null && _b !== void 0 ? _b : 536870912 /* NA */;
    }),
    secondary_structure_key: p(function (l) {
        var _a, _b;
        if (!_unit__WEBPACK_IMPORTED_MODULE_0__["default"].isAtomic(l.unit))
            notAtomic();
        var secStruc = (_a = _mol_model_props_computed_secondary_structure__WEBPACK_IMPORTED_MODULE_2__["SecondaryStructureProvider"].get(l.structure).value) === null || _a === void 0 ? void 0 : _a.get(l.unit.id);
        return (_b = secStruc === null || secStruc === void 0 ? void 0 : secStruc.key[l.unit.residueIndex[l.element]]) !== null && _b !== void 0 ? _b : -1;
    }),
    chem_comp_type: p(function (l) { return !_unit__WEBPACK_IMPORTED_MODULE_0__["default"].isAtomic(l.unit) ? notAtomic() : l.unit.model.properties.chemicalComponentMap.get(compId(l)).type; }),
};
var chain = {
    key: p(function (l) { return !_unit__WEBPACK_IMPORTED_MODULE_0__["default"].isAtomic(l.unit) ? notAtomic() : l.unit.chainIndex[l.element]; }),
    label_asym_id: p(function (l) { return !_unit__WEBPACK_IMPORTED_MODULE_0__["default"].isAtomic(l.unit) ? notAtomic() : l.unit.model.atomicHierarchy.chains.label_asym_id.value(l.unit.chainIndex[l.element]); }),
    auth_asym_id: p(function (l) { return !_unit__WEBPACK_IMPORTED_MODULE_0__["default"].isAtomic(l.unit) ? notAtomic() : l.unit.model.atomicHierarchy.chains.auth_asym_id.value(l.unit.chainIndex[l.element]); }),
    label_entity_id: p(function (l) { return !_unit__WEBPACK_IMPORTED_MODULE_0__["default"].isAtomic(l.unit) ? notAtomic() : l.unit.model.atomicHierarchy.chains.label_entity_id.value(l.unit.chainIndex[l.element]); })
};
var coarse = {
    key: atom.key,
    entityKey: p(function (l) { return !_unit__WEBPACK_IMPORTED_MODULE_0__["default"].isCoarse(l.unit) ? notCoarse() : l.unit.coarseElements.entityKey[l.element]; }),
    x: atom.x,
    y: atom.y,
    z: atom.z,
    asym_id: p(function (l) { return !_unit__WEBPACK_IMPORTED_MODULE_0__["default"].isCoarse(l.unit) ? notCoarse() : l.unit.coarseElements.asym_id.value(l.element); }),
    seq_id_begin: p(function (l) { return !_unit__WEBPACK_IMPORTED_MODULE_0__["default"].isCoarse(l.unit) ? notCoarse() : l.unit.coarseElements.seq_id_begin.value(l.element); }),
    seq_id_end: p(function (l) { return !_unit__WEBPACK_IMPORTED_MODULE_0__["default"].isCoarse(l.unit) ? notCoarse() : l.unit.coarseElements.seq_id_end.value(l.element); }),
    sphere_radius: p(function (l) { return !_unit__WEBPACK_IMPORTED_MODULE_0__["default"].isSpheres(l.unit) ? notCoarse('spheres') : l.unit.coarseConformation.radius[l.element]; }),
    sphere_rmsf: p(function (l) { return !_unit__WEBPACK_IMPORTED_MODULE_0__["default"].isSpheres(l.unit) ? notCoarse('spheres') : l.unit.coarseConformation.rmsf[l.element]; }),
    gaussian_weight: p(function (l) { return !_unit__WEBPACK_IMPORTED_MODULE_0__["default"].isGaussians(l.unit) ? notCoarse('gaussians') : l.unit.coarseConformation.weight[l.element]; }),
    gaussian_covariance_matrix: p(function (l) { return !_unit__WEBPACK_IMPORTED_MODULE_0__["default"].isGaussians(l.unit) ? notCoarse('gaussians') : l.unit.coarseConformation.covariance_matrix[l.element]; })
};
function eK(l) {
    switch (l.unit.kind) {
        case 0 /* Atomic */:
            return l.unit.model.atomicHierarchy.index.getEntityFromChain(l.unit.chainIndex[l.element]);
        case 1 /* Spheres */:
            return l.unit.model.coarseHierarchy.spheres.entityKey[l.element];
        case 2 /* Gaussians */:
            return l.unit.model.coarseHierarchy.gaussians.entityKey[l.element];
    }
}
var entity = {
    key: p(eK),
    id: p(function (l) { return l.unit.model.entities.data.id.value(eK(l)); }),
    type: p(function (l) { return l.unit.model.entities.data.type.value(eK(l)); }),
    src_method: p(function (l) { return l.unit.model.entities.data.src_method.value(eK(l)); }),
    pdbx_description: p(function (l) { return l.unit.model.entities.data.pdbx_description.value(eK(l)); }),
    formula_weight: p(function (l) { return l.unit.model.entities.data.formula_weight.value(eK(l)); }),
    pdbx_number_of_molecules: p(function (l) { return l.unit.model.entities.data.pdbx_number_of_molecules.value(eK(l)); }),
    details: p(function (l) { return l.unit.model.entities.data.details.value(eK(l)); }),
    pdbx_mutation: p(function (l) { return l.unit.model.entities.data.pdbx_mutation.value(eK(l)); }),
    pdbx_fragment: p(function (l) { return l.unit.model.entities.data.pdbx_fragment.value(eK(l)); }),
    pdbx_ec: p(function (l) { return l.unit.model.entities.data.pdbx_ec.value(eK(l)); }),
    subtype: p(function (l) { return l.unit.model.entities.subtype.value(eK(l)); }),
    prd_id: p(function (l) { return l.unit.model.entities.prd_id.value(eK(l)); }),
};
var _emptyList = [];
var unit = {
    id: p(function (l) { return l.unit.id; }),
    chainGroupId: p(function (l) { return l.unit.chainGroupId; }),
    multiChain: p(function (l) { return _unit__WEBPACK_IMPORTED_MODULE_0__["default"].Traits.is(l.unit.traits, 1 /* MultiChain */); }),
    object_primitive: p(function (l) { return l.unit.objectPrimitive; }),
    operator_name: p(function (l) { return l.unit.conformation.operator.name; }),
    model_index: p(function (l) { return l.unit.model.modelNum; }),
    model_label: p(function (l) { return l.unit.model.label; }),
    model_entry_id: p(function (l) { return l.unit.model.entryId; }),
    hkl: p(function (l) { return l.unit.conformation.operator.hkl; }),
    spgrOp: p(function (l) { return l.unit.conformation.operator.spgrOp; }),
    model_num: p(function (l) { return l.unit.model.modelNum; }),
    pdbx_struct_assembly_id: p(function (l) { var _a; return ((_a = l.unit.conformation.operator.assembly) === null || _a === void 0 ? void 0 : _a.id) || _mol_math_geometry__WEBPACK_IMPORTED_MODULE_3__["SymmetryOperator"].DefaultName; }),
    pdbx_struct_oper_list_ids: p(function (l) { var _a; return ((_a = l.unit.conformation.operator.assembly) === null || _a === void 0 ? void 0 : _a.operList) || _emptyList; }),
    struct_ncs_oper_id: p(function (l) { return l.unit.conformation.operator.ncsId; }),
};
var StructureProperties = {
    constant: constant,
    atom: atom,
    residue: residue,
    chain: chain,
    entity: entity,
    unit: unit,
    coarse: coarse
};
/* harmony default export */ __webpack_exports__["default"] = (StructureProperties);
//# sourceMappingURL=properties.js.map

/***/ }),

/***/ "./lib/mol-model/structure/structure/structure.js":
/*!********************************************************!*\
  !*** ./lib/mol-model/structure/structure/structure.js ***!
  \********************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _mol_data_int__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../../mol-data/int */ "./lib/mol-data/int.js");
/* harmony import */ var _mol_data_generic__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../../mol-data/generic */ "./lib/mol-data/generic.js");
/* harmony import */ var _mol_math_geometry_symmetry_operator__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../../mol-math/geometry/symmetry-operator */ "./lib/mol-math/geometry/symmetry-operator.js");
/* harmony import */ var _model__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../model */ "./lib/mol-model/structure/model.js");
/* harmony import */ var _mol_data_util__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../../mol-data/util */ "./lib/mol-data/util.js");
/* harmony import */ var _element__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ./element */ "./lib/mol-model/structure/structure/element.js");
/* harmony import */ var _unit__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ./unit */ "./lib/mol-model/structure/structure/unit.js");
/* harmony import */ var _util_lookup3d__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ./util/lookup3d */ "./lib/mol-model/structure/structure/util/lookup3d.js");
/* harmony import */ var _util_subset_builder__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ./util/subset-builder */ "./lib/mol-model/structure/structure/util/subset-builder.js");
/* harmony import */ var _unit_bonds__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ./unit/bonds */ "./lib/mol-model/structure/structure/unit/bonds.js");
/* harmony import */ var _symmetry__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ./symmetry */ "./lib/mol-model/structure/structure/symmetry.js");
/* harmony import */ var _properties__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! ./properties */ "./lib/mol-model/structure/structure/properties.js");
/* harmony import */ var _carbohydrates_compute__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! ./carbohydrates/compute */ "./lib/mol-model/structure/structure/carbohydrates/compute.js");
/* harmony import */ var _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! ../../../mol-math/linear-algebra */ "./lib/mol-math/linear-algebra.js");
/* harmony import */ var _mol_util_id_factory__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! ../../../mol-util/id-factory */ "./lib/mol-util/id-factory.js");
/* harmony import */ var _mol_math_geometry__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(/*! ../../../mol-math/geometry */ "./lib/mol-math/geometry.js");
/* harmony import */ var _custom_property__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(/*! ../../custom-property */ "./lib/mol-model/custom-property.js");
/* harmony import */ var _model_properties_atomic__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(/*! ../model/properties/atomic */ "./lib/mol-model/structure/model/properties/atomic.js");
/* harmony import */ var _query_selection__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(/*! ../query/selection */ "./lib/mol-model/structure/query/selection.js");
/* harmony import */ var _mol_math_geometry_boundary__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(/*! ../../../mol-math/geometry/boundary */ "./lib/mol-math/geometry/boundary.js");
/* harmony import */ var _mol_model_props_common_custom_structure_property__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(/*! ../../../mol-model-props/common/custom-structure-property */ "./lib/mol-model-props/common/custom-structure-property.js");
/* harmony import */ var _mol_task__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(/*! ../../../mol-task */ "./lib/mol-task/index.js");
/* harmony import */ var _util_boundary__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(/*! ./util/boundary */ "./lib/mol-model/structure/structure/util/boundary.js");
/**
 * Copyright (c) 2017-2021 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author David Sehnal <david.sehnal@gmail.com>
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */
























var Structure = /** @class */ (function () {
    function Structure(units, props) {
        if (props === void 0) { props = {}; }
        this._props = {
            hashCode: -1,
            transformHash: -1,
            elementCount: -1,
            bondCount: -1,
            uniqueElementCount: -1,
            atomicResidueCount: -1,
            polymerResidueCount: -1,
            polymerUnitCount: -1,
            coordinateSystem: _mol_math_geometry_symmetry_operator__WEBPACK_IMPORTED_MODULE_3__["SymmetryOperator"].Default,
            label: ''
        };
        var _a = this.initUnits(units), unitMap = _a.unitMap, unitIndexMap = _a.unitIndexMap;
        this.unitMap = unitMap;
        this.unitIndexMap = unitIndexMap;
        this.units = units;
        if (props.parent)
            this._props.parent = props.parent.parent || props.parent;
        if (props.interUnitBonds)
            this._props.interUnitBonds = props.interUnitBonds;
        if (props.coordinateSystem)
            this._props.coordinateSystem = props.coordinateSystem;
        else if (props.parent)
            this._props.coordinateSystem = props.parent.coordinateSystem;
        if (props.label)
            this._props.label = props.label;
        else if (props.parent)
            this._props.label = props.parent.label;
        if (props.masterModel)
            this._props.masterModel = props.masterModel;
        else if (props.parent)
            this._props.masterModel = props.parent.masterModel;
        if (props.representativeModel)
            this._props.representativeModel = props.representativeModel;
        else if (props.parent)
            this._props.representativeModel = props.parent.representativeModel;
    }
    Structure.prototype.subsetBuilder = function (isSorted) {
        return new _util_subset_builder__WEBPACK_IMPORTED_MODULE_9__["StructureSubsetBuilder"](this, isSorted);
    };
    Object.defineProperty(Structure.prototype, "elementCount", {
        /** Count of all elements in the structure, i.e. the sum of the elements in the units */
        get: function () {
            return this._props.elementCount;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Structure.prototype, "bondCount", {
        /** Count of all bonds (intra- and inter-unit) in the structure */
        get: function () {
            if (this._props.bondCount === -1) {
                this._props.bondCount = this.interUnitBonds.edgeCount + _unit_bonds__WEBPACK_IMPORTED_MODULE_10__["Bond"].getIntraUnitBondCount(this);
            }
            return this._props.bondCount;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Structure.prototype, "hasCustomProperties", {
        get: function () {
            return !!this._props.customProps && this._props.customProps.all.length > 0;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Structure.prototype, "customPropertyDescriptors", {
        get: function () {
            if (!this._props.customProps)
                this._props.customProps = new _custom_property__WEBPACK_IMPORTED_MODULE_17__["CustomProperties"]();
            return this._props.customProps;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Structure.prototype, "currentPropertyData", {
        /**
         * Property data unique to this instance of the structure.
         */
        get: function () {
            if (!this._props.propertyData)
                this._props.propertyData = Object.create(null);
            return this._props.propertyData;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Structure.prototype, "inheritedPropertyData", {
        /**
         * Property data of the parent structure if it exists, currentPropertyData otherwise.
         */
        get: function () {
            return this.parent ? this.parent.currentPropertyData : this.currentPropertyData;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Structure.prototype, "polymerResidueCount", {
        /** Count of all polymer residues in the structure */
        get: function () {
            if (this._props.polymerResidueCount === -1) {
                this._props.polymerResidueCount = getPolymerResidueCount(this);
            }
            return this._props.polymerResidueCount;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Structure.prototype, "polymerUnitCount", {
        get: function () {
            if (this._props.polymerUnitCount === -1) {
                this._props.polymerUnitCount = getPolymerUnitCount(this);
            }
            return this._props.polymerUnitCount;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Structure.prototype, "uniqueElementCount", {
        get: function () {
            if (this._props.uniqueElementCount === -1) {
                this._props.uniqueElementCount = getUniqueElementCount(this);
            }
            return this._props.uniqueElementCount;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Structure.prototype, "atomicResidueCount", {
        get: function () {
            if (this._props.atomicResidueCount === -1) {
                this._props.atomicResidueCount = getAtomicResidueCount(this);
            }
            return this._props.atomicResidueCount;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Structure.prototype, "isCoarseGrained", {
        /**
         * Coarse-grained structure, defined as containing less than
         * twice as many elements as polymer residues
         */
        get: function () {
            var ec = this.elementCount;
            var prc = this.polymerResidueCount;
            return prc && ec ? ec / prc < 2 : false;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Structure.prototype, "isEmpty", {
        get: function () {
            return this.units.length === 0;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Structure.prototype, "hashCode", {
        get: function () {
            if (this._props.hashCode !== -1)
                return this._props.hashCode;
            return this.computeHash();
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Structure.prototype, "transformHash", {
        /** Hash based on all unit.id values in the structure, reflecting the units transformation */
        get: function () {
            if (this._props.transformHash !== -1)
                return this._props.transformHash;
            this._props.transformHash = Object(_mol_data_util__WEBPACK_IMPORTED_MODULE_5__["hashFnv32a"])(this.units.map(function (u) { return u.id; }));
            return this._props.transformHash;
        },
        enumerable: false,
        configurable: true
    });
    Structure.prototype.computeHash = function () {
        var hash = 23;
        for (var i = 0, _i = this.units.length; i < _i; i++) {
            var u = this.units[i];
            hash = (31 * hash + u.id) | 0;
            hash = (31 * hash + _mol_data_int__WEBPACK_IMPORTED_MODULE_1__["SortedArray"].hashCode(u.elements)) | 0;
        }
        hash = (31 * hash + this.elementCount) | 0;
        hash = Object(_mol_data_util__WEBPACK_IMPORTED_MODULE_5__["hash1"])(hash);
        if (hash === -1)
            hash = 0;
        this._props.hashCode = hash;
        return hash;
    };
    /** Returns a new element location iterator */
    Structure.prototype.elementLocations = function () {
        return new Structure.ElementLocationIterator(this);
    };
    Object.defineProperty(Structure.prototype, "root", {
        /** The parent or itself in case this is the root */
        get: function () {
            return this._props.parent || this;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Structure.prototype, "parent", {
        /** The root/top-most parent or `undefined` in case this is the root */
        get: function () {
            return this._props.parent;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Structure.prototype, "coordinateSystem", {
        /**
         * Conformation transformation that was applied to every unit of this structure.
         *
         * Coordinate system applies to the *current* structure only.
         * A parent structure can have a different coordinate system and thefore it has to be composed "manualy"
         * by the consumer.
         */
        get: function () {
            return this._props.coordinateSystem;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Structure.prototype, "label", {
        get: function () {
            return this._props.label;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Structure.prototype, "boundary", {
        get: function () {
            if (this._props.boundary)
                return this._props.boundary;
            this._props.boundary = Object(_util_boundary__WEBPACK_IMPORTED_MODULE_23__["computeStructureBoundary"])(this);
            return this._props.boundary;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Structure.prototype, "lookup3d", {
        get: function () {
            if (this._props.lookup3d)
                return this._props.lookup3d;
            this._props.lookup3d = new _util_lookup3d__WEBPACK_IMPORTED_MODULE_8__["StructureLookup3D"](this);
            return this._props.lookup3d;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Structure.prototype, "interUnitBonds", {
        get: function () {
            if (this._props.interUnitBonds)
                return this._props.interUnitBonds;
            this._props.interUnitBonds = Object(_unit_bonds__WEBPACK_IMPORTED_MODULE_10__["computeInterUnitBonds"])(this);
            return this._props.interUnitBonds;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Structure.prototype, "unitSymmetryGroups", {
        get: function () {
            if (this._props.unitSymmetryGroups)
                return this._props.unitSymmetryGroups;
            this._props.unitSymmetryGroups = _symmetry__WEBPACK_IMPORTED_MODULE_11__["default"].computeTransformGroups(this);
            return this._props.unitSymmetryGroups;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Structure.prototype, "unitSymmetryGroupsIndexMap", {
        /** Maps unit.id to index of SymmetryGroup in unitSymmetryGroups array */
        get: function () {
            if (this._props.unitSymmetryGroupsIndexMap)
                return this._props.unitSymmetryGroupsIndexMap;
            this._props.unitSymmetryGroupsIndexMap = _unit__WEBPACK_IMPORTED_MODULE_7__["default"].SymmetryGroup.getUnitSymmetryGroupsIndexMap(this.unitSymmetryGroups);
            return this._props.unitSymmetryGroupsIndexMap;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Structure.prototype, "unitsSortedByVolume", {
        /** Array of all units in the structure, sorted by their boundary volume */
        get: function () {
            if (this._props.unitsSortedByVolume)
                return this._props.unitsSortedByVolume;
            this._props.unitsSortedByVolume = getUnitsSortedByVolume(this);
            return this._props.unitsSortedByVolume;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Structure.prototype, "carbohydrates", {
        get: function () {
            if (this._props.carbohydrates)
                return this._props.carbohydrates;
            this._props.carbohydrates = Object(_carbohydrates_compute__WEBPACK_IMPORTED_MODULE_13__["computeCarbohydrates"])(this);
            return this._props.carbohydrates;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Structure.prototype, "models", {
        get: function () {
            if (this._props.models)
                return this._props.models;
            this._props.models = getModels(this);
            return this._props.models;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Structure.prototype, "uniqueResidueNames", {
        get: function () {
            return this._props.uniqueResidueNames
                || (this._props.uniqueResidueNames = getUniqueResidueNames(this));
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Structure.prototype, "uniqueElementSymbols", {
        get: function () {
            return this._props.uniqueElementSymbols
                || (this._props.uniqueElementSymbols = getUniqueElementSymbols(this));
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Structure.prototype, "entityIndices", {
        get: function () {
            return this._props.entityIndices
                || (this._props.entityIndices = getEntityIndices(this));
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Structure.prototype, "uniqueAtomicResidueIndices", {
        get: function () {
            return this._props.uniqueAtomicResidueIndices
                || (this._props.uniqueAtomicResidueIndices = getUniqueAtomicResidueIndices(this));
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Structure.prototype, "isAtomic", {
        /** Contains only atomic units */
        get: function () {
            for (var _a = 0, _b = this.units; _a < _b.length; _a++) {
                var u = _b[_a];
                if (_unit__WEBPACK_IMPORTED_MODULE_7__["default"].isAtomic(u))
                    return false;
            }
            return true;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Structure.prototype, "hasAtomic", {
        /** Contains some atomic units */
        get: function () {
            for (var _a = 0, _b = this.units; _a < _b.length; _a++) {
                var u = _b[_a];
                if (_unit__WEBPACK_IMPORTED_MODULE_7__["default"].isAtomic(u))
                    return true;
            }
            return false;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Structure.prototype, "isCoarse", {
        /** Contains only coarse units */
        get: function () {
            for (var _a = 0, _b = this.units; _a < _b.length; _a++) {
                var u = _b[_a];
                if (_unit__WEBPACK_IMPORTED_MODULE_7__["default"].isCoarse(u))
                    return false;
            }
            return true;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Structure.prototype, "hasCoarse", {
        /** Contains some coarse units */
        get: function () {
            for (var _a = 0, _b = this.units; _a < _b.length; _a++) {
                var u = _b[_a];
                if (_unit__WEBPACK_IMPORTED_MODULE_7__["default"].isCoarse(u))
                    return true;
            }
            return false;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Structure.prototype, "serialMapping", {
        /**
         * Provides mapping for serial element indices accross all units.
         *
         * Note that this is especially costly for structures with many units that are grouped
         * into few symmetry groups. Use only when needed and prefer `StructureElement`
         * to address elements in a structure.
         */
        get: function () {
            return this._props.serialMapping || (this._props.serialMapping = getSerialMapping(this));
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Structure.prototype, "model", {
        /**
         * If the structure is based on a single model or has a master-/representative-model, return it.
         * Otherwise throw an exception.
         */
        get: function () {
            if (this._props.model)
                return this._props.model;
            if (this._props.representativeModel)
                return this._props.representativeModel;
            if (this._props.masterModel)
                return this._props.masterModel;
            var models = this.models;
            if (models.length > 1) {
                throw new Error('The structure is based on multiple models and has neither a master- nor a representative-model.');
            }
            this._props.model = models[0];
            return this._props.model;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Structure.prototype, "masterModel", {
        /** The master-model, other models can have bonds to it  */
        get: function () {
            return this._props.masterModel;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Structure.prototype, "representativeModel", {
        /** A representative model, e.g. the first model of a trajectory */
        get: function () {
            return this._props.representativeModel;
        },
        enumerable: false,
        configurable: true
    });
    Structure.prototype.hasElement = function (e) {
        if (!this.unitMap.has(e.unit.id))
            return false;
        return _mol_data_int__WEBPACK_IMPORTED_MODULE_1__["SortedArray"].has(this.unitMap.get(e.unit.id).elements, e.element);
    };
    Structure.prototype.getModelIndex = function (m) {
        return this.models.indexOf(m);
    };
    Structure.prototype.remapModel = function (m) {
        var units = [];
        for (var _a = 0, _b = this.unitSymmetryGroups; _a < _b.length; _a++) {
            var ug = _b[_a];
            var unit = ug.units[0].remapModel(m);
            units.push(unit);
            for (var i = 1, il = ug.units.length; i < il; ++i) {
                var u = ug.units[i];
                units.push(u.remapModel(m, unit.props));
            }
        }
        return Structure.create(units, {
            label: this.label,
            interUnitBonds: this._props.interUnitBonds,
        });
    };
    Structure.prototype.initUnits = function (units) {
        var unitMap = _mol_data_int__WEBPACK_IMPORTED_MODULE_1__["IntMap"].Mutable();
        var unitIndexMap = _mol_data_int__WEBPACK_IMPORTED_MODULE_1__["IntMap"].Mutable();
        var elementCount = 0;
        var isSorted = true;
        var lastId = units.length > 0 ? units[0].id : 0;
        for (var i = 0, _i = units.length; i < _i; i++) {
            var u = units[i];
            unitMap.set(u.id, u);
            elementCount += u.elements.length;
            if (u.id < lastId)
                isSorted = false;
            lastId = u.id;
        }
        if (!isSorted)
            Object(_mol_data_util__WEBPACK_IMPORTED_MODULE_5__["sort"])(units, 0, units.length, cmpUnits, _mol_data_util__WEBPACK_IMPORTED_MODULE_5__["arraySwap"]);
        for (var i = 0, _i = units.length; i < _i; i++) {
            unitIndexMap.set(units[i].id, i);
        }
        this._props.elementCount = elementCount;
        return { unitMap: unitMap, unitIndexMap: unitIndexMap };
    };
    return Structure;
}());
function cmpUnits(units, i, j) {
    return units[i].id - units[j].id;
}
function cmpUnitGroupVolume(units, i, j) {
    var d = units[i][1] - units[j][1];
    if (d === 0)
        return units[i][0] - units[j][0];
    return d;
}
function getUnitsSortedByVolume(structure) {
    var unitSymmetryGroups = structure.unitSymmetryGroups;
    var groups = unitSymmetryGroups.map(function (g, i) { return [i, _mol_math_geometry__WEBPACK_IMPORTED_MODULE_16__["Box3D"].volume(g.units[0].lookup3d.boundary.box)]; });
    Object(_mol_data_util__WEBPACK_IMPORTED_MODULE_5__["sort"])(groups, 0, groups.length, cmpUnitGroupVolume, _mol_data_util__WEBPACK_IMPORTED_MODULE_5__["arraySwap"]);
    var ret = [];
    for (var _a = 0, groups_1 = groups; _a < groups_1.length; _a++) {
        var i = groups_1[_a][0];
        for (var _b = 0, _c = unitSymmetryGroups[i].units; _b < _c.length; _b++) {
            var u = _c[_b];
            ret.push(u);
        }
    }
    return ret;
}
function getModels(s) {
    var units = s.units;
    var arr = _mol_data_generic__WEBPACK_IMPORTED_MODULE_2__["UniqueArray"].create();
    for (var _a = 0, units_1 = units; _a < units_1.length; _a++) {
        var u = units_1[_a];
        _mol_data_generic__WEBPACK_IMPORTED_MODULE_2__["UniqueArray"].add(arr, u.model.id, u.model);
    }
    return arr.array;
}
function getUniqueResidueNames(s) {
    var microheterogeneityCompIds = _properties__WEBPACK_IMPORTED_MODULE_12__["default"].residue.microheterogeneityCompIds;
    var names = new Set();
    var loc = _element__WEBPACK_IMPORTED_MODULE_6__["default"].Location.create(s);
    for (var _a = 0, _b = s.unitSymmetryGroups; _a < _b.length; _a++) {
        var unitGroup = _b[_a];
        var unit = unitGroup.units[0];
        // TODO: support coarse unit?
        if (!_unit__WEBPACK_IMPORTED_MODULE_7__["default"].isAtomic(unit))
            continue;
        var residues = _mol_data_int__WEBPACK_IMPORTED_MODULE_1__["Segmentation"].transientSegments(unit.model.atomicHierarchy.residueAtomSegments, unit.elements);
        loc.unit = unit;
        while (residues.hasNext) {
            var seg = residues.move();
            loc.element = unit.elements[seg.start];
            var compIds = microheterogeneityCompIds(loc);
            for (var _c = 0, compIds_1 = compIds; _c < compIds_1.length; _c++) {
                var compId = compIds_1[_c];
                names.add(compId);
            }
        }
    }
    return names;
}
function getUniqueElementSymbols(s) {
    var prop = _properties__WEBPACK_IMPORTED_MODULE_12__["default"].atom.type_symbol;
    var symbols = new Set();
    var loc = _element__WEBPACK_IMPORTED_MODULE_6__["default"].Location.create(s);
    for (var _a = 0, _b = s.unitSymmetryGroups; _a < _b.length; _a++) {
        var unitGroup = _b[_a];
        var unit = unitGroup.units[0];
        if (!_unit__WEBPACK_IMPORTED_MODULE_7__["default"].isAtomic(unit))
            continue;
        loc.unit = unit;
        for (var i = 0, il = unit.elements.length; i < il; ++i) {
            loc.element = unit.elements[i];
            symbols.add(prop(loc));
        }
    }
    return symbols;
}
function getEntityIndices(structure) {
    var units = structure.units;
    var l = _element__WEBPACK_IMPORTED_MODULE_6__["default"].Location.create(structure);
    var keys = _mol_data_generic__WEBPACK_IMPORTED_MODULE_2__["UniqueArray"].create();
    for (var _a = 0, units_2 = units; _a < units_2.length; _a++) {
        var unit = units_2[_a];
        var prop = unit.kind === 0 /* Atomic */ ? _properties__WEBPACK_IMPORTED_MODULE_12__["default"].entity.key : _properties__WEBPACK_IMPORTED_MODULE_12__["default"].coarse.entityKey;
        l.unit = unit;
        var elements = unit.elements;
        var chainsIt = _mol_data_int__WEBPACK_IMPORTED_MODULE_1__["Segmentation"].transientSegments(unit.model.atomicHierarchy.chainAtomSegments, elements);
        while (chainsIt.hasNext) {
            var chainSegment = chainsIt.move();
            l.element = elements[chainSegment.start];
            var key = prop(l);
            _mol_data_generic__WEBPACK_IMPORTED_MODULE_2__["UniqueArray"].add(keys, key, key);
        }
    }
    Object(_mol_data_util__WEBPACK_IMPORTED_MODULE_5__["sortArray"])(keys.array);
    return keys.array;
}
function getUniqueAtomicResidueIndices(structure) {
    var map = new Map();
    var modelIds = [];
    var unitGroups = structure.unitSymmetryGroups;
    for (var _a = 0, unitGroups_1 = unitGroups; _a < unitGroups_1.length; _a++) {
        var unitGroup = unitGroups_1[_a];
        var unit = unitGroup.units[0];
        if (!_unit__WEBPACK_IMPORTED_MODULE_7__["default"].isAtomic(unit))
            continue;
        var uniqueResidues = void 0;
        if (map.has(unit.model.id))
            uniqueResidues = map.get(unit.model.id);
        else {
            uniqueResidues = _mol_data_generic__WEBPACK_IMPORTED_MODULE_2__["UniqueArray"].create();
            modelIds.push(unit.model.id);
            map.set(unit.model.id, uniqueResidues);
        }
        var residues = _mol_data_int__WEBPACK_IMPORTED_MODULE_1__["Segmentation"].transientSegments(unit.model.atomicHierarchy.residueAtomSegments, unit.elements);
        while (residues.hasNext) {
            var seg = residues.move();
            _mol_data_generic__WEBPACK_IMPORTED_MODULE_2__["UniqueArray"].add(uniqueResidues, seg.index, seg.index);
        }
    }
    var ret = new Map();
    for (var _b = 0, modelIds_1 = modelIds; _b < modelIds_1.length; _b++) {
        var id = modelIds_1[_b];
        var array = map.get(id).array;
        Object(_mol_data_util__WEBPACK_IMPORTED_MODULE_5__["sortArray"])(array);
        ret.set(id, array);
    }
    return ret;
}
function getUniqueElementCount(structure) {
    var unitSymmetryGroups = structure.unitSymmetryGroups;
    var uniqueElementCount = 0;
    for (var i = 0, _i = unitSymmetryGroups.length; i < _i; i++) {
        uniqueElementCount += unitSymmetryGroups[i].elements.length;
    }
    return uniqueElementCount;
}
function getPolymerResidueCount(structure) {
    var units = structure.units;
    var polymerResidueCount = 0;
    for (var i = 0, _i = units.length; i < _i; i++) {
        polymerResidueCount += units[i].polymerElements.length;
    }
    return polymerResidueCount;
}
function getPolymerUnitCount(structure) {
    var units = structure.units;
    var polymerUnitCount = 0;
    for (var i = 0, _i = units.length; i < _i; i++) {
        if (units[i].polymerElements.length > 0)
            polymerUnitCount += 1;
    }
    return polymerUnitCount;
}
function getAtomicResidueCount(structure) {
    var units = structure.units;
    var atomicResidueCount = 0;
    for (var i = 0, _i = units.length; i < _i; i++) {
        var unit = units[i];
        if (!_unit__WEBPACK_IMPORTED_MODULE_7__["default"].isAtomic(unit))
            continue;
        var elements = unit.elements, residueIndex = unit.residueIndex;
        var idx = -1;
        var prevIdx = -1;
        for (var j = 0, jl = elements.length; j < jl; ++j) {
            idx = residueIndex[elements[j]];
            if (idx !== prevIdx) {
                atomicResidueCount += 1;
                prevIdx = idx;
            }
        }
    }
    return atomicResidueCount;
}
function getSerialMapping(structure) {
    var units = structure.units, elementCount = structure.elementCount, unitIndexMap = structure.unitIndexMap;
    var cumulativeUnitElementCount = new Uint32Array(units.length);
    var unitIndices = new Uint32Array(elementCount);
    var elementIndices = new Uint32Array(elementCount);
    for (var i = 0, m = 0, il = units.length; i < il; ++i) {
        cumulativeUnitElementCount[i] = m;
        var elements = units[i].elements;
        for (var j = 0, jl = elements.length; j < jl; ++j) {
            var mj = m + j;
            unitIndices[mj] = i;
            elementIndices[mj] = elements[j];
        }
        m += elements.length;
    }
    return {
        cumulativeUnitElementCount: cumulativeUnitElementCount,
        unitIndices: unitIndices,
        elementIndices: elementIndices,
        getSerialIndex: function (unit, element) { return cumulativeUnitElementCount[unitIndexMap.get(unit.id)] + _mol_data_int__WEBPACK_IMPORTED_MODULE_1__["OrderedSet"].indexOf(unit.elements, element); }
    };
}
(function (Structure) {
    Structure.Empty = new Structure([]);
    function Loci(structure) {
        return { kind: 'structure-loci', structure: structure };
    }
    Structure.Loci = Loci;
    function toStructureElementLoci(structure) {
        var elements = [];
        for (var _a = 0, _b = structure.units; _a < _b.length; _a++) {
            var unit = _b[_a];
            elements.push({ unit: unit, indices: _mol_data_int__WEBPACK_IMPORTED_MODULE_1__["Interval"].ofBounds(0, unit.elements.length) });
        }
        return _element__WEBPACK_IMPORTED_MODULE_6__["default"].Loci(structure, elements);
    }
    Structure.toStructureElementLoci = toStructureElementLoci;
    function toSubStructureElementLoci(parent, structure) {
        return _query_selection__WEBPACK_IMPORTED_MODULE_19__["StructureSelection"].toLociWithSourceUnits(_query_selection__WEBPACK_IMPORTED_MODULE_19__["StructureSelection"].Singletons(parent, structure));
    }
    Structure.toSubStructureElementLoci = toSubStructureElementLoci;
    function isLoci(x) {
        return !!x && x.kind === 'structure-loci';
    }
    Structure.isLoci = isLoci;
    function areLociEqual(a, b) {
        return a.structure === b.structure;
    }
    Structure.areLociEqual = areLociEqual;
    function isLociEmpty(loci) {
        return loci.structure.isEmpty;
    }
    Structure.isLociEmpty = isLociEmpty;
    function remapLoci(loci, structure) {
        if (structure === loci.structure)
            return loci;
        return Loci(structure);
    }
    Structure.remapLoci = remapLoci;
    function create(units, props) {
        return new Structure(units, props);
    }
    Structure.create = create;
    function ofTrajectory(trajectory, ctx) {
        return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"])(this, void 0, void 0, function () {
            var units, first, count, i, il, frame, structure, j, jl, u, invariantId, chainGroupId, newUnit;
            return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__generator"])(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (trajectory.frameCount === 0)
                            return [2 /*return*/, Structure.Empty];
                        units = [];
                        first = void 0;
                        count = 0;
                        i = 0, il = trajectory.frameCount;
                        _a.label = 1;
                    case 1:
                        if (!(i < il)) return [3 /*break*/, 4];
                        return [4 /*yield*/, _mol_task__WEBPACK_IMPORTED_MODULE_22__["Task"].resolveInContext(trajectory.getFrameAtIndex(i), ctx)];
                    case 2:
                        frame = _a.sent();
                        if (!first)
                            first = frame;
                        structure = ofModel(frame);
                        for (j = 0, jl = structure.units.length; j < jl; ++j) {
                            u = structure.units[j];
                            invariantId = u.invariantId + count;
                            chainGroupId = u.chainGroupId + count;
                            newUnit = _unit__WEBPACK_IMPORTED_MODULE_7__["default"].create(units.length, invariantId, chainGroupId, u.traits, u.kind, u.model, u.conformation.operator, u.elements);
                            units.push(newUnit);
                        }
                        count = units.length;
                        _a.label = 3;
                    case 3:
                        ++i;
                        return [3 /*break*/, 1];
                    case 4: return [2 /*return*/, create(units, { representativeModel: first, label: first.label })];
                }
            });
        });
    }
    Structure.ofTrajectory = ofTrajectory;
    var PARTITION = false;
    /**
     * Construct a Structure from a model.
     *
     * Generally, a single unit corresponds to a single chain, with the exception
     * of consecutive "single atom chains" with same entity_id and same auth_asym_id.
     */
    function ofModel(model) {
        var chains = model.atomicHierarchy.chainAtomSegments;
        var index = model.atomicHierarchy.index;
        var auth_asym_id = model.atomicHierarchy.chains.auth_asym_id;
        var atomicChainOperatorMappinng = model.atomicChainOperatorMappinng;
        var builder = new StructureBuilder({ label: model.label });
        for (var c = 0; c < chains.count; c++) {
            var operator = atomicChainOperatorMappinng.get(c) || _mol_math_geometry_symmetry_operator__WEBPACK_IMPORTED_MODULE_3__["SymmetryOperator"].Default;
            var start = chains.offsets[c];
            // set to true for chains that consist of "single atom residues",
            // note that it assumes there are no "zero atom residues"
            var singleAtomResidues = _model_properties_atomic__WEBPACK_IMPORTED_MODULE_18__["AtomicHierarchy"].chainResidueCount(model.atomicHierarchy, c) === chains.offsets[c + 1] - chains.offsets[c];
            var multiChain = false;
            if (isWaterChain(model, c)) {
                // merge consecutive water chains
                while (c + 1 < chains.count && isWaterChain(model, c + 1)) {
                    var op1 = atomicChainOperatorMappinng.get(c);
                    var op2 = atomicChainOperatorMappinng.get(c + 1);
                    if (op1 !== op2)
                        break;
                    multiChain = true;
                    c++;
                }
            }
            else {
                // merge consecutive "single atom chains" with same entity_id and auth_asym_id
                while (c + 1 < chains.count
                    && chains.offsets[c + 1] - chains.offsets[c] === 1
                    && chains.offsets[c + 2] - chains.offsets[c + 1] === 1) {
                    singleAtomResidues = true;
                    var e1 = index.getEntityFromChain(c);
                    var e2 = index.getEntityFromChain(c + 1);
                    if (e1 !== e2)
                        break;
                    var a1 = auth_asym_id.value(c);
                    var a2 = auth_asym_id.value(c + 1);
                    if (a1 !== a2)
                        break;
                    var op1 = atomicChainOperatorMappinng.get(c);
                    var op2 = atomicChainOperatorMappinng.get(c + 1);
                    if (op1 !== op2)
                        break;
                    multiChain = true;
                    c++;
                }
            }
            var elements = _mol_data_int__WEBPACK_IMPORTED_MODULE_1__["SortedArray"].ofBounds(start, chains.offsets[c + 1]);
            if (PARTITION) {
                // check for polymer to exclude CA/P-only models
                if (singleAtomResidues && !isPolymerChain(model, c)) {
                    partitionAtomicUnitByAtom(model, elements, builder, multiChain, operator);
                }
                else if (elements.length > 200000 || isWaterChain(model, c)) {
                    // split up very large chains e.g. lipid bilayers, micelles or water with explicit H
                    partitionAtomicUnitByResidue(model, elements, builder, multiChain, operator);
                }
                else {
                    builder.addUnit(0 /* Atomic */, model, operator, elements, multiChain ? 1 /* MultiChain */ : 0 /* None */);
                }
            }
            else {
                builder.addUnit(0 /* Atomic */, model, operator, elements, multiChain ? 1 /* MultiChain */ : 0 /* None */);
            }
        }
        var cs = model.coarseHierarchy;
        if (cs.isDefined) {
            if (cs.spheres.count > 0) {
                addCoarseUnits(builder, model, model.coarseHierarchy.spheres, 1 /* Spheres */);
            }
            if (cs.gaussians.count > 0) {
                addCoarseUnits(builder, model, model.coarseHierarchy.gaussians, 2 /* Gaussians */);
            }
        }
        return builder.getStructure();
    }
    Structure.ofModel = ofModel;
    function isWaterChain(model, chainIndex) {
        var e = model.atomicHierarchy.index.getEntityFromChain(chainIndex);
        return model.entities.data.type.value(e) === 'water';
    }
    function isPolymerChain(model, chainIndex) {
        var e = model.atomicHierarchy.index.getEntityFromChain(chainIndex);
        return model.entities.data.type.value(e) === 'polymer';
    }
    function partitionAtomicUnitByAtom(model, indices, builder, multiChain, operator) {
        var _a = model.atomicConformation, x = _a.x, y = _a.y, z = _a.z;
        var position = { x: x, y: y, z: z, indices: indices };
        var lookup = Object(_mol_math_geometry__WEBPACK_IMPORTED_MODULE_16__["GridLookup3D"])(position, Object(_mol_math_geometry_boundary__WEBPACK_IMPORTED_MODULE_20__["getBoundary"])(position), 8192);
        var _b = lookup.buckets, offset = _b.offset, count = _b.count, array = _b.array;
        var traits = (multiChain ? 1 /* MultiChain */ : 0 /* None */) | (offset.length > 1 ? 2 /* Partitioned */ : 0 /* None */);
        builder.beginChainGroup();
        for (var i = 0, _i = offset.length; i < _i; i++) {
            var start = offset[i];
            var set = new Int32Array(count[i]);
            for (var j = 0, _j = count[i]; j < _j; j++) {
                set[j] = indices[array[start + j]];
            }
            builder.addUnit(0 /* Atomic */, model, operator, _mol_data_int__WEBPACK_IMPORTED_MODULE_1__["SortedArray"].ofSortedArray(set), traits);
        }
        builder.endChainGroup();
    }
    // keeps atoms of residues together
    function partitionAtomicUnitByResidue(model, indices, builder, multiChain, operator) {
        var residueAtomSegments = model.atomicHierarchy.residueAtomSegments;
        var startIndices = [];
        var endIndices = [];
        var residueIt = _mol_data_int__WEBPACK_IMPORTED_MODULE_1__["Segmentation"].transientSegments(residueAtomSegments, indices);
        while (residueIt.hasNext) {
            var residueSegment = residueIt.move();
            startIndices[startIndices.length] = indices[residueSegment.start];
            endIndices[endIndices.length] = indices[residueSegment.end];
        }
        var firstResidueAtomCount = endIndices[0] - startIndices[0];
        var gridCellCount = 512 * firstResidueAtomCount;
        var _a = model.atomicConformation, x = _a.x, y = _a.y, z = _a.z;
        var position = { x: x, y: y, z: z, indices: _mol_data_int__WEBPACK_IMPORTED_MODULE_1__["SortedArray"].ofSortedArray(startIndices) };
        var lookup = Object(_mol_math_geometry__WEBPACK_IMPORTED_MODULE_16__["GridLookup3D"])(position, Object(_mol_math_geometry_boundary__WEBPACK_IMPORTED_MODULE_20__["getBoundary"])(position), gridCellCount);
        var _b = lookup.buckets, offset = _b.offset, count = _b.count, array = _b.array;
        var traits = (multiChain ? 1 /* MultiChain */ : 0 /* None */) | (offset.length > 1 ? 2 /* Partitioned */ : 0 /* None */);
        builder.beginChainGroup();
        for (var i = 0, _i = offset.length; i < _i; i++) {
            var start = offset[i];
            var set = [];
            for (var j = 0, _j = count[i]; j < _j; j++) {
                var k = array[start + j];
                for (var l = startIndices[k], _l = endIndices[k]; l < _l; l++) {
                    set[set.length] = l;
                }
            }
            builder.addUnit(0 /* Atomic */, model, operator, _mol_data_int__WEBPACK_IMPORTED_MODULE_1__["SortedArray"].ofSortedArray(new Int32Array(set)), traits);
        }
        builder.endChainGroup();
    }
    function addCoarseUnits(builder, model, elements, kind) {
        var chainElementSegments = elements.chainElementSegments;
        for (var cI = 0; cI < chainElementSegments.count; cI++) {
            var elements_1 = _mol_data_int__WEBPACK_IMPORTED_MODULE_1__["SortedArray"].ofBounds(chainElementSegments.offsets[cI], chainElementSegments.offsets[cI + 1]);
            builder.addUnit(kind, model, _mol_math_geometry_symmetry_operator__WEBPACK_IMPORTED_MODULE_3__["SymmetryOperator"].Default, elements_1, 0 /* None */);
        }
    }
    function transform(s, transform) {
        if (_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_14__["Mat4"].isIdentity(transform))
            return s;
        if (!_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_14__["Mat4"].isRotationAndTranslation(transform, _mol_math_geometry_symmetry_operator__WEBPACK_IMPORTED_MODULE_3__["SymmetryOperator"].RotationTranslationEpsilon))
            throw new Error('Only rotation/translation combination can be applied.');
        var units = [];
        for (var _a = 0, _b = s.units; _a < _b.length; _a++) {
            var u = _b[_a];
            var old = u.conformation.operator;
            var op = _mol_math_geometry_symmetry_operator__WEBPACK_IMPORTED_MODULE_3__["SymmetryOperator"].create(old.name, transform, old);
            units.push(u.applyOperator(u.id, op));
        }
        var cs = s.coordinateSystem;
        var newCS = _mol_math_geometry_symmetry_operator__WEBPACK_IMPORTED_MODULE_3__["SymmetryOperator"].compose(_mol_math_geometry_symmetry_operator__WEBPACK_IMPORTED_MODULE_3__["SymmetryOperator"].create(cs.name, transform, cs), cs);
        return new Structure(units, { parent: s, coordinateSystem: newCS });
    }
    Structure.transform = transform;
    var StructureBuilder = /** @class */ (function () {
        function StructureBuilder(props) {
            if (props === void 0) { props = {}; }
            this.props = props;
            this.units = [];
            this.invariantId = Object(_mol_util_id_factory__WEBPACK_IMPORTED_MODULE_15__["idFactory"])();
            this.chainGroupId = -1;
            this.inChainGroup = false;
            this.p = Object(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_14__["Vec3"])();
            this.singleElementUnits = new Map();
        }
        StructureBuilder.prototype.beginChainGroup = function () {
            this.chainGroupId++;
            this.inChainGroup = true;
        };
        StructureBuilder.prototype.endChainGroup = function () {
            this.inChainGroup = false;
        };
        StructureBuilder.prototype.addUnit = function (kind, model, operator, elements, traits, invariantId) {
            if (invariantId === undefined)
                invariantId = this.invariantId();
            var chainGroupId = this.inChainGroup ? this.chainGroupId : ++this.chainGroupId;
            var unit = _unit__WEBPACK_IMPORTED_MODULE_7__["default"].create(this.units.length, invariantId, chainGroupId, traits, kind, model, operator, elements);
            return this.add(unit);
        };
        StructureBuilder.prototype.add = function (unit) {
            // this is to avoid adding many identical single atom units,
            // for example, from 'degenerate' spacegroups
            // - Diamond (COD 9008564)
            if (unit.elements.length === 1) {
                unit.conformation.position(unit.elements[0], this.p);
                var hash = [unit.invariantId, this.p[0], this.p[1], this.p[2]].join('|');
                if (this.singleElementUnits.has(hash)) {
                    return this.singleElementUnits.get(hash);
                }
                else {
                    this.singleElementUnits.set(hash, unit);
                }
            }
            this.units.push(unit);
            return unit;
        };
        StructureBuilder.prototype.addWithOperator = function (unit, operator, dontCompose) {
            if (dontCompose === void 0) { dontCompose = false; }
            return this.add(unit.applyOperator(this.units.length, operator, dontCompose));
        };
        StructureBuilder.prototype.getStructure = function () {
            return create(this.units, this.props);
        };
        Object.defineProperty(StructureBuilder.prototype, "isEmpty", {
            get: function () {
                return this.units.length === 0;
            },
            enumerable: false,
            configurable: true
        });
        return StructureBuilder;
    }());
    Structure.StructureBuilder = StructureBuilder;
    function Builder(props) {
        if (props === void 0) { props = {}; }
        return new StructureBuilder(props);
    }
    Structure.Builder = Builder;
    function hashCode(s) {
        return s.hashCode;
    }
    Structure.hashCode = hashCode;
    /** Hash based on all unit.model conformation values in the structure */
    function conformationHash(s) {
        return Object(_mol_data_util__WEBPACK_IMPORTED_MODULE_5__["hashString"])(s.units.map(function (u) { return _unit__WEBPACK_IMPORTED_MODULE_7__["default"].conformationId(u); }).join('|'));
    }
    Structure.conformationHash = conformationHash;
    // TODO: there should be a version that properly supports partitioned units
    function areUnitIdsEqual(a, b) {
        if (a === b)
            return true;
        if (a.elementCount !== b.elementCount)
            return false;
        var len = a.units.length;
        if (len !== b.units.length)
            return false;
        for (var i = 0; i < len; i++) {
            if (a.units[i].id !== b.units[i].id)
                return false;
        }
        return true;
    }
    Structure.areUnitIdsEqual = areUnitIdsEqual;
    function areUnitIdsAndIndicesEqual(a, b) {
        if (!areUnitIdsEqual(a, b))
            return false;
        for (var i = 0, il = a.units.length; i < il; i++) {
            if (!_mol_data_int__WEBPACK_IMPORTED_MODULE_1__["SortedArray"].areEqual(a.units[i].elements, b.units[i].elements))
                return false;
        }
        return true;
    }
    Structure.areUnitIdsAndIndicesEqual = areUnitIdsAndIndicesEqual;
    function areHierarchiesEqual(a, b) {
        if (a.hashCode !== b.hashCode)
            return false;
        var len = a.models.length;
        if (len !== b.models.length)
            return false;
        for (var i = 0; i < len; i++) {
            if (!_model__WEBPACK_IMPORTED_MODULE_4__["Model"].areHierarchiesEqual(a.models[i], b.models[i]))
                return false;
        }
        return true;
    }
    Structure.areHierarchiesEqual = areHierarchiesEqual;
    function areEquivalent(a, b) {
        return a === b || (a.hashCode === b.hashCode &&
            _symmetry__WEBPACK_IMPORTED_MODULE_11__["default"].areTransformGroupsEquivalent(a.unitSymmetryGroups, b.unitSymmetryGroups));
    }
    Structure.areEquivalent = areEquivalent;
    /** Check if the structures or their parents are equivalent */
    function areRootsEquivalent(a, b) {
        return areEquivalent(a.root, b.root);
    }
    Structure.areRootsEquivalent = areRootsEquivalent;
    /** Check if the structures or their parents are equal */
    function areRootsEqual(a, b) {
        return a.root === b.root;
    }
    Structure.areRootsEqual = areRootsEqual;
    var ElementLocationIterator = /** @class */ (function () {
        function ElementLocationIterator(structure) {
            this.structure = structure;
            this.unitIndex = 0;
            this.maxIdx = 0;
            this.idx = -1;
            this.current = _element__WEBPACK_IMPORTED_MODULE_6__["default"].Location.create(structure);
            this.hasNext = structure.elementCount > 0;
            if (this.hasNext) {
                this.elements = structure.units[0].elements;
                this.maxIdx = this.elements.length - 1;
                this.current.unit = structure.units[0];
            }
        }
        ElementLocationIterator.prototype.move = function () {
            this.advance();
            this.current.element = this.elements[this.idx];
            return this.current;
        };
        ElementLocationIterator.prototype.advance = function () {
            if (this.idx < this.maxIdx) {
                this.idx++;
                if (this.idx === this.maxIdx)
                    this.hasNext = this.unitIndex + 1 < this.structure.units.length;
                return;
            }
            this.idx = 0;
            this.unitIndex++;
            if (this.unitIndex >= this.structure.units.length) {
                this.hasNext = false;
                return;
            }
            this.current.unit = this.structure.units[this.unitIndex];
            this.elements = this.current.unit.elements;
            this.maxIdx = this.elements.length - 1;
            if (this.maxIdx === 0) {
                this.hasNext = this.unitIndex + 1 < this.structure.units.length;
            }
        };
        return ElementLocationIterator;
    }());
    Structure.ElementLocationIterator = ElementLocationIterator;
    var distVec = Object(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_14__["Vec3"])();
    function unitElementMinDistance(unit, p, eRadius) {
        var elements = unit.elements, _a = unit.conformation, position = _a.position, r = _a.r, dV = distVec;
        var minD = Number.MAX_VALUE;
        for (var i = 0, _i = elements.length; i < _i; i++) {
            var e = elements[i];
            var d = _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_14__["Vec3"].distance(p, position(e, dV)) - eRadius - r(e);
            if (d < minD)
                minD = d;
        }
        return minD;
    }
    function minDistanceToPoint(s, point, radius) {
        var units = s.units;
        var minD = Number.MAX_VALUE;
        for (var i = 0, _i = units.length; i < _i; i++) {
            var unit = units[i];
            var d = unitElementMinDistance(unit, point, radius);
            if (d < minD)
                minD = d;
        }
        return minD;
    }
    Structure.minDistanceToPoint = minDistanceToPoint;
    var distPivot = Object(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_14__["Vec3"])();
    function distance(a, b) {
        if (a.elementCount === 0 || b.elementCount === 0)
            return 0;
        var units = a.units;
        var minD = Number.MAX_VALUE;
        for (var i = 0, _i = units.length; i < _i; i++) {
            var unit = units[i];
            var elements = unit.elements, _a = unit.conformation, position = _a.position, r = _a.r;
            for (var i_1 = 0, _i_1 = elements.length; i_1 < _i_1; i_1++) {
                var e = elements[i_1];
                var d = minDistanceToPoint(b, position(e, distPivot), r(e));
                if (d < minD)
                    minD = d;
            }
        }
        return minD;
    }
    Structure.distance = distance;
    function elementDescription(s) {
        return s.elementCount === 1 ? '1 element' : s.elementCount + " elements";
    }
    Structure.elementDescription = elementDescription;
    function validUnitPair(s, a, b) {
        return s.masterModel
            ? a.model === b.model || a.model === s.masterModel || b.model === s.masterModel
            : a.model === b.model;
    }
    Structure.validUnitPair = validUnitPair;
    /**
     * Iterate over all unit pairs of a structure and invokes callback for valid units
     * and unit pairs if within a max distance.
     */
    function eachUnitPair(structure, callback, props) {
        var maxRadius = props.maxRadius, validUnit = props.validUnit, validUnitPair = props.validUnitPair;
        if (!structure.units.some(function (u) { return validUnit(u); }))
            return;
        var lookup = structure.lookup3d;
        var imageCenter = Object(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_14__["Vec3"])();
        for (var _a = 0, _b = structure.units; _a < _b.length; _a++) {
            var unit = _b[_a];
            if (!validUnit(unit))
                continue;
            var bs = unit.boundary.sphere;
            _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_14__["Vec3"].transformMat4(imageCenter, bs.center, unit.conformation.operator.matrix);
            var closeUnits = lookup.findUnitIndices(imageCenter[0], imageCenter[1], imageCenter[2], bs.radius + maxRadius);
            for (var i = 0; i < closeUnits.count; i++) {
                var other = structure.units[closeUnits.indices[i]];
                if (!validUnit(other) || unit.id >= other.id || !validUnitPair(unit, other))
                    continue;
                if (other.elements.length >= unit.elements.length)
                    callback(unit, other);
                else
                    callback(other, unit);
            }
        }
    }
    Structure.eachUnitPair = eachUnitPair;
    //
    Structure.DefaultSizeThresholds = {
        /** Must be lower to be small */
        smallResidueCount: 10,
        /** Must be lower to be medium */
        mediumResidueCount: 5000,
        /** Must be lower to be large (big ribosomes like 4UG0 should still be `large`) */
        largeResidueCount: 20000,
        /**
         * Structures above `largeResidueCount` are consider huge when they have
         * a `highSymmetryUnitCount` or gigantic when not
         */
        highSymmetryUnitCount: 10,
        /** Fiber-like structure are consider small when below this */
        fiberResidueCount: 15,
    };
    function getPolymerSymmetryGroups(structure) {
        return structure.unitSymmetryGroups.filter(function (ug) { return ug.units[0].polymerElements.length > 0; });
    }
    /**
     * Try to match fiber-like structures like 6nk4
     */
    function isFiberLike(structure, thresholds) {
        var polymerSymmetryGroups = getPolymerSymmetryGroups(structure);
        return (polymerSymmetryGroups.length === 1 &&
            polymerSymmetryGroups[0].units.length > 2 &&
            polymerSymmetryGroups[0].units[0].polymerElements.length < thresholds.fiberResidueCount);
    }
    function hasHighSymmetry(structure, thresholds) {
        var polymerSymmetryGroups = getPolymerSymmetryGroups(structure);
        return (polymerSymmetryGroups.length >= 1 &&
            polymerSymmetryGroups[0].units.length > thresholds.highSymmetryUnitCount);
    }
    var Size;
    (function (Size) {
        Size[Size["Small"] = 0] = "Small";
        Size[Size["Medium"] = 1] = "Medium";
        Size[Size["Large"] = 2] = "Large";
        Size[Size["Huge"] = 3] = "Huge";
        Size[Size["Gigantic"] = 4] = "Gigantic";
    })(Size = Structure.Size || (Structure.Size = {}));
    /**
     * @param residueCountFactor - modifies the threshold counts, useful when estimating
     *                             the size of a structure comprised of multiple models
     */
    function getSize(structure, thresholds, residueCountFactor) {
        if (thresholds === void 0) { thresholds = {}; }
        if (residueCountFactor === void 0) { residueCountFactor = 1; }
        var t = Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, Structure.DefaultSizeThresholds), thresholds);
        if (structure.polymerResidueCount >= t.largeResidueCount * residueCountFactor) {
            if (hasHighSymmetry(structure, t)) {
                return Size.Huge;
            }
            else {
                return Size.Gigantic;
            }
        }
        else if (isFiberLike(structure, t)) {
            return Size.Small;
        }
        else if (structure.polymerResidueCount < t.smallResidueCount * residueCountFactor) {
            return Size.Small;
        }
        else if (structure.polymerResidueCount < t.mediumResidueCount * residueCountFactor) {
            return Size.Medium;
        }
        else {
            return Size.Large;
        }
    }
    Structure.getSize = getSize;
    Structure.Index = _mol_model_props_common_custom_structure_property__WEBPACK_IMPORTED_MODULE_21__["CustomStructureProperty"].createSimple('index', 'root');
})(Structure || (Structure = {}));
/* harmony default export */ __webpack_exports__["default"] = (Structure);
//# sourceMappingURL=structure.js.map

/***/ }),

/***/ "./lib/mol-model/structure/structure/symmetry.js":
/*!*******************************************************!*\
  !*** ./lib/mol-model/structure/structure/symmetry.js ***!
  \*******************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _mol_data_int__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../../mol-data/int */ "./lib/mol-data/int.js");
/* harmony import */ var _mol_data_util__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../../mol-data/util */ "./lib/mol-data/util.js");
/* harmony import */ var _mol_math_geometry__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../../mol-math/geometry */ "./lib/mol-math/geometry.js");
/* harmony import */ var _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../../mol-math/linear-algebra */ "./lib/mol-math/linear-algebra.js");
/* harmony import */ var _mol_task__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../../mol-task */ "./lib/mol-task/index.js");
/* harmony import */ var _model__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../model */ "./lib/mol-model/structure/model.js");
/* harmony import */ var _query__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../query */ "./lib/mol-model/structure/query.js");
/* harmony import */ var _structure__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ./structure */ "./lib/mol-model/structure/structure/structure.js");
/* harmony import */ var _unit__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ./unit */ "./lib/mol-model/structure/structure/unit.js");
/* harmony import */ var _mol_model_formats_structure_property_symmetry__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ../../../mol-model-formats/structure/property/symmetry */ "./lib/mol-model-formats/structure/property/symmetry.js");
/* harmony import */ var _properties__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ./properties */ "./lib/mol-model/structure/structure/properties.js");
/**
 * Copyright (c) 2017-2020 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author David Sehnal <david.sehnal@gmail.com>
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */












var StructureSymmetry;
(function (StructureSymmetry) {
    function buildAssembly(structure, asmName) {
        var _this = this;
        return _mol_task__WEBPACK_IMPORTED_MODULE_5__["Task"].create('Build Assembly', function (ctx) { return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"])(_this, void 0, void 0, function () {
            var models, assembly, coordinateSystem, assembler, queryCtx, _i, _a, g, selection, units, _b, _c, oper, _d, units_1, unit;
            return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__generator"])(this, function (_e) {
                models = structure.models;
                if (models.length !== 1)
                    throw new Error('Can only build assemblies from structures based on 1 model.');
                assembly = _model__WEBPACK_IMPORTED_MODULE_6__["Symmetry"].findAssembly(models[0], asmName);
                if (!assembly)
                    throw new Error("Assembly '" + asmName + "' is not defined.");
                coordinateSystem = _mol_math_geometry__WEBPACK_IMPORTED_MODULE_3__["SymmetryOperator"].create(assembly.id, _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_4__["Mat4"].identity(), { assembly: { id: assembly.id, operId: 0, operList: [] } });
                assembler = _structure__WEBPACK_IMPORTED_MODULE_8__["default"].Builder({ coordinateSystem: coordinateSystem, label: structure.label });
                queryCtx = new _query__WEBPACK_IMPORTED_MODULE_7__["QueryContext"](structure);
                for (_i = 0, _a = assembly.operatorGroups; _i < _a.length; _i++) {
                    g = _a[_i];
                    selection = g.selector(queryCtx);
                    if (_query__WEBPACK_IMPORTED_MODULE_7__["StructureSelection"].structureCount(selection) === 0) {
                        continue;
                    }
                    units = _query__WEBPACK_IMPORTED_MODULE_7__["StructureSelection"].unionStructure(selection).units;
                    for (_b = 0, _c = g.operators; _b < _c.length; _b++) {
                        oper = _c[_b];
                        for (_d = 0, units_1 = units; _d < units_1.length; _d++) {
                            unit = units_1[_d];
                            assembler.addWithOperator(unit, oper);
                        }
                    }
                }
                return [2 /*return*/, assembler.getStructure()];
            });
        }); });
    }
    StructureSymmetry.buildAssembly = buildAssembly;
    function buildSymmetryAssembly(structure, generators, symmetry) {
        var _this = this;
        return _mol_task__WEBPACK_IMPORTED_MODULE_5__["Task"].create('Build Symmetry Assembly', function (ctx) { return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"])(_this, void 0, void 0, function () {
            var models, modelCenter, assembler, queryCtx, _i, generators_1, g, selector, selection, units, _a, _b, _c, index, _d, i, j, k, operators, _e, units_2, unit, _f, operators_1, op;
            return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__generator"])(this, function (_g) {
                models = structure.models;
                if (models.length !== 1)
                    throw new Error('Can only build symmetry assemblies from structures based on 1 model.');
                modelCenter = Object(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_4__["Vec3"])();
                assembler = _structure__WEBPACK_IMPORTED_MODULE_8__["default"].Builder({ label: structure.label, representativeModel: models[0] });
                queryCtx = new _query__WEBPACK_IMPORTED_MODULE_7__["QueryContext"](structure);
                for (_i = 0, generators_1 = generators; _i < generators_1.length; _i++) {
                    g = generators_1[_i];
                    selector = getSelector(g.asymIds);
                    selection = selector(queryCtx);
                    if (_query__WEBPACK_IMPORTED_MODULE_7__["StructureSelection"].structureCount(selection) === 0) {
                        continue;
                    }
                    units = _query__WEBPACK_IMPORTED_MODULE_7__["StructureSelection"].unionStructure(selection).units;
                    for (_a = 0, _b = g.operators; _a < _b.length; _a++) {
                        _c = _b[_a], index = _c.index, _d = _c.shift, i = _d[0], j = _d[1], k = _d[2];
                        operators = getOperatorsForIndex(symmetry, index, i, j, k, modelCenter);
                        for (_e = 0, units_2 = units; _e < units_2.length; _e++) {
                            unit = units_2[_e];
                            for (_f = 0, operators_1 = operators; _f < operators_1.length; _f++) {
                                op = operators_1[_f];
                                assembler.addWithOperator(unit, op);
                            }
                        }
                    }
                }
                return [2 /*return*/, assembler.getStructure()];
            });
        }); });
    }
    StructureSymmetry.buildSymmetryAssembly = buildSymmetryAssembly;
    function builderSymmetryMates(structure, radius) {
        return _mol_task__WEBPACK_IMPORTED_MODULE_5__["Task"].create('Find Symmetry Mates', function (ctx) { return findMatesRadius(ctx, structure, radius); });
    }
    StructureSymmetry.builderSymmetryMates = builderSymmetryMates;
    function buildSymmetryRange(structure, ijkMin, ijkMax) {
        return _mol_task__WEBPACK_IMPORTED_MODULE_5__["Task"].create('Build Symmetry', function (ctx) { return findSymmetryRange(ctx, structure, ijkMin, ijkMax); });
    }
    StructureSymmetry.buildSymmetryRange = buildSymmetryRange;
    /** Builds NCS structure, returns the original if NCS operators are not present. */
    function buildNcs(structure) {
        return _mol_task__WEBPACK_IMPORTED_MODULE_5__["Task"].create('Build NCS', function (ctx) { return _buildNCS(ctx, structure); });
    }
    StructureSymmetry.buildNcs = buildNcs;
    function areUnitsEquivalent(a, b) {
        return a.invariantId === b.invariantId && a.model.id === b.model.id && _mol_data_int__WEBPACK_IMPORTED_MODULE_1__["SortedArray"].areEqual(a.elements, b.elements);
    }
    StructureSymmetry.areUnitsEquivalent = areUnitsEquivalent;
    function UnitEquivalenceBuilder() {
        return Object(_mol_data_util__WEBPACK_IMPORTED_MODULE_2__["EquivalenceClasses"])(_unit__WEBPACK_IMPORTED_MODULE_9__["default"].hashUnit, areUnitsEquivalent);
    }
    StructureSymmetry.UnitEquivalenceBuilder = UnitEquivalenceBuilder;
    function computeTransformGroups(s) {
        var groups = UnitEquivalenceBuilder();
        for (var _i = 0, _a = s.units; _i < _a.length; _i++) {
            var u = _a[_i];
            groups.add(u.id, u);
        }
        var ret = [];
        for (var _b = 0, _c = groups.groups; _b < _c.length; _b++) {
            var eqUnits = _c[_b];
            ret.push(_unit__WEBPACK_IMPORTED_MODULE_9__["default"].SymmetryGroup(eqUnits.map(function (id) { return s.unitMap.get(id); })));
        }
        return ret;
    }
    StructureSymmetry.computeTransformGroups = computeTransformGroups;
    /** Checks if transform groups are equal up to their unit's transformations */
    function areTransformGroupsEquivalent(a, b) {
        if (a.length !== b.length)
            return false;
        for (var i = 0, il = a.length; i < il; ++i) {
            var au = a[i].units, bu = b[i].units;
            if (au.length !== bu.length)
                return false;
            if (a[i].hashCode !== b[i].hashCode)
                return false;
            for (var j = 0, _j = au.length; j < _j; j++) {
                if (au[j].conformation !== bu[j].conformation)
                    return false;
            }
        }
        return true;
    }
    StructureSymmetry.areTransformGroupsEquivalent = areTransformGroupsEquivalent;
})(StructureSymmetry || (StructureSymmetry = {}));
function getSelector(asymIds) {
    return _query__WEBPACK_IMPORTED_MODULE_7__["Queries"].generators.atoms({ chainTest: _query__WEBPACK_IMPORTED_MODULE_7__["Queries"].pred.and(_query__WEBPACK_IMPORTED_MODULE_7__["Queries"].pred.eq(function (ctx) { return _properties__WEBPACK_IMPORTED_MODULE_11__["default"].unit.operator_name(ctx.element); }, _mol_math_geometry__WEBPACK_IMPORTED_MODULE_3__["SymmetryOperator"].DefaultName), _query__WEBPACK_IMPORTED_MODULE_7__["Queries"].pred.inSet(function (ctx) { return _properties__WEBPACK_IMPORTED_MODULE_11__["default"].chain.label_asym_id(ctx.element); }, asymIds)) });
}
function getOperatorsForIndex(symmetry, index, i, j, k, modelCenter) {
    var spacegroup = symmetry.spacegroup, ncsOperators = symmetry.ncsOperators;
    var operators = [];
    var toFractional = spacegroup.cell.toFractional;
    var ref = _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_4__["Vec3"].transformMat4(Object(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_4__["Vec3"])(), modelCenter, toFractional);
    var symOp = _mol_math_geometry__WEBPACK_IMPORTED_MODULE_3__["Spacegroup"].getSymmetryOperatorRef(spacegroup, index, i, j, k, ref);
    if (ncsOperators && ncsOperators.length) {
        for (var u = 0, ul = ncsOperators.length; u < ul; ++u) {
            var ncsOp = ncsOperators[u];
            var matrix = _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_4__["Mat4"].mul(Object(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_4__["Mat4"])(), symOp.matrix, ncsOp.matrix);
            var operator = _mol_math_geometry__WEBPACK_IMPORTED_MODULE_3__["SymmetryOperator"].create(symOp.name + " " + ncsOp.name, matrix, {
                assembly: symOp.assembly,
                ncsId: ncsOp.ncsId,
                hkl: symOp.hkl,
                spgrOp: symOp.spgrOp
            });
            operators.push(operator);
        }
    }
    else {
        operators.push(symOp);
    }
    return operators;
}
function getOperatorsForRange(symmetry, ijkMin, ijkMax, modelCenter) {
    var spacegroup = symmetry.spacegroup, ncsOperators = symmetry.ncsOperators;
    var ncsCount = (ncsOperators && ncsOperators.length) || 0;
    var operators = [];
    if (!ncsCount &&
        ijkMin[0] <= 0 && ijkMax[0] >= 0 &&
        ijkMin[1] <= 0 && ijkMax[1] >= 0 &&
        ijkMin[2] <= 0 && ijkMax[2] >= 0) {
        operators[0] = _mol_math_geometry__WEBPACK_IMPORTED_MODULE_3__["Spacegroup"].getSymmetryOperator(spacegroup, 0, 0, 0, 0);
    }
    var toFractional = spacegroup.cell.toFractional;
    var ref = _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_4__["Vec3"].transformMat4(Object(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_4__["Vec3"])(), modelCenter, toFractional);
    for (var op = 0; op < spacegroup.operators.length; op++) {
        for (var i = ijkMin[0]; i <= ijkMax[0]; i++) {
            for (var j = ijkMin[1]; j <= ijkMax[1]; j++) {
                for (var k = ijkMin[2]; k <= ijkMax[2]; k++) {
                    // check if we have added identity as the 1st operator.
                    if (!ncsCount && op === 0 && i === 0 && j === 0 && k === 0)
                        continue;
                    operators.push.apply(operators, getOperatorsForIndex(symmetry, op, i, j, k, ref));
                }
            }
        }
    }
    return operators;
}
function getOperatorsCached333(symmetry, ref) {
    if (symmetry._operators_333 && _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_4__["Vec3"].equals(ref, symmetry._operators_333.ref)) {
        return symmetry._operators_333.operators;
    }
    symmetry._operators_333 = {
        ref: _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_4__["Vec3"].clone(ref),
        operators: getOperatorsForRange(symmetry, _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_4__["Vec3"].create(-3, -3, -3), _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_4__["Vec3"].create(3, 3, 3), ref)
    };
    return symmetry._operators_333.operators;
}
function assembleOperators(structure, operators) {
    var assembler = _structure__WEBPACK_IMPORTED_MODULE_8__["default"].Builder({ label: structure.label });
    var units = structure.units;
    for (var _i = 0, operators_2 = operators; _i < operators_2.length; _i++) {
        var oper = operators_2[_i];
        for (var _a = 0, units_3 = units; _a < units_3.length; _a++) {
            var unit = units_3[_a];
            assembler.addWithOperator(unit, oper);
        }
    }
    return assembler.getStructure();
}
function _buildNCS(ctx, structure) {
    return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"])(this, void 0, void 0, function () {
        var models, symmetry, operators;
        return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__generator"])(this, function (_a) {
            models = structure.models;
            if (models.length !== 1)
                throw new Error('Can only build NCS from structures based on 1 model.');
            symmetry = _mol_model_formats_structure_property_symmetry__WEBPACK_IMPORTED_MODULE_10__["ModelSymmetry"].Provider.get(models[0]);
            if (!symmetry)
                return [2 /*return*/, structure];
            operators = symmetry.ncsOperators;
            if (!operators || !operators.length)
                return [2 /*return*/, structure];
            return [2 /*return*/, assembleOperators(structure, operators)];
        });
    });
}
function findSymmetryRange(ctx, structure, ijkMin, ijkMax) {
    return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"])(this, void 0, void 0, function () {
        var models, symmetry, spacegroup, modelCenter, operators;
        return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__generator"])(this, function (_a) {
            models = structure.models;
            if (models.length !== 1)
                throw new Error('Can only build symmetries from structures based on 1 model.');
            symmetry = _mol_model_formats_structure_property_symmetry__WEBPACK_IMPORTED_MODULE_10__["ModelSymmetry"].Provider.get(models[0]);
            if (!symmetry)
                return [2 /*return*/, structure];
            spacegroup = symmetry.spacegroup;
            if (_mol_math_geometry__WEBPACK_IMPORTED_MODULE_3__["SpacegroupCell"].isZero(spacegroup.cell))
                return [2 /*return*/, structure];
            modelCenter = _model__WEBPACK_IMPORTED_MODULE_6__["Model"].getCenter(models[0]);
            operators = getOperatorsForRange(symmetry, ijkMin, ijkMax, modelCenter);
            return [2 /*return*/, assembleOperators(structure, operators)];
        });
    });
}
function findMatesRadius(ctx, structure, radius) {
    return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"])(this, void 0, void 0, function () {
        function hash(unit, oper) {
            return unit.invariantId + "|" + oper.name;
        }
        var models, symmetry, spacegroup, modelCenter, operators, lookup, added, assembler, units, center, _i, operators_3, oper, _a, units_4, unit, boundingSphere, closeUnits, uI, _uI, closeUnit, h;
        return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__generator"])(this, function (_b) {
            switch (_b.label) {
                case 0:
                    models = structure.models;
                    if (models.length !== 1)
                        throw new Error('Can only build symmetries from structures based on 1 model.');
                    symmetry = _mol_model_formats_structure_property_symmetry__WEBPACK_IMPORTED_MODULE_10__["ModelSymmetry"].Provider.get(models[0]);
                    if (!symmetry)
                        return [2 /*return*/, structure];
                    spacegroup = symmetry.spacegroup;
                    if (_mol_math_geometry__WEBPACK_IMPORTED_MODULE_3__["SpacegroupCell"].isZero(spacegroup.cell))
                        return [2 /*return*/, structure];
                    if (!ctx.shouldUpdate) return [3 /*break*/, 2];
                    return [4 /*yield*/, ctx.update('Initialing...')];
                case 1:
                    _b.sent();
                    _b.label = 2;
                case 2:
                    modelCenter = _model__WEBPACK_IMPORTED_MODULE_6__["Model"].getCenter(models[0]);
                    operators = getOperatorsCached333(symmetry, modelCenter);
                    lookup = structure.lookup3d;
                    added = new Set();
                    assembler = _structure__WEBPACK_IMPORTED_MODULE_8__["default"].Builder({ label: structure.label });
                    units = structure.units;
                    center = _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_4__["Vec3"].zero();
                    _i = 0, operators_3 = operators;
                    _b.label = 3;
                case 3:
                    if (!(_i < operators_3.length)) return [3 /*break*/, 6];
                    oper = operators_3[_i];
                    for (_a = 0, units_4 = units; _a < units_4.length; _a++) {
                        unit = units_4[_a];
                        boundingSphere = unit.lookup3d.boundary.sphere;
                        _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_4__["Vec3"].transformMat4(center, boundingSphere.center, oper.matrix);
                        closeUnits = lookup.findUnitIndices(center[0], center[1], center[2], boundingSphere.radius + radius);
                        for (uI = 0, _uI = closeUnits.count; uI < _uI; uI++) {
                            closeUnit = units[closeUnits.indices[uI]];
                            if (!closeUnit.lookup3d.check(center[0], center[1], center[2], boundingSphere.radius + radius))
                                continue;
                            h = hash(unit, oper);
                            if (!added.has(h)) {
                                assembler.addWithOperator(unit, oper);
                                added.add(h);
                            }
                        }
                    }
                    if (!ctx.shouldUpdate) return [3 /*break*/, 5];
                    return [4 /*yield*/, ctx.update('Building symmetry...')];
                case 4:
                    _b.sent();
                    _b.label = 5;
                case 5:
                    _i++;
                    return [3 /*break*/, 3];
                case 6: return [2 /*return*/, assembler.getStructure()];
            }
        });
    });
}
/* harmony default export */ __webpack_exports__["default"] = (StructureSymmetry);
//# sourceMappingURL=symmetry.js.map

/***/ }),

/***/ "./lib/mol-model/structure/structure/unit.js":
/*!***************************************************!*\
  !*** ./lib/mol-model/structure/structure/unit.js ***!
  \***************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _mol_math_geometry_symmetry_operator__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../../mol-math/geometry/symmetry-operator */ "./lib/mol-math/geometry/symmetry-operator.js");
/* harmony import */ var _model__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../model */ "./lib/mol-model/structure/model.js");
/* harmony import */ var _mol_math_geometry__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../../mol-math/geometry */ "./lib/mol-math/geometry.js");
/* harmony import */ var _unit_bonds__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./unit/bonds */ "./lib/mol-model/structure/structure/unit/bonds.js");
/* harmony import */ var _mol_util__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../../mol-util */ "./lib/mol-util/index.js");
/* harmony import */ var _unit_rings__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ./unit/rings */ "./lib/mol-model/structure/structure/unit/rings.js");
/* harmony import */ var _mol_data_int__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../../../mol-data/int */ "./lib/mol-data/int.js");
/* harmony import */ var _mol_data_util__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ../../../mol-data/util */ "./lib/mol-data/util.js");
/* harmony import */ var _util_polymer__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ./util/polymer */ "./lib/mol-model/structure/structure/util/polymer.js");
/* harmony import */ var _util_principal_axes__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ./util/principal-axes */ "./lib/mol-model/structure/structure/util/principal-axes.js");
/* harmony import */ var _mol_math_geometry_boundary__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ../../../mol-math/geometry/boundary */ "./lib/mol-math/geometry/boundary.js");
/* harmony import */ var _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! ../../../mol-math/linear-algebra */ "./lib/mol-math/linear-algebra.js");
/* harmony import */ var _mol_model_formats_structure_property_bonds_index_pair__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! ../../../mol-model-formats/structure/property/bonds/index-pair */ "./lib/mol-model-formats/structure/property/bonds/index-pair.js");
/* harmony import */ var _unit_bonds_element_set_intra_bond_cache__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! ./unit/bonds/element-set-intra-bond-cache */ "./lib/mol-model/structure/structure/unit/bonds/element-set-intra-bond-cache.js");
/* harmony import */ var _mol_model_formats_structure_property_symmetry__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! ../../../mol-model-formats/structure/property/symmetry */ "./lib/mol-model-formats/structure/property/symmetry.js");
/**
 * Copyright (c) 2017-2021 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author David Sehnal <david.sehnal@gmail.com>
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */
















var Unit;
(function (Unit) {
    function isAtomic(u) { return u.kind === 0 /* Atomic */; }
    Unit.isAtomic = isAtomic;
    function isCoarse(u) { return u.kind === 1 /* Spheres */ || u.kind === 2 /* Gaussians */; }
    Unit.isCoarse = isCoarse;
    function isSpheres(u) { return u.kind === 1 /* Spheres */; }
    Unit.isSpheres = isSpheres;
    function isGaussians(u) { return u.kind === 2 /* Gaussians */; }
    Unit.isGaussians = isGaussians;
    function create(id, invariantId, chainGroupId, traits, kind, model, operator, elements, props) {
        switch (kind) {
            case 0 /* Atomic */: return new Atomic(id, invariantId, chainGroupId, traits, model, elements, _mol_math_geometry_symmetry_operator__WEBPACK_IMPORTED_MODULE_1__["SymmetryOperator"].createMapping(operator, model.atomicConformation, void 0), props !== null && props !== void 0 ? props : AtomicProperties());
            case 1 /* Spheres */: return createCoarse(id, invariantId, chainGroupId, traits, model, 1 /* Spheres */, elements, _mol_math_geometry_symmetry_operator__WEBPACK_IMPORTED_MODULE_1__["SymmetryOperator"].createMapping(operator, model.coarseConformation.spheres, getSphereRadiusFunc(model)), props !== null && props !== void 0 ? props : CoarseProperties());
            case 2 /* Gaussians */: return createCoarse(id, invariantId, chainGroupId, traits, model, 2 /* Gaussians */, elements, _mol_math_geometry_symmetry_operator__WEBPACK_IMPORTED_MODULE_1__["SymmetryOperator"].createMapping(operator, model.coarseConformation.gaussians, getGaussianRadiusFunc(model)), props !== null && props !== void 0 ? props : CoarseProperties());
        }
    }
    Unit.create = create;
    function getUnitIndexMap(units) {
        var unitIndexMap = _mol_data_int__WEBPACK_IMPORTED_MODULE_7__["IntMap"].Mutable();
        for (var i = 0, _i = units.length; i < _i; i++) {
            unitIndexMap.set(units[i].id, i);
        }
        return unitIndexMap;
    }
    function getTransformHash(units) {
        var ids = [];
        for (var i = 0, _i = units.length; i < _i; i++) {
            ids.push(units[i].id);
        }
        return Object(_mol_data_util__WEBPACK_IMPORTED_MODULE_8__["hashFnv32a"])(ids);
    }
    function SymmetryGroup(units) {
        var props = {};
        return {
            elements: units[0].elements,
            units: units,
            get unitIndexMap() {
                if (props.unitIndexMap)
                    return props.unitIndexMap;
                props.unitIndexMap = getUnitIndexMap(units);
                return props.unitIndexMap;
            },
            hashCode: hashUnit(units[0]),
            transformHash: getTransformHash(units)
        };
    }
    Unit.SymmetryGroup = SymmetryGroup;
    (function (SymmetryGroup) {
        function areInvariantElementsEqual(a, b) {
            if (a.hashCode !== b.hashCode)
                return false;
            return _mol_data_int__WEBPACK_IMPORTED_MODULE_7__["SortedArray"].areEqual(a.elements, b.elements);
        }
        SymmetryGroup.areInvariantElementsEqual = areInvariantElementsEqual;
        function getUnitSymmetryGroupsIndexMap(symmetryGroups) {
            var unitSymmetryGroupsIndexMap = _mol_data_int__WEBPACK_IMPORTED_MODULE_7__["IntMap"].Mutable();
            for (var i = 0, il = symmetryGroups.length; i < il; ++i) {
                var sg = symmetryGroups[i];
                for (var j = 0, jl = sg.units.length; j < jl; ++j) {
                    unitSymmetryGroupsIndexMap.set(sg.units[j].id, i);
                }
            }
            return unitSymmetryGroupsIndexMap;
        }
        SymmetryGroup.getUnitSymmetryGroupsIndexMap = getUnitSymmetryGroupsIndexMap;
    })(SymmetryGroup = Unit.SymmetryGroup || (Unit.SymmetryGroup = {}));
    function conformationId(unit) {
        return Unit.isAtomic(unit) ? unit.model.atomicConformation.id : unit.model.coarseConformation.id;
    }
    Unit.conformationId = conformationId;
    function hashUnit(u) {
        return Object(_mol_data_util__WEBPACK_IMPORTED_MODULE_8__["hash2"])(u.invariantId, _mol_data_int__WEBPACK_IMPORTED_MODULE_7__["SortedArray"].hashCode(u.elements));
    }
    Unit.hashUnit = hashUnit;
    var Traits;
    (function (Traits) {
        Traits.is = _mol_util__WEBPACK_IMPORTED_MODULE_5__["BitFlags"].has;
        Traits.create = _mol_util__WEBPACK_IMPORTED_MODULE_5__["BitFlags"].create;
    })(Traits = Unit.Traits || (Unit.Traits = {}));
    function BaseProperties() {
        return {};
    }
    function getSphereRadiusFunc(model) {
        var r = model.coarseConformation.spheres.radius;
        return function (i) { return r[i]; };
    }
    function getGaussianRadiusFunc(model) {
        // TODO: compute radius for gaussians
        return function (i) { return 0; };
    }
    /**
     * A bulding block of a structure that corresponds
     * to a "natural group of atoms" (most often a "chain")
     * together with a transformation (rotation and translation)
     * that is dynamically applied to the underlying atom set.
     *
     * An atom set can be referenced by multiple different units which
     * makes construction of assemblies and spacegroups very efficient.
     */
    var Atomic = /** @class */ (function () {
        function Atomic(id, invariantId, chainGroupId, traits, model, elements, conformation, props) {
            this.kind = 0 /* Atomic */;
            this.objectPrimitive = 'atomistic';
            this.id = id;
            this.invariantId = invariantId;
            this.chainGroupId = chainGroupId;
            this.traits = traits;
            this.model = model;
            this.elements = elements;
            this.conformation = conformation;
            this.residueIndex = model.atomicHierarchy.residueAtomSegments.index;
            this.chainIndex = model.atomicHierarchy.chainAtomSegments.index;
            this.props = props;
        }
        Atomic.prototype.getChild = function (elements) {
            if (elements.length === this.elements.length)
                return this;
            return new Atomic(this.id, this.invariantId, this.chainGroupId, this.traits, this.model, elements, this.conformation, AtomicProperties());
        };
        Atomic.prototype.applyOperator = function (id, operator, dontCompose) {
            if (dontCompose === void 0) { dontCompose = false; }
            var op = dontCompose ? operator : _mol_math_geometry_symmetry_operator__WEBPACK_IMPORTED_MODULE_1__["SymmetryOperator"].compose(this.conformation.operator, operator);
            return new Atomic(id, this.invariantId, this.chainGroupId, this.traits, this.model, this.elements, _mol_math_geometry_symmetry_operator__WEBPACK_IMPORTED_MODULE_1__["SymmetryOperator"].createMapping(op, this.model.atomicConformation, this.conformation.r), this.props);
        };
        Atomic.prototype.remapModel = function (model, props) {
            if (!props) {
                props = Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, this.props), { bonds: tryRemapBonds(this, this.props.bonds, model) });
                if (!Unit.isSameConformation(this, model)) {
                    props.boundary = undefined;
                    props.lookup3d = undefined;
                    props.principalAxes = undefined;
                }
            }
            var operator = this.conformation.operator;
            var symmetry = _mol_model_formats_structure_property_symmetry__WEBPACK_IMPORTED_MODULE_15__["ModelSymmetry"].Provider.get(model);
            if (operator.spgrOp !== -1 && symmetry && symmetry !== _mol_model_formats_structure_property_symmetry__WEBPACK_IMPORTED_MODULE_15__["ModelSymmetry"].Provider.get(this.model)) {
                var _a = operator.hkl, i = _a[0], j = _a[1], k = _a[2];
                var toFractional = symmetry.spacegroup.cell.toFractional;
                var ref = _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_12__["Vec3"].transformMat4(Object(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_12__["Vec3"])(), _model__WEBPACK_IMPORTED_MODULE_2__["Model"].getCenter(model), toFractional);
                operator = _mol_math_geometry__WEBPACK_IMPORTED_MODULE_3__["Spacegroup"].getSymmetryOperatorRef(symmetry.spacegroup, operator.spgrOp, i, j, k, ref);
            }
            var conformation = (this.model.atomicConformation !== model.atomicConformation || operator !== this.conformation.operator)
                ? _mol_math_geometry_symmetry_operator__WEBPACK_IMPORTED_MODULE_1__["SymmetryOperator"].createMapping(operator, model.atomicConformation)
                : this.conformation;
            return new Atomic(this.id, this.invariantId, this.chainGroupId, this.traits, model, this.elements, conformation, props);
        };
        Object.defineProperty(Atomic.prototype, "boundary", {
            get: function () {
                if (this.props.boundary)
                    return this.props.boundary;
                var _a = this.model.atomicConformation, x = _a.x, y = _a.y, z = _a.z;
                this.props.boundary = Object(_mol_math_geometry_boundary__WEBPACK_IMPORTED_MODULE_11__["getBoundary"])({ x: x, y: y, z: z, indices: this.elements });
                return this.props.boundary;
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(Atomic.prototype, "lookup3d", {
            get: function () {
                if (this.props.lookup3d)
                    return this.props.lookup3d;
                var _a = this.model.atomicConformation, x = _a.x, y = _a.y, z = _a.z;
                this.props.lookup3d = Object(_mol_math_geometry__WEBPACK_IMPORTED_MODULE_3__["GridLookup3D"])({ x: x, y: y, z: z, indices: this.elements }, this.boundary);
                return this.props.lookup3d;
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(Atomic.prototype, "principalAxes", {
            get: function () {
                if (this.props.principalAxes)
                    return this.props.principalAxes;
                this.props.principalAxes = Object(_util_principal_axes__WEBPACK_IMPORTED_MODULE_10__["getPrincipalAxes"])(this);
                return this.props.principalAxes;
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(Atomic.prototype, "bonds", {
            get: function () {
                if (this.props.bonds)
                    return this.props.bonds;
                var cache = _unit_bonds_element_set_intra_bond_cache__WEBPACK_IMPORTED_MODULE_14__["ElementSetIntraBondCache"].get(this.model);
                var bonds = cache.get(this.elements);
                if (!bonds) {
                    bonds = Object(_unit_bonds__WEBPACK_IMPORTED_MODULE_4__["computeIntraUnitBonds"])(this);
                    cache.set(this.elements, bonds);
                }
                this.props.bonds = bonds;
                return this.props.bonds;
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(Atomic.prototype, "rings", {
            get: function () {
                if (this.props.rings)
                    return this.props.rings;
                this.props.rings = _unit_rings__WEBPACK_IMPORTED_MODULE_6__["UnitRings"].create(this);
                return this.props.rings;
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(Atomic.prototype, "polymerElements", {
            get: function () {
                if (this.props.polymerElements)
                    return this.props.polymerElements;
                this.props.polymerElements = Object(_util_polymer__WEBPACK_IMPORTED_MODULE_9__["getAtomicPolymerElements"])(this);
                return this.props.polymerElements;
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(Atomic.prototype, "gapElements", {
            get: function () {
                if (this.props.gapElements)
                    return this.props.gapElements;
                this.props.gapElements = Object(_util_polymer__WEBPACK_IMPORTED_MODULE_9__["getAtomicGapElements"])(this);
                return this.props.gapElements;
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(Atomic.prototype, "nucleotideElements", {
            get: function () {
                if (this.props.nucleotideElements)
                    return this.props.nucleotideElements;
                this.props.nucleotideElements = Object(_util_polymer__WEBPACK_IMPORTED_MODULE_9__["getNucleotideElements"])(this);
                return this.props.nucleotideElements;
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(Atomic.prototype, "proteinElements", {
            get: function () {
                if (this.props.proteinElements)
                    return this.props.proteinElements;
                this.props.proteinElements = Object(_util_polymer__WEBPACK_IMPORTED_MODULE_9__["getProteinElements"])(this);
                return this.props.proteinElements;
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(Atomic.prototype, "residueCount", {
            get: function () {
                if (this.props.residueCount !== undefined)
                    return this.props.residueCount;
                var residueCount = 0;
                var residueIt = _mol_data_int__WEBPACK_IMPORTED_MODULE_7__["Segmentation"].transientSegments(this.model.atomicHierarchy.residueAtomSegments, this.elements);
                while (residueIt.hasNext) {
                    residueIt.move();
                    residueCount += 1;
                }
                this.props.residueCount = residueCount;
                return this.props.residueCount;
            },
            enumerable: false,
            configurable: true
        });
        Atomic.prototype.getResidueIndex = function (elementIndex) {
            return this.residueIndex[this.elements[elementIndex]];
        };
        return Atomic;
    }());
    Unit.Atomic = Atomic;
    function AtomicProperties() {
        return BaseProperties();
    }
    var Coarse = /** @class */ (function () {
        function Coarse(id, invariantId, chainGroupId, traits, model, kind, elements, conformation, props) {
            this.kind = kind;
            this.objectPrimitive = kind === 1 /* Spheres */ ? 'sphere' : 'gaussian';
            this.id = id;
            this.invariantId = invariantId;
            this.chainGroupId = chainGroupId;
            this.traits = traits;
            this.model = model;
            this.elements = elements;
            this.conformation = conformation;
            this.coarseElements = kind === 1 /* Spheres */ ? model.coarseHierarchy.spheres : model.coarseHierarchy.gaussians;
            this.coarseConformation = (kind === 1 /* Spheres */ ? model.coarseConformation.spheres : model.coarseConformation.gaussians);
            this.props = props;
        }
        Coarse.prototype.getChild = function (elements) {
            if (elements.length === this.elements.length)
                return this /** lets call this an ugly temporary hack */;
            return createCoarse(this.id, this.invariantId, this.chainGroupId, this.traits, this.model, this.kind, elements, this.conformation, CoarseProperties());
        };
        Coarse.prototype.applyOperator = function (id, operator, dontCompose) {
            if (dontCompose === void 0) { dontCompose = false; }
            var op = dontCompose ? operator : _mol_math_geometry_symmetry_operator__WEBPACK_IMPORTED_MODULE_1__["SymmetryOperator"].compose(this.conformation.operator, operator);
            return createCoarse(id, this.invariantId, this.chainGroupId, this.traits, this.model, this.kind, this.elements, _mol_math_geometry_symmetry_operator__WEBPACK_IMPORTED_MODULE_1__["SymmetryOperator"].createMapping(op, this.getCoarseConformation(), this.conformation.r), this.props);
        };
        Coarse.prototype.remapModel = function (model, props) {
            var coarseConformation = this.getCoarseConformation();
            var modelCoarseConformation = getCoarseConformation(this.kind, model);
            if (!props) {
                props = Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, this.props);
                if (!Unit.isSameConformation(this, model)) { // TODO get rid of casting
                    props.boundary = undefined;
                    props.lookup3d = undefined;
                    props.principalAxes = undefined;
                }
            }
            var conformation = coarseConformation !== modelCoarseConformation
                ? _mol_math_geometry_symmetry_operator__WEBPACK_IMPORTED_MODULE_1__["SymmetryOperator"].createMapping(this.conformation.operator, modelCoarseConformation)
                : this.conformation;
            return new Coarse(this.id, this.invariantId, this.chainGroupId, this.traits, model, this.kind, this.elements, conformation, props); // TODO get rid of casting
        };
        Object.defineProperty(Coarse.prototype, "boundary", {
            get: function () {
                if (this.props.boundary)
                    return this.props.boundary;
                // TODO: support sphere radius?
                var _a = this.getCoarseConformation(), x = _a.x, y = _a.y, z = _a.z;
                this.props.boundary = Object(_mol_math_geometry_boundary__WEBPACK_IMPORTED_MODULE_11__["getBoundary"])({ x: x, y: y, z: z, indices: this.elements });
                return this.props.boundary;
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(Coarse.prototype, "lookup3d", {
            get: function () {
                if (this.props.lookup3d)
                    return this.props.lookup3d;
                // TODO: support sphere radius?
                var _a = this.getCoarseConformation(), x = _a.x, y = _a.y, z = _a.z;
                this.props.lookup3d = Object(_mol_math_geometry__WEBPACK_IMPORTED_MODULE_3__["GridLookup3D"])({ x: x, y: y, z: z, indices: this.elements }, this.boundary);
                return this.props.lookup3d;
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(Coarse.prototype, "principalAxes", {
            get: function () {
                if (this.props.principalAxes)
                    return this.props.principalAxes;
                this.props.principalAxes = Object(_util_principal_axes__WEBPACK_IMPORTED_MODULE_10__["getPrincipalAxes"])(this); // TODO get rid of casting
                return this.props.principalAxes;
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(Coarse.prototype, "polymerElements", {
            get: function () {
                if (this.props.polymerElements)
                    return this.props.polymerElements;
                this.props.polymerElements = Object(_util_polymer__WEBPACK_IMPORTED_MODULE_9__["getCoarsePolymerElements"])(this); // TODO get rid of casting
                return this.props.polymerElements;
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(Coarse.prototype, "gapElements", {
            get: function () {
                if (this.props.gapElements)
                    return this.props.gapElements;
                this.props.gapElements = Object(_util_polymer__WEBPACK_IMPORTED_MODULE_9__["getCoarseGapElements"])(this); // TODO get rid of casting
                return this.props.gapElements;
            },
            enumerable: false,
            configurable: true
        });
        Coarse.prototype.getCoarseConformation = function () {
            return getCoarseConformation(this.kind, this.model);
        };
        return Coarse;
    }());
    function getCoarseConformation(kind, model) {
        return kind === 1 /* Spheres */ ? model.coarseConformation.spheres : model.coarseConformation.gaussians;
    }
    function CoarseProperties() {
        return BaseProperties();
    }
    var Spheres = /** @class */ (function (_super) {
        Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__extends"])(Spheres, _super);
        function Spheres() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        return Spheres;
    }(Coarse));
    Unit.Spheres = Spheres;
    var Gaussians = /** @class */ (function (_super) {
        Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__extends"])(Gaussians, _super);
        function Gaussians() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        return Gaussians;
    }(Coarse));
    Unit.Gaussians = Gaussians;
    function createCoarse(id, invariantId, chainGroupId, traits, model, kind, elements, conformation, props) {
        return new Coarse(id, invariantId, chainGroupId, traits, model, kind, elements, conformation, props) /** lets call this an ugly temporary hack */;
    }
    function areSameChainOperatorGroup(a, b) {
        return a.chainGroupId === b.chainGroupId && a.conformation.operator.name === b.conformation.operator.name;
    }
    Unit.areSameChainOperatorGroup = areSameChainOperatorGroup;
    function areOperatorsEqual(a, b) {
        return _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_12__["Mat4"].areEqual(a.conformation.operator.matrix, b.conformation.operator.matrix, 1e-6);
    }
    Unit.areOperatorsEqual = areOperatorsEqual;
    function areConformationsEqual(a, b) {
        if (!_mol_data_int__WEBPACK_IMPORTED_MODULE_7__["SortedArray"].areEqual(a.elements, b.elements))
            return false;
        return isSameConformation(a, b.model);
    }
    Unit.areConformationsEqual = areConformationsEqual;
    function tryRemapBonds(a, old, model) {
        // TODO: should include additional checks?
        var _a;
        if (!old)
            return void 0;
        if (a.model.atomicConformation.id === model.atomicConformation.id)
            return old;
        var oldIndex = _mol_model_formats_structure_property_bonds_index_pair__WEBPACK_IMPORTED_MODULE_13__["IndexPairBonds"].Provider.get(a.model);
        if (oldIndex) {
            var newIndex = _mol_model_formats_structure_property_bonds_index_pair__WEBPACK_IMPORTED_MODULE_13__["IndexPairBonds"].Provider.get(model);
            // TODO: check the actual indices instead of just reference equality?
            if (!newIndex || oldIndex === newIndex)
                return old;
            return void 0;
        }
        if ((_a = old.props) === null || _a === void 0 ? void 0 : _a.canRemap) {
            return old;
        }
        return isSameConformation(a, model) ? old : void 0;
    }
    function isSameConformation(u, model) {
        var coordsHistory = _model__WEBPACK_IMPORTED_MODULE_2__["Model"].CoordinatesHistory.get(_model__WEBPACK_IMPORTED_MODULE_2__["Model"].getRoot(model));
        if (coordsHistory)
            return coordsHistory.areEqual(u.elements, u.kind, model);
        var xs = u.elements;
        var _a = u.conformation.coordinates, xa = _a.x, ya = _a.y, za = _a.z;
        var _b = getModelConformationOfKind(u.kind, model), xb = _b.x, yb = _b.y, zb = _b.z;
        for (var i = 0, _i = xs.length; i < _i; i++) {
            var u_1 = xs[i];
            if (xa[u_1] !== xb[u_1] || ya[u_1] !== yb[u_1] || za[u_1] !== zb[u_1])
                return false;
        }
        return true;
    }
    Unit.isSameConformation = isSameConformation;
    function getModelConformationOfKind(kind, model) {
        return kind === 0 /* Atomic */ ? model.atomicConformation :
            kind === 1 /* Spheres */ ? model.coarseConformation.spheres :
                model.coarseConformation.gaussians;
    }
    Unit.getModelConformationOfKind = getModelConformationOfKind;
    function getConformation(u) {
        return getModelConformationOfKind(u.kind, u.model);
    }
    Unit.getConformation = getConformation;
    function getModelHierarchyOfKind(kind, model) {
        return kind === 0 /* Atomic */ ? model.atomicHierarchy :
            kind === 1 /* Spheres */ ? model.coarseHierarchy.spheres :
                model.coarseHierarchy.gaussians;
    }
    Unit.getModelHierarchyOfKind = getModelHierarchyOfKind;
    function getHierarchy(u) {
        return getModelHierarchyOfKind(u.kind, u.model);
    }
    Unit.getHierarchy = getHierarchy;
})(Unit || (Unit = {}));
/* harmony default export */ __webpack_exports__["default"] = (Unit);
//# sourceMappingURL=unit.js.map

/***/ }),

/***/ "./lib/mol-model/structure/structure/unit/bonds.js":
/*!*********************************************************!*\
  !*** ./lib/mol-model/structure/structure/unit/bonds.js ***!
  \*********************************************************/
/*! exports provided: IntraUnitBonds, InterUnitBonds, computeIntraUnitBonds, computeInterUnitBonds, Bond */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Bond", function() { return Bond; });
/* harmony import */ var _structure__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../structure */ "./lib/mol-model/structure/structure.js");
/* harmony import */ var _model_types__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../model/types */ "./lib/mol-model/structure/model/types.js");
/* harmony import */ var _mol_data_int__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../../../mol-data/int */ "./lib/mol-data/int.js");
/* harmony import */ var _mol_math_geometry_centroid_helper__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../../../mol-math/geometry/centroid-helper */ "./lib/mol-math/geometry/centroid-helper.js");
/* harmony import */ var _bonds_data__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./bonds/data */ "./lib/mol-model/structure/structure/unit/bonds/data.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "IntraUnitBonds", function() { return _bonds_data__WEBPACK_IMPORTED_MODULE_4__["IntraUnitBonds"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "InterUnitBonds", function() { return _bonds_data__WEBPACK_IMPORTED_MODULE_4__["InterUnitBonds"]; });

/* harmony import */ var _bonds_intra_compute__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./bonds/intra-compute */ "./lib/mol-model/structure/structure/unit/bonds/intra-compute.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "computeIntraUnitBonds", function() { return _bonds_intra_compute__WEBPACK_IMPORTED_MODULE_5__["computeIntraUnitBonds"]; });

/* harmony import */ var _bonds_inter_compute__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ./bonds/inter-compute */ "./lib/mol-model/structure/structure/unit/bonds/inter-compute.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "computeInterUnitBonds", function() { return _bonds_inter_compute__WEBPACK_IMPORTED_MODULE_6__["computeInterUnitBonds"]; });

/**
 * Copyright (c) 2017-2020 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author David Sehnal <david.sehnal@gmail.com>
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */







var Bond;
(function (Bond) {
    function Location(aStructure, aUnit, aIndex, bStructure, bUnit, bIndex) {
        return {
            kind: 'bond-location',
            aStructure: aStructure,
            aUnit: aUnit,
            aIndex: aIndex,
            bStructure: bStructure,
            bUnit: bUnit,
            bIndex: bIndex
        };
    }
    Bond.Location = Location;
    function isLocation(x) {
        return !!x && x.kind === 'bond-location';
    }
    Bond.isLocation = isLocation;
    function areLocationsEqual(locA, locB) {
        return (locA.aStructure.label === locB.aStructure.label && locA.bStructure.label === locB.bStructure.label &&
            locA.aIndex === locB.aIndex && locA.bIndex === locB.bIndex &&
            locA.aUnit.id === locB.aUnit.id && locA.bUnit.id === locB.bUnit.id);
    }
    Bond.areLocationsEqual = areLocationsEqual;
    function Loci(structure, bonds) {
        return { kind: 'bond-loci', structure: structure, bonds: bonds };
    }
    Bond.Loci = Loci;
    function isLoci(x) {
        return !!x && x.kind === 'bond-loci';
    }
    Bond.isLoci = isLoci;
    function areLociEqual(a, b) {
        if (a.structure !== b.structure)
            return false;
        if (a.bonds.length !== b.bonds.length)
            return false;
        for (var i = 0, il = a.bonds.length; i < il; ++i) {
            if (!areLocationsEqual(a.bonds[i], b.bonds[i]))
                return false;
        }
        return true;
    }
    Bond.areLociEqual = areLociEqual;
    function isLociEmpty(loci) {
        return loci.bonds.length === 0 ? true : false;
    }
    Bond.isLociEmpty = isLociEmpty;
    function remapLoci(loci, structure) {
        if (structure === loci.structure)
            return loci;
        var bonds = [];
        loci.bonds.forEach(function (l) {
            var unitA = structure.unitMap.get(l.aUnit.id);
            if (!unitA)
                return;
            var unitB = structure.unitMap.get(l.bUnit.id);
            if (!unitB)
                return;
            var elementA = l.aUnit.elements[l.aIndex];
            var indexA = _mol_data_int__WEBPACK_IMPORTED_MODULE_2__["SortedArray"].indexOf(unitA.elements, elementA);
            if (indexA === -1)
                return;
            var elementB = l.bUnit.elements[l.bIndex];
            var indexB = _mol_data_int__WEBPACK_IMPORTED_MODULE_2__["SortedArray"].indexOf(unitB.elements, elementB);
            if (indexB === -1)
                return;
            bonds.push(Location(loci.structure, unitA, indexA, loci.structure, unitB, indexB));
        });
        return Loci(structure, bonds);
    }
    Bond.remapLoci = remapLoci;
    function toStructureElementLoci(loci) {
        var elements = [];
        var map = new Map();
        for (var _i = 0, _a = loci.bonds; _i < _a.length; _i++) {
            var lociBond = _a[_i];
            var aIndex = lociBond.aIndex, aUnit = lociBond.aUnit, bIndex = lociBond.bIndex, bUnit = lociBond.bUnit;
            if (aUnit === bUnit) {
                if (map.has(aUnit.id))
                    map.get(aUnit.id).push(aIndex, bIndex);
                else
                    map.set(aUnit.id, [aIndex, bIndex]);
            }
            else {
                if (map.has(aUnit.id))
                    map.get(aUnit.id).push(aIndex);
                else
                    map.set(aUnit.id, [aIndex]);
                if (map.has(bUnit.id))
                    map.get(bUnit.id).push(bIndex);
                else
                    map.set(bUnit.id, [bIndex]);
            }
        }
        map.forEach(function (indices, id) {
            elements.push({
                unit: loci.structure.unitMap.get(id),
                indices: _mol_data_int__WEBPACK_IMPORTED_MODULE_2__["SortedArray"].deduplicate(_mol_data_int__WEBPACK_IMPORTED_MODULE_2__["SortedArray"].ofUnsortedArray(indices))
            });
        });
        return _structure__WEBPACK_IMPORTED_MODULE_0__["StructureElement"].Loci(loci.structure, elements);
    }
    Bond.toStructureElementLoci = toStructureElementLoci;
    function getType(structure, location) {
        if (location.aUnit === location.bUnit) {
            var bonds = location.aUnit.bonds;
            var idx = bonds.getEdgeIndex(location.aIndex, location.bIndex);
            if (idx < 0)
                return _model_types__WEBPACK_IMPORTED_MODULE_1__["BondType"].create(0 /* None */);
            return _model_types__WEBPACK_IMPORTED_MODULE_1__["BondType"].create(bonds.edgeProps.flags[idx]);
        }
        else {
            var bond = structure.interUnitBonds.getBondFromLocation(location);
            if (bond)
                return _model_types__WEBPACK_IMPORTED_MODULE_1__["BondType"].create(bond.props.flag);
            return _model_types__WEBPACK_IMPORTED_MODULE_1__["BondType"].create(0 /* None */);
        }
    }
    Bond.getType = getType;
    function getOrder(structure, location) {
        if (location.aUnit === location.bUnit) {
            var bonds = location.aUnit.bonds;
            var idx = bonds.getEdgeIndex(location.aIndex, location.bIndex);
            if (idx < 0)
                return 0;
            return bonds.edgeProps.order[idx];
        }
        else {
            var bond = structure.interUnitBonds.getBondFromLocation(location);
            if (bond)
                return bond.props.order;
            return 0;
        }
    }
    Bond.getOrder = getOrder;
    function getIntraUnitBondCount(structure) {
        var count = 0;
        for (var i = 0, il = structure.units.length; i < il; ++i) {
            var u = structure.units[i];
            if (_structure__WEBPACK_IMPORTED_MODULE_0__["Unit"].isAtomic(u))
                count += u.bonds.edgeCount;
        }
        return count;
    }
    Bond.getIntraUnitBondCount = getIntraUnitBondCount;
    var ElementBondIterator = /** @class */ (function () {
        function ElementBondIterator() {
            this.current = {};
            this.hasNext = false;
        }
        ElementBondIterator.prototype.move = function () {
            this.advance();
            return this.current;
        };
        ElementBondIterator.prototype.setElement = function (structure, unit, index) {
            this.structure = structure;
            this.unit = unit;
            this.index = index;
            this.interBondIndices = structure.interUnitBonds.getEdgeIndices(index, unit.id);
            this.interBondCount = this.interBondIndices.length;
            this.interBondIndex = 0;
            this.intraBondEnd = unit.bonds.offset[index + 1];
            this.intraBondIndex = unit.bonds.offset[index];
            this.hasNext = this.interBondIndex < this.interBondCount || this.intraBondIndex < this.intraBondEnd;
        };
        ElementBondIterator.prototype.advance = function () {
            if (this.intraBondIndex < this.intraBondEnd) {
                this.current.otherUnit = this.unit;
                this.current.otherIndex = this.unit.bonds.b[this.intraBondIndex];
                this.current.type = this.unit.bonds.edgeProps.flags[this.intraBondIndex];
                this.current.order = this.unit.bonds.edgeProps.order[this.intraBondIndex];
                this.intraBondIndex += 1;
            }
            else if (this.interBondIndex < this.interBondCount) {
                var b = this.structure.interUnitBonds.edges[this.interBondIndex];
                this.current.otherUnit = this.structure.unitMap.get(b.unitA !== this.unit.id ? b.unitA : b.unitB);
                this.current.otherIndex = b.indexA !== this.index ? b.indexA : b.indexB;
                this.current.type = b.props.flag;
                this.current.order = b.props.order;
                this.interBondIndex += 1;
            }
            else {
                this.hasNext = false;
                return;
            }
            this.hasNext = this.interBondIndex < this.interBondCount || this.intraBondIndex < this.intraBondEnd;
        };
        return ElementBondIterator;
    }());
    Bond.ElementBondIterator = ElementBondIterator;
    function getBoundingSphere(loci, boundingSphere) {
        return _mol_math_geometry_centroid_helper__WEBPACK_IMPORTED_MODULE_3__["CentroidHelper"].fromPairProvider(loci.bonds.length, function (i, pA, pB) {
            var _a = loci.bonds[i], aUnit = _a.aUnit, aIndex = _a.aIndex, bUnit = _a.bUnit, bIndex = _a.bIndex;
            aUnit.conformation.position(aUnit.elements[aIndex], pA);
            bUnit.conformation.position(bUnit.elements[bIndex], pB);
        }, boundingSphere);
    }
    Bond.getBoundingSphere = getBoundingSphere;
})(Bond || (Bond = {}));

//# sourceMappingURL=bonds.js.map

/***/ }),

/***/ "./lib/mol-model/structure/structure/unit/bonds/common.js":
/*!****************************************************************!*\
  !*** ./lib/mol-model/structure/structure/unit/bonds/common.js ***!
  \****************************************************************/
/*! exports provided: DefaultBondComputationProps, MetalsSet, getElementIdx, getElementPairThreshold, getElementThreshold, isHydrogen */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DefaultBondComputationProps", function() { return DefaultBondComputationProps; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MetalsSet", function() { return MetalsSet; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getElementIdx", function() { return getElementIdx; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getElementPairThreshold", function() { return getElementPairThreshold; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getElementThreshold", function() { return getElementThreshold; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isHydrogen", function() { return isHydrogen; });
/**
 * Copyright (c) 2017-2020 Mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author David Sehnal <david.sehnal@gmail.com>
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */
var DefaultBondComputationProps = {
    forceCompute: false,
    noCompute: false
};
// H,D,T are all mapped to H
var __ElementIndex = { 'H': 0, 'h': 0, 'D': 0, 'd': 0, 'T': 0, 't': 0, 'He': 2, 'HE': 2, 'he': 2, 'Li': 3, 'LI': 3, 'li': 3, 'Be': 4, 'BE': 4, 'be': 4, 'B': 5, 'b': 5, 'C': 6, 'c': 6, 'N': 7, 'n': 7, 'O': 8, 'o': 8, 'F': 9, 'f': 9, 'Ne': 10, 'NE': 10, 'ne': 10, 'Na': 11, 'NA': 11, 'na': 11, 'Mg': 12, 'MG': 12, 'mg': 12, 'Al': 13, 'AL': 13, 'al': 13, 'Si': 14, 'SI': 14, 'si': 14, 'P': 15, 'p': 15, 'S': 16, 's': 16, 'Cl': 17, 'CL': 17, 'cl': 17, 'Ar': 18, 'AR': 18, 'ar': 18, 'K': 19, 'k': 19, 'Ca': 20, 'CA': 20, 'ca': 20, 'Sc': 21, 'SC': 21, 'sc': 21, 'Ti': 22, 'TI': 22, 'ti': 22, 'V': 23, 'v': 23, 'Cr': 24, 'CR': 24, 'cr': 24, 'Mn': 25, 'MN': 25, 'mn': 25, 'Fe': 26, 'FE': 26, 'fe': 26, 'Co': 27, 'CO': 27, 'co': 27, 'Ni': 28, 'NI': 28, 'ni': 28, 'Cu': 29, 'CU': 29, 'cu': 29, 'Zn': 30, 'ZN': 30, 'zn': 30, 'Ga': 31, 'GA': 31, 'ga': 31, 'Ge': 32, 'GE': 32, 'ge': 32, 'As': 33, 'AS': 33, 'as': 33, 'Se': 34, 'SE': 34, 'se': 34, 'Br': 35, 'BR': 35, 'br': 35, 'Kr': 36, 'KR': 36, 'kr': 36, 'Rb': 37, 'RB': 37, 'rb': 37, 'Sr': 38, 'SR': 38, 'sr': 38, 'Y': 39, 'y': 39, 'Zr': 40, 'ZR': 40, 'zr': 40, 'Nb': 41, 'NB': 41, 'nb': 41, 'Mo': 42, 'MO': 42, 'mo': 42, 'Tc': 43, 'TC': 43, 'tc': 43, 'Ru': 44, 'RU': 44, 'ru': 44, 'Rh': 45, 'RH': 45, 'rh': 45, 'Pd': 46, 'PD': 46, 'pd': 46, 'Ag': 47, 'AG': 47, 'ag': 47, 'Cd': 48, 'CD': 48, 'cd': 48, 'In': 49, 'IN': 49, 'in': 49, 'Sn': 50, 'SN': 50, 'sn': 50, 'Sb': 51, 'SB': 51, 'sb': 51, 'Te': 52, 'TE': 52, 'te': 52, 'I': 53, 'i': 53, 'Xe': 54, 'XE': 54, 'xe': 54, 'Cs': 55, 'CS': 55, 'cs': 55, 'Ba': 56, 'BA': 56, 'ba': 56, 'La': 57, 'LA': 57, 'la': 57, 'Ce': 58, 'CE': 58, 'ce': 58, 'Pr': 59, 'PR': 59, 'pr': 59, 'Nd': 60, 'ND': 60, 'nd': 60, 'Pm': 61, 'PM': 61, 'pm': 61, 'Sm': 62, 'SM': 62, 'sm': 62, 'Eu': 63, 'EU': 63, 'eu': 63, 'Gd': 64, 'GD': 64, 'gd': 64, 'Tb': 65, 'TB': 65, 'tb': 65, 'Dy': 66, 'DY': 66, 'dy': 66, 'Ho': 67, 'HO': 67, 'ho': 67, 'Er': 68, 'ER': 68, 'er': 68, 'Tm': 69, 'TM': 69, 'tm': 69, 'Yb': 70, 'YB': 70, 'yb': 70, 'Lu': 71, 'LU': 71, 'lu': 71, 'Hf': 72, 'HF': 72, 'hf': 72, 'Ta': 73, 'TA': 73, 'ta': 73, 'W': 74, 'w': 74, 'Re': 75, 'RE': 75, 're': 75, 'Os': 76, 'OS': 76, 'os': 76, 'Ir': 77, 'IR': 77, 'ir': 77, 'Pt': 78, 'PT': 78, 'pt': 78, 'Au': 79, 'AU': 79, 'au': 79, 'Hg': 80, 'HG': 80, 'hg': 80, 'Tl': 81, 'TL': 81, 'tl': 81, 'Pb': 82, 'PB': 82, 'pb': 82, 'Bi': 83, 'BI': 83, 'bi': 83, 'Po': 84, 'PO': 84, 'po': 84, 'At': 85, 'AT': 85, 'at': 85, 'Rn': 86, 'RN': 86, 'rn': 86, 'Fr': 87, 'FR': 87, 'fr': 87, 'Ra': 88, 'RA': 88, 'ra': 88, 'Ac': 89, 'AC': 89, 'ac': 89, 'Th': 90, 'TH': 90, 'th': 90, 'Pa': 91, 'PA': 91, 'pa': 91, 'U': 92, 'u': 92, 'Np': 93, 'NP': 93, 'np': 93, 'Pu': 94, 'PU': 94, 'pu': 94, 'Am': 95, 'AM': 95, 'am': 95, 'Cm': 96, 'CM': 96, 'cm': 96, 'Bk': 97, 'BK': 97, 'bk': 97, 'Cf': 98, 'CF': 98, 'cf': 98, 'Es': 99, 'ES': 99, 'es': 99, 'Fm': 100, 'FM': 100, 'fm': 100, 'Md': 101, 'MD': 101, 'md': 101, 'No': 102, 'NO': 102, 'no': 102, 'Lr': 103, 'LR': 103, 'lr': 103, 'Rf': 104, 'RF': 104, 'rf': 104, 'Db': 105, 'DB': 105, 'db': 105, 'Sg': 106, 'SG': 106, 'sg': 106, 'Bh': 107, 'BH': 107, 'bh': 107, 'Hs': 108, 'HS': 108, 'hs': 108, 'Mt': 109, 'MT': 109, 'mt': 109 };
// Increased P (15) threshold from 1.9 to 2.0 (e.g. for G16 in 1O08)
var __ElementBondThresholds = { 0: 1.42, 1: 1.42, 3: 2.7, 4: 2.7, 6: 1.75, 7: 1.6, 8: 1.52, 11: 2.7, 12: 2.7, 13: 2.7, 14: 1.9, 15: 2.0, 16: 1.9, 17: 1.8, 19: 2.7, 20: 2.7, 21: 2.7, 22: 2.7, 23: 2.7, 24: 2.7, 25: 2.7, 26: 2.7, 27: 2.7, 28: 2.7, 29: 2.7, 30: 2.7, 31: 2.7, 33: 2.68, 37: 2.7, 38: 2.7, 39: 2.7, 40: 2.7, 41: 2.7, 42: 2.7, 43: 2.7, 44: 2.7, 45: 2.7, 46: 2.7, 47: 2.7, 48: 2.7, 49: 2.7, 50: 2.7, 55: 2.7, 56: 2.7, 57: 2.7, 58: 2.7, 59: 2.7, 60: 2.7, 61: 2.7, 62: 2.7, 63: 2.7, 64: 2.7, 65: 2.7, 66: 2.7, 67: 2.7, 68: 2.7, 69: 2.7, 70: 2.7, 71: 2.7, 72: 2.7, 73: 2.7, 74: 2.7, 75: 2.7, 76: 2.7, 77: 2.7, 78: 2.7, 79: 2.7, 80: 2.7, 81: 2.7, 82: 2.7, 83: 2.7, 87: 2.7, 88: 2.7, 89: 2.7, 90: 2.7, 91: 2.7, 92: 2.7, 93: 2.7, 94: 2.7, 95: 2.7, 96: 2.7, 97: 2.7, 98: 2.7, 99: 2.7, 100: 2.7, 101: 2.7, 102: 2.7, 103: 2.7, 104: 2.7, 105: 2.7, 106: 2.7, 107: 2.7, 108: 2.7, 109: 2.88 };
/**
 * Increased N-N (112) threshold from 1.55 to 1.6 (e.g. for 0QH in 1BMA)
 *
 * More experimentally observed bond length here (https://cccbdb.nist.gov/expbondlengths1x.asp)
 *
 * H-H (https://cccbdb.nist.gov/expbondlengths2x.asp?descript=rHH)
 * - 0.741
 *
 * Changed C-H (27) to 1.2
 * C-H (https://cccbdb.nist.gov/expbondlengths2x.asp?descript=rCH)
 * - Average    1.091 (+/- 0.017)
 * - Min        0.931
 * - Max        1.140
 *
 * Changed N-H (35) to 1.15
 * N-H (https://cccbdb.nist.gov/expbondlengths2x.asp?descript=rNH)
 * - Average    1.009 (+/- 0.043)
 * - Min        0.836
 * - Max        1.090
 *
 * Changed O-H (44) to 1.1
 * O-H (https://cccbdb.nist.gov/expbondlengths2x.asp?descript=rOH)
 * - Average    0.967 (+/- 0.022)
 * - Min        0.912
 * - Max        1.033
 *
 * Added P-H (135) as 1.47
 * P-H (https://cccbdb.nist.gov/expbondlengths2x.asp?descript=rPH)
 * - Average    1.423 ((+/- 0.007)
 * - Min        0.912
 * - Max        1.033
 *
 * Added S-H (152) as 1.45
 * S-H (https://cccbdb.nist.gov/expbondlengths2x.asp?descript=rSH)
 * - Average    1.345 (+/- 0.020)
 * - Min        1.322
 * - Max        1.400
 *
 * Added Si-Si (420) as 2.37
 * (https://cccbdb.nist.gov/expbondlengths2x.asp?descript=rSiSi)
 */
var __ElementPairThresholds = { 0: 0.8, 20: 1.31, 27: 1.2, 35: 1.15, 44: 1.1, 54: 1, 60: 1.84, 72: 1.88, 84: 1.75, 85: 1.56, 86: 1.76, 98: 1.6, 99: 1.68, 100: 1.63, 112: 1.6, 113: 1.59, 114: 1.36, 129: 1.45, 135: 1.47, 144: 1.6, 152: 1.45, 170: 1.4, 180: 1.55, 202: 2.4, 222: 2.24, 224: 1.91, 225: 1.98, 243: 2.02, 269: 2, 293: 1.9, 420: 2.37, 480: 2.3, 512: 2.3, 544: 2.3, 612: 2.1, 629: 1.54, 665: 1, 813: 2.6, 854: 2.27, 894: 1.93, 896: 2.1, 937: 2.05, 938: 2.06, 981: 1.62, 1258: 2.68, 1309: 2.33, 1484: 1, 1763: 2.14, 1823: 2.48, 1882: 2.1, 1944: 1.72, 2380: 2.34, 3367: 2.44, 3733: 2.11, 3819: 2.6, 3821: 2.36, 4736: 2.75, 5724: 2.73, 5959: 2.63, 6519: 2.84, 6750: 2.87, 8991: 2.81 };
var __DefaultBondingRadius = 2.001;
var MetalsSet = (function () {
    var metals = ['LI', 'NA', 'K', 'RB', 'CS', 'FR', 'BE', 'MG', 'CA', 'SR', 'BA', 'RA', 'AL', 'GA', 'IN', 'SN', 'TL', 'PB', 'BI', 'SC', 'TI', 'V', 'CR', 'MN', 'FE', 'CO', 'NI', 'CU', 'ZN', 'Y', 'ZR', 'NB', 'MO', 'TC', 'RU', 'RH', 'PD', 'AG', 'CD', 'LA', 'HF', 'TA', 'W', 'RE', 'OS', 'IR', 'PT', 'AU', 'HG', 'AC', 'RF', 'DB', 'SG', 'BH', 'HS', 'MT', 'CE', 'PR', 'ND', 'PM', 'SM', 'EU', 'GD', 'TB', 'DY', 'HO', 'ER', 'TM', 'YB', 'LU', 'TH', 'PA', 'U', 'NP', 'PU', 'AM', 'CM', 'BK', 'CF', 'ES', 'FM', 'MD', 'NO', 'LR'];
    var set = new Set();
    for (var _i = 0, metals_1 = metals; _i < metals_1.length; _i++) {
        var m = metals_1[_i];
        set.add(__ElementIndex[m]);
    }
    return set;
})();
function pair(a, b) {
    if (a < b)
        return (a + b) * (a + b + 1) / 2 + b;
    else
        return (a + b) * (a + b + 1) / 2 + a;
}
function getElementIdx(e) {
    var i = __ElementIndex[e];
    if (i === void 0)
        return -1;
    return i;
}
function getElementPairThreshold(i, j) {
    if (i < 0 || j < 0)
        return -1;
    var r = __ElementPairThresholds[pair(i, j)];
    if (r === void 0)
        return -1;
    return r;
}
function getElementThreshold(i) {
    if (i < 0)
        return __DefaultBondingRadius;
    var r = __ElementBondThresholds[i];
    if (r === void 0)
        return __DefaultBondingRadius;
    return r;
}
var H_ID = __ElementIndex['H'];
function isHydrogen(i) {
    return i === H_ID;
}
//# sourceMappingURL=common.js.map

/***/ }),

/***/ "./lib/mol-model/structure/structure/unit/bonds/data.js":
/*!**************************************************************!*\
  !*** ./lib/mol-model/structure/structure/unit/bonds/data.js ***!
  \**************************************************************/
/*! exports provided: IntraUnitBonds, InterUnitBonds */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "IntraUnitBonds", function() { return IntraUnitBonds; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "InterUnitBonds", function() { return InterUnitBonds; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _mol_math_graph__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../../../../mol-math/graph */ "./lib/mol-math/graph.js");
/* harmony import */ var _unit__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../unit */ "./lib/mol-model/structure/structure/unit.js");
/* harmony import */ var _mol_math_graph_inter_unit_graph__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../../../../mol-math/graph/inter-unit-graph */ "./lib/mol-math/graph/inter-unit-graph.js");
/**
 * Copyright (c) 2017-2020 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author David Sehnal <david.sehnal@gmail.com>
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */




var IntraUnitBonds;
(function (IntraUnitBonds) {
    IntraUnitBonds.Empty = _mol_math_graph__WEBPACK_IMPORTED_MODULE_1__["IntAdjacencyGraph"].create([], [], [], 0, { flags: [], order: [] });
})(IntraUnitBonds || (IntraUnitBonds = {}));
var InterUnitBonds = /** @class */ (function (_super) {
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__extends"])(InterUnitBonds, _super);
    function InterUnitBonds() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /** Get inter-unit bond given a bond-location */
    InterUnitBonds.prototype.getBondFromLocation = function (l) {
        return _unit__WEBPACK_IMPORTED_MODULE_2__["default"].isAtomic(l.aUnit) && _unit__WEBPACK_IMPORTED_MODULE_2__["default"].isAtomic(l.bUnit) ? this.getEdge(l.aIndex, l.aUnit.id, l.bIndex, l.bUnit.id) : undefined;
    };
    /** Get inter-unit bond index given a bond-location */
    InterUnitBonds.prototype.getBondIndexFromLocation = function (l) {
        return _unit__WEBPACK_IMPORTED_MODULE_2__["default"].isAtomic(l.aUnit) && _unit__WEBPACK_IMPORTED_MODULE_2__["default"].isAtomic(l.bUnit) ? this.getEdgeIndex(l.aIndex, l.aUnit.id, l.bIndex, l.bUnit.id) : -1;
    };
    return InterUnitBonds;
}(_mol_math_graph_inter_unit_graph__WEBPACK_IMPORTED_MODULE_3__["InterUnitGraph"]));
(function (InterUnitBonds) {
    var UnitPairBonds = /** @class */ (function (_super) {
        Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__extends"])(UnitPairBonds, _super);
        function UnitPairBonds() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        return UnitPairBonds;
    }(_mol_math_graph_inter_unit_graph__WEBPACK_IMPORTED_MODULE_3__["InterUnitGraph"].UnitPairEdges));
    InterUnitBonds.UnitPairBonds = UnitPairBonds;
})(InterUnitBonds || (InterUnitBonds = {}));

//# sourceMappingURL=data.js.map

/***/ }),

/***/ "./lib/mol-model/structure/structure/unit/bonds/element-set-intra-bond-cache.js":
/*!**************************************************************************************!*\
  !*** ./lib/mol-model/structure/structure/unit/bonds/element-set-intra-bond-cache.js ***!
  \**************************************************************************************/
/*! exports provided: ElementSetIntraBondCache */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ElementSetIntraBondCache", function() { return ElementSetIntraBondCache; });
/* harmony import */ var _mol_data_int__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../../../../mol-data/int */ "./lib/mol-data/int.js");
/**
 * Copyright (c) 2020 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author David Sehnal <david.sehnal@gmail.com>
 */

var ElementSetIntraBondCache = /** @class */ (function () {
    function ElementSetIntraBondCache() {
        this.data = new Map();
    }
    ElementSetIntraBondCache.prototype.get = function (xs) {
        var hash = _mol_data_int__WEBPACK_IMPORTED_MODULE_0__["SortedArray"].hashCode(xs);
        if (!this.data.has(hash))
            return void 0;
        for (var _i = 0, _a = this.data.get(hash); _i < _a.length; _i++) {
            var _b = _a[_i], s = _b[0], b = _b[1];
            if (_mol_data_int__WEBPACK_IMPORTED_MODULE_0__["SortedArray"].areEqual(xs, s))
                return b;
        }
    };
    ElementSetIntraBondCache.prototype.set = function (xs, bonds) {
        var hash = _mol_data_int__WEBPACK_IMPORTED_MODULE_0__["SortedArray"].hashCode(xs);
        if (this.data.has(hash)) {
            var es = this.data.get(hash);
            for (var _i = 0, es_1 = es; _i < es_1.length; _i++) {
                var e = es_1[_i];
                if (_mol_data_int__WEBPACK_IMPORTED_MODULE_0__["SortedArray"].areEqual(xs, e[0])) {
                    e[1] = bonds;
                    return;
                }
            }
            es.push([xs, bonds]);
        }
        else {
            this.data.set(hash, [[xs, bonds]]);
        }
    };
    ElementSetIntraBondCache.get = function (model) {
        if (!model._dynamicPropertyData.ElementSetIntraBondCache) {
            model._dynamicPropertyData.ElementSetIntraBondCache = new ElementSetIntraBondCache();
        }
        return model._dynamicPropertyData.ElementSetIntraBondCache;
    };
    return ElementSetIntraBondCache;
}());

//# sourceMappingURL=element-set-intra-bond-cache.js.map

/***/ }),

/***/ "./lib/mol-model/structure/structure/unit/bonds/inter-compute.js":
/*!***********************************************************************!*\
  !*** ./lib/mol-model/structure/structure/unit/bonds/inter-compute.js ***!
  \***********************************************************************/
/*! exports provided: computeInterUnitBonds */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "computeInterUnitBonds", function() { return computeInterUnitBonds; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _structure__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../structure */ "./lib/mol-model/structure/structure/structure.js");
/* harmony import */ var _unit__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../unit */ "./lib/mol-model/structure/structure/unit.js");
/* harmony import */ var _common__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./common */ "./lib/mol-model/structure/structure/unit/bonds/common.js");
/* harmony import */ var _data__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./data */ "./lib/mol-model/structure/structure/unit/bonds/data.js");
/* harmony import */ var _mol_data_int__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../../../../mol-data/int */ "./lib/mol-data/int.js");
/* harmony import */ var _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../../../../../mol-math/linear-algebra */ "./lib/mol-math/linear-algebra.js");
/* harmony import */ var _model_properties_atomic_bonds__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../../../model/properties/atomic/bonds */ "./lib/mol-model/structure/model/properties/atomic/bonds.js");
/* harmony import */ var _mol_model_formats_structure_property_bonds_index_pair__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ../../../../../mol-model-formats/structure/property/bonds/index-pair */ "./lib/mol-model-formats/structure/property/bonds/index-pair.js");
/* harmony import */ var _mol_math_graph_inter_unit_graph__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ../../../../../mol-math/graph/inter-unit-graph */ "./lib/mol-math/graph/inter-unit-graph.js");
/* harmony import */ var _mol_model_formats_structure_property_bonds_struct_conn__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ../../../../../mol-model-formats/structure/property/bonds/struct_conn */ "./lib/mol-model-formats/structure/property/bonds/struct_conn.js");
/* harmony import */ var _mol_math_linear_algebra_3d_common__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ../../../../../mol-math/linear-algebra/3d/common */ "./lib/mol-math/linear-algebra/3d/common.js");
/**
 * Copyright (c) 2017-2020 Mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author David Sehnal <david.sehnal@gmail.com>
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */












var MAX_RADIUS = 4;
var tmpDistVecA = Object(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_6__["Vec3"])();
var tmpDistVecB = Object(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_6__["Vec3"])();
function getDistance(unitA, indexA, unitB, indexB) {
    unitA.conformation.position(indexA, tmpDistVecA);
    unitB.conformation.position(indexB, tmpDistVecB);
    return _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_6__["Vec3"].distance(tmpDistVecA, tmpDistVecB);
}
var _imageTransform = Object(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_6__["Mat4"])();
var _imageA = Object(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_6__["Vec3"])();
function findPairBonds(unitA, unitB, props, builder) {
    var atomsA = unitA.elements, residueIndexA = unitA.residueIndex;
    var _a = unitA.model.atomicConformation, xA = _a.x, yA = _a.y, zA = _a.z;
    var atomsB = unitB.elements, residueIndexB = unitB.residueIndex;
    var atomCount = unitA.elements.length;
    var _b = unitA.model.atomicHierarchy.atoms, type_symbolA = _b.type_symbol, label_alt_idA = _b.label_alt_id, label_atom_idA = _b.label_atom_id, label_comp_idA = _b.label_comp_id;
    var _c = unitB.model.atomicHierarchy.atoms, type_symbolB = _c.type_symbol, label_alt_idB = _c.label_alt_id, label_atom_idB = _c.label_atom_id, label_comp_idB = _c.label_comp_id;
    var auth_seq_idA = unitA.model.atomicHierarchy.residues.auth_seq_id;
    var auth_seq_idB = unitB.model.atomicHierarchy.residues.auth_seq_id;
    var occupancyA = unitA.model.atomicConformation.occupancy;
    var occupancyB = unitB.model.atomicConformation.occupancy;
    var hasOccupancy = occupancyA.isDefined && occupancyB.isDefined;
    var structConn = unitA.model === unitB.model && _mol_model_formats_structure_property_bonds_struct_conn__WEBPACK_IMPORTED_MODULE_10__["StructConn"].Provider.get(unitA.model);
    var indexPairs = unitA.model === unitB.model && _mol_model_formats_structure_property_bonds_index_pair__WEBPACK_IMPORTED_MODULE_8__["IndexPairBonds"].Provider.get(unitA.model);
    var structConnExhaustive = unitA.model === unitB.model && _mol_model_formats_structure_property_bonds_struct_conn__WEBPACK_IMPORTED_MODULE_10__["StructConn"].isExhaustive(unitA.model);
    // the lookup queries need to happen in the "unitB space".
    // that means _imageA = inverseOperB(operA(aI))
    var imageTransform = _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_6__["Mat4"].mul(_imageTransform, unitB.conformation.operator.inverse, unitA.conformation.operator.matrix);
    var isNotIdentity = !_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_6__["Mat4"].isIdentity(imageTransform);
    var _d = unitB.boundary.sphere, bCenter = _d.center, bRadius = _d.radius;
    var testDistanceSq = (bRadius + MAX_RADIUS) * (bRadius + MAX_RADIUS);
    builder.startUnitPair(unitA.id, unitB.id);
    for (var _aI = 0; _aI < atomCount; _aI++) {
        var aI = atomsA[_aI];
        _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_6__["Vec3"].set(_imageA, xA[aI], yA[aI], zA[aI]);
        if (isNotIdentity)
            _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_6__["Vec3"].transformMat4(_imageA, _imageA, imageTransform);
        if (_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_6__["Vec3"].squaredDistance(_imageA, bCenter) > testDistanceSq)
            continue;
        if (!props.forceCompute && indexPairs) {
            var _e = indexPairs.edgeProps, order = _e.order, distance = _e.distance, flag = _e.flag;
            for (var i = indexPairs.offset[aI], il = indexPairs.offset[aI + 1]; i < il; ++i) {
                var bI = indexPairs.b[i];
                var _bI = _mol_data_int__WEBPACK_IMPORTED_MODULE_5__["SortedArray"].indexOf(unitB.elements, bI);
                if (_bI < 0)
                    continue;
                if (type_symbolA.value(aI) === 'H' && type_symbolB.value(bI) === 'H')
                    continue;
                var d = distance[i];
                // only allow inter-unit index-pair bonds when a distance is given
                if (d !== -1 && Object(_mol_math_linear_algebra_3d_common__WEBPACK_IMPORTED_MODULE_11__["equalEps"])(getDistance(unitA, aI, unitB, bI), d, 0.5)) {
                    builder.add(_aI, _bI, { order: order[i], flag: flag[i] });
                }
            }
            continue; // assume `indexPairs` supplies all bonds
        }
        var structConnEntries = props.forceCompute ? void 0 : structConn && structConn.byAtomIndex.get(aI);
        if (structConnEntries && structConnEntries.length) {
            var added = false;
            for (var _i = 0, structConnEntries_1 = structConnEntries; _i < structConnEntries_1.length; _i++) {
                var se = structConnEntries_1[_i];
                var partnerA = se.partnerA, partnerB = se.partnerB;
                var p = partnerA.atomIndex === aI ? partnerB : partnerA;
                var _bI = _mol_data_int__WEBPACK_IMPORTED_MODULE_5__["SortedArray"].indexOf(unitB.elements, p.atomIndex);
                if (_bI < 0)
                    continue;
                // check if the bond is within MAX_RADIUS for this pair of units
                if (getDistance(unitA, aI, unitB, p.atomIndex) > MAX_RADIUS)
                    continue;
                builder.add(_aI, _bI, { order: se.order, flag: se.flags });
                added = true;
            }
            // assume, for an atom, that if any inter unit bond is given
            // all are given and thus we don't need to compute any other
            if (added)
                continue;
        }
        if (structConnExhaustive)
            continue;
        var occA = occupancyA.value(aI);
        var lookup3d = unitB.lookup3d;
        var _f = lookup3d.find(_imageA[0], _imageA[1], _imageA[2], MAX_RADIUS), indices = _f.indices, count = _f.count, squaredDistances = _f.squaredDistances;
        if (count === 0)
            continue;
        var aeI = Object(_common__WEBPACK_IMPORTED_MODULE_3__["getElementIdx"])(type_symbolA.value(aI));
        var isHa = Object(_common__WEBPACK_IMPORTED_MODULE_3__["isHydrogen"])(aeI);
        var thresholdA = Object(_common__WEBPACK_IMPORTED_MODULE_3__["getElementThreshold"])(aeI);
        var altA = label_alt_idA.value(aI);
        var metalA = _common__WEBPACK_IMPORTED_MODULE_3__["MetalsSet"].has(aeI);
        var atomIdA = label_atom_idA.value(aI);
        var compIdA = label_comp_idA.value(residueIndexA[aI]);
        for (var ni = 0; ni < count; ni++) {
            var _bI = indices[ni];
            var bI = atomsB[_bI];
            var altB = label_alt_idB.value(bI);
            if (altA && altB && altA !== altB)
                continue;
            // Do not include bonds between images of the same residue with partial occupancy.
            // TODO: is this condition good enough?
            // - It works for cases like 3WQJ (label_asym_id: I) which have partial occupancy.
            // - Does NOT work for cases like 1RB8 (DC 7) with full occupancy.
            if (hasOccupancy && occupancyB.value(bI) < 1 && occA < 1) {
                if (auth_seq_idA.value(aI) === auth_seq_idB.value(bI)) {
                    continue;
                }
            }
            var beI = Object(_common__WEBPACK_IMPORTED_MODULE_3__["getElementIdx"])(type_symbolB.value(bI));
            var isHb = Object(_common__WEBPACK_IMPORTED_MODULE_3__["isHydrogen"])(beI);
            if (isHa && isHb)
                continue;
            var isMetal = (metalA || _common__WEBPACK_IMPORTED_MODULE_3__["MetalsSet"].has(beI)) && !(isHa || isHb);
            var dist = Math.sqrt(squaredDistances[ni]);
            if (dist === 0)
                continue;
            var thresholdAB = Object(_common__WEBPACK_IMPORTED_MODULE_3__["getElementPairThreshold"])(aeI, beI);
            var pairingThreshold = thresholdAB > 0
                ? thresholdAB
                : beI < 0
                    ? thresholdA
                    : (thresholdA + Object(_common__WEBPACK_IMPORTED_MODULE_3__["getElementThreshold"])(beI)) / 2; // not sure if avg or min but max is too big
            if (dist <= pairingThreshold) {
                var atomIdB = label_atom_idB.value(bI);
                var compIdB = label_comp_idB.value(residueIndexB[bI]);
                builder.add(_aI, _bI, {
                    order: Object(_model_properties_atomic_bonds__WEBPACK_IMPORTED_MODULE_7__["getInterBondOrderFromTable"])(compIdA, compIdB, atomIdA, atomIdB),
                    flag: (isMetal ? 2 /* MetallicCoordination */ : 1 /* Covalent */) | 32 /* Computed */
                });
            }
        }
    }
    builder.finishUnitPair();
}
function findBonds(structure, props) {
    var builder = new _mol_math_graph_inter_unit_graph__WEBPACK_IMPORTED_MODULE_9__["InterUnitGraph"].Builder();
    if (props.noCompute) {
        // TODO add function that only adds bonds defined in structConn and avoids using
        //      structure.lookup and unit.lookup (expensive for large structure and not
        //      needed for archival files or files with an MD topology)
        return new _data__WEBPACK_IMPORTED_MODULE_4__["InterUnitBonds"](builder.getMap());
    }
    var indexPairs = structure.models.length === 1 && _mol_model_formats_structure_property_bonds_index_pair__WEBPACK_IMPORTED_MODULE_8__["IndexPairBonds"].Provider.get(structure.model);
    if (indexPairs) {
        var distance = indexPairs.edgeProps.distance;
        var hasDistance = false;
        for (var i = 0, il = distance.length; i < il; ++i) {
            if (distance[i] !== -1) {
                hasDistance = true;
                break;
            }
        }
        if (!hasDistance)
            return new _data__WEBPACK_IMPORTED_MODULE_4__["InterUnitBonds"](builder.getMap());
    }
    _structure__WEBPACK_IMPORTED_MODULE_1__["default"].eachUnitPair(structure, function (unitA, unitB) {
        findPairBonds(unitA, unitB, props, builder);
    }, {
        maxRadius: MAX_RADIUS,
        validUnit: function (unit) { return _unit__WEBPACK_IMPORTED_MODULE_2__["default"].isAtomic(unit); },
        validUnitPair: function (unitA, unitB) { return props.validUnitPair(structure, unitA, unitB); }
    });
    return new _data__WEBPACK_IMPORTED_MODULE_4__["InterUnitBonds"](builder.getMap());
}
function computeInterUnitBonds(structure, props) {
    return findBonds(structure, Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, _common__WEBPACK_IMPORTED_MODULE_3__["DefaultBondComputationProps"]), { validUnitPair: (props && props.validUnitPair) || (function (s, a, b) {
            var mtA = a.model.atomicHierarchy.derived.residue.moleculeType;
            var mtB = b.model.atomicHierarchy.derived.residue.moleculeType;
            var notWater = ((!_unit__WEBPACK_IMPORTED_MODULE_2__["default"].isAtomic(a) || mtA[a.residueIndex[a.elements[0]]] !== 2 /* Water */) &&
                (!_unit__WEBPACK_IMPORTED_MODULE_2__["default"].isAtomic(b) || mtB[b.residueIndex[b.elements[0]]] !== 2 /* Water */));
            return _structure__WEBPACK_IMPORTED_MODULE_1__["default"].validUnitPair(s, a, b) && notWater;
        }) }));
}

//# sourceMappingURL=inter-compute.js.map

/***/ }),

/***/ "./lib/mol-model/structure/structure/unit/bonds/intra-compute.js":
/*!***********************************************************************!*\
  !*** ./lib/mol-model/structure/structure/unit/bonds/intra-compute.js ***!
  \***********************************************************************/
/*! exports provided: computeIntraUnitBonds */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "computeIntraUnitBonds", function() { return computeIntraUnitBonds; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _data__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./data */ "./lib/mol-model/structure/structure/unit/bonds/data.js");
/* harmony import */ var _mol_math_graph__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../../../../mol-math/graph */ "./lib/mol-math/graph.js");
/* harmony import */ var _common__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./common */ "./lib/mol-model/structure/structure/unit/bonds/common.js");
/* harmony import */ var _mol_data_int__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../../../../mol-data/int */ "./lib/mol-data/int.js");
/* harmony import */ var _model_properties_atomic_bonds__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../../model/properties/atomic/bonds */ "./lib/mol-model/structure/model/properties/atomic/bonds.js");
/* harmony import */ var _mol_model_formats_structure_property_bonds_index_pair__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../../../../../mol-model-formats/structure/property/bonds/index-pair */ "./lib/mol-model-formats/structure/property/bonds/index-pair.js");
/* harmony import */ var _mol_model_formats_structure_property_bonds_chem_comp__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../../../../../mol-model-formats/structure/property/bonds/chem_comp */ "./lib/mol-model-formats/structure/property/bonds/chem_comp.js");
/* harmony import */ var _mol_model_formats_structure_property_bonds_struct_conn__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ../../../../../mol-model-formats/structure/property/bonds/struct_conn */ "./lib/mol-model-formats/structure/property/bonds/struct_conn.js");
/* harmony import */ var _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ../../../../../mol-math/linear-algebra */ "./lib/mol-math/linear-algebra.js");
/* harmony import */ var _mol_math_linear_algebra_3d_common__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ../../../../../mol-math/linear-algebra/3d/common */ "./lib/mol-math/linear-algebra/3d/common.js");
/**
 * Copyright (c) 2017-2020 Mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author David Sehnal <david.sehnal@gmail.com>
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */











function getGraph(atomA, atomB, _order, _flags, atomCount, canRemap) {
    var builder = new _mol_math_graph__WEBPACK_IMPORTED_MODULE_2__["IntAdjacencyGraph"].EdgeBuilder(atomCount, atomA, atomB);
    var flags = new Uint16Array(builder.slotCount);
    var order = new Int8Array(builder.slotCount);
    for (var i = 0, _i = builder.edgeCount; i < _i; i++) {
        builder.addNextEdge();
        builder.assignProperty(flags, _flags[i]);
        builder.assignProperty(order, _order[i]);
    }
    return builder.createGraph({ flags: flags, order: order }, { canRemap: canRemap });
}
var tmpDistVecA = Object(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_9__["Vec3"])();
var tmpDistVecB = Object(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_9__["Vec3"])();
function getDistance(unit, indexA, indexB) {
    unit.conformation.position(indexA, tmpDistVecA);
    unit.conformation.position(indexB, tmpDistVecB);
    return _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_9__["Vec3"].distance(tmpDistVecA, tmpDistVecB);
}
var __structConnAdded = new Set();
function findIndexPairBonds(unit) {
    var indexPairs = _mol_model_formats_structure_property_bonds_index_pair__WEBPACK_IMPORTED_MODULE_6__["IndexPairBonds"].Provider.get(unit.model);
    var atoms = unit.elements;
    var type_symbol = unit.model.atomicHierarchy.atoms.type_symbol;
    var atomCount = unit.elements.length;
    var edgeProps = indexPairs.edgeProps;
    var atomA = [];
    var atomB = [];
    var flags = [];
    var order = [];
    for (var _aI = 0; _aI < atomCount; _aI++) {
        var aI = atoms[_aI];
        var isHa = type_symbol.value(aI) === 'H';
        for (var i = indexPairs.offset[aI], il = indexPairs.offset[aI + 1]; i < il; ++i) {
            var bI = indexPairs.b[i];
            if (aI >= bI)
                continue;
            var _bI = _mol_data_int__WEBPACK_IMPORTED_MODULE_4__["SortedArray"].indexOf(unit.elements, bI);
            if (_bI < 0)
                continue;
            if (isHa && type_symbol.value(bI) === 'H')
                continue;
            var d = edgeProps.distance[i];
            if (d === -1 || d === void 0 || Object(_mol_math_linear_algebra_3d_common__WEBPACK_IMPORTED_MODULE_10__["equalEps"])(getDistance(unit, aI, bI), d, 0.5)) {
                atomA[atomA.length] = _aI;
                atomB[atomB.length] = _bI;
                order[order.length] = edgeProps.order[i];
                flags[flags.length] = edgeProps.flag[i];
            }
        }
    }
    return getGraph(atomA, atomB, order, flags, atomCount, false);
}
function findBonds(unit, props) {
    var MAX_RADIUS = 4;
    var _a = unit.model.atomicConformation, x = _a.x, y = _a.y, z = _a.z;
    var atomCount = unit.elements.length;
    var atoms = unit.elements, residueIndex = unit.residueIndex, chainIndex = unit.chainIndex;
    var _b = unit.model.atomicHierarchy.atoms, type_symbol = _b.type_symbol, label_atom_id = _b.label_atom_id, label_alt_id = _b.label_alt_id, label_comp_id = _b.label_comp_id;
    var label_seq_id = unit.model.atomicHierarchy.residues.label_seq_id;
    var index = unit.model.atomicHierarchy.index;
    var byEntityKey = unit.model.sequence.byEntityKey;
    var query3d = unit.lookup3d;
    var structConn = _mol_model_formats_structure_property_bonds_struct_conn__WEBPACK_IMPORTED_MODULE_8__["StructConn"].Provider.get(unit.model);
    var component = _mol_model_formats_structure_property_bonds_chem_comp__WEBPACK_IMPORTED_MODULE_7__["ComponentBond"].Provider.get(unit.model);
    var structConnExhaustive = _mol_model_formats_structure_property_bonds_struct_conn__WEBPACK_IMPORTED_MODULE_8__["StructConn"].isExhaustive(unit.model);
    var atomA = [];
    var atomB = [];
    var flags = [];
    var order = [];
    var lastResidue = -1;
    var componentMap = void 0;
    var isWatery = true, isDictionaryBased = true, isSequenced = true;
    var structConnAdded = __structConnAdded;
    for (var _aI = 0; _aI < atomCount; _aI++) {
        var aI = atoms[_aI];
        var elemA = type_symbol.value(aI);
        if (isWatery && (elemA !== 'H' || elemA !== 'O'))
            isWatery = false;
        var structConnEntries = props.forceCompute ? void 0 : structConn && structConn.byAtomIndex.get(aI);
        var hasStructConn = false;
        if (structConnEntries) {
            for (var _c = 0, structConnEntries_1 = structConnEntries; _c < structConnEntries_1.length; _c++) {
                var se = structConnEntries_1[_c];
                var partnerA = se.partnerA, partnerB = se.partnerB;
                // symmetry must be the same for intra-unit bonds
                if (partnerA.symmetry !== partnerB.symmetry)
                    continue;
                var p = partnerA.atomIndex === aI ? partnerB : partnerA;
                var _bI = _mol_data_int__WEBPACK_IMPORTED_MODULE_4__["SortedArray"].indexOf(unit.elements, p.atomIndex);
                if (_bI < 0)
                    continue;
                atomA[atomA.length] = _aI;
                atomB[atomB.length] = _bI;
                flags[flags.length] = se.flags;
                order[order.length] = se.order;
                if (!hasStructConn)
                    structConnAdded.clear();
                hasStructConn = true;
                structConnAdded.add(_bI);
            }
        }
        if (structConnExhaustive)
            continue;
        var raI = residueIndex[aI];
        var seqIdA = label_seq_id.value(raI);
        var compId = label_comp_id.value(aI);
        if (!props.forceCompute && raI !== lastResidue) {
            if (!!component && component.entries.has(compId)) {
                var entitySeq = byEntityKey[index.getEntityFromChain(chainIndex[aI])];
                if (entitySeq && entitySeq.sequence.microHet.has(seqIdA)) {
                    // compute for sequence positions with micro-heterogeneity
                    componentMap = void 0;
                }
                else {
                    componentMap = component.entries.get(compId).map;
                }
            }
            else {
                componentMap = void 0;
            }
        }
        lastResidue = raI;
        var aeI = Object(_common__WEBPACK_IMPORTED_MODULE_3__["getElementIdx"])(elemA);
        var atomIdA = label_atom_id.value(aI);
        var componentPairs = componentMap ? componentMap.get(atomIdA) : void 0;
        var _d = query3d.find(x[aI], y[aI], z[aI], MAX_RADIUS), indices = _d.indices, count = _d.count, squaredDistances = _d.squaredDistances;
        var isHa = Object(_common__WEBPACK_IMPORTED_MODULE_3__["isHydrogen"])(aeI);
        var thresholdA = Object(_common__WEBPACK_IMPORTED_MODULE_3__["getElementThreshold"])(aeI);
        var altA = label_alt_id.value(aI);
        var metalA = _common__WEBPACK_IMPORTED_MODULE_3__["MetalsSet"].has(aeI);
        for (var ni = 0; ni < count; ni++) {
            var _bI = indices[ni];
            if (hasStructConn && structConnAdded.has(_bI))
                continue;
            var bI = atoms[_bI];
            if (bI <= aI)
                continue;
            var altB = label_alt_id.value(bI);
            if (altA && altB && altA !== altB)
                continue;
            var beI = Object(_common__WEBPACK_IMPORTED_MODULE_3__["getElementIdx"])(type_symbol.value(bI));
            var isHb = Object(_common__WEBPACK_IMPORTED_MODULE_3__["isHydrogen"])(beI);
            if (isHa && isHb)
                continue;
            var isMetal = (metalA || _common__WEBPACK_IMPORTED_MODULE_3__["MetalsSet"].has(beI)) && !(isHa || isHb);
            var rbI = residueIndex[bI];
            // handle "component dictionary" bonds.
            if (raI === rbI && componentPairs) {
                var e = componentPairs.get(label_atom_id.value(bI));
                if (e) {
                    atomA[atomA.length] = _aI;
                    atomB[atomB.length] = _bI;
                    order[order.length] = e.order;
                    var flag = e.flags;
                    if (isMetal) {
                        if (flag | 1 /* Covalent */)
                            flag ^= 1 /* Covalent */;
                        flag |= 2 /* MetallicCoordination */;
                    }
                    flags[flags.length] = flag;
                }
                continue;
            }
            var dist = Math.sqrt(squaredDistances[ni]);
            if (dist === 0)
                continue;
            var thresholdAB = Object(_common__WEBPACK_IMPORTED_MODULE_3__["getElementPairThreshold"])(aeI, beI);
            var pairingThreshold = thresholdAB > 0
                ? thresholdAB
                : beI < 0
                    ? thresholdA
                    : (thresholdA + Object(_common__WEBPACK_IMPORTED_MODULE_3__["getElementThreshold"])(beI)) / 2; // not sure if avg or min but max is too big
            if (dist <= pairingThreshold) {
                atomA[atomA.length] = _aI;
                atomB[atomB.length] = _bI;
                order[order.length] = Object(_model_properties_atomic_bonds__WEBPACK_IMPORTED_MODULE_5__["getIntraBondOrderFromTable"])(compId, atomIdA, label_atom_id.value(bI));
                flags[flags.length] = (isMetal ? 2 /* MetallicCoordination */ : 1 /* Covalent */) | 32 /* Computed */;
                var seqIdB = label_seq_id.value(rbI);
                if (seqIdA === seqIdB)
                    isDictionaryBased = false;
                if (Math.abs(seqIdA - seqIdB) > 1)
                    isSequenced = false;
            }
        }
    }
    var canRemap = isWatery || (isDictionaryBased && isSequenced);
    return getGraph(atomA, atomB, order, flags, atomCount, canRemap);
}
function computeIntraUnitBonds(unit, props) {
    var p = Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, _common__WEBPACK_IMPORTED_MODULE_3__["DefaultBondComputationProps"]), props);
    if (p.noCompute) {
        // TODO add function that only adds bonds defined in structConn of chemCompBond
        //      and avoid using unit.lookup
        return _data__WEBPACK_IMPORTED_MODULE_1__["IntraUnitBonds"].Empty;
    }
    if (!p.forceCompute && _mol_model_formats_structure_property_bonds_index_pair__WEBPACK_IMPORTED_MODULE_6__["IndexPairBonds"].Provider.get(unit.model)) {
        return findIndexPairBonds(unit);
    }
    else {
        return findBonds(unit, p);
    }
}

//# sourceMappingURL=intra-compute.js.map

/***/ }),

/***/ "./lib/mol-model/structure/structure/unit/rings.js":
/*!*********************************************************!*\
  !*** ./lib/mol-model/structure/structure/unit/rings.js ***!
  \*********************************************************/
/*! exports provided: UnitRing, UnitRings */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "UnitRing", function() { return UnitRing; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "UnitRings", function() { return UnitRings; });
/* harmony import */ var _rings_compute__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./rings/compute */ "./lib/mol-model/structure/structure/unit/rings/compute.js");
/* harmony import */ var _mol_data_int__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../../../mol-data/int */ "./lib/mol-data/int.js");
/* harmony import */ var _model_types__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../model/types */ "./lib/mol-model/structure/model/types.js");
/* harmony import */ var _util__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../util */ "./lib/mol-model/structure/util.js");
/* harmony import */ var _mol_math_linear_algebra_matrix_principal_axes__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../../../mol-math/linear-algebra/matrix/principal-axes */ "./lib/mol-math/linear-algebra/matrix/principal-axes.js");
/* harmony import */ var _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../../../mol-math/linear-algebra */ "./lib/mol-math/linear-algebra.js");
/**
 * Copyright (c) 2018-2019 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author David Sehnal <david.sehnal@gmail.com>
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */






var UnitRings = /** @class */ (function () {
    function UnitRings(all, unit) {
        this.unit = unit;
        this.all = all;
    }
    Object.defineProperty(UnitRings.prototype, "index", {
        get: function () {
            if (this._index)
                return this._index;
            this._index = Object(_rings_compute__WEBPACK_IMPORTED_MODULE_0__["createIndex"])(this.all, this.aromaticRings);
            return this._index;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(UnitRings.prototype, "byFingerprint", {
        get: function () {
            if (this._byFingerprint)
                return this._byFingerprint;
            this._byFingerprint = createByFingerprint(this.unit, this.all);
            return this._byFingerprint;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(UnitRings.prototype, "elementRingIndices", {
        /** Maps atom index inside a Unit to ring indices (an atom can be part of more than one ring) */
        get: function () {
            return this.index.elementRingIndices;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(UnitRings.prototype, "elementAromaticRingIndices", {
        get: function () {
            return this.index.elementAromaticRingIndices;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(UnitRings.prototype, "ringComponentIndex", {
        /** Maps UnitRings.Index to index to ringComponents */
        get: function () {
            return this.index.ringComponentIndex;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(UnitRings.prototype, "ringComponents", {
        get: function () {
            return this.index.ringComponents;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(UnitRings.prototype, "aromaticRings", {
        get: function () {
            if (this._aromaticRings)
                return this._aromaticRings;
            this._aromaticRings = getAromaticRings(this.unit, this.all);
            return this._aromaticRings;
        },
        enumerable: false,
        configurable: true
    });
    return UnitRings;
}());
var UnitRing;
(function (UnitRing) {
    function fingerprint(unit, ring) {
        var elements = unit.elements;
        var type_symbol = unit.model.atomicHierarchy.atoms.type_symbol;
        var symbols = [];
        for (var i = 0, _i = ring.length; i < _i; i++)
            symbols[symbols.length] = type_symbol.value(elements[ring[i]]);
        return elementFingerprint(symbols);
    }
    UnitRing.fingerprint = fingerprint;
    function elementFingerprint(elements) {
        return Object(_rings_compute__WEBPACK_IMPORTED_MODULE_0__["getFingerprint"])(elements);
    }
    UnitRing.elementFingerprint = elementFingerprint;
    var AromaticRingElements = new Set([
        "B" /* B */, "C" /* C */, "N" /* N */, "O" /* O */,
        "SI" /* SI */, "P" /* P */, "S" /* S */,
        "GE" /* GE */, "AS" /* AS */,
        "SN" /* SN */, "SB" /* SB */,
        "BI" /* BI */
    ]);
    var AromaticRingPlanarityThreshold = 0.05;
    function isAromatic(unit, ring) {
        var elements = unit.elements, _a = unit.bonds, b = _a.b, offset = _a.offset, flags = _a.edgeProps.flags;
        var _b = unit.model.atomicHierarchy.atoms, type_symbol = _b.type_symbol, label_comp_id = _b.label_comp_id;
        // ignore Proline (can be flat because of bad geometry)
        if (label_comp_id.value(unit.elements[ring[0]]) === 'PRO')
            return false;
        var aromaticBondCount = 0;
        var hasAromaticRingElement = false;
        for (var i = 0, il = ring.length; i < il; ++i) {
            var aI = ring[i];
            if (!hasAromaticRingElement && AromaticRingElements.has(type_symbol.value(elements[aI]))) {
                hasAromaticRingElement = true;
            }
            for (var j = offset[aI], jl = offset[aI + 1]; j < jl; ++j) {
                // comes e.g. from `chem_comp_bond.pdbx_aromatic_flag`
                if (_model_types__WEBPACK_IMPORTED_MODULE_2__["BondType"].is(16 /* Aromatic */, flags[j])) {
                    if (_mol_data_int__WEBPACK_IMPORTED_MODULE_1__["SortedArray"].has(ring, b[j]))
                        aromaticBondCount += 1;
                }
            }
        }
        if (aromaticBondCount === 2 * ring.length)
            return true;
        if (!hasAromaticRingElement)
            return false;
        var ma = _mol_math_linear_algebra_matrix_principal_axes__WEBPACK_IMPORTED_MODULE_4__["PrincipalAxes"].calculateMomentsAxes(Object(_util__WEBPACK_IMPORTED_MODULE_3__["getPositions"])(unit, ring));
        return _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_5__["Vec3"].magnitude(ma.dirC) < AromaticRingPlanarityThreshold;
    }
    UnitRing.isAromatic = isAromatic;
    /** Get the alternate location of the 1st non '' alt loc atom. */
    function getAltId(unit, ring) {
        var label_alt_id = unit.model.atomicHierarchy.atoms.label_alt_id;
        var elements = unit.elements;
        for (var i = 0, il = ring.length; i < il; ++i) {
            var eI = elements[ring[i]];
            var altId = label_alt_id.value(eI);
            if (altId)
                return altId;
        }
        return '';
    }
    UnitRing.getAltId = getAltId;
})(UnitRing || (UnitRing = {}));
(function (UnitRings) {
    function create(unit) {
        var rings = Object(_rings_compute__WEBPACK_IMPORTED_MODULE_0__["computeRings"])(unit);
        return new UnitRings(rings, unit);
    }
    UnitRings.create = create;
    /** Creates a mapping ResidueIndex -> list or rings that are on that residue and have one of the specified fingerprints. */
    function byFingerprintAndResidue(rings, fingerprints) {
        var map = new Map();
        for (var fI = 0, _fI = fingerprints.length; fI < _fI; fI++) {
            var fp = fingerprints[fI];
            addSingleResidueRings(rings, fp, map);
        }
        return map;
    }
    UnitRings.byFingerprintAndResidue = byFingerprintAndResidue;
})(UnitRings || (UnitRings = {}));
function createByFingerprint(unit, rings) {
    var byFingerprint = new Map();
    var idx = 0;
    for (var rI = 0, _rI = rings.length; rI < _rI; rI++) {
        var r = rings[rI];
        var fp = UnitRing.fingerprint(unit, r);
        if (byFingerprint.has(fp))
            byFingerprint.get(fp).push(idx);
        else
            byFingerprint.set(fp, [idx]);
        idx++;
    }
    return byFingerprint;
}
function ringResidueIdx(unit, ring) {
    var elements = unit.elements;
    var residueIndex = unit.model.atomicHierarchy.residueAtomSegments.index;
    var idx = residueIndex[elements[ring[0]]];
    for (var rI = 1, _rI = ring.length; rI < _rI; rI++) {
        if (idx !== residueIndex[elements[ring[rI]]])
            return -1;
    }
    return idx;
}
function addSingleResidueRings(rings, fp, map) {
    var byFp = rings.byFingerprint.get(fp);
    if (!byFp)
        return;
    for (var rI = 0, _rI = byFp.length; rI < _rI; rI++) {
        var r = byFp[rI];
        var idx = ringResidueIdx(rings.unit, rings.all[r]);
        if (idx >= 0) {
            if (map.has(idx))
                map.get(idx).push(r);
            else
                map.set(idx, [r]);
        }
    }
}
function getAromaticRings(unit, rings) {
    var aromaticRings = [];
    for (var i = 0, il = rings.length; i < il; ++i) {
        if (UnitRing.isAromatic(unit, rings[i]))
            aromaticRings.push(i);
    }
    return aromaticRings;
}

//# sourceMappingURL=rings.js.map

/***/ }),

/***/ "./lib/mol-model/structure/structure/unit/rings/compute.js":
/*!*****************************************************************!*\
  !*** ./lib/mol-model/structure/structure/unit/rings/compute.js ***!
  \*****************************************************************/
/*! exports provided: computeRings, getFingerprint, createIndex */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "computeRings", function() { return computeRings; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getFingerprint", function() { return getFingerprint; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createIndex", function() { return createIndex; });
/* harmony import */ var _mol_data_int__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../../../../mol-data/int */ "./lib/mol-data/int.js");
/* harmony import */ var _mol_math_graph__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../../../../mol-math/graph */ "./lib/mol-math/graph.js");
/* harmony import */ var _model_types__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../../model/types */ "./lib/mol-model/structure/model/types.js");
/* harmony import */ var _mol_data_util__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../../../../mol-data/util */ "./lib/mol-data/util.js");
/* harmony import */ var _mol_util_array__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../../../../mol-util/array */ "./lib/mol-util/array.js");
/**
 * Copyright (c) 2018 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author David Sehnal <david.sehnal@gmail.com>
 */





function computeRings(unit) {
    var size = largestResidue(unit);
    var state = State(unit, size);
    var residuesIt = _mol_data_int__WEBPACK_IMPORTED_MODULE_0__["Segmentation"].transientSegments(unit.model.atomicHierarchy.residueAtomSegments, unit.elements);
    while (residuesIt.hasNext) {
        var seg = residuesIt.move();
        processResidue(state, seg.start, seg.end);
    }
    return state.rings;
}
function State(unit, capacity) {
    return {
        startVertex: 0,
        endVertex: 0,
        count: 0,
        visited: new Int32Array(capacity),
        queue: new Int32Array(capacity),
        pred: new Int32Array(capacity),
        left: new Int32Array(4 /* MaxDepth */),
        right: new Int32Array(4 /* MaxDepth */),
        color: new Int32Array(capacity),
        currentColor: 0,
        currentAltLoc: '',
        hasAltLoc: false,
        rings: [],
        currentRings: [],
        unit: unit,
        bonds: unit.bonds,
        altLoc: unit.model.atomicHierarchy.atoms.label_alt_id
    };
}
function resetState(state) {
    state.count = state.endVertex - state.startVertex;
    var visited = state.visited, pred = state.pred, color = state.color;
    for (var i = 0; i < state.count; i++) {
        visited[i] = -1;
        pred[i] = -1;
        color[i] = 0;
    }
    state.currentColor = 0;
    state.currentAltLoc = '';
    state.hasAltLoc = false;
}
function largestResidue(unit) {
    var residuesIt = _mol_data_int__WEBPACK_IMPORTED_MODULE_0__["Segmentation"].transientSegments(unit.model.atomicHierarchy.residueAtomSegments, unit.elements);
    var size = 0;
    while (residuesIt.hasNext) {
        var seg = residuesIt.move();
        size = Math.max(size, seg.end - seg.start);
    }
    return size;
}
function processResidue(state, start, end) {
    var visited = state.visited;
    state.startVertex = start;
    state.endVertex = end;
    // no two atom rings
    if (state.endVertex - state.startVertex < 3)
        return;
    state.currentRings = [];
    var elements = state.unit.elements;
    var altLocs = [];
    for (var i = state.startVertex; i < state.endVertex; i++) {
        var altLoc = state.altLoc.value(elements[i]);
        Object(_mol_util_array__WEBPACK_IMPORTED_MODULE_4__["arraySetAdd"])(altLocs, altLoc);
    }
    Object(_mol_util_array__WEBPACK_IMPORTED_MODULE_4__["arraySetRemove"])(altLocs, '');
    if (altLocs.length === 0) {
        resetState(state);
        for (var i = 0; i < state.count; i++) {
            if (visited[i] >= 0)
                continue;
            findRings(state, i);
        }
    }
    else {
        for (var aI = 0; aI < altLocs.length; aI++) {
            resetState(state);
            state.hasAltLoc = true;
            state.currentAltLoc = altLocs[aI];
            for (var i = 0; i < state.count; i++) {
                if (visited[i] >= 0)
                    continue;
                var altLoc = state.altLoc.value(elements[state.startVertex + i]);
                if (altLoc && altLoc !== state.currentAltLoc) {
                    continue;
                }
                findRings(state, i);
            }
        }
    }
    for (var i = 0, _i = state.currentRings.length; i < _i; i++) {
        state.rings.push(state.currentRings[i]);
    }
}
function addRing(state, a, b) {
    // only "monotonous" rings
    if (b < a) {
        return;
    }
    var pred = state.pred, color = state.color, left = state.left, right = state.right;
    var nc = ++state.currentColor;
    var current = a;
    for (var t = 0; t < 4 /* MaxDepth */; t++) {
        color[current] = nc;
        current = pred[current];
        if (current < 0)
            break;
    }
    var leftOffset = 0, rightOffset = 0;
    var found = false, target = 0;
    current = b;
    for (var t = 0; t < 4 /* MaxDepth */; t++) {
        if (color[current] === nc) {
            target = current;
            found = true;
            break;
        }
        right[rightOffset++] = current;
        current = pred[current];
        if (current < 0)
            break;
    }
    if (!found) {
        return;
    }
    current = a;
    for (var t = 0; t < 4 /* MaxDepth */; t++) {
        left[leftOffset++] = current;
        if (target === current)
            break;
        current = pred[current];
        if (current < 0)
            break;
    }
    var len = leftOffset + rightOffset;
    // rings must have at least three elements
    if (len < 3) {
        return;
    }
    var ring = new Int32Array(len);
    var ringOffset = 0;
    for (var t = 0; t < leftOffset; t++)
        ring[ringOffset++] = state.startVertex + left[t];
    for (var t = rightOffset - 1; t >= 0; t--)
        ring[ringOffset++] = state.startVertex + right[t];
    Object(_mol_data_util__WEBPACK_IMPORTED_MODULE_3__["sortArray"])(ring);
    if (state.hasAltLoc) {
        // we need to check if the ring was already added because alt locs are present.
        for (var rI = 0, _rI = state.currentRings.length; rI < _rI; rI++) {
            var r = state.currentRings[rI];
            if (ring[0] !== r[0])
                continue;
            if (ring.length !== r.length)
                continue;
            var areSame = true;
            for (var aI = 0, _aI = ring.length; aI < _aI; aI++) {
                if (ring[aI] !== r[aI]) {
                    areSame = false;
                    break;
                }
            }
            if (areSame) {
                return;
            }
        }
    }
    state.currentRings.push(_mol_data_int__WEBPACK_IMPORTED_MODULE_0__["SortedArray"].ofSortedArray(ring));
}
function findRings(state, from) {
    var bonds = state.bonds, startVertex = state.startVertex, endVertex = state.endVertex, visited = state.visited, queue = state.queue, pred = state.pred;
    var elements = state.unit.elements;
    var neighbor = bonds.b, bondFlags = bonds.edgeProps.flags, offset = bonds.offset;
    visited[from] = 1;
    queue[0] = from;
    var head = 0, size = 1;
    while (head < size) {
        var top_1 = queue[head++];
        var a = startVertex + top_1;
        var start = offset[a], end = offset[a + 1];
        for (var i = start; i < end; i++) {
            var b = neighbor[i];
            if (b < startVertex || b >= endVertex || !_model_types__WEBPACK_IMPORTED_MODULE_2__["BondType"].isCovalent(bondFlags[i]))
                continue;
            if (state.hasAltLoc) {
                var altLoc = state.altLoc.value(elements[b]);
                if (altLoc && state.currentAltLoc !== altLoc) {
                    continue;
                }
            }
            var other = b - startVertex;
            if (visited[other] > 0) {
                if (pred[other] !== top_1 && pred[top_1] !== other) {
                    addRing(state, top_1, other);
                }
                continue;
            }
            visited[other] = 1;
            queue[size++] = other;
            pred[other] = top_1;
        }
    }
}
function getFingerprint(elements) {
    var len = elements.length;
    var reversed = new Array(len);
    for (var i = 0; i < len; i++)
        reversed[i] = elements[len - i - 1];
    var rotNormal = getMinimalRotation(elements);
    var rotReversed = getMinimalRotation(reversed);
    var isNormalSmaller = false;
    for (var i = 0; i < len; i++) {
        var u = elements[(i + rotNormal) % len], v = reversed[(i + rotReversed) % len];
        if (u !== v) {
            isNormalSmaller = u < v;
            break;
        }
    }
    if (isNormalSmaller)
        return buildFinderprint(elements, rotNormal);
    return buildFinderprint(reversed, rotReversed);
}
function getMinimalRotation(elements) {
    // adapted from http://en.wikipedia.org/wiki/Lexicographically_minimal_string_rotation
    var len = elements.length;
    var f = new Int32Array(len * 2);
    for (var i = 0; i < f.length; i++)
        f[i] = -1;
    var u = '', v = '', k = 0;
    for (var j = 1; j < f.length; j++) {
        var i = f[j - k - 1];
        while (i !== -1) {
            u = elements[j % len];
            v = elements[(k + i + 1) % len];
            if (u === v)
                break;
            if (u < v)
                k = j - i - 1;
            i = f[i];
        }
        if (i === -1) {
            u = elements[j % len];
            v = elements[(k + i + 1) % len];
            if (u !== v) {
                if (u < v)
                    k = j;
                f[j - k] = -1;
            }
            else
                f[j - k] = i + 1;
        }
        else
            f[j - k] = i + 1;
    }
    return k;
}
function buildFinderprint(elements, offset) {
    var len = elements.length;
    var ret = [];
    var i;
    for (i = 0; i < len - 1; i++) {
        ret.push(elements[(i + offset) % len]);
        ret.push('-');
    }
    ret.push(elements[(i + offset) % len]);
    return ret.join('');
}
function createIndex(rings, aromaticRings) {
    var elementRingIndices = new Map();
    var elementAromaticRingIndices = new Map();
    // for each ring atom, assign all rings that it is present in
    for (var rI = 0, _rI = rings.length; rI < _rI; rI++) {
        var r = rings[rI];
        for (var i = 0, _i = r.length; i < _i; i++) {
            var e = r[i];
            if (elementRingIndices.has(e))
                elementRingIndices.get(e).push(rI);
            else
                elementRingIndices.set(e, [rI]);
        }
    }
    // for each ring atom, assign all aromatic rings that it is present in
    for (var aI = 0, _aI = aromaticRings.length; aI < _aI; aI++) {
        var rI = aromaticRings[aI];
        var r = rings[rI];
        for (var i = 0, _i = r.length; i < _i; i++) {
            var e = r[i];
            if (elementAromaticRingIndices.has(e))
                elementAromaticRingIndices.get(e).push(rI);
            else
                elementAromaticRingIndices.set(e, [rI]);
        }
    }
    // create a graph where vertices are rings, edge if two rings share at least one atom
    var graph = new _mol_math_graph__WEBPACK_IMPORTED_MODULE_1__["IntAdjacencyGraph"].UniqueEdgeBuilder(rings.length);
    for (var rI = 0, _rI = rings.length; rI < _rI; rI++) {
        var r = rings[rI];
        for (var i = 0, _i = r.length; i < _i; i++) {
            var e = r[i];
            var containedRings = elementRingIndices.get(e);
            if (containedRings.length === 1)
                continue;
            for (var j = 0, _j = containedRings.length; j < _j; j++) {
                var rJ = containedRings[j];
                if (rI >= rJ)
                    continue;
                graph.addEdge(rI, rJ);
            }
        }
    }
    var components = _mol_math_graph__WEBPACK_IMPORTED_MODULE_1__["IntAdjacencyGraph"].connectedComponents(graph.getGraph());
    var ringComponentIndex = components.componentIndex;
    var ringComponents = [];
    for (var i = 0; i < components.componentCount; i++)
        ringComponents[i] = [];
    for (var rI = 0, _rI = rings.length; rI < _rI; rI++) {
        ringComponents[ringComponentIndex[rI]].push(rI);
    }
    return { elementRingIndices: elementRingIndices, elementAromaticRingIndices: elementAromaticRingIndices, ringComponentIndex: ringComponentIndex, ringComponents: ringComponents };
}
//# sourceMappingURL=compute.js.map

/***/ }),

/***/ "./lib/mol-model/structure/structure/util/boundary.js":
/*!************************************************************!*\
  !*** ./lib/mol-model/structure/structure/util/boundary.js ***!
  \************************************************************/
/*! exports provided: computeStructureBoundary */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "computeStructureBoundary", function() { return computeStructureBoundary; });
/* harmony import */ var _mol_math_geometry__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../../../mol-math/geometry */ "./lib/mol-math/geometry.js");
/* harmony import */ var _mol_math_geometry_boundary_helper__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../../../mol-math/geometry/boundary-helper */ "./lib/mol-math/geometry/boundary-helper.js");
/**
 * Copyright (c) 2018-2020 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author David Sehnal <david.sehnal@gmail.com>
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */


var tmpSphere = Object(_mol_math_geometry__WEBPACK_IMPORTED_MODULE_0__["Sphere3D"])();
var boundaryHelperCoarse = new _mol_math_geometry_boundary_helper__WEBPACK_IMPORTED_MODULE_1__["BoundaryHelper"]('14');
var boundaryHelperFine = new _mol_math_geometry_boundary_helper__WEBPACK_IMPORTED_MODULE_1__["BoundaryHelper"]('98');
function getBoundaryHelper(count) {
    return count > 500 ? boundaryHelperCoarse : boundaryHelperFine;
}
function computeStructureBoundary(s) {
    var units = s.units;
    var boundaryHelper = getBoundaryHelper(units.length);
    boundaryHelper.reset();
    for (var i = 0, _i = units.length; i < _i; i++) {
        var u = units[i];
        var invariantBoundary = u.boundary;
        var o = u.conformation.operator;
        if (o.isIdentity) {
            boundaryHelper.includeSphere(invariantBoundary.sphere);
        }
        else {
            _mol_math_geometry__WEBPACK_IMPORTED_MODULE_0__["Sphere3D"].transform(tmpSphere, invariantBoundary.sphere, o.matrix);
            boundaryHelper.includeSphere(tmpSphere);
        }
    }
    boundaryHelper.finishedIncludeStep();
    for (var i = 0, _i = units.length; i < _i; i++) {
        var u = units[i];
        var invariantBoundary = u.boundary;
        var o = u.conformation.operator;
        if (o.isIdentity) {
            boundaryHelper.radiusSphere(invariantBoundary.sphere);
        }
        else {
            _mol_math_geometry__WEBPACK_IMPORTED_MODULE_0__["Sphere3D"].transform(tmpSphere, invariantBoundary.sphere, o.matrix);
            boundaryHelper.radiusSphere(tmpSphere);
        }
    }
    return { box: boundaryHelper.getBox(), sphere: boundaryHelper.getSphere() };
}
//# sourceMappingURL=boundary.js.map

/***/ }),

/***/ "./lib/mol-model/structure/structure/util/lookup3d.js":
/*!************************************************************!*\
  !*** ./lib/mol-model/structure/structure/util/lookup3d.js ***!
  \************************************************************/
/*! exports provided: StructureResult, StructureLookup3D */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "StructureResult", function() { return StructureResult; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "StructureLookup3D", function() { return StructureLookup3D; });
/* harmony import */ var _mol_math_geometry__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../../../mol-math/geometry */ "./lib/mol-math/geometry.js");
/* harmony import */ var _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../../../mol-math/linear-algebra */ "./lib/mol-math/linear-algebra.js");
/* harmony import */ var _mol_data_int__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../../../mol-data/int */ "./lib/mol-data/int.js");
/* harmony import */ var _element__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../element */ "./lib/mol-model/structure/structure/element.js");
/**
 * Copyright (c) 2018-2020 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author David Sehnal <david.sehnal@gmail.com>
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */




var StructureResult;
(function (StructureResult) {
    function add(result, unit, index, distSq) {
        result.indices[result.count] = index;
        result.units[result.count] = unit;
        result.squaredDistances[result.count] = distSq;
        result.count++;
    }
    StructureResult.add = add;
    function create() {
        return { count: 0, indices: [], units: [], squaredDistances: [] };
    }
    StructureResult.create = create;
    function copy(out, result) {
        for (var i = 0; i < result.count; ++i) {
            out.indices[i] = result.indices[i];
            out.units[i] = result.units[i];
            out.squaredDistances[i] = result.squaredDistances[i];
        }
        out.count = result.count;
        return out;
    }
    StructureResult.copy = copy;
})(StructureResult || (StructureResult = {}));
var StructureLookup3D = /** @class */ (function () {
    function StructureLookup3D(structure) {
        this.structure = structure;
        this.pivot = Object(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_1__["Vec3"])();
        this.result = StructureResult.create();
        var units = structure.units, boundary = structure.boundary;
        var unitCount = units.length;
        var xs = new Float32Array(unitCount);
        var ys = new Float32Array(unitCount);
        var zs = new Float32Array(unitCount);
        var radius = new Float32Array(unitCount);
        var center = Object(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_1__["Vec3"])();
        for (var i = 0; i < unitCount; i++) {
            var unit = units[i];
            var s = unit.boundary.sphere;
            _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_1__["Vec3"].transformMat4(center, s.center, unit.conformation.operator.matrix);
            xs[i] = center[0];
            ys[i] = center[1];
            zs[i] = center[2];
            radius[i] = s.radius;
        }
        var position = { x: xs, y: ys, z: zs, radius: radius, indices: _mol_data_int__WEBPACK_IMPORTED_MODULE_2__["OrderedSet"].ofBounds(0, unitCount) };
        this.unitLookup = Object(_mol_math_geometry__WEBPACK_IMPORTED_MODULE_0__["GridLookup3D"])(position, boundary);
    }
    StructureLookup3D.prototype.findUnitIndices = function (x, y, z, radius) {
        return this.unitLookup.find(x, y, z, radius);
    };
    StructureLookup3D.prototype.find = function (x, y, z, radius) {
        _mol_math_geometry__WEBPACK_IMPORTED_MODULE_0__["Result"].reset(this.result);
        var units = this.structure.units;
        var closeUnits = this.unitLookup.find(x, y, z, radius);
        if (closeUnits.count === 0)
            return this.result;
        for (var t = 0, _t = closeUnits.count; t < _t; t++) {
            var unit = units[closeUnits.indices[t]];
            _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_1__["Vec3"].set(this.pivot, x, y, z);
            if (!unit.conformation.operator.isIdentity) {
                _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_1__["Vec3"].transformMat4(this.pivot, this.pivot, unit.conformation.operator.inverse);
            }
            var unitLookup = unit.lookup3d;
            var groupResult = unitLookup.find(this.pivot[0], this.pivot[1], this.pivot[2], radius);
            for (var j = 0, _j = groupResult.count; j < _j; j++) {
                StructureResult.add(this.result, unit, groupResult.indices[j], groupResult.squaredDistances[j]);
            }
        }
        return this.result;
    };
    StructureLookup3D.prototype.findIntoBuilder = function (x, y, z, radius, builder) {
        var units = this.structure.units;
        var closeUnits = this.unitLookup.find(x, y, z, radius);
        if (closeUnits.count === 0)
            return;
        for (var t = 0, _t = closeUnits.count; t < _t; t++) {
            var unit = units[closeUnits.indices[t]];
            _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_1__["Vec3"].set(this.pivot, x, y, z);
            if (!unit.conformation.operator.isIdentity) {
                _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_1__["Vec3"].transformMat4(this.pivot, this.pivot, unit.conformation.operator.inverse);
            }
            var unitLookup = unit.lookup3d;
            var groupResult = unitLookup.find(this.pivot[0], this.pivot[1], this.pivot[2], radius);
            if (groupResult.count === 0)
                continue;
            var elements = unit.elements;
            builder.beginUnit(unit.id);
            for (var j = 0, _j = groupResult.count; j < _j; j++) {
                builder.addElement(elements[groupResult.indices[j]]);
            }
            builder.commitUnit();
        }
    };
    StructureLookup3D.prototype.findIntoBuilderWithRadius = function (x, y, z, pivotR, maxRadius, radius, eRadius, builder) {
        var units = this.structure.units;
        var closeUnits = this.unitLookup.find(x, y, z, radius);
        if (closeUnits.count === 0)
            return;
        var se = _element__WEBPACK_IMPORTED_MODULE_3__["default"].Location.create(this.structure);
        var queryRadius = pivotR + maxRadius + radius;
        for (var t = 0, _t = closeUnits.count; t < _t; t++) {
            var unit = units[closeUnits.indices[t]];
            _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_1__["Vec3"].set(this.pivot, x, y, z);
            if (!unit.conformation.operator.isIdentity) {
                _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_1__["Vec3"].transformMat4(this.pivot, this.pivot, unit.conformation.operator.inverse);
            }
            var unitLookup = unit.lookup3d;
            var groupResult = unitLookup.find(this.pivot[0], this.pivot[1], this.pivot[2], queryRadius);
            if (groupResult.count === 0)
                continue;
            var elements = unit.elements;
            se.unit = unit;
            builder.beginUnit(unit.id);
            for (var j = 0, _j = groupResult.count; j < _j; j++) {
                se.element = elements[groupResult.indices[j]];
                var rr = eRadius(se);
                if (Math.sqrt(groupResult.squaredDistances[j]) - pivotR - rr > radius)
                    continue;
                builder.addElement(elements[groupResult.indices[j]]);
            }
            builder.commitUnit();
        }
    };
    StructureLookup3D.prototype.check = function (x, y, z, radius) {
        var units = this.structure.units;
        var closeUnits = this.unitLookup.find(x, y, z, radius);
        if (closeUnits.count === 0)
            return false;
        for (var t = 0, _t = closeUnits.count; t < _t; t++) {
            var unit = units[closeUnits.indices[t]];
            _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_1__["Vec3"].set(this.pivot, x, y, z);
            if (!unit.conformation.operator.isIdentity) {
                _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_1__["Vec3"].transformMat4(this.pivot, this.pivot, unit.conformation.operator.inverse);
            }
            var groupLookup = unit.lookup3d;
            if (groupLookup.check(this.pivot[0], this.pivot[1], this.pivot[2], radius))
                return true;
        }
        return false;
    };
    Object.defineProperty(StructureLookup3D.prototype, "boundary", {
        get: function () {
            return this.structure.boundary;
        },
        enumerable: false,
        configurable: true
    });
    return StructureLookup3D;
}());

//# sourceMappingURL=lookup3d.js.map

/***/ }),

/***/ "./lib/mol-model/structure/structure/util/polymer.js":
/*!***********************************************************!*\
  !*** ./lib/mol-model/structure/structure/util/polymer.js ***!
  \***********************************************************/
/*! exports provided: getAtomicPolymerElements, getCoarsePolymerElements, getAtomicGapElements, getCoarseGapElements, getNucleotideElements, getProteinElements */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getAtomicPolymerElements", function() { return getAtomicPolymerElements; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getCoarsePolymerElements", function() { return getCoarsePolymerElements; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getAtomicGapElements", function() { return getAtomicGapElements; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getCoarseGapElements", function() { return getCoarseGapElements; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getNucleotideElements", function() { return getNucleotideElements; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getProteinElements", function() { return getProteinElements; });
/* harmony import */ var _mol_model_structure__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../../../mol-model/structure */ "./lib/mol-model/structure.js");
/* harmony import */ var _mol_data_int__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../../../mol-data/int */ "./lib/mol-data/int.js");
/* harmony import */ var _mol_data_int_sorted_ranges__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../../../mol-data/int/sorted-ranges */ "./lib/mol-data/int/sorted-ranges.js");
/* harmony import */ var _mol_model_structure_model_types__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../../../mol-model/structure/model/types */ "./lib/mol-model/structure/model/types.js");
/**
 * Copyright (c) 2018-2019 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */




function getAtomicPolymerElements(unit) {
    var indices = [];
    var elements = unit.elements, model = unit.model;
    var residueAtomSegments = unit.model.atomicHierarchy.residueAtomSegments;
    var traceElementIndex = model.atomicHierarchy.derived.residue.traceElementIndex;
    var polymerIt = _mol_data_int_sorted_ranges__WEBPACK_IMPORTED_MODULE_2__["default"].transientSegments(unit.model.atomicRanges.polymerRanges, elements);
    var residueIt = _mol_data_int__WEBPACK_IMPORTED_MODULE_1__["Segmentation"].transientSegments(residueAtomSegments, elements);
    while (polymerIt.hasNext) {
        var polymerSegment = polymerIt.move();
        residueIt.setSegment(polymerSegment);
        while (residueIt.hasNext) {
            var residueSegment = residueIt.move();
            var start = residueSegment.start, end = residueSegment.end, index = residueSegment.index;
            if (_mol_data_int__WEBPACK_IMPORTED_MODULE_1__["OrderedSet"].areIntersecting(_mol_data_int__WEBPACK_IMPORTED_MODULE_1__["Interval"].ofRange(elements[start], elements[end - 1]), elements)) {
                var elementIndex = traceElementIndex[index];
                indices.push(elementIndex === -1 ? residueAtomSegments.offsets[index] : elementIndex);
            }
        }
    }
    return _mol_data_int__WEBPACK_IMPORTED_MODULE_1__["SortedArray"].ofSortedArray(indices);
}
function getCoarsePolymerElements(unit) {
    var indices = [];
    var elements = unit.elements, model = unit.model;
    var _a = model.coarseHierarchy, spheres = _a.spheres, gaussians = _a.gaussians;
    var polymerRanges = _mol_model_structure__WEBPACK_IMPORTED_MODULE_0__["Unit"].isSpheres(unit) ? spheres.polymerRanges : gaussians.polymerRanges;
    var polymerIt = _mol_data_int_sorted_ranges__WEBPACK_IMPORTED_MODULE_2__["default"].transientSegments(polymerRanges, elements);
    while (polymerIt.hasNext) {
        var _b = polymerIt.move(), start = _b.start, end = _b.end;
        for (var i = start; i < end; ++i) {
            indices.push(elements[i]);
        }
    }
    return _mol_data_int__WEBPACK_IMPORTED_MODULE_1__["SortedArray"].ofSortedArray(indices);
}
//
function getAtomicGapElements(unit) {
    var indices = [];
    var elements = unit.elements, model = unit.model, residueIndex = unit.residueIndex;
    var residueAtomSegments = unit.model.atomicHierarchy.residueAtomSegments;
    var traceElementIndex = model.atomicHierarchy.derived.residue.traceElementIndex;
    var gapIt = _mol_data_int_sorted_ranges__WEBPACK_IMPORTED_MODULE_2__["default"].transientSegments(unit.model.atomicRanges.gapRanges, unit.elements);
    while (gapIt.hasNext) {
        var gapSegment = gapIt.move();
        var indexStart = residueIndex[elements[gapSegment.start]];
        var indexEnd = residueIndex[elements[gapSegment.end - 1]];
        var elementIndexStart = traceElementIndex[indexStart];
        var elementIndexEnd = traceElementIndex[indexEnd];
        indices.push(elementIndexStart === -1 ? residueAtomSegments.offsets[indexStart] : elementIndexStart);
        indices.push(elementIndexEnd === -1 ? residueAtomSegments.offsets[indexEnd] : elementIndexEnd);
    }
    return _mol_data_int__WEBPACK_IMPORTED_MODULE_1__["SortedArray"].ofSortedArray(indices);
}
function getCoarseGapElements(unit) {
    var indices = [];
    var elements = unit.elements, model = unit.model;
    var _a = model.coarseHierarchy, spheres = _a.spheres, gaussians = _a.gaussians;
    var gapRanges = _mol_model_structure__WEBPACK_IMPORTED_MODULE_0__["Unit"].isSpheres(unit) ? spheres.gapRanges : gaussians.gapRanges;
    var gapIt = _mol_data_int_sorted_ranges__WEBPACK_IMPORTED_MODULE_2__["default"].transientSegments(gapRanges, elements);
    while (gapIt.hasNext) {
        var _b = gapIt.move(), start = _b.start, end = _b.end;
        indices.push(elements[start], elements[end - 1]);
    }
    return _mol_data_int__WEBPACK_IMPORTED_MODULE_1__["SortedArray"].ofSortedArray(indices);
}
//
function getNucleotideElements(unit) {
    var indices = [];
    var elements = unit.elements, model = unit.model;
    var _a = model.atomicHierarchy, chainAtomSegments = _a.chainAtomSegments, residueAtomSegments = _a.residueAtomSegments;
    var _b = model.atomicHierarchy.derived.residue, moleculeType = _b.moleculeType, traceElementIndex = _b.traceElementIndex;
    var chainIt = _mol_data_int__WEBPACK_IMPORTED_MODULE_1__["Segmentation"].transientSegments(chainAtomSegments, elements);
    var residueIt = _mol_data_int__WEBPACK_IMPORTED_MODULE_1__["Segmentation"].transientSegments(residueAtomSegments, elements);
    while (chainIt.hasNext) {
        residueIt.setSegment(chainIt.move());
        while (residueIt.hasNext) {
            var index = residueIt.move().index;
            if (Object(_mol_model_structure_model_types__WEBPACK_IMPORTED_MODULE_3__["isNucleic"])(moleculeType[index])) {
                var elementIndex = traceElementIndex[index];
                indices.push(elementIndex === -1 ? residueAtomSegments.offsets[index] : elementIndex);
            }
        }
    }
    return _mol_data_int__WEBPACK_IMPORTED_MODULE_1__["SortedArray"].ofSortedArray(indices);
}
function getProteinElements(unit) {
    var indices = [];
    var elements = unit.elements, model = unit.model;
    var _a = model.atomicHierarchy, chainAtomSegments = _a.chainAtomSegments, residueAtomSegments = _a.residueAtomSegments;
    var _b = model.atomicHierarchy.derived.residue, moleculeType = _b.moleculeType, traceElementIndex = _b.traceElementIndex;
    var chainIt = _mol_data_int__WEBPACK_IMPORTED_MODULE_1__["Segmentation"].transientSegments(chainAtomSegments, elements);
    var residueIt = _mol_data_int__WEBPACK_IMPORTED_MODULE_1__["Segmentation"].transientSegments(residueAtomSegments, elements);
    while (chainIt.hasNext) {
        residueIt.setSegment(chainIt.move());
        while (residueIt.hasNext) {
            var index = residueIt.move().index;
            if (Object(_mol_model_structure_model_types__WEBPACK_IMPORTED_MODULE_3__["isProtein"])(moleculeType[index])) {
                var elementIndex = traceElementIndex[index];
                indices.push(elementIndex === -1 ? residueAtomSegments.offsets[index] : elementIndex);
            }
        }
    }
    return _mol_data_int__WEBPACK_IMPORTED_MODULE_1__["SortedArray"].ofSortedArray(indices);
}
//# sourceMappingURL=polymer.js.map

/***/ }),

/***/ "./lib/mol-model/structure/structure/util/principal-axes.js":
/*!******************************************************************!*\
  !*** ./lib/mol-model/structure/structure/util/principal-axes.js ***!
  \******************************************************************/
/*! exports provided: toPositionsArray, getPrincipalAxes */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "toPositionsArray", function() { return toPositionsArray; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getPrincipalAxes", function() { return getPrincipalAxes; });
/* harmony import */ var _mol_math_linear_algebra_matrix_principal_axes__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../../../mol-math/linear-algebra/matrix/principal-axes */ "./lib/mol-math/linear-algebra/matrix/principal-axes.js");
/* harmony import */ var _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../../../mol-math/linear-algebra */ "./lib/mol-math/linear-algebra.js");
/**
 * Copyright (c) 2019 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */


var tempPos = _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_1__["Vec3"].zero();
function toPositionsArray(unit) {
    var pos = unit.conformation.invariantPosition;
    var elements = unit.elements;
    var positions = new Float32Array(elements.length * 3);
    for (var i = 0, il = elements.length; i < il; i++) {
        pos(elements[i], tempPos);
        _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_1__["Vec3"].toArray(tempPos, positions, i * 3);
    }
    return positions;
}
function getPrincipalAxes(unit) {
    var positions = toPositionsArray(unit);
    return _mol_math_linear_algebra_matrix_principal_axes__WEBPACK_IMPORTED_MODULE_0__["PrincipalAxes"].ofPositions(positions);
}
//# sourceMappingURL=principal-axes.js.map

/***/ }),

/***/ "./lib/mol-model/structure/structure/util/subset-builder.js":
/*!******************************************************************!*\
  !*** ./lib/mol-model/structure/structure/util/subset-builder.js ***!
  \******************************************************************/
/*! exports provided: StructureSubsetBuilder */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "StructureSubsetBuilder", function() { return StructureSubsetBuilder; });
/* harmony import */ var _mol_data_int__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../../../mol-data/int */ "./lib/mol-data/int.js");
/* harmony import */ var _mol_data_util__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../../../mol-data/util */ "./lib/mol-data/util.js");
/* harmony import */ var _symmetry__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../symmetry */ "./lib/mol-model/structure/structure/symmetry.js");
/* harmony import */ var _structure__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../structure */ "./lib/mol-model/structure/structure/structure.js");
/**
 * Copyright (c) 2017 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author David Sehnal <david.sehnal@gmail.com>
 */




var StructureSubsetBuilder = /** @class */ (function () {
    function StructureSubsetBuilder(parent, isSorted) {
        this.parent = parent;
        this.isSorted = isSorted;
        this.ids = [];
        this.unitMap = _mol_data_int__WEBPACK_IMPORTED_MODULE_0__["IntMap"].Mutable();
        this.parentId = -1;
        this.currentUnit = [];
        this.elementCount = 0;
    }
    StructureSubsetBuilder.prototype.addToUnit = function (parentId, e) {
        var unit = this.unitMap.get(parentId);
        if (!!unit) {
            unit[unit.length] = e;
        }
        else {
            this.unitMap.set(parentId, [e]);
            this.ids[this.ids.length] = parentId;
        }
        this.elementCount++;
    };
    StructureSubsetBuilder.prototype.beginUnit = function (parentId) {
        this.parentId = parentId;
        this.currentUnit = this.currentUnit.length > 0 ? [] : this.currentUnit;
    };
    StructureSubsetBuilder.prototype.addElement = function (e) {
        this.currentUnit[this.currentUnit.length] = e;
        this.elementCount++;
    };
    StructureSubsetBuilder.prototype.addElementRange = function (elements, start, end) {
        for (var i = start; i < end; i++) {
            this.currentUnit[this.currentUnit.length] = elements[i];
            this.elementCount++;
        }
    };
    StructureSubsetBuilder.prototype.commitUnit = function () {
        if (this.currentUnit.length === 0)
            return;
        this.ids[this.ids.length] = this.parentId;
        this.unitMap.set(this.parentId, this.currentUnit);
        this.parentId = -1;
    };
    StructureSubsetBuilder.prototype.setUnit = function (parentId, elements) {
        this.ids[this.ids.length] = parentId;
        this.unitMap.set(parentId, elements);
        this.elementCount += elements.length;
    };
    StructureSubsetBuilder.prototype._getStructure = function (deduplicateElements) {
        if (this.isEmpty)
            return _structure__WEBPACK_IMPORTED_MODULE_3__["default"].Empty;
        var newUnits = [];
        Object(_mol_data_util__WEBPACK_IMPORTED_MODULE_1__["sortArray"])(this.ids);
        var symmGroups = _symmetry__WEBPACK_IMPORTED_MODULE_2__["default"].UnitEquivalenceBuilder();
        for (var i = 0, _i = this.ids.length; i < _i; i++) {
            var id = this.ids[i];
            var parent_1 = this.parent.unitMap.get(id);
            var unit = this.unitMap.get(id);
            var sorted = false;
            if (deduplicateElements) {
                if (!this.isSorted)
                    Object(_mol_data_util__WEBPACK_IMPORTED_MODULE_1__["sortArray"])(unit);
                unit = _mol_data_int__WEBPACK_IMPORTED_MODULE_0__["SortedArray"].deduplicate(_mol_data_int__WEBPACK_IMPORTED_MODULE_0__["SortedArray"].ofSortedArray(this.currentUnit));
                sorted = true;
            }
            var l = unit.length;
            // if the length is the same, just copy the old unit.
            if (unit.length === parent_1.elements.length) {
                newUnits[newUnits.length] = parent_1;
                symmGroups.add(parent_1.id, parent_1);
                continue;
            }
            if (!this.isSorted && !sorted && l > 1)
                Object(_mol_data_util__WEBPACK_IMPORTED_MODULE_1__["sortArray"])(unit);
            var child = parent_1.getChild(_mol_data_int__WEBPACK_IMPORTED_MODULE_0__["SortedArray"].ofSortedArray(unit));
            var pivot = symmGroups.add(child.id, child);
            if (child !== pivot)
                child = pivot.applyOperator(child.id, child.conformation.operator, true);
            newUnits[newUnits.length] = child;
        }
        return _structure__WEBPACK_IMPORTED_MODULE_3__["default"].create(newUnits, { parent: this.parent });
    };
    StructureSubsetBuilder.prototype.getStructure = function () {
        return this._getStructure(false);
    };
    StructureSubsetBuilder.prototype.getStructureDeduplicate = function () {
        return this._getStructure(true);
    };
    StructureSubsetBuilder.prototype.setSingletonLocation = function (location) {
        var id = this.ids[0];
        location.unit = this.parent.unitMap.get(id);
        location.element = this.unitMap.get(id)[0];
    };
    Object.defineProperty(StructureSubsetBuilder.prototype, "isEmpty", {
        get: function () {
            return this.elementCount === 0;
        },
        enumerable: false,
        configurable: true
    });
    return StructureSubsetBuilder;
}());

//# sourceMappingURL=subset-builder.js.map

/***/ }),

/***/ "./lib/mol-model/structure/structure/util/superposition.js":
/*!*****************************************************************!*\
  !*** ./lib/mol-model/structure/structure/util/superposition.js ***!
  \*****************************************************************/
/*! exports provided: superpose, alignAndSuperpose */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "superpose", function() { return superpose; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "alignAndSuperpose", function() { return alignAndSuperpose; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _mol_math_linear_algebra_3d_minimize_rmsd__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../../../mol-math/linear-algebra/3d/minimize-rmsd */ "./lib/mol-math/linear-algebra/3d/minimize-rmsd.js");
/* harmony import */ var _element__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../element */ "./lib/mol-model/structure/structure/element.js");
/* harmony import */ var _mol_data_int__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../../../mol-data/int */ "./lib/mol-data/int.js");
/* harmony import */ var _sequence_alignment_sequence__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../../sequence/alignment/sequence */ "./lib/mol-model/sequence/alignment/sequence.js");
/* harmony import */ var _properties__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../properties */ "./lib/mol-model/structure/structure/properties.js");
/**
 * Copyright (c) 2019-2020 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author David Sehnal <david.sehnal@gmail.com>
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */






function superpose(xs) {
    var ret = [];
    if (xs.length <= 0)
        return ret;
    var n = getMinSize(xs);
    var input = {
        a: getPositionTable(xs[0], n),
        b: getPositionTable(xs[1], n)
    };
    ret[0] = _mol_math_linear_algebra_3d_minimize_rmsd__WEBPACK_IMPORTED_MODULE_1__["MinimizeRmsd"].compute(input);
    for (var i = 2; i < xs.length; i++) {
        input.b = getPositionTable(xs[i], n);
        input.centerB = void 0;
        ret.push(_mol_math_linear_algebra_3d_minimize_rmsd__WEBPACK_IMPORTED_MODULE_1__["MinimizeRmsd"].compute(input));
    }
    return ret;
}
var reProtein = /(polypeptide|cyclic-pseudo-peptide)/i;
function alignAndSuperpose(xs) {
    var ret = [];
    if (xs.length <= 0)
        return ret;
    var l = _element__WEBPACK_IMPORTED_MODULE_2__["default"].Loci.getFirstLocation(xs[0]);
    var subtype = _properties__WEBPACK_IMPORTED_MODULE_5__["default"].entity.subtype(l);
    var substMatrix = subtype.match(reProtein) ? 'blosum62' : 'default';
    for (var i = 1; i < xs.length; i++) {
        var _a = _sequence_alignment_sequence__WEBPACK_IMPORTED_MODULE_4__["AlignSequences"].compute({
            a: xs[0].elements[0],
            b: xs[i].elements[0],
        }, { substMatrix: substMatrix }), a = _a.a, b = _a.b, score = _a.score;
        var lociA = _element__WEBPACK_IMPORTED_MODULE_2__["default"].Loci(xs[0].structure, [a]);
        var lociB = _element__WEBPACK_IMPORTED_MODULE_2__["default"].Loci(xs[i].structure, [b]);
        var n = _mol_data_int__WEBPACK_IMPORTED_MODULE_3__["OrderedSet"].size(a.indices);
        ret.push(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, _mol_math_linear_algebra_3d_minimize_rmsd__WEBPACK_IMPORTED_MODULE_1__["MinimizeRmsd"].compute({
            a: getPositionTable(lociA, n),
            b: getPositionTable(lociB, n)
        })), { alignmentScore: score }));
    }
    return ret;
}
function getPositionTable(xs, n) {
    var ret = _mol_math_linear_algebra_3d_minimize_rmsd__WEBPACK_IMPORTED_MODULE_1__["MinimizeRmsd"].Positions.empty(n);
    var o = 0;
    for (var _a = 0, _b = xs.elements; _a < _b.length; _a++) {
        var u = _b[_a];
        var unit = u.unit, indices = u.indices;
        var elements = unit.elements;
        var _c = unit.conformation, x = _c.x, y = _c.y, z = _c.z;
        for (var i = 0, _i = _mol_data_int__WEBPACK_IMPORTED_MODULE_3__["OrderedSet"].size(indices); i < _i; i++) {
            var e = elements[_mol_data_int__WEBPACK_IMPORTED_MODULE_3__["OrderedSet"].getAt(indices, i)];
            ret.x[o] = x(e);
            ret.y[o] = y(e);
            ret.z[o] = z(e);
            o++;
            if (o >= n)
                break;
        }
        if (o >= n)
            break;
    }
    return ret;
}
function getMinSize(xs) {
    if (xs.length === 0)
        return 0;
    var s = _element__WEBPACK_IMPORTED_MODULE_2__["default"].Loci.size(xs[0]);
    for (var i = 1; i < xs.length; i++) {
        var t = _element__WEBPACK_IMPORTED_MODULE_2__["default"].Loci.size(xs[i]);
        if (t < s)
            s = t;
    }
    return s;
}
//# sourceMappingURL=superposition.js.map

/***/ }),

/***/ "./lib/mol-model/structure/structure/util/unique-subset-builder.js":
/*!*************************************************************************!*\
  !*** ./lib/mol-model/structure/structure/util/unique-subset-builder.js ***!
  \*************************************************************************/
/*! exports provided: StructureUniqueSubsetBuilder */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "StructureUniqueSubsetBuilder", function() { return StructureUniqueSubsetBuilder; });
/* harmony import */ var _mol_data_int__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../../../mol-data/int */ "./lib/mol-data/int.js");
/* harmony import */ var _mol_data_util__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../../../mol-data/util */ "./lib/mol-data/util.js");
/* harmony import */ var _symmetry__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../symmetry */ "./lib/mol-model/structure/structure/symmetry.js");
/* harmony import */ var _structure__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../structure */ "./lib/mol-model/structure/structure/structure.js");
/* harmony import */ var _mol_data_generic__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../../../mol-data/generic */ "./lib/mol-data/generic.js");
/**
 * Copyright (c) 2017 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author David Sehnal <david.sehnal@gmail.com>
 */





var StructureUniqueSubsetBuilder = /** @class */ (function () {
    function StructureUniqueSubsetBuilder(parent) {
        this.parent = parent;
        this.ids = [];
        this.unitMap = _mol_data_int__WEBPACK_IMPORTED_MODULE_0__["IntMap"].Mutable();
        this.parentId = -1;
        this.currentUnit = _mol_data_generic__WEBPACK_IMPORTED_MODULE_4__["UniqueArray"].create();
        this.elementCount = 0;
    }
    StructureUniqueSubsetBuilder.prototype.addToUnit = function (parentId, e) {
        var unit = this.unitMap.get(parentId);
        if (!!unit) {
            if (_mol_data_generic__WEBPACK_IMPORTED_MODULE_4__["UniqueArray"].add(unit, e, e))
                this.elementCount++;
        }
        else {
            var arr = _mol_data_generic__WEBPACK_IMPORTED_MODULE_4__["UniqueArray"].create();
            _mol_data_generic__WEBPACK_IMPORTED_MODULE_4__["UniqueArray"].add(arr, e, e);
            this.unitMap.set(parentId, arr);
            this.ids[this.ids.length] = parentId;
            this.elementCount++;
        }
    };
    StructureUniqueSubsetBuilder.prototype.has = function (parentId, e) {
        var unit = this.unitMap.get(parentId);
        if (!unit)
            return false;
        return _mol_data_generic__WEBPACK_IMPORTED_MODULE_4__["UniqueArray"].has(unit, e);
    };
    StructureUniqueSubsetBuilder.prototype.beginUnit = function (parentId) {
        this.parentId = parentId;
        if (this.unitMap.has(parentId)) {
            this.currentUnit = this.unitMap.get(parentId);
        }
        else {
            this.currentUnit = this.currentUnit.array.length > 0 ? _mol_data_generic__WEBPACK_IMPORTED_MODULE_4__["UniqueArray"].create() : this.currentUnit;
        }
    };
    StructureUniqueSubsetBuilder.prototype.addElement = function (e) {
        if (_mol_data_generic__WEBPACK_IMPORTED_MODULE_4__["UniqueArray"].add(this.currentUnit, e, e))
            this.elementCount++;
    };
    StructureUniqueSubsetBuilder.prototype.commitUnit = function () {
        if (this.currentUnit.array.length === 0 || this.unitMap.has(this.parentId))
            return;
        this.ids[this.ids.length] = this.parentId;
        this.unitMap.set(this.parentId, this.currentUnit);
        this.parentId = -1;
    };
    StructureUniqueSubsetBuilder.prototype.getStructure = function () {
        if (this.isEmpty)
            return _structure__WEBPACK_IMPORTED_MODULE_3__["default"].Empty;
        var newUnits = [];
        Object(_mol_data_util__WEBPACK_IMPORTED_MODULE_1__["sortArray"])(this.ids);
        var symmGroups = _symmetry__WEBPACK_IMPORTED_MODULE_2__["default"].UnitEquivalenceBuilder();
        for (var i = 0, _i = this.ids.length; i < _i; i++) {
            var id = this.ids[i];
            var parent_1 = this.parent.unitMap.get(id);
            var unit = this.unitMap.get(id).array;
            var l = unit.length;
            // if the length is the same, just copy the old unit.
            if (unit.length === parent_1.elements.length) {
                newUnits[newUnits.length] = parent_1;
                symmGroups.add(parent_1.id, parent_1);
                continue;
            }
            if (l > 1)
                Object(_mol_data_util__WEBPACK_IMPORTED_MODULE_1__["sortArray"])(unit);
            var child = parent_1.getChild(_mol_data_int__WEBPACK_IMPORTED_MODULE_0__["SortedArray"].ofSortedArray(unit));
            var pivot = symmGroups.add(child.id, child);
            if (child !== pivot)
                child = pivot.applyOperator(child.id, child.conformation.operator, true);
            newUnits[newUnits.length] = child;
        }
        return _structure__WEBPACK_IMPORTED_MODULE_3__["default"].create(newUnits, { parent: this.parent });
    };
    Object.defineProperty(StructureUniqueSubsetBuilder.prototype, "isEmpty", {
        get: function () {
            return this.elementCount === 0;
        },
        enumerable: false,
        configurable: true
    });
    return StructureUniqueSubsetBuilder;
}());

//# sourceMappingURL=unique-subset-builder.js.map

/***/ }),

/***/ "./lib/mol-model/structure/structure/util/unit-transforms.js":
/*!*******************************************************************!*\
  !*** ./lib/mol-model/structure/structure/util/unit-transforms.js ***!
  \*******************************************************************/
/*! exports provided: StructureUnitTransforms */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "StructureUnitTransforms", function() { return StructureUnitTransforms; });
/* harmony import */ var _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../../../mol-math/linear-algebra */ "./lib/mol-math/linear-algebra.js");
/* harmony import */ var _mol_data_int__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../../../mol-data/int */ "./lib/mol-data/int.js");
/* harmony import */ var _mol_geo_geometry_transform_data__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../../../mol-geo/geometry/transform-data */ "./lib/mol-geo/geometry/transform-data.js");
/**
 * Copyright (c) 2019 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */



var tmpMat = Object(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Mat4"])();
var StructureUnitTransforms = /** @class */ (function () {
    function StructureUnitTransforms(structure) {
        this.structure = structure;
        this.groupUnitTransforms = [];
        /** maps unit.id to offset of transform in unitTransforms */
        this.unitOffsetMap = _mol_data_int__WEBPACK_IMPORTED_MODULE_1__["IntMap"].Mutable();
        this.groupIndexMap = _mol_data_int__WEBPACK_IMPORTED_MODULE_1__["IntMap"].Mutable();
        this._isIdentity = undefined;
        this.version = 0;
        this.unitTransforms = new Float32Array(structure.units.length * 16);
        this.size = structure.units.length;
        this.reset(); // to set to identity
        var groupOffset = 0;
        for (var i = 0, il = structure.unitSymmetryGroups.length; i < il; ++i) {
            var g = structure.unitSymmetryGroups[i];
            this.groupIndexMap.set(g.hashCode, i);
            var groupTransforms = this.unitTransforms.subarray(groupOffset, groupOffset + g.units.length * 16);
            this.groupUnitTransforms.push(groupTransforms);
            for (var j = 0, jl = g.units.length; j < jl; ++j) {
                this.unitOffsetMap.set(g.units[j].id, groupOffset + j * 16);
            }
            groupOffset += g.units.length * 16;
        }
    }
    StructureUnitTransforms.prototype.reset = function () {
        this.version = 0;
        Object(_mol_geo_geometry_transform_data__WEBPACK_IMPORTED_MODULE_2__["fillIdentityTransform"])(this.unitTransforms, this.size);
        this._isIdentity = true;
    };
    Object.defineProperty(StructureUnitTransforms.prototype, "isIdentity", {
        get: function () {
            if (this._isIdentity === undefined) {
                this._isIdentity = true;
                for (var i = 0, il = this.size * 16; i < il; i += 16) {
                    _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Mat4"].fromArray(tmpMat, this.unitTransforms, i);
                    if (!_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Mat4"].isIdentity(tmpMat)) {
                        this._isIdentity = false;
                        break;
                    }
                }
            }
            return this._isIdentity;
        },
        enumerable: false,
        configurable: true
    });
    StructureUnitTransforms.prototype.setTransform = function (matrix, unit) {
        this.version = (this.version + 1) % 0x7fffffff;
        _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Mat4"].toArray(matrix, this.unitTransforms, this.unitOffsetMap.get(unit.id));
        this._isIdentity = undefined;
    };
    StructureUnitTransforms.prototype.getTransform = function (out, unit) {
        return _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Mat4"].fromArray(out, this.unitTransforms, this.unitOffsetMap.get(unit.id));
    };
    StructureUnitTransforms.prototype.getSymmetryGroupTransforms = function (group) {
        return this.groupUnitTransforms[this.groupIndexMap.get(group.hashCode)];
    };
    return StructureUnitTransforms;
}());

//# sourceMappingURL=unit-transforms.js.map

/***/ }),

/***/ "./lib/mol-model/structure/topology.js":
/*!*********************************************!*\
  !*** ./lib/mol-model/structure/topology.js ***!
  \*********************************************/
/*! exports provided: Topology */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _topology_topology__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./topology/topology */ "./lib/mol-model/structure/topology/topology.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Topology", function() { return _topology_topology__WEBPACK_IMPORTED_MODULE_0__["Topology"]; });

/**
 * Copyright (c) 2019 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */

//# sourceMappingURL=topology.js.map

/***/ }),

/***/ "./lib/mol-model/structure/topology/topology.js":
/*!******************************************************!*\
  !*** ./lib/mol-model/structure/topology/topology.js ***!
  \******************************************************/
/*! exports provided: Topology */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Topology", function() { return Topology; });
/* harmony import */ var _mol_util__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../../mol-util */ "./lib/mol-util/index.js");
/**
 * Copyright (c) 2019-2020 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */


var Topology;
(function (Topology) {
    function create(label, basic, bonds, format) {
        return {
            id: _mol_util__WEBPACK_IMPORTED_MODULE_0__["UUID"].create22(),
            label: label,
            basic: basic,
            sourceData: format,
            bonds: bonds
        };
    }
    Topology.create = create;
})(Topology || (Topology = {}));
//# sourceMappingURL=topology.js.map

/***/ }),

/***/ "./lib/mol-model/structure/trajectory.js":
/*!***********************************************!*\
  !*** ./lib/mol-model/structure/trajectory.js ***!
  \***********************************************/
/*! exports provided: ArrayTrajectory */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ArrayTrajectory", function() { return ArrayTrajectory; });
/**
 * Copyright (c) 2020 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author David Sehnal <david.sehnal@gmail.com>
 */
var ArrayTrajectory = /** @class */ (function () {
    function ArrayTrajectory(frames) {
        this.frames = frames;
        this.frameCount = frames.length;
        this.representative = frames[0];
        this.duration = frames.length;
    }
    ArrayTrajectory.prototype.getFrameAtIndex = function (i) {
        return this.frames[i];
    };
    return ArrayTrajectory;
}());

//# sourceMappingURL=trajectory.js.map

/***/ }),

/***/ "./lib/mol-model/structure/util.js":
/*!*****************************************!*\
  !*** ./lib/mol-model/structure/util.js ***!
  \*****************************************/
/*! exports provided: getCoarseBegCompId, getElementMoleculeType, getAtomicMoleculeType, getAtomIdForAtomRole, getPositions */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getCoarseBegCompId", function() { return getCoarseBegCompId; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getElementMoleculeType", function() { return getElementMoleculeType; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getAtomicMoleculeType", function() { return getAtomicMoleculeType; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getAtomIdForAtomRole", function() { return getAtomIdForAtomRole; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getPositions", function() { return getPositions; });
/* harmony import */ var _model_types__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./model/types */ "./lib/mol-model/structure/model/types.js");
/* harmony import */ var _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../mol-math/linear-algebra */ "./lib/mol-math/linear-algebra.js");
/**
 * Copyright (c) 2018-2019 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */


function getCoarseBegCompId(unit, element) {
    var entityKey = unit.coarseElements.entityKey[element];
    var seq = unit.model.sequence.byEntityKey[entityKey].sequence;
    var seq_id_begin = unit.coarseElements.seq_id_begin.value(element);
    return seq.compId.value(seq_id_begin - 1); // 1-indexed
}
function getElementMoleculeType(unit, element) {
    switch (unit.kind) {
        case 0 /* Atomic */:
            return unit.model.atomicHierarchy.derived.residue.moleculeType[unit.residueIndex[element]];
        case 1 /* Spheres */:
        case 2 /* Gaussians */:
            // TODO add unit.model.coarseHierarchy.derived.residue.moleculeType
            var compId = getCoarseBegCompId(unit, element);
            var cc = unit.model.properties.chemicalComponentMap.get(compId);
            if (cc)
                return Object(_model_types__WEBPACK_IMPORTED_MODULE_0__["getMoleculeType"])(cc.type, compId);
    }
    return 0 /* Unknown */;
}
function getAtomicMoleculeType(model, rI) {
    return model.atomicHierarchy.derived.residue.moleculeType[rI];
}
var EmptyAtomIds = new Set();
function getAtomIdForAtomRole(polymerType, atomRole) {
    var p = _model_types__WEBPACK_IMPORTED_MODULE_0__["PolymerTypeAtomRoleId"][polymerType];
    if (p !== undefined) {
        var a = p[atomRole];
        if (a !== undefined)
            return a;
    }
    return EmptyAtomIds;
}
var tmpPositionsVec = _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_1__["Vec3"].zero();
function getPositions(unit, indices) {
    var pos = unit.conformation.position;
    var positions = new Float32Array(indices.length * 3);
    var elements = unit.elements;
    for (var i = 0, il = indices.length; i < il; ++i) {
        pos(elements[indices[i]], tmpPositionsVec);
        _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_1__["Vec3"].toArray(tmpPositionsVec, positions, i * 3);
    }
    return positions;
}
//# sourceMappingURL=util.js.map

/***/ }),

/***/ "./lib/mol-model/volume.js":
/*!*********************************!*\
  !*** ./lib/mol-model/volume.js ***!
  \*********************************/
/*! exports provided: Volume, Grid */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _volume_volume__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./volume/volume */ "./lib/mol-model/volume/volume.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Volume", function() { return _volume_volume__WEBPACK_IMPORTED_MODULE_0__["Volume"]; });

/* harmony import */ var _volume_grid__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./volume/grid */ "./lib/mol-model/volume/grid.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Grid", function() { return _volume_grid__WEBPACK_IMPORTED_MODULE_1__["Grid"]; });

/**
 * Copyright (c) 2018-2020 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author David Sehnal <david.sehnal@gmail.com>
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */


//# sourceMappingURL=volume.js.map

/***/ }),

/***/ "./lib/mol-model/volume/grid.js":
/*!**************************************!*\
  !*** ./lib/mol-model/volume/grid.js ***!
  \**************************************/
/*! exports provided: Grid */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Grid", function() { return Grid; });
/* harmony import */ var _mol_math_geometry__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../mol-math/geometry */ "./lib/mol-math/geometry.js");
/* harmony import */ var _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../mol-math/linear-algebra */ "./lib/mol-math/linear-algebra.js");
/* harmony import */ var _mol_math_histogram__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../mol-math/histogram */ "./lib/mol-math/histogram.js");
/**
 * Copyright (c) 2018-2020 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author David Sehnal <david.sehnal@gmail.com>
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */



var Grid;
(function (Grid) {
    Grid.One = {
        transform: { kind: 'matrix', matrix: _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_1__["Mat4"].identity() },
        cells: _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_1__["Tensor"].create(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_1__["Tensor"].Space([1, 1, 1], [0, 1, 2]), _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_1__["Tensor"].Data1([0])),
        stats: { min: 0, max: 0, mean: 0, sigma: 0 },
    };
    var _scale = _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_1__["Mat4"].zero(), _translate = _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_1__["Mat4"].zero();
    function getGridToCartesianTransform(grid) {
        if (grid.transform.kind === 'matrix') {
            return _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_1__["Mat4"].copy(Object(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_1__["Mat4"])(), grid.transform.matrix);
        }
        if (grid.transform.kind === 'spacegroup') {
            var space = grid.cells.space;
            var scale = _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_1__["Mat4"].fromScaling(_scale, _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_1__["Vec3"].div(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_1__["Vec3"].zero(), _mol_math_geometry__WEBPACK_IMPORTED_MODULE_0__["Box3D"].size(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_1__["Vec3"].zero(), grid.transform.fractionalBox), _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_1__["Vec3"].ofArray(space.dimensions)));
            var translate = _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_1__["Mat4"].fromTranslation(_translate, grid.transform.fractionalBox.min);
            return _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_1__["Mat4"].mul3(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_1__["Mat4"].zero(), grid.transform.cell.fromFractional, translate, scale);
        }
        return _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_1__["Mat4"].identity();
    }
    Grid.getGridToCartesianTransform = getGridToCartesianTransform;
    function areEquivalent(gridA, gridB) {
        return gridA === gridB;
    }
    Grid.areEquivalent = areEquivalent;
    function isEmpty(grid) {
        return grid.cells.data.length === 0;
    }
    Grid.isEmpty = isEmpty;
    function getBoundingSphere(grid, boundingSphere) {
        if (!boundingSphere)
            boundingSphere = Object(_mol_math_geometry__WEBPACK_IMPORTED_MODULE_0__["Sphere3D"])();
        var dimensions = grid.cells.space.dimensions;
        var transform = Grid.getGridToCartesianTransform(grid);
        return _mol_math_geometry__WEBPACK_IMPORTED_MODULE_0__["Sphere3D"].fromDimensionsAndTransform(boundingSphere, dimensions, transform);
    }
    Grid.getBoundingSphere = getBoundingSphere;
    /**
     * Compute histogram with given bin count.
     * Cached on the Grid object.
     */
    function getHistogram(grid, binCount) {
        var histograms = grid._historams;
        if (!histograms) {
            histograms = grid._historams = {};
        }
        if (!histograms[binCount]) {
            histograms[binCount] = Object(_mol_math_histogram__WEBPACK_IMPORTED_MODULE_2__["calculateHistogram"])(grid.cells.data, binCount, { min: grid.stats.min, max: grid.stats.max });
        }
        return histograms[binCount];
    }
    Grid.getHistogram = getHistogram;
})(Grid || (Grid = {}));

//# sourceMappingURL=grid.js.map

/***/ }),

/***/ "./lib/mol-model/volume/volume.js":
/*!****************************************!*\
  !*** ./lib/mol-model/volume/volume.js ***!
  \****************************************/
/*! exports provided: Volume */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Volume", function() { return Volume; });
/* harmony import */ var _grid__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./grid */ "./lib/mol-model/volume/grid.js");
/* harmony import */ var _mol_data_int__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../mol-data/int */ "./lib/mol-data/int.js");
/* harmony import */ var _mol_math_geometry__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../mol-math/geometry */ "./lib/mol-math/geometry.js");
/* harmony import */ var _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../mol-math/linear-algebra */ "./lib/mol-math/linear-algebra.js");
/* harmony import */ var _mol_math_geometry_boundary_helper__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../mol-math/geometry/boundary-helper */ "./lib/mol-math/geometry/boundary-helper.js");
/* harmony import */ var _mol_model_formats_volume_cube__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../mol-model-formats/volume/cube */ "./lib/mol-model-formats/volume/cube.js");
/* harmony import */ var _mol_math_linear_algebra_3d_common__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../../mol-math/linear-algebra/3d/common */ "./lib/mol-math/linear-algebra/3d/common.js");
/* harmony import */ var _custom_property__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../custom-property */ "./lib/mol-model/custom-property.js");
/* harmony import */ var _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ../../mol-util/param-definition */ "./lib/mol-util/param-definition.js");
/* harmony import */ var _mol_util_number__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ../../mol-util/number */ "./lib/mol-util/number.js");
/**
 * Copyright (c) 2020 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */










var Volume;
(function (Volume) {
    function is(x) {
        var _a, _b, _c, _d;
        // TODO: improve
        return (((_d = (_c = (_b = (_a = x === null || x === void 0 ? void 0 : x.grid) === null || _a === void 0 ? void 0 : _a.cells) === null || _b === void 0 ? void 0 : _b.space) === null || _c === void 0 ? void 0 : _c.dimensions) === null || _d === void 0 ? void 0 : _d.length) && (x === null || x === void 0 ? void 0 : x.sourceData) && (x === null || x === void 0 ? void 0 : x.customProperties) && (x === null || x === void 0 ? void 0 : x._propertyData));
    }
    Volume.is = is;
    var IsoValue;
    (function (IsoValue) {
        function areSame(a, b, stats) {
            return Object(_mol_math_linear_algebra_3d_common__WEBPACK_IMPORTED_MODULE_6__["equalEps"])(toAbsolute(a, stats).absoluteValue, toAbsolute(b, stats).absoluteValue, stats.sigma / 100);
        }
        IsoValue.areSame = areSame;
        function absolute(value) { return { kind: 'absolute', absoluteValue: value }; }
        IsoValue.absolute = absolute;
        function relative(value) { return { kind: 'relative', relativeValue: value }; }
        IsoValue.relative = relative;
        function calcAbsolute(stats, relativeValue) {
            return relativeValue * stats.sigma + stats.mean;
        }
        IsoValue.calcAbsolute = calcAbsolute;
        function calcRelative(stats, absoluteValue) {
            return stats.sigma === 0 ? 0 : ((absoluteValue - stats.mean) / stats.sigma);
        }
        IsoValue.calcRelative = calcRelative;
        function toAbsolute(value, stats) {
            return value.kind === 'absolute' ? value : { kind: 'absolute', absoluteValue: IsoValue.calcAbsolute(stats, value.relativeValue) };
        }
        IsoValue.toAbsolute = toAbsolute;
        function toRelative(value, stats) {
            return value.kind === 'relative' ? value : { kind: 'relative', relativeValue: IsoValue.calcRelative(stats, value.absoluteValue) };
        }
        IsoValue.toRelative = toRelative;
        function toString(value) {
            return value.kind === 'relative'
                ? value.relativeValue.toFixed(2) + " \u03C3"
                : "" + value.absoluteValue.toPrecision(4);
        }
        IsoValue.toString = toString;
    })(IsoValue = Volume.IsoValue || (Volume.IsoValue = {}));
    var defaultStats = { min: -1, max: 1, mean: 0, sigma: 0.1 };
    function createIsoValueParam(defaultValue, stats) {
        var sts = stats || defaultStats;
        var min = sts.min, max = sts.max, mean = sts.mean, sigma = sts.sigma;
        // using ceil/floor could lead to "ouf of bounds" when converting
        var relMin = (min - mean) / sigma;
        var relMax = (max - mean) / sigma;
        var def = defaultValue;
        if (defaultValue.kind === 'absolute') {
            if (defaultValue.absoluteValue < min)
                def = Volume.IsoValue.absolute(min);
            else if (defaultValue.absoluteValue > max)
                def = Volume.IsoValue.absolute(max);
        }
        else {
            if (defaultValue.relativeValue < relMin)
                def = Volume.IsoValue.relative(relMin);
            else if (defaultValue.relativeValue > relMax)
                def = Volume.IsoValue.relative(relMax);
        }
        return _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_8__["ParamDefinition"].Conditioned(def, {
            'absolute': _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_8__["ParamDefinition"].Converted(function (v) { return Volume.IsoValue.toAbsolute(v, _grid__WEBPACK_IMPORTED_MODULE_0__["Grid"].One.stats).absoluteValue; }, function (v) { return Volume.IsoValue.absolute(v); }, _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_8__["ParamDefinition"].Numeric(mean, { min: min, max: max, step: Object(_mol_util_number__WEBPACK_IMPORTED_MODULE_9__["toPrecision"])(sigma / 100, 2) })),
            'relative': _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_8__["ParamDefinition"].Converted(function (v) { return Volume.IsoValue.toRelative(v, _grid__WEBPACK_IMPORTED_MODULE_0__["Grid"].One.stats).relativeValue; }, function (v) { return Volume.IsoValue.relative(v); }, _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_8__["ParamDefinition"].Numeric(Math.min(1, relMax), { min: relMin, max: relMax, step: Object(_mol_util_number__WEBPACK_IMPORTED_MODULE_9__["toPrecision"])(Math.round(((max - min) / sigma)) / 100, 2) }))
        }, function (v) { return v.kind === 'absolute' ? 'absolute' : 'relative'; }, function (v, c) { return c === 'absolute' ? Volume.IsoValue.toAbsolute(v, sts) : Volume.IsoValue.toRelative(v, sts); }, { isEssential: true });
    }
    Volume.createIsoValueParam = createIsoValueParam;
    Volume.IsoValueParam = createIsoValueParam(Volume.IsoValue.relative(2));
    Volume.One = {
        label: '',
        grid: _grid__WEBPACK_IMPORTED_MODULE_0__["Grid"].One,
        sourceData: { kind: '', name: '', data: {} },
        customProperties: new _custom_property__WEBPACK_IMPORTED_MODULE_7__["CustomProperties"](),
        _propertyData: Object.create(null),
    };
    function areEquivalent(volA, volB) {
        return _grid__WEBPACK_IMPORTED_MODULE_0__["Grid"].areEquivalent(volA.grid, volB.grid);
    }
    Volume.areEquivalent = areEquivalent;
    function isEmpty(vol) {
        return _grid__WEBPACK_IMPORTED_MODULE_0__["Grid"].isEmpty(vol.grid);
    }
    Volume.isEmpty = isEmpty;
    function isOrbitals(volume) {
        if (!_mol_model_formats_volume_cube__WEBPACK_IMPORTED_MODULE_5__["CubeFormat"].is(volume.sourceData))
            return false;
        return volume.sourceData.data.header.orbitals;
    }
    Volume.isOrbitals = isOrbitals;
    function Loci(volume) { return { kind: 'volume-loci', volume: volume }; }
    Volume.Loci = Loci;
    function isLoci(x) { return !!x && x.kind === 'volume-loci'; }
    Volume.isLoci = isLoci;
    function areLociEqual(a, b) { return a.volume === b.volume; }
    Volume.areLociEqual = areLociEqual;
    function isLociEmpty(loci) { return _grid__WEBPACK_IMPORTED_MODULE_0__["Grid"].isEmpty(loci.volume.grid); }
    Volume.isLociEmpty = isLociEmpty;
    function getBoundingSphere(volume, boundingSphere) {
        return _grid__WEBPACK_IMPORTED_MODULE_0__["Grid"].getBoundingSphere(volume.grid, boundingSphere);
    }
    Volume.getBoundingSphere = getBoundingSphere;
    var Isosurface;
    (function (Isosurface) {
        function Loci(volume, isoValue) { return { kind: 'isosurface-loci', volume: volume, isoValue: isoValue }; }
        Isosurface.Loci = Loci;
        function isLoci(x) { return !!x && x.kind === 'isosurface-loci'; }
        Isosurface.isLoci = isLoci;
        function areLociEqual(a, b) { return a.volume === b.volume && Volume.IsoValue.areSame(a.isoValue, b.isoValue, a.volume.grid.stats); }
        Isosurface.areLociEqual = areLociEqual;
        function isLociEmpty(loci) { return loci.volume.grid.cells.data.length === 0; }
        Isosurface.isLociEmpty = isLociEmpty;
        function getBoundingSphere(volume, isoValue, boundingSphere) {
            // TODO get bounding sphere for subgrid with values >= isoValue
            return Volume.getBoundingSphere(volume, boundingSphere);
        }
        Isosurface.getBoundingSphere = getBoundingSphere;
    })(Isosurface = Volume.Isosurface || (Volume.Isosurface = {}));
    var Cell;
    (function (Cell) {
        function Loci(volume, indices) { return { kind: 'cell-loci', volume: volume, indices: indices }; }
        Cell.Loci = Loci;
        function isLoci(x) { return !!x && x.kind === 'cell-loci'; }
        Cell.isLoci = isLoci;
        function areLociEqual(a, b) { return a.volume === b.volume && _mol_data_int__WEBPACK_IMPORTED_MODULE_1__["OrderedSet"].areEqual(a.indices, b.indices); }
        Cell.areLociEqual = areLociEqual;
        function isLociEmpty(loci) { return _mol_data_int__WEBPACK_IMPORTED_MODULE_1__["OrderedSet"].size(loci.indices) === 0; }
        Cell.isLociEmpty = isLociEmpty;
        var boundaryHelper = new _mol_math_geometry_boundary_helper__WEBPACK_IMPORTED_MODULE_4__["BoundaryHelper"]('98');
        var tmpBoundaryPos = Object(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_3__["Vec3"])();
        function getBoundingSphere(volume, indices, boundingSphere) {
            boundaryHelper.reset();
            var transform = _grid__WEBPACK_IMPORTED_MODULE_0__["Grid"].getGridToCartesianTransform(volume.grid);
            var getCoords = volume.grid.cells.space.getCoords;
            for (var i = 0, _i = _mol_data_int__WEBPACK_IMPORTED_MODULE_1__["OrderedSet"].size(indices); i < _i; i++) {
                var o = _mol_data_int__WEBPACK_IMPORTED_MODULE_1__["OrderedSet"].getAt(indices, i);
                getCoords(o, tmpBoundaryPos);
                _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_3__["Vec3"].transformMat4(tmpBoundaryPos, tmpBoundaryPos, transform);
                boundaryHelper.includePosition(tmpBoundaryPos);
            }
            boundaryHelper.finishedIncludeStep();
            for (var i = 0, _i = _mol_data_int__WEBPACK_IMPORTED_MODULE_1__["OrderedSet"].size(indices); i < _i; i++) {
                var o = _mol_data_int__WEBPACK_IMPORTED_MODULE_1__["OrderedSet"].getAt(indices, i);
                getCoords(o, tmpBoundaryPos);
                _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_3__["Vec3"].transformMat4(tmpBoundaryPos, tmpBoundaryPos, transform);
                boundaryHelper.radiusPosition(tmpBoundaryPos);
            }
            var bs = boundaryHelper.getSphere(boundingSphere);
            return _mol_math_geometry__WEBPACK_IMPORTED_MODULE_2__["Sphere3D"].expand(bs, bs, _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_3__["Mat4"].getMaxScaleOnAxis(transform) * 10);
        }
        Cell.getBoundingSphere = getBoundingSphere;
    })(Cell = Volume.Cell || (Volume.Cell = {}));
})(Volume || (Volume = {}));
//# sourceMappingURL=volume.js.map

/***/ }),

/***/ "./lib/mol-plugin-state/actions.js":
/*!*****************************************!*\
  !*** ./lib/mol-plugin-state/actions.js ***!
  \*****************************************/
/*! exports provided: StateActions */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "StateActions", function() { return StateActions; });
/* harmony import */ var _actions_structure__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./actions/structure */ "./lib/mol-plugin-state/actions/structure.js");
/* harmony import */ var _actions_volume__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./actions/volume */ "./lib/mol-plugin-state/actions/volume.js");
/* harmony import */ var _actions_file__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./actions/file */ "./lib/mol-plugin-state/actions/file.js");
/**
 * Copyright (c) 2019 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author David Sehnal <david.sehnal@gmail.com>
 */



var StateActions = {
    Structure: _actions_structure__WEBPACK_IMPORTED_MODULE_0__,
    Volume: _actions_volume__WEBPACK_IMPORTED_MODULE_1__,
    DataFormat: _actions_file__WEBPACK_IMPORTED_MODULE_2__
};
//# sourceMappingURL=actions.js.map

/***/ }),

/***/ "./lib/mol-plugin-state/actions/file.js":
/*!**********************************************!*\
  !*** ./lib/mol-plugin-state/actions/file.js ***!
  \**********************************************/
/*! exports provided: OpenFiles, DownloadFile */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "OpenFiles", function() { return OpenFiles; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DownloadFile", function() { return DownloadFile; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _mol_state__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../mol-state */ "./lib/mol-state/index.js");
/* harmony import */ var _mol_task__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../mol-task */ "./lib/mol-task/index.js");
/* harmony import */ var _mol_util_file_info__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../mol-util/file-info */ "./lib/mol-util/file-info.js");
/* harmony import */ var _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../mol-util/param-definition */ "./lib/mol-util/param-definition.js");
/* harmony import */ var _objects__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../objects */ "./lib/mol-plugin-state/objects.js");
/**
 * Copyright (c) 2019-2020 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */






var OpenFiles = _mol_state__WEBPACK_IMPORTED_MODULE_1__["StateAction"].build({
    display: { name: 'Open Files', description: 'Load one or more files and optionally create default visuals' },
    from: _objects__WEBPACK_IMPORTED_MODULE_5__["PluginStateObject"].Root,
    params: function (a, ctx) {
        var _a = ctx.dataFormats, extensions = _a.extensions, options = _a.options;
        return {
            files: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_4__["ParamDefinition"].FileList({ accept: Array.from(extensions.values()).map(function (e) { return "." + e; }).join(',') + ',.gz,.zip', multiple: true }),
            format: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_4__["ParamDefinition"].MappedStatic('auto', {
                auto: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_4__["ParamDefinition"].EmptyGroup(),
                specific: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_4__["ParamDefinition"].Select(options[0][0], options)
            }),
            visuals: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_4__["ParamDefinition"].Boolean(true, { description: 'Add default visuals' }),
        };
    }
})(function (_a, plugin) {
    var params = _a.params, state = _a.state;
    return _mol_task__WEBPACK_IMPORTED_MODULE_2__["Task"].create('Open Files', function (taskCtx) { return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"])(void 0, void 0, void 0, function () {
        return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__generator"])(this, function (_a) {
            switch (_a.label) {
                case 0:
                    plugin.behaviors.layout.leftPanelTabName.next('data');
                    return [4 /*yield*/, state.transaction(function () { return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"])(void 0, void 0, void 0, function () {
                            var _i, _a, file, info, isBinary, data, provider, parsed, e_1;
                            var _b, _c;
                            return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__generator"])(this, function (_d) {
                                switch (_d.label) {
                                    case 0:
                                        if (params.files === null) {
                                            plugin.log.error('No file(s) selected');
                                            return [2 /*return*/];
                                        }
                                        _i = 0, _a = params.files;
                                        _d.label = 1;
                                    case 1:
                                        if (!(_i < _a.length)) return [3 /*break*/, 9];
                                        file = _a[_i];
                                        _d.label = 2;
                                    case 2:
                                        _d.trys.push([2, 7, , 8]);
                                        info = Object(_mol_util_file_info__WEBPACK_IMPORTED_MODULE_3__["getFileInfo"])(file.file);
                                        isBinary = plugin.dataFormats.binaryExtensions.has(info.ext);
                                        return [4 /*yield*/, plugin.builders.data.readFile({ file: file, isBinary: isBinary })];
                                    case 3:
                                        data = (_d.sent()).data;
                                        provider = params.format.name === 'auto'
                                            ? plugin.dataFormats.auto(info, (_b = data.cell) === null || _b === void 0 ? void 0 : _b.obj)
                                            : plugin.dataFormats.get(params.format.params);
                                        if (!provider) {
                                            plugin.log.warn("OpenFiles: could not find data provider for '" + info.name + "." + info.ext + "'");
                                            return [3 /*break*/, 8];
                                        }
                                        return [4 /*yield*/, provider.parse(plugin, data)];
                                    case 4:
                                        parsed = _d.sent();
                                        if (!params.visuals) return [3 /*break*/, 6];
                                        return [4 /*yield*/, ((_c = provider.visuals) === null || _c === void 0 ? void 0 : _c.call(provider, plugin, parsed))];
                                    case 5:
                                        _d.sent();
                                        _d.label = 6;
                                    case 6: return [3 /*break*/, 8];
                                    case 7:
                                        e_1 = _d.sent();
                                        plugin.log.error(e_1);
                                        return [3 /*break*/, 8];
                                    case 8:
                                        _i++;
                                        return [3 /*break*/, 1];
                                    case 9: return [2 /*return*/];
                                }
                            });
                        }); }).runInContext(taskCtx)];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    }); });
});
var DownloadFile = _mol_state__WEBPACK_IMPORTED_MODULE_1__["StateAction"].build({
    display: { name: 'Download File', description: 'Load one or more file from an URL' },
    from: _objects__WEBPACK_IMPORTED_MODULE_5__["PluginStateObject"].Root,
    params: function (a, ctx) {
        var options = ctx.dataFormats.options;
        return {
            url: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_4__["ParamDefinition"].Url(''),
            format: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_4__["ParamDefinition"].Select(options[0][0], options),
            isBinary: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_4__["ParamDefinition"].Boolean(false),
            visuals: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_4__["ParamDefinition"].Boolean(true, { description: 'Add default visuals' }),
        };
    }
})(function (_a, plugin) {
    var params = _a.params, state = _a.state;
    return _mol_task__WEBPACK_IMPORTED_MODULE_2__["Task"].create('Open Files', function (taskCtx) { return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"])(void 0, void 0, void 0, function () {
        return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__generator"])(this, function (_a) {
            switch (_a.label) {
                case 0:
                    plugin.behaviors.layout.leftPanelTabName.next('data');
                    return [4 /*yield*/, state.transaction(function () { return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"])(void 0, void 0, void 0, function () {
                            var provider, data, parsed, e_2;
                            var _a;
                            return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__generator"])(this, function (_b) {
                                switch (_b.label) {
                                    case 0:
                                        _b.trys.push([0, 5, , 6]);
                                        provider = plugin.dataFormats.get(params.format);
                                        if (!provider) {
                                            plugin.log.warn("DownloadFile: could not find data provider for '" + params.format + "'");
                                            return [2 /*return*/];
                                        }
                                        return [4 /*yield*/, plugin.builders.data.download({ url: params.url, isBinary: params.isBinary })];
                                    case 1:
                                        data = _b.sent();
                                        return [4 /*yield*/, provider.parse(plugin, data)];
                                    case 2:
                                        parsed = _b.sent();
                                        if (!params.visuals) return [3 /*break*/, 4];
                                        return [4 /*yield*/, ((_a = provider.visuals) === null || _a === void 0 ? void 0 : _a.call(provider, plugin, parsed))];
                                    case 3:
                                        _b.sent();
                                        _b.label = 4;
                                    case 4: return [3 /*break*/, 6];
                                    case 5:
                                        e_2 = _b.sent();
                                        plugin.log.error(e_2);
                                        return [3 /*break*/, 6];
                                    case 6: return [2 /*return*/];
                                }
                            });
                        }); }).runInContext(taskCtx)];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    }); });
});
//# sourceMappingURL=file.js.map

/***/ }),

/***/ "./lib/mol-plugin-state/actions/structure.js":
/*!***************************************************!*\
  !*** ./lib/mol-plugin-state/actions/structure.js ***!
  \***************************************************/
/*! exports provided: PdbDownloadProvider, DownloadStructure, UpdateTrajectory, EnableModelCustomProps, EnableStructureCustomProps, AddTrajectory */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "PdbDownloadProvider", function() { return PdbDownloadProvider; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DownloadStructure", function() { return DownloadStructure; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "UpdateTrajectory", function() { return UpdateTrajectory; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "EnableModelCustomProps", function() { return EnableModelCustomProps; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "EnableStructureCustomProps", function() { return EnableStructureCustomProps; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "AddTrajectory", function() { return AddTrajectory; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _mol_state__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../mol-state */ "./lib/mol-state/index.js");
/* harmony import */ var _mol_task__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../mol-task */ "./lib/mol-task/index.js");
/* harmony import */ var _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../mol-util/param-definition */ "./lib/mol-util/param-definition.js");
/* harmony import */ var _builder_structure_representation_preset__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../builder/structure/representation-preset */ "./lib/mol-plugin-state/builder/structure/representation-preset.js");
/* harmony import */ var _formats_trajectory__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../formats/trajectory */ "./lib/mol-plugin-state/formats/trajectory.js");
/* harmony import */ var _helpers_root_structure__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../helpers/root-structure */ "./lib/mol-plugin-state/helpers/root-structure.js");
/* harmony import */ var _objects__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../objects */ "./lib/mol-plugin-state/objects.js");
/* harmony import */ var _transforms__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ../transforms */ "./lib/mol-plugin-state/transforms.js");
/* harmony import */ var _transforms_model__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ../transforms/model */ "./lib/mol-plugin-state/transforms/model.js");
/* harmony import */ var _mol_util_assets__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ../../mol-util/assets */ "./lib/mol-util/assets.js");
/* harmony import */ var _mol_plugin_config__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ../../mol-plugin/config */ "./lib/mol-plugin/config.js");
/**
 * Copyright (c) 2018-2020 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author David Sehnal <david.sehnal@gmail.com>
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */












var DownloadModelRepresentationOptions = function (plugin) { return _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_3__["ParamDefinition"].Group({
    type: _helpers_root_structure__WEBPACK_IMPORTED_MODULE_6__["RootStructureDefinition"].getParams(void 0, 'auto').type,
    representation: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_3__["ParamDefinition"].Select(_builder_structure_representation_preset__WEBPACK_IMPORTED_MODULE_4__["PresetStructureRepresentations"].auto.id, plugin.builders.structure.representation.getPresets().map(function (p) { return [p.id, p.display.name, p.display.group]; }), { description: 'Which representation preset to use.' }),
    representationParams: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_3__["ParamDefinition"].Group(_builder_structure_representation_preset__WEBPACK_IMPORTED_MODULE_4__["StructureRepresentationPresetProvider"].CommonParams, { isHidden: true }),
    asTrajectory: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_3__["ParamDefinition"].Optional(_mol_util_param_definition__WEBPACK_IMPORTED_MODULE_3__["ParamDefinition"].Boolean(false, { description: 'Load all entries into a single trajectory.' }))
}, { isExpanded: false }); };
var PdbDownloadProvider = {
    'rcsb': _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_3__["ParamDefinition"].Group({
        encoding: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_3__["ParamDefinition"].Select('bcif', [['cif', 'cif'], ['bcif', 'bcif']]),
    }, { label: 'RCSB PDB', isFlat: true }),
    'pdbe': _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_3__["ParamDefinition"].Group({
        variant: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_3__["ParamDefinition"].Select('updated-bcif', [['updated-bcif', 'Updated (bcif)'], ['updated', 'Updated'], ['archival', 'Archival']]),
    }, { label: 'PDBe', isFlat: true }),
};

var DownloadStructure = _mol_state__WEBPACK_IMPORTED_MODULE_1__["StateAction"].build({
    from: _objects__WEBPACK_IMPORTED_MODULE_7__["PluginStateObject"].Root,
    display: { name: 'Download Structure', description: 'Load a structure from the provided source and create its representation.' },
    params: function (_, plugin) {
        var options = DownloadModelRepresentationOptions(plugin);
        var defaultPdbProvider = plugin.config.get(_mol_plugin_config__WEBPACK_IMPORTED_MODULE_11__["PluginConfig"].Download.DefaultPdbProvider) || 'pdbe';
        return {
            source: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_3__["ParamDefinition"].MappedStatic('pdb', {
                'pdb': _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_3__["ParamDefinition"].Group({
                    provider: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_3__["ParamDefinition"].Group({
                        id: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_3__["ParamDefinition"].Text('1tqn', { label: 'PDB Id(s)', description: 'One or more comma/space separated PDB ids.' }),
                        server: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_3__["ParamDefinition"].MappedStatic(defaultPdbProvider, PdbDownloadProvider),
                    }, { pivot: 'id' }),
                    options: options
                }, { isFlat: true, label: 'PDB' }),
                'pdb-dev': _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_3__["ParamDefinition"].Group({
                    provider: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_3__["ParamDefinition"].Group({
                        id: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_3__["ParamDefinition"].Text('PDBDEV_00000001', { label: 'PDBDev Id(s)', description: 'One or more comma/space separated ids.' }),
                        encoding: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_3__["ParamDefinition"].Select('bcif', [['cif', 'cif'], ['bcif', 'bcif']]),
                    }, { pivot: 'id' }),
                    options: options
                }, { isFlat: true, label: 'PDBDEV' }),
                'swissmodel': _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_3__["ParamDefinition"].Group({
                    id: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_3__["ParamDefinition"].Text('Q9Y2I8', { label: 'UniProtKB AC(s)', description: 'One or more comma/space separated ACs.' }),
                    options: options
                }, { isFlat: true, label: 'SWISS-MODEL', description: 'Loads the best homology model or experimental structure' }),
                'pubchem': _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_3__["ParamDefinition"].Group({
                    id: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_3__["ParamDefinition"].Text('2244,2245', { label: 'PubChem ID', description: 'One or more comma/space separated IDs.' }),
                    options: options
                }, { isFlat: true, label: 'PubChem', description: 'Loads 3D conformer from PubChem.' }),
                'url': _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_3__["ParamDefinition"].Group({
                    url: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_3__["ParamDefinition"].Url(''),
                    format: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_3__["ParamDefinition"].Select('mmcif', _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_3__["ParamDefinition"].arrayToOptions(_formats_trajectory__WEBPACK_IMPORTED_MODULE_5__["BuiltInTrajectoryFormats"].map(function (f) { return f[0]; }), function (f) { return f; })),
                    isBinary: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_3__["ParamDefinition"].Boolean(false),
                    options: options
                }, { isFlat: true, label: 'URL' })
            })
        };
    }
})(function (_a, plugin) {
    var params = _a.params, state = _a.state;
    return _mol_task__WEBPACK_IMPORTED_MODULE_2__["Task"].create('Download Structure', function (ctx) { return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"])(void 0, void 0, void 0, function () {
        var src, downloadParams, asTrajectory, format, representationPreset, showUnitcell, structure;
        return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__generator"])(this, function (_a) {
            switch (_a.label) {
                case 0:
                    plugin.behaviors.layout.leftPanelTabName.next('data');
                    src = params.source;
                    asTrajectory = false, format = 'mmcif';
                    switch (src.name) {
                        case 'url':
                            downloadParams = [{ url: src.params.url, isBinary: src.params.isBinary }];
                            format = src.params.format;
                            break;
                        case 'pdb':
                            downloadParams = src.params.provider.server.name === 'pdbe'
                                ? src.params.provider.server.params.variant === 'updated'
                                    ? getDownloadParams(src.params.provider.id, function (id) { return "https://www.ebi.ac.uk/pdbe/static/entry/" + id.toLowerCase() + "_updated.cif"; }, function (id) { return "PDBe: " + id + " (updated cif)"; }, false)
                                    : src.params.provider.server.params.variant === 'updated-bcif'
                                        ? getDownloadParams(src.params.provider.id, function (id) { return "https://www.ebi.ac.uk/pdbe/entry-files/download/" + id.toLowerCase() + ".bcif"; }, function (id) { return "PDBe: " + id + " (updated cif)"; }, true)
                                        : getDownloadParams(src.params.provider.id, function (id) { return "https://www.ebi.ac.uk/pdbe/static/entry/" + id.toLowerCase() + ".cif"; }, function (id) { return "PDBe: " + id + " (cif)"; }, false)
                                : src.params.provider.server.params.encoding === 'cif'
                                    ? getDownloadParams(src.params.provider.id, function (id) { return "https://files.rcsb.org/download/" + id.toUpperCase() + ".cif"; }, function (id) { return "RCSB: " + id + " (cif)"; }, false)
                                    : getDownloadParams(src.params.provider.id, function (id) { return "https://models.rcsb.org/" + id.toUpperCase() + ".bcif"; }, function (id) { return "RCSB: " + id + " (bcif)"; }, true);
                            asTrajectory = !!src.params.options.asTrajectory;
                            break;
                        case 'pdb-dev':
                            downloadParams = getDownloadParams(src.params.provider.id, function (id) {
                                var nId = id.toUpperCase().startsWith('PDBDEV_') ? id : "PDBDEV_" + id.padStart(8, '0');
                                return src.params.provider.encoding === 'bcif'
                                    ? "https://pdb-dev.wwpdb.org/bcif/" + nId.toUpperCase() + ".bcif"
                                    : "https://pdb-dev.wwpdb.org/cif/" + nId.toUpperCase() + ".cif";
                            }, function (id) { return id.toUpperCase().startsWith('PDBDEV_') ? id : "PDBDEV_" + id.padStart(8, '0'); }, src.params.provider.encoding === 'bcif');
                            asTrajectory = !!src.params.options.asTrajectory;
                            break;
                        case 'swissmodel':
                            downloadParams = getDownloadParams(src.params.id, function (id) { return "https://swissmodel.expasy.org/repository/uniprot/" + id.toUpperCase() + ".pdb"; }, function (id) { return "SWISS-MODEL: " + id; }, false);
                            asTrajectory = !!src.params.options.asTrajectory;
                            format = 'pdb';
                            break;
                        case 'pubchem':
                            downloadParams = getDownloadParams(src.params.id, function (id) { return "https://pubchem.ncbi.nlm.nih.gov/rest/pug/compound/CID/" + id.trim() + "/record/SDF/?record_type=3d"; }, function (id) { return "PubChem: " + id; }, false);
                            asTrajectory = !!src.params.options.asTrajectory;
                            format = 'mol';
                            break;
                        default: throw new Error(src.name + " not supported.");
                    }
                    representationPreset = params.source.params.options.representation || _builder_structure_representation_preset__WEBPACK_IMPORTED_MODULE_4__["PresetStructureRepresentations"].auto.id;
                    showUnitcell = representationPreset !== _builder_structure_representation_preset__WEBPACK_IMPORTED_MODULE_4__["PresetStructureRepresentations"].empty.id;
                    structure = src.params.options.type.name === 'auto' ? void 0 : src.params.options.type;
                    return [4 /*yield*/, state.transaction(function () { return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"])(void 0, void 0, void 0, function () {
                            var blob, trajectory, _i, downloadParams_1, download, data, trajectory;
                            return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__generator"])(this, function (_a) {
                                switch (_a.label) {
                                    case 0:
                                        if (!(downloadParams.length > 0 && asTrajectory)) return [3 /*break*/, 4];
                                        return [4 /*yield*/, plugin.builders.data.downloadBlob({
                                                sources: downloadParams.map(function (src, i) { return ({ id: '' + i, url: src.url, isBinary: src.isBinary }); }),
                                                maxConcurrency: 6
                                            }, { state: { isGhost: true } })];
                                    case 1:
                                        blob = _a.sent();
                                        return [4 /*yield*/, plugin.builders.structure.parseTrajectory(blob, { formats: downloadParams.map(function (_, i) { return ({ id: '' + i, format: 'cif' }); }) })];
                                    case 2:
                                        trajectory = _a.sent();
                                        return [4 /*yield*/, plugin.builders.structure.hierarchy.applyPreset(trajectory, 'default', {
                                                structure: structure,
                                                showUnitcell: showUnitcell,
                                                representationPreset: representationPreset,
                                                representationPresetParams: params.source.params.options.representationParams
                                            })];
                                    case 3:
                                        _a.sent();
                                        return [3 /*break*/, 10];
                                    case 4:
                                        _i = 0, downloadParams_1 = downloadParams;
                                        _a.label = 5;
                                    case 5:
                                        if (!(_i < downloadParams_1.length)) return [3 /*break*/, 10];
                                        download = downloadParams_1[_i];
                                        return [4 /*yield*/, plugin.builders.data.download(download, { state: { isGhost: true } })];
                                    case 6:
                                        data = _a.sent();
                                        return [4 /*yield*/, plugin.builders.structure.parseTrajectory(data, format)];
                                    case 7:
                                        trajectory = _a.sent();
                                        return [4 /*yield*/, plugin.builders.structure.hierarchy.applyPreset(trajectory, 'default', {
                                                structure: structure,
                                                showUnitcell: showUnitcell,
                                                representationPreset: representationPreset,
                                                representationPresetParams: params.source.params.options.representationParams
                                            })];
                                    case 8:
                                        _a.sent();
                                        _a.label = 9;
                                    case 9:
                                        _i++;
                                        return [3 /*break*/, 5];
                                    case 10: return [2 /*return*/];
                                }
                            });
                        }); }).runInContext(ctx)];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    }); });
});
function getDownloadParams(src, url, label, isBinary) {
    var ids = src.split(/[,\s]/).map(function (id) { return id.trim(); }).filter(function (id) { return !!id && (id.length >= 4 || /^[1-9][0-9]*$/.test(id)); });
    var ret = [];
    for (var _i = 0, ids_1 = ids; _i < ids_1.length; _i++) {
        var id = ids_1[_i];
        ret.push({ url: _mol_util_assets__WEBPACK_IMPORTED_MODULE_10__["Asset"].Url(url(id)), isBinary: isBinary, label: label(id) });
    }
    return ret;
}
var UpdateTrajectory = _mol_state__WEBPACK_IMPORTED_MODULE_1__["StateAction"].build({
    display: { name: 'Update Trajectory' },
    params: {
        action: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_3__["ParamDefinition"].Select('advance', [['advance', 'Advance'], ['reset', 'Reset']]),
        by: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_3__["ParamDefinition"].Optional(_mol_util_param_definition__WEBPACK_IMPORTED_MODULE_3__["ParamDefinition"].Numeric(1, { min: -1, max: 1, step: 1 }))
    }
})(function (_a) {
    var params = _a.params, state = _a.state;
    var models = state.selectQ(function (q) { return q.ofTransformer(_transforms__WEBPACK_IMPORTED_MODULE_8__["StateTransforms"].Model.ModelFromTrajectory); });
    var update = state.build();
    if (params.action === 'reset') {
        for (var _i = 0, models_1 = models; _i < models_1.length; _i++) {
            var m = models_1[_i];
            update.to(m).update({ modelIndex: 0 });
        }
    }
    else {
        var _loop_1 = function (m) {
            var parent_1 = _mol_state__WEBPACK_IMPORTED_MODULE_1__["StateSelection"].findAncestorOfType(state.tree, state.cells, m.transform.ref, _objects__WEBPACK_IMPORTED_MODULE_7__["PluginStateObject"].Molecule.Trajectory);
            if (!parent_1 || !parent_1.obj)
                return "continue";
            var traj = parent_1.obj;
            update.to(m).update(function (old) {
                var modelIndex = (old.modelIndex + params.by) % traj.data.frameCount;
                if (modelIndex < 0)
                    modelIndex += traj.data.frameCount;
                return { modelIndex: modelIndex };
            });
        };
        for (var _b = 0, models_2 = models; _b < models_2.length; _b++) {
            var m = models_2[_b];
            _loop_1(m);
        }
    }
    return state.updateTree(update);
});
var EnableModelCustomProps = _mol_state__WEBPACK_IMPORTED_MODULE_1__["StateAction"].build({
    display: { name: 'Custom Model Properties', description: 'Enable parameters for custom properties of the model.' },
    from: _objects__WEBPACK_IMPORTED_MODULE_7__["PluginStateObject"].Molecule.Model,
    params: function (a, ctx) {
        return ctx.customModelProperties.getParams(a === null || a === void 0 ? void 0 : a.data);
    },
    isApplicable: function (a, t, ctx) {
        return t.transformer !== _transforms_model__WEBPACK_IMPORTED_MODULE_9__["CustomModelProperties"];
    }
})(function (_a, ctx) {
    var ref = _a.ref, params = _a.params;
    return ctx.builders.structure.insertModelProperties(ref, params);
});
var EnableStructureCustomProps = _mol_state__WEBPACK_IMPORTED_MODULE_1__["StateAction"].build({
    display: { name: 'Custom Structure Properties', description: 'Enable parameters for custom properties of the structure.' },
    from: _objects__WEBPACK_IMPORTED_MODULE_7__["PluginStateObject"].Molecule.Structure,
    params: function (a, ctx) {
        return ctx.customStructureProperties.getParams(a === null || a === void 0 ? void 0 : a.data);
    },
    isApplicable: function (a, t, ctx) {
        return t.transformer !== _transforms_model__WEBPACK_IMPORTED_MODULE_9__["CustomStructureProperties"];
    }
})(function (_a, ctx) {
    var ref = _a.ref, params = _a.params;
    return ctx.builders.structure.insertStructureProperties(ref, params);
});
var AddTrajectory = _mol_state__WEBPACK_IMPORTED_MODULE_1__["StateAction"].build({
    display: { name: 'Add Trajectory', description: 'Add trajectory from existing model/topology and coordinates.' },
    from: _objects__WEBPACK_IMPORTED_MODULE_7__["PluginStateObject"].Root,
    params: function (a, ctx) {
        var state = ctx.state.data;
        var models = Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__spreadArrays"])(state.selectQ(function (q) { return q.rootsOfType(_objects__WEBPACK_IMPORTED_MODULE_7__["PluginStateObject"].Molecule.Model); }), state.selectQ(function (q) { return q.rootsOfType(_objects__WEBPACK_IMPORTED_MODULE_7__["PluginStateObject"].Molecule.Topology); }));
        var modelOptions = models.map(function (t) { return [t.transform.ref, t.obj.label]; });
        var coords = state.selectQ(function (q) { return q.rootsOfType(_objects__WEBPACK_IMPORTED_MODULE_7__["PluginStateObject"].Molecule.Coordinates); });
        var coordOptions = coords.map(function (c) { return [c.transform.ref, c.obj.label]; });
        return {
            model: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_3__["ParamDefinition"].Select(modelOptions.length ? modelOptions[0][0] : '', modelOptions),
            coordinates: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_3__["ParamDefinition"].Select(coordOptions.length ? coordOptions[0][0] : '', coordOptions)
        };
    }
})(function (_a, ctx) {
    var params = _a.params, state = _a.state;
    return _mol_task__WEBPACK_IMPORTED_MODULE_2__["Task"].create('Add Trajectory', function (taskCtx) {
        return state.transaction(function () { return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"])(void 0, void 0, void 0, function () {
            var dependsOn, model, structure;
            return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__generator"])(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        dependsOn = [params.model, params.coordinates];
                        model = state.build().toRoot()
                            .apply(_transforms_model__WEBPACK_IMPORTED_MODULE_9__["TrajectoryFromModelAndCoordinates"], {
                            modelRef: params.model,
                            coordinatesRef: params.coordinates
                        }, { dependsOn: dependsOn })
                            .apply(_transforms__WEBPACK_IMPORTED_MODULE_8__["StateTransforms"].Model.ModelFromTrajectory, { modelIndex: 0 });
                        return [4 /*yield*/, state.updateTree(model).runInContext(taskCtx)];
                    case 1:
                        _a.sent();
                        return [4 /*yield*/, ctx.builders.structure.createStructure(model.selector)];
                    case 2:
                        structure = _a.sent();
                        return [4 /*yield*/, ctx.builders.structure.representation.applyPreset(structure, 'auto')];
                    case 3:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        }); }).runInContext(taskCtx);
    });
});
//# sourceMappingURL=structure.js.map

/***/ }),

/***/ "./lib/mol-plugin-state/actions/volume.js":
/*!************************************************!*\
  !*** ./lib/mol-plugin-state/actions/volume.js ***!
  \************************************************/
/*! exports provided: DownloadDensity, AssignColorVolume */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DownloadDensity", function() { return DownloadDensity; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "AssignColorVolume", function() { return AssignColorVolume; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _mol_state__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../mol-state */ "./lib/mol-state/index.js");
/* harmony import */ var _mol_task__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../mol-task */ "./lib/mol-task/index.js");
/* harmony import */ var _mol_util_file_info__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../mol-util/file-info */ "./lib/mol-util/file-info.js");
/* harmony import */ var _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../mol-util/param-definition */ "./lib/mol-util/param-definition.js");
/* harmony import */ var _objects__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../objects */ "./lib/mol-plugin-state/objects.js");
/* harmony import */ var _mol_util_assets__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../../mol-util/assets */ "./lib/mol-util/assets.js");
/* harmony import */ var _transforms__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../transforms */ "./lib/mol-plugin-state/transforms.js");
/**
 * Copyright (c) 2018-2020 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author David Sehnal <david.sehnal@gmail.com>
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */









var DownloadDensity = _mol_state__WEBPACK_IMPORTED_MODULE_1__["StateAction"].build({
    from: _objects__WEBPACK_IMPORTED_MODULE_5__["PluginStateObject"].Root,
    display: { name: 'Download Density', description: 'Load a density from the provided source and create its default visual.' },
    params: function (a, ctx) {
        var options = ctx.dataFormats.options;
        return {
            source: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_4__["ParamDefinition"].MappedStatic('pdb-xray', {
                'pdb-xray': _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_4__["ParamDefinition"].Group({
                    provider: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_4__["ParamDefinition"].Group({
                        id: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_4__["ParamDefinition"].Text('1tqn', { label: 'Id' }),
                        server: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_4__["ParamDefinition"].Select('rcsb', [['pdbe', 'PDBe'], ['rcsb', 'RCSB PDB']]),
                    }, { pivot: 'id' }),
                    type: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_4__["ParamDefinition"].Select('2fofc', [['2fofc', '2Fo-Fc'], ['fofc', 'Fo-Fc']]),
                }, { isFlat: true }),
                'pdb-xray-ds': _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_4__["ParamDefinition"].Group({
                    provider: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_4__["ParamDefinition"].Group({
                        id: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_4__["ParamDefinition"].Text('1tqn', { label: 'Id' }),
                        server: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_4__["ParamDefinition"].Select('pdbe', [['pdbe', 'PDBe'], ['rcsb', 'RCSB PDB']]),
                    }, { pivot: 'id' }),
                    detail: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_4__["ParamDefinition"].Numeric(3, { min: 0, max: 6, step: 1 }, { label: 'Detail' }),
                }, { isFlat: true }),
                'pdb-emd-ds': _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_4__["ParamDefinition"].Group({
                    provider: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_4__["ParamDefinition"].Group({
                        id: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_4__["ParamDefinition"].Text('emd-8004', { label: 'Id' }),
                        server: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_4__["ParamDefinition"].Select('pdbe', [['pdbe', 'PDBe'], ['rcsb', 'RCSB PDB']]),
                    }, { pivot: 'id' }),
                    detail: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_4__["ParamDefinition"].Numeric(3, { min: 0, max: 6, step: 1 }, { label: 'Detail' }),
                }, { isFlat: true }),
                'url': _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_4__["ParamDefinition"].Group({
                    url: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_4__["ParamDefinition"].Url(''),
                    isBinary: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_4__["ParamDefinition"].Boolean(false),
                    format: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_4__["ParamDefinition"].Select('auto', options),
                }, { isFlat: true })
            }, {
                options: [
                    ['pdb-xray', 'PDB X-ray maps'],
                    ['pdb-emd-ds', 'PDB EMD Density Server'],
                    ['pdb-xray-ds', 'PDB X-ray Density Server'],
                    ['url', 'URL']
                ]
            })
        };
    }
})(function (_a, plugin) {
    var params = _a.params;
    return _mol_task__WEBPACK_IMPORTED_MODULE_2__["Task"].create('Download Density', function (taskCtx) { return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"])(void 0, void 0, void 0, function () {
        var src, downloadParams, provider, data, entryId, volumes;
        var _a, _b;
        return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__generator"])(this, function (_c) {
            switch (_c.label) {
                case 0:
                    src = params.source;
                    switch (src.name) {
                        case 'url':
                            downloadParams = src.params;
                            break;
                        case 'pdb-xray':
                            downloadParams = src.params.provider.server === 'pdbe' ? {
                                url: _mol_util_assets__WEBPACK_IMPORTED_MODULE_6__["Asset"].Url(src.params.type === '2fofc'
                                    ? "http://www.ebi.ac.uk/pdbe/coordinates/files/" + src.params.provider.id.toLowerCase() + ".ccp4"
                                    : "http://www.ebi.ac.uk/pdbe/coordinates/files/" + src.params.provider.id.toLowerCase() + "_diff.ccp4"),
                                isBinary: true,
                                label: "PDBe X-ray map: " + src.params.provider.id
                            } : {
                                url: _mol_util_assets__WEBPACK_IMPORTED_MODULE_6__["Asset"].Url(src.params.type === '2fofc'
                                    ? "https://edmaps.rcsb.org/maps/" + src.params.provider.id.toLowerCase() + "_2fofc.dsn6"
                                    : "https://edmaps.rcsb.org/maps/" + src.params.provider.id.toLowerCase() + "_fofc.dsn6"),
                                isBinary: true,
                                label: "RCSB X-ray map: " + src.params.provider.id
                            };
                            break;
                        case 'pdb-emd-ds':
                            downloadParams = src.params.provider.server === 'pdbe' ? {
                                url: _mol_util_assets__WEBPACK_IMPORTED_MODULE_6__["Asset"].Url("https://www.ebi.ac.uk/pdbe/densities/emd/" + src.params.provider.id.toLowerCase() + "/cell?detail=" + src.params.detail),
                                isBinary: true,
                                label: "PDBe EMD Density Server: " + src.params.provider.id
                            } : {
                                url: _mol_util_assets__WEBPACK_IMPORTED_MODULE_6__["Asset"].Url("https://maps.rcsb.org/em/" + src.params.provider.id.toLowerCase() + "/cell?detail=" + src.params.detail),
                                isBinary: true,
                                label: "RCSB PDB EMD Density Server: " + src.params.provider.id
                            };
                            break;
                        case 'pdb-xray-ds':
                            downloadParams = src.params.provider.server === 'pdbe' ? {
                                url: _mol_util_assets__WEBPACK_IMPORTED_MODULE_6__["Asset"].Url("https://www.ebi.ac.uk/pdbe/densities/x-ray/" + src.params.provider.id.toLowerCase() + "/cell?detail=" + src.params.detail),
                                isBinary: true,
                                label: "PDBe X-ray Density Server: " + src.params.provider.id
                            } : {
                                url: _mol_util_assets__WEBPACK_IMPORTED_MODULE_6__["Asset"].Url("https://maps.rcsb.org/x-ray/" + src.params.provider.id.toLowerCase() + "/cell?detail=" + src.params.detail),
                                isBinary: true,
                                label: "RCSB PDB X-ray Density Server: " + src.params.provider.id
                            };
                            break;
                        default: throw new Error(src.name + " not supported.");
                    }
                    return [4 /*yield*/, plugin.builders.data.download(downloadParams)];
                case 1:
                    data = _c.sent();
                    entryId = undefined;
                    switch (src.name) {
                        case 'url':
                            downloadParams = src.params;
                            provider = src.params.format === 'auto' ? plugin.dataFormats.auto(Object(_mol_util_file_info__WEBPACK_IMPORTED_MODULE_3__["getFileInfo"])(_mol_util_assets__WEBPACK_IMPORTED_MODULE_6__["Asset"].getUrl(downloadParams.url)), (_a = data.cell) === null || _a === void 0 ? void 0 : _a.obj) : plugin.dataFormats.get(src.params.format);
                            break;
                        case 'pdb-xray':
                            entryId = src.params.provider.id;
                            provider = src.params.provider.server === 'pdbe'
                                ? plugin.dataFormats.get('ccp4')
                                : plugin.dataFormats.get('dsn6');
                            break;
                        case 'pdb-emd-ds':
                        case 'pdb-xray-ds':
                            entryId = src.params.provider.id;
                            provider = plugin.dataFormats.get('dscif');
                            break;
                        default: throw new Error(src.name + " not supported.");
                    }
                    if (!provider) {
                        plugin.log.warn('DownloadDensity: Format provider not found.');
                        return [2 /*return*/];
                    }
                    return [4 /*yield*/, provider.parse(plugin, data, { entryId: entryId })];
                case 2:
                    volumes = _c.sent();
                    return [4 /*yield*/, ((_b = provider.visuals) === null || _b === void 0 ? void 0 : _b.call(provider, plugin, volumes))];
                case 3:
                    _c.sent();
                    return [2 /*return*/];
            }
        });
    }); });
});
var AssignColorVolume = _mol_state__WEBPACK_IMPORTED_MODULE_1__["StateAction"].build({
    display: { name: 'Assign Volume Colors', description: 'Assigns another volume to be available for coloring.' },
    from: _objects__WEBPACK_IMPORTED_MODULE_5__["PluginStateObject"].Volume.Data,
    isApplicable: function (a) { return !a.data.colorVolume; },
    params: function (a, plugin) {
        var cells = plugin.state.data.select(_mol_state__WEBPACK_IMPORTED_MODULE_1__["StateSelection"].Generators.root.subtree().ofType(_objects__WEBPACK_IMPORTED_MODULE_5__["PluginStateObject"].Volume.Data).filter(function (cell) { var _a; return !!cell.obj && !((_a = cell.obj) === null || _a === void 0 ? void 0 : _a.data.colorVolume) && cell.obj !== a; }));
        if (cells.length === 0)
            return { ref: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_4__["ParamDefinition"].Text('', { isHidden: true, label: 'Volume' }) };
        return { ref: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_4__["ParamDefinition"].Select(cells[0].transform.ref, cells.map(function (c) { return [c.transform.ref, c.obj.label]; }), { label: 'Volume' }) };
    }
})(function (_a, plugin) {
    var ref = _a.ref, params = _a.params, state = _a.state;
    return plugin.build().to(ref).apply(_transforms__WEBPACK_IMPORTED_MODULE_7__["StateTransforms"].Volume.AssignColorVolume, { ref: params.ref }, { dependsOn: [params.ref] }).commit();
});
//# sourceMappingURL=volume.js.map

/***/ }),

/***/ "./lib/mol-plugin-state/animation/built-in/assembly-unwind.js":
/*!********************************************************************!*\
  !*** ./lib/mol-plugin-state/animation/built-in/assembly-unwind.js ***!
  \********************************************************************/
/*! exports provided: AnimateAssemblyUnwind */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "AnimateAssemblyUnwind", function() { return AnimateAssemblyUnwind; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _model__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../model */ "./lib/mol-plugin-state/animation/model.js");
/* harmony import */ var _objects__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../objects */ "./lib/mol-plugin-state/objects.js");
/* harmony import */ var _transforms__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../transforms */ "./lib/mol-plugin-state/transforms.js");
/* harmony import */ var _mol_state__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../../mol-state */ "./lib/mol-state/index.js");
/* harmony import */ var _mol_plugin_commands__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../../mol-plugin/commands */ "./lib/mol-plugin/commands.js");
/* harmony import */ var _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../../../mol-util/param-definition */ "./lib/mol-util/param-definition.js");
/**
 * Copyright (c) 2019 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author David Sehnal <david.sehnal@gmail.com>
 */







var AnimateAssemblyUnwind = _model__WEBPACK_IMPORTED_MODULE_1__["PluginStateAnimation"].create({
    name: 'built-in.animate-assembly-unwind',
    display: { name: 'Unwind Assembly' },
    isExportable: true,
    params: function (plugin) {
        var targets = [['all', 'All']];
        var structures = plugin.state.data.select(_mol_state__WEBPACK_IMPORTED_MODULE_4__["StateSelection"].Generators.rootsOfType(_objects__WEBPACK_IMPORTED_MODULE_2__["PluginStateObject"].Molecule.Structure));
        for (var _i = 0, structures_1 = structures; _i < structures_1.length; _i++) {
            var s = structures_1[_i];
            targets.push([s.transform.ref, s.obj.data.models[0].label]);
        }
        return {
            durationInMs: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_6__["ParamDefinition"].Numeric(3000, { min: 100, max: 10000, step: 100 }),
            playOnce: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_6__["ParamDefinition"].Boolean(false),
            target: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_6__["ParamDefinition"].Select(targets[0][0], targets)
        };
    },
    canApply: function (plugin) {
        var state = plugin.state.data;
        var root = _mol_state__WEBPACK_IMPORTED_MODULE_4__["StateTransform"].RootRef;
        var reprs = state.select(_mol_state__WEBPACK_IMPORTED_MODULE_4__["StateSelection"].Generators.ofType(_objects__WEBPACK_IMPORTED_MODULE_2__["PluginStateObject"].Molecule.Structure.Representation3D, root));
        return { canApply: reprs.length > 0 };
    },
    getDuration: function (params) {
        return {
            kind: 'fixed',
            durationMs: params.durationInMs
        };
    },
    initialState: function () { return ({ t: 0 }); },
    setup: function (params, _, plugin) {
        var state = plugin.state.data;
        var root = !params.target || params.target === 'all' ? _mol_state__WEBPACK_IMPORTED_MODULE_4__["StateTransform"].RootRef : params.target;
        var reprs = state.select(_mol_state__WEBPACK_IMPORTED_MODULE_4__["StateSelection"].Generators.ofType(_objects__WEBPACK_IMPORTED_MODULE_2__["PluginStateObject"].Molecule.Structure.Representation3D, root));
        var update = state.build();
        var changed = false;
        for (var _i = 0, reprs_1 = reprs; _i < reprs_1.length; _i++) {
            var r = reprs_1[_i];
            var unwinds = state.select(_mol_state__WEBPACK_IMPORTED_MODULE_4__["StateSelection"].Generators.ofTransformer(_transforms__WEBPACK_IMPORTED_MODULE_3__["StateTransforms"].Representation.UnwindStructureAssemblyRepresentation3D, r.transform.ref));
            if (unwinds.length > 0)
                continue;
            changed = true;
            update.to(r)
                .apply(_transforms__WEBPACK_IMPORTED_MODULE_3__["StateTransforms"].Representation.UnwindStructureAssemblyRepresentation3D, { t: 0 }, { tags: 'animate-assembly-unwind' });
        }
        if (!changed)
            return;
        return update.commit({ doNotUpdateCurrent: true });
    },
    teardown: function (_, __, plugin) {
        var state = plugin.state.data;
        var reprs = state.select(_mol_state__WEBPACK_IMPORTED_MODULE_4__["StateSelection"].Generators.ofType(_objects__WEBPACK_IMPORTED_MODULE_2__["PluginStateObject"].Molecule.Structure.Representation3DState)
            .withTag('animate-assembly-unwind'));
        if (reprs.length === 0)
            return;
        var update = state.build();
        for (var _i = 0, reprs_2 = reprs; _i < reprs_2.length; _i++) {
            var r = reprs_2[_i];
            update.delete(r.transform.ref);
        }
        return update.commit();
    },
    apply: function (animState, t, ctx) {
        return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"])(this, void 0, void 0, function () {
            var state, root, anims, update, d, newTime, finished, _i, anims_1, m;
            return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__generator"])(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        state = ctx.plugin.state.data;
                        root = !ctx.params.target || ctx.params.target === 'all' ? _mol_state__WEBPACK_IMPORTED_MODULE_4__["StateTransform"].RootRef : ctx.params.target;
                        anims = state.select(_mol_state__WEBPACK_IMPORTED_MODULE_4__["StateSelection"].Generators.ofTransformer(_transforms__WEBPACK_IMPORTED_MODULE_3__["StateTransforms"].Representation.UnwindStructureAssemblyRepresentation3D, root));
                        if (anims.length === 0) {
                            return [2 /*return*/, { kind: 'finished' }];
                        }
                        update = state.build();
                        d = (t.current - t.lastApplied) / ctx.params.durationInMs;
                        newTime = (animState.t + d), finished = false;
                        if (ctx.params.playOnce && newTime >= 1) {
                            finished = true;
                            newTime = 1;
                        }
                        else {
                            newTime = newTime % 1;
                        }
                        for (_i = 0, anims_1 = anims; _i < anims_1.length; _i++) {
                            m = anims_1[_i];
                            update.to(m).update({ t: newTime });
                        }
                        return [4 /*yield*/, _mol_plugin_commands__WEBPACK_IMPORTED_MODULE_5__["PluginCommands"].State.Update(ctx.plugin, { state: state, tree: update, options: { doNotLogTiming: true } })];
                    case 1:
                        _a.sent();
                        if (finished)
                            return [2 /*return*/, { kind: 'finished' }];
                        return [2 /*return*/, { kind: 'next', state: { t: newTime } }];
                }
            });
        });
    }
});
//# sourceMappingURL=assembly-unwind.js.map

/***/ }),

/***/ "./lib/mol-plugin-state/animation/built-in/camera-spin.js":
/*!****************************************************************!*\
  !*** ./lib/mol-plugin-state/animation/built-in/camera-spin.js ***!
  \****************************************************************/
/*! exports provided: AnimateCameraSpin */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "AnimateCameraSpin", function() { return AnimateCameraSpin; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _mol_math_interpolate__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../../mol-math/interpolate */ "./lib/mol-math/interpolate.js");
/* harmony import */ var _mol_math_linear_algebra_3d__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../../mol-math/linear-algebra/3d */ "./lib/mol-math/linear-algebra/3d.js");
/* harmony import */ var _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../../mol-util/param-definition */ "./lib/mol-util/param-definition.js");
/* harmony import */ var _model__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../model */ "./lib/mol-plugin-state/animation/model.js");
/**
 * Copyright (c) 2020 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author David Sehnal <david.sehnal@gmail.com>
 */





var _dir = Object(_mol_math_linear_algebra_3d__WEBPACK_IMPORTED_MODULE_2__["Vec3"])(), _axis = Object(_mol_math_linear_algebra_3d__WEBPACK_IMPORTED_MODULE_2__["Vec3"])(), _rot = Object(_mol_math_linear_algebra_3d__WEBPACK_IMPORTED_MODULE_2__["Quat"])();
var AnimateCameraSpin = _model__WEBPACK_IMPORTED_MODULE_4__["PluginStateAnimation"].create({
    name: 'built-in.animate-camera-spin',
    display: { name: 'Camera Spin' },
    isExportable: true,
    params: function () { return ({
        durationInMs: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_3__["ParamDefinition"].Numeric(4000, { min: 100, max: 20000, step: 100 }),
        speed: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_3__["ParamDefinition"].Numeric(1, { min: 1, max: 10, step: 1 }, { description: 'How many times to spin in the specified dutation.' }),
        direction: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_3__["ParamDefinition"].Select('cw', [['cw', 'Clockwise'], ['ccw', 'Counter Clockwise']], { cycle: true })
    }); },
    initialState: function (_, ctx) { var _a; return ({ snapshot: (_a = ctx.canvas3d) === null || _a === void 0 ? void 0 : _a.camera.getSnapshot() }); },
    getDuration: function (p) { return ({ kind: 'fixed', durationMs: p.durationInMs }); },
    teardown: function (_, state, ctx) {
        var _a;
        (_a = ctx.canvas3d) === null || _a === void 0 ? void 0 : _a.requestCameraReset({ snapshot: state.snapshot, durationMs: 0 });
    },
    apply: function (animState, t, ctx) {
        var _a, _b;
        return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"])(this, void 0, void 0, function () {
            var snapshot, phase, angle, position;
            return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__generator"])(this, function (_c) {
                if (t.current === 0) {
                    return [2 /*return*/, { kind: 'next', state: animState }];
                }
                snapshot = animState.snapshot;
                if (snapshot.radiusMax < 0.0001) {
                    return [2 /*return*/, { kind: 'finished' }];
                }
                phase = Object(_mol_math_interpolate__WEBPACK_IMPORTED_MODULE_1__["clamp"])(t.current / ctx.params.durationInMs, 0, 1);
                if (phase >= 0.99999) {
                    (_a = ctx.plugin.canvas3d) === null || _a === void 0 ? void 0 : _a.requestCameraReset({ snapshot: snapshot, durationMs: 0 });
                    return [2 /*return*/, { kind: 'finished' }];
                }
                angle = 2 * Math.PI * phase * ctx.params.speed * (ctx.params.direction === 'ccw' ? -1 : 1);
                _mol_math_linear_algebra_3d__WEBPACK_IMPORTED_MODULE_2__["Vec3"].sub(_dir, snapshot.position, snapshot.target);
                _mol_math_linear_algebra_3d__WEBPACK_IMPORTED_MODULE_2__["Vec3"].normalize(_axis, snapshot.up);
                _mol_math_linear_algebra_3d__WEBPACK_IMPORTED_MODULE_2__["Quat"].setAxisAngle(_rot, _axis, angle);
                _mol_math_linear_algebra_3d__WEBPACK_IMPORTED_MODULE_2__["Vec3"].transformQuat(_dir, _dir, _rot);
                position = _mol_math_linear_algebra_3d__WEBPACK_IMPORTED_MODULE_2__["Vec3"].add(Object(_mol_math_linear_algebra_3d__WEBPACK_IMPORTED_MODULE_2__["Vec3"])(), snapshot.target, _dir);
                (_b = ctx.plugin.canvas3d) === null || _b === void 0 ? void 0 : _b.requestCameraReset({ snapshot: Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, snapshot), { position: position }), durationMs: 0 });
                return [2 /*return*/, { kind: 'next', state: animState }];
            });
        });
    }
});
//# sourceMappingURL=camera-spin.js.map

/***/ }),

/***/ "./lib/mol-plugin-state/animation/built-in/model-index.js":
/*!****************************************************************!*\
  !*** ./lib/mol-plugin-state/animation/built-in/model-index.js ***!
  \****************************************************************/
/*! exports provided: AnimateModelIndex */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "AnimateModelIndex", function() { return AnimateModelIndex; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _mol_plugin_commands__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../../mol-plugin/commands */ "./lib/mol-plugin/commands.js");
/* harmony import */ var _mol_state__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../../mol-state */ "./lib/mol-state/index.js");
/* harmony import */ var _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../../mol-util/param-definition */ "./lib/mol-util/param-definition.js");
/* harmony import */ var _objects__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../objects */ "./lib/mol-plugin-state/objects.js");
/* harmony import */ var _transforms__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../transforms */ "./lib/mol-plugin-state/transforms.js");
/* harmony import */ var _model__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../model */ "./lib/mol-plugin-state/animation/model.js");
/**
 * Copyright (c) 2019 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author David Sehnal <david.sehnal@gmail.com>
 */







var AnimateModelIndex = _model__WEBPACK_IMPORTED_MODULE_6__["PluginStateAnimation"].create({
    name: 'built-in.animate-model-index',
    display: { name: 'Animate Trajectory' },
    params: function () { return ({
        mode: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_3__["ParamDefinition"].MappedStatic('palindrome', {
            palindrome: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_3__["ParamDefinition"].Group({}),
            loop: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_3__["ParamDefinition"].Group({}),
            once: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_3__["ParamDefinition"].Group({ direction: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_3__["ParamDefinition"].Select('forward', [['forward', 'Forward'], ['backward', 'Backward']]) }, { isFlat: true })
        }, { options: [['palindrome', 'Palindrome'], ['loop', 'Loop'], ['once', 'Once']] }),
        maxFPS: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_3__["ParamDefinition"].Numeric(15, { min: 1, max: 60, step: 1 })
    }); },
    canApply: function (ctx) {
        var state = ctx.state.data;
        var models = state.select(_mol_state__WEBPACK_IMPORTED_MODULE_2__["StateSelection"].Generators.ofTransformer(_transforms__WEBPACK_IMPORTED_MODULE_5__["StateTransforms"].Model.ModelFromTrajectory));
        for (var _i = 0, models_1 = models; _i < models_1.length; _i++) {
            var m = models_1[_i];
            var parent_1 = _mol_state__WEBPACK_IMPORTED_MODULE_2__["StateSelection"].findAncestorOfType(state.tree, state.cells, m.transform.ref, _objects__WEBPACK_IMPORTED_MODULE_4__["PluginStateObject"].Molecule.Trajectory);
            if (parent_1 && parent_1.obj && parent_1.obj.data.frameCount > 1)
                return { canApply: true };
        }
        return { canApply: false, reason: 'No trajectory to animate' };
    },
    initialState: function () { return ({}); },
    apply: function (animState, t, ctx) {
        return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"])(this, void 0, void 0, function () {
            var state, models, update, params, palindromeDirections, isEnd, allSingles, _loop_1, _i, models_2, m;
            return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__generator"])(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        // limit fps
                        if (t.current > 0 && t.current - t.lastApplied < 1000 / ctx.params.maxFPS) {
                            return [2 /*return*/, { kind: 'skip' }];
                        }
                        state = ctx.plugin.state.data;
                        models = state.select(_mol_state__WEBPACK_IMPORTED_MODULE_2__["StateSelection"].Generators.ofTransformer(_transforms__WEBPACK_IMPORTED_MODULE_5__["StateTransforms"].Model.ModelFromTrajectory));
                        if (models.length === 0) {
                            // nothing more to do here
                            return [2 /*return*/, { kind: 'finished' }];
                        }
                        update = state.build();
                        params = ctx.params;
                        palindromeDirections = animState.palindromeDirections || {};
                        isEnd = false, allSingles = true;
                        _loop_1 = function (m) {
                            var parent_2 = _mol_state__WEBPACK_IMPORTED_MODULE_2__["StateSelection"].findAncestorOfType(state.tree, state.cells, m.transform.ref, _objects__WEBPACK_IMPORTED_MODULE_4__["PluginStateObject"].Molecule.Trajectory);
                            if (!parent_2 || !parent_2.obj)
                                return "continue";
                            var traj = parent_2.obj;
                            if (traj.data.frameCount <= 1)
                                return "continue";
                            update.to(m).update(function (old) {
                                var len = traj.data.frameCount;
                                if (len !== 1) {
                                    allSingles = false;
                                }
                                else {
                                    return old;
                                }
                                var dir = 1;
                                if (params.mode.name === 'once') {
                                    dir = params.mode.params.direction === 'backward' ? -1 : 1;
                                    // if we are at start or end already, do nothing.
                                    if ((dir === -1 && old.modelIndex === 0) || (dir === 1 && old.modelIndex === len - 1)) {
                                        isEnd = true;
                                        return old;
                                    }
                                }
                                else if (params.mode.name === 'palindrome') {
                                    if (old.modelIndex === 0)
                                        dir = 1;
                                    else if (old.modelIndex === len - 1)
                                        dir = -1;
                                    else
                                        dir = palindromeDirections[m.transform.ref] || 1;
                                }
                                palindromeDirections[m.transform.ref] = dir;
                                var modelIndex = (old.modelIndex + dir) % len;
                                if (modelIndex < 0)
                                    modelIndex += len;
                                isEnd = isEnd || (dir === -1 && modelIndex === 0) || (dir === 1 && modelIndex === len - 1);
                                return { modelIndex: modelIndex };
                            });
                        };
                        for (_i = 0, models_2 = models; _i < models_2.length; _i++) {
                            m = models_2[_i];
                            _loop_1(m);
                        }
                        if (!!allSingles) return [3 /*break*/, 2];
                        return [4 /*yield*/, _mol_plugin_commands__WEBPACK_IMPORTED_MODULE_1__["PluginCommands"].State.Update(ctx.plugin, { state: state, tree: update, options: { doNotLogTiming: true } })];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2:
                        if (allSingles || (params.mode.name === 'once' && isEnd))
                            return [2 /*return*/, { kind: 'finished' }];
                        if (params.mode.name === 'palindrome')
                            return [2 /*return*/, { kind: 'next', state: { palindromeDirections: palindromeDirections } }];
                        return [2 /*return*/, { kind: 'next', state: {} }];
                }
            });
        });
    }
});
//# sourceMappingURL=model-index.js.map

/***/ }),

/***/ "./lib/mol-plugin-state/animation/built-in/state-snapshots.js":
/*!********************************************************************!*\
  !*** ./lib/mol-plugin-state/animation/built-in/state-snapshots.js ***!
  \********************************************************************/
/*! exports provided: AnimateStateSnapshots */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "AnimateStateSnapshots", function() { return AnimateStateSnapshots; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _model__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../model */ "./lib/mol-plugin-state/animation/model.js");
/**
 * Copyright (c) 2019 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author David Sehnal <david.sehnal@gmail.com>
 */


function setPartialSnapshot(plugin, entry, first) {
    var _a;
    if (first === void 0) { first = false; }
    return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"])(this, void 0, void 0, function () {
        return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__generator"])(this, function (_b) {
            switch (_b.label) {
                case 0:
                    if (!entry.snapshot.data) return [3 /*break*/, 2];
                    return [4 /*yield*/, plugin.runTask(plugin.state.data.setSnapshot(entry.snapshot.data))];
                case 1:
                    _b.sent();
                    _b.label = 2;
                case 2:
                    if (entry.snapshot.camera) {
                        (_a = plugin.canvas3d) === null || _a === void 0 ? void 0 : _a.requestCameraReset({
                            snapshot: entry.snapshot.camera.current,
                            durationMs: first || entry.snapshot.camera.transitionStyle === 'instant'
                                ? 0 : entry.snapshot.camera.transitionDurationInMs
                        });
                    }
                    return [2 /*return*/];
            }
        });
    });
}
var AnimateStateSnapshots = _model__WEBPACK_IMPORTED_MODULE_1__["PluginStateAnimation"].create({
    name: 'built-in.animate-state-snapshots',
    display: { name: 'State Snapshots' },
    isExportable: true,
    params: function () { return ({}); },
    canApply: function (plugin) {
        var entries = plugin.managers.snapshot.state.entries;
        if (entries.size < 2) {
            return { canApply: false, reason: 'At least 2 states required.' };
        }
        if (entries.some(function (e) { return !!(e === null || e === void 0 ? void 0 : e.snapshot.startAnimation); })) {
            return { canApply: false, reason: 'Nested animations not supported.' };
        }
        return { canApply: plugin.managers.snapshot.state.entries.size > 1 };
    },
    setup: function (_, __, plugin) {
        var pivot = plugin.managers.snapshot.state.entries.get(0);
        setPartialSnapshot(plugin, pivot, true);
    },
    getDuration: function (_, plugin) {
        return {
            kind: 'fixed',
            durationMs: plugin.managers.snapshot.state.entries.toArray().reduce(function (a, b) { var _a; return a + ((_a = b.snapshot.durationInMs) !== null && _a !== void 0 ? _a : 0); }, 0)
        };
    },
    initialState: function (_, plugin) {
        var snapshots = plugin.managers.snapshot.state.entries.toArray();
        return {
            totalDuration: snapshots.reduce(function (a, b) { var _a; return a + ((_a = b.snapshot.durationInMs) !== null && _a !== void 0 ? _a : 0); }, 0),
            snapshots: snapshots,
            currentIndex: 0
        };
    },
    apply: function (animState, t, ctx) {
        var _a;
        return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"])(this, void 0, void 0, function () {
            var ctime, i, _i, _b, s;
            return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__generator"])(this, function (_c) {
                if (t.current >= animState.totalDuration) {
                    return [2 /*return*/, { kind: 'finished' }];
                }
                ctime = 0, i = 0;
                for (_i = 0, _b = animState.snapshots; _i < _b.length; _i++) {
                    s = _b[_i];
                    ctime += (_a = s.snapshot.durationInMs) !== null && _a !== void 0 ? _a : 0;
                    if (t.current < ctime) {
                        break;
                    }
                    i++;
                }
                if (i >= animState.snapshots.length)
                    return [2 /*return*/, { kind: 'finished' }];
                if (i === animState.currentIndex) {
                    return [2 /*return*/, { kind: 'skip' }];
                }
                setPartialSnapshot(ctx.plugin, animState.snapshots[i]);
                return [2 /*return*/, { kind: 'next', state: Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, animState), { currentIndex: i }) }];
            });
        });
    }
});
//# sourceMappingURL=state-snapshots.js.map

/***/ }),

/***/ "./lib/mol-plugin-state/animation/helpers.js":
/*!***************************************************!*\
  !*** ./lib/mol-plugin-state/animation/helpers.js ***!
  \***************************************************/
/*! exports provided: unwindStructureAssembly, explodeStructure */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "unwindStructureAssembly", function() { return unwindStructureAssembly; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "explodeStructure", function() { return explodeStructure; });
/* harmony import */ var _mol_math_geometry__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../mol-math/geometry */ "./lib/mol-math/geometry.js");
/* harmony import */ var _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../mol-math/linear-algebra */ "./lib/mol-math/linear-algebra.js");
/**
 * Copyright (c) 2019 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author David Sehnal <david.sehnal@gmail.com>
 */


var _unwindMatrix = _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_1__["Mat4"].zero();
function unwindStructureAssembly(structure, unitTransforms, t) {
    for (var i = 0, _i = structure.units.length; i < _i; i++) {
        var u = structure.units[i];
        _mol_math_geometry__WEBPACK_IMPORTED_MODULE_0__["SymmetryOperator"].lerpFromIdentity(_unwindMatrix, u.conformation.operator, t);
        unitTransforms.setTransform(_unwindMatrix, u);
    }
}
var _centerVec = _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_1__["Vec3"].zero(), _transVec = _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_1__["Vec3"].zero(), _transMat = _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_1__["Mat4"].zero();
function explodeStructure(structure, unitTransforms, t) {
    var boundary = structure.boundary.sphere;
    var d = boundary.radius * t;
    for (var i = 0, _i = structure.units.length; i < _i; i++) {
        var u = structure.units[i];
        _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_1__["Vec3"].transformMat4(_centerVec, u.lookup3d.boundary.sphere.center, u.conformation.operator.matrix);
        _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_1__["Vec3"].sub(_transVec, _centerVec, boundary.center);
        _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_1__["Vec3"].setMagnitude(_transVec, _transVec, d);
        _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_1__["Mat4"].fromTranslation(_transMat, _transVec);
        unitTransforms.setTransform(_transMat, u);
    }
}
//# sourceMappingURL=helpers.js.map

/***/ }),

/***/ "./lib/mol-plugin-state/animation/model.js":
/*!*************************************************!*\
  !*** ./lib/mol-plugin-state/animation/model.js ***!
  \*************************************************/
/*! exports provided: PluginStateAnimation */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "PluginStateAnimation", function() { return PluginStateAnimation; });
/**
 * Copyright (c) 2019 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author David Sehnal <david.sehnal@gmail.com>
 */

var PluginStateAnimation;
(function (PluginStateAnimation) {
    function create(params) {
        return params;
    }
    PluginStateAnimation.create = create;
    function getDuration(ctx, instance) {
        var _a, _b;
        if (instance.customDurationMs)
            return instance.customDurationMs;
        var d = (_b = (_a = instance.definition).getDuration) === null || _b === void 0 ? void 0 : _b.call(_a, instance.params, ctx);
        if ((d === null || d === void 0 ? void 0 : d.kind) === 'fixed')
            return d.durationMs;
    }
    PluginStateAnimation.getDuration = getDuration;
})(PluginStateAnimation || (PluginStateAnimation = {}));
//# sourceMappingURL=model.js.map

/***/ }),

/***/ "./lib/mol-plugin-state/builder/data.js":
/*!**********************************************!*\
  !*** ./lib/mol-plugin-state/builder/data.js ***!
  \**********************************************/
/*! exports provided: DataBuilder */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DataBuilder", function() { return DataBuilder; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _transforms_data__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../transforms/data */ "./lib/mol-plugin-state/transforms/data.js");
/* harmony import */ var _mol_util_file_info__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../mol-util/file-info */ "./lib/mol-util/file-info.js");
/**
 * Copyright (c) 2019 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author David Sehnal <david.sehnal@gmail.com>
 */



var DataBuilder = /** @class */ (function () {
    function DataBuilder(plugin) {
        this.plugin = plugin;
    }
    Object.defineProperty(DataBuilder.prototype, "dataState", {
        get: function () {
            return this.plugin.state.data;
        },
        enumerable: false,
        configurable: true
    });
    DataBuilder.prototype.rawData = function (params, options) {
        var data = this.dataState.build().toRoot().apply(_transforms_data__WEBPACK_IMPORTED_MODULE_1__["RawData"], params, options);
        return data.commit({ revertOnError: true });
    };
    DataBuilder.prototype.download = function (params, options) {
        var data = this.dataState.build().toRoot().apply(_transforms_data__WEBPACK_IMPORTED_MODULE_1__["Download"], params, options);
        return data.commit({ revertOnError: true });
    };
    DataBuilder.prototype.downloadBlob = function (params, options) {
        var data = this.dataState.build().toRoot().apply(_transforms_data__WEBPACK_IMPORTED_MODULE_1__["DownloadBlob"], params, options);
        return data.commit({ revertOnError: true });
    };
    DataBuilder.prototype.readFile = function (params, options) {
        var _a;
        return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"])(this, void 0, void 0, function () {
            var data, fileInfo;
            return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__generator"])(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, this.dataState.build().toRoot().apply(_transforms_data__WEBPACK_IMPORTED_MODULE_1__["ReadFile"], params, options).commit({ revertOnError: true })];
                    case 1:
                        data = _b.sent();
                        fileInfo = Object(_mol_util_file_info__WEBPACK_IMPORTED_MODULE_2__["getFileInfo"])(((_a = params.file) === null || _a === void 0 ? void 0 : _a.file) || '');
                        return [2 /*return*/, { data: data, fileInfo: fileInfo }];
                }
            });
        });
    };
    return DataBuilder;
}());

//# sourceMappingURL=data.js.map

/***/ }),

/***/ "./lib/mol-plugin-state/builder/structure.js":
/*!***************************************************!*\
  !*** ./lib/mol-plugin-state/builder/structure.js ***!
  \***************************************************/
/*! exports provided: StructureBuilder */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "StructureBuilder", function() { return StructureBuilder; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _mol_state__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../mol-state */ "./lib/mol-state/index.js");
/* harmony import */ var _objects__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../objects */ "./lib/mol-plugin-state/objects.js");
/* harmony import */ var _transforms__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../transforms */ "./lib/mol-plugin-state/transforms.js");
/* harmony import */ var _structure_representation__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./structure/representation */ "./lib/mol-plugin-state/builder/structure/representation.js");
/* harmony import */ var _mol_task__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../mol-task */ "./lib/mol-task/index.js");
/* harmony import */ var _mol_model_structure__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../../mol-model/structure */ "./lib/mol-model/structure.js");
/* harmony import */ var _mol_model_formats_structure_property_symmetry__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../../mol-model-formats/structure/property/symmetry */ "./lib/mol-model-formats/structure/property/symmetry.js");
/* harmony import */ var _mol_math_geometry__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ../../mol-math/geometry */ "./lib/mol-math/geometry.js");
/* harmony import */ var _structure_hierarchy__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ./structure/hierarchy */ "./lib/mol-plugin-state/builder/structure/hierarchy.js");
/**
 * Copyright (c) 2020 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author David Sehnal <david.sehnal@gmail.com>
 */










var StructureBuilder = /** @class */ (function () {
    function StructureBuilder(plugin) {
        this.plugin = plugin;
        this.hierarchy = new _structure_hierarchy__WEBPACK_IMPORTED_MODULE_9__["TrajectoryHierarchyBuilder"](this.plugin);
        this.representation = new _structure_representation__WEBPACK_IMPORTED_MODULE_4__["StructureRepresentationBuilder"](this.plugin);
    }
    Object.defineProperty(StructureBuilder.prototype, "dataState", {
        get: function () {
            return this.plugin.state.data;
        },
        enumerable: false,
        configurable: true
    });
    StructureBuilder.prototype.parseTrajectoryData = function (data, format) {
        return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"])(this, void 0, void 0, function () {
            var provider, trajectory;
            return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__generator"])(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        provider = typeof format === 'string' ? this.plugin.dataFormats.get(format) : format;
                        if (!provider)
                            throw new Error("'" + format + "' is not a supported data format.");
                        return [4 /*yield*/, provider.parse(this.plugin, data)];
                    case 1:
                        trajectory = (_a.sent()).trajectory;
                        return [2 /*return*/, trajectory];
                }
            });
        });
    };
    StructureBuilder.prototype.parseTrajectoryBlob = function (data, params) {
        var state = this.dataState;
        var trajectory = state.build().to(data)
            .apply(_transforms__WEBPACK_IMPORTED_MODULE_3__["StateTransforms"].Data.ParseBlob, params, { state: { isGhost: true } })
            .apply(_transforms__WEBPACK_IMPORTED_MODULE_3__["StateTransforms"].Model.TrajectoryFromBlob, void 0);
        return trajectory.commit({ revertOnError: true });
    };
    StructureBuilder.prototype.parseTrajectory = function (data, params) {
        var cell = _mol_state__WEBPACK_IMPORTED_MODULE_1__["StateObjectRef"].resolveAndCheck(this.dataState, data);
        if (!cell)
            throw new Error('Invalid data cell.');
        if (_objects__WEBPACK_IMPORTED_MODULE_2__["PluginStateObject"].Data.Blob.is(cell.obj)) {
            return this.parseTrajectoryBlob(data, params);
        }
        else {
            return this.parseTrajectoryData(data, params);
        }
    };
    StructureBuilder.prototype.createModel = function (trajectory, params, initialState) {
        var state = this.dataState;
        var model = state.build().to(trajectory)
            .apply(_transforms__WEBPACK_IMPORTED_MODULE_3__["StateTransforms"].Model.ModelFromTrajectory, params || { modelIndex: 0 }, { state: initialState });
        return model.commit({ revertOnError: true });
    };
    StructureBuilder.prototype.insertModelProperties = function (model, params, initialState) {
        var state = this.dataState;
        var props = state.build().to(model)
            .apply(_transforms__WEBPACK_IMPORTED_MODULE_3__["StateTransforms"].Model.CustomModelProperties, params, { state: initialState });
        return props.commit({ revertOnError: true });
    };
    StructureBuilder.prototype.tryCreateUnitcell = function (model, params, initialState) {
        var _a, _b, _c;
        var state = this.dataState;
        var m = (_b = (_a = _mol_state__WEBPACK_IMPORTED_MODULE_1__["StateObjectRef"].resolveAndCheck(state, model)) === null || _a === void 0 ? void 0 : _a.obj) === null || _b === void 0 ? void 0 : _b.data;
        if (!m)
            return;
        var cell = (_c = _mol_model_formats_structure_property_symmetry__WEBPACK_IMPORTED_MODULE_7__["ModelSymmetry"].Provider.get(m)) === null || _c === void 0 ? void 0 : _c.spacegroup.cell;
        if (_mol_math_geometry__WEBPACK_IMPORTED_MODULE_8__["SpacegroupCell"].isZero(cell))
            return;
        var unitcell = state.build().to(model)
            .apply(_transforms__WEBPACK_IMPORTED_MODULE_3__["StateTransforms"].Representation.ModelUnitcell3D, params, { state: initialState });
        return unitcell.commit({ revertOnError: true });
    };
    StructureBuilder.prototype.createStructure = function (modelRef, params, initialState) {
        var _a;
        var state = this.dataState;
        if (!params) {
            var model = _mol_state__WEBPACK_IMPORTED_MODULE_1__["StateObjectRef"].resolveAndCheck(state, modelRef);
            if (model) {
                var symm = _mol_model_formats_structure_property_symmetry__WEBPACK_IMPORTED_MODULE_7__["ModelSymmetry"].Provider.get((_a = model.obj) === null || _a === void 0 ? void 0 : _a.data);
                if (!symm || (symm === null || symm === void 0 ? void 0 : symm.assemblies.length) === 0)
                    params = { name: 'model', params: {} };
            }
        }
        var structure = state.build().to(modelRef)
            .apply(_transforms__WEBPACK_IMPORTED_MODULE_3__["StateTransforms"].Model.StructureFromModel, { type: params || { name: 'assembly', params: {} } }, { state: initialState });
        return structure.commit({ revertOnError: true });
    };
    StructureBuilder.prototype.insertStructureProperties = function (structure, params) {
        var state = this.dataState;
        var props = state.build().to(structure)
            .apply(_transforms__WEBPACK_IMPORTED_MODULE_3__["StateTransforms"].Model.CustomStructureProperties, params);
        return props.commit({ revertOnError: true });
    };
    StructureBuilder.prototype.isComponentTransform = function (cell) {
        return cell.transform.transformer === _transforms__WEBPACK_IMPORTED_MODULE_3__["StateTransforms"].Model.StructureComponent;
    };
    /** returns undefined if the component is empty/null */
    StructureBuilder.prototype.tryCreateComponent = function (structure, params, key, tags) {
        var _a, _b;
        return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"])(this, void 0, void 0, function () {
            var state, root, keyTag, component, selector;
            return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__generator"])(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        state = this.dataState;
                        root = state.build().to(structure);
                        keyTag = "structure-component-" + key;
                        component = root.applyOrUpdateTagged(keyTag, _transforms__WEBPACK_IMPORTED_MODULE_3__["StateTransforms"].Model.StructureComponent, params, {
                            tags: tags ? Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__spreadArrays"])(tags, [keyTag]) : [keyTag]
                        });
                        return [4 /*yield*/, component.commit()];
                    case 1:
                        _c.sent();
                        selector = component.selector;
                        if (!(!selector.isOk || ((_b = (_a = selector.cell) === null || _a === void 0 ? void 0 : _a.obj) === null || _b === void 0 ? void 0 : _b.data.elementCount) === 0)) return [3 /*break*/, 3];
                        return [4 /*yield*/, state.build().delete(selector.ref).commit()];
                    case 2:
                        _c.sent();
                        return [2 /*return*/];
                    case 3: return [2 /*return*/, selector];
                }
            });
        });
    };
    StructureBuilder.prototype.tryCreateComponentFromExpression = function (structure, expression, key, params) {
        return this.tryCreateComponent(structure, {
            type: { name: 'expression', params: expression },
            nullIfEmpty: true,
            label: ((params === null || params === void 0 ? void 0 : params.label) || '').trim()
        }, key, params === null || params === void 0 ? void 0 : params.tags);
    };
    StructureBuilder.prototype.tryCreateComponentStatic = function (structure, type, params) {
        return this.tryCreateComponent(structure, {
            type: { name: 'static', params: type },
            nullIfEmpty: true,
            label: ((params === null || params === void 0 ? void 0 : params.label) || '').trim()
        }, "static-" + type, params === null || params === void 0 ? void 0 : params.tags);
    };
    StructureBuilder.prototype.tryCreateComponentFromSelection = function (structure, selection, key, params) {
        var _this = this;
        return this.plugin.runTask(_mol_task__WEBPACK_IMPORTED_MODULE_5__["Task"].create('Query Component', function (taskCtx) { return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"])(_this, void 0, void 0, function () {
            var _a, label, tags, structureData, transformParams, _b, _c, _d;
            var _e, _f;
            var _g, _h;
            return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__generator"])(this, function (_j) {
                switch (_j.label) {
                    case 0:
                        _a = params || {}, label = _a.label, tags = _a.tags;
                        label = (label || '').trim();
                        structureData = (_h = (_g = _mol_state__WEBPACK_IMPORTED_MODULE_1__["StateObjectRef"].resolveAndCheck(this.dataState, structure)) === null || _g === void 0 ? void 0 : _g.obj) === null || _h === void 0 ? void 0 : _h.data;
                        if (!structureData)
                            return [2 /*return*/];
                        if (!selection.referencesCurrent) return [3 /*break*/, 2];
                        _e = {};
                        _f = {
                            name: 'bundle'
                        };
                        _d = (_c = _mol_model_structure__WEBPACK_IMPORTED_MODULE_6__["StructureElement"].Bundle).fromSelection;
                        return [4 /*yield*/, selection.getSelection(this.plugin, taskCtx, structureData)];
                    case 1:
                        _b = (_e.type = (_f.params = _d.apply(_c, [_j.sent()]),
                            _f),
                            _e.nullIfEmpty = true,
                            _e.label = label || selection.label,
                            _e);
                        return [3 /*break*/, 3];
                    case 2:
                        _b = {
                            type: { name: 'expression', params: selection.expression },
                            nullIfEmpty: true,
                            label: label || selection.label
                        };
                        _j.label = 3;
                    case 3:
                        transformParams = _b;
                        if (!selection.ensureCustomProperties) return [3 /*break*/, 5];
                        return [4 /*yield*/, selection.ensureCustomProperties({ runtime: taskCtx, assetManager: this.plugin.managers.asset }, structureData)];
                    case 4:
                        _j.sent();
                        _j.label = 5;
                    case 5: return [2 /*return*/, this.tryCreateComponent(structure, transformParams, key, tags)];
                }
            });
        }); }));
    };
    return StructureBuilder;
}());

//# sourceMappingURL=structure.js.map

/***/ }),

/***/ "./lib/mol-plugin-state/builder/structure/hierarchy-preset.js":
/*!********************************************************************!*\
  !*** ./lib/mol-plugin-state/builder/structure/hierarchy-preset.js ***!
  \********************************************************************/
/*! exports provided: TrajectoryHierarchyPresetProvider, PresetTrajectoryHierarchy */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "TrajectoryHierarchyPresetProvider", function() { return TrajectoryHierarchyPresetProvider; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "PresetTrajectoryHierarchy", function() { return PresetTrajectoryHierarchy; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../../mol-util/param-definition */ "./lib/mol-util/param-definition.js");
/* harmony import */ var _mol_state__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../../mol-state */ "./lib/mol-state/index.js");
/* harmony import */ var _transforms__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../transforms */ "./lib/mol-plugin-state/transforms.js");
/* harmony import */ var _helpers_root_structure__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../helpers/root-structure */ "./lib/mol-plugin-state/helpers/root-structure.js");
/* harmony import */ var _representation_preset__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./representation-preset */ "./lib/mol-plugin-state/builder/structure/representation-preset.js");
/* harmony import */ var _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../../../mol-math/linear-algebra */ "./lib/mol-math/linear-algebra.js");
/* harmony import */ var _mol_model_structure__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../../../mol-model/structure */ "./lib/mol-model/structure.js");
/* harmony import */ var _mol_repr_util__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ../../../mol-repr/util */ "./lib/mol-repr/util.js");
/* harmony import */ var _mol_theme_color_operator_name__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ../../../mol-theme/color/operator-name */ "./lib/mol-theme/color/operator-name.js");
/**
 * Copyright (c) 2020 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author David Sehnal <david.sehnal@gmail.com>
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */










function TrajectoryHierarchyPresetProvider(preset) { return preset; }
(function (TrajectoryHierarchyPresetProvider) {
    TrajectoryHierarchyPresetProvider.CommonParams = function (a, plugin) { return ({
        modelProperties: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_1__["ParamDefinition"].Optional(_mol_util_param_definition__WEBPACK_IMPORTED_MODULE_1__["ParamDefinition"].Group(_mol_state__WEBPACK_IMPORTED_MODULE_2__["StateTransformer"].getParamDefinition(_transforms__WEBPACK_IMPORTED_MODULE_3__["StateTransforms"].Model.CustomModelProperties, void 0, plugin))),
        structureProperties: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_1__["ParamDefinition"].Optional(_mol_util_param_definition__WEBPACK_IMPORTED_MODULE_1__["ParamDefinition"].Group(_mol_state__WEBPACK_IMPORTED_MODULE_2__["StateTransformer"].getParamDefinition(_transforms__WEBPACK_IMPORTED_MODULE_3__["StateTransforms"].Model.CustomStructureProperties, void 0, plugin))),
        representationPreset: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_1__["ParamDefinition"].Optional(_mol_util_param_definition__WEBPACK_IMPORTED_MODULE_1__["ParamDefinition"].Text('auto'))
    }); };
})(TrajectoryHierarchyPresetProvider || (TrajectoryHierarchyPresetProvider = {}));
var CommonParams = TrajectoryHierarchyPresetProvider.CommonParams;
var DefaultParams = function (a, plugin) { return (Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({ model: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_1__["ParamDefinition"].Optional(_mol_util_param_definition__WEBPACK_IMPORTED_MODULE_1__["ParamDefinition"].Group(_mol_state__WEBPACK_IMPORTED_MODULE_2__["StateTransformer"].getParamDefinition(_transforms__WEBPACK_IMPORTED_MODULE_3__["StateTransforms"].Model.ModelFromTrajectory, a, plugin))), showUnitcell: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_1__["ParamDefinition"].Optional(_mol_util_param_definition__WEBPACK_IMPORTED_MODULE_1__["ParamDefinition"].Boolean(false)), structure: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_1__["ParamDefinition"].Optional(_helpers_root_structure__WEBPACK_IMPORTED_MODULE_4__["RootStructureDefinition"].getParams(void 0, 'assembly').type), representationPresetParams: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_1__["ParamDefinition"].Optional(_mol_util_param_definition__WEBPACK_IMPORTED_MODULE_1__["ParamDefinition"].Group(_representation_preset__WEBPACK_IMPORTED_MODULE_5__["StructureRepresentationPresetProvider"].CommonParams)) }, CommonParams(a, plugin))); };
var defaultPreset = TrajectoryHierarchyPresetProvider({
    id: 'preset-trajectory-default',
    display: {
        name: 'Default (Assembly)', group: 'Preset',
        description: 'Shows the first assembly or, if that is unavailable, the first model.'
    },
    isApplicable: function (o) {
        return true;
    },
    params: DefaultParams,
    apply: function (trajectory, params, plugin) {
        return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"])(this, void 0, void 0, function () {
            var builder, model, modelProperties, structure, structureProperties, unitcell, _a, representation;
            return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__generator"])(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        builder = plugin.builders.structure;
                        return [4 /*yield*/, builder.createModel(trajectory, params.model)];
                    case 1:
                        model = _b.sent();
                        return [4 /*yield*/, builder.insertModelProperties(model, params.modelProperties)];
                    case 2:
                        modelProperties = _b.sent();
                        return [4 /*yield*/, builder.createStructure(modelProperties || model, params.structure)];
                    case 3:
                        structure = _b.sent();
                        return [4 /*yield*/, builder.insertStructureProperties(structure, params.structureProperties)];
                    case 4:
                        structureProperties = _b.sent();
                        if (!(params.showUnitcell === void 0 || !!params.showUnitcell)) return [3 /*break*/, 6];
                        return [4 /*yield*/, builder.tryCreateUnitcell(modelProperties, undefined, { isHidden: true })];
                    case 5:
                        _a = _b.sent();
                        return [3 /*break*/, 7];
                    case 6:
                        _a = void 0;
                        _b.label = 7;
                    case 7:
                        unitcell = _a;
                        return [4 /*yield*/, plugin.builders.structure.representation.applyPreset(structureProperties, params.representationPreset || 'auto', params.representationPresetParams)];
                    case 8:
                        representation = _b.sent();
                        return [2 /*return*/, {
                                model: model,
                                modelProperties: modelProperties,
                                unitcell: unitcell,
                                structure: structure,
                                structureProperties: structureProperties,
                                representation: representation
                            }];
                }
            });
        });
    }
});
var AllModelsParams = function (a, plugin) { return (Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({ useDefaultIfSingleModel: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_1__["ParamDefinition"].Optional(_mol_util_param_definition__WEBPACK_IMPORTED_MODULE_1__["ParamDefinition"].Boolean(false)), representationPresetParams: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_1__["ParamDefinition"].Optional(_mol_util_param_definition__WEBPACK_IMPORTED_MODULE_1__["ParamDefinition"].Group(_representation_preset__WEBPACK_IMPORTED_MODULE_5__["StructureRepresentationPresetProvider"].CommonParams)) }, CommonParams(a, plugin))); };
var allModels = TrajectoryHierarchyPresetProvider({
    id: 'preset-trajectory-all-models',
    display: {
        name: 'All Models', group: 'Preset',
        description: 'Shows all models; colored by model-index.'
    },
    isApplicable: function (o) {
        return o.data.frameCount > 1;
    },
    params: AllModelsParams,
    apply: function (trajectory, params, plugin) {
        var _a, _b;
        return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"])(this, void 0, void 0, function () {
            var tr, builder, models, structures, i, model, modelProperties, structure, structureProperties, quality;
            return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__generator"])(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        tr = (_b = (_a = _mol_state__WEBPACK_IMPORTED_MODULE_2__["StateObjectRef"].resolveAndCheck(plugin.state.data, trajectory)) === null || _a === void 0 ? void 0 : _a.obj) === null || _b === void 0 ? void 0 : _b.data;
                        if (!tr)
                            return [2 /*return*/, {}];
                        if (tr.frameCount === 1 && params.useDefaultIfSingleModel) {
                            return [2 /*return*/, defaultPreset.apply(trajectory, params, plugin)];
                        }
                        builder = plugin.builders.structure;
                        models = [], structures = [];
                        i = 0;
                        _c.label = 1;
                    case 1:
                        if (!(i < tr.frameCount)) return [3 /*break*/, 8];
                        return [4 /*yield*/, builder.createModel(trajectory, { modelIndex: i })];
                    case 2:
                        model = _c.sent();
                        return [4 /*yield*/, builder.insertModelProperties(model, params.modelProperties, { isCollapsed: true })];
                    case 3:
                        modelProperties = _c.sent();
                        return [4 /*yield*/, builder.createStructure(modelProperties || model, { name: 'model', params: {} })];
                    case 4:
                        structure = _c.sent();
                        return [4 /*yield*/, builder.insertStructureProperties(structure, params.structureProperties)];
                    case 5:
                        structureProperties = _c.sent();
                        models.push(model);
                        structures.push(structure);
                        quality = structure.obj ? Object(_mol_repr_util__WEBPACK_IMPORTED_MODULE_8__["getStructureQuality"])(structure.obj.data, { elementCountFactor: tr.frameCount }) : 'medium';
                        return [4 /*yield*/, builder.representation.applyPreset(structureProperties, params.representationPreset || 'auto', { theme: { globalName: 'model-index' }, quality: quality })];
                    case 6:
                        _c.sent();
                        _c.label = 7;
                    case 7:
                        i++;
                        return [3 /*break*/, 1];
                    case 8: return [2 /*return*/, { models: models, structures: structures }];
                }
            });
        });
    }
});
var CrystalSymmetryParams = function (a, plugin) { return (Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({ model: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_1__["ParamDefinition"].Optional(_mol_util_param_definition__WEBPACK_IMPORTED_MODULE_1__["ParamDefinition"].Group(_mol_state__WEBPACK_IMPORTED_MODULE_2__["StateTransformer"].getParamDefinition(_transforms__WEBPACK_IMPORTED_MODULE_3__["StateTransforms"].Model.ModelFromTrajectory, a, plugin))) }, CommonParams(a, plugin))); };
function applyCrystalSymmetry(props, trajectory, params, plugin) {
    return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"])(this, void 0, void 0, function () {
        var builder, model, modelProperties, structure, structureProperties, unitcell, representation;
        return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__generator"])(this, function (_a) {
            switch (_a.label) {
                case 0:
                    builder = plugin.builders.structure;
                    return [4 /*yield*/, builder.createModel(trajectory, params.model)];
                case 1:
                    model = _a.sent();
                    return [4 /*yield*/, builder.insertModelProperties(model, params.modelProperties)];
                case 2:
                    modelProperties = _a.sent();
                    return [4 /*yield*/, builder.createStructure(modelProperties || model, {
                            name: 'symmetry',
                            params: props
                        })];
                case 3:
                    structure = _a.sent();
                    return [4 /*yield*/, builder.insertStructureProperties(structure, params.structureProperties)];
                case 4:
                    structureProperties = _a.sent();
                    return [4 /*yield*/, builder.tryCreateUnitcell(modelProperties, undefined, { isHidden: false })];
                case 5:
                    unitcell = _a.sent();
                    return [4 /*yield*/, plugin.builders.structure.representation.applyPreset(structureProperties, params.representationPreset || 'auto', { theme: { globalName: props.theme } })];
                case 6:
                    representation = _a.sent();
                    return [2 /*return*/, {
                            model: model,
                            modelProperties: modelProperties,
                            unitcell: unitcell,
                            structure: structure,
                            structureProperties: structureProperties,
                            representation: representation
                        }];
            }
        });
    });
}
var unitcell = TrajectoryHierarchyPresetProvider({
    id: 'preset-trajectory-unitcell',
    display: {
        name: 'Unit Cell', group: 'Preset',
        description: 'Shows the fully populated unit cell.'
    },
    isApplicable: function (o) {
        return _mol_model_structure__WEBPACK_IMPORTED_MODULE_7__["Model"].hasCrystalSymmetry(o.data.representative);
    },
    params: CrystalSymmetryParams,
    apply: function (trajectory, params, plugin) {
        return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"])(this, void 0, void 0, function () {
            return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__generator"])(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, applyCrystalSymmetry({ ijkMin: _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_6__["Vec3"].create(0, 0, 0), ijkMax: _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_6__["Vec3"].create(0, 0, 0) }, trajectory, params, plugin)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    }
});
var supercell = TrajectoryHierarchyPresetProvider({
    id: 'preset-trajectory-supercell',
    display: {
        name: 'Super Cell', group: 'Preset',
        description: 'Shows the super cell, i.e. the central unit cell and all adjacent unit cells.'
    },
    isApplicable: function (o) {
        return _mol_model_structure__WEBPACK_IMPORTED_MODULE_7__["Model"].hasCrystalSymmetry(o.data.representative);
    },
    params: CrystalSymmetryParams,
    apply: function (trajectory, params, plugin) {
        return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"])(this, void 0, void 0, function () {
            return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__generator"])(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, applyCrystalSymmetry({ ijkMin: _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_6__["Vec3"].create(-1, -1, -1), ijkMax: _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_6__["Vec3"].create(1, 1, 1), theme: 'operator-hkl' }, trajectory, params, plugin)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    }
});
var CrystalContactsParams = function (a, plugin) { return (Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({ model: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_1__["ParamDefinition"].Optional(_mol_util_param_definition__WEBPACK_IMPORTED_MODULE_1__["ParamDefinition"].Group(_mol_state__WEBPACK_IMPORTED_MODULE_2__["StateTransformer"].getParamDefinition(_transforms__WEBPACK_IMPORTED_MODULE_3__["StateTransforms"].Model.ModelFromTrajectory, a, plugin))) }, CommonParams(a, plugin))); };
var crystalContacts = TrajectoryHierarchyPresetProvider({
    id: 'preset-trajectory-crystal-contacts',
    display: {
        name: 'Crystal Contacts', group: 'Preset',
        description: 'Showsasymetric unit and chains from neighbours within 5 \u212B, i.e., symmetry mates.'
    },
    isApplicable: function (o) {
        return _mol_model_structure__WEBPACK_IMPORTED_MODULE_7__["Model"].hasCrystalSymmetry(o.data.representative);
    },
    params: CrystalContactsParams,
    apply: function (trajectory, params, plugin) {
        return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"])(this, void 0, void 0, function () {
            var builder, model, modelProperties, structure, structureProperties, unitcell, representation;
            return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__generator"])(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        builder = plugin.builders.structure;
                        return [4 /*yield*/, builder.createModel(trajectory, params.model)];
                    case 1:
                        model = _a.sent();
                        return [4 /*yield*/, builder.insertModelProperties(model, params.modelProperties)];
                    case 2:
                        modelProperties = _a.sent();
                        return [4 /*yield*/, builder.createStructure(modelProperties || model, {
                                name: 'symmetry-mates',
                                params: { radius: 5 }
                            })];
                    case 3:
                        structure = _a.sent();
                        return [4 /*yield*/, builder.insertStructureProperties(structure, params.structureProperties)];
                    case 4:
                        structureProperties = _a.sent();
                        return [4 /*yield*/, builder.tryCreateUnitcell(modelProperties, undefined, { isHidden: true })];
                    case 5:
                        unitcell = _a.sent();
                        return [4 /*yield*/, plugin.builders.structure.representation.applyPreset(structureProperties, params.representationPreset || 'auto', { theme: { globalName: 'operator-name', carbonColor: 'operator-name', focus: { name: 'element-symbol', params: { carbonColor: { name: 'operator-name', params: _mol_theme_color_operator_name__WEBPACK_IMPORTED_MODULE_9__["OperatorNameColorThemeProvider"].defaultValues } } } } })];
                    case 6:
                        representation = _a.sent();
                        return [2 /*return*/, {
                                model: model,
                                modelProperties: modelProperties,
                                unitcell: unitcell,
                                structure: structure,
                                structureProperties: structureProperties,
                                representation: representation
                            }];
                }
            });
        });
    }
});
var PresetTrajectoryHierarchy = {
    'default': defaultPreset,
    'all-models': allModels,
    unitcell: unitcell,
    supercell: supercell,
    crystalContacts: crystalContacts,
};
//# sourceMappingURL=hierarchy-preset.js.map

/***/ }),

/***/ "./lib/mol-plugin-state/builder/structure/hierarchy.js":
/*!*************************************************************!*\
  !*** ./lib/mol-plugin-state/builder/structure/hierarchy.js ***!
  \*************************************************************/
/*! exports provided: TrajectoryHierarchyBuilder */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "TrajectoryHierarchyBuilder", function() { return TrajectoryHierarchyBuilder; });
/* harmony import */ var _mol_data_util__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../../mol-data/util */ "./lib/mol-data/util.js");
/* harmony import */ var _mol_state__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../../mol-state */ "./lib/mol-state/index.js");
/* harmony import */ var _mol_task__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../../mol-task */ "./lib/mol-task/index.js");
/* harmony import */ var _mol_util_debug__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../../mol-util/debug */ "./lib/mol-util/debug.js");
/* harmony import */ var _mol_util_object__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../../mol-util/object */ "./lib/mol-util/object.js");
/* harmony import */ var _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../../mol-util/param-definition */ "./lib/mol-util/param-definition.js");
/* harmony import */ var _hierarchy_preset__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ./hierarchy-preset */ "./lib/mol-plugin-state/builder/structure/hierarchy-preset.js");
/* harmony import */ var _mol_util_array__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../../../mol-util/array */ "./lib/mol-util/array.js");
/**
 * Copyright (c) 2020 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author David Sehnal <david.sehnal@gmail.com>
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */








var TrajectoryHierarchyBuilder = /** @class */ (function () {
    function TrajectoryHierarchyBuilder(plugin) {
        var _this = this;
        this.plugin = plugin;
        this._providers = [];
        this.providerMap = new Map();
        this.defaultProvider = _hierarchy_preset__WEBPACK_IMPORTED_MODULE_6__["PresetTrajectoryHierarchy"].default;
        Object(_mol_util_object__WEBPACK_IMPORTED_MODULE_4__["objectForEach"])(_hierarchy_preset__WEBPACK_IMPORTED_MODULE_6__["PresetTrajectoryHierarchy"], function (r) { return _this.registerPreset(r); });
    }
    TrajectoryHierarchyBuilder.prototype.resolveProvider = function (ref) {
        var _a;
        return typeof ref === 'string'
            ? (_a = _hierarchy_preset__WEBPACK_IMPORTED_MODULE_6__["PresetTrajectoryHierarchy"][ref]) !== null && _a !== void 0 ? _a : Object(_mol_data_util__WEBPACK_IMPORTED_MODULE_0__["arrayFind"])(this._providers, function (p) { return p.id === ref; }) : ref;
    };
    TrajectoryHierarchyBuilder.prototype.hasPreset = function (t) {
        for (var _i = 0, _a = this._providers; _i < _a.length; _i++) {
            var p = _a[_i];
            if (!p.isApplicable || p.isApplicable(t, this.plugin))
                return true;
        }
        return false;
    };
    Object.defineProperty(TrajectoryHierarchyBuilder.prototype, "providers", {
        get: function () { return this._providers; },
        enumerable: false,
        configurable: true
    });
    TrajectoryHierarchyBuilder.prototype.getPresets = function (t) {
        if (!t)
            return this.providers;
        var ret = [];
        for (var _i = 0, _a = this._providers; _i < _a.length; _i++) {
            var p = _a[_i];
            if (p.isApplicable && !p.isApplicable(t, this.plugin))
                continue;
            ret.push(p);
        }
        return ret;
    };
    TrajectoryHierarchyBuilder.prototype.getPresetSelect = function (t) {
        var options = [];
        for (var _i = 0, _a = this._providers; _i < _a.length; _i++) {
            var p = _a[_i];
            if (t && p.isApplicable && !p.isApplicable(t, this.plugin))
                continue;
            options.push([p.id, p.display.name]);
        }
        return _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_5__["ParamDefinition"].Select('auto', options);
    };
    TrajectoryHierarchyBuilder.prototype.getPresetsWithOptions = function (t) {
        var options = [];
        var map = Object.create(null);
        for (var _i = 0, _a = this._providers; _i < _a.length; _i++) {
            var p = _a[_i];
            if (p.isApplicable && !p.isApplicable(t, this.plugin))
                continue;
            options.push([p.id, p.display.name]);
            map[p.id] = p.params ? _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_5__["ParamDefinition"].Group(p.params(t, this.plugin)) : _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_5__["ParamDefinition"].EmptyGroup();
        }
        if (options.length === 0)
            return _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_5__["ParamDefinition"].MappedStatic('', { '': _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_5__["ParamDefinition"].EmptyGroup() });
        return _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_5__["ParamDefinition"].MappedStatic(options[0][0], map, { options: options });
    };
    TrajectoryHierarchyBuilder.prototype.registerPreset = function (provider) {
        if (this.providerMap.has(provider.id)) {
            throw new Error("Hierarchy provider with id '" + provider.id + "' already registered.");
        }
        this._providers.push(provider);
        this.providerMap.set(provider.id, provider);
    };
    TrajectoryHierarchyBuilder.prototype.unregisterPreset = function (provider) {
        this.providerMap.delete(provider.id);
        Object(_mol_util_array__WEBPACK_IMPORTED_MODULE_7__["arrayRemoveInPlace"])(this._providers, provider);
    };
    TrajectoryHierarchyBuilder.prototype.applyPreset = function (parent, providerRef, params) {
        var _this = this;
        var provider = this.resolveProvider(providerRef);
        if (!provider)
            return;
        var state = this.plugin.state.data;
        var cell = _mol_state__WEBPACK_IMPORTED_MODULE_1__["StateObjectRef"].resolveAndCheck(state, parent);
        if (!cell) {
            if (!_mol_util_debug__WEBPACK_IMPORTED_MODULE_3__["isProductionMode"])
                console.warn("Applying hierarchy preset provider to bad cell.");
            return;
        }
        var prms = params || (provider.params
            ? _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_5__["ParamDefinition"].getDefaultValues(provider.params(cell.obj, this.plugin))
            : {});
        var task = _mol_task__WEBPACK_IMPORTED_MODULE_2__["Task"].create("" + provider.display.name, function () { return provider.apply(cell, prms, _this.plugin); });
        return this.plugin.runTask(task);
    };
    return TrajectoryHierarchyBuilder;
}());

//# sourceMappingURL=hierarchy.js.map

/***/ }),

/***/ "./lib/mol-plugin-state/builder/structure/representation-preset.js":
/*!*************************************************************************!*\
  !*** ./lib/mol-plugin-state/builder/structure/representation-preset.js ***!
  \*************************************************************************/
/*! exports provided: StructureRepresentationPresetProvider, presetStaticComponent, presetSelectionComponent, PresetStructureRepresentations */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "StructureRepresentationPresetProvider", function() { return StructureRepresentationPresetProvider; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "presetStaticComponent", function() { return presetStaticComponent; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "presetSelectionComponent", function() { return presetSelectionComponent; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "PresetStructureRepresentations", function() { return PresetStructureRepresentations; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../../mol-util/param-definition */ "./lib/mol-util/param-definition.js");
/* harmony import */ var _mol_geo_geometry_base__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../../mol-geo/geometry/base */ "./lib/mol-geo/geometry/base.js");
/* harmony import */ var _mol_model_structure__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../../mol-model/structure */ "./lib/mol-model/structure.js");
/* harmony import */ var _mol_state__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../../mol-state */ "./lib/mol-state/index.js");
/* harmony import */ var _helpers_structure_selection_query__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../helpers/structure-selection-query */ "./lib/mol-plugin-state/helpers/structure-selection-query.js");
/* harmony import */ var _mol_plugin_config__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../../../mol-plugin/config */ "./lib/mol-plugin/config.js");
/* harmony import */ var _mol_plugin_behavior_dynamic_selection_structure_focus_representation__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../../../mol-plugin/behavior/dynamic/selection/structure-focus-representation */ "./lib/mol-plugin/behavior/dynamic/selection/structure-focus-representation.js");
/* harmony import */ var _helpers_structure_representation_params__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ../../helpers/structure-representation-params */ "./lib/mol-plugin-state/helpers/structure-representation-params.js");
/* harmony import */ var _mol_theme_color_chain_id__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ../../../mol-theme/color/chain-id */ "./lib/mol-theme/color/chain-id.js");
/* harmony import */ var _mol_theme_color_operator_name__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ../../../mol-theme/color/operator-name */ "./lib/mol-theme/color/operator-name.js");
/* harmony import */ var _mol_model_formats_structure_property_bonds_index_pair__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ../../../mol-model-formats/structure/property/bonds/index-pair */ "./lib/mol-model-formats/structure/property/bonds/index-pair.js");
/* harmony import */ var _mol_model_formats_structure_property_bonds_struct_conn__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! ../../../mol-model-formats/structure/property/bonds/struct_conn */ "./lib/mol-model-formats/structure/property/bonds/struct_conn.js");
/**
 * Copyright (c) 2019-2021 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author David Sehnal <david.sehnal@gmail.com>
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */













function StructureRepresentationPresetProvider(repr) { return repr; }
(function (StructureRepresentationPresetProvider) {
    StructureRepresentationPresetProvider.CommonParams = {
        ignoreHydrogens: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_1__["ParamDefinition"].Optional(_mol_util_param_definition__WEBPACK_IMPORTED_MODULE_1__["ParamDefinition"].Boolean(false)),
        quality: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_1__["ParamDefinition"].Optional(_mol_util_param_definition__WEBPACK_IMPORTED_MODULE_1__["ParamDefinition"].Select('auto', _mol_geo_geometry_base__WEBPACK_IMPORTED_MODULE_2__["VisualQualityOptions"])),
        theme: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_1__["ParamDefinition"].Optional(_mol_util_param_definition__WEBPACK_IMPORTED_MODULE_1__["ParamDefinition"].Group({
            globalName: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_1__["ParamDefinition"].Optional(_mol_util_param_definition__WEBPACK_IMPORTED_MODULE_1__["ParamDefinition"].Text('')),
            carbonColor: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_1__["ParamDefinition"].Optional(_mol_util_param_definition__WEBPACK_IMPORTED_MODULE_1__["ParamDefinition"].Select('chain-id', _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_1__["ParamDefinition"].arrayToOptions(['chain-id', 'operator-name', 'element-symbol']))),
            symmetryColor: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_1__["ParamDefinition"].Optional(_mol_util_param_definition__WEBPACK_IMPORTED_MODULE_1__["ParamDefinition"].Text('')),
            focus: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_1__["ParamDefinition"].Optional(_mol_util_param_definition__WEBPACK_IMPORTED_MODULE_1__["ParamDefinition"].Group({
                name: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_1__["ParamDefinition"].Optional(_mol_util_param_definition__WEBPACK_IMPORTED_MODULE_1__["ParamDefinition"].Text('')),
                params: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_1__["ParamDefinition"].Optional(_mol_util_param_definition__WEBPACK_IMPORTED_MODULE_1__["ParamDefinition"].Value({}))
            }))
        }))
    };
    function getCarbonColorParams(name) {
        return name === 'chain-id'
            ? { name: name, params: _mol_theme_color_chain_id__WEBPACK_IMPORTED_MODULE_9__["ChainIdColorThemeProvider"].defaultValues }
            : name === 'operator-name'
                ? { name: name, params: _mol_theme_color_operator_name__WEBPACK_IMPORTED_MODULE_10__["OperatorNameColorThemeProvider"].defaultValues }
                : { name: name, params: {} };
    }
    function isSymmetry(structure) {
        return structure.units.some(function (u) { return !u.conformation.operator.assembly && u.conformation.operator.spgrOp >= 0; });
    }
    function reprBuilder(plugin, params, structure) {
        var _a, _b, _c, _d, _e, _f;
        var update = plugin.state.data.build();
        var builder = plugin.builders.structure.representation;
        var typeParams = {
            quality: plugin.managers.structure.component.state.options.visualQuality,
            ignoreHydrogens: !plugin.managers.structure.component.state.options.showHydrogens,
        };
        if (params.quality && params.quality !== 'auto')
            typeParams.quality = params.quality;
        if (params.ignoreHydrogens !== void 0)
            typeParams.ignoreHydrogens = !!params.ignoreHydrogens;
        var color = ((_a = params.theme) === null || _a === void 0 ? void 0 : _a.globalName) ? (_b = params.theme) === null || _b === void 0 ? void 0 : _b.globalName : void 0;
        var ballAndStickColor = ((_c = params.theme) === null || _c === void 0 ? void 0 : _c.carbonColor) !== undefined
            ? { carbonColor: getCarbonColorParams((_d = params.theme) === null || _d === void 0 ? void 0 : _d.carbonColor) }
            : {};
        var symmetryColor = structure && ((_e = params.theme) === null || _e === void 0 ? void 0 : _e.symmetryColor)
            ? isSymmetry(structure) ? (_f = params.theme) === null || _f === void 0 ? void 0 : _f.symmetryColor : color
            : color;
        return { update: update, builder: builder, color: color, symmetryColor: symmetryColor, typeParams: typeParams, ballAndStickColor: ballAndStickColor };
    }
    StructureRepresentationPresetProvider.reprBuilder = reprBuilder;
    function updateFocusRepr(plugin, structure, themeName, themeParams) {
        return plugin.state.updateBehavior(_mol_plugin_behavior_dynamic_selection_structure_focus_representation__WEBPACK_IMPORTED_MODULE_7__["StructureFocusRepresentation"], function (p) {
            var c = Object(_helpers_structure_representation_params__WEBPACK_IMPORTED_MODULE_8__["createStructureColorThemeParams"])(plugin, structure, 'ball-and-stick', themeName || 'element-symbol', themeParams);
            p.surroundingsParams.colorTheme = c;
            p.targetParams.colorTheme = c;
        });
    }
    StructureRepresentationPresetProvider.updateFocusRepr = updateFocusRepr;
})(StructureRepresentationPresetProvider || (StructureRepresentationPresetProvider = {}));
var CommonParams = StructureRepresentationPresetProvider.CommonParams;
var reprBuilder = StructureRepresentationPresetProvider.reprBuilder;
var updateFocusRepr = StructureRepresentationPresetProvider.updateFocusRepr;
var auto = StructureRepresentationPresetProvider({
    id: 'preset-structure-representation-auto',
    display: {
        name: 'Automatic',
        description: 'Show representations based on the size of the structure. Smaller structures are shown with more detail than larger ones, ranging from atomistic display to coarse surfaces.'
    },
    params: function () { return CommonParams; },
    apply: function (ref, params, plugin) {
        var _a, _b;
        var structure = (_b = (_a = _mol_state__WEBPACK_IMPORTED_MODULE_4__["StateObjectRef"].resolveAndCheck(plugin.state.data, ref)) === null || _a === void 0 ? void 0 : _a.obj) === null || _b === void 0 ? void 0 : _b.data;
        if (!structure)
            return {};
        var thresholds = plugin.config.get(_mol_plugin_config__WEBPACK_IMPORTED_MODULE_6__["PluginConfig"].Structure.SizeThresholds) || _mol_model_structure__WEBPACK_IMPORTED_MODULE_3__["Structure"].DefaultSizeThresholds;
        var size = _mol_model_structure__WEBPACK_IMPORTED_MODULE_3__["Structure"].getSize(structure, thresholds);
        switch (size) {
            case _mol_model_structure__WEBPACK_IMPORTED_MODULE_3__["Structure"].Size.Gigantic:
            case _mol_model_structure__WEBPACK_IMPORTED_MODULE_3__["Structure"].Size.Huge:
                return coarseSurface.apply(ref, params, plugin);
            case _mol_model_structure__WEBPACK_IMPORTED_MODULE_3__["Structure"].Size.Large:
                return polymerCartoon.apply(ref, params, plugin);
            case _mol_model_structure__WEBPACK_IMPORTED_MODULE_3__["Structure"].Size.Medium:
                return polymerAndLigand.apply(ref, params, plugin);
            case _mol_model_structure__WEBPACK_IMPORTED_MODULE_3__["Structure"].Size.Small:
                // `showCarbohydrateSymbol: true` is nice e.g. for PDB 1aga
                return atomicDetail.apply(ref, Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, params), { showCarbohydrateSymbol: true }), plugin);
        }
    }
});
var empty = StructureRepresentationPresetProvider({
    id: 'preset-structure-representation-empty',
    display: { name: 'Empty', description: 'Removes all existing representations.' },
    apply: function (ref, params, plugin) {
        return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"])(this, void 0, void 0, function () {
            return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__generator"])(this, function (_a) {
                return [2 /*return*/, {}];
            });
        });
    }
});
var BuiltInPresetGroupName = 'Basic';
var polymerAndLigand = StructureRepresentationPresetProvider({
    id: 'preset-structure-representation-polymer-and-ligand',
    display: {
        name: 'Polymer & Ligand', group: BuiltInPresetGroupName,
        description: 'Shows polymers as Cartoon, ligands as Ball & Stick, carbohydrates as 3D-SNFG and water molecules semi-transparent.'
    },
    params: function () { return CommonParams; },
    apply: function (ref, params, plugin) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
        return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"])(this, void 0, void 0, function () {
            var structureCell, components, structure, cartoonProps, waterType, lipidType, _l, update, builder, typeParams, color, symmetryColor, ballAndStickColor, representations;
            var _m;
            return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__generator"])(this, function (_o) {
                switch (_o.label) {
                    case 0:
                        structureCell = _mol_state__WEBPACK_IMPORTED_MODULE_4__["StateObjectRef"].resolveAndCheck(plugin.state.data, ref);
                        if (!structureCell)
                            return [2 /*return*/, {}];
                        _m = {};
                        return [4 /*yield*/, presetStaticComponent(plugin, structureCell, 'polymer')];
                    case 1:
                        _m.polymer = _o.sent();
                        return [4 /*yield*/, presetStaticComponent(plugin, structureCell, 'ligand')];
                    case 2:
                        _m.ligand = _o.sent();
                        return [4 /*yield*/, presetStaticComponent(plugin, structureCell, 'non-standard')];
                    case 3:
                        _m.nonStandard = _o.sent();
                        return [4 /*yield*/, presetStaticComponent(plugin, structureCell, 'branched', { label: 'Carbohydrate' })];
                    case 4:
                        _m.branched = _o.sent();
                        return [4 /*yield*/, presetStaticComponent(plugin, structureCell, 'water')];
                    case 5:
                        _m.water = _o.sent();
                        return [4 /*yield*/, presetStaticComponent(plugin, structureCell, 'ion')];
                    case 6:
                        _m.ion = _o.sent();
                        return [4 /*yield*/, presetStaticComponent(plugin, structureCell, 'lipid')];
                    case 7:
                        _m.lipid = _o.sent();
                        return [4 /*yield*/, presetStaticComponent(plugin, structureCell, 'coarse')];
                    case 8:
                        components = (_m.coarse = _o.sent(),
                            _m);
                        structure = structureCell.obj.data;
                        cartoonProps = {
                            sizeFactor: structure.isCoarseGrained ? 0.8 : 0.2,
                        };
                        waterType = (((_c = (_b = (_a = components.water) === null || _a === void 0 ? void 0 : _a.obj) === null || _b === void 0 ? void 0 : _b.data) === null || _c === void 0 ? void 0 : _c.elementCount) || 0) > 50000 ? 'line' : 'ball-and-stick';
                        lipidType = (((_f = (_e = (_d = components.lipid) === null || _d === void 0 ? void 0 : _d.obj) === null || _e === void 0 ? void 0 : _e.data) === null || _f === void 0 ? void 0 : _f.elementCount) || 0) > 20000 ? 'line' : 'ball-and-stick';
                        _l = reprBuilder(plugin, params, structure), update = _l.update, builder = _l.builder, typeParams = _l.typeParams, color = _l.color, symmetryColor = _l.symmetryColor, ballAndStickColor = _l.ballAndStickColor;
                        representations = {
                            polymer: builder.buildRepresentation(update, components.polymer, { type: 'cartoon', typeParams: Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, typeParams), cartoonProps), color: symmetryColor }, { tag: 'polymer' }),
                            ligand: builder.buildRepresentation(update, components.ligand, { type: 'ball-and-stick', typeParams: typeParams, color: color, colorParams: ballAndStickColor }, { tag: 'ligand' }),
                            nonStandard: builder.buildRepresentation(update, components.nonStandard, { type: 'ball-and-stick', typeParams: typeParams, color: color, colorParams: ballAndStickColor }, { tag: 'non-standard' }),
                            branchedBallAndStick: builder.buildRepresentation(update, components.branched, { type: 'ball-and-stick', typeParams: Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, typeParams), { alpha: 0.3 }), color: color, colorParams: ballAndStickColor }, { tag: 'branched-ball-and-stick' }),
                            branchedSnfg3d: builder.buildRepresentation(update, components.branched, { type: 'carbohydrate', typeParams: typeParams, color: color }, { tag: 'branched-snfg-3d' }),
                            water: builder.buildRepresentation(update, components.water, { type: waterType, typeParams: Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, typeParams), { alpha: 0.6 }), color: color, colorParams: { carbonColor: { name: 'element-symbol', params: {} } } }, { tag: 'water' }),
                            ion: builder.buildRepresentation(update, components.ion, { type: 'ball-and-stick', typeParams: typeParams, color: color, colorParams: { carbonColor: { name: 'element-symbol', params: {} } } }, { tag: 'ion' }),
                            lipid: builder.buildRepresentation(update, components.lipid, { type: lipidType, typeParams: Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, typeParams), { alpha: 0.6 }), color: color, colorParams: { carbonColor: { name: 'element-symbol', params: {} } } }, { tag: 'lipid' }),
                            coarse: builder.buildRepresentation(update, components.coarse, { type: 'spacefill', typeParams: typeParams, color: color || 'chain-id' }, { tag: 'coarse' })
                        };
                        return [4 /*yield*/, update.commit({ revertOnError: false })];
                    case 9:
                        _o.sent();
                        return [4 /*yield*/, updateFocusRepr(plugin, structure, (_h = (_g = params.theme) === null || _g === void 0 ? void 0 : _g.focus) === null || _h === void 0 ? void 0 : _h.name, (_k = (_j = params.theme) === null || _j === void 0 ? void 0 : _j.focus) === null || _k === void 0 ? void 0 : _k.params)];
                    case 10:
                        _o.sent();
                        return [2 /*return*/, { components: components, representations: representations }];
                }
            });
        });
    }
});
var proteinAndNucleic = StructureRepresentationPresetProvider({
    id: 'preset-structure-representation-protein-and-nucleic',
    display: {
        name: 'Protein & Nucleic', group: BuiltInPresetGroupName,
        description: 'Shows proteins as Cartoon and RNA/DNA as Gaussian Surface.'
    },
    params: function () { return CommonParams; },
    apply: function (ref, params, plugin) {
        var _a, _b, _c, _d;
        return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"])(this, void 0, void 0, function () {
            var structureCell, components, structure, cartoonProps, gaussianProps, _e, update, builder, typeParams, symmetryColor, representations;
            var _f;
            return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__generator"])(this, function (_g) {
                switch (_g.label) {
                    case 0:
                        structureCell = _mol_state__WEBPACK_IMPORTED_MODULE_4__["StateObjectRef"].resolveAndCheck(plugin.state.data, ref);
                        if (!structureCell)
                            return [2 /*return*/, {}];
                        _f = {};
                        return [4 /*yield*/, presetSelectionComponent(plugin, structureCell, 'protein')];
                    case 1:
                        _f.protein = _g.sent();
                        return [4 /*yield*/, presetSelectionComponent(plugin, structureCell, 'nucleic')];
                    case 2:
                        components = (_f.nucleic = _g.sent(),
                            _f);
                        structure = structureCell.obj.data;
                        cartoonProps = {
                            sizeFactor: structure.isCoarseGrained ? 0.8 : 0.2,
                        };
                        gaussianProps = {
                            radiusOffset: structure.isCoarseGrained ? 2 : 0,
                            smoothness: structure.isCoarseGrained ? 1.0 : 1.5,
                        };
                        _e = reprBuilder(plugin, params, structure), update = _e.update, builder = _e.builder, typeParams = _e.typeParams, symmetryColor = _e.symmetryColor;
                        representations = {
                            protein: builder.buildRepresentation(update, components.protein, { type: 'cartoon', typeParams: Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, typeParams), cartoonProps), color: symmetryColor }, { tag: 'protein' }),
                            nucleic: builder.buildRepresentation(update, components.nucleic, { type: 'gaussian-surface', typeParams: Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, typeParams), gaussianProps), color: symmetryColor }, { tag: 'nucleic' })
                        };
                        return [4 /*yield*/, update.commit({ revertOnError: true })];
                    case 3:
                        _g.sent();
                        return [4 /*yield*/, updateFocusRepr(plugin, structure, (_b = (_a = params.theme) === null || _a === void 0 ? void 0 : _a.focus) === null || _b === void 0 ? void 0 : _b.name, (_d = (_c = params.theme) === null || _c === void 0 ? void 0 : _c.focus) === null || _d === void 0 ? void 0 : _d.params)];
                    case 4:
                        _g.sent();
                        return [2 /*return*/, { components: components, representations: representations }];
                }
            });
        });
    }
});
var coarseSurface = StructureRepresentationPresetProvider({
    id: 'preset-structure-representation-coarse-surface',
    display: {
        name: 'Coarse Surface', group: BuiltInPresetGroupName,
        description: 'Shows polymers as coarse Gaussian Surface.'
    },
    params: function () { return CommonParams; },
    apply: function (ref, params, plugin) {
        var _a, _b, _c, _d;
        return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"])(this, void 0, void 0, function () {
            var structureCell, components, structure, size, gaussianProps, _e, update, builder, typeParams, symmetryColor, representations;
            var _f;
            return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__generator"])(this, function (_g) {
                switch (_g.label) {
                    case 0:
                        structureCell = _mol_state__WEBPACK_IMPORTED_MODULE_4__["StateObjectRef"].resolveAndCheck(plugin.state.data, ref);
                        if (!structureCell)
                            return [2 /*return*/, {}];
                        _f = {};
                        return [4 /*yield*/, presetStaticComponent(plugin, structureCell, 'polymer')];
                    case 1:
                        components = (_f.polymer = _g.sent(),
                            _f);
                        structure = structureCell.obj.data;
                        size = _mol_model_structure__WEBPACK_IMPORTED_MODULE_3__["Structure"].getSize(structure);
                        gaussianProps = Object.create(null);
                        if (size === _mol_model_structure__WEBPACK_IMPORTED_MODULE_3__["Structure"].Size.Gigantic) {
                            Object.assign(gaussianProps, {
                                traceOnly: true,
                                radiusOffset: 2,
                                smoothness: 1,
                                visuals: ['structure-gaussian-surface-mesh']
                            });
                        }
                        else if (size === _mol_model_structure__WEBPACK_IMPORTED_MODULE_3__["Structure"].Size.Huge) {
                            Object.assign(gaussianProps, {
                                radiusOffset: structure.isCoarseGrained ? 2 : 0,
                                smoothness: 1,
                            });
                        }
                        else if (structure.isCoarseGrained) {
                            Object.assign(gaussianProps, {
                                radiusOffset: 2,
                                smoothness: 1,
                            });
                        }
                        _e = reprBuilder(plugin, params, structure), update = _e.update, builder = _e.builder, typeParams = _e.typeParams, symmetryColor = _e.symmetryColor;
                        representations = {
                            polymer: builder.buildRepresentation(update, components.polymer, { type: 'gaussian-surface', typeParams: Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, typeParams), gaussianProps), color: symmetryColor }, { tag: 'polymer' })
                        };
                        return [4 /*yield*/, update.commit({ revertOnError: true })];
                    case 2:
                        _g.sent();
                        return [4 /*yield*/, updateFocusRepr(plugin, structure, (_b = (_a = params.theme) === null || _a === void 0 ? void 0 : _a.focus) === null || _b === void 0 ? void 0 : _b.name, (_d = (_c = params.theme) === null || _c === void 0 ? void 0 : _c.focus) === null || _d === void 0 ? void 0 : _d.params)];
                    case 3:
                        _g.sent();
                        return [2 /*return*/, { components: components, representations: representations }];
                }
            });
        });
    }
});
var polymerCartoon = StructureRepresentationPresetProvider({
    id: 'preset-structure-representation-polymer-cartoon',
    display: {
        name: 'Polymer Cartoon', group: BuiltInPresetGroupName,
        description: 'Shows polymers as Cartoon.'
    },
    params: function () { return CommonParams; },
    apply: function (ref, params, plugin) {
        var _a, _b, _c, _d;
        return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"])(this, void 0, void 0, function () {
            var structureCell, components, structure, cartoonProps, _e, update, builder, typeParams, symmetryColor, representations;
            var _f;
            return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__generator"])(this, function (_g) {
                switch (_g.label) {
                    case 0:
                        structureCell = _mol_state__WEBPACK_IMPORTED_MODULE_4__["StateObjectRef"].resolveAndCheck(plugin.state.data, ref);
                        if (!structureCell)
                            return [2 /*return*/, {}];
                        _f = {};
                        return [4 /*yield*/, presetStaticComponent(plugin, structureCell, 'polymer')];
                    case 1:
                        components = (_f.polymer = _g.sent(),
                            _f);
                        structure = structureCell.obj.data;
                        cartoonProps = {
                            sizeFactor: structure.isCoarseGrained ? 0.8 : 0.2
                        };
                        _e = reprBuilder(plugin, params, structure), update = _e.update, builder = _e.builder, typeParams = _e.typeParams, symmetryColor = _e.symmetryColor;
                        representations = {
                            polymer: builder.buildRepresentation(update, components.polymer, { type: 'cartoon', typeParams: Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, typeParams), cartoonProps), color: symmetryColor }, { tag: 'polymer' })
                        };
                        return [4 /*yield*/, update.commit({ revertOnError: true })];
                    case 2:
                        _g.sent();
                        return [4 /*yield*/, updateFocusRepr(plugin, structure, (_b = (_a = params.theme) === null || _a === void 0 ? void 0 : _a.focus) === null || _b === void 0 ? void 0 : _b.name, (_d = (_c = params.theme) === null || _c === void 0 ? void 0 : _c.focus) === null || _d === void 0 ? void 0 : _d.params)];
                    case 3:
                        _g.sent();
                        return [2 /*return*/, { components: components, representations: representations }];
                }
            });
        });
    }
});
var atomicDetail = StructureRepresentationPresetProvider({
    id: 'preset-structure-representation-atomic-detail',
    display: {
        name: 'Atomic Detail', group: BuiltInPresetGroupName,
        description: 'Shows everything in atomic detail with Ball & Stick.'
    },
    params: function () { return (Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, CommonParams), { showCarbohydrateSymbol: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_1__["ParamDefinition"].Boolean(false) })); },
    apply: function (ref, params, plugin) {
        return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"])(this, void 0, void 0, function () {
            var structureCell, components, structure, highElementCount, lowResidueElementRatio, m, bondsGiven, atomicType, showCarbohydrateSymbol, _a, _b, _c, _d, update, builder, typeParams, color, ballAndStickColor, colorParams, representations;
            var _e, _f;
            return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__generator"])(this, function (_g) {
                switch (_g.label) {
                    case 0:
                        structureCell = _mol_state__WEBPACK_IMPORTED_MODULE_4__["StateObjectRef"].resolveAndCheck(plugin.state.data, ref);
                        if (!structureCell)
                            return [2 /*return*/, {}];
                        _e = {};
                        return [4 /*yield*/, presetStaticComponent(plugin, structureCell, 'all')];
                    case 1:
                        components = (_e.all = _g.sent(),
                            _e.branched = undefined,
                            _e);
                        structure = structureCell.obj.data;
                        highElementCount = structure.elementCount > 100000;
                        lowResidueElementRatio = structure.atomicResidueCount &&
                            structure.elementCount > 1000 &&
                            structure.atomicResidueCount / structure.elementCount < 3;
                        m = structure.models[0];
                        bondsGiven = !!_mol_model_formats_structure_property_bonds_index_pair__WEBPACK_IMPORTED_MODULE_11__["IndexPairBonds"].Provider.get(m) || _mol_model_formats_structure_property_bonds_struct_conn__WEBPACK_IMPORTED_MODULE_12__["StructConn"].isExhaustive(m);
                        atomicType = lowResidueElementRatio && !bondsGiven
                            ? 'spacefill' : highElementCount
                            ? 'line' : 'ball-and-stick';
                        showCarbohydrateSymbol = params.showCarbohydrateSymbol && !highElementCount && !lowResidueElementRatio;
                        if (!showCarbohydrateSymbol) return [3 /*break*/, 3];
                        _b = (_a = Object).assign;
                        _c = [components];
                        _f = {};
                        return [4 /*yield*/, presetStaticComponent(plugin, structureCell, 'branched', { label: 'Carbohydrate' })];
                    case 2:
                        _b.apply(_a, _c.concat([(_f.branched = _g.sent(),
                                _f)]));
                        _g.label = 3;
                    case 3:
                        _d = reprBuilder(plugin, params, structure), update = _d.update, builder = _d.builder, typeParams = _d.typeParams, color = _d.color, ballAndStickColor = _d.ballAndStickColor;
                        colorParams = lowResidueElementRatio && !bondsGiven
                            ? { carbonColor: { name: 'element-symbol', params: {} } }
                            : ballAndStickColor;
                        representations = {
                            all: builder.buildRepresentation(update, components.all, { type: atomicType, typeParams: typeParams, color: color, colorParams: colorParams }, { tag: 'all' }),
                        };
                        if (showCarbohydrateSymbol) {
                            Object.assign(representations, {
                                snfg3d: builder.buildRepresentation(update, components.branched, { type: 'carbohydrate', typeParams: Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, typeParams), { alpha: 0.4, visuals: ['carbohydrate-symbol'] }), color: color }, { tag: 'snfg-3d' }),
                            });
                        }
                        return [4 /*yield*/, update.commit({ revertOnError: true })];
                    case 4:
                        _g.sent();
                        return [2 /*return*/, { components: components, representations: representations }];
                }
            });
        });
    }
});
function presetStaticComponent(plugin, structure, type, params) {
    return plugin.builders.structure.tryCreateComponentStatic(structure, type, params);
}
function presetSelectionComponent(plugin, structure, query, params) {
    return plugin.builders.structure.tryCreateComponentFromSelection(structure, _helpers_structure_selection_query__WEBPACK_IMPORTED_MODULE_5__["StructureSelectionQueries"][query], "selection-" + query, params);
}
var PresetStructureRepresentations = {
    empty: empty,
    auto: auto,
    'atomic-detail': atomicDetail,
    'polymer-cartoon': polymerCartoon,
    'polymer-and-ligand': polymerAndLigand,
    'protein-and-nucleic': proteinAndNucleic,
    'coarse-surface': coarseSurface
};
//# sourceMappingURL=representation-preset.js.map

/***/ }),

/***/ "./lib/mol-plugin-state/builder/structure/representation.js":
/*!******************************************************************!*\
  !*** ./lib/mol-plugin-state/builder/structure/representation.js ***!
  \******************************************************************/
/*! exports provided: StructureRepresentationBuilder */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "StructureRepresentationBuilder", function() { return StructureRepresentationBuilder; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _mol_data_util__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../../mol-data/util */ "./lib/mol-data/util.js");
/* harmony import */ var _mol_state__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../../mol-state */ "./lib/mol-state/index.js");
/* harmony import */ var _mol_task__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../../mol-task */ "./lib/mol-task/index.js");
/* harmony import */ var _mol_util_debug__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../../mol-util/debug */ "./lib/mol-util/debug.js");
/* harmony import */ var _mol_util_object__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../../mol-util/object */ "./lib/mol-util/object.js");
/* harmony import */ var _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../../../mol-util/param-definition */ "./lib/mol-util/param-definition.js");
/* harmony import */ var _helpers_structure_representation_params__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../../helpers/structure-representation-params */ "./lib/mol-plugin-state/helpers/structure-representation-params.js");
/* harmony import */ var _transforms_representation__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ../../transforms/representation */ "./lib/mol-plugin-state/transforms/representation.js");
/* harmony import */ var _representation_preset__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ./representation-preset */ "./lib/mol-plugin-state/builder/structure/representation-preset.js");
/* harmony import */ var _mol_util_array__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ../../../mol-util/array */ "./lib/mol-util/array.js");
/* harmony import */ var _mol_plugin_config__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ../../../mol-plugin/config */ "./lib/mol-plugin/config.js");
/**
 * Copyright (c) 2020 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author David Sehnal <david.sehnal@gmail.com>
 */












var StructureRepresentationBuilder = /** @class */ (function () {
    function StructureRepresentationBuilder(plugin) {
        var _this = this;
        this.plugin = plugin;
        this._providers = [];
        this.providerMap = new Map();
        this.defaultProvider = _representation_preset__WEBPACK_IMPORTED_MODULE_9__["PresetStructureRepresentations"].auto;
        Object(_mol_util_object__WEBPACK_IMPORTED_MODULE_5__["objectForEach"])(_representation_preset__WEBPACK_IMPORTED_MODULE_9__["PresetStructureRepresentations"], function (r) { return _this.registerPreset(r); });
    }
    Object.defineProperty(StructureRepresentationBuilder.prototype, "dataState", {
        get: function () { return this.plugin.state.data; },
        enumerable: false,
        configurable: true
    });
    StructureRepresentationBuilder.prototype.resolveProvider = function (ref) {
        var _a;
        return typeof ref === 'string'
            ? (_a = _representation_preset__WEBPACK_IMPORTED_MODULE_9__["PresetStructureRepresentations"][ref]) !== null && _a !== void 0 ? _a : Object(_mol_data_util__WEBPACK_IMPORTED_MODULE_1__["arrayFind"])(this._providers, function (p) { return p.id === ref; }) : ref;
    };
    StructureRepresentationBuilder.prototype.hasPreset = function (s) {
        for (var _i = 0, _a = this._providers; _i < _a.length; _i++) {
            var p = _a[_i];
            if (!p.isApplicable || p.isApplicable(s, this.plugin))
                return true;
        }
        return false;
    };
    Object.defineProperty(StructureRepresentationBuilder.prototype, "providers", {
        get: function () { return this._providers; },
        enumerable: false,
        configurable: true
    });
    StructureRepresentationBuilder.prototype.getPresets = function (s) {
        if (!s)
            return this.providers;
        var ret = [];
        for (var _i = 0, _a = this._providers; _i < _a.length; _i++) {
            var p = _a[_i];
            if (p.isApplicable && !p.isApplicable(s, this.plugin))
                continue;
            ret.push(p);
        }
        return ret;
    };
    StructureRepresentationBuilder.prototype.getPresetSelect = function (s) {
        var options = [];
        for (var _i = 0, _a = this._providers; _i < _a.length; _i++) {
            var p = _a[_i];
            if (s && p.isApplicable && !p.isApplicable(s, this.plugin))
                continue;
            options.push([p.id, p.display.name, p.display.group]);
        }
        return _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_6__["ParamDefinition"].Select('auto', options);
    };
    StructureRepresentationBuilder.prototype.getPresetsWithOptions = function (s) {
        var options = [];
        var map = Object.create(null);
        for (var _i = 0, _a = this._providers; _i < _a.length; _i++) {
            var p = _a[_i];
            if (p.isApplicable && !p.isApplicable(s, this.plugin))
                continue;
            options.push([p.id, p.display.name]);
            map[p.id] = p.params ? _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_6__["ParamDefinition"].Group(p.params(s, this.plugin)) : _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_6__["ParamDefinition"].EmptyGroup();
        }
        if (options.length === 0)
            return _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_6__["ParamDefinition"].MappedStatic('', { '': _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_6__["ParamDefinition"].EmptyGroup() });
        return _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_6__["ParamDefinition"].MappedStatic(options[0][0], map, { options: options });
    };
    StructureRepresentationBuilder.prototype.registerPreset = function (provider) {
        if (this.providerMap.has(provider.id)) {
            throw new Error("Representation provider with id '" + provider.id + "' already registered.");
        }
        this._providers.push(provider);
        this.providerMap.set(provider.id, provider);
    };
    StructureRepresentationBuilder.prototype.unregisterPreset = function (provider) {
        this.providerMap.delete(provider.id);
        Object(_mol_util_array__WEBPACK_IMPORTED_MODULE_10__["arrayRemoveInPlace"])(this._providers, provider);
    };
    StructureRepresentationBuilder.prototype.applyPreset = function (parent, providerRef, params) {
        var _this = this;
        var _a;
        var provider = this.resolveProvider(providerRef);
        if (!provider)
            return;
        var state = this.plugin.state.data;
        var cell = _mol_state__WEBPACK_IMPORTED_MODULE_2__["StateObjectRef"].resolveAndCheck(state, parent);
        if (!cell) {
            if (!_mol_util_debug__WEBPACK_IMPORTED_MODULE_4__["isProductionMode"])
                console.warn("Applying structure repr. provider to bad cell.");
            return;
        }
        var pd = ((_a = provider.params) === null || _a === void 0 ? void 0 : _a.call(provider, cell.obj, this.plugin)) || {};
        var prms = params || (provider.params
            ? _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_6__["ParamDefinition"].getDefaultValues(pd)
            : {});
        var defaults = this.plugin.config.get(_mol_plugin_config__WEBPACK_IMPORTED_MODULE_11__["PluginConfig"].Structure.DefaultRepresentationPresetParams);
        prms = _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_6__["ParamDefinition"].merge(pd, defaults, prms);
        var task = _mol_task__WEBPACK_IMPORTED_MODULE_3__["Task"].create("" + provider.display.name, function () { return provider.apply(cell, prms, _this.plugin); });
        return this.plugin.runTask(task);
    };
    StructureRepresentationBuilder.prototype.addRepresentation = function (structure, props, options) {
        return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"])(this, void 0, void 0, function () {
            var repr, selector;
            return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__generator"])(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        repr = this.dataState.build();
                        selector = this.buildRepresentation(repr, structure, props, options);
                        if (!selector)
                            return [2 /*return*/];
                        return [4 /*yield*/, repr.commit()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/, selector];
                }
            });
        });
    };
    StructureRepresentationBuilder.prototype.buildRepresentation = function (builder, structure, props, options) {
        var _a, _b;
        if (!structure)
            return;
        var data = (_b = (_a = _mol_state__WEBPACK_IMPORTED_MODULE_2__["StateObjectRef"].resolveAndCheck(this.dataState, structure)) === null || _a === void 0 ? void 0 : _a.obj) === null || _b === void 0 ? void 0 : _b.data;
        if (!data)
            return;
        var params = Object(_helpers_structure_representation_params__WEBPACK_IMPORTED_MODULE_7__["createStructureRepresentationParams"])(this.plugin, data, props);
        return (options === null || options === void 0 ? void 0 : options.tag) ? builder.to(structure).applyOrUpdateTagged(options.tag, _transforms_representation__WEBPACK_IMPORTED_MODULE_8__["StructureRepresentation3D"], params, { state: options === null || options === void 0 ? void 0 : options.initialState }).selector
            : builder.to(structure).apply(_transforms_representation__WEBPACK_IMPORTED_MODULE_8__["StructureRepresentation3D"], params, { state: options === null || options === void 0 ? void 0 : options.initialState }).selector;
    };
    return StructureRepresentationBuilder;
}());

//# sourceMappingURL=representation.js.map

/***/ }),

/***/ "./lib/mol-plugin-state/component.js":
/*!*******************************************!*\
  !*** ./lib/mol-plugin-state/component.js ***!
  \*******************************************/
/*! exports provided: PluginComponent, StatefulPluginComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "PluginComponent", function() { return PluginComponent; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "StatefulPluginComponent", function() { return StatefulPluginComponent; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _mol_util_object__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../mol-util/object */ "./lib/mol-util/object.js");
/* harmony import */ var _mol_util_rx_event_helper__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../mol-util/rx-event-helper */ "./lib/mol-util/rx-event-helper.js");
/* harmony import */ var _mol_util_array__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../mol-util/array */ "./lib/mol-util/array.js");
/**
 * Copyright (c) 2018-2020 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author David Sehnal <david.sehnal@gmail.com>
 */




var PluginComponent = /** @class */ (function () {
    function PluginComponent() {
        this.subs = void 0;
    }
    PluginComponent.prototype.subscribe = function (obs, action) {
        var _this = this;
        if (typeof this.subs === 'undefined')
            this.subs = [];
        var sub = obs.subscribe(action);
        this.subs.push(sub);
        return {
            unsubscribe: function () {
                if (sub && _this.subs && Object(_mol_util_array__WEBPACK_IMPORTED_MODULE_3__["arraySetRemove"])(_this.subs, sub)) {
                    sub.unsubscribe();
                    sub = void 0;
                }
            }
        };
    };
    Object.defineProperty(PluginComponent.prototype, "ev", {
        get: function () {
            return this._ev || (this._ev = _mol_util_rx_event_helper__WEBPACK_IMPORTED_MODULE_2__["RxEventHelper"].create());
        },
        enumerable: false,
        configurable: true
    });
    PluginComponent.prototype.dispose = function () {
        if (this._ev)
            this._ev.dispose();
        if (this.subs) {
            for (var _i = 0, _a = this.subs; _i < _a.length; _i++) {
                var s = _a[_i];
                s.unsubscribe();
            }
            this.subs = void 0;
        }
    };
    return PluginComponent;
}());

var StatefulPluginComponent = /** @class */ (function (_super) {
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__extends"])(StatefulPluginComponent, _super);
    function StatefulPluginComponent(initialState) {
        var _this = _super.call(this) || this;
        _this._state = initialState;
        return _this;
    }
    StatefulPluginComponent.prototype.updateState = function () {
        var states = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            states[_i] = arguments[_i];
        }
        var latest = this.state;
        var s = Object(_mol_util_object__WEBPACK_IMPORTED_MODULE_1__["shallowMergeArray"])(latest, states);
        if (s !== latest) {
            this._state = s;
            return true;
        }
        return false;
    };
    Object.defineProperty(StatefulPluginComponent.prototype, "state", {
        get: function () {
            return this._state;
        },
        enumerable: false,
        configurable: true
    });
    return StatefulPluginComponent;
}(PluginComponent));

//# sourceMappingURL=component.js.map

/***/ }),

/***/ "./lib/mol-plugin-state/formats/provider.js":
/*!**************************************************!*\
  !*** ./lib/mol-plugin-state/formats/provider.js ***!
  \**************************************************/
/*! exports provided: DataFormatProvider, guessCifVariant */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DataFormatProvider", function() { return DataFormatProvider; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "guessCifVariant", function() { return guessCifVariant; });
/* harmony import */ var _mol_io_common_msgpack_decode__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../mol-io/common/msgpack/decode */ "./lib/mol-io/common/msgpack/decode.js");
/**
 * Copyright (c) 2019-2020 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 * @author David Sehnal <david.sehnal@gmail.com>
 */

function DataFormatProvider(provider) { return provider; }
function guessCifVariant(info, data) {
    if (info.ext === 'bcif') {
        try {
            // TODO: find a way to run msgpackDecode only once
            //      now it is run twice, here and during file parsing
            if (Object(_mol_io_common_msgpack_decode__WEBPACK_IMPORTED_MODULE_0__["default"])(data).encoder.startsWith('VolumeServer'))
                return 'dscif';
        }
        catch (_a) { }
    }
    else if (info.ext === 'cif') {
        var str = data;
        if (str.startsWith('data_SERVER\n#\n_density_server_result'))
            return 'dscif';
        if (str.includes('atom_site_fract_x') || str.includes('atom_site.fract_x'))
            return 'coreCif';
    }
    return -1;
}
//# sourceMappingURL=provider.js.map

/***/ }),

/***/ "./lib/mol-plugin-state/formats/registry.js":
/*!**************************************************!*\
  !*** ./lib/mol-plugin-state/formats/registry.js ***!
  \**************************************************/
/*! exports provided: DataFormatRegistry */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DataFormatRegistry", function() { return DataFormatRegistry; });
/* harmony import */ var _trajectory__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./trajectory */ "./lib/mol-plugin-state/formats/trajectory.js");
/* harmony import */ var _volume__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./volume */ "./lib/mol-plugin-state/formats/volume.js");
/* harmony import */ var _shape__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./shape */ "./lib/mol-plugin-state/formats/shape.js");
/* harmony import */ var _structure__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./structure */ "./lib/mol-plugin-state/formats/structure.js");
/**
 * Copyright (c) 2019-2020 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 * @author David Sehnal <david.sehnal@gmail.com>
 */




var DataFormatRegistry = /** @class */ (function () {
    function DataFormatRegistry() {
        this._list = [];
        this._map = new Map();
        this._extensions = undefined;
        this._binaryExtensions = undefined;
        this._options = undefined;
        for (var _i = 0, BuiltInVolumeFormats_1 = _volume__WEBPACK_IMPORTED_MODULE_1__["BuiltInVolumeFormats"]; _i < BuiltInVolumeFormats_1.length; _i++) {
            var _a = BuiltInVolumeFormats_1[_i], id = _a[0], p = _a[1];
            this.add(id, p);
        }
        for (var _b = 0, BuiltInStructureFormats_1 = _structure__WEBPACK_IMPORTED_MODULE_3__["BuiltInStructureFormats"]; _b < BuiltInStructureFormats_1.length; _b++) {
            var _c = BuiltInStructureFormats_1[_b], id = _c[0], p = _c[1];
            this.add(id, p);
        }
        for (var _d = 0, BuiltInShapeFormats_1 = _shape__WEBPACK_IMPORTED_MODULE_2__["BuiltInShapeFormats"]; _d < BuiltInShapeFormats_1.length; _d++) {
            var _e = BuiltInShapeFormats_1[_d], id = _e[0], p = _e[1];
            this.add(id, p);
        }
        for (var _f = 0, BuiltInTrajectoryFormats_1 = _trajectory__WEBPACK_IMPORTED_MODULE_0__["BuiltInTrajectoryFormats"]; _f < BuiltInTrajectoryFormats_1.length; _f++) {
            var _g = BuiltInTrajectoryFormats_1[_f], id = _g[0], p = _g[1];
            this.add(id, p);
        }
    }
    Object.defineProperty(DataFormatRegistry.prototype, "types", {
        get: function () {
            return this._list.map(function (e) { return [e.name, e.provider.label]; });
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(DataFormatRegistry.prototype, "extensions", {
        get: function () {
            if (this._extensions)
                return this._extensions;
            var extensions = new Set();
            this._list.forEach(function (_a) {
                var _b, _c;
                var provider = _a.provider;
                (_b = provider.stringExtensions) === null || _b === void 0 ? void 0 : _b.forEach(function (ext) { return extensions.add(ext); });
                (_c = provider.binaryExtensions) === null || _c === void 0 ? void 0 : _c.forEach(function (ext) { return extensions.add(ext); });
            });
            this._extensions = extensions;
            return extensions;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(DataFormatRegistry.prototype, "binaryExtensions", {
        get: function () {
            if (this._binaryExtensions)
                return this._binaryExtensions;
            var binaryExtensions = new Set();
            this._list.forEach(function (_a) {
                var _b;
                var provider = _a.provider;
                return (_b = provider.binaryExtensions) === null || _b === void 0 ? void 0 : _b.forEach(function (ext) { return binaryExtensions.add(ext); });
            });
            this._binaryExtensions = binaryExtensions;
            return binaryExtensions;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(DataFormatRegistry.prototype, "options", {
        get: function () {
            if (this._options)
                return this._options;
            var options = [];
            this._list.forEach(function (_a) {
                var name = _a.name, provider = _a.provider;
                return options.push([name, provider.label, provider.category || '']);
            });
            this._options = options;
            return options;
        },
        enumerable: false,
        configurable: true
    });
    ;
    DataFormatRegistry.prototype._clear = function () {
        this._extensions = undefined;
        this._binaryExtensions = undefined;
        this._options = undefined;
    };
    DataFormatRegistry.prototype.add = function (name, provider) {
        this._clear();
        this._list.push({ name: name, provider: provider });
        this._map.set(name, provider);
    };
    DataFormatRegistry.prototype.remove = function (name) {
        this._clear();
        this._list.splice(this._list.findIndex(function (e) { return e.name === name; }), 1);
        this._map.delete(name);
    };
    DataFormatRegistry.prototype.auto = function (info, dataStateObject) {
        for (var i = 0, il = this.list.length; i < il; ++i) {
            var provider = this._list[i].provider;
            var hasExt = false;
            if (provider.binaryExtensions && provider.binaryExtensions.indexOf(info.ext) >= 0)
                hasExt = true;
            else if (provider.stringExtensions && provider.stringExtensions.indexOf(info.ext) >= 0)
                hasExt = true;
            if (hasExt && (!provider.isApplicable || provider.isApplicable(info, dataStateObject.data)))
                return provider;
        }
        return;
    };
    DataFormatRegistry.prototype.get = function (name) {
        if (this._map.has(name)) {
            return this._map.get(name);
        }
        else {
            throw new Error("unknown data format name '" + name + "'");
        }
    };
    Object.defineProperty(DataFormatRegistry.prototype, "list", {
        get: function () {
            return this._list;
        },
        enumerable: false,
        configurable: true
    });
    return DataFormatRegistry;
}());

//# sourceMappingURL=registry.js.map

/***/ }),

/***/ "./lib/mol-plugin-state/formats/shape.js":
/*!***********************************************!*\
  !*** ./lib/mol-plugin-state/formats/shape.js ***!
  \***********************************************/
/*! exports provided: ShapeFormatCategory, PlyProvider, BuiltInShapeFormats */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ShapeFormatCategory", function() { return ShapeFormatCategory; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "PlyProvider", function() { return PlyProvider; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "BuiltInShapeFormats", function() { return BuiltInShapeFormats; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _transforms__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../transforms */ "./lib/mol-plugin-state/transforms.js");
/* harmony import */ var _provider__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./provider */ "./lib/mol-plugin-state/formats/provider.js");
/**
 * Copyright (c) 2018-2020 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author David Sehnal <david.sehnal@gmail.com>
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */



var ShapeFormatCategory = 'Shape';
var PlyProvider = Object(_provider__WEBPACK_IMPORTED_MODULE_2__["DataFormatProvider"])({
    label: 'PLY',
    description: 'PLY',
    category: ShapeFormatCategory,
    stringExtensions: ['ply'],
    parse: function (plugin, data) { return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"])(void 0, void 0, void 0, function () {
        var format, shape;
        return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__generator"])(this, function (_a) {
            switch (_a.label) {
                case 0:
                    format = plugin.state.data.build()
                        .to(data)
                        .apply(_transforms__WEBPACK_IMPORTED_MODULE_1__["StateTransforms"].Data.ParsePly, {}, { state: { isGhost: true } });
                    shape = format.apply(_transforms__WEBPACK_IMPORTED_MODULE_1__["StateTransforms"].Model.ShapeFromPly);
                    return [4 /*yield*/, format.commit()];
                case 1:
                    _a.sent();
                    return [2 /*return*/, { format: format.selector, shape: shape.selector }];
            }
        });
    }); },
    visuals: function (plugin, data) {
        var repr = plugin.state.data.build()
            .to(data.shape)
            .apply(_transforms__WEBPACK_IMPORTED_MODULE_1__["StateTransforms"].Representation.ShapeRepresentation3D);
        return repr.commit();
    }
});
var BuiltInShapeFormats = [
    ['ply', PlyProvider],
];
//# sourceMappingURL=shape.js.map

/***/ }),

/***/ "./lib/mol-plugin-state/formats/structure.js":
/*!***************************************************!*\
  !*** ./lib/mol-plugin-state/formats/structure.js ***!
  \***************************************************/
/*! exports provided: StructureFormatCategory, PsfProvider, DcdProvider, XtcProvider, BuiltInStructureFormats */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "StructureFormatCategory", function() { return StructureFormatCategory; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "PsfProvider", function() { return PsfProvider; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DcdProvider", function() { return DcdProvider; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "XtcProvider", function() { return XtcProvider; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "BuiltInStructureFormats", function() { return BuiltInStructureFormats; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _transforms__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../transforms */ "./lib/mol-plugin-state/transforms.js");
/* harmony import */ var _provider__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./provider */ "./lib/mol-plugin-state/formats/provider.js");
/**
 * Copyright (c) 2018-2020 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author David Sehnal <david.sehnal@gmail.com>
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */



var StructureFormatCategory = 'Structure';
var PsfProvider = Object(_provider__WEBPACK_IMPORTED_MODULE_2__["DataFormatProvider"])({
    label: 'PSF',
    description: 'PSF',
    category: StructureFormatCategory,
    stringExtensions: ['psf'],
    parse: function (plugin, data) { return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"])(void 0, void 0, void 0, function () {
        var format, topology;
        return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__generator"])(this, function (_a) {
            switch (_a.label) {
                case 0:
                    format = plugin.state.data.build()
                        .to(data)
                        .apply(_transforms__WEBPACK_IMPORTED_MODULE_1__["StateTransforms"].Data.ParsePsf, {}, { state: { isGhost: true } });
                    topology = format.apply(_transforms__WEBPACK_IMPORTED_MODULE_1__["StateTransforms"].Model.TopologyFromPsf);
                    return [4 /*yield*/, format.commit()];
                case 1:
                    _a.sent();
                    return [2 /*return*/, { format: format.selector, topology: topology.selector }];
            }
        });
    }); }
});
var DcdProvider = Object(_provider__WEBPACK_IMPORTED_MODULE_2__["DataFormatProvider"])({
    label: 'DCD',
    description: 'DCD',
    category: StructureFormatCategory,
    binaryExtensions: ['dcd'],
    parse: function (plugin, data) {
        var coordinates = plugin.state.data.build()
            .to(data)
            .apply(_transforms__WEBPACK_IMPORTED_MODULE_1__["StateTransforms"].Model.CoordinatesFromDcd);
        return coordinates.commit();
    }
});
var XtcProvider = Object(_provider__WEBPACK_IMPORTED_MODULE_2__["DataFormatProvider"])({
    label: 'XTC',
    description: 'XTC',
    category: StructureFormatCategory,
    binaryExtensions: ['xtc'],
    parse: function (plugin, data) {
        var coordinates = plugin.state.data.build()
            .to(data)
            .apply(_transforms__WEBPACK_IMPORTED_MODULE_1__["StateTransforms"].Model.CoordinatesFromXtc);
        return coordinates.commit();
    }
});
var BuiltInStructureFormats = [
    ['psf', PsfProvider],
    ['dcd', DcdProvider],
    ['xtc', XtcProvider],
];
//# sourceMappingURL=structure.js.map

/***/ }),

/***/ "./lib/mol-plugin-state/formats/trajectory.js":
/*!****************************************************!*\
  !*** ./lib/mol-plugin-state/formats/trajectory.js ***!
  \****************************************************/
/*! exports provided: TrajectoryFormatCategory, MmcifProvider, CifCoreProvider, PdbProvider, PdbqtProvider, GroProvider, MolProvider, Mol2Provider, BuiltInTrajectoryFormats */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "TrajectoryFormatCategory", function() { return TrajectoryFormatCategory; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MmcifProvider", function() { return MmcifProvider; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CifCoreProvider", function() { return CifCoreProvider; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "PdbProvider", function() { return PdbProvider; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "PdbqtProvider", function() { return PdbqtProvider; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "GroProvider", function() { return GroProvider; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MolProvider", function() { return MolProvider; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Mol2Provider", function() { return Mol2Provider; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "BuiltInTrajectoryFormats", function() { return BuiltInTrajectoryFormats; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _transforms__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../transforms */ "./lib/mol-plugin-state/transforms.js");
/* harmony import */ var _provider__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./provider */ "./lib/mol-plugin-state/formats/provider.js");
/**
 * Copyright (c) 2018-2020 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author David Sehnal <david.sehnal@gmail.com>
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */



var TrajectoryFormatCategory = 'Trajectory';
function defaultVisuals(plugin, data) {
    return plugin.builders.structure.hierarchy.applyPreset(data.trajectory, 'default');
}
var MmcifProvider = {
    label: 'mmCIF',
    description: 'mmCIF',
    category: TrajectoryFormatCategory,
    stringExtensions: ['cif', 'mmcif', 'mcif'],
    binaryExtensions: ['bcif'],
    isApplicable: function (info, data) {
        if (info.ext === 'mmcif' || info.ext === 'mcif')
            return true;
        // assume undetermined cif/bcif files are mmCIF
        if (info.ext === 'cif' || info.ext === 'bcif')
            return Object(_provider__WEBPACK_IMPORTED_MODULE_2__["guessCifVariant"])(info, data) === -1;
        return false;
    },
    parse: function (plugin, data, params) { return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"])(void 0, void 0, void 0, function () {
        var state, cif, trajectory;
        var _a, _b;
        return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__generator"])(this, function (_c) {
            switch (_c.label) {
                case 0:
                    state = plugin.state.data;
                    cif = state.build().to(data)
                        .apply(_transforms__WEBPACK_IMPORTED_MODULE_1__["StateTransforms"].Data.ParseCif, void 0, { state: { isGhost: true } });
                    return [4 /*yield*/, cif
                            .apply(_transforms__WEBPACK_IMPORTED_MODULE_1__["StateTransforms"].Model.TrajectoryFromMmCif, void 0, { tags: params === null || params === void 0 ? void 0 : params.trajectoryTags })
                            .commit({ revertOnError: true })];
                case 1:
                    trajectory = _c.sent();
                    if ((((_b = (_a = cif.selector.cell) === null || _a === void 0 ? void 0 : _a.obj) === null || _b === void 0 ? void 0 : _b.data.blocks.length) || 0) > 1) {
                        plugin.state.data.updateCellState(cif.ref, { isGhost: false });
                    }
                    return [2 /*return*/, { trajectory: trajectory }];
            }
        });
    }); },
    visuals: defaultVisuals
};
var CifCoreProvider = {
    label: 'cifCore',
    description: 'CIF Core',
    category: TrajectoryFormatCategory,
    stringExtensions: ['cif'],
    isApplicable: function (info, data) {
        if (info.ext === 'cif')
            return Object(_provider__WEBPACK_IMPORTED_MODULE_2__["guessCifVariant"])(info, data) === 'coreCif';
        return false;
    },
    parse: function (plugin, data, params) { return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"])(void 0, void 0, void 0, function () {
        var state, cif, trajectory;
        var _a, _b;
        return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__generator"])(this, function (_c) {
            switch (_c.label) {
                case 0:
                    state = plugin.state.data;
                    cif = state.build().to(data)
                        .apply(_transforms__WEBPACK_IMPORTED_MODULE_1__["StateTransforms"].Data.ParseCif, void 0, { state: { isGhost: true } });
                    return [4 /*yield*/, cif
                            .apply(_transforms__WEBPACK_IMPORTED_MODULE_1__["StateTransforms"].Model.TrajectoryFromCifCore, void 0, { tags: params === null || params === void 0 ? void 0 : params.trajectoryTags })
                            .commit({ revertOnError: true })];
                case 1:
                    trajectory = _c.sent();
                    if ((((_b = (_a = cif.selector.cell) === null || _a === void 0 ? void 0 : _a.obj) === null || _b === void 0 ? void 0 : _b.data.blocks.length) || 0) > 1) {
                        plugin.state.data.updateCellState(cif.ref, { isGhost: false });
                    }
                    return [2 /*return*/, { trajectory: trajectory }];
            }
        });
    }); },
    visuals: defaultVisuals
};
function directTrajectory(transformer, transformerParams) {
    var _this = this;
    return function (plugin, data, params) { return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"])(_this, void 0, void 0, function () {
        var state, trajectory;
        return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__generator"])(this, function (_a) {
            switch (_a.label) {
                case 0:
                    state = plugin.state.data;
                    return [4 /*yield*/, state.build().to(data)
                            .apply(transformer, transformerParams, { tags: params === null || params === void 0 ? void 0 : params.trajectoryTags })
                            .commit({ revertOnError: true })];
                case 1:
                    trajectory = _a.sent();
                    return [2 /*return*/, { trajectory: trajectory }];
            }
        });
    }); };
}
var PdbProvider = {
    label: 'PDB',
    description: 'PDB',
    category: TrajectoryFormatCategory,
    stringExtensions: ['pdb', 'ent'],
    parse: directTrajectory(_transforms__WEBPACK_IMPORTED_MODULE_1__["StateTransforms"].Model.TrajectoryFromPDB),
    visuals: defaultVisuals
};
var PdbqtProvider = {
    label: 'PDBQT',
    description: 'PDBQT',
    category: TrajectoryFormatCategory,
    stringExtensions: ['pdbqt'],
    parse: directTrajectory(_transforms__WEBPACK_IMPORTED_MODULE_1__["StateTransforms"].Model.TrajectoryFromPDB, { isPdbqt: true }),
    visuals: defaultVisuals
};
var GroProvider = {
    label: 'GRO',
    description: 'GRO',
    category: TrajectoryFormatCategory,
    stringExtensions: ['gro'],
    binaryExtensions: [],
    parse: directTrajectory(_transforms__WEBPACK_IMPORTED_MODULE_1__["StateTransforms"].Model.TrajectoryFromGRO),
    visuals: defaultVisuals
};
var MolProvider = {
    label: 'MOL/SDF',
    description: 'MOL/SDF',
    category: TrajectoryFormatCategory,
    stringExtensions: ['mol', 'sdf', 'sd'],
    parse: directTrajectory(_transforms__WEBPACK_IMPORTED_MODULE_1__["StateTransforms"].Model.TrajectoryFromMOL),
    visuals: defaultVisuals
};
var Mol2Provider = {
    label: 'MOL2',
    description: 'MOL2',
    category: TrajectoryFormatCategory,
    stringExtensions: ['mol2'],
    parse: directTrajectory(_transforms__WEBPACK_IMPORTED_MODULE_1__["StateTransforms"].Model.TrajectoryFromMOL2),
    visuals: defaultVisuals
};
var BuiltInTrajectoryFormats = [
    ['mmcif', MmcifProvider],
    ['cifCore', CifCoreProvider],
    ['pdb', PdbProvider],
    ['pdbqt', PdbqtProvider],
    ['gro', GroProvider],
    ['mol', MolProvider],
    ['mol2', Mol2Provider],
];
//# sourceMappingURL=trajectory.js.map

/***/ }),

/***/ "./lib/mol-plugin-state/formats/volume.js":
/*!************************************************!*\
  !*** ./lib/mol-plugin-state/formats/volume.js ***!
  \************************************************/
/*! exports provided: VolumeFormatCategory, Ccp4Provider, Dsn6Provider, DxProvider, CubeProvider, DscifProvider, BuiltInVolumeFormats */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "VolumeFormatCategory", function() { return VolumeFormatCategory; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Ccp4Provider", function() { return Ccp4Provider; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Dsn6Provider", function() { return Dsn6Provider; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DxProvider", function() { return DxProvider; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CubeProvider", function() { return CubeProvider; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DscifProvider", function() { return DscifProvider; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "BuiltInVolumeFormats", function() { return BuiltInVolumeFormats; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _transforms__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../transforms */ "./lib/mol-plugin-state/transforms.js");
/* harmony import */ var _provider__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./provider */ "./lib/mol-plugin-state/formats/provider.js");
/* harmony import */ var _transforms_representation__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../transforms/representation */ "./lib/mol-plugin-state/transforms/representation.js");
/* harmony import */ var _mol_util_color_names__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../mol-util/color/names */ "./lib/mol-util/color/names.js");
/* harmony import */ var _mol_model_volume__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../mol-model/volume */ "./lib/mol-model/volume.js");
/* harmony import */ var _helpers_volume_representation_params__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../helpers/volume-representation-params */ "./lib/mol-plugin-state/helpers/volume-representation-params.js");
/* harmony import */ var _mol_util_object__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../../mol-util/object */ "./lib/mol-util/object.js");
/* harmony import */ var _mol_model_formats_volume_property__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ../../mol-model-formats/volume/property */ "./lib/mol-model-formats/volume/property.js");
/* harmony import */ var _mol_plugin_behavior_dynamic_volume_streaming_util__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ../../mol-plugin/behavior/dynamic/volume-streaming/util */ "./lib/mol-plugin/behavior/dynamic/volume-streaming/util.js");
/* harmony import */ var _mol_task__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ../../mol-task */ "./lib/mol-task/index.js");
/* harmony import */ var _mol_model_formats_volume_density_server__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ../../mol-model-formats/volume/density-server */ "./lib/mol-model-formats/volume/density-server.js");
/**
 * Copyright (c) 2018-2020 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author David Sehnal <david.sehnal@gmail.com>
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */












var VolumeFormatCategory = 'Volume';
function tryObtainRecommendedIsoValue(plugin, volume) {
    return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"])(this, void 0, void 0, function () {
        var entryId;
        var _this = this;
        return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__generator"])(this, function (_a) {
            if (!volume)
                return [2 /*return*/];
            entryId = volume.entryId;
            if (!entryId || !entryId.toLowerCase().startsWith('emd'))
                return [2 /*return*/];
            return [2 /*return*/, plugin.runTask(_mol_task__WEBPACK_IMPORTED_MODULE_10__["Task"].create('Try Set Recommended IsoValue', function (ctx) { return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"])(_this, void 0, void 0, function () {
                    var absIsoLevel, e_1;
                    return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__generator"])(this, function (_a) {
                        switch (_a.label) {
                            case 0:
                                _a.trys.push([0, 2, , 3]);
                                return [4 /*yield*/, Object(_mol_plugin_behavior_dynamic_volume_streaming_util__WEBPACK_IMPORTED_MODULE_9__["getContourLevelEmdb"])(plugin, ctx, entryId)];
                            case 1:
                                absIsoLevel = _a.sent();
                                _mol_model_formats_volume_property__WEBPACK_IMPORTED_MODULE_8__["RecommendedIsoValue"].Provider.set(volume, _mol_model_volume__WEBPACK_IMPORTED_MODULE_5__["Volume"].IsoValue.absolute(absIsoLevel));
                                return [3 /*break*/, 3];
                            case 2:
                                e_1 = _a.sent();
                                return [3 /*break*/, 3];
                            case 3: return [2 /*return*/];
                        }
                    });
                }); }))];
        });
    });
}
function tryGetRecomendedIsoValue(volume) {
    var recommendedIsoValue = _mol_model_formats_volume_property__WEBPACK_IMPORTED_MODULE_8__["RecommendedIsoValue"].Provider.get(volume);
    if (!recommendedIsoValue)
        return;
    if (recommendedIsoValue.kind === 'relative')
        return recommendedIsoValue;
    var stats = volume.grid.stats;
    if (_mol_model_formats_volume_density_server__WEBPACK_IMPORTED_MODULE_11__["DscifFormat"].is(volume.sourceData)) {
        stats = {
            min: volume.sourceData.data.volume_data_3d_info.min_source.value(0),
            max: volume.sourceData.data.volume_data_3d_info.max_source.value(0),
            mean: volume.sourceData.data.volume_data_3d_info.mean_source.value(0),
            sigma: volume.sourceData.data.volume_data_3d_info.sigma_source.value(0),
        };
    }
    return _mol_model_volume__WEBPACK_IMPORTED_MODULE_5__["Volume"].IsoValue.toRelative(recommendedIsoValue, stats);
}
function defaultVisuals(plugin, data) {
    return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"])(this, void 0, void 0, function () {
        var typeParams, isoValue, visual;
        return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__generator"])(this, function (_a) {
            switch (_a.label) {
                case 0:
                    typeParams = {};
                    isoValue = data.volume.data && tryGetRecomendedIsoValue(data.volume.data);
                    if (isoValue)
                        typeParams.isoValue = isoValue;
                    visual = plugin.build().to(data.volume).apply(_transforms__WEBPACK_IMPORTED_MODULE_1__["StateTransforms"].Representation.VolumeRepresentation3D, Object(_helpers_volume_representation_params__WEBPACK_IMPORTED_MODULE_6__["createVolumeRepresentationParams"])(plugin, data.volume.data, {
                        type: 'isosurface',
                        typeParams: typeParams,
                    }));
                    return [4 /*yield*/, visual.commit()];
                case 1: return [2 /*return*/, [_a.sent()]];
            }
        });
    });
}
var Ccp4Provider = Object(_provider__WEBPACK_IMPORTED_MODULE_2__["DataFormatProvider"])({
    label: 'CCP4/MRC/MAP',
    description: 'CCP4/MRC/MAP',
    category: VolumeFormatCategory,
    binaryExtensions: ['ccp4', 'mrc', 'map'],
    parse: function (plugin, data, params) { return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"])(void 0, void 0, void 0, function () {
        var format, volume;
        return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__generator"])(this, function (_a) {
            switch (_a.label) {
                case 0:
                    format = plugin.build()
                        .to(data)
                        .apply(_transforms__WEBPACK_IMPORTED_MODULE_1__["StateTransforms"].Data.ParseCcp4, {}, { state: { isGhost: true } });
                    volume = format.apply(_transforms__WEBPACK_IMPORTED_MODULE_1__["StateTransforms"].Volume.VolumeFromCcp4, { entryId: params === null || params === void 0 ? void 0 : params.entryId });
                    return [4 /*yield*/, format.commit({ revertOnError: true })];
                case 1:
                    _a.sent();
                    return [4 /*yield*/, tryObtainRecommendedIsoValue(plugin, volume.selector.data)];
                case 2:
                    _a.sent();
                    return [2 /*return*/, { format: format.selector, volume: volume.selector }];
            }
        });
    }); },
    visuals: defaultVisuals
});
var Dsn6Provider = Object(_provider__WEBPACK_IMPORTED_MODULE_2__["DataFormatProvider"])({
    label: 'DSN6/BRIX',
    description: 'DSN6/BRIX',
    category: VolumeFormatCategory,
    binaryExtensions: ['dsn6', 'brix'],
    parse: function (plugin, data, params) { return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"])(void 0, void 0, void 0, function () {
        var format, volume;
        return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__generator"])(this, function (_a) {
            switch (_a.label) {
                case 0:
                    format = plugin.build()
                        .to(data)
                        .apply(_transforms__WEBPACK_IMPORTED_MODULE_1__["StateTransforms"].Data.ParseDsn6, {}, { state: { isGhost: true } });
                    volume = format.apply(_transforms__WEBPACK_IMPORTED_MODULE_1__["StateTransforms"].Volume.VolumeFromDsn6, { entryId: params === null || params === void 0 ? void 0 : params.entryId });
                    return [4 /*yield*/, format.commit({ revertOnError: true })];
                case 1:
                    _a.sent();
                    return [4 /*yield*/, tryObtainRecommendedIsoValue(plugin, volume.selector.data)];
                case 2:
                    _a.sent();
                    return [2 /*return*/, { format: format.selector, volume: volume.selector }];
            }
        });
    }); },
    visuals: defaultVisuals
});
var DxProvider = Object(_provider__WEBPACK_IMPORTED_MODULE_2__["DataFormatProvider"])({
    label: 'DX',
    description: 'DX',
    category: VolumeFormatCategory,
    stringExtensions: ['dx'],
    binaryExtensions: ['dxbin'],
    parse: function (plugin, data, params) { return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"])(void 0, void 0, void 0, function () {
        var format, volume;
        return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__generator"])(this, function (_a) {
            switch (_a.label) {
                case 0:
                    format = plugin.build()
                        .to(data)
                        .apply(_transforms__WEBPACK_IMPORTED_MODULE_1__["StateTransforms"].Data.ParseDx, {}, { state: { isGhost: true } });
                    volume = format.apply(_transforms__WEBPACK_IMPORTED_MODULE_1__["StateTransforms"].Volume.VolumeFromDx, { entryId: params === null || params === void 0 ? void 0 : params.entryId });
                    return [4 /*yield*/, volume.commit({ revertOnError: true })];
                case 1:
                    _a.sent();
                    return [4 /*yield*/, tryObtainRecommendedIsoValue(plugin, volume.selector.data)];
                case 2:
                    _a.sent();
                    return [2 /*return*/, { volume: volume.selector }];
            }
        });
    }); },
    visuals: defaultVisuals
});
var CubeProvider = Object(_provider__WEBPACK_IMPORTED_MODULE_2__["DataFormatProvider"])({
    label: 'Cube',
    description: 'Cube',
    category: VolumeFormatCategory,
    stringExtensions: ['cub', 'cube'],
    parse: function (plugin, data, params) { return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"])(void 0, void 0, void 0, function () {
        var format, volume, structure;
        return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__generator"])(this, function (_a) {
            switch (_a.label) {
                case 0:
                    format = plugin.build()
                        .to(data)
                        .apply(_transforms__WEBPACK_IMPORTED_MODULE_1__["StateTransforms"].Data.ParseCube, {}, { state: { isGhost: true } });
                    volume = format.apply(_transforms__WEBPACK_IMPORTED_MODULE_1__["StateTransforms"].Volume.VolumeFromCube, { entryId: params === null || params === void 0 ? void 0 : params.entryId });
                    structure = format
                        .apply(_transforms__WEBPACK_IMPORTED_MODULE_1__["StateTransforms"].Model.TrajectoryFromCube, void 0, { state: { isGhost: true } })
                        .apply(_transforms__WEBPACK_IMPORTED_MODULE_1__["StateTransforms"].Model.ModelFromTrajectory)
                        .apply(_transforms__WEBPACK_IMPORTED_MODULE_1__["StateTransforms"].Model.StructureFromModel);
                    return [4 /*yield*/, format.commit({ revertOnError: true })];
                case 1:
                    _a.sent();
                    return [4 /*yield*/, tryObtainRecommendedIsoValue(plugin, volume.selector.data)];
                case 2:
                    _a.sent();
                    return [2 /*return*/, { format: format.selector, volume: volume.selector, structure: structure.selector }];
            }
        });
    }); },
    visuals: function (plugin, data) { return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"])(void 0, void 0, void 0, function () {
        var surfaces, volumeReprs, volumeData, volumePos, volumeNeg, volume, structure, structureReprs;
        var _a, _b;
        return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__generator"])(this, function (_c) {
            switch (_c.label) {
                case 0:
                    surfaces = plugin.build();
                    volumeReprs = [];
                    volumeData = (_b = (_a = data.volume.cell) === null || _a === void 0 ? void 0 : _a.obj) === null || _b === void 0 ? void 0 : _b.data;
                    if (volumeData && _mol_model_volume__WEBPACK_IMPORTED_MODULE_5__["Volume"].isOrbitals(volumeData)) {
                        volumePos = surfaces.to(data.volume).apply(_transforms__WEBPACK_IMPORTED_MODULE_1__["StateTransforms"].Representation.VolumeRepresentation3D, Object(_helpers_volume_representation_params__WEBPACK_IMPORTED_MODULE_6__["createVolumeRepresentationParams"])(plugin, volumeData, {
                            type: 'isosurface',
                            typeParams: { isoValue: _mol_model_volume__WEBPACK_IMPORTED_MODULE_5__["Volume"].IsoValue.relative(1), alpha: 0.4 },
                            color: 'uniform',
                            colorParams: { value: _mol_util_color_names__WEBPACK_IMPORTED_MODULE_4__["ColorNames"].blue }
                        }));
                        volumeNeg = surfaces.to(data.volume).apply(_transforms__WEBPACK_IMPORTED_MODULE_1__["StateTransforms"].Representation.VolumeRepresentation3D, Object(_helpers_volume_representation_params__WEBPACK_IMPORTED_MODULE_6__["createVolumeRepresentationParams"])(plugin, volumeData, {
                            type: 'isosurface',
                            typeParams: { isoValue: _mol_model_volume__WEBPACK_IMPORTED_MODULE_5__["Volume"].IsoValue.relative(-1), alpha: 0.4 },
                            color: 'uniform',
                            colorParams: { value: _mol_util_color_names__WEBPACK_IMPORTED_MODULE_4__["ColorNames"].red }
                        }));
                        volumeReprs.push(volumePos.selector, volumeNeg.selector);
                    }
                    else {
                        volume = surfaces.to(data.volume).apply(_transforms__WEBPACK_IMPORTED_MODULE_1__["StateTransforms"].Representation.VolumeRepresentation3D, Object(_helpers_volume_representation_params__WEBPACK_IMPORTED_MODULE_6__["createVolumeRepresentationParams"])(plugin, volumeData, {
                            type: 'isosurface',
                            typeParams: { isoValue: _mol_model_volume__WEBPACK_IMPORTED_MODULE_5__["Volume"].IsoValue.relative(2), alpha: 0.4 },
                            color: 'uniform',
                            colorParams: { value: _mol_util_color_names__WEBPACK_IMPORTED_MODULE_4__["ColorNames"].grey }
                        }));
                        volumeReprs.push(volume.selector);
                    }
                    return [4 /*yield*/, plugin.builders.structure.representation.applyPreset(data.structure, 'auto')];
                case 1:
                    structure = _c.sent();
                    return [4 /*yield*/, surfaces.commit()];
                case 2:
                    _c.sent();
                    structureReprs = [];
                    Object(_mol_util_object__WEBPACK_IMPORTED_MODULE_7__["objectForEach"])(structure === null || structure === void 0 ? void 0 : structure.representations, function (r) {
                        if (r)
                            structureReprs.push(r);
                    });
                    return [2 /*return*/, Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__spreadArrays"])(volumeReprs, structureReprs)];
            }
        });
    }); }
});
var DscifProvider = Object(_provider__WEBPACK_IMPORTED_MODULE_2__["DataFormatProvider"])({
    label: 'DensityServer CIF',
    description: 'DensityServer CIF',
    category: VolumeFormatCategory,
    stringExtensions: ['cif'],
    binaryExtensions: ['bcif'],
    isApplicable: function (info, data) {
        return Object(_provider__WEBPACK_IMPORTED_MODULE_2__["guessCifVariant"])(info, data) === 'dscif' ? true : false;
    },
    parse: function (plugin, data, params) { return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"])(void 0, void 0, void 0, function () {
        var cifCell, b, blocks, volumes, _i, blocks_1, block, _a, volumes_1, v;
        return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__generator"])(this, function (_b) {
            switch (_b.label) {
                case 0: return [4 /*yield*/, plugin.build().to(data).apply(_transforms__WEBPACK_IMPORTED_MODULE_1__["StateTransforms"].Data.ParseCif).commit()];
                case 1:
                    cifCell = _b.sent();
                    b = plugin.build().to(cifCell);
                    blocks = cifCell.obj.data.blocks.slice(1);
                    if (blocks.length !== 1 && blocks.length !== 2)
                        throw new Error('unknown number of blocks');
                    volumes = [];
                    for (_i = 0, blocks_1 = blocks; _i < blocks_1.length; _i++) {
                        block = blocks_1[_i];
                        volumes.push(b.apply(_transforms__WEBPACK_IMPORTED_MODULE_1__["StateTransforms"].Volume.VolumeFromDensityServerCif, { blockHeader: block.header, entryId: params === null || params === void 0 ? void 0 : params.entryId }).selector);
                    }
                    return [4 /*yield*/, b.commit()];
                case 2:
                    _b.sent();
                    _a = 0, volumes_1 = volumes;
                    _b.label = 3;
                case 3:
                    if (!(_a < volumes_1.length)) return [3 /*break*/, 6];
                    v = volumes_1[_a];
                    return [4 /*yield*/, tryObtainRecommendedIsoValue(plugin, v.data)];
                case 4:
                    _b.sent();
                    _b.label = 5;
                case 5:
                    _a++;
                    return [3 /*break*/, 3];
                case 6: return [2 /*return*/, { volumes: volumes }];
            }
        });
    }); },
    visuals: function (plugin, data) { return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"])(void 0, void 0, void 0, function () {
        var volumes, tree, visuals, isoValue, posParams, negParams;
        return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__generator"])(this, function (_a) {
            switch (_a.label) {
                case 0:
                    volumes = data.volumes;
                    tree = plugin.build();
                    visuals = [];
                    if (volumes.length > 0) {
                        isoValue = (volumes[0].data && tryGetRecomendedIsoValue(volumes[0].data)) || _mol_model_volume__WEBPACK_IMPORTED_MODULE_5__["Volume"].IsoValue.relative(1.5);
                        visuals[0] = tree
                            .to(volumes[0])
                            .apply(_transforms__WEBPACK_IMPORTED_MODULE_1__["StateTransforms"].Representation.VolumeRepresentation3D, _transforms_representation__WEBPACK_IMPORTED_MODULE_3__["VolumeRepresentation3DHelpers"].getDefaultParamsStatic(plugin, 'isosurface', { isoValue: isoValue, alpha: 1 }, 'uniform', { value: _mol_util_color_names__WEBPACK_IMPORTED_MODULE_4__["ColorNames"].teal }))
                            .selector;
                    }
                    if (volumes.length > 1) {
                        posParams = _transforms_representation__WEBPACK_IMPORTED_MODULE_3__["VolumeRepresentation3DHelpers"].getDefaultParamsStatic(plugin, 'isosurface', { isoValue: _mol_model_volume__WEBPACK_IMPORTED_MODULE_5__["Volume"].IsoValue.relative(3), alpha: 0.3 }, 'uniform', { value: _mol_util_color_names__WEBPACK_IMPORTED_MODULE_4__["ColorNames"].green });
                        negParams = _transforms_representation__WEBPACK_IMPORTED_MODULE_3__["VolumeRepresentation3DHelpers"].getDefaultParamsStatic(plugin, 'isosurface', { isoValue: _mol_model_volume__WEBPACK_IMPORTED_MODULE_5__["Volume"].IsoValue.relative(-3), alpha: 0.3 }, 'uniform', { value: _mol_util_color_names__WEBPACK_IMPORTED_MODULE_4__["ColorNames"].red });
                        visuals[visuals.length] = tree.to(volumes[1]).apply(_transforms__WEBPACK_IMPORTED_MODULE_1__["StateTransforms"].Representation.VolumeRepresentation3D, posParams).selector;
                        visuals[visuals.length] = tree.to(volumes[1]).apply(_transforms__WEBPACK_IMPORTED_MODULE_1__["StateTransforms"].Representation.VolumeRepresentation3D, negParams).selector;
                    }
                    return [4 /*yield*/, tree.commit()];
                case 1:
                    _a.sent();
                    return [2 /*return*/, visuals];
            }
        });
    }); }
});
var BuiltInVolumeFormats = [
    ['ccp4', Ccp4Provider],
    ['dsn6', Dsn6Provider],
    ['cube', CubeProvider],
    ['dx', DxProvider],
    ['dscif', DscifProvider],
];
//# sourceMappingURL=volume.js.map

/***/ }),

/***/ "./lib/mol-plugin-state/helpers/root-structure.js":
/*!********************************************************!*\
  !*** ./lib/mol-plugin-state/helpers/root-structure.js ***!
  \********************************************************/
/*! exports provided: RootStructureDefinition */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "RootStructureDefinition", function() { return RootStructureDefinition; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _mol_model_structure__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../mol-model/structure */ "./lib/mol-model/structure.js");
/* harmony import */ var _mol_util_string__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../mol-util/string */ "./lib/mol-util/string.js");
/* harmony import */ var _mol_math_geometry__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../mol-math/geometry */ "./lib/mol-math/geometry.js");
/* harmony import */ var _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../mol-util/param-definition */ "./lib/mol-util/param-definition.js");
/* harmony import */ var _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../mol-math/linear-algebra */ "./lib/mol-math/linear-algebra.js");
/* harmony import */ var _mol_model_structure_model_properties_symmetry__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../../mol-model/structure/model/properties/symmetry */ "./lib/mol-model/structure/model/properties/symmetry.js");
/* harmony import */ var _objects__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../objects */ "./lib/mol-plugin-state/objects.js");
/* harmony import */ var _mol_model_formats_structure_property_symmetry__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ../../mol-model-formats/structure/property/symmetry */ "./lib/mol-model-formats/structure/property/symmetry.js");
/**
 * Copyright (c) 2019-2020 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author David Sehnal <david.sehnal@gmail.com>
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */









var RootStructureDefinition;
(function (RootStructureDefinition) {
    function getParams(model, defaultValue) {
        var symmetry = model && _mol_model_formats_structure_property_symmetry__WEBPACK_IMPORTED_MODULE_8__["ModelSymmetry"].Provider.get(model);
        var assemblyIds = symmetry ? symmetry.assemblies.map(function (a) { return [a.id, a.id + ": " + Object(_mol_util_string__WEBPACK_IMPORTED_MODULE_2__["stringToWords"])(a.details)]; }) : [];
        var showSymm = !symmetry ? true : !_mol_math_geometry__WEBPACK_IMPORTED_MODULE_3__["SpacegroupCell"].isZero(symmetry.spacegroup.cell);
        var operatorOptions = [];
        if (symmetry) {
            var operators = symmetry.spacegroup.operators;
            for (var i = 0, il = operators.length; i < il; i++) {
                operatorOptions.push([i, i + 1 + ": " + _mol_math_geometry__WEBPACK_IMPORTED_MODULE_3__["Spacegroup"].getOperatorXyz(operators[i])]);
            }
        }
        var asymIdsOptions = [];
        if (model) {
            model.properties.structAsymMap.forEach(function (v) {
                var label = v.id === v.auth_id ? v.id : v.id + " [auth " + v.auth_id + "]";
                asymIdsOptions.push([v.id, label]);
            });
        }
        var modes = {
            auto: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_4__["ParamDefinition"].EmptyGroup(),
            model: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_4__["ParamDefinition"].EmptyGroup(),
            assembly: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_4__["ParamDefinition"].Group({
                id: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_4__["ParamDefinition"].Optional(model
                    ? _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_4__["ParamDefinition"].Select(assemblyIds.length ? assemblyIds[0][0] : '', assemblyIds, { label: 'Asm Id', description: 'Assembly Id' })
                    : _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_4__["ParamDefinition"].Text('', { label: 'Asm Id', description: 'Assembly Id (use empty for the 1st assembly)' }))
            }, { isFlat: true }),
            'symmetry-mates': _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_4__["ParamDefinition"].Group({
                radius: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_4__["ParamDefinition"].Numeric(5, { min: 0, max: 50, step: 1 })
            }, { isFlat: true }),
            'symmetry': _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_4__["ParamDefinition"].Group({
                ijkMin: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_4__["ParamDefinition"].Vec3(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_5__["Vec3"].create(-1, -1, -1), { step: 1 }, { label: 'Min IJK', fieldLabels: { x: 'I', y: 'J', z: 'K' } }),
                ijkMax: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_4__["ParamDefinition"].Vec3(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_5__["Vec3"].create(1, 1, 1), { step: 1 }, { label: 'Max IJK', fieldLabels: { x: 'I', y: 'J', z: 'K' } })
            }, { isFlat: true }),
            'symmetry-assembly': _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_4__["ParamDefinition"].Group({
                generators: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_4__["ParamDefinition"].ObjectList({
                    operators: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_4__["ParamDefinition"].ObjectList({
                        index: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_4__["ParamDefinition"].Select(0, operatorOptions),
                        shift: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_4__["ParamDefinition"].Vec3(Object(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_5__["Vec3"])(), { step: 1 }, { label: 'IJK', fieldLabels: { x: 'I', y: 'J', z: 'K' } })
                    }, function (e) { return e.index + 1 + "_" + e.shift.map(function (a) { return a + 5; }).join(''); }, {
                        defaultValue: []
                    }),
                    asymIds: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_4__["ParamDefinition"].MultiSelect([], asymIdsOptions)
                }, function (e) { return e.asymIds.length + " asym ids, " + e.operators.length + " operators"; }, {
                    defaultValue: []
                })
            }, { isFlat: true })
        };
        var options = [];
        if (defaultValue === 'auto') {
            options.push(['auto', 'Auto']);
        }
        options.push(['model', 'Model']);
        if (assemblyIds.length > 0) {
            options.push(['assembly', 'Assembly']);
        }
        if (showSymm) {
            options.push(['symmetry-mates', 'Symmetry Mates']);
            options.push(['symmetry', 'Symmetry (indices)']);
            options.push(['symmetry-assembly', 'Symmetry (assembly)']);
        }
        return {
            type: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_4__["ParamDefinition"].MappedStatic(defaultValue || 'model', modes, { options: options })
        };
    }
    RootStructureDefinition.getParams = getParams;
    function canAutoUpdate(oldParams, newParams) {
        if (newParams.name === 'symmetry-assembly' || (newParams.name === 'symmetry' && oldParams.name === 'symmetry'))
            return false;
        return true;
    }
    RootStructureDefinition.canAutoUpdate = canAutoUpdate;
    function buildAssembly(plugin, ctx, model, id) {
        return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"])(this, void 0, void 0, function () {
            var asm, symmetry, base, label, s, props;
            return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__generator"])(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        asm = void 0;
                        symmetry = _mol_model_formats_structure_property_symmetry__WEBPACK_IMPORTED_MODULE_8__["ModelSymmetry"].Provider.get(model);
                        // if no id is specified, use the 1st assembly.
                        if (!id && symmetry && symmetry.assemblies.length !== 0) {
                            id = symmetry.assemblies[0].id;
                        }
                        if (!symmetry || symmetry.assemblies.length === 0) {
                            plugin.log.warn("Model '" + model.entryId + "' has no assembly, returning model structure.");
                        }
                        else {
                            asm = _mol_model_structure_model_properties_symmetry__WEBPACK_IMPORTED_MODULE_6__["Symmetry"].findAssembly(model, id || '');
                            if (!asm) {
                                plugin.log.warn("Model '" + model.entryId + "' has no assembly called '" + id + "', returning model structure.");
                            }
                        }
                        base = _mol_model_structure__WEBPACK_IMPORTED_MODULE_1__["Structure"].ofModel(model);
                        if (!asm) {
                            label = { label: 'Model', description: _mol_model_structure__WEBPACK_IMPORTED_MODULE_1__["Structure"].elementDescription(base) };
                            return [2 /*return*/, new _objects__WEBPACK_IMPORTED_MODULE_7__["PluginStateObject"].Molecule.Structure(base, label)];
                        }
                        id = asm.id;
                        return [4 /*yield*/, _mol_model_structure__WEBPACK_IMPORTED_MODULE_1__["StructureSymmetry"].buildAssembly(base, id).runInContext(ctx)];
                    case 1:
                        s = _a.sent();
                        props = { label: "Assembly " + id, description: _mol_model_structure__WEBPACK_IMPORTED_MODULE_1__["Structure"].elementDescription(s) };
                        return [2 /*return*/, new _objects__WEBPACK_IMPORTED_MODULE_7__["PluginStateObject"].Molecule.Structure(s, props)];
                }
            });
        });
    }
    function buildSymmetry(ctx, model, ijkMin, ijkMax) {
        return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"])(this, void 0, void 0, function () {
            var base, s, props;
            return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__generator"])(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        base = _mol_model_structure__WEBPACK_IMPORTED_MODULE_1__["Structure"].ofModel(model);
                        return [4 /*yield*/, _mol_model_structure__WEBPACK_IMPORTED_MODULE_1__["StructureSymmetry"].buildSymmetryRange(base, ijkMin, ijkMax).runInContext(ctx)];
                    case 1:
                        s = _a.sent();
                        props = { label: "Symmetry [" + ijkMin + "] to [" + ijkMax + "]", description: _mol_model_structure__WEBPACK_IMPORTED_MODULE_1__["Structure"].elementDescription(s) };
                        return [2 /*return*/, new _objects__WEBPACK_IMPORTED_MODULE_7__["PluginStateObject"].Molecule.Structure(s, props)];
                }
            });
        });
    }
    function buildSymmetryMates(ctx, model, radius) {
        return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"])(this, void 0, void 0, function () {
            var base, s, props;
            return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__generator"])(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        base = _mol_model_structure__WEBPACK_IMPORTED_MODULE_1__["Structure"].ofModel(model);
                        return [4 /*yield*/, _mol_model_structure__WEBPACK_IMPORTED_MODULE_1__["StructureSymmetry"].builderSymmetryMates(base, radius).runInContext(ctx)];
                    case 1:
                        s = _a.sent();
                        props = { label: "Symmetry Mates", description: _mol_model_structure__WEBPACK_IMPORTED_MODULE_1__["Structure"].elementDescription(s) };
                        return [2 /*return*/, new _objects__WEBPACK_IMPORTED_MODULE_7__["PluginStateObject"].Molecule.Structure(s, props)];
                }
            });
        });
    }
    function buildSymmetryAssembly(ctx, model, generators, symmetry) {
        return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"])(this, void 0, void 0, function () {
            var base, s, props;
            return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__generator"])(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        base = _mol_model_structure__WEBPACK_IMPORTED_MODULE_1__["Structure"].ofModel(model);
                        return [4 /*yield*/, _mol_model_structure__WEBPACK_IMPORTED_MODULE_1__["StructureSymmetry"].buildSymmetryAssembly(base, generators, symmetry).runInContext(ctx)];
                    case 1:
                        s = _a.sent();
                        props = { label: "Symmetry Assembly", description: _mol_model_structure__WEBPACK_IMPORTED_MODULE_1__["Structure"].elementDescription(s) };
                        return [2 /*return*/, new _objects__WEBPACK_IMPORTED_MODULE_7__["PluginStateObject"].Molecule.Structure(s, props)];
                }
            });
        });
    }
    function create(plugin, ctx, model, params) {
        return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"])(this, void 0, void 0, function () {
            var symmetry, s, s;
            return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__generator"])(this, function (_a) {
                symmetry = _mol_model_formats_structure_property_symmetry__WEBPACK_IMPORTED_MODULE_8__["ModelSymmetry"].Provider.get(model);
                if (!symmetry || !params || params.name === 'model') {
                    s = _mol_model_structure__WEBPACK_IMPORTED_MODULE_1__["Structure"].ofModel(model);
                    return [2 /*return*/, new _objects__WEBPACK_IMPORTED_MODULE_7__["PluginStateObject"].Molecule.Structure(s, { label: 'Model', description: _mol_model_structure__WEBPACK_IMPORTED_MODULE_1__["Structure"].elementDescription(s) })];
                }
                if (params.name === 'auto') {
                    if (symmetry.assemblies.length === 0) {
                        s = _mol_model_structure__WEBPACK_IMPORTED_MODULE_1__["Structure"].ofModel(model);
                        return [2 /*return*/, new _objects__WEBPACK_IMPORTED_MODULE_7__["PluginStateObject"].Molecule.Structure(s, { label: 'Model', description: _mol_model_structure__WEBPACK_IMPORTED_MODULE_1__["Structure"].elementDescription(s) })];
                    }
                    else {
                        return [2 /*return*/, buildAssembly(plugin, ctx, model)];
                    }
                }
                if (params.name === 'assembly') {
                    return [2 /*return*/, buildAssembly(plugin, ctx, model, params.params.id)];
                }
                if (params.name === 'symmetry') {
                    return [2 /*return*/, buildSymmetry(ctx, model, params.params.ijkMin, params.params.ijkMax)];
                }
                if (params.name === 'symmetry-mates') {
                    return [2 /*return*/, buildSymmetryMates(ctx, model, params.params.radius)];
                }
                if (params.name === 'symmetry-assembly') {
                    return [2 /*return*/, buildSymmetryAssembly(ctx, model, params.params.generators, symmetry)];
                }
                throw new Error("Unknown represetation type: " + params.name);
            });
        });
    }
    RootStructureDefinition.create = create;
})(RootStructureDefinition || (RootStructureDefinition = {}));
//# sourceMappingURL=root-structure.js.map

/***/ }),

/***/ "./lib/mol-plugin-state/helpers/structure-clipping.js":
/*!************************************************************!*\
  !*** ./lib/mol-plugin-state/helpers/structure-clipping.js ***!
  \************************************************************/
/*! exports provided: setStructureClipping */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setStructureClipping", function() { return setStructureClipping; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _mol_model_structure__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../mol-model/structure */ "./lib/mol-model/structure.js");
/* harmony import */ var _mol_plugin_state_transforms__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../mol-plugin-state/transforms */ "./lib/mol-plugin-state/transforms.js");
/* harmony import */ var _mol_state__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../mol-state */ "./lib/mol-state/index.js");
/* harmony import */ var _mol_model_loci__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../mol-model/loci */ "./lib/mol-model/loci.js");
/* harmony import */ var _mol_theme_clipping__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../mol-theme/clipping */ "./lib/mol-theme/clipping.js");
/**
 * Copyright (c) 2019-2020 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 * @author David Sehnal <david.sehnal@gmail.com>
 */






var ClippingManagerTag = 'clipping-controls';
function setStructureClipping(plugin, components, groups, lociGetter, types) {
    return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"])(this, void 0, void 0, function () {
        var _this = this;
        return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__generator"])(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, eachRepr(plugin, components, function (update, repr, clippingCell) { return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"])(_this, void 0, void 0, function () {
                        var structure, loci, layer, bundleLayers, filtered, filtered;
                        return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__generator"])(this, function (_a) {
                            switch (_a.label) {
                                case 0:
                                    if (types && types.length > 0 && !types.includes(repr.params.values.type.name))
                                        return [2 /*return*/];
                                    structure = repr.obj.data.source.data;
                                    return [4 /*yield*/, lociGetter(structure.root)];
                                case 1:
                                    loci = _a.sent();
                                    if (_mol_model_loci__WEBPACK_IMPORTED_MODULE_4__["Loci"].isEmpty(loci))
                                        return [2 /*return*/];
                                    layer = {
                                        bundle: _mol_model_structure__WEBPACK_IMPORTED_MODULE_1__["StructureElement"].Bundle.fromLoci(loci),
                                        groups: groups
                                    };
                                    if (clippingCell) {
                                        bundleLayers = Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__spreadArrays"])(clippingCell.params.values.layers, [layer]);
                                        filtered = getFilteredBundle(bundleLayers, structure);
                                        update.to(clippingCell).update(_mol_theme_clipping__WEBPACK_IMPORTED_MODULE_5__["Clipping"].toBundle(filtered));
                                    }
                                    else {
                                        filtered = getFilteredBundle([layer], structure);
                                        update.to(repr.transform.ref)
                                            .apply(_mol_plugin_state_transforms__WEBPACK_IMPORTED_MODULE_2__["StateTransforms"].Representation.ClippingStructureRepresentation3DFromBundle, _mol_theme_clipping__WEBPACK_IMPORTED_MODULE_5__["Clipping"].toBundle(filtered), { tags: ClippingManagerTag });
                                    }
                                    return [2 /*return*/];
                            }
                        });
                    }); })];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    });
}
function eachRepr(plugin, components, callback) {
    return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"])(this, void 0, void 0, function () {
        var state, update, _i, components_1, c, _a, _b, r, clipping;
        return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__generator"])(this, function (_c) {
            switch (_c.label) {
                case 0:
                    state = plugin.state.data;
                    update = state.build();
                    _i = 0, components_1 = components;
                    _c.label = 1;
                case 1:
                    if (!(_i < components_1.length)) return [3 /*break*/, 6];
                    c = components_1[_i];
                    _a = 0, _b = c.representations;
                    _c.label = 2;
                case 2:
                    if (!(_a < _b.length)) return [3 /*break*/, 5];
                    r = _b[_a];
                    clipping = state.select(_mol_state__WEBPACK_IMPORTED_MODULE_3__["StateSelection"].Generators.ofTransformer(_mol_plugin_state_transforms__WEBPACK_IMPORTED_MODULE_2__["StateTransforms"].Representation.ClippingStructureRepresentation3DFromBundle, r.cell.transform.ref).withTag(ClippingManagerTag));
                    return [4 /*yield*/, callback(update, r.cell, clipping[0])];
                case 3:
                    _c.sent();
                    _c.label = 4;
                case 4:
                    _a++;
                    return [3 /*break*/, 2];
                case 5:
                    _i++;
                    return [3 /*break*/, 1];
                case 6: return [2 /*return*/, update.commit({ doNotUpdateCurrent: true })];
            }
        });
    });
}
/** filter clipping layers for given structure */
function getFilteredBundle(layers, structure) {
    var clipping = _mol_theme_clipping__WEBPACK_IMPORTED_MODULE_5__["Clipping"].ofBundle(layers, structure.root);
    var merged = _mol_theme_clipping__WEBPACK_IMPORTED_MODULE_5__["Clipping"].merge(clipping);
    return _mol_theme_clipping__WEBPACK_IMPORTED_MODULE_5__["Clipping"].filter(merged, structure);
}
//# sourceMappingURL=structure-clipping.js.map

/***/ }),

/***/ "./lib/mol-plugin-state/helpers/structure-component.js":
/*!*************************************************************!*\
  !*** ./lib/mol-plugin-state/helpers/structure-component.js ***!
  \*************************************************************/
/*! exports provided: StaticStructureComponentTypes, StructureComponentParams, createStructureComponent, updateStructureComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "StaticStructureComponentTypes", function() { return StaticStructureComponentTypes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "StructureComponentParams", function() { return StructureComponentParams; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createStructureComponent", function() { return createStructureComponent; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "updateStructureComponent", function() { return updateStructureComponent; });
/* harmony import */ var _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../mol-util/param-definition */ "./lib/mol-util/param-definition.js");
/* harmony import */ var _mol_script_language_builder__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../mol-script/language/builder */ "./lib/mol-script/language/builder.js");
/* harmony import */ var _mol_model_structure__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../mol-model/structure */ "./lib/mol-model/structure.js");
/* harmony import */ var _structure_query__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./structure-query */ "./lib/mol-plugin-state/helpers/structure-query.js");
/* harmony import */ var _objects__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../objects */ "./lib/mol-plugin-state/objects.js");
/* harmony import */ var _structure_selection_query__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./structure-selection-query */ "./lib/mol-plugin-state/helpers/structure-selection-query.js");
/* harmony import */ var _mol_state__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../../mol-state */ "./lib/mol-state/index.js");
/* harmony import */ var _mol_script_script__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../../mol-script/script */ "./lib/mol-script/script.js");
/**
 * Copyright (c) 2020 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author David Sehnal <david.sehnal@gmail.com>
 */








var StaticStructureComponentTypes = [
    'all',
    'polymer',
    'protein',
    'nucleic',
    'water',
    'ion',
    'lipid',
    'branched',
    'ligand',
    'non-standard',
    'coarse'
];
var StructureComponentParams = {
    type: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_0__["ParamDefinition"].MappedStatic('static', {
        static: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_0__["ParamDefinition"].Text('polymer'),
        expression: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_0__["ParamDefinition"].Value(_mol_script_language_builder__WEBPACK_IMPORTED_MODULE_1__["MolScriptBuilder"].struct.generator.all),
        bundle: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_0__["ParamDefinition"].Value(_mol_model_structure__WEBPACK_IMPORTED_MODULE_2__["StructureElement"].Bundle.Empty),
        script: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_0__["ParamDefinition"].Script({ language: 'mol-script', expression: '(sel.atom.all)' }),
    }, { isHidden: true }),
    nullIfEmpty: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_0__["ParamDefinition"].Optional(_mol_util_param_definition__WEBPACK_IMPORTED_MODULE_0__["ParamDefinition"].Boolean(true, { isHidden: true })),
    label: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_0__["ParamDefinition"].Text('', { isHidden: true })
};
function createStructureComponent(a, params, cache) {
    cache.source = a;
    var component = _mol_model_structure__WEBPACK_IMPORTED_MODULE_2__["Structure"].Empty;
    var label = void 0;
    switch (params.type.name) {
        case 'static': {
            var query = void 0;
            switch (params.type.params) {
                case 'all':
                    query = _structure_selection_query__WEBPACK_IMPORTED_MODULE_5__["StructureSelectionQueries"].all.query;
                    label = 'All';
                    break;
                case 'polymer':
                    query = _structure_selection_query__WEBPACK_IMPORTED_MODULE_5__["StructureSelectionQueries"].polymer.query;
                    label = 'Polymer';
                    break;
                case 'protein':
                    query = _structure_selection_query__WEBPACK_IMPORTED_MODULE_5__["StructureSelectionQueries"].protein.query;
                    label = 'Protein';
                    break;
                case 'nucleic':
                    query = _structure_selection_query__WEBPACK_IMPORTED_MODULE_5__["StructureSelectionQueries"].nucleic.query;
                    label = 'Nucleic';
                    break;
                case 'water':
                    query = _mol_model_structure__WEBPACK_IMPORTED_MODULE_2__["Queries"].internal.water();
                    label = 'Water';
                    break;
                case 'ion':
                    query = _structure_selection_query__WEBPACK_IMPORTED_MODULE_5__["StructureSelectionQueries"].ion.query;
                    label = 'Ion';
                    break;
                case 'lipid':
                    query = _structure_selection_query__WEBPACK_IMPORTED_MODULE_5__["StructureSelectionQueries"].lipid.query;
                    label = 'Lipid';
                    break;
                case 'branched':
                    query = _structure_selection_query__WEBPACK_IMPORTED_MODULE_5__["StructureSelectionQueries"].branchedPlusConnected.query;
                    label = 'Branched';
                    break;
                case 'ligand':
                    query = _structure_selection_query__WEBPACK_IMPORTED_MODULE_5__["StructureSelectionQueries"].ligandPlusConnected.query;
                    label = 'Ligand';
                    break;
                case 'non-standard':
                    query = _structure_selection_query__WEBPACK_IMPORTED_MODULE_5__["StructureSelectionQueries"].nonStandardPolymer.query;
                    label = 'Non-standard';
                    break;
                case 'coarse':
                    query = _structure_selection_query__WEBPACK_IMPORTED_MODULE_5__["StructureSelectionQueries"].coarse.query;
                    label = 'Coarse';
                    break;
                default: throw new Error(params.type + " is a not valid complex element.");
            }
            var result = query(new _mol_model_structure__WEBPACK_IMPORTED_MODULE_2__["QueryContext"](a));
            component = _mol_model_structure__WEBPACK_IMPORTED_MODULE_2__["StructureSelection"].unionStructure(result);
            break;
        }
        case 'script':
        case 'expression': {
            var _a = _structure_query__WEBPACK_IMPORTED_MODULE_3__["StructureQueryHelper"].createAndRun(a, params.type.params), selection = _a.selection, entry = _a.entry;
            cache.entry = entry;
            component = _mol_model_structure__WEBPACK_IMPORTED_MODULE_2__["StructureSelection"].unionStructure(selection);
            break;
        }
        case 'bundle': {
            if (params.type.params.hash !== a.hashCode)
                break;
            component = _mol_model_structure__WEBPACK_IMPORTED_MODULE_2__["StructureElement"].Bundle.toStructure(params.type.params, a);
            break;
        }
    }
    if (params.nullIfEmpty && component.elementCount === 0)
        return _mol_state__WEBPACK_IMPORTED_MODULE_6__["StateObject"].Null;
    var props = { label: "" + (params.label || label || 'Component'), description: _mol_model_structure__WEBPACK_IMPORTED_MODULE_2__["Structure"].elementDescription(component) };
    return new _objects__WEBPACK_IMPORTED_MODULE_4__["PluginStateObject"].Molecule.Structure(component, props);
}
function updateStructureComponent(a, b, oldParams, newParams, cache) {
    if (oldParams.type.name !== newParams.type.name)
        return _mol_state__WEBPACK_IMPORTED_MODULE_6__["StateTransformer"].UpdateResult.Recreate;
    var updated = false;
    switch (newParams.type.name) {
        case 'static': {
            if (oldParams.type.params !== newParams.type.params) {
                return _mol_state__WEBPACK_IMPORTED_MODULE_6__["StateTransformer"].UpdateResult.Recreate;
            }
            if (!_mol_model_structure__WEBPACK_IMPORTED_MODULE_2__["Structure"].areEquivalent(a, cache.source)) {
                return _mol_state__WEBPACK_IMPORTED_MODULE_6__["StateTransformer"].UpdateResult.Recreate;
            }
            if (b.data.model === a.model)
                return _mol_state__WEBPACK_IMPORTED_MODULE_6__["StateTransformer"].UpdateResult.Unchanged;
            if (!_mol_model_structure__WEBPACK_IMPORTED_MODULE_2__["Model"].areHierarchiesEqual(a.model, b.data.model))
                return _mol_state__WEBPACK_IMPORTED_MODULE_6__["StateTransformer"].UpdateResult.Recreate;
            b.data = b.data.remapModel(a.model);
            return _mol_state__WEBPACK_IMPORTED_MODULE_6__["StateTransformer"].UpdateResult.Updated;
        }
        case 'script':
            if (!_mol_script_script__WEBPACK_IMPORTED_MODULE_7__["Script"].areEqual(oldParams.type.params, newParams.type.params)) {
                return _mol_state__WEBPACK_IMPORTED_MODULE_6__["StateTransformer"].UpdateResult.Recreate;
            }
        case 'expression': {
            if (oldParams.type.params !== newParams.type.params) {
                return _mol_state__WEBPACK_IMPORTED_MODULE_6__["StateTransformer"].UpdateResult.Recreate;
            }
            if (a === cache.source)
                break;
            var entry = cache.entry;
            var selection = _structure_query__WEBPACK_IMPORTED_MODULE_3__["StructureQueryHelper"].updateStructure(entry, a);
            cache.source = a;
            b.data = _mol_model_structure__WEBPACK_IMPORTED_MODULE_2__["StructureSelection"].unionStructure(selection);
            _structure_query__WEBPACK_IMPORTED_MODULE_3__["StructureQueryHelper"].updateStructureObject(b, selection, newParams.label);
            updated = true;
            break;
        }
        case 'bundle': {
            if (a === cache.source && _mol_model_structure__WEBPACK_IMPORTED_MODULE_2__["StructureElement"].Bundle.areEqual(oldParams.type.params, newParams.type.params)) {
                break;
            }
            cache.source = a;
            if (newParams.type.params.hash !== a.hashCode) {
                updated = b.data.elementCount !== 0;
                b.data = b.data.elementCount === 0 ? b.data : _mol_model_structure__WEBPACK_IMPORTED_MODULE_2__["Structure"].Empty;
            }
            else {
                updated = true;
                b.data = _mol_model_structure__WEBPACK_IMPORTED_MODULE_2__["StructureElement"].Bundle.toStructure(newParams.type.params, a);
            }
            break;
        }
    }
    if (updated) {
        if (newParams.nullIfEmpty && b.data.elementCount === 0)
            return _mol_state__WEBPACK_IMPORTED_MODULE_6__["StateTransformer"].UpdateResult.Null;
        b.description = _mol_model_structure__WEBPACK_IMPORTED_MODULE_2__["Structure"].elementDescription(b.data);
    }
    if (oldParams.label !== newParams.label) {
        updated = true;
        b.label = "" + (newParams.label || b.label);
    }
    return updated ? _mol_state__WEBPACK_IMPORTED_MODULE_6__["StateTransformer"].UpdateResult.Updated : _mol_state__WEBPACK_IMPORTED_MODULE_6__["StateTransformer"].UpdateResult.Unchanged;
}
//# sourceMappingURL=structure-component.js.map

/***/ }),

/***/ "./lib/mol-plugin-state/helpers/structure-overpaint.js":
/*!*************************************************************!*\
  !*** ./lib/mol-plugin-state/helpers/structure-overpaint.js ***!
  \*************************************************************/
/*! exports provided: setStructureOverpaint, clearStructureOverpaint */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setStructureOverpaint", function() { return setStructureOverpaint; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "clearStructureOverpaint", function() { return clearStructureOverpaint; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _mol_model_structure__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../mol-model/structure */ "./lib/mol-model/structure.js");
/* harmony import */ var _mol_plugin_state_transforms__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../mol-plugin-state/transforms */ "./lib/mol-plugin-state/transforms.js");
/* harmony import */ var _mol_state__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../mol-state */ "./lib/mol-state/index.js");
/* harmony import */ var _mol_theme_overpaint__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../mol-theme/overpaint */ "./lib/mol-theme/overpaint.js");
/* harmony import */ var _mol_util_color__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../mol-util/color */ "./lib/mol-util/color/index.js");
/* harmony import */ var _mol_model_loci__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../../mol-model/loci */ "./lib/mol-model/loci.js");
/**
 * Copyright (c) 2019-2020 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 * @author David Sehnal <david.sehnal@gmail.com>
 */







var OverpaintManagerTag = 'overpaint-controls';
function setStructureOverpaint(plugin, components, color, lociGetter, types) {
    return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"])(this, void 0, void 0, function () {
        var _this = this;
        return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__generator"])(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, eachRepr(plugin, components, function (update, repr, overpaintCell) { return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"])(_this, void 0, void 0, function () {
                        var structure, loci, layer, bundleLayers, filtered, filtered;
                        return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__generator"])(this, function (_a) {
                            switch (_a.label) {
                                case 0:
                                    if (types && types.length > 0 && !types.includes(repr.params.values.type.name))
                                        return [2 /*return*/];
                                    structure = repr.obj.data.source.data;
                                    return [4 /*yield*/, lociGetter(structure.root)];
                                case 1:
                                    loci = _a.sent();
                                    if (_mol_model_loci__WEBPACK_IMPORTED_MODULE_6__["Loci"].isEmpty(loci))
                                        return [2 /*return*/];
                                    layer = {
                                        bundle: _mol_model_structure__WEBPACK_IMPORTED_MODULE_1__["StructureElement"].Bundle.fromLoci(loci),
                                        color: color === -1 ? Object(_mol_util_color__WEBPACK_IMPORTED_MODULE_5__["Color"])(0) : color,
                                        clear: color === -1
                                    };
                                    if (overpaintCell) {
                                        bundleLayers = Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__spreadArrays"])(overpaintCell.params.values.layers, [layer]);
                                        filtered = getFilteredBundle(bundleLayers, structure);
                                        update.to(overpaintCell).update(_mol_theme_overpaint__WEBPACK_IMPORTED_MODULE_4__["Overpaint"].toBundle(filtered));
                                    }
                                    else {
                                        filtered = getFilteredBundle([layer], structure);
                                        update.to(repr.transform.ref)
                                            .apply(_mol_plugin_state_transforms__WEBPACK_IMPORTED_MODULE_2__["StateTransforms"].Representation.OverpaintStructureRepresentation3DFromBundle, _mol_theme_overpaint__WEBPACK_IMPORTED_MODULE_4__["Overpaint"].toBundle(filtered), { tags: OverpaintManagerTag });
                                    }
                                    return [2 /*return*/];
                            }
                        });
                    }); })];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    });
}
function clearStructureOverpaint(plugin, components, types) {
    return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"])(this, void 0, void 0, function () {
        var _this = this;
        return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__generator"])(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, eachRepr(plugin, components, function (update, repr, overpaintCell) { return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"])(_this, void 0, void 0, function () {
                        return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__generator"])(this, function (_a) {
                            if (types && types.length > 0 && !types.includes(repr.params.values.type.name))
                                return [2 /*return*/];
                            if (overpaintCell) {
                                update.delete(overpaintCell.transform.ref);
                            }
                            return [2 /*return*/];
                        });
                    }); })];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    });
}
function eachRepr(plugin, components, callback) {
    return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"])(this, void 0, void 0, function () {
        var state, update, _i, components_1, c, _a, _b, r, overpaint;
        return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__generator"])(this, function (_c) {
            switch (_c.label) {
                case 0:
                    state = plugin.state.data;
                    update = state.build();
                    _i = 0, components_1 = components;
                    _c.label = 1;
                case 1:
                    if (!(_i < components_1.length)) return [3 /*break*/, 6];
                    c = components_1[_i];
                    _a = 0, _b = c.representations;
                    _c.label = 2;
                case 2:
                    if (!(_a < _b.length)) return [3 /*break*/, 5];
                    r = _b[_a];
                    overpaint = state.select(_mol_state__WEBPACK_IMPORTED_MODULE_3__["StateSelection"].Generators.ofTransformer(_mol_plugin_state_transforms__WEBPACK_IMPORTED_MODULE_2__["StateTransforms"].Representation.OverpaintStructureRepresentation3DFromBundle, r.cell.transform.ref).withTag(OverpaintManagerTag));
                    return [4 /*yield*/, callback(update, r.cell, overpaint[0])];
                case 3:
                    _c.sent();
                    _c.label = 4;
                case 4:
                    _a++;
                    return [3 /*break*/, 2];
                case 5:
                    _i++;
                    return [3 /*break*/, 1];
                case 6: return [2 /*return*/, update.commit({ doNotUpdateCurrent: true })];
            }
        });
    });
}
/** filter overpaint layers for given structure */
function getFilteredBundle(layers, structure) {
    var overpaint = _mol_theme_overpaint__WEBPACK_IMPORTED_MODULE_4__["Overpaint"].ofBundle(layers, structure.root);
    var merged = _mol_theme_overpaint__WEBPACK_IMPORTED_MODULE_4__["Overpaint"].merge(overpaint);
    return _mol_theme_overpaint__WEBPACK_IMPORTED_MODULE_4__["Overpaint"].filter(merged, structure);
}
//# sourceMappingURL=structure-overpaint.js.map

/***/ }),

/***/ "./lib/mol-plugin-state/helpers/structure-query.js":
/*!*********************************************************!*\
  !*** ./lib/mol-plugin-state/helpers/structure-query.js ***!
  \*********************************************************/
/*! exports provided: StructureQueryHelper */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "StructureQueryHelper", function() { return StructureQueryHelper; });
/* harmony import */ var _mol_model_structure__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../mol-model/structure */ "./lib/mol-model/structure.js");
/* harmony import */ var _mol_script_script__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../mol-script/script */ "./lib/mol-script/script.js");
/* harmony import */ var _mol_script_runtime_query_compiler__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../mol-script/runtime/query/compiler */ "./lib/mol-script/runtime/query/compiler.js");
/**
 * Copyright (c) 2019 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author David Sehnal <david.sehnal@gmail.com>
 */




var StructureQueryHelper;
(function (StructureQueryHelper) {
    function isUnchanged(entry, query, structure) {
        if (entry.currentStructure !== structure)
            return false;
        if (_mol_script_script__WEBPACK_IMPORTED_MODULE_1__["Script"].is(query)) {
            return !!entry.script && _mol_script_script__WEBPACK_IMPORTED_MODULE_1__["Script"].areEqual(entry.script, query);
        }
        return entry.expression === query;
    }
    StructureQueryHelper.isUnchanged = isUnchanged;
    function create(structure, query) {
        var script = _mol_script_script__WEBPACK_IMPORTED_MODULE_1__["Script"].is(query) ? query : void 0;
        var expression = _mol_script_script__WEBPACK_IMPORTED_MODULE_1__["Script"].is(query) ? _mol_script_script__WEBPACK_IMPORTED_MODULE_1__["Script"].toExpression(query) : query;
        var compiled = Object(_mol_script_runtime_query_compiler__WEBPACK_IMPORTED_MODULE_2__["compile"])(expression);
        return { script: script, expression: expression, compiled: compiled, originalStructure: structure, currentStructure: structure };
    }
    StructureQueryHelper.create = create;
    function run(entry, structure) {
        return entry.compiled(new _mol_model_structure__WEBPACK_IMPORTED_MODULE_0__["QueryContext"](structure));
    }
    StructureQueryHelper.run = run;
    function createAndRun(structure, query) {
        var entry = create(structure, query);
        return { entry: entry, selection: run(entry, structure) };
    }
    StructureQueryHelper.createAndRun = createAndRun;
    function updateStructure(entry, structure) {
        entry.currentStructure = structure;
        return entry.compiled(new _mol_model_structure__WEBPACK_IMPORTED_MODULE_0__["QueryContext"](structure));
    }
    StructureQueryHelper.updateStructure = updateStructure;
    function updateStructureObject(obj, selection, label) {
        var s = _mol_model_structure__WEBPACK_IMPORTED_MODULE_0__["StructureSelection"].unionStructure(selection);
        obj.label = "" + (label || 'Selection');
        obj.description = _mol_model_structure__WEBPACK_IMPORTED_MODULE_0__["Structure"].elementDescription(s);
        obj.data = s;
    }
    StructureQueryHelper.updateStructureObject = updateStructureObject;
})(StructureQueryHelper || (StructureQueryHelper = {}));
//# sourceMappingURL=structure-query.js.map

/***/ }),

/***/ "./lib/mol-plugin-state/helpers/structure-representation-params.js":
/*!*************************************************************************!*\
  !*** ./lib/mol-plugin-state/helpers/structure-representation-params.js ***!
  \*************************************************************************/
/*! exports provided: createStructureRepresentationParams, getStructureThemeTypes, createStructureColorThemeParams, createStructureSizeThemeParams */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createStructureRepresentationParams", function() { return createStructureRepresentationParams; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getStructureThemeTypes", function() { return getStructureThemeTypes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createStructureColorThemeParams", function() { return createStructureColorThemeParams; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createStructureSizeThemeParams", function() { return createStructureSizeThemeParams; });
/* harmony import */ var _mol_model_structure__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../mol-model/structure */ "./lib/mol-model/structure.js");
/* harmony import */ var _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../mol-util/param-definition */ "./lib/mol-util/param-definition.js");
/**
 * Copyright (c) 2020 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author David Sehnal <david.sehnal@gmail.com>
 */


function createStructureRepresentationParams(ctx, structure, props) {
    if (props === void 0) { props = {}; }
    var p = props;
    if (typeof p.type === 'string' || typeof p.color === 'string' || typeof p.size === 'string')
        return createParamsByName(ctx, structure || _mol_model_structure__WEBPACK_IMPORTED_MODULE_0__["Structure"].Empty, props);
    return createParamsProvider(ctx, structure || _mol_model_structure__WEBPACK_IMPORTED_MODULE_0__["Structure"].Empty, props);
}
function getStructureThemeTypes(ctx, structure) {
    var themeCtx = ctx.representation.structure.themes;
    if (!structure)
        return themeCtx.colorThemeRegistry.types;
    return themeCtx.colorThemeRegistry.getApplicableTypes({ structure: structure });
}
function createStructureColorThemeParams(ctx, structure, typeName, themeName, params) {
    var _a = ctx.representation.structure, registry = _a.registry, themes = _a.themes;
    var repr = registry.get(typeName || registry.default.name);
    var color = themes.colorThemeRegistry.get(themeName || repr.defaultColorTheme.name);
    var colorDefaultParams = _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_1__["ParamDefinition"].getDefaultValues(color.getParams({ structure: structure || _mol_model_structure__WEBPACK_IMPORTED_MODULE_0__["Structure"].Empty }));
    if (color.name === repr.defaultColorTheme.name)
        Object.assign(colorDefaultParams, repr.defaultColorTheme.props);
    return { name: color.name, params: Object.assign(colorDefaultParams, params) };
}
function createStructureSizeThemeParams(ctx, structure, typeName, themeName, params) {
    var _a = ctx.representation.structure, registry = _a.registry, themes = _a.themes;
    var repr = registry.get(typeName || registry.default.name);
    var size = themes.sizeThemeRegistry.get(themeName || repr.defaultSizeTheme.name);
    var sizeDefaultParams = _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_1__["ParamDefinition"].getDefaultValues(size.getParams({ structure: structure || _mol_model_structure__WEBPACK_IMPORTED_MODULE_0__["Structure"].Empty }));
    if (size.name === repr.defaultSizeTheme.name)
        Object.assign(sizeDefaultParams, repr.defaultSizeTheme.props);
    return { name: size.name, params: Object.assign(sizeDefaultParams, params) };
}
function createParamsByName(ctx, structure, props) {
    var typeProvider = (props.type && ctx.representation.structure.registry.get(props.type))
        || ctx.representation.structure.registry.default.provider;
    var colorProvider = (props.color && ctx.representation.structure.themes.colorThemeRegistry.get(props.color))
        || ctx.representation.structure.themes.colorThemeRegistry.get(typeProvider.defaultColorTheme.name);
    var sizeProvider = (props.size && ctx.representation.structure.themes.sizeThemeRegistry.get(props.size))
        || ctx.representation.structure.themes.sizeThemeRegistry.get(typeProvider.defaultSizeTheme.name);
    return createParamsProvider(ctx, structure, {
        type: typeProvider,
        typeParams: props.typeParams,
        color: colorProvider,
        colorParams: props.colorParams,
        size: sizeProvider,
        sizeParams: props.sizeParams
    });
}
function createParamsProvider(ctx, structure, props) {
    if (props === void 0) { props = {}; }
    var themeCtx = ctx.representation.structure.themes;
    var themeDataCtx = { structure: structure };
    var repr = props.type || ctx.representation.structure.registry.default.provider;
    var reprDefaultParams = _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_1__["ParamDefinition"].getDefaultValues(repr.getParams(themeCtx, structure));
    var reprParams = Object.assign(reprDefaultParams, props.typeParams);
    var color = props.color || themeCtx.colorThemeRegistry.get(repr.defaultColorTheme.name);
    var colorDefaultParams = _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_1__["ParamDefinition"].getDefaultValues(color.getParams(themeDataCtx));
    if (color.name === repr.defaultColorTheme.name)
        Object.assign(colorDefaultParams, repr.defaultColorTheme.props);
    var colorParams = Object.assign(colorDefaultParams, props.colorParams);
    var size = props.size || themeCtx.sizeThemeRegistry.get(repr.defaultSizeTheme.name);
    var sizeDefaultParams = _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_1__["ParamDefinition"].getDefaultValues(size.getParams(themeDataCtx));
    if (size.name === repr.defaultSizeTheme.name)
        Object.assign(sizeDefaultParams, repr.defaultSizeTheme.props);
    var sizeParams = Object.assign(sizeDefaultParams, props.sizeParams);
    return ({
        type: { name: repr.name, params: reprParams },
        colorTheme: { name: color.name, params: colorParams },
        sizeTheme: { name: size.name, params: sizeParams }
    });
}
//# sourceMappingURL=structure-representation-params.js.map

/***/ }),

/***/ "./lib/mol-plugin-state/helpers/structure-selection-query.js":
/*!*******************************************************************!*\
  !*** ./lib/mol-plugin-state/helpers/structure-selection-query.js ***!
  \*******************************************************************/
/*! exports provided: StructureSelectionCategory, StructureSelectionQuery, ResidueQuery, ElementSymbolQuery, EntityDescriptionQuery, getElementQueries, getNonStandardResidueQueries, getPolymerAndBranchedEntityQueries, applyBuiltInSelection, StructureSelectionQueries, StructureSelectionQueryRegistry */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "StructureSelectionCategory", function() { return StructureSelectionCategory; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "StructureSelectionQuery", function() { return StructureSelectionQuery; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ResidueQuery", function() { return ResidueQuery; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ElementSymbolQuery", function() { return ElementSymbolQuery; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "EntityDescriptionQuery", function() { return EntityDescriptionQuery; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getElementQueries", function() { return getElementQueries; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getNonStandardResidueQueries", function() { return getNonStandardResidueQueries; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getPolymerAndBranchedEntityQueries", function() { return getPolymerAndBranchedEntityQueries; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "applyBuiltInSelection", function() { return applyBuiltInSelection; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "StructureSelectionQueries", function() { return StructureSelectionQueries; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "StructureSelectionQueryRegistry", function() { return StructureSelectionQueryRegistry; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _mol_model_structure__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../mol-model/structure */ "./lib/mol-model/structure.js");
/* harmony import */ var _mol_model_structure_model_types__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../mol-model/structure/model/types */ "./lib/mol-model/structure/model/types.js");
/* harmony import */ var _mol_script_language_builder__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../mol-script/language/builder */ "./lib/mol-script/language/builder.js");
/* harmony import */ var _mol_script_runtime_query_compiler__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../mol-script/runtime/query/compiler */ "./lib/mol-script/runtime/query/compiler.js");
/* harmony import */ var _mol_util_set__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../mol-util/set */ "./lib/mol-util/set.js");
/* harmony import */ var _transforms__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../transforms */ "./lib/mol-plugin-state/transforms.js");
/* harmony import */ var _mol_model_structure_model_properties_atomic_types__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../../mol-model/structure/model/properties/atomic/types */ "./lib/mol-model/structure/model/properties/atomic/types.js");
/**
 * Copyright (c) 2019-2020 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 * @author David Sehnal <david.sehnal@gmail.com>
 */








var StructureSelectionCategory;
(function (StructureSelectionCategory) {
    StructureSelectionCategory["Type"] = "Type";
    StructureSelectionCategory["Structure"] = "Structure Property";
    StructureSelectionCategory["Atom"] = "Atom Property";
    StructureSelectionCategory["Bond"] = "Bond Property";
    StructureSelectionCategory["Residue"] = "Residue Property";
    StructureSelectionCategory["AminoAcid"] = "Amino Acid";
    StructureSelectionCategory["NucleicBase"] = "Nucleic Base";
    StructureSelectionCategory["Manipulate"] = "Manipulate Selection";
    StructureSelectionCategory["Validation"] = "Validation";
    StructureSelectionCategory["Misc"] = "Miscellaneous";
    StructureSelectionCategory["Internal"] = "Internal";
})(StructureSelectionCategory || (StructureSelectionCategory = {}));

function StructureSelectionQuery(label, expression, props) {
    var _a;
    if (props === void 0) { props = {}; }
    var _query;
    return {
        label: label,
        expression: expression,
        description: props.description || '',
        category: (_a = props.category) !== null && _a !== void 0 ? _a : StructureSelectionCategory.Misc,
        isHidden: !!props.isHidden,
        priority: props.priority || 0,
        referencesCurrent: !!props.referencesCurrent,
        get query() {
            if (!_query)
                _query = Object(_mol_script_runtime_query_compiler__WEBPACK_IMPORTED_MODULE_4__["compile"])(expression);
            return _query;
        },
        ensureCustomProperties: props.ensureCustomProperties,
        getSelection: function (plugin, runtime, structure) {
            return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"])(this, void 0, void 0, function () {
                var current, currentSelection;
                return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__generator"])(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            current = plugin.managers.structure.selection.getStructure(structure);
                            currentSelection = current ? _mol_model_structure__WEBPACK_IMPORTED_MODULE_1__["StructureSelection"].Sequence(structure, [current]) : _mol_model_structure__WEBPACK_IMPORTED_MODULE_1__["StructureSelection"].Empty(structure);
                            if (!props.ensureCustomProperties) return [3 /*break*/, 2];
                            return [4 /*yield*/, props.ensureCustomProperties({ runtime: runtime, assetManager: plugin.managers.asset }, structure)];
                        case 1:
                            _a.sent();
                            _a.label = 2;
                        case 2:
                            if (!_query)
                                _query = Object(_mol_script_runtime_query_compiler__WEBPACK_IMPORTED_MODULE_4__["compile"])(expression);
                            return [2 /*return*/, _query(new _mol_model_structure__WEBPACK_IMPORTED_MODULE_1__["QueryContext"](structure, { currentSelection: currentSelection }))];
                    }
                });
            });
        }
    };
}
var all = StructureSelectionQuery('All', _mol_script_language_builder__WEBPACK_IMPORTED_MODULE_3__["MolScriptBuilder"].struct.generator.all(), { category: '', priority: 1000 });
var current = StructureSelectionQuery('Current Selection', _mol_script_language_builder__WEBPACK_IMPORTED_MODULE_3__["MolScriptBuilder"].internal.generator.current(), { category: '', referencesCurrent: true });
var polymer = StructureSelectionQuery('Polymer', _mol_script_language_builder__WEBPACK_IMPORTED_MODULE_3__["MolScriptBuilder"].struct.modifier.union([
    _mol_script_language_builder__WEBPACK_IMPORTED_MODULE_3__["MolScriptBuilder"].struct.generator.atomGroups({
        'entity-test': _mol_script_language_builder__WEBPACK_IMPORTED_MODULE_3__["MolScriptBuilder"].core.logic.and([
            _mol_script_language_builder__WEBPACK_IMPORTED_MODULE_3__["MolScriptBuilder"].core.rel.eq([_mol_script_language_builder__WEBPACK_IMPORTED_MODULE_3__["MolScriptBuilder"].ammp('entityType'), 'polymer']),
            _mol_script_language_builder__WEBPACK_IMPORTED_MODULE_3__["MolScriptBuilder"].core.str.match([
                _mol_script_language_builder__WEBPACK_IMPORTED_MODULE_3__["MolScriptBuilder"].re('(polypeptide|cyclic-pseudo-peptide|peptide-like|nucleotide|peptide nucleic acid)', 'i'),
                _mol_script_language_builder__WEBPACK_IMPORTED_MODULE_3__["MolScriptBuilder"].ammp('entitySubtype')
            ])
        ])
    })
]), { category: StructureSelectionCategory.Type });
var trace = StructureSelectionQuery('Trace', _mol_script_language_builder__WEBPACK_IMPORTED_MODULE_3__["MolScriptBuilder"].struct.modifier.union([
    _mol_script_language_builder__WEBPACK_IMPORTED_MODULE_3__["MolScriptBuilder"].struct.combinator.merge([
        _mol_script_language_builder__WEBPACK_IMPORTED_MODULE_3__["MolScriptBuilder"].struct.modifier.union([
            _mol_script_language_builder__WEBPACK_IMPORTED_MODULE_3__["MolScriptBuilder"].struct.generator.atomGroups({
                'entity-test': _mol_script_language_builder__WEBPACK_IMPORTED_MODULE_3__["MolScriptBuilder"].core.rel.eq([_mol_script_language_builder__WEBPACK_IMPORTED_MODULE_3__["MolScriptBuilder"].ammp('entityType'), 'polymer']),
                'chain-test': _mol_script_language_builder__WEBPACK_IMPORTED_MODULE_3__["MolScriptBuilder"].core.set.has([
                    _mol_script_language_builder__WEBPACK_IMPORTED_MODULE_3__["MolScriptBuilder"].set('sphere', 'gaussian'), _mol_script_language_builder__WEBPACK_IMPORTED_MODULE_3__["MolScriptBuilder"].ammp('objectPrimitive')
                ])
            })
        ]),
        _mol_script_language_builder__WEBPACK_IMPORTED_MODULE_3__["MolScriptBuilder"].struct.modifier.union([
            _mol_script_language_builder__WEBPACK_IMPORTED_MODULE_3__["MolScriptBuilder"].struct.generator.atomGroups({
                'entity-test': _mol_script_language_builder__WEBPACK_IMPORTED_MODULE_3__["MolScriptBuilder"].core.rel.eq([_mol_script_language_builder__WEBPACK_IMPORTED_MODULE_3__["MolScriptBuilder"].ammp('entityType'), 'polymer']),
                'chain-test': _mol_script_language_builder__WEBPACK_IMPORTED_MODULE_3__["MolScriptBuilder"].core.rel.eq([_mol_script_language_builder__WEBPACK_IMPORTED_MODULE_3__["MolScriptBuilder"].ammp('objectPrimitive'), 'atomistic']),
                'atom-test': _mol_script_language_builder__WEBPACK_IMPORTED_MODULE_3__["MolScriptBuilder"].core.set.has([_mol_script_language_builder__WEBPACK_IMPORTED_MODULE_3__["MolScriptBuilder"].set('CA', 'P'), _mol_script_language_builder__WEBPACK_IMPORTED_MODULE_3__["MolScriptBuilder"].ammp('label_atom_id')])
            })
        ])
    ])
]), { category: StructureSelectionCategory.Structure });
var _proteinEntityTest = _mol_script_language_builder__WEBPACK_IMPORTED_MODULE_3__["MolScriptBuilder"].core.logic.and([
    _mol_script_language_builder__WEBPACK_IMPORTED_MODULE_3__["MolScriptBuilder"].core.rel.eq([_mol_script_language_builder__WEBPACK_IMPORTED_MODULE_3__["MolScriptBuilder"].ammp('entityType'), 'polymer']),
    _mol_script_language_builder__WEBPACK_IMPORTED_MODULE_3__["MolScriptBuilder"].core.str.match([
        _mol_script_language_builder__WEBPACK_IMPORTED_MODULE_3__["MolScriptBuilder"].re('(polypeptide|cyclic-pseudo-peptide|peptide-like)', 'i'),
        _mol_script_language_builder__WEBPACK_IMPORTED_MODULE_3__["MolScriptBuilder"].ammp('entitySubtype')
    ])
]);
var _nucleiEntityTest = _mol_script_language_builder__WEBPACK_IMPORTED_MODULE_3__["MolScriptBuilder"].core.logic.and([
    _mol_script_language_builder__WEBPACK_IMPORTED_MODULE_3__["MolScriptBuilder"].core.rel.eq([_mol_script_language_builder__WEBPACK_IMPORTED_MODULE_3__["MolScriptBuilder"].ammp('entityType'), 'polymer']),
    _mol_script_language_builder__WEBPACK_IMPORTED_MODULE_3__["MolScriptBuilder"].core.str.match([
        _mol_script_language_builder__WEBPACK_IMPORTED_MODULE_3__["MolScriptBuilder"].re('(nucleotide|peptide nucleic acid)', 'i'),
        _mol_script_language_builder__WEBPACK_IMPORTED_MODULE_3__["MolScriptBuilder"].ammp('entitySubtype')
    ])
]);
/**
 * this is to get non-polymer and peptide terminus components in polymer entities,
 * - non-polymer, e.g. PXZ in 4HIV or generally ACE
 * - carboxy terminus, e.g. FC0 in 4BP9, or ETA in 6DDE
 * - amino terminus, e.g. ARF in 3K4V, or 4MM in 3EGV
 */
var _nonPolymerResidueTest = _mol_script_language_builder__WEBPACK_IMPORTED_MODULE_3__["MolScriptBuilder"].core.str.match([
    _mol_script_language_builder__WEBPACK_IMPORTED_MODULE_3__["MolScriptBuilder"].re('non-polymer|(amino|carboxy) terminus|peptide-like', 'i'),
    _mol_script_language_builder__WEBPACK_IMPORTED_MODULE_3__["MolScriptBuilder"].ammp('chemCompType')
]);
// TODO maybe pre-calculate backbone atom properties
var backbone = StructureSelectionQuery('Backbone', _mol_script_language_builder__WEBPACK_IMPORTED_MODULE_3__["MolScriptBuilder"].struct.modifier.union([
    _mol_script_language_builder__WEBPACK_IMPORTED_MODULE_3__["MolScriptBuilder"].struct.combinator.merge([
        _mol_script_language_builder__WEBPACK_IMPORTED_MODULE_3__["MolScriptBuilder"].struct.modifier.union([
            _mol_script_language_builder__WEBPACK_IMPORTED_MODULE_3__["MolScriptBuilder"].struct.generator.atomGroups({
                'entity-test': _proteinEntityTest,
                'chain-test': _mol_script_language_builder__WEBPACK_IMPORTED_MODULE_3__["MolScriptBuilder"].core.rel.eq([_mol_script_language_builder__WEBPACK_IMPORTED_MODULE_3__["MolScriptBuilder"].ammp('objectPrimitive'), 'atomistic']),
                'residue-test': _mol_script_language_builder__WEBPACK_IMPORTED_MODULE_3__["MolScriptBuilder"].core.logic.not([_nonPolymerResidueTest]),
                'atom-test': _mol_script_language_builder__WEBPACK_IMPORTED_MODULE_3__["MolScriptBuilder"].core.set.has([_mol_script_language_builder__WEBPACK_IMPORTED_MODULE_3__["MolScriptBuilder"].set.apply(_mol_script_language_builder__WEBPACK_IMPORTED_MODULE_3__["MolScriptBuilder"], _mol_util_set__WEBPACK_IMPORTED_MODULE_5__["SetUtils"].toArray(_mol_model_structure_model_types__WEBPACK_IMPORTED_MODULE_2__["ProteinBackboneAtoms"])), _mol_script_language_builder__WEBPACK_IMPORTED_MODULE_3__["MolScriptBuilder"].ammp('label_atom_id')])
            })
        ]),
        _mol_script_language_builder__WEBPACK_IMPORTED_MODULE_3__["MolScriptBuilder"].struct.modifier.union([
            _mol_script_language_builder__WEBPACK_IMPORTED_MODULE_3__["MolScriptBuilder"].struct.generator.atomGroups({
                'entity-test': _nucleiEntityTest,
                'chain-test': _mol_script_language_builder__WEBPACK_IMPORTED_MODULE_3__["MolScriptBuilder"].core.rel.eq([_mol_script_language_builder__WEBPACK_IMPORTED_MODULE_3__["MolScriptBuilder"].ammp('objectPrimitive'), 'atomistic']),
                'residue-test': _mol_script_language_builder__WEBPACK_IMPORTED_MODULE_3__["MolScriptBuilder"].core.logic.not([_nonPolymerResidueTest]),
                'atom-test': _mol_script_language_builder__WEBPACK_IMPORTED_MODULE_3__["MolScriptBuilder"].core.set.has([_mol_script_language_builder__WEBPACK_IMPORTED_MODULE_3__["MolScriptBuilder"].set.apply(_mol_script_language_builder__WEBPACK_IMPORTED_MODULE_3__["MolScriptBuilder"], _mol_util_set__WEBPACK_IMPORTED_MODULE_5__["SetUtils"].toArray(_mol_model_structure_model_types__WEBPACK_IMPORTED_MODULE_2__["NucleicBackboneAtoms"])), _mol_script_language_builder__WEBPACK_IMPORTED_MODULE_3__["MolScriptBuilder"].ammp('label_atom_id')])
            })
        ])
    ])
]), { category: StructureSelectionCategory.Structure });
// TODO maybe pre-calculate sidechain atom property
var sidechain = StructureSelectionQuery('Sidechain', _mol_script_language_builder__WEBPACK_IMPORTED_MODULE_3__["MolScriptBuilder"].struct.modifier.union([
    _mol_script_language_builder__WEBPACK_IMPORTED_MODULE_3__["MolScriptBuilder"].struct.combinator.merge([
        _mol_script_language_builder__WEBPACK_IMPORTED_MODULE_3__["MolScriptBuilder"].struct.modifier.union([
            _mol_script_language_builder__WEBPACK_IMPORTED_MODULE_3__["MolScriptBuilder"].struct.generator.atomGroups({
                'entity-test': _proteinEntityTest,
                'chain-test': _mol_script_language_builder__WEBPACK_IMPORTED_MODULE_3__["MolScriptBuilder"].core.rel.eq([_mol_script_language_builder__WEBPACK_IMPORTED_MODULE_3__["MolScriptBuilder"].ammp('objectPrimitive'), 'atomistic']),
                'residue-test': _mol_script_language_builder__WEBPACK_IMPORTED_MODULE_3__["MolScriptBuilder"].core.logic.not([_nonPolymerResidueTest]),
                'atom-test': _mol_script_language_builder__WEBPACK_IMPORTED_MODULE_3__["MolScriptBuilder"].core.logic.or([
                    _mol_script_language_builder__WEBPACK_IMPORTED_MODULE_3__["MolScriptBuilder"].core.logic.not([
                        _mol_script_language_builder__WEBPACK_IMPORTED_MODULE_3__["MolScriptBuilder"].core.set.has([_mol_script_language_builder__WEBPACK_IMPORTED_MODULE_3__["MolScriptBuilder"].set.apply(_mol_script_language_builder__WEBPACK_IMPORTED_MODULE_3__["MolScriptBuilder"], _mol_util_set__WEBPACK_IMPORTED_MODULE_5__["SetUtils"].toArray(_mol_model_structure_model_types__WEBPACK_IMPORTED_MODULE_2__["ProteinBackboneAtoms"])), _mol_script_language_builder__WEBPACK_IMPORTED_MODULE_3__["MolScriptBuilder"].ammp('label_atom_id')])
                    ])
                ])
            })
        ]),
        _mol_script_language_builder__WEBPACK_IMPORTED_MODULE_3__["MolScriptBuilder"].struct.modifier.union([
            _mol_script_language_builder__WEBPACK_IMPORTED_MODULE_3__["MolScriptBuilder"].struct.generator.atomGroups({
                'entity-test': _nucleiEntityTest,
                'chain-test': _mol_script_language_builder__WEBPACK_IMPORTED_MODULE_3__["MolScriptBuilder"].core.rel.eq([_mol_script_language_builder__WEBPACK_IMPORTED_MODULE_3__["MolScriptBuilder"].ammp('objectPrimitive'), 'atomistic']),
                'residue-test': _mol_script_language_builder__WEBPACK_IMPORTED_MODULE_3__["MolScriptBuilder"].core.logic.not([_nonPolymerResidueTest]),
                'atom-test': _mol_script_language_builder__WEBPACK_IMPORTED_MODULE_3__["MolScriptBuilder"].core.logic.or([
                    _mol_script_language_builder__WEBPACK_IMPORTED_MODULE_3__["MolScriptBuilder"].core.logic.not([
                        _mol_script_language_builder__WEBPACK_IMPORTED_MODULE_3__["MolScriptBuilder"].core.set.has([_mol_script_language_builder__WEBPACK_IMPORTED_MODULE_3__["MolScriptBuilder"].set.apply(_mol_script_language_builder__WEBPACK_IMPORTED_MODULE_3__["MolScriptBuilder"], _mol_util_set__WEBPACK_IMPORTED_MODULE_5__["SetUtils"].toArray(_mol_model_structure_model_types__WEBPACK_IMPORTED_MODULE_2__["NucleicBackboneAtoms"])), _mol_script_language_builder__WEBPACK_IMPORTED_MODULE_3__["MolScriptBuilder"].ammp('label_atom_id')])
                    ])
                ])
            })
        ])
    ])
]), { category: StructureSelectionCategory.Structure });
// TODO maybe pre-calculate sidechain atom property
var sidechainWithTrace = StructureSelectionQuery('Sidechain with Trace', _mol_script_language_builder__WEBPACK_IMPORTED_MODULE_3__["MolScriptBuilder"].struct.modifier.union([
    _mol_script_language_builder__WEBPACK_IMPORTED_MODULE_3__["MolScriptBuilder"].struct.combinator.merge([
        _mol_script_language_builder__WEBPACK_IMPORTED_MODULE_3__["MolScriptBuilder"].struct.modifier.union([
            _mol_script_language_builder__WEBPACK_IMPORTED_MODULE_3__["MolScriptBuilder"].struct.generator.atomGroups({
                'entity-test': _proteinEntityTest,
                'chain-test': _mol_script_language_builder__WEBPACK_IMPORTED_MODULE_3__["MolScriptBuilder"].core.rel.eq([_mol_script_language_builder__WEBPACK_IMPORTED_MODULE_3__["MolScriptBuilder"].ammp('objectPrimitive'), 'atomistic']),
                'residue-test': _mol_script_language_builder__WEBPACK_IMPORTED_MODULE_3__["MolScriptBuilder"].core.logic.not([_nonPolymerResidueTest]),
                'atom-test': _mol_script_language_builder__WEBPACK_IMPORTED_MODULE_3__["MolScriptBuilder"].core.logic.or([
                    _mol_script_language_builder__WEBPACK_IMPORTED_MODULE_3__["MolScriptBuilder"].core.logic.not([
                        _mol_script_language_builder__WEBPACK_IMPORTED_MODULE_3__["MolScriptBuilder"].core.set.has([_mol_script_language_builder__WEBPACK_IMPORTED_MODULE_3__["MolScriptBuilder"].set.apply(_mol_script_language_builder__WEBPACK_IMPORTED_MODULE_3__["MolScriptBuilder"], _mol_util_set__WEBPACK_IMPORTED_MODULE_5__["SetUtils"].toArray(_mol_model_structure_model_types__WEBPACK_IMPORTED_MODULE_2__["ProteinBackboneAtoms"])), _mol_script_language_builder__WEBPACK_IMPORTED_MODULE_3__["MolScriptBuilder"].ammp('label_atom_id')])
                    ]),
                    _mol_script_language_builder__WEBPACK_IMPORTED_MODULE_3__["MolScriptBuilder"].core.rel.eq([_mol_script_language_builder__WEBPACK_IMPORTED_MODULE_3__["MolScriptBuilder"].ammp('label_atom_id'), 'CA']),
                    _mol_script_language_builder__WEBPACK_IMPORTED_MODULE_3__["MolScriptBuilder"].core.logic.and([
                        _mol_script_language_builder__WEBPACK_IMPORTED_MODULE_3__["MolScriptBuilder"].core.rel.eq([_mol_script_language_builder__WEBPACK_IMPORTED_MODULE_3__["MolScriptBuilder"].ammp('auth_comp_id'), 'PRO']),
                        _mol_script_language_builder__WEBPACK_IMPORTED_MODULE_3__["MolScriptBuilder"].core.rel.eq([_mol_script_language_builder__WEBPACK_IMPORTED_MODULE_3__["MolScriptBuilder"].ammp('label_atom_id'), 'N'])
                    ])
                ])
            })
        ]),
        _mol_script_language_builder__WEBPACK_IMPORTED_MODULE_3__["MolScriptBuilder"].struct.modifier.union([
            _mol_script_language_builder__WEBPACK_IMPORTED_MODULE_3__["MolScriptBuilder"].struct.generator.atomGroups({
                'entity-test': _nucleiEntityTest,
                'chain-test': _mol_script_language_builder__WEBPACK_IMPORTED_MODULE_3__["MolScriptBuilder"].core.rel.eq([_mol_script_language_builder__WEBPACK_IMPORTED_MODULE_3__["MolScriptBuilder"].ammp('objectPrimitive'), 'atomistic']),
                'residue-test': _mol_script_language_builder__WEBPACK_IMPORTED_MODULE_3__["MolScriptBuilder"].core.logic.not([_nonPolymerResidueTest]),
                'atom-test': _mol_script_language_builder__WEBPACK_IMPORTED_MODULE_3__["MolScriptBuilder"].core.logic.or([
                    _mol_script_language_builder__WEBPACK_IMPORTED_MODULE_3__["MolScriptBuilder"].core.logic.not([
                        _mol_script_language_builder__WEBPACK_IMPORTED_MODULE_3__["MolScriptBuilder"].core.set.has([_mol_script_language_builder__WEBPACK_IMPORTED_MODULE_3__["MolScriptBuilder"].set.apply(_mol_script_language_builder__WEBPACK_IMPORTED_MODULE_3__["MolScriptBuilder"], _mol_util_set__WEBPACK_IMPORTED_MODULE_5__["SetUtils"].toArray(_mol_model_structure_model_types__WEBPACK_IMPORTED_MODULE_2__["NucleicBackboneAtoms"])), _mol_script_language_builder__WEBPACK_IMPORTED_MODULE_3__["MolScriptBuilder"].ammp('label_atom_id')])
                    ]),
                    _mol_script_language_builder__WEBPACK_IMPORTED_MODULE_3__["MolScriptBuilder"].core.rel.eq([_mol_script_language_builder__WEBPACK_IMPORTED_MODULE_3__["MolScriptBuilder"].ammp('label_atom_id'), 'P'])
                ])
            })
        ])
    ])
]), { category: StructureSelectionCategory.Structure });
var protein = StructureSelectionQuery('Protein', _mol_script_language_builder__WEBPACK_IMPORTED_MODULE_3__["MolScriptBuilder"].struct.modifier.union([
    _mol_script_language_builder__WEBPACK_IMPORTED_MODULE_3__["MolScriptBuilder"].struct.generator.atomGroups({ 'entity-test': _proteinEntityTest })
]), { category: StructureSelectionCategory.Type });
var nucleic = StructureSelectionQuery('Nucleic', _mol_script_language_builder__WEBPACK_IMPORTED_MODULE_3__["MolScriptBuilder"].struct.modifier.union([
    _mol_script_language_builder__WEBPACK_IMPORTED_MODULE_3__["MolScriptBuilder"].struct.generator.atomGroups({ 'entity-test': _nucleiEntityTest })
]), { category: StructureSelectionCategory.Type });
var helix = StructureSelectionQuery('Helix', _mol_script_language_builder__WEBPACK_IMPORTED_MODULE_3__["MolScriptBuilder"].struct.modifier.union([
    _mol_script_language_builder__WEBPACK_IMPORTED_MODULE_3__["MolScriptBuilder"].struct.generator.atomGroups({
        'entity-test': _proteinEntityTest,
        'residue-test': _mol_script_language_builder__WEBPACK_IMPORTED_MODULE_3__["MolScriptBuilder"].core.flags.hasAny([
            _mol_script_language_builder__WEBPACK_IMPORTED_MODULE_3__["MolScriptBuilder"].ammp('secondaryStructureFlags'),
            _mol_script_language_builder__WEBPACK_IMPORTED_MODULE_3__["MolScriptBuilder"].core.type.bitflags([2 /* Helix */])
        ])
    })
]), { category: StructureSelectionCategory.Structure });
var beta = StructureSelectionQuery('Beta Strand/Sheet', _mol_script_language_builder__WEBPACK_IMPORTED_MODULE_3__["MolScriptBuilder"].struct.modifier.union([
    _mol_script_language_builder__WEBPACK_IMPORTED_MODULE_3__["MolScriptBuilder"].struct.generator.atomGroups({
        'entity-test': _proteinEntityTest,
        'residue-test': _mol_script_language_builder__WEBPACK_IMPORTED_MODULE_3__["MolScriptBuilder"].core.flags.hasAny([
            _mol_script_language_builder__WEBPACK_IMPORTED_MODULE_3__["MolScriptBuilder"].ammp('secondaryStructureFlags'),
            _mol_script_language_builder__WEBPACK_IMPORTED_MODULE_3__["MolScriptBuilder"].core.type.bitflags([4 /* Beta */])
        ])
    })
]), { category: StructureSelectionCategory.Structure });
var water = StructureSelectionQuery('Water', _mol_script_language_builder__WEBPACK_IMPORTED_MODULE_3__["MolScriptBuilder"].struct.modifier.union([
    _mol_script_language_builder__WEBPACK_IMPORTED_MODULE_3__["MolScriptBuilder"].struct.generator.atomGroups({
        'entity-test': _mol_script_language_builder__WEBPACK_IMPORTED_MODULE_3__["MolScriptBuilder"].core.rel.eq([_mol_script_language_builder__WEBPACK_IMPORTED_MODULE_3__["MolScriptBuilder"].ammp('entityType'), 'water'])
    })
]), { category: StructureSelectionCategory.Type });
var ion = StructureSelectionQuery('Ion', _mol_script_language_builder__WEBPACK_IMPORTED_MODULE_3__["MolScriptBuilder"].struct.modifier.union([
    _mol_script_language_builder__WEBPACK_IMPORTED_MODULE_3__["MolScriptBuilder"].struct.generator.atomGroups({
        'entity-test': _mol_script_language_builder__WEBPACK_IMPORTED_MODULE_3__["MolScriptBuilder"].core.rel.eq([_mol_script_language_builder__WEBPACK_IMPORTED_MODULE_3__["MolScriptBuilder"].ammp('entitySubtype'), 'ion'])
    })
]), { category: StructureSelectionCategory.Type });
var lipid = StructureSelectionQuery('Lipid', _mol_script_language_builder__WEBPACK_IMPORTED_MODULE_3__["MolScriptBuilder"].struct.modifier.union([
    _mol_script_language_builder__WEBPACK_IMPORTED_MODULE_3__["MolScriptBuilder"].struct.generator.atomGroups({
        'entity-test': _mol_script_language_builder__WEBPACK_IMPORTED_MODULE_3__["MolScriptBuilder"].core.rel.eq([_mol_script_language_builder__WEBPACK_IMPORTED_MODULE_3__["MolScriptBuilder"].ammp('entitySubtype'), 'lipid'])
    })
]), { category: StructureSelectionCategory.Type });
var branched = StructureSelectionQuery('Carbohydrate', _mol_script_language_builder__WEBPACK_IMPORTED_MODULE_3__["MolScriptBuilder"].struct.modifier.union([
    _mol_script_language_builder__WEBPACK_IMPORTED_MODULE_3__["MolScriptBuilder"].struct.generator.atomGroups({
        'entity-test': _mol_script_language_builder__WEBPACK_IMPORTED_MODULE_3__["MolScriptBuilder"].core.logic.or([
            _mol_script_language_builder__WEBPACK_IMPORTED_MODULE_3__["MolScriptBuilder"].core.rel.eq([_mol_script_language_builder__WEBPACK_IMPORTED_MODULE_3__["MolScriptBuilder"].ammp('entityType'), 'branched']),
            _mol_script_language_builder__WEBPACK_IMPORTED_MODULE_3__["MolScriptBuilder"].core.logic.and([
                _mol_script_language_builder__WEBPACK_IMPORTED_MODULE_3__["MolScriptBuilder"].core.rel.eq([_mol_script_language_builder__WEBPACK_IMPORTED_MODULE_3__["MolScriptBuilder"].ammp('entityType'), 'non-polymer']),
                _mol_script_language_builder__WEBPACK_IMPORTED_MODULE_3__["MolScriptBuilder"].core.str.match([
                    _mol_script_language_builder__WEBPACK_IMPORTED_MODULE_3__["MolScriptBuilder"].re('oligosaccharide', 'i'),
                    _mol_script_language_builder__WEBPACK_IMPORTED_MODULE_3__["MolScriptBuilder"].ammp('entitySubtype')
                ])
            ])
        ])
    })
]), { category: StructureSelectionCategory.Type });
var branchedPlusConnected = StructureSelectionQuery('Carbohydrate with Connected', _mol_script_language_builder__WEBPACK_IMPORTED_MODULE_3__["MolScriptBuilder"].struct.modifier.union([
    _mol_script_language_builder__WEBPACK_IMPORTED_MODULE_3__["MolScriptBuilder"].struct.modifier.includeConnected({
        0: branched.expression, 'layer-count': 1, 'as-whole-residues': true
    })
]), { category: StructureSelectionCategory.Internal, isHidden: true });
var branchedConnectedOnly = StructureSelectionQuery('Connected to Carbohydrate', _mol_script_language_builder__WEBPACK_IMPORTED_MODULE_3__["MolScriptBuilder"].struct.modifier.union([
    _mol_script_language_builder__WEBPACK_IMPORTED_MODULE_3__["MolScriptBuilder"].struct.modifier.exceptBy({
        0: branchedPlusConnected.expression,
        by: branched.expression
    })
]), { category: StructureSelectionCategory.Internal, isHidden: true });
var ligand = StructureSelectionQuery('Ligand', _mol_script_language_builder__WEBPACK_IMPORTED_MODULE_3__["MolScriptBuilder"].struct.modifier.union([
    _mol_script_language_builder__WEBPACK_IMPORTED_MODULE_3__["MolScriptBuilder"].struct.combinator.merge([
        _mol_script_language_builder__WEBPACK_IMPORTED_MODULE_3__["MolScriptBuilder"].struct.modifier.union([
            _mol_script_language_builder__WEBPACK_IMPORTED_MODULE_3__["MolScriptBuilder"].struct.generator.atomGroups({
                'entity-test': _mol_script_language_builder__WEBPACK_IMPORTED_MODULE_3__["MolScriptBuilder"].core.logic.and([
                    _mol_script_language_builder__WEBPACK_IMPORTED_MODULE_3__["MolScriptBuilder"].core.logic.or([
                        _mol_script_language_builder__WEBPACK_IMPORTED_MODULE_3__["MolScriptBuilder"].core.rel.eq([_mol_script_language_builder__WEBPACK_IMPORTED_MODULE_3__["MolScriptBuilder"].ammp('entityType'), 'non-polymer']),
                        _mol_script_language_builder__WEBPACK_IMPORTED_MODULE_3__["MolScriptBuilder"].core.rel.neq([_mol_script_language_builder__WEBPACK_IMPORTED_MODULE_3__["MolScriptBuilder"].ammp('entityPrdId'), ''])
                    ]),
                    _mol_script_language_builder__WEBPACK_IMPORTED_MODULE_3__["MolScriptBuilder"].core.logic.not([_mol_script_language_builder__WEBPACK_IMPORTED_MODULE_3__["MolScriptBuilder"].core.str.match([
                            _mol_script_language_builder__WEBPACK_IMPORTED_MODULE_3__["MolScriptBuilder"].re('(oligosaccharide|lipid|ion)', 'i'),
                            _mol_script_language_builder__WEBPACK_IMPORTED_MODULE_3__["MolScriptBuilder"].ammp('entitySubtype')
                        ])])
                ]),
                'chain-test': _mol_script_language_builder__WEBPACK_IMPORTED_MODULE_3__["MolScriptBuilder"].core.rel.eq([_mol_script_language_builder__WEBPACK_IMPORTED_MODULE_3__["MolScriptBuilder"].ammp('objectPrimitive'), 'atomistic']),
                'residue-test': _mol_script_language_builder__WEBPACK_IMPORTED_MODULE_3__["MolScriptBuilder"].core.logic.not([
                    _mol_script_language_builder__WEBPACK_IMPORTED_MODULE_3__["MolScriptBuilder"].core.str.match([_mol_script_language_builder__WEBPACK_IMPORTED_MODULE_3__["MolScriptBuilder"].re('saccharide', 'i'), _mol_script_language_builder__WEBPACK_IMPORTED_MODULE_3__["MolScriptBuilder"].ammp('chemCompType')])
                ])
            })
        ]),
        _mol_script_language_builder__WEBPACK_IMPORTED_MODULE_3__["MolScriptBuilder"].struct.modifier.union([
            _mol_script_language_builder__WEBPACK_IMPORTED_MODULE_3__["MolScriptBuilder"].struct.generator.atomGroups({
                'entity-test': _mol_script_language_builder__WEBPACK_IMPORTED_MODULE_3__["MolScriptBuilder"].core.rel.eq([_mol_script_language_builder__WEBPACK_IMPORTED_MODULE_3__["MolScriptBuilder"].ammp('entityType'), 'polymer']),
                'chain-test': _mol_script_language_builder__WEBPACK_IMPORTED_MODULE_3__["MolScriptBuilder"].core.rel.eq([_mol_script_language_builder__WEBPACK_IMPORTED_MODULE_3__["MolScriptBuilder"].ammp('objectPrimitive'), 'atomistic']),
                'residue-test': _nonPolymerResidueTest
            })
        ])
    ]),
]), { category: StructureSelectionCategory.Type });
// don't include branched entities as they have their own link representation
var ligandPlusConnected = StructureSelectionQuery('Ligand with Connected', _mol_script_language_builder__WEBPACK_IMPORTED_MODULE_3__["MolScriptBuilder"].struct.modifier.union([
    _mol_script_language_builder__WEBPACK_IMPORTED_MODULE_3__["MolScriptBuilder"].struct.modifier.exceptBy({
        0: _mol_script_language_builder__WEBPACK_IMPORTED_MODULE_3__["MolScriptBuilder"].struct.modifier.union([
            _mol_script_language_builder__WEBPACK_IMPORTED_MODULE_3__["MolScriptBuilder"].struct.modifier.includeConnected({
                0: ligand.expression,
                'layer-count': 1,
                'as-whole-residues': true,
                'bond-test': _mol_script_language_builder__WEBPACK_IMPORTED_MODULE_3__["MolScriptBuilder"].core.flags.hasAny([
                    _mol_script_language_builder__WEBPACK_IMPORTED_MODULE_3__["MolScriptBuilder"].struct.bondProperty.flags(),
                    _mol_script_language_builder__WEBPACK_IMPORTED_MODULE_3__["MolScriptBuilder"].core.type.bitflags([
                        1 /* Covalent */ | 2 /* MetallicCoordination */
                    ])
                ])
            })
        ]),
        by: branched.expression
    })
]), { category: StructureSelectionCategory.Internal, isHidden: true });
var ligandConnectedOnly = StructureSelectionQuery('Connected to Ligand', _mol_script_language_builder__WEBPACK_IMPORTED_MODULE_3__["MolScriptBuilder"].struct.modifier.union([
    _mol_script_language_builder__WEBPACK_IMPORTED_MODULE_3__["MolScriptBuilder"].struct.modifier.exceptBy({
        0: ligandPlusConnected.expression,
        by: ligand.expression
    })
]), { category: StructureSelectionCategory.Internal, isHidden: true });
// residues connected to ligands or branched entities
var connectedOnly = StructureSelectionQuery('Connected to Ligand or Carbohydrate', _mol_script_language_builder__WEBPACK_IMPORTED_MODULE_3__["MolScriptBuilder"].struct.modifier.union([
    _mol_script_language_builder__WEBPACK_IMPORTED_MODULE_3__["MolScriptBuilder"].struct.combinator.merge([
        branchedConnectedOnly.expression,
        ligandConnectedOnly.expression
    ]),
]), { category: StructureSelectionCategory.Internal, isHidden: true });
var disulfideBridges = StructureSelectionQuery('Disulfide Bridges', _mol_script_language_builder__WEBPACK_IMPORTED_MODULE_3__["MolScriptBuilder"].struct.modifier.union([
    _mol_script_language_builder__WEBPACK_IMPORTED_MODULE_3__["MolScriptBuilder"].struct.modifier.wholeResidues([
        _mol_script_language_builder__WEBPACK_IMPORTED_MODULE_3__["MolScriptBuilder"].struct.modifier.union([
            _mol_script_language_builder__WEBPACK_IMPORTED_MODULE_3__["MolScriptBuilder"].struct.generator.bondedAtomicPairs({
                0: _mol_script_language_builder__WEBPACK_IMPORTED_MODULE_3__["MolScriptBuilder"].core.flags.hasAny([
                    _mol_script_language_builder__WEBPACK_IMPORTED_MODULE_3__["MolScriptBuilder"].struct.bondProperty.flags(),
                    _mol_script_language_builder__WEBPACK_IMPORTED_MODULE_3__["MolScriptBuilder"].core.type.bitflags([8 /* Disulfide */])
                ])
            })
        ])
    ])
]), { category: StructureSelectionCategory.Bond });
var nonStandardPolymer = StructureSelectionQuery('Non-standard Residues in Polymers', _mol_script_language_builder__WEBPACK_IMPORTED_MODULE_3__["MolScriptBuilder"].struct.modifier.union([
    _mol_script_language_builder__WEBPACK_IMPORTED_MODULE_3__["MolScriptBuilder"].struct.generator.atomGroups({
        'entity-test': _mol_script_language_builder__WEBPACK_IMPORTED_MODULE_3__["MolScriptBuilder"].core.rel.eq([_mol_script_language_builder__WEBPACK_IMPORTED_MODULE_3__["MolScriptBuilder"].ammp('entityType'), 'polymer']),
        'chain-test': _mol_script_language_builder__WEBPACK_IMPORTED_MODULE_3__["MolScriptBuilder"].core.rel.eq([_mol_script_language_builder__WEBPACK_IMPORTED_MODULE_3__["MolScriptBuilder"].ammp('objectPrimitive'), 'atomistic']),
        'residue-test': _mol_script_language_builder__WEBPACK_IMPORTED_MODULE_3__["MolScriptBuilder"].ammp('isNonStandard')
    })
]), { category: StructureSelectionCategory.Residue });
var coarse = StructureSelectionQuery('Coarse Elements', _mol_script_language_builder__WEBPACK_IMPORTED_MODULE_3__["MolScriptBuilder"].struct.modifier.union([
    _mol_script_language_builder__WEBPACK_IMPORTED_MODULE_3__["MolScriptBuilder"].struct.generator.atomGroups({
        'chain-test': _mol_script_language_builder__WEBPACK_IMPORTED_MODULE_3__["MolScriptBuilder"].core.set.has([
            _mol_script_language_builder__WEBPACK_IMPORTED_MODULE_3__["MolScriptBuilder"].set('sphere', 'gaussian'), _mol_script_language_builder__WEBPACK_IMPORTED_MODULE_3__["MolScriptBuilder"].ammp('objectPrimitive')
        ])
    })
]), { category: StructureSelectionCategory.Type });
var ring = StructureSelectionQuery('Rings in Residues', _mol_script_language_builder__WEBPACK_IMPORTED_MODULE_3__["MolScriptBuilder"].struct.modifier.union([
    _mol_script_language_builder__WEBPACK_IMPORTED_MODULE_3__["MolScriptBuilder"].struct.generator.rings()
]), { category: StructureSelectionCategory.Residue });
var aromaticRing = StructureSelectionQuery('Aromatic Rings in Residues', _mol_script_language_builder__WEBPACK_IMPORTED_MODULE_3__["MolScriptBuilder"].struct.modifier.union([
    _mol_script_language_builder__WEBPACK_IMPORTED_MODULE_3__["MolScriptBuilder"].struct.generator.rings({ 'only-aromatic': true })
]), { category: StructureSelectionCategory.Residue });
var surroundings = StructureSelectionQuery('Surrounding Residues (5 \u212B) of Selection', _mol_script_language_builder__WEBPACK_IMPORTED_MODULE_3__["MolScriptBuilder"].struct.modifier.union([
    _mol_script_language_builder__WEBPACK_IMPORTED_MODULE_3__["MolScriptBuilder"].struct.modifier.exceptBy({
        0: _mol_script_language_builder__WEBPACK_IMPORTED_MODULE_3__["MolScriptBuilder"].struct.modifier.includeSurroundings({
            0: _mol_script_language_builder__WEBPACK_IMPORTED_MODULE_3__["MolScriptBuilder"].internal.generator.current(),
            radius: 5,
            'as-whole-residues': true
        }),
        by: _mol_script_language_builder__WEBPACK_IMPORTED_MODULE_3__["MolScriptBuilder"].internal.generator.current()
    })
]), {
    description: 'Select residues within 5 \u212B of the current selection.',
    category: StructureSelectionCategory.Manipulate,
    referencesCurrent: true
});
var complement = StructureSelectionQuery('Inverse / Complement of Selection', _mol_script_language_builder__WEBPACK_IMPORTED_MODULE_3__["MolScriptBuilder"].struct.modifier.union([
    _mol_script_language_builder__WEBPACK_IMPORTED_MODULE_3__["MolScriptBuilder"].struct.modifier.exceptBy({
        0: _mol_script_language_builder__WEBPACK_IMPORTED_MODULE_3__["MolScriptBuilder"].struct.generator.all(),
        by: _mol_script_language_builder__WEBPACK_IMPORTED_MODULE_3__["MolScriptBuilder"].internal.generator.current()
    })
]), {
    description: 'Select everything not in the current selection.',
    category: StructureSelectionCategory.Manipulate,
    referencesCurrent: true
});
var covalentlyBonded = StructureSelectionQuery('Residues Covalently Bonded to Selection', _mol_script_language_builder__WEBPACK_IMPORTED_MODULE_3__["MolScriptBuilder"].struct.modifier.union([
    _mol_script_language_builder__WEBPACK_IMPORTED_MODULE_3__["MolScriptBuilder"].struct.modifier.includeConnected({
        0: _mol_script_language_builder__WEBPACK_IMPORTED_MODULE_3__["MolScriptBuilder"].internal.generator.current(), 'layer-count': 1, 'as-whole-residues': true
    })
]), {
    description: 'Select residues covalently bonded to current selection.',
    category: StructureSelectionCategory.Manipulate,
    referencesCurrent: true
});
var covalentlyOrMetallicBonded = StructureSelectionQuery('Residues with Cov. or Metallic Bond to Selection', _mol_script_language_builder__WEBPACK_IMPORTED_MODULE_3__["MolScriptBuilder"].struct.modifier.union([
    _mol_script_language_builder__WEBPACK_IMPORTED_MODULE_3__["MolScriptBuilder"].struct.modifier.includeConnected({
        0: _mol_script_language_builder__WEBPACK_IMPORTED_MODULE_3__["MolScriptBuilder"].internal.generator.current(),
        'layer-count': 1,
        'as-whole-residues': true,
        'bond-test': _mol_script_language_builder__WEBPACK_IMPORTED_MODULE_3__["MolScriptBuilder"].core.flags.hasAny([
            _mol_script_language_builder__WEBPACK_IMPORTED_MODULE_3__["MolScriptBuilder"].struct.bondProperty.flags(),
            _mol_script_language_builder__WEBPACK_IMPORTED_MODULE_3__["MolScriptBuilder"].core.type.bitflags([
                1 /* Covalent */ | 2 /* MetallicCoordination */
            ])
        ])
    })
]), {
    description: 'Select residues with covalent or metallic bond to current selection.',
    category: StructureSelectionCategory.Manipulate,
    referencesCurrent: true
});
var wholeResidues = StructureSelectionQuery('Whole Residues of Selection', _mol_script_language_builder__WEBPACK_IMPORTED_MODULE_3__["MolScriptBuilder"].struct.modifier.union([
    _mol_script_language_builder__WEBPACK_IMPORTED_MODULE_3__["MolScriptBuilder"].struct.modifier.wholeResidues({
        0: _mol_script_language_builder__WEBPACK_IMPORTED_MODULE_3__["MolScriptBuilder"].internal.generator.current()
    })
]), {
    description: 'Expand current selection to whole residues.',
    category: StructureSelectionCategory.Manipulate,
    referencesCurrent: true
});
var StandardAminoAcids = [
    [['HIS'], 'Histidine'],
    [['ARG'], 'Arginine'],
    [['LYS'], 'Lysine'],
    [['ILE'], 'Isoleucine'],
    [['PHE'], 'Phenylalanine'],
    [['LEU'], 'Leucine'],
    [['TRP'], 'Tryptophan'],
    [['ALA'], 'Alanine'],
    [['MET'], 'Methionine'],
    [['PRO'], 'Proline'],
    [['CYS'], 'Cysteine'],
    [['ASN'], 'Asparagine'],
    [['VAL'], 'Valine'],
    [['GLY'], 'Glycine'],
    [['SER'], 'Serine'],
    [['GLN'], 'Glutamine'],
    [['TYR'], 'Tyrosine'],
    [['ASP'], 'Aspartic Acid'],
    [['GLU'], 'Glutamic Acid'],
    [['THR'], 'Threonine'],
    [['SEC'], 'Selenocysteine'],
    [['PYL'], 'Pyrrolysine'],
    [['UNK'], 'Unknown'],
].sort(function (a, b) { return a[1] < b[1] ? -1 : a[1] > b[1] ? 1 : 0; });
var StandardNucleicBases = [
    [['A', 'DA'], 'Adenosine'],
    [['C', 'DC'], 'Cytidine'],
    [['T', 'DT'], 'Thymidine'],
    [['G', 'DG'], 'Guanosine'],
    [['I', 'DI'], 'Inosine'],
    [['U', 'DU'], 'Uridine'],
    [['N', 'DN'], 'Unknown'],
].sort(function (a, b) { return a[1] < b[1] ? -1 : a[1] > b[1] ? 1 : 0; });
function ResidueQuery(_a, category, priority) {
    var names = _a[0], label = _a[1];
    if (priority === void 0) { priority = 0; }
    var description = names.length === 1 && !StandardResidues.has(names[0])
        ? "[" + names[0] + "] " + label
        : label + " (" + names.join(', ') + ")";
    return StructureSelectionQuery(description, _mol_script_language_builder__WEBPACK_IMPORTED_MODULE_3__["MolScriptBuilder"].struct.modifier.union([
        _mol_script_language_builder__WEBPACK_IMPORTED_MODULE_3__["MolScriptBuilder"].struct.generator.atomGroups({
            'residue-test': _mol_script_language_builder__WEBPACK_IMPORTED_MODULE_3__["MolScriptBuilder"].core.set.has([_mol_script_language_builder__WEBPACK_IMPORTED_MODULE_3__["MolScriptBuilder"].set.apply(_mol_script_language_builder__WEBPACK_IMPORTED_MODULE_3__["MolScriptBuilder"], names), _mol_script_language_builder__WEBPACK_IMPORTED_MODULE_3__["MolScriptBuilder"].ammp('auth_comp_id')])
        })
    ]), { category: category, priority: priority, description: description });
}
function ElementSymbolQuery(_a, category, priority) {
    var names = _a[0], label = _a[1];
    var description = label + " (" + names.join(', ') + ")";
    return StructureSelectionQuery(description, _mol_script_language_builder__WEBPACK_IMPORTED_MODULE_3__["MolScriptBuilder"].struct.modifier.union([
        _mol_script_language_builder__WEBPACK_IMPORTED_MODULE_3__["MolScriptBuilder"].struct.generator.atomGroups({
            'atom-test': _mol_script_language_builder__WEBPACK_IMPORTED_MODULE_3__["MolScriptBuilder"].core.set.has([_mol_script_language_builder__WEBPACK_IMPORTED_MODULE_3__["MolScriptBuilder"].set.apply(_mol_script_language_builder__WEBPACK_IMPORTED_MODULE_3__["MolScriptBuilder"], names), _mol_script_language_builder__WEBPACK_IMPORTED_MODULE_3__["MolScriptBuilder"].acp('elementSymbol')])
        })
    ]), { category: category, priority: priority, description: description });
}
function EntityDescriptionQuery(_a, category, priority) {
    var names = _a[0], label = _a[1];
    var description = "" + label;
    return StructureSelectionQuery("" + label, _mol_script_language_builder__WEBPACK_IMPORTED_MODULE_3__["MolScriptBuilder"].struct.modifier.union([
        _mol_script_language_builder__WEBPACK_IMPORTED_MODULE_3__["MolScriptBuilder"].struct.generator.atomGroups({
            'entity-test': _mol_script_language_builder__WEBPACK_IMPORTED_MODULE_3__["MolScriptBuilder"].core.list.equal([_mol_script_language_builder__WEBPACK_IMPORTED_MODULE_3__["MolScriptBuilder"].list.apply(_mol_script_language_builder__WEBPACK_IMPORTED_MODULE_3__["MolScriptBuilder"], names), _mol_script_language_builder__WEBPACK_IMPORTED_MODULE_3__["MolScriptBuilder"].ammp('entityDescription')])
        })
    ]), { category: category, priority: priority, description: description });
}
var StandardResidues = _mol_util_set__WEBPACK_IMPORTED_MODULE_5__["SetUtils"].unionMany(_mol_model_structure_model_types__WEBPACK_IMPORTED_MODULE_2__["AminoAcidNamesL"], _mol_model_structure_model_types__WEBPACK_IMPORTED_MODULE_2__["RnaBaseNames"], _mol_model_structure_model_types__WEBPACK_IMPORTED_MODULE_2__["DnaBaseNames"], _mol_model_structure_model_types__WEBPACK_IMPORTED_MODULE_2__["WaterNames"]);
function getElementQueries(structures) {
    var uniqueElements = new Set();
    for (var _i = 0, structures_1 = structures; _i < structures_1.length; _i++) {
        var structure = structures_1[_i];
        structure.uniqueElementSymbols.forEach(function (e) { return uniqueElements.add(e); });
    }
    var queries = [];
    uniqueElements.forEach(function (e) {
        var label = _mol_model_structure_model_properties_atomic_types__WEBPACK_IMPORTED_MODULE_7__["ElementNames"][e] || e;
        queries.push(ElementSymbolQuery([[e], label], 'Element Symbol', 0));
    });
    return queries;
}
function getNonStandardResidueQueries(structures) {
    var residueLabels = new Map();
    var uniqueResidues = new Set();
    for (var _i = 0, structures_2 = structures; _i < structures_2.length; _i++) {
        var structure = structures_2[_i];
        structure.uniqueResidueNames.forEach(function (r) { return uniqueResidues.add(r); });
        var _loop_1 = function (m) {
            structure.uniqueResidueNames.forEach(function (r) {
                var comp = m.properties.chemicalComponentMap.get(r);
                if (comp)
                    residueLabels.set(r, comp.name);
            });
        };
        for (var _a = 0, _b = structure.models; _a < _b.length; _a++) {
            var m = _b[_a];
            _loop_1(m);
        }
    }
    var queries = [];
    _mol_util_set__WEBPACK_IMPORTED_MODULE_5__["SetUtils"].difference(uniqueResidues, StandardResidues).forEach(function (r) {
        var label = residueLabels.get(r) || r;
        queries.push(ResidueQuery([[r], label], 'Ligand/Non-standard Residue', 200));
    });
    return queries;
}
function getPolymerAndBranchedEntityQueries(structures) {
    var uniqueEntities = new Map();
    var l = _mol_model_structure__WEBPACK_IMPORTED_MODULE_1__["StructureElement"].Location.create();
    for (var _i = 0, structures_3 = structures; _i < structures_3.length; _i++) {
        var structure = structures_3[_i];
        l.structure = structure;
        for (var _a = 0, _b = structure.unitSymmetryGroups; _a < _b.length; _a++) {
            var ug = _b[_a];
            l.unit = ug.units[0];
            l.element = ug.elements[0];
            var entityType = _mol_model_structure__WEBPACK_IMPORTED_MODULE_1__["StructureProperties"].entity.type(l);
            if (entityType === 'polymer' || entityType === 'branched') {
                var description = _mol_model_structure__WEBPACK_IMPORTED_MODULE_1__["StructureProperties"].entity.pdbx_description(l);
                uniqueEntities.set(description.join(', '), description);
            }
        }
    }
    var queries = [];
    uniqueEntities.forEach(function (v, k) {
        queries.push(EntityDescriptionQuery([v, k], 'Polymer/Carbohydrate Entities', 300));
    });
    return queries;
}
function applyBuiltInSelection(to, query, customTag) {
    return to.apply(_transforms__WEBPACK_IMPORTED_MODULE_6__["StateTransforms"].Model.StructureSelectionFromExpression, { expression: StructureSelectionQueries[query].expression, label: StructureSelectionQueries[query].label }, { tags: customTag ? [query, customTag] : [query] });
}
var StructureSelectionQueries = {
    all: all,
    current: current,
    polymer: polymer,
    trace: trace,
    backbone: backbone,
    sidechain: sidechain,
    sidechainWithTrace: sidechainWithTrace,
    protein: protein,
    nucleic: nucleic,
    helix: helix,
    beta: beta,
    water: water,
    ion: ion,
    lipid: lipid,
    branched: branched,
    branchedPlusConnected: branchedPlusConnected,
    branchedConnectedOnly: branchedConnectedOnly,
    ligand: ligand,
    ligandPlusConnected: ligandPlusConnected,
    ligandConnectedOnly: ligandConnectedOnly,
    connectedOnly: connectedOnly,
    disulfideBridges: disulfideBridges,
    nonStandardPolymer: nonStandardPolymer,
    coarse: coarse,
    ring: ring,
    aromaticRing: aromaticRing,
    surroundings: surroundings,
    complement: complement,
    covalentlyBonded: covalentlyBonded,
    covalentlyOrMetallicBonded: covalentlyOrMetallicBonded,
    wholeResidues: wholeResidues,
};
var StructureSelectionQueryRegistry = /** @class */ (function () {
    function StructureSelectionQueryRegistry() {
        var _a, _b;
        this.list = [];
        this.options = [];
        this.version = 1;
        // add built-in
        (_a = this.list).push.apply(_a, Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__spreadArrays"])(Object.values(StructureSelectionQueries), StandardAminoAcids.map(function (v) { return ResidueQuery(v, StructureSelectionCategory.AminoAcid); }), StandardNucleicBases.map(function (v) { return ResidueQuery(v, StructureSelectionCategory.NucleicBase); })));
        (_b = this.options).push.apply(_b, this.list.map(function (q) { return [q, q.label, q.category]; }));
    }
    StructureSelectionQueryRegistry.prototype.add = function (q) {
        this.list.push(q);
        this.options.push([q, q.label, q.category]);
        this.version += 1;
    };
    StructureSelectionQueryRegistry.prototype.remove = function (q) {
        var idx = this.list.indexOf(q);
        if (idx !== -1) {
            this.list.splice(idx, 1);
            this.options.splice(idx, 1);
            this.version += 1;
        }
    };
    return StructureSelectionQueryRegistry;
}());

//# sourceMappingURL=structure-selection-query.js.map

/***/ }),

/***/ "./lib/mol-plugin-state/helpers/structure-transparency.js":
/*!****************************************************************!*\
  !*** ./lib/mol-plugin-state/helpers/structure-transparency.js ***!
  \****************************************************************/
/*! exports provided: setStructureTransparency, clearStructureTransparency */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setStructureTransparency", function() { return setStructureTransparency; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "clearStructureTransparency", function() { return clearStructureTransparency; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _mol_model_structure__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../mol-model/structure */ "./lib/mol-model/structure.js");
/* harmony import */ var _mol_plugin_state_transforms__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../mol-plugin-state/transforms */ "./lib/mol-plugin-state/transforms.js");
/* harmony import */ var _mol_state__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../mol-state */ "./lib/mol-state/index.js");
/* harmony import */ var _mol_model_loci__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../mol-model/loci */ "./lib/mol-model/loci.js");
/* harmony import */ var _mol_theme_transparency__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../mol-theme/transparency */ "./lib/mol-theme/transparency.js");
/**
 * Copyright (c) 2019-2020 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 * @author David Sehnal <david.sehnal@gmail.com>
 */






var TransparencyManagerTag = 'transparency-controls';
function setStructureTransparency(plugin, components, value, lociGetter, types) {
    return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"])(this, void 0, void 0, function () {
        var _this = this;
        return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__generator"])(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, eachRepr(plugin, components, function (update, repr, transparencyCell) { return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"])(_this, void 0, void 0, function () {
                        var structure, loci, layer, bundleLayers, filtered, filtered;
                        return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__generator"])(this, function (_a) {
                            switch (_a.label) {
                                case 0:
                                    if (types && types.length > 0 && !types.includes(repr.params.values.type.name))
                                        return [2 /*return*/];
                                    structure = repr.obj.data.source.data;
                                    return [4 /*yield*/, lociGetter(structure.root)];
                                case 1:
                                    loci = _a.sent();
                                    if (_mol_model_loci__WEBPACK_IMPORTED_MODULE_4__["Loci"].isEmpty(loci))
                                        return [2 /*return*/];
                                    layer = {
                                        bundle: _mol_model_structure__WEBPACK_IMPORTED_MODULE_1__["StructureElement"].Bundle.fromLoci(loci),
                                        value: value,
                                    };
                                    if (transparencyCell) {
                                        bundleLayers = Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__spreadArrays"])(transparencyCell.params.values.layers, [layer]);
                                        filtered = getFilteredBundle(bundleLayers, structure);
                                        update.to(transparencyCell).update(_mol_theme_transparency__WEBPACK_IMPORTED_MODULE_5__["Transparency"].toBundle(filtered));
                                    }
                                    else {
                                        filtered = getFilteredBundle([layer], structure);
                                        update.to(repr.transform.ref)
                                            .apply(_mol_plugin_state_transforms__WEBPACK_IMPORTED_MODULE_2__["StateTransforms"].Representation.TransparencyStructureRepresentation3DFromBundle, _mol_theme_transparency__WEBPACK_IMPORTED_MODULE_5__["Transparency"].toBundle(filtered), { tags: TransparencyManagerTag });
                                    }
                                    return [2 /*return*/];
                            }
                        });
                    }); })];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    });
}
function clearStructureTransparency(plugin, components, types) {
    return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"])(this, void 0, void 0, function () {
        var _this = this;
        return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__generator"])(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, eachRepr(plugin, components, function (update, repr, transparencyCell) { return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"])(_this, void 0, void 0, function () {
                        return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__generator"])(this, function (_a) {
                            if (types && types.length > 0 && !types.includes(repr.params.values.type.name))
                                return [2 /*return*/];
                            if (transparencyCell) {
                                update.delete(transparencyCell.transform.ref);
                            }
                            return [2 /*return*/];
                        });
                    }); })];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    });
}
function eachRepr(plugin, components, callback) {
    return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"])(this, void 0, void 0, function () {
        var state, update, _i, components_1, c, _a, _b, r, transparency;
        return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__generator"])(this, function (_c) {
            switch (_c.label) {
                case 0:
                    state = plugin.state.data;
                    update = state.build();
                    _i = 0, components_1 = components;
                    _c.label = 1;
                case 1:
                    if (!(_i < components_1.length)) return [3 /*break*/, 6];
                    c = components_1[_i];
                    _a = 0, _b = c.representations;
                    _c.label = 2;
                case 2:
                    if (!(_a < _b.length)) return [3 /*break*/, 5];
                    r = _b[_a];
                    transparency = state.select(_mol_state__WEBPACK_IMPORTED_MODULE_3__["StateSelection"].Generators.ofTransformer(_mol_plugin_state_transforms__WEBPACK_IMPORTED_MODULE_2__["StateTransforms"].Representation.TransparencyStructureRepresentation3DFromBundle, r.cell.transform.ref).withTag(TransparencyManagerTag));
                    return [4 /*yield*/, callback(update, r.cell, transparency[0])];
                case 3:
                    _c.sent();
                    _c.label = 4;
                case 4:
                    _a++;
                    return [3 /*break*/, 2];
                case 5:
                    _i++;
                    return [3 /*break*/, 1];
                case 6: return [2 /*return*/, update.commit({ doNotUpdateCurrent: true })];
            }
        });
    });
}
/** filter transparency layers for given structure */
function getFilteredBundle(layers, structure) {
    var transparency = _mol_theme_transparency__WEBPACK_IMPORTED_MODULE_5__["Transparency"].ofBundle(layers, structure.root);
    var merged = _mol_theme_transparency__WEBPACK_IMPORTED_MODULE_5__["Transparency"].merge(transparency);
    return _mol_theme_transparency__WEBPACK_IMPORTED_MODULE_5__["Transparency"].filter(merged, structure);
}
//# sourceMappingURL=structure-transparency.js.map

/***/ }),

/***/ "./lib/mol-plugin-state/helpers/volume-representation-params.js":
/*!**********************************************************************!*\
  !*** ./lib/mol-plugin-state/helpers/volume-representation-params.js ***!
  \**********************************************************************/
/*! exports provided: createVolumeRepresentationParams, getVolumeThemeTypes, createVolumeColorThemeParams, createVolumeSizeThemeParams */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createVolumeRepresentationParams", function() { return createVolumeRepresentationParams; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getVolumeThemeTypes", function() { return getVolumeThemeTypes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createVolumeColorThemeParams", function() { return createVolumeColorThemeParams; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createVolumeSizeThemeParams", function() { return createVolumeSizeThemeParams; });
/* harmony import */ var _mol_model_volume__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../mol-model/volume */ "./lib/mol-model/volume.js");
/* harmony import */ var _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../mol-util/param-definition */ "./lib/mol-util/param-definition.js");
/**
 * Copyright (c) 2020 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author David Sehnal <david.sehnal@gmail.com>
 */


function createVolumeRepresentationParams(ctx, volume, props) {
    if (props === void 0) { props = {}; }
    var p = props;
    if (typeof p.type === 'string' || typeof p.color === 'string' || typeof p.size === 'string')
        return createParamsByName(ctx, volume || _mol_model_volume__WEBPACK_IMPORTED_MODULE_0__["Volume"].One, props);
    return createParamsProvider(ctx, volume || _mol_model_volume__WEBPACK_IMPORTED_MODULE_0__["Volume"].One, props);
}
function getVolumeThemeTypes(ctx, volume) {
    var themeCtx = ctx.representation.volume.themes;
    if (!volume)
        return themeCtx.colorThemeRegistry.types;
    return themeCtx.colorThemeRegistry.getApplicableTypes({ volume: volume });
}
function createVolumeColorThemeParams(ctx, volume, typeName, themeName, params) {
    var _a = ctx.representation.volume, registry = _a.registry, themes = _a.themes;
    var repr = registry.get(typeName || registry.default.name);
    var color = themes.colorThemeRegistry.get(themeName || repr.defaultColorTheme.name);
    var colorDefaultParams = _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_1__["ParamDefinition"].getDefaultValues(color.getParams({ volume: volume || _mol_model_volume__WEBPACK_IMPORTED_MODULE_0__["Volume"].One }));
    if (color.name === repr.defaultColorTheme.name)
        Object.assign(colorDefaultParams, repr.defaultColorTheme.props);
    return { name: color.name, params: Object.assign(colorDefaultParams, params) };
}
function createVolumeSizeThemeParams(ctx, volume, typeName, themeName, params) {
    var _a = ctx.representation.volume, registry = _a.registry, themes = _a.themes;
    var repr = registry.get(typeName || registry.default.name);
    var size = themes.sizeThemeRegistry.get(themeName || repr.defaultSizeTheme.name);
    var sizeDefaultParams = _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_1__["ParamDefinition"].getDefaultValues(size.getParams({ volume: volume || _mol_model_volume__WEBPACK_IMPORTED_MODULE_0__["Volume"].One }));
    if (size.name === repr.defaultSizeTheme.name)
        Object.assign(sizeDefaultParams, repr.defaultSizeTheme.props);
    return { name: size.name, params: Object.assign(sizeDefaultParams, params) };
}
function createParamsByName(ctx, volume, props) {
    var typeProvider = (props.type && ctx.representation.volume.registry.get(props.type))
        || ctx.representation.volume.registry.default.provider;
    var colorProvider = (props.color && ctx.representation.volume.themes.colorThemeRegistry.get(props.color))
        || ctx.representation.volume.themes.colorThemeRegistry.get(typeProvider.defaultColorTheme.name);
    var sizeProvider = (props.size && ctx.representation.volume.themes.sizeThemeRegistry.get(props.size))
        || ctx.representation.volume.themes.sizeThemeRegistry.get(typeProvider.defaultSizeTheme.name);
    return createParamsProvider(ctx, volume, {
        type: typeProvider,
        typeParams: props.typeParams,
        color: colorProvider,
        colorParams: props.colorParams,
        size: sizeProvider,
        sizeParams: props.sizeParams
    });
}
function createParamsProvider(ctx, volume, props) {
    if (props === void 0) { props = {}; }
    var themeCtx = ctx.representation.volume.themes;
    var themeDataCtx = { volume: volume };
    var repr = props.type || ctx.representation.volume.registry.default.provider;
    var reprDefaultParams = _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_1__["ParamDefinition"].getDefaultValues(repr.getParams(themeCtx, volume));
    var reprParams = Object.assign(reprDefaultParams, props.typeParams);
    var color = props.color || themeCtx.colorThemeRegistry.get(repr.defaultColorTheme.name);
    var colorDefaultParams = _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_1__["ParamDefinition"].getDefaultValues(color.getParams(themeDataCtx));
    if (color.name === repr.defaultColorTheme.name)
        Object.assign(colorDefaultParams, repr.defaultColorTheme.props);
    var colorParams = Object.assign(colorDefaultParams, props.colorParams);
    var size = props.size || themeCtx.sizeThemeRegistry.get(repr.defaultSizeTheme.name);
    var sizeDefaultParams = _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_1__["ParamDefinition"].getDefaultValues(size.getParams(themeDataCtx));
    if (size.name === repr.defaultSizeTheme.name)
        Object.assign(sizeDefaultParams, repr.defaultSizeTheme.props);
    var sizeParams = Object.assign(sizeDefaultParams, props.sizeParams);
    return ({
        type: { name: repr.name, params: reprParams },
        colorTheme: { name: color.name, params: colorParams },
        sizeTheme: { name: size.name, params: sizeParams }
    });
}
//# sourceMappingURL=volume-representation-params.js.map

/***/ }),

/***/ "./lib/mol-plugin-state/manager/animation.js":
/*!***************************************************!*\
  !*** ./lib/mol-plugin-state/manager/animation.js ***!
  \***************************************************/
/*! exports provided: PluginAnimationManager */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "PluginAnimationManager", function() { return PluginAnimationManager; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _component__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../component */ "./lib/mol-plugin-state/component.js");
/* harmony import */ var _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../mol-util/param-definition */ "./lib/mol-util/param-definition.js");
/**
 * Copyright (c) 2019 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author David Sehnal <david.sehnal@gmail.com>
 */




// TODO: pause functionality (this needs to reset if the state tree changes)
// TODO: handle unregistered animations on state restore
// TODO: better API
var PluginAnimationManager = /** @class */ (function (_super) {
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__extends"])(PluginAnimationManager, _super);
    function PluginAnimationManager(context) {
        var _this = _super.call(this, { params: { current: '' }, animationState: 'stopped' }) || this;
        _this.context = context;
        _this.map = new Map();
        _this._animations = [];
        _this.currentTime = 0;
        _this._params = void 0;
        _this.events = {
            updated: _this.ev(),
            applied: _this.ev(),
        };
        _this.isStopped = true;
        _this.isApplying = false;
        return _this;
    }
    Object.defineProperty(PluginAnimationManager.prototype, "isEmpty", {
        get: function () { return this._animations.length === 0; },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PluginAnimationManager.prototype, "current", {
        get: function () { return this._current; },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PluginAnimationManager.prototype, "animations", {
        get: function () { return this._animations; },
        enumerable: false,
        configurable: true
    });
    PluginAnimationManager.prototype.triggerUpdate = function () {
        this.events.updated.next();
    };
    PluginAnimationManager.prototype.triggerApply = function () {
        this.events.applied.next();
    };
    PluginAnimationManager.prototype.getParams = function () {
        if (!this._params) {
            this._params = {
                current: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_2__["ParamDefinition"].Select(this._animations[0] && this._animations[0].name, this._animations.map(function (a) { return [a.name, a.display.name]; }), { label: 'Animation' })
            };
        }
        return this._params;
    };
    PluginAnimationManager.prototype.updateParams = function (newParams) {
        if (this.isEmpty)
            return;
        this.updateState({ params: Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, this.state.params), newParams) });
        var anim = this.map.get(this.state.params.current);
        var params = anim.params(this.context);
        this._current = {
            anim: anim,
            params: params,
            paramValues: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_2__["ParamDefinition"].getDefaultValues(params),
            state: {},
            startedTime: -1,
            lastTime: 0
        };
        this.triggerUpdate();
    };
    PluginAnimationManager.prototype.updateCurrentParams = function (values) {
        if (this.isEmpty)
            return;
        this._current.paramValues = Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, this._current.paramValues), values);
        this.triggerUpdate();
    };
    PluginAnimationManager.prototype.register = function (animation) {
        if (this.map.has(animation.name)) {
            this.context.log.error("Animation '" + animation.name + "' is already registered.");
            return;
        }
        this._params = void 0;
        this.map.set(animation.name, animation);
        this._animations.push(animation);
        if (this._animations.length === 1) {
            this.updateParams({ current: animation.name });
        }
        else {
            this.triggerUpdate();
        }
    };
    PluginAnimationManager.prototype.play = function (animation, params) {
        return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"])(this, void 0, void 0, function () {
            return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__generator"])(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.stop()];
                    case 1:
                        _a.sent();
                        if (!this.map.has(animation.name)) {
                            this.register(animation);
                        }
                        this.updateParams({ current: animation.name });
                        this.updateCurrentParams(params);
                        return [4 /*yield*/, this.start()];
                    case 2:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    PluginAnimationManager.prototype.tick = function (t, isSynchronous) {
        return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"])(this, void 0, void 0, function () {
            return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__generator"])(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.currentTime = t;
                        if (this.isStopped)
                            return [2 /*return*/];
                        if (!isSynchronous) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.applyFrame()];
                    case 1:
                        _a.sent();
                        return [3 /*break*/, 3];
                    case 2:
                        this.applyAsync();
                        _a.label = 3;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    PluginAnimationManager.prototype.start = function () {
        return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"])(this, void 0, void 0, function () {
            var anim, initialState, state;
            return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__generator"])(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.updateState({ animationState: 'playing' });
                        if (!this.context.behaviors.state.isAnimating.value) {
                            this.context.behaviors.state.isAnimating.next(true);
                        }
                        this.triggerUpdate();
                        anim = this._current.anim;
                        initialState = this._current.anim.initialState(this._current.paramValues, this.context);
                        if (!anim.setup) return [3 /*break*/, 2];
                        return [4 /*yield*/, anim.setup(this._current.paramValues, initialState, this.context)];
                    case 1:
                        state = _a.sent();
                        if (state)
                            initialState = state;
                        _a.label = 2;
                    case 2:
                        this._current.lastTime = 0;
                        this._current.startedTime = -1;
                        this._current.state = initialState;
                        this.isStopped = false;
                        return [2 /*return*/];
                }
            });
        });
    };
    PluginAnimationManager.prototype.stop = function () {
        return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"])(this, void 0, void 0, function () {
            var anim;
            return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__generator"])(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.isStopped = true;
                        if (!(this.state.animationState !== 'stopped')) return [3 /*break*/, 3];
                        anim = this._current.anim;
                        if (!anim.teardown) return [3 /*break*/, 2];
                        return [4 /*yield*/, anim.teardown(this._current.paramValues, this._current.state, this.context)];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2:
                        this.updateState({ animationState: 'stopped' });
                        this.triggerUpdate();
                        _a.label = 3;
                    case 3:
                        if (this.context.behaviors.state.isAnimating.value) {
                            this.context.behaviors.state.isAnimating.next(false);
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    Object.defineProperty(PluginAnimationManager.prototype, "isAnimating", {
        get: function () {
            return this.state.animationState === 'playing';
        },
        enumerable: false,
        configurable: true
    });
    PluginAnimationManager.prototype.applyAsync = function () {
        return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"])(this, void 0, void 0, function () {
            return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__generator"])(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (this.isApplying)
                            return [2 /*return*/];
                        this.isApplying = true;
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, , 3, 4]);
                        return [4 /*yield*/, this.applyFrame()];
                    case 2:
                        _a.sent();
                        return [3 /*break*/, 4];
                    case 3:
                        this.isApplying = false;
                        return [7 /*endfinally*/];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    PluginAnimationManager.prototype.applyFrame = function () {
        return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"])(this, void 0, void 0, function () {
            var t, newState;
            return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__generator"])(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        t = this.currentTime;
                        if (this._current.startedTime < 0)
                            this._current.startedTime = t;
                        return [4 /*yield*/, this._current.anim.apply(this._current.state, { lastApplied: this._current.lastTime, current: t - this._current.startedTime }, { params: this._current.paramValues, plugin: this.context })];
                    case 1:
                        newState = _a.sent();
                        if (newState.kind === 'finished') {
                            this.stop();
                        }
                        else if (newState.kind === 'next') {
                            this._current.state = newState.state;
                            this._current.lastTime = t - this._current.startedTime;
                        }
                        this.triggerApply();
                        return [2 /*return*/];
                }
            });
        });
    };
    PluginAnimationManager.prototype.getSnapshot = function () {
        if (!this.current)
            return { state: this.state };
        return {
            state: this.state,
            current: {
                paramValues: this._current.paramValues,
                state: this._current.anim.stateSerialization ? this._current.anim.stateSerialization.toJSON(this._current.state) : this._current.state
            }
        };
    };
    PluginAnimationManager.prototype.setSnapshot = function (snapshot) {
        if (this.isEmpty)
            return;
        this.updateState({ animationState: snapshot.state.animationState });
        this.updateParams(snapshot.state.params);
        if (snapshot.current) {
            this.current.paramValues = snapshot.current.paramValues;
            this.current.state = this._current.anim.stateSerialization
                ? this._current.anim.stateSerialization.fromJSON(snapshot.current.state)
                : snapshot.current.state;
            this.triggerUpdate();
            if (this.state.animationState === 'playing')
                this.resume();
        }
    };
    PluginAnimationManager.prototype.resume = function () {
        return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"])(this, void 0, void 0, function () {
            var anim;
            return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__generator"])(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this._current.lastTime = 0;
                        this._current.startedTime = -1;
                        anim = this._current.anim;
                        if (!this.context.behaviors.state.isAnimating.value) {
                            this.context.behaviors.state.isAnimating.next(true);
                        }
                        if (!anim.setup) return [3 /*break*/, 2];
                        return [4 /*yield*/, anim.setup(this._current.paramValues, this._current.state, this.context)];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2:
                        this.isStopped = false;
                        return [2 /*return*/];
                }
            });
        });
    };
    return PluginAnimationManager;
}(_component__WEBPACK_IMPORTED_MODULE_1__["StatefulPluginComponent"]));
//# sourceMappingURL=animation.js.map

/***/ }),

/***/ "./lib/mol-plugin-state/manager/camera.js":
/*!************************************************!*\
  !*** ./lib/mol-plugin-state/manager/camera.js ***!
  \************************************************/
/*! exports provided: CameraManager */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CameraManager", function() { return CameraManager; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _mol_model_loci__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../mol-model/loci */ "./lib/mol-model/loci.js");
/* harmony import */ var _mol_math_geometry_boundary_helper__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../mol-math/geometry/boundary-helper */ "./lib/mol-math/geometry/boundary-helper.js");
/* harmony import */ var _mol_model_structure__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../mol-model/structure */ "./lib/mol-model/structure.js");
/**
 * Copyright (c) 2019-2020 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author David Sehnal <david.sehnal@gmail.com>
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */




// TODO: make this customizable somewhere?
var DefaultCameraFocusOptions = {
    minRadius: 5,
    extraRadius: 4,
    durationMs: 250
};
var CameraManager = /** @class */ (function () {
    function CameraManager(plugin) {
        this.plugin = plugin;
        this.boundaryHelper = new _mol_math_geometry_boundary_helper__WEBPACK_IMPORTED_MODULE_2__["BoundaryHelper"]('98');
    }
    CameraManager.prototype.transformedLoci = function (loci) {
        var _a, _b;
        if (_mol_model_structure__WEBPACK_IMPORTED_MODULE_3__["StructureElement"].Loci.is(loci)) {
            // use decorated (including 3d transforms) parent structure
            var parent_1 = (_b = (_a = this.plugin.helpers.substructureParent.get(loci.structure)) === null || _a === void 0 ? void 0 : _a.obj) === null || _b === void 0 ? void 0 : _b.data;
            if (parent_1)
                loci = _mol_model_structure__WEBPACK_IMPORTED_MODULE_3__["StructureElement"].Loci.remap(loci, parent_1);
        }
        return loci;
    };
    CameraManager.prototype.focusRenderObjects = function (objects, options) {
        if (!objects)
            return;
        var spheres = [];
        for (var _i = 0, objects_1 = objects; _i < objects_1.length; _i++) {
            var o = objects_1[_i];
            var s = o.values.boundingSphere.ref.value;
            if (s.radius === 0)
                continue;
            spheres.push(s);
        }
        this.focusSpheres(spheres, function (s) { return s; }, options);
    };
    CameraManager.prototype.focusLoci = function (loci, options) {
        // TODO: allow computation of principal axes here?
        // perhaps have an optimized function, that does exact axes small Loci and approximate/sampled from big ones?
        var sphere;
        if (Array.isArray(loci) && loci.length > 1) {
            var spheres = [];
            for (var _i = 0, loci_1 = loci; _i < loci_1.length; _i++) {
                var l = loci_1[_i];
                var s = _mol_model_loci__WEBPACK_IMPORTED_MODULE_1__["Loci"].getBoundingSphere(this.transformedLoci(l));
                if (s)
                    spheres.push(s);
            }
            if (spheres.length === 0)
                return;
            this.boundaryHelper.reset();
            for (var _a = 0, spheres_1 = spheres; _a < spheres_1.length; _a++) {
                var s = spheres_1[_a];
                this.boundaryHelper.includeSphere(s);
            }
            this.boundaryHelper.finishedIncludeStep();
            for (var _b = 0, spheres_2 = spheres; _b < spheres_2.length; _b++) {
                var s = spheres_2[_b];
                this.boundaryHelper.radiusSphere(s);
            }
            sphere = this.boundaryHelper.getSphere();
        }
        else if (Array.isArray(loci)) {
            if (loci.length === 0)
                return;
            sphere = _mol_model_loci__WEBPACK_IMPORTED_MODULE_1__["Loci"].getBoundingSphere(this.transformedLoci(loci[0]));
        }
        else {
            sphere = _mol_model_loci__WEBPACK_IMPORTED_MODULE_1__["Loci"].getBoundingSphere(this.transformedLoci(loci));
        }
        if (sphere) {
            this.focusSphere(sphere, options);
        }
    };
    CameraManager.prototype.focusSpheres = function (xs, sphere, options) {
        var spheres = [];
        for (var _i = 0, xs_1 = xs; _i < xs_1.length; _i++) {
            var x = xs_1[_i];
            var s = sphere(x);
            if (s)
                spheres.push(s);
        }
        if (spheres.length === 0)
            return;
        if (spheres.length === 1)
            return this.focusSphere(spheres[0], options);
        this.boundaryHelper.reset();
        for (var _a = 0, spheres_3 = spheres; _a < spheres_3.length; _a++) {
            var s = spheres_3[_a];
            this.boundaryHelper.includeSphere(s);
        }
        this.boundaryHelper.finishedIncludeStep();
        for (var _b = 0, spheres_4 = spheres; _b < spheres_4.length; _b++) {
            var s = spheres_4[_b];
            this.boundaryHelper.radiusSphere(s);
        }
        this.focusSphere(this.boundaryHelper.getSphere(), options);
    };
    CameraManager.prototype.focusSphere = function (sphere, options) {
        var _a, _b, _c, _d;
        var _e = Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, DefaultCameraFocusOptions), options), extraRadius = _e.extraRadius, minRadius = _e.minRadius, durationMs = _e.durationMs;
        var radius = Math.max(sphere.radius + extraRadius, minRadius);
        if (options === null || options === void 0 ? void 0 : options.principalAxes) {
            var _f = options === null || options === void 0 ? void 0 : options.principalAxes.boxAxes, origin_1 = _f.origin, dirA = _f.dirA, dirC = _f.dirC;
            var snapshot = (_a = this.plugin.canvas3d) === null || _a === void 0 ? void 0 : _a.camera.getFocus(origin_1, radius, dirA, dirC);
            (_b = this.plugin.canvas3d) === null || _b === void 0 ? void 0 : _b.requestCameraReset({ durationMs: durationMs, snapshot: snapshot });
            // this.plugin.canvas3d?.camera.focus(origin, radius, durationMs, dirA, dirC);
        }
        else {
            var snapshot = (_c = this.plugin.canvas3d) === null || _c === void 0 ? void 0 : _c.camera.getFocus(sphere.center, radius);
            (_d = this.plugin.canvas3d) === null || _d === void 0 ? void 0 : _d.requestCameraReset({ durationMs: durationMs, snapshot: snapshot });
            // this.plugin.canvas3d?.camera.focus(sphere.center, radius, durationMs);
        }
    };
    CameraManager.prototype.setSnapshot = function (snapshot, durationMs) {
        var _a;
        // TODO: setState and requestCameraReset are very similar now: unify them?
        (_a = this.plugin.canvas3d) === null || _a === void 0 ? void 0 : _a.requestCameraReset({ snapshot: snapshot, durationMs: durationMs });
    };
    CameraManager.prototype.reset = function (snapshot, durationMs) {
        var _a;
        (_a = this.plugin.canvas3d) === null || _a === void 0 ? void 0 : _a.requestCameraReset({ snapshot: snapshot, durationMs: durationMs });
    };
    return CameraManager;
}());

//# sourceMappingURL=camera.js.map

/***/ }),

/***/ "./lib/mol-plugin-state/manager/interactivity.js":
/*!*******************************************************!*\
  !*** ./lib/mol-plugin-state/manager/interactivity.js ***!
  \*******************************************************/
/*! exports provided: InteractivityManager */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "InteractivityManager", function() { return InteractivityManager; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _mol_model_loci__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../mol-model/loci */ "./lib/mol-model/loci.js");
/* harmony import */ var _mol_model_structure__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../mol-model/structure */ "./lib/mol-model/structure.js");
/* harmony import */ var _mol_repr_representation__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../mol-repr/representation */ "./lib/mol-repr/representation.js");
/* harmony import */ var _mol_util_marker_action__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../mol-util/marker-action */ "./lib/mol-util/marker-action.js");
/* harmony import */ var _mol_util_object__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../mol-util/object */ "./lib/mol-util/object.js");
/* harmony import */ var _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../../mol-util/param-definition */ "./lib/mol-util/param-definition.js");
/* harmony import */ var _component__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../component */ "./lib/mol-plugin-state/component.js");
/**
 * Copyright (c) 2019-2020 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 * @author David Sehnal <david.sehnal@gmail.com>
 */









// TODO: make this customizable somewhere?
var DefaultInteractivityFocusOptions = {
    minRadius: 6,
    extraRadius: 6,
    durationMs: 250,
};
var InteractivityManager = /** @class */ (function (_super) {
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__extends"])(InteractivityManager, _super);
    function InteractivityManager(plugin, props) {
        if (props === void 0) { props = {}; }
        var _this = _super.call(this, { props: Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_6__["ParamDefinition"].getDefaultValues(InteractivityManager.Params)), props) }) || this;
        _this.plugin = plugin;
        _this._props = _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_6__["ParamDefinition"].getDefaultValues(InteractivityManager.Params);
        _this.events = {
            propsUpdated: _this.ev()
        };
        _this.lociSelects = new InteractivityManager.LociSelectManager(plugin, _this._props);
        _this.lociHighlights = new InteractivityManager.LociHighlightManager(plugin, _this._props);
        return _this;
    }
    Object.defineProperty(InteractivityManager.prototype, "props", {
        get: function () { return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, this.state.props); },
        enumerable: false,
        configurable: true
    });
    InteractivityManager.prototype.setProps = function (props) {
        var old = this.props;
        var _new = Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, this.state.props), props);
        if (Object(_mol_util_object__WEBPACK_IMPORTED_MODULE_5__["shallowEqual"])(old, _new))
            return;
        this.updateState({ props: _new });
        this.lociSelects.setProps(_new);
        this.lociHighlights.setProps(_new);
        this.events.propsUpdated.next();
    };
    return InteractivityManager;
}(_component__WEBPACK_IMPORTED_MODULE_7__["StatefulPluginComponent"]));
(function (InteractivityManager) {
    InteractivityManager.Params = {
        granularity: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_6__["ParamDefinition"].Select('residue', _mol_model_loci__WEBPACK_IMPORTED_MODULE_1__["Loci"].GranularityOptions, { label: 'Picking Level', description: 'Controls if selections are expanded upon picking to whole residues, chains, structures, instances, or left as atoms and coarse elements' }),
    };
    var LociMarkManager = /** @class */ (function () {
        function LociMarkManager(ctx, props) {
            if (props === void 0) { props = {}; }
            this.ctx = ctx;
            this.providers = [];
            this.props = _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_6__["ParamDefinition"].getDefaultValues(InteractivityManager.Params);
            this.sel = ctx.managers.structure.selection;
            this.setProps(props);
        }
        LociMarkManager.prototype.setProps = function (props) {
            Object.assign(this.props, props);
        };
        LociMarkManager.prototype.addProvider = function (provider) {
            this.providers.push(provider);
        };
        LociMarkManager.prototype.removeProvider = function (provider) {
            this.providers = this.providers.filter(function (p) { return p !== provider; });
            // TODO clear, then re-apply remaining providers
        };
        LociMarkManager.prototype.normalizedLoci = function (reprLoci, applyGranularity) {
            if (applyGranularity === void 0) { applyGranularity = true; }
            var loci = reprLoci.loci, repr = reprLoci.repr;
            var granularity = applyGranularity ? this.props.granularity : undefined;
            return { loci: _mol_model_loci__WEBPACK_IMPORTED_MODULE_1__["Loci"].normalize(loci, granularity), repr: repr };
        };
        LociMarkManager.prototype.mark = function (current, action) {
            if (!_mol_model_loci__WEBPACK_IMPORTED_MODULE_1__["Loci"].isEmpty(current.loci)) {
                for (var _i = 0, _a = this.providers; _i < _a.length; _i++) {
                    var p = _a[_i];
                    p(current, action);
                }
            }
        };
        return LociMarkManager;
    }());
    InteractivityManager.LociMarkManager = LociMarkManager;
    //
    var LociHighlightManager = /** @class */ (function (_super) {
        Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__extends"])(LociHighlightManager, _super);
        function LociHighlightManager() {
            var _this = _super !== null && _super.apply(this, arguments) || this;
            _this.prev = [];
            _this.clearHighlights = function () {
                for (var _i = 0, _a = _this.prev; _i < _a.length; _i++) {
                    var p = _a[_i];
                    _this.mark(p, _mol_util_marker_action__WEBPACK_IMPORTED_MODULE_4__["MarkerAction"].RemoveHighlight);
                }
                _this.prev.length = 0;
            };
            return _this;
        }
        LociHighlightManager.prototype.isHighlighted = function (loci) {
            for (var _i = 0, _a = this.prev; _i < _a.length; _i++) {
                var p = _a[_i];
                if (_mol_repr_representation__WEBPACK_IMPORTED_MODULE_3__["Representation"].Loci.areEqual(p, loci))
                    return true;
            }
            return false;
        };
        LociHighlightManager.prototype.addHighlight = function (loci) {
            this.mark(loci, _mol_util_marker_action__WEBPACK_IMPORTED_MODULE_4__["MarkerAction"].Highlight);
            this.prev.push(loci);
        };
        LociHighlightManager.prototype.highlight = function (current, applyGranularity) {
            if (applyGranularity === void 0) { applyGranularity = true; }
            var normalized = this.normalizedLoci(current, applyGranularity);
            if (!this.isHighlighted(normalized)) {
                this.addHighlight(normalized);
            }
        };
        LociHighlightManager.prototype.highlightOnly = function (current, applyGranularity) {
            if (applyGranularity === void 0) { applyGranularity = true; }
            var normalized = this.normalizedLoci(current, applyGranularity);
            if (!this.isHighlighted(normalized)) {
                this.clearHighlights();
                this.addHighlight(normalized);
            }
        };
        LociHighlightManager.prototype.highlightOnlyExtend = function (current, applyGranularity) {
            if (applyGranularity === void 0) { applyGranularity = true; }
            var normalized = this.normalizedLoci(current, applyGranularity);
            if (_mol_model_structure__WEBPACK_IMPORTED_MODULE_2__["StructureElement"].Loci.is(normalized.loci)) {
                var loci = {
                    loci: this.sel.tryGetRange(normalized.loci) || normalized.loci,
                    repr: normalized.repr
                };
                if (!this.isHighlighted(loci)) {
                    this.clearHighlights();
                    this.addHighlight(loci);
                }
            }
        };
        return LociHighlightManager;
    }(LociMarkManager));
    InteractivityManager.LociHighlightManager = LociHighlightManager;
    //
    var LociSelectManager = /** @class */ (function (_super) {
        Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__extends"])(LociSelectManager, _super);
        function LociSelectManager() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        LociSelectManager.prototype.toggle = function (current, applyGranularity) {
            if (applyGranularity === void 0) { applyGranularity = true; }
            if (_mol_model_loci__WEBPACK_IMPORTED_MODULE_1__["Loci"].isEmpty(current.loci))
                return;
            var normalized = this.normalizedLoci(current, applyGranularity);
            if (_mol_model_structure__WEBPACK_IMPORTED_MODULE_2__["StructureElement"].Loci.is(normalized.loci)) {
                this.toggleSel(normalized);
            }
            else {
                _super.prototype.mark.call(this, normalized, _mol_util_marker_action__WEBPACK_IMPORTED_MODULE_4__["MarkerAction"].Toggle);
            }
        };
        LociSelectManager.prototype.toggleExtend = function (current, applyGranularity) {
            if (applyGranularity === void 0) { applyGranularity = true; }
            if (_mol_model_loci__WEBPACK_IMPORTED_MODULE_1__["Loci"].isEmpty(current.loci))
                return;
            var normalized = this.normalizedLoci(current, applyGranularity);
            if (_mol_model_structure__WEBPACK_IMPORTED_MODULE_2__["StructureElement"].Loci.is(normalized.loci)) {
                var loci = this.sel.tryGetRange(normalized.loci) || normalized.loci;
                this.toggleSel({ loci: loci, repr: normalized.repr });
            }
        };
        LociSelectManager.prototype.select = function (current, applyGranularity) {
            if (applyGranularity === void 0) { applyGranularity = true; }
            var normalized = this.normalizedLoci(current, applyGranularity);
            if (_mol_model_structure__WEBPACK_IMPORTED_MODULE_2__["StructureElement"].Loci.is(normalized.loci)) {
                this.sel.modify('add', normalized.loci);
            }
            this.mark(normalized, _mol_util_marker_action__WEBPACK_IMPORTED_MODULE_4__["MarkerAction"].Select);
        };
        LociSelectManager.prototype.selectJoin = function (current, applyGranularity) {
            if (applyGranularity === void 0) { applyGranularity = true; }
            var normalized = this.normalizedLoci(current, applyGranularity);
            if (_mol_model_structure__WEBPACK_IMPORTED_MODULE_2__["StructureElement"].Loci.is(normalized.loci)) {
                this.sel.modify('intersect', normalized.loci);
            }
            this.mark(normalized, _mol_util_marker_action__WEBPACK_IMPORTED_MODULE_4__["MarkerAction"].Select);
        };
        LociSelectManager.prototype.selectOnly = function (current, applyGranularity) {
            if (applyGranularity === void 0) { applyGranularity = true; }
            var normalized = this.normalizedLoci(current, applyGranularity);
            if (_mol_model_structure__WEBPACK_IMPORTED_MODULE_2__["StructureElement"].Loci.is(normalized.loci)) {
                // only deselect for the structure of the given loci
                this.deselect({ loci: _mol_model_structure__WEBPACK_IMPORTED_MODULE_2__["Structure"].toStructureElementLoci(normalized.loci.structure), repr: normalized.repr }, false);
                this.sel.modify('set', normalized.loci);
            }
            this.mark(normalized, _mol_util_marker_action__WEBPACK_IMPORTED_MODULE_4__["MarkerAction"].Select);
        };
        LociSelectManager.prototype.deselect = function (current, applyGranularity) {
            if (applyGranularity === void 0) { applyGranularity = true; }
            var normalized = this.normalizedLoci(current, applyGranularity);
            if (_mol_model_structure__WEBPACK_IMPORTED_MODULE_2__["StructureElement"].Loci.is(normalized.loci)) {
                this.sel.modify('remove', normalized.loci);
            }
            this.mark(normalized, _mol_util_marker_action__WEBPACK_IMPORTED_MODULE_4__["MarkerAction"].Deselect);
        };
        LociSelectManager.prototype.deselectAll = function () {
            this.sel.clear();
            this.mark({ loci: _mol_model_loci__WEBPACK_IMPORTED_MODULE_1__["EveryLoci"] }, _mol_util_marker_action__WEBPACK_IMPORTED_MODULE_4__["MarkerAction"].Deselect);
        };
        LociSelectManager.prototype.deselectAllOnEmpty = function (current) {
            if (Object(_mol_model_loci__WEBPACK_IMPORTED_MODULE_1__["isEmptyLoci"])(current.loci))
                this.deselectAll();
        };
        LociSelectManager.prototype.mark = function (current, action) {
            var loci = current.loci;
            if (!_mol_model_loci__WEBPACK_IMPORTED_MODULE_1__["Loci"].isEmpty(loci)) {
                if (_mol_model_structure__WEBPACK_IMPORTED_MODULE_2__["StructureElement"].Loci.is(loci)) {
                    // do a full deselect/select for the current structure so visuals that are
                    // marked with granularity unequal to 'element' and join/intersect operations
                    // are handled properly
                    _super.prototype.mark.call(this, { loci: _mol_model_structure__WEBPACK_IMPORTED_MODULE_2__["Structure"].Loci(loci.structure) }, _mol_util_marker_action__WEBPACK_IMPORTED_MODULE_4__["MarkerAction"].Deselect);
                    _super.prototype.mark.call(this, { loci: this.sel.getLoci(loci.structure) }, _mol_util_marker_action__WEBPACK_IMPORTED_MODULE_4__["MarkerAction"].Select);
                }
                else {
                    _super.prototype.mark.call(this, current, action);
                }
            }
        };
        LociSelectManager.prototype.toggleSel = function (current) {
            if (this.sel.has(current.loci)) {
                this.sel.modify('remove', current.loci);
                this.mark(current, _mol_util_marker_action__WEBPACK_IMPORTED_MODULE_4__["MarkerAction"].Deselect);
            }
            else {
                this.sel.modify('add', current.loci);
                this.mark(current, _mol_util_marker_action__WEBPACK_IMPORTED_MODULE_4__["MarkerAction"].Select);
            }
        };
        return LociSelectManager;
    }(LociMarkManager));
    InteractivityManager.LociSelectManager = LociSelectManager;
})(InteractivityManager || (InteractivityManager = {}));
//# sourceMappingURL=interactivity.js.map

/***/ }),

/***/ "./lib/mol-plugin-state/manager/loci-label.js":
/*!****************************************************!*\
  !*** ./lib/mol-plugin-state/manager/loci-label.js ***!
  \****************************************************/
/*! exports provided: LociLabelManager */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "LociLabelManager", function() { return LociLabelManager; });
/* harmony import */ var _mol_model_loci__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../mol-model/loci */ "./lib/mol-model/loci.js");
/* harmony import */ var _mol_repr_representation__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../mol-repr/representation */ "./lib/mol-repr/representation.js");
/* harmony import */ var _mol_util_marker_action__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../mol-util/marker-action */ "./lib/mol-util/marker-action.js");
/* harmony import */ var _mol_util_array__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../mol-util/array */ "./lib/mol-util/array.js");
/**
 * Copyright (c) 2018-2020 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author David Sehnal <david.sehnal@gmail.com>
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */




var LociLabelManager = /** @class */ (function () {
    function LociLabelManager(ctx) {
        var _this = this;
        this.ctx = ctx;
        this.providers = [];
        this.locis = [];
        this.isDirty = false;
        this.labels = [];
        this.groupedLabels = new Map();
        ctx.managers.interactivity.lociHighlights.addProvider(function (loci, action) {
            _this.mark(loci, action);
            _this.showLabels();
        });
    }
    LociLabelManager.prototype.clearProviders = function () {
        this.providers = [];
        this.isDirty = true;
        this.showLabels();
    };
    LociLabelManager.prototype.addProvider = function (provider) {
        this.providers.push(provider);
        this.providers.sort(function (a, b) { return (b.priority || 0) - (a.priority || 0); });
        this.isDirty = true;
        this.showLabels();
    };
    LociLabelManager.prototype.removeProvider = function (provider) {
        this.providers = this.providers.filter(function (p) { return p !== provider; });
        this.isDirty = true;
        this.showLabels();
    };
    LociLabelManager.prototype.mark = function (loci, action) {
        var idx = this.locis.findIndex(function (l) { return _mol_repr_representation__WEBPACK_IMPORTED_MODULE_1__["Representation"].Loci.areEqual(loci, l); });
        if (idx === -1 && action === _mol_util_marker_action__WEBPACK_IMPORTED_MODULE_2__["MarkerAction"].Highlight) {
            this.locis.push(loci);
            this.isDirty = true;
        }
        else if (idx !== -1 && action === _mol_util_marker_action__WEBPACK_IMPORTED_MODULE_2__["MarkerAction"].RemoveHighlight) {
            Object(_mol_util_array__WEBPACK_IMPORTED_MODULE_3__["arrayRemoveAtInPlace"])(this.locis, idx);
            this.isDirty = true;
        }
    };
    LociLabelManager.prototype.showLabels = function () {
        this.ctx.behaviors.labels.highlight.next({ labels: this.getLabels() });
    };
    LociLabelManager.prototype.getLabels = function () {
        var _this = this;
        if (this.isDirty) {
            this.groupedLabels.clear();
            this.labels.length = 0;
            for (var _i = 0, _a = this.providers; _i < _a.length; _i++) {
                var provider = _a[_i];
                for (var _b = 0, _c = this.locis; _b < _c.length; _b++) {
                    var loci = _c[_b];
                    if (_mol_model_loci__WEBPACK_IMPORTED_MODULE_0__["Loci"].isEmpty(loci.loci))
                        continue;
                    var label = provider.label(loci.loci, loci.repr);
                    if (label) {
                        var hash = provider.group ? provider.group(label) : label.toString();
                        var group = this.groupedLabels.get(hash);
                        if (group)
                            group.push(label);
                        else
                            this.groupedLabels.set(hash, [label]);
                    }
                }
            }
            this.labels.length = 0;
            this.groupedLabels.forEach(function (group, hash) {
                var count = group.length;
                var entry = count > 1 && group[0] !== group[1]
                    ? hash : group[0];
                _this.labels.push(count === 1 ? entry : entry + " <small>|| \u00D7 " + count + "</small>");
            });
            this.isDirty = false;
        }
        return this.labels;
    };
    return LociLabelManager;
}());

//# sourceMappingURL=loci-label.js.map

/***/ }),

/***/ "./lib/mol-plugin-state/manager/snapshots.js":
/*!***************************************************!*\
  !*** ./lib/mol-plugin-state/manager/snapshots.js ***!
  \***************************************************/
/*! exports provided: PluginStateSnapshotManager */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "PluginStateSnapshotManager", function() { return PluginStateSnapshotManager; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var immutable__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! immutable */ "./node_modules/immutable/dist/immutable.js");
/* harmony import */ var immutable__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(immutable__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _component__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../component */ "./lib/mol-plugin-state/component.js");
/* harmony import */ var _mol_io_common_utf8__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../mol-io/common/utf8 */ "./lib/mol-io/common/utf8.js");
/* harmony import */ var _mol_util_zip_zip__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../mol-util/zip/zip */ "./lib/mol-util/zip/zip.js");
/* harmony import */ var _mol_util_data_source__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../mol-util/data-source */ "./lib/mol-util/data-source.js");
/* harmony import */ var _mol_util_object__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../../mol-util/object */ "./lib/mol-util/object.js");
/* harmony import */ var _mol_plugin_version__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../../mol-plugin/version */ "./lib/mol-plugin/version.js");
/**
 * Copyright (c) 2018-2020 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author David Sehnal <david.sehnal@gmail.com>
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */









var PluginStateSnapshotManager = /** @class */ (function (_super) {
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__extends"])(PluginStateSnapshotManager, _super);
    function PluginStateSnapshotManager(plugin) {
        var _this = _super.call(this, {
            current: void 0,
            entries: Object(immutable__WEBPACK_IMPORTED_MODULE_1__["List"])(),
            isPlaying: false,
            nextSnapshotDelayInMs: PluginStateSnapshotManager.DefaultNextSnapshotDelayInMs
        }) || this;
        _this.plugin = plugin;
        _this.entryMap = new Map();
        _this.events = {
            changed: _this.ev()
        };
        _this.timeoutHandle = void 0;
        _this.next = function () { return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"])(_this, void 0, void 0, function () {
            var next, snapshot, delay;
            return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__generator"])(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.timeoutHandle = void 0;
                        next = this.getNextId(this.state.current, 1);
                        if (!next || next === this.state.current) {
                            this.stop();
                            return [2 /*return*/];
                        }
                        snapshot = this.setCurrent(next);
                        return [4 /*yield*/, this.plugin.state.setSnapshot(snapshot)];
                    case 1:
                        _a.sent();
                        delay = typeof snapshot.durationInMs !== 'undefined' ? snapshot.durationInMs : this.state.nextSnapshotDelayInMs;
                        if (this.state.isPlaying)
                            this.timeoutHandle = setTimeout(this.next, delay);
                        return [2 /*return*/];
                }
            });
        }); };
        return _this;
        // TODO make nextSnapshotDelayInMs editable
    }
    PluginStateSnapshotManager.prototype.getIndex = function (e) {
        return this.state.entries.indexOf(e);
    };
    PluginStateSnapshotManager.prototype.getEntry = function (id) {
        if (!id)
            return;
        return this.entryMap.get(id);
    };
    PluginStateSnapshotManager.prototype.remove = function (id) {
        var e = this.entryMap.get(id);
        if (!e)
            return;
        this.entryMap.delete(id);
        this.updateState({
            current: this.state.current === id ? void 0 : this.state.current,
            entries: this.state.entries.delete(this.getIndex(e))
        });
        this.events.changed.next();
    };
    PluginStateSnapshotManager.prototype.add = function (e) {
        this.entryMap.set(e.snapshot.id, e);
        this.updateState({ current: e.snapshot.id, entries: this.state.entries.push(e) });
        this.events.changed.next();
    };
    PluginStateSnapshotManager.prototype.replace = function (id, snapshot) {
        var old = this.getEntry(id);
        if (!old)
            return;
        var idx = this.getIndex(old);
        // The id changes here!
        var e = PluginStateSnapshotManager.Entry(snapshot, {
            name: old.name,
            description: old.description
        });
        this.entryMap.set(snapshot.id, e);
        this.updateState({ current: e.snapshot.id, entries: this.state.entries.set(idx, e) });
        this.events.changed.next();
    };
    PluginStateSnapshotManager.prototype.move = function (id, dir) {
        var len = this.state.entries.size;
        if (len < 2)
            return;
        var e = this.getEntry(id);
        if (!e)
            return;
        var from = this.getIndex(e);
        var to = (from + dir) % len;
        if (to < 0)
            to += len;
        var f = this.state.entries.get(to);
        var entries = this.state.entries.asMutable();
        entries.set(to, e);
        entries.set(from, f);
        this.updateState({ current: e.snapshot.id, entries: entries.asImmutable() });
        this.events.changed.next();
    };
    PluginStateSnapshotManager.prototype.clear = function () {
        if (this.state.entries.size === 0)
            return;
        this.entryMap.clear();
        this.updateState({ current: void 0, entries: Object(immutable__WEBPACK_IMPORTED_MODULE_1__["List"])() });
        this.events.changed.next();
    };
    PluginStateSnapshotManager.prototype.setCurrent = function (id) {
        var e = this.getEntry(id);
        if (e) {
            this.updateState({ current: id });
            this.events.changed.next();
        }
        return e && e.snapshot;
    };
    PluginStateSnapshotManager.prototype.getNextId = function (id, dir) {
        var len = this.state.entries.size;
        if (!id) {
            if (len === 0)
                return void 0;
            var idx_1 = dir === -1 ? len - 1 : 0;
            return this.state.entries.get(idx_1).snapshot.id;
        }
        var e = this.getEntry(id);
        if (!e)
            return;
        var idx = this.getIndex(e);
        if (idx < 0)
            return;
        idx = (idx + dir) % len;
        if (idx < 0)
            idx += len;
        return this.state.entries.get(idx).snapshot.id;
    };
    PluginStateSnapshotManager.prototype.setStateSnapshot = function (snapshot) {
        return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"])(this, void 0, void 0, function () {
            var entries, _i, _a, e, current, entry, next;
            return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__generator"])(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (snapshot.version !== _mol_plugin_version__WEBPACK_IMPORTED_MODULE_7__["PLUGIN_VERSION"]) {
                            // TODO
                            // console.warn('state snapshot version mismatch');
                        }
                        this.clear();
                        entries = Object(immutable__WEBPACK_IMPORTED_MODULE_1__["List"])().asMutable();
                        for (_i = 0, _a = snapshot.entries; _i < _a.length; _i++) {
                            e = _a[_i];
                            this.entryMap.set(e.snapshot.id, e);
                            entries.push(e);
                        }
                        current = snapshot.current
                            ? snapshot.current
                            : snapshot.entries.length > 0
                                ? snapshot.entries[0].snapshot.id
                                : void 0;
                        this.updateState({
                            current: current,
                            entries: entries.asImmutable(),
                            isPlaying: false,
                            nextSnapshotDelayInMs: snapshot.playback ? snapshot.playback.nextSnapshotDelayInMs : PluginStateSnapshotManager.DefaultNextSnapshotDelayInMs
                        });
                        this.events.changed.next();
                        if (!current)
                            return [2 /*return*/];
                        entry = this.getEntry(current);
                        next = entry && entry.snapshot;
                        if (!next)
                            return [2 /*return*/];
                        return [4 /*yield*/, this.plugin.state.setSnapshot(next)];
                    case 1:
                        _b.sent();
                        if (snapshot.playback && snapshot.playback.isPlaying)
                            this.play(true);
                        return [2 /*return*/, next];
                }
            });
        });
    };
    PluginStateSnapshotManager.prototype.syncCurrent = function (options) {
        var snapshot = this.plugin.state.getSnapshot(options === null || options === void 0 ? void 0 : options.params);
        if (this.state.entries.size === 0 || !this.state.current) {
            this.add(PluginStateSnapshotManager.Entry(snapshot, { name: options === null || options === void 0 ? void 0 : options.name, description: options === null || options === void 0 ? void 0 : options.description }));
        }
        else {
            this.replace(this.state.current, snapshot);
        }
    };
    PluginStateSnapshotManager.prototype.getStateSnapshot = function (options) {
        // TODO: diffing and all that fancy stuff
        this.syncCurrent(options);
        return {
            timestamp: +new Date(),
            version: _mol_plugin_version__WEBPACK_IMPORTED_MODULE_7__["PLUGIN_VERSION"],
            name: options && options.name,
            description: options && options.description,
            current: this.state.current,
            playback: {
                isPlaying: !!(options && options.playOnLoad),
                nextSnapshotDelayInMs: this.state.nextSnapshotDelayInMs
            },
            entries: this.state.entries.valueSeq().toArray()
        };
    };
    PluginStateSnapshotManager.prototype.serialize = function (options) {
        return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"])(this, void 0, void 0, function () {
            var json, state, zipDataObj, assets, _i, _a, _b, asset, file, _c, _d, _e, index, data, zipFile;
            return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__generator"])(this, function (_f) {
                switch (_f.label) {
                    case 0:
                        json = JSON.stringify(this.getStateSnapshot({ params: options === null || options === void 0 ? void 0 : options.params }), null, 2);
                        if (!(!(options === null || options === void 0 ? void 0 : options.type) || options.type === 'json' || options.type === 'molj')) return [3 /*break*/, 1];
                        return [2 /*return*/, new Blob([json], { type: 'application/json;charset=utf-8' })];
                    case 1:
                        state = new Uint8Array(Object(_mol_io_common_utf8__WEBPACK_IMPORTED_MODULE_3__["utf8ByteCount"])(json));
                        Object(_mol_io_common_utf8__WEBPACK_IMPORTED_MODULE_3__["utf8Write"])(state, 0, json);
                        zipDataObj = {
                            'state.json': state
                        };
                        assets = [];
                        _i = 0, _a = this.plugin.managers.asset.assets;
                        _f.label = 2;
                    case 2:
                        if (!(_i < _a.length)) return [3 /*break*/, 5];
                        _b = _a[_i], asset = _b.asset, file = _b.file;
                        assets.push([asset.id, asset]);
                        _c = zipDataObj;
                        _d = "assets/" + asset.id;
                        _e = Uint8Array.bind;
                        return [4 /*yield*/, file.arrayBuffer()];
                    case 3:
                        _c[_d] = new (_e.apply(Uint8Array, [void 0, _f.sent()]))();
                        _f.label = 4;
                    case 4:
                        _i++;
                        return [3 /*break*/, 2];
                    case 5:
                        if (assets.length > 0) {
                            index = JSON.stringify(assets, null, 2);
                            data = new Uint8Array(Object(_mol_io_common_utf8__WEBPACK_IMPORTED_MODULE_3__["utf8ByteCount"])(index));
                            Object(_mol_io_common_utf8__WEBPACK_IMPORTED_MODULE_3__["utf8Write"])(data, 0, index);
                            zipDataObj['assets.json'] = data;
                        }
                        zipFile = Object(_mol_util_zip_zip__WEBPACK_IMPORTED_MODULE_4__["zip"])(zipDataObj);
                        return [2 /*return*/, new Blob([zipFile], { type: 'application/zip' })];
                }
            });
        });
    };
    PluginStateSnapshotManager.prototype.open = function (file) {
        return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"])(this, void 0, void 0, function () {
            var fn, data, snapshot, data, assets_1, stateFile, stateData, file_1, json, _a, _b, _i, json_1, _c, id, asset, snapshot, e_1;
            return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__generator"])(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        _d.trys.push([0, 8, , 9]);
                        fn = file.name.toLowerCase();
                        if (!(fn.endsWith('json') || fn.endsWith('molj'))) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.plugin.runTask(Object(_mol_util_data_source__WEBPACK_IMPORTED_MODULE_5__["readFromFile"])(file, 'string'))];
                    case 1:
                        data = _d.sent();
                        snapshot = JSON.parse(data);
                        if (PluginStateSnapshotManager.isStateSnapshot(snapshot)) {
                            return [2 /*return*/, this.setStateSnapshot(snapshot)];
                        }
                        else if (PluginStateSnapshotManager.isStateSnapshot(snapshot.data)) {
                            return [2 /*return*/, this.setStateSnapshot(snapshot.data)];
                        }
                        else {
                            this.plugin.state.setSnapshot(snapshot);
                        }
                        return [3 /*break*/, 7];
                    case 2: return [4 /*yield*/, this.plugin.runTask(Object(_mol_util_data_source__WEBPACK_IMPORTED_MODULE_5__["readFromFile"])(file, 'zip'))];
                    case 3:
                        data = _d.sent();
                        assets_1 = Object.create(null);
                        Object(_mol_util_object__WEBPACK_IMPORTED_MODULE_6__["objectForEach"])(data, function (v, k) {
                            if (k === 'state.json' || k === 'assets.json')
                                return;
                            var name = k.substring(k.indexOf('/') + 1);
                            assets_1[name] = new File([v], name);
                        });
                        stateFile = new File([data['state.json']], 'state.json');
                        return [4 /*yield*/, this.plugin.runTask(Object(_mol_util_data_source__WEBPACK_IMPORTED_MODULE_5__["readFromFile"])(stateFile, 'string'))];
                    case 4:
                        stateData = _d.sent();
                        if (!data['assets.json']) return [3 /*break*/, 6];
                        file_1 = new File([data['assets.json']], 'assets.json');
                        _b = (_a = JSON).parse;
                        return [4 /*yield*/, this.plugin.runTask(Object(_mol_util_data_source__WEBPACK_IMPORTED_MODULE_5__["readFromFile"])(file_1, 'string'))];
                    case 5:
                        json = _b.apply(_a, [_d.sent()]);
                        for (_i = 0, json_1 = json; _i < json_1.length; _i++) {
                            _c = json_1[_i], id = _c[0], asset = _c[1];
                            this.plugin.managers.asset.set(asset, assets_1[id]);
                        }
                        _d.label = 6;
                    case 6:
                        snapshot = JSON.parse(stateData);
                        return [2 /*return*/, this.setStateSnapshot(snapshot)];
                    case 7: return [3 /*break*/, 9];
                    case 8:
                        e_1 = _d.sent();
                        this.plugin.log.error("Reading state: " + e_1);
                        return [3 /*break*/, 9];
                    case 9: return [2 /*return*/];
                }
            });
        });
    };
    PluginStateSnapshotManager.prototype.play = function (delayFirst) {
        if (delayFirst === void 0) { delayFirst = false; }
        this.updateState({ isPlaying: true });
        if (delayFirst) {
            var e = this.getEntry(this.state.current);
            if (!e) {
                this.next();
                return;
            }
            this.events.changed.next();
            var snapshot = e.snapshot;
            var delay = typeof snapshot.durationInMs !== 'undefined' ? snapshot.durationInMs : this.state.nextSnapshotDelayInMs;
            this.timeoutHandle = setTimeout(this.next, delay);
        }
        else {
            this.next();
        }
    };
    PluginStateSnapshotManager.prototype.stop = function () {
        this.updateState({ isPlaying: false });
        if (typeof this.timeoutHandle !== 'undefined')
            clearTimeout(this.timeoutHandle);
        this.timeoutHandle = void 0;
        this.events.changed.next();
    };
    PluginStateSnapshotManager.prototype.togglePlay = function () {
        if (this.state.isPlaying) {
            this.stop();
            this.plugin.managers.animation.stop();
        }
        else {
            this.play();
        }
    };
    PluginStateSnapshotManager.DefaultNextSnapshotDelayInMs = 1500;
    return PluginStateSnapshotManager;
}(_component__WEBPACK_IMPORTED_MODULE_2__["StatefulPluginComponent"]));
(function (PluginStateSnapshotManager) {
    function Entry(snapshot, params) {
        return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({ timestamp: +new Date(), snapshot: snapshot }, params);
    }
    PluginStateSnapshotManager.Entry = Entry;
    function isStateSnapshot(x) {
        var s = x;
        return !!s && !!s.timestamp && !!s.entries;
    }
    PluginStateSnapshotManager.isStateSnapshot = isStateSnapshot;
})(PluginStateSnapshotManager || (PluginStateSnapshotManager = {}));
//# sourceMappingURL=snapshots.js.map

/***/ }),

/***/ "./lib/mol-plugin-state/manager/structure/component.js":
/*!*************************************************************!*\
  !*** ./lib/mol-plugin-state/manager/structure/component.js ***!
  \*************************************************************/
/*! exports provided: StructureComponentManager */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "StructureComponentManager", function() { return StructureComponentManager; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _mol_geo_geometry_base__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../../mol-geo/geometry/base */ "./lib/mol-geo/geometry/base.js");
/* harmony import */ var _mol_model_props_computed_interactions__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../../mol-model-props/computed/interactions */ "./lib/mol-model-props/computed/interactions.js");
/* harmony import */ var _mol_model_structure__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../../mol-model/structure */ "./lib/mol-model/structure.js");
/* harmony import */ var _mol_model_structure_query_utils_structure_set__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../../mol-model/structure/query/utils/structure-set */ "./lib/mol-model/structure/query/utils/structure-set.js");
/* harmony import */ var _mol_plugin_behavior_static_state__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../../mol-plugin/behavior/static/state */ "./lib/mol-plugin/behavior/static/state.js");
/* harmony import */ var _mol_task__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../../../mol-task */ "./lib/mol-task/index.js");
/* harmony import */ var _mol_util__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../../../mol-util */ "./lib/mol-util/index.js");
/* harmony import */ var _mol_util_color_names__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ../../../mol-util/color/names */ "./lib/mol-util/color/names.js");
/* harmony import */ var _mol_util_object__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ../../../mol-util/object */ "./lib/mol-util/object.js");
/* harmony import */ var _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ../../../mol-util/param-definition */ "./lib/mol-util/param-definition.js");
/* harmony import */ var _component__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ../../component */ "./lib/mol-plugin-state/component.js");
/* harmony import */ var _helpers_structure_overpaint__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! ../../helpers/structure-overpaint */ "./lib/mol-plugin-state/helpers/structure-overpaint.js");
/* harmony import */ var _helpers_structure_representation_params__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! ../../helpers/structure-representation-params */ "./lib/mol-plugin-state/helpers/structure-representation-params.js");
/* harmony import */ var _helpers_structure_selection_query__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! ../../helpers/structure-selection-query */ "./lib/mol-plugin-state/helpers/structure-selection-query.js");
/* harmony import */ var _transforms_representation__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! ../../transforms/representation */ "./lib/mol-plugin-state/transforms/representation.js");
/* harmony import */ var _mol_theme_clipping__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(/*! ../../../mol-theme/clipping */ "./lib/mol-theme/clipping.js");
/* harmony import */ var _helpers_structure_clipping__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(/*! ../../helpers/structure-clipping */ "./lib/mol-plugin-state/helpers/structure-clipping.js");
/* harmony import */ var _helpers_structure_transparency__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(/*! ../../helpers/structure-transparency */ "./lib/mol-plugin-state/helpers/structure-transparency.js");
/* harmony import */ var _mol_plugin_behavior_dynamic_selection_structure_focus_representation__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(/*! ../../../mol-plugin/behavior/dynamic/selection/structure-focus-representation */ "./lib/mol-plugin/behavior/dynamic/selection/structure-focus-representation.js");
/**
 * Copyright (c) 2019-2020 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author David Sehnal <david.sehnal@gmail.com>
 */





















var StructureComponentManager = /** @class */ (function (_super) {
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__extends"])(StructureComponentManager, _super);
    function StructureComponentManager(plugin) {
        var _this = _super.call(this, { options: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_10__["ParamDefinition"].getDefaultValues(StructureComponentManager.OptionsParams) }) || this;
        _this.plugin = plugin;
        _this.events = {
            optionsUpdated: _this.ev()
        };
        return _this;
    }
    Object.defineProperty(StructureComponentManager.prototype, "currentStructures", {
        get: function () {
            return this.plugin.managers.structure.hierarchy.selection.structures;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(StructureComponentManager.prototype, "pivotStructure", {
        get: function () {
            return this.currentStructures[0];
        },
        enumerable: false,
        configurable: true
    });
    StructureComponentManager.prototype.setOptions = function (options) {
        return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"])(this, void 0, void 0, function () {
            var interactionChanged, update, _i, _a, s, _b, _c, c;
            var _this = this;
            return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__generator"])(this, function (_d) {
                interactionChanged = options.interactions !== this.state.options.interactions;
                this.updateState({ options: options });
                this.events.optionsUpdated.next();
                update = this.dataState.build();
                for (_i = 0, _a = this.currentStructures; _i < _a.length; _i++) {
                    s = _a[_i];
                    for (_b = 0, _c = s.components; _b < _c.length; _b++) {
                        c = _c[_b];
                        this.updateReprParams(update, c);
                    }
                }
                return [2 /*return*/, this.plugin.dataTransaction(function () { return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"])(_this, void 0, void 0, function () {
                        return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__generator"])(this, function (_a) {
                            switch (_a.label) {
                                case 0: return [4 /*yield*/, update.commit()];
                                case 1:
                                    _a.sent();
                                    return [4 /*yield*/, this.plugin.state.updateBehavior(_mol_plugin_behavior_dynamic_selection_structure_focus_representation__WEBPACK_IMPORTED_MODULE_19__["StructureFocusRepresentation"], function (p) {
                                            p.ignoreHydrogens = !options.showHydrogens;
                                        })];
                                case 2:
                                    _a.sent();
                                    if (!interactionChanged) return [3 /*break*/, 4];
                                    return [4 /*yield*/, this.updateInterationProps()];
                                case 3:
                                    _a.sent();
                                    _a.label = 4;
                                case 4: return [2 /*return*/];
                            }
                        });
                    }); })];
            });
        });
    };
    StructureComponentManager.prototype.updateReprParams = function (update, component) {
        var _a = this.state.options, showHydrogens = _a.showHydrogens, quality = _a.visualQuality;
        var ignoreHydrogens = !showHydrogens;
        for (var _i = 0, _b = component.representations; _i < _b.length; _i++) {
            var r = _b[_i];
            if (r.cell.transform.transformer !== _transforms_representation__WEBPACK_IMPORTED_MODULE_15__["StructureRepresentation3D"])
                continue;
            var params = r.cell.transform.params;
            if (!!params.type.params.ignoreHydrogens !== ignoreHydrogens || params.type.params.quality !== quality) {
                update.to(r.cell).update(function (old) {
                    old.type.params.ignoreHydrogens = ignoreHydrogens;
                    old.type.params.quality = quality;
                });
            }
        }
    };
    StructureComponentManager.prototype.updateInterationProps = function () {
        var _a, _b, _c;
        return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"])(this, void 0, void 0, function () {
            var _i, _d, s, interactionParams, oldParams, pd, params;
            var _this = this;
            return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__generator"])(this, function (_e) {
                switch (_e.label) {
                    case 0:
                        _i = 0, _d = this.currentStructures;
                        _e.label = 1;
                    case 1:
                        if (!(_i < _d.length)) return [3 /*break*/, 6];
                        s = _d[_i];
                        interactionParams = _mol_model_props_computed_interactions__WEBPACK_IMPORTED_MODULE_2__["InteractionsProvider"].getParams((_a = s.cell.obj) === null || _a === void 0 ? void 0 : _a.data);
                        if (!s.properties) return [3 /*break*/, 3];
                        oldParams = (_b = s.properties.cell.transform.params) === null || _b === void 0 ? void 0 : _b.properties[_mol_model_props_computed_interactions__WEBPACK_IMPORTED_MODULE_2__["InteractionsProvider"].descriptor.name];
                        if (_mol_util_param_definition__WEBPACK_IMPORTED_MODULE_10__["ParamDefinition"].areEqual(interactionParams, oldParams, this.state.options.interactions))
                            return [3 /*break*/, 5];
                        return [4 /*yield*/, this.dataState.build().to(s.properties.cell)
                                .update(function (old) {
                                old.properties[_mol_model_props_computed_interactions__WEBPACK_IMPORTED_MODULE_2__["InteractionsProvider"].descriptor.name] = _this.state.options.interactions;
                            })
                                .commit()];
                    case 2:
                        _e.sent();
                        return [3 /*break*/, 5];
                    case 3:
                        pd = this.plugin.customStructureProperties.getParams((_c = s.cell.obj) === null || _c === void 0 ? void 0 : _c.data);
                        params = _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_10__["ParamDefinition"].getDefaultValues(pd);
                        if (_mol_util_param_definition__WEBPACK_IMPORTED_MODULE_10__["ParamDefinition"].areEqual(interactionParams, params.properties[_mol_model_props_computed_interactions__WEBPACK_IMPORTED_MODULE_2__["InteractionsProvider"].descriptor.name], this.state.options.interactions))
                            return [3 /*break*/, 5];
                        params.properties[_mol_model_props_computed_interactions__WEBPACK_IMPORTED_MODULE_2__["InteractionsProvider"].descriptor.name] = this.state.options.interactions;
                        return [4 /*yield*/, this.plugin.builders.structure.insertStructureProperties(s.cell, params)];
                    case 4:
                        _e.sent();
                        _e.label = 5;
                    case 5:
                        _i++;
                        return [3 /*break*/, 1];
                    case 6: return [2 /*return*/];
                }
            });
        });
    };
    StructureComponentManager.prototype.applyPreset = function (structures, provider, params) {
        var _this = this;
        return this.plugin.dataTransaction(function () { return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"])(_this, void 0, void 0, function () {
            var _i, structures_1, s, preset;
            return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__generator"])(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _i = 0, structures_1 = structures;
                        _a.label = 1;
                    case 1:
                        if (!(_i < structures_1.length)) return [3 /*break*/, 5];
                        s = structures_1[_i];
                        return [4 /*yield*/, this.plugin.builders.structure.representation.applyPreset(s.cell, provider, params)];
                    case 2:
                        preset = _a.sent();
                        return [4 /*yield*/, this.syncPreset(s, preset)];
                    case 3:
                        _a.sent();
                        _a.label = 4;
                    case 4:
                        _i++;
                        return [3 /*break*/, 1];
                    case 5: return [2 /*return*/];
                }
            });
        }); }, { canUndo: 'Preset' });
    };
    StructureComponentManager.prototype.syncPreset = function (root, preset) {
        if (!preset || !preset.components)
            return this.clearComponents([root]);
        var keptRefs = new Set();
        Object(_mol_util_object__WEBPACK_IMPORTED_MODULE_9__["objectForEach"])(preset.components, function (c) {
            if (c)
                keptRefs.add(c.ref);
        });
        if (preset.representations) {
            Object(_mol_util_object__WEBPACK_IMPORTED_MODULE_9__["objectForEach"])(preset.representations, function (r) {
                if (r)
                    keptRefs.add(r.ref);
            });
        }
        if (keptRefs.size === 0)
            return this.clearComponents([root]);
        var changed = false;
        var update = this.dataState.build();
        var sync = function (r) {
            if (!keptRefs.has(r.cell.transform.ref)) {
                changed = true;
                update.delete(r.cell);
            }
        };
        for (var _i = 0, _a = root.components; _i < _a.length; _i++) {
            var c = _a[_i];
            sync(c);
            for (var _b = 0, _c = c.representations; _b < _c.length; _b++) {
                var r = _c[_b];
                sync(r);
            }
            if (c.genericRepresentations) {
                for (var _d = 0, _e = c.genericRepresentations; _d < _e.length; _d++) {
                    var r = _e[_d];
                    sync(r);
                }
            }
        }
        if (root.genericRepresentations) {
            for (var _f = 0, _g = root.genericRepresentations; _f < _g.length; _f++) {
                var r = _g[_f];
                sync(r);
            }
        }
        if (changed)
            return update.commit();
    };
    StructureComponentManager.prototype.clear = function (structures) {
        return this.clearComponents(structures);
    };
    StructureComponentManager.prototype.selectThis = function (components) {
        var _a;
        var mng = this.plugin.managers.structure.selection;
        mng.clear();
        for (var _i = 0, components_1 = components; _i < components_1.length; _i++) {
            var c = components_1[_i];
            var loci = _mol_model_structure__WEBPACK_IMPORTED_MODULE_3__["Structure"].toSubStructureElementLoci(c.structure.cell.obj.data, (_a = c.cell.obj) === null || _a === void 0 ? void 0 : _a.data);
            mng.fromLoci('set', loci);
        }
    };
    StructureComponentManager.prototype.canBeModified = function (ref) {
        return this.plugin.builders.structure.isComponentTransform(ref.cell);
    };
    StructureComponentManager.prototype.modifyByCurrentSelection = function (components, action) {
        var _this = this;
        return this.plugin.runTask(_mol_task__WEBPACK_IMPORTED_MODULE_6__["Task"].create('Modify Component', function (taskCtx) { return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"])(_this, void 0, void 0, function () {
            var b, _i, components_2, c, selection;
            return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__generator"])(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        b = this.dataState.build();
                        for (_i = 0, components_2 = components; _i < components_2.length; _i++) {
                            c = components_2[_i];
                            if (!this.canBeModified(c))
                                continue;
                            selection = this.plugin.managers.structure.selection.getStructure(c.structure.cell.obj.data);
                            if (!selection || selection.elementCount === 0)
                                continue;
                            this.modifyComponent(b, c, selection, action);
                        }
                        return [4 /*yield*/, this.dataState.updateTree(b, { canUndo: 'Modify Selection' }).runInContext(taskCtx)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        }); }));
    };
    StructureComponentManager.prototype.toggleVisibility = function (components, reprPivot) {
        if (components.length === 0)
            return;
        if (!reprPivot) {
            var isHidden = !components[0].cell.state.isHidden;
            for (var _i = 0, components_3 = components; _i < components_3.length; _i++) {
                var c = components_3[_i];
                Object(_mol_plugin_behavior_static_state__WEBPACK_IMPORTED_MODULE_5__["setSubtreeVisibility"])(this.dataState, c.cell.transform.ref, isHidden);
            }
        }
        else {
            var index = components[0].representations.indexOf(reprPivot);
            var isHidden = !reprPivot.cell.state.isHidden;
            for (var _a = 0, components_4 = components; _a < components_4.length; _a++) {
                var c = components_4[_a];
                // TODO: is it ok to use just the index here? Could possible lead to ugly edge cases, but perhaps not worth the trouble to "fix".
                var repr = c.representations[index];
                if (!repr)
                    continue;
                Object(_mol_plugin_behavior_static_state__WEBPACK_IMPORTED_MODULE_5__["setSubtreeVisibility"])(this.dataState, repr.cell.transform.ref, isHidden);
            }
        }
    };
    StructureComponentManager.prototype.removeRepresentations = function (components, pivot) {
        if (components.length === 0)
            return;
        var toRemove = [];
        if (pivot) {
            var index = components[0].representations.indexOf(pivot);
            if (index < 0)
                return;
            for (var _i = 0, components_5 = components; _i < components_5.length; _i++) {
                var c = components_5[_i];
                if (c.representations[index])
                    toRemove.push(c.representations[index]);
            }
        }
        else {
            for (var _a = 0, components_6 = components; _a < components_6.length; _a++) {
                var c = components_6[_a];
                for (var _b = 0, _c = c.representations; _b < _c.length; _b++) {
                    var r = _c[_b];
                    toRemove.push(r);
                }
            }
        }
        return this.plugin.managers.structure.hierarchy.remove(toRemove, true);
    };
    StructureComponentManager.prototype.updateRepresentations = function (components, pivot, params) {
        if (components.length === 0)
            return Promise.resolve();
        var index = components[0].representations.indexOf(pivot);
        if (index < 0)
            return Promise.resolve();
        var update = this.dataState.build();
        for (var _i = 0, components_7 = components; _i < components_7.length; _i++) {
            var c = components_7[_i];
            // TODO: is it ok to use just the index here? Could possible lead to ugly edge cases, but perhaps not worth the trouble to "fix".
            var repr = c.representations[index];
            if (!repr)
                continue;
            if (repr.cell.transform.transformer !== pivot.cell.transform.transformer)
                continue;
            update.to(repr.cell).update(params);
        }
        return update.commit({ canUndo: 'Update Representation' });
    };
    StructureComponentManager.prototype.updateRepresentationsTheme = function (components, paramsOrProvider) {
        var _a, _b, _c, _d;
        if (components.length === 0)
            return;
        var update = this.dataState.build();
        for (var _i = 0, components_8 = components; _i < components_8.length; _i++) {
            var c = components_8[_i];
            var _loop_1 = function (repr) {
                var old = repr.cell.transform.params;
                var params = typeof paramsOrProvider === 'function' ? paramsOrProvider(c, repr) : paramsOrProvider;
                var colorTheme = params.color === 'default'
                    ? Object(_helpers_structure_representation_params__WEBPACK_IMPORTED_MODULE_13__["createStructureColorThemeParams"])(this_1.plugin, (_a = c.structure.cell.obj) === null || _a === void 0 ? void 0 : _a.data, old === null || old === void 0 ? void 0 : old.type.name)
                    : params.color
                        ? Object(_helpers_structure_representation_params__WEBPACK_IMPORTED_MODULE_13__["createStructureColorThemeParams"])(this_1.plugin, (_b = c.structure.cell.obj) === null || _b === void 0 ? void 0 : _b.data, old === null || old === void 0 ? void 0 : old.type.name, params.color, params.colorParams)
                        : void 0;
                var sizeTheme = params.size === 'default'
                    ? Object(_helpers_structure_representation_params__WEBPACK_IMPORTED_MODULE_13__["createStructureSizeThemeParams"])(this_1.plugin, (_c = c.structure.cell.obj) === null || _c === void 0 ? void 0 : _c.data, old === null || old === void 0 ? void 0 : old.type.name)
                    : params.color
                        ? Object(_helpers_structure_representation_params__WEBPACK_IMPORTED_MODULE_13__["createStructureSizeThemeParams"])(this_1.plugin, (_d = c.structure.cell.obj) === null || _d === void 0 ? void 0 : _d.data, old === null || old === void 0 ? void 0 : old.type.name, params.size, params.sizeParams)
                        : void 0;
                if (colorTheme || sizeTheme) {
                    update.to(repr.cell).update(function (prev) {
                        if (colorTheme)
                            prev.colorTheme = colorTheme;
                        if (sizeTheme)
                            prev.sizeTheme = sizeTheme;
                    });
                }
            };
            var this_1 = this;
            for (var _e = 0, _f = c.representations; _e < _f.length; _e++) {
                var repr = _f[_e];
                _loop_1(repr);
            }
        }
        return update.commit({ canUndo: 'Update Theme' });
    };
    StructureComponentManager.prototype.addRepresentation = function (components, type) {
        var _this = this;
        if (components.length === 0)
            return;
        var _a = this.state.options, showHydrogens = _a.showHydrogens, quality = _a.visualQuality;
        var ignoreHydrogens = !showHydrogens;
        var typeParams = { ignoreHydrogens: ignoreHydrogens, quality: quality };
        return this.plugin.dataTransaction(function () { return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"])(_this, void 0, void 0, function () {
            var _i, components_9, component;
            return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__generator"])(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _i = 0, components_9 = components;
                        _a.label = 1;
                    case 1:
                        if (!(_i < components_9.length)) return [3 /*break*/, 4];
                        component = components_9[_i];
                        return [4 /*yield*/, this.plugin.builders.structure.representation.addRepresentation(component.cell, {
                                type: this.plugin.representation.structure.registry.get(type),
                                typeParams: typeParams
                            })];
                    case 2:
                        _a.sent();
                        _a.label = 3;
                    case 3:
                        _i++;
                        return [3 /*break*/, 1];
                    case 4: return [2 /*return*/];
                }
            });
        }); }, { canUndo: 'Add Representation' });
    };
    StructureComponentManager.prototype.tryFindComponent = function (structure, selection) {
        var _this = this;
        if (structure.components.length === 0)
            return;
        return this.plugin.runTask(_mol_task__WEBPACK_IMPORTED_MODULE_6__["Task"].create('Find Component', function (taskCtx) { return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"])(_this, void 0, void 0, function () {
            var data, sel, _a, _b, _i, _c, c, comp;
            var _d, _e;
            return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__generator"])(this, function (_f) {
                switch (_f.label) {
                    case 0:
                        data = (_d = structure.cell.obj) === null || _d === void 0 ? void 0 : _d.data;
                        if (!data)
                            return [2 /*return*/];
                        _b = (_a = _mol_model_structure__WEBPACK_IMPORTED_MODULE_3__["StructureSelection"]).unionStructure;
                        return [4 /*yield*/, selection.getSelection(this.plugin, taskCtx, data)];
                    case 1:
                        sel = _b.apply(_a, [_f.sent()]);
                        for (_i = 0, _c = structure.components; _i < _c.length; _i++) {
                            c = _c[_i];
                            comp = (_e = c.cell.obj) === null || _e === void 0 ? void 0 : _e.data;
                            if (!comp || !c.cell.parent)
                                continue;
                            if (Object(_mol_model_structure_query_utils_structure_set__WEBPACK_IMPORTED_MODULE_4__["structureAreEqual"])(sel, comp))
                                return [2 /*return*/, c.cell];
                        }
                        return [2 /*return*/];
                }
            });
        }); }));
    };
    StructureComponentManager.prototype.add = function (params, structures) {
        return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"])(this, void 0, void 0, function () {
            var _this = this;
            return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__generator"])(this, function (_a) {
                return [2 /*return*/, this.plugin.dataTransaction(function () { return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"])(_this, void 0, void 0, function () {
                        var xs, _a, showHydrogens, quality, ignoreHydrogens, typeParams, componentKey, _i, xs_1, s, component;
                        return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__generator"])(this, function (_b) {
                            switch (_b.label) {
                                case 0:
                                    xs = structures || this.currentStructures;
                                    if (xs.length === 0)
                                        return [2 /*return*/];
                                    _a = this.state.options, showHydrogens = _a.showHydrogens, quality = _a.visualQuality;
                                    ignoreHydrogens = !showHydrogens;
                                    typeParams = { ignoreHydrogens: ignoreHydrogens, quality: quality };
                                    componentKey = _mol_util__WEBPACK_IMPORTED_MODULE_7__["UUID"].create22();
                                    _i = 0, xs_1 = xs;
                                    _b.label = 1;
                                case 1:
                                    if (!(_i < xs_1.length)) return [3 /*break*/, 8];
                                    s = xs_1[_i];
                                    component = void 0;
                                    if (!params.options.checkExisting) return [3 /*break*/, 3];
                                    return [4 /*yield*/, this.tryFindComponent(s, params.selection)];
                                case 2:
                                    component = _b.sent();
                                    _b.label = 3;
                                case 3:
                                    if (!!component) return [3 /*break*/, 5];
                                    return [4 /*yield*/, this.plugin.builders.structure.tryCreateComponentFromSelection(s.cell, params.selection, componentKey, {
                                            label: params.options.label || (params.selection === _helpers_structure_selection_query__WEBPACK_IMPORTED_MODULE_14__["StructureSelectionQueries"].current ? 'Custom Selection' : ''),
                                        })];
                                case 4:
                                    component = _b.sent();
                                    _b.label = 5;
                                case 5:
                                    if (params.representation === 'none' || !component)
                                        return [3 /*break*/, 7];
                                    return [4 /*yield*/, this.plugin.builders.structure.representation.addRepresentation(component, {
                                            type: this.plugin.representation.structure.registry.get(params.representation),
                                            typeParams: typeParams
                                        })];
                                case 6:
                                    _b.sent();
                                    _b.label = 7;
                                case 7:
                                    _i++;
                                    return [3 /*break*/, 1];
                                case 8: return [2 /*return*/];
                            }
                        });
                    }); }, { canUndo: 'Add Selection' })];
            });
        });
    };
    StructureComponentManager.prototype.applyTheme = function (params, structures) {
        return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"])(this, void 0, void 0, function () {
            var _this = this;
            return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__generator"])(this, function (_a) {
                return [2 /*return*/, this.plugin.dataTransaction(function (ctx) { return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"])(_this, void 0, void 0, function () {
                        var xs, getLoci, _i, xs_2, s, p, p, p;
                        var _this = this;
                        return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__generator"])(this, function (_a) {
                            switch (_a.label) {
                                case 0:
                                    xs = structures || this.currentStructures;
                                    if (xs.length === 0)
                                        return [2 /*return*/];
                                    getLoci = function (s) { return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"])(_this, void 0, void 0, function () { var _a, _b; return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__generator"])(this, function (_c) {
                                        switch (_c.label) {
                                            case 0:
                                                _b = (_a = _mol_model_structure__WEBPACK_IMPORTED_MODULE_3__["StructureSelection"]).toLociWithSourceUnits;
                                                return [4 /*yield*/, params.selection.getSelection(this.plugin, ctx, s)];
                                            case 1: return [2 /*return*/, _b.apply(_a, [_c.sent()])];
                                        }
                                    }); }); };
                                    _i = 0, xs_2 = xs;
                                    _a.label = 1;
                                case 1:
                                    if (!(_i < xs_2.length)) return [3 /*break*/, 10];
                                    s = xs_2[_i];
                                    if (!(params.action.name === 'reset')) return [3 /*break*/, 3];
                                    return [4 /*yield*/, Object(_helpers_structure_overpaint__WEBPACK_IMPORTED_MODULE_12__["setStructureOverpaint"])(this.plugin, s.components, -1, getLoci, params.representations)];
                                case 2:
                                    _a.sent();
                                    return [3 /*break*/, 9];
                                case 3:
                                    if (!(params.action.name === 'color')) return [3 /*break*/, 5];
                                    p = params.action.params;
                                    return [4 /*yield*/, Object(_helpers_structure_overpaint__WEBPACK_IMPORTED_MODULE_12__["setStructureOverpaint"])(this.plugin, s.components, p.color, getLoci, params.representations)];
                                case 4:
                                    _a.sent();
                                    return [3 /*break*/, 9];
                                case 5:
                                    if (!(params.action.name === 'transparency')) return [3 /*break*/, 7];
                                    p = params.action.params;
                                    return [4 /*yield*/, Object(_helpers_structure_transparency__WEBPACK_IMPORTED_MODULE_18__["setStructureTransparency"])(this.plugin, s.components, p.value, getLoci, params.representations)];
                                case 6:
                                    _a.sent();
                                    return [3 /*break*/, 9];
                                case 7:
                                    if (!(params.action.name === 'clipping')) return [3 /*break*/, 9];
                                    p = params.action.params;
                                    return [4 /*yield*/, Object(_helpers_structure_clipping__WEBPACK_IMPORTED_MODULE_17__["setStructureClipping"])(this.plugin, s.components, _mol_theme_clipping__WEBPACK_IMPORTED_MODULE_16__["Clipping"].Groups.fromNames(p.excludeGroups), getLoci, params.representations)];
                                case 8:
                                    _a.sent();
                                    _a.label = 9;
                                case 9:
                                    _i++;
                                    return [3 /*break*/, 1];
                                case 10: return [2 /*return*/];
                            }
                        });
                    }); }, { canUndo: 'Apply Theme' })];
            });
        });
    };
    StructureComponentManager.prototype.modifyComponent = function (builder, component, by, action) {
        var _a, _b, _c;
        var structure = (_a = component.cell.obj) === null || _a === void 0 ? void 0 : _a.data;
        if (!structure)
            return;
        if ((action === 'subtract' || action === 'intersect') && !Object(_mol_model_structure_query_utils_structure_set__WEBPACK_IMPORTED_MODULE_4__["structureAreIntersecting"])(structure, by))
            return;
        var parent = (_b = component.structure.cell.obj) === null || _b === void 0 ? void 0 : _b.data;
        var modified = action === 'union'
            ? Object(_mol_model_structure_query_utils_structure_set__WEBPACK_IMPORTED_MODULE_4__["structureUnion"])(parent, [structure, by])
            : action === 'intersect'
                ? Object(_mol_model_structure_query_utils_structure_set__WEBPACK_IMPORTED_MODULE_4__["structureIntersect"])(structure, by)
                : Object(_mol_model_structure_query_utils_structure_set__WEBPACK_IMPORTED_MODULE_4__["structureSubtract"])(structure, by);
        if (modified.elementCount === 0) {
            builder.delete(component.cell.transform.ref);
        }
        else {
            var bundle = _mol_model_structure__WEBPACK_IMPORTED_MODULE_3__["StructureElement"].Bundle.fromSubStructure(parent, modified);
            var params = {
                type: { name: 'bundle', params: bundle },
                nullIfEmpty: true,
                label: (_c = component.cell.obj) === null || _c === void 0 ? void 0 : _c.label
            };
            builder.to(component.cell).update(params);
        }
    };
    StructureComponentManager.prototype.updateLabel = function (component, label) {
        var _a, _b;
        var params = {
            type: (_a = component.cell.params) === null || _a === void 0 ? void 0 : _a.values.type,
            nullIfEmpty: (_b = component.cell.params) === null || _b === void 0 ? void 0 : _b.values.nullIfEmpty,
            label: label
        };
        this.dataState.build().to(component.cell).update(params).commit();
    };
    Object.defineProperty(StructureComponentManager.prototype, "dataState", {
        get: function () {
            return this.plugin.state.data;
        },
        enumerable: false,
        configurable: true
    });
    StructureComponentManager.prototype.clearComponents = function (structures) {
        var deletes = this.dataState.build();
        for (var _i = 0, structures_2 = structures; _i < structures_2.length; _i++) {
            var s = structures_2[_i];
            for (var _a = 0, _b = s.components; _a < _b.length; _a++) {
                var c = _b[_a];
                deletes.delete(c.cell.transform.ref);
            }
        }
        return deletes.commit({ canUndo: 'Clear Selections' });
    };
    return StructureComponentManager;
}(_component__WEBPACK_IMPORTED_MODULE_11__["StatefulPluginComponent"]));
(function (StructureComponentManager) {
    StructureComponentManager.OptionsParams = {
        showHydrogens: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_10__["ParamDefinition"].Boolean(true, { description: 'Toggle display of hydrogen atoms in representations' }),
        visualQuality: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_10__["ParamDefinition"].Select('auto', _mol_geo_geometry_base__WEBPACK_IMPORTED_MODULE_1__["VisualQualityOptions"], { description: 'Control the visual/rendering quality of representations' }),
        interactions: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_10__["ParamDefinition"].Group(_mol_model_props_computed_interactions__WEBPACK_IMPORTED_MODULE_2__["InteractionsProvider"].defaultParams, { label: 'Non-covalent Interactions' }),
    };
    function getAddParams(plugin, params) {
        var options = plugin.query.structure.registry.options;
        params = Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({ pivot: plugin.managers.structure.component.pivotStructure, allowNone: true, hideSelection: false, checkExisting: false }, params);
        return {
            selection: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_10__["ParamDefinition"].Select(options[1][0], options, { isHidden: params === null || params === void 0 ? void 0 : params.hideSelection }),
            representation: getRepresentationTypesSelect(plugin, params === null || params === void 0 ? void 0 : params.pivot, (params === null || params === void 0 ? void 0 : params.allowNone) ? [['none', '< Create Later >']] : []),
            options: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_10__["ParamDefinition"].Group({
                label: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_10__["ParamDefinition"].Text(''),
                checkExisting: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_10__["ParamDefinition"].Boolean(!!(params === null || params === void 0 ? void 0 : params.checkExisting), { help: function () { return ({ description: 'Checks if a selection with the specifield elements already exists to avoid creating duplicate components.' }); } }),
            })
        };
    }
    StructureComponentManager.getAddParams = getAddParams;
    function getThemeParams(plugin, pivot) {
        var options = plugin.query.structure.registry.options;
        return {
            selection: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_10__["ParamDefinition"].Select(options[1][0], options, { isHidden: false }),
            action: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_10__["ParamDefinition"].MappedStatic('color', {
                color: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_10__["ParamDefinition"].Group({
                    color: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_10__["ParamDefinition"].Color(_mol_util_color_names__WEBPACK_IMPORTED_MODULE_8__["ColorNames"].blue, { isExpanded: true }),
                }, { isFlat: true }),
                reset: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_10__["ParamDefinition"].EmptyGroup({ label: 'Reset Color' }),
                transparency: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_10__["ParamDefinition"].Group({
                    value: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_10__["ParamDefinition"].Numeric(0.5, { min: 0, max: 1, step: 0.01 }),
                }, { isFlat: true }),
                clipping: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_10__["ParamDefinition"].Group({
                    excludeGroups: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_10__["ParamDefinition"].MultiSelect([], _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_10__["ParamDefinition"].objectToOptions(_mol_theme_clipping__WEBPACK_IMPORTED_MODULE_16__["Clipping"].Groups.Names)),
                }, { isFlat: true }),
            }),
            representations: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_10__["ParamDefinition"].MultiSelect([], getRepresentationTypes(plugin, pivot), { emptyValue: 'All' })
        };
    }
    StructureComponentManager.getThemeParams = getThemeParams;
    function getRepresentationTypes(plugin, pivot) {
        var _a, _b;
        return ((_a = pivot === null || pivot === void 0 ? void 0 : pivot.cell.obj) === null || _a === void 0 ? void 0 : _a.data) ? plugin.representation.structure.registry.getApplicableTypes((_b = pivot.cell.obj) === null || _b === void 0 ? void 0 : _b.data)
            : plugin.representation.structure.registry.types;
    }
    StructureComponentManager.getRepresentationTypes = getRepresentationTypes;
    function getRepresentationTypesSelect(plugin, pivot, custom, label) {
        var types = Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__spreadArrays"])(custom, getRepresentationTypes(plugin, pivot));
        return _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_10__["ParamDefinition"].Select(types[0][0], types, { label: label });
    }
})(StructureComponentManager || (StructureComponentManager = {}));
//# sourceMappingURL=component.js.map

/***/ }),

/***/ "./lib/mol-plugin-state/manager/structure/focus.js":
/*!*********************************************************!*\
  !*** ./lib/mol-plugin-state/manager/structure/focus.js ***!
  \*********************************************************/
/*! exports provided: StructureFocusManager */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "StructureFocusManager", function() { return StructureFocusManager; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _component__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../component */ "./lib/mol-plugin-state/component.js");
/* harmony import */ var _mol_util_array__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../../mol-util/array */ "./lib/mol-util/array.js");
/* harmony import */ var _mol_model_structure__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../../mol-model/structure */ "./lib/mol-model/structure.js");
/* harmony import */ var _mol_model_loci__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../../mol-model/loci */ "./lib/mol-model/loci.js");
/* harmony import */ var _mol_theme_label__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../../mol-theme/label */ "./lib/mol-theme/label.js");
/* harmony import */ var _objects__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../../objects */ "./lib/mol-plugin-state/objects.js");
/* harmony import */ var _mol_state__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../../../mol-state */ "./lib/mol-state/index.js");
/* harmony import */ var _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ../../../mol-math/linear-algebra */ "./lib/mol-math/linear-algebra.js");
/* harmony import */ var _mol_math_geometry__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ../../../mol-math/geometry */ "./lib/mol-math/geometry.js");
/**
 * Copyright (c) 2020 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 * @author David Sehnal <david.sehnal@gmail.com>
 */










var HISTORY_CAPACITY = 8;
var StructureFocusManager = /** @class */ (function (_super) {
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__extends"])(StructureFocusManager, _super);
    function StructureFocusManager(plugin) {
        var _this = _super.call(this, { history: [] }) || this;
        _this.plugin = plugin;
        _this.events = {
            historyUpdated: _this.ev()
        };
        _this.behaviors = {
            current: _this.ev.behavior(void 0)
        };
        plugin.state.data.events.object.removed.subscribe(function (_a) {
            var _b;
            var _c;
            var obj = _a.obj;
            if (!_objects__WEBPACK_IMPORTED_MODULE_6__["PluginStateObject"].Molecule.Structure.is(obj))
                return;
            if (((_c = _this.current) === null || _c === void 0 ? void 0 : _c.loci.structure) === obj.data) {
                _this.clear();
            }
            var keep = [];
            for (var _i = 0, _d = _this.history; _i < _d.length; _i++) {
                var e = _d[_i];
                if (e.loci.structure === obj.data)
                    keep.push(e);
            }
            if (keep.length !== _this.history.length) {
                _this.history.length = 0;
                (_b = _this.history).push.apply(_b, keep);
                _this.events.historyUpdated.next();
            }
        });
        var sphere = Object(_mol_math_geometry__WEBPACK_IMPORTED_MODULE_9__["Sphere3D"])();
        plugin.state.data.events.object.updated.subscribe(function (_a) {
            var _b;
            var oldData = _a.oldData, obj = _a.obj, action = _a.action;
            if (!_objects__WEBPACK_IMPORTED_MODULE_6__["PluginStateObject"].Molecule.Structure.is(obj))
                return;
            if (action === 'in-place') {
                var current = _this.state.current;
                var structure = obj.data;
                if (current && current.loci.structure === oldData) {
                    var loci = _mol_model_structure__WEBPACK_IMPORTED_MODULE_3__["StructureElement"].Loci.remap(current.loci, structure);
                    _this.state.current = Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, current), { loci: loci });
                    _this.behaviors.current.next(_this.state.current);
                    _mol_model_loci__WEBPACK_IMPORTED_MODULE_4__["Loci"].getBoundingSphere(loci, sphere);
                    var camera = (_b = _this.plugin.canvas3d) === null || _b === void 0 ? void 0 : _b.camera;
                    var d = camera.getTargetDistance(sphere.radius + 4); // default extraRadius
                    if (_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_8__["Vec3"].distance(camera.target, sphere.center) > sphere.radius ||
                        d > camera.viewport.height / camera.zoom) {
                        _this.plugin.managers.camera.focusSphere(sphere, { durationMs: 0 });
                    }
                }
                // TODO remap history as well
            }
        });
        return _this;
    }
    Object.defineProperty(StructureFocusManager.prototype, "current", {
        get: function () { return this.state.current; },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(StructureFocusManager.prototype, "history", {
        get: function () { return this.state.history; },
        enumerable: false,
        configurable: true
    });
    StructureFocusManager.prototype.tryAddHistory = function (entry) {
        if (_mol_model_structure__WEBPACK_IMPORTED_MODULE_3__["StructureElement"].Loci.isEmpty(entry.loci))
            return;
        var idx = 0, existingEntry = void 0;
        for (var _i = 0, _a = this.state.history; _i < _a.length; _i++) {
            var e = _a[_i];
            if (_mol_model_structure__WEBPACK_IMPORTED_MODULE_3__["StructureElement"].Loci.areEqual(e.loci, entry.loci)) {
                existingEntry = e;
                break;
            }
            idx++;
        }
        if (existingEntry) {
            // move to top, use new
            Object(_mol_util_array__WEBPACK_IMPORTED_MODULE_2__["arrayRemoveAtInPlace"])(this.state.history, idx);
            this.state.history.unshift(entry);
            this.events.historyUpdated.next();
            return;
        }
        this.state.history.unshift(entry);
        if (this.state.history.length > HISTORY_CAPACITY)
            this.state.history.pop();
        this.events.historyUpdated.next();
    };
    StructureFocusManager.prototype.set = function (entry) {
        this.tryAddHistory(entry);
        if (!this.state.current || !_mol_model_structure__WEBPACK_IMPORTED_MODULE_3__["StructureElement"].Loci.areEqual(this.state.current.loci, entry.loci)) {
            this.state.current = entry;
            this.behaviors.current.next(entry);
        }
    };
    StructureFocusManager.prototype.setFromLoci = function (anyLoci) {
        var loci = _mol_model_loci__WEBPACK_IMPORTED_MODULE_4__["Loci"].normalize(anyLoci);
        if (!_mol_model_structure__WEBPACK_IMPORTED_MODULE_3__["StructureElement"].Loci.is(loci) || _mol_model_structure__WEBPACK_IMPORTED_MODULE_3__["StructureElement"].Loci.isEmpty(loci)) {
            this.clear();
            return;
        }
        this.set({ loci: loci, label: Object(_mol_theme_label__WEBPACK_IMPORTED_MODULE_5__["lociLabel"])(loci, { reverse: true, hidePrefix: true, htmlStyling: false }) });
    };
    StructureFocusManager.prototype.addFromLoci = function (anyLoci) {
        var union = this.state.current && _mol_model_structure__WEBPACK_IMPORTED_MODULE_3__["StructureElement"].Loci.is(anyLoci) && anyLoci.structure === this.state.current.loci.structure
            ? _mol_model_structure__WEBPACK_IMPORTED_MODULE_3__["StructureElement"].Loci.union(anyLoci, this.state.current.loci)
            : anyLoci;
        this.setFromLoci(union);
    };
    StructureFocusManager.prototype.clear = function () {
        if (this.state.current) {
            this.state.current = undefined;
            this.behaviors.current.next(void 0);
        }
    };
    StructureFocusManager.prototype.getSnapshot = function () {
        if (!this.current)
            return {};
        var node = this.plugin.helpers.substructureParent.get(this.current.loci.structure);
        var ref = node === null || node === void 0 ? void 0 : node.transform.ref;
        if (!ref)
            return {};
        return {
            current: {
                label: this.current.label,
                ref: ref,
                bundle: _mol_model_structure__WEBPACK_IMPORTED_MODULE_3__["StructureElement"].Bundle.fromLoci(this.current.loci),
                category: this.current.category
            }
        };
    };
    StructureFocusManager.prototype.setSnapshot = function (snapshot) {
        var _a, _b;
        if (!snapshot.current) {
            this.clear();
            return;
        }
        var _c = snapshot.current, label = _c.label, ref = _c.ref, bundle = _c.bundle, category = _c.category;
        var structure = (_b = (_a = this.plugin.state.data.select(_mol_state__WEBPACK_IMPORTED_MODULE_7__["StateSelection"].Generators.byRef(ref))[0]) === null || _a === void 0 ? void 0 : _a.obj) === null || _b === void 0 ? void 0 : _b.data;
        if (!structure)
            return;
        var loci = _mol_model_structure__WEBPACK_IMPORTED_MODULE_3__["StructureElement"].Bundle.toLoci(bundle, structure);
        this.set({ label: label, loci: loci, category: category });
    };
    return StructureFocusManager;
}(_component__WEBPACK_IMPORTED_MODULE_1__["StatefulPluginComponent"]));

//# sourceMappingURL=focus.js.map

/***/ }),

/***/ "./lib/mol-plugin-state/manager/structure/hierarchy-state.js":
/*!*******************************************************************!*\
  !*** ./lib/mol-plugin-state/manager/structure/hierarchy-state.js ***!
  \*******************************************************************/
/*! exports provided: buildStructureHierarchy, StructureHierarchy */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "buildStructureHierarchy", function() { return buildStructureHierarchy; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "StructureHierarchy", function() { return StructureHierarchy; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _objects__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../objects */ "./lib/mol-plugin-state/objects.js");
/* harmony import */ var _mol_state__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../../mol-state */ "./lib/mol-state/index.js");
/* harmony import */ var _transforms__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../transforms */ "./lib/mol-plugin-state/transforms.js");
/* harmony import */ var _mol_plugin_behavior_dynamic_volume_streaming_behavior__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../../mol-plugin/behavior/dynamic/volume-streaming/behavior */ "./lib/mol-plugin/behavior/dynamic/volume-streaming/behavior.js");
/**
 * Copyright (c) 2020 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author David Sehnal <david.sehnal@gmail.com>
 */





function buildStructureHierarchy(state, previous) {
    var build = BuildState(state, previous || StructureHierarchy());
    doPreOrder(state.tree, build);
    if (previous)
        previous.refs.forEach(isRemoved, build);
    return { hierarchy: build.hierarchy, added: build.added, changed: build.changed };
}
function StructureHierarchy() {
    return { trajectories: [], models: [], structures: [], refs: new Map() };
}
function TrajectoryRef(cell) {
    return { kind: 'trajectory', cell: cell, version: cell.transform.version, models: [] };
}
function ModelRef(cell, trajectory) {
    return { kind: 'model', cell: cell, version: cell.transform.version, trajectory: trajectory, structures: [] };
}
function ModelPropertiesRef(cell, model) {
    return { kind: 'model-properties', cell: cell, version: cell.transform.version, model: model };
}
function ModelUnitcellRef(cell, model) {
    return { kind: 'model-unitcell', cell: cell, version: cell.transform.version, model: model };
}
function StructureRef(cell, model) {
    return { kind: 'structure', cell: cell, version: cell.transform.version, model: model, components: [] };
}
function StructurePropertiesRef(cell, structure) {
    return { kind: 'structure-properties', cell: cell, version: cell.transform.version, structure: structure };
}
function StructureTransformRef(cell, structure) {
    return { kind: 'structure-transform', cell: cell, version: cell.transform.version, structure: structure };
}
function StructureVolumeStreamingRef(cell, structure) {
    return { kind: 'structure-volume-streaming', cell: cell, version: cell.transform.version, structure: structure };
}
function componentKey(cell) {
    if (!cell.transform.tags)
        return cell.transform.ref;
    return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__spreadArrays"])(cell.transform.tags).sort().join();
}
function StructureComponentRef(cell, structure) {
    return { kind: 'structure-component', cell: cell, version: cell.transform.version, structure: structure, key: componentKey(cell), representations: [] };
}
function StructureRepresentationRef(cell, component) {
    return { kind: 'structure-representation', cell: cell, version: cell.transform.version, component: component };
}
function GenericRepresentationRef(cell, parent) {
    return { kind: 'generic-representation', cell: cell, version: cell.transform.version, parent: parent };
}
function BuildState(state, oldHierarchy) {
    return { state: state, oldHierarchy: oldHierarchy, hierarchy: StructureHierarchy(), changed: false, added: new Set() };
}
function createOrUpdateRefList(state, cell, list, ctor) {
    var args = [];
    for (var _i = 4; _i < arguments.length; _i++) {
        args[_i - 4] = arguments[_i];
    }
    var ref = ctor.apply(void 0, args);
    list.push(ref);
    state.hierarchy.refs.set(cell.transform.ref, ref);
    var old = state.oldHierarchy.refs.get(cell.transform.ref);
    if (old) {
        if (old.version !== cell.transform.version)
            state.changed = true;
    }
    else {
        state.added.add(ref.cell.transform.ref);
        state.changed = true;
    }
    return ref;
}
function createOrUpdateRef(state, cell, ctor) {
    var args = [];
    for (var _i = 3; _i < arguments.length; _i++) {
        args[_i - 3] = arguments[_i];
    }
    var ref = ctor.apply(void 0, args);
    state.hierarchy.refs.set(cell.transform.ref, ref);
    var old = state.oldHierarchy.refs.get(cell.transform.ref);
    if (old) {
        if (old.version !== cell.transform.version)
            state.changed = true;
    }
    else {
        state.added.add(ref.cell.transform.ref);
        state.changed = true;
    }
    return ref;
}
function isType(t) {
    return function (cell) { return t.is(cell.obj); };
}
function isTypeRoot(t, target) {
    return function (cell, state) { return !target(state) && t.is(cell.obj); };
}
function isTransformer(t) {
    return function (cell) { return cell.transform.transformer === t; };
}
function noop() { }
var Mapping = [
    // Trajectory
    [isType(_objects__WEBPACK_IMPORTED_MODULE_1__["PluginStateObject"].Molecule.Trajectory), function (state, cell) {
            state.currentTrajectory = createOrUpdateRefList(state, cell, state.hierarchy.trajectories, TrajectoryRef, cell);
        }, function (state) { return state.currentTrajectory = void 0; }],
    // Model
    [isTypeRoot(_objects__WEBPACK_IMPORTED_MODULE_1__["PluginStateObject"].Molecule.Model, function (s) { return s.currentModel; }), function (state, cell) {
            if (state.currentTrajectory) {
                state.currentModel = createOrUpdateRefList(state, cell, state.currentTrajectory.models, ModelRef, cell, state.currentTrajectory);
            }
            else {
                state.currentModel = createOrUpdateRef(state, cell, ModelRef, cell);
            }
            state.hierarchy.models.push(state.currentModel);
        }, function (state) { return state.currentModel = void 0; }],
    [isTransformer(_transforms__WEBPACK_IMPORTED_MODULE_3__["StateTransforms"].Model.CustomModelProperties), function (state, cell) {
            if (!state.currentModel)
                return false;
            state.currentModel.properties = createOrUpdateRef(state, cell, ModelPropertiesRef, cell, state.currentModel);
        }, noop],
    [isTransformer(_transforms__WEBPACK_IMPORTED_MODULE_3__["StateTransforms"].Representation.ModelUnitcell3D), function (state, cell) {
            if (!state.currentModel)
                return false;
            state.currentModel.unitcell = createOrUpdateRef(state, cell, ModelUnitcellRef, cell, state.currentModel);
        }, noop],
    // Structure
    [isTypeRoot(_objects__WEBPACK_IMPORTED_MODULE_1__["PluginStateObject"].Molecule.Structure, function (s) { return s.currentStructure; }), function (state, cell) {
            if (state.currentModel) {
                state.currentStructure = createOrUpdateRefList(state, cell, state.currentModel.structures, StructureRef, cell, state.currentModel);
            }
            else {
                state.currentStructure = createOrUpdateRef(state, cell, StructureRef, cell);
            }
            state.hierarchy.structures.push(state.currentStructure);
        }, function (state) { return state.currentStructure = void 0; }],
    [isTransformer(_transforms__WEBPACK_IMPORTED_MODULE_3__["StateTransforms"].Model.CustomStructureProperties), function (state, cell) {
            if (!state.currentStructure)
                return false;
            state.currentStructure.properties = createOrUpdateRef(state, cell, StructurePropertiesRef, cell, state.currentStructure);
        }, noop],
    [isTransformer(_transforms__WEBPACK_IMPORTED_MODULE_3__["StateTransforms"].Model.TransformStructureConformation), function (state, cell) {
            if (!state.currentStructure)
                return false;
            state.currentStructure.transform = createOrUpdateRef(state, cell, StructureTransformRef, cell, state.currentStructure);
        }, noop],
    // Volume Streaming
    [isType(_mol_plugin_behavior_dynamic_volume_streaming_behavior__WEBPACK_IMPORTED_MODULE_4__["VolumeStreaming"]), function (state, cell) {
            if (!state.currentStructure)
                return false;
            state.currentStructure.volumeStreaming = createOrUpdateRef(state, cell, StructureVolumeStreamingRef, cell, state.currentStructure);
            // Do not continue into VolumeStreaming subtree.
            return false;
        }, noop],
    // Component
    [function (cell, state) {
            if (state.currentComponent || !state.currentStructure || cell.transform.transformer.definition.isDecorator)
                return false;
            return _objects__WEBPACK_IMPORTED_MODULE_1__["PluginStateObject"].Molecule.Structure.is(cell.obj);
        }, function (state, cell) {
            if (state.currentStructure) {
                state.currentComponent = createOrUpdateRefList(state, cell, state.currentStructure.components, StructureComponentRef, cell, state.currentStructure);
            }
        }, function (state) { return state.currentComponent = void 0; }],
    // Component Representation
    [function (cell, state) {
            return !cell.state.isGhost && !!state.currentComponent && _objects__WEBPACK_IMPORTED_MODULE_1__["PluginStateObject"].Molecule.Structure.Representation3D.is(cell.obj);
        }, function (state, cell) {
            if (state.currentComponent) {
                createOrUpdateRefList(state, cell, state.currentComponent.representations, StructureRepresentationRef, cell, state.currentComponent);
            }
            // Nothing useful down the line
            return false;
        }, noop],
    // Generic Representation
    [function (cell) { return !cell.state.isGhost && _objects__WEBPACK_IMPORTED_MODULE_1__["PluginStateObject"].isRepresentation3D(cell.obj); }, function (state, cell) {
            var genericTarget = state.currentComponent || state.currentStructure || state.currentModel;
            if (genericTarget) {
                if (!genericTarget.genericRepresentations)
                    genericTarget.genericRepresentations = [];
                createOrUpdateRefList(state, cell, genericTarget.genericRepresentations, GenericRepresentationRef, cell, genericTarget);
            }
        }, noop],
];
function isValidCell(cell) {
    if (!cell || !(cell === null || cell === void 0 ? void 0 : cell.parent) || !cell.parent.cells.has(cell.transform.ref))
        return false;
    var obj = cell.obj;
    if (!obj || obj === _mol_state__WEBPACK_IMPORTED_MODULE_2__["StateObject"].Null || (cell.status !== 'ok' && cell.status !== 'error'))
        return false;
    return true;
}
function isRemoved(ref) {
    var cell = ref.cell;
    if (isValidCell(cell))
        return;
    this.changed = true;
}
function _preOrderFunc(c) { _doPreOrder(this, this.tree.transforms.get(c)); }
function _doPreOrder(ctx, root) {
    var state = ctx.state;
    var cell = state.state.cells.get(root.ref);
    if (!isValidCell(cell))
        return;
    var onLeave = void 0;
    var end = false;
    for (var _i = 0, Mapping_1 = Mapping; _i < Mapping_1.length; _i++) {
        var _a = Mapping_1[_i], test_1 = _a[0], f = _a[1], l = _a[2];
        if (test_1(cell, state)) {
            var cont = f(state, cell);
            if (cont === false) {
                end = true;
                break;
            }
            onLeave = l;
            break;
        }
    }
    // TODO: might be needed in the future
    // const { currentComponent, currentModel, currentStructure, currentTrajectory } = ctx.state;
    // const inTrackedSubtree = currentComponent || currentModel || currentStructure || currentTrajectory;
    // if (inTrackedSubtree && cell.transform.transformer.definition.isDecorator) {
    //     const ref = cell.transform.ref;
    //     const old = ctx.state.oldHierarchy.decorators.get(ref);
    //     if (old && old.version !== cell.transform.version) {
    //         ctx.state.changed = true;
    //     }
    //     ctx.state.hierarchy.decorators.set(cell.transform.ref, cell.transform);
    // }
    if (end)
        return;
    var children = ctx.tree.children.get(root.ref);
    if (children && children.size) {
        children.forEach(_preOrderFunc, ctx);
    }
    if (onLeave)
        onLeave(state);
}
function doPreOrder(tree, state) {
    var ctx = { tree: tree, state: state };
    _doPreOrder(ctx, tree.root);
    return ctx.state;
}
//# sourceMappingURL=hierarchy-state.js.map

/***/ }),

/***/ "./lib/mol-plugin-state/manager/structure/hierarchy.js":
/*!*************************************************************!*\
  !*** ./lib/mol-plugin-state/manager/structure/hierarchy.js ***!
  \*************************************************************/
/*! exports provided: StructureHierarchyManager */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "StructureHierarchyManager", function() { return StructureHierarchyManager; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _mol_plugin_behavior_static_state__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../../mol-plugin/behavior/static/state */ "./lib/mol-plugin/behavior/static/state.js");
/* harmony import */ var _mol_plugin_commands__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../../mol-plugin/commands */ "./lib/mol-plugin/commands.js");
/* harmony import */ var _mol_state__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../../mol-state */ "./lib/mol-state/index.js");
/* harmony import */ var _mol_util_set__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../../mol-util/set */ "./lib/mol-util/set.js");
/* harmony import */ var _component__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../component */ "./lib/mol-plugin-state/component.js");
/* harmony import */ var _hierarchy_state__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ./hierarchy-state */ "./lib/mol-plugin-state/manager/structure/hierarchy-state.js");
/**
 * Copyright (c) 2020 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author David Sehnal <david.sehnal@gmail.com>
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */







var StructureHierarchyManager = /** @class */ (function (_super) {
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__extends"])(StructureHierarchyManager, _super);
    function StructureHierarchyManager(plugin) {
        var _this = _super.call(this) || this;
        _this.plugin = plugin;
        _this.state = {
            syncedTree: _this.dataState.tree,
            notified: false,
            hierarchy: Object(_hierarchy_state__WEBPACK_IMPORTED_MODULE_6__["StructureHierarchy"])(),
            selection: {
                trajectories: [],
                models: [],
                structures: []
            }
        };
        _this.behaviors = {
            selection: _this.ev.behavior({
                hierarchy: _this.current,
                trajectories: _this.selection.trajectories,
                models: _this.selection.models,
                structures: _this.selection.structures
            })
        };
        _this._currentComponentGroups = void 0;
        _this._currentSelectionSet = void 0;
        _this.subscribe(plugin.state.data.events.changed, function (e) {
            if (e.inTransaction || plugin.behaviors.state.isAnimating.value)
                return;
            _this.sync(true);
        });
        _this.subscribe(plugin.behaviors.state.isAnimating, function (isAnimating) {
            if (!isAnimating && !plugin.behaviors.state.isUpdating.value)
                _this.sync(true);
        });
        return _this;
    }
    Object.defineProperty(StructureHierarchyManager.prototype, "dataState", {
        get: function () {
            return this.plugin.state.data;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(StructureHierarchyManager.prototype, "currentComponentGroups", {
        get: function () {
            if (this._currentComponentGroups)
                return this._currentComponentGroups;
            this._currentComponentGroups = StructureHierarchyManager.getComponentGroups(this.selection.structures);
            return this._currentComponentGroups;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(StructureHierarchyManager.prototype, "seletionSet", {
        get: function () {
            if (this._currentSelectionSet)
                return this._currentSelectionSet;
            this._currentSelectionSet = new Set();
            for (var _i = 0, _a = this.selection.trajectories; _i < _a.length; _i++) {
                var r = _a[_i];
                this._currentSelectionSet.add(r.cell.transform.ref);
            }
            for (var _b = 0, _c = this.selection.models; _b < _c.length; _b++) {
                var r = _c[_b];
                this._currentSelectionSet.add(r.cell.transform.ref);
            }
            for (var _d = 0, _e = this.selection.structures; _d < _e.length; _d++) {
                var r = _e[_d];
                this._currentSelectionSet.add(r.cell.transform.ref);
            }
            return this._currentSelectionSet;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(StructureHierarchyManager.prototype, "current", {
        get: function () {
            this.sync(false);
            return this.state.hierarchy;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(StructureHierarchyManager.prototype, "selection", {
        get: function () {
            this.sync(false);
            return this.state.selection;
        },
        enumerable: false,
        configurable: true
    });
    StructureHierarchyManager.prototype.getStructuresWithSelection = function () {
        var xs = this.plugin.managers.structure.hierarchy.current.structures;
        var ret = [];
        for (var _i = 0, xs_1 = xs; _i < xs_1.length; _i++) {
            var s = xs_1[_i];
            if (this.plugin.managers.structure.selection.structureHasSelection(s)) {
                ret.push(s);
            }
        }
        return ret;
    };
    StructureHierarchyManager.prototype.syncCurrent = function (all, added) {
        var current = this.seletionSet;
        var newCurrent = [];
        for (var _i = 0, all_1 = all; _i < all_1.length; _i++) {
            var r = all_1[_i];
            var ref = r.cell.transform.ref;
            if (current.has(ref) || added.has(ref))
                newCurrent.push(r);
        }
        if (newCurrent.length === 0)
            return all.length > 0 ? [all[0]] : [];
        return newCurrent;
    };
    StructureHierarchyManager.prototype.sync = function (notify) {
        if (!notify && this.dataState.inUpdate)
            return;
        if (this.state.syncedTree === this.dataState.tree) {
            if (notify && !this.state.notified) {
                this.state.notified = true;
                this.behaviors.selection.next(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({ hierarchy: this.state.hierarchy }, this.state.selection));
            }
            return;
        }
        this.state.syncedTree = this.dataState.tree;
        var update = Object(_hierarchy_state__WEBPACK_IMPORTED_MODULE_6__["buildStructureHierarchy"])(this.plugin.state.data, this.current);
        if (!update.changed) {
            return;
        }
        var hierarchy = update.hierarchy;
        var trajectories = this.syncCurrent(hierarchy.trajectories, update.added);
        var models = this.syncCurrent(hierarchy.models, update.added);
        var structures = this.syncCurrent(hierarchy.structures, update.added);
        this._currentComponentGroups = void 0;
        this._currentSelectionSet = void 0;
        this.state.hierarchy = hierarchy;
        this.state.selection.trajectories = trajectories;
        this.state.selection.models = models;
        this.state.selection.structures = structures;
        if (notify) {
            this.state.notified = true;
            this.behaviors.selection.next({ hierarchy: hierarchy, trajectories: trajectories, models: models, structures: structures });
        }
        else {
            this.state.notified = false;
        }
    };
    StructureHierarchyManager.prototype.updateCurrent = function (refs, action) {
        var hierarchy = this.current;
        var set = action === 'add'
            ? _mol_util_set__WEBPACK_IMPORTED_MODULE_4__["SetUtils"].union(this.seletionSet, new Set(refs.map(function (r) { return r.cell.transform.ref; })))
            : _mol_util_set__WEBPACK_IMPORTED_MODULE_4__["SetUtils"].difference(this.seletionSet, new Set(refs.map(function (r) { return r.cell.transform.ref; })));
        var trajectories = [];
        var models = [];
        var structures = [];
        for (var _i = 0, _a = hierarchy.trajectories; _i < _a.length; _i++) {
            var t = _a[_i];
            if (set.has(t.cell.transform.ref))
                trajectories.push(t);
        }
        for (var _b = 0, _c = hierarchy.models; _b < _c.length; _b++) {
            var m = _c[_b];
            if (set.has(m.cell.transform.ref))
                models.push(m);
        }
        for (var _d = 0, _e = hierarchy.structures; _d < _e.length; _d++) {
            var s = _e[_d];
            if (set.has(s.cell.transform.ref))
                structures.push(s);
        }
        this._currentComponentGroups = void 0;
        this._currentSelectionSet = void 0;
        this.state.selection.trajectories = trajectories;
        this.state.selection.models = models;
        this.state.selection.structures = structures;
        this.behaviors.selection.next({ hierarchy: hierarchy, trajectories: trajectories, models: models, structures: structures });
    };
    StructureHierarchyManager.prototype.remove = function (refs, canUndo) {
        if (refs.length === 0)
            return;
        var deletes = this.plugin.state.data.build();
        for (var _i = 0, refs_1 = refs; _i < refs_1.length; _i++) {
            var r = refs_1[_i];
            deletes.delete(typeof r === 'string' ? r : r.cell.transform.ref);
        }
        return deletes.commit({ canUndo: canUndo ? 'Remove' : false });
    };
    StructureHierarchyManager.prototype.toggleVisibility = function (refs, action) {
        if (refs.length === 0)
            return;
        var isHidden = action !== void 0
            ? (action === 'show' ? false : true)
            : !refs[0].cell.state.isHidden;
        for (var _i = 0, refs_2 = refs; _i < refs_2.length; _i++) {
            var c = refs_2[_i];
            Object(_mol_plugin_behavior_static_state__WEBPACK_IMPORTED_MODULE_1__["setSubtreeVisibility"])(this.dataState, c.cell.transform.ref, isHidden);
        }
    };
    StructureHierarchyManager.prototype.applyPreset = function (trajectories, provider, params) {
        var _this = this;
        return this.plugin.dataTransaction(function () { return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"])(_this, void 0, void 0, function () {
            var _i, trajectories_1, t;
            return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__generator"])(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _i = 0, trajectories_1 = trajectories;
                        _a.label = 1;
                    case 1:
                        if (!(_i < trajectories_1.length)) return [3 /*break*/, 6];
                        t = trajectories_1[_i];
                        if (!(t.models.length > 0)) return [3 /*break*/, 3];
                        return [4 /*yield*/, this.clearTrajectory(t)];
                    case 2:
                        _a.sent();
                        _a.label = 3;
                    case 3: return [4 /*yield*/, this.plugin.builders.structure.hierarchy.applyPreset(t.cell, provider, params)];
                    case 4:
                        _a.sent();
                        _a.label = 5;
                    case 5:
                        _i++;
                        return [3 /*break*/, 1];
                    case 6: return [2 /*return*/];
                }
            });
        }); });
    };
    StructureHierarchyManager.prototype.updateStructure = function (s, params) {
        return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"])(this, void 0, void 0, function () {
            var _this = this;
            return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__generator"])(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.plugin.dataTransaction(function () { return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"])(_this, void 0, void 0, function () {
                            var root, children;
                            return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__generator"])(this, function (_a) {
                                switch (_a.label) {
                                    case 0:
                                        root = _mol_state__WEBPACK_IMPORTED_MODULE_3__["StateTree"].getDecoratorRoot(this.dataState.tree, s.cell.transform.ref);
                                        children = this.dataState.tree.children.get(root).toArray();
                                        return [4 /*yield*/, this.remove(children, false)];
                                    case 1:
                                        _a.sent();
                                        return [4 /*yield*/, this.plugin.state.updateTransform(this.plugin.state.data, s.cell.transform.ref, params, 'Structure Type')];
                                    case 2:
                                        _a.sent();
                                        return [4 /*yield*/, this.plugin.builders.structure.representation.applyPreset(s.cell.transform.ref, 'auto')];
                                    case 3:
                                        _a.sent();
                                        return [2 /*return*/];
                                }
                            });
                        }); }, { canUndo: 'Structure Type' })];
                    case 1:
                        _a.sent();
                        _mol_plugin_commands__WEBPACK_IMPORTED_MODULE_2__["PluginCommands"].Camera.Reset(this.plugin);
                        return [2 /*return*/];
                }
            });
        });
    };
    StructureHierarchyManager.prototype.clearTrajectory = function (trajectory) {
        var builder = this.dataState.build();
        for (var _i = 0, _a = trajectory.models; _i < _a.length; _i++) {
            var m = _a[_i];
            builder.delete(m.cell);
        }
        return builder.commit();
    };
    return StructureHierarchyManager;
}(_component__WEBPACK_IMPORTED_MODULE_5__["PluginComponent"]));

(function (StructureHierarchyManager) {
    function getComponentGroups(structures) {
        if (!structures.length)
            return [];
        if (structures.length === 1)
            return structures[0].components.map(function (c) { return [c]; });
        var groups = [];
        var map = new Map();
        for (var _i = 0, structures_1 = structures; _i < structures_1.length; _i++) {
            var s = structures_1[_i];
            for (var _a = 0, _b = s.components; _a < _b.length; _a++) {
                var c = _b[_a];
                var key = c.key;
                if (!key)
                    continue;
                var component = map.get(key);
                if (!component) {
                    component = [];
                    map.set(key, component);
                    groups.push(component);
                }
                component.push(c);
            }
        }
        return groups;
    }
    StructureHierarchyManager.getComponentGroups = getComponentGroups;
    function getSelectedStructuresDescription(plugin) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j;
        var structures = plugin.managers.structure.hierarchy.selection.structures;
        if (structures.length === 0)
            return '';
        if (structures.length === 1) {
            var s = structures[0];
            var data = (_a = s.cell.obj) === null || _a === void 0 ? void 0 : _a.data;
            if (!data)
                return ((_b = s.cell.obj) === null || _b === void 0 ? void 0 : _b.label) || 'Structure';
            var model = data.models[0] || data.representativeModel || data.masterModel;
            if (!model)
                return ((_c = s.cell.obj) === null || _c === void 0 ? void 0 : _c.label) || 'Structure';
            var entryId = model.entryId;
            if (((_e = (_d = s.model) === null || _d === void 0 ? void 0 : _d.trajectory) === null || _e === void 0 ? void 0 : _e.models) && s.model.trajectory.models.length === 1)
                return entryId;
            if (s.model)
                return ((_f = s.model.cell.obj) === null || _f === void 0 ? void 0 : _f.label) + " | " + entryId;
            return entryId;
        }
        var p = structures[0];
        var t = (_g = p === null || p === void 0 ? void 0 : p.model) === null || _g === void 0 ? void 0 : _g.trajectory;
        var sameTraj = true;
        for (var _i = 0, structures_2 = structures; _i < structures_2.length; _i++) {
            var s = structures_2[_i];
            if (((_h = s === null || s === void 0 ? void 0 : s.model) === null || _h === void 0 ? void 0 : _h.trajectory) !== t) {
                sameTraj = false;
                break;
            }
        }
        return sameTraj && t ? ((_j = t.cell.obj) === null || _j === void 0 ? void 0 : _j.label) + " | " + structures.length + " structures" : structures.length + " structures";
    }
    StructureHierarchyManager.getSelectedStructuresDescription = getSelectedStructuresDescription;
})(StructureHierarchyManager || (StructureHierarchyManager = {}));
//# sourceMappingURL=hierarchy.js.map

/***/ }),

/***/ "./lib/mol-plugin-state/manager/structure/measurement.js":
/*!***************************************************************!*\
  !*** ./lib/mol-plugin-state/manager/structure/measurement.js ***!
  \***************************************************************/
/*! exports provided: StructureMeasurementManager, MeasurementGroupTag, StructureMeasurementParams */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "StructureMeasurementManager", function() { return StructureMeasurementManager; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MeasurementGroupTag", function() { return MeasurementGroupTag; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "StructureMeasurementParams", function() { return StructureMeasurementParams; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _mol_model_structure__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../../mol-model/structure */ "./lib/mol-model/structure.js");
/* harmony import */ var _mol_state__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../../mol-state */ "./lib/mol-state/index.js");
/* harmony import */ var _transforms__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../transforms */ "./lib/mol-plugin-state/transforms.js");
/* harmony import */ var _mol_plugin_commands__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../../mol-plugin/commands */ "./lib/mol-plugin/commands.js");
/* harmony import */ var _mol_util_array__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../../mol-util/array */ "./lib/mol-util/array.js");
/* harmony import */ var _component__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../../component */ "./lib/mol-plugin-state/component.js");
/* harmony import */ var _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../../../mol-util/param-definition */ "./lib/mol-util/param-definition.js");
/* harmony import */ var _mol_repr_shape_loci_common__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ../../../mol-repr/shape/loci/common */ "./lib/mol-repr/shape/loci/common.js");
/**
 * Copyright (c) 2019-2020 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author David Sehnal <david.sehnal@gmail.com>
 */










var MeasurementGroupTag = 'measurement-group';
var StructureMeasurementParams = {
    distanceUnitLabel: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_7__["ParamDefinition"].Text('\u212B', { isEssential: true }),
    textColor: _mol_repr_shape_loci_common__WEBPACK_IMPORTED_MODULE_8__["MeasurementRepresentationCommonTextParams"].textColor
};
var DefaultStructureMeasurementOptions = _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_7__["ParamDefinition"].getDefaultValues(StructureMeasurementParams);
var StructureMeasurementManager = /** @class */ (function (_super) {
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__extends"])(StructureMeasurementManager, _super);
    function StructureMeasurementManager(plugin) {
        var _this = _super.call(this, { labels: [], distances: [], angles: [], dihedrals: [], orientations: [], options: DefaultStructureMeasurementOptions }) || this;
        _this.plugin = plugin;
        _this.behaviors = {
            state: _this.ev.behavior(_this.state)
        };
        _this._empty = [];
        plugin.state.data.events.changed.subscribe(function (e) {
            if (e.inTransaction || plugin.behaviors.state.isAnimating.value)
                return;
            _this.sync();
        });
        plugin.behaviors.state.isAnimating.subscribe(function (isAnimating) {
            if (!isAnimating && !plugin.behaviors.state.isUpdating.value)
                _this.sync();
        });
        return _this;
    }
    StructureMeasurementManager.prototype.stateUpdated = function () {
        this.behaviors.state.next(this.state);
    };
    StructureMeasurementManager.prototype.getGroup = function () {
        var state = this.plugin.state.data;
        var groupRef = _mol_state__WEBPACK_IMPORTED_MODULE_2__["StateSelection"].findTagInSubtree(state.tree, _mol_state__WEBPACK_IMPORTED_MODULE_2__["StateTransform"].RootRef, MeasurementGroupTag);
        var builder = this.plugin.state.data.build();
        if (groupRef)
            return builder.to(groupRef);
        return builder.toRoot().group(_transforms__WEBPACK_IMPORTED_MODULE_3__["StateTransforms"].Misc.CreateGroup, { label: "Measurements" }, { tags: MeasurementGroupTag });
    };
    StructureMeasurementManager.prototype.setOptions = function (options) {
        return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"])(this, void 0, void 0, function () {
            var update, _i, _a, cell, _b, _c, cell, _d, _e, cell, _f, _g, cell;
            return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__generator"])(this, function (_h) {
                switch (_h.label) {
                    case 0:
                        if (this.updateState({ options: options }))
                            this.stateUpdated();
                        update = this.plugin.state.data.build();
                        for (_i = 0, _a = this.state.distances; _i < _a.length; _i++) {
                            cell = _a[_i];
                            update.to(cell).update(function (old) {
                                old.unitLabel = options.distanceUnitLabel;
                                old.textColor = options.textColor;
                            });
                        }
                        for (_b = 0, _c = this.state.labels; _b < _c.length; _b++) {
                            cell = _c[_b];
                            update.to(cell).update(function (old) { old.textColor = options.textColor; });
                        }
                        for (_d = 0, _e = this.state.angles; _d < _e.length; _d++) {
                            cell = _e[_d];
                            update.to(cell).update(function (old) { old.textColor = options.textColor; });
                        }
                        for (_f = 0, _g = this.state.dihedrals; _f < _g.length; _f++) {
                            cell = _g[_f];
                            update.to(cell).update(function (old) { old.textColor = options.textColor; });
                        }
                        if (update.editInfo.count === 0)
                            return [2 /*return*/];
                        return [4 /*yield*/, _mol_plugin_commands__WEBPACK_IMPORTED_MODULE_4__["PluginCommands"].State.Update(this.plugin, { state: this.plugin.state.data, tree: update, options: { doNotLogTiming: true } })];
                    case 1:
                        _h.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    StructureMeasurementManager.prototype.addDistance = function (a, b, options) {
        return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"])(this, void 0, void 0, function () {
            var cellA, cellB, dependsOn, update, state;
            return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__generator"])(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        cellA = this.plugin.helpers.substructureParent.get(a.structure);
                        cellB = this.plugin.helpers.substructureParent.get(b.structure);
                        if (!cellA || !cellB)
                            return [2 /*return*/];
                        dependsOn = [cellA.transform.ref];
                        Object(_mol_util_array__WEBPACK_IMPORTED_MODULE_5__["arraySetAdd"])(dependsOn, cellB.transform.ref);
                        update = this.getGroup();
                        update
                            .apply(_transforms__WEBPACK_IMPORTED_MODULE_3__["StateTransforms"].Model.MultiStructureSelectionFromExpression, {
                            selections: [
                                { key: 'a', groupId: 'a', ref: cellA.transform.ref, expression: _mol_model_structure__WEBPACK_IMPORTED_MODULE_1__["StructureElement"].Loci.toExpression(a) },
                                { key: 'b', groupId: 'b', ref: cellB.transform.ref, expression: _mol_model_structure__WEBPACK_IMPORTED_MODULE_1__["StructureElement"].Loci.toExpression(b) }
                            ],
                            isTransitive: true,
                            label: 'Distance'
                        }, { dependsOn: dependsOn, tags: options === null || options === void 0 ? void 0 : options.selectionTags })
                            .apply(_transforms__WEBPACK_IMPORTED_MODULE_3__["StateTransforms"].Representation.StructureSelectionsDistance3D, Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({ customText: (options === null || options === void 0 ? void 0 : options.customText) || '', unitLabel: this.state.options.distanceUnitLabel, textColor: this.state.options.textColor }, options === null || options === void 0 ? void 0 : options.lineParams), options === null || options === void 0 ? void 0 : options.labelParams), options === null || options === void 0 ? void 0 : options.visualParams), { tags: options === null || options === void 0 ? void 0 : options.reprTags });
                        state = this.plugin.state.data;
                        return [4 /*yield*/, _mol_plugin_commands__WEBPACK_IMPORTED_MODULE_4__["PluginCommands"].State.Update(this.plugin, { state: state, tree: update, options: { doNotLogTiming: true } })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    StructureMeasurementManager.prototype.addAngle = function (a, b, c, options) {
        return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"])(this, void 0, void 0, function () {
            var cellA, cellB, cellC, dependsOn, update, state;
            return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__generator"])(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        cellA = this.plugin.helpers.substructureParent.get(a.structure);
                        cellB = this.plugin.helpers.substructureParent.get(b.structure);
                        cellC = this.plugin.helpers.substructureParent.get(c.structure);
                        if (!cellA || !cellB || !cellC)
                            return [2 /*return*/];
                        dependsOn = [cellA.transform.ref];
                        Object(_mol_util_array__WEBPACK_IMPORTED_MODULE_5__["arraySetAdd"])(dependsOn, cellB.transform.ref);
                        Object(_mol_util_array__WEBPACK_IMPORTED_MODULE_5__["arraySetAdd"])(dependsOn, cellC.transform.ref);
                        update = this.getGroup();
                        update
                            .apply(_transforms__WEBPACK_IMPORTED_MODULE_3__["StateTransforms"].Model.MultiStructureSelectionFromExpression, {
                            selections: [
                                { key: 'a', ref: cellA.transform.ref, expression: _mol_model_structure__WEBPACK_IMPORTED_MODULE_1__["StructureElement"].Loci.toExpression(a) },
                                { key: 'b', ref: cellB.transform.ref, expression: _mol_model_structure__WEBPACK_IMPORTED_MODULE_1__["StructureElement"].Loci.toExpression(b) },
                                { key: 'c', ref: cellC.transform.ref, expression: _mol_model_structure__WEBPACK_IMPORTED_MODULE_1__["StructureElement"].Loci.toExpression(c) }
                            ],
                            isTransitive: true,
                            label: 'Angle'
                        }, { dependsOn: dependsOn, tags: options === null || options === void 0 ? void 0 : options.selectionTags })
                            .apply(_transforms__WEBPACK_IMPORTED_MODULE_3__["StateTransforms"].Representation.StructureSelectionsAngle3D, Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({ customText: (options === null || options === void 0 ? void 0 : options.customText) || '', textColor: this.state.options.textColor }, options === null || options === void 0 ? void 0 : options.lineParams), options === null || options === void 0 ? void 0 : options.labelParams), options === null || options === void 0 ? void 0 : options.visualParams), { tags: options === null || options === void 0 ? void 0 : options.reprTags });
                        state = this.plugin.state.data;
                        return [4 /*yield*/, _mol_plugin_commands__WEBPACK_IMPORTED_MODULE_4__["PluginCommands"].State.Update(this.plugin, { state: state, tree: update, options: { doNotLogTiming: true } })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    StructureMeasurementManager.prototype.addDihedral = function (a, b, c, d, options) {
        return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"])(this, void 0, void 0, function () {
            var cellA, cellB, cellC, cellD, dependsOn, update, state;
            return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__generator"])(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        cellA = this.plugin.helpers.substructureParent.get(a.structure);
                        cellB = this.plugin.helpers.substructureParent.get(b.structure);
                        cellC = this.plugin.helpers.substructureParent.get(c.structure);
                        cellD = this.plugin.helpers.substructureParent.get(d.structure);
                        if (!cellA || !cellB || !cellC || !cellD)
                            return [2 /*return*/];
                        dependsOn = [cellA.transform.ref];
                        Object(_mol_util_array__WEBPACK_IMPORTED_MODULE_5__["arraySetAdd"])(dependsOn, cellB.transform.ref);
                        Object(_mol_util_array__WEBPACK_IMPORTED_MODULE_5__["arraySetAdd"])(dependsOn, cellC.transform.ref);
                        Object(_mol_util_array__WEBPACK_IMPORTED_MODULE_5__["arraySetAdd"])(dependsOn, cellD.transform.ref);
                        update = this.getGroup();
                        update
                            .apply(_transforms__WEBPACK_IMPORTED_MODULE_3__["StateTransforms"].Model.MultiStructureSelectionFromExpression, {
                            selections: [
                                { key: 'a', ref: cellA.transform.ref, expression: _mol_model_structure__WEBPACK_IMPORTED_MODULE_1__["StructureElement"].Loci.toExpression(a) },
                                { key: 'b', ref: cellB.transform.ref, expression: _mol_model_structure__WEBPACK_IMPORTED_MODULE_1__["StructureElement"].Loci.toExpression(b) },
                                { key: 'c', ref: cellC.transform.ref, expression: _mol_model_structure__WEBPACK_IMPORTED_MODULE_1__["StructureElement"].Loci.toExpression(c) },
                                { key: 'd', ref: cellD.transform.ref, expression: _mol_model_structure__WEBPACK_IMPORTED_MODULE_1__["StructureElement"].Loci.toExpression(d) }
                            ],
                            isTransitive: true,
                            label: 'Dihedral'
                        }, { dependsOn: dependsOn, tags: options === null || options === void 0 ? void 0 : options.selectionTags })
                            .apply(_transforms__WEBPACK_IMPORTED_MODULE_3__["StateTransforms"].Representation.StructureSelectionsDihedral3D, Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({ customText: (options === null || options === void 0 ? void 0 : options.customText) || '', textColor: this.state.options.textColor }, options === null || options === void 0 ? void 0 : options.lineParams), options === null || options === void 0 ? void 0 : options.labelParams), options === null || options === void 0 ? void 0 : options.visualParams), { tags: options === null || options === void 0 ? void 0 : options.reprTags });
                        state = this.plugin.state.data;
                        return [4 /*yield*/, _mol_plugin_commands__WEBPACK_IMPORTED_MODULE_4__["PluginCommands"].State.Update(this.plugin, { state: state, tree: update, options: { doNotLogTiming: true } })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    StructureMeasurementManager.prototype.addLabel = function (a, options) {
        return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"])(this, void 0, void 0, function () {
            var cellA, dependsOn, update, state;
            return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__generator"])(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        cellA = this.plugin.helpers.substructureParent.get(a.structure);
                        if (!cellA)
                            return [2 /*return*/];
                        dependsOn = [cellA.transform.ref];
                        update = this.getGroup();
                        update
                            .apply(_transforms__WEBPACK_IMPORTED_MODULE_3__["StateTransforms"].Model.MultiStructureSelectionFromExpression, {
                            selections: [
                                { key: 'a', ref: cellA.transform.ref, expression: _mol_model_structure__WEBPACK_IMPORTED_MODULE_1__["StructureElement"].Loci.toExpression(a) },
                            ],
                            isTransitive: true,
                            label: 'Label'
                        }, { dependsOn: dependsOn, tags: options === null || options === void 0 ? void 0 : options.selectionTags })
                            .apply(_transforms__WEBPACK_IMPORTED_MODULE_3__["StateTransforms"].Representation.StructureSelectionsLabel3D, Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({ textColor: this.state.options.textColor }, options === null || options === void 0 ? void 0 : options.labelParams), options === null || options === void 0 ? void 0 : options.visualParams), { tags: options === null || options === void 0 ? void 0 : options.reprTags });
                        state = this.plugin.state.data;
                        return [4 /*yield*/, _mol_plugin_commands__WEBPACK_IMPORTED_MODULE_4__["PluginCommands"].State.Update(this.plugin, { state: state, tree: update, options: { doNotLogTiming: true } })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    StructureMeasurementManager.prototype.addOrientation = function (a) {
        return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"])(this, void 0, void 0, function () {
            var cellA, dependsOn, update, state;
            return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__generator"])(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        cellA = this.plugin.helpers.substructureParent.get(a.structure);
                        if (!cellA)
                            return [2 /*return*/];
                        dependsOn = [cellA.transform.ref];
                        update = this.getGroup();
                        update
                            .apply(_transforms__WEBPACK_IMPORTED_MODULE_3__["StateTransforms"].Model.MultiStructureSelectionFromExpression, {
                            selections: [
                                { key: 'a', ref: cellA.transform.ref, expression: _mol_model_structure__WEBPACK_IMPORTED_MODULE_1__["StructureElement"].Loci.toExpression(a) },
                            ],
                            isTransitive: true,
                            label: 'Orientation'
                        }, { dependsOn: dependsOn })
                            .apply(_transforms__WEBPACK_IMPORTED_MODULE_3__["StateTransforms"].Representation.StructureSelectionsOrientation3D);
                        state = this.plugin.state.data;
                        return [4 /*yield*/, _mol_plugin_commands__WEBPACK_IMPORTED_MODULE_4__["PluginCommands"].State.Update(this.plugin, { state: state, tree: update, options: { doNotLogTiming: true } })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    StructureMeasurementManager.prototype.getTransforms = function (transformer) {
        var state = this.plugin.state.data;
        var groupRef = _mol_state__WEBPACK_IMPORTED_MODULE_2__["StateSelection"].findTagInSubtree(state.tree, _mol_state__WEBPACK_IMPORTED_MODULE_2__["StateTransform"].RootRef, MeasurementGroupTag);
        var ret = groupRef ? state.select(_mol_state__WEBPACK_IMPORTED_MODULE_2__["StateSelection"].Generators.ofTransformer(transformer, groupRef)) : this._empty;
        if (ret.length === 0)
            return this._empty;
        return ret;
    };
    StructureMeasurementManager.prototype.sync = function () {
        var updated = this.updateState({
            labels: this.getTransforms(_transforms__WEBPACK_IMPORTED_MODULE_3__["StateTransforms"].Representation.StructureSelectionsLabel3D),
            distances: this.getTransforms(_transforms__WEBPACK_IMPORTED_MODULE_3__["StateTransforms"].Representation.StructureSelectionsDistance3D),
            angles: this.getTransforms(_transforms__WEBPACK_IMPORTED_MODULE_3__["StateTransforms"].Representation.StructureSelectionsAngle3D),
            dihedrals: this.getTransforms(_transforms__WEBPACK_IMPORTED_MODULE_3__["StateTransforms"].Representation.StructureSelectionsDihedral3D),
            orientations: this.getTransforms(_transforms__WEBPACK_IMPORTED_MODULE_3__["StateTransforms"].Representation.StructureSelectionsOrientation3D)
        });
        if (updated)
            this.stateUpdated();
    };
    return StructureMeasurementManager;
}(_component__WEBPACK_IMPORTED_MODULE_6__["StatefulPluginComponent"]));
//# sourceMappingURL=measurement.js.map

/***/ }),

/***/ "./lib/mol-plugin-state/manager/structure/selection.js":
/*!*************************************************************!*\
  !*** ./lib/mol-plugin-state/manager/structure/selection.js ***!
  \*************************************************************/
/*! exports provided: StructureSelectionManager */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "StructureSelectionManager", function() { return StructureSelectionManager; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _mol_data_int__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../../mol-data/int */ "./lib/mol-data/int.js");
/* harmony import */ var _mol_math_geometry_boundary_helper__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../../mol-math/geometry/boundary-helper */ "./lib/mol-math/geometry/boundary-helper.js");
/* harmony import */ var _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../../mol-math/linear-algebra */ "./lib/mol-math/linear-algebra.js");
/* harmony import */ var _mol_math_linear_algebra_matrix_principal_axes__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../../mol-math/linear-algebra/matrix/principal-axes */ "./lib/mol-math/linear-algebra/matrix/principal-axes.js");
/* harmony import */ var _mol_model_loci__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../../mol-model/loci */ "./lib/mol-model/loci.js");
/* harmony import */ var _mol_model_structure__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../../../mol-model/structure */ "./lib/mol-model/structure.js");
/* harmony import */ var _mol_state__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../../../mol-state */ "./lib/mol-state/index.js");
/* harmony import */ var _mol_task__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ../../../mol-task */ "./lib/mol-task/index.js");
/* harmony import */ var _mol_theme_label__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ../../../mol-theme/label */ "./lib/mol-theme/label.js");
/* harmony import */ var _mol_util_array__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ../../../mol-util/array */ "./lib/mol-util/array.js");
/* harmony import */ var _component__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ../../component */ "./lib/mol-plugin-state/component.js");
/* harmony import */ var _objects__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! ../../objects */ "./lib/mol-plugin-state/objects.js");
/* harmony import */ var _mol_util__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! ../../../mol-util */ "./lib/mol-util/index.js");
/**
 * Copyright (c) 2019-2020 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author David Sehnal <david.sehnal@gmail.com>
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */














var boundaryHelper = new _mol_math_geometry_boundary_helper__WEBPACK_IMPORTED_MODULE_2__["BoundaryHelper"]('98');
var HISTORY_CAPACITY = 24;
var StructureSelectionManager = /** @class */ (function (_super) {
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__extends"])(StructureSelectionManager, _super);
    function StructureSelectionManager(plugin) {
        var _this = _super.call(this, { entries: new Map(), additionsHistory: [], stats: SelectionStats() }) || this;
        _this.plugin = plugin;
        _this.events = {
            changed: _this.ev(),
            additionsHistoryUpdated: _this.ev(),
            loci: {
                add: _this.ev(),
                remove: _this.ev(),
                clear: _this.ev()
            }
        };
        // listen to events from substructureParent helper to ensure it is updated
        plugin.helpers.substructureParent.events.removed.subscribe(function (e) { return _this.onRemove(e.ref, e.obj); });
        plugin.helpers.substructureParent.events.updated.subscribe(function (e) { return _this.onUpdate(e.ref, e.oldObj, e.obj); });
        return _this;
    }
    Object.defineProperty(StructureSelectionManager.prototype, "entries", {
        get: function () { return this.state.entries; },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(StructureSelectionManager.prototype, "additionsHistory", {
        get: function () { return this.state.additionsHistory; },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(StructureSelectionManager.prototype, "stats", {
        get: function () {
            if (this.state.stats)
                return this.state.stats;
            this.state.stats = this.calcStats();
            return this.state.stats;
        },
        enumerable: false,
        configurable: true
    });
    StructureSelectionManager.prototype.getEntry = function (s) {
        // ignore decorators to get stable ref
        var cell = this.plugin.helpers.substructureParent.get(s, true);
        if (!cell)
            return;
        var ref = cell.transform.ref;
        if (!this.entries.has(ref)) {
            var entry = new SelectionEntry(_mol_model_structure__WEBPACK_IMPORTED_MODULE_6__["StructureElement"].Loci(s, []));
            this.entries.set(ref, entry);
            return entry;
        }
        return this.entries.get(ref);
    };
    StructureSelectionManager.prototype.calcStats = function () {
        var structureCount = 0;
        var elementCount = 0;
        var stats = _mol_model_structure__WEBPACK_IMPORTED_MODULE_6__["StructureElement"].Stats.create();
        this.entries.forEach(function (v) {
            var elements = v.selection.elements;
            if (elements.length) {
                structureCount += 1;
                for (var i = 0, il = elements.length; i < il; ++i) {
                    elementCount += _mol_data_int__WEBPACK_IMPORTED_MODULE_1__["OrderedSet"].size(elements[i].indices);
                }
                _mol_model_structure__WEBPACK_IMPORTED_MODULE_6__["StructureElement"].Stats.add(stats, stats, _mol_model_structure__WEBPACK_IMPORTED_MODULE_6__["StructureElement"].Stats.ofLoci(v.selection));
            }
        });
        var label = Object(_mol_theme_label__WEBPACK_IMPORTED_MODULE_9__["structureElementStatsLabel"])(stats, { countsOnly: true });
        return { structureCount: structureCount, elementCount: elementCount, label: label };
    };
    StructureSelectionManager.prototype.add = function (loci) {
        if (!_mol_model_structure__WEBPACK_IMPORTED_MODULE_6__["StructureElement"].Loci.is(loci))
            return false;
        var entry = this.getEntry(loci.structure);
        if (!entry)
            return false;
        var sel = entry.selection;
        entry.selection = _mol_model_structure__WEBPACK_IMPORTED_MODULE_6__["StructureElement"].Loci.union(entry.selection, loci);
        this.tryAddHistory(loci);
        this.referenceLoci = loci;
        this.events.loci.add.next(loci);
        return !_mol_model_structure__WEBPACK_IMPORTED_MODULE_6__["StructureElement"].Loci.areEqual(sel, entry.selection);
    };
    StructureSelectionManager.prototype.remove = function (loci) {
        if (!_mol_model_structure__WEBPACK_IMPORTED_MODULE_6__["StructureElement"].Loci.is(loci))
            return false;
        var entry = this.getEntry(loci.structure);
        if (!entry)
            return false;
        var sel = entry.selection;
        entry.selection = _mol_model_structure__WEBPACK_IMPORTED_MODULE_6__["StructureElement"].Loci.subtract(entry.selection, loci);
        // this.addHistory(loci);
        this.referenceLoci = loci;
        this.events.loci.remove.next(loci);
        return !_mol_model_structure__WEBPACK_IMPORTED_MODULE_6__["StructureElement"].Loci.areEqual(sel, entry.selection);
    };
    StructureSelectionManager.prototype.intersect = function (loci) {
        if (!_mol_model_structure__WEBPACK_IMPORTED_MODULE_6__["StructureElement"].Loci.is(loci))
            return false;
        var entry = this.getEntry(loci.structure);
        if (!entry)
            return false;
        var sel = entry.selection;
        entry.selection = _mol_model_structure__WEBPACK_IMPORTED_MODULE_6__["StructureElement"].Loci.intersect(entry.selection, loci);
        // this.addHistory(loci);
        this.referenceLoci = loci;
        return !_mol_model_structure__WEBPACK_IMPORTED_MODULE_6__["StructureElement"].Loci.areEqual(sel, entry.selection);
    };
    StructureSelectionManager.prototype.set = function (loci) {
        if (!_mol_model_structure__WEBPACK_IMPORTED_MODULE_6__["StructureElement"].Loci.is(loci))
            return false;
        var entry = this.getEntry(loci.structure);
        if (!entry)
            return false;
        var sel = entry.selection;
        entry.selection = loci;
        this.tryAddHistory(loci);
        this.referenceLoci = undefined;
        return !_mol_model_structure__WEBPACK_IMPORTED_MODULE_6__["StructureElement"].Loci.areEqual(sel, entry.selection);
    };
    StructureSelectionManager.prototype.modifyHistory = function (entry, action, modulus, groupByStructure) {
        if (groupByStructure === void 0) { groupByStructure = false; }
        var history = this.additionsHistory;
        var idx = history.indexOf(entry);
        if (idx < 0)
            return;
        var swapWith = void 0;
        switch (action) {
            case 'remove':
                Object(_mol_util_array__WEBPACK_IMPORTED_MODULE_10__["arrayRemoveAtInPlace"])(history, idx);
                break;
            case 'up':
                swapWith = idx - 1;
                break;
            case 'down':
                swapWith = idx + 1;
                break;
        }
        if (swapWith !== void 0) {
            var mod = modulus ? Math.min(history.length, modulus) : history.length;
            while (true) {
                swapWith = swapWith % mod;
                if (swapWith < 0)
                    swapWith += mod;
                if (!groupByStructure || history[idx].loci.structure === history[swapWith].loci.structure) {
                    var t = history[idx];
                    history[idx] = history[swapWith];
                    history[swapWith] = t;
                    break;
                }
                else {
                    swapWith += action === 'up' ? -1 : +1;
                }
            }
        }
        this.events.additionsHistoryUpdated.next();
    };
    StructureSelectionManager.prototype.tryAddHistory = function (loci) {
        if (_mol_model_loci__WEBPACK_IMPORTED_MODULE_5__["Loci"].isEmpty(loci))
            return;
        var idx = 0, entry = void 0;
        for (var _i = 0, _a = this.additionsHistory; _i < _a.length; _i++) {
            var l = _a[_i];
            if (_mol_model_loci__WEBPACK_IMPORTED_MODULE_5__["Loci"].areEqual(l.loci, loci)) {
                entry = l;
                break;
            }
            idx++;
        }
        if (entry) {
            // move to top
            Object(_mol_util_array__WEBPACK_IMPORTED_MODULE_10__["arrayRemoveAtInPlace"])(this.additionsHistory, idx);
            this.additionsHistory.unshift(entry);
            this.events.additionsHistoryUpdated.next();
            return;
        }
        var stats = _mol_model_structure__WEBPACK_IMPORTED_MODULE_6__["StructureElement"].Stats.ofLoci(loci);
        var label = Object(_mol_theme_label__WEBPACK_IMPORTED_MODULE_9__["structureElementStatsLabel"])(stats, { reverse: true });
        this.additionsHistory.unshift({ id: _mol_util__WEBPACK_IMPORTED_MODULE_13__["UUID"].create22(), loci: loci, label: label });
        if (this.additionsHistory.length > HISTORY_CAPACITY)
            this.additionsHistory.pop();
        this.events.additionsHistoryUpdated.next();
    };
    StructureSelectionManager.prototype.clearHistory = function () {
        if (this.state.additionsHistory.length !== 0) {
            this.state.additionsHistory = [];
            this.events.additionsHistoryUpdated.next();
        }
    };
    StructureSelectionManager.prototype.clearHistoryForStructure = function (structure) {
        var historyEntryToRemove = [];
        for (var _i = 0, _a = this.state.additionsHistory; _i < _a.length; _i++) {
            var e = _a[_i];
            if (e.loci.structure.root === structure.root) {
                historyEntryToRemove.push(e);
            }
        }
        for (var _b = 0, historyEntryToRemove_1 = historyEntryToRemove; _b < historyEntryToRemove_1.length; _b++) {
            var e = historyEntryToRemove_1[_b];
            this.modifyHistory(e, 'remove');
        }
        if (historyEntryToRemove.length !== 0) {
            this.events.additionsHistoryUpdated.next();
        }
    };
    StructureSelectionManager.prototype.onRemove = function (ref, obj) {
        var _a;
        if (this.entries.has(ref)) {
            this.entries.delete(ref);
            if (obj === null || obj === void 0 ? void 0 : obj.data) {
                this.clearHistoryForStructure(obj.data);
            }
            if (((_a = this.referenceLoci) === null || _a === void 0 ? void 0 : _a.structure) === (obj === null || obj === void 0 ? void 0 : obj.data)) {
                this.referenceLoci = undefined;
            }
            this.state.stats = void 0;
            this.events.changed.next();
        }
    };
    StructureSelectionManager.prototype.onUpdate = function (ref, oldObj, obj) {
        var _a, _b, _c, _d;
        // no change to structure
        if (oldObj === obj || (oldObj === null || oldObj === void 0 ? void 0 : oldObj.data) === obj.data)
            return;
        // ignore decorators to get stable ref
        var cell = this.plugin.helpers.substructureParent.get(obj.data, true);
        if (!cell)
            return;
        ref = cell.transform.ref;
        if (!this.entries.has(ref))
            return;
        // use structure from last decorator as reference
        var structure = (_b = (_a = this.plugin.helpers.substructureParent.get(obj.data)) === null || _a === void 0 ? void 0 : _a.obj) === null || _b === void 0 ? void 0 : _b.data;
        if (!structure)
            return;
        // oldObj is not defined for inserts (e.g. TransformStructureConformation)
        if (!(oldObj === null || oldObj === void 0 ? void 0 : oldObj.data) || _mol_model_structure__WEBPACK_IMPORTED_MODULE_6__["Structure"].areUnitIdsAndIndicesEqual(oldObj.data, obj.data)) {
            this.entries.set(ref, remapSelectionEntry(this.entries.get(ref), structure));
            // remap referenceLoci & prevHighlight if needed and possible
            if (((_c = this.referenceLoci) === null || _c === void 0 ? void 0 : _c.structure.root) === structure.root) {
                this.referenceLoci = _mol_model_structure__WEBPACK_IMPORTED_MODULE_6__["StructureElement"].Loci.remap(this.referenceLoci, structure);
            }
            // remap history locis if needed and possible
            var changedHistory = false;
            for (var _i = 0, _f = this.state.additionsHistory; _i < _f.length; _i++) {
                var e = _f[_i];
                if (e.loci.structure.root === structure.root) {
                    e.loci = _mol_model_structure__WEBPACK_IMPORTED_MODULE_6__["StructureElement"].Loci.remap(e.loci, structure);
                    changedHistory = true;
                }
            }
            if (changedHistory)
                this.events.additionsHistoryUpdated.next();
        }
        else {
            // clear the selection for ref
            this.entries.set(ref, new SelectionEntry(_mol_model_structure__WEBPACK_IMPORTED_MODULE_6__["StructureElement"].Loci(structure, [])));
            if (((_d = this.referenceLoci) === null || _d === void 0 ? void 0 : _d.structure.root) === structure.root) {
                this.referenceLoci = undefined;
            }
            this.clearHistoryForStructure(structure);
            this.state.stats = void 0;
            this.events.changed.next();
        }
    };
    /** Removes all selections and returns them */
    StructureSelectionManager.prototype.clear = function () {
        var keys = this.entries.keys();
        var selections = [];
        while (true) {
            var k = keys.next();
            if (k.done)
                break;
            var s = this.entries.get(k.value);
            if (!_mol_model_structure__WEBPACK_IMPORTED_MODULE_6__["StructureElement"].Loci.isEmpty(s.selection))
                selections.push(s.selection);
            s.selection = _mol_model_structure__WEBPACK_IMPORTED_MODULE_6__["StructureElement"].Loci(s.selection.structure, []);
        }
        this.referenceLoci = undefined;
        this.state.stats = void 0;
        this.events.changed.next();
        this.events.loci.clear.next();
        this.clearHistory();
        return selections;
    };
    StructureSelectionManager.prototype.getLoci = function (structure) {
        var entry = this.getEntry(structure);
        if (!entry)
            return _mol_model_loci__WEBPACK_IMPORTED_MODULE_5__["EmptyLoci"];
        return entry.selection;
    };
    StructureSelectionManager.prototype.getStructure = function (structure) {
        var entry = this.getEntry(structure);
        if (!entry)
            return;
        return entry.structure;
    };
    StructureSelectionManager.prototype.structureHasSelection = function (structure) {
        var _a, _b;
        var s = (_b = (_a = structure.cell) === null || _a === void 0 ? void 0 : _a.obj) === null || _b === void 0 ? void 0 : _b.data;
        if (!s)
            return false;
        var entry = this.getEntry(s);
        return !!entry && !_mol_model_structure__WEBPACK_IMPORTED_MODULE_6__["StructureElement"].Loci.isEmpty(entry.selection);
    };
    StructureSelectionManager.prototype.has = function (loci) {
        if (_mol_model_structure__WEBPACK_IMPORTED_MODULE_6__["StructureElement"].Loci.is(loci)) {
            var entry = this.getEntry(loci.structure);
            if (entry) {
                return _mol_model_structure__WEBPACK_IMPORTED_MODULE_6__["StructureElement"].Loci.isSubset(entry.selection, loci);
            }
        }
        return false;
    };
    StructureSelectionManager.prototype.tryGetRange = function (loci) {
        if (!_mol_model_structure__WEBPACK_IMPORTED_MODULE_6__["StructureElement"].Loci.is(loci))
            return;
        if (loci.elements.length !== 1)
            return;
        var entry = this.getEntry(loci.structure);
        if (!entry)
            return;
        var xs = loci.elements[0];
        if (!xs)
            return;
        var ref = this.referenceLoci;
        if (!ref || !_mol_model_structure__WEBPACK_IMPORTED_MODULE_6__["StructureElement"].Loci.is(ref) || ref.structure !== loci.structure)
            return;
        var e;
        for (var _i = 0, _a = ref.elements; _i < _a.length; _i++) {
            var _e = _a[_i];
            if (xs.unit === _e.unit) {
                e = _e;
                break;
            }
        }
        if (!e)
            return;
        if (xs.unit !== e.unit)
            return;
        return getElementRange(loci.structure, e, xs);
    };
    /** Count of all selected elements */
    StructureSelectionManager.prototype.elementCount = function () {
        var count = 0;
        this.entries.forEach(function (v) {
            count += _mol_model_structure__WEBPACK_IMPORTED_MODULE_6__["StructureElement"].Loci.size(v.selection);
        });
        return count;
    };
    StructureSelectionManager.prototype.getBoundary = function () {
        var min = _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_3__["Vec3"].create(Number.MAX_VALUE, Number.MAX_VALUE, Number.MAX_VALUE);
        var max = _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_3__["Vec3"].create(-Number.MAX_VALUE, -Number.MAX_VALUE, -Number.MAX_VALUE);
        boundaryHelper.reset();
        var boundaries = [];
        this.entries.forEach(function (v) {
            var loci = v.selection;
            if (!_mol_model_structure__WEBPACK_IMPORTED_MODULE_6__["StructureElement"].Loci.isEmpty(loci)) {
                boundaries.push(_mol_model_structure__WEBPACK_IMPORTED_MODULE_6__["StructureElement"].Loci.getBoundary(loci));
            }
        });
        for (var i = 0, il = boundaries.length; i < il; ++i) {
            var _a = boundaries[i], box = _a.box, sphere = _a.sphere;
            _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_3__["Vec3"].min(min, min, box.min);
            _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_3__["Vec3"].max(max, max, box.max);
            boundaryHelper.includePositionRadius(sphere.center, sphere.radius);
        }
        boundaryHelper.finishedIncludeStep();
        for (var i = 0, il = boundaries.length; i < il; ++i) {
            var sphere = boundaries[i].sphere;
            boundaryHelper.radiusPositionRadius(sphere.center, sphere.radius);
        }
        return { box: { min: min, max: max }, sphere: boundaryHelper.getSphere() };
    };
    StructureSelectionManager.prototype.getPrincipalAxes = function () {
        var elementCount = this.elementCount();
        var positions = new Float32Array(3 * elementCount);
        var offset = 0;
        this.entries.forEach(function (v) {
            _mol_model_structure__WEBPACK_IMPORTED_MODULE_6__["StructureElement"].Loci.toPositionsArray(v.selection, positions, offset);
            offset += _mol_model_structure__WEBPACK_IMPORTED_MODULE_6__["StructureElement"].Loci.size(v.selection) * 3;
        });
        return _mol_math_linear_algebra_matrix_principal_axes__WEBPACK_IMPORTED_MODULE_4__["PrincipalAxes"].ofPositions(positions);
    };
    StructureSelectionManager.prototype.modify = function (modifier, loci) {
        var changed = false;
        switch (modifier) {
            case 'add':
                changed = this.add(loci);
                break;
            case 'remove':
                changed = this.remove(loci);
                break;
            case 'intersect':
                changed = this.intersect(loci);
                break;
            case 'set':
                changed = this.set(loci);
                break;
        }
        if (changed) {
            this.state.stats = void 0;
            this.events.changed.next();
        }
    };
    Object.defineProperty(StructureSelectionManager.prototype, "applicableStructures", {
        get: function () {
            return this.plugin.managers.structure.hierarchy.selection.structures
                .filter(function (s) { return !!s.cell.obj; })
                .map(function (s) { return s.cell.obj.data; });
        },
        enumerable: false,
        configurable: true
    });
    StructureSelectionManager.prototype.triggerInteraction = function (modifier, loci, applyGranularity) {
        if (applyGranularity === void 0) { applyGranularity = true; }
        switch (modifier) {
            case 'add':
                this.plugin.managers.interactivity.lociSelects.select({ loci: loci }, applyGranularity);
                break;
            case 'remove':
                this.plugin.managers.interactivity.lociSelects.deselect({ loci: loci }, applyGranularity);
                break;
            case 'intersect':
                this.plugin.managers.interactivity.lociSelects.selectJoin({ loci: loci }, applyGranularity);
                break;
            case 'set':
                this.plugin.managers.interactivity.lociSelects.selectOnly({ loci: loci }, applyGranularity);
                break;
        }
    };
    StructureSelectionManager.prototype.fromLoci = function (modifier, loci, applyGranularity) {
        if (applyGranularity === void 0) { applyGranularity = true; }
        this.triggerInteraction(modifier, loci, applyGranularity);
    };
    StructureSelectionManager.prototype.fromSelectionQuery = function (modifier, query, applyGranularity) {
        var _this = this;
        if (applyGranularity === void 0) { applyGranularity = true; }
        this.plugin.runTask(_mol_task__WEBPACK_IMPORTED_MODULE_8__["Task"].create('Structure Selection', function (runtime) { return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"])(_this, void 0, void 0, function () {
            var _i, _a, s, loci;
            return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__generator"])(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _i = 0, _a = this.applicableStructures;
                        _b.label = 1;
                    case 1:
                        if (!(_i < _a.length)) return [3 /*break*/, 4];
                        s = _a[_i];
                        return [4 /*yield*/, query.getSelection(this.plugin, runtime, s)];
                    case 2:
                        loci = _b.sent();
                        this.triggerInteraction(modifier, _mol_model_structure__WEBPACK_IMPORTED_MODULE_6__["StructureSelection"].toLociWithSourceUnits(loci), applyGranularity);
                        _b.label = 3;
                    case 3:
                        _i++;
                        return [3 /*break*/, 1];
                    case 4: return [2 /*return*/];
                }
            });
        }); }));
    };
    StructureSelectionManager.prototype.fromSelections = function (ref) {
        var _a;
        var cell = _mol_state__WEBPACK_IMPORTED_MODULE_7__["StateObjectRef"].resolveAndCheck(this.plugin.state.data, ref);
        if (!cell || !cell.obj)
            return;
        if (!_objects__WEBPACK_IMPORTED_MODULE_12__["PluginStateObject"].Molecule.Structure.Selections.is(cell.obj)) {
            console.warn('fromSelections applied to wrong object type.', cell.obj);
            return;
        }
        this.clear();
        for (var _i = 0, _b = (_a = cell.obj) === null || _a === void 0 ? void 0 : _a.data; _i < _b.length; _i++) {
            var s = _b[_i];
            this.fromLoci('set', s.loci);
        }
    };
    return StructureSelectionManager;
}(_component__WEBPACK_IMPORTED_MODULE_11__["StatefulPluginComponent"]));

function SelectionStats() { return { structureCount: 0, elementCount: 0, label: 'Nothing Selected' }; }
;
var SelectionEntry = /** @class */ (function () {
    function SelectionEntry(selection) {
        this._structure = void 0;
        this._selection = selection;
    }
    Object.defineProperty(SelectionEntry.prototype, "selection", {
        get: function () { return this._selection; },
        set: function (value) {
            this._selection = value;
            this._structure = void 0;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SelectionEntry.prototype, "structure", {
        get: function () {
            if (this._structure)
                return this._structure;
            if (_mol_model_loci__WEBPACK_IMPORTED_MODULE_5__["Loci"].isEmpty(this._selection)) {
                this._structure = void 0;
            }
            else {
                this._structure = _mol_model_structure__WEBPACK_IMPORTED_MODULE_6__["StructureElement"].Loci.toStructure(this._selection);
            }
            return this._structure;
        },
        enumerable: false,
        configurable: true
    });
    return SelectionEntry;
}());
/** remap `selection-entry` to be related to `structure` if possible */
function remapSelectionEntry(e, s) {
    return new SelectionEntry(_mol_model_structure__WEBPACK_IMPORTED_MODULE_6__["StructureElement"].Loci.remap(e.selection, s));
}
/**
 * Assumes `ref` and `ext` belong to the same unit in the same structure
 */
function getElementRange(structure, ref, ext) {
    var min = Math.min(_mol_data_int__WEBPACK_IMPORTED_MODULE_1__["OrderedSet"].min(ref.indices), _mol_data_int__WEBPACK_IMPORTED_MODULE_1__["OrderedSet"].min(ext.indices));
    var max = Math.max(_mol_data_int__WEBPACK_IMPORTED_MODULE_1__["OrderedSet"].max(ref.indices), _mol_data_int__WEBPACK_IMPORTED_MODULE_1__["OrderedSet"].max(ext.indices));
    return _mol_model_structure__WEBPACK_IMPORTED_MODULE_6__["StructureElement"].Loci(structure, [{
            unit: ref.unit,
            indices: _mol_data_int__WEBPACK_IMPORTED_MODULE_1__["OrderedSet"].ofRange(min, max)
        }]);
}
//# sourceMappingURL=selection.js.map

/***/ }),

/***/ "./lib/mol-plugin-state/manager/volume/hierarchy-state.js":
/*!****************************************************************!*\
  !*** ./lib/mol-plugin-state/manager/volume/hierarchy-state.js ***!
  \****************************************************************/
/*! exports provided: buildVolumeHierarchy, VolumeHierarchy */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "buildVolumeHierarchy", function() { return buildVolumeHierarchy; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "VolumeHierarchy", function() { return VolumeHierarchy; });
/* harmony import */ var _objects__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../objects */ "./lib/mol-plugin-state/objects.js");
/* harmony import */ var _mol_state__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../../mol-state */ "./lib/mol-state/index.js");
/**
 * Copyright (c) 2020 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author David Sehnal <david.sehnal@gmail.com>
 */


function buildVolumeHierarchy(state, previous) {
    var build = BuildState(state, previous || VolumeHierarchy());
    doPreOrder(state.tree, build);
    if (previous)
        previous.refs.forEach(isRemoved, build);
    return { hierarchy: build.hierarchy, added: build.added, changed: build.changed };
}
function VolumeHierarchy() {
    return { volumes: [], refs: new Map() };
}
function VolumeRef(cell) {
    return { kind: 'volume', cell: cell, version: cell.transform.version, representations: [] };
}
function VolumeRepresentationRef(cell, volume) {
    return { kind: 'volume-representation', cell: cell, version: cell.transform.version, volume: volume };
}
function BuildState(state, oldHierarchy) {
    return { state: state, oldHierarchy: oldHierarchy, hierarchy: VolumeHierarchy(), changed: false, added: new Set() };
}
function createOrUpdateRefList(state, cell, list, ctor) {
    var args = [];
    for (var _i = 4; _i < arguments.length; _i++) {
        args[_i - 4] = arguments[_i];
    }
    var ref = ctor.apply(void 0, args);
    list.push(ref);
    state.hierarchy.refs.set(cell.transform.ref, ref);
    var old = state.oldHierarchy.refs.get(cell.transform.ref);
    if (old) {
        if (old.version !== cell.transform.version)
            state.changed = true;
    }
    else {
        state.added.add(ref.cell.transform.ref);
        state.changed = true;
    }
    return ref;
}
function isTypeRoot(t, target) {
    return function (cell, state) { return !target(state) && t.is(cell.obj); };
}
function noop() { }
var Mapping = [
    [isTypeRoot(_objects__WEBPACK_IMPORTED_MODULE_0__["PluginStateObject"].Volume.Data, function (t) { return t.currentVolume; }), function (state, cell) {
            state.currentVolume = createOrUpdateRefList(state, cell, state.hierarchy.volumes, VolumeRef, cell);
        }, function (state) { return state.currentVolume = void 0; }],
    [function (cell, state) {
            return !cell.state.isGhost && !!state.currentVolume && _objects__WEBPACK_IMPORTED_MODULE_0__["PluginStateObject"].Volume.Representation3D.is(cell.obj);
        }, function (state, cell) {
            if (state.currentVolume) {
                createOrUpdateRefList(state, cell, state.currentVolume.representations, VolumeRepresentationRef, cell, state.currentVolume);
            }
            return false;
        }, noop]
];
function isValidCell(cell) {
    if (!cell || !(cell === null || cell === void 0 ? void 0 : cell.parent) || !cell.parent.cells.has(cell.transform.ref))
        return false;
    var obj = cell.obj;
    if (!obj || obj === _mol_state__WEBPACK_IMPORTED_MODULE_1__["StateObject"].Null || (cell.status !== 'ok' && cell.status !== 'error'))
        return false;
    return true;
}
function isRemoved(ref) {
    var cell = ref.cell;
    if (isValidCell(cell))
        return;
    this.changed = true;
}
function _preOrderFunc(c) { _doPreOrder(this, this.tree.transforms.get(c)); }
function _doPreOrder(ctx, root) {
    var state = ctx.state;
    var cell = state.state.cells.get(root.ref);
    if (!isValidCell(cell))
        return;
    var onLeave = void 0;
    var end = false;
    for (var _i = 0, Mapping_1 = Mapping; _i < Mapping_1.length; _i++) {
        var _a = Mapping_1[_i], test_1 = _a[0], f = _a[1], l = _a[2];
        if (test_1(cell, state)) {
            var cont = f(state, cell);
            if (cont === false) {
                end = true;
                break;
            }
            onLeave = l;
            break;
        }
    }
    // TODO: might be needed in the future
    // const { currentComponent, currentModel, currentStructure, currentTrajectory } = ctx.state;
    // const inTrackedSubtree = currentComponent || currentModel || currentStructure || currentTrajectory;
    // if (inTrackedSubtree && cell.transform.transformer.definition.isDecorator) {
    //     const ref = cell.transform.ref;
    //     const old = ctx.state.oldHierarchy.decorators.get(ref);
    //     if (old && old.version !== cell.transform.version) {
    //         ctx.state.changed = true;
    //     }
    //     ctx.state.hierarchy.decorators.set(cell.transform.ref, cell.transform);
    // }
    if (end)
        return;
    var children = ctx.tree.children.get(root.ref);
    if (children && children.size) {
        children.forEach(_preOrderFunc, ctx);
    }
    if (onLeave)
        onLeave(state);
}
function doPreOrder(tree, state) {
    var ctx = { tree: tree, state: state };
    _doPreOrder(ctx, tree.root);
    return ctx.state;
}
//# sourceMappingURL=hierarchy-state.js.map

/***/ }),

/***/ "./lib/mol-plugin-state/manager/volume/hierarchy.js":
/*!**********************************************************!*\
  !*** ./lib/mol-plugin-state/manager/volume/hierarchy.js ***!
  \**********************************************************/
/*! exports provided: VolumeHierarchyManager */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "VolumeHierarchyManager", function() { return VolumeHierarchyManager; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _mol_plugin_behavior_static_state__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../../mol-plugin/behavior/static/state */ "./lib/mol-plugin/behavior/static/state.js");
/* harmony import */ var _component__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../component */ "./lib/mol-plugin-state/component.js");
/* harmony import */ var _hierarchy_state__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./hierarchy-state */ "./lib/mol-plugin-state/manager/volume/hierarchy-state.js");
/* harmony import */ var _helpers_volume_representation_params__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../helpers/volume-representation-params */ "./lib/mol-plugin-state/helpers/volume-representation-params.js");
/* harmony import */ var _transforms__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../transforms */ "./lib/mol-plugin-state/transforms.js");
/**
 * Copyright (c) 2020 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author David Sehnal <david.sehnal@gmail.com>
 */






var VolumeHierarchyManager = /** @class */ (function (_super) {
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__extends"])(VolumeHierarchyManager, _super);
    function VolumeHierarchyManager(plugin) {
        var _this = _super.call(this) || this;
        _this.plugin = plugin;
        _this.state = {
            syncedTree: _this.dataState.tree,
            notified: false,
            hierarchy: Object(_hierarchy_state__WEBPACK_IMPORTED_MODULE_3__["VolumeHierarchy"])(),
            selection: void 0
        };
        _this.behaviors = {
            selection: _this.ev.behavior({
                hierarchy: _this.current,
                volume: _this.selection
            })
        };
        _this.subscribe(plugin.state.data.events.changed, function (e) {
            if (e.inTransaction || plugin.behaviors.state.isAnimating.value)
                return;
            _this.sync(true);
        });
        _this.subscribe(plugin.behaviors.state.isAnimating, function (isAnimating) {
            if (!isAnimating && !plugin.behaviors.state.isUpdating.value)
                _this.sync(true);
        });
        return _this;
    }
    Object.defineProperty(VolumeHierarchyManager.prototype, "dataState", {
        get: function () {
            return this.plugin.state.data;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(VolumeHierarchyManager.prototype, "current", {
        get: function () {
            this.sync(false);
            return this.state.hierarchy;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(VolumeHierarchyManager.prototype, "selection", {
        get: function () {
            this.sync(false);
            return this.state.selection;
        },
        enumerable: false,
        configurable: true
    });
    VolumeHierarchyManager.prototype.sync = function (notify) {
        if (!notify && this.dataState.inUpdate)
            return;
        if (this.state.syncedTree === this.dataState.tree) {
            if (notify && !this.state.notified) {
                this.state.notified = true;
                this.behaviors.selection.next({ hierarchy: this.state.hierarchy, volume: this.state.selection });
            }
            return;
        }
        this.state.syncedTree = this.dataState.tree;
        var update = Object(_hierarchy_state__WEBPACK_IMPORTED_MODULE_3__["buildVolumeHierarchy"])(this.plugin.state.data, this.current);
        if (!update.changed) {
            return;
        }
        var hierarchy = update.hierarchy;
        this.state.hierarchy = hierarchy;
        if (!this.state.selection) {
            this.state.selection = hierarchy.volumes[0];
        }
        else {
            this.state.selection = hierarchy.refs.has(this.state.selection.cell.transform.ref) ? hierarchy.refs.get(this.state.selection.cell.transform.ref) : hierarchy.volumes[0];
        }
        if (notify) {
            this.state.notified = true;
            this.behaviors.selection.next({ hierarchy: hierarchy, volume: this.state.selection });
        }
        else {
            this.state.notified = false;
        }
    };
    VolumeHierarchyManager.prototype.setCurrent = function (volume) {
        this.state.selection = volume || this.state.hierarchy.volumes[0];
        this.behaviors.selection.next({ hierarchy: this.state.hierarchy, volume: volume || this.state.hierarchy.volumes[0] });
    };
    // TODO: have common util
    VolumeHierarchyManager.prototype.remove = function (refs, canUndo) {
        if (refs.length === 0)
            return;
        var deletes = this.plugin.state.data.build();
        for (var _i = 0, refs_1 = refs; _i < refs_1.length; _i++) {
            var r = refs_1[_i];
            deletes.delete(typeof r === 'string' ? r : r.cell.transform.ref);
        }
        return deletes.commit({ canUndo: canUndo ? 'Remove' : false });
    };
    // TODO: have common util
    VolumeHierarchyManager.prototype.toggleVisibility = function (refs, action) {
        if (refs.length === 0)
            return;
        var isHidden = action !== void 0
            ? (action === 'show' ? false : true)
            : !refs[0].cell.state.isHidden;
        for (var _i = 0, refs_2 = refs; _i < refs_2.length; _i++) {
            var c = refs_2[_i];
            Object(_mol_plugin_behavior_static_state__WEBPACK_IMPORTED_MODULE_1__["setSubtreeVisibility"])(this.dataState, c.cell.transform.ref, isHidden);
        }
    };
    VolumeHierarchyManager.prototype.addRepresentation = function (ref, type) {
        var _a;
        var update = this.dataState.build()
            .to(ref.cell)
            .apply(_transforms__WEBPACK_IMPORTED_MODULE_5__["StateTransforms"].Representation.VolumeRepresentation3D, Object(_helpers_volume_representation_params__WEBPACK_IMPORTED_MODULE_4__["createVolumeRepresentationParams"])(this.plugin, (_a = ref.cell.obj) === null || _a === void 0 ? void 0 : _a.data, {
            type: type,
        }));
        return update.commit({ canUndo: 'Add Representation' });
    };
    return VolumeHierarchyManager;
}(_component__WEBPACK_IMPORTED_MODULE_2__["PluginComponent"]));

(function (VolumeHierarchyManager) {
    function getRepresentationTypes(plugin, pivot) {
        var _a, _b;
        return ((_a = pivot === null || pivot === void 0 ? void 0 : pivot.cell.obj) === null || _a === void 0 ? void 0 : _a.data) ? plugin.representation.volume.registry.getApplicableTypes((_b = pivot.cell.obj) === null || _b === void 0 ? void 0 : _b.data)
            : plugin.representation.volume.registry.types;
    }
    VolumeHierarchyManager.getRepresentationTypes = getRepresentationTypes;
})(VolumeHierarchyManager || (VolumeHierarchyManager = {}));
//# sourceMappingURL=hierarchy.js.map

/***/ }),

/***/ "./lib/mol-plugin-state/objects.js":
/*!*****************************************!*\
  !*** ./lib/mol-plugin-state/objects.js ***!
  \*****************************************/
/*! exports provided: PluginStateObject, PluginStateTransform */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "PluginStateObject", function() { return PluginStateObject; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "PluginStateTransform", function() { return PluginStateTransform; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _mol_state__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../mol-state */ "./lib/mol-state/index.js");
/**
 * Copyright (c) 2018-2020 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author David Sehnal <david.sehnal@gmail.com>
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */


var PluginStateObject;
(function (PluginStateObject) {
    PluginStateObject.Create = _mol_state__WEBPACK_IMPORTED_MODULE_1__["StateObject"].factory();
    function isRepresentation3D(o) {
        return !!o && o.type.typeClass === 'Representation3D';
    }
    PluginStateObject.isRepresentation3D = isRepresentation3D;
    function isBehavior(o) {
        return !!o && o.type.typeClass === 'Behavior';
    }
    PluginStateObject.isBehavior = isBehavior;
    function CreateRepresentation3D(type) {
        return PluginStateObject.Create(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, type), { typeClass: 'Representation3D' }));
    }
    PluginStateObject.CreateRepresentation3D = CreateRepresentation3D;
    function CreateBehavior(type) {
        return PluginStateObject.Create(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, type), { typeClass: 'Behavior' }));
    }
    PluginStateObject.CreateBehavior = CreateBehavior;
    var Root = /** @class */ (function (_super) {
        Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__extends"])(Root, _super);
        function Root() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        return Root;
    }(PluginStateObject.Create({ name: 'Root', typeClass: 'Root' })));
    PluginStateObject.Root = Root;
    var Group = /** @class */ (function (_super) {
        Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__extends"])(Group, _super);
        function Group() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        return Group;
    }(PluginStateObject.Create({ name: 'Group', typeClass: 'Group' })));
    PluginStateObject.Group = Group;
    var Data;
    (function (Data) {
        var String = /** @class */ (function (_super) {
            Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__extends"])(String, _super);
            function String() {
                return _super !== null && _super.apply(this, arguments) || this;
            }
            return String;
        }(PluginStateObject.Create({ name: 'String Data', typeClass: 'Data', })));
        Data.String = String;
        var Binary = /** @class */ (function (_super) {
            Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__extends"])(Binary, _super);
            function Binary() {
                return _super !== null && _super.apply(this, arguments) || this;
            }
            return Binary;
        }(PluginStateObject.Create({ name: 'Binary Data', typeClass: 'Data' })));
        Data.Binary = Binary;
        var Blob = /** @class */ (function (_super) {
            Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__extends"])(Blob, _super);
            function Blob() {
                return _super !== null && _super.apply(this, arguments) || this;
            }
            return Blob;
        }(PluginStateObject.Create({ name: 'Data Blob', typeClass: 'Data' })));
        Data.Blob = Blob;
    })(Data = PluginStateObject.Data || (PluginStateObject.Data = {}));
    var Format;
    (function (Format) {
        var Json = /** @class */ (function (_super) {
            Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__extends"])(Json, _super);
            function Json() {
                return _super !== null && _super.apply(this, arguments) || this;
            }
            return Json;
        }(PluginStateObject.Create({ name: 'JSON Data', typeClass: 'Data' })));
        Format.Json = Json;
        var Cif = /** @class */ (function (_super) {
            Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__extends"])(Cif, _super);
            function Cif() {
                return _super !== null && _super.apply(this, arguments) || this;
            }
            return Cif;
        }(PluginStateObject.Create({ name: 'CIF File', typeClass: 'Data' })));
        Format.Cif = Cif;
        var Cube = /** @class */ (function (_super) {
            Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__extends"])(Cube, _super);
            function Cube() {
                return _super !== null && _super.apply(this, arguments) || this;
            }
            return Cube;
        }(PluginStateObject.Create({ name: 'Cube File', typeClass: 'Data' })));
        Format.Cube = Cube;
        var Psf = /** @class */ (function (_super) {
            Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__extends"])(Psf, _super);
            function Psf() {
                return _super !== null && _super.apply(this, arguments) || this;
            }
            return Psf;
        }(PluginStateObject.Create({ name: 'PSF File', typeClass: 'Data' })));
        Format.Psf = Psf;
        var Ply = /** @class */ (function (_super) {
            Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__extends"])(Ply, _super);
            function Ply() {
                return _super !== null && _super.apply(this, arguments) || this;
            }
            return Ply;
        }(PluginStateObject.Create({ name: 'PLY File', typeClass: 'Data' })));
        Format.Ply = Ply;
        var Ccp4 = /** @class */ (function (_super) {
            Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__extends"])(Ccp4, _super);
            function Ccp4() {
                return _super !== null && _super.apply(this, arguments) || this;
            }
            return Ccp4;
        }(PluginStateObject.Create({ name: 'CCP4/MRC/MAP File', typeClass: 'Data' })));
        Format.Ccp4 = Ccp4;
        var Dsn6 = /** @class */ (function (_super) {
            Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__extends"])(Dsn6, _super);
            function Dsn6() {
                return _super !== null && _super.apply(this, arguments) || this;
            }
            return Dsn6;
        }(PluginStateObject.Create({ name: 'DSN6/BRIX File', typeClass: 'Data' })));
        Format.Dsn6 = Dsn6;
        var Dx = /** @class */ (function (_super) {
            Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__extends"])(Dx, _super);
            function Dx() {
                return _super !== null && _super.apply(this, arguments) || this;
            }
            return Dx;
        }(PluginStateObject.Create({ name: 'DX File', typeClass: 'Data' })));
        Format.Dx = Dx;
        var Blob = /** @class */ (function (_super) {
            Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__extends"])(Blob, _super);
            function Blob() {
                return _super !== null && _super.apply(this, arguments) || this;
            }
            return Blob;
        }(PluginStateObject.Create({ name: 'Format Blob', typeClass: 'Data' })));
        Format.Blob = Blob;
    })(Format = PluginStateObject.Format || (PluginStateObject.Format = {}));
    var Molecule;
    (function (Molecule) {
        var Coordinates = /** @class */ (function (_super) {
            Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__extends"])(Coordinates, _super);
            function Coordinates() {
                return _super !== null && _super.apply(this, arguments) || this;
            }
            return Coordinates;
        }(PluginStateObject.Create({ name: 'Coordinates', typeClass: 'Object' })));
        Molecule.Coordinates = Coordinates;
        var Topology = /** @class */ (function (_super) {
            Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__extends"])(Topology, _super);
            function Topology() {
                return _super !== null && _super.apply(this, arguments) || this;
            }
            return Topology;
        }(PluginStateObject.Create({ name: 'Topology', typeClass: 'Object' })));
        Molecule.Topology = Topology;
        var Model = /** @class */ (function (_super) {
            Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__extends"])(Model, _super);
            function Model() {
                return _super !== null && _super.apply(this, arguments) || this;
            }
            return Model;
        }(PluginStateObject.Create({ name: 'Model', typeClass: 'Object' })));
        Molecule.Model = Model;
        var Trajectory = /** @class */ (function (_super) {
            Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__extends"])(Trajectory, _super);
            function Trajectory() {
                return _super !== null && _super.apply(this, arguments) || this;
            }
            return Trajectory;
        }(PluginStateObject.Create({ name: 'Trajectory', typeClass: 'Object' })));
        Molecule.Trajectory = Trajectory;
        var Structure = /** @class */ (function (_super) {
            Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__extends"])(Structure, _super);
            function Structure() {
                return _super !== null && _super.apply(this, arguments) || this;
            }
            return Structure;
        }(PluginStateObject.Create({ name: 'Structure', typeClass: 'Object' })));
        Molecule.Structure = Structure;
        (function (Structure) {
            var Representation3D = /** @class */ (function (_super) {
                Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__extends"])(Representation3D, _super);
                function Representation3D() {
                    return _super !== null && _super.apply(this, arguments) || this;
                }
                return Representation3D;
            }(CreateRepresentation3D({ name: 'Structure 3D' })));
            Structure.Representation3D = Representation3D;
            var Representation3DState = /** @class */ (function (_super) {
                Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__extends"])(Representation3DState, _super);
                function Representation3DState() {
                    return _super !== null && _super.apply(this, arguments) || this;
                }
                return Representation3DState;
            }(PluginStateObject.Create({ name: 'Structure 3D State', typeClass: 'Object' })));
            Structure.Representation3DState = Representation3DState;
            var Selections = /** @class */ (function (_super) {
                Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__extends"])(Selections, _super);
                function Selections() {
                    return _super !== null && _super.apply(this, arguments) || this;
                }
                return Selections;
            }(PluginStateObject.Create({ name: 'Selections', typeClass: 'Object' })));
            Structure.Selections = Selections;
        })(Structure = Molecule.Structure || (Molecule.Structure = {}));
    })(Molecule = PluginStateObject.Molecule || (PluginStateObject.Molecule = {}));
    var Volume;
    (function (Volume) {
        var Data = /** @class */ (function (_super) {
            Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__extends"])(Data, _super);
            function Data() {
                return _super !== null && _super.apply(this, arguments) || this;
            }
            return Data;
        }(PluginStateObject.Create({ name: 'Volume', typeClass: 'Object' })));
        Volume.Data = Data;
        var Representation3D = /** @class */ (function (_super) {
            Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__extends"])(Representation3D, _super);
            function Representation3D() {
                return _super !== null && _super.apply(this, arguments) || this;
            }
            return Representation3D;
        }(CreateRepresentation3D({ name: 'Volume 3D' })));
        Volume.Representation3D = Representation3D;
    })(Volume = PluginStateObject.Volume || (PluginStateObject.Volume = {}));
    var Shape;
    (function (Shape) {
        var Provider = /** @class */ (function (_super) {
            Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__extends"])(Provider, _super);
            function Provider() {
                return _super !== null && _super.apply(this, arguments) || this;
            }
            return Provider;
        }(PluginStateObject.Create({ name: 'Shape Provider', typeClass: 'Object' })));
        Shape.Provider = Provider;
        var Representation3D = /** @class */ (function (_super) {
            Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__extends"])(Representation3D, _super);
            function Representation3D() {
                return _super !== null && _super.apply(this, arguments) || this;
            }
            return Representation3D;
        }(CreateRepresentation3D({ name: 'Shape 3D' })));
        Shape.Representation3D = Representation3D;
    })(Shape = PluginStateObject.Shape || (PluginStateObject.Shape = {}));
})(PluginStateObject || (PluginStateObject = {}));
var PluginStateTransform;
(function (PluginStateTransform) {
    PluginStateTransform.CreateBuiltIn = _mol_state__WEBPACK_IMPORTED_MODULE_1__["StateTransformer"].factory('ms-plugin');
    PluginStateTransform.BuiltIn = _mol_state__WEBPACK_IMPORTED_MODULE_1__["StateTransformer"].builderFactory('ms-plugin');
})(PluginStateTransform || (PluginStateTransform = {}));
//# sourceMappingURL=objects.js.map

/***/ }),

/***/ "./lib/mol-plugin-state/transforms.js":
/*!********************************************!*\
  !*** ./lib/mol-plugin-state/transforms.js ***!
  \********************************************/
/*! exports provided: StateTransforms */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "StateTransforms", function() { return StateTransforms; });
/* harmony import */ var _transforms_data__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./transforms/data */ "./lib/mol-plugin-state/transforms/data.js");
/* harmony import */ var _transforms_misc__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./transforms/misc */ "./lib/mol-plugin-state/transforms/misc.js");
/* harmony import */ var _transforms_model__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./transforms/model */ "./lib/mol-plugin-state/transforms/model.js");
/* harmony import */ var _transforms_volume__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./transforms/volume */ "./lib/mol-plugin-state/transforms/volume.js");
/* harmony import */ var _transforms_representation__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./transforms/representation */ "./lib/mol-plugin-state/transforms/representation.js");
/**
 * Copyright (c) 2018 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author David Sehnal <david.sehnal@gmail.com>
 */





var StateTransforms = {
    Data: _transforms_data__WEBPACK_IMPORTED_MODULE_0__,
    Misc: _transforms_misc__WEBPACK_IMPORTED_MODULE_1__,
    Model: _transforms_model__WEBPACK_IMPORTED_MODULE_2__,
    Volume: _transforms_volume__WEBPACK_IMPORTED_MODULE_3__,
    Representation: _transforms_representation__WEBPACK_IMPORTED_MODULE_4__
};
//# sourceMappingURL=transforms.js.map

/***/ }),

/***/ "./lib/mol-plugin-state/transforms/data.js":
/*!*************************************************!*\
  !*** ./lib/mol-plugin-state/transforms/data.js ***!
  \*************************************************/
/*! exports provided: Download, DownloadBlob, RawData, ReadFile, ParseBlob, ParseCif, ParseCube, ParsePsf, ParsePly, ParseCcp4, ParseDsn6, ParseDx, ImportString, ImportJson, ParseJson */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Download", function() { return Download; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DownloadBlob", function() { return DownloadBlob; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "RawData", function() { return RawData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ReadFile", function() { return ReadFile; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ParseBlob", function() { return ParseBlob; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ParseCif", function() { return ParseCif; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ParseCube", function() { return ParseCube; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ParsePsf", function() { return ParsePsf; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ParsePly", function() { return ParsePly; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ParseCcp4", function() { return ParseCcp4; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ParseDsn6", function() { return ParseDsn6; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ParseDx", function() { return ParseDx; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ImportString", function() { return ImportString; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ImportJson", function() { return ImportJson; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ParseJson", function() { return ParseJson; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _mol_io_reader_ccp4_parser__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../mol-io/reader/ccp4/parser */ "./lib/mol-io/reader/ccp4/parser.js");
/* harmony import */ var _mol_io_reader_cif__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../mol-io/reader/cif */ "./lib/mol-io/reader/cif.js");
/* harmony import */ var _mol_io_reader_dsn6_parser__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../mol-io/reader/dsn6/parser */ "./lib/mol-io/reader/dsn6/parser.js");
/* harmony import */ var _mol_io_reader_ply_parser__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../mol-io/reader/ply/parser */ "./lib/mol-io/reader/ply/parser.js");
/* harmony import */ var _mol_io_reader_psf_parser__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../mol-io/reader/psf/parser */ "./lib/mol-io/reader/psf/parser.js");
/* harmony import */ var _mol_state__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../../mol-state */ "./lib/mol-state/index.js");
/* harmony import */ var _mol_task__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../../mol-task */ "./lib/mol-task/index.js");
/* harmony import */ var _mol_util_data_source__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ../../mol-util/data-source */ "./lib/mol-util/data-source.js");
/* harmony import */ var _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ../../mol-util/param-definition */ "./lib/mol-util/param-definition.js");
/* harmony import */ var _objects__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ../objects */ "./lib/mol-plugin-state/objects.js");
/* harmony import */ var _mol_util_assets__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ../../mol-util/assets */ "./lib/mol-util/assets.js");
/* harmony import */ var _mol_io_reader_cube_parser__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! ../../mol-io/reader/cube/parser */ "./lib/mol-io/reader/cube/parser.js");
/* harmony import */ var _mol_io_reader_dx_parser__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! ../../mol-io/reader/dx/parser */ "./lib/mol-io/reader/dx/parser.js");
/**
 * Copyright (c) 2018-2020 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author David Sehnal <david.sehnal@gmail.com>
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */





























var Download = _objects__WEBPACK_IMPORTED_MODULE_10__["PluginStateTransform"].BuiltIn({
    name: 'download',
    display: { name: 'Download', description: 'Download string or binary data from the specified URL' },
    from: [_objects__WEBPACK_IMPORTED_MODULE_10__["PluginStateObject"].Root],
    to: [_objects__WEBPACK_IMPORTED_MODULE_10__["PluginStateObject"].Data.String, _objects__WEBPACK_IMPORTED_MODULE_10__["PluginStateObject"].Data.Binary],
    params: {
        url: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_9__["ParamDefinition"].Url('https://www.ebi.ac.uk/pdbe/static/entry/1cbs_updated.cif', { description: 'Resource URL. Must be the same domain or support CORS.' }),
        label: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_9__["ParamDefinition"].Optional(_mol_util_param_definition__WEBPACK_IMPORTED_MODULE_9__["ParamDefinition"].Text('')),
        isBinary: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_9__["ParamDefinition"].Optional(_mol_util_param_definition__WEBPACK_IMPORTED_MODULE_9__["ParamDefinition"].Boolean(false, { description: 'If true, download data as binary (string otherwise)' }))
    }
})({
    apply: function (_a, plugin) {
        var _this = this;
        var p = _a.params, cache = _a.cache;
        return _mol_task__WEBPACK_IMPORTED_MODULE_7__["Task"].create('Download', function (ctx) { return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"])(_this, void 0, void 0, function () {
            var url, asset;
            return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__generator"])(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = _mol_util_assets__WEBPACK_IMPORTED_MODULE_11__["Asset"].getUrlAsset(plugin.managers.asset, p.url);
                        return [4 /*yield*/, plugin.managers.asset.resolve(url, p.isBinary ? 'binary' : 'string').runInContext(ctx)];
                    case 1:
                        asset = _a.sent();
                        cache.asset = asset;
                        return [2 /*return*/, p.isBinary
                                ? new _objects__WEBPACK_IMPORTED_MODULE_10__["PluginStateObject"].Data.Binary(asset.data, { label: p.label ? p.label : url.url })
                                : new _objects__WEBPACK_IMPORTED_MODULE_10__["PluginStateObject"].Data.String(asset.data, { label: p.label ? p.label : url.url })];
                }
            });
        }); });
    },
    dispose: function (_a) {
        var _b, _c;
        var cache = _a.cache;
        (_c = (_b = cache) === null || _b === void 0 ? void 0 : _b.asset) === null || _c === void 0 ? void 0 : _c.dispose();
    },
    update: function (_a) {
        var oldParams = _a.oldParams, newParams = _a.newParams, b = _a.b;
        if (oldParams.url !== newParams.url || oldParams.isBinary !== newParams.isBinary)
            return _mol_state__WEBPACK_IMPORTED_MODULE_6__["StateTransformer"].UpdateResult.Recreate;
        if (oldParams.label !== newParams.label) {
            b.label = newParams.label || ((typeof newParams.url === 'string') ? newParams.url : newParams.url.url);
            return _mol_state__WEBPACK_IMPORTED_MODULE_6__["StateTransformer"].UpdateResult.Updated;
        }
        return _mol_state__WEBPACK_IMPORTED_MODULE_6__["StateTransformer"].UpdateResult.Unchanged;
    }
});
var DownloadBlob = _objects__WEBPACK_IMPORTED_MODULE_10__["PluginStateTransform"].BuiltIn({
    name: 'download-blob',
    display: { name: 'Download Blob', description: 'Download multiple string or binary data from the specified URLs.' },
    from: _objects__WEBPACK_IMPORTED_MODULE_10__["PluginStateObject"].Root,
    to: _objects__WEBPACK_IMPORTED_MODULE_10__["PluginStateObject"].Data.Blob,
    params: {
        sources: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_9__["ParamDefinition"].ObjectList({
            id: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_9__["ParamDefinition"].Text('', { label: 'Unique ID' }),
            url: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_9__["ParamDefinition"].Url('https://www.ebi.ac.uk/pdbe/static/entry/1cbs_updated.cif', { description: 'Resource URL. Must be the same domain or support CORS.' }),
            isBinary: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_9__["ParamDefinition"].Optional(_mol_util_param_definition__WEBPACK_IMPORTED_MODULE_9__["ParamDefinition"].Boolean(false, { description: 'If true, download data as binary (string otherwise)' })),
            canFail: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_9__["ParamDefinition"].Optional(_mol_util_param_definition__WEBPACK_IMPORTED_MODULE_9__["ParamDefinition"].Boolean(false, { description: 'Indicate whether the download can fail and not be included in the blob as a result.' }))
        }, function (e) { return e.id + ": " + e.url; }),
        maxConcurrency: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_9__["ParamDefinition"].Optional(_mol_util_param_definition__WEBPACK_IMPORTED_MODULE_9__["ParamDefinition"].Numeric(4, { min: 1, max: 12, step: 1 }, { description: 'The maximum number of concurrent downloads.' }))
    }
})({
    apply: function (_a, plugin) {
        var _this = this;
        var params = _a.params, cache = _a.cache;
        return _mol_task__WEBPACK_IMPORTED_MODULE_7__["Task"].create('Download Blob', function (ctx) { return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"])(_this, void 0, void 0, function () {
            var entries, data, assets, i, r, src;
            return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__generator"])(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        entries = [];
                        return [4 /*yield*/, Object(_mol_util_data_source__WEBPACK_IMPORTED_MODULE_8__["ajaxGetMany"])(ctx, plugin.managers.asset, params.sources, params.maxConcurrency || 4)];
                    case 1:
                        data = _a.sent();
                        assets = [];
                        for (i = 0; i < data.length; i++) {
                            r = data[i], src = params.sources[i];
                            if (r.kind === 'error')
                                plugin.log.warn("Download " + r.id + " (" + src.url + ") failed: " + r.error);
                            else {
                                assets.push(r.result);
                                entries.push(src.isBinary
                                    ? { id: r.id, kind: 'binary', data: r.result.data }
                                    : { id: r.id, kind: 'string', data: r.result.data });
                            }
                        }
                        cache.assets = assets;
                        return [2 /*return*/, new _objects__WEBPACK_IMPORTED_MODULE_10__["PluginStateObject"].Data.Blob(entries, { label: 'Data Blob', description: entries.length + " " + (entries.length === 1 ? 'entry' : 'entries') })];
                }
            });
        }); });
    },
    dispose: function (_a, plugin) {
        var _b;
        var cache = _a.cache;
        var assets = (_b = cache) === null || _b === void 0 ? void 0 : _b.assets;
        if (!assets)
            return;
        for (var _c = 0, assets_1 = assets; _c < assets_1.length; _c++) {
            var a = assets_1[_c];
            a.dispose();
        }
    }
    // TODO: ??
    // update({ oldParams, newParams, b }) {
    //     return 0 as any;
    //     // if (oldParams.url !== newParams.url || oldParams.isBinary !== newParams.isBinary) return StateTransformer.UpdateResult.Recreate;
    //     // if (oldParams.label !== newParams.label) {
    //     //     (b.label as string) = newParams.label || newParams.url;
    //     //     return StateTransformer.UpdateResult.Updated;
    //     // }
    //     // return StateTransformer.UpdateResult.Unchanged;
    // }
});
var RawData = _objects__WEBPACK_IMPORTED_MODULE_10__["PluginStateTransform"].BuiltIn({
    name: 'raw-data',
    display: { name: 'Raw Data', description: 'Raw data supplied by value.' },
    from: [_objects__WEBPACK_IMPORTED_MODULE_10__["PluginStateObject"].Root],
    to: [_objects__WEBPACK_IMPORTED_MODULE_10__["PluginStateObject"].Data.String, _objects__WEBPACK_IMPORTED_MODULE_10__["PluginStateObject"].Data.Binary],
    params: {
        data: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_9__["ParamDefinition"].Value('', { isHidden: true }),
        label: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_9__["ParamDefinition"].Optional(_mol_util_param_definition__WEBPACK_IMPORTED_MODULE_9__["ParamDefinition"].Text(''))
    }
})({
    apply: function (_a) {
        var _this = this;
        var p = _a.params;
        return _mol_task__WEBPACK_IMPORTED_MODULE_7__["Task"].create('Raw Data', function () { return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"])(_this, void 0, void 0, function () {
            return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__generator"])(this, function (_a) {
                if (typeof p.data === 'string') {
                    return [2 /*return*/, new _objects__WEBPACK_IMPORTED_MODULE_10__["PluginStateObject"].Data.String(p.data, { label: p.label ? p.label : 'String' })];
                }
                else if (Array.isArray(p.data)) {
                    return [2 /*return*/, new _objects__WEBPACK_IMPORTED_MODULE_10__["PluginStateObject"].Data.Binary(new Uint8Array(p.data), { label: p.label ? p.label : 'Binary' })];
                }
                else if (p.data instanceof ArrayBuffer) {
                    return [2 /*return*/, new _objects__WEBPACK_IMPORTED_MODULE_10__["PluginStateObject"].Data.Binary(new Uint8Array(p.data), { label: p.label ? p.label : 'Binary' })];
                }
                else if (p.data instanceof Uint8Array) {
                    return [2 /*return*/, new _objects__WEBPACK_IMPORTED_MODULE_10__["PluginStateObject"].Data.Binary(p.data, { label: p.label ? p.label : 'Binary' })];
                }
                else {
                    throw new Error('Supplied binary data must be a plain array, ArrayBuffer, or Uint8Array.');
                }
                return [2 /*return*/];
            });
        }); });
    },
    update: function (_a) {
        var oldParams = _a.oldParams, newParams = _a.newParams, b = _a.b;
        if (oldParams.data !== newParams.data)
            return _mol_state__WEBPACK_IMPORTED_MODULE_6__["StateTransformer"].UpdateResult.Recreate;
        if (oldParams.label !== newParams.label) {
            b.label = newParams.label || b.label;
            return _mol_state__WEBPACK_IMPORTED_MODULE_6__["StateTransformer"].UpdateResult.Updated;
        }
        return _mol_state__WEBPACK_IMPORTED_MODULE_6__["StateTransformer"].UpdateResult.Unchanged;
    },
    customSerialization: {
        toJSON: function (p) {
            if (typeof p.data === 'string' || Array.isArray(p.data)) {
                return p;
            }
            else if (p.data instanceof ArrayBuffer) {
                var v = new Uint8Array(p.data);
                var data = new Array(v.length);
                for (var i = 0, _i = v.length; i < _i; i++)
                    data[i] = v[i];
                return { data: data, label: p.label };
            }
            else if (p.data instanceof Uint8Array) {
                var data = new Array(p.data.length);
                for (var i = 0, _i = p.data.length; i < _i; i++)
                    data[i] = p.data[i];
                return { data: data, label: p.label };
            }
        },
        fromJSON: function (data) {
            return data;
        }
    }
});
var ReadFile = _objects__WEBPACK_IMPORTED_MODULE_10__["PluginStateTransform"].BuiltIn({
    name: 'read-file',
    display: { name: 'Read File', description: 'Read string or binary data from the specified file' },
    from: _objects__WEBPACK_IMPORTED_MODULE_10__["PluginStateObject"].Root,
    to: [_objects__WEBPACK_IMPORTED_MODULE_10__["PluginStateObject"].Data.String, _objects__WEBPACK_IMPORTED_MODULE_10__["PluginStateObject"].Data.Binary],
    params: {
        file: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_9__["ParamDefinition"].File(),
        label: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_9__["ParamDefinition"].Optional(_mol_util_param_definition__WEBPACK_IMPORTED_MODULE_9__["ParamDefinition"].Text('')),
        isBinary: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_9__["ParamDefinition"].Optional(_mol_util_param_definition__WEBPACK_IMPORTED_MODULE_9__["ParamDefinition"].Boolean(false, { description: 'If true, open file as as binary (string otherwise)' }))
    }
})({
    apply: function (_a, plugin) {
        var _this = this;
        var p = _a.params, cache = _a.cache;
        return _mol_task__WEBPACK_IMPORTED_MODULE_7__["Task"].create('Open File', function (ctx) { return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"])(_this, void 0, void 0, function () {
            var asset, o;
            return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__generator"])(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (p.file === null) {
                            plugin.log.error('No file(s) selected');
                            return [2 /*return*/, _mol_state__WEBPACK_IMPORTED_MODULE_6__["StateObject"].Null];
                        }
                        return [4 /*yield*/, plugin.managers.asset.resolve(p.file, p.isBinary ? 'binary' : 'string').runInContext(ctx)];
                    case 1:
                        asset = _a.sent();
                        cache.asset = asset;
                        o = p.isBinary
                            ? new _objects__WEBPACK_IMPORTED_MODULE_10__["PluginStateObject"].Data.Binary(asset.data, { label: p.label ? p.label : p.file.name })
                            : new _objects__WEBPACK_IMPORTED_MODULE_10__["PluginStateObject"].Data.String(asset.data, { label: p.label ? p.label : p.file.name });
                        return [2 /*return*/, o];
                }
            });
        }); });
    },
    dispose: function (_a) {
        var _b, _c;
        var cache = _a.cache;
        (_c = (_b = cache) === null || _b === void 0 ? void 0 : _b.asset) === null || _c === void 0 ? void 0 : _c.dispose();
    },
    update: function (_a) {
        var _b;
        var oldParams = _a.oldParams, newParams = _a.newParams, b = _a.b;
        if (oldParams.label !== newParams.label) {
            b.label = newParams.label || ((_b = oldParams.file) === null || _b === void 0 ? void 0 : _b.name) || '';
            return _mol_state__WEBPACK_IMPORTED_MODULE_6__["StateTransformer"].UpdateResult.Updated;
        }
        return _mol_state__WEBPACK_IMPORTED_MODULE_6__["StateTransformer"].UpdateResult.Unchanged;
    },
    isSerializable: function () { return ({ isSerializable: false, reason: 'Cannot serialize user loaded files.' }); }
});
var ParseBlob = _objects__WEBPACK_IMPORTED_MODULE_10__["PluginStateTransform"].BuiltIn({
    name: 'parse-blob',
    display: { name: 'Parse Blob', description: 'Parse multiple data enties' },
    from: _objects__WEBPACK_IMPORTED_MODULE_10__["PluginStateObject"].Data.Blob,
    to: _objects__WEBPACK_IMPORTED_MODULE_10__["PluginStateObject"].Format.Blob,
    params: {
        formats: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_9__["ParamDefinition"].ObjectList({
            id: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_9__["ParamDefinition"].Text('', { label: 'Unique ID' }),
            format: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_9__["ParamDefinition"].Select('cif', [['cif', 'cif']])
        }, function (e) { return e.id + ": " + e.format; })
    }
})({
    apply: function (_a, plugin) {
        var _this = this;
        var a = _a.a, params = _a.params;
        return _mol_task__WEBPACK_IMPORTED_MODULE_7__["Task"].create('Parse Blob', function (ctx) { return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"])(_this, void 0, void 0, function () {
            var map, _a, _b, f, entries, _c, _d, e, parsed;
            return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__generator"])(this, function (_e) {
                switch (_e.label) {
                    case 0:
                        map = new Map();
                        for (_a = 0, _b = params.formats; _a < _b.length; _a++) {
                            f = _b[_a];
                            map.set(f.id, f.format);
                        }
                        entries = [];
                        _c = 0, _d = a.data;
                        _e.label = 1;
                    case 1:
                        if (!(_c < _d.length)) return [3 /*break*/, 4];
                        e = _d[_c];
                        if (!map.has(e.id))
                            return [3 /*break*/, 3];
                        return [4 /*yield*/, (e.kind === 'string' ? _mol_io_reader_cif__WEBPACK_IMPORTED_MODULE_2__["CIF"].parse(e.data) : _mol_io_reader_cif__WEBPACK_IMPORTED_MODULE_2__["CIF"].parseBinary(e.data)).runInContext(ctx)];
                    case 2:
                        parsed = _e.sent();
                        if (parsed.isError)
                            throw new Error(e.id + ": " + parsed.message);
                        entries.push({ id: e.id, kind: 'cif', data: parsed.result });
                        _e.label = 3;
                    case 3:
                        _c++;
                        return [3 /*break*/, 1];
                    case 4: return [2 /*return*/, new _objects__WEBPACK_IMPORTED_MODULE_10__["PluginStateObject"].Format.Blob(entries, { label: 'Format Blob', description: entries.length + " " + (entries.length === 1 ? 'entry' : 'entries') })];
                }
            });
        }); });
    },
});
var ParseCif = _objects__WEBPACK_IMPORTED_MODULE_10__["PluginStateTransform"].BuiltIn({
    name: 'parse-cif',
    display: { name: 'Parse CIF', description: 'Parse CIF from String or Binary data' },
    from: [_objects__WEBPACK_IMPORTED_MODULE_10__["PluginStateObject"].Data.String, _objects__WEBPACK_IMPORTED_MODULE_10__["PluginStateObject"].Data.Binary],
    to: _objects__WEBPACK_IMPORTED_MODULE_10__["PluginStateObject"].Format.Cif
})({
    apply: function (_a) {
        var _this = this;
        var a = _a.a;
        return _mol_task__WEBPACK_IMPORTED_MODULE_7__["Task"].create('Parse CIF', function (ctx) { return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"])(_this, void 0, void 0, function () {
            var parsed;
            return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__generator"])(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, (_objects__WEBPACK_IMPORTED_MODULE_10__["PluginStateObject"].Data.String.is(a) ? _mol_io_reader_cif__WEBPACK_IMPORTED_MODULE_2__["CIF"].parse(a.data) : _mol_io_reader_cif__WEBPACK_IMPORTED_MODULE_2__["CIF"].parseBinary(a.data)).runInContext(ctx)];
                    case 1:
                        parsed = _a.sent();
                        if (parsed.isError)
                            throw new Error(parsed.message);
                        return [2 /*return*/, new _objects__WEBPACK_IMPORTED_MODULE_10__["PluginStateObject"].Format.Cif(parsed.result)];
                }
            });
        }); });
    }
});
var ParseCube = _objects__WEBPACK_IMPORTED_MODULE_10__["PluginStateTransform"].BuiltIn({
    name: 'parse-cube',
    display: { name: 'Parse Cube', description: 'Parse Cube from String data' },
    from: _objects__WEBPACK_IMPORTED_MODULE_10__["PluginStateObject"].Data.String,
    to: _objects__WEBPACK_IMPORTED_MODULE_10__["PluginStateObject"].Format.Cube
})({
    apply: function (_a) {
        var _this = this;
        var a = _a.a;
        return _mol_task__WEBPACK_IMPORTED_MODULE_7__["Task"].create('Parse Cube', function (ctx) { return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"])(_this, void 0, void 0, function () {
            var parsed;
            return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__generator"])(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, Object(_mol_io_reader_cube_parser__WEBPACK_IMPORTED_MODULE_12__["parseCube"])(a.data, a.label).runInContext(ctx)];
                    case 1:
                        parsed = _a.sent();
                        if (parsed.isError)
                            throw new Error(parsed.message);
                        return [2 /*return*/, new _objects__WEBPACK_IMPORTED_MODULE_10__["PluginStateObject"].Format.Cube(parsed.result)];
                }
            });
        }); });
    }
});
var ParsePsf = _objects__WEBPACK_IMPORTED_MODULE_10__["PluginStateTransform"].BuiltIn({
    name: 'parse-psf',
    display: { name: 'Parse PSF', description: 'Parse PSF from String data' },
    from: [_objects__WEBPACK_IMPORTED_MODULE_10__["PluginStateObject"].Data.String],
    to: _objects__WEBPACK_IMPORTED_MODULE_10__["PluginStateObject"].Format.Psf
})({
    apply: function (_a) {
        var _this = this;
        var a = _a.a;
        return _mol_task__WEBPACK_IMPORTED_MODULE_7__["Task"].create('Parse PSF', function (ctx) { return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"])(_this, void 0, void 0, function () {
            var parsed;
            return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__generator"])(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, Object(_mol_io_reader_psf_parser__WEBPACK_IMPORTED_MODULE_5__["parsePsf"])(a.data).runInContext(ctx)];
                    case 1:
                        parsed = _a.sent();
                        if (parsed.isError)
                            throw new Error(parsed.message);
                        return [2 /*return*/, new _objects__WEBPACK_IMPORTED_MODULE_10__["PluginStateObject"].Format.Psf(parsed.result)];
                }
            });
        }); });
    }
});
var ParsePly = _objects__WEBPACK_IMPORTED_MODULE_10__["PluginStateTransform"].BuiltIn({
    name: 'parse-ply',
    display: { name: 'Parse PLY', description: 'Parse PLY from String data' },
    from: [_objects__WEBPACK_IMPORTED_MODULE_10__["PluginStateObject"].Data.String],
    to: _objects__WEBPACK_IMPORTED_MODULE_10__["PluginStateObject"].Format.Ply
})({
    apply: function (_a) {
        var _this = this;
        var a = _a.a;
        return _mol_task__WEBPACK_IMPORTED_MODULE_7__["Task"].create('Parse PLY', function (ctx) { return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"])(_this, void 0, void 0, function () {
            var parsed;
            return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__generator"])(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, _mol_io_reader_ply_parser__WEBPACK_IMPORTED_MODULE_4__["parse"](a.data).runInContext(ctx)];
                    case 1:
                        parsed = _a.sent();
                        if (parsed.isError)
                            throw new Error(parsed.message);
                        return [2 /*return*/, new _objects__WEBPACK_IMPORTED_MODULE_10__["PluginStateObject"].Format.Ply(parsed.result, { label: parsed.result.comments[0] || 'PLY Data' })];
                }
            });
        }); });
    }
});
var ParseCcp4 = _objects__WEBPACK_IMPORTED_MODULE_10__["PluginStateTransform"].BuiltIn({
    name: 'parse-ccp4',
    display: { name: 'Parse CCP4/MRC/MAP', description: 'Parse CCP4/MRC/MAP from Binary data' },
    from: [_objects__WEBPACK_IMPORTED_MODULE_10__["PluginStateObject"].Data.Binary],
    to: _objects__WEBPACK_IMPORTED_MODULE_10__["PluginStateObject"].Format.Ccp4
})({
    apply: function (_a) {
        var _this = this;
        var a = _a.a;
        return _mol_task__WEBPACK_IMPORTED_MODULE_7__["Task"].create('Parse CCP4/MRC/MAP', function (ctx) { return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"])(_this, void 0, void 0, function () {
            var parsed;
            return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__generator"])(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, _mol_io_reader_ccp4_parser__WEBPACK_IMPORTED_MODULE_1__["parse"](a.data, a.label).runInContext(ctx)];
                    case 1:
                        parsed = _a.sent();
                        if (parsed.isError)
                            throw new Error(parsed.message);
                        return [2 /*return*/, new _objects__WEBPACK_IMPORTED_MODULE_10__["PluginStateObject"].Format.Ccp4(parsed.result)];
                }
            });
        }); });
    }
});
var ParseDsn6 = _objects__WEBPACK_IMPORTED_MODULE_10__["PluginStateTransform"].BuiltIn({
    name: 'parse-dsn6',
    display: { name: 'Parse DSN6/BRIX', description: 'Parse CCP4/BRIX from Binary data' },
    from: [_objects__WEBPACK_IMPORTED_MODULE_10__["PluginStateObject"].Data.Binary],
    to: _objects__WEBPACK_IMPORTED_MODULE_10__["PluginStateObject"].Format.Dsn6
})({
    apply: function (_a) {
        var _this = this;
        var a = _a.a;
        return _mol_task__WEBPACK_IMPORTED_MODULE_7__["Task"].create('Parse DSN6/BRIX', function (ctx) { return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"])(_this, void 0, void 0, function () {
            var parsed;
            return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__generator"])(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, _mol_io_reader_dsn6_parser__WEBPACK_IMPORTED_MODULE_3__["parse"](a.data, a.label).runInContext(ctx)];
                    case 1:
                        parsed = _a.sent();
                        if (parsed.isError)
                            throw new Error(parsed.message);
                        return [2 /*return*/, new _objects__WEBPACK_IMPORTED_MODULE_10__["PluginStateObject"].Format.Dsn6(parsed.result)];
                }
            });
        }); });
    }
});
var ParseDx = _objects__WEBPACK_IMPORTED_MODULE_10__["PluginStateTransform"].BuiltIn({
    name: 'parse-dx',
    display: { name: 'Parse DX', description: 'Parse DX from Binary/String data' },
    from: [_objects__WEBPACK_IMPORTED_MODULE_10__["PluginStateObject"].Data.Binary, _objects__WEBPACK_IMPORTED_MODULE_10__["PluginStateObject"].Data.String],
    to: _objects__WEBPACK_IMPORTED_MODULE_10__["PluginStateObject"].Format.Dx
})({
    apply: function (_a) {
        var _this = this;
        var a = _a.a;
        return _mol_task__WEBPACK_IMPORTED_MODULE_7__["Task"].create('Parse DX', function (ctx) { return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"])(_this, void 0, void 0, function () {
            var parsed;
            return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__generator"])(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, Object(_mol_io_reader_dx_parser__WEBPACK_IMPORTED_MODULE_13__["parseDx"])(a.data, a.label).runInContext(ctx)];
                    case 1:
                        parsed = _a.sent();
                        if (parsed.isError)
                            throw new Error(parsed.message);
                        return [2 /*return*/, new _objects__WEBPACK_IMPORTED_MODULE_10__["PluginStateObject"].Format.Dx(parsed.result)];
                }
            });
        }); });
    }
});
var ImportString = _objects__WEBPACK_IMPORTED_MODULE_10__["PluginStateTransform"].BuiltIn({
    name: 'import-string',
    display: { name: 'Import String', description: 'Import given data as a string' },
    from: _objects__WEBPACK_IMPORTED_MODULE_10__["PluginStateObject"].Root,
    to: _objects__WEBPACK_IMPORTED_MODULE_10__["PluginStateObject"].Data.String,
    params: {
        data: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_9__["ParamDefinition"].Value(''),
        label: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_9__["ParamDefinition"].Optional(_mol_util_param_definition__WEBPACK_IMPORTED_MODULE_9__["ParamDefinition"].Text('')),
    }
})({
    apply: function (_a) {
        var _b = _a.params, data = _b.data, label = _b.label;
        return new _objects__WEBPACK_IMPORTED_MODULE_10__["PluginStateObject"].Data.String(data, { label: label || '' });
    },
    update: function (_a) {
        var oldParams = _a.oldParams, newParams = _a.newParams, b = _a.b;
        if (oldParams.data !== newParams.data)
            return _mol_state__WEBPACK_IMPORTED_MODULE_6__["StateTransformer"].UpdateResult.Recreate;
        if (oldParams.label !== newParams.label) {
            b.label = newParams.label || '';
            return _mol_state__WEBPACK_IMPORTED_MODULE_6__["StateTransformer"].UpdateResult.Updated;
        }
        return _mol_state__WEBPACK_IMPORTED_MODULE_6__["StateTransformer"].UpdateResult.Unchanged;
    },
    isSerializable: function () { return ({ isSerializable: false, reason: 'Cannot serialize user imported strings.' }); }
});
var ImportJson = _objects__WEBPACK_IMPORTED_MODULE_10__["PluginStateTransform"].BuiltIn({
    name: 'import-json',
    display: { name: 'Import JSON', description: 'Import given data as a JSON' },
    from: _objects__WEBPACK_IMPORTED_MODULE_10__["PluginStateObject"].Root,
    to: _objects__WEBPACK_IMPORTED_MODULE_10__["PluginStateObject"].Format.Json,
    params: {
        data: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_9__["ParamDefinition"].Value({}),
        label: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_9__["ParamDefinition"].Optional(_mol_util_param_definition__WEBPACK_IMPORTED_MODULE_9__["ParamDefinition"].Text('')),
    }
})({
    apply: function (_a) {
        var _b = _a.params, data = _b.data, label = _b.label;
        return new _objects__WEBPACK_IMPORTED_MODULE_10__["PluginStateObject"].Format.Json(data, { label: label || '' });
    },
    update: function (_a) {
        var oldParams = _a.oldParams, newParams = _a.newParams, b = _a.b;
        if (oldParams.data !== newParams.data)
            return _mol_state__WEBPACK_IMPORTED_MODULE_6__["StateTransformer"].UpdateResult.Recreate;
        if (oldParams.label !== newParams.label) {
            b.label = newParams.label || '';
            return _mol_state__WEBPACK_IMPORTED_MODULE_6__["StateTransformer"].UpdateResult.Updated;
        }
        return _mol_state__WEBPACK_IMPORTED_MODULE_6__["StateTransformer"].UpdateResult.Unchanged;
    },
    isSerializable: function () { return ({ isSerializable: false, reason: 'Cannot serialize user imported JSON.' }); }
});
var ParseJson = _objects__WEBPACK_IMPORTED_MODULE_10__["PluginStateTransform"].BuiltIn({
    name: 'parse-json',
    display: { name: 'Parse JSON', description: 'Parse JSON from String data' },
    from: [_objects__WEBPACK_IMPORTED_MODULE_10__["PluginStateObject"].Data.String],
    to: _objects__WEBPACK_IMPORTED_MODULE_10__["PluginStateObject"].Format.Json
})({
    apply: function (_a) {
        var _this = this;
        var a = _a.a;
        return _mol_task__WEBPACK_IMPORTED_MODULE_7__["Task"].create('Parse JSON', function (ctx) { return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"])(_this, void 0, void 0, function () {
            var json;
            return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__generator"])(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, (new Response(a.data)).json()];
                    case 1:
                        json = _a.sent();
                        return [2 /*return*/, new _objects__WEBPACK_IMPORTED_MODULE_10__["PluginStateObject"].Format.Json(json)];
                }
            });
        }); });
    }
});
//# sourceMappingURL=data.js.map

/***/ }),

/***/ "./lib/mol-plugin-state/transforms/helpers.js":
/*!****************************************************!*\
  !*** ./lib/mol-plugin-state/transforms/helpers.js ***!
  \****************************************************/
/*! exports provided: getDistanceDataFromStructureSelections, getAngleDataFromStructureSelections, getDihedralDataFromStructureSelections, getLabelDataFromStructureSelections, getOrientationDataFromStructureSelections */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getDistanceDataFromStructureSelections", function() { return getDistanceDataFromStructureSelections; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getAngleDataFromStructureSelections", function() { return getAngleDataFromStructureSelections; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getDihedralDataFromStructureSelections", function() { return getDihedralDataFromStructureSelections; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getLabelDataFromStructureSelections", function() { return getLabelDataFromStructureSelections; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getOrientationDataFromStructureSelections", function() { return getOrientationDataFromStructureSelections; });
/**
 * Copyright (c) 2019 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */
function getDistanceDataFromStructureSelections(s) {
    var lociA = s[0].loci;
    var lociB = s[1].loci;
    return { pairs: [{ loci: [lociA, lociB] }] };
}
function getAngleDataFromStructureSelections(s) {
    var lociA = s[0].loci;
    var lociB = s[1].loci;
    var lociC = s[2].loci;
    return { triples: [{ loci: [lociA, lociB, lociC] }] };
}
function getDihedralDataFromStructureSelections(s) {
    var lociA = s[0].loci;
    var lociB = s[1].loci;
    var lociC = s[2].loci;
    var lociD = s[3].loci;
    return { quads: [{ loci: [lociA, lociB, lociC, lociD] }] };
}
function getLabelDataFromStructureSelections(s) {
    var loci = s[0].loci;
    return { infos: [{ loci: loci }] };
}
function getOrientationDataFromStructureSelections(s) {
    var loci = s[0].loci;
    return { locis: [loci] };
}
//# sourceMappingURL=helpers.js.map

/***/ }),

/***/ "./lib/mol-plugin-state/transforms/misc.js":
/*!*************************************************!*\
  !*** ./lib/mol-plugin-state/transforms/misc.js ***!
  \*************************************************/
/*! exports provided: CreateGroup */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CreateGroup", function() { return CreateGroup; });
/* harmony import */ var _mol_state__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../mol-state */ "./lib/mol-state/index.js");
/* harmony import */ var _mol_util__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../mol-util */ "./lib/mol-util/index.js");
/* harmony import */ var _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../mol-util/param-definition */ "./lib/mol-util/param-definition.js");
/* harmony import */ var _objects__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../objects */ "./lib/mol-plugin-state/objects.js");
/**
 * Copyright (c) 2018-2019 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author David Sehnal <david.sehnal@gmail.com>
 */





var CreateGroup = _objects__WEBPACK_IMPORTED_MODULE_3__["PluginStateTransform"].BuiltIn({
    name: 'create-group',
    display: { name: 'Group' },
    from: [],
    to: _objects__WEBPACK_IMPORTED_MODULE_3__["PluginStateObject"].Group,
    params: {
        label: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_2__["ParamDefinition"].Text('Group'),
        description: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_2__["ParamDefinition"].Optional(_mol_util_param_definition__WEBPACK_IMPORTED_MODULE_2__["ParamDefinition"].Text(''))
    }
})({
    apply: function (_a) {
        var params = _a.params;
        return new _objects__WEBPACK_IMPORTED_MODULE_3__["PluginStateObject"].Group({}, params);
    },
    update: function (_a) {
        var oldParams = _a.oldParams, newParams = _a.newParams, b = _a.b;
        if (Object(_mol_util__WEBPACK_IMPORTED_MODULE_1__["shallowEqualObjects"])(oldParams, newParams))
            return _mol_state__WEBPACK_IMPORTED_MODULE_0__["StateTransformer"].UpdateResult.Unchanged;
        b.label = newParams.label;
        b.description = newParams.description;
        return _mol_state__WEBPACK_IMPORTED_MODULE_0__["StateTransformer"].UpdateResult.Updated;
    }
});
// export { ValueRefTest };
// type ValueRefTest = typeof ValueRefTest
// const ValueRefTest = PluginStateTransform.BuiltIn({
//     name: 'value-ref-test',
//     display: { name: 'ValueRef Test' },
//     from: SO.Root,
//     to: SO.Data.String,
//     params: (_, ctx: PluginContext) => {
//         const getOptions = () => ctx.state.data.selectQ(q => q.rootsOfType(SO.Molecule.Model)).map(m => [m.transform.ref, m.obj?.label || m.transform.ref] as [string, string]);
//         return {
//             ref: PD.ValueRef<SO.Molecule.Model>(getOptions, ctx.state.data.tryGetCellData, { defaultRef: getOptions()[0]?.[0] })
//         };
//     }
// })({
//     apply({ params }) {
//         const model = params.ref.getValue();
//         console.log(model);
//         return new SO.Data.String(`Model: ${model.label}`, { label: model.label });
//     }
// });
//# sourceMappingURL=misc.js.map

/***/ }),

/***/ "./lib/mol-plugin-state/transforms/model.js":
/*!**************************************************!*\
  !*** ./lib/mol-plugin-state/transforms/model.js ***!
  \**************************************************/
/*! exports provided: CoordinatesFromDcd, CoordinatesFromXtc, TopologyFromPsf, TrajectoryFromModelAndCoordinates, TrajectoryFromBlob, TrajectoryFromMmCif, TrajectoryFromPDB, TrajectoryFromGRO, TrajectoryFromMOL, TrajectoryFromMOL2, TrajectoryFromCube, TrajectoryFromCifCore, ModelFromTrajectory, StructureFromTrajectory, StructureFromModel, TransformStructureConformation, StructureSelectionFromExpression, MultiStructureSelectionFromExpression, StructureSelectionFromScript, StructureSelectionFromBundle, StructureComplexElement, StructureComponent, CustomModelProperties, CustomStructureProperties, ShapeFromPly, StructureComplexElementTypes */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CoordinatesFromDcd", function() { return CoordinatesFromDcd; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CoordinatesFromXtc", function() { return CoordinatesFromXtc; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "TopologyFromPsf", function() { return TopologyFromPsf; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "TrajectoryFromModelAndCoordinates", function() { return TrajectoryFromModelAndCoordinates; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "TrajectoryFromBlob", function() { return TrajectoryFromBlob; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "TrajectoryFromMmCif", function() { return TrajectoryFromMmCif; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "TrajectoryFromPDB", function() { return TrajectoryFromPDB; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "TrajectoryFromGRO", function() { return TrajectoryFromGRO; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "TrajectoryFromMOL", function() { return TrajectoryFromMOL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "TrajectoryFromMOL2", function() { return TrajectoryFromMOL2; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "TrajectoryFromCube", function() { return TrajectoryFromCube; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "TrajectoryFromCifCore", function() { return TrajectoryFromCifCore; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ModelFromTrajectory", function() { return ModelFromTrajectory; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "StructureFromTrajectory", function() { return StructureFromTrajectory; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "StructureFromModel", function() { return StructureFromModel; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "TransformStructureConformation", function() { return TransformStructureConformation; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "StructureSelectionFromExpression", function() { return StructureSelectionFromExpression; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MultiStructureSelectionFromExpression", function() { return MultiStructureSelectionFromExpression; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "StructureSelectionFromScript", function() { return StructureSelectionFromScript; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "StructureSelectionFromBundle", function() { return StructureSelectionFromBundle; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "StructureComplexElement", function() { return StructureComplexElement; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "StructureComponent", function() { return StructureComponent; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CustomModelProperties", function() { return CustomModelProperties; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CustomStructureProperties", function() { return CustomStructureProperties; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ShapeFromPly", function() { return ShapeFromPly; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "StructureComplexElementTypes", function() { return StructureComplexElementTypes; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _mol_io_reader_dcd_parser__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../mol-io/reader/dcd/parser */ "./lib/mol-io/reader/dcd/parser.js");
/* harmony import */ var _mol_io_reader_gro_parser__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../mol-io/reader/gro/parser */ "./lib/mol-io/reader/gro/parser.js");
/* harmony import */ var _mol_io_reader_pdb_parser__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../mol-io/reader/pdb/parser */ "./lib/mol-io/reader/pdb/parser.js");
/* harmony import */ var _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../mol-math/linear-algebra */ "./lib/mol-math/linear-algebra.js");
/* harmony import */ var _mol_model_formats_shape_ply__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../mol-model-formats/shape/ply */ "./lib/mol-model-formats/shape/ply.js");
/* harmony import */ var _mol_model_formats_structure_dcd__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../../mol-model-formats/structure/dcd */ "./lib/mol-model-formats/structure/dcd.js");
/* harmony import */ var _mol_model_formats_structure_gro__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../../mol-model-formats/structure/gro */ "./lib/mol-model-formats/structure/gro.js");
/* harmony import */ var _mol_model_formats_structure_mmcif__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ../../mol-model-formats/structure/mmcif */ "./lib/mol-model-formats/structure/mmcif.js");
/* harmony import */ var _mol_model_formats_structure_pdb__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ../../mol-model-formats/structure/pdb */ "./lib/mol-model-formats/structure/pdb.js");
/* harmony import */ var _mol_model_formats_structure_psf__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ../../mol-model-formats/structure/psf */ "./lib/mol-model-formats/structure/psf.js");
/* harmony import */ var _mol_model_structure__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ../../mol-model/structure */ "./lib/mol-model/structure.js");
/* harmony import */ var _mol_script_language_builder__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! ../../mol-script/language/builder */ "./lib/mol-script/language/builder.js");
/* harmony import */ var _mol_script_script__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! ../../mol-script/script */ "./lib/mol-script/script.js");
/* harmony import */ var _mol_state__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! ../../mol-state */ "./lib/mol-state/index.js");
/* harmony import */ var _mol_task__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! ../../mol-task */ "./lib/mol-task/index.js");
/* harmony import */ var _mol_util__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(/*! ../../mol-util */ "./lib/mol-util/index.js");
/* harmony import */ var _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(/*! ../../mol-util/param-definition */ "./lib/mol-util/param-definition.js");
/* harmony import */ var _helpers_root_structure__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(/*! ../helpers/root-structure */ "./lib/mol-plugin-state/helpers/root-structure.js");
/* harmony import */ var _helpers_structure_component__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(/*! ../helpers/structure-component */ "./lib/mol-plugin-state/helpers/structure-component.js");
/* harmony import */ var _helpers_structure_query__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(/*! ../helpers/structure-query */ "./lib/mol-plugin-state/helpers/structure-query.js");
/* harmony import */ var _helpers_structure_selection_query__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(/*! ../helpers/structure-selection-query */ "./lib/mol-plugin-state/helpers/structure-selection-query.js");
/* harmony import */ var _objects__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(/*! ../objects */ "./lib/mol-plugin-state/objects.js");
/* harmony import */ var _mol_io_reader_mol_parser__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(/*! ../../mol-io/reader/mol/parser */ "./lib/mol-io/reader/mol/parser.js");
/* harmony import */ var _mol_model_formats_structure_mol__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(/*! ../../mol-model-formats/structure/mol */ "./lib/mol-model-formats/structure/mol.js");
/* harmony import */ var _mol_model_formats_structure_cif_core__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__(/*! ../../mol-model-formats/structure/cif-core */ "./lib/mol-model-formats/structure/cif-core.js");
/* harmony import */ var _mol_model_formats_structure_cube__WEBPACK_IMPORTED_MODULE_26__ = __webpack_require__(/*! ../../mol-model-formats/structure/cube */ "./lib/mol-model-formats/structure/cube.js");
/* harmony import */ var _mol_io_reader_mol2_parser__WEBPACK_IMPORTED_MODULE_27__ = __webpack_require__(/*! ../../mol-io/reader/mol2/parser */ "./lib/mol-io/reader/mol2/parser.js");
/* harmony import */ var _mol_model_formats_structure_mol2__WEBPACK_IMPORTED_MODULE_28__ = __webpack_require__(/*! ../../mol-model-formats/structure/mol2 */ "./lib/mol-model-formats/structure/mol2.js");
/* harmony import */ var _mol_io_reader_xtc_parser__WEBPACK_IMPORTED_MODULE_29__ = __webpack_require__(/*! ../../mol-io/reader/xtc/parser */ "./lib/mol-io/reader/xtc/parser.js");
/* harmony import */ var _mol_model_formats_structure_xtc__WEBPACK_IMPORTED_MODULE_30__ = __webpack_require__(/*! ../../mol-model-formats/structure/xtc */ "./lib/mol-model-formats/structure/xtc.js");
/**
 * Copyright (c) 2018-2020 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author David Sehnal <david.sehnal@gmail.com>
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */
























































var CoordinatesFromDcd = _objects__WEBPACK_IMPORTED_MODULE_22__["PluginStateTransform"].BuiltIn({
    name: 'coordinates-from-dcd',
    display: { name: 'Parse DCD', description: 'Parse DCD binary data.' },
    from: [_objects__WEBPACK_IMPORTED_MODULE_22__["PluginStateObject"].Data.Binary],
    to: _objects__WEBPACK_IMPORTED_MODULE_22__["PluginStateObject"].Molecule.Coordinates
})({
    apply: function (_a) {
        var _this = this;
        var a = _a.a;
        return _mol_task__WEBPACK_IMPORTED_MODULE_15__["Task"].create('Parse DCD', function (ctx) { return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"])(_this, void 0, void 0, function () {
            var parsed, coordinates;
            return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__generator"])(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, Object(_mol_io_reader_dcd_parser__WEBPACK_IMPORTED_MODULE_1__["parseDcd"])(a.data).runInContext(ctx)];
                    case 1:
                        parsed = _a.sent();
                        if (parsed.isError)
                            throw new Error(parsed.message);
                        return [4 /*yield*/, Object(_mol_model_formats_structure_dcd__WEBPACK_IMPORTED_MODULE_6__["coordinatesFromDcd"])(parsed.result).runInContext(ctx)];
                    case 2:
                        coordinates = _a.sent();
                        return [2 /*return*/, new _objects__WEBPACK_IMPORTED_MODULE_22__["PluginStateObject"].Molecule.Coordinates(coordinates, { label: a.label, description: 'Coordinates' })];
                }
            });
        }); });
    }
});
var CoordinatesFromXtc = _objects__WEBPACK_IMPORTED_MODULE_22__["PluginStateTransform"].BuiltIn({
    name: 'coordinates-from-xtc',
    display: { name: 'Parse XTC', description: 'Parse XTC binary data.' },
    from: [_objects__WEBPACK_IMPORTED_MODULE_22__["PluginStateObject"].Data.Binary],
    to: _objects__WEBPACK_IMPORTED_MODULE_22__["PluginStateObject"].Molecule.Coordinates
})({
    apply: function (_a) {
        var _this = this;
        var a = _a.a;
        return _mol_task__WEBPACK_IMPORTED_MODULE_15__["Task"].create('Parse XTC', function (ctx) { return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"])(_this, void 0, void 0, function () {
            var parsed, coordinates;
            return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__generator"])(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, Object(_mol_io_reader_xtc_parser__WEBPACK_IMPORTED_MODULE_29__["parseXtc"])(a.data).runInContext(ctx)];
                    case 1:
                        parsed = _a.sent();
                        if (parsed.isError)
                            throw new Error(parsed.message);
                        return [4 /*yield*/, Object(_mol_model_formats_structure_xtc__WEBPACK_IMPORTED_MODULE_30__["coordinatesFromXtc"])(parsed.result).runInContext(ctx)];
                    case 2:
                        coordinates = _a.sent();
                        return [2 /*return*/, new _objects__WEBPACK_IMPORTED_MODULE_22__["PluginStateObject"].Molecule.Coordinates(coordinates, { label: a.label, description: 'Coordinates' })];
                }
            });
        }); });
    }
});
var TopologyFromPsf = _objects__WEBPACK_IMPORTED_MODULE_22__["PluginStateTransform"].BuiltIn({
    name: 'topology-from-psf',
    display: { name: 'PSF Topology', description: 'Parse PSF string data.' },
    from: [_objects__WEBPACK_IMPORTED_MODULE_22__["PluginStateObject"].Format.Psf],
    to: _objects__WEBPACK_IMPORTED_MODULE_22__["PluginStateObject"].Molecule.Topology
})({
    apply: function (_a) {
        var _this = this;
        var a = _a.a;
        return _mol_task__WEBPACK_IMPORTED_MODULE_15__["Task"].create('Create Topology', function (ctx) { return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"])(_this, void 0, void 0, function () {
            var topology;
            return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__generator"])(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, Object(_mol_model_formats_structure_psf__WEBPACK_IMPORTED_MODULE_10__["topologyFromPsf"])(a.data).runInContext(ctx)];
                    case 1:
                        topology = _a.sent();
                        return [2 /*return*/, new _objects__WEBPACK_IMPORTED_MODULE_22__["PluginStateObject"].Molecule.Topology(topology, { label: topology.label || a.label, description: 'Topology' })];
                }
            });
        }); });
    }
});
function getTrajectory(ctx, obj, coordinates) {
    return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"])(this, void 0, void 0, function () {
        var topology, model;
        return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__generator"])(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!(obj.type === _objects__WEBPACK_IMPORTED_MODULE_22__["PluginStateObject"].Molecule.Topology.type)) return [3 /*break*/, 2];
                    topology = obj.data;
                    return [4 /*yield*/, _mol_model_structure__WEBPACK_IMPORTED_MODULE_11__["Model"].trajectoryFromTopologyAndCoordinates(topology, coordinates).runInContext(ctx)];
                case 1: return [2 /*return*/, _a.sent()];
                case 2:
                    if (obj.type === _objects__WEBPACK_IMPORTED_MODULE_22__["PluginStateObject"].Molecule.Model.type) {
                        model = obj.data;
                        return [2 /*return*/, _mol_model_structure__WEBPACK_IMPORTED_MODULE_11__["Model"].trajectoryFromModelAndCoordinates(model, coordinates)];
                    }
                    _a.label = 3;
                case 3: throw new Error('no model/topology found');
            }
        });
    });
}
var TrajectoryFromModelAndCoordinates = _objects__WEBPACK_IMPORTED_MODULE_22__["PluginStateTransform"].BuiltIn({
    name: 'trajectory-from-model-and-coordinates',
    display: { name: 'Trajectory from Topology & Coordinates', description: 'Create a trajectory from existing model/topology and coordinates.' },
    from: _objects__WEBPACK_IMPORTED_MODULE_22__["PluginStateObject"].Root,
    to: _objects__WEBPACK_IMPORTED_MODULE_22__["PluginStateObject"].Molecule.Trajectory,
    params: {
        modelRef: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_17__["ParamDefinition"].Text('', { isHidden: true }),
        coordinatesRef: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_17__["ParamDefinition"].Text('', { isHidden: true }),
    }
})({
    apply: function (_a) {
        var _this = this;
        var params = _a.params, dependencies = _a.dependencies;
        return _mol_task__WEBPACK_IMPORTED_MODULE_15__["Task"].create('Create trajectory from model/topology and coordinates', function (ctx) { return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"])(_this, void 0, void 0, function () {
            var coordinates, trajectory, props;
            return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__generator"])(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        coordinates = dependencies[params.coordinatesRef].data;
                        return [4 /*yield*/, getTrajectory(ctx, dependencies[params.modelRef], coordinates)];
                    case 1:
                        trajectory = _a.sent();
                        props = { label: 'Trajectory', description: trajectory.frameCount + " model" + (trajectory.frameCount === 1 ? '' : 's') };
                        return [2 /*return*/, new _objects__WEBPACK_IMPORTED_MODULE_22__["PluginStateObject"].Molecule.Trajectory(trajectory, props)];
                }
            });
        }); });
    }
});
var TrajectoryFromBlob = _objects__WEBPACK_IMPORTED_MODULE_22__["PluginStateTransform"].BuiltIn({
    name: 'trajectory-from-blob',
    display: { name: 'Parse Blob', description: 'Parse format blob into a single trajectory.' },
    from: _objects__WEBPACK_IMPORTED_MODULE_22__["PluginStateObject"].Format.Blob,
    to: _objects__WEBPACK_IMPORTED_MODULE_22__["PluginStateObject"].Molecule.Trajectory
})({
    apply: function (_a) {
        var _this = this;
        var a = _a.a;
        return _mol_task__WEBPACK_IMPORTED_MODULE_15__["Task"].create('Parse Format Blob', function (ctx) { return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"])(_this, void 0, void 0, function () {
            var models, _i, _a, e, block, xs, i, x, i, props;
            return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__generator"])(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        models = [];
                        _i = 0, _a = a.data;
                        _b.label = 1;
                    case 1:
                        if (!(_i < _a.length)) return [3 /*break*/, 7];
                        e = _a[_i];
                        if (e.kind !== 'cif')
                            return [3 /*break*/, 6];
                        block = e.data.blocks[0];
                        return [4 /*yield*/, Object(_mol_model_formats_structure_mmcif__WEBPACK_IMPORTED_MODULE_8__["trajectoryFromMmCIF"])(block).runInContext(ctx)];
                    case 2:
                        xs = _b.sent();
                        if (xs.frameCount === 0)
                            throw new Error('No models found.');
                        i = 0;
                        _b.label = 3;
                    case 3:
                        if (!(i < xs.frameCount)) return [3 /*break*/, 6];
                        return [4 /*yield*/, _mol_task__WEBPACK_IMPORTED_MODULE_15__["Task"].resolveInContext(xs.getFrameAtIndex(i), ctx)];
                    case 4:
                        x = _b.sent();
                        models.push(x);
                        _b.label = 5;
                    case 5:
                        i++;
                        return [3 /*break*/, 3];
                    case 6:
                        _i++;
                        return [3 /*break*/, 1];
                    case 7:
                        for (i = 0; i < models.length; i++) {
                            _mol_model_structure__WEBPACK_IMPORTED_MODULE_11__["Model"].TrajectoryInfo.set(models[i], { index: i, size: models.length });
                        }
                        props = { label: 'Trajectory', description: models.length + " model" + (models.length === 1 ? '' : 's') };
                        return [2 /*return*/, new _objects__WEBPACK_IMPORTED_MODULE_22__["PluginStateObject"].Molecule.Trajectory(new _mol_model_structure__WEBPACK_IMPORTED_MODULE_11__["ArrayTrajectory"](models), props)];
                }
            });
        }); });
    }
});
function trajectoryProps(trajectory) {
    var first = trajectory.representative;
    return { label: "" + first.entry, description: trajectory.frameCount + " model" + (trajectory.frameCount === 1 ? '' : 's') };
}
var TrajectoryFromMmCif = _objects__WEBPACK_IMPORTED_MODULE_22__["PluginStateTransform"].BuiltIn({
    name: 'trajectory-from-mmcif',
    display: { name: 'Trajectory from mmCIF', description: 'Identify and create all separate models in the specified CIF data block' },
    from: _objects__WEBPACK_IMPORTED_MODULE_22__["PluginStateObject"].Format.Cif,
    to: _objects__WEBPACK_IMPORTED_MODULE_22__["PluginStateObject"].Molecule.Trajectory,
    params: function (a) {
        if (!a) {
            return {
                blockHeader: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_17__["ParamDefinition"].Optional(_mol_util_param_definition__WEBPACK_IMPORTED_MODULE_17__["ParamDefinition"].Text(void 0, { description: 'Header of the block to parse. If none is specifed, the 1st data block in the file is used.' }))
            };
        }
        var blocks = a.data.blocks;
        return {
            blockHeader: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_17__["ParamDefinition"].Optional(_mol_util_param_definition__WEBPACK_IMPORTED_MODULE_17__["ParamDefinition"].Select(blocks[0] && blocks[0].header, blocks.map(function (b) { return [b.header, b.header]; }), { description: 'Header of the block to parse' }))
        };
    }
})({
    isApplicable: function (a) { return a.data.blocks.length > 0; },
    apply: function (_a) {
        var _this = this;
        var a = _a.a, params = _a.params;
        return _mol_task__WEBPACK_IMPORTED_MODULE_15__["Task"].create('Parse mmCIF', function (ctx) { return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"])(_this, void 0, void 0, function () {
            var header, block, models, props;
            return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__generator"])(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        header = params.blockHeader || a.data.blocks[0].header;
                        block = a.data.blocks.find(function (b) { return b.header === header; });
                        if (!block)
                            throw new Error("Data block '" + [header] + "' not found.");
                        return [4 /*yield*/, Object(_mol_model_formats_structure_mmcif__WEBPACK_IMPORTED_MODULE_8__["trajectoryFromMmCIF"])(block).runInContext(ctx)];
                    case 1:
                        models = _a.sent();
                        if (models.frameCount === 0)
                            throw new Error('No models found.');
                        props = trajectoryProps(models);
                        return [2 /*return*/, new _objects__WEBPACK_IMPORTED_MODULE_22__["PluginStateObject"].Molecule.Trajectory(models, props)];
                }
            });
        }); });
    }
});
var TrajectoryFromPDB = _objects__WEBPACK_IMPORTED_MODULE_22__["PluginStateTransform"].BuiltIn({
    name: 'trajectory-from-pdb',
    display: { name: 'Parse PDB', description: 'Parse PDB string and create trajectory.' },
    from: [_objects__WEBPACK_IMPORTED_MODULE_22__["PluginStateObject"].Data.String],
    to: _objects__WEBPACK_IMPORTED_MODULE_22__["PluginStateObject"].Molecule.Trajectory,
    params: {
        isPdbqt: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_17__["ParamDefinition"].Boolean(false)
    }
})({
    apply: function (_a) {
        var _this = this;
        var a = _a.a, params = _a.params;
        return _mol_task__WEBPACK_IMPORTED_MODULE_15__["Task"].create('Parse PDB', function (ctx) { return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"])(_this, void 0, void 0, function () {
            var parsed, models, props;
            return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__generator"])(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, Object(_mol_io_reader_pdb_parser__WEBPACK_IMPORTED_MODULE_3__["parsePDB"])(a.data, a.label, params.isPdbqt).runInContext(ctx)];
                    case 1:
                        parsed = _a.sent();
                        if (parsed.isError)
                            throw new Error(parsed.message);
                        return [4 /*yield*/, Object(_mol_model_formats_structure_pdb__WEBPACK_IMPORTED_MODULE_9__["trajectoryFromPDB"])(parsed.result).runInContext(ctx)];
                    case 2:
                        models = _a.sent();
                        props = trajectoryProps(models);
                        return [2 /*return*/, new _objects__WEBPACK_IMPORTED_MODULE_22__["PluginStateObject"].Molecule.Trajectory(models, props)];
                }
            });
        }); });
    }
});
var TrajectoryFromGRO = _objects__WEBPACK_IMPORTED_MODULE_22__["PluginStateTransform"].BuiltIn({
    name: 'trajectory-from-gro',
    display: { name: 'Parse GRO', description: 'Parse GRO string and create trajectory.' },
    from: [_objects__WEBPACK_IMPORTED_MODULE_22__["PluginStateObject"].Data.String],
    to: _objects__WEBPACK_IMPORTED_MODULE_22__["PluginStateObject"].Molecule.Trajectory
})({
    apply: function (_a) {
        var _this = this;
        var a = _a.a;
        return _mol_task__WEBPACK_IMPORTED_MODULE_15__["Task"].create('Parse GRO', function (ctx) { return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"])(_this, void 0, void 0, function () {
            var parsed, models, props;
            return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__generator"])(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, Object(_mol_io_reader_gro_parser__WEBPACK_IMPORTED_MODULE_2__["parseGRO"])(a.data).runInContext(ctx)];
                    case 1:
                        parsed = _a.sent();
                        if (parsed.isError)
                            throw new Error(parsed.message);
                        return [4 /*yield*/, Object(_mol_model_formats_structure_gro__WEBPACK_IMPORTED_MODULE_7__["trajectoryFromGRO"])(parsed.result).runInContext(ctx)];
                    case 2:
                        models = _a.sent();
                        props = trajectoryProps(models);
                        return [2 /*return*/, new _objects__WEBPACK_IMPORTED_MODULE_22__["PluginStateObject"].Molecule.Trajectory(models, props)];
                }
            });
        }); });
    }
});
var TrajectoryFromMOL = _objects__WEBPACK_IMPORTED_MODULE_22__["PluginStateTransform"].BuiltIn({
    name: 'trajectory-from-mol',
    display: { name: 'Parse MOL', description: 'Parse MOL string and create trajectory.' },
    from: [_objects__WEBPACK_IMPORTED_MODULE_22__["PluginStateObject"].Data.String],
    to: _objects__WEBPACK_IMPORTED_MODULE_22__["PluginStateObject"].Molecule.Trajectory
})({
    apply: function (_a) {
        var _this = this;
        var a = _a.a;
        return _mol_task__WEBPACK_IMPORTED_MODULE_15__["Task"].create('Parse MOL', function (ctx) { return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"])(_this, void 0, void 0, function () {
            var parsed, models, props;
            return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__generator"])(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, Object(_mol_io_reader_mol_parser__WEBPACK_IMPORTED_MODULE_23__["parseMol"])(a.data).runInContext(ctx)];
                    case 1:
                        parsed = _a.sent();
                        if (parsed.isError)
                            throw new Error(parsed.message);
                        return [4 /*yield*/, Object(_mol_model_formats_structure_mol__WEBPACK_IMPORTED_MODULE_24__["trajectoryFromMol"])(parsed.result).runInContext(ctx)];
                    case 2:
                        models = _a.sent();
                        props = trajectoryProps(models);
                        return [2 /*return*/, new _objects__WEBPACK_IMPORTED_MODULE_22__["PluginStateObject"].Molecule.Trajectory(models, props)];
                }
            });
        }); });
    }
});
var TrajectoryFromMOL2 = _objects__WEBPACK_IMPORTED_MODULE_22__["PluginStateTransform"].BuiltIn({
    name: 'trajectory-from-mol2',
    display: { name: 'Parse MOL2', description: 'Parse MOL2 string and create trajectory.' },
    from: [_objects__WEBPACK_IMPORTED_MODULE_22__["PluginStateObject"].Data.String],
    to: _objects__WEBPACK_IMPORTED_MODULE_22__["PluginStateObject"].Molecule.Trajectory
})({
    apply: function (_a) {
        var _this = this;
        var a = _a.a;
        return _mol_task__WEBPACK_IMPORTED_MODULE_15__["Task"].create('Parse MOL2', function (ctx) { return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"])(_this, void 0, void 0, function () {
            var parsed, models, props;
            return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__generator"])(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, Object(_mol_io_reader_mol2_parser__WEBPACK_IMPORTED_MODULE_27__["parseMol2"])(a.data, a.label).runInContext(ctx)];
                    case 1:
                        parsed = _a.sent();
                        if (parsed.isError)
                            throw new Error(parsed.message);
                        return [4 /*yield*/, Object(_mol_model_formats_structure_mol2__WEBPACK_IMPORTED_MODULE_28__["trajectoryFromMol2"])(parsed.result).runInContext(ctx)];
                    case 2:
                        models = _a.sent();
                        props = trajectoryProps(models);
                        return [2 /*return*/, new _objects__WEBPACK_IMPORTED_MODULE_22__["PluginStateObject"].Molecule.Trajectory(models, props)];
                }
            });
        }); });
    }
});
var TrajectoryFromCube = _objects__WEBPACK_IMPORTED_MODULE_22__["PluginStateTransform"].BuiltIn({
    name: 'trajectory-from-cube',
    display: { name: 'Parse Cube', description: 'Parse Cube file to create a trajectory.' },
    from: _objects__WEBPACK_IMPORTED_MODULE_22__["PluginStateObject"].Format.Cube,
    to: _objects__WEBPACK_IMPORTED_MODULE_22__["PluginStateObject"].Molecule.Trajectory
})({
    apply: function (_a) {
        var _this = this;
        var a = _a.a;
        return _mol_task__WEBPACK_IMPORTED_MODULE_15__["Task"].create('Parse MOL', function (ctx) { return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"])(_this, void 0, void 0, function () {
            var models, props;
            return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__generator"])(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, Object(_mol_model_formats_structure_cube__WEBPACK_IMPORTED_MODULE_26__["trajectoryFromCube"])(a.data).runInContext(ctx)];
                    case 1:
                        models = _a.sent();
                        props = trajectoryProps(models);
                        return [2 /*return*/, new _objects__WEBPACK_IMPORTED_MODULE_22__["PluginStateObject"].Molecule.Trajectory(models, props)];
                }
            });
        }); });
    }
});
var TrajectoryFromCifCore = _objects__WEBPACK_IMPORTED_MODULE_22__["PluginStateTransform"].BuiltIn({
    name: 'trajectory-from-cif-core',
    display: { name: 'Parse CIF Core', description: 'Identify and create all separate models in the specified CIF data block' },
    from: _objects__WEBPACK_IMPORTED_MODULE_22__["PluginStateObject"].Format.Cif,
    to: _objects__WEBPACK_IMPORTED_MODULE_22__["PluginStateObject"].Molecule.Trajectory,
    params: function (a) {
        if (!a) {
            return {
                blockHeader: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_17__["ParamDefinition"].Optional(_mol_util_param_definition__WEBPACK_IMPORTED_MODULE_17__["ParamDefinition"].Text(void 0, { description: 'Header of the block to parse. If none is specifed, the 1st data block in the file is used.' }))
            };
        }
        var blocks = a.data.blocks;
        return {
            blockHeader: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_17__["ParamDefinition"].Optional(_mol_util_param_definition__WEBPACK_IMPORTED_MODULE_17__["ParamDefinition"].Select(blocks[0] && blocks[0].header, blocks.map(function (b) { return [b.header, b.header]; }), { description: 'Header of the block to parse' }))
        };
    }
})({
    apply: function (_a) {
        var _this = this;
        var a = _a.a, params = _a.params;
        return _mol_task__WEBPACK_IMPORTED_MODULE_15__["Task"].create('Parse CIF Core', function (ctx) { return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"])(_this, void 0, void 0, function () {
            var header, block, models, props;
            return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__generator"])(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        header = params.blockHeader || a.data.blocks[0].header;
                        block = a.data.blocks.find(function (b) { return b.header === header; });
                        if (!block)
                            throw new Error("Data block '" + [header] + "' not found.");
                        return [4 /*yield*/, Object(_mol_model_formats_structure_cif_core__WEBPACK_IMPORTED_MODULE_25__["trajectoryFromCifCore"])(block).runInContext(ctx)];
                    case 1:
                        models = _a.sent();
                        if (models.frameCount === 0)
                            throw new Error('No models found.');
                        props = trajectoryProps(models);
                        return [2 /*return*/, new _objects__WEBPACK_IMPORTED_MODULE_22__["PluginStateObject"].Molecule.Trajectory(models, props)];
                }
            });
        }); });
    }
});
var plus1 = function (v) { return v + 1; }, minus1 = function (v) { return v - 1; };
var ModelFromTrajectory = _objects__WEBPACK_IMPORTED_MODULE_22__["PluginStateTransform"].BuiltIn({
    name: 'model-from-trajectory',
    display: { name: 'Molecular Model', description: 'Create a molecular model from specified index in a trajectory.' },
    from: _objects__WEBPACK_IMPORTED_MODULE_22__["PluginStateObject"].Molecule.Trajectory,
    to: _objects__WEBPACK_IMPORTED_MODULE_22__["PluginStateObject"].Molecule.Model,
    params: function (a) {
        if (!a) {
            return { modelIndex: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_17__["ParamDefinition"].Numeric(0, {}, { description: 'Zero-based index of the model' }) };
        }
        return { modelIndex: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_17__["ParamDefinition"].Converted(plus1, minus1, _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_17__["ParamDefinition"].Numeric(1, { min: 1, max: a.data.frameCount, step: 1 }, { description: 'Model Index' })) };
    }
})({
    isApplicable: function (a) { return a.data.frameCount > 0; },
    apply: function (_a) {
        var _this = this;
        var a = _a.a, params = _a.params;
        return _mol_task__WEBPACK_IMPORTED_MODULE_15__["Task"].create('Model from Trajectory', function (ctx) { return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"])(_this, void 0, void 0, function () {
            var modelIndex, model, label, description;
            return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__generator"])(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        modelIndex = params.modelIndex % a.data.frameCount;
                        if (modelIndex < 0)
                            modelIndex += a.data.frameCount;
                        return [4 /*yield*/, _mol_task__WEBPACK_IMPORTED_MODULE_15__["Task"].resolveInContext(a.data.getFrameAtIndex(modelIndex), ctx)];
                    case 1:
                        model = _a.sent();
                        label = "Model " + (modelIndex + 1);
                        description = a.data.frameCount === 1 ? undefined : "of " + a.data.frameCount;
                        return [2 /*return*/, new _objects__WEBPACK_IMPORTED_MODULE_22__["PluginStateObject"].Molecule.Model(model, { label: label, description: description })];
                }
            });
        }); });
    },
    dispose: function (_a) {
        var b = _a.b;
        b === null || b === void 0 ? void 0 : b.data.customProperties.dispose();
    }
});
var StructureFromTrajectory = _objects__WEBPACK_IMPORTED_MODULE_22__["PluginStateTransform"].BuiltIn({
    name: 'structure-from-trajectory',
    display: { name: 'Structure from Trajectory', description: 'Create a molecular structure from a trajectory.' },
    from: _objects__WEBPACK_IMPORTED_MODULE_22__["PluginStateObject"].Molecule.Trajectory,
    to: _objects__WEBPACK_IMPORTED_MODULE_22__["PluginStateObject"].Molecule.Structure
})({
    apply: function (_a) {
        var _this = this;
        var a = _a.a;
        return _mol_task__WEBPACK_IMPORTED_MODULE_15__["Task"].create('Build Structure', function (ctx) { return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"])(_this, void 0, void 0, function () {
            var s, props;
            return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__generator"])(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, _mol_model_structure__WEBPACK_IMPORTED_MODULE_11__["Structure"].ofTrajectory(a.data, ctx)];
                    case 1:
                        s = _a.sent();
                        props = { label: 'Ensemble', description: _mol_model_structure__WEBPACK_IMPORTED_MODULE_11__["Structure"].elementDescription(s) };
                        return [2 /*return*/, new _objects__WEBPACK_IMPORTED_MODULE_22__["PluginStateObject"].Molecule.Structure(s, props)];
                }
            });
        }); });
    },
    dispose: function (_a) {
        var b = _a.b;
        b === null || b === void 0 ? void 0 : b.data.customPropertyDescriptors.dispose();
    }
});
var StructureFromModel = _objects__WEBPACK_IMPORTED_MODULE_22__["PluginStateTransform"].BuiltIn({
    name: 'structure-from-model',
    display: { name: 'Structure', description: 'Create a molecular structure (model, assembly, or symmetry) from the specified model.' },
    from: _objects__WEBPACK_IMPORTED_MODULE_22__["PluginStateObject"].Molecule.Model,
    to: _objects__WEBPACK_IMPORTED_MODULE_22__["PluginStateObject"].Molecule.Structure,
    params: function (a) { return _helpers_root_structure__WEBPACK_IMPORTED_MODULE_18__["RootStructureDefinition"].getParams(a && a.data); }
})({
    canAutoUpdate: function (_a) {
        var oldParams = _a.oldParams, newParams = _a.newParams;
        return _helpers_root_structure__WEBPACK_IMPORTED_MODULE_18__["RootStructureDefinition"].canAutoUpdate(oldParams.type, newParams.type);
    },
    apply: function (_a, plugin) {
        var _this = this;
        var a = _a.a, params = _a.params;
        return _mol_task__WEBPACK_IMPORTED_MODULE_15__["Task"].create('Build Structure', function (ctx) { return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"])(_this, void 0, void 0, function () {
            return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__generator"])(this, function (_a) {
                return [2 /*return*/, _helpers_root_structure__WEBPACK_IMPORTED_MODULE_18__["RootStructureDefinition"].create(plugin, ctx, a.data, params && params.type)];
            });
        }); });
    },
    update: function (_a) {
        var a = _a.a, b = _a.b, oldParams = _a.oldParams, newParams = _a.newParams;
        if (!Object(_mol_util__WEBPACK_IMPORTED_MODULE_16__["deepEqual"])(oldParams, newParams))
            return _mol_state__WEBPACK_IMPORTED_MODULE_14__["StateTransformer"].UpdateResult.Recreate;
        if (b.data.model === a.data)
            return _mol_state__WEBPACK_IMPORTED_MODULE_14__["StateTransformer"].UpdateResult.Unchanged;
        if (!_mol_model_structure__WEBPACK_IMPORTED_MODULE_11__["Model"].areHierarchiesEqual(a.data, b.data.model))
            return _mol_state__WEBPACK_IMPORTED_MODULE_14__["StateTransformer"].UpdateResult.Recreate;
        b.data = b.data.remapModel(a.data);
        return _mol_state__WEBPACK_IMPORTED_MODULE_14__["StateTransformer"].UpdateResult.Updated;
    },
    dispose: function (_a) {
        var b = _a.b;
        b === null || b === void 0 ? void 0 : b.data.customPropertyDescriptors.dispose();
    }
});
var _translation = Object(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_4__["Vec3"])(), _m = Object(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_4__["Mat4"])(), _n = Object(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_4__["Mat4"])();
var TransformStructureConformation = _objects__WEBPACK_IMPORTED_MODULE_22__["PluginStateTransform"].BuiltIn({
    name: 'transform-structure-conformation',
    display: { name: 'Transform Conformation' },
    isDecorator: true,
    from: _objects__WEBPACK_IMPORTED_MODULE_22__["PluginStateObject"].Molecule.Structure,
    to: _objects__WEBPACK_IMPORTED_MODULE_22__["PluginStateObject"].Molecule.Structure,
    params: {
        transform: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_17__["ParamDefinition"].MappedStatic('components', {
            components: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_17__["ParamDefinition"].Group({
                axis: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_17__["ParamDefinition"].Vec3(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_4__["Vec3"].create(1, 0, 0)),
                angle: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_17__["ParamDefinition"].Numeric(0, { min: -180, max: 180, step: 0.1 }),
                translation: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_17__["ParamDefinition"].Vec3(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_4__["Vec3"].create(0, 0, 0)),
            }, { isFlat: true }),
            matrix: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_17__["ParamDefinition"].Group({
                data: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_17__["ParamDefinition"].Mat4(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_4__["Mat4"].identity()),
                transpose: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_17__["ParamDefinition"].Boolean(false)
            }, { isFlat: true })
        }, { label: 'Kind' })
    }
})({
    canAutoUpdate: function (_a) {
        var newParams = _a.newParams;
        return newParams.transform.name !== 'matrix';
    },
    apply: function (_a) {
        // TODO: optimze
        // TODO: think of ways how to fast-track changes to this for animations
        var a = _a.a, params = _a.params;
        var transform = Object(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_4__["Mat4"])();
        if (params.transform.name === 'components') {
            var _b = params.transform.params, axis = _b.axis, angle = _b.angle, translation = _b.translation;
            var center = a.data.boundary.sphere.center;
            _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_4__["Mat4"].fromTranslation(_m, _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_4__["Vec3"].negate(_translation, center));
            _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_4__["Mat4"].fromTranslation(_n, _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_4__["Vec3"].add(_translation, center, translation));
            var rot = _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_4__["Mat4"].fromRotation(Object(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_4__["Mat4"])(), Math.PI / 180 * angle, _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_4__["Vec3"].normalize(Object(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_4__["Vec3"])(), axis));
            _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_4__["Mat4"].mul3(transform, _n, rot, _m);
        }
        else if (params.transform.name === 'matrix') {
            _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_4__["Mat4"].copy(transform, params.transform.params.data);
            if (params.transform.params.transpose)
                _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_4__["Mat4"].transpose(transform, transform);
        }
        var s = _mol_model_structure__WEBPACK_IMPORTED_MODULE_11__["Structure"].transform(a.data, transform);
        return new _objects__WEBPACK_IMPORTED_MODULE_22__["PluginStateObject"].Molecule.Structure(s, { label: a.label, description: a.description + " [Transformed]" });
    },
    dispose: function (_a) {
        var b = _a.b;
        b === null || b === void 0 ? void 0 : b.data.customPropertyDescriptors.dispose();
    }
    // interpolate(src, tar, t) {
    //     // TODO: optimize
    //     const u = Mat4.fromRotation(Mat4(), Math.PI / 180 * src.angle, Vec3.normalize(Vec3(), src.axis));
    //     Mat4.setTranslation(u, src.translation);
    //     const v = Mat4.fromRotation(Mat4(), Math.PI / 180 * tar.angle, Vec3.normalize(Vec3(), tar.axis));
    //     Mat4.setTranslation(v, tar.translation);
    //     const m = SymmetryOperator.slerp(Mat4(), u, v, t);
    //     const rot = Mat4.getRotation(Quat.zero(), m);
    //     const axis = Vec3();
    //     const angle = Quat.getAxisAngle(axis, rot);
    //     const translation = Mat4.getTranslation(Vec3(), m);
    //     return { axis, angle, translation };
    // }
});
var StructureSelectionFromExpression = _objects__WEBPACK_IMPORTED_MODULE_22__["PluginStateTransform"].BuiltIn({
    name: 'structure-selection-from-expression',
    display: { name: 'Selection', description: 'Create a molecular structure from the specified expression.' },
    from: _objects__WEBPACK_IMPORTED_MODULE_22__["PluginStateObject"].Molecule.Structure,
    to: _objects__WEBPACK_IMPORTED_MODULE_22__["PluginStateObject"].Molecule.Structure,
    params: {
        expression: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_17__["ParamDefinition"].Value(_mol_script_language_builder__WEBPACK_IMPORTED_MODULE_12__["MolScriptBuilder"].struct.generator.all, { isHidden: true }),
        label: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_17__["ParamDefinition"].Optional(_mol_util_param_definition__WEBPACK_IMPORTED_MODULE_17__["ParamDefinition"].Text('', { isHidden: true }))
    }
})({
    apply: function (_a) {
        var a = _a.a, params = _a.params, cache = _a.cache;
        var _b = _helpers_structure_query__WEBPACK_IMPORTED_MODULE_20__["StructureQueryHelper"].createAndRun(a.data, params.expression), selection = _b.selection, entry = _b.entry;
        cache.entry = entry;
        if (_mol_model_structure__WEBPACK_IMPORTED_MODULE_11__["StructureSelection"].isEmpty(selection))
            return _mol_state__WEBPACK_IMPORTED_MODULE_14__["StateObject"].Null;
        var s = _mol_model_structure__WEBPACK_IMPORTED_MODULE_11__["StructureSelection"].unionStructure(selection);
        var props = { label: "" + (params.label || 'Selection'), description: _mol_model_structure__WEBPACK_IMPORTED_MODULE_11__["Structure"].elementDescription(s) };
        return new _objects__WEBPACK_IMPORTED_MODULE_22__["PluginStateObject"].Molecule.Structure(s, props);
    },
    update: function (_a) {
        var a = _a.a, b = _a.b, oldParams = _a.oldParams, newParams = _a.newParams, cache = _a.cache;
        if (oldParams.expression !== newParams.expression)
            return _mol_state__WEBPACK_IMPORTED_MODULE_14__["StateTransformer"].UpdateResult.Recreate;
        var entry = cache.entry;
        if (entry.currentStructure === a.data) {
            return _mol_state__WEBPACK_IMPORTED_MODULE_14__["StateTransformer"].UpdateResult.Unchanged;
        }
        var selection = _helpers_structure_query__WEBPACK_IMPORTED_MODULE_20__["StructureQueryHelper"].updateStructure(entry, a.data);
        if (_mol_model_structure__WEBPACK_IMPORTED_MODULE_11__["StructureSelection"].isEmpty(selection))
            return _mol_state__WEBPACK_IMPORTED_MODULE_14__["StateTransformer"].UpdateResult.Null;
        _helpers_structure_query__WEBPACK_IMPORTED_MODULE_20__["StructureQueryHelper"].updateStructureObject(b, selection, newParams.label);
        return _mol_state__WEBPACK_IMPORTED_MODULE_14__["StateTransformer"].UpdateResult.Updated;
    },
    dispose: function (_a) {
        var b = _a.b;
        b === null || b === void 0 ? void 0 : b.data.customPropertyDescriptors.dispose();
    }
});
var MultiStructureSelectionFromExpression = _objects__WEBPACK_IMPORTED_MODULE_22__["PluginStateTransform"].BuiltIn({
    name: 'structure-multi-selection-from-expression',
    display: { name: 'Multi-structure Measurement Selection', description: 'Create selection object from multiple structures.' },
    from: _objects__WEBPACK_IMPORTED_MODULE_22__["PluginStateObject"].Root,
    to: _objects__WEBPACK_IMPORTED_MODULE_22__["PluginStateObject"].Molecule.Structure.Selections,
    params: {
        selections: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_17__["ParamDefinition"].ObjectList({
            key: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_17__["ParamDefinition"].Text(void 0, { description: 'A unique key.' }),
            ref: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_17__["ParamDefinition"].Text(),
            groupId: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_17__["ParamDefinition"].Optional(_mol_util_param_definition__WEBPACK_IMPORTED_MODULE_17__["ParamDefinition"].Text()),
            expression: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_17__["ParamDefinition"].Value(_mol_script_language_builder__WEBPACK_IMPORTED_MODULE_12__["MolScriptBuilder"].struct.generator.empty)
        }, function (e) { return e.ref; }, { isHidden: true }),
        isTransitive: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_17__["ParamDefinition"].Optional(_mol_util_param_definition__WEBPACK_IMPORTED_MODULE_17__["ParamDefinition"].Boolean(false, { isHidden: true, description: 'Remap the selections from the original structure if structurally equivalent.' })),
        label: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_17__["ParamDefinition"].Optional(_mol_util_param_definition__WEBPACK_IMPORTED_MODULE_17__["ParamDefinition"].Text('', { isHidden: true }))
    }
})({
    apply: function (_a) {
        var params = _a.params, cache = _a.cache, dependencies = _a.dependencies;
        var entries = new Map();
        var selections = [];
        var totalSize = 0;
        for (var _i = 0, _b = params.selections; _i < _b.length; _i++) {
            var sel = _b[_i];
            var _c = _helpers_structure_query__WEBPACK_IMPORTED_MODULE_20__["StructureQueryHelper"].createAndRun(dependencies[sel.ref].data, sel.expression), selection = _c.selection, entry = _c.entry;
            entries.set(sel.key, entry);
            var loci = _mol_model_structure__WEBPACK_IMPORTED_MODULE_11__["StructureSelection"].toLociWithSourceUnits(selection);
            selections.push({ key: sel.key, loci: loci, groupId: sel.groupId });
            totalSize += _mol_model_structure__WEBPACK_IMPORTED_MODULE_11__["StructureElement"].Loci.size(loci);
        }
        cache.entries = entries;
        var props = { label: "" + (params.label || 'Multi-selection'), description: params.selections.length + " source(s), " + totalSize + " element(s) total" };
        return new _objects__WEBPACK_IMPORTED_MODULE_22__["PluginStateObject"].Molecule.Structure.Selections(selections, props);
    },
    update: function (_a) {
        var b = _a.b, oldParams = _a.oldParams, newParams = _a.newParams, cache = _a.cache, dependencies = _a.dependencies;
        if (!!oldParams.isTransitive !== !!newParams.isTransitive)
            return _mol_state__WEBPACK_IMPORTED_MODULE_14__["StateTransformer"].UpdateResult.Recreate;
        var cacheEntries = cache.entries;
        var entries = new Map();
        var current = new Map();
        for (var _i = 0, _b = b.data; _i < _b.length; _i++) {
            var e = _b[_i];
            current.set(e.key, e);
        }
        var changed = false;
        var totalSize = 0;
        var selections = [];
        for (var _c = 0, _d = newParams.selections; _c < _d.length; _c++) {
            var sel = _d[_c];
            var structure = dependencies[sel.ref].data;
            var recreate = false;
            if (cacheEntries.has(sel.key)) {
                var entry = cacheEntries.get(sel.key);
                if (_helpers_structure_query__WEBPACK_IMPORTED_MODULE_20__["StructureQueryHelper"].isUnchanged(entry, sel.expression, structure) && current.has(sel.key)) {
                    var loci = current.get(sel.key);
                    if (loci.groupId !== sel.groupId) {
                        loci.groupId = sel.groupId;
                        changed = true;
                    }
                    entries.set(sel.key, entry);
                    selections.push(loci);
                    totalSize += _mol_model_structure__WEBPACK_IMPORTED_MODULE_11__["StructureElement"].Loci.size(loci.loci);
                    continue;
                }
                if (entry.expression !== sel.expression) {
                    recreate = true;
                }
                else {
                    // TODO: properly support "transitive" queries. For that Structure.areUnitAndIndicesEqual needs to be fixed;
                    var update = false;
                    if (!!newParams.isTransitive) {
                        if (_mol_model_structure__WEBPACK_IMPORTED_MODULE_11__["Structure"].areUnitIdsAndIndicesEqual(entry.originalStructure, structure)) {
                            var selection = _helpers_structure_query__WEBPACK_IMPORTED_MODULE_20__["StructureQueryHelper"].run(entry, entry.originalStructure);
                            entry.currentStructure = structure;
                            entries.set(sel.key, entry);
                            var loci = _mol_model_structure__WEBPACK_IMPORTED_MODULE_11__["StructureElement"].Loci.remap(_mol_model_structure__WEBPACK_IMPORTED_MODULE_11__["StructureSelection"].toLociWithSourceUnits(selection), structure);
                            selections.push({ key: sel.key, loci: loci, groupId: sel.groupId });
                            totalSize += _mol_model_structure__WEBPACK_IMPORTED_MODULE_11__["StructureElement"].Loci.size(loci);
                            changed = true;
                        }
                        else {
                            update = true;
                        }
                    }
                    else {
                        update = true;
                    }
                    if (update) {
                        changed = true;
                        var selection = _helpers_structure_query__WEBPACK_IMPORTED_MODULE_20__["StructureQueryHelper"].updateStructure(entry, structure);
                        entries.set(sel.key, entry);
                        var loci = _mol_model_structure__WEBPACK_IMPORTED_MODULE_11__["StructureSelection"].toLociWithSourceUnits(selection);
                        selections.push({ key: sel.key, loci: loci, groupId: sel.groupId });
                        totalSize += _mol_model_structure__WEBPACK_IMPORTED_MODULE_11__["StructureElement"].Loci.size(loci);
                    }
                }
            }
            else {
                recreate = true;
            }
            if (recreate) {
                changed = true;
                // create new selection
                var _e = _helpers_structure_query__WEBPACK_IMPORTED_MODULE_20__["StructureQueryHelper"].createAndRun(structure, sel.expression), selection = _e.selection, entry = _e.entry;
                entries.set(sel.key, entry);
                var loci = _mol_model_structure__WEBPACK_IMPORTED_MODULE_11__["StructureSelection"].toLociWithSourceUnits(selection);
                selections.push({ key: sel.key, loci: loci });
                totalSize += _mol_model_structure__WEBPACK_IMPORTED_MODULE_11__["StructureElement"].Loci.size(loci);
            }
        }
        if (!changed)
            return _mol_state__WEBPACK_IMPORTED_MODULE_14__["StateTransformer"].UpdateResult.Unchanged;
        cache.entries = entries;
        b.data = selections;
        b.label = "" + (newParams.label || 'Multi-selection');
        b.description = selections.length + " source(s), " + totalSize + " element(s) total";
        return _mol_state__WEBPACK_IMPORTED_MODULE_14__["StateTransformer"].UpdateResult.Updated;
    }
});
var StructureSelectionFromScript = _objects__WEBPACK_IMPORTED_MODULE_22__["PluginStateTransform"].BuiltIn({
    name: 'structure-selection-from-script',
    display: { name: 'Selection', description: 'Create a molecular structure from the specified script.' },
    from: _objects__WEBPACK_IMPORTED_MODULE_22__["PluginStateObject"].Molecule.Structure,
    to: _objects__WEBPACK_IMPORTED_MODULE_22__["PluginStateObject"].Molecule.Structure,
    params: {
        script: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_17__["ParamDefinition"].Script({ language: 'mol-script', expression: '(sel.atom.atom-groups :residue-test (= atom.resname ALA))' }),
        label: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_17__["ParamDefinition"].Optional(_mol_util_param_definition__WEBPACK_IMPORTED_MODULE_17__["ParamDefinition"].Text(''))
    }
})({
    apply: function (_a) {
        var a = _a.a, params = _a.params, cache = _a.cache;
        var _b = _helpers_structure_query__WEBPACK_IMPORTED_MODULE_20__["StructureQueryHelper"].createAndRun(a.data, params.script), selection = _b.selection, entry = _b.entry;
        cache.entry = entry;
        var s = _mol_model_structure__WEBPACK_IMPORTED_MODULE_11__["StructureSelection"].unionStructure(selection);
        var props = { label: "" + (params.label || 'Selection'), description: _mol_model_structure__WEBPACK_IMPORTED_MODULE_11__["Structure"].elementDescription(s) };
        return new _objects__WEBPACK_IMPORTED_MODULE_22__["PluginStateObject"].Molecule.Structure(s, props);
    },
    update: function (_a) {
        var a = _a.a, b = _a.b, oldParams = _a.oldParams, newParams = _a.newParams, cache = _a.cache;
        if (!_mol_script_script__WEBPACK_IMPORTED_MODULE_13__["Script"].areEqual(oldParams.script, newParams.script)) {
            return _mol_state__WEBPACK_IMPORTED_MODULE_14__["StateTransformer"].UpdateResult.Recreate;
        }
        var entry = cache.entry;
        if (entry.currentStructure === a.data) {
            return _mol_state__WEBPACK_IMPORTED_MODULE_14__["StateTransformer"].UpdateResult.Unchanged;
        }
        var selection = _helpers_structure_query__WEBPACK_IMPORTED_MODULE_20__["StructureQueryHelper"].updateStructure(entry, a.data);
        _helpers_structure_query__WEBPACK_IMPORTED_MODULE_20__["StructureQueryHelper"].updateStructureObject(b, selection, newParams.label);
        return _mol_state__WEBPACK_IMPORTED_MODULE_14__["StateTransformer"].UpdateResult.Updated;
    },
    dispose: function (_a) {
        var b = _a.b;
        b === null || b === void 0 ? void 0 : b.data.customPropertyDescriptors.dispose();
    }
});
var StructureSelectionFromBundle = _objects__WEBPACK_IMPORTED_MODULE_22__["PluginStateTransform"].BuiltIn({
    name: 'structure-selection-from-bundle',
    display: { name: 'Selection', description: 'Create a molecular structure from the specified structure-element bundle.' },
    from: _objects__WEBPACK_IMPORTED_MODULE_22__["PluginStateObject"].Molecule.Structure,
    to: _objects__WEBPACK_IMPORTED_MODULE_22__["PluginStateObject"].Molecule.Structure,
    params: {
        bundle: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_17__["ParamDefinition"].Value(_mol_model_structure__WEBPACK_IMPORTED_MODULE_11__["StructureElement"].Bundle.Empty, { isHidden: true }),
        label: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_17__["ParamDefinition"].Optional(_mol_util_param_definition__WEBPACK_IMPORTED_MODULE_17__["ParamDefinition"].Text('', { isHidden: true }))
    }
})({
    apply: function (_a) {
        var a = _a.a, params = _a.params, cache = _a.cache;
        if (params.bundle.hash !== a.data.hashCode) {
            return _mol_state__WEBPACK_IMPORTED_MODULE_14__["StateObject"].Null;
        }
        cache.source = a.data;
        var s = _mol_model_structure__WEBPACK_IMPORTED_MODULE_11__["StructureElement"].Bundle.toStructure(params.bundle, a.data);
        if (s.elementCount === 0)
            return _mol_state__WEBPACK_IMPORTED_MODULE_14__["StateObject"].Null;
        var props = { label: "" + (params.label || 'Selection'), description: _mol_model_structure__WEBPACK_IMPORTED_MODULE_11__["Structure"].elementDescription(s) };
        return new _objects__WEBPACK_IMPORTED_MODULE_22__["PluginStateObject"].Molecule.Structure(s, props);
    },
    update: function (_a) {
        var a = _a.a, b = _a.b, oldParams = _a.oldParams, newParams = _a.newParams, cache = _a.cache;
        if (!_mol_model_structure__WEBPACK_IMPORTED_MODULE_11__["StructureElement"].Bundle.areEqual(oldParams.bundle, newParams.bundle)) {
            return _mol_state__WEBPACK_IMPORTED_MODULE_14__["StateTransformer"].UpdateResult.Recreate;
        }
        if (newParams.bundle.hash !== a.data.hashCode) {
            return _mol_state__WEBPACK_IMPORTED_MODULE_14__["StateTransformer"].UpdateResult.Null;
        }
        if (cache.source === a.data) {
            return _mol_state__WEBPACK_IMPORTED_MODULE_14__["StateTransformer"].UpdateResult.Unchanged;
        }
        cache.source = a.data;
        var s = _mol_model_structure__WEBPACK_IMPORTED_MODULE_11__["StructureElement"].Bundle.toStructure(newParams.bundle, a.data);
        if (s.elementCount === 0)
            return _mol_state__WEBPACK_IMPORTED_MODULE_14__["StateTransformer"].UpdateResult.Null;
        b.label = "" + (newParams.label || 'Selection');
        b.description = _mol_model_structure__WEBPACK_IMPORTED_MODULE_11__["Structure"].elementDescription(s);
        b.data = s;
        return _mol_state__WEBPACK_IMPORTED_MODULE_14__["StateTransformer"].UpdateResult.Updated;
    },
    dispose: function (_a) {
        var b = _a.b;
        b === null || b === void 0 ? void 0 : b.data.customPropertyDescriptors.dispose();
    }
});
var StructureComplexElementTypes = {
    'polymer': 'polymer',
    'protein': 'protein',
    'nucleic': 'nucleic',
    'water': 'water',
    'branched': 'branched',
    'ligand': 'ligand',
    'non-standard': 'non-standard',
    'coarse': 'coarse',
    // Legacy
    'atomic-sequence': 'atomic-sequence',
    'atomic-het': 'atomic-het',
    'spheres': 'spheres'
};
var StructureComplexElementTypeTuples = _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_17__["ParamDefinition"].objectToOptions(StructureComplexElementTypes);
var StructureComplexElement = _objects__WEBPACK_IMPORTED_MODULE_22__["PluginStateTransform"].BuiltIn({
    name: 'structure-complex-element',
    display: { name: 'Complex Element', description: 'Create a molecular structure from the specified model.' },
    from: _objects__WEBPACK_IMPORTED_MODULE_22__["PluginStateObject"].Molecule.Structure,
    to: _objects__WEBPACK_IMPORTED_MODULE_22__["PluginStateObject"].Molecule.Structure,
    params: { type: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_17__["ParamDefinition"].Select('atomic-sequence', StructureComplexElementTypeTuples, { isHidden: true }) }
})({
    apply: function (_a) {
        // TODO: update function.
        var a = _a.a, params = _a.params;
        var query, label;
        switch (params.type) {
            case 'polymer':
                query = _helpers_structure_selection_query__WEBPACK_IMPORTED_MODULE_21__["StructureSelectionQueries"].polymer.query;
                label = 'Polymer';
                break;
            case 'protein':
                query = _helpers_structure_selection_query__WEBPACK_IMPORTED_MODULE_21__["StructureSelectionQueries"].protein.query;
                label = 'Protein';
                break;
            case 'nucleic':
                query = _helpers_structure_selection_query__WEBPACK_IMPORTED_MODULE_21__["StructureSelectionQueries"].nucleic.query;
                label = 'Nucleic';
                break;
            case 'water':
                query = _mol_model_structure__WEBPACK_IMPORTED_MODULE_11__["Queries"].internal.water();
                label = 'Water';
                break;
            case 'branched':
                query = _helpers_structure_selection_query__WEBPACK_IMPORTED_MODULE_21__["StructureSelectionQueries"].branchedPlusConnected.query;
                label = 'Branched';
                break;
            case 'ligand':
                query = _helpers_structure_selection_query__WEBPACK_IMPORTED_MODULE_21__["StructureSelectionQueries"].ligandPlusConnected.query;
                label = 'Ligand';
                break;
            case 'non-standard':
                query = _helpers_structure_selection_query__WEBPACK_IMPORTED_MODULE_21__["StructureSelectionQueries"].nonStandardPolymer.query;
                label = 'Non-standard';
                break;
            case 'coarse':
                query = _helpers_structure_selection_query__WEBPACK_IMPORTED_MODULE_21__["StructureSelectionQueries"].coarse.query;
                label = 'Coarse';
                break;
            case 'atomic-sequence':
                query = _mol_model_structure__WEBPACK_IMPORTED_MODULE_11__["Queries"].internal.atomicSequence();
                label = 'Sequence';
                break;
            case 'atomic-het':
                query = _mol_model_structure__WEBPACK_IMPORTED_MODULE_11__["Queries"].internal.atomicHet();
                label = 'HET Groups/Ligands';
                break;
            case 'spheres':
                query = _mol_model_structure__WEBPACK_IMPORTED_MODULE_11__["Queries"].internal.spheres();
                label = 'Coarse Spheres';
                break;
            default: throw new Error(params.type + " is a not valid complex element.");
        }
        var result = query(new _mol_model_structure__WEBPACK_IMPORTED_MODULE_11__["QueryContext"](a.data));
        var s = _mol_model_structure__WEBPACK_IMPORTED_MODULE_11__["StructureSelection"].unionStructure(result);
        if (s.elementCount === 0)
            return _mol_state__WEBPACK_IMPORTED_MODULE_14__["StateObject"].Null;
        return new _objects__WEBPACK_IMPORTED_MODULE_22__["PluginStateObject"].Molecule.Structure(s, { label: label, description: _mol_model_structure__WEBPACK_IMPORTED_MODULE_11__["Structure"].elementDescription(s) });
    },
    dispose: function (_a) {
        var b = _a.b;
        b === null || b === void 0 ? void 0 : b.data.customPropertyDescriptors.dispose();
    }
});
var StructureComponent = _objects__WEBPACK_IMPORTED_MODULE_22__["PluginStateTransform"].BuiltIn({
    name: 'structure-component',
    display: { name: 'Component', description: 'A molecular structure component.' },
    from: _objects__WEBPACK_IMPORTED_MODULE_22__["PluginStateObject"].Molecule.Structure,
    to: _objects__WEBPACK_IMPORTED_MODULE_22__["PluginStateObject"].Molecule.Structure,
    params: _helpers_structure_component__WEBPACK_IMPORTED_MODULE_19__["StructureComponentParams"]
})({
    apply: function (_a) {
        var a = _a.a, params = _a.params, cache = _a.cache;
        return Object(_helpers_structure_component__WEBPACK_IMPORTED_MODULE_19__["createStructureComponent"])(a.data, params, cache);
    },
    update: function (_a) {
        var a = _a.a, b = _a.b, oldParams = _a.oldParams, newParams = _a.newParams, cache = _a.cache;
        return Object(_helpers_structure_component__WEBPACK_IMPORTED_MODULE_19__["updateStructureComponent"])(a.data, b, oldParams, newParams, cache);
    },
    dispose: function (_a) {
        var b = _a.b;
        b === null || b === void 0 ? void 0 : b.data.customPropertyDescriptors.dispose();
    }
});
var CustomModelProperties = _objects__WEBPACK_IMPORTED_MODULE_22__["PluginStateTransform"].BuiltIn({
    name: 'custom-model-properties',
    display: { name: 'Custom Model Properties' },
    isDecorator: true,
    from: _objects__WEBPACK_IMPORTED_MODULE_22__["PluginStateObject"].Molecule.Model,
    to: _objects__WEBPACK_IMPORTED_MODULE_22__["PluginStateObject"].Molecule.Model,
    params: function (a, ctx) {
        return ctx.customModelProperties.getParams(a === null || a === void 0 ? void 0 : a.data);
    }
})({
    apply: function (_a, ctx) {
        var _this = this;
        var a = _a.a, params = _a.params;
        return _mol_task__WEBPACK_IMPORTED_MODULE_15__["Task"].create('Custom Props', function (taskCtx) { return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"])(_this, void 0, void 0, function () {
            return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__generator"])(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, attachModelProps(a.data, ctx, taskCtx, params)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/, new _objects__WEBPACK_IMPORTED_MODULE_22__["PluginStateObject"].Molecule.Model(a.data, { label: a.label, description: a.description })];
                }
            });
        }); });
    },
    update: function (_a, ctx) {
        var _this = this;
        var a = _a.a, b = _a.b, oldParams = _a.oldParams, newParams = _a.newParams;
        return _mol_task__WEBPACK_IMPORTED_MODULE_15__["Task"].create('Custom Props', function (taskCtx) { return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"])(_this, void 0, void 0, function () {
            var _i, _a, name_1, property;
            return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__generator"])(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        b.data = a.data;
                        b.label = a.label;
                        b.description = a.description;
                        for (_i = 0, _a = oldParams.autoAttach; _i < _a.length; _i++) {
                            name_1 = _a[_i];
                            property = ctx.customModelProperties.get(name_1);
                            if (!property)
                                continue;
                            a.data.customProperties.reference(property.descriptor, false);
                        }
                        return [4 /*yield*/, attachModelProps(a.data, ctx, taskCtx, newParams)];
                    case 1:
                        _b.sent();
                        return [2 /*return*/, _mol_state__WEBPACK_IMPORTED_MODULE_14__["StateTransformer"].UpdateResult.Updated];
                }
            });
        }); });
    },
    dispose: function (_a) {
        var b = _a.b;
        b === null || b === void 0 ? void 0 : b.data.customProperties.dispose();
    }
});
function attachModelProps(model, ctx, taskCtx, params) {
    return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"])(this, void 0, void 0, function () {
        var propertyCtx, autoAttach, properties, _i, _a, name_2, property, props, e_1;
        return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__generator"])(this, function (_b) {
            switch (_b.label) {
                case 0:
                    propertyCtx = { runtime: taskCtx, assetManager: ctx.managers.asset };
                    autoAttach = params.autoAttach, properties = params.properties;
                    _i = 0, _a = Object.keys(properties);
                    _b.label = 1;
                case 1:
                    if (!(_i < _a.length)) return [3 /*break*/, 8];
                    name_2 = _a[_i];
                    property = ctx.customModelProperties.get(name_2);
                    props = properties[name_2];
                    if (!(autoAttach.includes(name_2) || property.isHidden)) return [3 /*break*/, 6];
                    _b.label = 2;
                case 2:
                    _b.trys.push([2, 4, , 5]);
                    return [4 /*yield*/, property.attach(propertyCtx, model, props, true)];
                case 3:
                    _b.sent();
                    return [3 /*break*/, 5];
                case 4:
                    e_1 = _b.sent();
                    ctx.log.warn("Error attaching model prop '" + name_2 + "': " + e_1);
                    return [3 /*break*/, 5];
                case 5: return [3 /*break*/, 7];
                case 6:
                    property.set(model, props);
                    _b.label = 7;
                case 7:
                    _i++;
                    return [3 /*break*/, 1];
                case 8: return [2 /*return*/];
            }
        });
    });
}
var CustomStructureProperties = _objects__WEBPACK_IMPORTED_MODULE_22__["PluginStateTransform"].BuiltIn({
    name: 'custom-structure-properties',
    display: { name: 'Custom Structure Properties' },
    isDecorator: true,
    from: _objects__WEBPACK_IMPORTED_MODULE_22__["PluginStateObject"].Molecule.Structure,
    to: _objects__WEBPACK_IMPORTED_MODULE_22__["PluginStateObject"].Molecule.Structure,
    params: function (a, ctx) {
        return ctx.customStructureProperties.getParams(a === null || a === void 0 ? void 0 : a.data.root);
    }
})({
    apply: function (_a, ctx) {
        var _this = this;
        var a = _a.a, params = _a.params;
        return _mol_task__WEBPACK_IMPORTED_MODULE_15__["Task"].create('Custom Props', function (taskCtx) { return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"])(_this, void 0, void 0, function () {
            return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__generator"])(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, attachStructureProps(a.data.root, ctx, taskCtx, params)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/, new _objects__WEBPACK_IMPORTED_MODULE_22__["PluginStateObject"].Molecule.Structure(a.data, { label: a.label, description: a.description })];
                }
            });
        }); });
    },
    update: function (_a, ctx) {
        var _this = this;
        var a = _a.a, b = _a.b, oldParams = _a.oldParams, newParams = _a.newParams;
        if (a.data !== b.data)
            return _mol_state__WEBPACK_IMPORTED_MODULE_14__["StateTransformer"].UpdateResult.Recreate;
        return _mol_task__WEBPACK_IMPORTED_MODULE_15__["Task"].create('Custom Props', function (taskCtx) { return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"])(_this, void 0, void 0, function () {
            var _i, _a, name_3, property;
            return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__generator"])(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        b.data = a.data;
                        b.label = a.label;
                        b.description = a.description;
                        for (_i = 0, _a = oldParams.autoAttach; _i < _a.length; _i++) {
                            name_3 = _a[_i];
                            property = ctx.customStructureProperties.get(name_3);
                            if (!property)
                                continue;
                            a.data.customPropertyDescriptors.reference(property.descriptor, false);
                        }
                        return [4 /*yield*/, attachStructureProps(a.data.root, ctx, taskCtx, newParams)];
                    case 1:
                        _b.sent();
                        return [2 /*return*/, _mol_state__WEBPACK_IMPORTED_MODULE_14__["StateTransformer"].UpdateResult.Updated];
                }
            });
        }); });
    },
    dispose: function (_a) {
        var b = _a.b;
        b === null || b === void 0 ? void 0 : b.data.customPropertyDescriptors.dispose();
    }
});
function attachStructureProps(structure, ctx, taskCtx, params) {
    return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"])(this, void 0, void 0, function () {
        var propertyCtx, autoAttach, properties, _i, _a, name_4, property, props, e_2;
        return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__generator"])(this, function (_b) {
            switch (_b.label) {
                case 0:
                    propertyCtx = { runtime: taskCtx, assetManager: ctx.managers.asset };
                    autoAttach = params.autoAttach, properties = params.properties;
                    _i = 0, _a = Object.keys(properties);
                    _b.label = 1;
                case 1:
                    if (!(_i < _a.length)) return [3 /*break*/, 8];
                    name_4 = _a[_i];
                    property = ctx.customStructureProperties.get(name_4);
                    props = properties[name_4];
                    if (!(autoAttach.includes(name_4) || property.isHidden)) return [3 /*break*/, 6];
                    _b.label = 2;
                case 2:
                    _b.trys.push([2, 4, , 5]);
                    return [4 /*yield*/, property.attach(propertyCtx, structure, props, true)];
                case 3:
                    _b.sent();
                    return [3 /*break*/, 5];
                case 4:
                    e_2 = _b.sent();
                    ctx.log.warn("Error attaching structure prop '" + name_4 + "': " + e_2);
                    return [3 /*break*/, 5];
                case 5: return [3 /*break*/, 7];
                case 6:
                    property.set(structure, props);
                    _b.label = 7;
                case 7:
                    _i++;
                    return [3 /*break*/, 1];
                case 8: return [2 /*return*/];
            }
        });
    });
}
var ShapeFromPly = _objects__WEBPACK_IMPORTED_MODULE_22__["PluginStateTransform"].BuiltIn({
    name: 'shape-from-ply',
    display: { name: 'Shape from PLY', description: 'Create Shape from PLY data' },
    from: _objects__WEBPACK_IMPORTED_MODULE_22__["PluginStateObject"].Format.Ply,
    to: _objects__WEBPACK_IMPORTED_MODULE_22__["PluginStateObject"].Shape.Provider,
    params: function (a) {
        return {};
    }
})({
    apply: function (_a) {
        var _this = this;
        var a = _a.a, params = _a.params;
        return _mol_task__WEBPACK_IMPORTED_MODULE_15__["Task"].create('Create shape from PLY', function (ctx) { return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"])(_this, void 0, void 0, function () {
            var shape, props;
            return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__generator"])(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, Object(_mol_model_formats_shape_ply__WEBPACK_IMPORTED_MODULE_5__["shapeFromPly"])(a.data, params).runInContext(ctx)];
                    case 1:
                        shape = _a.sent();
                        props = { label: 'Shape' };
                        return [2 /*return*/, new _objects__WEBPACK_IMPORTED_MODULE_22__["PluginStateObject"].Shape.Provider(shape, props)];
                }
            });
        }); });
    }
});
//# sourceMappingURL=model.js.map

/***/ }),

/***/ "./lib/mol-plugin-state/transforms/representation.js":
/*!***********************************************************!*\
  !*** ./lib/mol-plugin-state/transforms/representation.js ***!
  \***********************************************************/
/*! exports provided: StructureRepresentation3D, ExplodeStructureRepresentation3D, UnwindStructureAssemblyRepresentation3D, OverpaintStructureRepresentation3DFromScript, OverpaintStructureRepresentation3DFromBundle, TransparencyStructureRepresentation3DFromScript, TransparencyStructureRepresentation3DFromBundle, ClippingStructureRepresentation3DFromScript, ClippingStructureRepresentation3DFromBundle, VolumeRepresentation3D, VolumeRepresentation3DHelpers, ShapeRepresentation3D, ModelUnitcell3D, StructureSelectionsDistance3D, StructureSelectionsAngle3D, StructureSelectionsDihedral3D, StructureSelectionsLabel3D, StructureSelectionsOrientation3D */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "StructureRepresentation3D", function() { return StructureRepresentation3D; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ExplodeStructureRepresentation3D", function() { return ExplodeStructureRepresentation3D; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "UnwindStructureAssemblyRepresentation3D", function() { return UnwindStructureAssemblyRepresentation3D; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "OverpaintStructureRepresentation3DFromScript", function() { return OverpaintStructureRepresentation3DFromScript; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "OverpaintStructureRepresentation3DFromBundle", function() { return OverpaintStructureRepresentation3DFromBundle; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "TransparencyStructureRepresentation3DFromScript", function() { return TransparencyStructureRepresentation3DFromScript; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "TransparencyStructureRepresentation3DFromBundle", function() { return TransparencyStructureRepresentation3DFromBundle; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ClippingStructureRepresentation3DFromScript", function() { return ClippingStructureRepresentation3DFromScript; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ClippingStructureRepresentation3DFromBundle", function() { return ClippingStructureRepresentation3DFromBundle; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "VolumeRepresentation3D", function() { return VolumeRepresentation3D; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "VolumeRepresentation3DHelpers", function() { return VolumeRepresentation3DHelpers; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ShapeRepresentation3D", function() { return ShapeRepresentation3D; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ModelUnitcell3D", function() { return ModelUnitcell3D; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "StructureSelectionsDistance3D", function() { return StructureSelectionsDistance3D; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "StructureSelectionsAngle3D", function() { return StructureSelectionsAngle3D; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "StructureSelectionsDihedral3D", function() { return StructureSelectionsDihedral3D; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "StructureSelectionsLabel3D", function() { return StructureSelectionsLabel3D; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "StructureSelectionsOrientation3D", function() { return StructureSelectionsOrientation3D; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _mol_model_structure__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../mol-model/structure */ "./lib/mol-model/structure.js");
/* harmony import */ var _mol_model_volume__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../mol-model/volume */ "./lib/mol-model/volume.js");
/* harmony import */ var _mol_state__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../mol-state */ "./lib/mol-state/index.js");
/* harmony import */ var _mol_task__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../mol-task */ "./lib/mol-task/index.js");
/* harmony import */ var _mol_theme_theme__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../mol-theme/theme */ "./lib/mol-theme/theme.js");
/* harmony import */ var _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../../mol-util/param-definition */ "./lib/mol-util/param-definition.js");
/* harmony import */ var _objects__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../objects */ "./lib/mol-plugin-state/objects.js");
/* harmony import */ var _mol_util_color_names__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ../../mol-util/color/names */ "./lib/mol-util/color/names.js");
/* harmony import */ var _mol_repr_shape_representation__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ../../mol-repr/shape/representation */ "./lib/mol-repr/shape/representation.js");
/* harmony import */ var _mol_model_structure_structure_util_unit_transforms__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ../../mol-model/structure/structure/util/unit-transforms */ "./lib/mol-model/structure/structure/util/unit-transforms.js");
/* harmony import */ var _animation_helpers__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ../animation/helpers */ "./lib/mol-plugin-state/animation/helpers.js");
/* harmony import */ var _mol_util_color__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! ../../mol-util/color */ "./lib/mol-util/color/index.js");
/* harmony import */ var _mol_theme_overpaint__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! ../../mol-theme/overpaint */ "./lib/mol-theme/overpaint.js");
/* harmony import */ var _mol_theme_transparency__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! ../../mol-theme/transparency */ "./lib/mol-theme/transparency.js");
/* harmony import */ var _mol_geo_geometry_base__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! ../../mol-geo/geometry/base */ "./lib/mol-geo/geometry/base.js");
/* harmony import */ var _mol_script_script__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(/*! ../../mol-script/script */ "./lib/mol-script/script.js");
/* harmony import */ var _mol_repr_shape_model_unitcell__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(/*! ../../mol-repr/shape/model/unitcell */ "./lib/mol-repr/shape/model/unitcell.js");
/* harmony import */ var _mol_repr_shape_loci_distance__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(/*! ../../mol-repr/shape/loci/distance */ "./lib/mol-repr/shape/loci/distance.js");
/* harmony import */ var _helpers__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(/*! ./helpers */ "./lib/mol-plugin-state/transforms/helpers.js");
/* harmony import */ var _mol_repr_shape_loci_label__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(/*! ../../mol-repr/shape/loci/label */ "./lib/mol-repr/shape/loci/label.js");
/* harmony import */ var _mol_repr_shape_loci_orientation__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(/*! ../../mol-repr/shape/loci/orientation */ "./lib/mol-repr/shape/loci/orientation.js");
/* harmony import */ var _mol_repr_shape_loci_angle__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(/*! ../../mol-repr/shape/loci/angle */ "./lib/mol-repr/shape/loci/angle.js");
/* harmony import */ var _mol_repr_shape_loci_dihedral__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(/*! ../../mol-repr/shape/loci/dihedral */ "./lib/mol-repr/shape/loci/dihedral.js");
/* harmony import */ var _mol_model_formats_structure_property_symmetry__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(/*! ../../mol-model-formats/structure/property/symmetry */ "./lib/mol-model-formats/structure/property/symmetry.js");
/* harmony import */ var _mol_theme_clipping__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__(/*! ../../mol-theme/clipping */ "./lib/mol-theme/clipping.js");
/* harmony import */ var _mol_util_type_helpers__WEBPACK_IMPORTED_MODULE_26__ = __webpack_require__(/*! ../../mol-util/type-helpers */ "./lib/mol-util/type-helpers.js");
/**
 * Copyright (c) 2018-2020 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author David Sehnal <david.sehnal@gmail.com>
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */





































var StructureRepresentation3D = _objects__WEBPACK_IMPORTED_MODULE_7__["PluginStateTransform"].BuiltIn({
    name: 'structure-representation-3d',
    display: '3D Representation',
    from: _objects__WEBPACK_IMPORTED_MODULE_7__["PluginStateObject"].Molecule.Structure,
    to: _objects__WEBPACK_IMPORTED_MODULE_7__["PluginStateObject"].Molecule.Structure.Representation3D,
    params: function (a, ctx) {
        var _a = ctx.representation.structure, registry = _a.registry, themeCtx = _a.themes;
        var type = registry.get(registry.default.name);
        if (!a) {
            var colorThemeInfo_1 = {
                help: function (value) {
                    var name = value.name, params = value.params;
                    var p = themeCtx.colorThemeRegistry.get(name);
                    var ct = p.factory({}, params);
                    return { description: ct.description, legend: ct.legend };
                }
            };
            return {
                type: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_6__["ParamDefinition"].Mapped(registry.default.name, registry.types, function (name) { return _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_6__["ParamDefinition"].Group(registry.get(name).getParams(themeCtx, _mol_model_structure__WEBPACK_IMPORTED_MODULE_1__["Structure"].Empty)); }),
                colorTheme: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_6__["ParamDefinition"].Mapped(type.defaultColorTheme.name, themeCtx.colorThemeRegistry.types, function (name) { return _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_6__["ParamDefinition"].Group(themeCtx.colorThemeRegistry.get(name).getParams({ structure: _mol_model_structure__WEBPACK_IMPORTED_MODULE_1__["Structure"].Empty })); }, colorThemeInfo_1),
                sizeTheme: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_6__["ParamDefinition"].Mapped(type.defaultSizeTheme.name, themeCtx.sizeThemeRegistry.types, function (name) { return _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_6__["ParamDefinition"].Group(themeCtx.sizeThemeRegistry.get(name).getParams({ structure: _mol_model_structure__WEBPACK_IMPORTED_MODULE_1__["Structure"].Empty })); })
            };
        }
        var dataCtx = { structure: a.data };
        var colorThemeInfo = {
            help: function (value) {
                var name = value.name, params = value.params;
                var p = themeCtx.colorThemeRegistry.get(name);
                var ct = p.factory(dataCtx, params);
                return { description: ct.description, legend: ct.legend };
            }
        };
        return ({
            type: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_6__["ParamDefinition"].Mapped(registry.default.name, registry.getApplicableTypes(a.data), function (name) { return _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_6__["ParamDefinition"].Group(registry.get(name).getParams(themeCtx, a.data)); }),
            colorTheme: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_6__["ParamDefinition"].Mapped(type.defaultColorTheme.name, themeCtx.colorThemeRegistry.getApplicableTypes(dataCtx), function (name) { return _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_6__["ParamDefinition"].Group(themeCtx.colorThemeRegistry.get(name).getParams(dataCtx)); }, colorThemeInfo),
            sizeTheme: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_6__["ParamDefinition"].Mapped(type.defaultSizeTheme.name, themeCtx.sizeThemeRegistry.types, function (name) { return _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_6__["ParamDefinition"].Group(themeCtx.sizeThemeRegistry.get(name).getParams(dataCtx)); })
        });
    }
})({
    canAutoUpdate: function (_a) {
        var a = _a.a, oldParams = _a.oldParams, newParams = _a.newParams;
        // TODO: other criteria as well?
        return a.data.elementCount < 10000 || (oldParams.type.name === newParams.type.name && newParams.type.params.quality !== 'custom');
    },
    apply: function (_a, plugin) {
        var _this = this;
        var a = _a.a, params = _a.params, cache = _a.cache;
        return _mol_task__WEBPACK_IMPORTED_MODULE_4__["Task"].create('Structure Representation', function (ctx) { return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"])(_this, void 0, void 0, function () {
            var propertyCtx, provider, repr, props;
            var _a;
            return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__generator"])(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        propertyCtx = { runtime: ctx, assetManager: plugin.managers.asset };
                        provider = plugin.representation.structure.registry.get(params.type.name);
                        if (!provider.ensureCustomProperties) return [3 /*break*/, 2];
                        return [4 /*yield*/, provider.ensureCustomProperties.attach(propertyCtx, a.data)];
                    case 1:
                        _b.sent();
                        _b.label = 2;
                    case 2:
                        repr = provider.factory(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({ webgl: (_a = plugin.canvas3d) === null || _a === void 0 ? void 0 : _a.webgl }, plugin.representation.structure.themes), provider.getParams);
                        return [4 /*yield*/, _mol_theme_theme__WEBPACK_IMPORTED_MODULE_5__["Theme"].ensureDependencies(propertyCtx, plugin.representation.structure.themes, { structure: a.data }, params)];
                    case 3:
                        _b.sent();
                        repr.setTheme(_mol_theme_theme__WEBPACK_IMPORTED_MODULE_5__["Theme"].create(plugin.representation.structure.themes, { structure: a.data }, params));
                        props = params.type.params || {};
                        return [4 /*yield*/, repr.createOrUpdate(props, a.data).runInContext(ctx)];
                    case 4:
                        _b.sent();
                        return [2 /*return*/, new _objects__WEBPACK_IMPORTED_MODULE_7__["PluginStateObject"].Molecule.Structure.Representation3D({ repr: repr, source: a }, { label: provider.label })];
                }
            });
        }); });
    },
    update: function (_a, plugin) {
        var _this = this;
        var a = _a.a, b = _a.b, oldParams = _a.oldParams, newParams = _a.newParams, cache = _a.cache;
        return _mol_task__WEBPACK_IMPORTED_MODULE_4__["Task"].create('Structure Representation', function (ctx) { return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"])(_this, void 0, void 0, function () {
            var provider, propertyCtx, props;
            return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__generator"])(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (newParams.type.name !== oldParams.type.name)
                            return [2 /*return*/, _mol_state__WEBPACK_IMPORTED_MODULE_3__["StateTransformer"].UpdateResult.Recreate];
                        provider = plugin.representation.structure.registry.get(newParams.type.name);
                        propertyCtx = { runtime: ctx, assetManager: plugin.managers.asset };
                        if (!provider.ensureCustomProperties) return [3 /*break*/, 2];
                        return [4 /*yield*/, provider.ensureCustomProperties.attach(propertyCtx, a.data)];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2:
                        // TODO: if themes had a .needsUpdate method the following block could
                        //       be optimized and only executed conditionally
                        // dispose isn't called on update so we need to handle it manually
                        _mol_theme_theme__WEBPACK_IMPORTED_MODULE_5__["Theme"].releaseDependencies(plugin.representation.structure.themes, { structure: b.data.source.data }, oldParams);
                        return [4 /*yield*/, _mol_theme_theme__WEBPACK_IMPORTED_MODULE_5__["Theme"].ensureDependencies(propertyCtx, plugin.representation.structure.themes, { structure: a.data }, newParams)];
                    case 3:
                        _a.sent();
                        b.data.repr.setTheme(_mol_theme_theme__WEBPACK_IMPORTED_MODULE_5__["Theme"].create(plugin.representation.structure.themes, { structure: a.data }, newParams));
                        props = Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, b.data.repr.props), newParams.type.params);
                        return [4 /*yield*/, b.data.repr.createOrUpdate(props, a.data).runInContext(ctx)];
                    case 4:
                        _a.sent();
                        b.data.source = a;
                        return [2 /*return*/, _mol_state__WEBPACK_IMPORTED_MODULE_3__["StateTransformer"].UpdateResult.Updated];
                }
            });
        }); });
    },
    dispose: function (_a, plugin) {
        var b = _a.b, params = _a.params;
        if (!b || !params)
            return;
        var structure = b.data.source.data;
        var provider = plugin.representation.structure.registry.get(params.type.name);
        if (provider.ensureCustomProperties)
            provider.ensureCustomProperties.detach(structure);
        _mol_theme_theme__WEBPACK_IMPORTED_MODULE_5__["Theme"].releaseDependencies(plugin.representation.structure.themes, { structure: structure }, params);
    },
    interpolate: function (src, tar, t) {
        if (src.colorTheme.name !== 'uniform' || tar.colorTheme.name !== 'uniform') {
            return t <= 0.5 ? src : tar;
        }
        var from = src.colorTheme.params.value, to = tar.colorTheme.params.value;
        var value = _mol_util_color__WEBPACK_IMPORTED_MODULE_12__["Color"].interpolate(from, to, t);
        return {
            type: t <= 0.5 ? src.type : tar.type,
            colorTheme: { name: 'uniform', params: { value: value } },
            sizeTheme: t <= 0.5 ? src.sizeTheme : tar.sizeTheme,
        };
    }
});
var UnwindStructureAssemblyRepresentation3D = _objects__WEBPACK_IMPORTED_MODULE_7__["PluginStateTransform"].BuiltIn({
    name: 'unwind-structure-assembly-representation-3d',
    display: 'Unwind Assembly 3D Representation',
    from: _objects__WEBPACK_IMPORTED_MODULE_7__["PluginStateObject"].Molecule.Structure.Representation3D,
    to: _objects__WEBPACK_IMPORTED_MODULE_7__["PluginStateObject"].Molecule.Structure.Representation3DState,
    params: { t: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_6__["ParamDefinition"].Numeric(0, { min: 0, max: 1, step: 0.01 }) }
})({
    canAutoUpdate: function () {
        return true;
    },
    apply: function (_a) {
        var a = _a.a, params = _a.params;
        var structure = a.data.source.data;
        var unitTransforms = new _mol_model_structure_structure_util_unit_transforms__WEBPACK_IMPORTED_MODULE_10__["StructureUnitTransforms"](structure);
        Object(_animation_helpers__WEBPACK_IMPORTED_MODULE_11__["unwindStructureAssembly"])(structure, unitTransforms, params.t);
        return new _objects__WEBPACK_IMPORTED_MODULE_7__["PluginStateObject"].Molecule.Structure.Representation3DState({
            state: { unitTransforms: unitTransforms },
            initialState: { unitTransforms: new _mol_model_structure_structure_util_unit_transforms__WEBPACK_IMPORTED_MODULE_10__["StructureUnitTransforms"](structure) },
            info: structure,
            source: a
        }, { label: "Unwind T = " + params.t.toFixed(2) });
    },
    update: function (_a) {
        var a = _a.a, b = _a.b, newParams = _a.newParams, oldParams = _a.oldParams;
        var structure = b.data.info;
        if (a.data.source.data !== structure)
            return _mol_state__WEBPACK_IMPORTED_MODULE_3__["StateTransformer"].UpdateResult.Recreate;
        if (a.data.repr !== b.data.source.data.repr)
            return _mol_state__WEBPACK_IMPORTED_MODULE_3__["StateTransformer"].UpdateResult.Recreate;
        if (oldParams.t === newParams.t)
            return _mol_state__WEBPACK_IMPORTED_MODULE_3__["StateTransformer"].UpdateResult.Unchanged;
        var unitTransforms = b.data.state.unitTransforms;
        Object(_animation_helpers__WEBPACK_IMPORTED_MODULE_11__["unwindStructureAssembly"])(structure, unitTransforms, newParams.t);
        b.label = "Unwind T = " + newParams.t.toFixed(2);
        b.data.source = a;
        return _mol_state__WEBPACK_IMPORTED_MODULE_3__["StateTransformer"].UpdateResult.Updated;
    }
});
var ExplodeStructureRepresentation3D = _objects__WEBPACK_IMPORTED_MODULE_7__["PluginStateTransform"].BuiltIn({
    name: 'explode-structure-representation-3d',
    display: 'Explode 3D Representation',
    from: _objects__WEBPACK_IMPORTED_MODULE_7__["PluginStateObject"].Molecule.Structure.Representation3D,
    to: _objects__WEBPACK_IMPORTED_MODULE_7__["PluginStateObject"].Molecule.Structure.Representation3DState,
    params: { t: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_6__["ParamDefinition"].Numeric(0, { min: 0, max: 1, step: 0.01 }) }
})({
    canAutoUpdate: function () {
        return true;
    },
    apply: function (_a) {
        var a = _a.a, params = _a.params;
        var structure = a.data.source.data;
        var unitTransforms = new _mol_model_structure_structure_util_unit_transforms__WEBPACK_IMPORTED_MODULE_10__["StructureUnitTransforms"](structure.root);
        Object(_animation_helpers__WEBPACK_IMPORTED_MODULE_11__["explodeStructure"])(structure, unitTransforms, params.t);
        return new _objects__WEBPACK_IMPORTED_MODULE_7__["PluginStateObject"].Molecule.Structure.Representation3DState({
            state: { unitTransforms: unitTransforms },
            initialState: { unitTransforms: new _mol_model_structure_structure_util_unit_transforms__WEBPACK_IMPORTED_MODULE_10__["StructureUnitTransforms"](structure.root) },
            info: structure.root,
            source: a
        }, { label: "Explode T = " + params.t.toFixed(2) });
    },
    update: function (_a) {
        var a = _a.a, b = _a.b, newParams = _a.newParams, oldParams = _a.oldParams;
        var structure = a.data.source.data;
        if (b.data.info !== structure.root)
            return _mol_state__WEBPACK_IMPORTED_MODULE_3__["StateTransformer"].UpdateResult.Recreate;
        if (a.data.repr !== b.data.source.data.repr)
            return _mol_state__WEBPACK_IMPORTED_MODULE_3__["StateTransformer"].UpdateResult.Recreate;
        if (oldParams.t === newParams.t)
            return _mol_state__WEBPACK_IMPORTED_MODULE_3__["StateTransformer"].UpdateResult.Unchanged;
        var unitTransforms = b.data.state.unitTransforms;
        Object(_animation_helpers__WEBPACK_IMPORTED_MODULE_11__["explodeStructure"])(structure.root, unitTransforms, newParams.t);
        b.label = "Explode T = " + newParams.t.toFixed(2);
        b.data.source = a;
        return _mol_state__WEBPACK_IMPORTED_MODULE_3__["StateTransformer"].UpdateResult.Updated;
    }
});
var OverpaintStructureRepresentation3DFromScript = _objects__WEBPACK_IMPORTED_MODULE_7__["PluginStateTransform"].BuiltIn({
    name: 'overpaint-structure-representation-3d-from-script',
    display: 'Overpaint 3D Representation',
    from: _objects__WEBPACK_IMPORTED_MODULE_7__["PluginStateObject"].Molecule.Structure.Representation3D,
    to: _objects__WEBPACK_IMPORTED_MODULE_7__["PluginStateObject"].Molecule.Structure.Representation3DState,
    params: {
        layers: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_6__["ParamDefinition"].ObjectList({
            script: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_6__["ParamDefinition"].Script(Object(_mol_script_script__WEBPACK_IMPORTED_MODULE_16__["Script"])('(sel.atom.all)', 'mol-script')),
            color: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_6__["ParamDefinition"].Color(_mol_util_color_names__WEBPACK_IMPORTED_MODULE_8__["ColorNames"].blueviolet),
            clear: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_6__["ParamDefinition"].Boolean(false)
        }, function (e) { return "" + (e.clear ? 'Clear' : _mol_util_color__WEBPACK_IMPORTED_MODULE_12__["Color"].toRgbString(e.color)); }, {
            defaultValue: [{
                    script: Object(_mol_script_script__WEBPACK_IMPORTED_MODULE_16__["Script"])('(sel.atom.all)', 'mol-script'),
                    color: _mol_util_color_names__WEBPACK_IMPORTED_MODULE_8__["ColorNames"].blueviolet,
                    clear: false
                }]
        }),
    }
})({
    canAutoUpdate: function () {
        return true;
    },
    apply: function (_a) {
        var a = _a.a, params = _a.params;
        var structure = a.data.source.data;
        var overpaint = _mol_theme_overpaint__WEBPACK_IMPORTED_MODULE_13__["Overpaint"].ofScript(params.layers, structure);
        return new _objects__WEBPACK_IMPORTED_MODULE_7__["PluginStateObject"].Molecule.Structure.Representation3DState({
            state: { overpaint: overpaint },
            initialState: { overpaint: _mol_theme_overpaint__WEBPACK_IMPORTED_MODULE_13__["Overpaint"].Empty },
            info: structure,
            source: a
        }, { label: "Overpaint (" + overpaint.layers.length + " Layers)" });
    },
    update: function (_a) {
        var a = _a.a, b = _a.b, newParams = _a.newParams, oldParams = _a.oldParams;
        var oldStructure = b.data.info;
        var newStructure = a.data.source.data;
        if (newStructure !== oldStructure)
            return _mol_state__WEBPACK_IMPORTED_MODULE_3__["StateTransformer"].UpdateResult.Recreate;
        if (a.data.repr !== b.data.source.data.repr)
            return _mol_state__WEBPACK_IMPORTED_MODULE_3__["StateTransformer"].UpdateResult.Recreate;
        var oldOverpaint = b.data.state.overpaint;
        var newOverpaint = _mol_theme_overpaint__WEBPACK_IMPORTED_MODULE_13__["Overpaint"].ofScript(newParams.layers, newStructure);
        if (_mol_theme_overpaint__WEBPACK_IMPORTED_MODULE_13__["Overpaint"].areEqual(oldOverpaint, newOverpaint))
            return _mol_state__WEBPACK_IMPORTED_MODULE_3__["StateTransformer"].UpdateResult.Unchanged;
        b.data.state.overpaint = newOverpaint;
        b.data.source = a;
        b.label = "Overpaint (" + newOverpaint.layers.length + " Layers)";
        return _mol_state__WEBPACK_IMPORTED_MODULE_3__["StateTransformer"].UpdateResult.Updated;
    }
});
var OverpaintStructureRepresentation3DFromBundle = _objects__WEBPACK_IMPORTED_MODULE_7__["PluginStateTransform"].BuiltIn({
    name: 'overpaint-structure-representation-3d-from-bundle',
    display: 'Overpaint 3D Representation',
    from: _objects__WEBPACK_IMPORTED_MODULE_7__["PluginStateObject"].Molecule.Structure.Representation3D,
    to: _objects__WEBPACK_IMPORTED_MODULE_7__["PluginStateObject"].Molecule.Structure.Representation3DState,
    params: {
        layers: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_6__["ParamDefinition"].ObjectList({
            bundle: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_6__["ParamDefinition"].Value(_mol_model_structure__WEBPACK_IMPORTED_MODULE_1__["StructureElement"].Bundle.Empty),
            color: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_6__["ParamDefinition"].Color(_mol_util_color_names__WEBPACK_IMPORTED_MODULE_8__["ColorNames"].blueviolet),
            clear: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_6__["ParamDefinition"].Boolean(false)
        }, function (e) { return "" + (e.clear ? 'Clear' : _mol_util_color__WEBPACK_IMPORTED_MODULE_12__["Color"].toRgbString(e.color)); }, {
            defaultValue: [{
                    bundle: _mol_model_structure__WEBPACK_IMPORTED_MODULE_1__["StructureElement"].Bundle.Empty,
                    color: _mol_util_color_names__WEBPACK_IMPORTED_MODULE_8__["ColorNames"].blueviolet,
                    clear: false
                }],
            isHidden: true
        }),
    }
})({
    canAutoUpdate: function () {
        return true;
    },
    apply: function (_a) {
        var a = _a.a, params = _a.params;
        var structure = a.data.source.data;
        var overpaint = _mol_theme_overpaint__WEBPACK_IMPORTED_MODULE_13__["Overpaint"].ofBundle(params.layers, structure);
        return new _objects__WEBPACK_IMPORTED_MODULE_7__["PluginStateObject"].Molecule.Structure.Representation3DState({
            state: { overpaint: overpaint },
            initialState: { overpaint: _mol_theme_overpaint__WEBPACK_IMPORTED_MODULE_13__["Overpaint"].Empty },
            info: structure,
            source: a
        }, { label: "Overpaint (" + overpaint.layers.length + " Layers)" });
    },
    update: function (_a) {
        var a = _a.a, b = _a.b, newParams = _a.newParams, oldParams = _a.oldParams;
        var oldStructure = b.data.info;
        var newStructure = a.data.source.data;
        if (newStructure !== oldStructure)
            return _mol_state__WEBPACK_IMPORTED_MODULE_3__["StateTransformer"].UpdateResult.Recreate;
        if (a.data.repr !== b.data.source.data.repr)
            return _mol_state__WEBPACK_IMPORTED_MODULE_3__["StateTransformer"].UpdateResult.Recreate;
        var oldOverpaint = b.data.state.overpaint;
        var newOverpaint = _mol_theme_overpaint__WEBPACK_IMPORTED_MODULE_13__["Overpaint"].ofBundle(newParams.layers, newStructure);
        if (_mol_theme_overpaint__WEBPACK_IMPORTED_MODULE_13__["Overpaint"].areEqual(oldOverpaint, newOverpaint))
            return _mol_state__WEBPACK_IMPORTED_MODULE_3__["StateTransformer"].UpdateResult.Unchanged;
        b.data.state.overpaint = newOverpaint;
        b.data.source = a;
        b.label = "Overpaint (" + newOverpaint.layers.length + " Layers)";
        return _mol_state__WEBPACK_IMPORTED_MODULE_3__["StateTransformer"].UpdateResult.Updated;
    }
});
var TransparencyStructureRepresentation3DFromScript = _objects__WEBPACK_IMPORTED_MODULE_7__["PluginStateTransform"].BuiltIn({
    name: 'transparency-structure-representation-3d-from-script',
    display: 'Transparency 3D Representation',
    from: _objects__WEBPACK_IMPORTED_MODULE_7__["PluginStateObject"].Molecule.Structure.Representation3D,
    to: _objects__WEBPACK_IMPORTED_MODULE_7__["PluginStateObject"].Molecule.Structure.Representation3DState,
    params: {
        layers: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_6__["ParamDefinition"].ObjectList({
            script: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_6__["ParamDefinition"].Script(Object(_mol_script_script__WEBPACK_IMPORTED_MODULE_16__["Script"])('(sel.atom.all)', 'mol-script')),
            value: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_6__["ParamDefinition"].Numeric(0.5, { min: 0, max: 1, step: 0.01 }, { label: 'Transparency' }),
        }, function (e) { return "Transparency (" + e.value + ")"; }, {
            defaultValue: [{
                    script: Object(_mol_script_script__WEBPACK_IMPORTED_MODULE_16__["Script"])('(sel.atom.all)', 'mol-script'),
                    value: 0.5,
                }]
        })
    }
})({
    canAutoUpdate: function () {
        return true;
    },
    apply: function (_a) {
        var a = _a.a, params = _a.params;
        var structure = a.data.source.data;
        var transparency = _mol_theme_transparency__WEBPACK_IMPORTED_MODULE_14__["Transparency"].ofScript(params.layers, structure);
        return new _objects__WEBPACK_IMPORTED_MODULE_7__["PluginStateObject"].Molecule.Structure.Representation3DState({
            state: { transparency: transparency },
            initialState: { transparency: _mol_theme_transparency__WEBPACK_IMPORTED_MODULE_14__["Transparency"].Empty },
            info: structure,
            source: a
        }, { label: "Transparency (" + transparency.layers.length + " Layers)" });
    },
    update: function (_a) {
        var a = _a.a, b = _a.b, newParams = _a.newParams, oldParams = _a.oldParams;
        var structure = b.data.info;
        if (a.data.source.data !== structure)
            return _mol_state__WEBPACK_IMPORTED_MODULE_3__["StateTransformer"].UpdateResult.Recreate;
        if (a.data.repr !== b.data.source.data.repr)
            return _mol_state__WEBPACK_IMPORTED_MODULE_3__["StateTransformer"].UpdateResult.Recreate;
        var oldTransparency = b.data.state.transparency;
        var newTransparency = _mol_theme_transparency__WEBPACK_IMPORTED_MODULE_14__["Transparency"].ofScript(newParams.layers, structure);
        if (_mol_theme_transparency__WEBPACK_IMPORTED_MODULE_14__["Transparency"].areEqual(oldTransparency, newTransparency))
            return _mol_state__WEBPACK_IMPORTED_MODULE_3__["StateTransformer"].UpdateResult.Unchanged;
        b.data.state.transparency = newTransparency;
        b.data.source = a;
        b.label = "Transparency (" + newTransparency.layers.length + " Layers)";
        return _mol_state__WEBPACK_IMPORTED_MODULE_3__["StateTransformer"].UpdateResult.Updated;
    }
});
var TransparencyStructureRepresentation3DFromBundle = _objects__WEBPACK_IMPORTED_MODULE_7__["PluginStateTransform"].BuiltIn({
    name: 'transparency-structure-representation-3d-from-bundle',
    display: 'Transparency 3D Representation',
    from: _objects__WEBPACK_IMPORTED_MODULE_7__["PluginStateObject"].Molecule.Structure.Representation3D,
    to: _objects__WEBPACK_IMPORTED_MODULE_7__["PluginStateObject"].Molecule.Structure.Representation3DState,
    params: {
        layers: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_6__["ParamDefinition"].ObjectList({
            bundle: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_6__["ParamDefinition"].Value(_mol_model_structure__WEBPACK_IMPORTED_MODULE_1__["StructureElement"].Bundle.Empty),
            value: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_6__["ParamDefinition"].Numeric(0.5, { min: 0, max: 1, step: 0.01 }, { label: 'Transparency' }),
        }, function (e) { return "Transparency (" + e.value + ")"; }, {
            defaultValue: [{
                    bundle: _mol_model_structure__WEBPACK_IMPORTED_MODULE_1__["StructureElement"].Bundle.Empty,
                    value: 0.5,
                }],
            isHidden: true
        })
    }
})({
    canAutoUpdate: function () {
        return true;
    },
    apply: function (_a) {
        var a = _a.a, params = _a.params;
        var structure = a.data.source.data;
        var transparency = _mol_theme_transparency__WEBPACK_IMPORTED_MODULE_14__["Transparency"].ofBundle(params.layers, structure);
        return new _objects__WEBPACK_IMPORTED_MODULE_7__["PluginStateObject"].Molecule.Structure.Representation3DState({
            state: { transparency: transparency },
            initialState: { transparency: _mol_theme_transparency__WEBPACK_IMPORTED_MODULE_14__["Transparency"].Empty },
            info: structure,
            source: a
        }, { label: "Transparency (" + transparency.layers.length + " Layers)" });
    },
    update: function (_a) {
        var a = _a.a, b = _a.b, newParams = _a.newParams, oldParams = _a.oldParams;
        var structure = b.data.info;
        if (a.data.source.data !== structure)
            return _mol_state__WEBPACK_IMPORTED_MODULE_3__["StateTransformer"].UpdateResult.Recreate;
        if (a.data.repr !== b.data.source.data.repr)
            return _mol_state__WEBPACK_IMPORTED_MODULE_3__["StateTransformer"].UpdateResult.Recreate;
        var oldTransparency = b.data.state.transparency;
        var newTransparency = _mol_theme_transparency__WEBPACK_IMPORTED_MODULE_14__["Transparency"].ofBundle(newParams.layers, structure);
        if (_mol_theme_transparency__WEBPACK_IMPORTED_MODULE_14__["Transparency"].areEqual(oldTransparency, newTransparency))
            return _mol_state__WEBPACK_IMPORTED_MODULE_3__["StateTransformer"].UpdateResult.Unchanged;
        b.data.state.transparency = newTransparency;
        b.data.source = a;
        b.label = "Transparency (" + newTransparency.layers.length + " Layers)";
        return _mol_state__WEBPACK_IMPORTED_MODULE_3__["StateTransformer"].UpdateResult.Updated;
    }
});
var ClippingStructureRepresentation3DFromScript = _objects__WEBPACK_IMPORTED_MODULE_7__["PluginStateTransform"].BuiltIn({
    name: 'clipping-structure-representation-3d-from-script',
    display: 'Clipping 3D Representation',
    from: _objects__WEBPACK_IMPORTED_MODULE_7__["PluginStateObject"].Molecule.Structure.Representation3D,
    to: _objects__WEBPACK_IMPORTED_MODULE_7__["PluginStateObject"].Molecule.Structure.Representation3DState,
    params: {
        layers: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_6__["ParamDefinition"].ObjectList({
            script: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_6__["ParamDefinition"].Script(Object(_mol_script_script__WEBPACK_IMPORTED_MODULE_16__["Script"])('(sel.atom.all)', 'mol-script')),
            groups: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_6__["ParamDefinition"].Converted(function (g) { return _mol_theme_clipping__WEBPACK_IMPORTED_MODULE_25__["Clipping"].Groups.toNames(g); }, function (n) { return _mol_theme_clipping__WEBPACK_IMPORTED_MODULE_25__["Clipping"].Groups.fromNames(n); }, _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_6__["ParamDefinition"].MultiSelect(Object(_mol_util_type_helpers__WEBPACK_IMPORTED_MODULE_26__["ObjectKeys"])(_mol_theme_clipping__WEBPACK_IMPORTED_MODULE_25__["Clipping"].Groups.Names), _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_6__["ParamDefinition"].objectToOptions(_mol_theme_clipping__WEBPACK_IMPORTED_MODULE_25__["Clipping"].Groups.Names))),
        }, function (e) { return _mol_theme_clipping__WEBPACK_IMPORTED_MODULE_25__["Clipping"].Groups.toNames(e.groups).length + " group(s)"; }, {
            defaultValue: [{
                    script: Object(_mol_script_script__WEBPACK_IMPORTED_MODULE_16__["Script"])('(sel.atom.all)', 'mol-script'),
                    groups: 0 /* None */,
                }]
        }),
    }
})({
    canAutoUpdate: function () {
        return true;
    },
    apply: function (_a) {
        var a = _a.a, params = _a.params;
        var structure = a.data.source.data;
        var clipping = _mol_theme_clipping__WEBPACK_IMPORTED_MODULE_25__["Clipping"].ofScript(params.layers, structure);
        return new _objects__WEBPACK_IMPORTED_MODULE_7__["PluginStateObject"].Molecule.Structure.Representation3DState({
            state: { clipping: clipping },
            initialState: { clipping: _mol_theme_clipping__WEBPACK_IMPORTED_MODULE_25__["Clipping"].Empty },
            info: structure,
            source: a
        }, { label: "Clipping (" + clipping.layers.length + " Layers)" });
    },
    update: function (_a) {
        var a = _a.a, b = _a.b, newParams = _a.newParams, oldParams = _a.oldParams;
        var structure = b.data.info;
        if (a.data.source.data !== structure)
            return _mol_state__WEBPACK_IMPORTED_MODULE_3__["StateTransformer"].UpdateResult.Recreate;
        if (a.data.repr !== b.data.source.data.repr)
            return _mol_state__WEBPACK_IMPORTED_MODULE_3__["StateTransformer"].UpdateResult.Recreate;
        var oldClipping = b.data.state.clipping;
        var newClipping = _mol_theme_clipping__WEBPACK_IMPORTED_MODULE_25__["Clipping"].ofScript(newParams.layers, structure);
        if (_mol_theme_clipping__WEBPACK_IMPORTED_MODULE_25__["Clipping"].areEqual(oldClipping, newClipping))
            return _mol_state__WEBPACK_IMPORTED_MODULE_3__["StateTransformer"].UpdateResult.Unchanged;
        b.data.state.clipping = newClipping;
        b.data.source = a;
        b.label = "Clipping (" + newClipping.layers.length + " Layers)";
        return _mol_state__WEBPACK_IMPORTED_MODULE_3__["StateTransformer"].UpdateResult.Updated;
    }
});
var ClippingStructureRepresentation3DFromBundle = _objects__WEBPACK_IMPORTED_MODULE_7__["PluginStateTransform"].BuiltIn({
    name: 'clipping-structure-representation-3d-from-bundle',
    display: 'Clipping 3D Representation',
    from: _objects__WEBPACK_IMPORTED_MODULE_7__["PluginStateObject"].Molecule.Structure.Representation3D,
    to: _objects__WEBPACK_IMPORTED_MODULE_7__["PluginStateObject"].Molecule.Structure.Representation3DState,
    params: {
        layers: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_6__["ParamDefinition"].ObjectList({
            bundle: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_6__["ParamDefinition"].Value(_mol_model_structure__WEBPACK_IMPORTED_MODULE_1__["StructureElement"].Bundle.Empty),
            groups: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_6__["ParamDefinition"].Converted(function (g) { return _mol_theme_clipping__WEBPACK_IMPORTED_MODULE_25__["Clipping"].Groups.toNames(g); }, function (n) { return _mol_theme_clipping__WEBPACK_IMPORTED_MODULE_25__["Clipping"].Groups.fromNames(n); }, _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_6__["ParamDefinition"].MultiSelect(Object(_mol_util_type_helpers__WEBPACK_IMPORTED_MODULE_26__["ObjectKeys"])(_mol_theme_clipping__WEBPACK_IMPORTED_MODULE_25__["Clipping"].Groups.Names), _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_6__["ParamDefinition"].objectToOptions(_mol_theme_clipping__WEBPACK_IMPORTED_MODULE_25__["Clipping"].Groups.Names))),
        }, function (e) { return _mol_theme_clipping__WEBPACK_IMPORTED_MODULE_25__["Clipping"].Groups.toNames(e.groups).length + " group(s)"; }, {
            defaultValue: [{
                    bundle: _mol_model_structure__WEBPACK_IMPORTED_MODULE_1__["StructureElement"].Bundle.Empty,
                    groups: 0 /* None */,
                }],
            isHidden: true
        }),
    }
})({
    canAutoUpdate: function () {
        return true;
    },
    apply: function (_a) {
        var a = _a.a, params = _a.params;
        var structure = a.data.source.data;
        var clipping = _mol_theme_clipping__WEBPACK_IMPORTED_MODULE_25__["Clipping"].ofBundle(params.layers, structure);
        return new _objects__WEBPACK_IMPORTED_MODULE_7__["PluginStateObject"].Molecule.Structure.Representation3DState({
            state: { clipping: clipping },
            initialState: { clipping: _mol_theme_clipping__WEBPACK_IMPORTED_MODULE_25__["Clipping"].Empty },
            info: structure,
            source: a
        }, { label: "Clipping (" + clipping.layers.length + " Layers)" });
    },
    update: function (_a) {
        var a = _a.a, b = _a.b, newParams = _a.newParams, oldParams = _a.oldParams;
        var structure = b.data.info;
        if (a.data.source.data !== structure)
            return _mol_state__WEBPACK_IMPORTED_MODULE_3__["StateTransformer"].UpdateResult.Recreate;
        if (a.data.repr !== b.data.source.data.repr)
            return _mol_state__WEBPACK_IMPORTED_MODULE_3__["StateTransformer"].UpdateResult.Recreate;
        var oldClipping = b.data.state.clipping;
        var newClipping = _mol_theme_clipping__WEBPACK_IMPORTED_MODULE_25__["Clipping"].ofBundle(newParams.layers, structure);
        if (_mol_theme_clipping__WEBPACK_IMPORTED_MODULE_25__["Clipping"].areEqual(oldClipping, newClipping))
            return _mol_state__WEBPACK_IMPORTED_MODULE_3__["StateTransformer"].UpdateResult.Unchanged;
        b.data.state.clipping = newClipping;
        b.data.source = a;
        b.label = "Clipping (" + newClipping.layers.length + " Layers)";
        return _mol_state__WEBPACK_IMPORTED_MODULE_3__["StateTransformer"].UpdateResult.Updated;
    }
});
//
var VolumeRepresentation3DHelpers;
(function (VolumeRepresentation3DHelpers) {
    function getDefaultParams(ctx, name, volume, volumeParams) {
        var type = ctx.representation.volume.registry.get(name);
        var themeDataCtx = { volume: volume };
        var colorParams = ctx.representation.volume.themes.colorThemeRegistry.get(type.defaultColorTheme.name).getParams(themeDataCtx);
        var sizeParams = ctx.representation.volume.themes.sizeThemeRegistry.get(type.defaultSizeTheme.name).getParams(themeDataCtx);
        var volumeDefaultParams = _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_6__["ParamDefinition"].getDefaultValues(type.getParams(ctx.representation.volume.themes, volume));
        return ({
            type: { name: name, params: volumeParams ? Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, volumeDefaultParams), volumeParams) : volumeDefaultParams },
            colorTheme: { name: type.defaultColorTheme.name, params: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_6__["ParamDefinition"].getDefaultValues(colorParams) },
            sizeTheme: { name: type.defaultSizeTheme.name, params: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_6__["ParamDefinition"].getDefaultValues(sizeParams) }
        });
    }
    VolumeRepresentation3DHelpers.getDefaultParams = getDefaultParams;
    function getDefaultParamsStatic(ctx, name, volumeParams, colorName, colorParams, sizeName, sizeParams) {
        var type = ctx.representation.volume.registry.get(name);
        var colorType = ctx.representation.volume.themes.colorThemeRegistry.get(colorName || type.defaultColorTheme.name);
        var sizeType = ctx.representation.volume.themes.sizeThemeRegistry.get(sizeName || type.defaultSizeTheme.name);
        return ({
            type: { name: name, params: volumeParams ? Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, type.defaultValues), volumeParams) : type.defaultValues },
            colorTheme: { name: type.defaultColorTheme.name, params: colorParams ? Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, colorType.defaultValues), colorParams) : colorType.defaultValues },
            sizeTheme: { name: type.defaultSizeTheme.name, params: sizeParams ? Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, sizeType.defaultValues), sizeParams) : sizeType.defaultValues }
        });
    }
    VolumeRepresentation3DHelpers.getDefaultParamsStatic = getDefaultParamsStatic;
    function getDescription(props) {
        var _a, _b, _c, _d;
        if (props.isoValue) {
            return _mol_model_volume__WEBPACK_IMPORTED_MODULE_2__["Volume"].IsoValue.toString(props.isoValue);
        }
        else if ((_b = (_a = props.renderMode) === null || _a === void 0 ? void 0 : _a.params) === null || _b === void 0 ? void 0 : _b.isoValue) {
            return _mol_model_volume__WEBPACK_IMPORTED_MODULE_2__["Volume"].IsoValue.toString((_d = (_c = props.renderMode) === null || _c === void 0 ? void 0 : _c.params) === null || _d === void 0 ? void 0 : _d.isoValue);
        }
    }
    VolumeRepresentation3DHelpers.getDescription = getDescription;
})(VolumeRepresentation3DHelpers || (VolumeRepresentation3DHelpers = {}));
var VolumeRepresentation3D = _objects__WEBPACK_IMPORTED_MODULE_7__["PluginStateTransform"].BuiltIn({
    name: 'volume-representation-3d',
    display: '3D Representation',
    from: _objects__WEBPACK_IMPORTED_MODULE_7__["PluginStateObject"].Volume.Data,
    to: _objects__WEBPACK_IMPORTED_MODULE_7__["PluginStateObject"].Volume.Representation3D,
    params: function (a, ctx) {
        var _a = ctx.representation.volume, registry = _a.registry, themeCtx = _a.themes;
        var type = registry.get(registry.default.name);
        if (!a) {
            return {
                type: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_6__["ParamDefinition"].Mapped(registry.default.name, registry.types, function (name) { return _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_6__["ParamDefinition"].Group(registry.get(name).getParams(themeCtx, _mol_model_volume__WEBPACK_IMPORTED_MODULE_2__["Volume"].One)); }),
                colorTheme: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_6__["ParamDefinition"].Mapped(type.defaultColorTheme.name, themeCtx.colorThemeRegistry.types, function (name) { return _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_6__["ParamDefinition"].Group(themeCtx.colorThemeRegistry.get(name).getParams({ volume: _mol_model_volume__WEBPACK_IMPORTED_MODULE_2__["Volume"].One })); }),
                sizeTheme: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_6__["ParamDefinition"].Mapped(type.defaultSizeTheme.name, themeCtx.sizeThemeRegistry.types, function (name) { return _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_6__["ParamDefinition"].Group(themeCtx.sizeThemeRegistry.get(name).getParams({ volume: _mol_model_volume__WEBPACK_IMPORTED_MODULE_2__["Volume"].One })); })
            };
        }
        var dataCtx = { volume: a.data };
        return ({
            type: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_6__["ParamDefinition"].Mapped(registry.default.name, registry.types, function (name) { return _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_6__["ParamDefinition"].Group(registry.get(name).getParams(themeCtx, a.data)); }),
            colorTheme: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_6__["ParamDefinition"].Mapped(type.defaultColorTheme.name, themeCtx.colorThemeRegistry.getApplicableTypes(dataCtx), function (name) { return _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_6__["ParamDefinition"].Group(themeCtx.colorThemeRegistry.get(name).getParams(dataCtx)); }),
            sizeTheme: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_6__["ParamDefinition"].Mapped(type.defaultSizeTheme.name, themeCtx.sizeThemeRegistry.types, function (name) { return _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_6__["ParamDefinition"].Group(themeCtx.sizeThemeRegistry.get(name).getParams(dataCtx)); })
        });
    }
})({
    canAutoUpdate: function (_a) {
        var oldParams = _a.oldParams, newParams = _a.newParams;
        return oldParams.type.name === newParams.type.name;
    },
    apply: function (_a, plugin) {
        var _this = this;
        var a = _a.a, params = _a.params;
        return _mol_task__WEBPACK_IMPORTED_MODULE_4__["Task"].create('Volume Representation', function (ctx) { return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"])(_this, void 0, void 0, function () {
            var propertyCtx, provider, repr, props;
            var _a;
            return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__generator"])(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        propertyCtx = { runtime: ctx, assetManager: plugin.managers.asset };
                        provider = plugin.representation.volume.registry.get(params.type.name);
                        if (!provider.ensureCustomProperties) return [3 /*break*/, 2];
                        return [4 /*yield*/, provider.ensureCustomProperties.attach(propertyCtx, a.data)];
                    case 1:
                        _b.sent();
                        _b.label = 2;
                    case 2:
                        repr = provider.factory(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({ webgl: (_a = plugin.canvas3d) === null || _a === void 0 ? void 0 : _a.webgl }, plugin.representation.volume.themes), provider.getParams);
                        repr.setTheme(_mol_theme_theme__WEBPACK_IMPORTED_MODULE_5__["Theme"].create(plugin.representation.volume.themes, { volume: a.data }, params));
                        props = params.type.params || {};
                        return [4 /*yield*/, repr.createOrUpdate(props, a.data).runInContext(ctx)];
                    case 3:
                        _b.sent();
                        return [2 /*return*/, new _objects__WEBPACK_IMPORTED_MODULE_7__["PluginStateObject"].Volume.Representation3D({ repr: repr, source: a }, { label: provider.label, description: VolumeRepresentation3DHelpers.getDescription(props) })];
                }
            });
        }); });
    },
    update: function (_a, plugin) {
        var _this = this;
        var a = _a.a, b = _a.b, oldParams = _a.oldParams, newParams = _a.newParams;
        return _mol_task__WEBPACK_IMPORTED_MODULE_4__["Task"].create('Volume Representation', function (ctx) { return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"])(_this, void 0, void 0, function () {
            var oldProvider, props;
            var _a;
            return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__generator"])(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (newParams.type.name !== oldParams.type.name) {
                            oldProvider = plugin.representation.volume.registry.get(oldParams.type.name);
                            (_a = oldProvider.ensureCustomProperties) === null || _a === void 0 ? void 0 : _a.detach(a.data);
                            return [2 /*return*/, _mol_state__WEBPACK_IMPORTED_MODULE_3__["StateTransformer"].UpdateResult.Recreate];
                        }
                        props = Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, b.data.repr.props), newParams.type.params);
                        b.data.repr.setTheme(_mol_theme_theme__WEBPACK_IMPORTED_MODULE_5__["Theme"].create(plugin.representation.volume.themes, { volume: a.data }, newParams));
                        return [4 /*yield*/, b.data.repr.createOrUpdate(props, a.data).runInContext(ctx)];
                    case 1:
                        _b.sent();
                        b.description = VolumeRepresentation3DHelpers.getDescription(props);
                        return [2 /*return*/, _mol_state__WEBPACK_IMPORTED_MODULE_3__["StateTransformer"].UpdateResult.Updated];
                }
            });
        }); });
    }
});
//

var ShapeRepresentation3D = _objects__WEBPACK_IMPORTED_MODULE_7__["PluginStateTransform"].BuiltIn({
    name: 'shape-representation-3d',
    display: '3D Representation',
    from: _objects__WEBPACK_IMPORTED_MODULE_7__["PluginStateObject"].Shape.Provider,
    to: _objects__WEBPACK_IMPORTED_MODULE_7__["PluginStateObject"].Shape.Representation3D,
    params: function (a, ctx) {
        return a ? a.data.params : _mol_geo_geometry_base__WEBPACK_IMPORTED_MODULE_15__["BaseGeometry"].Params;
    }
})({
    canAutoUpdate: function () {
        return true;
    },
    apply: function (_a, plugin) {
        var _this = this;
        var a = _a.a, params = _a.params;
        return _mol_task__WEBPACK_IMPORTED_MODULE_4__["Task"].create('Shape Representation', function (ctx) { return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"])(_this, void 0, void 0, function () {
            var props, repr;
            return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__generator"])(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        props = Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_6__["ParamDefinition"].getDefaultValues(a.data.params)), params);
                        repr = Object(_mol_repr_shape_representation__WEBPACK_IMPORTED_MODULE_9__["ShapeRepresentation"])(a.data.getShape, a.data.geometryUtils);
                        return [4 /*yield*/, repr.createOrUpdate(props, a.data.data).runInContext(ctx)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/, new _objects__WEBPACK_IMPORTED_MODULE_7__["PluginStateObject"].Shape.Representation3D({ repr: repr, source: a }, { label: a.data.label })];
                }
            });
        }); });
    },
    update: function (_a, plugin) {
        var _this = this;
        var a = _a.a, b = _a.b, oldParams = _a.oldParams, newParams = _a.newParams;
        return _mol_task__WEBPACK_IMPORTED_MODULE_4__["Task"].create('Shape Representation', function (ctx) { return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"])(_this, void 0, void 0, function () {
            var props;
            return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__generator"])(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        props = Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, b.data.repr.props), newParams);
                        return [4 /*yield*/, b.data.repr.createOrUpdate(props, a.data.data).runInContext(ctx)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/, _mol_state__WEBPACK_IMPORTED_MODULE_3__["StateTransformer"].UpdateResult.Updated];
                }
            });
        }); });
    }
});

var ModelUnitcell3D = _objects__WEBPACK_IMPORTED_MODULE_7__["PluginStateTransform"].BuiltIn({
    name: 'model-unitcell-3d',
    display: 'Model Unit Cell',
    from: _objects__WEBPACK_IMPORTED_MODULE_7__["PluginStateObject"].Molecule.Model,
    to: _objects__WEBPACK_IMPORTED_MODULE_7__["PluginStateObject"].Shape.Representation3D,
    params: Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, _mol_repr_shape_model_unitcell__WEBPACK_IMPORTED_MODULE_17__["UnitcellParams"])
})({
    isApplicable: function (a) { return !!_mol_model_formats_structure_property_symmetry__WEBPACK_IMPORTED_MODULE_24__["ModelSymmetry"].Provider.get(a.data); },
    canAutoUpdate: function (_a) {
        var oldParams = _a.oldParams, newParams = _a.newParams;
        return true;
    },
    apply: function (_a, plugin) {
        var _this = this;
        var a = _a.a, params = _a.params;
        return _mol_task__WEBPACK_IMPORTED_MODULE_4__["Task"].create('Model Unit Cell', function (ctx) { return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"])(_this, void 0, void 0, function () {
            var symmetry, data, repr;
            var _a;
            return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__generator"])(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        symmetry = _mol_model_formats_structure_property_symmetry__WEBPACK_IMPORTED_MODULE_24__["ModelSymmetry"].Provider.get(a.data);
                        if (!symmetry)
                            return [2 /*return*/, _mol_state__WEBPACK_IMPORTED_MODULE_3__["StateObject"].Null];
                        data = Object(_mol_repr_shape_model_unitcell__WEBPACK_IMPORTED_MODULE_17__["getUnitcellData"])(a.data, symmetry, params);
                        repr = Object(_mol_repr_shape_model_unitcell__WEBPACK_IMPORTED_MODULE_17__["UnitcellRepresentation"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({ webgl: (_a = plugin.canvas3d) === null || _a === void 0 ? void 0 : _a.webgl }, plugin.representation.structure.themes), function () { return _mol_repr_shape_model_unitcell__WEBPACK_IMPORTED_MODULE_17__["UnitcellParams"]; });
                        return [4 /*yield*/, repr.createOrUpdate(params, data).runInContext(ctx)];
                    case 1:
                        _b.sent();
                        return [2 /*return*/, new _objects__WEBPACK_IMPORTED_MODULE_7__["PluginStateObject"].Shape.Representation3D({ repr: repr, source: a }, { label: "Unit Cell", description: symmetry.spacegroup.name })];
                }
            });
        }); });
    },
    update: function (_a) {
        var _this = this;
        var a = _a.a, b = _a.b, newParams = _a.newParams;
        return _mol_task__WEBPACK_IMPORTED_MODULE_4__["Task"].create('Model Unit Cell', function (ctx) { return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"])(_this, void 0, void 0, function () {
            var symmetry, props, data;
            return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__generator"])(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        symmetry = _mol_model_formats_structure_property_symmetry__WEBPACK_IMPORTED_MODULE_24__["ModelSymmetry"].Provider.get(a.data);
                        if (!symmetry)
                            return [2 /*return*/, _mol_state__WEBPACK_IMPORTED_MODULE_3__["StateTransformer"].UpdateResult.Null];
                        props = Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, b.data.repr.props), newParams);
                        data = Object(_mol_repr_shape_model_unitcell__WEBPACK_IMPORTED_MODULE_17__["getUnitcellData"])(a.data, symmetry, props);
                        return [4 /*yield*/, b.data.repr.createOrUpdate(props, data).runInContext(ctx)];
                    case 1:
                        _a.sent();
                        b.data.source = a;
                        return [2 /*return*/, _mol_state__WEBPACK_IMPORTED_MODULE_3__["StateTransformer"].UpdateResult.Updated];
                }
            });
        }); });
    }
});

var StructureSelectionsDistance3D = _objects__WEBPACK_IMPORTED_MODULE_7__["PluginStateTransform"].BuiltIn({
    name: 'structure-selections-distance-3d',
    display: '3D Distance',
    from: _objects__WEBPACK_IMPORTED_MODULE_7__["PluginStateObject"].Molecule.Structure.Selections,
    to: _objects__WEBPACK_IMPORTED_MODULE_7__["PluginStateObject"].Shape.Representation3D,
    params: Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, _mol_repr_shape_loci_distance__WEBPACK_IMPORTED_MODULE_18__["DistanceParams"])
})({
    canAutoUpdate: function (_a) {
        var oldParams = _a.oldParams, newParams = _a.newParams;
        return true;
    },
    apply: function (_a, plugin) {
        var _this = this;
        var a = _a.a, params = _a.params;
        return _mol_task__WEBPACK_IMPORTED_MODULE_4__["Task"].create('Structure Distance', function (ctx) { return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"])(_this, void 0, void 0, function () {
            var data, repr;
            var _a;
            return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__generator"])(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        data = Object(_helpers__WEBPACK_IMPORTED_MODULE_19__["getDistanceDataFromStructureSelections"])(a.data);
                        repr = Object(_mol_repr_shape_loci_distance__WEBPACK_IMPORTED_MODULE_18__["DistanceRepresentation"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({ webgl: (_a = plugin.canvas3d) === null || _a === void 0 ? void 0 : _a.webgl }, plugin.representation.structure.themes), function () { return _mol_repr_shape_loci_distance__WEBPACK_IMPORTED_MODULE_18__["DistanceParams"]; });
                        return [4 /*yield*/, repr.createOrUpdate(params, data).runInContext(ctx)];
                    case 1:
                        _b.sent();
                        return [2 /*return*/, new _objects__WEBPACK_IMPORTED_MODULE_7__["PluginStateObject"].Shape.Representation3D({ repr: repr, source: a }, { label: "Distance" })];
                }
            });
        }); });
    },
    update: function (_a, plugin) {
        var _this = this;
        var a = _a.a, b = _a.b, oldParams = _a.oldParams, newParams = _a.newParams;
        return _mol_task__WEBPACK_IMPORTED_MODULE_4__["Task"].create('Structure Distance', function (ctx) { return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"])(_this, void 0, void 0, function () {
            var props, data;
            return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__generator"])(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        props = Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, b.data.repr.props), newParams);
                        data = Object(_helpers__WEBPACK_IMPORTED_MODULE_19__["getDistanceDataFromStructureSelections"])(a.data);
                        return [4 /*yield*/, b.data.repr.createOrUpdate(props, data).runInContext(ctx)];
                    case 1:
                        _a.sent();
                        b.data.source = a;
                        return [2 /*return*/, _mol_state__WEBPACK_IMPORTED_MODULE_3__["StateTransformer"].UpdateResult.Updated];
                }
            });
        }); });
    },
});

var StructureSelectionsAngle3D = _objects__WEBPACK_IMPORTED_MODULE_7__["PluginStateTransform"].BuiltIn({
    name: 'structure-selections-angle-3d',
    display: '3D Angle',
    from: _objects__WEBPACK_IMPORTED_MODULE_7__["PluginStateObject"].Molecule.Structure.Selections,
    to: _objects__WEBPACK_IMPORTED_MODULE_7__["PluginStateObject"].Shape.Representation3D,
    params: Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, _mol_repr_shape_loci_angle__WEBPACK_IMPORTED_MODULE_22__["AngleParams"])
})({
    canAutoUpdate: function (_a) {
        var oldParams = _a.oldParams, newParams = _a.newParams;
        return true;
    },
    apply: function (_a, plugin) {
        var _this = this;
        var a = _a.a, params = _a.params;
        return _mol_task__WEBPACK_IMPORTED_MODULE_4__["Task"].create('Structure Angle', function (ctx) { return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"])(_this, void 0, void 0, function () {
            var data, repr;
            var _a;
            return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__generator"])(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        data = Object(_helpers__WEBPACK_IMPORTED_MODULE_19__["getAngleDataFromStructureSelections"])(a.data);
                        repr = Object(_mol_repr_shape_loci_angle__WEBPACK_IMPORTED_MODULE_22__["AngleRepresentation"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({ webgl: (_a = plugin.canvas3d) === null || _a === void 0 ? void 0 : _a.webgl }, plugin.representation.structure.themes), function () { return _mol_repr_shape_loci_angle__WEBPACK_IMPORTED_MODULE_22__["AngleParams"]; });
                        return [4 /*yield*/, repr.createOrUpdate(params, data).runInContext(ctx)];
                    case 1:
                        _b.sent();
                        return [2 /*return*/, new _objects__WEBPACK_IMPORTED_MODULE_7__["PluginStateObject"].Shape.Representation3D({ repr: repr, source: a }, { label: "Angle" })];
                }
            });
        }); });
    },
    update: function (_a, plugin) {
        var _this = this;
        var a = _a.a, b = _a.b, oldParams = _a.oldParams, newParams = _a.newParams;
        return _mol_task__WEBPACK_IMPORTED_MODULE_4__["Task"].create('Structure Angle', function (ctx) { return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"])(_this, void 0, void 0, function () {
            var props, data;
            return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__generator"])(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        props = Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, b.data.repr.props), newParams);
                        data = Object(_helpers__WEBPACK_IMPORTED_MODULE_19__["getAngleDataFromStructureSelections"])(a.data);
                        return [4 /*yield*/, b.data.repr.createOrUpdate(props, data).runInContext(ctx)];
                    case 1:
                        _a.sent();
                        b.data.source = a;
                        return [2 /*return*/, _mol_state__WEBPACK_IMPORTED_MODULE_3__["StateTransformer"].UpdateResult.Updated];
                }
            });
        }); });
    },
});

var StructureSelectionsDihedral3D = _objects__WEBPACK_IMPORTED_MODULE_7__["PluginStateTransform"].BuiltIn({
    name: 'structure-selections-dihedral-3d',
    display: '3D Dihedral',
    from: _objects__WEBPACK_IMPORTED_MODULE_7__["PluginStateObject"].Molecule.Structure.Selections,
    to: _objects__WEBPACK_IMPORTED_MODULE_7__["PluginStateObject"].Shape.Representation3D,
    params: Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, _mol_repr_shape_loci_dihedral__WEBPACK_IMPORTED_MODULE_23__["DihedralParams"])
})({
    canAutoUpdate: function (_a) {
        var oldParams = _a.oldParams, newParams = _a.newParams;
        return true;
    },
    apply: function (_a, plugin) {
        var _this = this;
        var a = _a.a, params = _a.params;
        return _mol_task__WEBPACK_IMPORTED_MODULE_4__["Task"].create('Structure Dihedral', function (ctx) { return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"])(_this, void 0, void 0, function () {
            var data, repr;
            var _a;
            return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__generator"])(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        data = Object(_helpers__WEBPACK_IMPORTED_MODULE_19__["getDihedralDataFromStructureSelections"])(a.data);
                        repr = Object(_mol_repr_shape_loci_dihedral__WEBPACK_IMPORTED_MODULE_23__["DihedralRepresentation"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({ webgl: (_a = plugin.canvas3d) === null || _a === void 0 ? void 0 : _a.webgl }, plugin.representation.structure.themes), function () { return _mol_repr_shape_loci_dihedral__WEBPACK_IMPORTED_MODULE_23__["DihedralParams"]; });
                        return [4 /*yield*/, repr.createOrUpdate(params, data).runInContext(ctx)];
                    case 1:
                        _b.sent();
                        return [2 /*return*/, new _objects__WEBPACK_IMPORTED_MODULE_7__["PluginStateObject"].Shape.Representation3D({ repr: repr, source: a }, { label: "Dihedral" })];
                }
            });
        }); });
    },
    update: function (_a, plugin) {
        var _this = this;
        var a = _a.a, b = _a.b, oldParams = _a.oldParams, newParams = _a.newParams;
        return _mol_task__WEBPACK_IMPORTED_MODULE_4__["Task"].create('Structure Dihedral', function (ctx) { return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"])(_this, void 0, void 0, function () {
            var props, data;
            return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__generator"])(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        props = Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, b.data.repr.props), newParams);
                        data = Object(_helpers__WEBPACK_IMPORTED_MODULE_19__["getDihedralDataFromStructureSelections"])(a.data);
                        return [4 /*yield*/, b.data.repr.createOrUpdate(props, data).runInContext(ctx)];
                    case 1:
                        _a.sent();
                        b.data.source = a;
                        return [2 /*return*/, _mol_state__WEBPACK_IMPORTED_MODULE_3__["StateTransformer"].UpdateResult.Updated];
                }
            });
        }); });
    },
});

var StructureSelectionsLabel3D = _objects__WEBPACK_IMPORTED_MODULE_7__["PluginStateTransform"].BuiltIn({
    name: 'structure-selections-label-3d',
    display: '3D Label',
    from: _objects__WEBPACK_IMPORTED_MODULE_7__["PluginStateObject"].Molecule.Structure.Selections,
    to: _objects__WEBPACK_IMPORTED_MODULE_7__["PluginStateObject"].Shape.Representation3D,
    params: Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, _mol_repr_shape_loci_label__WEBPACK_IMPORTED_MODULE_20__["LabelParams"])
})({
    canAutoUpdate: function (_a) {
        var oldParams = _a.oldParams, newParams = _a.newParams;
        return true;
    },
    apply: function (_a, plugin) {
        var _this = this;
        var a = _a.a, params = _a.params;
        return _mol_task__WEBPACK_IMPORTED_MODULE_4__["Task"].create('Structure Label', function (ctx) { return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"])(_this, void 0, void 0, function () {
            var data, repr;
            var _a;
            return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__generator"])(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        data = Object(_helpers__WEBPACK_IMPORTED_MODULE_19__["getLabelDataFromStructureSelections"])(a.data);
                        repr = Object(_mol_repr_shape_loci_label__WEBPACK_IMPORTED_MODULE_20__["LabelRepresentation"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({ webgl: (_a = plugin.canvas3d) === null || _a === void 0 ? void 0 : _a.webgl }, plugin.representation.structure.themes), function () { return _mol_repr_shape_loci_label__WEBPACK_IMPORTED_MODULE_20__["LabelParams"]; });
                        return [4 /*yield*/, repr.createOrUpdate(params, data).runInContext(ctx)];
                    case 1:
                        _b.sent();
                        return [2 /*return*/, new _objects__WEBPACK_IMPORTED_MODULE_7__["PluginStateObject"].Shape.Representation3D({ repr: repr, source: a }, { label: "Label" })];
                }
            });
        }); });
    },
    update: function (_a, plugin) {
        var _this = this;
        var a = _a.a, b = _a.b, oldParams = _a.oldParams, newParams = _a.newParams;
        return _mol_task__WEBPACK_IMPORTED_MODULE_4__["Task"].create('Structure Label', function (ctx) { return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"])(_this, void 0, void 0, function () {
            var props, data;
            return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__generator"])(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        props = Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, b.data.repr.props), newParams);
                        data = Object(_helpers__WEBPACK_IMPORTED_MODULE_19__["getLabelDataFromStructureSelections"])(a.data);
                        return [4 /*yield*/, b.data.repr.createOrUpdate(props, data).runInContext(ctx)];
                    case 1:
                        _a.sent();
                        b.data.source = a;
                        return [2 /*return*/, _mol_state__WEBPACK_IMPORTED_MODULE_3__["StateTransformer"].UpdateResult.Updated];
                }
            });
        }); });
    },
});

var StructureSelectionsOrientation3D = _objects__WEBPACK_IMPORTED_MODULE_7__["PluginStateTransform"].BuiltIn({
    name: 'structure-selections-orientation-3d',
    display: '3D Orientation',
    from: _objects__WEBPACK_IMPORTED_MODULE_7__["PluginStateObject"].Molecule.Structure.Selections,
    to: _objects__WEBPACK_IMPORTED_MODULE_7__["PluginStateObject"].Shape.Representation3D,
    params: Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, _mol_repr_shape_loci_orientation__WEBPACK_IMPORTED_MODULE_21__["OrientationParams"])
})({
    canAutoUpdate: function (_a) {
        var oldParams = _a.oldParams, newParams = _a.newParams;
        return true;
    },
    apply: function (_a, plugin) {
        var _this = this;
        var a = _a.a, params = _a.params;
        return _mol_task__WEBPACK_IMPORTED_MODULE_4__["Task"].create('Structure Orientation', function (ctx) { return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"])(_this, void 0, void 0, function () {
            var data, repr;
            var _a;
            return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__generator"])(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        data = Object(_helpers__WEBPACK_IMPORTED_MODULE_19__["getOrientationDataFromStructureSelections"])(a.data);
                        repr = Object(_mol_repr_shape_loci_orientation__WEBPACK_IMPORTED_MODULE_21__["OrientationRepresentation"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({ webgl: (_a = plugin.canvas3d) === null || _a === void 0 ? void 0 : _a.webgl }, plugin.representation.structure.themes), function () { return _mol_repr_shape_loci_orientation__WEBPACK_IMPORTED_MODULE_21__["OrientationParams"]; });
                        return [4 /*yield*/, repr.createOrUpdate(params, data).runInContext(ctx)];
                    case 1:
                        _b.sent();
                        return [2 /*return*/, new _objects__WEBPACK_IMPORTED_MODULE_7__["PluginStateObject"].Shape.Representation3D({ repr: repr, source: a }, { label: "Orientation" })];
                }
            });
        }); });
    },
    update: function (_a, plugin) {
        var _this = this;
        var a = _a.a, b = _a.b, oldParams = _a.oldParams, newParams = _a.newParams;
        return _mol_task__WEBPACK_IMPORTED_MODULE_4__["Task"].create('Structure Orientation', function (ctx) { return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"])(_this, void 0, void 0, function () {
            var props, data;
            return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__generator"])(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        props = Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, b.data.repr.props), newParams);
                        data = Object(_helpers__WEBPACK_IMPORTED_MODULE_19__["getOrientationDataFromStructureSelections"])(a.data);
                        return [4 /*yield*/, b.data.repr.createOrUpdate(props, data).runInContext(ctx)];
                    case 1:
                        _a.sent();
                        b.data.source = a;
                        return [2 /*return*/, _mol_state__WEBPACK_IMPORTED_MODULE_3__["StateTransformer"].UpdateResult.Updated];
                }
            });
        }); });
    },
});
//# sourceMappingURL=representation.js.map

/***/ }),

/***/ "./lib/mol-plugin-state/transforms/volume.js":
/*!***************************************************!*\
  !*** ./lib/mol-plugin-state/transforms/volume.js ***!
  \***************************************************/
/*! exports provided: VolumeFromCcp4, VolumeFromDsn6, VolumeFromCube, VolumeFromDx, AssignColorVolume, VolumeFromDensityServerCif */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "VolumeFromCcp4", function() { return VolumeFromCcp4; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "VolumeFromDsn6", function() { return VolumeFromDsn6; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "VolumeFromCube", function() { return VolumeFromCube; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "VolumeFromDx", function() { return VolumeFromDx; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "AssignColorVolume", function() { return AssignColorVolume; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "VolumeFromDensityServerCif", function() { return VolumeFromDensityServerCif; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _mol_io_reader_cif__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../mol-io/reader/cif */ "./lib/mol-io/reader/cif.js");
/* harmony import */ var _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../mol-math/linear-algebra */ "./lib/mol-math/linear-algebra.js");
/* harmony import */ var _mol_model_formats_volume_ccp4__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../mol-model-formats/volume/ccp4 */ "./lib/mol-model-formats/volume/ccp4.js");
/* harmony import */ var _mol_model_formats_volume_density_server__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../mol-model-formats/volume/density-server */ "./lib/mol-model-formats/volume/density-server.js");
/* harmony import */ var _mol_model_formats_volume_dsn6__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../mol-model-formats/volume/dsn6 */ "./lib/mol-model-formats/volume/dsn6.js");
/* harmony import */ var _mol_task__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../../mol-task */ "./lib/mol-task/index.js");
/* harmony import */ var _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../../mol-util/param-definition */ "./lib/mol-util/param-definition.js");
/* harmony import */ var _objects__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ../objects */ "./lib/mol-plugin-state/objects.js");
/* harmony import */ var _mol_model_formats_volume_cube__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ../../mol-model-formats/volume/cube */ "./lib/mol-model-formats/volume/cube.js");
/* harmony import */ var _mol_model_formats_volume_dx__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ../../mol-model-formats/volume/dx */ "./lib/mol-model-formats/volume/dx.js");
/* harmony import */ var _mol_state__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ../../mol-state */ "./lib/mol-state/index.js");
/**
 * Copyright (c) 2018-2020 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author David Sehnal <david.sehnal@gmail.com>
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */


















var VolumeFromCcp4 = _objects__WEBPACK_IMPORTED_MODULE_8__["PluginStateTransform"].BuiltIn({
    name: 'volume-from-ccp4',
    display: { name: 'Volume from CCP4/MRC/MAP', description: 'Create Volume from CCP4/MRC/MAP data' },
    from: _objects__WEBPACK_IMPORTED_MODULE_8__["PluginStateObject"].Format.Ccp4,
    to: _objects__WEBPACK_IMPORTED_MODULE_8__["PluginStateObject"].Volume.Data,
    params: function (a) {
        return {
            voxelSize: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_7__["ParamDefinition"].Vec3(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_2__["Vec3"].create(1, 1, 1)),
            offset: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_7__["ParamDefinition"].Vec3(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_2__["Vec3"].create(0, 0, 0)),
            entryId: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_7__["ParamDefinition"].Text(''),
        };
    }
})({
    apply: function (_a) {
        var _this = this;
        var a = _a.a, params = _a.params;
        return _mol_task__WEBPACK_IMPORTED_MODULE_6__["Task"].create('Create volume from CCP4/MRC/MAP', function (ctx) { return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"])(_this, void 0, void 0, function () {
            var volume, props;
            return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__generator"])(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, Object(_mol_model_formats_volume_ccp4__WEBPACK_IMPORTED_MODULE_3__["volumeFromCcp4"])(a.data, Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, params), { label: a.data.name || a.label })).runInContext(ctx)];
                    case 1:
                        volume = _a.sent();
                        props = { label: volume.label || 'Volume', description: "Volume " + a.data.header.NX + "\u00D7" + a.data.header.NX + "\u00D7" + a.data.header.NX };
                        return [2 /*return*/, new _objects__WEBPACK_IMPORTED_MODULE_8__["PluginStateObject"].Volume.Data(volume, props)];
                }
            });
        }); });
    },
    dispose: function (_a) {
        var b = _a.b;
        b === null || b === void 0 ? void 0 : b.data.customProperties.dispose();
    }
});
var VolumeFromDsn6 = _objects__WEBPACK_IMPORTED_MODULE_8__["PluginStateTransform"].BuiltIn({
    name: 'volume-from-dsn6',
    display: { name: 'Volume from DSN6/BRIX', description: 'Create Volume from DSN6/BRIX data' },
    from: _objects__WEBPACK_IMPORTED_MODULE_8__["PluginStateObject"].Format.Dsn6,
    to: _objects__WEBPACK_IMPORTED_MODULE_8__["PluginStateObject"].Volume.Data,
    params: function (a) {
        return {
            voxelSize: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_7__["ParamDefinition"].Vec3(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_2__["Vec3"].create(1, 1, 1)),
            entryId: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_7__["ParamDefinition"].Text(''),
        };
    }
})({
    apply: function (_a) {
        var _this = this;
        var a = _a.a, params = _a.params;
        return _mol_task__WEBPACK_IMPORTED_MODULE_6__["Task"].create('Create volume from DSN6/BRIX', function (ctx) { return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"])(_this, void 0, void 0, function () {
            var volume, props;
            return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__generator"])(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, Object(_mol_model_formats_volume_dsn6__WEBPACK_IMPORTED_MODULE_5__["volumeFromDsn6"])(a.data, Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, params), { label: a.data.name || a.label })).runInContext(ctx)];
                    case 1:
                        volume = _a.sent();
                        props = { label: volume.label || 'Volume', description: "Volume " + a.data.header.xExtent + "\u00D7" + a.data.header.yExtent + "\u00D7" + a.data.header.zExtent };
                        return [2 /*return*/, new _objects__WEBPACK_IMPORTED_MODULE_8__["PluginStateObject"].Volume.Data(volume, props)];
                }
            });
        }); });
    },
    dispose: function (_a) {
        var b = _a.b;
        b === null || b === void 0 ? void 0 : b.data.customProperties.dispose();
    }
});
var VolumeFromCube = _objects__WEBPACK_IMPORTED_MODULE_8__["PluginStateTransform"].BuiltIn({
    name: 'volume-from-cube',
    display: { name: 'Volume from Cube', description: 'Create Volume from Cube data' },
    from: _objects__WEBPACK_IMPORTED_MODULE_8__["PluginStateObject"].Format.Cube,
    to: _objects__WEBPACK_IMPORTED_MODULE_8__["PluginStateObject"].Volume.Data,
    params: function (a) {
        var dataIndex = a ? _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_7__["ParamDefinition"].Select(0, a.data.header.dataSetIds.map(function (id, i) { return [i, "" + id]; })) : _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_7__["ParamDefinition"].Numeric(0);
        return {
            dataIndex: dataIndex,
            entryId: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_7__["ParamDefinition"].Text(''),
        };
    }
})({
    apply: function (_a) {
        var _this = this;
        var a = _a.a, params = _a.params;
        return _mol_task__WEBPACK_IMPORTED_MODULE_6__["Task"].create('Create volume from Cube', function (ctx) { return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"])(_this, void 0, void 0, function () {
            var volume, props;
            return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__generator"])(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, Object(_mol_model_formats_volume_cube__WEBPACK_IMPORTED_MODULE_9__["volumeFromCube"])(a.data, Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, params), { label: a.data.name || a.label })).runInContext(ctx)];
                    case 1:
                        volume = _a.sent();
                        props = { label: volume.label || 'Volume', description: "Volume " + a.data.header.dim[0] + "\u00D7" + a.data.header.dim[1] + "\u00D7" + a.data.header.dim[2] };
                        return [2 /*return*/, new _objects__WEBPACK_IMPORTED_MODULE_8__["PluginStateObject"].Volume.Data(volume, props)];
                }
            });
        }); });
    },
    dispose: function (_a) {
        var b = _a.b;
        b === null || b === void 0 ? void 0 : b.data.customProperties.dispose();
    }
});
var VolumeFromDx = _objects__WEBPACK_IMPORTED_MODULE_8__["PluginStateTransform"].BuiltIn({
    name: 'volume-from-dx',
    display: { name: 'Parse DX', description: 'Create volume from DX data.' },
    from: _objects__WEBPACK_IMPORTED_MODULE_8__["PluginStateObject"].Format.Dx,
    to: _objects__WEBPACK_IMPORTED_MODULE_8__["PluginStateObject"].Volume.Data
})({
    apply: function (_a) {
        var _this = this;
        var a = _a.a;
        return _mol_task__WEBPACK_IMPORTED_MODULE_6__["Task"].create('Parse DX', function (ctx) { return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"])(_this, void 0, void 0, function () {
            var volume, props;
            return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__generator"])(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, Object(_mol_model_formats_volume_dx__WEBPACK_IMPORTED_MODULE_10__["volumeFromDx"])(a.data, { label: a.data.name || a.label }).runInContext(ctx)];
                    case 1:
                        volume = _a.sent();
                        props = { label: volume.label || 'Volume', description: "Volume " + a.data.header.dim[0] + "\u00D7" + a.data.header.dim[1] + "\u00D7" + a.data.header.dim[2] };
                        return [2 /*return*/, new _objects__WEBPACK_IMPORTED_MODULE_8__["PluginStateObject"].Volume.Data(volume, props)];
                }
            });
        }); });
    },
    dispose: function (_a) {
        var b = _a.b;
        b === null || b === void 0 ? void 0 : b.data.customProperties.dispose();
    }
});
var VolumeFromDensityServerCif = _objects__WEBPACK_IMPORTED_MODULE_8__["PluginStateTransform"].BuiltIn({
    name: 'volume-from-density-server-cif',
    display: { name: 'Volume from density-server CIF', description: 'Identify and create all separate models in the specified CIF data block' },
    from: _objects__WEBPACK_IMPORTED_MODULE_8__["PluginStateObject"].Format.Cif,
    to: _objects__WEBPACK_IMPORTED_MODULE_8__["PluginStateObject"].Volume.Data,
    params: function (a) {
        if (!a) {
            return {
                blockHeader: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_7__["ParamDefinition"].Optional(_mol_util_param_definition__WEBPACK_IMPORTED_MODULE_7__["ParamDefinition"].Text(void 0, { description: 'Header of the block to parse. If none is specifed, the 1st data block in the file is used.' })),
                entryId: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_7__["ParamDefinition"].Text(''),
            };
        }
        var blocks = a.data.blocks.slice(1); // zero block contains query meta-data
        return {
            blockHeader: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_7__["ParamDefinition"].Optional(_mol_util_param_definition__WEBPACK_IMPORTED_MODULE_7__["ParamDefinition"].Select(blocks[0] && blocks[0].header, blocks.map(function (b) { return [b.header, b.header]; }), { description: 'Header of the block to parse' })),
            entryId: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_7__["ParamDefinition"].Text(''),
        };
    }
})({
    isApplicable: function (a) { return a.data.blocks.length > 0; },
    apply: function (_a) {
        var _this = this;
        var a = _a.a, params = _a.params;
        return _mol_task__WEBPACK_IMPORTED_MODULE_6__["Task"].create('Parse density-server CIF', function (ctx) { return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"])(_this, void 0, void 0, function () {
            var header, block, densityServerCif, volume, _a, x, y, z, props;
            return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__generator"])(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        header = params.blockHeader || a.data.blocks[1].header;
                        block = a.data.blocks.find(function (b) { return b.header === header; });
                        if (!block)
                            throw new Error("Data block '" + [header] + "' not found.");
                        densityServerCif = _mol_io_reader_cif__WEBPACK_IMPORTED_MODULE_1__["CIF"].schema.densityServer(block);
                        return [4 /*yield*/, Object(_mol_model_formats_volume_density_server__WEBPACK_IMPORTED_MODULE_4__["volumeFromDensityServerData"])(densityServerCif, { entryId: params.entryId }).runInContext(ctx)];
                    case 1:
                        volume = _b.sent();
                        _a = volume.grid.cells.space.dimensions, x = _a[0], y = _a[1], z = _a[2];
                        props = { label: densityServerCif.volume_data_3d_info.name.value(0), description: "Volume " + x + "\u00D7" + y + "\u00D7" + z };
                        return [2 /*return*/, new _objects__WEBPACK_IMPORTED_MODULE_8__["PluginStateObject"].Volume.Data(volume, props)];
                }
            });
        }); });
    },
    dispose: function (_a) {
        var b = _a.b;
        b === null || b === void 0 ? void 0 : b.data.customProperties.dispose();
    }
});
var AssignColorVolume = _objects__WEBPACK_IMPORTED_MODULE_8__["PluginStateTransform"].BuiltIn({
    name: 'assign-color-volume',
    display: { name: 'Assign Color Volume', description: 'Assigns another volume to be available for coloring.' },
    from: _objects__WEBPACK_IMPORTED_MODULE_8__["PluginStateObject"].Volume.Data,
    to: _objects__WEBPACK_IMPORTED_MODULE_8__["PluginStateObject"].Volume.Data,
    isDecorator: true,
    params: function (a, plugin) {
        if (!a)
            return { ref: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_7__["ParamDefinition"].Text() };
        var cells = plugin.state.data.select(_mol_state__WEBPACK_IMPORTED_MODULE_11__["StateSelection"].Generators.root.subtree().ofType(_objects__WEBPACK_IMPORTED_MODULE_8__["PluginStateObject"].Volume.Data).filter(function (cell) { var _a; return !!cell.obj && !((_a = cell.obj) === null || _a === void 0 ? void 0 : _a.data.colorVolume) && cell.obj !== a; }));
        if (cells.length === 0)
            return { ref: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_7__["ParamDefinition"].Text('', { isHidden: true }) };
        return { ref: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_7__["ParamDefinition"].Select(cells[0].transform.ref, cells.map(function (c) { return [c.transform.ref, c.obj.label]; })) };
    }
})({
    apply: function (_a) {
        var _this = this;
        var a = _a.a, params = _a.params, dependencies = _a.dependencies;
        return _mol_task__WEBPACK_IMPORTED_MODULE_6__["Task"].create('Assign Color Volume', function (ctx) { return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"])(_this, void 0, void 0, function () {
            var colorVolume, volume, props;
            return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__generator"])(this, function (_a) {
                if (!dependencies || !dependencies[params.ref]) {
                    throw new Error('Dependency not available.');
                }
                colorVolume = dependencies[params.ref].data;
                volume = Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, a.data), { colorVolume: colorVolume });
                props = { label: a.label, description: 'Volume + Colors' };
                return [2 /*return*/, new _objects__WEBPACK_IMPORTED_MODULE_8__["PluginStateObject"].Volume.Data(volume, props)];
            });
        }); });
    }
});
//# sourceMappingURL=volume.js.map

/***/ }),

/***/ "./lib/mol-plugin-ui/base.js":
/*!***********************************!*\
  !*** ./lib/mol-plugin-ui/base.js ***!
  \***********************************/
/*! exports provided: PluginReactContext, PluginUIComponent, PurePluginUIComponent, CollapsableControls */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "PluginReactContext", function() { return PluginReactContext; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "PluginUIComponent", function() { return PluginUIComponent; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "PurePluginUIComponent", function() { return PurePluginUIComponent; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CollapsableControls", function() { return CollapsableControls; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! react */ "./node_modules/react/index.js");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _controls_common__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./controls/common */ "./lib/mol-plugin-ui/controls/common.js");
/* harmony import */ var _controls_icons__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./controls/icons */ "./lib/mol-plugin-ui/controls/icons.js");
/**
 * Copyright (c) 2018-2020 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author David Sehnal <david.sehnal@gmail.com>
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */




var PluginReactContext = react__WEBPACK_IMPORTED_MODULE_1__["createContext"](void 0);
var PluginUIComponent = /** @class */ (function (_super) {
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__extends"])(PluginUIComponent, _super);
    function PluginUIComponent(props, context) {
        var _this = _super.call(this, props, context) || this;
        _this.subs = void 0;
        _this.plugin = context;
        if (_this.init)
            _this.init();
        return _this;
    }
    PluginUIComponent.prototype.subscribe = function (obs, action) {
        if (typeof this.subs === 'undefined')
            this.subs = [];
        this.subs.push(obs.subscribe(action));
    };
    PluginUIComponent.prototype.componentWillUnmount = function () {
        if (!this.subs)
            return;
        for (var _i = 0, _a = this.subs; _i < _a.length; _i++) {
            var s = _a[_i];
            s.unsubscribe();
        }
        this.subs = void 0;
    };
    PluginUIComponent.contextType = PluginReactContext;
    return PluginUIComponent;
}(react__WEBPACK_IMPORTED_MODULE_1__["Component"]));

var PurePluginUIComponent = /** @class */ (function (_super) {
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__extends"])(PurePluginUIComponent, _super);
    function PurePluginUIComponent(props, context) {
        var _this = _super.call(this, props, context) || this;
        _this.subs = void 0;
        _this.plugin = context;
        if (_this.init)
            _this.init();
        return _this;
    }
    PurePluginUIComponent.prototype.subscribe = function (obs, action) {
        if (typeof this.subs === 'undefined')
            this.subs = [];
        this.subs.push(obs.subscribe(action));
    };
    PurePluginUIComponent.prototype.componentWillUnmount = function () {
        if (!this.subs)
            return;
        for (var _i = 0, _a = this.subs; _i < _a.length; _i++) {
            var s = _a[_i];
            s.unsubscribe();
        }
        this.subs = void 0;
    };
    PurePluginUIComponent.contextType = PluginReactContext;
    return PurePluginUIComponent;
}(react__WEBPACK_IMPORTED_MODULE_1__["PureComponent"]));

var CollapsableControls = /** @class */ (function (_super) {
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__extends"])(CollapsableControls, _super);
    function CollapsableControls(props, context) {
        var _this = _super.call(this, props, context) || this;
        _this.toggleCollapsed = function () {
            _this.setState({ isCollapsed: !_this.state.isCollapsed });
        };
        var state = _this.defaultState();
        if (props.initiallyCollapsed !== undefined)
            state.isCollapsed = props.initiallyCollapsed;
        if (props.header !== undefined)
            state.header = props.header;
        _this.state = state;
        return _this;
    }
    CollapsableControls.prototype.componentDidUpdate = function (prevProps) {
        if (this.props.initiallyCollapsed !== undefined && prevProps.initiallyCollapsed !== this.props.initiallyCollapsed) {
            this.setState({ isCollapsed: this.props.initiallyCollapsed });
        }
    };
    CollapsableControls.prototype.render = function () {
        var _a;
        if (this.state.isHidden)
            return null;
        var wrapClass = this.state.isCollapsed
            ? 'msp-transform-wrapper msp-transform-wrapper-collapsed'
            : 'msp-transform-wrapper';
        return react__WEBPACK_IMPORTED_MODULE_1__["createElement"]("div", { className: wrapClass },
            react__WEBPACK_IMPORTED_MODULE_1__["createElement"]("div", { className: 'msp-transform-header' },
                react__WEBPACK_IMPORTED_MODULE_1__["createElement"](_controls_common__WEBPACK_IMPORTED_MODULE_2__["Button"], { icon: this.state.brand ? void 0 : this.state.isCollapsed ? _controls_icons__WEBPACK_IMPORTED_MODULE_3__["ArrowRightSvg"] : _controls_icons__WEBPACK_IMPORTED_MODULE_3__["ArrowDropDownSvg"], noOverflow: true, onClick: this.toggleCollapsed, className: this.state.brand ? "msp-transform-header-brand msp-transform-header-brand-" + this.state.brand.accent : void 0, title: "Click to " + (this.state.isCollapsed ? 'expand' : 'collapse') },
                    react__WEBPACK_IMPORTED_MODULE_1__["createElement"](_controls_icons__WEBPACK_IMPORTED_MODULE_3__["Icon"], { svg: (_a = this.state.brand) === null || _a === void 0 ? void 0 : _a.svg, inline: true }),
                    this.state.header,
                    react__WEBPACK_IMPORTED_MODULE_1__["createElement"]("small", { style: { margin: '0 6px' } }, this.state.isCollapsed ? '' : this.state.description))),
            !this.state.isCollapsed && this.renderControls());
    };
    return CollapsableControls;
}(PluginUIComponent));

//# sourceMappingURL=base.js.map

/***/ }),

/***/ "./lib/mol-plugin-ui/controls.js":
/*!***************************************!*\
  !*** ./lib/mol-plugin-ui/controls.js ***!
  \***************************************/
/*! exports provided: TrajectoryViewportControls, StateSnapshotViewportControls, AnimationViewportControls, SelectionViewportControls, LociLabels, CustomStructureControls, DefaultStructureTools */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "TrajectoryViewportControls", function() { return TrajectoryViewportControls; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "StateSnapshotViewportControls", function() { return StateSnapshotViewportControls; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "AnimationViewportControls", function() { return AnimationViewportControls; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SelectionViewportControls", function() { return SelectionViewportControls; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "LociLabels", function() { return LociLabels; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CustomStructureControls", function() { return CustomStructureControls; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DefaultStructureTools", function() { return DefaultStructureTools; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! react */ "./node_modules/react/index.js");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _mol_plugin_state_actions_structure__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../mol-plugin-state/actions/structure */ "./lib/mol-plugin-state/actions/structure.js");
/* harmony import */ var _mol_plugin_state_transforms__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../mol-plugin-state/transforms */ "./lib/mol-plugin-state/transforms.js");
/* harmony import */ var _mol_plugin_commands__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../mol-plugin/commands */ "./lib/mol-plugin/commands.js");
/* harmony import */ var _base__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./base */ "./lib/mol-plugin-ui/base.js");
/* harmony import */ var _controls_common__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ./controls/common */ "./lib/mol-plugin-ui/controls/common.js");
/* harmony import */ var _controls_icons__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ./controls/icons */ "./lib/mol-plugin-ui/controls/icons.js");
/* harmony import */ var _state_animation__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ./state/animation */ "./lib/mol-plugin-ui/state/animation.js");
/* harmony import */ var _structure_components__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ./structure/components */ "./lib/mol-plugin-ui/structure/components.js");
/* harmony import */ var _structure_measurements__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ./structure/measurements */ "./lib/mol-plugin-ui/structure/measurements.js");
/* harmony import */ var _structure_selection__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ./structure/selection */ "./lib/mol-plugin-ui/structure/selection.js");
/* harmony import */ var _structure_source__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! ./structure/source */ "./lib/mol-plugin-ui/structure/source.js");
/* harmony import */ var _structure_volume__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! ./structure/volume */ "./lib/mol-plugin-ui/structure/volume.js");
/* harmony import */ var _mol_plugin_config__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! ../mol-plugin/config */ "./lib/mol-plugin/config.js");
/* harmony import */ var _structure_superposition__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! ./structure/superposition */ "./lib/mol-plugin-ui/structure/superposition.js");
/**
 * Copyright (c) 2018-2020 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author David Sehnal <david.sehnal@gmail.com>
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */
















var TrajectoryViewportControls = /** @class */ (function (_super) {
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__extends"])(TrajectoryViewportControls, _super);
    function TrajectoryViewportControls() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = { show: false, label: '' };
        _this.update = function () {
            var state = _this.plugin.state.data;
            var models = state.selectQ(function (q) { return q.ofTransformer(_mol_plugin_state_transforms__WEBPACK_IMPORTED_MODULE_3__["StateTransforms"].Model.ModelFromTrajectory); });
            if (models.length === 0) {
                _this.setState({ show: false });
                return;
            }
            var label = '', count = 0, parents = new Set();
            for (var _i = 0, models_1 = models; _i < models_1.length; _i++) {
                var m = models_1[_i];
                if (!m.sourceRef)
                    continue;
                var parent_1 = state.cells.get(m.sourceRef).obj;
                if (!parent_1)
                    continue;
                if (parent_1.data.frameCount > 1) {
                    if (parents.has(m.sourceRef)) {
                        // do not show the controls if there are 2 models of the same trajectory present
                        _this.setState({ show: false });
                        return;
                    }
                    parents.add(m.sourceRef);
                    count++;
                    if (!label) {
                        var idx = m.transform.params.modelIndex;
                        label = "Model " + (idx + 1) + " / " + parent_1.data.frameCount;
                    }
                }
            }
            if (count > 1)
                label = '';
            _this.setState({ show: count > 0, label: label });
        };
        _this.reset = function () { return _mol_plugin_commands__WEBPACK_IMPORTED_MODULE_4__["PluginCommands"].State.ApplyAction(_this.plugin, {
            state: _this.plugin.state.data,
            action: _mol_plugin_state_actions_structure__WEBPACK_IMPORTED_MODULE_2__["UpdateTrajectory"].create({ action: 'reset' })
        }); };
        _this.prev = function () { return _mol_plugin_commands__WEBPACK_IMPORTED_MODULE_4__["PluginCommands"].State.ApplyAction(_this.plugin, {
            state: _this.plugin.state.data,
            action: _mol_plugin_state_actions_structure__WEBPACK_IMPORTED_MODULE_2__["UpdateTrajectory"].create({ action: 'advance', by: -1 })
        }); };
        _this.next = function () { return _mol_plugin_commands__WEBPACK_IMPORTED_MODULE_4__["PluginCommands"].State.ApplyAction(_this.plugin, {
            state: _this.plugin.state.data,
            action: _mol_plugin_state_actions_structure__WEBPACK_IMPORTED_MODULE_2__["UpdateTrajectory"].create({ action: 'advance', by: 1 })
        }); };
        return _this;
    }
    TrajectoryViewportControls.prototype.componentDidMount = function () {
        this.subscribe(this.plugin.state.data.events.changed, this.update);
        this.subscribe(this.plugin.behaviors.state.isAnimating, this.update);
    };
    TrajectoryViewportControls.prototype.render = function () {
        var isAnimating = this.plugin.behaviors.state.isAnimating.value;
        if (!this.state.show || (isAnimating && !this.state.label))
            return null;
        return react__WEBPACK_IMPORTED_MODULE_1__["createElement"]("div", { className: 'msp-traj-controls' },
            !isAnimating && react__WEBPACK_IMPORTED_MODULE_1__["createElement"](_controls_common__WEBPACK_IMPORTED_MODULE_6__["IconButton"], { svg: _controls_icons__WEBPACK_IMPORTED_MODULE_7__["SkipPreviousSvg"], title: 'First Model', onClick: this.reset, disabled: isAnimating }),
            !isAnimating && react__WEBPACK_IMPORTED_MODULE_1__["createElement"](_controls_common__WEBPACK_IMPORTED_MODULE_6__["IconButton"], { svg: _controls_icons__WEBPACK_IMPORTED_MODULE_7__["NavigateBeforeSvg"], title: 'Previous Model', onClick: this.prev, disabled: isAnimating }),
            !isAnimating && react__WEBPACK_IMPORTED_MODULE_1__["createElement"](_controls_common__WEBPACK_IMPORTED_MODULE_6__["IconButton"], { svg: _controls_icons__WEBPACK_IMPORTED_MODULE_7__["NavigateNextSvg"], title: 'Next Model', onClick: this.next, disabled: isAnimating }),
            !!this.state.label && react__WEBPACK_IMPORTED_MODULE_1__["createElement"]("span", null, this.state.label));
    };
    return TrajectoryViewportControls;
}(_base__WEBPACK_IMPORTED_MODULE_5__["PluginUIComponent"]));

var StateSnapshotViewportControls = /** @class */ (function (_super) {
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__extends"])(StateSnapshotViewportControls, _super);
    function StateSnapshotViewportControls() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = { isBusy: false, show: true };
        _this.keyUp = function (e) {
            if (!e.ctrlKey || _this.state.isBusy || e.target !== document.body)
                return;
            var snapshots = _this.plugin.managers.snapshot;
            if (e.keyCode === 37 || e.key === 'ArrowLeft') {
                if (snapshots.state.isPlaying)
                    snapshots.stop();
                _this.prev();
            }
            else if (e.keyCode === 38 || e.key === 'ArrowUp') {
                if (snapshots.state.isPlaying)
                    snapshots.stop();
                if (snapshots.state.entries.size === 0)
                    return;
                var e_1 = snapshots.state.entries.get(0);
                _this.update(e_1.snapshot.id);
            }
            else if (e.keyCode === 39 || e.key === 'ArrowRight') {
                if (snapshots.state.isPlaying)
                    snapshots.stop();
                _this.next();
            }
            else if (e.keyCode === 40 || e.key === 'ArrowDown') {
                if (snapshots.state.isPlaying)
                    snapshots.stop();
                if (snapshots.state.entries.size === 0)
                    return;
                var e_2 = snapshots.state.entries.get(snapshots.state.entries.size - 1);
                _this.update(e_2.snapshot.id);
            }
        };
        _this.change = function (e) {
            if (e.target.value === 'none')
                return;
            _this.update(e.target.value);
        };
        _this.prev = function () {
            var s = _this.plugin.managers.snapshot;
            var id = s.getNextId(s.state.current, -1);
            if (id)
                _this.update(id);
        };
        _this.next = function () {
            var s = _this.plugin.managers.snapshot;
            var id = s.getNextId(s.state.current, 1);
            if (id)
                _this.update(id);
        };
        _this.togglePlay = function () {
            _this.plugin.managers.snapshot.togglePlay();
        };
        return _this;
    }
    StateSnapshotViewportControls.prototype.componentDidMount = function () {
        var _this = this;
        // TODO: this needs to be diabled when the state is updating!
        this.subscribe(this.plugin.managers.snapshot.events.changed, function () { return _this.forceUpdate(); });
        this.subscribe(this.plugin.behaviors.state.isBusy, function (isBusy) { return _this.setState({ isBusy: isBusy }); });
        this.subscribe(this.plugin.behaviors.state.isAnimating, function (isBusy) { return _this.setState({ isBusy: isBusy }); });
        window.addEventListener('keyup', this.keyUp, false);
    };
    StateSnapshotViewportControls.prototype.componentWillUnmount = function () {
        _super.prototype.componentWillUnmount.call(this);
        window.removeEventListener('keyup', this.keyUp, false);
    };
    StateSnapshotViewportControls.prototype.update = function (id) {
        return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"])(this, void 0, void 0, function () {
            return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__generator"])(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.setState({ isBusy: true });
                        return [4 /*yield*/, _mol_plugin_commands__WEBPACK_IMPORTED_MODULE_4__["PluginCommands"].State.Snapshots.Apply(this.plugin, { id: id })];
                    case 1:
                        _a.sent();
                        this.setState({ isBusy: false });
                        return [2 /*return*/];
                }
            });
        });
    };
    StateSnapshotViewportControls.prototype.render = function () {
        var snapshots = this.plugin.managers.snapshot;
        var count = snapshots.state.entries.size;
        if (count < 2 || !this.state.show) {
            return null;
        }
        var current = snapshots.state.current;
        var isPlaying = snapshots.state.isPlaying;
        return react__WEBPACK_IMPORTED_MODULE_1__["createElement"]("div", { className: 'msp-state-snapshot-viewport-controls' },
            react__WEBPACK_IMPORTED_MODULE_1__["createElement"]("select", { className: 'msp-form-control', value: current || 'none', onChange: this.change, disabled: this.state.isBusy || isPlaying },
                !current && react__WEBPACK_IMPORTED_MODULE_1__["createElement"]("option", { key: 'none', value: 'none' }),
                snapshots.state.entries.valueSeq().map(function (e, i) { return react__WEBPACK_IMPORTED_MODULE_1__["createElement"]("option", { key: e.snapshot.id, value: e.snapshot.id }, "[" + (i + 1) + "/" + count + "]",
                    " ",
                    e.name || new Date(e.timestamp).toLocaleString()); })),
            react__WEBPACK_IMPORTED_MODULE_1__["createElement"](_controls_common__WEBPACK_IMPORTED_MODULE_6__["IconButton"], { svg: isPlaying ? _controls_icons__WEBPACK_IMPORTED_MODULE_7__["StopSvg"] : _controls_icons__WEBPACK_IMPORTED_MODULE_7__["PlayArrowSvg"], title: isPlaying ? 'Pause' : 'Cycle States', onClick: this.togglePlay, disabled: isPlaying ? false : this.state.isBusy }),
            !isPlaying && react__WEBPACK_IMPORTED_MODULE_1__["createElement"](react__WEBPACK_IMPORTED_MODULE_1__["Fragment"], null,
                react__WEBPACK_IMPORTED_MODULE_1__["createElement"](_controls_common__WEBPACK_IMPORTED_MODULE_6__["IconButton"], { svg: _controls_icons__WEBPACK_IMPORTED_MODULE_7__["NavigateBeforeSvg"], title: 'Previous State', onClick: this.prev, disabled: this.state.isBusy || isPlaying }),
                react__WEBPACK_IMPORTED_MODULE_1__["createElement"](_controls_common__WEBPACK_IMPORTED_MODULE_6__["IconButton"], { svg: _controls_icons__WEBPACK_IMPORTED_MODULE_7__["NavigateNextSvg"], title: 'Next State', onClick: this.next, disabled: this.state.isBusy || isPlaying })));
    };
    return StateSnapshotViewportControls;
}(_base__WEBPACK_IMPORTED_MODULE_5__["PluginUIComponent"]));

var AnimationViewportControls = /** @class */ (function (_super) {
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__extends"])(AnimationViewportControls, _super);
    function AnimationViewportControls() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = { isEmpty: true, isExpanded: false, isBusy: false, isAnimating: false, isPlaying: false };
        _this.toggleExpanded = function () { return _this.setState({ isExpanded: !_this.state.isExpanded }); };
        _this.stop = function () {
            _this.plugin.managers.animation.stop();
            _this.plugin.managers.snapshot.stop();
        };
        return _this;
    }
    AnimationViewportControls.prototype.componentDidMount = function () {
        var _this = this;
        this.subscribe(this.plugin.managers.snapshot.events.changed, function () {
            if (_this.plugin.managers.snapshot.state.isPlaying)
                _this.setState({ isPlaying: true, isExpanded: false });
            else
                _this.setState({ isPlaying: false });
        });
        this.subscribe(this.plugin.behaviors.state.isBusy, function (isBusy) {
            if (isBusy)
                _this.setState({ isBusy: true, isExpanded: false, isEmpty: _this.plugin.state.data.tree.transforms.size < 2 });
            else
                _this.setState({ isBusy: false, isEmpty: _this.plugin.state.data.tree.transforms.size < 2 });
        });
        this.subscribe(this.plugin.behaviors.state.isAnimating, function (isAnimating) {
            if (isAnimating)
                _this.setState({ isAnimating: true, isExpanded: false });
            else
                _this.setState({ isAnimating: false });
        });
    };
    AnimationViewportControls.prototype.render = function () {
        var isPlaying = this.plugin.managers.snapshot.state.isPlaying;
        if (isPlaying || this.state.isEmpty || this.plugin.managers.animation.isEmpty || !this.plugin.config.get(_mol_plugin_config__WEBPACK_IMPORTED_MODULE_14__["PluginConfig"].Viewport.ShowAnimation))
            return null;
        var isAnimating = this.state.isAnimating;
        return react__WEBPACK_IMPORTED_MODULE_1__["createElement"]("div", { className: 'msp-animation-viewport-controls' },
            react__WEBPACK_IMPORTED_MODULE_1__["createElement"]("div", null,
                react__WEBPACK_IMPORTED_MODULE_1__["createElement"]("div", { className: 'msp-semi-transparent-background' }),
                react__WEBPACK_IMPORTED_MODULE_1__["createElement"](_controls_common__WEBPACK_IMPORTED_MODULE_6__["IconButton"], { svg: isAnimating || isPlaying ? _controls_icons__WEBPACK_IMPORTED_MODULE_7__["StopSvg"] : _controls_icons__WEBPACK_IMPORTED_MODULE_7__["SubscriptionsOutlinedSvg"], transparent: true, title: isAnimating ? 'Stop' : 'Select Animation', onClick: isAnimating || isPlaying ? this.stop : this.toggleExpanded, toggleState: this.state.isExpanded, disabled: isAnimating || isPlaying ? false : this.state.isBusy || this.state.isPlaying || this.state.isEmpty })),
            (this.state.isExpanded && !this.state.isBusy) && react__WEBPACK_IMPORTED_MODULE_1__["createElement"]("div", { className: 'msp-animation-viewport-controls-select' },
                react__WEBPACK_IMPORTED_MODULE_1__["createElement"](_state_animation__WEBPACK_IMPORTED_MODULE_8__["AnimationControls"], { onStart: this.toggleExpanded })));
    };
    return AnimationViewportControls;
}(_base__WEBPACK_IMPORTED_MODULE_5__["PluginUIComponent"]));

var SelectionViewportControls = /** @class */ (function (_super) {
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__extends"])(SelectionViewportControls, _super);
    function SelectionViewportControls() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.onMouseMove = function (e) {
            // ignore mouse moves when no button is held
            if (e.buttons === 0)
                e.stopPropagation();
        };
        return _this;
    }
    SelectionViewportControls.prototype.componentDidMount = function () {
        var _this = this;
        this.subscribe(this.plugin.behaviors.interaction.selectionMode, function () { return _this.forceUpdate(); });
    };
    SelectionViewportControls.prototype.render = function () {
        if (!this.plugin.selectionMode)
            return null;
        return react__WEBPACK_IMPORTED_MODULE_1__["createElement"]("div", { className: 'msp-selection-viewport-controls', onMouseMove: this.onMouseMove },
            react__WEBPACK_IMPORTED_MODULE_1__["createElement"](_structure_selection__WEBPACK_IMPORTED_MODULE_11__["StructureSelectionActionsControls"], null));
    };
    return SelectionViewportControls;
}(_base__WEBPACK_IMPORTED_MODULE_5__["PluginUIComponent"]));

var LociLabels = /** @class */ (function (_super) {
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__extends"])(LociLabels, _super);
    function LociLabels() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = { labels: [] };
        return _this;
    }
    LociLabels.prototype.componentDidMount = function () {
        var _this = this;
        this.subscribe(this.plugin.behaviors.labels.highlight, function (e) { return _this.setState({ labels: e.labels }); });
    };
    LociLabels.prototype.render = function () {
        if (this.state.labels.length === 0) {
            return null;
        }
        return react__WEBPACK_IMPORTED_MODULE_1__["createElement"]("div", { className: 'msp-highlight-info' }, this.state.labels.map(function (e, i) { return react__WEBPACK_IMPORTED_MODULE_1__["createElement"]("div", { key: '' + i, dangerouslySetInnerHTML: { __html: e } }); }));
    };
    return LociLabels;
}(_base__WEBPACK_IMPORTED_MODULE_5__["PluginUIComponent"]));

var CustomStructureControls = /** @class */ (function (_super) {
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__extends"])(CustomStructureControls, _super);
    function CustomStructureControls() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    CustomStructureControls.prototype.componentDidMount = function () {
        var _this = this;
        this.subscribe(this.plugin.state.behaviors.events.changed, function () { return _this.forceUpdate(); });
    };
    CustomStructureControls.prototype.render = function () {
        var _this = this;
        var controls = [];
        this.plugin.customStructureControls.forEach(function (Controls, key) {
            controls.push(react__WEBPACK_IMPORTED_MODULE_1__["createElement"](Controls, { initiallyCollapsed: _this.props.initiallyCollapsed, key: key }));
        });
        return controls.length > 0 ? react__WEBPACK_IMPORTED_MODULE_1__["createElement"](react__WEBPACK_IMPORTED_MODULE_1__["Fragment"], null, controls) : null;
    };
    return CustomStructureControls;
}(_base__WEBPACK_IMPORTED_MODULE_5__["PluginUIComponent"]));

var DefaultStructureTools = /** @class */ (function (_super) {
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__extends"])(DefaultStructureTools, _super);
    function DefaultStructureTools() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    DefaultStructureTools.prototype.render = function () {
        return react__WEBPACK_IMPORTED_MODULE_1__["createElement"](react__WEBPACK_IMPORTED_MODULE_1__["Fragment"], null,
            react__WEBPACK_IMPORTED_MODULE_1__["createElement"]("div", { className: 'msp-section-header' },
                react__WEBPACK_IMPORTED_MODULE_1__["createElement"](_controls_icons__WEBPACK_IMPORTED_MODULE_7__["Icon"], { svg: _controls_icons__WEBPACK_IMPORTED_MODULE_7__["BuildSvg"] }),
                "Structure Tools"),
            react__WEBPACK_IMPORTED_MODULE_1__["createElement"](_structure_source__WEBPACK_IMPORTED_MODULE_12__["StructureSourceControls"], null),
            react__WEBPACK_IMPORTED_MODULE_1__["createElement"](_structure_measurements__WEBPACK_IMPORTED_MODULE_10__["StructureMeasurementsControls"], null),
            react__WEBPACK_IMPORTED_MODULE_1__["createElement"](_structure_superposition__WEBPACK_IMPORTED_MODULE_15__["StructureSuperpositionControls"], null),
            react__WEBPACK_IMPORTED_MODULE_1__["createElement"](_structure_components__WEBPACK_IMPORTED_MODULE_9__["StructureComponentControls"], null),
            this.plugin.config.get(_mol_plugin_config__WEBPACK_IMPORTED_MODULE_14__["PluginConfig"].VolumeStreaming.Enabled) && react__WEBPACK_IMPORTED_MODULE_1__["createElement"](_structure_volume__WEBPACK_IMPORTED_MODULE_13__["VolumeStreamingControls"], null),
            react__WEBPACK_IMPORTED_MODULE_1__["createElement"](_structure_volume__WEBPACK_IMPORTED_MODULE_13__["VolumeSourceControls"], null),
            react__WEBPACK_IMPORTED_MODULE_1__["createElement"](CustomStructureControls, null));
    };
    return DefaultStructureTools;
}(_base__WEBPACK_IMPORTED_MODULE_5__["PluginUIComponent"]));

//# sourceMappingURL=controls.js.map

/***/ }),

/***/ "./lib/mol-plugin-ui/controls/action-menu.js":
/*!***************************************************!*\
  !*** ./lib/mol-plugin-ui/controls/action-menu.js ***!
  \***************************************************/
/*! exports provided: ActionMenu */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ActionMenu", function() { return ActionMenu; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! react */ "./node_modules/react/index.js");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _common__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./common */ "./lib/mol-plugin-ui/controls/common.js");
/* harmony import */ var _icons__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./icons */ "./lib/mol-plugin-ui/controls/icons.js");
/**
 * Copyright (c) 2020 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author David Sehnal <david.sehnal@gmail.com>
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */




var ActionMenu = /** @class */ (function (_super) {
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__extends"])(ActionMenu, _super);
    function ActionMenu() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.hide = function () { return _this.props.onSelect(void 0); };
        return _this;
    }
    ActionMenu.prototype.render = function () {
        var cmd = this.props;
        var section = react__WEBPACK_IMPORTED_MODULE_1__["createElement"](Section, { items: cmd.items, onSelect: cmd.onSelect, current: cmd.current, multiselect: this.props.multiselect, noOffset: this.props.noOffset, noAccent: this.props.noAccent });
        return react__WEBPACK_IMPORTED_MODULE_1__["createElement"]("div", { className: "msp-action-menu-options" + (cmd.header ? '' : ' msp-action-menu-options-no-header') },
            cmd.header && react__WEBPACK_IMPORTED_MODULE_1__["createElement"](_common__WEBPACK_IMPORTED_MODULE_2__["ControlGroup"], { header: cmd.header, title: cmd.title, initialExpanded: true, hideExpander: true, hideOffset: true, onHeaderClick: this.hide, topRightIcon: _icons__WEBPACK_IMPORTED_MODULE_3__["CloseSvg"] }, section),
            !cmd.header && section);
    };
    return ActionMenu;
}(react__WEBPACK_IMPORTED_MODULE_1__["PureComponent"]));

(function (ActionMenu) {
    function Header(label, options) {
        return options ? Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({ kind: 'header', label: label }, options) : { kind: 'header', label: label };
    }
    ActionMenu.Header = Header;
    function Item(label, value, options) {
        return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({ kind: 'item', label: label, value: value }, options);
    }
    ActionMenu.Item = Item;
    function createItems(xs, params) {
        var _a = params || {}, label = _a.label, value = _a.value, category = _a.category, selected = _a.selected, icon = _a.icon, addOn = _a.addOn, description = _a.description;
        var cats = void 0;
        var items = [];
        for (var i = 0; i < xs.length; i++) {
            var x = xs[i];
            if ((params === null || params === void 0 ? void 0 : params.filter) && !params.filter(x))
                continue;
            var catName = category === null || category === void 0 ? void 0 : category(x);
            var l = label ? label(x) : '' + x;
            var v = value ? value(x) : x;
            var d = description ? description(x) :
                typeof x === 'string' ? x : undefined;
            var cat = void 0;
            if (!!catName) {
                if (!cats)
                    cats = new Map();
                cat = cats.get(catName);
                if (!cat) {
                    cat = [ActionMenu.Header(catName, { description: catName })];
                    cats.set(catName, cat);
                    items.push(cat);
                }
            }
            else {
                cat = items;
            }
            var ao = addOn === null || addOn === void 0 ? void 0 : addOn(x);
            cat.push({ kind: 'item', label: l, value: v, icon: icon ? icon(x) : void 0, selected: selected ? selected(x) : void 0, addOn: ao, description: d });
        }
        return items;
    }
    ActionMenu.createItems = createItems;
    var _selectOptions = { value: function (o) { return o[0]; }, label: function (o) { return o[1]; }, category: function (o) { return o[2]; } };
    function createItemsFromSelectOptions(options, params) {
        return createItems(options, params ? Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, _selectOptions), params) : _selectOptions);
    }
    ActionMenu.createItemsFromSelectOptions = createItemsFromSelectOptions;
    function hasSelectedItem(items) {
        if (isHeader(items))
            return false;
        if (isItem(items))
            return !!items.selected;
        for (var _i = 0, items_1 = items; _i < items_1.length; _i++) {
            var s = items_1[_i];
            var found = hasSelectedItem(s);
            if (found)
                return true;
        }
        return false;
    }
    ActionMenu.hasSelectedItem = hasSelectedItem;
    function findItem(items, value) {
        if (isHeader(items))
            return;
        if (isItem(items))
            return items.value === value ? items : void 0;
        for (var _i = 0, items_2 = items; _i < items_2.length; _i++) {
            var s = items_2[_i];
            var found = findItem(s, value);
            if (found)
                return found;
        }
    }
    ActionMenu.findItem = findItem;
    function getFirstItem(items) {
        if (isHeader(items))
            return;
        if (isItem(items))
            return items;
        for (var _i = 0, items_3 = items; _i < items_3.length; _i++) {
            var s = items_3[_i];
            var found = getFirstItem(s);
            if (found)
                return found;
        }
    }
    ActionMenu.getFirstItem = getFirstItem;
    // export type SelectProps<T> = {
    //     items: Items,
    //     onSelect: (item: Item) => void,
    //     disabled?: boolean,
    //     label?: string,
    //     current?: Item,
    //     style?: React.CSSProperties
    // }
    // export class Select<T> extends React.PureComponent<SelectProps<T>, { isExpanded: boolean }> {
    //     state = { isExpanded: false };
    //     toggleExpanded = () => this.setState({ isExpanded: !this.state.isExpanded })
    //     onSelect: OnSelect = (item) => {
    //         this.setState({ isExpanded: false });
    //         if (!item) return;
    //         this.onSelect(item);
    //     }
    //     render() {
    //         const current = this.props.current;
    //         const label = this.props.label || current?.label || '';
    //         return <div className='msp-action-menu-select' style={this.props.style}>
    //             <ToggleButton disabled={this.props.disabled} style={{ textAlign: 'left' }} className='msp-no-overflow'
    //                 label={label} title={label as string} toggle={this.toggleExpanded} isSelected={this.state.isExpanded} />
    //             {this.state.isExpanded && <ActionMenu items={this.props.items} current={this.props.current} onSelect={this.onSelect} />}
    //         </div>
    //     }
    // }
})(ActionMenu || (ActionMenu = {}));
var Section = /** @class */ (function (_super) {
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__extends"])(Section, _super);
    function Section() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = Section.createState(_this.props);
        _this.toggleExpanded = function (e) {
            _this.setState({ isExpanded: !_this.state.isExpanded });
            e.currentTarget.blur();
        };
        _this.selectAll = function () {
            var items = collectItems(_this.props.items, []).filter(function (i) { return !i.selected; });
            _this.props.onSelect(items);
        };
        _this.selectNone = function () {
            var items = collectItems(_this.props.items, []).filter(function (i) { return !!i.selected; });
            _this.props.onSelect(items);
        };
        return _this;
    }
    Section.createState = function (props, isExpanded) {
        var header = isItems(props.items) && isHeader(props.items[0]) ? props.items[0] : void 0;
        var hasCurrent = (header === null || header === void 0 ? void 0 : header.isIndependent) ? false
            : props.multiselect
                ? ActionMenu.hasSelectedItem(props.items)
                : (!!props.current && !!ActionMenu.findItem(props.items, props.current.value)) || ActionMenu.hasSelectedItem(props.items);
        return {
            header: header,
            hasCurrent: hasCurrent,
            isExpanded: hasCurrent || (isExpanded !== null && isExpanded !== void 0 ? isExpanded : !!(header === null || header === void 0 ? void 0 : header.initiallyExpanded))
        };
    };
    Section.prototype.componentDidUpdate = function (prevProps) {
        if (this.props.items !== prevProps.items || this.props.current !== prevProps.current) {
            // keep previously expanded section if the header label is the same
            var isExpanded = (isItems(this.props.items) && isItems(prevProps.items) &&
                isHeader(this.props.items[0]) && isHeader(prevProps.items[0]) &&
                this.props.items[0].label === prevProps.items[0].label) ? this.state.isExpanded : undefined;
            this.setState(Section.createState(this.props, isExpanded));
        }
    };
    Object.defineProperty(Section.prototype, "multiselectHeader", {
        get: function () {
            var _a = this.state, header = _a.header, hasCurrent = _a.hasCurrent;
            return react__WEBPACK_IMPORTED_MODULE_1__["createElement"]("div", { className: 'msp-flex-row msp-control-group-header' },
                react__WEBPACK_IMPORTED_MODULE_1__["createElement"](_common__WEBPACK_IMPORTED_MODULE_2__["Button"], { icon: this.state.isExpanded ? _icons__WEBPACK_IMPORTED_MODULE_3__["ArrowDropDownSvg"] : _icons__WEBPACK_IMPORTED_MODULE_3__["ArrowRightSvg"], flex: true, noOverflow: true, onClick: this.toggleExpanded, title: "Click to " + (this.state.isExpanded ? 'collapse' : 'expand') + "." + ((header === null || header === void 0 ? void 0 : header.description) ? " " + (header === null || header === void 0 ? void 0 : header.description) : '') }, hasCurrent ? react__WEBPACK_IMPORTED_MODULE_1__["createElement"]("b", null, header === null || header === void 0 ? void 0 : header.label) : header === null || header === void 0 ? void 0 : header.label),
                react__WEBPACK_IMPORTED_MODULE_1__["createElement"](_common__WEBPACK_IMPORTED_MODULE_2__["Button"], { icon: _icons__WEBPACK_IMPORTED_MODULE_3__["CheckSvg"], flex: true, onClick: this.selectAll, style: { flex: '0 0 50px', textAlign: 'right' } }, "All"),
                react__WEBPACK_IMPORTED_MODULE_1__["createElement"](_common__WEBPACK_IMPORTED_MODULE_2__["Button"], { icon: _icons__WEBPACK_IMPORTED_MODULE_3__["CloseSvg"], flex: true, onClick: this.selectNone, style: { flex: '0 0 50px', textAlign: 'right' } }, "None"));
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Section.prototype, "basicHeader", {
        get: function () {
            var _a = this.state, header = _a.header, hasCurrent = _a.hasCurrent;
            return react__WEBPACK_IMPORTED_MODULE_1__["createElement"]("div", { className: 'msp-control-group-header', style: { marginTop: '1px' } },
                react__WEBPACK_IMPORTED_MODULE_1__["createElement"](_common__WEBPACK_IMPORTED_MODULE_2__["Button"], { noOverflow: true, icon: this.state.isExpanded ? _icons__WEBPACK_IMPORTED_MODULE_3__["ArrowDropDownSvg"] : _icons__WEBPACK_IMPORTED_MODULE_3__["ArrowRightSvg"], onClick: this.toggleExpanded, title: "Click to " + (this.state.isExpanded ? 'collapse' : 'expand') + ". " + ((header === null || header === void 0 ? void 0 : header.description) ? header === null || header === void 0 ? void 0 : header.description : '') }, hasCurrent ? react__WEBPACK_IMPORTED_MODULE_1__["createElement"]("b", null, header === null || header === void 0 ? void 0 : header.label) : header === null || header === void 0 ? void 0 : header.label));
        },
        enumerable: false,
        configurable: true
    });
    Section.prototype.render = function () {
        var _this = this;
        var _a = this.props, items = _a.items, onSelect = _a.onSelect, current = _a.current;
        if (isHeader(items))
            return null;
        if (isItem(items))
            return react__WEBPACK_IMPORTED_MODULE_1__["createElement"](Action, { item: items, onSelect: onSelect, current: current, multiselect: this.props.multiselect });
        var header = this.state.header;
        return react__WEBPACK_IMPORTED_MODULE_1__["createElement"](react__WEBPACK_IMPORTED_MODULE_1__["Fragment"], null,
            header && (this.props.multiselect && this.state.isExpanded ? this.multiselectHeader : this.basicHeader),
            react__WEBPACK_IMPORTED_MODULE_1__["createElement"]("div", { className: this.props.noOffset ? void 0 : this.props.noAccent ? 'msp-control-offset' : 'msp-accent-offset' }, (!header || this.state.isExpanded) && items.map(function (x, i) {
                if (isHeader(x))
                    return null;
                if (isItem(x))
                    return react__WEBPACK_IMPORTED_MODULE_1__["createElement"](Action, { key: i, item: x, onSelect: onSelect, current: current, multiselect: _this.props.multiselect });
                return react__WEBPACK_IMPORTED_MODULE_1__["createElement"](Section, { key: i, items: x, onSelect: onSelect, current: current, multiselect: _this.props.multiselect, noAccent: true });
            })));
    };
    return Section;
}(react__WEBPACK_IMPORTED_MODULE_1__["PureComponent"]));
var Action = function (_a) {
    var item = _a.item, onSelect = _a.onSelect, current = _a.current, multiselect = _a.multiselect;
    var isCurrent = current === item;
    var style = item.addOn ? { position: 'relative' } : void 0;
    return react__WEBPACK_IMPORTED_MODULE_1__["createElement"](_common__WEBPACK_IMPORTED_MODULE_2__["Button"], { icon: item.icon, noOverflow: true, className: 'msp-action-menu-button', onClick: function (e) { return onSelect(multiselect ? [item] : item, e); }, disabled: item.disabled, style: style, title: item.description },
        isCurrent || item.selected ? react__WEBPACK_IMPORTED_MODULE_1__["createElement"]("b", null, item.label) : item.label,
        item.addOn);
};
function isItems(x) {
    return !!x && Array.isArray(x);
}
function isItem(x) {
    var v = x;
    return v && v.kind === 'item';
}
function isHeader(x) {
    var v = x;
    return v && v.kind === 'header';
}
function collectItems(items, target) {
    if (isHeader(items))
        return target;
    if (isItem(items)) {
        target.push(items);
        return target;
    }
    for (var _i = 0, items_4 = items; _i < items_4.length; _i++) {
        var i = items_4[_i];
        collectItems(i, target);
    }
    return target;
}
//# sourceMappingURL=action-menu.js.map

/***/ }),

/***/ "./lib/mol-plugin-ui/controls/color.js":
/*!*********************************************!*\
  !*** ./lib/mol-plugin-ui/controls/color.js ***!
  \*********************************************/
/*! exports provided: CombinedColorControl, ColorOptions, ColorValueOption */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CombinedColorControl", function() { return CombinedColorControl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ColorOptions", function() { return ColorOptions; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ColorValueOption", function() { return ColorValueOption; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _mol_util_color__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../mol-util/color */ "./lib/mol-util/color/index.js");
/* harmony import */ var _mol_util_string__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../mol-util/string */ "./lib/mol-util/string.js");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! react */ "./node_modules/react/index.js");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _common__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./common */ "./lib/mol-plugin-ui/controls/common.js");
/* harmony import */ var _mol_util_color_swatches__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../mol-util/color/swatches */ "./lib/mol-util/color/swatches.js");
/**
 * Copyright (c) 2019 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author David Sehnal <david.sehnal@gmail.com>
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */






var CombinedColorControl = /** @class */ (function (_super) {
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__extends"])(CombinedColorControl, _super);
    function CombinedColorControl() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            isExpanded: !!_this.props.param.isExpanded,
            lightness: 0
        };
        _this.toggleExpanded = function (e) {
            _this.setState({ isExpanded: !_this.state.isExpanded });
            e.currentTarget.blur();
        };
        _this.onClickSwatch = function (e) {
            var value = Object(_mol_util_color__WEBPACK_IMPORTED_MODULE_1__["Color"])(+(e.currentTarget.getAttribute('data-color') || '0'));
            if (value !== _this.props.value) {
                if (!_this.props.param.isExpanded)
                    _this.setState({ isExpanded: false });
                _this.update(value);
            }
        };
        _this.onR = function (v) {
            var _a = _mol_util_color__WEBPACK_IMPORTED_MODULE_1__["Color"].toRgb(_this.props.value), g = _a[1], b = _a[2];
            var value = _mol_util_color__WEBPACK_IMPORTED_MODULE_1__["Color"].fromRgb(v, g, b);
            if (value !== _this.props.value)
                _this.update(value);
        };
        _this.onG = function (v) {
            var _a = _mol_util_color__WEBPACK_IMPORTED_MODULE_1__["Color"].toRgb(_this.props.value), r = _a[0], b = _a[2];
            var value = _mol_util_color__WEBPACK_IMPORTED_MODULE_1__["Color"].fromRgb(r, v, b);
            if (value !== _this.props.value)
                _this.update(value);
        };
        _this.onB = function (v) {
            var _a = _mol_util_color__WEBPACK_IMPORTED_MODULE_1__["Color"].toRgb(_this.props.value), r = _a[0], g = _a[1];
            var value = _mol_util_color__WEBPACK_IMPORTED_MODULE_1__["Color"].fromRgb(r, g, v);
            if (value !== _this.props.value)
                _this.update(value);
        };
        _this.onLighten = function () {
            _this.update(_mol_util_color__WEBPACK_IMPORTED_MODULE_1__["Color"].lighten(_this.props.value, 0.1));
        };
        _this.onDarken = function () {
            _this.update(_mol_util_color__WEBPACK_IMPORTED_MODULE_1__["Color"].darken(_this.props.value, 0.1));
        };
        return _this;
    }
    CombinedColorControl.prototype.update = function (value) {
        this.props.onChange({ param: this.props.param, name: this.props.name, value: value });
    };
    CombinedColorControl.prototype.swatch = function () {
        var _this = this;
        return react__WEBPACK_IMPORTED_MODULE_3__["createElement"]("div", { className: 'msp-combined-color-swatch' }, _mol_util_color_swatches__WEBPACK_IMPORTED_MODULE_5__["DefaultColorSwatch"].map(function (c) { return react__WEBPACK_IMPORTED_MODULE_3__["createElement"](_common__WEBPACK_IMPORTED_MODULE_4__["Button"], { key: c[1], inline: true, "data-color": c[1], onClick: _this.onClickSwatch, style: { background: _mol_util_color__WEBPACK_IMPORTED_MODULE_1__["Color"].toStyle(c[1]) } }); }));
    };
    CombinedColorControl.prototype.render = function () {
        var label = this.props.param.label || Object(_mol_util_string__WEBPACK_IMPORTED_MODULE_2__["camelCaseToWords"])(this.props.name);
        var _a = _mol_util_color__WEBPACK_IMPORTED_MODULE_1__["Color"].toRgb(this.props.value), r = _a[0], g = _a[1], b = _a[2];
        return react__WEBPACK_IMPORTED_MODULE_3__["createElement"](react__WEBPACK_IMPORTED_MODULE_3__["Fragment"], null,
            react__WEBPACK_IMPORTED_MODULE_3__["createElement"](_common__WEBPACK_IMPORTED_MODULE_4__["ControlRow"], { title: this.props.param.description, label: label, control: react__WEBPACK_IMPORTED_MODULE_3__["createElement"](_common__WEBPACK_IMPORTED_MODULE_4__["Button"], { onClick: this.toggleExpanded, inline: true, className: 'msp-combined-color-button', style: { background: _mol_util_color__WEBPACK_IMPORTED_MODULE_1__["Color"].toStyle(this.props.value) } }) }),
            this.state.isExpanded && react__WEBPACK_IMPORTED_MODULE_3__["createElement"]("div", { className: 'msp-control-offset' },
                this.swatch(),
                react__WEBPACK_IMPORTED_MODULE_3__["createElement"](_common__WEBPACK_IMPORTED_MODULE_4__["ControlRow"], { label: 'RGB', className: 'msp-control-label-short', control: react__WEBPACK_IMPORTED_MODULE_3__["createElement"]("div", { style: { display: 'flex', textAlignLast: 'center', left: '80px' } },
                        react__WEBPACK_IMPORTED_MODULE_3__["createElement"](_common__WEBPACK_IMPORTED_MODULE_4__["TextInput"], { onChange: this.onR, numeric: true, value: r, delayMs: 250, style: { order: 1, flex: '1 1 auto', minWidth: 0 }, className: 'msp-form-control', onEnter: this.props.onEnter, blurOnEnter: true, blurOnEscape: true }),
                        react__WEBPACK_IMPORTED_MODULE_3__["createElement"](_common__WEBPACK_IMPORTED_MODULE_4__["TextInput"], { onChange: this.onG, numeric: true, value: g, delayMs: 250, style: { order: 2, flex: '1 1 auto', minWidth: 0 }, className: 'msp-form-control', onEnter: this.props.onEnter, blurOnEnter: true, blurOnEscape: true }),
                        react__WEBPACK_IMPORTED_MODULE_3__["createElement"](_common__WEBPACK_IMPORTED_MODULE_4__["TextInput"], { onChange: this.onB, numeric: true, value: b, delayMs: 250, style: { order: 3, flex: '1 1 auto', minWidth: 0 }, className: 'msp-form-control', onEnter: this.props.onEnter, blurOnEnter: true, blurOnEscape: true })) }),
                react__WEBPACK_IMPORTED_MODULE_3__["createElement"]("div", { style: { display: 'flex', textAlignLast: 'center' } },
                    react__WEBPACK_IMPORTED_MODULE_3__["createElement"](_common__WEBPACK_IMPORTED_MODULE_4__["Button"], { onClick: this.onLighten, style: { order: 1, flex: '1 1 auto', minWidth: 0 }, className: 'msp-form-control' }, "Lighten"),
                    react__WEBPACK_IMPORTED_MODULE_3__["createElement"](_common__WEBPACK_IMPORTED_MODULE_4__["Button"], { onClick: this.onDarken, style: { order: 1, flex: '1 1 auto', minWidth: 0 }, className: 'msp-form-control' }, "Darken"))));
    };
    return CombinedColorControl;
}(react__WEBPACK_IMPORTED_MODULE_3__["PureComponent"]));

var _colors = void 0;
function ColorOptions() {
    if (_colors)
        return _colors;
    _colors = react__WEBPACK_IMPORTED_MODULE_3__["createElement"](react__WEBPACK_IMPORTED_MODULE_3__["Fragment"], null, _mol_util_color_swatches__WEBPACK_IMPORTED_MODULE_5__["DefaultColorSwatch"].map(function (v) {
        return react__WEBPACK_IMPORTED_MODULE_3__["createElement"]("option", { key: v[1], value: v[1], style: { background: "" + _mol_util_color__WEBPACK_IMPORTED_MODULE_1__["Color"].toStyle(v[1]) } }, Object(_mol_util_string__WEBPACK_IMPORTED_MODULE_2__["stringToWords"])(v[0]));
    }));
    return _colors;
}
var DefaultColorSwatchMap = (function () {
    var map = new Map();
    for (var _i = 0, DefaultColorSwatch_1 = _mol_util_color_swatches__WEBPACK_IMPORTED_MODULE_5__["DefaultColorSwatch"]; _i < DefaultColorSwatch_1.length; _i++) {
        var v = DefaultColorSwatch_1[_i];
        map.set(v[1], v[0]);
    }
    return map;
})();
function ColorValueOption(color) {
    return !DefaultColorSwatchMap.has(color) ? react__WEBPACK_IMPORTED_MODULE_3__["createElement"]("option", { key: _mol_util_color__WEBPACK_IMPORTED_MODULE_1__["Color"].toHexString(color), value: color, style: { background: "" + _mol_util_color__WEBPACK_IMPORTED_MODULE_1__["Color"].toStyle(color) } }, _mol_util_color__WEBPACK_IMPORTED_MODULE_1__["Color"].toRgbString(color)) : null;
}
//# sourceMappingURL=color.js.map

/***/ }),

/***/ "./lib/mol-plugin-ui/controls/common.js":
/*!**********************************************!*\
  !*** ./lib/mol-plugin-ui/controls/common.js ***!
  \**********************************************/
/*! exports provided: ControlGroup, TextInput, ExpandableControlRow, SectionHeader, Button, IconButton, ToggleButton, ExpandGroup, ControlRow */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ControlGroup", function() { return ControlGroup; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "TextInput", function() { return TextInput; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ExpandableControlRow", function() { return ExpandableControlRow; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SectionHeader", function() { return SectionHeader; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Button", function() { return Button; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "IconButton", function() { return IconButton; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ToggleButton", function() { return ToggleButton; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ExpandGroup", function() { return ExpandGroup; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ControlRow", function() { return ControlRow; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! react */ "./node_modules/react/index.js");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _mol_util_color__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../mol-util/color */ "./lib/mol-util/color/index.js");
/* harmony import */ var _icons__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./icons */ "./lib/mol-plugin-ui/controls/icons.js");
/**
 * Copyright (c) 2018-2020 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author David Sehnal <david.sehnal@gmail.com>
 */




var ControlGroup = /** @class */ (function (_super) {
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__extends"])(ControlGroup, _super);
    function ControlGroup() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = { isExpanded: !!_this.props.initialExpanded };
        _this.headerClicked = function () {
            if (_this.props.onHeaderClick) {
                _this.props.onHeaderClick();
            }
            else {
                _this.setState({ isExpanded: !_this.state.isExpanded });
            }
        };
        return _this;
    }
    ControlGroup.prototype.render = function () {
        var groupClassName = this.props.hideOffset ? 'msp-control-group-children' : 'msp-control-group-children msp-control-offset';
        if (this.props.childrenClassName)
            groupClassName += ' ' + this.props.childrenClassName;
        // TODO: customize header style (bg color, togle button etc)
        return react__WEBPACK_IMPORTED_MODULE_1__["createElement"]("div", { className: 'msp-control-group-wrapper', style: { position: 'relative', marginTop: this.props.noTopMargin ? 0 : void 0 } },
            react__WEBPACK_IMPORTED_MODULE_1__["createElement"]("div", { className: 'msp-control-group-header', style: { marginLeft: this.props.headerLeftMargin }, title: this.props.title },
                react__WEBPACK_IMPORTED_MODULE_1__["createElement"](Button, { onClick: this.headerClicked },
                    !this.props.hideExpander && react__WEBPACK_IMPORTED_MODULE_1__["createElement"](_icons__WEBPACK_IMPORTED_MODULE_3__["Icon"], { svg: this.state.isExpanded ? _icons__WEBPACK_IMPORTED_MODULE_3__["ArrowRightSvg"] : _icons__WEBPACK_IMPORTED_MODULE_3__["ArrowDropDownSvg"] }),
                    this.props.topRightIcon && react__WEBPACK_IMPORTED_MODULE_1__["createElement"](_icons__WEBPACK_IMPORTED_MODULE_3__["Icon"], { svg: this.props.topRightIcon, style: { position: 'absolute', right: '2px', top: 0 } }),
                    react__WEBPACK_IMPORTED_MODULE_1__["createElement"]("b", null, this.props.header))),
            this.state.isExpanded && react__WEBPACK_IMPORTED_MODULE_1__["createElement"]("div", { className: groupClassName, style: { display: this.state.isExpanded ? 'block' : 'none', maxHeight: this.props.maxHeight, overflow: 'hidden', overflowY: 'auto' } }, this.props.children));
    };
    return ControlGroup;
}(react__WEBPACK_IMPORTED_MODULE_1__["Component"]));

function _id(x) { return x; }
var TextInput = /** @class */ (function (_super) {
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__extends"])(TextInput, _super);
    function TextInput() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.input = react__WEBPACK_IMPORTED_MODULE_1__["createRef"]();
        _this.delayHandle = void 0;
        _this.pendingValue = void 0;
        _this.state = { originalValue: '', value: '' };
        _this.onBlur = function () {
            _this.setState({ value: '' + _this.state.originalValue });
            if (_this.props.onBlur)
                _this.props.onBlur();
        };
        _this.raiseOnChange = function () {
            if (_this.pendingValue === void 0)
                return;
            _this.props.onChange(_this.pendingValue);
            _this.pendingValue = void 0;
        };
        _this.onChange = function (e) {
            var value = e.target.value;
            var isInvalid = (_this.props.isValid && !_this.props.isValid(value)) || (_this.props.numeric && Number.isNaN(+value));
            if (isInvalid) {
                _this.clearTimeout();
                _this.setState({ value: value });
                return;
            }
            if (_this.props.numeric) {
                _this.setState({ value: value }, function () { return _this.triggerChanged(value, +value); });
            }
            else {
                var converted_1 = (_this.props.toValue || _id)(value);
                var formatted_1 = (_this.props.fromValue || _id)(converted_1);
                _this.setState({ value: formatted_1 }, function () { return _this.triggerChanged(formatted_1, converted_1); });
            }
        };
        _this.onKeyUp = function (e) {
            if (e.charCode === 27 || e.keyCode === 27 || e.key === 'Escape') {
                if (_this.props.blurOnEscape && _this.input.current) {
                    _this.input.current.blur();
                }
            }
        };
        _this.onKeyPress = function (e) {
            if (e.keyCode === 13 || e.charCode === 13 || e.key === 'Enter') {
                if (_this.isPending) {
                    _this.clearTimeout();
                    _this.raiseOnChange();
                }
                if (_this.props.blurOnEnter && _this.input.current) {
                    _this.input.current.blur();
                }
                if (_this.props.onEnter)
                    _this.props.onEnter();
            }
            e.stopPropagation();
        };
        return _this;
    }
    Object.defineProperty(TextInput.prototype, "isPending", {
        get: function () { return typeof this.delayHandle !== 'undefined'; },
        enumerable: false,
        configurable: true
    });
    TextInput.prototype.clearTimeout = function () {
        if (this.isPending) {
            clearTimeout(this.delayHandle);
            this.delayHandle = void 0;
        }
    };
    TextInput.prototype.triggerChanged = function (formatted, converted) {
        this.clearTimeout();
        if (formatted === this.state.originalValue)
            return;
        if (this.props.delayMs) {
            this.pendingValue = converted;
            this.delayHandle = setTimeout(this.raiseOnChange, this.props.delayMs);
        }
        else {
            this.props.onChange(converted);
        }
    };
    TextInput.getDerivedStateFromProps = function (props, state) {
        var value = props.fromValue ? props.fromValue(props.value) : props.value;
        if (value === state.originalValue)
            return null;
        return { originalValue: value, value: value };
    };
    TextInput.prototype.render = function () {
        return react__WEBPACK_IMPORTED_MODULE_1__["createElement"]("input", { type: 'text', className: this.props.className, style: this.props.style, ref: this.input, onBlur: this.onBlur, value: this.state.value, placeholder: this.props.placeholder, onChange: this.onChange, onKeyPress: this.props.onEnter || this.props.blurOnEnter || this.props.blurOnEscape ? this.onKeyPress : void 0, onKeyDown: this.props.blurOnEscape ? this.onKeyUp : void 0, disabled: !!this.props.isDisabled });
    };
    return TextInput;
}(react__WEBPACK_IMPORTED_MODULE_1__["PureComponent"]));

var ExpandableControlRow = /** @class */ (function (_super) {
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__extends"])(ExpandableControlRow, _super);
    function ExpandableControlRow() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = { isExpanded: false };
        _this.toggleExpanded = function () { return _this.setState({ isExpanded: !_this.state.isExpanded }); };
        return _this;
    }
    ExpandableControlRow.prototype.render = function () {
        var _a = this.props, label = _a.label, pivot = _a.pivot, controls = _a.controls;
        // TODO: fix the inline CSS
        return react__WEBPACK_IMPORTED_MODULE_1__["createElement"](react__WEBPACK_IMPORTED_MODULE_1__["Fragment"], null,
            react__WEBPACK_IMPORTED_MODULE_1__["createElement"](ControlRow, { label: react__WEBPACK_IMPORTED_MODULE_1__["createElement"](react__WEBPACK_IMPORTED_MODULE_1__["Fragment"], null,
                    label,
                    react__WEBPACK_IMPORTED_MODULE_1__["createElement"]("button", { className: 'msp-btn-link msp-btn-icon msp-control-group-expander', onClick: this.toggleExpanded, title: (this.state.isExpanded ? 'Less' : 'More') + " options", style: { background: 'transparent', textAlign: 'left', padding: '0' } },
                        react__WEBPACK_IMPORTED_MODULE_1__["createElement"](_icons__WEBPACK_IMPORTED_MODULE_3__["Icon"], { svg: this.state.isExpanded ? _icons__WEBPACK_IMPORTED_MODULE_3__["RemoveSvg"] : _icons__WEBPACK_IMPORTED_MODULE_3__["AddSvg"], style: { display: 'inline-block' } }))), control: pivot }, this.props.colorStripe && react__WEBPACK_IMPORTED_MODULE_1__["createElement"]("div", { className: 'msp-expandable-group-color-stripe', style: { backgroundColor: _mol_util_color__WEBPACK_IMPORTED_MODULE_2__["Color"].toStyle(this.props.colorStripe) } })),
            this.state.isExpanded && react__WEBPACK_IMPORTED_MODULE_1__["createElement"]("div", { className: 'msp-control-offset' }, controls));
    };
    return ExpandableControlRow;
}(react__WEBPACK_IMPORTED_MODULE_1__["Component"]));

function SectionHeader(props) {
    return react__WEBPACK_IMPORTED_MODULE_1__["createElement"]("div", { className: "msp-section-header" + (props.accent ? ' msp-transform-header-brand-' + props.accent : '') },
        props.icon && react__WEBPACK_IMPORTED_MODULE_1__["createElement"](_icons__WEBPACK_IMPORTED_MODULE_3__["Icon"], { svg: props.icon }),
        props.title,
        " ",
        react__WEBPACK_IMPORTED_MODULE_1__["createElement"]("small", null, props.desc));
}
function Button(props) {
    var className = 'msp-btn';
    if (!props.inline)
        className += ' msp-btn-block';
    if (props.noOverflow)
        className += ' msp-no-overflow';
    if (props.flex)
        className += ' msp-flex-item';
    if (props.commit === 'on' || props.commit)
        className += ' msp-btn-commit msp-btn-commit-on';
    if (props.commit === 'off')
        className += ' msp-btn-commit msp-btn-commit-off';
    if (!props.children)
        className += ' msp-btn-childless';
    if (props.className)
        className += ' ' + props.className;
    var style = void 0;
    if (props.flex) {
        if (typeof props.flex === 'number')
            style = { flex: "0 0 " + props.flex + "px", padding: 0, maxWidth: props.flex + "px" };
        else if (typeof props.flex === 'string')
            style = { flex: "0 0 " + props.flex, padding: 0, maxWidth: props.flex };
    }
    if (props.style) {
        if (style)
            Object.assign(style, props.style);
        else
            style = props.style;
    }
    return react__WEBPACK_IMPORTED_MODULE_1__["createElement"]("button", { onClick: props.onClick, title: props.title, disabled: props.disabled, style: style, className: className, "data-id": props['data-id'], "data-color": props['data-color'], onContextMenu: props.onContextMenu, onMouseEnter: props.onMouseEnter, onMouseLeave: props.onMouseLeave },
        props.icon && react__WEBPACK_IMPORTED_MODULE_1__["createElement"](_icons__WEBPACK_IMPORTED_MODULE_3__["Icon"], { svg: props.icon }),
        props.children);
}
function IconButton(props) {
    var className = "msp-btn msp-btn-icon" + (props.small ? '-small' : '') + (props.className ? ' ' + props.className : '');
    if (typeof props.toggleState !== 'undefined') {
        className += " msp-btn-link-toggle-" + (props.toggleState ? 'on' : 'off');
    }
    if (props.transparent) {
        className += ' msp-transparent-bg';
    }
    var style = void 0;
    if (props.flex) {
        if (typeof props.flex === 'boolean')
            style = { flex: '0 0 32px', padding: 0 };
        else if (typeof props.flex === 'number')
            style = { flex: "0 0 " + props.flex + "px", padding: 0, maxWidth: props.flex + "px" };
        else
            style = { flex: "0 0 " + props.flex, padding: 0, maxWidth: props.flex };
    }
    if (props.style) {
        if (style)
            Object.assign(style, props.style);
        else
            style = props.style;
    }
    return react__WEBPACK_IMPORTED_MODULE_1__["createElement"]("button", { className: className, onClick: props.onClick, title: props.title, disabled: props.disabled, "data-id": props['data-id'], style: style },
        props.svg && react__WEBPACK_IMPORTED_MODULE_1__["createElement"](_icons__WEBPACK_IMPORTED_MODULE_3__["Icon"], { svg: props.svg }),
        props.extraContent);
}
var ToggleButton = /** @class */ (function (_super) {
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__extends"])(ToggleButton, _super);
    function ToggleButton() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.onClick = function (e) {
            e.currentTarget.blur();
            _this.props.toggle();
        };
        return _this;
    }
    ToggleButton.prototype.render = function () {
        var props = this.props;
        var label = props.label;
        var className = props.isSelected ? (props.className || '') + " msp-control-current" : props.className;
        return react__WEBPACK_IMPORTED_MODULE_1__["createElement"](Button, { icon: this.props.icon, onClick: this.onClick, title: this.props.title, inline: this.props.inline, disabled: props.disabled, style: props.style, className: className }, label && this.props.isSelected ? react__WEBPACK_IMPORTED_MODULE_1__["createElement"]("b", null, label) : label);
    };
    return ToggleButton;
}(react__WEBPACK_IMPORTED_MODULE_1__["PureComponent"]));

var ExpandGroup = /** @class */ (function (_super) {
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__extends"])(ExpandGroup, _super);
    function ExpandGroup() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = { isExpanded: !!_this.props.initiallyExpanded };
        _this.toggleExpanded = function () { return _this.setState({ isExpanded: !_this.state.isExpanded }); };
        return _this;
    }
    ExpandGroup.prototype.render = function () {
        return react__WEBPACK_IMPORTED_MODULE_1__["createElement"](react__WEBPACK_IMPORTED_MODULE_1__["Fragment"], null,
            react__WEBPACK_IMPORTED_MODULE_1__["createElement"]("div", { className: 'msp-control-group-header', style: { marginTop: this.props.marginTop !== void 0 ? this.props.marginTop : '1px', marginLeft: this.props.headerLeftMargin } },
                react__WEBPACK_IMPORTED_MODULE_1__["createElement"]("button", { className: 'msp-btn msp-form-control msp-btn-block', onClick: this.toggleExpanded, style: this.props.headerStyle },
                    react__WEBPACK_IMPORTED_MODULE_1__["createElement"](_icons__WEBPACK_IMPORTED_MODULE_3__["Icon"], { svg: this.state.isExpanded ? _icons__WEBPACK_IMPORTED_MODULE_3__["ArrowDropDownSvg"] : _icons__WEBPACK_IMPORTED_MODULE_3__["ArrowRightSvg"] }),
                    this.props.header)),
            this.state.isExpanded &&
                (this.props.noOffset
                    ? this.props.children
                    : react__WEBPACK_IMPORTED_MODULE_1__["createElement"]("div", { className: this.props.accent ? 'msp-accent-offset' : 'msp-control-offset' }, this.props.children)));
    };
    return ExpandGroup;
}(react__WEBPACK_IMPORTED_MODULE_1__["PureComponent"]));

function ControlRow(props) {
    var className = 'msp-control-row';
    if (props.className)
        className += ' ' + props.className;
    return react__WEBPACK_IMPORTED_MODULE_1__["createElement"]("div", { className: className },
        react__WEBPACK_IMPORTED_MODULE_1__["createElement"]("span", { className: 'msp-control-row-label', title: props.title }, props.label),
        react__WEBPACK_IMPORTED_MODULE_1__["createElement"]("div", { className: 'msp-control-row-ctrl' }, props.control),
        props.children);
}
//# sourceMappingURL=common.js.map

/***/ }),

/***/ "./lib/mol-plugin-ui/controls/icons.js":
/*!*********************************************!*\
  !*** ./lib/mol-plugin-ui/controls/icons.js ***!
  \*********************************************/
/*! exports provided: Icon, UnionSvg, SubtractSvg, IntersectSvg, SetSvg, MoleculeSvg, CubeOutlineSvg, CursorDefaultOutlineSvg, FileOutlineSvg, PencilRulerSvg, AccountTreeOutlinedSvg, AddSvg, ArrowDownwardSvg, ArrowDropDownSvg, ArrowRightSvg, ArrowUpwardSvg, AutorenewSvg, BlurOnSvg, BookmarksOutlinedSvg, BrushSvg, BuildOutlinedSvg, BuildSvg, CameraOutlinedSvg, CameraSvg, CancelOutlinedSvg, CancelSvg, CenterFocusStrongSvg, CheckSvg, ClearSvg, CloseSvg, CloudUploadSvg, CodeSvg, CopySvg, CropSvg, CropFreeSvg, CropOrginalSvg, DeleteOutlinedSvg, DeleteSvg, ErrorSvg, ExtensionSvg, FlipToFrontSvg, FullscreenSvg, GetAppSvg, HelpOutlineSvg, HomeOutlinedSvg, LaunchSvg, LinearScaleSvg, MoreHorizSvg, NavigateBeforeSvg, NavigateNextSvg, OpenInBrowserSvg, PlayArrowSvg, RefreshSvg, RemoveSvg, RestoreSvg, SaveOutlinedSvg, ScatterPlotSvg, SkipPreviousSvg, StopSvg, SubscriptionsOutlinedSvg, SwapHorizSvg, TuneSvg, VisibilityOffOutlinedSvg, VisibilityOutlinedSvg, WarningSvg, SelectionModeSvg, SuperposeAtomsSvg, SuperposeChainsSvg, SuperpositionSvg */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Icon", function() { return Icon; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "UnionSvg", function() { return UnionSvg; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SubtractSvg", function() { return SubtractSvg; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "IntersectSvg", function() { return IntersectSvg; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SetSvg", function() { return SetSvg; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MoleculeSvg", function() { return MoleculeSvg; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CubeOutlineSvg", function() { return CubeOutlineSvg; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CursorDefaultOutlineSvg", function() { return CursorDefaultOutlineSvg; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FileOutlineSvg", function() { return FileOutlineSvg; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "PencilRulerSvg", function() { return PencilRulerSvg; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "AccountTreeOutlinedSvg", function() { return AccountTreeOutlinedSvg; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "AddSvg", function() { return AddSvg; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ArrowDownwardSvg", function() { return ArrowDownwardSvg; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ArrowDropDownSvg", function() { return ArrowDropDownSvg; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ArrowRightSvg", function() { return ArrowRightSvg; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ArrowUpwardSvg", function() { return ArrowUpwardSvg; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "AutorenewSvg", function() { return AutorenewSvg; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "BlurOnSvg", function() { return BlurOnSvg; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "BookmarksOutlinedSvg", function() { return BookmarksOutlinedSvg; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "BrushSvg", function() { return BrushSvg; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "BuildOutlinedSvg", function() { return BuildOutlinedSvg; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "BuildSvg", function() { return BuildSvg; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CameraOutlinedSvg", function() { return CameraOutlinedSvg; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CameraSvg", function() { return CameraSvg; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CancelOutlinedSvg", function() { return CancelOutlinedSvg; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CancelSvg", function() { return CancelSvg; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CenterFocusStrongSvg", function() { return CenterFocusStrongSvg; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CheckSvg", function() { return CheckSvg; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ClearSvg", function() { return ClearSvg; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CloseSvg", function() { return CloseSvg; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CloudUploadSvg", function() { return CloudUploadSvg; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CodeSvg", function() { return CodeSvg; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CopySvg", function() { return CopySvg; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CropSvg", function() { return CropSvg; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CropFreeSvg", function() { return CropFreeSvg; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CropOrginalSvg", function() { return CropOrginalSvg; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DeleteOutlinedSvg", function() { return DeleteOutlinedSvg; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DeleteSvg", function() { return DeleteSvg; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ErrorSvg", function() { return ErrorSvg; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ExtensionSvg", function() { return ExtensionSvg; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FlipToFrontSvg", function() { return FlipToFrontSvg; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FullscreenSvg", function() { return FullscreenSvg; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "GetAppSvg", function() { return GetAppSvg; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "HelpOutlineSvg", function() { return HelpOutlineSvg; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "HomeOutlinedSvg", function() { return HomeOutlinedSvg; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "LaunchSvg", function() { return LaunchSvg; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "LinearScaleSvg", function() { return LinearScaleSvg; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MoreHorizSvg", function() { return MoreHorizSvg; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "NavigateBeforeSvg", function() { return NavigateBeforeSvg; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "NavigateNextSvg", function() { return NavigateNextSvg; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "OpenInBrowserSvg", function() { return OpenInBrowserSvg; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "PlayArrowSvg", function() { return PlayArrowSvg; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "RefreshSvg", function() { return RefreshSvg; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "RemoveSvg", function() { return RemoveSvg; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "RestoreSvg", function() { return RestoreSvg; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SaveOutlinedSvg", function() { return SaveOutlinedSvg; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ScatterPlotSvg", function() { return ScatterPlotSvg; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SkipPreviousSvg", function() { return SkipPreviousSvg; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "StopSvg", function() { return StopSvg; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SubscriptionsOutlinedSvg", function() { return SubscriptionsOutlinedSvg; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SwapHorizSvg", function() { return SwapHorizSvg; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "TuneSvg", function() { return TuneSvg; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "VisibilityOffOutlinedSvg", function() { return VisibilityOffOutlinedSvg; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "VisibilityOutlinedSvg", function() { return VisibilityOutlinedSvg; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "WarningSvg", function() { return WarningSvg; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SelectionModeSvg", function() { return SelectionModeSvg; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SuperposeAtomsSvg", function() { return SuperposeAtomsSvg; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SuperposeChainsSvg", function() { return SuperposeChainsSvg; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SuperpositionSvg", function() { return SuperpositionSvg; });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react */ "./node_modules/react/index.js");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/**
 * Copyright (c) 2020 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author David Sehnal <david.sehnal@gmail.com>
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */

function Icon(props) {
    if (!props.svg)
        return null;
    return react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("span", { className: "msp-icon msp-material-icon" + (props.inline ? ' msp-icon-inline' : ''), title: props.title, style: props.style },
        react__WEBPACK_IMPORTED_MODULE_0__["createElement"](props.svg, null));
}
//
var circleLeft = react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("circle", { r: '6px', id: 'circle-left', cy: '12px', cx: '8px', strokeWidth: '1px' });
var circleRight = react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("circle", { r: '6px', id: 'circle-right', cy: '12px', cx: '16px', strokeWidth: '1px' });
var _Union = react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("svg", { width: '24px', height: '24px', viewBox: '0 0 24 24' },
    react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("defs", null,
        circleLeft,
        circleRight),
    react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("g", null,
        react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("use", { href: '#circle-left', className: 'msp-shape-filled' }),
        react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("use", { href: '#circle-right', className: 'msp-shape-filled' }),
        react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("use", { href: '#circle-left', className: 'msp-shape-empty' })));
function UnionSvg() { return _Union; }
var _Subtract = react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("svg", { width: '24px', height: '24px', viewBox: '0 0 24 24' },
    react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("defs", null,
        circleLeft,
        circleRight,
        react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("mask", { id: 'mask-left' },
            react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("use", { href: '#circle-left', fill: 'white', stroke: 'white' }),
            react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("use", { href: '#circle-right', fill: 'black', strokeWidth: '0px', stroke: 'white' }))),
    react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("g", null,
        react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("use", { href: '#circle-left', className: 'msp-shape-filled', mask: 'url(#mask-left)' }),
        react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("use", { href: '#circle-right', className: 'msp-shape-empty' })));
function SubtractSvg() { return _Subtract; }
var _Intersect = react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("svg", { width: '24px', height: '24px', viewBox: '0 0 24 24' },
    react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("defs", null,
        circleLeft,
        circleRight,
        react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("clipPath", { id: 'clip-left' },
            react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("use", { href: '#circle-right' }))),
    react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("g", null,
        react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("use", { href: '#circle-left', className: 'msp-shape-filled', clipPath: 'url(#clip-left)' }),
        react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("use", { href: '#circle-left', className: 'msp-shape-empty' }),
        react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("use", { href: '#circle-right', className: 'msp-shape-empty' })));
function IntersectSvg() { return _Intersect; }
var _Set = react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("svg", { width: '24px', height: '24px', viewBox: '0 0 24 24' },
    react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("defs", null,
        circleLeft,
        circleRight),
    react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("g", null,
        react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("use", { href: '#circle-left', className: 'msp-shape-empty' }),
        react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("use", { href: '#circle-right', className: 'msp-shape-filled' })));
function SetSvg() { return _Set; }
var _Molecule = react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("svg", { width: '17px', height: '17px', viewBox: '0 0 299.463 299.463', strokeWidth: '6px' },
    react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("g", null,
        react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("path", { d: 'M256.851,173.832v-48.201c22.916-4.918,34.151-30.668,22.556-50.771c-11.547-20.004-39.486-23.251-55.242-5.844 l-41.746-24.106C189.618,22.603,172.861,0,149.734,0c-23.132,0-39.881,22.609-32.685,44.911L75.305,69.016 C59.522,51.586,31.597,54.88,20.061,74.863c-11.63,20.163-0.298,45.862,22.557,50.769v48.2 c-22.821,4.898-34.195,30.591-22.556,50.771c11.529,19.972,39.454,23.285,55.242,5.845l41.746,24.106 c-7.199,22.308,9.559,44.911,32.685,44.911c23.132,0,39.88-22.609,32.685-44.911l41.745-24.106 c15.817,17.469,43.73,14.099,55.242-5.844c0,0,0-0.001,0.001-0.002c4.587-7.953,5.805-17.213,3.431-26.076 C279.392,185.657,269.129,176.461,256.851,173.832z M249.62,72.088c20.568,0,27.428,27.191,10.008,37.239 c-0.003,0.002-0.006,0.003-0.009,0.005c-10.04,5.81-22.85,1.762-27.877-8.475C225.206,87.548,234.938,72.088,249.62,72.088z M149.734,14.4c11.005,0,19.958,8.954,19.958,19.959c0,11.127-9.077,19.958-19.958,19.958c-10.95,0-19.958-8.9-19.958-19.958 C129.776,23.354,138.729,14.4,149.734,14.4z M39.84,109.328c-17.451-10.067-10.534-37.24,10.01-37.24 c15.311,0,24.922,16.653,17.251,29.942C61.681,111.397,49.517,114.925,39.84,109.328z M59.802,224.702 c-9.535,5.503-21.768,2.229-27.268-7.298c-7.639-13.242,1.887-29.945,17.236-29.945c0.013,0,0.027,0,0.04,0 C70.07,187.48,77.49,214.469,59.802,224.702z M149.734,285.062c-11.005,0-19.958-8.954-19.958-19.958 c0-11.127,9.077-19.958,19.958-19.958c10.954,0,19.958,8.903,19.958,19.958C169.693,276.109,160.74,285.062,149.734,285.062z M216.953,217.982l-41.727,24.095c-13.778-15.22-37.459-14.94-50.983,0l-41.728-24.096c6.196-19.289-5.541-39.835-25.498-44.149 V125.63c19.752-4.268,31.762-24.65,25.498-44.149l41.727-24.095c13.629,15.055,37.32,15.093,50.983,0l41.728,24.096 c-6.196,19.29,5.534,39.835,25.498,44.149v48.202C222.61,178.123,210.721,198.581,216.953,217.982z M266.935,217.404 c-5.501,9.528-17.732,12.802-27.261,7.302c-17.682-10.23-10.301-37.247,10.032-37.247 C264.984,187.459,274.602,204.112,266.935,217.404z' })));
function MoleculeSvg() { return _Molecule; }
// The following icons are adapted from https://materialdesignicons.com/ and
// licensed with https://github.com/Templarian/MaterialDesign/blob/master/LICENSE
var _CubeOutline = react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("svg", { width: '24px', height: '24px', viewBox: '0 0 24 24', strokeWidth: '0.1px' },
    react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("path", { d: "M21,16.5C21,16.88 20.79,17.21 20.47,17.38L12.57,21.82C12.41,21.94 12.21,22 12,22C11.79,22 11.59,21.94 11.43,21.82L3.53,17.38C3.21,17.21 3,16.88 3,16.5V7.5C3,7.12 3.21,6.79 3.53,6.62L11.43,2.18C11.59,2.06 11.79,2 12,2C12.21,2 12.41,2.06 12.57,2.18L20.47,6.62C20.79,6.79 21,7.12 21,7.5V16.5M12,4.15L6.04,7.5L12,10.85L17.96,7.5L12,4.15M5,15.91L11,19.29V12.58L5,9.21V15.91M19,15.91V9.21L13,12.58V19.29L19,15.91Z" }));
function CubeOutlineSvg() { return _CubeOutline; }
var _CursorDefaultOutline = react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("svg", { width: '24px', height: '24px', viewBox: '0 0 24 24' },
    react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("path", { d: 'M10.07,14.27C10.57,14.03 11.16,14.25 11.4,14.75L13.7,19.74L15.5,18.89L13.19,13.91C12.95,13.41 13.17,12.81 13.67,12.58L13.95,12.5L16.25,12.05L8,5.12V15.9L9.82,14.43L10.07,14.27M13.64,21.97C13.14,22.21 12.54,22 12.31,21.5L10.13,16.76L7.62,18.78C7.45,18.92 7.24,19 7,19A1,1 0 0,1 6,18V3A1,1 0 0,1 7,2C7.24,2 7.47,2.09 7.64,2.23L7.65,2.22L19.14,11.86C19.57,12.22 19.62,12.85 19.27,13.27C19.12,13.45 18.91,13.57 18.7,13.61L15.54,14.23L17.74,18.96C18,19.46 17.76,20.05 17.26,20.28L13.64,21.97Z' }));
function CursorDefaultOutlineSvg() { return _CursorDefaultOutline; }
var _FileOutline = react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("svg", { width: '24px', height: '24px', viewBox: '0 0 24 24', strokeWidth: '0.1px' },
    react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("path", { fill: 'currentColor', d: 'M14,2H6A2,2 0 0,0 4,4V20A2,2 0 0,0 6,22H18A2,2 0 0,0 20,20V8L14,2M18,20H6V4H13V9H18V20Z' }));
function FileOutlineSvg() { return _FileOutline; }
var _PencilRuler = react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("svg", { width: '24px', height: '24px', viewBox: '0 0 24 24', strokeWidth: '0.1px' },
    react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("path", { d: "M3 17.25V21H6.75L17.81 9.93L14.06 6.18L3 17.25M22.61 18.36L18.36 22.61L13.16 17.41L14.93 15.64L15.93 16.64L18.4 14.16L19.82 15.58L18.36 17L19.42 18L20.84 16.6L22.61 18.36M6.61 10.83L1.39 5.64L5.64 1.39L7.4 3.16L4.93 5.64L6 6.7L8.46 4.22L9.88 5.64L8.46 7.05L9.46 8.05L6.61 10.83M20.71 7C21.1 6.61 21.1 6 20.71 5.59L18.37 3.29C18 2.9 17.35 2.9 16.96 3.29L15.12 5.12L18.87 8.87L20.71 7Z" }));
function PencilRulerSvg() { return _PencilRuler; }
// The following icons are adapted from https://material-ui.com/components/material-icons/ and
// licensed with https://github.com/mui-org/material-ui/blob/master/LICENSE
var _AccountTreeOutlined = react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("svg", { width: '24px', height: '24px', viewBox: '0 0 24 24' },
    react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("path", { d: 'M22 11V3h-7v3H9V3H2v8h7V8h2v10h4v3h7v-8h-7v3h-2V8h2v3h7zM7 9H4V5h3v4zm10 6h3v4h-3v-4zm0-10h3v4h-3V5z' }));
function AccountTreeOutlinedSvg() { return _AccountTreeOutlined; }
var _Add = react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("svg", { width: '24px', height: '24px', viewBox: '0 0 24 24' },
    react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("path", { d: 'M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6v2z' }));
function AddSvg() { return _Add; }
var _ArrowDownward = react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("svg", { width: '24px', height: '24px', viewBox: '0 0 24 24' },
    react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("path", { d: 'M20 12l-1.41-1.41L13 16.17V4h-2v12.17l-5.58-5.59L4 12l8 8 8-8z' }));
function ArrowDownwardSvg() { return _ArrowDownward; }
var _ArrowDropDown = react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("svg", { width: '24px', height: '24px', viewBox: '0 0 24 24' },
    react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("path", { d: 'M7 10l5 5 5-5z' }));
function ArrowDropDownSvg() { return _ArrowDropDown; }
var _ArrowRight = react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("svg", { width: '24px', height: '24px', viewBox: '0 0 24 24' },
    react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("path", { d: 'M10 17l5-5-5-5v10z' }));
function ArrowRightSvg() { return _ArrowRight; }
var _ArrowUpward = react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("svg", { width: '24px', height: '24px', viewBox: '0 0 24 24' },
    react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("path", { d: 'M4 12l1.41 1.41L11 7.83V20h2V7.83l5.58 5.59L20 12l-8-8-8 8z' }));
function ArrowUpwardSvg() { return _ArrowUpward; }
var _Autorenew = react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("svg", { width: '24px', height: '24px', viewBox: '0 0 24 24' },
    react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("path", { d: 'M12 6v3l4-4-4-4v3c-4.42 0-8 3.58-8 8 0 1.57.46 3.03 1.24 4.26L6.7 14.8c-.45-.83-.7-1.79-.7-2.8 0-3.31 2.69-6 6-6zm6.76 1.74L17.3 9.2c.44.84.7 1.79.7 2.8 0 3.31-2.69 6-6 6v-3l-4 4 4 4v-3c4.42 0 8-3.58 8-8 0-1.57-.46-3.03-1.24-4.26z' }));
function AutorenewSvg() { return _Autorenew; }
var _BlurOn = react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("svg", { width: '24px', height: '24px', viewBox: '0 0 24 24' },
    react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("path", { d: 'M6 13c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm0 4c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm0-8c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm-3 .5c-.28 0-.5.22-.5.5s.22.5.5.5.5-.22.5-.5-.22-.5-.5-.5zM6 5c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm15 5.5c.28 0 .5-.22.5-.5s-.22-.5-.5-.5-.5.22-.5.5.22.5.5.5zM14 7c.55 0 1-.45 1-1s-.45-1-1-1-1 .45-1 1 .45 1 1 1zm0-3.5c.28 0 .5-.22.5-.5s-.22-.5-.5-.5-.5.22-.5.5.22.5.5.5zm-11 10c-.28 0-.5.22-.5.5s.22.5.5.5.5-.22.5-.5-.22-.5-.5-.5zm7 7c-.28 0-.5.22-.5.5s.22.5.5.5.5-.22.5-.5-.22-.5-.5-.5zm0-17c.28 0 .5-.22.5-.5s-.22-.5-.5-.5-.5.22-.5.5.22.5.5.5zM10 7c.55 0 1-.45 1-1s-.45-1-1-1-1 .45-1 1 .45 1 1 1zm0 5.5c-.83 0-1.5.67-1.5 1.5s.67 1.5 1.5 1.5 1.5-.67 1.5-1.5-.67-1.5-1.5-1.5zm8 .5c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm0 4c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm0-8c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm0-4c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm3 8.5c-.28 0-.5.22-.5.5s.22.5.5.5.5-.22.5-.5-.22-.5-.5-.5zM14 17c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm0 3.5c-.28 0-.5.22-.5.5s.22.5.5.5.5-.22.5-.5-.22-.5-.5-.5zm-4-12c-.83 0-1.5.67-1.5 1.5s.67 1.5 1.5 1.5 1.5-.67 1.5-1.5-.67-1.5-1.5-1.5zm0 8.5c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm4-4.5c-.83 0-1.5.67-1.5 1.5s.67 1.5 1.5 1.5 1.5-.67 1.5-1.5-.67-1.5-1.5-1.5zm0-4c-.83 0-1.5.67-1.5 1.5s.67 1.5 1.5 1.5 1.5-.67 1.5-1.5-.67-1.5-1.5-1.5z' }));
function BlurOnSvg() { return _BlurOn; }
var _BookmarksOutlined = react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("svg", { width: '24px', height: '24px', viewBox: '0 0 24 24' },
    react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("path", { d: 'M15 7v12.97l-4.21-1.81-.79-.34-.79.34L5 19.97V7h10m4-6H8.99C7.89 1 7 1.9 7 3h10c1.1 0 2 .9 2 2v13l2 1V3c0-1.1-.9-2-2-2zm-4 4H5c-1.1 0-2 .9-2 2v16l7-3 7 3V7c0-1.1-.9-2-2-2z' }));
function BookmarksOutlinedSvg() { return _BookmarksOutlined; }
var _Brush = react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("svg", { width: '24px', height: '24px', viewBox: '0 0 24 24' },
    react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("path", { d: 'M7 14c-1.66 0-3 1.34-3 3 0 1.31-1.16 2-2 2 .92 1.22 2.49 2 4 2 2.21 0 4-1.79 4-4 0-1.66-1.34-3-3-3zm13.71-9.37l-1.34-1.34a.9959.9959 0 00-1.41 0L9 12.25 11.75 15l8.96-8.96c.39-.39.39-1.02 0-1.41z' }));
function BrushSvg() { return _Brush; }
var _BuildOutlined = react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("svg", { width: '24px', height: '24px', viewBox: '0 0 24 24' },
    react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("path", { d: 'M22.61 18.99l-9.08-9.08c.93-2.34.45-5.1-1.44-7C9.79.61 6.21.4 3.66 2.26L7.5 6.11 6.08 7.52 2.25 3.69C.39 6.23.6 9.82 2.9 12.11c1.86 1.86 4.57 2.35 6.89 1.48l9.11 9.11c.39.39 1.02.39 1.41 0l2.3-2.3c.4-.38.4-1.01 0-1.41zm-3 1.6l-9.46-9.46c-.61.45-1.29.72-2 .82-1.36.2-2.79-.21-3.83-1.25C3.37 9.76 2.93 8.5 3 7.26l3.09 3.09 4.24-4.24-3.09-3.09c1.24-.07 2.49.37 3.44 1.31 1.08 1.08 1.49 2.57 1.24 3.96-.12.71-.42 1.37-.88 1.96l9.45 9.45-.88.89z' }));
function BuildOutlinedSvg() { return _BuildOutlined; }
var _Build = react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("svg", { width: '24px', height: '24px', viewBox: '0 0 24 24' },
    react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("path", { d: 'M22.7 19l-9.1-9.1c.9-2.3.4-5-1.5-6.9-2-2-5-2.4-7.4-1.3L9 6 6 9 1.6 4.7C.4 7.1.9 10.1 2.9 12.1c1.9 1.9 4.6 2.4 6.9 1.5l9.1 9.1c.4.4 1 .4 1.4 0l2.3-2.3c.5-.4.5-1.1.1-1.4z' }));
function BuildSvg() { return _Build; }
var _CameraOutlined = react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("svg", { width: '24px', height: '24px', viewBox: '0 0 24 24' },
    react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("path", { d: 'M14.25 2.26l-.08-.04-.01.02C13.46 2.09 12.74 2 12 2 6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10c0-4.75-3.31-8.72-7.75-9.74zM19.41 9h-7.99l2.71-4.7c2.4.66 4.35 2.42 5.28 4.7zM13.1 4.08L10.27 9l-1.15 2L6.4 6.3C7.84 4.88 9.82 4 12 4c.37 0 .74.03 1.1.08zM5.7 7.09L8.54 12l1.15 2H4.26C4.1 13.36 4 12.69 4 12c0-1.85.64-3.55 1.7-4.91zM4.59 15h7.98l-2.71 4.7c-2.4-.67-4.34-2.42-5.27-4.7zm6.31 4.91L14.89 13l2.72 4.7C16.16 19.12 14.18 20 12 20c-.38 0-.74-.04-1.1-.09zm7.4-3l-4-6.91h5.43c.17.64.27 1.31.27 2 0 1.85-.64 3.55-1.7 4.91z' }));
function CameraOutlinedSvg() { return _CameraOutlined; }
var _Camera = react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("svg", { width: '24px', height: '24px', viewBox: '0 0 24 24' },
    react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("path", { d: 'M9.4 10.5l4.77-8.26C13.47 2.09 12.75 2 12 2c-2.4 0-4.6.85-6.32 2.25l3.66 6.35.06-.1zM21.54 9c-.92-2.92-3.15-5.26-6-6.34L11.88 9h9.66zm.26 1h-7.49l.29.5 4.76 8.25C21 16.97 22 14.61 22 12c0-.69-.07-1.35-.2-2zM8.54 12l-3.9-6.75C3.01 7.03 2 9.39 2 12c0 .69.07 1.35.2 2h7.49l-1.15-2zm-6.08 3c.92 2.92 3.15 5.26 6 6.34L12.12 15H2.46zm11.27 0l-3.9 6.76c.7.15 1.42.24 2.17.24 2.4 0 4.6-.85 6.32-2.25l-3.66-6.35-.93 1.6z' }));
function CameraSvg() { return _Camera; }
var _CancelOutlined = react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("svg", { width: '24px', height: '24px', viewBox: '0 0 24 24' },
    react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("path", { d: 'M12 2C6.47 2 2 6.47 2 12s4.47 10 10 10 10-4.47 10-10S17.53 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zm3.59-13L12 10.59 8.41 7 7 8.41 10.59 12 7 15.59 8.41 17 12 13.41 15.59 17 17 15.59 13.41 12 17 8.41z' }));
function CancelOutlinedSvg() { return _CancelOutlined; }
var _Cancel = react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("svg", { width: '24px', height: '24px', viewBox: '0 0 24 24' },
    react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("path", { d: 'M12 2C6.47 2 2 6.47 2 12s4.47 10 10 10 10-4.47 10-10S17.53 2 12 2zm5 13.59L15.59 17 12 13.41 8.41 17 7 15.59 10.59 12 7 8.41 8.41 7 12 10.59 15.59 7 17 8.41 13.41 12 17 15.59z' }));
function CancelSvg() { return _Cancel; }
var _CenterFocusStrong = react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("svg", { width: '24px', height: '24px', viewBox: '0 0 24 24' },
    react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("path", { d: 'M12 8c-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4zm-7 7H3v4c0 1.1.9 2 2 2h4v-2H5v-4zM5 5h4V3H5c-1.1 0-2 .9-2 2v4h2V5zm14-2h-4v2h4v4h2V5c0-1.1-.9-2-2-2zm0 16h-4v2h4c1.1 0 2-.9 2-2v-4h-2v4z' }));
function CenterFocusStrongSvg() { return _CenterFocusStrong; }
var _Check = react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("svg", { width: '24px', height: '24px', viewBox: '0 0 24 24' },
    react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("path", { d: 'M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z' }));
function CheckSvg() { return _Check; }
var _Clear = react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("svg", { width: '24px', height: '24px', viewBox: '0 0 24 24' },
    react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("path", { d: 'M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z' }));
function ClearSvg() { return _Clear; }
var _Close = react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("svg", { width: '24px', height: '24px', viewBox: '0 0 24 24' },
    react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("path", { d: 'M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z' }));
function CloseSvg() { return _Close; }
var _CloudUpload = react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("svg", { width: '24px', height: '24px', viewBox: '0 0 24 24' },
    react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("path", { d: 'M19.35 10.04C18.67 6.59 15.64 4 12 4 9.11 4 6.6 5.64 5.35 8.04 2.34 8.36 0 10.91 0 14c0 3.31 2.69 6 6 6h13c2.76 0 5-2.24 5-5 0-2.64-2.05-4.78-4.65-4.96zM14 13v4h-4v-4H7l5-5 5 5h-3z' }));
function CloudUploadSvg() { return _CloudUpload; }
var _Code = react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("svg", { width: '24px', height: '24px', viewBox: '0 0 24 24' },
    react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("path", { d: 'M9.4 16.6L4.8 12l4.6-4.6L8 6l-6 6 6 6 1.4-1.4zm5.2 0l4.6-4.6-4.6-4.6L16 6l6 6-6 6-1.4-1.4z' }));
function CodeSvg() { return _Code; }
var _Copy = react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("svg", { width: '24px', height: '24px', viewBox: '0 0 24 24' },
    react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("path", { d: 'M16 1H4c-1.1 0-2 .9-2 2v14h2V3h12V1zm-1 4H8c-1.1 0-1.99.9-1.99 2L6 21c0 1.1.89 2 1.99 2H19c1.1 0 2-.9 2-2V11l-6-6zM8 21V7h6v5h5v9H8z' }));
function CopySvg() { return _Copy; }
var _Crop = react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("svg", { width: '24px', height: '24px', viewBox: '0 0 24 24' },
    react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("path", { d: 'M17 15h2V7c0-1.1-.9-2-2-2H9v2h8v8zM7 17V1H5v4H1v2h4v10c0 1.1.9 2 2 2h10v4h2v-4h4v-2H7z' }));
function CropSvg() { return _Crop; }
var _CropFree = react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("svg", { width: '24px', height: '24px', viewBox: '0 0 24 24' },
    react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("path", { d: 'M3 5v4h2V5h4V3H5c-1.1 0-2 .9-2 2zm2 10H3v4c0 1.1.9 2 2 2h4v-2H5v-4zm14 4h-4v2h4c1.1 0 2-.9 2-2v-4h-2v4zm0-16h-4v2h4v4h2V5c0-1.1-.9-2-2-2z' }));
function CropFreeSvg() { return _CropFree; }
var _CropOriginal = react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("svg", { width: '24px', height: '24px', viewBox: '0 0 24 24' },
    react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("path", { d: 'M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H5V5h14v14zm-5.04-6.71l-2.75 3.54-1.96-2.36L6.5 17h11l-3.54-4.71z' }));
function CropOrginalSvg() { return _CropOriginal; }
var _DeleteOutlined = react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("svg", { width: '24px', height: '24px', viewBox: '0 0 24 24' },
    react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("path", { d: 'M16 9v10H8V9h8m-1.5-6h-5l-1 1H5v2h14V4h-3.5l-1-1zM18 7H6v12c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7z' }));
function DeleteOutlinedSvg() { return _DeleteOutlined; }
var _Delete = react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("svg", { width: '24px', height: '24px', viewBox: '0 0 24 24' },
    react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("path", { d: 'M6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7H6v12zM19 4h-3.5l-1-1h-5l-1 1H5v2h14V4z' }));
function DeleteSvg() { return _Delete; }
var _Error = react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("svg", { width: '24px', height: '24px', viewBox: '0 0 24 24' },
    react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("path", { d: 'M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-2h2v2zm0-4h-2V7h2v6z' }));
function ErrorSvg() { return _Error; }
var _Extension = react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("svg", { width: '24px', height: '24px', viewBox: '0 0 24 24' },
    react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("path", { d: 'M20.5 11H19V7c0-1.1-.9-2-2-2h-4V3.5C13 2.12 11.88 1 10.5 1S8 2.12 8 3.5V5H4c-1.1 0-1.99.9-1.99 2v3.8H3.5c1.49 0 2.7 1.21 2.7 2.7s-1.21 2.7-2.7 2.7H2V20c0 1.1.9 2 2 2h3.8v-1.5c0-1.49 1.21-2.7 2.7-2.7 1.49 0 2.7 1.21 2.7 2.7V22H17c1.1 0 2-.9 2-2v-4h1.5c1.38 0 2.5-1.12 2.5-2.5S21.88 11 20.5 11z' }));
function ExtensionSvg() { return _Extension; }
var _FlipToFront = react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("svg", { width: '24px', height: '24px', viewBox: '0 0 24 24', strokeWidth: '0.1px' },
    react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("path", { d: 'M3 13h2v-2H3v2zm0 4h2v-2H3v2zm2 4v-2H3c0 1.1.89 2 2 2zM3 9h2V7H3v2zm12 12h2v-2h-2v2zm4-18H9c-1.11 0-2 .9-2 2v10c0 1.1.89 2 2 2h10c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 12H9V5h10v10zm-8 6h2v-2h-2v2zm-4 0h2v-2H7v2z' }));
function FlipToFrontSvg() { return _FlipToFront; }
var _Fullscreen = react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("svg", { width: '24px', height: '24px', viewBox: '0 0 24 24' },
    react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("path", { d: 'M7 14H5v5h5v-2H7v-3zm-2-4h2V7h3V5H5v5zm12 7h-3v2h5v-5h-2v3zM14 5v2h3v3h2V5h-5z' }));
function FullscreenSvg() { return _Fullscreen; }
var _GetApp = react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("svg", { width: '24px', height: '24px', viewBox: '0 0 24 24' },
    react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("path", { d: 'M19 9h-4V3H9v6H5l7 7 7-7zM5 18v2h14v-2H5z' }));
function GetAppSvg() { return _GetApp; }
var _HelpOutline = react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("svg", { width: '24px', height: '24px', viewBox: '0 0 24 24' },
    react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("path", { d: 'M11 18h2v-2h-2v2zm1-16C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zm0-14c-2.21 0-4 1.79-4 4h2c0-1.1.9-2 2-2s2 .9 2 2c0 2-3 1.75-3 5h2c0-2.25 3-2.5 3-5 0-2.21-1.79-4-4-4z' }));
function HelpOutlineSvg() { return _HelpOutline; }
var _HomeOutlined = react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("svg", { width: '24px', height: '24px', viewBox: '0 0 24 24' },
    react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("path", { d: 'M12 5.69l5 4.5V18h-2v-6H9v6H7v-7.81l5-4.5M12 3L2 12h3v8h6v-6h2v6h6v-8h3L12 3z' }));
function HomeOutlinedSvg() { return _HomeOutlined; }
var _Launch = react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("svg", { width: '24px', height: '24px', viewBox: '0 0 24 24' },
    react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("path", { d: 'M19 19H5V5h7V3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2v-7h-2v7zM14 3v2h3.59l-9.83 9.83 1.41 1.41L19 6.41V10h2V3h-7z' }));
function LaunchSvg() { return _Launch; }
var _LinearScale = react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("svg", { width: '24px', height: '24px', viewBox: '0 0 24 24' },
    react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("path", { d: 'M19.5 9.5c-1.03 0-1.9.62-2.29 1.5h-2.92c-.39-.88-1.26-1.5-2.29-1.5s-1.9.62-2.29 1.5H6.79c-.39-.88-1.26-1.5-2.29-1.5C3.12 9.5 2 10.62 2 12s1.12 2.5 2.5 2.5c1.03 0 1.9-.62 2.29-1.5h2.92c.39.88 1.26 1.5 2.29 1.5s1.9-.62 2.29-1.5h2.92c.39.88 1.26 1.5 2.29 1.5 1.38 0 2.5-1.12 2.5-2.5s-1.12-2.5-2.5-2.5z' }));
function LinearScaleSvg() { return _LinearScale; }
var _MoreHoriz = react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("svg", { width: '24px', height: '24px', viewBox: '0 0 24 24' },
    react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("path", { d: 'M6 10c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm12 0c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm-6 0c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z' }));
function MoreHorizSvg() { return _MoreHoriz; }
var _NavigateBefore = react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("svg", { width: '24px', height: '24px', viewBox: '0 0 24 24' },
    react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("path", { d: 'M15.41 7.41L14 6l-6 6 6 6 1.41-1.41L10.83 12z' }));
function NavigateBeforeSvg() { return _NavigateBefore; }
var _NavigateNext = react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("svg", { width: '24px', height: '24px', viewBox: '0 0 24 24' },
    react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("path", { d: 'M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z' }));
function NavigateNextSvg() { return _NavigateNext; }
var _OpenInBrowser = react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("svg", { width: '24px', height: '24px', viewBox: '0 0 24 24' },
    react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("path", { d: 'M19 4H5c-1.11 0-2 .9-2 2v12c0 1.1.89 2 2 2h4v-2H5V8h14v10h-4v2h4c1.1 0 2-.9 2-2V6c0-1.1-.89-2-2-2zm-7 6l-4 4h3v6h2v-6h3l-4-4z' }));
function OpenInBrowserSvg() { return _OpenInBrowser; }
var _PlayArrow = react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("svg", { width: '24px', height: '24px', viewBox: '0 0 24 24' },
    react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("path", { d: 'M8 5v14l11-7z' }));
function PlayArrowSvg() { return _PlayArrow; }
var _Refresh = react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("svg", { width: '24px', height: '24px', viewBox: '0 0 24 24' },
    react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("path", { d: 'M17.65 6.35C16.2 4.9 14.21 4 12 4c-4.42 0-7.99 3.58-7.99 8s3.57 8 7.99 8c3.73 0 6.84-2.55 7.73-6h-2.08c-.82 2.33-3.04 4-5.65 4-3.31 0-6-2.69-6-6s2.69-6 6-6c1.66 0 3.14.69 4.22 1.78L13 11h7V4l-2.35 2.35z' }));
function RefreshSvg() { return _Refresh; }
var _Remove = react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("svg", { width: '24px', height: '24px', viewBox: '0 0 24 24' },
    react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("path", { d: 'M19 13H5v-2h14v2z' }));
function RemoveSvg() { return _Remove; }
var _Restore = react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("svg", { width: '24px', height: '24px', viewBox: '0 0 24 24' },
    react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("path", { d: 'M13 3c-4.97 0-9 4.03-9 9H1l3.89 3.89.07.14L9 12H6c0-3.87 3.13-7 7-7s7 3.13 7 7-3.13 7-7 7c-1.93 0-3.68-.79-4.94-2.06l-1.42 1.42C8.27 19.99 10.51 21 13 21c4.97 0 9-4.03 9-9s-4.03-9-9-9zm-1 5v5l4.28 2.54.72-1.21-3.5-2.08V8H12z' }));
function RestoreSvg() { return _Restore; }
var _SaveOutlined = react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("svg", { width: '24px', height: '24px', viewBox: '0 0 24 24', strokeWidth: '0.1px' },
    react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("path", { d: 'M17 3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V7l-4-4zm2 16H5V5h11.17L19 7.83V19zm-7-7c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3zM6 6h9v4H6z' }));
function SaveOutlinedSvg() { return _SaveOutlined; }
var _ScatterPlot = react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("svg", { width: '24px', height: '24px', viewBox: '0 0 24 24' },
    react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("circle", { cx: '7', cy: '14', r: '3' }),
    react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("circle", { cx: '11', cy: '6', r: '3' }),
    react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("circle", { cx: '16.6', cy: '17.6', r: '3' }));
function ScatterPlotSvg() { return _ScatterPlot; }
var _SkipPrevious = react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("svg", { width: '24px', height: '24px', viewBox: '0 0 24 24' },
    react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("path", { d: 'M6 6h2v12H6zm3.5 6l8.5 6V6z' }));
function SkipPreviousSvg() { return _SkipPrevious; }
var _Stop = react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("svg", { width: '24px', height: '24px', viewBox: '0 0 24 24' },
    react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("path", { d: 'M6 6h12v12H6z' }));
function StopSvg() { return _Stop; }
var _SubscriptionsOutlined = react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("svg", { width: '24px', height: '24px', viewBox: '0 0 24 24' },
    react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("path", { d: 'M4 6h16v2H4zm2-4h12v2H6zm14 8H4c-1.1 0-2 .9-2 2v8c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2v-8c0-1.1-.9-2-2-2zm0 10H4v-8h16v8zm-10-7.27v6.53L16 16z' }));
function SubscriptionsOutlinedSvg() { return _SubscriptionsOutlined; }
var _SwapHoriz = react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("svg", { width: '24px', height: '24px', viewBox: '0 0 24 24' },
    react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("path", { d: 'M6.99 11L3 15l3.99 4v-3H14v-2H6.99v-3zM21 9l-3.99-4v3H10v2h7.01v3L21 9z' }));
function SwapHorizSvg() { return _SwapHoriz; }
var _Tune = react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("svg", { width: '24px', height: '24px', viewBox: '0 0 24 24' },
    react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("path", { d: 'M3 17v2h6v-2H3zM3 5v2h10V5H3zm10 16v-2h8v-2h-8v-2h-2v6h2zM7 9v2H3v2h4v2h2V9H7zm14 4v-2H11v2h10zm-6-4h2V7h4V5h-4V3h-2v6z' }));
function TuneSvg() { return _Tune; }
var _VisibilityOffOutlined = react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("svg", { width: '24px', height: '24px', viewBox: '0 0 24 24' },
    react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("path", { d: 'M12 6c3.79 0 7.17 2.13 8.82 5.5-.59 1.22-1.42 2.27-2.41 3.12l1.41 1.41c1.39-1.23 2.49-2.77 3.18-4.53C21.27 7.11 17 4 12 4c-1.27 0-2.49.2-3.64.57l1.65 1.65C10.66 6.09 11.32 6 12 6zm-1.07 1.14L13 9.21c.57.25 1.03.71 1.28 1.28l2.07 2.07c.08-.34.14-.7.14-1.07C16.5 9.01 14.48 7 12 7c-.37 0-.72.05-1.07.14zM2.01 3.87l2.68 2.68C3.06 7.83 1.77 9.53 1 11.5 2.73 15.89 7 19 12 19c1.52 0 2.98-.29 4.32-.82l3.42 3.42 1.41-1.41L3.42 2.45 2.01 3.87zm7.5 7.5l2.61 2.61c-.04.01-.08.02-.12.02-1.38 0-2.5-1.12-2.5-2.5 0-.05.01-.08.01-.13zm-3.4-3.4l1.75 1.75c-.23.55-.36 1.15-.36 1.78 0 2.48 2.02 4.5 4.5 4.5.63 0 1.23-.13 1.77-.36l.98.98c-.88.24-1.8.38-2.75.38-3.79 0-7.17-2.13-8.82-5.5.7-1.43 1.72-2.61 2.93-3.53z' }));
function VisibilityOffOutlinedSvg() { return _VisibilityOffOutlined; }
var _VisibilityOutlined = react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("svg", { width: '24px', height: '24px', viewBox: '0 0 24 24' },
    react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("path", { d: 'M12 6c3.79 0 7.17 2.13 8.82 5.5C19.17 14.87 15.79 17 12 17s-7.17-2.13-8.82-5.5C4.83 8.13 8.21 6 12 6m0-2C7 4 2.73 7.11 1 11.5 2.73 15.89 7 19 12 19s9.27-3.11 11-7.5C21.27 7.11 17 4 12 4zm0 5c1.38 0 2.5 1.12 2.5 2.5S13.38 14 12 14s-2.5-1.12-2.5-2.5S10.62 9 12 9m0-2c-2.48 0-4.5 2.02-4.5 4.5S9.52 16 12 16s4.5-2.02 4.5-4.5S14.48 7 12 7z' }));
function VisibilityOutlinedSvg() { return _VisibilityOutlined; }
var _Warning = react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("svg", { width: '24px', height: '24px', viewBox: '0 0 24 24' },
    react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("path", { d: 'M1 21h22L12 2 1 21zm12-3h-2v-2h2v2zm0-4h-2v-4h2v4z' }));
function WarningSvg() { return _Warning; }
// Aliases
var SelectionModeSvg = CursorDefaultOutlineSvg;
var SuperposeAtomsSvg = ScatterPlotSvg;
var SuperposeChainsSvg = LinearScaleSvg;
var SuperpositionSvg = FlipToFrontSvg;
//# sourceMappingURL=icons.js.map

/***/ }),

/***/ "./lib/mol-plugin-ui/controls/legend.js":
/*!**********************************************!*\
  !*** ./lib/mol-plugin-ui/controls/legend.js ***!
  \**********************************************/
/*! exports provided: legendFor, ScaleLegend, TableLegend */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "legendFor", function() { return legendFor; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ScaleLegend", function() { return ScaleLegend; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "TableLegend", function() { return TableLegend; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _mol_util_color__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../mol-util/color */ "./lib/mol-util/color/index.js");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! react */ "./node_modules/react/index.js");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_2__);
/**
 * Copyright (c) 2019 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */



function legendFor(legend) {
    switch (legend.kind) {
        case 'scale-legend': return ScaleLegend;
        case 'table-legend': return TableLegend;
        default:
            var _ = legend;
            console.warn(_ + " has no associated UI component");
            return void 0;
    }
}
var ScaleLegend = /** @class */ (function (_super) {
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__extends"])(ScaleLegend, _super);
    function ScaleLegend() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ScaleLegend.prototype.render = function () {
        var legend = this.props.legend;
        var colors = legend.colors.map(function (c) { return Array.isArray(c) ? _mol_util_color__WEBPACK_IMPORTED_MODULE_1__["Color"].toStyle(c[0]) + " " + 100 * c[1] + "%" : _mol_util_color__WEBPACK_IMPORTED_MODULE_1__["Color"].toStyle(c); }).join(', ');
        return react__WEBPACK_IMPORTED_MODULE_2__["createElement"]("div", { className: 'msp-scale-legend' },
            react__WEBPACK_IMPORTED_MODULE_2__["createElement"]("div", { style: { background: "linear-gradient(to right, " + colors + ")" } },
                react__WEBPACK_IMPORTED_MODULE_2__["createElement"]("span", { style: { float: 'left' } }, legend.minLabel),
                react__WEBPACK_IMPORTED_MODULE_2__["createElement"]("span", { style: { float: 'right' } }, legend.maxLabel)));
    };
    return ScaleLegend;
}(react__WEBPACK_IMPORTED_MODULE_2__["PureComponent"]));

var TableLegend = /** @class */ (function (_super) {
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__extends"])(TableLegend, _super);
    function TableLegend() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    TableLegend.prototype.render = function () {
        var legend = this.props.legend;
        return react__WEBPACK_IMPORTED_MODULE_2__["createElement"]("div", { className: 'msp-table-legend' }, legend.table.map(function (value, i) {
            var name = value[0], color = value[1];
            return react__WEBPACK_IMPORTED_MODULE_2__["createElement"]("div", { key: i },
                react__WEBPACK_IMPORTED_MODULE_2__["createElement"]("div", { className: 'msp-table-legend-color', style: { backgroundColor: _mol_util_color__WEBPACK_IMPORTED_MODULE_1__["Color"].toStyle(color) } }),
                react__WEBPACK_IMPORTED_MODULE_2__["createElement"]("div", { className: 'msp-table-legend-text' }, name));
        }));
    };
    return TableLegend;
}(react__WEBPACK_IMPORTED_MODULE_2__["PureComponent"]));

//# sourceMappingURL=legend.js.map

/***/ }),

/***/ "./lib/mol-plugin-ui/controls/line-graph/line-graph-component.js":
/*!***********************************************************************!*\
  !*** ./lib/mol-plugin-ui/controls/line-graph/line-graph-component.js ***!
  \***********************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _point_component__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./point-component */ "./lib/mol-plugin-ui/controls/line-graph/point-component.js");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! react */ "./node_modules/react/index.js");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../../mol-math/linear-algebra */ "./lib/mol-math/linear-algebra.js");

/**
 * Copyright (c) 2018 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author Paul Luna <paulluna0215@gmail.com>
 */



var LineGraphComponent = /** @class */ (function (_super) {
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__extends"])(LineGraphComponent, _super);
    function LineGraphComponent(props) {
        var _this = _super.call(this, props) || this;
        _this.handleKeyDown = function (event) {
            // TODO: set canSelectMultiple = true
        };
        _this.handleKeyUp = function (event) {
            // TODO: SET canSelectMultiple = fasle
        };
        _this.handleClick = function (id) { return function (event) {
            // TODO: add point to selected array
        }; };
        _this.handleMouseDown = function (id) { return function (event) {
            if (id === 0 || id === _this.state.points.length - 1) {
                return;
            }
            if (_this.state.canSelectMultiple) {
                return;
            }
            var copyPoint = _this.normalizePoint(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_3__["Vec2"].create(_this.state.points[id][0], _this.state.points[id][1]));
            _this.ghostPoints.push(document.createElementNS(_this.namespace, 'circle'));
            _this.ghostPoints[0].setAttribute('r', '10');
            _this.ghostPoints[0].setAttribute('fill', 'orange');
            _this.ghostPoints[0].setAttribute('cx', "" + copyPoint[0]);
            _this.ghostPoints[0].setAttribute('cy', "" + copyPoint[1]);
            _this.ghostPoints[0].setAttribute('style', 'display: none');
            _this.gElement.appendChild(_this.ghostPoints[0]);
            _this.updatedX = copyPoint[0];
            _this.updatedY = copyPoint[1];
            _this.selected = [id];
        }; };
        _this.deletePoint = function (i) { return function (event) {
            if (i === 0 || i === _this.state.points.length - 1) {
                return;
            }
            var points = _this.state.points.filter(function (_, j) { return j !== i; });
            points.sort(function (a, b) {
                if (a[0] === b[0]) {
                    if (a[0] === 0) {
                        return a[1] - b[1];
                    }
                    if (a[1] === 1) {
                        return b[1] - a[1];
                    }
                    return a[1] - b[1];
                }
                return a[0] - b[0];
            });
            _this.setState({ points: points });
            _this.change(points);
            event.stopPropagation();
        }; };
        _this.myRef = react__WEBPACK_IMPORTED_MODULE_2__["createRef"]();
        _this.state = {
            points: [
                _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_3__["Vec2"].create(0, 0),
                _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_3__["Vec2"].create(1, 0)
            ],
            copyPoint: undefined,
            canSelectMultiple: false,
        };
        _this.height = 400;
        _this.width = 600;
        _this.padding = 70;
        _this.selected = undefined;
        _this.ghostPoints = [];
        _this.namespace = 'http://www.w3.org/2000/svg';
        for (var _i = 0, _a = _this.props.data; _i < _a.length; _i++) {
            var point = _a[_i];
            _this.state.points.push(point);
        }
        _this.state.points.sort(function (a, b) {
            if (a[0] === b[0]) {
                if (a[0] === 0) {
                    return a[1] - b[1];
                }
                if (a[1] === 1) {
                    return b[1] - a[1];
                }
                return a[1] - b[1];
            }
            return a[0] - b[0];
        });
        _this.handleDrag = _this.handleDrag.bind(_this);
        _this.handleMultipleDrag = _this.handleMultipleDrag.bind(_this);
        _this.handleDoubleClick = _this.handleDoubleClick.bind(_this);
        _this.refCallBack = _this.refCallBack.bind(_this);
        _this.handlePointUpdate = _this.handlePointUpdate.bind(_this);
        _this.change = _this.change.bind(_this);
        _this.handleKeyUp = _this.handleKeyUp.bind(_this);
        _this.handleLeave = _this.handleLeave.bind(_this);
        _this.handleEnter = _this.handleEnter.bind(_this);
        return _this;
    }
    LineGraphComponent.prototype.render = function () {
        var points = this.renderPoints();
        var lines = this.renderLines();
        return ([
            react__WEBPACK_IMPORTED_MODULE_2__["createElement"]("div", { key: "LineGraph" },
                react__WEBPACK_IMPORTED_MODULE_2__["createElement"]("svg", { className: "msp-canvas", ref: this.refCallBack, viewBox: "0 0 " + (this.width + this.padding) + " " + (this.height + this.padding), onMouseMove: this.handleDrag, onMouseUp: this.handlePointUpdate, onMouseLeave: this.handleLeave, onMouseEnter: this.handleEnter, tabIndex: 0, onKeyDown: this.handleKeyDown, onKeyUp: this.handleKeyUp, onDoubleClick: this.handleDoubleClick },
                    react__WEBPACK_IMPORTED_MODULE_2__["createElement"]("g", { stroke: "black", fill: "black" },
                        lines,
                        points),
                    react__WEBPACK_IMPORTED_MODULE_2__["createElement"]("g", { className: "ghost-points", stroke: "black", fill: "black" }))),
            react__WEBPACK_IMPORTED_MODULE_2__["createElement"]("div", { key: "modal", id: "modal-root" })
        ]);
    };
    LineGraphComponent.prototype.componentDidMount = function () {
        this.gElement = document.getElementsByClassName('ghost-points')[0];
    };
    LineGraphComponent.prototype.change = function (points) {
        var copyPoints = points.slice();
        copyPoints.shift();
        copyPoints.pop();
        this.props.onChange(copyPoints);
    };
    LineGraphComponent.prototype.handleDrag = function (event) {
        if (this.selected === undefined) {
            return;
        }
        var pt = this.myRef.createSVGPoint();
        var updatedCopyPoint;
        var padding = this.padding / 2;
        pt.x = event.clientX;
        pt.y = event.clientY;
        var svgP = pt.matrixTransform(this.myRef.getScreenCTM().inverse());
        updatedCopyPoint = _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_3__["Vec2"].create(svgP.x, svgP.y);
        if ((svgP.x < (padding) || svgP.x > (this.width + (padding))) && (svgP.y > (this.height + (padding)) || svgP.y < (padding))) {
            updatedCopyPoint = _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_3__["Vec2"].create(this.updatedX, this.updatedY);
        }
        else if (svgP.x < padding) {
            updatedCopyPoint = _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_3__["Vec2"].create(padding, svgP.y);
        }
        else if (svgP.x > (this.width + (padding))) {
            updatedCopyPoint = _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_3__["Vec2"].create(this.width + padding, svgP.y);
        }
        else if (svgP.y > (this.height + (padding))) {
            updatedCopyPoint = _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_3__["Vec2"].create(svgP.x, this.height + padding);
        }
        else if (svgP.y < (padding)) {
            updatedCopyPoint = _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_3__["Vec2"].create(svgP.x, padding);
        }
        else {
            updatedCopyPoint = _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_3__["Vec2"].create(svgP.x, svgP.y);
        }
        this.updatedX = updatedCopyPoint[0];
        this.updatedY = updatedCopyPoint[1];
        var unNormalizePoint = this.unNormalizePoint(updatedCopyPoint);
        this.ghostPoints[0].setAttribute('style', 'display: visible');
        this.ghostPoints[0].setAttribute('cx', "" + updatedCopyPoint[0]);
        this.ghostPoints[0].setAttribute('cy', "" + updatedCopyPoint[1]);
        this.props.onDrag(unNormalizePoint);
    };
    LineGraphComponent.prototype.handleMultipleDrag = function () {
        // TODO
    };
    LineGraphComponent.prototype.handlePointUpdate = function (event) {
        var selected = this.selected;
        if (this.state.canSelectMultiple) {
            return;
        }
        if (selected === undefined || selected[0] === 0 || selected[0] === this.state.points.length - 1) {
            this.setState({
                copyPoint: undefined,
            });
            return;
        }
        this.selected = undefined;
        var updatedPoint = this.unNormalizePoint(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_3__["Vec2"].create(this.updatedX, this.updatedY));
        var points = this.state.points.filter(function (_, i) { return i !== selected[0]; });
        points.push(updatedPoint);
        ;
        points.sort(function (a, b) {
            if (a[0] === b[0]) {
                if (a[0] === 0) {
                    return a[1] - b[1];
                }
                if (a[1] === 1) {
                    return b[1] - a[1];
                }
                return a[1] - b[1];
            }
            return a[0] - b[0];
        });
        this.setState({
            points: points,
        });
        this.change(points);
        this.gElement.innerHTML = '';
        this.ghostPoints = [];
        document.removeEventListener('mousemove', this.handleDrag, true);
        document.removeEventListener('mouseup', this.handlePointUpdate, true);
    };
    LineGraphComponent.prototype.handleDoubleClick = function (event) {
        var newPoint;
        var pt = this.myRef.createSVGPoint();
        pt.x = event.clientX;
        pt.y = event.clientY;
        var svgP = pt.matrixTransform(this.myRef.getScreenCTM().inverse());
        var points = this.state.points;
        var padding = this.padding / 2;
        if (svgP.x < (padding) ||
            svgP.x > (this.width + (padding)) ||
            svgP.y > (this.height + (padding)) ||
            svgP.y < (this.padding / 2)) {
            return;
        }
        newPoint = this.unNormalizePoint(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_3__["Vec2"].create(svgP.x, svgP.y));
        points.push(newPoint);
        points.sort(function (a, b) {
            if (a[0] === b[0]) {
                if (a[0] === 0) {
                    return a[1] - b[1];
                }
                if (a[1] === 1) {
                    return b[1] - a[1];
                }
                return a[1] - b[1];
            }
            return a[0] - b[0];
        });
        this.setState({ points: points });
        this.change(points);
    };
    LineGraphComponent.prototype.handleLeave = function () {
        if (this.selected === undefined) {
            return;
        }
        document.addEventListener('mousemove', this.handleDrag, true);
        document.addEventListener('mouseup', this.handlePointUpdate, true);
    };
    LineGraphComponent.prototype.handleEnter = function () {
        document.removeEventListener('mousemove', this.handleDrag, true);
        document.removeEventListener('mouseup', this.handlePointUpdate, true);
    };
    LineGraphComponent.prototype.normalizePoint = function (point) {
        var min = this.padding / 2;
        var maxX = this.width + min;
        var maxY = this.height + min;
        var normalizedX = (point[0] * (maxX - min)) + min;
        var normalizedY = (point[1] * (maxY - min)) + min;
        var reverseY = (this.height + this.padding) - normalizedY;
        var newPoint = _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_3__["Vec2"].create(normalizedX, reverseY);
        return newPoint;
    };
    LineGraphComponent.prototype.unNormalizePoint = function (point) {
        var min = this.padding / 2;
        var maxX = this.width + min;
        var maxY = this.height + min;
        var unNormalizedX = (point[0] - min) / (maxX - min);
        // we have to take into account that we reversed y when we first normalized it.
        var unNormalizedY = ((this.height + this.padding) - point[1] - min) / (maxY - min);
        return _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_3__["Vec2"].create(unNormalizedX, unNormalizedY);
    };
    LineGraphComponent.prototype.refCallBack = function (element) {
        if (element) {
            this.myRef = element;
        }
    };
    LineGraphComponent.prototype.renderPoints = function () {
        var points = [];
        var point;
        for (var i = 0; i < this.state.points.length; i++) {
            if (i !== 0 && i !== this.state.points.length - 1) {
                point = this.normalizePoint(this.state.points[i]);
                points.push(react__WEBPACK_IMPORTED_MODULE_2__["createElement"](_point_component__WEBPACK_IMPORTED_MODULE_1__["default"], { key: i, id: i, x: point[0], y: point[1], nX: this.state.points[i][0], nY: this.state.points[i][1], selected: false, delete: this.deletePoint, onmouseover: this.props.onHover, onmousedown: this.handleMouseDown(i), onclick: this.handleClick(i) }));
            }
        }
        return points;
    };
    LineGraphComponent.prototype.renderLines = function () {
        var points = [];
        var lines = [];
        var min;
        var maxX;
        var maxY;
        var normalizedX;
        var normalizedY;
        var reverseY;
        for (var _i = 0, _a = this.state.points; _i < _a.length; _i++) {
            var point = _a[_i];
            min = this.padding / 2;
            maxX = this.width + min;
            maxY = this.height + min;
            normalizedX = (point[0] * (maxX - min)) + min;
            normalizedY = (point[1] * (maxY - min)) + min;
            reverseY = this.height + this.padding - normalizedY;
            points.push(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_3__["Vec2"].create(normalizedX, reverseY));
        }
        var data = points;
        var size = data.length;
        for (var i = 0; i < size - 1; i++) {
            var x1 = data[i][0];
            var y1 = data[i][1];
            var x2 = data[i + 1][0];
            var y2 = data[i + 1][1];
            lines.push(react__WEBPACK_IMPORTED_MODULE_2__["createElement"]("line", { key: "lineOf" + i, x1: x1, x2: x2, y1: y1, y2: y2, stroke: "#cec9ba", strokeWidth: "5" }));
        }
        return lines;
    };
    return LineGraphComponent;
}(react__WEBPACK_IMPORTED_MODULE_2__["Component"]));
/* harmony default export */ __webpack_exports__["default"] = (LineGraphComponent);
//# sourceMappingURL=line-graph-component.js.map

/***/ }),

/***/ "./lib/mol-plugin-ui/controls/line-graph/point-component.js":
/*!******************************************************************!*\
  !*** ./lib/mol-plugin-ui/controls/line-graph/point-component.js ***!
  \******************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! react */ "./node_modules/react/index.js");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../../mol-math/linear-algebra */ "./lib/mol-math/linear-algebra.js");



var PointComponent = /** @class */ (function (_super) {
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__extends"])(PointComponent, _super);
    function PointComponent(props) {
        var _this = _super.call(this, props) || this;
        _this.state = { show: false };
        _this.handleHover = _this.handleHover.bind(_this);
        _this.handleHoverOff = _this.handleHoverOff.bind(_this);
        _this.deletePoint = _this.deletePoint.bind(_this);
        return _this;
    }
    PointComponent.prototype.handleHover = function () {
        this.setState({ show: true });
        var point = _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_2__["Vec2"].create(this.props.nX, this.props.nY);
        this.props.onmouseover(point);
    };
    PointComponent.prototype.handleHoverOff = function () {
        this.setState({ show: false });
        this.props.onmouseover(undefined);
    };
    PointComponent.prototype.deletePoint = function () {
        this.props.delete(this.props.id);
    };
    PointComponent.prototype.render = function () {
        return ([
            react__WEBPACK_IMPORTED_MODULE_1__["createElement"]("circle", { r: "10", key: this.props.id + "circle", id: "" + this.props.id, cx: this.props.x, cy: this.props.y, onClick: this.props.onclick, onDoubleClick: this.props.delete(this.props.id), onMouseEnter: this.handleHover, onMouseLeave: this.handleHoverOff, onMouseDown: this.props.onmousedown, fill: "black" })
        ]);
    };
    return PointComponent;
}(react__WEBPACK_IMPORTED_MODULE_1__["Component"]));
/* harmony default export */ __webpack_exports__["default"] = (PointComponent);
//# sourceMappingURL=point-component.js.map

/***/ }),

/***/ "./lib/mol-plugin-ui/controls/parameters.js":
/*!**************************************************!*\
  !*** ./lib/mol-plugin-ui/controls/parameters.js ***!
  \**************************************************/
/*! exports provided: ParameterControls, ParameterMappingControl, ParamHelp, SimpleParam, BoolControl, LineGraphControl, NumberInputControl, NumberRangeControl, TextControl, PureSelectControl, SelectControl, ValueRefControl, IntervalControl, BoundedIntervalControl, ColorControl, ColorListControl, OffsetColorListControl, Vec3Control, Mat4Control, UrlControl, FileControl, FileListControl, MultiSelectControl, GroupControl, MappedControl, ObjectListControl, ConditionedControl, ConvertedControl, ScriptControl */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ParameterControls", function() { return ParameterControls; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ParameterMappingControl", function() { return ParameterMappingControl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ParamHelp", function() { return ParamHelp; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SimpleParam", function() { return SimpleParam; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "BoolControl", function() { return BoolControl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "LineGraphControl", function() { return LineGraphControl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "NumberInputControl", function() { return NumberInputControl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "NumberRangeControl", function() { return NumberRangeControl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "TextControl", function() { return TextControl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "PureSelectControl", function() { return PureSelectControl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SelectControl", function() { return SelectControl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ValueRefControl", function() { return ValueRefControl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "IntervalControl", function() { return IntervalControl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "BoundedIntervalControl", function() { return BoundedIntervalControl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ColorControl", function() { return ColorControl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ColorListControl", function() { return ColorListControl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "OffsetColorListControl", function() { return OffsetColorListControl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Vec3Control", function() { return Vec3Control; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Mat4Control", function() { return Mat4Control; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "UrlControl", function() { return UrlControl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FileControl", function() { return FileControl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FileListControl", function() { return FileListControl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MultiSelectControl", function() { return MultiSelectControl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "GroupControl", function() { return GroupControl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MappedControl", function() { return MappedControl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ObjectListControl", function() { return ObjectListControl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ConditionedControl", function() { return ConditionedControl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ConvertedControl", function() { return ConvertedControl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ScriptControl", function() { return ScriptControl; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! react */ "./node_modules/react/index.js");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../mol-math/linear-algebra */ "./lib/mol-math/linear-algebra.js");
/* harmony import */ var _mol_util_color__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../mol-util/color */ "./lib/mol-util/color/index.js");
/* harmony import */ var _mol_util_color_lists__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../mol-util/color/lists */ "./lib/mol-util/color/lists.js");
/* harmony import */ var _mol_util_memoize__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../mol-util/memoize */ "./lib/mol-util/memoize.js");
/* harmony import */ var _mol_util_number__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../../mol-util/number */ "./lib/mol-util/number.js");
/* harmony import */ var _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../../mol-util/param-definition */ "./lib/mol-util/param-definition.js");
/* harmony import */ var _mol_util_string__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ../../mol-util/string */ "./lib/mol-util/string.js");
/* harmony import */ var _base__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ../base */ "./lib/mol-plugin-ui/base.js");
/* harmony import */ var _action_menu__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ./action-menu */ "./lib/mol-plugin-ui/controls/action-menu.js");
/* harmony import */ var _color__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ./color */ "./lib/mol-plugin-ui/controls/color.js");
/* harmony import */ var _common__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! ./common */ "./lib/mol-plugin-ui/controls/common.js");
/* harmony import */ var _icons__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! ./icons */ "./lib/mol-plugin-ui/controls/icons.js");
/* harmony import */ var _legend__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! ./legend */ "./lib/mol-plugin-ui/controls/legend.js");
/* harmony import */ var _line_graph_line_graph_component__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! ./line-graph/line-graph-component */ "./lib/mol-plugin-ui/controls/line-graph/line-graph-component.js");
/* harmony import */ var _slider__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(/*! ./slider */ "./lib/mol-plugin-ui/controls/slider.js");
/* harmony import */ var _mol_util_assets__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(/*! ../../mol-util/assets */ "./lib/mol-util/assets.js");
/**
 * Copyright (c) 2018-2020 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author David Sehnal <david.sehnal@gmail.com>
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */


















var ParameterControls = /** @class */ (function (_super) {
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__extends"])(ParameterControls, _super);
    function ParameterControls() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.onChange = function (params) {
            var _a;
            var _b, _c;
            (_c = (_b = _this.props).onChange) === null || _c === void 0 ? void 0 : _c.call(_b, params, _this.props.values);
            if (_this.props.onChangeValues) {
                var values = Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, _this.props.values), (_a = {}, _a[params.name] = params.value, _a));
                _this.props.onChangeValues(values, _this.props.values);
            }
        };
        _this.paramGroups = Object(_mol_util_memoize__WEBPACK_IMPORTED_MODULE_5__["memoizeLatest"])(function (params) { return classifyParams(params); });
        return _this;
    }
    ParameterControls.prototype.renderGroup = function (group) {
        var _a;
        if (group.length === 0)
            return null;
        var values = this.props.values;
        var ctrls = null;
        var category = void 0;
        for (var _i = 0, group_1 = group; _i < group_1.length; _i++) {
            var _b = group_1[_i], key = _b[0], p = _b[1], Control = _b[2];
            if ((_a = p.hideIf) === null || _a === void 0 ? void 0 : _a.call(p, values))
                continue;
            if (!ctrls)
                ctrls = [];
            category = p.category;
            ctrls.push(react__WEBPACK_IMPORTED_MODULE_1__["createElement"](Control, { param: p, key: key, onChange: this.onChange, onEnter: this.props.onEnter, isDisabled: this.props.isDisabled, name: key, value: values[key] }));
        }
        if (!ctrls)
            return null;
        if (category) {
            return [react__WEBPACK_IMPORTED_MODULE_1__["createElement"](_common__WEBPACK_IMPORTED_MODULE_12__["ExpandGroup"], { key: category, header: category }, ctrls)];
        }
        return ctrls;
    };
    ParameterControls.prototype.renderPart = function (groups) {
        var parts = null;
        for (var _i = 0, groups_1 = groups; _i < groups_1.length; _i++) {
            var g = groups_1[_i];
            var ctrls = this.renderGroup(g);
            if (!ctrls)
                continue;
            if (!parts)
                parts = [];
            for (var _a = 0, ctrls_1 = ctrls; _a < ctrls_1.length; _a++) {
                var c = ctrls_1[_a];
                parts.push(c);
            }
        }
        return parts;
    };
    ParameterControls.prototype.render = function () {
        var groups = this.paramGroups(this.props.params);
        var essentials = this.renderPart(groups.essentials);
        var advanced = this.renderPart(groups.advanced);
        if (essentials && advanced) {
            return react__WEBPACK_IMPORTED_MODULE_1__["createElement"](react__WEBPACK_IMPORTED_MODULE_1__["Fragment"], null,
                essentials,
                react__WEBPACK_IMPORTED_MODULE_1__["createElement"](_common__WEBPACK_IMPORTED_MODULE_12__["ExpandGroup"], { header: 'Advanced Options' }, advanced));
        }
        else if (essentials) {
            return essentials;
        }
        else {
            return advanced;
        }
    };
    return ParameterControls;
}(react__WEBPACK_IMPORTED_MODULE_1__["PureComponent"]));

var ParameterMappingControl = /** @class */ (function (_super) {
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__extends"])(ParameterMappingControl, _super);
    function ParameterMappingControl() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.setSettings = function (p, old) {
            var _a;
            var values = Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, old), (_a = {}, _a[p.name] = p.value, _a));
            var t = _this.props.mapping.update(values, _this.plugin);
            _this.props.mapping.apply(t, _this.plugin);
        };
        return _this;
    }
    ParameterMappingControl.prototype.componentDidMount = function () {
        var _this = this;
        this.subscribe(this.plugin.events.canvas3d.settingsUpdated, function () { return _this.forceUpdate(); });
    };
    ParameterMappingControl.prototype.render = function () {
        var t = this.props.mapping.getTarget(this.plugin);
        var values = this.props.mapping.getValues(t, this.plugin);
        var params = this.props.mapping.params(this.plugin);
        return react__WEBPACK_IMPORTED_MODULE_1__["createElement"](ParameterControls, { params: params, values: values, onChange: this.setSettings });
    };
    return ParameterMappingControl;
}(_base__WEBPACK_IMPORTED_MODULE_9__["PluginUIComponent"]));

function classifyParams(params) {
    function addParam(k, p, group) {
        var ctrl = controlFor(p);
        if (!ctrl)
            return;
        if (!p.category)
            group.params[0].push([k, p, ctrl]);
        else {
            if (!group.map)
                group.map = new Map();
            var c = group.map.get(p.category);
            if (!c) {
                c = [];
                group.map.set(p.category, c);
                group.params.push(c);
            }
            c.push([k, p, ctrl]);
        }
    }
    function sortGroups(x, y) {
        var a = x[0], b = y[0];
        if (!a || !a[1].category)
            return -1;
        if (!b || !b[1].category)
            return 1;
        return a[1].category < b[1].category ? -1 : 1;
    }
    var keys = Object.keys(params);
    var essentials = { params: [[]], map: void 0 };
    var advanced = { params: [[]], map: void 0 };
    for (var _i = 0, keys_1 = keys; _i < keys_1.length; _i++) {
        var k = keys_1[_i];
        var p = params[k];
        if (p.isHidden)
            continue;
        if (p.isEssential)
            addParam(k, p, essentials);
        else
            addParam(k, p, advanced);
    }
    essentials.params.sort(sortGroups);
    advanced.params.sort(sortGroups);
    return { essentials: essentials.params, advanced: advanced.params };
}
function controlFor(param) {
    switch (param.type) {
        case 'value': return void 0;
        case 'boolean': return BoolControl;
        case 'number': return typeof param.min !== 'undefined' && typeof param.max !== 'undefined'
            ? NumberRangeControl : NumberInputControl;
        case 'converted': return ConvertedControl;
        case 'conditioned': return ConditionedControl;
        case 'multi-select': return MultiSelectControl;
        case 'color': return _color__WEBPACK_IMPORTED_MODULE_11__["CombinedColorControl"];
        case 'color-list': return param.offsets ? OffsetColorListControl : ColorListControl;
        case 'vec3': return Vec3Control;
        case 'mat4': return Mat4Control;
        case 'url': return UrlControl;
        case 'file': return FileControl;
        case 'file-list': return FileListControl;
        case 'select': return SelectControl;
        case 'value-ref': return ValueRefControl;
        case 'data-ref': return void 0;
        case 'text': return TextControl;
        case 'interval': return typeof param.min !== 'undefined' && typeof param.max !== 'undefined'
            ? BoundedIntervalControl : IntervalControl;
        case 'group': return GroupControl;
        case 'mapped': return MappedControl;
        case 'line-graph': return LineGraphControl;
        case 'script': return ScriptControl;
        case 'object-list': return ObjectListControl;
        default:
            var _ = param;
            console.warn(_ + " has no associated UI component");
            return void 0;
    }
}
var ParamHelp = /** @class */ (function (_super) {
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__extends"])(ParamHelp, _super);
    function ParamHelp() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ParamHelp.prototype.render = function () {
        var _a = this.props, legend = _a.legend, description = _a.description;
        var Legend = legend && Object(_legend__WEBPACK_IMPORTED_MODULE_14__["legendFor"])(legend);
        return react__WEBPACK_IMPORTED_MODULE_1__["createElement"]("div", { className: 'msp-help-text' },
            react__WEBPACK_IMPORTED_MODULE_1__["createElement"]("div", null,
                react__WEBPACK_IMPORTED_MODULE_1__["createElement"]("div", { className: 'msp-help-description' },
                    react__WEBPACK_IMPORTED_MODULE_1__["createElement"](_icons__WEBPACK_IMPORTED_MODULE_13__["Icon"], { svg: _icons__WEBPACK_IMPORTED_MODULE_13__["HelpOutlineSvg"], inline: true }),
                    description),
                Legend && react__WEBPACK_IMPORTED_MODULE_1__["createElement"]("div", { className: 'msp-help-legend' },
                    react__WEBPACK_IMPORTED_MODULE_1__["createElement"](Legend, { legend: legend }))));
    };
    return ParamHelp;
}(react__WEBPACK_IMPORTED_MODULE_1__["PureComponent"]));

function renderSimple(options) {
    var props = options.props, state = options.state, control = options.control, toggleHelp = options.toggleHelp, addOn = options.addOn;
    var _className = [];
    if (props.param.shortLabel)
        _className.push('msp-control-label-short');
    if (props.param.twoColumns)
        _className.push('msp-control-col-2');
    var className = _className.join(' ');
    var label = props.param.label || Object(_mol_util_string__WEBPACK_IMPORTED_MODULE_8__["camelCaseToWords"])(props.name);
    var help = props.param.help
        ? props.param.help(props.value)
        : { description: props.param.description, legend: props.param.legend };
    var desc = props.param.description;
    var hasHelp = help.description || help.legend;
    return react__WEBPACK_IMPORTED_MODULE_1__["createElement"](react__WEBPACK_IMPORTED_MODULE_1__["Fragment"], null,
        react__WEBPACK_IMPORTED_MODULE_1__["createElement"](_common__WEBPACK_IMPORTED_MODULE_12__["ControlRow"], { className: className, title: desc, label: react__WEBPACK_IMPORTED_MODULE_1__["createElement"](react__WEBPACK_IMPORTED_MODULE_1__["Fragment"], null,
                label,
                hasHelp &&
                    react__WEBPACK_IMPORTED_MODULE_1__["createElement"]("button", { className: 'msp-help msp-btn-link msp-btn-icon msp-control-group-expander', onClick: toggleHelp, title: desc || (state.showHelp ? 'Hide' : 'Show') + " help", style: { background: 'transparent', textAlign: 'left', padding: '0' } },
                        react__WEBPACK_IMPORTED_MODULE_1__["createElement"](_icons__WEBPACK_IMPORTED_MODULE_13__["Icon"], { svg: _icons__WEBPACK_IMPORTED_MODULE_13__["HelpOutlineSvg"] }))), control: control }),
        hasHelp && state.showHelp && react__WEBPACK_IMPORTED_MODULE_1__["createElement"]("div", { className: 'msp-control-offset' },
            react__WEBPACK_IMPORTED_MODULE_1__["createElement"](ParamHelp, { legend: help.legend, description: help.description })),
        addOn);
}
var SimpleParam = /** @class */ (function (_super) {
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__extends"])(SimpleParam, _super);
    function SimpleParam() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = { showHelp: false };
        _this.toggleHelp = function () { return _this.setState({ showHelp: !_this.state.showHelp }); };
        return _this;
    }
    SimpleParam.prototype.update = function (value) {
        this.props.onChange({ param: this.props.param, name: this.props.name, value: value });
    };
    SimpleParam.prototype.renderAddOn = function () { return null; };
    SimpleParam.prototype.render = function () {
        return renderSimple({
            props: this.props,
            state: this.state,
            control: this.renderControl(),
            toggleHelp: this.toggleHelp,
            addOn: this.renderAddOn()
        });
    };
    return SimpleParam;
}(react__WEBPACK_IMPORTED_MODULE_1__["PureComponent"]));

var BoolControl = /** @class */ (function (_super) {
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__extends"])(BoolControl, _super);
    function BoolControl() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.onClick = function (e) { _this.update(!_this.props.value); e.currentTarget.blur(); };
        return _this;
    }
    BoolControl.prototype.renderControl = function () {
        return react__WEBPACK_IMPORTED_MODULE_1__["createElement"]("button", { onClick: this.onClick, disabled: this.props.isDisabled },
            react__WEBPACK_IMPORTED_MODULE_1__["createElement"](_icons__WEBPACK_IMPORTED_MODULE_13__["Icon"], { svg: this.props.value ? _icons__WEBPACK_IMPORTED_MODULE_13__["CheckSvg"] : _icons__WEBPACK_IMPORTED_MODULE_13__["ClearSvg"] }),
            this.props.value ? 'On' : 'Off');
    };
    return BoolControl;
}(SimpleParam));

var LineGraphControl = /** @class */ (function (_super) {
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__extends"])(LineGraphControl, _super);
    function LineGraphControl() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            isExpanded: false,
            isOverPoint: false,
            message: _this.props.param.defaultValue.length + " points",
        };
        _this.onHover = function (point) {
            _this.setState({ isOverPoint: !_this.state.isOverPoint });
            if (point) {
                _this.setState({ message: "(" + point[0].toFixed(2) + ", " + point[1].toFixed(2) + ")" });
                return;
            }
            _this.setState({ message: _this.props.value.length + " points" });
        };
        _this.onDrag = function (point) {
            _this.setState({ message: "(" + point[0].toFixed(2) + ", " + point[1].toFixed(2) + ")" });
        };
        _this.onChange = function (value) {
            _this.props.onChange({ name: _this.props.name, param: _this.props.param, value: value });
        };
        _this.toggleExpanded = function (e) {
            _this.setState({ isExpanded: !_this.state.isExpanded });
            e.currentTarget.blur();
        };
        return _this;
    }
    LineGraphControl.prototype.render = function () {
        var label = this.props.param.label || Object(_mol_util_string__WEBPACK_IMPORTED_MODULE_8__["camelCaseToWords"])(this.props.name);
        return react__WEBPACK_IMPORTED_MODULE_1__["createElement"](react__WEBPACK_IMPORTED_MODULE_1__["Fragment"], null,
            react__WEBPACK_IMPORTED_MODULE_1__["createElement"](_common__WEBPACK_IMPORTED_MODULE_12__["ControlRow"], { label: label, control: react__WEBPACK_IMPORTED_MODULE_1__["createElement"]("button", { onClick: this.toggleExpanded, disabled: this.props.isDisabled }, "" + this.state.message) }),
            react__WEBPACK_IMPORTED_MODULE_1__["createElement"]("div", { className: 'msp-control-offset', style: { display: this.state.isExpanded ? 'block' : 'none' } },
                react__WEBPACK_IMPORTED_MODULE_1__["createElement"](_line_graph_line_graph_component__WEBPACK_IMPORTED_MODULE_15__["default"], { data: this.props.param.defaultValue, onChange: this.onChange, onHover: this.onHover, onDrag: this.onDrag })));
    };
    return LineGraphControl;
}(react__WEBPACK_IMPORTED_MODULE_1__["PureComponent"]));

var NumberInputControl = /** @class */ (function (_super) {
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__extends"])(NumberInputControl, _super);
    function NumberInputControl() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = { value: '0' };
        _this.update = function (value) {
            var p = Object(_mol_util_number__WEBPACK_IMPORTED_MODULE_6__["getPrecision"])(_this.props.param.step || 0.01);
            value = parseFloat(value.toFixed(p));
            _this.props.onChange({ param: _this.props.param, name: _this.props.name, value: value });
        };
        return _this;
    }
    NumberInputControl.prototype.render = function () {
        var placeholder = this.props.param.label || Object(_mol_util_string__WEBPACK_IMPORTED_MODULE_8__["camelCaseToWords"])(this.props.name);
        var label = this.props.param.label || Object(_mol_util_string__WEBPACK_IMPORTED_MODULE_8__["camelCaseToWords"])(this.props.name);
        var p = Object(_mol_util_number__WEBPACK_IMPORTED_MODULE_6__["getPrecision"])(this.props.param.step || 0.01);
        return react__WEBPACK_IMPORTED_MODULE_1__["createElement"](_common__WEBPACK_IMPORTED_MODULE_12__["ControlRow"], { title: this.props.param.description, label: label, control: react__WEBPACK_IMPORTED_MODULE_1__["createElement"](_common__WEBPACK_IMPORTED_MODULE_12__["TextInput"], { numeric: true, value: parseFloat(this.props.value.toFixed(p)), onEnter: this.props.onEnter, placeholder: placeholder, isDisabled: this.props.isDisabled, onChange: this.update }) });
    };
    return NumberInputControl;
}(react__WEBPACK_IMPORTED_MODULE_1__["PureComponent"]));

var NumberRangeControl = /** @class */ (function (_super) {
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__extends"])(NumberRangeControl, _super);
    function NumberRangeControl() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.onChange = function (v) { _this.update(v); };
        return _this;
    }
    NumberRangeControl.prototype.renderControl = function () {
        var value = typeof this.props.value === 'undefined' ? this.props.param.defaultValue : this.props.value;
        return react__WEBPACK_IMPORTED_MODULE_1__["createElement"](_slider__WEBPACK_IMPORTED_MODULE_16__["Slider"], { value: value, min: this.props.param.min, max: this.props.param.max, step: this.props.param.step, onChange: this.onChange, onChangeImmediate: this.props.param.immediateUpdate ? this.onChange : void 0, disabled: this.props.isDisabled, onEnter: this.props.onEnter });
    };
    return NumberRangeControl;
}(SimpleParam));

var TextControl = /** @class */ (function (_super) {
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__extends"])(TextControl, _super);
    function TextControl() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.onChange = function (e) {
            var value = e.target.value;
            if (value !== _this.props.value) {
                _this.update(value);
            }
        };
        _this.onKeyPress = function (e) {
            if ((e.keyCode === 13 || e.charCode === 13 || e.key === 'Enter')) {
                if (_this.props.onEnter)
                    _this.props.onEnter();
            }
            e.stopPropagation();
        };
        return _this;
    }
    TextControl.prototype.renderControl = function () {
        var placeholder = this.props.param.label || Object(_mol_util_string__WEBPACK_IMPORTED_MODULE_8__["camelCaseToWords"])(this.props.name);
        return react__WEBPACK_IMPORTED_MODULE_1__["createElement"]("input", { type: 'text', value: this.props.value || '', placeholder: placeholder, onChange: this.onChange, onKeyPress: this.props.onEnter ? this.onKeyPress : void 0, disabled: this.props.isDisabled });
    };
    return TextControl;
}(SimpleParam));

var PureSelectControl = /** @class */ (function (_super) {
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__extends"])(PureSelectControl, _super);
    function PureSelectControl() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.onChange = function (e) {
            if (typeof _this.props.param.defaultValue === 'number') {
                _this.update(parseInt(e.target.value, 10));
            }
            else {
                _this.update(e.target.value);
            }
        };
        return _this;
    }
    PureSelectControl.prototype.update = function (value) {
        this.props.onChange({ param: this.props.param, name: this.props.name, value: value });
    };
    PureSelectControl.prototype.render = function () {
        var _this = this;
        var isInvalid = this.props.value !== void 0 && !this.props.param.options.some(function (e) { return e[0] === _this.props.value; });
        return react__WEBPACK_IMPORTED_MODULE_1__["createElement"]("select", { className: 'msp-form-control', title: this.props.title, value: this.props.value !== void 0 ? this.props.value : this.props.param.defaultValue, onChange: this.onChange, disabled: this.props.isDisabled },
            isInvalid && react__WEBPACK_IMPORTED_MODULE_1__["createElement"]("option", { key: this.props.value, value: this.props.value }, "[Invalid] " + this.props.value),
            this.props.param.options.map(function (_a) {
                var value = _a[0], label = _a[1];
                return react__WEBPACK_IMPORTED_MODULE_1__["createElement"]("option", { key: value, value: value }, label);
            }));
    };
    return PureSelectControl;
}(react__WEBPACK_IMPORTED_MODULE_1__["PureComponent"]));

var SelectControl = /** @class */ (function (_super) {
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__extends"])(SelectControl, _super);
    function SelectControl() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = { showHelp: false, showOptions: false };
        _this.onSelect = function (item) {
            if (!item || item.value === _this.props.value) {
                _this.setState({ showOptions: false });
            }
            else {
                _this.setState({ showOptions: false }, function () {
                    _this.props.onChange({ param: _this.props.param, name: _this.props.name, value: item.value });
                });
            }
        };
        _this.toggle = function () { return _this.setState({ showOptions: !_this.state.showOptions }); };
        _this.cycle = function () {
            var options = _this.props.param.options;
            var current = options.findIndex(function (o) { return o[0] === _this.props.value; });
            var next = current === options.length - 1 ? 0 : current + 1;
            _this.props.onChange({ param: _this.props.param, name: _this.props.name, value: options[next][0] });
        };
        _this.items = Object(_mol_util_memoize__WEBPACK_IMPORTED_MODULE_5__["memoizeLatest"])(function (param) { return _action_menu__WEBPACK_IMPORTED_MODULE_10__["ActionMenu"].createItemsFromSelectOptions(param.options); });
        _this.toggleHelp = function () { return _this.setState({ showHelp: !_this.state.showHelp }); };
        return _this;
    }
    SelectControl.prototype.renderControl = function () {
        var _a;
        var items = this.items(this.props.param);
        var current = this.props.value !== undefined ? _action_menu__WEBPACK_IMPORTED_MODULE_10__["ActionMenu"].findItem(items, this.props.value) : void 0;
        var label = current
            ? current.label
            : typeof this.props.value === 'undefined'
                ? (((_a = _action_menu__WEBPACK_IMPORTED_MODULE_10__["ActionMenu"].getFirstItem(items)) === null || _a === void 0 ? void 0 : _a.label) || '') + " [Default]"
                : "[Invalid] " + this.props.value;
        var toggle = this.props.param.cycle ? this.cycle : this.toggle;
        var textAlign = this.props.param.cycle ? 'center' : 'left';
        var icon = this.props.param.cycle
            ? (this.props.value === 'on' ? _icons__WEBPACK_IMPORTED_MODULE_13__["CheckSvg"]
                : this.props.value === 'off' ? _icons__WEBPACK_IMPORTED_MODULE_13__["ClearSvg"] : void 0)
            : void 0;
        return react__WEBPACK_IMPORTED_MODULE_1__["createElement"](_common__WEBPACK_IMPORTED_MODULE_12__["ToggleButton"], { disabled: this.props.isDisabled, style: { textAlign: textAlign, overflow: 'hidden', textOverflow: 'ellipsis' }, label: label, title: label, icon: icon, toggle: toggle, isSelected: this.state.showOptions });
    };
    SelectControl.prototype.renderAddOn = function () {
        if (!this.state.showOptions)
            return null;
        var items = this.items(this.props.param);
        var current = _action_menu__WEBPACK_IMPORTED_MODULE_10__["ActionMenu"].findItem(items, this.props.value);
        return react__WEBPACK_IMPORTED_MODULE_1__["createElement"](_action_menu__WEBPACK_IMPORTED_MODULE_10__["ActionMenu"], { items: items, current: current, onSelect: this.onSelect });
    };
    SelectControl.prototype.render = function () {
        return renderSimple({
            props: this.props,
            state: this.state,
            control: this.renderControl(),
            toggleHelp: this.toggleHelp,
            addOn: this.renderAddOn()
        });
    };
    return SelectControl;
}(react__WEBPACK_IMPORTED_MODULE_1__["PureComponent"]));

var ValueRefControl = /** @class */ (function (_super) {
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__extends"])(ValueRefControl, _super);
    function ValueRefControl() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = { showHelp: false, showOptions: false };
        _this.onSelect = function (item) {
            if (!item || item.value === _this.props.value) {
                _this.setState({ showOptions: false });
            }
            else {
                _this.setState({ showOptions: false }, function () {
                    _this.props.onChange({ param: _this.props.param, name: _this.props.name, value: { ref: item.value } });
                });
            }
        };
        _this.toggle = function () { return _this.setState({ showOptions: !_this.state.showOptions }); };
        _this.items = Object(_mol_util_memoize__WEBPACK_IMPORTED_MODULE_5__["memoizeLatest"])(function (param) { return _action_menu__WEBPACK_IMPORTED_MODULE_10__["ActionMenu"].createItemsFromSelectOptions(param.getOptions()); });
        _this.toggleHelp = function () { return _this.setState({ showHelp: !_this.state.showHelp }); };
        return _this;
    }
    ValueRefControl.prototype.renderControl = function () {
        var _a;
        var items = this.items(this.props.param);
        var current = this.props.value.ref ? _action_menu__WEBPACK_IMPORTED_MODULE_10__["ActionMenu"].findItem(items, this.props.value.ref) : void 0;
        var label = current
            ? current.label
            : "[Ref] " + ((_a = this.props.value.ref) !== null && _a !== void 0 ? _a : '');
        return react__WEBPACK_IMPORTED_MODULE_1__["createElement"](_common__WEBPACK_IMPORTED_MODULE_12__["ToggleButton"], { disabled: this.props.isDisabled, style: { textAlign: 'left', overflow: 'hidden', textOverflow: 'ellipsis' }, label: label, title: label, toggle: this.toggle, isSelected: this.state.showOptions });
    };
    ValueRefControl.prototype.renderAddOn = function () {
        if (!this.state.showOptions)
            return null;
        var items = this.items(this.props.param);
        var current = _action_menu__WEBPACK_IMPORTED_MODULE_10__["ActionMenu"].findItem(items, this.props.value.ref);
        return react__WEBPACK_IMPORTED_MODULE_1__["createElement"](_action_menu__WEBPACK_IMPORTED_MODULE_10__["ActionMenu"], { items: items, current: current, onSelect: this.onSelect });
    };
    ValueRefControl.prototype.render = function () {
        return renderSimple({
            props: this.props,
            state: this.state,
            control: this.renderControl(),
            toggleHelp: this.toggleHelp,
            addOn: this.renderAddOn()
        });
    };
    return ValueRefControl;
}(react__WEBPACK_IMPORTED_MODULE_1__["PureComponent"]));

var IntervalControl = /** @class */ (function (_super) {
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__extends"])(IntervalControl, _super);
    function IntervalControl() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = { isExpanded: false };
        _this.components = {
            0: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_7__["ParamDefinition"].Numeric(0, { step: _this.props.param.step }, { label: 'Min' }),
            1: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_7__["ParamDefinition"].Numeric(0, { step: _this.props.param.step }, { label: 'Max' })
        };
        _this.componentChange = function (_a) {
            var name = _a.name, value = _a.value;
            var v = Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__spreadArrays"])(_this.props.value);
            v[+name] = value;
            _this.change(v);
        };
        _this.toggleExpanded = function (e) {
            _this.setState({ isExpanded: !_this.state.isExpanded });
            e.currentTarget.blur();
        };
        return _this;
    }
    IntervalControl.prototype.change = function (value) {
        this.props.onChange({ name: this.props.name, param: this.props.param, value: value });
    };
    IntervalControl.prototype.render = function () {
        var v = this.props.value;
        var label = this.props.param.label || Object(_mol_util_string__WEBPACK_IMPORTED_MODULE_8__["camelCaseToWords"])(this.props.name);
        var p = Object(_mol_util_number__WEBPACK_IMPORTED_MODULE_6__["getPrecision"])(this.props.param.step || 0.01);
        var value = "[" + v[0].toFixed(p) + ", " + v[1].toFixed(p) + "]";
        return react__WEBPACK_IMPORTED_MODULE_1__["createElement"](react__WEBPACK_IMPORTED_MODULE_1__["Fragment"], null,
            react__WEBPACK_IMPORTED_MODULE_1__["createElement"](_common__WEBPACK_IMPORTED_MODULE_12__["ControlRow"], { label: label, control: react__WEBPACK_IMPORTED_MODULE_1__["createElement"]("button", { onClick: this.toggleExpanded, disabled: this.props.isDisabled }, value) }),
            this.state.isExpanded && react__WEBPACK_IMPORTED_MODULE_1__["createElement"]("div", { className: 'msp-control-offset' },
                react__WEBPACK_IMPORTED_MODULE_1__["createElement"](ParameterControls, { params: this.components, values: v, onChange: this.componentChange, onEnter: this.props.onEnter })));
    };
    return IntervalControl;
}(react__WEBPACK_IMPORTED_MODULE_1__["PureComponent"]));

var BoundedIntervalControl = /** @class */ (function (_super) {
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__extends"])(BoundedIntervalControl, _super);
    function BoundedIntervalControl() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.onChange = function (v) { _this.update(v); };
        return _this;
    }
    BoundedIntervalControl.prototype.renderControl = function () {
        return react__WEBPACK_IMPORTED_MODULE_1__["createElement"](_slider__WEBPACK_IMPORTED_MODULE_16__["Slider2"], { value: this.props.value, min: this.props.param.min, max: this.props.param.max, step: this.props.param.step, onChange: this.onChange, disabled: this.props.isDisabled, onEnter: this.props.onEnter });
    };
    return BoundedIntervalControl;
}(SimpleParam));

var ColorControl = /** @class */ (function (_super) {
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__extends"])(ColorControl, _super);
    function ColorControl() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.onChange = function (e) {
            _this.update(Object(_mol_util_color__WEBPACK_IMPORTED_MODULE_3__["Color"])(parseInt(e.target.value)));
        };
        return _this;
    }
    ColorControl.prototype.stripStyle = function () {
        return {
            background: _mol_util_color__WEBPACK_IMPORTED_MODULE_3__["Color"].toStyle(this.props.value),
            position: 'absolute',
            bottom: '0',
            height: '4px',
            right: '0',
            left: '0'
        };
    };
    ColorControl.prototype.renderControl = function () {
        return react__WEBPACK_IMPORTED_MODULE_1__["createElement"]("div", { style: { position: 'relative' } },
            react__WEBPACK_IMPORTED_MODULE_1__["createElement"]("select", { value: this.props.value, onChange: this.onChange },
                Object(_color__WEBPACK_IMPORTED_MODULE_11__["ColorValueOption"])(this.props.value),
                Object(_color__WEBPACK_IMPORTED_MODULE_11__["ColorOptions"])()),
            react__WEBPACK_IMPORTED_MODULE_1__["createElement"]("div", { style: this.stripStyle() }));
    };
    return ColorControl;
}(SimpleParam));

function colorEntryToStyle(e, includeOffset) {
    if (includeOffset === void 0) { includeOffset = false; }
    if (Array.isArray(e)) {
        if (includeOffset)
            return _mol_util_color__WEBPACK_IMPORTED_MODULE_3__["Color"].toStyle(e[0]) + " " + (100 * e[1]).toFixed(2) + "%";
        return _mol_util_color__WEBPACK_IMPORTED_MODULE_3__["Color"].toStyle(e[0]);
    }
    return _mol_util_color__WEBPACK_IMPORTED_MODULE_3__["Color"].toStyle(e);
}
var colorGradientInterpolated = Object(_mol_util_memoize__WEBPACK_IMPORTED_MODULE_5__["memoize1"])(function (colors) {
    var styles = colors.map(function (c) { return colorEntryToStyle(c, true); });
    return "linear-gradient(to right, " + styles.join(', ') + ")";
});
var colorGradientBanded = Object(_mol_util_memoize__WEBPACK_IMPORTED_MODULE_5__["memoize1"])(function (colors) {
    var n = colors.length;
    var styles = [colorEntryToStyle(colors[0]) + " " + 100 * (1 / n) + "%"];
    // TODO: does this need to support offsets?
    for (var i = 1, il = n - 1; i < il; ++i) {
        styles.push(colorEntryToStyle(colors[i]) + " " + 100 * (i / n) + "%", colorEntryToStyle(colors[i]) + " " + 100 * ((i + 1) / n) + "%");
    }
    styles.push(colorEntryToStyle(colors[n - 1]) + " " + 100 * ((n - 1) / n) + "%");
    return "linear-gradient(to right, " + styles.join(', ') + ")";
});
function colorStripStyle(list, right) {
    if (right === void 0) { right = '0'; }
    return {
        background: colorGradient(list.colors, list.kind === 'set'),
        position: 'absolute',
        bottom: '0',
        height: '4px',
        right: right,
        left: '0'
    };
}
function colorGradient(colors, banded) {
    return banded ? colorGradientBanded(colors) : colorGradientInterpolated(colors);
}
function createColorListHelpers() {
    var addOn = function (l) {
        var preset = Object(_mol_util_color_lists__WEBPACK_IMPORTED_MODULE_4__["getColorListFromName"])(l[0]);
        return react__WEBPACK_IMPORTED_MODULE_1__["createElement"]("div", { style: colorStripStyle({ kind: preset.type !== 'qualitative' ? 'interpolate' : 'set', colors: preset.list }) });
    };
    return {
        ColorPresets: {
            all: _action_menu__WEBPACK_IMPORTED_MODULE_10__["ActionMenu"].createItemsFromSelectOptions(_mol_util_color_lists__WEBPACK_IMPORTED_MODULE_4__["ColorListOptions"], { addOn: addOn }),
            scale: _action_menu__WEBPACK_IMPORTED_MODULE_10__["ActionMenu"].createItemsFromSelectOptions(_mol_util_color_lists__WEBPACK_IMPORTED_MODULE_4__["ColorListOptionsScale"], { addOn: addOn }),
            set: _action_menu__WEBPACK_IMPORTED_MODULE_10__["ActionMenu"].createItemsFromSelectOptions(_mol_util_color_lists__WEBPACK_IMPORTED_MODULE_4__["ColorListOptionsSet"], { addOn: addOn })
        },
        ColorsParam: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_7__["ParamDefinition"].ObjectList({ color: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_7__["ParamDefinition"].Color(0x0) }, function (_a) {
            var color = _a.color;
            return _mol_util_color__WEBPACK_IMPORTED_MODULE_3__["Color"].toHexString(color).toUpperCase();
        }),
        OffsetColorsParam: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_7__["ParamDefinition"].ObjectList({ color: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_7__["ParamDefinition"].Color(0x0), offset: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_7__["ParamDefinition"].Numeric(0, { min: 0, max: 1, step: 0.01 }) }, function (_a) {
            var color = _a.color, offset = _a.offset;
            return _mol_util_color__WEBPACK_IMPORTED_MODULE_3__["Color"].toHexString(color).toUpperCase() + " [" + offset.toFixed(2) + "]";
        }),
        IsInterpolatedParam: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_7__["ParamDefinition"].Boolean(false, { label: 'Interpolated' })
    };
}
var _colorListHelpers;
function ColorListHelpers() {
    if (_colorListHelpers)
        return _colorListHelpers;
    _colorListHelpers = createColorListHelpers();
    return _colorListHelpers;
}
var ColorListControl = /** @class */ (function (_super) {
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__extends"])(ColorListControl, _super);
    function ColorListControl() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = { showHelp: false, show: void 0 };
        _this.toggleEdit = function () { return _this.setState({ show: _this.state.show === 'edit' ? void 0 : 'edit' }); };
        _this.togglePresets = function () { return _this.setState({ show: _this.state.show === 'presets' ? void 0 : 'presets' }); };
        _this.selectPreset = function (item) {
            if (!item)
                return;
            _this.setState({ show: void 0 });
            var preset = Object(_mol_util_color_lists__WEBPACK_IMPORTED_MODULE_4__["getColorListFromName"])(item.value);
            _this.update({ kind: preset.type !== 'qualitative' ? 'interpolate' : 'set', colors: preset.list });
        };
        _this.colorsChanged = function (_a) {
            var value = _a.value;
            _this.update({
                kind: _this.props.value.kind,
                colors: value.map(function (c) { return c.color; })
            });
        };
        _this.isInterpolatedChanged = function (_a) {
            var value = _a.value;
            _this.update({ kind: value ? 'interpolate' : 'set', colors: _this.props.value.colors });
        };
        _this.toggleHelp = function () { return _this.setState({ showHelp: !_this.state.showHelp }); };
        return _this;
    }
    ColorListControl.prototype.update = function (value) {
        this.props.onChange({ param: this.props.param, name: this.props.name, value: value });
    };
    ColorListControl.prototype.renderControl = function () {
        var value = this.props.value;
        // TODO: fix the button right offset
        return react__WEBPACK_IMPORTED_MODULE_1__["createElement"](react__WEBPACK_IMPORTED_MODULE_1__["Fragment"], null,
            react__WEBPACK_IMPORTED_MODULE_1__["createElement"]("button", { onClick: this.toggleEdit, style: { position: 'relative', paddingRight: '33px' } },
                value.colors.length === 1 ? '1 color' : value.colors.length + " colors",
                react__WEBPACK_IMPORTED_MODULE_1__["createElement"]("div", { style: colorStripStyle(value, '33px') })),
            react__WEBPACK_IMPORTED_MODULE_1__["createElement"](_common__WEBPACK_IMPORTED_MODULE_12__["IconButton"], { svg: _icons__WEBPACK_IMPORTED_MODULE_13__["BookmarksOutlinedSvg"], onClick: this.togglePresets, toggleState: this.state.show === 'presets', title: 'Color Presets', style: { padding: 0, position: 'absolute', right: 0, top: 0, width: '32px' } }));
    };
    ColorListControl.prototype.renderColors = function () {
        if (!this.state.show)
            return null;
        var _a = ColorListHelpers(), ColorPresets = _a.ColorPresets, ColorsParam = _a.ColorsParam, IsInterpolatedParam = _a.IsInterpolatedParam;
        var preset = ColorPresets[this.props.param.presetKind];
        if (this.state.show === 'presets')
            return react__WEBPACK_IMPORTED_MODULE_1__["createElement"](_action_menu__WEBPACK_IMPORTED_MODULE_10__["ActionMenu"], { items: preset, onSelect: this.selectPreset });
        var values = this.props.value.colors.map(function (color) { return ({ color: color }); });
        return react__WEBPACK_IMPORTED_MODULE_1__["createElement"]("div", { className: 'msp-control-offset' },
            react__WEBPACK_IMPORTED_MODULE_1__["createElement"](ObjectListControl, { name: 'colors', param: ColorsParam, value: values, onChange: this.colorsChanged, isDisabled: this.props.isDisabled, onEnter: this.props.onEnter }),
            react__WEBPACK_IMPORTED_MODULE_1__["createElement"](BoolControl, { name: 'isInterpolated', param: IsInterpolatedParam, value: this.props.value.kind === 'interpolate', onChange: this.isInterpolatedChanged, isDisabled: this.props.isDisabled, onEnter: this.props.onEnter }));
    };
    ColorListControl.prototype.render = function () {
        return renderSimple({
            props: this.props,
            state: this.state,
            control: this.renderControl(),
            toggleHelp: this.toggleHelp,
            addOn: this.renderColors()
        });
    };
    return ColorListControl;
}(react__WEBPACK_IMPORTED_MODULE_1__["PureComponent"]));

var OffsetColorListControl = /** @class */ (function (_super) {
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__extends"])(OffsetColorListControl, _super);
    function OffsetColorListControl() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = { showHelp: false, show: void 0 };
        _this.toggleEdit = function () { return _this.setState({ show: _this.state.show === 'edit' ? void 0 : 'edit' }); };
        _this.togglePresets = function () { return _this.setState({ show: _this.state.show === 'presets' ? void 0 : 'presets' }); };
        _this.selectPreset = function (item) {
            if (!item)
                return;
            _this.setState({ show: void 0 });
            var preset = Object(_mol_util_color_lists__WEBPACK_IMPORTED_MODULE_4__["getColorListFromName"])(item.value);
            _this.update({ kind: preset.type !== 'qualitative' ? 'interpolate' : 'set', colors: preset.list });
        };
        _this.colorsChanged = function (_a) {
            var value = _a.value;
            var colors = value.map(function (c) { return [c.color, c.offset]; });
            colors.sort(function (a, b) { return a[1] - b[1]; });
            _this.update({ kind: _this.props.value.kind, colors: colors });
        };
        _this.isInterpolatedChanged = function (_a) {
            var value = _a.value;
            _this.update({ kind: value ? 'interpolate' : 'set', colors: _this.props.value.colors });
        };
        _this.toggleHelp = function () { return _this.setState({ showHelp: !_this.state.showHelp }); };
        return _this;
    }
    OffsetColorListControl.prototype.update = function (value) {
        this.props.onChange({ param: this.props.param, name: this.props.name, value: value });
    };
    OffsetColorListControl.prototype.renderControl = function () {
        var value = this.props.value;
        // TODO: fix the button right offset
        return react__WEBPACK_IMPORTED_MODULE_1__["createElement"](react__WEBPACK_IMPORTED_MODULE_1__["Fragment"], null,
            react__WEBPACK_IMPORTED_MODULE_1__["createElement"]("button", { onClick: this.toggleEdit, style: { position: 'relative', paddingRight: '33px' } },
                value.colors.length === 1 ? '1 color' : value.colors.length + " colors",
                react__WEBPACK_IMPORTED_MODULE_1__["createElement"]("div", { style: colorStripStyle(value, '33px') })),
            react__WEBPACK_IMPORTED_MODULE_1__["createElement"](_common__WEBPACK_IMPORTED_MODULE_12__["IconButton"], { svg: _icons__WEBPACK_IMPORTED_MODULE_13__["BookmarksOutlinedSvg"], onClick: this.togglePresets, toggleState: this.state.show === 'presets', title: 'Color Presets', style: { padding: 0, position: 'absolute', right: 0, top: 0, width: '32px' } }));
    };
    OffsetColorListControl.prototype.renderColors = function () {
        if (!this.state.show)
            return null;
        var _a = ColorListHelpers(), ColorPresets = _a.ColorPresets, OffsetColorsParam = _a.OffsetColorsParam, IsInterpolatedParam = _a.IsInterpolatedParam;
        var preset = ColorPresets[this.props.param.presetKind];
        if (this.state.show === 'presets')
            return react__WEBPACK_IMPORTED_MODULE_1__["createElement"](_action_menu__WEBPACK_IMPORTED_MODULE_10__["ActionMenu"], { items: preset, onSelect: this.selectPreset });
        var colors = this.props.value.colors;
        var values = colors.map(function (color, i) {
            if (Array.isArray(color))
                return { color: color[0], offset: color[1] };
            return { color: color, offset: i / colors.length };
        });
        values.sort(function (a, b) { return a.offset - b.offset; });
        return react__WEBPACK_IMPORTED_MODULE_1__["createElement"]("div", { className: 'msp-control-offset' },
            react__WEBPACK_IMPORTED_MODULE_1__["createElement"](ObjectListControl, { name: 'colors', param: OffsetColorsParam, value: values, onChange: this.colorsChanged, isDisabled: this.props.isDisabled, onEnter: this.props.onEnter }),
            react__WEBPACK_IMPORTED_MODULE_1__["createElement"](BoolControl, { name: 'isInterpolated', param: IsInterpolatedParam, value: this.props.value.kind === 'interpolate', onChange: this.isInterpolatedChanged, isDisabled: this.props.isDisabled, onEnter: this.props.onEnter }));
    };
    OffsetColorListControl.prototype.render = function () {
        return renderSimple({
            props: this.props,
            state: this.state,
            control: this.renderControl(),
            toggleHelp: this.toggleHelp,
            addOn: this.renderColors()
        });
    };
    return OffsetColorListControl;
}(react__WEBPACK_IMPORTED_MODULE_1__["PureComponent"]));

var Vec3Control = /** @class */ (function (_super) {
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__extends"])(Vec3Control, _super);
    function Vec3Control() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = { isExpanded: false };
        _this.components = {
            0: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_7__["ParamDefinition"].Numeric(0, { step: _this.props.param.step }, { label: (_this.props.param.fieldLabels && _this.props.param.fieldLabels.x) || 'X' }),
            1: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_7__["ParamDefinition"].Numeric(0, { step: _this.props.param.step }, { label: (_this.props.param.fieldLabels && _this.props.param.fieldLabels.y) || 'Y' }),
            2: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_7__["ParamDefinition"].Numeric(0, { step: _this.props.param.step }, { label: (_this.props.param.fieldLabels && _this.props.param.fieldLabels.z) || 'Z' })
        };
        _this.componentChange = function (_a) {
            var name = _a.name, value = _a.value;
            var v = _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_2__["Vec3"].copy(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_2__["Vec3"].zero(), _this.props.value);
            v[+name] = value;
            _this.change(v);
        };
        _this.toggleExpanded = function (e) {
            _this.setState({ isExpanded: !_this.state.isExpanded });
            e.currentTarget.blur();
        };
        return _this;
    }
    Vec3Control.prototype.change = function (value) {
        this.props.onChange({ name: this.props.name, param: this.props.param, value: value });
    };
    Vec3Control.prototype.render = function () {
        var v = this.props.value;
        var label = this.props.param.label || Object(_mol_util_string__WEBPACK_IMPORTED_MODULE_8__["camelCaseToWords"])(this.props.name);
        var p = Object(_mol_util_number__WEBPACK_IMPORTED_MODULE_6__["getPrecision"])(this.props.param.step || 0.01);
        var value = "[" + v[0].toFixed(p) + ", " + v[1].toFixed(p) + ", " + v[2].toFixed(p) + "]";
        return react__WEBPACK_IMPORTED_MODULE_1__["createElement"](react__WEBPACK_IMPORTED_MODULE_1__["Fragment"], null,
            react__WEBPACK_IMPORTED_MODULE_1__["createElement"](_common__WEBPACK_IMPORTED_MODULE_12__["ControlRow"], { label: label, control: react__WEBPACK_IMPORTED_MODULE_1__["createElement"]("button", { onClick: this.toggleExpanded, disabled: this.props.isDisabled }, value) }),
            this.state.isExpanded && react__WEBPACK_IMPORTED_MODULE_1__["createElement"]("div", { className: 'msp-control-offset' },
                react__WEBPACK_IMPORTED_MODULE_1__["createElement"](ParameterControls, { params: this.components, values: v, onChange: this.componentChange, onEnter: this.props.onEnter })));
    };
    return Vec3Control;
}(react__WEBPACK_IMPORTED_MODULE_1__["PureComponent"]));

var Mat4Control = /** @class */ (function (_super) {
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__extends"])(Mat4Control, _super);
    function Mat4Control() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = { isExpanded: false };
        _this.components = {
            json: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_7__["ParamDefinition"].Text(JSON.stringify(Object(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_2__["Mat4"])()), { description: 'JSON array with 4x4 matrix in a column major (j * 4 + i indexing) format' })
        };
        _this.componentChange = function (_a) {
            var name = _a.name, value = _a.value;
            var v = _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_2__["Mat4"].copy(Object(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_2__["Mat4"])(), _this.props.value);
            if (name === 'json') {
                _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_2__["Mat4"].copy(v, JSON.parse(value));
            }
            else {
                v[+name] = value;
            }
            _this.change(v);
        };
        _this.toggleExpanded = function (e) {
            _this.setState({ isExpanded: !_this.state.isExpanded });
            e.currentTarget.blur();
        };
        return _this;
    }
    Mat4Control.prototype.change = function (value) {
        this.props.onChange({ name: this.props.name, param: this.props.param, value: value });
    };
    Mat4Control.prototype.changeValue = function (idx) {
        var _this = this;
        return function (v) {
            var m = _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_2__["Mat4"].copy(Object(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_2__["Mat4"])(), _this.props.value);
            m[idx] = v;
            _this.change(m);
        };
    };
    Object.defineProperty(Mat4Control.prototype, "grid", {
        get: function () {
            var v = this.props.value;
            var rows = [];
            for (var i = 0; i < 4; i++) {
                var row = [];
                for (var j = 0; j < 4; j++) {
                    row.push(react__WEBPACK_IMPORTED_MODULE_1__["createElement"](_common__WEBPACK_IMPORTED_MODULE_12__["TextInput"], { key: j, numeric: true, delayMs: 50, value: _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_2__["Mat4"].getValue(v, i, j), onChange: this.changeValue(4 * j + i), className: 'msp-form-control', blurOnEnter: true, isDisabled: this.props.isDisabled }));
                }
                rows.push(react__WEBPACK_IMPORTED_MODULE_1__["createElement"]("div", { className: 'msp-flex-row', key: i }, row));
            }
            return react__WEBPACK_IMPORTED_MODULE_1__["createElement"]("div", { className: 'msp-parameter-matrix' }, rows);
        },
        enumerable: false,
        configurable: true
    });
    Mat4Control.prototype.render = function () {
        var v = {
            json: JSON.stringify(this.props.value)
        };
        var label = this.props.param.label || Object(_mol_util_string__WEBPACK_IMPORTED_MODULE_8__["camelCaseToWords"])(this.props.name);
        return react__WEBPACK_IMPORTED_MODULE_1__["createElement"](react__WEBPACK_IMPORTED_MODULE_1__["Fragment"], null,
            react__WEBPACK_IMPORTED_MODULE_1__["createElement"](_common__WEBPACK_IMPORTED_MODULE_12__["ControlRow"], { label: label, control: react__WEBPACK_IMPORTED_MODULE_1__["createElement"]("button", { onClick: this.toggleExpanded, disabled: this.props.isDisabled }, '4\u00D74 Matrix') }),
            this.state.isExpanded && react__WEBPACK_IMPORTED_MODULE_1__["createElement"]("div", { className: 'msp-control-offset' },
                this.grid,
                react__WEBPACK_IMPORTED_MODULE_1__["createElement"](ParameterControls, { params: this.components, values: v, onChange: this.componentChange, onEnter: this.props.onEnter })));
    };
    return Mat4Control;
}(react__WEBPACK_IMPORTED_MODULE_1__["PureComponent"]));

var UrlControl = /** @class */ (function (_super) {
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__extends"])(UrlControl, _super);
    function UrlControl() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.onChange = function (e) {
            var value = e.target.value;
            if (value !== _mol_util_assets__WEBPACK_IMPORTED_MODULE_17__["Asset"].getUrl(_this.props.value || '')) {
                _this.update(_mol_util_assets__WEBPACK_IMPORTED_MODULE_17__["Asset"].Url(value));
            }
        };
        _this.onKeyPress = function (e) {
            if ((e.keyCode === 13 || e.charCode === 13 || e.key === 'Enter')) {
                if (_this.props.onEnter)
                    _this.props.onEnter();
            }
            e.stopPropagation();
        };
        return _this;
    }
    UrlControl.prototype.renderControl = function () {
        var placeholder = this.props.param.label || Object(_mol_util_string__WEBPACK_IMPORTED_MODULE_8__["camelCaseToWords"])(this.props.name);
        return react__WEBPACK_IMPORTED_MODULE_1__["createElement"]("input", { type: 'text', value: _mol_util_assets__WEBPACK_IMPORTED_MODULE_17__["Asset"].getUrl(this.props.value || ''), placeholder: placeholder, onChange: this.onChange, onKeyPress: this.props.onEnter ? this.onKeyPress : void 0, disabled: this.props.isDisabled });
    };
    return UrlControl;
}(SimpleParam));

var FileControl = /** @class */ (function (_super) {
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__extends"])(FileControl, _super);
    function FileControl() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = { showHelp: false };
        _this.onChangeFile = function (e) {
            _this.change(e.target.files[0]);
        };
        _this.toggleHelp = function () { return _this.setState({ showHelp: !_this.state.showHelp }); };
        return _this;
    }
    FileControl.prototype.change = function (value) {
        this.props.onChange({ name: this.props.name, param: this.props.param, value: _mol_util_assets__WEBPACK_IMPORTED_MODULE_17__["Asset"].File(value) });
    };
    FileControl.prototype.renderControl = function () {
        var value = this.props.value;
        return react__WEBPACK_IMPORTED_MODULE_1__["createElement"]("div", { className: 'msp-btn msp-btn-block msp-btn-action msp-loader-msp-btn-file', style: { marginTop: '1px' } },
            value ? value.name : 'Select a file...',
            " ",
            react__WEBPACK_IMPORTED_MODULE_1__["createElement"]("input", { disabled: this.props.isDisabled, onChange: this.onChangeFile, type: 'file', multiple: false, accept: this.props.param.accept }));
    };
    FileControl.prototype.render = function () {
        if (this.props.param.label) {
            return renderSimple({
                props: this.props,
                state: this.state,
                control: this.renderControl(),
                toggleHelp: this.toggleHelp,
                addOn: null
            });
        }
        else {
            return this.renderControl();
        }
    };
    return FileControl;
}(react__WEBPACK_IMPORTED_MODULE_1__["PureComponent"]));

var FileListControl = /** @class */ (function (_super) {
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__extends"])(FileListControl, _super);
    function FileListControl() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = { showHelp: false };
        _this.onChangeFileList = function (e) {
            _this.change(e.target.files);
        };
        _this.toggleHelp = function () { return _this.setState({ showHelp: !_this.state.showHelp }); };
        return _this;
    }
    FileListControl.prototype.change = function (value) {
        var files = [];
        if (value) {
            for (var i = 0, il = value.length; i < il; ++i) {
                files.push(_mol_util_assets__WEBPACK_IMPORTED_MODULE_17__["Asset"].File(value[i]));
            }
        }
        this.props.onChange({ name: this.props.name, param: this.props.param, value: files });
    };
    FileListControl.prototype.renderControl = function () {
        var value = this.props.value;
        var names = [];
        if (value) {
            for (var _i = 0, value_1 = value; _i < value_1.length; _i++) {
                var file = value_1[_i];
                names.push(file.name);
            }
        }
        var label = names.length === 0
            ? 'Select files...' : names.length === 1
            ? names[0] : names.length + " files selected";
        return react__WEBPACK_IMPORTED_MODULE_1__["createElement"]("div", { className: 'msp-btn msp-btn-block msp-btn-action msp-loader-msp-btn-file', style: { marginTop: '1px' } },
            label,
            " ",
            react__WEBPACK_IMPORTED_MODULE_1__["createElement"]("input", { disabled: this.props.isDisabled, onChange: this.onChangeFileList, type: 'file', multiple: true, accept: this.props.param.accept }));
    };
    FileListControl.prototype.render = function () {
        if (this.props.param.label) {
            return renderSimple({
                props: this.props,
                state: this.state,
                control: this.renderControl(),
                toggleHelp: this.toggleHelp,
                addOn: null
            });
        }
        else {
            return this.renderControl();
        }
    };
    return FileListControl;
}(react__WEBPACK_IMPORTED_MODULE_1__["PureComponent"]));

var MultiSelectControl = /** @class */ (function (_super) {
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__extends"])(MultiSelectControl, _super);
    function MultiSelectControl() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = { isExpanded: false };
        _this.toggleExpanded = function (e) {
            _this.setState({ isExpanded: !_this.state.isExpanded });
            e.currentTarget.blur();
        };
        return _this;
    }
    MultiSelectControl.prototype.change = function (value) {
        this.props.onChange({ name: this.props.name, param: this.props.param, value: value });
    };
    MultiSelectControl.prototype.toggle = function (key) {
        var _this = this;
        return function (e) {
            if (_this.props.value.indexOf(key) < 0)
                _this.change(_this.props.value.concat(key));
            else
                _this.change(_this.props.value.filter(function (v) { return v !== key; }));
            e.currentTarget.blur();
        };
    };
    MultiSelectControl.prototype.render = function () {
        var _this = this;
        var current = this.props.value;
        var emptyLabel = this.props.param.emptyValue;
        var label = this.props.param.label || Object(_mol_util_string__WEBPACK_IMPORTED_MODULE_8__["camelCaseToWords"])(this.props.name);
        return react__WEBPACK_IMPORTED_MODULE_1__["createElement"](react__WEBPACK_IMPORTED_MODULE_1__["Fragment"], null,
            react__WEBPACK_IMPORTED_MODULE_1__["createElement"](_common__WEBPACK_IMPORTED_MODULE_12__["ControlRow"], { label: label, control: react__WEBPACK_IMPORTED_MODULE_1__["createElement"]("button", { onClick: this.toggleExpanded, disabled: this.props.isDisabled }, current.length === 0 && emptyLabel ? emptyLabel : current.length + " of " + this.props.param.options.length) }),
            this.state.isExpanded && react__WEBPACK_IMPORTED_MODULE_1__["createElement"]("div", { className: 'msp-control-offset' }, this.props.param.options.map(function (_a) {
                var value = _a[0], label = _a[1];
                var sel = current.indexOf(value) >= 0;
                return react__WEBPACK_IMPORTED_MODULE_1__["createElement"](_common__WEBPACK_IMPORTED_MODULE_12__["Button"], { key: value, onClick: _this.toggle(value), disabled: _this.props.isDisabled, style: { marginTop: '1px' } },
                    react__WEBPACK_IMPORTED_MODULE_1__["createElement"]("span", { style: { float: sel ? 'left' : 'right' } }, sel ? "\u2713 " + label : label + " \u2717"));
            })));
    };
    return MultiSelectControl;
}(react__WEBPACK_IMPORTED_MODULE_1__["PureComponent"]));

var GroupControl = /** @class */ (function (_super) {
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__extends"])(GroupControl, _super);
    function GroupControl() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = { isExpanded: !!_this.props.param.isExpanded, showHelp: false };
        _this.onChangeParam = function (e) {
            var _a;
            _this.change(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, _this.props.value), (_a = {}, _a[e.name] = e.value, _a)));
        };
        _this.toggleExpanded = function () { return _this.setState({ isExpanded: !_this.state.isExpanded }); };
        return _this;
    }
    GroupControl.prototype.change = function (value) {
        this.props.onChange({ name: this.props.name, param: this.props.param, value: value });
    };
    GroupControl.prototype.pivoted = function () {
        var key = this.props.param.pivot;
        var params = this.props.param.params;
        var pivot = params[key];
        var Control = controlFor(pivot);
        var ctrl = react__WEBPACK_IMPORTED_MODULE_1__["createElement"](Control, { name: key, param: pivot, value: this.props.value[key], onChange: this.onChangeParam, onEnter: this.props.onEnter, isDisabled: this.props.isDisabled });
        if (!this.state.isExpanded) {
            return react__WEBPACK_IMPORTED_MODULE_1__["createElement"]("div", { className: 'msp-mapped-parameter-group' },
                ctrl,
                react__WEBPACK_IMPORTED_MODULE_1__["createElement"](_common__WEBPACK_IMPORTED_MODULE_12__["IconButton"], { svg: _icons__WEBPACK_IMPORTED_MODULE_13__["MoreHorizSvg"], onClick: this.toggleExpanded, toggleState: this.state.isExpanded, title: "More Options" }));
        }
        var filtered = Object.create(null);
        for (var _i = 0, _a = Object.keys(params); _i < _a.length; _i++) {
            var k = _a[_i];
            if (k !== key)
                filtered[k] = params[k];
        }
        return react__WEBPACK_IMPORTED_MODULE_1__["createElement"]("div", { className: 'msp-mapped-parameter-group' },
            ctrl,
            react__WEBPACK_IMPORTED_MODULE_1__["createElement"](_common__WEBPACK_IMPORTED_MODULE_12__["IconButton"], { svg: _icons__WEBPACK_IMPORTED_MODULE_13__["MoreHorizSvg"], onClick: this.toggleExpanded, toggleState: this.state.isExpanded, title: "More Options" }),
            react__WEBPACK_IMPORTED_MODULE_1__["createElement"]("div", { className: 'msp-control-offset' },
                react__WEBPACK_IMPORTED_MODULE_1__["createElement"](ParameterControls, { params: filtered, onEnter: this.props.onEnter, values: this.props.value, onChange: this.onChangeParam, isDisabled: this.props.isDisabled })));
    };
    GroupControl.prototype.render = function () {
        var params = this.props.param.params;
        // Do not show if there are no params.
        if (Object.keys(params).length === 0)
            return null;
        if (this.props.param.pivot)
            return this.pivoted();
        var label = this.props.param.label || Object(_mol_util_string__WEBPACK_IMPORTED_MODULE_8__["camelCaseToWords"])(this.props.name);
        var controls = react__WEBPACK_IMPORTED_MODULE_1__["createElement"](ParameterControls, { params: params, onChange: this.onChangeParam, values: this.props.value, onEnter: this.props.onEnter, isDisabled: this.props.isDisabled });
        if (this.props.inMapped) {
            return react__WEBPACK_IMPORTED_MODULE_1__["createElement"]("div", { className: 'msp-control-offset' }, controls);
        }
        if (this.props.param.isFlat) {
            return controls;
        }
        return react__WEBPACK_IMPORTED_MODULE_1__["createElement"]("div", { className: 'msp-control-group-wrapper' },
            react__WEBPACK_IMPORTED_MODULE_1__["createElement"]("div", { className: 'msp-control-group-header' },
                react__WEBPACK_IMPORTED_MODULE_1__["createElement"]("button", { className: 'msp-btn msp-form-control msp-btn-block', onClick: this.toggleExpanded },
                    react__WEBPACK_IMPORTED_MODULE_1__["createElement"](_icons__WEBPACK_IMPORTED_MODULE_13__["Icon"], { svg: this.state.isExpanded ? _icons__WEBPACK_IMPORTED_MODULE_13__["ArrowDropDownSvg"] : _icons__WEBPACK_IMPORTED_MODULE_13__["ArrowRightSvg"] }),
                    label)),
            this.state.isExpanded && react__WEBPACK_IMPORTED_MODULE_1__["createElement"]("div", { className: 'msp-control-offset' }, controls));
    };
    return GroupControl;
}(react__WEBPACK_IMPORTED_MODULE_1__["PureComponent"]));

var MappedControl = /** @class */ (function (_super) {
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__extends"])(MappedControl, _super);
    function MappedControl() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = { isExpanded: false };
        // TODO: this could lead to a rare bug where the component is reused with different mapped control.
        // I think there are currently no cases where this could happen in the UI, but still need to watch out..
        _this.valuesCache = {};
        _this.onChangeName = function (e) {
            _this.change({ name: e.value, params: _this.getValues(e.value) });
        };
        _this.onChangeParam = function (e) {
            _this.setValues(_this.props.value.name, e.value);
            _this.change({ name: _this.props.value.name, params: e.value });
        };
        _this.toggleExpanded = function () { return _this.setState({ isExpanded: !_this.state.isExpanded }); };
        return _this;
    }
    MappedControl.prototype.setValues = function (name, values) {
        this.valuesCache[name] = values;
    };
    MappedControl.prototype.getValues = function (name) {
        if (name in this.valuesCache) {
            return this.valuesCache[name];
        }
        else {
            return this.props.param.map(name).defaultValue;
        }
    };
    MappedControl.prototype.change = function (value) {
        this.props.onChange({ name: this.props.name, param: this.props.param, value: value });
    };
    MappedControl.prototype.areParamsEmpty = function (params) {
        for (var _i = 0, _a = Object.keys(params); _i < _a.length; _i++) {
            var k = _a[_i];
            if (!params[k].isHidden)
                return false;
        }
        return true;
    };
    MappedControl.prototype.render = function () {
        var _this = this;
        var value = this.props.value || this.props.param.defaultValue;
        var param = this.props.param.map(value.name);
        var label = this.props.param.label || Object(_mol_util_string__WEBPACK_IMPORTED_MODULE_8__["camelCaseToWords"])(this.props.name);
        var Mapped = controlFor(param);
        var help = this.props.param.help;
        var select = help
            ? Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, this.props.param.select), { help: function (name) { return help({ name: name, params: _this.getValues(name) }); } }) : this.props.param.select;
        var Select = react__WEBPACK_IMPORTED_MODULE_1__["createElement"](SelectControl, { param: select, isDisabled: this.props.isDisabled, onChange: this.onChangeName, onEnter: this.props.onEnter, name: label, value: value.name });
        if (!Mapped) {
            return Select;
        }
        if (param.type === 'group' && !param.isFlat) {
            if (!this.areParamsEmpty(param.params)) {
                return react__WEBPACK_IMPORTED_MODULE_1__["createElement"]("div", { className: 'msp-mapped-parameter-group' },
                    Select,
                    react__WEBPACK_IMPORTED_MODULE_1__["createElement"](_common__WEBPACK_IMPORTED_MODULE_12__["IconButton"], { svg: _icons__WEBPACK_IMPORTED_MODULE_13__["MoreHorizSvg"], onClick: this.toggleExpanded, toggleState: this.state.isExpanded, title: label + " Properties" }),
                    this.state.isExpanded && react__WEBPACK_IMPORTED_MODULE_1__["createElement"](GroupControl, { inMapped: true, param: param, value: value.params, name: value.name, onChange: this.onChangeParam, onEnter: this.props.onEnter, isDisabled: this.props.isDisabled }));
            }
            return Select;
        }
        return react__WEBPACK_IMPORTED_MODULE_1__["createElement"](react__WEBPACK_IMPORTED_MODULE_1__["Fragment"], null,
            Select,
            react__WEBPACK_IMPORTED_MODULE_1__["createElement"](Mapped, { param: param, value: value.params, name: value.name, onChange: this.onChangeParam, onEnter: this.props.onEnter, isDisabled: this.props.isDisabled }));
    };
    return MappedControl;
}(react__WEBPACK_IMPORTED_MODULE_1__["PureComponent"]));

var ObjectListEditor = /** @class */ (function (_super) {
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__extends"])(ObjectListEditor, _super);
    function ObjectListEditor() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = { current: _this.props.value };
        _this.onChangeParam = function (e) {
            var _a;
            _this.setState({ current: Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, _this.state.current), (_a = {}, _a[e.name] = e.value, _a)) });
        };
        _this.apply = function () {
            _this.props.apply(_this.state.current);
        };
        return _this;
    }
    ObjectListEditor.prototype.componentDidUpdate = function (prevProps) {
        if (this.props.params !== prevProps.params || this.props.value !== prevProps.value) {
            this.setState({ current: this.props.value });
        }
    };
    ObjectListEditor.prototype.render = function () {
        return react__WEBPACK_IMPORTED_MODULE_1__["createElement"](react__WEBPACK_IMPORTED_MODULE_1__["Fragment"], null,
            react__WEBPACK_IMPORTED_MODULE_1__["createElement"](ParameterControls, { params: this.props.params, onChange: this.onChangeParam, values: this.state.current, onEnter: this.apply, isDisabled: this.props.isDisabled }),
            react__WEBPACK_IMPORTED_MODULE_1__["createElement"]("button", { className: "msp-btn msp-btn-block msp-form-control msp-control-top-offset", onClick: this.apply, disabled: this.props.isDisabled }, this.props.isUpdate ? 'Update' : 'Add'));
    };
    return ObjectListEditor;
}(react__WEBPACK_IMPORTED_MODULE_1__["PureComponent"]));
var ObjectListItem = /** @class */ (function (_super) {
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__extends"])(ObjectListItem, _super);
    function ObjectListItem() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = { isExpanded: false };
        _this.update = function (v) {
            // this.setState({ isExpanded: false }); // TODO auto update? mark changed state?
            _this.props.actions.update(v, _this.props.index);
        };
        _this.moveUp = function () {
            _this.props.actions.move(_this.props.index, -1);
        };
        _this.moveDown = function () {
            _this.props.actions.move(_this.props.index, 1);
        };
        _this.remove = function () {
            _this.setState({ isExpanded: false });
            _this.props.actions.remove(_this.props.index);
        };
        _this.toggleExpanded = function (e) {
            _this.setState({ isExpanded: !_this.state.isExpanded });
            e.currentTarget.blur();
        };
        return _this;
    }
    ObjectListItem.prototype.render = function () {
        return react__WEBPACK_IMPORTED_MODULE_1__["createElement"](react__WEBPACK_IMPORTED_MODULE_1__["Fragment"], null,
            react__WEBPACK_IMPORTED_MODULE_1__["createElement"]("div", { className: 'msp-param-object-list-item' },
                react__WEBPACK_IMPORTED_MODULE_1__["createElement"]("button", { className: 'msp-btn msp-btn-block msp-form-control', onClick: this.toggleExpanded },
                    react__WEBPACK_IMPORTED_MODULE_1__["createElement"]("span", null, this.props.index + 1 + ": "),
                    this.props.param.getLabel(this.props.value)),
                react__WEBPACK_IMPORTED_MODULE_1__["createElement"]("div", null,
                    react__WEBPACK_IMPORTED_MODULE_1__["createElement"](_common__WEBPACK_IMPORTED_MODULE_12__["IconButton"], { svg: _icons__WEBPACK_IMPORTED_MODULE_13__["ArrowDownwardSvg"], title: 'Move Up', onClick: this.moveUp, small: true }),
                    react__WEBPACK_IMPORTED_MODULE_1__["createElement"](_common__WEBPACK_IMPORTED_MODULE_12__["IconButton"], { svg: _icons__WEBPACK_IMPORTED_MODULE_13__["ArrowUpwardSvg"], title: 'Move Down', onClick: this.moveDown, small: true }),
                    react__WEBPACK_IMPORTED_MODULE_1__["createElement"](_common__WEBPACK_IMPORTED_MODULE_12__["IconButton"], { svg: _icons__WEBPACK_IMPORTED_MODULE_13__["DeleteOutlinedSvg"], title: 'Remove', onClick: this.remove, small: true }))),
            this.state.isExpanded && react__WEBPACK_IMPORTED_MODULE_1__["createElement"]("div", { className: 'msp-control-offset' },
                react__WEBPACK_IMPORTED_MODULE_1__["createElement"](ObjectListEditor, { params: this.props.param.element, apply: this.update, value: this.props.value, isUpdate: true, isDisabled: this.props.isDisabled })));
    };
    return ObjectListItem;
}(react__WEBPACK_IMPORTED_MODULE_1__["PureComponent"]));
var ObjectListControl = /** @class */ (function (_super) {
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__extends"])(ObjectListControl, _super);
    function ObjectListControl() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = { isExpanded: false };
        _this.add = function (v) {
            _this.change(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__spreadArrays"])(_this.props.value, [v]));
        };
        _this.actions = {
            update: function (v, i) {
                var value = _this.props.value.slice(0);
                value[i] = v;
                _this.change(value);
            },
            move: function (i, dir) {
                var xs = _this.props.value;
                if (xs.length === 1)
                    return;
                var j = (i + dir) % xs.length;
                if (j < 0)
                    j += xs.length;
                xs = xs.slice(0);
                var t = xs[i];
                xs[i] = xs[j];
                xs[j] = t;
                _this.change(xs);
            },
            remove: function (i) {
                var xs = _this.props.value;
                var update = [];
                for (var j = 0; j < xs.length; j++) {
                    if (i !== j)
                        update.push(xs[j]);
                }
                _this.change(update);
            }
        };
        _this.toggleExpanded = function (e) {
            _this.setState({ isExpanded: !_this.state.isExpanded });
            e.currentTarget.blur();
        };
        return _this;
    }
    ObjectListControl.prototype.change = function (value) {
        this.props.onChange({ name: this.props.name, param: this.props.param, value: value });
    };
    ObjectListControl.prototype.render = function () {
        var _this = this;
        var v = this.props.value;
        var label = this.props.param.label || Object(_mol_util_string__WEBPACK_IMPORTED_MODULE_8__["camelCaseToWords"])(this.props.name);
        var value = v.length + " item" + (v.length !== 1 ? 's' : '');
        return react__WEBPACK_IMPORTED_MODULE_1__["createElement"](react__WEBPACK_IMPORTED_MODULE_1__["Fragment"], null,
            react__WEBPACK_IMPORTED_MODULE_1__["createElement"](_common__WEBPACK_IMPORTED_MODULE_12__["ControlRow"], { label: label, control: react__WEBPACK_IMPORTED_MODULE_1__["createElement"]("button", { onClick: this.toggleExpanded, disabled: this.props.isDisabled }, value) }),
            this.state.isExpanded && react__WEBPACK_IMPORTED_MODULE_1__["createElement"]("div", { className: 'msp-control-offset' },
                this.props.value.map(function (v, i) { return react__WEBPACK_IMPORTED_MODULE_1__["createElement"](ObjectListItem, { key: i, param: _this.props.param, value: v, index: i, actions: _this.actions, isDisabled: _this.props.isDisabled }); }),
                react__WEBPACK_IMPORTED_MODULE_1__["createElement"](_common__WEBPACK_IMPORTED_MODULE_12__["ControlGroup"], { header: 'New Item' },
                    react__WEBPACK_IMPORTED_MODULE_1__["createElement"](ObjectListEditor, { params: this.props.param.element, apply: this.add, value: this.props.param.ctor(), isDisabled: this.props.isDisabled }))));
    };
    return ObjectListControl;
}(react__WEBPACK_IMPORTED_MODULE_1__["PureComponent"]));

var ConditionedControl = /** @class */ (function (_super) {
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__extends"])(ConditionedControl, _super);
    function ConditionedControl() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.onChangeCondition = function (e) {
            _this.change(_this.props.param.conditionedValue(_this.props.value, e.value));
        };
        _this.onChangeParam = function (e) {
            _this.change(e.value);
        };
        return _this;
    }
    ConditionedControl.prototype.change = function (value) {
        this.props.onChange({ name: this.props.name, param: this.props.param, value: value });
    };
    ConditionedControl.prototype.render = function () {
        var value = this.props.value;
        var condition = this.props.param.conditionForValue(value);
        var param = this.props.param.conditionParams[condition];
        var label = this.props.param.label || Object(_mol_util_string__WEBPACK_IMPORTED_MODULE_8__["camelCaseToWords"])(this.props.name);
        var Conditioned = controlFor(param);
        var select = react__WEBPACK_IMPORTED_MODULE_1__["createElement"](SelectControl, { param: this.props.param.select, isDisabled: this.props.isDisabled, onChange: this.onChangeCondition, onEnter: this.props.onEnter, name: label + " Kind", value: condition });
        if (!Conditioned) {
            return select;
        }
        return react__WEBPACK_IMPORTED_MODULE_1__["createElement"](react__WEBPACK_IMPORTED_MODULE_1__["Fragment"], null,
            select,
            react__WEBPACK_IMPORTED_MODULE_1__["createElement"](Conditioned, { param: param, value: value, name: label, onChange: this.onChangeParam, onEnter: this.props.onEnter, isDisabled: this.props.isDisabled }));
    };
    return ConditionedControl;
}(react__WEBPACK_IMPORTED_MODULE_1__["PureComponent"]));

var ConvertedControl = /** @class */ (function (_super) {
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__extends"])(ConvertedControl, _super);
    function ConvertedControl() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.onChange = function (e) {
            _this.props.onChange({
                name: _this.props.name,
                param: _this.props.param,
                value: _this.props.param.toValue(e.value)
            });
        };
        return _this;
    }
    ConvertedControl.prototype.render = function () {
        var value = this.props.param.fromValue(this.props.value);
        var Converted = controlFor(this.props.param.converted);
        if (!Converted)
            return null;
        return react__WEBPACK_IMPORTED_MODULE_1__["createElement"](Converted, { param: this.props.param.converted, value: value, name: this.props.name, onChange: this.onChange, onEnter: this.props.onEnter, isDisabled: this.props.isDisabled });
    };
    return ConvertedControl;
}(react__WEBPACK_IMPORTED_MODULE_1__["PureComponent"]));

var ScriptControl = /** @class */ (function (_super) {
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__extends"])(ScriptControl, _super);
    function ScriptControl() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.onChange = function (e) {
            var value = e.target.value;
            if (value !== _this.props.value.expression) {
                _this.update({ language: _this.props.value.language, expression: value });
            }
        };
        _this.onKeyPress = function (e) {
            if ((e.keyCode === 13 || e.charCode === 13 || e.key === 'Enter')) {
                if (_this.props.onEnter)
                    _this.props.onEnter();
            }
            e.stopPropagation();
        };
        return _this;
    }
    ScriptControl.prototype.renderControl = function () {
        // TODO: improve!
        var placeholder = this.props.param.label || Object(_mol_util_string__WEBPACK_IMPORTED_MODULE_8__["camelCaseToWords"])(this.props.name);
        return react__WEBPACK_IMPORTED_MODULE_1__["createElement"]("input", { type: 'text', value: this.props.value.expression || '', placeholder: placeholder, onChange: this.onChange, onKeyPress: this.props.onEnter ? this.onKeyPress : void 0, disabled: this.props.isDisabled });
    };
    return ScriptControl;
}(SimpleParam));

//# sourceMappingURL=parameters.js.map

/***/ }),

/***/ "./lib/mol-plugin-ui/controls/screenshot.js":
/*!**************************************************!*\
  !*** ./lib/mol-plugin-ui/controls/screenshot.js ***!
  \**************************************************/
/*! exports provided: ScreenshotPreview */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ScreenshotPreview", function() { return ScreenshotPreview; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! react */ "./node_modules/react/index.js");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _mol_util_object__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../mol-util/object */ "./lib/mol-util/object.js");
/* harmony import */ var _hooks_use_behavior__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../hooks/use-behavior */ "./lib/mol-plugin-ui/hooks/use-behavior.js");
/**
 * Copyright (c) 2020 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author David Sehnal <david.sehnal@gmail.com>
 */





var _ScreenshotPreview = function (props) {
    var plugin = props.plugin, cropFrameColor = props.cropFrameColor;
    var helper = plugin.helpers.viewportScreenshot;
    var _a = Object(react__WEBPACK_IMPORTED_MODULE_1__["useState"])(null), currentCanvas = _a[0], setCurrentCanvas = _a[1];
    var canvasRef = Object(react__WEBPACK_IMPORTED_MODULE_1__["useRef"])(null);
    var propsRef = Object(react__WEBPACK_IMPORTED_MODULE_1__["useRef"])(props);
    Object(react__WEBPACK_IMPORTED_MODULE_1__["useEffect"])(function () {
        propsRef.current = props;
    }, Object.values(props));
    Object(react__WEBPACK_IMPORTED_MODULE_1__["useEffect"])(function () {
        if (currentCanvas !== canvasRef.current) {
            setCurrentCanvas(canvasRef.current);
        }
    });
    Object(react__WEBPACK_IMPORTED_MODULE_1__["useEffect"])(function () {
        var _a;
        var isDirty = false;
        var subs = [];
        function subscribe(xs, f) {
            if (!xs)
                return;
            subs.push(xs.subscribe(f));
        }
        function preview() {
            var p = propsRef.current;
            if (!p.suspend && canvasRef.current) {
                drawPreview(helper, canvasRef.current, p.customBackground, p.borderColor, p.borderWidth);
            }
            if (!canvasRef.current)
                isDirty = true;
        }
        var interval = setInterval(function () {
            if (isDirty) {
                isDirty = false;
                preview();
            }
        }, 1000 / 8);
        subscribe(plugin.events.canvas3d.settingsUpdated, function () { return isDirty = true; });
        subscribe((_a = plugin.canvas3d) === null || _a === void 0 ? void 0 : _a.didDraw, function () { return isDirty = true; });
        subscribe(plugin.state.data.behaviors.isUpdating, function (v) {
            if (!v)
                isDirty = true;
        });
        subscribe(helper.behaviors.values, function () { return isDirty = true; });
        subscribe(helper.behaviors.cropParams, function () { return isDirty = true; });
        var resizeObserver = void 0;
        if (typeof ResizeObserver !== 'undefined') {
            resizeObserver = new ResizeObserver(function () { return isDirty = true; });
        }
        var canvas = canvasRef.current;
        resizeObserver === null || resizeObserver === void 0 ? void 0 : resizeObserver.observe(canvas);
        preview();
        return function () {
            clearInterval(interval);
            subs.forEach(function (s) { return s.unsubscribe(); });
            resizeObserver === null || resizeObserver === void 0 ? void 0 : resizeObserver.unobserve(canvas);
        };
    }, [helper]);
    Object(react__WEBPACK_IMPORTED_MODULE_1__["useLayoutEffect"])(function () {
        if (canvasRef.current) {
            drawPreview(helper, canvasRef.current, props.customBackground, props.borderColor, props.borderWidth);
        }
    }, Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__spreadArrays"])(Object.values(props)));
    return react__WEBPACK_IMPORTED_MODULE_1__["createElement"](react__WEBPACK_IMPORTED_MODULE_1__["Fragment"], null,
        react__WEBPACK_IMPORTED_MODULE_1__["createElement"]("div", { style: { position: 'relative', width: '100%', height: '100%' } },
            react__WEBPACK_IMPORTED_MODULE_1__["createElement"]("canvas", { ref: canvasRef, onContextMenu: function (e) { e.preventDefault(); e.stopPropagation(); }, style: { display: 'block', width: '100%', height: '100%' } }),
            react__WEBPACK_IMPORTED_MODULE_1__["createElement"](ViewportFrame, { plugin: plugin, canvas: currentCanvas, color: cropFrameColor })));
};
var ScreenshotPreview = react__WEBPACK_IMPORTED_MODULE_1__["memo"](_ScreenshotPreview, function (prev, next) { return Object(_mol_util_object__WEBPACK_IMPORTED_MODULE_2__["shallowEqual"])(prev, next); });
function drawPreview(helper, target, customBackground, borderColor, borderWidth) {
    var _a = helper.getPreview(), canvas = _a.canvas, width = _a.width, height = _a.height;
    var ctx = target.getContext('2d');
    if (!ctx)
        return;
    var w = target.clientWidth;
    var h = target.clientHeight;
    target.width = w;
    target.height = h;
    ctx.clearRect(0, 0, w, h);
    var frame = getViewportFrame(width, height, w, h);
    if (customBackground) {
        ctx.fillStyle = customBackground;
        ctx.fillRect(frame.x, frame.y, frame.width, frame.height);
    }
    else if (helper.values.transparent) {
        // must be an odd number
        var s = 13;
        for (var i = 0; i < frame.width; i += s) {
            for (var j = 0; j < frame.height; j += s) {
                ctx.fillStyle = (i + j) % 2 ? '#ffffff' : '#bfbfbf';
                var x = frame.x + i, y = frame.y + j;
                var w_1 = i + s > frame.width ? frame.width - i : s;
                var h_1 = j + s > frame.height ? frame.height - j : s;
                ctx.fillRect(x, y, w_1, h_1);
            }
        }
    }
    ctx.drawImage(canvas, frame.x, frame.y, frame.width, frame.height);
    if (borderColor && borderWidth) {
        var w_2 = borderWidth;
        ctx.rect(frame.x, frame.y, frame.width, frame.height);
        ctx.rect(frame.x + w_2, frame.y + w_2, frame.width - 2 * w_2, frame.height - 2 * w_2);
        ctx.fillStyle = borderColor;
        ctx.fill('evenodd');
    }
}
function ViewportFrame(_a) {
    var _b;
    var plugin = _a.plugin, canvas = _a.canvas, _c = _a.color, color = _c === void 0 ? 'rgba(255, 87, 45, 0.75)' : _c;
    var helper = plugin.helpers.viewportScreenshot;
    var params = Object(_hooks_use_behavior__WEBPACK_IMPORTED_MODULE_3__["useBehavior"])(helper === null || helper === void 0 ? void 0 : helper.behaviors.values);
    var cropParams = Object(_hooks_use_behavior__WEBPACK_IMPORTED_MODULE_3__["useBehavior"])(helper === null || helper === void 0 ? void 0 : helper.behaviors.cropParams);
    var crop = Object(_hooks_use_behavior__WEBPACK_IMPORTED_MODULE_3__["useBehavior"])(helper === null || helper === void 0 ? void 0 : helper.behaviors.relativeCrop);
    var cropFrameRef = Object(react__WEBPACK_IMPORTED_MODULE_1__["useRef"])({ x: 0, y: 0, width: 0, height: 0 });
    Object(_hooks_use_behavior__WEBPACK_IMPORTED_MODULE_3__["useBehavior"])((params === null || params === void 0 ? void 0 : params.resolution.name) === 'viewport' ? (_b = plugin.canvas3d) === null || _b === void 0 ? void 0 : _b.resized : void 0);
    var _d = react__WEBPACK_IMPORTED_MODULE_1__["useState"](''), drag = _d[0], setDrag = _d[1];
    var _e = Object(react__WEBPACK_IMPORTED_MODULE_1__["useState"])([0, 0]), start = _e[0], setStart = _e[1];
    var _f = Object(react__WEBPACK_IMPORTED_MODULE_1__["useState"])([0, 0]), current = _f[0], setCurrent = _f[1];
    if (!helper || !canvas)
        return null;
    var _g = helper.getSizeAndViewport(), width = _g.width, height = _g.height;
    var frame = getViewportFrame(width, height, canvas.clientWidth, canvas.clientHeight);
    var cropFrame = {
        x: frame.x + Math.floor(frame.width * crop.x),
        y: frame.y + Math.floor(frame.height * crop.y),
        width: Math.ceil(frame.width * crop.width),
        height: Math.ceil(frame.height * crop.height)
    };
    var rectCrop = toRect(cropFrame);
    var rectFrame = toRect(frame);
    if (drag === 'move') {
        rectCrop.l += current[0] - start[0];
        rectCrop.r += current[0] - start[0];
        rectCrop.t += current[1] - start[1];
        rectCrop.b += current[1] - start[1];
    }
    else if (drag) {
        if (drag.indexOf('left') >= 0) {
            rectCrop.l += current[0] - start[0];
        }
        else if (drag.indexOf('right') >= 0) {
            rectCrop.r += current[0] - start[0];
        }
        if (drag.indexOf('top') >= 0) {
            rectCrop.t += current[1] - start[1];
        }
        else if (drag.indexOf('bottom') >= 0) {
            rectCrop.b += current[1] - start[1];
        }
    }
    if (rectCrop.l > rectCrop.r) {
        var t = rectCrop.l;
        rectCrop.l = rectCrop.r;
        rectCrop.r = t;
    }
    if (rectCrop.t > rectCrop.b) {
        var t = rectCrop.t;
        rectCrop.t = rectCrop.b;
        rectCrop.b = t;
    }
    var pad = 40;
    rectCrop.l = Math.min(rectFrame.r - pad, Math.max(rectFrame.l, rectCrop.l));
    rectCrop.r = Math.max(rectFrame.l + pad, Math.min(rectFrame.r, rectCrop.r));
    rectCrop.t = Math.min(rectFrame.b - pad, Math.max(rectFrame.t, rectCrop.t));
    rectCrop.b = Math.max(rectFrame.t + pad, Math.min(rectFrame.b, rectCrop.b));
    cropFrame.x = rectCrop.l;
    cropFrame.y = rectCrop.t;
    cropFrame.width = rectCrop.r - rectCrop.l + 1;
    cropFrame.height = rectCrop.b - rectCrop.t + 1;
    cropFrameRef.current = cropFrame;
    var onMove = function (e) {
        e.preventDefault();
        setCurrent([e.pageX, e.pageY]);
    };
    var onTouchMove = function (e) {
        e.preventDefault();
        var t = e.touches[0];
        setCurrent([t.pageX, t.pageY]);
    };
    var onTouchStart = function (e) {
        e.preventDefault();
        setDrag(e.currentTarget.getAttribute('data-drag'));
        var t = e.touches[0];
        var p = [t.pageX, t.pageY];
        setStart(p);
        setCurrent(p);
        window.addEventListener('touchend', onTouchEnd);
        window.addEventListener('touchmove', onTouchMove);
    };
    var onStart = function (e) {
        e.preventDefault();
        setDrag(e.currentTarget.getAttribute('data-drag'));
        var p = [e.pageX, e.pageY];
        setStart(p);
        setCurrent(p);
        window.addEventListener('mouseup', onEnd);
        window.addEventListener('mousemove', onMove);
    };
    var onEnd = function () {
        window.removeEventListener('mouseup', onEnd);
        window.removeEventListener('mousemove', onMove);
        finish();
    };
    var onTouchEnd = function () {
        window.removeEventListener('touchend', onTouchEnd);
        window.removeEventListener('touchmove', onTouchMove);
        finish();
    };
    function finish() {
        var cropFrame = cropFrameRef.current;
        if (cropParams.auto) {
            helper === null || helper === void 0 ? void 0 : helper.behaviors.cropParams.next(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, cropParams), { auto: false }));
        }
        helper === null || helper === void 0 ? void 0 : helper.behaviors.relativeCrop.next({
            x: (cropFrame.x - frame.x) / frame.width,
            y: (cropFrame.y - frame.y) / frame.height,
            width: cropFrame.width / frame.width,
            height: cropFrame.height / frame.height
        });
        setDrag('');
        var p = [0, 0];
        setStart(p);
        setCurrent(p);
    }
    var contextMenu = function (e) {
        e.preventDefault();
        e.stopPropagation();
    };
    var d = 4;
    var border = "3px solid " + color;
    var transparent = 'transparent';
    return react__WEBPACK_IMPORTED_MODULE_1__["createElement"](react__WEBPACK_IMPORTED_MODULE_1__["Fragment"], null,
        react__WEBPACK_IMPORTED_MODULE_1__["createElement"]("div", { "data-drag": 'move', style: { position: 'absolute', left: cropFrame.x, top: cropFrame.y, width: cropFrame.width, height: cropFrame.height, border: border, cursor: 'move' }, onMouseDown: onStart, onTouchStart: onTouchStart, draggable: false, onContextMenu: contextMenu }),
        react__WEBPACK_IMPORTED_MODULE_1__["createElement"]("div", { "data-drag": 'left', style: { position: 'absolute', left: cropFrame.x - d, top: cropFrame.y + d, width: 4 * d, height: cropFrame.height - d, background: transparent, cursor: 'w-resize' }, onMouseDown: onStart, onTouchStart: onTouchStart, draggable: false, onContextMenu: contextMenu }),
        react__WEBPACK_IMPORTED_MODULE_1__["createElement"]("div", { "data-drag": 'right', style: { position: 'absolute', left: rectCrop.r - 2 * d, top: cropFrame.y, width: 4 * d, height: cropFrame.height - d, background: transparent, cursor: 'w-resize' }, onMouseDown: onStart, onTouchStart: onTouchStart, draggable: false, onContextMenu: contextMenu }),
        react__WEBPACK_IMPORTED_MODULE_1__["createElement"]("div", { "data-drag": 'top', style: { position: 'absolute', left: cropFrame.x - d, top: cropFrame.y - d, width: cropFrame.width + 2 * d, height: 4 * d, background: transparent, cursor: 'n-resize' }, onMouseDown: onStart, onTouchStart: onTouchStart, draggable: false, onContextMenu: contextMenu }),
        react__WEBPACK_IMPORTED_MODULE_1__["createElement"]("div", { "data-drag": 'bottom', style: { position: 'absolute', left: cropFrame.x - d, top: rectCrop.b - 2 * d, width: cropFrame.width + 2 * d, height: 4 * d, background: transparent, cursor: 'n-resize' }, onMouseDown: onStart, onTouchStart: onTouchStart, draggable: false, onContextMenu: contextMenu }),
        react__WEBPACK_IMPORTED_MODULE_1__["createElement"]("div", { "data-drag": 'top, left', style: { position: 'absolute', left: rectCrop.l - d, top: rectCrop.t - d, width: 4 * d, height: 4 * d, background: transparent, cursor: 'nw-resize' }, onMouseDown: onStart, onTouchStart: onTouchStart, draggable: false, onContextMenu: contextMenu }),
        react__WEBPACK_IMPORTED_MODULE_1__["createElement"]("div", { "data-drag": 'bottom, right', style: { position: 'absolute', left: rectCrop.r - 2 * d, top: rectCrop.b - 2 * d, width: 4 * d, height: 4 * d, background: transparent, cursor: 'nw-resize' }, onMouseDown: onStart, onTouchStart: onTouchStart, draggable: false, onContextMenu: contextMenu }),
        react__WEBPACK_IMPORTED_MODULE_1__["createElement"]("div", { "data-drag": 'top, right', style: { position: 'absolute', left: rectCrop.r - 2 * d, top: rectCrop.t - d, width: 4 * d, height: 4 * d, background: transparent, cursor: 'ne-resize' }, onMouseDown: onStart, onTouchStart: onTouchStart, draggable: false, onContextMenu: contextMenu }),
        react__WEBPACK_IMPORTED_MODULE_1__["createElement"]("div", { "data-drag": 'bottom, left', style: { position: 'absolute', left: rectCrop.l - d, top: rectCrop.b - 2 * d, width: 4 * d, height: 4 * d, background: transparent, cursor: 'ne-resize' }, onMouseDown: onStart, onTouchStart: onTouchStart, draggable: false, onContextMenu: contextMenu }));
}
function toRect(viewport) {
    return { l: viewport.x, t: viewport.y, r: viewport.x + viewport.width - 1, b: viewport.y + viewport.height - 1 };
}
function getViewportFrame(srcWidth, srcHeight, w, h) {
    var a0 = srcWidth / srcHeight;
    var a1 = w / h;
    if (a0 <= a1) {
        var t = h * a0;
        return { x: Math.round((w - t) / 2), y: 0, width: Math.round(t), height: h };
    }
    else {
        var t = w / a0;
        return { x: 0, y: Math.round((h - t) / 2), width: w, height: Math.round(t) };
    }
}
//# sourceMappingURL=screenshot.js.map

/***/ }),

/***/ "./lib/mol-plugin-ui/controls/slider.js":
/*!**********************************************!*\
  !*** ./lib/mol-plugin-ui/controls/slider.js ***!
  \**********************************************/
/*! exports provided: Slider, Slider2, Handle, SliderBase */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Slider", function() { return Slider; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Slider2", function() { return Slider2; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Handle", function() { return Handle; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SliderBase", function() { return SliderBase; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! react */ "./node_modules/react/index.js");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _common__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./common */ "./lib/mol-plugin-ui/controls/common.js");
/* harmony import */ var _mol_util__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../mol-util */ "./lib/mol-util/index.js");
/**
 * Copyright (c) 2018-2019 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author David Sehnal <david.sehnal@gmail.com>
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */




var Slider = /** @class */ (function (_super) {
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__extends"])(Slider, _super);
    function Slider() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = { isChanging: false, current: 0 };
        _this.begin = function () {
            _this.setState({ isChanging: true });
        };
        _this.end = function (v) {
            _this.setState({ isChanging: false });
            _this.props.onChange(v);
        };
        _this.updateCurrent = function (current) {
            var _a, _b;
            _this.setState({ current: current });
            (_b = (_a = _this.props).onChangeImmediate) === null || _b === void 0 ? void 0 : _b.call(_a, current);
        };
        _this.updateManually = function (v) {
            _this.setState({ isChanging: true });
            var n = v;
            if (_this.props.step === 1)
                n = Math.round(n);
            if (n < _this.props.min)
                n = _this.props.min;
            if (n > _this.props.max)
                n = _this.props.max;
            _this.setState({ current: n, isChanging: true });
        };
        _this.onManualBlur = function () {
            _this.setState({ isChanging: false });
            _this.props.onChange(_this.state.current);
        };
        return _this;
    }
    Slider.getDerivedStateFromProps = function (props, state) {
        if (state.isChanging || props.value === state.current)
            return null;
        return { current: props.value };
    };
    Slider.prototype.render = function () {
        var step = this.props.step;
        if (step === void 0)
            step = 1;
        return react__WEBPACK_IMPORTED_MODULE_1__["createElement"]("div", { className: 'msp-slider' },
            react__WEBPACK_IMPORTED_MODULE_1__["createElement"]("div", null,
                react__WEBPACK_IMPORTED_MODULE_1__["createElement"](SliderBase, { min: this.props.min, max: this.props.max, step: step, value: this.state.current, disabled: this.props.disabled, onBeforeChange: this.begin, onChange: this.updateCurrent, onAfterChange: this.end })),
            react__WEBPACK_IMPORTED_MODULE_1__["createElement"]("div", null,
                react__WEBPACK_IMPORTED_MODULE_1__["createElement"](_common__WEBPACK_IMPORTED_MODULE_2__["TextInput"], { numeric: true, delayMs: 50, value: this.state.current, blurOnEnter: true, onBlur: this.onManualBlur, isDisabled: this.props.disabled, onChange: this.updateManually })));
    };
    return Slider;
}(react__WEBPACK_IMPORTED_MODULE_1__["Component"]));

var Slider2 = /** @class */ (function (_super) {
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__extends"])(Slider2, _super);
    function Slider2() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = { isChanging: false, current: [0, 1] };
        _this.begin = function () {
            _this.setState({ isChanging: true });
        };
        _this.end = function (v) {
            _this.setState({ isChanging: false });
            _this.props.onChange(v);
        };
        _this.updateCurrent = function (current) {
            _this.setState({ current: current });
        };
        _this.updateMax = function (v) {
            var n = v;
            if (_this.props.step === 1)
                n = Math.round(n);
            if (n < _this.state.current[0])
                n = _this.state.current[0];
            else if (n < _this.props.min)
                n = _this.props.min;
            if (n > _this.props.max)
                n = _this.props.max;
            _this.props.onChange([_this.state.current[0], n]);
        };
        _this.updateMin = function (v) {
            var n = v;
            if (_this.props.step === 1)
                n = Math.round(n);
            if (n < _this.props.min)
                n = _this.props.min;
            if (n > _this.state.current[1])
                n = _this.state.current[1];
            else if (n > _this.props.max)
                n = _this.props.max;
            _this.props.onChange([n, _this.state.current[1]]);
        };
        return _this;
    }
    Slider2.getDerivedStateFromProps = function (props, state) {
        if (state.isChanging || (props.value[0] === state.current[0] && props.value[1] === state.current[1]))
            return null;
        return { current: props.value };
    };
    Slider2.prototype.render = function () {
        var step = this.props.step;
        if (step === void 0)
            step = 1;
        return react__WEBPACK_IMPORTED_MODULE_1__["createElement"]("div", { className: 'msp-slider2' },
            react__WEBPACK_IMPORTED_MODULE_1__["createElement"]("div", null,
                react__WEBPACK_IMPORTED_MODULE_1__["createElement"](_common__WEBPACK_IMPORTED_MODULE_2__["TextInput"], { numeric: true, delayMs: 50, value: this.state.current[0], onEnter: this.props.onEnter, blurOnEnter: true, isDisabled: this.props.disabled, onChange: this.updateMin })),
            react__WEBPACK_IMPORTED_MODULE_1__["createElement"]("div", null,
                react__WEBPACK_IMPORTED_MODULE_1__["createElement"](SliderBase, { min: this.props.min, max: this.props.max, step: step, value: this.state.current, disabled: this.props.disabled, onBeforeChange: this.begin, onChange: this.updateCurrent, onAfterChange: this.end, range: true, allowCross: true })),
            react__WEBPACK_IMPORTED_MODULE_1__["createElement"]("div", null,
                react__WEBPACK_IMPORTED_MODULE_1__["createElement"](_common__WEBPACK_IMPORTED_MODULE_2__["TextInput"], { numeric: true, delayMs: 50, value: this.state.current[1], onEnter: this.props.onEnter, blurOnEnter: true, isDisabled: this.props.disabled, onChange: this.updateMax })));
    };
    return Slider2;
}(react__WEBPACK_IMPORTED_MODULE_1__["Component"]));

/**
 * The following code was adapted from react-components/slider library.
 *
 * The MIT License (MIT)
 * Copyright (c) 2015-present Alipay.com, https://www.alipay.com/
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:

 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.

 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
 * OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
 * MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT.
 * IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY
 * CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT,
 * TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE
 * SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
 */
function classNames(_classes) {
    var classes = [];
    var hasOwn = {}.hasOwnProperty;
    for (var i = 0; i < arguments.length; i++) {
        var arg = arguments[i];
        if (!arg)
            continue;
        var argType = typeof arg;
        if (argType === 'string' || argType === 'number') {
            classes.push(arg);
        }
        else if (Array.isArray(arg)) {
            classes.push(classNames.apply(null, arg));
        }
        else if (argType === 'object') {
            for (var key in arg) {
                if (hasOwn.call(arg, key) && arg[key]) {
                    classes.push(key);
                }
            }
        }
    }
    return classes.join(' ');
}
function isNotTouchEvent(e) {
    return e.touches.length > 1 || (e.type.toLowerCase() === 'touchend' && e.touches.length > 0);
}
function getTouchPosition(vertical, e) {
    return vertical ? e.touches[0].clientY : e.touches[0].pageX;
}
function getMousePosition(vertical, e) {
    return vertical ? e.clientY : e.pageX;
}
function getHandleCenterPosition(vertical, handle) {
    var coords = handle.getBoundingClientRect();
    return vertical ?
        coords.top + (coords.height * 0.5) :
        coords.left + (coords.width * 0.5);
}
function pauseEvent(e) {
    e.stopPropagation();
    e.preventDefault();
}
var Handle = /** @class */ (function (_super) {
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__extends"])(Handle, _super);
    function Handle() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Handle.prototype.render = function () {
        var _a = this.props, className = _a.className, tipFormatter = _a.tipFormatter, vertical = _a.vertical, offset = _a.offset, value = _a.value, index = _a.index;
        var style = vertical ? { bottom: offset + "%" } : { left: offset + "%" };
        return (react__WEBPACK_IMPORTED_MODULE_1__["createElement"]("div", { className: className, style: style, title: tipFormatter(value, index) }));
    };
    return Handle;
}(react__WEBPACK_IMPORTED_MODULE_1__["Component"]));

var SliderBase = /** @class */ (function (_super) {
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__extends"])(SliderBase, _super);
    function SliderBase(props) {
        var _this = _super.call(this, props) || this;
        _this.sliderElement = react__WEBPACK_IMPORTED_MODULE_1__["createRef"]();
        _this.handleElements = [];
        _this.dragOffset = 0;
        _this.startPosition = 0;
        _this.startValue = 0;
        _this._getPointsCache = void 0;
        _this.onMouseDown = function (e) {
            if (e.button !== 0) {
                return;
            }
            var position = getMousePosition(_this.props.vertical, e);
            if (!_this.isEventFromHandle(e)) {
                _this.dragOffset = 0;
            }
            else {
                var handlePosition = getHandleCenterPosition(_this.props.vertical, e.target);
                _this.dragOffset = position - handlePosition;
                position = handlePosition;
            }
            _this.onStart(position);
            _this.addDocumentEvents('mouse');
            pauseEvent(e);
        };
        _this.onTouchMove = function (e) {
            if (isNotTouchEvent(e)) {
                _this.end('touch');
                return;
            }
            var position = getTouchPosition(_this.props.vertical, e);
            _this.onMove(e, position - _this.dragOffset);
        };
        _this.onTouchStart = function (e) {
            if (isNotTouchEvent(e))
                return;
            var position = getTouchPosition(_this.props.vertical, e);
            if (!_this.isEventFromHandle(e)) {
                _this.dragOffset = 0;
            }
            else {
                var handlePosition = getHandleCenterPosition(_this.props.vertical, e.target);
                _this.dragOffset = position - handlePosition;
                position = handlePosition;
            }
            _this.onStart(position);
            _this.addDocumentEvents('touch');
            pauseEvent(e);
        };
        _this.eventHandlers = {
            'touchmove': function (e) { return _this.onTouchMove(e); },
            'touchend': function (e) { return _this.end('touch'); },
            'mousemove': function (e) { return _this.onMouseMove(e); },
            'mouseup': function (e) { return _this.end('mouse'); },
        };
        _this.calcOffset = function (value) {
            var _a = _this.props, min = _a.min, max = _a.max;
            var ratio = (value - min) / (max - min);
            return ratio * 100;
        };
        var range = props.range, min = props.min, max = props.max;
        var initialValue = range ? Array.apply(null, Array(+range + 1)).map(function () { return min; }) : min;
        var defaultValue = ('defaultValue' in props ? props.defaultValue : initialValue);
        var value = (props.value !== undefined ? props.value : defaultValue);
        var bounds = (range ? value : [min, value]).map(function (v) { return _this.trimAlignValue(v); });
        var recent;
        if (range && bounds[0] === bounds[bounds.length - 1] && bounds[0] === max) {
            recent = 0;
        }
        else {
            recent = bounds.length - 1;
        }
        _this.state = {
            handle: null,
            recent: recent,
            bounds: bounds,
        };
        return _this;
    }
    SliderBase.prototype.componentDidUpdate = function (prevProps) {
        var _this = this;
        if (!('value' in this.props || 'min' in this.props || 'max' in this.props))
            return;
        var bounds = this.state.bounds;
        if (prevProps.range) {
            var value = this.props.value || bounds;
            var nextBounds = value.map(function (v) { return _this.trimAlignValue(v, _this.props); });
            if (nextBounds.every(function (v, i) { return v === bounds[i]; }))
                return;
            this.setState({ bounds: nextBounds });
            if (bounds.some(function (v) { return _this.isValueOutOfBounds(v, _this.props); })) {
                this.props.onChange(nextBounds);
            }
        }
        else {
            var value = this.props.value !== undefined ? this.props.value : bounds[1];
            var nextValue = this.trimAlignValue(value, this.props);
            if (nextValue === bounds[1] && bounds[0] === prevProps.min)
                return;
            this.setState({ bounds: [prevProps.min, nextValue] });
            if (this.isValueOutOfBounds(bounds[1], this.props)) {
                this.props.onChange(nextValue);
            }
        }
    };
    SliderBase.prototype.onChange = function (state) {
        var props = this.props;
        var isNotControlled = !('value' in props);
        if (isNotControlled) {
            this.setState(state);
        }
        else if (state.handle !== undefined) {
            this.setState({ handle: state.handle });
        }
        var data = Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, this.state), state);
        var changedValue = props.range ? data.bounds : data.bounds[1];
        props.onChange(changedValue);
    };
    SliderBase.prototype.onMouseMove = function (e) {
        var position = getMousePosition(this.props.vertical, e);
        this.onMove(e, position - this.dragOffset);
    };
    SliderBase.prototype.onMove = function (e, position) {
        pauseEvent(e);
        var props = this.props;
        var state = this.state;
        var diffPosition = position - this.startPosition;
        diffPosition = this.props.vertical ? -diffPosition : diffPosition;
        var diffValue = diffPosition / this.getSliderLength() * (props.max - props.min);
        var value = this.trimAlignValue(this.startValue + diffValue);
        var oldValue = state.bounds[state.handle];
        if (value === oldValue)
            return;
        var nextBounds = Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__spreadArrays"])(state.bounds);
        nextBounds[state.handle] = value;
        var nextHandle = state.handle;
        if (!!props.pushable) {
            var originalValue = state.bounds[nextHandle];
            this.pushSurroundingHandles(nextBounds, nextHandle, originalValue);
        }
        else if (props.allowCross) {
            nextBounds.sort(function (a, b) { return a - b; });
            nextHandle = nextBounds.indexOf(value);
        }
        this.onChange({
            handle: nextHandle,
            bounds: nextBounds,
        });
    };
    SliderBase.prototype.onStart = function (position) {
        var props = this.props;
        props.onBeforeChange(this.getValue());
        var value = this.calcValueByPos(position);
        this.startValue = value;
        this.startPosition = position;
        var state = this.state;
        var bounds = state.bounds;
        var valueNeedChanging = 1;
        if (this.props.range) {
            var closestBound = 0;
            for (var i = 1; i < bounds.length - 1; ++i) {
                if (value > bounds[i]) {
                    closestBound = i;
                }
            }
            if (Math.abs(bounds[closestBound + 1] - value) < Math.abs(bounds[closestBound] - value)) {
                closestBound = closestBound + 1;
            }
            valueNeedChanging = closestBound;
            var isAtTheSamePoint = (bounds[closestBound + 1] === bounds[closestBound]);
            if (isAtTheSamePoint) {
                valueNeedChanging = state.recent;
            }
            if (isAtTheSamePoint && (value !== bounds[closestBound + 1])) {
                valueNeedChanging = value < bounds[closestBound + 1] ? closestBound : closestBound + 1;
            }
        }
        this.setState({
            handle: valueNeedChanging,
            recent: valueNeedChanging,
        });
        var oldValue = state.bounds[valueNeedChanging];
        if (value === oldValue)
            return;
        var nextBounds = Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__spreadArrays"])(state.bounds);
        nextBounds[valueNeedChanging] = value;
        this.onChange({ bounds: nextBounds });
    };
    /**
     * Returns an array of possible slider points, taking into account both
     * `marks` and `step`. The result is cached.
     */
    SliderBase.prototype.getPoints = function () {
        var _a = this.props, marks = _a.marks, step = _a.step, min = _a.min, max = _a.max;
        var cache = this._getPointsCache;
        if (!cache || cache.marks !== marks || cache.step !== step) {
            var pointsObject = Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, marks);
            if (step !== null) {
                for (var point = min; point <= max; point += step) {
                    pointsObject[point] = point;
                }
            }
            var points = Object.keys(pointsObject).map(parseFloat);
            points.sort(function (a, b) { return a - b; });
            this._getPointsCache = { marks: marks, step: step, points: points };
        }
        return this._getPointsCache.points;
    };
    SliderBase.prototype.getPrecision = function (step) {
        var stepString = step.toString();
        var precision = 0;
        if (stepString.indexOf('.') >= 0) {
            precision = stepString.length - stepString.indexOf('.') - 1;
        }
        return precision;
    };
    SliderBase.prototype.getSliderLength = function () {
        var slider = this.sliderElement.current;
        if (!slider) {
            return 0;
        }
        return this.props.vertical ? slider.clientHeight : slider.clientWidth;
    };
    SliderBase.prototype.getSliderStart = function () {
        var slider = this.sliderElement.current;
        var rect = slider.getBoundingClientRect();
        return this.props.vertical ? rect.top : rect.left;
    };
    SliderBase.prototype.getValue = function () {
        var bounds = this.state.bounds;
        return (this.props.range ? bounds : bounds[1]);
    };
    SliderBase.prototype.addDocumentEvents = function (type) {
        if (type === 'touch') {
            document.addEventListener('touchmove', this.eventHandlers.touchmove);
            document.addEventListener('touchend', this.eventHandlers.touchend);
        }
        else if (type === 'mouse') {
            document.addEventListener('mousemove', this.eventHandlers.mousemove);
            document.addEventListener('mouseup', this.eventHandlers.mouseup);
        }
    };
    SliderBase.prototype.calcValue = function (offset) {
        var _a = this.props, vertical = _a.vertical, min = _a.min, max = _a.max;
        var ratio = Math.abs(offset / this.getSliderLength());
        var value = vertical ? (1 - ratio) * (max - min) + min : ratio * (max - min) + min;
        return value;
    };
    SliderBase.prototype.calcValueByPos = function (position) {
        var pixelOffset = position - this.getSliderStart();
        var nextValue = this.trimAlignValue(this.calcValue(pixelOffset));
        return nextValue;
    };
    SliderBase.prototype.end = function (type) {
        this.removeEvents(type);
        this.props.onAfterChange(this.getValue());
        this.setState({ handle: null });
    };
    SliderBase.prototype.isEventFromHandle = function (e) {
        for (var _i = 0, _a = this.handleElements; _i < _a.length; _i++) {
            var h = _a[_i];
            if (h.current === e.target)
                return true;
        }
        return false;
    };
    SliderBase.prototype.isValueOutOfBounds = function (value, props) {
        return value < props.min || value > props.max;
    };
    SliderBase.prototype.pushHandle = function (bounds, handle, direction, amount) {
        var originalValue = bounds[handle];
        var currentValue = bounds[handle];
        while (direction * (currentValue - originalValue) < amount) {
            if (!this.pushHandleOnePoint(bounds, handle, direction)) {
                // can't push handle enough to create the needed `amount` gap, so we
                // revert its position to the original value
                bounds[handle] = originalValue;
                return false;
            }
            currentValue = bounds[handle];
        }
        // the handle was pushed enough to create the needed `amount` gap
        return true;
    };
    SliderBase.prototype.pushHandleOnePoint = function (bounds, handle, direction) {
        var points = this.getPoints();
        var pointIndex = points.indexOf(bounds[handle]);
        var nextPointIndex = pointIndex + direction;
        if (nextPointIndex >= points.length || nextPointIndex < 0) {
            // reached the minimum or maximum available point, can't push anymore
            return false;
        }
        var nextHandle = handle + direction;
        var nextValue = points[nextPointIndex];
        var threshold = this.props.pushable;
        var diffToNext = direction * (bounds[nextHandle] - nextValue);
        if (!this.pushHandle(bounds, nextHandle, direction, +threshold - diffToNext)) {
            // couldn't push next handle, so we won't push this one either
            return false;
        }
        // push the handle
        bounds[handle] = nextValue;
        return true;
    };
    SliderBase.prototype.pushSurroundingHandles = function (bounds, handle, originalValue) {
        var threshold = this.props.pushable;
        var value = bounds[handle];
        var direction = 0;
        if (bounds[handle + 1] - value < threshold) {
            direction = +1;
        }
        else if (value - bounds[handle - 1] < threshold) {
            direction = -1;
        }
        if (direction === 0) {
            return;
        }
        var nextHandle = handle + direction;
        var diffToNext = direction * (bounds[nextHandle] - value);
        if (!this.pushHandle(bounds, nextHandle, direction, +threshold - diffToNext)) {
            // revert to original value if pushing is impossible
            bounds[handle] = originalValue;
        }
    };
    SliderBase.prototype.removeEvents = function (type) {
        if (type === 'touch') {
            document.removeEventListener('touchmove', this.eventHandlers.touchmove);
            document.removeEventListener('touchend', this.eventHandlers.touchend);
        }
        else if (type === 'mouse') {
            document.removeEventListener('mousemove', this.eventHandlers.mousemove);
            document.removeEventListener('mouseup', this.eventHandlers.mouseup);
        }
    };
    SliderBase.prototype.trimAlignValue = function (v, props) {
        var _a = (this.state || {}), handle = _a.handle, bounds = _a.bounds;
        var _b = Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, this.props), (props || {})), marks = _b.marks, step = _b.step, min = _b.min, max = _b.max, allowCross = _b.allowCross;
        var val = v;
        if (val <= min) {
            val = min;
        }
        if (val >= max) {
            val = max;
        }
        /* eslint-disable eqeqeq */
        if (!allowCross && handle != null && handle > 0 && val <= bounds[handle - 1]) {
            val = bounds[handle - 1];
        }
        if (!allowCross && handle != null && handle < bounds.length - 1 && val >= bounds[handle + 1]) {
            val = bounds[handle + 1];
        }
        /* eslint-enable eqeqeq */
        var points = Object.keys(marks).map(parseFloat);
        if (step !== null) {
            var closestStep = (Math.round((val - min) / step) * step) + min;
            points.push(closestStep);
        }
        var diffs = points.map(function (point) { return Math.abs(val - point); });
        var closestPoint = points[diffs.indexOf(Math.min.apply(Math, diffs))];
        return step !== null ? parseFloat(closestPoint.toFixed(this.getPrecision(step))) : closestPoint;
    };
    SliderBase.prototype.render = function () {
        var _a;
        var _this = this;
        var _b = this.state, handle = _b.handle, bounds = _b.bounds;
        var _c = this.props, className = _c.className, prefixCls = _c.prefixCls, disabled = _c.disabled, vertical = _c.vertical, range = _c.range, step = _c.step, marks = _c.marks, tipFormatter = _c.tipFormatter;
        var customHandle = this.props.handle;
        var offsets = bounds.map(this.calcOffset);
        var handleClassName = prefixCls + "-handle";
        var handlesClassNames = bounds.map(function (v, i) {
            var _a;
            return classNames((_a = {},
                _a[handleClassName] = true,
                _a[handleClassName + "-" + (i + 1)] = true,
                _a[handleClassName + "-lower"] = i === 0,
                _a[handleClassName + "-upper"] = i === bounds.length - 1,
                _a));
        });
        var isNoTip = (step === null) || (tipFormatter === null);
        var commonHandleProps = {
            prefixCls: prefixCls,
            noTip: isNoTip,
            tipFormatter: tipFormatter,
            vertical: vertical,
        };
        if (this.handleElements.length !== bounds.length) {
            this.handleElements = []; // = [];
            for (var i = 0; i < bounds.length; i++)
                this.handleElements.push(react__WEBPACK_IMPORTED_MODULE_1__["createRef"]());
        }
        var handles = bounds.map(function (v, i) { return react__WEBPACK_IMPORTED_MODULE_1__["cloneElement"](customHandle, Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, commonHandleProps), { className: handlesClassNames[i], value: v, offset: offsets[i], dragging: handle === i, index: i, key: i, ref: _this.handleElements[i] })); });
        if (!range) {
            handles.shift();
        }
        var sliderClassName = classNames((_a = {},
            _a[prefixCls] = true,
            _a[prefixCls + "-with-marks"] = Object.keys(marks).length,
            _a[prefixCls + "-disabled"] = disabled,
            _a[prefixCls + "-vertical"] = this.props.vertical,
            _a[className] = !!className,
            _a));
        return (react__WEBPACK_IMPORTED_MODULE_1__["createElement"]("div", { ref: this.sliderElement, className: sliderClassName, onTouchStart: disabled ? _mol_util__WEBPACK_IMPORTED_MODULE_3__["noop"] : this.onTouchStart, onMouseDown: disabled ? _mol_util__WEBPACK_IMPORTED_MODULE_3__["noop"] : this.onMouseDown },
            react__WEBPACK_IMPORTED_MODULE_1__["createElement"]("div", { className: prefixCls + "-rail" }),
            handles));
    };
    SliderBase.defaultProps = {
        prefixCls: 'msp-slider-base',
        className: '',
        min: 0,
        max: 100,
        step: 1,
        marks: {},
        handle: react__WEBPACK_IMPORTED_MODULE_1__["createElement"](Handle, { className: '', vertical: false, offset: 0, tipFormatter: function (v) { return v; }, value: 0, index: 0 }),
        onBeforeChange: _mol_util__WEBPACK_IMPORTED_MODULE_3__["noop"],
        onChange: _mol_util__WEBPACK_IMPORTED_MODULE_3__["noop"],
        onAfterChange: _mol_util__WEBPACK_IMPORTED_MODULE_3__["noop"],
        tipFormatter: function (value, index) { return value; },
        disabled: false,
        range: false,
        vertical: false,
        allowCross: true,
        pushable: false,
    };
    return SliderBase;
}(react__WEBPACK_IMPORTED_MODULE_1__["Component"]));

//# sourceMappingURL=slider.js.map

/***/ }),

/***/ "./lib/mol-plugin-ui/custom/volume.js":
/*!********************************************!*\
  !*** ./lib/mol-plugin-ui/custom/volume.js ***!
  \********************************************/
/*! exports provided: VolumeStreamingCustomControls */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "VolumeStreamingCustomControls", function() { return VolumeStreamingCustomControls; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _base__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../base */ "./lib/mol-plugin-ui/base.js");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! react */ "./node_modules/react/index.js");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _mol_plugin_behavior_dynamic_volume_streaming_behavior__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../mol-plugin/behavior/dynamic/volume-streaming/behavior */ "./lib/mol-plugin/behavior/dynamic/volume-streaming/behavior.js");
/* harmony import */ var _controls_common__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../controls/common */ "./lib/mol-plugin-ui/controls/common.js");
/* harmony import */ var _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../mol-util/param-definition */ "./lib/mol-util/param-definition.js");
/* harmony import */ var _controls_parameters__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../controls/parameters */ "./lib/mol-plugin-ui/controls/parameters.js");
/* harmony import */ var _controls_slider__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../controls/slider */ "./lib/mol-plugin-ui/controls/slider.js");
/* harmony import */ var _mol_model_volume__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ../../mol-model/volume */ "./lib/mol-model/volume.js");
/* harmony import */ var _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ../../mol-math/linear-algebra */ "./lib/mol-math/linear-algebra.js");
/* harmony import */ var _mol_util_color_names__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ../../mol-util/color/names */ "./lib/mol-util/color/names.js");
/* harmony import */ var _mol_util_number__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ../../mol-util/number */ "./lib/mol-util/number.js");
/* harmony import */ var _mol_state__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! ../../mol-state */ "./lib/mol-state/index.js");
/* harmony import */ var _mol_plugin_behavior_static_state__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! ../../mol-plugin/behavior/static/state */ "./lib/mol-plugin/behavior/static/state.js");
/* harmony import */ var _controls_icons__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! ../controls/icons */ "./lib/mol-plugin-ui/controls/icons.js");
/**
 * Copyright (c) 2019 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author David Sehnal <david.sehnal@gmail.com>
 */















var ChannelParams = {
    color: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_5__["ParamDefinition"].Color(_mol_util_color_names__WEBPACK_IMPORTED_MODULE_10__["ColorNames"].black, { description: 'Display color of the volume.' }),
    wireframe: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_5__["ParamDefinition"].Boolean(false, { description: 'Control display of the volume as a wireframe.' }),
    opacity: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_5__["ParamDefinition"].Numeric(0.3, { min: 0, max: 1, step: 0.01 }, { description: 'Opacity of the volume.' })
};
var Bounds = new Map([
    ['em', [-5, 5]],
    ['2fo-fc', [0, 3]],
    ['fo-fc(+ve)', [1, 5]],
    ['fo-fc(-ve)', [-5, -1]],
]);
var Channel = /** @class */ (function (_super) {
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__extends"])(Channel, _super);
    function Channel() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.ref = _mol_state__WEBPACK_IMPORTED_MODULE_12__["StateSelection"].findTagInSubtree(_this.plugin.state.data.tree, _this.props.bCell.transform.ref, _this.props.name);
        _this.getVisible = function () {
            var state = _this.plugin.state.data;
            var ref = _this.ref;
            if (!ref)
                return false;
            return !state.cells.get(ref).state.isHidden;
        };
        _this.toggleVisible = function () {
            var state = _this.plugin.state.data;
            var ref = _this.ref;
            if (!ref)
                return;
            Object(_mol_plugin_behavior_static_state__WEBPACK_IMPORTED_MODULE_13__["setSubtreeVisibility"])(state, ref, !state.cells.get(ref).state.isHidden);
        };
        return _this;
    }
    Channel.prototype.componentDidUpdate = function () {
        this.ref = _mol_state__WEBPACK_IMPORTED_MODULE_12__["StateSelection"].findTagInSubtree(this.plugin.state.data.tree, this.props.bCell.transform.ref, this.props.name);
    };
    Channel.prototype.componentDidMount = function () {
        var _this = this;
        this.subscribe(this.plugin.state.data.events.cell.stateUpdated, function (e) {
            if (_this.ref === e.ref)
                _this.forceUpdate();
        });
    };
    Channel.prototype.render = function () {
        var props = this.props;
        var isRelative = props.isRelative, stats = props.stats;
        var channel = props.channels[props.name];
        var min = stats.min, max = stats.max, mean = stats.mean, sigma = stats.sigma;
        var value = Math.round(100 * (channel.isoValue.kind === 'relative' ? channel.isoValue.relativeValue : channel.isoValue.absoluteValue)) / 100;
        var relMin = (min - mean) / sigma;
        var relMax = (max - mean) / sigma;
        if (!this.props.isUnbounded) {
            var bounds = Bounds.get(this.props.name);
            if (this.props.name === 'em') {
                relMin = Math.max(bounds[0], relMin);
                relMax = Math.min(bounds[1], relMax);
            }
            else {
                relMin = bounds[0];
                relMax = bounds[1];
            }
        }
        var vMin = mean + sigma * relMin, vMax = mean + sigma * relMax;
        var step = Object(_mol_util_number__WEBPACK_IMPORTED_MODULE_11__["toPrecision"])(isRelative ? Math.round(((vMax - vMin) / sigma)) / 100 : sigma / 100, 2);
        var ctrlMin = isRelative ? relMin : vMin;
        var ctrlMax = isRelative ? relMax : vMax;
        return react__WEBPACK_IMPORTED_MODULE_2__["createElement"](_controls_common__WEBPACK_IMPORTED_MODULE_4__["ExpandableControlRow"], { label: props.label + (props.isRelative ? ' \u03C3' : ''), colorStripe: channel.color, pivot: react__WEBPACK_IMPORTED_MODULE_2__["createElement"]("div", { className: 'msp-volume-channel-inline-controls' },
                react__WEBPACK_IMPORTED_MODULE_2__["createElement"](_controls_slider__WEBPACK_IMPORTED_MODULE_7__["Slider"], { value: value, min: ctrlMin, max: ctrlMax, step: step, onChange: function (v) { return props.changeIso(props.name, v, isRelative); }, disabled: props.params.isDisabled, onEnter: props.params.events.onEnter }),
                react__WEBPACK_IMPORTED_MODULE_2__["createElement"](_controls_common__WEBPACK_IMPORTED_MODULE_4__["IconButton"], { svg: this.getVisible() ? _controls_icons__WEBPACK_IMPORTED_MODULE_14__["VisibilityOutlinedSvg"] : _controls_icons__WEBPACK_IMPORTED_MODULE_14__["VisibilityOffOutlinedSvg"], onClick: this.toggleVisible, toggleState: false, disabled: props.params.isDisabled })), controls: react__WEBPACK_IMPORTED_MODULE_2__["createElement"](_controls_parameters__WEBPACK_IMPORTED_MODULE_6__["ParameterControls"], { onChange: function (_a) {
                    var name = _a.name, value = _a.value;
                    return props.changeParams(props.name, name, value);
                }, params: ChannelParams, values: channel, onEnter: props.params.events.onEnter, isDisabled: props.params.isDisabled }) });
    };
    return Channel;
}(_base__WEBPACK_IMPORTED_MODULE_1__["PluginUIComponent"]));
var VolumeStreamingCustomControls = /** @class */ (function (_super) {
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__extends"])(VolumeStreamingCustomControls, _super);
    function VolumeStreamingCustomControls() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.changeIso = function (name, value, isRelative) {
            var _a;
            var old = _this.props.params;
            _this.newParams(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, old), { entry: {
                    name: old.entry.name,
                    params: Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, old.entry.params), { channels: Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, old.entry.params.channels), (_a = {}, _a[name] = Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, old.entry.params.channels[name]), { isoValue: isRelative ? _mol_model_volume__WEBPACK_IMPORTED_MODULE_8__["Volume"].IsoValue.relative(value) : _mol_model_volume__WEBPACK_IMPORTED_MODULE_8__["Volume"].IsoValue.absolute(value) }), _a)) })
                } }));
        };
        _this.changeParams = function (name, param, value) {
            var _a, _b;
            var old = _this.props.params;
            _this.newParams(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, old), { entry: {
                    name: old.entry.name,
                    params: Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, old.entry.params), { channels: Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, old.entry.params.channels), (_a = {}, _a[name] = Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, old.entry.params.channels[name]), (_b = {}, _b[param] = value, _b)), _a)) })
                } }));
        };
        _this.changeOption = function (_a) {
            var name = _a.name, value = _a.value;
            var old = _this.props.params;
            if (name === 'entry') {
                _this.newParams(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, old), { entry: {
                        name: value,
                        params: old.entry.params,
                    } }));
            }
            else {
                var b = _this.props.b.data;
                var isEM = b.info.kind === 'em';
                var isRelative = value.params.isRelative;
                var sampling = b.info.header.sampling[0];
                var oldChannels = old.entry.params.channels;
                var oldView = old.entry.params.view.name === value.name
                    ? old.entry.params.view.params
                    : _this.props.info.params
                        .entry.map(old.entry.name)
                        .params
                        .view.map(value.name).defaultValue;
                var viewParams = Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, oldView);
                if (value.name === 'selection-box') {
                    viewParams.radius = value.params.radius;
                }
                else if (value.name === 'box') {
                    viewParams.bottomLeft = value.params.bottomLeft;
                    viewParams.topRight = value.params.topRight;
                }
                else if (value.name === 'auto') {
                    viewParams.radius = value.params.radius;
                    viewParams.selectionDetailLevel = value.params.selectionDetailLevel;
                }
                viewParams.isUnbounded = !!value.params.isUnbounded;
                _this.newParams(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, old), { entry: {
                        name: old.entry.name,
                        params: Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, old.entry.params), { view: {
                                name: value.name,
                                params: viewParams
                            }, detailLevel: value.params.detailLevel, channels: isEM
                                ? { em: _this.convert(oldChannels.em, sampling.valuesInfo[0], isRelative) }
                                : {
                                    '2fo-fc': _this.convert(oldChannels['2fo-fc'], sampling.valuesInfo[0], isRelative),
                                    'fo-fc(+ve)': _this.convert(oldChannels['fo-fc(+ve)'], sampling.valuesInfo[1], isRelative),
                                    'fo-fc(-ve)': _this.convert(oldChannels['fo-fc(-ve)'], sampling.valuesInfo[1], isRelative)
                                } })
                    } }));
            }
        };
        return _this;
    }
    VolumeStreamingCustomControls.prototype.areInitial = function (params) {
        return _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_5__["ParamDefinition"].areEqual(this.props.info.params, params, this.props.info.initialValues);
    };
    VolumeStreamingCustomControls.prototype.newParams = function (params) {
        this.props.events.onChange(params, this.areInitial(params));
    };
    VolumeStreamingCustomControls.prototype.convert = function (channel, stats, isRelative) {
        return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, channel), { isoValue: isRelative
                ? _mol_model_volume__WEBPACK_IMPORTED_MODULE_8__["Volume"].IsoValue.toRelative(channel.isoValue, stats)
                : _mol_model_volume__WEBPACK_IMPORTED_MODULE_8__["Volume"].IsoValue.toAbsolute(channel.isoValue, stats) });
    };
    VolumeStreamingCustomControls.prototype.render = function () {
        if (!this.props.b)
            return null;
        var b = this.props.b.data;
        var isEM = b.info.kind === 'em';
        var pivot = isEM ? 'em' : '2fo-fc';
        var params = this.props.params;
        var entry = this.props.info.params
            .entry.map(params.entry.name);
        var detailLevel = entry.params.detailLevel;
        var isRelative = params.entry.params.channels[pivot].isoValue.kind === 'relative';
        var sampling = b.info.header.sampling[0];
        var isRelativeParam = _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_5__["ParamDefinition"].Boolean(isRelative, { description: 'Use normalized or absolute isocontour scale.', label: 'Normalized' });
        var isUnbounded = !!params.entry.params.view.params.isUnbounded;
        var isUnboundedParam = _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_5__["ParamDefinition"].Boolean(isUnbounded, { description: 'Show full/limited range of iso-values for more fine-grained control.', label: 'Unbounded' });
        var isOff = params.entry.params.view.name === 'off';
        // TODO: factor common things out, cache
        var OptionsParams = {
            entry: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_5__["ParamDefinition"].Select(params.entry.name, b.data.entries.map(function (info) { return [info.dataId, info.dataId]; }), { isHidden: isOff, description: 'Which entry with volume data to display.' }),
            view: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_5__["ParamDefinition"].MappedStatic(params.entry.params.view.name, {
                'off': _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_5__["ParamDefinition"].Group({
                    isRelative: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_5__["ParamDefinition"].Boolean(isRelative, { isHidden: true }),
                    isUnbounded: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_5__["ParamDefinition"].Boolean(isUnbounded, { isHidden: true }),
                }, { description: 'Display off.' }),
                'box': _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_5__["ParamDefinition"].Group({
                    bottomLeft: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_5__["ParamDefinition"].Vec3(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_9__["Vec3"].zero()),
                    topRight: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_5__["ParamDefinition"].Vec3(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_9__["Vec3"].zero()),
                    detailLevel: detailLevel,
                    isRelative: isRelativeParam,
                    isUnbounded: isUnboundedParam,
                }, { description: 'Static box defined by cartesian coords.' }),
                'selection-box': _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_5__["ParamDefinition"].Group({
                    radius: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_5__["ParamDefinition"].Numeric(5, { min: 0, max: 50, step: 0.5 }, { description: 'Radius in \u212B within which the volume is shown.' }),
                    detailLevel: detailLevel,
                    isRelative: isRelativeParam,
                    isUnbounded: isUnboundedParam,
                }, { description: 'Box around focused element.' }),
                'cell': _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_5__["ParamDefinition"].Group({
                    detailLevel: detailLevel,
                    isRelative: isRelativeParam,
                    isUnbounded: isUnboundedParam,
                }, { description: 'Box around the structure\'s bounding box.' }),
                'auto': _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_5__["ParamDefinition"].Group({
                    radius: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_5__["ParamDefinition"].Numeric(5, { min: 0, max: 50, step: 0.5 }, { description: 'Radius in \u212B within which the volume is shown.' }),
                    detailLevel: detailLevel,
                    selectionDetailLevel: Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, detailLevel), { label: 'Selection Detail' }),
                    isRelative: isRelativeParam,
                    isUnbounded: isUnboundedParam,
                }, { description: 'Box around focused element.' }),
            }, { options: _mol_plugin_behavior_dynamic_volume_streaming_behavior__WEBPACK_IMPORTED_MODULE_3__["VolumeStreaming"].ViewTypeOptions, description: 'Controls what of the volume is displayed. "Off" hides the volume alltogether. "Bounded box" shows the volume inside the given box. "Around Focus" shows the volume around the element/atom last interacted with. "Whole Structure" shows the volume for the whole structure.' })
        };
        var options = {
            entry: params.entry.name,
            view: {
                name: params.entry.params.view.name,
                params: {
                    detailLevel: params.entry.params.detailLevel,
                    radius: params.entry.params.view.params.radius,
                    bottomLeft: params.entry.params.view.params.bottomLeft,
                    topRight: params.entry.params.view.params.topRight,
                    selectionDetailLevel: params.entry.params.view.params.selectionDetailLevel,
                    isRelative: isRelative,
                    isUnbounded: isUnbounded
                }
            }
        };
        if (isOff) {
            return react__WEBPACK_IMPORTED_MODULE_2__["createElement"](_controls_parameters__WEBPACK_IMPORTED_MODULE_6__["ParameterControls"], { onChange: this.changeOption, params: OptionsParams, values: options, onEnter: this.props.events.onEnter, isDisabled: this.props.isDisabled });
        }
        return react__WEBPACK_IMPORTED_MODULE_2__["createElement"](react__WEBPACK_IMPORTED_MODULE_2__["Fragment"], null,
            !isEM && react__WEBPACK_IMPORTED_MODULE_2__["createElement"](Channel, { label: '2Fo-Fc', name: '2fo-fc', bCell: this.props.bCell, channels: params.entry.params.channels, changeIso: this.changeIso, changeParams: this.changeParams, isRelative: isRelative, params: this.props, stats: sampling.valuesInfo[0], isUnbounded: isUnbounded }),
            !isEM && react__WEBPACK_IMPORTED_MODULE_2__["createElement"](Channel, { label: 'Fo-Fc(+ve)', name: 'fo-fc(+ve)', bCell: this.props.bCell, channels: params.entry.params.channels, changeIso: this.changeIso, changeParams: this.changeParams, isRelative: isRelative, params: this.props, stats: sampling.valuesInfo[1], isUnbounded: isUnbounded }),
            !isEM && react__WEBPACK_IMPORTED_MODULE_2__["createElement"](Channel, { label: 'Fo-Fc(-ve)', name: 'fo-fc(-ve)', bCell: this.props.bCell, channels: params.entry.params.channels, changeIso: this.changeIso, changeParams: this.changeParams, isRelative: isRelative, params: this.props, stats: sampling.valuesInfo[1], isUnbounded: isUnbounded }),
            isEM && react__WEBPACK_IMPORTED_MODULE_2__["createElement"](Channel, { label: 'EM', name: 'em', bCell: this.props.bCell, channels: params.entry.params.channels, changeIso: this.changeIso, changeParams: this.changeParams, isRelative: isRelative, params: this.props, stats: sampling.valuesInfo[0], isUnbounded: isUnbounded }),
            react__WEBPACK_IMPORTED_MODULE_2__["createElement"](_controls_parameters__WEBPACK_IMPORTED_MODULE_6__["ParameterControls"], { onChange: this.changeOption, params: OptionsParams, values: options, onEnter: this.props.events.onEnter, isDisabled: this.props.isDisabled }));
    };
    return VolumeStreamingCustomControls;
}(_base__WEBPACK_IMPORTED_MODULE_1__["PluginUIComponent"]));

//# sourceMappingURL=volume.js.map

/***/ }),

/***/ "./lib/mol-plugin-ui/hooks/use-behavior.js":
/*!*************************************************!*\
  !*** ./lib/mol-plugin-ui/hooks/use-behavior.js ***!
  \*************************************************/
/*! exports provided: useBehavior */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "useBehavior", function() { return useBehavior; });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react */ "./node_modules/react/index.js");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/**
 * Copyright (c) 2020 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author David Sehnal <david.sehnal@gmail.com>
 */

// eslint-disable-next-line
function useBehavior(s) {
    var _a = Object(react__WEBPACK_IMPORTED_MODULE_0__["useState"])(s === null || s === void 0 ? void 0 : s.value), value = _a[0], setValue = _a[1];
    Object(react__WEBPACK_IMPORTED_MODULE_0__["useEffect"])(function () {
        if (!s) {
            if (value !== void 0)
                setValue(void 0);
            return;
        }
        var fst = true;
        var sub = s.subscribe(function (v) {
            if (fst) {
                fst = false;
                if (v !== value)
                    setValue(v);
            }
            else
                setValue(v);
        });
        return function () {
            sub.unsubscribe();
        };
        // eslint-disable-next-line
    }, [s]);
    return value;
}
//# sourceMappingURL=use-behavior.js.map

/***/ }),

/***/ "./lib/mol-plugin-ui/left-panel.js":
/*!*****************************************!*\
  !*** ./lib/mol-plugin-ui/left-panel.js ***!
  \*****************************************/
/*! exports provided: LeftPanelControls */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "LeftPanelControls", function() { return LeftPanelControls; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! react */ "./node_modules/react/index.js");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _mol_canvas3d_canvas3d__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../mol-canvas3d/canvas3d */ "./lib/mol-canvas3d/canvas3d.js");
/* harmony import */ var _mol_plugin_commands__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../mol-plugin/commands */ "./lib/mol-plugin/commands.js");
/* harmony import */ var _mol_state__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../mol-state */ "./lib/mol-state/index.js");
/* harmony import */ var _base__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./base */ "./lib/mol-plugin-ui/base.js");
/* harmony import */ var _controls_common__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ./controls/common */ "./lib/mol-plugin-ui/controls/common.js");
/* harmony import */ var _controls_parameters__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ./controls/parameters */ "./lib/mol-plugin-ui/controls/parameters.js");
/* harmony import */ var _state_actions__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ./state/actions */ "./lib/mol-plugin-ui/state/actions.js");
/* harmony import */ var _state_snapshots__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ./state/snapshots */ "./lib/mol-plugin-ui/state/snapshots.js");
/* harmony import */ var _state_tree__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ./state/tree */ "./lib/mol-plugin-ui/state/tree.js");
/* harmony import */ var _viewport_help__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ./viewport/help */ "./lib/mol-plugin-ui/viewport/help.js");
/* harmony import */ var _controls_icons__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! ./controls/icons */ "./lib/mol-plugin-ui/controls/icons.js");
/**
 * Copyright (c) 2019 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author David Sehnal <david.sehnal@gmail.com>
 */













var LeftPanelControls = /** @class */ (function (_super) {
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__extends"])(LeftPanelControls, _super);
    function LeftPanelControls() {
        var _a;
        var _this = _super.apply(this, arguments) || this;
        _this.state = { tab: _this.plugin.behaviors.layout.leftPanelTabName.value };
        _this.set = function (tab) {
            if (_this.state.tab === tab) {
                _this.setState({ tab: 'none' }, function () { return _this.plugin.behaviors.layout.leftPanelTabName.next('none'); });
                _mol_plugin_commands__WEBPACK_IMPORTED_MODULE_3__["PluginCommands"].Layout.Update(_this.plugin, { state: { regionState: Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, _this.plugin.layout.state.regionState), { left: 'collapsed' }) } });
                return;
            }
            _this.setState({ tab: tab }, function () { return _this.plugin.behaviors.layout.leftPanelTabName.next(tab); });
            if (_this.plugin.layout.state.regionState.left !== 'full') {
                _mol_plugin_commands__WEBPACK_IMPORTED_MODULE_3__["PluginCommands"].Layout.Update(_this.plugin, { state: { regionState: Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, _this.plugin.layout.state.regionState), { left: 'full' }) } });
            }
        };
        _this.tabs = {
            'none': react__WEBPACK_IMPORTED_MODULE_1__["createElement"](react__WEBPACK_IMPORTED_MODULE_1__["Fragment"], null),
            'root': react__WEBPACK_IMPORTED_MODULE_1__["createElement"](react__WEBPACK_IMPORTED_MODULE_1__["Fragment"], null,
                react__WEBPACK_IMPORTED_MODULE_1__["createElement"](_controls_common__WEBPACK_IMPORTED_MODULE_6__["SectionHeader"], { icon: _controls_icons__WEBPACK_IMPORTED_MODULE_12__["HomeOutlinedSvg"], title: 'Home' }),
                react__WEBPACK_IMPORTED_MODULE_1__["createElement"](_state_actions__WEBPACK_IMPORTED_MODULE_8__["StateObjectActions"], { state: _this.plugin.state.data, nodeRef: _mol_state__WEBPACK_IMPORTED_MODULE_4__["StateTransform"].RootRef, hideHeader: true, initiallyCollapsed: true, alwaysExpandFirst: true }),
                ((_a = _this.plugin.spec.components) === null || _a === void 0 ? void 0 : _a.remoteState) !== 'none' && react__WEBPACK_IMPORTED_MODULE_1__["createElement"](_state_snapshots__WEBPACK_IMPORTED_MODULE_9__["RemoteStateSnapshots"], { listOnly: true })),
            'data': react__WEBPACK_IMPORTED_MODULE_1__["createElement"](react__WEBPACK_IMPORTED_MODULE_1__["Fragment"], null,
                react__WEBPACK_IMPORTED_MODULE_1__["createElement"](_controls_common__WEBPACK_IMPORTED_MODULE_6__["SectionHeader"], { icon: _controls_icons__WEBPACK_IMPORTED_MODULE_12__["AccountTreeOutlinedSvg"], title: react__WEBPACK_IMPORTED_MODULE_1__["createElement"](react__WEBPACK_IMPORTED_MODULE_1__["Fragment"], null,
                        react__WEBPACK_IMPORTED_MODULE_1__["createElement"](RemoveAllButton, null),
                        " State Tree") }),
                react__WEBPACK_IMPORTED_MODULE_1__["createElement"](_state_tree__WEBPACK_IMPORTED_MODULE_10__["StateTree"], { state: _this.plugin.state.data })),
            'states': react__WEBPACK_IMPORTED_MODULE_1__["createElement"](_state_snapshots__WEBPACK_IMPORTED_MODULE_9__["StateSnapshots"], null),
            'settings': react__WEBPACK_IMPORTED_MODULE_1__["createElement"](react__WEBPACK_IMPORTED_MODULE_1__["Fragment"], null,
                react__WEBPACK_IMPORTED_MODULE_1__["createElement"](_controls_common__WEBPACK_IMPORTED_MODULE_6__["SectionHeader"], { icon: _controls_icons__WEBPACK_IMPORTED_MODULE_12__["TuneSvg"], title: 'Plugin Settings' }),
                react__WEBPACK_IMPORTED_MODULE_1__["createElement"](FullSettings, null)),
            'help': react__WEBPACK_IMPORTED_MODULE_1__["createElement"](react__WEBPACK_IMPORTED_MODULE_1__["Fragment"], null,
                react__WEBPACK_IMPORTED_MODULE_1__["createElement"](_controls_common__WEBPACK_IMPORTED_MODULE_6__["SectionHeader"], { icon: _controls_icons__WEBPACK_IMPORTED_MODULE_12__["HelpOutlineSvg"], title: 'Help' }),
                react__WEBPACK_IMPORTED_MODULE_1__["createElement"](_viewport_help__WEBPACK_IMPORTED_MODULE_11__["HelpContent"], null))
        };
        return _this;
    }
    LeftPanelControls.prototype.componentDidMount = function () {
        var _this = this;
        this.subscribe(this.plugin.behaviors.layout.leftPanelTabName, function (tab) {
            if (_this.state.tab !== tab)
                _this.setState({ tab: tab });
            if (tab === 'none' && _this.plugin.layout.state.regionState.left !== 'collapsed') {
                _mol_plugin_commands__WEBPACK_IMPORTED_MODULE_3__["PluginCommands"].Layout.Update(_this.plugin, { state: { regionState: Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, _this.plugin.layout.state.regionState), { left: 'collapsed' }) } });
            }
        });
        this.subscribe(this.plugin.state.data.events.changed, function (_a) {
            var state = _a.state;
            if (_this.state.tab !== 'data')
                return;
            if (state.cells.size === 1)
                _this.set('root');
        });
    };
    LeftPanelControls.prototype.render = function () {
        var _this = this;
        var tab = this.state.tab;
        return react__WEBPACK_IMPORTED_MODULE_1__["createElement"]("div", { className: 'msp-left-panel-controls' },
            react__WEBPACK_IMPORTED_MODULE_1__["createElement"]("div", { className: 'msp-left-panel-controls-buttons' },
                react__WEBPACK_IMPORTED_MODULE_1__["createElement"](_controls_common__WEBPACK_IMPORTED_MODULE_6__["IconButton"], { svg: _controls_icons__WEBPACK_IMPORTED_MODULE_12__["HomeOutlinedSvg"], toggleState: tab === 'root', transparent: true, onClick: function () { return _this.set('root'); }, title: 'Home' }),
                react__WEBPACK_IMPORTED_MODULE_1__["createElement"](DataIcon, { set: this.set }),
                react__WEBPACK_IMPORTED_MODULE_1__["createElement"](_controls_common__WEBPACK_IMPORTED_MODULE_6__["IconButton"], { svg: _controls_icons__WEBPACK_IMPORTED_MODULE_12__["SaveOutlinedSvg"], toggleState: tab === 'states', transparent: true, onClick: function () { return _this.set('states'); }, title: 'Plugin State' }),
                react__WEBPACK_IMPORTED_MODULE_1__["createElement"](_controls_common__WEBPACK_IMPORTED_MODULE_6__["IconButton"], { svg: _controls_icons__WEBPACK_IMPORTED_MODULE_12__["HelpOutlineSvg"], toggleState: tab === 'help', transparent: true, onClick: function () { return _this.set('help'); }, title: 'Help' }),
                react__WEBPACK_IMPORTED_MODULE_1__["createElement"]("div", { className: 'msp-left-panel-controls-buttons-bottom' },
                    react__WEBPACK_IMPORTED_MODULE_1__["createElement"](_controls_common__WEBPACK_IMPORTED_MODULE_6__["IconButton"], { svg: _controls_icons__WEBPACK_IMPORTED_MODULE_12__["TuneSvg"], toggleState: tab === 'settings', transparent: true, onClick: function () { return _this.set('settings'); }, title: 'Settings' }))),
            react__WEBPACK_IMPORTED_MODULE_1__["createElement"]("div", { className: 'msp-scrollable-container' }, this.tabs[tab]));
    };
    return LeftPanelControls;
}(_base__WEBPACK_IMPORTED_MODULE_5__["PluginUIComponent"]));

var DataIcon = /** @class */ (function (_super) {
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__extends"])(DataIcon, _super);
    function DataIcon() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = { changed: false };
        return _this;
    }
    Object.defineProperty(DataIcon.prototype, "tab", {
        get: function () {
            return this.plugin.behaviors.layout.leftPanelTabName.value;
        },
        enumerable: false,
        configurable: true
    });
    DataIcon.prototype.componentDidMount = function () {
        var _this = this;
        this.subscribe(this.plugin.behaviors.layout.leftPanelTabName, function (tab) {
            if (_this.tab === 'data')
                _this.setState({ changed: false });
            else
                _this.forceUpdate();
        });
        this.subscribe(this.plugin.state.data.events.changed, function (state) {
            if (_this.tab !== 'data')
                _this.setState({ changed: true });
        });
    };
    DataIcon.prototype.render = function () {
        var _this = this;
        return react__WEBPACK_IMPORTED_MODULE_1__["createElement"](_controls_common__WEBPACK_IMPORTED_MODULE_6__["IconButton"], { svg: _controls_icons__WEBPACK_IMPORTED_MODULE_12__["AccountTreeOutlinedSvg"], toggleState: this.tab === 'data', transparent: true, onClick: function () { return _this.props.set('data'); }, title: 'State Tree', style: { position: 'relative' }, extraContent: this.state.changed ? react__WEBPACK_IMPORTED_MODULE_1__["createElement"]("div", { className: 'msp-left-panel-controls-button-data-dirty' }) : void 0 });
    };
    return DataIcon;
}(_base__WEBPACK_IMPORTED_MODULE_5__["PluginUIComponent"]));
var FullSettings = /** @class */ (function (_super) {
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__extends"])(FullSettings, _super);
    function FullSettings() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.setSettings = function (p) {
            var _a;
            _mol_plugin_commands__WEBPACK_IMPORTED_MODULE_3__["PluginCommands"].Canvas3D.SetSettings(_this.plugin, { settings: (_a = {}, _a[p.name] = p.value, _a) });
        };
        return _this;
    }
    FullSettings.prototype.componentDidMount = function () {
        var _this = this;
        this.subscribe(this.plugin.events.canvas3d.settingsUpdated, function () { return _this.forceUpdate(); });
        this.subscribe(this.plugin.layout.events.updated, function () { return _this.forceUpdate(); });
        this.subscribe(this.plugin.canvas3d.camera.stateChanged, function (state) {
            if (state.radiusMax !== undefined || state.radius !== undefined) {
                _this.forceUpdate();
            }
        });
    };
    FullSettings.prototype.render = function () {
        return react__WEBPACK_IMPORTED_MODULE_1__["createElement"](react__WEBPACK_IMPORTED_MODULE_1__["Fragment"], null,
            this.plugin.canvas3d && react__WEBPACK_IMPORTED_MODULE_1__["createElement"](react__WEBPACK_IMPORTED_MODULE_1__["Fragment"], null,
                react__WEBPACK_IMPORTED_MODULE_1__["createElement"](_controls_common__WEBPACK_IMPORTED_MODULE_6__["SectionHeader"], { title: 'Viewport' }),
                react__WEBPACK_IMPORTED_MODULE_1__["createElement"](_controls_parameters__WEBPACK_IMPORTED_MODULE_7__["ParameterControls"], { params: _mol_canvas3d_canvas3d__WEBPACK_IMPORTED_MODULE_2__["Canvas3DParams"], values: this.plugin.canvas3d.props, onChange: this.setSettings })),
            react__WEBPACK_IMPORTED_MODULE_1__["createElement"](_controls_common__WEBPACK_IMPORTED_MODULE_6__["SectionHeader"], { title: 'Behavior' }),
            react__WEBPACK_IMPORTED_MODULE_1__["createElement"](_state_tree__WEBPACK_IMPORTED_MODULE_10__["StateTree"], { state: this.plugin.state.behaviors }));
    };
    return FullSettings;
}(_base__WEBPACK_IMPORTED_MODULE_5__["PluginUIComponent"]));
var RemoveAllButton = /** @class */ (function (_super) {
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__extends"])(RemoveAllButton, _super);
    function RemoveAllButton() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.remove = function (e) {
            e.preventDefault();
            _mol_plugin_commands__WEBPACK_IMPORTED_MODULE_3__["PluginCommands"].State.RemoveObject(_this.plugin, { state: _this.plugin.state.data, ref: _mol_state__WEBPACK_IMPORTED_MODULE_4__["StateTransform"].RootRef });
        };
        return _this;
    }
    RemoveAllButton.prototype.componentDidMount = function () {
        var _this = this;
        this.subscribe(this.plugin.state.events.cell.created, function (e) {
            if (e.cell.transform.parent === _mol_state__WEBPACK_IMPORTED_MODULE_4__["StateTransform"].RootRef)
                _this.forceUpdate();
        });
        this.subscribe(this.plugin.state.events.cell.removed, function (e) {
            if (e.parent === _mol_state__WEBPACK_IMPORTED_MODULE_4__["StateTransform"].RootRef)
                _this.forceUpdate();
        });
    };
    RemoveAllButton.prototype.render = function () {
        var count = this.plugin.state.data.tree.children.get(_mol_state__WEBPACK_IMPORTED_MODULE_4__["StateTransform"].RootRef).size;
        if (count === 0)
            return null;
        return react__WEBPACK_IMPORTED_MODULE_1__["createElement"](_controls_common__WEBPACK_IMPORTED_MODULE_6__["IconButton"], { svg: _controls_icons__WEBPACK_IMPORTED_MODULE_12__["DeleteOutlinedSvg"], onClick: this.remove, title: 'Remove All', style: { display: 'inline-block' }, small: true, className: 'msp-no-hover-outline', transparent: true });
    };
    return RemoveAllButton;
}(_base__WEBPACK_IMPORTED_MODULE_5__["PluginUIComponent"]));
//# sourceMappingURL=left-panel.js.map

/***/ }),

/***/ "./lib/mol-plugin-ui/plugin.js":
/*!*************************************!*\
  !*** ./lib/mol-plugin-ui/plugin.js ***!
  \*************************************/
/*! exports provided: Plugin, PluginContextContainer, ControlsWrapper, DefaultViewport, Log */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Plugin", function() { return Plugin; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "PluginContextContainer", function() { return PluginContextContainer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ControlsWrapper", function() { return ControlsWrapper; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DefaultViewport", function() { return DefaultViewport; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Log", function() { return Log; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! react */ "./node_modules/react/index.js");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _mol_util__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../mol-util */ "./lib/mol-util/index.js");
/* harmony import */ var _base__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./base */ "./lib/mol-plugin-ui/base.js");
/* harmony import */ var _controls__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./controls */ "./lib/mol-plugin-ui/controls.js");
/* harmony import */ var _left_panel__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./left-panel */ "./lib/mol-plugin-ui/left-panel.js");
/* harmony import */ var _sequence__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ./sequence */ "./lib/mol-plugin-ui/sequence.js");
/* harmony import */ var _task__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ./task */ "./lib/mol-plugin-ui/task.js");
/* harmony import */ var _toast__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ./toast */ "./lib/mol-plugin-ui/toast.js");
/* harmony import */ var _viewport__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ./viewport */ "./lib/mol-plugin-ui/viewport.js");
/* harmony import */ var _mol_plugin_commands__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ../mol-plugin/commands */ "./lib/mol-plugin/commands.js");
/**
 * Copyright (c) 2018-2020 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author David Sehnal <david.sehnal@gmail.com>
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */











var Plugin = /** @class */ (function (_super) {
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__extends"])(Plugin, _super);
    function Plugin() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Plugin.prototype.region = function (kind, element) {
        return react__WEBPACK_IMPORTED_MODULE_1__["createElement"]("div", { className: "msp-layout-region msp-layout-" + kind },
            react__WEBPACK_IMPORTED_MODULE_1__["createElement"]("div", { className: 'msp-layout-static' }, element));
    };
    Plugin.prototype.render = function () {
        return react__WEBPACK_IMPORTED_MODULE_1__["createElement"](_base__WEBPACK_IMPORTED_MODULE_3__["PluginReactContext"].Provider, { value: this.props.plugin },
            react__WEBPACK_IMPORTED_MODULE_1__["createElement"](Layout, null));
    };
    return Plugin;
}(react__WEBPACK_IMPORTED_MODULE_1__["Component"]));

var PluginContextContainer = /** @class */ (function (_super) {
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__extends"])(PluginContextContainer, _super);
    function PluginContextContainer() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PluginContextContainer.prototype.render = function () {
        return react__WEBPACK_IMPORTED_MODULE_1__["createElement"](_base__WEBPACK_IMPORTED_MODULE_3__["PluginReactContext"].Provider, { value: this.props.plugin },
            react__WEBPACK_IMPORTED_MODULE_1__["createElement"]("div", { className: 'msp-plugin' }, this.props.children));
    };
    return PluginContextContainer;
}(react__WEBPACK_IMPORTED_MODULE_1__["Component"]));

var Layout = /** @class */ (function (_super) {
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__extends"])(Layout, _super);
    function Layout() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.onDrop = function (ev) {
            ev.preventDefault();
            var file;
            if (ev.dataTransfer.items) {
                // Use DataTransferItemList interface to access the file(s)
                for (var i = 0; i < ev.dataTransfer.items.length; i++) {
                    if (ev.dataTransfer.items[i].kind !== 'file')
                        continue;
                    file = ev.dataTransfer.items[i].getAsFile();
                    break;
                }
            }
            else {
                file = ev.dataTransfer.files[0];
            }
            if (!file)
                return;
            var fn = (file === null || file === void 0 ? void 0 : file.name.toLowerCase()) || '';
            if (fn.endsWith('molx') || fn.endsWith('molj')) {
                _mol_plugin_commands__WEBPACK_IMPORTED_MODULE_10__["PluginCommands"].State.Snapshots.OpenFile(_this.plugin, { file: file });
            }
        };
        _this.onDragOver = function (ev) {
            ev.preventDefault();
        };
        return _this;
    }
    Layout.prototype.componentDidMount = function () {
        var _this = this;
        this.subscribe(this.plugin.layout.events.updated, function () { return _this.forceUpdate(); });
    };
    Layout.prototype.region = function (kind, Element) {
        return react__WEBPACK_IMPORTED_MODULE_1__["createElement"]("div", { className: "msp-layout-region msp-layout-" + kind },
            react__WEBPACK_IMPORTED_MODULE_1__["createElement"]("div", { className: 'msp-layout-static' }, Element ? react__WEBPACK_IMPORTED_MODULE_1__["createElement"](Element, null) : null));
    };
    Object.defineProperty(Layout.prototype, "layoutVisibilityClassName", {
        get: function () {
            var layout = this.plugin.layout.state;
            var controls = (this.plugin.spec.layout && this.plugin.spec.layout.controls) || {};
            var classList = [];
            if (controls.top === 'none' || !layout.showControls || layout.regionState.top === 'hidden') {
                classList.push('msp-layout-hide-top');
            }
            if (controls.left === 'none' || !layout.showControls || layout.regionState.left === 'hidden') {
                classList.push('msp-layout-hide-left');
            }
            else if (layout.regionState.left === 'collapsed') {
                classList.push('msp-layout-collapse-left');
            }
            if (controls.right === 'none' || !layout.showControls || layout.regionState.right === 'hidden') {
                classList.push('msp-layout-hide-right');
            }
            if (controls.bottom === 'none' || !layout.showControls || layout.regionState.bottom === 'hidden') {
                classList.push('msp-layout-hide-bottom');
            }
            return classList.join(' ');
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Layout.prototype, "layoutClassName", {
        get: function () {
            var layout = this.plugin.layout.state;
            var classList = ['msp-plugin-content'];
            if (layout.isExpanded) {
                classList.push('msp-layout-expanded');
            }
            else {
                classList.push('msp-layout-standard', "msp-layout-standard-" + layout.controlsDisplay);
            }
            return classList.join(' ');
        },
        enumerable: false,
        configurable: true
    });
    Layout.prototype.render = function () {
        var _a, _b, _c, _d;
        var layout = this.plugin.layout.state;
        var controls = ((_a = this.plugin.spec.layout) === null || _a === void 0 ? void 0 : _a.controls) || {};
        var viewport = ((_c = (_b = this.plugin.spec.components) === null || _b === void 0 ? void 0 : _b.viewport) === null || _c === void 0 ? void 0 : _c.view) || DefaultViewport;
        return react__WEBPACK_IMPORTED_MODULE_1__["createElement"]("div", { className: 'msp-plugin', onDrop: this.onDrop, onDragOver: this.onDragOver },
            react__WEBPACK_IMPORTED_MODULE_1__["createElement"]("div", { className: this.layoutClassName },
                react__WEBPACK_IMPORTED_MODULE_1__["createElement"]("div", { className: this.layoutVisibilityClassName },
                    this.region('main', viewport),
                    layout.showControls && controls.top !== 'none' && this.region('top', controls.top || _sequence__WEBPACK_IMPORTED_MODULE_6__["SequenceView"]),
                    layout.showControls && controls.left !== 'none' && this.region('left', controls.left || _left_panel__WEBPACK_IMPORTED_MODULE_5__["LeftPanelControls"]),
                    layout.showControls && controls.right !== 'none' && this.region('right', controls.right || ControlsWrapper),
                    layout.showControls && controls.bottom !== 'none' && this.region('bottom', controls.bottom || Log)),
                !((_d = this.plugin.spec.components) === null || _d === void 0 ? void 0 : _d.hideTaskOverlay) && react__WEBPACK_IMPORTED_MODULE_1__["createElement"](_task__WEBPACK_IMPORTED_MODULE_7__["OverlayTaskProgress"], null)));
    };
    return Layout;
}(_base__WEBPACK_IMPORTED_MODULE_3__["PluginUIComponent"]));
var ControlsWrapper = /** @class */ (function (_super) {
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__extends"])(ControlsWrapper, _super);
    function ControlsWrapper() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ControlsWrapper.prototype.render = function () {
        var _a;
        var StructureTools = ((_a = this.plugin.spec.components) === null || _a === void 0 ? void 0 : _a.structureTools) || _controls__WEBPACK_IMPORTED_MODULE_4__["DefaultStructureTools"];
        return react__WEBPACK_IMPORTED_MODULE_1__["createElement"]("div", { className: 'msp-scrollable-container' },
            react__WEBPACK_IMPORTED_MODULE_1__["createElement"](StructureTools, null));
    };
    return ControlsWrapper;
}(_base__WEBPACK_IMPORTED_MODULE_3__["PluginUIComponent"]));

var DefaultViewport = /** @class */ (function (_super) {
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__extends"])(DefaultViewport, _super);
    function DefaultViewport() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    DefaultViewport.prototype.render = function () {
        var _a, _b;
        var VPControls = ((_b = (_a = this.plugin.spec.components) === null || _a === void 0 ? void 0 : _a.viewport) === null || _b === void 0 ? void 0 : _b.controls) || _viewport__WEBPACK_IMPORTED_MODULE_9__["ViewportControls"];
        return react__WEBPACK_IMPORTED_MODULE_1__["createElement"](react__WEBPACK_IMPORTED_MODULE_1__["Fragment"], null,
            react__WEBPACK_IMPORTED_MODULE_1__["createElement"](_viewport__WEBPACK_IMPORTED_MODULE_9__["Viewport"], null),
            react__WEBPACK_IMPORTED_MODULE_1__["createElement"]("div", { className: 'msp-viewport-top-left-controls' },
                react__WEBPACK_IMPORTED_MODULE_1__["createElement"](_controls__WEBPACK_IMPORTED_MODULE_4__["AnimationViewportControls"], null),
                react__WEBPACK_IMPORTED_MODULE_1__["createElement"](_controls__WEBPACK_IMPORTED_MODULE_4__["TrajectoryViewportControls"], null),
                react__WEBPACK_IMPORTED_MODULE_1__["createElement"](_controls__WEBPACK_IMPORTED_MODULE_4__["StateSnapshotViewportControls"], null)),
            react__WEBPACK_IMPORTED_MODULE_1__["createElement"](_controls__WEBPACK_IMPORTED_MODULE_4__["SelectionViewportControls"], null),
            react__WEBPACK_IMPORTED_MODULE_1__["createElement"](VPControls, null),
            react__WEBPACK_IMPORTED_MODULE_1__["createElement"](_task__WEBPACK_IMPORTED_MODULE_7__["BackgroundTaskProgress"], null),
            react__WEBPACK_IMPORTED_MODULE_1__["createElement"]("div", { className: 'msp-highlight-toast-wrapper' },
                react__WEBPACK_IMPORTED_MODULE_1__["createElement"](_controls__WEBPACK_IMPORTED_MODULE_4__["LociLabels"], null),
                react__WEBPACK_IMPORTED_MODULE_1__["createElement"](_toast__WEBPACK_IMPORTED_MODULE_8__["Toasts"], null)));
    };
    return DefaultViewport;
}(_base__WEBPACK_IMPORTED_MODULE_3__["PluginUIComponent"]));

var Log = /** @class */ (function (_super) {
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__extends"])(Log, _super);
    function Log() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.wrapper = react__WEBPACK_IMPORTED_MODULE_1__["createRef"]();
        _this.state = { entries: _this.plugin.log.entries };
        return _this;
    }
    Log.prototype.componentDidMount = function () {
        var _this = this;
        this.subscribe(this.plugin.events.log, function () { return _this.setState({ entries: _this.plugin.log.entries }); });
    };
    Log.prototype.componentDidUpdate = function () {
        this.scrollToBottom();
    };
    Log.prototype.scrollToBottom = function () {
        var log = this.wrapper.current;
        if (log)
            log.scrollTop = log.scrollHeight - log.clientHeight - 1;
    };
    Log.prototype.render = function () {
        // TODO: ability to show full log
        // showing more entries dramatically slows animations.
        var maxEntries = 10;
        var xs = this.state.entries, l = xs.size;
        var entries = [];
        for (var i = Math.max(0, l - maxEntries), o = 0; i < l; i++) {
            var e = xs.get(i);
            entries.push(react__WEBPACK_IMPORTED_MODULE_1__["createElement"]("li", { key: o++ },
                react__WEBPACK_IMPORTED_MODULE_1__["createElement"]("div", { className: 'msp-log-entry-badge msp-log-entry-' + e.type }),
                react__WEBPACK_IMPORTED_MODULE_1__["createElement"]("div", { className: 'msp-log-timestamp' }, Object(_mol_util__WEBPACK_IMPORTED_MODULE_2__["formatTime"])(e.timestamp)),
                react__WEBPACK_IMPORTED_MODULE_1__["createElement"]("div", { className: 'msp-log-entry' }, e.message)));
        }
        return react__WEBPACK_IMPORTED_MODULE_1__["createElement"]("div", { ref: this.wrapper, className: 'msp-log', style: { position: 'absolute', top: '0', right: '0', bottom: '0', left: '0', overflowY: 'auto' } },
            react__WEBPACK_IMPORTED_MODULE_1__["createElement"]("ul", { className: 'msp-list-unstyled' }, entries));
    };
    return Log;
}(_base__WEBPACK_IMPORTED_MODULE_3__["PluginUIComponent"]));

//# sourceMappingURL=plugin.js.map

/***/ }),

/***/ "./lib/mol-plugin-ui/sequence.js":
/*!***************************************!*\
  !*** ./lib/mol-plugin-ui/sequence.js ***!
  \***************************************/
/*! exports provided: SequenceView */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SequenceView", function() { return SequenceView; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! react */ "./node_modules/react/index.js");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _base__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./base */ "./lib/mol-plugin-ui/base.js");
/* harmony import */ var _mol_plugin_state_objects__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../mol-plugin-state/objects */ "./lib/mol-plugin-state/objects.js");
/* harmony import */ var _sequence_sequence__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./sequence/sequence */ "./lib/mol-plugin-ui/sequence/sequence.js");
/* harmony import */ var _mol_model_structure__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../mol-model/structure */ "./lib/mol-model/structure.js");
/* harmony import */ var _sequence_polymer__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ./sequence/polymer */ "./lib/mol-plugin-ui/sequence/polymer.js");
/* harmony import */ var _mol_util_marker_action__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../mol-util/marker-action */ "./lib/mol-util/marker-action.js");
/* harmony import */ var _controls_parameters__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ./controls/parameters */ "./lib/mol-plugin-ui/controls/parameters.js");
/* harmony import */ var _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ../mol-util/param-definition */ "./lib/mol-util/param-definition.js");
/* harmony import */ var _sequence_hetero__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ./sequence/hetero */ "./lib/mol-plugin-ui/sequence/hetero.js");
/* harmony import */ var _mol_state__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ../mol-state */ "./lib/mol-state/index.js");
/* harmony import */ var _sequence_chain__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! ./sequence/chain */ "./lib/mol-plugin-ui/sequence/chain.js");
/* harmony import */ var _sequence_element__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! ./sequence/element */ "./lib/mol-plugin-ui/sequence/element.js");
/* harmony import */ var _mol_theme_label__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! ../mol-theme/label */ "./lib/mol-theme/label.js");
/* harmony import */ var _controls_icons__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! ./controls/icons */ "./lib/mol-plugin-ui/controls/icons.js");
/* harmony import */ var _mol_util_array__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(/*! ../mol-util/array */ "./lib/mol-util/array.js");
/**
 * Copyright (c) 2018-2020 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 * @author David Sehnal <david.sehnal@gmail.com>
 */

















var MaxDisplaySequenceLength = 5000;
function opKey(l) {
    var ids = _mol_model_structure__WEBPACK_IMPORTED_MODULE_5__["StructureProperties"].unit.pdbx_struct_oper_list_ids(l);
    var ncs = _mol_model_structure__WEBPACK_IMPORTED_MODULE_5__["StructureProperties"].unit.struct_ncs_oper_id(l);
    var hkl = _mol_model_structure__WEBPACK_IMPORTED_MODULE_5__["StructureProperties"].unit.hkl(l);
    var spgrOp = _mol_model_structure__WEBPACK_IMPORTED_MODULE_5__["StructureProperties"].unit.spgrOp(l);
    return ids.sort().join(',') + "|" + ncs + "|" + hkl + "|" + spgrOp;
}
function splitModelEntityId(modelEntityId) {
    var _a = modelEntityId.split('|'), modelIdx = _a[0], entityId = _a[1];
    return [parseInt(modelIdx), entityId];
}
function getSequenceWrapper(state, structureSelection) {
    var structure = state.structure, modelEntityId = state.modelEntityId, chainGroupId = state.chainGroupId, operatorKey = state.operatorKey;
    var l = _mol_model_structure__WEBPACK_IMPORTED_MODULE_5__["StructureElement"].Location.create(structure);
    var _a = splitModelEntityId(modelEntityId), modelIdx = _a[0], entityId = _a[1];
    var units = [];
    for (var _i = 0, _b = structure.units; _i < _b.length; _i++) {
        var unit = _b[_i];
        _mol_model_structure__WEBPACK_IMPORTED_MODULE_5__["StructureElement"].Location.set(l, structure, unit, unit.elements[0]);
        if (structure.getModelIndex(unit.model) !== modelIdx)
            continue;
        if (_mol_model_structure__WEBPACK_IMPORTED_MODULE_5__["StructureProperties"].entity.id(l) !== entityId)
            continue;
        if (unit.chainGroupId !== chainGroupId)
            continue;
        if (opKey(l) !== operatorKey)
            continue;
        units.push(unit);
    }
    if (units.length > 0) {
        var data = { structure: structure, units: units };
        var unit = units[0];
        var sw = void 0;
        if (unit.polymerElements.length) {
            var l_1 = _mol_model_structure__WEBPACK_IMPORTED_MODULE_5__["StructureElement"].Location.create(structure, unit, unit.elements[0]);
            var entitySeq = unit.model.sequence.byEntityKey[_mol_model_structure__WEBPACK_IMPORTED_MODULE_5__["StructureProperties"].entity.key(l_1)];
            // check if entity sequence is available
            if (entitySeq && entitySeq.sequence.length <= MaxDisplaySequenceLength) {
                sw = new _sequence_polymer__WEBPACK_IMPORTED_MODULE_6__["PolymerSequenceWrapper"](data);
            }
            else {
                var polymerElementCount = units.reduce(function (a, v) { return a + v.polymerElements.length; }, 0);
                if (_mol_model_structure__WEBPACK_IMPORTED_MODULE_5__["Unit"].isAtomic(unit) || polymerElementCount > MaxDisplaySequenceLength) {
                    sw = new _sequence_chain__WEBPACK_IMPORTED_MODULE_12__["ChainSequenceWrapper"](data);
                }
                else {
                    sw = new _sequence_element__WEBPACK_IMPORTED_MODULE_13__["ElementSequenceWrapper"](data);
                }
            }
        }
        else if (_mol_model_structure__WEBPACK_IMPORTED_MODULE_5__["Unit"].isAtomic(unit)) {
            var residueCount = units.reduce(function (a, v) { return a + v.residueCount; }, 0);
            if (residueCount > MaxDisplaySequenceLength) {
                sw = new _sequence_chain__WEBPACK_IMPORTED_MODULE_12__["ChainSequenceWrapper"](data);
            }
            else {
                sw = new _sequence_hetero__WEBPACK_IMPORTED_MODULE_10__["HeteroSequenceWrapper"](data);
            }
        }
        else {
            console.warn('should not happen, expecting coarse units to be polymeric');
            sw = new _sequence_chain__WEBPACK_IMPORTED_MODULE_12__["ChainSequenceWrapper"](data);
        }
        sw.markResidue(structureSelection.getLoci(structure), _mol_util_marker_action__WEBPACK_IMPORTED_MODULE_7__["MarkerAction"].Select);
        return sw;
    }
    else {
        return 'No sequence available';
    }
}
function getModelEntityOptions(structure, polymersOnly) {
    if (polymersOnly === void 0) { polymersOnly = false; }
    var options = [];
    var l = _mol_model_structure__WEBPACK_IMPORTED_MODULE_5__["StructureElement"].Location.create(structure);
    var seen = new Set();
    for (var _i = 0, _a = structure.units; _i < _a.length; _i++) {
        var unit = _a[_i];
        _mol_model_structure__WEBPACK_IMPORTED_MODULE_5__["StructureElement"].Location.set(l, structure, unit, unit.elements[0]);
        var id = _mol_model_structure__WEBPACK_IMPORTED_MODULE_5__["StructureProperties"].entity.id(l);
        var modelIdx = structure.getModelIndex(unit.model);
        var key = modelIdx + "|" + id;
        if (seen.has(key))
            continue;
        if (polymersOnly && _mol_model_structure__WEBPACK_IMPORTED_MODULE_5__["StructureProperties"].entity.type(l) !== 'polymer')
            continue;
        var description = _mol_model_structure__WEBPACK_IMPORTED_MODULE_5__["StructureProperties"].entity.pdbx_description(l).join(', ');
        if (structure.models.length) {
            if (structure.representativeModel) { // indicates model trajectory
                description += " (Model " + structure.models[modelIdx].modelNum + ")";
            }
            else if (description.startsWith('Polymer ')) { // indicates generic entity name
                description += " (" + structure.models[modelIdx].entry + ")";
            }
        }
        var label = id + ": " + description;
        options.push([key, label]);
        seen.add(key);
    }
    if (options.length === 0)
        options.push(['', 'No entities']);
    return options;
}
function getChainOptions(structure, modelEntityId) {
    var options = [];
    var l = _mol_model_structure__WEBPACK_IMPORTED_MODULE_5__["StructureElement"].Location.create(structure);
    var seen = new Set();
    var _a = splitModelEntityId(modelEntityId), modelIdx = _a[0], entityId = _a[1];
    for (var _i = 0, _b = structure.units; _i < _b.length; _i++) {
        var unit = _b[_i];
        _mol_model_structure__WEBPACK_IMPORTED_MODULE_5__["StructureElement"].Location.set(l, structure, unit, unit.elements[0]);
        if (structure.getModelIndex(unit.model) !== modelIdx)
            continue;
        if (_mol_model_structure__WEBPACK_IMPORTED_MODULE_5__["StructureProperties"].entity.id(l) !== entityId)
            continue;
        var id = unit.chainGroupId;
        if (seen.has(id))
            continue;
        // TODO handle special case
        // - more than one chain in a unit
        var label = Object(_mol_theme_label__WEBPACK_IMPORTED_MODULE_14__["elementLabel"])(l, { granularity: 'chain', hidePrefix: true, htmlStyling: false });
        options.push([id, label]);
        seen.add(id);
    }
    if (options.length === 0)
        options.push([-1, 'No units']);
    return options;
}
function getOperatorOptions(structure, modelEntityId, chainGroupId) {
    var options = [];
    var l = _mol_model_structure__WEBPACK_IMPORTED_MODULE_5__["StructureElement"].Location.create(structure);
    var seen = new Set();
    var _a = splitModelEntityId(modelEntityId), modelIdx = _a[0], entityId = _a[1];
    for (var _i = 0, _b = structure.units; _i < _b.length; _i++) {
        var unit = _b[_i];
        _mol_model_structure__WEBPACK_IMPORTED_MODULE_5__["StructureElement"].Location.set(l, structure, unit, unit.elements[0]);
        if (structure.getModelIndex(unit.model) !== modelIdx)
            continue;
        if (_mol_model_structure__WEBPACK_IMPORTED_MODULE_5__["StructureProperties"].entity.id(l) !== entityId)
            continue;
        if (unit.chainGroupId !== chainGroupId)
            continue;
        var id = opKey(l);
        if (seen.has(id))
            continue;
        var label = unit.conformation.operator.name;
        options.push([id, label]);
        seen.add(id);
    }
    if (options.length === 0)
        options.push(['', 'No operators']);
    return options;
}
function getStructureOptions(state) {
    var _a;
    var options = [];
    var all = [];
    var structures = state.select(_mol_state__WEBPACK_IMPORTED_MODULE_11__["StateSelection"].Generators.rootsOfType(_mol_plugin_state_objects__WEBPACK_IMPORTED_MODULE_3__["PluginStateObject"].Molecule.Structure));
    for (var _i = 0, structures_1 = structures; _i < structures_1.length; _i++) {
        var s = structures_1[_i];
        if (!((_a = s.obj) === null || _a === void 0 ? void 0 : _a.data))
            continue;
        all.push(s.obj.data);
        options.push([s.transform.ref, s.obj.data.label]);
    }
    if (options.length === 0)
        options.push(['', 'No structure']);
    return { options: options, all: all };
}
var SequenceViewModeParam = _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_9__["ParamDefinition"].Select('single', [['single', 'Chain'], ['polymers', 'Polymers'], ['all', 'Everything']]);
var SequenceView = /** @class */ (function (_super) {
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__extends"])(SequenceView, _super);
    function SequenceView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = { structureOptions: { options: [], all: [] }, structure: _mol_model_structure__WEBPACK_IMPORTED_MODULE_5__["Structure"].Empty, structureRef: '', modelEntityId: '', chainGroupId: -1, operatorKey: '', mode: 'single' };
        _this.setParamProps = function (p) {
            var state = Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, _this.state);
            switch (p.name) {
                case 'mode':
                    state.mode = p.value;
                    if (_this.state.mode === state.mode)
                        return;
                    if (state.mode === 'all' || state.mode === 'polymers') {
                        break;
                    }
                case 'structure':
                    if (p.name === 'structure')
                        state.structureRef = p.value;
                    state.structure = _this.getStructure(state.structureRef);
                    state.modelEntityId = getModelEntityOptions(state.structure)[0][0];
                    state.chainGroupId = getChainOptions(state.structure, state.modelEntityId)[0][0];
                    state.operatorKey = getOperatorOptions(state.structure, state.modelEntityId, state.chainGroupId)[0][0];
                    break;
                case 'entity':
                    state.modelEntityId = p.value;
                    state.chainGroupId = getChainOptions(state.structure, state.modelEntityId)[0][0];
                    state.operatorKey = getOperatorOptions(state.structure, state.modelEntityId, state.chainGroupId)[0][0];
                    break;
                case 'chain':
                    state.chainGroupId = p.value;
                    state.operatorKey = getOperatorOptions(state.structure, state.modelEntityId, state.chainGroupId)[0][0];
                    break;
                case 'operator':
                    state.operatorKey = p.value;
                    break;
            }
            _this.setState(state);
        };
        return _this;
    }
    SequenceView.prototype.componentDidMount = function () {
        var _this = this;
        if (this.plugin.state.data.select(_mol_state__WEBPACK_IMPORTED_MODULE_11__["StateSelection"].Generators.rootsOfType(_mol_plugin_state_objects__WEBPACK_IMPORTED_MODULE_3__["PluginStateObject"].Molecule.Structure)).length > 0)
            this.setState(this.getInitialState());
        this.subscribe(this.plugin.state.events.object.updated, function (_a) {
            var ref = _a.ref, obj = _a.obj;
            if (ref === _this.state.structureRef && obj && obj.type === _mol_plugin_state_objects__WEBPACK_IMPORTED_MODULE_3__["PluginStateObject"].Molecule.Structure.type && obj.data !== _this.state.structure) {
                _this.sync();
            }
        });
        this.subscribe(this.plugin.state.events.object.created, function (_a) {
            var obj = _a.obj;
            if (obj && obj.type === _mol_plugin_state_objects__WEBPACK_IMPORTED_MODULE_3__["PluginStateObject"].Molecule.Structure.type) {
                _this.sync();
            }
        });
        this.subscribe(this.plugin.state.events.object.removed, function (_a) {
            var obj = _a.obj;
            if (obj && obj.type === _mol_plugin_state_objects__WEBPACK_IMPORTED_MODULE_3__["PluginStateObject"].Molecule.Structure.type && obj.data === _this.state.structure) {
                _this.sync();
            }
        });
    };
    SequenceView.prototype.sync = function () {
        var structureOptions = getStructureOptions(this.plugin.state.data);
        if (Object(_mol_util_array__WEBPACK_IMPORTED_MODULE_16__["arrayEqual"])(structureOptions.all, this.state.structureOptions.all))
            return;
        this.setState(this.getInitialState());
    };
    SequenceView.prototype.getStructure = function (ref) {
        var state = this.plugin.state.data;
        var cell = state.select(ref)[0];
        if (!ref || !cell || !cell.obj)
            return _mol_model_structure__WEBPACK_IMPORTED_MODULE_5__["Structure"].Empty;
        return cell.obj.data;
    };
    SequenceView.prototype.getSequenceWrapper = function (params) {
        return {
            wrapper: getSequenceWrapper(this.state, this.plugin.managers.structure.selection),
            label: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_9__["ParamDefinition"].optionLabel(params.chain, this.state.chainGroupId) + " | " + _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_9__["ParamDefinition"].optionLabel(params.entity, this.state.modelEntityId)
        };
    };
    SequenceView.prototype.getSequenceWrappers = function (params) {
        if (this.state.mode === 'single')
            return [this.getSequenceWrapper(params)];
        var structure = this.getStructure(this.state.structureRef);
        var wrappers = [];
        for (var _i = 0, _a = getModelEntityOptions(structure, this.state.mode === 'polymers'); _i < _a.length; _i++) {
            var _b = _a[_i], modelEntityId = _b[0], eLabel = _b[1];
            for (var _c = 0, _d = getChainOptions(structure, modelEntityId); _c < _d.length; _c++) {
                var _e = _d[_c], chainGroupId = _e[0], cLabel = _e[1];
                for (var _f = 0, _g = getOperatorOptions(structure, modelEntityId, chainGroupId); _f < _g.length; _f++) {
                    var operatorKey = _g[_f][0];
                    wrappers.push({
                        wrapper: getSequenceWrapper({
                            structure: structure,
                            modelEntityId: modelEntityId,
                            chainGroupId: chainGroupId,
                            operatorKey: operatorKey
                        }, this.plugin.managers.structure.selection),
                        label: cLabel + " | " + eLabel
                    });
                }
            }
        }
        return wrappers;
    };
    SequenceView.prototype.getInitialState = function () {
        var _a;
        var structureOptions = getStructureOptions(this.plugin.state.data);
        var structureRef = structureOptions.options[0][0];
        var structure = this.getStructure(structureRef);
        var modelEntityId = getModelEntityOptions(structure)[0][0];
        var chainGroupId = getChainOptions(structure, modelEntityId)[0][0];
        var operatorKey = getOperatorOptions(structure, modelEntityId, chainGroupId)[0][0];
        if (this.state.structure && this.state.structure === structure) {
            modelEntityId = this.state.modelEntityId;
            chainGroupId = this.state.chainGroupId;
            operatorKey = this.state.operatorKey;
        }
        return { structureOptions: structureOptions, structure: structure, structureRef: structureRef, modelEntityId: modelEntityId, chainGroupId: chainGroupId, operatorKey: operatorKey, mode: (_a = this.props.defaultMode) !== null && _a !== void 0 ? _a : 'single' };
    };
    Object.defineProperty(SequenceView.prototype, "params", {
        get: function () {
            var _a = this.state, structureOptions = _a.structureOptions, structure = _a.structure, modelEntityId = _a.modelEntityId, chainGroupId = _a.chainGroupId;
            var entityOptions = getModelEntityOptions(structure);
            var chainOptions = getChainOptions(structure, modelEntityId);
            var operatorOptions = getOperatorOptions(structure, modelEntityId, chainGroupId);
            return {
                structure: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_9__["ParamDefinition"].Select(structureOptions.options[0][0], structureOptions.options, { shortLabel: true }),
                entity: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_9__["ParamDefinition"].Select(entityOptions[0][0], entityOptions, { shortLabel: true }),
                chain: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_9__["ParamDefinition"].Select(chainOptions[0][0], chainOptions, { shortLabel: true, twoColumns: true, label: 'Chain' }),
                operator: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_9__["ParamDefinition"].Select(operatorOptions[0][0], operatorOptions, { shortLabel: true, twoColumns: true }),
                mode: SequenceViewModeParam
            };
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SequenceView.prototype, "values", {
        get: function () {
            return {
                structure: this.state.structureRef,
                entity: this.state.modelEntityId,
                chain: this.state.chainGroupId,
                operator: this.state.operatorKey,
                mode: this.state.mode
            };
        },
        enumerable: false,
        configurable: true
    });
    SequenceView.prototype.render = function () {
        if (this.getStructure(this.state.structureRef) === _mol_model_structure__WEBPACK_IMPORTED_MODULE_5__["Structure"].Empty) {
            return react__WEBPACK_IMPORTED_MODULE_1__["createElement"]("div", { className: 'msp-sequence' },
                react__WEBPACK_IMPORTED_MODULE_1__["createElement"]("div", { className: 'msp-sequence-select' },
                    react__WEBPACK_IMPORTED_MODULE_1__["createElement"](_controls_icons__WEBPACK_IMPORTED_MODULE_15__["Icon"], { svg: _controls_icons__WEBPACK_IMPORTED_MODULE_15__["HelpOutlineSvg"], style: { cursor: 'help', position: 'absolute', right: 0, top: 0 }, title: 'Shows a sequence of one or more chains. Use the controls to alter selection.' }),
                    react__WEBPACK_IMPORTED_MODULE_1__["createElement"]("span", null, "Sequence"),
                    react__WEBPACK_IMPORTED_MODULE_1__["createElement"]("span", { style: { fontWeight: 'normal' } }, "No structure available")));
        }
        var params = this.params;
        var values = this.values;
        var sequenceWrappers = this.getSequenceWrappers(params);
        return react__WEBPACK_IMPORTED_MODULE_1__["createElement"]("div", { className: 'msp-sequence' },
            react__WEBPACK_IMPORTED_MODULE_1__["createElement"]("div", { className: 'msp-sequence-select' },
                react__WEBPACK_IMPORTED_MODULE_1__["createElement"](_controls_icons__WEBPACK_IMPORTED_MODULE_15__["Icon"], { svg: _controls_icons__WEBPACK_IMPORTED_MODULE_15__["HelpOutlineSvg"], style: { cursor: 'help', position: 'absolute', right: 0, top: 0 }, title: 'This shows a single sequence. Use the controls to show a different sequence.' }),
                react__WEBPACK_IMPORTED_MODULE_1__["createElement"]("span", null, "Sequence of"),
                react__WEBPACK_IMPORTED_MODULE_1__["createElement"](_controls_parameters__WEBPACK_IMPORTED_MODULE_8__["PureSelectControl"], { title: "[Structure] " + _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_9__["ParamDefinition"].optionLabel(params.structure, values.structure), param: params.structure, name: 'structure', value: values.structure, onChange: this.setParamProps }),
                react__WEBPACK_IMPORTED_MODULE_1__["createElement"](_controls_parameters__WEBPACK_IMPORTED_MODULE_8__["PureSelectControl"], { title: "[Mode]", param: SequenceViewModeParam, name: 'mode', value: values.mode, onChange: this.setParamProps }),
                values.mode === 'single' && react__WEBPACK_IMPORTED_MODULE_1__["createElement"](_controls_parameters__WEBPACK_IMPORTED_MODULE_8__["PureSelectControl"], { title: "[Entity] " + _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_9__["ParamDefinition"].optionLabel(params.entity, values.entity), param: params.entity, name: 'entity', value: values.entity, onChange: this.setParamProps }),
                values.mode === 'single' && react__WEBPACK_IMPORTED_MODULE_1__["createElement"](_controls_parameters__WEBPACK_IMPORTED_MODULE_8__["PureSelectControl"], { title: "[Chain] " + _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_9__["ParamDefinition"].optionLabel(params.chain, values.chain), param: params.chain, name: 'chain', value: values.chain, onChange: this.setParamProps }),
                params.operator.options.length > 1 && react__WEBPACK_IMPORTED_MODULE_1__["createElement"](react__WEBPACK_IMPORTED_MODULE_1__["Fragment"], null,
                    react__WEBPACK_IMPORTED_MODULE_1__["createElement"](_controls_parameters__WEBPACK_IMPORTED_MODULE_8__["PureSelectControl"], { title: "[Instance] " + _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_9__["ParamDefinition"].optionLabel(params.operator, values.operator), param: params.operator, name: 'operator', value: values.operator, onChange: this.setParamProps }))),
            react__WEBPACK_IMPORTED_MODULE_1__["createElement"](NonEmptySequenceWrapper, null, sequenceWrappers.map(function (s, i) {
                var elem = typeof s.wrapper === 'string'
                    ? react__WEBPACK_IMPORTED_MODULE_1__["createElement"]("div", { key: i, className: 'msp-sequence-wrapper' }, s.wrapper)
                    : react__WEBPACK_IMPORTED_MODULE_1__["createElement"](_sequence_sequence__WEBPACK_IMPORTED_MODULE_4__["Sequence"], { key: i, sequenceWrapper: s.wrapper });
                if (values.mode === 'single')
                    return elem;
                return react__WEBPACK_IMPORTED_MODULE_1__["createElement"](react__WEBPACK_IMPORTED_MODULE_1__["Fragment"], null,
                    react__WEBPACK_IMPORTED_MODULE_1__["createElement"]("div", { className: 'msp-sequence-chain-label' }, s.label),
                    elem);
            })));
    };
    return SequenceView;
}(_base__WEBPACK_IMPORTED_MODULE_2__["PluginUIComponent"]));

function NonEmptySequenceWrapper(_a) {
    var children = _a.children;
    return react__WEBPACK_IMPORTED_MODULE_1__["createElement"]("div", { className: 'msp-sequence-wrapper-non-empty' }, children);
}
//# sourceMappingURL=sequence.js.map

/***/ }),

/***/ "./lib/mol-plugin-ui/sequence/chain.js":
/*!*********************************************!*\
  !*** ./lib/mol-plugin-ui/sequence/chain.js ***!
  \*********************************************/
/*! exports provided: ChainSequenceWrapper */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ChainSequenceWrapper", function() { return ChainSequenceWrapper; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _mol_model_structure__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../mol-model/structure */ "./lib/mol-model/structure.js");
/* harmony import */ var _wrapper__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./wrapper */ "./lib/mol-plugin-ui/sequence/wrapper.js");
/* harmony import */ var _mol_data_int__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../mol-data/int */ "./lib/mol-data/int.js");
/* harmony import */ var _mol_util_color_names__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../mol-util/color/names */ "./lib/mol-util/color/names.js");
/* harmony import */ var _mol_util_marker_action__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../mol-util/marker-action */ "./lib/mol-util/marker-action.js");
/**
 * Copyright (c) 2019 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */






var ChainSequenceWrapper = /** @class */ (function (_super) {
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__extends"])(ChainSequenceWrapper, _super);
    function ChainSequenceWrapper(data) {
        var _this = this;
        var residueCount = 0;
        var elementCount = 0;
        var counts = [];
        var l = _mol_model_structure__WEBPACK_IMPORTED_MODULE_1__["StructureElement"].Location.create(data.structure);
        var unitIndices = new Map();
        var lociElements = [];
        for (var i = 0, il = data.units.length; i < il; ++i) {
            var unit = data.units[i];
            _mol_model_structure__WEBPACK_IMPORTED_MODULE_1__["StructureElement"].Location.set(l, data.structure, unit, unit.elements[0]);
            var entitySeq = unit.model.sequence.byEntityKey[_mol_model_structure__WEBPACK_IMPORTED_MODULE_1__["StructureProperties"].entity.key(l)];
            if (entitySeq)
                residueCount += entitySeq.sequence.length;
            elementCount += unit.elements.length;
            var indices = _mol_data_int__WEBPACK_IMPORTED_MODULE_3__["Interval"].ofBounds(0, unit.elements.length);
            unitIndices.set(unit.id, indices);
            lociElements.push({ unit: unit, indices: indices });
        }
        if (residueCount > 0)
            counts.push(residueCount + " residues");
        counts.push(elementCount + " elements");
        var length = 1;
        var markerArray = new Uint8Array(length);
        _this = _super.call(this, data, markerArray, length) || this;
        _this.label = "Whole Chain (" + counts.join(', ') + ")";
        _this.unitIndices = unitIndices;
        _this.loci = _mol_model_structure__WEBPACK_IMPORTED_MODULE_1__["StructureElement"].Loci(_this.data.structure, lociElements);
        return _this;
    }
    ChainSequenceWrapper.prototype.residueLabel = function (seqIdx) {
        return this.label;
    };
    ChainSequenceWrapper.prototype.residueColor = function (seqIdx) {
        return _mol_util_color_names__WEBPACK_IMPORTED_MODULE_4__["ColorNames"].black;
    };
    ChainSequenceWrapper.prototype.residueClass = function (seqIdx) {
        return 'msp-sequence-present';
    };
    ChainSequenceWrapper.prototype.mark = function (loci, action) {
        var changed = false;
        var structure = this.data.structure;
        if (_mol_model_structure__WEBPACK_IMPORTED_MODULE_1__["StructureElement"].Loci.is(loci)) {
            if (!_mol_model_structure__WEBPACK_IMPORTED_MODULE_1__["Structure"].areRootsEquivalent(loci.structure, structure))
                return false;
            loci = _mol_model_structure__WEBPACK_IMPORTED_MODULE_1__["StructureElement"].Loci.remap(loci, structure);
            for (var _i = 0, _a = loci.elements; _i < _a.length; _i++) {
                var e = _a[_i];
                var indices = this.unitIndices.get(e.unit.id);
                if (indices) {
                    if (_mol_data_int__WEBPACK_IMPORTED_MODULE_3__["OrderedSet"].isSubset(indices, e.indices)) {
                        if (Object(_mol_util_marker_action__WEBPACK_IMPORTED_MODULE_5__["applyMarkerAction"])(this.markerArray, _mol_data_int__WEBPACK_IMPORTED_MODULE_3__["Interval"].ofSingleton(0), action))
                            changed = true;
                    }
                }
            }
        }
        else if (_mol_model_structure__WEBPACK_IMPORTED_MODULE_1__["Structure"].isLoci(loci)) {
            if (!_mol_model_structure__WEBPACK_IMPORTED_MODULE_1__["Structure"].areRootsEquivalent(loci.structure, structure))
                return false;
            if (Object(_mol_util_marker_action__WEBPACK_IMPORTED_MODULE_5__["applyMarkerAction"])(this.markerArray, _mol_data_int__WEBPACK_IMPORTED_MODULE_3__["Interval"].ofSingleton(0), action))
                changed = true;
        }
        return changed;
    };
    ChainSequenceWrapper.prototype.getLoci = function (seqIdx) {
        return this.loci;
    };
    return ChainSequenceWrapper;
}(_wrapper__WEBPACK_IMPORTED_MODULE_2__["SequenceWrapper"]));

//# sourceMappingURL=chain.js.map

/***/ }),

/***/ "./lib/mol-plugin-ui/sequence/element.js":
/*!***********************************************!*\
  !*** ./lib/mol-plugin-ui/sequence/element.js ***!
  \***********************************************/
/*! exports provided: ElementSequenceWrapper */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ElementSequenceWrapper", function() { return ElementSequenceWrapper; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _mol_model_structure__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../mol-model/structure */ "./lib/mol-model/structure.js");
/* harmony import */ var _wrapper__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./wrapper */ "./lib/mol-plugin-ui/sequence/wrapper.js");
/* harmony import */ var _mol_data_int__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../mol-data/int */ "./lib/mol-data/int.js");
/* harmony import */ var _mol_util_color_names__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../mol-util/color/names */ "./lib/mol-util/color/names.js");
/* harmony import */ var _mol_util_marker_action__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../mol-util/marker-action */ "./lib/mol-util/marker-action.js");
/**
 * Copyright (c) 2019 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */






var ElementSequenceWrapper = /** @class */ (function (_super) {
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__extends"])(ElementSequenceWrapper, _super);
    function ElementSequenceWrapper(data) {
        var _this = this;
        var length = 0;
        var unitIndices = new Map();
        var lociElements = [];
        for (var i = 0, il = data.units.length; i < il; ++i) {
            var unit = data.units[i];
            length += unit.elements.length;
            var indices = _mol_data_int__WEBPACK_IMPORTED_MODULE_3__["Interval"].ofBounds(0, unit.elements.length);
            unitIndices.set(unit.id, indices);
            lociElements.push({ unit: unit, indices: indices });
        }
        var markerArray = new Uint8Array(length);
        _this = _super.call(this, data, markerArray, length) || this;
        _this.unitIndices = unitIndices;
        return _this;
    }
    ElementSequenceWrapper.prototype.residueLabel = function (seqIdx) {
        return 'X';
    };
    ElementSequenceWrapper.prototype.residueColor = function (seqIdx) {
        return _mol_util_color_names__WEBPACK_IMPORTED_MODULE_4__["ColorNames"].black;
    };
    ElementSequenceWrapper.prototype.residueClass = function (seqIdx) {
        return 'msp-sequence-present';
    };
    ElementSequenceWrapper.prototype.mark = function (loci, action) {
        var changed = false;
        var _a = this.data, structure = _a.structure, units = _a.units;
        if (_mol_model_structure__WEBPACK_IMPORTED_MODULE_1__["StructureElement"].Loci.is(loci)) {
            if (!_mol_model_structure__WEBPACK_IMPORTED_MODULE_1__["Structure"].areRootsEquivalent(loci.structure, structure))
                return false;
            loci = _mol_model_structure__WEBPACK_IMPORTED_MODULE_1__["StructureElement"].Loci.remap(loci, structure);
            for (var _i = 0, _b = loci.elements; _i < _b.length; _i++) {
                var e = _b[_i];
                var indices = this.unitIndices.get(e.unit.id);
                if (indices) {
                    if (_mol_data_int__WEBPACK_IMPORTED_MODULE_3__["OrderedSet"].isSubset(indices, e.indices)) {
                        if (Object(_mol_util_marker_action__WEBPACK_IMPORTED_MODULE_5__["applyMarkerAction"])(this.markerArray, e.indices, action))
                            changed = true;
                    }
                }
            }
        }
        else if (_mol_model_structure__WEBPACK_IMPORTED_MODULE_1__["Structure"].isLoci(loci)) {
            if (!_mol_model_structure__WEBPACK_IMPORTED_MODULE_1__["Structure"].areRootsEquivalent(loci.structure, structure))
                return false;
            for (var i = 0, il = units.length; i < il; ++i) {
                var indices = this.unitIndices.get(units[i].id);
                if (Object(_mol_util_marker_action__WEBPACK_IMPORTED_MODULE_5__["applyMarkerAction"])(this.markerArray, indices, action))
                    changed = true;
            }
        }
        return changed;
    };
    ElementSequenceWrapper.prototype.getLoci = function (seqIdx) {
        var units = this.data.units;
        var lociElements = [];
        var offset = 0;
        for (var i = 0, il = units.length; i < il; ++i) {
            var unit = units[i];
            if (seqIdx < offset + unit.elements.length) {
                lociElements.push({ unit: unit, indices: _mol_data_int__WEBPACK_IMPORTED_MODULE_3__["Interval"].ofSingleton(seqIdx - offset) });
                break;
            }
            offset += unit.elements.length;
        }
        return _mol_model_structure__WEBPACK_IMPORTED_MODULE_1__["StructureElement"].Loci(this.data.structure, lociElements);
    };
    return ElementSequenceWrapper;
}(_wrapper__WEBPACK_IMPORTED_MODULE_2__["SequenceWrapper"]));

//# sourceMappingURL=element.js.map

/***/ }),

/***/ "./lib/mol-plugin-ui/sequence/hetero.js":
/*!**********************************************!*\
  !*** ./lib/mol-plugin-ui/sequence/hetero.js ***!
  \**********************************************/
/*! exports provided: HeteroSequenceWrapper */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "HeteroSequenceWrapper", function() { return HeteroSequenceWrapper; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _mol_model_structure__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../mol-model/structure */ "./lib/mol-model/structure.js");
/* harmony import */ var _wrapper__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./wrapper */ "./lib/mol-plugin-ui/sequence/wrapper.js");
/* harmony import */ var _mol_data_int__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../mol-data/int */ "./lib/mol-data/int.js");
/* harmony import */ var _mol_util_color_names__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../mol-util/color/names */ "./lib/mol-util/color/names.js");
/* harmony import */ var _mol_util_marker_action__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../mol-util/marker-action */ "./lib/mol-util/marker-action.js");
/**
 * Copyright (c) 2019 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */






var HeteroSequenceWrapper = /** @class */ (function (_super) {
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__extends"])(HeteroSequenceWrapper, _super);
    function HeteroSequenceWrapper(data) {
        var _this = this;
        var sequence = [];
        var sequenceIndices = new Map();
        var residueIndices = new Map();
        var seqToUnit = new Map();
        for (var i = 0, il = data.units.length; i < il; ++i) {
            var unit = data.units[i];
            var _a = unit.model.atomicHierarchy, residueAtomSegments = _a.residueAtomSegments, atoms = _a.atoms;
            var residueIt = _mol_data_int__WEBPACK_IMPORTED_MODULE_3__["Segmentation"].transientSegments(residueAtomSegments, unit.elements);
            while (residueIt.hasNext) {
                var index = residueIt.move().index;
                sequenceIndices.set(index, sequence.length);
                residueIndices.set(sequence.length, index);
                seqToUnit.set(sequence.length, unit);
                sequence.push(atoms.label_comp_id.value(residueAtomSegments.offsets[index]));
            }
        }
        var length = sequence.length;
        var markerArray = new Uint8Array(length);
        _this = _super.call(this, data, markerArray, length) || this;
        _this.unitMap = new Map();
        for (var _i = 0, _b = data.units; _i < _b.length; _i++) {
            var unit = _b[_i];
            _this.unitMap.set(unit.id, unit);
        }
        _this.sequence = sequence;
        _this.sequenceIndices = sequenceIndices;
        _this.residueIndices = residueIndices;
        _this.seqToUnit = seqToUnit;
        return _this;
    }
    HeteroSequenceWrapper.prototype.residueLabel = function (seqIdx) {
        return this.sequence[seqIdx];
    };
    HeteroSequenceWrapper.prototype.residueColor = function (seqIdx) {
        return _mol_util_color_names__WEBPACK_IMPORTED_MODULE_4__["ColorNames"].black;
    };
    HeteroSequenceWrapper.prototype.residueClass = function (seqIdx) {
        return 'msp-sequence-present';
    };
    HeteroSequenceWrapper.prototype.mark = function (loci, action) {
        var _this = this;
        var changed = false;
        var structure = this.data.structure;
        if (_mol_model_structure__WEBPACK_IMPORTED_MODULE_1__["StructureElement"].Loci.is(loci)) {
            if (!_mol_model_structure__WEBPACK_IMPORTED_MODULE_1__["Structure"].areRootsEquivalent(loci.structure, structure))
                return false;
            loci = _mol_model_structure__WEBPACK_IMPORTED_MODULE_1__["StructureElement"].Loci.remap(loci, structure);
            var _loop_1 = function (e) {
                var unit = this_1.unitMap.get(e.unit.id);
                if (unit) {
                    var residueIndex_1 = e.unit.model.atomicHierarchy.residueAtomSegments.index;
                    _mol_data_int__WEBPACK_IMPORTED_MODULE_3__["OrderedSet"].forEach(e.indices, function (v) {
                        var seqIdx = _this.sequenceIndices.get(residueIndex_1[unit.elements[v]]);
                        if (seqIdx !== undefined && Object(_mol_util_marker_action__WEBPACK_IMPORTED_MODULE_5__["applyMarkerAction"])(_this.markerArray, _mol_data_int__WEBPACK_IMPORTED_MODULE_3__["Interval"].ofSingleton(seqIdx), action))
                            changed = true;
                    });
                }
            };
            var this_1 = this;
            for (var _i = 0, _a = loci.elements; _i < _a.length; _i++) {
                var e = _a[_i];
                _loop_1(e);
            }
        }
        else if (_mol_model_structure__WEBPACK_IMPORTED_MODULE_1__["Structure"].isLoci(loci)) {
            if (!_mol_model_structure__WEBPACK_IMPORTED_MODULE_1__["Structure"].areRootsEquivalent(loci.structure, structure))
                return false;
            if (Object(_mol_util_marker_action__WEBPACK_IMPORTED_MODULE_5__["applyMarkerAction"])(this.markerArray, _mol_data_int__WEBPACK_IMPORTED_MODULE_3__["Interval"].ofBounds(0, this.length), action))
                changed = true;
        }
        return changed;
    };
    HeteroSequenceWrapper.prototype.getLoci = function (seqIdx) {
        var elements = [];
        var rI = this.residueIndices.get(seqIdx);
        if (rI !== undefined) {
            var unit = this.seqToUnit.get(seqIdx);
            var offsets = unit.model.atomicHierarchy.residueAtomSegments.offsets;
            var start = _mol_data_int__WEBPACK_IMPORTED_MODULE_3__["SortedArray"].findPredecessorIndex(unit.elements, offsets[rI]);
            var end = _mol_data_int__WEBPACK_IMPORTED_MODULE_3__["SortedArray"].findPredecessorIndex(unit.elements, offsets[rI + 1]);
            elements.push({ unit: unit, indices: _mol_data_int__WEBPACK_IMPORTED_MODULE_3__["Interval"].ofBounds(start, end) });
        }
        return _mol_model_structure__WEBPACK_IMPORTED_MODULE_1__["StructureElement"].Loci(this.data.structure, elements);
    };
    return HeteroSequenceWrapper;
}(_wrapper__WEBPACK_IMPORTED_MODULE_2__["SequenceWrapper"]));

//# sourceMappingURL=hetero.js.map

/***/ }),

/***/ "./lib/mol-plugin-ui/sequence/polymer.js":
/*!***********************************************!*\
  !*** ./lib/mol-plugin-ui/sequence/polymer.js ***!
  \***********************************************/
/*! exports provided: PolymerSequenceWrapper */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "PolymerSequenceWrapper", function() { return PolymerSequenceWrapper; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _mol_model_structure__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../mol-model/structure */ "./lib/mol-model/structure.js");
/* harmony import */ var _wrapper__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./wrapper */ "./lib/mol-plugin-ui/sequence/wrapper.js");
/* harmony import */ var _mol_data_int__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../mol-data/int */ "./lib/mol-data/int.js");
/* harmony import */ var _mol_util_color_names__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../mol-util/color/names */ "./lib/mol-util/color/names.js");
/* harmony import */ var _mol_util_marker_action__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../mol-util/marker-action */ "./lib/mol-util/marker-action.js");
/**
 * Copyright (c) 2019 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */






var PolymerSequenceWrapper = /** @class */ (function (_super) {
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__extends"])(PolymerSequenceWrapper, _super);
    function PolymerSequenceWrapper(data) {
        var _this = this;
        var l = _mol_model_structure__WEBPACK_IMPORTED_MODULE_1__["StructureElement"].Location.create(data.structure, data.units[0], data.units[0].elements[0]);
        var entitySeq = data.units[0].model.sequence.byEntityKey[_mol_model_structure__WEBPACK_IMPORTED_MODULE_1__["StructureProperties"].entity.key(l)];
        var length = entitySeq.sequence.length;
        var markerArray = new Uint8Array(length);
        _this = _super.call(this, data, markerArray, length) || this;
        _this.unitMap = new Map();
        for (var _i = 0, _a = data.units; _i < _a.length; _i++) {
            var unit = _a[_i];
            _this.unitMap.set(unit.id, unit);
        }
        _this.sequence = entitySeq.sequence;
        _this.missing = data.units[0].model.properties.missingResidues;
        _this.modelNum = data.units[0].model.modelNum;
        _this.asymId = _mol_model_structure__WEBPACK_IMPORTED_MODULE_1__["Unit"].isAtomic(data.units[0]) ? _mol_model_structure__WEBPACK_IMPORTED_MODULE_1__["StructureProperties"].chain.label_asym_id(l) : _mol_model_structure__WEBPACK_IMPORTED_MODULE_1__["StructureProperties"].coarse.asym_id(l);
        var missing = [];
        for (var i = 0; i < length; ++i) {
            if (_this.missing.has(_this.modelNum, _this.asymId, _this.seqId(i)))
                missing.push(i);
        }
        _this.observed = _mol_data_int__WEBPACK_IMPORTED_MODULE_3__["OrderedSet"].subtract(_mol_data_int__WEBPACK_IMPORTED_MODULE_3__["Interval"].ofBounds(0, length), _mol_data_int__WEBPACK_IMPORTED_MODULE_3__["SortedArray"].ofSortedArray(missing));
        return _this;
    }
    PolymerSequenceWrapper.prototype.seqId = function (seqIdx) {
        return this.sequence.seqId.value(seqIdx);
    };
    PolymerSequenceWrapper.prototype.residueLabel = function (seqIdx) {
        return this.sequence.label.value(seqIdx) || this.sequence.code.value(seqIdx);
    };
    PolymerSequenceWrapper.prototype.residueColor = function (seqIdx) {
        return this.missing.has(this.modelNum, this.asymId, this.seqId(seqIdx))
            ? _mol_util_color_names__WEBPACK_IMPORTED_MODULE_4__["ColorNames"].grey
            : _mol_util_color_names__WEBPACK_IMPORTED_MODULE_4__["ColorNames"].black;
    };
    PolymerSequenceWrapper.prototype.residueClass = function (seqIdx) {
        return this.missing.has(this.modelNum, this.asymId, this.seqId(seqIdx))
            ? 'msp-sequence-missing'
            : 'msp-sequence-present';
    };
    PolymerSequenceWrapper.prototype.mark = function (loci, action) {
        var _this = this;
        var changed = false;
        var structure = this.data.structure;
        var index = function (seqId) { return _this.sequence.index(seqId); };
        if (_mol_model_structure__WEBPACK_IMPORTED_MODULE_1__["StructureElement"].Loci.is(loci)) {
            if (!_mol_model_structure__WEBPACK_IMPORTED_MODULE_1__["Structure"].areRootsEquivalent(loci.structure, structure))
                return false;
            loci = _mol_model_structure__WEBPACK_IMPORTED_MODULE_1__["StructureElement"].Loci.remap(loci, structure);
            for (var _i = 0, _a = loci.elements; _i < _a.length; _i++) {
                var e = _a[_i];
                if (!this.unitMap.has(e.unit.id))
                    continue;
                if (_mol_model_structure__WEBPACK_IMPORTED_MODULE_1__["Unit"].isAtomic(e.unit)) {
                    changed = applyMarkerAtomic(e, action, this.markerArray, index) || changed;
                }
                else {
                    changed = applyMarkerCoarse(e, action, this.markerArray, index) || changed;
                }
            }
        }
        else if (_mol_model_structure__WEBPACK_IMPORTED_MODULE_1__["Structure"].isLoci(loci)) {
            if (!_mol_model_structure__WEBPACK_IMPORTED_MODULE_1__["Structure"].areRootsEquivalent(loci.structure, structure))
                return false;
            if (Object(_mol_util_marker_action__WEBPACK_IMPORTED_MODULE_5__["applyMarkerAction"])(this.markerArray, this.observed, action))
                changed = true;
        }
        return changed;
    };
    PolymerSequenceWrapper.prototype.getLoci = function (seqIdx) {
        var query = createResidueQuery(this.data.units[0].chainGroupId, this.data.units[0].conformation.operator.name, this.seqId(seqIdx));
        return _mol_model_structure__WEBPACK_IMPORTED_MODULE_1__["StructureSelection"].toLociWithSourceUnits(_mol_model_structure__WEBPACK_IMPORTED_MODULE_1__["StructureQuery"].run(query, this.data.structure));
    };
    return PolymerSequenceWrapper;
}(_wrapper__WEBPACK_IMPORTED_MODULE_2__["SequenceWrapper"]));

function createResidueQuery(chainGroupId, operatorName, label_seq_id) {
    return _mol_model_structure__WEBPACK_IMPORTED_MODULE_1__["Queries"].generators.atoms({
        unitTest: function (ctx) {
            return (_mol_model_structure__WEBPACK_IMPORTED_MODULE_1__["StructureProperties"].unit.chainGroupId(ctx.element) === chainGroupId &&
                _mol_model_structure__WEBPACK_IMPORTED_MODULE_1__["StructureProperties"].unit.operator_name(ctx.element) === operatorName);
        },
        residueTest: function (ctx) {
            if (ctx.element.unit.kind === 0 /* Atomic */) {
                return _mol_model_structure__WEBPACK_IMPORTED_MODULE_1__["StructureProperties"].residue.label_seq_id(ctx.element) === label_seq_id;
            }
            else {
                return (_mol_model_structure__WEBPACK_IMPORTED_MODULE_1__["StructureProperties"].coarse.seq_id_begin(ctx.element) <= label_seq_id &&
                    _mol_model_structure__WEBPACK_IMPORTED_MODULE_1__["StructureProperties"].coarse.seq_id_end(ctx.element) >= label_seq_id);
            }
        }
    });
}
function applyMarkerAtomic(e, action, markerArray, index) {
    var _a = e.unit, model = _a.model, elements = _a.elements;
    var residueIndex = model.atomicHierarchy.residueAtomSegments.index;
    var label_seq_id = model.atomicHierarchy.residues.label_seq_id;
    var changed = false;
    _mol_data_int__WEBPACK_IMPORTED_MODULE_3__["OrderedSet"].forEachSegment(e.indices, function (i) { return residueIndex[elements[i]]; }, function (rI) {
        var seqId = label_seq_id.value(rI);
        changed = Object(_mol_util_marker_action__WEBPACK_IMPORTED_MODULE_5__["applyMarkerActionAtPosition"])(markerArray, index(seqId), action) || changed;
    });
    return changed;
}
function applyMarkerCoarse(e, action, markerArray, index) {
    var _a = e.unit, model = _a.model, elements = _a.elements;
    var begin = _mol_model_structure__WEBPACK_IMPORTED_MODULE_1__["Unit"].isSpheres(e.unit) ? model.coarseHierarchy.spheres.seq_id_begin : model.coarseHierarchy.gaussians.seq_id_begin;
    var end = _mol_model_structure__WEBPACK_IMPORTED_MODULE_1__["Unit"].isSpheres(e.unit) ? model.coarseHierarchy.spheres.seq_id_end : model.coarseHierarchy.gaussians.seq_id_end;
    var changed = false;
    _mol_data_int__WEBPACK_IMPORTED_MODULE_3__["OrderedSet"].forEach(e.indices, function (i) {
        var eI = elements[i];
        for (var s = index(begin.value(eI)), e_1 = index(end.value(eI)); s <= e_1; s++) {
            changed = Object(_mol_util_marker_action__WEBPACK_IMPORTED_MODULE_5__["applyMarkerActionAtPosition"])(markerArray, s, action) || changed;
        }
    });
    return changed;
}
//# sourceMappingURL=polymer.js.map

/***/ }),

/***/ "./lib/mol-plugin-ui/sequence/sequence.js":
/*!************************************************!*\
  !*** ./lib/mol-plugin-ui/sequence/sequence.js ***!
  \************************************************/
/*! exports provided: Sequence */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Sequence", function() { return Sequence; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! react */ "./node_modules/react/index.js");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _base__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../base */ "./lib/mol-plugin-ui/base.js");
/* harmony import */ var _mol_util_input_input_observer__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../mol-util/input/input-observer */ "./lib/mol-util/input/input-observer.js");
/* harmony import */ var _mol_model_structure__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../mol-model/structure */ "./lib/mol-model/structure.js");
/* harmony import */ var rxjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! rxjs */ "./node_modules/rxjs/_esm5/index.js");
/* harmony import */ var rxjs_operators__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! rxjs/operators */ "./node_modules/rxjs/_esm5/operators/index.js");
/* harmony import */ var _mol_data_int__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../../mol-data/int */ "./lib/mol-data/int.js");
/* harmony import */ var _mol_repr_representation__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ../../mol-repr/representation */ "./lib/mol-repr/representation.js");
/**
 * Copyright (c) 2018-2020 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 * @author David Sehnal <david.sehnal@gmail.com>
 */









/** Note, if this is changed, the CSS for `msp-sequence-number` needs adjustment too */
var MaxSequenceNumberSize = 5;
// TODO: this is somewhat inefficient and should be done using a canvas.
var Sequence = /** @class */ (function (_super) {
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__extends"])(Sequence, _super);
    function Sequence() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.parentDiv = react__WEBPACK_IMPORTED_MODULE_1__["createRef"]();
        _this.lastMouseOverSeqIdx = -1;
        _this.highlightQueue = new rxjs__WEBPACK_IMPORTED_MODULE_5__["Subject"]();
        _this.lociHighlightProvider = function (loci, action) {
            var changed = _this.props.sequenceWrapper.markResidue(loci.loci, action);
            if (changed)
                _this.updateMarker();
        };
        _this.lociSelectionProvider = function (loci, action) {
            var changed = _this.props.sequenceWrapper.markResidue(loci.loci, action);
            if (changed)
                _this.updateMarker();
        };
        _this.contextMenu = function (e) {
            e.preventDefault();
        };
        _this.mouseDownLoci = undefined;
        _this.mouseDown = function (e) {
            e.stopPropagation();
            var seqIdx = _this.getSeqIdx(e);
            var loci = _this.getLoci(seqIdx);
            var buttons = Object(_mol_util_input_input_observer__WEBPACK_IMPORTED_MODULE_3__["getButtons"])(e.nativeEvent);
            var button = Object(_mol_util_input_input_observer__WEBPACK_IMPORTED_MODULE_3__["getButton"])(e.nativeEvent);
            var modifiers = Object(_mol_util_input_input_observer__WEBPACK_IMPORTED_MODULE_3__["getModifiers"])(e.nativeEvent);
            _this.click(loci, buttons, button, modifiers);
            _this.mouseDownLoci = loci;
        };
        _this.mouseUp = function (e) {
            e.stopPropagation();
            // ignore mouse-up events without a bound loci
            if (_this.mouseDownLoci === undefined)
                return;
            var seqIdx = _this.getSeqIdx(e);
            var loci = _this.getLoci(seqIdx);
            if (loci && !_mol_model_structure__WEBPACK_IMPORTED_MODULE_4__["StructureElement"].Loci.areEqual(_this.mouseDownLoci, loci)) {
                var buttons = Object(_mol_util_input_input_observer__WEBPACK_IMPORTED_MODULE_3__["getButtons"])(e.nativeEvent);
                var button = Object(_mol_util_input_input_observer__WEBPACK_IMPORTED_MODULE_3__["getButton"])(e.nativeEvent);
                var modifiers = Object(_mol_util_input_input_observer__WEBPACK_IMPORTED_MODULE_3__["getModifiers"])(e.nativeEvent);
                var ref = _this.mouseDownLoci.elements[0];
                var ext = loci.elements[0];
                var min = Math.min(_mol_data_int__WEBPACK_IMPORTED_MODULE_7__["OrderedSet"].min(ref.indices), _mol_data_int__WEBPACK_IMPORTED_MODULE_7__["OrderedSet"].min(ext.indices));
                var max = Math.max(_mol_data_int__WEBPACK_IMPORTED_MODULE_7__["OrderedSet"].max(ref.indices), _mol_data_int__WEBPACK_IMPORTED_MODULE_7__["OrderedSet"].max(ext.indices));
                var range = _mol_model_structure__WEBPACK_IMPORTED_MODULE_4__["StructureElement"].Loci(loci.structure, [{
                        unit: ref.unit,
                        indices: _mol_data_int__WEBPACK_IMPORTED_MODULE_7__["OrderedSet"].ofRange(min, max)
                    }]);
                _this.click(_mol_model_structure__WEBPACK_IMPORTED_MODULE_4__["StructureElement"].Loci.subtract(range, _this.mouseDownLoci), buttons, button, modifiers);
            }
            _this.mouseDownLoci = undefined;
        };
        _this.location = _mol_model_structure__WEBPACK_IMPORTED_MODULE_4__["StructureElement"].Location.create(void 0);
        _this.mouseMove = function (e) {
            e.stopPropagation();
            var buttons = Object(_mol_util_input_input_observer__WEBPACK_IMPORTED_MODULE_3__["getButtons"])(e.nativeEvent);
            var button = Object(_mol_util_input_input_observer__WEBPACK_IMPORTED_MODULE_3__["getButton"])(e.nativeEvent);
            var modifiers = Object(_mol_util_input_input_observer__WEBPACK_IMPORTED_MODULE_3__["getModifiers"])(e.nativeEvent);
            var el = e.target;
            if (!el || !el.getAttribute) {
                if (_this.lastMouseOverSeqIdx === -1)
                    return;
                _this.lastMouseOverSeqIdx = -1;
                _this.highlightQueue.next({ seqIdx: -1, buttons: buttons, button: button, modifiers: modifiers });
                return;
            }
            var seqIdx = el.hasAttribute('data-seqid') ? +el.getAttribute('data-seqid') : -1;
            if (_this.lastMouseOverSeqIdx === seqIdx) {
                return;
            }
            else {
                _this.lastMouseOverSeqIdx = seqIdx;
                if (_this.mouseDownLoci !== undefined) {
                    var loci = _this.getLoci(seqIdx);
                    _this.hover(loci, 0 /* None */, 0 /* None */, Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, modifiers), { shift: true }));
                }
                else {
                    _this.highlightQueue.next({ seqIdx: seqIdx, buttons: buttons, button: button, modifiers: modifiers });
                }
            }
        };
        _this.mouseLeave = function (e) {
            e.stopPropagation();
            _this.mouseDownLoci = undefined;
            if (_this.lastMouseOverSeqIdx === -1)
                return;
            _this.lastMouseOverSeqIdx = -1;
            var buttons = Object(_mol_util_input_input_observer__WEBPACK_IMPORTED_MODULE_3__["getButtons"])(e.nativeEvent);
            var button = Object(_mol_util_input_input_observer__WEBPACK_IMPORTED_MODULE_3__["getButton"])(e.nativeEvent);
            var modifiers = Object(_mol_util_input_input_observer__WEBPACK_IMPORTED_MODULE_3__["getModifiers"])(e.nativeEvent);
            _this.highlightQueue.next({ seqIdx: -1, buttons: buttons, button: button, modifiers: modifiers });
        };
        return _this;
    }
    Object.defineProperty(Sequence.prototype, "sequenceNumberPeriod", {
        get: function () {
            if (this.props.sequenceNumberPeriod !== undefined) {
                return this.props.sequenceNumberPeriod;
            }
            if (this.props.sequenceWrapper.length > 10)
                return 10;
            var lastSeqNum = this.getSequenceNumber(this.props.sequenceWrapper.length - 1);
            if (lastSeqNum.length > 1)
                return 5;
            return 1;
        },
        enumerable: false,
        configurable: true
    });
    Sequence.prototype.componentDidMount = function () {
        var _this = this;
        this.plugin.managers.interactivity.lociHighlights.addProvider(this.lociHighlightProvider);
        this.plugin.managers.interactivity.lociSelects.addProvider(this.lociSelectionProvider);
        this.subscribe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_6__["debounceTime"])(15)(this.highlightQueue), function (e) {
            var loci = _this.getLoci(e.seqIdx < 0 ? void 0 : e.seqIdx);
            _this.hover(loci, e.buttons, e.button, e.modifiers);
        });
        // this.updateMarker()
    };
    Sequence.prototype.componentWillUnmount = function () {
        _super.prototype.componentWillUnmount.call(this);
        this.plugin.managers.interactivity.lociHighlights.removeProvider(this.lociHighlightProvider);
        this.plugin.managers.interactivity.lociSelects.removeProvider(this.lociSelectionProvider);
    };
    Sequence.prototype.getLoci = function (seqIdx) {
        if (seqIdx !== undefined) {
            var loci = this.props.sequenceWrapper.getLoci(seqIdx);
            if (!_mol_model_structure__WEBPACK_IMPORTED_MODULE_4__["StructureElement"].Loci.isEmpty(loci))
                return loci;
        }
    };
    Sequence.prototype.getSeqIdx = function (e) {
        var seqIdx = undefined;
        var el = e.target;
        if (el && el.getAttribute) {
            seqIdx = el.hasAttribute('data-seqid') ? +el.getAttribute('data-seqid') : undefined;
        }
        return seqIdx;
    };
    Sequence.prototype.hover = function (loci, buttons, button, modifiers) {
        var ev = { current: _mol_repr_representation__WEBPACK_IMPORTED_MODULE_8__["Representation"].Loci.Empty, buttons: buttons, button: button, modifiers: modifiers };
        if (loci !== undefined && !_mol_model_structure__WEBPACK_IMPORTED_MODULE_4__["StructureElement"].Loci.isEmpty(loci)) {
            ev.current = { loci: loci };
        }
        this.plugin.behaviors.interaction.hover.next(ev);
    };
    Sequence.prototype.click = function (loci, buttons, button, modifiers) {
        var ev = { current: _mol_repr_representation__WEBPACK_IMPORTED_MODULE_8__["Representation"].Loci.Empty, buttons: buttons, button: button, modifiers: modifiers };
        if (loci !== undefined && !_mol_model_structure__WEBPACK_IMPORTED_MODULE_4__["StructureElement"].Loci.isEmpty(loci)) {
            ev.current = { loci: loci };
        }
        this.plugin.behaviors.interaction.click.next(ev);
    };
    Sequence.prototype.getBackgroundColor = function (marker) {
        // TODO: make marker color configurable
        if (typeof marker === 'undefined')
            console.error('unexpected marker value');
        return marker === 0 ? '' : marker % 2 === 0 ? 'rgb(51, 255, 25)' /* selected */ : 'rgb(255, 102, 153)' /* highlighted */;
    };
    Sequence.prototype.getResidueClass = function (seqIdx, label) {
        return label.length > 1
            ? this.props.sequenceWrapper.residueClass(seqIdx) + (seqIdx === 0 ? ' msp-sequence-residue-long-begin' : ' msp-sequence-residue-long')
            : this.props.sequenceWrapper.residueClass(seqIdx);
    };
    Sequence.prototype.residue = function (seqIdx, label, marker) {
        return react__WEBPACK_IMPORTED_MODULE_1__["createElement"]("span", { key: seqIdx, "data-seqid": seqIdx, style: { backgroundColor: this.getBackgroundColor(marker) }, className: this.getResidueClass(seqIdx, label) }, "\u200B" + label + "\u200B");
    };
    Sequence.prototype.getSequenceNumberClass = function (seqIdx, seqNum, label) {
        var classList = ['msp-sequence-number'];
        if (seqNum.startsWith('-')) {
            if (label.length > 1 && seqIdx > 0)
                classList.push('msp-sequence-number-long-negative');
            else
                classList.push('msp-sequence-number-negative');
        }
        else {
            if (label.length > 1 && seqIdx > 0)
                classList.push('msp-sequence-number-long');
        }
        return classList.join(' ');
    };
    Sequence.prototype.getSequenceNumber = function (seqIdx) {
        var seqNum = '';
        var loci = this.props.sequenceWrapper.getLoci(seqIdx);
        var l = _mol_model_structure__WEBPACK_IMPORTED_MODULE_4__["StructureElement"].Loci.getFirstLocation(loci, this.location);
        if (l) {
            if (_mol_model_structure__WEBPACK_IMPORTED_MODULE_4__["Unit"].isAtomic(l.unit)) {
                var seqId = _mol_model_structure__WEBPACK_IMPORTED_MODULE_4__["StructureProperties"].residue.auth_seq_id(l);
                var insCode = _mol_model_structure__WEBPACK_IMPORTED_MODULE_4__["StructureProperties"].residue.pdbx_PDB_ins_code(l);
                seqNum = "" + seqId + (insCode ? insCode : '');
            }
            else if (_mol_model_structure__WEBPACK_IMPORTED_MODULE_4__["Unit"].isCoarse(l.unit)) {
                seqNum = "" + (seqIdx + 1);
            }
        }
        return seqNum;
    };
    Sequence.prototype.padSeqNum = function (n) {
        if (n.length < MaxSequenceNumberSize)
            return n + new Array(MaxSequenceNumberSize - n.length + 1).join('\u00A0');
        return n;
    };
    Sequence.prototype.getSequenceNumberSpan = function (seqIdx, label) {
        var seqNum = this.getSequenceNumber(seqIdx);
        return react__WEBPACK_IMPORTED_MODULE_1__["createElement"]("span", { key: "marker-" + seqIdx, className: this.getSequenceNumberClass(seqIdx, seqNum, label) }, this.padSeqNum(seqNum));
    };
    Sequence.prototype.updateMarker = function () {
        if (!this.parentDiv.current)
            return;
        var xs = this.parentDiv.current.children;
        var markerArray = this.props.sequenceWrapper.markerArray;
        var hasNumbers = !this.props.hideSequenceNumbers, period = this.sequenceNumberPeriod;
        // let first: HTMLSpanElement | undefined;
        var o = 0;
        for (var i = 0, il = markerArray.length; i < il; i++) {
            if (hasNumbers && i % period === 0 && i < il)
                o++;
            // o + 1 to account for help icon
            var span = xs[o];
            if (!span)
                return;
            o++;
            // if (!first && markerArray[i] > 0) {
            //     first = span;
            // }
            var backgroundColor = this.getBackgroundColor(markerArray[i]);
            if (span.style.backgroundColor !== backgroundColor)
                span.style.backgroundColor = backgroundColor;
        }
        // if (first) {
        //     first.scrollIntoView({ block: 'nearest' });
        // }
    };
    Sequence.prototype.render = function () {
        var sw = this.props.sequenceWrapper;
        var elems = [];
        var hasNumbers = !this.props.hideSequenceNumbers, period = this.sequenceNumberPeriod;
        for (var i = 0, il = sw.length; i < il; ++i) {
            var label = sw.residueLabel(i);
            // add sequence number before name so the html element do not get separated by a line-break
            if (hasNumbers && i % period === 0 && i < il) {
                elems[elems.length] = this.getSequenceNumberSpan(i, label);
            }
            elems[elems.length] = this.residue(i, label, sw.markerArray[i]);
        }
        // calling .updateMarker here is neccesary to ensure existing
        // residue spans are updated as react won't update them
        this.updateMarker();
        return react__WEBPACK_IMPORTED_MODULE_1__["createElement"]("div", { className: 'msp-sequence-wrapper', onContextMenu: this.contextMenu, onMouseDown: this.mouseDown, onMouseUp: this.mouseUp, onMouseMove: this.mouseMove, onMouseLeave: this.mouseLeave, ref: this.parentDiv }, elems);
    };
    return Sequence;
}(_base__WEBPACK_IMPORTED_MODULE_2__["PluginUIComponent"]));

//# sourceMappingURL=sequence.js.map

/***/ }),

/***/ "./lib/mol-plugin-ui/sequence/wrapper.js":
/*!***********************************************!*\
  !*** ./lib/mol-plugin-ui/sequence/wrapper.js ***!
  \***********************************************/
/*! exports provided: SequenceWrapper */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SequenceWrapper", function() { return SequenceWrapper; });
/* harmony import */ var _mol_data_int__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../mol-data/int */ "./lib/mol-data/int.js");
/* harmony import */ var _mol_model_loci__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../mol-model/loci */ "./lib/mol-model/loci.js");
/* harmony import */ var _mol_util_marker_action__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../mol-util/marker-action */ "./lib/mol-util/marker-action.js");
/**
 * Copyright (c) 2019 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */




var SequenceWrapper = /** @class */ (function () {
    function SequenceWrapper(data, markerArray, length) {
        this.data = data;
        this.markerArray = markerArray;
        this.length = length;
    }
    SequenceWrapper.prototype.markResidue = function (loci, action) {
        if (Object(_mol_model_loci__WEBPACK_IMPORTED_MODULE_1__["isEveryLoci"])(loci)) {
            return Object(_mol_util_marker_action__WEBPACK_IMPORTED_MODULE_2__["applyMarkerAction"])(this.markerArray, _mol_data_int__WEBPACK_IMPORTED_MODULE_0__["Interval"].ofLength(this.length), action);
        }
        else {
            return this.mark(loci, action);
        }
    };
    return SequenceWrapper;
}());
//# sourceMappingURL=wrapper.js.map

/***/ }),

/***/ "./lib/mol-plugin-ui/skin/light.scss":
/*!*******************************************!*\
  !*** ./lib/mol-plugin-ui/skin/light.scss ***!
  \*******************************************/
/*! no exports provided */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
// extracted by mini-css-extract-plugin


/***/ }),

/***/ "./lib/mol-plugin-ui/state/actions.js":
/*!********************************************!*\
  !*** ./lib/mol-plugin-ui/state/actions.js ***!
  \********************************************/
/*! exports provided: StateObjectActions */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "StateObjectActions", function() { return StateObjectActions; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! react */ "./node_modules/react/index.js");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _base__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../base */ "./lib/mol-plugin-ui/base.js");
/* harmony import */ var _controls_icons__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../controls/icons */ "./lib/mol-plugin-ui/controls/icons.js");
/* harmony import */ var _apply_action__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./apply-action */ "./lib/mol-plugin-ui/state/apply-action.js");
/**
 * Copyright (c) 2018 - 2019 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author David Sehnal <david.sehnal@gmail.com>
 */





var StateObjectActions = /** @class */ (function (_super) {
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__extends"])(StateObjectActions, _super);
    function StateObjectActions() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(StateObjectActions.prototype, "current", {
        get: function () {
            return this.props.state.behaviors.currentObject.value;
        },
        enumerable: false,
        configurable: true
    });
    StateObjectActions.prototype.componentDidMount = function () {
        // TODO: handle tree change: some state actions might become invalid
        // this.subscribe(this.props.state.events.changed, o => {
        //     this.setState(createStateObjectActionSelectState(this.props));
        // });
        var _this = this;
        this.subscribe(this.plugin.state.events.object.updated, function (_a) {
            var ref = _a.ref, state = _a.state;
            var current = _this.current;
            if (current.ref !== ref || current.state !== state)
                return;
            _this.forceUpdate();
        });
        this.subscribe(this.plugin.state.data.actions.events.added, function () { return _this.forceUpdate(); });
        this.subscribe(this.plugin.state.data.actions.events.removed, function () { return _this.forceUpdate(); });
    };
    StateObjectActions.prototype.render = function () {
        var _this = this;
        var _a = this.props, state = _a.state, ref = _a.nodeRef;
        var cell = state.cells.get(ref);
        var actions = state.actions.fromCell(cell, this.plugin);
        if (actions.length === 0)
            return null;
        var def = cell.transform.transformer.definition;
        var display = cell.obj ? cell.obj.label : (def.display && def.display.name) || def.name;
        return react__WEBPACK_IMPORTED_MODULE_1__["createElement"]("div", { className: 'msp-state-actions' },
            !this.props.hideHeader && react__WEBPACK_IMPORTED_MODULE_1__["createElement"]("div", { className: 'msp-section-header' },
                react__WEBPACK_IMPORTED_MODULE_1__["createElement"](_controls_icons__WEBPACK_IMPORTED_MODULE_3__["Icon"], { svg: _controls_icons__WEBPACK_IMPORTED_MODULE_3__["CodeSvg"] }),
                " ", "Actions (" + display + ")"),
            actions.map(function (act, i) { return react__WEBPACK_IMPORTED_MODULE_1__["createElement"](_apply_action__WEBPACK_IMPORTED_MODULE_4__["ApplyActionControl"], { key: "" + act.id, state: state, action: act, nodeRef: ref, initiallyCollapsed: i === 0 ? !_this.props.alwaysExpandFirst && _this.props.initiallyCollapsed : _this.props.initiallyCollapsed }); }));
    };
    return StateObjectActions;
}(_base__WEBPACK_IMPORTED_MODULE_2__["PluginUIComponent"]));

//# sourceMappingURL=actions.js.map

/***/ }),

/***/ "./lib/mol-plugin-ui/state/animation.js":
/*!**********************************************!*\
  !*** ./lib/mol-plugin-ui/state/animation.js ***!
  \**********************************************/
/*! exports provided: AnimationControls */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "AnimationControls", function() { return AnimationControls; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! react */ "./node_modules/react/index.js");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _base__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../base */ "./lib/mol-plugin-ui/base.js");
/* harmony import */ var _controls_parameters__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../controls/parameters */ "./lib/mol-plugin-ui/controls/parameters.js");
/* harmony import */ var _controls_common__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../controls/common */ "./lib/mol-plugin-ui/controls/common.js");
/* harmony import */ var _controls_icons__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../controls/icons */ "./lib/mol-plugin-ui/controls/icons.js");
/**
 * Copyright (c) 2019 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author David Sehnal <david.sehnal@gmail.com>
 */






var AnimationControls = /** @class */ (function (_super) {
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__extends"])(AnimationControls, _super);
    function AnimationControls() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.updateParams = function (p) {
            var _a;
            _this.plugin.managers.animation.updateParams((_a = {}, _a[p.name] = p.value, _a));
        };
        _this.updateCurrentParams = function (p) {
            var _a;
            _this.plugin.managers.animation.updateCurrentParams((_a = {}, _a[p.name] = p.value, _a));
        };
        _this.startOrStop = function () {
            var anim = _this.plugin.managers.animation;
            if (anim.state.animationState === 'playing')
                anim.stop();
            else {
                if (_this.props.onStart)
                    _this.props.onStart();
                anim.start();
            }
        };
        return _this;
    }
    AnimationControls.prototype.componentDidMount = function () {
        var _this = this;
        this.subscribe(this.plugin.managers.animation.events.updated, function () { return _this.forceUpdate(); });
    };
    AnimationControls.prototype.render = function () {
        var _a, _b;
        var anim = this.plugin.managers.animation;
        if (anim.isEmpty)
            return null;
        var isDisabled = anim.state.animationState === 'playing';
        var canApply = (_b = (_a = anim.current.anim).canApply) === null || _b === void 0 ? void 0 : _b.call(_a, this.plugin);
        return react__WEBPACK_IMPORTED_MODULE_1__["createElement"](react__WEBPACK_IMPORTED_MODULE_1__["Fragment"], null,
            react__WEBPACK_IMPORTED_MODULE_1__["createElement"](_controls_parameters__WEBPACK_IMPORTED_MODULE_3__["ParameterControls"], { params: anim.getParams(), values: anim.state.params, onChange: this.updateParams, isDisabled: isDisabled }),
            react__WEBPACK_IMPORTED_MODULE_1__["createElement"](_controls_parameters__WEBPACK_IMPORTED_MODULE_3__["ParameterControls"], { params: anim.current.params, values: anim.current.paramValues, onChange: this.updateCurrentParams, isDisabled: isDisabled }),
            react__WEBPACK_IMPORTED_MODULE_1__["createElement"]("div", { className: 'msp-flex-row' },
                react__WEBPACK_IMPORTED_MODULE_1__["createElement"](_controls_common__WEBPACK_IMPORTED_MODULE_4__["Button"], { icon: anim.state.animationState !== 'playing' ? void 0 : _controls_icons__WEBPACK_IMPORTED_MODULE_5__["PlayArrowSvg"], onClick: this.startOrStop, disabled: canApply !== void 0 && canApply.canApply === false }, anim.state.animationState === 'playing' ? 'Stop' : canApply === void 0 || canApply.canApply ? 'Start' : canApply.reason || 'Start')));
    };
    return AnimationControls;
}(_base__WEBPACK_IMPORTED_MODULE_2__["PluginUIComponent"]));

//# sourceMappingURL=animation.js.map

/***/ }),

/***/ "./lib/mol-plugin-ui/state/apply-action.js":
/*!*************************************************!*\
  !*** ./lib/mol-plugin-ui/state/apply-action.js ***!
  \*************************************************/
/*! exports provided: ApplyActionControl */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ApplyActionControl", function() { return ApplyActionControl; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _mol_plugin_commands__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../mol-plugin/commands */ "./lib/mol-plugin/commands.js");
/* harmony import */ var _mol_util_memoize__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../mol-util/memoize */ "./lib/mol-util/memoize.js");
/* harmony import */ var _common__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./common */ "./lib/mol-plugin-ui/state/common.js");
/* harmony import */ var _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../mol-util/param-definition */ "./lib/mol-util/param-definition.js");
/**
 * Copyright (c) 2018 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author David Sehnal <david.sehnal@gmail.com>
 */






var ApplyActionControl = /** @class */ (function (_super) {
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__extends"])(ApplyActionControl, _super);
    function ApplyActionControl() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this._getInfo = Object(_mol_util_memoize__WEBPACK_IMPORTED_MODULE_2__["memoizeLatest"])(function (t, v) { return _common__WEBPACK_IMPORTED_MODULE_3__["StateTransformParameters"].infoFromAction(_this.plugin, _this.props.state, _this.props.action, _this.props.nodeRef); });
        _this.state = { plugin: _this.plugin, ref: _this.props.nodeRef, version: _this.props.state.transforms.get(_this.props.nodeRef).version, error: void 0, isInitial: true, params: _this.getInfo().initialValues, busy: false, isCollapsed: _this.props.initiallyCollapsed };
        return _this;
    }
    ApplyActionControl.prototype.applyAction = function () {
        return _mol_plugin_commands__WEBPACK_IMPORTED_MODULE_1__["PluginCommands"].State.ApplyAction(this.plugin, {
            state: this.props.state,
            action: this.props.action.create(this.state.params),
            ref: this.props.nodeRef
        });
    };
    ApplyActionControl.prototype.getInfo = function () { return this._getInfo(this.props.nodeRef, this.props.state.transforms.get(this.props.nodeRef).version); };
    ApplyActionControl.prototype.getTransformerId = function () { return this.props.state.transforms.get(this.props.nodeRef).transformer.id; };
    ApplyActionControl.prototype.getHeader = function () { return this.props.hideHeader ? 'none' : this.props.action.definition.display; };
    ApplyActionControl.prototype.canApply = function () { return !this.state.error && !this.state.busy; };
    ApplyActionControl.prototype.canAutoApply = function () { return false; };
    ApplyActionControl.prototype.applyText = function () { return 'Apply'; };
    ApplyActionControl.prototype.isUpdate = function () { return false; };
    ApplyActionControl.prototype.getSourceAndTarget = function () { return { a: this.props.state.cells.get(this.props.nodeRef).obj }; };
    ApplyActionControl.getDerivedStateFromProps = function (props, state) {
        var version = props.state.transforms.get(props.nodeRef).version;
        if (props.nodeRef === state.ref && version === state.version) {
            return null;
        }
        var source = props.state.cells.get(props.nodeRef).obj;
        var params = props.action.definition.params
            ? _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_4__["ParamDefinition"].getDefaultValues(props.action.definition.params(source, state.plugin))
            : {};
        var newState = {
            plugin: state.plugin,
            ref: props.nodeRef,
            version: version,
            params: params,
            isInitial: true,
            error: void 0
        };
        return newState;
    };
    return ApplyActionControl;
}(_common__WEBPACK_IMPORTED_MODULE_3__["TransformControlBase"]));
//# sourceMappingURL=apply-action.js.map

/***/ }),

/***/ "./lib/mol-plugin-ui/state/common.js":
/*!*******************************************!*\
  !*** ./lib/mol-plugin-ui/state/common.js ***!
  \*******************************************/
/*! exports provided: StateTransformParameters, TransformControlBase */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "StateTransformParameters", function() { return StateTransformParameters; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "TransformControlBase", function() { return TransformControlBase; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! react */ "./node_modules/react/index.js");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _base__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../base */ "./lib/mol-plugin-ui/base.js");
/* harmony import */ var _controls_parameters__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../controls/parameters */ "./lib/mol-plugin-ui/controls/parameters.js");
/* harmony import */ var _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../mol-util/param-definition */ "./lib/mol-util/param-definition.js");
/* harmony import */ var rxjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! rxjs */ "./node_modules/rxjs/_esm5/index.js");
/* harmony import */ var _controls_icons__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../controls/icons */ "./lib/mol-plugin-ui/controls/icons.js");
/* harmony import */ var _controls_common__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../controls/common */ "./lib/mol-plugin-ui/controls/common.js");
/**
 * Copyright (c) 2018 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author David Sehnal <david.sehnal@gmail.com>
 */









var StateTransformParameters = /** @class */ (function (_super) {
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__extends"])(StateTransformParameters, _super);
    function StateTransformParameters() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.onChange = function (_a) {
            var _b;
            var name = _a.name, value = _a.value;
            var params = Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, _this.props.params), (_b = {}, _b[name] = value, _b));
            _this.props.events.onChange(params, _this.areInitial(params), _this.validate(params));
        };
        return _this;
    }
    StateTransformParameters.prototype.validate = function (params) {
        // TODO
        return void 0;
    };
    StateTransformParameters.prototype.areInitial = function (params) {
        return _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_4__["ParamDefinition"].areEqual(this.props.info.params, params, this.props.info.initialValues);
    };
    StateTransformParameters.prototype.render = function () {
        return react__WEBPACK_IMPORTED_MODULE_1__["createElement"](_controls_parameters__WEBPACK_IMPORTED_MODULE_3__["ParameterControls"], { params: this.props.info.params, values: this.props.params, onChange: this.onChange, onEnter: this.props.events.onEnter, isDisabled: this.props.isDisabled });
    };
    return StateTransformParameters;
}(_base__WEBPACK_IMPORTED_MODULE_2__["PurePluginUIComponent"]));
(function (StateTransformParameters) {
    function areParamsEmpty(params) {
        var keys = Object.keys(params);
        for (var _i = 0, keys_1 = keys; _i < keys_1.length; _i++) {
            var k = keys_1[_i];
            if (!params[k].isHidden)
                return false;
        }
        return true;
    }
    function infoFromAction(plugin, state, action, nodeRef) {
        var source = state.cells.get(nodeRef).obj;
        var params = action.definition.params ? action.definition.params(source, plugin) : {};
        var initialValues = _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_4__["ParamDefinition"].getDefaultValues(params);
        return {
            initialValues: initialValues,
            params: params,
            isEmpty: areParamsEmpty(params)
        };
    }
    StateTransformParameters.infoFromAction = infoFromAction;
    function infoFromTransform(plugin, state, transform) {
        var cell = state.cells.get(transform.ref);
        // const source: StateObjectCell | undefined = (cell.sourceRef && state.cells.get(cell.sourceRef)!) || void 0;
        // const create = transform.transformer.definition.params;
        // const params = create ? create((source && source.obj) as any, plugin) : { };
        var params = (cell.params && cell.params.definition) || {};
        var initialValues = (cell.params && cell.params.values) || {};
        return {
            initialValues: initialValues,
            params: params,
            isEmpty: areParamsEmpty(params)
        };
    }
    StateTransformParameters.infoFromTransform = infoFromTransform;
})(StateTransformParameters || (StateTransformParameters = {}));
var TransformControlBase = /** @class */ (function (_super) {
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__extends"])(TransformControlBase, _super);
    function TransformControlBase() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.busy = new rxjs__WEBPACK_IMPORTED_MODULE_5__["Subject"]();
        _this.onEnter = function () {
            if (_this.state.error)
                return;
            _this.apply();
        };
        _this.autoApplyHandle = void 0;
        _this.events = {
            onEnter: _this.onEnter,
            onChange: function (params, isInitial, errors) {
                _this.clearAutoApply();
                _this.setState({ params: params, isInitial: isInitial, error: errors && errors[0] }, function () {
                    if (!isInitial && !_this.state.error && _this.canAutoApply(params)) {
                        _this.clearAutoApply();
                        _this.autoApplyHandle = setTimeout(_this.apply, 50);
                    }
                });
            }
        };
        _this.apply = function () { return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"])(_this, void 0, void 0, function () {
            var _a;
            var _b, _c;
            return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__generator"])(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        this.clearAutoApply();
                        this.setState({ busy: true });
                        _d.label = 1;
                    case 1:
                        _d.trys.push([1, 3, 4, 5]);
                        return [4 /*yield*/, this.applyAction()];
                    case 2:
                        _d.sent();
                        return [3 /*break*/, 5];
                    case 3:
                        _a = _d.sent();
                        return [3 /*break*/, 5];
                    case 4:
                        (_c = (_b = this.props).onApply) === null || _c === void 0 ? void 0 : _c.call(_b);
                        this.busy.next(false);
                        return [7 /*endfinally*/];
                    case 5: return [2 /*return*/];
                }
            });
        }); };
        _this.refresh = function () {
            _this.setState({ params: _this.getInfo().initialValues, isInitial: true, error: void 0 });
        };
        _this.setDefault = function () {
            var info = _this.getInfo();
            var params = _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_4__["ParamDefinition"].getDefaultValues(info.params);
            _this.setState({ params: params, isInitial: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_4__["ParamDefinition"].areEqual(info.params, params, info.initialValues), error: void 0 });
        };
        _this.toggleExpanded = function () {
            _this.setState({ isCollapsed: !_this.state.isCollapsed });
        };
        return _this;
    }
    TransformControlBase.prototype.clearAutoApply = function () {
        if (this.autoApplyHandle !== void 0) {
            clearTimeout(this.autoApplyHandle);
            this.autoApplyHandle = void 0;
        }
    };
    TransformControlBase.prototype.componentDidMount = function () {
        var _this = this;
        this.subscribe(this.plugin.behaviors.state.isBusy, function (b) {
            if (_this.state.busy !== b)
                _this.busy.next(b);
        });
        this.subscribe(this.busy, function (busy) {
            if (_this.state.busy !== busy)
                _this.setState({ busy: busy });
        });
    };
    TransformControlBase.prototype.renderApply = function () {
        var canApply = this.canApply();
        if (this.props.autoHideApply && (!canApply || this.canAutoApply(this.state.params)))
            return null;
        return react__WEBPACK_IMPORTED_MODULE_1__["createElement"]("div", { className: 'msp-transform-apply-wrap' },
            react__WEBPACK_IMPORTED_MODULE_1__["createElement"](_controls_common__WEBPACK_IMPORTED_MODULE_7__["IconButton"], { svg: _controls_icons__WEBPACK_IMPORTED_MODULE_6__["RefreshSvg"], className: 'msp-transform-default-params', onClick: this.setDefault, disabled: this.state.busy, title: 'Set default params' }),
            react__WEBPACK_IMPORTED_MODULE_1__["createElement"]("div", { className: "msp-transform-apply-wider" },
                react__WEBPACK_IMPORTED_MODULE_1__["createElement"](_controls_common__WEBPACK_IMPORTED_MODULE_7__["Button"], { icon: canApply ? _controls_icons__WEBPACK_IMPORTED_MODULE_6__["CheckSvg"] : void 0, className: "msp-btn-commit msp-btn-commit-" + (canApply ? 'on' : 'off'), onClick: this.apply, disabled: !canApply }, this.props.applyLabel || this.applyText())));
    };
    TransformControlBase.prototype.renderDefault = function () {
        var info = this.getInfo();
        var isEmpty = info.isEmpty && this.isUpdate();
        var display = this.getHeader();
        var tId = this.getTransformerId();
        var ParamEditor = this.plugin.customParamEditors.has(tId)
            ? this.plugin.customParamEditors.get(tId)
            : StateTransformParameters;
        var wrapClass = this.state.isCollapsed
            ? 'msp-transform-wrapper msp-transform-wrapper-collapsed'
            : 'msp-transform-wrapper';
        var params = null;
        if (!isEmpty && !this.state.isCollapsed) {
            var _a = this.getSourceAndTarget(), a = _a.a, b = _a.b, bCell = _a.bCell;
            var applyControl = this.renderApply();
            params = react__WEBPACK_IMPORTED_MODULE_1__["createElement"](react__WEBPACK_IMPORTED_MODULE_1__["Fragment"], null,
                react__WEBPACK_IMPORTED_MODULE_1__["createElement"](ParamEditor, { info: info, a: a, b: b, bCell: bCell, events: this.events, params: this.state.params, isDisabled: this.state.busy }),
                applyControl);
        }
        var ctrl = react__WEBPACK_IMPORTED_MODULE_1__["createElement"]("div", { className: wrapClass, style: { marginBottom: this.props.noMargin ? 0 : void 0 } },
            display !== 'none' && !this.props.wrapInExpander && react__WEBPACK_IMPORTED_MODULE_1__["createElement"]("div", { className: 'msp-transform-header' },
                react__WEBPACK_IMPORTED_MODULE_1__["createElement"](_controls_common__WEBPACK_IMPORTED_MODULE_7__["Button"], { onClick: this.toggleExpanded, title: display.description },
                    !isEmpty && react__WEBPACK_IMPORTED_MODULE_1__["createElement"](_controls_icons__WEBPACK_IMPORTED_MODULE_6__["Icon"], { svg: this.state.isCollapsed ? _controls_icons__WEBPACK_IMPORTED_MODULE_6__["ArrowRightSvg"] : _controls_icons__WEBPACK_IMPORTED_MODULE_6__["ArrowDropDownSvg"] }),
                    display.name)),
            params);
        if (isEmpty || !this.props.wrapInExpander)
            return ctrl;
        return react__WEBPACK_IMPORTED_MODULE_1__["createElement"](_controls_common__WEBPACK_IMPORTED_MODULE_7__["ExpandGroup"], { header: this.isUpdate() ? "Update " + (display === 'none' ? '' : display.name) : "Apply " + (display === 'none' ? '' : display.name), headerLeftMargin: this.props.expanderHeaderLeftMargin }, ctrl);
    };
    TransformControlBase.prototype.renderSimple = function () {
        var _a, _b, _c;
        var info = this.getInfo();
        var canApply = this.canApply();
        var apply = react__WEBPACK_IMPORTED_MODULE_1__["createElement"]("div", { className: 'msp-flex-row' },
            react__WEBPACK_IMPORTED_MODULE_1__["createElement"](_controls_common__WEBPACK_IMPORTED_MODULE_7__["Button"], { icon: (_a = this.props.simpleApply) === null || _a === void 0 ? void 0 : _a.icon, title: (_b = this.props.simpleApply) === null || _b === void 0 ? void 0 : _b.title, disabled: this.state.busy || !canApply, onClick: this.apply, className: 'msp-btn-apply-simple' }, (_c = this.props.simpleApply) === null || _c === void 0 ? void 0 : _c.header),
            !info.isEmpty && react__WEBPACK_IMPORTED_MODULE_1__["createElement"](_controls_common__WEBPACK_IMPORTED_MODULE_7__["ToggleButton"], { icon: _controls_icons__WEBPACK_IMPORTED_MODULE_6__["TuneSvg"], label: '', title: 'Options', toggle: this.toggleExpanded, isSelected: !this.state.isCollapsed, disabled: this.state.busy, style: { flex: '0 0 40px', padding: 0 } }));
        if (this.state.isCollapsed)
            return apply;
        var tId = this.getTransformerId();
        var ParamEditor = this.plugin.customParamEditors.has(tId)
            ? this.plugin.customParamEditors.get(tId)
            : StateTransformParameters;
        var _d = this.getSourceAndTarget(), a = _d.a, b = _d.b, bCell = _d.bCell;
        return react__WEBPACK_IMPORTED_MODULE_1__["createElement"](react__WEBPACK_IMPORTED_MODULE_1__["Fragment"], null,
            apply,
            react__WEBPACK_IMPORTED_MODULE_1__["createElement"](ParamEditor, { info: info, a: a, b: b, bCell: bCell, events: this.events, params: this.state.params, isDisabled: this.state.busy }));
    };
    TransformControlBase.prototype.render = function () {
        // console.log('rendering', ((this.props as any)?.transform?.transformer || (this.props as any)?.action)?.definition.display.name, +new Date)
        return this.props.simpleApply ? this.renderSimple() : this.renderDefault();
    };
    return TransformControlBase;
}(_base__WEBPACK_IMPORTED_MODULE_2__["PurePluginUIComponent"]));
//# sourceMappingURL=common.js.map

/***/ }),

/***/ "./lib/mol-plugin-ui/state/snapshots.js":
/*!**********************************************!*\
  !*** ./lib/mol-plugin-ui/state/snapshots.js ***!
  \**********************************************/
/*! exports provided: StateSnapshots, StateExportImportControls, LocalStateSnapshotParams, LocalStateSnapshots, LocalStateSnapshotList, RemoteStateSnapshots */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "StateSnapshots", function() { return StateSnapshots; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "StateExportImportControls", function() { return StateExportImportControls; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "LocalStateSnapshotParams", function() { return LocalStateSnapshotParams; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "LocalStateSnapshots", function() { return LocalStateSnapshots; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "LocalStateSnapshotList", function() { return LocalStateSnapshotList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "RemoteStateSnapshots", function() { return RemoteStateSnapshots; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var immutable__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! immutable */ "./node_modules/immutable/dist/immutable.js");
/* harmony import */ var immutable__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(immutable__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! react */ "./node_modules/react/index.js");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _mol_plugin_commands__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../mol-plugin/commands */ "./lib/mol-plugin/commands.js");
/* harmony import */ var _mol_plugin_config__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../mol-plugin/config */ "./lib/mol-plugin/config.js");
/* harmony import */ var _mol_plugin_state__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../mol-plugin/state */ "./lib/mol-plugin/state.js");
/* harmony import */ var _mol_util__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../../mol-util */ "./lib/mol-util/index.js");
/* harmony import */ var _mol_util_now__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../../mol-util/now */ "./lib/mol-util/now.js");
/* harmony import */ var _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ../../mol-util/param-definition */ "./lib/mol-util/param-definition.js");
/* harmony import */ var _mol_util_url__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ../../mol-util/url */ "./lib/mol-util/url.js");
/* harmony import */ var _base__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ../base */ "./lib/mol-plugin-ui/base.js");
/* harmony import */ var _controls_common__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ../controls/common */ "./lib/mol-plugin-ui/controls/common.js");
/* harmony import */ var _controls_icons__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! ../controls/icons */ "./lib/mol-plugin-ui/controls/icons.js");
/* harmony import */ var _controls_parameters__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! ../controls/parameters */ "./lib/mol-plugin-ui/controls/parameters.js");
/**
 * Copyright (c) 2018 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author David Sehnal <david.sehnal@gmail.com>
 */














var StateSnapshots = /** @class */ (function (_super) {
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__extends"])(StateSnapshots, _super);
    function StateSnapshots() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    StateSnapshots.prototype.render = function () {
        var _a;
        return react__WEBPACK_IMPORTED_MODULE_2__["createElement"]("div", null,
            react__WEBPACK_IMPORTED_MODULE_2__["createElement"](_controls_common__WEBPACK_IMPORTED_MODULE_11__["SectionHeader"], { icon: _controls_icons__WEBPACK_IMPORTED_MODULE_12__["SaveOutlinedSvg"], title: 'Plugin State' }),
            react__WEBPACK_IMPORTED_MODULE_2__["createElement"]("div", { style: { marginBottom: '10px' } },
                react__WEBPACK_IMPORTED_MODULE_2__["createElement"](_controls_common__WEBPACK_IMPORTED_MODULE_11__["ExpandGroup"], { header: 'Save Options', initiallyExpanded: false },
                    react__WEBPACK_IMPORTED_MODULE_2__["createElement"](LocalStateSnapshotParams, null))),
            react__WEBPACK_IMPORTED_MODULE_2__["createElement"](LocalStateSnapshots, null),
            react__WEBPACK_IMPORTED_MODULE_2__["createElement"](LocalStateSnapshotList, null),
            react__WEBPACK_IMPORTED_MODULE_2__["createElement"](_controls_common__WEBPACK_IMPORTED_MODULE_11__["SectionHeader"], { title: 'Save as File', accent: 'blue' }),
            react__WEBPACK_IMPORTED_MODULE_2__["createElement"](StateExportImportControls, null),
            ((_a = this.plugin.spec.components) === null || _a === void 0 ? void 0 : _a.remoteState) !== 'none' && react__WEBPACK_IMPORTED_MODULE_2__["createElement"](RemoteStateSnapshots, null));
    };
    return StateSnapshots;
}(_base__WEBPACK_IMPORTED_MODULE_10__["PluginUIComponent"]));

var StateExportImportControls = /** @class */ (function (_super) {
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__extends"])(StateExportImportControls, _super);
    function StateExportImportControls() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.downloadToFileJson = function () {
            var _a, _b;
            (_b = (_a = _this.props).onAction) === null || _b === void 0 ? void 0 : _b.call(_a);
            _mol_plugin_commands__WEBPACK_IMPORTED_MODULE_3__["PluginCommands"].State.Snapshots.DownloadToFile(_this.plugin, { type: 'json' });
        };
        _this.downloadToFileZip = function () {
            var _a, _b;
            (_b = (_a = _this.props).onAction) === null || _b === void 0 ? void 0 : _b.call(_a);
            _mol_plugin_commands__WEBPACK_IMPORTED_MODULE_3__["PluginCommands"].State.Snapshots.DownloadToFile(_this.plugin, { type: 'zip' });
        };
        _this.open = function (e) {
            var _a, _b;
            if (!e.target.files || !e.target.files[0]) {
                _this.plugin.log.error('No state file selected');
                return;
            }
            (_b = (_a = _this.props).onAction) === null || _b === void 0 ? void 0 : _b.call(_a);
            _mol_plugin_commands__WEBPACK_IMPORTED_MODULE_3__["PluginCommands"].State.Snapshots.OpenFile(_this.plugin, { file: e.target.files[0] });
        };
        return _this;
    }
    StateExportImportControls.prototype.render = function () {
        return react__WEBPACK_IMPORTED_MODULE_2__["createElement"](react__WEBPACK_IMPORTED_MODULE_2__["Fragment"], null,
            react__WEBPACK_IMPORTED_MODULE_2__["createElement"]("div", { className: 'msp-flex-row' },
                react__WEBPACK_IMPORTED_MODULE_2__["createElement"](_controls_common__WEBPACK_IMPORTED_MODULE_11__["Button"], { icon: _controls_icons__WEBPACK_IMPORTED_MODULE_12__["GetAppSvg"], onClick: this.downloadToFileJson, title: 'Save the state description. Input data are loaded using the provided sources. Does not work if local files are used as input.' }, "State"),
                react__WEBPACK_IMPORTED_MODULE_2__["createElement"](_controls_common__WEBPACK_IMPORTED_MODULE_11__["Button"], { icon: _controls_icons__WEBPACK_IMPORTED_MODULE_12__["GetAppSvg"], onClick: this.downloadToFileZip, title: 'Save the state including the input data.' }, "Session"),
                react__WEBPACK_IMPORTED_MODULE_2__["createElement"]("div", { className: 'msp-btn msp-btn-block msp-btn-action msp-loader-msp-btn-file' },
                    react__WEBPACK_IMPORTED_MODULE_2__["createElement"](_controls_icons__WEBPACK_IMPORTED_MODULE_12__["Icon"], { svg: _controls_icons__WEBPACK_IMPORTED_MODULE_12__["OpenInBrowserSvg"], inline: true }),
                    " Open ",
                    react__WEBPACK_IMPORTED_MODULE_2__["createElement"]("input", { onChange: this.open, type: 'file', multiple: false, accept: '.molx,.molj' }))),
            react__WEBPACK_IMPORTED_MODULE_2__["createElement"]("div", { className: 'msp-help-text', style: { padding: '10px' } },
                react__WEBPACK_IMPORTED_MODULE_2__["createElement"](_controls_icons__WEBPACK_IMPORTED_MODULE_12__["Icon"], { svg: _controls_icons__WEBPACK_IMPORTED_MODULE_12__["WarningSvg"] }),
                " This is an experimental feature and stored states/sessions might not be openable in a future version."));
    };
    return StateExportImportControls;
}(_base__WEBPACK_IMPORTED_MODULE_10__["PluginUIComponent"]));

var LocalStateSnapshotParams = /** @class */ (function (_super) {
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__extends"])(LocalStateSnapshotParams, _super);
    function LocalStateSnapshotParams() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    LocalStateSnapshotParams.prototype.componentDidMount = function () {
        var _this = this;
        this.subscribe(this.plugin.state.snapshotParams, function () { return _this.forceUpdate(); });
    };
    LocalStateSnapshotParams.prototype.render = function () {
        return react__WEBPACK_IMPORTED_MODULE_2__["createElement"](_controls_parameters__WEBPACK_IMPORTED_MODULE_13__["ParameterControls"], { params: _mol_plugin_state__WEBPACK_IMPORTED_MODULE_5__["PluginState"].SnapshotParams, values: this.plugin.state.snapshotParams.value, onChangeValues: this.plugin.state.setSnapshotParams });
    };
    return LocalStateSnapshotParams;
}(_base__WEBPACK_IMPORTED_MODULE_10__["PluginUIComponent"]));

var LocalStateSnapshots = /** @class */ (function (_super) {
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__extends"])(LocalStateSnapshots, _super);
    function LocalStateSnapshots() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = { params: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_8__["ParamDefinition"].getDefaultValues(LocalStateSnapshots.Params) };
        _this.add = function () {
            _mol_plugin_commands__WEBPACK_IMPORTED_MODULE_3__["PluginCommands"].State.Snapshots.Add(_this.plugin, {
                name: _this.state.params.name,
                description: _this.state.params.description
            });
        };
        _this.updateParams = function (params) { return _this.setState({ params: params }); };
        _this.clear = function () {
            _mol_plugin_commands__WEBPACK_IMPORTED_MODULE_3__["PluginCommands"].State.Snapshots.Clear(_this.plugin, {});
        };
        return _this;
    }
    LocalStateSnapshots.prototype.shouldComponentUpdate = function (nextProps, nextState) {
        return !Object(_mol_util__WEBPACK_IMPORTED_MODULE_6__["shallowEqualObjects"])(this.props, nextProps) || !Object(_mol_util__WEBPACK_IMPORTED_MODULE_6__["shallowEqualObjects"])(this.state, nextState);
    };
    LocalStateSnapshots.prototype.render = function () {
        return react__WEBPACK_IMPORTED_MODULE_2__["createElement"]("div", null,
            react__WEBPACK_IMPORTED_MODULE_2__["createElement"](_controls_parameters__WEBPACK_IMPORTED_MODULE_13__["ParameterControls"], { params: LocalStateSnapshots.Params, values: this.state.params, onEnter: this.add, onChangeValues: this.updateParams }),
            react__WEBPACK_IMPORTED_MODULE_2__["createElement"]("div", { className: 'msp-flex-row' },
                react__WEBPACK_IMPORTED_MODULE_2__["createElement"](_controls_common__WEBPACK_IMPORTED_MODULE_11__["IconButton"], { onClick: this.clear, svg: _controls_icons__WEBPACK_IMPORTED_MODULE_12__["DeleteOutlinedSvg"], title: 'Remove All' }),
                react__WEBPACK_IMPORTED_MODULE_2__["createElement"](_controls_common__WEBPACK_IMPORTED_MODULE_11__["Button"], { onClick: this.add, icon: _controls_icons__WEBPACK_IMPORTED_MODULE_12__["AddSvg"], style: { textAlign: 'right' }, commit: true }, "Add")));
    };
    LocalStateSnapshots.Params = {
        name: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_8__["ParamDefinition"].Text(),
        description: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_8__["ParamDefinition"].Text()
    };
    return LocalStateSnapshots;
}(_base__WEBPACK_IMPORTED_MODULE_10__["PluginUIComponent"]));

var LocalStateSnapshotList = /** @class */ (function (_super) {
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__extends"])(LocalStateSnapshotList, _super);
    function LocalStateSnapshotList() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.apply = function (e) {
            var id = e.currentTarget.getAttribute('data-id');
            if (!id)
                return;
            _mol_plugin_commands__WEBPACK_IMPORTED_MODULE_3__["PluginCommands"].State.Snapshots.Apply(_this.plugin, { id: id });
        };
        _this.remove = function (e) {
            var id = e.currentTarget.getAttribute('data-id');
            if (!id)
                return;
            _mol_plugin_commands__WEBPACK_IMPORTED_MODULE_3__["PluginCommands"].State.Snapshots.Remove(_this.plugin, { id: id });
        };
        _this.moveUp = function (e) {
            var id = e.currentTarget.getAttribute('data-id');
            if (!id)
                return;
            _mol_plugin_commands__WEBPACK_IMPORTED_MODULE_3__["PluginCommands"].State.Snapshots.Move(_this.plugin, { id: id, dir: -1 });
        };
        _this.moveDown = function (e) {
            var id = e.currentTarget.getAttribute('data-id');
            if (!id)
                return;
            _mol_plugin_commands__WEBPACK_IMPORTED_MODULE_3__["PluginCommands"].State.Snapshots.Move(_this.plugin, { id: id, dir: 1 });
        };
        _this.replace = function (e) {
            var id = e.currentTarget.getAttribute('data-id');
            if (!id)
                return;
            _mol_plugin_commands__WEBPACK_IMPORTED_MODULE_3__["PluginCommands"].State.Snapshots.Replace(_this.plugin, { id: id });
        };
        return _this;
    }
    LocalStateSnapshotList.prototype.componentDidMount = function () {
        var _this = this;
        this.subscribe(this.plugin.managers.snapshot.events.changed, function () { return _this.forceUpdate(); });
    };
    LocalStateSnapshotList.prototype.render = function () {
        var _this = this;
        var current = this.plugin.managers.snapshot.state.current;
        return react__WEBPACK_IMPORTED_MODULE_2__["createElement"]("ul", { style: { listStyle: 'none', marginTop: '10px' }, className: 'msp-state-list' }, this.plugin.managers.snapshot.state.entries.map(function (e) { return react__WEBPACK_IMPORTED_MODULE_2__["createElement"]("li", { key: e.snapshot.id, className: 'msp-flex-row' },
            react__WEBPACK_IMPORTED_MODULE_2__["createElement"](_controls_common__WEBPACK_IMPORTED_MODULE_11__["Button"], { "data-id": e.snapshot.id, onClick: _this.apply, className: 'msp-no-overflow' },
                react__WEBPACK_IMPORTED_MODULE_2__["createElement"]("span", { style: { fontWeight: e.snapshot.id === current ? 'bold' : void 0 } }, e.name || new Date(e.timestamp).toLocaleString()),
                " ",
                react__WEBPACK_IMPORTED_MODULE_2__["createElement"]("small", null, "" + (e.snapshot.durationInMs ? Object(_mol_util_now__WEBPACK_IMPORTED_MODULE_7__["formatTimespan"])(e.snapshot.durationInMs, false) + ("" + (e.description ? ', ' : '')) : '') + (e.description ? e.description : ''))),
            react__WEBPACK_IMPORTED_MODULE_2__["createElement"](_controls_common__WEBPACK_IMPORTED_MODULE_11__["IconButton"], { svg: _controls_icons__WEBPACK_IMPORTED_MODULE_12__["ArrowUpwardSvg"], "data-id": e.snapshot.id, title: 'Move Up', onClick: _this.moveUp, flex: '20px' }),
            react__WEBPACK_IMPORTED_MODULE_2__["createElement"](_controls_common__WEBPACK_IMPORTED_MODULE_11__["IconButton"], { svg: _controls_icons__WEBPACK_IMPORTED_MODULE_12__["ArrowDownwardSvg"], "data-id": e.snapshot.id, title: 'Move Down', onClick: _this.moveDown, flex: '20px' }),
            react__WEBPACK_IMPORTED_MODULE_2__["createElement"](_controls_common__WEBPACK_IMPORTED_MODULE_11__["IconButton"], { svg: _controls_icons__WEBPACK_IMPORTED_MODULE_12__["SwapHorizSvg"], "data-id": e.snapshot.id, title: 'Replace', onClick: _this.replace, flex: '20px' }),
            react__WEBPACK_IMPORTED_MODULE_2__["createElement"](_controls_common__WEBPACK_IMPORTED_MODULE_11__["IconButton"], { svg: _controls_icons__WEBPACK_IMPORTED_MODULE_12__["DeleteOutlinedSvg"], "data-id": e.snapshot.id, title: 'Remove', onClick: _this.remove, flex: '20px' })); }));
    };
    return LocalStateSnapshotList;
}(_base__WEBPACK_IMPORTED_MODULE_10__["PluginUIComponent"]));

var RemoteStateSnapshots = /** @class */ (function (_super) {
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__extends"])(RemoteStateSnapshots, _super);
    function RemoteStateSnapshots() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.Params = {
            name: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_8__["ParamDefinition"].Text(),
            options: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_8__["ParamDefinition"].Group({
                description: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_8__["ParamDefinition"].Text(),
                playOnLoad: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_8__["ParamDefinition"].Boolean(false),
                serverUrl: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_8__["ParamDefinition"].Text(_this.plugin.config.get(_mol_plugin_config__WEBPACK_IMPORTED_MODULE_4__["PluginConfig"].State.CurrentServer))
            })
        };
        _this.state = { params: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_8__["ParamDefinition"].getDefaultValues(_this.Params), entries: Object(immutable__WEBPACK_IMPORTED_MODULE_1__["OrderedMap"])(), isBusy: false };
        _this.ListOnlyParams = {
            options: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_8__["ParamDefinition"].Group({
                serverUrl: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_8__["ParamDefinition"].Text(_this.plugin.config.get(_mol_plugin_config__WEBPACK_IMPORTED_MODULE_4__["PluginConfig"].State.CurrentServer))
            }, { isFlat: true })
        };
        _this._mounted = false;
        _this.refresh = function () { return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"])(_this, void 0, void 0, function () {
            var json, entries, _i, json_1, e, e_1;
            return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__generator"])(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        this.setState({ isBusy: true });
                        this.plugin.config.set(_mol_plugin_config__WEBPACK_IMPORTED_MODULE_4__["PluginConfig"].State.CurrentServer, this.state.params.options.serverUrl);
                        return [4 /*yield*/, this.plugin.runTask(this.plugin.fetch({ url: this.serverUrl('list'), type: 'json' }))];
                    case 1:
                        json = (_a.sent()) || [];
                        json.sort(function (a, b) {
                            if (a.isSticky === b.isSticky)
                                return a.timestamp - b.timestamp;
                            return a.isSticky ? -1 : 1;
                        });
                        entries = Object(immutable__WEBPACK_IMPORTED_MODULE_1__["OrderedMap"])().asMutable();
                        for (_i = 0, json_1 = json; _i < json_1.length; _i++) {
                            e = json_1[_i];
                            entries.set(e.id, Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, e), { url: this.serverUrl("get/" + e.id), removeUrl: this.serverUrl("remove/" + e.id) }));
                        }
                        if (this._mounted)
                            this.setState({ entries: entries.asImmutable(), isBusy: false });
                        return [3 /*break*/, 3];
                    case 2:
                        e_1 = _a.sent();
                        this.plugin.log.error('Fetching Remote Snapshots: ' + e_1);
                        if (this._mounted)
                            this.setState({ entries: Object(immutable__WEBPACK_IMPORTED_MODULE_1__["OrderedMap"])(), isBusy: false });
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        }); };
        _this.upload = function () { return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"])(_this, void 0, void 0, function () {
            return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__generator"])(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.setState({ isBusy: true });
                        this.plugin.config.set(_mol_plugin_config__WEBPACK_IMPORTED_MODULE_4__["PluginConfig"].State.CurrentServer, this.state.params.options.serverUrl);
                        return [4 /*yield*/, _mol_plugin_commands__WEBPACK_IMPORTED_MODULE_3__["PluginCommands"].State.Snapshots.Upload(this.plugin, {
                                name: this.state.params.name,
                                description: this.state.params.options.description,
                                playOnLoad: this.state.params.options.playOnLoad,
                                serverUrl: this.state.params.options.serverUrl
                            })];
                    case 1:
                        _a.sent();
                        this.plugin.log.message('Snapshot uploaded.');
                        if (this._mounted) {
                            this.setState({ isBusy: false });
                            this.refresh();
                        }
                        return [2 /*return*/];
                }
            });
        }); };
        _this.fetch = function (e) { return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"])(_this, void 0, void 0, function () {
            var id, entry;
            return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__generator"])(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        id = e.currentTarget.getAttribute('data-id');
                        if (!id)
                            return [2 /*return*/];
                        entry = this.state.entries.get(id);
                        if (!entry)
                            return [2 /*return*/];
                        this.setState({ isBusy: true });
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, , 3, 4]);
                        return [4 /*yield*/, _mol_plugin_commands__WEBPACK_IMPORTED_MODULE_3__["PluginCommands"].State.Snapshots.Fetch(this.plugin, { url: entry.url })];
                    case 2:
                        _a.sent();
                        return [3 /*break*/, 4];
                    case 3:
                        if (this._mounted)
                            this.setState({ isBusy: false });
                        return [7 /*endfinally*/];
                    case 4: return [2 /*return*/];
                }
            });
        }); };
        _this.remove = function (e) { return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"])(_this, void 0, void 0, function () {
            var id, entry, _a;
            return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__generator"])(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        id = e.currentTarget.getAttribute('data-id');
                        if (!id)
                            return [2 /*return*/];
                        entry = this.state.entries.get(id);
                        if (!entry)
                            return [2 /*return*/];
                        this.setState({ entries: this.state.entries.remove(id) });
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, fetch(entry.removeUrl)];
                    case 2:
                        _b.sent();
                        return [3 /*break*/, 4];
                    case 3:
                        _a = _b.sent();
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        }); };
        return _this;
    }
    RemoteStateSnapshots.prototype.componentDidMount = function () {
        this.refresh();
        // TODO: solve this by using "PluginComponent" with behaviors intead
        this._mounted = true;
        // this.subscribe(UploadedEvent, this.refresh);
    };
    RemoteStateSnapshots.prototype.componentWillUnmount = function () {
        this._mounted = false;
    };
    RemoteStateSnapshots.prototype.serverUrl = function (q) {
        if (!q)
            return this.state.params.options.serverUrl;
        return Object(_mol_util_url__WEBPACK_IMPORTED_MODULE_9__["urlCombine"])(this.state.params.options.serverUrl, q);
    };
    RemoteStateSnapshots.prototype.render = function () {
        var _this = this;
        return react__WEBPACK_IMPORTED_MODULE_2__["createElement"](react__WEBPACK_IMPORTED_MODULE_2__["Fragment"], null,
            react__WEBPACK_IMPORTED_MODULE_2__["createElement"](_controls_common__WEBPACK_IMPORTED_MODULE_11__["SectionHeader"], { title: 'Remote States', accent: 'blue' }),
            !this.props.listOnly && react__WEBPACK_IMPORTED_MODULE_2__["createElement"](react__WEBPACK_IMPORTED_MODULE_2__["Fragment"], null,
                react__WEBPACK_IMPORTED_MODULE_2__["createElement"](_controls_parameters__WEBPACK_IMPORTED_MODULE_13__["ParameterControls"], { params: this.Params, values: this.state.params, onEnter: this.upload, onChange: function (p) {
                        var _a;
                        _this.setState({ params: Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, _this.state.params), (_a = {}, _a[p.name] = p.value, _a)) });
                    }, isDisabled: this.state.isBusy }),
                react__WEBPACK_IMPORTED_MODULE_2__["createElement"]("div", { className: 'msp-flex-row' },
                    react__WEBPACK_IMPORTED_MODULE_2__["createElement"](_controls_common__WEBPACK_IMPORTED_MODULE_11__["IconButton"], { onClick: this.refresh, disabled: this.state.isBusy, svg: _controls_icons__WEBPACK_IMPORTED_MODULE_12__["RefreshSvg"] }),
                    react__WEBPACK_IMPORTED_MODULE_2__["createElement"](_controls_common__WEBPACK_IMPORTED_MODULE_11__["Button"], { icon: _controls_icons__WEBPACK_IMPORTED_MODULE_12__["CloudUploadSvg"], onClick: this.upload, disabled: this.state.isBusy, commit: true }, "Upload"))),
            react__WEBPACK_IMPORTED_MODULE_2__["createElement"](RemoteStateSnapshotList, { entries: this.state.entries, isBusy: this.state.isBusy, serverUrl: this.state.params.options.serverUrl, fetch: this.fetch, remove: this.props.listOnly ? void 0 : this.remove }),
            this.props.listOnly && react__WEBPACK_IMPORTED_MODULE_2__["createElement"]("div", { style: { marginTop: '10px' } },
                react__WEBPACK_IMPORTED_MODULE_2__["createElement"](_controls_parameters__WEBPACK_IMPORTED_MODULE_13__["ParameterControls"], { params: this.ListOnlyParams, values: this.state.params, onEnter: this.upload, onChange: function (p) {
                        var _a;
                        _this.setState({ params: Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, _this.state.params), (_a = {}, _a[p.name] = p.value, _a)) });
                    }, isDisabled: this.state.isBusy }),
                react__WEBPACK_IMPORTED_MODULE_2__["createElement"]("div", { className: 'msp-flex-row' },
                    react__WEBPACK_IMPORTED_MODULE_2__["createElement"](_controls_common__WEBPACK_IMPORTED_MODULE_11__["Button"], { onClick: this.refresh, disabled: this.state.isBusy, icon: _controls_icons__WEBPACK_IMPORTED_MODULE_12__["RefreshSvg"] }, "Refresh"))));
    };
    return RemoteStateSnapshots;
}(_base__WEBPACK_IMPORTED_MODULE_10__["PluginUIComponent"]));

var RemoteStateSnapshotList = /** @class */ (function (_super) {
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__extends"])(RemoteStateSnapshotList, _super);
    function RemoteStateSnapshotList() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.open = function (e) { return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"])(_this, void 0, void 0, function () {
            var id, entry, url, qi;
            return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__generator"])(this, function (_a) {
                id = e.currentTarget.getAttribute('data-id');
                if (!id)
                    return [2 /*return*/];
                entry = this.props.entries.get(id);
                if (!entry)
                    return [2 /*return*/];
                e.preventDefault();
                url = "" + window.location, qi = url.indexOf('?');
                if (qi > 0)
                    url = url.substr(0, qi);
                window.open(url + "?snapshot-url=" + encodeURIComponent(entry.url), '_blank');
                return [2 /*return*/];
            });
        }); };
        return _this;
    }
    RemoteStateSnapshotList.prototype.render = function () {
        var _this = this;
        return react__WEBPACK_IMPORTED_MODULE_2__["createElement"]("ul", { style: { listStyle: 'none', marginTop: '10px' }, className: 'msp-state-list' }, this.props.entries.valueSeq().map(function (e) { return react__WEBPACK_IMPORTED_MODULE_2__["createElement"]("li", { key: e.id, className: 'msp-flex-row' },
            react__WEBPACK_IMPORTED_MODULE_2__["createElement"](_controls_common__WEBPACK_IMPORTED_MODULE_11__["Button"], { "data-id": e.id, onClick: _this.props.fetch, disabled: _this.props.isBusy, onContextMenu: _this.open, title: 'Click to download, right-click to open in a new tab.' },
                e.name || new Date(e.timestamp).toLocaleString(),
                " ",
                react__WEBPACK_IMPORTED_MODULE_2__["createElement"]("small", null, e.description)),
            !e.isSticky && _this.props.remove && react__WEBPACK_IMPORTED_MODULE_2__["createElement"](_controls_common__WEBPACK_IMPORTED_MODULE_11__["IconButton"], { svg: _controls_icons__WEBPACK_IMPORTED_MODULE_12__["DeleteOutlinedSvg"], "data-id": e.id, title: 'Remove', onClick: _this.props.remove, disabled: _this.props.isBusy, small: true })); }));
    };
    return RemoteStateSnapshotList;
}(_base__WEBPACK_IMPORTED_MODULE_10__["PurePluginUIComponent"]));
//# sourceMappingURL=snapshots.js.map

/***/ }),

/***/ "./lib/mol-plugin-ui/state/tree.js":
/*!*****************************************!*\
  !*** ./lib/mol-plugin-ui/state/tree.js ***!
  \*****************************************/
/*! exports provided: StateTree */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "StateTree", function() { return StateTree; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! react */ "./node_modules/react/index.js");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var rxjs_operators__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! rxjs/operators */ "./node_modules/rxjs/_esm5/operators/index.js");
/* harmony import */ var _mol_plugin_commands__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../mol-plugin/commands */ "./lib/mol-plugin/commands.js");
/* harmony import */ var _mol_state__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../mol-state */ "./lib/mol-state/index.js");
/* harmony import */ var _mol_state_tree_spine__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../mol-state/tree/spine */ "./lib/mol-state/tree/spine.js");
/* harmony import */ var _base__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../base */ "./lib/mol-plugin-ui/base.js");
/* harmony import */ var _controls_action_menu__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../controls/action-menu */ "./lib/mol-plugin-ui/controls/action-menu.js");
/* harmony import */ var _controls_common__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ../controls/common */ "./lib/mol-plugin-ui/controls/common.js");
/* harmony import */ var _controls_icons__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ../controls/icons */ "./lib/mol-plugin-ui/controls/icons.js");
/* harmony import */ var _apply_action__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ./apply-action */ "./lib/mol-plugin-ui/state/apply-action.js");
/* harmony import */ var _update_transform__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ./update-transform */ "./lib/mol-plugin-ui/state/update-transform.js");
/**
 * Copyright (c) 2018 - 2019 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author David Sehnal <david.sehnal@gmail.com>
 */












var StateTree = /** @class */ (function (_super) {
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__extends"])(StateTree, _super);
    function StateTree() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = { showActions: true };
        return _this;
    }
    StateTree.prototype.componentDidMount = function () {
        var _this = this;
        this.subscribe(this.plugin.state.events.cell.created, function (e) {
            if (e.cell.transform.parent === _mol_state__WEBPACK_IMPORTED_MODULE_4__["StateTransform"].RootRef)
                _this.forceUpdate();
        });
        this.subscribe(this.plugin.state.events.cell.removed, function (e) {
            if (e.parent === _mol_state__WEBPACK_IMPORTED_MODULE_4__["StateTransform"].RootRef)
                _this.forceUpdate();
        });
    };
    StateTree.getDerivedStateFromProps = function (props, state) {
        var n = props.state.tree.root.ref;
        var children = props.state.tree.children.get(n);
        var showActions = children.size === 0;
        if (state.showActions === showActions)
            return null;
        return { showActions: showActions };
    };
    StateTree.prototype.render = function () {
        var ref = this.props.state.tree.root.ref;
        if (this.state.showActions) {
            return react__WEBPACK_IMPORTED_MODULE_1__["createElement"]("div", { style: { margin: '10px', cursor: 'default' } },
                react__WEBPACK_IMPORTED_MODULE_1__["createElement"]("p", null, "Nothing to see here yet."),
                react__WEBPACK_IMPORTED_MODULE_1__["createElement"]("p", null,
                    "Structures and Volumes can be loaded from the ",
                    react__WEBPACK_IMPORTED_MODULE_1__["createElement"](_controls_icons__WEBPACK_IMPORTED_MODULE_9__["Icon"], { svg: _controls_icons__WEBPACK_IMPORTED_MODULE_9__["HomeOutlinedSvg"] }),
                    " tab."));
        }
        return react__WEBPACK_IMPORTED_MODULE_1__["createElement"](StateTreeNode, { cell: this.props.state.cells.get(ref), depth: 0 });
    };
    return StateTree;
}(_base__WEBPACK_IMPORTED_MODULE_6__["PluginUIComponent"]));

var StateTreeNode = /** @class */ (function (_super) {
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__extends"])(StateTreeNode, _super);
    function StateTreeNode() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            isCollapsed: !!_this.props.cell.state.isCollapsed,
            isNull: StateTreeNode.isNull(_this.props.cell),
            showLabel: StateTreeNode.showLabel(_this.props.cell)
        };
        return _this;
    }
    StateTreeNode.prototype.is = function (e) {
        return e.ref === this.ref && e.state === this.props.cell.parent;
    };
    Object.defineProperty(StateTreeNode.prototype, "ref", {
        get: function () {
            return this.props.cell.transform.ref;
        },
        enumerable: false,
        configurable: true
    });
    StateTreeNode.prototype.componentDidMount = function () {
        var _this = this;
        this.subscribe(this.plugin.state.events.cell.stateUpdated, function (e) {
            if (_this.props.cell === e.cell && _this.is(e) && e.state.cells.has(_this.ref)) {
                if (_this.state.isCollapsed !== !!e.cell.state.isCollapsed
                    || _this.state.isNull !== StateTreeNode.isNull(e.cell)
                    || _this.state.showLabel !== StateTreeNode.showLabel(e.cell)) {
                    _this.forceUpdate();
                }
            }
        });
        this.subscribe(this.plugin.state.events.cell.created, function (e) {
            if (_this.props.cell.parent === e.state && _this.ref === e.cell.transform.parent) {
                _this.forceUpdate();
            }
        });
        this.subscribe(this.plugin.state.events.cell.removed, function (e) {
            if (_this.props.cell.parent === e.state && _this.ref === e.parent) {
                _this.forceUpdate();
            }
        });
    };
    StateTreeNode.getDerivedStateFromProps = function (props, state) {
        var isNull = StateTreeNode.isNull(props.cell);
        var showLabel = StateTreeNode.showLabel(props.cell);
        if (!!props.cell.state.isCollapsed === state.isCollapsed && state.isNull === isNull && state.showLabel === showLabel)
            return null;
        return { isCollapsed: !!props.cell.state.isCollapsed, isNull: isNull, showLabel: showLabel };
    };
    StateTreeNode.hasDecorator = function (cell) {
        var _a;
        var children = cell.parent.tree.children.get(cell.transform.ref);
        if (children.size !== 1)
            return false;
        return !!((_a = cell.parent) === null || _a === void 0 ? void 0 : _a.tree.transforms.get(children.first()).transformer.definition.isDecorator);
    };
    StateTreeNode.isNull = function (cell) {
        return !cell || !cell.parent || cell.obj === _mol_state__WEBPACK_IMPORTED_MODULE_4__["StateObject"].Null || !cell.parent.tree.transforms.has(cell.transform.ref);
    };
    StateTreeNode.showLabel = function (cell) {
        return (cell.transform.ref !== _mol_state__WEBPACK_IMPORTED_MODULE_4__["StateTransform"].RootRef) && (cell.status !== 'ok' || (!cell.state.isGhost && !StateTreeNode.hasDecorator(cell)));
    };
    StateTreeNode.prototype.render = function () {
        var _this = this;
        if (this.state.isNull) {
            return null;
        }
        var cell = this.props.cell;
        var children = cell.parent.tree.children.get(this.ref);
        if (!this.state.showLabel) {
            if (children.size === 0)
                return null;
            return react__WEBPACK_IMPORTED_MODULE_1__["createElement"](react__WEBPACK_IMPORTED_MODULE_1__["Fragment"], null, children.map(function (c) { return react__WEBPACK_IMPORTED_MODULE_1__["createElement"](StateTreeNode, { cell: cell.parent.cells.get(c), key: c, depth: _this.props.depth }); }));
        }
        var newDepth = this.props.depth + 1;
        return react__WEBPACK_IMPORTED_MODULE_1__["createElement"](react__WEBPACK_IMPORTED_MODULE_1__["Fragment"], null,
            react__WEBPACK_IMPORTED_MODULE_1__["createElement"](StateTreeNodeLabel, { cell: cell, depth: this.props.depth }),
            children.size === 0
                ? void 0
                : react__WEBPACK_IMPORTED_MODULE_1__["createElement"]("div", { style: { display: this.state.isCollapsed ? 'none' : 'block' } }, children.map(function (c) { return react__WEBPACK_IMPORTED_MODULE_1__["createElement"](StateTreeNode, { cell: cell.parent.cells.get(c), key: c, depth: newDepth }); })));
    };
    return StateTreeNode;
}(_base__WEBPACK_IMPORTED_MODULE_6__["PluginUIComponent"]));
var StateTreeNodeLabel = /** @class */ (function (_super) {
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__extends"])(StateTreeNodeLabel, _super);
    function StateTreeNodeLabel() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            isCurrent: _this.props.cell.parent.current === _this.ref,
            isCollapsed: !!_this.props.cell.state.isCollapsed,
            action: void 0,
            currentAction: void 0
        };
        _this.setCurrent = function (e) {
            e === null || e === void 0 ? void 0 : e.preventDefault();
            e === null || e === void 0 ? void 0 : e.currentTarget.blur();
            _mol_plugin_commands__WEBPACK_IMPORTED_MODULE_3__["PluginCommands"].State.SetCurrentObject(_this.plugin, { state: _this.props.cell.parent, ref: _this.ref });
        };
        _this.setCurrentRoot = function (e) {
            e === null || e === void 0 ? void 0 : e.preventDefault();
            e === null || e === void 0 ? void 0 : e.currentTarget.blur();
            _mol_plugin_commands__WEBPACK_IMPORTED_MODULE_3__["PluginCommands"].State.SetCurrentObject(_this.plugin, { state: _this.props.cell.parent, ref: _mol_state__WEBPACK_IMPORTED_MODULE_4__["StateTransform"].RootRef });
        };
        _this.remove = function (e) {
            e === null || e === void 0 ? void 0 : e.preventDefault();
            _mol_plugin_commands__WEBPACK_IMPORTED_MODULE_3__["PluginCommands"].State.RemoveObject(_this.plugin, { state: _this.props.cell.parent, ref: _this.ref, removeParentGhosts: true });
        };
        _this.toggleVisible = function (e) {
            e.preventDefault();
            _mol_plugin_commands__WEBPACK_IMPORTED_MODULE_3__["PluginCommands"].State.ToggleVisibility(_this.plugin, { state: _this.props.cell.parent, ref: _this.ref });
            e.currentTarget.blur();
        };
        _this.toggleExpanded = function (e) {
            e.preventDefault();
            _mol_plugin_commands__WEBPACK_IMPORTED_MODULE_3__["PluginCommands"].State.ToggleExpanded(_this.plugin, { state: _this.props.cell.parent, ref: _this.ref });
            e.currentTarget.blur();
        };
        _this.highlight = function (e) {
            e.preventDefault();
            _mol_plugin_commands__WEBPACK_IMPORTED_MODULE_3__["PluginCommands"].Interactivity.Object.Highlight(_this.plugin, { state: _this.props.cell.parent, ref: _this.ref });
            e.currentTarget.blur();
        };
        _this.clearHighlight = function (e) {
            e.preventDefault();
            _mol_plugin_commands__WEBPACK_IMPORTED_MODULE_3__["PluginCommands"].Interactivity.ClearHighlights(_this.plugin);
            e.currentTarget.blur();
        };
        _this.hideApply = function () {
            _this.setCurrentRoot();
        };
        _this.selectAction = function (item) {
            if (!item)
                return;
            (item === null || item === void 0 ? void 0 : item.value)();
        };
        return _this;
    }
    StateTreeNodeLabel.prototype.is = function (e) {
        return e.ref === this.ref && e.state === this.props.cell.parent;
    };
    Object.defineProperty(StateTreeNodeLabel.prototype, "ref", {
        get: function () {
            return this.props.cell.transform.ref;
        },
        enumerable: false,
        configurable: true
    });
    StateTreeNodeLabel.prototype.componentDidMount = function () {
        var _this = this;
        this.subscribe(this.plugin.state.events.cell.stateUpdated.pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_2__["filter"])(function (e) { return _this.is(e); }), Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_2__["debounceTime"])(33)), function (e) {
            _this.forceUpdate();
        });
        this.subscribe(this.props.cell.parent.behaviors.currentObject, function (e) {
            if (!_this.is(e)) {
                if (_this.state.isCurrent && e.state.transforms.has(_this.ref)) {
                    _this._setCurrent(_this.props.cell.parent.current === _this.ref, _this.state.isCollapsed);
                }
                return;
            }
            if (e.state.transforms.has(_this.ref)) {
                _this._setCurrent(_this.props.cell.parent.current === _this.ref, !!_this.props.cell.state.isCollapsed);
            }
        });
    };
    StateTreeNodeLabel.prototype._setCurrent = function (isCurrent, isCollapsed) {
        if (isCurrent) {
            this.setState({ isCurrent: isCurrent, action: 'options', currentAction: void 0, isCollapsed: isCollapsed });
        }
        else {
            this.setState({ isCurrent: isCurrent, action: void 0, currentAction: void 0, isCollapsed: isCollapsed });
        }
    };
    StateTreeNodeLabel.getDerivedStateFromProps = function (props, state) {
        var isCurrent = props.cell.parent.current === props.cell.transform.ref;
        var isCollapsed = !!props.cell.state.isCollapsed;
        if (state.isCollapsed === isCollapsed && state.isCurrent === isCurrent)
            return null;
        return { isCurrent: isCurrent, isCollapsed: isCollapsed, action: void 0, currentAction: void 0 };
    };
    Object.defineProperty(StateTreeNodeLabel.prototype, "actions", {
        get: function () {
            var _this = this;
            var cell = this.props.cell;
            var actions = Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__spreadArrays"])(cell.parent.actions.fromCell(cell, this.plugin));
            if (actions.length === 0)
                return;
            actions.sort(function (a, b) { return a.definition.display.name < b.definition.display.name ? -1 : a.definition.display.name === b.definition.display.name ? 0 : 1; });
            return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__spreadArrays"])([
                _controls_action_menu__WEBPACK_IMPORTED_MODULE_7__["ActionMenu"].Header('Apply Action')
            ], actions.map(function (a) { return _controls_action_menu__WEBPACK_IMPORTED_MODULE_7__["ActionMenu"].Item(a.definition.display.name, function () { return _this.setState({ action: 'apply', currentAction: a }); }); }));
        },
        enumerable: false,
        configurable: true
    });
    StateTreeNodeLabel.prototype.updates = function (margin) {
        var cell = this.props.cell;
        var decoratorChain = _mol_state_tree_spine__WEBPACK_IMPORTED_MODULE_5__["StateTreeSpine"].getDecoratorChain(cell.parent, cell.transform.ref);
        var decorators = [];
        for (var i = decoratorChain.length - 1; i >= 0; i--) {
            var d = decoratorChain[i];
            decorators.push(react__WEBPACK_IMPORTED_MODULE_1__["createElement"](_update_transform__WEBPACK_IMPORTED_MODULE_11__["UpdateTransformControl"], { key: d.transform.transformer.id + "-" + i, state: cell.parent, transform: d.transform, noMargin: true, wrapInExpander: true, expanderHeaderLeftMargin: margin }));
        }
        return react__WEBPACK_IMPORTED_MODULE_1__["createElement"]("div", { className: 'msp-tree-updates-wrapper' }, decorators);
    };
    StateTreeNodeLabel.prototype.render = function () {
        var cell = this.props.cell;
        var n = cell.transform;
        if (!cell)
            return null;
        var isCurrent = this.is(cell.parent.behaviors.currentObject.value);
        var disabled = cell.status !== 'error' && cell.status !== 'ok';
        var label;
        if (cell.status === 'error' || !cell.obj) {
            var name_1 = cell.status === 'error' ? cell.errorText : n.transformer.definition.display.name;
            label = react__WEBPACK_IMPORTED_MODULE_1__["createElement"](_controls_common__WEBPACK_IMPORTED_MODULE_8__["Button"], { className: 'msp-btn-tree-label msp-no-hover-outline', noOverflow: true, title: name_1, onClick: this.state.isCurrent ? this.setCurrentRoot : this.setCurrent, disabled: disabled },
                cell.status === 'error' && react__WEBPACK_IMPORTED_MODULE_1__["createElement"]("b", null,
                    "[",
                    cell.status,
                    "]"),
                " ",
                react__WEBPACK_IMPORTED_MODULE_1__["createElement"]("span", null, name_1));
        }
        else {
            var obj = cell.obj;
            var title = obj.label + " " + (obj.description ? obj.description : '');
            label = react__WEBPACK_IMPORTED_MODULE_1__["createElement"](_controls_common__WEBPACK_IMPORTED_MODULE_8__["Button"], { className: "msp-btn-tree-label msp-type-class-" + obj.type.typeClass, noOverflow: true, disabled: disabled, title: title, onClick: this.state.isCurrent ? this.setCurrentRoot : this.setCurrent },
                react__WEBPACK_IMPORTED_MODULE_1__["createElement"]("span", null, obj.label),
                " ",
                obj.description ? react__WEBPACK_IMPORTED_MODULE_1__["createElement"]("small", null, obj.description) : void 0);
        }
        var children = cell.parent.tree.children.get(this.ref);
        var cellState = cell.state;
        var expand = react__WEBPACK_IMPORTED_MODULE_1__["createElement"](_controls_common__WEBPACK_IMPORTED_MODULE_8__["IconButton"], { svg: cellState.isCollapsed ? _controls_icons__WEBPACK_IMPORTED_MODULE_9__["ArrowRightSvg"] : _controls_icons__WEBPACK_IMPORTED_MODULE_9__["ArrowDropDownSvg"], flex: '20px', disabled: disabled, onClick: this.toggleExpanded, transparent: true, className: 'msp-no-hover-outline', style: { visibility: children.size > 0 ? 'visible' : 'hidden' } });
        var remove = !cell.state.isLocked ? react__WEBPACK_IMPORTED_MODULE_1__["createElement"](_controls_common__WEBPACK_IMPORTED_MODULE_8__["IconButton"], { svg: _controls_icons__WEBPACK_IMPORTED_MODULE_9__["DeleteOutlinedSvg"], onClick: this.remove, disabled: disabled, small: true, toggleState: false }) : void 0;
        var visibility = react__WEBPACK_IMPORTED_MODULE_1__["createElement"](_controls_common__WEBPACK_IMPORTED_MODULE_8__["IconButton"], { svg: cellState.isHidden ? _controls_icons__WEBPACK_IMPORTED_MODULE_9__["VisibilityOffOutlinedSvg"] : _controls_icons__WEBPACK_IMPORTED_MODULE_9__["VisibilityOutlinedSvg"], toggleState: false, disabled: disabled, small: true, onClick: this.toggleVisible });
        var marginStyle = {
            marginLeft: this.props.depth * 8 + "px"
        };
        var row = react__WEBPACK_IMPORTED_MODULE_1__["createElement"]("div", { className: "msp-flex-row msp-tree-row" + (isCurrent ? ' msp-tree-row-current' : ''), onMouseEnter: this.highlight, onMouseLeave: this.clearHighlight, style: marginStyle },
            expand,
            label,
            remove,
            visibility);
        if (!isCurrent)
            return row;
        if (this.state.action === 'apply' && this.state.currentAction) {
            return react__WEBPACK_IMPORTED_MODULE_1__["createElement"]("div", { style: { marginBottom: '1px' } },
                row,
                react__WEBPACK_IMPORTED_MODULE_1__["createElement"](_controls_common__WEBPACK_IMPORTED_MODULE_8__["ControlGroup"], { header: "Apply " + this.state.currentAction.definition.display.name, initialExpanded: true, hideExpander: true, hideOffset: false, onHeaderClick: this.hideApply, topRightIcon: _controls_icons__WEBPACK_IMPORTED_MODULE_9__["CloseSvg"], headerLeftMargin: this.props.depth * 8 + 21 + "px" },
                    react__WEBPACK_IMPORTED_MODULE_1__["createElement"](_apply_action__WEBPACK_IMPORTED_MODULE_10__["ApplyActionControl"], { onApply: this.hideApply, state: this.props.cell.parent, action: this.state.currentAction, nodeRef: this.props.cell.transform.ref, hideHeader: true, noMargin: true })));
        }
        if (this.state.action === 'options') {
            var actions = this.actions;
            var updates = this.updates(this.props.depth * 8 + 21 + "px");
            return react__WEBPACK_IMPORTED_MODULE_1__["createElement"]("div", { style: { marginBottom: '1px' } },
                row,
                updates,
                actions && react__WEBPACK_IMPORTED_MODULE_1__["createElement"]("div", { style: { marginLeft: this.props.depth * 8 + 21 + "px", marginTop: '-1px' } },
                    react__WEBPACK_IMPORTED_MODULE_1__["createElement"](_controls_action_menu__WEBPACK_IMPORTED_MODULE_7__["ActionMenu"], { items: actions, onSelect: this.selectAction })));
        }
        return row;
    };
    return StateTreeNodeLabel;
}(_base__WEBPACK_IMPORTED_MODULE_6__["PluginUIComponent"]));
//# sourceMappingURL=tree.js.map

/***/ }),

/***/ "./lib/mol-plugin-ui/state/update-transform.js":
/*!*****************************************************!*\
  !*** ./lib/mol-plugin-ui/state/update-transform.js ***!
  \*****************************************************/
/*! exports provided: UpdateTransformControl, TransformUpdaterControl */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "UpdateTransformControl", function() { return UpdateTransformControl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "TransformUpdaterControl", function() { return TransformUpdaterControl; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _mol_util_memoize__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../mol-util/memoize */ "./lib/mol-util/memoize.js");
/* harmony import */ var _common__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./common */ "./lib/mol-plugin-ui/state/common.js");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! react */ "./node_modules/react/index.js");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _base__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../base */ "./lib/mol-plugin-ui/base.js");
/**
 * Copyright (c) 2018 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author David Sehnal <david.sehnal@gmail.com>
 */






var UpdateTransformControl = /** @class */ (function (_super) {
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__extends"])(UpdateTransformControl, _super);
    function UpdateTransformControl() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this._getInfo = Object(_mol_util_memoize__WEBPACK_IMPORTED_MODULE_1__["memoizeLatest"])(function (t) { return _common__WEBPACK_IMPORTED_MODULE_2__["StateTransformParameters"].infoFromTransform(_this.plugin, _this.props.state, t); });
        _this.state = { error: void 0, isInitial: true, params: _this.getInfo().initialValues, busy: false, isCollapsed: _this.props.initiallyCollapsed };
        return _this;
    }
    UpdateTransformControl.prototype.applyAction = function () {
        if (this.props.customUpdate)
            return this.props.customUpdate(this.state.params);
        return this.plugin.state.updateTransform(this.props.state, this.props.transform.ref, this.state.params);
    };
    UpdateTransformControl.prototype.getInfo = function () { return this._getInfo(this.props.transform); };
    UpdateTransformControl.prototype.getTransformerId = function () { return this.props.transform.transformer.id; };
    UpdateTransformControl.prototype.getHeader = function () { return this.props.customHeader || this.props.transform.transformer.definition.display; };
    UpdateTransformControl.prototype.canApply = function () {
        var state = this.props.state;
        var cell = state.cells.get(this.props.transform.ref);
        if (!cell)
            return false;
        if (cell.status === 'error') {
            var parent_1 = state.cells.get(this.props.transform.parent);
            if (!parent_1)
                return false;
            return parent_1.status === 'ok';
        }
        return !this.state.error && !this.state.busy && !this.state.isInitial;
    };
    UpdateTransformControl.prototype.applyText = function () { return this.canApply() ? 'Update' : 'Nothing to Update'; };
    UpdateTransformControl.prototype.isUpdate = function () { return true; };
    UpdateTransformControl.prototype.getSourceAndTarget = function () {
        var bCell = this.props.state.cells.get(this.props.transform.ref);
        return {
            a: this.props.state.cells.get(this.props.transform.parent).obj,
            b: bCell === null || bCell === void 0 ? void 0 : bCell.obj,
            bCell: bCell
        };
    };
    UpdateTransformControl.prototype.canAutoApply = function (newParams) {
        var autoUpdate = this.props.transform.transformer.definition.canAutoUpdate;
        if (!autoUpdate)
            return false;
        var state = this.props.state;
        var cell = state.cells.get(this.props.transform.ref);
        if (!cell || !cell.sourceRef || cell.status !== 'ok')
            return false;
        var parentCell = state.cells.get(cell.sourceRef);
        return autoUpdate({ a: parentCell.obj, b: cell.obj, oldParams: this.getInfo().initialValues, newParams: newParams }, this.plugin);
    };
    UpdateTransformControl.prototype.componentDidMount = function () {
        var _this = this;
        _super.prototype.componentDidMount.call(this);
        if (this.props.toggleCollapsed)
            this.subscribe(this.props.toggleCollapsed, function () { return _this.setState({ isCollapsed: !_this.state.isCollapsed }); });
        this.subscribe(this.plugin.state.events.object.updated, function (_a) {
            var ref = _a.ref, state = _a.state;
            if (_this.props.transform.ref !== ref || _this.props.state !== state)
                return;
            if (_this.state.params !== _this.props.transform.params) {
                _this._getInfo = Object(_mol_util_memoize__WEBPACK_IMPORTED_MODULE_1__["memoizeLatest"])(function (t) { return _common__WEBPACK_IMPORTED_MODULE_2__["StateTransformParameters"].infoFromTransform(_this.plugin, _this.props.state, t); });
                _this.setState({ params: _this.props.transform.params, isInitial: true });
            }
        });
    };
    UpdateTransformControl.prototype.componentDidUpdate = function (prevProps) {
        var _a;
        if (this.props.transform !== prevProps.transform) {
            var cell = this.props.state.cells.get(this.props.transform.ref);
            this.setState({
                params: ((_a = cell.params) === null || _a === void 0 ? void 0 : _a.values) || {},
                isInitial: true,
                error: void 0,
                simpleOnly: this.state.simpleOnly
            });
        }
    };
    return UpdateTransformControl;
}(_common__WEBPACK_IMPORTED_MODULE_2__["TransformControlBase"]));
var TransformUpdaterControl = /** @class */ (function (_super) {
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__extends"])(TransformUpdaterControl, _super);
    function TransformUpdaterControl() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    TransformUpdaterControl.prototype.componentDidMount = function () {
        var _this = this;
        this.subscribe(this.plugin.state.events.object.updated, function (_a) {
            var ref = _a.ref, state = _a.state;
            if (_this.props.nodeRef !== ref || _this.plugin.state.data !== state)
                return;
            _this.forceUpdate();
        });
    };
    TransformUpdaterControl.prototype.render = function () {
        var state = this.plugin.state.data;
        var ref = this.props.nodeRef;
        var cell = state.cells.get(ref);
        if (!cell || (cell.status !== 'ok' && cell.status !== 'error'))
            return null;
        var transform = cell.transform;
        return react__WEBPACK_IMPORTED_MODULE_3__["createElement"](UpdateTransformControl, { state: state, transform: transform, initiallyCollapsed: this.props.initiallyCollapsed, customHeader: this.props.header });
    };
    return TransformUpdaterControl;
}(_base__WEBPACK_IMPORTED_MODULE_4__["PluginUIComponent"]));
//# sourceMappingURL=update-transform.js.map

/***/ }),

/***/ "./lib/mol-plugin-ui/structure/components.js":
/*!***************************************************!*\
  !*** ./lib/mol-plugin-ui/structure/components.js ***!
  \***************************************************/
/*! exports provided: StructureComponentControls, AddComponentControls */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "StructureComponentControls", function() { return StructureComponentControls; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "AddComponentControls", function() { return AddComponentControls; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! react */ "./node_modules/react/index.js");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _mol_plugin_state_helpers_structure_representation_params__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../mol-plugin-state/helpers/structure-representation-params */ "./lib/mol-plugin-state/helpers/structure-representation-params.js");
/* harmony import */ var _mol_plugin_state_manager_structure_component__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../mol-plugin-state/manager/structure/component */ "./lib/mol-plugin-state/manager/structure/component.js");
/* harmony import */ var _mol_plugin_state_manager_structure_hierarchy__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../mol-plugin-state/manager/structure/hierarchy */ "./lib/mol-plugin-state/manager/structure/hierarchy.js");
/* harmony import */ var _mol_plugin_commands__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../mol-plugin/commands */ "./lib/mol-plugin/commands.js");
/* harmony import */ var _mol_state__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../../mol-state */ "./lib/mol-state/index.js");
/* harmony import */ var _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../../mol-util/param-definition */ "./lib/mol-util/param-definition.js");
/* harmony import */ var _base__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ../base */ "./lib/mol-plugin-ui/base.js");
/* harmony import */ var _controls_action_menu__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ../controls/action-menu */ "./lib/mol-plugin-ui/controls/action-menu.js");
/* harmony import */ var _controls_common__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ../controls/common */ "./lib/mol-plugin-ui/controls/common.js");
/* harmony import */ var _controls_icons__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ../controls/icons */ "./lib/mol-plugin-ui/controls/icons.js");
/* harmony import */ var _controls_parameters__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! ../controls/parameters */ "./lib/mol-plugin-ui/controls/parameters.js");
/* harmony import */ var _state_update_transform__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! ../state/update-transform */ "./lib/mol-plugin-ui/state/update-transform.js");
/* harmony import */ var _generic__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! ./generic */ "./lib/mol-plugin-ui/structure/generic.js");
/**
 * Copyright (c) 2020 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author David Sehnal <david.sehnal@gmail.com>
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */















var StructureComponentControls = /** @class */ (function (_super) {
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__extends"])(StructureComponentControls, _super);
    function StructureComponentControls() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    StructureComponentControls.prototype.defaultState = function () {
        return {
            header: 'Components',
            isCollapsed: false,
            isDisabled: false,
            brand: { accent: 'blue', svg: _controls_icons__WEBPACK_IMPORTED_MODULE_11__["CubeOutlineSvg"] }
        };
    };
    StructureComponentControls.prototype.componentDidMount = function () {
        var _this = this;
        this.subscribe(this.plugin.managers.structure.hierarchy.behaviors.selection, function (c) { return _this.setState({
            description: _mol_plugin_state_manager_structure_hierarchy__WEBPACK_IMPORTED_MODULE_4__["StructureHierarchyManager"].getSelectedStructuresDescription(_this.plugin)
        }); });
    };
    StructureComponentControls.prototype.renderControls = function () {
        return react__WEBPACK_IMPORTED_MODULE_1__["createElement"](react__WEBPACK_IMPORTED_MODULE_1__["Fragment"], null,
            react__WEBPACK_IMPORTED_MODULE_1__["createElement"](ComponentEditorControls, null),
            react__WEBPACK_IMPORTED_MODULE_1__["createElement"](ComponentListControls, null),
            react__WEBPACK_IMPORTED_MODULE_1__["createElement"](_generic__WEBPACK_IMPORTED_MODULE_14__["GenericEntryListControls"], null));
    };
    return StructureComponentControls;
}(_base__WEBPACK_IMPORTED_MODULE_8__["CollapsableControls"]));

var ComponentEditorControls = /** @class */ (function (_super) {
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__extends"])(ComponentEditorControls, _super);
    function ComponentEditorControls() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            isEmpty: true,
            isBusy: false,
            canUndo: false
        };
        _this.togglePreset = _this.toggleAction('preset');
        _this.toggleAdd = _this.toggleAction('add');
        _this.toggleOptions = _this.toggleAction('options');
        _this.hideAction = function () { return _this.setState({ action: void 0 }); };
        _this.applyPreset = function (item) {
            _this.hideAction();
            if (!item)
                return;
            var mng = _this.plugin.managers.structure;
            var structures = mng.hierarchy.selection.structures;
            if (item.value === null)
                mng.component.clear(structures);
            else
                mng.component.applyPreset(structures, item.value);
        };
        _this.undo = function () {
            var task = _this.plugin.state.data.undo();
            if (task)
                _this.plugin.runTask(task);
        };
        return _this;
    }
    Object.defineProperty(ComponentEditorControls.prototype, "isDisabled", {
        get: function () {
            return this.state.isBusy || this.state.isEmpty;
        },
        enumerable: false,
        configurable: true
    });
    ComponentEditorControls.prototype.componentDidMount = function () {
        var _this = this;
        this.subscribe(this.plugin.managers.structure.hierarchy.behaviors.selection, function (c) { return _this.setState({
            action: _this.state.action !== 'options' || c.structures.length === 0 ? void 0 : 'options',
            isEmpty: c.structures.length === 0
        }); });
        this.subscribe(this.plugin.behaviors.state.isBusy, function (v) {
            _this.setState({ isBusy: v, action: _this.state.action !== 'options' ? void 0 : 'options' });
        });
        this.subscribe(this.plugin.state.data.events.historyUpdated, function (_a) {
            var state = _a.state;
            _this.setState({ canUndo: state.canUndo });
        });
    };
    ComponentEditorControls.prototype.toggleAction = function (action) {
        var _this = this;
        return function () { return _this.setState({ action: _this.state.action === action ? void 0 : action }); };
    };
    Object.defineProperty(ComponentEditorControls.prototype, "presetControls", {
        get: function () {
            return react__WEBPACK_IMPORTED_MODULE_1__["createElement"](_controls_action_menu__WEBPACK_IMPORTED_MODULE_9__["ActionMenu"], { items: this.presetActions, onSelect: this.applyPreset });
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ComponentEditorControls.prototype, "presetActions", {
        get: function () {
            var pivot = this.plugin.managers.structure.component.pivotStructure;
            var providers = this.plugin.builders.structure.representation.getPresets(pivot === null || pivot === void 0 ? void 0 : pivot.cell.obj);
            return _controls_action_menu__WEBPACK_IMPORTED_MODULE_9__["ActionMenu"].createItems(providers, { label: function (p) { return p.display.name; }, category: function (p) { return p.display.group; }, description: function (p) { return p.display.description; } });
        },
        enumerable: false,
        configurable: true
    });
    ComponentEditorControls.prototype.render = function () {
        var undoTitle = this.state.canUndo
            ? "Undo " + this.plugin.state.data.latestUndoLabel
            : 'Some mistakes of the past can be undone.';
        return react__WEBPACK_IMPORTED_MODULE_1__["createElement"](react__WEBPACK_IMPORTED_MODULE_1__["Fragment"], null,
            react__WEBPACK_IMPORTED_MODULE_1__["createElement"]("div", { className: 'msp-flex-row' },
                react__WEBPACK_IMPORTED_MODULE_1__["createElement"](_controls_common__WEBPACK_IMPORTED_MODULE_10__["ToggleButton"], { icon: _controls_icons__WEBPACK_IMPORTED_MODULE_11__["BookmarksOutlinedSvg"], label: 'Preset', title: 'Apply a representation preset for the current structure(s).', toggle: this.togglePreset, isSelected: this.state.action === 'preset', disabled: this.isDisabled }),
                react__WEBPACK_IMPORTED_MODULE_1__["createElement"](_controls_common__WEBPACK_IMPORTED_MODULE_10__["ToggleButton"], { icon: _controls_icons__WEBPACK_IMPORTED_MODULE_11__["AddSvg"], label: 'Add', title: 'Add a new representation component for a selection.', toggle: this.toggleAdd, isSelected: this.state.action === 'add', disabled: this.isDisabled }),
                react__WEBPACK_IMPORTED_MODULE_1__["createElement"](_controls_common__WEBPACK_IMPORTED_MODULE_10__["ToggleButton"], { icon: _controls_icons__WEBPACK_IMPORTED_MODULE_11__["TuneSvg"], label: '', title: 'Options that are applied to all applicable representations.', style: { flex: '0 0 40px', padding: 0 }, toggle: this.toggleOptions, isSelected: this.state.action === 'options', disabled: this.isDisabled }),
                react__WEBPACK_IMPORTED_MODULE_1__["createElement"](_controls_common__WEBPACK_IMPORTED_MODULE_10__["IconButton"], { svg: _controls_icons__WEBPACK_IMPORTED_MODULE_11__["RestoreSvg"], className: 'msp-flex-item', flex: '40px', onClick: this.undo, disabled: !this.state.canUndo || this.isDisabled, title: undoTitle })),
            this.state.action === 'preset' && this.presetControls,
            this.state.action === 'add' && react__WEBPACK_IMPORTED_MODULE_1__["createElement"]("div", { className: 'msp-control-offset' },
                react__WEBPACK_IMPORTED_MODULE_1__["createElement"](AddComponentControls, { onApply: this.hideAction })),
            this.state.action === 'options' && react__WEBPACK_IMPORTED_MODULE_1__["createElement"]("div", { className: 'msp-control-offset' },
                react__WEBPACK_IMPORTED_MODULE_1__["createElement"](ComponentOptionsControls, { isDisabled: this.isDisabled })));
    };
    return ComponentEditorControls;
}(_base__WEBPACK_IMPORTED_MODULE_8__["PurePluginUIComponent"]));
var AddComponentControls = /** @class */ (function (_super) {
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__extends"])(AddComponentControls, _super);
    function AddComponentControls() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = _this.createState();
        _this.apply = function () {
            var structures = _this.props.forSelection ? _this.currentStructures : _this.selectedStructures;
            _this.props.onApply();
            _this.plugin.managers.structure.component.add(_this.state.values, structures);
        };
        _this.paramsChanged = function (values) { return _this.setState({ values: values }); };
        return _this;
    }
    AddComponentControls.prototype.createState = function () {
        var params = _mol_plugin_state_manager_structure_component__WEBPACK_IMPORTED_MODULE_3__["StructureComponentManager"].getAddParams(this.plugin);
        return { params: params, values: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_7__["ParamDefinition"].getDefaultValues(params) };
    };
    Object.defineProperty(AddComponentControls.prototype, "selectedStructures", {
        get: function () {
            return this.plugin.managers.structure.component.currentStructures;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AddComponentControls.prototype, "currentStructures", {
        get: function () {
            return this.plugin.managers.structure.hierarchy.current.structures;
        },
        enumerable: false,
        configurable: true
    });
    AddComponentControls.prototype.render = function () {
        return react__WEBPACK_IMPORTED_MODULE_1__["createElement"](react__WEBPACK_IMPORTED_MODULE_1__["Fragment"], null,
            react__WEBPACK_IMPORTED_MODULE_1__["createElement"](_controls_parameters__WEBPACK_IMPORTED_MODULE_12__["ParameterControls"], { params: this.state.params, values: this.state.values, onChangeValues: this.paramsChanged }),
            react__WEBPACK_IMPORTED_MODULE_1__["createElement"](_controls_common__WEBPACK_IMPORTED_MODULE_10__["Button"], { icon: _controls_icons__WEBPACK_IMPORTED_MODULE_11__["AddSvg"], title: 'Use Selection and optional Representation to create a new Component.', className: 'msp-btn-commit msp-btn-commit-on', onClick: this.apply, style: { marginTop: '1px' } }, "Create Component"));
    };
    return AddComponentControls;
}(_base__WEBPACK_IMPORTED_MODULE_8__["PurePluginUIComponent"]));

var ComponentOptionsControls = /** @class */ (function (_super) {
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__extends"])(ComponentOptionsControls, _super);
    function ComponentOptionsControls() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.update = function (options) { return _this.plugin.managers.structure.component.setOptions(options); };
        return _this;
    }
    ComponentOptionsControls.prototype.componentDidMount = function () {
        var _this = this;
        this.subscribe(this.plugin.managers.structure.component.events.optionsUpdated, function () { return _this.forceUpdate(); });
    };
    ComponentOptionsControls.prototype.render = function () {
        return react__WEBPACK_IMPORTED_MODULE_1__["createElement"](_controls_parameters__WEBPACK_IMPORTED_MODULE_12__["ParameterControls"], { params: _mol_plugin_state_manager_structure_component__WEBPACK_IMPORTED_MODULE_3__["StructureComponentManager"].OptionsParams, values: this.plugin.managers.structure.component.state.options, onChangeValues: this.update, isDisabled: this.props.isDisabled });
    };
    return ComponentOptionsControls;
}(_base__WEBPACK_IMPORTED_MODULE_8__["PurePluginUIComponent"]));
var ComponentListControls = /** @class */ (function (_super) {
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__extends"])(ComponentListControls, _super);
    function ComponentListControls() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ComponentListControls.prototype.componentDidMount = function () {
        var _this = this;
        this.subscribe(this.plugin.managers.structure.hierarchy.behaviors.selection, function () {
            _this.forceUpdate();
        });
    };
    ComponentListControls.prototype.render = function () {
        var componentGroups = this.plugin.managers.structure.hierarchy.currentComponentGroups;
        if (componentGroups.length === 0)
            return null;
        return react__WEBPACK_IMPORTED_MODULE_1__["createElement"]("div", { style: { marginTop: '6px' } }, componentGroups.map(function (g) { return react__WEBPACK_IMPORTED_MODULE_1__["createElement"](StructureComponentGroup, { key: g[0].cell.transform.ref, group: g }); }));
    };
    return ComponentListControls;
}(_base__WEBPACK_IMPORTED_MODULE_8__["PurePluginUIComponent"]));
var StructureComponentGroup = /** @class */ (function (_super) {
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__extends"])(StructureComponentGroup, _super);
    function StructureComponentGroup() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = { action: void 0 };
        _this.toggleVisible = function (e) {
            e.preventDefault();
            e.currentTarget.blur();
            _this.plugin.managers.structure.component.toggleVisibility(_this.props.group);
        };
        _this.selectAction = function (item) {
            if (!item)
                return;
            _this.setState({ action: void 0 });
            (item === null || item === void 0 ? void 0 : item.value)();
        };
        _this.remove = function () { return _this.plugin.managers.structure.hierarchy.remove(_this.props.group, true); };
        _this.toggleAction = function () { return _this.setState({ action: _this.state.action === 'action' ? void 0 : 'action' }); };
        _this.toggleLabel = function () { return _this.setState({ action: _this.state.action === 'label' ? void 0 : 'label' }); };
        _this.highlight = function (e) {
            e.preventDefault();
            if (!_this.props.group[0].cell.parent)
                return;
            _mol_plugin_commands__WEBPACK_IMPORTED_MODULE_5__["PluginCommands"].Interactivity.Object.Highlight(_this.plugin, { state: _this.props.group[0].cell.parent, ref: _this.props.group.map(function (c) { return c.cell.transform.ref; }) });
        };
        _this.clearHighlight = function (e) {
            e.preventDefault();
            _mol_plugin_commands__WEBPACK_IMPORTED_MODULE_5__["PluginCommands"].Interactivity.ClearHighlights(_this.plugin);
        };
        _this.focus = function () {
            var allHidden = true;
            for (var _i = 0, _a = _this.props.group; _i < _a.length; _i++) {
                var c = _a[_i];
                if (!c.cell.state.isHidden) {
                    allHidden = false;
                    break;
                }
            }
            if (allHidden) {
                _this.plugin.managers.structure.hierarchy.toggleVisibility(_this.props.group, 'show');
            }
            _this.plugin.managers.camera.focusSpheres(_this.props.group, function (e) {
                var _a;
                if (e.cell.state.isHidden)
                    return;
                return (_a = e.cell.obj) === null || _a === void 0 ? void 0 : _a.data.boundary.sphere;
            });
        };
        _this.updateLabel = function (v) {
            _this.plugin.managers.structure.component.updateLabel(_this.pivot, v);
        };
        return _this;
    }
    Object.defineProperty(StructureComponentGroup.prototype, "pivot", {
        get: function () {
            return this.props.group[0];
        },
        enumerable: false,
        configurable: true
    });
    StructureComponentGroup.prototype.componentDidMount = function () {
        var _this = this;
        this.subscribe(this.plugin.state.events.cell.stateUpdated, function (e) {
            if (_mol_state__WEBPACK_IMPORTED_MODULE_6__["State"].ObjectEvent.isCell(e, _this.pivot.cell))
                _this.forceUpdate();
        });
    };
    Object.defineProperty(StructureComponentGroup.prototype, "colorByActions", {
        get: function () {
            var _this = this;
            var _a, _b;
            var mng = this.plugin.managers.structure.component;
            var repr = this.pivot.representations[0];
            var name = (_a = repr.cell.transform.params) === null || _a === void 0 ? void 0 : _a.colorTheme.name;
            var themes = Object(_mol_plugin_state_helpers_structure_representation_params__WEBPACK_IMPORTED_MODULE_2__["getStructureThemeTypes"])(this.plugin, (_b = this.pivot.cell.obj) === null || _b === void 0 ? void 0 : _b.data);
            return _controls_action_menu__WEBPACK_IMPORTED_MODULE_9__["ActionMenu"].createItemsFromSelectOptions(themes, {
                value: function (o) { return function () { return mng.updateRepresentationsTheme(_this.props.group, { color: o[0] }); }; },
                selected: function (o) { return o[0] === name; }
            });
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(StructureComponentGroup.prototype, "actions", {
        get: function () {
            var _this = this;
            var mng = this.plugin.managers.structure.component;
            var ret = [
                Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__spreadArrays"])([
                    _controls_action_menu__WEBPACK_IMPORTED_MODULE_9__["ActionMenu"].Header('Add Representation')
                ], _mol_plugin_state_manager_structure_component__WEBPACK_IMPORTED_MODULE_3__["StructureComponentManager"].getRepresentationTypes(this.plugin, this.props.group[0])
                    .map(function (t) { return _controls_action_menu__WEBPACK_IMPORTED_MODULE_9__["ActionMenu"].Item(t[1], function () { return mng.addRepresentation(_this.props.group, t[0]); }); }))
            ];
            if (this.pivot.representations.length > 0) {
                ret.push(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__spreadArrays"])([
                    _controls_action_menu__WEBPACK_IMPORTED_MODULE_9__["ActionMenu"].Header('Set Coloring', { isIndependent: true })
                ], this.colorByActions));
            }
            if (mng.canBeModified(this.props.group[0])) {
                ret.push([
                    _controls_action_menu__WEBPACK_IMPORTED_MODULE_9__["ActionMenu"].Header('Modify by Selection'),
                    _controls_action_menu__WEBPACK_IMPORTED_MODULE_9__["ActionMenu"].Item('Include', function () { return mng.modifyByCurrentSelection(_this.props.group, 'union'); }, { icon: _controls_icons__WEBPACK_IMPORTED_MODULE_11__["UnionSvg"] }),
                    _controls_action_menu__WEBPACK_IMPORTED_MODULE_9__["ActionMenu"].Item('Subtract', function () { return mng.modifyByCurrentSelection(_this.props.group, 'subtract'); }, { icon: _controls_icons__WEBPACK_IMPORTED_MODULE_11__["SubtractSvg"] }),
                    _controls_action_menu__WEBPACK_IMPORTED_MODULE_9__["ActionMenu"].Item('Intersect', function () { return mng.modifyByCurrentSelection(_this.props.group, 'intersect'); }, { icon: _controls_icons__WEBPACK_IMPORTED_MODULE_11__["IntersectSvg"] })
                ]);
            }
            ret.push(_controls_action_menu__WEBPACK_IMPORTED_MODULE_9__["ActionMenu"].Item('Select This', function () { return mng.selectThis(_this.props.group); }, { icon: _controls_icons__WEBPACK_IMPORTED_MODULE_11__["SetSvg"] }));
            if (mng.canBeModified(this.props.group[0])) {
                ret.push(_controls_action_menu__WEBPACK_IMPORTED_MODULE_9__["ActionMenu"].Item('Edit Label', this.toggleLabel));
            }
            return ret;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(StructureComponentGroup.prototype, "reprLabel", {
        get: function () {
            var _a;
            // TODO: handle generic reprs.
            var pivot = this.pivot;
            if (pivot.representations.length === 0)
                return 'No repr.';
            if (pivot.representations.length === 1)
                return (_a = pivot.representations[0].cell.obj) === null || _a === void 0 ? void 0 : _a.label;
            return pivot.representations.length + " reprs";
        },
        enumerable: false,
        configurable: true
    });
    StructureComponentGroup.prototype.render = function () {
        var _this = this;
        var _a;
        var component = this.pivot;
        var cell = component.cell;
        var label = (_a = cell.obj) === null || _a === void 0 ? void 0 : _a.label;
        var reprLabel = this.reprLabel;
        return react__WEBPACK_IMPORTED_MODULE_1__["createElement"](react__WEBPACK_IMPORTED_MODULE_1__["Fragment"], null,
            react__WEBPACK_IMPORTED_MODULE_1__["createElement"]("div", { className: 'msp-flex-row' },
                react__WEBPACK_IMPORTED_MODULE_1__["createElement"](_controls_common__WEBPACK_IMPORTED_MODULE_10__["Button"], { noOverflow: true, className: 'msp-control-button-label', title: label + ". Click to focus.", onClick: this.focus, onMouseEnter: this.highlight, onMouseLeave: this.clearHighlight, style: { textAlign: 'left' } },
                    label,
                    react__WEBPACK_IMPORTED_MODULE_1__["createElement"]("small", { className: 'msp-25-lower-contrast-text', style: { float: 'right' } }, reprLabel)),
                react__WEBPACK_IMPORTED_MODULE_1__["createElement"](_controls_common__WEBPACK_IMPORTED_MODULE_10__["IconButton"], { svg: cell.state.isHidden ? _controls_icons__WEBPACK_IMPORTED_MODULE_11__["VisibilityOffOutlinedSvg"] : _controls_icons__WEBPACK_IMPORTED_MODULE_11__["VisibilityOutlinedSvg"], toggleState: false, onClick: this.toggleVisible, title: (cell.state.isHidden ? 'Show' : 'Hide') + " component", small: true, className: 'msp-form-control', flex: true }),
                react__WEBPACK_IMPORTED_MODULE_1__["createElement"](_controls_common__WEBPACK_IMPORTED_MODULE_10__["IconButton"], { svg: _controls_icons__WEBPACK_IMPORTED_MODULE_11__["DeleteOutlinedSvg"], toggleState: false, onClick: this.remove, title: 'Remove', small: true, className: 'msp-form-control', flex: true }),
                react__WEBPACK_IMPORTED_MODULE_1__["createElement"](_controls_common__WEBPACK_IMPORTED_MODULE_10__["IconButton"], { svg: _controls_icons__WEBPACK_IMPORTED_MODULE_11__["MoreHorizSvg"], onClick: this.toggleAction, title: 'Actions', toggleState: this.state.action === 'action', className: 'msp-form-control', flex: true })),
            this.state.action === 'label' && react__WEBPACK_IMPORTED_MODULE_1__["createElement"]("div", { className: 'msp-control-offset', style: { marginBottom: '6px' } },
                react__WEBPACK_IMPORTED_MODULE_1__["createElement"](_controls_common__WEBPACK_IMPORTED_MODULE_10__["ControlRow"], { label: 'Label', control: react__WEBPACK_IMPORTED_MODULE_1__["createElement"]("div", { style: { display: 'flex', textAlignLast: 'center' } },
                        react__WEBPACK_IMPORTED_MODULE_1__["createElement"](_controls_common__WEBPACK_IMPORTED_MODULE_10__["TextInput"], { onChange: this.updateLabel, value: label, style: { flex: '1 1 auto', minWidth: 0 }, className: 'msp-form-control', blurOnEnter: true, blurOnEscape: true }),
                        react__WEBPACK_IMPORTED_MODULE_1__["createElement"](_controls_common__WEBPACK_IMPORTED_MODULE_10__["IconButton"], { svg: _controls_icons__WEBPACK_IMPORTED_MODULE_11__["CheckSvg"], onClick: this.toggleLabel, className: 'msp-form-control msp-control-button-label', flex: true })) })),
            this.state.action === 'action' && react__WEBPACK_IMPORTED_MODULE_1__["createElement"]("div", { className: 'msp-accent-offset' },
                react__WEBPACK_IMPORTED_MODULE_1__["createElement"]("div", { style: { marginBottom: '6px' } },
                    react__WEBPACK_IMPORTED_MODULE_1__["createElement"](_controls_action_menu__WEBPACK_IMPORTED_MODULE_9__["ActionMenu"], { items: this.actions, onSelect: this.selectAction, noOffset: true })),
                react__WEBPACK_IMPORTED_MODULE_1__["createElement"]("div", { style: { marginBottom: '6px' } }, component.representations.map(function (r) { return react__WEBPACK_IMPORTED_MODULE_1__["createElement"](StructureRepresentationEntry, { group: _this.props.group, key: r.cell.transform.ref, representation: r }); }))));
    };
    return StructureComponentGroup;
}(_base__WEBPACK_IMPORTED_MODULE_8__["PurePluginUIComponent"]));
var StructureRepresentationEntry = /** @class */ (function (_super) {
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__extends"])(StructureRepresentationEntry, _super);
    function StructureRepresentationEntry() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.remove = function () { return _this.plugin.managers.structure.component.removeRepresentations(_this.props.group, _this.props.representation); };
        _this.toggleVisible = function (e) {
            e.preventDefault();
            e.currentTarget.blur();
            _this.plugin.managers.structure.component.toggleVisibility(_this.props.group, _this.props.representation);
        };
        _this.update = function (params) { return _this.plugin.managers.structure.component.updateRepresentations(_this.props.group, _this.props.representation, params); };
        return _this;
    }
    StructureRepresentationEntry.prototype.componentDidMount = function () {
        var _this = this;
        this.subscribe(this.plugin.state.events.cell.stateUpdated, function (e) {
            if (_mol_state__WEBPACK_IMPORTED_MODULE_6__["State"].ObjectEvent.isCell(e, _this.props.representation.cell))
                _this.forceUpdate();
        });
    };
    StructureRepresentationEntry.prototype.render = function () {
        var _a;
        var repr = this.props.representation.cell;
        return react__WEBPACK_IMPORTED_MODULE_1__["createElement"]("div", { className: 'msp-representation-entry' },
            repr.parent && react__WEBPACK_IMPORTED_MODULE_1__["createElement"](_controls_common__WEBPACK_IMPORTED_MODULE_10__["ExpandGroup"], { header: (((_a = repr.obj) === null || _a === void 0 ? void 0 : _a.label) || '') + " Representation", noOffset: true },
                react__WEBPACK_IMPORTED_MODULE_1__["createElement"](_state_update_transform__WEBPACK_IMPORTED_MODULE_13__["UpdateTransformControl"], { state: repr.parent, transform: repr.transform, customHeader: 'none', customUpdate: this.update, noMargin: true })),
            react__WEBPACK_IMPORTED_MODULE_1__["createElement"](_controls_common__WEBPACK_IMPORTED_MODULE_10__["IconButton"], { svg: _controls_icons__WEBPACK_IMPORTED_MODULE_11__["DeleteOutlinedSvg"], onClick: this.remove, title: 'Remove', small: true, className: 'msp-default-bg', toggleState: false, style: {
                    position: 'absolute', top: 0, right: '32px', lineHeight: '24px', height: '24px', textAlign: 'right', width: '44px', paddingRight: '6px', background: 'none'
                } }),
            react__WEBPACK_IMPORTED_MODULE_1__["createElement"](_controls_common__WEBPACK_IMPORTED_MODULE_10__["IconButton"], { svg: this.props.representation.cell.state.isHidden ? _controls_icons__WEBPACK_IMPORTED_MODULE_11__["VisibilityOffOutlinedSvg"] : _controls_icons__WEBPACK_IMPORTED_MODULE_11__["VisibilityOutlinedSvg"], toggleState: false, onClick: this.toggleVisible, title: 'Toggle Visibility', small: true, className: 'msp-default-bg', style: {
                    position: 'absolute', top: 0, right: 0, lineHeight: '24px', height: '24px', textAlign: 'right', width: '32px', paddingRight: '6px', background: 'none'
                } }));
    };
    return StructureRepresentationEntry;
}(_base__WEBPACK_IMPORTED_MODULE_8__["PurePluginUIComponent"]));
//# sourceMappingURL=components.js.map

/***/ }),

/***/ "./lib/mol-plugin-ui/structure/focus.js":
/*!**********************************************!*\
  !*** ./lib/mol-plugin-ui/structure/focus.js ***!
  \**********************************************/
/*! exports provided: StructureFocusControls */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "StructureFocusControls", function() { return StructureFocusControls; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! react */ "./node_modules/react/index.js");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _mol_data_int__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../mol-data/int */ "./lib/mol-data/int.js");
/* harmony import */ var _mol_model_structure__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../mol-model/structure */ "./lib/mol-model/structure.js");
/* harmony import */ var _mol_plugin_behavior_dynamic_representation__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../mol-plugin/behavior/dynamic/representation */ "./lib/mol-plugin/behavior/dynamic/representation.js");
/* harmony import */ var _mol_theme_label__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../mol-theme/label */ "./lib/mol-theme/label.js");
/* harmony import */ var _mol_util_binding__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../../mol-util/binding */ "./lib/mol-util/binding.js");
/* harmony import */ var _mol_util_memoize__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../../mol-util/memoize */ "./lib/mol-util/memoize.js");
/* harmony import */ var _base__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ../base */ "./lib/mol-plugin-ui/base.js");
/* harmony import */ var _controls_action_menu__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ../controls/action-menu */ "./lib/mol-plugin-ui/controls/action-menu.js");
/* harmony import */ var _controls_common__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ../controls/common */ "./lib/mol-plugin-ui/controls/common.js");
/* harmony import */ var _controls_icons__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ../controls/icons */ "./lib/mol-plugin-ui/controls/icons.js");
/**
 * Copyright (c) 2020 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */












function addSymmetryGroupEntries(entries, location, unitSymmetryGroup, granularity) {
    var idx = _mol_data_int__WEBPACK_IMPORTED_MODULE_2__["SortedArray"].indexOf(location.unit.elements, location.element);
    var base = _mol_model_structure__WEBPACK_IMPORTED_MODULE_3__["StructureElement"].Loci(location.structure, [
        { unit: location.unit, indices: _mol_data_int__WEBPACK_IMPORTED_MODULE_2__["OrderedSet"].ofSingleton(idx) }
    ]);
    var extended = granularity === 'residue'
        ? _mol_model_structure__WEBPACK_IMPORTED_MODULE_3__["StructureElement"].Loci.extendToWholeResidues(base)
        : _mol_model_structure__WEBPACK_IMPORTED_MODULE_3__["StructureElement"].Loci.extendToWholeChains(base);
    var name = _mol_model_structure__WEBPACK_IMPORTED_MODULE_3__["StructureProperties"].entity.pdbx_description(location).join(', ');
    for (var _i = 0, _a = unitSymmetryGroup.units; _i < _a.length; _i++) {
        var u = _a[_i];
        var loci = _mol_model_structure__WEBPACK_IMPORTED_MODULE_3__["StructureElement"].Loci(extended.structure, [
            { unit: u, indices: extended.elements[0].indices }
        ]);
        var label = Object(_mol_theme_label__WEBPACK_IMPORTED_MODULE_5__["lociLabel"])(loci, { reverse: true, hidePrefix: true, htmlStyling: false, granularity: granularity });
        if (!label)
            label = Object(_mol_theme_label__WEBPACK_IMPORTED_MODULE_5__["lociLabel"])(loci, { hidePrefix: false, htmlStyling: false });
        if (unitSymmetryGroup.units.length > 1) {
            label += " | " + loci.elements[0].unit.conformation.operator.name;
        }
        var item = { label: label, category: name, loci: loci };
        if (entries.has(name))
            entries.get(name).push(item);
        else
            entries.set(name, [item]);
    }
}
function getFocusEntries(structure) {
    var entityEntries = new Map();
    var l = _mol_model_structure__WEBPACK_IMPORTED_MODULE_3__["StructureElement"].Location.create(structure);
    for (var _i = 0, _a = structure.unitSymmetryGroups; _i < _a.length; _i++) {
        var ug = _a[_i];
        if (!_mol_model_structure__WEBPACK_IMPORTED_MODULE_3__["Unit"].isAtomic(ug.units[0]))
            continue;
        l.unit = ug.units[0];
        l.element = ug.elements[0];
        var isMultiChain = _mol_model_structure__WEBPACK_IMPORTED_MODULE_3__["Unit"].Traits.is(l.unit.traits, 1 /* MultiChain */);
        var entityType = _mol_model_structure__WEBPACK_IMPORTED_MODULE_3__["StructureProperties"].entity.type(l);
        var isNonPolymer = entityType === 'non-polymer';
        var isBranched = entityType === 'branched';
        var isBirdMolecule = !!_mol_model_structure__WEBPACK_IMPORTED_MODULE_3__["StructureProperties"].entity.prd_id(l);
        if (isBirdMolecule) {
            addSymmetryGroupEntries(entityEntries, l, ug, 'chain');
        }
        else if (isNonPolymer && !isMultiChain) {
            addSymmetryGroupEntries(entityEntries, l, ug, 'residue');
        }
        else if (isBranched || (isNonPolymer && isMultiChain)) {
            var u = l.unit;
            var residueIndex = u.model.atomicHierarchy.residueAtomSegments.index;
            var prev = -1;
            for (var i = 0, il = u.elements.length; i < il; ++i) {
                var eI = u.elements[i];
                var rI = residueIndex[eI];
                if (rI !== prev) {
                    l.element = eI;
                    addSymmetryGroupEntries(entityEntries, l, ug, 'residue');
                    prev = rI;
                }
            }
        }
    }
    var entries = [];
    entityEntries.forEach(function (e, name) {
        if (e.length === 1) {
            entries.push({ label: name + ": " + e[0].label, loci: e[0].loci });
        }
        else if (e.length < 2000) {
            entries.push.apply(entries, e);
        }
    });
    return entries;
}
var StructureFocusControls = /** @class */ (function (_super) {
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__extends"])(StructureFocusControls, _super);
    function StructureFocusControls() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = { isBusy: false, showAction: false };
        _this.getSelectionItems = Object(_mol_util_memoize__WEBPACK_IMPORTED_MODULE_7__["memoizeLatest"])(function (structures) {
            var _a;
            var presetItems = [];
            for (var _i = 0, structures_1 = structures; _i < structures_1.length; _i++) {
                var s = structures_1[_i];
                var d = (_a = s.cell.obj) === null || _a === void 0 ? void 0 : _a.data;
                if (d) {
                    var entries = getFocusEntries(d);
                    if (entries.length > 0) {
                        presetItems.push(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__spreadArrays"])([
                            _controls_action_menu__WEBPACK_IMPORTED_MODULE_9__["ActionMenu"].Header(d.label, { description: d.label })
                        ], _controls_action_menu__WEBPACK_IMPORTED_MODULE_9__["ActionMenu"].createItems(entries, {
                            label: function (f) { return f.label; },
                            category: function (f) { return f.category; },
                            description: function (f) { return f.label; }
                        })));
                    }
                }
            }
            return presetItems;
        });
        _this.selectAction = function (item, e) {
            if (!item || !_this.state.showAction) {
                _this.setState({ showAction: false });
                return;
            }
            var f = item.value;
            if (e === null || e === void 0 ? void 0 : e.shiftKey) {
                _this.plugin.managers.structure.focus.addFromLoci(f.loci);
            }
            else {
                _this.plugin.managers.structure.focus.set(f);
            }
            _this.focusCamera();
        };
        _this.toggleAction = function () { return _this.setState({ showAction: !_this.state.showAction }); };
        _this.focusCamera = function () {
            var current = _this.plugin.managers.structure.focus.current;
            if (current)
                _this.plugin.managers.camera.focusLoci(current.loci);
        };
        _this.clear = function () {
            _this.plugin.managers.structure.focus.clear();
            _this.plugin.managers.camera.reset();
        };
        _this.highlightCurrent = function () {
            var current = _this.plugin.managers.structure.focus.current;
            if (current)
                _this.plugin.managers.interactivity.lociHighlights.highlightOnly({ loci: current.loci }, false);
        };
        _this.clearHighlights = function () {
            _this.plugin.managers.interactivity.lociHighlights.clearHighlights();
        };
        return _this;
    }
    StructureFocusControls.prototype.componentDidMount = function () {
        var _this = this;
        this.subscribe(this.plugin.managers.structure.focus.behaviors.current, function (c) {
            // clear the memo cache
            _this.getSelectionItems([]);
            _this.forceUpdate();
        });
        this.subscribe(this.plugin.managers.structure.focus.events.historyUpdated, function (c) {
            _this.forceUpdate();
        });
        this.subscribe(this.plugin.behaviors.state.isBusy, function (v) {
            _this.setState({ isBusy: v, showAction: false });
        });
    };
    Object.defineProperty(StructureFocusControls.prototype, "isDisabled", {
        get: function () {
            return this.state.isBusy || this.actionItems.length === 0;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(StructureFocusControls.prototype, "actionItems", {
        get: function () {
            var historyItems = [];
            var history = this.plugin.managers.structure.focus.history;
            if (history.length > 0) {
                historyItems.push(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__spreadArrays"])([
                    _controls_action_menu__WEBPACK_IMPORTED_MODULE_9__["ActionMenu"].Header('History', { description: 'Previously focused on items.' })
                ], _controls_action_menu__WEBPACK_IMPORTED_MODULE_9__["ActionMenu"].createItems(history, {
                    label: function (f) { return f.label; },
                    description: function (f) {
                        return f.category && f.label !== f.category
                            ? f.category + " | " + f.label
                            : f.label;
                    }
                })));
            }
            var presetItems = this.getSelectionItems(this.plugin.managers.structure.hierarchy.selection.structures);
            if (presetItems.length === 1) {
                var item = presetItems[0];
                var header = item[0];
                header.initiallyExpanded = true;
            }
            var items = [];
            if (presetItems.length > 0)
                items.push.apply(items, presetItems);
            if (historyItems.length > 0)
                items.push.apply(items, historyItems);
            return items;
        },
        enumerable: false,
        configurable: true
    });
    StructureFocusControls.prototype.getToggleBindingLabel = function () {
        var _a;
        var t = this.plugin.state.behaviors.transforms.get(_mol_plugin_behavior_dynamic_representation__WEBPACK_IMPORTED_MODULE_4__["FocusLoci"].id);
        if (!t)
            return '';
        var binding = (_a = t.params) === null || _a === void 0 ? void 0 : _a.bindings.clickFocus;
        if (!binding || _mol_util_binding__WEBPACK_IMPORTED_MODULE_6__["Binding"].isEmpty(binding))
            return '';
        return _mol_util_binding__WEBPACK_IMPORTED_MODULE_6__["Binding"].formatTriggers(binding);
    };
    StructureFocusControls.prototype.render = function () {
        var current = this.plugin.managers.structure.focus.current;
        var label = (current === null || current === void 0 ? void 0 : current.label) || 'Nothing Focused';
        var title = 'Click to Center Camera';
        if (!current) {
            title = 'Select focus using the menu';
            var binding = this.getToggleBindingLabel();
            if (binding) {
                title += "\nor use '" + binding + "' on element";
            }
        }
        return react__WEBPACK_IMPORTED_MODULE_1__["createElement"](react__WEBPACK_IMPORTED_MODULE_1__["Fragment"], null,
            react__WEBPACK_IMPORTED_MODULE_1__["createElement"]("div", { className: 'msp-flex-row' },
                react__WEBPACK_IMPORTED_MODULE_1__["createElement"](_controls_common__WEBPACK_IMPORTED_MODULE_10__["Button"], { noOverflow: true, onClick: this.focusCamera, title: title, onMouseEnter: this.highlightCurrent, onMouseLeave: this.clearHighlights, disabled: this.isDisabled || !current, style: { textAlignLast: current ? 'left' : void 0 } }, label),
                current && react__WEBPACK_IMPORTED_MODULE_1__["createElement"](_controls_common__WEBPACK_IMPORTED_MODULE_10__["IconButton"], { svg: _controls_icons__WEBPACK_IMPORTED_MODULE_11__["CancelOutlinedSvg"], onClick: this.clear, title: 'Clear', className: 'msp-form-control', flex: true, disabled: this.isDisabled }),
                react__WEBPACK_IMPORTED_MODULE_1__["createElement"](_controls_common__WEBPACK_IMPORTED_MODULE_10__["ToggleButton"], { icon: _controls_icons__WEBPACK_IMPORTED_MODULE_11__["CenterFocusStrongSvg"], title: 'Select a focus target to center on an show its surroundings. Hold shift to focus on multiple targets.', toggle: this.toggleAction, isSelected: this.state.showAction, disabled: this.isDisabled, style: { flex: '0 0 40px', padding: 0 } })),
            this.state.showAction && react__WEBPACK_IMPORTED_MODULE_1__["createElement"](_controls_action_menu__WEBPACK_IMPORTED_MODULE_9__["ActionMenu"], { items: this.actionItems, onSelect: this.selectAction }));
    };
    return StructureFocusControls;
}(_base__WEBPACK_IMPORTED_MODULE_8__["PluginUIComponent"]));

//# sourceMappingURL=focus.js.map

/***/ }),

/***/ "./lib/mol-plugin-ui/structure/generic.js":
/*!************************************************!*\
  !*** ./lib/mol-plugin-ui/structure/generic.js ***!
  \************************************************/
/*! exports provided: GenericEntryListControls, GenericEntry */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "GenericEntryListControls", function() { return GenericEntryListControls; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "GenericEntry", function() { return GenericEntry; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! react */ "./node_modules/react/index.js");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _mol_plugin_commands__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../mol-plugin/commands */ "./lib/mol-plugin/commands.js");
/* harmony import */ var _mol_state__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../mol-state */ "./lib/mol-state/index.js");
/* harmony import */ var _base__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../base */ "./lib/mol-plugin-ui/base.js");
/* harmony import */ var _controls_common__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../controls/common */ "./lib/mol-plugin-ui/controls/common.js");
/* harmony import */ var _state_update_transform__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../state/update-transform */ "./lib/mol-plugin-ui/state/update-transform.js");
/* harmony import */ var _controls_icons__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../controls/icons */ "./lib/mol-plugin-ui/controls/icons.js");
/**
 * Copyright (c) 2020 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 * @author David Sehnal <david.sehnal@gmail.com>
 */








var GenericEntryListControls = /** @class */ (function (_super) {
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__extends"])(GenericEntryListControls, _super);
    function GenericEntryListControls() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(GenericEntryListControls.prototype, "current", {
        get: function () {
            return this.plugin.managers.structure.hierarchy.behaviors.selection;
        },
        enumerable: false,
        configurable: true
    });
    GenericEntryListControls.prototype.componentDidMount = function () {
        var _this = this;
        this.subscribe(this.current, function () { return _this.forceUpdate(); });
    };
    Object.defineProperty(GenericEntryListControls.prototype, "unitcell", {
        get: function () {
            var _a;
            var selection = this.plugin.managers.structure.hierarchy.selection;
            if (selection.structures.length === 0)
                return null;
            var refs = [];
            for (var _i = 0, _b = selection.structures; _i < _b.length; _i++) {
                var s = _b[_i];
                var model = s.model;
                if ((model === null || model === void 0 ? void 0 : model.unitcell) && ((_a = model.unitcell) === null || _a === void 0 ? void 0 : _a.cell.obj))
                    refs.push(model.unitcell);
            }
            if (refs.length === 0)
                return null;
            return react__WEBPACK_IMPORTED_MODULE_1__["createElement"](GenericEntry, { refs: refs, labelMultiple: 'Unit Cells' });
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(GenericEntryListControls.prototype, "customControls", {
        get: function () {
            var _this = this;
            var controls = [];
            this.plugin.genericRepresentationControls.forEach(function (provider, key) {
                var _a = provider(_this.plugin.managers.structure.hierarchy.selection), refs = _a[0], labelMultiple = _a[1];
                if (refs.length > 0) {
                    controls.push(react__WEBPACK_IMPORTED_MODULE_1__["createElement"]("div", { key: key },
                        react__WEBPACK_IMPORTED_MODULE_1__["createElement"](GenericEntry, { refs: refs, labelMultiple: labelMultiple })));
                }
            });
            return controls.length > 0 ? controls : null;
        },
        enumerable: false,
        configurable: true
    });
    GenericEntryListControls.prototype.render = function () {
        return react__WEBPACK_IMPORTED_MODULE_1__["createElement"](react__WEBPACK_IMPORTED_MODULE_1__["Fragment"], null,
            react__WEBPACK_IMPORTED_MODULE_1__["createElement"]("div", { style: { marginTop: '6px' } },
                this.unitcell,
                this.customControls));
    };
    return GenericEntryListControls;
}(_base__WEBPACK_IMPORTED_MODULE_4__["PurePluginUIComponent"]));

var GenericEntry = /** @class */ (function (_super) {
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__extends"])(GenericEntry, _super);
    function GenericEntry() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = { showOptions: false };
        _this.toggleVisibility = function (e) {
            e.preventDefault();
            _this.plugin.managers.structure.hierarchy.toggleVisibility(_this.props.refs);
            e.currentTarget.blur();
        };
        _this.highlight = function (e) {
            e.preventDefault();
            if (!_this.pivot.cell.parent)
                return;
            _mol_plugin_commands__WEBPACK_IMPORTED_MODULE_2__["PluginCommands"].Interactivity.Object.Highlight(_this.plugin, {
                state: _this.pivot.cell.parent,
                ref: _this.props.refs.map(function (c) { return c.cell.transform.ref; })
            });
        };
        _this.clearHighlight = function (e) {
            e.preventDefault();
            _mol_plugin_commands__WEBPACK_IMPORTED_MODULE_2__["PluginCommands"].Interactivity.ClearHighlights(_this.plugin);
        };
        _this.focus = function (e) {
            var _a;
            e.preventDefault();
            var allHidden = true;
            for (var _i = 0, _b = _this.props.refs; _i < _b.length; _i++) {
                var uc = _b[_i];
                if (!uc.cell.state.isHidden) {
                    allHidden = false;
                    break;
                }
            }
            if (allHidden) {
                _this.plugin.managers.structure.hierarchy.toggleVisibility(_this.props.refs, 'show');
            }
            var loci = [];
            for (var _c = 0, _d = _this.props.refs; _c < _d.length; _c++) {
                var uc = _d[_c];
                if (uc.cell.state.isHidden) {
                    continue;
                }
                var l = (_a = uc.cell.obj) === null || _a === void 0 ? void 0 : _a.data.repr.getLoci();
                if (l)
                    loci.push(l);
            }
            _this.plugin.managers.camera.focusLoci(loci);
        };
        _this.toggleOptions = function () { return _this.setState({ showOptions: !_this.state.showOptions }); };
        return _this;
    }
    GenericEntry.prototype.componentDidMount = function () {
        var _this = this;
        this.subscribe(this.plugin.state.events.cell.stateUpdated, function (e) {
            var _a;
            if (_mol_state__WEBPACK_IMPORTED_MODULE_3__["State"].ObjectEvent.isCell(e, (_a = _this.pivot) === null || _a === void 0 ? void 0 : _a.cell))
                _this.forceUpdate();
        });
    };
    Object.defineProperty(GenericEntry.prototype, "pivot", {
        get: function () { return this.props.refs[0]; },
        enumerable: false,
        configurable: true
    });
    GenericEntry.prototype.render = function () {
        var _a = this.props, refs = _a.refs, labelMultiple = _a.labelMultiple;
        if (refs.length === 0)
            return null;
        var pivot = refs[0];
        var label, description;
        if (refs.length === 1) {
            var obj = pivot.cell.obj;
            if (!obj)
                return null;
            label = obj === null || obj === void 0 ? void 0 : obj.label;
            description = obj === null || obj === void 0 ? void 0 : obj.description;
        }
        else {
            label = refs.length + " " + (labelMultiple || 'Objects');
        }
        return react__WEBPACK_IMPORTED_MODULE_1__["createElement"](react__WEBPACK_IMPORTED_MODULE_1__["Fragment"], null,
            react__WEBPACK_IMPORTED_MODULE_1__["createElement"]("div", { className: 'msp-flex-row' },
                react__WEBPACK_IMPORTED_MODULE_1__["createElement"]("button", { className: 'msp-form-control msp-control-button-label', title: label + ". Click to focus.", onClick: this.focus, onMouseEnter: this.highlight, onMouseLeave: this.clearHighlight, style: { textAlign: 'left' } },
                    label,
                    " ",
                    react__WEBPACK_IMPORTED_MODULE_1__["createElement"]("small", null, description)),
                react__WEBPACK_IMPORTED_MODULE_1__["createElement"](_controls_common__WEBPACK_IMPORTED_MODULE_5__["IconButton"], { svg: pivot.cell.state.isHidden ? _controls_icons__WEBPACK_IMPORTED_MODULE_7__["VisibilityOffOutlinedSvg"] : _controls_icons__WEBPACK_IMPORTED_MODULE_7__["VisibilityOutlinedSvg"], toggleState: false, className: 'msp-form-control', onClick: this.toggleVisibility, title: "" + (pivot.cell.state.isHidden ? 'Show' : 'Hide'), small: true, flex: true }),
                refs.length === 1 && react__WEBPACK_IMPORTED_MODULE_1__["createElement"](_controls_common__WEBPACK_IMPORTED_MODULE_5__["IconButton"], { svg: _controls_icons__WEBPACK_IMPORTED_MODULE_7__["MoreHorizSvg"], className: 'msp-form-control', onClick: this.toggleOptions, title: 'Options', toggleState: this.state.showOptions, flex: true })),
            (refs.length === 1 && this.state.showOptions && pivot.cell.parent) && react__WEBPACK_IMPORTED_MODULE_1__["createElement"](react__WEBPACK_IMPORTED_MODULE_1__["Fragment"], null,
                react__WEBPACK_IMPORTED_MODULE_1__["createElement"]("div", { className: 'msp-control-offset' },
                    react__WEBPACK_IMPORTED_MODULE_1__["createElement"](_state_update_transform__WEBPACK_IMPORTED_MODULE_6__["UpdateTransformControl"], { state: pivot.cell.parent, transform: pivot.cell.transform, customHeader: 'none', autoHideApply: true }))));
    };
    return GenericEntry;
}(_base__WEBPACK_IMPORTED_MODULE_4__["PurePluginUIComponent"]));

//# sourceMappingURL=generic.js.map

/***/ }),

/***/ "./lib/mol-plugin-ui/structure/measurements.js":
/*!*****************************************************!*\
  !*** ./lib/mol-plugin-ui/structure/measurements.js ***!
  \*****************************************************/
/*! exports provided: StructureMeasurementsControls, MeasurementList, MeasurementControls */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "StructureMeasurementsControls", function() { return StructureMeasurementsControls; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MeasurementList", function() { return MeasurementList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MeasurementControls", function() { return MeasurementControls; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! react */ "./node_modules/react/index.js");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _mol_model_loci__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../mol-model/loci */ "./lib/mol-model/loci.js");
/* harmony import */ var _mol_plugin_state_manager_structure_measurement__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../mol-plugin-state/manager/structure/measurement */ "./lib/mol-plugin-state/manager/structure/measurement.js");
/* harmony import */ var _mol_plugin_commands__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../mol-plugin/commands */ "./lib/mol-plugin/commands.js");
/* harmony import */ var _mol_theme_label__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../mol-theme/label */ "./lib/mol-theme/label.js");
/* harmony import */ var _base__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../base */ "./lib/mol-plugin-ui/base.js");
/* harmony import */ var _controls_action_menu__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../controls/action-menu */ "./lib/mol-plugin-ui/controls/action-menu.js");
/* harmony import */ var _controls_common__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ../controls/common */ "./lib/mol-plugin-ui/controls/common.js");
/* harmony import */ var _controls_icons__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ../controls/icons */ "./lib/mol-plugin-ui/controls/icons.js");
/* harmony import */ var _controls_parameters__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ../controls/parameters */ "./lib/mol-plugin-ui/controls/parameters.js");
/* harmony import */ var _state_update_transform__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ../state/update-transform */ "./lib/mol-plugin-ui/state/update-transform.js");
/* harmony import */ var _selection__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! ./selection */ "./lib/mol-plugin-ui/structure/selection.js");
/**
 * Copyright (c) 2020 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 * @author David Sehnal <david.sehnal@gmail.com>
 */













// TODO details, options (e.g. change text for labels)
var StructureMeasurementsControls = /** @class */ (function (_super) {
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__extends"])(StructureMeasurementsControls, _super);
    function StructureMeasurementsControls() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    StructureMeasurementsControls.prototype.defaultState = function () {
        return {
            isCollapsed: false,
            header: 'Measurements',
            brand: { accent: 'gray', svg: _controls_icons__WEBPACK_IMPORTED_MODULE_9__["PencilRulerSvg"] }
        };
    };
    StructureMeasurementsControls.prototype.renderControls = function () {
        return react__WEBPACK_IMPORTED_MODULE_1__["createElement"](react__WEBPACK_IMPORTED_MODULE_1__["Fragment"], null,
            react__WEBPACK_IMPORTED_MODULE_1__["createElement"](MeasurementControls, null),
            react__WEBPACK_IMPORTED_MODULE_1__["createElement"](MeasurementList, null));
    };
    return StructureMeasurementsControls;
}(_base__WEBPACK_IMPORTED_MODULE_6__["CollapsableControls"]));

var MeasurementList = /** @class */ (function (_super) {
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__extends"])(MeasurementList, _super);
    function MeasurementList() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    MeasurementList.prototype.componentDidMount = function () {
        var _this = this;
        this.subscribe(this.plugin.managers.structure.measurement.behaviors.state, function () {
            _this.forceUpdate();
        });
    };
    MeasurementList.prototype.renderGroup = function (cells, header) {
        var group = [];
        for (var _a = 0, cells_1 = cells; _a < cells_1.length; _a++) {
            var cell = cells_1[_a];
            if (cell.obj)
                group.push(react__WEBPACK_IMPORTED_MODULE_1__["createElement"](MeasurementEntry, { key: cell.obj.id, cell: cell }));
        }
        return group.length ? react__WEBPACK_IMPORTED_MODULE_1__["createElement"](_controls_common__WEBPACK_IMPORTED_MODULE_8__["ExpandGroup"], { header: header, initiallyExpanded: true }, group) : null;
    };
    MeasurementList.prototype.render = function () {
        var measurements = this.plugin.managers.structure.measurement.state;
        return react__WEBPACK_IMPORTED_MODULE_1__["createElement"]("div", { style: { marginTop: '6px' } },
            this.renderGroup(measurements.labels, 'Labels'),
            this.renderGroup(measurements.distances, 'Distances'),
            this.renderGroup(measurements.angles, 'Angles'),
            this.renderGroup(measurements.dihedrals, 'Dihedrals'));
    };
    return MeasurementList;
}(_base__WEBPACK_IMPORTED_MODULE_6__["PurePluginUIComponent"]));

var MeasurementControls = /** @class */ (function (_super) {
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__extends"])(MeasurementControls, _super);
    function MeasurementControls() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = { isBusy: false, action: void 0 };
        _this.measureDistance = function () {
            var loci = _this.plugin.managers.structure.selection.additionsHistory;
            _this.plugin.managers.structure.measurement.addDistance(loci[0].loci, loci[1].loci);
        };
        _this.measureAngle = function () {
            var loci = _this.plugin.managers.structure.selection.additionsHistory;
            _this.plugin.managers.structure.measurement.addAngle(loci[0].loci, loci[1].loci, loci[2].loci);
        };
        _this.measureDihedral = function () {
            var loci = _this.plugin.managers.structure.selection.additionsHistory;
            _this.plugin.managers.structure.measurement.addDihedral(loci[0].loci, loci[1].loci, loci[2].loci, loci[3].loci);
        };
        _this.addLabel = function () {
            var loci = _this.plugin.managers.structure.selection.additionsHistory;
            _this.plugin.managers.structure.measurement.addLabel(loci[0].loci);
        };
        _this.selectAction = function (item) {
            _this.toggleAdd();
            if (!item)
                return;
            (item === null || item === void 0 ? void 0 : item.value)();
        };
        _this.toggleAdd = function () { return _this.setState({ action: _this.state.action === 'add' ? void 0 : 'add' }); };
        _this.toggleOptions = function () { return _this.setState({ action: _this.state.action === 'options' ? void 0 : 'options' }); };
        return _this;
    }
    MeasurementControls.prototype.componentDidMount = function () {
        var _this = this;
        this.subscribe(this.selection.events.additionsHistoryUpdated, function () {
            _this.forceUpdate();
        });
        this.subscribe(this.plugin.behaviors.state.isBusy, function (v) {
            _this.setState({ isBusy: v });
        });
    };
    Object.defineProperty(MeasurementControls.prototype, "selection", {
        get: function () {
            return this.plugin.managers.structure.selection;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(MeasurementControls.prototype, "actions", {
        get: function () {
            var history = this.selection.additionsHistory;
            var ret = [
                { kind: 'item', label: "Label " + (history.length === 0 ? ' (1 selection required)' : ' (1st selection)'), value: this.addLabel, disabled: history.length === 0 },
                { kind: 'item', label: "Distance " + (history.length < 2 ? ' (2 selections required)' : ' (top 2 selections)'), value: this.measureDistance, disabled: history.length < 2 },
                { kind: 'item', label: "Angle " + (history.length < 3 ? ' (3 selections required)' : ' (top 3 selections)'), value: this.measureAngle, disabled: history.length < 3 },
                { kind: 'item', label: "Dihedral " + (history.length < 4 ? ' (4 selections required)' : ' (top 4 selections)'), value: this.measureDihedral, disabled: history.length < 4 },
            ];
            return ret;
        },
        enumerable: false,
        configurable: true
    });
    MeasurementControls.prototype.highlight = function (loci) {
        this.plugin.managers.interactivity.lociHighlights.highlightOnly({ loci: loci }, false);
    };
    MeasurementControls.prototype.moveHistory = function (e, direction) {
        this.plugin.managers.structure.selection.modifyHistory(e, direction, 4);
    };
    MeasurementControls.prototype.focusLoci = function (loci) {
        this.plugin.managers.camera.focusLoci(loci);
    };
    MeasurementControls.prototype.historyEntry = function (e, idx) {
        var _this = this;
        var history = this.plugin.managers.structure.selection.additionsHistory;
        return react__WEBPACK_IMPORTED_MODULE_1__["createElement"]("div", { className: 'msp-flex-row', key: e.id },
            react__WEBPACK_IMPORTED_MODULE_1__["createElement"](_controls_common__WEBPACK_IMPORTED_MODULE_8__["Button"], { noOverflow: true, title: 'Click to focus. Hover to highlight.', onClick: function () { return _this.focusLoci(e.loci); }, style: { width: 'auto', textAlign: 'left' }, onMouseEnter: function () { return _this.highlight(e.loci); }, onMouseLeave: this.plugin.managers.interactivity.lociHighlights.clearHighlights },
                idx,
                ". ",
                react__WEBPACK_IMPORTED_MODULE_1__["createElement"]("span", { dangerouslySetInnerHTML: { __html: e.label } })),
            history.length > 1 && react__WEBPACK_IMPORTED_MODULE_1__["createElement"](_controls_common__WEBPACK_IMPORTED_MODULE_8__["IconButton"], { svg: _controls_icons__WEBPACK_IMPORTED_MODULE_9__["ArrowUpwardSvg"], small: true, className: 'msp-form-control', onClick: function () { return _this.moveHistory(e, 'up'); }, flex: '20px', title: 'Move up' }),
            history.length > 1 && react__WEBPACK_IMPORTED_MODULE_1__["createElement"](_controls_common__WEBPACK_IMPORTED_MODULE_8__["IconButton"], { svg: _controls_icons__WEBPACK_IMPORTED_MODULE_9__["ArrowDownwardSvg"], small: true, className: 'msp-form-control', onClick: function () { return _this.moveHistory(e, 'down'); }, flex: '20px', title: 'Move down' }),
            react__WEBPACK_IMPORTED_MODULE_1__["createElement"](_controls_common__WEBPACK_IMPORTED_MODULE_8__["IconButton"], { svg: _controls_icons__WEBPACK_IMPORTED_MODULE_9__["DeleteOutlinedSvg"], small: true, className: 'msp-form-control', onClick: function () { return _this.plugin.managers.structure.selection.modifyHistory(e, 'remove'); }, flex: true, title: 'Remove' }));
    };
    MeasurementControls.prototype.add = function () {
        var history = this.plugin.managers.structure.selection.additionsHistory;
        var entries = [];
        for (var i = 0, _i = Math.min(history.length, 4); i < _i; i++) {
            entries.push(this.historyEntry(history[i], i + 1));
        }
        return react__WEBPACK_IMPORTED_MODULE_1__["createElement"](react__WEBPACK_IMPORTED_MODULE_1__["Fragment"], null,
            react__WEBPACK_IMPORTED_MODULE_1__["createElement"](_controls_action_menu__WEBPACK_IMPORTED_MODULE_7__["ActionMenu"], { items: this.actions, onSelect: this.selectAction }),
            entries.length > 0 && react__WEBPACK_IMPORTED_MODULE_1__["createElement"]("div", { className: 'msp-control-offset' }, entries),
            entries.length === 0 && react__WEBPACK_IMPORTED_MODULE_1__["createElement"]("div", { className: 'msp-control-offset msp-help-text' },
                react__WEBPACK_IMPORTED_MODULE_1__["createElement"]("div", { className: 'msp-help-description' },
                    react__WEBPACK_IMPORTED_MODULE_1__["createElement"](_controls_icons__WEBPACK_IMPORTED_MODULE_9__["Icon"], { svg: _controls_icons__WEBPACK_IMPORTED_MODULE_9__["HelpOutlineSvg"], inline: true }),
                    "Add one or more selections (toggle ",
                    react__WEBPACK_IMPORTED_MODULE_1__["createElement"](_selection__WEBPACK_IMPORTED_MODULE_12__["ToggleSelectionModeButton"], { inline: true }),
                    " mode)")));
    };
    MeasurementControls.prototype.render = function () {
        return react__WEBPACK_IMPORTED_MODULE_1__["createElement"](react__WEBPACK_IMPORTED_MODULE_1__["Fragment"], null,
            react__WEBPACK_IMPORTED_MODULE_1__["createElement"]("div", { className: 'msp-flex-row' },
                react__WEBPACK_IMPORTED_MODULE_1__["createElement"](_controls_common__WEBPACK_IMPORTED_MODULE_8__["ToggleButton"], { icon: _controls_icons__WEBPACK_IMPORTED_MODULE_9__["AddSvg"], label: 'Add', toggle: this.toggleAdd, isSelected: this.state.action === 'add', disabled: this.state.isBusy, className: 'msp-btn-apply-simple' }),
                react__WEBPACK_IMPORTED_MODULE_1__["createElement"](_controls_common__WEBPACK_IMPORTED_MODULE_8__["ToggleButton"], { icon: _controls_icons__WEBPACK_IMPORTED_MODULE_9__["TuneSvg"], label: '', title: 'Options', toggle: this.toggleOptions, isSelected: this.state.action === 'options', disabled: this.state.isBusy, style: { flex: '0 0 40px', padding: 0 } })),
            this.state.action === 'add' && this.add(),
            this.state.action === 'options' && react__WEBPACK_IMPORTED_MODULE_1__["createElement"](MeasurementsOptions, null));
    };
    return MeasurementControls;
}(_base__WEBPACK_IMPORTED_MODULE_6__["PurePluginUIComponent"]));

var MeasurementsOptions = /** @class */ (function (_super) {
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__extends"])(MeasurementsOptions, _super);
    function MeasurementsOptions() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = { isDisabled: false };
        _this.changed = function (options) {
            _this.plugin.managers.structure.measurement.setOptions(options);
        };
        return _this;
    }
    MeasurementsOptions.prototype.componentDidMount = function () {
        var _this = this;
        this.subscribe(this.plugin.managers.structure.measurement.behaviors.state, function () {
            _this.forceUpdate();
        });
        this.subscribe(this.plugin.behaviors.state.isBusy, function (v) {
            _this.setState({ isDisabled: v });
        });
    };
    MeasurementsOptions.prototype.render = function () {
        var measurements = this.plugin.managers.structure.measurement.state;
        return react__WEBPACK_IMPORTED_MODULE_1__["createElement"]("div", { className: 'msp-control-offset' },
            react__WEBPACK_IMPORTED_MODULE_1__["createElement"](_controls_parameters__WEBPACK_IMPORTED_MODULE_10__["ParameterControls"], { params: _mol_plugin_state_manager_structure_measurement__WEBPACK_IMPORTED_MODULE_3__["StructureMeasurementParams"], values: measurements.options, onChangeValues: this.changed, isDisabled: this.state.isDisabled }));
    };
    return MeasurementsOptions;
}(_base__WEBPACK_IMPORTED_MODULE_6__["PurePluginUIComponent"]));
var MeasurementEntry = /** @class */ (function (_super) {
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__extends"])(MeasurementEntry, _super);
    function MeasurementEntry() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = { showUpdate: false };
        _this.delete = function () {
            _mol_plugin_commands__WEBPACK_IMPORTED_MODULE_4__["PluginCommands"].State.RemoveObject(_this.plugin, { state: _this.props.cell.parent, ref: _this.props.cell.transform.parent, removeParentGhosts: true });
        };
        _this.toggleVisibility = function (e) {
            e.preventDefault();
            _mol_plugin_commands__WEBPACK_IMPORTED_MODULE_4__["PluginCommands"].State.ToggleVisibility(_this.plugin, { state: _this.props.cell.parent, ref: _this.props.cell.transform.parent });
            e.currentTarget.blur();
        };
        _this.highlight = function () {
            var _a;
            var selections = _this.selections;
            if (!selections)
                return;
            _this.plugin.managers.interactivity.lociHighlights.clearHighlights();
            for (var _b = 0, _c = selections.data; _b < _c.length; _b++) {
                var d = _c[_b];
                _this.plugin.managers.interactivity.lociHighlights.highlight({ loci: d.loci }, false);
            }
            _this.plugin.managers.interactivity.lociHighlights.highlight({ loci: (_a = _this.props.cell.obj) === null || _a === void 0 ? void 0 : _a.data.repr.getLoci() }, false);
        };
        _this.clearHighlight = function () {
            _this.plugin.managers.interactivity.lociHighlights.clearHighlights();
        };
        _this.toggleUpdate = function () { return _this.setState({ showUpdate: !_this.state.showUpdate }); };
        _this.focus = function () {
            var selections = _this.selections;
            if (!selections)
                return;
            var sphere = _mol_model_loci__WEBPACK_IMPORTED_MODULE_2__["Loci"].getBundleBoundingSphere(toLociBundle(selections.data));
            if (sphere) {
                _this.plugin.managers.camera.focusSphere(sphere);
            }
        };
        _this.selectAction = function (item) {
            if (!item)
                return;
            _this.setState({ showUpdate: false });
            (item === null || item === void 0 ? void 0 : item.value)();
        };
        return _this;
    }
    MeasurementEntry.prototype.componentDidMount = function () {
        var _this = this;
        this.subscribe(this.plugin.state.events.cell.stateUpdated, function (e) {
            _this.forceUpdate();
        });
    };
    Object.defineProperty(MeasurementEntry.prototype, "selections", {
        get: function () {
            var _a;
            return (_a = this.props.cell.obj) === null || _a === void 0 ? void 0 : _a.data.source;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(MeasurementEntry.prototype, "label", {
        get: function () {
            var selections = this.selections;
            switch (selections === null || selections === void 0 ? void 0 : selections.data.length) {
                case 1: return Object(_mol_theme_label__WEBPACK_IMPORTED_MODULE_5__["lociLabel"])(selections.data[0].loci, { condensed: true });
                case 2: return Object(_mol_theme_label__WEBPACK_IMPORTED_MODULE_5__["distanceLabel"])(toLociBundle(selections.data), { condensed: true, unitLabel: this.plugin.managers.structure.measurement.state.options.distanceUnitLabel });
                case 3: return Object(_mol_theme_label__WEBPACK_IMPORTED_MODULE_5__["angleLabel"])(toLociBundle(selections.data), { condensed: true });
                case 4: return Object(_mol_theme_label__WEBPACK_IMPORTED_MODULE_5__["dihedralLabel"])(toLociBundle(selections.data), { condensed: true });
                default: return '';
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(MeasurementEntry.prototype, "actions", {
        get: function () {
            var _this = this;
            this.props.cell.sourceRef;
            return [_controls_action_menu__WEBPACK_IMPORTED_MODULE_7__["ActionMenu"].Item('Select This', function () { return _this.plugin.managers.structure.selection.fromSelections(_this.props.cell.sourceRef); }, { icon: _controls_icons__WEBPACK_IMPORTED_MODULE_9__["SetSvg"] })];
        },
        enumerable: false,
        configurable: true
    });
    MeasurementEntry.prototype.render = function () {
        var cell = this.props.cell;
        var obj = cell.obj;
        if (!obj)
            return null;
        return react__WEBPACK_IMPORTED_MODULE_1__["createElement"](react__WEBPACK_IMPORTED_MODULE_1__["Fragment"], null,
            react__WEBPACK_IMPORTED_MODULE_1__["createElement"]("div", { className: 'msp-flex-row', key: obj.id, onMouseEnter: this.highlight, onMouseLeave: this.clearHighlight },
                react__WEBPACK_IMPORTED_MODULE_1__["createElement"]("button", { className: 'msp-form-control msp-control-button-label msp-no-overflow', title: 'Click to focus. Hover to highlight.', onClick: this.focus, style: { width: 'auto', textAlign: 'left' } },
                    react__WEBPACK_IMPORTED_MODULE_1__["createElement"]("span", { dangerouslySetInnerHTML: { __html: this.label } })),
                react__WEBPACK_IMPORTED_MODULE_1__["createElement"](_controls_common__WEBPACK_IMPORTED_MODULE_8__["IconButton"], { svg: cell.state.isHidden ? _controls_icons__WEBPACK_IMPORTED_MODULE_9__["VisibilityOffOutlinedSvg"] : _controls_icons__WEBPACK_IMPORTED_MODULE_9__["VisibilityOutlinedSvg"], toggleState: false, small: true, className: 'msp-form-control', onClick: this.toggleVisibility, flex: true, title: cell.state.isHidden ? 'Show' : 'Hide' }),
                react__WEBPACK_IMPORTED_MODULE_1__["createElement"](_controls_common__WEBPACK_IMPORTED_MODULE_8__["IconButton"], { svg: _controls_icons__WEBPACK_IMPORTED_MODULE_9__["DeleteOutlinedSvg"], small: true, className: 'msp-form-control', onClick: this.delete, flex: true, title: 'Delete', toggleState: false }),
                react__WEBPACK_IMPORTED_MODULE_1__["createElement"](_controls_common__WEBPACK_IMPORTED_MODULE_8__["IconButton"], { svg: _controls_icons__WEBPACK_IMPORTED_MODULE_9__["MoreHorizSvg"], className: 'msp-form-control', onClick: this.toggleUpdate, flex: true, title: 'Actions', toggleState: this.state.showUpdate })),
            this.state.showUpdate && cell.parent && react__WEBPACK_IMPORTED_MODULE_1__["createElement"](react__WEBPACK_IMPORTED_MODULE_1__["Fragment"], null,
                react__WEBPACK_IMPORTED_MODULE_1__["createElement"]("div", { className: 'msp-accent-offset' },
                    react__WEBPACK_IMPORTED_MODULE_1__["createElement"](_controls_action_menu__WEBPACK_IMPORTED_MODULE_7__["ActionMenu"], { items: this.actions, onSelect: this.selectAction, noOffset: true }),
                    react__WEBPACK_IMPORTED_MODULE_1__["createElement"](_controls_common__WEBPACK_IMPORTED_MODULE_8__["ExpandGroup"], { header: 'Options', noOffset: true },
                        react__WEBPACK_IMPORTED_MODULE_1__["createElement"](_state_update_transform__WEBPACK_IMPORTED_MODULE_11__["UpdateTransformControl"], { state: cell.parent, transform: cell.transform, customHeader: 'none', autoHideApply: true })))));
    };
    return MeasurementEntry;
}(_base__WEBPACK_IMPORTED_MODULE_6__["PurePluginUIComponent"]));
function toLociBundle(data) {
    return { loci: data.map(function (d) { return d.loci; }) };
}
//# sourceMappingURL=measurements.js.map

/***/ }),

/***/ "./lib/mol-plugin-ui/structure/selection.js":
/*!**************************************************!*\
  !*** ./lib/mol-plugin-ui/structure/selection.js ***!
  \**************************************************/
/*! exports provided: ToggleSelectionModeButton, StructureSelectionActionsControls, StructureSelectionStatsControls */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ToggleSelectionModeButton", function() { return ToggleSelectionModeButton; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "StructureSelectionActionsControls", function() { return StructureSelectionActionsControls; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "StructureSelectionStatsControls", function() { return StructureSelectionStatsControls; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! react */ "./node_modules/react/index.js");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _mol_plugin_state_helpers_structure_selection_query__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../mol-plugin-state/helpers/structure-selection-query */ "./lib/mol-plugin-state/helpers/structure-selection-query.js");
/* harmony import */ var _mol_plugin_state_manager_interactivity__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../mol-plugin-state/manager/interactivity */ "./lib/mol-plugin-state/manager/interactivity.js");
/* harmony import */ var _mol_plugin_state_manager_structure_component__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../mol-plugin-state/manager/structure/component */ "./lib/mol-plugin-state/manager/structure/component.js");
/* harmony import */ var _mol_util_memoize__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../mol-util/memoize */ "./lib/mol-util/memoize.js");
/* harmony import */ var _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../../mol-util/param-definition */ "./lib/mol-util/param-definition.js");
/* harmony import */ var _mol_util_string__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../../mol-util/string */ "./lib/mol-util/string.js");
/* harmony import */ var _base__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ../base */ "./lib/mol-plugin-ui/base.js");
/* harmony import */ var _controls_action_menu__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ../controls/action-menu */ "./lib/mol-plugin-ui/controls/action-menu.js");
/* harmony import */ var _controls_common__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ../controls/common */ "./lib/mol-plugin-ui/controls/common.js");
/* harmony import */ var _controls_parameters__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ../controls/parameters */ "./lib/mol-plugin-ui/controls/parameters.js");
/* harmony import */ var _controls_icons__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! ../controls/icons */ "./lib/mol-plugin-ui/controls/icons.js");
/* harmony import */ var _components__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! ./components */ "./lib/mol-plugin-ui/structure/components.js");
/* harmony import */ var _viewport_help__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! ../viewport/help */ "./lib/mol-plugin-ui/viewport/help.js");
/**
 * Copyright (c) 2019-2020 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 * @author David Sehnal <david.sehnal@gmail.com>
 */















var ToggleSelectionModeButton = /** @class */ (function (_super) {
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__extends"])(ToggleSelectionModeButton, _super);
    function ToggleSelectionModeButton() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this._toggleSelMode = function () {
            _this.plugin.selectionMode = !_this.plugin.selectionMode;
        };
        return _this;
    }
    ToggleSelectionModeButton.prototype.componentDidMount = function () {
        var _this = this;
        this.subscribe(this.plugin.events.canvas3d.settingsUpdated, function () { return _this.forceUpdate(); });
        this.subscribe(this.plugin.layout.events.updated, function () { return _this.forceUpdate(); });
        this.subscribe(this.plugin.behaviors.interaction.selectionMode, function () { return _this.forceUpdate(); });
    };
    ToggleSelectionModeButton.prototype.render = function () {
        var style = this.props.inline
            ? { background: 'transparent', width: 'auto', height: 'auto', lineHeight: 'unset' }
            : { background: 'transparent' };
        return react__WEBPACK_IMPORTED_MODULE_1__["createElement"](_controls_common__WEBPACK_IMPORTED_MODULE_10__["IconButton"], { svg: _controls_icons__WEBPACK_IMPORTED_MODULE_12__["SelectionModeSvg"], onClick: this._toggleSelMode, title: 'Toggle Selection Mode', style: style, toggleState: this.plugin.selectionMode });
    };
    return ToggleSelectionModeButton;
}(_base__WEBPACK_IMPORTED_MODULE_8__["PurePluginUIComponent"]));

var StructureSelectionParams = {
    granularity: _mol_plugin_state_manager_interactivity__WEBPACK_IMPORTED_MODULE_3__["InteractivityManager"].Params.granularity,
};
var ActionHeader = new Map([
    ['add', 'Add/Union Selection'],
    ['remove', 'Remove/Subtract Selection'],
    ['intersect', 'Intersect Selection'],
    ['set', 'Set Selection']
]);
var StructureSelectionActionsControls = /** @class */ (function (_super) {
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__extends"])(StructureSelectionActionsControls, _super);
    function StructureSelectionActionsControls() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            action: void 0,
            isEmpty: true,
            isBusy: false,
            canUndo: false,
        };
        _this.set = function (modifier, selectionQuery) {
            _this.plugin.managers.structure.selection.fromSelectionQuery(modifier, selectionQuery, false);
        };
        _this.selectQuery = function (item, e) {
            if (!item || !_this.state.action) {
                _this.setState({ action: void 0 });
                return;
            }
            var q = _this.state.action;
            if (e === null || e === void 0 ? void 0 : e.shiftKey) {
                _this.set(q, item.value);
            }
            else {
                _this.setState({ action: void 0 }, function () {
                    _this.set(q, item.value);
                });
            }
        };
        _this.queriesItems = [];
        _this.queriesVersion = -1;
        _this.toggleAdd = _this.showAction('add');
        _this.toggleRemove = _this.showAction('remove');
        _this.toggleIntersect = _this.showAction('intersect');
        _this.toggleSet = _this.showAction('set');
        _this.toggleTheme = _this.showAction('theme');
        _this.toggleAddComponent = _this.showAction('add-component');
        _this.toggleHelp = _this.showAction('help');
        _this.setGranuality = function (_a) {
            var value = _a.value;
            _this.plugin.managers.interactivity.setProps({ granularity: value });
        };
        _this.turnOff = function () { return _this.plugin.selectionMode = false; };
        _this.undo = function () {
            var task = _this.plugin.state.data.undo();
            if (task)
                _this.plugin.runTask(task);
        };
        _this.subtract = function () {
            var sel = _this.plugin.managers.structure.hierarchy.getStructuresWithSelection();
            var components = [];
            for (var _i = 0, sel_1 = sel; _i < sel_1.length; _i++) {
                var s = sel_1[_i];
                components.push.apply(components, s.components);
            }
            if (components.length === 0)
                return;
            _this.plugin.managers.structure.component.modifyByCurrentSelection(components, 'subtract');
        };
        return _this;
    }
    StructureSelectionActionsControls.prototype.componentDidMount = function () {
        var _this = this;
        this.subscribe(this.plugin.managers.structure.hierarchy.behaviors.selection, function (c) {
            var isEmpty = c.hierarchy.structures.length === 0;
            if (_this.state.isEmpty !== isEmpty) {
                _this.setState({ isEmpty: isEmpty });
            }
            // trigger elementQueries and nonStandardResidueQueries recalculation
            _this.queriesVersion = -1;
            _this.forceUpdate();
        });
        this.subscribe(this.plugin.behaviors.state.isBusy, function (v) {
            _this.setState({ isBusy: v, action: void 0 });
        });
        this.subscribe(this.plugin.managers.interactivity.events.propsUpdated, function () {
            _this.forceUpdate();
        });
        this.subscribe(this.plugin.state.data.events.historyUpdated, function (_a) {
            var state = _a.state;
            _this.setState({ canUndo: state.canUndo });
        });
    };
    Object.defineProperty(StructureSelectionActionsControls.prototype, "isDisabled", {
        get: function () {
            return this.state.isBusy || this.state.isEmpty;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(StructureSelectionActionsControls.prototype, "structures", {
        get: function () {
            var _a;
            var structures = [];
            for (var _i = 0, _b = this.plugin.managers.structure.hierarchy.selection.structures; _i < _b.length; _i++) {
                var s = _b[_i];
                var structure = (_a = s.cell.obj) === null || _a === void 0 ? void 0 : _a.data;
                if (structure)
                    structures.push(structure);
            }
            return structures;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(StructureSelectionActionsControls.prototype, "queries", {
        get: function () {
            var registry = this.plugin.query.structure.registry;
            if (registry.version !== this.queriesVersion) {
                var structures = this.structures;
                var queries = Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__spreadArrays"])(registry.list, Object(_mol_plugin_state_helpers_structure_selection_query__WEBPACK_IMPORTED_MODULE_2__["getPolymerAndBranchedEntityQueries"])(structures), Object(_mol_plugin_state_helpers_structure_selection_query__WEBPACK_IMPORTED_MODULE_2__["getNonStandardResidueQueries"])(structures), Object(_mol_plugin_state_helpers_structure_selection_query__WEBPACK_IMPORTED_MODULE_2__["getElementQueries"])(structures)).sort(function (a, b) { return b.priority - a.priority; });
                this.queriesItems = _controls_action_menu__WEBPACK_IMPORTED_MODULE_9__["ActionMenu"].createItems(queries, {
                    filter: function (q) { return q !== _mol_plugin_state_helpers_structure_selection_query__WEBPACK_IMPORTED_MODULE_2__["StructureSelectionQueries"].current && !q.isHidden; },
                    label: function (q) { return q.label; },
                    category: function (q) { return q.category; },
                    description: function (q) { return q.description; }
                });
                this.queriesVersion = registry.version;
            }
            return this.queriesItems;
        },
        enumerable: false,
        configurable: true
    });
    StructureSelectionActionsControls.prototype.showAction = function (q) {
        var _this = this;
        return function () { return _this.setState({ action: _this.state.action === q ? void 0 : q }); };
    };
    StructureSelectionActionsControls.prototype.render = function () {
        var granularity = this.plugin.managers.interactivity.props.granularity;
        var undoTitle = this.state.canUndo
            ? "Undo " + this.plugin.state.data.latestUndoLabel
            : 'Some mistakes of the past can be undone.';
        return react__WEBPACK_IMPORTED_MODULE_1__["createElement"](react__WEBPACK_IMPORTED_MODULE_1__["Fragment"], null,
            react__WEBPACK_IMPORTED_MODULE_1__["createElement"]("div", { className: 'msp-flex-row', style: { background: 'none' } },
                react__WEBPACK_IMPORTED_MODULE_1__["createElement"](_controls_parameters__WEBPACK_IMPORTED_MODULE_11__["PureSelectControl"], { title: "Picking Level for selecting and highlighting", param: StructureSelectionParams.granularity, name: 'granularity', value: granularity, onChange: this.setGranuality, isDisabled: this.isDisabled }),
                react__WEBPACK_IMPORTED_MODULE_1__["createElement"](_controls_common__WEBPACK_IMPORTED_MODULE_10__["ToggleButton"], { icon: _controls_icons__WEBPACK_IMPORTED_MODULE_12__["UnionSvg"], title: ActionHeader.get('add') + ". Hold shift key to keep menu open.", toggle: this.toggleAdd, isSelected: this.state.action === 'add', disabled: this.isDisabled }),
                react__WEBPACK_IMPORTED_MODULE_1__["createElement"](_controls_common__WEBPACK_IMPORTED_MODULE_10__["ToggleButton"], { icon: _controls_icons__WEBPACK_IMPORTED_MODULE_12__["SubtractSvg"], title: ActionHeader.get('remove') + ". Hold shift key to keep menu open.", toggle: this.toggleRemove, isSelected: this.state.action === 'remove', disabled: this.isDisabled }),
                react__WEBPACK_IMPORTED_MODULE_1__["createElement"](_controls_common__WEBPACK_IMPORTED_MODULE_10__["ToggleButton"], { icon: _controls_icons__WEBPACK_IMPORTED_MODULE_12__["IntersectSvg"], title: ActionHeader.get('intersect') + ". Hold shift key to keep menu open.", toggle: this.toggleIntersect, isSelected: this.state.action === 'intersect', disabled: this.isDisabled }),
                react__WEBPACK_IMPORTED_MODULE_1__["createElement"](_controls_common__WEBPACK_IMPORTED_MODULE_10__["ToggleButton"], { icon: _controls_icons__WEBPACK_IMPORTED_MODULE_12__["SetSvg"], title: ActionHeader.get('set') + ". Hold shift key to keep menu open.", toggle: this.toggleSet, isSelected: this.state.action === 'set', disabled: this.isDisabled }),
                react__WEBPACK_IMPORTED_MODULE_1__["createElement"](_controls_common__WEBPACK_IMPORTED_MODULE_10__["ToggleButton"], { icon: _controls_icons__WEBPACK_IMPORTED_MODULE_12__["BrushSvg"], title: 'Apply Theme to Selection', toggle: this.toggleTheme, isSelected: this.state.action === 'theme', disabled: this.isDisabled, style: { marginLeft: '10px' } }),
                react__WEBPACK_IMPORTED_MODULE_1__["createElement"](_controls_common__WEBPACK_IMPORTED_MODULE_10__["ToggleButton"], { icon: _controls_icons__WEBPACK_IMPORTED_MODULE_12__["CubeOutlineSvg"], title: 'Create Component of Selection with Representation', toggle: this.toggleAddComponent, isSelected: this.state.action === 'add-component', disabled: this.isDisabled }),
                react__WEBPACK_IMPORTED_MODULE_1__["createElement"](_controls_common__WEBPACK_IMPORTED_MODULE_10__["IconButton"], { svg: _controls_icons__WEBPACK_IMPORTED_MODULE_12__["RemoveSvg"], title: 'Remove/subtract Selection from all Components', onClick: this.subtract, disabled: this.isDisabled }),
                react__WEBPACK_IMPORTED_MODULE_1__["createElement"](_controls_common__WEBPACK_IMPORTED_MODULE_10__["IconButton"], { svg: _controls_icons__WEBPACK_IMPORTED_MODULE_12__["RestoreSvg"], onClick: this.undo, disabled: !this.state.canUndo || this.isDisabled, title: undoTitle }),
                react__WEBPACK_IMPORTED_MODULE_1__["createElement"](_controls_common__WEBPACK_IMPORTED_MODULE_10__["ToggleButton"], { icon: _controls_icons__WEBPACK_IMPORTED_MODULE_12__["HelpOutlineSvg"], title: 'Show/hide help', toggle: this.toggleHelp, style: { marginLeft: '10px' }, isSelected: this.state.action === 'help' }),
                react__WEBPACK_IMPORTED_MODULE_1__["createElement"](_controls_common__WEBPACK_IMPORTED_MODULE_10__["IconButton"], { svg: _controls_icons__WEBPACK_IMPORTED_MODULE_12__["CancelOutlinedSvg"], title: 'Turn selection mode off', onClick: this.turnOff })),
            (this.state.action && this.state.action !== 'theme' && this.state.action !== 'add-component' && this.state.action !== 'help') && react__WEBPACK_IMPORTED_MODULE_1__["createElement"]("div", { className: 'msp-selection-viewport-controls-actions' },
                react__WEBPACK_IMPORTED_MODULE_1__["createElement"](_controls_action_menu__WEBPACK_IMPORTED_MODULE_9__["ActionMenu"], { header: ActionHeader.get(this.state.action), title: 'Click to close.', items: this.queries, onSelect: this.selectQuery, noOffset: true })),
            this.state.action === 'theme' && react__WEBPACK_IMPORTED_MODULE_1__["createElement"]("div", { className: 'msp-selection-viewport-controls-actions' },
                react__WEBPACK_IMPORTED_MODULE_1__["createElement"](_controls_common__WEBPACK_IMPORTED_MODULE_10__["ControlGroup"], { header: 'Theme', title: 'Click to close.', initialExpanded: true, hideExpander: true, hideOffset: true, onHeaderClick: this.toggleTheme, topRightIcon: _controls_icons__WEBPACK_IMPORTED_MODULE_12__["CloseSvg"] },
                    react__WEBPACK_IMPORTED_MODULE_1__["createElement"](ApplyThemeControls, { onApply: this.toggleTheme }))),
            this.state.action === 'add-component' && react__WEBPACK_IMPORTED_MODULE_1__["createElement"]("div", { className: 'msp-selection-viewport-controls-actions' },
                react__WEBPACK_IMPORTED_MODULE_1__["createElement"](_controls_common__WEBPACK_IMPORTED_MODULE_10__["ControlGroup"], { header: 'Add Component', title: 'Click to close.', initialExpanded: true, hideExpander: true, hideOffset: true, onHeaderClick: this.toggleAddComponent, topRightIcon: _controls_icons__WEBPACK_IMPORTED_MODULE_12__["CloseSvg"] },
                    react__WEBPACK_IMPORTED_MODULE_1__["createElement"](_components__WEBPACK_IMPORTED_MODULE_13__["AddComponentControls"], { onApply: this.toggleAddComponent, forSelection: true }))),
            this.state.action === 'help' && react__WEBPACK_IMPORTED_MODULE_1__["createElement"]("div", { className: 'msp-selection-viewport-controls-actions' },
                react__WEBPACK_IMPORTED_MODULE_1__["createElement"](_controls_common__WEBPACK_IMPORTED_MODULE_10__["ControlGroup"], { header: 'Help', title: 'Click to close.', initialExpanded: true, hideExpander: true, hideOffset: true, onHeaderClick: this.toggleHelp, topRightIcon: _controls_icons__WEBPACK_IMPORTED_MODULE_12__["CloseSvg"], maxHeight: '300px' },
                    react__WEBPACK_IMPORTED_MODULE_1__["createElement"](_viewport_help__WEBPACK_IMPORTED_MODULE_14__["HelpGroup"], { header: 'Selection Operations' },
                        react__WEBPACK_IMPORTED_MODULE_1__["createElement"](_viewport_help__WEBPACK_IMPORTED_MODULE_14__["HelpText"], null,
                            "Use ",
                            react__WEBPACK_IMPORTED_MODULE_1__["createElement"](_controls_icons__WEBPACK_IMPORTED_MODULE_12__["Icon"], { svg: _controls_icons__WEBPACK_IMPORTED_MODULE_12__["UnionSvg"], inline: true }),
                            " ",
                            react__WEBPACK_IMPORTED_MODULE_1__["createElement"](_controls_icons__WEBPACK_IMPORTED_MODULE_12__["Icon"], { svg: _controls_icons__WEBPACK_IMPORTED_MODULE_12__["SubtractSvg"], inline: true }),
                            " ",
                            react__WEBPACK_IMPORTED_MODULE_1__["createElement"](_controls_icons__WEBPACK_IMPORTED_MODULE_12__["Icon"], { svg: _controls_icons__WEBPACK_IMPORTED_MODULE_12__["IntersectSvg"], inline: true }),
                            " ",
                            react__WEBPACK_IMPORTED_MODULE_1__["createElement"](_controls_icons__WEBPACK_IMPORTED_MODULE_12__["Icon"], { svg: _controls_icons__WEBPACK_IMPORTED_MODULE_12__["SetSvg"], inline: true }),
                            " to modify the selection.")),
                    react__WEBPACK_IMPORTED_MODULE_1__["createElement"](_viewport_help__WEBPACK_IMPORTED_MODULE_14__["HelpGroup"], { header: 'Representation Operations' },
                        react__WEBPACK_IMPORTED_MODULE_1__["createElement"](_viewport_help__WEBPACK_IMPORTED_MODULE_14__["HelpText"], null,
                            "Use ",
                            react__WEBPACK_IMPORTED_MODULE_1__["createElement"](_controls_icons__WEBPACK_IMPORTED_MODULE_12__["Icon"], { svg: _controls_icons__WEBPACK_IMPORTED_MODULE_12__["BrushSvg"], inline: true }),
                            " ",
                            react__WEBPACK_IMPORTED_MODULE_1__["createElement"](_controls_icons__WEBPACK_IMPORTED_MODULE_12__["Icon"], { svg: _controls_icons__WEBPACK_IMPORTED_MODULE_12__["CubeOutlineSvg"], inline: true }),
                            " ",
                            react__WEBPACK_IMPORTED_MODULE_1__["createElement"](_controls_icons__WEBPACK_IMPORTED_MODULE_12__["Icon"], { svg: _controls_icons__WEBPACK_IMPORTED_MODULE_12__["RemoveSvg"], inline: true }),
                            " ",
                            react__WEBPACK_IMPORTED_MODULE_1__["createElement"](_controls_icons__WEBPACK_IMPORTED_MODULE_12__["Icon"], { svg: _controls_icons__WEBPACK_IMPORTED_MODULE_12__["RestoreSvg"], inline: true }),
                            " to color, create components, remove from components, or undo actions.")),
                    react__WEBPACK_IMPORTED_MODULE_1__["createElement"](_viewport_help__WEBPACK_IMPORTED_MODULE_14__["ViewportHelpContent"], { selectOnly: true }))));
    };
    return StructureSelectionActionsControls;
}(_base__WEBPACK_IMPORTED_MODULE_8__["PluginUIComponent"]));

var StructureSelectionStatsControls = /** @class */ (function (_super) {
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__extends"])(StructureSelectionStatsControls, _super);
    function StructureSelectionStatsControls() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            isEmpty: true,
            isBusy: false
        };
        _this.clear = function () { return _this.plugin.managers.interactivity.lociSelects.deselectAll(); };
        _this.focus = function () {
            if (_this.plugin.managers.structure.selection.stats.elementCount === 0)
                return;
            var sphere = _this.plugin.managers.structure.selection.getBoundary().sphere;
            _this.plugin.managers.camera.focusSphere(sphere);
        };
        _this.highlight = function (e) {
            _this.plugin.managers.interactivity.lociHighlights.clearHighlights();
            _this.plugin.managers.structure.selection.entries.forEach(function (e) {
                _this.plugin.managers.interactivity.lociHighlights.highlight({ loci: e.selection }, false);
            });
        };
        _this.clearHighlight = function () {
            _this.plugin.managers.interactivity.lociHighlights.clearHighlights();
        };
        return _this;
    }
    StructureSelectionStatsControls.prototype.componentDidMount = function () {
        var _this = this;
        this.subscribe(this.plugin.managers.structure.selection.events.changed, function () {
            _this.forceUpdate();
        });
        this.subscribe(this.plugin.managers.structure.hierarchy.behaviors.selection, function (c) {
            var isEmpty = c.structures.length === 0;
            if (_this.state.isEmpty !== isEmpty) {
                _this.setState({ isEmpty: isEmpty });
            }
        });
        this.subscribe(this.plugin.behaviors.state.isBusy, function (v) {
            _this.setState({ isBusy: v });
        });
    };
    Object.defineProperty(StructureSelectionStatsControls.prototype, "isDisabled", {
        get: function () {
            return this.state.isBusy || this.state.isEmpty;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(StructureSelectionStatsControls.prototype, "stats", {
        get: function () {
            var stats = this.plugin.managers.structure.selection.stats;
            if (stats.structureCount === 0 || stats.elementCount === 0) {
                return 'Nothing Selected';
            }
            else {
                return Object(_mol_util_string__WEBPACK_IMPORTED_MODULE_7__["stripTags"])(stats.label) + " Selected";
            }
        },
        enumerable: false,
        configurable: true
    });
    StructureSelectionStatsControls.prototype.render = function () {
        var stats = this.plugin.managers.structure.selection.stats;
        var empty = stats.structureCount === 0 || stats.elementCount === 0;
        if (empty && this.props.hideOnEmpty)
            return null;
        return react__WEBPACK_IMPORTED_MODULE_1__["createElement"](react__WEBPACK_IMPORTED_MODULE_1__["Fragment"], null,
            react__WEBPACK_IMPORTED_MODULE_1__["createElement"]("div", { className: 'msp-flex-row' },
                react__WEBPACK_IMPORTED_MODULE_1__["createElement"](_controls_common__WEBPACK_IMPORTED_MODULE_10__["Button"], { noOverflow: true, onClick: this.focus, title: 'Click to Focus Selection', disabled: empty, onMouseEnter: this.highlight, onMouseLeave: this.clearHighlight, style: { textAlignLast: !empty ? 'left' : void 0 } }, this.stats),
                !empty && react__WEBPACK_IMPORTED_MODULE_1__["createElement"](_controls_common__WEBPACK_IMPORTED_MODULE_10__["IconButton"], { svg: _controls_icons__WEBPACK_IMPORTED_MODULE_12__["CancelOutlinedSvg"], onClick: this.clear, title: 'Clear', className: 'msp-form-control', flex: true })));
    };
    return StructureSelectionStatsControls;
}(_base__WEBPACK_IMPORTED_MODULE_8__["PluginUIComponent"]));

var ApplyThemeControls = /** @class */ (function (_super) {
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__extends"])(ApplyThemeControls, _super);
    function ApplyThemeControls() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this._params = Object(_mol_util_memoize__WEBPACK_IMPORTED_MODULE_5__["memoizeLatest"])(function (pivot) { return _mol_plugin_state_manager_structure_component__WEBPACK_IMPORTED_MODULE_4__["StructureComponentManager"].getThemeParams(_this.plugin, pivot); });
        _this.state = { values: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_6__["ParamDefinition"].getDefaultValues(_this.params) };
        _this.apply = function () {
            var _a, _b;
            _this.plugin.managers.structure.component.applyTheme(_this.state.values, _this.plugin.managers.structure.hierarchy.current.structures);
            (_b = (_a = _this.props).onApply) === null || _b === void 0 ? void 0 : _b.call(_a);
        };
        _this.paramsChanged = function (values) { return _this.setState({ values: values }); };
        return _this;
    }
    Object.defineProperty(ApplyThemeControls.prototype, "params", {
        get: function () { return this._params(this.plugin.managers.structure.component.pivotStructure); },
        enumerable: false,
        configurable: true
    });
    ApplyThemeControls.prototype.render = function () {
        return react__WEBPACK_IMPORTED_MODULE_1__["createElement"](react__WEBPACK_IMPORTED_MODULE_1__["Fragment"], null,
            react__WEBPACK_IMPORTED_MODULE_1__["createElement"](_controls_parameters__WEBPACK_IMPORTED_MODULE_11__["ParameterControls"], { params: this.params, values: this.state.values, onChangeValues: this.paramsChanged }),
            react__WEBPACK_IMPORTED_MODULE_1__["createElement"](_controls_common__WEBPACK_IMPORTED_MODULE_10__["Button"], { icon: _controls_icons__WEBPACK_IMPORTED_MODULE_12__["BrushSvg"], className: 'msp-btn-commit msp-btn-commit-on', onClick: this.apply, style: { marginTop: '1px' } }, "Apply Theme"));
    };
    return ApplyThemeControls;
}(_base__WEBPACK_IMPORTED_MODULE_8__["PurePluginUIComponent"]));
//# sourceMappingURL=selection.js.map

/***/ }),

/***/ "./lib/mol-plugin-ui/structure/source.js":
/*!***********************************************!*\
  !*** ./lib/mol-plugin-ui/structure/source.js ***!
  \***********************************************/
/*! exports provided: StructureSourceControls */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "StructureSourceControls", function() { return StructureSourceControls; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! react */ "./node_modules/react/index.js");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _mol_plugin_state_transforms__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../mol-plugin-state/transforms */ "./lib/mol-plugin-state/transforms.js");
/* harmony import */ var _base__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../base */ "./lib/mol-plugin-ui/base.js");
/* harmony import */ var _controls_action_menu__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../controls/action-menu */ "./lib/mol-plugin-ui/controls/action-menu.js");
/* harmony import */ var _controls_common__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../controls/common */ "./lib/mol-plugin-ui/controls/common.js");
/* harmony import */ var _controls_parameters__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../controls/parameters */ "./lib/mol-plugin-ui/controls/parameters.js");
/* harmony import */ var _focus__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ./focus */ "./lib/mol-plugin-ui/structure/focus.js");
/* harmony import */ var _state_update_transform__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ../state/update-transform */ "./lib/mol-plugin-ui/state/update-transform.js");
/* harmony import */ var _selection__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ./selection */ "./lib/mol-plugin-ui/structure/selection.js");
/* harmony import */ var _mol_state__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ../../mol-state */ "./lib/mol-state/index.js");
/* harmony import */ var _controls_icons__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ../controls/icons */ "./lib/mol-plugin-ui/controls/icons.js");
/* harmony import */ var _mol_model_structure__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! ../../mol-model/structure */ "./lib/mol-model/structure.js");
/**
 * Copyright (c) 2020 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author David Sehnal <david.sehnal@gmail.com>
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */













var StructureSourceControls = /** @class */ (function (_super) {
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__extends"])(StructureSourceControls, _super);
    function StructureSourceControls() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.item = function (ref) {
            var _a, _b, _c, _d, _e, _f, _g, _h, _j;
            var selected = _this.plugin.managers.structure.hierarchy.seletionSet;
            var label;
            switch (ref.kind) {
                case 'model': {
                    var model = (_a = ref.cell.obj) === null || _a === void 0 ? void 0 : _a.data;
                    if (model && _mol_model_structure__WEBPACK_IMPORTED_MODULE_12__["Model"].TrajectoryInfo.get(model).size > 1) {
                        label = ((_b = ref.cell.obj) === null || _b === void 0 ? void 0 : _b.data.entryId) + " | Model " + (_mol_model_structure__WEBPACK_IMPORTED_MODULE_12__["Model"].TrajectoryInfo.get(model).index + 1) + " of " + _mol_model_structure__WEBPACK_IMPORTED_MODULE_12__["Model"].TrajectoryInfo.get(model).size;
                    }
                    label = ((_c = ref.cell.obj) === null || _c === void 0 ? void 0 : _c.data.entryId) + " | " + ((_d = ref.cell.obj) === null || _d === void 0 ? void 0 : _d.label);
                    break;
                }
                case 'structure': {
                    var model = (_e = ref.cell.obj) === null || _e === void 0 ? void 0 : _e.data.models[0];
                    if (model && _mol_model_structure__WEBPACK_IMPORTED_MODULE_12__["Model"].TrajectoryInfo.get(model).size > 1) {
                        label = model.entryId + " | " + ((_f = ref.cell.obj) === null || _f === void 0 ? void 0 : _f.label) + " (Model " + (_mol_model_structure__WEBPACK_IMPORTED_MODULE_12__["Model"].TrajectoryInfo.get(model).index + 1) + " of " + _mol_model_structure__WEBPACK_IMPORTED_MODULE_12__["Model"].TrajectoryInfo.get(model).size + ")";
                        break;
                    }
                    else if (model) {
                        label = model.entryId + " | " + ((_g = ref.cell.obj) === null || _g === void 0 ? void 0 : _g.label);
                        break;
                    }
                    else {
                        label = "" + ((_h = ref.cell.obj) === null || _h === void 0 ? void 0 : _h.label);
                        break;
                    }
                }
                default:
                    label = (_j = ref.cell.obj) === null || _j === void 0 ? void 0 : _j.label;
                    break;
            }
            var item = { kind: 'item', label: label || ref.kind, selected: selected.has(ref.cell.transform.ref), value: [ref] };
            return item;
        };
        _this.getTrajectoryItems = function (t) {
            var _a;
            if (t.models.length === 0)
                return _this.item(t);
            return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__spreadArrays"])([_controls_action_menu__WEBPACK_IMPORTED_MODULE_4__["ActionMenu"].Header((_a = t.cell.obj) === null || _a === void 0 ? void 0 : _a.label)], t.models.map(_this.getModelItems));
        };
        _this.getModelItems = function (m) {
            var _a, _b, _c;
            if (m.structures.length === 0)
                return _this.item(m);
            if (m.structures.length === 1) {
                var selected = _this.plugin.managers.structure.hierarchy.seletionSet;
                var ref = m.structures[0];
                return { label: ((_a = m.cell.obj) === null || _a === void 0 ? void 0 : _a.label) + " | " + ((_b = ref.cell.obj) === null || _b === void 0 ? void 0 : _b.label), selected: selected.has(ref.cell.transform.ref), value: [m, ref] };
            }
            return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__spreadArrays"])([_controls_action_menu__WEBPACK_IMPORTED_MODULE_4__["ActionMenu"].Header((_c = m.cell.obj) === null || _c === void 0 ? void 0 : _c.label)], m.structures.map(_this.item));
        };
        _this.selectHierarchy = function (items) {
            if (!items || items.length === 0)
                return;
            var refs = [];
            for (var _i = 0, items_1 = items; _i < items_1.length; _i++) {
                var i = items_1[_i];
                for (var _a = 0, _b = i.value; _a < _b.length; _a++) {
                    var r = _b[_a];
                    refs.push(r);
                }
            }
            _this.plugin.managers.structure.hierarchy.updateCurrent(refs, items[0].selected ? 'remove' : 'add');
        };
        _this.toggleHierarchy = function () { return _this.setState({ show: _this.state.show !== 'hierarchy' ? 'hierarchy' : void 0 }); };
        _this.togglePreset = function () { return _this.setState({ show: _this.state.show !== 'presets' ? 'presets' : void 0 }); };
        _this.applyPreset = function (item) {
            _this.setState({ show: void 0 });
            if (!item)
                return;
            var mng = _this.plugin.managers.structure;
            var trajectories = mng.hierarchy.selection.trajectories;
            mng.hierarchy.applyPreset(trajectories, item.value);
        };
        _this.updateStructureModel = function (params) { return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"])(_this, void 0, void 0, function () {
            var selection, m;
            return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__generator"])(this, function (_a) {
                selection = this.plugin.managers.structure.hierarchy.selection;
                m = selection.structures[0].model;
                this.plugin.state.updateTransform(this.plugin.state.data, m.cell.transform.ref, params, 'Model Index');
                return [2 /*return*/];
            });
        }); };
        _this.updateStructure = function (params) {
            var selection = _this.plugin.managers.structure.hierarchy.selection;
            var s = selection.structures[0];
            return _this.plugin.managers.structure.hierarchy.updateStructure(s, params);
        };
        return _this;
    }
    StructureSourceControls.prototype.defaultState = function () {
        return {
            header: 'Structure',
            isCollapsed: false,
            isBusy: false,
            brand: { accent: 'purple', svg: _controls_icons__WEBPACK_IMPORTED_MODULE_11__["MoleculeSvg"] }
        };
    };
    StructureSourceControls.prototype.componentDidMount = function () {
        var _this = this;
        this.subscribe(this.plugin.managers.structure.hierarchy.behaviors.selection, function () { return _this.forceUpdate(); });
        this.subscribe(this.plugin.behaviors.state.isBusy, function (v) {
            _this.setState({ isBusy: v });
        });
    };
    Object.defineProperty(StructureSourceControls.prototype, "hierarchyItems", {
        get: function () {
            var mng = this.plugin.managers.structure.hierarchy;
            var current = mng.current;
            var ret = [];
            if (current.trajectories.length > 1) {
                ret.push(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__spreadArrays"])([
                    _controls_action_menu__WEBPACK_IMPORTED_MODULE_4__["ActionMenu"].Header('Trajectories')
                ], current.trajectories.map(this.item)));
            }
            if (current.models.length > 1 || current.trajectories.length > 1) {
                ret.push(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__spreadArrays"])([
                    _controls_action_menu__WEBPACK_IMPORTED_MODULE_4__["ActionMenu"].Header('Models')
                ], current.models.map(this.item)));
            }
            if (current.trajectories.length === 1 && current.models.length === 1) {
                ret.push.apply(ret, current.structures.map(this.item));
            }
            else if (current.structures.length > 0) {
                ret.push(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__spreadArrays"])([
                    _controls_action_menu__WEBPACK_IMPORTED_MODULE_4__["ActionMenu"].Header('Structures')
                ], current.structures.map(this.item)));
            }
            return ret;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(StructureSourceControls.prototype, "isEmpty", {
        get: function () {
            var _a = this.plugin.managers.structure.hierarchy.current, structures = _a.structures, models = _a.models, trajectories = _a.trajectories;
            return trajectories.length === 0 && models.length === 0 && structures.length === 0;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(StructureSourceControls.prototype, "label", {
        get: function () {
            var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p;
            var _q = this.plugin.managers.structure.hierarchy.selection, structures = _q.structures, models = _q.models, trajectories = _q.trajectories;
            if (structures.length === 1) {
                var s = structures[0];
                if (((_b = (_a = s.model) === null || _a === void 0 ? void 0 : _a.trajectory) === null || _b === void 0 ? void 0 : _b.models) && s.model.trajectory.models.length === 1)
                    return (_c = s.cell.obj) === null || _c === void 0 ? void 0 : _c.data.label;
                if (s.model)
                    return ((_d = s.model.cell.obj) === null || _d === void 0 ? void 0 : _d.label) + " | " + ((_e = s.cell.obj) === null || _e === void 0 ? void 0 : _e.data.label);
                return (_f = s.cell.obj) === null || _f === void 0 ? void 0 : _f.data.label;
            }
            if (structures.length > 1) {
                var p = structures[0];
                var t = (_g = p === null || p === void 0 ? void 0 : p.model) === null || _g === void 0 ? void 0 : _g.trajectory;
                var sameTraj = true;
                for (var _i = 0, structures_1 = structures; _i < structures_1.length; _i++) {
                    var s = structures_1[_i];
                    if (((_h = s === null || s === void 0 ? void 0 : s.model) === null || _h === void 0 ? void 0 : _h.trajectory) !== t) {
                        sameTraj = false;
                        break;
                    }
                }
                return sameTraj && t ? ((_j = t.cell.obj) === null || _j === void 0 ? void 0 : _j.label) + " | " + structures.length + " structures" : structures.length + " structures";
            }
            if (models.length > 0) {
                var t = models[0].trajectory;
                if (models.length === 1) {
                    var model = (_k = models[0].cell.obj) === null || _k === void 0 ? void 0 : _k.data;
                    if (model && _mol_model_structure__WEBPACK_IMPORTED_MODULE_12__["Model"].TrajectoryInfo.get(model).size > 1) {
                        return ((_l = t === null || t === void 0 ? void 0 : t.cell.obj) === null || _l === void 0 ? void 0 : _l.label) + " | Model " + (_mol_model_structure__WEBPACK_IMPORTED_MODULE_12__["Model"].TrajectoryInfo.get(model).index + 1) + " of " + _mol_model_structure__WEBPACK_IMPORTED_MODULE_12__["Model"].TrajectoryInfo.get(model).size;
                    }
                    else {
                        return ((_m = t === null || t === void 0 ? void 0 : t.cell.obj) === null || _m === void 0 ? void 0 : _m.label) + " | Model";
                    }
                }
                var sameTraj = true;
                for (var _r = 0, models_1 = models; _r < models_1.length; _r++) {
                    var m = models_1[_r];
                    if (m.trajectory !== t) {
                        sameTraj = false;
                        break;
                    }
                }
                return sameTraj ? ((_o = t === null || t === void 0 ? void 0 : t.cell.obj) === null || _o === void 0 ? void 0 : _o.label) + " | " + models.length + " models" : models.length + " models";
            }
            if (trajectories.length > 0) {
                return trajectories.length === 1 ? ((_p = trajectories[0].cell.obj) === null || _p === void 0 ? void 0 : _p.label) + " trajectory" : trajectories.length + " trajectories";
            }
            if (trajectories.length === 0 && models.length === 0 && structures.length === 0) {
                return 'Nothing Loaded';
            }
            return 'Nothing Selected';
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(StructureSourceControls.prototype, "presetActions", {
        get: function () {
            var actions = [];
            var trajectories = this.plugin.managers.structure.hierarchy.selection.trajectories;
            if (trajectories.length !== 1)
                return actions;
            var providers = this.plugin.builders.structure.hierarchy.getPresets(trajectories[0].cell.obj);
            for (var _i = 0, providers_1 = providers; _i < providers_1.length; _i++) {
                var p = providers_1[_i];
                actions.push(_controls_action_menu__WEBPACK_IMPORTED_MODULE_4__["ActionMenu"].Item(p.display.name, p, { description: p.display.description }));
            }
            return actions;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(StructureSourceControls.prototype, "modelIndex", {
        get: function () {
            var _a, _b;
            var selection = this.plugin.managers.structure.hierarchy.selection;
            if (selection.structures.length !== 1)
                return null;
            var m = selection.structures[0].model;
            if (!m || m.cell.transform.transformer !== _mol_plugin_state_transforms__WEBPACK_IMPORTED_MODULE_2__["StateTransforms"].Model.ModelFromTrajectory)
                return null;
            if (!m.cell.obj || _mol_model_structure__WEBPACK_IMPORTED_MODULE_12__["Model"].TrajectoryInfo.get(m.cell.obj.data).size <= 1)
                return null;
            var params = (_a = m.cell.params) === null || _a === void 0 ? void 0 : _a.definition;
            if (!params)
                return null;
            return react__WEBPACK_IMPORTED_MODULE_1__["createElement"](_controls_parameters__WEBPACK_IMPORTED_MODULE_6__["ParameterControls"], { params: params, values: (_b = m.cell.params) === null || _b === void 0 ? void 0 : _b.values, onChangeValues: this.updateStructureModel, isDisabled: this.state.isBusy });
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(StructureSourceControls.prototype, "structureType", {
        get: function () {
            var _a;
            var selection = this.plugin.managers.structure.hierarchy.selection;
            if (selection.structures.length !== 1)
                return null;
            var s = selection.structures[0];
            var params = (_a = s.cell.params) === null || _a === void 0 ? void 0 : _a.definition;
            if (!params || !s.cell.parent)
                return null;
            return react__WEBPACK_IMPORTED_MODULE_1__["createElement"](_state_update_transform__WEBPACK_IMPORTED_MODULE_8__["UpdateTransformControl"], { state: s.cell.parent, transform: s.cell.transform, customHeader: 'none', customUpdate: this.updateStructure, noMargin: true, autoHideApply: true });
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(StructureSourceControls.prototype, "transform", {
        get: function () {
            var selection = this.plugin.managers.structure.hierarchy.selection;
            if (selection.structures.length !== 1)
                return null;
            var pivot = selection.structures[0];
            if (!pivot.cell.parent)
                return null;
            var t = _mol_state__WEBPACK_IMPORTED_MODULE_10__["StateSelection"].tryFindDecorator(this.plugin.state.data, pivot.cell.transform.ref, _mol_plugin_state_transforms__WEBPACK_IMPORTED_MODULE_2__["StateTransforms"].Model.TransformStructureConformation);
            if (!t)
                return;
            return react__WEBPACK_IMPORTED_MODULE_1__["createElement"](_controls_common__WEBPACK_IMPORTED_MODULE_5__["ExpandGroup"], { header: "Conformation Transform" },
                react__WEBPACK_IMPORTED_MODULE_1__["createElement"](_state_update_transform__WEBPACK_IMPORTED_MODULE_8__["UpdateTransformControl"], { state: t.parent, transform: t.transform, customHeader: 'none', noMargin: true, autoHideApply: true }));
        },
        enumerable: false,
        configurable: true
    });
    StructureSourceControls.prototype.renderControls = function () {
        var disabled = this.state.isBusy || this.isEmpty;
        var presets = this.presetActions;
        var label = this.label;
        return react__WEBPACK_IMPORTED_MODULE_1__["createElement"](react__WEBPACK_IMPORTED_MODULE_1__["Fragment"], null,
            react__WEBPACK_IMPORTED_MODULE_1__["createElement"]("div", { className: 'msp-flex-row', style: { marginTop: '1px' } },
                react__WEBPACK_IMPORTED_MODULE_1__["createElement"](_controls_common__WEBPACK_IMPORTED_MODULE_5__["Button"], { noOverflow: true, flex: true, onClick: this.toggleHierarchy, disabled: disabled, title: label }, label),
                presets.length > 0 && react__WEBPACK_IMPORTED_MODULE_1__["createElement"](_controls_common__WEBPACK_IMPORTED_MODULE_5__["IconButton"], { svg: _controls_icons__WEBPACK_IMPORTED_MODULE_11__["BookmarksOutlinedSvg"], className: 'msp-form-control', flex: '40px', onClick: this.togglePreset, title: 'Apply a structure presets to the current hierarchy.', toggleState: this.state.show === 'presets', disabled: disabled })),
            this.state.show === 'hierarchy' && react__WEBPACK_IMPORTED_MODULE_1__["createElement"](_controls_action_menu__WEBPACK_IMPORTED_MODULE_4__["ActionMenu"], { items: this.hierarchyItems, onSelect: this.selectHierarchy, multiselect: true }),
            this.state.show === 'presets' && react__WEBPACK_IMPORTED_MODULE_1__["createElement"](_controls_action_menu__WEBPACK_IMPORTED_MODULE_4__["ActionMenu"], { items: presets, onSelect: this.applyPreset }),
            this.modelIndex,
            this.structureType,
            this.transform,
            react__WEBPACK_IMPORTED_MODULE_1__["createElement"]("div", { style: { marginTop: '6px' } },
                react__WEBPACK_IMPORTED_MODULE_1__["createElement"](_focus__WEBPACK_IMPORTED_MODULE_7__["StructureFocusControls"], null),
                react__WEBPACK_IMPORTED_MODULE_1__["createElement"](_selection__WEBPACK_IMPORTED_MODULE_9__["StructureSelectionStatsControls"], { hideOnEmpty: true })));
    };
    return StructureSourceControls;
}(_base__WEBPACK_IMPORTED_MODULE_3__["CollapsableControls"]));

//# sourceMappingURL=source.js.map

/***/ }),

/***/ "./lib/mol-plugin-ui/structure/superposition.js":
/*!******************************************************!*\
  !*** ./lib/mol-plugin-ui/structure/superposition.js ***!
  \******************************************************/
/*! exports provided: StructureSuperpositionControls, StructureSuperpositionParams, SuperpositionControls */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "StructureSuperpositionControls", function() { return StructureSuperpositionControls; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "StructureSuperpositionParams", function() { return StructureSuperpositionParams; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SuperpositionControls", function() { return SuperpositionControls; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! react */ "./node_modules/react/index.js");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _base__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../base */ "./lib/mol-plugin-ui/base.js");
/* harmony import */ var _controls_icons__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../controls/icons */ "./lib/mol-plugin-ui/controls/icons.js");
/* harmony import */ var _controls_common__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../controls/common */ "./lib/mol-plugin-ui/controls/common.js");
/* harmony import */ var _mol_model_structure__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../mol-model/structure */ "./lib/mol-model/structure.js");
/* harmony import */ var _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../../mol-util/param-definition */ "./lib/mol-util/param-definition.js");
/* harmony import */ var _mol_state__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../../mol-state */ "./lib/mol-state/index.js");
/* harmony import */ var _mol_plugin_state_transforms__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ../../mol-plugin-state/transforms */ "./lib/mol-plugin-state/transforms.js");
/* harmony import */ var _mol_model_structure_structure_util_superposition__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ../../mol-model/structure/structure/util/superposition */ "./lib/mol-model/structure/structure/util/superposition.js");
/* harmony import */ var _mol_plugin_state_helpers_structure_selection_query__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ../../mol-plugin-state/helpers/structure-selection-query */ "./lib/mol-plugin-state/helpers/structure-selection-query.js");
/* harmony import */ var _mol_theme_label__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ../../mol-theme/label */ "./lib/mol-theme/label.js");
/* harmony import */ var _controls_parameters__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! ../controls/parameters */ "./lib/mol-plugin-ui/controls/parameters.js");
/* harmony import */ var _mol_util_string__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! ../../mol-util/string */ "./lib/mol-util/string.js");
/* harmony import */ var _selection__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! ./selection */ "./lib/mol-plugin-ui/structure/selection.js");
/**
 * Copyright (c) 2020 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */















var StructureSuperpositionControls = /** @class */ (function (_super) {
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__extends"])(StructureSuperpositionControls, _super);
    function StructureSuperpositionControls() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    StructureSuperpositionControls.prototype.defaultState = function () {
        return {
            isCollapsed: false,
            header: 'Superposition',
            brand: { accent: 'gray', svg: _controls_icons__WEBPACK_IMPORTED_MODULE_3__["SuperpositionSvg"] },
            isHidden: true
        };
    };
    StructureSuperpositionControls.prototype.componentDidMount = function () {
        var _this = this;
        this.subscribe(this.plugin.managers.structure.hierarchy.behaviors.selection, function (sel) {
            _this.setState({ isHidden: sel.structures.length < 2 });
        });
    };
    StructureSuperpositionControls.prototype.renderControls = function () {
        return react__WEBPACK_IMPORTED_MODULE_1__["createElement"](react__WEBPACK_IMPORTED_MODULE_1__["Fragment"], null,
            react__WEBPACK_IMPORTED_MODULE_1__["createElement"](SuperpositionControls, null));
    };
    return StructureSuperpositionControls;
}(_base__WEBPACK_IMPORTED_MODULE_2__["CollapsableControls"]));

var StructureSuperpositionParams = {
    alignSequences: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_6__["ParamDefinition"].Boolean(true, { isEssential: true, description: 'Perform a sequence alignment and use the aligned residue pairs to guide the 3D superposition.' }),
};
var DefaultStructureSuperpositionOptions = _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_6__["ParamDefinition"].getDefaultValues(StructureSuperpositionParams);
var SuperpositionTag = 'SuperpositionTransform';
;
;
var SuperpositionControls = /** @class */ (function (_super) {
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__extends"])(SuperpositionControls, _super);
    function SuperpositionControls() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            isBusy: false,
            action: undefined,
            options: DefaultStructureSuperpositionOptions
        };
        _this.superposeChains = function () { return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"])(_this, void 0, void 0, function () {
            var query, entries, traceLocis, transforms, eA, i, il, eB, _a, bTransform, rmsd, labelA, labelB;
            var _this = this;
            return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__generator"])(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        query = _mol_plugin_state_helpers_structure_selection_query__WEBPACK_IMPORTED_MODULE_10__["StructureSelectionQueries"].trace.query;
                        entries = this.chainEntries;
                        traceLocis = entries.map(function (e, i) {
                            var s = _mol_model_structure__WEBPACK_IMPORTED_MODULE_5__["StructureElement"].Loci.toStructure(e.loci);
                            var loci = _mol_model_structure__WEBPACK_IMPORTED_MODULE_5__["StructureSelection"].toLociWithSourceUnits(query(new _mol_model_structure__WEBPACK_IMPORTED_MODULE_5__["QueryContext"](s)));
                            return _mol_model_structure__WEBPACK_IMPORTED_MODULE_5__["StructureElement"].Loci.remap(loci, i === 0
                                ? _this.plugin.helpers.substructureParent.get(e.loci.structure.root).obj.data
                                : loci.structure.root);
                        });
                        transforms = this.state.options.alignSequences
                            ? Object(_mol_model_structure_structure_util_superposition__WEBPACK_IMPORTED_MODULE_9__["alignAndSuperpose"])(traceLocis)
                            : Object(_mol_model_structure_structure_util_superposition__WEBPACK_IMPORTED_MODULE_9__["superpose"])(traceLocis);
                        eA = entries[0];
                        i = 1, il = traceLocis.length;
                        _b.label = 1;
                    case 1:
                        if (!(i < il)) return [3 /*break*/, 4];
                        eB = entries[i];
                        _a = transforms[i - 1], bTransform = _a.bTransform, rmsd = _a.rmsd;
                        return [4 /*yield*/, this.transform(eB.cell, bTransform)];
                    case 2:
                        _b.sent();
                        labelA = Object(_mol_util_string__WEBPACK_IMPORTED_MODULE_13__["stripTags"])(eA.label);
                        labelB = Object(_mol_util_string__WEBPACK_IMPORTED_MODULE_13__["stripTags"])(eB.label);
                        this.plugin.log.info("Superposed [" + labelA + "] and [" + labelB + "] with RMSD " + rmsd.toFixed(2) + ".");
                        _b.label = 3;
                    case 3:
                        ++i;
                        return [3 /*break*/, 1];
                    case 4: return [2 /*return*/];
                }
            });
        }); };
        _this.superposeAtoms = function () { return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"])(_this, void 0, void 0, function () {
            var entries, atomLocis, transforms, eA, i, il, eB, _a, bTransform, rmsd, labelA, labelB, count;
            var _this = this;
            return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__generator"])(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        entries = this.atomEntries;
                        atomLocis = entries.map(function (e, i) {
                            return _mol_model_structure__WEBPACK_IMPORTED_MODULE_5__["StructureElement"].Loci.remap(e.loci, i === 0
                                ? _this.plugin.helpers.substructureParent.get(e.loci.structure.root).obj.data
                                : e.loci.structure.root);
                        });
                        transforms = Object(_mol_model_structure_structure_util_superposition__WEBPACK_IMPORTED_MODULE_9__["superpose"])(atomLocis);
                        eA = entries[0];
                        i = 1, il = atomLocis.length;
                        _b.label = 1;
                    case 1:
                        if (!(i < il)) return [3 /*break*/, 4];
                        eB = entries[i];
                        _a = transforms[i - 1], bTransform = _a.bTransform, rmsd = _a.rmsd;
                        return [4 /*yield*/, this.transform(eB.cell, bTransform)];
                    case 2:
                        _b.sent();
                        labelA = Object(_mol_util_string__WEBPACK_IMPORTED_MODULE_13__["stripTags"])(eA.label);
                        labelB = Object(_mol_util_string__WEBPACK_IMPORTED_MODULE_13__["stripTags"])(eB.label);
                        count = entries[i].atoms.length;
                        this.plugin.log.info("Superposed " + count + " " + (count === 1 ? 'atom' : 'atoms') + " of [" + labelA + "] and [" + labelB + "] with RMSD " + rmsd.toFixed(2) + ".");
                        _b.label = 3;
                    case 3:
                        ++i;
                        return [3 /*break*/, 1];
                    case 4: return [2 /*return*/];
                }
            });
        }); };
        _this.toggleByChains = function () { return _this.setState({ action: _this.state.action === 'byChains' ? void 0 : 'byChains' }); };
        _this.toggleByAtoms = function () { return _this.setState({ action: _this.state.action === 'byAtoms' ? void 0 : 'byAtoms' }); };
        _this.toggleOptions = function () { return _this.setState({ action: _this.state.action === 'options' ? void 0 : 'options' }); };
        _this.setOptions = function (values) {
            _this.setState({ options: values });
        };
        return _this;
    }
    SuperpositionControls.prototype.componentDidMount = function () {
        var _this = this;
        this.subscribe(this.selection.events.changed, function () {
            _this.forceUpdate();
        });
        this.subscribe(this.selection.events.additionsHistoryUpdated, function () {
            _this.forceUpdate();
        });
        this.subscribe(this.plugin.behaviors.state.isBusy, function (v) {
            _this.setState({ isBusy: v });
        });
    };
    Object.defineProperty(SuperpositionControls.prototype, "selection", {
        get: function () {
            return this.plugin.managers.structure.selection;
        },
        enumerable: false,
        configurable: true
    });
    SuperpositionControls.prototype.transform = function (s, matrix) {
        return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"])(this, void 0, void 0, function () {
            var r, o, params, b;
            return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__generator"])(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        r = _mol_state__WEBPACK_IMPORTED_MODULE_7__["StateObjectRef"].resolveAndCheck(this.plugin.state.data, s);
                        if (!r)
                            return [2 /*return*/];
                        o = _mol_state__WEBPACK_IMPORTED_MODULE_7__["StateSelection"].findTagInSubtree(this.plugin.state.data.tree, r.transform.ref, SuperpositionTag);
                        params = {
                            transform: {
                                name: 'matrix',
                                params: { data: matrix, transpose: false }
                            }
                        };
                        b = o
                            ? this.plugin.state.data.build().to(o).update(params)
                            : this.plugin.state.data.build().to(s)
                                .insert(_mol_plugin_state_transforms__WEBPACK_IMPORTED_MODULE_8__["StateTransforms"].Model.TransformStructureConformation, params, { tags: SuperpositionTag });
                        return [4 /*yield*/, this.plugin.runTask(this.plugin.state.data.updateTree(b))];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    SuperpositionControls.prototype.highlight = function (loci) {
        this.plugin.managers.interactivity.lociHighlights.highlightOnly({ loci: loci }, false);
    };
    SuperpositionControls.prototype.moveHistory = function (e, direction) {
        this.plugin.managers.structure.selection.modifyHistory(e, direction, void 0, true);
    };
    SuperpositionControls.prototype.focusLoci = function (loci) {
        this.plugin.managers.camera.focusLoci(loci);
    };
    SuperpositionControls.prototype.lociEntry = function (e, idx) {
        var _this = this;
        return react__WEBPACK_IMPORTED_MODULE_1__["createElement"]("div", { className: 'msp-flex-row', key: idx },
            react__WEBPACK_IMPORTED_MODULE_1__["createElement"](_controls_common__WEBPACK_IMPORTED_MODULE_4__["Button"], { noOverflow: true, title: 'Click to focus. Hover to highlight.', onClick: function () { return _this.focusLoci(e.loci); }, style: { width: 'auto', textAlign: 'left' }, onMouseEnter: function () { return _this.highlight(e.loci); }, onMouseLeave: this.plugin.managers.interactivity.lociHighlights.clearHighlights },
                react__WEBPACK_IMPORTED_MODULE_1__["createElement"]("span", { dangerouslySetInnerHTML: { __html: e.label } })));
    };
    SuperpositionControls.prototype.historyEntry = function (e, idx) {
        var _this = this;
        var history = this.plugin.managers.structure.selection.additionsHistory;
        return react__WEBPACK_IMPORTED_MODULE_1__["createElement"]("div", { className: 'msp-flex-row', key: e.id },
            react__WEBPACK_IMPORTED_MODULE_1__["createElement"](_controls_common__WEBPACK_IMPORTED_MODULE_4__["Button"], { noOverflow: true, title: 'Click to focus. Hover to highlight.', onClick: function () { return _this.focusLoci(e.loci); }, style: { width: 'auto', textAlign: 'left' }, onMouseEnter: function () { return _this.highlight(e.loci); }, onMouseLeave: this.plugin.managers.interactivity.lociHighlights.clearHighlights },
                idx,
                ". ",
                react__WEBPACK_IMPORTED_MODULE_1__["createElement"]("span", { dangerouslySetInnerHTML: { __html: e.label } })),
            history.length > 1 && react__WEBPACK_IMPORTED_MODULE_1__["createElement"](_controls_common__WEBPACK_IMPORTED_MODULE_4__["IconButton"], { svg: _controls_icons__WEBPACK_IMPORTED_MODULE_3__["ArrowUpwardSvg"], small: true, className: 'msp-form-control', onClick: function () { return _this.moveHistory(e, 'up'); }, flex: '20px', title: 'Move up' }),
            history.length > 1 && react__WEBPACK_IMPORTED_MODULE_1__["createElement"](_controls_common__WEBPACK_IMPORTED_MODULE_4__["IconButton"], { svg: _controls_icons__WEBPACK_IMPORTED_MODULE_3__["ArrowDownwardSvg"], small: true, className: 'msp-form-control', onClick: function () { return _this.moveHistory(e, 'down'); }, flex: '20px', title: 'Move down' }),
            react__WEBPACK_IMPORTED_MODULE_1__["createElement"](_controls_common__WEBPACK_IMPORTED_MODULE_4__["IconButton"], { svg: _controls_icons__WEBPACK_IMPORTED_MODULE_3__["DeleteOutlinedSvg"], small: true, className: 'msp-form-control', onClick: function () { return _this.plugin.managers.structure.selection.modifyHistory(e, 'remove'); }, flex: true, title: 'Remove' }));
    };
    SuperpositionControls.prototype.atomsLociEntry = function (e, idx) {
        var _this = this;
        return react__WEBPACK_IMPORTED_MODULE_1__["createElement"]("div", { key: idx },
            react__WEBPACK_IMPORTED_MODULE_1__["createElement"]("div", { className: 'msp-control-group-header' },
                react__WEBPACK_IMPORTED_MODULE_1__["createElement"]("div", { className: 'msp-no-overflow', title: e.label }, e.label)),
            react__WEBPACK_IMPORTED_MODULE_1__["createElement"]("div", { className: 'msp-control-offset' }, e.atoms.map(function (h, i) { return _this.historyEntry(h, i); })));
    };
    Object.defineProperty(SuperpositionControls.prototype, "chainEntries", {
        get: function () {
            var _this = this;
            var location = _mol_model_structure__WEBPACK_IMPORTED_MODULE_5__["StructureElement"].Location.create();
            var entries = [];
            this.plugin.managers.structure.selection.entries.forEach(function (_a, ref) {
                var selection = _a.selection;
                var cell = _mol_state__WEBPACK_IMPORTED_MODULE_7__["StateObjectRef"].resolveAndCheck(_this.plugin.state.data, ref);
                if (!cell || _mol_model_structure__WEBPACK_IMPORTED_MODULE_5__["StructureElement"].Loci.isEmpty(selection))
                    return;
                // only single polymer chain selections
                var l = _mol_model_structure__WEBPACK_IMPORTED_MODULE_5__["StructureElement"].Loci.getFirstLocation(selection, location);
                if (selection.elements.length > 1 || _mol_model_structure__WEBPACK_IMPORTED_MODULE_5__["StructureProperties"].entity.type(l) !== 'polymer')
                    return;
                var stats = _mol_model_structure__WEBPACK_IMPORTED_MODULE_5__["StructureElement"].Stats.ofLoci(selection);
                var counts = Object(_mol_theme_label__WEBPACK_IMPORTED_MODULE_11__["structureElementStatsLabel"])(stats, { countsOnly: true });
                var chain = Object(_mol_theme_label__WEBPACK_IMPORTED_MODULE_11__["elementLabel"])(l, { reverse: true, granularity: 'chain' }).split('|');
                var label = counts + " | " + chain[0] + " | " + chain[chain.length - 1];
                entries.push({ loci: selection, label: label, cell: cell });
            });
            return entries;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SuperpositionControls.prototype, "atomEntries", {
        get: function () {
            var _this = this;
            var structureEntries = new Map();
            var history = this.plugin.managers.structure.selection.additionsHistory;
            for (var i = 0, il = history.length; i < il; ++i) {
                var e = history[i];
                if (_mol_model_structure__WEBPACK_IMPORTED_MODULE_5__["StructureElement"].Loci.size(e.loci) !== 1)
                    continue;
                var k = e.loci.structure;
                if (structureEntries.has(k))
                    structureEntries.get(k).push(e);
                else
                    structureEntries.set(k, [e]);
            }
            var entries = [];
            structureEntries.forEach(function (atoms, structure) {
                var cell = _this.plugin.helpers.substructureParent.get(structure);
                var elements = [];
                for (var i = 0, il = atoms.length; i < il; ++i) {
                    // note, we don't do loci union here to keep order of selected atoms
                    // for atom pairing during superposition
                    elements.push(atoms[i].loci.elements[0]);
                }
                var loci = _mol_model_structure__WEBPACK_IMPORTED_MODULE_5__["StructureElement"].Loci(atoms[0].loci.structure, elements);
                var label = loci.structure.label.split(' | ')[0];
                entries.push({ loci: loci, label: label, cell: cell, atoms: atoms });
            });
            return entries;
        },
        enumerable: false,
        configurable: true
    });
    SuperpositionControls.prototype.addByChains = function () {
        var _this = this;
        var entries = this.chainEntries;
        return react__WEBPACK_IMPORTED_MODULE_1__["createElement"](react__WEBPACK_IMPORTED_MODULE_1__["Fragment"], null,
            entries.length > 0 && react__WEBPACK_IMPORTED_MODULE_1__["createElement"]("div", { className: 'msp-control-offset' }, entries.map(function (e, i) { return _this.lociEntry(e, i); })),
            entries.length < 2 && react__WEBPACK_IMPORTED_MODULE_1__["createElement"]("div", { className: 'msp-control-offset msp-help-text' },
                react__WEBPACK_IMPORTED_MODULE_1__["createElement"]("div", { className: 'msp-help-description' },
                    react__WEBPACK_IMPORTED_MODULE_1__["createElement"](_controls_icons__WEBPACK_IMPORTED_MODULE_3__["Icon"], { svg: _controls_icons__WEBPACK_IMPORTED_MODULE_3__["HelpOutlineSvg"], inline: true }),
                    "Add 2 or more selections (toggle ",
                    react__WEBPACK_IMPORTED_MODULE_1__["createElement"](_selection__WEBPACK_IMPORTED_MODULE_14__["ToggleSelectionModeButton"], { inline: true }),
                    " mode) from separate structures. Selections must be limited to single polymer chains or residues therein.")),
            entries.length > 1 && react__WEBPACK_IMPORTED_MODULE_1__["createElement"](_controls_common__WEBPACK_IMPORTED_MODULE_4__["Button"], { title: 'Superpose structures by selected chains.', className: 'msp-btn-commit msp-btn-commit-on', onClick: this.superposeChains, style: { marginTop: '1px' } }, "Superpose"));
    };
    SuperpositionControls.prototype.addByAtoms = function () {
        var _this = this;
        var entries = this.atomEntries;
        return react__WEBPACK_IMPORTED_MODULE_1__["createElement"](react__WEBPACK_IMPORTED_MODULE_1__["Fragment"], null,
            entries.length > 0 && react__WEBPACK_IMPORTED_MODULE_1__["createElement"]("div", { className: 'msp-control-offset' }, entries.map(function (e, i) { return _this.atomsLociEntry(e, i); })),
            entries.length < 2 && react__WEBPACK_IMPORTED_MODULE_1__["createElement"]("div", { className: 'msp-control-offset msp-help-text' },
                react__WEBPACK_IMPORTED_MODULE_1__["createElement"]("div", { className: 'msp-help-description' },
                    react__WEBPACK_IMPORTED_MODULE_1__["createElement"](_controls_icons__WEBPACK_IMPORTED_MODULE_3__["Icon"], { svg: _controls_icons__WEBPACK_IMPORTED_MODULE_3__["HelpOutlineSvg"], inline: true }),
                    "Add 1 or more selections (toggle ",
                    react__WEBPACK_IMPORTED_MODULE_1__["createElement"](_selection__WEBPACK_IMPORTED_MODULE_14__["ToggleSelectionModeButton"], { inline: true }),
                    " mode) from separate structures. Selections must be limited to single atoms.")),
            entries.length > 1 && react__WEBPACK_IMPORTED_MODULE_1__["createElement"](_controls_common__WEBPACK_IMPORTED_MODULE_4__["Button"], { title: 'Superpose structures by selected atoms.', className: 'msp-btn-commit msp-btn-commit-on', onClick: this.superposeAtoms, style: { marginTop: '1px' } }, "Superpose"));
    };
    SuperpositionControls.prototype.render = function () {
        return react__WEBPACK_IMPORTED_MODULE_1__["createElement"](react__WEBPACK_IMPORTED_MODULE_1__["Fragment"], null,
            react__WEBPACK_IMPORTED_MODULE_1__["createElement"]("div", { className: 'msp-flex-row' },
                react__WEBPACK_IMPORTED_MODULE_1__["createElement"](_controls_common__WEBPACK_IMPORTED_MODULE_4__["ToggleButton"], { icon: _controls_icons__WEBPACK_IMPORTED_MODULE_3__["SuperposeChainsSvg"], label: 'By Chains', toggle: this.toggleByChains, isSelected: this.state.action === 'byChains', disabled: this.state.isBusy }),
                react__WEBPACK_IMPORTED_MODULE_1__["createElement"](_controls_common__WEBPACK_IMPORTED_MODULE_4__["ToggleButton"], { icon: _controls_icons__WEBPACK_IMPORTED_MODULE_3__["SuperposeAtomsSvg"], label: 'By Atoms', toggle: this.toggleByAtoms, isSelected: this.state.action === 'byAtoms', disabled: this.state.isBusy }),
                react__WEBPACK_IMPORTED_MODULE_1__["createElement"](_controls_common__WEBPACK_IMPORTED_MODULE_4__["ToggleButton"], { icon: _controls_icons__WEBPACK_IMPORTED_MODULE_3__["TuneSvg"], label: '', title: 'Options', toggle: this.toggleOptions, isSelected: this.state.action === 'options', disabled: this.state.isBusy, style: { flex: '0 0 40px', padding: 0 } })),
            this.state.action === 'byChains' && this.addByChains(),
            this.state.action === 'byAtoms' && this.addByAtoms(),
            this.state.action === 'options' && react__WEBPACK_IMPORTED_MODULE_1__["createElement"]("div", { className: 'msp-control-offset' },
                react__WEBPACK_IMPORTED_MODULE_1__["createElement"](_controls_parameters__WEBPACK_IMPORTED_MODULE_12__["ParameterControls"], { params: StructureSuperpositionParams, values: this.state.options, onChangeValues: this.setOptions, isDisabled: this.state.isBusy })));
    };
    return SuperpositionControls;
}(_base__WEBPACK_IMPORTED_MODULE_2__["PurePluginUIComponent"]));

//# sourceMappingURL=superposition.js.map

/***/ }),

/***/ "./lib/mol-plugin-ui/structure/volume.js":
/*!***********************************************!*\
  !*** ./lib/mol-plugin-ui/structure/volume.js ***!
  \***********************************************/
/*! exports provided: VolumeStreamingControls, VolumeSourceControls */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "VolumeStreamingControls", function() { return VolumeStreamingControls; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "VolumeSourceControls", function() { return VolumeSourceControls; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! react */ "./node_modules/react/index.js");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _mol_plugin_state_manager_structure_hierarchy__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../mol-plugin-state/manager/structure/hierarchy */ "./lib/mol-plugin-state/manager/structure/hierarchy.js");
/* harmony import */ var _mol_plugin_state_manager_volume_hierarchy__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../mol-plugin-state/manager/volume/hierarchy */ "./lib/mol-plugin-state/manager/volume/hierarchy.js");
/* harmony import */ var _mol_plugin_behavior_dynamic_representation__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../mol-plugin/behavior/dynamic/representation */ "./lib/mol-plugin/behavior/dynamic/representation.js");
/* harmony import */ var _mol_plugin_behavior_dynamic_volume_streaming_behavior__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../mol-plugin/behavior/dynamic/volume-streaming/behavior */ "./lib/mol-plugin/behavior/dynamic/volume-streaming/behavior.js");
/* harmony import */ var _mol_plugin_behavior_dynamic_volume_streaming_transformers__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../../mol-plugin/behavior/dynamic/volume-streaming/transformers */ "./lib/mol-plugin/behavior/dynamic/volume-streaming/transformers.js");
/* harmony import */ var _mol_state__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../../mol-state */ "./lib/mol-state/index.js");
/* harmony import */ var _base__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ../base */ "./lib/mol-plugin-ui/base.js");
/* harmony import */ var _controls_action_menu__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ../controls/action-menu */ "./lib/mol-plugin-ui/controls/action-menu.js");
/* harmony import */ var _controls_common__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ../controls/common */ "./lib/mol-plugin-ui/controls/common.js");
/* harmony import */ var _state_apply_action__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ../state/apply-action */ "./lib/mol-plugin-ui/state/apply-action.js");
/* harmony import */ var _state_update_transform__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! ../state/update-transform */ "./lib/mol-plugin-ui/state/update-transform.js");
/* harmony import */ var _viewport_help__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! ../viewport/help */ "./lib/mol-plugin-ui/viewport/help.js");
/* harmony import */ var _mol_plugin_commands__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! ../../mol-plugin/commands */ "./lib/mol-plugin/commands.js");
/* harmony import */ var _controls_icons__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! ../controls/icons */ "./lib/mol-plugin-ui/controls/icons.js");
/**
 * Copyright (c) 2020 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author David Sehnal <david.sehnal@gmail.com>
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */
















var VolumeStreamingControls = /** @class */ (function (_super) {
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__extends"])(VolumeStreamingControls, _super);
    function VolumeStreamingControls() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    VolumeStreamingControls.prototype.defaultState = function () {
        return {
            header: 'Volume Streaming',
            isCollapsed: false,
            isBusy: false,
            isHidden: true,
            brand: { accent: 'cyan', svg: _controls_icons__WEBPACK_IMPORTED_MODULE_15__["BlurOnSvg"] }
        };
    };
    VolumeStreamingControls.prototype.componentDidMount = function () {
        var _this = this;
        // TODO: do not hide this but instead show some help text??
        this.subscribe(this.plugin.managers.structure.hierarchy.behaviors.selection, function () {
            _this.setState({
                isHidden: !_this.canEnable(),
                description: _mol_plugin_state_manager_structure_hierarchy__WEBPACK_IMPORTED_MODULE_2__["StructureHierarchyManager"].getSelectedStructuresDescription(_this.plugin)
            });
        });
        this.subscribe(this.plugin.state.events.cell.stateUpdated, function (e) {
            if (_mol_state__WEBPACK_IMPORTED_MODULE_7__["StateTransform"].hasTag(e.cell.transform, _mol_plugin_behavior_dynamic_volume_streaming_behavior__WEBPACK_IMPORTED_MODULE_5__["VolumeStreaming"].RootTag))
                _this.forceUpdate();
        });
        this.subscribe(this.plugin.behaviors.state.isBusy, function (v) {
            _this.setState({ isBusy: v });
        });
    };
    Object.defineProperty(VolumeStreamingControls.prototype, "pivot", {
        get: function () {
            return this.plugin.managers.structure.hierarchy.selection.structures[0];
        },
        enumerable: false,
        configurable: true
    });
    VolumeStreamingControls.prototype.canEnable = function () {
        var _a, _b;
        var selection = this.plugin.managers.structure.hierarchy.selection;
        if (selection.structures.length !== 1)
            return false;
        var pivot = this.pivot.cell;
        if (!pivot.obj)
            return false;
        return !!((_b = (_a = _mol_plugin_behavior_dynamic_volume_streaming_transformers__WEBPACK_IMPORTED_MODULE_6__["InitVolumeStreaming"].definition).isApplicable) === null || _b === void 0 ? void 0 : _b.call(_a, pivot.obj, pivot.transform, this.plugin));
    };
    VolumeStreamingControls.prototype.renderEnable = function () {
        var _a;
        var pivot = this.pivot;
        if (!pivot.cell.parent)
            return null;
        var root = _mol_state__WEBPACK_IMPORTED_MODULE_7__["StateSelection"].findTagInSubtree(pivot.cell.parent.tree, this.pivot.cell.transform.ref, _mol_plugin_behavior_dynamic_volume_streaming_behavior__WEBPACK_IMPORTED_MODULE_5__["VolumeStreaming"].RootTag);
        var rootCell = root && pivot.cell.parent.cells.get(root);
        var simpleApply = rootCell && rootCell.status === 'error'
            ? { header: 'Error enabling', icon: _controls_icons__WEBPACK_IMPORTED_MODULE_15__["ErrorSvg"], title: rootCell.errorText }
            : rootCell && ((_a = rootCell.obj) === null || _a === void 0 ? void 0 : _a.data.entries.length) === 0
                ? { header: 'Error enabling', icon: _controls_icons__WEBPACK_IMPORTED_MODULE_15__["ErrorSvg"], title: 'No entry for streaming found' }
                : { header: 'Enable', icon: _controls_icons__WEBPACK_IMPORTED_MODULE_15__["CheckSvg"], title: 'Enable' };
        return react__WEBPACK_IMPORTED_MODULE_1__["createElement"](_state_apply_action__WEBPACK_IMPORTED_MODULE_11__["ApplyActionControl"], { state: pivot.cell.parent, action: _mol_plugin_behavior_dynamic_volume_streaming_transformers__WEBPACK_IMPORTED_MODULE_6__["InitVolumeStreaming"], initiallyCollapsed: true, nodeRef: pivot.cell.transform.ref, simpleApply: simpleApply });
    };
    VolumeStreamingControls.prototype.renderParams = function () {
        var _a, _b, _c, _d, _e;
        var pivot = this.pivot;
        if (!pivot.cell.parent)
            return null;
        var bindings = ((_b = (_a = pivot.volumeStreaming) === null || _a === void 0 ? void 0 : _a.cell.transform.params) === null || _b === void 0 ? void 0 : _b.entry.params.view.name) === 'selection-box' && ((_e = (_d = (_c = this.plugin.state.behaviors.cells.get(_mol_plugin_behavior_dynamic_representation__WEBPACK_IMPORTED_MODULE_4__["FocusLoci"].id)) === null || _c === void 0 ? void 0 : _c.params) === null || _d === void 0 ? void 0 : _d.values) === null || _e === void 0 ? void 0 : _e.bindings);
        return react__WEBPACK_IMPORTED_MODULE_1__["createElement"](react__WEBPACK_IMPORTED_MODULE_1__["Fragment"], null,
            react__WEBPACK_IMPORTED_MODULE_1__["createElement"](_state_update_transform__WEBPACK_IMPORTED_MODULE_12__["UpdateTransformControl"], { state: pivot.cell.parent, transform: pivot.volumeStreaming.cell.transform, customHeader: 'none', noMargin: true }),
            bindings && react__WEBPACK_IMPORTED_MODULE_1__["createElement"](_controls_common__WEBPACK_IMPORTED_MODULE_10__["ExpandGroup"], { header: 'Controls Help' },
                react__WEBPACK_IMPORTED_MODULE_1__["createElement"](_viewport_help__WEBPACK_IMPORTED_MODULE_13__["BindingsHelp"], { bindings: bindings })));
    };
    VolumeStreamingControls.prototype.renderControls = function () {
        var pivot = this.pivot;
        if (!pivot)
            return null;
        if (!pivot.volumeStreaming)
            return this.renderEnable();
        return this.renderParams();
    };
    return VolumeStreamingControls;
}(_base__WEBPACK_IMPORTED_MODULE_8__["CollapsableControls"]));

var VolumeSourceControls = /** @class */ (function (_super) {
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__extends"])(VolumeSourceControls, _super);
    function VolumeSourceControls() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.item = function (ref) {
            var _a;
            var selected = _this.plugin.managers.volume.hierarchy.selection;
            var label = ((_a = ref.cell.obj) === null || _a === void 0 ? void 0 : _a.label) || 'Volume';
            var item = { kind: 'item', label: label || ref.kind, selected: selected === ref, value: ref };
            return item;
        };
        _this.selectCurrent = function (item) {
            _this.toggleHierarchy();
            if (!item)
                return;
            _this.plugin.managers.volume.hierarchy.setCurrent(item.value);
        };
        _this.selectAdd = function (item) {
            if (!item)
                return;
            _this.setState({ show: void 0 });
            item.value();
        };
        _this.toggleHierarchy = function () { return _this.setState({ show: _this.state.show !== 'hierarchy' ? 'hierarchy' : void 0 }); };
        _this.toggleAddRepr = function () { return _this.setState({ show: _this.state.show !== 'add-repr' ? 'add-repr' : void 0 }); };
        return _this;
    }
    VolumeSourceControls.prototype.defaultState = function () {
        return {
            header: 'Volume',
            isCollapsed: false,
            isBusy: false,
            isHidden: true,
            brand: { accent: 'purple', svg: _controls_icons__WEBPACK_IMPORTED_MODULE_15__["BlurOnSvg"] }
        };
    };
    VolumeSourceControls.prototype.componentDidMount = function () {
        var _this = this;
        this.subscribe(this.plugin.managers.volume.hierarchy.behaviors.selection, function (sel) {
            _this.setState({ isHidden: sel.hierarchy.volumes.length === 0 });
        });
        this.subscribe(this.plugin.behaviors.state.isBusy, function (v) {
            _this.setState({ isBusy: v });
        });
    };
    Object.defineProperty(VolumeSourceControls.prototype, "hierarchyItems", {
        get: function () {
            var mng = this.plugin.managers.volume.hierarchy;
            var current = mng.current;
            var ret = [];
            for (var _i = 0, _a = current.volumes; _i < _a.length; _i++) {
                var ref = _a[_i];
                ret.push(this.item(ref));
            }
            return ret;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(VolumeSourceControls.prototype, "addActions", {
        get: function () {
            var mng = this.plugin.managers.volume.hierarchy;
            var current = mng.selection;
            var ret = Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__spreadArrays"])(_mol_plugin_state_manager_volume_hierarchy__WEBPACK_IMPORTED_MODULE_3__["VolumeHierarchyManager"].getRepresentationTypes(this.plugin, current)
                .map(function (t) { return _controls_action_menu__WEBPACK_IMPORTED_MODULE_9__["ActionMenu"].Item(t[1], function () { return mng.addRepresentation(current, t[0]); }); }));
            return ret;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(VolumeSourceControls.prototype, "isEmpty", {
        get: function () {
            var volumes = this.plugin.managers.volume.hierarchy.current.volumes;
            return volumes.length === 0;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(VolumeSourceControls.prototype, "label", {
        get: function () {
            var _a;
            var selected = this.plugin.managers.volume.hierarchy.selection;
            if (!selected)
                return 'Nothing Selected';
            return ((_a = selected === null || selected === void 0 ? void 0 : selected.cell.obj) === null || _a === void 0 ? void 0 : _a.label) || 'Volume';
        },
        enumerable: false,
        configurable: true
    });
    VolumeSourceControls.prototype.renderControls = function () {
        var disabled = this.state.isBusy || this.isEmpty;
        var label = this.label;
        var selected = this.plugin.managers.volume.hierarchy.selection;
        return react__WEBPACK_IMPORTED_MODULE_1__["createElement"](react__WEBPACK_IMPORTED_MODULE_1__["Fragment"], null,
            react__WEBPACK_IMPORTED_MODULE_1__["createElement"]("div", { className: 'msp-flex-row', style: { marginTop: '1px' } },
                react__WEBPACK_IMPORTED_MODULE_1__["createElement"](_controls_common__WEBPACK_IMPORTED_MODULE_10__["Button"], { noOverflow: true, flex: true, onClick: this.toggleHierarchy, disabled: disabled, title: label }, label),
                !this.isEmpty && react__WEBPACK_IMPORTED_MODULE_1__["createElement"](_controls_common__WEBPACK_IMPORTED_MODULE_10__["IconButton"], { svg: _controls_icons__WEBPACK_IMPORTED_MODULE_15__["AddSvg"], onClick: this.toggleAddRepr, title: 'Apply a structure presets to the current hierarchy.', toggleState: this.state.show === 'add-repr', disabled: disabled })),
            this.state.show === 'hierarchy' && react__WEBPACK_IMPORTED_MODULE_1__["createElement"](_controls_action_menu__WEBPACK_IMPORTED_MODULE_9__["ActionMenu"], { items: this.hierarchyItems, onSelect: this.selectCurrent }),
            this.state.show === 'add-repr' && react__WEBPACK_IMPORTED_MODULE_1__["createElement"](_controls_action_menu__WEBPACK_IMPORTED_MODULE_9__["ActionMenu"], { items: this.addActions, onSelect: this.selectAdd }),
            selected && selected.representations.length > 0 && react__WEBPACK_IMPORTED_MODULE_1__["createElement"]("div", { style: { marginTop: '6px' } }, selected.representations.map(function (r) { return react__WEBPACK_IMPORTED_MODULE_1__["createElement"](VolumeRepresentationControls, { key: r.cell.transform.ref, representation: r }); })));
    };
    return VolumeSourceControls;
}(_base__WEBPACK_IMPORTED_MODULE_8__["CollapsableControls"]));

var VolumeRepresentationControls = /** @class */ (function (_super) {
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__extends"])(VolumeRepresentationControls, _super);
    function VolumeRepresentationControls() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = { action: void 0 };
        _this.remove = function () { return _this.plugin.managers.volume.hierarchy.remove([_this.props.representation], true); };
        _this.toggleVisible = function (e) {
            e.preventDefault();
            e.currentTarget.blur();
            _this.plugin.managers.volume.hierarchy.toggleVisibility([_this.props.representation]);
        };
        _this.toggleUpdate = function () { return _this.setState({ action: _this.state.action === 'update' ? void 0 : 'update' }); };
        _this.highlight = function (e) {
            e.preventDefault();
            if (!_this.props.representation.cell.parent)
                return;
            _mol_plugin_commands__WEBPACK_IMPORTED_MODULE_14__["PluginCommands"].Interactivity.Object.Highlight(_this.plugin, { state: _this.props.representation.cell.parent, ref: _this.props.representation.cell.transform.ref });
        };
        _this.clearHighlight = function (e) {
            e.preventDefault();
            _mol_plugin_commands__WEBPACK_IMPORTED_MODULE_14__["PluginCommands"].Interactivity.ClearHighlights(_this.plugin);
        };
        _this.focus = function () {
            var _a;
            var repr = _this.props.representation;
            var objects = (_a = _this.props.representation.cell.obj) === null || _a === void 0 ? void 0 : _a.data.repr.renderObjects;
            if (repr.cell.state.isHidden)
                _this.plugin.managers.volume.hierarchy.toggleVisibility([_this.props.representation], 'show');
            _this.plugin.managers.camera.focusRenderObjects(objects, { extraRadius: 1 });
        };
        return _this;
    }
    VolumeRepresentationControls.prototype.componentDidMount = function () {
        var _this = this;
        this.subscribe(this.plugin.state.events.cell.stateUpdated, function (e) {
            if (_mol_state__WEBPACK_IMPORTED_MODULE_7__["State"].ObjectEvent.isCell(e, _this.props.representation.cell))
                _this.forceUpdate();
        });
    };
    VolumeRepresentationControls.prototype.render = function () {
        var _a, _b, _c;
        var repr = this.props.representation.cell;
        return react__WEBPACK_IMPORTED_MODULE_1__["createElement"](react__WEBPACK_IMPORTED_MODULE_1__["Fragment"], null,
            react__WEBPACK_IMPORTED_MODULE_1__["createElement"]("div", { className: 'msp-flex-row' },
                react__WEBPACK_IMPORTED_MODULE_1__["createElement"](_controls_common__WEBPACK_IMPORTED_MODULE_10__["Button"], { noOverflow: true, className: 'msp-control-button-label', title: ((_a = repr.obj) === null || _a === void 0 ? void 0 : _a.label) + ". Click to focus.", onClick: this.focus, onMouseEnter: this.highlight, onMouseLeave: this.clearHighlight, style: { textAlign: 'left' } }, (_b = repr.obj) === null || _b === void 0 ? void 0 :
                    _b.label,
                    react__WEBPACK_IMPORTED_MODULE_1__["createElement"]("small", { className: 'msp-25-lower-contrast-text', style: { float: 'right' } }, (_c = repr.obj) === null || _c === void 0 ? void 0 : _c.description)),
                react__WEBPACK_IMPORTED_MODULE_1__["createElement"](_controls_common__WEBPACK_IMPORTED_MODULE_10__["IconButton"], { svg: repr.state.isHidden ? _controls_icons__WEBPACK_IMPORTED_MODULE_15__["VisibilityOffOutlinedSvg"] : _controls_icons__WEBPACK_IMPORTED_MODULE_15__["VisibilityOutlinedSvg"], toggleState: false, onClick: this.toggleVisible, title: (repr.state.isHidden ? 'Show' : 'Hide') + " component", small: true, className: 'msp-form-control', flex: true }),
                react__WEBPACK_IMPORTED_MODULE_1__["createElement"](_controls_common__WEBPACK_IMPORTED_MODULE_10__["IconButton"], { svg: _controls_icons__WEBPACK_IMPORTED_MODULE_15__["DeleteOutlinedSvg"], onClick: this.remove, title: 'Remove', small: true }),
                react__WEBPACK_IMPORTED_MODULE_1__["createElement"](_controls_common__WEBPACK_IMPORTED_MODULE_10__["IconButton"], { svg: _controls_icons__WEBPACK_IMPORTED_MODULE_15__["MoreHorizSvg"], onClick: this.toggleUpdate, title: 'Actions', toggleState: this.state.action === 'update' })),
            this.state.action === 'update' && !!repr.parent && react__WEBPACK_IMPORTED_MODULE_1__["createElement"]("div", { style: { marginBottom: '6px' }, className: 'msp-accent-offset' },
                react__WEBPACK_IMPORTED_MODULE_1__["createElement"](_state_update_transform__WEBPACK_IMPORTED_MODULE_12__["UpdateTransformControl"], { state: repr.parent, transform: repr.transform, customHeader: 'none', noMargin: true })));
    };
    return VolumeRepresentationControls;
}(_base__WEBPACK_IMPORTED_MODULE_8__["PurePluginUIComponent"]));
//# sourceMappingURL=volume.js.map

/***/ }),

/***/ "./lib/mol-plugin-ui/task.js":
/*!***********************************!*\
  !*** ./lib/mol-plugin-ui/task.js ***!
  \***********************************/
/*! exports provided: BackgroundTaskProgress, OverlayTaskProgress */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "BackgroundTaskProgress", function() { return BackgroundTaskProgress; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "OverlayTaskProgress", function() { return OverlayTaskProgress; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! react */ "./node_modules/react/index.js");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _base__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./base */ "./lib/mol-plugin-ui/base.js");
/* harmony import */ var immutable__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! immutable */ "./node_modules/immutable/dist/immutable.js");
/* harmony import */ var immutable__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(immutable__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var rxjs_operators__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! rxjs/operators */ "./node_modules/rxjs/_esm5/operators/index.js");
/* harmony import */ var _controls_common__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./controls/common */ "./lib/mol-plugin-ui/controls/common.js");
/* harmony import */ var _controls_icons__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ./controls/icons */ "./lib/mol-plugin-ui/controls/icons.js");
/**
 * Copyright (c) 2018 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author David Sehnal <david.sehnal@gmail.com>
 */







var BackgroundTaskProgress = /** @class */ (function (_super) {
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__extends"])(BackgroundTaskProgress, _super);
    function BackgroundTaskProgress() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = { tracked: Object(immutable__WEBPACK_IMPORTED_MODULE_3__["OrderedMap"])() };
        return _this;
    }
    BackgroundTaskProgress.prototype.componentDidMount = function () {
        var _this = this;
        var _a;
        var hideOverlay = !!((_a = this.plugin.spec.components) === null || _a === void 0 ? void 0 : _a.hideTaskOverlay);
        this.subscribe(this.plugin.events.task.progress.pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_4__["filter"])(function (e) { return e.level === 'background' && (hideOverlay || !e.useOverlay); })), function (e) {
            _this.setState({ tracked: _this.state.tracked.set(e.id, e) });
        });
        this.subscribe(this.plugin.events.task.finished, function (_a) {
            var id = _a.id;
            _this.setState({ tracked: _this.state.tracked.delete(id) });
        });
    };
    BackgroundTaskProgress.prototype.render = function () {
        return react__WEBPACK_IMPORTED_MODULE_1__["createElement"]("div", { className: 'msp-background-tasks' }, this.state.tracked.valueSeq().map(function (e) { return react__WEBPACK_IMPORTED_MODULE_1__["createElement"](ProgressEntry, { key: e.id, event: e }); }));
    };
    return BackgroundTaskProgress;
}(_base__WEBPACK_IMPORTED_MODULE_2__["PluginUIComponent"]));

var ProgressEntry = /** @class */ (function (_super) {
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__extends"])(ProgressEntry, _super);
    function ProgressEntry() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.abort = function () {
            _this.plugin.managers.task.requestAbort(_this.props.event.progress.root.progress.taskId, 'User Request');
        };
        return _this;
    }
    ProgressEntry.prototype.render = function () {
        var root = this.props.event.progress.root;
        var subtaskCount = countSubtasks(this.props.event.progress.root) - 1;
        var pr = root.progress.isIndeterminate
            ? void 0
            : react__WEBPACK_IMPORTED_MODULE_1__["createElement"](react__WEBPACK_IMPORTED_MODULE_1__["Fragment"], null,
                "[",
                root.progress.current,
                "/",
                root.progress.max,
                "]");
        var subtasks = subtaskCount > 0
            ? react__WEBPACK_IMPORTED_MODULE_1__["createElement"](react__WEBPACK_IMPORTED_MODULE_1__["Fragment"], null,
                "[",
                subtaskCount,
                " subtask(s)]")
            : void 0;
        return react__WEBPACK_IMPORTED_MODULE_1__["createElement"]("div", { className: 'msp-task-state' },
            react__WEBPACK_IMPORTED_MODULE_1__["createElement"]("div", null,
                root.progress.canAbort && react__WEBPACK_IMPORTED_MODULE_1__["createElement"](_controls_common__WEBPACK_IMPORTED_MODULE_5__["IconButton"], { svg: _controls_icons__WEBPACK_IMPORTED_MODULE_6__["CancelSvg"], onClick: this.abort, title: 'Abort' }),
                react__WEBPACK_IMPORTED_MODULE_1__["createElement"]("div", null,
                    root.progress.message,
                    " ",
                    pr,
                    " ",
                    subtasks)));
    };
    return ProgressEntry;
}(_base__WEBPACK_IMPORTED_MODULE_2__["PluginUIComponent"]));
function countSubtasks(progress) {
    if (progress.children.length === 0)
        return 1;
    var sum = 0;
    for (var _i = 0, _a = progress.children; _i < _a.length; _i++) {
        var c = _a[_i];
        sum += countSubtasks(c);
    }
    return sum;
}
var OverlayTaskProgress = /** @class */ (function (_super) {
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__extends"])(OverlayTaskProgress, _super);
    function OverlayTaskProgress() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = { tracked: Object(immutable__WEBPACK_IMPORTED_MODULE_3__["OrderedMap"])() };
        return _this;
    }
    OverlayTaskProgress.prototype.componentDidMount = function () {
        var _this = this;
        this.subscribe(this.plugin.events.task.progress.pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_4__["filter"])(function (e) { return !!e.useOverlay; })), function (e) {
            _this.setState({ tracked: _this.state.tracked.set(e.id, e) });
        });
        this.subscribe(this.plugin.events.task.finished, function (_a) {
            var id = _a.id;
            _this.setState({ tracked: _this.state.tracked.delete(id) });
        });
    };
    OverlayTaskProgress.prototype.render = function () {
        if (this.state.tracked.size === 0)
            return null;
        return react__WEBPACK_IMPORTED_MODULE_1__["createElement"]("div", { className: 'msp-overlay-tasks' }, this.state.tracked.valueSeq().map(function (e) { return react__WEBPACK_IMPORTED_MODULE_1__["createElement"](ProgressEntry, { key: e.id, event: e }); }));
    };
    return OverlayTaskProgress;
}(_base__WEBPACK_IMPORTED_MODULE_2__["PluginUIComponent"]));

//# sourceMappingURL=task.js.map

/***/ }),

/***/ "./lib/mol-plugin-ui/toast.js":
/*!************************************!*\
  !*** ./lib/mol-plugin-ui/toast.js ***!
  \************************************/
/*! exports provided: Toasts */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Toasts", function() { return Toasts; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! react */ "./node_modules/react/index.js");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _base__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./base */ "./lib/mol-plugin-ui/base.js");
/* harmony import */ var _controls_common__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./controls/common */ "./lib/mol-plugin-ui/controls/common.js");
/* harmony import */ var _controls_icons__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./controls/icons */ "./lib/mol-plugin-ui/controls/icons.js");
/**
 * Copyright (c) 2019 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * Adapted from LiteMol (c) David Sehnal
 *
 * @author David Sehnal <david.sehnal@gmail.com>
 */





var ToastEntry = /** @class */ (function (_super) {
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__extends"])(ToastEntry, _super);
    function ToastEntry() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.hide = function () {
            var entry = _this.props.entry;
            (entry.hide || function () { }).call(null);
        };
        return _this;
    }
    ToastEntry.prototype.render = function () {
        var _this = this;
        var entry = this.props.entry;
        var message = typeof entry.message === 'string'
            ? react__WEBPACK_IMPORTED_MODULE_1__["createElement"]("div", { dangerouslySetInnerHTML: { __html: entry.message } })
            : react__WEBPACK_IMPORTED_MODULE_1__["createElement"]("div", null,
                react__WEBPACK_IMPORTED_MODULE_1__["createElement"](entry.message, null));
        return react__WEBPACK_IMPORTED_MODULE_1__["createElement"]("div", { className: 'msp-toast-entry' },
            react__WEBPACK_IMPORTED_MODULE_1__["createElement"]("div", { className: 'msp-toast-title', onClick: function () { return _this.hide(); } }, entry.title),
            react__WEBPACK_IMPORTED_MODULE_1__["createElement"]("div", { className: 'msp-toast-message' }, message),
            react__WEBPACK_IMPORTED_MODULE_1__["createElement"]("div", { className: 'msp-toast-clear' }),
            react__WEBPACK_IMPORTED_MODULE_1__["createElement"]("div", { className: 'msp-toast-hide' },
                react__WEBPACK_IMPORTED_MODULE_1__["createElement"](_controls_common__WEBPACK_IMPORTED_MODULE_3__["IconButton"], { svg: _controls_icons__WEBPACK_IMPORTED_MODULE_4__["CancelSvg"], onClick: this.hide, title: 'Hide', className: 'msp-no-hover-outline' })));
    };
    return ToastEntry;
}(_base__WEBPACK_IMPORTED_MODULE_2__["PluginUIComponent"]));
var Toasts = /** @class */ (function (_super) {
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__extends"])(Toasts, _super);
    function Toasts() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Toasts.prototype.componentDidMount = function () {
        var _this = this;
        this.subscribe(this.plugin.managers.toast.events.changed, function () { return _this.forceUpdate(); });
    };
    Toasts.prototype.render = function () {
        var state = this.plugin.managers.toast.state;
        if (!state.entries.count())
            return null;
        var entries = [];
        state.entries.forEach(function (t, k) { return entries.push(t); });
        entries.sort(function (x, y) { return x.serialNumber - y.serialNumber; });
        return react__WEBPACK_IMPORTED_MODULE_1__["createElement"]("div", { className: 'msp-toast-container' }, entries.map(function (e) { return react__WEBPACK_IMPORTED_MODULE_1__["createElement"](ToastEntry, { key: e.serialNumber, entry: e }); }));
    };
    return Toasts;
}(_base__WEBPACK_IMPORTED_MODULE_2__["PluginUIComponent"]));

//# sourceMappingURL=toast.js.map

/***/ }),

/***/ "./lib/mol-plugin-ui/viewport.js":
/*!***************************************!*\
  !*** ./lib/mol-plugin-ui/viewport.js ***!
  \***************************************/
/*! exports provided: ViewportControls, Logo, Viewport */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ViewportControls", function() { return ViewportControls; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Logo", function() { return Logo; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Viewport", function() { return Viewport; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! react */ "./node_modules/react/index.js");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _mol_plugin_commands__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../mol-plugin/commands */ "./lib/mol-plugin/commands.js");
/* harmony import */ var _mol_plugin_config__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../mol-plugin/config */ "./lib/mol-plugin/config.js");
/* harmony import */ var _base__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./base */ "./lib/mol-plugin-ui/base.js");
/* harmony import */ var _controls_common__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./controls/common */ "./lib/mol-plugin-ui/controls/common.js");
/* harmony import */ var _controls_icons__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ./controls/icons */ "./lib/mol-plugin-ui/controls/icons.js");
/* harmony import */ var _structure_selection__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ./structure/selection */ "./lib/mol-plugin-ui/structure/selection.js");
/* harmony import */ var _viewport_canvas__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ./viewport/canvas */ "./lib/mol-plugin-ui/viewport/canvas.js");
/* harmony import */ var _viewport_screenshot__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ./viewport/screenshot */ "./lib/mol-plugin-ui/viewport/screenshot.js");
/* harmony import */ var _viewport_simple_settings__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ./viewport/simple-settings */ "./lib/mol-plugin-ui/viewport/simple-settings.js");
/**
 * Copyright (c) 2018-2019 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 * @author David Sehnal <david.sehnal@gmail.com>
 */











var ViewportControls = /** @class */ (function (_super) {
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__extends"])(ViewportControls, _super);
    function ViewportControls() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.allCollapsedState = {
            isSettingsExpanded: false,
            isScreenshotExpanded: false
        };
        _this.state = Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, _this.allCollapsedState);
        _this.resetCamera = function () {
            _mol_plugin_commands__WEBPACK_IMPORTED_MODULE_2__["PluginCommands"].Camera.Reset(_this.plugin, {});
        };
        _this.toggleSettingsExpanded = _this.toggle('isSettingsExpanded');
        _this.toggleScreenshotExpanded = _this.toggle('isScreenshotExpanded');
        _this.toggleControls = function () {
            _mol_plugin_commands__WEBPACK_IMPORTED_MODULE_2__["PluginCommands"].Layout.Update(_this.plugin, { state: { showControls: !_this.plugin.layout.state.showControls } });
        };
        _this.toggleExpanded = function () {
            _mol_plugin_commands__WEBPACK_IMPORTED_MODULE_2__["PluginCommands"].Layout.Update(_this.plugin, { state: { isExpanded: !_this.plugin.layout.state.isExpanded } });
        };
        _this.setSettings = function (p) {
            var _a;
            _mol_plugin_commands__WEBPACK_IMPORTED_MODULE_2__["PluginCommands"].Canvas3D.SetSettings(_this.plugin, { settings: (_a = {}, _a[p.name] = p.value, _a) });
        };
        _this.setLayout = function (p) {
            var _a;
            _mol_plugin_commands__WEBPACK_IMPORTED_MODULE_2__["PluginCommands"].Layout.Update(_this.plugin, { state: (_a = {}, _a[p.name] = p.value, _a) });
        };
        _this.screenshot = function () {
            var _a;
            (_a = _this.plugin.helpers.viewportScreenshot) === null || _a === void 0 ? void 0 : _a.download();
        };
        _this.onMouseMove = function (e) {
            // ignore mouse moves when no button is held
            if (e.buttons === 0)
                e.stopPropagation();
        };
        return _this;
    }
    ViewportControls.prototype.toggle = function (panel) {
        var _this = this;
        return function (e) {
            var _a;
            _this.setState(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, _this.allCollapsedState), (_a = {}, _a[panel] = !_this.state[panel], _a)));
            e === null || e === void 0 ? void 0 : e.currentTarget.blur();
        };
    };
    ViewportControls.prototype.componentDidMount = function () {
        var _this = this;
        this.subscribe(this.plugin.events.canvas3d.settingsUpdated, function () { return _this.forceUpdate(); });
        this.subscribe(this.plugin.layout.events.updated, function () { return _this.forceUpdate(); });
    };
    ViewportControls.prototype.icon = function (icon, onClick, title, isOn) {
        if (isOn === void 0) { isOn = true; }
        return react__WEBPACK_IMPORTED_MODULE_1__["createElement"](_controls_common__WEBPACK_IMPORTED_MODULE_5__["IconButton"], { svg: icon, toggleState: isOn, onClick: onClick, title: title, style: { background: 'transparent' } });
    };
    ViewportControls.prototype.render = function () {
        return react__WEBPACK_IMPORTED_MODULE_1__["createElement"]("div", { className: 'msp-viewport-controls', onMouseMove: this.onMouseMove },
            react__WEBPACK_IMPORTED_MODULE_1__["createElement"]("div", { className: 'msp-viewport-controls-buttons' },
                react__WEBPACK_IMPORTED_MODULE_1__["createElement"]("div", null,
                    react__WEBPACK_IMPORTED_MODULE_1__["createElement"]("div", { className: 'msp-semi-transparent-background' }),
                    this.icon(_controls_icons__WEBPACK_IMPORTED_MODULE_6__["AutorenewSvg"], this.resetCamera, 'Reset Camera')),
                react__WEBPACK_IMPORTED_MODULE_1__["createElement"]("div", null,
                    react__WEBPACK_IMPORTED_MODULE_1__["createElement"]("div", { className: 'msp-semi-transparent-background' }),
                    this.icon(_controls_icons__WEBPACK_IMPORTED_MODULE_6__["CameraOutlinedSvg"], this.toggleScreenshotExpanded, 'Screenshot / State Snapshot', this.state.isScreenshotExpanded)),
                react__WEBPACK_IMPORTED_MODULE_1__["createElement"]("div", null,
                    react__WEBPACK_IMPORTED_MODULE_1__["createElement"]("div", { className: 'msp-semi-transparent-background' }),
                    this.plugin.config.get(_mol_plugin_config__WEBPACK_IMPORTED_MODULE_3__["PluginConfig"].Viewport.ShowControls) && this.icon(_controls_icons__WEBPACK_IMPORTED_MODULE_6__["BuildOutlinedSvg"], this.toggleControls, 'Toggle Controls Panel', this.plugin.layout.state.showControls),
                    this.plugin.config.get(_mol_plugin_config__WEBPACK_IMPORTED_MODULE_3__["PluginConfig"].Viewport.ShowExpand) && this.icon(_controls_icons__WEBPACK_IMPORTED_MODULE_6__["FullscreenSvg"], this.toggleExpanded, 'Toggle Expanded Viewport', this.plugin.layout.state.isExpanded),
                    this.plugin.config.get(_mol_plugin_config__WEBPACK_IMPORTED_MODULE_3__["PluginConfig"].Viewport.ShowSettings) && this.icon(_controls_icons__WEBPACK_IMPORTED_MODULE_6__["TuneSvg"], this.toggleSettingsExpanded, 'Settings / Controls Info', this.state.isSettingsExpanded)),
                this.plugin.config.get(_mol_plugin_config__WEBPACK_IMPORTED_MODULE_3__["PluginConfig"].Viewport.ShowSelectionMode) && react__WEBPACK_IMPORTED_MODULE_1__["createElement"]("div", null,
                    react__WEBPACK_IMPORTED_MODULE_1__["createElement"]("div", { className: 'msp-semi-transparent-background' }),
                    react__WEBPACK_IMPORTED_MODULE_1__["createElement"](_structure_selection__WEBPACK_IMPORTED_MODULE_7__["ToggleSelectionModeButton"], null))),
            this.state.isScreenshotExpanded && react__WEBPACK_IMPORTED_MODULE_1__["createElement"]("div", { className: 'msp-viewport-controls-panel' },
                react__WEBPACK_IMPORTED_MODULE_1__["createElement"](_controls_common__WEBPACK_IMPORTED_MODULE_5__["ControlGroup"], { header: 'Screenshot / State', title: 'Click to close.', initialExpanded: true, hideExpander: true, hideOffset: true, onHeaderClick: this.toggleScreenshotExpanded, topRightIcon: _controls_icons__WEBPACK_IMPORTED_MODULE_6__["CloseSvg"], noTopMargin: true, childrenClassName: 'msp-viewport-controls-panel-controls' },
                    react__WEBPACK_IMPORTED_MODULE_1__["createElement"](_viewport_screenshot__WEBPACK_IMPORTED_MODULE_9__["DownloadScreenshotControls"], { close: this.toggleScreenshotExpanded }))),
            this.state.isSettingsExpanded && react__WEBPACK_IMPORTED_MODULE_1__["createElement"]("div", { className: 'msp-viewport-controls-panel' },
                react__WEBPACK_IMPORTED_MODULE_1__["createElement"](_controls_common__WEBPACK_IMPORTED_MODULE_5__["ControlGroup"], { header: 'Settings / Controls Info', title: 'Click to close.', initialExpanded: true, hideExpander: true, hideOffset: true, onHeaderClick: this.toggleSettingsExpanded, topRightIcon: _controls_icons__WEBPACK_IMPORTED_MODULE_6__["CloseSvg"], noTopMargin: true, childrenClassName: 'msp-viewport-controls-panel-controls' },
                    react__WEBPACK_IMPORTED_MODULE_1__["createElement"](_viewport_simple_settings__WEBPACK_IMPORTED_MODULE_10__["SimpleSettingsControl"], null))));
    };
    return ViewportControls;
}(_base__WEBPACK_IMPORTED_MODULE_4__["PluginUIComponent"]));

var Logo = function () {
    return react__WEBPACK_IMPORTED_MODULE_1__["createElement"]("a", { className: 'msp-logo', href: 'https://molstar.org', target: '_blank' });
};
var Viewport = function () { return react__WEBPACK_IMPORTED_MODULE_1__["createElement"](_viewport_canvas__WEBPACK_IMPORTED_MODULE_8__["ViewportCanvas"], { logo: Logo }); };
//# sourceMappingURL=viewport.js.map

/***/ }),

/***/ "./lib/mol-plugin-ui/viewport/canvas.js":
/*!**********************************************!*\
  !*** ./lib/mol-plugin-ui/viewport/canvas.js ***!
  \**********************************************/
/*! exports provided: ViewportCanvas */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ViewportCanvas", function() { return ViewportCanvas; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! react */ "./node_modules/react/index.js");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _base__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../base */ "./lib/mol-plugin-ui/base.js");
/**
 * Copyright (c) 2020-2021 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author David Sehnal <david.sehnal@gmail.com>
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */



var ViewportCanvas = /** @class */ (function (_super) {
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__extends"])(ViewportCanvas, _super);
    function ViewportCanvas() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.container = react__WEBPACK_IMPORTED_MODULE_1__["createRef"]();
        _this.canvas = react__WEBPACK_IMPORTED_MODULE_1__["createRef"]();
        _this.state = {
            noWebGl: false,
            showLogo: true
        };
        _this.handleLogo = function () {
            var _a;
            _this.setState({ showLogo: !((_a = _this.plugin.canvas3d) === null || _a === void 0 ? void 0 : _a.reprCount.value) });
        };
        return _this;
    }
    ViewportCanvas.prototype.componentDidMount = function () {
        if (!this.canvas.current || !this.container.current || !this.plugin.initViewer(this.canvas.current, this.container.current)) {
            this.setState({ noWebGl: true });
            return;
        }
        this.handleLogo();
        this.subscribe(this.plugin.canvas3d.reprCount, this.handleLogo);
    };
    ViewportCanvas.prototype.componentWillUnmount = function () {
        _super.prototype.componentWillUnmount.call(this);
        // TODO viewer cleanup
    };
    ViewportCanvas.prototype.renderMissing = function () {
        if (this.props.noWebGl) {
            var C = this.props.noWebGl;
            return react__WEBPACK_IMPORTED_MODULE_1__["createElement"](C, null);
        }
        return react__WEBPACK_IMPORTED_MODULE_1__["createElement"]("div", { className: 'msp-no-webgl' },
            react__WEBPACK_IMPORTED_MODULE_1__["createElement"]("div", null,
                react__WEBPACK_IMPORTED_MODULE_1__["createElement"]("p", null,
                    react__WEBPACK_IMPORTED_MODULE_1__["createElement"]("b", null, "WebGL does not seem to be available.")),
                react__WEBPACK_IMPORTED_MODULE_1__["createElement"]("p", null, "This can be caused by an outdated browser, graphics card driver issue, or bad weather. Sometimes, just restarting the browser helps."),
                react__WEBPACK_IMPORTED_MODULE_1__["createElement"]("p", null,
                    "For a list of supported browsers, refer to ",
                    react__WEBPACK_IMPORTED_MODULE_1__["createElement"]("a", { href: 'http://caniuse.com/#feat=webgl', target: '_blank' }, "http://caniuse.com/#feat=webgl"),
                    ".")));
    };
    ViewportCanvas.prototype.render = function () {
        if (this.state.noWebGl)
            return this.renderMissing();
        var Logo = this.props.logo;
        return react__WEBPACK_IMPORTED_MODULE_1__["createElement"]("div", { className: this.props.parentClassName || 'msp-viewport', style: this.props.parentStyle },
            react__WEBPACK_IMPORTED_MODULE_1__["createElement"]("div", { className: this.props.hostClassName || 'msp-viewport-host3d', style: this.props.hostStyle, ref: this.container },
                react__WEBPACK_IMPORTED_MODULE_1__["createElement"]("canvas", { ref: this.canvas })),
            (this.state.showLogo && Logo) && react__WEBPACK_IMPORTED_MODULE_1__["createElement"](Logo, null));
    };
    return ViewportCanvas;
}(_base__WEBPACK_IMPORTED_MODULE_2__["PluginUIComponent"]));

//# sourceMappingURL=canvas.js.map

/***/ }),

/***/ "./lib/mol-plugin-ui/viewport/help.js":
/*!********************************************!*\
  !*** ./lib/mol-plugin-ui/viewport/help.js ***!
  \********************************************/
/*! exports provided: BindingsHelp, HelpText, HelpGroup, ViewportHelpContent, HelpContent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "BindingsHelp", function() { return BindingsHelp; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "HelpText", function() { return HelpText; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "HelpGroup", function() { return HelpGroup; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ViewportHelpContent", function() { return ViewportHelpContent; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "HelpContent", function() { return HelpContent; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! react */ "./node_modules/react/index.js");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _mol_util_binding__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../mol-util/binding */ "./lib/mol-util/binding.js");
/* harmony import */ var _base__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../base */ "./lib/mol-plugin-ui/base.js");
/* harmony import */ var _mol_state__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../mol-state */ "./lib/mol-state/index.js");
/* harmony import */ var _mol_plugin_behavior_dynamic_representation__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../mol-plugin/behavior/dynamic/representation */ "./lib/mol-plugin/behavior/dynamic/representation.js");
/* harmony import */ var _controls_icons__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../controls/icons */ "./lib/mol-plugin-ui/controls/icons.js");
/* harmony import */ var _controls_common__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../controls/common */ "./lib/mol-plugin-ui/controls/common.js");
/**
 * Copyright (c) 2019-2020 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */









function getBindingsList(bindings) {
    return Object.keys(bindings).map(function (k) { return [k, bindings[k]]; });
}
var BindingsHelp = /** @class */ (function (_super) {
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__extends"])(BindingsHelp, _super);
    function BindingsHelp() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    BindingsHelp.prototype.getBindingComponents = function () {
        var bindingsList = getBindingsList(this.props.bindings);
        return react__WEBPACK_IMPORTED_MODULE_1__["createElement"](react__WEBPACK_IMPORTED_MODULE_1__["Fragment"], null, bindingsList.map(function (value) {
            var name = value[0], binding = value[1];
            return !_mol_util_binding__WEBPACK_IMPORTED_MODULE_2__["Binding"].isEmpty(binding)
                ? react__WEBPACK_IMPORTED_MODULE_1__["createElement"]("div", { key: name, style: { marginBottom: '6px' } },
                    react__WEBPACK_IMPORTED_MODULE_1__["createElement"]("b", null, binding.action),
                    react__WEBPACK_IMPORTED_MODULE_1__["createElement"]("br", null),
                    react__WEBPACK_IMPORTED_MODULE_1__["createElement"]("span", { dangerouslySetInnerHTML: { __html: _mol_util_binding__WEBPACK_IMPORTED_MODULE_2__["Binding"].format(binding, name) } }))
                : null;
        }));
    };
    BindingsHelp.prototype.render = function () {
        return react__WEBPACK_IMPORTED_MODULE_1__["createElement"](HelpText, null, this.getBindingComponents());
    };
    return BindingsHelp;
}(react__WEBPACK_IMPORTED_MODULE_1__["PureComponent"]));

var HelpText = /** @class */ (function (_super) {
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__extends"])(HelpText, _super);
    function HelpText() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    HelpText.prototype.render = function () {
        return react__WEBPACK_IMPORTED_MODULE_1__["createElement"]("div", { className: 'msp-help-text' },
            react__WEBPACK_IMPORTED_MODULE_1__["createElement"]("div", null, this.props.children));
    };
    return HelpText;
}(react__WEBPACK_IMPORTED_MODULE_1__["PureComponent"]));

var HelpGroup = /** @class */ (function (_super) {
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__extends"])(HelpGroup, _super);
    function HelpGroup() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            header: _this.props.header,
            isExpanded: !!_this.props.initiallyExpanded
        };
        _this.toggleExpanded = function () { return _this.setState({ isExpanded: !_this.state.isExpanded }); };
        return _this;
    }
    HelpGroup.prototype.render = function () {
        return react__WEBPACK_IMPORTED_MODULE_1__["createElement"]("div", { className: 'msp-control-group-wrapper' },
            react__WEBPACK_IMPORTED_MODULE_1__["createElement"]("div", { className: 'msp-control-group-header' },
                react__WEBPACK_IMPORTED_MODULE_1__["createElement"](_controls_common__WEBPACK_IMPORTED_MODULE_7__["Button"], { onClick: this.toggleExpanded },
                    react__WEBPACK_IMPORTED_MODULE_1__["createElement"](_controls_icons__WEBPACK_IMPORTED_MODULE_6__["Icon"], { svg: this.state.isExpanded ? _controls_icons__WEBPACK_IMPORTED_MODULE_6__["ArrowDropDownSvg"] : _controls_icons__WEBPACK_IMPORTED_MODULE_6__["ArrowRightSvg"] }),
                    this.props.header)),
            this.state.isExpanded && react__WEBPACK_IMPORTED_MODULE_1__["createElement"]("div", { className: 'msp-control-offset', style: { display: this.state.isExpanded ? 'block' : 'none' } }, this.props.children));
    };
    return HelpGroup;
}(react__WEBPACK_IMPORTED_MODULE_1__["PureComponent"]));

function HelpSection(props) {
    return react__WEBPACK_IMPORTED_MODULE_1__["createElement"]("div", { className: 'msp-simple-help-section' }, props.header);
}
var ViewportHelpContent = /** @class */ (function (_super) {
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__extends"])(ViewportHelpContent, _super);
    function ViewportHelpContent() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ViewportHelpContent.prototype.componentDidMount = function () {
        var _this = this;
        this.subscribe(this.plugin.events.canvas3d.settingsUpdated, function () { return _this.forceUpdate(); });
    };
    ViewportHelpContent.prototype.render = function () {
        var interactionBindings = {};
        this.plugin.spec.behaviors.forEach(function (b) {
            var bindings = b.defaultParams.bindings;
            if (bindings)
                Object.assign(interactionBindings, bindings);
        });
        return react__WEBPACK_IMPORTED_MODULE_1__["createElement"](react__WEBPACK_IMPORTED_MODULE_1__["Fragment"], null,
            (!this.props.selectOnly && this.plugin.canvas3d) && react__WEBPACK_IMPORTED_MODULE_1__["createElement"](HelpGroup, { key: 'trackball', header: 'Moving in 3D' },
                react__WEBPACK_IMPORTED_MODULE_1__["createElement"](BindingsHelp, { bindings: this.plugin.canvas3d.props.trackball.bindings })),
            react__WEBPACK_IMPORTED_MODULE_1__["createElement"](HelpGroup, { key: 'interactions', header: 'Mouse Controls' },
                react__WEBPACK_IMPORTED_MODULE_1__["createElement"](BindingsHelp, { bindings: interactionBindings })));
    };
    return ViewportHelpContent;
}(_base__WEBPACK_IMPORTED_MODULE_3__["PluginUIComponent"]));

var HelpContent = /** @class */ (function (_super) {
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__extends"])(HelpContent, _super);
    function HelpContent() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    HelpContent.prototype.componentDidMount = function () {
        var _this = this;
        this.subscribe(this.plugin.events.canvas3d.settingsUpdated, function () { return _this.forceUpdate(); });
    };
    HelpContent.prototype.formatTriggers = function (binding) {
        return binding.triggers.map(function (t) { return _mol_util_binding__WEBPACK_IMPORTED_MODULE_2__["Binding"].Trigger.format(t); }).join(' or ');
    };
    HelpContent.prototype.getTriggerFor = function (transformer, name) {
        var state = this.plugin.state.behaviors;
        var selections = state.select(_mol_state__WEBPACK_IMPORTED_MODULE_4__["StateSelection"].Generators.ofTransformer(transformer));
        var params = selections.length === 1 ? selections[0].params : undefined;
        var bindings = params ? params.values.bindings : {};
        var binding = name in bindings ? bindings[name] : _mol_util_binding__WEBPACK_IMPORTED_MODULE_2__["Binding"].Empty;
        return this.formatTriggers(binding);
    };
    HelpContent.prototype.render = function () {
        var selectToggleTriggers = this.getTriggerFor(_mol_plugin_behavior_dynamic_representation__WEBPACK_IMPORTED_MODULE_5__["SelectLoci"], 'clickSelectToggle');
        var focusTriggers = this.getTriggerFor(_mol_plugin_behavior_dynamic_representation__WEBPACK_IMPORTED_MODULE_5__["FocusLoci"], 'clickFocus');
        // TODO: interactive help, for example for density
        return react__WEBPACK_IMPORTED_MODULE_1__["createElement"]("div", null,
            react__WEBPACK_IMPORTED_MODULE_1__["createElement"](HelpSection, { header: 'Interface Controls' }),
            react__WEBPACK_IMPORTED_MODULE_1__["createElement"](HelpGroup, { header: 'Inline Help' },
                react__WEBPACK_IMPORTED_MODULE_1__["createElement"](HelpText, null, "Many user interface elements show a little questionmark icon when hovered over. Clicking the icon toggles the display of an inline help text."),
                react__WEBPACK_IMPORTED_MODULE_1__["createElement"](HelpText, null, "Tooltips may provide additional information on a user interface element and are shown when hovering over it with the mouse.")),
            react__WEBPACK_IMPORTED_MODULE_1__["createElement"](HelpGroup, { header: 'Selections' },
                react__WEBPACK_IMPORTED_MODULE_1__["createElement"](HelpText, null,
                    "The viewer allows changing colors and representations for selections of atoms, residues or chains. Selections can be created by",
                    react__WEBPACK_IMPORTED_MODULE_1__["createElement"]("ul", { style: { paddingLeft: '20px' } },
                        react__WEBPACK_IMPORTED_MODULE_1__["createElement"]("li", null,
                            "picking elements on the 3D canvas or the sequence view using the mouse, e.g. toggle selection using ",
                            selectToggleTriggers,
                            " (for more see help section on ",
                            react__WEBPACK_IMPORTED_MODULE_1__["createElement"]("i", null, "Mouse Controls"),
                            ")"),
                        react__WEBPACK_IMPORTED_MODULE_1__["createElement"]("li", null,
                            "using the ",
                            react__WEBPACK_IMPORTED_MODULE_1__["createElement"]("i", null, "Add"),
                            ", ",
                            react__WEBPACK_IMPORTED_MODULE_1__["createElement"]("i", null, "Remove"),
                            " and ",
                            react__WEBPACK_IMPORTED_MODULE_1__["createElement"]("i", null, "Only"),
                            " dropdown buttons in the ",
                            react__WEBPACK_IMPORTED_MODULE_1__["createElement"]("i", null, "Manage Selection"),
                            " panel which allow modifing the current selection by predefined sets")))),
            react__WEBPACK_IMPORTED_MODULE_1__["createElement"](HelpGroup, { header: 'Coloring' },
                react__WEBPACK_IMPORTED_MODULE_1__["createElement"](HelpText, null,
                    "There are two ways to color structures. Every representation (e.g. cartoon or spacefill) has a color theme which can be changed using the dropdown for each representation in the ",
                    react__WEBPACK_IMPORTED_MODULE_1__["createElement"]("i", null, "Structure Settings"),
                    " panel. Additionally any selection atoms, residues or chains can by given a custom color. For that, first select the parts of the structure to be colored (see help section on ",
                    react__WEBPACK_IMPORTED_MODULE_1__["createElement"]("i", null, "Selections"),
                    ") and, second, choose a color from the color dropdown botton in the ",
                    react__WEBPACK_IMPORTED_MODULE_1__["createElement"]("i", null, "Selection"),
                    " row of the ",
                    react__WEBPACK_IMPORTED_MODULE_1__["createElement"]("i", null, "Change Representation"),
                    " panel. The theme color can be seen as a base color that is overpainted by the custom color. Custom colors can be removed for a selection with the 'Clear' option in the color dropdown.")),
            react__WEBPACK_IMPORTED_MODULE_1__["createElement"](HelpGroup, { header: 'Representations' },
                react__WEBPACK_IMPORTED_MODULE_1__["createElement"](HelpText, null,
                    "Structures can be shown with many different representations (e.g. cartoon or spacefill). The ",
                    react__WEBPACK_IMPORTED_MODULE_1__["createElement"]("i", null, "Change Representation"),
                    " panel offers a collection of predefined styles which can be applied using the ",
                    react__WEBPACK_IMPORTED_MODULE_1__["createElement"]("i", null, "Preset"),
                    " dropdown button. Additionally any selection atoms, residues or chains can by shown with a custom representation. For that, first select the parts of the structure to be mofified (see help section on ",
                    react__WEBPACK_IMPORTED_MODULE_1__["createElement"]("i", null, "Selections"),
                    ") and, second, choose a representation to hide or show from the ",
                    react__WEBPACK_IMPORTED_MODULE_1__["createElement"]("i", null, "Show"),
                    " and ",
                    react__WEBPACK_IMPORTED_MODULE_1__["createElement"]("i", null, "Hide"),
                    " dropdown bottons in the ",
                    react__WEBPACK_IMPORTED_MODULE_1__["createElement"]("i", null, "Selection"),
                    " row of the ",
                    react__WEBPACK_IMPORTED_MODULE_1__["createElement"]("i", null, "Change Representation"),
                    " panel. The ",
                    react__WEBPACK_IMPORTED_MODULE_1__["createElement"]("i", null, "Everything"),
                    " row applies the action to the whole structure instead of the current selection.")),
            react__WEBPACK_IMPORTED_MODULE_1__["createElement"](HelpGroup, { header: 'Surroundings' },
                react__WEBPACK_IMPORTED_MODULE_1__["createElement"](HelpText, null,
                    "To show the surroundings of a residue or ligand, click it in the 3D scene or in the sequence widget using ",
                    focusTriggers,
                    ".")),
            react__WEBPACK_IMPORTED_MODULE_1__["createElement"](HelpSection, { header: 'How-to Guides' }),
            react__WEBPACK_IMPORTED_MODULE_1__["createElement"](HelpGroup, { header: 'Create an Image' },
                react__WEBPACK_IMPORTED_MODULE_1__["createElement"](HelpText, null,
                    react__WEBPACK_IMPORTED_MODULE_1__["createElement"]("p", null,
                        "Use the ",
                        react__WEBPACK_IMPORTED_MODULE_1__["createElement"](_controls_icons__WEBPACK_IMPORTED_MODULE_6__["Icon"], { svg: _controls_icons__WEBPACK_IMPORTED_MODULE_6__["CameraSvg"] }),
                        " icon in the viewport to bring up the screenshot controls."),
                    react__WEBPACK_IMPORTED_MODULE_1__["createElement"]("p", null,
                        "To adjust the size of the image, use the ",
                        react__WEBPACK_IMPORTED_MODULE_1__["createElement"]("i", null, "Resolution"),
                        " dropdown."))),
            react__WEBPACK_IMPORTED_MODULE_1__["createElement"](HelpSection, { header: 'Mouse Controls' }),
            react__WEBPACK_IMPORTED_MODULE_1__["createElement"](ViewportHelpContent, null));
    };
    return HelpContent;
}(_base__WEBPACK_IMPORTED_MODULE_3__["PluginUIComponent"]));

//# sourceMappingURL=help.js.map

/***/ }),

/***/ "./lib/mol-plugin-ui/viewport/screenshot.js":
/*!**************************************************!*\
  !*** ./lib/mol-plugin-ui/viewport/screenshot.js ***!
  \**************************************************/
/*! exports provided: DownloadScreenshotControls */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DownloadScreenshotControls", function() { return DownloadScreenshotControls; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! react */ "./node_modules/react/index.js");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _mol_plugin_commands__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../mol-plugin/commands */ "./lib/mol-plugin/commands.js");
/* harmony import */ var _base__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../base */ "./lib/mol-plugin-ui/base.js");
/* harmony import */ var _controls_common__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../controls/common */ "./lib/mol-plugin-ui/controls/common.js");
/* harmony import */ var _controls_icons__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../controls/icons */ "./lib/mol-plugin-ui/controls/icons.js");
/* harmony import */ var _controls_parameters__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../controls/parameters */ "./lib/mol-plugin-ui/controls/parameters.js");
/* harmony import */ var _controls_screenshot__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../controls/screenshot */ "./lib/mol-plugin-ui/controls/screenshot.js");
/* harmony import */ var _hooks_use_behavior__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ../hooks/use-behavior */ "./lib/mol-plugin-ui/hooks/use-behavior.js");
/* harmony import */ var _state_snapshots__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ../state/snapshots */ "./lib/mol-plugin-ui/state/snapshots.js");
/**
 * Copyright (c) 2019-2020 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 * @author David Sehnal <david.sehnal@gmail.com>
 */










var DownloadScreenshotControls = /** @class */ (function (_super) {
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__extends"])(DownloadScreenshotControls, _super);
    function DownloadScreenshotControls() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            showPreview: true,
            isDisabled: false
        };
        _this.download = function () {
            var _a;
            (_a = _this.plugin.helpers.viewportScreenshot) === null || _a === void 0 ? void 0 : _a.download();
            _this.props.close();
        };
        _this.copy = function () { return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"])(_this, void 0, void 0, function () {
            var _a;
            return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__generator"])(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, ((_a = this.plugin.helpers.viewportScreenshot) === null || _a === void 0 ? void 0 : _a.copyToClipboard())];
                    case 1:
                        _b.sent();
                        _mol_plugin_commands__WEBPACK_IMPORTED_MODULE_2__["PluginCommands"].Toast.Show(this.plugin, {
                            message: 'Copied to clipboard.',
                            title: 'Screenshot',
                            timeoutMs: 1500
                        });
                        return [2 /*return*/];
                }
            });
        }); };
        _this.copyImg = function () { return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"])(_this, void 0, void 0, function () {
            var src;
            var _a;
            return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__generator"])(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, ((_a = this.plugin.helpers.viewportScreenshot) === null || _a === void 0 ? void 0 : _a.getImageDataUri())];
                    case 1:
                        src = _b.sent();
                        this.setState({ imageData: src });
                        return [2 /*return*/];
                }
            });
        }); };
        _this.open = function (e) {
            if (!e.target.files || !e.target.files[0])
                return;
            _mol_plugin_commands__WEBPACK_IMPORTED_MODULE_2__["PluginCommands"].State.Snapshots.OpenFile(_this.plugin, { file: e.target.files[0] });
        };
        return _this;
    }
    DownloadScreenshotControls.prototype.componentDidMount = function () {
        var _this = this;
        this.subscribe(this.plugin.state.data.behaviors.isUpdating, function (v) {
            _this.setState({ isDisabled: v });
        });
    };
    DownloadScreenshotControls.prototype.componentWillUnmount = function () {
        this.setState({ imageData: void 0 });
    };
    DownloadScreenshotControls.prototype.render = function () {
        var _this = this;
        var _a;
        var hasClipboardApi = !!((_a = navigator.clipboard) === null || _a === void 0 ? void 0 : _a.write);
        return react__WEBPACK_IMPORTED_MODULE_1__["createElement"]("div", null,
            this.state.showPreview && react__WEBPACK_IMPORTED_MODULE_1__["createElement"]("div", { className: 'msp-image-preview' },
                react__WEBPACK_IMPORTED_MODULE_1__["createElement"](_controls_screenshot__WEBPACK_IMPORTED_MODULE_7__["ScreenshotPreview"], { plugin: this.plugin }),
                react__WEBPACK_IMPORTED_MODULE_1__["createElement"](CropControls, { plugin: this.plugin })),
            react__WEBPACK_IMPORTED_MODULE_1__["createElement"]("div", { className: 'msp-flex-row' },
                hasClipboardApi && react__WEBPACK_IMPORTED_MODULE_1__["createElement"](_controls_common__WEBPACK_IMPORTED_MODULE_4__["Button"], { icon: _controls_icons__WEBPACK_IMPORTED_MODULE_5__["CopySvg"], onClick: this.copy, disabled: this.state.isDisabled }, "Copy"),
                !hasClipboardApi && !this.state.imageData && react__WEBPACK_IMPORTED_MODULE_1__["createElement"](_controls_common__WEBPACK_IMPORTED_MODULE_4__["Button"], { icon: _controls_icons__WEBPACK_IMPORTED_MODULE_5__["CopySvg"], onClick: this.copyImg, disabled: this.state.isDisabled }, "Copy"),
                this.state.imageData && react__WEBPACK_IMPORTED_MODULE_1__["createElement"](_controls_common__WEBPACK_IMPORTED_MODULE_4__["Button"], { onClick: function () { return _this.setState({ imageData: void 0 }); }, disabled: this.state.isDisabled }, "Clear"),
                react__WEBPACK_IMPORTED_MODULE_1__["createElement"](_controls_common__WEBPACK_IMPORTED_MODULE_4__["Button"], { icon: _controls_icons__WEBPACK_IMPORTED_MODULE_5__["GetAppSvg"], onClick: this.download, disabled: this.state.isDisabled }, "Download")),
            this.state.imageData && react__WEBPACK_IMPORTED_MODULE_1__["createElement"]("div", { className: 'msp-row msp-copy-image-wrapper' },
                react__WEBPACK_IMPORTED_MODULE_1__["createElement"]("div", null, "Right click below + Copy Image"),
                react__WEBPACK_IMPORTED_MODULE_1__["createElement"]("img", { src: this.state.imageData, style: { width: '100%', height: 32, display: 'block' } })),
            react__WEBPACK_IMPORTED_MODULE_1__["createElement"](ScreenshotParams, { plugin: this.plugin, isDisabled: this.state.isDisabled }),
            react__WEBPACK_IMPORTED_MODULE_1__["createElement"](_controls_common__WEBPACK_IMPORTED_MODULE_4__["ExpandGroup"], { header: 'State' },
                react__WEBPACK_IMPORTED_MODULE_1__["createElement"](_state_snapshots__WEBPACK_IMPORTED_MODULE_9__["StateExportImportControls"], { onAction: this.props.close }),
                react__WEBPACK_IMPORTED_MODULE_1__["createElement"](_controls_common__WEBPACK_IMPORTED_MODULE_4__["ExpandGroup"], { header: 'Save Options', initiallyExpanded: false, noOffset: true },
                    react__WEBPACK_IMPORTED_MODULE_1__["createElement"](_state_snapshots__WEBPACK_IMPORTED_MODULE_9__["LocalStateSnapshotParams"], null))));
    };
    return DownloadScreenshotControls;
}(_base__WEBPACK_IMPORTED_MODULE_3__["PluginUIComponent"]));

function ScreenshotParams(_a) {
    var plugin = _a.plugin, isDisabled = _a.isDisabled;
    var helper = plugin.helpers.viewportScreenshot;
    var values = Object(_hooks_use_behavior__WEBPACK_IMPORTED_MODULE_8__["useBehavior"])(helper.behaviors.values);
    return react__WEBPACK_IMPORTED_MODULE_1__["createElement"](_controls_parameters__WEBPACK_IMPORTED_MODULE_6__["ParameterControls"], { params: helper.params, values: values, onChangeValues: function (v) { return helper.behaviors.values.next(v); }, isDisabled: isDisabled });
}
function CropControls(_a) {
    var plugin = _a.plugin;
    var helper = plugin.helpers.viewportScreenshot;
    var cropParams = Object(_hooks_use_behavior__WEBPACK_IMPORTED_MODULE_8__["useBehavior"])(helper === null || helper === void 0 ? void 0 : helper.behaviors.cropParams);
    Object(_hooks_use_behavior__WEBPACK_IMPORTED_MODULE_8__["useBehavior"])(helper === null || helper === void 0 ? void 0 : helper.behaviors.relativeCrop);
    if (!helper)
        return null;
    return react__WEBPACK_IMPORTED_MODULE_1__["createElement"]("div", { style: { width: '100%', height: '24px', marginTop: '8px' } },
        react__WEBPACK_IMPORTED_MODULE_1__["createElement"](_controls_common__WEBPACK_IMPORTED_MODULE_4__["ToggleButton"], { icon: _controls_icons__WEBPACK_IMPORTED_MODULE_5__["CropOrginalSvg"], title: 'Auto-crop', inline: true, isSelected: cropParams.auto, style: { background: 'transparent', float: 'left', width: 'auto', height: '24px', lineHeight: '24px' }, toggle: function () { return helper.toggleAutocrop(); }, label: 'Auto-crop ' + (cropParams.auto ? 'On' : 'Off') }),
        !cropParams.auto && react__WEBPACK_IMPORTED_MODULE_1__["createElement"](_controls_common__WEBPACK_IMPORTED_MODULE_4__["Button"], { icon: _controls_icons__WEBPACK_IMPORTED_MODULE_5__["CropSvg"], title: 'Crop', style: { background: 'transparent', float: 'right', height: '24px', lineHeight: '24px', width: '24px', padding: '0' }, onClick: function () { return helper.autocrop(); } }),
        !cropParams.auto && !helper.isFullFrame && react__WEBPACK_IMPORTED_MODULE_1__["createElement"](_controls_common__WEBPACK_IMPORTED_MODULE_4__["Button"], { icon: _controls_icons__WEBPACK_IMPORTED_MODULE_5__["CropFreeSvg"], title: 'Reset Crop', style: { background: 'transparent', float: 'right', height: '24px', lineHeight: '24px', width: '24px', padding: '0' }, onClick: function () { return helper.resetCrop(); } }));
}
//# sourceMappingURL=screenshot.js.map

/***/ }),

/***/ "./lib/mol-plugin-ui/viewport/simple-settings.js":
/*!*******************************************************!*\
  !*** ./lib/mol-plugin-ui/viewport/simple-settings.js ***!
  \*******************************************************/
/*! exports provided: SimpleSettingsControl */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SimpleSettingsControl", function() { return SimpleSettingsControl; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var immer__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! immer */ "./node_modules/immer/dist/immer.esm.js");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! react */ "./node_modules/react/index.js");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _mol_canvas3d_canvas3d__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../mol-canvas3d/canvas3d */ "./lib/mol-canvas3d/canvas3d.js");
/* harmony import */ var _mol_plugin_commands__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../mol-plugin/commands */ "./lib/mol-plugin/commands.js");
/* harmony import */ var _mol_state__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../mol-state */ "./lib/mol-state/index.js");
/* harmony import */ var _mol_util_color__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../../mol-util/color */ "./lib/mol-util/color/index.js");
/* harmony import */ var _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../../mol-util/param-definition */ "./lib/mol-util/param-definition.js");
/* harmony import */ var _mol_util_param_mapping__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ../../mol-util/param-mapping */ "./lib/mol-util/param-mapping.js");
/* harmony import */ var _base__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ../base */ "./lib/mol-plugin-ui/base.js");
/* harmony import */ var _controls_parameters__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ../controls/parameters */ "./lib/mol-plugin-ui/controls/parameters.js");
/* harmony import */ var _help__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ./help */ "./lib/mol-plugin-ui/viewport/help.js");
/**
 * Copyright (c) 2019-2020 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 * @author David Sehnal <david.sehnal@gmail.com>
 */












var SimpleSettingsControl = /** @class */ (function (_super) {
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__extends"])(SimpleSettingsControl, _super);
    function SimpleSettingsControl() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    SimpleSettingsControl.prototype.componentDidMount = function () {
        var _this = this;
        this.subscribe(this.plugin.events.canvas3d.settingsUpdated, function () { return _this.forceUpdate(); });
        this.subscribe(this.plugin.canvas3d.camera.stateChanged, function (state) {
            if (state.radiusMax !== undefined || state.radius !== undefined) {
                _this.forceUpdate();
            }
        });
    };
    SimpleSettingsControl.prototype.render = function () {
        if (!this.plugin.canvas3d)
            return null;
        return react__WEBPACK_IMPORTED_MODULE_2__["createElement"](react__WEBPACK_IMPORTED_MODULE_2__["Fragment"], null,
            react__WEBPACK_IMPORTED_MODULE_2__["createElement"](_controls_parameters__WEBPACK_IMPORTED_MODULE_10__["ParameterMappingControl"], { mapping: SimpleSettingsMapping }),
            react__WEBPACK_IMPORTED_MODULE_2__["createElement"](_help__WEBPACK_IMPORTED_MODULE_11__["ViewportHelpContent"], null));
    };
    return SimpleSettingsControl;
}(_base__WEBPACK_IMPORTED_MODULE_9__["PluginUIComponent"]));

var LayoutOptions = {
    'sequence': 'Sequence',
    'log': 'Log',
    'left': 'Left Panel'
};
var SimpleSettingsParams = {
    spin: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_7__["ParamDefinition"].Group({
        spin: _mol_canvas3d_canvas3d__WEBPACK_IMPORTED_MODULE_3__["Canvas3DParams"].trackball.params.spin,
        speed: _mol_canvas3d_canvas3d__WEBPACK_IMPORTED_MODULE_3__["Canvas3DParams"].trackball.params.spinSpeed
    }, { pivot: 'spin' }),
    camera: _mol_canvas3d_canvas3d__WEBPACK_IMPORTED_MODULE_3__["Canvas3DParams"].camera,
    background: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_7__["ParamDefinition"].Group({
        color: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_7__["ParamDefinition"].Color(Object(_mol_util_color__WEBPACK_IMPORTED_MODULE_6__["Color"])(0xFCFBF9), { label: 'Background', description: 'Custom background color' }),
        transparent: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_7__["ParamDefinition"].Boolean(false)
    }, { pivot: 'color' }),
    lighting: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_7__["ParamDefinition"].Group({
        renderStyle: _mol_canvas3d_canvas3d__WEBPACK_IMPORTED_MODULE_3__["Canvas3DParams"].renderer.params.style,
        occlusion: _mol_canvas3d_canvas3d__WEBPACK_IMPORTED_MODULE_3__["Canvas3DParams"].postprocessing.params.occlusion,
        outline: _mol_canvas3d_canvas3d__WEBPACK_IMPORTED_MODULE_3__["Canvas3DParams"].postprocessing.params.outline,
        fog: _mol_canvas3d_canvas3d__WEBPACK_IMPORTED_MODULE_3__["Canvas3DParams"].cameraFog,
    }, { pivot: 'renderStyle' }),
    clipping: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_7__["ParamDefinition"].Group(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, _mol_canvas3d_canvas3d__WEBPACK_IMPORTED_MODULE_3__["Canvas3DParams"].cameraClipping.params), _mol_canvas3d_canvas3d__WEBPACK_IMPORTED_MODULE_3__["Canvas3DParams"].renderer.params.clip.params), { pivot: 'radius' }),
    layout: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_7__["ParamDefinition"].MultiSelect([], _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_7__["ParamDefinition"].objectToOptions(LayoutOptions)),
};
var SimpleSettingsMapping = Object(_mol_util_param_mapping__WEBPACK_IMPORTED_MODULE_8__["ParamMapping"])({
    params: function (ctx) {
        var _a;
        var params = _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_7__["ParamDefinition"].clone(SimpleSettingsParams);
        var controls = (_a = ctx.spec.layout) === null || _a === void 0 ? void 0 : _a.controls;
        if (controls) {
            var options = [];
            if (controls.top !== 'none')
                options.push(['sequence', LayoutOptions.sequence]);
            if (controls.bottom !== 'none')
                options.push(['log', LayoutOptions.log]);
            if (controls.left !== 'none')
                options.push(['left', LayoutOptions.left]);
            params.layout.options = options;
        }
        return params;
    },
    target: function (ctx) {
        var _a, _b;
        var c = (_a = ctx.spec.layout) === null || _a === void 0 ? void 0 : _a.controls;
        var r = ctx.layout.state.regionState;
        var layout = [];
        if (r.top !== 'hidden' && (!c || c.top !== 'none'))
            layout.push('sequence');
        if (r.bottom !== 'hidden' && (!c || c.bottom !== 'none'))
            layout.push('log');
        if (r.left !== 'hidden' && (!c || c.left !== 'none'))
            layout.push('left');
        return { canvas: (_b = ctx.canvas3d) === null || _b === void 0 ? void 0 : _b.props, layout: layout };
    }
})({
    values: function (props, ctx) {
        var canvas = props.canvas;
        var renderer = canvas.renderer;
        return {
            layout: props.layout,
            spin: { spin: !!canvas.trackball.spin, speed: canvas.trackball.spinSpeed },
            camera: canvas.camera,
            background: {
                color: renderer.backgroundColor,
                transparent: canvas.transparentBackground
            },
            lighting: {
                renderStyle: renderer.style,
                occlusion: canvas.postprocessing.occlusion,
                outline: canvas.postprocessing.outline,
                fog: canvas.cameraFog
            },
            clipping: Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, canvas.cameraClipping), canvas.renderer.clip)
        };
    },
    update: function (s, props) {
        var canvas = props.canvas;
        canvas.trackball.spin = s.spin.spin;
        canvas.trackball.spinSpeed = s.spin.speed;
        canvas.camera = s.camera;
        canvas.transparentBackground = s.background.transparent;
        canvas.renderer.backgroundColor = s.background.color;
        canvas.renderer.style = s.lighting.renderStyle;
        canvas.postprocessing.occlusion = s.lighting.occlusion;
        canvas.postprocessing.outline = s.lighting.outline;
        canvas.cameraFog = s.lighting.fog;
        canvas.cameraClipping = {
            radius: s.clipping.radius,
            far: s.clipping.far,
        };
        canvas.renderer.clip = {
            variant: s.clipping.variant,
            objects: s.clipping.objects,
        };
        props.layout = s.layout;
    },
    apply: function (props, ctx) {
        return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"])(this, void 0, void 0, function () {
            var hideLeft, state;
            return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__generator"])(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, _mol_plugin_commands__WEBPACK_IMPORTED_MODULE_4__["PluginCommands"].Canvas3D.SetSettings(ctx, { settings: props.canvas })];
                    case 1:
                        _a.sent();
                        hideLeft = props.layout.indexOf('left') < 0;
                        state = Object(immer__WEBPACK_IMPORTED_MODULE_1__["produce"])(ctx.layout.state, function (s) {
                            s.regionState.top = props.layout.indexOf('sequence') >= 0 ? 'full' : 'hidden';
                            s.regionState.bottom = props.layout.indexOf('log') >= 0 ? 'full' : 'hidden';
                            s.regionState.left = hideLeft ? 'hidden' : ctx.behaviors.layout.leftPanelTabName.value === 'none' ? 'collapsed' : 'full';
                        });
                        return [4 /*yield*/, _mol_plugin_commands__WEBPACK_IMPORTED_MODULE_4__["PluginCommands"].Layout.Update(ctx, { state: state })];
                    case 2:
                        _a.sent();
                        if (hideLeft) {
                            _mol_plugin_commands__WEBPACK_IMPORTED_MODULE_4__["PluginCommands"].State.SetCurrentObject(ctx, { state: ctx.state.data, ref: _mol_state__WEBPACK_IMPORTED_MODULE_5__["StateTransform"].RootRef });
                        }
                        return [2 /*return*/];
                }
            });
        });
    }
});
//# sourceMappingURL=simple-settings.js.map

/***/ }),

/***/ "./lib/mol-plugin/animation-loop.js":
/*!******************************************!*\
  !*** ./lib/mol-plugin/animation-loop.js ***!
  \******************************************/
/*! exports provided: PluginAnimationLoop */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "PluginAnimationLoop", function() { return PluginAnimationLoop; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _mol_util_now__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../mol-util/now */ "./lib/mol-util/now.js");
/**
 * Copyright (c) 2020 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author David Sehnal <david.sehnal@gmail.com>
 */


var PluginAnimationLoop = /** @class */ (function () {
    function PluginAnimationLoop(plugin) {
        var _this = this;
        this.plugin = plugin;
        this.currentFrame = void 0;
        this._isAnimating = false;
        this.frame = function () {
            _this.tick(Object(_mol_util_now__WEBPACK_IMPORTED_MODULE_1__["now"])());
            if (_this._isAnimating) {
                _this.currentFrame = requestAnimationFrame(_this.frame);
            }
        };
    }
    Object.defineProperty(PluginAnimationLoop.prototype, "isAnimating", {
        get: function () {
            return this._isAnimating;
        },
        enumerable: false,
        configurable: true
    });
    PluginAnimationLoop.prototype.tick = function (t, options) {
        var _a;
        return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"])(this, void 0, void 0, function () {
            return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__generator"])(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, this.plugin.managers.animation.tick(t, options === null || options === void 0 ? void 0 : options.isSynchronous)];
                    case 1:
                        _b.sent();
                        (_a = this.plugin.canvas3d) === null || _a === void 0 ? void 0 : _a.tick(t, options);
                        return [2 /*return*/];
                }
            });
        });
    };
    PluginAnimationLoop.prototype.resetTime = function (t) {
        var _a;
        if (t === void 0) { t = Object(_mol_util_now__WEBPACK_IMPORTED_MODULE_1__["now"])(); }
        (_a = this.plugin.canvas3d) === null || _a === void 0 ? void 0 : _a.resetTime(t);
    };
    PluginAnimationLoop.prototype.start = function () {
        this._isAnimating = true;
        this.resetTime();
        this.currentFrame = requestAnimationFrame(this.frame);
    };
    PluginAnimationLoop.prototype.stop = function () {
        this._isAnimating = false;
        if (this.currentFrame !== void 0) {
            cancelAnimationFrame(this.currentFrame);
            this.currentFrame = void 0;
        }
    };
    return PluginAnimationLoop;
}());

//# sourceMappingURL=animation-loop.js.map

/***/ }),

/***/ "./lib/mol-plugin/behavior.js":
/*!************************************!*\
  !*** ./lib/mol-plugin/behavior.js ***!
  \************************************/
/*! exports provided: PluginBehavior, BuiltInPluginBehaviors, PluginBehaviors */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "BuiltInPluginBehaviors", function() { return BuiltInPluginBehaviors; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "PluginBehaviors", function() { return PluginBehaviors; });
/* harmony import */ var _behavior_behavior__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./behavior/behavior */ "./lib/mol-plugin/behavior/behavior.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "PluginBehavior", function() { return _behavior_behavior__WEBPACK_IMPORTED_MODULE_0__["PluginBehavior"]; });

/* harmony import */ var _behavior_static_state__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./behavior/static/state */ "./lib/mol-plugin/behavior/static/state.js");
/* harmony import */ var _behavior_static_representation__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./behavior/static/representation */ "./lib/mol-plugin/behavior/static/representation.js");
/* harmony import */ var _behavior_static_camera__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./behavior/static/camera */ "./lib/mol-plugin/behavior/static/camera.js");
/* harmony import */ var _behavior_static_misc__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./behavior/static/misc */ "./lib/mol-plugin/behavior/static/misc.js");
/* harmony import */ var _behavior_dynamic_representation__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./behavior/dynamic/representation */ "./lib/mol-plugin/behavior/dynamic/representation.js");
/* harmony import */ var _behavior_dynamic_camera__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ./behavior/dynamic/camera */ "./lib/mol-plugin/behavior/dynamic/camera.js");
/* harmony import */ var _behavior_dynamic_custom_props__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ./behavior/dynamic/custom-props */ "./lib/mol-plugin/behavior/dynamic/custom-props.js");
/**
 * Copyright (c) 2018 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author David Sehnal <david.sehnal@gmail.com>
 */








var BuiltInPluginBehaviors = {
    State: _behavior_static_state__WEBPACK_IMPORTED_MODULE_1__,
    Representation: _behavior_static_representation__WEBPACK_IMPORTED_MODULE_2__,
    Camera: _behavior_static_camera__WEBPACK_IMPORTED_MODULE_3__,
    Misc: _behavior_static_misc__WEBPACK_IMPORTED_MODULE_4__
};
var PluginBehaviors = {
    Representation: _behavior_dynamic_representation__WEBPACK_IMPORTED_MODULE_5__,
    Camera: _behavior_dynamic_camera__WEBPACK_IMPORTED_MODULE_6__,
    CustomProps: _behavior_dynamic_custom_props__WEBPACK_IMPORTED_MODULE_7__
};
//# sourceMappingURL=behavior.js.map

/***/ }),

/***/ "./lib/mol-plugin/behavior/behavior.js":
/*!*********************************************!*\
  !*** ./lib/mol-plugin/behavior/behavior.js ***!
  \*********************************************/
/*! exports provided: PluginBehavior */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "PluginBehavior", function() { return PluginBehavior; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _mol_plugin_state_objects__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../mol-plugin-state/objects */ "./lib/mol-plugin-state/objects.js");
/* harmony import */ var _mol_state__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../mol-state */ "./lib/mol-state/index.js");
/* harmony import */ var _mol_task__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../mol-task */ "./lib/mol-task/index.js");
/* harmony import */ var _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../mol-util/param-definition */ "./lib/mol-util/param-definition.js");
/* harmony import */ var _mol_util__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../mol-util */ "./lib/mol-util/index.js");
/**
 * Copyright (c) 2018 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author David Sehnal <david.sehnal@gmail.com>
 */







var PluginBehavior;
(function (PluginBehavior) {
    var Root = /** @class */ (function (_super) {
        Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__extends"])(Root, _super);
        function Root() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        return Root;
    }(_mol_plugin_state_objects__WEBPACK_IMPORTED_MODULE_1__["PluginStateObject"].Create({ name: 'Root', typeClass: 'Root' })));
    PluginBehavior.Root = Root;
    var Category = /** @class */ (function (_super) {
        Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__extends"])(Category, _super);
        function Category() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        return Category;
    }(_mol_plugin_state_objects__WEBPACK_IMPORTED_MODULE_1__["PluginStateObject"].Create({ name: 'Category', typeClass: 'Object' })));
    PluginBehavior.Category = Category;
    var Behavior = /** @class */ (function (_super) {
        Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__extends"])(Behavior, _super);
        function Behavior() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        return Behavior;
    }(_mol_plugin_state_objects__WEBPACK_IMPORTED_MODULE_1__["PluginStateObject"].CreateBehavior({ name: 'Behavior' })));
    PluginBehavior.Behavior = Behavior;
    PluginBehavior.Categories = {
        'common': 'Common',
        'representation': 'Representation',
        'interaction': 'Interaction',
        'custom-props': 'Custom Properties',
        'misc': 'Miscellaneous'
    };
    PluginBehavior.CreateCategory = _mol_plugin_state_objects__WEBPACK_IMPORTED_MODULE_1__["PluginStateTransform"].BuiltIn({
        name: 'create-behavior-category',
        display: { name: 'Behavior Category' },
        from: Root,
        to: Category,
        params: {
            label: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_4__["ParamDefinition"].Text('', { isHidden: true }),
        }
    })({
        apply: function (_a) {
            var params = _a.params;
            return new Category({}, { label: params.label });
        }
    });
    var categoryMap = new Map();
    function getCategoryId(t) {
        return categoryMap.get(t.id);
    }
    PluginBehavior.getCategoryId = getCategoryId;
    function create(params) {
        var t = _mol_plugin_state_objects__WEBPACK_IMPORTED_MODULE_1__["PluginStateTransform"].CreateBuiltIn({
            name: params.name,
            display: params.display,
            from: [Root],
            to: [Behavior],
            params: params.params,
            apply: function (_a, ctx) {
                var p = _a.params;
                var label = params.label ? params.label(p) : { label: params.display.name, description: params.display.description };
                return new Behavior(new params.ctor(ctx, p), label);
            },
            update: function (_a) {
                var _this = this;
                var b = _a.b, newParams = _a.newParams;
                return _mol_task__WEBPACK_IMPORTED_MODULE_3__["Task"].create('Update Behavior', function () { return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"])(_this, void 0, void 0, function () {
                    var updated;
                    return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__generator"])(this, function (_a) {
                        switch (_a.label) {
                            case 0:
                                if (!b.data.update)
                                    return [2 /*return*/, _mol_state__WEBPACK_IMPORTED_MODULE_2__["StateTransformer"].UpdateResult.Unchanged];
                                return [4 /*yield*/, b.data.update(newParams)];
                            case 1:
                                updated = _a.sent();
                                return [2 /*return*/, updated ? _mol_state__WEBPACK_IMPORTED_MODULE_2__["StateTransformer"].UpdateResult.Updated : _mol_state__WEBPACK_IMPORTED_MODULE_2__["StateTransformer"].UpdateResult.Unchanged];
                        }
                    });
                }); });
            },
            canAutoUpdate: params.canAutoUpdate
        });
        categoryMap.set(t.id, params.category);
        return t;
    }
    PluginBehavior.create = create;
    function simpleCommandHandler(cmd, action) {
        return /** @class */ (function () {
            // TODO can't be private due to bug with generating declerations, see https://github.com/Microsoft/TypeScript/issues/17293
            function class_1(/** private */ ctx) {
                this.ctx = ctx;
                // TODO can't be private due to bug with generating declerations, see https://github.com/Microsoft/TypeScript/issues/17293
                /** private */ this.sub = void 0;
            }
            class_1.prototype.register = function () {
                var _this = this;
                this.sub = cmd.subscribe(this.ctx, function (data) { return action(data, _this.ctx); });
            };
            class_1.prototype.unregister = function () {
                if (this.sub)
                    this.sub.unsubscribe();
                this.sub = void 0;
            };
            return class_1;
        }());
    }
    PluginBehavior.simpleCommandHandler = simpleCommandHandler;
    var Handler = /** @class */ (function () {
        function Handler(ctx, params) {
            this.ctx = ctx;
            this.params = params;
            this.subs = [];
        }
        Handler.prototype.subscribeCommand = function (cmd, action) {
            this.subs.push(cmd.subscribe(this.ctx, action));
        };
        Handler.prototype.subscribeObservable = function (o, action) {
            this.subs.push(o.subscribe(action));
        };
        Handler.prototype.track = function (sub) {
            this.subs.push(sub);
        };
        Handler.prototype.unregister = function () {
            for (var _i = 0, _a = this.subs; _i < _a.length; _i++) {
                var s = _a[_i];
                s.unsubscribe();
            }
            this.subs = [];
        };
        Handler.prototype.update = function (params) {
            if (Object(_mol_util__WEBPACK_IMPORTED_MODULE_5__["shallowEqualObjects"])(params, this.params))
                return false;
            this.params = params;
            return true;
        };
        return Handler;
    }());
    PluginBehavior.Handler = Handler;
    var WithSubscribers = /** @class */ (function () {
        function WithSubscribers(plugin, params) {
            this.plugin = plugin;
            this.params = params;
            this.subs = [];
        }
        WithSubscribers.prototype.subscribeCommand = function (cmd, action) {
            this.subs.push(cmd.subscribe(this.plugin, action));
        };
        WithSubscribers.prototype.subscribeObservable = function (o, action) {
            this.subs.push(o.subscribe(action));
        };
        WithSubscribers.prototype.unregister = function () {
            for (var _i = 0, _a = this.subs; _i < _a.length; _i++) {
                var s = _a[_i];
                s.unsubscribe();
            }
            this.subs = [];
        };
        return WithSubscribers;
    }());
    PluginBehavior.WithSubscribers = WithSubscribers;
})(PluginBehavior || (PluginBehavior = {}));
//# sourceMappingURL=behavior.js.map

/***/ }),

/***/ "./lib/mol-plugin/behavior/dynamic/camera.js":
/*!***************************************************!*\
  !*** ./lib/mol-plugin/behavior/dynamic/camera.js ***!
  \***************************************************/
/*! exports provided: FocusLoci */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FocusLoci", function() { return FocusLoci; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _mol_model_loci__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../../mol-model/loci */ "./lib/mol-model/loci.js");
/* harmony import */ var _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../../mol-util/param-definition */ "./lib/mol-util/param-definition.js");
/* harmony import */ var _behavior__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../behavior */ "./lib/mol-plugin/behavior/behavior.js");
/* harmony import */ var _mol_util_input_input_observer__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../../mol-util/input/input-observer */ "./lib/mol-util/input/input-observer.js");
/* harmony import */ var _mol_util_binding__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../../mol-util/binding */ "./lib/mol-util/binding.js");
/* harmony import */ var _commands__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../../commands */ "./lib/mol-plugin/commands.js");
/**
 * Copyright (c) 2018-2020 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author David Sehnal <david.sehnal@gmail.com>
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */







var B = _mol_util_input_input_observer__WEBPACK_IMPORTED_MODULE_4__["ButtonsType"];
var M = _mol_util_input_input_observer__WEBPACK_IMPORTED_MODULE_4__["ModifiersKeys"];
var Trigger = _mol_util_binding__WEBPACK_IMPORTED_MODULE_5__["Binding"].Trigger;
var DefaultFocusLociBindings = {
    clickCenterFocus: Object(_mol_util_binding__WEBPACK_IMPORTED_MODULE_5__["Binding"])([
        Trigger(1 /* Primary */, M.create()),
        Trigger(2 /* Secondary */, M.create()),
        Trigger(1 /* Primary */, M.create({ control: true }))
    ], 'Camera center and focus', 'Click element using ${triggers}'),
    clickCenterFocusSelectMode: Object(_mol_util_binding__WEBPACK_IMPORTED_MODULE_5__["Binding"])([
        Trigger(2 /* Secondary */, M.create()),
        Trigger(1 /* Primary */, M.create({ control: true }))
    ], 'Camera center and focus', 'Click element using ${triggers}'),
};
var FocusLociParams = {
    minRadius: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_2__["ParamDefinition"].Numeric(8, { min: 1, max: 50, step: 1 }),
    extraRadius: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_2__["ParamDefinition"].Numeric(4, { min: 1, max: 50, step: 1 }, { description: 'Value added to the bounding-sphere radius of the Loci' }),
    durationMs: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_2__["ParamDefinition"].Numeric(250, { min: 0, max: 1000, step: 1 }, { description: 'Camera transition duration' }),
    bindings: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_2__["ParamDefinition"].Value(DefaultFocusLociBindings, { isHidden: true }),
};
var FocusLoci = _behavior__WEBPACK_IMPORTED_MODULE_3__["PluginBehavior"].create({
    name: 'camera-focus-loci',
    category: 'interaction',
    ctor: /** @class */ (function (_super) {
        Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__extends"])(class_1, _super);
        function class_1() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        class_1.prototype.register = function () {
            var _this = this;
            this.subscribeObservable(this.ctx.behaviors.interaction.click, function (_a) {
                var current = _a.current, button = _a.button, modifiers = _a.modifiers;
                if (!_this.ctx.canvas3d)
                    return;
                var binding = _this.ctx.selectionMode
                    ? _this.params.bindings.clickCenterFocusSelectMode
                    : _this.params.bindings.clickCenterFocus;
                if (_mol_util_binding__WEBPACK_IMPORTED_MODULE_5__["Binding"].match(binding, button, modifiers)) {
                    if (_mol_model_loci__WEBPACK_IMPORTED_MODULE_1__["Loci"].isEmpty(current.loci)) {
                        _commands__WEBPACK_IMPORTED_MODULE_6__["PluginCommands"].Camera.Reset(_this.ctx, {});
                        return;
                    }
                    var loci = _mol_model_loci__WEBPACK_IMPORTED_MODULE_1__["Loci"].normalize(current.loci, _this.ctx.managers.interactivity.props.granularity);
                    _this.ctx.managers.camera.focusLoci(loci, _this.params);
                }
            });
        };
        return class_1;
    }(_behavior__WEBPACK_IMPORTED_MODULE_3__["PluginBehavior"].Handler)),
    params: function () { return FocusLociParams; },
    display: { name: 'Camera Focus Loci on Canvas' }
});
//# sourceMappingURL=camera.js.map

/***/ }),

/***/ "./lib/mol-plugin/behavior/dynamic/custom-props.js":
/*!*********************************************************!*\
  !*** ./lib/mol-plugin/behavior/dynamic/custom-props.js ***!
  \*********************************************************/
/*! exports provided: StructureInfo, AccessibleSurfaceArea, Interactions, SecondaryStructure, ValenceModel, CrossLinkRestraint */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _custom_props_structure_info__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./custom-props/structure-info */ "./lib/mol-plugin/behavior/dynamic/custom-props/structure-info.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "StructureInfo", function() { return _custom_props_structure_info__WEBPACK_IMPORTED_MODULE_0__["StructureInfo"]; });

/* harmony import */ var _custom_props_computed_accessible_surface_area__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./custom-props/computed/accessible-surface-area */ "./lib/mol-plugin/behavior/dynamic/custom-props/computed/accessible-surface-area.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "AccessibleSurfaceArea", function() { return _custom_props_computed_accessible_surface_area__WEBPACK_IMPORTED_MODULE_1__["AccessibleSurfaceArea"]; });

/* harmony import */ var _custom_props_computed_interactions__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./custom-props/computed/interactions */ "./lib/mol-plugin/behavior/dynamic/custom-props/computed/interactions.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Interactions", function() { return _custom_props_computed_interactions__WEBPACK_IMPORTED_MODULE_2__["Interactions"]; });

/* harmony import */ var _custom_props_computed_secondary_structure__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./custom-props/computed/secondary-structure */ "./lib/mol-plugin/behavior/dynamic/custom-props/computed/secondary-structure.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "SecondaryStructure", function() { return _custom_props_computed_secondary_structure__WEBPACK_IMPORTED_MODULE_3__["SecondaryStructure"]; });

/* harmony import */ var _custom_props_computed_valence_model__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./custom-props/computed/valence-model */ "./lib/mol-plugin/behavior/dynamic/custom-props/computed/valence-model.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ValenceModel", function() { return _custom_props_computed_valence_model__WEBPACK_IMPORTED_MODULE_4__["ValenceModel"]; });

/* harmony import */ var _custom_props_integrative_cross_link_restraint__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./custom-props/integrative/cross-link-restraint */ "./lib/mol-plugin/behavior/dynamic/custom-props/integrative/cross-link-restraint.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "CrossLinkRestraint", function() { return _custom_props_integrative_cross_link_restraint__WEBPACK_IMPORTED_MODULE_5__["CrossLinkRestraint"]; });

/**
 * Copyright (c) 2018-2020 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author David Sehnal <david.sehnal@gmail.com>
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */






//# sourceMappingURL=custom-props.js.map

/***/ }),

/***/ "./lib/mol-plugin/behavior/dynamic/custom-props/computed/accessible-surface-area.js":
/*!******************************************************************************************!*\
  !*** ./lib/mol-plugin/behavior/dynamic/custom-props/computed/accessible-surface-area.js ***!
  \******************************************************************************************/
/*! exports provided: AccessibleSurfaceArea */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "AccessibleSurfaceArea", function() { return AccessibleSurfaceArea; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _behavior__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../../behavior */ "./lib/mol-plugin/behavior/behavior.js");
/* harmony import */ var _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../../../../mol-util/param-definition */ "./lib/mol-util/param-definition.js");
/* harmony import */ var _mol_model_props_computed_accessible_surface_area__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../../../../mol-model-props/computed/accessible-surface-area */ "./lib/mol-model-props/computed/accessible-surface-area.js");
/* harmony import */ var _mol_model_props_computed_themes_accessible_surface_area__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../../../../mol-model-props/computed/themes/accessible-surface-area */ "./lib/mol-model-props/computed/themes/accessible-surface-area.js");
/* harmony import */ var _mol_data_int__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../../../../mol-data/int */ "./lib/mol-data/int.js");
/* harmony import */ var _mol_util_array__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../../../../../mol-util/array */ "./lib/mol-util/array.js");
/* harmony import */ var _mol_script_runtime_query_compiler__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../../../../../mol-script/runtime/query/compiler */ "./lib/mol-script/runtime/query/compiler.js");
/* harmony import */ var _mol_plugin_state_helpers_structure_selection_query__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ../../../../../mol-plugin-state/helpers/structure-selection-query */ "./lib/mol-plugin-state/helpers/structure-selection-query.js");
/* harmony import */ var _mol_script_language_builder__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ../../../../../mol-script/language/builder */ "./lib/mol-script/language/builder.js");
/**
 * Copyright (c) 2019-2020 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */










var AccessibleSurfaceArea = _behavior__WEBPACK_IMPORTED_MODULE_1__["PluginBehavior"].create({
    name: 'computed-accessible-surface-area-prop',
    category: 'custom-props',
    display: { name: 'Accessible Surface Area' },
    ctor: /** @class */ (function (_super) {
        Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__extends"])(class_1, _super);
        function class_1() {
            var _this = _super !== null && _super.apply(this, arguments) || this;
            _this.provider = _mol_model_props_computed_accessible_surface_area__WEBPACK_IMPORTED_MODULE_3__["AccessibleSurfaceAreaProvider"];
            _this.labelProvider = {
                label: function (loci) {
                    if (!_this.params.showTooltip)
                        return;
                    return accessibleSurfaceAreaLabel(loci);
                }
            };
            return _this;
        }
        class_1.prototype.update = function (p) {
            var updated = (this.params.autoAttach !== p.autoAttach ||
                this.params.showTooltip !== p.showTooltip);
            this.params.autoAttach = p.autoAttach;
            this.params.showTooltip = p.showTooltip;
            this.ctx.customStructureProperties.setDefaultAutoAttach(this.provider.descriptor.name, this.params.autoAttach);
            return updated;
        };
        class_1.prototype.register = function () {
            _mol_script_runtime_query_compiler__WEBPACK_IMPORTED_MODULE_7__["DefaultQueryRuntimeTable"].addCustomProp(this.provider.descriptor);
            this.ctx.customStructureProperties.register(this.provider, this.params.autoAttach);
            this.ctx.representation.structure.themes.colorThemeRegistry.add(_mol_model_props_computed_themes_accessible_surface_area__WEBPACK_IMPORTED_MODULE_4__["AccessibleSurfaceAreaColorThemeProvider"]);
            this.ctx.managers.lociLabels.addProvider(this.labelProvider);
            this.ctx.query.structure.registry.add(isBuried);
            this.ctx.query.structure.registry.add(isAccessible);
        };
        class_1.prototype.unregister = function () {
            _mol_script_runtime_query_compiler__WEBPACK_IMPORTED_MODULE_7__["DefaultQueryRuntimeTable"].removeCustomProp(this.provider.descriptor);
            this.ctx.customStructureProperties.unregister(this.provider.descriptor.name);
            this.ctx.representation.structure.themes.colorThemeRegistry.remove(_mol_model_props_computed_themes_accessible_surface_area__WEBPACK_IMPORTED_MODULE_4__["AccessibleSurfaceAreaColorThemeProvider"]);
            this.ctx.managers.lociLabels.removeProvider(this.labelProvider);
            this.ctx.query.structure.registry.remove(isBuried);
            this.ctx.query.structure.registry.remove(isAccessible);
        };
        return class_1;
    }(_behavior__WEBPACK_IMPORTED_MODULE_1__["PluginBehavior"].Handler)),
    params: function () { return ({
        autoAttach: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_2__["ParamDefinition"].Boolean(false),
        showTooltip: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_2__["ParamDefinition"].Boolean(true)
    }); }
});
//
function accessibleSurfaceAreaLabel(loci) {
    if (loci.kind === 'element-loci') {
        if (loci.elements.length === 0)
            return;
        var accessibleSurfaceArea = _mol_model_props_computed_accessible_surface_area__WEBPACK_IMPORTED_MODULE_3__["AccessibleSurfaceAreaProvider"].get(loci.structure).value;
        if (!accessibleSurfaceArea || loci.structure.customPropertyDescriptors.hasReference(_mol_model_props_computed_accessible_surface_area__WEBPACK_IMPORTED_MODULE_3__["AccessibleSurfaceAreaProvider"].descriptor))
            return;
        var getSerialIndex_1 = loci.structure.root.serialMapping.getSerialIndex;
        var area_1 = accessibleSurfaceArea.area, serialResidueIndex_1 = accessibleSurfaceArea.serialResidueIndex;
        var seen_1 = new Set();
        var cummulativeArea_1 = 0;
        var _loop_1 = function (indices, unit) {
            var elements = unit.elements;
            _mol_data_int__WEBPACK_IMPORTED_MODULE_5__["OrderedSet"].forEach(indices, function (idx) {
                var rSI = serialResidueIndex_1[getSerialIndex_1(unit, elements[idx])];
                if (rSI !== -1 && !seen_1.has(rSI)) {
                    cummulativeArea_1 += area_1[rSI];
                    seen_1.add(rSI);
                }
            });
        };
        for (var _i = 0, _a = loci.elements; _i < _a.length; _i++) {
            var _b = _a[_i], indices = _b.indices, unit = _b.unit;
            _loop_1(indices, unit);
        }
        if (seen_1.size === 0)
            return;
        var residueCount = "<small>(" + seen_1.size + " " + (seen_1.size > 1 ? 'Residues sum' : 'Residue') + ")</small>";
        return "Accessible Surface Area " + residueCount + ": " + cummulativeArea_1.toFixed(2) + " \u212B<sup>2</sup>";
    }
    else if (loci.kind === 'structure-loci') {
        var accessibleSurfaceArea = _mol_model_props_computed_accessible_surface_area__WEBPACK_IMPORTED_MODULE_3__["AccessibleSurfaceAreaProvider"].get(loci.structure).value;
        if (!accessibleSurfaceArea || loci.structure.customPropertyDescriptors.hasReference(_mol_model_props_computed_accessible_surface_area__WEBPACK_IMPORTED_MODULE_3__["AccessibleSurfaceAreaProvider"].descriptor))
            return;
        return "Accessible Surface Area <small>(Whole Structure)</small>: " + Object(_mol_util_array__WEBPACK_IMPORTED_MODULE_6__["arraySum"])(accessibleSurfaceArea.area).toFixed(2) + " \u212B<sup>2</sup>";
    }
}
//
var isBuried = Object(_mol_plugin_state_helpers_structure_selection_query__WEBPACK_IMPORTED_MODULE_8__["StructureSelectionQuery"])('Buried Protein Residues', _mol_script_language_builder__WEBPACK_IMPORTED_MODULE_9__["MolScriptBuilder"].struct.modifier.union([
    _mol_script_language_builder__WEBPACK_IMPORTED_MODULE_9__["MolScriptBuilder"].struct.modifier.wholeResidues([
        _mol_script_language_builder__WEBPACK_IMPORTED_MODULE_9__["MolScriptBuilder"].struct.modifier.union([
            _mol_script_language_builder__WEBPACK_IMPORTED_MODULE_9__["MolScriptBuilder"].struct.generator.atomGroups({
                'chain-test': _mol_script_language_builder__WEBPACK_IMPORTED_MODULE_9__["MolScriptBuilder"].core.rel.eq([_mol_script_language_builder__WEBPACK_IMPORTED_MODULE_9__["MolScriptBuilder"].ammp('objectPrimitive'), 'atomistic']),
                'residue-test': _mol_model_props_computed_accessible_surface_area__WEBPACK_IMPORTED_MODULE_3__["AccessibleSurfaceAreaSymbols"].isBuried.symbol(),
            })
        ])
    ])
]), {
    description: 'Select buried protein residues.',
    category: _mol_plugin_state_helpers_structure_selection_query__WEBPACK_IMPORTED_MODULE_8__["StructureSelectionCategory"].Residue,
    ensureCustomProperties: function (ctx, structure) {
        return _mol_model_props_computed_accessible_surface_area__WEBPACK_IMPORTED_MODULE_3__["AccessibleSurfaceAreaProvider"].attach(ctx, structure);
    }
});
var isAccessible = Object(_mol_plugin_state_helpers_structure_selection_query__WEBPACK_IMPORTED_MODULE_8__["StructureSelectionQuery"])('Accessible Protein Residues', _mol_script_language_builder__WEBPACK_IMPORTED_MODULE_9__["MolScriptBuilder"].struct.modifier.union([
    _mol_script_language_builder__WEBPACK_IMPORTED_MODULE_9__["MolScriptBuilder"].struct.modifier.wholeResidues([
        _mol_script_language_builder__WEBPACK_IMPORTED_MODULE_9__["MolScriptBuilder"].struct.modifier.union([
            _mol_script_language_builder__WEBPACK_IMPORTED_MODULE_9__["MolScriptBuilder"].struct.generator.atomGroups({
                'chain-test': _mol_script_language_builder__WEBPACK_IMPORTED_MODULE_9__["MolScriptBuilder"].core.rel.eq([_mol_script_language_builder__WEBPACK_IMPORTED_MODULE_9__["MolScriptBuilder"].ammp('objectPrimitive'), 'atomistic']),
                'residue-test': _mol_model_props_computed_accessible_surface_area__WEBPACK_IMPORTED_MODULE_3__["AccessibleSurfaceAreaSymbols"].isAccessible.symbol(),
            })
        ])
    ])
]), {
    description: 'Select accessible protein residues.',
    category: _mol_plugin_state_helpers_structure_selection_query__WEBPACK_IMPORTED_MODULE_8__["StructureSelectionCategory"].Residue,
    ensureCustomProperties: function (ctx, structure) {
        return _mol_model_props_computed_accessible_surface_area__WEBPACK_IMPORTED_MODULE_3__["AccessibleSurfaceAreaProvider"].attach(ctx, structure);
    }
});
//# sourceMappingURL=accessible-surface-area.js.map

/***/ }),

/***/ "./lib/mol-plugin/behavior/dynamic/custom-props/computed/interactions.js":
/*!*******************************************************************************!*\
  !*** ./lib/mol-plugin/behavior/dynamic/custom-props/computed/interactions.js ***!
  \*******************************************************************************/
/*! exports provided: Interactions */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Interactions", function() { return Interactions; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _behavior__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../../behavior */ "./lib/mol-plugin/behavior/behavior.js");
/* harmony import */ var _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../../../../mol-util/param-definition */ "./lib/mol-util/param-definition.js");
/* harmony import */ var _mol_model_props_computed_interactions__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../../../../mol-model-props/computed/interactions */ "./lib/mol-model-props/computed/interactions.js");
/* harmony import */ var _mol_state__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../../../../mol-state */ "./lib/mol-state/index.js");
/* harmony import */ var _mol_plugin_state_objects__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../../../../mol-plugin-state/objects */ "./lib/mol-plugin-state/objects.js");
/* harmony import */ var _mol_model_structure_structure_element__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../../../../../mol-model/structure/structure/element */ "./lib/mol-model/structure/structure/element.js");
/* harmony import */ var _mol_data_int__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../../../../../mol-data/int */ "./lib/mol-data/int.js");
/* harmony import */ var _mol_model_props_computed_interactions_common__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ../../../../../mol-model-props/computed/interactions/common */ "./lib/mol-model-props/computed/interactions/common.js");
/* harmony import */ var _mol_util_array__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ../../../../../mol-util/array */ "./lib/mol-util/array.js");
/* harmony import */ var _mol_model_props_computed_themes_interaction_type__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ../../../../../mol-model-props/computed/themes/interaction-type */ "./lib/mol-model-props/computed/themes/interaction-type.js");
/* harmony import */ var _mol_model_props_computed_representations_interactions__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ../../../../../mol-model-props/computed/representations/interactions */ "./lib/mol-model-props/computed/representations/interactions.js");
/**
 * Copyright (c) 2019-2020 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */












var Interactions = _behavior__WEBPACK_IMPORTED_MODULE_1__["PluginBehavior"].create({
    name: 'computed-interactions-prop',
    category: 'custom-props',
    display: { name: 'Interactions' },
    ctor: /** @class */ (function (_super) {
        Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__extends"])(class_1, _super);
        function class_1() {
            var _this = _super !== null && _super.apply(this, arguments) || this;
            _this.provider = _mol_model_props_computed_interactions__WEBPACK_IMPORTED_MODULE_3__["InteractionsProvider"];
            _this.labelProvider = {
                label: function (loci) {
                    if (!_this.params.showTooltip)
                        return void 0;
                    switch (loci.kind) {
                        case 'element-loci':
                            if (loci.elements.length === 0)
                                return void 0;
                            var labels = [];
                            var structures = _this.getStructures(loci.structure);
                            for (var _i = 0, structures_1 = structures; _i < structures_1.length; _i++) {
                                var s = structures_1[_i];
                                var interactions = _this.provider.get(s).value;
                                if (!interactions)
                                    continue;
                                var l = _mol_model_structure_structure_element__WEBPACK_IMPORTED_MODULE_6__["default"].Loci.remap(loci, s);
                                if (l.elements.length !== 1)
                                    continue;
                                var e = l.elements[0];
                                if (_mol_data_int__WEBPACK_IMPORTED_MODULE_7__["OrderedSet"].size(e.indices) !== 1)
                                    continue;
                                var features = interactions.unitsFeatures.get(e.unit.id);
                                if (!features)
                                    continue;
                                var typeLabels = [];
                                var groupLabels = [];
                                var label = [];
                                var idx = _mol_data_int__WEBPACK_IMPORTED_MODULE_7__["OrderedSet"].start(e.indices);
                                var types = features.types, groups = features.groups, _a = features.elementsIndex, indices = _a.indices, offsets = _a.offsets;
                                for (var i = offsets[idx], il = offsets[idx + 1]; i < il; ++i) {
                                    var f = indices[i];
                                    var type = types[f];
                                    var group = groups[f];
                                    if (type)
                                        typeLabels.push(Object(_mol_model_props_computed_interactions_common__WEBPACK_IMPORTED_MODULE_8__["featureTypeLabel"])(type));
                                    if (group)
                                        groupLabels.push(Object(_mol_model_props_computed_interactions_common__WEBPACK_IMPORTED_MODULE_8__["featureGroupLabel"])(group));
                                }
                                if (typeLabels.length)
                                    label.push("<small>Types</small> " + typeLabels.join(', '));
                                if (groupLabels.length)
                                    label.push("<small>Groups</small> " + groupLabels.join(', '));
                                if (label.length)
                                    labels.push("Interaction Feature: " + label.join(' | '));
                            }
                            return labels.length ? labels.join('<br/>') : undefined;
                        default: return void 0;
                    }
                }
            };
            return _this;
        }
        class_1.prototype.getStructures = function (structure) {
            var structures = [];
            var root = this.ctx.helpers.substructureParent.get(structure);
            if (root) {
                var state = this.ctx.state.data;
                var selections = state.select(_mol_state__WEBPACK_IMPORTED_MODULE_4__["StateSelection"].Generators.ofType(_mol_plugin_state_objects__WEBPACK_IMPORTED_MODULE_5__["PluginStateObject"].Molecule.Structure, root.transform.ref));
                for (var _i = 0, selections_1 = selections; _i < selections_1.length; _i++) {
                    var s = selections_1[_i];
                    if (s.obj)
                        Object(_mol_util_array__WEBPACK_IMPORTED_MODULE_9__["arraySetAdd"])(structures, s.obj.data);
                }
            }
            return structures;
        };
        class_1.prototype.update = function (p) {
            var updated = (this.params.autoAttach !== p.autoAttach ||
                this.params.showTooltip !== p.showTooltip);
            this.params.autoAttach = p.autoAttach;
            this.params.showTooltip = p.showTooltip;
            this.ctx.customStructureProperties.setDefaultAutoAttach(this.provider.descriptor.name, this.params.autoAttach);
            return updated;
        };
        class_1.prototype.register = function () {
            this.ctx.customStructureProperties.register(this.provider, this.params.autoAttach);
            this.ctx.representation.structure.themes.colorThemeRegistry.add(_mol_model_props_computed_themes_interaction_type__WEBPACK_IMPORTED_MODULE_10__["InteractionTypeColorThemeProvider"]);
            this.ctx.managers.lociLabels.addProvider(this.labelProvider);
            this.ctx.representation.structure.registry.add(_mol_model_props_computed_representations_interactions__WEBPACK_IMPORTED_MODULE_11__["InteractionsRepresentationProvider"]);
        };
        class_1.prototype.unregister = function () {
            this.ctx.customStructureProperties.unregister(this.provider.descriptor.name);
            this.ctx.representation.structure.themes.colorThemeRegistry.remove(_mol_model_props_computed_themes_interaction_type__WEBPACK_IMPORTED_MODULE_10__["InteractionTypeColorThemeProvider"]);
            this.ctx.managers.lociLabels.removeProvider(this.labelProvider);
            this.ctx.representation.structure.registry.remove(_mol_model_props_computed_representations_interactions__WEBPACK_IMPORTED_MODULE_11__["InteractionsRepresentationProvider"]);
        };
        return class_1;
    }(_behavior__WEBPACK_IMPORTED_MODULE_1__["PluginBehavior"].Handler)),
    params: function () { return ({
        autoAttach: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_2__["ParamDefinition"].Boolean(false),
        showTooltip: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_2__["ParamDefinition"].Boolean(true)
    }); }
});
//# sourceMappingURL=interactions.js.map

/***/ }),

/***/ "./lib/mol-plugin/behavior/dynamic/custom-props/computed/secondary-structure.js":
/*!**************************************************************************************!*\
  !*** ./lib/mol-plugin/behavior/dynamic/custom-props/computed/secondary-structure.js ***!
  \**************************************************************************************/
/*! exports provided: SecondaryStructure */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SecondaryStructure", function() { return SecondaryStructure; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _behavior__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../../behavior */ "./lib/mol-plugin/behavior/behavior.js");
/* harmony import */ var _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../../../../mol-util/param-definition */ "./lib/mol-util/param-definition.js");
/* harmony import */ var _mol_model_props_computed_secondary_structure__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../../../../mol-model-props/computed/secondary-structure */ "./lib/mol-model-props/computed/secondary-structure.js");
/**
 * Copyright (c) 2019 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */




var SecondaryStructure = _behavior__WEBPACK_IMPORTED_MODULE_1__["PluginBehavior"].create({
    name: 'computed-secondary-structure-prop',
    category: 'custom-props',
    display: { name: 'Secondary Structure' },
    ctor: /** @class */ (function (_super) {
        Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__extends"])(class_1, _super);
        function class_1() {
            var _this = _super !== null && _super.apply(this, arguments) || this;
            _this.provider = _mol_model_props_computed_secondary_structure__WEBPACK_IMPORTED_MODULE_3__["SecondaryStructureProvider"];
            return _this;
        }
        class_1.prototype.update = function (p) {
            var updated = (this.params.autoAttach !== p.autoAttach);
            this.params.autoAttach = p.autoAttach;
            this.ctx.customStructureProperties.setDefaultAutoAttach(this.provider.descriptor.name, this.params.autoAttach);
            return updated;
        };
        class_1.prototype.register = function () {
            this.ctx.customStructureProperties.register(this.provider, this.params.autoAttach);
        };
        class_1.prototype.unregister = function () {
            this.ctx.customStructureProperties.unregister(this.provider.descriptor.name);
        };
        return class_1;
    }(_behavior__WEBPACK_IMPORTED_MODULE_1__["PluginBehavior"].Handler)),
    params: function () { return ({
        autoAttach: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_2__["ParamDefinition"].Boolean(false)
    }); }
});
//# sourceMappingURL=secondary-structure.js.map

/***/ }),

/***/ "./lib/mol-plugin/behavior/dynamic/custom-props/computed/valence-model.js":
/*!********************************************************************************!*\
  !*** ./lib/mol-plugin/behavior/dynamic/custom-props/computed/valence-model.js ***!
  \********************************************************************************/
/*! exports provided: ValenceModel */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ValenceModel", function() { return ValenceModel; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _behavior__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../../behavior */ "./lib/mol-plugin/behavior/behavior.js");
/* harmony import */ var _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../../../../mol-util/param-definition */ "./lib/mol-util/param-definition.js");
/* harmony import */ var _mol_model_props_computed_valence_model__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../../../../mol-model-props/computed/valence-model */ "./lib/mol-model-props/computed/valence-model.js");
/* harmony import */ var _mol_plugin_state_objects__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../../../../mol-plugin-state/objects */ "./lib/mol-plugin-state/objects.js");
/* harmony import */ var _mol_state__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../../../../mol-state */ "./lib/mol-state/index.js");
/* harmony import */ var _mol_model_structure__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../../../../../mol-model/structure */ "./lib/mol-model/structure.js");
/* harmony import */ var _mol_data_int__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../../../../../mol-data/int */ "./lib/mol-data/int.js");
/* harmony import */ var _mol_model_props_computed_chemistry_geometry__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ../../../../../mol-model-props/computed/chemistry/geometry */ "./lib/mol-model-props/computed/chemistry/geometry.js");
/* harmony import */ var _mol_util_array__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ../../../../../mol-util/array */ "./lib/mol-util/array.js");
/**
 * Copyright (c) 2019 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */










var ValenceModel = _behavior__WEBPACK_IMPORTED_MODULE_1__["PluginBehavior"].create({
    name: 'computed-valence-model-prop',
    category: 'custom-props',
    display: { name: 'Valence Model' },
    ctor: /** @class */ (function (_super) {
        Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__extends"])(class_1, _super);
        function class_1() {
            var _this = _super !== null && _super.apply(this, arguments) || this;
            _this.provider = _mol_model_props_computed_valence_model__WEBPACK_IMPORTED_MODULE_3__["ValenceModelProvider"];
            _this.labelProvider = {
                label: function (loci) {
                    if (!_this.params.showTooltip)
                        return void 0;
                    switch (loci.kind) {
                        case 'element-loci':
                            if (loci.elements.length === 0)
                                return void 0;
                            var labels = [];
                            var structures = _this.getStructures(loci.structure);
                            for (var _i = 0, structures_1 = structures; _i < structures_1.length; _i++) {
                                var s = structures_1[_i];
                                var valenceModel = _this.provider.get(s).value;
                                if (!valenceModel)
                                    continue;
                                var l = _mol_model_structure__WEBPACK_IMPORTED_MODULE_6__["StructureElement"].Loci.remap(loci, s);
                                if (l.elements.length !== 1)
                                    continue;
                                var e = l.elements[0];
                                if (_mol_data_int__WEBPACK_IMPORTED_MODULE_7__["OrderedSet"].size(e.indices) !== 1)
                                    continue;
                                var vm = valenceModel.get(e.unit.id);
                                if (!vm)
                                    continue;
                                var idx = _mol_data_int__WEBPACK_IMPORTED_MODULE_7__["OrderedSet"].start(e.indices);
                                var charge = vm.charge[idx];
                                var idealGeometry = vm.idealGeometry[idx];
                                var implicitH = vm.implicitH[idx];
                                var totalH = vm.totalH[idx];
                                labels.push("Valence Model: <small>Charge</small> " + charge + " | <small>Ideal Geometry</small> " + Object(_mol_model_props_computed_chemistry_geometry__WEBPACK_IMPORTED_MODULE_8__["geometryLabel"])(idealGeometry) + " | <small>Implicit H</small> " + implicitH + " | <small>Total H</small> " + totalH);
                            }
                            return labels.length ? labels.join('<br/>') : undefined;
                        default: return void 0;
                    }
                }
            };
            return _this;
        }
        class_1.prototype.getStructures = function (structure) {
            var structures = [];
            var root = this.ctx.helpers.substructureParent.get(structure);
            if (root) {
                var state = this.ctx.state.data;
                var selections = state.select(_mol_state__WEBPACK_IMPORTED_MODULE_5__["StateSelection"].Generators.ofType(_mol_plugin_state_objects__WEBPACK_IMPORTED_MODULE_4__["PluginStateObject"].Molecule.Structure, root.transform.ref));
                for (var _i = 0, selections_1 = selections; _i < selections_1.length; _i++) {
                    var s = selections_1[_i];
                    if (s.obj)
                        Object(_mol_util_array__WEBPACK_IMPORTED_MODULE_9__["arraySetAdd"])(structures, s.obj.data);
                }
            }
            return structures;
        };
        class_1.prototype.update = function (p) {
            var updated = (this.params.autoAttach !== p.autoAttach ||
                this.params.showTooltip !== p.showTooltip);
            this.params.autoAttach = p.autoAttach;
            this.params.showTooltip = p.showTooltip;
            this.ctx.customStructureProperties.setDefaultAutoAttach(this.provider.descriptor.name, this.params.autoAttach);
            return updated;
        };
        class_1.prototype.register = function () {
            this.ctx.customStructureProperties.register(this.provider, this.params.autoAttach);
            this.ctx.managers.lociLabels.addProvider(this.labelProvider);
        };
        class_1.prototype.unregister = function () {
            this.ctx.customStructureProperties.unregister(this.provider.descriptor.name);
            this.ctx.managers.lociLabels.removeProvider(this.labelProvider);
        };
        return class_1;
    }(_behavior__WEBPACK_IMPORTED_MODULE_1__["PluginBehavior"].Handler)),
    params: function () { return ({
        autoAttach: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_2__["ParamDefinition"].Boolean(false),
        showTooltip: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_2__["ParamDefinition"].Boolean(true)
    }); }
});
//# sourceMappingURL=valence-model.js.map

/***/ }),

/***/ "./lib/mol-plugin/behavior/dynamic/custom-props/integrative/cross-link-restraint.js":
/*!******************************************************************************************!*\
  !*** ./lib/mol-plugin/behavior/dynamic/custom-props/integrative/cross-link-restraint.js ***!
  \******************************************************************************************/
/*! exports provided: CrossLinkRestraint */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CrossLinkRestraint", function() { return CrossLinkRestraint; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _behavior__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../../behavior */ "./lib/mol-plugin/behavior/behavior.js");
/* harmony import */ var _mol_model_props_integrative_cross_link_restraint_format__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../../../../mol-model-props/integrative/cross-link-restraint/format */ "./lib/mol-model-props/integrative/cross-link-restraint/format.js");
/* harmony import */ var _mol_model_formats_structure_mmcif__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../../../../mol-model-formats/structure/mmcif */ "./lib/mol-model-formats/structure/mmcif.js");
/* harmony import */ var _mol_model_props_integrative_cross_link_restraint_representation__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../../../../mol-model-props/integrative/cross-link-restraint/representation */ "./lib/mol-model-props/integrative/cross-link-restraint/representation.js");
/* harmony import */ var _mol_model_props_integrative_cross_link_restraint_color__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../../../../mol-model-props/integrative/cross-link-restraint/color */ "./lib/mol-model-props/integrative/cross-link-restraint/color.js");
/**
 * Copyright (c) 2020 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */






var CrossLinkRestraint = _behavior__WEBPACK_IMPORTED_MODULE_1__["PluginBehavior"].create({
    name: 'integrative-cross-link-restraint',
    category: 'custom-props',
    display: { name: 'Cross Link Restraint' },
    ctor: /** @class */ (function (_super) {
        Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__extends"])(class_1, _super);
        function class_1() {
            var _this = _super !== null && _super.apply(this, arguments) || this;
            _this.provider = _mol_model_props_integrative_cross_link_restraint_format__WEBPACK_IMPORTED_MODULE_2__["ModelCrossLinkRestraint"].Provider;
            return _this;
        }
        class_1.prototype.register = function () {
            this.provider.formatRegistry.add('mmCIF', crossLinkRestraintFromMmcif);
            this.ctx.representation.structure.themes.colorThemeRegistry.add(_mol_model_props_integrative_cross_link_restraint_color__WEBPACK_IMPORTED_MODULE_5__["CrossLinkColorThemeProvider"]);
            this.ctx.representation.structure.registry.add(_mol_model_props_integrative_cross_link_restraint_representation__WEBPACK_IMPORTED_MODULE_4__["CrossLinkRestraintRepresentationProvider"]);
        };
        class_1.prototype.unregister = function () {
            this.provider.formatRegistry.remove('mmCIF');
            this.ctx.representation.structure.themes.colorThemeRegistry.remove(_mol_model_props_integrative_cross_link_restraint_color__WEBPACK_IMPORTED_MODULE_5__["CrossLinkColorThemeProvider"]);
            this.ctx.representation.structure.registry.remove(_mol_model_props_integrative_cross_link_restraint_representation__WEBPACK_IMPORTED_MODULE_4__["CrossLinkRestraintRepresentationProvider"]);
        };
        return class_1;
    }(_behavior__WEBPACK_IMPORTED_MODULE_1__["PluginBehavior"].Handler))
});
function crossLinkRestraintFromMmcif(model) {
    if (!_mol_model_formats_structure_mmcif__WEBPACK_IMPORTED_MODULE_3__["MmcifFormat"].is(model.sourceData))
        return;
    var ihm_cross_link_restraint = model.sourceData.data.db.ihm_cross_link_restraint;
    if (ihm_cross_link_restraint._rowCount === 0)
        return;
    return _mol_model_props_integrative_cross_link_restraint_format__WEBPACK_IMPORTED_MODULE_2__["ModelCrossLinkRestraint"].fromTable(ihm_cross_link_restraint, model);
}
//# sourceMappingURL=cross-link-restraint.js.map

/***/ }),

/***/ "./lib/mol-plugin/behavior/dynamic/custom-props/structure-info.js":
/*!************************************************************************!*\
  !*** ./lib/mol-plugin/behavior/dynamic/custom-props/structure-info.js ***!
  \************************************************************************/
/*! exports provided: StructureInfo */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "StructureInfo", function() { return StructureInfo; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _behavior__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../../behavior */ "./lib/mol-plugin/behavior.js");
/* harmony import */ var _mol_model_structure__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../../../mol-model/structure */ "./lib/mol-model/structure.js");
/* harmony import */ var _mol_plugin_state_objects__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../../../mol-plugin-state/objects */ "./lib/mol-plugin-state/objects.js");
/* harmony import */ var _mol_state__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../../../mol-state */ "./lib/mol-state/index.js");
/**
 * Copyright (c) 2020 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */





var StructureInfo = _behavior__WEBPACK_IMPORTED_MODULE_1__["PluginBehavior"].create({
    name: 'structure-info-prop',
    category: 'custom-props',
    display: { name: 'Structure Info' },
    ctor: /** @class */ (function (_super) {
        Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__extends"])(class_1, _super);
        function class_1() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        Object.defineProperty(class_1.prototype, "maxModelIndex", {
            get: function () {
                var _a, _b;
                var maxIndex = -1;
                var cells = this.ctx.state.data.select(_mol_state__WEBPACK_IMPORTED_MODULE_4__["StateSelection"].Generators.rootsOfType(_mol_plugin_state_objects__WEBPACK_IMPORTED_MODULE_3__["PluginStateObject"].Molecule.Model));
                for (var _i = 0, cells_1 = cells; _i < cells_1.length; _i++) {
                    var c = cells_1[_i];
                    var index = ((_a = c.obj) === null || _a === void 0 ? void 0 : _a.data) && _mol_model_structure__WEBPACK_IMPORTED_MODULE_2__["Model"].Index.get((_b = c.obj) === null || _b === void 0 ? void 0 : _b.data).value;
                    if (index !== undefined && index > maxIndex)
                        maxIndex = index;
                }
                return maxIndex;
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(class_1.prototype, "maxStructureIndex", {
            get: function () {
                var _a, _b;
                var maxIndex = -1;
                var cells = this.ctx.state.data.select(_mol_state__WEBPACK_IMPORTED_MODULE_4__["StateSelection"].Generators.rootsOfType(_mol_plugin_state_objects__WEBPACK_IMPORTED_MODULE_3__["PluginStateObject"].Molecule.Structure));
                for (var _i = 0, cells_2 = cells; _i < cells_2.length; _i++) {
                    var c = cells_2[_i];
                    var index = ((_a = c.obj) === null || _a === void 0 ? void 0 : _a.data) && _mol_model_structure__WEBPACK_IMPORTED_MODULE_2__["Structure"].Index.get((_b = c.obj) === null || _b === void 0 ? void 0 : _b.data).value;
                    if (index !== undefined && index > maxIndex)
                        maxIndex = index;
                }
                return maxIndex;
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(class_1.prototype, "asymIdOffset", {
            get: function () {
                var _a;
                var auth = 0;
                var label = 0;
                var cells = this.ctx.state.data.select(_mol_state__WEBPACK_IMPORTED_MODULE_4__["StateSelection"].Generators.rootsOfType(_mol_plugin_state_objects__WEBPACK_IMPORTED_MODULE_3__["PluginStateObject"].Molecule.Model));
                for (var _i = 0, cells_3 = cells; _i < cells_3.length; _i++) {
                    var c = cells_3[_i];
                    var m = (_a = c.obj) === null || _a === void 0 ? void 0 : _a.data;
                    if (m) {
                        var count = _mol_model_structure__WEBPACK_IMPORTED_MODULE_2__["Model"].AsymIdCount.get(m);
                        var offset = _mol_model_structure__WEBPACK_IMPORTED_MODULE_2__["Model"].AsymIdOffset.get(m).value;
                        if (count !== undefined && offset !== undefined) {
                            auth = Math.max(auth, offset.auth + count.auth);
                            label = Math.max(label, offset.label + count.label);
                        }
                    }
                }
                return { auth: auth, label: label };
            },
            enumerable: false,
            configurable: true
        });
        class_1.prototype.handleModel = function (model, oldModel) {
            if (_mol_model_structure__WEBPACK_IMPORTED_MODULE_2__["Model"].Index.get(model).value === undefined) {
                var oldIndex = oldModel && _mol_model_structure__WEBPACK_IMPORTED_MODULE_2__["Model"].Index.get(oldModel).value;
                var value = oldIndex !== null && oldIndex !== void 0 ? oldIndex : (this.maxModelIndex + 1);
                _mol_model_structure__WEBPACK_IMPORTED_MODULE_2__["Model"].Index.set(model, { value: value });
            }
            if (_mol_model_structure__WEBPACK_IMPORTED_MODULE_2__["Model"].AsymIdOffset.get(model).value === undefined) {
                var oldOffset = oldModel && _mol_model_structure__WEBPACK_IMPORTED_MODULE_2__["Model"].AsymIdOffset.get(oldModel).value;
                var value = oldOffset !== null && oldOffset !== void 0 ? oldOffset : Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, this.asymIdOffset);
                _mol_model_structure__WEBPACK_IMPORTED_MODULE_2__["Model"].AsymIdOffset.set(model, { value: value });
            }
        };
        class_1.prototype.handleStructure = function (structure, oldStructure) {
            if (structure.parent !== undefined)
                return;
            if (_mol_model_structure__WEBPACK_IMPORTED_MODULE_2__["Structure"].Index.get(structure).value !== undefined)
                return;
            var oldIndex = oldStructure && _mol_model_structure__WEBPACK_IMPORTED_MODULE_2__["Structure"].Index.get(oldStructure).value;
            var value = oldIndex !== null && oldIndex !== void 0 ? oldIndex : (this.maxStructureIndex + 1);
            _mol_model_structure__WEBPACK_IMPORTED_MODULE_2__["Structure"].Index.set(structure, { value: value });
        };
        class_1.prototype.handle = function (ref, obj, oldObj) {
            if (_mol_plugin_state_objects__WEBPACK_IMPORTED_MODULE_3__["PluginStateObject"].Molecule.Structure.is(obj)) {
                var transform = this.ctx.state.data.tree.transforms.get(ref);
                if (!transform.transformer.definition.isDecorator && obj.data.parent === undefined) {
                    this.handleStructure(obj.data, oldObj === null || oldObj === void 0 ? void 0 : oldObj.data);
                }
            }
            else if (_mol_plugin_state_objects__WEBPACK_IMPORTED_MODULE_3__["PluginStateObject"].Molecule.Model.is(obj)) {
                var transform = this.ctx.state.data.tree.transforms.get(ref);
                if (!transform.transformer.definition.isDecorator) {
                    this.handleModel(obj.data, oldObj === null || oldObj === void 0 ? void 0 : oldObj.data);
                }
            }
        };
        class_1.prototype.register = function () {
            var _this = this;
            this.ctx.customModelProperties.register(_mol_model_structure__WEBPACK_IMPORTED_MODULE_2__["Model"].AsymIdOffset, true);
            this.ctx.customModelProperties.register(_mol_model_structure__WEBPACK_IMPORTED_MODULE_2__["Model"].Index, true);
            this.ctx.customStructureProperties.register(_mol_model_structure__WEBPACK_IMPORTED_MODULE_2__["Structure"].Index, true);
            this.subscribeObservable(this.ctx.state.data.events.object.created, function (o) {
                _this.handle(o.ref, o.obj);
            });
            this.subscribeObservable(this.ctx.state.data.events.object.updated, function (o) {
                _this.handle(o.ref, o.obj, o.oldObj);
            });
        };
        class_1.prototype.unregister = function () {
            this.ctx.customModelProperties.unregister(_mol_model_structure__WEBPACK_IMPORTED_MODULE_2__["Model"].AsymIdOffset.descriptor.name);
            this.ctx.customModelProperties.unregister(_mol_model_structure__WEBPACK_IMPORTED_MODULE_2__["Model"].Index.descriptor.name);
            this.ctx.customStructureProperties.unregister(_mol_model_structure__WEBPACK_IMPORTED_MODULE_2__["Structure"].Index.descriptor.name);
        };
        return class_1;
    }(_behavior__WEBPACK_IMPORTED_MODULE_1__["PluginBehavior"].Handler))
});
//# sourceMappingURL=structure-info.js.map

/***/ }),

/***/ "./lib/mol-plugin/behavior/dynamic/representation.js":
/*!***********************************************************!*\
  !*** ./lib/mol-plugin/behavior/dynamic/representation.js ***!
  \***********************************************************/
/*! exports provided: HighlightLoci, SelectLoci, DefaultLociLabelProvider, FocusLoci */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "HighlightLoci", function() { return HighlightLoci; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SelectLoci", function() { return SelectLoci; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DefaultLociLabelProvider", function() { return DefaultLociLabelProvider; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FocusLoci", function() { return FocusLoci; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _mol_util_marker_action__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../../mol-util/marker-action */ "./lib/mol-util/marker-action.js");
/* harmony import */ var _mol_plugin_state_objects__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../../mol-plugin-state/objects */ "./lib/mol-plugin-state/objects.js");
/* harmony import */ var _mol_theme_label__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../../mol-theme/label */ "./lib/mol-theme/label.js");
/* harmony import */ var _behavior__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../behavior */ "./lib/mol-plugin/behavior/behavior.js");
/* harmony import */ var _mol_state_tree_spine__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../../mol-state/tree/spine */ "./lib/mol-state/tree/spine.js");
/* harmony import */ var _mol_state__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../../../mol-state */ "./lib/mol-state/index.js");
/* harmony import */ var _mol_util_input_input_observer__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../../../mol-util/input/input-observer */ "./lib/mol-util/input/input-observer.js");
/* harmony import */ var _mol_util_binding__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ../../../mol-util/binding */ "./lib/mol-util/binding.js");
/* harmony import */ var _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ../../../mol-util/param-definition */ "./lib/mol-util/param-definition.js");
/* harmony import */ var _mol_model_loci__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ../../../mol-model/loci */ "./lib/mol-model/loci.js");
/* harmony import */ var _mol_model_structure__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ../../../mol-model/structure */ "./lib/mol-model/structure.js");
/* harmony import */ var _mol_util_array__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! ../../../mol-util/array */ "./lib/mol-util/array.js");
/**
 * Copyright (c) 2018-2020 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author David Sehnal <david.sehnal@gmail.com>
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */













var B = _mol_util_input_input_observer__WEBPACK_IMPORTED_MODULE_7__["ButtonsType"];
var M = _mol_util_input_input_observer__WEBPACK_IMPORTED_MODULE_7__["ModifiersKeys"];
var Trigger = _mol_util_binding__WEBPACK_IMPORTED_MODULE_8__["Binding"].Trigger;
//
var DefaultHighlightLociBindings = {
    hoverHighlightOnly: Object(_mol_util_binding__WEBPACK_IMPORTED_MODULE_8__["Binding"])([Trigger(0 /* None */)], 'Highlight', 'Hover element using ${triggers}'),
    hoverHighlightOnlyExtend: Object(_mol_util_binding__WEBPACK_IMPORTED_MODULE_8__["Binding"])([Trigger(0 /* None */, M.create({ shift: true }))], 'Extend highlight', 'From selected to hovered element along polymer using ${triggers}'),
};
var HighlightLociParams = {
    bindings: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_9__["ParamDefinition"].Value(DefaultHighlightLociBindings, { isHidden: true }),
    ignore: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_9__["ParamDefinition"].Value([], { isHidden: true }),
    mark: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_9__["ParamDefinition"].Boolean(true)
};
var HighlightLoci = _behavior__WEBPACK_IMPORTED_MODULE_4__["PluginBehavior"].create({
    name: 'representation-highlight-loci',
    category: 'interaction',
    ctor: /** @class */ (function (_super) {
        Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__extends"])(class_1, _super);
        function class_1() {
            var _this = _super !== null && _super.apply(this, arguments) || this;
            _this.lociMarkProvider = function (interactionLoci, action) {
                if (!_this.ctx.canvas3d || !_this.params.mark)
                    return;
                _this.ctx.canvas3d.mark(interactionLoci, action);
            };
            return _this;
        }
        class_1.prototype.register = function () {
            var _this = this;
            this.subscribeObservable(this.ctx.behaviors.interaction.hover, function (_a) {
                var _b;
                var current = _a.current, buttons = _a.buttons, modifiers = _a.modifiers;
                if (!_this.ctx.canvas3d || _this.ctx.isBusy)
                    return;
                if (((_b = _this.params.ignore) === null || _b === void 0 ? void 0 : _b.indexOf(current.loci.kind)) >= 0) {
                    _this.ctx.managers.interactivity.lociHighlights.highlightOnly({ repr: current.repr, loci: _mol_model_loci__WEBPACK_IMPORTED_MODULE_10__["EmptyLoci"] });
                    return;
                }
                var matched = false;
                if (_mol_util_binding__WEBPACK_IMPORTED_MODULE_8__["Binding"].match(_this.params.bindings.hoverHighlightOnly, buttons, modifiers)) {
                    // remove repr to highlight loci everywhere on hover
                    _this.ctx.managers.interactivity.lociHighlights.highlightOnly({ loci: current.loci });
                    matched = true;
                }
                if (_mol_util_binding__WEBPACK_IMPORTED_MODULE_8__["Binding"].match(_this.params.bindings.hoverHighlightOnlyExtend, buttons, modifiers)) {
                    // remove repr to highlight loci everywhere on hover
                    _this.ctx.managers.interactivity.lociHighlights.highlightOnlyExtend({ loci: current.loci });
                    matched = true;
                }
                if (!matched) {
                    _this.ctx.managers.interactivity.lociHighlights.highlightOnly({ repr: current.repr, loci: _mol_model_loci__WEBPACK_IMPORTED_MODULE_10__["EmptyLoci"] });
                }
            });
            this.ctx.managers.interactivity.lociHighlights.addProvider(this.lociMarkProvider);
        };
        class_1.prototype.unregister = function () {
            this.ctx.managers.interactivity.lociHighlights.removeProvider(this.lociMarkProvider);
        };
        return class_1;
    }(_behavior__WEBPACK_IMPORTED_MODULE_4__["PluginBehavior"].Handler)),
    params: function () { return HighlightLociParams; },
    display: { name: 'Highlight Loci on Canvas' }
});
//
var DefaultSelectLociBindings = {
    clickSelect: _mol_util_binding__WEBPACK_IMPORTED_MODULE_8__["Binding"].Empty,
    clickToggleExtend: Object(_mol_util_binding__WEBPACK_IMPORTED_MODULE_8__["Binding"])([Trigger(1 /* Primary */, M.create({ shift: true }))], 'Toggle extended selection', '${triggers} to extend selection along polymer'),
    clickSelectOnly: _mol_util_binding__WEBPACK_IMPORTED_MODULE_8__["Binding"].Empty,
    clickToggle: Object(_mol_util_binding__WEBPACK_IMPORTED_MODULE_8__["Binding"])([Trigger(1 /* Primary */, M.create())], 'Toggle selection', '${triggers} on element'),
    clickDeselect: _mol_util_binding__WEBPACK_IMPORTED_MODULE_8__["Binding"].Empty,
    clickDeselectAllOnEmpty: Object(_mol_util_binding__WEBPACK_IMPORTED_MODULE_8__["Binding"])([Trigger(1 /* Primary */, M.create())], 'Deselect all', 'Click on nothing using ${triggers}'),
};
var SelectLociParams = {
    bindings: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_9__["ParamDefinition"].Value(DefaultSelectLociBindings, { isHidden: true }),
    ignore: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_9__["ParamDefinition"].Value([], { isHidden: true }),
    mark: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_9__["ParamDefinition"].Boolean(true)
};
var SelectLoci = _behavior__WEBPACK_IMPORTED_MODULE_4__["PluginBehavior"].create({
    name: 'representation-select-loci',
    category: 'interaction',
    ctor: /** @class */ (function (_super) {
        Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__extends"])(class_2, _super);
        function class_2(ctx, params) {
            var _this = _super.call(this, ctx, params) || this;
            _this.lociMarkProvider = function (reprLoci, action) {
                if (!_this.ctx.canvas3d || !_this.params.mark)
                    return;
                _this.ctx.canvas3d.mark({ loci: reprLoci.loci }, action);
            };
            _this.spine = new _mol_state_tree_spine__WEBPACK_IMPORTED_MODULE_5__["StateTreeSpine"].Impl(ctx.state.data.cells);
            return _this;
        }
        class_2.prototype.applySelectMark = function (ref, clear) {
            var cell = this.ctx.state.data.cells.get(ref);
            if (cell && _mol_plugin_state_objects__WEBPACK_IMPORTED_MODULE_2__["PluginStateObject"].isRepresentation3D(cell.obj)) {
                this.spine.current = cell;
                var so = this.spine.getRootOfType(_mol_plugin_state_objects__WEBPACK_IMPORTED_MODULE_2__["PluginStateObject"].Molecule.Structure);
                if (so) {
                    if (clear) {
                        this.lociMarkProvider({ loci: _mol_model_structure__WEBPACK_IMPORTED_MODULE_11__["Structure"].Loci(so.data) }, _mol_util_marker_action__WEBPACK_IMPORTED_MODULE_1__["MarkerAction"].Deselect);
                    }
                    var loci = this.ctx.managers.structure.selection.getLoci(so.data);
                    this.lociMarkProvider({ loci: loci }, _mol_util_marker_action__WEBPACK_IMPORTED_MODULE_1__["MarkerAction"].Select);
                }
            }
        };
        class_2.prototype.register = function () {
            var _this = this;
            var lociIsEmpty = function (current) { return _mol_model_loci__WEBPACK_IMPORTED_MODULE_10__["Loci"].isEmpty(current.loci); };
            var lociIsNotEmpty = function (current) { return !_mol_model_loci__WEBPACK_IMPORTED_MODULE_10__["Loci"].isEmpty(current.loci); };
            var actions = [
                ['clickSelect', function (current) { return _this.ctx.managers.interactivity.lociSelects.select(current); }, lociIsNotEmpty],
                ['clickToggle', function (current) { return _this.ctx.managers.interactivity.lociSelects.toggle(current); }, lociIsNotEmpty],
                ['clickToggleExtend', function (current) { return _this.ctx.managers.interactivity.lociSelects.toggleExtend(current); }, lociIsNotEmpty],
                ['clickSelectOnly', function (current) { return _this.ctx.managers.interactivity.lociSelects.selectOnly(current); }, lociIsNotEmpty],
                ['clickDeselect', function (current) { return _this.ctx.managers.interactivity.lociSelects.deselect(current); }, lociIsNotEmpty],
                ['clickDeselectAllOnEmpty', function () { return _this.ctx.managers.interactivity.lociSelects.deselectAll(); }, lociIsEmpty],
            ];
            // sort the action so that the ones with more modifiers trigger sooner.
            actions.sort(function (a, b) {
                var x = _this.params.bindings[a[0]], y = _this.params.bindings[b[0]];
                var k = x.triggers.length === 0 ? 0 : Object(_mol_util_array__WEBPACK_IMPORTED_MODULE_12__["arrayMax"])(x.triggers.map(function (t) { return M.size(t.modifiers); }));
                var l = y.triggers.length === 0 ? 0 : Object(_mol_util_array__WEBPACK_IMPORTED_MODULE_12__["arrayMax"])(y.triggers.map(function (t) { return M.size(t.modifiers); }));
                return l - k;
            });
            this.subscribeObservable(this.ctx.behaviors.interaction.click, function (_a) {
                var _b;
                var current = _a.current, button = _a.button, modifiers = _a.modifiers;
                if (!_this.ctx.canvas3d || _this.ctx.isBusy || !_this.ctx.selectionMode)
                    return;
                if (((_b = _this.params.ignore) === null || _b === void 0 ? void 0 : _b.indexOf(current.loci.kind)) >= 0)
                    return;
                // only trigger the 1st action that matches
                for (var _i = 0, actions_1 = actions; _i < actions_1.length; _i++) {
                    var _c = actions_1[_i], binding = _c[0], action = _c[1], condition = _c[2];
                    if (_mol_util_binding__WEBPACK_IMPORTED_MODULE_8__["Binding"].match(_this.params.bindings[binding], button, modifiers) && (!condition || condition(current))) {
                        action(current);
                        break;
                    }
                }
            });
            this.ctx.managers.interactivity.lociSelects.addProvider(this.lociMarkProvider);
            this.subscribeObservable(this.ctx.state.events.object.created, function (_a) {
                var ref = _a.ref;
                return _this.applySelectMark(ref);
            });
            // re-apply select-mark to all representation of an updated structure
            this.subscribeObservable(this.ctx.state.events.object.updated, function (_a) {
                var ref = _a.ref, obj = _a.obj, oldObj = _a.oldObj, oldData = _a.oldData, action = _a.action;
                var cell = _this.ctx.state.data.cells.get(ref);
                if (cell && _mol_plugin_state_objects__WEBPACK_IMPORTED_MODULE_2__["PluginStateObject"].Molecule.Structure.is(cell.obj)) {
                    var structure = obj.data;
                    var oldStructure = action === 'recreate' ? oldObj === null || oldObj === void 0 ? void 0 : oldObj.data :
                        action === 'in-place' ? oldData : undefined;
                    if (oldStructure &&
                        _mol_model_structure__WEBPACK_IMPORTED_MODULE_11__["Structure"].areEquivalent(structure, oldStructure) &&
                        _mol_model_structure__WEBPACK_IMPORTED_MODULE_11__["Structure"].areHierarchiesEqual(structure, oldStructure))
                        return;
                    var reprs = _this.ctx.state.data.select(_mol_state__WEBPACK_IMPORTED_MODULE_6__["StateSelection"].Generators.ofType(_mol_plugin_state_objects__WEBPACK_IMPORTED_MODULE_2__["PluginStateObject"].Molecule.Structure.Representation3D, ref));
                    for (var _i = 0, reprs_1 = reprs; _i < reprs_1.length; _i++) {
                        var repr = reprs_1[_i];
                        _this.applySelectMark(repr.transform.ref, true);
                    }
                }
            });
        };
        class_2.prototype.unregister = function () {
            this.ctx.managers.interactivity.lociSelects.removeProvider(this.lociMarkProvider);
        };
        return class_2;
    }(_behavior__WEBPACK_IMPORTED_MODULE_4__["PluginBehavior"].Handler)),
    params: function () { return SelectLociParams; },
    display: { name: 'Select Loci on Canvas' }
});
//
var DefaultLociLabelProvider = _behavior__WEBPACK_IMPORTED_MODULE_4__["PluginBehavior"].create({
    name: 'default-loci-label-provider',
    category: 'interaction',
    ctor: /** @class */ (function () {
        function class_3(ctx) {
            this.ctx = ctx;
            this.f = {
                label: function (loci) {
                    var label = [];
                    if (_mol_model_structure__WEBPACK_IMPORTED_MODULE_11__["StructureElement"].Loci.is(loci) && loci.elements.length === 1) {
                        var u = loci.elements[0].unit;
                        var l = _mol_model_structure__WEBPACK_IMPORTED_MODULE_11__["StructureElement"].Location.create(loci.structure, u, u.elements[0]);
                        var name_1 = _mol_model_structure__WEBPACK_IMPORTED_MODULE_11__["StructureProperties"].entity.pdbx_description(l).join(', ');
                        label.push(name_1);
                    }
                    label.push(Object(_mol_theme_label__WEBPACK_IMPORTED_MODULE_3__["lociLabel"])(loci));
                    return label.filter(function (l) { return !!l; }).join('</br>');
                },
                group: function (label) { return label.toString().replace(/Model [0-9]+/g, 'Models'); },
                priority: 100
            };
        }
        class_3.prototype.register = function () { this.ctx.managers.lociLabels.addProvider(this.f); };
        class_3.prototype.unregister = function () { this.ctx.managers.lociLabels.removeProvider(this.f); };
        return class_3;
    }()),
    display: { name: 'Provide Default Loci Label' }
});
//
var DefaultFocusLociBindings = {
    clickFocus: Object(_mol_util_binding__WEBPACK_IMPORTED_MODULE_8__["Binding"])([
        Trigger(1 /* Primary */, M.create()),
    ], 'Representation Focus', 'Click element using ${triggers}'),
    clickFocusAdd: Object(_mol_util_binding__WEBPACK_IMPORTED_MODULE_8__["Binding"])([
        Trigger(1 /* Primary */, M.create({ shift: true })),
    ], 'Representation Focus Add', 'Click element using ${triggers}'),
    clickFocusSelectMode: Object(_mol_util_binding__WEBPACK_IMPORTED_MODULE_8__["Binding"])([
    // default is empty
    ], 'Representation Focus', 'Click element using ${triggers}'),
    clickFocusAddSelectMode: Object(_mol_util_binding__WEBPACK_IMPORTED_MODULE_8__["Binding"])([
    // default is empty
    ], 'Representation Focus Add', 'Click element using ${triggers}'),
};
var FocusLociParams = {
    bindings: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_9__["ParamDefinition"].Value(DefaultFocusLociBindings, { isHidden: true }),
};
var FocusLoci = _behavior__WEBPACK_IMPORTED_MODULE_4__["PluginBehavior"].create({
    name: 'representation-focus-loci',
    category: 'interaction',
    ctor: /** @class */ (function (_super) {
        Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__extends"])(class_4, _super);
        function class_4() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        class_4.prototype.register = function () {
            var _this = this;
            this.subscribeObservable(this.ctx.behaviors.interaction.click, function (_a) {
                var _b;
                var current = _a.current, button = _a.button, modifiers = _a.modifiers;
                var _c = _this.params.bindings, clickFocus = _c.clickFocus, clickFocusAdd = _c.clickFocusAdd, clickFocusSelectMode = _c.clickFocusSelectMode, clickFocusAddSelectMode = _c.clickFocusAddSelectMode;
                // only apply structure focus for appropriate granularity
                var granularity = _this.ctx.managers.interactivity.props.granularity;
                if (granularity !== 'residue' && granularity !== 'element')
                    return;
                var binding = _this.ctx.selectionMode ? clickFocusSelectMode : clickFocus;
                var matched = _mol_util_binding__WEBPACK_IMPORTED_MODULE_8__["Binding"].match(binding, button, modifiers);
                var bindingAdd = _this.ctx.selectionMode ? clickFocusAddSelectMode : clickFocusAdd;
                var matchedAdd = _mol_util_binding__WEBPACK_IMPORTED_MODULE_8__["Binding"].match(bindingAdd, button, modifiers);
                if (!matched && !matchedAdd)
                    return;
                var loci = _mol_model_loci__WEBPACK_IMPORTED_MODULE_10__["Loci"].normalize(current.loci, 'residue');
                var entry = _this.ctx.managers.structure.focus.current;
                if (entry && _mol_model_loci__WEBPACK_IMPORTED_MODULE_10__["Loci"].areEqual(entry.loci, loci)) {
                    _this.ctx.managers.structure.focus.clear();
                }
                else {
                    if (matched) {
                        _this.ctx.managers.structure.focus.setFromLoci(loci);
                    }
                    else {
                        _this.ctx.managers.structure.focus.addFromLoci(loci);
                        // focus-add is not handled in camera behavior, doing it here
                        var current_1 = (_b = _this.ctx.managers.structure.focus.current) === null || _b === void 0 ? void 0 : _b.loci;
                        if (current_1)
                            _this.ctx.managers.camera.focusLoci(current_1);
                    }
                }
            });
        };
        return class_4;
    }(_behavior__WEBPACK_IMPORTED_MODULE_4__["PluginBehavior"].Handler)),
    params: function () { return FocusLociParams; },
    display: { name: 'Representation Focus Loci on Canvas' }
});
//# sourceMappingURL=representation.js.map

/***/ }),

/***/ "./lib/mol-plugin/behavior/dynamic/selection/structure-focus-representation.js":
/*!*************************************************************************************!*\
  !*** ./lib/mol-plugin/behavior/dynamic/selection/structure-focus-representation.js ***!
  \*************************************************************************************/
/*! exports provided: StructureFocusRepresentationTags, StructureFocusRepresentation */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "StructureFocusRepresentationTags", function() { return StructureFocusRepresentationTags; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "StructureFocusRepresentation", function() { return StructureFocusRepresentation; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _mol_model_props_computed_representations_interactions__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../../../mol-model-props/computed/representations/interactions */ "./lib/mol-model-props/computed/representations/interactions.js");
/* harmony import */ var _mol_model_props_computed_themes_interaction_type__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../../../mol-model-props/computed/themes/interaction-type */ "./lib/mol-model-props/computed/themes/interaction-type.js");
/* harmony import */ var _mol_model_structure__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../../../mol-model/structure */ "./lib/mol-model/structure.js");
/* harmony import */ var _mol_plugin_state_helpers_structure_representation_params__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../../../mol-plugin-state/helpers/structure-representation-params */ "./lib/mol-plugin-state/helpers/structure-representation-params.js");
/* harmony import */ var _mol_plugin_state_transforms__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../../../mol-plugin-state/transforms */ "./lib/mol-plugin-state/transforms.js");
/* harmony import */ var _behavior__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../../../behavior */ "./lib/mol-plugin/behavior.js");
/* harmony import */ var _mol_script_language_builder__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../../../../mol-script/language/builder */ "./lib/mol-script/language/builder.js");
/* harmony import */ var _mol_state__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ../../../../mol-state */ "./lib/mol-state/index.js");
/* harmony import */ var _mol_theme_size__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ../../../../mol-theme/size */ "./lib/mol-theme/size.js");
/* harmony import */ var _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ../../../../mol-util/param-definition */ "./lib/mol-util/param-definition.js");
/* harmony import */ var _commands__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ../../../commands */ "./lib/mol-plugin/commands.js");
/**
 * Copyright (c) 2019-2020 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author David Sehnal <david.sehnal@gmail.com>
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */












var StructureFocusRepresentationParams = function (plugin) {
    var reprParams = _mol_plugin_state_transforms__WEBPACK_IMPORTED_MODULE_5__["StateTransforms"].Representation.StructureRepresentation3D.definition.params(void 0, plugin);
    return {
        expandRadius: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_10__["ParamDefinition"].Numeric(5, { min: 1, max: 10, step: 1 }),
        targetParams: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_10__["ParamDefinition"].Group(reprParams, {
            label: 'Target',
            customDefault: Object(_mol_plugin_state_helpers_structure_representation_params__WEBPACK_IMPORTED_MODULE_4__["createStructureRepresentationParams"])(plugin, void 0, { type: 'ball-and-stick', size: 'physical', typeParams: { sizeFactor: 0.26, alpha: 0.51 } })
        }),
        surroundingsParams: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_10__["ParamDefinition"].Group(reprParams, {
            label: 'Surroundings',
            customDefault: Object(_mol_plugin_state_helpers_structure_representation_params__WEBPACK_IMPORTED_MODULE_4__["createStructureRepresentationParams"])(plugin, void 0, { type: 'ball-and-stick', size: 'physical', typeParams: { sizeFactor: 0.16 } })
        }),
        nciParams: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_10__["ParamDefinition"].Group(reprParams, {
            label: 'Non-covalent Int.',
            customDefault: Object(_mol_plugin_state_helpers_structure_representation_params__WEBPACK_IMPORTED_MODULE_4__["createStructureRepresentationParams"])(plugin, void 0, {
                type: _mol_model_props_computed_representations_interactions__WEBPACK_IMPORTED_MODULE_1__["InteractionsRepresentationProvider"],
                color: _mol_model_props_computed_themes_interaction_type__WEBPACK_IMPORTED_MODULE_2__["InteractionTypeColorThemeProvider"],
                size: _mol_theme_size__WEBPACK_IMPORTED_MODULE_9__["SizeTheme"].BuiltIn.uniform
            })
        }),
        components: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_10__["ParamDefinition"].MultiSelect(FocusComponents, _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_10__["ParamDefinition"].arrayToOptions(FocusComponents)),
        excludeTargetFromSurroundings: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_10__["ParamDefinition"].Boolean(false, { label: 'Exclude Target', description: 'Exclude the focus "target" from the surroudings component.' }),
        ignoreHydrogens: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_10__["ParamDefinition"].Boolean(false)
    };
};
var FocusComponents = ['target', 'surroundings', 'interactions'];
var StructureFocusRepresentationTags;
(function (StructureFocusRepresentationTags) {
    StructureFocusRepresentationTags["TargetSel"] = "structure-focus-target-sel";
    StructureFocusRepresentationTags["TargetRepr"] = "structure-focus-target-repr";
    StructureFocusRepresentationTags["SurrSel"] = "structure-focus-surr-sel";
    StructureFocusRepresentationTags["SurrRepr"] = "structure-focus-surr-repr";
    StructureFocusRepresentationTags["SurrNciRepr"] = "structure-focus-surr-nci-repr";
})(StructureFocusRepresentationTags || (StructureFocusRepresentationTags = {}));
var TagSet = new Set([StructureFocusRepresentationTags.TargetSel, StructureFocusRepresentationTags.TargetRepr, StructureFocusRepresentationTags.SurrSel, StructureFocusRepresentationTags.SurrRepr, StructureFocusRepresentationTags.SurrNciRepr]);
var StructureFocusRepresentationBehavior = /** @class */ (function (_super) {
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__extends"])(StructureFocusRepresentationBehavior, _super);
    function StructureFocusRepresentationBehavior() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.currentSource = void 0;
        return _this;
    }
    Object.defineProperty(StructureFocusRepresentationBehavior.prototype, "surrLabel", {
        get: function () { return "[Focus] Surroundings (" + this.params.expandRadius + " \u00C5)"; },
        enumerable: false,
        configurable: true
    });
    StructureFocusRepresentationBehavior.prototype.getReprParams = function (reprParams) {
        return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, this.params.targetParams), { type: {
                name: reprParams.type.name,
                params: Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, reprParams.type.params), { ignoreHydrogens: this.params.ignoreHydrogens })
            } });
    };
    StructureFocusRepresentationBehavior.prototype.ensureShape = function (cell) {
        var state = this.plugin.state.data, tree = state.tree;
        var builder = state.build();
        var refs = _mol_state__WEBPACK_IMPORTED_MODULE_8__["StateSelection"].findUniqueTagsInSubtree(tree, cell.transform.ref, TagSet);
        // Selections
        if (!refs[StructureFocusRepresentationTags.TargetSel]) {
            refs[StructureFocusRepresentationTags.TargetSel] = builder
                .to(cell)
                .apply(_mol_plugin_state_transforms__WEBPACK_IMPORTED_MODULE_5__["StateTransforms"].Model.StructureSelectionFromBundle, { bundle: _mol_model_structure__WEBPACK_IMPORTED_MODULE_3__["StructureElement"].Bundle.Empty, label: '[Focus] Target' }, { tags: StructureFocusRepresentationTags.TargetSel }).ref;
        }
        if (!refs[StructureFocusRepresentationTags.SurrSel]) {
            refs[StructureFocusRepresentationTags.SurrSel] = builder
                .to(cell)
                .apply(_mol_plugin_state_transforms__WEBPACK_IMPORTED_MODULE_5__["StateTransforms"].Model.StructureSelectionFromExpression, { expression: _mol_script_language_builder__WEBPACK_IMPORTED_MODULE_7__["MolScriptBuilder"].struct.generator.empty(), label: this.surrLabel }, { tags: StructureFocusRepresentationTags.SurrSel }).ref;
        }
        var components = this.params.components;
        // Representations
        if (components.indexOf('target') >= 0 && !refs[StructureFocusRepresentationTags.TargetRepr]) {
            refs[StructureFocusRepresentationTags.TargetRepr] = builder
                .to(refs[StructureFocusRepresentationTags.TargetSel])
                .apply(_mol_plugin_state_transforms__WEBPACK_IMPORTED_MODULE_5__["StateTransforms"].Representation.StructureRepresentation3D, this.getReprParams(this.params.targetParams), { tags: StructureFocusRepresentationTags.TargetRepr }).ref;
        }
        if (components.indexOf('surroundings') >= 0 && !refs[StructureFocusRepresentationTags.SurrRepr]) {
            refs[StructureFocusRepresentationTags.SurrRepr] = builder
                .to(refs[StructureFocusRepresentationTags.SurrSel])
                .apply(_mol_plugin_state_transforms__WEBPACK_IMPORTED_MODULE_5__["StateTransforms"].Representation.StructureRepresentation3D, this.getReprParams(this.params.surroundingsParams), { tags: StructureFocusRepresentationTags.SurrRepr }).ref;
        }
        if (components.indexOf('interactions') >= 0 && !refs[StructureFocusRepresentationTags.SurrNciRepr]) {
            refs[StructureFocusRepresentationTags.SurrNciRepr] = builder
                .to(refs[StructureFocusRepresentationTags.SurrSel])
                .apply(_mol_plugin_state_transforms__WEBPACK_IMPORTED_MODULE_5__["StateTransforms"].Representation.StructureRepresentation3D, this.params.nciParams, { tags: StructureFocusRepresentationTags.SurrNciRepr }).ref;
        }
        return { state: state, builder: builder, refs: refs };
    };
    StructureFocusRepresentationBehavior.prototype.clear = function (root) {
        var state = this.plugin.state.data;
        this.currentSource = void 0;
        var foci = state.select(_mol_state__WEBPACK_IMPORTED_MODULE_8__["StateSelection"].Generators.byRef(root).subtree().withTag(StructureFocusRepresentationTags.TargetSel));
        var surrs = state.select(_mol_state__WEBPACK_IMPORTED_MODULE_8__["StateSelection"].Generators.byRef(root).subtree().withTag(StructureFocusRepresentationTags.SurrSel));
        if (foci.length === 0 && surrs.length === 0)
            return;
        var update = state.build();
        var bundle = _mol_model_structure__WEBPACK_IMPORTED_MODULE_3__["StructureElement"].Bundle.Empty;
        for (var _i = 0, foci_1 = foci; _i < foci_1.length; _i++) {
            var f = foci_1[_i];
            update.to(f).update(_mol_plugin_state_transforms__WEBPACK_IMPORTED_MODULE_5__["StateTransforms"].Model.StructureSelectionFromBundle, function (old) { return (Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, old), { bundle: bundle })); });
        }
        var expression = _mol_script_language_builder__WEBPACK_IMPORTED_MODULE_7__["MolScriptBuilder"].struct.generator.empty();
        for (var _a = 0, surrs_1 = surrs; _a < surrs_1.length; _a++) {
            var s = surrs_1[_a];
            update.to(s).update(_mol_plugin_state_transforms__WEBPACK_IMPORTED_MODULE_5__["StateTransforms"].Model.StructureSelectionFromExpression, function (old) { return (Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, old), { expression: expression })); });
        }
        return _commands__WEBPACK_IMPORTED_MODULE_11__["PluginCommands"].State.Update(this.plugin, { state: state, tree: update, options: { doNotLogTiming: true, doNotUpdateCurrent: true } });
    };
    StructureFocusRepresentationBehavior.prototype.focus = function (sourceLoci) {
        return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"])(this, void 0, void 0, function () {
            var parent, loci, residueLoci, residueBundle, target, surroundings, _a, state, builder, refs;
            var _this = this;
            return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__generator"])(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        parent = this.plugin.helpers.substructureParent.get(sourceLoci.structure);
                        if (!parent || !parent.obj)
                            return [2 /*return*/];
                        this.currentSource = sourceLoci;
                        loci = _mol_model_structure__WEBPACK_IMPORTED_MODULE_3__["StructureElement"].Loci.remap(sourceLoci, parent.obj.data);
                        residueLoci = _mol_model_structure__WEBPACK_IMPORTED_MODULE_3__["StructureElement"].Loci.extendToWholeResidues(loci);
                        residueBundle = _mol_model_structure__WEBPACK_IMPORTED_MODULE_3__["StructureElement"].Bundle.fromLoci(residueLoci);
                        target = _mol_model_structure__WEBPACK_IMPORTED_MODULE_3__["StructureElement"].Bundle.toExpression(residueBundle);
                        surroundings = _mol_script_language_builder__WEBPACK_IMPORTED_MODULE_7__["MolScriptBuilder"].struct.modifier.includeSurroundings({
                            0: target,
                            radius: this.params.expandRadius,
                            'as-whole-residues': true
                        });
                        if (this.params.excludeTargetFromSurroundings) {
                            surroundings = _mol_script_language_builder__WEBPACK_IMPORTED_MODULE_7__["MolScriptBuilder"].struct.modifier.exceptBy({
                                0: surroundings,
                                by: target
                            });
                        }
                        _a = this.ensureShape(parent), state = _a.state, builder = _a.builder, refs = _a.refs;
                        builder.to(refs[StructureFocusRepresentationTags.TargetSel]).update(_mol_plugin_state_transforms__WEBPACK_IMPORTED_MODULE_5__["StateTransforms"].Model.StructureSelectionFromBundle, function (old) { return (Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, old), { bundle: residueBundle })); });
                        builder.to(refs[StructureFocusRepresentationTags.SurrSel]).update(_mol_plugin_state_transforms__WEBPACK_IMPORTED_MODULE_5__["StateTransforms"].Model.StructureSelectionFromExpression, function (old) { return (Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, old), { expression: surroundings, label: _this.surrLabel })); });
                        return [4 /*yield*/, _commands__WEBPACK_IMPORTED_MODULE_11__["PluginCommands"].State.Update(this.plugin, { state: state, tree: builder, options: { doNotLogTiming: true, doNotUpdateCurrent: true } })];
                    case 1:
                        _b.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    StructureFocusRepresentationBehavior.prototype.register = function (ref) {
        var _this = this;
        this.subscribeObservable(this.plugin.managers.structure.focus.behaviors.current, function (entry) {
            if (entry)
                _this.focus(entry.loci);
            else
                _this.clear(_mol_state__WEBPACK_IMPORTED_MODULE_8__["StateTransform"].RootRef);
        });
    };
    StructureFocusRepresentationBehavior.prototype.update = function (params) {
        return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"])(this, void 0, void 0, function () {
            var old, state, builder, all, components, hasComponent, _i, _a, repr, _b, _c, repr, _d, _e, repr;
            return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__generator"])(this, function (_f) {
                switch (_f.label) {
                    case 0:
                        old = this.params;
                        this.params = params;
                        if (old.excludeTargetFromSurroundings !== params.excludeTargetFromSurroundings) {
                            if (this.currentSource) {
                                this.focus(this.currentSource);
                            }
                            return [2 /*return*/, true];
                        }
                        state = this.plugin.state.data;
                        builder = state.build();
                        all = _mol_state__WEBPACK_IMPORTED_MODULE_8__["StateSelection"].Generators.root.subtree();
                        components = this.params.components;
                        hasComponent = components.indexOf('target') >= 0;
                        for (_i = 0, _a = state.select(all.withTag(StructureFocusRepresentationTags.TargetRepr)); _i < _a.length; _i++) {
                            repr = _a[_i];
                            if (!hasComponent)
                                builder.delete(repr.transform.ref);
                            else
                                builder.to(repr).update(this.getReprParams(this.params.targetParams));
                        }
                        hasComponent = components.indexOf('surroundings') >= 0;
                        for (_b = 0, _c = state.select(all.withTag(StructureFocusRepresentationTags.SurrRepr)); _b < _c.length; _b++) {
                            repr = _c[_b];
                            if (!hasComponent)
                                builder.delete(repr.transform.ref);
                            else
                                builder.to(repr).update(this.getReprParams(this.params.surroundingsParams));
                        }
                        hasComponent = components.indexOf('interactions') >= 0;
                        for (_d = 0, _e = state.select(all.withTag(StructureFocusRepresentationTags.SurrNciRepr)); _d < _e.length; _d++) {
                            repr = _e[_d];
                            if (!hasComponent)
                                builder.delete(repr.transform.ref);
                            else
                                builder.to(repr).update(this.params.nciParams);
                        }
                        return [4 /*yield*/, _commands__WEBPACK_IMPORTED_MODULE_11__["PluginCommands"].State.Update(this.plugin, { state: state, tree: builder, options: { doNotLogTiming: true, doNotUpdateCurrent: true } })];
                    case 1:
                        _f.sent();
                        if (params.expandRadius !== old.expandRadius) {
                            if (this.currentSource) {
                                this.focus(this.currentSource);
                            }
                            return [2 /*return*/, true];
                        }
                        return [2 /*return*/, true];
                }
            });
        });
    };
    return StructureFocusRepresentationBehavior;
}(_behavior__WEBPACK_IMPORTED_MODULE_6__["PluginBehavior"].WithSubscribers));
var StructureFocusRepresentation = _behavior__WEBPACK_IMPORTED_MODULE_6__["PluginBehavior"].create({
    name: 'create-structure-focus-representation',
    display: { name: 'Structure Focus Representation' },
    category: 'interaction',
    ctor: StructureFocusRepresentationBehavior,
    params: function (_, plugin) { return StructureFocusRepresentationParams(plugin); }
});
//# sourceMappingURL=structure-focus-representation.js.map

/***/ }),

/***/ "./lib/mol-plugin/behavior/dynamic/volume-streaming/behavior.js":
/*!**********************************************************************!*\
  !*** ./lib/mol-plugin/behavior/dynamic/volume-streaming/behavior.js ***!
  \**********************************************************************/
/*! exports provided: VolumeStreaming */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "VolumeStreaming", function() { return VolumeStreaming; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../../../mol-util/param-definition */ "./lib/mol-util/param-definition.js");
/* harmony import */ var _mol_plugin_state_objects__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../../../mol-plugin-state/objects */ "./lib/mol-plugin-state/objects.js");
/* harmony import */ var _mol_model_volume__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../../../mol-model/volume */ "./lib/mol-model/volume.js");
/* harmony import */ var _mol_math_geometry__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../../../mol-math/geometry */ "./lib/mol-math/geometry.js");
/* harmony import */ var _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../../../mol-math/linear-algebra */ "./lib/mol-math/linear-algebra.js");
/* harmony import */ var _mol_util_color__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../../../../mol-util/color */ "./lib/mol-util/color/index.js");
/* harmony import */ var _behavior__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../../behavior */ "./lib/mol-plugin/behavior/behavior.js");
/* harmony import */ var _mol_util_lru_cache__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ../../../../mol-util/lru-cache */ "./lib/mol-util/lru-cache.js");
/* harmony import */ var _mol_util_url__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ../../../../mol-util/url */ "./lib/mol-util/url.js");
/* harmony import */ var _mol_io_reader_cif__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ../../../../mol-io/reader/cif */ "./lib/mol-io/reader/cif.js");
/* harmony import */ var _mol_model_formats_volume_density_server__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ../../../../mol-model-formats/volume/density-server */ "./lib/mol-model-formats/volume/density-server.js");
/* harmony import */ var _commands__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! ../../../commands */ "./lib/mol-plugin/commands.js");
/* harmony import */ var _mol_state__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! ../../../../mol-state */ "./lib/mol-state/index.js");
/* harmony import */ var _mol_model_structure__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! ../../../../mol-model/structure */ "./lib/mol-model/structure.js");
/* harmony import */ var _mol_model_loci__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! ../../../../mol-model/loci */ "./lib/mol-model/loci.js");
/* harmony import */ var _mol_util_assets__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(/*! ../../../../mol-util/assets */ "./lib/mol-util/assets.js");
/* harmony import */ var _mol_model_structure_model_properties_global_transform__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(/*! ../../../../mol-model/structure/model/properties/global-transform */ "./lib/mol-model/structure/model/properties/global-transform.js");
/**
 * Copyright (c) 2019-2020 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author David Sehnal <david.sehnal@gmail.com>
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */


















var VolumeStreaming = /** @class */ (function (_super) {
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__extends"])(VolumeStreaming, _super);
    function VolumeStreaming() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return VolumeStreaming;
}(_mol_plugin_state_objects__WEBPACK_IMPORTED_MODULE_2__["PluginStateObject"].CreateBehavior({ name: 'Volume Streaming' })));

(function (VolumeStreaming) {
    VolumeStreaming.RootTag = 'volume-streaming-info';
    function channelParam(label, color, defaultValue, stats, defaults) {
        var _a, _b, _c, _d;
        if (defaults === void 0) { defaults = {}; }
        return _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_1__["ParamDefinition"].Group({
            isoValue: _mol_model_volume__WEBPACK_IMPORTED_MODULE_3__["Volume"].createIsoValueParam((_a = defaults.isoValue) !== null && _a !== void 0 ? _a : defaultValue, stats),
            color: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_1__["ParamDefinition"].Color((_b = defaults.color) !== null && _b !== void 0 ? _b : color),
            wireframe: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_1__["ParamDefinition"].Boolean((_c = defaults.wireframe) !== null && _c !== void 0 ? _c : false),
            opacity: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_1__["ParamDefinition"].Numeric((_d = defaults.opacity) !== null && _d !== void 0 ? _d : 0.3, { min: 0, max: 1, step: 0.01 })
        }, { label: label, isExpanded: true });
    }
    var fakeSampling = {
        byteOffset: 0,
        rate: 1,
        sampleCount: [1, 1, 1],
        valuesInfo: [{ mean: 0, min: -1, max: 1, sigma: 0.1 }, { mean: 0, min: -1, max: 1, sigma: 0.1 }]
    };
    function createParams(options) {
        if (options === void 0) { options = {}; }
        var data = options.data, defaultView = options.defaultView, channelParams = options.channelParams;
        var map = new Map();
        if (data)
            data.entries.forEach(function (d) { return map.set(d.dataId, d); });
        var names = data ? data.entries.map(function (d) { return [d.dataId, d.dataId]; }) : [];
        var defaultKey = data ? data.entries[0].dataId : '';
        return {
            entry: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_1__["ParamDefinition"].Mapped(defaultKey, names, function (name) { return _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_1__["ParamDefinition"].Group(createEntryParams({ entryData: map.get(name), defaultView: defaultView, structure: data && data.structure, channelParams: channelParams })); }),
        };
    }
    VolumeStreaming.createParams = createParams;
    function createEntryParams(options) {
        var entryData = options.entryData, defaultView = options.defaultView, structure = options.structure, _a = options.channelParams, channelParams = _a === void 0 ? {} : _a;
        // fake the info
        var info = entryData || { kind: 'em', header: { sampling: [fakeSampling], availablePrecisions: [{ precision: 0, maxVoxels: 0 }] }, emDefaultContourLevel: _mol_model_volume__WEBPACK_IMPORTED_MODULE_3__["Volume"].IsoValue.relative(0) };
        var box = (structure && structure.boundary.box) || Object(_mol_math_geometry__WEBPACK_IMPORTED_MODULE_4__["Box3D"])();
        return {
            view: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_1__["ParamDefinition"].MappedStatic(defaultView || (info.kind === 'em' ? 'cell' : 'selection-box'), {
                'off': _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_1__["ParamDefinition"].Group({}),
                'box': _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_1__["ParamDefinition"].Group({
                    bottomLeft: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_1__["ParamDefinition"].Vec3(box.min),
                    topRight: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_1__["ParamDefinition"].Vec3(box.max),
                }, { description: 'Static box defined by cartesian coords.', isFlat: true }),
                'selection-box': _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_1__["ParamDefinition"].Group({
                    radius: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_1__["ParamDefinition"].Numeric(5, { min: 0, max: 50, step: 0.5 }, { description: 'Radius in \u212B within which the volume is shown.' }),
                    bottomLeft: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_1__["ParamDefinition"].Vec3(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_5__["Vec3"].create(0, 0, 0), {}, { isHidden: true }),
                    topRight: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_1__["ParamDefinition"].Vec3(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_5__["Vec3"].create(0, 0, 0), {}, { isHidden: true }),
                }, { description: 'Box around focused element.', isFlat: true }),
                'cell': _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_1__["ParamDefinition"].Group({}),
                // Show selection-box if available and cell otherwise.
                'auto': _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_1__["ParamDefinition"].Group({
                    radius: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_1__["ParamDefinition"].Numeric(5, { min: 0, max: 50, step: 0.5 }, { description: 'Radius in \u212B within which the volume is shown.' }),
                    selectionDetailLevel: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_1__["ParamDefinition"].Select(Math.min(6, info.header.availablePrecisions.length - 1), info.header.availablePrecisions.map(function (p, i) { return [i, i + 1 + " [ " + (Math.pow(p.maxVoxels, 1 / 3) | 0) + "^3 cells ]"]; }), { label: 'Selection Detail', description: 'Determines the maximum number of voxels. Depending on the size of the volume options are in the range from 0 (0.52M voxels) to 6 (25.17M voxels).' }),
                    isSelection: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_1__["ParamDefinition"].Boolean(false, { isHidden: true }),
                    bottomLeft: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_1__["ParamDefinition"].Vec3(box.min, {}, { isHidden: true }),
                    topRight: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_1__["ParamDefinition"].Vec3(box.max, {}, { isHidden: true }),
                }, { description: 'Box around focused element.', isFlat: true })
            }, { options: VolumeStreaming.ViewTypeOptions, description: 'Controls what of the volume is displayed. "Off" hides the volume alltogether. "Bounded box" shows the volume inside the given box. "Around Interaction" shows the volume around the focused element/atom. "Whole Structure" shows the volume for the whole structure.' }),
            detailLevel: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_1__["ParamDefinition"].Select(Math.min(3, info.header.availablePrecisions.length - 1), info.header.availablePrecisions.map(function (p, i) { return [i, i + 1 + " [ " + (Math.pow(p.maxVoxels, 1 / 3) | 0) + "^3 cells ]"]; }), { description: 'Determines the maximum number of voxels. Depending on the size of the volume options are in the range from 0 (0.52M voxels) to 6 (25.17M voxels).' }),
            channels: info.kind === 'em'
                ? _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_1__["ParamDefinition"].Group({
                    'em': channelParam('EM', Object(_mol_util_color__WEBPACK_IMPORTED_MODULE_6__["Color"])(0x638F8F), info.emDefaultContourLevel || _mol_model_volume__WEBPACK_IMPORTED_MODULE_3__["Volume"].IsoValue.relative(1), info.header.sampling[0].valuesInfo[0], channelParams['em'])
                }, { isFlat: true })
                : _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_1__["ParamDefinition"].Group({
                    '2fo-fc': channelParam('2Fo-Fc', Object(_mol_util_color__WEBPACK_IMPORTED_MODULE_6__["Color"])(0x3362B2), _mol_model_volume__WEBPACK_IMPORTED_MODULE_3__["Volume"].IsoValue.relative(1.5), info.header.sampling[0].valuesInfo[0], channelParams['2fo-fc']),
                    'fo-fc(+ve)': channelParam('Fo-Fc(+ve)', Object(_mol_util_color__WEBPACK_IMPORTED_MODULE_6__["Color"])(0x33BB33), _mol_model_volume__WEBPACK_IMPORTED_MODULE_3__["Volume"].IsoValue.relative(3), info.header.sampling[0].valuesInfo[1], channelParams['fo-fc(+ve)']),
                    'fo-fc(-ve)': channelParam('Fo-Fc(-ve)', Object(_mol_util_color__WEBPACK_IMPORTED_MODULE_6__["Color"])(0xBB3333), _mol_model_volume__WEBPACK_IMPORTED_MODULE_3__["Volume"].IsoValue.relative(-3), info.header.sampling[0].valuesInfo[1], channelParams['fo-fc(-ve)']),
                }, { isFlat: true }),
        };
    }
    VolumeStreaming.createEntryParams = createEntryParams;
    VolumeStreaming.ViewTypeOptions = [['off', 'Off'], ['box', 'Bounded Box'], ['selection-box', 'Around Focus'], ['cell', 'Whole Structure'], ['auto', 'Auto']];
    VolumeStreaming.ChannelTypeOptions = [['em', 'em'], ['2fo-fc', '2fo-fc'], ['fo-fc(+ve)', 'fo-fc(+ve)'], ['fo-fc(-ve)', 'fo-fc(-ve)']];
    var Behavior = /** @class */ (function (_super) {
        Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__extends"])(Behavior, _super);
        function Behavior(plugin, data) {
            var _this = _super.call(this, plugin, {}) || this;
            _this.plugin = plugin;
            _this.data = data;
            _this.cache = _mol_util_lru_cache__WEBPACK_IMPORTED_MODULE_8__["LRUCache"].create(25);
            _this.params = {};
            _this.lastLoci = _mol_model_loci__WEBPACK_IMPORTED_MODULE_15__["EmptyLoci"];
            _this.ref = '';
            _this.channels = {};
            _this._invTransform = Object(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_5__["Mat4"])();
            _this.infoMap = new Map();
            _this.data.entries.forEach(function (info) { return _this.infoMap.set(info.dataId, info); });
            return _this;
        }
        Object.defineProperty(Behavior.prototype, "info", {
            get: function () {
                return this.infoMap.get(this.params.entry.name);
            },
            enumerable: false,
            configurable: true
        });
        Behavior.prototype.queryData = function (box) {
            return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"])(this, void 0, void 0, function () {
                var url, a, b, detail, entry, urlAsset, asset, data, removed;
                return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__generator"])(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            url = Object(_mol_util_url__WEBPACK_IMPORTED_MODULE_9__["urlCombine"])(this.data.serverUrl, this.info.kind + "/" + this.info.dataId.toLowerCase());
                            if (box) {
                                a = box.min, b = box.max;
                                url += "/box"
                                    + ("/" + a.map(function (v) { return Math.round(1000 * v) / 1000; }).join(','))
                                    + ("/" + b.map(function (v) { return Math.round(1000 * v) / 1000; }).join(','));
                            }
                            else {
                                url += "/cell";
                            }
                            detail = this.params.entry.params.detailLevel;
                            if (this.params.entry.params.view.name === 'auto' && this.params.entry.params.view.params.isSelection) {
                                detail = this.params.entry.params.view.params.selectionDetailLevel;
                            }
                            url += "?detail=" + detail;
                            entry = _mol_util_lru_cache__WEBPACK_IMPORTED_MODULE_8__["LRUCache"].get(this.cache, url);
                            if (entry)
                                return [2 /*return*/, entry.data];
                            urlAsset = _mol_util_assets__WEBPACK_IMPORTED_MODULE_16__["Asset"].getUrlAsset(this.plugin.managers.asset, url);
                            return [4 /*yield*/, this.plugin.runTask(this.plugin.managers.asset.resolve(urlAsset, 'binary'))];
                        case 1:
                            asset = _a.sent();
                            return [4 /*yield*/, this.parseCif(asset.data)];
                        case 2:
                            data = _a.sent();
                            if (!data)
                                return [2 /*return*/];
                            removed = _mol_util_lru_cache__WEBPACK_IMPORTED_MODULE_8__["LRUCache"].set(this.cache, url, { data: data, asset: asset });
                            if (removed)
                                removed.asset.dispose();
                            return [2 /*return*/, data];
                    }
                });
            });
        };
        Behavior.prototype.parseCif = function (data) {
            return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"])(this, void 0, void 0, function () {
                var parsed, ret, i, block, densityServerCif, volume;
                return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__generator"])(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, this.plugin.runTask(_mol_io_reader_cif__WEBPACK_IMPORTED_MODULE_10__["CIF"].parseBinary(data))];
                        case 1:
                            parsed = _a.sent();
                            if (parsed.isError) {
                                this.plugin.log.error('VolumeStreaming, parsing CIF: ' + parsed.toString());
                                return [2 /*return*/];
                            }
                            if (parsed.result.blocks.length < 2) {
                                this.plugin.log.error('VolumeStreaming: Invalid data.');
                                return [2 /*return*/];
                            }
                            ret = {};
                            i = 1;
                            _a.label = 2;
                        case 2:
                            if (!(i < parsed.result.blocks.length)) return [3 /*break*/, 5];
                            block = parsed.result.blocks[i];
                            densityServerCif = _mol_io_reader_cif__WEBPACK_IMPORTED_MODULE_10__["CIF"].schema.densityServer(block);
                            return [4 /*yield*/, this.plugin.runTask(Object(_mol_model_formats_volume_density_server__WEBPACK_IMPORTED_MODULE_11__["volumeFromDensityServerData"])(densityServerCif))];
                        case 3:
                            volume = _a.sent();
                            ret[block.header] = volume;
                            _a.label = 4;
                        case 4:
                            i++;
                            return [3 /*break*/, 2];
                        case 5: return [2 /*return*/, ret];
                    }
                });
            });
        };
        Behavior.prototype.updateSelectionBoxParams = function (box) {
            if (this.params.entry.params.view.name !== 'selection-box')
                return;
            var state = this.plugin.state.data;
            var newParams = Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, this.params), { entry: {
                    name: this.params.entry.name,
                    params: Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, this.params.entry.params), { view: {
                            name: 'selection-box',
                            params: {
                                radius: this.params.entry.params.view.params.radius,
                                bottomLeft: box.min,
                                topRight: box.max
                            }
                        } })
                } });
            var update = state.build().to(this.ref).update(newParams);
            _commands__WEBPACK_IMPORTED_MODULE_12__["PluginCommands"].State.Update(this.plugin, { state: state, tree: update, options: { doNotUpdateCurrent: true } });
        };
        Behavior.prototype.updateAutoParams = function (box, isSelection) {
            if (this.params.entry.params.view.name !== 'auto')
                return;
            var state = this.plugin.state.data;
            var newParams = Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, this.params), { entry: {
                    name: this.params.entry.name,
                    params: Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, this.params.entry.params), { view: {
                            name: 'auto',
                            params: {
                                radius: this.params.entry.params.view.params.radius,
                                selectionDetailLevel: this.params.entry.params.view.params.selectionDetailLevel,
                                isSelection: isSelection,
                                bottomLeft: (box === null || box === void 0 ? void 0 : box.min) || _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_5__["Vec3"].zero(),
                                topRight: (box === null || box === void 0 ? void 0 : box.max) || _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_5__["Vec3"].zero()
                            }
                        } })
                } });
            var update = state.build().to(this.ref).update(newParams);
            _commands__WEBPACK_IMPORTED_MODULE_12__["PluginCommands"].State.Update(this.plugin, { state: state, tree: update, options: { doNotUpdateCurrent: true } });
        };
        Behavior.prototype.getStructureRoot = function () {
            return this.plugin.state.data.select(_mol_state__WEBPACK_IMPORTED_MODULE_13__["StateSelection"].Generators.byRef(this.ref).rootOfType(_mol_plugin_state_objects__WEBPACK_IMPORTED_MODULE_2__["PluginStateObject"].Molecule.Structure))[0];
        };
        Behavior.prototype.register = function (ref) {
            var _this = this;
            this.ref = ref;
            this.subscribeObservable(this.plugin.state.events.object.removed, function (o) {
                if (!_mol_plugin_state_objects__WEBPACK_IMPORTED_MODULE_2__["PluginStateObject"].Molecule.Structure.is(o.obj) || !_mol_model_structure__WEBPACK_IMPORTED_MODULE_14__["StructureElement"].Loci.is(_this.lastLoci))
                    return;
                if (_this.lastLoci.structure === o.obj.data) {
                    _this.lastLoci = _mol_model_loci__WEBPACK_IMPORTED_MODULE_15__["EmptyLoci"];
                }
            });
            this.subscribeObservable(this.plugin.state.events.object.updated, function (o) {
                if (!_mol_plugin_state_objects__WEBPACK_IMPORTED_MODULE_2__["PluginStateObject"].Molecule.Structure.is(o.oldObj) || !_mol_model_structure__WEBPACK_IMPORTED_MODULE_14__["StructureElement"].Loci.is(_this.lastLoci))
                    return;
                if (_this.lastLoci.structure === o.oldObj.data) {
                    _this.lastLoci = _mol_model_loci__WEBPACK_IMPORTED_MODULE_15__["EmptyLoci"];
                }
            });
            this.subscribeObservable(this.plugin.managers.structure.focus.behaviors.current, function (entry) {
                if (!_this.plugin.state.data.tree.children.has(_this.ref))
                    return;
                var loci = entry ? entry.loci : _mol_model_loci__WEBPACK_IMPORTED_MODULE_15__["EmptyLoci"];
                switch (_this.params.entry.params.view.name) {
                    case 'auto':
                        _this.updateAuto(loci);
                        break;
                    case 'selection-box':
                        _this.updateSelectionBox(loci);
                        break;
                    default:
                        _this.lastLoci = loci;
                        break;
                }
            });
        };
        Behavior.prototype.unregister = function () {
            var entry = this.cache.entries.first;
            while (entry) {
                entry.value.data.asset.dispose();
                entry = entry.next;
            }
        };
        Behavior.prototype.getBoxFromLoci = function (loci) {
            var _a, _b, _c;
            if (_mol_model_loci__WEBPACK_IMPORTED_MODULE_15__["Loci"].isEmpty(loci)) {
                return Object(_mol_math_geometry__WEBPACK_IMPORTED_MODULE_4__["Box3D"])();
            }
            var parent = this.plugin.helpers.substructureParent.get(loci.structure, true);
            if (!parent)
                return Object(_mol_math_geometry__WEBPACK_IMPORTED_MODULE_4__["Box3D"])();
            var root = this.getStructureRoot();
            if (!root || ((_a = root.obj) === null || _a === void 0 ? void 0 : _a.data) !== ((_b = parent.obj) === null || _b === void 0 ? void 0 : _b.data))
                return Object(_mol_math_geometry__WEBPACK_IMPORTED_MODULE_4__["Box3D"])();
            var transform = _mol_model_structure_model_properties_global_transform__WEBPACK_IMPORTED_MODULE_17__["GlobalModelTransformInfo"].get((_c = root.obj) === null || _c === void 0 ? void 0 : _c.data.models[0]);
            if (transform)
                _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_5__["Mat4"].invert(this._invTransform, transform);
            var extendedLoci = _mol_model_structure__WEBPACK_IMPORTED_MODULE_14__["StructureElement"].Loci.extendToWholeResidues(loci);
            var box = _mol_model_structure__WEBPACK_IMPORTED_MODULE_14__["StructureElement"].Loci.getBoundary(extendedLoci, transform && !Number.isNaN(this._invTransform[0]) ? this._invTransform : void 0).box;
            if (_mol_model_structure__WEBPACK_IMPORTED_MODULE_14__["StructureElement"].Loci.size(extendedLoci) === 1) {
                _mol_math_geometry__WEBPACK_IMPORTED_MODULE_4__["Box3D"].expand(box, box, _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_5__["Vec3"].create(1, 1, 1));
            }
            return box;
        };
        Behavior.prototype.updateAuto = function (loci) {
            // if (Loci.areEqual(this.lastLoci, loci)) {
            //     this.lastLoci = EmptyLoci;
            //     this.updateSelectionBoxParams(Box3D.empty());
            //     return;
            // }
            this.lastLoci = loci;
            if (Object(_mol_model_loci__WEBPACK_IMPORTED_MODULE_15__["isEmptyLoci"])(loci)) {
                this.updateAutoParams(this.info.kind === 'x-ray' ? this.data.structure.boundary.box : void 0, false);
                return;
            }
            var box = this.getBoxFromLoci(loci);
            this.updateAutoParams(box, true);
        };
        Behavior.prototype.updateSelectionBox = function (loci) {
            if (_mol_model_loci__WEBPACK_IMPORTED_MODULE_15__["Loci"].areEqual(this.lastLoci, loci)) {
                this.lastLoci = _mol_model_loci__WEBPACK_IMPORTED_MODULE_15__["EmptyLoci"];
                this.updateSelectionBoxParams(Object(_mol_math_geometry__WEBPACK_IMPORTED_MODULE_4__["Box3D"])());
                return;
            }
            this.lastLoci = loci;
            if (Object(_mol_model_loci__WEBPACK_IMPORTED_MODULE_15__["isEmptyLoci"])(loci)) {
                this.updateSelectionBoxParams(Object(_mol_math_geometry__WEBPACK_IMPORTED_MODULE_4__["Box3D"])());
                return;
            }
            var box = this.getBoxFromLoci(loci);
            this.updateSelectionBoxParams(box);
        };
        Behavior.prototype.update = function (params) {
            return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"])(this, void 0, void 0, function () {
                var switchedToSelection, box, emptyData, r, r, data, _a, info;
                return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__generator"])(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            switchedToSelection = params.entry.params.view.name === 'selection-box' && this.params && this.params.entry && this.params.entry.params && this.params.entry.params.view && this.params.entry.params.view.name !== 'selection-box';
                            this.params = params;
                            box = void 0, emptyData = false;
                            switch (params.entry.params.view.name) {
                                case 'off':
                                    emptyData = true;
                                    break;
                                case 'box':
                                    box = _mol_math_geometry__WEBPACK_IMPORTED_MODULE_4__["Box3D"].create(params.entry.params.view.params.bottomLeft, params.entry.params.view.params.topRight);
                                    emptyData = _mol_math_geometry__WEBPACK_IMPORTED_MODULE_4__["Box3D"].volume(box) < 0.0001;
                                    break;
                                case 'selection-box': {
                                    if (switchedToSelection) {
                                        box = this.getBoxFromLoci(this.lastLoci) || Object(_mol_math_geometry__WEBPACK_IMPORTED_MODULE_4__["Box3D"])();
                                    }
                                    else {
                                        box = _mol_math_geometry__WEBPACK_IMPORTED_MODULE_4__["Box3D"].create(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_5__["Vec3"].clone(params.entry.params.view.params.bottomLeft), _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_5__["Vec3"].clone(params.entry.params.view.params.topRight));
                                    }
                                    r = params.entry.params.view.params.radius;
                                    emptyData = _mol_math_geometry__WEBPACK_IMPORTED_MODULE_4__["Box3D"].volume(box) < 0.0001;
                                    _mol_math_geometry__WEBPACK_IMPORTED_MODULE_4__["Box3D"].expand(box, box, _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_5__["Vec3"].create(r, r, r));
                                    break;
                                }
                                case 'cell':
                                    box = this.info.kind === 'x-ray'
                                        ? this.data.structure.boundary.box
                                        : void 0;
                                    break;
                                case 'auto':
                                    box = params.entry.params.view.params.isSelection || this.info.kind === 'x-ray'
                                        ? _mol_math_geometry__WEBPACK_IMPORTED_MODULE_4__["Box3D"].create(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_5__["Vec3"].clone(params.entry.params.view.params.bottomLeft), _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_5__["Vec3"].clone(params.entry.params.view.params.topRight))
                                        : void 0;
                                    if (box) {
                                        emptyData = _mol_math_geometry__WEBPACK_IMPORTED_MODULE_4__["Box3D"].volume(box) < 0.0001;
                                        if (params.entry.params.view.params.isSelection) {
                                            r = params.entry.params.view.params.radius;
                                            _mol_math_geometry__WEBPACK_IMPORTED_MODULE_4__["Box3D"].expand(box, box, _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_5__["Vec3"].create(r, r, r));
                                        }
                                    }
                                    break;
                            }
                            if (!emptyData) return [3 /*break*/, 1];
                            _a = {};
                            return [3 /*break*/, 3];
                        case 1: return [4 /*yield*/, this.queryData(box)];
                        case 2:
                            _a = _b.sent();
                            _b.label = 3;
                        case 3:
                            data = _a;
                            if (!data)
                                return [2 /*return*/, false];
                            info = params.entry.params.channels;
                            if (this.info.kind === 'x-ray') {
                                this.channels['2fo-fc'] = this.createChannel(data['2FO-FC'] || _mol_model_volume__WEBPACK_IMPORTED_MODULE_3__["Volume"].One, info['2fo-fc'], this.info.header.sampling[0].valuesInfo[0]);
                                this.channels['fo-fc(+ve)'] = this.createChannel(data['FO-FC'] || _mol_model_volume__WEBPACK_IMPORTED_MODULE_3__["Volume"].One, info['fo-fc(+ve)'], this.info.header.sampling[0].valuesInfo[1]);
                                this.channels['fo-fc(-ve)'] = this.createChannel(data['FO-FC'] || _mol_model_volume__WEBPACK_IMPORTED_MODULE_3__["Volume"].One, info['fo-fc(-ve)'], this.info.header.sampling[0].valuesInfo[1]);
                            }
                            else {
                                this.channels['em'] = this.createChannel(data['EM'] || _mol_model_volume__WEBPACK_IMPORTED_MODULE_3__["Volume"].One, info['em'], this.info.header.sampling[0].valuesInfo[0]);
                            }
                            return [2 /*return*/, true];
                    }
                });
            });
        };
        Behavior.prototype.createChannel = function (data, info, stats) {
            var i = info;
            return {
                data: data,
                color: i.color,
                wireframe: i.wireframe,
                opacity: i.opacity,
                isoValue: i.isoValue.kind === 'relative' ? i.isoValue : _mol_model_volume__WEBPACK_IMPORTED_MODULE_3__["Volume"].IsoValue.toRelative(i.isoValue, stats)
            };
        };
        Behavior.prototype.getDescription = function () {
            if (this.params.entry.params.view.name === 'selection-box')
                return 'Selection';
            if (this.params.entry.params.view.name === 'box')
                return 'Static Box';
            if (this.params.entry.params.view.name === 'cell')
                return 'Cell';
            return '';
        };
        return Behavior;
    }(_behavior__WEBPACK_IMPORTED_MODULE_7__["PluginBehavior"].WithSubscribers));
    VolumeStreaming.Behavior = Behavior;
})(VolumeStreaming || (VolumeStreaming = {}));
//# sourceMappingURL=behavior.js.map

/***/ }),

/***/ "./lib/mol-plugin/behavior/dynamic/volume-streaming/model.js":
/*!*******************************************************************!*\
  !*** ./lib/mol-plugin/behavior/dynamic/volume-streaming/model.js ***!
  \*******************************************************************/
/*! exports provided: VolumeServerInfo, VolumeServerHeader */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "VolumeServerInfo", function() { return VolumeServerInfo; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "VolumeServerHeader", function() { return VolumeServerHeader; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _mol_plugin_state_objects__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../../../mol-plugin-state/objects */ "./lib/mol-plugin-state/objects.js");
/**
 * Copyright (c) 2019-2020 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author David Sehnal <david.sehnal@gmail.com>
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */


var VolumeServerInfo = /** @class */ (function (_super) {
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__extends"])(VolumeServerInfo, _super);
    function VolumeServerInfo() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return VolumeServerInfo;
}(_mol_plugin_state_objects__WEBPACK_IMPORTED_MODULE_1__["PluginStateObject"].Create({ name: 'Volume Streaming', typeClass: 'Object' })));

var VolumeServerHeader;
(function (VolumeServerHeader) {
    var ValueType;
    (function (ValueType) {
        ValueType.Float32 = 'float32';
        ValueType.Int8 = 'int8';
    })(ValueType = VolumeServerHeader.ValueType || (VolumeServerHeader.ValueType = {}));
})(VolumeServerHeader || (VolumeServerHeader = {}));
//# sourceMappingURL=model.js.map

/***/ }),

/***/ "./lib/mol-plugin/behavior/dynamic/volume-streaming/transformers.js":
/*!**************************************************************************!*\
  !*** ./lib/mol-plugin/behavior/dynamic/volume-streaming/transformers.js ***!
  \**************************************************************************/
/*! exports provided: InitVolumeStreaming, BoxifyVolumeStreaming, CreateVolumeStreamingInfo, CreateVolumeStreamingBehavior, VolumeStreamingVisual */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "InitVolumeStreaming", function() { return InitVolumeStreaming; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "BoxifyVolumeStreaming", function() { return BoxifyVolumeStreaming; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CreateVolumeStreamingInfo", function() { return CreateVolumeStreamingInfo; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CreateVolumeStreamingBehavior", function() { return CreateVolumeStreamingBehavior; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "VolumeStreamingVisual", function() { return VolumeStreamingVisual; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _mol_plugin_state_objects__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../../../mol-plugin-state/objects */ "./lib/mol-plugin-state/objects.js");
/* harmony import */ var _model__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./model */ "./lib/mol-plugin/behavior/dynamic/volume-streaming/model.js");
/* harmony import */ var _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../../../mol-util/param-definition */ "./lib/mol-util/param-definition.js");
/* harmony import */ var _mol_task__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../../../mol-task */ "./lib/mol-task/index.js");
/* harmony import */ var _mol_util_url__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../../../mol-util/url */ "./lib/mol-util/url.js");
/* harmony import */ var _mol_model_volume__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../../../../mol-model/volume */ "./lib/mol-model/volume.js");
/* harmony import */ var _mol_state__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../../../../mol-state */ "./lib/mol-state/index.js");
/* harmony import */ var _util__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ./util */ "./lib/mol-plugin/behavior/dynamic/volume-streaming/util.js");
/* harmony import */ var _behavior__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ./behavior */ "./lib/mol-plugin/behavior/dynamic/volume-streaming/behavior.js");
/* harmony import */ var _mol_plugin_state_transforms_representation__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ../../../../mol-plugin-state/transforms/representation */ "./lib/mol-plugin-state/transforms/representation.js");
/* harmony import */ var _mol_repr_volume_registry__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ../../../../mol-repr/volume/registry */ "./lib/mol-repr/volume/registry.js");
/* harmony import */ var _mol_theme_theme__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! ../../../../mol-theme/theme */ "./lib/mol-theme/theme.js");
/* harmony import */ var _mol_math_geometry__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! ../../../../mol-math/geometry */ "./lib/mol-math/geometry.js");
/* harmony import */ var _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! ../../../../mol-math/linear-algebra */ "./lib/mol-math/linear-algebra.js");
/* harmony import */ var _config__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! ../../../config */ "./lib/mol-plugin/config.js");
/* harmony import */ var _mol_model_structure__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(/*! ../../../../mol-model/structure */ "./lib/mol-model/structure.js");
/* harmony import */ var _mol_model_structure_model_properties_global_transform__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(/*! ../../../../mol-model/structure/model/properties/global-transform */ "./lib/mol-model/structure/model/properties/global-transform.js");
/**
 * Copyright (c) 2019-2020 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author David Sehnal <david.sehnal@gmail.com>
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */


















function addEntry(entries, method, dataId, emDefaultContourLevel) {
    entries.push({
        source: method === 'em'
            ? { name: 'em', params: { isoValue: _mol_model_volume__WEBPACK_IMPORTED_MODULE_6__["Volume"].IsoValue.absolute(emDefaultContourLevel || 0) } }
            : { name: 'x-ray', params: {} },
        dataId: dataId
    });
}
var InitVolumeStreaming = _mol_state__WEBPACK_IMPORTED_MODULE_7__["StateAction"].build({
    display: { name: 'Volume Streaming' },
    from: _mol_plugin_state_objects__WEBPACK_IMPORTED_MODULE_1__["PluginStateObject"].Molecule.Structure,
    params: function (a, plugin) {
        var method = Object(_util__WEBPACK_IMPORTED_MODULE_8__["getStreamingMethod"])(a && a.data);
        var ids = Object(_util__WEBPACK_IMPORTED_MODULE_8__["getIds"])(method, a && a.data);
        return {
            method: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_3__["ParamDefinition"].Select(method, [['em', 'EM'], ['x-ray', 'X-Ray']]),
            entries: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_3__["ParamDefinition"].ObjectList({ id: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_3__["ParamDefinition"].Text(ids[0] || '') }, function (_a) {
                var id = _a.id;
                return id;
            }, { defaultValue: ids.map(function (id) { return ({ id: id }); }) }),
            defaultView: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_3__["ParamDefinition"].Select(method === 'em' ? 'cell' : 'selection-box', _behavior__WEBPACK_IMPORTED_MODULE_9__["VolumeStreaming"].ViewTypeOptions),
            options: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_3__["ParamDefinition"].Group({
                serverUrl: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_3__["ParamDefinition"].Text(plugin.config.get(_config__WEBPACK_IMPORTED_MODULE_15__["PluginConfig"].VolumeStreaming.DefaultServer) || 'https://ds.litemol.org'),
                behaviorRef: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_3__["ParamDefinition"].Text('', { isHidden: true }),
                emContourProvider: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_3__["ParamDefinition"].Select('emdb', [['emdb', 'EMDB'], ['pdbe', 'PDBe']], { isHidden: true }),
                channelParams: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_3__["ParamDefinition"].Value({}, { isHidden: true })
            })
        };
    },
    isApplicable: function (a, _, plugin) {
        var canStreamTest = plugin.config.get(_config__WEBPACK_IMPORTED_MODULE_15__["PluginConfig"].VolumeStreaming.CanStream);
        if (canStreamTest)
            return canStreamTest(a.data, plugin);
        return a.data.models.length === 1 && _mol_model_structure__WEBPACK_IMPORTED_MODULE_16__["Model"].probablyHasDensityMap(a.data.models[0]);
    }
})(function (_a, plugin) {
    var ref = _a.ref, state = _a.state, params = _a.params;
    return _mol_task__WEBPACK_IMPORTED_MODULE_4__["Task"].create('Volume Streaming', function (taskCtx) { return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"])(void 0, void 0, void 0, function () {
        var entries, i, il, dataId, emDefaultContourLevel, emdbIds, j, jl, emdbId, contourLevel, e_1, e_2, infoTree, info, children, infoObj, behTree;
        return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__generator"])(this, function (_a) {
            switch (_a.label) {
                case 0:
                    entries = [];
                    i = 0, il = params.entries.length;
                    _a.label = 1;
                case 1:
                    if (!(i < il)) return [3 /*break*/, 16];
                    dataId = params.entries[i].id.toLowerCase();
                    emDefaultContourLevel = void 0;
                    if (!(params.method === 'em')) return [3 /*break*/, 14];
                    if (!!dataId.toUpperCase().startsWith('EMD')) return [3 /*break*/, 11];
                    return [4 /*yield*/, taskCtx.update('Getting EMDB info...')];
                case 2:
                    _a.sent();
                    return [4 /*yield*/, Object(_util__WEBPACK_IMPORTED_MODULE_8__["getEmdbIds"])(plugin, taskCtx, dataId)];
                case 3:
                    emdbIds = _a.sent();
                    j = 0, jl = emdbIds.length;
                    _a.label = 4;
                case 4:
                    if (!(j < jl)) return [3 /*break*/, 10];
                    emdbId = emdbIds[j];
                    contourLevel = void 0;
                    _a.label = 5;
                case 5:
                    _a.trys.push([5, 7, , 8]);
                    return [4 /*yield*/, Object(_util__WEBPACK_IMPORTED_MODULE_8__["getContourLevel"])(params.options.emContourProvider, plugin, taskCtx, emdbId)];
                case 6:
                    contourLevel = _a.sent();
                    return [3 /*break*/, 8];
                case 7:
                    e_1 = _a.sent();
                    console.info("Could not get map info for " + emdbId + ": " + e_1);
                    return [3 /*break*/, 9];
                case 8:
                    addEntry(entries, params.method, emdbId, contourLevel || 0);
                    _a.label = 9;
                case 9:
                    ++j;
                    return [3 /*break*/, 4];
                case 10: return [3 /*break*/, 15];
                case 11:
                    _a.trys.push([11, 13, , 14]);
                    return [4 /*yield*/, Object(_util__WEBPACK_IMPORTED_MODULE_8__["getContourLevel"])(params.options.emContourProvider, plugin, taskCtx, dataId)];
                case 12:
                    emDefaultContourLevel = _a.sent();
                    return [3 /*break*/, 14];
                case 13:
                    e_2 = _a.sent();
                    console.info("Could not get map info for " + dataId + ": " + e_2);
                    return [3 /*break*/, 15];
                case 14:
                    addEntry(entries, params.method, dataId, emDefaultContourLevel || 0);
                    _a.label = 15;
                case 15:
                    ++i;
                    return [3 /*break*/, 1];
                case 16:
                    infoTree = state.build().to(ref)
                        .applyOrUpdateTagged(_behavior__WEBPACK_IMPORTED_MODULE_9__["VolumeStreaming"].RootTag, CreateVolumeStreamingInfo, {
                        serverUrl: params.options.serverUrl,
                        entries: entries
                    });
                    return [4 /*yield*/, infoTree.commit()];
                case 17:
                    _a.sent();
                    info = infoTree.selector;
                    if (!info.isOk)
                        return [2 /*return*/];
                    children = state.tree.children.get(info.ref);
                    if (!((children === null || children === void 0 ? void 0 : children.size) > 0)) return [3 /*break*/, 19];
                    return [4 /*yield*/, plugin.managers.structure.hierarchy.remove(children === null || children === void 0 ? void 0 : children.toArray())];
                case 18:
                    _a.sent();
                    _a.label = 19;
                case 19:
                    infoObj = info.cell.obj;
                    behTree = state.build().to(infoTree.ref).apply(CreateVolumeStreamingBehavior, _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_3__["ParamDefinition"].getDefaultValues(_behavior__WEBPACK_IMPORTED_MODULE_9__["VolumeStreaming"].createParams({ data: infoObj.data, defaultView: params.defaultView, channelParams: params.options.channelParams })), { ref: params.options.behaviorRef ? params.options.behaviorRef : void 0 });
                    if (params.method === 'em') {
                        behTree.apply(VolumeStreamingVisual, { channel: 'em' }, { state: { isGhost: true }, tags: 'em' });
                    }
                    else {
                        behTree.apply(VolumeStreamingVisual, { channel: '2fo-fc' }, { state: { isGhost: true }, tags: '2fo-fc' });
                        behTree.apply(VolumeStreamingVisual, { channel: 'fo-fc(+ve)' }, { state: { isGhost: true }, tags: 'fo-fc(+ve)' });
                        behTree.apply(VolumeStreamingVisual, { channel: 'fo-fc(-ve)' }, { state: { isGhost: true }, tags: 'fo-fc(-ve)' });
                    }
                    return [4 /*yield*/, state.updateTree(behTree).runInContext(taskCtx)];
                case 20:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    }); });
});
var BoxifyVolumeStreaming = _mol_state__WEBPACK_IMPORTED_MODULE_7__["StateAction"].build({
    display: { name: 'Boxify Volume Streaming', description: 'Make the current box permanent.' },
    from: _behavior__WEBPACK_IMPORTED_MODULE_9__["VolumeStreaming"],
    isApplicable: function (a) { return a.data.params.entry.params.view.name === 'selection-box'; }
})(function (_a, plugin) {
    var a = _a.a, ref = _a.ref, state = _a.state;
    var params = a.data.params;
    if (params.entry.params.view.name !== 'selection-box')
        return;
    var box = _mol_math_geometry__WEBPACK_IMPORTED_MODULE_13__["Box3D"].create(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_14__["Vec3"].clone(params.entry.params.view.params.bottomLeft), _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_14__["Vec3"].clone(params.entry.params.view.params.topRight));
    var r = params.entry.params.view.params.radius;
    _mol_math_geometry__WEBPACK_IMPORTED_MODULE_13__["Box3D"].expand(box, box, _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_14__["Vec3"].create(r, r, r));
    var newParams = Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, params), { entry: {
            name: params.entry.name,
            params: Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, params.entry.params), { view: {
                    name: 'box',
                    params: {
                        bottomLeft: box.min,
                        topRight: box.max
                    }
                } })
        } });
    return state.updateTree(state.build().to(ref).update(newParams));
});
var InfoEntryParams = {
    dataId: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_3__["ParamDefinition"].Text(''),
    source: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_3__["ParamDefinition"].MappedStatic('x-ray', {
        'em': _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_3__["ParamDefinition"].Group({
            isoValue: _mol_model_volume__WEBPACK_IMPORTED_MODULE_6__["Volume"].createIsoValueParam(_mol_model_volume__WEBPACK_IMPORTED_MODULE_6__["Volume"].IsoValue.relative(1))
        }),
        'x-ray': _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_3__["ParamDefinition"].Group({})
    })
};

var CreateVolumeStreamingInfo = _mol_plugin_state_objects__WEBPACK_IMPORTED_MODULE_1__["PluginStateTransform"].BuiltIn({
    name: 'create-volume-streaming-info',
    display: { name: 'Volume Streaming Info' },
    from: _mol_plugin_state_objects__WEBPACK_IMPORTED_MODULE_1__["PluginStateObject"].Molecule.Structure,
    to: _model__WEBPACK_IMPORTED_MODULE_2__["VolumeServerInfo"],
    params: function (a) {
        return {
            serverUrl: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_3__["ParamDefinition"].Text('https://ds.litemol.org'),
            entries: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_3__["ParamDefinition"].ObjectList(InfoEntryParams, function (_a) {
                var dataId = _a.dataId;
                return dataId;
            }, {
                defaultValue: [{ dataId: '', source: { name: 'x-ray', params: {} } }]
            }),
        };
    }
})({
    apply: function (_a, plugin) {
        var a = _a.a, params = _a.params;
        return _mol_task__WEBPACK_IMPORTED_MODULE_4__["Task"].create('', function (taskCtx) { return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"])(void 0, void 0, void 0, function () {
            var entries, i, il, e, dataId, emDefaultContourLevel, header, data;
            return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__generator"])(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        entries = [];
                        i = 0, il = params.entries.length;
                        _a.label = 1;
                    case 1:
                        if (!(i < il)) return [3 /*break*/, 5];
                        e = params.entries[i];
                        dataId = e.dataId;
                        emDefaultContourLevel = e.source.name === 'em' ? e.source.params.isoValue : _mol_model_volume__WEBPACK_IMPORTED_MODULE_6__["Volume"].IsoValue.relative(1);
                        return [4 /*yield*/, taskCtx.update('Getting server header...')];
                    case 2:
                        _a.sent();
                        return [4 /*yield*/, plugin.fetch({ url: Object(_mol_util_url__WEBPACK_IMPORTED_MODULE_5__["urlCombine"])(params.serverUrl, e.source.name + "/" + dataId.toLocaleLowerCase()), type: 'json' }).runInContext(taskCtx)];
                    case 3:
                        header = _a.sent();
                        entries.push({
                            dataId: dataId,
                            kind: e.source.name,
                            header: header,
                            emDefaultContourLevel: emDefaultContourLevel
                        });
                        _a.label = 4;
                    case 4:
                        ++i;
                        return [3 /*break*/, 1];
                    case 5:
                        data = {
                            serverUrl: params.serverUrl,
                            entries: entries,
                            structure: a.data
                        };
                        return [2 /*return*/, new _model__WEBPACK_IMPORTED_MODULE_2__["VolumeServerInfo"](data, { label: 'Volume Server', description: "" + entries.map(function (e) { return e.dataId; }).join(', ') })];
                }
            });
        }); });
    }
});

var CreateVolumeStreamingBehavior = _mol_plugin_state_objects__WEBPACK_IMPORTED_MODULE_1__["PluginStateTransform"].BuiltIn({
    name: 'create-volume-streaming-behavior',
    display: { name: 'Volume Streaming Behavior' },
    from: _model__WEBPACK_IMPORTED_MODULE_2__["VolumeServerInfo"],
    to: _behavior__WEBPACK_IMPORTED_MODULE_9__["VolumeStreaming"],
    params: function (a) {
        return _behavior__WEBPACK_IMPORTED_MODULE_9__["VolumeStreaming"].createParams({ data: a && a.data });
    }
})({
    canAutoUpdate: function (_a) {
        var oldParams = _a.oldParams, newParams = _a.newParams;
        return oldParams.entry.params.view === newParams.entry.params.view
            || newParams.entry.params.view.name === 'selection-box'
            || newParams.entry.params.view.name === 'off';
    },
    apply: function (_a, plugin) {
        var a = _a.a, params = _a.params;
        return _mol_task__WEBPACK_IMPORTED_MODULE_4__["Task"].create('Volume streaming', function (_) { return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"])(void 0, void 0, void 0, function () {
            var behavior;
            return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__generator"])(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        behavior = new _behavior__WEBPACK_IMPORTED_MODULE_9__["VolumeStreaming"].Behavior(plugin, a.data);
                        return [4 /*yield*/, behavior.update(params)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/, new _behavior__WEBPACK_IMPORTED_MODULE_9__["VolumeStreaming"](behavior, { label: 'Volume Streaming', description: behavior.getDescription() })];
                }
            });
        }); });
    },
    update: function (_a) {
        var _this = this;
        var a = _a.a, b = _a.b, oldParams = _a.oldParams, newParams = _a.newParams;
        return _mol_task__WEBPACK_IMPORTED_MODULE_4__["Task"].create('Update Volume Streaming', function (_) { return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"])(_this, void 0, void 0, function () {
            var emDefaultContourLevel, ret;
            return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__generator"])(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (oldParams.entry.name !== newParams.entry.name) {
                            if ('em' in newParams.entry.params.channels) {
                                emDefaultContourLevel = b.data.infoMap.get(newParams.entry.name).emDefaultContourLevel;
                                if (emDefaultContourLevel) {
                                    newParams.entry.params.channels['em'].isoValue = emDefaultContourLevel;
                                }
                            }
                        }
                        return [4 /*yield*/, b.data.update(newParams)];
                    case 1:
                        ret = (_a.sent()) ? _mol_state__WEBPACK_IMPORTED_MODULE_7__["StateTransformer"].UpdateResult.Updated : _mol_state__WEBPACK_IMPORTED_MODULE_7__["StateTransformer"].UpdateResult.Unchanged;
                        b.description = b.data.getDescription();
                        return [2 /*return*/, ret];
                }
            });
        }); });
    }
});

var VolumeStreamingVisual = _mol_plugin_state_objects__WEBPACK_IMPORTED_MODULE_1__["PluginStateTransform"].BuiltIn({
    name: 'create-volume-streaming-visual',
    display: { name: 'Volume Streaming Visual' },
    from: _behavior__WEBPACK_IMPORTED_MODULE_9__["VolumeStreaming"],
    to: _mol_plugin_state_objects__WEBPACK_IMPORTED_MODULE_1__["PluginStateObject"].Volume.Representation3D,
    params: {
        channel: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_3__["ParamDefinition"].Select('em', _behavior__WEBPACK_IMPORTED_MODULE_9__["VolumeStreaming"].ChannelTypeOptions, { isHidden: true })
    }
})({
    apply: function (_a, plugin) {
        var a = _a.a, srcParams = _a.params, spine = _a.spine;
        return _mol_task__WEBPACK_IMPORTED_MODULE_4__["Task"].create('Volume Representation', function (ctx) { return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"])(void 0, void 0, void 0, function () {
            var channel, params, provider, props, repr, structure, transform;
            var _a, _b;
            return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__generator"])(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        channel = a.data.channels[srcParams.channel];
                        if (!channel)
                            return [2 /*return*/, _mol_state__WEBPACK_IMPORTED_MODULE_7__["StateObject"].Null];
                        params = createVolumeProps(a.data, srcParams.channel);
                        provider = _mol_repr_volume_registry__WEBPACK_IMPORTED_MODULE_11__["VolumeRepresentationRegistry"].BuiltIn.isosurface;
                        props = params.type.params || {};
                        repr = provider.factory(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({ webgl: (_a = plugin.canvas3d) === null || _a === void 0 ? void 0 : _a.webgl }, plugin.representation.volume.themes), provider.getParams);
                        repr.setTheme(_mol_theme_theme__WEBPACK_IMPORTED_MODULE_12__["Theme"].create(plugin.representation.volume.themes, { volume: channel.data }, params));
                        structure = (_b = spine.getAncestorOfType(_mol_plugin_state_objects__WEBPACK_IMPORTED_MODULE_1__["PluginStateObject"].Molecule.Structure)) === null || _b === void 0 ? void 0 : _b.data;
                        transform = (structure === null || structure === void 0 ? void 0 : structure.models.length) === 0 ? void 0 : _mol_model_structure_model_properties_global_transform__WEBPACK_IMPORTED_MODULE_17__["GlobalModelTransformInfo"].get(structure === null || structure === void 0 ? void 0 : structure.models[0]);
                        return [4 /*yield*/, repr.createOrUpdate(props, channel.data).runInContext(ctx)];
                    case 1:
                        _c.sent();
                        if (transform)
                            repr.setState({ transform: transform });
                        return [2 /*return*/, new _mol_plugin_state_objects__WEBPACK_IMPORTED_MODULE_1__["PluginStateObject"].Volume.Representation3D({ repr: repr, source: a }, { label: Math.round(channel.isoValue.relativeValue * 100) / 100 + " \u03C3 [" + srcParams.channel + "]" })];
                }
            });
        }); });
    },
    update: function (_a, plugin) {
        var a = _a.a, b = _a.b, newParams = _a.newParams, spine = _a.spine;
        return _mol_task__WEBPACK_IMPORTED_MODULE_4__["Task"].create('Volume Representation', function (ctx) { return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"])(void 0, void 0, void 0, function () {
            var channel, params, props;
            return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__generator"])(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        channel = a.data.channels[newParams.channel];
                        // TODO: is this correct behavior?
                        if (!channel)
                            return [2 /*return*/, _mol_state__WEBPACK_IMPORTED_MODULE_7__["StateTransformer"].UpdateResult.Unchanged];
                        params = createVolumeProps(a.data, newParams.channel);
                        props = Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, b.data.repr.props), params.type.params);
                        b.data.repr.setTheme(_mol_theme_theme__WEBPACK_IMPORTED_MODULE_12__["Theme"].create(plugin.representation.volume.themes, { volume: channel.data }, params));
                        return [4 /*yield*/, b.data.repr.createOrUpdate(props, channel.data).runInContext(ctx)];
                    case 1:
                        _a.sent();
                        // TODO: set the transform here as well in case the structure moves?
                        //       doing this here now breaks the code for some reason...
                        // const structure = spine.getAncestorOfType(SO.Molecule.Structure)?.data;
                        // const transform = structure?.models.length === 0 ? void 0 : GlobalModelTransformInfo.get(structure?.models[0]!);
                        // if (transform) b.data.repr.setState({ transform });
                        return [2 /*return*/, _mol_state__WEBPACK_IMPORTED_MODULE_7__["StateTransformer"].UpdateResult.Updated];
                }
            });
        }); });
    }
});
function createVolumeProps(streaming, channelName) {
    var channel = streaming.channels[channelName];
    return _mol_plugin_state_transforms_representation__WEBPACK_IMPORTED_MODULE_10__["VolumeRepresentation3DHelpers"].getDefaultParamsStatic(streaming.plugin, 'isosurface', { isoValue: channel.isoValue, alpha: channel.opacity, visuals: channel.wireframe ? ['wireframe'] : ['solid'] }, 'uniform', { value: channel.color });
}
//# sourceMappingURL=transformers.js.map

/***/ }),

/***/ "./lib/mol-plugin/behavior/dynamic/volume-streaming/util.js":
/*!******************************************************************!*\
  !*** ./lib/mol-plugin/behavior/dynamic/volume-streaming/util.js ***!
  \******************************************************************/
/*! exports provided: getStreamingMethod, getEmIds, getXrayIds, getIds, getContourLevel, getContourLevelEmdb, getContourLevelPdbe, getEmdbIds */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getStreamingMethod", function() { return getStreamingMethod; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getEmIds", function() { return getEmIds; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getXrayIds", function() { return getXrayIds; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getIds", function() { return getIds; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getContourLevel", function() { return getContourLevel; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getContourLevelEmdb", function() { return getContourLevelEmdb; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getContourLevelPdbe", function() { return getContourLevelPdbe; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getEmdbIds", function() { return getEmdbIds; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _mol_model_structure__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../../../mol-model/structure */ "./lib/mol-model/structure.js");
/* harmony import */ var _mol_model_formats_structure_mmcif__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../../../mol-model-formats/structure/mmcif */ "./lib/mol-model-formats/structure/mmcif.js");
/* harmony import */ var _config__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../../config */ "./lib/mol-plugin/config.js");
/**
 * Copyright (c) 2019-2020 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author David Sehnal <david.sehnal@gmail.com>
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */




function getStreamingMethod(s, defaultKind) {
    if (defaultKind === void 0) { defaultKind = 'x-ray'; }
    if (!s)
        return defaultKind;
    var model = s.models[0];
    if (!_mol_model_formats_structure_mmcif__WEBPACK_IMPORTED_MODULE_2__["MmcifFormat"].is(model.sourceData))
        return defaultKind;
    // Prefer EMDB entries over structure-factors (SF) e.g. for 'ELECTRON CRYSTALLOGRAPHY' entries
    // like 6AXZ or 6KJ3 for which EMDB entries are available but map calculation from SF is hard.
    if (_mol_model_structure__WEBPACK_IMPORTED_MODULE_1__["Model"].hasEmMap(model))
        return 'em';
    if (_mol_model_structure__WEBPACK_IMPORTED_MODULE_1__["Model"].hasXrayMap(model))
        return 'x-ray';
    // Fallbacks based on experimental method
    if (_mol_model_structure__WEBPACK_IMPORTED_MODULE_1__["Model"].isFromEm(model))
        return 'em';
    if (_mol_model_structure__WEBPACK_IMPORTED_MODULE_1__["Model"].isFromXray(model))
        return 'x-ray';
    return defaultKind;
}
/** Returns EMD ID when available, otherwise falls back to PDB ID */
function getEmIds(model) {
    var ids = [];
    if (!_mol_model_formats_structure_mmcif__WEBPACK_IMPORTED_MODULE_2__["MmcifFormat"].is(model.sourceData))
        return [model.entryId];
    var _a = model.sourceData.data.db.pdbx_database_related, db_id = _a.db_id, db_name = _a.db_name, content_type = _a.content_type;
    if (!db_name.isDefined)
        return [model.entryId];
    for (var i = 0, il = db_name.rowCount; i < il; ++i) {
        if (db_name.value(i).toUpperCase() === 'EMDB' && content_type.value(i) === 'associated EM volume') {
            ids.push(db_id.value(i));
        }
    }
    return ids;
}
function getXrayIds(model) {
    return [model.entryId];
}
function getIds(method, s) {
    if (!s || !s.models.length)
        return [];
    var model = s.models[0];
    switch (method) {
        case 'em': return getEmIds(model);
        case 'x-ray': return getXrayIds(model);
    }
}
function getContourLevel(provider, plugin, taskCtx, emdbId) {
    return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"])(this, void 0, void 0, function () {
        return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__generator"])(this, function (_a) {
            switch (provider) {
                case 'emdb': return [2 /*return*/, getContourLevelEmdb(plugin, taskCtx, emdbId)];
                case 'pdbe': return [2 /*return*/, getContourLevelPdbe(plugin, taskCtx, emdbId)];
            }
            return [2 /*return*/];
        });
    });
}
function getContourLevelEmdb(plugin, taskCtx, emdbId) {
    return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"])(this, void 0, void 0, function () {
        var emdbHeaderServer, header, map, contourLevel;
        return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__generator"])(this, function (_a) {
            switch (_a.label) {
                case 0:
                    emdbHeaderServer = plugin.config.get(_config__WEBPACK_IMPORTED_MODULE_3__["PluginConfig"].VolumeStreaming.EmdbHeaderServer);
                    return [4 /*yield*/, plugin.fetch({ url: emdbHeaderServer + "/" + emdbId.toUpperCase() + "/header/" + emdbId.toLowerCase() + ".xml", type: 'xml' }).runInContext(taskCtx)];
                case 1:
                    header = _a.sent();
                    map = header.getElementsByTagName('map')[0];
                    contourLevel = parseFloat(map.getElementsByTagName('contourLevel')[0].textContent);
                    return [2 /*return*/, contourLevel];
            }
        });
    });
}
function getContourLevelPdbe(plugin, taskCtx, emdbId) {
    var _a, _b, _c;
    return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"])(this, void 0, void 0, function () {
        var header, emdbEntry, contourLevel;
        return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__generator"])(this, function (_d) {
            switch (_d.label) {
                case 0:
                    emdbId = emdbId.toUpperCase();
                    return [4 /*yield*/, plugin.fetch({ url: "https://www.ebi.ac.uk/pdbe/api/emdb/entry/map/" + emdbId, type: 'json' }).runInContext(taskCtx)];
                case 1:
                    header = _d.sent();
                    emdbEntry = header === null || header === void 0 ? void 0 : header[emdbId];
                    contourLevel = void 0;
                    if (((_c = (_b = (_a = emdbEntry === null || emdbEntry === void 0 ? void 0 : emdbEntry[0]) === null || _a === void 0 ? void 0 : _a.map) === null || _b === void 0 ? void 0 : _b.contour_level) === null || _c === void 0 ? void 0 : _c.value) !== void 0) {
                        contourLevel = +emdbEntry[0].map.contour_level.value;
                    }
                    return [2 /*return*/, contourLevel];
            }
        });
    });
}
function getEmdbIds(plugin, taskCtx, pdbId) {
    var _a;
    return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"])(this, void 0, void 0, function () {
        var summary, summaryEntry, emdbIds, emdb;
        return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__generator"])(this, function (_b) {
            switch (_b.label) {
                case 0: return [4 /*yield*/, plugin.fetch({ url: "https://www.ebi.ac.uk/pdbe/api/pdb/entry/summary/" + pdbId, type: 'json' }).runInContext(taskCtx)];
                case 1:
                    summary = _b.sent();
                    summaryEntry = summary === null || summary === void 0 ? void 0 : summary[pdbId];
                    emdbIds = [];
                    if ((_a = summaryEntry === null || summaryEntry === void 0 ? void 0 : summaryEntry[0]) === null || _a === void 0 ? void 0 : _a.related_structures) {
                        emdb = summaryEntry[0].related_structures.filter(function (s) { return s.resource === 'EMDB' && s.relationship === 'associated EM volume'; });
                        if (!emdb.length) {
                            throw new Error("No related EMDB entry found for '" + pdbId + "'.");
                        }
                        emdbIds.push.apply(emdbIds, emdb.map(function (e) { return e.accession; }));
                    }
                    else {
                        throw new Error("No related EMDB entry found for '" + pdbId + "'.");
                    }
                    return [2 /*return*/, emdbIds];
            }
        });
    });
}
//# sourceMappingURL=util.js.map

/***/ }),

/***/ "./lib/mol-plugin/behavior/static/camera.js":
/*!**************************************************!*\
  !*** ./lib/mol-plugin/behavior/static/camera.js ***!
  \**************************************************/
/*! exports provided: registerDefault, Reset, SetSnapshot, Focus */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "registerDefault", function() { return registerDefault; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Reset", function() { return Reset; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SetSnapshot", function() { return SetSnapshot; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Focus", function() { return Focus; });
/* harmony import */ var _commands__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../commands */ "./lib/mol-plugin/commands.js");
/**
 * Copyright (c) 2018 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author David Sehnal <david.sehnal@gmail.com>
 */

function registerDefault(ctx) {
    Reset(ctx);
    Focus(ctx);
    SetSnapshot(ctx);
}
function Reset(ctx) {
    _commands__WEBPACK_IMPORTED_MODULE_0__["PluginCommands"].Camera.Reset.subscribe(ctx, function (options) {
        ctx.managers.camera.reset(options === null || options === void 0 ? void 0 : options.snapshot, options === null || options === void 0 ? void 0 : options.durationMs);
    });
}
function SetSnapshot(ctx) {
    _commands__WEBPACK_IMPORTED_MODULE_0__["PluginCommands"].Camera.SetSnapshot.subscribe(ctx, function (_a) {
        var snapshot = _a.snapshot, durationMs = _a.durationMs;
        ctx.managers.camera.setSnapshot(snapshot, durationMs);
    });
}
function Focus(ctx) {
    _commands__WEBPACK_IMPORTED_MODULE_0__["PluginCommands"].Camera.Focus.subscribe(ctx, function (_a) {
        var center = _a.center, radius = _a.radius, durationMs = _a.durationMs;
        ctx.managers.camera.focusSphere({ center: center, radius: radius }, { durationMs: durationMs });
        ctx.events.canvas3d.settingsUpdated.next();
    });
}
//# sourceMappingURL=camera.js.map

/***/ }),

/***/ "./lib/mol-plugin/behavior/static/misc.js":
/*!************************************************!*\
  !*** ./lib/mol-plugin/behavior/static/misc.js ***!
  \************************************************/
/*! exports provided: registerDefault, Canvas3DSetSettings */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "registerDefault", function() { return registerDefault; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Canvas3DSetSettings", function() { return Canvas3DSetSettings; });
/* harmony import */ var _commands__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../commands */ "./lib/mol-plugin/commands.js");
/* harmony import */ var _mol_canvas3d_canvas3d__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../../mol-canvas3d/canvas3d */ "./lib/mol-canvas3d/canvas3d.js");
/**
 * Copyright (c) 2018-2019 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author David Sehnal <david.sehnal@gmail.com>
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */


function registerDefault(ctx) {
    Canvas3DSetSettings(ctx);
}
function Canvas3DSetSettings(ctx) {
    _commands__WEBPACK_IMPORTED_MODULE_0__["PluginCommands"].Canvas3D.ResetSettings.subscribe(ctx, function () {
        var _a;
        (_a = ctx.canvas3d) === null || _a === void 0 ? void 0 : _a.setProps(_mol_canvas3d_canvas3d__WEBPACK_IMPORTED_MODULE_1__["DefaultCanvas3DParams"]);
        ctx.events.canvas3d.settingsUpdated.next();
    });
    _commands__WEBPACK_IMPORTED_MODULE_0__["PluginCommands"].Canvas3D.SetSettings.subscribe(ctx, function (e) {
        var _a;
        if (!ctx.canvas3d)
            return;
        (_a = ctx.canvas3d) === null || _a === void 0 ? void 0 : _a.setProps(e.settings);
        ctx.events.canvas3d.settingsUpdated.next();
    });
}
//# sourceMappingURL=misc.js.map

/***/ }),

/***/ "./lib/mol-plugin/behavior/static/representation.js":
/*!**********************************************************!*\
  !*** ./lib/mol-plugin/behavior/static/representation.js ***!
  \**********************************************************/
/*! exports provided: registerDefault, SyncRepresentationToCanvas, SyncStructureRepresentation3DState, UpdateRepresentationVisibility */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "registerDefault", function() { return registerDefault; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SyncRepresentationToCanvas", function() { return SyncRepresentationToCanvas; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SyncStructureRepresentation3DState", function() { return SyncStructureRepresentation3DState; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "UpdateRepresentationVisibility", function() { return UpdateRepresentationVisibility; });
/* harmony import */ var _mol_plugin_state_objects__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../../mol-plugin-state/objects */ "./lib/mol-plugin-state/objects.js");
/**
 * Copyright (c) 2018 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author David Sehnal <david.sehnal@gmail.com>
 */

function registerDefault(ctx) {
    SyncRepresentationToCanvas(ctx);
    SyncStructureRepresentation3DState(ctx); // should be AFTER SyncRepresentationToCanvas
    UpdateRepresentationVisibility(ctx);
}
function SyncRepresentationToCanvas(ctx) {
    var events = ctx.state.data.events;
    events.object.created.subscribe(function (e) {
        var _a;
        if (!_mol_plugin_state_objects__WEBPACK_IMPORTED_MODULE_0__["PluginStateObject"].isRepresentation3D(e.obj))
            return;
        updateVisibility(e.state.cells.get(e.ref), e.obj.data.repr);
        e.obj.data.repr.setState({ syncManually: true });
        (_a = ctx.canvas3d) === null || _a === void 0 ? void 0 : _a.add(e.obj.data.repr);
    });
    events.object.updated.subscribe(function (e) {
        var _a, _b;
        if (e.oldObj && _mol_plugin_state_objects__WEBPACK_IMPORTED_MODULE_0__["PluginStateObject"].isRepresentation3D(e.oldObj)) {
            (_a = ctx.canvas3d) === null || _a === void 0 ? void 0 : _a.remove(e.oldObj.data.repr);
            e.oldObj.data.repr.destroy();
        }
        if (!_mol_plugin_state_objects__WEBPACK_IMPORTED_MODULE_0__["PluginStateObject"].isRepresentation3D(e.obj)) {
            return;
        }
        updateVisibility(e.state.cells.get(e.ref), e.obj.data.repr);
        if (e.action === 'recreate') {
            e.obj.data.repr.setState({ syncManually: true });
        }
        (_b = ctx.canvas3d) === null || _b === void 0 ? void 0 : _b.add(e.obj.data.repr);
    });
    events.object.removed.subscribe(function (e) {
        var _a;
        if (!_mol_plugin_state_objects__WEBPACK_IMPORTED_MODULE_0__["PluginStateObject"].isRepresentation3D(e.obj))
            return;
        (_a = ctx.canvas3d) === null || _a === void 0 ? void 0 : _a.remove(e.obj.data.repr);
        e.obj.data.repr.destroy();
    });
}
function SyncStructureRepresentation3DState(ctx) {
    // TODO: figure out how to do transform composition here?
    var events = ctx.state.data.events;
    events.object.created.subscribe(function (e) {
        var _a;
        if (!_mol_plugin_state_objects__WEBPACK_IMPORTED_MODULE_0__["PluginStateObject"].Molecule.Structure.Representation3DState.is(e.obj))
            return;
        var data = e.obj.data;
        data.source.data.repr.setState(data.state);
        (_a = ctx.canvas3d) === null || _a === void 0 ? void 0 : _a.update(data.source.data.repr);
    });
    events.object.updated.subscribe(function (e) {
        var _a;
        if (!_mol_plugin_state_objects__WEBPACK_IMPORTED_MODULE_0__["PluginStateObject"].Molecule.Structure.Representation3DState.is(e.obj))
            return;
        var data = e.obj.data;
        data.source.data.repr.setState(data.state);
        (_a = ctx.canvas3d) === null || _a === void 0 ? void 0 : _a.update(data.source.data.repr);
    });
    events.object.removed.subscribe(function (e) {
        var _a;
        if (!_mol_plugin_state_objects__WEBPACK_IMPORTED_MODULE_0__["PluginStateObject"].Molecule.Structure.Representation3DState.is(e.obj))
            return;
        var data = e.obj.data;
        data.source.data.repr.setState(data.initialState);
        (_a = ctx.canvas3d) === null || _a === void 0 ? void 0 : _a.update(data.source.data.repr);
    });
}
function UpdateRepresentationVisibility(ctx) {
    ctx.state.data.events.cell.stateUpdated.subscribe(function (e) {
        var _a;
        var cell = e.state.cells.get(e.ref);
        if (!_mol_plugin_state_objects__WEBPACK_IMPORTED_MODULE_0__["PluginStateObject"].isRepresentation3D(cell.obj))
            return;
        updateVisibility(cell, cell.obj.data.repr);
        (_a = ctx.canvas3d) === null || _a === void 0 ? void 0 : _a.syncVisibility();
    });
}
function updateVisibility(cell, r) {
    r.setState({ visible: !cell.state.isHidden });
}
//# sourceMappingURL=representation.js.map

/***/ }),

/***/ "./lib/mol-plugin/behavior/static/state.js":
/*!*************************************************!*\
  !*** ./lib/mol-plugin/behavior/static/state.js ***!
  \*************************************************/
/*! exports provided: registerDefault, SyncBehaviors, SetCurrentObject, Update, ApplyAction, RemoveObject, ToggleExpanded, ToggleVisibility, setSubtreeVisibility, Highlight, ClearHighlights, Snapshots */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "registerDefault", function() { return registerDefault; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SyncBehaviors", function() { return SyncBehaviors; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SetCurrentObject", function() { return SetCurrentObject; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Update", function() { return Update; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ApplyAction", function() { return ApplyAction; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "RemoveObject", function() { return RemoveObject; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ToggleExpanded", function() { return ToggleExpanded; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ToggleVisibility", function() { return ToggleVisibility; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setSubtreeVisibility", function() { return setSubtreeVisibility; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Highlight", function() { return Highlight; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ClearHighlights", function() { return ClearHighlights; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Snapshots", function() { return Snapshots; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _mol_model_structure__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../../mol-model/structure */ "./lib/mol-model/structure.js");
/* harmony import */ var _mol_plugin_state_manager_snapshots__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../../mol-plugin-state/manager/snapshots */ "./lib/mol-plugin-state/manager/snapshots.js");
/* harmony import */ var _mol_plugin_state_objects__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../../mol-plugin-state/objects */ "./lib/mol-plugin-state/objects.js");
/* harmony import */ var _mol_state__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../../mol-state */ "./lib/mol-state/index.js");
/* harmony import */ var _mol_util_date__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../../mol-util/date */ "./lib/mol-util/date.js");
/* harmony import */ var _mol_util_download__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../../../mol-util/download */ "./lib/mol-util/download.js");
/* harmony import */ var _mol_util_url__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../../../mol-util/url */ "./lib/mol-util/url.js");
/* harmony import */ var _commands__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ../../commands */ "./lib/mol-plugin/commands.js");
/* harmony import */ var _config__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ../../config */ "./lib/mol-plugin/config.js");
/**
 * Copyright (c) 2018-2020 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author David Sehnal <david.sehnal@gmail.com>
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */










function registerDefault(ctx) {
    SyncBehaviors(ctx);
    SetCurrentObject(ctx);
    Update(ctx);
    ApplyAction(ctx);
    RemoveObject(ctx);
    ToggleExpanded(ctx);
    ToggleVisibility(ctx);
    Highlight(ctx);
    ClearHighlights(ctx);
    Snapshots(ctx);
}
function SyncBehaviors(ctx) {
    ctx.state.events.object.created.subscribe(function (o) {
        if (!_mol_plugin_state_objects__WEBPACK_IMPORTED_MODULE_3__["PluginStateObject"].isBehavior(o.obj))
            return;
        o.obj.data.register(o.ref);
    });
    ctx.state.events.object.removed.subscribe(function (o) {
        if (!_mol_plugin_state_objects__WEBPACK_IMPORTED_MODULE_3__["PluginStateObject"].isBehavior(o.obj))
            return;
        o.obj.data.unregister();
    });
    ctx.state.events.object.updated.subscribe(function (o) {
        if (o.action === 'recreate') {
            if (o.oldObj && _mol_plugin_state_objects__WEBPACK_IMPORTED_MODULE_3__["PluginStateObject"].isBehavior(o.oldObj))
                o.oldObj.data.unregister();
            if (o.obj && _mol_plugin_state_objects__WEBPACK_IMPORTED_MODULE_3__["PluginStateObject"].isBehavior(o.obj))
                o.obj.data.register(o.ref);
        }
    });
}
function SetCurrentObject(ctx) {
    _commands__WEBPACK_IMPORTED_MODULE_8__["PluginCommands"].State.SetCurrentObject.subscribe(ctx, function (_a) {
        var state = _a.state, ref = _a.ref;
        return state.setCurrent(ref);
    });
}
function Update(ctx) {
    _commands__WEBPACK_IMPORTED_MODULE_8__["PluginCommands"].State.Update.subscribe(ctx, function (_a) {
        var state = _a.state, tree = _a.tree, options = _a.options;
        return ctx.runTask(state.updateTree(tree, options));
    });
}
function ApplyAction(ctx) {
    _commands__WEBPACK_IMPORTED_MODULE_8__["PluginCommands"].State.ApplyAction.subscribe(ctx, function (_a) {
        var state = _a.state, action = _a.action, ref = _a.ref;
        return ctx.runTask(state.applyAction(action.action, action.params, ref));
    });
}
function RemoveObject(ctx) {
    function remove(state, ref) {
        var tree = state.build().delete(ref);
        return ctx.runTask(state.updateTree(tree));
    }
    _commands__WEBPACK_IMPORTED_MODULE_8__["PluginCommands"].State.RemoveObject.subscribe(ctx, function (_a) {
        var state = _a.state, ref = _a.ref, removeParentGhosts = _a.removeParentGhosts;
        if (removeParentGhosts) {
            var tree = state.tree;
            var curr = tree.transforms.get(ref);
            if (curr.parent === ref)
                return remove(state, ref);
            while (true) {
                var children = tree.children.get(curr.parent);
                if (curr.parent === curr.ref || children.size > 1)
                    return remove(state, curr.ref);
                var parent_1 = tree.transforms.get(curr.parent);
                // TODO: should this use "cell state" instead?
                if (!parent_1.state.isGhost)
                    return remove(state, curr.ref);
                curr = parent_1;
            }
        }
        else {
            return remove(state, ref);
        }
    });
}
function ToggleExpanded(ctx) {
    _commands__WEBPACK_IMPORTED_MODULE_8__["PluginCommands"].State.ToggleExpanded.subscribe(ctx, function (_a) {
        var state = _a.state, ref = _a.ref;
        return state.updateCellState(ref, function (_a) {
            var isCollapsed = _a.isCollapsed;
            return ({ isCollapsed: !isCollapsed });
        });
    });
}
function ToggleVisibility(ctx) {
    _commands__WEBPACK_IMPORTED_MODULE_8__["PluginCommands"].State.ToggleVisibility.subscribe(ctx, function (_a) {
        var state = _a.state, ref = _a.ref;
        return setSubtreeVisibility(state, ref, !state.cells.get(ref).state.isHidden);
    });
}
function setSubtreeVisibility(state, root, value) {
    _mol_state__WEBPACK_IMPORTED_MODULE_4__["StateTree"].doPreOrder(state.tree, state.transforms.get(root), { state: state, value: value }, setVisibilityVisitor);
}
function setVisibilityVisitor(t, tree, ctx) {
    ctx.state.updateCellState(t.ref, { isHidden: ctx.value });
}
function Highlight(ctx) {
    _commands__WEBPACK_IMPORTED_MODULE_8__["PluginCommands"].Interactivity.Object.Highlight.subscribe(ctx, function (_a) {
        var state = _a.state, ref = _a.ref;
        if (!ctx.canvas3d || ctx.isBusy)
            return;
        ctx.managers.interactivity.lociHighlights.clearHighlights();
        var refs = typeof ref === 'string' ? [ref] : ref;
        for (var _i = 0, refs_1 = refs; _i < refs_1.length; _i++) {
            var r = refs_1[_i];
            var cell = state.cells.get(r);
            if (!cell)
                continue;
            if (_mol_plugin_state_objects__WEBPACK_IMPORTED_MODULE_3__["PluginStateObject"].Molecule.Structure.is(cell.obj)) {
                ctx.managers.interactivity.lociHighlights.highlight({ loci: _mol_model_structure__WEBPACK_IMPORTED_MODULE_1__["Structure"].Loci(cell.obj.data) }, false);
            }
            else if (cell && _mol_plugin_state_objects__WEBPACK_IMPORTED_MODULE_3__["PluginStateObject"].isRepresentation3D(cell.obj)) {
                var repr = cell.obj.data.repr;
                ctx.managers.interactivity.lociHighlights.highlight({ loci: repr.getLoci(), repr: repr }, false);
            }
            else if (_mol_plugin_state_objects__WEBPACK_IMPORTED_MODULE_3__["PluginStateObject"].Molecule.Structure.Selections.is(cell.obj)) {
                for (var _b = 0, _c = cell.obj.data; _b < _c.length; _b++) {
                    var entry = _c[_b];
                    ctx.managers.interactivity.lociHighlights.highlight({ loci: entry.loci }, false);
                }
            }
        }
        // TODO: highlight volumes?
        // TODO: select structures of subtree?
    });
}
function ClearHighlights(ctx) {
    _commands__WEBPACK_IMPORTED_MODULE_8__["PluginCommands"].Interactivity.ClearHighlights.subscribe(ctx, function () {
        ctx.managers.interactivity.lociHighlights.clearHighlights();
    });
}
function Snapshots(ctx) {
    var _this = this;
    ctx.config.set(_config__WEBPACK_IMPORTED_MODULE_9__["PluginConfig"].State.CurrentServer, ctx.config.get(_config__WEBPACK_IMPORTED_MODULE_9__["PluginConfig"].State.DefaultServer));
    _commands__WEBPACK_IMPORTED_MODULE_8__["PluginCommands"].State.Snapshots.Clear.subscribe(ctx, function () {
        ctx.managers.snapshot.clear();
    });
    _commands__WEBPACK_IMPORTED_MODULE_8__["PluginCommands"].State.Snapshots.Remove.subscribe(ctx, function (_a) {
        var id = _a.id;
        ctx.managers.snapshot.remove(id);
    });
    _commands__WEBPACK_IMPORTED_MODULE_8__["PluginCommands"].State.Snapshots.Add.subscribe(ctx, function (_a) {
        var name = _a.name, description = _a.description, params = _a.params;
        var entry = _mol_plugin_state_manager_snapshots__WEBPACK_IMPORTED_MODULE_2__["PluginStateSnapshotManager"].Entry(ctx.state.getSnapshot(params), { name: name, description: description });
        ctx.managers.snapshot.add(entry);
    });
    _commands__WEBPACK_IMPORTED_MODULE_8__["PluginCommands"].State.Snapshots.Replace.subscribe(ctx, function (_a) {
        var id = _a.id, params = _a.params;
        ctx.managers.snapshot.replace(id, ctx.state.getSnapshot(params));
    });
    _commands__WEBPACK_IMPORTED_MODULE_8__["PluginCommands"].State.Snapshots.Move.subscribe(ctx, function (_a) {
        var id = _a.id, dir = _a.dir;
        ctx.managers.snapshot.move(id, dir);
    });
    _commands__WEBPACK_IMPORTED_MODULE_8__["PluginCommands"].State.Snapshots.Apply.subscribe(ctx, function (_a) {
        var id = _a.id;
        var snapshot = ctx.managers.snapshot.setCurrent(id);
        if (!snapshot)
            return;
        return ctx.state.setSnapshot(snapshot);
    });
    _commands__WEBPACK_IMPORTED_MODULE_8__["PluginCommands"].State.Snapshots.Upload.subscribe(ctx, function (_a) {
        var name = _a.name, description = _a.description, playOnLoad = _a.playOnLoad, serverUrl = _a.serverUrl, params = _a.params;
        return fetch(Object(_mol_util_url__WEBPACK_IMPORTED_MODULE_7__["urlCombine"])(serverUrl, "set?name=" + encodeURIComponent(name || '') + "&description=" + encodeURIComponent(description || '')), {
            method: 'POST',
            mode: 'cors',
            referrer: 'no-referrer',
            headers: { 'Content-Type': 'application/json; charset=utf-8' },
            body: JSON.stringify(ctx.managers.snapshot.getStateSnapshot({ name: name, description: description, playOnLoad: playOnLoad }))
        });
    });
    _commands__WEBPACK_IMPORTED_MODULE_8__["PluginCommands"].State.Snapshots.Fetch.subscribe(ctx, function (_a) {
        var url = _a.url;
        return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"])(_this, void 0, void 0, function () {
            var json;
            return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__generator"])(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, ctx.runTask(ctx.fetch({ url: url, type: 'json' }))];
                    case 1:
                        json = _b.sent();
                        return [4 /*yield*/, ctx.managers.snapshot.setStateSnapshot(json.data)];
                    case 2:
                        _b.sent();
                        return [2 /*return*/];
                }
            });
        });
    });
    _commands__WEBPACK_IMPORTED_MODULE_8__["PluginCommands"].State.Snapshots.DownloadToFile.subscribe(ctx, function (_a) {
        var name = _a.name, type = _a.type, params = _a.params;
        return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"])(_this, void 0, void 0, function () {
            var filename, data;
            return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__generator"])(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        filename = "mol-star_state_" + (name || Object(_mol_util_date__WEBPACK_IMPORTED_MODULE_5__["getFormattedTime"])()) + "." + (type === 'json' ? 'molj' : 'molx');
                        return [4 /*yield*/, ctx.managers.snapshot.serialize({ type: type, params: params })];
                    case 1:
                        data = _b.sent();
                        Object(_mol_util_download__WEBPACK_IMPORTED_MODULE_6__["download"])(data, "" + filename);
                        return [2 /*return*/];
                }
            });
        });
    });
    _commands__WEBPACK_IMPORTED_MODULE_8__["PluginCommands"].State.Snapshots.OpenFile.subscribe(ctx, function (_a) {
        var file = _a.file;
        return ctx.managers.snapshot.open(file);
    });
    _commands__WEBPACK_IMPORTED_MODULE_8__["PluginCommands"].State.Snapshots.OpenUrl.subscribe(ctx, function (_a) {
        var url = _a.url, type = _a.type;
        return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"])(_this, void 0, void 0, function () {
            var data;
            return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__generator"])(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, ctx.runTask(ctx.fetch({ url: url, type: 'binary' }))];
                    case 1:
                        data = _b.sent();
                        return [2 /*return*/, ctx.managers.snapshot.open(new File([data], "state." + type))];
                }
            });
        });
    });
}
//# sourceMappingURL=state.js.map

/***/ }),

/***/ "./lib/mol-plugin/command.js":
/*!***********************************!*\
  !*** ./lib/mol-plugin/command.js ***!
  \***********************************/
/*! exports provided: PluginCommand, PluginCommandManager */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "PluginCommand", function() { return PluginCommand; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "PluginCommandManager", function() { return PluginCommandManager; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _mol_util__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../mol-util */ "./lib/mol-util/index.js");
/**
 * Copyright (c) 2018 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author David Sehnal <david.sehnal@gmail.com>
 */



function PluginCommand() {
    var ret = (function (ctx, params) { return ctx.commands.dispatch(ret, params || {}); });
    ret.subscribe = function (ctx, action) { return ctx.commands.subscribe(ret, action); };
    ret.id = _mol_util__WEBPACK_IMPORTED_MODULE_1__["UUID"].create22();
    return ret;
}
var PluginCommandManager = /** @class */ (function () {
    function PluginCommandManager() {
        this.subs = new Map();
        this.disposing = false;
    }
    PluginCommandManager.prototype.subscribe = function (cmd, action) {
        var _this = this;
        var actions = this.subs.get(cmd.id);
        if (!actions) {
            actions = [];
            this.subs.set(cmd.id, actions);
        }
        actions.push(action);
        return {
            unsubscribe: function () {
                var actions = _this.subs.get(cmd.id);
                if (!actions)
                    return;
                var idx = actions.indexOf(action);
                if (idx < 0)
                    return;
                for (var i = idx + 1; i < actions.length; i++) {
                    actions[i - 1] = actions[i];
                }
                actions.pop();
            }
        };
    };
    /** Resolves after all actions have completed */
    PluginCommandManager.prototype.dispatch = function (cmd, params) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            if (_this.disposing) {
                reject('disposed');
                return;
            }
            var actions = _this.subs.get(cmd.id);
            if (!actions) {
                resolve();
                return;
            }
            _this.resolve({ cmd: cmd, params: params, resolve: resolve, reject: reject });
        });
    };
    PluginCommandManager.prototype.dispose = function () {
        this.subs.clear();
    };
    PluginCommandManager.prototype.resolve = function (instance) {
        return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"])(this, void 0, void 0, function () {
            var actions, _i, actions_1, a, e_1;
            return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__generator"])(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        actions = this.subs.get(instance.cmd.id);
                        if (!actions) {
                            instance.resolve();
                            return [2 /*return*/];
                        }
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 6, , 7]);
                        _i = 0, actions_1 = actions;
                        _a.label = 2;
                    case 2:
                        if (!(_i < actions_1.length)) return [3 /*break*/, 5];
                        a = actions_1[_i];
                        return [4 /*yield*/, a(instance.params)];
                    case 3:
                        _a.sent();
                        _a.label = 4;
                    case 4:
                        _i++;
                        return [3 /*break*/, 2];
                    case 5:
                        instance.resolve();
                        return [3 /*break*/, 7];
                    case 6:
                        e_1 = _a.sent();
                        instance.reject(e_1);
                        return [3 /*break*/, 7];
                    case 7: return [2 /*return*/];
                }
            });
        });
    };
    return PluginCommandManager;
}());
//# sourceMappingURL=command.js.map

/***/ }),

/***/ "./lib/mol-plugin/commands.js":
/*!************************************!*\
  !*** ./lib/mol-plugin/commands.js ***!
  \************************************/
/*! exports provided: PluginCommands */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "PluginCommands", function() { return PluginCommands; });
/* harmony import */ var _command__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./command */ "./lib/mol-plugin/command.js");
/**
 * Copyright (c) 2018-2020 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author David Sehnal <david.sehnal@gmail.com>
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */

var PluginCommands = {
    State: {
        SetCurrentObject: Object(_command__WEBPACK_IMPORTED_MODULE_0__["PluginCommand"])(),
        ApplyAction: Object(_command__WEBPACK_IMPORTED_MODULE_0__["PluginCommand"])(),
        Update: Object(_command__WEBPACK_IMPORTED_MODULE_0__["PluginCommand"])(),
        RemoveObject: Object(_command__WEBPACK_IMPORTED_MODULE_0__["PluginCommand"])(),
        ToggleExpanded: Object(_command__WEBPACK_IMPORTED_MODULE_0__["PluginCommand"])(),
        ToggleVisibility: Object(_command__WEBPACK_IMPORTED_MODULE_0__["PluginCommand"])(),
        Snapshots: {
            Add: Object(_command__WEBPACK_IMPORTED_MODULE_0__["PluginCommand"])(),
            Replace: Object(_command__WEBPACK_IMPORTED_MODULE_0__["PluginCommand"])(),
            Move: Object(_command__WEBPACK_IMPORTED_MODULE_0__["PluginCommand"])(),
            Remove: Object(_command__WEBPACK_IMPORTED_MODULE_0__["PluginCommand"])(),
            Apply: Object(_command__WEBPACK_IMPORTED_MODULE_0__["PluginCommand"])(),
            Clear: Object(_command__WEBPACK_IMPORTED_MODULE_0__["PluginCommand"])(),
            Upload: Object(_command__WEBPACK_IMPORTED_MODULE_0__["PluginCommand"])(),
            Fetch: Object(_command__WEBPACK_IMPORTED_MODULE_0__["PluginCommand"])(),
            DownloadToFile: Object(_command__WEBPACK_IMPORTED_MODULE_0__["PluginCommand"])(),
            OpenFile: Object(_command__WEBPACK_IMPORTED_MODULE_0__["PluginCommand"])(),
            OpenUrl: Object(_command__WEBPACK_IMPORTED_MODULE_0__["PluginCommand"])(),
        }
    },
    Interactivity: {
        Object: {
            Highlight: Object(_command__WEBPACK_IMPORTED_MODULE_0__["PluginCommand"])(),
        },
        Structure: {
            Highlight: Object(_command__WEBPACK_IMPORTED_MODULE_0__["PluginCommand"])(),
            Select: Object(_command__WEBPACK_IMPORTED_MODULE_0__["PluginCommand"])()
        },
        ClearHighlights: Object(_command__WEBPACK_IMPORTED_MODULE_0__["PluginCommand"])(),
    },
    Layout: {
        Update: Object(_command__WEBPACK_IMPORTED_MODULE_0__["PluginCommand"])()
    },
    Toast: {
        Show: Object(_command__WEBPACK_IMPORTED_MODULE_0__["PluginCommand"])(),
        Hide: Object(_command__WEBPACK_IMPORTED_MODULE_0__["PluginCommand"])()
    },
    Camera: {
        Reset: Object(_command__WEBPACK_IMPORTED_MODULE_0__["PluginCommand"])(),
        SetSnapshot: Object(_command__WEBPACK_IMPORTED_MODULE_0__["PluginCommand"])(),
        Focus: Object(_command__WEBPACK_IMPORTED_MODULE_0__["PluginCommand"])()
    },
    Canvas3D: {
        SetSettings: Object(_command__WEBPACK_IMPORTED_MODULE_0__["PluginCommand"])(),
        ResetSettings: Object(_command__WEBPACK_IMPORTED_MODULE_0__["PluginCommand"])()
    }
};
//# sourceMappingURL=commands.js.map

/***/ }),

/***/ "./lib/mol-plugin/config.js":
/*!**********************************!*\
  !*** ./lib/mol-plugin/config.js ***!
  \**********************************/
/*! exports provided: PluginConfigItem, PluginConfig, PluginConfigManager */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "PluginConfigItem", function() { return PluginConfigItem; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "PluginConfig", function() { return PluginConfig; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "PluginConfigManager", function() { return PluginConfigManager; });
/* harmony import */ var _mol_model_structure__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../mol-model/structure */ "./lib/mol-model/structure.js");
/**
 * Copyright (c) 2020-2021 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author David Sehnal <david.sehnal@gmail.com>
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */

var PluginConfigItem = /** @class */ (function () {
    function PluginConfigItem(key, defaultValue) {
        this.key = key;
        this.defaultValue = defaultValue;
    }
    PluginConfigItem.prototype.toString = function () { return this.key; };
    PluginConfigItem.prototype.valueOf = function () { return this.key; };
    return PluginConfigItem;
}());

function item(key, defaultValue) { return new PluginConfigItem(key, defaultValue); }
var PluginConfig = {
    item: item,
    General: {
        IsBusyTimeoutMs: item('plugin-config.is-busy-timeout', 750),
        DisableAntialiasing: item('plugin-config.disable-antialiasing', false),
        DisablePreserveDrawingBuffer: item('plugin-config.disable-preserve-drawing-buffer', false),
        PixelScale: item('plugin-config.pixel-scale', 1),
        PickScale: item('plugin-config.pick-scale', 0.25),
        EnableWboit: item('plugin-config.enable-wboit', true),
    },
    State: {
        DefaultServer: item('plugin-state.server', 'https://webchem.ncbr.muni.cz/molstar-state'),
        CurrentServer: item('plugin-state.server', 'https://webchem.ncbr.muni.cz/molstar-state'),
        HistoryCapacity: item('history-capacity.server', 5)
    },
    VolumeStreaming: {
        Enabled: item('volume-streaming.enabled', true),
        DefaultServer: item('volume-streaming.server', 'https://ds.litemol.org'),
        CanStream: item('volume-streaming.can-stream', function (s, plugin) {
            return s.models.length === 1 && _mol_model_structure__WEBPACK_IMPORTED_MODULE_0__["Model"].probablyHasDensityMap(s.models[0]);
        }),
        EmdbHeaderServer: item('volume-streaming.emdb-header-server', 'https://ftp.wwpdb.org/pub/emdb/structures'),
    },
    Viewport: {
        ShowExpand: item('viewer.show-expand-button', true),
        ShowControls: item('viewer.show-controls-button', true),
        ShowSettings: item('viewer.show-settings-button', true),
        ShowSelectionMode: item('viewer.show-selection-model-button', true),
        ShowAnimation: item('viewer.show-animation-button', true),
    },
    Download: {
        DefaultPdbProvider: item('download.default-pdb-provider', 'pdbe'),
        DefaultEmdbProvider: item('download.default-emdb-provider', 'pdbe'),
    },
    Structure: {
        SizeThresholds: item('structure.size-thresholds', _mol_model_structure__WEBPACK_IMPORTED_MODULE_0__["Structure"].DefaultSizeThresholds),
        DefaultRepresentationPresetParams: item('structure.default-representation-preset-params', {})
    }
};
var PluginConfigManager = /** @class */ (function () {
    function PluginConfigManager(initial) {
        var _this = this;
        this._config = new Map();
        if (!initial)
            return;
        initial.forEach(function (_a) {
            var k = _a[0], v = _a[1];
            return _this._config.set(k, v);
        });
    }
    PluginConfigManager.prototype.get = function (key) {
        if (!this._config.has(key))
            return key.defaultValue;
        return this._config.get(key);
    };
    PluginConfigManager.prototype.set = function (key, value) {
        this._config.set(key, value);
    };
    PluginConfigManager.prototype.delete = function (key) {
        this._config.delete(key);
    };
    return PluginConfigManager;
}());

//# sourceMappingURL=config.js.map

/***/ }),

/***/ "./lib/mol-plugin/context.js":
/*!***********************************!*\
  !*** ./lib/mol-plugin/context.js ***!
  \***********************************/
/*! exports provided: PluginContext */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "PluginContext", function() { return PluginContext; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var immer__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! immer */ "./node_modules/immer/dist/immer.esm.js");
/* harmony import */ var immutable__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! immutable */ "./node_modules/immutable/dist/immutable.js");
/* harmony import */ var immutable__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(immutable__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var rxjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! rxjs */ "./node_modules/rxjs/_esm5/index.js");
/* harmony import */ var _mol_canvas3d_canvas3d__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../mol-canvas3d/canvas3d */ "./lib/mol-canvas3d/canvas3d.js");
/* harmony import */ var _mol_model_props_common_custom_property__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../mol-model-props/common/custom-property */ "./lib/mol-model-props/common/custom-property.js");
/* harmony import */ var _mol_plugin_state_builder_data__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../mol-plugin-state/builder/data */ "./lib/mol-plugin-state/builder/data.js");
/* harmony import */ var _mol_plugin_state_builder_structure__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../mol-plugin-state/builder/structure */ "./lib/mol-plugin-state/builder/structure.js");
/* harmony import */ var _mol_plugin_state_formats_registry__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ../mol-plugin-state/formats/registry */ "./lib/mol-plugin-state/formats/registry.js");
/* harmony import */ var _mol_plugin_state_helpers_structure_selection_query__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ../mol-plugin-state/helpers/structure-selection-query */ "./lib/mol-plugin-state/helpers/structure-selection-query.js");
/* harmony import */ var _mol_plugin_state_manager_camera__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ../mol-plugin-state/manager/camera */ "./lib/mol-plugin-state/manager/camera.js");
/* harmony import */ var _mol_plugin_state_manager_interactivity__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ../mol-plugin-state/manager/interactivity */ "./lib/mol-plugin-state/manager/interactivity.js");
/* harmony import */ var _mol_plugin_state_manager_loci_label__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! ../mol-plugin-state/manager/loci-label */ "./lib/mol-plugin-state/manager/loci-label.js");
/* harmony import */ var _mol_plugin_state_manager_structure_component__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! ../mol-plugin-state/manager/structure/component */ "./lib/mol-plugin-state/manager/structure/component.js");
/* harmony import */ var _mol_plugin_state_manager_structure_focus__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! ../mol-plugin-state/manager/structure/focus */ "./lib/mol-plugin-state/manager/structure/focus.js");
/* harmony import */ var _mol_plugin_state_manager_structure_hierarchy__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! ../mol-plugin-state/manager/structure/hierarchy */ "./lib/mol-plugin-state/manager/structure/hierarchy.js");
/* harmony import */ var _mol_plugin_state_manager_structure_measurement__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(/*! ../mol-plugin-state/manager/structure/measurement */ "./lib/mol-plugin-state/manager/structure/measurement.js");
/* harmony import */ var _mol_plugin_state_manager_structure_selection__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(/*! ../mol-plugin-state/manager/structure/selection */ "./lib/mol-plugin-state/manager/structure/selection.js");
/* harmony import */ var _mol_repr_representation__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(/*! ../mol-repr/representation */ "./lib/mol-repr/representation.js");
/* harmony import */ var _mol_repr_structure_registry__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(/*! ../mol-repr/structure/registry */ "./lib/mol-repr/structure/registry.js");
/* harmony import */ var _mol_repr_volume_registry__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(/*! ../mol-repr/volume/registry */ "./lib/mol-repr/volume/registry.js");
/* harmony import */ var _mol_state__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(/*! ../mol-state */ "./lib/mol-state/index.js");
/* harmony import */ var _mol_task__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(/*! ../mol-task */ "./lib/mol-task/index.js");
/* harmony import */ var _mol_theme_color__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(/*! ../mol-theme/color */ "./lib/mol-theme/color.js");
/* harmony import */ var _mol_theme_size__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(/*! ../mol-theme/size */ "./lib/mol-theme/size.js");
/* harmony import */ var _mol_util_color__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__(/*! ../mol-util/color */ "./lib/mol-util/color/index.js");
/* harmony import */ var _mol_util_data_source__WEBPACK_IMPORTED_MODULE_26__ = __webpack_require__(/*! ../mol-util/data-source */ "./lib/mol-util/data-source.js");
/* harmony import */ var _mol_util_debug__WEBPACK_IMPORTED_MODULE_27__ = __webpack_require__(/*! ../mol-util/debug */ "./lib/mol-util/debug.js");
/* harmony import */ var _mol_util_input_input_observer__WEBPACK_IMPORTED_MODULE_28__ = __webpack_require__(/*! ../mol-util/input/input-observer */ "./lib/mol-util/input/input-observer.js");
/* harmony import */ var _mol_util_log_entry__WEBPACK_IMPORTED_MODULE_29__ = __webpack_require__(/*! ../mol-util/log-entry */ "./lib/mol-util/log-entry.js");
/* harmony import */ var _mol_util_rx_event_helper__WEBPACK_IMPORTED_MODULE_30__ = __webpack_require__(/*! ../mol-util/rx-event-helper */ "./lib/mol-util/rx-event-helper.js");
/* harmony import */ var _behavior__WEBPACK_IMPORTED_MODULE_31__ = __webpack_require__(/*! ./behavior */ "./lib/mol-plugin/behavior.js");
/* harmony import */ var _behavior_behavior__WEBPACK_IMPORTED_MODULE_32__ = __webpack_require__(/*! ./behavior/behavior */ "./lib/mol-plugin/behavior/behavior.js");
/* harmony import */ var _command__WEBPACK_IMPORTED_MODULE_33__ = __webpack_require__(/*! ./command */ "./lib/mol-plugin/command.js");
/* harmony import */ var _commands__WEBPACK_IMPORTED_MODULE_34__ = __webpack_require__(/*! ./commands */ "./lib/mol-plugin/commands.js");
/* harmony import */ var _config__WEBPACK_IMPORTED_MODULE_35__ = __webpack_require__(/*! ./config */ "./lib/mol-plugin/config.js");
/* harmony import */ var _layout__WEBPACK_IMPORTED_MODULE_36__ = __webpack_require__(/*! ./layout */ "./lib/mol-plugin/layout.js");
/* harmony import */ var _state__WEBPACK_IMPORTED_MODULE_37__ = __webpack_require__(/*! ./state */ "./lib/mol-plugin/state.js");
/* harmony import */ var _util_substructure_parent_helper__WEBPACK_IMPORTED_MODULE_38__ = __webpack_require__(/*! ./util/substructure-parent-helper */ "./lib/mol-plugin/util/substructure-parent-helper.js");
/* harmony import */ var _util_task_manager__WEBPACK_IMPORTED_MODULE_39__ = __webpack_require__(/*! ./util/task-manager */ "./lib/mol-plugin/util/task-manager.js");
/* harmony import */ var _util_toast__WEBPACK_IMPORTED_MODULE_40__ = __webpack_require__(/*! ./util/toast */ "./lib/mol-plugin/util/toast.js");
/* harmony import */ var _util_viewport_screenshot__WEBPACK_IMPORTED_MODULE_41__ = __webpack_require__(/*! ./util/viewport-screenshot */ "./lib/mol-plugin/util/viewport-screenshot.js");
/* harmony import */ var _version__WEBPACK_IMPORTED_MODULE_42__ = __webpack_require__(/*! ./version */ "./lib/mol-plugin/version.js");
/* harmony import */ var _mol_util_assets__WEBPACK_IMPORTED_MODULE_43__ = __webpack_require__(/*! ../mol-util/assets */ "./lib/mol-util/assets.js");
/* harmony import */ var _mol_plugin_state_manager_snapshots__WEBPACK_IMPORTED_MODULE_44__ = __webpack_require__(/*! ../mol-plugin-state/manager/snapshots */ "./lib/mol-plugin-state/manager/snapshots.js");
/* harmony import */ var _mol_plugin_state_manager_animation__WEBPACK_IMPORTED_MODULE_45__ = __webpack_require__(/*! ../mol-plugin-state/manager/animation */ "./lib/mol-plugin-state/manager/animation.js");
/* harmony import */ var _mol_util_object__WEBPACK_IMPORTED_MODULE_46__ = __webpack_require__(/*! ../mol-util/object */ "./lib/mol-util/object.js");
/* harmony import */ var _mol_plugin_state_manager_volume_hierarchy__WEBPACK_IMPORTED_MODULE_47__ = __webpack_require__(/*! ../mol-plugin-state/manager/volume/hierarchy */ "./lib/mol-plugin-state/manager/volume/hierarchy.js");
/* harmony import */ var rxjs_operators__WEBPACK_IMPORTED_MODULE_48__ = __webpack_require__(/*! rxjs/operators */ "./node_modules/rxjs/_esm5/operators/index.js");
/* harmony import */ var _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_49__ = __webpack_require__(/*! ../mol-math/linear-algebra */ "./lib/mol-math/linear-algebra.js");
/* harmony import */ var _animation_loop__WEBPACK_IMPORTED_MODULE_50__ = __webpack_require__(/*! ./animation-loop */ "./lib/mol-plugin/animation-loop.js");
/* harmony import */ var _mol_canvas3d_util__WEBPACK_IMPORTED_MODULE_51__ = __webpack_require__(/*! ../mol-canvas3d/util */ "./lib/mol-canvas3d/util.js");
/**
 * Copyright (c) 2018-2021 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author David Sehnal <david.sehnal@gmail.com>
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */




















































var PluginContext = /** @class */ (function () {
    function PluginContext(spec) {
        var _this = this;
        this.spec = spec;
        this.runTask = function (task, params) { return _this.managers.task.run(task, params); };
        this.resolveTask = function (object) {
            if (!object)
                return void 0;
            if (_mol_task__WEBPACK_IMPORTED_MODULE_22__["Task"].is(object))
                return _this.runTask(object);
            return object;
        };
        this.subs = [];
        this.disposed = false;
        this.ev = _mol_util_rx_event_helper__WEBPACK_IMPORTED_MODULE_30__["RxEventHelper"].create();
        this.config = new _config__WEBPACK_IMPORTED_MODULE_35__["PluginConfigManager"](this.spec.config); // needed to init state
        this.state = new _state__WEBPACK_IMPORTED_MODULE_37__["PluginState"](this);
        this.commands = new _command__WEBPACK_IMPORTED_MODULE_33__["PluginCommandManager"]();
        this.canvas3dInit = this.ev.behavior(false);
        this.behaviors = {
            state: {
                isAnimating: this.ev.behavior(false),
                isUpdating: this.ev.behavior(false),
                // TODO: should there be separate "updated" event?
                //   Often, this is used to indicate that the state has updated
                //   and it might not be the best way to react to state updates.
                isBusy: this.ev.behavior(false)
            },
            interaction: {
                hover: this.ev.behavior({ current: _mol_repr_representation__WEBPACK_IMPORTED_MODULE_18__["Representation"].Loci.Empty, modifiers: _mol_util_input_input_observer__WEBPACK_IMPORTED_MODULE_28__["ModifiersKeys"].None, buttons: 0, button: 0 }),
                click: this.ev.behavior({ current: _mol_repr_representation__WEBPACK_IMPORTED_MODULE_18__["Representation"].Loci.Empty, modifiers: _mol_util_input_input_observer__WEBPACK_IMPORTED_MODULE_28__["ModifiersKeys"].None, buttons: 0, button: 0 }),
                drag: this.ev.behavior({ current: _mol_repr_representation__WEBPACK_IMPORTED_MODULE_18__["Representation"].Loci.Empty, modifiers: _mol_util_input_input_observer__WEBPACK_IMPORTED_MODULE_28__["ModifiersKeys"].None, buttons: 0, button: 0, pageStart: Object(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_49__["Vec2"])(), pageEnd: Object(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_49__["Vec2"])() }),
                selectionMode: this.ev.behavior(false)
            },
            labels: {
                highlight: this.ev.behavior({ labels: [] })
            },
            layout: {
                leftPanelTabName: this.ev.behavior('root')
            },
            canvas3d: {
                initialized: this.canvas3dInit.pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_48__["filter"])(function (v) { return !!v; }), Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_48__["take"])(1))
            }
        };
        this.animationLoop = new _animation_loop__WEBPACK_IMPORTED_MODULE_50__["PluginAnimationLoop"](this);
        this.layout = new _layout__WEBPACK_IMPORTED_MODULE_36__["PluginLayout"](this);
        this.representation = {
            structure: {
                registry: new _mol_repr_structure_registry__WEBPACK_IMPORTED_MODULE_19__["StructureRepresentationRegistry"](),
                themes: { colorThemeRegistry: _mol_theme_color__WEBPACK_IMPORTED_MODULE_23__["ColorTheme"].createRegistry(), sizeThemeRegistry: _mol_theme_size__WEBPACK_IMPORTED_MODULE_24__["SizeTheme"].createRegistry() },
            },
            volume: {
                registry: new _mol_repr_volume_registry__WEBPACK_IMPORTED_MODULE_20__["VolumeRepresentationRegistry"](),
                themes: { colorThemeRegistry: _mol_theme_color__WEBPACK_IMPORTED_MODULE_23__["ColorTheme"].createRegistry(), sizeThemeRegistry: _mol_theme_size__WEBPACK_IMPORTED_MODULE_24__["SizeTheme"].createRegistry() }
            }
        };
        this.query = {
            structure: {
                registry: new _mol_plugin_state_helpers_structure_selection_query__WEBPACK_IMPORTED_MODULE_9__["StructureSelectionQueryRegistry"]()
            }
        };
        this.dataFormats = new _mol_plugin_state_formats_registry__WEBPACK_IMPORTED_MODULE_8__["DataFormatRegistry"]();
        this.builders = {
            data: new _mol_plugin_state_builder_data__WEBPACK_IMPORTED_MODULE_6__["DataBuilder"](this),
            structure: void 0
        };
        this.helpers = {
            substructureParent: new _util_substructure_parent_helper__WEBPACK_IMPORTED_MODULE_38__["SubstructureParentHelper"](this),
            viewportScreenshot: void 0
        };
        this.managers = {
            structure: {
                hierarchy: new _mol_plugin_state_manager_structure_hierarchy__WEBPACK_IMPORTED_MODULE_15__["StructureHierarchyManager"](this),
                component: new _mol_plugin_state_manager_structure_component__WEBPACK_IMPORTED_MODULE_13__["StructureComponentManager"](this),
                measurement: new _mol_plugin_state_manager_structure_measurement__WEBPACK_IMPORTED_MODULE_16__["StructureMeasurementManager"](this),
                selection: new _mol_plugin_state_manager_structure_selection__WEBPACK_IMPORTED_MODULE_17__["StructureSelectionManager"](this),
                focus: new _mol_plugin_state_manager_structure_focus__WEBPACK_IMPORTED_MODULE_14__["StructureFocusManager"](this),
            },
            volume: {
                hierarchy: new _mol_plugin_state_manager_volume_hierarchy__WEBPACK_IMPORTED_MODULE_47__["VolumeHierarchyManager"](this)
            },
            interactivity: void 0,
            camera: new _mol_plugin_state_manager_camera__WEBPACK_IMPORTED_MODULE_10__["CameraManager"](this),
            animation: new _mol_plugin_state_manager_animation__WEBPACK_IMPORTED_MODULE_45__["PluginAnimationManager"](this),
            snapshot: new _mol_plugin_state_manager_snapshots__WEBPACK_IMPORTED_MODULE_44__["PluginStateSnapshotManager"](this),
            lociLabels: void 0,
            toast: new _util_toast__WEBPACK_IMPORTED_MODULE_40__["PluginToastManager"](this),
            asset: new _mol_util_assets__WEBPACK_IMPORTED_MODULE_43__["AssetManager"](),
            task: new _util_task_manager__WEBPACK_IMPORTED_MODULE_39__["TaskManager"]()
        };
        this.events = {
            log: this.ev(),
            task: this.managers.task.events,
            canvas3d: {
                settingsUpdated: this.ev(),
            }
        };
        this.customModelProperties = new _mol_model_props_common_custom_property__WEBPACK_IMPORTED_MODULE_5__["CustomProperty"].Registry();
        this.customStructureProperties = new _mol_model_props_common_custom_property__WEBPACK_IMPORTED_MODULE_5__["CustomProperty"].Registry();
        this.customParamEditors = new Map();
        this.customStructureControls = new Map();
        this.genericRepresentationControls = new Map();
        /**
         * Used to store application specific custom state which is then available
         * to State Actions and similar constructs via the PluginContext.
         */
        this.customState = Object.create(null);
        this.log = {
            entries: Object(immutable__WEBPACK_IMPORTED_MODULE_2__["List"])(),
            entry: function (e) { return _this.events.log.next(e); },
            error: function (msg) { return _this.events.log.next(_mol_util_log_entry__WEBPACK_IMPORTED_MODULE_29__["LogEntry"].error(msg)); },
            message: function (msg) { return _this.events.log.next(_mol_util_log_entry__WEBPACK_IMPORTED_MODULE_29__["LogEntry"].message(msg)); },
            info: function (msg) { return _this.events.log.next(_mol_util_log_entry__WEBPACK_IMPORTED_MODULE_29__["LogEntry"].info(msg)); },
            warn: function (msg) { return _this.events.log.next(_mol_util_log_entry__WEBPACK_IMPORTED_MODULE_29__["LogEntry"].warning(msg)); },
        };
        /**
         * This should be used in all transform related request so that it could be "spoofed" to allow
         * "static" access to resources.
         */
        this.fetch = _mol_util_data_source__WEBPACK_IMPORTED_MODULE_26__["ajaxGet"];
        // the reason for this is that sometimes, transform params get modified inline (i.e. palette.valueLabel)
        // and freezing the params object causes "read-only exception"
        // TODO: is this the best place to do it?
        Object(immer__WEBPACK_IMPORTED_MODULE_1__["setAutoFreeze"])(false);
    }
    PluginContext.prototype.build = function () {
        return this.state.data.build();
    };
    PluginContext.prototype.initViewer = function (canvas, container) {
        var _this = this;
        var _a, _b, _c, _d, _e, _f, _g;
        try {
            this.layout.setRoot(container);
            if (this.spec.layout && this.spec.layout.initial)
                this.layout.setProps(this.spec.layout.initial);
            var antialias = !((_a = this.config.get(_config__WEBPACK_IMPORTED_MODULE_35__["PluginConfig"].General.DisableAntialiasing)) !== null && _a !== void 0 ? _a : false);
            var preserveDrawingBuffer = !((_b = this.config.get(_config__WEBPACK_IMPORTED_MODULE_35__["PluginConfig"].General.DisablePreserveDrawingBuffer)) !== null && _b !== void 0 ? _b : false);
            var pixelScale = this.config.get(_config__WEBPACK_IMPORTED_MODULE_35__["PluginConfig"].General.PixelScale) || 1;
            var pickScale = this.config.get(_config__WEBPACK_IMPORTED_MODULE_35__["PluginConfig"].General.PickScale) || 0.25;
            var enableWboit = this.config.get(_config__WEBPACK_IMPORTED_MODULE_35__["PluginConfig"].General.EnableWboit) || false;
            this.canvas3dContext = _mol_canvas3d_canvas3d__WEBPACK_IMPORTED_MODULE_4__["Canvas3DContext"].fromCanvas(canvas, { antialias: antialias, preserveDrawingBuffer: preserveDrawingBuffer, pixelScale: pixelScale, pickScale: pickScale, enableWboit: enableWboit });
            this.canvas3d = _mol_canvas3d_canvas3d__WEBPACK_IMPORTED_MODULE_4__["Canvas3D"].create(this.canvas3dContext);
            this.canvas3dInit.next(true);
            var props = (_d = (_c = this.spec.components) === null || _c === void 0 ? void 0 : _c.viewport) === null || _d === void 0 ? void 0 : _d.canvas3d;
            var backgroundColor_1 = Object(_mol_util_color__WEBPACK_IMPORTED_MODULE_25__["Color"])(0xFCFBF9);
            if (!props) {
                (_e = this.canvas3d) === null || _e === void 0 ? void 0 : _e.setProps({ renderer: { backgroundColor: backgroundColor_1 } });
            }
            else {
                if (((_f = props.renderer) === null || _f === void 0 ? void 0 : _f.backgroundColor) === void 0) {
                    props = Object(immer__WEBPACK_IMPORTED_MODULE_1__["default"])(props, function (p) {
                        if (p.renderer)
                            p.renderer.backgroundColor = backgroundColor_1;
                        else
                            p.renderer = { backgroundColor: backgroundColor_1 };
                    });
                }
                (_g = this.canvas3d) === null || _g === void 0 ? void 0 : _g.setProps(props);
            }
            this.animationLoop.start();
            this.helpers.viewportScreenshot = new _util_viewport_screenshot__WEBPACK_IMPORTED_MODULE_41__["ViewportScreenshotHelper"](this);
            this.subs.push(this.canvas3d.interaction.click.subscribe(function (e) { return _this.behaviors.interaction.click.next(e); }));
            this.subs.push(this.canvas3d.interaction.drag.subscribe(function (e) { return _this.behaviors.interaction.drag.next(e); }));
            this.subs.push(this.canvas3d.interaction.hover.subscribe(function (e) { return _this.behaviors.interaction.hover.next(e); }));
            this.subs.push(this.canvas3d.input.resize.subscribe(function () { return _this.handleResize(); }));
            this.subs.push(this.layout.events.updated.subscribe(function () { return requestAnimationFrame(function () { return _this.handleResize(); }); }));
            this.handleResize();
            return true;
        }
        catch (e) {
            this.log.error('' + e);
            console.error(e);
            return false;
        }
    };
    PluginContext.prototype.handleResize = function () {
        var _a, _b;
        var canvas = (_a = this.canvas3dContext) === null || _a === void 0 ? void 0 : _a.canvas;
        var container = this.layout.root;
        if (container && canvas) {
            var pixelScale = this.config.get(_config__WEBPACK_IMPORTED_MODULE_35__["PluginConfig"].General.PixelScale) || 1;
            Object(_mol_canvas3d_util__WEBPACK_IMPORTED_MODULE_51__["resizeCanvas"])(canvas, container, pixelScale);
            (_b = this.canvas3d) === null || _b === void 0 ? void 0 : _b.requestResize();
        }
    };
    Object.defineProperty(PluginContext.prototype, "isBusy", {
        /** return true is animating or updating */
        get: function () {
            return this.behaviors.state.isAnimating.value || this.behaviors.state.isUpdating.value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PluginContext.prototype, "selectionMode", {
        get: function () {
            return this.behaviors.interaction.selectionMode.value;
        },
        set: function (mode) {
            this.behaviors.interaction.selectionMode.next(mode);
        },
        enumerable: false,
        configurable: true
    });
    PluginContext.prototype.dataTransaction = function (f, options) {
        return this.runTask(this.state.data.transaction(f, options));
    };
    PluginContext.prototype.clear = function (resetViewportSettings) {
        var _a;
        if (resetViewportSettings === void 0) { resetViewportSettings = false; }
        if (resetViewportSettings)
            (_a = this.canvas3d) === null || _a === void 0 ? void 0 : _a.setProps(_mol_canvas3d_canvas3d__WEBPACK_IMPORTED_MODULE_4__["DefaultCanvas3DParams"]);
        return _commands__WEBPACK_IMPORTED_MODULE_34__["PluginCommands"].State.RemoveObject(this, { state: this.state.data, ref: _mol_state__WEBPACK_IMPORTED_MODULE_21__["StateTransform"].RootRef });
    };
    PluginContext.prototype.dispose = function (options) {
        var _a, _b;
        if (this.disposed)
            return;
        for (var _i = 0, _c = this.subs; _i < _c.length; _i++) {
            var s = _c[_i];
            s.unsubscribe();
        }
        this.subs = [];
        this.commands.dispose();
        (_a = this.canvas3d) === null || _a === void 0 ? void 0 : _a.dispose();
        (_b = this.canvas3dContext) === null || _b === void 0 ? void 0 : _b.dispose(options);
        this.ev.dispose();
        this.state.dispose();
        this.managers.task.dispose();
        this.layout.dispose();
        this.helpers.substructureParent.dispose();
        Object(_mol_util_object__WEBPACK_IMPORTED_MODULE_46__["objectForEach"])(this.managers, function (m) { var _a, _b; return (_b = (_a = m) === null || _a === void 0 ? void 0 : _a.dispose) === null || _b === void 0 ? void 0 : _b.call(_a); });
        Object(_mol_util_object__WEBPACK_IMPORTED_MODULE_46__["objectForEach"])(this.managers.structure, function (m) { var _a, _b; return (_b = (_a = m) === null || _a === void 0 ? void 0 : _a.dispose) === null || _b === void 0 ? void 0 : _b.call(_a); });
        this.disposed = true;
    };
    PluginContext.prototype.initBehaviorEvents = function () {
        var _this = this;
        this.subs.push(Object(rxjs__WEBPACK_IMPORTED_MODULE_3__["merge"])(this.state.data.behaviors.isUpdating, this.state.behaviors.behaviors.isUpdating).subscribe(function (u) {
            if (_this.behaviors.state.isUpdating.value !== u)
                _this.behaviors.state.isUpdating.next(u);
        }));
        var timeoutMs = this.config.get(_config__WEBPACK_IMPORTED_MODULE_35__["PluginConfig"].General.IsBusyTimeoutMs) || 750;
        var isBusy = this.behaviors.state.isBusy;
        var timeout = void 0;
        var setBusy = function () {
            if (!isBusy.value)
                isBusy.next(true);
        };
        var reset = function () {
            if (timeout !== void 0)
                clearTimeout(timeout);
            timeout = void 0;
        };
        this.subs.push(Object(rxjs__WEBPACK_IMPORTED_MODULE_3__["merge"])(this.behaviors.state.isUpdating, this.behaviors.state.isAnimating).subscribe(function (v) {
            var isUpdating = _this.behaviors.state.isUpdating.value;
            var isAnimating = _this.behaviors.state.isAnimating.value;
            if (isUpdating || isAnimating) {
                if (!isBusy.value) {
                    reset();
                    timeout = setTimeout(setBusy, timeoutMs);
                }
            }
            else {
                reset();
                isBusy.next(false);
            }
        }));
        this.subs.push(this.behaviors.interaction.selectionMode.subscribe(function (v) {
            var _a;
            if (!v) {
                (_a = _this.managers.interactivity) === null || _a === void 0 ? void 0 : _a.lociSelects.deselectAll();
            }
        }));
    };
    PluginContext.prototype.initBuiltInBehavior = function () {
        var _this = this;
        _behavior__WEBPACK_IMPORTED_MODULE_31__["BuiltInPluginBehaviors"].State.registerDefault(this);
        _behavior__WEBPACK_IMPORTED_MODULE_31__["BuiltInPluginBehaviors"].Representation.registerDefault(this);
        _behavior__WEBPACK_IMPORTED_MODULE_31__["BuiltInPluginBehaviors"].Camera.registerDefault(this);
        _behavior__WEBPACK_IMPORTED_MODULE_31__["BuiltInPluginBehaviors"].Misc.registerDefault(this);
        this.subs.push(Object(rxjs__WEBPACK_IMPORTED_MODULE_3__["merge"])(this.state.data.events.log, this.state.behaviors.events.log).subscribe(function (e) { return _this.events.log.next(e); }));
    };
    PluginContext.prototype.initBehaviors = function () {
        return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"])(this, void 0, void 0, function () {
            var tree, _i, _a, cat, _b, _c, b, cat, _d, _e, b, cat;
            return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__generator"])(this, function (_f) {
                switch (_f.label) {
                    case 0:
                        tree = this.state.behaviors.build();
                        for (_i = 0, _a = Object.keys(_behavior_behavior__WEBPACK_IMPORTED_MODULE_32__["PluginBehavior"].Categories); _i < _a.length; _i++) {
                            cat = _a[_i];
                            tree.toRoot().apply(_behavior_behavior__WEBPACK_IMPORTED_MODULE_32__["PluginBehavior"].CreateCategory, { label: _behavior_behavior__WEBPACK_IMPORTED_MODULE_32__["PluginBehavior"].Categories[cat] }, { ref: cat, state: { isLocked: true } });
                        }
                        // Init custom properties 1st
                        for (_b = 0, _c = this.spec.behaviors; _b < _c.length; _b++) {
                            b = _c[_b];
                            cat = _behavior_behavior__WEBPACK_IMPORTED_MODULE_32__["PluginBehavior"].getCategoryId(b.transformer);
                            if (cat !== 'custom-props')
                                continue;
                            tree.to(_behavior_behavior__WEBPACK_IMPORTED_MODULE_32__["PluginBehavior"].getCategoryId(b.transformer)).apply(b.transformer, b.defaultParams, { ref: b.transformer.id });
                        }
                        return [4 /*yield*/, this.runTask(this.state.behaviors.updateTree(tree, { doNotUpdateCurrent: true, doNotLogTiming: true }))];
                    case 1:
                        _f.sent();
                        tree = this.state.behaviors.build();
                        for (_d = 0, _e = this.spec.behaviors; _d < _e.length; _d++) {
                            b = _e[_d];
                            cat = _behavior_behavior__WEBPACK_IMPORTED_MODULE_32__["PluginBehavior"].getCategoryId(b.transformer);
                            if (cat === 'custom-props')
                                continue;
                            tree.to(_behavior_behavior__WEBPACK_IMPORTED_MODULE_32__["PluginBehavior"].getCategoryId(b.transformer)).apply(b.transformer, b.defaultParams, { ref: b.transformer.id });
                        }
                        return [4 /*yield*/, this.runTask(this.state.behaviors.updateTree(tree, { doNotUpdateCurrent: true, doNotLogTiming: true }))];
                    case 2:
                        _f.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    PluginContext.prototype.initCustomFormats = function () {
        if (!this.spec.customFormats)
            return;
        for (var _i = 0, _a = this.spec.customFormats; _i < _a.length; _i++) {
            var f = _a[_i];
            this.dataFormats.add(f[0], f[1]);
        }
    };
    PluginContext.prototype.initDataActions = function () {
        for (var _i = 0, _a = this.spec.actions; _i < _a.length; _i++) {
            var a = _a[_i];
            this.state.data.actions.add(a.action);
        }
    };
    PluginContext.prototype.initAnimations = function () {
        if (!this.spec.animations)
            return;
        for (var _i = 0, _a = this.spec.animations; _i < _a.length; _i++) {
            var anim = _a[_i];
            this.managers.animation.register(anim);
        }
    };
    PluginContext.prototype.initCustomParamEditors = function () {
        if (!this.spec.customParamEditors)
            return;
        for (var _i = 0, _a = this.spec.customParamEditors; _i < _a.length; _i++) {
            var _b = _a[_i], t = _b[0], e = _b[1];
            this.customParamEditors.set(t.id, e);
        }
    };
    PluginContext.prototype.init = function () {
        return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"])(this, void 0, void 0, function () {
            var _this = this;
            return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__generator"])(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.subs.push(this.events.log.subscribe(function (e) { return _this.log.entries = _this.log.entries.push(e); }));
                        this.initCustomFormats();
                        this.initBehaviorEvents();
                        this.initBuiltInBehavior();
                        this.managers.interactivity = new _mol_plugin_state_manager_interactivity__WEBPACK_IMPORTED_MODULE_11__["InteractivityManager"](this);
                        this.managers.lociLabels = new _mol_plugin_state_manager_loci_label__WEBPACK_IMPORTED_MODULE_12__["LociLabelManager"](this);
                        this.builders.structure = new _mol_plugin_state_builder_structure__WEBPACK_IMPORTED_MODULE_7__["StructureBuilder"](this);
                        this.initDataActions();
                        this.initAnimations();
                        this.initCustomParamEditors();
                        return [4 /*yield*/, this.initBehaviors()];
                    case 1:
                        _a.sent();
                        this.log.message("Mol* Plugin " + _version__WEBPACK_IMPORTED_MODULE_42__["PLUGIN_VERSION"] + " [" + _version__WEBPACK_IMPORTED_MODULE_42__["PLUGIN_VERSION_DATE"].toLocaleString() + "]");
                        if (!_mol_util_debug__WEBPACK_IMPORTED_MODULE_27__["isProductionMode"])
                            this.log.message("Development mode enabled");
                        if (_mol_util_debug__WEBPACK_IMPORTED_MODULE_27__["isDebugMode"])
                            this.log.message("Debug mode enabled");
                        return [2 /*return*/];
                }
            });
        });
    };
    return PluginContext;
}());

//# sourceMappingURL=context.js.map

/***/ }),

/***/ "./lib/mol-plugin/index.js":
/*!*********************************!*\
  !*** ./lib/mol-plugin/index.js ***!
  \*********************************/
/*! exports provided: DefaultPluginSpec, createPlugin, createPluginAsync */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DefaultPluginSpec", function() { return DefaultPluginSpec; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createPlugin", function() { return createPlugin; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createPluginAsync", function() { return createPluginAsync; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! react */ "./node_modules/react/index.js");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react_dom__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! react-dom */ "./node_modules/react-dom/index.js");
/* harmony import */ var react_dom__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(react_dom__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _mol_plugin_state_actions__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../mol-plugin-state/actions */ "./lib/mol-plugin-state/actions.js");
/* harmony import */ var _mol_plugin_state_transforms__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../mol-plugin-state/transforms */ "./lib/mol-plugin-state/transforms.js");
/* harmony import */ var _mol_plugin_ui_custom_volume__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../mol-plugin-ui/custom/volume */ "./lib/mol-plugin-ui/custom/volume.js");
/* harmony import */ var _mol_plugin_ui_plugin__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../mol-plugin-ui/plugin */ "./lib/mol-plugin-ui/plugin.js");
/* harmony import */ var _behavior__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ./behavior */ "./lib/mol-plugin/behavior.js");
/* harmony import */ var _behavior_dynamic_selection_structure_focus_representation__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ./behavior/dynamic/selection/structure-focus-representation */ "./lib/mol-plugin/behavior/dynamic/selection/structure-focus-representation.js");
/* harmony import */ var _behavior_dynamic_volume_streaming_transformers__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ./behavior/dynamic/volume-streaming/transformers */ "./lib/mol-plugin/behavior/dynamic/volume-streaming/transformers.js");
/* harmony import */ var _context__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ./context */ "./lib/mol-plugin/context.js");
/* harmony import */ var _spec__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ./spec */ "./lib/mol-plugin/spec.js");
/* harmony import */ var _mol_plugin_state_actions_volume__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! ../mol-plugin-state/actions/volume */ "./lib/mol-plugin-state/actions/volume.js");
/* harmony import */ var _mol_plugin_state_animation_built_in_model_index__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! ../mol-plugin-state/animation/built-in/model-index */ "./lib/mol-plugin-state/animation/built-in/model-index.js");
/* harmony import */ var _mol_plugin_state_animation_built_in_assembly_unwind__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! ../mol-plugin-state/animation/built-in/assembly-unwind */ "./lib/mol-plugin-state/animation/built-in/assembly-unwind.js");
/* harmony import */ var _mol_plugin_state_animation_built_in_camera_spin__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! ../mol-plugin-state/animation/built-in/camera-spin */ "./lib/mol-plugin-state/animation/built-in/camera-spin.js");
/* harmony import */ var _mol_plugin_state_animation_built_in_state_snapshots__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(/*! ../mol-plugin-state/animation/built-in/state-snapshots */ "./lib/mol-plugin-state/animation/built-in/state-snapshots.js");
/**
 * Copyright (c) 2018-2020 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author David Sehnal <david.sehnal@gmail.com>
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */

















var DefaultPluginSpec = {
    actions: [
        _spec__WEBPACK_IMPORTED_MODULE_11__["PluginSpec"].Action(_mol_plugin_state_actions__WEBPACK_IMPORTED_MODULE_3__["StateActions"].Structure.DownloadStructure),
        _spec__WEBPACK_IMPORTED_MODULE_11__["PluginSpec"].Action(_mol_plugin_state_actions__WEBPACK_IMPORTED_MODULE_3__["StateActions"].Structure.AddTrajectory),
        _spec__WEBPACK_IMPORTED_MODULE_11__["PluginSpec"].Action(_mol_plugin_state_actions__WEBPACK_IMPORTED_MODULE_3__["StateActions"].Volume.DownloadDensity),
        _spec__WEBPACK_IMPORTED_MODULE_11__["PluginSpec"].Action(_mol_plugin_state_actions__WEBPACK_IMPORTED_MODULE_3__["StateActions"].DataFormat.DownloadFile),
        _spec__WEBPACK_IMPORTED_MODULE_11__["PluginSpec"].Action(_mol_plugin_state_actions__WEBPACK_IMPORTED_MODULE_3__["StateActions"].DataFormat.OpenFiles),
        _spec__WEBPACK_IMPORTED_MODULE_11__["PluginSpec"].Action(_mol_plugin_state_actions__WEBPACK_IMPORTED_MODULE_3__["StateActions"].Structure.EnableModelCustomProps),
        _spec__WEBPACK_IMPORTED_MODULE_11__["PluginSpec"].Action(_mol_plugin_state_actions__WEBPACK_IMPORTED_MODULE_3__["StateActions"].Structure.EnableStructureCustomProps),
        // Volume streaming
        _spec__WEBPACK_IMPORTED_MODULE_11__["PluginSpec"].Action(_behavior_dynamic_volume_streaming_transformers__WEBPACK_IMPORTED_MODULE_9__["InitVolumeStreaming"]),
        _spec__WEBPACK_IMPORTED_MODULE_11__["PluginSpec"].Action(_behavior_dynamic_volume_streaming_transformers__WEBPACK_IMPORTED_MODULE_9__["BoxifyVolumeStreaming"]),
        _spec__WEBPACK_IMPORTED_MODULE_11__["PluginSpec"].Action(_behavior_dynamic_volume_streaming_transformers__WEBPACK_IMPORTED_MODULE_9__["CreateVolumeStreamingBehavior"]),
        _spec__WEBPACK_IMPORTED_MODULE_11__["PluginSpec"].Action(_mol_plugin_state_transforms__WEBPACK_IMPORTED_MODULE_4__["StateTransforms"].Data.Download),
        _spec__WEBPACK_IMPORTED_MODULE_11__["PluginSpec"].Action(_mol_plugin_state_transforms__WEBPACK_IMPORTED_MODULE_4__["StateTransforms"].Data.ParseCif),
        _spec__WEBPACK_IMPORTED_MODULE_11__["PluginSpec"].Action(_mol_plugin_state_transforms__WEBPACK_IMPORTED_MODULE_4__["StateTransforms"].Data.ParseCcp4),
        _spec__WEBPACK_IMPORTED_MODULE_11__["PluginSpec"].Action(_mol_plugin_state_transforms__WEBPACK_IMPORTED_MODULE_4__["StateTransforms"].Data.ParseDsn6),
        _spec__WEBPACK_IMPORTED_MODULE_11__["PluginSpec"].Action(_mol_plugin_state_transforms__WEBPACK_IMPORTED_MODULE_4__["StateTransforms"].Model.TrajectoryFromMmCif),
        _spec__WEBPACK_IMPORTED_MODULE_11__["PluginSpec"].Action(_mol_plugin_state_transforms__WEBPACK_IMPORTED_MODULE_4__["StateTransforms"].Model.TrajectoryFromCifCore),
        _spec__WEBPACK_IMPORTED_MODULE_11__["PluginSpec"].Action(_mol_plugin_state_transforms__WEBPACK_IMPORTED_MODULE_4__["StateTransforms"].Model.TrajectoryFromPDB),
        _spec__WEBPACK_IMPORTED_MODULE_11__["PluginSpec"].Action(_mol_plugin_state_transforms__WEBPACK_IMPORTED_MODULE_4__["StateTransforms"].Model.TransformStructureConformation),
        _spec__WEBPACK_IMPORTED_MODULE_11__["PluginSpec"].Action(_mol_plugin_state_transforms__WEBPACK_IMPORTED_MODULE_4__["StateTransforms"].Model.StructureFromModel),
        _spec__WEBPACK_IMPORTED_MODULE_11__["PluginSpec"].Action(_mol_plugin_state_transforms__WEBPACK_IMPORTED_MODULE_4__["StateTransforms"].Model.StructureFromTrajectory),
        _spec__WEBPACK_IMPORTED_MODULE_11__["PluginSpec"].Action(_mol_plugin_state_transforms__WEBPACK_IMPORTED_MODULE_4__["StateTransforms"].Model.ModelFromTrajectory),
        _spec__WEBPACK_IMPORTED_MODULE_11__["PluginSpec"].Action(_mol_plugin_state_transforms__WEBPACK_IMPORTED_MODULE_4__["StateTransforms"].Model.StructureSelectionFromScript),
        _spec__WEBPACK_IMPORTED_MODULE_11__["PluginSpec"].Action(_mol_plugin_state_transforms__WEBPACK_IMPORTED_MODULE_4__["StateTransforms"].Representation.StructureRepresentation3D),
        _spec__WEBPACK_IMPORTED_MODULE_11__["PluginSpec"].Action(_mol_plugin_state_transforms__WEBPACK_IMPORTED_MODULE_4__["StateTransforms"].Representation.StructureSelectionsDistance3D),
        _spec__WEBPACK_IMPORTED_MODULE_11__["PluginSpec"].Action(_mol_plugin_state_transforms__WEBPACK_IMPORTED_MODULE_4__["StateTransforms"].Representation.StructureSelectionsAngle3D),
        _spec__WEBPACK_IMPORTED_MODULE_11__["PluginSpec"].Action(_mol_plugin_state_transforms__WEBPACK_IMPORTED_MODULE_4__["StateTransforms"].Representation.StructureSelectionsDihedral3D),
        _spec__WEBPACK_IMPORTED_MODULE_11__["PluginSpec"].Action(_mol_plugin_state_transforms__WEBPACK_IMPORTED_MODULE_4__["StateTransforms"].Representation.StructureSelectionsLabel3D),
        _spec__WEBPACK_IMPORTED_MODULE_11__["PluginSpec"].Action(_mol_plugin_state_transforms__WEBPACK_IMPORTED_MODULE_4__["StateTransforms"].Representation.StructureSelectionsOrientation3D),
        _spec__WEBPACK_IMPORTED_MODULE_11__["PluginSpec"].Action(_mol_plugin_state_transforms__WEBPACK_IMPORTED_MODULE_4__["StateTransforms"].Representation.ModelUnitcell3D),
        _spec__WEBPACK_IMPORTED_MODULE_11__["PluginSpec"].Action(_mol_plugin_state_transforms__WEBPACK_IMPORTED_MODULE_4__["StateTransforms"].Representation.ExplodeStructureRepresentation3D),
        _spec__WEBPACK_IMPORTED_MODULE_11__["PluginSpec"].Action(_mol_plugin_state_transforms__WEBPACK_IMPORTED_MODULE_4__["StateTransforms"].Representation.UnwindStructureAssemblyRepresentation3D),
        _spec__WEBPACK_IMPORTED_MODULE_11__["PluginSpec"].Action(_mol_plugin_state_transforms__WEBPACK_IMPORTED_MODULE_4__["StateTransforms"].Representation.OverpaintStructureRepresentation3DFromScript),
        _spec__WEBPACK_IMPORTED_MODULE_11__["PluginSpec"].Action(_mol_plugin_state_transforms__WEBPACK_IMPORTED_MODULE_4__["StateTransforms"].Representation.TransparencyStructureRepresentation3DFromScript),
        _spec__WEBPACK_IMPORTED_MODULE_11__["PluginSpec"].Action(_mol_plugin_state_actions_volume__WEBPACK_IMPORTED_MODULE_12__["AssignColorVolume"]),
        _spec__WEBPACK_IMPORTED_MODULE_11__["PluginSpec"].Action(_mol_plugin_state_transforms__WEBPACK_IMPORTED_MODULE_4__["StateTransforms"].Volume.VolumeFromCcp4),
        _spec__WEBPACK_IMPORTED_MODULE_11__["PluginSpec"].Action(_mol_plugin_state_transforms__WEBPACK_IMPORTED_MODULE_4__["StateTransforms"].Volume.VolumeFromDsn6),
        _spec__WEBPACK_IMPORTED_MODULE_11__["PluginSpec"].Action(_mol_plugin_state_transforms__WEBPACK_IMPORTED_MODULE_4__["StateTransforms"].Volume.VolumeFromCube),
        _spec__WEBPACK_IMPORTED_MODULE_11__["PluginSpec"].Action(_mol_plugin_state_transforms__WEBPACK_IMPORTED_MODULE_4__["StateTransforms"].Volume.VolumeFromDx),
        _spec__WEBPACK_IMPORTED_MODULE_11__["PluginSpec"].Action(_mol_plugin_state_transforms__WEBPACK_IMPORTED_MODULE_4__["StateTransforms"].Representation.VolumeRepresentation3D),
    ],
    behaviors: [
        _spec__WEBPACK_IMPORTED_MODULE_11__["PluginSpec"].Behavior(_behavior__WEBPACK_IMPORTED_MODULE_7__["PluginBehaviors"].Representation.HighlightLoci),
        _spec__WEBPACK_IMPORTED_MODULE_11__["PluginSpec"].Behavior(_behavior__WEBPACK_IMPORTED_MODULE_7__["PluginBehaviors"].Representation.SelectLoci),
        _spec__WEBPACK_IMPORTED_MODULE_11__["PluginSpec"].Behavior(_behavior__WEBPACK_IMPORTED_MODULE_7__["PluginBehaviors"].Representation.DefaultLociLabelProvider),
        _spec__WEBPACK_IMPORTED_MODULE_11__["PluginSpec"].Behavior(_behavior__WEBPACK_IMPORTED_MODULE_7__["PluginBehaviors"].Representation.FocusLoci),
        _spec__WEBPACK_IMPORTED_MODULE_11__["PluginSpec"].Behavior(_behavior__WEBPACK_IMPORTED_MODULE_7__["PluginBehaviors"].Camera.FocusLoci),
        _spec__WEBPACK_IMPORTED_MODULE_11__["PluginSpec"].Behavior(_behavior_dynamic_selection_structure_focus_representation__WEBPACK_IMPORTED_MODULE_8__["StructureFocusRepresentation"]),
        _spec__WEBPACK_IMPORTED_MODULE_11__["PluginSpec"].Behavior(_behavior__WEBPACK_IMPORTED_MODULE_7__["PluginBehaviors"].CustomProps.StructureInfo),
        _spec__WEBPACK_IMPORTED_MODULE_11__["PluginSpec"].Behavior(_behavior__WEBPACK_IMPORTED_MODULE_7__["PluginBehaviors"].CustomProps.AccessibleSurfaceArea),
        _spec__WEBPACK_IMPORTED_MODULE_11__["PluginSpec"].Behavior(_behavior__WEBPACK_IMPORTED_MODULE_7__["PluginBehaviors"].CustomProps.Interactions),
        _spec__WEBPACK_IMPORTED_MODULE_11__["PluginSpec"].Behavior(_behavior__WEBPACK_IMPORTED_MODULE_7__["PluginBehaviors"].CustomProps.SecondaryStructure),
        _spec__WEBPACK_IMPORTED_MODULE_11__["PluginSpec"].Behavior(_behavior__WEBPACK_IMPORTED_MODULE_7__["PluginBehaviors"].CustomProps.ValenceModel),
        _spec__WEBPACK_IMPORTED_MODULE_11__["PluginSpec"].Behavior(_behavior__WEBPACK_IMPORTED_MODULE_7__["PluginBehaviors"].CustomProps.CrossLinkRestraint),
    ],
    customParamEditors: [
        [_behavior_dynamic_volume_streaming_transformers__WEBPACK_IMPORTED_MODULE_9__["CreateVolumeStreamingBehavior"], _mol_plugin_ui_custom_volume__WEBPACK_IMPORTED_MODULE_5__["VolumeStreamingCustomControls"]]
    ],
    animations: [
        _mol_plugin_state_animation_built_in_model_index__WEBPACK_IMPORTED_MODULE_13__["AnimateModelIndex"],
        _mol_plugin_state_animation_built_in_camera_spin__WEBPACK_IMPORTED_MODULE_15__["AnimateCameraSpin"],
        _mol_plugin_state_animation_built_in_state_snapshots__WEBPACK_IMPORTED_MODULE_16__["AnimateStateSnapshots"],
        _mol_plugin_state_animation_built_in_assembly_unwind__WEBPACK_IMPORTED_MODULE_14__["AnimateAssemblyUnwind"]
    ]
};
function createPlugin(target, spec) {
    var ctx = new _context__WEBPACK_IMPORTED_MODULE_10__["PluginContext"](spec || DefaultPluginSpec);
    ctx.init();
    react_dom__WEBPACK_IMPORTED_MODULE_2__["render"](react__WEBPACK_IMPORTED_MODULE_1__["createElement"](_mol_plugin_ui_plugin__WEBPACK_IMPORTED_MODULE_6__["Plugin"], { plugin: ctx }), target);
    return ctx;
}
/** Returns the instance of the plugin after all behaviors have been initialized */
function createPluginAsync(target, spec) {
    return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"])(this, void 0, void 0, function () {
        var ctx, init;
        return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__generator"])(this, function (_a) {
            switch (_a.label) {
                case 0:
                    ctx = new _context__WEBPACK_IMPORTED_MODULE_10__["PluginContext"](spec || DefaultPluginSpec);
                    init = ctx.init();
                    react_dom__WEBPACK_IMPORTED_MODULE_2__["render"](react__WEBPACK_IMPORTED_MODULE_1__["createElement"](_mol_plugin_ui_plugin__WEBPACK_IMPORTED_MODULE_6__["Plugin"], { plugin: ctx }), target);
                    return [4 /*yield*/, init];
                case 1:
                    _a.sent();
                    return [2 /*return*/, ctx];
            }
        });
    });
}
//# sourceMappingURL=index.js.map

/***/ }),

/***/ "./lib/mol-plugin/layout.js":
/*!**********************************!*\
  !*** ./lib/mol-plugin/layout.js ***!
  \**********************************/
/*! exports provided: PluginLayoutStateParams, PluginLayout */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "PluginLayoutStateParams", function() { return PluginLayoutStateParams; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "PluginLayout", function() { return PluginLayout; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../mol-util/param-definition */ "./lib/mol-util/param-definition.js");
/* harmony import */ var _mol_plugin_state_component__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../mol-plugin-state/component */ "./lib/mol-plugin-state/component.js");
/* harmony import */ var _commands__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./commands */ "./lib/mol-plugin/commands.js");
/**
 * Copyright (c) 2018-2019 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author David Sehnal <david.sehnal@gmail.com>
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */




var regionStateOptions = [
    ['full', 'Full'],
    ['collapsed', 'Collapsed'],
    ['hidden', 'Hidden'],
];
var simpleRegionStateOptions = [
    ['full', 'Full'],
    ['hidden', 'Hidden'],
];
var PluginLayoutStateParams = {
    isExpanded: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_1__["ParamDefinition"].Boolean(false),
    showControls: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_1__["ParamDefinition"].Boolean(true),
    regionState: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_1__["ParamDefinition"].Group({
        left: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_1__["ParamDefinition"].Select('full', regionStateOptions),
        top: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_1__["ParamDefinition"].Select('full', simpleRegionStateOptions),
        right: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_1__["ParamDefinition"].Select('full', simpleRegionStateOptions),
        bottom: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_1__["ParamDefinition"].Select('full', simpleRegionStateOptions),
    }),
    controlsDisplay: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_1__["ParamDefinition"].Value('outside', { isHidden: true })
};
var PluginLayout = /** @class */ (function (_super) {
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__extends"])(PluginLayout, _super);
    function PluginLayout(context) {
        var _this = _super.call(this, Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_1__["ParamDefinition"].getDefaultValues(PluginLayoutStateParams)), (context.spec.layout && context.spec.layout.initial))) || this;
        _this.context = context;
        _this.events = {
            updated: _this.ev()
        };
        _this.rootState = void 0;
        _commands__WEBPACK_IMPORTED_MODULE_3__["PluginCommands"].Layout.Update.subscribe(context, function (e) { return _this.updateProps(e.state); });
        // TODO how best make sure it runs on node.js as well as in the browser?
        if (typeof document !== 'undefined') {
            // <meta name='viewport' content='width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=0' />
            _this.expandedViewport = document.createElement('meta');
            _this.expandedViewport.name = 'viewport';
            _this.expandedViewport.content = 'width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=0';
        }
        return _this;
    }
    PluginLayout.prototype.updateProps = function (state) {
        var prevExpanded = !!this.state.isExpanded;
        this.updateState(state);
        if (this.root && typeof state.isExpanded === 'boolean' && state.isExpanded !== prevExpanded)
            this.handleExpand();
        this.events.updated.next();
    };
    PluginLayout.prototype.setProps = function (props) {
        this.updateState(props);
    };
    PluginLayout.prototype.setRoot = function (root) {
        this.root = root;
        if (this.state.isExpanded)
            this.handleExpand();
    };
    PluginLayout.prototype.getScrollElement = function () {
        if (document.scrollingElement)
            return document.scrollingElement;
        if (document.documentElement)
            return document.documentElement;
        return document.body;
    };
    PluginLayout.prototype.handleExpand = function () {
        try {
            var body = document.getElementsByTagName('body')[0];
            var head = document.getElementsByTagName('head')[0];
            if (!body || !head || !this.root)
                return;
            if (this.state.isExpanded) {
                var children = head.children;
                var viewports = [];
                var hasExp = false;
                for (var i = 0; i < children.length; i++) {
                    if (children[i] === this.expandedViewport) {
                        hasExp = true;
                    }
                    else if ((children[i].name || '').toLowerCase() === 'viewport') {
                        viewports.push(children[i]);
                    }
                }
                for (var _i = 0, viewports_1 = viewports; _i < viewports_1.length; _i++) {
                    var v = viewports_1[_i];
                    head.removeChild(v);
                }
                if (!hasExp)
                    head.appendChild(this.expandedViewport);
                var s = body.style;
                var doc = this.getScrollElement();
                var scrollLeft = doc.scrollLeft;
                var scrollTop = doc.scrollTop;
                this.rootState = {
                    top: s.top, bottom: s.bottom, right: s.right, left: s.left,
                    scrollTop: scrollTop, scrollLeft: scrollLeft,
                    position: s.position, overflow: s.overflow,
                    viewports: viewports,
                    zIndex: this.root.style.zIndex,
                    width: s.width, height: s.height,
                    maxWidth: s.maxWidth, maxHeight: s.maxHeight,
                    margin: s.margin, marginLeft: s.marginLeft, marginRight: s.marginRight, marginTop: s.marginTop, marginBottom: s.marginBottom
                };
                s.overflow = 'hidden';
                s.position = 'fixed';
                s.top = '0';
                s.bottom = '0';
                s.right = '0';
                s.left = '0';
                s.width = '100%';
                s.height = '100%';
                s.maxWidth = '100%';
                s.maxHeight = '100%';
                s.margin = '0';
                s.marginLeft = '0';
                s.marginRight = '0';
                s.marginTop = '0';
                s.marginBottom = '0';
                // TODO: setting this breaks viewport controls for some reason. Is there a fix?
                // this.root.style.zIndex = '100000';
            }
            else {
                var children = head.children;
                for (var i = 0; i < children.length; i++) {
                    if (children[i] === this.expandedViewport) {
                        head.removeChild(this.expandedViewport);
                        break;
                    }
                }
                if (this.rootState) {
                    var t = this.rootState;
                    for (var _a = 0, _b = t.viewports; _a < _b.length; _a++) {
                        var v = _b[_a];
                        head.appendChild(v);
                    }
                    var s = body.style;
                    s.top = t.top;
                    s.bottom = t.bottom;
                    s.left = t.left;
                    s.right = t.right;
                    s.width = t.width;
                    s.height = t.height;
                    s.maxWidth = t.maxWidth;
                    s.maxHeight = t.maxHeight;
                    s.margin = t.margin;
                    s.marginLeft = t.marginLeft;
                    s.marginRight = t.marginRight;
                    s.marginTop = t.marginTop;
                    s.marginBottom = t.marginBottom;
                    s.position = t.position;
                    s.overflow = t.overflow || '';
                    var doc = this.getScrollElement();
                    doc.scrollTop = t.scrollTop;
                    doc.scrollLeft = t.scrollLeft;
                    this.rootState = void 0;
                    this.root.style.zIndex = t.zIndex;
                }
            }
        }
        catch (e) {
            var msg = 'Layout change error, you might have to reload the page.';
            this.context.log.error(msg);
            console.error(msg, e);
        }
    };
    return PluginLayout;
}(_mol_plugin_state_component__WEBPACK_IMPORTED_MODULE_2__["StatefulPluginComponent"]));

//# sourceMappingURL=layout.js.map

/***/ }),

/***/ "./lib/mol-plugin/spec.js":
/*!********************************!*\
  !*** ./lib/mol-plugin/spec.js ***!
  \********************************/
/*! exports provided: PluginSpec */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "PluginSpec", function() { return PluginSpec; });
/**
 * Copyright (c) 2018-2019 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author David Sehnal <david.sehnal@gmail.com>
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */

var PluginSpec;
(function (PluginSpec) {
    function Action(action, params) {
        return { action: action, customControl: params && params.customControl, autoUpdate: params && params.autoUpdate };
    }
    PluginSpec.Action = Action;
    function Behavior(transformer, defaultParams) {
        if (defaultParams === void 0) { defaultParams = {}; }
        return { transformer: transformer, defaultParams: defaultParams };
    }
    PluginSpec.Behavior = Behavior;
})(PluginSpec || (PluginSpec = {}));
//# sourceMappingURL=spec.js.map

/***/ }),

/***/ "./lib/mol-plugin/state.js":
/*!*********************************!*\
  !*** ./lib/mol-plugin/state.js ***!
  \*********************************/
/*! exports provided: PluginState */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "PluginState", function() { return PluginState; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _mol_state__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../mol-state */ "./lib/mol-state/index.js");
/* harmony import */ var _mol_plugin_state_objects__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../mol-plugin-state/objects */ "./lib/mol-plugin-state/objects.js");
/* harmony import */ var _behavior__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./behavior */ "./lib/mol-plugin/behavior.js");
/* harmony import */ var _mol_canvas3d_canvas3d__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../mol-canvas3d/canvas3d */ "./lib/mol-canvas3d/canvas3d.js");
/* harmony import */ var _commands__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./commands */ "./lib/mol-plugin/commands.js");
/* harmony import */ var _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../mol-util/param-definition */ "./lib/mol-util/param-definition.js");
/* harmony import */ var _mol_util__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../mol-util */ "./lib/mol-util/index.js");
/* harmony import */ var immer__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! immer */ "./node_modules/immer/dist/immer.esm.js");
/* harmony import */ var rxjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! rxjs */ "./node_modules/rxjs/_esm5/index.js");
/* harmony import */ var _mol_plugin_state_component__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ../mol-plugin-state/component */ "./lib/mol-plugin-state/component.js");
/* harmony import */ var _config__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ./config */ "./lib/mol-plugin/config.js");
/**
 * Copyright (c) 2018-2020 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author David Sehnal <david.sehnal@gmail.com>
 */













var PluginState = /** @class */ (function (_super) {
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__extends"])(PluginState, _super);
    function PluginState(plugin) {
        var _this = _super.call(this) || this;
        _this.plugin = plugin;
        _this.data = _mol_state__WEBPACK_IMPORTED_MODULE_1__["State"].create(new _mol_plugin_state_objects__WEBPACK_IMPORTED_MODULE_2__["PluginStateObject"].Root({}), { runTask: _this.plugin.runTask, globalContext: _this.plugin, historyCapacity: _this.plugin.config.get(_config__WEBPACK_IMPORTED_MODULE_11__["PluginConfig"].State.HistoryCapacity) });
        _this.behaviors = _mol_state__WEBPACK_IMPORTED_MODULE_1__["State"].create(new _behavior__WEBPACK_IMPORTED_MODULE_3__["PluginBehavior"].Root({}), { runTask: _this.plugin.runTask, globalContext: _this.plugin, rootState: { isLocked: true } });
        _this.events = {
            cell: {
                stateUpdated: Object(rxjs__WEBPACK_IMPORTED_MODULE_9__["merge"])(_this.data.events.cell.stateUpdated, _this.behaviors.events.cell.stateUpdated),
                created: Object(rxjs__WEBPACK_IMPORTED_MODULE_9__["merge"])(_this.data.events.cell.created, _this.behaviors.events.cell.created),
                removed: Object(rxjs__WEBPACK_IMPORTED_MODULE_9__["merge"])(_this.data.events.cell.removed, _this.behaviors.events.cell.removed),
            },
            object: {
                created: Object(rxjs__WEBPACK_IMPORTED_MODULE_9__["merge"])(_this.data.events.object.created, _this.behaviors.events.object.created),
                removed: Object(rxjs__WEBPACK_IMPORTED_MODULE_9__["merge"])(_this.data.events.object.removed, _this.behaviors.events.object.removed),
                updated: Object(rxjs__WEBPACK_IMPORTED_MODULE_9__["merge"])(_this.data.events.object.updated, _this.behaviors.events.object.updated)
            }
        };
        _this.snapshotParams = _this.ev.behavior(PluginState.DefaultSnapshotParams);
        _this.setSnapshotParams = function (params) {
            _this.snapshotParams.next(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, PluginState.DefaultSnapshotParams), params));
        };
        return _this;
    }
    Object.defineProperty(PluginState.prototype, "animation", {
        get: function () { return this.plugin.managers.animation; },
        enumerable: false,
        configurable: true
    });
    PluginState.prototype.getSnapshot = function (params) {
        var _a, _b;
        var p = Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, this.snapshotParams.value), params);
        return {
            id: _mol_util__WEBPACK_IMPORTED_MODULE_7__["UUID"].create22(),
            data: p.data ? this.data.getSnapshot() : void 0,
            behaviour: p.behavior ? this.behaviors.getSnapshot() : void 0,
            animation: p.animation ? this.animation.getSnapshot() : void 0,
            startAnimation: p.startAnimation ? !!p.startAnimation : void 0,
            camera: p.camera ? {
                current: this.plugin.canvas3d.camera.getSnapshot(),
                transitionStyle: p.cameraTransition.name,
                transitionDurationInMs: ((_a = p === null || p === void 0 ? void 0 : p.cameraTransition) === null || _a === void 0 ? void 0 : _a.name) === 'animate' ? p.cameraTransition.params.durationInMs : void 0
            } : void 0,
            canvas3d: p.canvas3d ? { props: (_b = this.plugin.canvas3d) === null || _b === void 0 ? void 0 : _b.props } : void 0,
            interactivity: p.interactivity ? { props: this.plugin.managers.interactivity.props } : void 0,
            structureFocus: this.plugin.managers.structure.focus.getSnapshot(),
            durationInMs: p === null || p === void 0 ? void 0 : p.durationInMs
        };
    };
    PluginState.prototype.setSnapshot = function (snapshot) {
        var _a;
        return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"])(this, void 0, void 0, function () {
            var settings;
            return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__generator"])(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, this.animation.stop()];
                    case 1:
                        _b.sent();
                        if (!snapshot.behaviour) return [3 /*break*/, 3];
                        return [4 /*yield*/, this.plugin.runTask(this.behaviors.setSnapshot(snapshot.behaviour))];
                    case 2:
                        _b.sent();
                        _b.label = 3;
                    case 3:
                        if (!snapshot.data) return [3 /*break*/, 5];
                        return [4 /*yield*/, this.plugin.runTask(this.data.setSnapshot(snapshot.data))];
                    case 4:
                        _b.sent();
                        _b.label = 5;
                    case 5:
                        if (!((_a = snapshot.canvas3d) === null || _a === void 0 ? void 0 : _a.props)) return [3 /*break*/, 7];
                        settings = _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_6__["ParamDefinition"].normalizeParams(_mol_canvas3d_canvas3d__WEBPACK_IMPORTED_MODULE_4__["Canvas3DParams"], snapshot.canvas3d.props, 'children');
                        return [4 /*yield*/, _commands__WEBPACK_IMPORTED_MODULE_5__["PluginCommands"].Canvas3D.SetSettings(this.plugin, { settings: settings })];
                    case 6:
                        _b.sent();
                        _b.label = 7;
                    case 7:
                        if (snapshot.interactivity) {
                            if (snapshot.interactivity.props)
                                this.plugin.managers.interactivity.setProps(snapshot.interactivity.props);
                        }
                        if (snapshot.structureFocus) {
                            this.plugin.managers.structure.focus.setSnapshot(snapshot.structureFocus);
                        }
                        if (snapshot.animation) {
                            this.animation.setSnapshot(snapshot.animation);
                        }
                        if (snapshot.camera) {
                            _commands__WEBPACK_IMPORTED_MODULE_5__["PluginCommands"].Camera.Reset(this.plugin, {
                                snapshot: snapshot.camera.current,
                                durationMs: snapshot.camera.transitionStyle === 'animate'
                                    ? snapshot.camera.transitionDurationInMs
                                    : void 0
                            });
                        }
                        if (snapshot.startAnimation) {
                            this.animation.start();
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    PluginState.prototype.updateTransform = function (state, a, params, canUndo) {
        var tree = state.build().to(a).update(params);
        return _commands__WEBPACK_IMPORTED_MODULE_5__["PluginCommands"].State.Update(this.plugin, { state: state, tree: tree, options: { canUndo: canUndo } });
    };
    PluginState.prototype.updateBehavior = function (behavior, params) {
        var tree = this.behaviors.build();
        if (!this.behaviors.tree.transforms.has(behavior.id)) {
            var defaultParams = behavior.createDefaultParams(void 0, this.plugin);
            tree.to(_behavior__WEBPACK_IMPORTED_MODULE_3__["PluginBehavior"].getCategoryId(behavior)).apply(behavior, Object(immer__WEBPACK_IMPORTED_MODULE_8__["produce"])(defaultParams, params), { ref: behavior.id });
        }
        else {
            tree.to(behavior.id).update(params);
        }
        return this.plugin.runTask(this.behaviors.updateTree(tree));
    };
    PluginState.prototype.dispose = function () {
        this.behaviors.cells.forEach(function (cell) {
            if (_behavior__WEBPACK_IMPORTED_MODULE_3__["PluginBehavior"].Behavior.is(cell.obj)) {
                cell.obj.data.unregister();
            }
        });
        _super.prototype.dispose.call(this);
        this.data.dispose();
        this.behaviors.dispose();
        this.animation.dispose();
    };
    return PluginState;
}(_mol_plugin_state_component__WEBPACK_IMPORTED_MODULE_10__["PluginComponent"]));
(function (PluginState) {
    PluginState.SnapshotParams = {
        durationInMs: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_6__["ParamDefinition"].Numeric(1500, { min: 100, max: 15000, step: 100 }, { label: 'Duration in ms' }),
        data: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_6__["ParamDefinition"].Boolean(true),
        behavior: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_6__["ParamDefinition"].Boolean(false),
        animation: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_6__["ParamDefinition"].Boolean(true),
        startAnimation: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_6__["ParamDefinition"].Boolean(false),
        canvas3d: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_6__["ParamDefinition"].Boolean(true),
        interactivity: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_6__["ParamDefinition"].Boolean(true),
        camera: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_6__["ParamDefinition"].Boolean(true),
        cameraTransition: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_6__["ParamDefinition"].MappedStatic('animate', {
            animate: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_6__["ParamDefinition"].Group({
                durationInMs: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_6__["ParamDefinition"].Numeric(250, { min: 100, max: 5000, step: 500 }, { label: 'Duration in ms' }),
            }),
            instant: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_6__["ParamDefinition"].Group({})
        }, { options: [['animate', 'Animate'], ['instant', 'Instant']] })
    };
    PluginState.DefaultSnapshotParams = _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_6__["ParamDefinition"].getDefaultValues(PluginState.SnapshotParams);
})(PluginState || (PluginState = {}));
//# sourceMappingURL=state.js.map

/***/ }),

/***/ "./lib/mol-plugin/util/substructure-parent-helper.js":
/*!***********************************************************!*\
  !*** ./lib/mol-plugin/util/substructure-parent-helper.js ***!
  \***********************************************************/
/*! exports provided: SubstructureParentHelper */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SubstructureParentHelper", function() { return SubstructureParentHelper; });
/* harmony import */ var _mol_plugin_state_objects__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../mol-plugin-state/objects */ "./lib/mol-plugin-state/objects.js");
/* harmony import */ var _mol_state__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../mol-state */ "./lib/mol-state/index.js");
/* harmony import */ var _mol_util_rx_event_helper__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../mol-util/rx-event-helper */ "./lib/mol-util/rx-event-helper.js");
/**
 * Copyright (c) 2019 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author David Sehnal <david.sehnal@gmail.com>
 */




var SubstructureParentHelper = /** @class */ (function () {
    function SubstructureParentHelper(plugin) {
        var _this = this;
        this.plugin = plugin;
        this.ev = _mol_util_rx_event_helper__WEBPACK_IMPORTED_MODULE_2__["RxEventHelper"].create();
        this.events = {
            updated: this.ev(),
            removed: this.ev(),
        };
        // private decorators = new Map<string, string[]>();
        this.root = new Map();
        this.tracked = new Map();
        plugin.state.data.events.object.created.subscribe(function (e) {
            _this.addMapping(e.state, e.ref, e.obj);
        });
        plugin.state.data.events.object.removed.subscribe(function (e) {
            if (_this.removeMapping(e.ref)) {
                _this.events.removed.next({ ref: e.ref, obj: e.obj });
            }
        });
        plugin.state.data.events.object.updated.subscribe(function (e) {
            if (_this.updateMapping(e.state, e.ref, e.oldObj, e.obj)) {
                _this.events.updated.next({ ref: e.ref, oldObj: e.oldObj, obj: e.obj });
            }
        });
    }
    SubstructureParentHelper.prototype.getDecorator = function (root) {
        var tree = this.plugin.state.data.tree;
        var children = tree.children.get(root);
        if (children.size !== 1)
            return root;
        var child = children.first();
        if (tree.transforms.get(child).transformer.definition.isDecorator) {
            return this.getDecorator(child);
        }
        return root;
    };
    /** Returns the root node of given structure if existing, takes decorators into account */
    SubstructureParentHelper.prototype.get = function (s, ignoreDecorators) {
        if (ignoreDecorators === void 0) { ignoreDecorators = false; }
        var r = this.root.get(s);
        if (!r)
            return;
        if (ignoreDecorators)
            return this.plugin.state.data.cells.get(r.ref);
        return this.plugin.state.data.cells.get(this.getDecorator(r.ref));
    };
    SubstructureParentHelper.prototype.addMapping = function (state, ref, obj) {
        if (!_mol_plugin_state_objects__WEBPACK_IMPORTED_MODULE_0__["PluginStateObject"].Molecule.Structure.is(obj))
            return false;
        this.tracked.set(ref, obj.data);
        // if the structure is already present in the tree, do not rewrite the root.
        if (this.root.has(obj.data)) {
            var e = this.root.get(obj.data);
            e.count++;
        }
        else {
            var parent_1 = state.select(_mol_state__WEBPACK_IMPORTED_MODULE_1__["StateSelection"].Generators.byRef(ref).rootOfType([_mol_plugin_state_objects__WEBPACK_IMPORTED_MODULE_0__["PluginStateObject"].Molecule.Structure]))[0];
            if (!parent_1) {
                this.root.set(obj.data, { ref: ref, count: 1 });
            }
            else {
                this.root.set(obj.data, { ref: parent_1.transform.ref, count: 1 });
            }
        }
        return true;
    };
    SubstructureParentHelper.prototype.removeMapping = function (ref) {
        if (!this.tracked.has(ref))
            return false;
        var s = this.tracked.get(ref);
        this.tracked.delete(ref);
        var root = this.root.get(s);
        if (root.count > 1) {
            root.count--;
        }
        else {
            this.root.delete(s);
        }
        return true;
    };
    SubstructureParentHelper.prototype.updateMapping = function (state, ref, oldObj, obj) {
        if (!_mol_plugin_state_objects__WEBPACK_IMPORTED_MODULE_0__["PluginStateObject"].Molecule.Structure.is(obj))
            return false;
        this.removeMapping(ref);
        this.addMapping(state, ref, obj);
        return true;
    };
    SubstructureParentHelper.prototype.dispose = function () {
        this.ev.dispose();
    };
    return SubstructureParentHelper;
}());
//# sourceMappingURL=substructure-parent-helper.js.map

/***/ }),

/***/ "./lib/mol-plugin/util/task-manager.js":
/*!*********************************************!*\
  !*** ./lib/mol-plugin/util/task-manager.js ***!
  \*********************************************/
/*! exports provided: TaskManager */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "TaskManager", function() { return TaskManager; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _mol_task__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../mol-task */ "./lib/mol-task/index.js");
/* harmony import */ var _mol_util_rx_event_helper__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../mol-util/rx-event-helper */ "./lib/mol-util/rx-event-helper.js");
/* harmony import */ var _mol_util_now__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../mol-util/now */ "./lib/mol-util/now.js");
/* harmony import */ var _mol_task_execution_observable__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../mol-task/execution/observable */ "./lib/mol-task/execution/observable.js");
/* harmony import */ var _mol_util_array__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../mol-util/array */ "./lib/mol-util/array.js");
/**
 * Copyright (c) 2018 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author David Sehnal <david.sehnal@gmail.com>
 */







var TaskManager = /** @class */ (function () {
    function TaskManager() {
        this.ev = _mol_util_rx_event_helper__WEBPACK_IMPORTED_MODULE_2__["RxEventHelper"].create();
        this.id = 0;
        this.runningTasks = new Set();
        this.abortRequests = new Map();
        this.options = new Map();
        this.currentContext = [];
        this.events = {
            progress: this.ev(),
            finished: this.ev()
        };
    }
    TaskManager.prototype.tryGetAbortTaskId = function (node) {
        if (this.abortRequests.has(node.progress.taskId))
            return node.progress.taskId;
        for (var _i = 0, _a = node.children; _i < _a.length; _i++) {
            var c = _a[_i];
            var abort = this.tryGetAbortTaskId(c);
            if (abort !== void 0)
                return abort;
        }
        return void 0;
    };
    TaskManager.prototype.track = function (internalId, taskId) {
        var _this = this;
        return function (progress) {
            var _a;
            if (progress.canAbort && progress.requestAbort) {
                var abortTaskId = _this.tryGetAbortTaskId(progress.root);
                if (abortTaskId !== void 0)
                    progress.requestAbort(_this.abortRequests.get(abortTaskId));
            }
            var elapsed = Object(_mol_util_now__WEBPACK_IMPORTED_MODULE_3__["now"])() - progress.root.progress.startedTime;
            _this.events.progress.next({
                id: internalId,
                useOverlay: (_a = _this.options.get(taskId)) === null || _a === void 0 ? void 0 : _a.useOverlay,
                level: elapsed < 250 ? 'none' : 'background',
                progress: progress
            });
        };
    };
    TaskManager.prototype.run = function (task, params) {
        return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"])(this, void 0, void 0, function () {
            var id, ctx, ret;
            return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__generator"])(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        id = this.id++;
                        if ((params === null || params === void 0 ? void 0 : params.createNewContext) || this.currentContext.length === 0) {
                            ctx = { ctx: Object(_mol_task_execution_observable__WEBPACK_IMPORTED_MODULE_4__["CreateObservableCtx"])(task, this.track(id, task.id), 100), refCount: 1 };
                        }
                        else {
                            ctx = this.currentContext[this.currentContext.length - 1];
                            ctx.refCount++;
                        }
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, , 3, 4]);
                        this.options.set(task.id, { useOverlay: !!(params === null || params === void 0 ? void 0 : params.useOverlay) });
                        this.runningTasks.add(task.id);
                        return [4 /*yield*/, Object(_mol_task_execution_observable__WEBPACK_IMPORTED_MODULE_4__["ExecuteInContext"])(ctx.ctx, task)];
                    case 2:
                        ret = _a.sent();
                        return [2 /*return*/, ret];
                    case 3:
                        this.options.delete(task.id);
                        this.runningTasks.delete(task.id);
                        this.events.finished.next({ id: id });
                        this.abortRequests.delete(task.id);
                        ctx.refCount--;
                        if (ctx.refCount === 0)
                            Object(_mol_util_array__WEBPACK_IMPORTED_MODULE_5__["arrayRemoveInPlace"])(this.currentContext, ctx);
                        return [7 /*endfinally*/];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    TaskManager.prototype.requestAbortAll = function (reason) {
        var _this = this;
        this.runningTasks.forEach(function (id) { return _this.abortRequests.set(id, reason); });
    };
    TaskManager.prototype.requestAbort = function (taskIdOrProgress, reason) {
        var id = typeof taskIdOrProgress === 'number'
            ? taskIdOrProgress
            : taskIdOrProgress.root.progress.taskId;
        this.abortRequests.set(id, reason);
    };
    TaskManager.prototype.dispose = function () {
        this.ev.dispose();
    };
    return TaskManager;
}());
(function (TaskManager) {
    function delay(time) {
        return new Promise(function (res) { return setTimeout(res, time); });
    }
    function testTask(N) {
        var _this = this;
        return _mol_task__WEBPACK_IMPORTED_MODULE_1__["Task"].create('Test', function (ctx) { return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"])(_this, void 0, void 0, function () {
            var i;
            return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__generator"])(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        i = 0;
                        _a.label = 1;
                    case 1:
                        if (!(i < N)) return [3 /*break*/, 5];
                        return [4 /*yield*/, delay(100 + Math.random() * 200)];
                    case 2:
                        _a.sent();
                        if (!ctx.shouldUpdate) return [3 /*break*/, 4];
                        return [4 /*yield*/, ctx.update({ message: 'Step ' + i, current: i, max: N, isIndeterminate: false })];
                    case 3:
                        _a.sent();
                        _a.label = 4;
                    case 4:
                        i++;
                        return [3 /*break*/, 1];
                    case 5: return [2 /*return*/];
                }
            });
        }); });
    }
    TaskManager.testTask = testTask;
})(TaskManager || (TaskManager = {}));
//# sourceMappingURL=task-manager.js.map

/***/ }),

/***/ "./lib/mol-plugin/util/toast.js":
/*!**************************************!*\
  !*** ./lib/mol-plugin/util/toast.js ***!
  \**************************************/
/*! exports provided: PluginToastManager */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "PluginToastManager", function() { return PluginToastManager; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _mol_plugin_state_component__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../mol-plugin-state/component */ "./lib/mol-plugin-state/component.js");
/* harmony import */ var immutable__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! immutable */ "./node_modules/immutable/dist/immutable.js");
/* harmony import */ var immutable__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(immutable__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _commands__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../commands */ "./lib/mol-plugin/commands.js");
/**
 * Copyright (c) 2019 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * Adapted from LiteMol (c) David Sehnal
 *
 * @author David Sehnal <david.sehnal@gmail.com>
 */




var PluginToastManager = /** @class */ (function (_super) {
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__extends"])(PluginToastManager, _super);
    function PluginToastManager(plugin) {
        var _this = _super.call(this, { entries: Object(immutable__WEBPACK_IMPORTED_MODULE_2__["OrderedMap"])() }) || this;
        _this.events = {
            changed: _this.ev()
        };
        _this.serialNumber = 0;
        _this.serialId = 0;
        _commands__WEBPACK_IMPORTED_MODULE_3__["PluginCommands"].Toast.Show.subscribe(plugin, function (e) { return _this.show(e); });
        _commands__WEBPACK_IMPORTED_MODULE_3__["PluginCommands"].Toast.Hide.subscribe(plugin, function (e) { return _this.hide(_this.findByKey(e.key)); });
        return _this;
    }
    PluginToastManager.prototype.findByKey = function (key) {
        return this.state.entries.find(function (e) { return !!e && e.key === key; });
    };
    PluginToastManager.prototype.show = function (toast) {
        var _this = this;
        var entries = this.state.entries;
        var e = void 0;
        var id = ++this.serialId;
        var serialNumber;
        if (toast.key && (e = this.findByKey(toast.key))) {
            if (e.timeout !== void 0)
                clearTimeout(e.timeout);
            serialNumber = e.serialNumber;
            entries = entries.remove(e.id);
        }
        else {
            serialNumber = ++this.serialNumber;
        }
        e = {
            id: id,
            serialNumber: serialNumber,
            key: toast.key,
            title: toast.title,
            message: toast.message,
            timeout: this.timeout(id, toast.timeoutMs),
            hide: function () { return _this.hideId(id); }
        };
        if (this.updateState({ entries: entries.set(id, e) }))
            this.events.changed.next();
    };
    PluginToastManager.prototype.timeout = function (id, delay) {
        var _this = this;
        if (delay === void 0)
            return void 0;
        if (delay < 0)
            delay = 500;
        return setTimeout(function () {
            var e = _this.state.entries.get(id);
            e.timeout = void 0;
            _this.hide(e);
        }, delay);
    };
    PluginToastManager.prototype.hideId = function (id) {
        this.hide(this.state.entries.get(id));
    };
    PluginToastManager.prototype.hide = function (e) {
        if (!e)
            return;
        if (e.timeout !== void 0)
            clearTimeout(e.timeout);
        e.hide = void 0;
        if (this.updateState({ entries: this.state.entries.delete(e.id) }))
            this.events.changed.next();
    };
    return PluginToastManager;
}(_mol_plugin_state_component__WEBPACK_IMPORTED_MODULE_1__["StatefulPluginComponent"]));

//# sourceMappingURL=toast.js.map

/***/ }),

/***/ "./lib/mol-plugin/util/viewport-screenshot.js":
/*!****************************************************!*\
  !*** ./lib/mol-plugin/util/viewport-screenshot.js ***!
  \****************************************************/
/*! exports provided: ViewportScreenshotHelper */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ViewportScreenshotHelper", function() { return ViewportScreenshotHelper; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _mol_canvas3d_helper_camera_helper__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../mol-canvas3d/helper/camera-helper */ "./lib/mol-canvas3d/helper/camera-helper.js");
/* harmony import */ var _mol_canvas3d_util__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../mol-canvas3d/util */ "./lib/mol-canvas3d/util.js");
/* harmony import */ var _mol_math_linear_algebra_3d_common__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../mol-math/linear-algebra/3d/common */ "./lib/mol-math/linear-algebra/3d/common.js");
/* harmony import */ var _mol_plugin_state_component__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../mol-plugin-state/component */ "./lib/mol-plugin-state/component.js");
/* harmony import */ var _mol_plugin_state_objects__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../mol-plugin-state/objects */ "./lib/mol-plugin-state/objects.js");
/* harmony import */ var _mol_state__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../../mol-state */ "./lib/mol-state/index.js");
/* harmony import */ var _mol_task__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../../mol-task */ "./lib/mol-task/index.js");
/* harmony import */ var _mol_util_color__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ../../mol-util/color */ "./lib/mol-util/color/index.js");
/* harmony import */ var _mol_util_download__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ../../mol-util/download */ "./lib/mol-util/download.js");
/* harmony import */ var _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ../../mol-util/param-definition */ "./lib/mol-util/param-definition.js");
/* harmony import */ var _mol_util_set__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ../../mol-util/set */ "./lib/mol-util/set.js");

/**
 * Copyright (c) 2019-2020 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author David Sehnal <david.sehnal@gmail.com>
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */












var ViewportScreenshotHelper = /** @class */ (function (_super) {
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__extends"])(ViewportScreenshotHelper, _super);
    function ViewportScreenshotHelper(plugin) {
        var _this = _super.call(this) || this;
        _this.plugin = plugin;
        _this._params = void 0;
        _this.behaviors = {
            values: _this.ev.behavior({
                transparent: _this.params.transparent.defaultValue,
                axes: { name: 'off', params: {} },
                resolution: _this.params.resolution.defaultValue
            }),
            cropParams: _this.ev.behavior({ auto: true, relativePadding: 0.1 }),
            relativeCrop: _this.ev.behavior({ x: 0, y: 0, width: 1, height: 1 }),
        };
        _this.events = {
            previewed: _this.ev()
        };
        _this.canvas = function () {
            var canvas = document.createElement('canvas');
            return canvas;
        }();
        _this.previewCanvas = function () {
            var canvas = document.createElement('canvas');
            return canvas;
        }();
        _this.previewData = {
            image: { data: new Uint8ClampedArray(1), width: 1, height: 0 },
            background: Object(_mol_util_color__WEBPACK_IMPORTED_MODULE_8__["Color"])(0),
            transparent: false
        };
        return _this;
    }
    ViewportScreenshotHelper.prototype.createParams = function () {
        var max = Math.min(this.plugin.canvas3d ? this.plugin.canvas3d.webgl.maxRenderbufferSize : 4096, 4096);
        return {
            resolution: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_10__["ParamDefinition"].MappedStatic('viewport', {
                viewport: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_10__["ParamDefinition"].Group({}),
                hd: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_10__["ParamDefinition"].Group({}),
                'full-hd': _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_10__["ParamDefinition"].Group({}),
                'ultra-hd': _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_10__["ParamDefinition"].Group({}),
                custom: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_10__["ParamDefinition"].Group({
                    width: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_10__["ParamDefinition"].Numeric(1920, { min: 128, max: max, step: 1 }),
                    height: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_10__["ParamDefinition"].Numeric(1080, { min: 128, max: max, step: 1 }),
                }, { isFlat: true })
            }, {
                options: [
                    ['viewport', 'Viewport'],
                    ['hd', 'HD (1280 x 720)'],
                    ['full-hd', 'Full HD (1920 x 1080)'],
                    ['ultra-hd', 'Ultra HD (3840 x 2160)'],
                    ['custom', 'Custom']
                ]
            }),
            transparent: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_10__["ParamDefinition"].Boolean(false),
            axes: _mol_canvas3d_helper_camera_helper__WEBPACK_IMPORTED_MODULE_1__["CameraHelperParams"].axes,
        };
    };
    Object.defineProperty(ViewportScreenshotHelper.prototype, "params", {
        get: function () {
            if (this._params)
                return this._params;
            return this._params = this.createParams();
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ViewportScreenshotHelper.prototype, "values", {
        get: function () {
            return this.behaviors.values.value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ViewportScreenshotHelper.prototype, "cropParams", {
        get: function () {
            return this.behaviors.cropParams.value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ViewportScreenshotHelper.prototype, "relativeCrop", {
        get: function () {
            return this.behaviors.relativeCrop.value;
        },
        enumerable: false,
        configurable: true
    });
    ViewportScreenshotHelper.prototype.getCanvasSize = function () {
        var _a, _b;
        return {
            width: ((_a = this.plugin.canvas3d) === null || _a === void 0 ? void 0 : _a.webgl.gl.drawingBufferWidth) || 0,
            height: ((_b = this.plugin.canvas3d) === null || _b === void 0 ? void 0 : _b.webgl.gl.drawingBufferHeight) || 0
        };
    };
    ViewportScreenshotHelper.prototype.getSize = function () {
        var values = this.values;
        switch (values.resolution.name) {
            case 'viewport': return this.getCanvasSize();
            case 'hd': return { width: 1280, height: 720 };
            case 'full-hd': return { width: 1920, height: 1080 };
            case 'ultra-hd': return { width: 3840, height: 2160 };
            default: return { width: values.resolution.params.width, height: values.resolution.params.height };
        }
    };
    ViewportScreenshotHelper.prototype.createPass = function (mutlisample) {
        var c = this.plugin.canvas3d;
        var _a = c.webgl.extensions, colorBufferFloat = _a.colorBufferFloat, textureFloat = _a.textureFloat;
        return this.plugin.canvas3d.getImagePass({
            transparentBackground: this.values.transparent,
            cameraHelper: { axes: this.values.axes },
            multiSample: {
                mode: mutlisample ? 'on' : 'off',
                sampleLevel: colorBufferFloat && textureFloat ? 4 : 2
            },
            postprocessing: Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, c.props.postprocessing), { antialiasing: { name: 'off', params: {} } })
        });
    };
    Object.defineProperty(ViewportScreenshotHelper.prototype, "previewPass", {
        get: function () {
            return this._previewPass || (this._previewPass = this.createPass(false));
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ViewportScreenshotHelper.prototype, "imagePass", {
        get: function () {
            if (this._imagePass) {
                this._imagePass.setProps({
                    cameraHelper: { axes: this.values.axes },
                    transparentBackground: this.values.transparent,
                    // TODO: optimize because this creates a copy of a large object!
                    postprocessing: Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, this.plugin.canvas3d.props.postprocessing), { antialiasing: { name: 'off', params: {} } })
                });
                return this._imagePass;
            }
            return this._imagePass = this.createPass(true);
        },
        enumerable: false,
        configurable: true
    });
    ViewportScreenshotHelper.prototype.getFilename = function (extension) {
        if (extension === void 0) { extension = '.png'; }
        var models = this.plugin.state.data.select(_mol_state__WEBPACK_IMPORTED_MODULE_6__["StateSelection"].Generators.rootsOfType(_mol_plugin_state_objects__WEBPACK_IMPORTED_MODULE_5__["PluginStateObject"].Molecule.Model)).map(function (s) { return s.obj.data; });
        var uniqueIds = new Set();
        models.forEach(function (m) { return uniqueIds.add(m.entryId.toUpperCase()); });
        var idString = _mol_util_set__WEBPACK_IMPORTED_MODULE_11__["SetUtils"].toArray(uniqueIds).join('-');
        return "" + (idString || 'molstar-image') + extension;
    };
    ViewportScreenshotHelper.prototype.resetCrop = function () {
        this.behaviors.relativeCrop.next({ x: 0, y: 0, width: 1, height: 1 });
    };
    ViewportScreenshotHelper.prototype.toggleAutocrop = function () {
        if (this.cropParams.auto) {
            this.behaviors.cropParams.next(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, this.cropParams), { auto: false }));
            this.resetCrop();
        }
        else {
            this.behaviors.cropParams.next(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, this.cropParams), { auto: true }));
        }
    };
    Object.defineProperty(ViewportScreenshotHelper.prototype, "isFullFrame", {
        get: function () {
            var crop = this.relativeCrop;
            return Object(_mol_math_linear_algebra_3d_common__WEBPACK_IMPORTED_MODULE_3__["equalEps"])(crop.x, 0, 1e-5) && Object(_mol_math_linear_algebra_3d_common__WEBPACK_IMPORTED_MODULE_3__["equalEps"])(crop.y, 0, 1e-5) && Object(_mol_math_linear_algebra_3d_common__WEBPACK_IMPORTED_MODULE_3__["equalEps"])(crop.width, 1, 1e-5) && Object(_mol_math_linear_algebra_3d_common__WEBPACK_IMPORTED_MODULE_3__["equalEps"])(crop.height, 1, 1e-5);
        },
        enumerable: false,
        configurable: true
    });
    ViewportScreenshotHelper.prototype.autocrop = function (relativePadding) {
        if (relativePadding === void 0) { relativePadding = this.cropParams.relativePadding; }
        var _a = this.previewData.image, data = _a.data, width = _a.width, height = _a.height;
        var isTransparent = this.previewData.transparent;
        var bgColor = isTransparent ? this.previewData.background : 0xff000000 | this.previewData.background;
        var l = width, r = 0, t = height, b = 0;
        for (var j = 0; j < height; j++) {
            var jj = j * width;
            for (var i = 0; i < width; i++) {
                var o = 4 * (jj + i);
                if (isTransparent) {
                    if (data[o + 3] === 0)
                        continue;
                }
                else {
                    var c = (data[o] << 16) | (data[o + 1] << 8) | (data[o + 2]) | (data[o + 3] << 24);
                    if (c === bgColor)
                        continue;
                }
                if (i < l)
                    l = i;
                if (i > r)
                    r = i;
                if (j < t)
                    t = j;
                if (j > b)
                    b = j;
            }
        }
        if (l > r) {
            var x = l;
            l = r;
            r = x;
        }
        if (t > b) {
            var x = t;
            t = b;
            b = x;
        }
        var tw = r - l + 1, th = b - t + 1;
        l -= relativePadding * tw;
        r += relativePadding * tw;
        t -= relativePadding * th;
        b += relativePadding * th;
        var crop = {
            x: Math.max(0, l / width),
            y: Math.max(0, t / height),
            width: Math.min(1, (r - l + 1) / width),
            height: Math.min(1, (b - t + 1) / height)
        };
        this.behaviors.relativeCrop.next(crop);
    };
    ViewportScreenshotHelper.prototype.getPreview = function (maxDim) {
        if (maxDim === void 0) { maxDim = 320; }
        var _a = this.getSize(), width = _a.width, height = _a.height;
        if (width <= 0 || height <= 0)
            return;
        var f = width / height;
        var w = 0, h = 0;
        if (f > 1) {
            w = maxDim;
            h = Math.round(maxDim / f);
        }
        else {
            h = maxDim;
            w = Math.round(maxDim * f);
        }
        var canvasProps = this.plugin.canvas3d.props;
        this.previewPass.setProps({
            cameraHelper: { axes: this.values.axes },
            transparentBackground: this.values.transparent,
            // TODO: optimize because this creates a copy of a large object!
            postprocessing: canvasProps.postprocessing
        });
        var imageData = this.previewPass.getImageData(w, h);
        var canvas = this.previewCanvas;
        canvas.width = imageData.width;
        canvas.height = imageData.height;
        this.previewData.image = imageData;
        this.previewData.background = canvasProps.renderer.backgroundColor;
        this.previewData.transparent = this.values.transparent;
        var canvasCtx = canvas.getContext('2d');
        if (!canvasCtx)
            throw new Error('Could not create canvas 2d context');
        canvasCtx.putImageData(imageData, 0, 0);
        if (this.cropParams.auto)
            this.autocrop();
        this.events.previewed.next();
        return { canvas: canvas, width: w, height: h };
    };
    ViewportScreenshotHelper.prototype.getSizeAndViewport = function () {
        var _a = this.getSize(), width = _a.width, height = _a.height;
        var crop = this.relativeCrop;
        var viewport = {
            x: Math.floor(crop.x * width),
            y: Math.floor(crop.y * height),
            width: Math.ceil(crop.width * width),
            height: Math.ceil(crop.height * height)
        };
        if (viewport.width + viewport.x > width)
            viewport.width = width - viewport.x;
        if (viewport.height + viewport.y > height)
            viewport.height = height - viewport.y;
        return { width: width, height: height, viewport: viewport };
    };
    ViewportScreenshotHelper.prototype.draw = function (ctx) {
        return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"])(this, void 0, void 0, function () {
            var _a, width, height, viewport, imageData, canvas, canvasCtx;
            return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__generator"])(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = this.getSizeAndViewport(), width = _a.width, height = _a.height, viewport = _a.viewport;
                        if (width <= 0 || height <= 0)
                            return [2 /*return*/];
                        return [4 /*yield*/, ctx.update('Rendering image...')];
                    case 1:
                        _b.sent();
                        imageData = this.imagePass.getImageData(width, height, viewport);
                        return [4 /*yield*/, ctx.update('Encoding image...')];
                    case 2:
                        _b.sent();
                        canvas = this.canvas;
                        canvas.width = imageData.width;
                        canvas.height = imageData.height;
                        canvasCtx = canvas.getContext('2d');
                        if (!canvasCtx)
                            throw new Error('Could not create canvas 2d context');
                        canvasCtx.putImageData(imageData, 0, 0);
                        return [2 /*return*/];
                }
            });
        });
    };
    ViewportScreenshotHelper.prototype.copyToClipboardTask = function () {
        var _this = this;
        var cb = navigator.clipboard;
        if (!(cb === null || cb === void 0 ? void 0 : cb.write)) {
            this.plugin.log.error('clipboard.write not supported!');
            return;
        }
        return _mol_task__WEBPACK_IMPORTED_MODULE_7__["Task"].create('Copy Image', function (ctx) { return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"])(_this, void 0, void 0, function () {
            var blob, item;
            return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__generator"])(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.draw(ctx)];
                    case 1:
                        _a.sent();
                        return [4 /*yield*/, ctx.update('Converting image...')];
                    case 2:
                        _a.sent();
                        return [4 /*yield*/, Object(_mol_canvas3d_util__WEBPACK_IMPORTED_MODULE_2__["canvasToBlob"])(this.canvas, 'png')];
                    case 3:
                        blob = _a.sent();
                        item = new ClipboardItem({ 'image/png': blob });
                        cb.write([item]);
                        this.plugin.log.message('Image copied to clipboard.');
                        return [2 /*return*/];
                }
            });
        }); });
    };
    ViewportScreenshotHelper.prototype.getImageDataUri = function () {
        var _this = this;
        return this.plugin.runTask(_mol_task__WEBPACK_IMPORTED_MODULE_7__["Task"].create('Generate Image', function (ctx) { return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"])(_this, void 0, void 0, function () {
            return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__generator"])(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.draw(ctx)];
                    case 1:
                        _a.sent();
                        return [4 /*yield*/, ctx.update('Converting image...')];
                    case 2:
                        _a.sent();
                        return [2 /*return*/, this.canvas.toDataURL('png')];
                }
            });
        }); }));
    };
    ViewportScreenshotHelper.prototype.copyToClipboard = function () {
        var task = this.copyToClipboardTask();
        if (!task)
            return;
        return this.plugin.runTask(task);
    };
    ViewportScreenshotHelper.prototype.downloadTask = function (filename) {
        var _this = this;
        return _mol_task__WEBPACK_IMPORTED_MODULE_7__["Task"].create('Download Image', function (ctx) { return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"])(_this, void 0, void 0, function () {
            var blob;
            return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__generator"])(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.draw(ctx)];
                    case 1:
                        _a.sent();
                        return [4 /*yield*/, ctx.update('Downloading image...')];
                    case 2:
                        _a.sent();
                        return [4 /*yield*/, Object(_mol_canvas3d_util__WEBPACK_IMPORTED_MODULE_2__["canvasToBlob"])(this.canvas, 'png')];
                    case 3:
                        blob = _a.sent();
                        Object(_mol_util_download__WEBPACK_IMPORTED_MODULE_9__["download"])(blob, filename !== null && filename !== void 0 ? filename : this.getFilename());
                        return [2 /*return*/];
                }
            });
        }); });
    };
    ViewportScreenshotHelper.prototype.download = function (filename) {
        this.plugin.runTask(this.downloadTask(filename));
    };
    return ViewportScreenshotHelper;
}(_mol_plugin_state_component__WEBPACK_IMPORTED_MODULE_4__["PluginComponent"]));
//# sourceMappingURL=viewport-screenshot.js.map

/***/ }),

/***/ "./lib/mol-plugin/version.js":
/*!***********************************!*\
  !*** ./lib/mol-plugin/version.js ***!
  \***********************************/
/*! exports provided: PLUGIN_VERSION, PLUGIN_VERSION_DATE */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "PLUGIN_VERSION", function() { return PLUGIN_VERSION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "PLUGIN_VERSION_DATE", function() { return PLUGIN_VERSION_DATE; });
var PLUGIN_VERSION = '1.2.15';
var PLUGIN_VERSION_DATE = new Date( true ? 1612540169568 : undefined);

/***/ }),

/***/ "./lib/mol-repr/representation.js":
/*!****************************************!*\
  !*** ./lib/mol-repr/representation.js ***!
  \****************************************/
/*! exports provided: RepresentationProvider, EmptyRepresentationProvider, RepresentationRegistry, Representation */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "RepresentationProvider", function() { return RepresentationProvider; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "EmptyRepresentationProvider", function() { return EmptyRepresentationProvider; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "RepresentationRegistry", function() { return RepresentationRegistry; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Representation", function() { return Representation; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../mol-util/param-definition */ "./lib/mol-util/param-definition.js");
/* harmony import */ var _mol_theme_theme__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../mol-theme/theme */ "./lib/mol-theme/theme.js");
/* harmony import */ var rxjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! rxjs */ "./node_modules/rxjs/_esm5/index.js");
/* harmony import */ var _mol_task__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../mol-task */ "./lib/mol-task/index.js");
/* harmony import */ var _mol_util_marker_action__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../mol-util/marker-action */ "./lib/mol-util/marker-action.js");
/* harmony import */ var _mol_model_loci__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../mol-model/loci */ "./lib/mol-model/loci.js");
/* harmony import */ var _mol_theme_overpaint__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../mol-theme/overpaint */ "./lib/mol-theme/overpaint.js");
/* harmony import */ var _mol_theme_transparency__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ../mol-theme/transparency */ "./lib/mol-theme/transparency.js");
/* harmony import */ var _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ../mol-math/linear-algebra */ "./lib/mol-math/linear-algebra.js");
/* harmony import */ var _util__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ./util */ "./lib/mol-repr/util.js");
/* harmony import */ var _mol_geo_geometry_base__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ../mol-geo/geometry/base */ "./lib/mol-geo/geometry/base.js");
/* harmony import */ var _visual__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! ./visual */ "./lib/mol-repr/visual.js");
/* harmony import */ var _mol_theme_clipping__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! ../mol-theme/clipping */ "./lib/mol-theme/clipping.js");
/**
 * Copyright (c) 2018-2020 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */














var RepresentationProvider;
(function (RepresentationProvider) {
    function getDetaultParams(r, ctx, data) {
        return _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_1__["ParamDefinition"].getDefaultValues(r.getParams(ctx, data));
    }
    RepresentationProvider.getDetaultParams = getDetaultParams;
})(RepresentationProvider || (RepresentationProvider = {}));
var EmptyRepresentationProvider = {
    label: '',
    description: '',
    factory: function () { return Representation.Empty; },
    getParams: function () { return ({}); },
    defaultValues: {}
};
function getTypes(list) {
    return list.map(function (e) { return [e.name, e.provider.label]; });
}
var RepresentationRegistry = /** @class */ (function () {
    function RepresentationRegistry() {
        this._list = [];
        this._map = new Map();
        this._name = new Map();
    }
    Object.defineProperty(RepresentationRegistry.prototype, "default", {
        get: function () { return this._list[0]; },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(RepresentationRegistry.prototype, "types", {
        get: function () { return getTypes(this._list); },
        enumerable: false,
        configurable: true
    });
    ;
    RepresentationRegistry.prototype.add = function (provider) {
        if (this._map.has(provider.name)) {
            throw new Error(provider.name + " already registered.");
        }
        this._list.push({ name: provider.name, provider: provider });
        this._map.set(provider.name, provider);
        this._name.set(provider, provider.name);
    };
    RepresentationRegistry.prototype.getName = function (provider) {
        if (!this._name.has(provider))
            throw new Error("'" + provider.label + "' is not a registered represenatation provider.");
        return this._name.get(provider);
    };
    RepresentationRegistry.prototype.remove = function (provider) {
        var name = provider.name;
        this._list.splice(this._list.findIndex(function (e) { return e.name === name; }), 1);
        var p = this._map.get(name);
        if (p) {
            this._map.delete(name);
            this._name.delete(p);
        }
    };
    RepresentationRegistry.prototype.get = function (name) {
        return this._map.get(name) || EmptyRepresentationProvider;
    };
    Object.defineProperty(RepresentationRegistry.prototype, "list", {
        get: function () {
            return this._list;
        },
        enumerable: false,
        configurable: true
    });
    RepresentationRegistry.prototype.getApplicableList = function (data) {
        return this._list.filter(function (e) { return e.provider.isApplicable(data); });
    };
    RepresentationRegistry.prototype.getApplicableTypes = function (data) {
        return getTypes(this.getApplicableList(data));
    };
    return RepresentationRegistry;
}());

//

var Representation;
(function (Representation) {
    var Loci;
    (function (Loci) {
        function areEqual(a, b) {
            return a.repr === b.repr && _mol_model_loci__WEBPACK_IMPORTED_MODULE_6__["Loci"].areEqual(a.loci, b.loci);
        }
        Loci.areEqual = areEqual;
        function isEmpty(a) {
            return _mol_model_loci__WEBPACK_IMPORTED_MODULE_6__["Loci"].isEmpty(a.loci);
        }
        Loci.isEmpty = isEmpty;
        Loci.Empty = { loci: _mol_model_loci__WEBPACK_IMPORTED_MODULE_6__["EmptyLoci"] };
    })(Loci = Representation.Loci || (Representation.Loci = {}));
    function createState() {
        return { visible: true, alphaFactor: 1, pickable: true, colorOnly: false, syncManually: false, transform: _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_9__["Mat4"].identity(), overpaint: _mol_theme_overpaint__WEBPACK_IMPORTED_MODULE_7__["Overpaint"].Empty, transparency: _mol_theme_transparency__WEBPACK_IMPORTED_MODULE_8__["Transparency"].Empty, clipping: _mol_theme_clipping__WEBPACK_IMPORTED_MODULE_13__["Clipping"].Empty, markerActions: _mol_util_marker_action__WEBPACK_IMPORTED_MODULE_5__["MarkerActions"].All };
    }
    Representation.createState = createState;
    function updateState(state, update) {
        if (update.visible !== undefined)
            state.visible = update.visible;
        if (update.alphaFactor !== undefined)
            state.alphaFactor = update.alphaFactor;
        if (update.pickable !== undefined)
            state.pickable = update.pickable;
        if (update.colorOnly !== undefined)
            state.colorOnly = update.colorOnly;
        if (update.overpaint !== undefined)
            state.overpaint = update.overpaint;
        if (update.transparency !== undefined)
            state.transparency = update.transparency;
        if (update.clipping !== undefined)
            state.clipping = update.clipping;
        if (update.syncManually !== undefined)
            state.syncManually = update.syncManually;
        if (update.transform !== undefined)
            _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_9__["Mat4"].copy(state.transform, update.transform);
        if (update.markerActions !== undefined)
            state.markerActions = update.markerActions;
    }
    Representation.updateState = updateState;
    Representation.StateBuilder = { create: createState, update: updateState };
    Representation.Empty = {
        label: '', groupCount: 0, renderObjects: [], props: {}, params: {}, updated: new rxjs__WEBPACK_IMPORTED_MODULE_3__["Subject"](), state: createState(), theme: _mol_theme_theme__WEBPACK_IMPORTED_MODULE_2__["Theme"].createEmpty(),
        createOrUpdate: function () { return _mol_task__WEBPACK_IMPORTED_MODULE_4__["Task"].constant('', undefined); },
        setState: function () { },
        setTheme: function () { },
        getLoci: function () { return _mol_model_loci__WEBPACK_IMPORTED_MODULE_6__["EmptyLoci"]; },
        mark: function () { return false; },
        destroy: function () { }
    };
    function createMulti(label, ctx, getParams, stateBuilder, reprDefs) {
        var _this = this;
        var version = 0;
        var updated = new rxjs__WEBPACK_IMPORTED_MODULE_3__["Subject"]();
        var currentState = stateBuilder.create();
        var currentTheme = _mol_theme_theme__WEBPACK_IMPORTED_MODULE_2__["Theme"].createEmpty();
        var currentParams;
        var currentProps;
        var currentData;
        var reprMap = {};
        var reprList = Object.keys(reprDefs).map(function (name, i) {
            reprMap[i] = name;
            var repr = reprDefs[name](ctx, getParams);
            repr.setState(currentState);
            return repr;
        });
        return {
            label: label,
            updated: updated,
            get groupCount() {
                var groupCount = 0;
                if (currentProps) {
                    var visuals = currentProps.visuals;
                    for (var i = 0, il = reprList.length; i < il; ++i) {
                        if (!visuals || visuals.includes(reprMap[i])) {
                            groupCount += reprList[i].groupCount;
                        }
                    }
                }
                return groupCount;
            },
            get renderObjects() {
                var renderObjects = [];
                if (currentProps) {
                    var visuals = currentProps.visuals;
                    for (var i = 0, il = reprList.length; i < il; ++i) {
                        if (!visuals || visuals.includes(reprMap[i])) {
                            renderObjects.push.apply(renderObjects, reprList[i].renderObjects);
                        }
                    }
                }
                return renderObjects;
            },
            get props() { return currentProps; },
            get params() { return currentParams; },
            createOrUpdate: function (props, data) {
                if (props === void 0) { props = {}; }
                if (data && data !== currentData) {
                    currentParams = getParams(ctx, data);
                    currentData = data;
                    if (!currentProps)
                        currentProps = _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_1__["ParamDefinition"].getDefaultValues(currentParams);
                }
                var qualityProps = Object(_util__WEBPACK_IMPORTED_MODULE_10__["getQualityProps"])(Object.assign({}, currentProps, props), currentData);
                Object.assign(currentProps, props, qualityProps);
                var visuals = currentProps.visuals;
                return _mol_task__WEBPACK_IMPORTED_MODULE_4__["Task"].create("Creating or updating '" + label + "' representation", function (runtime) { return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"])(_this, void 0, void 0, function () {
                    var i, il;
                    return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__generator"])(this, function (_a) {
                        switch (_a.label) {
                            case 0:
                                i = 0, il = reprList.length;
                                _a.label = 1;
                            case 1:
                                if (!(i < il)) return [3 /*break*/, 4];
                                if (!(!visuals || visuals.includes(reprMap[i]))) return [3 /*break*/, 3];
                                return [4 /*yield*/, reprList[i].createOrUpdate(currentProps, currentData).runInContext(runtime)];
                            case 2:
                                _a.sent();
                                _a.label = 3;
                            case 3:
                                ++i;
                                return [3 /*break*/, 1];
                            case 4:
                                updated.next(version++);
                                return [2 /*return*/];
                        }
                    });
                }); });
            },
            get state() { return currentState; },
            get theme() { return currentTheme; },
            getLoci: function (pickingId) {
                var visuals = currentProps.visuals;
                for (var i = 0, il = reprList.length; i < il; ++i) {
                    if (!visuals || visuals.includes(reprMap[i])) {
                        var loci = reprList[i].getLoci(pickingId);
                        if (!Object(_mol_model_loci__WEBPACK_IMPORTED_MODULE_6__["isEmptyLoci"])(loci))
                            return loci;
                    }
                }
                return _mol_model_loci__WEBPACK_IMPORTED_MODULE_6__["EmptyLoci"];
            },
            mark: function (loci, action) {
                var marked = false;
                for (var i = 0, il = reprList.length; i < il; ++i) {
                    marked = reprList[i].mark(loci, action) || marked;
                }
                return marked;
            },
            setState: function (state) {
                stateBuilder.update(currentState, state);
                for (var i = 0, il = reprList.length; i < il; ++i) {
                    reprList[i].setState(currentState);
                }
            },
            setTheme: function (theme) {
                for (var i = 0, il = reprList.length; i < il; ++i) {
                    reprList[i].setTheme(theme);
                }
            },
            destroy: function () {
                for (var i = 0, il = reprList.length; i < il; ++i) {
                    reprList[i].destroy();
                }
            }
        };
    }
    Representation.createMulti = createMulti;
    function fromRenderObject(label, renderObject) {
        var _this = this;
        var version = 0;
        var updated = new rxjs__WEBPACK_IMPORTED_MODULE_3__["Subject"]();
        var currentState = Representation.createState();
        var currentTheme = _mol_theme_theme__WEBPACK_IMPORTED_MODULE_2__["Theme"].createEmpty();
        var currentParams = _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_1__["ParamDefinition"].clone(_mol_geo_geometry_base__WEBPACK_IMPORTED_MODULE_11__["BaseGeometry"].Params);
        var currentProps = _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_1__["ParamDefinition"].getDefaultValues(_mol_geo_geometry_base__WEBPACK_IMPORTED_MODULE_11__["BaseGeometry"].Params);
        return {
            label: label,
            updated: updated,
            get groupCount() { return renderObject.values.uGroupCount.ref.value; },
            get renderObjects() { return [renderObject]; },
            get props() { return currentProps; },
            get params() { return currentParams; },
            createOrUpdate: function (props) {
                if (props === void 0) { props = {}; }
                var qualityProps = Object(_util__WEBPACK_IMPORTED_MODULE_10__["getQualityProps"])(Object.assign({}, currentProps, props));
                Object.assign(currentProps, props, qualityProps);
                return _mol_task__WEBPACK_IMPORTED_MODULE_4__["Task"].create("Updating '" + label + "' representation", function (runtime) { return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"])(_this, void 0, void 0, function () {
                    return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__generator"])(this, function (_a) {
                        // TODO
                        updated.next(version++);
                        return [2 /*return*/];
                    });
                }); });
            },
            get state() { return currentState; },
            get theme() { return currentTheme; },
            getLoci: function () {
                // TODO
                return _mol_model_loci__WEBPACK_IMPORTED_MODULE_6__["EmptyLoci"];
            },
            mark: function (loci, action) {
                // TODO
                return false;
            },
            setState: function (state) {
                if (state.visible !== undefined)
                    _visual__WEBPACK_IMPORTED_MODULE_12__["Visual"].setVisibility(renderObject, state.visible);
                if (state.alphaFactor !== undefined)
                    _visual__WEBPACK_IMPORTED_MODULE_12__["Visual"].setAlphaFactor(renderObject, state.alphaFactor);
                if (state.pickable !== undefined)
                    _visual__WEBPACK_IMPORTED_MODULE_12__["Visual"].setPickable(renderObject, state.pickable);
                if (state.colorOnly !== undefined)
                    _visual__WEBPACK_IMPORTED_MODULE_12__["Visual"].setColorOnly(renderObject, state.colorOnly);
                if (state.overpaint !== undefined) {
                    // TODO
                }
                if (state.transparency !== undefined) {
                    // TODO
                }
                if (state.transform !== undefined)
                    _visual__WEBPACK_IMPORTED_MODULE_12__["Visual"].setTransform(renderObject, state.transform);
                Representation.updateState(currentState, state);
            },
            setTheme: function () { },
            destroy: function () { }
        };
    }
    Representation.fromRenderObject = fromRenderObject;
})(Representation || (Representation = {}));
//# sourceMappingURL=representation.js.map

/***/ }),

/***/ "./lib/mol-repr/shape/loci/angle.js":
/*!******************************************!*\
  !*** ./lib/mol-repr/shape/loci/angle.js ***!
  \******************************************/
/*! exports provided: AngleParams, AngleRepresentation */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "AngleParams", function() { return AngleParams; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "AngleRepresentation", function() { return AngleRepresentation; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _mol_model_loci__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../../mol-model/loci */ "./lib/mol-model/loci.js");
/* harmony import */ var _mol_geo_geometry_lines_lines__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../../mol-geo/geometry/lines/lines */ "./lib/mol-geo/geometry/lines/lines.js");
/* harmony import */ var _mol_geo_geometry_text_text__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../../mol-geo/geometry/text/text */ "./lib/mol-geo/geometry/text/text.js");
/* harmony import */ var _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../../mol-util/param-definition */ "./lib/mol-util/param-definition.js");
/* harmony import */ var _mol_util_color_names__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../../mol-util/color/names */ "./lib/mol-util/color/names.js");
/* harmony import */ var _representation__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../representation */ "./lib/mol-repr/shape/representation.js");
/* harmony import */ var _representation__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../../representation */ "./lib/mol-repr/representation.js");
/* harmony import */ var _mol_model_shape__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ../../../mol-model/shape */ "./lib/mol-model/shape.js");
/* harmony import */ var _mol_geo_geometry_lines_lines_builder__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ../../../mol-geo/geometry/lines/lines-builder */ "./lib/mol-geo/geometry/lines/lines-builder.js");
/* harmony import */ var _mol_geo_geometry_text_text_builder__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ../../../mol-geo/geometry/text/text-builder */ "./lib/mol-geo/geometry/text/text-builder.js");
/* harmony import */ var _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ../../../mol-math/linear-algebra */ "./lib/mol-math/linear-algebra.js");
/* harmony import */ var _mol_geo_geometry_mesh_mesh__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! ../../../mol-geo/geometry/mesh/mesh */ "./lib/mol-geo/geometry/mesh/mesh.js");
/* harmony import */ var _mol_geo_geometry_mesh_mesh_builder__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! ../../../mol-geo/geometry/mesh/mesh-builder */ "./lib/mol-geo/geometry/mesh/mesh-builder.js");
/* harmony import */ var _mol_math_misc__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! ../../../mol-math/misc */ "./lib/mol-math/misc.js");
/* harmony import */ var _mol_geo_primitive_circle__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! ../../../mol-geo/primitive/circle */ "./lib/mol-geo/primitive/circle.js");
/* harmony import */ var _mol_geo_primitive_primitive__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(/*! ../../../mol-geo/primitive/primitive */ "./lib/mol-geo/primitive/primitive.js");
/* harmony import */ var _mol_util_marker_action__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(/*! ../../../mol-util/marker-action */ "./lib/mol-util/marker-action.js");
/* harmony import */ var _mol_theme_label__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(/*! ../../../mol-theme/label */ "./lib/mol-theme/label.js");
/* harmony import */ var _mol_math_geometry__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(/*! ../../../mol-math/geometry */ "./lib/mol-math/geometry.js");
/* harmony import */ var _common__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(/*! ./common */ "./lib/mol-repr/shape/loci/common.js");
/**
 * Copyright (c) 2019-2020 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */





















var SharedParams = {
    color: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_4__["ParamDefinition"].Color(_mol_util_color_names__WEBPACK_IMPORTED_MODULE_5__["ColorNames"].lightgreen),
    arcScale: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_4__["ParamDefinition"].Numeric(0.7, { min: 0.01, max: 1, step: 0.01 })
};
var LinesParams = Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, _mol_geo_geometry_lines_lines__WEBPACK_IMPORTED_MODULE_2__["Lines"].Params), SharedParams), { lineSizeAttenuation: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_4__["ParamDefinition"].Boolean(true), linesSize: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_4__["ParamDefinition"].Numeric(0.04, { min: 0.01, max: 5, step: 0.01 }), dashLength: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_4__["ParamDefinition"].Numeric(0.04, { min: 0.01, max: 0.2, step: 0.01 }) });
var VectorsParams = Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, LinesParams);
var ArcParams = Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, LinesParams);
var SectorParams = Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, _mol_geo_geometry_mesh_mesh__WEBPACK_IMPORTED_MODULE_12__["Mesh"].Params), SharedParams), { ignoreLight: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_4__["ParamDefinition"].Boolean(true), sectorOpacity: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_4__["ParamDefinition"].Numeric(0.75, { min: 0, max: 1, step: 0.01 }) });
var AngleVisuals = {
    'vectors': function (ctx, getParams) { return Object(_representation__WEBPACK_IMPORTED_MODULE_6__["ShapeRepresentation"])(getVectorsShape, _mol_geo_geometry_lines_lines__WEBPACK_IMPORTED_MODULE_2__["Lines"].Utils, { modifyState: function (s) { return (Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, s), { pickable: false })); } }); },
    'arc': function (ctx, getParams) { return Object(_representation__WEBPACK_IMPORTED_MODULE_6__["ShapeRepresentation"])(getArcShape, _mol_geo_geometry_lines_lines__WEBPACK_IMPORTED_MODULE_2__["Lines"].Utils, { modifyState: function (s) { return (Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, s), { pickable: false })); } }); },
    'sector': function (ctx, getParams) { return Object(_representation__WEBPACK_IMPORTED_MODULE_6__["ShapeRepresentation"])(getSectorShape, _mol_geo_geometry_mesh_mesh__WEBPACK_IMPORTED_MODULE_12__["Mesh"].Utils, { modifyProps: function (p) { return (Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, p), { alpha: p.sectorOpacity })); }, modifyState: function (s) { return (Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, s), { markerActions: _mol_util_marker_action__WEBPACK_IMPORTED_MODULE_17__["MarkerActions"].Highlighting })); } }); },
    'text': function (ctx, getParams) { return Object(_representation__WEBPACK_IMPORTED_MODULE_6__["ShapeRepresentation"])(getTextShape, _mol_geo_geometry_text_text__WEBPACK_IMPORTED_MODULE_3__["Text"].Utils, { modifyState: function (s) { return (Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, s), { markerActions: _mol_util_marker_action__WEBPACK_IMPORTED_MODULE_17__["MarkerAction"].None })); } }); },
};
var AngleParams = Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, VectorsParams), ArcParams), SectorParams), _common__WEBPACK_IMPORTED_MODULE_20__["LociLabelTextParams"]), { visuals: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_4__["ParamDefinition"].MultiSelect(['vectors', 'sector', 'text'], _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_4__["ParamDefinition"].objectToOptions(AngleVisuals)) });
//
function getAngleState() {
    return {
        sphereA: Object(_mol_math_geometry__WEBPACK_IMPORTED_MODULE_19__["Sphere3D"])(),
        sphereB: Object(_mol_math_geometry__WEBPACK_IMPORTED_MODULE_19__["Sphere3D"])(),
        sphereC: Object(_mol_math_geometry__WEBPACK_IMPORTED_MODULE_19__["Sphere3D"])(),
        arcDirA: Object(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_11__["Vec3"])(),
        arcDirC: Object(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_11__["Vec3"])(),
        arcNormal: Object(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_11__["Vec3"])(),
        radius: 0,
        angle: 0,
    };
}
var tmpVec = Object(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_11__["Vec3"])();
var tmpMat = Object(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_11__["Mat4"])();
function setAngleState(triple, state, arcScale) {
    var sphereA = state.sphereA, sphereB = state.sphereB, sphereC = state.sphereC;
    var arcDirA = state.arcDirA, arcDirC = state.arcDirC, arcNormal = state.arcNormal;
    var _a = triple.loci, lociA = _a[0], lociB = _a[1], lociC = _a[2];
    _mol_model_loci__WEBPACK_IMPORTED_MODULE_1__["Loci"].getBoundingSphere(lociA, sphereA);
    _mol_model_loci__WEBPACK_IMPORTED_MODULE_1__["Loci"].getBoundingSphere(lociB, sphereB);
    _mol_model_loci__WEBPACK_IMPORTED_MODULE_1__["Loci"].getBoundingSphere(lociC, sphereC);
    _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_11__["Vec3"].sub(arcDirA, sphereA.center, sphereB.center);
    _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_11__["Vec3"].sub(arcDirC, sphereC.center, sphereB.center);
    _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_11__["Vec3"].cross(arcNormal, arcDirA, arcDirC);
    var len = Math.min(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_11__["Vec3"].magnitude(arcDirA), _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_11__["Vec3"].magnitude(arcDirC));
    var radius = len * arcScale;
    state.radius = radius;
    state.angle = _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_11__["Vec3"].angle(arcDirA, arcDirC);
    return state;
}
function getCircle(state, segmentLength) {
    var radius = state.radius, angle = state.angle;
    var segments = segmentLength ? Object(_mol_math_misc__WEBPACK_IMPORTED_MODULE_14__["arcLength"])(angle, radius) / segmentLength : 32;
    _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_11__["Mat4"].targetTo(tmpMat, state.sphereB.center, state.sphereA.center, state.arcNormal);
    _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_11__["Mat4"].setTranslation(tmpMat, state.sphereB.center);
    _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_11__["Mat4"].mul(tmpMat, tmpMat, _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_11__["Mat4"].rotY180);
    var circle = Object(_mol_geo_primitive_circle__WEBPACK_IMPORTED_MODULE_15__["Circle"])({ radius: radius, thetaLength: angle, segments: segments });
    return Object(_mol_geo_primitive_primitive__WEBPACK_IMPORTED_MODULE_16__["transformPrimitive"])(circle, tmpMat);
}
var tmpState = getAngleState();
function getAngleName(data) {
    return data.triples.length === 1 ? "Angle " + Object(_mol_theme_label__WEBPACK_IMPORTED_MODULE_18__["angleLabel"])(data.triples[0], { measureOnly: true }) : data.triples.length + " Angles";
}
//
function buildVectorsLines(data, props, lines) {
    var builder = _mol_geo_geometry_lines_lines_builder__WEBPACK_IMPORTED_MODULE_9__["LinesBuilder"].create(128, 64, lines);
    for (var i = 0, il = data.triples.length; i < il; ++i) {
        setAngleState(data.triples[i], tmpState, props.arcScale);
        builder.addFixedLengthDashes(tmpState.sphereB.center, tmpState.sphereA.center, props.dashLength, i);
        builder.addFixedLengthDashes(tmpState.sphereB.center, tmpState.sphereC.center, props.dashLength, i);
    }
    return builder.getLines();
}
function getVectorsShape(ctx, data, props, shape) {
    var lines = buildVectorsLines(data, props, shape && shape.geometry);
    var name = getAngleName(data);
    return _mol_model_shape__WEBPACK_IMPORTED_MODULE_8__["Shape"].create(name, data, lines, function () { return props.color; }, function () { return props.linesSize; }, function () { return ''; });
}
//
function buildArcLines(data, props, lines) {
    var builder = _mol_geo_geometry_lines_lines_builder__WEBPACK_IMPORTED_MODULE_9__["LinesBuilder"].create(128, 64, lines);
    for (var i = 0, il = data.triples.length; i < il; ++i) {
        setAngleState(data.triples[i], tmpState, props.arcScale);
        var circle = getCircle(tmpState, props.dashLength);
        var indices = circle.indices, vertices = circle.vertices;
        for (var j = 0, jl = indices.length; j < jl; j += 3) {
            if (j % 2 === 1)
                continue; // draw every other segment to get dashes
            var start = indices[j] * 3;
            var end = indices[j + 1] * 3;
            var startX = vertices[start];
            var startY = vertices[start + 1];
            var startZ = vertices[start + 2];
            var endX = vertices[end];
            var endY = vertices[end + 1];
            var endZ = vertices[end + 2];
            builder.add(startX, startY, startZ, endX, endY, endZ, i);
        }
    }
    return builder.getLines();
}
function getArcShape(ctx, data, props, shape) {
    var lines = buildArcLines(data, props, shape && shape.geometry);
    var name = getAngleName(data);
    return _mol_model_shape__WEBPACK_IMPORTED_MODULE_8__["Shape"].create(name, data, lines, function () { return props.color; }, function () { return props.linesSize; }, function () { return ''; });
}
//
function buildSectorMesh(data, props, mesh) {
    var state = _mol_geo_geometry_mesh_mesh_builder__WEBPACK_IMPORTED_MODULE_13__["MeshBuilder"].createState(128, 64, mesh);
    for (var i = 0, il = data.triples.length; i < il; ++i) {
        setAngleState(data.triples[i], tmpState, props.arcScale);
        var circle = getCircle(tmpState);
        state.currentGroup = i;
        _mol_geo_geometry_mesh_mesh_builder__WEBPACK_IMPORTED_MODULE_13__["MeshBuilder"].addPrimitive(state, _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_11__["Mat4"].id, circle);
        _mol_geo_geometry_mesh_mesh_builder__WEBPACK_IMPORTED_MODULE_13__["MeshBuilder"].addPrimitiveFlipped(state, _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_11__["Mat4"].id, circle);
    }
    return _mol_geo_geometry_mesh_mesh_builder__WEBPACK_IMPORTED_MODULE_13__["MeshBuilder"].getMesh(state);
}
function getSectorShape(ctx, data, props, shape) {
    var mesh = buildSectorMesh(data, props, shape && shape.geometry);
    var name = getAngleName(data);
    var getLabel = function (groupId) { return Object(_mol_theme_label__WEBPACK_IMPORTED_MODULE_18__["angleLabel"])(data.triples[groupId]); };
    return _mol_model_shape__WEBPACK_IMPORTED_MODULE_8__["Shape"].create(name, data, mesh, function () { return props.color; }, function () { return 1; }, getLabel);
}
//
function buildText(data, props, text) {
    var builder = _mol_geo_geometry_text_text_builder__WEBPACK_IMPORTED_MODULE_10__["TextBuilder"].create(props, 128, 64, text);
    for (var i = 0, il = data.triples.length; i < il; ++i) {
        setAngleState(data.triples[i], tmpState, props.arcScale);
        _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_11__["Vec3"].add(tmpVec, tmpState.arcDirA, tmpState.arcDirC);
        _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_11__["Vec3"].setMagnitude(tmpVec, tmpVec, tmpState.radius);
        _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_11__["Vec3"].add(tmpVec, tmpState.sphereB.center, tmpVec);
        var angle = Object(_mol_math_misc__WEBPACK_IMPORTED_MODULE_14__["radToDeg"])(tmpState.angle).toFixed(2);
        var label = props.customText || angle + "\u00B0";
        var radius = Math.max(2, tmpState.sphereA.radius, tmpState.sphereB.radius, tmpState.sphereC.radius);
        var scale = radius / 2;
        builder.add(label, tmpVec[0], tmpVec[1], tmpVec[2], 0.1, scale, i);
    }
    return builder.getText();
}
function getTextShape(ctx, data, props, shape) {
    var text = buildText(data, props, shape && shape.geometry);
    var name = getAngleName(data);
    var getLabel = function (groupId) { return Object(_mol_theme_label__WEBPACK_IMPORTED_MODULE_18__["angleLabel"])(data.triples[groupId]); };
    return _mol_model_shape__WEBPACK_IMPORTED_MODULE_8__["Shape"].create(name, data, text, function () { return props.textColor; }, function () { return props.textSize; }, getLabel);
}
function AngleRepresentation(ctx, getParams) {
    return _representation__WEBPACK_IMPORTED_MODULE_7__["Representation"].createMulti('Angle', ctx, getParams, _representation__WEBPACK_IMPORTED_MODULE_7__["Representation"].StateBuilder, AngleVisuals);
}
//# sourceMappingURL=angle.js.map

/***/ }),

/***/ "./lib/mol-repr/shape/loci/common.js":
/*!*******************************************!*\
  !*** ./lib/mol-repr/shape/loci/common.js ***!
  \*******************************************/
/*! exports provided: MeasurementRepresentationCommonTextParams, LociLabelTextParams */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MeasurementRepresentationCommonTextParams", function() { return MeasurementRepresentationCommonTextParams; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "LociLabelTextParams", function() { return LociLabelTextParams; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../../mol-util/param-definition */ "./lib/mol-util/param-definition.js");
/* harmony import */ var _mol_util_color_names__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../../mol-util/color/names */ "./lib/mol-util/color/names.js");
/* harmony import */ var _mol_geo_geometry_text_text__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../../mol-geo/geometry/text/text */ "./lib/mol-geo/geometry/text/text.js");
/**
 * Copyright (c) 2020 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 * @author David Sehnal <david.sehnal@gmail.com>
 */




var MeasurementRepresentationCommonTextParams = {
    customText: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_1__["ParamDefinition"].Text('', { label: 'Text', description: 'Override the label with custom value.' }),
    textColor: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_1__["ParamDefinition"].Color(_mol_util_color_names__WEBPACK_IMPORTED_MODULE_2__["ColorNames"].black, { isEssential: true }),
    textSize: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_1__["ParamDefinition"].Numeric(0.5, { min: 0.1, max: 5, step: 0.1 }, { isEssential: true }),
};
var LociLabelTextParams = Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, _mol_geo_geometry_text_text__WEBPACK_IMPORTED_MODULE_3__["Text"].Params), MeasurementRepresentationCommonTextParams), { borderWidth: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_1__["ParamDefinition"].Numeric(0.2, { min: 0, max: 0.5, step: 0.01 }) });
//# sourceMappingURL=common.js.map

/***/ }),

/***/ "./lib/mol-repr/shape/loci/dihedral.js":
/*!*********************************************!*\
  !*** ./lib/mol-repr/shape/loci/dihedral.js ***!
  \*********************************************/
/*! exports provided: DihedralParams, DihedralRepresentation */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DihedralParams", function() { return DihedralParams; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DihedralRepresentation", function() { return DihedralRepresentation; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _mol_model_loci__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../../mol-model/loci */ "./lib/mol-model/loci.js");
/* harmony import */ var _mol_geo_geometry_lines_lines__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../../mol-geo/geometry/lines/lines */ "./lib/mol-geo/geometry/lines/lines.js");
/* harmony import */ var _mol_geo_geometry_text_text__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../../mol-geo/geometry/text/text */ "./lib/mol-geo/geometry/text/text.js");
/* harmony import */ var _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../../mol-util/param-definition */ "./lib/mol-util/param-definition.js");
/* harmony import */ var _mol_util_color_names__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../../mol-util/color/names */ "./lib/mol-util/color/names.js");
/* harmony import */ var _representation__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../representation */ "./lib/mol-repr/shape/representation.js");
/* harmony import */ var _representation__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../../representation */ "./lib/mol-repr/representation.js");
/* harmony import */ var _mol_model_shape__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ../../../mol-model/shape */ "./lib/mol-model/shape.js");
/* harmony import */ var _mol_geo_geometry_lines_lines_builder__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ../../../mol-geo/geometry/lines/lines-builder */ "./lib/mol-geo/geometry/lines/lines-builder.js");
/* harmony import */ var _mol_geo_geometry_text_text_builder__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ../../../mol-geo/geometry/text/text-builder */ "./lib/mol-geo/geometry/text/text-builder.js");
/* harmony import */ var _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ../../../mol-math/linear-algebra */ "./lib/mol-math/linear-algebra.js");
/* harmony import */ var _mol_geo_geometry_mesh_mesh__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! ../../../mol-geo/geometry/mesh/mesh */ "./lib/mol-geo/geometry/mesh/mesh.js");
/* harmony import */ var _mol_geo_geometry_mesh_mesh_builder__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! ../../../mol-geo/geometry/mesh/mesh-builder */ "./lib/mol-geo/geometry/mesh/mesh-builder.js");
/* harmony import */ var _mol_math_misc__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! ../../../mol-math/misc */ "./lib/mol-math/misc.js");
/* harmony import */ var _mol_geo_primitive_circle__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! ../../../mol-geo/primitive/circle */ "./lib/mol-geo/primitive/circle.js");
/* harmony import */ var _mol_geo_primitive_primitive__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(/*! ../../../mol-geo/primitive/primitive */ "./lib/mol-geo/primitive/primitive.js");
/* harmony import */ var _mol_util_marker_action__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(/*! ../../../mol-util/marker-action */ "./lib/mol-util/marker-action.js");
/* harmony import */ var _mol_theme_label__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(/*! ../../../mol-theme/label */ "./lib/mol-theme/label.js");
/* harmony import */ var _common__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(/*! ./common */ "./lib/mol-repr/shape/loci/common.js");
/* harmony import */ var _mol_math_geometry__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(/*! ../../../mol-math/geometry */ "./lib/mol-math/geometry.js");
/**
 * Copyright (c) 2019-2020 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */





















var SharedParams = {
    color: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_4__["ParamDefinition"].Color(_mol_util_color_names__WEBPACK_IMPORTED_MODULE_5__["ColorNames"].lightgreen),
    arcScale: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_4__["ParamDefinition"].Numeric(0.7, { min: 0.01, max: 1, step: 0.01 })
};
var LinesParams = Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, _mol_geo_geometry_lines_lines__WEBPACK_IMPORTED_MODULE_2__["Lines"].Params), SharedParams), { lineSizeAttenuation: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_4__["ParamDefinition"].Boolean(true), linesSize: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_4__["ParamDefinition"].Numeric(0.04, { min: 0.01, max: 5, step: 0.01 }), dashLength: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_4__["ParamDefinition"].Numeric(0.04, { min: 0.01, max: 0.2, step: 0.01 }) });
var VectorsParams = Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, LinesParams);
var ExtendersParams = Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, LinesParams);
var ArmsParams = Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, LinesParams);
var ArcParams = Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, LinesParams);
var SectorParams = Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, _mol_geo_geometry_mesh_mesh__WEBPACK_IMPORTED_MODULE_12__["Mesh"].Params), SharedParams), { ignoreLight: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_4__["ParamDefinition"].Boolean(true), sectorOpacity: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_4__["ParamDefinition"].Numeric(0.75, { min: 0, max: 1, step: 0.01 }) });
var DihedralVisuals = {
    'vectors': function (ctx, getParams) { return Object(_representation__WEBPACK_IMPORTED_MODULE_6__["ShapeRepresentation"])(getVectorsShape, _mol_geo_geometry_lines_lines__WEBPACK_IMPORTED_MODULE_2__["Lines"].Utils, { modifyState: function (s) { return (Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, s), { pickable: false })); } }); },
    'extenders': function (ctx, getParams) { return Object(_representation__WEBPACK_IMPORTED_MODULE_6__["ShapeRepresentation"])(getExtendersShape, _mol_geo_geometry_lines_lines__WEBPACK_IMPORTED_MODULE_2__["Lines"].Utils, { modifyState: function (s) { return (Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, s), { pickable: false })); } }); },
    'connector': function (ctx, getParams) { return Object(_representation__WEBPACK_IMPORTED_MODULE_6__["ShapeRepresentation"])(getConnectorShape, _mol_geo_geometry_lines_lines__WEBPACK_IMPORTED_MODULE_2__["Lines"].Utils, { modifyState: function (s) { return (Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, s), { pickable: false })); } }); },
    'arms': function (ctx, getParams) { return Object(_representation__WEBPACK_IMPORTED_MODULE_6__["ShapeRepresentation"])(getArmsShape, _mol_geo_geometry_lines_lines__WEBPACK_IMPORTED_MODULE_2__["Lines"].Utils, { modifyState: function (s) { return (Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, s), { pickable: false })); } }); },
    'arc': function (ctx, getParams) { return Object(_representation__WEBPACK_IMPORTED_MODULE_6__["ShapeRepresentation"])(getArcShape, _mol_geo_geometry_lines_lines__WEBPACK_IMPORTED_MODULE_2__["Lines"].Utils, { modifyState: function (s) { return (Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, s), { pickable: false })); } }); },
    'sector': function (ctx, getParams) { return Object(_representation__WEBPACK_IMPORTED_MODULE_6__["ShapeRepresentation"])(getSectorShape, _mol_geo_geometry_mesh_mesh__WEBPACK_IMPORTED_MODULE_12__["Mesh"].Utils, { modifyProps: function (p) { return (Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, p), { alpha: p.sectorOpacity })); }, modifyState: function (s) { return (Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, s), { markerActions: _mol_util_marker_action__WEBPACK_IMPORTED_MODULE_17__["MarkerActions"].Highlighting })); } }); },
    'text': function (ctx, getParams) { return Object(_representation__WEBPACK_IMPORTED_MODULE_6__["ShapeRepresentation"])(getTextShape, _mol_geo_geometry_text_text__WEBPACK_IMPORTED_MODULE_3__["Text"].Utils, { modifyState: function (s) { return (Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, s), { markerActions: _mol_util_marker_action__WEBPACK_IMPORTED_MODULE_17__["MarkerAction"].None })); } }); },
};
var DihedralParams = Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, VectorsParams), ExtendersParams), ArmsParams), ArcParams), SectorParams), _common__WEBPACK_IMPORTED_MODULE_19__["LociLabelTextParams"]), { visuals: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_4__["ParamDefinition"].MultiSelect(['extenders', 'arms', 'sector', 'text'], _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_4__["ParamDefinition"].objectToOptions(DihedralVisuals)) });
//
function getDihedralState() {
    return {
        sphereA: Object(_mol_math_geometry__WEBPACK_IMPORTED_MODULE_20__["Sphere3D"])(),
        sphereB: Object(_mol_math_geometry__WEBPACK_IMPORTED_MODULE_20__["Sphere3D"])(),
        sphereC: Object(_mol_math_geometry__WEBPACK_IMPORTED_MODULE_20__["Sphere3D"])(),
        sphereD: Object(_mol_math_geometry__WEBPACK_IMPORTED_MODULE_20__["Sphere3D"])(),
        dirBA: Object(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_11__["Vec3"])(),
        dirCD: Object(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_11__["Vec3"])(),
        projA: Object(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_11__["Vec3"])(),
        projD: Object(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_11__["Vec3"])(),
        arcPointA: Object(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_11__["Vec3"])(),
        arcPointD: Object(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_11__["Vec3"])(),
        arcDirA: Object(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_11__["Vec3"])(),
        arcDirD: Object(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_11__["Vec3"])(),
        arcCenter: Object(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_11__["Vec3"])(),
        arcNormal: Object(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_11__["Vec3"])(),
        radius: 0,
        angle: 0,
    };
}
var tmpVec = Object(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_11__["Vec3"])();
var tmpMat = Object(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_11__["Mat4"])();
// TODO improper dihedrals are not handled correctly
function setDihedralState(quad, state, arcScale) {
    var sphereA = state.sphereA, sphereB = state.sphereB, sphereC = state.sphereC, sphereD = state.sphereD, dirBA = state.dirBA, dirCD = state.dirCD, projA = state.projA, projD = state.projD;
    var arcPointA = state.arcPointA, arcPointD = state.arcPointD, arcDirA = state.arcDirA, arcDirD = state.arcDirD, arcCenter = state.arcCenter, arcNormal = state.arcNormal;
    var _a = quad.loci, lociA = _a[0], lociB = _a[1], lociC = _a[2], lociD = _a[3];
    _mol_model_loci__WEBPACK_IMPORTED_MODULE_1__["Loci"].getBoundingSphere(lociA, sphereA);
    _mol_model_loci__WEBPACK_IMPORTED_MODULE_1__["Loci"].getBoundingSphere(lociB, sphereB);
    _mol_model_loci__WEBPACK_IMPORTED_MODULE_1__["Loci"].getBoundingSphere(lociC, sphereC);
    _mol_model_loci__WEBPACK_IMPORTED_MODULE_1__["Loci"].getBoundingSphere(lociD, sphereD);
    _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_11__["Vec3"].add(arcCenter, sphereB.center, sphereC.center);
    _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_11__["Vec3"].scale(arcCenter, arcCenter, 0.5);
    _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_11__["Vec3"].sub(dirBA, sphereA.center, sphereB.center);
    _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_11__["Vec3"].sub(dirCD, sphereD.center, sphereC.center);
    _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_11__["Vec3"].add(arcPointA, arcCenter, dirBA);
    _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_11__["Vec3"].add(arcPointD, arcCenter, dirCD);
    _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_11__["Vec3"].sub(arcNormal, sphereC.center, sphereB.center);
    _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_11__["Vec3"].orthogonalize(arcDirA, arcNormal, dirBA);
    _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_11__["Vec3"].orthogonalize(arcDirD, arcNormal, dirCD);
    _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_11__["Vec3"].projectPointOnVector(projA, arcPointA, arcDirA, arcCenter);
    _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_11__["Vec3"].projectPointOnVector(projD, arcPointD, arcDirD, arcCenter);
    var len = Math.min(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_11__["Vec3"].distance(projA, arcCenter), _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_11__["Vec3"].distance(projD, arcCenter));
    var radius = len * arcScale;
    _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_11__["Vec3"].setMagnitude(arcDirA, arcDirA, radius);
    _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_11__["Vec3"].setMagnitude(arcDirD, arcDirD, radius);
    _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_11__["Vec3"].add(arcPointA, arcCenter, arcDirA);
    _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_11__["Vec3"].add(arcPointD, arcCenter, arcDirD);
    state.radius = radius;
    state.angle = _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_11__["Vec3"].dihedralAngle(sphereA.center, sphereB.center, sphereC.center, sphereD.center);
    _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_11__["Vec3"].matchDirection(tmpVec, arcNormal, _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_11__["Vec3"].sub(tmpVec, arcPointA, sphereA.center));
    var angleA = _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_11__["Vec3"].angle(dirBA, tmpVec);
    var lenA = radius / Math.cos(angleA - _mol_math_misc__WEBPACK_IMPORTED_MODULE_14__["halfPI"]);
    _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_11__["Vec3"].add(projA, sphereB.center, _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_11__["Vec3"].setMagnitude(tmpVec, dirBA, lenA));
    _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_11__["Vec3"].matchDirection(tmpVec, arcNormal, _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_11__["Vec3"].sub(tmpVec, arcPointD, sphereD.center));
    var angleD = _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_11__["Vec3"].angle(dirCD, tmpVec);
    var lenD = radius / Math.cos(angleD - _mol_math_misc__WEBPACK_IMPORTED_MODULE_14__["halfPI"]);
    _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_11__["Vec3"].add(projD, sphereC.center, _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_11__["Vec3"].setMagnitude(tmpVec, dirCD, lenD));
    return state;
}
function getCircle(state, segmentLength) {
    var radius = state.radius, angle = state.angle;
    var segments = segmentLength ? Object(_mol_math_misc__WEBPACK_IMPORTED_MODULE_14__["arcLength"])(angle, radius) / segmentLength : 32;
    _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_11__["Mat4"].targetTo(tmpMat, state.arcCenter, angle < 0 ? state.arcPointD : state.arcPointA, state.arcNormal);
    _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_11__["Mat4"].setTranslation(tmpMat, state.arcCenter);
    _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_11__["Mat4"].mul(tmpMat, tmpMat, _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_11__["Mat4"].rotY180);
    var circle = Object(_mol_geo_primitive_circle__WEBPACK_IMPORTED_MODULE_15__["Circle"])({ radius: radius, thetaLength: Math.abs(angle), segments: segments });
    return Object(_mol_geo_primitive_primitive__WEBPACK_IMPORTED_MODULE_16__["transformPrimitive"])(circle, tmpMat);
}
var tmpState = getDihedralState();
function getDihedralName(data) {
    return data.quads.length === 1 ? "Dihedral " + Object(_mol_theme_label__WEBPACK_IMPORTED_MODULE_18__["dihedralLabel"])(data.quads[0], { measureOnly: true }) : data.quads.length + " Dihedrals";
}
//
function buildVectorsLines(data, props, lines) {
    var builder = _mol_geo_geometry_lines_lines_builder__WEBPACK_IMPORTED_MODULE_9__["LinesBuilder"].create(128, 64, lines);
    for (var i = 0, il = data.quads.length; i < il; ++i) {
        setDihedralState(data.quads[i], tmpState, props.arcScale);
        builder.addFixedLengthDashes(tmpState.arcCenter, tmpState.arcPointA, props.dashLength, i);
        builder.addFixedLengthDashes(tmpState.arcCenter, tmpState.arcPointD, props.dashLength, i);
    }
    return builder.getLines();
}
function getVectorsShape(ctx, data, props, shape) {
    var lines = buildVectorsLines(data, props, shape && shape.geometry);
    var name = getDihedralName(data);
    return _mol_model_shape__WEBPACK_IMPORTED_MODULE_8__["Shape"].create(name, data, lines, function () { return props.color; }, function () { return props.linesSize; }, function () { return ''; });
}
//
function buildConnectorLine(data, props, lines) {
    var builder = _mol_geo_geometry_lines_lines_builder__WEBPACK_IMPORTED_MODULE_9__["LinesBuilder"].create(128, 64, lines);
    for (var i = 0, il = data.quads.length; i < il; ++i) {
        setDihedralState(data.quads[i], tmpState, props.arcScale);
        builder.addFixedLengthDashes(tmpState.sphereB.center, tmpState.sphereC.center, props.dashLength, i);
    }
    return builder.getLines();
}
function getConnectorShape(ctx, data, props, shape) {
    var lines = buildConnectorLine(data, props, shape && shape.geometry);
    var name = getDihedralName(data);
    return _mol_model_shape__WEBPACK_IMPORTED_MODULE_8__["Shape"].create(name, data, lines, function () { return props.color; }, function () { return props.linesSize; }, function () { return ''; });
}
//
function buildArmsLines(data, props, lines) {
    var builder = _mol_geo_geometry_lines_lines_builder__WEBPACK_IMPORTED_MODULE_9__["LinesBuilder"].create(128, 64, lines);
    for (var i = 0, il = data.quads.length; i < il; ++i) {
        setDihedralState(data.quads[i], tmpState, props.arcScale);
        builder.addFixedLengthDashes(tmpState.sphereB.center, tmpState.sphereA.center, props.dashLength, i);
        builder.addFixedLengthDashes(tmpState.sphereC.center, tmpState.sphereD.center, props.dashLength, i);
    }
    return builder.getLines();
}
function getArmsShape(ctx, data, props, shape) {
    var lines = buildArmsLines(data, props, shape && shape.geometry);
    var name = getDihedralName(data);
    return _mol_model_shape__WEBPACK_IMPORTED_MODULE_8__["Shape"].create(name, data, lines, function () { return props.color; }, function () { return props.linesSize; }, function () { return ''; });
}
//
function buildExtendersLines(data, props, lines) {
    var builder = _mol_geo_geometry_lines_lines_builder__WEBPACK_IMPORTED_MODULE_9__["LinesBuilder"].create(128, 64, lines);
    for (var i = 0, il = data.quads.length; i < il; ++i) {
        setDihedralState(data.quads[i], tmpState, props.arcScale);
        builder.addFixedLengthDashes(tmpState.arcPointA, tmpState.projA, props.dashLength, i);
        builder.addFixedLengthDashes(tmpState.arcPointD, tmpState.projD, props.dashLength, i);
    }
    return builder.getLines();
}
function getExtendersShape(ctx, data, props, shape) {
    var lines = buildExtendersLines(data, props, shape && shape.geometry);
    var name = getDihedralName(data);
    return _mol_model_shape__WEBPACK_IMPORTED_MODULE_8__["Shape"].create(name, data, lines, function () { return props.color; }, function () { return props.linesSize; }, function () { return ''; });
}
//
function buildArcLines(data, props, lines) {
    var builder = _mol_geo_geometry_lines_lines_builder__WEBPACK_IMPORTED_MODULE_9__["LinesBuilder"].create(128, 64, lines);
    for (var i = 0, il = data.quads.length; i < il; ++i) {
        setDihedralState(data.quads[i], tmpState, props.arcScale);
        var circle = getCircle(tmpState, props.dashLength);
        var indices = circle.indices, vertices = circle.vertices;
        for (var j = 0, jl = indices.length; j < jl; j += 3) {
            if (j % 2 === 1)
                continue; // draw every other segment to get dashes
            var start = indices[j] * 3;
            var end = indices[j + 1] * 3;
            var startX = vertices[start];
            var startY = vertices[start + 1];
            var startZ = vertices[start + 2];
            var endX = vertices[end];
            var endY = vertices[end + 1];
            var endZ = vertices[end + 2];
            builder.add(startX, startY, startZ, endX, endY, endZ, i);
        }
    }
    return builder.getLines();
}
function getArcShape(ctx, data, props, shape) {
    var lines = buildArcLines(data, props, shape && shape.geometry);
    var name = getDihedralName(data);
    return _mol_model_shape__WEBPACK_IMPORTED_MODULE_8__["Shape"].create(name, data, lines, function () { return props.color; }, function () { return props.linesSize; }, function () { return ''; });
}
//
function buildSectorMesh(data, props, mesh) {
    var state = _mol_geo_geometry_mesh_mesh_builder__WEBPACK_IMPORTED_MODULE_13__["MeshBuilder"].createState(128, 64, mesh);
    for (var i = 0, il = data.quads.length; i < il; ++i) {
        setDihedralState(data.quads[i], tmpState, props.arcScale);
        var circle = getCircle(tmpState);
        state.currentGroup = i;
        _mol_geo_geometry_mesh_mesh_builder__WEBPACK_IMPORTED_MODULE_13__["MeshBuilder"].addPrimitive(state, _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_11__["Mat4"].id, circle);
        _mol_geo_geometry_mesh_mesh_builder__WEBPACK_IMPORTED_MODULE_13__["MeshBuilder"].addPrimitiveFlipped(state, _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_11__["Mat4"].id, circle);
    }
    return _mol_geo_geometry_mesh_mesh_builder__WEBPACK_IMPORTED_MODULE_13__["MeshBuilder"].getMesh(state);
}
function getSectorShape(ctx, data, props, shape) {
    var mesh = buildSectorMesh(data, props, shape && shape.geometry);
    var name = getDihedralName(data);
    var getLabel = function (groupId) { return Object(_mol_theme_label__WEBPACK_IMPORTED_MODULE_18__["dihedralLabel"])(data.quads[groupId]); };
    return _mol_model_shape__WEBPACK_IMPORTED_MODULE_8__["Shape"].create(name, data, mesh, function () { return props.color; }, function () { return 1; }, getLabel);
}
//
function buildText(data, props, text) {
    var builder = _mol_geo_geometry_text_text_builder__WEBPACK_IMPORTED_MODULE_10__["TextBuilder"].create(props, 128, 64, text);
    for (var i = 0, il = data.quads.length; i < il; ++i) {
        setDihedralState(data.quads[i], tmpState, props.arcScale);
        _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_11__["Vec3"].add(tmpVec, tmpState.arcDirA, tmpState.arcDirD);
        _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_11__["Vec3"].setMagnitude(tmpVec, tmpVec, tmpState.radius);
        _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_11__["Vec3"].add(tmpVec, tmpState.arcCenter, tmpVec);
        var angle = Object(_mol_math_misc__WEBPACK_IMPORTED_MODULE_14__["radToDeg"])(tmpState.angle).toFixed(2);
        if (angle === '-0.00')
            angle = '0.00';
        var label = props.customText || angle + "\u00B0";
        var radius = Math.max(2, tmpState.sphereA.radius, tmpState.sphereB.radius, tmpState.sphereC.radius, tmpState.sphereD.radius);
        var scale = radius / 2;
        builder.add(label, tmpVec[0], tmpVec[1], tmpVec[2], 0.1, scale, i);
    }
    return builder.getText();
}
function getTextShape(ctx, data, props, shape) {
    var text = buildText(data, props, shape && shape.geometry);
    var name = getDihedralName(data);
    var getLabel = function (groupId) { return Object(_mol_theme_label__WEBPACK_IMPORTED_MODULE_18__["dihedralLabel"])(data.quads[groupId]); };
    return _mol_model_shape__WEBPACK_IMPORTED_MODULE_8__["Shape"].create(name, data, text, function () { return props.textColor; }, function () { return props.textSize; }, getLabel);
}
function DihedralRepresentation(ctx, getParams) {
    return _representation__WEBPACK_IMPORTED_MODULE_7__["Representation"].createMulti('Dihedral', ctx, getParams, _representation__WEBPACK_IMPORTED_MODULE_7__["Representation"].StateBuilder, DihedralVisuals);
}
//# sourceMappingURL=dihedral.js.map

/***/ }),

/***/ "./lib/mol-repr/shape/loci/distance.js":
/*!*********************************************!*\
  !*** ./lib/mol-repr/shape/loci/distance.js ***!
  \*********************************************/
/*! exports provided: DistanceParams, DistanceRepresentation */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DistanceParams", function() { return DistanceParams; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DistanceRepresentation", function() { return DistanceRepresentation; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _mol_model_loci__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../../mol-model/loci */ "./lib/mol-model/loci.js");
/* harmony import */ var _mol_geo_geometry_lines_lines__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../../mol-geo/geometry/lines/lines */ "./lib/mol-geo/geometry/lines/lines.js");
/* harmony import */ var _mol_geo_geometry_text_text__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../../mol-geo/geometry/text/text */ "./lib/mol-geo/geometry/text/text.js");
/* harmony import */ var _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../../mol-util/param-definition */ "./lib/mol-util/param-definition.js");
/* harmony import */ var _mol_util_color_names__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../../mol-util/color/names */ "./lib/mol-util/color/names.js");
/* harmony import */ var _representation__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../representation */ "./lib/mol-repr/shape/representation.js");
/* harmony import */ var _representation__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../../representation */ "./lib/mol-repr/representation.js");
/* harmony import */ var _mol_model_shape__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ../../../mol-model/shape */ "./lib/mol-model/shape.js");
/* harmony import */ var _mol_geo_geometry_lines_lines_builder__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ../../../mol-geo/geometry/lines/lines-builder */ "./lib/mol-geo/geometry/lines/lines-builder.js");
/* harmony import */ var _mol_geo_geometry_text_text_builder__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ../../../mol-geo/geometry/text/text-builder */ "./lib/mol-geo/geometry/text/text-builder.js");
/* harmony import */ var _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ../../../mol-math/linear-algebra */ "./lib/mol-math/linear-algebra.js");
/* harmony import */ var _mol_util_marker_action__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! ../../../mol-util/marker-action */ "./lib/mol-util/marker-action.js");
/* harmony import */ var _mol_theme_label__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! ../../../mol-theme/label */ "./lib/mol-theme/label.js");
/* harmony import */ var _common__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! ./common */ "./lib/mol-repr/shape/loci/common.js");
/* harmony import */ var _mol_math_geometry__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! ../../../mol-math/geometry */ "./lib/mol-math/geometry.js");
/**
 * Copyright (c) 2019-2020 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */
















var SharedParams = {
    unitLabel: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_4__["ParamDefinition"].Text('\u212B', { isEssential: true })
};
var LineParams = Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, _mol_geo_geometry_lines_lines__WEBPACK_IMPORTED_MODULE_2__["Lines"].Params), SharedParams), { lineSizeAttenuation: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_4__["ParamDefinition"].Boolean(true), linesColor: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_4__["ParamDefinition"].Color(_mol_util_color_names__WEBPACK_IMPORTED_MODULE_5__["ColorNames"].lightgreen, { isEssential: true }), linesSize: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_4__["ParamDefinition"].Numeric(0.075, { min: 0.01, max: 5, step: 0.01 }), dashLength: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_4__["ParamDefinition"].Numeric(0.2, { min: 0.01, max: 0.2, step: 0.01 }) });
var TextParams = Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, _common__WEBPACK_IMPORTED_MODULE_14__["LociLabelTextParams"]), SharedParams);
var DistanceVisuals = {
    'lines': function (ctx, getParams) { return Object(_representation__WEBPACK_IMPORTED_MODULE_6__["ShapeRepresentation"])(getLinesShape, _mol_geo_geometry_lines_lines__WEBPACK_IMPORTED_MODULE_2__["Lines"].Utils, { modifyState: function (s) { return (Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, s), { markerActions: _mol_util_marker_action__WEBPACK_IMPORTED_MODULE_12__["MarkerActions"].Highlighting })); } }); },
    'text': function (ctx, getParams) { return Object(_representation__WEBPACK_IMPORTED_MODULE_6__["ShapeRepresentation"])(getTextShape, _mol_geo_geometry_text_text__WEBPACK_IMPORTED_MODULE_3__["Text"].Utils, { modifyState: function (s) { return (Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, s), { markerActions: _mol_util_marker_action__WEBPACK_IMPORTED_MODULE_12__["MarkerAction"].None })); } }); },
};
var DistanceParams = Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, LineParams), TextParams), { visuals: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_4__["ParamDefinition"].MultiSelect(['lines', 'text'], _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_4__["ParamDefinition"].objectToOptions(DistanceVisuals)) });
//
function getDistanceState() {
    return {
        sphereA: Object(_mol_math_geometry__WEBPACK_IMPORTED_MODULE_15__["Sphere3D"])(),
        sphereB: Object(_mol_math_geometry__WEBPACK_IMPORTED_MODULE_15__["Sphere3D"])(),
        center: Object(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_11__["Vec3"])(),
        distance: 0,
    };
}
function setDistanceState(pair, state) {
    var sphereA = state.sphereA, sphereB = state.sphereB, center = state.center;
    var _a = pair.loci, lociA = _a[0], lociB = _a[1];
    _mol_model_loci__WEBPACK_IMPORTED_MODULE_1__["Loci"].getBoundingSphere(lociA, sphereA);
    _mol_model_loci__WEBPACK_IMPORTED_MODULE_1__["Loci"].getBoundingSphere(lociB, sphereB);
    _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_11__["Vec3"].add(center, sphereA.center, sphereB.center);
    _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_11__["Vec3"].scale(center, center, 0.5);
    state.distance = _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_11__["Vec3"].distance(sphereA.center, sphereB.center);
    return state;
}
var tmpState = getDistanceState();
function getDistanceName(data, unitLabel) {
    return data.pairs.length === 1 ? "Distance " + Object(_mol_theme_label__WEBPACK_IMPORTED_MODULE_13__["distanceLabel"])(data.pairs[0], { unitLabel: unitLabel, measureOnly: true }) : data.pairs.length + " Distances";
}
//
function buildLines(data, props, lines) {
    var builder = _mol_geo_geometry_lines_lines_builder__WEBPACK_IMPORTED_MODULE_9__["LinesBuilder"].create(128, 64, lines);
    for (var i = 0, il = data.pairs.length; i < il; ++i) {
        setDistanceState(data.pairs[i], tmpState);
        builder.addFixedLengthDashes(tmpState.sphereA.center, tmpState.sphereB.center, props.dashLength, i);
    }
    return builder.getLines();
}
function getLinesShape(ctx, data, props, shape) {
    var lines = buildLines(data, props, shape && shape.geometry);
    var name = getDistanceName(data, props.unitLabel);
    var getLabel = function (groupId) { return Object(_mol_theme_label__WEBPACK_IMPORTED_MODULE_13__["distanceLabel"])(data.pairs[groupId], props); };
    return _mol_model_shape__WEBPACK_IMPORTED_MODULE_8__["Shape"].create(name, data, lines, function () { return props.linesColor; }, function () { return props.linesSize; }, getLabel);
}
//
function buildText(data, props, text) {
    var builder = _mol_geo_geometry_text_text_builder__WEBPACK_IMPORTED_MODULE_10__["TextBuilder"].create(props, 128, 64, text);
    for (var i = 0, il = data.pairs.length; i < il; ++i) {
        setDistanceState(data.pairs[i], tmpState);
        var center = tmpState.center, distance = tmpState.distance, sphereA = tmpState.sphereA, sphereB = tmpState.sphereB;
        var label = props.customText || distance.toFixed(2) + " " + props.unitLabel;
        var radius = Math.max(2, sphereA.radius, sphereB.radius);
        var scale = radius / 2;
        builder.add(label, center[0], center[1], center[2], 1, scale, i);
    }
    return builder.getText();
}
function getTextShape(ctx, data, props, shape) {
    var text = buildText(data, props, shape && shape.geometry);
    var name = getDistanceName(data, props.unitLabel);
    var getLabel = function (groupId) { return Object(_mol_theme_label__WEBPACK_IMPORTED_MODULE_13__["distanceLabel"])(data.pairs[groupId], props); };
    return _mol_model_shape__WEBPACK_IMPORTED_MODULE_8__["Shape"].create(name, data, text, function () { return props.textColor; }, function () { return props.textSize; }, getLabel);
}
function DistanceRepresentation(ctx, getParams) {
    return _representation__WEBPACK_IMPORTED_MODULE_7__["Representation"].createMulti('Distance', ctx, getParams, _representation__WEBPACK_IMPORTED_MODULE_7__["Representation"].StateBuilder, DistanceVisuals);
}
//# sourceMappingURL=distance.js.map

/***/ }),

/***/ "./lib/mol-repr/shape/loci/label.js":
/*!******************************************!*\
  !*** ./lib/mol-repr/shape/loci/label.js ***!
  \******************************************/
/*! exports provided: LabelParams, LabelRepresentation */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "LabelParams", function() { return LabelParams; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "LabelRepresentation", function() { return LabelRepresentation; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _mol_model_loci__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../../mol-model/loci */ "./lib/mol-model/loci.js");
/* harmony import */ var _mol_geo_geometry_text_text__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../../mol-geo/geometry/text/text */ "./lib/mol-geo/geometry/text/text.js");
/* harmony import */ var _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../../mol-util/param-definition */ "./lib/mol-util/param-definition.js");
/* harmony import */ var _representation__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../representation */ "./lib/mol-repr/shape/representation.js");
/* harmony import */ var _representation__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../representation */ "./lib/mol-repr/representation.js");
/* harmony import */ var _mol_model_shape__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../../../mol-model/shape */ "./lib/mol-model/shape.js");
/* harmony import */ var _mol_geo_geometry_text_text_builder__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../../../mol-geo/geometry/text/text-builder */ "./lib/mol-geo/geometry/text/text-builder.js");
/* harmony import */ var _mol_math_geometry__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ../../../mol-math/geometry */ "./lib/mol-math/geometry.js");
/* harmony import */ var _mol_theme_label__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ../../../mol-theme/label */ "./lib/mol-theme/label.js");
/* harmony import */ var _common__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ./common */ "./lib/mol-repr/shape/loci/common.js");
/**
 * Copyright (c) 2019 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */











var TextParams = Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, _common__WEBPACK_IMPORTED_MODULE_10__["LociLabelTextParams"]), { offsetZ: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_3__["ParamDefinition"].Numeric(2, { min: 0, max: 10, step: 0.1 }) });
var LabelVisuals = {
    'text': function (ctx, getParams) { return Object(_representation__WEBPACK_IMPORTED_MODULE_4__["ShapeRepresentation"])(getTextShape, _mol_geo_geometry_text_text__WEBPACK_IMPORTED_MODULE_2__["Text"].Utils, { modifyState: function (s) { return (Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, s), { pickable: false })); } }); },
};
var LabelParams = Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, TextParams), { scaleByRadius: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_3__["ParamDefinition"].Boolean(true), visuals: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_3__["ParamDefinition"].MultiSelect(['text'], _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_3__["ParamDefinition"].objectToOptions(LabelVisuals)) });
//
var tmpSphere = Object(_mol_math_geometry__WEBPACK_IMPORTED_MODULE_8__["Sphere3D"])();
function label(info, condensed) {
    if (condensed === void 0) { condensed = false; }
    return info.label || Object(_mol_theme_label__WEBPACK_IMPORTED_MODULE_9__["lociLabel"])(info.loci, { hidePrefix: true, htmlStyling: false, condensed: condensed });
}
function getLabelName(data) {
    return data.infos.length === 1 ? label(data.infos[0]) : data.infos.length + " Labels";
}
//
function buildText(data, props, text) {
    var builder = _mol_geo_geometry_text_text_builder__WEBPACK_IMPORTED_MODULE_7__["TextBuilder"].create(props, 128, 64, text);
    var customLabel = props.customText.trim();
    for (var i = 0, il = data.infos.length; i < il; ++i) {
        var info = data.infos[i];
        var sphere = _mol_model_loci__WEBPACK_IMPORTED_MODULE_1__["Loci"].getBoundingSphere(info.loci, tmpSphere);
        if (!sphere)
            continue;
        var center = sphere.center, radius = sphere.radius;
        var text_1 = customLabel || label(info, true);
        builder.add(text_1, center[0], center[1], center[2], props.scaleByRadius ? radius / 0.9 : 0, props.scaleByRadius ? Math.max(1, radius) : 1, i);
    }
    return builder.getText();
}
function getTextShape(ctx, data, props, shape) {
    var text = buildText(data, props, shape && shape.geometry);
    var name = getLabelName(data);
    var customLabel = props.customText.trim();
    var getLabel = customLabel
        ? function (groupId) {
            return customLabel;
        } : function (groupId) {
        return label(data.infos[groupId]);
    };
    return _mol_model_shape__WEBPACK_IMPORTED_MODULE_6__["Shape"].create(name, data, text, function () { return props.textColor; }, function () { return props.textSize; }, getLabel);
}
function LabelRepresentation(ctx, getParams) {
    return _representation__WEBPACK_IMPORTED_MODULE_5__["Representation"].createMulti('Label', ctx, getParams, _representation__WEBPACK_IMPORTED_MODULE_5__["Representation"].StateBuilder, LabelVisuals);
}
//# sourceMappingURL=label.js.map

/***/ }),

/***/ "./lib/mol-repr/shape/loci/orientation.js":
/*!************************************************!*\
  !*** ./lib/mol-repr/shape/loci/orientation.js ***!
  \************************************************/
/*! exports provided: OrientationParams, OrientationRepresentation */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "OrientationParams", function() { return OrientationParams; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "OrientationRepresentation", function() { return OrientationRepresentation; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _mol_model_loci__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../../mol-model/loci */ "./lib/mol-model/loci.js");
/* harmony import */ var _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../../mol-util/param-definition */ "./lib/mol-util/param-definition.js");
/* harmony import */ var _mol_util_color_names__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../../mol-util/color/names */ "./lib/mol-util/color/names.js");
/* harmony import */ var _representation__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../representation */ "./lib/mol-repr/shape/representation.js");
/* harmony import */ var _representation__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../representation */ "./lib/mol-repr/representation.js");
/* harmony import */ var _mol_model_shape__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../../../mol-model/shape */ "./lib/mol-model/shape.js");
/* harmony import */ var _mol_geo_geometry_mesh_mesh__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../../../mol-geo/geometry/mesh/mesh */ "./lib/mol-geo/geometry/mesh/mesh.js");
/* harmony import */ var _mol_geo_geometry_mesh_mesh_builder__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ../../../mol-geo/geometry/mesh/mesh-builder */ "./lib/mol-geo/geometry/mesh/mesh-builder.js");
/* harmony import */ var _mol_theme_label__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ../../../mol-theme/label */ "./lib/mol-theme/label.js");
/* harmony import */ var _mol_geo_geometry_mesh_builder_axes__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ../../../mol-geo/geometry/mesh/builder/axes */ "./lib/mol-geo/geometry/mesh/builder/axes.js");
/* harmony import */ var _mol_geo_geometry_mesh_builder_box__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ../../../mol-geo/geometry/mesh/builder/box */ "./lib/mol-geo/geometry/mesh/builder/box.js");
/* harmony import */ var _mol_geo_geometry_mesh_builder_ellipsoid__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! ../../../mol-geo/geometry/mesh/builder/ellipsoid */ "./lib/mol-geo/geometry/mesh/builder/ellipsoid.js");
/* harmony import */ var _mol_math_geometry__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! ../../../mol-math/geometry */ "./lib/mol-math/geometry.js");
/* harmony import */ var _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! ../../../mol-math/linear-algebra */ "./lib/mol-math/linear-algebra.js");
/* harmony import */ var _mol_util_marker_action__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! ../../../mol-util/marker-action */ "./lib/mol-util/marker-action.js");
/**
 * Copyright (c) 2019 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */
















var SharedParams = {
    color: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_2__["ParamDefinition"].Color(_mol_util_color_names__WEBPACK_IMPORTED_MODULE_3__["ColorNames"].orange),
    scale: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_2__["ParamDefinition"].Numeric(2, { min: 0.1, max: 10, step: 0.1 })
};
var AxesParams = Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, _mol_geo_geometry_mesh_mesh__WEBPACK_IMPORTED_MODULE_7__["Mesh"].Params), SharedParams);
var BoxParams = Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, _mol_geo_geometry_mesh_mesh__WEBPACK_IMPORTED_MODULE_7__["Mesh"].Params), SharedParams);
var EllipsoidParams = Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, _mol_geo_geometry_mesh_mesh__WEBPACK_IMPORTED_MODULE_7__["Mesh"].Params), SharedParams);
var OrientationVisuals = {
    'axes': function (ctx, getParams) { return Object(_representation__WEBPACK_IMPORTED_MODULE_4__["ShapeRepresentation"])(getAxesShape, _mol_geo_geometry_mesh_mesh__WEBPACK_IMPORTED_MODULE_7__["Mesh"].Utils); },
    'box': function (ctx, getParams) { return Object(_representation__WEBPACK_IMPORTED_MODULE_4__["ShapeRepresentation"])(getBoxShape, _mol_geo_geometry_mesh_mesh__WEBPACK_IMPORTED_MODULE_7__["Mesh"].Utils); },
    'ellipsoid': function (ctx, getParams) { return Object(_representation__WEBPACK_IMPORTED_MODULE_4__["ShapeRepresentation"])(getEllipsoidShape, _mol_geo_geometry_mesh_mesh__WEBPACK_IMPORTED_MODULE_7__["Mesh"].Utils); },
};
var OrientationParams = Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, AxesParams), BoxParams), { visuals: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_2__["ParamDefinition"].MultiSelect(['box'], _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_2__["ParamDefinition"].objectToOptions(OrientationVisuals)), color: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_2__["ParamDefinition"].Color(_mol_util_color_names__WEBPACK_IMPORTED_MODULE_3__["ColorNames"].orange), scale: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_2__["ParamDefinition"].Numeric(2, { min: 0.1, max: 5, step: 0.1 }) });
//
function orientationLabel(loci) {
    var label = Object(_mol_theme_label__WEBPACK_IMPORTED_MODULE_9__["lociLabel"])(loci, { countsOnly: true });
    return "Principal Axes of " + label;
}
function getOrientationName(data) {
    return data.locis.length === 1 ? orientationLabel(data.locis[0]) : data.locis.length + " Orientations";
}
//
function buildAxesMesh(data, props, mesh) {
    var state = _mol_geo_geometry_mesh_mesh_builder__WEBPACK_IMPORTED_MODULE_8__["MeshBuilder"].createState(256, 128, mesh);
    for (var i = 0, il = data.locis.length; i < il; ++i) {
        var principalAxes = _mol_model_loci__WEBPACK_IMPORTED_MODULE_1__["Loci"].getPrincipalAxes(data.locis[i]);
        if (principalAxes) {
            state.currentGroup = i;
            Object(_mol_geo_geometry_mesh_builder_axes__WEBPACK_IMPORTED_MODULE_10__["addAxes"])(state, principalAxes.momentsAxes, props.scale, 2, 20);
        }
    }
    return _mol_geo_geometry_mesh_mesh_builder__WEBPACK_IMPORTED_MODULE_8__["MeshBuilder"].getMesh(state);
}
function getAxesShape(ctx, data, props, shape) {
    var mesh = buildAxesMesh(data, props, shape && shape.geometry);
    var name = getOrientationName(data);
    var getLabel = function (groupId) {
        return orientationLabel(data.locis[groupId]);
    };
    return _mol_model_shape__WEBPACK_IMPORTED_MODULE_6__["Shape"].create(name, data, mesh, function () { return props.color; }, function () { return 1; }, getLabel);
}
//
function buildBoxMesh(data, props, mesh) {
    var state = _mol_geo_geometry_mesh_mesh_builder__WEBPACK_IMPORTED_MODULE_8__["MeshBuilder"].createState(256, 128, mesh);
    for (var i = 0, il = data.locis.length; i < il; ++i) {
        var principalAxes = _mol_model_loci__WEBPACK_IMPORTED_MODULE_1__["Loci"].getPrincipalAxes(data.locis[i]);
        if (principalAxes) {
            state.currentGroup = i;
            Object(_mol_geo_geometry_mesh_builder_box__WEBPACK_IMPORTED_MODULE_11__["addOrientedBox"])(state, principalAxes.boxAxes, props.scale, 2, 20);
        }
    }
    return _mol_geo_geometry_mesh_mesh_builder__WEBPACK_IMPORTED_MODULE_8__["MeshBuilder"].getMesh(state);
}
function getBoxShape(ctx, data, props, shape) {
    var mesh = buildBoxMesh(data, props, shape && shape.geometry);
    var name = getOrientationName(data);
    var getLabel = function (groupId) {
        return orientationLabel(data.locis[groupId]);
    };
    return _mol_model_shape__WEBPACK_IMPORTED_MODULE_6__["Shape"].create(name, data, mesh, function () { return props.color; }, function () { return 1; }, getLabel);
}
//
function buildEllipsoidMesh(data, props, mesh) {
    var state = _mol_geo_geometry_mesh_mesh_builder__WEBPACK_IMPORTED_MODULE_8__["MeshBuilder"].createState(256, 128, mesh);
    for (var i = 0, il = data.locis.length; i < il; ++i) {
        var principalAxes = _mol_model_loci__WEBPACK_IMPORTED_MODULE_1__["Loci"].getPrincipalAxes(data.locis[i]);
        if (principalAxes) {
            var axes = principalAxes.boxAxes;
            var origin_1 = axes.origin, dirA = axes.dirA, dirB = axes.dirB;
            var size = _mol_math_geometry__WEBPACK_IMPORTED_MODULE_13__["Axes3D"].size(Object(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_14__["Vec3"])(), axes);
            _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_14__["Vec3"].scale(size, size, 0.5);
            var radiusScale = _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_14__["Vec3"].create(size[2], size[1], size[0]);
            state.currentGroup = i;
            Object(_mol_geo_geometry_mesh_builder_ellipsoid__WEBPACK_IMPORTED_MODULE_12__["addEllipsoid"])(state, origin_1, dirA, dirB, radiusScale, 2);
        }
    }
    return _mol_geo_geometry_mesh_mesh_builder__WEBPACK_IMPORTED_MODULE_8__["MeshBuilder"].getMesh(state);
}
function getEllipsoidShape(ctx, data, props, shape) {
    var mesh = buildEllipsoidMesh(data, props, shape && shape.geometry);
    var name = getOrientationName(data);
    var getLabel = function (groupId) {
        return orientationLabel(data.locis[groupId]);
    };
    return _mol_model_shape__WEBPACK_IMPORTED_MODULE_6__["Shape"].create(name, data, mesh, function () { return props.color; }, function () { return 1; }, getLabel);
}
function OrientationRepresentation(ctx, getParams) {
    var repr = _representation__WEBPACK_IMPORTED_MODULE_5__["Representation"].createMulti('Orientation', ctx, getParams, _representation__WEBPACK_IMPORTED_MODULE_5__["Representation"].StateBuilder, OrientationVisuals);
    repr.setState({ markerActions: _mol_util_marker_action__WEBPACK_IMPORTED_MODULE_15__["MarkerActions"].Highlighting });
    return repr;
}
//# sourceMappingURL=orientation.js.map

/***/ }),

/***/ "./lib/mol-repr/shape/model/unitcell.js":
/*!**********************************************!*\
  !*** ./lib/mol-repr/shape/model/unitcell.js ***!
  \**********************************************/
/*! exports provided: UnitcellParams, getUnitcellData, UnitcellRepresentation */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "UnitcellParams", function() { return UnitcellParams; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getUnitcellData", function() { return getUnitcellData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "UnitcellRepresentation", function() { return UnitcellRepresentation; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _mol_model_structure__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../../mol-model/structure */ "./lib/mol-model/structure.js");
/* harmony import */ var _representation__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../representation */ "./lib/mol-repr/shape/representation.js");
/* harmony import */ var _mol_model_shape__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../../mol-model/shape */ "./lib/mol-model/shape.js");
/* harmony import */ var _mol_util_color_names__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../../mol-util/color/names */ "./lib/mol-util/color/names.js");
/* harmony import */ var _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../../mol-util/param-definition */ "./lib/mol-util/param-definition.js");
/* harmony import */ var _mol_geo_geometry_mesh_mesh__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../../../mol-geo/geometry/mesh/mesh */ "./lib/mol-geo/geometry/mesh/mesh.js");
/* harmony import */ var _mol_geo_geometry_mesh_mesh_builder__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../../../mol-geo/geometry/mesh/mesh-builder */ "./lib/mol-geo/geometry/mesh/mesh-builder.js");
/* harmony import */ var _mol_geo_primitive_box__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ../../../mol-geo/primitive/box */ "./lib/mol-geo/primitive/box.js");
/* harmony import */ var _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ../../../mol-math/linear-algebra */ "./lib/mol-math/linear-algebra.js");
/* harmony import */ var _mol_geo_primitive_cage__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ../../../mol-geo/primitive/cage */ "./lib/mol-geo/primitive/cage.js");
/* harmony import */ var _mol_math_geometry__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ../../../mol-math/geometry */ "./lib/mol-math/geometry.js");
/* harmony import */ var _representation__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! ../../representation */ "./lib/mol-repr/representation.js");
/**
 * Copyright (c) 2019-2020 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */













var translate05 = _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_9__["Mat4"].fromTranslation(Object(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_9__["Mat4"])(), _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_9__["Vec3"].create(0.5, 0.5, 0.5));
var unitCage = Object(_mol_geo_primitive_cage__WEBPACK_IMPORTED_MODULE_10__["transformCage"])(Object(_mol_geo_primitive_cage__WEBPACK_IMPORTED_MODULE_10__["cloneCage"])(Object(_mol_geo_primitive_box__WEBPACK_IMPORTED_MODULE_8__["BoxCage"])()), translate05);
var tmpRef = Object(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_9__["Vec3"])();
var tmpTranslate = Object(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_9__["Mat4"])();
var CellRef = {
    origin: 'Origin',
    model: 'Model'
};
var CellAttachment = {
    corner: 'Corner',
    center: 'Center'
};
var CellParams = Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, _mol_geo_geometry_mesh_mesh__WEBPACK_IMPORTED_MODULE_6__["Mesh"].Params), { cellColor: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_5__["ParamDefinition"].Color(_mol_util_color_names__WEBPACK_IMPORTED_MODULE_4__["ColorNames"].orange), cellScale: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_5__["ParamDefinition"].Numeric(2, { min: 0.1, max: 5, step: 0.1 }), ref: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_5__["ParamDefinition"].Select('model', _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_5__["ParamDefinition"].objectToOptions(CellRef), { isEssential: true }), attachment: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_5__["ParamDefinition"].Select('corner', _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_5__["ParamDefinition"].objectToOptions(CellAttachment), { isEssential: true }) });
var UnitcellVisuals = {
    'mesh': function (ctx, getParams) { return Object(_representation__WEBPACK_IMPORTED_MODULE_2__["ShapeRepresentation"])(getUnitcellShape, _mol_geo_geometry_mesh_mesh__WEBPACK_IMPORTED_MODULE_6__["Mesh"].Utils); },
};
var UnitcellParams = Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, CellParams);
function getUnitcellMesh(data, props, mesh) {
    var state = _mol_geo_geometry_mesh_mesh_builder__WEBPACK_IMPORTED_MODULE_7__["MeshBuilder"].createState(256, 128, mesh);
    var fromFractional = data.symmetry.spacegroup.cell.fromFractional;
    _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_9__["Vec3"].copy(tmpRef, data.ref);
    if (props.attachment === 'center') {
        _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_9__["Vec3"].trunc(tmpRef, tmpRef);
        _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_9__["Vec3"].subScalar(tmpRef, tmpRef, 0.5);
    }
    else {
        _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_9__["Vec3"].floor(tmpRef, tmpRef);
    }
    _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_9__["Mat4"].fromTranslation(tmpTranslate, tmpRef);
    var cellCage = Object(_mol_geo_primitive_cage__WEBPACK_IMPORTED_MODULE_10__["transformCage"])(Object(_mol_geo_primitive_cage__WEBPACK_IMPORTED_MODULE_10__["cloneCage"])(unitCage), tmpTranslate);
    var radius = (Math.cbrt(data.symmetry.spacegroup.cell.volume) / 300) * props.cellScale;
    state.currentGroup = 1;
    _mol_geo_geometry_mesh_mesh_builder__WEBPACK_IMPORTED_MODULE_7__["MeshBuilder"].addCage(state, fromFractional, cellCage, radius, 2, 20);
    var sphere = _mol_math_geometry__WEBPACK_IMPORTED_MODULE_11__["Sphere3D"].fromDimensionsAndTransform(Object(_mol_math_geometry__WEBPACK_IMPORTED_MODULE_11__["Sphere3D"])(), _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_9__["Vec3"].unit, fromFractional);
    _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_9__["Vec3"].transformMat4(tmpRef, tmpRef, fromFractional);
    _mol_math_geometry__WEBPACK_IMPORTED_MODULE_11__["Sphere3D"].translate(sphere, sphere, tmpRef);
    _mol_math_geometry__WEBPACK_IMPORTED_MODULE_11__["Sphere3D"].expand(sphere, sphere, radius);
    var m = _mol_geo_geometry_mesh_mesh_builder__WEBPACK_IMPORTED_MODULE_7__["MeshBuilder"].getMesh(state);
    m.setBoundingSphere(sphere);
    return m;
}
function getUnitcellShape(ctx, data, props, shape) {
    var geo = getUnitcellMesh(data, props, shape && shape.geometry);
    var label = _mol_model_structure__WEBPACK_IMPORTED_MODULE_1__["Symmetry"].getUnitcellLabel(data.symmetry);
    return _mol_model_shape__WEBPACK_IMPORTED_MODULE_3__["Shape"].create(label, data, geo, function () { return props.cellColor; }, function () { return 1; }, function () { return label; });
}
//
function getUnitcellData(model, symmetry, props) {
    var ref = Object(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_9__["Vec3"])();
    if (props.ref === 'model') {
        _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_9__["Vec3"].transformMat4(ref, _mol_model_structure__WEBPACK_IMPORTED_MODULE_1__["Model"].getCenter(model), symmetry.spacegroup.cell.toFractional);
    }
    return { symmetry: symmetry, ref: ref };
}
function UnitcellRepresentation(ctx, getParams) {
    return _representation__WEBPACK_IMPORTED_MODULE_12__["Representation"].createMulti('Unit Cell', ctx, getParams, _representation__WEBPACK_IMPORTED_MODULE_12__["Representation"].StateBuilder, UnitcellVisuals);
}
//# sourceMappingURL=unitcell.js.map

/***/ }),

/***/ "./lib/mol-repr/shape/representation.js":
/*!**********************************************!*\
  !*** ./lib/mol-repr/shape/representation.js ***!
  \**********************************************/
/*! exports provided: ShapeRepresentation */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ShapeRepresentation", function() { return ShapeRepresentation; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _mol_geo_geometry_geometry__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../mol-geo/geometry/geometry */ "./lib/mol-geo/geometry/geometry.js");
/* harmony import */ var _representation__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../representation */ "./lib/mol-repr/representation.js");
/* harmony import */ var _mol_model_shape__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../mol-model/shape */ "./lib/mol-model/shape.js");
/* harmony import */ var rxjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! rxjs */ "./node_modules/rxjs/_esm5/index.js");
/* harmony import */ var _mol_gl_render_object__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../mol-gl/render-object */ "./lib/mol-gl/render-object.js");
/* harmony import */ var _mol_theme_theme__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../../mol-theme/theme */ "./lib/mol-theme/theme.js");
/* harmony import */ var _util__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../util */ "./lib/mol-repr/util.js");
/* harmony import */ var _mol_geo_geometry_marker_data__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ../../mol-geo/geometry/marker-data */ "./lib/mol-geo/geometry/marker-data.js");
/* harmony import */ var _mol_util_marker_action__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ../../mol-util/marker-action */ "./lib/mol-util/marker-action.js");
/* harmony import */ var _mol_util__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ../../mol-util */ "./lib/mol-util/index.js");
/* harmony import */ var _mol_geo_geometry_color_data__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ../../mol-geo/geometry/color-data */ "./lib/mol-geo/geometry/color-data.js");
/* harmony import */ var _mol_geo_geometry_size_data__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! ../../mol-geo/geometry/size-data */ "./lib/mol-geo/geometry/size-data.js");
/* harmony import */ var _mol_model_loci__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! ../../mol-model/loci */ "./lib/mol-model/loci.js");
/* harmony import */ var _mol_data_int__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! ../../mol-data/int */ "./lib/mol-data/int.js");
/* harmony import */ var _visual__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! ../visual */ "./lib/mol-repr/visual.js");
/* harmony import */ var _mol_task__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(/*! ../../mol-task */ "./lib/mol-task/index.js");
/* harmony import */ var _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(/*! ../../mol-util/param-definition */ "./lib/mol-util/param-definition.js");
/* harmony import */ var _mol_util_debug__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(/*! ../../mol-util/debug */ "./lib/mol-util/debug.js");
/**
 * Copyright (c) 2018-2020 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */



















function ShapeRepresentation(getShape, geometryUtils, builder) {
    if (builder === void 0) { builder = {}; }
    var version = 0;
    var updated = new rxjs__WEBPACK_IMPORTED_MODULE_4__["Subject"]();
    var _state = _representation__WEBPACK_IMPORTED_MODULE_2__["Representation"].createState();
    var materialId = Object(_mol_gl_render_object__WEBPACK_IMPORTED_MODULE_5__["getNextMaterialId"])();
    var renderObjects = [];
    var _renderObject;
    var _shape;
    var _theme = _mol_theme_theme__WEBPACK_IMPORTED_MODULE_6__["Theme"].createEmpty();
    var currentProps = _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_17__["ParamDefinition"].getDefaultValues(geometryUtils.Params); // TODO avoid casting
    var currentParams;
    var locationIt;
    var positionIt;
    if (builder.modifyState)
        _representation__WEBPACK_IMPORTED_MODULE_2__["Representation"].updateState(_state, builder.modifyState(_state));
    var updateState = _util__WEBPACK_IMPORTED_MODULE_7__["VisualUpdateState"].create();
    function prepareUpdate(props, shape) {
        if (props === void 0) { props = {}; }
        _util__WEBPACK_IMPORTED_MODULE_7__["VisualUpdateState"].reset(updateState);
        if (!shape && !_shape) {
            // console.error('no shape given')
            return;
        }
        else if (shape && !_shape) {
            // console.log('first shape')
            updateState.createNew = true;
        }
        else if (shape && _shape && shape.id === _shape.id) {
            // console.log('same shape')
            // nothing to set
        }
        else if (shape && _shape && shape.id !== _shape.id) {
            // console.log('new shape')
            updateState.updateTransform = true;
            updateState.createGeometry = true;
        }
        else if (!shape) {
            // console.log('only props')
            // nothing to set
        }
        else {
            console.warn('unexpected state');
        }
        if (updateState.updateTransform) {
            updateState.updateColor = true;
            updateState.updateSize = true;
        }
        if (updateState.createGeometry) {
            updateState.updateColor = true;
            updateState.updateSize = true;
        }
    }
    function createOrUpdate(props, data) {
        var _this = this;
        if (props === void 0) { props = {}; }
        if (builder.modifyProps)
            props = builder.modifyProps(props);
        return _mol_task__WEBPACK_IMPORTED_MODULE_16__["Task"].create('ShapeRepresentation.create', function (runtime) { return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"])(_this, void 0, void 0, function () {
            var newProps, shape, _a, transform, values, state, instanceCount, groupCount;
            return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__generator"])(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        newProps = Object.assign(currentProps, props);
                        if (!data) return [3 /*break*/, 2];
                        return [4 /*yield*/, getShape(runtime, data, newProps, _shape)];
                    case 1:
                        _a = _b.sent();
                        return [3 /*break*/, 3];
                    case 2:
                        _a = undefined;
                        _b.label = 3;
                    case 3:
                        shape = _a;
                        prepareUpdate(props, shape);
                        if (shape) {
                            _shape = shape;
                            Object.assign(_theme, _mol_model_shape__WEBPACK_IMPORTED_MODULE_3__["Shape"].getTheme(_shape));
                        }
                        if (updateState.createNew) {
                            renderObjects.length = 0; // clear list o renderObjects
                            locationIt = _mol_model_shape__WEBPACK_IMPORTED_MODULE_3__["Shape"].groupIterator(_shape);
                            transform = _mol_model_shape__WEBPACK_IMPORTED_MODULE_3__["Shape"].createTransform(_shape.transforms);
                            values = geometryUtils.createValues(_shape.geometry, transform, locationIt, _theme, newProps);
                            state = geometryUtils.createRenderableState(newProps);
                            if (builder.modifyState)
                                Object.assign(state, builder.modifyState(state));
                            _representation__WEBPACK_IMPORTED_MODULE_2__["Representation"].updateState(_state, state);
                            _renderObject = Object(_mol_gl_render_object__WEBPACK_IMPORTED_MODULE_5__["createRenderObject"])(_shape.geometry.kind, values, state, materialId);
                            if (_renderObject)
                                renderObjects.push(_renderObject); // add new renderObject to list
                            positionIt = geometryUtils.createPositionIterator(_shape.geometry, _renderObject.values);
                        }
                        else {
                            if (!_renderObject) {
                                throw new Error('expected renderObject to be available');
                            }
                            if (updateState.updateTransform) {
                                // console.log('update transform')
                                _mol_model_shape__WEBPACK_IMPORTED_MODULE_3__["Shape"].createTransform(_shape.transforms, _renderObject.values);
                                locationIt = _mol_model_shape__WEBPACK_IMPORTED_MODULE_3__["Shape"].groupIterator(_shape);
                                instanceCount = locationIt.instanceCount, groupCount = locationIt.groupCount;
                                Object(_mol_geo_geometry_marker_data__WEBPACK_IMPORTED_MODULE_8__["createMarkers"])(instanceCount * groupCount, _renderObject.values);
                            }
                            if (updateState.createGeometry) {
                                // console.log('update geometry')
                                _mol_util__WEBPACK_IMPORTED_MODULE_10__["ValueCell"].updateIfChanged(_renderObject.values.drawCount, _mol_geo_geometry_geometry__WEBPACK_IMPORTED_MODULE_1__["Geometry"].getDrawCount(_shape.geometry));
                                _mol_util__WEBPACK_IMPORTED_MODULE_10__["ValueCell"].updateIfChanged(_renderObject.values.uVertexCount, _mol_geo_geometry_geometry__WEBPACK_IMPORTED_MODULE_1__["Geometry"].getVertexCount(_shape.geometry));
                            }
                            if (updateState.updateTransform || updateState.createGeometry) {
                                // console.log('updateBoundingSphere')
                                geometryUtils.updateBoundingSphere(_renderObject.values, _shape.geometry);
                                positionIt = geometryUtils.createPositionIterator(_shape.geometry, _renderObject.values);
                            }
                            if (updateState.updateColor) {
                                // console.log('update color')
                                Object(_mol_geo_geometry_color_data__WEBPACK_IMPORTED_MODULE_11__["createColors"])(locationIt, positionIt, _theme.color, _renderObject.values);
                            }
                            if (updateState.updateSize) {
                                // not all geometries have size data, so check here
                                if ('uSize' in _renderObject.values) {
                                    // console.log('update size')
                                    Object(_mol_geo_geometry_size_data__WEBPACK_IMPORTED_MODULE_12__["createSizes"])(locationIt, _theme.size, _renderObject.values);
                                }
                            }
                            geometryUtils.updateValues(_renderObject.values, newProps);
                            geometryUtils.updateRenderableState(_renderObject.state, newProps);
                        }
                        currentProps = newProps;
                        // increment version
                        updated.next(version++);
                        return [2 /*return*/];
                }
            });
        }); });
    }
    function lociApply(loci, apply) {
        if (Object(_mol_model_loci__WEBPACK_IMPORTED_MODULE_13__["isEveryLoci"])(loci) || (_mol_model_shape__WEBPACK_IMPORTED_MODULE_3__["Shape"].isLoci(loci) && loci.shape === _shape)) {
            return apply(_mol_data_int__WEBPACK_IMPORTED_MODULE_14__["Interval"].ofBounds(0, _shape.groupCount * _shape.transforms.length));
        }
        else {
            return eachShapeGroup(loci, _shape, apply);
        }
    }
    return {
        label: 'Shape geometry',
        get groupCount() { return locationIt ? locationIt.count : 0; },
        get props() { return currentProps; },
        get params() { return currentParams; },
        get state() { return _state; },
        get theme() { return _theme; },
        renderObjects: renderObjects,
        updated: updated,
        createOrUpdate: createOrUpdate,
        getLoci: function (pickingId) {
            if (pickingId === undefined)
                return _mol_model_shape__WEBPACK_IMPORTED_MODULE_3__["Shape"].Loci(_shape);
            var objectId = pickingId.objectId, groupId = pickingId.groupId, instanceId = pickingId.instanceId;
            if (_renderObject && _renderObject.id === objectId) {
                return _mol_model_shape__WEBPACK_IMPORTED_MODULE_3__["ShapeGroup"].Loci(_shape, [{ ids: _mol_data_int__WEBPACK_IMPORTED_MODULE_14__["OrderedSet"].ofSingleton(groupId), instance: instanceId }]);
            }
            return _mol_model_loci__WEBPACK_IMPORTED_MODULE_13__["EmptyLoci"];
        },
        mark: function (loci, action) {
            if (!_mol_util_marker_action__WEBPACK_IMPORTED_MODULE_9__["MarkerActions"].is(_state.markerActions, action))
                return false;
            if (_mol_model_shape__WEBPACK_IMPORTED_MODULE_3__["ShapeGroup"].isLoci(loci) || _mol_model_shape__WEBPACK_IMPORTED_MODULE_3__["Shape"].isLoci(loci)) {
                if (loci.shape !== _shape)
                    return false;
            }
            else if (!Object(_mol_model_loci__WEBPACK_IMPORTED_MODULE_13__["isEveryLoci"])(loci)) {
                return false;
            }
            return _visual__WEBPACK_IMPORTED_MODULE_15__["Visual"].mark(_renderObject, loci, action, lociApply);
        },
        setState: function (state) {
            if (builder.modifyState)
                state = builder.modifyState(state);
            if (_renderObject) {
                if (state.visible !== undefined)
                    _visual__WEBPACK_IMPORTED_MODULE_15__["Visual"].setVisibility(_renderObject, state.visible);
                if (state.alphaFactor !== undefined)
                    _visual__WEBPACK_IMPORTED_MODULE_15__["Visual"].setAlphaFactor(_renderObject, state.alphaFactor);
                if (state.pickable !== undefined)
                    _visual__WEBPACK_IMPORTED_MODULE_15__["Visual"].setPickable(_renderObject, state.pickable);
                if (state.colorOnly !== undefined)
                    _visual__WEBPACK_IMPORTED_MODULE_15__["Visual"].setColorOnly(_renderObject, state.colorOnly);
                if (state.overpaint !== undefined) {
                    _visual__WEBPACK_IMPORTED_MODULE_15__["Visual"].setOverpaint(_renderObject, state.overpaint, lociApply, true);
                }
                if (state.transparency !== undefined) {
                    _visual__WEBPACK_IMPORTED_MODULE_15__["Visual"].setTransparency(_renderObject, state.transparency, lociApply, true);
                }
                if (state.transform !== undefined)
                    _visual__WEBPACK_IMPORTED_MODULE_15__["Visual"].setTransform(_renderObject, state.transform);
            }
            _representation__WEBPACK_IMPORTED_MODULE_2__["Representation"].updateState(_state, state);
        },
        setTheme: function (theme) {
            if (_mol_util_debug__WEBPACK_IMPORTED_MODULE_18__["isDebugMode"]) {
                console.warn('The `ShapeRepresentation` theme is fixed to `ShapeGroupColorTheme` and `ShapeGroupSizeTheme`. Colors are taken from `Shape.getColor` and sizes from `Shape.getSize`');
            }
        },
        destroy: function () {
            renderObjects.length = 0;
            if (_renderObject) {
                _renderObject.state.disposed = true;
                _renderObject = undefined;
            }
        }
    };
}
function eachShapeGroup(loci, shape, apply) {
    if (!_mol_model_shape__WEBPACK_IMPORTED_MODULE_3__["ShapeGroup"].isLoci(loci))
        return false;
    if (loci.shape !== shape)
        return false;
    var changed = false;
    var groupCount = shape.groupCount;
    var groups = loci.groups;
    for (var _a = 0, groups_1 = groups; _a < groups_1.length; _a++) {
        var _b = groups_1[_a], ids = _b.ids, instance = _b.instance;
        if (_mol_data_int__WEBPACK_IMPORTED_MODULE_14__["Interval"].is(ids)) {
            var start = instance * groupCount + _mol_data_int__WEBPACK_IMPORTED_MODULE_14__["Interval"].start(ids);
            var end = instance * groupCount + _mol_data_int__WEBPACK_IMPORTED_MODULE_14__["Interval"].end(ids);
            if (apply(_mol_data_int__WEBPACK_IMPORTED_MODULE_14__["Interval"].ofBounds(start, end)))
                changed = true;
        }
        else {
            for (var i = 0, _i = ids.length; i < _i; i++) {
                var idx = instance * groupCount + ids[i];
                if (apply(_mol_data_int__WEBPACK_IMPORTED_MODULE_14__["Interval"].ofSingleton(idx)))
                    changed = true;
            }
        }
    }
    return changed;
}
//# sourceMappingURL=representation.js.map

/***/ }),

/***/ "./lib/mol-repr/structure/complex-representation.js":
/*!**********************************************************!*\
  !*** ./lib/mol-repr/structure/complex-representation.js ***!
  \**********************************************************/
/*! exports provided: ComplexRepresentation */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ComplexRepresentation", function() { return ComplexRepresentation; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../mol-util/param-definition */ "./lib/mol-util/param-definition.js");
/* harmony import */ var _representation__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./representation */ "./lib/mol-repr/structure/representation.js");
/* harmony import */ var _mol_model_structure__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../mol-model/structure */ "./lib/mol-model/structure.js");
/* harmony import */ var rxjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! rxjs */ "./node_modules/rxjs/_esm5/index.js");
/* harmony import */ var _mol_gl_render_object__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../mol-gl/render-object */ "./lib/mol-gl/render-object.js");
/* harmony import */ var _mol_theme_theme__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../../mol-theme/theme */ "./lib/mol-theme/theme.js");
/* harmony import */ var _mol_task__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../../mol-task */ "./lib/mol-task/index.js");
/* harmony import */ var _mol_model_loci__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ../../mol-model/loci */ "./lib/mol-model/loci.js");
/* harmony import */ var _mol_util_marker_action__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ../../mol-util/marker-action */ "./lib/mol-util/marker-action.js");
/* harmony import */ var _mol_theme_overpaint__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ../../mol-theme/overpaint */ "./lib/mol-theme/overpaint.js");
/* harmony import */ var _mol_theme_clipping__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ../../mol-theme/clipping */ "./lib/mol-theme/clipping.js");
/* harmony import */ var _mol_theme_transparency__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! ../../mol-theme/transparency */ "./lib/mol-theme/transparency.js");
/**
 * Copyright (c) 2018-2021 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 * @author David Sehnal <david.sehnal@gmail.com>
 */













function ComplexRepresentation(label, ctx, getParams, visualCtor) {
    var version = 0;
    var webgl = ctx.webgl;
    var updated = new rxjs__WEBPACK_IMPORTED_MODULE_4__["Subject"]();
    var materialId = Object(_mol_gl_render_object__WEBPACK_IMPORTED_MODULE_5__["getNextMaterialId"])();
    var renderObjects = [];
    var _state = _representation__WEBPACK_IMPORTED_MODULE_2__["StructureRepresentationStateBuilder"].create();
    var visual;
    var _structure;
    var _params;
    var _props;
    var _theme = _mol_theme_theme__WEBPACK_IMPORTED_MODULE_6__["Theme"].createEmpty();
    function createOrUpdate(props, structure) {
        var _this = this;
        if (props === void 0) { props = {}; }
        if (structure && structure !== _structure) {
            _params = getParams(ctx, structure);
            _structure = structure;
            if (!_props)
                _props = _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_1__["ParamDefinition"].getDefaultValues(_params);
        }
        _props = Object.assign({}, _props, props);
        return _mol_task__WEBPACK_IMPORTED_MODULE_7__["Task"].create('Creating or updating ComplexRepresentation', function (runtime) { return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"])(_this, void 0, void 0, function () {
            var newVisual, promise;
            var _a;
            return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__generator"])(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        newVisual = false;
                        if (!visual) {
                            visual = visualCtor(materialId, _props, webgl);
                            newVisual = true;
                        }
                        else if ((_a = visual.mustRecreate) === null || _a === void 0 ? void 0 : _a.call(visual, _props, webgl)) {
                            visual.destroy();
                            visual = visualCtor(materialId, _props, webgl);
                            newVisual = true;
                        }
                        promise = visual.createOrUpdate({ webgl: webgl, runtime: runtime }, _theme, _props, structure);
                        if (!promise) return [3 /*break*/, 2];
                        return [4 /*yield*/, promise];
                    case 1:
                        _b.sent();
                        _b.label = 2;
                    case 2:
                        if (newVisual)
                            setState(_state); // current state for new visual
                        // update list of renderObjects
                        renderObjects.length = 0;
                        if (visual && visual.renderObject)
                            renderObjects.push(visual.renderObject);
                        // increment version
                        updated.next(version++);
                        return [2 /*return*/];
                }
            });
        }); });
    }
    function getLoci(pickingId) {
        if (pickingId === undefined)
            return _mol_model_structure__WEBPACK_IMPORTED_MODULE_3__["Structure"].Loci(_structure);
        return visual ? visual.getLoci(pickingId) : _mol_model_loci__WEBPACK_IMPORTED_MODULE_8__["EmptyLoci"];
    }
    function mark(loci, action) {
        if (!_structure)
            return false;
        if (!_mol_util_marker_action__WEBPACK_IMPORTED_MODULE_9__["MarkerActions"].is(_state.markerActions, action))
            return false;
        if (_mol_model_structure__WEBPACK_IMPORTED_MODULE_3__["Structure"].isLoci(loci) || _mol_model_structure__WEBPACK_IMPORTED_MODULE_3__["StructureElement"].Loci.is(loci) || _mol_model_structure__WEBPACK_IMPORTED_MODULE_3__["Bond"].isLoci(loci)) {
            if (!_mol_model_structure__WEBPACK_IMPORTED_MODULE_3__["Structure"].areRootsEquivalent(loci.structure, _structure))
                return false;
            // Remap `loci` from equivalent structure to the current `_structure`
            loci = _mol_model_loci__WEBPACK_IMPORTED_MODULE_8__["Loci"].remap(loci, _structure);
        }
        else if (!Object(_mol_model_loci__WEBPACK_IMPORTED_MODULE_8__["isEveryLoci"])(loci) && !Object(_mol_model_loci__WEBPACK_IMPORTED_MODULE_8__["isDataLoci"])(loci)) {
            return false;
        }
        if (_mol_model_loci__WEBPACK_IMPORTED_MODULE_8__["Loci"].isEmpty(loci))
            return false;
        return visual ? visual.mark(loci, action) : false;
    }
    function setState(state) {
        _representation__WEBPACK_IMPORTED_MODULE_2__["StructureRepresentationStateBuilder"].update(_state, state);
        if (state.visible !== undefined && visual) {
            // hide visual when _unitTransforms is set and not the identity
            visual.setVisibility(state.visible && (_state.unitTransforms === null || _state.unitTransforms.isIdentity));
        }
        if (state.alphaFactor !== undefined && visual)
            visual.setAlphaFactor(state.alphaFactor);
        if (state.pickable !== undefined && visual)
            visual.setPickable(state.pickable);
        if (state.overpaint !== undefined && visual) {
            // Remap loci from equivalent structure to the current structure
            var remappedOverpaint = _mol_theme_overpaint__WEBPACK_IMPORTED_MODULE_10__["Overpaint"].remap(state.overpaint, _structure);
            visual.setOverpaint(remappedOverpaint);
        }
        if (state.transparency !== undefined && visual) {
            // Remap loci from equivalent structure to the current structure
            var remappedTransparency = _mol_theme_transparency__WEBPACK_IMPORTED_MODULE_12__["Transparency"].remap(state.transparency, _structure);
            visual.setTransparency(remappedTransparency);
        }
        if (state.clipping !== undefined && visual) {
            // Remap loci from equivalent structure to the current structure
            var remappedClipping = _mol_theme_clipping__WEBPACK_IMPORTED_MODULE_11__["Clipping"].remap(state.clipping, _structure);
            visual.setClipping(remappedClipping);
        }
        if (state.transform !== undefined && visual)
            visual.setTransform(state.transform);
        if (state.unitTransforms !== undefined && visual) {
            // Since ComplexVisuals always renders geometries between units, the application
            // of `unitTransforms` does not make sense. When given here and not the identity,
            // it is ignored and sets the visual's visibility to `false`.
            visual.setVisibility(_state.visible && (state.unitTransforms === null || state.unitTransforms.isIdentity));
        }
    }
    function setTheme(theme) {
        _theme = theme;
    }
    function destroy() {
        if (visual)
            visual.destroy();
    }
    return {
        label: label,
        get groupCount() {
            return visual ? visual.groupCount : 0;
        },
        get props() { return _props; },
        get params() { return _params; },
        get state() { return _state; },
        get theme() { return _theme; },
        renderObjects: renderObjects,
        updated: updated,
        createOrUpdate: createOrUpdate,
        setState: setState,
        setTheme: setTheme,
        getLoci: getLoci,
        mark: mark,
        destroy: destroy
    };
}
//# sourceMappingURL=complex-representation.js.map

/***/ }),

/***/ "./lib/mol-repr/structure/complex-visual.js":
/*!**************************************************!*\
  !*** ./lib/mol-repr/structure/complex-visual.js ***!
  \**************************************************/
/*! exports provided: ComplexVisual, ComplexMeshParams, ComplexMeshVisual, ComplexCylindersParams, ComplexCylindersVisual, ComplexLinesParams, ComplexLinesVisual, ComplexTextParams, ComplexTextVisual, ComplexDirectVolumeParams, ComplexDirectVolumeVisual, ComplexTextureMeshParams, ComplexTextureMeshVisual */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ComplexVisual", function() { return ComplexVisual; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ComplexMeshParams", function() { return ComplexMeshParams; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ComplexMeshVisual", function() { return ComplexMeshVisual; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ComplexCylindersParams", function() { return ComplexCylindersParams; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ComplexCylindersVisual", function() { return ComplexCylindersVisual; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ComplexLinesParams", function() { return ComplexLinesParams; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ComplexLinesVisual", function() { return ComplexLinesVisual; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ComplexTextParams", function() { return ComplexTextParams; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ComplexTextVisual", function() { return ComplexTextVisual; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ComplexDirectVolumeParams", function() { return ComplexDirectVolumeParams; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ComplexDirectVolumeVisual", function() { return ComplexDirectVolumeVisual; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ComplexTextureMeshParams", function() { return ComplexTextureMeshParams; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ComplexTextureMeshVisual", function() { return ComplexTextureMeshVisual; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _visual__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../visual */ "./lib/mol-repr/visual.js");
/* harmony import */ var _mol_model_structure__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../mol-model/structure */ "./lib/mol-model/structure.js");
/* harmony import */ var _mol_geo_geometry_geometry__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../mol-geo/geometry/geometry */ "./lib/mol-geo/geometry/geometry.js");
/* harmony import */ var _mol_theme_theme__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../mol-theme/theme */ "./lib/mol-theme/theme.js");
/* harmony import */ var _mol_geo_geometry_transform_data__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../mol-geo/geometry/transform-data */ "./lib/mol-geo/geometry/transform-data.js");
/* harmony import */ var _mol_gl_render_object__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../../mol-gl/render-object */ "./lib/mol-gl/render-object.js");
/* harmony import */ var _mol_model_loci__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../../mol-model/loci */ "./lib/mol-model/loci.js");
/* harmony import */ var _mol_data_int__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ../../mol-data/int */ "./lib/mol-data/int.js");
/* harmony import */ var _util__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ../util */ "./lib/mol-repr/util.js");
/* harmony import */ var _mol_theme_color__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ../../mol-theme/color */ "./lib/mol-theme/color.js");
/* harmony import */ var _mol_util__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ../../mol-util */ "./lib/mol-util/index.js");
/* harmony import */ var _mol_geo_geometry_size_data__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! ../../mol-geo/geometry/size-data */ "./lib/mol-geo/geometry/size-data.js");
/* harmony import */ var _mol_geo_geometry_color_data__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! ../../mol-geo/geometry/color-data */ "./lib/mol-geo/geometry/color-data.js");
/* harmony import */ var _mol_geo_geometry_mesh_mesh__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! ../../mol-geo/geometry/mesh/mesh */ "./lib/mol-geo/geometry/mesh/mesh.js");
/* harmony import */ var _mol_geo_geometry_cylinders_cylinders__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! ../../mol-geo/geometry/cylinders/cylinders */ "./lib/mol-geo/geometry/cylinders/cylinders.js");
/* harmony import */ var _mol_geo_geometry_lines_lines__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(/*! ../../mol-geo/geometry/lines/lines */ "./lib/mol-geo/geometry/lines/lines.js");
/* harmony import */ var _mol_geo_geometry_text_text__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(/*! ../../mol-geo/geometry/text/text */ "./lib/mol-geo/geometry/text/text.js");
/* harmony import */ var _mol_theme_size__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(/*! ../../mol-theme/size */ "./lib/mol-theme/size.js");
/* harmony import */ var _mol_geo_geometry_direct_volume_direct_volume__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(/*! ../../mol-geo/geometry/direct-volume/direct-volume */ "./lib/mol-geo/geometry/direct-volume/direct-volume.js");
/* harmony import */ var _mol_geo_geometry_marker_data__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(/*! ../../mol-geo/geometry/marker-data */ "./lib/mol-geo/geometry/marker-data.js");
/* harmony import */ var _params__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(/*! ./params */ "./lib/mol-repr/structure/params.js");
/* harmony import */ var _mol_geo_geometry_texture_mesh_texture_mesh__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(/*! ../../mol-geo/geometry/texture-mesh/texture-mesh */ "./lib/mol-geo/geometry/texture-mesh/texture-mesh.js");
/**
 * Copyright (c) 2018-2021 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */























function createComplexRenderObject(structure, geometry, locationIt, theme, props, materialId) {
    var _a = _mol_geo_geometry_geometry__WEBPACK_IMPORTED_MODULE_3__["Geometry"].getUtils(geometry), createValues = _a.createValues, createRenderableState = _a.createRenderableState;
    var transform = Object(_mol_geo_geometry_transform_data__WEBPACK_IMPORTED_MODULE_5__["createIdentityTransform"])();
    var values = createValues(geometry, transform, locationIt, theme, props);
    var state = createRenderableState(props);
    return Object(_mol_gl_render_object__WEBPACK_IMPORTED_MODULE_6__["createRenderObject"])(geometry.kind, values, state, materialId);
}
function ComplexVisual(builder, materialId) {
    var defaultProps = builder.defaultProps, createGeometry = builder.createGeometry, createLocationIterator = builder.createLocationIterator, getLoci = builder.getLoci, eachLocation = builder.eachLocation, setUpdateState = builder.setUpdateState, mustRecreate = builder.mustRecreate, dispose = builder.dispose;
    var _a = builder.geometryUtils, updateValues = _a.updateValues, updateBoundingSphere = _a.updateBoundingSphere, updateRenderableState = _a.updateRenderableState, createPositionIterator = _a.createPositionIterator;
    var updateState = _util__WEBPACK_IMPORTED_MODULE_9__["VisualUpdateState"].create();
    var renderObject;
    var newProps;
    var newTheme;
    var newStructure;
    var currentProps = Object.assign({}, defaultProps);
    var currentTheme = _mol_theme_theme__WEBPACK_IMPORTED_MODULE_4__["Theme"].createEmpty();
    var currentStructure;
    var geometry;
    var locationIt;
    var positionIt;
    function prepareUpdate(theme, props, structure) {
        if (!structure && !currentStructure) {
            throw new Error('missing structure');
        }
        newProps = Object.assign({}, currentProps, props);
        newTheme = theme;
        newStructure = structure;
        _util__WEBPACK_IMPORTED_MODULE_9__["VisualUpdateState"].reset(updateState);
        if (!renderObject || !currentStructure) {
            updateState.createNew = true;
            updateState.createGeometry = true;
            return;
        }
        setUpdateState(updateState, newProps, currentProps, newTheme, currentTheme, newStructure, currentStructure);
        if (!_mol_model_structure__WEBPACK_IMPORTED_MODULE_2__["Structure"].areEquivalent(newStructure, currentStructure)) {
            updateState.createGeometry = true;
        }
        if (!_mol_model_structure__WEBPACK_IMPORTED_MODULE_2__["Structure"].areHierarchiesEqual(newStructure, currentStructure)) {
            updateState.updateTransform = true;
            updateState.createGeometry = true;
        }
        if (!_mol_theme_color__WEBPACK_IMPORTED_MODULE_10__["ColorTheme"].areEqual(theme.color, currentTheme.color)) {
            updateState.updateColor = true;
        }
        if (!Object(_mol_util__WEBPACK_IMPORTED_MODULE_11__["deepEqual"])(newProps.unitKinds, currentProps.unitKinds)) {
            updateState.createGeometry = true;
        }
        if (updateState.updateSize && !('uSize' in renderObject.values)) {
            updateState.createGeometry = true;
        }
        if (updateState.createGeometry) {
            updateState.updateColor = true;
            updateState.updateSize = true;
        }
    }
    function update(newGeometry) {
        if (updateState.createNew) {
            locationIt = createLocationIterator(newStructure);
            if (newGeometry) {
                renderObject = createComplexRenderObject(newStructure, newGeometry, locationIt, newTheme, newProps, materialId);
                positionIt = createPositionIterator(newGeometry, renderObject.values);
            }
            else {
                throw new Error('expected geometry to be given');
            }
        }
        else {
            if (!renderObject) {
                throw new Error('expected renderObject to be available');
            }
            if (updateState.updateTransform) {
                // console.log('update transform')
                locationIt = createLocationIterator(newStructure);
                var instanceCount = locationIt.instanceCount, groupCount = locationIt.groupCount;
                Object(_mol_geo_geometry_marker_data__WEBPACK_IMPORTED_MODULE_20__["createMarkers"])(instanceCount * groupCount, renderObject.values);
            }
            if (updateState.createGeometry) {
                if (newGeometry) {
                    _mol_util__WEBPACK_IMPORTED_MODULE_11__["ValueCell"].updateIfChanged(renderObject.values.drawCount, _mol_geo_geometry_geometry__WEBPACK_IMPORTED_MODULE_3__["Geometry"].getDrawCount(newGeometry));
                    _mol_util__WEBPACK_IMPORTED_MODULE_11__["ValueCell"].updateIfChanged(renderObject.values.uVertexCount, _mol_geo_geometry_geometry__WEBPACK_IMPORTED_MODULE_3__["Geometry"].getVertexCount(newGeometry));
                }
                else {
                    throw new Error('expected geometry to be given');
                }
            }
            if (updateState.updateTransform || updateState.createGeometry) {
                updateBoundingSphere(renderObject.values, newGeometry || geometry);
                positionIt = createPositionIterator(geometry, renderObject.values);
            }
            if (updateState.updateSize) {
                // not all geometries have size data, so check here
                if ('uSize' in renderObject.values) {
                    Object(_mol_geo_geometry_size_data__WEBPACK_IMPORTED_MODULE_12__["createSizes"])(locationIt, newTheme.size, renderObject.values);
                }
            }
            if (updateState.updateColor) {
                Object(_mol_geo_geometry_color_data__WEBPACK_IMPORTED_MODULE_13__["createColors"])(locationIt, positionIt, newTheme.color, renderObject.values);
            }
            updateValues(renderObject.values, newProps);
            updateRenderableState(renderObject.state, newProps);
        }
        currentProps = newProps;
        currentTheme = newTheme;
        currentStructure = newStructure;
        if (newGeometry)
            geometry = newGeometry;
    }
    function lociIsSuperset(loci) {
        if (Object(_mol_model_loci__WEBPACK_IMPORTED_MODULE_7__["isEveryLoci"])(loci))
            return true;
        if (_mol_model_structure__WEBPACK_IMPORTED_MODULE_2__["Structure"].isLoci(loci) && _mol_model_structure__WEBPACK_IMPORTED_MODULE_2__["Structure"].areRootsEquivalent(loci.structure, currentStructure))
            return true;
        if (_mol_model_structure__WEBPACK_IMPORTED_MODULE_2__["StructureElement"].Loci.is(loci) && _mol_model_structure__WEBPACK_IMPORTED_MODULE_2__["Structure"].areRootsEquivalent(loci.structure, currentStructure)) {
            if (_mol_model_structure__WEBPACK_IMPORTED_MODULE_2__["StructureElement"].Loci.isWholeStructure(loci))
                return true;
        }
        return false;
    }
    function lociApply(loci, apply, isMarking) {
        if (lociIsSuperset(loci)) {
            return apply(_mol_data_int__WEBPACK_IMPORTED_MODULE_8__["Interval"].ofBounds(0, locationIt.groupCount * locationIt.instanceCount));
        }
        else {
            return eachLocation(loci, currentStructure, apply, isMarking);
        }
    }
    return {
        get groupCount() { return locationIt ? locationIt.count : 0; },
        get renderObject() { return locationIt && locationIt.count ? renderObject : undefined; },
        createOrUpdate: function (ctx, theme, props, structure) {
            if (props === void 0) { props = {}; }
            prepareUpdate(theme, props, structure || currentStructure);
            if (updateState.createGeometry) {
                var newGeometry = createGeometry(ctx, newStructure, newTheme, newProps, geometry);
                return newGeometry instanceof Promise ? newGeometry.then(update) : update(newGeometry);
            }
            else {
                update();
            }
        },
        getLoci: function (pickingId) {
            return renderObject ? getLoci(pickingId, currentStructure, renderObject.id) : _mol_model_loci__WEBPACK_IMPORTED_MODULE_7__["EmptyLoci"];
        },
        mark: function (loci, action) {
            return _visual__WEBPACK_IMPORTED_MODULE_1__["Visual"].mark(renderObject, loci, action, lociApply);
        },
        setVisibility: function (visible) {
            _visual__WEBPACK_IMPORTED_MODULE_1__["Visual"].setVisibility(renderObject, visible);
        },
        setAlphaFactor: function (alphaFactor) {
            _visual__WEBPACK_IMPORTED_MODULE_1__["Visual"].setAlphaFactor(renderObject, alphaFactor);
        },
        setPickable: function (pickable) {
            _visual__WEBPACK_IMPORTED_MODULE_1__["Visual"].setPickable(renderObject, pickable);
        },
        setColorOnly: function (colorOnly) {
            _visual__WEBPACK_IMPORTED_MODULE_1__["Visual"].setColorOnly(renderObject, colorOnly);
        },
        setTransform: function (matrix, instanceMatrices) {
            _visual__WEBPACK_IMPORTED_MODULE_1__["Visual"].setTransform(renderObject, matrix, instanceMatrices);
        },
        setOverpaint: function (overpaint) {
            _visual__WEBPACK_IMPORTED_MODULE_1__["Visual"].setOverpaint(renderObject, overpaint, lociApply, true);
        },
        setTransparency: function (transparency) {
            _visual__WEBPACK_IMPORTED_MODULE_1__["Visual"].setTransparency(renderObject, transparency, lociApply, true);
        },
        setClipping: function (clipping) {
            _visual__WEBPACK_IMPORTED_MODULE_1__["Visual"].setClipping(renderObject, clipping, lociApply, true);
        },
        destroy: function () {
            dispose === null || dispose === void 0 ? void 0 : dispose(geometry);
            if (renderObject) {
                renderObject.state.disposed = true;
                renderObject = undefined;
            }
        },
        mustRecreate: mustRecreate
    };
}
// mesh
var ComplexMeshParams = Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, _params__WEBPACK_IMPORTED_MODULE_21__["StructureMeshParams"]), _params__WEBPACK_IMPORTED_MODULE_21__["StructureParams"]);
function ComplexMeshVisual(builder, materialId) {
    return ComplexVisual(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, builder), { setUpdateState: function (state, newProps, currentProps, newTheme, currentTheme, newStructure, currentStructure) {
            builder.setUpdateState(state, newProps, currentProps, newTheme, currentTheme, newStructure, currentStructure);
            if (!_mol_theme_size__WEBPACK_IMPORTED_MODULE_18__["SizeTheme"].areEqual(newTheme.size, currentTheme.size))
                state.createGeometry = true;
        }, geometryUtils: _mol_geo_geometry_mesh_mesh__WEBPACK_IMPORTED_MODULE_14__["Mesh"].Utils }), materialId);
}
// cylinders
var ComplexCylindersParams = Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, _params__WEBPACK_IMPORTED_MODULE_21__["StructureCylindersParams"]), _params__WEBPACK_IMPORTED_MODULE_21__["StructureParams"]);
function ComplexCylindersVisual(builder, materialId) {
    return ComplexVisual(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, builder), { setUpdateState: function (state, newProps, currentProps, newTheme, currentTheme, newStructure, currentStructure) {
            builder.setUpdateState(state, newProps, currentProps, newTheme, currentTheme, newStructure, currentStructure);
            if (!_mol_theme_size__WEBPACK_IMPORTED_MODULE_18__["SizeTheme"].areEqual(newTheme.size, currentTheme.size))
                state.updateSize = true;
        }, geometryUtils: _mol_geo_geometry_cylinders_cylinders__WEBPACK_IMPORTED_MODULE_15__["Cylinders"].Utils }), materialId);
}
// lines
var ComplexLinesParams = Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, _params__WEBPACK_IMPORTED_MODULE_21__["StructureLinesParams"]), _params__WEBPACK_IMPORTED_MODULE_21__["StructureParams"]);
function ComplexLinesVisual(builder, materialId) {
    return ComplexVisual(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, builder), { setUpdateState: function (state, newProps, currentProps, newTheme, currentTheme, newStructure, currentStructure) {
            builder.setUpdateState(state, newProps, currentProps, newTheme, currentTheme, newStructure, currentStructure);
            if (!_mol_theme_size__WEBPACK_IMPORTED_MODULE_18__["SizeTheme"].areEqual(newTheme.size, currentTheme.size))
                state.updateSize = true;
        }, geometryUtils: _mol_geo_geometry_lines_lines__WEBPACK_IMPORTED_MODULE_16__["Lines"].Utils }), materialId);
}
// text
var ComplexTextParams = Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, _params__WEBPACK_IMPORTED_MODULE_21__["StructureTextParams"]), _params__WEBPACK_IMPORTED_MODULE_21__["StructureParams"]);
function ComplexTextVisual(builder, materialId) {
    return ComplexVisual(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, builder), { setUpdateState: function (state, newProps, currentProps, newTheme, currentTheme, newStructure, currentStructure) {
            builder.setUpdateState(state, newProps, currentProps, newTheme, currentTheme, newStructure, currentStructure);
            if (!_mol_theme_size__WEBPACK_IMPORTED_MODULE_18__["SizeTheme"].areEqual(newTheme.size, currentTheme.size))
                state.updateSize = true;
            if (newProps.background !== currentProps.background)
                state.createGeometry = true;
            if (newProps.backgroundMargin !== currentProps.backgroundMargin)
                state.createGeometry = true;
            if (newProps.tether !== currentProps.tether)
                state.createGeometry = true;
            if (newProps.tetherLength !== currentProps.tetherLength)
                state.createGeometry = true;
            if (newProps.tetherBaseWidth !== currentProps.tetherBaseWidth)
                state.createGeometry = true;
            if (newProps.attachment !== currentProps.attachment)
                state.createGeometry = true;
            if (newProps.fontFamily !== currentProps.fontFamily)
                state.createGeometry = true;
            if (newProps.fontQuality !== currentProps.fontQuality)
                state.createGeometry = true;
            if (newProps.fontStyle !== currentProps.fontStyle)
                state.createGeometry = true;
            if (newProps.fontVariant !== currentProps.fontVariant)
                state.createGeometry = true;
            if (newProps.fontWeight !== currentProps.fontWeight)
                state.createGeometry = true;
        }, geometryUtils: _mol_geo_geometry_text_text__WEBPACK_IMPORTED_MODULE_17__["Text"].Utils }), materialId);
}
// direct-volume
var ComplexDirectVolumeParams = Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, _params__WEBPACK_IMPORTED_MODULE_21__["StructureDirectVolumeParams"]), _params__WEBPACK_IMPORTED_MODULE_21__["StructureParams"]);
function ComplexDirectVolumeVisual(builder, materialId) {
    return ComplexVisual(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, builder), { setUpdateState: function (state, newProps, currentProps, newTheme, currentTheme, newStructure, currentStructure) {
            builder.setUpdateState(state, newProps, currentProps, newTheme, currentTheme, newStructure, currentStructure);
            if (!_mol_theme_size__WEBPACK_IMPORTED_MODULE_18__["SizeTheme"].areEqual(newTheme.size, currentTheme.size))
                state.createGeometry = true;
        }, geometryUtils: _mol_geo_geometry_direct_volume_direct_volume__WEBPACK_IMPORTED_MODULE_19__["DirectVolume"].Utils }), materialId);
}
// texture-mesh
var ComplexTextureMeshParams = Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, _params__WEBPACK_IMPORTED_MODULE_21__["StructureTextureMeshParams"]), _params__WEBPACK_IMPORTED_MODULE_21__["StructureParams"]);
function ComplexTextureMeshVisual(builder, materialId) {
    return ComplexVisual(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, builder), { setUpdateState: function (state, newProps, currentProps, newTheme, currentTheme, newStructure, currentStructure) {
            builder.setUpdateState(state, newProps, currentProps, newTheme, currentTheme, newStructure, currentStructure);
            if (!_mol_theme_size__WEBPACK_IMPORTED_MODULE_18__["SizeTheme"].areEqual(newTheme.size, currentTheme.size))
                state.createGeometry = true;
        }, geometryUtils: _mol_geo_geometry_texture_mesh_texture_mesh__WEBPACK_IMPORTED_MODULE_22__["TextureMesh"].Utils }), materialId);
}
//# sourceMappingURL=complex-visual.js.map

/***/ }),

/***/ "./lib/mol-repr/structure/params.js":
/*!******************************************!*\
  !*** ./lib/mol-repr/structure/params.js ***!
  \******************************************/
/*! exports provided: getUnitKindsParam, StructureParams, StructureMeshParams, StructureSpheresParams, StructureCylindersParams, StructurePointsParams, StructureLinesParams, StructureTextParams, StructureDirectVolumeParams, StructureTextureMeshParams */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getUnitKindsParam", function() { return getUnitKindsParam; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "StructureParams", function() { return StructureParams; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "StructureMeshParams", function() { return StructureMeshParams; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "StructureSpheresParams", function() { return StructureSpheresParams; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "StructureCylindersParams", function() { return StructureCylindersParams; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "StructurePointsParams", function() { return StructurePointsParams; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "StructureLinesParams", function() { return StructureLinesParams; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "StructureTextParams", function() { return StructureTextParams; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "StructureDirectVolumeParams", function() { return StructureDirectVolumeParams; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "StructureTextureMeshParams", function() { return StructureTextureMeshParams; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _mol_geo_geometry_direct_volume_direct_volume__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../mol-geo/geometry/direct-volume/direct-volume */ "./lib/mol-geo/geometry/direct-volume/direct-volume.js");
/* harmony import */ var _mol_geo_geometry_lines_lines__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../mol-geo/geometry/lines/lines */ "./lib/mol-geo/geometry/lines/lines.js");
/* harmony import */ var _mol_geo_geometry_mesh_mesh__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../mol-geo/geometry/mesh/mesh */ "./lib/mol-geo/geometry/mesh/mesh.js");
/* harmony import */ var _mol_geo_geometry_points_points__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../mol-geo/geometry/points/points */ "./lib/mol-geo/geometry/points/points.js");
/* harmony import */ var _mol_geo_geometry_spheres_spheres__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../mol-geo/geometry/spheres/spheres */ "./lib/mol-geo/geometry/spheres/spheres.js");
/* harmony import */ var _mol_geo_geometry_cylinders_cylinders__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../../mol-geo/geometry/cylinders/cylinders */ "./lib/mol-geo/geometry/cylinders/cylinders.js");
/* harmony import */ var _mol_geo_geometry_text_text__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../../mol-geo/geometry/text/text */ "./lib/mol-geo/geometry/text/text.js");
/* harmony import */ var _mol_geo_geometry_texture_mesh_texture_mesh__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ../../mol-geo/geometry/texture-mesh/texture-mesh */ "./lib/mol-geo/geometry/texture-mesh/texture-mesh.js");
/* harmony import */ var _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ../../mol-util/param-definition */ "./lib/mol-util/param-definition.js");
/* harmony import */ var _visual_util_common__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ./visual/util/common */ "./lib/mol-repr/structure/visual/util/common.js");
/**
 * Copyright (c) 2018-2020 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 * @author David Sehnal <david.sehnal@gmail.com>
 */











function getUnitKindsParam(defaultValue) {
    return _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_9__["ParamDefinition"].MultiSelect(defaultValue, _visual_util_common__WEBPACK_IMPORTED_MODULE_10__["UnitKindOptions"], { description: 'For which kinds of units/chains to show the representation visuals.' });
}
var StructureParams = {
    unitKinds: getUnitKindsParam(['atomic', 'spheres']),
};
var StructureMeshParams = Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, _mol_geo_geometry_mesh_mesh__WEBPACK_IMPORTED_MODULE_3__["Mesh"].Params);
var StructureSpheresParams = Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, _mol_geo_geometry_spheres_spheres__WEBPACK_IMPORTED_MODULE_5__["Spheres"].Params);
var StructureCylindersParams = Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, _mol_geo_geometry_cylinders_cylinders__WEBPACK_IMPORTED_MODULE_6__["Cylinders"].Params);
var StructurePointsParams = Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, _mol_geo_geometry_points_points__WEBPACK_IMPORTED_MODULE_4__["Points"].Params);
var StructureLinesParams = Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, _mol_geo_geometry_lines_lines__WEBPACK_IMPORTED_MODULE_2__["Lines"].Params);
var StructureTextParams = Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, _mol_geo_geometry_text_text__WEBPACK_IMPORTED_MODULE_7__["Text"].Params);
var StructureDirectVolumeParams = Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, _mol_geo_geometry_direct_volume_direct_volume__WEBPACK_IMPORTED_MODULE_1__["DirectVolume"].Params);
var StructureTextureMeshParams = Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, _mol_geo_geometry_texture_mesh_texture_mesh__WEBPACK_IMPORTED_MODULE_8__["TextureMesh"].Params);
//# sourceMappingURL=params.js.map

/***/ }),

/***/ "./lib/mol-repr/structure/registry.js":
/*!********************************************!*\
  !*** ./lib/mol-repr/structure/registry.js ***!
  \********************************************/
/*! exports provided: StructureRepresentationRegistry */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "StructureRepresentationRegistry", function() { return StructureRepresentationRegistry; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _mol_util_object__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../mol-util/object */ "./lib/mol-util/object.js");
/* harmony import */ var _representation__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../representation */ "./lib/mol-repr/representation.js");
/* harmony import */ var _representation_ball_and_stick__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./representation/ball-and-stick */ "./lib/mol-repr/structure/representation/ball-and-stick.js");
/* harmony import */ var _representation_carbohydrate__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./representation/carbohydrate */ "./lib/mol-repr/structure/representation/carbohydrate.js");
/* harmony import */ var _representation_cartoon__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./representation/cartoon */ "./lib/mol-repr/structure/representation/cartoon.js");
/* harmony import */ var _representation_ellipsoid__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ./representation/ellipsoid */ "./lib/mol-repr/structure/representation/ellipsoid.js");
/* harmony import */ var _representation_gaussian_surface__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ./representation/gaussian-surface */ "./lib/mol-repr/structure/representation/gaussian-surface.js");
/* harmony import */ var _representation_label__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ./representation/label */ "./lib/mol-repr/structure/representation/label.js");
/* harmony import */ var _representation_molecular_surface__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ./representation/molecular-surface */ "./lib/mol-repr/structure/representation/molecular-surface.js");
/* harmony import */ var _representation_orientation__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ./representation/orientation */ "./lib/mol-repr/structure/representation/orientation.js");
/* harmony import */ var _representation_point__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ./representation/point */ "./lib/mol-repr/structure/representation/point.js");
/* harmony import */ var _representation_putty__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! ./representation/putty */ "./lib/mol-repr/structure/representation/putty.js");
/* harmony import */ var _representation_spacefill__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! ./representation/spacefill */ "./lib/mol-repr/structure/representation/spacefill.js");
/* harmony import */ var _representation_line__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! ./representation/line */ "./lib/mol-repr/structure/representation/line.js");
/* harmony import */ var _representation_gaussian_volume__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! ./representation/gaussian-volume */ "./lib/mol-repr/structure/representation/gaussian-volume.js");
/**
 * Copyright (c) 2018-2020 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */
















var StructureRepresentationRegistry = /** @class */ (function (_super) {
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__extends"])(StructureRepresentationRegistry, _super);
    function StructureRepresentationRegistry() {
        var _this = _super.call(this) || this;
        Object(_mol_util_object__WEBPACK_IMPORTED_MODULE_1__["objectForEach"])(StructureRepresentationRegistry.BuiltIn, function (p, k) {
            if (p.name !== k)
                throw new Error("Fix BuiltInStructureRepresentations to have matching names. " + p.name + " " + k);
            _this.add(p);
        });
        return _this;
    }
    return StructureRepresentationRegistry;
}(_representation__WEBPACK_IMPORTED_MODULE_2__["RepresentationRegistry"]));

(function (StructureRepresentationRegistry) {
    StructureRepresentationRegistry.BuiltIn = {
        'cartoon': _representation_cartoon__WEBPACK_IMPORTED_MODULE_5__["CartoonRepresentationProvider"],
        'ball-and-stick': _representation_ball_and_stick__WEBPACK_IMPORTED_MODULE_3__["BallAndStickRepresentationProvider"],
        'carbohydrate': _representation_carbohydrate__WEBPACK_IMPORTED_MODULE_4__["CarbohydrateRepresentationProvider"],
        'ellipsoid': _representation_ellipsoid__WEBPACK_IMPORTED_MODULE_6__["EllipsoidRepresentationProvider"],
        'gaussian-surface': _representation_gaussian_surface__WEBPACK_IMPORTED_MODULE_7__["GaussianSurfaceRepresentationProvider"],
        'gaussian-volume': _representation_gaussian_volume__WEBPACK_IMPORTED_MODULE_15__["GaussianVolumeRepresentationProvider"],
        'label': _representation_label__WEBPACK_IMPORTED_MODULE_8__["LabelRepresentationProvider"],
        'line': _representation_line__WEBPACK_IMPORTED_MODULE_14__["LineRepresentationProvider"],
        'molecular-surface': _representation_molecular_surface__WEBPACK_IMPORTED_MODULE_9__["MolecularSurfaceRepresentationProvider"],
        'orientation': _representation_orientation__WEBPACK_IMPORTED_MODULE_10__["OrientationRepresentationProvider"],
        'point': _representation_point__WEBPACK_IMPORTED_MODULE_11__["PointRepresentationProvider"],
        'putty': _representation_putty__WEBPACK_IMPORTED_MODULE_12__["PuttyRepresentationProvider"],
        'spacefill': _representation_spacefill__WEBPACK_IMPORTED_MODULE_13__["SpacefillRepresentationProvider"],
    };
})(StructureRepresentationRegistry || (StructureRepresentationRegistry = {}));
//# sourceMappingURL=registry.js.map

/***/ }),

/***/ "./lib/mol-repr/structure/representation.js":
/*!**************************************************!*\
  !*** ./lib/mol-repr/structure/representation.js ***!
  \**************************************************/
/*! exports provided: StructureRepresentationStateBuilder, StructureRepresentationProvider, ComplexRepresentation, ComplexVisual, UnitsRepresentation, UnitsVisual */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "StructureRepresentationStateBuilder", function() { return StructureRepresentationStateBuilder; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "StructureRepresentationProvider", function() { return StructureRepresentationProvider; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _representation__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../representation */ "./lib/mol-repr/representation.js");
/* harmony import */ var _complex_representation__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./complex-representation */ "./lib/mol-repr/structure/complex-representation.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ComplexRepresentation", function() { return _complex_representation__WEBPACK_IMPORTED_MODULE_2__["ComplexRepresentation"]; });

/* harmony import */ var _complex_visual__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./complex-visual */ "./lib/mol-repr/structure/complex-visual.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ComplexVisual", function() { return _complex_visual__WEBPACK_IMPORTED_MODULE_3__["ComplexVisual"]; });

/* harmony import */ var _units_representation__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./units-representation */ "./lib/mol-repr/structure/units-representation.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "UnitsRepresentation", function() { return _units_representation__WEBPACK_IMPORTED_MODULE_4__["UnitsRepresentation"]; });

/* harmony import */ var _units_visual__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./units-visual */ "./lib/mol-repr/structure/units-visual.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "UnitsVisual", function() { return _units_visual__WEBPACK_IMPORTED_MODULE_5__["UnitsVisual"]; });

/**
 * Copyright (c) 2018-2020 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 * @author David Sehnal <david.sehnal@gmail.com>
 */


var StructureRepresentationStateBuilder = {
    create: function () {
        return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, _representation__WEBPACK_IMPORTED_MODULE_1__["Representation"].createState()), { unitTransforms: null, unitTransformsVersion: -1 });
    },
    update: function (state, update) {
        _representation__WEBPACK_IMPORTED_MODULE_1__["Representation"].updateState(state, update);
        if (update.unitTransforms !== undefined)
            state.unitTransforms = update.unitTransforms;
    }
};
function StructureRepresentationProvider(p) { return p; }
//




//# sourceMappingURL=representation.js.map

/***/ }),

/***/ "./lib/mol-repr/structure/representation/ball-and-stick.js":
/*!*****************************************************************!*\
  !*** ./lib/mol-repr/structure/representation/ball-and-stick.js ***!
  \*****************************************************************/
/*! exports provided: BallAndStickParams, getBallAndStickParams, BallAndStickRepresentation, BallAndStickRepresentationProvider */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "BallAndStickParams", function() { return BallAndStickParams; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getBallAndStickParams", function() { return getBallAndStickParams; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "BallAndStickRepresentation", function() { return BallAndStickRepresentation; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "BallAndStickRepresentationProvider", function() { return BallAndStickRepresentationProvider; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _visual_bond_intra_unit_cylinder__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../visual/bond-intra-unit-cylinder */ "./lib/mol-repr/structure/visual/bond-intra-unit-cylinder.js");
/* harmony import */ var _visual_bond_inter_unit_cylinder__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../visual/bond-inter-unit-cylinder */ "./lib/mol-repr/structure/visual/bond-inter-unit-cylinder.js");
/* harmony import */ var _visual_element_sphere__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../visual/element-sphere */ "./lib/mol-repr/structure/visual/element-sphere.js");
/* harmony import */ var _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../../mol-util/param-definition */ "./lib/mol-util/param-definition.js");
/* harmony import */ var _units_representation__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../units-representation */ "./lib/mol-repr/structure/units-representation.js");
/* harmony import */ var _complex_representation__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../complex-representation */ "./lib/mol-repr/structure/complex-representation.js");
/* harmony import */ var _representation__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../representation */ "./lib/mol-repr/structure/representation.js");
/* harmony import */ var _mol_repr_representation__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ../../../mol-repr/representation */ "./lib/mol-repr/representation.js");
/* harmony import */ var _params__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ../params */ "./lib/mol-repr/structure/params.js");
/**
 * Copyright (c) 2018-2021 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */










var BallAndStickVisuals = {
    'element-sphere': function (ctx, getParams) { return Object(_units_representation__WEBPACK_IMPORTED_MODULE_5__["UnitsRepresentation"])('Element sphere', ctx, getParams, _visual_element_sphere__WEBPACK_IMPORTED_MODULE_3__["ElementSphereVisual"]); },
    'intra-bond': function (ctx, getParams) { return Object(_units_representation__WEBPACK_IMPORTED_MODULE_5__["UnitsRepresentation"])('Intra-unit bond cylinder', ctx, getParams, _visual_bond_intra_unit_cylinder__WEBPACK_IMPORTED_MODULE_1__["IntraUnitBondCylinderVisual"]); },
    'inter-bond': function (ctx, getParams) { return Object(_complex_representation__WEBPACK_IMPORTED_MODULE_6__["ComplexRepresentation"])('Inter-unit bond cylinder', ctx, getParams, _visual_bond_inter_unit_cylinder__WEBPACK_IMPORTED_MODULE_2__["InterUnitBondCylinderVisual"]); },
};
var BallAndStickParams = Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, _visual_element_sphere__WEBPACK_IMPORTED_MODULE_3__["ElementSphereParams"]), _visual_bond_intra_unit_cylinder__WEBPACK_IMPORTED_MODULE_1__["IntraUnitBondCylinderParams"]), _visual_bond_inter_unit_cylinder__WEBPACK_IMPORTED_MODULE_2__["InterUnitBondCylinderParams"]), { unitKinds: Object(_params__WEBPACK_IMPORTED_MODULE_9__["getUnitKindsParam"])(['atomic']), sizeFactor: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_4__["ParamDefinition"].Numeric(0.15, { min: 0.01, max: 10, step: 0.01 }), sizeAspectRatio: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_4__["ParamDefinition"].Numeric(2 / 3, { min: 0.01, max: 3, step: 0.01 }), visuals: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_4__["ParamDefinition"].MultiSelect(['element-sphere', 'intra-bond', 'inter-bond'], _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_4__["ParamDefinition"].objectToOptions(BallAndStickVisuals)) });
function getBallAndStickParams(ctx, structure) {
    return _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_4__["ParamDefinition"].clone(BallAndStickParams);
}
function BallAndStickRepresentation(ctx, getParams) {
    return _mol_repr_representation__WEBPACK_IMPORTED_MODULE_8__["Representation"].createMulti('Ball & Stick', ctx, getParams, _representation__WEBPACK_IMPORTED_MODULE_7__["StructureRepresentationStateBuilder"], BallAndStickVisuals);
}
var BallAndStickRepresentationProvider = Object(_representation__WEBPACK_IMPORTED_MODULE_7__["StructureRepresentationProvider"])({
    name: 'ball-and-stick',
    label: 'Ball & Stick',
    description: 'Displays atoms as spheres and bonds as cylinders.',
    factory: BallAndStickRepresentation,
    getParams: getBallAndStickParams,
    defaultValues: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_4__["ParamDefinition"].getDefaultValues(BallAndStickParams),
    defaultColorTheme: { name: 'element-symbol' },
    defaultSizeTheme: { name: 'physical' },
    isApplicable: function (structure) { return structure.elementCount > 0; }
});
//# sourceMappingURL=ball-and-stick.js.map

/***/ }),

/***/ "./lib/mol-repr/structure/representation/carbohydrate.js":
/*!***************************************************************!*\
  !*** ./lib/mol-repr/structure/representation/carbohydrate.js ***!
  \***************************************************************/
/*! exports provided: CarbohydrateParams, getCarbohydrateParams, CarbohydrateRepresentation, CarbohydrateRepresentationProvider */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CarbohydrateParams", function() { return CarbohydrateParams; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getCarbohydrateParams", function() { return getCarbohydrateParams; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CarbohydrateRepresentation", function() { return CarbohydrateRepresentation; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CarbohydrateRepresentationProvider", function() { return CarbohydrateRepresentationProvider; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _mol_model_structure__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../../mol-model/structure */ "./lib/mol-model/structure.js");
/* harmony import */ var _mol_repr_representation__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../../mol-repr/representation */ "./lib/mol-repr/representation.js");
/* harmony import */ var _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../../mol-util/param-definition */ "./lib/mol-util/param-definition.js");
/* harmony import */ var _complex_representation__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../complex-representation */ "./lib/mol-repr/structure/complex-representation.js");
/* harmony import */ var _representation__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../representation */ "./lib/mol-repr/structure/representation.js");
/* harmony import */ var _visual_carbohydrate_link_cylinder__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../visual/carbohydrate-link-cylinder */ "./lib/mol-repr/structure/visual/carbohydrate-link-cylinder.js");
/* harmony import */ var _visual_carbohydrate_symbol_mesh__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../visual/carbohydrate-symbol-mesh */ "./lib/mol-repr/structure/visual/carbohydrate-symbol-mesh.js");
/* harmony import */ var _visual_carbohydrate_terminal_link_cylinder__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ../visual/carbohydrate-terminal-link-cylinder */ "./lib/mol-repr/structure/visual/carbohydrate-terminal-link-cylinder.js");
/**
 * Copyright (c) 2018 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */









var CarbohydrateVisuals = {
    'carbohydrate-symbol': function (ctx, getParams) { return Object(_complex_representation__WEBPACK_IMPORTED_MODULE_4__["ComplexRepresentation"])('Carbohydrate symbol mesh', ctx, getParams, _visual_carbohydrate_symbol_mesh__WEBPACK_IMPORTED_MODULE_7__["CarbohydrateSymbolVisual"]); },
    'carbohydrate-link': function (ctx, getParams) { return Object(_complex_representation__WEBPACK_IMPORTED_MODULE_4__["ComplexRepresentation"])('Carbohydrate link cylinder', ctx, getParams, _visual_carbohydrate_link_cylinder__WEBPACK_IMPORTED_MODULE_6__["CarbohydrateLinkVisual"]); },
    'carbohydrate-terminal-link': function (ctx, getParams) { return Object(_complex_representation__WEBPACK_IMPORTED_MODULE_4__["ComplexRepresentation"])('Carbohydrate terminal link cylinder', ctx, getParams, _visual_carbohydrate_terminal_link_cylinder__WEBPACK_IMPORTED_MODULE_8__["CarbohydrateTerminalLinkVisual"]); },
};
var CarbohydrateParams = Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, _visual_carbohydrate_symbol_mesh__WEBPACK_IMPORTED_MODULE_7__["CarbohydrateSymbolParams"]), _visual_carbohydrate_link_cylinder__WEBPACK_IMPORTED_MODULE_6__["CarbohydrateLinkParams"]), _visual_carbohydrate_terminal_link_cylinder__WEBPACK_IMPORTED_MODULE_8__["CarbohydrateTerminalLinkParams"]), { visuals: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_3__["ParamDefinition"].MultiSelect(['carbohydrate-symbol', 'carbohydrate-link', 'carbohydrate-terminal-link'], _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_3__["ParamDefinition"].objectToOptions(CarbohydrateVisuals)) });
function getCarbohydrateParams(ctx, structure) {
    return _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_3__["ParamDefinition"].clone(CarbohydrateParams);
}
function CarbohydrateRepresentation(ctx, getParams) {
    return _mol_repr_representation__WEBPACK_IMPORTED_MODULE_2__["Representation"].createMulti('Carbohydrate', ctx, getParams, _representation__WEBPACK_IMPORTED_MODULE_5__["StructureRepresentationStateBuilder"], CarbohydrateVisuals);
}
var CarbohydrateRepresentationProvider = Object(_representation__WEBPACK_IMPORTED_MODULE_5__["StructureRepresentationProvider"])({
    name: 'carbohydrate',
    label: 'Carbohydrate',
    description: 'Displays carbohydrate symbols (3D SNFG).',
    factory: CarbohydrateRepresentation,
    getParams: getCarbohydrateParams,
    defaultValues: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_3__["ParamDefinition"].getDefaultValues(CarbohydrateParams),
    defaultColorTheme: { name: 'carbohydrate-symbol' },
    defaultSizeTheme: { name: 'uniform' },
    isApplicable: function (structure) {
        return structure.models.some(function (m) { return _mol_model_structure__WEBPACK_IMPORTED_MODULE_1__["Model"].hasCarbohydrate(m); });
    }
});
//# sourceMappingURL=carbohydrate.js.map

/***/ }),

/***/ "./lib/mol-repr/structure/representation/cartoon.js":
/*!**********************************************************!*\
  !*** ./lib/mol-repr/structure/representation/cartoon.js ***!
  \**********************************************************/
/*! exports provided: CartoonParams, getCartoonParams, CartoonRepresentation, CartoonRepresentationProvider */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CartoonParams", function() { return CartoonParams; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getCartoonParams", function() { return getCartoonParams; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CartoonRepresentation", function() { return CartoonRepresentation; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CartoonRepresentationProvider", function() { return CartoonRepresentationProvider; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _mol_model_structure__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../../mol-model/structure */ "./lib/mol-model/structure.js");
/* harmony import */ var _mol_repr_representation__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../../mol-repr/representation */ "./lib/mol-repr/representation.js");
/* harmony import */ var _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../../mol-util/param-definition */ "./lib/mol-util/param-definition.js");
/* harmony import */ var _representation__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../representation */ "./lib/mol-repr/structure/representation.js");
/* harmony import */ var _units_representation__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../units-representation */ "./lib/mol-repr/structure/units-representation.js");
/* harmony import */ var _visual_nucleotide_block_mesh__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../visual/nucleotide-block-mesh */ "./lib/mol-repr/structure/visual/nucleotide-block-mesh.js");
/* harmony import */ var _visual_nucleotide_ring_mesh__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../visual/nucleotide-ring-mesh */ "./lib/mol-repr/structure/visual/nucleotide-ring-mesh.js");
/* harmony import */ var _visual_polymer_direction_wedge__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ../visual/polymer-direction-wedge */ "./lib/mol-repr/structure/visual/polymer-direction-wedge.js");
/* harmony import */ var _visual_polymer_gap_cylinder__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ../visual/polymer-gap-cylinder */ "./lib/mol-repr/structure/visual/polymer-gap-cylinder.js");
/* harmony import */ var _visual_polymer_trace_mesh__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ../visual/polymer-trace-mesh */ "./lib/mol-repr/structure/visual/polymer-trace-mesh.js");
/* harmony import */ var _mol_model_props_computed_secondary_structure__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ../../../mol-model-props/computed/secondary-structure */ "./lib/mol-model-props/computed/secondary-structure.js");
/**
 * Copyright (c) 2018 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */












var CartoonVisuals = {
    'polymer-trace': function (ctx, getParams) { return Object(_units_representation__WEBPACK_IMPORTED_MODULE_5__["UnitsRepresentation"])('Polymer trace mesh', ctx, getParams, _visual_polymer_trace_mesh__WEBPACK_IMPORTED_MODULE_10__["PolymerTraceVisual"]); },
    'polymer-gap': function (ctx, getParams) { return Object(_units_representation__WEBPACK_IMPORTED_MODULE_5__["UnitsRepresentation"])('Polymer gap cylinder', ctx, getParams, _visual_polymer_gap_cylinder__WEBPACK_IMPORTED_MODULE_9__["PolymerGapVisual"]); },
    'nucleotide-block': function (ctx, getParams) { return Object(_units_representation__WEBPACK_IMPORTED_MODULE_5__["UnitsRepresentation"])('Nucleotide block mesh', ctx, getParams, _visual_nucleotide_block_mesh__WEBPACK_IMPORTED_MODULE_6__["NucleotideBlockVisual"]); },
    'nucleotide-ring': function (ctx, getParams) { return Object(_units_representation__WEBPACK_IMPORTED_MODULE_5__["UnitsRepresentation"])('Nucleotide ring mesh', ctx, getParams, _visual_nucleotide_ring_mesh__WEBPACK_IMPORTED_MODULE_7__["NucleotideRingVisual"]); },
    'direction-wedge': function (ctx, getParams) { return Object(_units_representation__WEBPACK_IMPORTED_MODULE_5__["UnitsRepresentation"])('Polymer direction wedge', ctx, getParams, _visual_polymer_direction_wedge__WEBPACK_IMPORTED_MODULE_8__["PolymerDirectionVisual"]); }
};
var CartoonParams = Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, _visual_polymer_trace_mesh__WEBPACK_IMPORTED_MODULE_10__["PolymerTraceParams"]), _visual_polymer_gap_cylinder__WEBPACK_IMPORTED_MODULE_9__["PolymerGapParams"]), _visual_nucleotide_block_mesh__WEBPACK_IMPORTED_MODULE_6__["NucleotideBlockParams"]), _visual_nucleotide_ring_mesh__WEBPACK_IMPORTED_MODULE_7__["NucleotideRingParams"]), _visual_polymer_direction_wedge__WEBPACK_IMPORTED_MODULE_8__["PolymerDirectionParams"]), { sizeFactor: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_3__["ParamDefinition"].Numeric(0.2, { min: 0, max: 10, step: 0.01 }), visuals: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_3__["ParamDefinition"].MultiSelect(['polymer-trace', 'polymer-gap', 'nucleotide-block'], _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_3__["ParamDefinition"].objectToOptions(CartoonVisuals)) });
function getCartoonParams(ctx, structure) {
    var params = _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_3__["ParamDefinition"].clone(CartoonParams);
    var hasNucleotides = false;
    var hasGaps = false;
    structure.units.forEach(function (u) {
        if (!hasNucleotides && _mol_model_structure__WEBPACK_IMPORTED_MODULE_1__["Unit"].isAtomic(u) && u.nucleotideElements.length)
            hasNucleotides = true;
        if (!hasGaps && u.gapElements.length)
            hasGaps = true;
    });
    params.visuals.defaultValue = ['polymer-trace'];
    if (hasNucleotides)
        params.visuals.defaultValue.push('nucleotide-block');
    if (hasGaps)
        params.visuals.defaultValue.push('polymer-gap');
    return params;
}
function CartoonRepresentation(ctx, getParams) {
    return _mol_repr_representation__WEBPACK_IMPORTED_MODULE_2__["Representation"].createMulti('Cartoon', ctx, getParams, _representation__WEBPACK_IMPORTED_MODULE_4__["StructureRepresentationStateBuilder"], CartoonVisuals);
}
var CartoonRepresentationProvider = Object(_representation__WEBPACK_IMPORTED_MODULE_4__["StructureRepresentationProvider"])({
    name: 'cartoon',
    label: 'Cartoon',
    description: 'Displays ribbons, planks, tubes smoothly following the trace atoms of polymers.',
    factory: CartoonRepresentation,
    getParams: getCartoonParams,
    defaultValues: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_3__["ParamDefinition"].getDefaultValues(CartoonParams),
    defaultColorTheme: { name: 'prediction' },
    defaultSizeTheme: { name: 'uniform' },
    isApplicable: function (structure) { return structure.polymerResidueCount > 0; },
    ensureCustomProperties: {
        attach: function (ctx, structure) { return _mol_model_props_computed_secondary_structure__WEBPACK_IMPORTED_MODULE_11__["SecondaryStructureProvider"].attach(ctx, structure, void 0, true); },
        detach: function (data) { return _mol_model_props_computed_secondary_structure__WEBPACK_IMPORTED_MODULE_11__["SecondaryStructureProvider"].ref(data, false); }
    }
});
//# sourceMappingURL=cartoon.js.map

/***/ }),

/***/ "./lib/mol-repr/structure/representation/ellipsoid.js":
/*!************************************************************!*\
  !*** ./lib/mol-repr/structure/representation/ellipsoid.js ***!
  \************************************************************/
/*! exports provided: EllipsoidParams, getEllipsoidParams, EllipsoidRepresentation, EllipsoidRepresentationProvider */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "EllipsoidParams", function() { return EllipsoidParams; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getEllipsoidParams", function() { return getEllipsoidParams; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "EllipsoidRepresentation", function() { return EllipsoidRepresentation; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "EllipsoidRepresentationProvider", function() { return EllipsoidRepresentationProvider; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../../mol-util/param-definition */ "./lib/mol-util/param-definition.js");
/* harmony import */ var _mol_repr_representation__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../../mol-repr/representation */ "./lib/mol-repr/representation.js");
/* harmony import */ var _mol_repr_structure_representation__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../../mol-repr/structure/representation */ "./lib/mol-repr/structure/representation.js");
/* harmony import */ var _visual_ellipsoid_mesh__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../visual/ellipsoid-mesh */ "./lib/mol-repr/structure/visual/ellipsoid-mesh.js");
/* harmony import */ var _mol_model_formats_structure_property_anisotropic__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../../mol-model-formats/structure/property/anisotropic */ "./lib/mol-model-formats/structure/property/anisotropic.js");
/* harmony import */ var _visual_bond_intra_unit_cylinder__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../visual/bond-intra-unit-cylinder */ "./lib/mol-repr/structure/visual/bond-intra-unit-cylinder.js");
/* harmony import */ var _visual_bond_inter_unit_cylinder__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../visual/bond-inter-unit-cylinder */ "./lib/mol-repr/structure/visual/bond-inter-unit-cylinder.js");
/* harmony import */ var _params__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ../params */ "./lib/mol-repr/structure/params.js");
/**
 * Copyright (c) 2019-2021 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */









var EllipsoidVisuals = {
    'ellipsoid-mesh': function (ctx, getParams) { return Object(_mol_repr_structure_representation__WEBPACK_IMPORTED_MODULE_3__["UnitsRepresentation"])('Ellipsoid Mesh', ctx, getParams, _visual_ellipsoid_mesh__WEBPACK_IMPORTED_MODULE_4__["EllipsoidMeshVisual"]); },
    'intra-bond': function (ctx, getParams) { return Object(_mol_repr_structure_representation__WEBPACK_IMPORTED_MODULE_3__["UnitsRepresentation"])('Intra-unit bond cylinder', ctx, getParams, _visual_bond_intra_unit_cylinder__WEBPACK_IMPORTED_MODULE_6__["IntraUnitBondCylinderVisual"]); },
    'inter-bond': function (ctx, getParams) { return Object(_mol_repr_structure_representation__WEBPACK_IMPORTED_MODULE_3__["ComplexRepresentation"])('Inter-unit bond cylinder', ctx, getParams, _visual_bond_inter_unit_cylinder__WEBPACK_IMPORTED_MODULE_7__["InterUnitBondCylinderVisual"]); },
};
var EllipsoidParams = Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, _visual_ellipsoid_mesh__WEBPACK_IMPORTED_MODULE_4__["EllipsoidMeshParams"]), _visual_bond_intra_unit_cylinder__WEBPACK_IMPORTED_MODULE_6__["IntraUnitBondCylinderParams"]), _visual_bond_inter_unit_cylinder__WEBPACK_IMPORTED_MODULE_7__["InterUnitBondCylinderParams"]), { unitKinds: Object(_params__WEBPACK_IMPORTED_MODULE_8__["getUnitKindsParam"])(['atomic']), sizeFactor: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_1__["ParamDefinition"].Numeric(1, { min: 0.01, max: 10, step: 0.01 }), sizeAspectRatio: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_1__["ParamDefinition"].Numeric(0.1, { min: 0.01, max: 3, step: 0.01 }), linkCap: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_1__["ParamDefinition"].Boolean(true), visuals: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_1__["ParamDefinition"].MultiSelect(['ellipsoid-mesh', 'intra-bond', 'inter-bond'], _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_1__["ParamDefinition"].objectToOptions(EllipsoidVisuals)) });
function getEllipsoidParams(ctx, structure) {
    return _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_1__["ParamDefinition"].clone(EllipsoidParams);
}
function EllipsoidRepresentation(ctx, getParams) {
    return _mol_repr_representation__WEBPACK_IMPORTED_MODULE_2__["Representation"].createMulti('Ellipsoid', ctx, getParams, _mol_repr_structure_representation__WEBPACK_IMPORTED_MODULE_3__["StructureRepresentationStateBuilder"], EllipsoidVisuals);
}
var EllipsoidRepresentationProvider = Object(_mol_repr_structure_representation__WEBPACK_IMPORTED_MODULE_3__["StructureRepresentationProvider"])({
    name: 'ellipsoid',
    label: 'Ellipsoid',
    description: 'Displays anisotropic displacement ellipsoids of atomic elements plus bonds as cylinders.',
    factory: EllipsoidRepresentation,
    getParams: getEllipsoidParams,
    defaultValues: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_1__["ParamDefinition"].getDefaultValues(EllipsoidParams),
    defaultColorTheme: { name: 'element-symbol' },
    defaultSizeTheme: { name: 'uniform' },
    isApplicable: function (structure) { return structure.elementCount > 0 && structure.models.some(function (m) { return _mol_model_formats_structure_property_anisotropic__WEBPACK_IMPORTED_MODULE_5__["AtomSiteAnisotrop"].Provider.isApplicable(m); }); }
});
//# sourceMappingURL=ellipsoid.js.map

/***/ }),

/***/ "./lib/mol-repr/structure/representation/gaussian-surface.js":
/*!*******************************************************************!*\
  !*** ./lib/mol-repr/structure/representation/gaussian-surface.js ***!
  \*******************************************************************/
/*! exports provided: GaussianSurfaceParams, getGaussianSurfaceParams, GaussianSurfaceRepresentation, GaussianSurfaceRepresentationProvider */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "GaussianSurfaceParams", function() { return GaussianSurfaceParams; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getGaussianSurfaceParams", function() { return getGaussianSurfaceParams; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "GaussianSurfaceRepresentation", function() { return GaussianSurfaceRepresentation; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "GaussianSurfaceRepresentationProvider", function() { return GaussianSurfaceRepresentationProvider; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _visual_gaussian_surface_mesh__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../visual/gaussian-surface-mesh */ "./lib/mol-repr/structure/visual/gaussian-surface-mesh.js");
/* harmony import */ var _units_representation__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../units-representation */ "./lib/mol-repr/structure/units-representation.js");
/* harmony import */ var _visual_gaussian_surface_wireframe__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../visual/gaussian-surface-wireframe */ "./lib/mol-repr/structure/visual/gaussian-surface-wireframe.js");
/* harmony import */ var _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../../mol-util/param-definition */ "./lib/mol-util/param-definition.js");
/* harmony import */ var _representation__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../representation */ "./lib/mol-repr/structure/representation.js");
/* harmony import */ var _mol_repr_representation__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../../../mol-repr/representation */ "./lib/mol-repr/representation.js");
/**
 * Copyright (c) 2018-2021 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */







var GaussianSurfaceVisuals = {
    'gaussian-surface-mesh': function (ctx, getParams) { return Object(_units_representation__WEBPACK_IMPORTED_MODULE_2__["UnitsRepresentation"])('Gaussian surface mesh', ctx, getParams, _visual_gaussian_surface_mesh__WEBPACK_IMPORTED_MODULE_1__["GaussianSurfaceVisual"]); },
    'structure-gaussian-surface-mesh': function (ctx, getParams) { return Object(_representation__WEBPACK_IMPORTED_MODULE_5__["ComplexRepresentation"])('Structure-Gaussian surface mesh', ctx, getParams, _visual_gaussian_surface_mesh__WEBPACK_IMPORTED_MODULE_1__["StructureGaussianSurfaceVisual"]); },
    'gaussian-surface-wireframe': function (ctx, getParams) { return Object(_units_representation__WEBPACK_IMPORTED_MODULE_2__["UnitsRepresentation"])('Gaussian surface wireframe', ctx, getParams, _visual_gaussian_surface_wireframe__WEBPACK_IMPORTED_MODULE_3__["GaussianWireframeVisual"]); },
};
var GaussianSurfaceParams = Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, _visual_gaussian_surface_mesh__WEBPACK_IMPORTED_MODULE_1__["GaussianSurfaceMeshParams"]), _visual_gaussian_surface_wireframe__WEBPACK_IMPORTED_MODULE_3__["GaussianWireframeParams"]), { visuals: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_4__["ParamDefinition"].MultiSelect(['gaussian-surface-mesh'], _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_4__["ParamDefinition"].objectToOptions(GaussianSurfaceVisuals)) });
function getGaussianSurfaceParams(ctx, structure) {
    return _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_4__["ParamDefinition"].clone(GaussianSurfaceParams);
}
function GaussianSurfaceRepresentation(ctx, getParams) {
    return _mol_repr_representation__WEBPACK_IMPORTED_MODULE_6__["Representation"].createMulti('Gaussian Surface', ctx, getParams, _representation__WEBPACK_IMPORTED_MODULE_5__["StructureRepresentationStateBuilder"], GaussianSurfaceVisuals);
}
var GaussianSurfaceRepresentationProvider = Object(_representation__WEBPACK_IMPORTED_MODULE_5__["StructureRepresentationProvider"])({
    name: 'gaussian-surface',
    label: 'Gaussian Surface',
    description: 'Displays a gaussian molecular surface.',
    factory: GaussianSurfaceRepresentation,
    getParams: getGaussianSurfaceParams,
    defaultValues: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_4__["ParamDefinition"].getDefaultValues(GaussianSurfaceParams),
    defaultColorTheme: { name: 'chain-id' },
    defaultSizeTheme: { name: 'uniform' },
    isApplicable: function (structure) { return structure.elementCount > 0; }
});
//# sourceMappingURL=gaussian-surface.js.map

/***/ }),

/***/ "./lib/mol-repr/structure/representation/gaussian-volume.js":
/*!******************************************************************!*\
  !*** ./lib/mol-repr/structure/representation/gaussian-volume.js ***!
  \******************************************************************/
/*! exports provided: GaussianVolumeParams, getGaussianVolumeParams, GaussianVolumeRepresentation, GaussianVolumeRepresentationProvider */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "GaussianVolumeParams", function() { return GaussianVolumeParams; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getGaussianVolumeParams", function() { return getGaussianVolumeParams; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "GaussianVolumeRepresentation", function() { return GaussianVolumeRepresentation; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "GaussianVolumeRepresentationProvider", function() { return GaussianVolumeRepresentationProvider; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../../mol-util/param-definition */ "./lib/mol-util/param-definition.js");
/* harmony import */ var _visual_gaussian_density_volume__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../visual/gaussian-density-volume */ "./lib/mol-repr/structure/visual/gaussian-density-volume.js");
/* harmony import */ var _representation__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../representation */ "./lib/mol-repr/structure/representation.js");
/* harmony import */ var _mol_repr_representation__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../../mol-repr/representation */ "./lib/mol-repr/representation.js");
/* harmony import */ var _mol_geo_geometry_direct_volume_direct_volume__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../../mol-geo/geometry/direct-volume/direct-volume */ "./lib/mol-geo/geometry/direct-volume/direct-volume.js");
/**
 * Copyright (c) 2018-2020 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */






var GaussianVolumeVisuals = {
    'gaussian-volume': function (ctx, getParams) { return Object(_representation__WEBPACK_IMPORTED_MODULE_3__["ComplexRepresentation"])('Gaussian volume', ctx, getParams, _visual_gaussian_density_volume__WEBPACK_IMPORTED_MODULE_2__["GaussianDensityVolumeVisual"]); },
    'units-gaussian-volume': function (ctx, getParams) { return Object(_representation__WEBPACK_IMPORTED_MODULE_3__["UnitsRepresentation"])('Units-Gaussian volume', ctx, getParams, _visual_gaussian_density_volume__WEBPACK_IMPORTED_MODULE_2__["UnitsGaussianDensityVolumeVisual"]); }
};
var GaussianVolumeParams = Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, _visual_gaussian_density_volume__WEBPACK_IMPORTED_MODULE_2__["GaussianDensityVolumeParams"]), { visuals: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_1__["ParamDefinition"].MultiSelect(['gaussian-volume'], _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_1__["ParamDefinition"].objectToOptions(GaussianVolumeVisuals)) });
function getGaussianVolumeParams(ctx, structure) {
    var p = _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_1__["ParamDefinition"].clone(GaussianVolumeParams);
    p.renderMode = _mol_geo_geometry_direct_volume_direct_volume__WEBPACK_IMPORTED_MODULE_5__["DirectVolume"].createRenderModeParam({
        // TODO find a better way to set
        min: 0, max: 1, mean: 0.04, sigma: 0.01
    });
    p.jumpLength = _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_1__["ParamDefinition"].Numeric(4, { min: 0, max: 20, step: 0.1 });
    return p;
}
function GaussianVolumeRepresentation(ctx, getParams) {
    return _mol_repr_representation__WEBPACK_IMPORTED_MODULE_4__["Representation"].createMulti('Gaussian Volume', ctx, getParams, _representation__WEBPACK_IMPORTED_MODULE_3__["StructureRepresentationStateBuilder"], GaussianVolumeVisuals);
}
var GaussianVolumeRepresentationProvider = Object(_representation__WEBPACK_IMPORTED_MODULE_3__["StructureRepresentationProvider"])({
    name: 'gaussian-volume',
    label: 'Gaussian Volume',
    description: 'Displays a gaussian molecular density using direct volume rendering.',
    factory: GaussianVolumeRepresentation,
    getParams: getGaussianVolumeParams,
    defaultValues: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_1__["ParamDefinition"].getDefaultValues(GaussianVolumeParams),
    defaultColorTheme: { name: 'chain-id' },
    defaultSizeTheme: { name: 'uniform' },
    isApplicable: function (structure) { return structure.elementCount > 0; }
});
//# sourceMappingURL=gaussian-volume.js.map

/***/ }),

/***/ "./lib/mol-repr/structure/representation/label.js":
/*!********************************************************!*\
  !*** ./lib/mol-repr/structure/representation/label.js ***!
  \********************************************************/
/*! exports provided: LabelParams, getLabelParams, LabelRepresentation, LabelRepresentationProvider */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "LabelParams", function() { return LabelParams; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getLabelParams", function() { return getLabelParams; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "LabelRepresentation", function() { return LabelRepresentation; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "LabelRepresentationProvider", function() { return LabelRepresentationProvider; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../../mol-util/param-definition */ "./lib/mol-util/param-definition.js");
/* harmony import */ var _representation__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../representation */ "./lib/mol-repr/structure/representation.js");
/* harmony import */ var _mol_repr_representation__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../../mol-repr/representation */ "./lib/mol-repr/representation.js");
/* harmony import */ var _visual_label_text__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../visual/label-text */ "./lib/mol-repr/structure/visual/label-text.js");
/* harmony import */ var _mol_util_marker_action__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../../mol-util/marker-action */ "./lib/mol-util/marker-action.js");
/**
 * Copyright (c) 2019 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */






var LabelVisuals = {
    'label-text': function (ctx, getParams) { return Object(_representation__WEBPACK_IMPORTED_MODULE_2__["ComplexRepresentation"])('Label text', ctx, getParams, _visual_label_text__WEBPACK_IMPORTED_MODULE_4__["LabelTextVisual"]); },
};
var LabelParams = Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, _visual_label_text__WEBPACK_IMPORTED_MODULE_4__["LabelTextParams"]), { visuals: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_1__["ParamDefinition"].MultiSelect(['label-text'], _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_1__["ParamDefinition"].objectToOptions(LabelVisuals)) });
function getLabelParams(ctx, structure) {
    return _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_1__["ParamDefinition"].clone(LabelParams);
}
function LabelRepresentation(ctx, getParams) {
    var repr = _mol_repr_representation__WEBPACK_IMPORTED_MODULE_3__["Representation"].createMulti('Label', ctx, getParams, _representation__WEBPACK_IMPORTED_MODULE_2__["StructureRepresentationStateBuilder"], LabelVisuals);
    repr.setState({ pickable: false, markerActions: _mol_util_marker_action__WEBPACK_IMPORTED_MODULE_5__["MarkerAction"].None });
    return repr;
}
var LabelRepresentationProvider = Object(_representation__WEBPACK_IMPORTED_MODULE_2__["StructureRepresentationProvider"])({
    name: 'label',
    label: 'Label',
    description: 'Displays labels.',
    factory: LabelRepresentation,
    getParams: getLabelParams,
    defaultValues: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_1__["ParamDefinition"].getDefaultValues(LabelParams),
    defaultColorTheme: { name: 'uniform' },
    defaultSizeTheme: { name: 'uniform' },
    isApplicable: function (structure) { return structure.elementCount > 0; }
});
//# sourceMappingURL=label.js.map

/***/ }),

/***/ "./lib/mol-repr/structure/representation/line.js":
/*!*******************************************************!*\
  !*** ./lib/mol-repr/structure/representation/line.js ***!
  \*******************************************************/
/*! exports provided: LineParams, getLineParams, LineRepresentation, LineRepresentationProvider */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "LineParams", function() { return LineParams; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getLineParams", function() { return getLineParams; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "LineRepresentation", function() { return LineRepresentation; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "LineRepresentationProvider", function() { return LineRepresentationProvider; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _visual_bond_intra_unit_line__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../visual/bond-intra-unit-line */ "./lib/mol-repr/structure/visual/bond-intra-unit-line.js");
/* harmony import */ var _visual_bond_inter_unit_line__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../visual/bond-inter-unit-line */ "./lib/mol-repr/structure/visual/bond-inter-unit-line.js");
/* harmony import */ var _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../../mol-util/param-definition */ "./lib/mol-util/param-definition.js");
/* harmony import */ var _units_representation__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../units-representation */ "./lib/mol-repr/structure/units-representation.js");
/* harmony import */ var _complex_representation__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../complex-representation */ "./lib/mol-repr/structure/complex-representation.js");
/* harmony import */ var _representation__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../representation */ "./lib/mol-repr/structure/representation.js");
/* harmony import */ var _mol_repr_representation__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../../../mol-repr/representation */ "./lib/mol-repr/representation.js");
/* harmony import */ var _params__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ../params */ "./lib/mol-repr/structure/params.js");
/**
 * Copyright (c) 2020 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */









var LineVisuals = {
    'intra-bond': function (ctx, getParams) { return Object(_units_representation__WEBPACK_IMPORTED_MODULE_4__["UnitsRepresentation"])('Intra-unit bond line', ctx, getParams, _visual_bond_intra_unit_line__WEBPACK_IMPORTED_MODULE_1__["IntraUnitBondLineVisual"]); },
    'inter-bond': function (ctx, getParams) { return Object(_complex_representation__WEBPACK_IMPORTED_MODULE_5__["ComplexRepresentation"])('Inter-unit bond line', ctx, getParams, _visual_bond_inter_unit_line__WEBPACK_IMPORTED_MODULE_2__["InterUnitBondLineVisual"]); },
};
var LineParams = Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, _visual_bond_intra_unit_line__WEBPACK_IMPORTED_MODULE_1__["IntraUnitBondLineParams"]), _visual_bond_inter_unit_line__WEBPACK_IMPORTED_MODULE_2__["InterUnitBondLineParams"]), { sizeFactor: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_3__["ParamDefinition"].Numeric(1.5, { min: 0.01, max: 10, step: 0.01 }), unitKinds: Object(_params__WEBPACK_IMPORTED_MODULE_8__["getUnitKindsParam"])(['atomic']), visuals: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_3__["ParamDefinition"].MultiSelect(['intra-bond', 'inter-bond'], _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_3__["ParamDefinition"].objectToOptions(LineVisuals)) });
function getLineParams(ctx, structure) {
    return _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_3__["ParamDefinition"].clone(LineParams);
}
function LineRepresentation(ctx, getParams) {
    return _mol_repr_representation__WEBPACK_IMPORTED_MODULE_7__["Representation"].createMulti('Line', ctx, getParams, _representation__WEBPACK_IMPORTED_MODULE_6__["StructureRepresentationStateBuilder"], LineVisuals);
}
var LineRepresentationProvider = Object(_representation__WEBPACK_IMPORTED_MODULE_6__["StructureRepresentationProvider"])({
    name: 'line',
    label: 'Line',
    description: 'Displays bonds as lines.',
    factory: LineRepresentation,
    getParams: getLineParams,
    defaultValues: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_3__["ParamDefinition"].getDefaultValues(LineParams),
    defaultColorTheme: { name: 'element-symbol' },
    defaultSizeTheme: { name: 'uniform' },
    isApplicable: function (structure) { return structure.elementCount > 0; }
});
//# sourceMappingURL=line.js.map

/***/ }),

/***/ "./lib/mol-repr/structure/representation/molecular-surface.js":
/*!********************************************************************!*\
  !*** ./lib/mol-repr/structure/representation/molecular-surface.js ***!
  \********************************************************************/
/*! exports provided: MolecularSurfaceParams, getMolecularSurfaceParams, MolecularSurfaceRepresentation, MolecularSurfaceRepresentationProvider */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MolecularSurfaceParams", function() { return MolecularSurfaceParams; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getMolecularSurfaceParams", function() { return getMolecularSurfaceParams; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MolecularSurfaceRepresentation", function() { return MolecularSurfaceRepresentation; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MolecularSurfaceRepresentationProvider", function() { return MolecularSurfaceRepresentationProvider; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _visual_molecular_surface_mesh__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../visual/molecular-surface-mesh */ "./lib/mol-repr/structure/visual/molecular-surface-mesh.js");
/* harmony import */ var _units_representation__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../units-representation */ "./lib/mol-repr/structure/units-representation.js");
/* harmony import */ var _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../../mol-util/param-definition */ "./lib/mol-util/param-definition.js");
/* harmony import */ var _representation__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../representation */ "./lib/mol-repr/structure/representation.js");
/* harmony import */ var _mol_repr_representation__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../../mol-repr/representation */ "./lib/mol-repr/representation.js");
/* harmony import */ var _visual_molecular_surface_wireframe__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../visual/molecular-surface-wireframe */ "./lib/mol-repr/structure/visual/molecular-surface-wireframe.js");
/**
 * Copyright (c) 2018-2019 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */







var MolecularSurfaceVisuals = {
    'molecular-surface-mesh': function (ctx, getParams) { return Object(_units_representation__WEBPACK_IMPORTED_MODULE_2__["UnitsRepresentation"])('Molecular surface mesh', ctx, getParams, _visual_molecular_surface_mesh__WEBPACK_IMPORTED_MODULE_1__["MolecularSurfaceMeshVisual"]); },
    'molecular-surface-wireframe': function (ctx, getParams) { return Object(_units_representation__WEBPACK_IMPORTED_MODULE_2__["UnitsRepresentation"])('Molecular surface wireframe', ctx, getParams, _visual_molecular_surface_wireframe__WEBPACK_IMPORTED_MODULE_6__["MolecularSurfaceWireframeVisual"]); },
};
var MolecularSurfaceParams = Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, _visual_molecular_surface_mesh__WEBPACK_IMPORTED_MODULE_1__["MolecularSurfaceMeshParams"]), _visual_molecular_surface_wireframe__WEBPACK_IMPORTED_MODULE_6__["MolecularSurfaceWireframeParams"]), { visuals: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_3__["ParamDefinition"].MultiSelect(['molecular-surface-mesh'], _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_3__["ParamDefinition"].objectToOptions(MolecularSurfaceVisuals)) });
function getMolecularSurfaceParams(ctx, structure) {
    return _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_3__["ParamDefinition"].clone(MolecularSurfaceParams);
}
function MolecularSurfaceRepresentation(ctx, getParams) {
    return _mol_repr_representation__WEBPACK_IMPORTED_MODULE_5__["Representation"].createMulti('Molecular Surface', ctx, getParams, _representation__WEBPACK_IMPORTED_MODULE_4__["StructureRepresentationStateBuilder"], MolecularSurfaceVisuals);
}
var MolecularSurfaceRepresentationProvider = Object(_representation__WEBPACK_IMPORTED_MODULE_4__["StructureRepresentationProvider"])({
    name: 'molecular-surface',
    label: 'Molecular Surface',
    description: 'Displays a molecular surface.',
    factory: MolecularSurfaceRepresentation,
    getParams: getMolecularSurfaceParams,
    defaultValues: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_3__["ParamDefinition"].getDefaultValues(MolecularSurfaceParams),
    defaultColorTheme: { name: 'chain-id' },
    defaultSizeTheme: { name: 'uniform' },
    isApplicable: function (structure) { return structure.elementCount > 0; }
});
//# sourceMappingURL=molecular-surface.js.map

/***/ }),

/***/ "./lib/mol-repr/structure/representation/orientation.js":
/*!**************************************************************!*\
  !*** ./lib/mol-repr/structure/representation/orientation.js ***!
  \**************************************************************/
/*! exports provided: OrientationParams, getOrientationParams, OrientationRepresentation, OrientationRepresentationProvider */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "OrientationParams", function() { return OrientationParams; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getOrientationParams", function() { return getOrientationParams; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "OrientationRepresentation", function() { return OrientationRepresentation; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "OrientationRepresentationProvider", function() { return OrientationRepresentationProvider; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _units_representation__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../units-representation */ "./lib/mol-repr/structure/units-representation.js");
/* harmony import */ var _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../../mol-util/param-definition */ "./lib/mol-util/param-definition.js");
/* harmony import */ var _representation__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../representation */ "./lib/mol-repr/structure/representation.js");
/* harmony import */ var _mol_repr_representation__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../../mol-repr/representation */ "./lib/mol-repr/representation.js");
/* harmony import */ var _visual_orientation_ellipsoid_mesh__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../visual/orientation-ellipsoid-mesh */ "./lib/mol-repr/structure/visual/orientation-ellipsoid-mesh.js");
/**
 * Copyright (c) 2019 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */






var OrientationVisuals = {
    'orientation-ellipsoid-mesh': function (ctx, getParams) { return Object(_units_representation__WEBPACK_IMPORTED_MODULE_1__["UnitsRepresentation"])('Orientation ellipsoid mesh', ctx, getParams, _visual_orientation_ellipsoid_mesh__WEBPACK_IMPORTED_MODULE_5__["OrientationEllipsoidMeshVisual"]); },
};
var OrientationParams = Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, _visual_orientation_ellipsoid_mesh__WEBPACK_IMPORTED_MODULE_5__["OrientationEllipsoidMeshParams"]), { visuals: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_2__["ParamDefinition"].MultiSelect(['orientation-ellipsoid-mesh'], _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_2__["ParamDefinition"].objectToOptions(OrientationVisuals)) });
function getOrientationParams(ctx, structure) {
    return _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_2__["ParamDefinition"].clone(OrientationParams);
}
function OrientationRepresentation(ctx, getParams) {
    return _mol_repr_representation__WEBPACK_IMPORTED_MODULE_4__["Representation"].createMulti('Orientation', ctx, getParams, _representation__WEBPACK_IMPORTED_MODULE_3__["StructureRepresentationStateBuilder"], OrientationVisuals);
}
var OrientationRepresentationProvider = Object(_representation__WEBPACK_IMPORTED_MODULE_3__["StructureRepresentationProvider"])({
    name: 'orientation',
    label: 'Orientation',
    description: 'Displays orientation ellipsoids for polymer chains.',
    factory: OrientationRepresentation,
    getParams: getOrientationParams,
    defaultValues: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_2__["ParamDefinition"].getDefaultValues(OrientationParams),
    defaultColorTheme: { name: 'chain-id' },
    defaultSizeTheme: { name: 'uniform' },
    isApplicable: function (structure) { return structure.elementCount > 0; }
});
//# sourceMappingURL=orientation.js.map

/***/ }),

/***/ "./lib/mol-repr/structure/representation/point.js":
/*!********************************************************!*\
  !*** ./lib/mol-repr/structure/representation/point.js ***!
  \********************************************************/
/*! exports provided: PointParams, getPointParams, PointRepresentation, PointRepresentationProvider */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "PointParams", function() { return PointParams; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getPointParams", function() { return getPointParams; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "PointRepresentation", function() { return PointRepresentation; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "PointRepresentationProvider", function() { return PointRepresentationProvider; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _visual_element_point__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../visual/element-point */ "./lib/mol-repr/structure/visual/element-point.js");
/* harmony import */ var _units_representation__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../units-representation */ "./lib/mol-repr/structure/units-representation.js");
/* harmony import */ var _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../../mol-util/param-definition */ "./lib/mol-util/param-definition.js");
/* harmony import */ var _representation__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../representation */ "./lib/mol-repr/structure/representation.js");
/* harmony import */ var _mol_repr_representation__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../../mol-repr/representation */ "./lib/mol-repr/representation.js");
/**
 * Copyright (c) 2018 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */






var PointVisuals = {
    'element-point': function (ctx, getParams) { return Object(_units_representation__WEBPACK_IMPORTED_MODULE_2__["UnitsRepresentation"])('Points', ctx, getParams, _visual_element_point__WEBPACK_IMPORTED_MODULE_1__["ElementPointVisual"]); },
};
var PointParams = Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, _visual_element_point__WEBPACK_IMPORTED_MODULE_1__["ElementPointParams"]);
function getPointParams(ctx, structure) {
    return _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_3__["ParamDefinition"].clone(PointParams);
}
function PointRepresentation(ctx, getParams) {
    return _mol_repr_representation__WEBPACK_IMPORTED_MODULE_5__["Representation"].createMulti('Point', ctx, getParams, _representation__WEBPACK_IMPORTED_MODULE_4__["StructureRepresentationStateBuilder"], PointVisuals);
}
var PointRepresentationProvider = Object(_representation__WEBPACK_IMPORTED_MODULE_4__["StructureRepresentationProvider"])({
    name: 'point',
    label: 'Point',
    description: 'Displays elements (atoms, coarse spheres) as spheres.',
    factory: PointRepresentation,
    getParams: getPointParams,
    defaultValues: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_3__["ParamDefinition"].getDefaultValues(PointParams),
    defaultColorTheme: { name: 'element-symbol' },
    defaultSizeTheme: { name: 'physical' },
    isApplicable: function (structure) { return structure.elementCount > 0; }
});
//# sourceMappingURL=point.js.map

/***/ }),

/***/ "./lib/mol-repr/structure/representation/putty.js":
/*!********************************************************!*\
  !*** ./lib/mol-repr/structure/representation/putty.js ***!
  \********************************************************/
/*! exports provided: PuttyParams, getPuttyParams, PuttyRepresentation, PuttyRepresentationProvider */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "PuttyParams", function() { return PuttyParams; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getPuttyParams", function() { return getPuttyParams; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "PuttyRepresentation", function() { return PuttyRepresentation; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "PuttyRepresentationProvider", function() { return PuttyRepresentationProvider; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _visual_polymer_tube_mesh__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../visual/polymer-tube-mesh */ "./lib/mol-repr/structure/visual/polymer-tube-mesh.js");
/* harmony import */ var _visual_polymer_gap_cylinder__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../visual/polymer-gap-cylinder */ "./lib/mol-repr/structure/visual/polymer-gap-cylinder.js");
/* harmony import */ var _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../../mol-util/param-definition */ "./lib/mol-util/param-definition.js");
/* harmony import */ var _units_representation__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../units-representation */ "./lib/mol-repr/structure/units-representation.js");
/* harmony import */ var _representation__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../representation */ "./lib/mol-repr/structure/representation.js");
/* harmony import */ var _mol_repr_representation__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../../../mol-repr/representation */ "./lib/mol-repr/representation.js");
/* harmony import */ var _mol_model_structure__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../../../mol-model/structure */ "./lib/mol-model/structure.js");
/**
 * Copyright (c) 2019-2020 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */








var PuttyVisuals = {
    'polymer-tube': function (ctx, getParams) { return Object(_units_representation__WEBPACK_IMPORTED_MODULE_4__["UnitsRepresentation"])('Polymer tube mesh', ctx, getParams, _visual_polymer_tube_mesh__WEBPACK_IMPORTED_MODULE_1__["PolymerTubeVisual"]); },
    'polymer-gap': function (ctx, getParams) { return Object(_units_representation__WEBPACK_IMPORTED_MODULE_4__["UnitsRepresentation"])('Polymer gap cylinder', ctx, getParams, _visual_polymer_gap_cylinder__WEBPACK_IMPORTED_MODULE_2__["PolymerGapVisual"]); },
};
var PuttyParams = Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, _visual_polymer_tube_mesh__WEBPACK_IMPORTED_MODULE_1__["PolymerTubeParams"]), _visual_polymer_gap_cylinder__WEBPACK_IMPORTED_MODULE_2__["PolymerGapParams"]), { sizeFactor: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_3__["ParamDefinition"].Numeric(0.2, { min: 0, max: 10, step: 0.01 }), visuals: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_3__["ParamDefinition"].MultiSelect(['polymer-tube', 'polymer-gap'], _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_3__["ParamDefinition"].objectToOptions(PuttyVisuals)) });
function getPuttyParams(ctx, structure) {
    var params = _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_3__["ParamDefinition"].clone(PuttyParams);
    var hasNucleotides = false;
    var hasGaps = false;
    structure.units.forEach(function (u) {
        if (!hasNucleotides && _mol_model_structure__WEBPACK_IMPORTED_MODULE_7__["Unit"].isAtomic(u) && u.nucleotideElements.length)
            hasNucleotides = true;
        if (!hasGaps && u.gapElements.length)
            hasGaps = true;
    });
    params.visuals.defaultValue = ['polymer-tube'];
    if (hasGaps)
        params.visuals.defaultValue.push('polymer-gap');
    return params;
}
function PuttyRepresentation(ctx, getParams) {
    return _mol_repr_representation__WEBPACK_IMPORTED_MODULE_6__["Representation"].createMulti('Putty', ctx, getParams, _representation__WEBPACK_IMPORTED_MODULE_5__["StructureRepresentationStateBuilder"], PuttyVisuals);
}
var PuttyRepresentationProvider = Object(_representation__WEBPACK_IMPORTED_MODULE_5__["StructureRepresentationProvider"])({
    name: 'putty',
    label: 'Putty',
    description: 'Displays a tube smoothly following the trace atoms of polymers.',
    factory: PuttyRepresentation,
    getParams: getPuttyParams,
    defaultValues: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_3__["ParamDefinition"].getDefaultValues(PuttyParams),
    defaultColorTheme: { name: 'chain-id' },
    defaultSizeTheme: { name: 'uncertainty' },
    isApplicable: function (structure) { return structure.polymerResidueCount > 0; },
});
//# sourceMappingURL=putty.js.map

/***/ }),

/***/ "./lib/mol-repr/structure/representation/spacefill.js":
/*!************************************************************!*\
  !*** ./lib/mol-repr/structure/representation/spacefill.js ***!
  \************************************************************/
/*! exports provided: SpacefillParams, getSpacefillParams, SpacefillRepresentation, SpacefillRepresentationProvider */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SpacefillParams", function() { return SpacefillParams; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getSpacefillParams", function() { return getSpacefillParams; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SpacefillRepresentation", function() { return SpacefillRepresentation; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SpacefillRepresentationProvider", function() { return SpacefillRepresentationProvider; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _visual_element_sphere__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../visual/element-sphere */ "./lib/mol-repr/structure/visual/element-sphere.js");
/* harmony import */ var _units_representation__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../units-representation */ "./lib/mol-repr/structure/units-representation.js");
/* harmony import */ var _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../../mol-util/param-definition */ "./lib/mol-util/param-definition.js");
/* harmony import */ var _representation__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../representation */ "./lib/mol-repr/structure/representation.js");
/* harmony import */ var _mol_repr_representation__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../../mol-repr/representation */ "./lib/mol-repr/representation.js");
/**
 * Copyright (c) 2018-2021 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */






var SpacefillVisuals = {
    'element-sphere': function (ctx, getParams) { return Object(_units_representation__WEBPACK_IMPORTED_MODULE_2__["UnitsRepresentation"])('Sphere mesh', ctx, getParams, _visual_element_sphere__WEBPACK_IMPORTED_MODULE_1__["ElementSphereVisual"]); },
};
var SpacefillParams = Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, _visual_element_sphere__WEBPACK_IMPORTED_MODULE_1__["ElementSphereParams"]);
function getSpacefillParams(ctx, structure) {
    return _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_3__["ParamDefinition"].clone(SpacefillParams);
}
function SpacefillRepresentation(ctx, getParams) {
    return _mol_repr_representation__WEBPACK_IMPORTED_MODULE_5__["Representation"].createMulti('Spacefill', ctx, getParams, _representation__WEBPACK_IMPORTED_MODULE_4__["StructureRepresentationStateBuilder"], SpacefillVisuals);
}
var SpacefillRepresentationProvider = Object(_representation__WEBPACK_IMPORTED_MODULE_4__["StructureRepresentationProvider"])({
    name: 'spacefill',
    label: 'Spacefill',
    description: 'Displays atomic/coarse elements as spheres.',
    factory: SpacefillRepresentation,
    getParams: getSpacefillParams,
    defaultValues: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_3__["ParamDefinition"].getDefaultValues(SpacefillParams),
    defaultColorTheme: { name: 'element-symbol' },
    defaultSizeTheme: { name: 'physical' },
    isApplicable: function (structure) { return structure.elementCount > 0; }
});
//# sourceMappingURL=spacefill.js.map

/***/ }),

/***/ "./lib/mol-repr/structure/units-representation.js":
/*!********************************************************!*\
  !*** ./lib/mol-repr/structure/units-representation.js ***!
  \********************************************************/
/*! exports provided: UnitsRepresentation */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "UnitsRepresentation", function() { return UnitsRepresentation; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../mol-util/param-definition */ "./lib/mol-util/param-definition.js");
/* harmony import */ var _representation__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./representation */ "./lib/mol-repr/structure/representation.js");
/* harmony import */ var _mol_model_structure__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../mol-model/structure */ "./lib/mol-model/structure.js");
/* harmony import */ var rxjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! rxjs */ "./node_modules/rxjs/_esm5/index.js");
/* harmony import */ var _mol_gl_render_object__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../mol-gl/render-object */ "./lib/mol-gl/render-object.js");
/* harmony import */ var _mol_theme_theme__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../../mol-theme/theme */ "./lib/mol-theme/theme.js");
/* harmony import */ var _mol_task__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../../mol-task */ "./lib/mol-task/index.js");
/* harmony import */ var _mol_model_loci__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ../../mol-model/loci */ "./lib/mol-model/loci.js");
/* harmony import */ var _mol_util_marker_action__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ../../mol-util/marker-action */ "./lib/mol-util/marker-action.js");
/* harmony import */ var _mol_theme_overpaint__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ../../mol-theme/overpaint */ "./lib/mol-theme/overpaint.js");
/* harmony import */ var _mol_theme_transparency__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ../../mol-theme/transparency */ "./lib/mol-theme/transparency.js");
/* harmony import */ var _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! ../../mol-math/linear-algebra */ "./lib/mol-math/linear-algebra.js");
/* harmony import */ var _mol_data_int__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! ../../mol-data/int */ "./lib/mol-data/int.js");
/* harmony import */ var _mol_theme_clipping__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! ../../mol-theme/clipping */ "./lib/mol-theme/clipping.js");
/**
 * Copyright (c) 2018-2021 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 * @author David Sehnal <david.sehnal@gmail.com>
 */















function UnitsRepresentation(label, ctx, getParams, visualCtor) {
    var version = 0;
    var webgl = ctx.webgl;
    var updated = new rxjs__WEBPACK_IMPORTED_MODULE_4__["Subject"]();
    var materialId = Object(_mol_gl_render_object__WEBPACK_IMPORTED_MODULE_5__["getNextMaterialId"])();
    var renderObjects = [];
    var _state = _representation__WEBPACK_IMPORTED_MODULE_2__["StructureRepresentationStateBuilder"].create();
    var visuals = new Map();
    var _structure;
    var _groups;
    var _params;
    var _props;
    var _theme = _mol_theme_theme__WEBPACK_IMPORTED_MODULE_6__["Theme"].createEmpty();
    function createOrUpdate(props, structure) {
        var _this = this;
        if (props === void 0) { props = {}; }
        if (structure && structure !== _structure) {
            _params = getParams(ctx, structure);
            if (!_props)
                _props = _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_1__["ParamDefinition"].getDefaultValues(_params);
        }
        _props = Object.assign({}, _props, props);
        return _mol_task__WEBPACK_IMPORTED_MODULE_7__["Task"].create('Creating or updating UnitsRepresentation', function (runtime) { return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"])(_this, void 0, void 0, function () {
            var i, group, visual, promise, oldVisuals, i, group, visualGroup, visual, promise, promise, arr, visual, promise, i, group, visualGroup, visual, promise, promise, visualsList_1, i, il, _a, visual, group, promise, promise;
            var _b, _c, _d;
            return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__generator"])(this, function (_e) {
                switch (_e.label) {
                    case 0:
                        if (!(!_structure && !structure)) return [3 /*break*/, 1];
                        throw new Error('missing structure');
                    case 1:
                        if (!(structure && !_structure)) return [3 /*break*/, 8];
                        // console.log(label, 'initial structure');
                        // First call with a structure, create visuals for each group.
                        _groups = structure.unitSymmetryGroups;
                        i = 0;
                        _e.label = 2;
                    case 2:
                        if (!(i < _groups.length)) return [3 /*break*/, 7];
                        group = _groups[i];
                        visual = visualCtor(materialId, _props, webgl);
                        promise = visual.createOrUpdate({ webgl: webgl, runtime: runtime }, _theme, _props, { group: group, structure: structure });
                        if (!promise) return [3 /*break*/, 4];
                        return [4 /*yield*/, promise];
                    case 3:
                        _e.sent();
                        _e.label = 4;
                    case 4:
                        setVisualState(visual, group, _state); // current state for new visual
                        visuals.set(group.hashCode, { visual: visual, group: group });
                        if (!runtime.shouldUpdate) return [3 /*break*/, 6];
                        return [4 /*yield*/, runtime.update({ message: 'Creating or updating UnitsVisual', current: i, max: _groups.length })];
                    case 5:
                        _e.sent();
                        _e.label = 6;
                    case 6:
                        i++;
                        return [3 /*break*/, 2];
                    case 7: return [3 /*break*/, 43];
                    case 8:
                        if (!(structure && !_mol_model_structure__WEBPACK_IMPORTED_MODULE_3__["Structure"].areUnitIdsAndIndicesEqual(structure, _structure))) return [3 /*break*/, 22];
                        // console.log(label, 'structures not equivalent');
                        // Tries to re-use existing visuals for the groups of the new structure.
                        // Creates additional visuals if needed, destroys left-over visuals.
                        _groups = structure.unitSymmetryGroups;
                        oldVisuals = visuals;
                        visuals = new Map();
                        i = 0;
                        _e.label = 9;
                    case 9:
                        if (!(i < _groups.length)) return [3 /*break*/, 21];
                        group = _groups[i];
                        visualGroup = oldVisuals.get(group.hashCode);
                        if (!visualGroup) return [3 /*break*/, 15];
                        visual = visualGroup.visual;
                        if (!((_b = visual.mustRecreate) === null || _b === void 0 ? void 0 : _b.call(visual, _props, webgl))) return [3 /*break*/, 12];
                        visual.destroy();
                        visual = visualCtor(materialId, _props, webgl);
                        promise = visual.createOrUpdate({ webgl: webgl, runtime: runtime }, _theme, _props, { group: group, structure: structure });
                        if (!promise) return [3 /*break*/, 11];
                        return [4 /*yield*/, promise];
                    case 10:
                        _e.sent();
                        _e.label = 11;
                    case 11:
                        setVisualState(visual, group, _state); // current state for new visual
                        return [3 /*break*/, 14];
                    case 12:
                        promise = visual.createOrUpdate({ webgl: webgl, runtime: runtime }, _theme, _props, { group: group, structure: structure });
                        if (!promise) return [3 /*break*/, 14];
                        return [4 /*yield*/, promise];
                    case 13:
                        _e.sent();
                        _e.label = 14;
                    case 14:
                        visuals.set(group.hashCode, { visual: visual, group: group });
                        oldVisuals.delete(group.hashCode);
                        // Remove highlight
                        // TODO: remove selection too??
                        if (visual.renderObject) {
                            arr = visual.renderObject.values.tMarker.ref.value.array;
                            Object(_mol_util_marker_action__WEBPACK_IMPORTED_MODULE_9__["applyMarkerAction"])(arr, _mol_data_int__WEBPACK_IMPORTED_MODULE_13__["Interval"].ofBounds(0, arr.length), _mol_util_marker_action__WEBPACK_IMPORTED_MODULE_9__["MarkerAction"].RemoveHighlight);
                        }
                        return [3 /*break*/, 18];
                    case 15:
                        visual = visualCtor(materialId, _props, webgl);
                        promise = visual.createOrUpdate({ webgl: webgl, runtime: runtime }, _theme, _props, { group: group, structure: structure });
                        if (!promise) return [3 /*break*/, 17];
                        return [4 /*yield*/, promise];
                    case 16:
                        _e.sent();
                        _e.label = 17;
                    case 17:
                        setVisualState(visual, group, _state); // current state for new visual
                        visuals.set(group.hashCode, { visual: visual, group: group });
                        _e.label = 18;
                    case 18:
                        if (!runtime.shouldUpdate) return [3 /*break*/, 20];
                        return [4 /*yield*/, runtime.update({ message: 'Creating or updating UnitsVisual', current: i, max: _groups.length })];
                    case 19:
                        _e.sent();
                        _e.label = 20;
                    case 20:
                        i++;
                        return [3 /*break*/, 9];
                    case 21:
                        oldVisuals.forEach(function (_a) {
                            var visual = _a.visual;
                            // console.log(label, 'removed unused visual');
                            visual.destroy();
                        });
                        return [3 /*break*/, 43];
                    case 22:
                        if (!(structure && structure !== _structure && _mol_model_structure__WEBPACK_IMPORTED_MODULE_3__["Structure"].areUnitIdsAndIndicesEqual(structure, _structure))) return [3 /*break*/, 34];
                        // console.log(label, 'structures equivalent but not identical');
                        // Expects that for structures with the same hashCode,
                        // the unitSymmetryGroups are the same as well.
                        // Re-uses existing visuals for the groups of the new structure.
                        _groups = structure.unitSymmetryGroups;
                        i = 0;
                        _e.label = 23;
                    case 23:
                        if (!(i < _groups.length)) return [3 /*break*/, 33];
                        group = _groups[i];
                        visualGroup = visuals.get(group.hashCode);
                        if (!visualGroup) return [3 /*break*/, 29];
                        visual = visualGroup.visual;
                        if (!((_c = visual.mustRecreate) === null || _c === void 0 ? void 0 : _c.call(visual, _props, ctx.webgl))) return [3 /*break*/, 26];
                        visual.destroy();
                        visual = visualCtor(materialId, _props, ctx.webgl);
                        visualGroup.visual = visual;
                        promise = visual.createOrUpdate({ webgl: webgl, runtime: runtime }, _theme, _props, { group: group, structure: structure });
                        if (!promise) return [3 /*break*/, 25];
                        return [4 /*yield*/, promise];
                    case 24:
                        _e.sent();
                        _e.label = 25;
                    case 25:
                        setVisualState(visual, group, _state); // current state for new visual
                        return [3 /*break*/, 28];
                    case 26:
                        promise = visual.createOrUpdate({ webgl: webgl, runtime: runtime }, _theme, _props, { group: group, structure: structure });
                        if (!promise) return [3 /*break*/, 28];
                        return [4 /*yield*/, promise];
                    case 27:
                        _e.sent();
                        _e.label = 28;
                    case 28:
                        visualGroup.group = group;
                        return [3 /*break*/, 30];
                    case 29: throw new Error("expected to find visual for hashCode " + group.hashCode);
                    case 30:
                        if (!runtime.shouldUpdate) return [3 /*break*/, 32];
                        return [4 /*yield*/, runtime.update({ message: 'Creating or updating UnitsVisual', current: i, max: _groups.length })];
                    case 31:
                        _e.sent();
                        _e.label = 32;
                    case 32:
                        i++;
                        return [3 /*break*/, 23];
                    case 33: return [3 /*break*/, 43];
                    case 34:
                        visualsList_1 = [];
                        visuals.forEach(function (vg) { return visualsList_1.push(vg); });
                        i = 0, il = visualsList_1.length;
                        _e.label = 35;
                    case 35:
                        if (!(i < il)) return [3 /*break*/, 43];
                        _a = visualsList_1[i], visual = _a.visual, group = _a.group;
                        if (!((_d = visual.mustRecreate) === null || _d === void 0 ? void 0 : _d.call(visual, _props, ctx.webgl))) return [3 /*break*/, 38];
                        visual.destroy();
                        visual = visualCtor(materialId, _props, webgl);
                        visualsList_1[i].visual = visual;
                        promise = visual.createOrUpdate({ webgl: webgl, runtime: runtime }, _theme, _props, { group: group, structure: _structure });
                        if (!promise) return [3 /*break*/, 37];
                        return [4 /*yield*/, promise];
                    case 36:
                        _e.sent();
                        _e.label = 37;
                    case 37:
                        setVisualState(visual, group, _state); // current state for new visual
                        return [3 /*break*/, 40];
                    case 38:
                        promise = visual.createOrUpdate({ webgl: webgl, runtime: runtime }, _theme, _props);
                        if (!promise) return [3 /*break*/, 40];
                        return [4 /*yield*/, promise];
                    case 39:
                        _e.sent();
                        _e.label = 40;
                    case 40:
                        if (!runtime.shouldUpdate) return [3 /*break*/, 42];
                        return [4 /*yield*/, runtime.update({ message: 'Creating or updating UnitsVisual', current: i, max: il })];
                    case 41:
                        _e.sent();
                        _e.label = 42;
                    case 42:
                        ++i;
                        return [3 /*break*/, 35];
                    case 43:
                        // update list of renderObjects
                        renderObjects.length = 0;
                        visuals.forEach(function (_a) {
                            var visual = _a.visual;
                            if (visual.renderObject)
                                renderObjects.push(visual.renderObject);
                        });
                        // set new structure
                        if (structure)
                            _structure = structure;
                        // increment version
                        updated.next(version++);
                        return [2 /*return*/];
                }
            });
        }); });
    }
    function getLoci(pickingId) {
        if (pickingId === undefined)
            return _mol_model_structure__WEBPACK_IMPORTED_MODULE_3__["Structure"].Loci(_structure);
        var loci = _mol_model_loci__WEBPACK_IMPORTED_MODULE_8__["EmptyLoci"];
        visuals.forEach(function (_a) {
            var visual = _a.visual;
            var _loci = visual.getLoci(pickingId);
            if (!Object(_mol_model_loci__WEBPACK_IMPORTED_MODULE_8__["isEmptyLoci"])(_loci))
                loci = _loci;
        });
        return loci;
    }
    function mark(loci, action) {
        if (!_structure)
            return false;
        if (!_mol_util_marker_action__WEBPACK_IMPORTED_MODULE_9__["MarkerActions"].is(_state.markerActions, action))
            return false;
        if (_mol_model_structure__WEBPACK_IMPORTED_MODULE_3__["Structure"].isLoci(loci) || _mol_model_structure__WEBPACK_IMPORTED_MODULE_3__["StructureElement"].Loci.is(loci) || _mol_model_structure__WEBPACK_IMPORTED_MODULE_3__["Bond"].isLoci(loci)) {
            if (!_mol_model_structure__WEBPACK_IMPORTED_MODULE_3__["Structure"].areRootsEquivalent(loci.structure, _structure))
                return false;
            // Remap `loci` from equivalent structure to the current `_structure`
            loci = _mol_model_loci__WEBPACK_IMPORTED_MODULE_8__["Loci"].remap(loci, _structure);
        }
        else if (!Object(_mol_model_loci__WEBPACK_IMPORTED_MODULE_8__["isEveryLoci"])(loci) && !Object(_mol_model_loci__WEBPACK_IMPORTED_MODULE_8__["isDataLoci"])(loci)) {
            return false;
        }
        if (_mol_model_loci__WEBPACK_IMPORTED_MODULE_8__["Loci"].isEmpty(loci))
            return false;
        var changed = false;
        visuals.forEach(function (_a) {
            var visual = _a.visual;
            changed = visual.mark(loci, action) || changed;
        });
        return changed;
    }
    function setVisualState(visual, group, state) {
        var visible = state.visible, alphaFactor = state.alphaFactor, pickable = state.pickable, overpaint = state.overpaint, transparency = state.transparency, clipping = state.clipping, transform = state.transform, unitTransforms = state.unitTransforms;
        if (visible !== undefined)
            visual.setVisibility(visible);
        if (alphaFactor !== undefined)
            visual.setAlphaFactor(alphaFactor);
        if (pickable !== undefined)
            visual.setPickable(pickable);
        if (overpaint !== undefined)
            visual.setOverpaint(overpaint);
        if (transparency !== undefined)
            visual.setTransparency(transparency);
        if (clipping !== undefined)
            visual.setClipping(clipping);
        if (transform !== undefined)
            visual.setTransform(transform);
        if (unitTransforms !== undefined) {
            if (unitTransforms) {
                // console.log(group.hashCode, unitTransforms.getSymmetryGroupTransforms(group))
                visual.setTransform(undefined, unitTransforms.getSymmetryGroupTransforms(group));
            }
            else {
                visual.setTransform(undefined, null);
            }
        }
    }
    function setState(state) {
        var visible = state.visible, alphaFactor = state.alphaFactor, pickable = state.pickable, overpaint = state.overpaint, transparency = state.transparency, clipping = state.clipping, transform = state.transform, unitTransforms = state.unitTransforms, syncManually = state.syncManually, markerActions = state.markerActions;
        var newState = {};
        if (visible !== _state.visible)
            newState.visible = visible;
        if (alphaFactor !== _state.alphaFactor)
            newState.alphaFactor = alphaFactor;
        if (pickable !== _state.pickable)
            newState.pickable = pickable;
        if (overpaint !== undefined && !_mol_theme_overpaint__WEBPACK_IMPORTED_MODULE_10__["Overpaint"].areEqual(overpaint, _state.overpaint)) {
            if (_structure) {
                newState.overpaint = _mol_theme_overpaint__WEBPACK_IMPORTED_MODULE_10__["Overpaint"].remap(overpaint, _structure);
            }
        }
        if (transparency !== undefined && !_mol_theme_transparency__WEBPACK_IMPORTED_MODULE_11__["Transparency"].areEqual(transparency, _state.transparency)) {
            if (_structure) {
                newState.transparency = _mol_theme_transparency__WEBPACK_IMPORTED_MODULE_11__["Transparency"].remap(transparency, _structure);
            }
        }
        if (clipping !== undefined && !_mol_theme_clipping__WEBPACK_IMPORTED_MODULE_14__["Clipping"].areEqual(clipping, _state.clipping)) {
            if (_structure) {
                newState.clipping = _mol_theme_clipping__WEBPACK_IMPORTED_MODULE_14__["Clipping"].remap(clipping, _structure);
            }
        }
        if (transform !== undefined && !_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_12__["Mat4"].areEqual(transform, _state.transform, _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_12__["EPSILON"])) {
            newState.transform = transform;
        }
        if (unitTransforms !== _state.unitTransforms || (unitTransforms === null || unitTransforms === void 0 ? void 0 : unitTransforms.version) !== state.unitTransformsVersion) {
            newState.unitTransforms = unitTransforms;
            _state.unitTransformsVersion = unitTransforms ? unitTransforms === null || unitTransforms === void 0 ? void 0 : unitTransforms.version : -1;
        }
        if (syncManually !== _state.syncManually)
            newState.syncManually = syncManually;
        if (markerActions !== _state.markerActions)
            newState.markerActions = markerActions;
        visuals.forEach(function (_a) {
            var visual = _a.visual, group = _a.group;
            return setVisualState(visual, group, newState);
        });
        _representation__WEBPACK_IMPORTED_MODULE_2__["StructureRepresentationStateBuilder"].update(_state, newState);
    }
    function setTheme(theme) {
        _theme = theme;
    }
    function destroy() {
        visuals.forEach(function (_a) {
            var visual = _a.visual;
            return visual.destroy();
        });
        visuals.clear();
    }
    return {
        label: label,
        get groupCount() {
            var groupCount = 0;
            visuals.forEach(function (_a) {
                var visual = _a.visual;
                if (visual.renderObject)
                    groupCount += visual.groupCount;
            });
            return groupCount;
        },
        get props() { return _props; },
        get params() { return _params; },
        get state() { return _state; },
        get theme() { return _theme; },
        renderObjects: renderObjects,
        updated: updated,
        createOrUpdate: createOrUpdate,
        setState: setState,
        setTheme: setTheme,
        getLoci: getLoci,
        mark: mark,
        destroy: destroy
    };
}
//# sourceMappingURL=units-representation.js.map

/***/ }),

/***/ "./lib/mol-repr/structure/units-visual.js":
/*!************************************************!*\
  !*** ./lib/mol-repr/structure/units-visual.js ***!
  \************************************************/
/*! exports provided: UnitsVisual, UnitsMeshParams, UnitsMeshVisual, UnitsSpheresParams, UnitsSpheresVisual, UnitsCylindersParams, UnitsCylindersVisual, UnitsPointsParams, UnitsPointsVisual, UnitsLinesParams, UnitsLinesVisual, UnitsTextParams, UnitsTextVisual, UnitsDirectVolumeParams, UnitsDirectVolumeVisual, UnitsTextureMeshParams, UnitsTextureMeshVisual */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "UnitsVisual", function() { return UnitsVisual; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "UnitsMeshParams", function() { return UnitsMeshParams; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "UnitsMeshVisual", function() { return UnitsMeshVisual; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "UnitsSpheresParams", function() { return UnitsSpheresParams; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "UnitsSpheresVisual", function() { return UnitsSpheresVisual; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "UnitsCylindersParams", function() { return UnitsCylindersParams; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "UnitsCylindersVisual", function() { return UnitsCylindersVisual; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "UnitsPointsParams", function() { return UnitsPointsParams; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "UnitsPointsVisual", function() { return UnitsPointsVisual; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "UnitsLinesParams", function() { return UnitsLinesParams; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "UnitsLinesVisual", function() { return UnitsLinesVisual; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "UnitsTextParams", function() { return UnitsTextParams; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "UnitsTextVisual", function() { return UnitsTextVisual; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "UnitsDirectVolumeParams", function() { return UnitsDirectVolumeParams; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "UnitsDirectVolumeVisual", function() { return UnitsDirectVolumeVisual; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "UnitsTextureMeshParams", function() { return UnitsTextureMeshParams; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "UnitsTextureMeshVisual", function() { return UnitsTextureMeshVisual; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _mol_model_structure__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../mol-model/structure */ "./lib/mol-model/structure.js");
/* harmony import */ var _visual__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../visual */ "./lib/mol-repr/visual.js");
/* harmony import */ var _mol_geo_geometry_geometry__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../mol-geo/geometry/geometry */ "./lib/mol-geo/geometry/geometry.js");
/* harmony import */ var _mol_theme_theme__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../mol-theme/theme */ "./lib/mol-theme/theme.js");
/* harmony import */ var _visual_util_common__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./visual/util/common */ "./lib/mol-repr/structure/visual/util/common.js");
/* harmony import */ var _mol_gl_render_object__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../../mol-gl/render-object */ "./lib/mol-gl/render-object.js");
/* harmony import */ var _mol_model_loci__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../../mol-model/loci */ "./lib/mol-model/loci.js");
/* harmony import */ var _mol_data_int__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ../../mol-data/int */ "./lib/mol-data/int.js");
/* harmony import */ var _util__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ../util */ "./lib/mol-repr/util.js");
/* harmony import */ var _mol_theme_color__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ../../mol-theme/color */ "./lib/mol-theme/color.js");
/* harmony import */ var _mol_geo_geometry_marker_data__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ../../mol-geo/geometry/marker-data */ "./lib/mol-geo/geometry/marker-data.js");
/* harmony import */ var _mol_util__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! ../../mol-util */ "./lib/mol-util/index.js");
/* harmony import */ var _mol_geo_geometry_size_data__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! ../../mol-geo/geometry/size-data */ "./lib/mol-geo/geometry/size-data.js");
/* harmony import */ var _mol_geo_geometry_color_data__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! ../../mol-geo/geometry/color-data */ "./lib/mol-geo/geometry/color-data.js");
/* harmony import */ var _mol_geo_geometry_mesh_mesh__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! ../../mol-geo/geometry/mesh/mesh */ "./lib/mol-geo/geometry/mesh/mesh.js");
/* harmony import */ var _mol_theme_size__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(/*! ../../mol-theme/size */ "./lib/mol-theme/size.js");
/* harmony import */ var _mol_geo_geometry_spheres_spheres__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(/*! ../../mol-geo/geometry/spheres/spheres */ "./lib/mol-geo/geometry/spheres/spheres.js");
/* harmony import */ var _mol_geo_geometry_cylinders_cylinders__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(/*! ../../mol-geo/geometry/cylinders/cylinders */ "./lib/mol-geo/geometry/cylinders/cylinders.js");
/* harmony import */ var _mol_geo_geometry_points_points__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(/*! ../../mol-geo/geometry/points/points */ "./lib/mol-geo/geometry/points/points.js");
/* harmony import */ var _mol_geo_geometry_lines_lines__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(/*! ../../mol-geo/geometry/lines/lines */ "./lib/mol-geo/geometry/lines/lines.js");
/* harmony import */ var _mol_geo_geometry_text_text__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(/*! ../../mol-geo/geometry/text/text */ "./lib/mol-geo/geometry/text/text.js");
/* harmony import */ var _mol_geo_geometry_direct_volume_direct_volume__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(/*! ../../mol-geo/geometry/direct-volume/direct-volume */ "./lib/mol-geo/geometry/direct-volume/direct-volume.js");
/* harmony import */ var _mol_geo_geometry_texture_mesh_texture_mesh__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(/*! ../../mol-geo/geometry/texture-mesh/texture-mesh */ "./lib/mol-geo/geometry/texture-mesh/texture-mesh.js");
/* harmony import */ var _params__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(/*! ./params */ "./lib/mol-repr/structure/params.js");
/**
 * Copyright (c) 2018-2020 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */

























function createUnitsRenderObject(group, geometry, locationIt, theme, props, materialId) {
    var _a = _mol_geo_geometry_geometry__WEBPACK_IMPORTED_MODULE_3__["Geometry"].getUtils(geometry), createValues = _a.createValues, createRenderableState = _a.createRenderableState;
    var transform = Object(_visual_util_common__WEBPACK_IMPORTED_MODULE_5__["createUnitsTransform"])(group);
    var values = createValues(geometry, transform, locationIt, theme, props);
    var state = createRenderableState(props);
    return Object(_mol_gl_render_object__WEBPACK_IMPORTED_MODULE_6__["createRenderObject"])(geometry.kind, values, state, materialId);
}
function UnitsVisual(builder, materialId) {
    var defaultProps = builder.defaultProps, createGeometry = builder.createGeometry, createLocationIterator = builder.createLocationIterator, getLoci = builder.getLoci, eachLocation = builder.eachLocation, setUpdateState = builder.setUpdateState, mustRecreate = builder.mustRecreate, dispose = builder.dispose;
    var _a = builder.geometryUtils, createEmptyGeometry = _a.createEmpty, updateValues = _a.updateValues, updateBoundingSphere = _a.updateBoundingSphere, updateRenderableState = _a.updateRenderableState, createPositionIterator = _a.createPositionIterator;
    var updateState = _util__WEBPACK_IMPORTED_MODULE_9__["VisualUpdateState"].create();
    var renderObject;
    var newProps = Object.assign({}, defaultProps);
    var newTheme = _mol_theme_theme__WEBPACK_IMPORTED_MODULE_4__["Theme"].createEmpty();
    var newStructureGroup;
    var currentProps;
    var currentTheme;
    var currentStructureGroup;
    var geometry;
    var locationIt;
    var positionIt;
    function prepareUpdate(theme, props, structureGroup) {
        if (!structureGroup && !currentStructureGroup) {
            throw new Error('missing structureGroup');
        }
        newProps = props;
        newTheme = theme;
        newStructureGroup = structureGroup;
        _util__WEBPACK_IMPORTED_MODULE_9__["VisualUpdateState"].reset(updateState);
        if (!renderObject || !currentStructureGroup) {
            // console.log('create new');
            updateState.createNew = true;
            updateState.createGeometry = true;
            return;
        }
        setUpdateState(updateState, newProps, currentProps, newTheme, currentTheme, newStructureGroup, currentStructureGroup);
        if (!_mol_model_structure__WEBPACK_IMPORTED_MODULE_1__["Structure"].areHierarchiesEqual(currentStructureGroup.structure, newStructureGroup.structure)) {
            // console.log('new hierarchy');
            updateState.updateTransform = true;
            updateState.updateColor = true;
            updateState.updateSize = true;
        }
        if (!_mol_theme_color__WEBPACK_IMPORTED_MODULE_10__["ColorTheme"].areEqual(newTheme.color, currentTheme.color)) {
            // console.log('new colorTheme');
            updateState.updateColor = true;
        }
        if (!Object(_mol_util__WEBPACK_IMPORTED_MODULE_12__["deepEqual"])(newProps.unitKinds, currentProps.unitKinds)) {
            // console.log('new unitKinds');
            updateState.createGeometry = true;
        }
        if (newStructureGroup.group.transformHash !== currentStructureGroup.group.transformHash) {
            // console.log('new transformHash');
            if (newStructureGroup.group.units.length !== currentStructureGroup.group.units.length || updateState.updateColor) {
                updateState.updateTransform = true;
            }
            else {
                updateState.updateMatrix = true;
            }
        }
        // check if the operator or conformation of unit has changed
        var newUnit = newStructureGroup.group.units[0];
        var currentUnit = currentStructureGroup.group.units[0];
        if (!_mol_model_structure__WEBPACK_IMPORTED_MODULE_1__["Unit"].areOperatorsEqual(newUnit, currentUnit)) {
            // console.log('new operators');
            updateState.updateTransform = true;
        }
        if (!_mol_model_structure__WEBPACK_IMPORTED_MODULE_1__["Unit"].areConformationsEqual(newUnit, currentUnit)) {
            // console.log('new conformation');
            updateState.createGeometry = true;
        }
        if (updateState.updateTransform) {
            updateState.updateMatrix = true;
        }
        if (updateState.updateSize && !('uSize' in renderObject.values)) {
            updateState.createGeometry = true;
        }
        if (updateState.createGeometry || updateState.updateTransform) {
            if (currentStructureGroup.structure.hashCode !== newStructureGroup.structure.hashCode) {
                // console.log('new hashCode');
                updateState.updateColor = true;
                updateState.updateSize = true;
            }
            if (newTheme.color.granularity.startsWith('vertex')) {
                updateState.updateColor = true;
            }
        }
    }
    function update(newGeometry) {
        if (updateState.createNew) {
            locationIt = createLocationIterator(newStructureGroup);
            if (newGeometry) {
                renderObject = createUnitsRenderObject(newStructureGroup.group, newGeometry, locationIt, newTheme, newProps, materialId);
                positionIt = createPositionIterator(newGeometry, renderObject.values);
            }
            else {
                throw new Error('expected geometry to be given');
            }
        }
        else {
            if (!renderObject) {
                throw new Error('expected renderObject to be available');
            }
            if (updateState.updateTransform) {
                // console.log('update transform');
                locationIt = createLocationIterator(newStructureGroup);
                var instanceCount = locationIt.instanceCount, groupCount = locationIt.groupCount;
                Object(_mol_geo_geometry_marker_data__WEBPACK_IMPORTED_MODULE_11__["createMarkers"])(instanceCount * groupCount, renderObject.values);
            }
            if (updateState.updateMatrix) {
                // console.log('update matrix');
                Object(_visual_util_common__WEBPACK_IMPORTED_MODULE_5__["createUnitsTransform"])(newStructureGroup.group, renderObject.values);
            }
            if (updateState.createGeometry) {
                // console.log('update geometry');
                if (newGeometry) {
                    _mol_util__WEBPACK_IMPORTED_MODULE_12__["ValueCell"].updateIfChanged(renderObject.values.drawCount, _mol_geo_geometry_geometry__WEBPACK_IMPORTED_MODULE_3__["Geometry"].getDrawCount(newGeometry));
                    _mol_util__WEBPACK_IMPORTED_MODULE_12__["ValueCell"].updateIfChanged(renderObject.values.uVertexCount, _mol_geo_geometry_geometry__WEBPACK_IMPORTED_MODULE_3__["Geometry"].getVertexCount(newGeometry));
                }
                else {
                    throw new Error('expected geometry to be given');
                }
            }
            if (updateState.updateTransform || updateState.createGeometry) {
                updateBoundingSphere(renderObject.values, newGeometry || geometry);
                positionIt = createPositionIterator(newGeometry || geometry, renderObject.values);
            }
            if (updateState.updateSize) {
                // not all geometries have size data, so check here
                if ('uSize' in renderObject.values) {
                    // console.log('update size');
                    Object(_mol_geo_geometry_size_data__WEBPACK_IMPORTED_MODULE_13__["createSizes"])(locationIt, newTheme.size, renderObject.values);
                }
            }
            if (updateState.updateColor) {
                // console.log('update color');
                Object(_mol_geo_geometry_color_data__WEBPACK_IMPORTED_MODULE_14__["createColors"])(locationIt, positionIt, newTheme.color, renderObject.values);
            }
            updateValues(renderObject.values, newProps);
            updateRenderableState(renderObject.state, newProps);
        }
        currentProps = newProps;
        currentTheme = newTheme;
        currentStructureGroup = newStructureGroup;
        if (newGeometry)
            geometry = newGeometry;
    }
    function _createGeometry(ctx, unit, structure, theme, props, geometry) {
        return Object(_visual_util_common__WEBPACK_IMPORTED_MODULE_5__["includesUnitKind"])(props.unitKinds, unit)
            ? createGeometry(ctx, unit, structure, theme, props, geometry)
            : createEmptyGeometry(geometry);
    }
    function lociIsSuperset(loci) {
        if (Object(_mol_model_loci__WEBPACK_IMPORTED_MODULE_7__["isEveryLoci"])(loci))
            return true;
        if (_mol_model_structure__WEBPACK_IMPORTED_MODULE_1__["Structure"].isLoci(loci) && _mol_model_structure__WEBPACK_IMPORTED_MODULE_1__["Structure"].areRootsEquivalent(loci.structure, currentStructureGroup.structure))
            return true;
        if (_mol_model_structure__WEBPACK_IMPORTED_MODULE_1__["StructureElement"].Loci.is(loci) && _mol_model_structure__WEBPACK_IMPORTED_MODULE_1__["Structure"].areRootsEquivalent(loci.structure, currentStructureGroup.structure)) {
            if (_mol_model_structure__WEBPACK_IMPORTED_MODULE_1__["StructureElement"].Loci.isWholeStructure(loci))
                return true;
        }
        return false;
    }
    function lociApply(loci, apply, isMarking) {
        if (lociIsSuperset(loci)) {
            return apply(_mol_data_int__WEBPACK_IMPORTED_MODULE_8__["Interval"].ofBounds(0, locationIt.groupCount * locationIt.instanceCount));
        }
        else {
            return eachLocation(loci, currentStructureGroup, apply, isMarking);
        }
    }
    return {
        get groupCount() { return locationIt ? locationIt.count : 0; },
        get renderObject() { return locationIt && locationIt.count ? renderObject : undefined; },
        createOrUpdate: function (ctx, theme, props, structureGroup) {
            prepareUpdate(theme, props, structureGroup || currentStructureGroup);
            if (updateState.createGeometry) {
                var newGeometry = _createGeometry(ctx, newStructureGroup.group.units[0], newStructureGroup.structure, newTheme, newProps, geometry);
                return newGeometry instanceof Promise ? newGeometry.then(update) : update(newGeometry);
            }
            else {
                update();
            }
        },
        getLoci: function (pickingId) {
            return renderObject ? getLoci(pickingId, currentStructureGroup, renderObject.id) : _mol_model_loci__WEBPACK_IMPORTED_MODULE_7__["EmptyLoci"];
        },
        mark: function (loci, action) {
            return _visual__WEBPACK_IMPORTED_MODULE_2__["Visual"].mark(renderObject, loci, action, lociApply);
        },
        setVisibility: function (visible) {
            _visual__WEBPACK_IMPORTED_MODULE_2__["Visual"].setVisibility(renderObject, visible);
        },
        setAlphaFactor: function (alphaFactor) {
            _visual__WEBPACK_IMPORTED_MODULE_2__["Visual"].setAlphaFactor(renderObject, alphaFactor);
        },
        setPickable: function (pickable) {
            _visual__WEBPACK_IMPORTED_MODULE_2__["Visual"].setPickable(renderObject, pickable);
        },
        setColorOnly: function (colorOnly) {
            _visual__WEBPACK_IMPORTED_MODULE_2__["Visual"].setColorOnly(renderObject, colorOnly);
        },
        setTransform: function (matrix, instanceMatrices) {
            _visual__WEBPACK_IMPORTED_MODULE_2__["Visual"].setTransform(renderObject, matrix, instanceMatrices);
        },
        setOverpaint: function (overpaint) {
            _visual__WEBPACK_IMPORTED_MODULE_2__["Visual"].setOverpaint(renderObject, overpaint, lociApply, true);
        },
        setTransparency: function (transparency) {
            _visual__WEBPACK_IMPORTED_MODULE_2__["Visual"].setTransparency(renderObject, transparency, lociApply, true);
        },
        setClipping: function (clipping) {
            _visual__WEBPACK_IMPORTED_MODULE_2__["Visual"].setClipping(renderObject, clipping, lociApply, true);
        },
        destroy: function () {
            dispose === null || dispose === void 0 ? void 0 : dispose(geometry);
            if (renderObject) {
                renderObject.state.disposed = true;
                renderObject = undefined;
            }
        },
        mustRecreate: mustRecreate
    };
}
// mesh
var UnitsMeshParams = Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, _params__WEBPACK_IMPORTED_MODULE_24__["StructureMeshParams"]), _params__WEBPACK_IMPORTED_MODULE_24__["StructureParams"]);
function UnitsMeshVisual(builder, materialId) {
    return UnitsVisual(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, builder), { setUpdateState: function (state, newProps, currentProps, newTheme, currentTheme, newStructureGroup, currentStructureGroup) {
            builder.setUpdateState(state, newProps, currentProps, newTheme, currentTheme, newStructureGroup, currentStructureGroup);
            if (!_mol_theme_size__WEBPACK_IMPORTED_MODULE_16__["SizeTheme"].areEqual(newTheme.size, currentTheme.size))
                state.createGeometry = true;
        }, geometryUtils: _mol_geo_geometry_mesh_mesh__WEBPACK_IMPORTED_MODULE_15__["Mesh"].Utils }), materialId);
}
// spheres
var UnitsSpheresParams = Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, _params__WEBPACK_IMPORTED_MODULE_24__["StructureSpheresParams"]), _params__WEBPACK_IMPORTED_MODULE_24__["StructureParams"]);
function UnitsSpheresVisual(builder, materialId) {
    return UnitsVisual(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, builder), { setUpdateState: function (state, newProps, currentProps, newTheme, currentTheme, newStructureGroup, currentStructureGroup) {
            builder.setUpdateState(state, newProps, currentProps, newTheme, currentTheme, newStructureGroup, currentStructureGroup);
            if (!_mol_theme_size__WEBPACK_IMPORTED_MODULE_16__["SizeTheme"].areEqual(newTheme.size, currentTheme.size))
                state.updateSize = true;
        }, geometryUtils: _mol_geo_geometry_spheres_spheres__WEBPACK_IMPORTED_MODULE_17__["Spheres"].Utils }), materialId);
}
// cylinders
var UnitsCylindersParams = Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, _params__WEBPACK_IMPORTED_MODULE_24__["StructureCylindersParams"]), _params__WEBPACK_IMPORTED_MODULE_24__["StructureParams"]);
function UnitsCylindersVisual(builder, materialId) {
    return UnitsVisual(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, builder), { setUpdateState: function (state, newProps, currentProps, newTheme, currentTheme, newStructureGroup, currentStructureGroup) {
            builder.setUpdateState(state, newProps, currentProps, newTheme, currentTheme, newStructureGroup, currentStructureGroup);
            if (!_mol_theme_size__WEBPACK_IMPORTED_MODULE_16__["SizeTheme"].areEqual(newTheme.size, currentTheme.size))
                state.updateSize = true;
        }, geometryUtils: _mol_geo_geometry_cylinders_cylinders__WEBPACK_IMPORTED_MODULE_18__["Cylinders"].Utils }), materialId);
}
// points
var UnitsPointsParams = Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, _params__WEBPACK_IMPORTED_MODULE_24__["StructurePointsParams"]), _params__WEBPACK_IMPORTED_MODULE_24__["StructureParams"]);
function UnitsPointsVisual(builder, materialId) {
    return UnitsVisual(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, builder), { setUpdateState: function (state, newProps, currentProps, newTheme, currentTheme, newStructureGroup, currentStructureGroup) {
            builder.setUpdateState(state, newProps, currentProps, newTheme, currentTheme, newStructureGroup, currentStructureGroup);
            if (!_mol_theme_size__WEBPACK_IMPORTED_MODULE_16__["SizeTheme"].areEqual(newTheme.size, currentTheme.size))
                state.updateSize = true;
        }, geometryUtils: _mol_geo_geometry_points_points__WEBPACK_IMPORTED_MODULE_19__["Points"].Utils }), materialId);
}
// lines
var UnitsLinesParams = Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, _params__WEBPACK_IMPORTED_MODULE_24__["StructureLinesParams"]), _params__WEBPACK_IMPORTED_MODULE_24__["StructureParams"]);
function UnitsLinesVisual(builder, materialId) {
    return UnitsVisual(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, builder), { setUpdateState: function (state, newProps, currentProps, newTheme, currentTheme, newStructureGroup, currentStructureGroup) {
            builder.setUpdateState(state, newProps, currentProps, newTheme, currentTheme, newStructureGroup, currentStructureGroup);
            if (!_mol_theme_size__WEBPACK_IMPORTED_MODULE_16__["SizeTheme"].areEqual(newTheme.size, currentTheme.size))
                state.updateSize = true;
        }, geometryUtils: _mol_geo_geometry_lines_lines__WEBPACK_IMPORTED_MODULE_20__["Lines"].Utils }), materialId);
}
// text
var UnitsTextParams = Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, _params__WEBPACK_IMPORTED_MODULE_24__["StructureTextParams"]), _params__WEBPACK_IMPORTED_MODULE_24__["StructureParams"]);
function UnitsTextVisual(builder, materialId) {
    return UnitsVisual(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, builder), { setUpdateState: function (state, newProps, currentProps, newTheme, currentTheme, newStructureGroup, currentStructureGroup) {
            builder.setUpdateState(state, newProps, currentProps, newTheme, currentTheme, newStructureGroup, currentStructureGroup);
            if (!_mol_theme_size__WEBPACK_IMPORTED_MODULE_16__["SizeTheme"].areEqual(newTheme.size, currentTheme.size))
                state.updateSize = true;
            if (newProps.background !== currentProps.background)
                state.createGeometry = true;
            if (newProps.backgroundMargin !== currentProps.backgroundMargin)
                state.createGeometry = true;
            if (newProps.tether !== currentProps.tether)
                state.createGeometry = true;
            if (newProps.tetherLength !== currentProps.tetherLength)
                state.createGeometry = true;
            if (newProps.tetherBaseWidth !== currentProps.tetherBaseWidth)
                state.createGeometry = true;
            if (newProps.attachment !== currentProps.attachment)
                state.createGeometry = true;
            if (newProps.fontFamily !== currentProps.fontFamily)
                state.createGeometry = true;
            if (newProps.fontQuality !== currentProps.fontQuality)
                state.createGeometry = true;
            if (newProps.fontStyle !== currentProps.fontStyle)
                state.createGeometry = true;
            if (newProps.fontVariant !== currentProps.fontVariant)
                state.createGeometry = true;
            if (newProps.fontWeight !== currentProps.fontWeight)
                state.createGeometry = true;
        }, geometryUtils: _mol_geo_geometry_text_text__WEBPACK_IMPORTED_MODULE_21__["Text"].Utils }), materialId);
}
// direct-volume
var UnitsDirectVolumeParams = Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, _params__WEBPACK_IMPORTED_MODULE_24__["StructureDirectVolumeParams"]), _params__WEBPACK_IMPORTED_MODULE_24__["StructureParams"]);
function UnitsDirectVolumeVisual(builder, materialId) {
    return UnitsVisual(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, builder), { setUpdateState: function (state, newProps, currentProps, newTheme, currentTheme, newStructureGroup, currentStructureGroup) {
            builder.setUpdateState(state, newProps, currentProps, newTheme, currentTheme, newStructureGroup, currentStructureGroup);
            if (!_mol_theme_size__WEBPACK_IMPORTED_MODULE_16__["SizeTheme"].areEqual(newTheme.size, currentTheme.size))
                state.createGeometry = true;
        }, geometryUtils: _mol_geo_geometry_direct_volume_direct_volume__WEBPACK_IMPORTED_MODULE_22__["DirectVolume"].Utils }), materialId);
}
// texture-mesh
var UnitsTextureMeshParams = Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, _params__WEBPACK_IMPORTED_MODULE_24__["StructureTextureMeshParams"]), _params__WEBPACK_IMPORTED_MODULE_24__["StructureParams"]);
function UnitsTextureMeshVisual(builder, materialId) {
    return UnitsVisual(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, builder), { setUpdateState: function (state, newProps, currentProps, newTheme, currentTheme, newStructureGroup, currentStructureGroup) {
            builder.setUpdateState(state, newProps, currentProps, newTheme, currentTheme, newStructureGroup, currentStructureGroup);
            if (!_mol_theme_size__WEBPACK_IMPORTED_MODULE_16__["SizeTheme"].areEqual(newTheme.size, currentTheme.size))
                state.createGeometry = true;
        }, geometryUtils: _mol_geo_geometry_texture_mesh_texture_mesh__WEBPACK_IMPORTED_MODULE_23__["TextureMesh"].Utils }), materialId);
}
//# sourceMappingURL=units-visual.js.map

/***/ }),

/***/ "./lib/mol-repr/structure/visual/bond-inter-unit-cylinder.js":
/*!*******************************************************************!*\
  !*** ./lib/mol-repr/structure/visual/bond-inter-unit-cylinder.js ***!
  \*******************************************************************/
/*! exports provided: InterUnitBondCylinderParams, InterUnitBondCylinderVisual, InterUnitBondCylinderImpostorVisual, InterUnitBondCylinderMeshVisual */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "InterUnitBondCylinderParams", function() { return InterUnitBondCylinderParams; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "InterUnitBondCylinderVisual", function() { return InterUnitBondCylinderVisual; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "InterUnitBondCylinderImpostorVisual", function() { return InterUnitBondCylinderImpostorVisual; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "InterUnitBondCylinderMeshVisual", function() { return InterUnitBondCylinderMeshVisual; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../../mol-util/param-definition */ "./lib/mol-util/param-definition.js");
/* harmony import */ var _mol_model_structure__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../../mol-model/structure */ "./lib/mol-model/structure.js");
/* harmony import */ var _mol_geo_geometry_mesh_mesh__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../../mol-geo/geometry/mesh/mesh */ "./lib/mol-geo/geometry/mesh/mesh.js");
/* harmony import */ var _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../../mol-math/linear-algebra */ "./lib/mol-math/linear-algebra.js");
/* harmony import */ var _mol_util__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../../mol-util */ "./lib/mol-util/index.js");
/* harmony import */ var _util_link__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ./util/link */ "./lib/mol-repr/structure/visual/util/link.js");
/* harmony import */ var _complex_visual__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../complex-visual */ "./lib/mol-repr/structure/complex-visual.js");
/* harmony import */ var _mol_model_structure_model_types__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ../../../mol-model/structure/model/types */ "./lib/mol-model/structure/model/types.js");
/* harmony import */ var _util_bond__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ./util/bond */ "./lib/mol-repr/structure/visual/util/bond.js");
/* harmony import */ var _mol_math_geometry__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ../../../mol-math/geometry */ "./lib/mol-math/geometry.js");
/* harmony import */ var _mol_geo_geometry_cylinders_cylinders__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ../../../mol-geo/geometry/cylinders/cylinders */ "./lib/mol-geo/geometry/cylinders/cylinders.js");
/**
 * Copyright (c) 2018-2020 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */












var tmpRefPosBondIt = new _mol_model_structure__WEBPACK_IMPORTED_MODULE_2__["Bond"].ElementBondIterator();
function setRefPosition(pos, structure, unit, index) {
    tmpRefPosBondIt.setElement(structure, unit, index);
    while (tmpRefPosBondIt.hasNext) {
        var bA = tmpRefPosBondIt.move();
        bA.otherUnit.conformation.position(bA.otherUnit.elements[bA.otherIndex], pos);
        return pos;
    }
    return null;
}
var tmpRef = Object(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_4__["Vec3"])();
function getInterUnitBondCylinderBuilderProps(structure, theme, props) {
    var locE = _mol_model_structure__WEBPACK_IMPORTED_MODULE_2__["StructureElement"].Location.create(structure);
    var locB = _mol_model_structure__WEBPACK_IMPORTED_MODULE_2__["Bond"].Location(structure, undefined, undefined, structure, undefined, undefined);
    var bonds = structure.interUnitBonds;
    var edgeCount = bonds.edgeCount, edges = bonds.edges;
    var sizeFactor = props.sizeFactor, sizeAspectRatio = props.sizeAspectRatio;
    var delta = Object(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_4__["Vec3"])();
    var radius = function (edgeIndex) {
        var b = edges[edgeIndex];
        locB.aUnit = structure.unitMap.get(b.unitA);
        locB.aIndex = b.indexA;
        locB.bUnit = structure.unitMap.get(b.unitB);
        locB.bIndex = b.indexB;
        return theme.size.size(locB) * sizeFactor;
    };
    var radiusA = function (edgeIndex) {
        var b = edges[edgeIndex];
        locE.unit = structure.unitMap.get(b.unitA);
        locE.element = locE.unit.elements[b.indexA];
        return theme.size.size(locE) * sizeFactor;
    };
    var radiusB = function (edgeIndex) {
        var b = edges[edgeIndex];
        locE.unit = structure.unitMap.get(b.unitB);
        locE.element = locE.unit.elements[b.indexB];
        return theme.size.size(locE) * sizeFactor;
    };
    return {
        linkCount: edgeCount,
        referencePosition: function (edgeIndex) {
            var b = edges[edgeIndex];
            var unitA, unitB;
            var indexA, indexB;
            if (b.unitA < b.unitB) {
                unitA = structure.unitMap.get(b.unitA);
                unitB = structure.unitMap.get(b.unitB);
                indexA = b.indexA;
                indexB = b.indexB;
            }
            else if (b.unitA > b.unitB) {
                unitA = structure.unitMap.get(b.unitB);
                unitB = structure.unitMap.get(b.unitA);
                indexA = b.indexB;
                indexB = b.indexA;
            }
            else {
                throw new Error('same units in createInterUnitBondCylinderMesh');
            }
            return setRefPosition(tmpRef, structure, unitA, indexA) || setRefPosition(tmpRef, structure, unitB, indexB);
        },
        position: function (posA, posB, edgeIndex) {
            var b = edges[edgeIndex];
            var uA = structure.unitMap.get(b.unitA);
            var uB = structure.unitMap.get(b.unitB);
            var rA = radiusA(edgeIndex), rB = radiusB(edgeIndex);
            var r = Math.min(rA, rB) * sizeAspectRatio;
            var oA = Math.sqrt(Math.max(0, rA * rA - r * r)) - 0.05;
            var oB = Math.sqrt(Math.max(0, rB * rB - r * r)) - 0.05;
            uA.conformation.position(uA.elements[b.indexA], posA);
            uB.conformation.position(uB.elements[b.indexB], posB);
            if (oA <= 0.01 && oB <= 0.01)
                return;
            _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_4__["Vec3"].normalize(delta, _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_4__["Vec3"].sub(delta, posB, posA));
            _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_4__["Vec3"].scaleAndAdd(posA, posA, delta, oA);
            _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_4__["Vec3"].scaleAndAdd(posB, posB, delta, -oB);
        },
        style: function (edgeIndex) {
            var o = edges[edgeIndex].props.order;
            var f = _mol_util__WEBPACK_IMPORTED_MODULE_5__["BitFlags"].create(edges[edgeIndex].props.flag);
            if (_mol_model_structure_model_types__WEBPACK_IMPORTED_MODULE_8__["BondType"].is(f, 2 /* MetallicCoordination */) || _mol_model_structure_model_types__WEBPACK_IMPORTED_MODULE_8__["BondType"].is(f, 4 /* HydrogenBond */)) {
                // show metall coordinations and hydrogen bonds with dashed cylinders
                return 1 /* Dashed */;
            }
            else if (o === 2) {
                return 2 /* Double */;
            }
            else if (o === 3) {
                return 3 /* Triple */;
            }
            else {
                return 0 /* Solid */;
            }
        },
        radius: function (edgeIndex) {
            return radius(edgeIndex) * sizeAspectRatio;
        },
        ignore: Object(_util_bond__WEBPACK_IMPORTED_MODULE_9__["makeInterBondIgnoreTest"])(structure, props)
    };
}
function createInterUnitBondCylinderImpostors(ctx, structure, theme, props, cylinders) {
    if (!structure.interUnitBonds.edgeCount)
        return _mol_geo_geometry_cylinders_cylinders__WEBPACK_IMPORTED_MODULE_11__["Cylinders"].createEmpty(cylinders);
    var builderProps = getInterUnitBondCylinderBuilderProps(structure, theme, props);
    var m = Object(_util_link__WEBPACK_IMPORTED_MODULE_6__["createLinkCylinderImpostors"])(ctx, builderProps, props, cylinders);
    var sphere = _mol_math_geometry__WEBPACK_IMPORTED_MODULE_10__["Sphere3D"].expand(Object(_mol_math_geometry__WEBPACK_IMPORTED_MODULE_10__["Sphere3D"])(), structure.boundary.sphere, 1 * props.sizeFactor);
    m.setBoundingSphere(sphere);
    return m;
}
function createInterUnitBondCylinderMesh(ctx, structure, theme, props, mesh) {
    if (!structure.interUnitBonds.edgeCount)
        return _mol_geo_geometry_mesh_mesh__WEBPACK_IMPORTED_MODULE_3__["Mesh"].createEmpty(mesh);
    var builderProps = getInterUnitBondCylinderBuilderProps(structure, theme, props);
    var m = Object(_util_link__WEBPACK_IMPORTED_MODULE_6__["createLinkCylinderMesh"])(ctx, builderProps, props, mesh);
    var sphere = _mol_math_geometry__WEBPACK_IMPORTED_MODULE_10__["Sphere3D"].expand(Object(_mol_math_geometry__WEBPACK_IMPORTED_MODULE_10__["Sphere3D"])(), structure.boundary.sphere, 1 * props.sizeFactor);
    m.setBoundingSphere(sphere);
    return m;
}
var InterUnitBondCylinderParams = Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, _complex_visual__WEBPACK_IMPORTED_MODULE_7__["ComplexMeshParams"]), _complex_visual__WEBPACK_IMPORTED_MODULE_7__["ComplexCylindersParams"]), _util_bond__WEBPACK_IMPORTED_MODULE_9__["BondCylinderParams"]), { sizeFactor: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_1__["ParamDefinition"].Numeric(0.3, { min: 0, max: 10, step: 0.01 }), sizeAspectRatio: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_1__["ParamDefinition"].Numeric(2 / 3, { min: 0, max: 3, step: 0.01 }), useImpostor: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_1__["ParamDefinition"].Boolean(true) });
function InterUnitBondCylinderVisual(materialId, props, webgl) {
    return (props === null || props === void 0 ? void 0 : props.useImpostor) && webgl && webgl.extensions.fragDepth
        ? InterUnitBondCylinderImpostorVisual(materialId)
        : InterUnitBondCylinderMeshVisual(materialId);
}
function InterUnitBondCylinderImpostorVisual(materialId) {
    return Object(_complex_visual__WEBPACK_IMPORTED_MODULE_7__["ComplexCylindersVisual"])({
        defaultProps: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_1__["ParamDefinition"].getDefaultValues(InterUnitBondCylinderParams),
        createGeometry: createInterUnitBondCylinderImpostors,
        createLocationIterator: _util_bond__WEBPACK_IMPORTED_MODULE_9__["BondIterator"].fromStructure,
        getLoci: _util_bond__WEBPACK_IMPORTED_MODULE_9__["getInterBondLoci"],
        eachLocation: _util_bond__WEBPACK_IMPORTED_MODULE_9__["eachInterBond"],
        setUpdateState: function (state, newProps, currentProps) {
            state.createGeometry = (newProps.linkScale !== currentProps.linkScale ||
                newProps.linkSpacing !== currentProps.linkSpacing ||
                newProps.ignoreHydrogens !== currentProps.ignoreHydrogens ||
                newProps.linkCap !== currentProps.linkCap ||
                newProps.dashCount !== currentProps.dashCount ||
                newProps.dashScale !== currentProps.dashScale ||
                newProps.dashCap !== currentProps.dashCap ||
                !Object(_mol_util__WEBPACK_IMPORTED_MODULE_5__["arrayEqual"])(newProps.includeTypes, currentProps.includeTypes) ||
                !Object(_mol_util__WEBPACK_IMPORTED_MODULE_5__["arrayEqual"])(newProps.excludeTypes, currentProps.excludeTypes));
        },
        mustRecreate: function (props, webgl) {
            return !props.useImpostor || !webgl;
        }
    }, materialId);
}
function InterUnitBondCylinderMeshVisual(materialId) {
    return Object(_complex_visual__WEBPACK_IMPORTED_MODULE_7__["ComplexMeshVisual"])({
        defaultProps: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_1__["ParamDefinition"].getDefaultValues(InterUnitBondCylinderParams),
        createGeometry: createInterUnitBondCylinderMesh,
        createLocationIterator: _util_bond__WEBPACK_IMPORTED_MODULE_9__["BondIterator"].fromStructure,
        getLoci: _util_bond__WEBPACK_IMPORTED_MODULE_9__["getInterBondLoci"],
        eachLocation: _util_bond__WEBPACK_IMPORTED_MODULE_9__["eachInterBond"],
        setUpdateState: function (state, newProps, currentProps) {
            state.createGeometry = (newProps.sizeFactor !== currentProps.sizeFactor ||
                newProps.sizeAspectRatio !== currentProps.sizeAspectRatio ||
                newProps.radialSegments !== currentProps.radialSegments ||
                newProps.linkScale !== currentProps.linkScale ||
                newProps.linkSpacing !== currentProps.linkSpacing ||
                newProps.ignoreHydrogens !== currentProps.ignoreHydrogens ||
                newProps.linkCap !== currentProps.linkCap ||
                newProps.dashCount !== currentProps.dashCount ||
                newProps.dashScale !== currentProps.dashScale ||
                newProps.dashCap !== currentProps.dashCap ||
                !Object(_mol_util__WEBPACK_IMPORTED_MODULE_5__["arrayEqual"])(newProps.includeTypes, currentProps.includeTypes) ||
                !Object(_mol_util__WEBPACK_IMPORTED_MODULE_5__["arrayEqual"])(newProps.excludeTypes, currentProps.excludeTypes));
        },
        mustRecreate: function (props, webgl) {
            return props.useImpostor && !!webgl;
        }
    }, materialId);
}
//# sourceMappingURL=bond-inter-unit-cylinder.js.map

/***/ }),

/***/ "./lib/mol-repr/structure/visual/bond-inter-unit-line.js":
/*!***************************************************************!*\
  !*** ./lib/mol-repr/structure/visual/bond-inter-unit-line.js ***!
  \***************************************************************/
/*! exports provided: InterUnitBondLineParams, InterUnitBondLineVisual */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "InterUnitBondLineParams", function() { return InterUnitBondLineParams; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "InterUnitBondLineVisual", function() { return InterUnitBondLineVisual; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../../mol-util/param-definition */ "./lib/mol-util/param-definition.js");
/* harmony import */ var _mol_model_structure__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../../mol-model/structure */ "./lib/mol-model/structure.js");
/* harmony import */ var _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../../mol-math/linear-algebra */ "./lib/mol-math/linear-algebra.js");
/* harmony import */ var _mol_util__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../../mol-util */ "./lib/mol-util/index.js");
/* harmony import */ var _util_link__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./util/link */ "./lib/mol-repr/structure/visual/util/link.js");
/* harmony import */ var _complex_visual__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../complex-visual */ "./lib/mol-repr/structure/complex-visual.js");
/* harmony import */ var _mol_model_structure_model_types__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../../../mol-model/structure/model/types */ "./lib/mol-model/structure/model/types.js");
/* harmony import */ var _util_bond__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ./util/bond */ "./lib/mol-repr/structure/visual/util/bond.js");
/* harmony import */ var _mol_geo_geometry_lines_lines__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ../../../mol-geo/geometry/lines/lines */ "./lib/mol-geo/geometry/lines/lines.js");
/* harmony import */ var _mol_math_geometry__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ../../../mol-math/geometry */ "./lib/mol-math/geometry.js");
/**
 * Copyright (c) 2020 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */











var tmpRefPosBondIt = new _mol_model_structure__WEBPACK_IMPORTED_MODULE_2__["Bond"].ElementBondIterator();
function setRefPosition(pos, structure, unit, index) {
    tmpRefPosBondIt.setElement(structure, unit, index);
    while (tmpRefPosBondIt.hasNext) {
        var bA = tmpRefPosBondIt.move();
        bA.otherUnit.conformation.position(bA.otherUnit.elements[bA.otherIndex], pos);
        return pos;
    }
    return null;
}
var tmpRef = Object(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_3__["Vec3"])();
var tmpLoc = _mol_model_structure__WEBPACK_IMPORTED_MODULE_2__["StructureElement"].Location.create(void 0);
function createInterUnitBondLines(ctx, structure, theme, props, lines) {
    var bonds = structure.interUnitBonds;
    var edgeCount = bonds.edgeCount, edges = bonds.edges;
    var sizeFactor = props.sizeFactor;
    if (!edgeCount)
        return _mol_geo_geometry_lines_lines__WEBPACK_IMPORTED_MODULE_9__["Lines"].createEmpty(lines);
    var builderProps = {
        linkCount: edgeCount,
        referencePosition: function (edgeIndex) {
            var b = edges[edgeIndex];
            var unitA, unitB;
            var indexA, indexB;
            if (b.unitA < b.unitB) {
                unitA = structure.unitMap.get(b.unitA);
                unitB = structure.unitMap.get(b.unitB);
                indexA = b.indexA;
                indexB = b.indexB;
            }
            else if (b.unitA > b.unitB) {
                unitA = structure.unitMap.get(b.unitB);
                unitB = structure.unitMap.get(b.unitA);
                indexA = b.indexB;
                indexB = b.indexA;
            }
            else {
                throw new Error('same units in createInterUnitBondLines');
            }
            return setRefPosition(tmpRef, structure, unitA, indexA) || setRefPosition(tmpRef, structure, unitB, indexB);
        },
        position: function (posA, posB, edgeIndex) {
            var b = edges[edgeIndex];
            var uA = structure.unitMap.get(b.unitA);
            var uB = structure.unitMap.get(b.unitB);
            uA.conformation.position(uA.elements[b.indexA], posA);
            uB.conformation.position(uB.elements[b.indexB], posB);
        },
        style: function (edgeIndex) {
            var o = edges[edgeIndex].props.order;
            var f = _mol_util__WEBPACK_IMPORTED_MODULE_4__["BitFlags"].create(edges[edgeIndex].props.flag);
            if (_mol_model_structure_model_types__WEBPACK_IMPORTED_MODULE_7__["BondType"].is(f, 2 /* MetallicCoordination */) || _mol_model_structure_model_types__WEBPACK_IMPORTED_MODULE_7__["BondType"].is(f, 4 /* HydrogenBond */)) {
                // show metall coordinations and hydrogen bonds with dashed cylinders
                return 1 /* Dashed */;
            }
            else if (o === 2) {
                return 2 /* Double */;
            }
            else if (o === 3) {
                return 3 /* Triple */;
            }
            else {
                return 0 /* Solid */;
            }
        },
        radius: function (edgeIndex) {
            var b = edges[edgeIndex];
            tmpLoc.structure = structure;
            tmpLoc.unit = structure.unitMap.get(b.unitA);
            tmpLoc.element = tmpLoc.unit.elements[b.indexA];
            var sizeA = theme.size.size(tmpLoc);
            tmpLoc.unit = structure.unitMap.get(b.unitB);
            tmpLoc.element = tmpLoc.unit.elements[b.indexB];
            var sizeB = theme.size.size(tmpLoc);
            return Math.min(sizeA, sizeB) * sizeFactor;
        },
        ignore: Object(_util_bond__WEBPACK_IMPORTED_MODULE_8__["makeInterBondIgnoreTest"])(structure, props)
    };
    var l = Object(_util_link__WEBPACK_IMPORTED_MODULE_5__["createLinkLines"])(ctx, builderProps, props, lines);
    var sphere = _mol_math_geometry__WEBPACK_IMPORTED_MODULE_10__["Sphere3D"].expand(Object(_mol_math_geometry__WEBPACK_IMPORTED_MODULE_10__["Sphere3D"])(), structure.boundary.sphere, 1 * sizeFactor);
    l.setBoundingSphere(sphere);
    return l;
}
var InterUnitBondLineParams = Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, _complex_visual__WEBPACK_IMPORTED_MODULE_6__["ComplexLinesParams"]), _util_bond__WEBPACK_IMPORTED_MODULE_8__["BondLineParams"]);
function InterUnitBondLineVisual(materialId) {
    return Object(_complex_visual__WEBPACK_IMPORTED_MODULE_6__["ComplexLinesVisual"])({
        defaultProps: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_1__["ParamDefinition"].getDefaultValues(InterUnitBondLineParams),
        createGeometry: createInterUnitBondLines,
        createLocationIterator: _util_bond__WEBPACK_IMPORTED_MODULE_8__["BondIterator"].fromStructure,
        getLoci: _util_bond__WEBPACK_IMPORTED_MODULE_8__["getInterBondLoci"],
        eachLocation: _util_bond__WEBPACK_IMPORTED_MODULE_8__["eachInterBond"],
        setUpdateState: function (state, newProps, currentProps) {
            state.createGeometry = (newProps.sizeFactor !== currentProps.sizeFactor ||
                newProps.linkScale !== currentProps.linkScale ||
                newProps.linkSpacing !== currentProps.linkSpacing ||
                newProps.dashCount !== currentProps.dashCount ||
                newProps.ignoreHydrogens !== currentProps.ignoreHydrogens ||
                !Object(_mol_util__WEBPACK_IMPORTED_MODULE_4__["arrayEqual"])(newProps.includeTypes, currentProps.includeTypes) ||
                !Object(_mol_util__WEBPACK_IMPORTED_MODULE_4__["arrayEqual"])(newProps.excludeTypes, currentProps.excludeTypes));
        }
    }, materialId);
}
//# sourceMappingURL=bond-inter-unit-line.js.map

/***/ }),

/***/ "./lib/mol-repr/structure/visual/bond-intra-unit-cylinder.js":
/*!*******************************************************************!*\
  !*** ./lib/mol-repr/structure/visual/bond-intra-unit-cylinder.js ***!
  \*******************************************************************/
/*! exports provided: IntraUnitBondCylinderParams, IntraUnitBondCylinderVisual, IntraUnitBondCylinderImpostorVisual, IntraUnitBondCylinderMeshVisual */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "IntraUnitBondCylinderParams", function() { return IntraUnitBondCylinderParams; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "IntraUnitBondCylinderVisual", function() { return IntraUnitBondCylinderVisual; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "IntraUnitBondCylinderImpostorVisual", function() { return IntraUnitBondCylinderImpostorVisual; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "IntraUnitBondCylinderMeshVisual", function() { return IntraUnitBondCylinderMeshVisual; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../../mol-util/param-definition */ "./lib/mol-util/param-definition.js");
/* harmony import */ var _mol_model_structure__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../../mol-model/structure */ "./lib/mol-model/structure.js");
/* harmony import */ var _mol_geo_geometry_mesh_mesh__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../../mol-geo/geometry/mesh/mesh */ "./lib/mol-geo/geometry/mesh/mesh.js");
/* harmony import */ var _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../../mol-math/linear-algebra */ "./lib/mol-math/linear-algebra.js");
/* harmony import */ var _mol_util__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../../mol-util */ "./lib/mol-util/index.js");
/* harmony import */ var _util_link__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ./util/link */ "./lib/mol-repr/structure/visual/util/link.js");
/* harmony import */ var _units_visual__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../units-visual */ "./lib/mol-repr/structure/units-visual.js");
/* harmony import */ var _mol_model_structure_model_types__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ../../../mol-model/structure/model/types */ "./lib/mol-model/structure/model/types.js");
/* harmony import */ var _util_bond__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ./util/bond */ "./lib/mol-repr/structure/visual/util/bond.js");
/* harmony import */ var _mol_math_geometry__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ../../../mol-math/geometry */ "./lib/mol-math/geometry.js");
/* harmony import */ var _mol_math_graph__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ../../../mol-math/graph */ "./lib/mol-math/graph.js");
/* harmony import */ var _mol_geo_geometry_cylinders_cylinders__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! ../../../mol-geo/geometry/cylinders/cylinders */ "./lib/mol-geo/geometry/cylinders/cylinders.js");
/**
 * Copyright (c) 2018-2020 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 * @author David Sehnal <david.sehnal@gmail.com>
 */













// avoiding namespace lookup improved performance in Chrome (Aug 2020)
var isBondType = _mol_model_structure_model_types__WEBPACK_IMPORTED_MODULE_8__["BondType"].is;
function getIntraUnitBondCylinderBuilderProps(unit, structure, theme, props) {
    var locE = _mol_model_structure__WEBPACK_IMPORTED_MODULE_2__["StructureElement"].Location.create(structure, unit);
    var locB = _mol_model_structure__WEBPACK_IMPORTED_MODULE_2__["Bond"].Location(structure, unit, undefined, structure, unit, undefined);
    var elements = unit.elements;
    var bonds = unit.bonds;
    var edgeCount = bonds.edgeCount, a = bonds.a, b = bonds.b, edgeProps = bonds.edgeProps, offset = bonds.offset;
    var _order = edgeProps.order, _flags = edgeProps.flags;
    var sizeFactor = props.sizeFactor, sizeAspectRatio = props.sizeAspectRatio;
    var vRef = Object(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_4__["Vec3"])(), delta = Object(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_4__["Vec3"])();
    var pos = unit.conformation.invariantPosition;
    var radius = function (edgeIndex) {
        locB.aIndex = a[edgeIndex];
        locB.bIndex = b[edgeIndex];
        return theme.size.size(locB) * sizeFactor;
    };
    var radiusA = function (edgeIndex) {
        locE.element = elements[a[edgeIndex]];
        return theme.size.size(locE) * sizeFactor;
    };
    var radiusB = function (edgeIndex) {
        locE.element = elements[b[edgeIndex]];
        return theme.size.size(locE) * sizeFactor;
    };
    return {
        linkCount: edgeCount * 2,
        referencePosition: function (edgeIndex) {
            var _a, _b;
            var aI = a[edgeIndex], bI = b[edgeIndex];
            if (aI > bI)
                _a = [bI, aI], aI = _a[0], bI = _a[1];
            if (offset[aI + 1] - offset[aI] === 1)
                _b = [bI, aI], aI = _b[0], bI = _b[1];
            // TODO prefer reference atoms within rings
            for (var i = offset[aI], il = offset[aI + 1]; i < il; ++i) {
                var _bI = b[i];
                if (_bI !== bI && _bI !== aI)
                    return pos(elements[_bI], vRef);
            }
            for (var i = offset[bI], il = offset[bI + 1]; i < il; ++i) {
                var _aI = a[i];
                if (_aI !== aI && _aI !== bI)
                    return pos(elements[_aI], vRef);
            }
            return null;
        },
        position: function (posA, posB, edgeIndex) {
            var rA = radiusA(edgeIndex), rB = radiusB(edgeIndex);
            var r = Math.min(rA, rB) * sizeAspectRatio;
            var oA = Math.sqrt(Math.max(0, rA * rA - r * r)) - 0.05;
            var oB = Math.sqrt(Math.max(0, rB * rB - r * r)) - 0.05;
            pos(elements[a[edgeIndex]], posA);
            pos(elements[b[edgeIndex]], posB);
            if (oA <= 0.01 && oB <= 0.01)
                return;
            _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_4__["Vec3"].normalize(delta, _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_4__["Vec3"].sub(delta, posB, posA));
            _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_4__["Vec3"].scaleAndAdd(posA, posA, delta, oA);
            _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_4__["Vec3"].scaleAndAdd(posB, posB, delta, -oB);
        },
        style: function (edgeIndex) {
            var o = _order[edgeIndex];
            var f = _flags[edgeIndex];
            if (isBondType(f, 2 /* MetallicCoordination */) || isBondType(f, 4 /* HydrogenBond */)) {
                // show metall coordinations and hydrogen bonds with dashed cylinders
                return 1 /* Dashed */;
            }
            else if (o === 2) {
                return 2 /* Double */;
            }
            else if (o === 3) {
                return 3 /* Triple */;
            }
            else {
                return 0 /* Solid */;
            }
        },
        radius: function (edgeIndex) {
            return radius(edgeIndex) * sizeAspectRatio;
        },
        ignore: Object(_util_bond__WEBPACK_IMPORTED_MODULE_9__["makeIntraBondIgnoreTest"])(unit, props)
    };
}
function createIntraUnitBondCylinderImpostors(ctx, unit, structure, theme, props, cylinders) {
    if (!_mol_model_structure__WEBPACK_IMPORTED_MODULE_2__["Unit"].isAtomic(unit))
        return _mol_geo_geometry_cylinders_cylinders__WEBPACK_IMPORTED_MODULE_12__["Cylinders"].createEmpty(cylinders);
    if (!unit.bonds.edgeCount)
        return _mol_geo_geometry_cylinders_cylinders__WEBPACK_IMPORTED_MODULE_12__["Cylinders"].createEmpty(cylinders);
    var builderProps = getIntraUnitBondCylinderBuilderProps(unit, structure, theme, props);
    var c = Object(_util_link__WEBPACK_IMPORTED_MODULE_6__["createLinkCylinderImpostors"])(ctx, builderProps, props, cylinders);
    var sphere = _mol_math_geometry__WEBPACK_IMPORTED_MODULE_10__["Sphere3D"].expand(Object(_mol_math_geometry__WEBPACK_IMPORTED_MODULE_10__["Sphere3D"])(), unit.boundary.sphere, 1 * props.sizeFactor);
    c.setBoundingSphere(sphere);
    return c;
}
function createIntraUnitBondCylinderMesh(ctx, unit, structure, theme, props, mesh) {
    if (!_mol_model_structure__WEBPACK_IMPORTED_MODULE_2__["Unit"].isAtomic(unit))
        return _mol_geo_geometry_mesh_mesh__WEBPACK_IMPORTED_MODULE_3__["Mesh"].createEmpty(mesh);
    if (!unit.bonds.edgeCount)
        return _mol_geo_geometry_mesh_mesh__WEBPACK_IMPORTED_MODULE_3__["Mesh"].createEmpty(mesh);
    var builderProps = getIntraUnitBondCylinderBuilderProps(unit, structure, theme, props);
    var m = Object(_util_link__WEBPACK_IMPORTED_MODULE_6__["createLinkCylinderMesh"])(ctx, builderProps, props, mesh);
    var sphere = _mol_math_geometry__WEBPACK_IMPORTED_MODULE_10__["Sphere3D"].expand(Object(_mol_math_geometry__WEBPACK_IMPORTED_MODULE_10__["Sphere3D"])(), unit.boundary.sphere, 1 * props.sizeFactor);
    m.setBoundingSphere(sphere);
    return m;
}
var IntraUnitBondCylinderParams = Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, _units_visual__WEBPACK_IMPORTED_MODULE_7__["UnitsMeshParams"]), _units_visual__WEBPACK_IMPORTED_MODULE_7__["UnitsCylindersParams"]), _util_bond__WEBPACK_IMPORTED_MODULE_9__["BondCylinderParams"]), { sizeFactor: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_1__["ParamDefinition"].Numeric(0.3, { min: 0, max: 10, step: 0.01 }), sizeAspectRatio: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_1__["ParamDefinition"].Numeric(2 / 3, { min: 0, max: 3, step: 0.01 }), useImpostor: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_1__["ParamDefinition"].Boolean(true) });
function IntraUnitBondCylinderVisual(materialId, props, webgl) {
    return (props === null || props === void 0 ? void 0 : props.useImpostor) && webgl && webgl.extensions.fragDepth
        ? IntraUnitBondCylinderImpostorVisual(materialId)
        : IntraUnitBondCylinderMeshVisual(materialId);
}
function IntraUnitBondCylinderImpostorVisual(materialId) {
    return Object(_units_visual__WEBPACK_IMPORTED_MODULE_7__["UnitsCylindersVisual"])({
        defaultProps: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_1__["ParamDefinition"].getDefaultValues(IntraUnitBondCylinderParams),
        createGeometry: createIntraUnitBondCylinderImpostors,
        createLocationIterator: _util_bond__WEBPACK_IMPORTED_MODULE_9__["BondIterator"].fromGroup,
        getLoci: _util_bond__WEBPACK_IMPORTED_MODULE_9__["getIntraBondLoci"],
        eachLocation: _util_bond__WEBPACK_IMPORTED_MODULE_9__["eachIntraBond"],
        setUpdateState: function (state, newProps, currentProps, newTheme, currentTheme, newStructureGroup, currentStructureGroup) {
            state.createGeometry = (newProps.linkScale !== currentProps.linkScale ||
                newProps.linkSpacing !== currentProps.linkSpacing ||
                newProps.ignoreHydrogens !== currentProps.ignoreHydrogens ||
                newProps.linkCap !== currentProps.linkCap ||
                newProps.dashCount !== currentProps.dashCount ||
                newProps.dashScale !== currentProps.dashScale ||
                newProps.dashCap !== currentProps.dashCap ||
                !Object(_mol_util__WEBPACK_IMPORTED_MODULE_5__["arrayEqual"])(newProps.includeTypes, currentProps.includeTypes) ||
                !Object(_mol_util__WEBPACK_IMPORTED_MODULE_5__["arrayEqual"])(newProps.excludeTypes, currentProps.excludeTypes));
            var newUnit = newStructureGroup.group.units[0];
            var currentUnit = currentStructureGroup.group.units[0];
            if (_mol_model_structure__WEBPACK_IMPORTED_MODULE_2__["Unit"].isAtomic(newUnit) && _mol_model_structure__WEBPACK_IMPORTED_MODULE_2__["Unit"].isAtomic(currentUnit)) {
                if (!_mol_math_graph__WEBPACK_IMPORTED_MODULE_11__["IntAdjacencyGraph"].areEqual(newUnit.bonds, currentUnit.bonds)) {
                    state.createGeometry = true;
                    state.updateTransform = true;
                    state.updateColor = true;
                    state.updateSize = true;
                }
            }
        },
        mustRecreate: function (props, webgl) {
            return !props.useImpostor || !webgl;
        }
    }, materialId);
}
function IntraUnitBondCylinderMeshVisual(materialId) {
    return Object(_units_visual__WEBPACK_IMPORTED_MODULE_7__["UnitsMeshVisual"])({
        defaultProps: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_1__["ParamDefinition"].getDefaultValues(IntraUnitBondCylinderParams),
        createGeometry: createIntraUnitBondCylinderMesh,
        createLocationIterator: _util_bond__WEBPACK_IMPORTED_MODULE_9__["BondIterator"].fromGroup,
        getLoci: _util_bond__WEBPACK_IMPORTED_MODULE_9__["getIntraBondLoci"],
        eachLocation: _util_bond__WEBPACK_IMPORTED_MODULE_9__["eachIntraBond"],
        setUpdateState: function (state, newProps, currentProps, newTheme, currentTheme, newStructureGroup, currentStructureGroup) {
            state.createGeometry = (newProps.sizeFactor !== currentProps.sizeFactor ||
                newProps.sizeAspectRatio !== currentProps.sizeAspectRatio ||
                newProps.radialSegments !== currentProps.radialSegments ||
                newProps.linkScale !== currentProps.linkScale ||
                newProps.linkSpacing !== currentProps.linkSpacing ||
                newProps.ignoreHydrogens !== currentProps.ignoreHydrogens ||
                newProps.linkCap !== currentProps.linkCap ||
                newProps.dashCount !== currentProps.dashCount ||
                newProps.dashScale !== currentProps.dashScale ||
                newProps.dashCap !== currentProps.dashCap ||
                !Object(_mol_util__WEBPACK_IMPORTED_MODULE_5__["arrayEqual"])(newProps.includeTypes, currentProps.includeTypes) ||
                !Object(_mol_util__WEBPACK_IMPORTED_MODULE_5__["arrayEqual"])(newProps.excludeTypes, currentProps.excludeTypes));
            var newUnit = newStructureGroup.group.units[0];
            var currentUnit = currentStructureGroup.group.units[0];
            if (_mol_model_structure__WEBPACK_IMPORTED_MODULE_2__["Unit"].isAtomic(newUnit) && _mol_model_structure__WEBPACK_IMPORTED_MODULE_2__["Unit"].isAtomic(currentUnit)) {
                if (!_mol_math_graph__WEBPACK_IMPORTED_MODULE_11__["IntAdjacencyGraph"].areEqual(newUnit.bonds, currentUnit.bonds)) {
                    state.createGeometry = true;
                    state.updateTransform = true;
                    state.updateColor = true;
                    state.updateSize = true;
                }
            }
        },
        mustRecreate: function (props, webgl) {
            return props.useImpostor && !!webgl;
        }
    }, materialId);
}
//# sourceMappingURL=bond-intra-unit-cylinder.js.map

/***/ }),

/***/ "./lib/mol-repr/structure/visual/bond-intra-unit-line.js":
/*!***************************************************************!*\
  !*** ./lib/mol-repr/structure/visual/bond-intra-unit-line.js ***!
  \***************************************************************/
/*! exports provided: IntraUnitBondLineParams, IntraUnitBondLineVisual */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "IntraUnitBondLineParams", function() { return IntraUnitBondLineParams; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "IntraUnitBondLineVisual", function() { return IntraUnitBondLineVisual; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../../mol-util/param-definition */ "./lib/mol-util/param-definition.js");
/* harmony import */ var _mol_model_structure__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../../mol-model/structure */ "./lib/mol-model/structure.js");
/* harmony import */ var _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../../mol-math/linear-algebra */ "./lib/mol-math/linear-algebra.js");
/* harmony import */ var _mol_util__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../../mol-util */ "./lib/mol-util/index.js");
/* harmony import */ var _util_link__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./util/link */ "./lib/mol-repr/structure/visual/util/link.js");
/* harmony import */ var _units_visual__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../units-visual */ "./lib/mol-repr/structure/units-visual.js");
/* harmony import */ var _mol_model_structure_model_types__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../../../mol-model/structure/model/types */ "./lib/mol-model/structure/model/types.js");
/* harmony import */ var _util_bond__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ./util/bond */ "./lib/mol-repr/structure/visual/util/bond.js");
/* harmony import */ var _mol_math_geometry__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ../../../mol-math/geometry */ "./lib/mol-math/geometry.js");
/* harmony import */ var _mol_geo_geometry_lines_lines__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ../../../mol-geo/geometry/lines/lines */ "./lib/mol-geo/geometry/lines/lines.js");
/* harmony import */ var _mol_math_graph__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ../../../mol-math/graph */ "./lib/mol-math/graph.js");
/**
 * Copyright (c) 2020 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */












// avoiding namespace lookup improved performance in Chrome (Aug 2020)
var isBondType = _mol_model_structure_model_types__WEBPACK_IMPORTED_MODULE_7__["BondType"].is;
function createIntraUnitBondLines(ctx, unit, structure, theme, props, lines) {
    if (!_mol_model_structure__WEBPACK_IMPORTED_MODULE_2__["Unit"].isAtomic(unit))
        return _mol_geo_geometry_lines_lines__WEBPACK_IMPORTED_MODULE_10__["Lines"].createEmpty(lines);
    var location = _mol_model_structure__WEBPACK_IMPORTED_MODULE_2__["StructureElement"].Location.create(structure, unit);
    var elements = unit.elements;
    var bonds = unit.bonds;
    var edgeCount = bonds.edgeCount, a = bonds.a, b = bonds.b, edgeProps = bonds.edgeProps, offset = bonds.offset;
    var _order = edgeProps.order, _flags = edgeProps.flags;
    var sizeFactor = props.sizeFactor;
    if (!edgeCount)
        return _mol_geo_geometry_lines_lines__WEBPACK_IMPORTED_MODULE_10__["Lines"].createEmpty(lines);
    var vRef = Object(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_3__["Vec3"])();
    var pos = unit.conformation.invariantPosition;
    var builderProps = {
        linkCount: edgeCount * 2,
        referencePosition: function (edgeIndex) {
            var _a, _b;
            var aI = a[edgeIndex], bI = b[edgeIndex];
            if (aI > bI)
                _a = [bI, aI], aI = _a[0], bI = _a[1];
            if (offset[aI + 1] - offset[aI] === 1)
                _b = [bI, aI], aI = _b[0], bI = _b[1];
            // TODO prefer reference atoms within rings
            for (var i = offset[aI], il = offset[aI + 1]; i < il; ++i) {
                var _bI = b[i];
                if (_bI !== bI && _bI !== aI)
                    return pos(elements[_bI], vRef);
            }
            for (var i = offset[bI], il = offset[bI + 1]; i < il; ++i) {
                var _aI = a[i];
                if (_aI !== aI && _aI !== bI)
                    return pos(elements[_aI], vRef);
            }
            return null;
        },
        position: function (posA, posB, edgeIndex) {
            pos(elements[a[edgeIndex]], posA);
            pos(elements[b[edgeIndex]], posB);
        },
        style: function (edgeIndex) {
            var o = _order[edgeIndex];
            var f = _flags[edgeIndex];
            if (isBondType(f, 2 /* MetallicCoordination */) || isBondType(f, 4 /* HydrogenBond */)) {
                // show metall coordinations and hydrogen bonds with dashed cylinders
                return 1 /* Dashed */;
            }
            else if (o === 2) {
                return 2 /* Double */;
            }
            else if (o === 3) {
                return 3 /* Triple */;
            }
            else {
                return 0 /* Solid */;
            }
        },
        radius: function (edgeIndex) {
            location.element = elements[a[edgeIndex]];
            var sizeA = theme.size.size(location);
            location.element = elements[b[edgeIndex]];
            var sizeB = theme.size.size(location);
            return Math.min(sizeA, sizeB) * sizeFactor;
        },
        ignore: Object(_util_bond__WEBPACK_IMPORTED_MODULE_8__["makeIntraBondIgnoreTest"])(unit, props)
    };
    var l = Object(_util_link__WEBPACK_IMPORTED_MODULE_5__["createLinkLines"])(ctx, builderProps, props, lines);
    var sphere = _mol_math_geometry__WEBPACK_IMPORTED_MODULE_9__["Sphere3D"].expand(Object(_mol_math_geometry__WEBPACK_IMPORTED_MODULE_9__["Sphere3D"])(), unit.boundary.sphere, 1 * sizeFactor);
    l.setBoundingSphere(sphere);
    return l;
}
var IntraUnitBondLineParams = Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, _units_visual__WEBPACK_IMPORTED_MODULE_6__["UnitsLinesParams"]), _util_bond__WEBPACK_IMPORTED_MODULE_8__["BondLineParams"]);
function IntraUnitBondLineVisual(materialId) {
    return Object(_units_visual__WEBPACK_IMPORTED_MODULE_6__["UnitsLinesVisual"])({
        defaultProps: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_1__["ParamDefinition"].getDefaultValues(IntraUnitBondLineParams),
        createGeometry: createIntraUnitBondLines,
        createLocationIterator: _util_bond__WEBPACK_IMPORTED_MODULE_8__["BondIterator"].fromGroup,
        getLoci: _util_bond__WEBPACK_IMPORTED_MODULE_8__["getIntraBondLoci"],
        eachLocation: _util_bond__WEBPACK_IMPORTED_MODULE_8__["eachIntraBond"],
        setUpdateState: function (state, newProps, currentProps, newTheme, currentTheme, newStructureGroup, currentStructureGroup) {
            state.createGeometry = (newProps.sizeFactor !== currentProps.sizeFactor ||
                newProps.linkScale !== currentProps.linkScale ||
                newProps.linkSpacing !== currentProps.linkSpacing ||
                newProps.dashCount !== currentProps.dashCount ||
                newProps.ignoreHydrogens !== currentProps.ignoreHydrogens ||
                !Object(_mol_util__WEBPACK_IMPORTED_MODULE_4__["arrayEqual"])(newProps.includeTypes, currentProps.includeTypes) ||
                !Object(_mol_util__WEBPACK_IMPORTED_MODULE_4__["arrayEqual"])(newProps.excludeTypes, currentProps.excludeTypes));
            var newUnit = newStructureGroup.group.units[0];
            var currentUnit = currentStructureGroup.group.units[0];
            if (_mol_model_structure__WEBPACK_IMPORTED_MODULE_2__["Unit"].isAtomic(newUnit) && _mol_model_structure__WEBPACK_IMPORTED_MODULE_2__["Unit"].isAtomic(currentUnit)) {
                if (!_mol_math_graph__WEBPACK_IMPORTED_MODULE_11__["IntAdjacencyGraph"].areEqual(newUnit.bonds, currentUnit.bonds)) {
                    state.createGeometry = true;
                    state.updateTransform = true;
                    state.updateColor = true;
                    state.updateSize = true;
                }
            }
        }
    }, materialId);
}
//# sourceMappingURL=bond-intra-unit-line.js.map

/***/ }),

/***/ "./lib/mol-repr/structure/visual/carbohydrate-link-cylinder.js":
/*!*********************************************************************!*\
  !*** ./lib/mol-repr/structure/visual/carbohydrate-link-cylinder.js ***!
  \*********************************************************************/
/*! exports provided: CarbohydrateLinkParams, CarbohydrateLinkVisual */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CarbohydrateLinkParams", function() { return CarbohydrateLinkParams; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CarbohydrateLinkVisual", function() { return CarbohydrateLinkVisual; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _mol_model_structure__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../../mol-model/structure */ "./lib/mol-model/structure.js");
/* harmony import */ var _mol_model_loci__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../../mol-model/loci */ "./lib/mol-model/loci.js");
/* harmony import */ var _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../../mol-math/linear-algebra */ "./lib/mol-math/linear-algebra.js");
/* harmony import */ var _util_link__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./util/link */ "./lib/mol-repr/structure/visual/util/link.js");
/* harmony import */ var _mol_data_int__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../../mol-data/int */ "./lib/mol-data/int.js");
/* harmony import */ var _complex_visual__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../complex-visual */ "./lib/mol-repr/structure/complex-visual.js");
/* harmony import */ var _units_visual__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../units-visual */ "./lib/mol-repr/structure/units-visual.js");
/* harmony import */ var _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ../../../mol-util/param-definition */ "./lib/mol-util/param-definition.js");
/* harmony import */ var _mol_geo_util_location_iterator__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ../../../mol-geo/util/location-iterator */ "./lib/mol-geo/util/location-iterator.js");
/* harmony import */ var _util_common__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ./util/common */ "./lib/mol-repr/structure/visual/util/common.js");
/**
 * Copyright (c) 2018-2020 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */











function createCarbohydrateLinkCylinderMesh(ctx, structure, theme, props, mesh) {
    var _a = structure.carbohydrates, links = _a.links, elements = _a.elements;
    var linkSizeFactor = props.linkSizeFactor;
    var location = _mol_model_structure__WEBPACK_IMPORTED_MODULE_1__["StructureElement"].Location.create(structure);
    var builderProps = {
        linkCount: links.length,
        position: function (posA, posB, edgeIndex) {
            var l = links[edgeIndex];
            _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_3__["Vec3"].copy(posA, elements[l.carbohydrateIndexA].geometry.center);
            _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_3__["Vec3"].copy(posB, elements[l.carbohydrateIndexB].geometry.center);
        },
        radius: function (edgeIndex) {
            var l = links[edgeIndex];
            var carbA = elements[l.carbohydrateIndexA];
            var ringA = carbA.unit.rings.all[carbA.ringIndex];
            location.unit = carbA.unit;
            location.element = carbA.unit.elements[ringA[0]];
            return theme.size.size(location) * linkSizeFactor;
        },
    };
    return Object(_util_link__WEBPACK_IMPORTED_MODULE_4__["createLinkCylinderMesh"])(ctx, builderProps, props, mesh);
}
var CarbohydrateLinkParams = Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, _units_visual__WEBPACK_IMPORTED_MODULE_7__["UnitsMeshParams"]), _util_link__WEBPACK_IMPORTED_MODULE_4__["LinkCylinderParams"]), { linkSizeFactor: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_8__["ParamDefinition"].Numeric(0.3, { min: 0, max: 3, step: 0.01 }) });
function CarbohydrateLinkVisual(materialId) {
    return Object(_complex_visual__WEBPACK_IMPORTED_MODULE_6__["ComplexMeshVisual"])({
        defaultProps: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_8__["ParamDefinition"].getDefaultValues(CarbohydrateLinkParams),
        createGeometry: createCarbohydrateLinkCylinderMesh,
        createLocationIterator: CarbohydrateLinkIterator,
        getLoci: getLinkLoci,
        eachLocation: eachCarbohydrateLink,
        setUpdateState: function (state, newProps, currentProps) {
            state.createGeometry = (newProps.linkSizeFactor !== currentProps.linkSizeFactor ||
                newProps.radialSegments !== currentProps.radialSegments ||
                newProps.linkCap !== currentProps.linkCap);
        }
    }, materialId);
}
function CarbohydrateLinkIterator(structure) {
    var _a = structure.carbohydrates, elements = _a.elements, links = _a.links;
    var groupCount = links.length;
    var instanceCount = 1;
    var location = _mol_model_structure__WEBPACK_IMPORTED_MODULE_1__["StructureElement"].Location.create(structure);
    var getLocation = function (groupIndex) {
        var link = links[groupIndex];
        var carbA = elements[link.carbohydrateIndexA];
        var ringA = carbA.unit.rings.all[carbA.ringIndex];
        location.unit = carbA.unit;
        location.element = carbA.unit.elements[ringA[0]];
        return location;
    };
    return Object(_mol_geo_util_location_iterator__WEBPACK_IMPORTED_MODULE_9__["LocationIterator"])(groupCount, instanceCount, 1, getLocation, true);
}
function getLinkLoci(pickingId, structure, id) {
    var objectId = pickingId.objectId, groupId = pickingId.groupId;
    if (id === objectId) {
        var _a = structure.carbohydrates, links = _a.links, elements = _a.elements;
        var l = links[groupId];
        var carbA = elements[l.carbohydrateIndexA];
        var carbB = elements[l.carbohydrateIndexB];
        return _mol_model_structure__WEBPACK_IMPORTED_MODULE_1__["StructureElement"].Loci.union(Object(_util_common__WEBPACK_IMPORTED_MODULE_10__["getAltResidueLociFromId"])(structure, carbA.unit, carbA.residueIndex, carbA.altId), Object(_util_common__WEBPACK_IMPORTED_MODULE_10__["getAltResidueLociFromId"])(structure, carbB.unit, carbB.residueIndex, carbB.altId));
    }
    return _mol_model_loci__WEBPACK_IMPORTED_MODULE_2__["EmptyLoci"];
}
function eachCarbohydrateLink(loci, structure, apply) {
    var changed = false;
    if (!_mol_model_structure__WEBPACK_IMPORTED_MODULE_1__["StructureElement"].Loci.is(loci))
        return false;
    if (!_mol_model_structure__WEBPACK_IMPORTED_MODULE_1__["Structure"].areEquivalent(loci.structure, structure))
        return false;
    var getLinkIndices = structure.carbohydrates.getLinkIndices;
    var _loop_1 = function (unit, indices) {
        if (!_mol_model_structure__WEBPACK_IMPORTED_MODULE_1__["Unit"].isAtomic(unit))
            return "continue";
        _mol_data_int__WEBPACK_IMPORTED_MODULE_5__["OrderedSet"].forEach(indices, function (v) {
            // TODO avoid duplicate calls to apply
            var linkIndices = getLinkIndices(unit, unit.elements[v]);
            for (var i = 0, il = linkIndices.length; i < il; ++i) {
                if (apply(_mol_data_int__WEBPACK_IMPORTED_MODULE_5__["Interval"].ofSingleton(linkIndices[i])))
                    changed = true;
            }
        });
    };
    for (var _i = 0, _a = loci.elements; _i < _a.length; _i++) {
        var _b = _a[_i], unit = _b.unit, indices = _b.indices;
        _loop_1(unit, indices);
    }
    return changed;
}
//# sourceMappingURL=carbohydrate-link-cylinder.js.map

/***/ }),

/***/ "./lib/mol-repr/structure/visual/carbohydrate-symbol-mesh.js":
/*!*******************************************************************!*\
  !*** ./lib/mol-repr/structure/visual/carbohydrate-symbol-mesh.js ***!
  \*******************************************************************/
/*! exports provided: CarbohydrateSymbolParams, CarbohydrateSymbolVisual */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CarbohydrateSymbolParams", function() { return CarbohydrateSymbolParams; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CarbohydrateSymbolVisual", function() { return CarbohydrateSymbolVisual; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../../mol-math/linear-algebra */ "./lib/mol-math/linear-algebra.js");
/* harmony import */ var _mol_geo_primitive_box__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../../mol-geo/primitive/box */ "./lib/mol-geo/primitive/box.js");
/* harmony import */ var _mol_geo_primitive_pyramid__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../../mol-geo/primitive/pyramid */ "./lib/mol-geo/primitive/pyramid.js");
/* harmony import */ var _mol_geo_primitive_star__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../../mol-geo/primitive/star */ "./lib/mol-geo/primitive/star.js");
/* harmony import */ var _mol_geo_primitive_octahedron__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../../mol-geo/primitive/octahedron */ "./lib/mol-geo/primitive/octahedron.js");
/* harmony import */ var _mol_geo_primitive_prism__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../../../mol-geo/primitive/prism */ "./lib/mol-geo/primitive/prism.js");
/* harmony import */ var _mol_model_structure__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../../../mol-model/structure */ "./lib/mol-model/structure.js");
/* harmony import */ var _mol_geo_geometry_mesh_mesh_builder__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ../../../mol-geo/geometry/mesh/mesh-builder */ "./lib/mol-geo/geometry/mesh/mesh-builder.js");
/* harmony import */ var _mol_model_structure_structure_carbohydrates_constants__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ../../../mol-model/structure/structure/carbohydrates/constants */ "./lib/mol-model/structure/structure/carbohydrates/constants.js");
/* harmony import */ var _mol_geo_geometry_mesh_builder_sphere__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ../../../mol-geo/geometry/mesh/builder/sphere */ "./lib/mol-geo/geometry/mesh/builder/sphere.js");
/* harmony import */ var _complex_visual__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ../complex-visual */ "./lib/mol-repr/structure/complex-visual.js");
/* harmony import */ var _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! ../../../mol-util/param-definition */ "./lib/mol-util/param-definition.js");
/* harmony import */ var _mol_geo_util_location_iterator__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! ../../../mol-geo/util/location-iterator */ "./lib/mol-geo/util/location-iterator.js");
/* harmony import */ var _mol_data_int__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! ../../../mol-data/int */ "./lib/mol-data/int.js");
/* harmony import */ var _mol_model_loci__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! ../../../mol-model/loci */ "./lib/mol-model/loci.js");
/* harmony import */ var _util_common__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(/*! ./util/common */ "./lib/mol-repr/structure/visual/util/common.js");
/* harmony import */ var _mol_geo_geometry_base__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(/*! ../../../mol-geo/geometry/base */ "./lib/mol-geo/geometry/base.js");
/**
 * Copyright (c) 2018-2020 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */


















var t = _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_1__["Mat4"].identity();
var sVec = _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_1__["Vec3"].zero();
var pd = _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_1__["Vec3"].zero();
var SideFactor = 2 * 0.806; // 0.806 == Math.cos(Math.PI / 4)
var box = Object(_mol_geo_primitive_box__WEBPACK_IMPORTED_MODULE_2__["Box"])();
var perforatedBox = Object(_mol_geo_primitive_box__WEBPACK_IMPORTED_MODULE_2__["PerforatedBox"])();
var octagonalPyramid = Object(_mol_geo_primitive_pyramid__WEBPACK_IMPORTED_MODULE_3__["OctagonalPyramid"])();
var perforatedOctagonalPyramid = Object(_mol_geo_primitive_pyramid__WEBPACK_IMPORTED_MODULE_3__["PerforatedOctagonalPyramid"])();
var star = Object(_mol_geo_primitive_star__WEBPACK_IMPORTED_MODULE_4__["Star"])({ outerRadius: 1, innerRadius: 0.5, thickness: 0.5, pointCount: 5 });
var octahedron = Object(_mol_geo_primitive_octahedron__WEBPACK_IMPORTED_MODULE_5__["Octahedron"])();
var perforatedOctahedron = Object(_mol_geo_primitive_octahedron__WEBPACK_IMPORTED_MODULE_5__["PerforatedOctahedron"])();
var diamondPrism = Object(_mol_geo_primitive_prism__WEBPACK_IMPORTED_MODULE_6__["DiamondPrism"])();
var pentagonalPrism = Object(_mol_geo_primitive_prism__WEBPACK_IMPORTED_MODULE_6__["PentagonalPrism"])();
var hexagonalPrism = Object(_mol_geo_primitive_prism__WEBPACK_IMPORTED_MODULE_6__["HexagonalPrism"])();
var shiftedHexagonalPrism = Object(_mol_geo_primitive_prism__WEBPACK_IMPORTED_MODULE_6__["ShiftedHexagonalPrism"])();
var heptagonalPrism = Object(_mol_geo_primitive_prism__WEBPACK_IMPORTED_MODULE_6__["HeptagonalPrism"])();
function createCarbohydrateSymbolMesh(ctx, structure, theme, props, mesh) {
    var builderState = _mol_geo_geometry_mesh_mesh_builder__WEBPACK_IMPORTED_MODULE_8__["MeshBuilder"].createState(256, 128, mesh);
    var detail = props.detail, sizeFactor = props.sizeFactor;
    var carbohydrates = structure.carbohydrates;
    var n = carbohydrates.elements.length;
    var l = _mol_model_structure__WEBPACK_IMPORTED_MODULE_7__["StructureElement"].Location.create(structure);
    for (var i = 0; i < n; ++i) {
        var c = carbohydrates.elements[i];
        var ring = c.unit.rings.all[c.ringIndex];
        var shapeType = Object(_mol_model_structure_structure_carbohydrates_constants__WEBPACK_IMPORTED_MODULE_9__["getSaccharideShape"])(c.component.type, ring.length);
        l.unit = c.unit;
        l.element = c.unit.elements[ring[0]];
        var size = theme.size.size(l);
        var radius = size * sizeFactor;
        var side = size * sizeFactor * SideFactor;
        var _a = c.geometry, center = _a.center, normal = _a.normal, direction = _a.direction;
        _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_1__["Vec3"].add(pd, center, direction);
        _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_1__["Mat4"].targetTo(t, center, pd, normal);
        _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_1__["Mat4"].setTranslation(t, center);
        builderState.currentGroup = i * 2;
        switch (shapeType) {
            case 0 /* FilledSphere */:
                Object(_mol_geo_geometry_mesh_builder_sphere__WEBPACK_IMPORTED_MODULE_10__["addSphere"])(builderState, center, radius, detail);
                break;
            case 1 /* FilledCube */:
                _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_1__["Mat4"].scaleUniformly(t, t, side);
                _mol_geo_geometry_mesh_mesh_builder__WEBPACK_IMPORTED_MODULE_8__["MeshBuilder"].addPrimitive(builderState, t, box);
                break;
            case 2 /* CrossedCube */:
                _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_1__["Mat4"].scaleUniformly(t, t, side);
                _mol_geo_geometry_mesh_mesh_builder__WEBPACK_IMPORTED_MODULE_8__["MeshBuilder"].addPrimitive(builderState, t, perforatedBox);
                _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_1__["Mat4"].mul(t, t, _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_1__["Mat4"].rotZ90X180);
                builderState.currentGroup += 1;
                _mol_geo_geometry_mesh_mesh_builder__WEBPACK_IMPORTED_MODULE_8__["MeshBuilder"].addPrimitive(builderState, t, perforatedBox);
                break;
            case 4 /* FilledCone */:
                _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_1__["Mat4"].scaleUniformly(t, t, side * 1.2);
                _mol_geo_geometry_mesh_mesh_builder__WEBPACK_IMPORTED_MODULE_8__["MeshBuilder"].addPrimitive(builderState, t, octagonalPyramid);
                break;
            case 5 /* DevidedCone */:
                _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_1__["Mat4"].scaleUniformly(t, t, side * 1.2);
                _mol_geo_geometry_mesh_mesh_builder__WEBPACK_IMPORTED_MODULE_8__["MeshBuilder"].addPrimitive(builderState, t, perforatedOctagonalPyramid);
                _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_1__["Mat4"].mul(t, t, _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_1__["Mat4"].rotZ90);
                builderState.currentGroup += 1;
                _mol_geo_geometry_mesh_mesh_builder__WEBPACK_IMPORTED_MODULE_8__["MeshBuilder"].addPrimitive(builderState, t, perforatedOctagonalPyramid);
                break;
            case 6 /* FlatBox */:
                _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_1__["Mat4"].mul(t, t, _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_1__["Mat4"].rotZY90);
                _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_1__["Mat4"].scale(t, t, _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_1__["Vec3"].set(sVec, side, side, side / 2));
                _mol_geo_geometry_mesh_mesh_builder__WEBPACK_IMPORTED_MODULE_8__["MeshBuilder"].addPrimitive(builderState, t, box);
                break;
            case 7 /* FilledStar */:
                _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_1__["Mat4"].scaleUniformly(t, t, side);
                _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_1__["Mat4"].mul(t, t, _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_1__["Mat4"].rotZY90);
                _mol_geo_geometry_mesh_mesh_builder__WEBPACK_IMPORTED_MODULE_8__["MeshBuilder"].addPrimitive(builderState, t, star);
                break;
            case 8 /* FilledDiamond */:
                _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_1__["Mat4"].mul(t, t, _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_1__["Mat4"].rotZY90);
                _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_1__["Mat4"].scale(t, t, _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_1__["Vec3"].set(sVec, side * 1.4, side * 1.4, side * 1.4));
                _mol_geo_geometry_mesh_mesh_builder__WEBPACK_IMPORTED_MODULE_8__["MeshBuilder"].addPrimitive(builderState, t, octahedron);
                break;
            case 3 /* DividedDiamond */:
                _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_1__["Mat4"].mul(t, t, _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_1__["Mat4"].rotZY90);
                _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_1__["Mat4"].scale(t, t, _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_1__["Vec3"].set(sVec, side * 1.4, side * 1.4, side * 1.4));
                _mol_geo_geometry_mesh_mesh_builder__WEBPACK_IMPORTED_MODULE_8__["MeshBuilder"].addPrimitive(builderState, t, perforatedOctahedron);
                _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_1__["Mat4"].mul(t, t, _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_1__["Mat4"].rotY90);
                builderState.currentGroup += 1;
                _mol_geo_geometry_mesh_mesh_builder__WEBPACK_IMPORTED_MODULE_8__["MeshBuilder"].addPrimitive(builderState, t, perforatedOctahedron);
                break;
            case 9 /* FlatDiamond */:
                _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_1__["Mat4"].mul(t, t, _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_1__["Mat4"].rotZY90);
                _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_1__["Mat4"].scale(t, t, _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_1__["Vec3"].set(sVec, side, side / 2, side / 2));
                _mol_geo_geometry_mesh_mesh_builder__WEBPACK_IMPORTED_MODULE_8__["MeshBuilder"].addPrimitive(builderState, t, diamondPrism);
                break;
            case 12 /* DiamondPrism */:
                _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_1__["Mat4"].mul(t, t, _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_1__["Mat4"].rotZY90);
                _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_1__["Mat4"].scale(t, t, _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_1__["Vec3"].set(sVec, side, side, side / 2));
                _mol_geo_geometry_mesh_mesh_builder__WEBPACK_IMPORTED_MODULE_8__["MeshBuilder"].addPrimitive(builderState, t, diamondPrism);
                break;
            case 13 /* PentagonalPrism */:
            case 11 /* Pentagon */:
                _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_1__["Mat4"].mul(t, t, _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_1__["Mat4"].rotZY90);
                _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_1__["Mat4"].scale(t, t, _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_1__["Vec3"].set(sVec, side, side, side / 2));
                _mol_geo_geometry_mesh_mesh_builder__WEBPACK_IMPORTED_MODULE_8__["MeshBuilder"].addPrimitive(builderState, t, pentagonalPrism);
                break;
            case 14 /* HexagonalPrism */:
                _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_1__["Mat4"].mul(t, t, _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_1__["Mat4"].rotZY90);
                _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_1__["Mat4"].scale(t, t, _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_1__["Vec3"].set(sVec, side, side, side / 2));
                _mol_geo_geometry_mesh_mesh_builder__WEBPACK_IMPORTED_MODULE_8__["MeshBuilder"].addPrimitive(builderState, t, hexagonalPrism);
                break;
            case 15 /* HeptagonalPrism */:
                _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_1__["Mat4"].mul(t, t, _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_1__["Mat4"].rotZY90);
                _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_1__["Mat4"].scale(t, t, _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_1__["Vec3"].set(sVec, side, side, side / 2));
                _mol_geo_geometry_mesh_mesh_builder__WEBPACK_IMPORTED_MODULE_8__["MeshBuilder"].addPrimitive(builderState, t, heptagonalPrism);
                break;
            case 10 /* FlatHexagon */:
            default:
                _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_1__["Mat4"].mul(t, t, _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_1__["Mat4"].rotZYZ90);
                _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_1__["Mat4"].scale(t, t, _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_1__["Vec3"].set(sVec, side / 1.5, side, side / 2));
                _mol_geo_geometry_mesh_mesh_builder__WEBPACK_IMPORTED_MODULE_8__["MeshBuilder"].addPrimitive(builderState, t, shiftedHexagonalPrism);
                break;
        }
    }
    return _mol_geo_geometry_mesh_mesh_builder__WEBPACK_IMPORTED_MODULE_8__["MeshBuilder"].getMesh(builderState);
}
var CarbohydrateSymbolParams = Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, _complex_visual__WEBPACK_IMPORTED_MODULE_11__["ComplexMeshParams"]), { detail: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_12__["ParamDefinition"].Numeric(0, { min: 0, max: 3, step: 1 }, _mol_geo_geometry_base__WEBPACK_IMPORTED_MODULE_17__["BaseGeometry"].CustomQualityParamInfo), sizeFactor: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_12__["ParamDefinition"].Numeric(1.75, { min: 0, max: 10, step: 0.01 }) });
function CarbohydrateSymbolVisual(materialId) {
    return Object(_complex_visual__WEBPACK_IMPORTED_MODULE_11__["ComplexMeshVisual"])({
        defaultProps: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_12__["ParamDefinition"].getDefaultValues(CarbohydrateSymbolParams),
        createGeometry: createCarbohydrateSymbolMesh,
        createLocationIterator: CarbohydrateElementIterator,
        getLoci: getCarbohydrateLoci,
        eachLocation: eachCarbohydrate,
        setUpdateState: function (state, newProps, currentProps) {
            state.createGeometry = (newProps.sizeFactor !== currentProps.sizeFactor ||
                newProps.detail !== currentProps.detail);
        }
    }, materialId);
}
function CarbohydrateElementIterator(structure) {
    var carbElements = structure.carbohydrates.elements;
    var groupCount = carbElements.length * 2;
    var instanceCount = 1;
    var location = _mol_model_structure__WEBPACK_IMPORTED_MODULE_7__["StructureElement"].Location.create(structure);
    function getLocation(groupIndex, instanceIndex) {
        var carb = carbElements[Math.floor(groupIndex / 2)];
        var ring = carb.unit.rings.all[carb.ringIndex];
        location.unit = carb.unit;
        location.element = carb.unit.elements[ring[0]];
        return location;
    }
    function isSecondary(elementIndex, instanceIndex) {
        return (elementIndex % 2) === 1;
    }
    return Object(_mol_geo_util_location_iterator__WEBPACK_IMPORTED_MODULE_13__["LocationIterator"])(groupCount, instanceCount, 1, getLocation, true, isSecondary);
}
/** Return a Loci for the elements of the whole residue of a carbohydrate. */
function getCarbohydrateLoci(pickingId, structure, id) {
    var objectId = pickingId.objectId, groupId = pickingId.groupId;
    if (id === objectId) {
        var carb = structure.carbohydrates.elements[Math.floor(groupId / 2)];
        return Object(_util_common__WEBPACK_IMPORTED_MODULE_16__["getAltResidueLociFromId"])(structure, carb.unit, carb.residueIndex, carb.altId);
    }
    return _mol_model_loci__WEBPACK_IMPORTED_MODULE_15__["EmptyLoci"];
}
/** For each carbohydrate (usually a monosaccharide) when all its residue's elements are in a loci. */
function eachCarbohydrate(loci, structure, apply) {
    var getElementIndices = structure.carbohydrates.getElementIndices;
    var changed = false;
    if (!_mol_model_structure__WEBPACK_IMPORTED_MODULE_7__["StructureElement"].Loci.is(loci))
        return false;
    if (!_mol_model_structure__WEBPACK_IMPORTED_MODULE_7__["Structure"].areEquivalent(loci.structure, structure))
        return false;
    var _loop_1 = function (unit, indices) {
        if (!_mol_model_structure__WEBPACK_IMPORTED_MODULE_7__["Unit"].isAtomic(unit))
            return "continue";
        _mol_data_int__WEBPACK_IMPORTED_MODULE_14__["OrderedSet"].forEach(indices, function (v) {
            // TODO avoid duplicate calls to apply
            var elementIndices = getElementIndices(unit, unit.elements[v]);
            for (var i = 0, il = elementIndices.length; i < il; ++i) {
                if (apply(_mol_data_int__WEBPACK_IMPORTED_MODULE_14__["Interval"].ofSingleton(elementIndices[i] * 2)))
                    changed = true;
            }
        });
    };
    for (var _i = 0, _a = loci.elements; _i < _a.length; _i++) {
        var _b = _a[_i], unit = _b.unit, indices = _b.indices;
        _loop_1(unit, indices);
    }
    return changed;
}
//# sourceMappingURL=carbohydrate-symbol-mesh.js.map

/***/ }),

/***/ "./lib/mol-repr/structure/visual/carbohydrate-terminal-link-cylinder.js":
/*!******************************************************************************!*\
  !*** ./lib/mol-repr/structure/visual/carbohydrate-terminal-link-cylinder.js ***!
  \******************************************************************************/
/*! exports provided: CarbohydrateTerminalLinkParams, CarbohydrateTerminalLinkVisual */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CarbohydrateTerminalLinkParams", function() { return CarbohydrateTerminalLinkParams; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CarbohydrateTerminalLinkVisual", function() { return CarbohydrateTerminalLinkVisual; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../../mol-util/param-definition */ "./lib/mol-util/param-definition.js");
/* harmony import */ var _mol_model_structure__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../../mol-model/structure */ "./lib/mol-model/structure.js");
/* harmony import */ var _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../../mol-math/linear-algebra */ "./lib/mol-math/linear-algebra.js");
/* harmony import */ var _util_link__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./util/link */ "./lib/mol-repr/structure/visual/util/link.js");
/* harmony import */ var _units_visual__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../units-visual */ "./lib/mol-repr/structure/units-visual.js");
/* harmony import */ var _complex_visual__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../complex-visual */ "./lib/mol-repr/structure/complex-visual.js");
/* harmony import */ var _mol_geo_util_location_iterator__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../../../mol-geo/util/location-iterator */ "./lib/mol-geo/util/location-iterator.js");
/* harmony import */ var _mol_data_int__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ../../../mol-data/int */ "./lib/mol-data/int.js");
/* harmony import */ var _mol_model_loci__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ../../../mol-model/loci */ "./lib/mol-model/loci.js");
/* harmony import */ var _mol_model_structure_structure_unit_bonds_common__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ../../../mol-model/structure/structure/unit/bonds/common */ "./lib/mol-model/structure/structure/unit/bonds/common.js");
/* harmony import */ var _util_common__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ./util/common */ "./lib/mol-repr/structure/visual/util/common.js");
/**
 * Copyright (c) 2018-2020 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */












function createCarbohydrateTerminalLinkCylinderMesh(ctx, structure, theme, props, mesh) {
    var _a = structure.carbohydrates, terminalLinks = _a.terminalLinks, elements = _a.elements;
    var terminalLinkSizeFactor = props.terminalLinkSizeFactor;
    var location = _mol_model_structure__WEBPACK_IMPORTED_MODULE_2__["StructureElement"].Location.create(structure);
    var builderProps = {
        linkCount: terminalLinks.length,
        position: function (posA, posB, edgeIndex) {
            var l = terminalLinks[edgeIndex];
            if (l.fromCarbohydrate) {
                _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_3__["Vec3"].copy(posA, elements[l.carbohydrateIndex].geometry.center);
                l.elementUnit.conformation.position(l.elementUnit.elements[l.elementIndex], posB);
            }
            else {
                l.elementUnit.conformation.position(l.elementUnit.elements[l.elementIndex], posA);
                _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_3__["Vec3"].copy(posB, elements[l.carbohydrateIndex].geometry.center);
            }
        },
        radius: function (edgeIndex) {
            var l = terminalLinks[edgeIndex];
            if (l.fromCarbohydrate) {
                var carb = elements[l.carbohydrateIndex];
                var ring = carb.unit.rings.all[carb.ringIndex];
                location.unit = carb.unit;
                location.element = carb.unit.elements[ring[0]];
            }
            else {
                location.unit = l.elementUnit;
                location.element = l.elementUnit.elements[l.elementIndex];
            }
            return theme.size.size(location) * terminalLinkSizeFactor;
        },
        style: function (edgeIndex) {
            var l = terminalLinks[edgeIndex];
            var eI = l.elementUnit.elements[l.elementIndex];
            var beI = Object(_mol_model_structure_structure_unit_bonds_common__WEBPACK_IMPORTED_MODULE_10__["getElementIdx"])(l.elementUnit.model.atomicHierarchy.atoms.type_symbol.value(eI));
            return _mol_model_structure_structure_unit_bonds_common__WEBPACK_IMPORTED_MODULE_10__["MetalsSet"].has(beI) ? 1 /* Dashed */ : 0 /* Solid */;
        }
    };
    return Object(_util_link__WEBPACK_IMPORTED_MODULE_4__["createLinkCylinderMesh"])(ctx, builderProps, props, mesh);
}
var CarbohydrateTerminalLinkParams = Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, _units_visual__WEBPACK_IMPORTED_MODULE_5__["UnitsMeshParams"]), _util_link__WEBPACK_IMPORTED_MODULE_4__["LinkCylinderParams"]), { terminalLinkSizeFactor: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_1__["ParamDefinition"].Numeric(0.2, { min: 0, max: 3, step: 0.01 }) });
function CarbohydrateTerminalLinkVisual(materialId) {
    return Object(_complex_visual__WEBPACK_IMPORTED_MODULE_6__["ComplexMeshVisual"])({
        defaultProps: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_1__["ParamDefinition"].getDefaultValues(CarbohydrateTerminalLinkParams),
        createGeometry: createCarbohydrateTerminalLinkCylinderMesh,
        createLocationIterator: CarbohydrateTerminalLinkIterator,
        getLoci: getTerminalLinkLoci,
        eachLocation: eachTerminalLink,
        setUpdateState: function (state, newProps, currentProps) {
            state.createGeometry = (newProps.terminalLinkSizeFactor !== currentProps.terminalLinkSizeFactor ||
                newProps.radialSegments !== currentProps.radialSegments ||
                newProps.linkCap !== currentProps.linkCap);
        }
    }, materialId);
}
function CarbohydrateTerminalLinkIterator(structure) {
    var _a = structure.carbohydrates, elements = _a.elements, terminalLinks = _a.terminalLinks;
    var groupCount = terminalLinks.length;
    var instanceCount = 1;
    var location = _mol_model_structure__WEBPACK_IMPORTED_MODULE_2__["StructureElement"].Location.create(structure);
    var getLocation = function (groupIndex) {
        var terminalLink = terminalLinks[groupIndex];
        if (terminalLink.fromCarbohydrate) {
            var carb = elements[terminalLink.carbohydrateIndex];
            var ring = carb.unit.rings.all[carb.ringIndex];
            location.unit = carb.unit;
            location.element = carb.unit.elements[ring[0]];
        }
        else {
            location.unit = terminalLink.elementUnit;
            location.element = terminalLink.elementUnit.elements[terminalLink.elementIndex];
        }
        return location;
    };
    return Object(_mol_geo_util_location_iterator__WEBPACK_IMPORTED_MODULE_7__["LocationIterator"])(groupCount, instanceCount, 1, getLocation, true);
}
function getTerminalLinkLoci(pickingId, structure, id) {
    var objectId = pickingId.objectId, groupId = pickingId.groupId;
    if (id === objectId) {
        var _a = structure.carbohydrates, terminalLinks = _a.terminalLinks, elements = _a.elements;
        var l = terminalLinks[groupId];
        var carb = elements[l.carbohydrateIndex];
        return _mol_model_structure__WEBPACK_IMPORTED_MODULE_2__["StructureElement"].Loci.union(Object(_util_common__WEBPACK_IMPORTED_MODULE_11__["getAltResidueLociFromId"])(structure, carb.unit, carb.residueIndex, carb.altId), Object(_util_common__WEBPACK_IMPORTED_MODULE_11__["getAltResidueLoci"])(structure, l.elementUnit, l.elementUnit.elements[l.elementIndex]));
    }
    return _mol_model_loci__WEBPACK_IMPORTED_MODULE_9__["EmptyLoci"];
}
function eachTerminalLink(loci, structure, apply) {
    var changed = false;
    if (!_mol_model_structure__WEBPACK_IMPORTED_MODULE_2__["StructureElement"].Loci.is(loci))
        return false;
    if (!_mol_model_structure__WEBPACK_IMPORTED_MODULE_2__["Structure"].areEquivalent(loci.structure, structure))
        return false;
    var getTerminalLinkIndices = structure.carbohydrates.getTerminalLinkIndices;
    var _loop_1 = function (unit, indices) {
        if (!_mol_model_structure__WEBPACK_IMPORTED_MODULE_2__["Unit"].isAtomic(unit))
            return "continue";
        _mol_data_int__WEBPACK_IMPORTED_MODULE_8__["OrderedSet"].forEach(indices, function (v) {
            // TODO avoid duplicate calls to apply
            var linkIndices = getTerminalLinkIndices(unit, unit.elements[v]);
            for (var i = 0, il = linkIndices.length; i < il; ++i) {
                if (apply(_mol_data_int__WEBPACK_IMPORTED_MODULE_8__["Interval"].ofSingleton(linkIndices[i])))
                    changed = true;
            }
        });
    };
    for (var _i = 0, _a = loci.elements; _i < _a.length; _i++) {
        var _b = _a[_i], unit = _b.unit, indices = _b.indices;
        _loop_1(unit, indices);
    }
    return changed;
}
//# sourceMappingURL=carbohydrate-terminal-link-cylinder.js.map

/***/ }),

/***/ "./lib/mol-repr/structure/visual/element-point.js":
/*!********************************************************!*\
  !*** ./lib/mol-repr/structure/visual/element-point.js ***!
  \********************************************************/
/*! exports provided: ElementPointParams, createElementPoint, ElementPointVisual */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ElementPointParams", function() { return ElementPointParams; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createElementPoint", function() { return createElementPoint; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ElementPointVisual", function() { return ElementPointVisual; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../../mol-util/param-definition */ "./lib/mol-util/param-definition.js");
/* harmony import */ var _units_visual__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../units-visual */ "./lib/mol-repr/structure/units-visual.js");
/* harmony import */ var _mol_geo_geometry_points_points_builder__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../../mol-geo/geometry/points/points-builder */ "./lib/mol-geo/geometry/points/points-builder.js");
/* harmony import */ var _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../../mol-math/linear-algebra */ "./lib/mol-math/linear-algebra.js");
/* harmony import */ var _util_element__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./util/element */ "./lib/mol-repr/structure/visual/util/element.js");
/* harmony import */ var _mol_math_geometry__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../../../mol-math/geometry */ "./lib/mol-math/geometry.js");
/**
 * Copyright (c) 2018-2020 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */







var ElementPointParams = Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, _units_visual__WEBPACK_IMPORTED_MODULE_2__["UnitsPointsParams"]), { 
    // sizeFactor: PD.Numeric(1.0, { min: 0, max: 10, step: 0.01 }),
    pointSizeAttenuation: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_1__["ParamDefinition"].Boolean(false), ignoreHydrogens: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_1__["ParamDefinition"].Boolean(false), traceOnly: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_1__["ParamDefinition"].Boolean(false) });
// TODO size
function createElementPoint(ctx, unit, structure, theme, props, points) {
    // TODO sizeFactor
    var elements = unit.elements;
    var n = elements.length;
    var builder = _mol_geo_geometry_points_points_builder__WEBPACK_IMPORTED_MODULE_3__["PointsBuilder"].create(n, n / 10, points);
    var p = Object(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_4__["Vec3"])();
    var pos = unit.conformation.invariantPosition;
    var ignore = Object(_util_element__WEBPACK_IMPORTED_MODULE_5__["makeElementIgnoreTest"])(unit, props);
    if (ignore) {
        for (var i = 0; i < n; ++i) {
            if (ignore(unit, elements[i]))
                continue;
            pos(elements[i], p);
            builder.add(p[0], p[1], p[2], i);
        }
    }
    else {
        for (var i = 0; i < n; ++i) {
            pos(elements[i], p);
            builder.add(p[0], p[1], p[2], i);
        }
    }
    var pt = builder.getPoints();
    var sphere = _mol_math_geometry__WEBPACK_IMPORTED_MODULE_6__["Sphere3D"].expand(Object(_mol_math_geometry__WEBPACK_IMPORTED_MODULE_6__["Sphere3D"])(), unit.boundary.sphere, 1 * props.sizeFactor);
    pt.setBoundingSphere(sphere);
    return pt;
}
function ElementPointVisual(materialId) {
    return Object(_units_visual__WEBPACK_IMPORTED_MODULE_2__["UnitsPointsVisual"])({
        defaultProps: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_1__["ParamDefinition"].getDefaultValues(ElementPointParams),
        createGeometry: createElementPoint,
        createLocationIterator: _util_element__WEBPACK_IMPORTED_MODULE_5__["ElementIterator"].fromGroup,
        getLoci: _util_element__WEBPACK_IMPORTED_MODULE_5__["getElementLoci"],
        eachLocation: _util_element__WEBPACK_IMPORTED_MODULE_5__["eachElement"],
        setUpdateState: function (state, newProps, currentProps) {
            state.createGeometry = (newProps.ignoreHydrogens !== currentProps.ignoreHydrogens ||
                newProps.traceOnly !== currentProps.traceOnly);
        }
    }, materialId);
}
//# sourceMappingURL=element-point.js.map

/***/ }),

/***/ "./lib/mol-repr/structure/visual/element-sphere.js":
/*!*********************************************************!*\
  !*** ./lib/mol-repr/structure/visual/element-sphere.js ***!
  \*********************************************************/
/*! exports provided: ElementSphereParams, ElementSphereVisual, ElementSphereImpostorVisual, ElementSphereMeshVisual */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ElementSphereParams", function() { return ElementSphereParams; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ElementSphereVisual", function() { return ElementSphereVisual; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ElementSphereImpostorVisual", function() { return ElementSphereImpostorVisual; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ElementSphereMeshVisual", function() { return ElementSphereMeshVisual; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../../mol-util/param-definition */ "./lib/mol-util/param-definition.js");
/* harmony import */ var _units_visual__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../units-visual */ "./lib/mol-repr/structure/units-visual.js");
/* harmony import */ var _util_element__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./util/element */ "./lib/mol-repr/structure/visual/util/element.js");
/* harmony import */ var _mol_geo_geometry_base__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../../mol-geo/geometry/base */ "./lib/mol-geo/geometry/base.js");
/**
 * Copyright (c) 2018-2021 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 * @author David Sehnal <david.sehnal@gmail.com>
 */





var ElementSphereParams = Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, _units_visual__WEBPACK_IMPORTED_MODULE_2__["UnitsMeshParams"]), _units_visual__WEBPACK_IMPORTED_MODULE_2__["UnitsSpheresParams"]), { sizeFactor: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_1__["ParamDefinition"].Numeric(1, { min: 0, max: 10, step: 0.1 }), detail: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_1__["ParamDefinition"].Numeric(0, { min: 0, max: 3, step: 1 }, _mol_geo_geometry_base__WEBPACK_IMPORTED_MODULE_4__["BaseGeometry"].CustomQualityParamInfo), ignoreHydrogens: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_1__["ParamDefinition"].Boolean(false), traceOnly: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_1__["ParamDefinition"].Boolean(false), useImpostor: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_1__["ParamDefinition"].Boolean(true) });
function ElementSphereVisual(materialId, props, webgl) {
    return (props === null || props === void 0 ? void 0 : props.useImpostor) && webgl && webgl.extensions.fragDepth
        ? ElementSphereImpostorVisual(materialId)
        : ElementSphereMeshVisual(materialId);
}
function ElementSphereImpostorVisual(materialId) {
    return Object(_units_visual__WEBPACK_IMPORTED_MODULE_2__["UnitsSpheresVisual"])({
        defaultProps: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_1__["ParamDefinition"].getDefaultValues(ElementSphereParams),
        createGeometry: _util_element__WEBPACK_IMPORTED_MODULE_3__["createElementSphereImpostor"],
        createLocationIterator: _util_element__WEBPACK_IMPORTED_MODULE_3__["ElementIterator"].fromGroup,
        getLoci: _util_element__WEBPACK_IMPORTED_MODULE_3__["getElementLoci"],
        eachLocation: _util_element__WEBPACK_IMPORTED_MODULE_3__["eachElement"],
        setUpdateState: function (state, newProps, currentProps) {
            state.createGeometry = (newProps.ignoreHydrogens !== currentProps.ignoreHydrogens ||
                newProps.traceOnly !== currentProps.traceOnly);
        },
        mustRecreate: function (props, webgl) {
            return !props.useImpostor || !webgl;
        }
    }, materialId);
}
function ElementSphereMeshVisual(materialId) {
    return Object(_units_visual__WEBPACK_IMPORTED_MODULE_2__["UnitsMeshVisual"])({
        defaultProps: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_1__["ParamDefinition"].getDefaultValues(ElementSphereParams),
        createGeometry: _util_element__WEBPACK_IMPORTED_MODULE_3__["createElementSphereMesh"],
        createLocationIterator: _util_element__WEBPACK_IMPORTED_MODULE_3__["ElementIterator"].fromGroup,
        getLoci: _util_element__WEBPACK_IMPORTED_MODULE_3__["getElementLoci"],
        eachLocation: _util_element__WEBPACK_IMPORTED_MODULE_3__["eachElement"],
        setUpdateState: function (state, newProps, currentProps) {
            state.createGeometry = (newProps.sizeFactor !== currentProps.sizeFactor ||
                newProps.detail !== currentProps.detail ||
                newProps.ignoreHydrogens !== currentProps.ignoreHydrogens ||
                newProps.traceOnly !== currentProps.traceOnly);
        },
        mustRecreate: function (props, webgl) {
            return props.useImpostor && !!webgl;
        }
    }, materialId);
}
//# sourceMappingURL=element-sphere.js.map

/***/ }),

/***/ "./lib/mol-repr/structure/visual/ellipsoid-mesh.js":
/*!*********************************************************!*\
  !*** ./lib/mol-repr/structure/visual/ellipsoid-mesh.js ***!
  \*********************************************************/
/*! exports provided: EllipsoidMeshParams, EllipsoidMeshVisual, createEllipsoidMesh */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "EllipsoidMeshParams", function() { return EllipsoidMeshParams; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "EllipsoidMeshVisual", function() { return EllipsoidMeshVisual; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createEllipsoidMesh", function() { return createEllipsoidMesh; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../../mol-util/param-definition */ "./lib/mol-util/param-definition.js");
/* harmony import */ var _mol_repr_structure_units_visual__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../../mol-repr/structure/units-visual */ "./lib/mol-repr/structure/units-visual.js");
/* harmony import */ var _mol_repr_structure_visual_util_element__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../../mol-repr/structure/visual/util/element */ "./lib/mol-repr/structure/visual/util/element.js");
/* harmony import */ var _mol_model_structure__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../../mol-model/structure */ "./lib/mol-model/structure.js");
/* harmony import */ var _mol_geo_geometry_mesh_mesh__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../../mol-geo/geometry/mesh/mesh */ "./lib/mol-geo/geometry/mesh/mesh.js");
/* harmony import */ var _mol_geo_primitive_sphere__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../../../mol-geo/primitive/sphere */ "./lib/mol-geo/primitive/sphere.js");
/* harmony import */ var _mol_geo_geometry_mesh_mesh_builder__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../../../mol-geo/geometry/mesh/mesh-builder */ "./lib/mol-geo/geometry/mesh/mesh-builder.js");
/* harmony import */ var _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ../../../mol-math/linear-algebra */ "./lib/mol-math/linear-algebra.js");
/* harmony import */ var _mol_repr_structure_visual_util_common__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ../../../mol-repr/structure/visual/util/common */ "./lib/mol-repr/structure/visual/util/common.js");
/* harmony import */ var _mol_geo_geometry_mesh_builder_ellipsoid__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ../../../mol-geo/geometry/mesh/builder/ellipsoid */ "./lib/mol-geo/geometry/mesh/builder/ellipsoid.js");
/* harmony import */ var _mol_model_formats_structure_property_anisotropic__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ../../../mol-model-formats/structure/property/anisotropic */ "./lib/mol-model-formats/structure/property/anisotropic.js");
/* harmony import */ var _mol_math_linear_algebra_3d_common__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! ../../../mol-math/linear-algebra/3d/common */ "./lib/mol-math/linear-algebra/3d/common.js");
/* harmony import */ var _mol_geo_geometry_mesh_builder_sphere__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! ../../../mol-geo/geometry/mesh/builder/sphere */ "./lib/mol-geo/geometry/mesh/builder/sphere.js");
/* harmony import */ var _mol_math_geometry__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! ../../../mol-math/geometry */ "./lib/mol-math/geometry.js");
/* harmony import */ var _mol_geo_geometry_base__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! ../../../mol-geo/geometry/base */ "./lib/mol-geo/geometry/base.js");
/**
 * Copyright (c) 2019 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */
















var EllipsoidMeshParams = Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, _mol_repr_structure_units_visual__WEBPACK_IMPORTED_MODULE_2__["UnitsMeshParams"]), { sizeFactor: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_1__["ParamDefinition"].Numeric(1, { min: 0, max: 10, step: 0.1 }), detail: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_1__["ParamDefinition"].Numeric(0, { min: 0, max: 3, step: 1 }, _mol_geo_geometry_base__WEBPACK_IMPORTED_MODULE_15__["BaseGeometry"].CustomQualityParamInfo), ignoreHydrogens: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_1__["ParamDefinition"].Boolean(false) });
function EllipsoidMeshVisual(materialId) {
    return Object(_mol_repr_structure_units_visual__WEBPACK_IMPORTED_MODULE_2__["UnitsMeshVisual"])({
        defaultProps: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_1__["ParamDefinition"].getDefaultValues(EllipsoidMeshParams),
        createGeometry: createEllipsoidMesh,
        createLocationIterator: _mol_repr_structure_visual_util_element__WEBPACK_IMPORTED_MODULE_3__["ElementIterator"].fromGroup,
        getLoci: _mol_repr_structure_visual_util_element__WEBPACK_IMPORTED_MODULE_3__["getElementLoci"],
        eachLocation: _mol_repr_structure_visual_util_element__WEBPACK_IMPORTED_MODULE_3__["eachElement"],
        setUpdateState: function (state, newProps, currentProps) {
            state.createGeometry = (newProps.sizeFactor !== currentProps.sizeFactor ||
                newProps.detail !== currentProps.detail ||
                newProps.ignoreHydrogens !== currentProps.ignoreHydrogens);
        }
    }, materialId);
}
function createEllipsoidMesh(ctx, unit, structure, theme, props, mesh) {
    var detail = props.detail, sizeFactor = props.sizeFactor;
    var elements = unit.elements, model = unit.model;
    var atomicNumber = unit.model.atomicHierarchy.derived.atom.atomicNumber;
    var elementCount = elements.length;
    var vertexCount = elementCount * Object(_mol_geo_primitive_sphere__WEBPACK_IMPORTED_MODULE_6__["sphereVertexCount"])(detail);
    var builderState = _mol_geo_geometry_mesh_mesh_builder__WEBPACK_IMPORTED_MODULE_7__["MeshBuilder"].createState(vertexCount, vertexCount / 2, mesh);
    var atomSiteAnisotrop = _mol_model_formats_structure_property_anisotropic__WEBPACK_IMPORTED_MODULE_11__["AtomSiteAnisotrop"].Provider.get(model);
    if (!atomSiteAnisotrop)
        return _mol_geo_geometry_mesh_mesh__WEBPACK_IMPORTED_MODULE_5__["Mesh"].createEmpty(mesh);
    var v = Object(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_8__["Vec3"])();
    var mat = Object(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_8__["Mat3"])();
    var eigvals = Object(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_8__["Vec3"])();
    var eigvec1 = Object(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_8__["Vec3"])();
    var eigvec2 = Object(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_8__["Vec3"])();
    var elementToAnsiotrop = atomSiteAnisotrop.elementToAnsiotrop, data = atomSiteAnisotrop.data;
    var U = data.U;
    var space = data._schema.U.space;
    var pos = unit.conformation.invariantPosition;
    var l = _mol_model_structure__WEBPACK_IMPORTED_MODULE_4__["StructureElement"].Location.create(structure);
    l.unit = unit;
    for (var i = 0; i < elementCount; i++) {
        var ei = elements[i];
        var ai = elementToAnsiotrop[ei];
        if (ai === -1)
            continue;
        if (props.ignoreHydrogens && Object(_mol_repr_structure_visual_util_common__WEBPACK_IMPORTED_MODULE_9__["isH"])(atomicNumber, ei))
            continue;
        l.element = ei;
        pos(ei, v);
        builderState.currentGroup = i;
        _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_8__["Tensor"].toMat3(mat, space, U.value(ai));
        _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_8__["Mat3"].symmtricFromLower(mat, mat);
        _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_8__["Mat3"].symmetricEigenvalues(eigvals, mat);
        _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_8__["Mat3"].eigenvector(eigvec1, mat, eigvals[1]);
        _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_8__["Mat3"].eigenvector(eigvec2, mat, eigvals[2]);
        for (var j = 0; j < 3; ++j) {
            // show 50% probability surface, needs sqrt as U matrix is in angstrom-squared
            // take abs of eigenvalue to avoid reflection
            // multiply by given size-factor
            eigvals[j] = sizeFactor * 1.5958 * Math.sqrt(Math.abs(eigvals[j]));
        }
        if (Object(_mol_math_linear_algebra_3d_common__WEBPACK_IMPORTED_MODULE_12__["equalEps"])(eigvals[0], eigvals[1], _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_8__["EPSILON"]) && Object(_mol_math_linear_algebra_3d_common__WEBPACK_IMPORTED_MODULE_12__["equalEps"])(eigvals[1], eigvals[2], _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_8__["EPSILON"])) {
            Object(_mol_geo_geometry_mesh_builder_sphere__WEBPACK_IMPORTED_MODULE_13__["addSphere"])(builderState, v, eigvals[0], detail);
        }
        else {
            Object(_mol_geo_geometry_mesh_builder_ellipsoid__WEBPACK_IMPORTED_MODULE_10__["addEllipsoid"])(builderState, v, eigvec2, eigvec1, eigvals, detail);
        }
    }
    var m = _mol_geo_geometry_mesh_mesh_builder__WEBPACK_IMPORTED_MODULE_7__["MeshBuilder"].getMesh(builderState);
    var sphere = _mol_math_geometry__WEBPACK_IMPORTED_MODULE_14__["Sphere3D"].expand(Object(_mol_math_geometry__WEBPACK_IMPORTED_MODULE_14__["Sphere3D"])(), unit.boundary.sphere, 1 * sizeFactor);
    m.setBoundingSphere(sphere);
    return m;
}
//# sourceMappingURL=ellipsoid-mesh.js.map

/***/ }),

/***/ "./lib/mol-repr/structure/visual/gaussian-density-volume.js":
/*!******************************************************************!*\
  !*** ./lib/mol-repr/structure/visual/gaussian-density-volume.js ***!
  \******************************************************************/
/*! exports provided: GaussianDensityVolumeParams, GaussianDensityVolumeVisual, UnitsGaussianDensityVolumeParams, UnitsGaussianDensityVolumeVisual */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "GaussianDensityVolumeParams", function() { return GaussianDensityVolumeParams; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "GaussianDensityVolumeVisual", function() { return GaussianDensityVolumeVisual; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "UnitsGaussianDensityVolumeParams", function() { return UnitsGaussianDensityVolumeParams; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "UnitsGaussianDensityVolumeVisual", function() { return UnitsGaussianDensityVolumeVisual; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../../mol-util/param-definition */ "./lib/mol-util/param-definition.js");
/* harmony import */ var _util_gaussian__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./util/gaussian */ "./lib/mol-repr/structure/visual/util/gaussian.js");
/* harmony import */ var _mol_geo_geometry_direct_volume_direct_volume__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../../mol-geo/geometry/direct-volume/direct-volume */ "./lib/mol-geo/geometry/direct-volume/direct-volume.js");
/* harmony import */ var _complex_visual__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../complex-visual */ "./lib/mol-repr/structure/complex-visual.js");
/* harmony import */ var _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../../mol-math/linear-algebra */ "./lib/mol-math/linear-algebra.js");
/* harmony import */ var _util_element__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ./util/element */ "./lib/mol-repr/structure/visual/util/element.js");
/* harmony import */ var _mol_math_geometry__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../../../mol-math/geometry */ "./lib/mol-math/geometry.js");
/* harmony import */ var _units_visual__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ../units-visual */ "./lib/mol-repr/structure/units-visual.js");
/* harmony import */ var _util_common__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ./util/common */ "./lib/mol-repr/structure/visual/util/common.js");
/**
 * Copyright (c) 2018-2021 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */










function createGaussianDensityVolume(ctx, structure, theme, props, directVolume) {
    return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"])(this, void 0, void 0, function () {
        var runtime, webgl, p, oldTexture, densityTextureData, transform, texture, bbox, gridDim, stats, unitToCartn, cellDim, vol, sphere;
        return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__generator"])(this, function (_a) {
            switch (_a.label) {
                case 0:
                    runtime = ctx.runtime, webgl = ctx.webgl;
                    if (webgl === undefined)
                        throw new Error('createGaussianDensityVolume requires `webgl` object in VisualContext');
                    p = Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, props), { useGpu: true });
                    oldTexture = directVolume ? directVolume.gridTexture.ref.value : undefined;
                    return [4 /*yield*/, Object(_util_gaussian__WEBPACK_IMPORTED_MODULE_2__["computeStructureGaussianDensityTexture"])(structure, p, webgl, oldTexture).runInContext(runtime)];
                case 1:
                    densityTextureData = _a.sent();
                    transform = densityTextureData.transform, texture = densityTextureData.texture, bbox = densityTextureData.bbox, gridDim = densityTextureData.gridDim;
                    stats = { min: 0, max: 1, mean: 0.04, sigma: 0.01 };
                    unitToCartn = _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_5__["Mat4"].mul(Object(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_5__["Mat4"])(), transform, _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_5__["Mat4"].fromScaling(Object(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_5__["Mat4"])(), gridDim));
                    cellDim = _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_5__["Mat4"].getScaling(Object(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_5__["Vec3"])(), transform);
                    vol = _mol_geo_geometry_direct_volume_direct_volume__WEBPACK_IMPORTED_MODULE_3__["DirectVolume"].create(bbox, gridDim, transform, unitToCartn, cellDim, texture, stats, true, directVolume);
                    sphere = _mol_math_geometry__WEBPACK_IMPORTED_MODULE_7__["Sphere3D"].expand(Object(_mol_math_geometry__WEBPACK_IMPORTED_MODULE_7__["Sphere3D"])(), structure.boundary.sphere, props.radiusOffset + Object(_util_common__WEBPACK_IMPORTED_MODULE_9__["getStructureExtraRadius"])(structure));
                    vol.setBoundingSphere(sphere);
                    return [2 /*return*/, vol];
            }
        });
    });
}
var GaussianDensityVolumeParams = Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, _complex_visual__WEBPACK_IMPORTED_MODULE_4__["ComplexDirectVolumeParams"]), _util_gaussian__WEBPACK_IMPORTED_MODULE_2__["GaussianDensityParams"]), { ignoreHydrogens: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_1__["ParamDefinition"].Boolean(false) });
function GaussianDensityVolumeVisual(materialId) {
    return Object(_complex_visual__WEBPACK_IMPORTED_MODULE_4__["ComplexDirectVolumeVisual"])({
        defaultProps: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_1__["ParamDefinition"].getDefaultValues(GaussianDensityVolumeParams),
        createGeometry: createGaussianDensityVolume,
        createLocationIterator: _util_element__WEBPACK_IMPORTED_MODULE_6__["ElementIterator"].fromStructure,
        getLoci: _util_element__WEBPACK_IMPORTED_MODULE_6__["getSerialElementLoci"],
        eachLocation: _util_element__WEBPACK_IMPORTED_MODULE_6__["eachSerialElement"],
        setUpdateState: function (state, newProps, currentProps) {
            if (newProps.resolution !== currentProps.resolution)
                state.createGeometry = true;
            if (newProps.radiusOffset !== currentProps.radiusOffset)
                state.createGeometry = true;
            if (newProps.smoothness !== currentProps.smoothness)
                state.createGeometry = true;
            if (newProps.ignoreHydrogens !== currentProps.ignoreHydrogens)
                state.createGeometry = true;
            if (newProps.traceOnly !== currentProps.traceOnly)
                state.createGeometry = true;
            if (newProps.includeParent !== currentProps.includeParent)
                state.createGeometry = true;
        },
        dispose: function (geometry) {
            geometry.gridTexture.ref.value.destroy();
        }
    }, materialId);
}
//
function createUnitsGaussianDensityVolume(ctx, unit, structure, theme, props, directVolume) {
    return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"])(this, void 0, void 0, function () {
        var runtime, webgl, p, oldTexture, densityTextureData, transform, texture, bbox, gridDim, stats, unitToCartn, cellDim, vol, sphere;
        return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__generator"])(this, function (_a) {
            switch (_a.label) {
                case 0:
                    runtime = ctx.runtime, webgl = ctx.webgl;
                    if (webgl === undefined)
                        throw new Error('createUnitGaussianDensityVolume requires `webgl` object in VisualContext');
                    p = Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, props), { useGpu: true });
                    oldTexture = directVolume ? directVolume.gridTexture.ref.value : undefined;
                    return [4 /*yield*/, Object(_util_gaussian__WEBPACK_IMPORTED_MODULE_2__["computeUnitGaussianDensityTexture"])(structure, unit, p, webgl, oldTexture).runInContext(runtime)];
                case 1:
                    densityTextureData = _a.sent();
                    transform = densityTextureData.transform, texture = densityTextureData.texture, bbox = densityTextureData.bbox, gridDim = densityTextureData.gridDim;
                    stats = { min: 0, max: 1, mean: 0.04, sigma: 0.01 };
                    unitToCartn = _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_5__["Mat4"].mul(Object(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_5__["Mat4"])(), transform, _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_5__["Mat4"].fromScaling(Object(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_5__["Mat4"])(), gridDim));
                    cellDim = _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_5__["Mat4"].getScaling(Object(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_5__["Vec3"])(), transform);
                    vol = _mol_geo_geometry_direct_volume_direct_volume__WEBPACK_IMPORTED_MODULE_3__["DirectVolume"].create(bbox, gridDim, transform, unitToCartn, cellDim, texture, stats, true, directVolume);
                    sphere = _mol_math_geometry__WEBPACK_IMPORTED_MODULE_7__["Sphere3D"].expand(Object(_mol_math_geometry__WEBPACK_IMPORTED_MODULE_7__["Sphere3D"])(), unit.boundary.sphere, props.radiusOffset + Object(_util_common__WEBPACK_IMPORTED_MODULE_9__["getUnitExtraRadius"])(unit));
                    vol.setBoundingSphere(sphere);
                    return [2 /*return*/, vol];
            }
        });
    });
}
var UnitsGaussianDensityVolumeParams = Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, _units_visual__WEBPACK_IMPORTED_MODULE_8__["UnitsDirectVolumeParams"]), _util_gaussian__WEBPACK_IMPORTED_MODULE_2__["GaussianDensityParams"]), { ignoreHydrogens: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_1__["ParamDefinition"].Boolean(false) });
function UnitsGaussianDensityVolumeVisual(materialId) {
    return Object(_units_visual__WEBPACK_IMPORTED_MODULE_8__["UnitsDirectVolumeVisual"])({
        defaultProps: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_1__["ParamDefinition"].getDefaultValues(UnitsGaussianDensityVolumeParams),
        createGeometry: createUnitsGaussianDensityVolume,
        createLocationIterator: _util_element__WEBPACK_IMPORTED_MODULE_6__["ElementIterator"].fromGroup,
        getLoci: _util_element__WEBPACK_IMPORTED_MODULE_6__["getElementLoci"],
        eachLocation: _util_element__WEBPACK_IMPORTED_MODULE_6__["eachElement"],
        setUpdateState: function (state, newProps, currentProps) {
            if (newProps.resolution !== currentProps.resolution)
                state.createGeometry = true;
            if (newProps.radiusOffset !== currentProps.radiusOffset)
                state.createGeometry = true;
            if (newProps.smoothness !== currentProps.smoothness)
                state.createGeometry = true;
            if (newProps.ignoreHydrogens !== currentProps.ignoreHydrogens)
                state.createGeometry = true;
            if (newProps.traceOnly !== currentProps.traceOnly)
                state.createGeometry = true;
            if (newProps.includeParent !== currentProps.includeParent)
                state.createGeometry = true;
        },
        dispose: function (geometry) {
            geometry.gridTexture.ref.value.destroy();
        }
    }, materialId);
}
//# sourceMappingURL=gaussian-density-volume.js.map

/***/ }),

/***/ "./lib/mol-repr/structure/visual/gaussian-surface-mesh.js":
/*!****************************************************************!*\
  !*** ./lib/mol-repr/structure/visual/gaussian-surface-mesh.js ***!
  \****************************************************************/
/*! exports provided: GaussianSurfaceMeshParams, StructureGaussianSurfaceMeshParams, GaussianSurfaceVisual, StructureGaussianSurfaceVisual, GaussianSurfaceMeshVisual, StructureGaussianSurfaceMeshVisual, GaussianSurfaceTextureMeshVisual, StructureGaussianSurfaceTextureMeshVisual */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "GaussianSurfaceMeshParams", function() { return GaussianSurfaceMeshParams; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "StructureGaussianSurfaceMeshParams", function() { return StructureGaussianSurfaceMeshParams; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "GaussianSurfaceVisual", function() { return GaussianSurfaceVisual; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "StructureGaussianSurfaceVisual", function() { return StructureGaussianSurfaceVisual; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "GaussianSurfaceMeshVisual", function() { return GaussianSurfaceMeshVisual; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "StructureGaussianSurfaceMeshVisual", function() { return StructureGaussianSurfaceMeshVisual; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "GaussianSurfaceTextureMeshVisual", function() { return GaussianSurfaceTextureMeshVisual; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "StructureGaussianSurfaceTextureMeshVisual", function() { return StructureGaussianSurfaceTextureMeshVisual; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../../mol-util/param-definition */ "./lib/mol-util/param-definition.js");
/* harmony import */ var _units_visual__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../units-visual */ "./lib/mol-repr/structure/units-visual.js");
/* harmony import */ var _util_gaussian__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./util/gaussian */ "./lib/mol-repr/structure/visual/util/gaussian.js");
/* harmony import */ var _mol_geo_geometry_mesh_mesh__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../../mol-geo/geometry/mesh/mesh */ "./lib/mol-geo/geometry/mesh/mesh.js");
/* harmony import */ var _mol_geo_util_marching_cubes_algorithm__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../../mol-geo/util/marching-cubes/algorithm */ "./lib/mol-geo/util/marching-cubes/algorithm.js");
/* harmony import */ var _util_element__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ./util/element */ "./lib/mol-repr/structure/visual/util/element.js");
/* harmony import */ var _mol_geo_geometry_texture_mesh_texture_mesh__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../../../mol-geo/geometry/texture-mesh/texture-mesh */ "./lib/mol-geo/geometry/texture-mesh/texture-mesh.js");
/* harmony import */ var _mol_gl_compute_marching_cubes_active_voxels__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ../../../mol-gl/compute/marching-cubes/active-voxels */ "./lib/mol-gl/compute/marching-cubes/active-voxels.js");
/* harmony import */ var _mol_gl_compute_histogram_pyramid_reduction__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ../../../mol-gl/compute/histogram-pyramid/reduction */ "./lib/mol-gl/compute/histogram-pyramid/reduction.js");
/* harmony import */ var _mol_gl_compute_marching_cubes_isosurface__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ../../../mol-gl/compute/marching-cubes/isosurface */ "./lib/mol-gl/compute/marching-cubes/isosurface.js");
/* harmony import */ var _mol_math_geometry__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ../../../mol-math/geometry */ "./lib/mol-math/geometry.js");
/* harmony import */ var _complex_visual__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! ../complex-visual */ "./lib/mol-repr/structure/complex-visual.js");
/* harmony import */ var _util_common__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! ./util/common */ "./lib/mol-repr/structure/visual/util/common.js");
/**
 * Copyright (c) 2018-2021 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */














var SharedParams = Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, _util_gaussian__WEBPACK_IMPORTED_MODULE_3__["GaussianDensityParams"]), { ignoreHydrogens: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_1__["ParamDefinition"].Boolean(false), useGpu: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_1__["ParamDefinition"].Boolean(false) });
var GaussianSurfaceMeshParams = Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, _units_visual__WEBPACK_IMPORTED_MODULE_2__["UnitsMeshParams"]), _units_visual__WEBPACK_IMPORTED_MODULE_2__["UnitsTextureMeshParams"]), SharedParams);
var StructureGaussianSurfaceMeshParams = Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, _complex_visual__WEBPACK_IMPORTED_MODULE_12__["ComplexMeshParams"]), _complex_visual__WEBPACK_IMPORTED_MODULE_12__["ComplexTextureMeshParams"]), SharedParams);
function gpuSupport(webgl) {
    return webgl.extensions.colorBufferFloat && webgl.extensions.textureFloat && webgl.extensions.blendMinMax && webgl.extensions.drawBuffers;
}
function GaussianSurfaceVisual(materialId, props, webgl) {
    return (props === null || props === void 0 ? void 0 : props.useGpu) && webgl && gpuSupport(webgl)
        ? GaussianSurfaceTextureMeshVisual(materialId)
        : GaussianSurfaceMeshVisual(materialId);
}
function StructureGaussianSurfaceVisual(materialId, props, webgl) {
    return (props === null || props === void 0 ? void 0 : props.useGpu) && webgl && gpuSupport(webgl)
        ? StructureGaussianSurfaceTextureMeshVisual(materialId)
        : StructureGaussianSurfaceMeshVisual(materialId);
}
//
function createGaussianSurfaceMesh(ctx, unit, structure, theme, props, mesh) {
    return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"])(this, void 0, void 0, function () {
        var smoothness, _a, transform, field, idField, radiusFactor, params, surface, sphere;
        return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__generator"])(this, function (_b) {
            switch (_b.label) {
                case 0:
                    smoothness = props.smoothness;
                    return [4 /*yield*/, Object(_util_gaussian__WEBPACK_IMPORTED_MODULE_3__["computeUnitGaussianDensity"])(structure, unit, props, ctx.webgl).runInContext(ctx.runtime)];
                case 1:
                    _a = _b.sent(), transform = _a.transform, field = _a.field, idField = _a.idField, radiusFactor = _a.radiusFactor;
                    params = {
                        isoLevel: Math.exp(-smoothness) / radiusFactor,
                        scalarField: field,
                        idField: idField
                    };
                    return [4 /*yield*/, Object(_mol_geo_util_marching_cubes_algorithm__WEBPACK_IMPORTED_MODULE_5__["computeMarchingCubesMesh"])(params, mesh).runAsChild(ctx.runtime)];
                case 2:
                    surface = _b.sent();
                    _mol_geo_geometry_mesh_mesh__WEBPACK_IMPORTED_MODULE_4__["Mesh"].transform(surface, transform);
                    if (ctx.webgl && !ctx.webgl.isWebGL2)
                        _mol_geo_geometry_mesh_mesh__WEBPACK_IMPORTED_MODULE_4__["Mesh"].uniformTriangleGroup(surface);
                    sphere = _mol_math_geometry__WEBPACK_IMPORTED_MODULE_11__["Sphere3D"].expand(Object(_mol_math_geometry__WEBPACK_IMPORTED_MODULE_11__["Sphere3D"])(), unit.boundary.sphere, props.radiusOffset + Object(_util_common__WEBPACK_IMPORTED_MODULE_13__["getUnitExtraRadius"])(unit));
                    surface.setBoundingSphere(sphere);
                    return [2 /*return*/, surface];
            }
        });
    });
}
function GaussianSurfaceMeshVisual(materialId) {
    return Object(_units_visual__WEBPACK_IMPORTED_MODULE_2__["UnitsMeshVisual"])({
        defaultProps: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_1__["ParamDefinition"].getDefaultValues(GaussianSurfaceMeshParams),
        createGeometry: createGaussianSurfaceMesh,
        createLocationIterator: _util_element__WEBPACK_IMPORTED_MODULE_6__["ElementIterator"].fromGroup,
        getLoci: _util_element__WEBPACK_IMPORTED_MODULE_6__["getElementLoci"],
        eachLocation: _util_element__WEBPACK_IMPORTED_MODULE_6__["eachElement"],
        setUpdateState: function (state, newProps, currentProps) {
            if (newProps.resolution !== currentProps.resolution)
                state.createGeometry = true;
            if (newProps.radiusOffset !== currentProps.radiusOffset)
                state.createGeometry = true;
            if (newProps.smoothness !== currentProps.smoothness)
                state.createGeometry = true;
            if (newProps.ignoreHydrogens !== currentProps.ignoreHydrogens)
                state.createGeometry = true;
            if (newProps.traceOnly !== currentProps.traceOnly)
                state.createGeometry = true;
            if (newProps.includeParent !== currentProps.includeParent)
                state.createGeometry = true;
        },
        mustRecreate: function (props, webgl) {
            return props.useGpu && !!webgl;
        }
    }, materialId);
}
//
function createStructureGaussianSurfaceMesh(ctx, structure, theme, props, mesh) {
    return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"])(this, void 0, void 0, function () {
        var smoothness, _a, transform, field, idField, radiusFactor, params, surface, sphere;
        return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__generator"])(this, function (_b) {
            switch (_b.label) {
                case 0:
                    smoothness = props.smoothness;
                    return [4 /*yield*/, Object(_util_gaussian__WEBPACK_IMPORTED_MODULE_3__["computeStructureGaussianDensity"])(structure, props, ctx.webgl).runInContext(ctx.runtime)];
                case 1:
                    _a = _b.sent(), transform = _a.transform, field = _a.field, idField = _a.idField, radiusFactor = _a.radiusFactor;
                    params = {
                        isoLevel: Math.exp(-smoothness) / radiusFactor,
                        scalarField: field,
                        idField: idField
                    };
                    return [4 /*yield*/, Object(_mol_geo_util_marching_cubes_algorithm__WEBPACK_IMPORTED_MODULE_5__["computeMarchingCubesMesh"])(params, mesh).runAsChild(ctx.runtime)];
                case 2:
                    surface = _b.sent();
                    _mol_geo_geometry_mesh_mesh__WEBPACK_IMPORTED_MODULE_4__["Mesh"].transform(surface, transform);
                    if (ctx.webgl && !ctx.webgl.isWebGL2)
                        _mol_geo_geometry_mesh_mesh__WEBPACK_IMPORTED_MODULE_4__["Mesh"].uniformTriangleGroup(surface);
                    sphere = _mol_math_geometry__WEBPACK_IMPORTED_MODULE_11__["Sphere3D"].expand(Object(_mol_math_geometry__WEBPACK_IMPORTED_MODULE_11__["Sphere3D"])(), structure.boundary.sphere, props.radiusOffset + Object(_util_common__WEBPACK_IMPORTED_MODULE_13__["getStructureExtraRadius"])(structure));
                    surface.setBoundingSphere(sphere);
                    return [2 /*return*/, surface];
            }
        });
    });
}
function StructureGaussianSurfaceMeshVisual(materialId) {
    return Object(_complex_visual__WEBPACK_IMPORTED_MODULE_12__["ComplexMeshVisual"])({
        defaultProps: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_1__["ParamDefinition"].getDefaultValues(StructureGaussianSurfaceMeshParams),
        createGeometry: createStructureGaussianSurfaceMesh,
        createLocationIterator: _util_element__WEBPACK_IMPORTED_MODULE_6__["ElementIterator"].fromStructure,
        getLoci: _util_element__WEBPACK_IMPORTED_MODULE_6__["getSerialElementLoci"],
        eachLocation: _util_element__WEBPACK_IMPORTED_MODULE_6__["eachSerialElement"],
        setUpdateState: function (state, newProps, currentProps) {
            if (newProps.resolution !== currentProps.resolution)
                state.createGeometry = true;
            if (newProps.radiusOffset !== currentProps.radiusOffset)
                state.createGeometry = true;
            if (newProps.smoothness !== currentProps.smoothness)
                state.createGeometry = true;
            if (newProps.ignoreHydrogens !== currentProps.ignoreHydrogens)
                state.createGeometry = true;
            if (newProps.traceOnly !== currentProps.traceOnly)
                state.createGeometry = true;
        },
        mustRecreate: function (props, webgl) {
            return props.useGpu && !!webgl;
        }
    }, materialId);
}
//
var GaussianSurfaceName = 'gaussian-surface';
function createGaussianSurfaceTextureMesh(ctx, unit, structure, theme, props, textureMesh) {
    return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"])(this, void 0, void 0, function () {
        var _a, namedTextures, resources, _b, colorBufferFloat, textureFloat, colorBufferHalfFloat, textureHalfFloat, densityTextureData, isoLevel, activeVoxelsTex, compacted, gv, boundingSphere, surface;
        return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__generator"])(this, function (_c) {
            switch (_c.label) {
                case 0:
                    if (!ctx.webgl)
                        throw new Error('webgl context required to create gaussian surface texture-mesh');
                    _a = ctx.webgl, namedTextures = _a.namedTextures, resources = _a.resources, _b = _a.extensions, colorBufferFloat = _b.colorBufferFloat, textureFloat = _b.textureFloat, colorBufferHalfFloat = _b.colorBufferHalfFloat, textureHalfFloat = _b.textureHalfFloat;
                    if (!namedTextures[GaussianSurfaceName]) {
                        namedTextures[GaussianSurfaceName] = colorBufferHalfFloat && textureHalfFloat
                            ? resources.texture('image-float16', 'rgba', 'fp16', 'linear')
                            : colorBufferFloat && textureFloat
                                ? resources.texture('image-float32', 'rgba', 'float', 'linear')
                                : resources.texture('image-uint8', 'rgba', 'ubyte', 'linear');
                    }
                    return [4 /*yield*/, Object(_util_gaussian__WEBPACK_IMPORTED_MODULE_3__["computeUnitGaussianDensityTexture2d"])(structure, unit, true, props, ctx.webgl, namedTextures[GaussianSurfaceName]).runInContext(ctx.runtime)];
                case 1:
                    densityTextureData = _c.sent();
                    isoLevel = Math.exp(-props.smoothness) / densityTextureData.radiusFactor;
                    activeVoxelsTex = Object(_mol_gl_compute_marching_cubes_active_voxels__WEBPACK_IMPORTED_MODULE_8__["calcActiveVoxels"])(ctx.webgl, densityTextureData.texture, densityTextureData.gridDim, densityTextureData.gridTexDim, isoLevel, densityTextureData.gridTexScale);
                    compacted = Object(_mol_gl_compute_histogram_pyramid_reduction__WEBPACK_IMPORTED_MODULE_9__["createHistogramPyramid"])(ctx.webgl, activeVoxelsTex, densityTextureData.gridTexScale, densityTextureData.gridTexDim);
                    gv = Object(_mol_gl_compute_marching_cubes_isosurface__WEBPACK_IMPORTED_MODULE_10__["createIsosurfaceBuffers"])(ctx.webgl, activeVoxelsTex, densityTextureData.texture, compacted, densityTextureData.gridDim, densityTextureData.gridTexDim, densityTextureData.transform, isoLevel, textureMesh ? textureMesh.vertexGroupTexture.ref.value : undefined, textureMesh ? textureMesh.normalTexture.ref.value : undefined);
                    boundingSphere = _mol_math_geometry__WEBPACK_IMPORTED_MODULE_11__["Sphere3D"].expand(Object(_mol_math_geometry__WEBPACK_IMPORTED_MODULE_11__["Sphere3D"])(), unit.boundary.sphere, props.radiusOffset + Object(_util_common__WEBPACK_IMPORTED_MODULE_13__["getStructureExtraRadius"])(structure));
                    surface = _mol_geo_geometry_texture_mesh_texture_mesh__WEBPACK_IMPORTED_MODULE_7__["TextureMesh"].create(gv.vertexCount, 1, gv.vertexGroupTexture, gv.normalTexture, boundingSphere, textureMesh);
                    // console.log({
                    //     renderables: ctx.webgl.namedComputeRenderables,
                    //     framebuffers: ctx.webgl.namedFramebuffers,
                    //     textures: ctx.webgl.namedTextures,
                    // });
                    // ctx.webgl.waitForGpuCommandsCompleteSync();
                    return [2 /*return*/, surface];
            }
        });
    });
}
function GaussianSurfaceTextureMeshVisual(materialId) {
    return Object(_units_visual__WEBPACK_IMPORTED_MODULE_2__["UnitsTextureMeshVisual"])({
        defaultProps: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_1__["ParamDefinition"].getDefaultValues(GaussianSurfaceMeshParams),
        createGeometry: createGaussianSurfaceTextureMesh,
        createLocationIterator: _util_element__WEBPACK_IMPORTED_MODULE_6__["ElementIterator"].fromGroup,
        getLoci: _util_element__WEBPACK_IMPORTED_MODULE_6__["getElementLoci"],
        eachLocation: _util_element__WEBPACK_IMPORTED_MODULE_6__["eachElement"],
        setUpdateState: function (state, newProps, currentProps) {
            if (newProps.resolution !== currentProps.resolution)
                state.createGeometry = true;
            if (newProps.radiusOffset !== currentProps.radiusOffset)
                state.createGeometry = true;
            if (newProps.smoothness !== currentProps.smoothness)
                state.createGeometry = true;
            if (newProps.ignoreHydrogens !== currentProps.ignoreHydrogens)
                state.createGeometry = true;
            if (newProps.traceOnly !== currentProps.traceOnly)
                state.createGeometry = true;
            if (newProps.includeParent !== currentProps.includeParent)
                state.createGeometry = true;
        },
        mustRecreate: function (props, webgl) {
            return !props.useGpu || !webgl;
        },
        dispose: function (geometry) {
            geometry.normalTexture.ref.value.destroy();
            geometry.vertexGroupTexture.ref.value.destroy();
        }
    }, materialId);
}
//
function createStructureGaussianSurfaceTextureMesh(ctx, structure, theme, props, textureMesh) {
    return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"])(this, void 0, void 0, function () {
        var _a, namedTextures, resources, _b, colorBufferFloat, textureFloat, colorBufferHalfFloat, textureHalfFloat, densityTextureData, isoLevel, activeVoxelsTex, compacted, gv, boundingSphere, surface;
        return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__generator"])(this, function (_c) {
            switch (_c.label) {
                case 0:
                    if (!ctx.webgl)
                        throw new Error('webgl context required to create structure gaussian surface texture-mesh');
                    _a = ctx.webgl, namedTextures = _a.namedTextures, resources = _a.resources, _b = _a.extensions, colorBufferFloat = _b.colorBufferFloat, textureFloat = _b.textureFloat, colorBufferHalfFloat = _b.colorBufferHalfFloat, textureHalfFloat = _b.textureHalfFloat;
                    if (!namedTextures[GaussianSurfaceName]) {
                        namedTextures[GaussianSurfaceName] = colorBufferHalfFloat && textureHalfFloat
                            ? resources.texture('image-float16', 'rgba', 'fp16', 'linear')
                            : colorBufferFloat && textureFloat
                                ? resources.texture('image-float32', 'rgba', 'float', 'linear')
                                : resources.texture('image-uint8', 'rgba', 'ubyte', 'linear');
                    }
                    return [4 /*yield*/, Object(_util_gaussian__WEBPACK_IMPORTED_MODULE_3__["computeStructureGaussianDensityTexture2d"])(structure, true, props, ctx.webgl, namedTextures[GaussianSurfaceName]).runInContext(ctx.runtime)];
                case 1:
                    densityTextureData = _c.sent();
                    isoLevel = Math.exp(-props.smoothness) / densityTextureData.radiusFactor;
                    activeVoxelsTex = Object(_mol_gl_compute_marching_cubes_active_voxels__WEBPACK_IMPORTED_MODULE_8__["calcActiveVoxels"])(ctx.webgl, densityTextureData.texture, densityTextureData.gridDim, densityTextureData.gridTexDim, isoLevel, densityTextureData.gridTexScale);
                    compacted = Object(_mol_gl_compute_histogram_pyramid_reduction__WEBPACK_IMPORTED_MODULE_9__["createHistogramPyramid"])(ctx.webgl, activeVoxelsTex, densityTextureData.gridTexScale, densityTextureData.gridTexDim);
                    gv = Object(_mol_gl_compute_marching_cubes_isosurface__WEBPACK_IMPORTED_MODULE_10__["createIsosurfaceBuffers"])(ctx.webgl, activeVoxelsTex, densityTextureData.texture, compacted, densityTextureData.gridDim, densityTextureData.gridTexDim, densityTextureData.transform, isoLevel, textureMesh ? textureMesh.vertexGroupTexture.ref.value : undefined, textureMesh ? textureMesh.normalTexture.ref.value : undefined);
                    boundingSphere = _mol_math_geometry__WEBPACK_IMPORTED_MODULE_11__["Sphere3D"].expand(Object(_mol_math_geometry__WEBPACK_IMPORTED_MODULE_11__["Sphere3D"])(), structure.boundary.sphere, props.radiusOffset + Object(_util_common__WEBPACK_IMPORTED_MODULE_13__["getStructureExtraRadius"])(structure));
                    surface = _mol_geo_geometry_texture_mesh_texture_mesh__WEBPACK_IMPORTED_MODULE_7__["TextureMesh"].create(gv.vertexCount, 1, gv.vertexGroupTexture, gv.normalTexture, boundingSphere, textureMesh);
                    // console.log({
                    //     renderables: ctx.webgl.namedComputeRenderables,
                    //     framebuffers: ctx.webgl.namedFramebuffers,
                    //     textures: ctx.webgl.namedTextures,
                    // });
                    // ctx.webgl.waitForGpuCommandsCompleteSync();
                    return [2 /*return*/, surface];
            }
        });
    });
}
function StructureGaussianSurfaceTextureMeshVisual(materialId) {
    return Object(_complex_visual__WEBPACK_IMPORTED_MODULE_12__["ComplexTextureMeshVisual"])({
        defaultProps: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_1__["ParamDefinition"].getDefaultValues(StructureGaussianSurfaceMeshParams),
        createGeometry: createStructureGaussianSurfaceTextureMesh,
        createLocationIterator: _util_element__WEBPACK_IMPORTED_MODULE_6__["ElementIterator"].fromStructure,
        getLoci: _util_element__WEBPACK_IMPORTED_MODULE_6__["getSerialElementLoci"],
        eachLocation: _util_element__WEBPACK_IMPORTED_MODULE_6__["eachSerialElement"],
        setUpdateState: function (state, newProps, currentProps) {
            if (newProps.resolution !== currentProps.resolution)
                state.createGeometry = true;
            if (newProps.radiusOffset !== currentProps.radiusOffset)
                state.createGeometry = true;
            if (newProps.smoothness !== currentProps.smoothness)
                state.createGeometry = true;
            if (newProps.ignoreHydrogens !== currentProps.ignoreHydrogens)
                state.createGeometry = true;
            if (newProps.traceOnly !== currentProps.traceOnly)
                state.createGeometry = true;
        },
        mustRecreate: function (props, webgl) {
            return !props.useGpu || !webgl;
        },
        dispose: function (geometry) {
            geometry.normalTexture.ref.value.destroy();
            geometry.vertexGroupTexture.ref.value.destroy();
        }
    }, materialId);
}
//# sourceMappingURL=gaussian-surface-mesh.js.map

/***/ }),

/***/ "./lib/mol-repr/structure/visual/gaussian-surface-wireframe.js":
/*!*********************************************************************!*\
  !*** ./lib/mol-repr/structure/visual/gaussian-surface-wireframe.js ***!
  \*********************************************************************/
/*! exports provided: GaussianWireframeParams, GaussianWireframeVisual */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "GaussianWireframeParams", function() { return GaussianWireframeParams; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "GaussianWireframeVisual", function() { return GaussianWireframeVisual; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../../mol-util/param-definition */ "./lib/mol-util/param-definition.js");
/* harmony import */ var _mol_geo_geometry_lines_lines__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../../mol-geo/geometry/lines/lines */ "./lib/mol-geo/geometry/lines/lines.js");
/* harmony import */ var _util_gaussian__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./util/gaussian */ "./lib/mol-repr/structure/visual/util/gaussian.js");
/* harmony import */ var _mol_geo_util_marching_cubes_algorithm__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../../mol-geo/util/marching-cubes/algorithm */ "./lib/mol-geo/util/marching-cubes/algorithm.js");
/* harmony import */ var _units_visual__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../units-visual */ "./lib/mol-repr/structure/units-visual.js");
/* harmony import */ var _util_element__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ./util/element */ "./lib/mol-repr/structure/visual/util/element.js");
/* harmony import */ var _mol_math_geometry__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../../../mol-math/geometry */ "./lib/mol-math/geometry.js");
/* harmony import */ var _util_common__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ./util/common */ "./lib/mol-repr/structure/visual/util/common.js");
/**
 * Copyright (c) 2018-2021 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */









function createGaussianWireframe(ctx, unit, structure, theme, props, lines) {
    return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"])(this, void 0, void 0, function () {
        var smoothness, _a, transform, field, idField, params, wireframe, sphere;
        return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__generator"])(this, function (_b) {
            switch (_b.label) {
                case 0:
                    smoothness = props.smoothness;
                    return [4 /*yield*/, Object(_util_gaussian__WEBPACK_IMPORTED_MODULE_3__["computeUnitGaussianDensity"])(structure, unit, props, ctx.webgl).runInContext(ctx.runtime)];
                case 1:
                    _a = _b.sent(), transform = _a.transform, field = _a.field, idField = _a.idField;
                    params = {
                        isoLevel: Math.exp(-smoothness),
                        scalarField: field,
                        idField: idField
                    };
                    return [4 /*yield*/, Object(_mol_geo_util_marching_cubes_algorithm__WEBPACK_IMPORTED_MODULE_4__["computeMarchingCubesLines"])(params, lines).runAsChild(ctx.runtime)];
                case 2:
                    wireframe = _b.sent();
                    _mol_geo_geometry_lines_lines__WEBPACK_IMPORTED_MODULE_2__["Lines"].transform(wireframe, transform);
                    sphere = _mol_math_geometry__WEBPACK_IMPORTED_MODULE_7__["Sphere3D"].expand(Object(_mol_math_geometry__WEBPACK_IMPORTED_MODULE_7__["Sphere3D"])(), unit.boundary.sphere, props.radiusOffset + Object(_util_common__WEBPACK_IMPORTED_MODULE_8__["getUnitExtraRadius"])(unit));
                    wireframe.setBoundingSphere(sphere);
                    return [2 /*return*/, wireframe];
            }
        });
    });
}
var GaussianWireframeParams = Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, _units_visual__WEBPACK_IMPORTED_MODULE_5__["UnitsLinesParams"]), _util_gaussian__WEBPACK_IMPORTED_MODULE_3__["GaussianDensityParams"]), { sizeFactor: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_1__["ParamDefinition"].Numeric(3, { min: 0, max: 10, step: 0.1 }), lineSizeAttenuation: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_1__["ParamDefinition"].Boolean(false), ignoreHydrogens: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_1__["ParamDefinition"].Boolean(false) });
function GaussianWireframeVisual(materialId) {
    return Object(_units_visual__WEBPACK_IMPORTED_MODULE_5__["UnitsLinesVisual"])({
        defaultProps: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_1__["ParamDefinition"].getDefaultValues(GaussianWireframeParams),
        createGeometry: createGaussianWireframe,
        createLocationIterator: _util_element__WEBPACK_IMPORTED_MODULE_6__["ElementIterator"].fromGroup,
        getLoci: _util_element__WEBPACK_IMPORTED_MODULE_6__["getElementLoci"],
        eachLocation: _util_element__WEBPACK_IMPORTED_MODULE_6__["eachElement"],
        setUpdateState: function (state, newProps, currentProps) {
            if (newProps.resolution !== currentProps.resolution)
                state.createGeometry = true;
            if (newProps.radiusOffset !== currentProps.radiusOffset)
                state.createGeometry = true;
            if (newProps.smoothness !== currentProps.smoothness)
                state.createGeometry = true;
            if (newProps.ignoreHydrogens !== currentProps.ignoreHydrogens)
                state.createGeometry = true;
            if (newProps.traceOnly !== currentProps.traceOnly)
                state.createGeometry = true;
            if (newProps.includeParent !== currentProps.includeParent)
                state.createGeometry = true;
        }
    }, materialId);
}
//# sourceMappingURL=gaussian-surface-wireframe.js.map

/***/ }),

/***/ "./lib/mol-repr/structure/visual/label-text.js":
/*!*****************************************************!*\
  !*** ./lib/mol-repr/structure/visual/label-text.js ***!
  \*****************************************************/
/*! exports provided: LabelTextParams, LabelTextVisual */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "LabelTextParams", function() { return LabelTextParams; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "LabelTextVisual", function() { return LabelTextVisual; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../../mol-util/param-definition */ "./lib/mol-util/param-definition.js");
/* harmony import */ var _mol_model_structure__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../../mol-model/structure */ "./lib/mol-model/structure.js");
/* harmony import */ var _mol_geo_geometry_text_text_builder__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../../mol-geo/geometry/text/text-builder */ "./lib/mol-geo/geometry/text/text-builder.js");
/* harmony import */ var _complex_visual__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../complex-visual */ "./lib/mol-repr/structure/complex-visual.js");
/* harmony import */ var _util_element__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./util/element */ "./lib/mol-repr/structure/visual/util/element.js");
/* harmony import */ var _mol_util_color_names__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../../../mol-util/color/names */ "./lib/mol-util/color/names.js");
/* harmony import */ var _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../../../mol-math/linear-algebra */ "./lib/mol-math/linear-algebra.js");
/* harmony import */ var _mol_theme_size_physical__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ../../../mol-theme/size/physical */ "./lib/mol-theme/size/physical.js");
/* harmony import */ var _mol_math_geometry_boundary_helper__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ../../../mol-math/geometry/boundary-helper */ "./lib/mol-math/geometry/boundary-helper.js");
/**
 * Copyright (c) 2019-2020 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 * @author David Sehnal <david.sehnal@gmail.com>
 */










var LabelTextParams = Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, _complex_visual__WEBPACK_IMPORTED_MODULE_4__["ComplexTextParams"]), { background: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_1__["ParamDefinition"].Boolean(true), backgroundMargin: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_1__["ParamDefinition"].Numeric(0, { min: 0, max: 1, step: 0.01 }), backgroundColor: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_1__["ParamDefinition"].Color(_mol_util_color_names__WEBPACK_IMPORTED_MODULE_6__["ColorNames"].black), backgroundOpacity: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_1__["ParamDefinition"].Numeric(0.5, { min: 0, max: 1, step: 0.01 }), level: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_1__["ParamDefinition"].Select('residue', [['chain', 'Chain'], ['residue', 'Residue'], ['element', 'Element']]), chainScale: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_1__["ParamDefinition"].Numeric(10, { min: 0, max: 20, step: 0.1 }), residueScale: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_1__["ParamDefinition"].Numeric(1, { min: 0, max: 20, step: 0.1 }), elementScale: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_1__["ParamDefinition"].Numeric(0.5, { min: 0, max: 20, step: 0.1 }) });
function LabelTextVisual(materialId) {
    return Object(_complex_visual__WEBPACK_IMPORTED_MODULE_4__["ComplexTextVisual"])({
        defaultProps: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_1__["ParamDefinition"].getDefaultValues(LabelTextParams),
        createGeometry: createLabelText,
        createLocationIterator: _util_element__WEBPACK_IMPORTED_MODULE_5__["ElementIterator"].fromStructure,
        getLoci: _util_element__WEBPACK_IMPORTED_MODULE_5__["getSerialElementLoci"],
        eachLocation: _util_element__WEBPACK_IMPORTED_MODULE_5__["eachSerialElement"],
        setUpdateState: function (state, newProps, currentProps) {
            state.createGeometry = (newProps.level !== currentProps.level ||
                (newProps.level === 'chain' && newProps.chainScale !== currentProps.chainScale) ||
                (newProps.level === 'residue' && newProps.residueScale !== currentProps.residueScale) ||
                (newProps.level === 'element' && newProps.elementScale !== currentProps.elementScale));
        }
    }, materialId);
}
function createLabelText(ctx, structure, theme, props, text) {
    switch (props.level) {
        case 'chain': return createChainText(ctx, structure, theme, props, text);
        case 'residue': return createResidueText(ctx, structure, theme, props, text);
        case 'element': return createElementText(ctx, structure, theme, props, text);
    }
}
//
var tmpVec = Object(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_7__["Vec3"])();
var boundaryHelper = new _mol_math_geometry_boundary_helper__WEBPACK_IMPORTED_MODULE_9__["BoundaryHelper"]('98');
function createChainText(ctx, structure, theme, props, text) {
    var l = _mol_model_structure__WEBPACK_IMPORTED_MODULE_2__["StructureElement"].Location.create(structure);
    var units = structure.units, serialMapping = structure.serialMapping;
    var _a = _mol_model_structure__WEBPACK_IMPORTED_MODULE_2__["StructureProperties"].chain, auth_asym_id = _a.auth_asym_id, label_asym_id = _a.label_asym_id;
    var cumulativeUnitElementCount = serialMapping.cumulativeUnitElementCount;
    var count = units.length;
    var chainScale = props.chainScale;
    var builder = _mol_geo_geometry_text_text_builder__WEBPACK_IMPORTED_MODULE_3__["TextBuilder"].create(props, count, count / 2, text);
    for (var i = 0, il = units.length; i < il; ++i) {
        var unit = units[i];
        l.unit = unit;
        l.element = unit.elements[0];
        var _b = unit.lookup3d.boundary.sphere, center = _b.center, radius = _b.radius;
        _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_7__["Vec3"].transformMat4(tmpVec, center, unit.conformation.operator.matrix);
        var authId = auth_asym_id(l);
        var labelId = label_asym_id(l);
        var text_1 = authId === labelId ? labelId : labelId + " [" + authId + "]";
        builder.add(text_1, tmpVec[0], tmpVec[1], tmpVec[2], radius, chainScale, cumulativeUnitElementCount[i]);
    }
    return builder.getText();
}
function createResidueText(ctx, structure, theme, props, text) {
    var l = _mol_model_structure__WEBPACK_IMPORTED_MODULE_2__["StructureElement"].Location.create(structure);
    var units = structure.units, serialMapping = structure.serialMapping;
    var label_comp_id = _mol_model_structure__WEBPACK_IMPORTED_MODULE_2__["StructureProperties"].atom.label_comp_id;
    var auth_seq_id = _mol_model_structure__WEBPACK_IMPORTED_MODULE_2__["StructureProperties"].residue.auth_seq_id;
    var cumulativeUnitElementCount = serialMapping.cumulativeUnitElementCount;
    var count = structure.polymerResidueCount * 2;
    var residueScale = props.residueScale;
    var builder = _mol_geo_geometry_text_text_builder__WEBPACK_IMPORTED_MODULE_3__["TextBuilder"].create(props, count, count / 2, text);
    for (var i = 0, il = units.length; i < il; ++i) {
        var unit = units[i];
        var pos = unit.conformation.position;
        var elements = unit.elements;
        l.unit = unit;
        l.element = unit.elements[0];
        var residueIndex = unit.model.atomicHierarchy.residueAtomSegments.index;
        var groupOffset = cumulativeUnitElementCount[i];
        var j = 0, jl = elements.length;
        while (j < jl) {
            var start = j, rI = residueIndex[elements[j]];
            j++;
            while (j < jl && residueIndex[elements[j]] === rI)
                j++;
            boundaryHelper.reset();
            for (var eI = start; eI < j; eI++) {
                pos(elements[eI], tmpVec);
                boundaryHelper.includePosition(tmpVec);
            }
            boundaryHelper.finishedIncludeStep();
            for (var eI = start; eI < j; eI++) {
                pos(elements[eI], tmpVec);
                boundaryHelper.radiusPosition(tmpVec);
            }
            l.element = elements[start];
            var _a = boundaryHelper.getSphere(), center = _a.center, radius = _a.radius;
            var authSeqId = auth_seq_id(l);
            var compId = label_comp_id(l);
            var text_2 = compId + " " + authSeqId;
            builder.add(text_2, center[0], center[1], center[2], radius, residueScale, groupOffset + start);
        }
    }
    return builder.getText();
}
function createElementText(ctx, structure, theme, props, text) {
    var l = _mol_model_structure__WEBPACK_IMPORTED_MODULE_2__["StructureElement"].Location.create(structure);
    var units = structure.units, serialMapping = structure.serialMapping;
    var _a = _mol_model_structure__WEBPACK_IMPORTED_MODULE_2__["StructureProperties"].atom, label_atom_id = _a.label_atom_id, label_alt_id = _a.label_alt_id;
    var cumulativeUnitElementCount = serialMapping.cumulativeUnitElementCount;
    var sizeTheme = Object(_mol_theme_size_physical__WEBPACK_IMPORTED_MODULE_8__["PhysicalSizeTheme"])({}, { scale: 1 });
    var count = structure.elementCount;
    var elementScale = props.elementScale;
    var builder = _mol_geo_geometry_text_text_builder__WEBPACK_IMPORTED_MODULE_3__["TextBuilder"].create(props, count, count / 2, text);
    for (var i = 0, il = units.length; i < il; ++i) {
        var unit = units[i];
        var pos = unit.conformation.position;
        var elements = unit.elements;
        l.unit = unit;
        var groupOffset = cumulativeUnitElementCount[i];
        for (var j = 0, _j = elements.length; j < _j; j++) {
            l.element = elements[j];
            pos(l.element, tmpVec);
            var atomId = label_atom_id(l);
            var altId = label_alt_id(l);
            var text_3 = altId ? atomId + "%" + altId : atomId;
            builder.add(text_3, tmpVec[0], tmpVec[1], tmpVec[2], sizeTheme.size(l), elementScale, groupOffset + j);
        }
    }
    return builder.getText();
}
//# sourceMappingURL=label-text.js.map

/***/ }),

/***/ "./lib/mol-repr/structure/visual/molecular-surface-mesh.js":
/*!*****************************************************************!*\
  !*** ./lib/mol-repr/structure/visual/molecular-surface-mesh.js ***!
  \*****************************************************************/
/*! exports provided: MolecularSurfaceMeshParams, MolecularSurfaceMeshVisual */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MolecularSurfaceMeshParams", function() { return MolecularSurfaceMeshParams; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MolecularSurfaceMeshVisual", function() { return MolecularSurfaceMeshVisual; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../../mol-util/param-definition */ "./lib/mol-util/param-definition.js");
/* harmony import */ var _units_visual__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../units-visual */ "./lib/mol-repr/structure/units-visual.js");
/* harmony import */ var _mol_math_geometry_molecular_surface__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../../mol-math/geometry/molecular-surface */ "./lib/mol-math/geometry/molecular-surface.js");
/* harmony import */ var _mol_geo_geometry_mesh_mesh__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../../mol-geo/geometry/mesh/mesh */ "./lib/mol-geo/geometry/mesh/mesh.js");
/* harmony import */ var _util_molecular_surface__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./util/molecular-surface */ "./lib/mol-repr/structure/visual/util/molecular-surface.js");
/* harmony import */ var _mol_geo_util_marching_cubes_algorithm__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../../../mol-geo/util/marching-cubes/algorithm */ "./lib/mol-geo/util/marching-cubes/algorithm.js");
/* harmony import */ var _util_element__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ./util/element */ "./lib/mol-repr/structure/visual/util/element.js");
/* harmony import */ var _util_common__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ./util/common */ "./lib/mol-repr/structure/visual/util/common.js");
/* harmony import */ var _mol_math_geometry__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ../../../mol-math/geometry */ "./lib/mol-math/geometry.js");
/**
 * Copyright (c) 2019-2020 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */










var MolecularSurfaceMeshParams = Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, _units_visual__WEBPACK_IMPORTED_MODULE_2__["UnitsMeshParams"]), _mol_math_geometry_molecular_surface__WEBPACK_IMPORTED_MODULE_3__["MolecularSurfaceCalculationParams"]), _util_common__WEBPACK_IMPORTED_MODULE_8__["CommonSurfaceParams"]);
//
function createMolecularSurfaceMesh(ctx, unit, structure, theme, props, mesh) {
    return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"])(this, void 0, void 0, function () {
        var _a, transform, field, idField, params, surface, sphere;
        return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__generator"])(this, function (_b) {
            switch (_b.label) {
                case 0: return [4 /*yield*/, Object(_util_molecular_surface__WEBPACK_IMPORTED_MODULE_5__["computeUnitMolecularSurface"])(structure, unit, props).runInContext(ctx.runtime)];
                case 1:
                    _a = _b.sent(), transform = _a.transform, field = _a.field, idField = _a.idField;
                    params = {
                        isoLevel: props.probeRadius,
                        scalarField: field,
                        idField: idField
                    };
                    return [4 /*yield*/, Object(_mol_geo_util_marching_cubes_algorithm__WEBPACK_IMPORTED_MODULE_6__["computeMarchingCubesMesh"])(params, mesh).runAsChild(ctx.runtime)];
                case 2:
                    surface = _b.sent();
                    _mol_geo_geometry_mesh_mesh__WEBPACK_IMPORTED_MODULE_4__["Mesh"].transform(surface, transform);
                    if (ctx.webgl && !ctx.webgl.isWebGL2)
                        _mol_geo_geometry_mesh_mesh__WEBPACK_IMPORTED_MODULE_4__["Mesh"].uniformTriangleGroup(surface);
                    sphere = _mol_math_geometry__WEBPACK_IMPORTED_MODULE_9__["Sphere3D"].expand(Object(_mol_math_geometry__WEBPACK_IMPORTED_MODULE_9__["Sphere3D"])(), unit.boundary.sphere, props.probeRadius + Object(_util_common__WEBPACK_IMPORTED_MODULE_8__["getUnitExtraRadius"])(unit));
                    surface.setBoundingSphere(sphere);
                    return [2 /*return*/, surface];
            }
        });
    });
}
function MolecularSurfaceMeshVisual(materialId) {
    return Object(_units_visual__WEBPACK_IMPORTED_MODULE_2__["UnitsMeshVisual"])({
        defaultProps: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_1__["ParamDefinition"].getDefaultValues(MolecularSurfaceMeshParams),
        createGeometry: createMolecularSurfaceMesh,
        createLocationIterator: _util_element__WEBPACK_IMPORTED_MODULE_7__["ElementIterator"].fromGroup,
        getLoci: _util_element__WEBPACK_IMPORTED_MODULE_7__["getElementLoci"],
        eachLocation: _util_element__WEBPACK_IMPORTED_MODULE_7__["eachElement"],
        setUpdateState: function (state, newProps, currentProps) {
            if (newProps.resolution !== currentProps.resolution)
                state.createGeometry = true;
            if (newProps.probeRadius !== currentProps.probeRadius)
                state.createGeometry = true;
            if (newProps.probePositions !== currentProps.probePositions)
                state.createGeometry = true;
            if (newProps.ignoreHydrogens !== currentProps.ignoreHydrogens)
                state.createGeometry = true;
            if (newProps.includeParent !== currentProps.includeParent)
                state.createGeometry = true;
        }
    }, materialId);
}
//# sourceMappingURL=molecular-surface-mesh.js.map

/***/ }),

/***/ "./lib/mol-repr/structure/visual/molecular-surface-wireframe.js":
/*!**********************************************************************!*\
  !*** ./lib/mol-repr/structure/visual/molecular-surface-wireframe.js ***!
  \**********************************************************************/
/*! exports provided: MolecularSurfaceWireframeParams, MolecularSurfaceWireframeVisual */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MolecularSurfaceWireframeParams", function() { return MolecularSurfaceWireframeParams; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MolecularSurfaceWireframeVisual", function() { return MolecularSurfaceWireframeVisual; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../../mol-util/param-definition */ "./lib/mol-util/param-definition.js");
/* harmony import */ var _units_visual__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../units-visual */ "./lib/mol-repr/structure/units-visual.js");
/* harmony import */ var _mol_math_geometry_molecular_surface__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../../mol-math/geometry/molecular-surface */ "./lib/mol-math/geometry/molecular-surface.js");
/* harmony import */ var _mol_geo_geometry_lines_lines__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../../mol-geo/geometry/lines/lines */ "./lib/mol-geo/geometry/lines/lines.js");
/* harmony import */ var _util_molecular_surface__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./util/molecular-surface */ "./lib/mol-repr/structure/visual/util/molecular-surface.js");
/* harmony import */ var _mol_geo_util_marching_cubes_algorithm__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../../../mol-geo/util/marching-cubes/algorithm */ "./lib/mol-geo/util/marching-cubes/algorithm.js");
/* harmony import */ var _util_element__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ./util/element */ "./lib/mol-repr/structure/visual/util/element.js");
/* harmony import */ var _util_common__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ./util/common */ "./lib/mol-repr/structure/visual/util/common.js");
/* harmony import */ var _mol_math_geometry__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ../../../mol-math/geometry */ "./lib/mol-math/geometry.js");
/**
 * Copyright (c) 2019-2020 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */










var MolecularSurfaceWireframeParams = Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, _units_visual__WEBPACK_IMPORTED_MODULE_2__["UnitsLinesParams"]), _mol_math_geometry_molecular_surface__WEBPACK_IMPORTED_MODULE_3__["MolecularSurfaceCalculationParams"]), _util_common__WEBPACK_IMPORTED_MODULE_8__["CommonSurfaceParams"]), { sizeFactor: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_1__["ParamDefinition"].Numeric(1.5, { min: 0, max: 10, step: 0.1 }) });
//
function createMolecularSurfaceWireframe(ctx, unit, structure, theme, props, lines) {
    return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"])(this, void 0, void 0, function () {
        var _a, transform, field, idField, params, wireframe, sphere;
        return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__generator"])(this, function (_b) {
            switch (_b.label) {
                case 0: return [4 /*yield*/, Object(_util_molecular_surface__WEBPACK_IMPORTED_MODULE_5__["computeUnitMolecularSurface"])(structure, unit, props).runInContext(ctx.runtime)];
                case 1:
                    _a = _b.sent(), transform = _a.transform, field = _a.field, idField = _a.idField;
                    params = {
                        isoLevel: props.probeRadius,
                        scalarField: field,
                        idField: idField
                    };
                    return [4 /*yield*/, Object(_mol_geo_util_marching_cubes_algorithm__WEBPACK_IMPORTED_MODULE_6__["computeMarchingCubesLines"])(params, lines).runAsChild(ctx.runtime)];
                case 2:
                    wireframe = _b.sent();
                    _mol_geo_geometry_lines_lines__WEBPACK_IMPORTED_MODULE_4__["Lines"].transform(wireframe, transform);
                    sphere = _mol_math_geometry__WEBPACK_IMPORTED_MODULE_9__["Sphere3D"].expand(Object(_mol_math_geometry__WEBPACK_IMPORTED_MODULE_9__["Sphere3D"])(), unit.boundary.sphere, props.probeRadius + Object(_util_common__WEBPACK_IMPORTED_MODULE_8__["getUnitExtraRadius"])(unit));
                    wireframe.setBoundingSphere(sphere);
                    return [2 /*return*/, wireframe];
            }
        });
    });
}
function MolecularSurfaceWireframeVisual(materialId) {
    return Object(_units_visual__WEBPACK_IMPORTED_MODULE_2__["UnitsLinesVisual"])({
        defaultProps: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_1__["ParamDefinition"].getDefaultValues(MolecularSurfaceWireframeParams),
        createGeometry: createMolecularSurfaceWireframe,
        createLocationIterator: _util_element__WEBPACK_IMPORTED_MODULE_7__["ElementIterator"].fromGroup,
        getLoci: _util_element__WEBPACK_IMPORTED_MODULE_7__["getElementLoci"],
        eachLocation: _util_element__WEBPACK_IMPORTED_MODULE_7__["eachElement"],
        setUpdateState: function (state, newProps, currentProps) {
            if (newProps.resolution !== currentProps.resolution)
                state.createGeometry = true;
            if (newProps.probeRadius !== currentProps.probeRadius)
                state.createGeometry = true;
            if (newProps.probePositions !== currentProps.probePositions)
                state.createGeometry = true;
            if (newProps.ignoreHydrogens !== currentProps.ignoreHydrogens)
                state.createGeometry = true;
            if (newProps.includeParent !== currentProps.includeParent)
                state.createGeometry = true;
        }
    }, materialId);
}
//# sourceMappingURL=molecular-surface-wireframe.js.map

/***/ }),

/***/ "./lib/mol-repr/structure/visual/nucleotide-block-mesh.js":
/*!****************************************************************!*\
  !*** ./lib/mol-repr/structure/visual/nucleotide-block-mesh.js ***!
  \****************************************************************/
/*! exports provided: NucleotideBlockMeshParams, DefaultNucleotideBlockMeshProps, NucleotideBlockParams, NucleotideBlockVisual */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "NucleotideBlockMeshParams", function() { return NucleotideBlockMeshParams; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DefaultNucleotideBlockMeshProps", function() { return DefaultNucleotideBlockMeshProps; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "NucleotideBlockParams", function() { return NucleotideBlockParams; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "NucleotideBlockVisual", function() { return NucleotideBlockVisual; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../../mol-util/param-definition */ "./lib/mol-util/param-definition.js");
/* harmony import */ var _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../../mol-math/linear-algebra */ "./lib/mol-math/linear-algebra.js");
/* harmony import */ var _mol_geo_primitive_box__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../../mol-geo/primitive/box */ "./lib/mol-geo/primitive/box.js");
/* harmony import */ var _mol_model_structure__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../../mol-model/structure */ "./lib/mol-model/structure.js");
/* harmony import */ var _mol_geo_geometry_mesh_mesh__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../../mol-geo/geometry/mesh/mesh */ "./lib/mol-geo/geometry/mesh/mesh.js");
/* harmony import */ var _mol_geo_geometry_mesh_mesh_builder__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../../../mol-geo/geometry/mesh/mesh-builder */ "./lib/mol-geo/geometry/mesh/mesh-builder.js");
/* harmony import */ var _mol_data_int__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../../../mol-data/int */ "./lib/mol-data/int.js");
/* harmony import */ var _mol_model_structure_model_types__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ../../../mol-model/structure/model/types */ "./lib/mol-model/structure/model/types.js");
/* harmony import */ var _mol_geo_geometry_mesh_builder_cylinder__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ../../../mol-geo/geometry/mesh/builder/cylinder */ "./lib/mol-geo/geometry/mesh/builder/cylinder.js");
/* harmony import */ var _units_visual__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ../units-visual */ "./lib/mol-repr/structure/units-visual.js");
/* harmony import */ var _util_nucleotide__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ./util/nucleotide */ "./lib/mol-repr/structure/visual/util/nucleotide.js");
/* harmony import */ var _mol_geo_geometry_base__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! ../../../mol-geo/geometry/base */ "./lib/mol-geo/geometry/base.js");
/* harmony import */ var _mol_math_geometry__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! ../../../mol-math/geometry */ "./lib/mol-math/geometry.js");
/**
 * Copyright (c) 2018-2019 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */














// TODO support blocks for multiple locations (including from microheterogeneity)
var p1 = _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_2__["Vec3"].zero();
var p2 = _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_2__["Vec3"].zero();
var p3 = _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_2__["Vec3"].zero();
var p4 = _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_2__["Vec3"].zero();
var p5 = _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_2__["Vec3"].zero();
var p6 = _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_2__["Vec3"].zero();
var v12 = _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_2__["Vec3"].zero();
var v34 = _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_2__["Vec3"].zero();
var vC = _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_2__["Vec3"].zero();
var center = _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_2__["Vec3"].zero();
var t = _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_2__["Mat4"].identity();
var sVec = _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_2__["Vec3"].zero();
var box = Object(_mol_geo_primitive_box__WEBPACK_IMPORTED_MODULE_3__["Box"])();
var NucleotideBlockMeshParams = {
    sizeFactor: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_1__["ParamDefinition"].Numeric(0.2, { min: 0, max: 10, step: 0.01 }),
    radialSegments: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_1__["ParamDefinition"].Numeric(16, { min: 2, max: 56, step: 2 }, _mol_geo_geometry_base__WEBPACK_IMPORTED_MODULE_12__["BaseGeometry"].CustomQualityParamInfo),
};
var DefaultNucleotideBlockMeshProps = _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_1__["ParamDefinition"].getDefaultValues(NucleotideBlockMeshParams);
function createNucleotideBlockMesh(ctx, unit, structure, theme, props, mesh) {
    if (!_mol_model_structure__WEBPACK_IMPORTED_MODULE_4__["Unit"].isAtomic(unit))
        return _mol_geo_geometry_mesh_mesh__WEBPACK_IMPORTED_MODULE_5__["Mesh"].createEmpty(mesh);
    var nucleotideElementCount = unit.nucleotideElements.length;
    if (!nucleotideElementCount)
        return _mol_geo_geometry_mesh_mesh__WEBPACK_IMPORTED_MODULE_5__["Mesh"].createEmpty(mesh);
    var sizeFactor = props.sizeFactor, radialSegments = props.radialSegments;
    var vertexCount = nucleotideElementCount * (box.vertices.length / 3 + radialSegments * 2);
    var builderState = _mol_geo_geometry_mesh_mesh_builder__WEBPACK_IMPORTED_MODULE_6__["MeshBuilder"].createState(vertexCount, vertexCount / 4, mesh);
    var elements = unit.elements, model = unit.model;
    var _a = model.atomicHierarchy, chainAtomSegments = _a.chainAtomSegments, residueAtomSegments = _a.residueAtomSegments, atoms = _a.atoms, atomicIndex = _a.index;
    var _b = model.atomicHierarchy.derived.residue, moleculeType = _b.moleculeType, traceElementIndex = _b.traceElementIndex;
    var label_comp_id = atoms.label_comp_id;
    var pos = unit.conformation.invariantPosition;
    var chainIt = _mol_data_int__WEBPACK_IMPORTED_MODULE_7__["Segmentation"].transientSegments(chainAtomSegments, elements);
    var residueIt = _mol_data_int__WEBPACK_IMPORTED_MODULE_7__["Segmentation"].transientSegments(residueAtomSegments, elements);
    var cylinderProps = { radiusTop: 1 * sizeFactor, radiusBottom: 1 * sizeFactor, radialSegments: radialSegments, bottomCap: true };
    var i = 0;
    while (chainIt.hasNext) {
        residueIt.setSegment(chainIt.move());
        while (residueIt.hasNext) {
            var residueIndex = residueIt.move().index;
            if (Object(_mol_model_structure_model_types__WEBPACK_IMPORTED_MODULE_8__["isNucleic"])(moleculeType[residueIndex])) {
                var compId = label_comp_id.value(residueAtomSegments.offsets[residueIndex]);
                var idx1 = -1, idx2 = -1, idx3 = -1, idx4 = -1, idx5 = -1, idx6 = -1;
                var width = 4.5, height = 4.5, depth = 2.5 * sizeFactor;
                var isPurine = Object(_mol_model_structure_model_types__WEBPACK_IMPORTED_MODULE_8__["isPurineBase"])(compId);
                var isPyrimidine = Object(_mol_model_structure_model_types__WEBPACK_IMPORTED_MODULE_8__["isPyrimidineBase"])(compId);
                if (!isPurine && !isPyrimidine) {
                    // detect Purine or Pyrimidin based on geometry
                    var idxC4 = atomicIndex.findAtomOnResidue(residueIndex, 'C4');
                    var idxN9 = atomicIndex.findAtomOnResidue(residueIndex, 'N9');
                    if (idxC4 !== -1 && idxN9 !== -1 && _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_2__["Vec3"].distance(pos(idxC4, p1), pos(idxN9, p2)) < 1.6) {
                        isPurine = true;
                    }
                    else {
                        isPyrimidine = true;
                    }
                }
                if (isPurine) {
                    height = 4.5;
                    idx1 = atomicIndex.findAtomOnResidue(residueIndex, 'N1');
                    idx2 = atomicIndex.findAtomOnResidue(residueIndex, 'C4');
                    idx3 = atomicIndex.findAtomOnResidue(residueIndex, 'C6');
                    idx4 = atomicIndex.findAtomOnResidue(residueIndex, 'C2');
                    idx5 = atomicIndex.findAtomOnResidue(residueIndex, 'N9');
                    idx6 = traceElementIndex[residueIndex];
                }
                else if (isPyrimidine) {
                    height = 3.0;
                    idx1 = atomicIndex.findAtomOnResidue(residueIndex, 'N3');
                    idx2 = atomicIndex.findAtomOnResidue(residueIndex, 'C6');
                    idx3 = atomicIndex.findAtomOnResidue(residueIndex, 'C4');
                    idx4 = atomicIndex.findAtomOnResidue(residueIndex, 'C2');
                    idx5 = atomicIndex.findAtomOnResidue(residueIndex, 'N1');
                    if (idx5 === -1) {
                        // modified ring, e.g. DZ
                        idx5 = atomicIndex.findAtomOnResidue(residueIndex, 'C1');
                    }
                    idx6 = traceElementIndex[residueIndex];
                }
                if (idx5 !== -1 && idx6 !== -1) {
                    pos(idx5, p5);
                    pos(idx6, p6);
                    builderState.currentGroup = i;
                    Object(_mol_geo_geometry_mesh_builder_cylinder__WEBPACK_IMPORTED_MODULE_9__["addCylinder"])(builderState, p5, p6, 1, cylinderProps);
                    if (idx1 !== -1 && idx2 !== -1 && idx3 !== -1 && idx4 !== -1) {
                        pos(idx1, p1);
                        pos(idx2, p2);
                        pos(idx3, p3);
                        pos(idx4, p4);
                        _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_2__["Vec3"].normalize(v12, _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_2__["Vec3"].sub(v12, p2, p1));
                        _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_2__["Vec3"].normalize(v34, _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_2__["Vec3"].sub(v34, p4, p3));
                        _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_2__["Vec3"].normalize(vC, _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_2__["Vec3"].cross(vC, v12, v34));
                        _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_2__["Mat4"].targetTo(t, p1, p2, vC);
                        _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_2__["Vec3"].scaleAndAdd(center, p1, v12, height / 2 - 0.2);
                        _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_2__["Mat4"].scale(t, t, _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_2__["Vec3"].set(sVec, width, depth, height));
                        _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_2__["Mat4"].setTranslation(t, center);
                        _mol_geo_geometry_mesh_mesh_builder__WEBPACK_IMPORTED_MODULE_6__["MeshBuilder"].addPrimitive(builderState, t, box);
                    }
                }
                ++i;
            }
        }
    }
    var m = _mol_geo_geometry_mesh_mesh_builder__WEBPACK_IMPORTED_MODULE_6__["MeshBuilder"].getMesh(builderState);
    var sphere = _mol_math_geometry__WEBPACK_IMPORTED_MODULE_13__["Sphere3D"].expand(Object(_mol_math_geometry__WEBPACK_IMPORTED_MODULE_13__["Sphere3D"])(), unit.boundary.sphere, 1 * props.sizeFactor);
    m.setBoundingSphere(sphere);
    return m;
}
var NucleotideBlockParams = Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, _units_visual__WEBPACK_IMPORTED_MODULE_10__["UnitsMeshParams"]), NucleotideBlockMeshParams);
function NucleotideBlockVisual(materialId) {
    return Object(_units_visual__WEBPACK_IMPORTED_MODULE_10__["UnitsMeshVisual"])({
        defaultProps: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_1__["ParamDefinition"].getDefaultValues(NucleotideBlockParams),
        createGeometry: createNucleotideBlockMesh,
        createLocationIterator: _util_nucleotide__WEBPACK_IMPORTED_MODULE_11__["NucleotideLocationIterator"].fromGroup,
        getLoci: _util_nucleotide__WEBPACK_IMPORTED_MODULE_11__["getNucleotideElementLoci"],
        eachLocation: _util_nucleotide__WEBPACK_IMPORTED_MODULE_11__["eachNucleotideElement"],
        setUpdateState: function (state, newProps, currentProps) {
            state.createGeometry = (newProps.sizeFactor !== currentProps.sizeFactor ||
                newProps.radialSegments !== currentProps.radialSegments);
        }
    }, materialId);
}
//# sourceMappingURL=nucleotide-block-mesh.js.map

/***/ }),

/***/ "./lib/mol-repr/structure/visual/nucleotide-ring-mesh.js":
/*!***************************************************************!*\
  !*** ./lib/mol-repr/structure/visual/nucleotide-ring-mesh.js ***!
  \***************************************************************/
/*! exports provided: NucleotideRingMeshParams, DefaultNucleotideRingMeshProps, NucleotideRingParams, NucleotideRingVisual */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "NucleotideRingMeshParams", function() { return NucleotideRingMeshParams; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DefaultNucleotideRingMeshProps", function() { return DefaultNucleotideRingMeshProps; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "NucleotideRingParams", function() { return NucleotideRingParams; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "NucleotideRingVisual", function() { return NucleotideRingVisual; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../../mol-util/param-definition */ "./lib/mol-util/param-definition.js");
/* harmony import */ var _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../../mol-math/linear-algebra */ "./lib/mol-math/linear-algebra.js");
/* harmony import */ var _mol_model_structure__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../../mol-model/structure */ "./lib/mol-model/structure.js");
/* harmony import */ var _mol_geo_geometry_mesh_mesh__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../../mol-geo/geometry/mesh/mesh */ "./lib/mol-geo/geometry/mesh/mesh.js");
/* harmony import */ var _mol_geo_geometry_mesh_mesh_builder__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../../mol-geo/geometry/mesh/mesh-builder */ "./lib/mol-geo/geometry/mesh/mesh-builder.js");
/* harmony import */ var _mol_data_int__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../../../mol-data/int */ "./lib/mol-data/int.js");
/* harmony import */ var _mol_model_structure_model_types__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../../../mol-model/structure/model/types */ "./lib/mol-model/structure/model/types.js");
/* harmony import */ var _mol_geo_geometry_mesh_builder_cylinder__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ../../../mol-geo/geometry/mesh/builder/cylinder */ "./lib/mol-geo/geometry/mesh/builder/cylinder.js");
/* harmony import */ var _mol_geo_geometry_mesh_builder_sphere__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ../../../mol-geo/geometry/mesh/builder/sphere */ "./lib/mol-geo/geometry/mesh/builder/sphere.js");
/* harmony import */ var _units_visual__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ../units-visual */ "./lib/mol-repr/structure/units-visual.js");
/* harmony import */ var _util_nucleotide__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ./util/nucleotide */ "./lib/mol-repr/structure/visual/util/nucleotide.js");
/* harmony import */ var _mol_geo_geometry_base__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! ../../../mol-geo/geometry/base */ "./lib/mol-geo/geometry/base.js");
/* harmony import */ var _mol_math_geometry__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! ../../../mol-math/geometry */ "./lib/mol-math/geometry.js");
/**
 * Copyright (c) 2019 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */














// TODO support rings for multiple locations (including from microheterogeneity)
var pTrace = _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_2__["Vec3"].zero();
var pN1 = _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_2__["Vec3"].zero();
var pC2 = _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_2__["Vec3"].zero();
var pN3 = _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_2__["Vec3"].zero();
var pC4 = _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_2__["Vec3"].zero();
var pC5 = _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_2__["Vec3"].zero();
var pC6 = _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_2__["Vec3"].zero();
var pN7 = _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_2__["Vec3"].zero();
var pC8 = _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_2__["Vec3"].zero();
var pN9 = _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_2__["Vec3"].zero();
var normal = _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_2__["Vec3"].zero();
var NucleotideRingMeshParams = {
    sizeFactor: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_1__["ParamDefinition"].Numeric(0.2, { min: 0, max: 10, step: 0.01 }),
    radialSegments: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_1__["ParamDefinition"].Numeric(16, { min: 2, max: 56, step: 2 }, _mol_geo_geometry_base__WEBPACK_IMPORTED_MODULE_12__["BaseGeometry"].CustomQualityParamInfo),
    detail: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_1__["ParamDefinition"].Numeric(0, { min: 0, max: 3, step: 1 }, _mol_geo_geometry_base__WEBPACK_IMPORTED_MODULE_12__["BaseGeometry"].CustomQualityParamInfo),
};
var DefaultNucleotideRingMeshProps = _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_1__["ParamDefinition"].getDefaultValues(NucleotideRingMeshParams);
var positionsRing5_6 = new Float32Array(2 * 9 * 3);
var stripIndicesRing5_6 = new Uint32Array([0, 1, 2, 3, 4, 5, 6, 7, 16, 17, 14, 15, 12, 13, 8, 9, 10, 11, 0, 1]);
var fanIndicesTopRing5_6 = new Uint32Array([8, 12, 14, 16, 6, 4, 2, 0, 10]);
var fanIndicesBottomRing5_6 = new Uint32Array([9, 11, 1, 3, 5, 7, 17, 15, 13]);
var positionsRing6 = new Float32Array(2 * 6 * 3);
var stripIndicesRing6 = new Uint32Array([0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 0, 1]);
var fanIndicesTopRing6 = new Uint32Array([0, 10, 8, 6, 4, 2]);
var fanIndicesBottomRing6 = new Uint32Array([1, 3, 5, 7, 9, 11]);
var tmpShiftV = _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_2__["Vec3"].zero();
function shiftPositions(out, dir) {
    var positions = [];
    for (var _i = 2; _i < arguments.length; _i++) {
        positions[_i - 2] = arguments[_i];
    }
    for (var i = 0, il = positions.length; i < il; ++i) {
        var v = positions[i];
        _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_2__["Vec3"].toArray(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_2__["Vec3"].add(tmpShiftV, v, dir), out, (i * 2) * 3);
        _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_2__["Vec3"].toArray(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_2__["Vec3"].sub(tmpShiftV, v, dir), out, (i * 2 + 1) * 3);
    }
}
function createNucleotideRingMesh(ctx, unit, structure, theme, props, mesh) {
    if (!_mol_model_structure__WEBPACK_IMPORTED_MODULE_3__["Unit"].isAtomic(unit))
        return _mol_geo_geometry_mesh_mesh__WEBPACK_IMPORTED_MODULE_4__["Mesh"].createEmpty(mesh);
    var nucleotideElementCount = unit.nucleotideElements.length;
    if (!nucleotideElementCount)
        return _mol_geo_geometry_mesh_mesh__WEBPACK_IMPORTED_MODULE_4__["Mesh"].createEmpty(mesh);
    var sizeFactor = props.sizeFactor, radialSegments = props.radialSegments, detail = props.detail;
    var vertexCount = nucleotideElementCount * (26 + radialSegments * 2);
    var builderState = _mol_geo_geometry_mesh_mesh_builder__WEBPACK_IMPORTED_MODULE_5__["MeshBuilder"].createState(vertexCount, vertexCount / 4, mesh);
    var elements = unit.elements, model = unit.model;
    var _a = model.atomicHierarchy, chainAtomSegments = _a.chainAtomSegments, residueAtomSegments = _a.residueAtomSegments, atoms = _a.atoms, atomicIndex = _a.index;
    var _b = model.atomicHierarchy.derived.residue, moleculeType = _b.moleculeType, traceElementIndex = _b.traceElementIndex;
    var label_comp_id = atoms.label_comp_id;
    var pos = unit.conformation.invariantPosition;
    var chainIt = _mol_data_int__WEBPACK_IMPORTED_MODULE_6__["Segmentation"].transientSegments(chainAtomSegments, elements);
    var residueIt = _mol_data_int__WEBPACK_IMPORTED_MODULE_6__["Segmentation"].transientSegments(residueAtomSegments, elements);
    var radius = 1 * sizeFactor;
    var halfThickness = 1.25 * sizeFactor;
    var cylinderProps = { radiusTop: 1 * sizeFactor, radiusBottom: 1 * sizeFactor, radialSegments: radialSegments };
    var i = 0;
    while (chainIt.hasNext) {
        residueIt.setSegment(chainIt.move());
        while (residueIt.hasNext) {
            var residueIndex = residueIt.move().index;
            if (Object(_mol_model_structure_model_types__WEBPACK_IMPORTED_MODULE_7__["isNucleic"])(moleculeType[residueIndex])) {
                var compId = label_comp_id.value(residueAtomSegments.offsets[residueIndex]);
                var idxTrace = -1, idxN1 = -1, idxC2 = -1, idxN3 = -1, idxC4 = -1, idxC5 = -1, idxC6 = -1, idxN7 = -1, idxC8 = -1, idxN9 = -1;
                builderState.currentGroup = i;
                var isPurine = Object(_mol_model_structure_model_types__WEBPACK_IMPORTED_MODULE_7__["isPurineBase"])(compId);
                var isPyrimidine = Object(_mol_model_structure_model_types__WEBPACK_IMPORTED_MODULE_7__["isPyrimidineBase"])(compId);
                if (!isPurine && !isPyrimidine) {
                    // detect Purine or Pyrimidin based on geometry
                    var idxC4_1 = atomicIndex.findAtomOnResidue(residueIndex, 'C4');
                    var idxN9_1 = atomicIndex.findAtomOnResidue(residueIndex, 'N9');
                    if (idxC4_1 !== -1 && idxN9_1 !== -1 && _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_2__["Vec3"].distance(pos(idxC4_1, pC4), pos(idxN9_1, pN9)) < 1.6) {
                        isPurine = true;
                    }
                    else {
                        isPyrimidine = true;
                    }
                }
                if (isPurine) {
                    idxTrace = traceElementIndex[residueIndex];
                    idxN1 = atomicIndex.findAtomOnResidue(residueIndex, 'N1');
                    idxC2 = atomicIndex.findAtomOnResidue(residueIndex, 'C2');
                    idxN3 = atomicIndex.findAtomOnResidue(residueIndex, 'N3');
                    idxC4 = atomicIndex.findAtomOnResidue(residueIndex, 'C4');
                    idxC5 = atomicIndex.findAtomOnResidue(residueIndex, 'C5');
                    if (idxC5 === -1) {
                        // modified ring, e.g. DP
                        idxC5 = atomicIndex.findAtomOnResidue(residueIndex, 'N5');
                    }
                    idxC6 = atomicIndex.findAtomOnResidue(residueIndex, 'C6');
                    idxN7 = atomicIndex.findAtomOnResidue(residueIndex, 'N7');
                    if (idxN7 === -1) {
                        // modified ring, e.g. DP
                        idxN7 = atomicIndex.findAtomOnResidue(residueIndex, 'C7');
                    }
                    idxC8 = atomicIndex.findAtomOnResidue(residueIndex, 'C8');
                    idxN9 = atomicIndex.findAtomOnResidue(residueIndex, 'N9');
                    if (idxN9 !== -1 && idxTrace !== -1) {
                        pos(idxN9, pN9);
                        pos(idxTrace, pTrace);
                        builderState.currentGroup = i;
                        Object(_mol_geo_geometry_mesh_builder_cylinder__WEBPACK_IMPORTED_MODULE_8__["addCylinder"])(builderState, pN9, pTrace, 1, cylinderProps);
                        Object(_mol_geo_geometry_mesh_builder_sphere__WEBPACK_IMPORTED_MODULE_9__["addSphere"])(builderState, pN9, radius, detail);
                    }
                    if (idxN1 !== -1 && idxC2 !== -1 && idxN3 !== -1 && idxC4 !== -1 && idxC5 !== -1 && idxC6 !== -1 && idxN7 !== -1 && idxC8 !== -1 && idxN9 !== -1) {
                        pos(idxN1, pN1);
                        pos(idxC2, pC2);
                        pos(idxN3, pN3);
                        pos(idxC4, pC4);
                        pos(idxC5, pC5);
                        pos(idxC6, pC6);
                        pos(idxN7, pN7);
                        pos(idxC8, pC8);
                        _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_2__["Vec3"].triangleNormal(normal, pN1, pC4, pC5);
                        _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_2__["Vec3"].scale(normal, normal, halfThickness);
                        shiftPositions(positionsRing5_6, normal, pN1, pC2, pN3, pC4, pC5, pC6, pN7, pC8, pN9);
                        _mol_geo_geometry_mesh_mesh_builder__WEBPACK_IMPORTED_MODULE_5__["MeshBuilder"].addTriangleStrip(builderState, positionsRing5_6, stripIndicesRing5_6);
                        _mol_geo_geometry_mesh_mesh_builder__WEBPACK_IMPORTED_MODULE_5__["MeshBuilder"].addTriangleFan(builderState, positionsRing5_6, fanIndicesTopRing5_6);
                        _mol_geo_geometry_mesh_mesh_builder__WEBPACK_IMPORTED_MODULE_5__["MeshBuilder"].addTriangleFan(builderState, positionsRing5_6, fanIndicesBottomRing5_6);
                    }
                }
                else if (isPyrimidine) {
                    idxTrace = traceElementIndex[residueIndex];
                    idxN1 = atomicIndex.findAtomOnResidue(residueIndex, 'N1');
                    if (idxN1 === -1) {
                        // modified ring, e.g. DZ
                        idxN1 = atomicIndex.findAtomOnResidue(residueIndex, 'C1');
                    }
                    idxC2 = atomicIndex.findAtomOnResidue(residueIndex, 'C2');
                    idxN3 = atomicIndex.findAtomOnResidue(residueIndex, 'N3');
                    idxC4 = atomicIndex.findAtomOnResidue(residueIndex, 'C4');
                    idxC5 = atomicIndex.findAtomOnResidue(residueIndex, 'C5');
                    idxC6 = atomicIndex.findAtomOnResidue(residueIndex, 'C6');
                    if (idxN1 !== -1 && idxTrace !== -1) {
                        pos(idxN1, pN1);
                        pos(idxTrace, pTrace);
                        builderState.currentGroup = i;
                        Object(_mol_geo_geometry_mesh_builder_cylinder__WEBPACK_IMPORTED_MODULE_8__["addCylinder"])(builderState, pN1, pTrace, 1, cylinderProps);
                        Object(_mol_geo_geometry_mesh_builder_sphere__WEBPACK_IMPORTED_MODULE_9__["addSphere"])(builderState, pN1, radius, detail);
                    }
                    if (idxN1 !== -1 && idxC2 !== -1 && idxN3 !== -1 && idxC4 !== -1 && idxC5 !== -1 && idxC6 !== -1) {
                        pos(idxC2, pC2);
                        pos(idxN3, pN3);
                        pos(idxC4, pC4);
                        pos(idxC5, pC5);
                        pos(idxC6, pC6);
                        _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_2__["Vec3"].triangleNormal(normal, pN1, pC4, pC5);
                        _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_2__["Vec3"].scale(normal, normal, halfThickness);
                        shiftPositions(positionsRing6, normal, pN1, pC2, pN3, pC4, pC5, pC6);
                        _mol_geo_geometry_mesh_mesh_builder__WEBPACK_IMPORTED_MODULE_5__["MeshBuilder"].addTriangleStrip(builderState, positionsRing6, stripIndicesRing6);
                        _mol_geo_geometry_mesh_mesh_builder__WEBPACK_IMPORTED_MODULE_5__["MeshBuilder"].addTriangleFan(builderState, positionsRing6, fanIndicesTopRing6);
                        _mol_geo_geometry_mesh_mesh_builder__WEBPACK_IMPORTED_MODULE_5__["MeshBuilder"].addTriangleFan(builderState, positionsRing6, fanIndicesBottomRing6);
                    }
                }
                ++i;
            }
        }
    }
    var m = _mol_geo_geometry_mesh_mesh_builder__WEBPACK_IMPORTED_MODULE_5__["MeshBuilder"].getMesh(builderState);
    var sphere = _mol_math_geometry__WEBPACK_IMPORTED_MODULE_13__["Sphere3D"].expand(Object(_mol_math_geometry__WEBPACK_IMPORTED_MODULE_13__["Sphere3D"])(), unit.boundary.sphere, 1 * props.sizeFactor);
    m.setBoundingSphere(sphere);
    return m;
}
var NucleotideRingParams = Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, _units_visual__WEBPACK_IMPORTED_MODULE_10__["UnitsMeshParams"]), NucleotideRingMeshParams);
function NucleotideRingVisual(materialId) {
    return Object(_units_visual__WEBPACK_IMPORTED_MODULE_10__["UnitsMeshVisual"])({
        defaultProps: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_1__["ParamDefinition"].getDefaultValues(NucleotideRingParams),
        createGeometry: createNucleotideRingMesh,
        createLocationIterator: _util_nucleotide__WEBPACK_IMPORTED_MODULE_11__["NucleotideLocationIterator"].fromGroup,
        getLoci: _util_nucleotide__WEBPACK_IMPORTED_MODULE_11__["getNucleotideElementLoci"],
        eachLocation: _util_nucleotide__WEBPACK_IMPORTED_MODULE_11__["eachNucleotideElement"],
        setUpdateState: function (state, newProps, currentProps) {
            state.createGeometry = (newProps.sizeFactor !== currentProps.sizeFactor ||
                newProps.radialSegments !== currentProps.radialSegments);
        }
    }, materialId);
}
//# sourceMappingURL=nucleotide-ring-mesh.js.map

/***/ }),

/***/ "./lib/mol-repr/structure/visual/orientation-ellipsoid-mesh.js":
/*!*********************************************************************!*\
  !*** ./lib/mol-repr/structure/visual/orientation-ellipsoid-mesh.js ***!
  \*********************************************************************/
/*! exports provided: OrientationEllipsoidMeshParams, OrientationEllipsoidMeshVisual, createOrientationEllipsoidMesh */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "OrientationEllipsoidMeshParams", function() { return OrientationEllipsoidMeshParams; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "OrientationEllipsoidMeshVisual", function() { return OrientationEllipsoidMeshVisual; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createOrientationEllipsoidMesh", function() { return createOrientationEllipsoidMesh; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../../mol-util/param-definition */ "./lib/mol-util/param-definition.js");
/* harmony import */ var _mol_repr_structure_units_visual__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../../mol-repr/structure/units-visual */ "./lib/mol-repr/structure/units-visual.js");
/* harmony import */ var _mol_model_structure__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../../mol-model/structure */ "./lib/mol-model/structure.js");
/* harmony import */ var _mol_geo_geometry_mesh_mesh__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../../mol-geo/geometry/mesh/mesh */ "./lib/mol-geo/geometry/mesh/mesh.js");
/* harmony import */ var _mol_geo_geometry_mesh_mesh_builder__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../../mol-geo/geometry/mesh/mesh-builder */ "./lib/mol-geo/geometry/mesh/mesh-builder.js");
/* harmony import */ var _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../../../mol-math/linear-algebra */ "./lib/mol-math/linear-algebra.js");
/* harmony import */ var _mol_geo_geometry_mesh_builder_ellipsoid__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../../../mol-geo/geometry/mesh/builder/ellipsoid */ "./lib/mol-geo/geometry/mesh/builder/ellipsoid.js");
/* harmony import */ var _mol_math_geometry__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ../../../mol-math/geometry */ "./lib/mol-math/geometry.js");
/* harmony import */ var _mol_data_int__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ../../../mol-data/int */ "./lib/mol-data/int.js");
/* harmony import */ var _mol_model_loci__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ../../../mol-model/loci */ "./lib/mol-model/loci.js");
/* harmony import */ var _mol_geo_util_location_iterator__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ../../../mol-geo/util/location-iterator */ "./lib/mol-geo/util/location-iterator.js");
/* harmony import */ var _mol_geo_geometry_base__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! ../../../mol-geo/geometry/base */ "./lib/mol-geo/geometry/base.js");
/**
 * Copyright (c) 2019 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */













var OrientationEllipsoidMeshParams = Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, _mol_repr_structure_units_visual__WEBPACK_IMPORTED_MODULE_2__["UnitsMeshParams"]), { sizeFactor: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_1__["ParamDefinition"].Numeric(1, { min: 0, max: 2, step: 0.1 }), detail: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_1__["ParamDefinition"].Numeric(0, { min: 0, max: 3, step: 1 }, _mol_geo_geometry_base__WEBPACK_IMPORTED_MODULE_12__["BaseGeometry"].CustomQualityParamInfo) });
function OrientationEllipsoidMeshVisual(materialId) {
    return Object(_mol_repr_structure_units_visual__WEBPACK_IMPORTED_MODULE_2__["UnitsMeshVisual"])({
        defaultProps: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_1__["ParamDefinition"].getDefaultValues(OrientationEllipsoidMeshParams),
        createGeometry: createOrientationEllipsoidMesh,
        createLocationIterator: UnitIterator,
        getLoci: getUnitLoci,
        eachLocation: eachUnit,
        setUpdateState: function (state, newProps, currentProps) {
            state.createGeometry = (newProps.sizeFactor !== currentProps.sizeFactor ||
                newProps.detail !== currentProps.detail);
        }
    }, materialId);
}
function isUnitApplicable(unit) {
    if (_mol_model_structure__WEBPACK_IMPORTED_MODULE_3__["Unit"].Traits.is(unit.traits, 1 /* MultiChain */))
        return false;
    if (_mol_model_structure__WEBPACK_IMPORTED_MODULE_3__["Unit"].Traits.is(unit.traits, 2 /* Partitioned */))
        return false;
    if (_mol_model_structure__WEBPACK_IMPORTED_MODULE_3__["Unit"].isCoarse(unit))
        return true;
    if (unit.elements.length === 0)
        return false;
    unit.model.atomicHierarchy.derived.residue.moleculeType;
    var rI = unit.residueIndex[unit.elements[0]];
    var mt = unit.model.atomicHierarchy.derived.residue.moleculeType[rI];
    if (mt === 3 /* Ion */)
        return false;
    if (mt === 2 /* Water */)
        return false;
    return true;
}
function createOrientationEllipsoidMesh(ctx, unit, structure, theme, props, mesh) {
    if (!isUnitApplicable(unit))
        return _mol_geo_geometry_mesh_mesh__WEBPACK_IMPORTED_MODULE_4__["Mesh"].createEmpty(mesh);
    var detail = props.detail, sizeFactor = props.sizeFactor;
    var vertexCount = 256;
    var builderState = _mol_geo_geometry_mesh_mesh_builder__WEBPACK_IMPORTED_MODULE_5__["MeshBuilder"].createState(vertexCount, vertexCount / 2, mesh);
    var axes = unit.principalAxes.boxAxes;
    var origin = axes.origin, dirA = axes.dirA, dirB = axes.dirB;
    var size = _mol_math_geometry__WEBPACK_IMPORTED_MODULE_8__["Axes3D"].size(Object(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_6__["Vec3"])(), axes);
    _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_6__["Vec3"].scale(size, size, sizeFactor / 2);
    var radiusScale = _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_6__["Vec3"].create(size[2], size[1], size[0]);
    builderState.currentGroup = 0;
    Object(_mol_geo_geometry_mesh_builder_ellipsoid__WEBPACK_IMPORTED_MODULE_7__["addEllipsoid"])(builderState, origin, dirA, dirB, radiusScale, detail + 1);
    var m = _mol_geo_geometry_mesh_mesh_builder__WEBPACK_IMPORTED_MODULE_5__["MeshBuilder"].getMesh(builderState);
    var sphere = _mol_math_geometry__WEBPACK_IMPORTED_MODULE_8__["Sphere3D"].expand(Object(_mol_math_geometry__WEBPACK_IMPORTED_MODULE_8__["Sphere3D"])(), unit.boundary.sphere, 1 * props.sizeFactor);
    m.setBoundingSphere(sphere);
    return m;
}
//
function UnitIterator(structureGroup) {
    var group = structureGroup.group, structure = structureGroup.structure;
    var groupCount = 1;
    var instanceCount = group.units.length;
    var location = _mol_model_structure__WEBPACK_IMPORTED_MODULE_3__["StructureElement"].Location.create(structure);
    var getLocation = function (groupIndex, instanceIndex) {
        var unit = group.units[instanceIndex];
        location.unit = unit;
        location.element = unit.elements[groupIndex];
        return location;
    };
    return Object(_mol_geo_util_location_iterator__WEBPACK_IMPORTED_MODULE_11__["LocationIterator"])(groupCount, instanceCount, 1, getLocation);
}
function getUnitLoci(pickingId, structureGroup, id) {
    var objectId = pickingId.objectId, instanceId = pickingId.instanceId;
    if (id === objectId) {
        var structure = structureGroup.structure, group = structureGroup.group;
        var unit = group.units[instanceId];
        var indices = _mol_data_int__WEBPACK_IMPORTED_MODULE_9__["OrderedSet"].ofBounds(0, unit.elements.length);
        return _mol_model_structure__WEBPACK_IMPORTED_MODULE_3__["StructureElement"].Loci(structure, [{ unit: unit, indices: indices }]);
    }
    return _mol_model_loci__WEBPACK_IMPORTED_MODULE_10__["EmptyLoci"];
}
function eachUnit(loci, structureGroup, apply) {
    var changed = false;
    if (!_mol_model_structure__WEBPACK_IMPORTED_MODULE_3__["StructureElement"].Loci.is(loci))
        return false;
    var structure = structureGroup.structure, group = structureGroup.group;
    if (!_mol_model_structure__WEBPACK_IMPORTED_MODULE_3__["Structure"].areEquivalent(loci.structure, structure))
        return false;
    var elementCount = group.elements.length;
    for (var _i = 0, _a = loci.elements; _i < _a.length; _i++) {
        var e = _a[_i];
        var unitIdx = group.unitIndexMap.get(e.unit.id);
        if (unitIdx !== undefined) {
            if (_mol_data_int__WEBPACK_IMPORTED_MODULE_9__["OrderedSet"].size(e.indices) === elementCount) {
                if (apply(_mol_data_int__WEBPACK_IMPORTED_MODULE_9__["Interval"].ofSingleton(unitIdx)))
                    changed = true;
            }
        }
    }
    return changed;
}
//# sourceMappingURL=orientation-ellipsoid-mesh.js.map

/***/ }),

/***/ "./lib/mol-repr/structure/visual/polymer-direction-wedge.js":
/*!******************************************************************!*\
  !*** ./lib/mol-repr/structure/visual/polymer-direction-wedge.js ***!
  \******************************************************************/
/*! exports provided: PolymerDirectionWedgeParams, DefaultPolymerDirectionWedgeProps, PolymerDirectionParams, PolymerDirectionVisual */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "PolymerDirectionWedgeParams", function() { return PolymerDirectionWedgeParams; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DefaultPolymerDirectionWedgeProps", function() { return DefaultPolymerDirectionWedgeProps; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "PolymerDirectionParams", function() { return PolymerDirectionParams; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "PolymerDirectionVisual", function() { return PolymerDirectionVisual; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../../mol-util/param-definition */ "./lib/mol-util/param-definition.js");
/* harmony import */ var _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../../mol-math/linear-algebra */ "./lib/mol-math/linear-algebra.js");
/* harmony import */ var _mol_geo_primitive_wedge__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../../mol-geo/primitive/wedge */ "./lib/mol-geo/primitive/wedge.js");
/* harmony import */ var _mol_geo_geometry_mesh_mesh__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../../mol-geo/geometry/mesh/mesh */ "./lib/mol-geo/geometry/mesh/mesh.js");
/* harmony import */ var _mol_geo_geometry_mesh_mesh_builder__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../../mol-geo/geometry/mesh/mesh-builder */ "./lib/mol-geo/geometry/mesh/mesh-builder.js");
/* harmony import */ var _util_polymer__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ./util/polymer */ "./lib/mol-repr/structure/visual/util/polymer.js");
/* harmony import */ var _mol_model_structure_model_types__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../../../mol-model/structure/model/types */ "./lib/mol-model/structure/model/types.js");
/* harmony import */ var _units_visual__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ../units-visual */ "./lib/mol-repr/structure/units-visual.js");
/* harmony import */ var _mol_math_geometry__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ../../../mol-math/geometry */ "./lib/mol-math/geometry.js");
/**
 * Copyright (c) 2018 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */










var t = _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_2__["Mat4"].identity();
var sVec = _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_2__["Vec3"].zero();
var n0 = _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_2__["Vec3"].zero();
var n1 = _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_2__["Vec3"].zero();
var upVec = _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_2__["Vec3"].zero();
var depthFactor = 4;
var widthFactor = 4;
var heightFactor = 6;
var wedge = Object(_mol_geo_primitive_wedge__WEBPACK_IMPORTED_MODULE_3__["Wedge"])();
var PolymerDirectionWedgeParams = {
    sizeFactor: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_1__["ParamDefinition"].Numeric(0.2, { min: 0, max: 10, step: 0.01 }),
};
var DefaultPolymerDirectionWedgeProps = _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_1__["ParamDefinition"].getDefaultValues(PolymerDirectionWedgeParams);
function createPolymerDirectionWedgeMesh(ctx, unit, structure, theme, props, mesh) {
    var polymerElementCount = unit.polymerElements.length;
    if (!polymerElementCount)
        return _mol_geo_geometry_mesh_mesh__WEBPACK_IMPORTED_MODULE_4__["Mesh"].createEmpty(mesh);
    var sizeFactor = props.sizeFactor;
    var vertexCount = polymerElementCount * 24;
    var builderState = _mol_geo_geometry_mesh_mesh_builder__WEBPACK_IMPORTED_MODULE_5__["MeshBuilder"].createState(vertexCount, vertexCount / 10, mesh);
    var linearSegments = 1;
    var state = Object(_util_polymer__WEBPACK_IMPORTED_MODULE_6__["createCurveSegmentState"])(linearSegments);
    var normalVectors = state.normalVectors, binormalVectors = state.binormalVectors;
    var i = 0;
    var polymerTraceIt = Object(_util_polymer__WEBPACK_IMPORTED_MODULE_6__["PolymerTraceIterator"])(unit, structure);
    while (polymerTraceIt.hasNext) {
        var v = polymerTraceIt.move();
        builderState.currentGroup = i;
        var isNucleicType = Object(_mol_model_structure_model_types__WEBPACK_IMPORTED_MODULE_7__["isNucleic"])(v.moleculeType);
        var isSheet = _mol_model_structure_model_types__WEBPACK_IMPORTED_MODULE_7__["SecondaryStructureType"].is(v.secStrucType, 4 /* Beta */);
        var tension = (isNucleicType || isSheet) ? 0.5 : 0.9;
        var shift = isNucleicType ? 0.3 : 0.5;
        Object(_util_polymer__WEBPACK_IMPORTED_MODULE_6__["interpolateCurveSegment"])(state, v, tension, shift);
        if ((isSheet && !v.secStrucLast) || !isSheet) {
            var size = theme.size.size(v.center) * sizeFactor;
            var depth = depthFactor * size;
            var width = widthFactor * size;
            var height = heightFactor * size;
            var vectors = isNucleicType ? binormalVectors : normalVectors;
            _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_2__["Vec3"].fromArray(n0, vectors, 0);
            _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_2__["Vec3"].fromArray(n1, vectors, 3);
            _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_2__["Vec3"].normalize(upVec, _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_2__["Vec3"].add(upVec, n0, n1));
            _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_2__["Mat4"].targetTo(t, v.p3, v.p1, upVec);
            _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_2__["Mat4"].mul(t, t, _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_2__["Mat4"].rotY90Z180);
            _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_2__["Mat4"].scale(t, t, _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_2__["Vec3"].set(sVec, height, width, depth));
            _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_2__["Mat4"].setTranslation(t, v.p2);
            _mol_geo_geometry_mesh_mesh_builder__WEBPACK_IMPORTED_MODULE_5__["MeshBuilder"].addPrimitive(builderState, t, wedge);
        }
        ++i;
    }
    var m = _mol_geo_geometry_mesh_mesh_builder__WEBPACK_IMPORTED_MODULE_5__["MeshBuilder"].getMesh(builderState);
    var sphere = _mol_math_geometry__WEBPACK_IMPORTED_MODULE_9__["Sphere3D"].expand(Object(_mol_math_geometry__WEBPACK_IMPORTED_MODULE_9__["Sphere3D"])(), unit.boundary.sphere, 1 * props.sizeFactor);
    m.setBoundingSphere(sphere);
    return m;
}
var PolymerDirectionParams = Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, _units_visual__WEBPACK_IMPORTED_MODULE_8__["UnitsMeshParams"]), PolymerDirectionWedgeParams);
function PolymerDirectionVisual(materialId) {
    return Object(_units_visual__WEBPACK_IMPORTED_MODULE_8__["UnitsMeshVisual"])({
        defaultProps: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_1__["ParamDefinition"].getDefaultValues(PolymerDirectionParams),
        createGeometry: createPolymerDirectionWedgeMesh,
        createLocationIterator: _util_polymer__WEBPACK_IMPORTED_MODULE_6__["PolymerLocationIterator"].fromGroup,
        getLoci: _util_polymer__WEBPACK_IMPORTED_MODULE_6__["getPolymerElementLoci"],
        eachLocation: _util_polymer__WEBPACK_IMPORTED_MODULE_6__["eachPolymerElement"],
        setUpdateState: function (state, newProps, currentProps) {
            state.createGeometry = (newProps.sizeFactor !== currentProps.sizeFactor);
        }
    }, materialId);
}
//# sourceMappingURL=polymer-direction-wedge.js.map

/***/ }),

/***/ "./lib/mol-repr/structure/visual/polymer-gap-cylinder.js":
/*!***************************************************************!*\
  !*** ./lib/mol-repr/structure/visual/polymer-gap-cylinder.js ***!
  \***************************************************************/
/*! exports provided: PolymerGapCylinderParams, DefaultPolymerGapCylinderProps, PolymerGapParams, PolymerGapVisual */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "PolymerGapCylinderParams", function() { return PolymerGapCylinderParams; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DefaultPolymerGapCylinderProps", function() { return DefaultPolymerGapCylinderProps; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "PolymerGapParams", function() { return PolymerGapParams; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "PolymerGapVisual", function() { return PolymerGapVisual; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../../mol-util/param-definition */ "./lib/mol-util/param-definition.js");
/* harmony import */ var _mol_geo_geometry_mesh_mesh__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../../mol-geo/geometry/mesh/mesh */ "./lib/mol-geo/geometry/mesh/mesh.js");
/* harmony import */ var _mol_geo_geometry_mesh_mesh_builder__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../../mol-geo/geometry/mesh/mesh-builder */ "./lib/mol-geo/geometry/mesh/mesh-builder.js");
/* harmony import */ var _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../../mol-math/linear-algebra */ "./lib/mol-math/linear-algebra.js");
/* harmony import */ var _util_polymer__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./util/polymer */ "./lib/mol-repr/structure/visual/util/polymer.js");
/* harmony import */ var _mol_geo_geometry_mesh_builder_cylinder__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../../../mol-geo/geometry/mesh/builder/cylinder */ "./lib/mol-geo/geometry/mesh/builder/cylinder.js");
/* harmony import */ var _units_visual__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../units-visual */ "./lib/mol-repr/structure/units-visual.js");
/* harmony import */ var _mol_geo_geometry_base__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ../../../mol-geo/geometry/base */ "./lib/mol-geo/geometry/base.js");
/* harmony import */ var _mol_math_geometry__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ../../../mol-math/geometry */ "./lib/mol-math/geometry.js");
/**
 * Copyright (c) 2018-2019 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */










// import { TriangularPyramid } from '../../../mol-geo/primitive/pyramid';
var segmentCount = 10;
var PolymerGapCylinderParams = {
    sizeFactor: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_1__["ParamDefinition"].Numeric(0.2, { min: 0, max: 10, step: 0.01 }),
    radialSegments: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_1__["ParamDefinition"].Numeric(16, { min: 2, max: 56, step: 2 }, _mol_geo_geometry_base__WEBPACK_IMPORTED_MODULE_8__["BaseGeometry"].CustomQualityParamInfo),
};
var DefaultPolymerGapCylinderProps = _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_1__["ParamDefinition"].getDefaultValues(PolymerGapCylinderParams);
// const triangularPyramid = TriangularPyramid()
// const t = Mat4.identity()
// const pd = Vec3.zero()
function createPolymerGapCylinderMesh(ctx, unit, structure, theme, props, mesh) {
    var polymerGapCount = unit.gapElements.length;
    if (!polymerGapCount)
        return _mol_geo_geometry_mesh_mesh__WEBPACK_IMPORTED_MODULE_2__["Mesh"].createEmpty(mesh);
    var sizeFactor = props.sizeFactor, radialSegments = props.radialSegments;
    var vertexCountEstimate = segmentCount * radialSegments * 2 * polymerGapCount * 2;
    var builderState = _mol_geo_geometry_mesh_mesh_builder__WEBPACK_IMPORTED_MODULE_3__["MeshBuilder"].createState(vertexCountEstimate, vertexCountEstimate / 10, mesh);
    var pos = unit.conformation.invariantPosition;
    var pA = _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_4__["Vec3"].zero();
    var pB = _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_4__["Vec3"].zero();
    var cylinderProps = {
        radiusTop: 1, radiusBottom: 1, topCap: true, bottomCap: true,
        radialSegments: radialSegments
    };
    var i = 0;
    var polymerGapIt = Object(_util_polymer__WEBPACK_IMPORTED_MODULE_5__["PolymerGapIterator"])(structure, unit);
    while (polymerGapIt.hasNext) {
        var _a = polymerGapIt.move(), centerA = _a.centerA, centerB = _a.centerB;
        if (centerA.element === centerB.element) {
            // TODO
            // builderState.currentGroup = i
            // pos(centerA.element, pA)
            // Vec3.add(pd, pA, Vec3.create(1, 0, 0))
            // Mat4.targetTo(t, pA, pd, Vec3.create(0, 1, 0))
            // Mat4.setTranslation(t, pA)
            // Mat4.scale(t, t, Vec3.create(0.7, 0.7, 2.5))
            // MeshBuilder.addPrimitive(builderState, t, triangularPyramid)
        }
        else {
            pos(centerA.element, pA);
            pos(centerB.element, pB);
            cylinderProps.radiusTop = cylinderProps.radiusBottom = theme.size.size(centerA) * sizeFactor;
            builderState.currentGroup = i;
            Object(_mol_geo_geometry_mesh_builder_cylinder__WEBPACK_IMPORTED_MODULE_6__["addFixedCountDashedCylinder"])(builderState, pA, pB, 0.5, segmentCount, cylinderProps);
            cylinderProps.radiusTop = cylinderProps.radiusBottom = theme.size.size(centerB) * sizeFactor;
            builderState.currentGroup = i + 1;
            Object(_mol_geo_geometry_mesh_builder_cylinder__WEBPACK_IMPORTED_MODULE_6__["addFixedCountDashedCylinder"])(builderState, pB, pA, 0.5, segmentCount, cylinderProps);
        }
        i += 2;
    }
    var m = _mol_geo_geometry_mesh_mesh_builder__WEBPACK_IMPORTED_MODULE_3__["MeshBuilder"].getMesh(builderState);
    var sphere = _mol_math_geometry__WEBPACK_IMPORTED_MODULE_9__["Sphere3D"].expand(Object(_mol_math_geometry__WEBPACK_IMPORTED_MODULE_9__["Sphere3D"])(), unit.boundary.sphere, 1 * props.sizeFactor);
    m.setBoundingSphere(sphere);
    return m;
}
var PolymerGapParams = Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, _units_visual__WEBPACK_IMPORTED_MODULE_7__["UnitsMeshParams"]), PolymerGapCylinderParams);
function PolymerGapVisual(materialId) {
    return Object(_units_visual__WEBPACK_IMPORTED_MODULE_7__["UnitsMeshVisual"])({
        defaultProps: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_1__["ParamDefinition"].getDefaultValues(PolymerGapParams),
        createGeometry: createPolymerGapCylinderMesh,
        createLocationIterator: _util_polymer__WEBPACK_IMPORTED_MODULE_5__["PolymerGapLocationIterator"].fromGroup,
        getLoci: _util_polymer__WEBPACK_IMPORTED_MODULE_5__["getPolymerGapElementLoci"],
        eachLocation: _util_polymer__WEBPACK_IMPORTED_MODULE_5__["eachPolymerGapElement"],
        setUpdateState: function (state, newProps, currentProps) {
            state.createGeometry = (newProps.sizeFactor !== currentProps.sizeFactor ||
                newProps.radialSegments !== currentProps.radialSegments);
        }
    }, materialId);
}
//# sourceMappingURL=polymer-gap-cylinder.js.map

/***/ }),

/***/ "./lib/mol-repr/structure/visual/polymer-trace-mesh.js":
/*!*************************************************************!*\
  !*** ./lib/mol-repr/structure/visual/polymer-trace-mesh.js ***!
  \*************************************************************/
/*! exports provided: PolymerTraceMeshParams, DefaultPolymerTraceMeshProps, PolymerTraceParams, PolymerTraceVisual */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "PolymerTraceMeshParams", function() { return PolymerTraceMeshParams; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DefaultPolymerTraceMeshProps", function() { return DefaultPolymerTraceMeshProps; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "PolymerTraceParams", function() { return PolymerTraceParams; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "PolymerTraceVisual", function() { return PolymerTraceVisual; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../../mol-util/param-definition */ "./lib/mol-util/param-definition.js");
/* harmony import */ var _mol_model_structure__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../../mol-model/structure */ "./lib/mol-model/structure.js");
/* harmony import */ var _mol_geo_geometry_mesh_mesh__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../../mol-geo/geometry/mesh/mesh */ "./lib/mol-geo/geometry/mesh/mesh.js");
/* harmony import */ var _mol_geo_geometry_mesh_mesh_builder__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../../mol-geo/geometry/mesh/mesh-builder */ "./lib/mol-geo/geometry/mesh/mesh-builder.js");
/* harmony import */ var _util_polymer__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./util/polymer */ "./lib/mol-repr/structure/visual/util/polymer.js");
/* harmony import */ var _mol_model_structure_model_types__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../../../mol-model/structure/model/types */ "./lib/mol-model/structure/model/types.js");
/* harmony import */ var _mol_geo_geometry_mesh_builder_sheet__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../../../mol-geo/geometry/mesh/builder/sheet */ "./lib/mol-geo/geometry/mesh/builder/sheet.js");
/* harmony import */ var _mol_geo_geometry_mesh_builder_tube__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ../../../mol-geo/geometry/mesh/builder/tube */ "./lib/mol-geo/geometry/mesh/builder/tube.js");
/* harmony import */ var _units_visual__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ../units-visual */ "./lib/mol-repr/structure/units-visual.js");
/* harmony import */ var _mol_model_props_computed_secondary_structure__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ../../../mol-model-props/computed/secondary-structure */ "./lib/mol-model-props/computed/secondary-structure.js");
/* harmony import */ var _mol_geo_geometry_mesh_builder_ribbon__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ../../../mol-geo/geometry/mesh/builder/ribbon */ "./lib/mol-geo/geometry/mesh/builder/ribbon.js");
/* harmony import */ var _mol_geo_geometry_mesh_builder_sphere__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! ../../../mol-geo/geometry/mesh/builder/sphere */ "./lib/mol-geo/geometry/mesh/builder/sphere.js");
/* harmony import */ var _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! ../../../mol-math/linear-algebra */ "./lib/mol-math/linear-algebra.js");
/* harmony import */ var _mol_geo_geometry_base__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! ../../../mol-geo/geometry/base */ "./lib/mol-geo/geometry/base.js");
/* harmony import */ var _mol_math_geometry__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! ../../../mol-math/geometry */ "./lib/mol-math/geometry.js");
/**
 * Copyright (c) 2018-2019 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */
















var PolymerTraceMeshParams = {
    sizeFactor: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_1__["ParamDefinition"].Numeric(0.2, { min: 0, max: 10, step: 0.01 }),
    aspectRatio: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_1__["ParamDefinition"].Numeric(5, { min: 0.1, max: 10, step: 0.1 }),
    arrowFactor: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_1__["ParamDefinition"].Numeric(1.5, { min: 0, max: 3, step: 0.1 }),
    detail: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_1__["ParamDefinition"].Numeric(0, { min: 0, max: 3, step: 1 }, _mol_geo_geometry_base__WEBPACK_IMPORTED_MODULE_14__["BaseGeometry"].CustomQualityParamInfo),
    linearSegments: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_1__["ParamDefinition"].Numeric(8, { min: 1, max: 48, step: 1 }, _mol_geo_geometry_base__WEBPACK_IMPORTED_MODULE_14__["BaseGeometry"].CustomQualityParamInfo),
    radialSegments: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_1__["ParamDefinition"].Numeric(16, { min: 2, max: 56, step: 2 }, _mol_geo_geometry_base__WEBPACK_IMPORTED_MODULE_14__["BaseGeometry"].CustomQualityParamInfo)
};
var DefaultPolymerTraceMeshProps = _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_1__["ParamDefinition"].getDefaultValues(PolymerTraceMeshParams);
var tmpV1 = Object(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_13__["Vec3"])();
function createPolymerTraceMesh(ctx, unit, structure, theme, props, mesh) {
    var _a, _b, _c;
    var polymerElementCount = unit.polymerElements.length;
    if (!polymerElementCount)
        return _mol_geo_geometry_mesh_mesh__WEBPACK_IMPORTED_MODULE_3__["Mesh"].createEmpty(mesh);
    var sizeFactor = props.sizeFactor, detail = props.detail, linearSegments = props.linearSegments, radialSegments = props.radialSegments, aspectRatio = props.aspectRatio, arrowFactor = props.arrowFactor;
    var vertexCount = linearSegments * radialSegments * polymerElementCount + (radialSegments + 1) * polymerElementCount * 2;
    var builderState = _mol_geo_geometry_mesh_mesh_builder__WEBPACK_IMPORTED_MODULE_4__["MeshBuilder"].createState(vertexCount, vertexCount / 10, mesh);
    var isCoarse = _mol_model_structure__WEBPACK_IMPORTED_MODULE_2__["Unit"].isCoarse(unit);
    var state = Object(_util_polymer__WEBPACK_IMPORTED_MODULE_5__["createCurveSegmentState"])(linearSegments);
    var curvePoints = state.curvePoints, normalVectors = state.normalVectors, binormalVectors = state.binormalVectors, widthValues = state.widthValues, heightValues = state.heightValues;
    var i = 0;
    var polymerTraceIt = Object(_util_polymer__WEBPACK_IMPORTED_MODULE_5__["PolymerTraceIterator"])(unit, structure);
    while (polymerTraceIt.hasNext) {
        var v = polymerTraceIt.move();
        builderState.currentGroup = i;
        var isNucleicType = Object(_mol_model_structure_model_types__WEBPACK_IMPORTED_MODULE_6__["isNucleic"])(v.moleculeType);
        var isSheet = _mol_model_structure_model_types__WEBPACK_IMPORTED_MODULE_6__["SecondaryStructureType"].is(v.secStrucType, 4 /* Beta */);
        var isHelix = _mol_model_structure_model_types__WEBPACK_IMPORTED_MODULE_6__["SecondaryStructureType"].is(v.secStrucType, 2 /* Helix */);
        var tension = isHelix ? _util_polymer__WEBPACK_IMPORTED_MODULE_5__["HelixTension"] : _util_polymer__WEBPACK_IMPORTED_MODULE_5__["StandardTension"];
        var shift = isNucleicType ? _util_polymer__WEBPACK_IMPORTED_MODULE_5__["NucleicShift"] : _util_polymer__WEBPACK_IMPORTED_MODULE_5__["StandardShift"];
        Object(_util_polymer__WEBPACK_IMPORTED_MODULE_5__["interpolateCurveSegment"])(state, v, tension, shift);
        var w0 = theme.size.size(v.centerPrev) * sizeFactor;
        var w1 = theme.size.size(v.center) * sizeFactor;
        var w2 = theme.size.size(v.centerNext) * sizeFactor;
        if (isCoarse) {
            w0 *= aspectRatio / 2;
            w1 *= aspectRatio / 2;
            w2 *= aspectRatio / 2;
        }
        var startCap = v.secStrucFirst || v.coarseBackboneFirst || v.first;
        var endCap = v.secStrucLast || v.coarseBackboneLast || v.last;
        var segmentCount = linearSegments;
        if (v.initial) {
            segmentCount = Math.max(Math.round(linearSegments * shift), 1);
            var offset = linearSegments - segmentCount;
            curvePoints.copyWithin(0, offset * 3);
            binormalVectors.copyWithin(0, offset * 3);
            normalVectors.copyWithin(0, offset * 3);
            _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_13__["Vec3"].fromArray(tmpV1, curvePoints, 3);
            _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_13__["Vec3"].normalize(tmpV1, _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_13__["Vec3"].sub(tmpV1, v.p2, tmpV1));
            _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_13__["Vec3"].scaleAndAdd(tmpV1, v.p2, tmpV1, w1 * _util_polymer__WEBPACK_IMPORTED_MODULE_5__["OverhangFactor"]);
            _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_13__["Vec3"].toArray(tmpV1, curvePoints, 0);
        }
        else if (v.final) {
            segmentCount = Math.max(Math.round(linearSegments * (1 - shift)), 1);
            _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_13__["Vec3"].fromArray(tmpV1, curvePoints, segmentCount * 3 - 3);
            _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_13__["Vec3"].normalize(tmpV1, _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_13__["Vec3"].sub(tmpV1, v.p2, tmpV1));
            _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_13__["Vec3"].scaleAndAdd(tmpV1, v.p2, tmpV1, w1 * _util_polymer__WEBPACK_IMPORTED_MODULE_5__["OverhangFactor"]);
            _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_13__["Vec3"].toArray(tmpV1, curvePoints, segmentCount * 3);
        }
        if (v.initial === true && v.final === true) {
            Object(_mol_geo_geometry_mesh_builder_sphere__WEBPACK_IMPORTED_MODULE_12__["addSphere"])(builderState, v.p2, w1 * 2, detail);
        }
        else if (isSheet) {
            var h0 = w0 * aspectRatio;
            var h1 = w1 * aspectRatio;
            var h2 = w2 * aspectRatio;
            var arrowHeight = v.secStrucLast ? h1 * arrowFactor : 0;
            Object(_util_polymer__WEBPACK_IMPORTED_MODULE_5__["interpolateSizes"])(state, w0, w1, w2, h0, h1, h2, shift);
            if (radialSegments === 2) {
                Object(_mol_geo_geometry_mesh_builder_ribbon__WEBPACK_IMPORTED_MODULE_11__["addRibbon"])(builderState, curvePoints, normalVectors, binormalVectors, segmentCount, widthValues, heightValues, arrowHeight);
            }
            else {
                Object(_mol_geo_geometry_mesh_builder_sheet__WEBPACK_IMPORTED_MODULE_7__["addSheet"])(builderState, curvePoints, normalVectors, binormalVectors, segmentCount, widthValues, heightValues, arrowHeight, startCap, endCap);
            }
        }
        else {
            var h0 = void 0, h1 = void 0, h2 = void 0;
            if (isHelix && !v.isCoarseBackbone) {
                h0 = w0 * aspectRatio;
                h1 = w1 * aspectRatio;
                h2 = w2 * aspectRatio;
            }
            else if (isNucleicType && !v.isCoarseBackbone) {
                h0 = w0 * aspectRatio;
                h1 = w1 * aspectRatio;
                h2 = w2 * aspectRatio;
                _a = [h0, w0], w0 = _a[0], h0 = _a[1];
                _b = [h1, w1], w1 = _b[0], h1 = _b[1];
                _c = [h2, w2], w2 = _c[0], h2 = _c[1];
            }
            else {
                h0 = w0;
                h1 = w1;
                h2 = w2;
            }
            Object(_util_polymer__WEBPACK_IMPORTED_MODULE_5__["interpolateSizes"])(state, w0, w1, w2, h0, h1, h2, shift);
            if (radialSegments === 2) {
                if (isNucleicType && !v.isCoarseBackbone) {
                    // TODO find a cleaner way to swap normal and binormal for nucleic types
                    for (var i_1 = 0, il = binormalVectors.length; i_1 < il; i_1++)
                        binormalVectors[i_1] *= -1;
                    Object(_mol_geo_geometry_mesh_builder_ribbon__WEBPACK_IMPORTED_MODULE_11__["addRibbon"])(builderState, curvePoints, binormalVectors, normalVectors, segmentCount, heightValues, widthValues, 0);
                }
                else {
                    Object(_mol_geo_geometry_mesh_builder_ribbon__WEBPACK_IMPORTED_MODULE_11__["addRibbon"])(builderState, curvePoints, normalVectors, binormalVectors, segmentCount, widthValues, heightValues, 0);
                }
            }
            else if (radialSegments === 4) {
                Object(_mol_geo_geometry_mesh_builder_sheet__WEBPACK_IMPORTED_MODULE_7__["addSheet"])(builderState, curvePoints, normalVectors, binormalVectors, segmentCount, widthValues, heightValues, 0, startCap, endCap);
            }
            else {
                Object(_mol_geo_geometry_mesh_builder_tube__WEBPACK_IMPORTED_MODULE_8__["addTube"])(builderState, curvePoints, normalVectors, binormalVectors, segmentCount, radialSegments, widthValues, heightValues, startCap, endCap);
            }
        }
        ++i;
    }
    var m = _mol_geo_geometry_mesh_mesh_builder__WEBPACK_IMPORTED_MODULE_4__["MeshBuilder"].getMesh(builderState);
    var sphere = _mol_math_geometry__WEBPACK_IMPORTED_MODULE_15__["Sphere3D"].expand(Object(_mol_math_geometry__WEBPACK_IMPORTED_MODULE_15__["Sphere3D"])(), unit.boundary.sphere, 1 * props.sizeFactor);
    m.setBoundingSphere(sphere);
    return m;
}
var PolymerTraceParams = Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, _units_visual__WEBPACK_IMPORTED_MODULE_9__["UnitsMeshParams"]), PolymerTraceMeshParams);
function PolymerTraceVisual(materialId) {
    return Object(_units_visual__WEBPACK_IMPORTED_MODULE_9__["UnitsMeshVisual"])({
        defaultProps: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_1__["ParamDefinition"].getDefaultValues(PolymerTraceParams),
        createGeometry: createPolymerTraceMesh,
        createLocationIterator: _util_polymer__WEBPACK_IMPORTED_MODULE_5__["PolymerLocationIterator"].fromGroup,
        getLoci: _util_polymer__WEBPACK_IMPORTED_MODULE_5__["getPolymerElementLoci"],
        eachLocation: _util_polymer__WEBPACK_IMPORTED_MODULE_5__["eachPolymerElement"],
        setUpdateState: function (state, newProps, currentProps, newTheme, currentTheme, newStructureGroup, currentStructureGroup) {
            state.createGeometry = (newProps.sizeFactor !== currentProps.sizeFactor ||
                newProps.detail !== currentProps.detail ||
                newProps.linearSegments !== currentProps.linearSegments ||
                newProps.radialSegments !== currentProps.radialSegments ||
                newProps.aspectRatio !== currentProps.aspectRatio ||
                newProps.arrowFactor !== currentProps.arrowFactor);
            var secondaryStructureHash = _mol_model_props_computed_secondary_structure__WEBPACK_IMPORTED_MODULE_10__["SecondaryStructureProvider"].get(newStructureGroup.structure).version;
            if (state.info.secondaryStructureHash !== secondaryStructureHash) {
                state.createGeometry = true;
                state.info.secondaryStructureHash = secondaryStructureHash;
            }
        }
    }, materialId);
}
//# sourceMappingURL=polymer-trace-mesh.js.map

/***/ }),

/***/ "./lib/mol-repr/structure/visual/polymer-tube-mesh.js":
/*!************************************************************!*\
  !*** ./lib/mol-repr/structure/visual/polymer-tube-mesh.js ***!
  \************************************************************/
/*! exports provided: PolymerTubeMeshParams, DefaultPolymerTubeMeshProps, PolymerTubeParams, PolymerTubeVisual */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "PolymerTubeMeshParams", function() { return PolymerTubeMeshParams; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DefaultPolymerTubeMeshProps", function() { return DefaultPolymerTubeMeshProps; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "PolymerTubeParams", function() { return PolymerTubeParams; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "PolymerTubeVisual", function() { return PolymerTubeVisual; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../../mol-util/param-definition */ "./lib/mol-util/param-definition.js");
/* harmony import */ var _mol_geo_geometry_mesh_mesh__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../../mol-geo/geometry/mesh/mesh */ "./lib/mol-geo/geometry/mesh/mesh.js");
/* harmony import */ var _mol_geo_geometry_mesh_mesh_builder__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../../mol-geo/geometry/mesh/mesh-builder */ "./lib/mol-geo/geometry/mesh/mesh-builder.js");
/* harmony import */ var _util_polymer__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./util/polymer */ "./lib/mol-repr/structure/visual/util/polymer.js");
/* harmony import */ var _mol_model_structure_model_types__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../../mol-model/structure/model/types */ "./lib/mol-model/structure/model/types.js");
/* harmony import */ var _mol_geo_geometry_mesh_builder_tube__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../../../mol-geo/geometry/mesh/builder/tube */ "./lib/mol-geo/geometry/mesh/builder/tube.js");
/* harmony import */ var _units_visual__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../units-visual */ "./lib/mol-repr/structure/units-visual.js");
/* harmony import */ var _mol_geo_geometry_mesh_builder_sheet__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ../../../mol-geo/geometry/mesh/builder/sheet */ "./lib/mol-geo/geometry/mesh/builder/sheet.js");
/* harmony import */ var _mol_geo_geometry_mesh_builder_ribbon__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ../../../mol-geo/geometry/mesh/builder/ribbon */ "./lib/mol-geo/geometry/mesh/builder/ribbon.js");
/* harmony import */ var _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ../../../mol-math/linear-algebra */ "./lib/mol-math/linear-algebra.js");
/* harmony import */ var _mol_geo_geometry_mesh_builder_sphere__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ../../../mol-geo/geometry/mesh/builder/sphere */ "./lib/mol-geo/geometry/mesh/builder/sphere.js");
/* harmony import */ var _mol_geo_geometry_base__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! ../../../mol-geo/geometry/base */ "./lib/mol-geo/geometry/base.js");
/* harmony import */ var _mol_math_geometry__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! ../../../mol-math/geometry */ "./lib/mol-math/geometry.js");
/**
 * Copyright (c) 2019-2020 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */














var PolymerTubeMeshParams = {
    sizeFactor: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_1__["ParamDefinition"].Numeric(0.2, { min: 0, max: 10, step: 0.01 }),
    detail: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_1__["ParamDefinition"].Numeric(0, { min: 0, max: 3, step: 1 }, _mol_geo_geometry_base__WEBPACK_IMPORTED_MODULE_12__["BaseGeometry"].CustomQualityParamInfo),
    linearSegments: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_1__["ParamDefinition"].Numeric(8, { min: 1, max: 48, step: 1 }, _mol_geo_geometry_base__WEBPACK_IMPORTED_MODULE_12__["BaseGeometry"].CustomQualityParamInfo),
    radialSegments: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_1__["ParamDefinition"].Numeric(16, { min: 2, max: 56, step: 2 }, _mol_geo_geometry_base__WEBPACK_IMPORTED_MODULE_12__["BaseGeometry"].CustomQualityParamInfo),
};
var DefaultPolymerTubeMeshProps = _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_1__["ParamDefinition"].getDefaultValues(PolymerTubeMeshParams);
var tmpV1 = Object(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_10__["Vec3"])();
function createPolymerTubeMesh(ctx, unit, structure, theme, props, mesh) {
    var polymerElementCount = unit.polymerElements.length;
    if (!polymerElementCount)
        return _mol_geo_geometry_mesh_mesh__WEBPACK_IMPORTED_MODULE_2__["Mesh"].createEmpty(mesh);
    var sizeFactor = props.sizeFactor, detail = props.detail, linearSegments = props.linearSegments, radialSegments = props.radialSegments;
    var vertexCount = linearSegments * radialSegments * polymerElementCount + (radialSegments + 1) * polymerElementCount * 2;
    var builderState = _mol_geo_geometry_mesh_mesh_builder__WEBPACK_IMPORTED_MODULE_3__["MeshBuilder"].createState(vertexCount, vertexCount / 10, mesh);
    var state = Object(_util_polymer__WEBPACK_IMPORTED_MODULE_4__["createCurveSegmentState"])(linearSegments);
    var curvePoints = state.curvePoints, normalVectors = state.normalVectors, binormalVectors = state.binormalVectors, widthValues = state.widthValues, heightValues = state.heightValues;
    var i = 0;
    var polymerTraceIt = Object(_util_polymer__WEBPACK_IMPORTED_MODULE_4__["PolymerTraceIterator"])(unit, structure, true);
    while (polymerTraceIt.hasNext) {
        var v = polymerTraceIt.move();
        builderState.currentGroup = i;
        var isNucleicType = Object(_mol_model_structure_model_types__WEBPACK_IMPORTED_MODULE_5__["isNucleic"])(v.moleculeType);
        var shift = isNucleicType ? _util_polymer__WEBPACK_IMPORTED_MODULE_4__["NucleicShift"] : _util_polymer__WEBPACK_IMPORTED_MODULE_4__["StandardShift"];
        Object(_util_polymer__WEBPACK_IMPORTED_MODULE_4__["interpolateCurveSegment"])(state, v, _util_polymer__WEBPACK_IMPORTED_MODULE_4__["StandardTension"], shift);
        var startCap = v.coarseBackboneFirst || v.first;
        var endCap = v.coarseBackboneLast || v.last;
        var s0 = theme.size.size(v.centerPrev) * sizeFactor;
        var s1 = theme.size.size(v.center) * sizeFactor;
        var s2 = theme.size.size(v.centerNext) * sizeFactor;
        Object(_util_polymer__WEBPACK_IMPORTED_MODULE_4__["interpolateSizes"])(state, s0, s1, s2, s0, s1, s2, shift);
        var segmentCount = linearSegments;
        if (v.initial) {
            segmentCount = Math.max(Math.round(linearSegments * shift), 1);
            var offset = linearSegments - segmentCount;
            curvePoints.copyWithin(0, offset * 3);
            binormalVectors.copyWithin(0, offset * 3);
            normalVectors.copyWithin(0, offset * 3);
            widthValues.copyWithin(0, offset * 3);
            heightValues.copyWithin(0, offset * 3);
            _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_10__["Vec3"].fromArray(tmpV1, curvePoints, 3);
            _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_10__["Vec3"].normalize(tmpV1, _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_10__["Vec3"].sub(tmpV1, v.p2, tmpV1));
            _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_10__["Vec3"].scaleAndAdd(tmpV1, v.p2, tmpV1, s1 * _util_polymer__WEBPACK_IMPORTED_MODULE_4__["OverhangFactor"]);
            _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_10__["Vec3"].toArray(tmpV1, curvePoints, 0);
        }
        else if (v.final) {
            segmentCount = Math.max(Math.round(linearSegments * (1 - shift)), 1);
            _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_10__["Vec3"].fromArray(tmpV1, curvePoints, segmentCount * 3 - 3);
            _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_10__["Vec3"].normalize(tmpV1, _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_10__["Vec3"].sub(tmpV1, v.p2, tmpV1));
            _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_10__["Vec3"].scaleAndAdd(tmpV1, v.p2, tmpV1, s1 * _util_polymer__WEBPACK_IMPORTED_MODULE_4__["OverhangFactor"]);
            _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_10__["Vec3"].toArray(tmpV1, curvePoints, segmentCount * 3);
        }
        if (v.initial === true && v.final === true) {
            Object(_mol_geo_geometry_mesh_builder_sphere__WEBPACK_IMPORTED_MODULE_11__["addSphere"])(builderState, v.p2, s1 * 2, detail);
        }
        else if (radialSegments === 2) {
            Object(_mol_geo_geometry_mesh_builder_ribbon__WEBPACK_IMPORTED_MODULE_9__["addRibbon"])(builderState, curvePoints, normalVectors, binormalVectors, segmentCount, widthValues, heightValues, 0);
        }
        else if (radialSegments === 4) {
            Object(_mol_geo_geometry_mesh_builder_sheet__WEBPACK_IMPORTED_MODULE_8__["addSheet"])(builderState, curvePoints, normalVectors, binormalVectors, segmentCount, widthValues, heightValues, 0, startCap, endCap);
        }
        else {
            Object(_mol_geo_geometry_mesh_builder_tube__WEBPACK_IMPORTED_MODULE_6__["addTube"])(builderState, curvePoints, normalVectors, binormalVectors, segmentCount, radialSegments, widthValues, heightValues, startCap, endCap);
        }
        ++i;
    }
    var m = _mol_geo_geometry_mesh_mesh_builder__WEBPACK_IMPORTED_MODULE_3__["MeshBuilder"].getMesh(builderState);
    var sphere = _mol_math_geometry__WEBPACK_IMPORTED_MODULE_13__["Sphere3D"].expand(Object(_mol_math_geometry__WEBPACK_IMPORTED_MODULE_13__["Sphere3D"])(), unit.boundary.sphere, 1 * props.sizeFactor);
    m.setBoundingSphere(sphere);
    return m;
}
var PolymerTubeParams = Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, _units_visual__WEBPACK_IMPORTED_MODULE_7__["UnitsMeshParams"]), PolymerTubeMeshParams);
function PolymerTubeVisual(materialId) {
    return Object(_units_visual__WEBPACK_IMPORTED_MODULE_7__["UnitsMeshVisual"])({
        defaultProps: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_1__["ParamDefinition"].getDefaultValues(PolymerTubeParams),
        createGeometry: createPolymerTubeMesh,
        createLocationIterator: _util_polymer__WEBPACK_IMPORTED_MODULE_4__["PolymerLocationIterator"].fromGroup,
        getLoci: _util_polymer__WEBPACK_IMPORTED_MODULE_4__["getPolymerElementLoci"],
        eachLocation: _util_polymer__WEBPACK_IMPORTED_MODULE_4__["eachPolymerElement"],
        setUpdateState: function (state, newProps, currentProps) {
            state.createGeometry = (newProps.sizeFactor !== currentProps.sizeFactor ||
                newProps.detail !== currentProps.detail ||
                newProps.linearSegments !== currentProps.linearSegments ||
                newProps.radialSegments !== currentProps.radialSegments);
        }
    }, materialId);
}
//# sourceMappingURL=polymer-tube-mesh.js.map

/***/ }),

/***/ "./lib/mol-repr/structure/visual/util/bond.js":
/*!****************************************************!*\
  !*** ./lib/mol-repr/structure/visual/util/bond.js ***!
  \****************************************************/
/*! exports provided: BondParams, DefaultBondProps, BondCylinderParams, DefaultBondCylinderProps, BondLineParams, DefaultBondLineProps, ignoreBondType, makeIntraBondIgnoreTest, makeInterBondIgnoreTest, BondIterator, getIntraBondLoci, eachIntraBond, getInterBondLoci, eachInterBond */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "BondParams", function() { return BondParams; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DefaultBondProps", function() { return DefaultBondProps; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "BondCylinderParams", function() { return BondCylinderParams; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DefaultBondCylinderProps", function() { return DefaultBondCylinderProps; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "BondLineParams", function() { return BondLineParams; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DefaultBondLineProps", function() { return DefaultBondLineProps; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ignoreBondType", function() { return ignoreBondType; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "makeIntraBondIgnoreTest", function() { return makeIntraBondIgnoreTest; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "makeInterBondIgnoreTest", function() { return makeInterBondIgnoreTest; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "BondIterator", function() { return BondIterator; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getIntraBondLoci", function() { return getIntraBondLoci; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "eachIntraBond", function() { return eachIntraBond; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getInterBondLoci", function() { return getInterBondLoci; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "eachInterBond", function() { return eachInterBond; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _mol_model_structure_model_types__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../../../mol-model/structure/model/types */ "./lib/mol-model/structure/model/types.js");
/* harmony import */ var _mol_model_structure__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../../../mol-model/structure */ "./lib/mol-model/structure.js");
/* harmony import */ var _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../../../mol-util/param-definition */ "./lib/mol-util/param-definition.js");
/* harmony import */ var _mol_geo_util_location_iterator__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../../../mol-geo/util/location-iterator */ "./lib/mol-geo/util/location-iterator.js");
/* harmony import */ var _link__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./link */ "./lib/mol-repr/structure/visual/util/link.js");
/* harmony import */ var _mol_util_type_helpers__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../../../../mol-util/type-helpers */ "./lib/mol-util/type-helpers.js");
/* harmony import */ var _mol_model_loci__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../../../../mol-model/loci */ "./lib/mol-model/loci.js");
/* harmony import */ var _mol_data_int__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ../../../../mol-data/int */ "./lib/mol-data/int.js");
/* harmony import */ var _common__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ./common */ "./lib/mol-repr/structure/visual/util/common.js");
/**
 * Copyright (c) 2018-2020 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */










var BondParams = {
    includeTypes: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_3__["ParamDefinition"].MultiSelect(Object(_mol_util_type_helpers__WEBPACK_IMPORTED_MODULE_6__["ObjectKeys"])(_mol_model_structure_model_types__WEBPACK_IMPORTED_MODULE_1__["BondType"].Names), _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_3__["ParamDefinition"].objectToOptions(_mol_model_structure_model_types__WEBPACK_IMPORTED_MODULE_1__["BondType"].Names)),
    excludeTypes: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_3__["ParamDefinition"].MultiSelect([], _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_3__["ParamDefinition"].objectToOptions(_mol_model_structure_model_types__WEBPACK_IMPORTED_MODULE_1__["BondType"].Names)),
    ignoreHydrogens: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_3__["ParamDefinition"].Boolean(false),
};
var DefaultBondProps = _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_3__["ParamDefinition"].getDefaultValues(BondParams);
var BondCylinderParams = Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, _link__WEBPACK_IMPORTED_MODULE_5__["LinkCylinderParams"]), BondParams);
var DefaultBondCylinderProps = _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_3__["ParamDefinition"].getDefaultValues(BondCylinderParams);
var BondLineParams = Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, _link__WEBPACK_IMPORTED_MODULE_5__["LinkLineParams"]), BondParams);
var DefaultBondLineProps = _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_3__["ParamDefinition"].getDefaultValues(BondLineParams);
function ignoreBondType(include, exclude, f) {
    return !_mol_model_structure_model_types__WEBPACK_IMPORTED_MODULE_1__["BondType"].is(include, f) || _mol_model_structure_model_types__WEBPACK_IMPORTED_MODULE_1__["BondType"].is(exclude, f);
}
function makeIntraBondIgnoreTest(unit, props) {
    var elements = unit.elements;
    var atomicNumber = unit.model.atomicHierarchy.derived.atom.atomicNumber;
    var bonds = unit.bonds;
    var a = bonds.a, b = bonds.b, edgeProps = bonds.edgeProps;
    var _flags = edgeProps.flags;
    var ignoreHydrogens = props.ignoreHydrogens, includeTypes = props.includeTypes, excludeTypes = props.excludeTypes;
    var include = _mol_model_structure_model_types__WEBPACK_IMPORTED_MODULE_1__["BondType"].fromNames(includeTypes);
    var exclude = _mol_model_structure_model_types__WEBPACK_IMPORTED_MODULE_1__["BondType"].fromNames(excludeTypes);
    var allBondTypes = _mol_model_structure_model_types__WEBPACK_IMPORTED_MODULE_1__["BondType"].isAll(include) && 0 /* None */ === exclude;
    if (!allBondTypes && ignoreHydrogens) {
        return function (edgeIndex) { return Object(_common__WEBPACK_IMPORTED_MODULE_9__["isH"])(atomicNumber, elements[a[edgeIndex]]) || Object(_common__WEBPACK_IMPORTED_MODULE_9__["isH"])(atomicNumber, elements[b[edgeIndex]]) || ignoreBondType(include, exclude, _flags[edgeIndex]); };
    }
    else if (!allBondTypes) {
        return function (edgeIndex) { return ignoreBondType(include, exclude, _flags[edgeIndex]); };
    }
    else if (ignoreHydrogens) {
        return function (edgeIndex) { return Object(_common__WEBPACK_IMPORTED_MODULE_9__["isH"])(atomicNumber, elements[a[edgeIndex]]) || Object(_common__WEBPACK_IMPORTED_MODULE_9__["isH"])(atomicNumber, elements[b[edgeIndex]]); };
    }
}
function makeInterBondIgnoreTest(structure, props) {
    var bonds = structure.interUnitBonds;
    var edges = bonds.edges;
    var ignoreHydrogens = props.ignoreHydrogens, includeTypes = props.includeTypes, excludeTypes = props.excludeTypes;
    var include = _mol_model_structure_model_types__WEBPACK_IMPORTED_MODULE_1__["BondType"].fromNames(includeTypes);
    var exclude = _mol_model_structure_model_types__WEBPACK_IMPORTED_MODULE_1__["BondType"].fromNames(excludeTypes);
    var allBondTypes = _mol_model_structure_model_types__WEBPACK_IMPORTED_MODULE_1__["BondType"].isAll(include) && 0 /* None */ === exclude;
    var ignoreHydrogen = function (edgeIndex) {
        var b = edges[edgeIndex];
        var uA = structure.unitMap.get(b.unitA);
        var uB = structure.unitMap.get(b.unitB);
        return Object(_common__WEBPACK_IMPORTED_MODULE_9__["isHydrogen"])(uA, uA.elements[b.indexA]) || Object(_common__WEBPACK_IMPORTED_MODULE_9__["isHydrogen"])(uB, uB.elements[b.indexB]);
    };
    if (!allBondTypes && ignoreHydrogens) {
        return function (edgeIndex) { return ignoreHydrogen(edgeIndex) || ignoreBondType(include, exclude, edges[edgeIndex].props.flag); };
    }
    else if (!allBondTypes) {
        return function (edgeIndex) { return ignoreBondType(include, exclude, edges[edgeIndex].props.flag); };
    }
    else if (ignoreHydrogens) {
        return function (edgeIndex) { return ignoreHydrogen(edgeIndex); };
    }
}
var BondIterator;
(function (BondIterator) {
    function fromGroup(structureGroup) {
        var group = structureGroup.group, structure = structureGroup.structure;
        var unit = group.units[0];
        var groupCount = _mol_model_structure__WEBPACK_IMPORTED_MODULE_2__["Unit"].isAtomic(unit) ? unit.bonds.edgeCount * 2 : 0;
        var instanceCount = group.units.length;
        var location = _mol_model_structure__WEBPACK_IMPORTED_MODULE_2__["Bond"].Location();
        location.aStructure = structure;
        location.bStructure = structure;
        var getLocation = function (groupIndex, instanceIndex) {
            var unit = group.units[instanceIndex];
            location.aUnit = unit;
            location.bUnit = unit;
            location.aIndex = unit.bonds.a[groupIndex];
            location.bIndex = unit.bonds.b[groupIndex];
            return location;
        };
        return Object(_mol_geo_util_location_iterator__WEBPACK_IMPORTED_MODULE_4__["LocationIterator"])(groupCount, instanceCount, 1, getLocation);
    }
    BondIterator.fromGroup = fromGroup;
    function fromStructure(structure) {
        var groupCount = structure.interUnitBonds.edgeCount;
        var instanceCount = 1;
        var location = _mol_model_structure__WEBPACK_IMPORTED_MODULE_2__["Bond"].Location();
        location.aStructure = structure;
        location.bStructure = structure;
        var getLocation = function (groupIndex) {
            var bond = structure.interUnitBonds.edges[groupIndex];
            location.aUnit = structure.unitMap.get(bond.unitA);
            location.aIndex = bond.indexA;
            location.bUnit = structure.unitMap.get(bond.unitB);
            location.bIndex = bond.indexB;
            return location;
        };
        return Object(_mol_geo_util_location_iterator__WEBPACK_IMPORTED_MODULE_4__["LocationIterator"])(groupCount, instanceCount, 1, getLocation, true);
    }
    BondIterator.fromStructure = fromStructure;
})(BondIterator || (BondIterator = {}));
//
function getIntraBondLoci(pickingId, structureGroup, id) {
    var objectId = pickingId.objectId, instanceId = pickingId.instanceId, groupId = pickingId.groupId;
    if (id === objectId) {
        var structure = structureGroup.structure, group = structureGroup.group;
        var unit = group.units[instanceId];
        if (_mol_model_structure__WEBPACK_IMPORTED_MODULE_2__["Unit"].isAtomic(unit)) {
            return _mol_model_structure__WEBPACK_IMPORTED_MODULE_2__["Bond"].Loci(structure, [
                _mol_model_structure__WEBPACK_IMPORTED_MODULE_2__["Bond"].Location(structure, unit, unit.bonds.a[groupId], structure, unit, unit.bonds.b[groupId]),
                _mol_model_structure__WEBPACK_IMPORTED_MODULE_2__["Bond"].Location(structure, unit, unit.bonds.b[groupId], structure, unit, unit.bonds.a[groupId])
            ]);
        }
    }
    return _mol_model_loci__WEBPACK_IMPORTED_MODULE_7__["EmptyLoci"];
}
function eachIntraBond(loci, structureGroup, apply, isMarking) {
    var changed = false;
    if (_mol_model_structure__WEBPACK_IMPORTED_MODULE_2__["Bond"].isLoci(loci)) {
        var structure = structureGroup.structure, group = structureGroup.group;
        if (!_mol_model_structure__WEBPACK_IMPORTED_MODULE_2__["Structure"].areEquivalent(loci.structure, structure))
            return false;
        var unit = group.units[0];
        if (!_mol_model_structure__WEBPACK_IMPORTED_MODULE_2__["Unit"].isAtomic(unit))
            return false;
        var groupCount = unit.bonds.edgeCount * 2;
        for (var _i = 0, _a = loci.bonds; _i < _a.length; _i++) {
            var b = _a[_i];
            if (b.aUnit !== b.bUnit)
                continue;
            var unitIdx = group.unitIndexMap.get(b.aUnit.id);
            if (unitIdx !== undefined) {
                var idx = unit.bonds.getDirectedEdgeIndex(b.aIndex, b.bIndex);
                if (idx !== -1) {
                    if (apply(_mol_data_int__WEBPACK_IMPORTED_MODULE_8__["Interval"].ofSingleton(unitIdx * groupCount + idx)))
                        changed = true;
                }
            }
        }
    }
    else if (_mol_model_structure__WEBPACK_IMPORTED_MODULE_2__["StructureElement"].Loci.is(loci)) {
        var structure = structureGroup.structure, group = structureGroup.group;
        if (!_mol_model_structure__WEBPACK_IMPORTED_MODULE_2__["Structure"].areEquivalent(loci.structure, structure))
            return false;
        var unit = group.units[0];
        if (!_mol_model_structure__WEBPACK_IMPORTED_MODULE_2__["Unit"].isAtomic(unit))
            return false;
        var groupCount_1 = unit.bonds.edgeCount * 2;
        var _loop_1 = function (e) {
            var unitIdx = group.unitIndexMap.get(e.unit.id);
            if (unitIdx !== undefined) {
                var _a = unit.bonds, offset_1 = _a.offset, b_1 = _a.b;
                _mol_data_int__WEBPACK_IMPORTED_MODULE_8__["OrderedSet"].forEach(e.indices, function (v) {
                    for (var t = offset_1[v], _t = offset_1[v + 1]; t < _t; t++) {
                        if (!isMarking || _mol_data_int__WEBPACK_IMPORTED_MODULE_8__["OrderedSet"].has(e.indices, b_1[t])) {
                            if (apply(_mol_data_int__WEBPACK_IMPORTED_MODULE_8__["Interval"].ofSingleton(unitIdx * groupCount_1 + t)))
                                changed = true;
                        }
                    }
                });
            }
        };
        for (var _b = 0, _c = loci.elements; _b < _c.length; _b++) {
            var e = _c[_b];
            _loop_1(e);
        }
    }
    return changed;
}
//
function getInterBondLoci(pickingId, structure, id) {
    var objectId = pickingId.objectId, groupId = pickingId.groupId;
    if (id === objectId) {
        var b = structure.interUnitBonds.edges[groupId];
        var uA = structure.unitMap.get(b.unitA);
        var uB = structure.unitMap.get(b.unitB);
        return _mol_model_structure__WEBPACK_IMPORTED_MODULE_2__["Bond"].Loci(structure, [
            _mol_model_structure__WEBPACK_IMPORTED_MODULE_2__["Bond"].Location(structure, uA, b.indexA, structure, uB, b.indexB),
            _mol_model_structure__WEBPACK_IMPORTED_MODULE_2__["Bond"].Location(structure, uB, b.indexB, structure, uA, b.indexA)
        ]);
    }
    return _mol_model_loci__WEBPACK_IMPORTED_MODULE_7__["EmptyLoci"];
}
function eachInterBond(loci, structure, apply, isMarking) {
    var changed = false;
    if (_mol_model_structure__WEBPACK_IMPORTED_MODULE_2__["Bond"].isLoci(loci)) {
        if (!_mol_model_structure__WEBPACK_IMPORTED_MODULE_2__["Structure"].areEquivalent(loci.structure, structure))
            return false;
        for (var _i = 0, _a = loci.bonds; _i < _a.length; _i++) {
            var b = _a[_i];
            var idx = structure.interUnitBonds.getBondIndexFromLocation(b);
            if (idx !== -1) {
                if (apply(_mol_data_int__WEBPACK_IMPORTED_MODULE_8__["Interval"].ofSingleton(idx)))
                    changed = true;
            }
        }
    }
    else if (_mol_model_structure__WEBPACK_IMPORTED_MODULE_2__["StructureElement"].Loci.is(loci)) {
        if (!_mol_model_structure__WEBPACK_IMPORTED_MODULE_2__["Structure"].areEquivalent(loci.structure, structure))
            return false;
        if (isMarking && loci.elements.length === 1)
            return false; // only a single unit
        var map_1 = new Map();
        for (var _b = 0, _c = loci.elements; _b < _c.length; _b++) {
            var e = _c[_b];
            map_1.set(e.unit.id, e.indices);
        }
        var _loop_2 = function (e) {
            var unit = e.unit;
            if (!_mol_model_structure__WEBPACK_IMPORTED_MODULE_2__["Unit"].isAtomic(unit))
                return "continue";
            structure.interUnitBonds.getConnectedUnits(unit.id).forEach(function (b) {
                var otherLociIndices = map_1.get(b.unitB);
                if (!isMarking || otherLociIndices) {
                    _mol_data_int__WEBPACK_IMPORTED_MODULE_8__["OrderedSet"].forEach(e.indices, function (v) {
                        if (!b.connectedIndices.includes(v))
                            return;
                        b.getEdges(v).forEach(function (bi) {
                            if (!isMarking || (otherLociIndices && _mol_data_int__WEBPACK_IMPORTED_MODULE_8__["OrderedSet"].has(otherLociIndices, bi.indexB))) {
                                var idx = structure.interUnitBonds.getEdgeIndex(v, unit.id, bi.indexB, b.unitB);
                                if (apply(_mol_data_int__WEBPACK_IMPORTED_MODULE_8__["Interval"].ofSingleton(idx)))
                                    changed = true;
                            }
                        });
                    });
                }
            });
        };
        for (var _d = 0, _e = loci.elements; _d < _e.length; _d++) {
            var e = _e[_d];
            _loop_2(e);
        }
    }
    return changed;
}
//# sourceMappingURL=bond.js.map

/***/ }),

/***/ "./lib/mol-repr/structure/visual/util/common.js":
/*!******************************************************!*\
  !*** ./lib/mol-repr/structure/visual/util/common.js ***!
  \******************************************************/
/*! exports provided: getResidueLoci, getAltResidueLoci, getAltResidueLociFromId, createUnitsTransform, UnitKindInfo, UnitKindOptions, includesUnitKind, ensureReasonableResolution, getConformation, CommonSurfaceParams, DefaultCommonSurfaceProps, getUnitConformationAndRadius, getStructureConformationAndRadius, isHydrogen, isH, isTrace, getUnitExtraRadius, getStructureExtraRadius */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getResidueLoci", function() { return getResidueLoci; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getAltResidueLoci", function() { return getAltResidueLoci; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getAltResidueLociFromId", function() { return getAltResidueLociFromId; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createUnitsTransform", function() { return createUnitsTransform; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "UnitKindInfo", function() { return UnitKindInfo; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "UnitKindOptions", function() { return UnitKindOptions; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "includesUnitKind", function() { return includesUnitKind; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ensureReasonableResolution", function() { return ensureReasonableResolution; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getConformation", function() { return getConformation; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CommonSurfaceParams", function() { return CommonSurfaceParams; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DefaultCommonSurfaceProps", function() { return DefaultCommonSurfaceProps; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getUnitConformationAndRadius", function() { return getUnitConformationAndRadius; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getStructureConformationAndRadius", function() { return getStructureConformationAndRadius; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isHydrogen", function() { return isHydrogen; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isH", function() { return isH; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isTrace", function() { return isTrace; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getUnitExtraRadius", function() { return getUnitExtraRadius; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getStructureExtraRadius", function() { return getStructureExtraRadius; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _mol_model_structure__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../../../mol-model/structure */ "./lib/mol-model/structure.js");
/* harmony import */ var _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../../../mol-math/linear-algebra */ "./lib/mol-math/linear-algebra.js");
/* harmony import */ var _mol_geo_geometry_transform_data__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../../../mol-geo/geometry/transform-data */ "./lib/mol-geo/geometry/transform-data.js");
/* harmony import */ var _mol_data_int__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../../../mol-data/int */ "./lib/mol-data/int.js");
/* harmony import */ var _mol_model_loci__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../../../mol-model/loci */ "./lib/mol-model/loci.js");
/* harmony import */ var _mol_theme_size_physical__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../../../../mol-theme/size/physical */ "./lib/mol-theme/size/physical.js");
/* harmony import */ var _mol_model_structure_model_properties_atomic__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../../../../mol-model/structure/model/properties/atomic */ "./lib/mol-model/structure/model/properties/atomic.js");
/* harmony import */ var _mol_util_array__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ../../../../mol-util/array */ "./lib/mol-util/array.js");
/* harmony import */ var _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ../../../../mol-util/param-definition */ "./lib/mol-util/param-definition.js");
/* harmony import */ var _mol_math_geometry_boundary__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ../../../../mol-math/geometry/boundary */ "./lib/mol-math/geometry/boundary.js");
/* harmony import */ var _mol_math_geometry__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ../../../../mol-math/geometry */ "./lib/mol-math/geometry.js");
/**
 * Copyright (c) 2018-2021 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */












/** Return a Loci for the elements of a whole residue the elementIndex belongs to. */
function getResidueLoci(structure, unit, elementIndex) {
    var elements = unit.elements, model = unit.model;
    if (_mol_data_int__WEBPACK_IMPORTED_MODULE_4__["OrderedSet"].indexOf(elements, elementIndex) !== -1) {
        var _a = model.atomicHierarchy.residueAtomSegments, index = _a.index, offsets = _a.offsets;
        var rI = index[elementIndex];
        var _indices = [];
        for (var i = offsets[rI], il = offsets[rI + 1]; i < il; ++i) {
            var unitIndex = _mol_data_int__WEBPACK_IMPORTED_MODULE_4__["OrderedSet"].indexOf(elements, i);
            if (unitIndex !== -1)
                _indices.push(unitIndex);
        }
        var indices = _mol_data_int__WEBPACK_IMPORTED_MODULE_4__["OrderedSet"].ofSortedArray(_mol_data_int__WEBPACK_IMPORTED_MODULE_4__["SortedArray"].ofSortedArray(_indices));
        return _mol_model_structure__WEBPACK_IMPORTED_MODULE_1__["StructureElement"].Loci(structure, [{ unit: unit, indices: indices }]);
    }
    return _mol_model_loci__WEBPACK_IMPORTED_MODULE_5__["EmptyLoci"];
}
/**
 * Return a Loci for the elements of a whole residue the elementIndex belongs to but
 * restrict to elements that have the same label_alt_id or none
 */
function getAltResidueLoci(structure, unit, elementIndex) {
    var elements = unit.elements, model = unit.model;
    var label_alt_id = model.atomicHierarchy.atoms.label_alt_id;
    var elementAltId = label_alt_id.value(elementIndex);
    if (_mol_data_int__WEBPACK_IMPORTED_MODULE_4__["OrderedSet"].indexOf(elements, elementIndex) !== -1) {
        var index = model.atomicHierarchy.residueAtomSegments.index;
        var rI = index[elementIndex];
        return getAltResidueLociFromId(structure, unit, rI, elementAltId);
    }
    return _mol_model_structure__WEBPACK_IMPORTED_MODULE_1__["StructureElement"].Loci(structure, []);
}
function getAltResidueLociFromId(structure, unit, residueIndex, elementAltId) {
    var elements = unit.elements, model = unit.model;
    var label_alt_id = model.atomicHierarchy.atoms.label_alt_id;
    var offsets = model.atomicHierarchy.residueAtomSegments.offsets;
    var _indices = [];
    for (var i = offsets[residueIndex], il = offsets[residueIndex + 1]; i < il; ++i) {
        var unitIndex = _mol_data_int__WEBPACK_IMPORTED_MODULE_4__["OrderedSet"].indexOf(elements, i);
        if (unitIndex !== -1) {
            var altId = label_alt_id.value(i);
            if (elementAltId === altId || altId === '') {
                _indices.push(unitIndex);
            }
        }
    }
    var indices = _mol_data_int__WEBPACK_IMPORTED_MODULE_4__["OrderedSet"].ofSortedArray(_mol_data_int__WEBPACK_IMPORTED_MODULE_4__["SortedArray"].ofSortedArray(_indices));
    return _mol_model_structure__WEBPACK_IMPORTED_MODULE_1__["StructureElement"].Loci(structure, [{ unit: unit, indices: indices }]);
}
//
function createUnitsTransform(_a, transformData) {
    var units = _a.units;
    var unitCount = units.length;
    var n = unitCount * 16;
    var array = transformData && transformData.aTransform.ref.value.length >= n ? transformData.aTransform.ref.value : new Float32Array(n);
    for (var i = 0; i < unitCount; i++) {
        _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_2__["Mat4"].toArray(units[i].conformation.operator.matrix, array, i * 16);
    }
    return Object(_mol_geo_geometry_transform_data__WEBPACK_IMPORTED_MODULE_3__["createTransform"])(array, unitCount, transformData);
}
var UnitKindInfo = {
    'atomic': {},
    'spheres': {},
    'gaussians': {},
};
var UnitKindOptions = _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_9__["ParamDefinition"].objectToOptions(UnitKindInfo);
function includesUnitKind(unitKinds, unit) {
    for (var i = 0, il = unitKinds.length; i < il; ++i) {
        if (_mol_model_structure__WEBPACK_IMPORTED_MODULE_1__["Unit"].isAtomic(unit) && unitKinds[i] === 'atomic')
            return true;
        if (_mol_model_structure__WEBPACK_IMPORTED_MODULE_1__["Unit"].isSpheres(unit) && unitKinds[i] === 'spheres')
            return true;
        if (_mol_model_structure__WEBPACK_IMPORTED_MODULE_1__["Unit"].isGaussians(unit) && unitKinds[i] === 'gaussians')
            return true;
    }
    return false;
}
//
var DefaultMaxCells = 500000000;
/** guard against overly high resolution for the given box size */
function ensureReasonableResolution(box, props, maxCells) {
    if (maxCells === void 0) { maxCells = DefaultMaxCells; }
    var size = _mol_math_geometry__WEBPACK_IMPORTED_MODULE_11__["Box3D"].size(Object(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_2__["Vec3"])(), box);
    var maxArea = Math.floor(Math.cbrt(maxCells) * Math.cbrt(maxCells));
    var area = size[0] * size[1];
    var maxAreaCells = Math.ceil(area / props.resolution);
    var resolution = maxAreaCells > maxArea ? area / maxArea : props.resolution;
    return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, props), { resolution: resolution });
}
function getConformation(unit) {
    switch (unit.kind) {
        case 0 /* Atomic */: return unit.model.atomicConformation;
        case 1 /* Spheres */: return unit.model.coarseConformation.spheres;
        case 2 /* Gaussians */: return unit.model.coarseConformation.gaussians;
    }
}
var CommonSurfaceParams = {
    ignoreHydrogens: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_9__["ParamDefinition"].Boolean(false, { description: 'Whether or not to include hydrogen atoms in the surface calculation.' }),
    traceOnly: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_9__["ParamDefinition"].Boolean(false, { description: 'Whether or not to only use trace atoms in the surface calculation.' }),
    includeParent: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_9__["ParamDefinition"].Boolean(false, { description: 'Include elements of the parent structure in surface calculation to get a surface patch of the current structure.' }),
};
var DefaultCommonSurfaceProps = _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_9__["ParamDefinition"].getDefaultValues(CommonSurfaceParams);
var v = Object(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_2__["Vec3"])();
function squaredDistance(x, y, z, center) {
    return _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_2__["Vec3"].squaredDistance(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_2__["Vec3"].set(v, x, y, z), center);
}
/** marks `indices` for filtering/ignoring in `id` when not in `elements` */
function filterId(id, elements, indices) {
    var start = 0;
    var end = elements.length;
    for (var i = 0, il = indices.length; i < il; ++i) {
        var idx = _mol_data_int__WEBPACK_IMPORTED_MODULE_4__["SortedArray"].indexOfInRange(elements, indices[i], start, end);
        if (idx === -1) {
            id[i] = -2;
        }
        else {
            id[i] = idx;
            start = idx;
        }
    }
}
function getUnitConformationAndRadius(structure, unit, props) {
    var ignoreHydrogens = props.ignoreHydrogens, traceOnly = props.traceOnly, includeParent = props.includeParent;
    var rootUnit = includeParent ? structure.root.unitMap.get(unit.id) : unit;
    var _a = getConformation(rootUnit), x = _a.x, y = _a.y, z = _a.z;
    var elements = rootUnit.elements;
    var _b = unit.boundary.sphere, center = _b.center, sphereRadius = _b.radius;
    var extraRadius = (2 + 1.5) * 2; // TODO should be twice (the max vdW/sphere radius plus the probe radius)
    var radiusSq = (sphereRadius + extraRadius) * (sphereRadius + extraRadius);
    var indices;
    var id;
    if (ignoreHydrogens || traceOnly || (includeParent && rootUnit !== unit)) {
        var _indices = [];
        var _id = [];
        for (var i = 0, il = elements.length; i < il; ++i) {
            var eI = elements[i];
            if (ignoreHydrogens && isHydrogen(rootUnit, eI))
                continue;
            if (traceOnly && !isTrace(rootUnit, eI))
                continue;
            if (includeParent && squaredDistance(x[eI], y[eI], z[eI], center) > radiusSq)
                continue;
            _indices.push(eI);
            _id.push(i);
        }
        indices = _mol_data_int__WEBPACK_IMPORTED_MODULE_4__["SortedArray"].ofSortedArray(_indices);
        id = _id;
    }
    else {
        indices = elements;
        id = Object(_mol_util_array__WEBPACK_IMPORTED_MODULE_8__["fillSerial"])(new Int32Array(indices.length));
    }
    if (includeParent && rootUnit !== unit) {
        filterId(id, unit.elements, indices);
    }
    var position = { indices: indices, x: x, y: y, z: z, id: id };
    var boundary = unit === rootUnit ? unit.boundary : Object(_mol_math_geometry_boundary__WEBPACK_IMPORTED_MODULE_10__["getBoundary"])(position);
    var l = _mol_model_structure__WEBPACK_IMPORTED_MODULE_1__["StructureElement"].Location.create(structure, rootUnit);
    var sizeTheme = Object(_mol_theme_size_physical__WEBPACK_IMPORTED_MODULE_6__["PhysicalSizeTheme"])({}, { scale: 1 });
    var radius = function (index) {
        l.element = index;
        return sizeTheme.size(l);
    };
    return { position: position, boundary: boundary, radius: radius };
}
function getStructureConformationAndRadius(structure, ignoreHydrogens, traceOnly) {
    var l = _mol_model_structure__WEBPACK_IMPORTED_MODULE_1__["StructureElement"].Location.create(structure);
    var sizeTheme = Object(_mol_theme_size_physical__WEBPACK_IMPORTED_MODULE_6__["PhysicalSizeTheme"])({}, { scale: 1 });
    var xs;
    var ys;
    var zs;
    var rs;
    var id;
    if (ignoreHydrogens || traceOnly) {
        var _xs = [];
        var _ys = [];
        var _zs = [];
        var _rs = [];
        var _id = [];
        for (var i = 0, m = 0, il = structure.units.length; i < il; ++i) {
            var unit = structure.units[i];
            var elements = unit.elements;
            var _a = unit.conformation, x = _a.x, y = _a.y, z = _a.z;
            l.unit = unit;
            for (var j = 0, jl = elements.length; j < jl; ++j) {
                var eI = elements[j];
                if (ignoreHydrogens && isHydrogen(unit, eI))
                    continue;
                if (traceOnly && !isTrace(unit, eI))
                    continue;
                _xs.push(x(eI));
                _ys.push(y(eI));
                _zs.push(z(eI));
                l.element = eI;
                _rs.push(sizeTheme.size(l));
                _id.push(m + j);
            }
            m += elements.length;
        }
        xs = _xs, ys = _ys, zs = _zs, rs = _rs;
        id = _id;
    }
    else {
        var elementCount = structure.elementCount;
        var _xs = new Float32Array(elementCount);
        var _ys = new Float32Array(elementCount);
        var _zs = new Float32Array(elementCount);
        var _rs = new Float32Array(elementCount);
        for (var i = 0, m = 0, il = structure.units.length; i < il; ++i) {
            var unit = structure.units[i];
            var elements = unit.elements;
            var _b = unit.conformation, x = _b.x, y = _b.y, z = _b.z;
            l.unit = unit;
            for (var j = 0, jl = elements.length; j < jl; ++j) {
                var eI = elements[j];
                var mj = m + j;
                _xs[mj] = x(eI);
                _ys[mj] = y(eI);
                _zs[mj] = z(eI);
                l.element = eI;
                _rs[mj] = sizeTheme.size(l);
            }
            m += elements.length;
        }
        xs = _xs, ys = _ys, zs = _zs, rs = _rs;
        id = Object(_mol_util_array__WEBPACK_IMPORTED_MODULE_8__["fillSerial"])(new Uint32Array(elementCount));
    }
    var position = { indices: _mol_data_int__WEBPACK_IMPORTED_MODULE_4__["OrderedSet"].ofRange(0, id.length), x: xs, y: ys, z: zs, id: id };
    var radius = function (index) { return rs[index]; };
    return { position: position, radius: radius };
}
var _H = _mol_model_structure_model_properties_atomic__WEBPACK_IMPORTED_MODULE_7__["AtomicNumbers"]['H'];
function isHydrogen(unit, element) {
    if (_mol_model_structure__WEBPACK_IMPORTED_MODULE_1__["Unit"].isCoarse(unit))
        return false;
    return unit.model.atomicHierarchy.derived.atom.atomicNumber[element] === _H;
}
function isH(atomicNumber, element) {
    return atomicNumber[element] === _H;
}
function isTrace(unit, element) {
    if (_mol_model_structure__WEBPACK_IMPORTED_MODULE_1__["Unit"].isCoarse(unit))
        return true;
    var atomId = unit.model.atomicHierarchy.atoms.label_atom_id.value(element);
    if (atomId === 'CA' || atomId === 'P')
        return true;
    return false;
}
function getUnitExtraRadius(unit) {
    if (_mol_model_structure__WEBPACK_IMPORTED_MODULE_1__["Unit"].isAtomic(unit))
        return 4;
    var max = 0;
    var elements = unit.elements;
    var r = unit.conformation.r;
    for (var i = 0, _i = elements.length; i < _i; i++) {
        var _r = r(elements[i]);
        if (_r > max)
            max = _r;
    }
    return max + 1;
}
function getStructureExtraRadius(structure) {
    var max = 0;
    for (var _a = 0, _b = structure.unitSymmetryGroups; _a < _b.length; _a++) {
        var ug = _b[_a];
        var r = getUnitExtraRadius(ug.units[0]);
        if (r > max)
            max = r;
    }
    return max;
}
//# sourceMappingURL=common.js.map

/***/ }),

/***/ "./lib/mol-repr/structure/visual/util/element.js":
/*!*******************************************************!*\
  !*** ./lib/mol-repr/structure/visual/util/element.js ***!
  \*******************************************************/
/*! exports provided: makeElementIgnoreTest, createElementSphereMesh, createElementSphereImpostor, eachElement, getElementLoci, eachSerialElement, getSerialElementLoci, ElementIterator */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "makeElementIgnoreTest", function() { return makeElementIgnoreTest; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createElementSphereMesh", function() { return createElementSphereMesh; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createElementSphereImpostor", function() { return createElementSphereImpostor; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "eachElement", function() { return eachElement; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getElementLoci", function() { return getElementLoci; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "eachSerialElement", function() { return eachSerialElement; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getSerialElementLoci", function() { return getSerialElementLoci; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ElementIterator", function() { return ElementIterator; });
/* harmony import */ var _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../../../mol-math/linear-algebra */ "./lib/mol-math/linear-algebra.js");
/* harmony import */ var _mol_model_structure__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../../../mol-model/structure */ "./lib/mol-model/structure.js");
/* harmony import */ var _mol_model_loci__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../../../mol-model/loci */ "./lib/mol-model/loci.js");
/* harmony import */ var _mol_data_int__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../../../mol-data/int */ "./lib/mol-data/int.js");
/* harmony import */ var _mol_geo_primitive_sphere__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../../../mol-geo/primitive/sphere */ "./lib/mol-geo/primitive/sphere.js");
/* harmony import */ var _mol_geo_geometry_mesh_mesh_builder__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../../../mol-geo/geometry/mesh/mesh-builder */ "./lib/mol-geo/geometry/mesh/mesh-builder.js");
/* harmony import */ var _mol_geo_geometry_mesh_builder_sphere__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../../../../mol-geo/geometry/mesh/builder/sphere */ "./lib/mol-geo/geometry/mesh/builder/sphere.js");
/* harmony import */ var _mol_geo_util_location_iterator__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../../../../mol-geo/util/location-iterator */ "./lib/mol-geo/util/location-iterator.js");
/* harmony import */ var _mol_geo_geometry_spheres_spheres_builder__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ../../../../mol-geo/geometry/spheres/spheres-builder */ "./lib/mol-geo/geometry/spheres/spheres-builder.js");
/* harmony import */ var _common__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ./common */ "./lib/mol-repr/structure/visual/util/common.js");
/* harmony import */ var _mol_math_geometry__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ../../../../mol-math/geometry */ "./lib/mol-math/geometry.js");
/**
 * Copyright (c) 2018-2020 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 * @author David Sehnal <david.sehnal@gmail.com>
 */











function makeElementIgnoreTest(unit, props) {
    var ignoreHydrogens = props.ignoreHydrogens, traceOnly = props.traceOnly;
    var atomicNumber = unit.model.atomicHierarchy.derived.atom.atomicNumber;
    var isCoarse = _mol_model_structure__WEBPACK_IMPORTED_MODULE_1__["Unit"].isCoarse(unit);
    if (!isCoarse && ignoreHydrogens && traceOnly) {
        return function (unit, element) { return Object(_common__WEBPACK_IMPORTED_MODULE_9__["isH"])(atomicNumber, element) && !Object(_common__WEBPACK_IMPORTED_MODULE_9__["isTrace"])(unit, element); };
    }
    else if (!isCoarse && ignoreHydrogens) {
        return function (unit, element) { return Object(_common__WEBPACK_IMPORTED_MODULE_9__["isH"])(atomicNumber, element); };
    }
    else if (!isCoarse && traceOnly) {
        return function (unit, element) { return !Object(_common__WEBPACK_IMPORTED_MODULE_9__["isTrace"])(unit, element); };
    }
}
function createElementSphereMesh(ctx, unit, structure, theme, props, mesh) {
    var detail = props.detail, sizeFactor = props.sizeFactor;
    var elements = unit.elements;
    var elementCount = elements.length;
    var vertexCount = elementCount * Object(_mol_geo_primitive_sphere__WEBPACK_IMPORTED_MODULE_4__["sphereVertexCount"])(detail);
    var builderState = _mol_geo_geometry_mesh_mesh_builder__WEBPACK_IMPORTED_MODULE_5__["MeshBuilder"].createState(vertexCount, vertexCount / 2, mesh);
    var v = Object(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"])();
    var pos = unit.conformation.invariantPosition;
    var ignore = makeElementIgnoreTest(unit, props);
    var l = _mol_model_structure__WEBPACK_IMPORTED_MODULE_1__["StructureElement"].Location.create(structure);
    l.unit = unit;
    var maxSize = 0;
    for (var i = 0; i < elementCount; i++) {
        if (ignore && ignore(unit, elements[i]))
            continue;
        l.element = elements[i];
        pos(elements[i], v);
        builderState.currentGroup = i;
        var size = theme.size.size(l);
        if (size > maxSize)
            maxSize = size;
        Object(_mol_geo_geometry_mesh_builder_sphere__WEBPACK_IMPORTED_MODULE_6__["addSphere"])(builderState, v, size * sizeFactor, detail);
    }
    var m = _mol_geo_geometry_mesh_mesh_builder__WEBPACK_IMPORTED_MODULE_5__["MeshBuilder"].getMesh(builderState);
    var sphere = _mol_math_geometry__WEBPACK_IMPORTED_MODULE_10__["Sphere3D"].expand(Object(_mol_math_geometry__WEBPACK_IMPORTED_MODULE_10__["Sphere3D"])(), unit.boundary.sphere, maxSize * sizeFactor + 0.05);
    m.setBoundingSphere(sphere);
    return m;
}
function createElementSphereImpostor(ctx, unit, structure, theme, props, spheres) {
    var elements = unit.elements;
    var elementCount = elements.length;
    var builder = _mol_geo_geometry_spheres_spheres_builder__WEBPACK_IMPORTED_MODULE_8__["SpheresBuilder"].create(elementCount, elementCount / 2, spheres);
    var v = Object(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"])();
    var pos = unit.conformation.invariantPosition;
    var ignore = makeElementIgnoreTest(unit, props);
    var l = _mol_model_structure__WEBPACK_IMPORTED_MODULE_1__["StructureElement"].Location.create(structure, unit);
    var maxSize = 0;
    for (var i = 0; i < elementCount; i++) {
        if (ignore === null || ignore === void 0 ? void 0 : ignore(unit, elements[i]))
            continue;
        pos(elements[i], v);
        builder.add(v[0], v[1], v[2], i);
        l.element = elements[i];
        var size = theme.size.size(l);
        if (size > maxSize)
            maxSize = size;
    }
    var s = builder.getSpheres();
    s.setBoundingSphere(_mol_math_geometry__WEBPACK_IMPORTED_MODULE_10__["Sphere3D"].expand(Object(_mol_math_geometry__WEBPACK_IMPORTED_MODULE_10__["Sphere3D"])(), unit.boundary.sphere, maxSize * props.sizeFactor + 0.05));
    return s;
}
function eachElement(loci, structureGroup, apply) {
    var changed = false;
    if (!_mol_model_structure__WEBPACK_IMPORTED_MODULE_1__["StructureElement"].Loci.is(loci))
        return false;
    var structure = structureGroup.structure, group = structureGroup.group;
    if (!_mol_model_structure__WEBPACK_IMPORTED_MODULE_1__["Structure"].areEquivalent(loci.structure, structure))
        return false;
    var elementCount = group.elements.length;
    for (var _a = 0, _b = loci.elements; _a < _b.length; _a++) {
        var e = _b[_a];
        var unitIdx = group.unitIndexMap.get(e.unit.id);
        if (unitIdx !== undefined) {
            var offset = unitIdx * elementCount; // to target unit instance
            if (_mol_data_int__WEBPACK_IMPORTED_MODULE_3__["Interval"].is(e.indices)) {
                var start = offset + _mol_data_int__WEBPACK_IMPORTED_MODULE_3__["Interval"].start(e.indices);
                var end = offset + _mol_data_int__WEBPACK_IMPORTED_MODULE_3__["Interval"].end(e.indices);
                if (apply(_mol_data_int__WEBPACK_IMPORTED_MODULE_3__["Interval"].ofBounds(start, end)))
                    changed = true;
            }
            else {
                for (var i = 0, _i = e.indices.length; i < _i; i++) {
                    var start = e.indices[i];
                    var endI = i + 1;
                    while (endI < _i && e.indices[endI] === start)
                        endI++;
                    i = endI - 1;
                    var end = e.indices[i];
                    changed = apply(_mol_data_int__WEBPACK_IMPORTED_MODULE_3__["Interval"].ofRange(offset + start, offset + end)) || changed;
                }
            }
        }
    }
    return changed;
}
function getElementLoci(pickingId, structureGroup, id) {
    var objectId = pickingId.objectId, instanceId = pickingId.instanceId, groupId = pickingId.groupId;
    if (id === objectId) {
        var structure = structureGroup.structure, group = structureGroup.group;
        var unit = group.units[instanceId];
        var indices = _mol_data_int__WEBPACK_IMPORTED_MODULE_3__["OrderedSet"].ofSingleton(groupId);
        return _mol_model_structure__WEBPACK_IMPORTED_MODULE_1__["StructureElement"].Loci(structure, [{ unit: unit, indices: indices }]);
    }
    return _mol_model_loci__WEBPACK_IMPORTED_MODULE_2__["EmptyLoci"];
}
//
function eachSerialElement(loci, structure, apply) {
    var changed = false;
    if (!_mol_model_structure__WEBPACK_IMPORTED_MODULE_1__["StructureElement"].Loci.is(loci))
        return false;
    if (!_mol_model_structure__WEBPACK_IMPORTED_MODULE_1__["Structure"].areEquivalent(loci.structure, structure))
        return false;
    var cumulativeUnitElementCount = structure.serialMapping.cumulativeUnitElementCount;
    for (var _a = 0, _b = loci.elements; _a < _b.length; _a++) {
        var e = _b[_a];
        var unitIdx = structure.unitIndexMap.get(e.unit.id);
        if (unitIdx !== undefined) {
            if (_mol_data_int__WEBPACK_IMPORTED_MODULE_3__["Interval"].is(e.indices)) {
                var start = cumulativeUnitElementCount[unitIdx] + _mol_data_int__WEBPACK_IMPORTED_MODULE_3__["Interval"].start(e.indices);
                var end = cumulativeUnitElementCount[unitIdx] + _mol_data_int__WEBPACK_IMPORTED_MODULE_3__["Interval"].end(e.indices);
                if (apply(_mol_data_int__WEBPACK_IMPORTED_MODULE_3__["Interval"].ofBounds(start, end)))
                    changed = true;
            }
            else {
                for (var i = 0, _i = e.indices.length; i < _i; i++) {
                    var idx = cumulativeUnitElementCount[unitIdx] + e.indices[i];
                    if (apply(_mol_data_int__WEBPACK_IMPORTED_MODULE_3__["Interval"].ofSingleton(idx)))
                        changed = true;
                }
            }
        }
    }
    return changed;
}
function getSerialElementLoci(pickingId, structure, id) {
    var objectId = pickingId.objectId, groupId = pickingId.groupId;
    if (id === objectId) {
        var _a = structure.serialMapping, unitIndices = _a.unitIndices, cumulativeUnitElementCount = _a.cumulativeUnitElementCount;
        var unitIdx = unitIndices[groupId];
        var unit = structure.units[unitIdx];
        var idx = groupId - cumulativeUnitElementCount[unitIdx];
        var indices = _mol_data_int__WEBPACK_IMPORTED_MODULE_3__["OrderedSet"].ofSingleton(idx);
        return _mol_model_structure__WEBPACK_IMPORTED_MODULE_1__["StructureElement"].Loci(structure, [{ unit: unit, indices: indices }]);
    }
    return _mol_model_loci__WEBPACK_IMPORTED_MODULE_2__["EmptyLoci"];
}
//
var ElementIterator;
(function (ElementIterator) {
    function fromGroup(structureGroup) {
        var group = structureGroup.group, structure = structureGroup.structure;
        var groupCount = group.elements.length;
        var instanceCount = group.units.length;
        var location = _mol_model_structure__WEBPACK_IMPORTED_MODULE_1__["StructureElement"].Location.create(structure);
        var getLocation = function (groupIndex, instanceIndex) {
            var unit = group.units[instanceIndex];
            location.unit = unit;
            location.element = unit.elements[groupIndex];
            return location;
        };
        return Object(_mol_geo_util_location_iterator__WEBPACK_IMPORTED_MODULE_7__["LocationIterator"])(groupCount, instanceCount, 1, getLocation);
    }
    ElementIterator.fromGroup = fromGroup;
    function fromStructure(structure) {
        var units = structure.units, elementCount = structure.elementCount;
        var groupCount = elementCount;
        var instanceCount = 1;
        var _a = structure.serialMapping, unitIndices = _a.unitIndices, elementIndices = _a.elementIndices;
        var location = _mol_model_structure__WEBPACK_IMPORTED_MODULE_1__["StructureElement"].Location.create(structure);
        var getLocation = function (groupIndex) {
            location.unit = units[unitIndices[groupIndex]];
            location.element = elementIndices[groupIndex];
            return location;
        };
        return Object(_mol_geo_util_location_iterator__WEBPACK_IMPORTED_MODULE_7__["LocationIterator"])(groupCount, instanceCount, 1, getLocation, true);
    }
    ElementIterator.fromStructure = fromStructure;
})(ElementIterator || (ElementIterator = {}));
//# sourceMappingURL=element.js.map

/***/ }),

/***/ "./lib/mol-repr/structure/visual/util/gaussian.js":
/*!********************************************************!*\
  !*** ./lib/mol-repr/structure/visual/util/gaussian.js ***!
  \********************************************************/
/*! exports provided: GaussianDensityParams, DefaultGaussianDensityProps, computeUnitGaussianDensity, computeUnitGaussianDensityTexture, computeUnitGaussianDensityTexture2d, computeStructureGaussianDensity, computeStructureGaussianDensityTexture, computeStructureGaussianDensityTexture2d */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "GaussianDensityParams", function() { return GaussianDensityParams; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DefaultGaussianDensityProps", function() { return DefaultGaussianDensityProps; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "computeUnitGaussianDensity", function() { return computeUnitGaussianDensity; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "computeUnitGaussianDensityTexture", function() { return computeUnitGaussianDensityTexture; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "computeUnitGaussianDensityTexture2d", function() { return computeUnitGaussianDensityTexture2d; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "computeStructureGaussianDensity", function() { return computeStructureGaussianDensity; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "computeStructureGaussianDensityTexture", function() { return computeStructureGaussianDensityTexture; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "computeStructureGaussianDensityTexture2d", function() { return computeStructureGaussianDensityTexture2d; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _mol_task__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../../../mol-task */ "./lib/mol-task/index.js");
/* harmony import */ var _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../../../mol-util/param-definition */ "./lib/mol-util/param-definition.js");
/* harmony import */ var _mol_math_geometry_gaussian_density_gpu__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../../../mol-math/geometry/gaussian-density/gpu */ "./lib/mol-math/geometry/gaussian-density/gpu.js");
/* harmony import */ var _common__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./common */ "./lib/mol-repr/structure/visual/util/common.js");
/* harmony import */ var _mol_geo_geometry_base__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../../../mol-geo/geometry/base */ "./lib/mol-geo/geometry/base.js");
/* harmony import */ var _mol_math_geometry_gaussian_density_cpu__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../../../../mol-math/geometry/gaussian-density/cpu */ "./lib/mol-math/geometry/gaussian-density/cpu.js");
/**
 * Copyright (c) 2018-2021 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */







var GaussianDensityParams = Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({ resolution: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_2__["ParamDefinition"].Numeric(1, { min: 0.1, max: 20, step: 0.1 }, Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({ description: 'Grid resolution/cell spacing.' }, _mol_geo_geometry_base__WEBPACK_IMPORTED_MODULE_5__["BaseGeometry"].CustomQualityParamInfo)), radiusOffset: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_2__["ParamDefinition"].Numeric(0, { min: 0, max: 10, step: 0.1 }, { description: 'Extra/offset radius added to the atoms/coarse elements for gaussian calculation. Useful to create coarse, low resolution surfaces.' }), smoothness: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_2__["ParamDefinition"].Numeric(1.5, { min: 0.5, max: 2.5, step: 0.1 }, { description: 'Smoothness of the gausian surface, lower is smoother.' }) }, _common__WEBPACK_IMPORTED_MODULE_4__["CommonSurfaceParams"]);
var DefaultGaussianDensityProps = _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_2__["ParamDefinition"].getDefaultValues(GaussianDensityParams);
//
function getTextureMaxCells(webgl) {
    var d = Math.min(webgl.maxTextureSize / 2, 4096);
    return d * d;
}
function largestUnitBox(structure) {
    var units = structure.unitsSortedByVolume;
    return units[units.length - 1].lookup3d.boundary.box;
}
//
function computeUnitGaussianDensity(structure, unit, props, webgl) {
    var _this = this;
    var box = unit.lookup3d.boundary.box;
    var p = Object(_common__WEBPACK_IMPORTED_MODULE_4__["ensureReasonableResolution"])(largestUnitBox(structure), props);
    var _a = Object(_common__WEBPACK_IMPORTED_MODULE_4__["getUnitConformationAndRadius"])(structure, unit, p), position = _a.position, radius = _a.radius;
    return _mol_task__WEBPACK_IMPORTED_MODULE_1__["Task"].create('Gaussian Density', function (ctx) { return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"])(_this, void 0, void 0, function () {
        return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__generator"])(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, Object(_mol_math_geometry_gaussian_density_cpu__WEBPACK_IMPORTED_MODULE_6__["GaussianDensityCPU"])(ctx, position, box, radius, p)];
                case 1: return [2 /*return*/, _a.sent()];
            }
        });
    }); });
}
function computeUnitGaussianDensityTexture(structure, unit, props, webgl, texture) {
    var _this = this;
    var box = unit.lookup3d.boundary.box;
    var p = Object(_common__WEBPACK_IMPORTED_MODULE_4__["ensureReasonableResolution"])(largestUnitBox(structure), props, getTextureMaxCells(webgl));
    var _a = Object(_common__WEBPACK_IMPORTED_MODULE_4__["getUnitConformationAndRadius"])(structure, unit, p), position = _a.position, radius = _a.radius;
    return _mol_task__WEBPACK_IMPORTED_MODULE_1__["Task"].create('Gaussian Density', function (ctx) { return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"])(_this, void 0, void 0, function () {
        return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__generator"])(this, function (_a) {
            return [2 /*return*/, Object(_mol_math_geometry_gaussian_density_gpu__WEBPACK_IMPORTED_MODULE_3__["GaussianDensityTexture"])(webgl, position, box, radius, p, texture)];
        });
    }); });
}
function computeUnitGaussianDensityTexture2d(structure, unit, powerOfTwo, props, webgl, texture) {
    var _this = this;
    var box = unit.lookup3d.boundary.box;
    var p = Object(_common__WEBPACK_IMPORTED_MODULE_4__["ensureReasonableResolution"])(largestUnitBox(structure), props, getTextureMaxCells(webgl));
    var _a = Object(_common__WEBPACK_IMPORTED_MODULE_4__["getUnitConformationAndRadius"])(structure, unit, p), position = _a.position, radius = _a.radius;
    return _mol_task__WEBPACK_IMPORTED_MODULE_1__["Task"].create('Gaussian Density', function (ctx) { return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"])(_this, void 0, void 0, function () {
        return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__generator"])(this, function (_a) {
            return [2 /*return*/, Object(_mol_math_geometry_gaussian_density_gpu__WEBPACK_IMPORTED_MODULE_3__["GaussianDensityTexture2d"])(webgl, position, box, radius, powerOfTwo, p, texture)];
        });
    }); });
}
//
function computeStructureGaussianDensity(structure, props, webgl) {
    var _this = this;
    var box = structure.lookup3d.boundary.box;
    var p = Object(_common__WEBPACK_IMPORTED_MODULE_4__["ensureReasonableResolution"])(box, props);
    var _a = Object(_common__WEBPACK_IMPORTED_MODULE_4__["getStructureConformationAndRadius"])(structure, props.ignoreHydrogens, props.traceOnly), position = _a.position, radius = _a.radius;
    return _mol_task__WEBPACK_IMPORTED_MODULE_1__["Task"].create('Gaussian Density', function (ctx) { return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"])(_this, void 0, void 0, function () {
        return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__generator"])(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, Object(_mol_math_geometry_gaussian_density_cpu__WEBPACK_IMPORTED_MODULE_6__["GaussianDensityCPU"])(ctx, position, box, radius, p)];
                case 1: return [2 /*return*/, _a.sent()];
            }
        });
    }); });
}
function computeStructureGaussianDensityTexture(structure, props, webgl, texture) {
    var _this = this;
    var box = structure.lookup3d.boundary.box;
    var p = Object(_common__WEBPACK_IMPORTED_MODULE_4__["ensureReasonableResolution"])(box, props, getTextureMaxCells(webgl));
    var _a = Object(_common__WEBPACK_IMPORTED_MODULE_4__["getStructureConformationAndRadius"])(structure, props.ignoreHydrogens, props.traceOnly), position = _a.position, radius = _a.radius;
    return _mol_task__WEBPACK_IMPORTED_MODULE_1__["Task"].create('Gaussian Density', function (ctx) { return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"])(_this, void 0, void 0, function () {
        return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__generator"])(this, function (_a) {
            return [2 /*return*/, Object(_mol_math_geometry_gaussian_density_gpu__WEBPACK_IMPORTED_MODULE_3__["GaussianDensityTexture"])(webgl, position, box, radius, p, texture)];
        });
    }); });
}
function computeStructureGaussianDensityTexture2d(structure, powerOfTwo, props, webgl, texture) {
    var _this = this;
    var box = structure.lookup3d.boundary.box;
    var p = Object(_common__WEBPACK_IMPORTED_MODULE_4__["ensureReasonableResolution"])(box, props, getTextureMaxCells(webgl));
    var _a = Object(_common__WEBPACK_IMPORTED_MODULE_4__["getStructureConformationAndRadius"])(structure, props.ignoreHydrogens, props.traceOnly), position = _a.position, radius = _a.radius;
    return _mol_task__WEBPACK_IMPORTED_MODULE_1__["Task"].create('Gaussian Density', function (ctx) { return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"])(_this, void 0, void 0, function () {
        return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__generator"])(this, function (_a) {
            return [2 /*return*/, Object(_mol_math_geometry_gaussian_density_gpu__WEBPACK_IMPORTED_MODULE_3__["GaussianDensityTexture2d"])(webgl, position, box, radius, powerOfTwo, p, texture)];
        });
    }); });
}
//# sourceMappingURL=gaussian.js.map

/***/ }),

/***/ "./lib/mol-repr/structure/visual/util/link.js":
/*!****************************************************!*\
  !*** ./lib/mol-repr/structure/visual/util/link.js ***!
  \****************************************************/
/*! exports provided: LinkCylinderParams, DefaultLinkCylinderProps, LinkLineParams, DefaultLinkLineProps, calculateShiftDir, createLinkCylinderMesh, createLinkCylinderImpostors, createLinkLines */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "LinkCylinderParams", function() { return LinkCylinderParams; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DefaultLinkCylinderProps", function() { return DefaultLinkCylinderProps; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "LinkLineParams", function() { return LinkLineParams; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DefaultLinkLineProps", function() { return DefaultLinkLineProps; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "calculateShiftDir", function() { return calculateShiftDir; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createLinkCylinderMesh", function() { return createLinkCylinderMesh; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createLinkCylinderImpostors", function() { return createLinkCylinderImpostors; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createLinkLines", function() { return createLinkLines; });
/* harmony import */ var _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../../../mol-math/linear-algebra */ "./lib/mol-math/linear-algebra.js");
/* harmony import */ var _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../../../mol-util/param-definition */ "./lib/mol-util/param-definition.js");
/* harmony import */ var _mol_geo_geometry_mesh_mesh__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../../../mol-geo/geometry/mesh/mesh */ "./lib/mol-geo/geometry/mesh/mesh.js");
/* harmony import */ var _mol_geo_geometry_mesh_mesh_builder__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../../../mol-geo/geometry/mesh/mesh-builder */ "./lib/mol-geo/geometry/mesh/mesh-builder.js");
/* harmony import */ var _mol_geo_geometry_mesh_builder_cylinder__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../../../mol-geo/geometry/mesh/builder/cylinder */ "./lib/mol-geo/geometry/mesh/builder/cylinder.js");
/* harmony import */ var _mol_geo_geometry_base__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../../../mol-geo/geometry/base */ "./lib/mol-geo/geometry/base.js");
/* harmony import */ var _mol_geo_geometry_lines_lines__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../../../../mol-geo/geometry/lines/lines */ "./lib/mol-geo/geometry/lines/lines.js");
/* harmony import */ var _mol_geo_geometry_lines_lines_builder__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../../../../mol-geo/geometry/lines/lines-builder */ "./lib/mol-geo/geometry/lines/lines-builder.js");
/* harmony import */ var _mol_geo_geometry_cylinders_cylinders__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ../../../../mol-geo/geometry/cylinders/cylinders */ "./lib/mol-geo/geometry/cylinders/cylinders.js");
/* harmony import */ var _mol_geo_geometry_cylinders_cylinders_builder__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ../../../../mol-geo/geometry/cylinders/cylinders-builder */ "./lib/mol-geo/geometry/cylinders/cylinders-builder.js");
/**
 * Copyright (c) 2018-2020 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */










var LinkCylinderParams = {
    linkScale: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_1__["ParamDefinition"].Numeric(0.4, { min: 0, max: 1, step: 0.1 }),
    linkSpacing: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_1__["ParamDefinition"].Numeric(1, { min: 0, max: 2, step: 0.01 }),
    linkCap: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_1__["ParamDefinition"].Boolean(false),
    dashCount: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_1__["ParamDefinition"].Numeric(4, { min: 2, max: 10, step: 2 }),
    dashScale: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_1__["ParamDefinition"].Numeric(0.8, { min: 0, max: 2, step: 0.1 }),
    dashCap: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_1__["ParamDefinition"].Boolean(true),
    radialSegments: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_1__["ParamDefinition"].Numeric(16, { min: 2, max: 56, step: 2 }, _mol_geo_geometry_base__WEBPACK_IMPORTED_MODULE_5__["BaseGeometry"].CustomQualityParamInfo),
};
var DefaultLinkCylinderProps = _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_1__["ParamDefinition"].getDefaultValues(LinkCylinderParams);
var LinkLineParams = {
    linkScale: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_1__["ParamDefinition"].Numeric(0.5, { min: 0, max: 1, step: 0.1 }),
    linkSpacing: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_1__["ParamDefinition"].Numeric(0.1, { min: 0, max: 2, step: 0.01 }),
    dashCount: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_1__["ParamDefinition"].Numeric(4, { min: 2, max: 10, step: 2 }),
};
var DefaultLinkLineProps = _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_1__["ParamDefinition"].getDefaultValues(LinkLineParams);
var tmpV12 = Object(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"])();
var tmpShiftV12 = Object(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"])();
var tmpShiftV13 = Object(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"])();
var up = _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"].create(0, 1, 0);
/** Calculate 'shift' direction that is perpendiculat to v1 - v2 and goes through v3 */
function calculateShiftDir(out, v1, v2, v3) {
    _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"].normalize(tmpShiftV12, _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"].sub(tmpShiftV12, v1, v2));
    if (v3 !== null) {
        _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"].sub(tmpShiftV13, v1, v3);
    }
    else {
        _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"].copy(tmpShiftV13, v1); // no reference point, use v1
    }
    _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"].normalize(tmpShiftV13, tmpShiftV13);
    // ensure v13 and v12 are not colinear
    var dp = _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"].dot(tmpShiftV12, tmpShiftV13);
    if (1 - Math.abs(dp) < 1e-5) {
        _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"].set(tmpShiftV13, 1, 0, 0);
        dp = _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"].dot(tmpShiftV12, tmpShiftV13);
        if (1 - Math.abs(dp) < 1e-5) {
            _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"].set(tmpShiftV13, 0, 1, 0);
            dp = _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"].dot(tmpShiftV12, tmpShiftV13);
        }
    }
    _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"].setMagnitude(tmpShiftV12, tmpShiftV12, dp);
    _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"].sub(tmpShiftV13, tmpShiftV13, tmpShiftV12);
    return _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"].normalize(out, tmpShiftV13);
}
// avoiding namespace lookup improved performance in Chrome (Aug 2020)
var v3scale = _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"].scale;
var v3add = _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"].add;
var v3sub = _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"].sub;
var v3setMagnitude = _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"].setMagnitude;
var v3dot = _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"].dot;
/**
 * Each edge is included twice to allow for coloring/picking
 * the half closer to the first vertex, i.e. vertex a.
 */
function createLinkCylinderMesh(ctx, linkBuilder, props, mesh) {
    var linkCount = linkBuilder.linkCount, referencePosition = linkBuilder.referencePosition, position = linkBuilder.position, style = linkBuilder.style, radius = linkBuilder.radius, ignore = linkBuilder.ignore;
    if (!linkCount)
        return _mol_geo_geometry_mesh_mesh__WEBPACK_IMPORTED_MODULE_2__["Mesh"].createEmpty(mesh);
    var linkScale = props.linkScale, linkSpacing = props.linkSpacing, radialSegments = props.radialSegments, linkCap = props.linkCap, dashCount = props.dashCount, dashScale = props.dashScale, dashCap = props.dashCap;
    var vertexCountEstimate = radialSegments * 2 * linkCount * 2;
    var builderState = _mol_geo_geometry_mesh_mesh_builder__WEBPACK_IMPORTED_MODULE_3__["MeshBuilder"].createState(vertexCountEstimate, vertexCountEstimate / 4, mesh);
    var va = Object(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"])();
    var vb = Object(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"])();
    var vShift = Object(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"])();
    var cylinderProps = {
        radiusTop: 1,
        radiusBottom: 1,
        radialSegments: radialSegments,
        topCap: linkCap,
        bottomCap: linkCap
    };
    var segmentCount = dashCount + 1;
    for (var edgeIndex = 0, _eI = linkCount; edgeIndex < _eI; ++edgeIndex) {
        if (ignore && ignore(edgeIndex))
            continue;
        position(va, vb, edgeIndex);
        v3sub(tmpV12, vb, va);
        var linkRadius = radius(edgeIndex);
        var linkStyle = style ? style(edgeIndex) : 0 /* Solid */;
        var _a = (v3dot(tmpV12, up) > 0) ? [false, linkCap] : [linkCap, false], topCap = _a[0], bottomCap = _a[1];
        builderState.currentGroup = edgeIndex;
        if (linkStyle === 0 /* Solid */) {
            cylinderProps.radiusTop = cylinderProps.radiusBottom = linkRadius;
            cylinderProps.topCap = topCap;
            cylinderProps.bottomCap = bottomCap;
            Object(_mol_geo_geometry_mesh_builder_cylinder__WEBPACK_IMPORTED_MODULE_4__["addCylinder"])(builderState, va, vb, 0.5, cylinderProps);
        }
        else if (linkStyle === 1 /* Dashed */) {
            cylinderProps.radiusTop = cylinderProps.radiusBottom = linkRadius * dashScale;
            cylinderProps.topCap = cylinderProps.bottomCap = dashCap;
            Object(_mol_geo_geometry_mesh_builder_cylinder__WEBPACK_IMPORTED_MODULE_4__["addFixedCountDashedCylinder"])(builderState, va, vb, 0.5, segmentCount, cylinderProps);
        }
        else if (linkStyle === 2 /* Double */ || linkStyle === 3 /* Triple */) {
            var order = linkStyle === 2 /* Double */ ? 2 : 3;
            var multiRadius = linkRadius * (linkScale / (0.5 * order));
            var absOffset = (linkRadius - multiRadius) * linkSpacing;
            calculateShiftDir(vShift, va, vb, referencePosition ? referencePosition(edgeIndex) : null);
            v3setMagnitude(vShift, vShift, absOffset);
            cylinderProps.radiusTop = cylinderProps.radiusBottom = multiRadius;
            cylinderProps.topCap = topCap;
            cylinderProps.bottomCap = bottomCap;
            if (order === 3)
                Object(_mol_geo_geometry_mesh_builder_cylinder__WEBPACK_IMPORTED_MODULE_4__["addCylinder"])(builderState, va, vb, 0.5, cylinderProps);
            Object(_mol_geo_geometry_mesh_builder_cylinder__WEBPACK_IMPORTED_MODULE_4__["addDoubleCylinder"])(builderState, va, vb, 0.5, vShift, cylinderProps);
        }
        else if (linkStyle === 4 /* Disk */) {
            v3scale(tmpV12, tmpV12, 0.475);
            v3add(va, va, tmpV12);
            v3sub(vb, vb, tmpV12);
            cylinderProps.radiusTop = cylinderProps.radiusBottom = linkRadius;
            cylinderProps.topCap = topCap;
            cylinderProps.bottomCap = bottomCap;
            Object(_mol_geo_geometry_mesh_builder_cylinder__WEBPACK_IMPORTED_MODULE_4__["addCylinder"])(builderState, va, vb, 0.5, cylinderProps);
        }
    }
    return _mol_geo_geometry_mesh_mesh_builder__WEBPACK_IMPORTED_MODULE_3__["MeshBuilder"].getMesh(builderState);
}
/**
 * Each edge is included twice to allow for coloring/picking
 * the half closer to the first vertex, i.e. vertex a.
 */
function createLinkCylinderImpostors(ctx, linkBuilder, props, cylinders) {
    var linkCount = linkBuilder.linkCount, referencePosition = linkBuilder.referencePosition, position = linkBuilder.position, style = linkBuilder.style, radius = linkBuilder.radius, ignore = linkBuilder.ignore;
    if (!linkCount)
        return _mol_geo_geometry_cylinders_cylinders__WEBPACK_IMPORTED_MODULE_8__["Cylinders"].createEmpty(cylinders);
    var linkScale = props.linkScale, linkSpacing = props.linkSpacing, linkCap = props.linkCap, dashCount = props.dashCount, dashScale = props.dashScale, dashCap = props.dashCap;
    var cylindersCountEstimate = linkCount * 2;
    var builder = _mol_geo_geometry_cylinders_cylinders_builder__WEBPACK_IMPORTED_MODULE_9__["CylindersBuilder"].create(cylindersCountEstimate, cylindersCountEstimate / 4, cylinders);
    var va = Object(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"])();
    var vb = Object(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"])();
    var vShift = Object(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"])();
    // automatically adjust length for evenly spaced dashed cylinders
    var segmentCount = dashCount % 2 === 1 ? dashCount : dashCount + 1;
    var lengthScale = 0.5 - (0.5 / 2 / segmentCount);
    for (var edgeIndex = 0, _eI = linkCount; edgeIndex < _eI; ++edgeIndex) {
        if (ignore && ignore(edgeIndex))
            continue;
        position(va, vb, edgeIndex);
        var linkRadius = radius(edgeIndex);
        var linkStyle = style ? style(edgeIndex) : 0 /* Solid */;
        if (linkStyle === 0 /* Solid */) {
            v3scale(vb, v3add(vb, va, vb), 0.5);
            builder.add(va[0], va[1], va[2], vb[0], vb[1], vb[2], 1, linkCap, false, edgeIndex);
        }
        else if (linkStyle === 1 /* Dashed */) {
            v3scale(tmpV12, v3sub(tmpV12, vb, va), lengthScale);
            v3sub(vb, vb, tmpV12);
            builder.addFixedCountDashes(va, vb, segmentCount, dashScale, dashCap, dashCap, edgeIndex);
        }
        else if (linkStyle === 2 /* Double */ || linkStyle === 3 /* Triple */) {
            v3scale(vb, v3add(vb, va, vb), 0.5);
            var order = linkStyle === 2 /* Double */ ? 2 : 3;
            var multiScale = linkScale / (0.5 * order);
            var absOffset = (linkRadius - multiScale * linkRadius) * linkSpacing;
            calculateShiftDir(vShift, va, vb, referencePosition ? referencePosition(edgeIndex) : null);
            v3setMagnitude(vShift, vShift, absOffset);
            if (order === 3)
                builder.add(va[0], va[1], va[2], vb[0], vb[1], vb[2], multiScale, linkCap, false, edgeIndex);
            builder.add(va[0] + vShift[0], va[1] + vShift[1], va[2] + vShift[2], vb[0] + vShift[0], vb[1] + vShift[1], vb[2] + vShift[2], multiScale, linkCap, false, edgeIndex);
            builder.add(va[0] - vShift[0], va[1] - vShift[1], va[2] - vShift[2], vb[0] - vShift[0], vb[1] - vShift[1], vb[2] - vShift[2], multiScale, linkCap, false, edgeIndex);
        }
        else if (linkStyle === 4 /* Disk */) {
            v3scale(tmpV12, v3sub(tmpV12, vb, va), 0.475);
            v3add(va, va, tmpV12);
            v3sub(vb, vb, tmpV12);
            builder.add(va[0], va[1], va[2], vb[0], vb[1], vb[2], 1, linkCap, false, edgeIndex);
        }
    }
    return builder.getCylinders();
}
/**
 * Each edge is included twice to allow for coloring/picking
 * the half closer to the first vertex, i.e. vertex a.
 */
function createLinkLines(ctx, linkBuilder, props, lines) {
    var linkCount = linkBuilder.linkCount, referencePosition = linkBuilder.referencePosition, position = linkBuilder.position, style = linkBuilder.style, ignore = linkBuilder.ignore;
    if (!linkCount)
        return _mol_geo_geometry_lines_lines__WEBPACK_IMPORTED_MODULE_6__["Lines"].createEmpty(lines);
    var linkScale = props.linkScale, linkSpacing = props.linkSpacing, dashCount = props.dashCount;
    var linesCountEstimate = linkCount * 2;
    var builder = _mol_geo_geometry_lines_lines_builder__WEBPACK_IMPORTED_MODULE_7__["LinesBuilder"].create(linesCountEstimate, linesCountEstimate / 4, lines);
    var va = Object(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"])();
    var vb = Object(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"])();
    var vShift = Object(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"])();
    // automatically adjust length for evenly spaced dashed lines
    var segmentCount = dashCount % 2 === 1 ? dashCount : dashCount + 1;
    var lengthScale = 0.5 - (0.5 / 2 / segmentCount);
    for (var edgeIndex = 0, _eI = linkCount; edgeIndex < _eI; ++edgeIndex) {
        if (ignore && ignore(edgeIndex))
            continue;
        position(va, vb, edgeIndex);
        var linkStyle = style ? style(edgeIndex) : 0 /* Solid */;
        if (linkStyle === 0 /* Solid */) {
            v3scale(vb, v3add(vb, va, vb), 0.5);
            builder.add(va[0], va[1], va[2], vb[0], vb[1], vb[2], edgeIndex);
        }
        else if (linkStyle === 1 /* Dashed */) {
            v3scale(tmpV12, v3sub(tmpV12, vb, va), lengthScale);
            v3sub(vb, vb, tmpV12);
            builder.addFixedCountDashes(va, vb, segmentCount, edgeIndex);
        }
        else if (linkStyle === 2 /* Double */ || linkStyle === 3 /* Triple */) {
            v3scale(vb, v3add(vb, va, vb), 0.5);
            var order = linkStyle === 2 /* Double */ ? 2 : 3;
            var multiRadius = 1 * (linkScale / (0.5 * order));
            var absOffset = (1 - multiRadius) * linkSpacing;
            calculateShiftDir(vShift, va, vb, referencePosition ? referencePosition(edgeIndex) : null);
            v3setMagnitude(vShift, vShift, absOffset);
            if (order === 3)
                builder.add(va[0], va[1], va[2], vb[0], vb[1], vb[2], edgeIndex);
            builder.add(va[0] + vShift[0], va[1] + vShift[1], va[2] + vShift[2], vb[0] + vShift[0], vb[1] + vShift[1], vb[2] + vShift[2], edgeIndex);
            builder.add(va[0] - vShift[0], va[1] - vShift[1], va[2] - vShift[2], vb[0] - vShift[0], vb[1] - vShift[1], vb[2] - vShift[2], edgeIndex);
        }
        else if (linkStyle === 4 /* Disk */) {
            v3scale(tmpV12, v3sub(tmpV12, vb, va), 0.475);
            v3add(va, va, tmpV12);
            v3sub(vb, vb, tmpV12);
            // TODO what to do here? Line as disk doesn't work well.
            builder.add(va[0], va[1], va[2], vb[0], vb[1], vb[2], edgeIndex);
        }
    }
    return builder.getLines();
}
//# sourceMappingURL=link.js.map

/***/ }),

/***/ "./lib/mol-repr/structure/visual/util/molecular-surface.js":
/*!*****************************************************************!*\
  !*** ./lib/mol-repr/structure/visual/util/molecular-surface.js ***!
  \*****************************************************************/
/*! exports provided: computeUnitMolecularSurface */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "computeUnitMolecularSurface", function() { return computeUnitMolecularSurface; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _mol_task__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../../../mol-task */ "./lib/mol-task/index.js");
/* harmony import */ var _common__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./common */ "./lib/mol-repr/structure/visual/util/common.js");
/* harmony import */ var _mol_math_geometry_molecular_surface__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../../../mol-math/geometry/molecular-surface */ "./lib/mol-math/geometry/molecular-surface.js");
/* harmony import */ var _mol_data_int__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../../../mol-data/int */ "./lib/mol-data/int.js");
/**
 * Copyright (c) 2019-2020 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */





function getPositionDataAndMaxRadius(structure, unit, props) {
    var probeRadius = props.probeRadius;
    var _a = Object(_common__WEBPACK_IMPORTED_MODULE_2__["getUnitConformationAndRadius"])(structure, unit, props), position = _a.position, boundary = _a.boundary, radius = _a.radius;
    var indices = position.indices;
    var n = _mol_data_int__WEBPACK_IMPORTED_MODULE_4__["OrderedSet"].size(indices);
    var radii = new Float32Array(_mol_data_int__WEBPACK_IMPORTED_MODULE_4__["OrderedSet"].end(indices));
    var maxRadius = 0;
    for (var i = 0; i < n; ++i) {
        var j = _mol_data_int__WEBPACK_IMPORTED_MODULE_4__["OrderedSet"].getAt(indices, i);
        var r = radius(j);
        if (maxRadius < r)
            maxRadius = r;
        radii[j] = r + probeRadius;
    }
    return { position: Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, position), { radius: radii }), boundary: boundary, maxRadius: maxRadius };
}
function computeUnitMolecularSurface(structure, unit, props) {
    var _this = this;
    var box = unit.lookup3d.boundary.box;
    var p = Object(_common__WEBPACK_IMPORTED_MODULE_2__["ensureReasonableResolution"])(box, props);
    var _a = getPositionDataAndMaxRadius(structure, unit, p), position = _a.position, boundary = _a.boundary, maxRadius = _a.maxRadius;
    return _mol_task__WEBPACK_IMPORTED_MODULE_1__["Task"].create('Molecular Surface', function (ctx) { return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"])(_this, void 0, void 0, function () {
        return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__generator"])(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, MolecularSurface(ctx, position, boundary, maxRadius, box, p)];
                case 1: return [2 /*return*/, _a.sent()];
            }
        });
    }); });
}
//
function MolecularSurface(ctx, position, boundary, maxRadius, box, props) {
    return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"])(this, void 0, void 0, function () {
        return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__generator"])(this, function (_a) {
            return [2 /*return*/, Object(_mol_math_geometry_molecular_surface__WEBPACK_IMPORTED_MODULE_3__["calcMolecularSurface"])(ctx, position, boundary, maxRadius, box, props)];
        });
    });
}
//# sourceMappingURL=molecular-surface.js.map

/***/ }),

/***/ "./lib/mol-repr/structure/visual/util/nucleotide.js":
/*!**********************************************************!*\
  !*** ./lib/mol-repr/structure/visual/util/nucleotide.js ***!
  \**********************************************************/
/*! exports provided: NucleotideLocationIterator, getNucleotideElementLoci, eachNucleotideElement */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "NucleotideLocationIterator", function() { return NucleotideLocationIterator; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getNucleotideElementLoci", function() { return getNucleotideElementLoci; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "eachNucleotideElement", function() { return eachNucleotideElement; });
/* harmony import */ var _mol_model_structure__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../../../mol-model/structure */ "./lib/mol-model/structure.js");
/* harmony import */ var _mol_model_loci__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../../../mol-model/loci */ "./lib/mol-model/loci.js");
/* harmony import */ var _mol_geo_util_location_iterator__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../../../mol-geo/util/location-iterator */ "./lib/mol-geo/util/location-iterator.js");
/* harmony import */ var _common__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./common */ "./lib/mol-repr/structure/visual/util/common.js");
/* harmony import */ var _polymer__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./polymer */ "./lib/mol-repr/structure/visual/util/polymer.js");
/**
 * Copyright (c) 2018 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */





var NucleotideLocationIterator;
(function (NucleotideLocationIterator) {
    function fromGroup(structureGroup) {
        var group = structureGroup.group, structure = structureGroup.structure;
        var u = group.units[0];
        var nucleotideElementIndices = _mol_model_structure__WEBPACK_IMPORTED_MODULE_0__["Unit"].isAtomic(u) ? u.nucleotideElements : [];
        var groupCount = nucleotideElementIndices.length;
        var instanceCount = group.units.length;
        var location = _mol_model_structure__WEBPACK_IMPORTED_MODULE_0__["StructureElement"].Location.create(structure);
        var getLocation = function (groupIndex, instanceIndex) {
            var unit = group.units[instanceIndex];
            location.unit = unit;
            location.element = nucleotideElementIndices[groupIndex];
            return location;
        };
        return Object(_mol_geo_util_location_iterator__WEBPACK_IMPORTED_MODULE_2__["LocationIterator"])(groupCount, instanceCount, 1, getLocation);
    }
    NucleotideLocationIterator.fromGroup = fromGroup;
})(NucleotideLocationIterator || (NucleotideLocationIterator = {}));
function getNucleotideElementLoci(pickingId, structureGroup, id) {
    var objectId = pickingId.objectId, instanceId = pickingId.instanceId, groupId = pickingId.groupId;
    if (id === objectId) {
        var structure = structureGroup.structure, group = structureGroup.group;
        var unit = group.units[instanceId];
        if (_mol_model_structure__WEBPACK_IMPORTED_MODULE_0__["Unit"].isAtomic(unit)) {
            return Object(_common__WEBPACK_IMPORTED_MODULE_3__["getResidueLoci"])(structure, unit, unit.nucleotideElements[groupId]);
        }
    }
    return _mol_model_loci__WEBPACK_IMPORTED_MODULE_1__["EmptyLoci"];
}
function selectNuclotideElements(u) { return u.nucleotideElements; }
/**
 * Mark a nucleotide element (e.g. part of a cartoon block)
 * - mark only when all its residue's elements are in a loci
 */
function eachNucleotideElement(loci, structureGroup, apply) {
    var changed = false;
    if (!_mol_model_structure__WEBPACK_IMPORTED_MODULE_0__["StructureElement"].Loci.is(loci))
        return false;
    var structure = structureGroup.structure, group = structureGroup.group;
    if (!_mol_model_structure__WEBPACK_IMPORTED_MODULE_0__["Structure"].areEquivalent(loci.structure, structure))
        return false;
    var unit = group.units[0];
    if (!_mol_model_structure__WEBPACK_IMPORTED_MODULE_0__["Unit"].isAtomic(unit))
        return false;
    var nucleotideElements = unit.nucleotideElements;
    var groupCount = nucleotideElements.length;
    for (var _i = 0, _a = loci.elements; _i < _a.length; _i++) {
        var e = _a[_i];
        if (!_mol_model_structure__WEBPACK_IMPORTED_MODULE_0__["Unit"].isAtomic(e.unit))
            continue;
        if (!group.unitIndexMap.has(e.unit.id))
            continue;
        var intervalOffset = group.unitIndexMap.get(e.unit.id) * groupCount;
        if (_mol_model_structure__WEBPACK_IMPORTED_MODULE_0__["Unit"].isAtomic(e.unit)) {
            changed = Object(_polymer__WEBPACK_IMPORTED_MODULE_4__["eachAtomicUnitTracedElement"])(intervalOffset, groupCount, selectNuclotideElements, apply, e) || changed;
        }
    }
    return changed;
}
//# sourceMappingURL=nucleotide.js.map

/***/ }),

/***/ "./lib/mol-repr/structure/visual/util/polymer.js":
/*!*******************************************************!*\
  !*** ./lib/mol-repr/structure/visual/util/polymer.js ***!
  \*******************************************************/
/*! exports provided: PolymerBackboneIterator, AtomicPolymerBackboneIterator, CoarsePolymerBackboneIterator, PolymerGapIterator, AtomicPolymerGapIterator, CoarsePolymerGapIterator, PolymerTraceIterator, AtomicPolymerTraceIterator, CoarsePolymerTraceIterator, createCurveSegmentState, interpolateCurveSegment, interpolatePointsAndTangents, interpolateNormals, interpolateSizes, StandardTension, HelixTension, StandardShift, NucleicShift, OverhangFactor, getPolymerRanges, getGapRanges, PolymerLocationIterator, PolymerGapLocationIterator, getPolymerElementLoci, eachAtomicUnitTracedElement, eachPolymerElement, getPolymerGapElementLoci, eachPolymerGapElement */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "StandardTension", function() { return StandardTension; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "HelixTension", function() { return HelixTension; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "StandardShift", function() { return StandardShift; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "NucleicShift", function() { return NucleicShift; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "OverhangFactor", function() { return OverhangFactor; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getPolymerRanges", function() { return getPolymerRanges; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getGapRanges", function() { return getGapRanges; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "PolymerLocationIterator", function() { return PolymerLocationIterator; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "PolymerGapLocationIterator", function() { return PolymerGapLocationIterator; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getPolymerElementLoci", function() { return getPolymerElementLoci; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "eachAtomicUnitTracedElement", function() { return eachAtomicUnitTracedElement; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "eachPolymerElement", function() { return eachPolymerElement; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getPolymerGapElementLoci", function() { return getPolymerGapElementLoci; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "eachPolymerGapElement", function() { return eachPolymerGapElement; });
/* harmony import */ var _mol_model_structure__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../../../mol-model/structure */ "./lib/mol-model/structure.js");
/* harmony import */ var _mol_data_int__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../../../mol-data/int */ "./lib/mol-data/int.js");
/* harmony import */ var _mol_model_loci__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../../../mol-model/loci */ "./lib/mol-model/loci.js");
/* harmony import */ var _mol_geo_util_location_iterator__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../../../mol-geo/util/location-iterator */ "./lib/mol-geo/util/location-iterator.js");
/* harmony import */ var _common__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./common */ "./lib/mol-repr/structure/visual/util/common.js");
/* harmony import */ var _polymer_backbone_iterator__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./polymer/backbone-iterator */ "./lib/mol-repr/structure/visual/util/polymer/backbone-iterator.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "PolymerBackboneIterator", function() { return _polymer_backbone_iterator__WEBPACK_IMPORTED_MODULE_5__["PolymerBackboneIterator"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "AtomicPolymerBackboneIterator", function() { return _polymer_backbone_iterator__WEBPACK_IMPORTED_MODULE_5__["AtomicPolymerBackboneIterator"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "CoarsePolymerBackboneIterator", function() { return _polymer_backbone_iterator__WEBPACK_IMPORTED_MODULE_5__["CoarsePolymerBackboneIterator"]; });

/* harmony import */ var _polymer_gap_iterator__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ./polymer/gap-iterator */ "./lib/mol-repr/structure/visual/util/polymer/gap-iterator.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "PolymerGapIterator", function() { return _polymer_gap_iterator__WEBPACK_IMPORTED_MODULE_6__["PolymerGapIterator"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "AtomicPolymerGapIterator", function() { return _polymer_gap_iterator__WEBPACK_IMPORTED_MODULE_6__["AtomicPolymerGapIterator"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "CoarsePolymerGapIterator", function() { return _polymer_gap_iterator__WEBPACK_IMPORTED_MODULE_6__["CoarsePolymerGapIterator"]; });

/* harmony import */ var _polymer_trace_iterator__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ./polymer/trace-iterator */ "./lib/mol-repr/structure/visual/util/polymer/trace-iterator.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "PolymerTraceIterator", function() { return _polymer_trace_iterator__WEBPACK_IMPORTED_MODULE_7__["PolymerTraceIterator"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "AtomicPolymerTraceIterator", function() { return _polymer_trace_iterator__WEBPACK_IMPORTED_MODULE_7__["AtomicPolymerTraceIterator"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "CoarsePolymerTraceIterator", function() { return _polymer_trace_iterator__WEBPACK_IMPORTED_MODULE_7__["CoarsePolymerTraceIterator"]; });

/* harmony import */ var _polymer_curve_segment__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ./polymer/curve-segment */ "./lib/mol-repr/structure/visual/util/polymer/curve-segment.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "createCurveSegmentState", function() { return _polymer_curve_segment__WEBPACK_IMPORTED_MODULE_8__["createCurveSegmentState"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "interpolateCurveSegment", function() { return _polymer_curve_segment__WEBPACK_IMPORTED_MODULE_8__["interpolateCurveSegment"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "interpolatePointsAndTangents", function() { return _polymer_curve_segment__WEBPACK_IMPORTED_MODULE_8__["interpolatePointsAndTangents"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "interpolateNormals", function() { return _polymer_curve_segment__WEBPACK_IMPORTED_MODULE_8__["interpolateNormals"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "interpolateSizes", function() { return _polymer_curve_segment__WEBPACK_IMPORTED_MODULE_8__["interpolateSizes"]; });

/**
 * Copyright (c) 2018-2019 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 * @author David Sehnal <david.sehnal@gmail.com>
 */









var StandardTension = 0.5;
var HelixTension = 0.9;
var StandardShift = 0.5;
var NucleicShift = 0.3;
var OverhangFactor = 2;
function getPolymerRanges(unit) {
    switch (unit.kind) {
        case 0 /* Atomic */: return unit.model.atomicRanges.polymerRanges;
        case 1 /* Spheres */: return unit.model.coarseHierarchy.spheres.polymerRanges;
        case 2 /* Gaussians */: return unit.model.coarseHierarchy.gaussians.polymerRanges;
    }
}
function getGapRanges(unit) {
    switch (unit.kind) {
        case 0 /* Atomic */: return unit.model.atomicRanges.gapRanges;
        case 1 /* Spheres */: return unit.model.coarseHierarchy.spheres.gapRanges;
        case 2 /* Gaussians */: return unit.model.coarseHierarchy.gaussians.gapRanges;
    }
}
var PolymerLocationIterator;
(function (PolymerLocationIterator) {
    function fromGroup(structureGroup) {
        var group = structureGroup.group, structure = structureGroup.structure;
        var polymerElements = group.units[0].polymerElements;
        var groupCount = polymerElements.length;
        var instanceCount = group.units.length;
        var location = _mol_model_structure__WEBPACK_IMPORTED_MODULE_0__["StructureElement"].Location.create(structure);
        var getLocation = function (groupIndex, instanceIndex) {
            var unit = group.units[instanceIndex];
            location.unit = unit;
            location.element = polymerElements[groupIndex];
            return location;
        };
        return Object(_mol_geo_util_location_iterator__WEBPACK_IMPORTED_MODULE_3__["LocationIterator"])(groupCount, instanceCount, 1, getLocation);
    }
    PolymerLocationIterator.fromGroup = fromGroup;
})(PolymerLocationIterator || (PolymerLocationIterator = {}));
var PolymerGapLocationIterator;
(function (PolymerGapLocationIterator) {
    function fromGroup(structureGroup) {
        var group = structureGroup.group, structure = structureGroup.structure;
        var gapElements = group.units[0].gapElements;
        var groupCount = gapElements.length;
        var instanceCount = group.units.length;
        var location = _mol_model_structure__WEBPACK_IMPORTED_MODULE_0__["StructureElement"].Location.create(structure);
        var getLocation = function (groupIndex, instanceIndex) {
            var unit = group.units[instanceIndex];
            location.unit = unit;
            location.element = gapElements[groupIndex];
            return location;
        };
        return Object(_mol_geo_util_location_iterator__WEBPACK_IMPORTED_MODULE_3__["LocationIterator"])(groupCount, instanceCount, 1, getLocation);
    }
    PolymerGapLocationIterator.fromGroup = fromGroup;
})(PolymerGapLocationIterator || (PolymerGapLocationIterator = {}));
/** Return a Loci for the elements of the whole residue of a polymer element. */
function getPolymerElementLoci(pickingId, structureGroup, id) {
    var objectId = pickingId.objectId, instanceId = pickingId.instanceId, groupId = pickingId.groupId;
    if (id === objectId) {
        var structure = structureGroup.structure, group = structureGroup.group;
        var unit = group.units[instanceId];
        if (_mol_model_structure__WEBPACK_IMPORTED_MODULE_0__["Unit"].isAtomic(unit)) {
            return Object(_common__WEBPACK_IMPORTED_MODULE_4__["getResidueLoci"])(structure, unit, unit.polymerElements[groupId]);
        }
        else {
            var elements = unit.elements;
            var elementIndex = unit.polymerElements[groupId];
            var unitIndex = _mol_data_int__WEBPACK_IMPORTED_MODULE_1__["OrderedSet"].indexOf(elements, elementIndex);
            if (unitIndex !== -1) {
                var indices = _mol_data_int__WEBPACK_IMPORTED_MODULE_1__["OrderedSet"].ofSingleton(unitIndex);
                return _mol_model_structure__WEBPACK_IMPORTED_MODULE_0__["StructureElement"].Loci(structure, [{ unit: unit, indices: indices }]);
            }
        }
    }
    return _mol_model_loci__WEBPACK_IMPORTED_MODULE_2__["EmptyLoci"];
}
function tryApplyResidueInterval(offset, elements, traceElementIndex, apply, r1, r2) {
    var start = -1, startIdx = -1;
    for (var rI = r1; rI <= r2; rI++) {
        var eI = traceElementIndex[rI];
        if (eI < 0)
            continue;
        start = _mol_data_int__WEBPACK_IMPORTED_MODULE_1__["OrderedSet"].indexOf(elements, eI);
        if (start >= 0) {
            startIdx = rI;
            break;
        }
    }
    if (start < 0) {
        return false;
    }
    var end = start;
    for (var rI = r2; rI > startIdx; rI--) {
        var eI = traceElementIndex[rI];
        if (eI < 0)
            continue;
        var e = _mol_data_int__WEBPACK_IMPORTED_MODULE_1__["OrderedSet"].indexOf(elements, eI);
        if (e >= 0) {
            end = e;
            break;
        }
    }
    return apply(_mol_data_int__WEBPACK_IMPORTED_MODULE_1__["Interval"].ofRange(offset + start, offset + end));
}
function eachAtomicUnitTracedElement(offset, groupSize, elementsSelector, apply, e) {
    var changed = false;
    var elements = e.unit.elements;
    var traceElementIndex = e.unit.model.atomicHierarchy.derived.residue.traceElementIndex;
    var resIndex = e.unit.model.atomicHierarchy.residueAtomSegments.index;
    var tracedElements = elementsSelector(e.unit);
    if (_mol_data_int__WEBPACK_IMPORTED_MODULE_1__["Interval"].is(e.indices)) {
        if (_mol_data_int__WEBPACK_IMPORTED_MODULE_1__["Interval"].start(e.indices) === 0 && _mol_data_int__WEBPACK_IMPORTED_MODULE_1__["Interval"].end(e.indices) === e.unit.elements.length) {
            // full unit here
            changed = apply(_mol_data_int__WEBPACK_IMPORTED_MODULE_1__["Interval"].ofBounds(offset, offset + groupSize)) || changed;
        }
        else {
            var r1 = resIndex[elements[_mol_data_int__WEBPACK_IMPORTED_MODULE_1__["Interval"].min(e.indices)]];
            var r2 = resIndex[elements[_mol_data_int__WEBPACK_IMPORTED_MODULE_1__["Interval"].max(e.indices)]];
            changed = tryApplyResidueInterval(offset, tracedElements, traceElementIndex, apply, r1, r2) || changed;
        }
    }
    else {
        var indices = e.indices;
        for (var i = 0, _i = indices.length; i < _i; i++) {
            var r1 = resIndex[elements[indices[i]]];
            var r2 = r1;
            var endI = i + 1;
            while (endI < _i) {
                var _r = resIndex[elements[indices[endI]]];
                if (_r - r2 > 1)
                    break;
                r2 = _r;
                endI++;
            }
            i = endI - 1;
            changed = tryApplyResidueInterval(offset, tracedElements, traceElementIndex, apply, r1, r2) || changed;
        }
    }
    return changed;
}
function selectPolymerElements(u) { return u.polymerElements; }
/** Mark a polymer element (e.g. part of a cartoon trace) */
function eachPolymerElement(loci, structureGroup, apply) {
    var changed = false;
    if (!_mol_model_structure__WEBPACK_IMPORTED_MODULE_0__["StructureElement"].Loci.is(loci))
        return false;
    var structure = structureGroup.structure, group = structureGroup.group;
    if (!_mol_model_structure__WEBPACK_IMPORTED_MODULE_0__["Structure"].areEquivalent(loci.structure, structure))
        return false;
    var groupCount = group.units[0].polymerElements.length;
    for (var _a = 0, _b = loci.elements; _a < _b.length; _a++) {
        var e = _b[_a];
        if (!group.unitIndexMap.has(e.unit.id))
            continue;
        var offset = group.unitIndexMap.get(e.unit.id) * groupCount; // to target unit instance
        if (_mol_model_structure__WEBPACK_IMPORTED_MODULE_0__["Unit"].isAtomic(e.unit)) {
            changed = eachAtomicUnitTracedElement(offset, groupCount, selectPolymerElements, apply, e) || changed;
        }
        else {
            if (_mol_data_int__WEBPACK_IMPORTED_MODULE_1__["Interval"].is(e.indices)) {
                var start = offset + _mol_data_int__WEBPACK_IMPORTED_MODULE_1__["Interval"].start(e.indices);
                var end = offset + _mol_data_int__WEBPACK_IMPORTED_MODULE_1__["Interval"].end(e.indices);
                changed = apply(_mol_data_int__WEBPACK_IMPORTED_MODULE_1__["Interval"].ofBounds(start, end)) || changed;
            }
            else {
                for (var i = 0, _i = e.indices.length; i < _i; i++) {
                    var start = e.indices[i];
                    var endI = i + 1;
                    while (endI < _i && e.indices[endI] === start)
                        endI++;
                    i = endI - 1;
                    var end = e.indices[i];
                    changed = apply(_mol_data_int__WEBPACK_IMPORTED_MODULE_1__["Interval"].ofRange(offset + start, offset + end)) || changed;
                }
            }
        }
    }
    return changed;
}
/** Return a Loci for both directions of the polymer gap element. */
function getPolymerGapElementLoci(pickingId, structureGroup, id) {
    var objectId = pickingId.objectId, instanceId = pickingId.instanceId, groupId = pickingId.groupId;
    if (id === objectId) {
        var structure = structureGroup.structure, group = structureGroup.group;
        var unit = group.units[instanceId];
        var unitIndexA = _mol_data_int__WEBPACK_IMPORTED_MODULE_1__["OrderedSet"].indexOf(unit.elements, unit.gapElements[groupId]);
        var unitIndexB = _mol_data_int__WEBPACK_IMPORTED_MODULE_1__["OrderedSet"].indexOf(unit.elements, unit.gapElements[groupId % 2 ? groupId - 1 : groupId + 1]);
        if (unitIndexA !== -1 && unitIndexB !== -1) {
            return _mol_model_structure__WEBPACK_IMPORTED_MODULE_0__["Bond"].Loci(structure, [
                _mol_model_structure__WEBPACK_IMPORTED_MODULE_0__["Bond"].Location(structure, unit, unitIndexA, structure, unit, unitIndexB),
                _mol_model_structure__WEBPACK_IMPORTED_MODULE_0__["Bond"].Location(structure, unit, unitIndexB, structure, unit, unitIndexA)
            ]);
        }
    }
    return _mol_model_loci__WEBPACK_IMPORTED_MODULE_2__["EmptyLoci"];
}
function eachPolymerGapElement(loci, structureGroup, apply) {
    var changed = false;
    if (_mol_model_structure__WEBPACK_IMPORTED_MODULE_0__["Bond"].isLoci(loci)) {
        var structure = structureGroup.structure, group = structureGroup.group;
        if (!_mol_model_structure__WEBPACK_IMPORTED_MODULE_0__["Structure"].areRootsEquivalent(loci.structure, structure))
            return false;
        loci = _mol_model_structure__WEBPACK_IMPORTED_MODULE_0__["Bond"].remapLoci(loci, structure);
        var groupCount = group.units[0].gapElements.length;
        for (var _a = 0, _b = loci.bonds; _a < _b.length; _a++) {
            var b = _b[_a];
            var unitIdx = group.unitIndexMap.get(b.aUnit.id);
            if (unitIdx !== undefined) {
                var idxA = _mol_data_int__WEBPACK_IMPORTED_MODULE_1__["OrderedSet"].indexOf(b.aUnit.gapElements, b.aUnit.elements[b.aIndex]);
                var idxB = _mol_data_int__WEBPACK_IMPORTED_MODULE_1__["OrderedSet"].indexOf(b.bUnit.gapElements, b.bUnit.elements[b.bIndex]);
                if (idxA !== -1 && idxB !== -1) {
                    if (apply(_mol_data_int__WEBPACK_IMPORTED_MODULE_1__["Interval"].ofSingleton(unitIdx * groupCount + idxA)))
                        changed = true;
                }
            }
        }
    }
    else if (_mol_model_structure__WEBPACK_IMPORTED_MODULE_0__["StructureElement"].Loci.is(loci)) {
        var structure = structureGroup.structure, group = structureGroup.group;
        if (!_mol_model_structure__WEBPACK_IMPORTED_MODULE_0__["Structure"].areRootsEquivalent(loci.structure, structure))
            return false;
        loci = _mol_model_structure__WEBPACK_IMPORTED_MODULE_0__["StructureElement"].Loci.remap(loci, structure);
        var groupCount_1 = group.units[0].gapElements.length;
        var _loop_1 = function (e) {
            var unitIdx = group.unitIndexMap.get(e.unit.id);
            if (unitIdx !== undefined) {
                _mol_data_int__WEBPACK_IMPORTED_MODULE_1__["OrderedSet"].forEach(e.indices, function (v) {
                    var idx = _mol_data_int__WEBPACK_IMPORTED_MODULE_1__["OrderedSet"].indexOf(e.unit.gapElements, e.unit.elements[v]);
                    if (idx !== -1) {
                        if (apply(_mol_data_int__WEBPACK_IMPORTED_MODULE_1__["Interval"].ofSingleton(unitIdx * groupCount_1 + idx)))
                            changed = true;
                    }
                });
            }
        };
        for (var _c = 0, _d = loci.elements; _c < _d.length; _c++) {
            var e = _d[_c];
            _loop_1(e);
        }
    }
    return changed;
}
//# sourceMappingURL=polymer.js.map

/***/ }),

/***/ "./lib/mol-repr/structure/visual/util/polymer/backbone-iterator.js":
/*!*************************************************************************!*\
  !*** ./lib/mol-repr/structure/visual/util/polymer/backbone-iterator.js ***!
  \*************************************************************************/
/*! exports provided: PolymerBackboneIterator, AtomicPolymerBackboneIterator, CoarsePolymerBackboneIterator */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "PolymerBackboneIterator", function() { return PolymerBackboneIterator; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "AtomicPolymerBackboneIterator", function() { return AtomicPolymerBackboneIterator; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CoarsePolymerBackboneIterator", function() { return CoarsePolymerBackboneIterator; });
/* harmony import */ var _mol_model_structure__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../../../../mol-model/structure */ "./lib/mol-model/structure.js");
/* harmony import */ var _mol_data_int__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../../../../mol-data/int */ "./lib/mol-data/int.js");
/* harmony import */ var _mol_data_int_sorted_ranges__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../../../../mol-data/int/sorted-ranges */ "./lib/mol-data/int/sorted-ranges.js");
/* harmony import */ var _polymer__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../polymer */ "./lib/mol-repr/structure/visual/util/polymer.js");
/**
 * Copyright (c) 2018 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */




/** Iterates over consecutive pairs of residues/coarse elements in polymers */
function PolymerBackboneIterator(structure, unit) {
    switch (unit.kind) {
        case 0 /* Atomic */: return new AtomicPolymerBackboneIterator(structure, unit);
        case 1 /* Spheres */:
        case 2 /* Gaussians */:
            return new CoarsePolymerBackboneIterator(structure, unit);
    }
}
function createPolymerBackbonePair(structure, unit) {
    return {
        centerA: _mol_model_structure__WEBPACK_IMPORTED_MODULE_0__["StructureElement"].Location.create(structure, unit),
        centerB: _mol_model_structure__WEBPACK_IMPORTED_MODULE_0__["StructureElement"].Location.create(structure, unit),
    };
}
var AtomicPolymerBackboneIterator = /** @class */ (function () {
    function AtomicPolymerBackboneIterator(structure, unit) {
        this.unit = unit;
        this.state = 0 /* nextPolymer */;
        this.hasNext = false;
        this.traceElementIndex = unit.model.atomicHierarchy.derived.residue.traceElementIndex; // can assume it won't be -1 for polymer residues
        this.polymerIt = _mol_data_int_sorted_ranges__WEBPACK_IMPORTED_MODULE_2__["default"].transientSegments(Object(_polymer__WEBPACK_IMPORTED_MODULE_3__["getPolymerRanges"])(unit), unit.elements);
        this.residueIt = _mol_data_int__WEBPACK_IMPORTED_MODULE_1__["Segmentation"].transientSegments(unit.model.atomicHierarchy.residueAtomSegments, unit.elements);
        this.value = createPolymerBackbonePair(structure, unit);
        this.hasNext = this.residueIt.hasNext && this.polymerIt.hasNext;
    }
    AtomicPolymerBackboneIterator.prototype.move = function () {
        if (this.state === 0 /* nextPolymer */) {
            while (this.polymerIt.hasNext) {
                this.residueIt.setSegment(this.polymerIt.move());
                if (this.residueIt.hasNext) {
                    this.residueSegment = this.residueIt.move();
                    this.value.centerB.element = this.traceElementIndex[this.residueSegment.index];
                    this.state = 2 /* nextResidue */;
                    break;
                }
            }
        }
        if (this.state === 2 /* nextResidue */) {
            this.residueSegment = this.residueIt.move();
            this.value.centerA.element = this.value.centerB.element;
            this.value.centerB.element = this.traceElementIndex[this.residueSegment.index];
            if (!this.residueIt.hasNext) {
                if (this.unit.model.atomicRanges.cyclicPolymerMap.has(this.residueSegment.index)) {
                    this.state = 3 /* cycle */;
                }
                else {
                    // TODO need to advance to a polymer that has two or more residues (can't assume it has)
                    this.state = 0 /* nextPolymer */;
                }
            }
        }
        else if (this.state === 3 /* cycle */) {
            var cyclicPolymerMap = this.unit.model.atomicRanges.cyclicPolymerMap;
            this.value.centerA.element = this.value.centerB.element;
            this.value.centerB.element = this.traceElementIndex[cyclicPolymerMap.get(this.residueSegment.index)];
            // TODO need to advance to a polymer that has two or more residues (can't assume it has)
            this.state = 0 /* nextPolymer */;
        }
        this.hasNext = this.residueIt.hasNext || this.polymerIt.hasNext || this.state === 3 /* cycle */;
        return this.value;
    };
    return AtomicPolymerBackboneIterator;
}());

var CoarsePolymerBackboneIterator = /** @class */ (function () {
    function CoarsePolymerBackboneIterator(structure, unit) {
        this.unit = unit;
        this.state = 0 /* nextPolymer */;
        this.hasNext = false;
        this.polymerIt = _mol_data_int_sorted_ranges__WEBPACK_IMPORTED_MODULE_2__["default"].transientSegments(Object(_polymer__WEBPACK_IMPORTED_MODULE_3__["getPolymerRanges"])(unit), unit.elements);
        this.value = createPolymerBackbonePair(structure, unit);
        this.hasNext = this.polymerIt.hasNext;
    }
    CoarsePolymerBackboneIterator.prototype.move = function () {
        if (this.state === 0 /* nextPolymer */) {
            if (this.polymerIt.hasNext) {
                this.polymerSegment = this.polymerIt.move();
                this.elementIndex = this.polymerSegment.start;
                if (this.elementIndex + 1 < this.polymerSegment.end) {
                    this.value.centerB.element = this.unit.elements[this.elementIndex];
                    this.state = 1 /* nextElement */;
                }
                else {
                    this.state = 0 /* nextPolymer */;
                }
            }
        }
        if (this.state === 1 /* nextElement */) {
            this.elementIndex += 1;
            this.value.centerA.element = this.value.centerB.element;
            this.value.centerB.element = this.unit.elements[this.elementIndex];
            if (this.elementIndex + 1 >= this.polymerSegment.end) {
                this.state = 0 /* nextPolymer */;
            }
        }
        this.hasNext = this.elementIndex + 1 < this.polymerSegment.end || this.polymerIt.hasNext;
        return this.value;
    };
    return CoarsePolymerBackboneIterator;
}());

//# sourceMappingURL=backbone-iterator.js.map

/***/ }),

/***/ "./lib/mol-repr/structure/visual/util/polymer/curve-segment.js":
/*!*********************************************************************!*\
  !*** ./lib/mol-repr/structure/visual/util/polymer/curve-segment.js ***!
  \*********************************************************************/
/*! exports provided: createCurveSegmentState, interpolateCurveSegment, interpolatePointsAndTangents, interpolateNormals, interpolateSizes */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createCurveSegmentState", function() { return createCurveSegmentState; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "interpolateCurveSegment", function() { return interpolateCurveSegment; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "interpolatePointsAndTangents", function() { return interpolatePointsAndTangents; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "interpolateNormals", function() { return interpolateNormals; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "interpolateSizes", function() { return interpolateSizes; });
/* harmony import */ var _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../../../../mol-math/linear-algebra */ "./lib/mol-math/linear-algebra.js");
/* harmony import */ var _mol_math_interpolate__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../../../../mol-math/interpolate */ "./lib/mol-math/interpolate.js");
/**
 * Copyright (c) 2018-2020 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */


// avoiding namespace lookup improved performance in Chrome (Aug 2020)
var v3fromArray = _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"].fromArray;
var v3toArray = _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"].toArray;
var v3normalize = _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"].normalize;
var v3sub = _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"].sub;
var v3spline = _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"].spline;
var v3slerp = _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"].slerp;
var v3copy = _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"].copy;
var v3cross = _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"].cross;
var v3orthogonalize = _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"].orthogonalize;
var v3matchDirection = _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"].matchDirection;
function createCurveSegmentState(linearSegments) {
    var n = linearSegments + 1;
    var pn = n * 3;
    return {
        curvePoints: new Float32Array(pn),
        tangentVectors: new Float32Array(pn),
        normalVectors: new Float32Array(pn),
        binormalVectors: new Float32Array(pn),
        widthValues: new Float32Array(n),
        heightValues: new Float32Array(n),
        linearSegments: linearSegments
    };
}
function interpolateCurveSegment(state, controls, tension, shift) {
    interpolatePointsAndTangents(state, controls, tension, shift);
    interpolateNormals(state, controls);
}
var tanA = Object(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"])();
var tanB = Object(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"])();
var curvePoint = Object(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"])();
function interpolatePointsAndTangents(state, controls, tension, shift) {
    var curvePoints = state.curvePoints, tangentVectors = state.tangentVectors, linearSegments = state.linearSegments;
    var p0 = controls.p0, p1 = controls.p1, p2 = controls.p2, p3 = controls.p3, p4 = controls.p4, secStrucFirst = controls.secStrucFirst, secStrucLast = controls.secStrucLast;
    var shift1 = 1 - shift;
    var tensionBeg = secStrucFirst ? 0.5 : tension;
    var tensionEnd = secStrucLast ? 0.5 : tension;
    for (var j = 0; j <= linearSegments; ++j) {
        var t = j * 1.0 / linearSegments;
        if (t < shift1) {
            var te = Object(_mol_math_interpolate__WEBPACK_IMPORTED_MODULE_1__["lerp"])(tensionBeg, tension, t);
            v3spline(curvePoint, p0, p1, p2, p3, t + shift, te);
            v3spline(tanA, p0, p1, p2, p3, t + shift + 0.01, tensionBeg);
            v3spline(tanB, p0, p1, p2, p3, t + shift - 0.01, tensionBeg);
        }
        else {
            var te = Object(_mol_math_interpolate__WEBPACK_IMPORTED_MODULE_1__["lerp"])(tension, tensionEnd, t);
            v3spline(curvePoint, p1, p2, p3, p4, t - shift1, te);
            v3spline(tanA, p1, p2, p3, p4, t - shift1 + 0.01, te);
            v3spline(tanB, p1, p2, p3, p4, t - shift1 - 0.01, te);
        }
        v3toArray(curvePoint, curvePoints, j * 3);
        v3normalize(tangentVec, v3sub(tangentVec, tanA, tanB));
        v3toArray(tangentVec, tangentVectors, j * 3);
    }
}
var tmpNormal = Object(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"])();
var tangentVec = Object(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"])();
var normalVec = Object(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"])();
var binormalVec = Object(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"])();
var prevNormal = Object(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"])();
var firstTangentVec = Object(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"])();
var lastTangentVec = Object(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"])();
var firstNormalVec = Object(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"])();
var lastNormalVec = Object(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_0__["Vec3"])();
/**
 * Populate normalVectors by interpolating from firstDirection to lastDirection with
 * resulting vector perpendicular to tangentVectors and binormalVectors
 */
function interpolateNormals(state, controls) {
    var curvePoints = state.curvePoints, tangentVectors = state.tangentVectors, normalVectors = state.normalVectors, binormalVectors = state.binormalVectors;
    var firstDirection = controls.d12, lastDirection = controls.d23;
    var n = curvePoints.length / 3;
    v3fromArray(firstTangentVec, tangentVectors, 0);
    v3fromArray(lastTangentVec, tangentVectors, (n - 1) * 3);
    v3orthogonalize(firstNormalVec, firstTangentVec, firstDirection);
    v3orthogonalize(lastNormalVec, lastTangentVec, lastDirection);
    v3matchDirection(lastNormalVec, lastNormalVec, firstNormalVec);
    v3copy(prevNormal, firstNormalVec);
    for (var i = 0; i < n; ++i) {
        var t = i === 0 ? 0 : 1 / (n - i);
        v3fromArray(tangentVec, tangentVectors, i * 3);
        v3orthogonalize(normalVec, tangentVec, v3slerp(tmpNormal, prevNormal, lastNormalVec, t));
        v3toArray(normalVec, normalVectors, i * 3);
        v3copy(prevNormal, normalVec);
        v3normalize(binormalVec, v3cross(binormalVec, tangentVec, normalVec));
        v3toArray(binormalVec, binormalVectors, i * 3);
    }
}
function interpolateSizes(state, w0, w1, w2, h0, h1, h2, shift) {
    var widthValues = state.widthValues, heightValues = state.heightValues, linearSegments = state.linearSegments;
    var shift1 = 1 - shift;
    for (var i = 0; i <= linearSegments; ++i) {
        var t = i * 1.0 / linearSegments;
        if (t < shift1) {
            widthValues[i] = Object(_mol_math_interpolate__WEBPACK_IMPORTED_MODULE_1__["lerp"])(w0, w1, t + shift);
            heightValues[i] = Object(_mol_math_interpolate__WEBPACK_IMPORTED_MODULE_1__["lerp"])(h0, h1, t + shift);
        }
        else {
            widthValues[i] = Object(_mol_math_interpolate__WEBPACK_IMPORTED_MODULE_1__["lerp"])(w1, w2, t - shift1);
            heightValues[i] = Object(_mol_math_interpolate__WEBPACK_IMPORTED_MODULE_1__["lerp"])(h1, h2, t - shift1);
        }
    }
}
//# sourceMappingURL=curve-segment.js.map

/***/ }),

/***/ "./lib/mol-repr/structure/visual/util/polymer/gap-iterator.js":
/*!********************************************************************!*\
  !*** ./lib/mol-repr/structure/visual/util/polymer/gap-iterator.js ***!
  \********************************************************************/
/*! exports provided: PolymerGapIterator, AtomicPolymerGapIterator, CoarsePolymerGapIterator */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "PolymerGapIterator", function() { return PolymerGapIterator; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "AtomicPolymerGapIterator", function() { return AtomicPolymerGapIterator; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CoarsePolymerGapIterator", function() { return CoarsePolymerGapIterator; });
/* harmony import */ var _mol_model_structure__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../../../../mol-model/structure */ "./lib/mol-model/structure.js");
/* harmony import */ var _mol_data_int_sorted_ranges__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../../../../mol-data/int/sorted-ranges */ "./lib/mol-data/int/sorted-ranges.js");
/* harmony import */ var _polymer__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../polymer */ "./lib/mol-repr/structure/visual/util/polymer.js");
/**
 * Copyright (c) 2018 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */



/** Iterates over gaps, i.e. the stem residues/coarse elements adjacent to gaps */
function PolymerGapIterator(structure, unit) {
    switch (unit.kind) {
        case 0 /* Atomic */: return new AtomicPolymerGapIterator(structure, unit);
        case 1 /* Spheres */:
        case 2 /* Gaussians */:
            return new CoarsePolymerGapIterator(structure, unit);
    }
}
function createPolymerGapPair(structure, unit) {
    return {
        centerA: _mol_model_structure__WEBPACK_IMPORTED_MODULE_0__["StructureElement"].Location.create(structure, unit),
        centerB: _mol_model_structure__WEBPACK_IMPORTED_MODULE_0__["StructureElement"].Location.create(structure, unit),
    };
}
var AtomicPolymerGapIterator = /** @class */ (function () {
    function AtomicPolymerGapIterator(structure, unit) {
        this.unit = unit;
        this.hasNext = false;
        this.traceElementIndex = unit.model.atomicHierarchy.derived.residue.traceElementIndex; // can assume it won't be -1 for polymer residues
        this.gapIt = _mol_data_int_sorted_ranges__WEBPACK_IMPORTED_MODULE_1__["default"].transientSegments(Object(_polymer__WEBPACK_IMPORTED_MODULE_2__["getGapRanges"])(unit), unit.elements);
        this.value = createPolymerGapPair(structure, unit);
        this.hasNext = this.gapIt.hasNext;
    }
    AtomicPolymerGapIterator.prototype.move = function () {
        var _a = this.unit, elements = _a.elements, residueIndex = _a.residueIndex;
        var gapSegment = this.gapIt.move();
        this.value.centerA.element = this.traceElementIndex[residueIndex[elements[gapSegment.start]]];
        this.value.centerB.element = this.traceElementIndex[residueIndex[elements[gapSegment.end - 1]]];
        this.hasNext = this.gapIt.hasNext;
        return this.value;
    };
    return AtomicPolymerGapIterator;
}());

var CoarsePolymerGapIterator = /** @class */ (function () {
    function CoarsePolymerGapIterator(structure, unit) {
        this.unit = unit;
        this.hasNext = false;
        this.gapIt = _mol_data_int_sorted_ranges__WEBPACK_IMPORTED_MODULE_1__["default"].transientSegments(Object(_polymer__WEBPACK_IMPORTED_MODULE_2__["getGapRanges"])(unit), unit.elements);
        this.value = createPolymerGapPair(structure, unit);
        this.hasNext = this.gapIt.hasNext;
    }
    CoarsePolymerGapIterator.prototype.move = function () {
        var gapSegment = this.gapIt.move();
        this.value.centerA.element = this.unit.elements[gapSegment.start];
        this.value.centerB.element = this.unit.elements[gapSegment.end - 1];
        this.hasNext = this.gapIt.hasNext;
        return this.value;
    };
    return CoarsePolymerGapIterator;
}());

//# sourceMappingURL=gap-iterator.js.map

/***/ }),

/***/ "./lib/mol-repr/structure/visual/util/polymer/trace-iterator.js":
/*!**********************************************************************!*\
  !*** ./lib/mol-repr/structure/visual/util/polymer/trace-iterator.js ***!
  \**********************************************************************/
/*! exports provided: PolymerTraceIterator, AtomicPolymerTraceIterator, CoarsePolymerTraceIterator */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "PolymerTraceIterator", function() { return PolymerTraceIterator; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "AtomicPolymerTraceIterator", function() { return AtomicPolymerTraceIterator; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CoarsePolymerTraceIterator", function() { return CoarsePolymerTraceIterator; });
/* harmony import */ var _mol_model_structure__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../../../../mol-model/structure */ "./lib/mol-model/structure.js");
/* harmony import */ var _mol_data_int__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../../../../mol-data/int */ "./lib/mol-data/int.js");
/* harmony import */ var _mol_model_structure_model_types__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../../../../mol-model/structure/model/types */ "./lib/mol-model/structure/model/types.js");
/* harmony import */ var _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../../../../mol-math/linear-algebra */ "./lib/mol-math/linear-algebra.js");
/* harmony import */ var _mol_data_int_sorted_ranges__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../../../../mol-data/int/sorted-ranges */ "./lib/mol-data/int/sorted-ranges.js");
/* harmony import */ var _polymer__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../polymer */ "./lib/mol-repr/structure/visual/util/polymer.js");
/* harmony import */ var _mol_model_props_computed_secondary_structure__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../../../../../mol-model-props/computed/secondary-structure */ "./lib/mol-model-props/computed/secondary-structure.js");
/**
 * Copyright (c) 2018-2020 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */







/**
 * Iterates over individual residues/coarse elements in polymers of a unit while
 * providing information about the neighbourhood in the underlying model for drawing splines
 */
function PolymerTraceIterator(unit, structure, ignoreSecondaryStructure) {
    if (ignoreSecondaryStructure === void 0) { ignoreSecondaryStructure = false; }
    switch (unit.kind) {
        case 0 /* Atomic */: return new AtomicPolymerTraceIterator(unit, structure, ignoreSecondaryStructure);
        case 1 /* Spheres */:
        case 2 /* Gaussians */:
            return new CoarsePolymerTraceIterator(unit, structure);
    }
}
var SecStrucTypeNA = _mol_model_structure_model_types__WEBPACK_IMPORTED_MODULE_2__["SecondaryStructureType"].create(536870912 /* NA */);
function createPolymerTraceElement(structure, unit) {
    return {
        center: _mol_model_structure__WEBPACK_IMPORTED_MODULE_0__["StructureElement"].Location.create(structure, unit),
        centerPrev: _mol_model_structure__WEBPACK_IMPORTED_MODULE_0__["StructureElement"].Location.create(structure, unit),
        centerNext: _mol_model_structure__WEBPACK_IMPORTED_MODULE_0__["StructureElement"].Location.create(structure, unit),
        first: false, last: false,
        initial: false, final: false,
        secStrucFirst: false, secStrucLast: false,
        secStrucType: SecStrucTypeNA,
        moleculeType: 0 /* Unknown */,
        coarseBackboneFirst: false, coarseBackboneLast: false,
        isCoarseBackbone: false,
        p0: Object(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_3__["Vec3"])(), p1: Object(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_3__["Vec3"])(), p2: Object(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_3__["Vec3"])(), p3: Object(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_3__["Vec3"])(), p4: Object(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_3__["Vec3"])(),
        d12: Object(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_3__["Vec3"])(), d23: Object(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_3__["Vec3"])()
    };
}
var tmpDir = Object(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_3__["Vec3"])();
var tmpVecA = Object(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_3__["Vec3"])();
var tmpVecB = Object(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_3__["Vec3"])();
var AtomicPolymerTraceIterator = /** @class */ (function () {
    function AtomicPolymerTraceIterator(unit, structure, ignoreSecondaryStructure) {
        if (ignoreSecondaryStructure === void 0) { ignoreSecondaryStructure = false; }
        var _a;
        this.unit = unit;
        this.state = 0 /* nextPolymer */;
        this.p0 = Object(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_3__["Vec3"])();
        this.p1 = Object(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_3__["Vec3"])();
        this.p2 = Object(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_3__["Vec3"])();
        this.p3 = Object(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_3__["Vec3"])();
        this.p4 = Object(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_3__["Vec3"])();
        this.p5 = Object(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_3__["Vec3"])();
        this.p6 = Object(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_3__["Vec3"])();
        this.d01 = Object(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_3__["Vec3"])();
        this.d12 = Object(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_3__["Vec3"])();
        this.d23 = Object(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_3__["Vec3"])();
        this.d34 = Object(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_3__["Vec3"])();
        this.hasNext = false;
        this.atomicConformation = unit.model.atomicConformation;
        this.residueAtomSegments = unit.model.atomicHierarchy.residueAtomSegments;
        this.polymerRanges = unit.model.atomicRanges.polymerRanges;
        this.traceElementIndex = unit.model.atomicHierarchy.derived.residue.traceElementIndex; // can assume it won't be -1 for polymer residues
        this.directionFromElementIndex = unit.model.atomicHierarchy.derived.residue.directionFromElementIndex;
        this.directionToElementIndex = unit.model.atomicHierarchy.derived.residue.directionToElementIndex;
        this.moleculeType = unit.model.atomicHierarchy.derived.residue.moleculeType;
        this.cyclicPolymerMap = unit.model.atomicRanges.cyclicPolymerMap;
        this.polymerIt = _mol_data_int_sorted_ranges__WEBPACK_IMPORTED_MODULE_4__["default"].transientSegments(this.polymerRanges, unit.elements);
        this.residueIt = _mol_data_int__WEBPACK_IMPORTED_MODULE_1__["Segmentation"].transientSegments(this.residueAtomSegments, unit.elements);
        this.value = createPolymerTraceElement(structure, unit);
        this.hasNext = this.residueIt.hasNext && this.polymerIt.hasNext;
        var secondaryStructure = !ignoreSecondaryStructure && ((_a = _mol_model_props_computed_secondary_structure__WEBPACK_IMPORTED_MODULE_6__["SecondaryStructureProvider"].get(structure).value) === null || _a === void 0 ? void 0 : _a.get(unit.invariantId));
        if (secondaryStructure) {
            var type_1 = secondaryStructure.type, getIndex_1 = secondaryStructure.getIndex;
            this.getSecStruc = function (residueIndex) { return type_1[getIndex_1(residueIndex)]; };
        }
        else {
            this.getSecStruc = function (residueIndex) { return SecStrucTypeNA; };
        }
    }
    AtomicPolymerTraceIterator.prototype.pos = function (target, index) {
        if (index !== -1) {
            target[0] = this.atomicConformation.x[index];
            target[1] = this.atomicConformation.y[index];
            target[2] = this.atomicConformation.z[index];
        }
    };
    AtomicPolymerTraceIterator.prototype.updateResidueSegmentRange = function (polymerSegment) {
        var index = this.residueAtomSegments.index;
        this.residueSegmentMin = index[this.polymerRanges[polymerSegment.index * 2]];
        this.residueSegmentMax = index[this.polymerRanges[polymerSegment.index * 2 + 1]];
    };
    AtomicPolymerTraceIterator.prototype.getResidueIndex = function (residueIndex) {
        if (residueIndex < this.residueSegmentMin) {
            var cyclicIndex = this.cyclicPolymerMap.get(this.residueSegmentMin);
            if (cyclicIndex !== undefined) {
                residueIndex = cyclicIndex - (this.residueSegmentMin - residueIndex - 1);
            }
            else {
                residueIndex = this.residueSegmentMin;
            }
        }
        else if (residueIndex > this.residueSegmentMax) {
            var cyclicIndex = this.cyclicPolymerMap.get(this.residueSegmentMax);
            if (cyclicIndex !== undefined) {
                residueIndex = cyclicIndex + (residueIndex - this.residueSegmentMax - 1);
            }
            else {
                residueIndex = this.residueSegmentMax;
            }
        }
        return residueIndex;
    };
    AtomicPolymerTraceIterator.prototype.setControlPoint = function (out, p1, p2, p3, residueIndex) {
        var ss = this.getSecStruc(residueIndex);
        if (_mol_model_structure_model_types__WEBPACK_IMPORTED_MODULE_2__["SecondaryStructureType"].is(ss, 4 /* Beta */)) {
            _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_3__["Vec3"].scale(out, _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_3__["Vec3"].add(out, p1, _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_3__["Vec3"].add(out, p3, _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_3__["Vec3"].add(out, p2, p2))), 1 / 4);
        }
        else {
            _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_3__["Vec3"].copy(out, p2);
        }
    };
    AtomicPolymerTraceIterator.prototype.setFromToVector = function (out, residueIndex) {
        if (this.value.isCoarseBackbone) {
            _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_3__["Vec3"].set(out, 1, 0, 0);
        }
        else {
            this.pos(tmpVecA, this.directionFromElementIndex[residueIndex]);
            this.pos(tmpVecB, this.directionToElementIndex[residueIndex]);
            _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_3__["Vec3"].sub(out, tmpVecB, tmpVecA);
        }
    };
    AtomicPolymerTraceIterator.prototype.setDirection = function (out, v1, v2, v3) {
        _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_3__["Vec3"].matchDirection(tmpVecA, v1, v2);
        _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_3__["Vec3"].matchDirection(tmpVecB, v3, v2);
        _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_3__["Vec3"].scale(out, _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_3__["Vec3"].add(out, tmpVecA, _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_3__["Vec3"].add(out, tmpVecB, _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_3__["Vec3"].add(out, v2, v2))), 1 / 4);
    };
    AtomicPolymerTraceIterator.prototype.move = function () {
        var _a = this, residueIt = _a.residueIt, polymerIt = _a.polymerIt, value = _a.value;
        if (this.state === 0 /* nextPolymer */) {
            while (polymerIt.hasNext) {
                this.polymerSegment = polymerIt.move();
                residueIt.setSegment(this.polymerSegment);
                this.updateResidueSegmentRange(this.polymerSegment);
                if (residueIt.hasNext) {
                    this.state = 1 /* nextResidue */;
                    var residueIndexBeg = this.residueAtomSegments.index[this.unit.elements[this.polymerSegment.start]];
                    var residueIndexBegPrev = this.getResidueIndex(residueIndexBeg - 1);
                    this.currSecStrucType = residueIndexBeg === residueIndexBegPrev ? SecStrucTypeNA : this.getSecStruc(residueIndexBegPrev);
                    this.nextSecStrucType = this.getSecStruc(residueIndexBeg);
                    this.currCoarseBackbone = this.directionFromElementIndex[residueIndexBegPrev] === -1 || this.directionToElementIndex[residueIndexBegPrev] === -1;
                    this.nextCoarseBackbone = this.directionFromElementIndex[residueIndexBeg] === -1 || this.directionToElementIndex[residueIndexBeg] === -1;
                    break;
                }
            }
        }
        if (this.state === 1 /* nextResidue */) {
            var residueIndex = residueIt.move().index;
            var residueIndexPrev3 = this.getResidueIndex(residueIndex - 3);
            var residueIndexPrev2 = this.getResidueIndex(residueIndex - 2);
            var residueIndexPrev1 = this.getResidueIndex(residueIndex - 1);
            var residueIndexNext1 = this.getResidueIndex(residueIndex + 1);
            var residueIndexNext2 = this.getResidueIndex(residueIndex + 2);
            var residueIndexNext3 = this.getResidueIndex(residueIndex + 3);
            this.prevSecStrucType = this.currSecStrucType;
            this.currSecStrucType = this.nextSecStrucType;
            this.nextSecStrucType = residueIndex === residueIndexNext1 ? SecStrucTypeNA : this.getSecStruc(residueIndexNext1);
            this.prevCoarseBackbone = this.currCoarseBackbone;
            this.currCoarseBackbone = this.nextCoarseBackbone;
            this.nextCoarseBackbone = residueIndex === residueIndexNext1 ? false : (this.directionFromElementIndex[residueIndexNext1] === -1 || this.directionToElementIndex[residueIndexNext1] === -1);
            value.secStrucType = this.currSecStrucType;
            value.secStrucFirst = this.prevSecStrucType !== this.currSecStrucType;
            value.secStrucLast = this.currSecStrucType !== this.nextSecStrucType;
            value.isCoarseBackbone = this.currCoarseBackbone;
            value.coarseBackboneFirst = this.prevCoarseBackbone !== this.currCoarseBackbone;
            value.coarseBackboneLast = this.currCoarseBackbone !== this.nextCoarseBackbone;
            value.first = residueIndex === this.residueSegmentMin;
            value.last = residueIndex === this.residueSegmentMax;
            value.moleculeType = this.moleculeType[residueIndex];
            value.isCoarseBackbone = this.directionFromElementIndex[residueIndex] === -1 || this.directionToElementIndex[residueIndex] === -1;
            value.initial = residueIndex === residueIndexPrev1;
            value.final = residueIndex === residueIndexNext1;
            value.centerPrev.element = this.traceElementIndex[residueIndexPrev1];
            value.center.element = this.traceElementIndex[residueIndex];
            value.centerNext.element = this.traceElementIndex[residueIndexNext1];
            this.pos(this.p0, this.traceElementIndex[residueIndexPrev3]);
            this.pos(this.p1, this.traceElementIndex[residueIndexPrev2]);
            this.pos(this.p2, this.traceElementIndex[residueIndexPrev1]);
            this.pos(this.p3, this.traceElementIndex[residueIndex]);
            this.pos(this.p4, this.traceElementIndex[residueIndexNext1]);
            this.pos(this.p5, this.traceElementIndex[residueIndexNext2]);
            this.pos(this.p6, this.traceElementIndex[residueIndexNext3]);
            this.setFromToVector(this.d01, residueIndexPrev1);
            this.setFromToVector(this.d12, residueIndex);
            this.setFromToVector(this.d23, residueIndexNext1);
            this.setFromToVector(this.d34, residueIndexNext2);
            // extend termini
            var f = 0.5;
            if (residueIndex === residueIndexPrev1) {
                _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_3__["Vec3"].scale(tmpDir, _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_3__["Vec3"].sub(tmpDir, this.p3, this.p4), f);
                _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_3__["Vec3"].add(this.p2, this.p3, tmpDir);
                _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_3__["Vec3"].add(this.p1, this.p2, tmpDir);
                _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_3__["Vec3"].add(this.p0, this.p1, tmpDir);
            }
            else if (residueIndexPrev1 === residueIndexPrev2) {
                _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_3__["Vec3"].scale(tmpDir, _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_3__["Vec3"].sub(tmpDir, this.p2, this.p3), f);
                _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_3__["Vec3"].add(this.p1, this.p2, tmpDir);
                _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_3__["Vec3"].add(this.p0, this.p1, tmpDir);
            }
            else if (residueIndexPrev2 === residueIndexPrev3) {
                _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_3__["Vec3"].scale(tmpDir, _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_3__["Vec3"].sub(tmpDir, this.p1, this.p2), f);
                _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_3__["Vec3"].add(this.p0, this.p1, tmpDir);
            }
            if (residueIndex === residueIndexNext1) {
                _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_3__["Vec3"].scale(tmpDir, _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_3__["Vec3"].sub(tmpDir, this.p3, this.p2), f);
                _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_3__["Vec3"].add(this.p4, this.p3, tmpDir);
                _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_3__["Vec3"].add(this.p5, this.p4, tmpDir);
                _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_3__["Vec3"].add(this.p6, this.p5, tmpDir);
            }
            else if (residueIndexNext1 === residueIndexNext2) {
                _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_3__["Vec3"].scale(tmpDir, _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_3__["Vec3"].sub(tmpDir, this.p4, this.p3), f);
                _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_3__["Vec3"].add(this.p5, this.p4, tmpDir);
                _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_3__["Vec3"].add(this.p6, this.p5, tmpDir);
            }
            else if (residueIndexNext2 === residueIndexNext3) {
                _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_3__["Vec3"].scale(tmpDir, _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_3__["Vec3"].sub(tmpDir, this.p5, this.p4), f);
                _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_3__["Vec3"].add(this.p6, this.p5, tmpDir);
            }
            this.setControlPoint(value.p0, this.p0, this.p1, this.p2, residueIndexPrev2);
            this.setControlPoint(value.p1, this.p1, this.p2, this.p3, residueIndexPrev1);
            this.setControlPoint(value.p2, this.p2, this.p3, this.p4, residueIndex);
            this.setControlPoint(value.p3, this.p3, this.p4, this.p5, residueIndexNext1);
            this.setControlPoint(value.p4, this.p4, this.p5, this.p6, residueIndexNext2);
            this.setDirection(value.d12, this.d01, this.d12, this.d23);
            this.setDirection(value.d23, this.d12, this.d23, this.d34);
            if (!residueIt.hasNext) {
                this.state = 0 /* nextPolymer */;
            }
        }
        this.hasNext = residueIt.hasNext || polymerIt.hasNext;
        return this.value;
    };
    return AtomicPolymerTraceIterator;
}());

var CoarsePolymerTraceIterator = /** @class */ (function () {
    function CoarsePolymerTraceIterator(unit, structure) {
        this.unit = unit;
        this.state = 0 /* nextPolymer */;
        this.hasNext = false;
        this.polymerIt = _mol_data_int_sorted_ranges__WEBPACK_IMPORTED_MODULE_4__["default"].transientSegments(Object(_polymer__WEBPACK_IMPORTED_MODULE_5__["getPolymerRanges"])(unit), unit.elements);
        this.value = createPolymerTraceElement(structure, unit);
        _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_3__["Vec3"].set(this.value.d12, 1, 0, 0);
        _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_3__["Vec3"].set(this.value.d23, 1, 0, 0);
        switch (unit.kind) {
            case 1 /* Spheres */:
                this.conformation = unit.model.coarseConformation.spheres;
                break;
            case 2 /* Gaussians */:
                this.conformation = unit.model.coarseConformation.gaussians;
                break;
        }
        this.hasNext = this.polymerIt.hasNext;
    }
    CoarsePolymerTraceIterator.prototype.getElementIndex = function (elementIndex) {
        return Math.min(Math.max(this.polymerSegment.start, elementIndex), this.polymerSegment.end - 1);
    };
    CoarsePolymerTraceIterator.prototype.pos = function (target, elementIndex) {
        var index = this.unit.elements[elementIndex];
        target[0] = this.conformation.x[index];
        target[1] = this.conformation.y[index];
        target[2] = this.conformation.z[index];
    };
    CoarsePolymerTraceIterator.prototype.move = function () {
        if (this.state === 0 /* nextPolymer */) {
            while (this.polymerIt.hasNext) {
                this.polymerSegment = this.polymerIt.move();
                this.elementIndex = this.polymerSegment.start;
                if (this.elementIndex < this.polymerSegment.end) {
                    this.state = 1 /* nextElement */;
                    break;
                }
            }
        }
        if (this.state === 1 /* nextElement */) {
            var elementIndexPrev2 = this.getElementIndex(this.elementIndex - 2);
            var elementIndexPrev1 = this.getElementIndex(this.elementIndex - 1);
            var elementIndexNext1 = this.getElementIndex(this.elementIndex + 1);
            var elementIndexNext2 = this.getElementIndex(this.elementIndex + 2);
            this.value.centerPrev.element = this.value.center.unit.elements[elementIndexPrev1];
            this.value.center.element = this.value.center.unit.elements[this.elementIndex];
            this.value.centerNext.element = this.value.center.unit.elements[elementIndexNext1];
            this.pos(this.value.p0, elementIndexPrev2);
            this.pos(this.value.p1, elementIndexPrev1);
            this.pos(this.value.p2, this.elementIndex);
            this.pos(this.value.p3, elementIndexNext1);
            this.pos(this.value.p4, elementIndexNext2);
            // extend termini
            var f = 0.5;
            if (this.elementIndex === elementIndexPrev1) {
                _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_3__["Vec3"].scale(tmpDir, _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_3__["Vec3"].sub(tmpDir, this.value.p2, this.value.p3), f);
                _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_3__["Vec3"].add(this.value.p1, this.value.p2, tmpDir);
                _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_3__["Vec3"].add(this.value.p0, this.value.p1, tmpDir);
            }
            else if (elementIndexPrev1 === elementIndexPrev2) {
                _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_3__["Vec3"].scale(tmpDir, _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_3__["Vec3"].sub(tmpDir, this.value.p1, this.value.p2), f);
                _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_3__["Vec3"].add(this.value.p0, this.value.p1, tmpDir);
            }
            if (this.elementIndex === elementIndexNext1) {
                _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_3__["Vec3"].scale(tmpDir, _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_3__["Vec3"].sub(tmpDir, this.value.p2, this.value.p1), f);
                _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_3__["Vec3"].add(this.value.p3, this.value.p2, tmpDir);
                _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_3__["Vec3"].add(this.value.p4, this.value.p3, tmpDir);
            }
            else if (elementIndexNext1 === elementIndexNext2) {
                _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_3__["Vec3"].scale(tmpDir, _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_3__["Vec3"].sub(tmpDir, this.value.p3, this.value.p2), f);
                _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_3__["Vec3"].add(this.value.p4, this.value.p3, tmpDir);
            }
            this.value.first = this.elementIndex === this.polymerSegment.start;
            this.value.last = this.elementIndex === this.polymerSegment.end - 1;
            if (this.elementIndex + 1 >= this.polymerSegment.end) {
                this.state = 0 /* nextPolymer */;
            }
        }
        this.hasNext = this.elementIndex + 1 < this.polymerSegment.end || this.polymerIt.hasNext;
        this.elementIndex += 1;
        return this.value;
    };
    return CoarsePolymerTraceIterator;
}());

//# sourceMappingURL=trace-iterator.js.map

/***/ }),

/***/ "./lib/mol-repr/util.js":
/*!******************************!*\
  !*** ./lib/mol-repr/util.js ***!
  \******************************/
/*! exports provided: VisualUpdateState, DefaultQualityThresholds, getStructureQuality, getQualityProps */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "VisualUpdateState", function() { return VisualUpdateState; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DefaultQualityThresholds", function() { return DefaultQualityThresholds; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getStructureQuality", function() { return getStructureQuality; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getQualityProps", function() { return getQualityProps; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _mol_util__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../mol-util */ "./lib/mol-util/index.js");
/* harmony import */ var _mol_model_structure__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../mol-model/structure */ "./lib/mol-model/structure.js");
/* harmony import */ var _mol_math_geometry__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../mol-math/geometry */ "./lib/mol-math/geometry.js");
/* harmony import */ var _mol_model_formats_structure_property_symmetry__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../mol-model-formats/structure/property/symmetry */ "./lib/mol-model-formats/structure/property/symmetry.js");
/* harmony import */ var _mol_model_volume__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../mol-model/volume */ "./lib/mol-model/volume.js");
/**
 * Copyright (c) 2018-2020 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */






var VisualUpdateState;
(function (VisualUpdateState) {
    function create() {
        return {
            updateTransform: false,
            updateMatrix: false,
            updateColor: false,
            updateSize: false,
            createGeometry: false,
            createNew: false,
            info: {}
        };
    }
    VisualUpdateState.create = create;
    function reset(state) {
        state.updateTransform = false;
        state.updateMatrix = false;
        state.updateColor = false;
        state.updateSize = false;
        state.createGeometry = false;
        state.createNew = false;
    }
    VisualUpdateState.reset = reset;
})(VisualUpdateState || (VisualUpdateState = {}));
var DefaultQualityThresholds = {
    lowestElementCount: 500000,
    lowerElementCount: 200000,
    lowElementCount: 60000,
    mediumElementCount: 20000,
    highElementCount: 2000,
    coarseGrainedFactor: 10,
    elementCountFactor: 1
};
function getStructureQuality(structure, tresholds) {
    if (tresholds === void 0) { tresholds = {}; }
    var t = Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, DefaultQualityThresholds), tresholds);
    var score = structure.elementCount * t.elementCountFactor;
    if (structure.isCoarseGrained)
        score *= t.coarseGrainedFactor;
    if (score > t.lowestElementCount) {
        return 'lowest';
    }
    else if (score > t.lowerElementCount) {
        return 'lower';
    }
    else if (score > t.lowElementCount) {
        return 'low';
    }
    else if (score > t.mediumElementCount) {
        return 'medium';
    }
    else if (score > t.highElementCount) {
        return 'high';
    }
    else {
        return 'higher';
    }
}
/**
 * Uses cell volume to avoid costly boundary calculation if
 * - single model
 * - non-empty 'P 1' spacegroup
 */
function getRootVolume(structure) {
    if (structure.root.models.length === 1) {
        var sym = _mol_model_formats_structure_property_symmetry__WEBPACK_IMPORTED_MODULE_4__["ModelSymmetry"].Provider.get(structure.root.model);
        if (sym && sym.spacegroup.name === 'P 1' && !_mol_math_geometry__WEBPACK_IMPORTED_MODULE_3__["SpacegroupCell"].isZero(sym.spacegroup.cell)) {
            return sym.spacegroup.cell.volume;
        }
    }
    return _mol_math_geometry__WEBPACK_IMPORTED_MODULE_3__["Box3D"].volume(structure.root.boundary.box);
}
function getQualityProps(props, data) {
    var quality = Object(_mol_util__WEBPACK_IMPORTED_MODULE_1__["defaults"])(props.quality, 'auto');
    var detail = Object(_mol_util__WEBPACK_IMPORTED_MODULE_1__["defaults"])(props.detail, 1);
    var radialSegments = Object(_mol_util__WEBPACK_IMPORTED_MODULE_1__["defaults"])(props.radialSegments, 12);
    var linearSegments = Object(_mol_util__WEBPACK_IMPORTED_MODULE_1__["defaults"])(props.linearSegments, 8);
    var resolution = Object(_mol_util__WEBPACK_IMPORTED_MODULE_1__["defaults"])(props.resolution, 2);
    var doubleSided = Object(_mol_util__WEBPACK_IMPORTED_MODULE_1__["defaults"])(props.doubleSided, true);
    var volume = 0;
    if (quality === 'auto') {
        if (data instanceof _mol_model_structure__WEBPACK_IMPORTED_MODULE_2__["Structure"]) {
            quality = getStructureQuality(data.root);
            volume = getRootVolume(data);
        }
        else if (_mol_model_volume__WEBPACK_IMPORTED_MODULE_5__["Volume"].is(data)) {
            var _a = data.grid.cells.space.dimensions, x = _a[0], y = _a[1], z = _a[2];
            volume = x * y * z;
            quality = volume < 10000000 ? 'medium' : 'low';
        }
    }
    switch (quality) {
        case 'highest':
            detail = 3;
            radialSegments = 36;
            linearSegments = 18;
            resolution = Math.max(volume / 500000000, 0.1);
            doubleSided = true;
            break;
        case 'higher':
            detail = 3;
            radialSegments = 28;
            linearSegments = 14;
            resolution = Math.max(volume / 400000000, 0.3);
            doubleSided = true;
            break;
        case 'high':
            detail = 2;
            radialSegments = 20;
            linearSegments = 10;
            resolution = Math.max(volume / 300000000, 0.5);
            doubleSided = true;
            break;
        case 'medium':
            detail = 1;
            radialSegments = 12;
            linearSegments = 8;
            resolution = Math.max(volume / 200000000, 1);
            doubleSided = true;
            break;
        case 'low':
            detail = 0;
            radialSegments = 8;
            linearSegments = 3;
            resolution = Math.max(volume / 150000000, 2);
            doubleSided = false;
            break;
        case 'lower':
            detail = 0;
            radialSegments = 4;
            linearSegments = 2;
            resolution = Math.max(volume / 100000000, 4);
            doubleSided = false;
            break;
        case 'lowest':
            detail = 0;
            radialSegments = 2;
            linearSegments = 1;
            resolution = Math.max(volume / 75000000, 8);
            doubleSided = false;
            break;
        case 'custom':
            // use defaults or given props as set above
            break;
    }
    resolution = Math.min(resolution, 20);
    if ((props.alpha !== undefined && props.alpha < 1) || !!props.xrayShaded) {
        doubleSided = false;
    }
    return {
        detail: detail,
        radialSegments: radialSegments,
        linearSegments: linearSegments,
        resolution: resolution,
        doubleSided: doubleSided
    };
}
//# sourceMappingURL=util.js.map

/***/ }),

/***/ "./lib/mol-repr/visual.js":
/*!********************************!*\
  !*** ./lib/mol-repr/visual.js ***!
  \********************************/
/*! exports provided: Visual */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Visual", function() { return Visual; });
/* harmony import */ var _mol_model_loci__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../mol-model/loci */ "./lib/mol-model/loci.js");
/* harmony import */ var _mol_util_marker_action__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../mol-util/marker-action */ "./lib/mol-util/marker-action.js");
/* harmony import */ var _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../mol-math/linear-algebra */ "./lib/mol-math/linear-algebra.js");
/* harmony import */ var _mol_geo_geometry_transform_data__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../mol-geo/geometry/transform-data */ "./lib/mol-geo/geometry/transform-data.js");
/* harmony import */ var _mol_gl_renderable_util__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../mol-gl/renderable/util */ "./lib/mol-gl/renderable/util.js");
/* harmony import */ var _mol_util__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../mol-util */ "./lib/mol-util/index.js");
/* harmony import */ var _mol_geo_geometry_overpaint_data__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../mol-geo/geometry/overpaint-data */ "./lib/mol-geo/geometry/overpaint-data.js");
/* harmony import */ var _mol_data_int__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../mol-data/int */ "./lib/mol-data/int.js");
/* harmony import */ var _mol_geo_geometry_transparency_data__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ../mol-geo/geometry/transparency-data */ "./lib/mol-geo/geometry/transparency-data.js");
/* harmony import */ var _mol_geo_geometry_clipping_data__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ../mol-geo/geometry/clipping-data */ "./lib/mol-geo/geometry/clipping-data.js");
/**
 * Copyright (c) 2018-2020 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */










// export type VisualFactory<D, P extends PD.Params> = (ctx: VisualContext) => Visual<D, P>

var Visual;
(function (Visual) {
    function setVisibility(renderObject, visible) {
        if (renderObject)
            renderObject.state.visible = visible;
    }
    Visual.setVisibility = setVisibility;
    function setAlphaFactor(renderObject, alphaFactor) {
        if (renderObject)
            renderObject.state.alphaFactor = alphaFactor;
    }
    Visual.setAlphaFactor = setAlphaFactor;
    function setPickable(renderObject, pickable) {
        if (renderObject)
            renderObject.state.pickable = pickable;
    }
    Visual.setPickable = setPickable;
    function setColorOnly(renderObject, colorOnly) {
        if (renderObject)
            renderObject.state.colorOnly = colorOnly;
    }
    Visual.setColorOnly = setColorOnly;
    function mark(renderObject, loci, action, lociApply) {
        if (!renderObject)
            return false;
        var _a = renderObject.values, tMarker = _a.tMarker, uGroupCount = _a.uGroupCount, instanceCount = _a.instanceCount;
        var count = uGroupCount.ref.value * instanceCount.ref.value;
        var array = tMarker.ref.value.array;
        var changed = false;
        if (Object(_mol_model_loci__WEBPACK_IMPORTED_MODULE_0__["isEveryLoci"])(loci)) {
            changed = Object(_mol_util_marker_action__WEBPACK_IMPORTED_MODULE_1__["applyMarkerAction"])(array, _mol_data_int__WEBPACK_IMPORTED_MODULE_7__["Interval"].ofLength(count), action);
        }
        else if (!Object(_mol_model_loci__WEBPACK_IMPORTED_MODULE_0__["isEmptyLoci"])(loci)) {
            changed = lociApply(loci, function (interval) { return Object(_mol_util_marker_action__WEBPACK_IMPORTED_MODULE_1__["applyMarkerAction"])(array, interval, action); }, true);
        }
        if (changed)
            _mol_util__WEBPACK_IMPORTED_MODULE_5__["ValueCell"].update(tMarker, tMarker.ref.value);
        return changed;
    }
    Visual.mark = mark;
    function setOverpaint(renderObject, overpaint, lociApply, clear) {
        if (!renderObject)
            return;
        var _a = renderObject.values, tOverpaint = _a.tOverpaint, uGroupCount = _a.uGroupCount, instanceCount = _a.instanceCount;
        var count = uGroupCount.ref.value * instanceCount.ref.value;
        // ensure texture has right size
        Object(_mol_geo_geometry_overpaint_data__WEBPACK_IMPORTED_MODULE_6__["createOverpaint"])(overpaint.layers.length ? count : 0, renderObject.values);
        var array = tOverpaint.ref.value.array;
        // clear all if requested
        if (clear)
            Object(_mol_geo_geometry_overpaint_data__WEBPACK_IMPORTED_MODULE_6__["clearOverpaint"])(array, 0, count);
        var _loop_1 = function (i, il) {
            var _a = overpaint.layers[i], loci = _a.loci, color = _a.color, clear_1 = _a.clear;
            var apply = function (interval) {
                var start = _mol_data_int__WEBPACK_IMPORTED_MODULE_7__["Interval"].start(interval);
                var end = _mol_data_int__WEBPACK_IMPORTED_MODULE_7__["Interval"].end(interval);
                return clear_1
                    ? Object(_mol_geo_geometry_overpaint_data__WEBPACK_IMPORTED_MODULE_6__["clearOverpaint"])(array, start, end)
                    : Object(_mol_geo_geometry_overpaint_data__WEBPACK_IMPORTED_MODULE_6__["applyOverpaintColor"])(array, start, end, color);
            };
            lociApply(loci, apply, false);
        };
        for (var i = 0, il = overpaint.layers.length; i < il; ++i) {
            _loop_1(i, il);
        }
        _mol_util__WEBPACK_IMPORTED_MODULE_5__["ValueCell"].update(tOverpaint, tOverpaint.ref.value);
    }
    Visual.setOverpaint = setOverpaint;
    function setTransparency(renderObject, transparency, lociApply, clear) {
        if (!renderObject)
            return;
        var _a = renderObject.values, tTransparency = _a.tTransparency, transparencyAverage = _a.transparencyAverage, uGroupCount = _a.uGroupCount, instanceCount = _a.instanceCount;
        var count = uGroupCount.ref.value * instanceCount.ref.value;
        // ensure texture has right size and variant
        Object(_mol_geo_geometry_transparency_data__WEBPACK_IMPORTED_MODULE_8__["createTransparency"])(transparency.layers.length ? count : 0, renderObject.values);
        var array = tTransparency.ref.value.array;
        // clear if requested
        if (clear)
            Object(_mol_geo_geometry_transparency_data__WEBPACK_IMPORTED_MODULE_8__["clearTransparency"])(array, 0, count);
        var _loop_2 = function (i, il) {
            var _a = transparency.layers[i], loci = _a.loci, value = _a.value;
            var apply = function (interval) {
                var start = _mol_data_int__WEBPACK_IMPORTED_MODULE_7__["Interval"].start(interval);
                var end = _mol_data_int__WEBPACK_IMPORTED_MODULE_7__["Interval"].end(interval);
                return Object(_mol_geo_geometry_transparency_data__WEBPACK_IMPORTED_MODULE_8__["applyTransparencyValue"])(array, start, end, value);
            };
            lociApply(loci, apply, false);
        };
        for (var i = 0, il = transparency.layers.length; i < il; ++i) {
            _loop_2(i, il);
        }
        _mol_util__WEBPACK_IMPORTED_MODULE_5__["ValueCell"].update(tTransparency, tTransparency.ref.value);
        _mol_util__WEBPACK_IMPORTED_MODULE_5__["ValueCell"].updateIfChanged(transparencyAverage, Object(_mol_geo_geometry_transparency_data__WEBPACK_IMPORTED_MODULE_8__["getTransparencyAverage"])(array, count));
    }
    Visual.setTransparency = setTransparency;
    function setClipping(renderObject, clipping, lociApply, clear) {
        if (!renderObject)
            return;
        var _a = renderObject.values, tClipping = _a.tClipping, uGroupCount = _a.uGroupCount, instanceCount = _a.instanceCount;
        var count = uGroupCount.ref.value * instanceCount.ref.value;
        // ensure texture has right size
        Object(_mol_geo_geometry_clipping_data__WEBPACK_IMPORTED_MODULE_9__["createClipping"])(clipping.layers.length ? count : 0, renderObject.values);
        var array = tClipping.ref.value.array;
        // clear if requested
        if (clear)
            Object(_mol_geo_geometry_clipping_data__WEBPACK_IMPORTED_MODULE_9__["clearClipping"])(array, 0, count);
        var _loop_3 = function (i, il) {
            var _a = clipping.layers[i], loci = _a.loci, groups = _a.groups;
            var apply = function (interval) {
                var start = _mol_data_int__WEBPACK_IMPORTED_MODULE_7__["Interval"].start(interval);
                var end = _mol_data_int__WEBPACK_IMPORTED_MODULE_7__["Interval"].end(interval);
                return Object(_mol_geo_geometry_clipping_data__WEBPACK_IMPORTED_MODULE_9__["applyClippingGroups"])(array, start, end, groups);
            };
            lociApply(loci, apply, false);
        };
        for (var i = 0, il = clipping.layers.length; i < il; ++i) {
            _loop_3(i, il);
        }
        _mol_util__WEBPACK_IMPORTED_MODULE_5__["ValueCell"].update(tClipping, tClipping.ref.value);
    }
    Visual.setClipping = setClipping;
    function setTransform(renderObject, transform, instanceTransforms) {
        if (!renderObject || (!transform && !instanceTransforms))
            return;
        var values = renderObject.values;
        if (transform) {
            _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_2__["Mat4"].copy(values.matrix.ref.value, transform);
            _mol_util__WEBPACK_IMPORTED_MODULE_5__["ValueCell"].update(values.matrix, values.matrix.ref.value);
        }
        if (instanceTransforms) {
            values.extraTransform.ref.value.set(instanceTransforms);
            _mol_util__WEBPACK_IMPORTED_MODULE_5__["ValueCell"].update(values.extraTransform, values.extraTransform.ref.value);
        }
        else if (instanceTransforms === null) {
            Object(_mol_geo_geometry_transform_data__WEBPACK_IMPORTED_MODULE_3__["fillIdentityTransform"])(values.extraTransform.ref.value, values.instanceCount.ref.value);
            _mol_util__WEBPACK_IMPORTED_MODULE_5__["ValueCell"].update(values.extraTransform, values.extraTransform.ref.value);
        }
        Object(_mol_geo_geometry_transform_data__WEBPACK_IMPORTED_MODULE_3__["updateTransformData"])(values);
        var boundingSphere = Object(_mol_gl_renderable_util__WEBPACK_IMPORTED_MODULE_4__["calculateTransformBoundingSphere"])(values.invariantBoundingSphere.ref.value, values.aTransform.ref.value, values.instanceCount.ref.value);
        _mol_util__WEBPACK_IMPORTED_MODULE_5__["ValueCell"].update(values.boundingSphere, boundingSphere);
    }
    Visual.setTransform = setTransform;
})(Visual || (Visual = {}));
//# sourceMappingURL=visual.js.map

/***/ }),

/***/ "./lib/mol-repr/volume/direct-volume.js":
/*!**********************************************!*\
  !*** ./lib/mol-repr/volume/direct-volume.js ***!
  \**********************************************/
/*! exports provided: createDirectVolume2d, createDirectVolume3d, createDirectVolume, getDirectVolumeLoci, eachDirectVolume, DirectVolumeParams, getDirectVolumeParams, DirectVolumeVisual, DirectVolumeRepresentation, DirectVolumeRepresentationProvider */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createDirectVolume2d", function() { return createDirectVolume2d; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createDirectVolume3d", function() { return createDirectVolume3d; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createDirectVolume", function() { return createDirectVolume; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getDirectVolumeLoci", function() { return getDirectVolumeLoci; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "eachDirectVolume", function() { return eachDirectVolume; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DirectVolumeParams", function() { return DirectVolumeParams; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getDirectVolumeParams", function() { return getDirectVolumeParams; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DirectVolumeVisual", function() { return DirectVolumeVisual; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DirectVolumeRepresentation", function() { return DirectVolumeRepresentation; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DirectVolumeRepresentationProvider", function() { return DirectVolumeRepresentationProvider; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../mol-util/param-definition */ "./lib/mol-util/param-definition.js");
/* harmony import */ var _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../mol-math/linear-algebra */ "./lib/mol-math/linear-algebra.js");
/* harmony import */ var _mol_math_geometry__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../mol-math/geometry */ "./lib/mol-math/geometry.js");
/* harmony import */ var _mol_model_volume__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../mol-model/volume */ "./lib/mol-model/volume.js");
/* harmony import */ var _mol_geo_geometry_direct_volume_direct_volume__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../mol-geo/geometry/direct-volume/direct-volume */ "./lib/mol-geo/geometry/direct-volume/direct-volume.js");
/* harmony import */ var _representation__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ./representation */ "./lib/mol-repr/volume/representation.js");
/* harmony import */ var _mol_geo_util_location_iterator__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../../mol-geo/util/location-iterator */ "./lib/mol-geo/util/location-iterator.js");
/* harmony import */ var _mol_model_location__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ../../mol-model/location */ "./lib/mol-model/location.js");
/* harmony import */ var _mol_data_int__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ../../mol-data/int */ "./lib/mol-data/int.js");
/* harmony import */ var _mol_model_loci__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ../../mol-model/loci */ "./lib/mol-model/loci.js");
/* harmony import */ var _util__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ./util */ "./lib/mol-repr/volume/util.js");
/**
 * Copyright (c) 2018-2020 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */












function getBoundingBox(gridDimension, transform) {
    var bbox = Object(_mol_math_geometry__WEBPACK_IMPORTED_MODULE_3__["Box3D"])();
    _mol_math_geometry__WEBPACK_IMPORTED_MODULE_3__["Box3D"].add(bbox, gridDimension);
    _mol_math_geometry__WEBPACK_IMPORTED_MODULE_3__["Box3D"].transform(bbox, bbox, transform);
    return bbox;
}
// 2d volume texture
function createDirectVolume2d(ctx, webgl, volume, directVolume) {
    var gridDimension = volume.grid.cells.space.dimensions;
    var textureImage = Object(_util__WEBPACK_IMPORTED_MODULE_11__["createVolumeTexture2d"])(volume, 'normals');
    // debugTexture(createImageData(textureImage.array, textureImage.width, textureImage.height), 1/3)
    var transform = _mol_model_volume__WEBPACK_IMPORTED_MODULE_4__["Grid"].getGridToCartesianTransform(volume.grid);
    var bbox = getBoundingBox(gridDimension, transform);
    var texture = directVolume ? directVolume.gridTexture.ref.value : webgl.resources.texture('image-uint8', 'rgba', 'ubyte', 'linear');
    texture.load(textureImage);
    var _a = getUnitToCartn(volume.grid), unitToCartn = _a.unitToCartn, cellDim = _a.cellDim;
    return _mol_geo_geometry_direct_volume_direct_volume__WEBPACK_IMPORTED_MODULE_5__["DirectVolume"].create(bbox, gridDimension, transform, unitToCartn, cellDim, texture, volume.grid.stats, false, directVolume);
}
// 3d volume texture
function getUnitToCartn(grid) {
    if (grid.transform.kind === 'matrix') {
        return {
            unitToCartn: _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_2__["Mat4"].mul(Object(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_2__["Mat4"])(), grid.transform.matrix, _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_2__["Mat4"].fromScaling(Object(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_2__["Mat4"])(), grid.cells.space.dimensions)),
            cellDim: _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_2__["Mat4"].getScaling(Object(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_2__["Vec3"])(), grid.transform.matrix)
        };
    }
    var box = grid.transform.fractionalBox;
    var size = _mol_math_geometry__WEBPACK_IMPORTED_MODULE_3__["Box3D"].size(Object(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_2__["Vec3"])(), box);
    return {
        unitToCartn: _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_2__["Mat4"].mul3(Object(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_2__["Mat4"])(), grid.transform.cell.fromFractional, _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_2__["Mat4"].fromTranslation(Object(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_2__["Mat4"])(), box.min), _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_2__["Mat4"].fromScaling(Object(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_2__["Mat4"])(), size)),
        cellDim: _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_2__["Vec3"].div(Object(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_2__["Vec3"])(), grid.transform.cell.size, grid.cells.space.dimensions)
    };
}
function createDirectVolume3d(ctx, webgl, volume, directVolume) {
    var gridDimension = volume.grid.cells.space.dimensions;
    var textureVolume = Object(_util__WEBPACK_IMPORTED_MODULE_11__["createVolumeTexture3d"])(volume);
    var transform = _mol_model_volume__WEBPACK_IMPORTED_MODULE_4__["Grid"].getGridToCartesianTransform(volume.grid);
    var bbox = getBoundingBox(gridDimension, transform);
    var texture = directVolume ? directVolume.gridTexture.ref.value : webgl.resources.texture('volume-uint8', 'rgba', 'ubyte', 'linear');
    texture.load(textureVolume);
    var _a = getUnitToCartn(volume.grid), unitToCartn = _a.unitToCartn, cellDim = _a.cellDim;
    return _mol_geo_geometry_direct_volume_direct_volume__WEBPACK_IMPORTED_MODULE_5__["DirectVolume"].create(bbox, gridDimension, transform, unitToCartn, cellDim, texture, volume.grid.stats, false, directVolume);
}
//
function createDirectVolume(ctx, volume, theme, props, directVolume) {
    return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"])(this, void 0, void 0, function () {
        var runtime, webgl;
        return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__generator"])(this, function (_a) {
            runtime = ctx.runtime, webgl = ctx.webgl;
            if (webgl === undefined)
                throw new Error('DirectVolumeVisual requires `webgl` in props');
            return [2 /*return*/, webgl.isWebGL2 ?
                    createDirectVolume3d(runtime, webgl, volume, directVolume) :
                    createDirectVolume2d(runtime, webgl, volume, directVolume)];
        });
    });
}
function getLoci(volume, props) {
    return props.renderMode.name === 'isosurface'
        ? _mol_model_volume__WEBPACK_IMPORTED_MODULE_4__["Volume"].Isosurface.Loci(volume, props.renderMode.params.isoValue)
        : _mol_model_volume__WEBPACK_IMPORTED_MODULE_4__["Volume"].Loci(volume);
}
function getDirectVolumeLoci(pickingId, volume, props, id) {
    var objectId = pickingId.objectId, groupId = pickingId.groupId;
    if (id === objectId) {
        return _mol_model_volume__WEBPACK_IMPORTED_MODULE_4__["Volume"].Cell.Loci(volume, _mol_data_int__WEBPACK_IMPORTED_MODULE_9__["Interval"].ofSingleton(groupId));
    }
    return _mol_model_loci__WEBPACK_IMPORTED_MODULE_10__["EmptyLoci"];
}
function eachDirectVolume(loci, volume, props, apply) {
    var isoValue = props.renderMode.name === 'isosurface'
        ? props.renderMode.params.isoValue : undefined;
    return Object(_util__WEBPACK_IMPORTED_MODULE_11__["eachVolumeLoci"])(loci, volume, isoValue, apply);
}
//
var DirectVolumeParams = Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, _mol_geo_geometry_direct_volume_direct_volume__WEBPACK_IMPORTED_MODULE_5__["DirectVolume"].Params), { quality: Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, _mol_geo_geometry_direct_volume_direct_volume__WEBPACK_IMPORTED_MODULE_5__["DirectVolume"].Params.quality), { isEssential: false }) });
function getDirectVolumeParams(ctx, volume) {
    var p = _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_1__["ParamDefinition"].clone(DirectVolumeParams);
    p.renderMode = _mol_geo_geometry_direct_volume_direct_volume__WEBPACK_IMPORTED_MODULE_5__["DirectVolume"].createRenderModeParam(volume.grid.stats);
    return p;
}
function DirectVolumeVisual(materialId) {
    return Object(_representation__WEBPACK_IMPORTED_MODULE_6__["VolumeVisual"])({
        defaultProps: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_1__["ParamDefinition"].getDefaultValues(DirectVolumeParams),
        createGeometry: createDirectVolume,
        createLocationIterator: function (volume) { return Object(_mol_geo_util_location_iterator__WEBPACK_IMPORTED_MODULE_7__["LocationIterator"])(volume.grid.cells.data.length, 1, 1, function () { return _mol_model_location__WEBPACK_IMPORTED_MODULE_8__["NullLocation"]; }); },
        getLoci: getDirectVolumeLoci,
        eachLocation: eachDirectVolume,
        setUpdateState: function (state, volume, newProps, currentProps) {
        },
        geometryUtils: _mol_geo_geometry_direct_volume_direct_volume__WEBPACK_IMPORTED_MODULE_5__["DirectVolume"].Utils,
        dispose: function (geometry) {
            geometry.gridTexture.ref.value.destroy();
        }
    }, materialId);
}
function DirectVolumeRepresentation(ctx, getParams) {
    return Object(_representation__WEBPACK_IMPORTED_MODULE_6__["VolumeRepresentation"])('Direct Volume', ctx, getParams, DirectVolumeVisual, getLoci);
}
var DirectVolumeRepresentationProvider = Object(_representation__WEBPACK_IMPORTED_MODULE_6__["VolumeRepresentationProvider"])({
    name: 'direct-volume',
    label: 'Direct Volume',
    description: 'Direct rendering of volumetric data.',
    factory: DirectVolumeRepresentation,
    getParams: getDirectVolumeParams,
    defaultValues: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_1__["ParamDefinition"].getDefaultValues(DirectVolumeParams),
    defaultColorTheme: { name: 'uniform' },
    defaultSizeTheme: { name: 'uniform' },
    isApplicable: function (volume) { return !_mol_model_volume__WEBPACK_IMPORTED_MODULE_4__["Volume"].isEmpty(volume); }
});
//# sourceMappingURL=direct-volume.js.map

/***/ }),

/***/ "./lib/mol-repr/volume/isosurface.js":
/*!*******************************************!*\
  !*** ./lib/mol-repr/volume/isosurface.js ***!
  \*******************************************/
/*! exports provided: VolumeIsosurfaceParams, IsosurfaceVisual, eachIsosurface, createVolumeIsosurfaceMesh, IsosurfaceMeshParams, IsosurfaceMeshVisual, IsosurfaceTextureMeshVisual, createVolumeIsosurfaceWireframe, IsosurfaceWireframeParams, IsosurfaceWireframeVisual, IsosurfaceParams, getIsosurfaceParams, IsosurfaceRepresentation, IsosurfaceRepresentationProvider */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "VolumeIsosurfaceParams", function() { return VolumeIsosurfaceParams; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "IsosurfaceVisual", function() { return IsosurfaceVisual; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "eachIsosurface", function() { return eachIsosurface; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createVolumeIsosurfaceMesh", function() { return createVolumeIsosurfaceMesh; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "IsosurfaceMeshParams", function() { return IsosurfaceMeshParams; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "IsosurfaceMeshVisual", function() { return IsosurfaceMeshVisual; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "IsosurfaceTextureMeshVisual", function() { return IsosurfaceTextureMeshVisual; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createVolumeIsosurfaceWireframe", function() { return createVolumeIsosurfaceWireframe; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "IsosurfaceWireframeParams", function() { return IsosurfaceWireframeParams; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "IsosurfaceWireframeVisual", function() { return IsosurfaceWireframeVisual; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "IsosurfaceParams", function() { return IsosurfaceParams; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getIsosurfaceParams", function() { return getIsosurfaceParams; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "IsosurfaceRepresentation", function() { return IsosurfaceRepresentation; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "IsosurfaceRepresentationProvider", function() { return IsosurfaceRepresentationProvider; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../mol-util/param-definition */ "./lib/mol-util/param-definition.js");
/* harmony import */ var _mol_model_volume__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../mol-model/volume */ "./lib/mol-model/volume.js");
/* harmony import */ var _mol_geo_geometry_mesh_mesh__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../mol-geo/geometry/mesh/mesh */ "./lib/mol-geo/geometry/mesh/mesh.js");
/* harmony import */ var _mol_geo_util_marching_cubes_algorithm__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../mol-geo/util/marching-cubes/algorithm */ "./lib/mol-geo/util/marching-cubes/algorithm.js");
/* harmony import */ var _representation__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./representation */ "./lib/mol-repr/volume/representation.js");
/* harmony import */ var _mol_geo_util_location_iterator__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../../mol-geo/util/location-iterator */ "./lib/mol-geo/util/location-iterator.js");
/* harmony import */ var _mol_model_location__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../../mol-model/location */ "./lib/mol-model/location.js");
/* harmony import */ var _mol_geo_geometry_lines_lines__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ../../mol-geo/geometry/lines/lines */ "./lib/mol-geo/geometry/lines/lines.js");
/* harmony import */ var _representation__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ../representation */ "./lib/mol-repr/representation.js");
/* harmony import */ var _mol_model_loci__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ../../mol-model/loci */ "./lib/mol-model/loci.js");
/* harmony import */ var _mol_data_int__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ../../mol-data/int */ "./lib/mol-data/int.js");
/* harmony import */ var _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! ../../mol-math/linear-algebra */ "./lib/mol-math/linear-algebra.js");
/* harmony import */ var _mol_util_array__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! ../../mol-util/array */ "./lib/mol-util/array.js");
/* harmony import */ var _util__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! ./util */ "./lib/mol-repr/volume/util.js");
/* harmony import */ var _mol_geo_geometry_texture_mesh_texture_mesh__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! ../../mol-geo/geometry/texture-mesh/texture-mesh */ "./lib/mol-geo/geometry/texture-mesh/texture-mesh.js");
/* harmony import */ var _mol_gl_compute_marching_cubes_active_voxels__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(/*! ../../mol-gl/compute/marching-cubes/active-voxels */ "./lib/mol-gl/compute/marching-cubes/active-voxels.js");
/* harmony import */ var _mol_gl_compute_histogram_pyramid_reduction__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(/*! ../../mol-gl/compute/histogram-pyramid/reduction */ "./lib/mol-gl/compute/histogram-pyramid/reduction.js");
/* harmony import */ var _mol_gl_compute_marching_cubes_isosurface__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(/*! ../../mol-gl/compute/marching-cubes/isosurface */ "./lib/mol-gl/compute/marching-cubes/isosurface.js");
/* harmony import */ var _mol_model_custom_property__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(/*! ../../mol-model/custom-property */ "./lib/mol-model/custom-property.js");
/**
 * Copyright (c) 2018-2021 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author David Sehnal <david.sehnal@gmail.com>
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */




















var VolumeIsosurfaceParams = {
    isoValue: _mol_model_volume__WEBPACK_IMPORTED_MODULE_2__["Volume"].IsoValueParam
};
function gpuSupport(webgl) {
    return webgl.extensions.colorBufferFloat && webgl.extensions.textureFloat && webgl.extensions.drawBuffers;
}
function IsosurfaceVisual(materialId, props, webgl) {
    return (props === null || props === void 0 ? void 0 : props.useGpu) && webgl && gpuSupport(webgl)
        ? IsosurfaceTextureMeshVisual(materialId)
        : IsosurfaceMeshVisual(materialId);
}
function getLoci(volume, props) {
    return _mol_model_volume__WEBPACK_IMPORTED_MODULE_2__["Volume"].Isosurface.Loci(volume, props.isoValue);
}
function getIsosurfaceLoci(pickingId, volume, props, id) {
    var objectId = pickingId.objectId, groupId = pickingId.groupId;
    if (id === objectId) {
        return _mol_model_volume__WEBPACK_IMPORTED_MODULE_2__["Volume"].Cell.Loci(volume, _mol_data_int__WEBPACK_IMPORTED_MODULE_11__["Interval"].ofSingleton(groupId));
    }
    return _mol_model_loci__WEBPACK_IMPORTED_MODULE_10__["EmptyLoci"];
}
function eachIsosurface(loci, volume, props, apply) {
    return Object(_util__WEBPACK_IMPORTED_MODULE_14__["eachVolumeLoci"])(loci, volume, props.isoValue, apply);
}
//
function createVolumeIsosurfaceMesh(ctx, volume, theme, props, mesh) {
    return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"])(this, void 0, void 0, function () {
        var ids, surface, transform;
        return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__generator"])(this, function (_a) {
            switch (_a.label) {
                case 0:
                    ctx.runtime.update({ message: 'Marching cubes...' });
                    ids = Object(_mol_util_array__WEBPACK_IMPORTED_MODULE_13__["fillSerial"])(new Int32Array(volume.grid.cells.data.length));
                    return [4 /*yield*/, Object(_mol_geo_util_marching_cubes_algorithm__WEBPACK_IMPORTED_MODULE_4__["computeMarchingCubesMesh"])({
                            isoLevel: _mol_model_volume__WEBPACK_IMPORTED_MODULE_2__["Volume"].IsoValue.toAbsolute(props.isoValue, volume.grid.stats).absoluteValue,
                            scalarField: volume.grid.cells,
                            idField: _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_12__["Tensor"].create(volume.grid.cells.space, _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_12__["Tensor"].Data1(ids))
                        }, mesh).runAsChild(ctx.runtime)];
                case 1:
                    surface = _a.sent();
                    transform = _mol_model_volume__WEBPACK_IMPORTED_MODULE_2__["Grid"].getGridToCartesianTransform(volume.grid);
                    _mol_geo_geometry_mesh_mesh__WEBPACK_IMPORTED_MODULE_3__["Mesh"].transform(surface, transform);
                    if (ctx.webgl && !ctx.webgl.isWebGL2)
                        _mol_geo_geometry_mesh_mesh__WEBPACK_IMPORTED_MODULE_3__["Mesh"].uniformTriangleGroup(surface);
                    surface.setBoundingSphere(_mol_model_volume__WEBPACK_IMPORTED_MODULE_2__["Volume"].getBoundingSphere(volume));
                    return [2 /*return*/, surface];
            }
        });
    });
}
var IsosurfaceMeshParams = Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, _mol_geo_geometry_mesh_mesh__WEBPACK_IMPORTED_MODULE_3__["Mesh"].Params), _mol_geo_geometry_texture_mesh_texture_mesh__WEBPACK_IMPORTED_MODULE_15__["TextureMesh"].Params), VolumeIsosurfaceParams), { quality: Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, _mol_geo_geometry_mesh_mesh__WEBPACK_IMPORTED_MODULE_3__["Mesh"].Params.quality), { isEssential: false }), useGpu: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_1__["ParamDefinition"].Boolean(false) });
function IsosurfaceMeshVisual(materialId) {
    return Object(_representation__WEBPACK_IMPORTED_MODULE_5__["VolumeVisual"])({
        defaultProps: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_1__["ParamDefinition"].getDefaultValues(IsosurfaceMeshParams),
        createGeometry: createVolumeIsosurfaceMesh,
        createLocationIterator: function (volume) { return Object(_mol_geo_util_location_iterator__WEBPACK_IMPORTED_MODULE_6__["LocationIterator"])(volume.grid.cells.data.length, 1, 1, function () { return _mol_model_location__WEBPACK_IMPORTED_MODULE_7__["NullLocation"]; }); },
        getLoci: getIsosurfaceLoci,
        eachLocation: eachIsosurface,
        setUpdateState: function (state, volume, newProps, currentProps) {
            if (!_mol_model_volume__WEBPACK_IMPORTED_MODULE_2__["Volume"].IsoValue.areSame(newProps.isoValue, currentProps.isoValue, volume.grid.stats))
                state.createGeometry = true;
        },
        geometryUtils: _mol_geo_geometry_mesh_mesh__WEBPACK_IMPORTED_MODULE_3__["Mesh"].Utils,
        mustRecreate: function (props, webgl) {
            return props.useGpu && !!webgl;
        }
    }, materialId);
}
//
var VolumeIsosurfaceTexture;
(function (VolumeIsosurfaceTexture) {
    var name = 'volume-isosurface-texture';
    VolumeIsosurfaceTexture.descriptor = Object(_mol_model_custom_property__WEBPACK_IMPORTED_MODULE_19__["CustomPropertyDescriptor"])({ name: name });
    function get(volume, webgl) {
        var resources = webgl.resources;
        var padding = 1;
        var transform = _mol_model_volume__WEBPACK_IMPORTED_MODULE_2__["Grid"].getGridToCartesianTransform(volume.grid);
        var gridDimension = _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_12__["Vec3"].clone(volume.grid.cells.space.dimensions);
        var _a = Object(_util__WEBPACK_IMPORTED_MODULE_14__["getVolumeTexture2dLayout"])(gridDimension, padding), width = _a.width, height = _a.height, texDim = _a.powerOfTwoSize;
        var gridTexDim = _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_12__["Vec3"].create(width, height, 0);
        var gridTexScale = _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_12__["Vec2"].create(width / texDim, height / texDim);
        // console.log({ texDim, width, height, gridDimension });
        if (!volume._propertyData[name]) {
            volume._propertyData[name] = resources.texture('image-uint8', 'rgba', 'ubyte', 'linear');
            var texture_1 = volume._propertyData[name];
            texture_1.define(texDim, texDim);
            // load volume into sub-section of texture
            texture_1.load(Object(_util__WEBPACK_IMPORTED_MODULE_14__["createVolumeTexture2d"])(volume, 'groups', padding), true);
            volume.customProperties.add(VolumeIsosurfaceTexture.descriptor);
            volume.customProperties.assets(VolumeIsosurfaceTexture.descriptor, [{ dispose: function () { return texture_1.destroy(); } }]);
        }
        gridDimension[0] += padding;
        gridDimension[1] += padding;
        return {
            texture: volume._propertyData[name],
            transform: transform,
            gridDimension: gridDimension,
            gridTexDim: gridTexDim,
            gridTexScale: gridTexScale
        };
    }
    VolumeIsosurfaceTexture.get = get;
})(VolumeIsosurfaceTexture || (VolumeIsosurfaceTexture = {}));
function createVolumeIsosurfaceTextureMesh(ctx, volume, theme, props, textureMesh) {
    return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"])(this, void 0, void 0, function () {
        var _a, max, min, diff, value, isoLevel, _b, texture, gridDimension, gridTexDim, gridTexScale, transform, activeVoxelsTex, compacted, gv, surface;
        return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__generator"])(this, function (_c) {
            if (!ctx.webgl)
                throw new Error('webgl context required to create volume isosurface texture-mesh');
            _a = volume.grid.stats, max = _a.max, min = _a.min;
            diff = max - min;
            value = _mol_model_volume__WEBPACK_IMPORTED_MODULE_2__["Volume"].IsoValue.toAbsolute(props.isoValue, volume.grid.stats).absoluteValue;
            isoLevel = ((value - min) / diff);
            _b = VolumeIsosurfaceTexture.get(volume, ctx.webgl), texture = _b.texture, gridDimension = _b.gridDimension, gridTexDim = _b.gridTexDim, gridTexScale = _b.gridTexScale, transform = _b.transform;
            activeVoxelsTex = Object(_mol_gl_compute_marching_cubes_active_voxels__WEBPACK_IMPORTED_MODULE_16__["calcActiveVoxels"])(ctx.webgl, texture, gridDimension, gridTexDim, isoLevel, gridTexScale);
            compacted = Object(_mol_gl_compute_histogram_pyramid_reduction__WEBPACK_IMPORTED_MODULE_17__["createHistogramPyramid"])(ctx.webgl, activeVoxelsTex, gridTexScale, gridTexDim);
            gv = Object(_mol_gl_compute_marching_cubes_isosurface__WEBPACK_IMPORTED_MODULE_18__["createIsosurfaceBuffers"])(ctx.webgl, activeVoxelsTex, texture, compacted, gridDimension, gridTexDim, transform, isoLevel, textureMesh ? textureMesh.vertexGroupTexture.ref.value : undefined, textureMesh ? textureMesh.normalTexture.ref.value : undefined);
            surface = _mol_geo_geometry_texture_mesh_texture_mesh__WEBPACK_IMPORTED_MODULE_15__["TextureMesh"].create(gv.vertexCount, 1, gv.vertexGroupTexture, gv.normalTexture, _mol_model_volume__WEBPACK_IMPORTED_MODULE_2__["Volume"].getBoundingSphere(volume), textureMesh);
            // console.log({
            //     renderables: ctx.webgl.namedComputeRenderables,
            //     framebuffers: ctx.webgl.namedFramebuffers,
            //     textures: ctx.webgl.namedTextures,
            // });
            // ctx.webgl.waitForGpuCommandsCompleteSync();
            return [2 /*return*/, surface];
        });
    });
}
function IsosurfaceTextureMeshVisual(materialId) {
    return Object(_representation__WEBPACK_IMPORTED_MODULE_5__["VolumeVisual"])({
        defaultProps: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_1__["ParamDefinition"].getDefaultValues(IsosurfaceMeshParams),
        createGeometry: createVolumeIsosurfaceTextureMesh,
        createLocationIterator: function (volume) { return Object(_mol_geo_util_location_iterator__WEBPACK_IMPORTED_MODULE_6__["LocationIterator"])(volume.grid.cells.data.length, 1, 1, function () { return _mol_model_location__WEBPACK_IMPORTED_MODULE_7__["NullLocation"]; }); },
        getLoci: getIsosurfaceLoci,
        eachLocation: eachIsosurface,
        setUpdateState: function (state, volume, newProps, currentProps) {
            if (!_mol_model_volume__WEBPACK_IMPORTED_MODULE_2__["Volume"].IsoValue.areSame(newProps.isoValue, currentProps.isoValue, volume.grid.stats))
                state.createGeometry = true;
        },
        geometryUtils: _mol_geo_geometry_texture_mesh_texture_mesh__WEBPACK_IMPORTED_MODULE_15__["TextureMesh"].Utils,
        mustRecreate: function (props, webgl) {
            return !props.useGpu || !webgl;
        },
        dispose: function (geometry) {
            geometry.normalTexture.ref.value.destroy();
            geometry.vertexGroupTexture.ref.value.destroy();
        }
    }, materialId);
}
//
function createVolumeIsosurfaceWireframe(ctx, volume, theme, props, lines) {
    return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"])(this, void 0, void 0, function () {
        var ids, wireframe, transform;
        return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__generator"])(this, function (_a) {
            switch (_a.label) {
                case 0:
                    ctx.runtime.update({ message: 'Marching cubes...' });
                    ids = Object(_mol_util_array__WEBPACK_IMPORTED_MODULE_13__["fillSerial"])(new Int32Array(volume.grid.cells.data.length));
                    return [4 /*yield*/, Object(_mol_geo_util_marching_cubes_algorithm__WEBPACK_IMPORTED_MODULE_4__["computeMarchingCubesLines"])({
                            isoLevel: _mol_model_volume__WEBPACK_IMPORTED_MODULE_2__["Volume"].IsoValue.toAbsolute(props.isoValue, volume.grid.stats).absoluteValue,
                            scalarField: volume.grid.cells,
                            idField: _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_12__["Tensor"].create(volume.grid.cells.space, _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_12__["Tensor"].Data1(ids))
                        }, lines).runAsChild(ctx.runtime)];
                case 1:
                    wireframe = _a.sent();
                    transform = _mol_model_volume__WEBPACK_IMPORTED_MODULE_2__["Grid"].getGridToCartesianTransform(volume.grid);
                    _mol_geo_geometry_lines_lines__WEBPACK_IMPORTED_MODULE_8__["Lines"].transform(wireframe, transform);
                    wireframe.setBoundingSphere(_mol_model_volume__WEBPACK_IMPORTED_MODULE_2__["Volume"].getBoundingSphere(volume));
                    return [2 /*return*/, wireframe];
            }
        });
    });
}
var IsosurfaceWireframeParams = Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, _mol_geo_geometry_lines_lines__WEBPACK_IMPORTED_MODULE_8__["Lines"].Params), VolumeIsosurfaceParams), { quality: Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, _mol_geo_geometry_lines_lines__WEBPACK_IMPORTED_MODULE_8__["Lines"].Params.quality), { isEssential: false }), sizeFactor: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_1__["ParamDefinition"].Numeric(3, { min: 0, max: 10, step: 0.1 }) });
function IsosurfaceWireframeVisual(materialId) {
    return Object(_representation__WEBPACK_IMPORTED_MODULE_5__["VolumeVisual"])({
        defaultProps: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_1__["ParamDefinition"].getDefaultValues(IsosurfaceWireframeParams),
        createGeometry: createVolumeIsosurfaceWireframe,
        createLocationIterator: function (volume) { return Object(_mol_geo_util_location_iterator__WEBPACK_IMPORTED_MODULE_6__["LocationIterator"])(volume.grid.cells.data.length, 1, 1, function () { return _mol_model_location__WEBPACK_IMPORTED_MODULE_7__["NullLocation"]; }); },
        getLoci: getIsosurfaceLoci,
        eachLocation: eachIsosurface,
        setUpdateState: function (state, volume, newProps, currentProps) {
            if (!_mol_model_volume__WEBPACK_IMPORTED_MODULE_2__["Volume"].IsoValue.areSame(newProps.isoValue, currentProps.isoValue, volume.grid.stats))
                state.createGeometry = true;
        },
        geometryUtils: _mol_geo_geometry_lines_lines__WEBPACK_IMPORTED_MODULE_8__["Lines"].Utils
    }, materialId);
}
//
var IsosurfaceVisuals = {
    'solid': function (ctx, getParams) { return Object(_representation__WEBPACK_IMPORTED_MODULE_5__["VolumeRepresentation"])('Isosurface mesh', ctx, getParams, IsosurfaceVisual, getLoci); },
    'wireframe': function (ctx, getParams) { return Object(_representation__WEBPACK_IMPORTED_MODULE_5__["VolumeRepresentation"])('Isosurface wireframe', ctx, getParams, IsosurfaceWireframeVisual, getLoci); },
};
var IsosurfaceParams = Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, IsosurfaceMeshParams), IsosurfaceWireframeParams), { visuals: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_1__["ParamDefinition"].MultiSelect(['solid'], _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_1__["ParamDefinition"].objectToOptions(IsosurfaceVisuals)) });
function getIsosurfaceParams(ctx, volume) {
    var p = _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_1__["ParamDefinition"].clone(IsosurfaceParams);
    p.isoValue = _mol_model_volume__WEBPACK_IMPORTED_MODULE_2__["Volume"].createIsoValueParam(_mol_model_volume__WEBPACK_IMPORTED_MODULE_2__["Volume"].IsoValue.relative(2), volume.grid.stats);
    return p;
}
function IsosurfaceRepresentation(ctx, getParams) {
    return _representation__WEBPACK_IMPORTED_MODULE_9__["Representation"].createMulti('Isosurface', ctx, getParams, _representation__WEBPACK_IMPORTED_MODULE_9__["Representation"].StateBuilder, IsosurfaceVisuals);
}
var IsosurfaceRepresentationProvider = Object(_representation__WEBPACK_IMPORTED_MODULE_5__["VolumeRepresentationProvider"])({
    name: 'isosurface',
    label: 'Isosurface',
    description: 'Displays a triangulated isosurface of volumetric data.',
    factory: IsosurfaceRepresentation,
    getParams: getIsosurfaceParams,
    defaultValues: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_1__["ParamDefinition"].getDefaultValues(IsosurfaceParams),
    defaultColorTheme: { name: 'uniform' },
    defaultSizeTheme: { name: 'uniform' },
    isApplicable: function (volume) { return !_mol_model_volume__WEBPACK_IMPORTED_MODULE_2__["Volume"].isEmpty(volume); }
});
//# sourceMappingURL=isosurface.js.map

/***/ }),

/***/ "./lib/mol-repr/volume/registry.js":
/*!*****************************************!*\
  !*** ./lib/mol-repr/volume/registry.js ***!
  \*****************************************/
/*! exports provided: VolumeRepresentationRegistry */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "VolumeRepresentationRegistry", function() { return VolumeRepresentationRegistry; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _representation__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../representation */ "./lib/mol-repr/representation.js");
/* harmony import */ var _isosurface__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./isosurface */ "./lib/mol-repr/volume/isosurface.js");
/* harmony import */ var _mol_util_object__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../mol-util/object */ "./lib/mol-util/object.js");
/* harmony import */ var _slice__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./slice */ "./lib/mol-repr/volume/slice.js");
/* harmony import */ var _direct_volume__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./direct-volume */ "./lib/mol-repr/volume/direct-volume.js");
/**
 * Copyright (c) 2018-2020 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */






var VolumeRepresentationRegistry = /** @class */ (function (_super) {
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__extends"])(VolumeRepresentationRegistry, _super);
    function VolumeRepresentationRegistry() {
        var _this = _super.call(this) || this;
        Object(_mol_util_object__WEBPACK_IMPORTED_MODULE_3__["objectForEach"])(VolumeRepresentationRegistry.BuiltIn, function (p, k) {
            if (p.name !== k)
                throw new Error("Fix BuiltInVolumeRepresentations to have matching names. " + p.name + " " + k);
            _this.add(p);
        });
        return _this;
    }
    return VolumeRepresentationRegistry;
}(_representation__WEBPACK_IMPORTED_MODULE_1__["RepresentationRegistry"]));

(function (VolumeRepresentationRegistry) {
    VolumeRepresentationRegistry.BuiltIn = {
        'isosurface': _isosurface__WEBPACK_IMPORTED_MODULE_2__["IsosurfaceRepresentationProvider"],
        'slice': _slice__WEBPACK_IMPORTED_MODULE_4__["SliceRepresentationProvider"],
        'direct-volume': _direct_volume__WEBPACK_IMPORTED_MODULE_5__["DirectVolumeRepresentationProvider"],
    };
})(VolumeRepresentationRegistry || (VolumeRepresentationRegistry = {}));
//# sourceMappingURL=registry.js.map

/***/ }),

/***/ "./lib/mol-repr/volume/representation.js":
/*!***********************************************!*\
  !*** ./lib/mol-repr/volume/representation.js ***!
  \***********************************************/
/*! exports provided: VolumeVisual, VolumeRepresentationProvider, VolumeParams, VolumeRepresentation */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "VolumeVisual", function() { return VolumeVisual; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "VolumeRepresentationProvider", function() { return VolumeRepresentationProvider; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "VolumeParams", function() { return VolumeParams; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "VolumeRepresentation", function() { return VolumeRepresentation; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../mol-util/param-definition */ "./lib/mol-util/param-definition.js");
/* harmony import */ var _visual__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../visual */ "./lib/mol-repr/visual.js");
/* harmony import */ var _mol_model_volume__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../mol-model/volume */ "./lib/mol-model/volume.js");
/* harmony import */ var _mol_geo_geometry_geometry__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../mol-geo/geometry/geometry */ "./lib/mol-geo/geometry/geometry.js");
/* harmony import */ var _mol_theme_theme__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../mol-theme/theme */ "./lib/mol-theme/theme.js");
/* harmony import */ var _mol_geo_geometry_transform_data__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../../mol-geo/geometry/transform-data */ "./lib/mol-geo/geometry/transform-data.js");
/* harmony import */ var _mol_gl_render_object__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../../mol-gl/render-object */ "./lib/mol-gl/render-object.js");
/* harmony import */ var _mol_model_loci__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ../../mol-model/loci */ "./lib/mol-model/loci.js");
/* harmony import */ var _mol_data_int__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ../../mol-data/int */ "./lib/mol-data/int.js");
/* harmony import */ var _util__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ../util */ "./lib/mol-repr/util.js");
/* harmony import */ var _mol_theme_color__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ../../mol-theme/color */ "./lib/mol-theme/color.js");
/* harmony import */ var _mol_util__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! ../../mol-util */ "./lib/mol-util/index.js");
/* harmony import */ var _mol_geo_geometry_size_data__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! ../../mol-geo/geometry/size-data */ "./lib/mol-geo/geometry/size-data.js");
/* harmony import */ var _mol_geo_geometry_color_data__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! ../../mol-geo/geometry/color-data */ "./lib/mol-geo/geometry/color-data.js");
/* harmony import */ var _representation__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! ../representation */ "./lib/mol-repr/representation.js");
/* harmony import */ var _mol_geo_geometry_base__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(/*! ../../mol-geo/geometry/base */ "./lib/mol-geo/geometry/base.js");
/* harmony import */ var rxjs__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(/*! rxjs */ "./node_modules/rxjs/_esm5/index.js");
/* harmony import */ var _mol_task__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(/*! ../../mol-task */ "./lib/mol-task/index.js");
/**
 * Copyright (c) 2018-2020 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */



















function createVolumeRenderObject(volume, geometry, locationIt, theme, props, materialId) {
    var _a = _mol_geo_geometry_geometry__WEBPACK_IMPORTED_MODULE_4__["Geometry"].getUtils(geometry), createValues = _a.createValues, createRenderableState = _a.createRenderableState;
    var transform = Object(_mol_geo_geometry_transform_data__WEBPACK_IMPORTED_MODULE_6__["createIdentityTransform"])();
    var values = createValues(geometry, transform, locationIt, theme, props);
    var state = createRenderableState(props);
    return Object(_mol_gl_render_object__WEBPACK_IMPORTED_MODULE_7__["createRenderObject"])(geometry.kind, values, state, materialId);
}
function VolumeVisual(builder, materialId) {
    var defaultProps = builder.defaultProps, createGeometry = builder.createGeometry, createLocationIterator = builder.createLocationIterator, getLoci = builder.getLoci, eachLocation = builder.eachLocation, setUpdateState = builder.setUpdateState, mustRecreate = builder.mustRecreate, dispose = builder.dispose;
    var _a = builder.geometryUtils, updateValues = _a.updateValues, updateBoundingSphere = _a.updateBoundingSphere, updateRenderableState = _a.updateRenderableState, createPositionIterator = _a.createPositionIterator;
    var updateState = _util__WEBPACK_IMPORTED_MODULE_10__["VisualUpdateState"].create();
    var renderObject;
    var newProps;
    var newTheme;
    var newVolume;
    var currentProps = Object.assign({}, defaultProps);
    var currentTheme = _mol_theme_theme__WEBPACK_IMPORTED_MODULE_5__["Theme"].createEmpty();
    var currentVolume;
    var geometry;
    var locationIt;
    var positionIt;
    function prepareUpdate(theme, props, volume) {
        if (!volume && !currentVolume) {
            throw new Error('missing volume');
        }
        newProps = Object.assign({}, currentProps, props);
        newTheme = theme;
        newVolume = volume;
        _util__WEBPACK_IMPORTED_MODULE_10__["VisualUpdateState"].reset(updateState);
        if (!renderObject) {
            updateState.createNew = true;
        }
        else if (!currentVolume || !_mol_model_volume__WEBPACK_IMPORTED_MODULE_3__["Volume"].areEquivalent(newVolume, currentVolume)) {
            updateState.createNew = true;
        }
        if (updateState.createNew) {
            updateState.createGeometry = true;
            return;
        }
        setUpdateState(updateState, volume, newProps, currentProps, newTheme, currentTheme);
        if (!_mol_theme_color__WEBPACK_IMPORTED_MODULE_11__["ColorTheme"].areEqual(theme.color, currentTheme.color))
            updateState.updateColor = true;
        if (updateState.createGeometry) {
            updateState.updateColor = true;
        }
    }
    function update(newGeometry) {
        if (updateState.createNew) {
            locationIt = createLocationIterator(newVolume);
            if (newGeometry) {
                renderObject = createVolumeRenderObject(newVolume, newGeometry, locationIt, newTheme, newProps, materialId);
                positionIt = createPositionIterator(newGeometry, renderObject.values);
            }
            else {
                throw new Error('expected geometry to be given');
            }
        }
        else {
            if (!renderObject) {
                throw new Error('expected renderObject to be available');
            }
            locationIt.reset();
            if (updateState.createGeometry) {
                if (newGeometry) {
                    _mol_util__WEBPACK_IMPORTED_MODULE_12__["ValueCell"].updateIfChanged(renderObject.values.drawCount, _mol_geo_geometry_geometry__WEBPACK_IMPORTED_MODULE_4__["Geometry"].getDrawCount(newGeometry));
                    _mol_util__WEBPACK_IMPORTED_MODULE_12__["ValueCell"].updateIfChanged(renderObject.values.uVertexCount, _mol_geo_geometry_geometry__WEBPACK_IMPORTED_MODULE_4__["Geometry"].getVertexCount(newGeometry));
                }
                else {
                    throw new Error('expected geometry to be given');
                }
            }
            if (updateState.updateTransform || updateState.createGeometry) {
                updateBoundingSphere(renderObject.values, newGeometry || geometry);
                positionIt = createPositionIterator(newGeometry || geometry, renderObject.values);
            }
            if (updateState.updateSize) {
                // not all geometries have size data, so check here
                if ('uSize' in renderObject.values) {
                    Object(_mol_geo_geometry_size_data__WEBPACK_IMPORTED_MODULE_13__["createSizes"])(locationIt, newTheme.size, renderObject.values);
                }
            }
            if (updateState.updateColor) {
                Object(_mol_geo_geometry_color_data__WEBPACK_IMPORTED_MODULE_14__["createColors"])(locationIt, positionIt, newTheme.color, renderObject.values);
            }
            updateValues(renderObject.values, newProps);
            updateRenderableState(renderObject.state, newProps);
        }
        currentProps = newProps;
        currentTheme = newTheme;
        currentVolume = newVolume;
        if (newGeometry)
            geometry = newGeometry;
    }
    function lociApply(loci, apply) {
        if (Object(_mol_model_loci__WEBPACK_IMPORTED_MODULE_8__["isEveryLoci"])(loci)) {
            return apply(_mol_data_int__WEBPACK_IMPORTED_MODULE_9__["Interval"].ofBounds(0, locationIt.groupCount * locationIt.instanceCount));
        }
        else {
            return eachLocation(loci, currentVolume, currentProps, apply);
        }
    }
    return {
        get groupCount() { return locationIt ? locationIt.count : 0; },
        get renderObject() { return renderObject; },
        createOrUpdate: function (ctx, theme, props, volume) {
            if (props === void 0) { props = {}; }
            return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"])(this, void 0, void 0, function () {
                var newGeometry;
                return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__generator"])(this, function (_a) {
                    prepareUpdate(theme, props, volume || currentVolume);
                    if (updateState.createGeometry) {
                        newGeometry = createGeometry(ctx, newVolume, newTheme, newProps, geometry);
                        return [2 /*return*/, newGeometry instanceof Promise ? newGeometry.then(update) : update(newGeometry)];
                    }
                    else {
                        update();
                    }
                    return [2 /*return*/];
                });
            });
        },
        getLoci: function (pickingId) {
            return renderObject ? getLoci(pickingId, currentVolume, currentProps, renderObject.id) : _mol_model_loci__WEBPACK_IMPORTED_MODULE_8__["EmptyLoci"];
        },
        mark: function (loci, action) {
            return _visual__WEBPACK_IMPORTED_MODULE_2__["Visual"].mark(renderObject, loci, action, lociApply);
        },
        setVisibility: function (visible) {
            _visual__WEBPACK_IMPORTED_MODULE_2__["Visual"].setVisibility(renderObject, visible);
        },
        setAlphaFactor: function (alphaFactor) {
            _visual__WEBPACK_IMPORTED_MODULE_2__["Visual"].setAlphaFactor(renderObject, alphaFactor);
        },
        setPickable: function (pickable) {
            _visual__WEBPACK_IMPORTED_MODULE_2__["Visual"].setPickable(renderObject, pickable);
        },
        setColorOnly: function (colorOnly) {
            _visual__WEBPACK_IMPORTED_MODULE_2__["Visual"].setColorOnly(renderObject, colorOnly);
        },
        setTransform: function (matrix, instanceMatrices) {
            _visual__WEBPACK_IMPORTED_MODULE_2__["Visual"].setTransform(renderObject, matrix, instanceMatrices);
        },
        setOverpaint: function (overpaint) {
            return _visual__WEBPACK_IMPORTED_MODULE_2__["Visual"].setOverpaint(renderObject, overpaint, lociApply, true);
        },
        setTransparency: function (transparency) {
            return _visual__WEBPACK_IMPORTED_MODULE_2__["Visual"].setTransparency(renderObject, transparency, lociApply, true);
        },
        setClipping: function (clipping) {
            return _visual__WEBPACK_IMPORTED_MODULE_2__["Visual"].setClipping(renderObject, clipping, lociApply, true);
        },
        destroy: function () {
            dispose === null || dispose === void 0 ? void 0 : dispose(geometry);
            if (renderObject) {
                renderObject.state.disposed = true;
                renderObject = undefined;
            }
        },
        mustRecreate: mustRecreate
    };
}
function VolumeRepresentationProvider(p) { return p; }
//
var VolumeParams = Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, _mol_geo_geometry_base__WEBPACK_IMPORTED_MODULE_16__["BaseGeometry"].Params);
function VolumeRepresentation(label, ctx, getParams, visualCtor, getLoci) {
    var version = 0;
    var webgl = ctx.webgl;
    var updated = new rxjs__WEBPACK_IMPORTED_MODULE_17__["Subject"]();
    var materialId = Object(_mol_gl_render_object__WEBPACK_IMPORTED_MODULE_7__["getNextMaterialId"])();
    var renderObjects = [];
    var _state = _representation__WEBPACK_IMPORTED_MODULE_15__["Representation"].createState();
    var visual;
    var _volume;
    var _params;
    var _props;
    var _theme = _mol_theme_theme__WEBPACK_IMPORTED_MODULE_5__["Theme"].createEmpty();
    function createOrUpdate(props, volume) {
        var _this = this;
        if (props === void 0) { props = {}; }
        if (volume && volume !== _volume) {
            _params = getParams(ctx, volume);
            _volume = volume;
            if (!_props)
                _props = _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_1__["ParamDefinition"].getDefaultValues(_params);
        }
        var qualityProps = Object(_util__WEBPACK_IMPORTED_MODULE_10__["getQualityProps"])(Object.assign({}, _props, props), _volume);
        Object.assign(_props, props, qualityProps);
        return _mol_task__WEBPACK_IMPORTED_MODULE_18__["Task"].create('Creating or updating VolumeRepresentation', function (runtime) { return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"])(_this, void 0, void 0, function () {
            var promise;
            var _a;
            return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__generator"])(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (!visual) {
                            visual = visualCtor(materialId, _props, webgl);
                        }
                        else if ((_a = visual.mustRecreate) === null || _a === void 0 ? void 0 : _a.call(visual, _props, webgl)) {
                            visual.destroy();
                            visual = visualCtor(materialId, _props, webgl);
                        }
                        promise = visual.createOrUpdate({ webgl: webgl, runtime: runtime }, _theme, _props, volume);
                        if (!promise) return [3 /*break*/, 2];
                        return [4 /*yield*/, promise];
                    case 1:
                        _b.sent();
                        _b.label = 2;
                    case 2:
                        // update list of renderObjects
                        renderObjects.length = 0;
                        if (visual && visual.renderObject)
                            renderObjects.push(visual.renderObject);
                        // increment version
                        updated.next(version++);
                        return [2 /*return*/];
                }
            });
        }); });
    }
    function mark(loci, action) {
        return visual ? visual.mark(loci, action) : false;
    }
    function setState(state) {
        if (state.visible !== undefined && visual)
            visual.setVisibility(state.visible);
        if (state.alphaFactor !== undefined && visual)
            visual.setAlphaFactor(state.alphaFactor);
        if (state.pickable !== undefined && visual)
            visual.setPickable(state.pickable);
        if (state.overpaint !== undefined && visual)
            visual.setOverpaint(state.overpaint);
        if (state.transparency !== undefined && visual)
            visual.setTransparency(state.transparency);
        if (state.transform !== undefined && visual)
            visual.setTransform(state.transform);
        _representation__WEBPACK_IMPORTED_MODULE_15__["Representation"].updateState(_state, state);
    }
    function setTheme(theme) {
        _theme = theme;
    }
    function destroy() {
        if (visual)
            visual.destroy();
    }
    return {
        label: label,
        get groupCount() {
            return visual ? visual.groupCount : 0;
        },
        get props() { return _props; },
        get params() { return _params; },
        get state() { return _state; },
        get theme() { return _theme; },
        renderObjects: renderObjects,
        updated: updated,
        createOrUpdate: createOrUpdate,
        setState: setState,
        setTheme: setTheme,
        getLoci: function (pickingId) {
            if (pickingId === undefined)
                return getLoci(_volume, _props);
            return visual ? visual.getLoci(pickingId) : _mol_model_loci__WEBPACK_IMPORTED_MODULE_8__["EmptyLoci"];
        },
        mark: mark,
        destroy: destroy
    };
}
//# sourceMappingURL=representation.js.map

/***/ }),

/***/ "./lib/mol-repr/volume/slice.js":
/*!**************************************!*\
  !*** ./lib/mol-repr/volume/slice.js ***!
  \**************************************/
/*! exports provided: createImage, SliceParams, getSliceParams, SliceVisual, SliceRepresentation, SliceRepresentationProvider */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createImage", function() { return createImage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SliceParams", function() { return SliceParams; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getSliceParams", function() { return getSliceParams; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SliceVisual", function() { return SliceVisual; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SliceRepresentation", function() { return SliceRepresentation; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SliceRepresentationProvider", function() { return SliceRepresentationProvider; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../mol-util/param-definition */ "./lib/mol-util/param-definition.js");
/* harmony import */ var _mol_geo_geometry_image_image__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../mol-geo/geometry/image/image */ "./lib/mol-geo/geometry/image/image.js");
/* harmony import */ var _mol_model_volume__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../mol-model/volume */ "./lib/mol-model/volume.js");
/* harmony import */ var _representation__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./representation */ "./lib/mol-repr/volume/representation.js");
/* harmony import */ var _mol_geo_util_location_iterator__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../mol-geo/util/location-iterator */ "./lib/mol-geo/util/location-iterator.js");
/* harmony import */ var _mol_model_location__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../../mol-model/location */ "./lib/mol-model/location.js");
/* harmony import */ var _mol_model_loci__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../../mol-model/loci */ "./lib/mol-model/loci.js");
/* harmony import */ var _mol_data_int__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ../../mol-data/int */ "./lib/mol-data/int.js");
/* harmony import */ var _mol_geo_util__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ../../mol-geo/util */ "./lib/mol-geo/util.js");
/* harmony import */ var _mol_util_color__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ../../mol-util/color */ "./lib/mol-util/color/index.js");
/* harmony import */ var _mol_theme_color__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ../../mol-theme/color */ "./lib/mol-theme/color.js");
/* harmony import */ var _mol_util_float_packing__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! ../../mol-util/float-packing */ "./lib/mol-util/float-packing.js");
/* harmony import */ var _util__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! ./util */ "./lib/mol-repr/volume/util.js");
/**
 * Copyright (c) 2020 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */














function createImage(ctx, volume, theme, props, image) {
    return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"])(this, void 0, void 0, function () {
        var dim, isoValue, _a, space, data, _b, min, max, isoVal, color, _c, r, g, b, _d, width, height, x, y, z, x0, y0, z0, nx, ny, nz, corners, imageArray, groupArray, i, iy, ix, iz, val, normVal, imageTexture, groupTexture, transform;
        return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__generator"])(this, function (_e) {
            dim = props.dimension.name, isoValue = props.isoValue;
            _a = volume.grid.cells, space = _a.space, data = _a.data;
            _b = volume.grid.stats, min = _b.min, max = _b.max;
            isoVal = _mol_model_volume__WEBPACK_IMPORTED_MODULE_3__["Volume"].IsoValue.toAbsolute(isoValue, volume.grid.stats).absoluteValue;
            color = theme.color.color(_mol_model_location__WEBPACK_IMPORTED_MODULE_6__["NullLocation"], false);
            _c = _mol_util_color__WEBPACK_IMPORTED_MODULE_10__["Color"].toRgbNormalized(color), r = _c[0], g = _c[1], b = _c[2];
            _d = getSliceInfo(volume.grid, props), width = _d.width, height = _d.height, x = _d.x, y = _d.y, z = _d.z, x0 = _d.x0, y0 = _d.y0, z0 = _d.z0, nx = _d.nx, ny = _d.ny, nz = _d.nz;
            corners = new Float32Array(dim === 'x' ? [x, 0, 0, x, y, 0, x, 0, z, x, y, z] :
                dim === 'y' ? [0, y, 0, x, y, 0, 0, y, z, x, y, z] :
                    [0, 0, z, 0, y, z, x, 0, z, x, y, z]);
            imageArray = new Uint8Array(width * height * 4);
            groupArray = getPackedGroupArray(volume.grid, props);
            i = 0;
            for (iy = y0; iy < ny; ++iy) {
                for (ix = x0; ix < nx; ++ix) {
                    for (iz = z0; iz < nz; ++iz) {
                        val = space.get(data, ix, iy, iz);
                        normVal = (val - min) / (max - min);
                        imageArray[i] = r * normVal * 2 * 255;
                        imageArray[i + 1] = g * normVal * 2 * 255;
                        imageArray[i + 2] = b * normVal * 2 * 255;
                        imageArray[i + 3] = val >= isoVal ? 255 : 0;
                        i += 4;
                    }
                }
            }
            imageTexture = { width: width, height: height, array: imageArray, flipY: true };
            groupTexture = { width: width, height: height, array: groupArray, flipY: true };
            transform = _mol_model_volume__WEBPACK_IMPORTED_MODULE_3__["Grid"].getGridToCartesianTransform(volume.grid);
            Object(_mol_geo_util__WEBPACK_IMPORTED_MODULE_9__["transformPositionArray"])(transform, corners, 0, 4);
            return [2 /*return*/, _mol_geo_geometry_image_image__WEBPACK_IMPORTED_MODULE_2__["Image"].create(imageTexture, corners, groupTexture, image)];
        });
    });
}
function getSliceInfo(grid, props) {
    var _a = props.dimension, dim = _a.name, index = _a.params;
    var space = grid.cells.space;
    var width, height;
    var x, y, z;
    var x0 = 0, y0 = 0, z0 = 0;
    var _b = space.dimensions, nx = _b[0], ny = _b[1], nz = _b[2];
    if (dim === 'x') {
        x = index, y = ny - 1, z = nz - 1;
        width = nz, height = ny;
        x0 = x, nx = x0 + 1;
    }
    else if (dim === 'y') {
        x = nx - 1, y = index, z = nz - 1;
        width = nz, height = nx;
        y0 = y, ny = y0 + 1;
    }
    else {
        x = nx - 1, y = ny - 1, z = index;
        width = nx, height = ny;
        z0 = z, nz = z0 + 1;
    }
    return {
        width: width, height: height,
        x: x, y: y, z: z,
        x0: x0, y0: y0, z0: z0,
        nx: nx, ny: ny, nz: nz
    };
}
function getPackedGroupArray(grid, props) {
    var space = grid.cells.space;
    var _a = getSliceInfo(grid, props), width = _a.width, height = _a.height, x0 = _a.x0, y0 = _a.y0, z0 = _a.z0, nx = _a.nx, ny = _a.ny, nz = _a.nz;
    var groupArray = new Uint8Array(width * height * 4);
    var j = 0;
    for (var iy = y0; iy < ny; ++iy) {
        for (var ix = x0; ix < nx; ++ix) {
            for (var iz = z0; iz < nz; ++iz) {
                Object(_mol_util_float_packing__WEBPACK_IMPORTED_MODULE_12__["encodeFloatRGBtoArray"])(space.dataOffset(ix, iy, iz), groupArray, j);
                j += 4;
            }
        }
    }
    return groupArray;
}
function getGroupArray(grid, props) {
    var space = grid.cells.space;
    var _a = getSliceInfo(grid, props), width = _a.width, height = _a.height, x0 = _a.x0, y0 = _a.y0, z0 = _a.z0, nx = _a.nx, ny = _a.ny, nz = _a.nz;
    var groupArray = new Uint32Array(width * height);
    var j = 0;
    for (var iy = y0; iy < ny; ++iy) {
        for (var ix = x0; ix < nx; ++ix) {
            for (var iz = z0; iz < nz; ++iz) {
                groupArray[j] = space.dataOffset(ix, iy, iz);
                j += 1;
            }
        }
    }
    return groupArray;
}
function getLoci(volume, props) {
    // TODO cache somehow?
    var groupArray = getGroupArray(volume.grid, props);
    return _mol_model_volume__WEBPACK_IMPORTED_MODULE_3__["Volume"].Cell.Loci(volume, _mol_data_int__WEBPACK_IMPORTED_MODULE_8__["SortedArray"].ofUnsortedArray(groupArray));
}
function getSliceLoci(pickingId, volume, props, id) {
    var objectId = pickingId.objectId, groupId = pickingId.groupId;
    if (id === objectId) {
        return _mol_model_volume__WEBPACK_IMPORTED_MODULE_3__["Volume"].Cell.Loci(volume, _mol_data_int__WEBPACK_IMPORTED_MODULE_8__["Interval"].ofSingleton(groupId));
    }
    return _mol_model_loci__WEBPACK_IMPORTED_MODULE_7__["EmptyLoci"];
}
function eachSlice(loci, volume, props, apply) {
    return Object(_util__WEBPACK_IMPORTED_MODULE_13__["eachVolumeLoci"])(loci, volume, undefined, apply);
}
//
var SliceParams = Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, _mol_geo_geometry_image_image__WEBPACK_IMPORTED_MODULE_2__["Image"].Params), { quality: Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, _mol_geo_geometry_image_image__WEBPACK_IMPORTED_MODULE_2__["Image"].Params.quality), { isEssential: false }), dimension: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_1__["ParamDefinition"].MappedStatic('x', {
        x: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_1__["ParamDefinition"].Numeric(0, { min: 0, max: 0, step: 1 }),
        y: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_1__["ParamDefinition"].Numeric(0, { min: 0, max: 0, step: 1 }),
        z: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_1__["ParamDefinition"].Numeric(0, { min: 0, max: 0, step: 1 }),
    }, { isEssential: true }), isoValue: _mol_model_volume__WEBPACK_IMPORTED_MODULE_3__["Volume"].IsoValueParam });
function getSliceParams(ctx, volume) {
    var p = _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_1__["ParamDefinition"].clone(SliceParams);
    var dim = volume.grid.cells.space.dimensions;
    p.dimension = _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_1__["ParamDefinition"].MappedStatic('x', {
        x: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_1__["ParamDefinition"].Numeric(0, { min: 0, max: dim[0] - 1, step: 1 }),
        y: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_1__["ParamDefinition"].Numeric(0, { min: 0, max: dim[1] - 1, step: 1 }),
        z: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_1__["ParamDefinition"].Numeric(0, { min: 0, max: dim[2] - 1, step: 1 }),
    }, { isEssential: true });
    p.isoValue = _mol_model_volume__WEBPACK_IMPORTED_MODULE_3__["Volume"].createIsoValueParam(_mol_model_volume__WEBPACK_IMPORTED_MODULE_3__["Volume"].IsoValue.absolute(volume.grid.stats.min), volume.grid.stats);
    return p;
}
function SliceVisual(materialId) {
    return Object(_representation__WEBPACK_IMPORTED_MODULE_4__["VolumeVisual"])({
        defaultProps: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_1__["ParamDefinition"].getDefaultValues(SliceParams),
        createGeometry: createImage,
        createLocationIterator: function (volume) { return Object(_mol_geo_util_location_iterator__WEBPACK_IMPORTED_MODULE_5__["LocationIterator"])(volume.grid.cells.data.length, 1, 1, function () { return _mol_model_location__WEBPACK_IMPORTED_MODULE_6__["NullLocation"]; }); },
        getLoci: getSliceLoci,
        eachLocation: eachSlice,
        setUpdateState: function (state, volume, newProps, currentProps, newTheme, currentTheme) {
            state.createGeometry = (newProps.dimension.name !== currentProps.dimension.name ||
                newProps.dimension.params !== currentProps.dimension.params ||
                !_mol_model_volume__WEBPACK_IMPORTED_MODULE_3__["Volume"].IsoValue.areSame(newProps.isoValue, currentProps.isoValue, volume.grid.stats) ||
                !_mol_theme_color__WEBPACK_IMPORTED_MODULE_11__["ColorTheme"].areEqual(newTheme.color, currentTheme.color));
        },
        geometryUtils: Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, _mol_geo_geometry_image_image__WEBPACK_IMPORTED_MODULE_2__["Image"].Utils), { createRenderableState: function (props) {
                var state = _mol_geo_geometry_image_image__WEBPACK_IMPORTED_MODULE_2__["Image"].Utils.createRenderableState(props);
                updateRenderableState(state, props);
                return state;
            }, updateRenderableState: updateRenderableState })
    }, materialId);
}
function updateRenderableState(state, props) {
    _mol_geo_geometry_image_image__WEBPACK_IMPORTED_MODULE_2__["Image"].Utils.updateRenderableState(state, props);
    state.opaque = false;
    state.writeDepth = true;
}
function SliceRepresentation(ctx, getParams) {
    return Object(_representation__WEBPACK_IMPORTED_MODULE_4__["VolumeRepresentation"])('Slice', ctx, getParams, SliceVisual, getLoci);
}
var SliceRepresentationProvider = Object(_representation__WEBPACK_IMPORTED_MODULE_4__["VolumeRepresentationProvider"])({
    name: 'slice',
    label: 'Slice',
    description: 'Slice of volume rendered as image with interpolation.',
    factory: SliceRepresentation,
    getParams: getSliceParams,
    defaultValues: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_1__["ParamDefinition"].getDefaultValues(SliceParams),
    defaultColorTheme: { name: 'uniform' },
    defaultSizeTheme: { name: 'uniform' },
    isApplicable: function (volume) { return !_mol_model_volume__WEBPACK_IMPORTED_MODULE_3__["Volume"].isEmpty(volume); }
});
//# sourceMappingURL=slice.js.map

/***/ }),

/***/ "./lib/mol-repr/volume/util.js":
/*!*************************************!*\
  !*** ./lib/mol-repr/volume/util.js ***!
  \*************************************/
/*! exports provided: eachVolumeLoci, getVolumeTexture2dLayout, createVolumeTexture2d, createVolumeTexture3d */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "eachVolumeLoci", function() { return eachVolumeLoci; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getVolumeTexture2dLayout", function() { return getVolumeTexture2dLayout; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createVolumeTexture2d", function() { return createVolumeTexture2d; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createVolumeTexture3d", function() { return createVolumeTexture3d; });
/* harmony import */ var _mol_model_volume__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../mol-model/volume */ "./lib/mol-model/volume.js");
/* harmony import */ var _mol_data_int__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../mol-data/int */ "./lib/mol-data/int.js");
/* harmony import */ var _mol_math_linear_algebra_3d_common__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../mol-math/linear-algebra/3d/common */ "./lib/mol-math/linear-algebra/3d/common.js");
/* harmony import */ var _mol_math_linear_algebra_3d_vec3__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../mol-math/linear-algebra/3d/vec3 */ "./lib/mol-math/linear-algebra/3d/vec3.js");
/* harmony import */ var _mol_util_float_packing__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../mol-util/float-packing */ "./lib/mol-util/float-packing.js");
/**
 * Copyright (c) 2020 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */





// avoiding namespace lookup improved performance in Chrome (Aug 2020)
var v3set = _mol_math_linear_algebra_3d_vec3__WEBPACK_IMPORTED_MODULE_3__["default"].set;
var v3normalize = _mol_math_linear_algebra_3d_vec3__WEBPACK_IMPORTED_MODULE_3__["default"].normalize;
var v3sub = _mol_math_linear_algebra_3d_vec3__WEBPACK_IMPORTED_MODULE_3__["default"].sub;
var v3addScalar = _mol_math_linear_algebra_3d_vec3__WEBPACK_IMPORTED_MODULE_3__["default"].addScalar;
var v3scale = _mol_math_linear_algebra_3d_vec3__WEBPACK_IMPORTED_MODULE_3__["default"].scale;
var v3toArray = _mol_math_linear_algebra_3d_vec3__WEBPACK_IMPORTED_MODULE_3__["default"].toArray;
function eachVolumeLoci(loci, volume, isoValue, apply) {
    var changed = false;
    if (_mol_model_volume__WEBPACK_IMPORTED_MODULE_0__["Volume"].isLoci(loci)) {
        if (!_mol_model_volume__WEBPACK_IMPORTED_MODULE_0__["Volume"].areEquivalent(loci.volume, volume))
            return false;
        if (apply(_mol_data_int__WEBPACK_IMPORTED_MODULE_1__["Interval"].ofLength(volume.grid.cells.data.length)))
            changed = true;
    }
    else if (_mol_model_volume__WEBPACK_IMPORTED_MODULE_0__["Volume"].Isosurface.isLoci(loci)) {
        if (!_mol_model_volume__WEBPACK_IMPORTED_MODULE_0__["Volume"].areEquivalent(loci.volume, volume))
            return false;
        if (isoValue) {
            if (!_mol_model_volume__WEBPACK_IMPORTED_MODULE_0__["Volume"].IsoValue.areSame(loci.isoValue, isoValue, volume.grid.stats))
                return false;
            if (apply(_mol_data_int__WEBPACK_IMPORTED_MODULE_1__["Interval"].ofLength(volume.grid.cells.data.length)))
                changed = true;
        }
        else {
            // TODO find a cheaper way?
            var _a = volume.grid, stats = _a.stats, data = _a.cells.data;
            var eps = stats.sigma;
            var v = _mol_model_volume__WEBPACK_IMPORTED_MODULE_0__["Volume"].IsoValue.toAbsolute(loci.isoValue, stats).absoluteValue;
            for (var i = 0, il = data.length; i < il; ++i) {
                if (Object(_mol_math_linear_algebra_3d_common__WEBPACK_IMPORTED_MODULE_2__["equalEps"])(v, data[i], eps)) {
                    if (apply(_mol_data_int__WEBPACK_IMPORTED_MODULE_1__["Interval"].ofSingleton(i)))
                        changed = true;
                }
            }
        }
    }
    else if (_mol_model_volume__WEBPACK_IMPORTED_MODULE_0__["Volume"].Cell.isLoci(loci)) {
        if (!_mol_model_volume__WEBPACK_IMPORTED_MODULE_0__["Volume"].areEquivalent(loci.volume, volume))
            return false;
        if (_mol_data_int__WEBPACK_IMPORTED_MODULE_1__["Interval"].is(loci.indices)) {
            if (apply(loci.indices))
                changed = true;
        }
        else {
            _mol_data_int__WEBPACK_IMPORTED_MODULE_1__["OrderedSet"].forEach(loci.indices, function (v) {
                if (apply(_mol_data_int__WEBPACK_IMPORTED_MODULE_1__["Interval"].ofSingleton(v)))
                    changed = true;
            });
        }
    }
    return changed;
}
//
function getVolumeTexture2dLayout(dim, padding) {
    if (padding === void 0) { padding = 0; }
    var area = dim[0] * dim[1] * dim[2];
    var squareDim = Math.sqrt(area);
    var powerOfTwoSize = Math.pow(2, Math.ceil(Math.log(squareDim) / Math.log(2)));
    var width = dim[0] + padding;
    var height = dim[1] + padding;
    var rows = 1;
    var columns = width;
    if (powerOfTwoSize < width * dim[2]) {
        columns = Math.floor(powerOfTwoSize / width);
        rows = Math.ceil(dim[2] / columns);
        width *= columns;
        height *= rows;
    }
    else {
        width *= dim[2];
    }
    return { width: width, height: height, columns: columns, rows: rows, powerOfTwoSize: height < powerOfTwoSize ? powerOfTwoSize : powerOfTwoSize * 2 };
}
function createVolumeTexture2d(volume, variant, padding) {
    if (padding === void 0) { padding = 0; }
    var _a = volume.grid, _b = _a.cells, space = _b.space, data = _b.data, _c = _a.stats, max = _c.max, min = _c.min;
    var dim = space.dimensions;
    var o = space.dataOffset;
    var _d = getVolumeTexture2dLayout(dim, padding), width = _d.width, height = _d.height;
    var array = new Uint8Array(width * height * 4);
    var textureImage = { array: array, width: width, height: height };
    var diff = max - min;
    var xn = dim[0], yn = dim[1], zn = dim[2];
    var xnp = xn + padding;
    var ynp = yn + padding;
    var n0 = Object(_mol_math_linear_algebra_3d_vec3__WEBPACK_IMPORTED_MODULE_3__["default"])();
    var n1 = Object(_mol_math_linear_algebra_3d_vec3__WEBPACK_IMPORTED_MODULE_3__["default"])();
    var xn1 = xn - 1;
    var yn1 = yn - 1;
    var zn1 = zn - 1;
    for (var z = 0; z < zn; ++z) {
        for (var y = 0; y < yn; ++y) {
            for (var x = 0; x < xn; ++x) {
                var column = Math.floor(((z * xnp) % width) / xnp);
                var row = Math.floor((z * xnp) / width);
                var px = column * xnp + x;
                var index = 4 * ((row * ynp * width) + (y * width) + px);
                var offset = o(x, y, z);
                if (variant === 'groups') {
                    Object(_mol_util_float_packing__WEBPACK_IMPORTED_MODULE_4__["encodeFloatRGBtoArray"])(offset, array, index);
                }
                else {
                    v3set(n0, data[o(Math.max(0, x - 1), y, z)], data[o(x, Math.max(0, y - 1), z)], data[o(x, y, Math.max(0, z - 1))]);
                    v3set(n1, data[o(Math.min(xn1, x + 1), y, z)], data[o(x, Math.min(yn1, y + 1), z)], data[o(x, y, Math.min(zn1, z + 1))]);
                    v3normalize(n0, v3sub(n0, n0, n1));
                    v3addScalar(n0, v3scale(n0, n0, 0.5), 0.5);
                    v3toArray(v3scale(n0, n0, 255), array, index);
                }
                array[index + 3] = ((data[offset] - min) / diff) * 255;
            }
        }
    }
    return textureImage;
}
function createVolumeTexture3d(volume) {
    var _a = volume.grid, _b = _a.cells, space = _b.space, data = _b.data, _c = _a.stats, max = _c.max, min = _c.min;
    var _d = space.dimensions, width = _d[0], height = _d[1], depth = _d[2];
    var o = space.dataOffset;
    var array = new Uint8Array(width * height * depth * 4);
    var textureVolume = { array: array, width: width, height: height, depth: depth };
    var diff = max - min;
    var n0 = Object(_mol_math_linear_algebra_3d_vec3__WEBPACK_IMPORTED_MODULE_3__["default"])();
    var n1 = Object(_mol_math_linear_algebra_3d_vec3__WEBPACK_IMPORTED_MODULE_3__["default"])();
    var width1 = width - 1;
    var height1 = height - 1;
    var depth1 = depth - 1;
    var i = 0;
    for (var z = 0; z < depth; ++z) {
        for (var y = 0; y < height; ++y) {
            for (var x = 0; x < width; ++x) {
                var offset = o(x, y, z);
                v3set(n0, data[o(Math.max(0, x - 1), y, z)], data[o(x, Math.max(0, y - 1), z)], data[o(x, y, Math.max(0, z - 1))]);
                v3set(n1, data[o(Math.min(width1, x + 1), y, z)], data[o(x, Math.min(height1, y + 1), z)], data[o(x, y, Math.min(depth1, z + 1))]);
                v3normalize(n0, v3sub(n0, n0, n1));
                v3addScalar(n0, v3scale(n0, n0, 0.5), 0.5);
                v3toArray(v3scale(n0, n0, 255), array, i);
                array[i + 3] = ((data[offset] - min) / diff) * 255;
                i += 4;
            }
        }
    }
    return textureVolume;
}
//# sourceMappingURL=util.js.map

/***/ }),

/***/ "./lib/mol-script/language/builder.js":
/*!********************************************!*\
  !*** ./lib/mol-script/language/builder.js ***!
  \********************************************/
/*! exports provided: MolScriptBuilder */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MolScriptBuilder", function() { return MolScriptBuilder; });
/* harmony import */ var _symbol_table__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./symbol-table */ "./lib/mol-script/language/symbol-table.js");
/**
 * Copyright (c) 2018 Mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author David Sehnal <david.sehnal@gmail.com>
 */

var MolScriptBuilder;
(function (MolScriptBuilder) {
    MolScriptBuilder.core = _symbol_table__WEBPACK_IMPORTED_MODULE_0__["MolScriptSymbolTable"].core;
    MolScriptBuilder.struct = _symbol_table__WEBPACK_IMPORTED_MODULE_0__["MolScriptSymbolTable"].structureQuery;
    MolScriptBuilder.internal = _symbol_table__WEBPACK_IMPORTED_MODULE_0__["MolScriptSymbolTable"].internal;
    /** Atom-name constructor */
    function atomName(s) { return MolScriptBuilder.struct.type.atomName([s]); }
    MolScriptBuilder.atomName = atomName;
    /** Element-symbol constructor */
    function es(s) { return MolScriptBuilder.struct.type.elementSymbol([s]); }
    MolScriptBuilder.es = es;
    /** List constructor */
    function list() {
        var xs = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            xs[_i] = arguments[_i];
        }
        return MolScriptBuilder.core.type.list(xs);
    }
    MolScriptBuilder.list = list;
    /** Set constructor */
    function set() {
        var xs = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            xs[_i] = arguments[_i];
        }
        return MolScriptBuilder.core.type.set(xs);
    }
    MolScriptBuilder.set = set;
    /** RegEx constructor */
    function re(pattern, flags) { return MolScriptBuilder.core.type.regex([pattern, flags]); }
    MolScriptBuilder.re = re;
    /** Function constructor */
    function fn(x) { return MolScriptBuilder.core.ctrl.fn([x]); }
    MolScriptBuilder.fn = fn;
    function evaluate(x) { return MolScriptBuilder.core.ctrl.eval([x]); }
    MolScriptBuilder.evaluate = evaluate;
    var _acp = MolScriptBuilder.struct.atomProperty.core, _ammp = MolScriptBuilder.struct.atomProperty.macromolecular, _atp = MolScriptBuilder.struct.atomProperty.topology;
    /** atom core property */
    function acp(p) { return _acp[p](); }
    MolScriptBuilder.acp = acp;
    ;
    /** atom topology property */
    function atp(p) { return _atp[p](); }
    MolScriptBuilder.atp = atp;
    ;
    /** atom macromolecular property */
    function ammp(p) { return _ammp[p](); }
    MolScriptBuilder.ammp = ammp;
    ;
    var _aps = MolScriptBuilder.struct.atomSet.propertySet;
    /** atom core property set */
    function acpSet(p) { return _aps([acp(p)]); }
    MolScriptBuilder.acpSet = acpSet;
    ;
    /** atom topology property set */
    function atpSet(p) { return _aps([atp(p)]); }
    MolScriptBuilder.atpSet = atpSet;
    ;
    /** atom macromolecular property set */
    function ammpSet(p) { return _aps([ammp(p)]); }
    MolScriptBuilder.ammpSet = ammpSet;
    ;
})(MolScriptBuilder || (MolScriptBuilder = {}));
//# sourceMappingURL=builder.js.map

/***/ }),

/***/ "./lib/mol-script/language/expression.js":
/*!***********************************************!*\
  !*** ./lib/mol-script/language/expression.js ***!
  \***********************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/*
 * Copyright (c) 2018 Mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author David Sehnal <david.sehnal@gmail.com>
 */
var Expression;
(function (Expression) {
    function Symbol(name) { return { name: name }; }
    Expression.Symbol = Symbol;
    function Apply(head, args) { return args ? { head: head, args: args } : { head: head }; }
    Expression.Apply = Apply;
    function isArgumentsArray(e) { return !!e && Array.isArray(e); }
    Expression.isArgumentsArray = isArgumentsArray;
    function isArgumentsMap(e) { return !!e && !Array.isArray(e); }
    Expression.isArgumentsMap = isArgumentsMap;
    function isLiteral(e) { return !isApply(e) && !isSymbol(e); }
    Expression.isLiteral = isLiteral;
    function isApply(e) { return !!e && !!e.head && typeof e === 'object'; }
    Expression.isApply = isApply;
    function isSymbol(e) { return !!e && typeof e.name === 'string'; }
    Expression.isSymbol = isSymbol;
})(Expression || (Expression = {}));
/* harmony default export */ __webpack_exports__["default"] = (Expression);
//# sourceMappingURL=expression.js.map

/***/ }),

/***/ "./lib/mol-script/language/helpers.js":
/*!********************************************!*\
  !*** ./lib/mol-script/language/helpers.js ***!
  \********************************************/
/*! exports provided: symbol, normalizeTable, symbolList */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "symbol", function() { return symbol; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "normalizeTable", function() { return normalizeTable; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "symbolList", function() { return symbolList; });
/* harmony import */ var _symbol__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./symbol */ "./lib/mol-script/language/symbol.js");
/*
 * Copyright (c) 2018 Mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author David Sehnal <david.sehnal@gmail.com>
 */

function symbol(args, type, description) {
    return Object(_symbol__WEBPACK_IMPORTED_MODULE_0__["MSymbol"])('', args, type, description);
}
function normalizeTable(table) {
    _normalizeTable('', '', table);
}
function symbolList(table) {
    var list = [];
    _symbolList(table, list);
    return list;
}
function formatKey(key) {
    var regex = /([a-z])([A-Z])([a-z]|$)/g;
    // do this twice because 'xXxX'
    return key.replace(regex, function (s, a, b, c) { return a + "-" + b.toLocaleLowerCase() + c; }).replace(regex, function (s, a, b, c) { return a + "-" + b.toLocaleLowerCase() + c; });
}
function _normalizeTable(namespace, key, obj) {
    if (Object(_symbol__WEBPACK_IMPORTED_MODULE_0__["isSymbol"])(obj)) {
        obj.info.namespace = namespace;
        obj.info.name = obj.info.name || formatKey(key);
        obj.id = obj.info.namespace + "." + obj.info.name;
        return;
    }
    var currentNs = "" + (obj['@namespace'] || formatKey(key));
    var newNs = namespace ? namespace + "." + currentNs : currentNs;
    for (var _i = 0, _a = Object.keys(obj); _i < _a.length; _i++) {
        var childKey = _a[_i];
        if (typeof obj[childKey] !== 'object' && !Object(_symbol__WEBPACK_IMPORTED_MODULE_0__["isSymbol"])(obj[childKey]))
            continue;
        _normalizeTable(newNs, childKey, obj[childKey]);
    }
}
function _symbolList(obj, list) {
    if (Object(_symbol__WEBPACK_IMPORTED_MODULE_0__["isSymbol"])(obj)) {
        list.push(obj);
        return;
    }
    for (var _i = 0, _a = Object.keys(obj); _i < _a.length; _i++) {
        var childKey = _a[_i];
        if (typeof obj[childKey] !== 'object' && !Object(_symbol__WEBPACK_IMPORTED_MODULE_0__["isSymbol"])(obj[childKey]))
            continue;
        _symbolList(obj[childKey], list);
    }
}
//# sourceMappingURL=helpers.js.map

/***/ }),

/***/ "./lib/mol-script/language/parser.js":
/*!*******************************************!*\
  !*** ./lib/mol-script/language/parser.js ***!
  \*******************************************/
/*! exports provided: parseMolScript */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "parseMolScript", function() { return parseMolScript; });
/* harmony import */ var _mol_util_monadic_parser__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../mol-util/monadic-parser */ "./lib/mol-util/monadic-parser.js");
/* harmony import */ var _expression__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./expression */ "./lib/mol-script/language/expression.js");
/* harmony import */ var _builder__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./builder */ "./lib/mol-script/language/builder.js");
/**
 * Copyright (c) 2018 Mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author David Sehnal <david.sehnal@gmail.com>
 */



function parseMolScript(input) {
    return Language.parse(input);
}
var Language;
(function (Language) {
    var ASTNode;
    (function (ASTNode) {
        function str(value) { return { kind: 'string', value: value }; }
        ASTNode.str = str;
        function symb(value) { return { kind: 'symbol', value: value }; }
        ASTNode.symb = symb;
        function list(bracket, nodes) { return { kind: 'list', bracket: bracket, nodes: nodes }; }
        ASTNode.list = list;
        function comment(value) { return { kind: 'comment', value: value }; }
        ASTNode.comment = comment;
    })(ASTNode || (ASTNode = {}));
    var ws = _mol_util_monadic_parser__WEBPACK_IMPORTED_MODULE_0__["MonadicParser"].regexp(/[\n\r\s]*/);
    var Expr = _mol_util_monadic_parser__WEBPACK_IMPORTED_MODULE_0__["MonadicParser"].lazy(function () { return (_mol_util_monadic_parser__WEBPACK_IMPORTED_MODULE_0__["MonadicParser"].alt(Str, List, Symb, Comment).trim(ws)); });
    var Str = _mol_util_monadic_parser__WEBPACK_IMPORTED_MODULE_0__["MonadicParser"].takeWhile(function (c) { return c !== '`'; }).trim('`').map(ASTNode.str);
    var Symb = _mol_util_monadic_parser__WEBPACK_IMPORTED_MODULE_0__["MonadicParser"].regexp(/[^()\[\]{};`,\n\r\s]+/).map(ASTNode.symb);
    var Comment = _mol_util_monadic_parser__WEBPACK_IMPORTED_MODULE_0__["MonadicParser"].regexp(/\s*;+([^\n\r]*)\n/, 1).map(ASTNode.comment);
    var Args = Expr.many();
    var List1 = Args.wrap('(', ')').map(function (args) { return ASTNode.list('(', args); });
    var List2 = Args.wrap('[', ']').map(function (args) { return ASTNode.list('[', args); });
    var List3 = Args.wrap('{', '}').map(function (args) { return ASTNode.list('{', args); });
    var List = _mol_util_monadic_parser__WEBPACK_IMPORTED_MODULE_0__["MonadicParser"].alt(List1, List2, List3);
    var Expressions = Expr.many();
    function getAST(input) { return Expressions.tryParse(input); }
    function visitExpr(expr) {
        switch (expr.kind) {
            case 'string': return expr.value;
            case 'symbol': {
                var value = expr.value;
                if (value.length > 1) {
                    var fst = value.charAt(0);
                    switch (fst) {
                        case '.': return _builder__WEBPACK_IMPORTED_MODULE_2__["MolScriptBuilder"].atomName(value.substr(1));
                        case '_': return _builder__WEBPACK_IMPORTED_MODULE_2__["MolScriptBuilder"].struct.type.elementSymbol([value.substr(1)]);
                    }
                }
                if (value === 'true')
                    return true;
                if (value === 'false')
                    return false;
                if (isNumber(value))
                    return +value;
                return _expression__WEBPACK_IMPORTED_MODULE_1__["default"].Symbol(value);
            }
            case 'list': {
                switch (expr.bracket) {
                    case '[': return _builder__WEBPACK_IMPORTED_MODULE_2__["MolScriptBuilder"].core.type.list(withoutComments(expr.nodes).map(visitExpr));
                    case '{': return _builder__WEBPACK_IMPORTED_MODULE_2__["MolScriptBuilder"].core.type.set(withoutComments(expr.nodes).map(visitExpr));
                    case '(': {
                        var head = visitExpr(expr.nodes[0]);
                        return _expression__WEBPACK_IMPORTED_MODULE_1__["default"].Apply(head, getArgs(expr.nodes));
                    }
                }
                return 0;
            }
            default: {
                throw new Error('should not happen');
            }
        }
    }
    function getArgs(nodes) {
        if (nodes.length <= 1)
            return void 0;
        if (!hasNamedArgs(nodes)) {
            var args_1 = [];
            for (var i = 1, _i = nodes.length; i < _i; i++) {
                var n = nodes[i];
                if (n.kind === 'comment')
                    continue;
                args_1[args_1.length] = visitExpr(n);
            }
            return args_1;
        }
        var args = {};
        var allNumeric = true;
        var pos = 0;
        for (var i = 1, _i = nodes.length; i < _i; i++) {
            var n = nodes[i];
            if (n.kind === 'comment')
                continue;
            if (n.kind === 'symbol' && n.value.length > 1 && n.value.charAt(0) === ':') {
                var name_1 = n.value.substr(1);
                ++i;
                while (i < _i && nodes[i].kind === 'comment') {
                    i++;
                }
                if (i >= _i)
                    throw new Error("There must be a value foolowed a named arg ':" + name_1 + "'.");
                args[name_1] = visitExpr(nodes[i]);
                if (isNaN(+name_1))
                    allNumeric = false;
            }
            else {
                args[pos++] = visitExpr(n);
            }
        }
        if (allNumeric) {
            var keys = Object.keys(args).map(function (a) { return +a; }).sort(function (a, b) { return a - b; });
            var isArray = true;
            for (var i = 0, _i = keys.length; i < _i; i++) {
                if (keys[i] !== i) {
                    isArray = false;
                    break;
                }
            }
            if (isArray) {
                var arrayArgs = [];
                for (var i = 0, _i = keys.length; i < _i; i++) {
                    arrayArgs[i] = args[i];
                }
                return arrayArgs;
            }
        }
        return args;
    }
    function hasNamedArgs(nodes) {
        for (var i = 1, _i = nodes.length; i < _i; i++) {
            var n = nodes[i];
            if (n.kind === 'symbol' && n.value.length > 1 && n.value.charAt(0) === ':')
                return true;
        }
        return false;
    }
    function withoutComments(nodes) {
        var hasComment = false;
        for (var i = 0, _i = nodes.length; i < _i; i++) {
            if (nodes[i].kind === 'comment') {
                hasComment = true;
                break;
            }
        }
        if (!hasComment)
            return nodes;
        return nodes.filter(function (n) { return n.kind !== 'comment'; });
    }
    function isNumber(value) {
        return /-?(0|[1-9][0-9]*)([.][0-9]+)?([eE][+-]?[0-9]+)?/.test(value) && !isNaN(+value);
    }
    function parse(input) {
        var ast = getAST(input);
        var ret = [];
        for (var _a = 0, ast_1 = ast; _a < ast_1.length; _a++) {
            var expr = ast_1[_a];
            if (expr.kind === 'comment')
                continue;
            ret[ret.length] = visitExpr(expr);
        }
        return ret;
    }
    Language.parse = parse;
})(Language || (Language = {}));
//# sourceMappingURL=parser.js.map

/***/ }),

/***/ "./lib/mol-script/language/symbol-table.js":
/*!*************************************************!*\
  !*** ./lib/mol-script/language/symbol-table.js ***!
  \*************************************************/
/*! exports provided: SymbolList, SymbolMap, MolScriptSymbolTable */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SymbolList", function() { return SymbolList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SymbolMap", function() { return SymbolMap; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MolScriptSymbolTable", function() { return MolScriptSymbolTable; });
/* harmony import */ var _symbol_table_core__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./symbol-table/core */ "./lib/mol-script/language/symbol-table/core.js");
/* harmony import */ var _symbol_table_structure_query__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./symbol-table/structure-query */ "./lib/mol-script/language/symbol-table/structure-query.js");
/* harmony import */ var _symbol_table_internal__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./symbol-table/internal */ "./lib/mol-script/language/symbol-table/internal.js");
/* harmony import */ var _helpers__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./helpers */ "./lib/mol-script/language/helpers.js");
/**
 * Copyright (c) 2017 Mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author David Sehnal <david.sehnal@gmail.com>
 */




var MolScriptSymbolTable = { core: _symbol_table_core__WEBPACK_IMPORTED_MODULE_0__["default"], structureQuery: _symbol_table_structure_query__WEBPACK_IMPORTED_MODULE_1__["default"], internal: _symbol_table_internal__WEBPACK_IMPORTED_MODULE_2__["default"] };
Object(_helpers__WEBPACK_IMPORTED_MODULE_3__["normalizeTable"])(MolScriptSymbolTable);
var SymbolList = Object(_helpers__WEBPACK_IMPORTED_MODULE_3__["symbolList"])(MolScriptSymbolTable);
var SymbolMap = (function () {
    var map = Object.create(null);
    for (var _i = 0, SymbolList_1 = SymbolList; _i < SymbolList_1.length; _i++) {
        var s = SymbolList_1[_i];
        map[s.id] = s;
    }
    return map;
})();

//# sourceMappingURL=symbol-table.js.map

/***/ }),

/***/ "./lib/mol-script/language/symbol-table/core.js":
/*!******************************************************!*\
  !*** ./lib/mol-script/language/symbol-table/core.js ***!
  \******************************************************/
/*! exports provided: Types, TTargs, SymbolList, SymbolMap, default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Types", function() { return Types; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "TTargs", function() { return TTargs; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SymbolList", function() { return SymbolList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SymbolMap", function() { return SymbolMap; });
/* harmony import */ var _type__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../type */ "./lib/mol-script/language/type.js");
/* harmony import */ var _symbol__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../symbol */ "./lib/mol-script/language/symbol.js");
/* harmony import */ var _helpers__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../helpers */ "./lib/mol-script/language/helpers.js");
/**
 * Copyright (c) 2018 Mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author David Sehnal <david.sehnal@gmail.com>
 */



var Types;
(function (Types) {
    Types.AnyVar = _type__WEBPACK_IMPORTED_MODULE_0__["default"].Variable('a', _type__WEBPACK_IMPORTED_MODULE_0__["default"].Any);
    Types.AnyValueVar = _type__WEBPACK_IMPORTED_MODULE_0__["default"].Variable('a', _type__WEBPACK_IMPORTED_MODULE_0__["default"].Any);
    Types.ConstrainedVar = _type__WEBPACK_IMPORTED_MODULE_0__["default"].Variable('a', _type__WEBPACK_IMPORTED_MODULE_0__["default"].Any, true);
    Types.Regex = _type__WEBPACK_IMPORTED_MODULE_0__["default"].Value('Core', 'Regex');
    Types.Set = function (t) { return _type__WEBPACK_IMPORTED_MODULE_0__["default"].Container('Core', 'Set', t || Types.AnyValueVar); };
    Types.List = function (t) { return _type__WEBPACK_IMPORTED_MODULE_0__["default"].Container('Core', 'List', t || Types.AnyVar); };
    Types.Fn = function (t, alias) { return _type__WEBPACK_IMPORTED_MODULE_0__["default"].Container('Core', 'Fn', t || Types.AnyVar, alias); };
    Types.Flags = function (t, alias) { return _type__WEBPACK_IMPORTED_MODULE_0__["default"].Container('Core', 'Flags', t, alias); };
    Types.BitFlags = Types.Flags(_type__WEBPACK_IMPORTED_MODULE_0__["default"].Num, 'BitFlags');
})(Types || (Types = {}));
function unaryOp(type, description) {
    return Object(_helpers__WEBPACK_IMPORTED_MODULE_2__["symbol"])(_symbol__WEBPACK_IMPORTED_MODULE_1__["Arguments"].Dictionary({ 0: Object(_symbol__WEBPACK_IMPORTED_MODULE_1__["Argument"])(type) }), type, description);
}
function binOp(type, description) {
    return Object(_helpers__WEBPACK_IMPORTED_MODULE_2__["symbol"])(_symbol__WEBPACK_IMPORTED_MODULE_1__["Arguments"].List(type, { nonEmpty: true }), type, description);
}
function binRel(src, target, description) {
    return Object(_helpers__WEBPACK_IMPORTED_MODULE_2__["symbol"])(_symbol__WEBPACK_IMPORTED_MODULE_1__["Arguments"].Dictionary({
        0: Object(_symbol__WEBPACK_IMPORTED_MODULE_1__["Argument"])(src),
        1: Object(_symbol__WEBPACK_IMPORTED_MODULE_1__["Argument"])(src)
    }), target, description);
}
var TTargs = _symbol__WEBPACK_IMPORTED_MODULE_1__["Arguments"].Dictionary({
    0: Object(_symbol__WEBPACK_IMPORTED_MODULE_1__["Argument"])(_type__WEBPACK_IMPORTED_MODULE_0__["default"].Num),
    1: Object(_symbol__WEBPACK_IMPORTED_MODULE_1__["Argument"])(_type__WEBPACK_IMPORTED_MODULE_0__["default"].Num)
});
var XX = { test: Object(_symbol__WEBPACK_IMPORTED_MODULE_1__["Argument"])(_type__WEBPACK_IMPORTED_MODULE_0__["default"].Str) };
var t = 0;
t.test;
var type = {
    '@header': 'Types',
    bool: Object(_helpers__WEBPACK_IMPORTED_MODULE_2__["symbol"])(_symbol__WEBPACK_IMPORTED_MODULE_1__["Arguments"].Dictionary({ 0: Object(_symbol__WEBPACK_IMPORTED_MODULE_1__["Argument"])(_type__WEBPACK_IMPORTED_MODULE_0__["default"].AnyValue) }), _type__WEBPACK_IMPORTED_MODULE_0__["default"].Bool, 'Convert a value to boolean.'),
    num: Object(_helpers__WEBPACK_IMPORTED_MODULE_2__["symbol"])(_symbol__WEBPACK_IMPORTED_MODULE_1__["Arguments"].Dictionary({ 0: Object(_symbol__WEBPACK_IMPORTED_MODULE_1__["Argument"])(_type__WEBPACK_IMPORTED_MODULE_0__["default"].AnyValue) }), _type__WEBPACK_IMPORTED_MODULE_0__["default"].Num, 'Convert a value to number.'),
    str: Object(_helpers__WEBPACK_IMPORTED_MODULE_2__["symbol"])(_symbol__WEBPACK_IMPORTED_MODULE_1__["Arguments"].Dictionary({ 0: Object(_symbol__WEBPACK_IMPORTED_MODULE_1__["Argument"])(_type__WEBPACK_IMPORTED_MODULE_0__["default"].AnyValue) }), _type__WEBPACK_IMPORTED_MODULE_0__["default"].Str, 'Convert a value to string.'),
    regex: Object(_helpers__WEBPACK_IMPORTED_MODULE_2__["symbol"])(_symbol__WEBPACK_IMPORTED_MODULE_1__["Arguments"].Dictionary({
        0: Object(_symbol__WEBPACK_IMPORTED_MODULE_1__["Argument"])(_type__WEBPACK_IMPORTED_MODULE_0__["default"].Str, { description: 'Expression' }),
        1: Object(_symbol__WEBPACK_IMPORTED_MODULE_1__["Argument"])(_type__WEBPACK_IMPORTED_MODULE_0__["default"].Str, { isOptional: true, description: "Flags, e.g. 'i' for ignore case" })
    }), Types.Regex, 'Creates a regular expression from a string using the ECMAscript syntax.'),
    list: Object(_helpers__WEBPACK_IMPORTED_MODULE_2__["symbol"])(_symbol__WEBPACK_IMPORTED_MODULE_1__["Arguments"].List(Types.AnyVar), Types.List()),
    set: Object(_helpers__WEBPACK_IMPORTED_MODULE_2__["symbol"])(_symbol__WEBPACK_IMPORTED_MODULE_1__["Arguments"].List(Types.AnyValueVar), Types.Set()),
    bitflags: Object(_helpers__WEBPACK_IMPORTED_MODULE_2__["symbol"])(_symbol__WEBPACK_IMPORTED_MODULE_1__["Arguments"].Dictionary({ 0: Object(_symbol__WEBPACK_IMPORTED_MODULE_1__["Argument"])(_type__WEBPACK_IMPORTED_MODULE_0__["default"].Num) }), Types.BitFlags, 'Interpret a number as bitflags.'),
    compositeKey: Object(_helpers__WEBPACK_IMPORTED_MODULE_2__["symbol"])(_symbol__WEBPACK_IMPORTED_MODULE_1__["Arguments"].List(_type__WEBPACK_IMPORTED_MODULE_0__["default"].AnyValue), _type__WEBPACK_IMPORTED_MODULE_0__["default"].AnyValue),
};
var logic = {
    '@header': 'Logic',
    not: unaryOp(_type__WEBPACK_IMPORTED_MODULE_0__["default"].Bool),
    and: binOp(_type__WEBPACK_IMPORTED_MODULE_0__["default"].Bool),
    or: binOp(_type__WEBPACK_IMPORTED_MODULE_0__["default"].Bool),
};
var ctrl = {
    '@header': 'Control',
    eval: Object(_helpers__WEBPACK_IMPORTED_MODULE_2__["symbol"])(_symbol__WEBPACK_IMPORTED_MODULE_1__["Arguments"].Dictionary({ 0: Object(_symbol__WEBPACK_IMPORTED_MODULE_1__["Argument"])(Types.Fn(Types.AnyVar)) }), Types.AnyVar, 'Evaluate a function.'),
    fn: Object(_helpers__WEBPACK_IMPORTED_MODULE_2__["symbol"])(_symbol__WEBPACK_IMPORTED_MODULE_1__["Arguments"].Dictionary({ 0: Object(_symbol__WEBPACK_IMPORTED_MODULE_1__["Argument"])(Types.AnyVar) }), Types.Fn(Types.AnyVar), 'Wrap an expression to a "lazy" function.'),
    if: Object(_helpers__WEBPACK_IMPORTED_MODULE_2__["symbol"])(_symbol__WEBPACK_IMPORTED_MODULE_1__["Arguments"].Dictionary({
        0: Object(_symbol__WEBPACK_IMPORTED_MODULE_1__["Argument"])(_type__WEBPACK_IMPORTED_MODULE_0__["default"].Bool, { description: 'Condition' }),
        1: Object(_symbol__WEBPACK_IMPORTED_MODULE_1__["Argument"])(_type__WEBPACK_IMPORTED_MODULE_0__["default"].Variable('a', _type__WEBPACK_IMPORTED_MODULE_0__["default"].Any), { description: 'If true' }),
        2: Object(_symbol__WEBPACK_IMPORTED_MODULE_1__["Argument"])(_type__WEBPACK_IMPORTED_MODULE_0__["default"].Variable('b', _type__WEBPACK_IMPORTED_MODULE_0__["default"].Any), { description: 'If false' })
    }), _type__WEBPACK_IMPORTED_MODULE_0__["default"].Union([_type__WEBPACK_IMPORTED_MODULE_0__["default"].Variable('a', _type__WEBPACK_IMPORTED_MODULE_0__["default"].Any), _type__WEBPACK_IMPORTED_MODULE_0__["default"].Variable('b', _type__WEBPACK_IMPORTED_MODULE_0__["default"].Any)])),
    assoc: Object(_helpers__WEBPACK_IMPORTED_MODULE_2__["symbol"])(_symbol__WEBPACK_IMPORTED_MODULE_1__["Arguments"].Dictionary({
        0: Object(_symbol__WEBPACK_IMPORTED_MODULE_1__["Argument"])(_type__WEBPACK_IMPORTED_MODULE_0__["default"].Str, { description: 'Name' }),
        1: Object(_symbol__WEBPACK_IMPORTED_MODULE_1__["Argument"])(_type__WEBPACK_IMPORTED_MODULE_0__["default"].Variable('a', _type__WEBPACK_IMPORTED_MODULE_0__["default"].Any), { description: 'Value to assign' })
    }), _type__WEBPACK_IMPORTED_MODULE_0__["default"].Variable('a', _type__WEBPACK_IMPORTED_MODULE_0__["default"].Any))
};
var rel = {
    '@header': 'Relational',
    eq: binRel(_type__WEBPACK_IMPORTED_MODULE_0__["default"].Variable('a', _type__WEBPACK_IMPORTED_MODULE_0__["default"].AnyValue, true), _type__WEBPACK_IMPORTED_MODULE_0__["default"].Bool),
    neq: binRel(_type__WEBPACK_IMPORTED_MODULE_0__["default"].Variable('a', _type__WEBPACK_IMPORTED_MODULE_0__["default"].AnyValue, true), _type__WEBPACK_IMPORTED_MODULE_0__["default"].Bool),
    lt: binRel(_type__WEBPACK_IMPORTED_MODULE_0__["default"].Num, _type__WEBPACK_IMPORTED_MODULE_0__["default"].Bool),
    lte: binRel(_type__WEBPACK_IMPORTED_MODULE_0__["default"].Num, _type__WEBPACK_IMPORTED_MODULE_0__["default"].Bool),
    gr: binRel(_type__WEBPACK_IMPORTED_MODULE_0__["default"].Num, _type__WEBPACK_IMPORTED_MODULE_0__["default"].Bool),
    gre: binRel(_type__WEBPACK_IMPORTED_MODULE_0__["default"].Num, _type__WEBPACK_IMPORTED_MODULE_0__["default"].Bool),
    inRange: Object(_helpers__WEBPACK_IMPORTED_MODULE_2__["symbol"])(_symbol__WEBPACK_IMPORTED_MODULE_1__["Arguments"].Dictionary({
        0: Object(_symbol__WEBPACK_IMPORTED_MODULE_1__["Argument"])(_type__WEBPACK_IMPORTED_MODULE_0__["default"].Num, { description: 'Value to test' }),
        1: Object(_symbol__WEBPACK_IMPORTED_MODULE_1__["Argument"])(_type__WEBPACK_IMPORTED_MODULE_0__["default"].Num, { description: 'Minimum value' }),
        2: Object(_symbol__WEBPACK_IMPORTED_MODULE_1__["Argument"])(_type__WEBPACK_IMPORTED_MODULE_0__["default"].Num, { description: 'Maximum value' })
    }), _type__WEBPACK_IMPORTED_MODULE_0__["default"].Bool, 'Check if the value of the 1st argument is >= 2nd and <= 3rd.'),
};
var math = {
    '@header': 'Math',
    add: binOp(_type__WEBPACK_IMPORTED_MODULE_0__["default"].Num),
    sub: binOp(_type__WEBPACK_IMPORTED_MODULE_0__["default"].Num),
    mult: binOp(_type__WEBPACK_IMPORTED_MODULE_0__["default"].Num),
    div: binRel(_type__WEBPACK_IMPORTED_MODULE_0__["default"].Num, _type__WEBPACK_IMPORTED_MODULE_0__["default"].Num),
    pow: binRel(_type__WEBPACK_IMPORTED_MODULE_0__["default"].Num, _type__WEBPACK_IMPORTED_MODULE_0__["default"].Num),
    mod: binRel(_type__WEBPACK_IMPORTED_MODULE_0__["default"].Num, _type__WEBPACK_IMPORTED_MODULE_0__["default"].Num),
    min: binOp(_type__WEBPACK_IMPORTED_MODULE_0__["default"].Num),
    max: binOp(_type__WEBPACK_IMPORTED_MODULE_0__["default"].Num),
    floor: unaryOp(_type__WEBPACK_IMPORTED_MODULE_0__["default"].Num),
    ceil: unaryOp(_type__WEBPACK_IMPORTED_MODULE_0__["default"].Num),
    roundInt: unaryOp(_type__WEBPACK_IMPORTED_MODULE_0__["default"].Num),
    abs: unaryOp(_type__WEBPACK_IMPORTED_MODULE_0__["default"].Num),
    sqrt: unaryOp(_type__WEBPACK_IMPORTED_MODULE_0__["default"].Num),
    cbrt: unaryOp(_type__WEBPACK_IMPORTED_MODULE_0__["default"].Num),
    sin: unaryOp(_type__WEBPACK_IMPORTED_MODULE_0__["default"].Num),
    cos: unaryOp(_type__WEBPACK_IMPORTED_MODULE_0__["default"].Num),
    tan: unaryOp(_type__WEBPACK_IMPORTED_MODULE_0__["default"].Num),
    asin: unaryOp(_type__WEBPACK_IMPORTED_MODULE_0__["default"].Num),
    acos: unaryOp(_type__WEBPACK_IMPORTED_MODULE_0__["default"].Num),
    atan: unaryOp(_type__WEBPACK_IMPORTED_MODULE_0__["default"].Num),
    sinh: unaryOp(_type__WEBPACK_IMPORTED_MODULE_0__["default"].Num),
    cosh: unaryOp(_type__WEBPACK_IMPORTED_MODULE_0__["default"].Num),
    tanh: unaryOp(_type__WEBPACK_IMPORTED_MODULE_0__["default"].Num),
    exp: unaryOp(_type__WEBPACK_IMPORTED_MODULE_0__["default"].Num),
    log: unaryOp(_type__WEBPACK_IMPORTED_MODULE_0__["default"].Num),
    log10: unaryOp(_type__WEBPACK_IMPORTED_MODULE_0__["default"].Num),
    atan2: binRel(_type__WEBPACK_IMPORTED_MODULE_0__["default"].Num, _type__WEBPACK_IMPORTED_MODULE_0__["default"].Num)
};
var str = {
    '@header': 'Strings',
    concat: binOp(_type__WEBPACK_IMPORTED_MODULE_0__["default"].Str),
    match: Object(_helpers__WEBPACK_IMPORTED_MODULE_2__["symbol"])(_symbol__WEBPACK_IMPORTED_MODULE_1__["Arguments"].Dictionary({ 0: Object(_symbol__WEBPACK_IMPORTED_MODULE_1__["Argument"])(Types.Regex), 1: Object(_symbol__WEBPACK_IMPORTED_MODULE_1__["Argument"])(_type__WEBPACK_IMPORTED_MODULE_0__["default"].Str) }), _type__WEBPACK_IMPORTED_MODULE_0__["default"].Bool)
};
var list = {
    '@header': 'Lists',
    getAt: Object(_helpers__WEBPACK_IMPORTED_MODULE_2__["symbol"])(_symbol__WEBPACK_IMPORTED_MODULE_1__["Arguments"].Dictionary({ 0: Object(_symbol__WEBPACK_IMPORTED_MODULE_1__["Argument"])(Types.List()), 1: Object(_symbol__WEBPACK_IMPORTED_MODULE_1__["Argument"])(_type__WEBPACK_IMPORTED_MODULE_0__["default"].Num) }), Types.AnyVar),
    equal: Object(_helpers__WEBPACK_IMPORTED_MODULE_2__["symbol"])(_symbol__WEBPACK_IMPORTED_MODULE_1__["Arguments"].Dictionary({ 0: Object(_symbol__WEBPACK_IMPORTED_MODULE_1__["Argument"])(Types.List()), 1: Object(_symbol__WEBPACK_IMPORTED_MODULE_1__["Argument"])(Types.List()) }), _type__WEBPACK_IMPORTED_MODULE_0__["default"].Bool)
};
var set = {
    '@header': 'Sets',
    has: Object(_helpers__WEBPACK_IMPORTED_MODULE_2__["symbol"])(_symbol__WEBPACK_IMPORTED_MODULE_1__["Arguments"].Dictionary({ 0: Object(_symbol__WEBPACK_IMPORTED_MODULE_1__["Argument"])(Types.Set(Types.ConstrainedVar)), 1: Object(_symbol__WEBPACK_IMPORTED_MODULE_1__["Argument"])(Types.ConstrainedVar) }), _type__WEBPACK_IMPORTED_MODULE_0__["default"].Bool, 'Check if the the 1st argument includes the value of the 2nd.'),
    isSubset: Object(_helpers__WEBPACK_IMPORTED_MODULE_2__["symbol"])(_symbol__WEBPACK_IMPORTED_MODULE_1__["Arguments"].Dictionary({ 0: Object(_symbol__WEBPACK_IMPORTED_MODULE_1__["Argument"])(Types.Set(Types.ConstrainedVar)), 1: Object(_symbol__WEBPACK_IMPORTED_MODULE_1__["Argument"])(Types.Set(Types.ConstrainedVar)) }), _type__WEBPACK_IMPORTED_MODULE_0__["default"].Bool, 'Check if the the 1st argument is a subset of the 2nd.')
};
var flags = {
    '@header': 'Flags',
    hasAny: Object(_helpers__WEBPACK_IMPORTED_MODULE_2__["symbol"])(_symbol__WEBPACK_IMPORTED_MODULE_1__["Arguments"].Dictionary({
        0: Object(_symbol__WEBPACK_IMPORTED_MODULE_1__["Argument"])(Types.Flags(Types.ConstrainedVar)),
        1: Object(_symbol__WEBPACK_IMPORTED_MODULE_1__["Argument"])(Types.Flags(Types.ConstrainedVar))
    }), _type__WEBPACK_IMPORTED_MODULE_0__["default"].Bool, 'Check if the the 1st argument has at least one of the 2nd one\'s flags.'),
    hasAll: Object(_helpers__WEBPACK_IMPORTED_MODULE_2__["symbol"])(_symbol__WEBPACK_IMPORTED_MODULE_1__["Arguments"].Dictionary({
        0: Object(_symbol__WEBPACK_IMPORTED_MODULE_1__["Argument"])(Types.Flags(Types.ConstrainedVar)),
        1: Object(_symbol__WEBPACK_IMPORTED_MODULE_1__["Argument"])(Types.Flags(Types.ConstrainedVar))
    }), _type__WEBPACK_IMPORTED_MODULE_0__["default"].Bool, 'Check if the the 1st argument has all 2nd one\'s flags.'),
};
var table = {
    '@header': 'Language Primitives',
    type: type,
    logic: logic,
    ctrl: ctrl,
    rel: rel,
    math: math,
    str: str,
    list: list,
    set: set,
    flags: flags
};
Object(_helpers__WEBPACK_IMPORTED_MODULE_2__["normalizeTable"])(table);
var SymbolList = Object(_helpers__WEBPACK_IMPORTED_MODULE_2__["symbolList"])(table);
var SymbolMap = (function () {
    var map = Object.create(null);
    for (var _i = 0, SymbolList_1 = SymbolList; _i < SymbolList_1.length; _i++) {
        var s = SymbolList_1[_i];
        map[s.id] = s;
    }
    return map;
})();
/* harmony default export */ __webpack_exports__["default"] = (table);
//# sourceMappingURL=core.js.map

/***/ }),

/***/ "./lib/mol-script/language/symbol-table/internal.js":
/*!**********************************************************!*\
  !*** ./lib/mol-script/language/symbol-table/internal.js ***!
  \**********************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _type__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../type */ "./lib/mol-script/language/type.js");
/* harmony import */ var _structure_query__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./structure-query */ "./lib/mol-script/language/symbol-table/structure-query.js");
/* harmony import */ var _symbol__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../symbol */ "./lib/mol-script/language/symbol.js");
/* harmony import */ var _helpers__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../helpers */ "./lib/mol-script/language/helpers.js");
/**
 * Copyright (c) 2019 Mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author David Sehnal <david.sehnal@gmail.com>
 */




var generator = {
    '@header': 'Generators',
    bundleElement: Object(_helpers__WEBPACK_IMPORTED_MODULE_3__["symbol"])(_symbol__WEBPACK_IMPORTED_MODULE_2__["Arguments"].Dictionary({
        // TODO: should we use more universal unit keys? (i.e. based on chain and "operator name")
        groupedUnits: Object(_symbol__WEBPACK_IMPORTED_MODULE_2__["Argument"])(_type__WEBPACK_IMPORTED_MODULE_0__["default"].Any),
        set: Object(_symbol__WEBPACK_IMPORTED_MODULE_2__["Argument"])(_type__WEBPACK_IMPORTED_MODULE_0__["default"].Any),
        ranges: Object(_symbol__WEBPACK_IMPORTED_MODULE_2__["Argument"])(_type__WEBPACK_IMPORTED_MODULE_0__["default"].Any) // SortedArray<UnitIndex>
    }), _type__WEBPACK_IMPORTED_MODULE_0__["default"].Any),
    bundle: Object(_helpers__WEBPACK_IMPORTED_MODULE_3__["symbol"])(_symbol__WEBPACK_IMPORTED_MODULE_2__["Arguments"].Dictionary({
        elements: Object(_symbol__WEBPACK_IMPORTED_MODULE_2__["Argument"])(_type__WEBPACK_IMPORTED_MODULE_0__["default"].Any) // BundleElement[]
    }), _structure_query__WEBPACK_IMPORTED_MODULE_1__["Types"].ElementSelectionQuery, 'A selection with single structure containing represented by the bundle.'),
    // Use with caution as this is not "state saveable"
    // This query should never be used in any State Transform!
    current: Object(_helpers__WEBPACK_IMPORTED_MODULE_3__["symbol"])(_symbol__WEBPACK_IMPORTED_MODULE_2__["Arguments"].None, _structure_query__WEBPACK_IMPORTED_MODULE_1__["Types"].ElementSelectionQuery, 'Current selection provided by the query context. Avoid using this in State Transforms.')
};
/* harmony default export */ __webpack_exports__["default"] = ({
    '@header': 'Internal Queries',
    generator: generator
});
//# sourceMappingURL=internal.js.map

/***/ }),

/***/ "./lib/mol-script/language/symbol-table/structure-query.js":
/*!*****************************************************************!*\
  !*** ./lib/mol-script/language/symbol-table/structure-query.js ***!
  \*****************************************************************/
/*! exports provided: Types, default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Types", function() { return Types; });
/* harmony import */ var _type__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../type */ "./lib/mol-script/language/type.js");
/* harmony import */ var _core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./core */ "./lib/mol-script/language/symbol-table/core.js");
/* harmony import */ var _symbol__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../symbol */ "./lib/mol-script/language/symbol.js");
/* harmony import */ var _helpers__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../helpers */ "./lib/mol-script/language/helpers.js");
/**
 * Copyright (c) 2018-2019 Mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author David Sehnal <david.sehnal@gmail.com>
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */




var Types;
(function (Types) {
    Types.ElementSymbol = _type__WEBPACK_IMPORTED_MODULE_0__["default"].Value('Structure', 'ElementSymbol');
    Types.AtomName = _type__WEBPACK_IMPORTED_MODULE_0__["default"].Value('Structure', 'AtomName');
    Types.BondFlag = _type__WEBPACK_IMPORTED_MODULE_0__["default"].OneOf('Structure', 'BondFlag', _type__WEBPACK_IMPORTED_MODULE_0__["default"].Str, ['covalent', 'metallic', 'ion', 'hydrogen', 'sulfide', 'computed', 'aromatic']);
    Types.BondFlags = _core__WEBPACK_IMPORTED_MODULE_1__["Types"].Flags(Types.BondFlag, 'BondFlags');
    Types.SecondaryStructureFlag = _type__WEBPACK_IMPORTED_MODULE_0__["default"].OneOf('Structure', 'SecondaryStructureFlag', _type__WEBPACK_IMPORTED_MODULE_0__["default"].Str, ['alpha', 'beta', '3-10', 'pi', 'sheet', 'strand', 'helix', 'turn', 'none']);
    Types.SecondaryStructureFlags = _core__WEBPACK_IMPORTED_MODULE_1__["Types"].Flags(Types.SecondaryStructureFlag, 'SecondaryStructureFlag');
    Types.RingFingerprint = _type__WEBPACK_IMPORTED_MODULE_0__["default"].Value('Structure', 'RingFingerprint');
    Types.EntityType = _type__WEBPACK_IMPORTED_MODULE_0__["default"].OneOf('Structure', 'EntityType', _type__WEBPACK_IMPORTED_MODULE_0__["default"].Str, ['polymer', 'non-polymer', 'water', 'branched']);
    Types.EntitySubtype = _type__WEBPACK_IMPORTED_MODULE_0__["default"].OneOf('Structure', 'EntitySubtype', _type__WEBPACK_IMPORTED_MODULE_0__["default"].Str, ['other', 'polypeptide(D)', 'polypeptide(L)', 'polydeoxyribonucleotide', 'polyribonucleotide', 'polydeoxyribonucleotide/polyribonucleotide hybrid', 'cyclic-pseudo-peptide', 'peptide nucleic acid', 'oligosaccharide']);
    Types.ObjectPrimitive = _type__WEBPACK_IMPORTED_MODULE_0__["default"].OneOf('Structure', 'ObjectPrimitive', _type__WEBPACK_IMPORTED_MODULE_0__["default"].Str, ['atomistic', 'sphere', 'gaussian', 'other']);
    Types.ResidueId = _type__WEBPACK_IMPORTED_MODULE_0__["default"].Value('Structure', 'ResidueId');
    Types.ElementSet = _type__WEBPACK_IMPORTED_MODULE_0__["default"].Value('Structure', 'ElementSet');
    Types.ElementSelection = _type__WEBPACK_IMPORTED_MODULE_0__["default"].Value('Structure', 'ElementSelection');
    Types.ElementReference = _type__WEBPACK_IMPORTED_MODULE_0__["default"].Value('Structure', 'ElementReference');
    Types.ElementSelectionQuery = _core__WEBPACK_IMPORTED_MODULE_1__["Types"].Fn(Types.ElementSelection, 'ElementSelectionQuery');
})(Types || (Types = {}));
var type = {
    '@header': 'Types',
    elementSymbol: Object(_helpers__WEBPACK_IMPORTED_MODULE_3__["symbol"])(_symbol__WEBPACK_IMPORTED_MODULE_2__["Arguments"].Dictionary({ 0: Object(_symbol__WEBPACK_IMPORTED_MODULE_2__["Argument"])(_type__WEBPACK_IMPORTED_MODULE_0__["default"].Str) }), Types.ElementSymbol, 'Create element symbol representation from a string value.'),
    atomName: Object(_helpers__WEBPACK_IMPORTED_MODULE_3__["symbol"])(_symbol__WEBPACK_IMPORTED_MODULE_2__["Arguments"].Dictionary({ 0: Object(_symbol__WEBPACK_IMPORTED_MODULE_2__["Argument"])(_type__WEBPACK_IMPORTED_MODULE_0__["default"].AnyValue) }), Types.AtomName, 'Convert a value to an atom name.'),
    entityType: Object(_helpers__WEBPACK_IMPORTED_MODULE_3__["symbol"])(_symbol__WEBPACK_IMPORTED_MODULE_2__["Arguments"].Dictionary({ 0: Object(_symbol__WEBPACK_IMPORTED_MODULE_2__["Argument"])(Types.EntityType) }), Types.EntityType, "Create normalized representation of entity type: " + _type__WEBPACK_IMPORTED_MODULE_0__["default"].oneOfValues(Types.EntityType).join(', ') + "."),
    bondFlags: Object(_helpers__WEBPACK_IMPORTED_MODULE_3__["symbol"])(_symbol__WEBPACK_IMPORTED_MODULE_2__["Arguments"].List(Types.BondFlag), Types.BondFlags, "Create bond flags representation from a list of strings. Allowed flags: " + _type__WEBPACK_IMPORTED_MODULE_0__["default"].oneOfValues(Types.BondFlag).join(', ') + "."),
    ringFingerprint: Object(_helpers__WEBPACK_IMPORTED_MODULE_3__["symbol"])(_symbol__WEBPACK_IMPORTED_MODULE_2__["Arguments"].List(Types.ElementSymbol, { nonEmpty: true }), Types.RingFingerprint, 'Create ring fingerprint from the supplied atom element list.'),
    secondaryStructureFlags: Object(_helpers__WEBPACK_IMPORTED_MODULE_3__["symbol"])(_symbol__WEBPACK_IMPORTED_MODULE_2__["Arguments"].List(Types.SecondaryStructureFlag), Types.SecondaryStructureFlags, "Create secondary structure flags representation from a list of strings. Allowed flags: " + _type__WEBPACK_IMPORTED_MODULE_0__["default"].oneOfValues(Types.SecondaryStructureFlag).join(', ') + "."),
    authResidueId: Object(_helpers__WEBPACK_IMPORTED_MODULE_3__["symbol"])(_symbol__WEBPACK_IMPORTED_MODULE_2__["Arguments"].Dictionary({
        0: Object(_symbol__WEBPACK_IMPORTED_MODULE_2__["Argument"])(_type__WEBPACK_IMPORTED_MODULE_0__["default"].Str, { description: 'auth_asym_id' }),
        1: Object(_symbol__WEBPACK_IMPORTED_MODULE_2__["Argument"])(_type__WEBPACK_IMPORTED_MODULE_0__["default"].Num, { description: 'auth_seq_id' }),
        2: Object(_symbol__WEBPACK_IMPORTED_MODULE_2__["Argument"])(_type__WEBPACK_IMPORTED_MODULE_0__["default"].Str, { description: 'pdbx_PDB_ins_code', isOptional: true })
    }), Types.ResidueId, "Residue identifier based on \"auth_\" annotation."),
    labelResidueId: Object(_helpers__WEBPACK_IMPORTED_MODULE_3__["symbol"])(_symbol__WEBPACK_IMPORTED_MODULE_2__["Arguments"].Dictionary({
        0: Object(_symbol__WEBPACK_IMPORTED_MODULE_2__["Argument"])(_type__WEBPACK_IMPORTED_MODULE_0__["default"].Str, { description: 'label_entity_id' }),
        1: Object(_symbol__WEBPACK_IMPORTED_MODULE_2__["Argument"])(_type__WEBPACK_IMPORTED_MODULE_0__["default"].Str, { description: 'label_asym_id' }),
        2: Object(_symbol__WEBPACK_IMPORTED_MODULE_2__["Argument"])(_type__WEBPACK_IMPORTED_MODULE_0__["default"].Num, { description: 'label_seq_id' }),
        3: Object(_symbol__WEBPACK_IMPORTED_MODULE_2__["Argument"])(_type__WEBPACK_IMPORTED_MODULE_0__["default"].Str, { description: 'pdbx_PDB_ins_code', isOptional: true })
    }), Types.ResidueId, "Residue identifier based on mmCIF's \"label_\" annotation.")
};
var slot = {
    '@header': 'Iteration Slots',
    element: Object(_helpers__WEBPACK_IMPORTED_MODULE_3__["symbol"])(_symbol__WEBPACK_IMPORTED_MODULE_2__["Arguments"].None, Types.ElementReference, 'A reference to the current element.'),
    elementSetReduce: Object(_helpers__WEBPACK_IMPORTED_MODULE_3__["symbol"])(_symbol__WEBPACK_IMPORTED_MODULE_2__["Arguments"].None, _type__WEBPACK_IMPORTED_MODULE_0__["default"].Variable('a', _type__WEBPACK_IMPORTED_MODULE_0__["default"].AnyValue, true), 'Current value of the element set reducer.')
};
var generator = {
    '@header': 'Generators',
    all: Object(_helpers__WEBPACK_IMPORTED_MODULE_3__["symbol"])(_symbol__WEBPACK_IMPORTED_MODULE_2__["Arguments"].None, Types.ElementSelectionQuery, 'The entire structure.'),
    atomGroups: Object(_helpers__WEBPACK_IMPORTED_MODULE_3__["symbol"])(_symbol__WEBPACK_IMPORTED_MODULE_2__["Arguments"].Dictionary({
        'entity-test': Object(_symbol__WEBPACK_IMPORTED_MODULE_2__["Argument"])(_type__WEBPACK_IMPORTED_MODULE_0__["default"].Bool, { isOptional: true, defaultValue: true, description: 'Test for the 1st atom of every entity' }),
        'chain-test': Object(_symbol__WEBPACK_IMPORTED_MODULE_2__["Argument"])(_type__WEBPACK_IMPORTED_MODULE_0__["default"].Bool, { isOptional: true, defaultValue: true, description: 'Test for the 1st atom of every chain' }),
        'residue-test': Object(_symbol__WEBPACK_IMPORTED_MODULE_2__["Argument"])(_type__WEBPACK_IMPORTED_MODULE_0__["default"].Bool, { isOptional: true, defaultValue: true, description: 'Test for the 1st atom every residue' }),
        'atom-test': Object(_symbol__WEBPACK_IMPORTED_MODULE_2__["Argument"])(_type__WEBPACK_IMPORTED_MODULE_0__["default"].Bool, { isOptional: true, defaultValue: true }),
        'group-by': Object(_symbol__WEBPACK_IMPORTED_MODULE_2__["Argument"])(_type__WEBPACK_IMPORTED_MODULE_0__["default"].Any, { isOptional: true, defaultValue: "atom-key", description: 'Group atoms to sets based on this property. Default: each atom has its own set' }),
    }), Types.ElementSelectionQuery, 'Return all atoms for which the tests are satisfied, grouped into sets.'),
    bondedAtomicPairs: Object(_helpers__WEBPACK_IMPORTED_MODULE_3__["symbol"])(_symbol__WEBPACK_IMPORTED_MODULE_2__["Arguments"].Dictionary({
        0: Object(_symbol__WEBPACK_IMPORTED_MODULE_2__["Argument"])(_type__WEBPACK_IMPORTED_MODULE_0__["default"].Bool, { isOptional: true, defaultValue: 'true for covalent bonds', description: 'Test each bond with this predicate. Each bond is visited twice with swapped atom order.' }),
    }), Types.ElementSelectionQuery, 'Return all pairs of atoms for which the test is satisfied.'),
    rings: Object(_helpers__WEBPACK_IMPORTED_MODULE_3__["symbol"])(_symbol__WEBPACK_IMPORTED_MODULE_2__["Arguments"].Dictionary({
        'fingerprint': Object(_symbol__WEBPACK_IMPORTED_MODULE_2__["Argument"])(Types.RingFingerprint, { isOptional: true }),
        'only-aromatic': Object(_symbol__WEBPACK_IMPORTED_MODULE_2__["Argument"])(_type__WEBPACK_IMPORTED_MODULE_0__["default"].Bool, { isOptional: true, defaultValue: false }),
    }), Types.ElementSelectionQuery, 'Return all rings or those with the specified fingerprint and/or only aromatic rings.'),
    queryInSelection: Object(_helpers__WEBPACK_IMPORTED_MODULE_3__["symbol"])(_symbol__WEBPACK_IMPORTED_MODULE_2__["Arguments"].Dictionary({
        0: Object(_symbol__WEBPACK_IMPORTED_MODULE_2__["Argument"])(Types.ElementSelectionQuery),
        query: Object(_symbol__WEBPACK_IMPORTED_MODULE_2__["Argument"])(Types.ElementSelectionQuery),
        'in-complement': Object(_symbol__WEBPACK_IMPORTED_MODULE_2__["Argument"])(_type__WEBPACK_IMPORTED_MODULE_0__["default"].Bool, { isOptional: true, defaultValue: false })
    }), Types.ElementSelectionQuery, 'Executes query only on atoms that are in the source selection.'),
    empty: Object(_helpers__WEBPACK_IMPORTED_MODULE_3__["symbol"])(_symbol__WEBPACK_IMPORTED_MODULE_2__["Arguments"].None, Types.ElementSelectionQuery, 'Nada.'),
};
var modifier = {
    '@header': 'Selection Modifications',
    queryEach: Object(_helpers__WEBPACK_IMPORTED_MODULE_3__["symbol"])(_symbol__WEBPACK_IMPORTED_MODULE_2__["Arguments"].Dictionary({
        0: Object(_symbol__WEBPACK_IMPORTED_MODULE_2__["Argument"])(Types.ElementSelectionQuery),
        query: Object(_symbol__WEBPACK_IMPORTED_MODULE_2__["Argument"])(Types.ElementSelectionQuery)
    }), Types.ElementSelectionQuery, 'Query every atom set in the input selection separately.'),
    intersectBy: Object(_helpers__WEBPACK_IMPORTED_MODULE_3__["symbol"])(_symbol__WEBPACK_IMPORTED_MODULE_2__["Arguments"].Dictionary({
        0: Object(_symbol__WEBPACK_IMPORTED_MODULE_2__["Argument"])(Types.ElementSelectionQuery),
        by: Object(_symbol__WEBPACK_IMPORTED_MODULE_2__["Argument"])(Types.ElementSelectionQuery)
    }), Types.ElementSelectionQuery, 'Intersect each atom set from the first sequence from atoms in the second one.'),
    exceptBy: Object(_helpers__WEBPACK_IMPORTED_MODULE_3__["symbol"])(_symbol__WEBPACK_IMPORTED_MODULE_2__["Arguments"].Dictionary({
        0: Object(_symbol__WEBPACK_IMPORTED_MODULE_2__["Argument"])(Types.ElementSelectionQuery),
        by: Object(_symbol__WEBPACK_IMPORTED_MODULE_2__["Argument"])(Types.ElementSelectionQuery)
    }), Types.ElementSelectionQuery, "Remove all atoms from 'selection' that occur in 'by'."),
    unionBy: Object(_helpers__WEBPACK_IMPORTED_MODULE_3__["symbol"])(_symbol__WEBPACK_IMPORTED_MODULE_2__["Arguments"].Dictionary({
        0: Object(_symbol__WEBPACK_IMPORTED_MODULE_2__["Argument"])(Types.ElementSelectionQuery),
        by: Object(_symbol__WEBPACK_IMPORTED_MODULE_2__["Argument"])(Types.ElementSelectionQuery)
    }), Types.ElementSelectionQuery, 'For each atom set A in the orginal sequence, combine all atoms sets in the target selection that intersect with A.'),
    union: Object(_helpers__WEBPACK_IMPORTED_MODULE_3__["symbol"])(_symbol__WEBPACK_IMPORTED_MODULE_2__["Arguments"].Dictionary({
        0: Object(_symbol__WEBPACK_IMPORTED_MODULE_2__["Argument"])(Types.ElementSelectionQuery)
    }), Types.ElementSelectionQuery, 'Collects all atom sets in the sequence into a single atom set.'),
    cluster: Object(_helpers__WEBPACK_IMPORTED_MODULE_3__["symbol"])(_symbol__WEBPACK_IMPORTED_MODULE_2__["Arguments"].Dictionary({
        0: Object(_symbol__WEBPACK_IMPORTED_MODULE_2__["Argument"])(Types.ElementSelectionQuery),
        'min-distance': Object(_symbol__WEBPACK_IMPORTED_MODULE_2__["Argument"])(_type__WEBPACK_IMPORTED_MODULE_0__["default"].Num, { isOptional: true, defaultValue: 0 }),
        'max-distance': Object(_symbol__WEBPACK_IMPORTED_MODULE_2__["Argument"])(_type__WEBPACK_IMPORTED_MODULE_0__["default"].Num),
        'min-size': Object(_symbol__WEBPACK_IMPORTED_MODULE_2__["Argument"])(_type__WEBPACK_IMPORTED_MODULE_0__["default"].Num, { description: 'Minimal number of sets to merge, must be at least 2', isOptional: true, defaultValue: 2 }),
        'max-size': Object(_symbol__WEBPACK_IMPORTED_MODULE_2__["Argument"])(_type__WEBPACK_IMPORTED_MODULE_0__["default"].Num, { description: 'Maximal number of sets to merge, if not set, no limit', isOptional: true }),
    }), Types.ElementSelectionQuery, 'Combines atom sets that have mutual distance in the interval [min-radius, max-radius]. Minimum/maximum size determines how many atom sets can be combined.'),
    includeSurroundings: Object(_helpers__WEBPACK_IMPORTED_MODULE_3__["symbol"])(_symbol__WEBPACK_IMPORTED_MODULE_2__["Arguments"].Dictionary({
        0: Object(_symbol__WEBPACK_IMPORTED_MODULE_2__["Argument"])(Types.ElementSelectionQuery),
        radius: Object(_symbol__WEBPACK_IMPORTED_MODULE_2__["Argument"])(_type__WEBPACK_IMPORTED_MODULE_0__["default"].Num),
        'atom-radius': Object(_symbol__WEBPACK_IMPORTED_MODULE_2__["Argument"])(_type__WEBPACK_IMPORTED_MODULE_0__["default"].Num, { isOptional: true, defaultValue: 0, description: 'Value added to each atom before the distance check, for example VDW radius. Using this argument is computationally demanding.' }),
        'as-whole-residues': Object(_symbol__WEBPACK_IMPORTED_MODULE_2__["Argument"])(_type__WEBPACK_IMPORTED_MODULE_0__["default"].Bool, { isOptional: true })
    }), Types.ElementSelectionQuery, 'For each atom set in the selection, include all surrouding atoms/residues that are within the specified radius.'),
    includeConnected: Object(_helpers__WEBPACK_IMPORTED_MODULE_3__["symbol"])(_symbol__WEBPACK_IMPORTED_MODULE_2__["Arguments"].Dictionary({
        0: Object(_symbol__WEBPACK_IMPORTED_MODULE_2__["Argument"])(Types.ElementSelectionQuery),
        'bond-test': Object(_symbol__WEBPACK_IMPORTED_MODULE_2__["Argument"])(_type__WEBPACK_IMPORTED_MODULE_0__["default"].Bool, { isOptional: true, defaultValue: 'true for covalent bonds' }),
        'layer-count': Object(_symbol__WEBPACK_IMPORTED_MODULE_2__["Argument"])(_type__WEBPACK_IMPORTED_MODULE_0__["default"].Num, { isOptional: true, defaultValue: 1, description: 'Number of bonded layers to include.' }),
        'as-whole-residues': Object(_symbol__WEBPACK_IMPORTED_MODULE_2__["Argument"])(_type__WEBPACK_IMPORTED_MODULE_0__["default"].Bool, { isOptional: true })
    }), Types.ElementSelectionQuery, 'Pick all atom sets that are connected to the target.'),
    wholeResidues: Object(_helpers__WEBPACK_IMPORTED_MODULE_3__["symbol"])(_symbol__WEBPACK_IMPORTED_MODULE_2__["Arguments"].Dictionary({
        0: Object(_symbol__WEBPACK_IMPORTED_MODULE_2__["Argument"])(Types.ElementSelectionQuery),
    }), Types.ElementSelectionQuery, 'Expand the selection to whole residues.'),
    expandProperty: Object(_helpers__WEBPACK_IMPORTED_MODULE_3__["symbol"])(_symbol__WEBPACK_IMPORTED_MODULE_2__["Arguments"].Dictionary({
        0: Object(_symbol__WEBPACK_IMPORTED_MODULE_2__["Argument"])(Types.ElementSelectionQuery),
        property: Object(_symbol__WEBPACK_IMPORTED_MODULE_2__["Argument"])(_type__WEBPACK_IMPORTED_MODULE_0__["default"].AnyValue)
    }), Types.ElementSelectionQuery, 'To each atom set in the selection, add all atoms that have the same property value that was already present in the set.')
};
var filter = {
    '@header': 'Selection Filters',
    pick: Object(_helpers__WEBPACK_IMPORTED_MODULE_3__["symbol"])(_symbol__WEBPACK_IMPORTED_MODULE_2__["Arguments"].Dictionary({
        0: Object(_symbol__WEBPACK_IMPORTED_MODULE_2__["Argument"])(Types.ElementSelectionQuery),
        test: Object(_symbol__WEBPACK_IMPORTED_MODULE_2__["Argument"])(_type__WEBPACK_IMPORTED_MODULE_0__["default"].Bool)
    }), Types.ElementSelectionQuery, 'Pick all atom sets that satisfy the test.'),
    first: Object(_helpers__WEBPACK_IMPORTED_MODULE_3__["symbol"])(_symbol__WEBPACK_IMPORTED_MODULE_2__["Arguments"].Dictionary({
        0: Object(_symbol__WEBPACK_IMPORTED_MODULE_2__["Argument"])(Types.ElementSelectionQuery)
    }), Types.ElementSelectionQuery, 'Take the 1st atom set in the sequence.'),
    withSameAtomProperties: Object(_helpers__WEBPACK_IMPORTED_MODULE_3__["symbol"])(_symbol__WEBPACK_IMPORTED_MODULE_2__["Arguments"].Dictionary({
        0: Object(_symbol__WEBPACK_IMPORTED_MODULE_2__["Argument"])(Types.ElementSelectionQuery),
        source: Object(_symbol__WEBPACK_IMPORTED_MODULE_2__["Argument"])(Types.ElementSelectionQuery),
        property: Object(_symbol__WEBPACK_IMPORTED_MODULE_2__["Argument"])(_type__WEBPACK_IMPORTED_MODULE_0__["default"].Any)
    }), Types.ElementSelectionQuery, 'Pick all atom sets for which the set of given atom properties is a subset of the source properties.'),
    intersectedBy: Object(_helpers__WEBPACK_IMPORTED_MODULE_3__["symbol"])(_symbol__WEBPACK_IMPORTED_MODULE_2__["Arguments"].Dictionary({
        0: Object(_symbol__WEBPACK_IMPORTED_MODULE_2__["Argument"])(Types.ElementSelectionQuery),
        by: Object(_symbol__WEBPACK_IMPORTED_MODULE_2__["Argument"])(Types.ElementSelectionQuery)
    }), Types.ElementSelectionQuery, 'Pick all atom sets that have non-zero intersection with the target.'),
    within: Object(_helpers__WEBPACK_IMPORTED_MODULE_3__["symbol"])(_symbol__WEBPACK_IMPORTED_MODULE_2__["Arguments"].Dictionary({
        0: Object(_symbol__WEBPACK_IMPORTED_MODULE_2__["Argument"])(Types.ElementSelectionQuery),
        target: Object(_symbol__WEBPACK_IMPORTED_MODULE_2__["Argument"])(Types.ElementSelectionQuery),
        'min-radius': Object(_symbol__WEBPACK_IMPORTED_MODULE_2__["Argument"])(_type__WEBPACK_IMPORTED_MODULE_0__["default"].Num, { isOptional: true, defaultValue: 0 }),
        'max-radius': Object(_symbol__WEBPACK_IMPORTED_MODULE_2__["Argument"])(_type__WEBPACK_IMPORTED_MODULE_0__["default"].Num),
        'atom-radius': Object(_symbol__WEBPACK_IMPORTED_MODULE_2__["Argument"])(_type__WEBPACK_IMPORTED_MODULE_0__["default"].Num, { isOptional: true, defaultValue: 0, description: 'Value added to each atom before the distance check, for example VDW radius. Using this argument is computationally demanding.' }),
        invert: Object(_symbol__WEBPACK_IMPORTED_MODULE_2__["Argument"])(_type__WEBPACK_IMPORTED_MODULE_0__["default"].Bool, { isOptional: true, defaultValue: false, description: 'If true, pick only atom sets that are further than the specified radius.' }),
    }), Types.ElementSelectionQuery, 'Pick all atom sets from selection that have any atom within the radius of any atom from target.'),
    isConnectedTo: Object(_helpers__WEBPACK_IMPORTED_MODULE_3__["symbol"])(_symbol__WEBPACK_IMPORTED_MODULE_2__["Arguments"].Dictionary({
        0: Object(_symbol__WEBPACK_IMPORTED_MODULE_2__["Argument"])(Types.ElementSelectionQuery),
        target: Object(_symbol__WEBPACK_IMPORTED_MODULE_2__["Argument"])(Types.ElementSelectionQuery),
        'bond-test': Object(_symbol__WEBPACK_IMPORTED_MODULE_2__["Argument"])(_type__WEBPACK_IMPORTED_MODULE_0__["default"].Bool, { isOptional: true, defaultValue: 'true for covalent bonds' }),
        disjunct: Object(_symbol__WEBPACK_IMPORTED_MODULE_2__["Argument"])(_type__WEBPACK_IMPORTED_MODULE_0__["default"].Bool, { isOptional: true, defaultValue: true, description: 'If true, there must exist a bond to an atom that lies outside the given atom set to pass test.' }),
        invert: Object(_symbol__WEBPACK_IMPORTED_MODULE_2__["Argument"])(_type__WEBPACK_IMPORTED_MODULE_0__["default"].Bool, { isOptional: true, defaultValue: false, description: 'If true, return atom sets that are not connected.' })
    }), Types.ElementSelectionQuery, 'Pick all atom sets that are connected to the target.'),
};
var combinator = {
    '@header': 'Selection Combinators',
    intersect: Object(_helpers__WEBPACK_IMPORTED_MODULE_3__["symbol"])(_symbol__WEBPACK_IMPORTED_MODULE_2__["Arguments"].List(Types.ElementSelectionQuery), Types.ElementSelectionQuery, 'Return all unique atom sets that appear in all of the source selections.'),
    merge: Object(_helpers__WEBPACK_IMPORTED_MODULE_3__["symbol"])(_symbol__WEBPACK_IMPORTED_MODULE_2__["Arguments"].List(Types.ElementSelectionQuery), Types.ElementSelectionQuery, 'Merges multiple selections into a single one. Only unique atom sets are kept.'),
    distanceCluster: Object(_helpers__WEBPACK_IMPORTED_MODULE_3__["symbol"])(_symbol__WEBPACK_IMPORTED_MODULE_2__["Arguments"].Dictionary({
        matrix: Object(_symbol__WEBPACK_IMPORTED_MODULE_2__["Argument"])(_core__WEBPACK_IMPORTED_MODULE_1__["Types"].List(_core__WEBPACK_IMPORTED_MODULE_1__["Types"].List(_type__WEBPACK_IMPORTED_MODULE_0__["default"].Num)), { description: 'Distance matrix, represented as list of rows (num[][])). Lower triangle is min distance, upper triangle is max distance.' }),
        selections: Object(_symbol__WEBPACK_IMPORTED_MODULE_2__["Argument"])(_core__WEBPACK_IMPORTED_MODULE_1__["Types"].List(Types.ElementSelectionQuery), { description: 'A list of held selections.' })
    }), Types.ElementSelectionQuery, 'Pick combinations of atom sets from the source sequences that are mutually within distances specified by a matrix.')
};
var atomSet = {
    '@header': 'Atom Sets',
    atomCount: Object(_helpers__WEBPACK_IMPORTED_MODULE_3__["symbol"])(_symbol__WEBPACK_IMPORTED_MODULE_2__["Arguments"].None, _type__WEBPACK_IMPORTED_MODULE_0__["default"].Num),
    countQuery: Object(_helpers__WEBPACK_IMPORTED_MODULE_3__["symbol"])(_symbol__WEBPACK_IMPORTED_MODULE_2__["Arguments"].Dictionary({
        0: Object(_symbol__WEBPACK_IMPORTED_MODULE_2__["Argument"])(Types.ElementSelectionQuery)
    }), _type__WEBPACK_IMPORTED_MODULE_0__["default"].Num, 'Counts the number of occurences of a specific query inside the current atom set.'),
    reduce: Object(_helpers__WEBPACK_IMPORTED_MODULE_3__["symbol"])(_symbol__WEBPACK_IMPORTED_MODULE_2__["Arguments"].Dictionary({
        initial: Object(_symbol__WEBPACK_IMPORTED_MODULE_2__["Argument"])(_type__WEBPACK_IMPORTED_MODULE_0__["default"].Variable('a', _type__WEBPACK_IMPORTED_MODULE_0__["default"].AnyValue, true), { description: 'Initial value assigned to slot.atom-set-reduce. Current atom is set to the 1st atom of the current set for this.' }),
        value: Object(_symbol__WEBPACK_IMPORTED_MODULE_2__["Argument"])(_type__WEBPACK_IMPORTED_MODULE_0__["default"].Variable('a', _type__WEBPACK_IMPORTED_MODULE_0__["default"].AnyValue, true), { description: 'Expression executed for each atom in the set' })
    }), _type__WEBPACK_IMPORTED_MODULE_0__["default"].Variable('a', _type__WEBPACK_IMPORTED_MODULE_0__["default"].AnyValue, true), 'Execute the value expression for each atom in the current atom set and return the result. Works the same way as Array.reduce in JavaScript (``result = value(value(...value(initial)))``)'),
    propertySet: Object(_helpers__WEBPACK_IMPORTED_MODULE_3__["symbol"])(_symbol__WEBPACK_IMPORTED_MODULE_2__["Arguments"].Dictionary({
        0: Object(_symbol__WEBPACK_IMPORTED_MODULE_2__["Argument"])(_core__WEBPACK_IMPORTED_MODULE_1__["Types"].ConstrainedVar),
    }), _core__WEBPACK_IMPORTED_MODULE_1__["Types"].Set(_core__WEBPACK_IMPORTED_MODULE_1__["Types"].ConstrainedVar), 'Returns a set with all values of the given property in the current atom set.'),
};
var atomProperty = {
    '@header': 'Atom Properties',
    core: {
        '@header': 'Core Properties',
        elementSymbol: atomProp(Types.ElementSymbol),
        vdw: atomProp(_type__WEBPACK_IMPORTED_MODULE_0__["default"].Num, 'Van der Waals radius'),
        mass: atomProp(_type__WEBPACK_IMPORTED_MODULE_0__["default"].Num, 'Atomic weight'),
        atomicNumber: atomProp(_type__WEBPACK_IMPORTED_MODULE_0__["default"].Num, 'Atomic number'),
        x: atomProp(_type__WEBPACK_IMPORTED_MODULE_0__["default"].Num, 'Cartesian X coordinate'),
        y: atomProp(_type__WEBPACK_IMPORTED_MODULE_0__["default"].Num, 'Cartesian Y coordinate'),
        z: atomProp(_type__WEBPACK_IMPORTED_MODULE_0__["default"].Num, 'Cartesian Z coordinate'),
        atomKey: atomProp(_type__WEBPACK_IMPORTED_MODULE_0__["default"].AnyValue, 'Unique value for each atom. Main use case is grouping of atoms.'),
        bondCount: Object(_helpers__WEBPACK_IMPORTED_MODULE_3__["symbol"])(_symbol__WEBPACK_IMPORTED_MODULE_2__["Arguments"].Dictionary({
            0: Object(_symbol__WEBPACK_IMPORTED_MODULE_2__["Argument"])(Types.ElementReference, { isOptional: true, defaultValue: 'slot.current-atom' }),
            flags: Object(_symbol__WEBPACK_IMPORTED_MODULE_2__["Argument"])(Types.BondFlags, { isOptional: true, defaultValue: 'covalent' }),
        }), _type__WEBPACK_IMPORTED_MODULE_0__["default"].Num, 'Number of bonds (by default only covalent bonds are counted).'),
        sourceIndex: atomProp(_type__WEBPACK_IMPORTED_MODULE_0__["default"].Num, 'Index of the atom/element in the input file.'),
        operatorName: atomProp(_type__WEBPACK_IMPORTED_MODULE_0__["default"].Str, 'Name of the symmetry operator applied to this element.'),
        modelIndex: atomProp(_type__WEBPACK_IMPORTED_MODULE_0__["default"].Num, 'Index of the model in the input file.'),
        modelLabel: atomProp(_type__WEBPACK_IMPORTED_MODULE_0__["default"].Str, 'Label/header of the model in the input file.')
    },
    topology: {
        connectedComponentKey: atomProp(_type__WEBPACK_IMPORTED_MODULE_0__["default"].AnyValue, 'Unique value for each connected component.')
    },
    macromolecular: {
        '@header': 'Macromolecular Properties (derived from the mmCIF format)',
        authResidueId: atomProp(Types.ResidueId, "type.auth-residue-id symbol executed on current atom's residue"),
        labelResidueId: atomProp(Types.ResidueId, "type.label-residue-id symbol executed on current atom's residue"),
        residueKey: atomProp(_type__WEBPACK_IMPORTED_MODULE_0__["default"].AnyValue, 'Unique value for each tuple ``(label_entity_id,auth_asym_id, auth_seq_id, pdbx_PDB_ins_code)``, main use case is grouping of atoms'),
        chainKey: atomProp(_type__WEBPACK_IMPORTED_MODULE_0__["default"].AnyValue, 'Unique value for each tuple ``(label_entity_id, auth_asym_id)``, main use case is grouping of atoms'),
        entityKey: atomProp(_type__WEBPACK_IMPORTED_MODULE_0__["default"].AnyValue, 'Unique value for each tuple ``label_entity_id``, main use case is grouping of atoms'),
        isHet: atomProp(_type__WEBPACK_IMPORTED_MODULE_0__["default"].Bool, 'Equivalent to atom_site.group_PDB !== ATOM'),
        id: atomProp(_type__WEBPACK_IMPORTED_MODULE_0__["default"].Num, '_atom_site.id'),
        label_atom_id: atomProp(Types.AtomName),
        label_alt_id: atomProp(_type__WEBPACK_IMPORTED_MODULE_0__["default"].Str),
        label_comp_id: atomProp(_type__WEBPACK_IMPORTED_MODULE_0__["default"].Str),
        label_asym_id: atomProp(_type__WEBPACK_IMPORTED_MODULE_0__["default"].Str),
        label_entity_id: atomProp(_type__WEBPACK_IMPORTED_MODULE_0__["default"].Str),
        label_seq_id: atomProp(_type__WEBPACK_IMPORTED_MODULE_0__["default"].Num),
        auth_atom_id: atomProp(Types.AtomName),
        auth_comp_id: atomProp(_type__WEBPACK_IMPORTED_MODULE_0__["default"].Str),
        auth_asym_id: atomProp(_type__WEBPACK_IMPORTED_MODULE_0__["default"].Str),
        auth_seq_id: atomProp(_type__WEBPACK_IMPORTED_MODULE_0__["default"].Num),
        pdbx_PDB_ins_code: atomProp(_type__WEBPACK_IMPORTED_MODULE_0__["default"].Str),
        pdbx_formal_charge: atomProp(_type__WEBPACK_IMPORTED_MODULE_0__["default"].Num),
        occupancy: atomProp(_type__WEBPACK_IMPORTED_MODULE_0__["default"].Num),
        B_iso_or_equiv: atomProp(_type__WEBPACK_IMPORTED_MODULE_0__["default"].Num),
        entityType: atomProp(Types.EntityType, 'Type of the entity as defined in mmCIF (polymer, non-polymer, branched, water)'),
        entitySubtype: atomProp(Types.EntitySubtype, 'Subtype of the entity as defined in mmCIF _entity_poly.type and _pdbx_entity_branch.type (other, polypeptide(D), polypeptide(L), polydeoxyribonucleotide, polyribonucleotide, polydeoxyribonucleotide/polyribonucleotide hybrid, cyclic-pseudo-peptide, peptide nucleic acid, oligosaccharide)'),
        entityPrdId: atomProp(_type__WEBPACK_IMPORTED_MODULE_0__["default"].Str, "The PRD ID of the entity."),
        entityDescription: atomProp(_core__WEBPACK_IMPORTED_MODULE_1__["Types"].List(_type__WEBPACK_IMPORTED_MODULE_0__["default"].Str)),
        objectPrimitive: atomProp(Types.ObjectPrimitive, 'Type of the primitive object used to model this segment as defined in mmCIF/IHM (atomistic, sphere, gaussian, other)'),
        secondaryStructureKey: atomProp(_type__WEBPACK_IMPORTED_MODULE_0__["default"].AnyValue, 'Unique value for each secondary structure element.'),
        secondaryStructureFlags: atomProp(Types.SecondaryStructureFlags),
        isModified: atomProp(_type__WEBPACK_IMPORTED_MODULE_0__["default"].Bool, 'True if the atom belongs to modification of a standard residue.'),
        modifiedParentName: atomProp(_type__WEBPACK_IMPORTED_MODULE_0__["default"].Str, "'3-letter' code of the modifed parent residue."),
        isNonStandard: atomProp(_type__WEBPACK_IMPORTED_MODULE_0__["default"].Bool, 'True if this is a non-standard residue.'),
        chemCompType: atomProp(_type__WEBPACK_IMPORTED_MODULE_0__["default"].Str, "Type of the chemical component as defined in mmCIF."),
    }
};
var bondProperty = {
    '@header': 'Bond Properties',
    flags: bondProp(Types.BondFlags),
    order: bondProp(_type__WEBPACK_IMPORTED_MODULE_0__["default"].Num),
    length: bondProp(_type__WEBPACK_IMPORTED_MODULE_0__["default"].Num),
    atomA: bondProp(Types.ElementReference),
    atomB: bondProp(Types.ElementReference)
};
function atomProp(type, description) {
    return Object(_helpers__WEBPACK_IMPORTED_MODULE_3__["symbol"])(_symbol__WEBPACK_IMPORTED_MODULE_2__["Arguments"].Dictionary({ 0: Object(_symbol__WEBPACK_IMPORTED_MODULE_2__["Argument"])(Types.ElementReference, { isOptional: true, defaultValue: 'slot.current-atom' }) }), type, description);
}
function bondProp(type, description) {
    return Object(_helpers__WEBPACK_IMPORTED_MODULE_3__["symbol"])(_symbol__WEBPACK_IMPORTED_MODULE_2__["Arguments"].None, type, description);
}
/* harmony default export */ __webpack_exports__["default"] = ({
    '@header': 'Structure Queries',
    type: type,
    slot: slot,
    generator: generator,
    modifier: modifier,
    filter: filter,
    combinator: combinator,
    atomSet: atomSet,
    atomProperty: atomProperty,
    bondProperty: bondProperty
});
//# sourceMappingURL=structure-query.js.map

/***/ }),

/***/ "./lib/mol-script/language/symbol.js":
/*!*******************************************!*\
  !*** ./lib/mol-script/language/symbol.js ***!
  \*******************************************/
/*! exports provided: Argument, Arguments, MSymbol, CustomPropSymbol, isSymbol */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Argument", function() { return Argument; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Arguments", function() { return Arguments; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MSymbol", function() { return MSymbol; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CustomPropSymbol", function() { return CustomPropSymbol; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isSymbol", function() { return isSymbol; });
/* harmony import */ var _expression__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./expression */ "./lib/mol-script/language/expression.js");
/*
 * Copyright (c) 2018 Mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author David Sehnal <david.sehnal@gmail.com>
 */

function Argument(type, params) {
    var _a = params || {}, _b = _a.description, description = _b === void 0 ? void 0 : _b, _c = _a.isOptional, isOptional = _c === void 0 ? false : _c, _d = _a.isRest, isRest = _d === void 0 ? false : _d, _e = _a.defaultValue, defaultValue = _e === void 0 ? void 0 : _e;
    return { type: type, isOptional: isOptional, isRest: isRest, defaultValue: defaultValue, description: description };
}
var Arguments;
(function (Arguments) {
    Arguments.None = Dictionary({});
    function Dictionary(map) {
        return { kind: 'dictionary', map: map, '@type': 0 };
    }
    Arguments.Dictionary = Dictionary;
    function List(type, params) {
        var _a = (params || {}).nonEmpty, nonEmpty = _a === void 0 ? false : _a;
        return { kind: 'list', type: type, nonEmpty: nonEmpty, '@type': 0 };
    }
    Arguments.List = List;
})(Arguments || (Arguments = {}));
function MSymbol(name, args, type, description) {
    var symbol = function (args) {
        return _expression__WEBPACK_IMPORTED_MODULE_0__["default"].Apply(_expression__WEBPACK_IMPORTED_MODULE_0__["default"].Symbol(symbol.id), args);
    };
    symbol.info = { namespace: '', name: name, description: description };
    symbol.id = '';
    symbol.args = args;
    symbol.type = type;
    return symbol;
}
function CustomPropSymbol(namespace, name, type, description) {
    var symbol = function (args) {
        return _expression__WEBPACK_IMPORTED_MODULE_0__["default"].Apply(_expression__WEBPACK_IMPORTED_MODULE_0__["default"].Symbol(symbol.id), args);
    };
    symbol.info = { namespace: namespace, name: name, description: description };
    symbol.id = namespace + "." + name;
    symbol.args = Arguments.None;
    symbol.type = type;
    return symbol;
}
function isSymbol(x) {
    var s = x;
    return typeof s === 'function' && !!s.info && !!s.args && typeof s.info.namespace === 'string' && !!s.type;
}
//# sourceMappingURL=symbol.js.map

/***/ }),

/***/ "./lib/mol-script/language/type.js":
/*!*****************************************!*\
  !*** ./lib/mol-script/language/type.js ***!
  \*****************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/*
 * Copyright (c) 2018 Mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author David Sehnal <david.sehnal@gmail.com>
 */
var Type;
(function (Type) {
    function Variable(name, type, isConstraint) { return { kind: 'variable', name: name, type: type, isConstraint: isConstraint }; }
    Type.Variable = Variable;
    function Value(namespace, name, parent) { return { kind: 'value', namespace: namespace, name: name, parent: parent }; }
    Type.Value = Value;
    function Container(namespace, name, child, alias) { return { kind: 'container', namespace: namespace, name: name, child: child, alias: alias }; }
    Type.Container = Container;
    function Union(types) { return { kind: 'union', types: types }; }
    Type.Union = Union;
    function OneOf(namespace, name, type, values) {
        var vals = Object.create(null);
        for (var _i = 0, values_1 = values; _i < values_1.length; _i++) {
            var v = values_1[_i];
            vals[v] = true;
        }
        return { kind: 'oneof', namespace: namespace, name: name, type: type, values: vals };
    }
    Type.OneOf = OneOf;
    Type.Any = { kind: 'any' };
    Type.AnyValue = { kind: 'any-value' };
    Type.Num = Value('', 'Number');
    Type.Str = Value('', 'String');
    Type.Bool = OneOf('', 'Bool', Type.Str, ['true', 'false']);
    function oneOfValues(_a) {
        var values = _a.values;
        return Object.keys(values).sort();
    }
    Type.oneOfValues = oneOfValues;
})(Type || (Type = {}));
/* harmony default export */ __webpack_exports__["default"] = (Type);
//# sourceMappingURL=type.js.map

/***/ }),

/***/ "./lib/mol-script/runtime/query/base.js":
/*!**********************************************!*\
  !*** ./lib/mol-script/runtime/query/base.js ***!
  \**********************************************/
/*! exports provided: QueryRuntimeTable, DefaultQueryRuntimeTable, QueryCompilerCtx, QueryCompiledSymbol, CompiledQueryFn, QueryRuntimeArguments, QuerySymbolRuntime, compile */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "QueryRuntimeTable", function() { return QueryRuntimeTable; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DefaultQueryRuntimeTable", function() { return DefaultQueryRuntimeTable; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "QueryCompilerCtx", function() { return QueryCompilerCtx; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "QueryCompiledSymbol", function() { return QueryCompiledSymbol; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CompiledQueryFn", function() { return CompiledQueryFn; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "QueryRuntimeArguments", function() { return QueryRuntimeArguments; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "QuerySymbolRuntime", function() { return QuerySymbolRuntime; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "compile", function() { return compile; });
/* harmony import */ var _language_expression__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../language/expression */ "./lib/mol-script/language/expression.js");
/* harmony import */ var _mol_model_structure__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../../mol-model/structure */ "./lib/mol-model/structure.js");
/**
 * Copyright (c) 2018 Mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author David Sehnal <david.sehnal@gmail.com>
 */


var QueryRuntimeTable = /** @class */ (function () {
    function QueryRuntimeTable() {
        this.map = new Map();
    }
    QueryRuntimeTable.prototype.removeSymbol = function (runtime) {
        this.map.delete(runtime.symbol.id);
    };
    QueryRuntimeTable.prototype.addSymbol = function (runtime) {
        if (this.map.has(runtime.symbol.id)) {
            console.warn("Symbol '" + runtime.symbol.id + "' already added. Call removeSymbol/removeCustomProps re-adding the symbol.");
        }
        this.map.set(runtime.symbol.id, runtime);
    };
    QueryRuntimeTable.prototype.addCustomProp = function (desc) {
        if (!desc.symbols)
            return;
        for (var _a = 0, _b = Object.keys(desc.symbols); _a < _b.length; _a++) {
            var k = _b[_a];
            this.addSymbol(desc.symbols[k]);
        }
    };
    QueryRuntimeTable.prototype.removeCustomProp = function (desc) {
        if (!desc.symbols)
            return;
        for (var _a = 0, _b = Object.keys(desc.symbols); _a < _b.length; _a++) {
            var k = _b[_a];
            this.removeSymbol(desc.symbols[k]);
        }
    };
    QueryRuntimeTable.prototype.getRuntime = function (id) {
        return this.map.get(id);
    };
    return QueryRuntimeTable;
}());

var DefaultQueryRuntimeTable = new QueryRuntimeTable();
var QueryCompilerCtx = /** @class */ (function () {
    function QueryCompilerCtx(table) {
        this.table = table;
        this.constQueryContext = new _mol_model_structure__WEBPACK_IMPORTED_MODULE_1__["QueryContext"](_mol_model_structure__WEBPACK_IMPORTED_MODULE_1__["Structure"].Empty);
    }
    return QueryCompilerCtx;
}());

var QueryCompiledSymbol;
(function (QueryCompiledSymbol) {
    function Const(value) {
        return { kind: 'const', value: value };
    }
    QueryCompiledSymbol.Const = Const;
    function Dynamic(runtime) {
        return { kind: 'dynamic', runtime: runtime };
    }
    QueryCompiledSymbol.Dynamic = Dynamic;
})(QueryCompiledSymbol || (QueryCompiledSymbol = {}));
var CompiledQueryFn;
(function (CompiledQueryFn) {
    function Const(value) {
        return { isConst: true, fn: function CompiledQueryFn_Const(ctx) { return value; } };
    }
    CompiledQueryFn.Const = Const;
    function Dynamic(fn) {
        return { isConst: false, fn: fn };
    }
    CompiledQueryFn.Dynamic = Dynamic;
})(CompiledQueryFn || (CompiledQueryFn = {}));
var QueryRuntimeArguments;
(function (QueryRuntimeArguments) {
    function forEachEval(xs, queryCtx, f, ctx) {
        if (typeof xs.length === 'number') {
            for (var i = 0, _i = xs.length; i < _i; i++)
                f(xs[i](queryCtx), i, ctx);
        }
        else {
            var i = 0;
            for (var _a = 0, _b = Object.keys(xs); _a < _b.length; _a++) {
                var k = _b[_a];
                f(xs[k](queryCtx), i++, ctx);
            }
        }
        return ctx;
    }
    QueryRuntimeArguments.forEachEval = forEachEval;
})(QueryRuntimeArguments || (QueryRuntimeArguments = {}));
var QuerySymbolRuntime;
(function (QuerySymbolRuntime) {
    function Const(symbol, fn) {
        return new SymbolRuntimeImpl(symbol, fn, true);
    }
    QuerySymbolRuntime.Const = Const;
    function Dynamic(symbol, fn) {
        return new SymbolRuntimeImpl(symbol, fn, false);
    }
    QuerySymbolRuntime.Dynamic = Dynamic;
})(QuerySymbolRuntime || (QuerySymbolRuntime = {}));
var SymbolRuntimeImpl = /** @class */ (function () {
    function SymbolRuntimeImpl(symbol, fn, isConst) {
        this.symbol = symbol;
        this.fn = fn;
        this.isConst = isConst;
    }
    SymbolRuntimeImpl.prototype.compile = function (ctx, inputArgs) {
        var args, constArgs = false;
        if (!inputArgs) {
            args = void 0;
            constArgs = true;
        }
        else if (_language_expression__WEBPACK_IMPORTED_MODULE_0__["default"].isArgumentsArray(inputArgs)) {
            args = [];
            constArgs = false;
            for (var _a = 0, inputArgs_1 = inputArgs; _a < inputArgs_1.length; _a++) {
                var arg = inputArgs_1[_a];
                var compiled = _compile(ctx, arg);
                constArgs = constArgs && compiled.isConst;
                args.push(compiled.fn);
            }
        }
        else {
            args = Object.create(null);
            constArgs = false;
            for (var _b = 0, _c = Object.keys(inputArgs); _b < _c.length; _b++) {
                var key = _c[_b];
                var compiled = _compile(ctx, inputArgs[key]);
                constArgs = constArgs && compiled.isConst;
                args[key] = compiled.fn;
            }
        }
        if (this.isConst) {
            if (this.isConst && constArgs) {
                return CompiledQueryFn.Const(this.fn(ctx.constQueryContext, args));
            }
            return CompiledQueryFn.Dynamic(createDynamicFn(this.fn, args));
        }
        return CompiledQueryFn.Dynamic(createDynamicFn(this.fn, args));
    };
    return SymbolRuntimeImpl;
}());
function createDynamicFn(fn, args) {
    return function DynamicFn(ctx) { return fn(ctx, args); };
}
function _compile(ctx, expression) {
    if (_language_expression__WEBPACK_IMPORTED_MODULE_0__["default"].isLiteral(expression)) {
        return CompiledQueryFn.Const(expression);
    }
    if (_language_expression__WEBPACK_IMPORTED_MODULE_0__["default"].isSymbol(expression)) {
        var runtime = ctx.table.getRuntime(expression.name);
        if (!runtime)
            return CompiledQueryFn.Const(expression.name);
        return runtime.compile(ctx);
    }
    if (!_language_expression__WEBPACK_IMPORTED_MODULE_0__["default"].isSymbol(expression.head)) {
        throw new Error('Can only apply symbols.');
    }
    var compiler = ctx.table.getRuntime(expression.head.name);
    if (!compiler) {
        throw new Error("Symbol '" + expression.head.name + "' is not implemented.");
    }
    return compiler.compile(ctx, expression.args);
}
function compile(expression) {
    var ctx = new QueryCompilerCtx(DefaultQueryRuntimeTable);
    return _compile(ctx, expression).fn;
}
//# sourceMappingURL=base.js.map

/***/ }),

/***/ "./lib/mol-script/runtime/query/compiler.js":
/*!**************************************************!*\
  !*** ./lib/mol-script/runtime/query/compiler.js ***!
  \**************************************************/
/*! exports provided: QueryRuntimeTable, DefaultQueryRuntimeTable, QueryCompilerCtx, QueryCompiledSymbol, CompiledQueryFn, QueryRuntimeArguments, QuerySymbolRuntime, compile */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _base__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./base */ "./lib/mol-script/runtime/query/base.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "QueryRuntimeTable", function() { return _base__WEBPACK_IMPORTED_MODULE_0__["QueryRuntimeTable"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "DefaultQueryRuntimeTable", function() { return _base__WEBPACK_IMPORTED_MODULE_0__["DefaultQueryRuntimeTable"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "QueryCompilerCtx", function() { return _base__WEBPACK_IMPORTED_MODULE_0__["QueryCompilerCtx"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "QueryCompiledSymbol", function() { return _base__WEBPACK_IMPORTED_MODULE_0__["QueryCompiledSymbol"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "CompiledQueryFn", function() { return _base__WEBPACK_IMPORTED_MODULE_0__["CompiledQueryFn"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "QueryRuntimeArguments", function() { return _base__WEBPACK_IMPORTED_MODULE_0__["QueryRuntimeArguments"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "QuerySymbolRuntime", function() { return _base__WEBPACK_IMPORTED_MODULE_0__["QuerySymbolRuntime"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "compile", function() { return _base__WEBPACK_IMPORTED_MODULE_0__["compile"]; });

/* harmony import */ var _table__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./table */ "./lib/mol-script/runtime/query/table.js");
/**
 * Copyright (c) 2018 Mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author David Sehnal <david.sehnal@gmail.com>
 */


//# sourceMappingURL=compiler.js.map

/***/ }),

/***/ "./lib/mol-script/runtime/query/table.js":
/*!***********************************************!*\
  !*** ./lib/mol-script/runtime/query/table.js ***!
  \***********************************************/
/*! no exports provided */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _language_symbol_table__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../language/symbol-table */ "./lib/mol-script/language/symbol-table.js");
/* harmony import */ var _base__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./base */ "./lib/mol-script/runtime/query/base.js");
/* harmony import */ var _mol_model_structure__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../../mol-model/structure */ "./lib/mol-model/structure.js");
/* harmony import */ var _mol_model_structure_model_types__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../../mol-model/structure/model/types */ "./lib/mol-model/structure/model/types.js");
/* harmony import */ var _mol_util_set__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../../mol-util/set */ "./lib/mol-util/set.js");
/* harmony import */ var _mol_util_string__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../../mol-util/string */ "./lib/mol-util/string.js");
/* harmony import */ var _mol_model_structure_model_properties_atomic__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../../../mol-model/structure/model/properties/atomic */ "./lib/mol-model/structure/model/properties/atomic.js");
/* harmony import */ var _mol_data_util__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../../../mol-data/util */ "./lib/mol-data/util.js");
/* harmony import */ var _mol_model_structure_query_queries_internal__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ../../../mol-model/structure/query/queries/internal */ "./lib/mol-model/structure/query/queries/internal.js");
/* harmony import */ var _mol_util_array__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ../../../mol-util/array */ "./lib/mol-util/array.js");
/**
 * Copyright (c) 2018-2019 Mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author David Sehnal <david.sehnal@gmail.com>
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */










var C = _base__WEBPACK_IMPORTED_MODULE_1__["QuerySymbolRuntime"].Const;
var D = _base__WEBPACK_IMPORTED_MODULE_1__["QuerySymbolRuntime"].Dynamic;
var symbols = [
    // ============= TYPES =============
    C(_language_symbol_table__WEBPACK_IMPORTED_MODULE_0__["MolScriptSymbolTable"].core.type.bool, function core_type_bool(ctx, v) { return !!v[0](ctx); }),
    C(_language_symbol_table__WEBPACK_IMPORTED_MODULE_0__["MolScriptSymbolTable"].core.type.num, function core_type_num(ctx, v) { return +v[0](ctx); }),
    C(_language_symbol_table__WEBPACK_IMPORTED_MODULE_0__["MolScriptSymbolTable"].core.type.str, function core_type_str(ctx, v) { return '' + v[0](ctx); }),
    C(_language_symbol_table__WEBPACK_IMPORTED_MODULE_0__["MolScriptSymbolTable"].core.type.list, function core_type_list(ctx, xs) { return _base__WEBPACK_IMPORTED_MODULE_1__["QueryRuntimeArguments"].forEachEval(xs, ctx, function (v, i, list) { return list[i] = v; }, []); }),
    C(_language_symbol_table__WEBPACK_IMPORTED_MODULE_0__["MolScriptSymbolTable"].core.type.set, function core_type_set(ctx, xs) { return _base__WEBPACK_IMPORTED_MODULE_1__["QueryRuntimeArguments"].forEachEval(xs, ctx, function core_type_set_argEval(v, i, set) { return set.add(v); }, new Set()); }),
    C(_language_symbol_table__WEBPACK_IMPORTED_MODULE_0__["MolScriptSymbolTable"].core.type.regex, function core_type_regex(ctx, v) { return new RegExp(v[0](ctx), (v[1] && v[1](ctx)) || ''); }),
    C(_language_symbol_table__WEBPACK_IMPORTED_MODULE_0__["MolScriptSymbolTable"].core.type.bitflags, function core_type_bitflags(ctx, v) { return +v[0](ctx); }),
    C(_language_symbol_table__WEBPACK_IMPORTED_MODULE_0__["MolScriptSymbolTable"].core.type.compositeKey, function core_type_compositeKey(ctx, xs) { return _base__WEBPACK_IMPORTED_MODULE_1__["QueryRuntimeArguments"].forEachEval(xs, ctx, function (v, i, list) { return list[i] = '' + v; }, []).join('-'); }),
    // ============= LOGIC ================
    C(_language_symbol_table__WEBPACK_IMPORTED_MODULE_0__["MolScriptSymbolTable"].core.logic.not, function (ctx, v) { return !v[0](ctx); }),
    C(_language_symbol_table__WEBPACK_IMPORTED_MODULE_0__["MolScriptSymbolTable"].core.logic.and, function (ctx, xs) {
        if (typeof xs.length === 'number') {
            for (var i = 0, _i = xs.length; i < _i; i++)
                if (!xs[i](ctx))
                    return false;
        }
        else {
            for (var _a = 0, _b = Object.keys(xs); _a < _b.length; _a++) {
                var k = _b[_a];
                if (!xs[k](ctx))
                    return false;
            }
        }
        return true;
    }),
    C(_language_symbol_table__WEBPACK_IMPORTED_MODULE_0__["MolScriptSymbolTable"].core.logic.or, function (ctx, xs) {
        if (typeof xs.length === 'number') {
            for (var i = 0, _i = xs.length; i < _i; i++)
                if (xs[i](ctx))
                    return true;
        }
        else {
            for (var _a = 0, _b = Object.keys(xs); _a < _b.length; _a++) {
                var k = _b[_a];
                if (xs[k](ctx))
                    return true;
            }
        }
        return false;
    }),
    // ============= RELATIONAL ================
    C(_language_symbol_table__WEBPACK_IMPORTED_MODULE_0__["MolScriptSymbolTable"].core.rel.eq, function (ctx, v) { return v[0](ctx) === v[1](ctx); }),
    C(_language_symbol_table__WEBPACK_IMPORTED_MODULE_0__["MolScriptSymbolTable"].core.rel.neq, function (ctx, v) { return v[0](ctx) !== v[1](ctx); }),
    C(_language_symbol_table__WEBPACK_IMPORTED_MODULE_0__["MolScriptSymbolTable"].core.rel.lt, function (ctx, v) { return v[0](ctx) < v[1](ctx); }),
    C(_language_symbol_table__WEBPACK_IMPORTED_MODULE_0__["MolScriptSymbolTable"].core.rel.lte, function (ctx, v) { return v[0](ctx) <= v[1](ctx); }),
    C(_language_symbol_table__WEBPACK_IMPORTED_MODULE_0__["MolScriptSymbolTable"].core.rel.gr, function (ctx, v) { return v[0](ctx) > v[1](ctx); }),
    C(_language_symbol_table__WEBPACK_IMPORTED_MODULE_0__["MolScriptSymbolTable"].core.rel.gre, function (ctx, v) { return v[0](ctx) >= v[1](ctx); }),
    C(_language_symbol_table__WEBPACK_IMPORTED_MODULE_0__["MolScriptSymbolTable"].core.rel.inRange, function (ctx, v) {
        var x = v[0](ctx);
        return x >= v[1](ctx) && x <= v[2](ctx);
    }),
    // ============= ARITHMETIC ================
    C(_language_symbol_table__WEBPACK_IMPORTED_MODULE_0__["MolScriptSymbolTable"].core.math.add, function (ctx, xs) {
        var ret = 0;
        if (typeof xs.length === 'number') {
            for (var i = 0, _i = xs.length; i < _i; i++)
                ret += xs[i](ctx);
        }
        else {
            for (var _a = 0, _b = Object.keys(xs); _a < _b.length; _a++) {
                var k = _b[_a];
                ret += xs[k](ctx);
            }
        }
        return ret;
    }),
    C(_language_symbol_table__WEBPACK_IMPORTED_MODULE_0__["MolScriptSymbolTable"].core.math.sub, function (ctx, xs) {
        var ret = 0;
        if (typeof xs.length === 'number') {
            if (xs.length === 1)
                return -xs[0](ctx);
            ret = xs[0](ctx) || 0;
            for (var i = 1, _i = xs.length; i < _i; i++)
                ret -= xs[i](ctx);
        }
        else {
            var keys = Object.keys(xs);
            if (keys.length === 1)
                return -xs[keys[0]](ctx);
            ret = xs[keys[0]](ctx) || 0;
            for (var i = 1, _i = keys.length; i < _i; i++)
                ret -= xs[keys[i]](ctx);
        }
        return ret;
    }),
    C(_language_symbol_table__WEBPACK_IMPORTED_MODULE_0__["MolScriptSymbolTable"].core.math.mult, function (ctx, xs) {
        var ret = 1;
        if (typeof xs.length === 'number') {
            for (var i = 0, _i = xs.length; i < _i; i++)
                ret *= xs[i](ctx);
        }
        else {
            for (var _a = 0, _b = Object.keys(xs); _a < _b.length; _a++) {
                var k = _b[_a];
                ret *= xs[k](ctx);
            }
        }
        return ret;
    }),
    C(_language_symbol_table__WEBPACK_IMPORTED_MODULE_0__["MolScriptSymbolTable"].core.math.div, function (ctx, v) { return v[0](ctx) / v[1](ctx); }),
    C(_language_symbol_table__WEBPACK_IMPORTED_MODULE_0__["MolScriptSymbolTable"].core.math.pow, function (ctx, v) { return Math.pow(v[0](ctx), v[1](ctx)); }),
    C(_language_symbol_table__WEBPACK_IMPORTED_MODULE_0__["MolScriptSymbolTable"].core.math.mod, function (ctx, v) { return v[0](ctx) % v[1](ctx); }),
    C(_language_symbol_table__WEBPACK_IMPORTED_MODULE_0__["MolScriptSymbolTable"].core.math.min, function (ctx, xs) {
        var ret = Number.POSITIVE_INFINITY;
        if (typeof xs.length === 'number') {
            for (var i = 0, _i = xs.length; i < _i; i++)
                ret = Math.min(xs[i](ctx), ret);
        }
        else {
            for (var _a = 0, _b = Object.keys(xs); _a < _b.length; _a++) {
                var k = _b[_a];
                ret = Math.min(xs[k](ctx), ret);
            }
        }
        return ret;
    }),
    C(_language_symbol_table__WEBPACK_IMPORTED_MODULE_0__["MolScriptSymbolTable"].core.math.max, function (ctx, xs) {
        var ret = Number.NEGATIVE_INFINITY;
        if (typeof xs.length === 'number') {
            for (var i = 0, _i = xs.length; i < _i; i++)
                ret = Math.max(xs[i](ctx), ret);
        }
        else {
            for (var _a = 0, _b = Object.keys(xs); _a < _b.length; _a++) {
                var k = _b[_a];
                ret = Math.max(xs[k](ctx), ret);
            }
        }
        return ret;
    }),
    C(_language_symbol_table__WEBPACK_IMPORTED_MODULE_0__["MolScriptSymbolTable"].core.math.floor, function (ctx, v) { return Math.floor(v[0](ctx)); }),
    C(_language_symbol_table__WEBPACK_IMPORTED_MODULE_0__["MolScriptSymbolTable"].core.math.ceil, function (ctx, v) { return Math.ceil(v[0](ctx)); }),
    C(_language_symbol_table__WEBPACK_IMPORTED_MODULE_0__["MolScriptSymbolTable"].core.math.roundInt, function (ctx, v) { return Math.round(v[0](ctx)); }),
    C(_language_symbol_table__WEBPACK_IMPORTED_MODULE_0__["MolScriptSymbolTable"].core.math.abs, function (ctx, v) { return Math.abs(v[0](ctx)); }),
    C(_language_symbol_table__WEBPACK_IMPORTED_MODULE_0__["MolScriptSymbolTable"].core.math.sqrt, function (ctx, v) { return Math.sqrt(v[0](ctx)); }),
    C(_language_symbol_table__WEBPACK_IMPORTED_MODULE_0__["MolScriptSymbolTable"].core.math.cbrt, function (ctx, v) { return Math.cbrt(v[0](ctx)); }),
    C(_language_symbol_table__WEBPACK_IMPORTED_MODULE_0__["MolScriptSymbolTable"].core.math.sin, function (ctx, v) { return Math.sin(v[0](ctx)); }),
    C(_language_symbol_table__WEBPACK_IMPORTED_MODULE_0__["MolScriptSymbolTable"].core.math.cos, function (ctx, v) { return Math.cos(v[0](ctx)); }),
    C(_language_symbol_table__WEBPACK_IMPORTED_MODULE_0__["MolScriptSymbolTable"].core.math.tan, function (ctx, v) { return Math.tan(v[0](ctx)); }),
    C(_language_symbol_table__WEBPACK_IMPORTED_MODULE_0__["MolScriptSymbolTable"].core.math.asin, function (ctx, v) { return Math.asin(v[0](ctx)); }),
    C(_language_symbol_table__WEBPACK_IMPORTED_MODULE_0__["MolScriptSymbolTable"].core.math.acos, function (ctx, v) { return Math.acos(v[0](ctx)); }),
    C(_language_symbol_table__WEBPACK_IMPORTED_MODULE_0__["MolScriptSymbolTable"].core.math.atan, function (ctx, v) { return Math.atan(v[0](ctx)); }),
    C(_language_symbol_table__WEBPACK_IMPORTED_MODULE_0__["MolScriptSymbolTable"].core.math.sinh, function (ctx, v) { return Math.sinh(v[0](ctx)); }),
    C(_language_symbol_table__WEBPACK_IMPORTED_MODULE_0__["MolScriptSymbolTable"].core.math.cosh, function (ctx, v) { return Math.cosh(v[0](ctx)); }),
    C(_language_symbol_table__WEBPACK_IMPORTED_MODULE_0__["MolScriptSymbolTable"].core.math.tanh, function (ctx, v) { return Math.tanh(v[0](ctx)); }),
    C(_language_symbol_table__WEBPACK_IMPORTED_MODULE_0__["MolScriptSymbolTable"].core.math.exp, function (ctx, v) { return Math.exp(v[0](ctx)); }),
    C(_language_symbol_table__WEBPACK_IMPORTED_MODULE_0__["MolScriptSymbolTable"].core.math.log, function (ctx, v) { return Math.log(v[0](ctx)); }),
    C(_language_symbol_table__WEBPACK_IMPORTED_MODULE_0__["MolScriptSymbolTable"].core.math.log10, function (ctx, v) { return Math.log10(v[0](ctx)); }),
    C(_language_symbol_table__WEBPACK_IMPORTED_MODULE_0__["MolScriptSymbolTable"].core.math.atan2, function (ctx, v) { return Math.atan2(v[0](ctx), v[1](ctx)); }),
    // ============= STRING ================
    C(_language_symbol_table__WEBPACK_IMPORTED_MODULE_0__["MolScriptSymbolTable"].core.str.match, function (ctx, v) { return v[0](ctx).test(v[1](ctx)); }),
    C(_language_symbol_table__WEBPACK_IMPORTED_MODULE_0__["MolScriptSymbolTable"].core.str.concat, function (ctx, xs) {
        var ret = [];
        if (typeof xs.length === 'number') {
            for (var i = 0, _i = xs.length; i < _i; i++)
                ret.push(xs[i](ctx).toString());
        }
        else {
            for (var _a = 0, _b = Object.keys(xs); _a < _b.length; _a++) {
                var k = _b[_a];
                ret.push(xs[k](ctx).toString());
            }
        }
        return ret.join('');
    }),
    // ============= LIST ================
    C(_language_symbol_table__WEBPACK_IMPORTED_MODULE_0__["MolScriptSymbolTable"].core.list.getAt, function (ctx, v) { return v[0](ctx)[v[1](ctx)]; }),
    C(_language_symbol_table__WEBPACK_IMPORTED_MODULE_0__["MolScriptSymbolTable"].core.list.equal, function (ctx, v) { return Object(_mol_util_array__WEBPACK_IMPORTED_MODULE_9__["arrayEqual"])(v[0](ctx), v[1](ctx)); }),
    // ============= SET ================
    C(_language_symbol_table__WEBPACK_IMPORTED_MODULE_0__["MolScriptSymbolTable"].core.set.has, function core_set_has(ctx, v) { return v[0](ctx).has(v[1](ctx)); }),
    C(_language_symbol_table__WEBPACK_IMPORTED_MODULE_0__["MolScriptSymbolTable"].core.set.isSubset, function core_set_isSubset(ctx, v) { return _mol_util_set__WEBPACK_IMPORTED_MODULE_4__["SetUtils"].isSuperset(v[1](ctx), v[0](ctx)); }),
    // ============= FLAGS ================
    C(_language_symbol_table__WEBPACK_IMPORTED_MODULE_0__["MolScriptSymbolTable"].core.flags.hasAny, function (ctx, v) {
        var test = v[1](ctx);
        var tested = v[0](ctx);
        if (!test)
            return !!tested;
        return (tested & test) !== 0;
    }),
    C(_language_symbol_table__WEBPACK_IMPORTED_MODULE_0__["MolScriptSymbolTable"].core.flags.hasAll, function (ctx, v) {
        var test = v[1](ctx);
        var tested = v[0](ctx);
        if (!test)
            return !tested;
        return (tested & test) === test;
    }),
    // Structure
    // ============= TYPES ================
    C(_language_symbol_table__WEBPACK_IMPORTED_MODULE_0__["MolScriptSymbolTable"].structureQuery.type.elementSymbol, function (ctx, v) { return Object(_mol_model_structure_model_types__WEBPACK_IMPORTED_MODULE_3__["ElementSymbol"])(v[0](ctx)); }),
    C(_language_symbol_table__WEBPACK_IMPORTED_MODULE_0__["MolScriptSymbolTable"].structureQuery.type.atomName, function (ctx, v) { return Object(_mol_util_string__WEBPACK_IMPORTED_MODULE_5__["upperCaseAny"])(v[0](ctx)); }),
    C(_language_symbol_table__WEBPACK_IMPORTED_MODULE_0__["MolScriptSymbolTable"].structureQuery.type.bondFlags, function (ctx, xs) {
        var ret = 0 /* None */;
        if (typeof xs.length === 'number') {
            for (var i = 0, _i = xs.length; i < _i; i++)
                ret = bondFlag(ret, xs[i](ctx));
        }
        else {
            for (var _a = 0, _b = Object.keys(xs); _a < _b.length; _a++) {
                var k = _b[_a];
                ret = bondFlag(ret, xs[k](ctx));
            }
        }
        return ret;
    }),
    C(_language_symbol_table__WEBPACK_IMPORTED_MODULE_0__["MolScriptSymbolTable"].structureQuery.type.ringFingerprint, function (ctx, xs) { return _mol_model_structure__WEBPACK_IMPORTED_MODULE_2__["UnitRing"].elementFingerprint(getArray(ctx, xs)); }),
    C(_language_symbol_table__WEBPACK_IMPORTED_MODULE_0__["MolScriptSymbolTable"].structureQuery.type.secondaryStructureFlags, function (ctx, xs) {
        var ret = 0 /* None */;
        if (typeof xs.length === 'number') {
            for (var i = 0, _i = xs.length; i < _i; i++)
                ret = secondaryStructureFlag(ret, xs[i](ctx));
        }
        else {
            for (var _a = 0, _b = Object.keys(xs); _a < _b.length; _a++) {
                var k = _b[_a];
                ret = secondaryStructureFlag(ret, xs[k](ctx));
            }
        }
        return ret;
    }),
    // TODO:
    // C(MolScript.structureQuery.type.entityType, (ctx, v) => StructureRuntime.Common.entityType(v[0](ctx))),
    // C(MolScript.structureQuery.type.authResidueId, (ctx, v) => ResidueIdentifier.auth(v[0](ctx), v[1](ctx), v[2] && v[2](ctx))),
    // C(MolScript.structureQuery.type.labelResidueId, (ctx, v) => ResidueIdentifier.label(v[0](ctx), v[1](ctx), v[2](ctx), v[3] && v[3](ctx))),
    // ============= SLOTS ================
    // TODO: slots might not be needed after all: reducer simply pushes/pops current element
    // C(MolScript.structureQuery.slot.element, (ctx, _) => ctx_.element),
    // C(MolScript.structureQuery.slot.elementSetReduce, (ctx, _) => ctx_.element),
    // ============= FILTERS ================
    D(_language_symbol_table__WEBPACK_IMPORTED_MODULE_0__["MolScriptSymbolTable"].structureQuery.filter.pick, function (ctx, xs) { return _mol_model_structure__WEBPACK_IMPORTED_MODULE_2__["Queries"].filters.pick(xs[0], xs['test'])(ctx); }),
    D(_language_symbol_table__WEBPACK_IMPORTED_MODULE_0__["MolScriptSymbolTable"].structureQuery.filter.first, function (ctx, xs) { return _mol_model_structure__WEBPACK_IMPORTED_MODULE_2__["Queries"].filters.first(xs[0])(ctx); }),
    D(_language_symbol_table__WEBPACK_IMPORTED_MODULE_0__["MolScriptSymbolTable"].structureQuery.filter.withSameAtomProperties, function (ctx, xs) { return _mol_model_structure__WEBPACK_IMPORTED_MODULE_2__["Queries"].filters.withSameAtomProperties(xs[0], xs['source'], xs['property'])(ctx); }),
    D(_language_symbol_table__WEBPACK_IMPORTED_MODULE_0__["MolScriptSymbolTable"].structureQuery.filter.intersectedBy, function (ctx, xs) { return _mol_model_structure__WEBPACK_IMPORTED_MODULE_2__["Queries"].filters.areIntersectedBy(xs[0], xs['by'])(ctx); }),
    D(_language_symbol_table__WEBPACK_IMPORTED_MODULE_0__["MolScriptSymbolTable"].structureQuery.filter.within, function (ctx, xs) { return _mol_model_structure__WEBPACK_IMPORTED_MODULE_2__["Queries"].filters.within({
        query: xs[0],
        target: xs['target'],
        minRadius: xs['min-radius'],
        maxRadius: xs['max-radius'],
        elementRadius: xs['atom-radius'],
        invert: xs['invert']
    })(ctx); }),
    D(_language_symbol_table__WEBPACK_IMPORTED_MODULE_0__["MolScriptSymbolTable"].structureQuery.filter.isConnectedTo, function (ctx, xs) { return _mol_model_structure__WEBPACK_IMPORTED_MODULE_2__["Queries"].filters.isConnectedTo({
        query: xs[0],
        target: xs['target'],
        disjunct: xs['disjunct'],
        invert: xs['invert'],
        bondTest: xs['bond-test']
    })(ctx); }),
    // ============= GENERATORS ================
    D(_language_symbol_table__WEBPACK_IMPORTED_MODULE_0__["MolScriptSymbolTable"].structureQuery.generator.atomGroups, function structureQuery_generator_atomGroups(ctx, xs) {
        return _mol_model_structure__WEBPACK_IMPORTED_MODULE_2__["Queries"].generators.atoms({
            entityTest: xs['entity-test'],
            chainTest: xs['chain-test'],
            residueTest: xs['residue-test'],
            atomTest: xs['atom-test'],
            groupBy: xs['group-by']
        })(ctx);
    }),
    D(_language_symbol_table__WEBPACK_IMPORTED_MODULE_0__["MolScriptSymbolTable"].structureQuery.generator.all, function structureQuery_generator_all(ctx) { return _mol_model_structure__WEBPACK_IMPORTED_MODULE_2__["Queries"].generators.all(ctx); }),
    D(_language_symbol_table__WEBPACK_IMPORTED_MODULE_0__["MolScriptSymbolTable"].structureQuery.generator.empty, function structureQuery_generator_empty(ctx) { return _mol_model_structure__WEBPACK_IMPORTED_MODULE_2__["Queries"].generators.none(ctx); }),
    D(_language_symbol_table__WEBPACK_IMPORTED_MODULE_0__["MolScriptSymbolTable"].structureQuery.generator.bondedAtomicPairs, function structureQuery_generator_bondedAtomicPairs(ctx, xs) {
        return _mol_model_structure__WEBPACK_IMPORTED_MODULE_2__["Queries"].generators.bondedAtomicPairs(xs && xs[0])(ctx);
    }),
    D(_language_symbol_table__WEBPACK_IMPORTED_MODULE_0__["MolScriptSymbolTable"].structureQuery.generator.rings, function structureQuery_generator_rings(ctx, xs) {
        var _a, _b;
        return _mol_model_structure__WEBPACK_IMPORTED_MODULE_2__["Queries"].generators.rings((_a = xs === null || xs === void 0 ? void 0 : xs['fingerprint']) === null || _a === void 0 ? void 0 : _a.call(xs, ctx), (_b = xs === null || xs === void 0 ? void 0 : xs['only-aromatic']) === null || _b === void 0 ? void 0 : _b.call(xs, ctx))(ctx);
    }),
    // ============= MODIFIERS ================
    D(_language_symbol_table__WEBPACK_IMPORTED_MODULE_0__["MolScriptSymbolTable"].structureQuery.modifier.includeSurroundings, function structureQuery_modifier_includeSurroundings(ctx, xs) {
        return _mol_model_structure__WEBPACK_IMPORTED_MODULE_2__["Queries"].modifiers.includeSurroundings(xs[0], {
            radius: xs['radius'](ctx),
            wholeResidues: !!(xs['as-whole-residues'] && xs['as-whole-residues'](ctx)),
            elementRadius: xs['atom-radius']
        })(ctx);
    }),
    D(_language_symbol_table__WEBPACK_IMPORTED_MODULE_0__["MolScriptSymbolTable"].structureQuery.modifier.wholeResidues, function structureQuery_modifier_wholeResidues(ctx, xs) { return _mol_model_structure__WEBPACK_IMPORTED_MODULE_2__["Queries"].modifiers.wholeResidues(xs[0])(ctx); }),
    D(_language_symbol_table__WEBPACK_IMPORTED_MODULE_0__["MolScriptSymbolTable"].structureQuery.modifier.union, function structureQuery_modifier_union(ctx, xs) { return _mol_model_structure__WEBPACK_IMPORTED_MODULE_2__["Queries"].modifiers.union(xs[0])(ctx); }),
    D(_language_symbol_table__WEBPACK_IMPORTED_MODULE_0__["MolScriptSymbolTable"].structureQuery.modifier.expandProperty, function structureQuery_modifier_expandProperty(ctx, xs) { return _mol_model_structure__WEBPACK_IMPORTED_MODULE_2__["Queries"].modifiers.expandProperty(xs[0], xs['property'])(ctx); }),
    D(_language_symbol_table__WEBPACK_IMPORTED_MODULE_0__["MolScriptSymbolTable"].structureQuery.modifier.exceptBy, function structureQuery_modifier_exceptBy(ctx, xs) { return _mol_model_structure__WEBPACK_IMPORTED_MODULE_2__["Queries"].modifiers.exceptBy(xs[0], xs['by'])(ctx); }),
    D(_language_symbol_table__WEBPACK_IMPORTED_MODULE_0__["MolScriptSymbolTable"].structureQuery.modifier.includeConnected, function structureQuery_modifier_includeConnected(ctx, xs) {
        return _mol_model_structure__WEBPACK_IMPORTED_MODULE_2__["Queries"].modifiers.includeConnected({
            query: xs[0],
            bondTest: xs['bond-test'],
            wholeResidues: !!(xs['as-whole-residues'] && xs['as-whole-residues'](ctx)),
            layerCount: (xs['layer-count'] && xs['layer-count'](ctx)) || 1
        })(ctx);
    }),
    // ============= COMBINATORS ================
    D(_language_symbol_table__WEBPACK_IMPORTED_MODULE_0__["MolScriptSymbolTable"].structureQuery.combinator.merge, function (ctx, xs) { return _mol_model_structure__WEBPACK_IMPORTED_MODULE_2__["Queries"].combinators.merge(xs)(ctx); }),
    // ============= ATOM PROPERTIES ================
    // ~~~ CORE ~~~
    D(_language_symbol_table__WEBPACK_IMPORTED_MODULE_0__["MolScriptSymbolTable"].structureQuery.atomProperty.core.elementSymbol, atomProp(_mol_model_structure__WEBPACK_IMPORTED_MODULE_2__["StructureProperties"].atom.type_symbol)),
    D(_language_symbol_table__WEBPACK_IMPORTED_MODULE_0__["MolScriptSymbolTable"].structureQuery.atomProperty.core.vdw, function (ctx, xs) { return Object(_mol_model_structure_model_properties_atomic__WEBPACK_IMPORTED_MODULE_6__["VdwRadius"])(_mol_model_structure__WEBPACK_IMPORTED_MODULE_2__["StructureProperties"].atom.type_symbol((xs && xs[0] && xs[0](ctx)) || ctx.element)); }),
    D(_language_symbol_table__WEBPACK_IMPORTED_MODULE_0__["MolScriptSymbolTable"].structureQuery.atomProperty.core.mass, function (ctx, xs) { return Object(_mol_model_structure_model_properties_atomic__WEBPACK_IMPORTED_MODULE_6__["AtomWeight"])(_mol_model_structure__WEBPACK_IMPORTED_MODULE_2__["StructureProperties"].atom.type_symbol((xs && xs[0] && xs[0](ctx)) || ctx.element)); }),
    D(_language_symbol_table__WEBPACK_IMPORTED_MODULE_0__["MolScriptSymbolTable"].structureQuery.atomProperty.core.atomicNumber, function (ctx, xs) { return Object(_mol_model_structure_model_properties_atomic__WEBPACK_IMPORTED_MODULE_6__["AtomNumber"])(_mol_model_structure__WEBPACK_IMPORTED_MODULE_2__["StructureProperties"].atom.type_symbol((xs && xs[0] && xs[0](ctx)) || ctx.element)); }),
    D(_language_symbol_table__WEBPACK_IMPORTED_MODULE_0__["MolScriptSymbolTable"].structureQuery.atomProperty.core.x, atomProp(_mol_model_structure__WEBPACK_IMPORTED_MODULE_2__["StructureProperties"].atom.x)),
    D(_language_symbol_table__WEBPACK_IMPORTED_MODULE_0__["MolScriptSymbolTable"].structureQuery.atomProperty.core.y, atomProp(_mol_model_structure__WEBPACK_IMPORTED_MODULE_2__["StructureProperties"].atom.y)),
    D(_language_symbol_table__WEBPACK_IMPORTED_MODULE_0__["MolScriptSymbolTable"].structureQuery.atomProperty.core.z, atomProp(_mol_model_structure__WEBPACK_IMPORTED_MODULE_2__["StructureProperties"].atom.z)),
    D(_language_symbol_table__WEBPACK_IMPORTED_MODULE_0__["MolScriptSymbolTable"].structureQuery.atomProperty.core.sourceIndex, atomProp(_mol_model_structure__WEBPACK_IMPORTED_MODULE_2__["StructureProperties"].atom.sourceIndex)),
    D(_language_symbol_table__WEBPACK_IMPORTED_MODULE_0__["MolScriptSymbolTable"].structureQuery.atomProperty.core.operatorName, atomProp(_mol_model_structure__WEBPACK_IMPORTED_MODULE_2__["StructureProperties"].unit.operator_name)),
    D(_language_symbol_table__WEBPACK_IMPORTED_MODULE_0__["MolScriptSymbolTable"].structureQuery.atomProperty.core.modelIndex, atomProp(_mol_model_structure__WEBPACK_IMPORTED_MODULE_2__["StructureProperties"].unit.model_index)),
    D(_language_symbol_table__WEBPACK_IMPORTED_MODULE_0__["MolScriptSymbolTable"].structureQuery.atomProperty.core.modelLabel, atomProp(_mol_model_structure__WEBPACK_IMPORTED_MODULE_2__["StructureProperties"].unit.model_label)),
    D(_language_symbol_table__WEBPACK_IMPORTED_MODULE_0__["MolScriptSymbolTable"].structureQuery.atomProperty.core.atomKey, function (ctx, xs) {
        var e = (xs && xs[0] && xs[0](ctx)) || ctx.element;
        return Object(_mol_data_util__WEBPACK_IMPORTED_MODULE_7__["cantorPairing"])(e.unit.id, e.element);
    }),
    // TODO:
    // D(MolScript.structureQuery.atomProperty.core.bondCount, (ctx, _) => ),
    // ~~~ TOPOLOGY ~~~
    // TODO
    // ~~~ MACROMOLECULAR ~~~
    // TODO:
    // // identifiers
    // labelResidueId: prop((env, v) => ResidueIdentifier.labelOfResidueIndex(env.context.model, getAddress(env, v).residue)),
    // authResidueId: prop((env, v) => ResidueIdentifier.authOfResidueIndex(env.context.model, getAddress(env, v).residue)),
    // keys
    D(_language_symbol_table__WEBPACK_IMPORTED_MODULE_0__["MolScriptSymbolTable"].structureQuery.atomProperty.macromolecular.residueKey, function (ctx, xs) { return _mol_model_structure__WEBPACK_IMPORTED_MODULE_2__["StructureElement"].residueIndex((xs && xs[0] && xs[0](ctx)) || ctx.element); }),
    D(_language_symbol_table__WEBPACK_IMPORTED_MODULE_0__["MolScriptSymbolTable"].structureQuery.atomProperty.macromolecular.chainKey, function (ctx, xs) { return _mol_model_structure__WEBPACK_IMPORTED_MODULE_2__["StructureElement"].chainIndex((xs && xs[0] && xs[0](ctx)) || ctx.element); }),
    D(_language_symbol_table__WEBPACK_IMPORTED_MODULE_0__["MolScriptSymbolTable"].structureQuery.atomProperty.macromolecular.entityKey, function (ctx, xs) { return _mol_model_structure__WEBPACK_IMPORTED_MODULE_2__["StructureElement"].entityIndex((xs && xs[0] && xs[0](ctx)) || ctx.element); }),
    // mmCIF
    D(_language_symbol_table__WEBPACK_IMPORTED_MODULE_0__["MolScriptSymbolTable"].structureQuery.atomProperty.macromolecular.id, atomProp(_mol_model_structure__WEBPACK_IMPORTED_MODULE_2__["StructureProperties"].atom.id)),
    D(_language_symbol_table__WEBPACK_IMPORTED_MODULE_0__["MolScriptSymbolTable"].structureQuery.atomProperty.macromolecular.isHet, function (ctx, xs) { return _mol_model_structure__WEBPACK_IMPORTED_MODULE_2__["StructureProperties"].residue.group_PDB((xs && xs[0] && xs[0](ctx)) || ctx.element) !== 'ATOM'; }),
    D(_language_symbol_table__WEBPACK_IMPORTED_MODULE_0__["MolScriptSymbolTable"].structureQuery.atomProperty.macromolecular.label_atom_id, atomProp(_mol_model_structure__WEBPACK_IMPORTED_MODULE_2__["StructureProperties"].atom.label_atom_id)),
    D(_language_symbol_table__WEBPACK_IMPORTED_MODULE_0__["MolScriptSymbolTable"].structureQuery.atomProperty.macromolecular.label_alt_id, atomProp(_mol_model_structure__WEBPACK_IMPORTED_MODULE_2__["StructureProperties"].atom.label_alt_id)),
    D(_language_symbol_table__WEBPACK_IMPORTED_MODULE_0__["MolScriptSymbolTable"].structureQuery.atomProperty.macromolecular.label_comp_id, atomProp(_mol_model_structure__WEBPACK_IMPORTED_MODULE_2__["StructureProperties"].atom.label_comp_id)),
    D(_language_symbol_table__WEBPACK_IMPORTED_MODULE_0__["MolScriptSymbolTable"].structureQuery.atomProperty.macromolecular.label_seq_id, atomProp(_mol_model_structure__WEBPACK_IMPORTED_MODULE_2__["StructureProperties"].residue.label_seq_id)),
    D(_language_symbol_table__WEBPACK_IMPORTED_MODULE_0__["MolScriptSymbolTable"].structureQuery.atomProperty.macromolecular.label_asym_id, atomProp(_mol_model_structure__WEBPACK_IMPORTED_MODULE_2__["StructureProperties"].chain.label_asym_id)),
    D(_language_symbol_table__WEBPACK_IMPORTED_MODULE_0__["MolScriptSymbolTable"].structureQuery.atomProperty.macromolecular.label_entity_id, atomProp(_mol_model_structure__WEBPACK_IMPORTED_MODULE_2__["StructureProperties"].entity.id)),
    D(_language_symbol_table__WEBPACK_IMPORTED_MODULE_0__["MolScriptSymbolTable"].structureQuery.atomProperty.macromolecular.auth_atom_id, atomProp(_mol_model_structure__WEBPACK_IMPORTED_MODULE_2__["StructureProperties"].atom.auth_atom_id)),
    D(_language_symbol_table__WEBPACK_IMPORTED_MODULE_0__["MolScriptSymbolTable"].structureQuery.atomProperty.macromolecular.auth_comp_id, atomProp(_mol_model_structure__WEBPACK_IMPORTED_MODULE_2__["StructureProperties"].atom.auth_comp_id)),
    D(_language_symbol_table__WEBPACK_IMPORTED_MODULE_0__["MolScriptSymbolTable"].structureQuery.atomProperty.macromolecular.auth_seq_id, atomProp(_mol_model_structure__WEBPACK_IMPORTED_MODULE_2__["StructureProperties"].residue.auth_seq_id)),
    D(_language_symbol_table__WEBPACK_IMPORTED_MODULE_0__["MolScriptSymbolTable"].structureQuery.atomProperty.macromolecular.auth_asym_id, atomProp(_mol_model_structure__WEBPACK_IMPORTED_MODULE_2__["StructureProperties"].chain.auth_asym_id)),
    D(_language_symbol_table__WEBPACK_IMPORTED_MODULE_0__["MolScriptSymbolTable"].structureQuery.atomProperty.macromolecular.pdbx_PDB_ins_code, atomProp(_mol_model_structure__WEBPACK_IMPORTED_MODULE_2__["StructureProperties"].residue.pdbx_PDB_ins_code)),
    D(_language_symbol_table__WEBPACK_IMPORTED_MODULE_0__["MolScriptSymbolTable"].structureQuery.atomProperty.macromolecular.pdbx_formal_charge, atomProp(_mol_model_structure__WEBPACK_IMPORTED_MODULE_2__["StructureProperties"].atom.pdbx_formal_charge)),
    D(_language_symbol_table__WEBPACK_IMPORTED_MODULE_0__["MolScriptSymbolTable"].structureQuery.atomProperty.macromolecular.occupancy, atomProp(_mol_model_structure__WEBPACK_IMPORTED_MODULE_2__["StructureProperties"].atom.occupancy)),
    D(_language_symbol_table__WEBPACK_IMPORTED_MODULE_0__["MolScriptSymbolTable"].structureQuery.atomProperty.macromolecular.B_iso_or_equiv, atomProp(_mol_model_structure__WEBPACK_IMPORTED_MODULE_2__["StructureProperties"].atom.B_iso_or_equiv)),
    D(_language_symbol_table__WEBPACK_IMPORTED_MODULE_0__["MolScriptSymbolTable"].structureQuery.atomProperty.macromolecular.entityType, atomProp(_mol_model_structure__WEBPACK_IMPORTED_MODULE_2__["StructureProperties"].entity.type)),
    D(_language_symbol_table__WEBPACK_IMPORTED_MODULE_0__["MolScriptSymbolTable"].structureQuery.atomProperty.macromolecular.entitySubtype, atomProp(_mol_model_structure__WEBPACK_IMPORTED_MODULE_2__["StructureProperties"].entity.subtype)),
    D(_language_symbol_table__WEBPACK_IMPORTED_MODULE_0__["MolScriptSymbolTable"].structureQuery.atomProperty.macromolecular.entityPrdId, atomProp(_mol_model_structure__WEBPACK_IMPORTED_MODULE_2__["StructureProperties"].entity.prd_id)),
    D(_language_symbol_table__WEBPACK_IMPORTED_MODULE_0__["MolScriptSymbolTable"].structureQuery.atomProperty.macromolecular.entityDescription, atomProp(_mol_model_structure__WEBPACK_IMPORTED_MODULE_2__["StructureProperties"].entity.pdbx_description)),
    D(_language_symbol_table__WEBPACK_IMPORTED_MODULE_0__["MolScriptSymbolTable"].structureQuery.atomProperty.macromolecular.objectPrimitive, atomProp(_mol_model_structure__WEBPACK_IMPORTED_MODULE_2__["StructureProperties"].unit.object_primitive)),
    D(_language_symbol_table__WEBPACK_IMPORTED_MODULE_0__["MolScriptSymbolTable"].structureQuery.atomProperty.macromolecular.isNonStandard, atomProp(_mol_model_structure__WEBPACK_IMPORTED_MODULE_2__["StructureProperties"].residue.isNonStandard)),
    D(_language_symbol_table__WEBPACK_IMPORTED_MODULE_0__["MolScriptSymbolTable"].structureQuery.atomProperty.macromolecular.secondaryStructureKey, atomProp(_mol_model_structure__WEBPACK_IMPORTED_MODULE_2__["StructureProperties"].residue.secondary_structure_key)),
    D(_language_symbol_table__WEBPACK_IMPORTED_MODULE_0__["MolScriptSymbolTable"].structureQuery.atomProperty.macromolecular.secondaryStructureFlags, atomProp(_mol_model_structure__WEBPACK_IMPORTED_MODULE_2__["StructureProperties"].residue.secondary_structure_type)),
    D(_language_symbol_table__WEBPACK_IMPORTED_MODULE_0__["MolScriptSymbolTable"].structureQuery.atomProperty.macromolecular.chemCompType, atomProp(_mol_model_structure__WEBPACK_IMPORTED_MODULE_2__["StructureProperties"].residue.chem_comp_type)),
    // ============= BOND PROPERTIES ================
    D(_language_symbol_table__WEBPACK_IMPORTED_MODULE_0__["MolScriptSymbolTable"].structureQuery.bondProperty.order, function (ctx, xs) { return ctx.atomicBond.order; }),
    D(_language_symbol_table__WEBPACK_IMPORTED_MODULE_0__["MolScriptSymbolTable"].structureQuery.bondProperty.flags, function (ctx, xs) { return ctx.atomicBond.type; }),
    D(_language_symbol_table__WEBPACK_IMPORTED_MODULE_0__["MolScriptSymbolTable"].structureQuery.bondProperty.atomA, function (ctx, xs) { return ctx.atomicBond.a; }),
    D(_language_symbol_table__WEBPACK_IMPORTED_MODULE_0__["MolScriptSymbolTable"].structureQuery.bondProperty.atomB, function (ctx, xs) { return ctx.atomicBond.b; }),
    D(_language_symbol_table__WEBPACK_IMPORTED_MODULE_0__["MolScriptSymbolTable"].structureQuery.bondProperty.length, function (ctx, xs) { return ctx.atomicBond.length; }),
    // Internal
    D(_language_symbol_table__WEBPACK_IMPORTED_MODULE_0__["MolScriptSymbolTable"].internal.generator.bundleElement, function internal_generator_bundleElement(ctx, xs) { return Object(_mol_model_structure_query_queries_internal__WEBPACK_IMPORTED_MODULE_8__["bundleElementImpl"])(xs.groupedUnits(ctx), xs.ranges(ctx), xs.set(ctx)); }),
    D(_language_symbol_table__WEBPACK_IMPORTED_MODULE_0__["MolScriptSymbolTable"].internal.generator.bundle, function internal_generator_bundle(ctx, xs) { return Object(_mol_model_structure_query_queries_internal__WEBPACK_IMPORTED_MODULE_8__["bundleGenerator"])(xs.elements(ctx))(ctx); }),
    D(_language_symbol_table__WEBPACK_IMPORTED_MODULE_0__["MolScriptSymbolTable"].internal.generator.current, function internal_generator_current(ctx, xs) { return ctx.tryGetCurrentSelection(); }),
];
function atomProp(p) {
    return function (ctx, xs) { return p((xs && xs[0] && xs[0](ctx)) || ctx.element); };
}
function bondFlag(current, f) {
    return current | (_mol_model_structure_model_types__WEBPACK_IMPORTED_MODULE_3__["BondType"].isName(f) ? _mol_model_structure_model_types__WEBPACK_IMPORTED_MODULE_3__["BondType"].fromName(f) : 0 /* None */);
}
function secondaryStructureFlag(current, f) {
    switch (f.toLowerCase()) {
        case 'helix': return current | 2 /* Helix */;
        case 'alpha': return current | 2 /* Helix */ | 4096 /* HelixAlpha */;
        case 'pi': return current | 2 /* Helix */ | 32768 /* HelixPi */;
        case '310': return current | 2 /* Helix */ | 2048 /* Helix3Ten */;
        case 'beta': return current | 4 /* Beta */;
        case 'strand': return current | 4 /* Beta */ | 4194304 /* BetaStrand */;
        case 'sheet': return current | 4 /* Beta */ | 8388608 /* BetaSheet */;
        case 'turn': return current | 16 /* Turn */;
        case 'bend': return current | 8 /* Bend */;
        case 'coil': return current | 536870912 /* NA */;
        default: return current;
    }
}
function getArray(ctx, xs) {
    var ret = [];
    if (!xs)
        return ret;
    if (typeof xs.length === 'number') {
        for (var i = 0, _i = xs.length; i < _i; i++)
            ret.push(xs[i](ctx));
    }
    else {
        var keys = Object.keys(xs);
        for (var i = 1, _i = keys.length; i < _i; i++)
            ret.push(xs[keys[i]](ctx));
    }
    return ret;
}
(function () {
    for (var _a = 0, symbols_1 = symbols; _a < symbols_1.length; _a++) {
        var s = symbols_1[_a];
        _base__WEBPACK_IMPORTED_MODULE_1__["DefaultQueryRuntimeTable"].addSymbol(s);
    }
})();
//# sourceMappingURL=table.js.map

/***/ }),

/***/ "./lib/mol-script/script.js":
/*!**********************************!*\
  !*** ./lib/mol-script/script.js ***!
  \**********************************/
/*! exports provided: Script */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Script", function() { return Script; });
/* harmony import */ var _script_mol_script_symbols__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./script/mol-script/symbols */ "./lib/mol-script/script/mol-script/symbols.js");
/* harmony import */ var _language_parser__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./language/parser */ "./lib/mol-script/language/parser.js");
/* harmony import */ var _mol_model_structure__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../mol-model/structure */ "./lib/mol-model/structure.js");
/* harmony import */ var _runtime_query_compiler__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./runtime/query/compiler */ "./lib/mol-script/runtime/query/compiler.js");
/* harmony import */ var _language_builder__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./language/builder */ "./lib/mol-script/language/builder.js");
/**
 * Copyright (c) 2019 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */






function Script(expression, language) {
    return { expression: expression, language: language };
}
(function (Script) {
    function is(x) {
        return !!x && typeof x.expression === 'string' && !!x.language;
    }
    Script.is = is;
    function areEqual(a, b) {
        return a.language === b.language && a.expression === b.expression;
    }
    Script.areEqual = areEqual;
    function toExpression(script) {
        switch (script.language) {
            case 'mol-script':
                var parsed = Object(_language_parser__WEBPACK_IMPORTED_MODULE_1__["parseMolScript"])(script.expression);
                if (parsed.length === 0)
                    throw new Error('No query');
                return Object(_script_mol_script_symbols__WEBPACK_IMPORTED_MODULE_0__["transpileMolScript"])(parsed[0]);
        }
        throw new Error('unsupported script language');
    }
    Script.toExpression = toExpression;
    function toQuery(script) {
        var expression = toExpression(script);
        return Object(_runtime_query_compiler__WEBPACK_IMPORTED_MODULE_3__["compile"])(expression);
    }
    Script.toQuery = toQuery;
    function toLoci(script, structure) {
        var query = toQuery(script);
        var result = query(new _mol_model_structure__WEBPACK_IMPORTED_MODULE_2__["QueryContext"](structure));
        return _mol_model_structure__WEBPACK_IMPORTED_MODULE_2__["StructureSelection"].toLociWithSourceUnits(result);
    }
    Script.toLoci = toLoci;
    function getStructureSelection(expr, structure, options) {
        var e = typeof expr === 'function' ? expr(_language_builder__WEBPACK_IMPORTED_MODULE_4__["MolScriptBuilder"]) : expr;
        var query = Object(_runtime_query_compiler__WEBPACK_IMPORTED_MODULE_3__["compile"])(e);
        return query(new _mol_model_structure__WEBPACK_IMPORTED_MODULE_2__["QueryContext"](structure, options));
    }
    Script.getStructureSelection = getStructureSelection;
})(Script || (Script = {}));
//# sourceMappingURL=script.js.map

/***/ }),

/***/ "./lib/mol-script/script/mol-script/macro.js":
/*!***************************************************!*\
  !*** ./lib/mol-script/script/mol-script/macro.js ***!
  \***************************************************/
/*! exports provided: getPositionalArgs, tryGetArg, pickArgs, aggregate */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getPositionalArgs", function() { return getPositionalArgs; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "tryGetArg", function() { return tryGetArg; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "pickArgs", function() { return pickArgs; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "aggregate", function() { return aggregate; });
/* harmony import */ var _language_builder__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../language/builder */ "./lib/mol-script/language/builder.js");
/**
 * Copyright (c) 2018-2019 Mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author David Sehnal <david.sehnal@gmail.com>
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */

function getPositionalArgs(args) {
    return Object.keys(args)
        .filter(function (k) { return !isNaN(k); })
        .map(function (k) { return +k; })
        .sort(function (a, b) { return a - b; })
        .map(function (k) { return args[k]; });
}
function tryGetArg(args, name, defaultValue) {
    return (args && args[name] !== void 0) ? args[name] : defaultValue;
}
function pickArgs(args) {
    var names = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        names[_i - 1] = arguments[_i];
    }
    var ret = Object.create(null);
    var count = 0;
    for (var _a = 0, _b = Object.keys(args); _a < _b.length; _a++) {
        var k = _b[_a];
        if (names.indexOf(k) >= 0) {
            ret[k] = args[k];
            count++;
        }
    }
    return count ? ret : void 0;
}
function aggregate(property, fn, initial) {
    return _language_builder__WEBPACK_IMPORTED_MODULE_0__["MolScriptBuilder"].struct.atomSet.reduce({
        initial: initial !== void 0 ? initial : property,
        value: fn([_language_builder__WEBPACK_IMPORTED_MODULE_0__["MolScriptBuilder"].struct.slot.elementSetReduce(), property])
    });
}
//# sourceMappingURL=macro.js.map

/***/ }),

/***/ "./lib/mol-script/script/mol-script/symbols.js":
/*!*****************************************************!*\
  !*** ./lib/mol-script/script/mol-script/symbols.js ***!
  \*****************************************************/
/*! exports provided: isMolScriptSymbol, SymbolTable, MolScriptSymbols, Constants, NamedArgs, SymbolMap, SymbolList, transpileMolScript */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isMolScriptSymbol", function() { return isMolScriptSymbol; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SymbolTable", function() { return SymbolTable; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MolScriptSymbols", function() { return MolScriptSymbols; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Constants", function() { return Constants; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "NamedArgs", function() { return NamedArgs; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SymbolMap", function() { return SymbolMap; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SymbolList", function() { return SymbolList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "transpileMolScript", function() { return transpileMolScript; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _mol_data_generic__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../../mol-data/generic */ "./lib/mol-data/generic.js");
/* harmony import */ var _language_expression__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../language/expression */ "./lib/mol-script/language/expression.js");
/* harmony import */ var _language_symbol__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../language/symbol */ "./lib/mol-script/language/symbol.js");
/* harmony import */ var _language_symbol_table__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../language/symbol-table */ "./lib/mol-script/language/symbol-table.js");
/* harmony import */ var _language_type__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../language/type */ "./lib/mol-script/language/type.js");
/* harmony import */ var _language_symbol_table_structure_query__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../../language/symbol-table/structure-query */ "./lib/mol-script/language/symbol-table/structure-query.js");
/* harmony import */ var _language_builder__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../../language/builder */ "./lib/mol-script/language/builder.js");
/* harmony import */ var _macro__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ./macro */ "./lib/mol-script/script/mol-script/macro.js");
/**
 * Copyright (c) 2018 Mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author David Sehnal <david.sehnal@gmail.com>
 */









function Alias(symbol) {
    var aliases = [];
    for (var _a = 1; _a < arguments.length; _a++) {
        aliases[_a - 1] = arguments[_a];
    }
    return { kind: 'alias', aliases: aliases, symbol: symbol };
}
function Macro(symbol, translate) {
    var aliases = [];
    for (var _a = 2; _a < arguments.length; _a++) {
        aliases[_a - 2] = arguments[_a];
    }
    symbol.info.namespace = 'molscript-macro';
    symbol.id = "molscript-macro." + symbol.info.name;
    return { kind: 'macro', symbol: symbol, translate: translate, aliases: Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__spreadArrays"])([symbol.info.name], aliases) };
}
function isMolScriptSymbol(x) {
    return x.kind === 'alias' || x.kind === 'macro';
}
var SymbolTable = [
    [
        'Core symbols',
        Alias(_language_symbol_table__WEBPACK_IMPORTED_MODULE_4__["MolScriptSymbolTable"].core.type.bool, 'bool'),
        Alias(_language_symbol_table__WEBPACK_IMPORTED_MODULE_4__["MolScriptSymbolTable"].core.type.num, 'num'),
        Alias(_language_symbol_table__WEBPACK_IMPORTED_MODULE_4__["MolScriptSymbolTable"].core.type.str, 'str'),
        Alias(_language_symbol_table__WEBPACK_IMPORTED_MODULE_4__["MolScriptSymbolTable"].core.type.regex, 'regex'),
        Alias(_language_symbol_table__WEBPACK_IMPORTED_MODULE_4__["MolScriptSymbolTable"].core.type.list, 'list'),
        Alias(_language_symbol_table__WEBPACK_IMPORTED_MODULE_4__["MolScriptSymbolTable"].core.type.set, 'set'),
        Alias(_language_symbol_table__WEBPACK_IMPORTED_MODULE_4__["MolScriptSymbolTable"].core.type.compositeKey, 'composite-key'),
        Alias(_language_symbol_table__WEBPACK_IMPORTED_MODULE_4__["MolScriptSymbolTable"].core.logic.not, 'not'),
        Alias(_language_symbol_table__WEBPACK_IMPORTED_MODULE_4__["MolScriptSymbolTable"].core.logic.and, 'and'),
        Alias(_language_symbol_table__WEBPACK_IMPORTED_MODULE_4__["MolScriptSymbolTable"].core.logic.or, 'or'),
        Alias(_language_symbol_table__WEBPACK_IMPORTED_MODULE_4__["MolScriptSymbolTable"].core.ctrl.if, 'if'),
        Alias(_language_symbol_table__WEBPACK_IMPORTED_MODULE_4__["MolScriptSymbolTable"].core.ctrl.fn, 'fn'),
        Alias(_language_symbol_table__WEBPACK_IMPORTED_MODULE_4__["MolScriptSymbolTable"].core.ctrl.eval, 'eval'),
        Alias(_language_symbol_table__WEBPACK_IMPORTED_MODULE_4__["MolScriptSymbolTable"].core.math.add, 'add', '+'),
        Alias(_language_symbol_table__WEBPACK_IMPORTED_MODULE_4__["MolScriptSymbolTable"].core.math.sub, 'sub', '-'),
        Alias(_language_symbol_table__WEBPACK_IMPORTED_MODULE_4__["MolScriptSymbolTable"].core.math.mult, 'mult', '*'),
        Alias(_language_symbol_table__WEBPACK_IMPORTED_MODULE_4__["MolScriptSymbolTable"].core.math.div, 'div', '/'),
        Alias(_language_symbol_table__WEBPACK_IMPORTED_MODULE_4__["MolScriptSymbolTable"].core.math.pow, 'pow', '**'),
        Alias(_language_symbol_table__WEBPACK_IMPORTED_MODULE_4__["MolScriptSymbolTable"].core.math.mod, 'mod'),
        Alias(_language_symbol_table__WEBPACK_IMPORTED_MODULE_4__["MolScriptSymbolTable"].core.math.min, 'min'),
        Alias(_language_symbol_table__WEBPACK_IMPORTED_MODULE_4__["MolScriptSymbolTable"].core.math.max, 'max'),
        Alias(_language_symbol_table__WEBPACK_IMPORTED_MODULE_4__["MolScriptSymbolTable"].core.math.floor, 'floor'),
        Alias(_language_symbol_table__WEBPACK_IMPORTED_MODULE_4__["MolScriptSymbolTable"].core.math.ceil, 'ceil'),
        Alias(_language_symbol_table__WEBPACK_IMPORTED_MODULE_4__["MolScriptSymbolTable"].core.math.roundInt, 'round'),
        Alias(_language_symbol_table__WEBPACK_IMPORTED_MODULE_4__["MolScriptSymbolTable"].core.math.abs, 'abs'),
        Alias(_language_symbol_table__WEBPACK_IMPORTED_MODULE_4__["MolScriptSymbolTable"].core.math.sqrt, 'sqrt'),
        Alias(_language_symbol_table__WEBPACK_IMPORTED_MODULE_4__["MolScriptSymbolTable"].core.math.cbrt, 'cbrt'),
        Alias(_language_symbol_table__WEBPACK_IMPORTED_MODULE_4__["MolScriptSymbolTable"].core.math.sin, 'sin'),
        Alias(_language_symbol_table__WEBPACK_IMPORTED_MODULE_4__["MolScriptSymbolTable"].core.math.cos, 'cos'),
        Alias(_language_symbol_table__WEBPACK_IMPORTED_MODULE_4__["MolScriptSymbolTable"].core.math.tan, 'tan'),
        Alias(_language_symbol_table__WEBPACK_IMPORTED_MODULE_4__["MolScriptSymbolTable"].core.math.asin, 'asin'),
        Alias(_language_symbol_table__WEBPACK_IMPORTED_MODULE_4__["MolScriptSymbolTable"].core.math.acos, 'acos'),
        Alias(_language_symbol_table__WEBPACK_IMPORTED_MODULE_4__["MolScriptSymbolTable"].core.math.atan, 'atan'),
        Alias(_language_symbol_table__WEBPACK_IMPORTED_MODULE_4__["MolScriptSymbolTable"].core.math.sinh, 'sinh'),
        Alias(_language_symbol_table__WEBPACK_IMPORTED_MODULE_4__["MolScriptSymbolTable"].core.math.cosh, 'cosh'),
        Alias(_language_symbol_table__WEBPACK_IMPORTED_MODULE_4__["MolScriptSymbolTable"].core.math.tanh, 'tanh'),
        Alias(_language_symbol_table__WEBPACK_IMPORTED_MODULE_4__["MolScriptSymbolTable"].core.math.exp, 'exp'),
        Alias(_language_symbol_table__WEBPACK_IMPORTED_MODULE_4__["MolScriptSymbolTable"].core.math.log, 'log'),
        Alias(_language_symbol_table__WEBPACK_IMPORTED_MODULE_4__["MolScriptSymbolTable"].core.math.log10, 'log10'),
        Alias(_language_symbol_table__WEBPACK_IMPORTED_MODULE_4__["MolScriptSymbolTable"].core.math.atan2, 'atan2'),
        Alias(_language_symbol_table__WEBPACK_IMPORTED_MODULE_4__["MolScriptSymbolTable"].core.rel.eq, 'eq', '='),
        Alias(_language_symbol_table__WEBPACK_IMPORTED_MODULE_4__["MolScriptSymbolTable"].core.rel.neq, 'neq', '!='),
        Alias(_language_symbol_table__WEBPACK_IMPORTED_MODULE_4__["MolScriptSymbolTable"].core.rel.lt, 'lt', '<'),
        Alias(_language_symbol_table__WEBPACK_IMPORTED_MODULE_4__["MolScriptSymbolTable"].core.rel.lte, 'lte', '<='),
        Alias(_language_symbol_table__WEBPACK_IMPORTED_MODULE_4__["MolScriptSymbolTable"].core.rel.gr, 'gr', '>'),
        Alias(_language_symbol_table__WEBPACK_IMPORTED_MODULE_4__["MolScriptSymbolTable"].core.rel.gre, 'gre', '>='),
        Alias(_language_symbol_table__WEBPACK_IMPORTED_MODULE_4__["MolScriptSymbolTable"].core.rel.inRange, 'in-range'),
        Alias(_language_symbol_table__WEBPACK_IMPORTED_MODULE_4__["MolScriptSymbolTable"].core.str.concat, 'concat'),
        Alias(_language_symbol_table__WEBPACK_IMPORTED_MODULE_4__["MolScriptSymbolTable"].core.str.match, 'regex.match'),
        Alias(_language_symbol_table__WEBPACK_IMPORTED_MODULE_4__["MolScriptSymbolTable"].core.list.getAt, 'list.get'),
        Alias(_language_symbol_table__WEBPACK_IMPORTED_MODULE_4__["MolScriptSymbolTable"].core.set.has, 'set.has'),
        Alias(_language_symbol_table__WEBPACK_IMPORTED_MODULE_4__["MolScriptSymbolTable"].core.set.isSubset, 'set.subset'),
    ],
    [
        'Structure',
        [
            'Types',
            Alias(_language_symbol_table__WEBPACK_IMPORTED_MODULE_4__["MolScriptSymbolTable"].structureQuery.type.entityType, 'ent-type'),
            Alias(_language_symbol_table__WEBPACK_IMPORTED_MODULE_4__["MolScriptSymbolTable"].structureQuery.type.authResidueId, 'auth-resid'),
            Alias(_language_symbol_table__WEBPACK_IMPORTED_MODULE_4__["MolScriptSymbolTable"].structureQuery.type.labelResidueId, 'label-resid'),
            Alias(_language_symbol_table__WEBPACK_IMPORTED_MODULE_4__["MolScriptSymbolTable"].structureQuery.type.ringFingerprint, 'ringfp'),
            Alias(_language_symbol_table__WEBPACK_IMPORTED_MODULE_4__["MolScriptSymbolTable"].structureQuery.type.bondFlags, 'bond-flags'),
        ],
        [
            'Slots',
            Alias(_language_symbol_table__WEBPACK_IMPORTED_MODULE_4__["MolScriptSymbolTable"].structureQuery.slot.elementSetReduce, 'atom.set.reduce.value'),
        ],
        [
            'Generators',
            Alias(_language_symbol_table__WEBPACK_IMPORTED_MODULE_4__["MolScriptSymbolTable"].structureQuery.generator.atomGroups, 'sel.atom.atom-groups'),
            Alias(_language_symbol_table__WEBPACK_IMPORTED_MODULE_4__["MolScriptSymbolTable"].structureQuery.generator.queryInSelection, 'sel.atom.query-in-selection'),
            Alias(_language_symbol_table__WEBPACK_IMPORTED_MODULE_4__["MolScriptSymbolTable"].structureQuery.generator.rings, 'sel.atom.rings'),
            Alias(_language_symbol_table__WEBPACK_IMPORTED_MODULE_4__["MolScriptSymbolTable"].structureQuery.generator.empty, 'sel.atom.empty'),
            Alias(_language_symbol_table__WEBPACK_IMPORTED_MODULE_4__["MolScriptSymbolTable"].structureQuery.generator.all, 'sel.atom.all'),
            Alias(_language_symbol_table__WEBPACK_IMPORTED_MODULE_4__["MolScriptSymbolTable"].structureQuery.generator.bondedAtomicPairs, 'sel.atom.bonded-pairs'),
            Macro(Object(_language_symbol__WEBPACK_IMPORTED_MODULE_3__["MSymbol"])('sel.atom.atoms', _language_symbol__WEBPACK_IMPORTED_MODULE_3__["Arguments"].Dictionary({
                0: Object(_language_symbol__WEBPACK_IMPORTED_MODULE_3__["Argument"])(_language_type__WEBPACK_IMPORTED_MODULE_5__["default"].Bool, { isOptional: true, defaultValue: true, description: 'Test applied to each atom.' })
            }), _language_symbol_table_structure_query__WEBPACK_IMPORTED_MODULE_6__["Types"].ElementSelection, 'A selection of singleton atom sets.'), function (args) { return _language_builder__WEBPACK_IMPORTED_MODULE_7__["MolScriptBuilder"].struct.generator.atomGroups({ 'atom-test': Object(_macro__WEBPACK_IMPORTED_MODULE_8__["tryGetArg"])(args, 0, true) }); }),
            Macro(Object(_language_symbol__WEBPACK_IMPORTED_MODULE_3__["MSymbol"])('sel.atom.res', _language_symbol__WEBPACK_IMPORTED_MODULE_3__["Arguments"].Dictionary({
                0: Object(_language_symbol__WEBPACK_IMPORTED_MODULE_3__["Argument"])(_language_type__WEBPACK_IMPORTED_MODULE_5__["default"].Bool, { isOptional: true, defaultValue: true, description: 'Test applied to the 1st atom of each residue.' })
            }), _language_symbol_table_structure_query__WEBPACK_IMPORTED_MODULE_6__["Types"].ElementSelection, 'A selection of atom sets grouped by residue.'), function (args) { return _language_builder__WEBPACK_IMPORTED_MODULE_7__["MolScriptBuilder"].struct.generator.atomGroups({
                'residue-test': Object(_macro__WEBPACK_IMPORTED_MODULE_8__["tryGetArg"])(args, 0, true),
                'group-by': _language_builder__WEBPACK_IMPORTED_MODULE_7__["MolScriptBuilder"].ammp('residueKey')
            }); }),
            Macro(Object(_language_symbol__WEBPACK_IMPORTED_MODULE_3__["MSymbol"])('sel.atom.chains', _language_symbol__WEBPACK_IMPORTED_MODULE_3__["Arguments"].Dictionary({
                0: Object(_language_symbol__WEBPACK_IMPORTED_MODULE_3__["Argument"])(_language_type__WEBPACK_IMPORTED_MODULE_5__["default"].Bool, { isOptional: true, defaultValue: true, description: 'Test applied to the 1st atom of each chain.' })
            }), _language_symbol_table_structure_query__WEBPACK_IMPORTED_MODULE_6__["Types"].ElementSelection, 'A selection of atom sets grouped by chain.'), function (args) { return _language_builder__WEBPACK_IMPORTED_MODULE_7__["MolScriptBuilder"].struct.generator.atomGroups({
                'chain-test': Object(_macro__WEBPACK_IMPORTED_MODULE_8__["tryGetArg"])(args, 0, true),
                'group-by': _language_builder__WEBPACK_IMPORTED_MODULE_7__["MolScriptBuilder"].ammp('chainKey')
            }); }),
        ],
        [
            'Modifiers',
            Alias(_language_symbol_table__WEBPACK_IMPORTED_MODULE_4__["MolScriptSymbolTable"].structureQuery.modifier.queryEach, 'sel.atom.query-each'),
            Alias(_language_symbol_table__WEBPACK_IMPORTED_MODULE_4__["MolScriptSymbolTable"].structureQuery.modifier.intersectBy, 'sel.atom.intersect-by'),
            Alias(_language_symbol_table__WEBPACK_IMPORTED_MODULE_4__["MolScriptSymbolTable"].structureQuery.modifier.exceptBy, 'sel.atom.except-by'),
            Alias(_language_symbol_table__WEBPACK_IMPORTED_MODULE_4__["MolScriptSymbolTable"].structureQuery.modifier.unionBy, 'sel.atom.union-by'),
            Alias(_language_symbol_table__WEBPACK_IMPORTED_MODULE_4__["MolScriptSymbolTable"].structureQuery.modifier.union, 'sel.atom.union'),
            Alias(_language_symbol_table__WEBPACK_IMPORTED_MODULE_4__["MolScriptSymbolTable"].structureQuery.modifier.cluster, 'sel.atom.cluster'),
            Alias(_language_symbol_table__WEBPACK_IMPORTED_MODULE_4__["MolScriptSymbolTable"].structureQuery.modifier.includeSurroundings, 'sel.atom.include-surroundings'),
            Alias(_language_symbol_table__WEBPACK_IMPORTED_MODULE_4__["MolScriptSymbolTable"].structureQuery.modifier.includeConnected, 'sel.atom.include-connected'),
            Alias(_language_symbol_table__WEBPACK_IMPORTED_MODULE_4__["MolScriptSymbolTable"].structureQuery.modifier.expandProperty, 'sel.atom.expand-property'),
        ],
        [
            'Filters',
            Alias(_language_symbol_table__WEBPACK_IMPORTED_MODULE_4__["MolScriptSymbolTable"].structureQuery.filter.pick, 'sel.atom.pick'),
            Alias(_language_symbol_table__WEBPACK_IMPORTED_MODULE_4__["MolScriptSymbolTable"].structureQuery.filter.first, 'sel.atom.first'),
            Alias(_language_symbol_table__WEBPACK_IMPORTED_MODULE_4__["MolScriptSymbolTable"].structureQuery.filter.withSameAtomProperties, 'sel.atom.with-same-atom-properties'),
            Alias(_language_symbol_table__WEBPACK_IMPORTED_MODULE_4__["MolScriptSymbolTable"].structureQuery.filter.intersectedBy, 'sel.atom.intersected-by'),
            Alias(_language_symbol_table__WEBPACK_IMPORTED_MODULE_4__["MolScriptSymbolTable"].structureQuery.filter.within, 'sel.atom.within'),
            Alias(_language_symbol_table__WEBPACK_IMPORTED_MODULE_4__["MolScriptSymbolTable"].structureQuery.filter.isConnectedTo, 'sel.atom.is-connected-to'),
        ],
        [
            'Combinators',
            Alias(_language_symbol_table__WEBPACK_IMPORTED_MODULE_4__["MolScriptSymbolTable"].structureQuery.combinator.intersect, 'sel.atom.intersect'),
            Alias(_language_symbol_table__WEBPACK_IMPORTED_MODULE_4__["MolScriptSymbolTable"].structureQuery.combinator.merge, 'sel.atom.merge'),
            Alias(_language_symbol_table__WEBPACK_IMPORTED_MODULE_4__["MolScriptSymbolTable"].structureQuery.combinator.distanceCluster, 'sel.atom.dist-cluster'),
        ],
        [
            'Atom Set Properties',
            Alias(_language_symbol_table__WEBPACK_IMPORTED_MODULE_4__["MolScriptSymbolTable"].structureQuery.atomSet.atomCount, 'atom.set.atom-count'),
            Alias(_language_symbol_table__WEBPACK_IMPORTED_MODULE_4__["MolScriptSymbolTable"].structureQuery.atomSet.countQuery, 'atom.set.count-query'),
            Alias(_language_symbol_table__WEBPACK_IMPORTED_MODULE_4__["MolScriptSymbolTable"].structureQuery.atomSet.reduce, 'atom.set.reduce'),
            Alias(_language_symbol_table__WEBPACK_IMPORTED_MODULE_4__["MolScriptSymbolTable"].structureQuery.atomSet.propertySet, 'atom.set.property'),
        ],
        [
            'Atom Properties',
            Alias(_language_symbol_table__WEBPACK_IMPORTED_MODULE_4__["MolScriptSymbolTable"].structureQuery.atomProperty.core.elementSymbol, 'atom.el'),
            Alias(_language_symbol_table__WEBPACK_IMPORTED_MODULE_4__["MolScriptSymbolTable"].structureQuery.atomProperty.core.vdw, 'atom.vdw'),
            Alias(_language_symbol_table__WEBPACK_IMPORTED_MODULE_4__["MolScriptSymbolTable"].structureQuery.atomProperty.core.mass, 'atom.mass'),
            Alias(_language_symbol_table__WEBPACK_IMPORTED_MODULE_4__["MolScriptSymbolTable"].structureQuery.atomProperty.core.atomicNumber, 'atom.atomic-number'),
            Alias(_language_symbol_table__WEBPACK_IMPORTED_MODULE_4__["MolScriptSymbolTable"].structureQuery.atomProperty.core.x, 'atom.x'),
            Alias(_language_symbol_table__WEBPACK_IMPORTED_MODULE_4__["MolScriptSymbolTable"].structureQuery.atomProperty.core.y, 'atom.y'),
            Alias(_language_symbol_table__WEBPACK_IMPORTED_MODULE_4__["MolScriptSymbolTable"].structureQuery.atomProperty.core.z, 'atom.z'),
            Alias(_language_symbol_table__WEBPACK_IMPORTED_MODULE_4__["MolScriptSymbolTable"].structureQuery.atomProperty.core.sourceIndex, 'atom.src-index'),
            Alias(_language_symbol_table__WEBPACK_IMPORTED_MODULE_4__["MolScriptSymbolTable"].structureQuery.atomProperty.core.operatorName, 'atom.op-name'),
            Alias(_language_symbol_table__WEBPACK_IMPORTED_MODULE_4__["MolScriptSymbolTable"].structureQuery.atomProperty.core.modelIndex, 'atom.model-index'),
            Alias(_language_symbol_table__WEBPACK_IMPORTED_MODULE_4__["MolScriptSymbolTable"].structureQuery.atomProperty.core.modelLabel, 'atom.model-label'),
            Alias(_language_symbol_table__WEBPACK_IMPORTED_MODULE_4__["MolScriptSymbolTable"].structureQuery.atomProperty.core.atomKey, 'atom.key'),
            Alias(_language_symbol_table__WEBPACK_IMPORTED_MODULE_4__["MolScriptSymbolTable"].structureQuery.atomProperty.core.bondCount, 'atom.bond-count'),
            Alias(_language_symbol_table__WEBPACK_IMPORTED_MODULE_4__["MolScriptSymbolTable"].structureQuery.atomProperty.topology.connectedComponentKey, 'atom.key.molecule'),
            Alias(_language_symbol_table__WEBPACK_IMPORTED_MODULE_4__["MolScriptSymbolTable"].structureQuery.atomProperty.macromolecular.authResidueId, 'atom.auth-resid'),
            Alias(_language_symbol_table__WEBPACK_IMPORTED_MODULE_4__["MolScriptSymbolTable"].structureQuery.atomProperty.macromolecular.labelResidueId, 'atom.label-resid'),
            Alias(_language_symbol_table__WEBPACK_IMPORTED_MODULE_4__["MolScriptSymbolTable"].structureQuery.atomProperty.macromolecular.residueKey, 'atom.key.res'),
            Alias(_language_symbol_table__WEBPACK_IMPORTED_MODULE_4__["MolScriptSymbolTable"].structureQuery.atomProperty.macromolecular.chainKey, 'atom.key.chain'),
            Alias(_language_symbol_table__WEBPACK_IMPORTED_MODULE_4__["MolScriptSymbolTable"].structureQuery.atomProperty.macromolecular.entityKey, 'atom.key.entity'),
            Alias(_language_symbol_table__WEBPACK_IMPORTED_MODULE_4__["MolScriptSymbolTable"].structureQuery.atomProperty.macromolecular.isHet, 'atom.is-het'),
            Alias(_language_symbol_table__WEBPACK_IMPORTED_MODULE_4__["MolScriptSymbolTable"].structureQuery.atomProperty.macromolecular.id, 'atom.id'),
            Alias(_language_symbol_table__WEBPACK_IMPORTED_MODULE_4__["MolScriptSymbolTable"].structureQuery.atomProperty.macromolecular.label_atom_id, 'atom.label_atom_id'),
            Alias(_language_symbol_table__WEBPACK_IMPORTED_MODULE_4__["MolScriptSymbolTable"].structureQuery.atomProperty.macromolecular.label_alt_id, 'atom.label_alt_id', 'atom.altloc'),
            Alias(_language_symbol_table__WEBPACK_IMPORTED_MODULE_4__["MolScriptSymbolTable"].structureQuery.atomProperty.macromolecular.label_comp_id, 'atom.label_comp_id'),
            Alias(_language_symbol_table__WEBPACK_IMPORTED_MODULE_4__["MolScriptSymbolTable"].structureQuery.atomProperty.macromolecular.label_asym_id, 'atom.label_asym_id'),
            Alias(_language_symbol_table__WEBPACK_IMPORTED_MODULE_4__["MolScriptSymbolTable"].structureQuery.atomProperty.macromolecular.label_entity_id, 'atom.label_entity_id'),
            Alias(_language_symbol_table__WEBPACK_IMPORTED_MODULE_4__["MolScriptSymbolTable"].structureQuery.atomProperty.macromolecular.label_seq_id, 'atom.label_seq_id'),
            Alias(_language_symbol_table__WEBPACK_IMPORTED_MODULE_4__["MolScriptSymbolTable"].structureQuery.atomProperty.macromolecular.auth_atom_id, 'atom.auth_atom_id', 'atom.name'),
            Alias(_language_symbol_table__WEBPACK_IMPORTED_MODULE_4__["MolScriptSymbolTable"].structureQuery.atomProperty.macromolecular.auth_comp_id, 'atom.auth_comp_id', 'atom.resname'),
            Alias(_language_symbol_table__WEBPACK_IMPORTED_MODULE_4__["MolScriptSymbolTable"].structureQuery.atomProperty.macromolecular.auth_asym_id, 'atom.auth_asym_id', 'atom.chain'),
            Alias(_language_symbol_table__WEBPACK_IMPORTED_MODULE_4__["MolScriptSymbolTable"].structureQuery.atomProperty.macromolecular.auth_seq_id, 'atom.auth_seq_id', 'atom.resno'),
            Alias(_language_symbol_table__WEBPACK_IMPORTED_MODULE_4__["MolScriptSymbolTable"].structureQuery.atomProperty.macromolecular.pdbx_PDB_ins_code, 'atom.pdbx_PDB_ins_code', 'atom.inscode'),
            Alias(_language_symbol_table__WEBPACK_IMPORTED_MODULE_4__["MolScriptSymbolTable"].structureQuery.atomProperty.macromolecular.pdbx_formal_charge, 'atom.pdbx_formal_charge'),
            Alias(_language_symbol_table__WEBPACK_IMPORTED_MODULE_4__["MolScriptSymbolTable"].structureQuery.atomProperty.macromolecular.occupancy, 'atom.occupancy'),
            Alias(_language_symbol_table__WEBPACK_IMPORTED_MODULE_4__["MolScriptSymbolTable"].structureQuery.atomProperty.macromolecular.B_iso_or_equiv, 'atom.B_iso_or_equiv', 'atom.bfactor'),
            Alias(_language_symbol_table__WEBPACK_IMPORTED_MODULE_4__["MolScriptSymbolTable"].structureQuery.atomProperty.macromolecular.entityType, 'atom.entity-type'),
            Alias(_language_symbol_table__WEBPACK_IMPORTED_MODULE_4__["MolScriptSymbolTable"].structureQuery.atomProperty.macromolecular.entitySubtype, 'atom.entity-subtype'),
            Alias(_language_symbol_table__WEBPACK_IMPORTED_MODULE_4__["MolScriptSymbolTable"].structureQuery.atomProperty.macromolecular.entityPrdId, 'atom.entity-prd-id'),
            Alias(_language_symbol_table__WEBPACK_IMPORTED_MODULE_4__["MolScriptSymbolTable"].structureQuery.atomProperty.macromolecular.entityDescription, 'atom.entity-description'),
            Alias(_language_symbol_table__WEBPACK_IMPORTED_MODULE_4__["MolScriptSymbolTable"].structureQuery.atomProperty.macromolecular.objectPrimitive, 'atom.object-primitive'),
            Alias(_language_symbol_table__WEBPACK_IMPORTED_MODULE_4__["MolScriptSymbolTable"].structureQuery.atomProperty.macromolecular.chemCompType, 'atom.chem-comp-type'),
            Alias(_language_symbol_table__WEBPACK_IMPORTED_MODULE_4__["MolScriptSymbolTable"].structureQuery.atomProperty.macromolecular.secondaryStructureKey, 'atom.key.sec-struct'),
            Alias(_language_symbol_table__WEBPACK_IMPORTED_MODULE_4__["MolScriptSymbolTable"].structureQuery.atomProperty.macromolecular.isModified, 'atom.is-modified'),
            Alias(_language_symbol_table__WEBPACK_IMPORTED_MODULE_4__["MolScriptSymbolTable"].structureQuery.atomProperty.macromolecular.modifiedParentName, 'atom.modified-parent'),
        ],
        [
            'Bond Properties',
            Alias(_language_symbol_table__WEBPACK_IMPORTED_MODULE_4__["MolScriptSymbolTable"].structureQuery.bondProperty.order, 'bond.order'),
            Alias(_language_symbol_table__WEBPACK_IMPORTED_MODULE_4__["MolScriptSymbolTable"].structureQuery.bondProperty.length, 'bond.length'),
            Alias(_language_symbol_table__WEBPACK_IMPORTED_MODULE_4__["MolScriptSymbolTable"].structureQuery.bondProperty.atomA, 'bond.atom-a'),
            Alias(_language_symbol_table__WEBPACK_IMPORTED_MODULE_4__["MolScriptSymbolTable"].structureQuery.bondProperty.atomB, 'bond.atom-b'),
            Macro(Object(_language_symbol__WEBPACK_IMPORTED_MODULE_3__["MSymbol"])('bond.is', _language_symbol__WEBPACK_IMPORTED_MODULE_3__["Arguments"].List(_language_symbol_table_structure_query__WEBPACK_IMPORTED_MODULE_6__["Types"].BondFlag), _language_type__WEBPACK_IMPORTED_MODULE_5__["default"].Bool, "Test if the current bond has at least one (or all if partial = false) of the specified flags: " + _language_type__WEBPACK_IMPORTED_MODULE_5__["default"].oneOfValues(_language_symbol_table_structure_query__WEBPACK_IMPORTED_MODULE_6__["Types"].BondFlag).join(', ')), function (args) { return _language_builder__WEBPACK_IMPORTED_MODULE_7__["MolScriptBuilder"].core.flags.hasAny([_language_builder__WEBPACK_IMPORTED_MODULE_7__["MolScriptBuilder"].struct.bondProperty.flags(), _language_builder__WEBPACK_IMPORTED_MODULE_7__["MolScriptBuilder"].struct.type.bondFlags(Object(_macro__WEBPACK_IMPORTED_MODULE_8__["getPositionalArgs"])(args))]); }),
        ]
    ]
];
var list = [];
function makeList(xs) {
    for (var _a = 0, xs_1 = xs; _a < xs_1.length; _a++) {
        var x = xs_1[_a];
        if (isMolScriptSymbol(x))
            list.push(x);
        else if (x instanceof Array)
            makeList(x);
    }
}
makeList(SymbolTable);
var normalized = (function () {
    var symbolList = [];
    var symbolMap = Object.create(null);
    var namedArgs = _mol_data_generic__WEBPACK_IMPORTED_MODULE_1__["UniqueArray"].create();
    var constants = _mol_data_generic__WEBPACK_IMPORTED_MODULE_1__["UniqueArray"].create();
    for (var _a = 0, list_1 = list; _a < list_1.length; _a++) {
        var s = list_1[_a];
        for (var _b = 0, _c = s.aliases; _b < _c.length; _b++) {
            var a = _c[_b];
            symbolList.push([a, s]);
            if (symbolMap[a])
                throw new Error("Alias '" + a + "' already in use.");
            symbolMap[a] = s;
        }
        var args = s.symbol.args;
        if (args.kind !== 'dictionary') {
            if (args.type.kind === 'oneof') {
                _language_type__WEBPACK_IMPORTED_MODULE_5__["default"].oneOfValues(args.type).forEach(function (v) { return _mol_data_generic__WEBPACK_IMPORTED_MODULE_1__["UniqueArray"].add(constants, v, v); });
            }
            continue;
        }
        for (var _d = 0, _e = Object.keys(args.map); _d < _e.length; _d++) {
            var a = _e[_d];
            if (isNaN(a))
                _mol_data_generic__WEBPACK_IMPORTED_MODULE_1__["UniqueArray"].add(namedArgs, a, a);
            var arg = (args.map[a]);
            if (arg.type.kind === 'oneof') {
                _language_type__WEBPACK_IMPORTED_MODULE_5__["default"].oneOfValues(arg.type).forEach(function (v) { return _mol_data_generic__WEBPACK_IMPORTED_MODULE_1__["UniqueArray"].add(constants, v, v); });
            }
        }
    }
    return { symbolList: symbolList, symbolMap: symbolMap, namedArgs: namedArgs.array, constants: constants.array };
})();
var MolScriptSymbols = list;
var Constants = normalized.constants;
var NamedArgs = normalized.namedArgs;
var SymbolMap = normalized.symbolMap;
var SymbolList = normalized.symbolList;
function substSymbols(expr) {
    if (_language_expression__WEBPACK_IMPORTED_MODULE_2__["default"].isLiteral(expr)) {
        return expr;
    }
    if (_language_expression__WEBPACK_IMPORTED_MODULE_2__["default"].isSymbol(expr)) {
        if (!SymbolMap[expr.name])
            return expr;
        var s = SymbolMap[expr.name];
        if (s.kind === 'alias')
            return _language_expression__WEBPACK_IMPORTED_MODULE_2__["default"].Symbol(SymbolMap[expr.name].symbol.id);
        throw s.translate([]);
    }
    var isMacro = _language_expression__WEBPACK_IMPORTED_MODULE_2__["default"].isSymbol(expr.head) && !!SymbolMap[expr.head.name] && SymbolMap[expr.head.name].kind === 'macro';
    var head = isMacro ? expr.head : substSymbols(expr.head);
    var headChanged = head !== expr.head;
    if (!expr.args) {
        if (isMacro)
            return substSymbols(expr.head); // TODO: is this correct?
        return headChanged ? _language_expression__WEBPACK_IMPORTED_MODULE_2__["default"].Apply(head) : expr;
    }
    var argsChanged = false;
    var newArgs;
    if (_language_expression__WEBPACK_IMPORTED_MODULE_2__["default"].isArgumentsArray(expr.args)) {
        newArgs = [];
        for (var i = 0, _i = expr.args.length; i < _i; i++) {
            var oldArg = expr.args[i];
            var newArg = substSymbols(oldArg);
            if (oldArg !== newArg)
                argsChanged = true;
            newArgs[newArgs.length] = newArg;
        }
        if (!argsChanged)
            newArgs = expr.args;
        if (!isMacro && !headChanged && !argsChanged)
            return expr;
    }
    else {
        newArgs = {};
        for (var _a = 0, _b = Object.keys(expr.args); _a < _b.length; _a++) {
            var key = _b[_a];
            var oldArg = expr.args[key];
            var newArg = substSymbols(oldArg);
            if (oldArg !== newArg)
                argsChanged = true;
            newArgs[key] = newArg;
        }
        if (!isMacro && !headChanged && !argsChanged)
            return expr;
        if (!argsChanged)
            newArgs = expr.args;
    }
    if (isMacro) {
        var macro = SymbolMap[expr.head.name];
        if (macro.kind !== 'macro')
            return _language_expression__WEBPACK_IMPORTED_MODULE_2__["default"].Apply(head, newArgs);
        var ret = macro.translate(newArgs);
        return ret;
    }
    return _language_expression__WEBPACK_IMPORTED_MODULE_2__["default"].Apply(head, newArgs);
}
function transpileMolScript(expr) {
    return substSymbols(expr);
}
// const sortedSymbols = SymbolList.map(s => s[0]).sort((a, b) => {
//     if (a.length === b.length) return (a < b) as any;
//     return a.length - b.length;
// });
// export default [...sortedSymbols, ...NamedArgs.map(a => ':' + a), ...Constants];
//# sourceMappingURL=symbols.js.map

/***/ }),

/***/ "./lib/mol-state/action.js":
/*!*********************************!*\
  !*** ./lib/mol-state/action.js ***!
  \*********************************/
/*! exports provided: StateAction */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "StateAction", function() { return StateAction; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _mol_util__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../mol-util */ "./lib/mol-util/index.js");
/* harmony import */ var _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../mol-util/param-definition */ "./lib/mol-util/param-definition.js");
/**
 * Copyright (c) 2018 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author David Sehnal <david.sehnal@gmail.com>
 */




var StateAction;
(function (StateAction) {
    function create(definition) {
        var action = {
            create: function (params) { return { action: action, params: params }; },
            id: _mol_util__WEBPACK_IMPORTED_MODULE_1__["UUID"].create22(),
            definition: definition,
            createDefaultParams: function (a, globalCtx) { return definition.params ? _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_2__["ParamDefinition"].getDefaultValues(definition.params(a, globalCtx)) : {}; }
        };
        return action;
    }
    StateAction.create = create;
    function fromTransformer(transformer) {
        var def = transformer.definition;
        return create({
            from: def.from,
            display: def.display,
            params: def.params,
            isApplicable: transformer.definition.isApplicable
                ? function (a, t, ctx) { return transformer.definition.isApplicable(a, ctx); }
                : void 0,
            run: function (_a) {
                var cell = _a.cell, state = _a.state, params = _a.params;
                var tree = state.build().to(cell.transform.ref).apply(transformer, params);
                return state.updateTree(tree);
            }
        });
    }
    StateAction.fromTransformer = fromTransformer;
    var Builder;
    (function (Builder) {
        function root(info) {
            return function (def) { return create(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({ from: info.from instanceof Array
                    ? info.from
                    : !!info.from ? [info.from] : [], display: typeof info.display === 'string'
                    ? { name: info.display }
                    : !!info.display
                        ? info.display
                        : { name: 'Unnamed State Action' }, params: typeof info.params === 'object'
                    ? function () { return info.params; }
                    : !!info.params
                        ? info.params
                        : void 0, isApplicable: info.isApplicable }, (typeof def === 'function'
                ? { run: def }
                : def))); };
        }
        Builder.build = function (info) { return root(info); };
    })(Builder = StateAction.Builder || (StateAction.Builder = {}));
    StateAction.build = Builder.build;
})(StateAction || (StateAction = {}));
//# sourceMappingURL=action.js.map

/***/ }),

/***/ "./lib/mol-state/action/manager.js":
/*!*****************************************!*\
  !*** ./lib/mol-state/action/manager.js ***!
  \*****************************************/
/*! exports provided: StateActionManager */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "StateActionManager", function() { return StateActionManager; });
/* harmony import */ var _transformer__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../transformer */ "./lib/mol-state/transformer.js");
/* harmony import */ var _mol_util__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../mol-util */ "./lib/mol-util/index.js");
/* harmony import */ var _mol_util_array__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../mol-util/array */ "./lib/mol-util/array.js");
/* harmony import */ var _mol_util_rx_event_helper__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../mol-util/rx-event-helper */ "./lib/mol-util/rx-event-helper.js");
/**
 * Copyright (c) 2018 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author David Sehnal <david.sehnal@gmail.com>
 */





var StateActionManager = /** @class */ (function () {
    function StateActionManager() {
        this.ev = _mol_util_rx_event_helper__WEBPACK_IMPORTED_MODULE_3__["RxEventHelper"].create();
        this.actions = new Map();
        this.fromTypeIndex = new Map();
        this.events = {
            added: this.ev(),
            removed: this.ev(),
        };
    }
    StateActionManager.prototype.add = function (actionOrTransformer) {
        var action = _transformer__WEBPACK_IMPORTED_MODULE_0__["StateTransformer"].is(actionOrTransformer) ? actionOrTransformer.toAction() : actionOrTransformer;
        if (this.actions.has(action.id))
            return this;
        this.actions.set(action.id, action);
        for (var _i = 0, _a = action.definition.from; _i < _a.length; _i++) {
            var t = _a[_i];
            if (this.fromTypeIndex.has(t.type)) {
                this.fromTypeIndex.get(t.type).push(action);
            }
            else {
                this.fromTypeIndex.set(t.type, [action]);
            }
        }
        this.events.added.next();
        return this;
    };
    StateActionManager.prototype.remove = function (actionOrTransformer) {
        var id = _transformer__WEBPACK_IMPORTED_MODULE_0__["StateTransformer"].is(actionOrTransformer)
            ? actionOrTransformer.toAction().id
            : _mol_util__WEBPACK_IMPORTED_MODULE_1__["UUID"].is(actionOrTransformer)
                ? actionOrTransformer
                : actionOrTransformer.id;
        var action = this.actions.get(id);
        if (!action)
            return this;
        this.actions.delete(id);
        for (var _i = 0, _a = action.definition.from; _i < _a.length; _i++) {
            var t = _a[_i];
            var xs = this.fromTypeIndex.get(t.type);
            if (!xs)
                continue;
            Object(_mol_util_array__WEBPACK_IMPORTED_MODULE_2__["arraySetRemove"])(xs, action);
            if (xs.length === 0)
                this.fromTypeIndex.delete(t.type);
        }
        this.events.removed.next();
        return this;
    };
    StateActionManager.prototype.fromCell = function (cell, ctx) {
        var obj = cell.obj;
        if (!obj)
            return [];
        var actions = this.fromTypeIndex.get(obj.type);
        if (!actions)
            return [];
        var hasTest = false;
        for (var _i = 0, actions_1 = actions; _i < actions_1.length; _i++) {
            var a = actions_1[_i];
            if (a.definition.isApplicable) {
                hasTest = true;
                break;
            }
        }
        if (!hasTest)
            return actions;
        var ret = [];
        for (var _a = 0, actions_2 = actions; _a < actions_2.length; _a++) {
            var a = actions_2[_a];
            if (a.definition.isApplicable) {
                if (a.definition.isApplicable(obj, cell.transform, ctx)) {
                    ret.push(a);
                }
            }
            else {
                ret.push(a);
            }
        }
        return ret;
    };
    StateActionManager.prototype.dispose = function () {
        this.ev.dispose();
    };
    return StateActionManager;
}());
//# sourceMappingURL=manager.js.map

/***/ }),

/***/ "./lib/mol-state/index.js":
/*!********************************!*\
  !*** ./lib/mol-state/index.js ***!
  \********************************/
/*! exports provided: StateObject, StateObjectCell, StateObjectTracker, StateObjectSelector, StateObjectRef, StateTree, TransientTree, State, StateBuilder, StateSelection, StateTransformer, StateTransform, StateAction */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _object__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./object */ "./lib/mol-state/object.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "StateObject", function() { return _object__WEBPACK_IMPORTED_MODULE_0__["StateObject"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "StateObjectCell", function() { return _object__WEBPACK_IMPORTED_MODULE_0__["StateObjectCell"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "StateObjectTracker", function() { return _object__WEBPACK_IMPORTED_MODULE_0__["StateObjectTracker"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "StateObjectSelector", function() { return _object__WEBPACK_IMPORTED_MODULE_0__["StateObjectSelector"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "StateObjectRef", function() { return _object__WEBPACK_IMPORTED_MODULE_0__["StateObjectRef"]; });

/* harmony import */ var _tree__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./tree */ "./lib/mol-state/tree.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "StateTree", function() { return _tree__WEBPACK_IMPORTED_MODULE_1__["StateTree"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "TransientTree", function() { return _tree__WEBPACK_IMPORTED_MODULE_1__["TransientTree"]; });

/* harmony import */ var _state__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./state */ "./lib/mol-state/state.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "State", function() { return _state__WEBPACK_IMPORTED_MODULE_2__["State"]; });

/* harmony import */ var _state_builder__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./state/builder */ "./lib/mol-state/state/builder.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "StateBuilder", function() { return _state_builder__WEBPACK_IMPORTED_MODULE_3__["StateBuilder"]; });

/* harmony import */ var _state_selection__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./state/selection */ "./lib/mol-state/state/selection.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "StateSelection", function() { return _state_selection__WEBPACK_IMPORTED_MODULE_4__["StateSelection"]; });

/* harmony import */ var _transformer__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./transformer */ "./lib/mol-state/transformer.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "StateTransformer", function() { return _transformer__WEBPACK_IMPORTED_MODULE_5__["StateTransformer"]; });

/* harmony import */ var _transform__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ./transform */ "./lib/mol-state/transform.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "StateTransform", function() { return _transform__WEBPACK_IMPORTED_MODULE_6__["StateTransform"]; });

/* harmony import */ var _action__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ./action */ "./lib/mol-state/action.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "StateAction", function() { return _action__WEBPACK_IMPORTED_MODULE_7__["StateAction"]; });

/**
 * Copyright (c) 2018 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author David Sehnal <david.sehnal@gmail.com>
 */








//# sourceMappingURL=index.js.map

/***/ }),

/***/ "./lib/mol-state/object.js":
/*!*********************************!*\
  !*** ./lib/mol-state/object.js ***!
  \*********************************/
/*! exports provided: StateObject, StateObjectCell, StateObjectTracker, StateObjectSelector, StateObjectRef */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "StateObject", function() { return StateObject; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "StateObjectCell", function() { return StateObjectCell; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "StateObjectTracker", function() { return StateObjectTracker; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "StateObjectSelector", function() { return StateObjectSelector; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "StateObjectRef", function() { return StateObjectRef; });
/* harmony import */ var _mol_util__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../mol-util */ "./lib/mol-util/index.js");
/* harmony import */ var _mol_state__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../mol-state */ "./lib/mol-state/index.js");
/**
 * Copyright (c) 2018 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author David Sehnal <david.sehnal@gmail.com>
 */



var StateObject;
(function (StateObject) {
    function factory() {
        return function (type) { return create(type); };
    }
    StateObject.factory = factory;
    function create(type) {
        var _a;
        return _a = /** @class */ (function () {
                function O(data, props) {
                    this.data = data;
                    this.id = _mol_util__WEBPACK_IMPORTED_MODULE_0__["UUID"].create22();
                    this.type = type;
                    this.label = props && props.label || type.name;
                    this.description = props && props.description;
                }
                O.is = function (obj) { return !!obj && type === obj.type; };
                return O;
            }()),
            _a.type = type,
            _a;
    }
    StateObject.create = create;
    function hasTag(o, t) {
        if (!o.tags)
            return false;
        for (var _i = 0, _a = o.tags; _i < _a.length; _i++) {
            var s = _a[_i];
            if (s === t)
                return true;
        }
        return false;
    }
    StateObject.hasTag = hasTag;
    /** A special object indicating a transformer result has no value. */
    StateObject.Null = {
        id: _mol_util__WEBPACK_IMPORTED_MODULE_0__["UUID"].create22(),
        type: { name: 'Null', typeClass: 'Null' },
        data: void 0,
        label: 'Null'
    };
})(StateObject || (StateObject = {}));
var StateObjectCell;
(function (StateObjectCell) {
    function is(o) {
        var c = o;
        return !!c && !!c.transform && !!c.parent && !!c.status;
    }
    StateObjectCell.is = is;
    function resolve(state, refOrCellOrSelector) {
        var ref = typeof refOrCellOrSelector === 'string'
            ? refOrCellOrSelector
            : StateObjectCell.is(refOrCellOrSelector)
                ? refOrCellOrSelector.transform.ref
                : refOrCellOrSelector.ref;
        return state.cells.get(ref);
    }
    StateObjectCell.resolve = resolve;
})(StateObjectCell || (StateObjectCell = {}));
// TODO: improve the API?
var StateObjectTracker = /** @class */ (function () {
    function StateObjectTracker(state) {
        this.state = state;
        this.version = '';
    }
    StateObjectTracker.prototype.setQuery = function (sel) {
        this.query = _mol_state__WEBPACK_IMPORTED_MODULE_1__["StateSelection"].compile(sel);
    };
    StateObjectTracker.prototype.update = function () {
        var cell = this.state.select(this.query)[0];
        var version = cell ? cell.transform.version : void 0;
        var changed = this.cell !== cell || this.version !== version;
        this.cell = cell;
        this.version = version || '';
        this.data = cell && cell.obj ? cell.obj.data : void 0;
        return changed;
    };
    return StateObjectTracker;
}());

var StateObjectSelector = /** @class */ (function () {
    function StateObjectSelector(ref, state) {
        this.ref = ref;
        this.state = state;
    }
    Object.defineProperty(StateObjectSelector.prototype, "cell", {
        get: function () {
            var _a;
            return (_a = this.state) === null || _a === void 0 ? void 0 : _a.cells.get(this.ref);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(StateObjectSelector.prototype, "obj", {
        get: function () {
            var _a, _b;
            return (_b = (_a = this.state) === null || _a === void 0 ? void 0 : _a.cells.get(this.ref)) === null || _b === void 0 ? void 0 : _b.obj;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(StateObjectSelector.prototype, "data", {
        get: function () {
            var _a;
            return (_a = this.obj) === null || _a === void 0 ? void 0 : _a.data;
        },
        enumerable: false,
        configurable: true
    });
    StateObjectSelector.prototype.update = function (params, builder) {
        if (!this.state)
            throw new Error("To use update() from StateObjectSelector, 'state' must be defined.");
        if (!builder)
            builder = this.state.build();
        (builder || this.state.build()).to(this).update(params);
        return builder;
    };
    /** Checks if the object exists. If not throw an error. */
    StateObjectSelector.prototype.checkValid = function () {
        if (!this.state) {
            throw new Error('Unassigned State.');
        }
        var cell = this.cell;
        if (!cell) {
            throw new Error("Not created at all. Did you await/then the corresponding state update?");
        }
        if (cell.status === 'ok')
            return true;
        if (cell.status === 'error')
            throw new Error(cell.errorText);
        if (cell.obj === StateObject.Null)
            throw new Error('The object is Null.');
        throw new Error("Unresolved. Did you await/then the corresponding state update?");
    };
    Object.defineProperty(StateObjectSelector.prototype, "isOk", {
        get: function () {
            var cell = this.cell;
            return cell && cell.status === 'ok' && cell.obj !== StateObject.Null;
        },
        enumerable: false,
        configurable: true
    });
    return StateObjectSelector;
}());

var StateObjectRef;
(function (StateObjectRef) {
    function resolveRef(ref) {
        var _a;
        if (!ref)
            return;
        if (typeof ref === 'string')
            return ref;
        if (StateObjectCell.is(ref))
            return ref.transform.ref;
        return (_a = ref.cell) === null || _a === void 0 ? void 0 : _a.transform.ref;
    }
    StateObjectRef.resolveRef = resolveRef;
    function resolve(state, ref) {
        if (!ref)
            return;
        if (StateObjectCell.is(ref))
            return ref;
        if (typeof ref === 'string')
            return state.cells.get(ref);
        return ref.cell;
    }
    StateObjectRef.resolve = resolve;
    function resolveAndCheck(state, ref) {
        var cell = resolve(state, ref);
        if (!cell || !cell.obj || cell.status !== 'ok')
            return;
        return cell;
    }
    StateObjectRef.resolveAndCheck = resolveAndCheck;
})(StateObjectRef || (StateObjectRef = {}));
//# sourceMappingURL=object.js.map

/***/ }),

/***/ "./lib/mol-state/state.js":
/*!********************************!*\
  !*** ./lib/mol-state/state.js ***!
  \********************************/
/*! exports provided: State */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "State", function() { return State; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _object__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./object */ "./lib/mol-state/object.js");
/* harmony import */ var _tree__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./tree */ "./lib/mol-state/tree.js");
/* harmony import */ var _transform__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./transform */ "./lib/mol-state/transform.js");
/* harmony import */ var _transformer__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./transformer */ "./lib/mol-state/transformer.js");
/* harmony import */ var _mol_task__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../mol-task */ "./lib/mol-task/index.js");
/* harmony import */ var _state_selection__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ./state/selection */ "./lib/mol-state/state/selection.js");
/* harmony import */ var _mol_util_rx_event_helper__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../mol-util/rx-event-helper */ "./lib/mol-util/rx-event-helper.js");
/* harmony import */ var _state_builder__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ./state/builder */ "./lib/mol-state/state/builder.js");
/* harmony import */ var _action_manager__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ./action/manager */ "./lib/mol-state/action/manager.js");
/* harmony import */ var _mol_util_log_entry__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ../mol-util/log-entry */ "./lib/mol-util/log-entry.js");
/* harmony import */ var _mol_util_now__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ../mol-util/now */ "./lib/mol-util/now.js");
/* harmony import */ var _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! ../mol-util/param-definition */ "./lib/mol-util/param-definition.js");
/* harmony import */ var _tree_spine__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! ./tree/spine */ "./lib/mol-state/tree/spine.js");
/* harmony import */ var _mol_util_async_queue__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! ../mol-util/async-queue */ "./lib/mol-util/async-queue.js");
/* harmony import */ var _mol_util_debug__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! ../mol-util/debug */ "./lib/mol-util/debug.js");
/* harmony import */ var _mol_util_array__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(/*! ../mol-util/array */ "./lib/mol-util/array.js");
/* harmony import */ var _mol_data_generic__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(/*! ../mol-data/generic */ "./lib/mol-data/generic.js");
/* harmony import */ var _mol_util_object__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(/*! ../mol-util/object */ "./lib/mol-util/object.js");
/**
 * Copyright (c) 2018-2020 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author David Sehnal <david.sehnal@gmail.com>
 */




















var State = /** @class */ (function () {
    function State(rootObject, params) {
        var _this = this;
        this.errorFree = true;
        this.ev = _mol_util_rx_event_helper__WEBPACK_IMPORTED_MODULE_7__["RxEventHelper"].create();
        this.globalContext = void 0;
        this.events = {
            cell: {
                stateUpdated: this.ev(),
                created: this.ev(),
                removed: this.ev(),
            },
            object: {
                updated: this.ev(),
                created: this.ev(),
                removed: this.ev()
            },
            log: this.ev(),
            changed: this.ev(),
            historyUpdated: this.ev()
        };
        this.behaviors = {
            currentObject: this.ev.behavior({ state: this, ref: _transform__WEBPACK_IMPORTED_MODULE_3__["StateTransform"].RootRef }),
            isUpdating: this.ev.behavior(false),
        };
        this.actions = new _action_manager__WEBPACK_IMPORTED_MODULE_9__["StateActionManager"]();
        this.cells = new Map();
        this.spine = new _tree_spine__WEBPACK_IMPORTED_MODULE_13__["StateTreeSpine"].Impl(this.cells);
        this.tryGetCellData = function (ref) {
            var _a, _b;
            var ret = (_b = (_a = _this.cells.get(ref)) === null || _a === void 0 ? void 0 : _a.obj) === null || _b === void 0 ? void 0 : _b.data;
            if (!ref)
                throw new Error("Cell '" + ref + "' data undefined.");
            return ret;
        };
        this.historyCapacity = 5;
        this.history = [];
        this.undoingHistory = false;
        this.inTransaction = false;
        this.inTransactionError = false;
        this._inUpdate = false;
        this.reverted = false;
        this.updateQueue = new _mol_util_async_queue__WEBPACK_IMPORTED_MODULE_14__["AsyncQueue"]();
        this._tree = _tree__WEBPACK_IMPORTED_MODULE_2__["StateTree"].createEmpty(_transform__WEBPACK_IMPORTED_MODULE_3__["StateTransform"].createRoot(params && params.rootState)).asTransient();
        var tree = this._tree;
        var root = tree.root;
        this.runTask = params.runTask;
        if ((params === null || params === void 0 ? void 0 : params.historyCapacity) !== void 0)
            this.historyCapacity = params.historyCapacity;
        this.cells.set(root.ref, {
            parent: this,
            transform: root,
            sourceRef: void 0,
            obj: rootObject,
            status: 'ok',
            state: Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, root.state),
            errorText: void 0,
            params: {
                definition: {},
                values: {}
            },
            paramsNormalizedVersion: root.version,
            dependencies: { dependentBy: [], dependsOn: [] },
            cache: {}
        });
        this.globalContext = params && params.globalContext;
    }
    Object.defineProperty(State.prototype, "tree", {
        get: function () { return this._tree; },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(State.prototype, "transforms", {
        get: function () { return this._tree.transforms; },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(State.prototype, "current", {
        get: function () { return this.behaviors.currentObject.value.ref; },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(State.prototype, "root", {
        get: function () { return this.cells.get(this._tree.root.ref); },
        enumerable: false,
        configurable: true
    });
    State.prototype.build = function () { return new _state_builder__WEBPACK_IMPORTED_MODULE_8__["StateBuilder"].Root(this.tree, this); };
    State.prototype.addHistory = function (tree, label) {
        if (this.historyCapacity === 0)
            return;
        this.history.unshift([tree, label || 'Update']);
        if (this.history.length > this.historyCapacity)
            this.history.pop();
        this.events.historyUpdated.next({ state: this });
    };
    State.prototype.clearHistory = function () {
        if (this.history.length === 0)
            return;
        this.history = [];
        this.events.historyUpdated.next({ state: this });
    };
    Object.defineProperty(State.prototype, "latestUndoLabel", {
        get: function () {
            return this.history.length > 0 ? this.history[0][1] : void 0;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(State.prototype, "canUndo", {
        get: function () {
            return this.history.length > 0;
        },
        enumerable: false,
        configurable: true
    });
    State.prototype.undo = function () {
        var _this = this;
        return _mol_task__WEBPACK_IMPORTED_MODULE_5__["Task"].create('Undo', function (ctx) { return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"])(_this, void 0, void 0, function () {
            var e;
            return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__generator"])(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        e = this.history.shift();
                        if (!e)
                            return [2 /*return*/];
                        this.events.historyUpdated.next({ state: this });
                        this.undoingHistory = true;
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, , 3, 4]);
                        return [4 /*yield*/, this.updateTree(e[0], { canUndo: false }).runInContext(ctx)];
                    case 2:
                        _a.sent();
                        return [3 /*break*/, 4];
                    case 3:
                        this.undoingHistory = false;
                        return [7 /*endfinally*/];
                    case 4: return [2 /*return*/];
                }
            });
        }); });
    };
    State.prototype.getSnapshot = function () {
        return { tree: _tree__WEBPACK_IMPORTED_MODULE_2__["StateTree"].toJSON(this._tree) };
    };
    State.prototype.setSnapshot = function (snapshot) {
        var tree = _tree__WEBPACK_IMPORTED_MODULE_2__["StateTree"].fromJSON(snapshot.tree);
        return this.updateTree(tree);
    };
    State.prototype.setCurrent = function (ref) {
        this.behaviors.currentObject.next({ state: this, ref: ref });
    };
    State.prototype.updateCellState = function (ref, stateOrProvider) {
        var cell = this.cells.get(ref);
        if (!cell)
            return;
        var update = typeof stateOrProvider === 'function' ? stateOrProvider(cell.state) : stateOrProvider;
        if (_transform__WEBPACK_IMPORTED_MODULE_3__["StateTransform"].assignState(cell.state, update)) {
            cell.transform = this._tree.assignState(cell.transform.ref, update);
            this.events.cell.stateUpdated.next({ state: this, ref: ref, cell: cell });
        }
    };
    State.prototype.dispose = function () {
        this.ev.dispose();
        this.actions.dispose();
    };
    /**
     * Select Cells using the provided selector.
     * @example state.query(StateSelection.Generators.byRef('test').ancestorOfType(type))
     * @example state.query('test')
     */
    State.prototype.select = function (selector) {
        return _state_selection__WEBPACK_IMPORTED_MODULE_6__["StateSelection"].select(selector, this);
    };
    /**
     * Select Cells by building a query generated on the fly.
     * @example state.select(q => q.byRef('test').subtree())
     */
    State.prototype.selectQ = function (selector) {
        if (typeof selector === 'string')
            return _state_selection__WEBPACK_IMPORTED_MODULE_6__["StateSelection"].select(selector, this);
        return _state_selection__WEBPACK_IMPORTED_MODULE_6__["StateSelection"].select(selector(_state_selection__WEBPACK_IMPORTED_MODULE_6__["StateSelection"].Generators), this);
    };
    /**
     * Creates a Task that applies the specified StateAction (i.e. must use run* on the result)
     * If no ref is specified, apply to root.
     */
    State.prototype.applyAction = function (action, params, ref) {
        var _this = this;
        if (ref === void 0) { ref = _transform__WEBPACK_IMPORTED_MODULE_3__["StateTransform"].RootRef; }
        return _mol_task__WEBPACK_IMPORTED_MODULE_5__["Task"].create('Apply Action', function (ctx) {
            var cell = _this.cells.get(ref);
            if (!cell)
                throw new Error("'" + ref + "' does not exist.");
            if (cell.status !== 'ok')
                throw new Error("Action cannot be applied to a cell with status '" + cell.status + "'");
            return runTask(action.definition.run({ ref: ref, cell: cell, a: cell.obj, params: params, state: _this }, _this.globalContext), ctx);
        });
    };
    /** Apply series of updates to the state. If any of them fail, revert to the original state. */
    State.prototype.transaction = function (edits, options) {
        var _this = this;
        return _mol_task__WEBPACK_IMPORTED_MODULE_5__["Task"].create('State Transaction', function (ctx) { return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"])(_this, void 0, void 0, function () {
            var isNested, snapshot, restored, e_1;
            return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__generator"])(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        isNested = this.inTransaction;
                        snapshot = this._tree.asImmutable();
                        restored = false;
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 5, 8, 9]);
                        if (!isNested)
                            this.behaviors.isUpdating.next(true);
                        this.inTransaction = true;
                        this.inTransactionError = false;
                        return [4 /*yield*/, edits(ctx)];
                    case 2:
                        _a.sent();
                        if (!this.inTransactionError) return [3 /*break*/, 4];
                        restored = true;
                        return [4 /*yield*/, this.updateTree(snapshot).runInContext(ctx)];
                    case 3:
                        _a.sent();
                        _a.label = 4;
                    case 4: return [3 /*break*/, 9];
                    case 5:
                        e_1 = _a.sent();
                        if (!!restored) return [3 /*break*/, 7];
                        restored = true;
                        return [4 /*yield*/, this.updateTree(snapshot).runInContext(ctx)];
                    case 6:
                        _a.sent();
                        this.events.log.next(_mol_util_log_entry__WEBPACK_IMPORTED_MODULE_10__["LogEntry"].error('' + e_1));
                        _a.label = 7;
                    case 7:
                        if (isNested) {
                            this.inTransactionError = true;
                            throw e_1;
                        }
                        if (options === null || options === void 0 ? void 0 : options.rethrowErrors)
                            throw e_1;
                        return [3 /*break*/, 9];
                    case 8:
                        if (!isNested) {
                            this.inTransaction = false;
                            this.events.changed.next({ state: this, inTransaction: false });
                            this.behaviors.isUpdating.next(false);
                            if (!restored) {
                                if (options === null || options === void 0 ? void 0 : options.canUndo)
                                    this.addHistory(snapshot, typeof options.canUndo === 'string' ? options.canUndo : void 0);
                                else
                                    this.clearHistory();
                            }
                        }
                        return [7 /*endfinally*/];
                    case 9: return [2 /*return*/];
                }
            });
        }); });
    };
    Object.defineProperty(State.prototype, "inUpdate", {
        /**
         * Determines whether the state is currently "inside" updateTree function.
         * This is different from "isUpdating" which wraps entire transactions.
         */
        get: function () { return this._inUpdate; },
        enumerable: false,
        configurable: true
    });
    State.prototype.updateTree = function (tree, options) {
        var _this = this;
        var params = { tree: tree, options: options };
        return _mol_task__WEBPACK_IMPORTED_MODULE_5__["Task"].create('Update Tree', function (taskCtx) { return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"])(_this, void 0, void 0, function () {
            var removed, snapshot, reverted, ret, _a;
            return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__generator"])(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, this.updateQueue.enqueue(params)];
                    case 1:
                        removed = _b.sent();
                        if (!removed)
                            return [2 /*return*/];
                        this._inUpdate = true;
                        snapshot = (options === null || options === void 0 ? void 0 : options.canUndo) ? this._tree.asImmutable() : void 0;
                        reverted = false;
                        if (!this.inTransaction)
                            this.behaviors.isUpdating.next(true);
                        _b.label = 2;
                    case 2:
                        _b.trys.push([2, , 7, 8]);
                        if (_state_builder__WEBPACK_IMPORTED_MODULE_8__["StateBuilder"].is(tree)) {
                            if (tree.editInfo.applied)
                                throw new Error('This builder has already been applied. Create a new builder for further state updates');
                            tree.editInfo.applied = true;
                        }
                        this.reverted = false;
                        if (!(options && (options.revertIfAborted || options.revertOnError))) return [3 /*break*/, 4];
                        return [4 /*yield*/, this._revertibleTreeUpdate(taskCtx, params, options)];
                    case 3:
                        _a = _b.sent();
                        return [3 /*break*/, 6];
                    case 4: return [4 /*yield*/, this._updateTree(taskCtx, params)];
                    case 5:
                        _a = _b.sent();
                        _b.label = 6;
                    case 6:
                        ret = _a;
                        reverted = this.reverted;
                        if (ret.ctx.hadError)
                            this.inTransactionError = true;
                        if (!ret.cell)
                            return [2 /*return*/];
                        return [2 /*return*/, new _object__WEBPACK_IMPORTED_MODULE_1__["StateObjectSelector"](ret.cell.transform.ref, this)];
                    case 7:
                        this._inUpdate = false;
                        this.updateQueue.handled(params);
                        if (!this.inTransaction) {
                            this.behaviors.isUpdating.next(false);
                            if (!(options === null || options === void 0 ? void 0 : options.canUndo)) {
                                if (!this.undoingHistory)
                                    this.clearHistory();
                            }
                            else if (!reverted) {
                                this.addHistory(snapshot, typeof options.canUndo === 'string' ? options.canUndo : void 0);
                            }
                        }
                        return [7 /*endfinally*/];
                    case 8: return [2 /*return*/];
                }
            });
        }); }, function () {
            _this.updateQueue.remove(params);
        });
    };
    State.prototype._revertibleTreeUpdate = function (taskCtx, params, options) {
        return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"])(this, void 0, void 0, function () {
            var old, ret, revert;
            return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__generator"])(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        old = this.tree;
                        return [4 /*yield*/, this._updateTree(taskCtx, params)];
                    case 1:
                        ret = _a.sent();
                        revert = ((ret.ctx.hadError || ret.ctx.wasAborted) && options.revertOnError) || (ret.ctx.wasAborted && options.revertIfAborted);
                        if (!revert) return [3 /*break*/, 3];
                        this.reverted = true;
                        return [4 /*yield*/, this._updateTree(taskCtx, { tree: old, options: params.options })];
                    case 2: return [2 /*return*/, _a.sent()];
                    case 3: return [2 /*return*/, ret];
                }
            });
        });
    };
    State.prototype._updateTree = function (taskCtx, params) {
        return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"])(this, void 0, void 0, function () {
            var updated, ctx, cell;
            return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__generator"])(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        updated = false;
                        ctx = this.updateTreeAndCreateCtx(params.tree, taskCtx, params.options);
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, , 3, 4]);
                        return [4 /*yield*/, update(ctx)];
                    case 2:
                        updated = _a.sent();
                        if (_state_builder__WEBPACK_IMPORTED_MODULE_8__["StateBuilder"].isTo(params.tree)) {
                            cell = this.select(params.tree.ref)[0];
                            return [2 /*return*/, { ctx: ctx, cell: cell }];
                        }
                        return [2 /*return*/, { ctx: ctx }];
                    case 3:
                        this.spine.current = undefined;
                        if (updated)
                            this.events.changed.next({ state: this, inTransaction: this.inTransaction });
                        return [7 /*endfinally*/];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    State.prototype.updateTreeAndCreateCtx = function (tree, taskCtx, options) {
        var _tree = (_state_builder__WEBPACK_IMPORTED_MODULE_8__["StateBuilder"].is(tree) ? tree.getTree() : tree).asTransient();
        var oldTree = this._tree;
        this._tree = _tree;
        var cells = this.cells;
        var ctx = {
            parent: this,
            editInfo: _state_builder__WEBPACK_IMPORTED_MODULE_8__["StateBuilder"].is(tree) ? tree.editInfo : void 0,
            errorFree: this.errorFree,
            taskCtx: taskCtx,
            oldTree: oldTree,
            tree: _tree,
            cells: this.cells,
            spine: this.spine,
            results: [],
            options: Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, StateUpdateDefaultOptions), options),
            changed: false,
            hadError: false,
            wasAborted: false,
            newCurrent: void 0,
            getCellData: function (ref) { var _a; return (_a = cells.get(ref).obj) === null || _a === void 0 ? void 0 : _a.data; }
        };
        this.errorFree = true;
        return ctx;
    };
    return State;
}());
(function (State) {
    function create(rootObject, params) {
        return new State(rootObject, params);
    }
    State.create = create;
    var ObjectEvent;
    (function (ObjectEvent) {
        function isCell(e, cell) {
            return !!cell && e.ref === cell.transform.ref && e.state === cell.parent;
        }
        ObjectEvent.isCell = isCell;
    })(ObjectEvent = State.ObjectEvent || (State.ObjectEvent = {}));
})(State || (State = {}));
var StateUpdateDefaultOptions = {
    doNotLogTiming: false,
    doNotUpdateCurrent: true,
    revertIfAborted: false,
    revertOnError: false,
    canUndo: false
};
function update(ctx) {
    return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"])(this, void 0, void 0, function () {
        var fastTrack, deletes, deletedObjects, roots, current, hasCurrent, _i, deletes_1, d, newCurrent_1, i, cell, _a, deletes_2, d, cell, obj, init, _b, _c, cell, i, d, parent_1, _d, _e, cell, _f, roots_1, root, newCurrent, _g, _h, update_1, transform, current, currentCell;
        return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__generator"])(this, function (_j) {
            switch (_j.label) {
                case 0:
                    fastTrack = !!(ctx.editInfo && ctx.editInfo.count === 1 && ctx.editInfo.lastUpdate && ctx.editInfo.sourceTree === ctx.oldTree);
                    deletedObjects = [];
                    if (fastTrack) {
                        deletes = [];
                        roots = [ctx.editInfo.lastUpdate];
                    }
                    else {
                        // find all nodes that will definitely be deleted.
                        // this is done in "post order", meaning that leaves will be deleted first.
                        deletes = findDeletes(ctx);
                        current = ctx.parent.current;
                        hasCurrent = false;
                        for (_i = 0, deletes_1 = deletes; _i < deletes_1.length; _i++) {
                            d = deletes_1[_i];
                            if (d === current) {
                                hasCurrent = true;
                                break;
                            }
                        }
                        if (hasCurrent) {
                            newCurrent_1 = findNewCurrent(ctx.oldTree, current, deletes, ctx.cells);
                            ctx.parent.setCurrent(newCurrent_1);
                        }
                        for (i = deletes.length - 1; i >= 0; i--) {
                            cell = ctx.cells.get(deletes[i]);
                            if (cell) {
                                dispose(cell.transform, cell.obj, cell === null || cell === void 0 ? void 0 : cell.transform.params, cell.cache, ctx.parent.globalContext);
                            }
                        }
                        for (_a = 0, deletes_2 = deletes; _a < deletes_2.length; _a++) {
                            d = deletes_2[_a];
                            cell = ctx.cells.get(d);
                            if (cell) {
                                cell.parent = void 0;
                                unlinkCell(cell);
                            }
                            obj = cell && cell.obj;
                            ctx.cells.delete(d);
                            deletedObjects.push(obj);
                        }
                        // Find roots where transform version changed or where nodes will be added.
                        roots = findUpdateRoots(ctx.cells, ctx.tree);
                    }
                    init = initCells(ctx, roots);
                    // Notify additions of new cells.
                    for (_b = 0, _c = init.added; _b < _c.length; _b++) {
                        cell = _c[_b];
                        ctx.parent.events.cell.created.next({ state: ctx.parent, ref: cell.transform.ref, cell: cell });
                    }
                    for (i = 0; i < deletes.length; i++) {
                        d = deletes[i];
                        parent_1 = ctx.oldTree.transforms.get(d).parent;
                        ctx.parent.events.object.removed.next({ state: ctx.parent, ref: d, obj: deletedObjects[i] });
                        ctx.parent.events.cell.removed.next({ state: ctx.parent, ref: d, parent: parent_1 });
                    }
                    if (deletedObjects.length)
                        deletedObjects = [];
                    if (init.dependent) {
                        for (_d = 0, _e = init.dependent; _d < _e.length; _d++) {
                            cell = _e[_d];
                            roots.push(cell.transform.ref);
                        }
                    }
                    // Set status of cells that will be updated to 'pending'.
                    initCellStatus(ctx, roots);
                    _f = 0, roots_1 = roots;
                    _j.label = 1;
                case 1:
                    if (!(_f < roots_1.length)) return [3 /*break*/, 4];
                    root = roots_1[_f];
                    return [4 /*yield*/, updateSubtree(ctx, root)];
                case 2:
                    _j.sent();
                    _j.label = 3;
                case 3:
                    _f++;
                    return [3 /*break*/, 1];
                case 4:
                    // Sync cell states
                    if (!ctx.editInfo) {
                        syncNewStates(ctx);
                    }
                    newCurrent = ctx.newCurrent;
                    // Raise object updated events
                    for (_g = 0, _h = ctx.results; _g < _h.length; _g++) {
                        update_1 = _h[_g];
                        if (update_1.action === 'created') {
                            ctx.parent.events.object.created.next({ state: ctx.parent, ref: update_1.ref, obj: update_1.obj });
                            if (!ctx.newCurrent) {
                                transform = ctx.tree.transforms.get(update_1.ref);
                                if (!transform.state.isGhost && update_1.obj !== _object__WEBPACK_IMPORTED_MODULE_1__["StateObject"].Null)
                                    newCurrent = update_1.ref;
                            }
                        }
                        else if (update_1.action === 'updated') {
                            ctx.parent.events.object.updated.next({ state: ctx.parent, ref: update_1.ref, action: 'in-place', obj: update_1.obj, oldData: update_1.oldData });
                        }
                        else if (update_1.action === 'replaced') {
                            ctx.parent.events.object.updated.next({ state: ctx.parent, ref: update_1.ref, action: 'recreate', obj: update_1.obj, oldObj: update_1.oldObj });
                        }
                    }
                    if (newCurrent) {
                        if (!ctx.options.doNotUpdateCurrent)
                            ctx.parent.setCurrent(newCurrent);
                    }
                    else {
                        current = ctx.parent.current;
                        currentCell = ctx.cells.get(current);
                        if (currentCell && (currentCell.obj === _object__WEBPACK_IMPORTED_MODULE_1__["StateObject"].Null
                            || (currentCell.status === 'error' && currentCell.errorText === ParentNullErrorText))) {
                            newCurrent = findNewCurrent(ctx.oldTree, current, [], ctx.cells);
                            ctx.parent.setCurrent(newCurrent);
                        }
                    }
                    return [2 /*return*/, deletes.length > 0 || roots.length > 0 || ctx.changed];
            }
        });
    });
}
function findUpdateRoots(cells, tree) {
    var findState = { roots: [], cells: cells };
    _tree__WEBPACK_IMPORTED_MODULE_2__["StateTree"].doPreOrder(tree, tree.root, findState, findUpdateRootsVisitor);
    return findState.roots;
}
function findUpdateRootsVisitor(n, _, s) {
    var cell = s.cells.get(n.ref);
    if (!cell || cell.transform.version !== n.version) {
        s.roots.push(n.ref);
        return false;
    }
    if (cell.status === 'error')
        return false;
    // nothing below a Null object can be an update root
    if (cell && cell.obj === _object__WEBPACK_IMPORTED_MODULE_1__["StateObject"].Null)
        return false;
    return true;
}
function checkDeleteVisitor(n, _, ctx) {
    if (!ctx.newTree.transforms.has(n.ref) && ctx.cells.has(n.ref))
        ctx.deletes.push(n.ref);
}
function findDeletes(ctx) {
    var deleteCtx = { newTree: ctx.tree, cells: ctx.cells, deletes: [] };
    _tree__WEBPACK_IMPORTED_MODULE_2__["StateTree"].doPostOrder(ctx.oldTree, ctx.oldTree.root, deleteCtx, checkDeleteVisitor);
    return deleteCtx.deletes;
}
function syncNewStatesVisitor(n, tree, ctx) {
    var cell = ctx.cells.get(n.ref);
    if (!cell || !_transform__WEBPACK_IMPORTED_MODULE_3__["StateTransform"].syncState(cell.state, n.state))
        return;
    ctx.parent.events.cell.stateUpdated.next({ state: ctx.parent, ref: n.ref, cell: cell });
}
function syncNewStates(ctx) {
    _tree__WEBPACK_IMPORTED_MODULE_2__["StateTree"].doPreOrder(ctx.tree, ctx.tree.root, ctx, syncNewStatesVisitor);
}
function setCellStatus(ctx, ref, status, errorText) {
    var cell = ctx.cells.get(ref);
    var changed = cell.status !== status;
    cell.status = status;
    cell.errorText = errorText;
    if (changed)
        ctx.parent.events.cell.stateUpdated.next({ state: ctx.parent, ref: ref, cell: cell });
}
function initCellStatusVisitor(t, _, ctx) {
    ctx.cells.get(t.ref).transform = t;
    setCellStatus(ctx, t.ref, 'pending');
}
function initCellStatus(ctx, roots) {
    for (var _i = 0, roots_2 = roots; _i < roots_2.length; _i++) {
        var root = roots_2[_i];
        _tree__WEBPACK_IMPORTED_MODULE_2__["StateTree"].doPreOrder(ctx.tree, ctx.tree.transforms.get(root), ctx, initCellStatusVisitor);
    }
}
function unlinkCell(cell) {
    for (var _i = 0, _a = cell.dependencies.dependsOn; _i < _a.length; _i++) {
        var other = _a[_i];
        Object(_mol_util_array__WEBPACK_IMPORTED_MODULE_16__["arraySetRemove"])(other.dependencies.dependentBy, cell);
    }
}
function addCellsVisitor(transform, _, _a) {
    var ctx = _a.ctx, added = _a.added, visited = _a.visited;
    visited.add(transform.ref);
    if (ctx.cells.has(transform.ref)) {
        return;
    }
    var cell = {
        parent: ctx.parent,
        transform: transform,
        sourceRef: void 0,
        status: 'pending',
        state: Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, transform.state),
        errorText: void 0,
        params: void 0,
        paramsNormalizedVersion: '',
        dependencies: { dependentBy: [], dependsOn: [] },
        cache: void 0
    };
    ctx.cells.set(transform.ref, cell);
    added.push(cell);
}
// type LinkCellsCtx = { ctx: UpdateContext, visited: Set<Ref>, dependent: UniqueArray<Ref, StateObjectCell> }
function linkCells(target, ctx) {
    if (!target.transform.dependsOn)
        return;
    for (var _i = 0, _a = target.transform.dependsOn; _i < _a.length; _i++) {
        var ref = _a[_i];
        var t = ctx.tree.transforms.get(ref);
        if (!t) {
            throw new Error("Cannot depend on a non-existent transform.");
        }
        var cell = ctx.cells.get(ref);
        Object(_mol_util_array__WEBPACK_IMPORTED_MODULE_16__["arraySetAdd"])(target.dependencies.dependsOn, cell);
        Object(_mol_util_array__WEBPACK_IMPORTED_MODULE_16__["arraySetAdd"])(cell.dependencies.dependentBy, target);
    }
}
function initCells(ctx, roots) {
    var initCtx = { ctx: ctx, visited: new Set(), added: [] };
    // Add new cells
    for (var _i = 0, roots_3 = roots; _i < roots_3.length; _i++) {
        var root = roots_3[_i];
        _tree__WEBPACK_IMPORTED_MODULE_2__["StateTree"].doPreOrder(ctx.tree, ctx.tree.transforms.get(root), initCtx, addCellsVisitor);
    }
    // Update links for newly added cells
    for (var _a = 0, _b = initCtx.added; _a < _b.length; _a++) {
        var cell = _b[_a];
        linkCells(cell, ctx);
    }
    var dependent;
    // Find dependent cells
    initCtx.visited.forEach(function (ref) {
        var cell = ctx.cells.get(ref);
        for (var _i = 0, _a = cell.dependencies.dependentBy; _i < _a.length; _i++) {
            var by = _a[_i];
            if (initCtx.visited.has(by.transform.ref))
                continue;
            if (!dependent)
                dependent = _mol_data_generic__WEBPACK_IMPORTED_MODULE_17__["UniqueArray"].create();
            _mol_data_generic__WEBPACK_IMPORTED_MODULE_17__["UniqueArray"].add(dependent, by.transform.ref, by);
        }
    });
    // TODO: check if dependent cells are all "proper roots"
    return { added: initCtx.added, dependent: dependent ? dependent.array : void 0 };
}
function findNewCurrent(tree, start, deletes, cells) {
    var deleteSet = new Set(deletes);
    return _findNewCurrent(tree, start, deleteSet, cells);
}
function _findNewCurrent(tree, ref, deletes, cells) {
    if (ref === _transform__WEBPACK_IMPORTED_MODULE_3__["StateTransform"].RootRef)
        return ref;
    var node = tree.transforms.get(ref);
    var siblings = tree.children.get(node.parent).values();
    var prevCandidate = void 0, seenRef = false;
    while (true) {
        var s = siblings.next();
        if (s.done)
            break;
        if (deletes.has(s.value))
            continue;
        var cell = cells.get(s.value);
        if (!cell || cell.status === 'error' || cell.obj === _object__WEBPACK_IMPORTED_MODULE_1__["StateObject"].Null) {
            continue;
        }
        var t = tree.transforms.get(s.value);
        if (t.state.isGhost)
            continue;
        if (s.value === ref) {
            seenRef = true;
            if (!deletes.has(ref))
                prevCandidate = ref;
            continue;
        }
        if (seenRef)
            return t.ref;
        prevCandidate = t.ref;
    }
    if (prevCandidate)
        return prevCandidate;
    return _findNewCurrent(tree, node.parent, deletes, cells);
}
/** Set status and error text of the cell. Remove all existing objects in the subtree. */
function doError(ctx, ref, errorObject, silent) {
    if (!silent) {
        ctx.hadError = true;
        ctx.parent.errorFree = false;
    }
    var cell = ctx.cells.get(ref);
    if (errorObject) {
        ctx.wasAborted = ctx.wasAborted || _mol_task__WEBPACK_IMPORTED_MODULE_5__["Task"].isAbort(errorObject);
        var message = '' + errorObject;
        setCellStatus(ctx, ref, 'error', message);
        if (!silent)
            ctx.parent.events.log.next({ type: 'error', timestamp: new Date(), message: message });
    }
    else {
        cell.params = void 0;
    }
    if (cell.obj) {
        var obj = cell.obj;
        cell.obj = void 0;
        cell.cache = void 0;
        ctx.parent.events.object.removed.next({ state: ctx.parent, ref: ref, obj: obj });
    }
    // remove the objects in the child nodes if they exist
    var children = ctx.tree.children.get(ref).values();
    while (true) {
        var next = children.next();
        if (next.done)
            return;
        doError(ctx, next.value, void 0, silent);
    }
}
var ParentNullErrorText = 'Parent is null';
function updateSubtree(ctx, root) {
    return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"])(this, void 0, void 0, function () {
        var isNull, start, update_2, time, e_2, children, next;
        return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__generator"])(this, function (_a) {
            switch (_a.label) {
                case 0:
                    setCellStatus(ctx, root, 'processing');
                    isNull = false;
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    start = Object(_mol_util_now__WEBPACK_IMPORTED_MODULE_11__["now"])();
                    return [4 /*yield*/, updateNode(ctx, root)];
                case 2:
                    update_2 = _a.sent();
                    time = Object(_mol_util_now__WEBPACK_IMPORTED_MODULE_11__["now"])() - start;
                    if (update_2.action !== 'none')
                        ctx.changed = true;
                    setCellStatus(ctx, root, 'ok');
                    ctx.results.push(update_2);
                    if (update_2.action === 'created') {
                        isNull = update_2.obj === _object__WEBPACK_IMPORTED_MODULE_1__["StateObject"].Null;
                        if (!isNull && !ctx.options.doNotLogTiming)
                            ctx.parent.events.log.next(_mol_util_log_entry__WEBPACK_IMPORTED_MODULE_10__["LogEntry"].info("Created " + update_2.obj.label + " in " + Object(_mol_util_now__WEBPACK_IMPORTED_MODULE_11__["formatTimespan"])(time) + "."));
                    }
                    else if (update_2.action === 'updated') {
                        isNull = update_2.obj === _object__WEBPACK_IMPORTED_MODULE_1__["StateObject"].Null;
                        if (!isNull && !ctx.options.doNotLogTiming)
                            ctx.parent.events.log.next(_mol_util_log_entry__WEBPACK_IMPORTED_MODULE_10__["LogEntry"].info("Updated " + update_2.obj.label + " in " + Object(_mol_util_now__WEBPACK_IMPORTED_MODULE_11__["formatTimespan"])(time) + "."));
                    }
                    else if (update_2.action === 'replaced') {
                        isNull = update_2.obj === _object__WEBPACK_IMPORTED_MODULE_1__["StateObject"].Null;
                        if (!isNull && !ctx.options.doNotLogTiming)
                            ctx.parent.events.log.next(_mol_util_log_entry__WEBPACK_IMPORTED_MODULE_10__["LogEntry"].info("Updated " + update_2.obj.label + " in " + Object(_mol_util_now__WEBPACK_IMPORTED_MODULE_11__["formatTimespan"])(time) + "."));
                    }
                    return [3 /*break*/, 4];
                case 3:
                    e_2 = _a.sent();
                    ctx.changed = true;
                    if (!ctx.hadError)
                        ctx.newCurrent = root;
                    doError(ctx, root, e_2, false);
                    if (!_mol_util_debug__WEBPACK_IMPORTED_MODULE_15__["isProductionMode"])
                        console.error(e_2);
                    return [2 /*return*/];
                case 4:
                    children = ctx.tree.children.get(root).values();
                    _a.label = 5;
                case 5:
                    if (false) {}
                    next = children.next();
                    if (next.done)
                        return [2 /*return*/];
                    if (!isNull) return [3 /*break*/, 6];
                    doError(ctx, next.value, void 0, true);
                    return [3 /*break*/, 8];
                case 6: return [4 /*yield*/, updateSubtree(ctx, next.value)];
                case 7:
                    _a.sent();
                    _a.label = 8;
                case 8: return [3 /*break*/, 5];
                case 9: return [2 /*return*/];
            }
        });
    });
}
function resolveParams(ctx, transform, src, cell) {
    var prms = transform.transformer.definition.params;
    var definition = prms ? prms(src, ctx.parent.globalContext) : {};
    if (cell.paramsNormalizedVersion !== transform.version) {
        transform.params = _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_12__["ParamDefinition"].normalizeParams(definition, transform.params, 'all');
        cell.paramsNormalizedVersion = transform.version;
    }
    else {
        var defaultValues = _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_12__["ParamDefinition"].getDefaultValues(definition);
        transform.params = transform.params
            ? Object(_mol_util_object__WEBPACK_IMPORTED_MODULE_18__["assignIfUndefined"])(transform.params, defaultValues)
            : defaultValues;
    }
    _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_12__["ParamDefinition"].resolveRefs(definition, transform.params, ctx.getCellData);
    return { definition: definition, values: transform.params };
}
function updateNode(ctx, currentRef) {
    var _a;
    return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"])(this, void 0, void 0, function () {
        var oldTree, tree, current, transform, parentCell, parent, params, obj, oldParams, oldCache, oldData, newParams, updateKind, _b, _c, oldObj, newObj;
        return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__generator"])(this, function (_d) {
            switch (_d.label) {
                case 0:
                    oldTree = ctx.oldTree, tree = ctx.tree;
                    current = ctx.cells.get(currentRef);
                    transform = current.transform;
                    // special case for Root
                    if (current.transform.ref === _transform__WEBPACK_IMPORTED_MODULE_3__["StateTransform"].RootRef) {
                        return [2 /*return*/, { action: 'none' }];
                    }
                    parentCell = transform.transformer.definition.from.length === 0
                        ? ctx.cells.get(current.transform.parent)
                        : _state_selection__WEBPACK_IMPORTED_MODULE_6__["StateSelection"].findAncestorOfType(tree, ctx.cells, currentRef, transform.transformer.definition.from);
                    if (!parentCell) {
                        throw new Error("No suitable parent found for '" + currentRef + "'");
                    }
                    ctx.spine.current = current;
                    parent = parentCell.obj;
                    current.sourceRef = parentCell.transform.ref;
                    params = resolveParams(ctx, transform, parent, current);
                    if (!(!oldTree.transforms.has(currentRef) || !current.params)) return [3 /*break*/, 2];
                    current.params = params;
                    return [4 /*yield*/, createObject(ctx, current, transform.transformer, parent, params.values)];
                case 1:
                    obj = _d.sent();
                    updateTag(obj, transform);
                    current.obj = obj;
                    return [2 /*return*/, { ref: currentRef, action: 'created', obj: obj }];
                case 2:
                    oldParams = current.params.values;
                    oldCache = current.cache;
                    oldData = (_a = current.obj) === null || _a === void 0 ? void 0 : _a.data;
                    newParams = params.values;
                    current.params = params;
                    if (!(!!current.obj && current.obj !== _object__WEBPACK_IMPORTED_MODULE_1__["StateObject"].Null)) return [3 /*break*/, 4];
                    return [4 /*yield*/, updateObject(ctx, current, transform.transformer, parent, current.obj, oldParams, newParams)];
                case 3:
                    _b = _d.sent();
                    return [3 /*break*/, 5];
                case 4:
                    _b = _transformer__WEBPACK_IMPORTED_MODULE_4__["StateTransformer"].UpdateResult.Recreate;
                    _d.label = 5;
                case 5:
                    updateKind = _b;
                    _c = updateKind;
                    switch (_c) {
                        case _transformer__WEBPACK_IMPORTED_MODULE_4__["StateTransformer"].UpdateResult.Recreate: return [3 /*break*/, 6];
                        case _transformer__WEBPACK_IMPORTED_MODULE_4__["StateTransformer"].UpdateResult.Updated: return [3 /*break*/, 8];
                        case _transformer__WEBPACK_IMPORTED_MODULE_4__["StateTransformer"].UpdateResult.Null: return [3 /*break*/, 9];
                    }
                    return [3 /*break*/, 10];
                case 6:
                    oldObj = current.obj;
                    dispose(transform, oldObj, oldParams, oldCache, ctx.parent.globalContext);
                    return [4 /*yield*/, createObject(ctx, current, transform.transformer, parent, newParams)];
                case 7:
                    newObj = _d.sent();
                    updateTag(newObj, transform);
                    current.obj = newObj;
                    return [2 /*return*/, { ref: currentRef, action: 'replaced', oldObj: oldObj, obj: newObj }];
                case 8:
                    updateTag(current.obj, transform);
                    return [2 /*return*/, { ref: currentRef, action: 'updated', oldData: oldData, obj: current.obj }];
                case 9:
                    {
                        dispose(transform, current.obj, oldParams, oldCache, ctx.parent.globalContext);
                        current.obj = _object__WEBPACK_IMPORTED_MODULE_1__["StateObject"].Null;
                        return [2 /*return*/, { ref: currentRef, action: 'updated', obj: current.obj }];
                    }
                    _d.label = 10;
                case 10: return [2 /*return*/, { action: 'none' }];
            }
        });
    });
}
function dispose(transform, b, params, cache, globalContext) {
    var _a, _b;
    (_b = (_a = transform.transformer.definition).dispose) === null || _b === void 0 ? void 0 : _b.call(_a, {
        b: b !== _object__WEBPACK_IMPORTED_MODULE_1__["StateObject"].Null ? b : void 0,
        params: params,
        cache: cache
    }, globalContext);
}
function updateTag(obj, transform) {
    if (!obj || obj === _object__WEBPACK_IMPORTED_MODULE_1__["StateObject"].Null)
        return;
    obj.tags = transform.tags;
}
function runTask(t, ctx) {
    if (typeof t.runInContext === 'function')
        return t.runInContext(ctx);
    return t;
}
function resolveDependencies(cell) {
    if (cell.dependencies.dependsOn.length === 0)
        return void 0;
    var deps = Object.create(null);
    for (var _i = 0, _a = cell.dependencies.dependsOn; _i < _a.length; _i++) {
        var dep = _a[_i];
        if (!dep.obj) {
            throw new Error('Unresolved dependency.');
        }
        deps[dep.transform.ref] = dep.obj;
    }
    return deps;
}
function createObject(ctx, cell, transformer, a, params) {
    if (!cell.cache)
        cell.cache = Object.create(null);
    return runTask(transformer.definition.apply({ a: a, params: params, cache: cell.cache, spine: ctx.spine, dependencies: resolveDependencies(cell) }, ctx.parent.globalContext), ctx.taskCtx);
}
function updateObject(ctx, cell, transformer, a, b, oldParams, newParams) {
    return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"])(this, void 0, void 0, function () {
        return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__generator"])(this, function (_a) {
            if (!transformer.definition.update) {
                return [2 /*return*/, _transformer__WEBPACK_IMPORTED_MODULE_4__["StateTransformer"].UpdateResult.Recreate];
            }
            if (!cell.cache)
                cell.cache = Object.create(null);
            return [2 /*return*/, runTask(transformer.definition.update({ a: a, oldParams: oldParams, b: b, newParams: newParams, cache: cell.cache, spine: ctx.spine, dependencies: resolveDependencies(cell) }, ctx.parent.globalContext), ctx.taskCtx)];
        });
    });
}
//# sourceMappingURL=state.js.map

/***/ }),

/***/ "./lib/mol-state/state/builder.js":
/*!****************************************!*\
  !*** ./lib/mol-state/state/builder.js ***!
  \****************************************/
/*! exports provided: StateBuilder */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "StateBuilder", function() { return StateBuilder; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _tree_immutable__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../tree/immutable */ "./lib/mol-state/tree/immutable.js");
/* harmony import */ var _object__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../object */ "./lib/mol-state/object.js");
/* harmony import */ var _transform__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../transform */ "./lib/mol-state/transform.js");
/* harmony import */ var immer__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! immer */ "./node_modules/immer/dist/immer.esm.js");
/**
 * Copyright (c) 2018 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author David Sehnal <david.sehnal@gmail.com>
 */






var StateBuilder;
(function (StateBuilder) {
    function buildTree(state) {
        if (!state.state || state.state.tree === state.editInfo.sourceTree) {
            return state.tree.asImmutable();
        }
        // The tree has changed in the meantime, we need to reapply the changes!
        var tree = state.state.tree.asTransient();
        for (var _i = 0, _a = state.actions; _i < _a.length; _i++) {
            var a = _a[_i];
            switch (a.kind) {
                case 'add':
                    tree.add(a.transform);
                    break;
                case 'update':
                    tree.setParams(a.ref, a.params);
                    break;
                case 'delete':
                    tree.remove(a.ref);
                    break;
                case 'insert': {
                    var children = tree.children.get(a.ref).toArray();
                    tree.add(a.transform);
                    for (var _b = 0, children_1 = children; _b < children_1.length; _b++) {
                        var c = children_1[_b];
                        tree.changeParent(c, a.transform.ref);
                    }
                    break;
                }
            }
        }
        state.editInfo.sourceTree = state.tree;
        return tree.asImmutable();
    }
    function is(obj) {
        return !!obj && typeof obj.getTree === 'function';
    }
    StateBuilder.is = is;
    function isTo(obj) {
        return !!obj && typeof obj.getTree === 'function' && typeof obj.ref === 'string';
    }
    StateBuilder.isTo = isTo;
    // type ToFromCell<C extends StateObjectCell> = C extends StateObjectCell<infer A, StateTransform<infer T extends StateTransformer>> ? To<A, any>: never
    var Root = /** @class */ (function () {
        function Root(tree, state) {
            this.state = { state: state, tree: tree.asTransient(), actions: [], editInfo: { applied: false, sourceTree: tree, count: 0, lastUpdate: void 0 } };
        }
        Object.defineProperty(Root.prototype, "editInfo", {
            get: function () { return this.state.editInfo; },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(Root.prototype, "currentTree", {
            get: function () { return this.state.tree; },
            enumerable: false,
            configurable: true
        });
        Root.prototype.to = function (refOrCellOrSelector) {
            var ref = typeof refOrCellOrSelector === 'string'
                ? refOrCellOrSelector
                : _object__WEBPACK_IMPORTED_MODULE_2__["StateObjectCell"].is(refOrCellOrSelector)
                    ? refOrCellOrSelector.transform.ref
                    : refOrCellOrSelector.ref;
            return new To(this.state, ref, this);
        };
        Root.prototype.toRoot = function () { return new To(this.state, this.state.tree.root.ref, this); };
        Root.prototype.delete = function (obj) {
            var ref = _object__WEBPACK_IMPORTED_MODULE_2__["StateObjectRef"].resolveRef(obj);
            if (!ref || !this.state.tree.transforms.has(ref))
                return this;
            this.editInfo.count++;
            this.state.tree.remove(ref);
            this.state.actions.push({ kind: 'delete', ref: ref });
            return this;
        };
        Root.prototype.getTree = function () { return buildTree(this.state); };
        Root.prototype.commit = function (options) {
            if (!this.state.state)
                throw new Error('Cannot commit template tree');
            return this.state.state.runTask(this.state.state.updateTree(this, options));
        };
        return Root;
    }());
    StateBuilder.Root = Root;
    var To = /** @class */ (function () {
        function To(state, ref, root) {
            this.state = state;
            this.root = root;
            this.ref = ref;
            if (!this.state.tree.transforms.has(ref)) {
                throw new Error("Could not find node '" + ref + "'.");
            }
        }
        Object.defineProperty(To.prototype, "editInfo", {
            get: function () { return this.state.editInfo; },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(To.prototype, "selector", {
            get: function () { return new _object__WEBPACK_IMPORTED_MODULE_2__["StateObjectSelector"](this.ref, this.state.state); },
            enumerable: false,
            configurable: true
        });
        To.prototype.getApplyRoot = function () {
            return _tree_immutable__WEBPACK_IMPORTED_MODULE_1__["StateTree"].getDecoratorRoot(this.state.tree, this.ref);
        };
        /**
         * Apply the transformed to the parent node
         * If no params are specified (params <- undefined), default params are lazily resolved.
         */
        To.prototype.apply = function (tr, params, options) {
            if (tr.definition.isDecorator) {
                return this.insert(tr, params, options);
            }
            var applyRoot = this.getApplyRoot();
            var t = tr.apply(applyRoot, params, options);
            this.state.tree.add(t);
            this.editInfo.count++;
            this.editInfo.lastUpdate = t.ref;
            this.state.actions.push({ kind: 'add', transform: t });
            return new To(this.state, t.ref, this.root);
        };
        /**
         * If the ref is present, the transform is applied.
         * Otherwise a transform with the specifed ref is created.
         */
        To.prototype.applyOrUpdate = function (ref, tr, params, options) {
            if (this.state.tree.transforms.has(ref)) {
                var to = this.to(ref);
                if (params)
                    to.update(params);
                return to;
            }
            else {
                return this.apply(tr, params, Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, options), { ref: ref }));
            }
        };
        /**
         * Apply the transformed to the parent node
         * If no params are specified (params <- undefined), default params are lazily resolved.
         * The transformer cannot be a decorator to be able to use this.
         */
        To.prototype.applyOrUpdateTagged = function (tags, tr, params, options) {
            if (tr.definition.isDecorator) {
                throw new Error("Can't use applyOrUpdateTagged on decorator transformers.");
            }
            var applyRoot = this.getApplyRoot();
            var children = this.state.tree.children.get(applyRoot).values();
            while (true) {
                var child = children.next();
                if (child.done)
                    break;
                var tr_1 = this.state.tree.transforms.get(child.value);
                if (tr_1 && _transform__WEBPACK_IMPORTED_MODULE_3__["StateTransform"].hasTags(tr_1, tags)) {
                    var to = this.to(child.value);
                    to.updateTagged(params, tagsUnion(tr_1.tags, tags, options && options.tags));
                    return to;
                }
            }
            var t = tr.apply(applyRoot, params, Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, options), { tags: tagsUnion(tags, options && options.tags) }));
            this.state.tree.add(t);
            this.editInfo.count++;
            this.editInfo.lastUpdate = t.ref;
            this.state.actions.push({ kind: 'add', transform: t });
            return new To(this.state, t.ref, this.root);
        };
        /**
         * A helper to greate a group-like state object and keep the current type.
         */
        To.prototype.group = function (tr, params, options) {
            return this.apply(tr, params, options);
        };
        /**
         * Inserts a new transform that does not change the object type and move the original children to it.
         */
        To.prototype.insert = function (tr, params, options) {
            // cache the children
            var children = this.state.tree.children.get(this.ref).toArray();
            // add the new node
            var t = tr.apply(this.ref, params, options);
            this.state.tree.add(t);
            // move the original children to the new node
            for (var _i = 0, children_2 = children; _i < children_2.length; _i++) {
                var c = children_2[_i];
                this.state.tree.changeParent(c, t.ref);
            }
            this.editInfo.count++;
            this.editInfo.lastUpdate = t.ref;
            this.state.actions.push({ kind: 'insert', ref: this.ref, transform: t });
            return new To(this.state, t.ref, this.root);
        };
        To.prototype.updateTagged = function (params, tags) {
            if (this.state.tree.setParams(this.ref, params) || this.state.tree.setTags(this.ref, tags)) {
                this.editInfo.count++;
                this.editInfo.lastUpdate = this.ref;
                this.state.actions.push({ kind: 'update', ref: this.ref, params: params });
            }
        };
        To.prototype.update = function (paramsOrTransformer, provider) {
            var params;
            if (provider) {
                var old = this.state.tree.transforms.get(this.ref);
                params = Object(immer__WEBPACK_IMPORTED_MODULE_4__["produce"])(old.params, provider);
            }
            else {
                params = typeof paramsOrTransformer === 'function'
                    ? Object(immer__WEBPACK_IMPORTED_MODULE_4__["produce"])(this.state.tree.transforms.get(this.ref).params, paramsOrTransformer)
                    : paramsOrTransformer;
            }
            if (this.state.tree.setParams(this.ref, params)) {
                this.editInfo.count++;
                this.editInfo.lastUpdate = this.ref;
                this.state.actions.push({ kind: 'update', ref: this.ref, params: params });
            }
            return this.root;
        };
        To.prototype.to = function (ref) { return this.root.to(ref); };
        To.prototype.toRoot = function () { return this.root.toRoot(); };
        To.prototype.delete = function (ref) { return this.root.delete(ref); };
        To.prototype.getTree = function () { return buildTree(this.state); };
        /** Returns selector to this node. */
        To.prototype.commit = function (options) {
            if (!this.state.state)
                throw new Error('Cannot commit template tree');
            return this.state.state.runTask(this.state.state.updateTree(this, options));
        };
        return To;
    }());
    StateBuilder.To = To;
})(StateBuilder || (StateBuilder = {}));
function tagsUnion() {
    var arrays = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        arrays[_i] = arguments[_i];
    }
    var set = void 0;
    var ret = [];
    for (var _a = 0, arrays_1 = arrays; _a < arrays_1.length; _a++) {
        var xs = arrays_1[_a];
        if (!xs)
            continue;
        if (!set)
            set = new Set();
        if (typeof xs === 'string') {
            if (set.has(xs))
                continue;
            set.add(xs);
            ret.push(xs);
        }
        else {
            for (var _b = 0, xs_1 = xs; _b < xs_1.length; _b++) {
                var x = xs_1[_b];
                if (set.has(x))
                    continue;
                set.add(x);
                ret.push(x);
            }
        }
    }
    return ret;
}
//# sourceMappingURL=builder.js.map

/***/ }),

/***/ "./lib/mol-state/state/selection.js":
/*!******************************************!*\
  !*** ./lib/mol-state/state/selection.js ***!
  \******************************************/
/*! exports provided: StateSelection */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "StateSelection", function() { return StateSelection; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _tree__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../tree */ "./lib/mol-state/tree.js");
/* harmony import */ var _transform__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../transform */ "./lib/mol-state/transform.js");
/**
 * Copyright (c) 2018-2020 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author David Sehnal <david.sehnal@gmail.com>
 */



var StateSelection;
(function (StateSelection) {
    function select(s, state) {
        return compile(s)(state);
    }
    StateSelection.select = select;
    function compile(s) {
        var selector = s ? s : Generators.root;
        var query;
        if (isBuilder(selector))
            query = selector.compile();
        else if (isObj(selector))
            query = Generators.byValue(selector).compile();
        else if (isQuery(selector))
            query = selector;
        else
            query = Generators.byRef(selector).compile();
        return query;
    }
    StateSelection.compile = compile;
    function isObj(arg) {
        return arg.transform !== void 0 && arg.status !== void 0;
    }
    function isBuilder(arg) {
        return arg.compile !== void 0;
    }
    function isQuery(arg) {
        return typeof arg === 'function';
    }
    var BuilderPrototype = {
        select: function (state) {
            return select(this, state || this.state);
        }
    };
    function registerModifier(name, f) {
        BuilderPrototype[name] = function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            return f.call.apply(f, Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__spreadArrays"])([void 0, this], args));
        };
    }
    function build(compile) {
        return Object.create(BuilderPrototype, { compile: { writable: false, configurable: false, value: compile } });
    }
    var Generators;
    (function (Generators) {
        Generators.root = build(function () { return function (state) { return [state.cells.get(state.tree.root.ref)]; }; });
        function byRef() {
            var refs = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                refs[_i] = arguments[_i];
            }
            return build(function () { return function (state) {
                var ret = [];
                for (var _i = 0, refs_1 = refs; _i < refs_1.length; _i++) {
                    var ref = refs_1[_i];
                    var n = state.cells.get(ref);
                    if (!n)
                        continue;
                    ret.push(n);
                }
                return ret;
            }; });
        }
        Generators.byRef = byRef;
        function byValue() {
            var objects = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                objects[_i] = arguments[_i];
            }
            return build(function () { return function (state) { return objects; }; });
        }
        Generators.byValue = byValue;
        function rootsOfType(type, root) {
            if (root === void 0) { root = _transform__WEBPACK_IMPORTED_MODULE_2__["StateTransform"].RootRef; }
            return build(function () { return function (state) {
                var ctx = { roots: [], cells: state.cells, type: type.type };
                _tree__WEBPACK_IMPORTED_MODULE_1__["StateTree"].doPreOrder(state.tree, state.tree.transforms.get(root), ctx, _findRootsOfType);
                return ctx.roots;
            }; });
        }
        Generators.rootsOfType = rootsOfType;
        function ofType(type, root) {
            if (root === void 0) { root = _transform__WEBPACK_IMPORTED_MODULE_2__["StateTransform"].RootRef; }
            return build(function () { return function (state) {
                var ctx = { ret: [], cells: state.cells, type: type.type };
                _tree__WEBPACK_IMPORTED_MODULE_1__["StateTree"].doPreOrder(state.tree, state.tree.transforms.get(root), ctx, _findOfType);
                return ctx.ret;
            }; });
        }
        Generators.ofType = ofType;
        function ofTransformer(t, root) {
            if (root === void 0) { root = _transform__WEBPACK_IMPORTED_MODULE_2__["StateTransform"].RootRef; }
            return build(function () { return function (state) {
                var ctx = { ret: [], cells: state.cells, t: t };
                _tree__WEBPACK_IMPORTED_MODULE_1__["StateTree"].doPreOrder(state.tree, state.tree.transforms.get(root), ctx, _findOfTransformer);
                return ctx.ret;
            }; });
        }
        Generators.ofTransformer = ofTransformer;
        function ofTransformerWithError(t, root) {
            if (root === void 0) { root = _transform__WEBPACK_IMPORTED_MODULE_2__["StateTransform"].RootRef; }
            return build(function () { return function (state) {
                var ctx = { ret: [], cells: state.cells, t: t };
                _tree__WEBPACK_IMPORTED_MODULE_1__["StateTree"].doPreOrder(state.tree, state.tree.transforms.get(root), ctx, _findOfTransformerWithError);
                return ctx.ret;
            }; });
        }
        Generators.ofTransformerWithError = ofTransformerWithError;
        function _findRootsOfType(n, _, s) {
            var cell = s.cells.get(n.ref);
            if (cell && cell.obj && cell.obj.type === s.type) {
                s.roots.push(cell);
                return false;
            }
            return true;
        }
        function _findOfType(n, _, s) {
            var cell = s.cells.get(n.ref);
            if (cell && cell.obj && cell.obj.type === s.type) {
                s.ret.push(cell);
            }
            return true;
        }
        function _findOfTransformer(n, _, s) {
            var cell = s.cells.get(n.ref);
            if (cell && cell.obj && cell.transform.transformer === s.t) {
                s.ret.push(cell);
            }
            return true;
        }
        function _findOfTransformerWithError(n, _, s) {
            var cell = s.cells.get(n.ref);
            if (cell && cell.status === 'error' && cell.transform.transformer === s.t) {
                s.ret.push(cell);
            }
            return true;
        }
    })(Generators = StateSelection.Generators || (StateSelection.Generators = {}));
    registerModifier('flatMap', flatMap);
    function flatMap(b, f) {
        var q = compile(b);
        return build(function () { return function (state) {
            var ret = [];
            for (var _i = 0, _a = q(state); _i < _a.length; _i++) {
                var n = _a[_i];
                for (var _b = 0, _c = f(n, state); _b < _c.length; _b++) {
                    var m = _c[_b];
                    ret.push(m);
                }
            }
            return ret;
        }; });
    }
    StateSelection.flatMap = flatMap;
    registerModifier('mapObject', mapObject);
    function mapObject(b, f) {
        var q = compile(b);
        return build(function () { return function (state) {
            var ret = [];
            for (var _i = 0, _a = q(state); _i < _a.length; _i++) {
                var n = _a[_i];
                var x = f(n, state);
                if (x)
                    ret.push(x);
            }
            return ret;
        }; });
    }
    StateSelection.mapObject = mapObject;
    registerModifier('unique', unique);
    function unique(b) {
        var q = compile(b);
        return build(function () { return function (state) {
            var set = new Set();
            var ret = [];
            for (var _i = 0, _a = q(state); _i < _a.length; _i++) {
                var n = _a[_i];
                if (!n)
                    continue;
                if (!set.has(n.transform.ref)) {
                    set.add(n.transform.ref);
                    ret.push(n);
                }
            }
            return ret;
        }; });
    }
    StateSelection.unique = unique;
    registerModifier('first', first);
    function first(b) {
        var q = compile(b);
        return build(function () { return function (state) {
            var r = q(state);
            return r.length ? [r[0]] : [];
        }; });
    }
    StateSelection.first = first;
    registerModifier('filter', filter);
    function filter(b, p) { return flatMap(b, function (n) { return p(n) ? [n] : []; }); }
    StateSelection.filter = filter;
    registerModifier('withStatus', withStatus);
    function withStatus(b, s) { return filter(b, function (n) { return n.status === s; }); }
    StateSelection.withStatus = withStatus;
    registerModifier('withTag', withTag);
    function withTag(b, tag) { return filter(b, function (n) { return !!n.transform.tags && n.transform.tags.indexOf(tag) >= 0; }); }
    StateSelection.withTag = withTag;
    registerModifier('subtree', subtree);
    function subtree(b) {
        return flatMap(b, function (n, s) {
            var nodes = [];
            _tree__WEBPACK_IMPORTED_MODULE_1__["StateTree"].doPreOrder(s.tree, s.tree.transforms.get(n.transform.ref), nodes, function (x, _, ctx) { ctx.push(x.ref); });
            return nodes.map(function (x) { return s.cells.get(x); });
        });
    }
    StateSelection.subtree = subtree;
    registerModifier('children', children);
    function children(b) {
        return flatMap(b, function (n, s) {
            var nodes = [];
            s.tree.children.get(n.transform.ref).forEach(function (c) { return nodes.push(s.cells.get(c)); });
            return nodes;
        });
    }
    StateSelection.children = children;
    registerModifier('ofType', ofType);
    function ofType(b, t) { return filter(b, function (n) { return n.obj ? n.obj.type === t.type : false; }); }
    StateSelection.ofType = ofType;
    registerModifier('ancestor', ancestor);
    function ancestor(b, test) { return unique(mapObject(b, function (n, s) { return findAncestor(s.tree, s.cells, n.transform.ref, test); })); }
    StateSelection.ancestor = ancestor;
    registerModifier('ancestorOfType', ancestorOfType);
    function ancestorOfType(b, types) { return unique(mapObject(b, function (n, s) { return findAncestorOfType(s.tree, s.cells, n.transform.ref, types); })); }
    StateSelection.ancestorOfType = ancestorOfType;
    registerModifier('ancestorWithTransformer', ancestorWithTransformer);
    function ancestorWithTransformer(b, transfomers) { return unique(mapObject(b, function (n, s) { return findAncestorWithTransformer(s.tree, s.cells, n.transform.ref, transfomers); })); }
    StateSelection.ancestorWithTransformer = ancestorWithTransformer;
    registerModifier('withTransformer', withTransformer);
    function withTransformer(b, t) { return filter(b, function (o) { return o.transform.transformer === t; }); }
    StateSelection.withTransformer = withTransformer;
    registerModifier('root', root);
    function root(b, test) { return unique(mapObject(b, function (n, s) { return findRoot(s.tree, s.cells, n.transform.ref, test); })); }
    StateSelection.root = root;
    registerModifier('rootOfType', rootOfType);
    function rootOfType(b, types) { return unique(mapObject(b, function (n, s) { return findRootOfType(s.tree, s.cells, n.transform.ref, types); })); }
    StateSelection.rootOfType = rootOfType;
    registerModifier('parent', parent);
    function parent(b) { return unique(mapObject(b, function (n, s) { return s.cells.get(s.tree.transforms.get(n.transform.ref).parent); })); }
    StateSelection.parent = parent;
    function _findAncestor(tree, cells, root, test, findClosest) {
        var current = tree.transforms.get(root);
        var ret = void 0;
        while (true) {
            current = tree.transforms.get(current.parent);
            var cell = cells.get(current.ref);
            if (cell.obj && test(cell)) {
                ret = cell;
                if (findClosest)
                    return ret;
            }
            if (current.ref === _transform__WEBPACK_IMPORTED_MODULE_2__["StateTransform"].RootRef) {
                return ret;
            }
        }
    }
    // Return first ancestor that satisfies the given test
    function findAncestor(tree, cells, root, test) {
        return _findAncestor(tree, cells, root, test, true);
    }
    StateSelection.findAncestor = findAncestor;
    // Return last (with lowest depth) ancestor that satisfies the given test
    function findRoot(tree, cells, root, test) {
        return _findAncestor(tree, cells, root, test, false);
    }
    StateSelection.findRoot = findRoot;
    function findAncestorWithTransformer(tree, cells, root, transfomers) {
        return findAncestor(tree, cells, root, Array.isArray(transfomers)
            ? function (cell) { return transfomers.indexOf(cell.transform.transformer) >= 0; }
            : function (cell) { return cell.transform.transformer === transfomers; });
    }
    StateSelection.findAncestorWithTransformer = findAncestorWithTransformer;
    function findAncestorOfType(tree, cells, root, types) {
        return findAncestor(tree, cells, root, _testTypes(types));
    }
    StateSelection.findAncestorOfType = findAncestorOfType;
    function findRootOfType(tree, cells, root, types) {
        return findRoot(tree, cells, root, _testTypes(types));
    }
    StateSelection.findRootOfType = findRootOfType;
    function _testTypes(types) {
        return Array.isArray(types)
            ? function (cell) {
                for (var _i = 0, types_1 = types; _i < types_1.length; _i++) {
                    var t = types_1[_i];
                    if (t.type === cell.obj.type)
                        return true;
                }
            } : function (cell) { return cell.obj.type === types.type; };
    }
    function findUniqueTagsInSubtree(tree, root, tags) {
        return _tree__WEBPACK_IMPORTED_MODULE_1__["StateTree"].doPreOrder(tree, tree.transforms.get(root), { refs: {}, tags: tags }, _findUniqueTagsInSubtree).refs;
    }
    StateSelection.findUniqueTagsInSubtree = findUniqueTagsInSubtree;
    function _findUniqueTagsInSubtree(n, _, s) {
        if (n.tags) {
            for (var _i = 0, _a = n.tags; _i < _a.length; _i++) {
                var t = _a[_i];
                if (!s.tags.has(t))
                    continue;
                s.refs[t] = n.ref;
                break;
            }
        }
        return true;
    }
    function findTagInSubtree(tree, root, tag) {
        return _tree__WEBPACK_IMPORTED_MODULE_1__["StateTree"].doPreOrder(tree, tree.transforms.get(root), { ref: void 0, tag: tag }, _findTagInSubtree).ref;
    }
    StateSelection.findTagInSubtree = findTagInSubtree;
    function _findTagInSubtree(n, _, s) {
        if (n.tags && n.tags.indexOf(s.tag) >= 0) {
            s.ref = n.ref;
            return false;
        }
        return true;
    }
    function findWithAllTags(tree, root, tags) {
        return _tree__WEBPACK_IMPORTED_MODULE_1__["StateTree"].doPreOrder(tree, tree.transforms.get(root), { refs: [], tags: tags }, _findWithAllTags).refs;
    }
    StateSelection.findWithAllTags = findWithAllTags;
    function _findWithAllTags(n, _, s) {
        if (n.tags) {
            var len = s.tags.size;
            var found = 0;
            for (var _i = 0, _a = n.tags; _i < _a.length; _i++) {
                var t = _a[_i];
                if (!s.tags.has(t))
                    continue;
                found++;
                if (found === len) {
                    s.refs.push(n);
                    break;
                }
            }
        }
        else if (s.tags.size === 0) {
            s.refs.push(n);
        }
    }
    function tryFindDecorator(state, root, transformer) {
        var t = state.transforms.get(root);
        if (t.transformer === transformer)
            return state.cells.get(root);
        var children = state.tree.children.get(root);
        if (children.size !== 1)
            return;
        var first = children.first();
        if (state.transforms.get(first).transformer.definition.isDecorator)
            return tryFindDecorator(state, first, transformer);
    }
    StateSelection.tryFindDecorator = tryFindDecorator;
})(StateSelection || (StateSelection = {}));

//# sourceMappingURL=selection.js.map

/***/ }),

/***/ "./lib/mol-state/transform.js":
/*!************************************!*\
  !*** ./lib/mol-state/transform.js ***!
  \************************************/
/*! exports provided: StateTransform */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "StateTransform", function() { return Transform; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _transformer__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./transformer */ "./lib/mol-state/transformer.js");
/* harmony import */ var _mol_util__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../mol-util */ "./lib/mol-util/index.js");
/**
 * Copyright (c) 2018 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author David Sehnal <david.sehnal@gmail.com>
 */




var Transform;
(function (Transform) {
    Transform.RootRef = '-=root=-';
    function areStatesEqual(a, b) {
        return !!a.isHidden !== !!b.isHidden || !!a.isCollapsed !== !!b.isCollapsed
            || !!a.isGhost !== !!b.isGhost || !!a.isLocked !== !!b.isLocked;
    }
    Transform.areStatesEqual = areStatesEqual;
    function isStateChange(a, b) {
        if (!b)
            return false;
        if (typeof b.isCollapsed !== 'undefined' && a.isCollapsed !== b.isCollapsed)
            return true;
        if (typeof b.isHidden !== 'undefined' && a.isHidden !== b.isHidden)
            return true;
        if (typeof b.isGhost !== 'undefined' && a.isGhost !== b.isGhost)
            return true;
        if (typeof b.isLocked !== 'undefined' && a.isLocked !== b.isLocked)
            return true;
        return false;
    }
    Transform.isStateChange = isStateChange;
    function assignState(a, b) {
        if (!b)
            return false;
        var changed = false;
        for (var _i = 0, _a = Object.keys(b); _i < _a.length; _i++) {
            var k = _a[_i];
            var s = b[k], t = a[k];
            if (!!s === !!t)
                continue;
            changed = true;
            a[k] = s;
        }
        return changed;
    }
    Transform.assignState = assignState;
    function syncState(a, b) {
        if (!b)
            return false;
        var changed = false;
        for (var _i = 0, _a = Object.keys(b); _i < _a.length; _i++) {
            var k = _a[_i];
            var s = b[k], t = a[k];
            if (!!s === !!t)
                continue;
            changed = true;
            a[k] = s;
        }
        for (var _b = 0, _c = Object.keys(a); _b < _c.length; _b++) {
            var k = _c[_b];
            var s = b[k], t = a[k];
            if (!!s === !!t)
                continue;
            changed = true;
            a[k] = s;
        }
        return changed;
    }
    Transform.syncState = syncState;
    function create(parent, transformer, params, options) {
        var ref = options && options.ref ? options.ref : _mol_util__WEBPACK_IMPORTED_MODULE_2__["UUID"].create22();
        var tags = void 0;
        if (options && options.tags) {
            tags = typeof options.tags === 'string' ? [options.tags] : options.tags;
            if (tags.length === 0)
                tags = void 0;
            else
                tags.sort();
        }
        return {
            parent: parent,
            transformer: transformer,
            state: (options === null || options === void 0 ? void 0 : options.state) || {},
            tags: tags,
            ref: ref,
            dependsOn: options && options.dependsOn,
            params: params,
            version: _mol_util__WEBPACK_IMPORTED_MODULE_2__["UUID"].create22()
        };
    }
    Transform.create = create;
    function withParams(t, params) {
        return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, t), { params: params, version: _mol_util__WEBPACK_IMPORTED_MODULE_2__["UUID"].create22() });
    }
    Transform.withParams = withParams;
    function withState(t, state) {
        if (!state)
            return t;
        return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, t), { state: Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, t.state), state) });
    }
    Transform.withState = withState;
    function withTags(t, newTags) {
        var tags = void 0;
        if (newTags) {
            tags = typeof newTags === 'string' ? [newTags] : newTags;
            if (tags.length === 0)
                tags = void 0;
            else
                tags.sort();
        }
        return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, t), { tags: tags, version: _mol_util__WEBPACK_IMPORTED_MODULE_2__["UUID"].create22() });
    }
    Transform.withTags = withTags;
    function withParent(t, parent) {
        return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, t), { parent: parent, version: _mol_util__WEBPACK_IMPORTED_MODULE_2__["UUID"].create22() });
    }
    Transform.withParent = withParent;
    function createRoot(state) {
        return create(Transform.RootRef, _transformer__WEBPACK_IMPORTED_MODULE_1__["StateTransformer"].ROOT, {}, { ref: Transform.RootRef, state: state });
    }
    Transform.createRoot = createRoot;
    function hasTag(t, tag) {
        if (!t.tags)
            return false;
        return t.tags.indexOf(tag) >= 0;
    }
    Transform.hasTag = hasTag;
    function hasTags(t, tags) {
        if (!t.tags)
            return typeof tags !== 'string' && tags.length === 0;
        if (typeof tags === 'string')
            return hasTag(t, tags);
        for (var _i = 0, tags_1 = tags; _i < tags_1.length; _i++) {
            var tag = tags_1[_i];
            if (t.tags.indexOf(tag) < 0)
                return false;
        }
        return true;
    }
    Transform.hasTags = hasTags;
    function _id(x) { return x; }
    function toJSON(t) {
        var pToJson = t.transformer.definition.customSerialization
            ? t.transformer.definition.customSerialization.toJSON
            : _id;
        var state = void 0;
        for (var _i = 0, _a = Object.keys(t.state); _i < _a.length; _i++) {
            var k = _a[_i];
            var s = t.state[k];
            if (!s)
                continue;
            if (!state)
                state = {};
            state[k] = true;
        }
        return {
            parent: t.parent,
            transformer: t.transformer.id,
            params: t.params ? pToJson(t.params) : void 0,
            state: state,
            tags: t.tags,
            ref: t.ref,
            dependsOn: t.dependsOn,
            version: t.version
        };
    }
    Transform.toJSON = toJSON;
    function fromJSON(t) {
        var transformer = _transformer__WEBPACK_IMPORTED_MODULE_1__["StateTransformer"].get(t.transformer);
        var pFromJson = transformer.definition.customSerialization
            ? transformer.definition.customSerialization.fromJSON
            : _id;
        return {
            parent: t.parent,
            transformer: transformer,
            params: t.params ? pFromJson(t.params) : void 0,
            state: t.state || {},
            tags: t.tags,
            ref: t.ref,
            dependsOn: t.dependsOn,
            version: t.version
        };
    }
    Transform.fromJSON = fromJSON;
})(Transform || (Transform = {}));
//# sourceMappingURL=transform.js.map

/***/ }),

/***/ "./lib/mol-state/transformer.js":
/*!**************************************!*\
  !*** ./lib/mol-state/transformer.js ***!
  \**************************************/
/*! exports provided: StateTransformer */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "StateTransformer", function() { return Transformer; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _transform__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./transform */ "./lib/mol-state/transform.js");
/* harmony import */ var _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../mol-util/param-definition */ "./lib/mol-util/param-definition.js");
/* harmony import */ var _action__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./action */ "./lib/mol-state/action.js");
/* harmony import */ var _mol_util_string__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../mol-util/string */ "./lib/mol-util/string.js");
/**
 * Copyright (c) 2018 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author David Sehnal <david.sehnal@gmail.com>
 */






var Transformer;
(function (Transformer) {
    function getParamDefinition(t, a, globalCtx) {
        return t.definition.params ? t.definition.params(a, globalCtx) : {};
    }
    Transformer.getParamDefinition = getParamDefinition;
    function is(obj) {
        return !!obj && typeof obj.toAction === 'function' && typeof obj.apply === 'function';
    }
    Transformer.is = is;
    var UpdateResult;
    (function (UpdateResult) {
        UpdateResult[UpdateResult["Unchanged"] = 0] = "Unchanged";
        UpdateResult[UpdateResult["Updated"] = 1] = "Updated";
        UpdateResult[UpdateResult["Recreate"] = 2] = "Recreate";
        UpdateResult[UpdateResult["Null"] = 3] = "Null";
    })(UpdateResult = Transformer.UpdateResult || (Transformer.UpdateResult = {}));
    var registry = new Map();
    var fromTypeIndex = new Map();
    function _index(tr) {
        for (var _i = 0, _a = tr.definition.from; _i < _a.length; _i++) {
            var t = _a[_i];
            if (fromTypeIndex.has(t.type)) {
                fromTypeIndex.get(t.type).push(tr);
            }
            else {
                fromTypeIndex.set(t.type, [tr]);
            }
        }
    }
    function getAll() {
        return Array.from(registry.values());
    }
    Transformer.getAll = getAll;
    function get(id) {
        var t = registry.get(id);
        if (!t) {
            throw new Error("A transformer with signature '" + id + "' is not registered.");
        }
        return t;
    }
    Transformer.get = get;
    function fromType(type) {
        return fromTypeIndex.get(type) || [];
    }
    Transformer.fromType = fromType;
    function create(namespace, definition) {
        var name = definition.name;
        var id = namespace + "." + name;
        if (registry.has(id)) {
            throw new Error("A transform with id '" + name + "' is already registered. Please pick a unique identifier for your transforms and/or register them only once. This is to ensure that transforms can be serialized and replayed.");
        }
        var t = {
            apply: function (parent, params, props) { return _transform__WEBPACK_IMPORTED_MODULE_1__["StateTransform"].create(parent, t, params, props); },
            toAction: function () { return _action__WEBPACK_IMPORTED_MODULE_3__["StateAction"].fromTransformer(t); },
            namespace: namespace,
            id: id,
            definition: definition,
            createDefaultParams: function (a, globalCtx) { return definition.params ? _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_2__["ParamDefinition"].getDefaultValues(definition.params(a, globalCtx)) : {}; }
        };
        registry.set(id, t);
        _index(t);
        return t;
    }
    Transformer.create = create;
    function factory(namespace) {
        return function (definition) { return create(namespace, definition); };
    }
    Transformer.factory = factory;
    function builderFactory(namespace) {
        return Builder.build(namespace);
    }
    Transformer.builderFactory = builderFactory;
    var Builder;
    (function (Builder) {
        function root(namespace, info) {
            return function (def) { return create(namespace, Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({ name: info.name, from: info.from instanceof Array ? info.from : [info.from], to: info.to instanceof Array ? info.to : [info.to], display: typeof info.display === 'string'
                    ? { name: info.display }
                    : !!info.display
                        ? info.display
                        : { name: Object(_mol_util_string__WEBPACK_IMPORTED_MODULE_4__["capitalize"])(info.name.replace(/[-]/g, ' ')) }, params: typeof info.params === 'object'
                    ? function () { return info.params; }
                    : !!info.params
                        ? info.params
                        : void 0, isDecorator: info.isDecorator }, def)); };
        }
        function build(namespace) {
            return function (info) { return root(namespace, info); };
        }
        Builder.build = build;
    })(Builder = Transformer.Builder || (Transformer.Builder = {}));
    function build(namespace) {
        return Builder.build(namespace);
    }
    Transformer.build = build;
    Transformer.ROOT = create('build-in', {
        name: 'root',
        from: [],
        to: [],
        display: { name: 'Root', description: 'For internal use.' },
        apply: function () { throw new Error('should never be applied'); },
        update: function () { return UpdateResult.Unchanged; }
    });
})(Transformer || (Transformer = {}));
//# sourceMappingURL=transformer.js.map

/***/ }),

/***/ "./lib/mol-state/tree.js":
/*!*******************************!*\
  !*** ./lib/mol-state/tree.js ***!
  \*******************************/
/*! exports provided: StateTree, TransientTree */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _tree_immutable__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./tree/immutable */ "./lib/mol-state/tree/immutable.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "StateTree", function() { return _tree_immutable__WEBPACK_IMPORTED_MODULE_0__["StateTree"]; });

/* harmony import */ var _tree_transient__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./tree/transient */ "./lib/mol-state/tree/transient.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "TransientTree", function() { return _tree_transient__WEBPACK_IMPORTED_MODULE_1__["TransientTree"]; });

/**
 * Copyright (c) 2018 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author David Sehnal <david.sehnal@gmail.com>
 */



//# sourceMappingURL=tree.js.map

/***/ }),

/***/ "./lib/mol-state/tree/immutable.js":
/*!*****************************************!*\
  !*** ./lib/mol-state/tree/immutable.js ***!
  \*****************************************/
/*! exports provided: StateTree */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "StateTree", function() { return StateTree; });
/* harmony import */ var immutable__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! immutable */ "./node_modules/immutable/dist/immutable.js");
/* harmony import */ var immutable__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(immutable__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _transform__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../transform */ "./lib/mol-state/transform.js");
/* harmony import */ var _transient__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./transient */ "./lib/mol-state/tree/transient.js");
/**
 * Copyright (c) 2018 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author David Sehnal <david.sehnal@gmail.com>
 */




var StateTree;
(function (StateTree) {
    var Impl = /** @class */ (function () {
        function Impl(transforms, children, dependencies) {
            this.transforms = transforms;
            this.children = children;
            this.dependencies = dependencies;
        }
        Object.defineProperty(Impl.prototype, "root", {
            get: function () { return this.transforms.get(_transform__WEBPACK_IMPORTED_MODULE_1__["StateTransform"].RootRef); },
            enumerable: false,
            configurable: true
        });
        Impl.prototype.asTransient = function () {
            return new _transient__WEBPACK_IMPORTED_MODULE_2__["TransientTree"](this);
        };
        return Impl;
    }());
    /**
     * Create an instance of an immutable tree.
     */
    function createEmpty(customRoot) {
        var root = customRoot || _transform__WEBPACK_IMPORTED_MODULE_1__["StateTransform"].createRoot();
        return create(Object(immutable__WEBPACK_IMPORTED_MODULE_0__["Map"])([[root.ref, root]]), Object(immutable__WEBPACK_IMPORTED_MODULE_0__["Map"])([[root.ref, Object(immutable__WEBPACK_IMPORTED_MODULE_0__["OrderedSet"])()]]), Object(immutable__WEBPACK_IMPORTED_MODULE_0__["Map"])());
    }
    StateTree.createEmpty = createEmpty;
    function create(nodes, children, dependencies) {
        return new Impl(nodes, children, dependencies);
    }
    StateTree.create = create;
    function _postOrderFunc(c) { _doPostOrder(this, this.tree.transforms.get(c)); }
    function _doPostOrder(ctx, root) {
        var children = ctx.tree.children.get(root.ref);
        if (children && children.size) {
            children.forEach(_postOrderFunc, ctx);
        }
        ctx.f(root, ctx.tree, ctx.state);
    }
    /**
     * Visit all nodes in a subtree in "post order", meaning leafs get visited first.
     */
    function doPostOrder(tree, root, state, f) {
        var ctx = { tree: tree, state: state, f: f };
        _doPostOrder(ctx, root);
        return ctx.state;
    }
    StateTree.doPostOrder = doPostOrder;
    function _preOrderFunc(c) { _doPreOrder(this, this.tree.transforms.get(c)); }
    function _doPreOrder(ctx, root) {
        var ret = ctx.f(root, ctx.tree, ctx.state);
        if (typeof ret === 'boolean' && !ret)
            return;
        var children = ctx.tree.children.get(root.ref);
        if (children && children.size) {
            children.forEach(_preOrderFunc, ctx);
        }
    }
    /**
     * Visit all nodes in a subtree in "pre order", meaning leafs get visited last.
     * If the visitor function returns false, the visiting for that branch is interrupted.
     */
    function doPreOrder(tree, root, state, f) {
        var ctx = { tree: tree, state: state, f: f };
        _doPreOrder(ctx, root);
        return ctx.state;
    }
    StateTree.doPreOrder = doPreOrder;
    function _subtree(n, _, subtree) { subtree.push(n); }
    /**
     * Get all nodes in a subtree, leafs come first.
     */
    function subtreePostOrder(tree, root) {
        return doPostOrder(tree, root, [], _subtree);
    }
    StateTree.subtreePostOrder = subtreePostOrder;
    function _visitNodeToJson(node, tree, ctx) {
        // const children: Ref[] = [];
        // tree.children.get(node.ref).forEach(_visitChildToJson as any, children);
        ctx.push(_transform__WEBPACK_IMPORTED_MODULE_1__["StateTransform"].toJSON(node));
    }
    function toJSON(tree) {
        var transforms = [];
        doPreOrder(tree, tree.root, transforms, _visitNodeToJson);
        return { transforms: transforms };
    }
    StateTree.toJSON = toJSON;
    function fromJSON(data) {
        var nodes = Object(immutable__WEBPACK_IMPORTED_MODULE_0__["Map"])().asMutable();
        var children = Object(immutable__WEBPACK_IMPORTED_MODULE_0__["Map"])().asMutable();
        var dependencies = Object(immutable__WEBPACK_IMPORTED_MODULE_0__["Map"])().asMutable();
        for (var _i = 0, _a = data.transforms; _i < _a.length; _i++) {
            var t = _a[_i];
            var transform = _transform__WEBPACK_IMPORTED_MODULE_1__["StateTransform"].fromJSON(t);
            nodes.set(transform.ref, transform);
            if (!children.has(transform.ref)) {
                children.set(transform.ref, Object(immutable__WEBPACK_IMPORTED_MODULE_0__["OrderedSet"])().asMutable());
            }
            if (transform.ref !== transform.parent)
                children.get(transform.parent).add(transform.ref);
        }
        var dependent = new Set();
        for (var _b = 0, _c = data.transforms; _b < _c.length; _b++) {
            var t = _c[_b];
            var ref = t.ref;
            children.set(ref, children.get(ref).asImmutable());
            if (!t.dependsOn)
                continue;
            for (var _d = 0, _e = t.dependsOn; _d < _e.length; _d++) {
                var d = _e[_d];
                dependent.add(d);
                if (!dependencies.has(d)) {
                    dependencies.set(d, Object(immutable__WEBPACK_IMPORTED_MODULE_0__["OrderedSet"])([ref]).asMutable());
                }
                else {
                    dependencies.get(d).add(ref);
                }
            }
        }
        dependent.forEach(function (d) {
            dependencies.set(d, dependencies.get(d).asImmutable());
        });
        return create(nodes.asImmutable(), children.asImmutable(), dependencies.asImmutable());
    }
    StateTree.fromJSON = fromJSON;
    function dump(tree) {
        console.log({
            tr: tree.transforms.keySeq().toArray(),
            tr1: tree.transforms.valueSeq().toArray().map(function (t) { return t.ref; }),
            ch: tree.children.keySeq().toArray()
        });
    }
    StateTree.dump = dump;
    function _subtreeHasRef(tree, root, ref) {
        if (root === ref)
            return true;
        var children = tree.children.get(root);
        var it = children.values();
        while (true) {
            var next = it.next();
            if (next.done)
                return false;
            if (_subtreeHasRef(tree, next.value, ref))
                return true;
        }
    }
    /** Check if the subtree with the given root has the provided ref */
    function subtreeHasRef(tree, root, ref) {
        if (!tree.transforms.has(root) || !tree.transforms.has(ref))
            return false;
        return _subtreeHasRef(tree, root, ref);
    }
    StateTree.subtreeHasRef = subtreeHasRef;
    function getDecoratorRoot(tree, ref) {
        var children = tree.children.get(ref);
        if (children.size !== 1)
            return ref;
        var child = tree.transforms.get(children.first());
        if (child.transformer.definition.isDecorator)
            return getDecoratorRoot(tree, child.ref);
        return ref;
    }
    StateTree.getDecoratorRoot = getDecoratorRoot;
})(StateTree || (StateTree = {}));
//# sourceMappingURL=immutable.js.map

/***/ }),

/***/ "./lib/mol-state/tree/spine.js":
/*!*************************************!*\
  !*** ./lib/mol-state/tree/spine.js ***!
  \*************************************/
/*! exports provided: StateTreeSpine */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "StateTreeSpine", function() { return StateTreeSpine; });
/* harmony import */ var _transform__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../transform */ "./lib/mol-state/transform.js");
/**
 * Copyright (c) 2019 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author David Sehnal <david.sehnal@gmail.com>
 */


var StateTreeSpine;
(function (StateTreeSpine) {
    var Impl = /** @class */ (function () {
        function Impl(cells) {
            this.cells = cells;
            this._current = void 0;
        }
        Object.defineProperty(Impl.prototype, "current", {
            get: function () { return this._current; },
            set: function (cell) { this._current = cell; },
            enumerable: false,
            configurable: true
        });
        Impl.prototype.getAncestorOfType = function (t) {
            if (!this._current)
                return void 0;
            var cell = this._current;
            while (true) {
                cell = this.cells.get(cell.transform.parent);
                if (!cell.obj)
                    return void 0;
                if (cell.obj.type === t.type)
                    return cell.obj;
                if (cell.transform.ref === _transform__WEBPACK_IMPORTED_MODULE_0__["StateTransform"].RootRef)
                    return void 0;
            }
        };
        Impl.prototype.getRootOfType = function (t) {
            if (!this._current)
                return void 0;
            var cell = this._current; // check current first
            var ret = void 0;
            while (true) {
                if (!cell.obj)
                    return void 0;
                if (cell.obj.type === t.type) {
                    ret = cell;
                }
                if (cell.transform.ref === _transform__WEBPACK_IMPORTED_MODULE_0__["StateTransform"].RootRef)
                    return ret ? ret.obj : void 0;
                cell = this.cells.get(cell.transform.parent); // assign parent for next check
            }
        };
        return Impl;
    }());
    StateTreeSpine.Impl = Impl;
    function getDecoratorChain(state, currentRef) {
        var cells = state.cells;
        var current = cells.get(currentRef);
        var ret = [current];
        while (current === null || current === void 0 ? void 0 : current.transform.transformer.definition.isDecorator) {
            current = cells.get(current.transform.parent);
            ret.push(current);
        }
        return ret;
    }
    StateTreeSpine.getDecoratorChain = getDecoratorChain;
    function getRootOfType(state, t, ref) {
        var ret = void 0;
        var cell = state.cells.get(ref);
        if (!cell)
            return void 0;
        while (true) {
            if (!cell.obj)
                return void 0;
            if (cell.obj.type === t.type) {
                ret = cell;
            }
            if (cell.transform.ref === _transform__WEBPACK_IMPORTED_MODULE_0__["StateTransform"].RootRef)
                return ret ? ret.obj : void 0;
            cell = state.cells.get(cell.transform.parent); // assign parent for next check
        }
    }
    StateTreeSpine.getRootOfType = getRootOfType;
})(StateTreeSpine || (StateTreeSpine = {}));
//# sourceMappingURL=spine.js.map

/***/ }),

/***/ "./lib/mol-state/tree/transient.js":
/*!*****************************************!*\
  !*** ./lib/mol-state/tree/transient.js ***!
  \*****************************************/
/*! exports provided: TransientTree */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "TransientTree", function() { return TransientTree; });
/* harmony import */ var immutable__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! immutable */ "./node_modules/immutable/dist/immutable.js");
/* harmony import */ var immutable__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(immutable__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _transform__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../transform */ "./lib/mol-state/transform.js");
/* harmony import */ var _immutable__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./immutable */ "./lib/mol-state/tree/immutable.js");
/* harmony import */ var _mol_util_object__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../mol-util/object */ "./lib/mol-util/object.js");
/* harmony import */ var _mol_util_array__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../mol-util/array */ "./lib/mol-util/array.js");
/**
 * Copyright (c) 2018 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author David Sehnal <david.sehnal@gmail.com>
 */






var TransientTree = /** @class */ (function () {
    function TransientTree(tree) {
        this.tree = tree;
        this.transforms = this.tree.transforms;
        this.children = this.tree.children;
        this.dependencies = this.tree.dependencies;
        this.changedNodes = false;
        this.changedChildren = false;
        this.changedDependencies = false;
        this._childMutations = void 0;
        this._dependencyMutations = void 0;
        this._stateUpdates = void 0;
    }
    Object.defineProperty(TransientTree.prototype, "childMutations", {
        get: function () {
            if (this._childMutations)
                return this._childMutations;
            this._childMutations = new Map();
            return this._childMutations;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TransientTree.prototype, "dependencyMutations", {
        get: function () {
            if (this._dependencyMutations)
                return this._dependencyMutations;
            this._dependencyMutations = new Map();
            return this._dependencyMutations;
        },
        enumerable: false,
        configurable: true
    });
    TransientTree.prototype.changeNodes = function () {
        if (this.changedNodes)
            return;
        this.changedNodes = true;
        this.transforms = this.transforms.asMutable();
    };
    TransientTree.prototype.changeChildren = function () {
        if (this.changedChildren)
            return;
        this.changedChildren = true;
        this.children = this.children.asMutable();
    };
    TransientTree.prototype.changeDependencies = function () {
        if (this.changedDependencies)
            return;
        this.changedDependencies = true;
        this.dependencies = this.dependencies.asMutable();
    };
    Object.defineProperty(TransientTree.prototype, "root", {
        get: function () { return this.transforms.get(_transform__WEBPACK_IMPORTED_MODULE_1__["StateTransform"].RootRef); },
        enumerable: false,
        configurable: true
    });
    TransientTree.prototype.asTransient = function () {
        return this.asImmutable().asTransient();
    };
    TransientTree.prototype.addChild = function (parent, child) {
        this.changeChildren();
        if (this.childMutations.has(parent)) {
            this.childMutations.get(parent).add(child);
        }
        else {
            var set = this.children.get(parent).asMutable();
            set.add(child);
            this.children.set(parent, set);
            this.childMutations.set(parent, set);
        }
    };
    TransientTree.prototype.removeChild = function (parent, child) {
        this.changeChildren();
        if (this.childMutations.has(parent)) {
            this.childMutations.get(parent).remove(child);
        }
        else {
            var set = this.children.get(parent).asMutable();
            set.remove(child);
            this.children.set(parent, set);
            this.childMutations.set(parent, set);
        }
    };
    TransientTree.prototype.clearRoot = function () {
        var parent = _transform__WEBPACK_IMPORTED_MODULE_1__["StateTransform"].RootRef;
        if (this.children.get(parent).size === 0)
            return;
        this.changeChildren();
        var set = Object(immutable__WEBPACK_IMPORTED_MODULE_0__["OrderedSet"])();
        this.children.set(parent, set);
        this.childMutations.set(parent, set);
    };
    TransientTree.prototype.mutateDependency = function (parent, child, action) {
        var set = this.dependencyMutations.get(parent);
        if (!set) {
            var src = this.dependencies.get(parent);
            if (!src && action === 'remove')
                return;
            this.changeDependencies();
            set = src ? src.asMutable() : Object(immutable__WEBPACK_IMPORTED_MODULE_0__["OrderedSet"])().asMutable();
            this.dependencyMutations.set(parent, set);
            this.dependencies.set(parent, set);
        }
        if (action === 'add') {
            set.add(child);
        }
        else {
            set.remove(child);
        }
    };
    TransientTree.prototype.changeParent = function (ref, newParent) {
        ensurePresent(this.transforms, ref);
        var old = this.transforms.get(ref);
        this.removeChild(old.parent, ref);
        this.addChild(newParent, ref);
        this.changeNodes();
        this.transforms.set(ref, _transform__WEBPACK_IMPORTED_MODULE_1__["StateTransform"].withParent(old, newParent));
    };
    TransientTree.prototype.add = function (transform) {
        var ref = transform.ref;
        if (this.transforms.has(transform.ref)) {
            var node = this.transforms.get(transform.ref);
            if (node.parent !== transform.parent)
                alreadyPresent(transform.ref);
        }
        var children = this.children.get(transform.parent);
        if (!children)
            parentNotPresent(transform.parent);
        if (!children.has(transform.ref)) {
            this.addChild(transform.parent, transform.ref);
        }
        if (!this.children.has(transform.ref)) {
            if (!this.changedChildren) {
                this.changedChildren = true;
                this.children = this.children.asMutable();
            }
            this.children.set(transform.ref, Object(immutable__WEBPACK_IMPORTED_MODULE_0__["OrderedSet"])());
        }
        this.changeNodes();
        this.transforms.set(ref, transform);
        if (transform.dependsOn) {
            for (var _i = 0, _a = transform.dependsOn; _i < _a.length; _i++) {
                var d = _a[_i];
                this.mutateDependency(d, ref, 'add');
            }
        }
        return this;
    };
    /** Calls Transform.definition.params.areEqual if available, otherwise uses shallowEqual to check if the params changed */
    TransientTree.prototype.setParams = function (ref, params) {
        ensurePresent(this.transforms, ref);
        var transform = this.transforms.get(ref);
        // TODO: should this be here?
        if (Object(_mol_util_object__WEBPACK_IMPORTED_MODULE_3__["shallowEqual"])(transform.params, params)) {
            return false;
        }
        if (!this.changedNodes) {
            this.changedNodes = true;
            this.transforms = this.transforms.asMutable();
        }
        this.transforms.set(transform.ref, _transform__WEBPACK_IMPORTED_MODULE_1__["StateTransform"].withParams(transform, params));
        return true;
    };
    /** Calls Transform.definition.params.areEqual if available, otherwise uses shallowEqual to check if the params changed */
    TransientTree.prototype.setTags = function (ref, tags) {
        ensurePresent(this.transforms, ref);
        var transform = this.transforms.get(ref);
        var withTags = _transform__WEBPACK_IMPORTED_MODULE_1__["StateTransform"].withParams(transform, tags);
        // TODO: should this be here?
        if (Object(_mol_util_array__WEBPACK_IMPORTED_MODULE_4__["arrayEqual"])(transform.tags, withTags.tags)) {
            return false;
        }
        if (!this.changedNodes) {
            this.changedNodes = true;
            this.transforms = this.transforms.asMutable();
        }
        this.transforms.set(transform.ref, withTags);
        return true;
    };
    TransientTree.prototype.assignState = function (ref, state) {
        ensurePresent(this.transforms, ref);
        var old = this.transforms.get(ref);
        if (this._stateUpdates && this._stateUpdates.has(ref)) {
            _transform__WEBPACK_IMPORTED_MODULE_1__["StateTransform"].assignState(old.state, state);
            return old;
        }
        else {
            if (!this._stateUpdates)
                this._stateUpdates = new Set();
            this._stateUpdates.add(old.ref);
            this.changeNodes();
            var updated = _transform__WEBPACK_IMPORTED_MODULE_1__["StateTransform"].withState(old, state);
            this.transforms.set(ref, updated);
            return updated;
        }
    };
    TransientTree.prototype.remove = function (ref) {
        var node = this.transforms.get(ref);
        if (!node)
            return [];
        var st = _immutable__WEBPACK_IMPORTED_MODULE_2__["StateTree"].subtreePostOrder(this, node);
        if (ref === _transform__WEBPACK_IMPORTED_MODULE_1__["StateTransform"].RootRef) {
            st.pop();
            if (st.length === 0)
                return st;
            this.clearRoot();
        }
        else {
            if (st.length === 0)
                return st;
            this.removeChild(node.parent, node.ref);
        }
        this.changeNodes();
        this.changeChildren();
        for (var _i = 0, st_1 = st; _i < st_1.length; _i++) {
            var n = st_1[_i];
            this.transforms.delete(n.ref);
            this.children.delete(n.ref);
            if (this._childMutations)
                this._childMutations.delete(n.ref);
        }
        var depRemoves = [];
        for (var _a = 0, st_2 = st; _a < st_2.length; _a++) {
            var n = st_2[_a];
            if (n.dependsOn) {
                for (var _b = 0, _c = n.dependsOn; _b < _c.length; _b++) {
                    var d = _c[_b];
                    if (!this.transforms.has(d))
                        continue;
                    this.mutateDependency(d, n.ref, 'remove');
                }
            }
            if (this.dependencies.has(n.ref)) {
                var deps = this.dependencies.get(n.ref).toArray();
                this.changeDependencies();
                this.dependencies.delete(n.ref);
                if (this._dependencyMutations)
                    this._dependencyMutations.delete(n.ref);
                for (var _d = 0, deps_1 = deps; _d < deps_1.length; _d++) {
                    var dep = deps_1[_d];
                    if (!this.transforms.has(dep))
                        continue;
                    for (var _e = 0, _f = this.remove(dep); _e < _f.length; _e++) {
                        var del = _f[_e];
                        depRemoves[depRemoves.length] = del;
                    }
                }
            }
        }
        for (var _g = 0, depRemoves_1 = depRemoves; _g < depRemoves_1.length; _g++) {
            var dep = depRemoves_1[_g];
            st[st.length] = dep;
        }
        return st;
    };
    TransientTree.prototype.asImmutable = function () {
        if (!this.changedNodes && !this.changedChildren && !this._childMutations)
            return this.tree;
        if (this._childMutations)
            this._childMutations.forEach(fixChildMutations, this.children);
        if (this._dependencyMutations)
            this._dependencyMutations.forEach(fixDependencyMutations, this.dependencies);
        return _immutable__WEBPACK_IMPORTED_MODULE_2__["StateTree"].create(this.changedNodes ? this.transforms.asImmutable() : this.transforms, this.changedChildren ? this.children.asImmutable() : this.children, this.changedDependencies ? this.dependencies.asImmutable() : this.dependencies);
    };
    return TransientTree;
}());
function fixChildMutations(m, k) {
    this.set(k, m.asImmutable());
}
function fixDependencyMutations(m, k) {
    if (m.size === 0)
        this.delete(k);
    else
        this.set(k, m.asImmutable());
}
function alreadyPresent(ref) {
    throw new Error("Transform '" + ref + "' is already present in the tree.");
}
function parentNotPresent(ref) {
    throw new Error("Parent '" + ref + "' must be present in the tree.");
}
function ensurePresent(nodes, ref) {
    if (!nodes.has(ref)) {
        throw new Error("Node '" + ref + "' is not present in the tree.");
    }
}
//# sourceMappingURL=transient.js.map

/***/ }),

/***/ "./lib/mol-task/execution/observable.js":
/*!**********************************************!*\
  !*** ./lib/mol-task/execution/observable.js ***!
  \**********************************************/
/*! exports provided: ExecuteObservable, CreateObservableCtx, ExecuteInContext, ExecuteObservableChild */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ExecuteObservable", function() { return ExecuteObservable; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CreateObservableCtx", function() { return CreateObservableCtx; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ExecuteInContext", function() { return ExecuteInContext; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ExecuteObservableChild", function() { return ExecuteObservableChild; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _task__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../task */ "./lib/mol-task/task.js");
/* harmony import */ var _mol_util_now__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../mol-util/now */ "./lib/mol-util/now.js");
/* harmony import */ var _util_scheduler__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../util/scheduler */ "./lib/mol-task/util/scheduler.js");
/* harmony import */ var _util_user_timing__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../util/user-timing */ "./lib/mol-task/util/user-timing.js");
/* harmony import */ var _mol_util_debug__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../mol-util/debug */ "./lib/mol-util/debug.js");
/**
 * Copyright (c) 2017-2018 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author David Sehnal <david.sehnal@gmail.com>
 */






function ExecuteObservable(task, observer, updateRateMs) {
    if (updateRateMs === void 0) { updateRateMs = 250; }
    var info = ProgressInfo(task, observer, updateRateMs);
    var ctx = new ObservableRuntimeContext(info, info.root);
    return execute(task, ctx);
}
function CreateObservableCtx(task, observer, updateRateMs) {
    if (updateRateMs === void 0) { updateRateMs = 250; }
    var info = ProgressInfo(task, observer, updateRateMs);
    return new ObservableRuntimeContext(info, info.root);
}
function ExecuteInContext(ctx, task) {
    return execute(task, ctx);
}
function ExecuteObservableChild(ctx, task, progress) {
    return ctx.runChild(task, progress);
}
function defaultProgress(task) {
    return {
        taskId: task.id,
        taskName: task.name,
        message: '',
        startedTime: 0,
        canAbort: true,
        isIndeterminate: true,
        current: 0,
        max: 0
    };
}
function ProgressInfo(task, observer, updateRateMs) {
    var abortToken = { abortRequested: false, treeAborted: false, reason: '' };
    return {
        updateRateMs: updateRateMs,
        lastNotified: Object(_mol_util_now__WEBPACK_IMPORTED_MODULE_2__["now"])(),
        observer: observer,
        abortToken: abortToken,
        taskId: task.id,
        root: { progress: defaultProgress(task), children: [] },
        tryAbort: createAbortFunction(abortToken)
    };
}
function createAbortFunction(token) {
    return function (reason) {
        token.abortRequested = true;
        token.reason = reason || token.reason;
    };
}
function cloneTree(root) {
    return { progress: Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, root.progress), children: root.children.map(cloneTree) };
}
function canAbort(root) {
    return root.progress.canAbort && root.children.every(canAbort);
}
function snapshotProgress(info) {
    return { root: cloneTree(info.root), canAbort: canAbort(info.root), requestAbort: info.tryAbort };
}
function execute(task, ctx) {
    return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"])(this, void 0, void 0, function () {
        var ret, e_1;
        return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__generator"])(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _util_user_timing__WEBPACK_IMPORTED_MODULE_4__["UserTiming"].markStart(task);
                    ctx.node.progress.startedTime = Object(_mol_util_now__WEBPACK_IMPORTED_MODULE_2__["now"])();
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 7]);
                    return [4 /*yield*/, task.f(ctx)];
                case 2:
                    ret = _a.sent();
                    _util_user_timing__WEBPACK_IMPORTED_MODULE_4__["UserTiming"].markEnd(task);
                    _util_user_timing__WEBPACK_IMPORTED_MODULE_4__["UserTiming"].measure(task);
                    if (ctx.info.abortToken.abortRequested) {
                        abort(ctx.info);
                    }
                    return [2 /*return*/, ret];
                case 3:
                    e_1 = _a.sent();
                    if (!_task__WEBPACK_IMPORTED_MODULE_1__["Task"].isAbort(e_1)) return [3 /*break*/, 6];
                    ctx.isAborted = true;
                    if (!(ctx.node.children.length > 0)) return [3 /*break*/, 5];
                    return [4 /*yield*/, new Promise(function (res) { ctx.onChildrenFinished = res; })];
                case 4:
                    _a.sent();
                    _a.label = 5;
                case 5:
                    if (task.onAbort) {
                        task.onAbort();
                    }
                    _a.label = 6;
                case 6:
                    if (_mol_util_debug__WEBPACK_IMPORTED_MODULE_5__["isDebugMode"])
                        console.error(e_1);
                    throw e_1;
                case 7: return [2 /*return*/];
            }
        });
    });
}
function abort(info) {
    if (!info.abortToken.treeAborted) {
        info.abortToken.treeAborted = true;
        abortTree(info.root);
        notifyObserver(info, Object(_mol_util_now__WEBPACK_IMPORTED_MODULE_2__["now"])());
    }
    throw _task__WEBPACK_IMPORTED_MODULE_1__["Task"].Aborted(info.abortToken.reason);
}
function abortTree(root) {
    var progress = root.progress;
    progress.isIndeterminate = true;
    progress.canAbort = false;
    progress.message = 'Aborting...';
    for (var _a = 0, _b = root.children; _a < _b.length; _a++) {
        var c = _b[_a];
        abortTree(c);
    }
}
// function shouldNotify(info: ProgressInfo, time: number) {
//     return time - info.lastNotified > info.updateRateMs;
// }
function notifyObserver(info, time) {
    info.lastNotified = time;
    var snapshot = snapshotProgress(info);
    info.observer(snapshot);
}
var ObservableRuntimeContext = /** @class */ (function () {
    function ObservableRuntimeContext(info, node) {
        this.isSynchronous = false;
        this.isExecuting = true;
        this.lastUpdatedTime = 0;
        // used for waiting for cancelled computation trees
        this.onChildrenFinished = void 0;
        this.node = node;
        this.info = info;
    }
    ObservableRuntimeContext.prototype.checkAborted = function () {
        if (this.info.abortToken.abortRequested) {
            this.isAborted = true;
            abort(this.info);
        }
    };
    Object.defineProperty(ObservableRuntimeContext.prototype, "shouldUpdate", {
        get: function () {
            this.checkAborted();
            return Object(_mol_util_now__WEBPACK_IMPORTED_MODULE_2__["now"])() - this.lastUpdatedTime > this.info.updateRateMs;
        },
        enumerable: false,
        configurable: true
    });
    ObservableRuntimeContext.prototype.updateProgress = function (update) {
        this.checkAborted();
        if (!update)
            return;
        var progress = this.node.progress;
        if (typeof update === 'string') {
            progress.message = update;
            progress.isIndeterminate = true;
        }
        else {
            if (typeof update.canAbort !== 'undefined')
                progress.canAbort = update.canAbort;
            if (typeof update.message !== 'undefined')
                progress.message = update.message;
            if (typeof update.current !== 'undefined')
                progress.current = update.current;
            if (typeof update.max !== 'undefined')
                progress.max = update.max;
            progress.isIndeterminate = typeof progress.current === 'undefined' || typeof progress.max === 'undefined';
            if (typeof update.isIndeterminate !== 'undefined')
                progress.isIndeterminate = update.isIndeterminate;
        }
    };
    ObservableRuntimeContext.prototype.update = function (progress, dontNotify) {
        // The progress tracking and observer notification are separated
        // because the computation can have a tree structure.
        // All nodes of the tree should be regualarly updated at the specified frequency,
        // however, the notification should only be invoked once per the whole tree.
        this.lastUpdatedTime = Object(_mol_util_now__WEBPACK_IMPORTED_MODULE_2__["now"])();
        this.updateProgress(progress);
        // TODO: do the shouldNotify check here?
        if (!!dontNotify /* || !shouldNotify(this.info, this.lastUpdatedTime)*/)
            return;
        notifyObserver(this.info, this.lastUpdatedTime);
        // The computation could have been aborted during the notifycation phase.
        this.checkAborted();
        return _util_scheduler__WEBPACK_IMPORTED_MODULE_3__["Scheduler"].immediatePromise();
    };
    ObservableRuntimeContext.prototype.runChild = function (task, progress) {
        return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"])(this, void 0, void 0, function () {
            var node, children, ctx, e_2, idx, i, _i;
            return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__generator"])(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.updateProgress(progress);
                        node = { progress: defaultProgress(task), children: [] };
                        children = this.node.children;
                        children.push(node);
                        ctx = new ObservableRuntimeContext(this.info, node);
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, 4, 5]);
                        return [4 /*yield*/, execute(task, ctx)];
                    case 2: return [2 /*return*/, _a.sent()];
                    case 3:
                        e_2 = _a.sent();
                        if (_task__WEBPACK_IMPORTED_MODULE_1__["Task"].isAbort(e_2)) {
                            // need to catch the error here because otherwise
                            // promises for running child tasks in a tree-like computation
                            // will get orphaned and cause "uncaught error in Promise".
                            if (this.isAborted)
                                return [2 /*return*/, void 0];
                        }
                        throw e_2;
                    case 4:
                        idx = children.indexOf(node);
                        if (idx >= 0) {
                            for (i = idx, _i = children.length - 1; i < _i; i++) {
                                children[i] = children[i + 1];
                            }
                            children.pop();
                        }
                        if (children.length === 0 && this.onChildrenFinished)
                            this.onChildrenFinished();
                        return [7 /*endfinally*/];
                    case 5: return [2 /*return*/];
                }
            });
        });
    };
    return ObservableRuntimeContext;
}());
//# sourceMappingURL=observable.js.map

/***/ }),

/***/ "./lib/mol-task/execution/progress.js":
/*!********************************************!*\
  !*** ./lib/mol-task/execution/progress.js ***!
  \********************************************/
/*! exports provided: Progress */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Progress", function() { return Progress; });
/**
 * Copyright (c) 2017 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author David Sehnal <david.sehnal@gmail.com>
 */
var Progress;
(function (Progress) {
    function _format(root, prefix) {
        if (prefix === void 0) { prefix = ''; }
        var p = root.progress;
        if (!root.children.length) {
            if (p.isIndeterminate)
                return "" + prefix + p.taskName + ": " + p.message;
            return "" + prefix + p.taskName + ": [" + p.current + "/" + p.max + "] " + p.message;
        }
        var newPrefix = prefix + '  |_ ';
        var subTree = root.children.map(function (c) { return _format(c, newPrefix); });
        if (p.isIndeterminate)
            return "" + prefix + p.taskName + ": " + p.message + "\n" + subTree.join('\n');
        return "" + prefix + p.taskName + ": [" + p.current + "/" + p.max + "] " + p.message + "\n" + subTree.join('\n');
    }
    function format(p) { return _format(p.root); }
    Progress.format = format;
})(Progress || (Progress = {}));

//# sourceMappingURL=progress.js.map

/***/ }),

/***/ "./lib/mol-task/execution/runtime-context.js":
/*!***************************************************!*\
  !*** ./lib/mol-task/execution/runtime-context.js ***!
  \***************************************************/
/*! exports provided: RuntimeContext */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "RuntimeContext", function() { return RuntimeContext; });
/* harmony import */ var _synchronous__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./synchronous */ "./lib/mol-task/execution/synchronous.js");
/**
 * Copyright (c) 2017 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author David Sehnal <david.sehnal@gmail.com>
 */

var RuntimeContext;
(function (RuntimeContext) {
    RuntimeContext.Synchronous = _synchronous__WEBPACK_IMPORTED_MODULE_0__["SyncRuntimeContext"];
})(RuntimeContext || (RuntimeContext = {}));

//# sourceMappingURL=runtime-context.js.map

/***/ }),

/***/ "./lib/mol-task/execution/synchronous.js":
/*!***********************************************!*\
  !*** ./lib/mol-task/execution/synchronous.js ***!
  \***********************************************/
/*! exports provided: SynchronousRuntimeContext, SyncRuntimeContext */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SynchronousRuntimeContext", function() { return SynchronousRuntimeContext; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SyncRuntimeContext", function() { return SyncRuntimeContext; });
/**
 * Copyright (c) 2017 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author David Sehnal <david.sehnal@gmail.com>
 */
var SynchronousRuntimeContext = /** @class */ (function () {
    function SynchronousRuntimeContext() {
        this.shouldUpdate = false;
        this.isSynchronous = true;
    }
    SynchronousRuntimeContext.prototype.update = function (progress, dontNotify) { };
    return SynchronousRuntimeContext;
}());

var SyncRuntimeContext = new SynchronousRuntimeContext();
//# sourceMappingURL=synchronous.js.map

/***/ }),

/***/ "./lib/mol-task/index.js":
/*!*******************************!*\
  !*** ./lib/mol-task/index.js ***!
  \*******************************/
/*! exports provided: Task, RuntimeContext, Progress, Scheduler, MultistepTask, chunkedSubtask */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _task__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./task */ "./lib/mol-task/task.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Task", function() { return _task__WEBPACK_IMPORTED_MODULE_0__["Task"]; });

/* harmony import */ var _execution_runtime_context__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./execution/runtime-context */ "./lib/mol-task/execution/runtime-context.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "RuntimeContext", function() { return _execution_runtime_context__WEBPACK_IMPORTED_MODULE_1__["RuntimeContext"]; });

/* harmony import */ var _execution_progress__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./execution/progress */ "./lib/mol-task/execution/progress.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Progress", function() { return _execution_progress__WEBPACK_IMPORTED_MODULE_2__["Progress"]; });

/* harmony import */ var _util_scheduler__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./util/scheduler */ "./lib/mol-task/util/scheduler.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Scheduler", function() { return _util_scheduler__WEBPACK_IMPORTED_MODULE_3__["Scheduler"]; });

/* harmony import */ var _util_multistep__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./util/multistep */ "./lib/mol-task/util/multistep.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MultistepTask", function() { return _util_multistep__WEBPACK_IMPORTED_MODULE_4__["MultistepTask"]; });

/* harmony import */ var _util_chunked__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./util/chunked */ "./lib/mol-task/util/chunked.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "chunkedSubtask", function() { return _util_chunked__WEBPACK_IMPORTED_MODULE_5__["chunkedSubtask"]; });

/**
 * Copyright (c) 2017 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author David Sehnal <david.sehnal@gmail.com>
 */







//# sourceMappingURL=index.js.map

/***/ }),

/***/ "./lib/mol-task/task.js":
/*!******************************!*\
  !*** ./lib/mol-task/task.js ***!
  \******************************/
/*! exports provided: Task */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Task", function() { return Task; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _execution_observable__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./execution/observable */ "./lib/mol-task/execution/observable.js");
/* harmony import */ var _execution_synchronous__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./execution/synchronous */ "./lib/mol-task/execution/synchronous.js");
/* harmony import */ var _mol_util_id_factory__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../mol-util/id-factory */ "./lib/mol-util/id-factory.js");
/**
 * Copyright (c) 2017-2018 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author David Sehnal <david.sehnal@gmail.com>
 */




var Task;
(function (Task) {
    var Impl = /** @class */ (function () {
        function Impl(name, f, onAbort) {
            this.name = name;
            this.f = f;
            this.onAbort = onAbort;
            this.id = getNextId();
        }
        Impl.prototype.run = function (observer, updateRateMs) {
            if (updateRateMs === void 0) { updateRateMs = 250; }
            if (observer)
                return Object(_execution_observable__WEBPACK_IMPORTED_MODULE_1__["ExecuteObservable"])(this, observer, updateRateMs);
            return this.f(_execution_synchronous__WEBPACK_IMPORTED_MODULE_2__["SyncRuntimeContext"]);
        };
        Impl.prototype.runAsChild = function (ctx, progress) {
            if (ctx.isSynchronous)
                return this.f(_execution_synchronous__WEBPACK_IMPORTED_MODULE_2__["SyncRuntimeContext"]);
            return Object(_execution_observable__WEBPACK_IMPORTED_MODULE_1__["ExecuteObservableChild"])(ctx, this, progress);
        };
        Impl.prototype.runInContext = function (ctx) {
            if (ctx.isSynchronous)
                return this.f(_execution_synchronous__WEBPACK_IMPORTED_MODULE_2__["SyncRuntimeContext"]);
            return Object(_execution_observable__WEBPACK_IMPORTED_MODULE_1__["ExecuteInContext"])(ctx, this);
        };
        return Impl;
    }());
    function is(t) {
        var _t = t;
        return !!t && typeof _t.id === 'number' && typeof _t.name === 'string' && !!_t.run;
    }
    Task.is = is;
    function isAbort(e) { return !!e && !!e.isAborted; }
    Task.isAbort = isAbort;
    function Aborted(reason) { return { isAborted: true, reason: reason, toString: function () { return "Aborted" + (reason ? ': ' + reason : ''); } }; }
    Task.Aborted = Aborted;
    function create(name, f, onAbort) {
        return new Impl(name, f, onAbort);
    }
    Task.create = create;
    function constant(name, value) {
        var _this = this;
        return create(name, function (ctx) { return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"])(_this, void 0, void 0, function () { return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__generator"])(this, function (_a) {
            return [2 /*return*/, value];
        }); }); });
    }
    Task.constant = constant;
    function empty() {
        var _this = this;
        return create('', function (ctx) { return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"])(_this, void 0, void 0, function () { return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__generator"])(this, function (_a) {
            return [2 /*return*/];
        }); }); });
    }
    Task.empty = empty;
    function fail(name, reason) {
        var _this = this;
        return create(name, function (ctx) { return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"])(_this, void 0, void 0, function () { return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__generator"])(this, function (_a) {
            throw new Error(reason);
        }); }); });
    }
    Task.fail = fail;
    function resolveInContext(object, ctx) {
        if (is(object))
            return ctx ? object.runInContext(ctx) : object.run();
        return object;
    }
    Task.resolveInContext = resolveInContext;
    var getNextId = Object(_mol_util_id_factory__WEBPACK_IMPORTED_MODULE_3__["idFactory"])(0, 0x3fffffff);
})(Task || (Task = {}));

//# sourceMappingURL=task.js.map

/***/ }),

/***/ "./lib/mol-task/util/chunked.js":
/*!**************************************!*\
  !*** ./lib/mol-task/util/chunked.js ***!
  \**************************************/
/*! exports provided: chunkedSubtask */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "chunkedSubtask", function() { return chunkedSubtask; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _mol_util_now__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../mol-util/now */ "./lib/mol-util/now.js");
/**
 * Copyright (c) 2018 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author David Sehnal <david.sehnal@gmail.com>
 */


function chunkedSubtask(ctx, initialChunk, state, f, update) {
    return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"])(this, void 0, void 0, function () {
        var chunkSize, globalProcessed, globalTime, start, lastSize, currentTime, delta;
        return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__generator"])(this, function (_a) {
            switch (_a.label) {
                case 0:
                    chunkSize = Math.max(initialChunk, 0);
                    globalProcessed = 0, globalTime = 0;
                    if (ctx.isSynchronous) {
                        f(Number.MAX_SAFE_INTEGER, state);
                        return [2 /*return*/, state];
                    }
                    start = Object(_mol_util_now__WEBPACK_IMPORTED_MODULE_1__["now"])();
                    lastSize = 0, currentTime = 0;
                    _a.label = 1;
                case 1:
                    if (!((lastSize = f(chunkSize, state)) > 0)) return [3 /*break*/, 4];
                    globalProcessed += lastSize;
                    delta = Object(_mol_util_now__WEBPACK_IMPORTED_MODULE_1__["now"])() - start;
                    currentTime += delta;
                    globalTime += delta;
                    if (!ctx.shouldUpdate) return [3 /*break*/, 3];
                    return [4 /*yield*/, update(ctx, state, globalProcessed)];
                case 2:
                    _a.sent();
                    chunkSize = Math.round(currentTime * globalProcessed / globalTime) + 1;
                    start = Object(_mol_util_now__WEBPACK_IMPORTED_MODULE_1__["now"])();
                    currentTime = 0;
                    _a.label = 3;
                case 3: return [3 /*break*/, 1];
                case 4:
                    if (!ctx.shouldUpdate) return [3 /*break*/, 6];
                    return [4 /*yield*/, update(ctx, state, globalProcessed)];
                case 5:
                    _a.sent();
                    _a.label = 6;
                case 6: return [2 /*return*/, state];
            }
        });
    });
}

//# sourceMappingURL=chunked.js.map

/***/ }),

/***/ "./lib/mol-task/util/multistep.js":
/*!****************************************!*\
  !*** ./lib/mol-task/util/multistep.js ***!
  \****************************************/
/*! exports provided: MultistepTask */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MultistepTask", function() { return MultistepTask; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _task__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../task */ "./lib/mol-task/task.js");
/**
 * Copyright (c) 2018 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author David Sehnal <david.sehnal@gmail.com>
 */


function MultistepTask(name, steps, f, onAbort) {
    var _this = this;
    return function (params) { return _task__WEBPACK_IMPORTED_MODULE_1__["Task"].create(name, function (ctx) { return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"])(_this, void 0, void 0, function () { return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__generator"])(this, function (_a) {
        return [2 /*return*/, f(params, function (n) { return ctx.update({ message: "" + steps[n], current: n + 1, max: steps.length }); }, ctx)];
    }); }); }, onAbort); };
}

//# sourceMappingURL=multistep.js.map

/***/ }),

/***/ "./lib/mol-task/util/scheduler.js":
/*!****************************************!*\
  !*** ./lib/mol-task/util/scheduler.js ***!
  \****************************************/
/*! exports provided: Scheduler */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* WEBPACK VAR INJECTION */(function(process, setImmediate, clearImmediate) {/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Scheduler", function() { return Scheduler; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/**
 * Copyright (c) 2017 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author David Sehnal <david.sehnal@gmail.com>
 */

function createImmediateActions() {
    var global = (function () {
        var _window = typeof window !== 'undefined' && window;
        var _self = typeof self !== 'undefined' && typeof WorkerGlobalScope !== 'undefined' && self instanceof WorkerGlobalScope && self;
        var _global = typeof global !== 'undefined' && global;
        return _window || _global || _self;
    })();
    var tasksByHandle = {};
    var doc = typeof document !== 'undefined' ? document : void 0;
    var nextHandle = 1; // Spec says greater than zero
    var registerImmediate;
    function setImmediate(callback) {
        var args = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            args[_i - 1] = arguments[_i];
        }
        // Callback can either be a function or a string
        if (typeof callback !== 'function') {
            callback = new Function('' + callback);
        }
        // Store and register the task
        var task = { callback: callback, args: args };
        tasksByHandle[nextHandle] = task;
        registerImmediate(nextHandle);
        return nextHandle++;
    }
    function clearImmediate(handle) {
        delete tasksByHandle[handle];
    }
    function run(task) {
        var callback = task.callback;
        var args = task.args;
        switch (args.length) {
            case 0:
                callback();
                break;
            case 1:
                callback(args[0]);
                break;
            case 2:
                callback(args[0], args[1]);
                break;
            case 3:
                callback(args[0], args[1], args[2]);
                break;
            default:
                callback.apply(undefined, args);
                break;
        }
    }
    function runIfPresent(handle) {
        var task = tasksByHandle[handle];
        clearImmediate(handle);
        run(task);
    }
    function installNextTickImplementation() {
        registerImmediate = function (handle) {
            process.nextTick(function () { runIfPresent(handle); });
        };
    }
    function canUsePostMessage() {
        if (global && global.postMessage && !global.importScripts) {
            var postMessageIsAsynchronous_1 = true;
            var oldOnMessage = global.onmessage;
            global.onmessage = function () {
                postMessageIsAsynchronous_1 = false;
            };
            global.postMessage('', '*');
            global.onmessage = oldOnMessage;
            return postMessageIsAsynchronous_1;
        }
    }
    function installPostMessageImplementation() {
        // Installs an event handler on `global` for the `message` event: see
        // * https://developer.mozilla.org/en/DOM/window.postMessage
        // * http://www.whatwg.org/specs/web-apps/current-work/multipage/comms.html#crossDocumentMessages
        var messagePrefix = 'setImmediate$' + Math.random() + '$';
        var onGlobalMessage = function (event) {
            if (event.source === global &&
                typeof event.data === 'string' &&
                event.data.indexOf(messagePrefix) === 0) {
                runIfPresent(+event.data.slice(messagePrefix.length));
            }
        };
        if (window.addEventListener) {
            window.addEventListener('message', onGlobalMessage, false);
        }
        else {
            window.attachEvent('onmessage', onGlobalMessage);
        }
        registerImmediate = function (handle) {
            window.postMessage(messagePrefix + handle, '*');
        };
    }
    function installMessageChannelImplementation() {
        var channel = new MessageChannel();
        channel.port1.onmessage = function (event) {
            var handle = event.data;
            runIfPresent(handle);
        };
        registerImmediate = function (handle) {
            channel.port2.postMessage(handle);
        };
    }
    function installReadyStateChangeImplementation() {
        var html = doc.documentElement;
        registerImmediate = function (handle) {
            // Create a <script> element; its readystatechange event will be fired asynchronously once it is inserted
            // into the document. Do so, thus queuing up the task. Remember to clean up once it's been called.
            var script = doc.createElement('script');
            script.onreadystatechange = function () {
                runIfPresent(handle);
                script.onreadystatechange = null;
                html.removeChild(script);
                script = null;
            };
            html.appendChild(script);
        };
    }
    function installSetTimeoutImplementation() {
        registerImmediate = function (handle) {
            setTimeout(runIfPresent, 0, handle);
        };
    }
    // Don't get fooled by e.g. browserify environments.
    if (typeof process !== 'undefined' && {}.toString.call(process) === '[object process]') {
        // For Node.js before 0.9
        installNextTickImplementation();
    }
    else if (canUsePostMessage()) {
        // For non-IE10 modern browsers
        installPostMessageImplementation();
    }
    else if (typeof MessageChannel !== 'undefined') {
        // For web workers, where supported
        installMessageChannelImplementation();
    }
    else if (doc && 'onreadystatechange' in doc.createElement('script')) {
        // For IE 6–8
        installReadyStateChangeImplementation();
    }
    else {
        // For older browsers
        installSetTimeoutImplementation();
    }
    return {
        setImmediate: setImmediate,
        clearImmediate: clearImmediate
    };
}
var immediateActions = (function () {
    if (typeof setImmediate !== 'undefined') {
        if (typeof window !== 'undefined') {
            return {
                setImmediate: function (handler) {
                    var _a;
                    var args = [];
                    for (var _i = 1; _i < arguments.length; _i++) {
                        args[_i - 1] = arguments[_i];
                    }
                    return (_a = window).setImmediate.apply(_a, Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__spreadArrays"])([handler], args));
                },
                clearImmediate: function (handle) { return window.clearImmediate(handle); }
            };
        }
        else {
            return { setImmediate: setImmediate, clearImmediate: clearImmediate };
        }
    }
    return createImmediateActions();
}());
function resolveImmediate(res) {
    immediateActions.setImmediate(res);
}
var Scheduler = {
    setImmediate: immediateActions.setImmediate,
    clearImmediate: immediateActions.clearImmediate,
    immediatePromise: function () { return new Promise(resolveImmediate); },
    delay: function (timeout, value) {
        if (value === void 0) { value = void 0; }
        return new Promise(function (r) { return setTimeout(r, timeout, value); });
    }
};

//# sourceMappingURL=scheduler.js.map
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(/*! ./../../../node_modules/process/browser.js */ "./node_modules/process/browser.js"), __webpack_require__(/*! ./../../../node_modules/timers-browserify/main.js */ "./node_modules/timers-browserify/main.js").setImmediate, __webpack_require__(/*! ./../../../node_modules/timers-browserify/main.js */ "./node_modules/timers-browserify/main.js").clearImmediate))

/***/ }),

/***/ "./lib/mol-task/util/user-timing.js":
/*!******************************************!*\
  !*** ./lib/mol-task/util/user-timing.js ***!
  \******************************************/
/*! exports provided: UserTiming */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "UserTiming", function() { return UserTiming; });
/* harmony import */ var _mol_util_debug__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../mol-util/debug */ "./lib/mol-util/debug.js");
/**
 * Copyright (c) 2018-2019 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */

var hasPerformance = (typeof performance !== 'undefined') && performance.mark && performance.measure;
var timingEnabled = hasPerformance && !_mol_util_debug__WEBPACK_IMPORTED_MODULE_0__["isProductionMode"];
var UserTiming;
(function (UserTiming) {
    function startMarkName(task) { return "startTask" + task.id; }
    function endMarkName(task) { return "endTask" + task.id; }
    function markStart(task) {
        if (timingEnabled)
            performance.mark(startMarkName(task));
    }
    UserTiming.markStart = markStart;
    function markEnd(task) {
        if (timingEnabled)
            performance.mark(endMarkName(task));
    }
    UserTiming.markEnd = markEnd;
    function measure(task) {
        if (timingEnabled)
            performance.measure("\u2733\uFE0F " + task.name, startMarkName(task), endMarkName(task));
    }
    UserTiming.measure = measure;
})(UserTiming || (UserTiming = {}));
//# sourceMappingURL=user-timing.js.map

/***/ }),

/***/ "./lib/mol-theme/clipping.js":
/*!***********************************!*\
  !*** ./lib/mol-theme/clipping.js ***!
  \***********************************/
/*! exports provided: Clipping */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Clipping", function() { return Clipping; });
/* harmony import */ var _mol_model_loci__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../mol-model/loci */ "./lib/mol-model/loci.js");
/* harmony import */ var _mol_model_structure__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../mol-model/structure */ "./lib/mol-model/structure.js");
/* harmony import */ var _mol_script_script__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../mol-script/script */ "./lib/mol-script/script.js");
/* harmony import */ var _mol_util_bit_flags__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../mol-util/bit-flags */ "./lib/mol-util/bit-flags.js");
/**
 * Copyright (c) 2020 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */





function Clipping(layers) {
    return { layers: layers };
}
(function (Clipping) {
    Clipping.Empty = { layers: [] };
    var Groups;
    (function (Groups) {
        Groups.is = _mol_util_bit_flags__WEBPACK_IMPORTED_MODULE_3__["default"].has;
        function create(flags) {
            return _mol_util_bit_flags__WEBPACK_IMPORTED_MODULE_3__["default"].create(flags);
        }
        Groups.create = create;
        Groups.Names = {
            'one': 1 /* One */,
            'two': 2 /* Two */,
            'three': 4 /* Three */,
            'four': 8 /* Four */,
            'five': 16 /* Five */,
            'six': 32 /* Six */,
        };
        function isName(name) {
            return name in Groups.Names;
        }
        Groups.isName = isName;
        function fromName(name) {
            switch (name) {
                case 'one': return 1 /* One */;
                case 'two': return 2 /* Two */;
                case 'three': return 4 /* Three */;
                case 'four': return 8 /* Four */;
                case 'five': return 16 /* Five */;
                case 'six': return 32 /* Six */;
            }
        }
        Groups.fromName = fromName;
        function fromNames(names) {
            var f = 0 /* None */;
            for (var i = 0, il = names.length; i < il; ++i) {
                f |= fromName(names[i]);
            }
            return f;
        }
        Groups.fromNames = fromNames;
        function toNames(groups) {
            var names = [];
            if (Groups.is(groups, 1 /* One */))
                names.push('one');
            if (Groups.is(groups, 2 /* Two */))
                names.push('two');
            if (Groups.is(groups, 4 /* Three */))
                names.push('three');
            if (Groups.is(groups, 8 /* Four */))
                names.push('four');
            if (Groups.is(groups, 16 /* Five */))
                names.push('five');
            if (Groups.is(groups, 32 /* Six */))
                names.push('six');
            return names;
        }
        Groups.toNames = toNames;
    })(Groups = Clipping.Groups || (Clipping.Groups = {}));
    /** Clip object types */
    Clipping.Type = {
        none: 0,
        plane: 1,
        sphere: 2,
        cube: 3,
        cylinder: 4,
        infiniteCone: 5,
    };
    function areEqual(cA, cB) {
        if (cA.layers.length === 0 && cB.layers.length === 0)
            return true;
        if (cA.layers.length !== cB.layers.length)
            return false;
        for (var i = 0, il = cA.layers.length; i < il; ++i) {
            if (cA.layers[i].groups !== cB.layers[i].groups)
                return false;
            if (!_mol_model_loci__WEBPACK_IMPORTED_MODULE_0__["Loci"].areEqual(cA.layers[i].loci, cB.layers[i].loci))
                return false;
        }
        return true;
    }
    Clipping.areEqual = areEqual;
    function isEmpty(clipping) {
        return clipping.layers.length === 0;
    }
    Clipping.isEmpty = isEmpty;
    function remap(clipping, structure) {
        var layers = [];
        for (var _i = 0, _a = clipping.layers; _i < _a.length; _i++) {
            var layer = _a[_i];
            var loci = layer.loci, groups = layer.groups;
            loci = _mol_model_structure__WEBPACK_IMPORTED_MODULE_1__["StructureElement"].Loci.remap(loci, structure);
            if (!_mol_model_structure__WEBPACK_IMPORTED_MODULE_1__["StructureElement"].Loci.isEmpty(loci)) {
                layers.push({ loci: loci, groups: groups });
            }
        }
        return { layers: layers };
    }
    Clipping.remap = remap;
    function merge(clipping) {
        if (isEmpty(clipping))
            return clipping;
        var structure = clipping.layers[0].loci.structure;
        var map = new Map();
        var shadowed = _mol_model_structure__WEBPACK_IMPORTED_MODULE_1__["StructureElement"].Loci.none(structure);
        for (var i = 0, il = clipping.layers.length; i < il; ++i) {
            var _a = clipping.layers[il - i - 1], loci = _a.loci, groups = _a.groups; // process from end
            loci = _mol_model_structure__WEBPACK_IMPORTED_MODULE_1__["StructureElement"].Loci.subtract(loci, shadowed);
            shadowed = _mol_model_structure__WEBPACK_IMPORTED_MODULE_1__["StructureElement"].Loci.union(loci, shadowed);
            if (!_mol_model_structure__WEBPACK_IMPORTED_MODULE_1__["StructureElement"].Loci.isEmpty(loci)) {
                if (map.has(groups)) {
                    loci = _mol_model_structure__WEBPACK_IMPORTED_MODULE_1__["StructureElement"].Loci.union(loci, map.get(groups));
                }
                map.set(groups, loci);
            }
        }
        var layers = [];
        map.forEach(function (loci, groups) {
            layers.push({ loci: loci, groups: groups });
        });
        return { layers: layers };
    }
    Clipping.merge = merge;
    function filter(clipping, filter) {
        if (isEmpty(clipping))
            return clipping;
        var structure = clipping.layers[0].loci.structure;
        var layers = [];
        for (var _i = 0, _a = clipping.layers; _i < _a.length; _i++) {
            var layer = _a[_i];
            var loci = layer.loci, groups = layer.groups;
            // filter by first map to the `filter` structure and
            // then map back to the original structure of the clipping loci
            var filtered = _mol_model_structure__WEBPACK_IMPORTED_MODULE_1__["StructureElement"].Loci.remap(loci, filter);
            loci = _mol_model_structure__WEBPACK_IMPORTED_MODULE_1__["StructureElement"].Loci.remap(filtered, structure);
            if (!_mol_model_structure__WEBPACK_IMPORTED_MODULE_1__["StructureElement"].Loci.isEmpty(loci)) {
                layers.push({ loci: loci, groups: groups });
            }
        }
        return { layers: layers };
    }
    Clipping.filter = filter;
    function ofScript(scriptLayers, structure) {
        var layers = [];
        for (var i = 0, il = scriptLayers.length; i < il; ++i) {
            var _a = scriptLayers[i], script = _a.script, groups = _a.groups;
            var loci = _mol_script_script__WEBPACK_IMPORTED_MODULE_2__["Script"].toLoci(script, structure);
            if (!_mol_model_structure__WEBPACK_IMPORTED_MODULE_1__["StructureElement"].Loci.isEmpty(loci)) {
                layers.push({ loci: loci, groups: groups });
            }
        }
        return { layers: layers };
    }
    Clipping.ofScript = ofScript;
    function ofBundle(bundleLayers, structure) {
        var layers = [];
        for (var i = 0, il = bundleLayers.length; i < il; ++i) {
            var _a = bundleLayers[i], bundle = _a.bundle, groups = _a.groups;
            var loci = _mol_model_structure__WEBPACK_IMPORTED_MODULE_1__["StructureElement"].Bundle.toLoci(bundle, structure.root);
            layers.push({ loci: loci, groups: groups });
        }
        return { layers: layers };
    }
    Clipping.ofBundle = ofBundle;
    function toBundle(clipping) {
        var layers = [];
        for (var i = 0, il = clipping.layers.length; i < il; ++i) {
            var _a = clipping.layers[i], loci = _a.loci, groups = _a.groups;
            var bundle = _mol_model_structure__WEBPACK_IMPORTED_MODULE_1__["StructureElement"].Bundle.fromLoci(loci);
            layers.push({ bundle: bundle, groups: groups });
        }
        return { layers: layers };
    }
    Clipping.toBundle = toBundle;
})(Clipping || (Clipping = {}));
//# sourceMappingURL=clipping.js.map

/***/ }),

/***/ "./lib/mol-theme/color.js":
/*!********************************!*\
  !*** ./lib/mol-theme/color.js ***!
  \********************************/
/*! exports provided: ColorTheme, ColorThemeProvider */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ColorTheme", function() { return ColorTheme; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ColorThemeProvider", function() { return ColorThemeProvider; });
/* harmony import */ var _mol_util_color__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../mol-util/color */ "./lib/mol-util/color/index.js");
/* harmony import */ var _color_carbohydrate_symbol__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./color/carbohydrate-symbol */ "./lib/mol-theme/color/carbohydrate-symbol.js");
/* harmony import */ var _color_uniform__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./color/uniform */ "./lib/mol-theme/color/uniform.js");
/* harmony import */ var _mol_util__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../mol-util */ "./lib/mol-util/index.js");
/* harmony import */ var _theme__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./theme */ "./lib/mol-theme/theme.js");
/* harmony import */ var _color_chain_id__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./color/chain-id */ "./lib/mol-theme/color/chain-id.js");
/* harmony import */ var _color_element_index__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ./color/element-index */ "./lib/mol-theme/color/element-index.js");
/* harmony import */ var _color_element_symbol__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ./color/element-symbol */ "./lib/mol-theme/color/element-symbol.js");
/* harmony import */ var _color_molecule_type__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ./color/molecule-type */ "./lib/mol-theme/color/molecule-type.js");
/* harmony import */ var _color_polymer_id__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ./color/polymer-id */ "./lib/mol-theme/color/polymer-id.js");
/* harmony import */ var _color_polymer_index__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ./color/polymer-index */ "./lib/mol-theme/color/polymer-index.js");
/* harmony import */ var _color_residue_name__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ./color/residue-name */ "./lib/mol-theme/color/residue-name.js");
/* harmony import */ var _color_secondary_structure__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! ./color/secondary-structure */ "./lib/mol-theme/color/secondary-structure.js");
/* harmony import */ var _color_sequence_id__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! ./color/sequence-id */ "./lib/mol-theme/color/sequence-id.js");
/* harmony import */ var _color_shape_group__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! ./color/shape-group */ "./lib/mol-theme/color/shape-group.js");
/* harmony import */ var _color_unit_index__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! ./color/unit-index */ "./lib/mol-theme/color/unit-index.js");
/* harmony import */ var _color_uncertainty__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(/*! ./color/uncertainty */ "./lib/mol-theme/color/uncertainty.js");
/* harmony import */ var _color_entity_source__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(/*! ./color/entity-source */ "./lib/mol-theme/color/entity-source.js");
/* harmony import */ var _color_illustrative__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(/*! ./color/illustrative */ "./lib/mol-theme/color/illustrative.js");
/* harmony import */ var _color_hydrophobicity__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(/*! ./color/hydrophobicity */ "./lib/mol-theme/color/hydrophobicity.js");
/* harmony import */ var _color_model_index__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(/*! ./color/model-index */ "./lib/mol-theme/color/model-index.js");
/* harmony import */ var _color_occupancy__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(/*! ./color/occupancy */ "./lib/mol-theme/color/occupancy.js");
/* harmony import */ var _color_operator_name__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(/*! ./color/operator-name */ "./lib/mol-theme/color/operator-name.js");
/* harmony import */ var _color_operator_hkl__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(/*! ./color/operator-hkl */ "./lib/mol-theme/color/operator-hkl.js");
/* harmony import */ var _color_partial_charge__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(/*! ./color/partial-charge */ "./lib/mol-theme/color/partial-charge.js");
/* harmony import */ var _color_prediction__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__(/*! ./color/prediction */ "./lib/mol-theme/color/prediction.js");
/**
 * Copyright (c) 2018-2020 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */



























var ColorTheme;
(function (ColorTheme) {
    ColorTheme.EmptyFactory = function () { return ColorTheme.Empty; };
    var EmptyColor = Object(_mol_util_color__WEBPACK_IMPORTED_MODULE_0__["Color"])(0xCCCCCC);
    ColorTheme.Empty = {
        factory: ColorTheme.EmptyFactory,
        granularity: 'uniform',
        color: function () { return EmptyColor; },
        props: {}
    };
    function areEqual(themeA, themeB) {
        return themeA.contextHash === themeB.contextHash && themeA.factory === themeB.factory && Object(_mol_util__WEBPACK_IMPORTED_MODULE_3__["deepEqual"])(themeA.props, themeB.props);
    }
    ColorTheme.areEqual = areEqual;
    ColorTheme.EmptyProvider = { name: '', label: '', category: '', factory: ColorTheme.EmptyFactory, getParams: function () { return ({}); }, defaultValues: {}, isApplicable: function () { return true; } };
    function createRegistry() {
        return new _theme__WEBPACK_IMPORTED_MODULE_4__["ThemeRegistry"](ColorTheme.BuiltIn, ColorTheme.EmptyProvider);
    }
    ColorTheme.createRegistry = createRegistry;
    ColorTheme.BuiltIn = {
        'carbohydrate-symbol': _color_carbohydrate_symbol__WEBPACK_IMPORTED_MODULE_1__["CarbohydrateSymbolColorThemeProvider"],
        'chain-id': _color_chain_id__WEBPACK_IMPORTED_MODULE_5__["ChainIdColorThemeProvider"],
        'element-index': _color_element_index__WEBPACK_IMPORTED_MODULE_6__["ElementIndexColorThemeProvider"],
        'element-symbol': _color_element_symbol__WEBPACK_IMPORTED_MODULE_7__["ElementSymbolColorThemeProvider"],
        'entity-source': _color_entity_source__WEBPACK_IMPORTED_MODULE_17__["EntitySourceColorThemeProvider"],
        'hydrophobicity': _color_hydrophobicity__WEBPACK_IMPORTED_MODULE_19__["HydrophobicityColorThemeProvider"],
        'illustrative': _color_illustrative__WEBPACK_IMPORTED_MODULE_18__["IllustrativeColorThemeProvider"],
        'model-index': _color_model_index__WEBPACK_IMPORTED_MODULE_20__["ModelIndexColorThemeProvider"],
        'molecule-type': _color_molecule_type__WEBPACK_IMPORTED_MODULE_8__["MoleculeTypeColorThemeProvider"],
        'occupancy': _color_occupancy__WEBPACK_IMPORTED_MODULE_21__["OccupancyColorThemeProvider"],
        'operator-hkl': _color_operator_hkl__WEBPACK_IMPORTED_MODULE_23__["OperatorHklColorThemeProvider"],
        'operator-name': _color_operator_name__WEBPACK_IMPORTED_MODULE_22__["OperatorNameColorThemeProvider"],
        'partial-charge': _color_partial_charge__WEBPACK_IMPORTED_MODULE_24__["PartialChargeColorThemeProvider"],
        'polymer-id': _color_polymer_id__WEBPACK_IMPORTED_MODULE_9__["PolymerIdColorThemeProvider"],
        'polymer-index': _color_polymer_index__WEBPACK_IMPORTED_MODULE_10__["PolymerIndexColorThemeProvider"],
        'residue-name': _color_residue_name__WEBPACK_IMPORTED_MODULE_11__["ResidueNameColorThemeProvider"],
        'secondary-structure': _color_secondary_structure__WEBPACK_IMPORTED_MODULE_12__["SecondaryStructureColorThemeProvider"],
        'sequence-id': _color_sequence_id__WEBPACK_IMPORTED_MODULE_13__["SequenceIdColorThemeProvider"],
        'shape-group': _color_shape_group__WEBPACK_IMPORTED_MODULE_14__["ShapeGroupColorThemeProvider"],
        'uncertainty': _color_uncertainty__WEBPACK_IMPORTED_MODULE_16__["UncertaintyColorThemeProvider"],
        'unit-index': _color_unit_index__WEBPACK_IMPORTED_MODULE_15__["UnitIndexColorThemeProvider"],
        'uniform': _color_uniform__WEBPACK_IMPORTED_MODULE_2__["UniformColorThemeProvider"],
        'prediction': _color_prediction__WEBPACK_IMPORTED_MODULE_25__["PredictionColorThemeProvider"],
    };
})(ColorTheme || (ColorTheme = {}));
function ColorThemeProvider(p) { return p; }
//# sourceMappingURL=color.js.map

/***/ }),

/***/ "./lib/mol-theme/color/carbohydrate-symbol.js":
/*!****************************************************!*\
  !*** ./lib/mol-theme/color/carbohydrate-symbol.js ***!
  \****************************************************/
/*! exports provided: CarbohydrateSymbolColorThemeParams, getCarbohydrateSymbolColorThemeParams, CarbohydrateSymbolColorTheme, CarbohydrateSymbolColorThemeProvider */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CarbohydrateSymbolColorThemeParams", function() { return CarbohydrateSymbolColorThemeParams; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getCarbohydrateSymbolColorThemeParams", function() { return getCarbohydrateSymbolColorThemeParams; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CarbohydrateSymbolColorTheme", function() { return CarbohydrateSymbolColorTheme; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CarbohydrateSymbolColorThemeProvider", function() { return CarbohydrateSymbolColorThemeProvider; });
/* harmony import */ var _mol_model_structure__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../mol-model/structure */ "./lib/mol-model/structure.js");
/* harmony import */ var _mol_model_structure_structure_carbohydrates_constants__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../mol-model/structure/structure/carbohydrates/constants */ "./lib/mol-model/structure/structure/carbohydrates/constants.js");
/* harmony import */ var _mol_util_color__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../mol-util/color */ "./lib/mol-util/color/index.js");
/* harmony import */ var _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../mol-util/param-definition */ "./lib/mol-util/param-definition.js");
/* harmony import */ var _mol_util_legend__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../mol-util/legend */ "./lib/mol-util/legend.js");
/**
 * Copyright (c) 2018-2020 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */





var DefaultColor = Object(_mol_util_color__WEBPACK_IMPORTED_MODULE_2__["Color"])(0xCCCCCC);
var Description = 'Assigns colors according to the Symbol Nomenclature for Glycans (SNFG).';
var CarbohydrateSymbolColorThemeParams = {};
function getCarbohydrateSymbolColorThemeParams(ctx) {
    return CarbohydrateSymbolColorThemeParams; // TODO return copy
}
function CarbohydrateSymbolColorTheme(ctx, props) {
    var color;
    if (ctx.structure) {
        var _a = ctx.structure.carbohydrates, elements_1 = _a.elements, getElementIndices_1 = _a.getElementIndices;
        var getColor_1 = function (unit, index) {
            if (!_mol_model_structure__WEBPACK_IMPORTED_MODULE_0__["Unit"].isAtomic(unit))
                return DefaultColor;
            var carbs = getElementIndices_1(unit, index);
            return carbs.length > 0 ? elements_1[carbs[0]].component.color : DefaultColor;
        };
        color = function (location, isSecondary) {
            if (isSecondary) {
                return _mol_model_structure_structure_carbohydrates_constants__WEBPACK_IMPORTED_MODULE_1__["SaccharideColors"].Secondary;
            }
            else {
                if (_mol_model_structure__WEBPACK_IMPORTED_MODULE_0__["StructureElement"].Location.is(location)) {
                    return getColor_1(location.unit, location.element);
                }
                else if (_mol_model_structure__WEBPACK_IMPORTED_MODULE_0__["Bond"].isLocation(location)) {
                    return getColor_1(location.aUnit, location.aUnit.elements[location.aIndex]);
                }
            }
            return DefaultColor;
        };
    }
    else {
        color = function () { return DefaultColor; };
    }
    return {
        factory: CarbohydrateSymbolColorTheme,
        granularity: 'group',
        color: color,
        props: props,
        description: Description,
        legend: Object(_mol_util_legend__WEBPACK_IMPORTED_MODULE_4__["TableLegend"])(_mol_model_structure_structure_carbohydrates_constants__WEBPACK_IMPORTED_MODULE_1__["MonosaccharidesColorTable"])
    };
}
var CarbohydrateSymbolColorThemeProvider = {
    name: 'carbohydrate-symbol',
    label: 'Carbohydrate Symbol',
    category: "Residue Property" /* Residue */,
    factory: CarbohydrateSymbolColorTheme,
    getParams: getCarbohydrateSymbolColorThemeParams,
    defaultValues: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_3__["ParamDefinition"].getDefaultValues(CarbohydrateSymbolColorThemeParams),
    isApplicable: function (ctx) {
        return !!ctx.structure && ctx.structure.models.some(function (m) { return _mol_model_structure__WEBPACK_IMPORTED_MODULE_0__["Model"].hasCarbohydrate(m); });
    }
};
//# sourceMappingURL=carbohydrate-symbol.js.map

/***/ }),

/***/ "./lib/mol-theme/color/chain-id.js":
/*!*****************************************!*\
  !*** ./lib/mol-theme/color/chain-id.js ***!
  \*****************************************/
/*! exports provided: ChainIdColorThemeParams, getChainIdColorThemeParams, ChainIdColorTheme, ChainIdColorThemeProvider */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ChainIdColorThemeParams", function() { return ChainIdColorThemeParams; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getChainIdColorThemeParams", function() { return getChainIdColorThemeParams; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ChainIdColorTheme", function() { return ChainIdColorTheme; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ChainIdColorThemeProvider", function() { return ChainIdColorThemeProvider; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _mol_model_structure__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../mol-model/structure */ "./lib/mol-model/structure.js");
/* harmony import */ var _mol_util_color__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../mol-util/color */ "./lib/mol-util/color/index.js");
/* harmony import */ var _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../mol-util/param-definition */ "./lib/mol-util/param-definition.js");
/* harmony import */ var _mol_util_color_palette__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../mol-util/color/palette */ "./lib/mol-util/color/palette.js");
/**
 * Copyright (c) 2018-2020 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */





var DefaultList = 'many-distinct';
var DefaultColor = Object(_mol_util_color__WEBPACK_IMPORTED_MODULE_2__["Color"])(0xFAFAFA);
var Description = 'Gives every chain a color based on its `asym_id` value.';
var ChainIdColorThemeParams = Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({ asymId: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_3__["ParamDefinition"].Select('auth', _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_3__["ParamDefinition"].arrayToOptions(['auth', 'label'])) }, Object(_mol_util_color_palette__WEBPACK_IMPORTED_MODULE_4__["getPaletteParams"])({ type: 'colors', colorList: DefaultList }));
function getChainIdColorThemeParams(ctx) {
    var _a;
    var params = _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_3__["ParamDefinition"].clone(ChainIdColorThemeParams);
    if ((_a = ctx.structure) === null || _a === void 0 ? void 0 : _a.models.some(function (m) { return m.coarseHierarchy.isDefined; })) {
        params.asymId.defaultValue = 'label';
    }
    return params;
}
function getAsymId(unit, type) {
    switch (unit.kind) {
        case 0 /* Atomic */:
            return type === 'auth'
                ? _mol_model_structure__WEBPACK_IMPORTED_MODULE_1__["StructureProperties"].chain.auth_asym_id
                : _mol_model_structure__WEBPACK_IMPORTED_MODULE_1__["StructureProperties"].chain.label_asym_id;
        case 1 /* Spheres */:
        case 2 /* Gaussians */:
            return _mol_model_structure__WEBPACK_IMPORTED_MODULE_1__["StructureProperties"].coarse.asym_id;
    }
}
function getAsymIdKey(location, type) {
    var asymId = getAsymId(location.unit, type)(location);
    return location.structure.root.models.length > 1
        ? getKey(location.unit.model, asymId)
        : asymId;
}
function getKey(model, asymId) {
    return asymId + "|" + ((_mol_model_structure__WEBPACK_IMPORTED_MODULE_1__["Model"].Index.get(model).value || 0) + 1);
}
function getAsymIdSerialMap(structure, type) {
    var map = new Map();
    var _loop_1 = function (m) {
        var asymIdOffset = _mol_model_structure__WEBPACK_IMPORTED_MODULE_1__["Model"].AsymIdOffset.get(m).value;
        var offset = (type === 'auth' ? asymIdOffset === null || asymIdOffset === void 0 ? void 0 : asymIdOffset.auth : asymIdOffset === null || asymIdOffset === void 0 ? void 0 : asymIdOffset.label) || 0;
        var count = 0;
        m.properties.structAsymMap.forEach(function (_a, label_id) {
            var auth_id = _a.auth_id;
            var asymId = type === 'auth' ? auth_id : label_id;
            var k = structure.models.length > 1
                ? getKey(m, asymId)
                : asymId;
            if (!map.has(k)) {
                map.set(k, count + offset);
                ++count;
            }
        });
    };
    for (var _i = 0, _a = structure.models; _i < _a.length; _i++) {
        var m = _a[_i];
        _loop_1(m);
    }
    return map;
}
function ChainIdColorTheme(ctx, props) {
    var color;
    var legend;
    if (ctx.structure) {
        var l_1 = _mol_model_structure__WEBPACK_IMPORTED_MODULE_1__["StructureElement"].Location.create(ctx.structure.root);
        var asymIdSerialMap_1 = getAsymIdSerialMap(ctx.structure.root, props.asymId);
        var labelTable_1 = Array.from(asymIdSerialMap_1.keys());
        var valueLabel = function (i) { return labelTable_1[i]; };
        var palette_1 = Object(_mol_util_color_palette__WEBPACK_IMPORTED_MODULE_4__["getPalette"])(asymIdSerialMap_1.size, props, { valueLabel: valueLabel });
        legend = palette_1.legend;
        color = function (location) {
            var serial = undefined;
            if (_mol_model_structure__WEBPACK_IMPORTED_MODULE_1__["StructureElement"].Location.is(location)) {
                var k = getAsymIdKey(location, props.asymId);
                serial = asymIdSerialMap_1.get(k);
            }
            else if (_mol_model_structure__WEBPACK_IMPORTED_MODULE_1__["Bond"].isLocation(location)) {
                l_1.unit = location.aUnit;
                l_1.element = location.aUnit.elements[location.aIndex];
                var k = getAsymIdKey(l_1, props.asymId);
                serial = asymIdSerialMap_1.get(k);
            }
            return serial === undefined ? DefaultColor : palette_1.color(serial);
        };
    }
    else {
        color = function () { return DefaultColor; };
    }
    return {
        factory: ChainIdColorTheme,
        granularity: 'group',
        color: color,
        props: props,
        description: Description,
        legend: legend
    };
}
var ChainIdColorThemeProvider = {
    name: 'chain-id',
    label: 'Chain Id',
    category: "Chain Property" /* Chain */,
    factory: ChainIdColorTheme,
    getParams: getChainIdColorThemeParams,
    defaultValues: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_3__["ParamDefinition"].getDefaultValues(ChainIdColorThemeParams),
    isApplicable: function (ctx) { return !!ctx.structure; }
};
//# sourceMappingURL=chain-id.js.map

/***/ }),

/***/ "./lib/mol-theme/color/element-index.js":
/*!**********************************************!*\
  !*** ./lib/mol-theme/color/element-index.js ***!
  \**********************************************/
/*! exports provided: ElementIndexColorThemeParams, getElementIndexColorThemeParams, ElementIndexColorTheme, ElementIndexColorThemeProvider */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ElementIndexColorThemeParams", function() { return ElementIndexColorThemeParams; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getElementIndexColorThemeParams", function() { return getElementIndexColorThemeParams; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ElementIndexColorTheme", function() { return ElementIndexColorTheme; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ElementIndexColorThemeProvider", function() { return ElementIndexColorThemeProvider; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _mol_util_color__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../mol-util/color */ "./lib/mol-util/color/index.js");
/* harmony import */ var _mol_model_structure__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../mol-model/structure */ "./lib/mol-model/structure.js");
/* harmony import */ var _mol_data_int__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../mol-data/int */ "./lib/mol-data/int.js");
/* harmony import */ var _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../mol-util/param-definition */ "./lib/mol-util/param-definition.js");
/* harmony import */ var _mol_util_color_palette__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../mol-util/color/palette */ "./lib/mol-util/color/palette.js");
/**
 * Copyright (c) 2018-2019 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */






var DefaultColor = Object(_mol_util_color__WEBPACK_IMPORTED_MODULE_1__["Color"])(0xCCCCCC);
var Description = 'Gives every element (atom or coarse sphere/gaussian) a unique color based on the position (index) of the element in the list of elements in the structure.';
var ElementIndexColorThemeParams = Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, Object(_mol_util_color_palette__WEBPACK_IMPORTED_MODULE_5__["getPaletteParams"])({ type: 'colors', colorList: 'red-yellow-blue' }));
function getElementIndexColorThemeParams(ctx) {
    return ElementIndexColorThemeParams; // TODO return copy
}
function ElementIndexColorTheme(ctx, props) {
    var color;
    var legend;
    if (ctx.structure) {
        var units_1 = ctx.structure.root.units;
        var unitCount = units_1.length;
        var cummulativeElementCount_1 = new Map();
        var unitIdIndex_1 = new Map();
        var elementCount = 0;
        for (var i = 0; i < unitCount; ++i) {
            cummulativeElementCount_1.set(i, elementCount);
            elementCount += units_1[i].elements.length;
            unitIdIndex_1.set(units_1[i].id, i);
        }
        var palette_1 = Object(_mol_util_color_palette__WEBPACK_IMPORTED_MODULE_5__["getPalette"])(elementCount, props);
        legend = palette_1.legend;
        color = function (location) {
            if (_mol_model_structure__WEBPACK_IMPORTED_MODULE_2__["StructureElement"].Location.is(location)) {
                var unitIndex = unitIdIndex_1.get(location.unit.id);
                var unitElementIndex = _mol_data_int__WEBPACK_IMPORTED_MODULE_3__["OrderedSet"].findPredecessorIndex(units_1[unitIndex].elements, location.element);
                return palette_1.color(cummulativeElementCount_1.get(unitIndex) + unitElementIndex);
            }
            else if (_mol_model_structure__WEBPACK_IMPORTED_MODULE_2__["Bond"].isLocation(location)) {
                var unitIndex = unitIdIndex_1.get(location.aUnit.id);
                var unitElementIndex = _mol_data_int__WEBPACK_IMPORTED_MODULE_3__["OrderedSet"].findPredecessorIndex(units_1[unitIndex].elements, location.aUnit.elements[location.aIndex]);
                return palette_1.color(cummulativeElementCount_1.get(unitIndex) + unitElementIndex);
            }
            return DefaultColor;
        };
    }
    else {
        color = function () { return DefaultColor; };
    }
    return {
        factory: ElementIndexColorTheme,
        granularity: 'groupInstance',
        color: color,
        props: props,
        description: Description,
        legend: legend
    };
}
var ElementIndexColorThemeProvider = {
    name: 'element-index',
    label: 'Element Index',
    category: "Atom Property" /* Atom */,
    factory: ElementIndexColorTheme,
    getParams: getElementIndexColorThemeParams,
    defaultValues: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_4__["ParamDefinition"].getDefaultValues(ElementIndexColorThemeParams),
    isApplicable: function (ctx) { return !!ctx.structure; }
};
//# sourceMappingURL=element-index.js.map

/***/ }),

/***/ "./lib/mol-theme/color/element-symbol.js":
/*!***********************************************!*\
  !*** ./lib/mol-theme/color/element-symbol.js ***!
  \***********************************************/
/*! exports provided: ElementSymbolColors, ElementSymbolColorThemeParams, getElementSymbolColorThemeParams, elementSymbolColor, ElementSymbolColorTheme, ElementSymbolColorThemeProvider */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ElementSymbolColors", function() { return ElementSymbolColors; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ElementSymbolColorThemeParams", function() { return ElementSymbolColorThemeParams; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getElementSymbolColorThemeParams", function() { return getElementSymbolColorThemeParams; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "elementSymbolColor", function() { return elementSymbolColor; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ElementSymbolColorTheme", function() { return ElementSymbolColorTheme; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ElementSymbolColorThemeProvider", function() { return ElementSymbolColorThemeProvider; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _mol_util_color__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../mol-util/color */ "./lib/mol-util/color/index.js");
/* harmony import */ var _mol_model_structure__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../mol-model/structure */ "./lib/mol-model/structure.js");
/* harmony import */ var _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../mol-util/param-definition */ "./lib/mol-util/param-definition.js");
/* harmony import */ var _mol_util_legend__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../mol-util/legend */ "./lib/mol-util/legend.js");
/* harmony import */ var _mol_util_color_color__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../mol-util/color/color */ "./lib/mol-util/color/color.js");
/* harmony import */ var _chain_id__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ./chain-id */ "./lib/mol-theme/color/chain-id.js");
/* harmony import */ var _operator_name__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ./operator-name */ "./lib/mol-theme/color/operator-name.js");
/**
 * Copyright (c) 2018-2020 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */








// from Jmol http://jmol.sourceforge.net/jscolors/ (or 0xFFFFFF)
var ElementSymbolColors = Object(_mol_util_color__WEBPACK_IMPORTED_MODULE_1__["ColorMap"])({
    'H': 0xFFFFFF, 'D': 0xFFFFC0, 'T': 0xFFFFA0, 'HE': 0xD9FFFF, 'LI': 0xCC80FF, 'BE': 0xC2FF00, 'B': 0xFFB5B5, 'C': 0x909090, 'N': 0x3050F8, 'O': 0xFF0D0D, 'F': 0x90E050, 'NE': 0xB3E3F5, 'NA': 0xAB5CF2, 'MG': 0x8AFF00, 'AL': 0xBFA6A6, 'SI': 0xF0C8A0, 'P': 0xFF8000, 'S': 0xFFFF30, 'CL': 0x1FF01F, 'AR': 0x80D1E3, 'K': 0x8F40D4, 'CA': 0x3DFF00, 'SC': 0xE6E6E6, 'TI': 0xBFC2C7, 'V': 0xA6A6AB, 'CR': 0x8A99C7, 'MN': 0x9C7AC7, 'FE': 0xE06633, 'CO': 0xF090A0, 'NI': 0x50D050, 'CU': 0xC88033, 'ZN': 0x7D80B0, 'GA': 0xC28F8F, 'GE': 0x668F8F, 'AS': 0xBD80E3, 'SE': 0xFFA100, 'BR': 0xA62929, 'KR': 0x5CB8D1, 'RB': 0x702EB0, 'SR': 0x00FF00, 'Y': 0x94FFFF, 'ZR': 0x94E0E0, 'NB': 0x73C2C9, 'MO': 0x54B5B5, 'TC': 0x3B9E9E, 'RU': 0x248F8F, 'RH': 0x0A7D8C, 'PD': 0x006985, 'AG': 0xC0C0C0, 'CD': 0xFFD98F, 'IN': 0xA67573, 'SN': 0x668080, 'SB': 0x9E63B5, 'TE': 0xD47A00, 'I': 0x940094, 'XE': 0x940094, 'CS': 0x57178F, 'BA': 0x00C900, 'LA': 0x70D4FF, 'CE': 0xFFFFC7, 'PR': 0xD9FFC7, 'ND': 0xC7FFC7, 'PM': 0xA3FFC7, 'SM': 0x8FFFC7, 'EU': 0x61FFC7, 'GD': 0x45FFC7, 'TB': 0x30FFC7, 'DY': 0x1FFFC7, 'HO': 0x00FF9C, 'ER': 0x00E675, 'TM': 0x00D452, 'YB': 0x00BF38, 'LU': 0x00AB24, 'HF': 0x4DC2FF, 'TA': 0x4DA6FF, 'W': 0x2194D6, 'RE': 0x267DAB, 'OS': 0x266696, 'IR': 0x175487, 'PT': 0xD0D0E0, 'AU': 0xFFD123, 'HG': 0xB8B8D0, 'TL': 0xA6544D, 'PB': 0x575961, 'BI': 0x9E4FB5, 'PO': 0xAB5C00, 'AT': 0x754F45, 'RN': 0x428296, 'FR': 0x420066, 'RA': 0x007D00, 'AC': 0x70ABFA, 'TH': 0x00BAFF, 'PA': 0x00A1FF, 'U': 0x008FFF, 'NP': 0x0080FF, 'PU': 0x006BFF, 'AM': 0x545CF2, 'CM': 0x785CE3, 'BK': 0x8A4FE3, 'CF': 0xA136D4, 'ES': 0xB31FD4, 'FM': 0xB31FBA, 'MD': 0xB30DA6, 'NO': 0xBD0D87, 'LR': 0xC70066, 'RF': 0xCC0059, 'DB': 0xD1004F, 'SG': 0xD90045, 'BH': 0xE00038, 'HS': 0xE6002E, 'MT': 0xEB0026, 'DS': 0xFFFFFF, 'RG': 0xFFFFFF, 'CN': 0xFFFFFF, 'UUT': 0xFFFFFF, 'FL': 0xFFFFFF, 'UUP': 0xFFFFFF, 'LV': 0xFFFFFF, 'UUH': 0xFFFFFF
});
var DefaultElementSymbolColor = Object(_mol_util_color__WEBPACK_IMPORTED_MODULE_1__["Color"])(0xFFFFFF);
var Description = 'Assigns a color to every atom according to its chemical element.';
// TODO generalise `carbonColor` param to all themes?
var ElementSymbolColorThemeParams = {
    carbonColor: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_3__["ParamDefinition"].MappedStatic('chain-id', {
        'chain-id': _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_3__["ParamDefinition"].Group(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, _chain_id__WEBPACK_IMPORTED_MODULE_6__["ChainIdColorThemeParams"])),
        'operator-name': _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_3__["ParamDefinition"].Group(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, _operator_name__WEBPACK_IMPORTED_MODULE_7__["OperatorNameColorThemeParams"])),
        'element-symbol': _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_3__["ParamDefinition"].Group({})
    }, { description: 'Use chain-id coloring for carbon atoms.' }),
    saturation: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_3__["ParamDefinition"].Numeric(0, { min: -6, max: 6, step: 0.1 }),
    lightness: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_3__["ParamDefinition"].Numeric(0.2, { min: -6, max: 6, step: 0.1 })
};
function getElementSymbolColorThemeParams(ctx) {
    return ElementSymbolColorThemeParams; // TODO return copy
}
function elementSymbolColor(colorMap, element) {
    var c = colorMap[element];
    return c === undefined ? DefaultElementSymbolColor : c;
}
function ElementSymbolColorTheme(ctx, props) {
    var colorMap = Object(_mol_util_color_color__WEBPACK_IMPORTED_MODULE_5__["getAdjustedColorMap"])(ElementSymbolColors, props.saturation, props.lightness);
    var carbonColor = props.carbonColor.name === 'chain-id'
        ? Object(_chain_id__WEBPACK_IMPORTED_MODULE_6__["ChainIdColorTheme"])(ctx, props.carbonColor.params).color
        : props.carbonColor.name === 'operator-name'
            ? Object(_operator_name__WEBPACK_IMPORTED_MODULE_7__["OperatorNameColorTheme"])(ctx, props.carbonColor.params).color
            : undefined;
    function elementColor(element, location) {
        return (carbonColor && element === 'C')
            ? carbonColor(location, false)
            : elementSymbolColor(colorMap, element);
    }
    function color(location) {
        if (_mol_model_structure__WEBPACK_IMPORTED_MODULE_2__["StructureElement"].Location.is(location)) {
            if (_mol_model_structure__WEBPACK_IMPORTED_MODULE_2__["Unit"].isAtomic(location.unit)) {
                var type_symbol = location.unit.model.atomicHierarchy.atoms.type_symbol;
                return elementColor(type_symbol.value(location.element), location);
            }
        }
        else if (_mol_model_structure__WEBPACK_IMPORTED_MODULE_2__["Bond"].isLocation(location)) {
            if (_mol_model_structure__WEBPACK_IMPORTED_MODULE_2__["Unit"].isAtomic(location.aUnit)) {
                var type_symbol = location.aUnit.model.atomicHierarchy.atoms.type_symbol;
                var element = type_symbol.value(location.aUnit.elements[location.aIndex]);
                return elementColor(element, location);
            }
        }
        return DefaultElementSymbolColor;
    }
    var granularity = props.carbonColor.name === 'element-symbol' ? 'group' : 'groupInstance';
    return {
        factory: ElementSymbolColorTheme,
        granularity: granularity,
        color: color,
        props: props,
        description: Description,
        legend: Object(_mol_util_legend__WEBPACK_IMPORTED_MODULE_4__["TableLegend"])(Object.keys(ElementSymbolColors).map(function (name) {
            return [name, ElementSymbolColors[name]];
        }))
    };
}
var ElementSymbolColorThemeProvider = {
    name: 'element-symbol',
    label: 'Element Symbol',
    category: "Atom Property" /* Atom */,
    factory: ElementSymbolColorTheme,
    getParams: getElementSymbolColorThemeParams,
    defaultValues: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_3__["ParamDefinition"].getDefaultValues(ElementSymbolColorThemeParams),
    isApplicable: function (ctx) { return !!ctx.structure; }
};
//# sourceMappingURL=element-symbol.js.map

/***/ }),

/***/ "./lib/mol-theme/color/entity-source.js":
/*!**********************************************!*\
  !*** ./lib/mol-theme/color/entity-source.js ***!
  \**********************************************/
/*! exports provided: EntitySourceColorThemeParams, getEntitySourceColorThemeParams, EntitySourceColorTheme, EntitySourceColorThemeProvider */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "EntitySourceColorThemeParams", function() { return EntitySourceColorThemeParams; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getEntitySourceColorThemeParams", function() { return getEntitySourceColorThemeParams; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "EntitySourceColorTheme", function() { return EntitySourceColorTheme; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "EntitySourceColorThemeProvider", function() { return EntitySourceColorThemeProvider; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _mol_model_structure__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../mol-model/structure */ "./lib/mol-model/structure.js");
/* harmony import */ var _mol_util_color__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../mol-util/color */ "./lib/mol-util/color/index.js");
/* harmony import */ var _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../mol-util/param-definition */ "./lib/mol-util/param-definition.js");
/* harmony import */ var _mol_util_color_palette__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../mol-util/color/palette */ "./lib/mol-util/color/palette.js");
/* harmony import */ var _mol_util_number__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../mol-util/number */ "./lib/mol-util/number.js");
/* harmony import */ var _mol_util_color_lists__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../../mol-util/color/lists */ "./lib/mol-util/color/lists.js");
/* harmony import */ var _mol_model_formats_structure_mmcif__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../../mol-model-formats/structure/mmcif */ "./lib/mol-model-formats/structure/mmcif.js");
/**
 * Copyright (c) 2019 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */








var DefaultList = 'dark-2';
var DefaultColor = Object(_mol_util_color__WEBPACK_IMPORTED_MODULE_2__["Color"])(0xFAFAFA);
var Description = 'Gives ranges of a polymer chain a color based on the entity source it originates from (e.g. gene, plasmid, organism).';
var EntitySourceColorThemeParams = Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, Object(_mol_util_color_palette__WEBPACK_IMPORTED_MODULE_4__["getPaletteParams"])({ type: 'colors', colorList: DefaultList }));
function getEntitySourceColorThemeParams(ctx) {
    var params = _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_3__["ParamDefinition"].clone(EntitySourceColorThemeParams);
    if (ctx.structure) {
        if (getMaps(ctx.structure.root.models).srcKeySerialMap.size > _mol_util_color_lists__WEBPACK_IMPORTED_MODULE_6__["ColorLists"][DefaultList].list.length) {
            params.palette.defaultValue.name = 'colors';
            params.palette.defaultValue.params = Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, params.palette.defaultValue.params), { list: { kind: 'interpolate', colors: Object(_mol_util_color_lists__WEBPACK_IMPORTED_MODULE_6__["getColorListFromName"])(DefaultList).list } });
        }
    }
    return params;
}
function modelEntityKey(modelIndex, entityId) {
    return modelIndex + "|" + entityId;
}
function srcKey(modelIndex, entityId, organism, srcId, plasmid, gene) {
    return modelIndex + "|" + entityId + "|" + organism + "|" + (gene ? gene : (plasmid ? plasmid : srcId));
}
function addSrc(seqToSrcByModelEntity, srcKeySerialMap, modelIndex, model, entity_src, scientific_name, plasmid_name, gene_src_gene) {
    var entity_id = entity_src.entity_id, pdbx_src_id = entity_src.pdbx_src_id, pdbx_beg_seq_num = entity_src.pdbx_beg_seq_num, pdbx_end_seq_num = entity_src.pdbx_end_seq_num;
    for (var j = 0, jl = entity_src._rowCount; j < jl; ++j) {
        var entityId = entity_id.value(j);
        var mK = modelEntityKey(modelIndex, entityId);
        var seqToSrc = void 0;
        if (!seqToSrcByModelEntity.has(mK)) {
            var entityIndex = model.entities.getEntityIndex(entityId);
            var seq = model.sequence.sequences[entityIndex].sequence;
            seqToSrc = new Int16Array(seq.length);
            seqToSrcByModelEntity.set(mK, seqToSrc);
        }
        else {
            seqToSrc = seqToSrcByModelEntity.get(mK);
        }
        var plasmid = plasmid_name ? plasmid_name.value(j) : '';
        var gene = gene_src_gene ? gene_src_gene.value(j)[0] : '';
        var sK = srcKey(modelIndex, entityId, scientific_name.value(j), pdbx_src_id.value(j), plasmid, gene);
        // may not be given (= 0) indicating src is for the whole seq
        var beg = pdbx_beg_seq_num.valueKind(j) === 0 /* Present */ ? pdbx_beg_seq_num.value(j) : 1;
        var end = pdbx_end_seq_num.valueKind(j) === 0 /* Present */ ? pdbx_end_seq_num.value(j) : seqToSrc.length;
        var srcIndex = void 0; // serial no starting from 1
        if (srcKeySerialMap.has(sK)) {
            srcIndex = srcKeySerialMap.get(sK);
        }
        else {
            srcIndex = srcKeySerialMap.size + 1;
            srcKeySerialMap.set(sK, srcIndex);
        }
        // set src index
        for (var i = beg, il = end; i <= il; ++i) {
            seqToSrc[i - 1] = srcIndex;
        }
    }
}
function getMaps(models) {
    var seqToSrcByModelEntity = new Map();
    var srcKeySerialMap = new Map(); // serial no starting from 1
    for (var i = 0, il = models.length; i < il; ++i) {
        var m = models[i];
        if (!_mol_model_formats_structure_mmcif__WEBPACK_IMPORTED_MODULE_7__["MmcifFormat"].is(m.sourceData))
            continue;
        var _a = m.sourceData.data.db, entity_src_gen = _a.entity_src_gen, entity_src_nat = _a.entity_src_nat, pdbx_entity_src_syn = _a.pdbx_entity_src_syn;
        addSrc(seqToSrcByModelEntity, srcKeySerialMap, i, m, entity_src_gen, entity_src_gen.pdbx_gene_src_scientific_name, entity_src_gen.plasmid_name, entity_src_gen.pdbx_gene_src_gene);
        addSrc(seqToSrcByModelEntity, srcKeySerialMap, i, m, entity_src_nat, entity_src_nat.pdbx_organism_scientific, entity_src_nat.pdbx_plasmid_name);
        addSrc(seqToSrcByModelEntity, srcKeySerialMap, i, m, pdbx_entity_src_syn, pdbx_entity_src_syn.organism_scientific);
    }
    return { seqToSrcByModelEntity: seqToSrcByModelEntity, srcKeySerialMap: srcKeySerialMap };
}
function getLabelTable(srcKeySerialMap) {
    var unnamedCount = 0;
    return Array.from(srcKeySerialMap.keys()).map(function (v) {
        var vs = v.split('|');
        var organism = vs[2];
        var name = Object(_mol_util_number__WEBPACK_IMPORTED_MODULE_5__["isInteger"])(vs[3]) ? "Unnamed " + ++unnamedCount : vs[3];
        return "" + name + (organism ? " (" + organism + ")" : '');
    });
}
function EntitySourceColorTheme(ctx, props) {
    var color;
    var legend;
    if (ctx.structure) {
        var l_1 = _mol_model_structure__WEBPACK_IMPORTED_MODULE_1__["StructureElement"].Location.create(ctx.structure);
        var models_1 = ctx.structure.root.models;
        var _a = getMaps(models_1), seqToSrcByModelEntity_1 = _a.seqToSrcByModelEntity, srcKeySerialMap = _a.srcKeySerialMap;
        var labelTable_1 = getLabelTable(srcKeySerialMap);
        var valueLabel = function (i) { return labelTable_1[i]; };
        var palette_1 = Object(_mol_util_color_palette__WEBPACK_IMPORTED_MODULE_4__["getPalette"])(srcKeySerialMap.size, props, { valueLabel: valueLabel });
        legend = palette_1.legend;
        var getSrcColor_1 = function (location) {
            var modelIndex = models_1.indexOf(location.unit.model);
            var entityId = _mol_model_structure__WEBPACK_IMPORTED_MODULE_1__["StructureProperties"].entity.id(location);
            var mK = modelEntityKey(modelIndex, entityId);
            var seqToSrc = seqToSrcByModelEntity_1.get(mK);
            if (seqToSrc) {
                // minus 1 to convert seqId to array index
                return palette_1.color(seqToSrc[_mol_model_structure__WEBPACK_IMPORTED_MODULE_1__["StructureProperties"].residue.label_seq_id(location) - 1] - 1);
            }
            else {
                return DefaultColor;
            }
        };
        color = function (location) {
            if (_mol_model_structure__WEBPACK_IMPORTED_MODULE_1__["StructureElement"].Location.is(location)) {
                return getSrcColor_1(location);
            }
            else if (_mol_model_structure__WEBPACK_IMPORTED_MODULE_1__["Bond"].isLocation(location)) {
                l_1.unit = location.aUnit;
                l_1.element = location.aUnit.elements[location.aIndex];
                return getSrcColor_1(l_1);
            }
            return DefaultColor;
        };
    }
    else {
        color = function () { return DefaultColor; };
    }
    return {
        factory: EntitySourceColorTheme,
        granularity: 'group',
        color: color,
        props: props,
        description: Description,
        legend: legend
    };
}
var EntitySourceColorThemeProvider = {
    name: 'entity-source',
    label: 'Entity Source',
    category: "Chain Property" /* Chain */,
    factory: EntitySourceColorTheme,
    getParams: getEntitySourceColorThemeParams,
    defaultValues: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_3__["ParamDefinition"].getDefaultValues(EntitySourceColorThemeParams),
    isApplicable: function (ctx) { return !!ctx.structure; }
};
//# sourceMappingURL=entity-source.js.map

/***/ }),

/***/ "./lib/mol-theme/color/hydrophobicity.js":
/*!***********************************************!*\
  !*** ./lib/mol-theme/color/hydrophobicity.js ***!
  \***********************************************/
/*! exports provided: HydrophobicityColorThemeParams, getHydrophobicityColorThemeParams, hydrophobicity, HydrophobicityColorTheme, HydrophobicityColorThemeProvider */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "HydrophobicityColorThemeParams", function() { return HydrophobicityColorThemeParams; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getHydrophobicityColorThemeParams", function() { return getHydrophobicityColorThemeParams; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "hydrophobicity", function() { return hydrophobicity; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "HydrophobicityColorTheme", function() { return HydrophobicityColorTheme; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "HydrophobicityColorThemeProvider", function() { return HydrophobicityColorThemeProvider; });
/* harmony import */ var _mol_util_color__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../mol-util/color */ "./lib/mol-util/color/index.js");
/* harmony import */ var _mol_model_structure__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../mol-model/structure */ "./lib/mol-model/structure.js");
/* harmony import */ var _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../mol-util/param-definition */ "./lib/mol-util/param-definition.js");
/* harmony import */ var _mol_model_structure_model_types__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../mol-model/structure/model/types */ "./lib/mol-model/structure/model/types.js");
/**
 * Copyright (c) 2019 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */




var Description = 'Assigns a color to every amino acid according to the "Experimentally determined hydrophobicity scale for proteins at membrane interfaces" by Wimely and White (doi:10.1038/nsb1096-842).';
var HydrophobicityColorThemeParams = {
    list: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_2__["ParamDefinition"].ColorList('red-yellow-green', { presetKind: 'scale' }),
    scale: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_2__["ParamDefinition"].Select('DGwif', [['DGwif', 'DG water-membrane'], ['DGwoct', 'DG water-octanol'], ['Oct-IF', 'DG difference']])
};
function getHydrophobicityColorThemeParams(ctx) {
    return HydrophobicityColorThemeParams; // TODO return copy
}
var scaleIndexMap = { 'DGwif': 0, 'DGwoct': 1, 'Oct-IF': 2 };
function hydrophobicity(compId, scaleIndex) {
    var c = _mol_model_structure_model_types__WEBPACK_IMPORTED_MODULE_3__["ResidueHydrophobicity"][compId];
    return c === undefined ? 0 : c[scaleIndex];
}
function getAtomicCompId(unit, element) {
    return unit.model.atomicHierarchy.atoms.label_comp_id.value(element);
}
function getCoarseCompId(unit, element) {
    var seqIdBegin = unit.coarseElements.seq_id_begin.value(element);
    var seqIdEnd = unit.coarseElements.seq_id_end.value(element);
    if (seqIdBegin === seqIdEnd) {
        var entityKey = unit.coarseElements.entityKey[element];
        var seq = unit.model.sequence.byEntityKey[entityKey].sequence;
        return seq.compId.value(seqIdBegin - 1); // 1-indexed
    }
}
function HydrophobicityColorTheme(ctx, props) {
    var scaleIndex = scaleIndexMap[props.scale];
    // get domain
    var min = Infinity;
    var max = -Infinity;
    for (var name_1 in _mol_model_structure_model_types__WEBPACK_IMPORTED_MODULE_3__["ResidueHydrophobicity"]) {
        var val = _mol_model_structure_model_types__WEBPACK_IMPORTED_MODULE_3__["ResidueHydrophobicity"][name_1][scaleIndex];
        min = Math.min(min, val);
        max = Math.max(max, val);
    }
    var scale = _mol_util_color__WEBPACK_IMPORTED_MODULE_0__["ColorScale"].create({
        listOrName: props.list.colors,
        domain: [max, min],
        minLabel: 'Hydrophobic',
        maxLabel: 'Hydrophilic'
    });
    function color(location) {
        var compId;
        if (_mol_model_structure__WEBPACK_IMPORTED_MODULE_1__["StructureElement"].Location.is(location)) {
            if (_mol_model_structure__WEBPACK_IMPORTED_MODULE_1__["Unit"].isAtomic(location.unit)) {
                compId = getAtomicCompId(location.unit, location.element);
            }
            else {
                compId = getCoarseCompId(location.unit, location.element);
            }
        }
        else if (_mol_model_structure__WEBPACK_IMPORTED_MODULE_1__["Bond"].isLocation(location)) {
            if (_mol_model_structure__WEBPACK_IMPORTED_MODULE_1__["Unit"].isAtomic(location.aUnit)) {
                compId = getAtomicCompId(location.aUnit, location.aUnit.elements[location.aIndex]);
            }
            else {
                compId = getCoarseCompId(location.aUnit, location.aUnit.elements[location.aIndex]);
            }
        }
        return scale.color(compId ? hydrophobicity(compId, scaleIndex) : 0);
    }
    return {
        factory: HydrophobicityColorTheme,
        granularity: 'group',
        color: color,
        props: props,
        description: Description,
        legend: scale ? scale.legend : undefined
    };
}
var HydrophobicityColorThemeProvider = {
    name: 'hydrophobicity',
    label: 'Hydrophobicity',
    category: "Residue Property" /* Residue */,
    factory: HydrophobicityColorTheme,
    getParams: getHydrophobicityColorThemeParams,
    defaultValues: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_2__["ParamDefinition"].getDefaultValues(HydrophobicityColorThemeParams),
    isApplicable: function (ctx) { return !!ctx.structure; }
};
//# sourceMappingURL=hydrophobicity.js.map

/***/ }),

/***/ "./lib/mol-theme/color/illustrative.js":
/*!*********************************************!*\
  !*** ./lib/mol-theme/color/illustrative.js ***!
  \*********************************************/
/*! exports provided: IllustrativeColorThemeParams, getIllustrativeColorThemeParams, IllustrativeColorTheme, IllustrativeColorThemeProvider */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "IllustrativeColorThemeParams", function() { return IllustrativeColorThemeParams; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getIllustrativeColorThemeParams", function() { return getIllustrativeColorThemeParams; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "IllustrativeColorTheme", function() { return IllustrativeColorTheme; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "IllustrativeColorThemeProvider", function() { return IllustrativeColorThemeProvider; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _mol_util_color__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../mol-util/color */ "./lib/mol-util/color/index.js");
/* harmony import */ var _mol_model_structure__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../mol-model/structure */ "./lib/mol-model/structure.js");
/* harmony import */ var _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../mol-util/param-definition */ "./lib/mol-util/param-definition.js");
/* harmony import */ var _chain_id__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./chain-id */ "./lib/mol-theme/color/chain-id.js");
/**
 * Copyright (c) 2019-2020 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */





var DefaultIllustrativeColor = Object(_mol_util_color__WEBPACK_IMPORTED_MODULE_1__["Color"])(0xEEEEEE);
var Description = "Assigns an illustrative color that gives every chain a unique color with lighter carbons (inspired by David Goodsell's Molecule of the Month style).";
var IllustrativeColorThemeParams = Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, _chain_id__WEBPACK_IMPORTED_MODULE_4__["ChainIdColorThemeParams"]);
function getIllustrativeColorThemeParams(ctx) {
    return IllustrativeColorThemeParams; // TODO return copy
}
function IllustrativeColorTheme(ctx, props) {
    var _a = Object(_chain_id__WEBPACK_IMPORTED_MODULE_4__["ChainIdColorTheme"])(ctx, props), chainIdColor = _a.color, legend = _a.legend;
    function illustrativeColor(location, typeSymbol) {
        var baseColor = chainIdColor(location, false);
        return typeSymbol === 'C' ? _mol_util_color__WEBPACK_IMPORTED_MODULE_1__["Color"].lighten(baseColor, 0.8) : baseColor;
    }
    function color(location) {
        if (_mol_model_structure__WEBPACK_IMPORTED_MODULE_2__["StructureElement"].Location.is(location) && _mol_model_structure__WEBPACK_IMPORTED_MODULE_2__["Unit"].isAtomic(location.unit)) {
            var typeSymbol = location.unit.model.atomicHierarchy.atoms.type_symbol.value(location.element);
            return illustrativeColor(location, typeSymbol);
        }
        else if (_mol_model_structure__WEBPACK_IMPORTED_MODULE_2__["Bond"].isLocation(location) && _mol_model_structure__WEBPACK_IMPORTED_MODULE_2__["Unit"].isAtomic(location.aUnit)) {
            var elementIndex = location.aUnit.elements[location.aIndex];
            var typeSymbol = location.aUnit.model.atomicHierarchy.atoms.type_symbol.value(elementIndex);
            return illustrativeColor(location, typeSymbol);
        }
        return DefaultIllustrativeColor;
    }
    return {
        factory: IllustrativeColorTheme,
        granularity: 'group',
        color: color,
        props: props,
        description: Description,
        legend: legend
    };
}
var IllustrativeColorThemeProvider = {
    name: 'illustrative',
    label: 'Illustrative',
    category: "Miscellaneous" /* Misc */,
    factory: IllustrativeColorTheme,
    getParams: getIllustrativeColorThemeParams,
    defaultValues: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_3__["ParamDefinition"].getDefaultValues(IllustrativeColorThemeParams),
    isApplicable: function (ctx) { return !!ctx.structure; }
};
//# sourceMappingURL=illustrative.js.map

/***/ }),

/***/ "./lib/mol-theme/color/model-index.js":
/*!********************************************!*\
  !*** ./lib/mol-theme/color/model-index.js ***!
  \********************************************/
/*! exports provided: ModelIndexColorThemeParams, getModelIndexColorThemeParams, ModelIndexColorTheme, ModelIndexColorThemeProvider */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ModelIndexColorThemeParams", function() { return ModelIndexColorThemeParams; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getModelIndexColorThemeParams", function() { return getModelIndexColorThemeParams; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ModelIndexColorTheme", function() { return ModelIndexColorTheme; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ModelIndexColorThemeProvider", function() { return ModelIndexColorThemeProvider; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _mol_util_color__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../mol-util/color */ "./lib/mol-util/color/index.js");
/* harmony import */ var _mol_model_structure__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../mol-model/structure */ "./lib/mol-model/structure.js");
/* harmony import */ var _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../mol-util/param-definition */ "./lib/mol-util/param-definition.js");
/* harmony import */ var _mol_util_color_palette__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../mol-util/color/palette */ "./lib/mol-util/color/palette.js");
/**
 * Copyright (c) 2019-2020 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */





var DefaultColor = Object(_mol_util_color__WEBPACK_IMPORTED_MODULE_1__["Color"])(0xCCCCCC);
var Description = 'Gives every model a unique color based on the position (index) of the model in the list of models in the structure.';
var ModelIndexColorThemeParams = Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, Object(_mol_util_color_palette__WEBPACK_IMPORTED_MODULE_4__["getPaletteParams"])({ type: 'colors', colorList: 'purples' }));
function getModelIndexColorThemeParams(ctx) {
    return ModelIndexColorThemeParams; // TODO return copy
}
function ModelIndexColorTheme(ctx, props) {
    var _a, _b;
    var color;
    var legend;
    if (ctx.structure) {
        var models = ctx.structure.root.models;
        var size = 0;
        for (var _i = 0, models_1 = models; _i < models_1.length; _i++) {
            var m = models_1[_i];
            size = Math.max(size, ((_a = _mol_model_structure__WEBPACK_IMPORTED_MODULE_2__["Model"].TrajectoryInfo.get(m)) === null || _a === void 0 ? void 0 : _a.size) || 0);
        }
        var palette = Object(_mol_util_color_palette__WEBPACK_IMPORTED_MODULE_4__["getPalette"])(size, props);
        legend = palette.legend;
        var modelColor_1 = new Map();
        for (var i = 0, il = models.length; i < il; ++i) {
            var idx = ((_b = _mol_model_structure__WEBPACK_IMPORTED_MODULE_2__["Model"].TrajectoryInfo.get(models[i])) === null || _b === void 0 ? void 0 : _b.index) || 0;
            modelColor_1.set(idx, palette.color(idx));
        }
        color = function (location) {
            if (_mol_model_structure__WEBPACK_IMPORTED_MODULE_2__["StructureElement"].Location.is(location)) {
                return modelColor_1.get(_mol_model_structure__WEBPACK_IMPORTED_MODULE_2__["Model"].TrajectoryInfo.get(location.unit.model).index);
            }
            else if (_mol_model_structure__WEBPACK_IMPORTED_MODULE_2__["Bond"].isLocation(location)) {
                return modelColor_1.get(_mol_model_structure__WEBPACK_IMPORTED_MODULE_2__["Model"].TrajectoryInfo.get(location.aUnit.model).index);
            }
            return DefaultColor;
        };
    }
    else {
        color = function () { return DefaultColor; };
    }
    return {
        factory: ModelIndexColorTheme,
        granularity: 'instance',
        color: color,
        props: props,
        description: Description,
        legend: legend
    };
}
var ModelIndexColorThemeProvider = {
    name: 'model-index',
    label: 'Model Index',
    category: "Chain Property" /* Chain */,
    factory: ModelIndexColorTheme,
    getParams: getModelIndexColorThemeParams,
    defaultValues: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_3__["ParamDefinition"].getDefaultValues(ModelIndexColorThemeParams),
    isApplicable: function (ctx) { return !!ctx.structure && ctx.structure.elementCount > 0 && _mol_model_structure__WEBPACK_IMPORTED_MODULE_2__["Model"].TrajectoryInfo.get(ctx.structure.models[0]).size > 1; }
};
//# sourceMappingURL=model-index.js.map

/***/ }),

/***/ "./lib/mol-theme/color/molecule-type.js":
/*!**********************************************!*\
  !*** ./lib/mol-theme/color/molecule-type.js ***!
  \**********************************************/
/*! exports provided: MoleculeTypeColors, MoleculeTypeColorThemeParams, getMoleculeTypeColorThemeParams, moleculeTypeColor, MoleculeTypeColorTheme, MoleculeTypeColorThemeProvider */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MoleculeTypeColors", function() { return MoleculeTypeColors; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MoleculeTypeColorThemeParams", function() { return MoleculeTypeColorThemeParams; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getMoleculeTypeColorThemeParams", function() { return getMoleculeTypeColorThemeParams; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "moleculeTypeColor", function() { return moleculeTypeColor; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MoleculeTypeColorTheme", function() { return MoleculeTypeColorTheme; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MoleculeTypeColorThemeProvider", function() { return MoleculeTypeColorThemeProvider; });
/* harmony import */ var _mol_util_color__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../mol-util/color */ "./lib/mol-util/color/index.js");
/* harmony import */ var _mol_model_structure__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../mol-model/structure */ "./lib/mol-model/structure.js");
/* harmony import */ var _mol_model_structure_util__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../mol-model/structure/util */ "./lib/mol-model/structure/util.js");
/* harmony import */ var _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../mol-util/param-definition */ "./lib/mol-util/param-definition.js");
/* harmony import */ var _mol_util_legend__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../mol-util/legend */ "./lib/mol-util/legend.js");
/* harmony import */ var _mol_util_color_color__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../mol-util/color/color */ "./lib/mol-util/color/color.js");
/**
 * Copyright (c) 2018-2019 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */






var MoleculeTypeColors = Object(_mol_util_color__WEBPACK_IMPORTED_MODULE_0__["ColorMap"])({
    water: 0x386cb0,
    ion: 0xf0027f,
    protein: 0xbeaed4,
    RNA: 0xfdc086,
    DNA: 0xbf5b17,
    PNA: 0x42A49A,
    saccharide: 0x7fc97f,
});
var DefaultMoleculeTypeColor = Object(_mol_util_color__WEBPACK_IMPORTED_MODULE_0__["Color"])(0xffff99);
var Description = 'Assigns a color based on the molecule type of a residue.';
var MoleculeTypeColorThemeParams = {
    saturation: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_3__["ParamDefinition"].Numeric(0, { min: -6, max: 6, step: 0.1 }),
    lightness: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_3__["ParamDefinition"].Numeric(0, { min: -6, max: 6, step: 0.1 })
};
function getMoleculeTypeColorThemeParams(ctx) {
    return MoleculeTypeColorThemeParams; // TODO return copy
}
function moleculeTypeColor(colorMap, unit, element) {
    var moleculeType = Object(_mol_model_structure_util__WEBPACK_IMPORTED_MODULE_2__["getElementMoleculeType"])(unit, element);
    switch (moleculeType) {
        case 2 /* Water */: return colorMap.water;
        case 3 /* Ion */: return colorMap.ion;
        case 5 /* Protein */: return colorMap.protein;
        case 6 /* RNA */: return colorMap.RNA;
        case 7 /* DNA */: return colorMap.DNA;
        case 8 /* PNA */: return colorMap.PNA;
        case 9 /* Saccharide */: return colorMap.saccharide;
    }
    return DefaultMoleculeTypeColor;
}
function MoleculeTypeColorTheme(ctx, props) {
    var colorMap = Object(_mol_util_color_color__WEBPACK_IMPORTED_MODULE_5__["getAdjustedColorMap"])(MoleculeTypeColors, props.saturation, props.lightness);
    function color(location) {
        if (_mol_model_structure__WEBPACK_IMPORTED_MODULE_1__["StructureElement"].Location.is(location)) {
            return moleculeTypeColor(colorMap, location.unit, location.element);
        }
        else if (_mol_model_structure__WEBPACK_IMPORTED_MODULE_1__["Bond"].isLocation(location)) {
            return moleculeTypeColor(colorMap, location.aUnit, location.aUnit.elements[location.aIndex]);
        }
        return DefaultMoleculeTypeColor;
    }
    return {
        factory: MoleculeTypeColorTheme,
        granularity: 'group',
        color: color,
        props: props,
        description: Description,
        legend: Object(_mol_util_legend__WEBPACK_IMPORTED_MODULE_4__["TableLegend"])(Object.keys(MoleculeTypeColors).map(function (name) {
            return [name, MoleculeTypeColors[name]];
        }).concat([['Other/unknown', DefaultMoleculeTypeColor]]))
    };
}
var MoleculeTypeColorThemeProvider = {
    name: 'molecule-type',
    label: 'Molecule Type',
    category: "Residue Property" /* Residue */,
    factory: MoleculeTypeColorTheme,
    getParams: getMoleculeTypeColorThemeParams,
    defaultValues: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_3__["ParamDefinition"].getDefaultValues(MoleculeTypeColorThemeParams),
    isApplicable: function (ctx) { return !!ctx.structure; }
};
//# sourceMappingURL=molecule-type.js.map

/***/ }),

/***/ "./lib/mol-theme/color/occupancy.js":
/*!******************************************!*\
  !*** ./lib/mol-theme/color/occupancy.js ***!
  \******************************************/
/*! exports provided: OccupancyColorThemeParams, getOccupancyColorThemeParams, getOccupancy, OccupancyColorTheme, OccupancyColorThemeProvider */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "OccupancyColorThemeParams", function() { return OccupancyColorThemeParams; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getOccupancyColorThemeParams", function() { return getOccupancyColorThemeParams; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getOccupancy", function() { return getOccupancy; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "OccupancyColorTheme", function() { return OccupancyColorTheme; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "OccupancyColorThemeProvider", function() { return OccupancyColorThemeProvider; });
/* harmony import */ var _mol_util_color__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../mol-util/color */ "./lib/mol-util/color/index.js");
/* harmony import */ var _mol_model_structure__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../mol-model/structure */ "./lib/mol-model/structure.js");
/* harmony import */ var _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../mol-util/param-definition */ "./lib/mol-util/param-definition.js");
/**
 * Copyright (c) 2019 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */



var DefaultOccupancyColor = Object(_mol_util_color__WEBPACK_IMPORTED_MODULE_0__["Color"])(0xCCCCCC);
var Description = "Assigns a color based on the occupancy of an atom.";
var OccupancyColorThemeParams = {
    domain: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_2__["ParamDefinition"].Interval([0, 1]),
    list: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_2__["ParamDefinition"].ColorList('purples', { presetKind: 'scale' }),
};
function getOccupancyColorThemeParams(ctx) {
    return OccupancyColorThemeParams; // TODO return copy
}
function getOccupancy(unit, element) {
    if (_mol_model_structure__WEBPACK_IMPORTED_MODULE_1__["Unit"].isAtomic(unit)) {
        return unit.model.atomicConformation.occupancy.value(element);
    }
    else {
        return 0;
    }
}
function OccupancyColorTheme(ctx, props) {
    var scale = _mol_util_color__WEBPACK_IMPORTED_MODULE_0__["ColorScale"].create({
        reverse: false,
        domain: props.domain,
        listOrName: props.list.colors,
    });
    function color(location) {
        if (_mol_model_structure__WEBPACK_IMPORTED_MODULE_1__["StructureElement"].Location.is(location)) {
            return scale.color(getOccupancy(location.unit, location.element));
        }
        else if (_mol_model_structure__WEBPACK_IMPORTED_MODULE_1__["Bond"].isLocation(location)) {
            return scale.color(getOccupancy(location.aUnit, location.aUnit.elements[location.aIndex]));
        }
        return DefaultOccupancyColor;
    }
    return {
        factory: OccupancyColorTheme,
        granularity: 'group',
        color: color,
        props: props,
        description: Description,
        legend: scale ? scale.legend : undefined
    };
}
var OccupancyColorThemeProvider = {
    name: 'occupancy',
    label: 'Occupancy',
    category: "Atom Property" /* Atom */,
    factory: OccupancyColorTheme,
    getParams: getOccupancyColorThemeParams,
    defaultValues: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_2__["ParamDefinition"].getDefaultValues(OccupancyColorThemeParams),
    isApplicable: function (ctx) { return !!ctx.structure && ctx.structure.models.some(function (m) { return m.atomicConformation.occupancy.isDefined; }); }
};
//# sourceMappingURL=occupancy.js.map

/***/ }),

/***/ "./lib/mol-theme/color/operator-hkl.js":
/*!*********************************************!*\
  !*** ./lib/mol-theme/color/operator-hkl.js ***!
  \*********************************************/
/*! exports provided: OperatorHklColorThemeParams, getOperatorHklColorThemeParams, OperatorHklColorTheme, OperatorHklColorThemeProvider */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "OperatorHklColorThemeParams", function() { return OperatorHklColorThemeParams; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getOperatorHklColorThemeParams", function() { return getOperatorHklColorThemeParams; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "OperatorHklColorTheme", function() { return OperatorHklColorTheme; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "OperatorHklColorThemeProvider", function() { return OperatorHklColorThemeProvider; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _mol_util_color__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../mol-util/color */ "./lib/mol-util/color/index.js");
/* harmony import */ var _mol_model_structure__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../mol-model/structure */ "./lib/mol-model/structure.js");
/* harmony import */ var _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../mol-util/param-definition */ "./lib/mol-util/param-definition.js");
/* harmony import */ var _mol_util_color_palette__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../mol-util/color/palette */ "./lib/mol-util/color/palette.js");
/* harmony import */ var _mol_util_number__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../mol-util/number */ "./lib/mol-util/number.js");
/* harmony import */ var _mol_util_color_lists__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../../mol-util/color/lists */ "./lib/mol-util/color/lists.js");
/**
 * Copyright (c) 2019 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */







var DefaultList = 'dark-2';
var DefaultColor = Object(_mol_util_color__WEBPACK_IMPORTED_MODULE_1__["Color"])(0xCCCCCC);
var Description = "Assigns a color based on the operator HKL value of a transformed chain.";
var OperatorHklColorThemeParams = Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, Object(_mol_util_color_palette__WEBPACK_IMPORTED_MODULE_4__["getPaletteParams"])({ type: 'colors', colorList: DefaultList }));
function getOperatorHklColorThemeParams(ctx) {
    var params = _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_3__["ParamDefinition"].clone(OperatorHklColorThemeParams);
    if (ctx.structure) {
        if (getOperatorHklSerialMap(ctx.structure.root).map.size > _mol_util_color_lists__WEBPACK_IMPORTED_MODULE_6__["ColorLists"][DefaultList].list.length) {
            params.palette.defaultValue.name = 'colors';
            params.palette.defaultValue.params = Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, params.palette.defaultValue.params), { list: { kind: 'interpolate', colors: Object(_mol_util_color_lists__WEBPACK_IMPORTED_MODULE_6__["getColorListFromName"])(DefaultList).list } });
        }
    }
    return params;
}
var hklOffset = 10000;
function hklKey(hkl) {
    return hkl.map(function (v) { return ("" + (v + hklOffset)).padStart(5, '0'); }).join('');
}
function hklKeySplit(key) {
    var len = Object(_mol_util_number__WEBPACK_IMPORTED_MODULE_5__["integerDigitCount"])(hklOffset, 0);
    var h = parseInt(key.substr(0, len));
    var k = parseInt(key.substr(len, len));
    var l = parseInt(key.substr(len + len, len));
    return [h - hklOffset, k - hklOffset, l - hklOffset];
}
function formatHkl(hkl) {
    return hkl.map(function (v) { return v + 5; }).join('');
}
function getOperatorHklSerialMap(structure) {
    var map = new Map();
    var set = new Set();
    for (var i = 0, il = structure.units.length; i < il; ++i) {
        var k = hklKey(structure.units[i].conformation.operator.hkl);
        set.add(k);
    }
    var arr = Array.from(set.values()).sort();
    arr.forEach(function (k) { return map.set(k, map.size); });
    var min = hklKeySplit(arr[0]);
    var max = hklKeySplit(arr[arr.length - 1]);
    return { min: min, max: max, map: map };
}
function OperatorHklColorTheme(ctx, props) {
    var color;
    var legend;
    if (ctx.structure) {
        var _a = getOperatorHklSerialMap(ctx.structure.root), min = _a.min, max = _a.max, map_1 = _a.map;
        var labelTable_1 = [];
        map_1.forEach(function (v, k) {
            var i = v % map_1.size;
            var label = formatHkl(hklKeySplit(k));
            if (labelTable_1[i] === undefined)
                labelTable_1[i] = label;
            else
                labelTable_1[i] += ", " + label;
        });
        var labelOptions = {
            minLabel: formatHkl(min),
            maxLabel: formatHkl(max),
            valueLabel: function (i) { return labelTable_1[i]; }
        };
        var palette_1 = Object(_mol_util_color_palette__WEBPACK_IMPORTED_MODULE_4__["getPalette"])(map_1.size, props, labelOptions);
        legend = palette_1.legend;
        color = function (location) {
            var serial = undefined;
            if (_mol_model_structure__WEBPACK_IMPORTED_MODULE_2__["StructureElement"].Location.is(location)) {
                var k = hklKey(location.unit.conformation.operator.hkl);
                serial = map_1.get(k);
            }
            else if (_mol_model_structure__WEBPACK_IMPORTED_MODULE_2__["Bond"].isLocation(location)) {
                var k = hklKey(location.aUnit.conformation.operator.hkl);
                serial = map_1.get(k);
            }
            return serial === undefined ? DefaultColor : palette_1.color(serial);
        };
    }
    else {
        color = function () { return DefaultColor; };
    }
    return {
        factory: OperatorHklColorTheme,
        granularity: 'instance',
        color: color,
        props: props,
        description: Description,
        legend: legend
    };
}
var OperatorHklColorThemeProvider = {
    name: 'operator-hkl',
    label: 'Operator HKL',
    category: "Symmetry" /* Symmetry */,
    factory: OperatorHklColorTheme,
    getParams: getOperatorHklColorThemeParams,
    defaultValues: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_3__["ParamDefinition"].getDefaultValues(OperatorHklColorThemeParams),
    isApplicable: function (ctx) { return !!ctx.structure; }
};
//# sourceMappingURL=operator-hkl.js.map

/***/ }),

/***/ "./lib/mol-theme/color/operator-name.js":
/*!**********************************************!*\
  !*** ./lib/mol-theme/color/operator-name.js ***!
  \**********************************************/
/*! exports provided: OperatorNameColorThemeParams, getOperatorNameColorThemeParams, OperatorNameColorTheme, OperatorNameColorThemeProvider */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "OperatorNameColorThemeParams", function() { return OperatorNameColorThemeParams; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getOperatorNameColorThemeParams", function() { return getOperatorNameColorThemeParams; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "OperatorNameColorTheme", function() { return OperatorNameColorTheme; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "OperatorNameColorThemeProvider", function() { return OperatorNameColorThemeProvider; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _mol_util_color__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../mol-util/color */ "./lib/mol-util/color/index.js");
/* harmony import */ var _mol_model_structure__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../mol-model/structure */ "./lib/mol-model/structure.js");
/* harmony import */ var _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../mol-util/param-definition */ "./lib/mol-util/param-definition.js");
/* harmony import */ var _mol_util_color_palette__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../mol-util/color/palette */ "./lib/mol-util/color/palette.js");
/**
 * Copyright (c) 2019 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */





var DefaultList = 'many-distinct';
var DefaultColor = Object(_mol_util_color__WEBPACK_IMPORTED_MODULE_1__["Color"])(0xCCCCCC);
var Description = "Assigns a color based on the operator name of a transformed chain.";
var OperatorNameColorThemeParams = Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, Object(_mol_util_color_palette__WEBPACK_IMPORTED_MODULE_4__["getPaletteParams"])({ type: 'colors', colorList: DefaultList }));
function getOperatorNameColorThemeParams(ctx) {
    var params = _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_3__["ParamDefinition"].clone(OperatorNameColorThemeParams);
    return params;
}
function getOperatorNameSerialMap(structure) {
    var map = new Map();
    for (var i = 0, il = structure.units.length; i < il; ++i) {
        var name_1 = structure.units[i].conformation.operator.name;
        if (!map.has(name_1))
            map.set(name_1, map.size);
    }
    return map;
}
function OperatorNameColorTheme(ctx, props) {
    var color;
    var legend;
    if (ctx.structure) {
        var operatorNameSerialMap_1 = getOperatorNameSerialMap(ctx.structure.root);
        var labelTable_1 = Array.from(operatorNameSerialMap_1.keys());
        var valueLabel = function (i) { return labelTable_1[i]; };
        var palette_1 = Object(_mol_util_color_palette__WEBPACK_IMPORTED_MODULE_4__["getPalette"])(operatorNameSerialMap_1.size, props, { valueLabel: valueLabel });
        legend = palette_1.legend;
        color = function (location) {
            var serial = undefined;
            if (_mol_model_structure__WEBPACK_IMPORTED_MODULE_2__["StructureElement"].Location.is(location)) {
                var name_2 = location.unit.conformation.operator.name;
                serial = operatorNameSerialMap_1.get(name_2);
            }
            else if (_mol_model_structure__WEBPACK_IMPORTED_MODULE_2__["Bond"].isLocation(location)) {
                var name_3 = location.aUnit.conformation.operator.name;
                serial = operatorNameSerialMap_1.get(name_3);
            }
            return serial === undefined ? DefaultColor : palette_1.color(serial);
        };
    }
    else {
        color = function () { return DefaultColor; };
    }
    return {
        factory: OperatorNameColorTheme,
        granularity: 'instance',
        color: color,
        props: props,
        description: Description,
        legend: legend
    };
}
var OperatorNameColorThemeProvider = {
    name: 'operator-name',
    label: 'Operator Name',
    category: "Symmetry" /* Symmetry */,
    factory: OperatorNameColorTheme,
    getParams: getOperatorNameColorThemeParams,
    defaultValues: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_3__["ParamDefinition"].getDefaultValues(OperatorNameColorThemeParams),
    isApplicable: function (ctx) { return !!ctx.structure; }
};
//# sourceMappingURL=operator-name.js.map

/***/ }),

/***/ "./lib/mol-theme/color/partial-charge.js":
/*!***********************************************!*\
  !*** ./lib/mol-theme/color/partial-charge.js ***!
  \***********************************************/
/*! exports provided: PartialChargeColorThemeParams, getPartialChargeColorThemeParams, PartialChargeColorTheme, PartialChargeColorThemeProvider */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "PartialChargeColorThemeParams", function() { return PartialChargeColorThemeParams; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getPartialChargeColorThemeParams", function() { return getPartialChargeColorThemeParams; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "PartialChargeColorTheme", function() { return PartialChargeColorTheme; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "PartialChargeColorThemeProvider", function() { return PartialChargeColorThemeProvider; });
/* harmony import */ var _mol_util_color__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../mol-util/color */ "./lib/mol-util/color/index.js");
/* harmony import */ var _mol_model_structure__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../mol-model/structure */ "./lib/mol-model/structure.js");
/* harmony import */ var _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../mol-util/param-definition */ "./lib/mol-util/param-definition.js");
/* harmony import */ var _mol_model_formats_structure_property_partial_charge__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../mol-model-formats/structure/property/partial-charge */ "./lib/mol-model-formats/structure/property/partial-charge.js");
/**
 * Copyright (c) 2020 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */




var DefaultPartialChargeColor = Object(_mol_util_color__WEBPACK_IMPORTED_MODULE_0__["Color"])(0xffff99);
var Description = "Assigns a color based on the partial charge of an atom.";
var PartialChargeColorThemeParams = {
    domain: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_2__["ParamDefinition"].Interval([-1, 1]),
    list: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_2__["ParamDefinition"].ColorList('red-white-blue', { presetKind: 'scale' }),
};
function getPartialChargeColorThemeParams(ctx) {
    return PartialChargeColorThemeParams; // TODO return copy
}
function getPartialCharge(unit, element) {
    var _a;
    return (_a = _mol_model_formats_structure_property_partial_charge__WEBPACK_IMPORTED_MODULE_3__["AtomPartialCharge"].Provider.get(unit.model)) === null || _a === void 0 ? void 0 : _a.data.value(element);
}
function PartialChargeColorTheme(ctx, props) {
    var scale = _mol_util_color__WEBPACK_IMPORTED_MODULE_0__["ColorScale"].create({
        domain: props.domain,
        listOrName: props.list.colors,
    });
    function color(location) {
        if (_mol_model_structure__WEBPACK_IMPORTED_MODULE_1__["StructureElement"].Location.is(location)) {
            var q = getPartialCharge(location.unit, location.element);
            return q !== undefined ? scale.color(q) : DefaultPartialChargeColor;
        }
        else if (_mol_model_structure__WEBPACK_IMPORTED_MODULE_1__["Bond"].isLocation(location)) {
            var q = getPartialCharge(location.aUnit, location.aUnit.elements[location.aIndex]);
            return q !== undefined ? scale.color(q) : DefaultPartialChargeColor;
        }
        return DefaultPartialChargeColor;
    }
    return {
        factory: PartialChargeColorTheme,
        granularity: 'group',
        color: color,
        props: props,
        description: Description,
        legend: scale ? scale.legend : undefined
    };
}
var PartialChargeColorThemeProvider = {
    name: 'partial-charge',
    label: 'Partial Charge',
    category: "Atom Property" /* Atom */,
    factory: PartialChargeColorTheme,
    getParams: getPartialChargeColorThemeParams,
    defaultValues: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_2__["ParamDefinition"].getDefaultValues(PartialChargeColorThemeParams),
    isApplicable: function (ctx) { return !!ctx.structure && ctx.structure.models.some(function (m) { return _mol_model_formats_structure_property_partial_charge__WEBPACK_IMPORTED_MODULE_3__["AtomPartialCharge"].Provider.get(m) !== undefined; }); }
};
//# sourceMappingURL=partial-charge.js.map

/***/ }),

/***/ "./lib/mol-theme/color/polymer-id.js":
/*!*******************************************!*\
  !*** ./lib/mol-theme/color/polymer-id.js ***!
  \*******************************************/
/*! exports provided: PolymerIdColorThemeParams, getPolymerIdColorThemeParams, PolymerIdColorTheme, PolymerIdColorThemeProvider */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "PolymerIdColorThemeParams", function() { return PolymerIdColorThemeParams; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getPolymerIdColorThemeParams", function() { return getPolymerIdColorThemeParams; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "PolymerIdColorTheme", function() { return PolymerIdColorTheme; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "PolymerIdColorThemeProvider", function() { return PolymerIdColorThemeProvider; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _mol_model_structure__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../mol-model/structure */ "./lib/mol-model/structure.js");
/* harmony import */ var _mol_util_color__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../mol-util/color */ "./lib/mol-util/color/index.js");
/* harmony import */ var _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../mol-util/param-definition */ "./lib/mol-util/param-definition.js");
/* harmony import */ var _mol_util_color_palette__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../mol-util/color/palette */ "./lib/mol-util/color/palette.js");
/* harmony import */ var _mol_data_int__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../mol-data/int */ "./lib/mol-data/int.js");
/* harmony import */ var _mol_util_color_lists__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../../mol-util/color/lists */ "./lib/mol-util/color/lists.js");
/**
 * Copyright (c) 2018-2019 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */







var DefaultList = 'dark-2';
var DefaultColor = Object(_mol_util_color__WEBPACK_IMPORTED_MODULE_2__["Color"])(0xFAFAFA);
var Description = 'Gives every polymer chain a color based on its `asym_id` value.';
var PolymerIdColorThemeParams = Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, Object(_mol_util_color_palette__WEBPACK_IMPORTED_MODULE_4__["getPaletteParams"])({ type: 'colors', colorList: DefaultList }));
function getPolymerIdColorThemeParams(ctx) {
    var params = _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_3__["ParamDefinition"].clone(PolymerIdColorThemeParams);
    if (ctx.structure) {
        if (getPolymerAsymIdSerialMap(ctx.structure.root).size > _mol_util_color_lists__WEBPACK_IMPORTED_MODULE_6__["ColorLists"][DefaultList].list.length) {
            params.palette.defaultValue.name = 'colors';
            params.palette.defaultValue.params = Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, params.palette.defaultValue.params), { list: { kind: 'interpolate', colors: Object(_mol_util_color_lists__WEBPACK_IMPORTED_MODULE_6__["getColorListFromName"])(DefaultList).list } });
        }
    }
    return params;
}
function getAsymId(unit) {
    switch (unit.kind) {
        case 0 /* Atomic */:
            return _mol_model_structure__WEBPACK_IMPORTED_MODULE_1__["StructureProperties"].chain.label_asym_id;
        case 1 /* Spheres */:
        case 2 /* Gaussians */:
            return _mol_model_structure__WEBPACK_IMPORTED_MODULE_1__["StructureProperties"].coarse.asym_id;
    }
}
function getPolymerAsymIdSerialMap(structure) {
    var map = new Map();
    for (var i = 0, il = structure.unitSymmetryGroups.length; i < il; ++i) {
        var unit = structure.unitSymmetryGroups[i].units[0];
        var model = unit.model;
        if (_mol_model_structure__WEBPACK_IMPORTED_MODULE_1__["Unit"].isAtomic(unit)) {
            var _a = model.atomicHierarchy, chainAtomSegments = _a.chainAtomSegments, chains = _a.chains;
            var chainIt = _mol_data_int__WEBPACK_IMPORTED_MODULE_5__["Segmentation"].transientSegments(chainAtomSegments, unit.elements);
            while (chainIt.hasNext) {
                var chainIndex = chainIt.move().index;
                var entityId = chains.label_entity_id.value(chainIndex);
                var eI = model.entities.getEntityIndex(entityId);
                if (model.entities.data.type.value(eI) === 'polymer') {
                    var asymId = chains.label_asym_id.value(chainIndex);
                    if (!map.has(asymId))
                        map.set(asymId, map.size);
                }
            }
        }
        else if (_mol_model_structure__WEBPACK_IMPORTED_MODULE_1__["Unit"].isCoarse(unit)) {
            var _b = _mol_model_structure__WEBPACK_IMPORTED_MODULE_1__["Unit"].isSpheres(unit)
                ? model.coarseHierarchy.spheres
                : model.coarseHierarchy.gaussians, chainElementSegments = _b.chainElementSegments, asym_id = _b.asym_id, entity_id = _b.entity_id;
            var chainIt = _mol_data_int__WEBPACK_IMPORTED_MODULE_5__["Segmentation"].transientSegments(chainElementSegments, unit.elements);
            while (chainIt.hasNext) {
                var chainIndex = chainIt.move().index;
                var elementIndex = chainElementSegments.offsets[chainIndex];
                var entityId = entity_id.value(elementIndex);
                var eI = model.entities.getEntityIndex(entityId);
                if (model.entities.data.type.value(eI) === 'polymer') {
                    var asymId = asym_id.value(elementIndex);
                    if (!map.has(asymId))
                        map.set(asymId, map.size);
                }
            }
        }
    }
    return map;
}
function PolymerIdColorTheme(ctx, props) {
    var color;
    var legend;
    if (ctx.structure) {
        var l_1 = _mol_model_structure__WEBPACK_IMPORTED_MODULE_1__["StructureElement"].Location.create(ctx.structure);
        var polymerAsymIdSerialMap_1 = getPolymerAsymIdSerialMap(ctx.structure.root);
        var labelTable_1 = Array.from(polymerAsymIdSerialMap_1.keys());
        var valueLabel = function (i) { return labelTable_1[i]; };
        var palette_1 = Object(_mol_util_color_palette__WEBPACK_IMPORTED_MODULE_4__["getPalette"])(polymerAsymIdSerialMap_1.size, props, { valueLabel: valueLabel });
        legend = palette_1.legend;
        color = function (location) {
            var serial = undefined;
            if (_mol_model_structure__WEBPACK_IMPORTED_MODULE_1__["StructureElement"].Location.is(location)) {
                var asym_id = getAsymId(location.unit);
                serial = polymerAsymIdSerialMap_1.get(asym_id(location));
            }
            else if (_mol_model_structure__WEBPACK_IMPORTED_MODULE_1__["Bond"].isLocation(location)) {
                var asym_id = getAsymId(location.aUnit);
                l_1.unit = location.aUnit;
                l_1.element = location.aUnit.elements[location.aIndex];
                serial = polymerAsymIdSerialMap_1.get(asym_id(l_1));
            }
            return serial === undefined ? DefaultColor : palette_1.color(serial);
        };
    }
    else {
        color = function () { return DefaultColor; };
    }
    return {
        factory: PolymerIdColorTheme,
        granularity: 'group',
        color: color,
        props: props,
        description: Description,
        legend: legend
    };
}
var PolymerIdColorThemeProvider = {
    name: 'polymer-id',
    label: 'Polymer Chain Id',
    category: "Chain Property" /* Chain */,
    factory: PolymerIdColorTheme,
    getParams: getPolymerIdColorThemeParams,
    defaultValues: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_3__["ParamDefinition"].getDefaultValues(PolymerIdColorThemeParams),
    isApplicable: function (ctx) { return !!ctx.structure; }
};
//# sourceMappingURL=polymer-id.js.map

/***/ }),

/***/ "./lib/mol-theme/color/polymer-index.js":
/*!**********************************************!*\
  !*** ./lib/mol-theme/color/polymer-index.js ***!
  \**********************************************/
/*! exports provided: PolymerIndexColorThemeParams, getPolymerIndexColorThemeParams, PolymerIndexColorTheme, PolymerIndexColorThemeProvider */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "PolymerIndexColorThemeParams", function() { return PolymerIndexColorThemeParams; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getPolymerIndexColorThemeParams", function() { return getPolymerIndexColorThemeParams; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "PolymerIndexColorTheme", function() { return PolymerIndexColorTheme; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "PolymerIndexColorThemeProvider", function() { return PolymerIndexColorThemeProvider; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _mol_util_color__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../mol-util/color */ "./lib/mol-util/color/index.js");
/* harmony import */ var _mol_model_structure__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../mol-model/structure */ "./lib/mol-model/structure.js");
/* harmony import */ var _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../mol-util/param-definition */ "./lib/mol-util/param-definition.js");
/* harmony import */ var _mol_util_color_palette__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../mol-util/color/palette */ "./lib/mol-util/color/palette.js");
/* harmony import */ var _mol_util_color_lists__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../mol-util/color/lists */ "./lib/mol-util/color/lists.js");
/**
 * Copyright (c) 2018-2019 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */






var DefaultList = 'dark-2';
var DefaultColor = Object(_mol_util_color__WEBPACK_IMPORTED_MODULE_1__["Color"])(0xCCCCCC);
var Description = 'Gives every polymer chain instance a unique color based on the position (index) of the polymer in the list of polymers in the structure.';
var PolymerIndexColorThemeParams = Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, Object(_mol_util_color_palette__WEBPACK_IMPORTED_MODULE_4__["getPaletteParams"])({ type: 'colors', colorList: DefaultList }));
function getPolymerIndexColorThemeParams(ctx) {
    var params = _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_3__["ParamDefinition"].clone(PolymerIndexColorThemeParams);
    if (ctx.structure) {
        if (getPolymerChainCount(ctx.structure.root) > _mol_util_color_lists__WEBPACK_IMPORTED_MODULE_5__["ColorLists"][DefaultList].list.length) {
            params.palette.defaultValue.name = 'colors';
            params.palette.defaultValue.params = Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, params.palette.defaultValue.params), { list: { kind: 'interpolate', colors: Object(_mol_util_color_lists__WEBPACK_IMPORTED_MODULE_5__["getColorListFromName"])(DefaultList).list } });
        }
    }
    return params;
}
function getPolymerChainCount(structure) {
    var polymerChainCount = 0;
    var units = structure.units;
    for (var i = 0, il = units.length; i < il; ++i) {
        if (units[i].polymerElements.length > 0)
            ++polymerChainCount;
    }
    return polymerChainCount;
}
function PolymerIndexColorTheme(ctx, props) {
    var color;
    var legend;
    if (ctx.structure) {
        var palette = Object(_mol_util_color_palette__WEBPACK_IMPORTED_MODULE_4__["getPalette"])(getPolymerChainCount(ctx.structure.root), props);
        legend = palette.legend;
        var units = ctx.structure.root.units;
        var unitIdColor_1 = new Map();
        for (var i = 0, j = 0, il = units.length; i < il; ++i) {
            if (units[i].polymerElements.length > 0) {
                unitIdColor_1.set(units[i].id, palette.color(j));
                ++j;
            }
        }
        color = function (location) {
            var color;
            if (_mol_model_structure__WEBPACK_IMPORTED_MODULE_2__["StructureElement"].Location.is(location)) {
                color = unitIdColor_1.get(location.unit.id);
            }
            else if (_mol_model_structure__WEBPACK_IMPORTED_MODULE_2__["Bond"].isLocation(location)) {
                color = unitIdColor_1.get(location.aUnit.id);
            }
            return color !== undefined ? color : DefaultColor;
        };
    }
    else {
        color = function () { return DefaultColor; };
    }
    return {
        factory: PolymerIndexColorTheme,
        granularity: 'instance',
        color: color,
        props: props,
        description: Description,
        legend: legend
    };
}
var PolymerIndexColorThemeProvider = {
    name: 'polymer-index',
    label: 'Polymer Chain Instance',
    category: "Chain Property" /* Chain */,
    factory: PolymerIndexColorTheme,
    getParams: getPolymerIndexColorThemeParams,
    defaultValues: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_3__["ParamDefinition"].getDefaultValues(PolymerIndexColorThemeParams),
    isApplicable: function (ctx) { return !!ctx.structure; }
};
//# sourceMappingURL=polymer-index.js.map

/***/ }),

/***/ "./lib/mol-theme/color/prediction.js":
/*!*******************************************!*\
  !*** ./lib/mol-theme/color/prediction.js ***!
  \*******************************************/
/*! exports provided: PredictionColorThemeParams, getPredictionColorThemeParams, getPrediction, PredictionColorTheme, PredictionColorThemeProvider */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "PredictionColorThemeParams", function() { return PredictionColorThemeParams; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getPredictionColorThemeParams", function() { return getPredictionColorThemeParams; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getPrediction", function() { return getPrediction; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "PredictionColorTheme", function() { return PredictionColorTheme; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "PredictionColorThemeProvider", function() { return PredictionColorThemeProvider; });
/* harmony import */ var _mol_util_color__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../mol-util/color */ "./lib/mol-util/color/index.js");
/* harmony import */ var _mol_model_structure__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../mol-model/structure */ "./lib/mol-model/structure.js");
/* harmony import */ var _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../mol-util/param-definition */ "./lib/mol-util/param-definition.js");
/**
 * Copyright (c) 2019 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */



var DefaultPredictionColor = Object(_mol_util_color__WEBPACK_IMPORTED_MODULE_0__["Color"])(0xCCCCCC);
var Description = "Assigns a color based on the predicted interface of an atom.";
var PredictionColorThemeParams = {
    domain: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_2__["ParamDefinition"].Interval([0.0, 1.0]),
    list: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_2__["ParamDefinition"].ColorList('blue-white-red', { presetKind: 'scale' }),
};
function getPredictionColorThemeParams(ctx) {
    return PredictionColorThemeParams; // TODO return copy
}
function getPrediction(unit, element) {
    if (_mol_model_structure__WEBPACK_IMPORTED_MODULE_1__["Unit"].isAtomic(unit)) {
        return unit.model.atomicConformation.occupancy.value(element);
    }
    else {
        return 0;
    }
}
function PredictionColorTheme(ctx, props) {
    var scale = _mol_util_color__WEBPACK_IMPORTED_MODULE_0__["ColorScale"].create({
        reverse: false,
        domain: props.domain,
        listOrName: props.list.colors,
    });
    function color(location) {
        if (_mol_model_structure__WEBPACK_IMPORTED_MODULE_1__["StructureElement"].Location.is(location)) {
            return scale.color(getPrediction(location.unit, location.element));
        }
        else if (_mol_model_structure__WEBPACK_IMPORTED_MODULE_1__["Bond"].isLocation(location)) {
            return scale.color(getPrediction(location.aUnit, location.aUnit.elements[location.aIndex]));
        }
        return DefaultPredictionColor;
    }
    return {
        factory: PredictionColorTheme,
        granularity: 'group',
        color: color,
        props: props,
        description: Description,
        legend: scale ? scale.legend : undefined
    };
}
var PredictionColorThemeProvider = {
    name: 'prediction',
    label: 'Prediction',
    category: "Atom Property" /* Atom */,
    factory: PredictionColorTheme,
    getParams: getPredictionColorThemeParams,
    defaultValues: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_2__["ParamDefinition"].getDefaultValues(PredictionColorThemeParams),
    isApplicable: function (ctx) { return !!ctx.structure && ctx.structure.models.some(function (m) { return m.atomicConformation.occupancy.isDefined; }); }
};
//# sourceMappingURL=prediction.js.map

/***/ }),

/***/ "./lib/mol-theme/color/residue-name.js":
/*!*********************************************!*\
  !*** ./lib/mol-theme/color/residue-name.js ***!
  \*********************************************/
/*! exports provided: ResidueNameColors, ResidueNameColorThemeParams, getResidueNameColorThemeParams, residueNameColor, ResidueNameColorTheme, ResidueNameColorThemeProvider */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ResidueNameColors", function() { return ResidueNameColors; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ResidueNameColorThemeParams", function() { return ResidueNameColorThemeParams; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getResidueNameColorThemeParams", function() { return getResidueNameColorThemeParams; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "residueNameColor", function() { return residueNameColor; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ResidueNameColorTheme", function() { return ResidueNameColorTheme; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ResidueNameColorThemeProvider", function() { return ResidueNameColorThemeProvider; });
/* harmony import */ var _mol_util_color__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../mol-util/color */ "./lib/mol-util/color/index.js");
/* harmony import */ var _mol_model_structure__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../mol-model/structure */ "./lib/mol-model/structure.js");
/* harmony import */ var _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../mol-util/param-definition */ "./lib/mol-util/param-definition.js");
/* harmony import */ var _mol_util_legend__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../mol-util/legend */ "./lib/mol-util/legend.js");
/* harmony import */ var _mol_util_color_color__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../mol-util/color/color */ "./lib/mol-util/color/color.js");
/**
 * Copyright (c) 2018-2019 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */





// protein colors from Jmol http://jmol.sourceforge.net/jscolors/
var ResidueNameColors = Object(_mol_util_color__WEBPACK_IMPORTED_MODULE_0__["ColorMap"])({
    // standard amino acids
    'ALA': 0x8CFF8C,
    'ARG': 0x00007C,
    'ASN': 0xFF7C70,
    'ASP': 0xA00042,
    'CYS': 0xFFFF70,
    'GLN': 0xFF4C4C,
    'GLU': 0x660000,
    'GLY': 0xEEEEEE,
    'HIS': 0x7070FF,
    'ILE': 0x004C00,
    'LEU': 0x455E45,
    'LYS': 0x4747B8,
    'MET': 0xB8A042,
    'PHE': 0x534C52,
    'PRO': 0x525252,
    'SER': 0xFF7042,
    'THR': 0xB84C00,
    'TRP': 0x4F4600,
    'TYR': 0x8C704C,
    'VAL': 0xFF8CFF,
    // rna bases
    'A': 0xDC143C,
    'G': 0x32CD32,
    'I': 0x9ACD32,
    'C': 0xFFD700,
    'T': 0x4169E1,
    'U': 0x40E0D0,
    // dna bases
    'DA': 0xDC143C,
    'DG': 0x32CD32,
    'DI': 0x9ACD32,
    'DC': 0xFFD700,
    'DT': 0x4169E1,
    'DU': 0x40E0D0,
    // peptide bases
    'APN': 0xDC143C,
    'GPN': 0x32CD32,
    'CPN': 0xFFD700,
    'TPN': 0x4169E1,
});
var DefaultResidueNameColor = Object(_mol_util_color__WEBPACK_IMPORTED_MODULE_0__["Color"])(0xFF00FF);
var Description = 'Assigns a color to every residue according to its name.';
var ResidueNameColorThemeParams = {
    saturation: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_2__["ParamDefinition"].Numeric(0, { min: -6, max: 6, step: 0.1 }),
    lightness: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_2__["ParamDefinition"].Numeric(1, { min: -6, max: 6, step: 0.1 })
};
function getResidueNameColorThemeParams(ctx) {
    return ResidueNameColorThemeParams; // TODO return copy
}
function getAtomicCompId(unit, element) {
    return unit.model.atomicHierarchy.atoms.label_comp_id.value(element);
}
function getCoarseCompId(unit, element) {
    var seqIdBegin = unit.coarseElements.seq_id_begin.value(element);
    var seqIdEnd = unit.coarseElements.seq_id_end.value(element);
    if (seqIdBegin === seqIdEnd) {
        var entityKey = unit.coarseElements.entityKey[element];
        var seq = unit.model.sequence.byEntityKey[entityKey].sequence;
        return seq.compId.value(seqIdBegin - 1); // 1-indexed
    }
}
function residueNameColor(colorMap, residueName) {
    var c = colorMap[residueName];
    return c === undefined ? DefaultResidueNameColor : c;
}
function ResidueNameColorTheme(ctx, props) {
    var colorMap = Object(_mol_util_color_color__WEBPACK_IMPORTED_MODULE_4__["getAdjustedColorMap"])(ResidueNameColors, props.saturation, props.lightness);
    function color(location) {
        if (_mol_model_structure__WEBPACK_IMPORTED_MODULE_1__["StructureElement"].Location.is(location)) {
            if (_mol_model_structure__WEBPACK_IMPORTED_MODULE_1__["Unit"].isAtomic(location.unit)) {
                var compId = getAtomicCompId(location.unit, location.element);
                return residueNameColor(colorMap, compId);
            }
            else {
                var compId = getCoarseCompId(location.unit, location.element);
                if (compId)
                    return residueNameColor(colorMap, compId);
            }
        }
        else if (_mol_model_structure__WEBPACK_IMPORTED_MODULE_1__["Bond"].isLocation(location)) {
            if (_mol_model_structure__WEBPACK_IMPORTED_MODULE_1__["Unit"].isAtomic(location.aUnit)) {
                var compId = getAtomicCompId(location.aUnit, location.aUnit.elements[location.aIndex]);
                return residueNameColor(colorMap, compId);
            }
            else {
                var compId = getCoarseCompId(location.aUnit, location.aUnit.elements[location.aIndex]);
                if (compId)
                    return residueNameColor(colorMap, compId);
            }
        }
        return DefaultResidueNameColor;
    }
    return {
        factory: ResidueNameColorTheme,
        granularity: 'group',
        color: color,
        props: props,
        description: Description,
        legend: Object(_mol_util_legend__WEBPACK_IMPORTED_MODULE_3__["TableLegend"])(Object.keys(ResidueNameColors).map(function (name) {
            return [name, ResidueNameColors[name]];
        }).concat([['Unknown', DefaultResidueNameColor]]))
    };
}
var ResidueNameColorThemeProvider = {
    name: 'residue-name',
    label: 'Residue Name',
    category: "Residue Property" /* Residue */,
    factory: ResidueNameColorTheme,
    getParams: getResidueNameColorThemeParams,
    defaultValues: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_2__["ParamDefinition"].getDefaultValues(ResidueNameColorThemeParams),
    isApplicable: function (ctx) { return !!ctx.structure; }
};
//# sourceMappingURL=residue-name.js.map

/***/ }),

/***/ "./lib/mol-theme/color/secondary-structure.js":
/*!****************************************************!*\
  !*** ./lib/mol-theme/color/secondary-structure.js ***!
  \****************************************************/
/*! exports provided: SecondaryStructureColorThemeParams, getSecondaryStructureColorThemeParams, secondaryStructureColor, SecondaryStructureColorTheme, SecondaryStructureColorThemeProvider */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SecondaryStructureColorThemeParams", function() { return SecondaryStructureColorThemeParams; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getSecondaryStructureColorThemeParams", function() { return getSecondaryStructureColorThemeParams; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "secondaryStructureColor", function() { return secondaryStructureColor; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SecondaryStructureColorTheme", function() { return SecondaryStructureColorTheme; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SecondaryStructureColorThemeProvider", function() { return SecondaryStructureColorThemeProvider; });
/* harmony import */ var _mol_util_color__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../mol-util/color */ "./lib/mol-util/color/index.js");
/* harmony import */ var _mol_model_structure__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../mol-model/structure */ "./lib/mol-model/structure.js");
/* harmony import */ var _mol_model_structure_model_types__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../mol-model/structure/model/types */ "./lib/mol-model/structure/model/types.js");
/* harmony import */ var _mol_model_structure_util__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../mol-model/structure/util */ "./lib/mol-model/structure/util.js");
/* harmony import */ var _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../mol-util/param-definition */ "./lib/mol-util/param-definition.js");
/* harmony import */ var _mol_util_legend__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../mol-util/legend */ "./lib/mol-util/legend.js");
/* harmony import */ var _mol_model_props_computed_secondary_structure__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../../mol-model-props/computed/secondary-structure */ "./lib/mol-model-props/computed/secondary-structure.js");
/* harmony import */ var _mol_util_color_color__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../../mol-util/color/color */ "./lib/mol-util/color/color.js");
/* harmony import */ var _mol_data_util__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ../../mol-data/util */ "./lib/mol-data/util.js");
/**
 * Copyright (c) 2018-2019 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */









// from Jmol http://jmol.sourceforge.net/jscolors/ (shapely)
var SecondaryStructureColors = Object(_mol_util_color__WEBPACK_IMPORTED_MODULE_0__["ColorMap"])({
    'alphaHelix': 0xFF0080,
    'threeTenHelix': 0xA00080,
    'piHelix': 0x600080,
    'betaTurn': 0x6080FF,
    'betaStrand': 0xFFC800,
    'coil': 0xFFFFFF,
    'bend': 0x66D8C9 /* biting original color used 0x00FF00 */,
    'turn': 0x00B266,
    'dna': 0xAE00FE,
    'rna': 0xFD0162,
    'carbohydrate': 0xA6A6FA
});
var DefaultSecondaryStructureColor = Object(_mol_util_color__WEBPACK_IMPORTED_MODULE_0__["Color"])(0x808080);
var Description = 'Assigns a color based on the type of secondary structure and basic molecule type.';
var SecondaryStructureColorThemeParams = {
    saturation: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_4__["ParamDefinition"].Numeric(-1, { min: -6, max: 6, step: 0.1 }),
    lightness: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_4__["ParamDefinition"].Numeric(0, { min: -6, max: 6, step: 0.1 })
};
function getSecondaryStructureColorThemeParams(ctx) {
    return SecondaryStructureColorThemeParams; // TODO return copy
}
function secondaryStructureColor(colorMap, unit, element, computedSecondaryStructure) {
    var secStrucType = _mol_model_structure_model_types__WEBPACK_IMPORTED_MODULE_2__["SecondaryStructureType"].create(0 /* None */);
    if (computedSecondaryStructure && _mol_model_structure__WEBPACK_IMPORTED_MODULE_1__["Unit"].isAtomic(unit)) {
        var secondaryStructure = computedSecondaryStructure.get(unit.invariantId);
        if (secondaryStructure)
            secStrucType = secondaryStructure.type[secondaryStructure.getIndex(unit.residueIndex[element])];
    }
    if (_mol_model_structure_model_types__WEBPACK_IMPORTED_MODULE_2__["SecondaryStructureType"].is(secStrucType, 2 /* Helix */)) {
        if (_mol_model_structure_model_types__WEBPACK_IMPORTED_MODULE_2__["SecondaryStructureType"].is(secStrucType, 2048 /* Helix3Ten */)) {
            return colorMap.threeTenHelix;
        }
        else if (_mol_model_structure_model_types__WEBPACK_IMPORTED_MODULE_2__["SecondaryStructureType"].is(secStrucType, 32768 /* HelixPi */)) {
            return colorMap.piHelix;
        }
        return colorMap.alphaHelix;
    }
    else if (_mol_model_structure_model_types__WEBPACK_IMPORTED_MODULE_2__["SecondaryStructureType"].is(secStrucType, 4 /* Beta */)) {
        return colorMap.betaStrand;
    }
    else if (_mol_model_structure_model_types__WEBPACK_IMPORTED_MODULE_2__["SecondaryStructureType"].is(secStrucType, 8 /* Bend */)) {
        return colorMap.bend;
    }
    else if (_mol_model_structure_model_types__WEBPACK_IMPORTED_MODULE_2__["SecondaryStructureType"].is(secStrucType, 16 /* Turn */)) {
        return colorMap.turn;
    }
    else {
        var moleculeType = Object(_mol_model_structure_util__WEBPACK_IMPORTED_MODULE_3__["getElementMoleculeType"])(unit, element);
        if (moleculeType === 7 /* DNA */) {
            return colorMap.dna;
        }
        else if (moleculeType === 6 /* RNA */) {
            return colorMap.rna;
        }
        else if (moleculeType === 9 /* Saccharide */) {
            return colorMap.carbohydrate;
        }
        else if (moleculeType === 5 /* Protein */) {
            return colorMap.coil;
        }
    }
    return DefaultSecondaryStructureColor;
}
function SecondaryStructureColorTheme(ctx, props) {
    var computedSecondaryStructure = ctx.structure && _mol_model_props_computed_secondary_structure__WEBPACK_IMPORTED_MODULE_6__["SecondaryStructureProvider"].get(ctx.structure);
    var contextHash = computedSecondaryStructure ? Object(_mol_data_util__WEBPACK_IMPORTED_MODULE_8__["hash2"])(computedSecondaryStructure.id, computedSecondaryStructure.version) : -1;
    var colorMap = Object(_mol_util_color_color__WEBPACK_IMPORTED_MODULE_7__["getAdjustedColorMap"])(SecondaryStructureColors, props.saturation, props.lightness);
    function color(location) {
        if (_mol_model_structure__WEBPACK_IMPORTED_MODULE_1__["StructureElement"].Location.is(location)) {
            return secondaryStructureColor(colorMap, location.unit, location.element, computedSecondaryStructure === null || computedSecondaryStructure === void 0 ? void 0 : computedSecondaryStructure.value);
        }
        else if (_mol_model_structure__WEBPACK_IMPORTED_MODULE_1__["Bond"].isLocation(location)) {
            return secondaryStructureColor(colorMap, location.aUnit, location.aUnit.elements[location.aIndex], computedSecondaryStructure === null || computedSecondaryStructure === void 0 ? void 0 : computedSecondaryStructure.value);
        }
        return DefaultSecondaryStructureColor;
    }
    return {
        factory: SecondaryStructureColorTheme,
        granularity: 'group',
        color: color,
        props: props,
        contextHash: contextHash,
        description: Description,
        legend: Object(_mol_util_legend__WEBPACK_IMPORTED_MODULE_5__["TableLegend"])(Object.keys(SecondaryStructureColors).map(function (name) {
            return [name, SecondaryStructureColors[name]];
        }).concat([['Other', DefaultSecondaryStructureColor]]))
    };
}
var SecondaryStructureColorThemeProvider = {
    name: 'secondary-structure',
    label: 'Secondary Structure',
    category: "Residue Property" /* Residue */,
    factory: SecondaryStructureColorTheme,
    getParams: getSecondaryStructureColorThemeParams,
    defaultValues: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_4__["ParamDefinition"].getDefaultValues(SecondaryStructureColorThemeParams),
    isApplicable: function (ctx) { return !!ctx.structure; },
    ensureCustomProperties: {
        attach: function (ctx, data) { return data.structure ? _mol_model_props_computed_secondary_structure__WEBPACK_IMPORTED_MODULE_6__["SecondaryStructureProvider"].attach(ctx, data.structure, void 0, true) : Promise.resolve(); },
        detach: function (data) { return data.structure && data.structure.customPropertyDescriptors.reference(_mol_model_props_computed_secondary_structure__WEBPACK_IMPORTED_MODULE_6__["SecondaryStructureProvider"].descriptor, false); }
    }
};
//# sourceMappingURL=secondary-structure.js.map

/***/ }),

/***/ "./lib/mol-theme/color/sequence-id.js":
/*!********************************************!*\
  !*** ./lib/mol-theme/color/sequence-id.js ***!
  \********************************************/
/*! exports provided: SequenceIdColorThemeParams, getSequenceIdColorThemeParams, SequenceIdColorTheme, SequenceIdColorThemeProvider */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SequenceIdColorThemeParams", function() { return SequenceIdColorThemeParams; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getSequenceIdColorThemeParams", function() { return getSequenceIdColorThemeParams; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SequenceIdColorTheme", function() { return SequenceIdColorTheme; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SequenceIdColorThemeProvider", function() { return SequenceIdColorThemeProvider; });
/* harmony import */ var _mol_model_structure__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../mol-model/structure */ "./lib/mol-model/structure.js");
/* harmony import */ var _mol_util_color__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../mol-util/color */ "./lib/mol-util/color/index.js");
/* harmony import */ var _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../mol-util/param-definition */ "./lib/mol-util/param-definition.js");
/**
 * Copyright (c) 2018 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */



var DefaultColor = Object(_mol_util_color__WEBPACK_IMPORTED_MODULE_1__["Color"])(0xCCCCCC);
var Description = 'Gives every polymer residue a color based on its `seq_id` value.';
var SequenceIdColorThemeParams = {
    list: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_2__["ParamDefinition"].ColorList('turbo', { presetKind: 'scale' }),
};
function getSequenceIdColorThemeParams(ctx) {
    return SequenceIdColorThemeParams; // TODO return copy
}
function getSeqId(unit, element) {
    var model = unit.model;
    switch (unit.kind) {
        case 0 /* Atomic */:
            var residueIndex = model.atomicHierarchy.residueAtomSegments.index[element];
            return model.atomicHierarchy.residues.label_seq_id.value(residueIndex);
        case 1 /* Spheres */:
            return Math.round((model.coarseHierarchy.spheres.seq_id_begin.value(element) +
                model.coarseHierarchy.spheres.seq_id_end.value(element)) / 2);
        case 2 /* Gaussians */:
            return Math.round((model.coarseHierarchy.gaussians.seq_id_begin.value(element) +
                model.coarseHierarchy.gaussians.seq_id_end.value(element)) / 2);
    }
}
function getSequenceLength(unit, element) {
    var model = unit.model;
    var entityId = '';
    switch (unit.kind) {
        case 0 /* Atomic */:
            var chainIndex = model.atomicHierarchy.chainAtomSegments.index[element];
            entityId = model.atomicHierarchy.chains.label_entity_id.value(chainIndex);
            break;
        case 1 /* Spheres */:
            entityId = model.coarseHierarchy.spheres.entity_id.value(element);
            break;
        case 2 /* Gaussians */:
            entityId = model.coarseHierarchy.gaussians.entity_id.value(element);
            break;
    }
    if (entityId === '')
        return 0;
    var entityIndex = model.entities.getEntityIndex(entityId);
    if (entityIndex === -1)
        return 0;
    var entity = model.sequence.byEntityKey[entityIndex];
    if (entity === undefined)
        return 0;
    return entity.sequence.length;
}
function SequenceIdColorTheme(ctx, props) {
    var scale = _mol_util_color__WEBPACK_IMPORTED_MODULE_1__["ColorScale"].create({
        listOrName: props.list.colors,
        minLabel: 'Start',
        maxLabel: 'End',
    });
    var color = function (location) {
        if (_mol_model_structure__WEBPACK_IMPORTED_MODULE_0__["StructureElement"].Location.is(location)) {
            var unit = location.unit, element = location.element;
            var seq_id = getSeqId(unit, element);
            if (seq_id > 0) {
                var seqLen = getSequenceLength(unit, element);
                if (seqLen) {
                    scale.setDomain(0, seqLen - 1);
                    return scale.color(seq_id);
                }
            }
        }
        else if (_mol_model_structure__WEBPACK_IMPORTED_MODULE_0__["Bond"].isLocation(location)) {
            var aUnit = location.aUnit, aIndex = location.aIndex;
            var seq_id = getSeqId(aUnit, aUnit.elements[aIndex]);
            if (seq_id > 0) {
                var seqLen = getSequenceLength(aUnit, aUnit.elements[aIndex]);
                if (seqLen) {
                    scale.setDomain(0, seqLen - 1);
                    return scale.color(seq_id);
                }
            }
        }
        return DefaultColor;
    };
    return {
        factory: SequenceIdColorTheme,
        granularity: 'group',
        color: color,
        props: props,
        description: Description,
        legend: scale ? scale.legend : undefined
    };
}
var SequenceIdColorThemeProvider = {
    name: 'sequence-id',
    label: 'Sequence Id',
    category: "Residue Property" /* Residue */,
    factory: SequenceIdColorTheme,
    getParams: getSequenceIdColorThemeParams,
    defaultValues: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_2__["ParamDefinition"].getDefaultValues(SequenceIdColorThemeParams),
    isApplicable: function (ctx) { return !!ctx.structure; }
};
//# sourceMappingURL=sequence-id.js.map

/***/ }),

/***/ "./lib/mol-theme/color/shape-group.js":
/*!********************************************!*\
  !*** ./lib/mol-theme/color/shape-group.js ***!
  \********************************************/
/*! exports provided: ShapeGroupColorThemeParams, getShapeGroupColorThemeParams, ShapeGroupColorTheme, ShapeGroupColorThemeProvider */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ShapeGroupColorThemeParams", function() { return ShapeGroupColorThemeParams; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getShapeGroupColorThemeParams", function() { return getShapeGroupColorThemeParams; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ShapeGroupColorTheme", function() { return ShapeGroupColorTheme; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ShapeGroupColorThemeProvider", function() { return ShapeGroupColorThemeProvider; });
/* harmony import */ var _mol_util_color__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../mol-util/color */ "./lib/mol-util/color/index.js");
/* harmony import */ var _mol_model_shape__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../mol-model/shape */ "./lib/mol-model/shape.js");
/* harmony import */ var _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../mol-util/param-definition */ "./lib/mol-util/param-definition.js");
/**
 * Copyright (c) 2018 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */



var DefaultColor = Object(_mol_util_color__WEBPACK_IMPORTED_MODULE_0__["Color"])(0xCCCCCC);
var Description = 'Assigns colors as defined by the shape object.';
var ShapeGroupColorThemeParams = {};
function getShapeGroupColorThemeParams(ctx) {
    return ShapeGroupColorThemeParams; // TODO return copy
}
function ShapeGroupColorTheme(ctx, props) {
    return {
        factory: ShapeGroupColorTheme,
        granularity: 'groupInstance',
        color: function (location) {
            if (_mol_model_shape__WEBPACK_IMPORTED_MODULE_1__["ShapeGroup"].isLocation(location)) {
                return location.shape.getColor(location.group, location.instance);
            }
            return DefaultColor;
        },
        props: props,
        description: Description
    };
}
var ShapeGroupColorThemeProvider = {
    name: 'shape-group',
    label: 'Shape Group',
    category: "Miscellaneous" /* Misc */,
    factory: ShapeGroupColorTheme,
    getParams: getShapeGroupColorThemeParams,
    defaultValues: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_2__["ParamDefinition"].getDefaultValues(ShapeGroupColorThemeParams),
    isApplicable: function (ctx) { return !!ctx.shape; }
};
//# sourceMappingURL=shape-group.js.map

/***/ }),

/***/ "./lib/mol-theme/color/uncertainty.js":
/*!********************************************!*\
  !*** ./lib/mol-theme/color/uncertainty.js ***!
  \********************************************/
/*! exports provided: UncertaintyColorThemeParams, getUncertaintyColorThemeParams, getUncertainty, UncertaintyColorTheme, UncertaintyColorThemeProvider */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "UncertaintyColorThemeParams", function() { return UncertaintyColorThemeParams; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getUncertaintyColorThemeParams", function() { return getUncertaintyColorThemeParams; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getUncertainty", function() { return getUncertainty; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "UncertaintyColorTheme", function() { return UncertaintyColorTheme; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "UncertaintyColorThemeProvider", function() { return UncertaintyColorThemeProvider; });
/* harmony import */ var _mol_util_color__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../mol-util/color */ "./lib/mol-util/color/index.js");
/* harmony import */ var _mol_model_structure__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../mol-model/structure */ "./lib/mol-model/structure.js");
/* harmony import */ var _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../mol-util/param-definition */ "./lib/mol-util/param-definition.js");
/**
 * Copyright (c) 2019 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */



var DefaultUncertaintyColor = Object(_mol_util_color__WEBPACK_IMPORTED_MODULE_0__["Color"])(0xffff99);
var Description = "Assigns a color based on the uncertainty or disorder of an element's position, e.g. B-factor or RMSF, depending on the data availability and experimental technique.";
var UncertaintyColorThemeParams = {
    domain: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_2__["ParamDefinition"].Interval([0, 100]),
    list: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_2__["ParamDefinition"].ColorList('red-white-blue', { presetKind: 'scale' }),
};
function getUncertaintyColorThemeParams(ctx) {
    return UncertaintyColorThemeParams; // TODO return copy
}
function getUncertainty(unit, element) {
    if (_mol_model_structure__WEBPACK_IMPORTED_MODULE_1__["Unit"].isAtomic(unit)) {
        return unit.model.atomicConformation.B_iso_or_equiv.value(element);
    }
    else if (_mol_model_structure__WEBPACK_IMPORTED_MODULE_1__["Unit"].isSpheres(unit)) {
        return unit.model.coarseConformation.spheres.rmsf[element];
    }
    else {
        return 0;
    }
}
function UncertaintyColorTheme(ctx, props) {
    var scale = _mol_util_color__WEBPACK_IMPORTED_MODULE_0__["ColorScale"].create({
        reverse: true,
        domain: props.domain,
        listOrName: props.list.colors,
    });
    // TODO calc domain based on data, set min/max as 10/90 percentile to be robust against outliers
    function color(location) {
        if (_mol_model_structure__WEBPACK_IMPORTED_MODULE_1__["StructureElement"].Location.is(location)) {
            return scale.color(getUncertainty(location.unit, location.element));
        }
        else if (_mol_model_structure__WEBPACK_IMPORTED_MODULE_1__["Bond"].isLocation(location)) {
            return scale.color(getUncertainty(location.aUnit, location.aUnit.elements[location.aIndex]));
        }
        return DefaultUncertaintyColor;
    }
    return {
        factory: UncertaintyColorTheme,
        granularity: 'group',
        color: color,
        props: props,
        description: Description,
        legend: scale ? scale.legend : undefined
    };
}
var UncertaintyColorThemeProvider = {
    name: 'uncertainty',
    label: 'Uncertainty/Disorder',
    category: "Atom Property" /* Atom */,
    factory: UncertaintyColorTheme,
    getParams: getUncertaintyColorThemeParams,
    defaultValues: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_2__["ParamDefinition"].getDefaultValues(UncertaintyColorThemeParams),
    isApplicable: function (ctx) { return !!ctx.structure && ctx.structure.models.some(function (m) { return m.atomicConformation.B_iso_or_equiv.isDefined || m.coarseHierarchy.isDefined; }); }
};
//# sourceMappingURL=uncertainty.js.map

/***/ }),

/***/ "./lib/mol-theme/color/uniform.js":
/*!****************************************!*\
  !*** ./lib/mol-theme/color/uniform.js ***!
  \****************************************/
/*! exports provided: UniformColorThemeParams, getUniformColorThemeParams, UniformColorTheme, UniformColorThemeProvider */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "UniformColorThemeParams", function() { return UniformColorThemeParams; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getUniformColorThemeParams", function() { return getUniformColorThemeParams; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "UniformColorTheme", function() { return UniformColorTheme; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "UniformColorThemeProvider", function() { return UniformColorThemeProvider; });
/* harmony import */ var _mol_util_color__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../mol-util/color */ "./lib/mol-util/color/index.js");
/* harmony import */ var _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../mol-util/param-definition */ "./lib/mol-util/param-definition.js");
/* harmony import */ var _mol_util_legend__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../mol-util/legend */ "./lib/mol-util/legend.js");
/* harmony import */ var _mol_util__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../mol-util */ "./lib/mol-util/index.js");
/**
 * Copyright (c) 2018-2019 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */




var DefaultColor = Object(_mol_util_color__WEBPACK_IMPORTED_MODULE_0__["Color"])(0xCCCCCC);
var Description = 'Gives everything the same, uniform color.';
var UniformColorThemeParams = {
    value: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_1__["ParamDefinition"].Color(DefaultColor),
};
function getUniformColorThemeParams(ctx) {
    return UniformColorThemeParams; // TODO return copy
}
function UniformColorTheme(ctx, props) {
    var color = Object(_mol_util__WEBPACK_IMPORTED_MODULE_3__["defaults"])(props.value, DefaultColor);
    return {
        factory: UniformColorTheme,
        granularity: 'uniform',
        color: function () { return color; },
        props: props,
        description: Description,
        legend: Object(_mol_util_legend__WEBPACK_IMPORTED_MODULE_2__["TableLegend"])([['uniform', color]])
    };
}
var UniformColorThemeProvider = {
    name: 'uniform',
    label: 'Uniform',
    category: "Miscellaneous" /* Misc */,
    factory: UniformColorTheme,
    getParams: getUniformColorThemeParams,
    defaultValues: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_1__["ParamDefinition"].getDefaultValues(UniformColorThemeParams),
    isApplicable: function (ctx) { return true; }
};
//# sourceMappingURL=uniform.js.map

/***/ }),

/***/ "./lib/mol-theme/color/unit-index.js":
/*!*******************************************!*\
  !*** ./lib/mol-theme/color/unit-index.js ***!
  \*******************************************/
/*! exports provided: UnitIndexColorThemeParams, getUnitIndexColorThemeParams, UnitIndexColorTheme, UnitIndexColorThemeProvider */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "UnitIndexColorThemeParams", function() { return UnitIndexColorThemeParams; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getUnitIndexColorThemeParams", function() { return getUnitIndexColorThemeParams; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "UnitIndexColorTheme", function() { return UnitIndexColorTheme; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "UnitIndexColorThemeProvider", function() { return UnitIndexColorThemeProvider; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _mol_util_color__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../mol-util/color */ "./lib/mol-util/color/index.js");
/* harmony import */ var _mol_model_structure__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../mol-model/structure */ "./lib/mol-model/structure.js");
/* harmony import */ var _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../mol-util/param-definition */ "./lib/mol-util/param-definition.js");
/* harmony import */ var _mol_util_color_palette__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../mol-util/color/palette */ "./lib/mol-util/color/palette.js");
/* harmony import */ var _mol_util_color_lists__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../mol-util/color/lists */ "./lib/mol-util/color/lists.js");
/**
 * Copyright (c) 2018-2019 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */






var DefaultList = 'dark-2';
var DefaultColor = Object(_mol_util_color__WEBPACK_IMPORTED_MODULE_1__["Color"])(0xCCCCCC);
var Description = 'Gives every chain instance (single chain or collection of single elements) a unique color based on the position (index) of the chain in the list of chains in the structure.';
var UnitIndexColorThemeParams = Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, Object(_mol_util_color_palette__WEBPACK_IMPORTED_MODULE_4__["getPaletteParams"])({ type: 'colors', colorList: DefaultList }));
function getUnitIndexColorThemeParams(ctx) {
    var params = _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_3__["ParamDefinition"].clone(UnitIndexColorThemeParams);
    if (ctx.structure) {
        if (ctx.structure.root.units.length > _mol_util_color_lists__WEBPACK_IMPORTED_MODULE_5__["ColorLists"][DefaultList].list.length) {
            params.palette.defaultValue.name = 'colors';
            params.palette.defaultValue.params = Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, params.palette.defaultValue.params), { list: { kind: 'interpolate', colors: Object(_mol_util_color_lists__WEBPACK_IMPORTED_MODULE_5__["getColorListFromName"])(DefaultList).list } });
        }
    }
    return params;
}
function UnitIndexColorTheme(ctx, props) {
    var color;
    var legend;
    if (ctx.structure) {
        var units = ctx.structure.root.units;
        var palette = Object(_mol_util_color_palette__WEBPACK_IMPORTED_MODULE_4__["getPalette"])(units.length, props);
        legend = palette.legend;
        var unitIdColor_1 = new Map();
        for (var i = 0, il = units.length; i < il; ++i) {
            unitIdColor_1.set(units[i].id, palette.color(i));
        }
        color = function (location) {
            if (_mol_model_structure__WEBPACK_IMPORTED_MODULE_2__["StructureElement"].Location.is(location)) {
                return unitIdColor_1.get(location.unit.id);
            }
            else if (_mol_model_structure__WEBPACK_IMPORTED_MODULE_2__["Bond"].isLocation(location)) {
                return unitIdColor_1.get(location.aUnit.id);
            }
            return DefaultColor;
        };
    }
    else {
        color = function () { return DefaultColor; };
    }
    return {
        factory: UnitIndexColorTheme,
        granularity: 'instance',
        color: color,
        props: props,
        description: Description,
        legend: legend
    };
}
var UnitIndexColorThemeProvider = {
    name: 'unit-index',
    label: 'Chain Instance',
    category: "Chain Property" /* Chain */,
    factory: UnitIndexColorTheme,
    getParams: getUnitIndexColorThemeParams,
    defaultValues: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_3__["ParamDefinition"].getDefaultValues(UnitIndexColorThemeParams),
    isApplicable: function (ctx) { return !!ctx.structure; }
};
//# sourceMappingURL=unit-index.js.map

/***/ }),

/***/ "./lib/mol-theme/label.js":
/*!********************************!*\
  !*** ./lib/mol-theme/label.js ***!
  \********************************/
/*! exports provided: DefaultLabelOptions, lociLabel, structureElementStatsLabel, bondLabel, bundleLabel, _bundleLabel, elementLabel, distanceLabel, angleLabel, dihedralLabel */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DefaultLabelOptions", function() { return DefaultLabelOptions; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "lociLabel", function() { return lociLabel; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "structureElementStatsLabel", function() { return structureElementStatsLabel; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "bondLabel", function() { return bondLabel; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "bundleLabel", function() { return bundleLabel; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_bundleLabel", function() { return _bundleLabel; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "elementLabel", function() { return elementLabel; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "distanceLabel", function() { return distanceLabel; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "angleLabel", function() { return angleLabel; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "dihedralLabel", function() { return dihedralLabel; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _mol_model_structure__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../mol-model/structure */ "./lib/mol-model/structure.js");
/* harmony import */ var _mol_model_loci__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../mol-model/loci */ "./lib/mol-model/loci.js");
/* harmony import */ var _mol_data_int__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../mol-data/int */ "./lib/mol-data/int.js");
/* harmony import */ var _mol_util_string__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../mol-util/string */ "./lib/mol-util/string.js");
/* harmony import */ var _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../mol-math/linear-algebra */ "./lib/mol-math/linear-algebra.js");
/* harmony import */ var _mol_math_misc__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../mol-math/misc */ "./lib/mol-math/misc.js");
/* harmony import */ var _mol_model_volume__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../mol-model/volume */ "./lib/mol-model/volume.js");
/**
 * Copyright (c) 2018-2020 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 * @author David Sehnal <david.sehnal@gmail.com>
 */








var DefaultLabelOptions = {
    granularity: 'element',
    condensed: false,
    reverse: false,
    countsOnly: false,
    hidePrefix: false,
    htmlStyling: true,
};
function lociLabel(loci, options) {
    if (options === void 0) { options = {}; }
    switch (loci.kind) {
        case 'structure-loci':
            return loci.structure.models.map(function (m) { return m.entry; }).filter(function (l) { return !!l; }).join(', ');
        case 'element-loci':
            return structureElementStatsLabel(_mol_model_structure__WEBPACK_IMPORTED_MODULE_1__["StructureElement"].Stats.ofLoci(loci), options);
        case 'bond-loci':
            var bond = loci.bonds[0];
            return bond ? bondLabel(bond) : '';
        case 'shape-loci':
            return loci.shape.name;
        case 'group-loci':
            var g = loci.groups[0];
            return g ? loci.shape.getLabel(_mol_data_int__WEBPACK_IMPORTED_MODULE_3__["OrderedSet"].start(g.ids), g.instance) : '';
        case 'every-loci':
            return 'Everything';
        case 'empty-loci':
            return 'Nothing';
        case 'data-loci':
            return loci.getLabel();
        case 'volume-loci':
            return loci.volume.label || 'Volume';
        case 'isosurface-loci':
            return [
                "" + (loci.volume.label || 'Volume'),
                "Isosurface at " + _mol_model_volume__WEBPACK_IMPORTED_MODULE_7__["Volume"].IsoValue.toString(loci.isoValue)
            ].join(' | ');
        case 'cell-loci':
            var size = _mol_data_int__WEBPACK_IMPORTED_MODULE_3__["OrderedSet"].size(loci.indices);
            var start = _mol_data_int__WEBPACK_IMPORTED_MODULE_3__["OrderedSet"].start(loci.indices);
            var absVal = _mol_model_volume__WEBPACK_IMPORTED_MODULE_7__["Volume"].IsoValue.absolute(loci.volume.grid.cells.data[start]);
            var relVal = _mol_model_volume__WEBPACK_IMPORTED_MODULE_7__["Volume"].IsoValue.toRelative(absVal, loci.volume.grid.stats);
            var label = [
                "" + (loci.volume.label || 'Volume'),
                "" + (size === 1 ? "Cell #" + start : size + " Cells")
            ];
            if (size === 1) {
                label.push(_mol_model_volume__WEBPACK_IMPORTED_MODULE_7__["Volume"].IsoValue.toString(absVal) + " (" + _mol_model_volume__WEBPACK_IMPORTED_MODULE_7__["Volume"].IsoValue.toString(relVal) + ")");
            }
            return label.join(' | ');
    }
}
function countLabel(count, label) {
    return count === 1 ? "1 " + label : count + " " + label + "s";
}
function otherLabel(count, location, granularity, hidePrefix, reverse, condensed) {
    return elementLabel(location, { granularity: granularity, hidePrefix: hidePrefix, reverse: reverse, condensed: condensed }) + " <small>[+ " + countLabel(count - 1, "other " + Object(_mol_util_string__WEBPACK_IMPORTED_MODULE_4__["capitalize"])(granularity)) + "]</small>";
}
/** Gets residue count of the model chain segments the unit is a subset of */
function getResidueCount(unit) {
    var elements = unit.elements, model = unit.model;
    var _a = model.atomicHierarchy, chainAtomSegments = _a.chainAtomSegments, residueAtomSegments = _a.residueAtomSegments;
    var elementStart = chainAtomSegments.offsets[chainAtomSegments.index[elements[0]]];
    var elementEnd = chainAtomSegments.offsets[chainAtomSegments.index[elements[elements.length - 1]] + 1] - 1;
    return residueAtomSegments.index[elementEnd] - residueAtomSegments.index[elementStart] + 1;
}
function structureElementStatsLabel(stats, options) {
    if (options === void 0) { options = {}; }
    var o = Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, DefaultLabelOptions), options);
    var label = _structureElementStatsLabel(stats, o.countsOnly, o.hidePrefix, o.condensed, o.reverse);
    return o.htmlStyling ? label : Object(_mol_util_string__WEBPACK_IMPORTED_MODULE_4__["stripTags"])(label);
}
function _structureElementStatsLabel(stats, countsOnly, hidePrefix, condensed, reverse) {
    if (countsOnly === void 0) { countsOnly = false; }
    if (hidePrefix === void 0) { hidePrefix = false; }
    if (condensed === void 0) { condensed = false; }
    if (reverse === void 0) { reverse = false; }
    var structureCount = stats.structureCount, chainCount = stats.chainCount, residueCount = stats.residueCount, conformationCount = stats.conformationCount, elementCount = stats.elementCount;
    if (!countsOnly && elementCount === 1 && residueCount === 0 && chainCount === 0) {
        return elementLabel(stats.firstElementLoc, { hidePrefix: hidePrefix, condensed: condensed, granularity: 'element', reverse: reverse });
    }
    else if (!countsOnly && elementCount === 0 && residueCount === 1 && chainCount === 0) {
        return elementLabel(stats.firstResidueLoc, { hidePrefix: hidePrefix, condensed: condensed, granularity: 'residue', reverse: reverse });
    }
    else if (!countsOnly && elementCount === 0 && residueCount === 0 && chainCount === 1) {
        var unit = stats.firstChainLoc.unit;
        var granularity = (_mol_model_structure__WEBPACK_IMPORTED_MODULE_1__["Unit"].isAtomic(unit) && getResidueCount(unit) === 1)
            ? 'residue' : _mol_model_structure__WEBPACK_IMPORTED_MODULE_1__["Unit"].Traits.is(unit.traits, 1 /* MultiChain */)
            ? 'residue' : 'chain';
        return elementLabel(stats.firstChainLoc, { hidePrefix: hidePrefix, condensed: condensed, granularity: granularity, reverse: reverse });
    }
    else if (!countsOnly) {
        var label = [];
        if (structureCount > 0) {
            label.push(structureCount === 1 ? elementLabel(stats.firstStructureLoc, { hidePrefix: hidePrefix, condensed: condensed, granularity: 'structure', reverse: reverse }) : otherLabel(structureCount, stats.firstStructureLoc, 'structure', hidePrefix, reverse, condensed));
        }
        if (chainCount > 0) {
            label.push(chainCount === 1 ? elementLabel(stats.firstChainLoc, { condensed: condensed, granularity: 'chain', hidePrefix: hidePrefix, reverse: reverse }) : otherLabel(chainCount, stats.firstChainLoc, 'chain', hidePrefix, reverse, condensed));
            hidePrefix = true;
        }
        if (residueCount > 0) {
            label.push(residueCount === 1 ? elementLabel(stats.firstResidueLoc, { condensed: condensed, granularity: 'residue', hidePrefix: hidePrefix, reverse: reverse }) : otherLabel(residueCount, stats.firstResidueLoc, 'residue', hidePrefix, reverse, condensed));
            hidePrefix = true;
        }
        if (conformationCount > 0) {
            label.push(conformationCount === 1 ? elementLabel(stats.firstConformationLoc, { condensed: condensed, granularity: 'conformation', hidePrefix: hidePrefix, reverse: reverse }) : otherLabel(conformationCount, stats.firstConformationLoc, 'conformation', hidePrefix, reverse, condensed));
            hidePrefix = true;
        }
        if (elementCount > 0) {
            label.push(elementCount === 1 ? elementLabel(stats.firstElementLoc, { condensed: condensed, granularity: 'element', hidePrefix: hidePrefix, reverse: reverse }) : otherLabel(elementCount, stats.firstElementLoc, 'element', hidePrefix, reverse, condensed));
        }
        return label.join('<small> + </small>');
    }
    else {
        var label = [];
        if (structureCount > 0)
            label.push(countLabel(structureCount, 'Structure'));
        if (chainCount > 0)
            label.push(countLabel(chainCount, 'Chain'));
        if (residueCount > 0)
            label.push(countLabel(residueCount, 'Residue'));
        if (conformationCount > 0)
            label.push(countLabel(conformationCount, 'Conformation'));
        if (elementCount > 0)
            label.push(countLabel(elementCount, 'Element'));
        return label.join('<small> + </small>');
    }
}
function bondLabel(bond, options) {
    if (options === void 0) { options = {}; }
    return bundleLabel({ loci: [
            _mol_model_structure__WEBPACK_IMPORTED_MODULE_1__["StructureElement"].Loci(bond.aStructure, [{ unit: bond.aUnit, indices: _mol_data_int__WEBPACK_IMPORTED_MODULE_3__["OrderedSet"].ofSingleton(bond.aIndex) }]),
            _mol_model_structure__WEBPACK_IMPORTED_MODULE_1__["StructureElement"].Loci(bond.bStructure, [{ unit: bond.bUnit, indices: _mol_data_int__WEBPACK_IMPORTED_MODULE_3__["OrderedSet"].ofSingleton(bond.bIndex) }])
        ] }, options);
}
function bundleLabel(bundle, options) {
    if (options === void 0) { options = {}; }
    var o = Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, DefaultLabelOptions), options);
    var label = _bundleLabel(bundle, o);
    return o.htmlStyling ? label : Object(_mol_util_string__WEBPACK_IMPORTED_MODULE_4__["stripTags"])(label);
}
function _bundleLabel(bundle, options) {
    var granularity = options.granularity, hidePrefix = options.hidePrefix, reverse = options.reverse, condensed = options.condensed;
    var isSingleElements = true;
    for (var _i = 0, _a = bundle.loci; _i < _a.length; _i++) {
        var l = _a[_i];
        if (!_mol_model_structure__WEBPACK_IMPORTED_MODULE_1__["StructureElement"].Loci.is(l) || _mol_model_structure__WEBPACK_IMPORTED_MODULE_1__["StructureElement"].Loci.size(l) !== 1) {
            isSingleElements = false;
            break;
        }
    }
    if (isSingleElements) {
        var locations = bundle.loci.map(function (l) {
            var _a = l.elements[0], unit = _a.unit, indices = _a.indices;
            return _mol_model_structure__WEBPACK_IMPORTED_MODULE_1__["StructureElement"].Location.create(l.structure, unit, unit.elements[_mol_data_int__WEBPACK_IMPORTED_MODULE_3__["OrderedSet"].start(indices)]);
        });
        var labels = locations.map(function (l) { return _elementLabel(l, granularity, hidePrefix, reverse || condensed); });
        if (condensed) {
            return labels.map(function (l) { return l[0].replace(/\[.*\]/g, '').trim(); }).filter(function (l) { return !!l; }).join(' \u2014 ');
        }
        var offset = 0;
        for (var i = 0, il = Math.min.apply(Math, labels.map(function (l) { return l.length; })) - 1; i < il; ++i) {
            var areIdentical = true;
            for (var j = 1, jl = labels.length; j < jl; ++j) {
                if (labels[0][i] !== labels[j][i]) {
                    areIdentical = false;
                    break;
                }
            }
            if (areIdentical)
                offset += 1;
            else
                break;
        }
        if (offset > 0) {
            var offsetLabels = [labels[0].join(' | ')];
            for (var j = 1, jl = labels.length; j < jl; ++j) {
                offsetLabels.push(labels[j].slice(offset).filter(function (l) { return !!l; }).join(' | '));
            }
            return offsetLabels.join(' \u2014 ');
        }
        else {
            return labels.map(function (l) { return l.filter(function (l) { return !!l; }).join(' | '); }).filter(function (l) { return !!l; }).join('</br>');
        }
    }
    else {
        var labels = bundle.loci.map(function (l) { return lociLabel(l, options); });
        return labels.filter(function (l) { return !!l; }).join(condensed ? ' \u2014 ' : '</br>');
    }
}
function elementLabel(location, options) {
    var _a, _b;
    if (options === void 0) { options = {}; }
    var o = Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, DefaultLabelOptions), options);
    var _label = _elementLabel(location, o.granularity, o.hidePrefix, o.reverse || o.condensed);
    // TODO: condensed label for single atom structure returns empty label.. handle this case here?
    var label = o.condensed ? (_b = (_a = _label[0]) === null || _a === void 0 ? void 0 : _a.replace(/\[.*\]/g, '').trim()) !== null && _b !== void 0 ? _b : '' : _label.filter(function (l) { return !!l; }).join(' | ');
    return o.htmlStyling ? label : Object(_mol_util_string__WEBPACK_IMPORTED_MODULE_4__["stripTags"])(label);
}
function _elementLabel(location, granularity, hidePrefix, reverse) {
    if (granularity === void 0) { granularity = 'element'; }
    if (hidePrefix === void 0) { hidePrefix = false; }
    if (reverse === void 0) { reverse = false; }
    var label = [];
    if (!hidePrefix) {
        var entry = location.unit.model.entry;
        if (entry.length > 30)
            entry = entry.substr(0, 27) + '\u2026'; // ellipsis
        label.push("<small>" + entry + "</small>"); // entry
        if (granularity !== 'structure') {
            label.push("<small>Model " + location.unit.model.modelNum + "</small>"); // model
            label.push("<small>Instance " + location.unit.conformation.operator.name + "</small>"); // instance
        }
    }
    if (_mol_model_structure__WEBPACK_IMPORTED_MODULE_1__["Unit"].isAtomic(location.unit)) {
        label.push.apply(label, _atomicElementLabel(location, granularity, reverse));
    }
    else if (_mol_model_structure__WEBPACK_IMPORTED_MODULE_1__["Unit"].isCoarse(location.unit)) {
        label.push.apply(label, _coarseElementLabel(location, granularity));
    }
    else {
        label.push('Unknown');
    }
    return reverse ? label.reverse() : label;
}
function _atomicElementLabel(location, granularity, hideOccupancy) {
    if (hideOccupancy === void 0) { hideOccupancy = false; }
    var rI = _mol_model_structure__WEBPACK_IMPORTED_MODULE_1__["StructureElement"].Location.residueIndex(location);
    var label_asym_id = _mol_model_structure__WEBPACK_IMPORTED_MODULE_1__["StructureProperties"].chain.label_asym_id(location);
    var auth_asym_id = _mol_model_structure__WEBPACK_IMPORTED_MODULE_1__["StructureProperties"].chain.auth_asym_id(location);
    var has_label_seq_id = location.unit.model.atomicHierarchy.residues.label_seq_id.valueKind(rI) === 0 /* Present */;
    var label_seq_id = _mol_model_structure__WEBPACK_IMPORTED_MODULE_1__["StructureProperties"].residue.label_seq_id(location);
    var auth_seq_id = _mol_model_structure__WEBPACK_IMPORTED_MODULE_1__["StructureProperties"].residue.auth_seq_id(location);
    var ins_code = _mol_model_structure__WEBPACK_IMPORTED_MODULE_1__["StructureProperties"].residue.pdbx_PDB_ins_code(location);
    var comp_id = _mol_model_structure__WEBPACK_IMPORTED_MODULE_1__["StructureProperties"].atom.label_comp_id(location);
    var atom_id = _mol_model_structure__WEBPACK_IMPORTED_MODULE_1__["StructureProperties"].atom.label_atom_id(location);
    var alt_id = _mol_model_structure__WEBPACK_IMPORTED_MODULE_1__["StructureProperties"].atom.label_alt_id(location);
    var occupancy = _mol_model_structure__WEBPACK_IMPORTED_MODULE_1__["StructureProperties"].atom.occupancy(location);
    var microHetCompIds = _mol_model_structure__WEBPACK_IMPORTED_MODULE_1__["StructureProperties"].residue.microheterogeneityCompIds(location);
    var compId = granularity === 'residue' && microHetCompIds.length > 1 ?
        "(" + microHetCompIds.join('|') + ")" : comp_id;
    var label = [];
    switch (granularity) {
        case 'element':
            label.push("<b>" + atom_id + "</b>" + (alt_id ? "%" + alt_id : ''));
        case 'conformation':
            if (granularity === 'conformation' && alt_id) {
                label.push("<small>Conformation</small> <b>" + alt_id + "</b>");
            }
        case 'residue':
            var seq_id = label_seq_id === auth_seq_id || !has_label_seq_id ? auth_seq_id : label_seq_id;
            label.push("<b>" + compId + " " + seq_id + "</b>" + (seq_id !== auth_seq_id ? " <small>[auth</small> <b>" + auth_seq_id + "</b><small>]</small>" : '') + "<b>" + (ins_code ? ins_code : '') + "</b>");
        case 'chain':
            if (label_asym_id === auth_asym_id) {
                label.push("<b>" + label_asym_id + "</b>");
            }
            else {
                if (granularity === 'chain' && _mol_model_structure__WEBPACK_IMPORTED_MODULE_1__["Unit"].Traits.is(location.unit.traits, 1 /* MultiChain */)) {
                    label.push("<small>[auth</small> <b>" + auth_asym_id + "</b><small>]</small>");
                }
                else {
                    label.push("<b>" + label_asym_id + "</b> <small>[auth</small> <b>" + auth_asym_id + "</b><small>]</small>");
                }
            }
    }
    if (label.length > 0 && occupancy !== 1 && !hideOccupancy) {
        label[0] = label[0] + " <small>[occupancy</small> <b>" + Math.round(100 * occupancy) / 100 + "</b><small>]</small>";
    }
    return label.reverse();
}
function _coarseElementLabel(location, granularity) {
    var asym_id = _mol_model_structure__WEBPACK_IMPORTED_MODULE_1__["StructureProperties"].coarse.asym_id(location);
    var seq_id_begin = _mol_model_structure__WEBPACK_IMPORTED_MODULE_1__["StructureProperties"].coarse.seq_id_begin(location);
    var seq_id_end = _mol_model_structure__WEBPACK_IMPORTED_MODULE_1__["StructureProperties"].coarse.seq_id_end(location);
    var label = [];
    switch (granularity) {
        case 'element':
        case 'conformation':
        case 'residue':
            if (seq_id_begin === seq_id_end) {
                var entityIndex = _mol_model_structure__WEBPACK_IMPORTED_MODULE_1__["StructureProperties"].coarse.entityKey(location);
                var seq = location.unit.model.sequence.byEntityKey[entityIndex];
                var comp_id = seq.sequence.compId.value(seq_id_begin - 1); // 1-indexed
                label.push("<b>" + comp_id + " " + seq_id_begin + "</b>");
            }
            else {
                label.push("<b>" + seq_id_begin + "-" + seq_id_end + "</b>");
            }
        case 'chain':
            label.push("<b>" + asym_id + "</b>");
    }
    return label.reverse();
}
//
function distanceLabel(pair, options) {
    if (options === void 0) { options = {}; }
    var o = Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, DefaultLabelOptions), { measureOnly: false, unitLabel: '\u212B' }), options);
    var _a = pair.loci.map(function (l) { return _mol_model_loci__WEBPACK_IMPORTED_MODULE_2__["Loci"].getCenter(l); }), cA = _a[0], cB = _a[1];
    var distance = _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_5__["Vec3"].distance(cA, cB).toFixed(2) + " " + o.unitLabel;
    if (o.measureOnly)
        return distance;
    var label = bundleLabel(pair, o);
    return o.condensed ? distance + " | " + label : "Distance " + distance + "</br>" + label;
}
function angleLabel(triple, options) {
    if (options === void 0) { options = {}; }
    var o = Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, DefaultLabelOptions), { measureOnly: false }), options);
    var _a = triple.loci.map(function (l) { return _mol_model_loci__WEBPACK_IMPORTED_MODULE_2__["Loci"].getCenter(l); }), cA = _a[0], cB = _a[1], cC = _a[2];
    var vAB = _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_5__["Vec3"].sub(Object(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_5__["Vec3"])(), cA, cB);
    var vCB = _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_5__["Vec3"].sub(Object(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_5__["Vec3"])(), cC, cB);
    var angle = Object(_mol_math_misc__WEBPACK_IMPORTED_MODULE_6__["radToDeg"])(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_5__["Vec3"].angle(vAB, vCB)).toFixed(2) + "\u00B0";
    if (o.measureOnly)
        return angle;
    var label = bundleLabel(triple, o);
    return o.condensed ? angle + " | " + label : "Angle " + angle + "</br>" + label;
}
function dihedralLabel(quad, options) {
    if (options === void 0) { options = {}; }
    var o = Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, DefaultLabelOptions), { measureOnly: false }), options);
    var _a = quad.loci.map(function (l) { return _mol_model_loci__WEBPACK_IMPORTED_MODULE_2__["Loci"].getCenter(l); }), cA = _a[0], cB = _a[1], cC = _a[2], cD = _a[3];
    var dihedral = Object(_mol_math_misc__WEBPACK_IMPORTED_MODULE_6__["radToDeg"])(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_5__["Vec3"].dihedralAngle(cA, cB, cC, cD)).toFixed(2) + "\u00B0";
    if (o.measureOnly)
        return dihedral;
    var label = bundleLabel(quad, o);
    return o.condensed ? dihedral + " | " + label : "Dihedral " + dihedral + "</br>" + label;
}
//# sourceMappingURL=label.js.map

/***/ }),

/***/ "./lib/mol-theme/overpaint.js":
/*!************************************!*\
  !*** ./lib/mol-theme/overpaint.js ***!
  \************************************/
/*! exports provided: Overpaint */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Overpaint", function() { return Overpaint; });
/* harmony import */ var _mol_model_loci__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../mol-model/loci */ "./lib/mol-model/loci.js");
/* harmony import */ var _mol_util_color__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../mol-util/color */ "./lib/mol-util/color/index.js");
/* harmony import */ var _mol_model_structure__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../mol-model/structure */ "./lib/mol-model/structure.js");
/* harmony import */ var _mol_script_script__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../mol-script/script */ "./lib/mol-script/script.js");
/**
 * Copyright (c) 2019-2020 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */





function Overpaint(layers) {
    return { layers: layers };
}
(function (Overpaint) {
    Overpaint.Empty = { layers: [] };
    function areEqual(oA, oB) {
        if (oA.layers.length === 0 && oB.layers.length === 0)
            return true;
        if (oA.layers.length !== oB.layers.length)
            return false;
        for (var i = 0, il = oA.layers.length; i < il; ++i) {
            if (oA.layers[i].clear !== oB.layers[i].clear)
                return false;
            if (oA.layers[i].color !== oB.layers[i].color)
                return false;
            if (!_mol_model_loci__WEBPACK_IMPORTED_MODULE_0__["Loci"].areEqual(oA.layers[i].loci, oB.layers[i].loci))
                return false;
        }
        return true;
    }
    Overpaint.areEqual = areEqual;
    function isEmpty(overpaint) {
        return overpaint.layers.length === 0;
    }
    Overpaint.isEmpty = isEmpty;
    function remap(overpaint, structure) {
        var layers = [];
        for (var _i = 0, _a = overpaint.layers; _i < _a.length; _i++) {
            var layer = _a[_i];
            var loci = layer.loci, color = layer.color, clear = layer.clear;
            loci = _mol_model_structure__WEBPACK_IMPORTED_MODULE_2__["StructureElement"].Loci.remap(loci, structure);
            if (!_mol_model_structure__WEBPACK_IMPORTED_MODULE_2__["StructureElement"].Loci.isEmpty(loci)) {
                layers.push({ loci: loci, color: color, clear: clear });
            }
        }
        return { layers: layers };
    }
    Overpaint.remap = remap;
    function merge(overpaint) {
        if (isEmpty(overpaint))
            return overpaint;
        var structure = overpaint.layers[0].loci.structure;
        var map = new Map();
        var shadowed = _mol_model_structure__WEBPACK_IMPORTED_MODULE_2__["StructureElement"].Loci.none(structure);
        for (var i = 0, il = overpaint.layers.length; i < il; ++i) {
            var _a = overpaint.layers[il - i - 1], loci = _a.loci, color = _a.color, clear = _a.clear; // process from end
            loci = _mol_model_structure__WEBPACK_IMPORTED_MODULE_2__["StructureElement"].Loci.subtract(loci, shadowed);
            shadowed = _mol_model_structure__WEBPACK_IMPORTED_MODULE_2__["StructureElement"].Loci.union(loci, shadowed);
            if (!_mol_model_structure__WEBPACK_IMPORTED_MODULE_2__["StructureElement"].Loci.isEmpty(loci)) {
                var colorOrClear = clear ? -1 : color;
                if (map.has(colorOrClear)) {
                    loci = _mol_model_structure__WEBPACK_IMPORTED_MODULE_2__["StructureElement"].Loci.union(loci, map.get(colorOrClear));
                }
                map.set(colorOrClear, loci);
            }
        }
        var layers = [];
        map.forEach(function (loci, colorOrClear) {
            var clear = colorOrClear === -1;
            var color = colorOrClear === -1 ? Object(_mol_util_color__WEBPACK_IMPORTED_MODULE_1__["Color"])(0) : colorOrClear;
            layers.push({ loci: loci, color: color, clear: clear });
        });
        return { layers: layers };
    }
    Overpaint.merge = merge;
    function filter(overpaint, filter) {
        if (isEmpty(overpaint))
            return overpaint;
        var structure = overpaint.layers[0].loci.structure;
        var layers = [];
        for (var _i = 0, _a = overpaint.layers; _i < _a.length; _i++) {
            var layer = _a[_i];
            var loci = layer.loci, color = layer.color, clear = layer.clear;
            // filter by first map to the `filter` structure and
            // then map back to the original structure of the overpaint loci
            var filtered = _mol_model_structure__WEBPACK_IMPORTED_MODULE_2__["StructureElement"].Loci.remap(loci, filter);
            loci = _mol_model_structure__WEBPACK_IMPORTED_MODULE_2__["StructureElement"].Loci.remap(filtered, structure);
            if (!_mol_model_structure__WEBPACK_IMPORTED_MODULE_2__["StructureElement"].Loci.isEmpty(loci)) {
                layers.push({ loci: loci, color: color, clear: clear });
            }
        }
        return { layers: layers };
    }
    Overpaint.filter = filter;
    function ofScript(scriptLayers, structure) {
        var layers = [];
        for (var i = 0, il = scriptLayers.length; i < il; ++i) {
            var _a = scriptLayers[i], script = _a.script, color = _a.color, clear = _a.clear;
            var loci = _mol_script_script__WEBPACK_IMPORTED_MODULE_3__["Script"].toLoci(script, structure);
            if (!_mol_model_structure__WEBPACK_IMPORTED_MODULE_2__["StructureElement"].Loci.isEmpty(loci)) {
                layers.push({ loci: loci, color: color, clear: clear });
            }
        }
        return { layers: layers };
    }
    Overpaint.ofScript = ofScript;
    function ofBundle(bundleLayers, structure) {
        var layers = [];
        for (var i = 0, il = bundleLayers.length; i < il; ++i) {
            var _a = bundleLayers[i], bundle = _a.bundle, color = _a.color, clear = _a.clear;
            var loci = _mol_model_structure__WEBPACK_IMPORTED_MODULE_2__["StructureElement"].Bundle.toLoci(bundle, structure.root);
            layers.push({ loci: loci, color: color, clear: clear });
        }
        return { layers: layers };
    }
    Overpaint.ofBundle = ofBundle;
    function toBundle(overpaint) {
        var layers = [];
        for (var i = 0, il = overpaint.layers.length; i < il; ++i) {
            var _a = overpaint.layers[i], loci = _a.loci, color = _a.color, clear = _a.clear;
            var bundle = _mol_model_structure__WEBPACK_IMPORTED_MODULE_2__["StructureElement"].Bundle.fromLoci(loci);
            layers.push({ bundle: bundle, color: color, clear: clear });
        }
        return { layers: layers };
    }
    Overpaint.toBundle = toBundle;
})(Overpaint || (Overpaint = {}));
//# sourceMappingURL=overpaint.js.map

/***/ }),

/***/ "./lib/mol-theme/size.js":
/*!*******************************!*\
  !*** ./lib/mol-theme/size.js ***!
  \*******************************/
/*! exports provided: SizeTheme */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SizeTheme", function() { return SizeTheme; });
/* harmony import */ var _size_uniform__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./size/uniform */ "./lib/mol-theme/size/uniform.js");
/* harmony import */ var _mol_theme_theme__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../mol-theme/theme */ "./lib/mol-theme/theme.js");
/* harmony import */ var _size_physical__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./size/physical */ "./lib/mol-theme/size/physical.js");
/* harmony import */ var _mol_util__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../mol-util */ "./lib/mol-util/index.js");
/* harmony import */ var _size_shape_group__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./size/shape-group */ "./lib/mol-theme/size/shape-group.js");
/* harmony import */ var _size_uncertainty__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./size/uncertainty */ "./lib/mol-theme/size/uncertainty.js");
/**
 * Copyright (c) 2018-2019 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */







var SizeTheme;
(function (SizeTheme) {
    SizeTheme.EmptyFactory = function () { return SizeTheme.Empty; };
    SizeTheme.Empty = { factory: SizeTheme.EmptyFactory, granularity: 'uniform', size: function () { return 1; }, props: {} };
    function areEqual(themeA, themeB) {
        return themeA.factory === themeB.factory && Object(_mol_util__WEBPACK_IMPORTED_MODULE_3__["deepEqual"])(themeA.props, themeB.props);
    }
    SizeTheme.areEqual = areEqual;
    SizeTheme.EmptyProvider = { name: '', label: '', category: '', factory: SizeTheme.EmptyFactory, getParams: function () { return ({}); }, defaultValues: {}, isApplicable: function () { return true; } };
    function createRegistry() {
        return new _mol_theme_theme__WEBPACK_IMPORTED_MODULE_1__["ThemeRegistry"](SizeTheme.BuiltIn, SizeTheme.EmptyProvider);
    }
    SizeTheme.createRegistry = createRegistry;
    SizeTheme.BuiltIn = {
        'physical': _size_physical__WEBPACK_IMPORTED_MODULE_2__["PhysicalSizeThemeProvider"],
        'shape-group': _size_shape_group__WEBPACK_IMPORTED_MODULE_4__["ShapeGroupSizeThemeProvider"],
        'uncertainty': _size_uncertainty__WEBPACK_IMPORTED_MODULE_5__["UncertaintySizeThemeProvider"],
        'uniform': _size_uniform__WEBPACK_IMPORTED_MODULE_0__["UniformSizeThemeProvider"]
    };
})(SizeTheme || (SizeTheme = {}));
//# sourceMappingURL=size.js.map

/***/ }),

/***/ "./lib/mol-theme/size/physical.js":
/*!****************************************!*\
  !*** ./lib/mol-theme/size/physical.js ***!
  \****************************************/
/*! exports provided: PhysicalSizeThemeParams, getPhysicalSizeThemeParams, getPhysicalRadius, PhysicalSizeTheme, PhysicalSizeThemeProvider */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "PhysicalSizeThemeParams", function() { return PhysicalSizeThemeParams; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getPhysicalSizeThemeParams", function() { return getPhysicalSizeThemeParams; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getPhysicalRadius", function() { return getPhysicalRadius; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "PhysicalSizeTheme", function() { return PhysicalSizeTheme; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "PhysicalSizeThemeProvider", function() { return PhysicalSizeThemeProvider; });
/* harmony import */ var _mol_model_structure__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../mol-model/structure */ "./lib/mol-model/structure.js");
/* harmony import */ var _mol_model_structure_model_properties_atomic__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../mol-model/structure/model/properties/atomic */ "./lib/mol-model/structure/model/properties/atomic.js");
/* harmony import */ var _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../mol-util/param-definition */ "./lib/mol-util/param-definition.js");
/**
 * Copyright (c) 2018 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */



var DefaultSize = 1;
var Description = 'Assigns a physical size, i.e. vdW radius for atoms or given radius for coarse spheres.';
var PhysicalSizeThemeParams = {
    scale: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_2__["ParamDefinition"].Numeric(1, { min: 0.1, max: 5, step: 0.1 })
};
function getPhysicalSizeThemeParams(ctx) {
    return PhysicalSizeThemeParams; // TODO return copy
}
function getPhysicalRadius(unit, element) {
    if (_mol_model_structure__WEBPACK_IMPORTED_MODULE_0__["Unit"].isAtomic(unit)) {
        return Object(_mol_model_structure_model_properties_atomic__WEBPACK_IMPORTED_MODULE_1__["VdwRadius"])(unit.model.atomicHierarchy.atoms.type_symbol.value(element));
    }
    else if (_mol_model_structure__WEBPACK_IMPORTED_MODULE_0__["Unit"].isSpheres(unit)) {
        return unit.model.coarseConformation.spheres.radius[element];
    }
    else {
        return 0;
    }
}
/**
 * Create attribute data with the physical size of an element,
 * i.e. vdw for atoms and radius for coarse spheres
 */
function PhysicalSizeTheme(ctx, props) {
    var scale = props.scale === void 0 ? 1 : props.scale;
    function size(location) {
        var size;
        if (_mol_model_structure__WEBPACK_IMPORTED_MODULE_0__["StructureElement"].Location.is(location)) {
            size = scale * getPhysicalRadius(location.unit, location.element);
        }
        else if (_mol_model_structure__WEBPACK_IMPORTED_MODULE_0__["Bond"].isLocation(location)) {
            size = scale * Math.min(getPhysicalRadius(location.aUnit, location.aUnit.elements[location.aIndex]), getPhysicalRadius(location.bUnit, location.bUnit.elements[location.bIndex]));
        }
        else {
            size = scale * DefaultSize;
        }
        return size;
    }
    return {
        factory: PhysicalSizeTheme,
        granularity: 'group',
        size: size,
        props: props,
        description: Description
    };
}
var PhysicalSizeThemeProvider = {
    name: 'physical',
    label: 'Physical',
    category: '',
    factory: PhysicalSizeTheme,
    getParams: getPhysicalSizeThemeParams,
    defaultValues: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_2__["ParamDefinition"].getDefaultValues(PhysicalSizeThemeParams),
    isApplicable: function (ctx) { return !!ctx.structure; }
};
//# sourceMappingURL=physical.js.map

/***/ }),

/***/ "./lib/mol-theme/size/shape-group.js":
/*!*******************************************!*\
  !*** ./lib/mol-theme/size/shape-group.js ***!
  \*******************************************/
/*! exports provided: ShapeGroupSizeThemeParams, getShapeGroupSizeThemeParams, ShapeGroupSizeTheme, ShapeGroupSizeThemeProvider */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ShapeGroupSizeThemeParams", function() { return ShapeGroupSizeThemeParams; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getShapeGroupSizeThemeParams", function() { return getShapeGroupSizeThemeParams; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ShapeGroupSizeTheme", function() { return ShapeGroupSizeTheme; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ShapeGroupSizeThemeProvider", function() { return ShapeGroupSizeThemeProvider; });
/* harmony import */ var _mol_model_shape__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../mol-model/shape */ "./lib/mol-model/shape.js");
/* harmony import */ var _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../mol-util/param-definition */ "./lib/mol-util/param-definition.js");
/**
 * Copyright (c) 2019 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */


var DefaultSize = 1;
var Description = 'Assigns sizes as defined by the shape object.';
var ShapeGroupSizeThemeParams = {};
function getShapeGroupSizeThemeParams(ctx) {
    return ShapeGroupSizeThemeParams; // TODO return copy
}
function ShapeGroupSizeTheme(ctx, props) {
    return {
        factory: ShapeGroupSizeTheme,
        granularity: 'groupInstance',
        size: function (location) {
            if (_mol_model_shape__WEBPACK_IMPORTED_MODULE_0__["ShapeGroup"].isLocation(location)) {
                return location.shape.getSize(location.group, location.instance);
            }
            return DefaultSize;
        },
        props: props,
        description: Description
    };
}
var ShapeGroupSizeThemeProvider = {
    name: 'shape-group',
    label: 'Shape Group',
    category: '',
    factory: ShapeGroupSizeTheme,
    getParams: getShapeGroupSizeThemeParams,
    defaultValues: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_1__["ParamDefinition"].getDefaultValues(ShapeGroupSizeThemeParams),
    isApplicable: function (ctx) { return !!ctx.shape; }
};
//# sourceMappingURL=shape-group.js.map

/***/ }),

/***/ "./lib/mol-theme/size/uncertainty.js":
/*!*******************************************!*\
  !*** ./lib/mol-theme/size/uncertainty.js ***!
  \*******************************************/
/*! exports provided: UncertaintySizeThemeParams, getUncertaintySizeThemeParams, getUncertainty, UncertaintySizeTheme, UncertaintySizeThemeProvider */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "UncertaintySizeThemeParams", function() { return UncertaintySizeThemeParams; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getUncertaintySizeThemeParams", function() { return getUncertaintySizeThemeParams; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getUncertainty", function() { return getUncertainty; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "UncertaintySizeTheme", function() { return UncertaintySizeTheme; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "UncertaintySizeThemeProvider", function() { return UncertaintySizeThemeProvider; });
/* harmony import */ var _mol_model_structure__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../mol-model/structure */ "./lib/mol-model/structure.js");
/* harmony import */ var _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../mol-util/param-definition */ "./lib/mol-util/param-definition.js");
/**
 * Copyright (c) 2019 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */


var Description = "Assigns a size reflecting the uncertainty or disorder of an element's position, e.g. B-factor or RMSF, depending on the data availability and experimental technique.";
var UncertaintySizeThemeParams = {
    bfactorFactor: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_1__["ParamDefinition"].Numeric(0.1, { min: 0, max: 1, step: 0.01 }),
    rmsfFactor: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_1__["ParamDefinition"].Numeric(0.05, { min: 0, max: 1, step: 0.01 }),
    baseSize: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_1__["ParamDefinition"].Numeric(0.2, { min: 0, max: 2, step: 0.1 }),
};
function getUncertaintySizeThemeParams(ctx) {
    return UncertaintySizeThemeParams; // TODO return copy
}
function getUncertainty(unit, element, props) {
    if (_mol_model_structure__WEBPACK_IMPORTED_MODULE_0__["Unit"].isAtomic(unit)) {
        return unit.model.atomicConformation.B_iso_or_equiv.value(element) * props.bfactorFactor;
    }
    else if (_mol_model_structure__WEBPACK_IMPORTED_MODULE_0__["Unit"].isSpheres(unit)) {
        return unit.model.coarseConformation.spheres.rmsf[element] * props.rmsfFactor;
    }
    else {
        return 0;
    }
}
function UncertaintySizeTheme(ctx, props) {
    function size(location) {
        var size = props.baseSize;
        if (_mol_model_structure__WEBPACK_IMPORTED_MODULE_0__["StructureElement"].Location.is(location)) {
            size += getUncertainty(location.unit, location.element, props);
        }
        else if (_mol_model_structure__WEBPACK_IMPORTED_MODULE_0__["Bond"].isLocation(location)) {
            size += getUncertainty(location.aUnit, location.aUnit.elements[location.aIndex], props);
        }
        return size;
    }
    return {
        factory: UncertaintySizeTheme,
        granularity: 'group',
        size: size,
        props: props,
        description: Description
    };
}
var UncertaintySizeThemeProvider = {
    name: 'uncertainty',
    label: 'Uncertainty/Disorder',
    category: '',
    factory: UncertaintySizeTheme,
    getParams: getUncertaintySizeThemeParams,
    defaultValues: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_1__["ParamDefinition"].getDefaultValues(UncertaintySizeThemeParams),
    isApplicable: function (ctx) { return !!ctx.structure && ctx.structure.models.some(function (m) { return m.atomicConformation.B_iso_or_equiv.isDefined || m.coarseHierarchy.isDefined; }); }
};
//# sourceMappingURL=uncertainty.js.map

/***/ }),

/***/ "./lib/mol-theme/size/uniform.js":
/*!***************************************!*\
  !*** ./lib/mol-theme/size/uniform.js ***!
  \***************************************/
/*! exports provided: UniformSizeThemeParams, getUniformSizeThemeParams, UniformSizeTheme, UniformSizeThemeProvider */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "UniformSizeThemeParams", function() { return UniformSizeThemeParams; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getUniformSizeThemeParams", function() { return getUniformSizeThemeParams; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "UniformSizeTheme", function() { return UniformSizeTheme; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "UniformSizeThemeProvider", function() { return UniformSizeThemeProvider; });
/* harmony import */ var _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../mol-util/param-definition */ "./lib/mol-util/param-definition.js");
/**
 * Copyright (c) 2018 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */

var Description = 'Gives everything the same, uniform size.';
var UniformSizeThemeParams = {
    value: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_0__["ParamDefinition"].Numeric(1, { min: 0, max: 20, step: 0.1 }),
};
function getUniformSizeThemeParams(ctx) {
    return UniformSizeThemeParams; // TODO return copy
}
function UniformSizeTheme(ctx, props) {
    var size = props.value;
    return {
        factory: UniformSizeTheme,
        granularity: 'uniform',
        size: function () { return size; },
        props: props,
        description: Description
    };
}
var UniformSizeThemeProvider = {
    name: 'uniform',
    label: 'Uniform',
    category: '',
    factory: UniformSizeTheme,
    getParams: getUniformSizeThemeParams,
    defaultValues: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_0__["ParamDefinition"].getDefaultValues(UniformSizeThemeParams),
    isApplicable: function (ctx) { return true; }
};
//# sourceMappingURL=uniform.js.map

/***/ }),

/***/ "./lib/mol-theme/theme.js":
/*!********************************!*\
  !*** ./lib/mol-theme/theme.js ***!
  \********************************/
/*! exports provided: Theme, ThemeRegistry */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Theme", function() { return Theme; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ThemeRegistry", function() { return ThemeRegistry; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _color__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./color */ "./lib/mol-theme/color.js");
/* harmony import */ var _size__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./size */ "./lib/mol-theme/size.js");
/* harmony import */ var _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../mol-util/param-definition */ "./lib/mol-util/param-definition.js");
/* harmony import */ var _mol_util_object__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../mol-util/object */ "./lib/mol-util/object.js");
/**
 * Copyright (c) 2018-2020 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */






var Theme;
(function (Theme) {
    function create(ctx, data, props, theme) {
        theme = theme || createEmpty();
        var colorProps = props.colorTheme;
        var sizeProps = props.sizeTheme;
        theme.color = ctx.colorThemeRegistry.create(colorProps.name, data, colorProps.params);
        theme.size = ctx.sizeThemeRegistry.create(sizeProps.name, data, sizeProps.params);
        return theme;
    }
    Theme.create = create;
    function createEmpty() {
        return { color: _color__WEBPACK_IMPORTED_MODULE_1__["ColorTheme"].Empty, size: _size__WEBPACK_IMPORTED_MODULE_2__["SizeTheme"].Empty };
    }
    Theme.createEmpty = createEmpty;
    function ensureDependencies(ctx, theme, data, props) {
        var _a, _b;
        return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"])(this, void 0, void 0, function () {
            return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__generator"])(this, function (_c) {
                switch (_c.label) {
                    case 0: return [4 /*yield*/, ((_a = theme.colorThemeRegistry.get(props.colorTheme.name).ensureCustomProperties) === null || _a === void 0 ? void 0 : _a.attach(ctx, data))];
                    case 1:
                        _c.sent();
                        return [4 /*yield*/, ((_b = theme.sizeThemeRegistry.get(props.sizeTheme.name).ensureCustomProperties) === null || _b === void 0 ? void 0 : _b.attach(ctx, data))];
                    case 2:
                        _c.sent();
                        return [2 /*return*/];
                }
            });
        });
    }
    Theme.ensureDependencies = ensureDependencies;
    function releaseDependencies(theme, data, props) {
        var _a, _b;
        (_a = theme.colorThemeRegistry.get(props.colorTheme.name).ensureCustomProperties) === null || _a === void 0 ? void 0 : _a.detach(data);
        (_b = theme.sizeThemeRegistry.get(props.sizeTheme.name).ensureCustomProperties) === null || _b === void 0 ? void 0 : _b.detach(data);
    }
    Theme.releaseDependencies = releaseDependencies;
})(Theme || (Theme = {}));
function getTypes(list) {
    return list.map(function (e) { return [e.name, e.provider.label, e.provider.category]; });
}
var ThemeRegistry = /** @class */ (function () {
    function ThemeRegistry(builtInThemes, emptyProvider) {
        var _this = this;
        this.emptyProvider = emptyProvider;
        this._list = [];
        this._map = new Map();
        this._name = new Map();
        Object(_mol_util_object__WEBPACK_IMPORTED_MODULE_4__["objectForEach"])(builtInThemes, function (p, k) {
            if (p.name !== k)
                throw new Error("Fix build in themes to have matching names. " + p.name + " " + k);
            _this.add(p);
        });
    }
    Object.defineProperty(ThemeRegistry.prototype, "default", {
        get: function () { return this._list[0]; },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ThemeRegistry.prototype, "list", {
        get: function () { return this._list; },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ThemeRegistry.prototype, "types", {
        get: function () { return getTypes(this._list); },
        enumerable: false,
        configurable: true
    });
    ThemeRegistry.prototype.sort = function () {
        this._list.sort(function (a, b) {
            if (a.provider.category === b.provider.category) {
                return a.provider.label < b.provider.label ? -1 : a.provider.label > b.provider.label ? 1 : 0;
            }
            return a.provider.category < b.provider.category ? -1 : 1;
        });
    };
    ThemeRegistry.prototype.add = function (provider) {
        if (this._map.has(provider.name)) {
            throw new Error(provider.name + " already registered.");
        }
        var name = provider.name;
        this._list.push({ name: name, provider: provider });
        this._map.set(name, provider);
        this._name.set(provider, name);
        this.sort();
    };
    ThemeRegistry.prototype.remove = function (provider) {
        this._list.splice(this._list.findIndex(function (e) { return e.name === provider.name; }), 1);
        var p = this._map.get(provider.name);
        if (p) {
            this._map.delete(provider.name);
            this._name.delete(p);
        }
    };
    ThemeRegistry.prototype.has = function (provider) {
        return this._map.has(provider.name);
    };
    ThemeRegistry.prototype.get = function (name) {
        return this._map.get(name) || this.emptyProvider;
    };
    ThemeRegistry.prototype.getName = function (provider) {
        if (!this._name.has(provider))
            throw new Error("'" + provider.label + "' is not a registered theme provider.");
        return this._name.get(provider);
    };
    ThemeRegistry.prototype.create = function (name, ctx, props) {
        if (props === void 0) { props = {}; }
        var provider = this.get(name);
        return provider.factory(ctx, Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_3__["ParamDefinition"].getDefaultValues(provider.getParams(ctx))), props));
    };
    ThemeRegistry.prototype.getApplicableList = function (ctx) {
        return this._list.filter(function (e) { return e.provider.isApplicable(ctx); });
    };
    ThemeRegistry.prototype.getApplicableTypes = function (ctx) {
        return getTypes(this.getApplicableList(ctx));
    };
    return ThemeRegistry;
}());

//# sourceMappingURL=theme.js.map

/***/ }),

/***/ "./lib/mol-theme/transparency.js":
/*!***************************************!*\
  !*** ./lib/mol-theme/transparency.js ***!
  \***************************************/
/*! exports provided: Transparency */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Transparency", function() { return Transparency; });
/* harmony import */ var _mol_model_loci__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../mol-model/loci */ "./lib/mol-model/loci.js");
/* harmony import */ var _mol_model_structure__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../mol-model/structure */ "./lib/mol-model/structure.js");
/* harmony import */ var _mol_script_script__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../mol-script/script */ "./lib/mol-script/script.js");
/**
 * Copyright (c) 2019-2020 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */




function Transparency(layers) {
    return { layers: layers };
}
(function (Transparency) {
    Transparency.Empty = { layers: [] };
    function areEqual(tA, tB) {
        if (tA.layers.length === 0 && tB.layers.length === 0)
            return true;
        if (tA.layers.length !== tB.layers.length)
            return false;
        for (var i = 0, il = tA.layers.length; i < il; ++i) {
            if (tA.layers[i].value !== tB.layers[i].value)
                return false;
            if (!_mol_model_loci__WEBPACK_IMPORTED_MODULE_0__["Loci"].areEqual(tA.layers[i].loci, tB.layers[i].loci))
                return false;
        }
        return true;
    }
    Transparency.areEqual = areEqual;
    function isEmpty(transparency) {
        return transparency.layers.length === 0;
    }
    Transparency.isEmpty = isEmpty;
    function remap(transparency, structure) {
        var layers = [];
        for (var _i = 0, _a = transparency.layers; _i < _a.length; _i++) {
            var layer = _a[_i];
            var loci = layer.loci, value = layer.value;
            loci = _mol_model_structure__WEBPACK_IMPORTED_MODULE_1__["StructureElement"].Loci.remap(loci, structure);
            if (!_mol_model_structure__WEBPACK_IMPORTED_MODULE_1__["StructureElement"].Loci.isEmpty(loci)) {
                layers.push({ loci: loci, value: value });
            }
        }
        return { layers: layers };
    }
    Transparency.remap = remap;
    function merge(transparency) {
        if (isEmpty(transparency))
            return transparency;
        var structure = transparency.layers[0].loci.structure;
        var map = new Map();
        var shadowed = _mol_model_structure__WEBPACK_IMPORTED_MODULE_1__["StructureElement"].Loci.none(structure);
        for (var i = 0, il = transparency.layers.length; i < il; ++i) {
            var _a = transparency.layers[il - i - 1], loci = _a.loci, value = _a.value; // process from end
            loci = _mol_model_structure__WEBPACK_IMPORTED_MODULE_1__["StructureElement"].Loci.subtract(loci, shadowed);
            shadowed = _mol_model_structure__WEBPACK_IMPORTED_MODULE_1__["StructureElement"].Loci.union(loci, shadowed);
            if (!_mol_model_structure__WEBPACK_IMPORTED_MODULE_1__["StructureElement"].Loci.isEmpty(loci)) {
                if (map.has(value)) {
                    loci = _mol_model_structure__WEBPACK_IMPORTED_MODULE_1__["StructureElement"].Loci.union(loci, map.get(value));
                }
                map.set(value, loci);
            }
        }
        var layers = [];
        map.forEach(function (loci, value) {
            layers.push({ loci: loci, value: value });
        });
        return { layers: layers };
    }
    Transparency.merge = merge;
    function filter(transparency, filter) {
        if (isEmpty(transparency))
            return transparency;
        var structure = transparency.layers[0].loci.structure;
        var layers = [];
        for (var _i = 0, _a = transparency.layers; _i < _a.length; _i++) {
            var layer = _a[_i];
            var loci = layer.loci, value = layer.value;
            // filter by first map to the `filter` structure and
            // then map back to the original structure of the transparency loci
            var filtered = _mol_model_structure__WEBPACK_IMPORTED_MODULE_1__["StructureElement"].Loci.remap(loci, filter);
            loci = _mol_model_structure__WEBPACK_IMPORTED_MODULE_1__["StructureElement"].Loci.remap(filtered, structure);
            if (!_mol_model_structure__WEBPACK_IMPORTED_MODULE_1__["StructureElement"].Loci.isEmpty(loci)) {
                layers.push({ loci: loci, value: value });
            }
        }
        return { layers: layers };
    }
    Transparency.filter = filter;
    function ofScript(scriptLayers, structure) {
        var layers = [];
        for (var i = 0, il = scriptLayers.length; i < il; ++i) {
            var _a = scriptLayers[i], script = _a.script, value = _a.value;
            var loci = _mol_script_script__WEBPACK_IMPORTED_MODULE_2__["Script"].toLoci(script, structure);
            if (!_mol_model_structure__WEBPACK_IMPORTED_MODULE_1__["StructureElement"].Loci.isEmpty(loci)) {
                layers.push({ loci: loci, value: value });
            }
        }
        return { layers: layers };
    }
    Transparency.ofScript = ofScript;
    function ofBundle(bundleLayers, structure) {
        var layers = [];
        for (var i = 0, il = bundleLayers.length; i < il; ++i) {
            var _a = bundleLayers[i], bundle = _a.bundle, value = _a.value;
            var loci = _mol_model_structure__WEBPACK_IMPORTED_MODULE_1__["StructureElement"].Bundle.toLoci(bundle, structure.root);
            layers.push({ loci: loci, value: value });
        }
        return { layers: layers };
    }
    Transparency.ofBundle = ofBundle;
    function toBundle(transparency) {
        var layers = [];
        for (var i = 0, il = transparency.layers.length; i < il; ++i) {
            var _a = transparency.layers[i], loci = _a.loci, value = _a.value;
            var bundle = _mol_model_structure__WEBPACK_IMPORTED_MODULE_1__["StructureElement"].Bundle.fromLoci(loci);
            layers.push({ bundle: bundle, value: value });
        }
        return { layers: layers };
    }
    Transparency.toBundle = toBundle;
})(Transparency || (Transparency = {}));
//# sourceMappingURL=transparency.js.map

/***/ }),

/***/ "./lib/mol-util/array.js":
/*!*******************************!*\
  !*** ./lib/mol-util/array.js ***!
  \*******************************/
/*! exports provided: arrayMax, arrayMin, arrayMinMax, arraySum, arrayMean, arrayRms, fillSerial, arrayRemoveInPlace, arrayRemoveAtInPlace, arraySetAdd, arraySetRemove, arrayEqual, arrayIsIdentity, arrayMapUpsert */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "arrayMax", function() { return arrayMax; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "arrayMin", function() { return arrayMin; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "arrayMinMax", function() { return arrayMinMax; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "arraySum", function() { return arraySum; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "arrayMean", function() { return arrayMean; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "arrayRms", function() { return arrayRms; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fillSerial", function() { return fillSerial; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "arrayRemoveInPlace", function() { return arrayRemoveInPlace; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "arrayRemoveAtInPlace", function() { return arrayRemoveAtInPlace; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "arraySetAdd", function() { return arraySetAdd; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "arraySetRemove", function() { return arraySetRemove; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "arrayEqual", function() { return arrayEqual; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "arrayIsIdentity", function() { return arrayIsIdentity; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "arrayMapUpsert", function() { return arrayMapUpsert; });
/**
 * Copyright (c) 2018-2019 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */
// TODO move to mol-math as Vector???
/** Get the maximum value in an array */
function arrayMax(array) {
    var max = -Infinity;
    for (var i = 0, il = array.length; i < il; ++i) {
        if (array[i] > max)
            max = array[i];
    }
    return max;
}
/** Get the minimum value in an array */
function arrayMin(array) {
    var min = Infinity;
    for (var i = 0, il = array.length; i < il; ++i) {
        if (array[i] < min)
            min = array[i];
    }
    return min;
}
/** Get the minimum & maximum value in an array */
function arrayMinMax(array) {
    var min = Infinity;
    var max = -Infinity;
    for (var i = 0, il = array.length; i < il; ++i) {
        if (array[i] < min)
            min = array[i];
        if (array[i] > max)
            max = array[i];
    }
    return [min, max];
}
/** Get the sum of values in an array */
function arraySum(array, stride, offset) {
    if (stride === void 0) { stride = 1; }
    if (offset === void 0) { offset = 0; }
    var n = array.length;
    var sum = 0;
    for (var i = offset; i < n; i += stride) {
        sum += array[i];
    }
    return sum;
}
/** Get the mean of values in an array */
function arrayMean(array, stride, offset) {
    if (stride === void 0) { stride = 1; }
    if (offset === void 0) { offset = 0; }
    return arraySum(array, stride, offset) / (array.length / stride);
}
/** Get the root mean square of values in an array */
function arrayRms(array) {
    var n = array.length;
    var sumSq = 0;
    for (var i = 0; i < n; ++i) {
        var di = array[i];
        sumSq += di * di;
    }
    return Math.sqrt(sumSq / n);
}
/** Fill an array with serial numbers starting from 0 until n - 1 (defaults to array.length) */
function fillSerial(array, n) {
    for (var i = 0, il = n ? Math.min(n, array.length) : array.length; i < il; ++i)
        array[i] = i;
    return array;
}
function arrayRemoveInPlace(xs, x) {
    var i = 0, l = xs.length, found = false;
    for (; i < l; i++) {
        if (xs[i] === x) {
            found = true;
            break;
        }
    }
    if (!found)
        return false;
    arrayRemoveAtInPlace(xs, i);
    return true;
}
function arrayRemoveAtInPlace(xs, idx) {
    for (var i = idx, _i = xs.length - 1; i < _i; i++) {
        xs[i] = xs[i + 1];
    }
    xs.pop();
}
function arraySetAdd(xs, x) {
    if (xs.indexOf(x) >= 0)
        return false;
    xs.push(x);
    return true;
}
function arraySetRemove(xs, x) {
    var idx = xs.indexOf(x);
    if (idx < 0)
        return false;
    for (var i = idx, _i = xs.length - 1; i < _i; i++) {
        xs[i] = xs[i + 1];
    }
    xs.pop();
    return true;
}
function arrayEqual(xs, ys) {
    if (!xs || xs.length === 0)
        return !ys || ys.length === 0;
    if (!ys)
        return false;
    var lenX = xs.length;
    if (lenX !== ys.length)
        return false;
    for (var i = 0; i < lenX; i++) {
        if (xs[i] !== ys[i])
            return false;
    }
    return true;
}
function arrayIsIdentity(xs) {
    for (var i = 0, _i = xs.length; i < _i; i++) {
        if (xs[i] !== i)
            return false;
    }
    return true;
}
function arrayMapUpsert(xs, key, value) {
    for (var i = 0, il = xs.length; i < il; ++i) {
        if (xs[i][0] === key) {
            xs[i][1] = value;
            return;
        }
    }
    xs.push([key, value]);
}
//# sourceMappingURL=array.js.map

/***/ }),

/***/ "./lib/mol-util/assets.js":
/*!********************************!*\
  !*** ./lib/mol-util/assets.js ***!
  \********************************/
/*! exports provided: AssetManager, Asset */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "AssetManager", function() { return AssetManager; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Asset", function() { return Asset; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _uuid__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./uuid */ "./lib/mol-util/uuid.js");
/* harmony import */ var _mol_data_util__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../mol-data/util */ "./lib/mol-data/util.js");
/* harmony import */ var _data_source__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./data-source */ "./lib/mol-util/data-source.js");
/* harmony import */ var _mol_task__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../mol-task */ "./lib/mol-task/index.js");
/**
 * Copyright (c) 2020 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author David Sehnal <david.sehnal@gmail.com>
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */






var Asset;
(function (Asset) {
    function Url(url, options) {
        return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({ kind: 'url', id: _uuid__WEBPACK_IMPORTED_MODULE_1__["default"].create22(), url: url }, options);
    }
    Asset.Url = Url;
    function File(file) {
        return { kind: 'file', id: _uuid__WEBPACK_IMPORTED_MODULE_1__["default"].create22(), name: file.name, file: file };
    }
    Asset.File = File;
    function isUrl(x) {
        return (x === null || x === void 0 ? void 0 : x.kind) === 'url';
    }
    Asset.isUrl = isUrl;
    function isFile(x) {
        return (x === null || x === void 0 ? void 0 : x.kind) === 'file';
    }
    Asset.isFile = isFile;
    function Wrapper(data, asset, manager) {
        return {
            data: data,
            dispose: function () {
                manager.release(asset);
            }
        };
    }
    Asset.Wrapper = Wrapper;
    function getUrl(url) {
        return typeof url === 'string' ? url : url.url;
    }
    Asset.getUrl = getUrl;
    function getUrlAsset(manager, url, body) {
        if (typeof url === 'string') {
            var asset = manager.tryFindUrl(url, body);
            return asset || Url(url, { body: body });
        }
        return url;
    }
    Asset.getUrlAsset = getUrlAsset;
})(Asset || (Asset = {}));
var AssetManager = /** @class */ (function () {
    function AssetManager() {
        // TODO: add URL based ref-counted cache?
        // TODO: when serializing, check for duplicates?
        this._assets = new Map();
    }
    Object.defineProperty(AssetManager.prototype, "assets", {
        get: function () {
            return Object(_mol_data_util__WEBPACK_IMPORTED_MODULE_2__["iterableToArray"])(this._assets.values());
        },
        enumerable: false,
        configurable: true
    });
    AssetManager.prototype.tryFindUrl = function (url, body) {
        var assets = this.assets.values();
        while (true) {
            var v = assets.next();
            if (v.done)
                return;
            var asset = v.value.asset;
            if (Asset.isUrl(asset) && asset.url === url && (asset.body || '') === (body || ''))
                return asset;
        }
    };
    AssetManager.prototype.set = function (asset, file) {
        this._assets.set(asset.id, { asset: asset, file: file, refCount: 0 });
    };
    AssetManager.prototype.resolve = function (asset, type, store) {
        var _this = this;
        if (store === void 0) { store = true; }
        if (Asset.isUrl(asset)) {
            return _mol_task__WEBPACK_IMPORTED_MODULE_4__["Task"].create("Download " + (asset.title || asset.url), function (ctx) { return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"])(_this, void 0, void 0, function () {
                var entry, _a, _b, _c, _d, data, file, _e, _f;
                return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__generator"])(this, function (_g) {
                    switch (_g.label) {
                        case 0:
                            if (!this._assets.has(asset.id)) return [3 /*break*/, 2];
                            entry = this._assets.get(asset.id);
                            entry.refCount++;
                            _b = (_a = Asset).Wrapper;
                            return [4 /*yield*/, Object(_data_source__WEBPACK_IMPORTED_MODULE_3__["readFromFile"])(entry.file, type).runInContext(ctx)];
                        case 1: return [2 /*return*/, _b.apply(_a, [_g.sent(), asset, this])];
                        case 2:
                            if (!!store) return [3 /*break*/, 4];
                            _d = (_c = Asset).Wrapper;
                            return [4 /*yield*/, Object(_data_source__WEBPACK_IMPORTED_MODULE_3__["ajaxGet"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, asset), { type: type })).runInContext(ctx)];
                        case 3: return [2 /*return*/, _d.apply(_c, [_g.sent(), asset, this])];
                        case 4: return [4 /*yield*/, Object(_data_source__WEBPACK_IMPORTED_MODULE_3__["ajaxGet"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, asset), { type: 'binary' })).runInContext(ctx)];
                        case 5:
                            data = _g.sent();
                            file = new File([data], 'raw-data');
                            this._assets.set(asset.id, { asset: asset, file: file, refCount: 1 });
                            _f = (_e = Asset).Wrapper;
                            return [4 /*yield*/, Object(_data_source__WEBPACK_IMPORTED_MODULE_3__["readFromFile"])(file, type).runInContext(ctx)];
                        case 6: return [2 /*return*/, _f.apply(_e, [_g.sent(), asset, this])];
                    }
                });
            }); });
        }
        else {
            return _mol_task__WEBPACK_IMPORTED_MODULE_4__["Task"].create("Read " + asset.name, function (ctx) { return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"])(_this, void 0, void 0, function () {
                var entry, _a, _b, _c, _d;
                return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__generator"])(this, function (_e) {
                    switch (_e.label) {
                        case 0:
                            if (!this._assets.has(asset.id)) return [3 /*break*/, 2];
                            entry = this._assets.get(asset.id);
                            entry.refCount++;
                            _b = (_a = Asset).Wrapper;
                            return [4 /*yield*/, Object(_data_source__WEBPACK_IMPORTED_MODULE_3__["readFromFile"])(entry.file, type).runInContext(ctx)];
                        case 1: return [2 /*return*/, _b.apply(_a, [_e.sent(), asset, this])];
                        case 2:
                            if (!(asset.file instanceof File)) {
                                throw new Error("Cannot resolve file asset '" + asset.name + "' (" + asset.id + ")");
                            }
                            if (store) {
                                this._assets.set(asset.id, { asset: asset, file: asset.file, refCount: 1 });
                            }
                            _d = (_c = Asset).Wrapper;
                            return [4 /*yield*/, Object(_data_source__WEBPACK_IMPORTED_MODULE_3__["readFromFile"])(asset.file, type).runInContext(ctx)];
                        case 3: return [2 /*return*/, _d.apply(_c, [_e.sent(), asset, this])];
                    }
                });
            }); });
        }
    };
    AssetManager.prototype.release = function (asset) {
        var entry = this._assets.get(asset.id);
        if (!entry)
            return;
        entry.refCount--;
        if (entry.refCount <= 0)
            this._assets.delete(asset.id);
    };
    return AssetManager;
}());
//# sourceMappingURL=assets.js.map

/***/ }),

/***/ "./lib/mol-util/async-queue.js":
/*!*************************************!*\
  !*** ./lib/mol-util/async-queue.js ***!
  \*************************************/
/*! exports provided: AsyncQueue */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "AsyncQueue", function() { return AsyncQueue; });
/* harmony import */ var _array__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./array */ "./lib/mol-util/array.js");
/* harmony import */ var rxjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! rxjs */ "./node_modules/rxjs/_esm5/index.js");
/**
 * Copyright (c) 2019 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author David Sehnal <david.sehnal@gmail.com>
 */


var AsyncQueue = /** @class */ (function () {
    function AsyncQueue() {
        this.queue = [];
        this.signal = new rxjs__WEBPACK_IMPORTED_MODULE_1__["Subject"]();
    }
    Object.defineProperty(AsyncQueue.prototype, "length", {
        get: function () { return this.queue.length; },
        enumerable: false,
        configurable: true
    });
    AsyncQueue.prototype.enqueue = function (v) {
        this.queue.push(v);
        if (this.queue.length === 1)
            return true;
        return this.waitFor(v);
    };
    AsyncQueue.prototype.handled = function (v) {
        Object(_array__WEBPACK_IMPORTED_MODULE_0__["arrayRemoveInPlace"])(this.queue, v);
        if (this.queue.length > 0) {
            this.signal.next({ v: this.queue[0], stillPresent: true });
        }
    };
    AsyncQueue.prototype.remove = function (v) {
        var rem = Object(_array__WEBPACK_IMPORTED_MODULE_0__["arrayRemoveInPlace"])(this.queue, v);
        if (rem)
            this.signal.next({ v: v, stillPresent: false });
        return rem;
    };
    AsyncQueue.prototype.waitFor = function (t) {
        var _this = this;
        return new Promise(function (res) {
            var sub = _this.signal.subscribe(function (_a) {
                var v = _a.v, removed = _a.stillPresent;
                if (v === t) {
                    sub.unsubscribe();
                    res(removed);
                }
            });
        });
    };
    return AsyncQueue;
}());

//# sourceMappingURL=async-queue.js.map

/***/ }),

/***/ "./lib/mol-util/binding.js":
/*!*********************************!*\
  !*** ./lib/mol-util/binding.js ***!
  \*********************************/
/*! exports provided: Binding */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Binding", function() { return Binding; });
/* harmony import */ var _input_input_observer__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./input/input-observer */ "./lib/mol-util/input/input-observer.js");
/* harmony import */ var _string__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./string */ "./lib/mol-util/string.js");
/**
 * Copyright (c) 2019 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */



function Binding(triggers, action, description) {
    if (action === void 0) { action = ''; }
    if (description === void 0) { description = ''; }
    return Binding.create(triggers, action, description);
}
(function (Binding) {
    function create(triggers, action, description) {
        if (action === void 0) { action = ''; }
        if (description === void 0) { description = ''; }
        return { triggers: triggers, action: action, description: description };
    }
    Binding.create = create;
    Binding.Empty = { triggers: [], action: '', description: '' };
    function isEmpty(binding) {
        return binding.triggers.length === 0 ||
            binding.triggers.every(function (t) { return t.buttons === undefined && t.modifiers === undefined; });
    }
    Binding.isEmpty = isEmpty;
    function match(binding, buttons, modifiers) {
        return binding.triggers.some(function (t) { return Trigger.match(t, buttons, modifiers); });
    }
    Binding.match = match;
    function formatTriggers(binding) {
        return binding.triggers.map(Trigger.format).join(' or ');
    }
    Binding.formatTriggers = formatTriggers;
    function format(binding, name) {
        if (name === void 0) { name = ''; }
        var help = binding.description || Object(_string__WEBPACK_IMPORTED_MODULE_1__["stringToWords"])(name);
        return Object(_string__WEBPACK_IMPORTED_MODULE_1__["interpolate"])(help, { triggers: '<i>' + formatTriggers(binding) + '</i>' });
    }
    Binding.format = format;
    function Trigger(buttons, modifiers) {
        return Trigger.create(buttons, modifiers);
    }
    Binding.Trigger = Trigger;
    (function (Trigger) {
        function create(buttons, modifiers) {
            return { buttons: buttons, modifiers: modifiers };
        }
        Trigger.create = create;
        Trigger.Empty = {};
        function match(trigger, buttons, modifiers) {
            var b = trigger.buttons, m = trigger.modifiers;
            return b !== undefined &&
                (b === buttons || _input_input_observer__WEBPACK_IMPORTED_MODULE_0__["ButtonsType"].has(b, buttons)) &&
                (!m || _input_input_observer__WEBPACK_IMPORTED_MODULE_0__["ModifiersKeys"].areEqual(m, modifiers));
        }
        Trigger.match = match;
        function format(trigger) {
            var s = [];
            var b = formatButtons(trigger.buttons);
            if (b)
                s.push(b);
            var m = formatModifiers(trigger.modifiers);
            if (m)
                s.push(m);
            return s.join(' + ');
        }
        Trigger.format = format;
    })(Trigger = Binding.Trigger || (Binding.Trigger = {}));
})(Binding || (Binding = {}));
var B = _input_input_observer__WEBPACK_IMPORTED_MODULE_0__["ButtonsType"];
function formatButtons(buttons) {
    var s = [];
    if (buttons === undefined) {
        s.push('any mouse button');
    }
    else if (buttons === 0) {
        s.push('mouse hover');
    }
    else {
        if (B.has(buttons, 1 /* Primary */))
            s.push('left mouse button');
        if (B.has(buttons, 2 /* Secondary */))
            s.push('right mouse button');
        if (B.has(buttons, 4 /* Auxilary */))
            s.push('wheel/middle mouse button');
        if (B.has(buttons, 8 /* Forth */))
            s.push('three fingers');
    }
    return s.join(' + ');
}
function formatModifiers(modifiers, verbose) {
    var s = [];
    if (modifiers) {
        if (modifiers.alt)
            s.push('alt key');
        if (modifiers.control)
            s.push('control key');
        if (modifiers.meta)
            s.push('meta/command key');
        if (modifiers.shift)
            s.push('shift key');
        if (verbose && s.length === 0)
            s.push('no key');
    }
    else {
        if (verbose)
            s.push('any key');
    }
    return s.join(' + ');
}
//# sourceMappingURL=binding.js.map

/***/ }),

/***/ "./lib/mol-util/bit-flags.js":
/*!***********************************!*\
  !*** ./lib/mol-util/bit-flags.js ***!
  \***********************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/**
 * Copyright (c) 2017 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author David Sehnal <david.sehnal@gmail.com>
 */
var BitFlags;
(function (BitFlags) {
    function create(flags) { return flags; }
    BitFlags.create = create;
    function has(flags, flag) { return (flags & flag) !== 0; }
    BitFlags.has = has;
    /** toCheck must be non-zero */
    function hasAll(flags, toCheck) { return !!toCheck && (flags & toCheck) === toCheck; }
    BitFlags.hasAll = hasAll;
})(BitFlags || (BitFlags = {}));
/* harmony default export */ __webpack_exports__["default"] = (BitFlags);
//# sourceMappingURL=bit-flags.js.map

/***/ }),

/***/ "./lib/mol-util/color/color.js":
/*!*************************************!*\
  !*** ./lib/mol-util/color/color.js ***!
  \*************************************/
/*! exports provided: Color, ColorList, ColorTable, ColorMap, getAdjustedColorMap, ColorSwatch */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Color", function() { return Color; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ColorList", function() { return ColorList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ColorTable", function() { return ColorTable; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ColorMap", function() { return ColorMap; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getAdjustedColorMap", function() { return getAdjustedColorMap; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ColorSwatch", function() { return ColorSwatch; });
/* harmony import */ var _spaces_hcl__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./spaces/hcl */ "./lib/mol-util/color/spaces/hcl.js");
/* harmony import */ var _spaces_lab__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./spaces/lab */ "./lib/mol-util/color/spaces/lab.js");
/**
 * Copyright (c) 2018-2020 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */


function Color(hex) { return hex; }
(function (Color) {
    function toStyle(hexColor) {
        return "rgb(" + (hexColor >> 16 & 255) + ", " + (hexColor >> 8 & 255) + ", " + (hexColor & 255) + ")";
    }
    Color.toStyle = toStyle;
    function toHexString(hexColor) {
        return '0x' + ('000000' + hexColor.toString(16)).slice(-6);
    }
    Color.toHexString = toHexString;
    function toRgbString(hexColor) {
        return "RGB: " + Color.toRgb(hexColor).join(', ');
    }
    Color.toRgbString = toRgbString;
    function toRgb(hexColor) {
        return [hexColor >> 16 & 255, hexColor >> 8 & 255, hexColor & 255];
    }
    Color.toRgb = toRgb;
    function toRgbNormalized(hexColor) {
        return [(hexColor >> 16 & 255) / 255, (hexColor >> 8 & 255) / 255, (hexColor & 255) / 255];
    }
    Color.toRgbNormalized = toRgbNormalized;
    function fromRgb(r, g, b) {
        return ((r << 16) | (g << 8) | b);
    }
    Color.fromRgb = fromRgb;
    function fromNormalizedRgb(r, g, b) {
        return (((r * 255) << 16) | ((g * 255) << 8) | (b * 255));
    }
    Color.fromNormalizedRgb = fromNormalizedRgb;
    function fromArray(array, offset) {
        return fromRgb(array[offset], array[offset + 1], array[offset + 2]);
    }
    Color.fromArray = fromArray;
    function fromNormalizedArray(array, offset) {
        return fromNormalizedRgb(array[offset], array[offset + 1], array[offset + 2]);
    }
    Color.fromNormalizedArray = fromNormalizedArray;
    /** Copies hex color to rgb array */
    function toArray(hexColor, array, offset) {
        array[offset] = (hexColor >> 16 & 255);
        array[offset + 1] = (hexColor >> 8 & 255);
        array[offset + 2] = (hexColor & 255);
        return array;
    }
    Color.toArray = toArray;
    /** Copies normalized (0 to 1) hex color to rgb array */
    function toArrayNormalized(hexColor, array, offset) {
        array[offset] = (hexColor >> 16 & 255) / 255;
        array[offset + 1] = (hexColor >> 8 & 255) / 255;
        array[offset + 2] = (hexColor & 255) / 255;
        return array;
    }
    Color.toArrayNormalized = toArrayNormalized;
    /** Copies hex color to rgb vec3 */
    function toVec3(out, hexColor) {
        out[0] = (hexColor >> 16 & 255);
        out[1] = (hexColor >> 8 & 255);
        out[2] = (hexColor & 255);
        return out;
    }
    Color.toVec3 = toVec3;
    /** Copies normalized (0 to 1) hex color to rgb vec3 */
    function toVec3Normalized(out, hexColor) {
        out[0] = (hexColor >> 16 & 255) / 255;
        out[1] = (hexColor >> 8 & 255) / 255;
        out[2] = (hexColor & 255) / 255;
        return out;
    }
    Color.toVec3Normalized = toVec3Normalized;
    /** Linear interpolation between two colors in rgb space */
    function interpolate(c1, c2, t) {
        var r1 = c1 >> 16 & 255;
        var g1 = c1 >> 8 & 255;
        var b1 = c1 & 255;
        var r2 = c2 >> 16 & 255;
        var g2 = c2 >> 8 & 255;
        var b2 = c2 & 255;
        var r = r1 + (r2 - r1) * t;
        var g = g1 + (g2 - g1) * t;
        var b = b1 + (b2 - b1) * t;
        return ((r << 16) | (g << 8) | b);
    }
    Color.interpolate = interpolate;
    var tmpSaturateHcl = [0, 0, 0];
    function saturate(c, amount) {
        _spaces_hcl__WEBPACK_IMPORTED_MODULE_0__["Hcl"].fromColor(tmpSaturateHcl, c);
        return _spaces_hcl__WEBPACK_IMPORTED_MODULE_0__["Hcl"].toColor(_spaces_hcl__WEBPACK_IMPORTED_MODULE_0__["Hcl"].saturate(tmpSaturateHcl, tmpSaturateHcl, amount));
    }
    Color.saturate = saturate;
    function desaturate(c, amount) {
        return saturate(c, -amount);
    }
    Color.desaturate = desaturate;
    var tmpDarkenLab = [0, 0, 0];
    function darken(c, amount) {
        _spaces_lab__WEBPACK_IMPORTED_MODULE_1__["Lab"].fromColor(tmpDarkenLab, c);
        return _spaces_lab__WEBPACK_IMPORTED_MODULE_1__["Lab"].toColor(_spaces_lab__WEBPACK_IMPORTED_MODULE_1__["Lab"].darken(tmpDarkenLab, tmpDarkenLab, amount));
    }
    Color.darken = darken;
    function lighten(c, amount) {
        return darken(c, -amount);
    }
    Color.lighten = lighten;
    //
    function _sRGBToLinear(c) {
        return (c < 0.04045) ? c * 0.0773993808 : Math.pow(c * 0.9478672986 + 0.0521327014, 2.4);
    }
    function sRGBToLinear(c) {
        return fromNormalizedRgb(_sRGBToLinear((c >> 16 & 255) / 255), _sRGBToLinear((c >> 8 & 255) / 255), _sRGBToLinear((c & 255) / 255));
    }
    Color.sRGBToLinear = sRGBToLinear;
    function _linearToSRGB(c) {
        return (c < 0.0031308) ? c * 12.92 : 1.055 * (Math.pow(c, 0.41666)) - 0.055;
    }
    function linearToSRGB(c) {
        return fromNormalizedRgb(_linearToSRGB((c >> 16 & 255) / 255), _linearToSRGB((c >> 8 & 255) / 255), _linearToSRGB((c & 255) / 255));
    }
    Color.linearToSRGB = linearToSRGB;
})(Color || (Color = {}));
function ColorList(label, type, description, list) {
    return { label: label, description: description, list: list, type: type };
}
function ColorTable(o) { return o; }
function ColorMap(o) { return o; }
function getAdjustedColorMap(map, saturation, lightness) {
    var adjustedMap = {};
    for (var e in map) {
        var c = map[e];
        c = Color.saturate(c, saturation);
        c = Color.darken(c, -lightness);
        adjustedMap[e] = c;
    }
    return adjustedMap;
}
function ColorSwatch(l) { return l; }
//# sourceMappingURL=color.js.map

/***/ }),

/***/ "./lib/mol-util/color/distinct.js":
/*!****************************************!*\
  !*** ./lib/mol-util/color/distinct.js ***!
  \****************************************/
/*! exports provided: DistinctColorsParams, distinctColors */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DistinctColorsParams", function() { return DistinctColorsParams; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "distinctColors", function() { return distinctColors; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _spaces_lab__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./spaces/lab */ "./lib/mol-util/color/spaces/lab.js");
/* harmony import */ var _spaces_hcl__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./spaces/hcl */ "./lib/mol-util/color/spaces/hcl.js");
/* harmony import */ var _mol_util_object__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../mol-util/object */ "./lib/mol-util/object.js");
/* harmony import */ var _mol_util__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../mol-util */ "./lib/mol-util/index.js");
/* harmony import */ var _mol_util_array__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../mol-util/array */ "./lib/mol-util/array.js");
/* harmony import */ var _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../../mol-util/param-definition */ "./lib/mol-util/param-definition.js");
/**
 * Copyright (c) 2019 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 *
 * adapted from https://github.com/internalfx/distinct-colors (ISC License Copyright (c) 2015, InternalFX Inc.)
 * which is heavily inspired by http://tools.medialab.sciences-po.fr/iwanthue/
 */







var DistinctColorsParams = {
    hue: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_6__["ParamDefinition"].Interval([1, 360], { min: 0, max: 360, step: 1 }),
    chroma: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_6__["ParamDefinition"].Interval([40, 70], { min: 0, max: 100, step: 1 }),
    luminance: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_6__["ParamDefinition"].Interval([15, 85], { min: 0, max: 100, step: 1 }),
    clusteringStepCount: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_6__["ParamDefinition"].Numeric(50, { min: 10, max: 200, step: 1 }, { isHidden: true }),
    minSampleCount: _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_6__["ParamDefinition"].Numeric(800, { min: 100, max: 5000, step: 100 }, { isHidden: true })
};
function distance(colorA, colorB) {
    return Math.sqrt(Math.pow(Math.abs(colorA[0] - colorB[0]), 2) +
        Math.pow(Math.abs(colorA[1] - colorB[1]), 2) +
        Math.pow(Math.abs(colorA[2] - colorB[2]), 2));
}
var LabTolerance = 2;
var tmpCheckColorHcl = [0, 0, 0];
var tmpCheckColorLab = [0, 0, 0];
function checkColor(lab, props) {
    _spaces_lab__WEBPACK_IMPORTED_MODULE_1__["Lab"].toHcl(tmpCheckColorHcl, lab);
    // roundtrip to RGB for conversion tolerance testing
    _spaces_lab__WEBPACK_IMPORTED_MODULE_1__["Lab"].fromColor(tmpCheckColorLab, _spaces_lab__WEBPACK_IMPORTED_MODULE_1__["Lab"].toColor(lab));
    return (tmpCheckColorHcl[0] >= props.hue[0] &&
        tmpCheckColorHcl[0] <= props.hue[1] &&
        tmpCheckColorHcl[1] >= props.chroma[0] &&
        tmpCheckColorHcl[1] <= props.chroma[1] &&
        tmpCheckColorHcl[2] >= props.luminance[0] &&
        tmpCheckColorHcl[2] <= props.luminance[1] &&
        tmpCheckColorLab[0] >= (lab[0] - LabTolerance) &&
        tmpCheckColorLab[0] <= (lab[0] + LabTolerance) &&
        tmpCheckColorLab[1] >= (lab[1] - LabTolerance) &&
        tmpCheckColorLab[1] <= (lab[1] + LabTolerance) &&
        tmpCheckColorLab[2] >= (lab[2] - LabTolerance) &&
        tmpCheckColorLab[2] <= (lab[2] + LabTolerance));
}
function sortByContrast(colors) {
    var unsortedColors = colors.slice(0);
    var sortedColors = [unsortedColors.shift()];
    while (unsortedColors.length > 0) {
        var lastColor = sortedColors[sortedColors.length - 1];
        var nearest = 0;
        var maxDist = Number.MIN_SAFE_INTEGER;
        for (var i = 0; i < unsortedColors.length; ++i) {
            var dist = distance(lastColor, unsortedColors[i]);
            if (dist > maxDist) {
                maxDist = dist;
                nearest = i;
            }
        }
        sortedColors.push(unsortedColors.splice(nearest, 1)[0]);
    }
    return sortedColors;
}
function getSamples(count, p) {
    var samples = new Map();
    var rangeDivider = Math.cbrt(count) * 1.001;
    var hStep = (p.hue[1] - p.hue[0]) / rangeDivider;
    var cStep = (p.chroma[1] - p.chroma[0]) / rangeDivider;
    var lStep = (p.luminance[1] - p.luminance[0]) / rangeDivider;
    for (var h = p.hue[0]; h <= p.hue[1]; h += hStep) {
        for (var c = p.chroma[0]; c <= p.chroma[1]; c += cStep) {
            for (var l = p.luminance[0]; l <= p.luminance[1]; l += lStep) {
                var lab = _spaces_lab__WEBPACK_IMPORTED_MODULE_1__["Lab"].fromHcl(Object(_spaces_lab__WEBPACK_IMPORTED_MODULE_1__["Lab"])(), _spaces_hcl__WEBPACK_IMPORTED_MODULE_2__["Hcl"].create(h, c, l));
                if (checkColor(lab, p))
                    samples.set(lab.toString(), lab);
            }
        }
    }
    return Array.from(samples.values());
}
/**
 * Create a list of visually distinct colors
 */
function distinctColors(count, props) {
    if (props === void 0) { props = {}; }
    var p = Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, _mol_util_param_definition__WEBPACK_IMPORTED_MODULE_6__["ParamDefinition"].getDefaultValues(DistinctColorsParams)), props);
    if (count <= 0)
        return [];
    var samples = getSamples(Math.max(p.minSampleCount, count * 5), p);
    if (samples.length < count) {
        throw new Error('Not enough samples to generate distinct colors, increase sample count.');
    }
    var colors = [];
    var zonesProto = [];
    var sliceSize = Math.floor(samples.length / count);
    for (var i = 0; i < samples.length; i += sliceSize) {
        colors.push(samples[i]);
        zonesProto.push([]);
        if (colors.length >= count)
            break;
    }
    for (var step = 1; step <= p.clusteringStepCount; ++step) {
        var zones = Object(_mol_util_object__WEBPACK_IMPORTED_MODULE_3__["deepClone"])(zonesProto);
        // Find closest color for each sample
        for (var i = 0; i < samples.length; ++i) {
            var minDist = Number.MAX_SAFE_INTEGER;
            var nearest = 0;
            for (var j = 0; j < colors.length; j++) {
                var dist = distance(samples[i], colors[j]);
                if (dist < minDist) {
                    minDist = dist;
                    nearest = j;
                }
            }
            zones[nearest].push(samples[i]);
        }
        var lastColors = Object(_mol_util_object__WEBPACK_IMPORTED_MODULE_3__["deepClone"])(colors);
        for (var i = 0; i < zones.length; ++i) {
            var zone = zones[i];
            var size = zone.length;
            var Ls = [];
            var As = [];
            var Bs = [];
            for (var _i = 0, zone_1 = zone; _i < zone_1.length; _i++) {
                var sample = zone_1[_i];
                Ls.push(sample[0]);
                As.push(sample[1]);
                Bs.push(sample[2]);
            }
            var lAvg = Object(_mol_util_array__WEBPACK_IMPORTED_MODULE_5__["arraySum"])(Ls) / size;
            var aAvg = Object(_mol_util_array__WEBPACK_IMPORTED_MODULE_5__["arraySum"])(As) / size;
            var bAvg = Object(_mol_util_array__WEBPACK_IMPORTED_MODULE_5__["arraySum"])(Bs) / size;
            colors[i] = [lAvg, aAvg, bAvg];
        }
        if (Object(_mol_util__WEBPACK_IMPORTED_MODULE_4__["deepEqual"])(lastColors, colors))
            break;
    }
    return sortByContrast(colors).map(function (c) { return _spaces_lab__WEBPACK_IMPORTED_MODULE_1__["Lab"].toColor(c); });
}
//# sourceMappingURL=distinct.js.map

/***/ }),

/***/ "./lib/mol-util/color/index.js":
/*!*************************************!*\
  !*** ./lib/mol-util/color/index.js ***!
  \*************************************/
/*! exports provided: Color, ColorMap, ColorTable, ColorScale */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _color__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./color */ "./lib/mol-util/color/color.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Color", function() { return _color__WEBPACK_IMPORTED_MODULE_0__["Color"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ColorMap", function() { return _color__WEBPACK_IMPORTED_MODULE_0__["ColorMap"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ColorTable", function() { return _color__WEBPACK_IMPORTED_MODULE_0__["ColorTable"]; });

/* harmony import */ var _scale__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./scale */ "./lib/mol-util/color/scale.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ColorScale", function() { return _scale__WEBPACK_IMPORTED_MODULE_1__["ColorScale"]; });

/**
 * Copyright (c) 2018 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */


//# sourceMappingURL=index.js.map

/***/ }),

/***/ "./lib/mol-util/color/lists.js":
/*!*************************************!*\
  !*** ./lib/mol-util/color/lists.js ***!
  \*************************************/
/*! exports provided: ColorLists, ColorListNames, ColorListOptions, ColorListOptionsScale, ColorListOptionsSet, getColorListFromName */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ColorLists", function() { return ColorLists; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ColorListNames", function() { return ColorListNames; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ColorListOptions", function() { return ColorListOptions; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ColorListOptionsScale", function() { return ColorListOptionsScale; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ColorListOptionsSet", function() { return ColorListOptionsSet; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getColorListFromName", function() { return getColorListFromName; });
/* harmony import */ var _color__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./color */ "./lib/mol-util/color/color.js");
/* harmony import */ var _string__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../string */ "./lib/mol-util/string.js");
/**
 * Copyright (c) 2018-2019 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */


var ColorLists = {
    /**
     * Brewer Color Lists
     *
     * Copyright (c) 2002 Cynthia Brewer, Mark Harrower, and The Pennsylvania State University.
     * Licensed under the Apache License, Version 2.0 (the "License");
     */
    'orange-red': Object(_color__WEBPACK_IMPORTED_MODULE_0__["ColorList"])('Orange-Red', 'sequential', 'Orange-Red, sequential color scheme from ColorBrewer 2.0', [0xfff7ec, 0xfee8c8, 0xfdd49e, 0xfdbb84, 0xfc8d59, 0xef6548, 0xd7301f, 0xb30000, 0x7f0000]),
    'purple-blue': Object(_color__WEBPACK_IMPORTED_MODULE_0__["ColorList"])('Purple-Blue', 'sequential', 'Purple-Blue, sequential color scheme from ColorBrewer 2.0', [0xfff7fb, 0xece7f2, 0xd0d1e6, 0xa6bddb, 0x74a9cf, 0x3690c0, 0x0570b0, 0x045a8d, 0x023858]),
    'blue-purple': Object(_color__WEBPACK_IMPORTED_MODULE_0__["ColorList"])('Blue-Purple', 'sequential', 'Blue-Purple, sequential color scheme from ColorBrewer 2.0', [0xf7fcfd, 0xe0ecf4, 0xbfd3e6, 0x9ebcda, 0x8c96c6, 0x8c6bb1, 0x88419d, 0x810f7c, 0x4d004b]),
    'oranges': Object(_color__WEBPACK_IMPORTED_MODULE_0__["ColorList"])('Oranges', 'sequential', '', [0xfff5eb, 0xfee6ce, 0xfdd0a2, 0xfdae6b, 0xfd8d3c, 0xf16913, 0xd94801, 0xa63603, 0x7f2704]),
    'blue-green': Object(_color__WEBPACK_IMPORTED_MODULE_0__["ColorList"])('Blue-Green', 'sequential', '', [0xf7fcfd, 0xe5f5f9, 0xccece6, 0x99d8c9, 0x66c2a4, 0x41ae76, 0x238b45, 0x006d2c, 0x00441b]),
    'yellow-orange-brown': Object(_color__WEBPACK_IMPORTED_MODULE_0__["ColorList"])('Yellow-Orange-Brown', 'sequential', '', [0xffffe5, 0xfff7bc, 0xfee391, 0xfec44f, 0xfe9929, 0xec7014, 0xcc4c02, 0x993404, 0x662506]),
    'yellow-green': Object(_color__WEBPACK_IMPORTED_MODULE_0__["ColorList"])('Yellow-Green', 'sequential', '', [0xffffe5, 0xf7fcb9, 0xd9f0a3, 0xaddd8e, 0x78c679, 0x41ab5d, 0x238443, 0x006837, 0x004529]),
    'reds': Object(_color__WEBPACK_IMPORTED_MODULE_0__["ColorList"])('Reds', 'sequential', '', [0xfff5f0, 0xfee0d2, 0xfcbba1, 0xfc9272, 0xfb6a4a, 0xef3b2c, 0xcb181d, 0xa50f15, 0x67000d]),
    'red-purple': Object(_color__WEBPACK_IMPORTED_MODULE_0__["ColorList"])('Red-Purple', 'sequential', '', [0xfff7f3, 0xfde0dd, 0xfcc5c0, 0xfa9fb5, 0xf768a1, 0xdd3497, 0xae017e, 0x7a0177, 0x49006a]),
    'greens': Object(_color__WEBPACK_IMPORTED_MODULE_0__["ColorList"])('Greens', 'sequential', '', [0xf7fcf5, 0xe5f5e0, 0xc7e9c0, 0xa1d99b, 0x74c476, 0x41ab5d, 0x238b45, 0x006d2c, 0x00441b]),
    'yellow-green-blue': Object(_color__WEBPACK_IMPORTED_MODULE_0__["ColorList"])('Yellow-Green-Blue', 'sequential', '', [0xffffd9, 0xedf8b1, 0xc7e9b4, 0x7fcdbb, 0x41b6c4, 0x1d91c0, 0x225ea8, 0x253494, 0x081d58]),
    'purples': Object(_color__WEBPACK_IMPORTED_MODULE_0__["ColorList"])('Purples', 'sequential', '', [0xfcfbfd, 0xefedf5, 0xdadaeb, 0xbcbddc, 0x9e9ac8, 0x807dba, 0x6a51a3, 0x54278f, 0x3f007d]),
    'green-blue': Object(_color__WEBPACK_IMPORTED_MODULE_0__["ColorList"])('Green-Blue', 'sequential', '', [0xf7fcf0, 0xe0f3db, 0xccebc5, 0xa8ddb5, 0x7bccc4, 0x4eb3d3, 0x2b8cbe, 0x0868ac, 0x084081]),
    'greys': Object(_color__WEBPACK_IMPORTED_MODULE_0__["ColorList"])('Greys', 'sequential', '', [0xffffff, 0xf0f0f0, 0xd9d9d9, 0xbdbdbd, 0x969696, 0x737373, 0x525252, 0x252525, 0x000000]),
    'yellow-orange-red': Object(_color__WEBPACK_IMPORTED_MODULE_0__["ColorList"])('Yellow-Orange-Red', 'sequential', '', [0xffffcc, 0xffeda0, 0xfed976, 0xfeb24c, 0xfd8d3c, 0xfc4e2a, 0xe31a1c, 0xbd0026, 0x800026]),
    'purple-red': Object(_color__WEBPACK_IMPORTED_MODULE_0__["ColorList"])('Purple-Red', 'sequential', '', [0xf7f4f9, 0xe7e1ef, 0xd4b9da, 0xc994c7, 0xdf65b0, 0xe7298a, 0xce1256, 0x980043, 0x67001f]),
    'blues': Object(_color__WEBPACK_IMPORTED_MODULE_0__["ColorList"])('Blues', 'sequential', '', [0xf7fbff, 0xdeebf7, 0xc6dbef, 0x9ecae1, 0x6baed6, 0x4292c6, 0x2171b5, 0x08519c, 0x08306b]),
    'purple-blue-green': Object(_color__WEBPACK_IMPORTED_MODULE_0__["ColorList"])('Purple-Blue-Green', 'sequential', '', [0xfff7fb, 0xece2f0, 0xd0d1e6, 0xa6bddb, 0x67a9cf, 0x3690c0, 0x02818a, 0x016c59, 0x014636]),
    'spectral': Object(_color__WEBPACK_IMPORTED_MODULE_0__["ColorList"])('Spectral', 'diverging', '', [0x9e0142, 0xd53e4f, 0xf46d43, 0xfdae61, 0xfee08b, 0xffffbf, 0xe6f598, 0xabdda4, 0x66c2a5, 0x3288bd, 0x5e4fa2]),
    'red-yellow-green': Object(_color__WEBPACK_IMPORTED_MODULE_0__["ColorList"])('Red-Yellow-Green', 'diverging', '', [0xa50026, 0xd73027, 0xf46d43, 0xfdae61, 0xfee08b, 0xffffbf, 0xd9ef8b, 0xa6d96a, 0x66bd63, 0x1a9850, 0x006837]),
    'red-blue': Object(_color__WEBPACK_IMPORTED_MODULE_0__["ColorList"])('Red-Blue', 'diverging', '', [0x67001f, 0xb2182b, 0xd6604d, 0xf4a582, 0xfddbc7, 0xf7f7f7, 0xd1e5f0, 0x92c5de, 0x4393c3, 0x2166ac, 0x053061]),
    'pink-yellow-green': Object(_color__WEBPACK_IMPORTED_MODULE_0__["ColorList"])('Pink-Yellow-Green', 'diverging', '', [0x8e0152, 0xc51b7d, 0xde77ae, 0xf1b6da, 0xfde0ef, 0xf7f7f7, 0xe6f5d0, 0xb8e186, 0x7fbc41, 0x4d9221, 0x276419]),
    'purple-green': Object(_color__WEBPACK_IMPORTED_MODULE_0__["ColorList"])('Purple-Green', 'diverging', '', [0x40004b, 0x762a83, 0x9970ab, 0xc2a5cf, 0xe7d4e8, 0xf7f7f7, 0xd9f0d3, 0xa6dba0, 0x5aae61, 0x1b7837, 0x00441b]),
    'red-yellow-blue': Object(_color__WEBPACK_IMPORTED_MODULE_0__["ColorList"])('Red-Yellow-Blue', 'diverging', 'Red-Yellow-Blue, diverging color scheme from ColorBrewer 2.0', [0xa50026, 0xd73027, 0xf46d43, 0xfdae61, 0xfee090, 0xffffbf, 0xe0f3f8, 0xabd9e9, 0x74add1, 0x4575b4, 0x313695]),
    'brown-white-green': Object(_color__WEBPACK_IMPORTED_MODULE_0__["ColorList"])('Brown-White-Green', 'diverging', '', [0x543005, 0x8c510a, 0xbf812d, 0xdfc27d, 0xf6e8c3, 0xf5f5f5, 0xc7eae5, 0x80cdc1, 0x35978f, 0x01665e, 0x003c30]),
    'red-grey': Object(_color__WEBPACK_IMPORTED_MODULE_0__["ColorList"])('Red-Grey', 'diverging', '', [0x67001f, 0xb2182b, 0xd6604d, 0xf4a582, 0xfddbc7, 0xffffff, 0xe0e0e0, 0xbababa, 0x878787, 0x4d4d4d, 0x1a1a1a]),
    'orange-purple': Object(_color__WEBPACK_IMPORTED_MODULE_0__["ColorList"])('Orange-Purple', 'diverging', '', [0x7f3b08, 0xb35806, 0xe08214, 0xfdb863, 0xfee0b6, 0xf7f7f7, 0xd8daeb, 0xb2abd2, 0x8073ac, 0x542788, 0x2d004b]),
    'set-2': Object(_color__WEBPACK_IMPORTED_MODULE_0__["ColorList"])('Set-2', 'qualitative', '', [0x66c2a5, 0xfc8d62, 0x8da0cb, 0xe78ac3, 0xa6d854, 0xffd92f, 0xe5c494, 0xb3b3b3]),
    'accent': Object(_color__WEBPACK_IMPORTED_MODULE_0__["ColorList"])('Accent', 'qualitative', '', [0x7fc97f, 0xbeaed4, 0xfdc086, 0xffff99, 0x386cb0, 0xf0027f, 0xbf5b17, 0x666666]),
    'set-1': Object(_color__WEBPACK_IMPORTED_MODULE_0__["ColorList"])('Set-1', 'qualitative', '', [0xe41a1c, 0x377eb8, 0x4daf4a, 0x984ea3, 0xff7f00, 0xffff33, 0xa65628, 0xf781bf, 0x999999]),
    'set-3': Object(_color__WEBPACK_IMPORTED_MODULE_0__["ColorList"])('Set-3', 'qualitative', '', [0x8dd3c7, 0xffffb3, 0xbebada, 0xfb8072, 0x80b1d3, 0xfdb462, 0xb3de69, 0xfccde5, 0xd9d9d9, 0xbc80bd, 0xccebc5, 0xffed6f]),
    'dark-2': Object(_color__WEBPACK_IMPORTED_MODULE_0__["ColorList"])('Dark-2', 'qualitative', '', [0x1b9e77, 0xd95f02, 0x7570b3, 0xe7298a, 0x66a61e, 0xe6ab02, 0xa6761d, 0x666666]),
    'paired': Object(_color__WEBPACK_IMPORTED_MODULE_0__["ColorList"])('Paired', 'qualitative', '', [0xa6cee3, 0x1f78b4, 0xb2df8a, 0x33a02c, 0xfb9a99, 0xe31a1c, 0xfdbf6f, 0xff7f00, 0xcab2d6, 0x6a3d9a, 0xffff99, 0xb15928]),
    'pastel-2': Object(_color__WEBPACK_IMPORTED_MODULE_0__["ColorList"])('Pastel-2', 'qualitative', '', [0xb3e2cd, 0xfdcdac, 0xcbd5e8, 0xf4cae4, 0xe6f5c9, 0xfff2ae, 0xf1e2cc, 0xcccccc]),
    'pastel-1': Object(_color__WEBPACK_IMPORTED_MODULE_0__["ColorList"])('Pastel-1', 'qualitative', '', [0xfbb4ae, 0xb3cde3, 0xccebc5, 0xdecbe4, 0xfed9a6, 0xffffcc, 0xe5d8bd, 0xfddaec, 0xf2f2f2]),
    'many-distinct': Object(_color__WEBPACK_IMPORTED_MODULE_0__["ColorList"])('Many-Distinct', 'qualitative', '', [
        // dark-2
        0x1b9e77, 0xd95f02, 0x7570b3, 0xe7298a, 0x66a61e, 0xe6ab02, 0xa6761d, 0x666666,
        // set-1
        0xe41a1c, 0x377eb8, 0x4daf4a, 0x984ea3, 0xff7f00, 0xffff33, 0xa65628, 0xf781bf, 0x999999,
        // set-2
        0x66c2a5, 0xfc8d62, 0x8da0cb, 0xe78ac3, 0xa6d854, 0xffd92f, 0xe5c494, 0xb3b3b3
    ]),
    /**
     * Matplotlib colormaps, including various perceptually uniform shades, see https://bids.github.io/colormap/
     */
    'magma': Object(_color__WEBPACK_IMPORTED_MODULE_0__["ColorList"])('Magma', 'sequential', 'Perceptually uniform shades of black-red-white', [0x420f74, 0x4a1079, 0x52127c, 0x5a157e, 0x61187f, 0x691c80, 0x711f81, 0x792281, 0x812581, 0x892881, 0x912a80, 0x992d7f, 0xa12f7e, 0xa9327c, 0xb1357a, 0xb93778, 0xc23a75, 0xca3e72, 0xd1426e, 0xd9466a, 0xe04b66, 0xe65162, 0xec585f, 0xf0605d, 0xf4685b, 0xf7715b, 0xf97b5d, 0xfb8460, 0xfc8e63, 0xfd9768, 0xfda16e, 0xfeaa74, 0xfeb37b, 0xfebc82, 0xfec689, 0xfdcf92, 0xfdd89a, 0xfde1a3, 0xfceaac, 0xfcf3b5, 0xfbfcbf]),
    'inferno': Object(_color__WEBPACK_IMPORTED_MODULE_0__["ColorList"])('Inferno', 'sequential', 'Perceptually uniform shades of black-red-yellow', [0x480b6a, 0x500d6c, 0x58106d, 0x60136e, 0x68166e, 0x70196e, 0x781c6d, 0x801f6b, 0x88216a, 0x902468, 0x982765, 0xa02a62, 0xa72d5f, 0xaf315b, 0xb73456, 0xbe3852, 0xc53d4d, 0xcc4148, 0xd24742, 0xd94d3d, 0xde5337, 0xe45a31, 0xe8612b, 0xed6825, 0xf0701e, 0xf37918, 0xf68111, 0xf88a0b, 0xfa9306, 0xfb9d06, 0xfba60b, 0xfbb014, 0xfbb91e, 0xf9c32a, 0xf8cd37, 0xf5d745, 0xf3e056, 0xf1e968, 0xf1f27d, 0xf5f891, 0xfcfea4]),
    'plasma': Object(_color__WEBPACK_IMPORTED_MODULE_0__["ColorList"])('Plasma', 'sequential', 'Perceptually uniform shades of blue-red-yellow', [0x1b068c, 0x250591, 0x2f0495, 0x380499, 0x40039c, 0x49029f, 0x5101a2, 0x5901a4, 0x6100a6, 0x6800a7, 0x7000a8, 0x7801a8, 0x7f03a7, 0x8607a6, 0x8e0ca4, 0x9511a1, 0x9b179e, 0xa21c9a, 0xa82296, 0xae2791, 0xb42d8d, 0xb93388, 0xbe3883, 0xc33e7f, 0xc8447a, 0xcd4975, 0xd14f71, 0xd6556d, 0xda5a68, 0xde6064, 0xe26660, 0xe56c5b, 0xe97257, 0xec7853, 0xef7e4e, 0xf2854a, 0xf58b46, 0xf79241, 0xf9993d, 0xfaa039, 0xfca735, 0xfdaf31, 0xfdb62d, 0xfdbe29, 0xfdc626, 0xfcce25, 0xfad624, 0xf8df24, 0xf5e726, 0xf2f026, 0xeff821]),
    'viridis': Object(_color__WEBPACK_IMPORTED_MODULE_0__["ColorList"])('Viridis', 'sequential', 'Perceptually uniform shades of blue-green-yellow', [0x45085b, 0x470f62, 0x471669, 0x481d6f, 0x482374, 0x472a79, 0x46307d, 0x453681, 0x433c84, 0x414286, 0x3e4888, 0x3c4d8a, 0x3a538b, 0x37588c, 0x355d8c, 0x32628d, 0x30678d, 0x2e6c8e, 0x2c718e, 0x2a768e, 0x287a8e, 0x267f8e, 0x24848d, 0x23898d, 0x218d8c, 0x1f928c, 0x1e978a, 0x1e9b89, 0x1ea087, 0x20a585, 0x23a982, 0x28ae7f, 0x2eb27c, 0x35b778, 0x3dbb74, 0x45bf6f, 0x4fc369, 0x59c764, 0x64cb5d, 0x70ce56, 0x7cd24f, 0x88d547, 0x95d73f, 0xa2da37, 0xafdc2e, 0xbdde26, 0xcae01e, 0xd7e219, 0xe4e318, 0xf1e51c, 0xfde724]),
    'cividis': Object(_color__WEBPACK_IMPORTED_MODULE_0__["ColorList"])('Cividis', 'sequential', 'Perceptually uniform shades of blue-green-yellow, should look effectively identical to colorblind and non-colorblind users', [0x002c67, 0x003070, 0x083370, 0x16366f, 0x1f3a6e, 0x273d6d, 0x2e416c, 0x34446c, 0x39486c, 0x3f4b6b, 0x444f6b, 0x49526b, 0x4e566c, 0x52596c, 0x575d6d, 0x5b606e, 0x60646e, 0x64676f, 0x686b71, 0x6d6e72, 0x717273, 0x757575, 0x797977, 0x7e7d78, 0x838078, 0x878478, 0x8c8878, 0x918c77, 0x968f77, 0x9b9376, 0xa09775, 0xa59b73, 0xaa9f72, 0xafa370, 0xb4a76f, 0xb9ab6d, 0xbeb06a, 0xc4b468, 0xc9b865, 0xcebc62, 0xd4c15e, 0xd9c55a, 0xdfca56, 0xe4ce51, 0xead34c, 0xefd846, 0xf5dc3f, 0xfbe136, 0xfde737]),
    'twilight': Object(_color__WEBPACK_IMPORTED_MODULE_0__["ColorList"])('Twilight', 'sequential', 'Perceptually uniform shades of white-blue-black-red-white, cyclic', [0xdfd9e1, 0xd8d7dd, 0xced3d8, 0xc2cdd3, 0xb4c7ce, 0xa7c0ca, 0x9ab8c7, 0x8eb0c5, 0x83a8c3, 0x7a9fc2, 0x7297c0, 0x6b8ebf, 0x6684bd, 0x637bbb, 0x6171b9, 0x5f67b6, 0x5e5cb2, 0x5e51ad, 0x5d46a7, 0x5c3c9f, 0x5b3196, 0x58278b, 0x531e7d, 0x4d176e, 0x46135f, 0x3e1151, 0x381045, 0x32113b, 0x301336, 0x361138, 0x3e113c, 0x471240, 0x521445, 0x5e1749, 0x6a1a4d, 0x761e4f, 0x812350, 0x8b2a50, 0x95324f, 0x9d3a4f, 0xa5434f, 0xac4d50, 0xb25752, 0xb86155, 0xbc6c59, 0xc0775f, 0xc48267, 0xc78d70, 0xc9987b, 0xcca389, 0xceae97, 0xd2b8a6, 0xd6c1b5, 0xdacac4, 0xddd1d1, 0xe0d6db, 0xe1d8e1]),
    /**
     * https://ai.googleblog.com/2019/08/turbo-improved-rainbow-colormap-for.html
     */
    'turbo': Object(_color__WEBPACK_IMPORTED_MODULE_0__["ColorList"])('Turbo', 'sequential', 'Improved (smooth) rainbow colormap for visualization', [0x4a41b5, 0x4a58dd, 0x426ff2, 0x3987f9, 0x2f9df5, 0x28b2e9, 0x25c6d8, 0x27d7c4, 0x2ee5ae, 0x3bf098, 0x4df884, 0x62fd70, 0x7bfe5f, 0x95fb51, 0xaff444, 0xc8ea3a, 0xdedd32, 0xf0cc2c, 0xfeb927, 0xffa423, 0xff8e1f, 0xff761c, 0xf65f18, 0xe54813, 0xd0330e, 0xba2208, 0xa51403, 0x960d00]),
    /**
     * Other
     */
    'rainbow': Object(_color__WEBPACK_IMPORTED_MODULE_0__["ColorList"])('Rainbow', 'sequential', '', [0x3361E1, 0x35A845, 0xF9FF00, 0xEC8711, 0xBF2222]),
    'red-white-blue': Object(_color__WEBPACK_IMPORTED_MODULE_0__["ColorList"])('Red-White-Blue', 'diverging', '', [0xBF2222, 0xFFFFFF, 0x3361E1]),
    'blue-white-red': Object(_color__WEBPACK_IMPORTED_MODULE_0__["ColorList"])('Blue-White-Red', 'diverging', '', [0x3361E1, 0xFFFFFF, 0xBF2222]),
};
var ColorListNames = Object.keys(ColorLists);
var ColorListOptions = ColorListNames.map(function (n) { return [n, ColorLists[n].label, Object(_string__WEBPACK_IMPORTED_MODULE_1__["capitalize"])(ColorLists[n].type)]; });
var ColorListOptionsScale = ColorListOptions.filter(function (v) { return ColorLists[v[0]].type === 'diverging' || ColorLists[v[0]].type === 'sequential'; });
var ColorListOptionsSet = ColorListOptions.filter(function (v) { return ColorLists[v[0]].type === 'qualitative'; });
function getColorListFromName(name) {
    if (name in ColorLists)
        return ColorLists[name];
    console.warn("unknown color list named '" + name + "'");
    return ColorLists['red-yellow-blue'];
}
//# sourceMappingURL=lists.js.map

/***/ }),

/***/ "./lib/mol-util/color/names.js":
/*!*************************************!*\
  !*** ./lib/mol-util/color/names.js ***!
  \*************************************/
/*! exports provided: ColorNames, ColorNamesValueMap */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ColorNames", function() { return ColorNames; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ColorNamesValueMap", function() { return ColorNamesValueMap; });
/* harmony import */ var _color__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./color */ "./lib/mol-util/color/color.js");
/**
 * Copyright (c) 2018-2019 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */

/** X11 color names http://www.w3.org/TR/css3-color/#svg-color */
var ColorNames = Object(_color__WEBPACK_IMPORTED_MODULE_0__["ColorMap"])({
    aliceblue: 0xf0f8ff,
    antiquewhite: 0xfaebd7,
    aqua: 0x00ffff,
    aquamarine: 0x7fffd4,
    azure: 0xf0ffff,
    beige: 0xf5f5dc,
    bisque: 0xffe4c4,
    black: 0x000000,
    blanchedalmond: 0xffebcd,
    blue: 0x0000ff,
    blueviolet: 0x8a2be2,
    brown: 0xa52a2a,
    burlywood: 0xdeb887,
    cadetblue: 0x5f9ea0,
    chartreuse: 0x7fff00,
    chocolate: 0xd2691e,
    coral: 0xff7f50,
    cornflower: 0x6495ed,
    cornflowerblue: 0x6495ed,
    cornsilk: 0xfff8dc,
    crimson: 0xdc143c,
    cyan: 0x00ffff,
    darkblue: 0x00008b,
    darkcyan: 0x008b8b,
    darkgoldenrod: 0xb8860b,
    darkgray: 0xa9a9a9,
    darkgreen: 0x006400,
    darkgrey: 0xa9a9a9,
    darkkhaki: 0xbdb76b,
    darkmagenta: 0x8b008b,
    darkolivegreen: 0x556b2f,
    darkorange: 0xff8c00,
    darkorchid: 0x9932cc,
    darkred: 0x8b0000,
    darksalmon: 0xe9967a,
    darkseagreen: 0x8fbc8f,
    darkslateblue: 0x483d8b,
    darkslategray: 0x2f4f4f,
    darkslategrey: 0x2f4f4f,
    darkturquoise: 0x00ced1,
    darkviolet: 0x9400d3,
    deeppink: 0xff1493,
    deepskyblue: 0x00bfff,
    dimgray: 0x696969,
    dimgrey: 0x696969,
    dodgerblue: 0x1e90ff,
    firebrick: 0xb22222,
    floralwhite: 0xfffaf0,
    forestgreen: 0x228b22,
    fuchsia: 0xff00ff,
    gainsboro: 0xdcdcdc,
    ghostwhite: 0xf8f8ff,
    gold: 0xffd700,
    goldenrod: 0xdaa520,
    gray: 0x808080,
    green: 0x008000,
    greenyellow: 0xadff2f,
    grey: 0x808080,
    honeydew: 0xf0fff0,
    hotpink: 0xff69b4,
    indianred: 0xcd5c5c,
    indigo: 0x4b0082,
    ivory: 0xfffff0,
    khaki: 0xf0e68c,
    laserlemon: 0xffff54,
    lavender: 0xe6e6fa,
    lavenderblush: 0xfff0f5,
    lawngreen: 0x7cfc00,
    lemonchiffon: 0xfffacd,
    lightblue: 0xadd8e6,
    lightcoral: 0xf08080,
    lightcyan: 0xe0ffff,
    lightgoldenrod: 0xfafad2,
    lightgoldenrodyellow: 0xfafad2,
    lightgray: 0xd3d3d3,
    lightgreen: 0x90ee90,
    lightgrey: 0xd3d3d3,
    lightpink: 0xffb6c1,
    lightsalmon: 0xffa07a,
    lightseagreen: 0x20b2aa,
    lightskyblue: 0x87cefa,
    lightslategray: 0x778899,
    lightslategrey: 0x778899,
    lightsteelblue: 0xb0c4de,
    lightyellow: 0xffffe0,
    lime: 0x00ff00,
    limegreen: 0x32cd32,
    linen: 0xfaf0e6,
    magenta: 0xff00ff,
    maroon: 0x800000,
    maroon2: 0x7f0000,
    maroon3: 0xb03060,
    mediumaquamarine: 0x66cdaa,
    mediumblue: 0x0000cd,
    mediumorchid: 0xba55d3,
    mediumpurple: 0x9370db,
    mediumseagreen: 0x3cb371,
    mediumslateblue: 0x7b68ee,
    mediumspringgreen: 0x00fa9a,
    mediumturquoise: 0x48d1cc,
    mediumvioletred: 0xc71585,
    midnightblue: 0x191970,
    mintcream: 0xf5fffa,
    mistyrose: 0xffe4e1,
    moccasin: 0xffe4b5,
    navajowhite: 0xffdead,
    navy: 0x000080,
    oldlace: 0xfdf5e6,
    olive: 0x808000,
    olivedrab: 0x6b8e23,
    orange: 0xffa500,
    orangered: 0xff4500,
    orchid: 0xda70d6,
    palegoldenrod: 0xeee8aa,
    palegreen: 0x98fb98,
    paleturquoise: 0xafeeee,
    palevioletred: 0xdb7093,
    papayawhip: 0xffefd5,
    peachpuff: 0xffdab9,
    peru: 0xcd853f,
    pink: 0xffc0cb,
    plum: 0xdda0dd,
    powderblue: 0xb0e0e6,
    purple: 0x800080,
    purple2: 0x7f007f,
    purple3: 0xa020f0,
    rebeccapurple: 0x663399,
    red: 0xff0000,
    rosybrown: 0xbc8f8f,
    royalblue: 0x4169e1,
    saddlebrown: 0x8b4513,
    salmon: 0xfa8072,
    sandybrown: 0xf4a460,
    seagreen: 0x2e8b57,
    seashell: 0xfff5ee,
    sienna: 0xa0522d,
    silver: 0xc0c0c0,
    skyblue: 0x87ceeb,
    slateblue: 0x6a5acd,
    slategray: 0x708090,
    slategrey: 0x708090,
    snow: 0xfffafa,
    springgreen: 0x00ff7f,
    steelblue: 0x4682b4,
    tan: 0xd2b48c,
    teal: 0x008080,
    thistle: 0xd8bfd8,
    tomato: 0xff6347,
    turquoise: 0x40e0d0,
    violet: 0xee82ee,
    wheat: 0xf5deb3,
    white: 0xffffff,
    whitesmoke: 0xf5f5f5,
    yellow: 0xffff00,
    yellowgreen: 0x9acd32
});
var ColorNamesValueMap = (function () {
    var map = new Map();
    Object.keys(ColorNames).forEach(function (name) {
        map.set(ColorNames[name], name);
    });
    return map;
})();
//# sourceMappingURL=names.js.map

/***/ }),

/***/ "./lib/mol-util/color/palette.js":
/*!***************************************!*\
  !*** ./lib/mol-util/color/palette.js ***!
  \***************************************/
/*! exports provided: getPaletteParams, getPalette */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getPaletteParams", function() { return getPaletteParams; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getPalette", function() { return getPalette; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _legend__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../legend */ "./lib/mol-util/legend.js");
/* harmony import */ var _param_definition__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../param-definition */ "./lib/mol-util/param-definition.js");
/* harmony import */ var _distinct__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./distinct */ "./lib/mol-util/color/distinct.js");
/* harmony import */ var _lists__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./lists */ "./lib/mol-util/color/lists.js");
/* harmony import */ var _scale__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./scale */ "./lib/mol-util/color/scale.js");
/**
 * Copyright (c) 2019-2021 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 * @author David Sehnal <david.sehnal@gmail.com>
 */






var DefaultGetPaletteProps = {
    type: 'generate',
    colorList: 'red-yellow-blue'
};
function getPaletteParams(props) {
    if (props === void 0) { props = {}; }
    var p = Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, DefaultGetPaletteProps), props);
    return {
        palette: _param_definition__WEBPACK_IMPORTED_MODULE_2__["ParamDefinition"].MappedStatic(p.type, {
            colors: _param_definition__WEBPACK_IMPORTED_MODULE_2__["ParamDefinition"].Group({
                list: _param_definition__WEBPACK_IMPORTED_MODULE_2__["ParamDefinition"].ColorList(p.colorList),
            }, { isFlat: true }),
            generate: _param_definition__WEBPACK_IMPORTED_MODULE_2__["ParamDefinition"].Group(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, _distinct__WEBPACK_IMPORTED_MODULE_3__["DistinctColorsParams"]), { maxCount: _param_definition__WEBPACK_IMPORTED_MODULE_2__["ParamDefinition"].Numeric(75, { min: 1, max: 250, step: 1 }) }), { isFlat: true })
        }, {
            options: [
                ['colors', 'Color List'],
                ['generate', 'Generate Distinct']
            ]
        })
    };
}
var DefaultPaletteProps = _param_definition__WEBPACK_IMPORTED_MODULE_2__["ParamDefinition"].getDefaultValues(getPaletteParams());
var DefaultLabelOptions = {
    valueLabel: function (i) { return "" + (i + 1); },
    minLabel: 'Start',
    maxLabel: 'End'
};
function getPalette(count, props, labelOptions) {
    var _a;
    if (labelOptions === void 0) { labelOptions = {}; }
    var color;
    var legend;
    if (props.palette.name === 'colors' && props.palette.params.list.kind === 'interpolate') {
        var list = props.palette.params.list;
        var domain = [0, count - 1];
        var _b = Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, DefaultLabelOptions), labelOptions), minLabel = _b.minLabel, maxLabel = _b.maxLabel;
        var colors = list.colors;
        if (colors.length === 0)
            colors = Object(_lists__WEBPACK_IMPORTED_MODULE_4__["getColorListFromName"])(DefaultGetPaletteProps.colorList).list;
        var scale = _scale__WEBPACK_IMPORTED_MODULE_5__["ColorScale"].create({ listOrName: colors, domain: domain, minLabel: minLabel, maxLabel: maxLabel });
        legend = scale.legend;
        color = scale.color;
    }
    else {
        var colors_1;
        if (props.palette.name === 'colors') {
            colors_1 = props.palette.params.list.colors.map(function (c) { return Array.isArray(c) ? c[0] : c; });
            if (colors_1.length === 0)
                colors_1 = Object(_lists__WEBPACK_IMPORTED_MODULE_4__["getColorListFromName"])('dark-2').list.map(function (c) { return Array.isArray(c) ? c[0] : c; });
        }
        else {
            count = Math.min(count, props.palette.params.maxCount);
            colors_1 = Object(_distinct__WEBPACK_IMPORTED_MODULE_3__["distinctColors"])(count, props.palette.params);
        }
        var valueLabel = (_a = labelOptions.valueLabel) !== null && _a !== void 0 ? _a : DefaultLabelOptions.valueLabel;
        var colorsLength_1 = colors_1.length;
        var table = [];
        for (var i = 0; i < count; ++i) {
            var j = i % colorsLength_1;
            if (table[j] === undefined) {
                table[j] = [valueLabel(i), colors_1[j]];
            }
            else {
                table[j][0] += ", " + valueLabel(i);
            }
        }
        legend = Object(_legend__WEBPACK_IMPORTED_MODULE_1__["TableLegend"])(table);
        color = function (i) { return colors_1[i % colorsLength_1]; };
    }
    return { color: color, legend: legend };
}
//# sourceMappingURL=palette.js.map

/***/ }),

/***/ "./lib/mol-util/color/scale.js":
/*!*************************************!*\
  !*** ./lib/mol-util/color/scale.js ***!
  \*************************************/
/*! exports provided: DefaultColorScaleProps, ColorScale */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DefaultColorScaleProps", function() { return DefaultColorScaleProps; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ColorScale", function() { return ColorScale; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _color__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./color */ "./lib/mol-util/color/color.js");
/* harmony import */ var _lists__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./lists */ "./lib/mol-util/color/lists.js");
/* harmony import */ var _mol_util__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../mol-util */ "./lib/mol-util/index.js");
/* harmony import */ var _legend__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../legend */ "./lib/mol-util/legend.js");
/* harmony import */ var _mol_data_int__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../mol-data/int */ "./lib/mol-data/int.js");
/* harmony import */ var _mol_math_interpolate__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../../mol-math/interpolate */ "./lib/mol-math/interpolate.js");
/**
 * Copyright (c) 2018-2019 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */







var DefaultColorScaleProps = {
    domain: [0, 1],
    reverse: false,
    listOrName: 'red-yellow-blue',
    minLabel: '',
    maxLabel: '',
};
var ColorScale;
(function (ColorScale) {
    function create(props) {
        var _a = Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, DefaultColorScaleProps), props), domain = _a.domain, reverse = _a.reverse, listOrName = _a.listOrName;
        var list = typeof listOrName === 'string' ? Object(_lists__WEBPACK_IMPORTED_MODULE_2__["getColorListFromName"])(listOrName).list : listOrName;
        var colors = reverse ? list.slice().reverse() : list;
        var count1 = colors.length - 1;
        var diff = 0, min = 0, max = 0;
        function setDomain(_min, _max) {
            min = _min;
            max = _max;
            diff = (max - min) || 1;
        }
        setDomain(domain[0], domain[1]);
        var minLabel = Object(_mol_util__WEBPACK_IMPORTED_MODULE_3__["defaults"])(props.minLabel, min.toString());
        var maxLabel = Object(_mol_util__WEBPACK_IMPORTED_MODULE_3__["defaults"])(props.maxLabel, max.toString());
        var color;
        var hasOffsets = colors.every(function (c) { return Array.isArray(c); });
        if (hasOffsets) {
            var sorted = Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__spreadArrays"])(colors);
            sorted.sort(function (a, b) { return a[1] - b[1]; });
            var src_1 = sorted.map(function (c) { return c[0]; });
            var off_1 = _mol_data_int__WEBPACK_IMPORTED_MODULE_5__["SortedArray"].ofSortedArray(sorted.map(function (c) { return c[1]; }));
            var max_1 = src_1.length - 1;
            color = function (v) {
                var t = Object(_mol_math_interpolate__WEBPACK_IMPORTED_MODULE_6__["clamp"])((v - min) / diff, 0, 1);
                var i = _mol_data_int__WEBPACK_IMPORTED_MODULE_5__["SortedArray"].findPredecessorIndex(off_1, t);
                if (i === 0) {
                    return src_1[min];
                }
                else if (i > max_1) {
                    return src_1[max_1];
                }
                var o1 = off_1[i - 1], o2 = off_1[i];
                var t1 = Object(_mol_math_interpolate__WEBPACK_IMPORTED_MODULE_6__["clamp"])((t - o1) / (o2 - o1), 0, 1); // TODO: cache the deltas?
                return _color__WEBPACK_IMPORTED_MODULE_1__["Color"].interpolate(src_1[i - 1], src_1[i], t1);
            };
        }
        else {
            color = function (value) {
                var t = Math.min(colors.length - 1, Math.max(0, ((value - min) / diff) * count1));
                var tf = Math.floor(t);
                var c1 = colors[tf];
                var c2 = colors[Math.ceil(t)];
                return _color__WEBPACK_IMPORTED_MODULE_1__["Color"].interpolate(c1, c2, t - tf);
            };
        }
        return {
            color: color,
            colorToArray: function (value, array, offset) {
                _color__WEBPACK_IMPORTED_MODULE_1__["Color"].toArray(color(value), array, offset);
            },
            normalizedColorToArray: function (value, array, offset) {
                _color__WEBPACK_IMPORTED_MODULE_1__["Color"].toArrayNormalized(color(value), array, offset);
            },
            setDomain: setDomain,
            get legend() { return Object(_legend__WEBPACK_IMPORTED_MODULE_4__["ScaleLegend"])(minLabel, maxLabel, colors); }
        };
    }
    ColorScale.create = create;
})(ColorScale || (ColorScale = {}));
//# sourceMappingURL=scale.js.map

/***/ }),

/***/ "./lib/mol-util/color/spaces/hcl.js":
/*!******************************************!*\
  !*** ./lib/mol-util/color/spaces/hcl.js ***!
  \******************************************/
/*! exports provided: Hcl */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Hcl", function() { return Hcl; });
/* harmony import */ var _mol_math_misc__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../../mol-math/misc */ "./lib/mol-math/misc.js");
/* harmony import */ var _lab__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./lab */ "./lib/mol-util/color/spaces/lab.js");
/**
 * Copyright (c) 2019 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 *
 * Color conversion code adapted from chroma.js (https://github.com/gka/chroma.js)
 * Copyright (c) 2011-2018, Gregor Aisch, BSD license
 */



/**
 * CIE HCL (Hue-Chroma-Luminance) color
 *
 * - H [0..360]
 * - C [0..100]
 * - L [0..100]
 *
 * Cylindrical representation of CIELUV (see https://en.wikipedia.org/wiki/CIELUV)
 */
function Hcl() {
    return Hcl.zero();
}
(function (Hcl) {
    function zero() {
        var out = [0.1, 0.0, 0.0];
        out[0] = 0;
        return out;
    }
    Hcl.zero = zero;
    function create(h, c, l) {
        var out = zero();
        out[0] = h;
        out[1] = c;
        out[2] = l;
        return out;
    }
    Hcl.create = create;
    var tmpFromColorLab = [0, 0, 0];
    function fromColor(out, color) {
        return _lab__WEBPACK_IMPORTED_MODULE_1__["Lab"].toHcl(out, _lab__WEBPACK_IMPORTED_MODULE_1__["Lab"].fromColor(tmpFromColorLab, color));
    }
    Hcl.fromColor = fromColor;
    function fromLab(hcl, lab) {
        return _lab__WEBPACK_IMPORTED_MODULE_1__["Lab"].toHcl(hcl, lab);
    }
    Hcl.fromLab = fromLab;
    var tmpToColorLab = [0, 0, 0];
    function toColor(hcl) {
        return _lab__WEBPACK_IMPORTED_MODULE_1__["Lab"].toColor(toLab(tmpToColorLab, hcl));
    }
    Hcl.toColor = toColor;
    /**
     * Convert from a qualitative parameter h and a quantitative parameter l to a 24-bit pixel.
     *
     * These formulas were invented by David Dalrymple to obtain maximum contrast without going
     * out of gamut if the parameters are in the range 0-1.
     * A saturation multiplier was added by Gregor Aisch
     */
    function toLab(out, hcl) {
        var h = hcl[0], c = hcl[1], l = hcl[2];
        if (isNaN(h))
            h = 0;
        h = Object(_mol_math_misc__WEBPACK_IMPORTED_MODULE_0__["degToRad"])(h);
        out[0] = l;
        out[1] = Math.cos(h) * c;
        out[2] = Math.sin(h) * c;
        return out;
    }
    Hcl.toLab = toLab;
    function copy(out, c) {
        out[0] = c[0];
        out[1] = c[1];
        out[2] = c[2];
        return out;
    }
    Hcl.copy = copy;
    function saturate(out, c, amount) {
        out[0] = c[0];
        out[1] = Math.max(0, c[1] + Kn * amount);
        out[2] = c[2];
        return out;
    }
    Hcl.saturate = saturate;
    function desaturate(out, c, amount) {
        return saturate(out, c, -amount);
    }
    Hcl.desaturate = desaturate;
    var tmpDarkenLab = [0, 0, 0];
    function darken(out, c, amount) {
        toLab(tmpDarkenLab, c);
        return _lab__WEBPACK_IMPORTED_MODULE_1__["Lab"].toHcl(out, _lab__WEBPACK_IMPORTED_MODULE_1__["Lab"].darken(tmpDarkenLab, tmpDarkenLab, amount));
    }
    Hcl.darken = darken;
    function lighten(out, c, amount) {
        return darken(out, c, -amount);
    }
    Hcl.lighten = lighten;
    // Corresponds roughly to RGB brighter/darker
    var Kn = 18;
})(Hcl || (Hcl = {}));
//# sourceMappingURL=hcl.js.map

/***/ }),

/***/ "./lib/mol-util/color/spaces/lab.js":
/*!******************************************!*\
  !*** ./lib/mol-util/color/spaces/lab.js ***!
  \******************************************/
/*! exports provided: Lab */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Lab", function() { return Lab; });
/* harmony import */ var _color__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../color */ "./lib/mol-util/color/color.js");
/* harmony import */ var _hcl__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./hcl */ "./lib/mol-util/color/spaces/hcl.js");
/* harmony import */ var _mol_math_misc__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../../mol-math/misc */ "./lib/mol-math/misc.js");
/* harmony import */ var _mol_math_interpolate__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../../mol-math/interpolate */ "./lib/mol-math/interpolate.js");
/**
 * Copyright (c) 2019 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 *
 * Color conversion code adapted from chroma.js (https://github.com/gka/chroma.js)
 * Copyright (c) 2011-2018, Gregor Aisch, BSD license
 */





/**
 * CIE LAB color
 *
 * - L* [0..100] - lightness from black to white
 * - a [-100..100] - green (-) to red (+)
 * - b [-100..100] - blue (-) to yellow (+)
 *
 * see https://en.wikipedia.org/wiki/CIELAB_color_space
 */
function Lab() {
    return Lab.zero();
}
(function (Lab) {
    function zero() {
        var out = [0.1, 0.0, 0.0];
        out[0] = 0;
        return out;
    }
    Lab.zero = zero;
    function create(l, a, b) {
        var out = zero();
        out[0] = l;
        out[1] = a;
        out[2] = b;
        return out;
    }
    Lab.create = create;
    function fromColor(out, color) {
        var _a = _color__WEBPACK_IMPORTED_MODULE_0__["Color"].toRgb(color), r = _a[0], g = _a[1], b = _a[2];
        var _b = rgbToXyz(r, g, b), x = _b[0], y = _b[1], z = _b[2];
        var l = 116 * y - 16;
        out[0] = l < 0 ? 0 : l;
        out[1] = 500 * (x - y);
        out[2] = 200 * (y - z);
        return out;
    }
    Lab.fromColor = fromColor;
    function fromHcl(out, hcl) {
        return _hcl__WEBPACK_IMPORTED_MODULE_1__["Hcl"].toLab(out, hcl);
    }
    Lab.fromHcl = fromHcl;
    function toColor(lab) {
        var y = (lab[0] + 16) / 116;
        var x = isNaN(lab[1]) ? y : y + lab[1] / 500;
        var z = isNaN(lab[2]) ? y : y - lab[2] / 200;
        y = Yn * lab_xyz(y);
        x = Xn * lab_xyz(x);
        z = Zn * lab_xyz(z);
        var r = xyz_rgb(3.2404542 * x - 1.5371385 * y - 0.4985314 * z); // D65 -> sRGB
        var g = xyz_rgb(-0.9692660 * x + 1.8760108 * y + 0.0415560 * z);
        var b = xyz_rgb(0.0556434 * x - 0.2040259 * y + 1.0572252 * z);
        return _color__WEBPACK_IMPORTED_MODULE_0__["Color"].fromRgb(Math.round(Object(_mol_math_interpolate__WEBPACK_IMPORTED_MODULE_3__["clamp"])(r, 0, 255)), Math.round(Object(_mol_math_interpolate__WEBPACK_IMPORTED_MODULE_3__["clamp"])(g, 0, 255)), Math.round(Object(_mol_math_interpolate__WEBPACK_IMPORTED_MODULE_3__["clamp"])(b, 0, 255)));
    }
    Lab.toColor = toColor;
    function toHcl(out, lab) {
        var l = lab[0], a = lab[1], b = lab[2];
        var c = Math.sqrt(a * a + b * b);
        var h = (Object(_mol_math_misc__WEBPACK_IMPORTED_MODULE_2__["radToDeg"])(Math.atan2(b, a)) + 360) % 360;
        if (Math.round(c * 10000) === 0)
            h = Number.NaN;
        out[0] = h;
        out[1] = c;
        out[2] = l;
        return out;
    }
    Lab.toHcl = toHcl;
    function copy(out, c) {
        out[0] = c[0];
        out[1] = c[1];
        out[2] = c[2];
        return out;
    }
    Lab.copy = copy;
    function darken(out, c, amount) {
        out[0] = c[0] - Kn * amount;
        out[1] = c[1];
        out[2] = c[2];
        return out;
    }
    Lab.darken = darken;
    function lighten(out, c, amount) {
        return darken(out, c, -amount);
    }
    Lab.lighten = lighten;
    var tmpSaturateHcl = [0, 0, 0];
    function saturate(out, c, amount) {
        toHcl(tmpSaturateHcl, c);
        return _hcl__WEBPACK_IMPORTED_MODULE_1__["Hcl"].toLab(out, _hcl__WEBPACK_IMPORTED_MODULE_1__["Hcl"].saturate(tmpSaturateHcl, tmpSaturateHcl, amount));
    }
    Lab.saturate = saturate;
    function desaturate(out, c, amount) {
        return saturate(out, c, -amount);
    }
    Lab.desaturate = desaturate;
    // Corresponds roughly to RGB brighter/darker
    var Kn = 18;
    /** D65 standard referent */
    var Xn = 0.950470;
    var Yn = 1;
    var Zn = 1.088830;
    var T0 = 0.137931034; // 4 / 29
    var T1 = 0.206896552; // 6 / 29
    var T2 = 0.12841855; // 3 * t1 * t1
    var T3 = 0.008856452; // t1 * t1 * t1
    /** convert component from xyz to rgb */
    function xyz_rgb(c) {
        return 255 * (c <= 0.00304 ? 12.92 * c : 1.055 * Math.pow(c, 1 / 2.4) - 0.055);
    }
    /** convert component from lab to xyz */
    function lab_xyz(t) {
        return t > T1 ? t * t * t : T2 * (t - T0);
    }
    /** convert component from rgb to xyz */
    function rgb_xyz(c) {
        if ((c /= 255) <= 0.04045)
            return c / 12.92;
        return Math.pow((c + 0.055) / 1.055, 2.4);
    }
    /** convert component from xyz to lab */
    function xyz_lab(t) {
        if (t > T3)
            return Math.pow(t, 1 / 3);
        return t / T2 + T0;
    }
    function rgbToXyz(r, g, b) {
        r = rgb_xyz(r);
        g = rgb_xyz(g);
        b = rgb_xyz(b);
        var x = xyz_lab((0.4124564 * r + 0.3575761 * g + 0.1804375 * b) / Xn);
        var y = xyz_lab((0.2126729 * r + 0.7151522 * g + 0.0721750 * b) / Yn);
        var z = xyz_lab((0.0193339 * r + 0.1191920 * g + 0.9503041 * b) / Zn);
        return [x, y, z];
    }
})(Lab || (Lab = {}));
//# sourceMappingURL=lab.js.map

/***/ }),

/***/ "./lib/mol-util/color/swatches.js":
/*!****************************************!*\
  !*** ./lib/mol-util/color/swatches.js ***!
  \****************************************/
/*! exports provided: DefaultColorSwatch */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DefaultColorSwatch", function() { return DefaultColorSwatch; });
/* harmony import */ var _color__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./color */ "./lib/mol-util/color/color.js");
/**
 * Copyright (c) 2019 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 * @author David Sehnal <david.sehnal@gmail.com>
 */

var DefaultColorSwatch = Object(_color__WEBPACK_IMPORTED_MODULE_0__["ColorSwatch"])([
    ['black', 0x000000],
    ['gray', 0x808080],
    ['white', 0xFFFFFF],
    ['red', 0xD33115],
    ['orange', 0xE27300],
    ['yellow', 0xFCC400],
    ['green', 0x68BC00],
    ['cyan', 0x16A5A5],
    ['blue', 0x009CE0],
    ['purple', 0x7B64FF],
    ['magenta', 0xFA28FF],
    ['violet', 0x7D2187]
]);
//# sourceMappingURL=swatches.js.map

/***/ }),

/***/ "./lib/mol-util/data-source.js":
/*!*************************************!*\
  !*** ./lib/mol-util/data-source.js ***!
  \*************************************/
/*! exports provided: DataCompressionMethod, readStringFromFile, readUint8ArrayFromFile, readFromFile, ajaxGet, ajaxGetMany */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DataCompressionMethod", function() { return DataCompressionMethod; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "readStringFromFile", function() { return readStringFromFile; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "readUint8ArrayFromFile", function() { return readUint8ArrayFromFile; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "readFromFile", function() { return readFromFile; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ajaxGet", function() { return ajaxGet; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ajaxGetMany", function() { return ajaxGetMany; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _mol_task__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../mol-task */ "./lib/mol-task/index.js");
/* harmony import */ var _zip_zip__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./zip/zip */ "./lib/mol-util/zip/zip.js");
/* harmony import */ var _mol_io_common_utf8__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../mol-io/common/utf8 */ "./lib/mol-io/common/utf8.js");
/* harmony import */ var _assets__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./assets */ "./lib/mol-util/assets.js");
/**
 * Copyright (c) 2018-2020 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author David Sehnal <david.sehnal@gmail.com>
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 *
 * Adapted from LiteMol
 */





// polyfill XMLHttpRequest in node.js
var XHR = typeof document === 'undefined' ? __webpack_require__(/*! xhr2 */ "./node_modules/xhr2/lib/browser.js") : XMLHttpRequest;
var DataCompressionMethod;
(function (DataCompressionMethod) {
    DataCompressionMethod[DataCompressionMethod["None"] = 0] = "None";
    DataCompressionMethod[DataCompressionMethod["Gzip"] = 1] = "Gzip";
    DataCompressionMethod[DataCompressionMethod["Zip"] = 2] = "Zip";
})(DataCompressionMethod || (DataCompressionMethod = {}));
function readStringFromFile(file) {
    return readFromFileInternal(file, 'string');
}
function readUint8ArrayFromFile(file) {
    return readFromFileInternal(file, 'binary');
}
function readFromFile(file, type) {
    return readFromFileInternal(file, type);
}
function ajaxGet(params) {
    if (typeof params === 'string')
        return ajaxGetInternal(params, params, 'string');
    return ajaxGetInternal(params.title, params.url, params.type || 'string', params.body, params.headers);
}
function isDone(data) {
    if (data instanceof FileReader) {
        return data.readyState === FileReader.DONE;
    }
    else if (data instanceof XMLHttpRequest) {
        return data.readyState === XMLHttpRequest.DONE;
    }
    throw new Error('unknown data type');
}
function genericError(isDownload) {
    if (isDownload)
        return 'Failed to download data. Possible reasons: Resource is not available, or CORS is not allowed on the server.';
    return 'Failed to open file.';
}
function readData(ctx, action, data) {
    return new Promise(function (resolve, reject) {
        // first check if data reading is already done
        if (isDone(data)) {
            var error = data.error;
            if (error !== null && error !== undefined) {
                reject(error !== null && error !== void 0 ? error : genericError(data instanceof XMLHttpRequest));
            }
            else {
                resolve(data);
            }
            return;
        }
        var hasError = false;
        data.onerror = function (e) {
            if (hasError)
                return;
            var error = e.target.error;
            reject(error !== null && error !== void 0 ? error : genericError(data instanceof XMLHttpRequest));
        };
        data.onprogress = function (e) {
            if (!ctx.shouldUpdate || hasError)
                return;
            try {
                if (e.lengthComputable) {
                    ctx.update({ message: action, isIndeterminate: false, current: e.loaded, max: e.total });
                }
                else {
                    ctx.update({ message: action + " " + (e.loaded / 1024 / 1024).toFixed(2) + " MB", isIndeterminate: true });
                }
            }
            catch (e) {
                hasError = true;
                reject(e);
            }
        };
        data.onload = function (e) {
            resolve(data);
        };
    });
}
function getCompression(name) {
    return /\.gz$/i.test(name) ? DataCompressionMethod.Gzip :
        /\.zip$/i.test(name) ? DataCompressionMethod.Zip :
            DataCompressionMethod.None;
}
function decompress(ctx, data, compression) {
    return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"])(this, void 0, void 0, function () {
        var _a, parsed, names;
        return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__generator"])(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _a = compression;
                    switch (_a) {
                        case DataCompressionMethod.None: return [3 /*break*/, 1];
                        case DataCompressionMethod.Gzip: return [3 /*break*/, 2];
                        case DataCompressionMethod.Zip: return [3 /*break*/, 3];
                    }
                    return [3 /*break*/, 5];
                case 1: return [2 /*return*/, data];
                case 2: return [2 /*return*/, Object(_zip_zip__WEBPACK_IMPORTED_MODULE_2__["ungzip"])(ctx, data)];
                case 3: return [4 /*yield*/, Object(_zip_zip__WEBPACK_IMPORTED_MODULE_2__["unzip"])(ctx, data.buffer)];
                case 4:
                    parsed = _b.sent();
                    names = Object.keys(parsed);
                    if (names.length !== 1)
                        throw new Error('can only decompress zip files with a single entry');
                    return [2 /*return*/, parsed[names[0]]];
                case 5: return [2 /*return*/];
            }
        });
    });
}
function processFile(ctx, reader, type, compression) {
    return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"])(this, void 0, void 0, function () {
        var result, data, decompressed, parser;
        return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__generator"])(this, function (_a) {
            switch (_a.label) {
                case 0:
                    result = reader.result;
                    data = result instanceof ArrayBuffer ? new Uint8Array(result) : result;
                    if (data === null)
                        throw new Error('no data given');
                    if (!(compression !== DataCompressionMethod.None)) return [3 /*break*/, 4];
                    if (!(data instanceof Uint8Array))
                        throw new Error('need Uint8Array for decompression');
                    return [4 /*yield*/, decompress(ctx, data, compression)];
                case 1:
                    decompressed = _a.sent();
                    if (!(type === 'string')) return [3 /*break*/, 3];
                    return [4 /*yield*/, ctx.update({ message: 'Decoding text...' })];
                case 2:
                    _a.sent();
                    data = Object(_mol_io_common_utf8__WEBPACK_IMPORTED_MODULE_3__["utf8Read"])(decompressed, 0, decompressed.length);
                    return [3 /*break*/, 4];
                case 3:
                    data = decompressed;
                    _a.label = 4;
                case 4:
                    if (!(type === 'binary' && data instanceof Uint8Array)) return [3 /*break*/, 5];
                    return [2 /*return*/, data];
                case 5:
                    if (!(type === 'zip' && data instanceof Uint8Array)) return [3 /*break*/, 7];
                    return [4 /*yield*/, Object(_zip_zip__WEBPACK_IMPORTED_MODULE_2__["unzip"])(ctx, data.buffer)];
                case 6: return [2 /*return*/, _a.sent()];
                case 7:
                    if (type === 'string' && typeof data === 'string') {
                        return [2 /*return*/, data];
                    }
                    else if (type === 'xml' && typeof data === 'string') {
                        parser = new DOMParser();
                        return [2 /*return*/, parser.parseFromString(data, 'application/xml')];
                    }
                    else if (type === 'json' && typeof data === 'string') {
                        return [2 /*return*/, JSON.parse(data)];
                    }
                    _a.label = 8;
                case 8: throw new Error("could not get requested response data '" + type + "'");
            }
        });
    });
}
function readFromFileInternal(file, type) {
    var _this = this;
    var reader = void 0;
    return _mol_task__WEBPACK_IMPORTED_MODULE_1__["Task"].create('Read File', function (ctx) { return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"])(_this, void 0, void 0, function () {
        var compression, fileReader;
        return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__generator"])(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, , 5, 6]);
                    reader = new FileReader();
                    compression = type === 'zip' ? DataCompressionMethod.None : getCompression(file.name);
                    if (type === 'binary' || type === 'zip' || compression !== DataCompressionMethod.None) {
                        reader.readAsArrayBuffer(file);
                    }
                    else {
                        reader.readAsText(file);
                    }
                    return [4 /*yield*/, ctx.update({ message: 'Opening file...', canAbort: true })];
                case 1:
                    _a.sent();
                    return [4 /*yield*/, readData(ctx, 'Reading...', reader)];
                case 2:
                    fileReader = _a.sent();
                    return [4 /*yield*/, ctx.update({ message: 'Processing file...', canAbort: false })];
                case 3:
                    _a.sent();
                    return [4 /*yield*/, processFile(ctx, fileReader, type, compression)];
                case 4: return [2 /*return*/, _a.sent()];
                case 5:
                    reader = void 0;
                    return [7 /*endfinally*/];
                case 6: return [2 /*return*/];
            }
        });
    }); }, function () {
        if (reader)
            reader.abort();
    });
}
var RequestPool = /** @class */ (function () {
    function RequestPool() {
    }
    RequestPool.get = function () {
        if (this.pool.length) {
            return this.pool.pop();
        }
        return new XHR();
    };
    RequestPool.emptyFunc = function () { };
    RequestPool.deposit = function (req) {
        if (this.pool.length < this.poolSize) {
            req.onabort = RequestPool.emptyFunc;
            req.onerror = RequestPool.emptyFunc;
            req.onload = RequestPool.emptyFunc;
            req.onprogress = RequestPool.emptyFunc;
            this.pool.push(req);
        }
    };
    RequestPool.pool = [];
    RequestPool.poolSize = 15;
    return RequestPool;
}());
function processAjax(req, type) {
    if (req.status >= 200 && req.status < 400) {
        var response = req.response;
        RequestPool.deposit(req);
        if ((type === 'binary' || type === 'zip') && response instanceof ArrayBuffer) {
            return new Uint8Array(response);
        }
        else if (type === 'string' && typeof response === 'string') {
            return response;
        }
        else if (type === 'xml' && response instanceof XMLDocument) {
            return response;
        }
        else if (type === 'json' && typeof response === 'object') {
            return response;
        }
        throw new Error("could not get requested response data '" + type + "'");
    }
    else {
        RequestPool.deposit(req);
        throw new Error("Download failed with status code " + req.status);
    }
}
function getRequestResponseType(type) {
    switch (type) {
        case 'json': return 'json';
        case 'xml': return 'document';
        case 'string': return 'text';
        case 'binary': return 'arraybuffer';
        case 'zip': return 'arraybuffer';
    }
}
function ajaxGetInternal(title, url, type, body, headers) {
    var _this = this;
    var xhttp = void 0;
    return _mol_task__WEBPACK_IMPORTED_MODULE_1__["Task"].create(title ? title : 'Download', function (ctx) { return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"])(_this, void 0, void 0, function () {
        var _a, headers_1, _b, name_1, value, req, result;
        return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__generator"])(this, function (_c) {
            switch (_c.label) {
                case 0:
                    xhttp = RequestPool.get();
                    xhttp.open(body ? 'post' : 'get', url, true);
                    if (headers) {
                        for (_a = 0, headers_1 = headers; _a < headers_1.length; _a++) {
                            _b = headers_1[_a], name_1 = _b[0], value = _b[1];
                            xhttp.setRequestHeader(name_1, value);
                        }
                    }
                    xhttp.responseType = getRequestResponseType(type);
                    xhttp.send(body);
                    return [4 /*yield*/, ctx.update({ message: 'Waiting for server...', canAbort: true })];
                case 1:
                    _c.sent();
                    return [4 /*yield*/, readData(ctx, 'Downloading...', xhttp)];
                case 2:
                    req = _c.sent();
                    xhttp = void 0; // guard against reuse, help garbage collector
                    return [4 /*yield*/, ctx.update({ message: 'Parsing response...', canAbort: false })];
                case 3:
                    _c.sent();
                    result = processAjax(req, type);
                    return [2 /*return*/, result];
            }
        });
    }); }, function () {
        if (xhttp) {
            xhttp.abort();
            xhttp = void 0; // guard against reuse, help garbage collector
        }
    });
}
function ajaxGetMany(ctx, assetManager, sources, maxConcurrency) {
    return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"])(this, void 0, void 0, function () {
        var len, slots, promises, promiseKeys, currentSrc, _i, current, done, r, src, idx, current, asset;
        return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__generator"])(this, function (_a) {
            switch (_a.label) {
                case 0:
                    len = sources.length;
                    slots = new Array(sources.length);
                    return [4 /*yield*/, ctx.update({ message: 'Downloading...', current: 0, max: len })];
                case 1:
                    _a.sent();
                    promises = [], promiseKeys = [];
                    currentSrc = 0;
                    for (_i = Math.min(len, maxConcurrency); currentSrc < _i; currentSrc++) {
                        current = sources[currentSrc];
                        promises.push(wrapPromise(currentSrc, current.id, assetManager.resolve(_assets__WEBPACK_IMPORTED_MODULE_4__["Asset"].getUrlAsset(assetManager, current.url), current.isBinary ? 'binary' : 'string').runAsChild(ctx)));
                        promiseKeys.push(currentSrc);
                    }
                    done = 0;
                    _a.label = 2;
                case 2:
                    if (!(promises.length > 0)) return [3 /*break*/, 6];
                    return [4 /*yield*/, Promise.race(promises)];
                case 3:
                    r = _a.sent();
                    src = sources[r.index];
                    idx = promiseKeys.indexOf(r.index);
                    done++;
                    if (r.kind === 'error' && !src.canFail) {
                        // TODO: cancel other downloads
                        throw new Error(src.url + ": " + r.error);
                    }
                    if (!ctx.shouldUpdate) return [3 /*break*/, 5];
                    return [4 /*yield*/, ctx.update({ message: 'Downloading...', current: done, max: len })];
                case 4:
                    _a.sent();
                    _a.label = 5;
                case 5:
                    slots[r.index] = r;
                    promises = promises.filter(_filterRemoveIndex, idx);
                    promiseKeys = promiseKeys.filter(_filterRemoveIndex, idx);
                    if (currentSrc < len) {
                        current = sources[currentSrc];
                        asset = assetManager.resolve(_assets__WEBPACK_IMPORTED_MODULE_4__["Asset"].getUrlAsset(assetManager, current.url), current.isBinary ? 'binary' : 'string').runAsChild(ctx);
                        promises.push(wrapPromise(currentSrc, current.id, asset));
                        promiseKeys.push(currentSrc);
                        currentSrc++;
                    }
                    return [3 /*break*/, 2];
                case 6: return [2 /*return*/, slots];
            }
        });
    });
}
function _filterRemoveIndex(_, i) {
    return this !== i;
}
function wrapPromise(index, id, p) {
    return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"])(this, void 0, void 0, function () {
        var result, error_1;
        return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__generator"])(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, p];
                case 1:
                    result = _a.sent();
                    return [2 /*return*/, { kind: 'ok', result: result, index: index, id: id }];
                case 2:
                    error_1 = _a.sent();
                    return [2 /*return*/, { kind: 'error', error: error_1, index: index, id: id }];
                case 3: return [2 /*return*/];
            }
        });
    });
}
//# sourceMappingURL=data-source.js.map

/***/ }),

/***/ "./lib/mol-util/date.js":
/*!******************************!*\
  !*** ./lib/mol-util/date.js ***!
  \******************************/
/*! exports provided: dateToUtcString, getFormattedTime */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "dateToUtcString", function() { return dateToUtcString; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getFormattedTime", function() { return getFormattedTime; });
/**
 * Copyright (c) 2018 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author David Sehnal <david.sehnal@gmail.com>
 */
function dateToUtcString(date) {
    return date.toISOString().replace(/T/, ' ').replace(/\..+/, '');
}
function getFormattedTime() {
    var today = new Date();
    var y = today.getFullYear();
    var m = today.getMonth() + 1;
    var d = today.getDate();
    var h = today.getHours();
    var mi = today.getMinutes();
    var s = today.getSeconds();
    return y + '-' + m + '-' + d + '-' + h + '-' + mi + '-' + s;
}
//# sourceMappingURL=date.js.map

/***/ }),

/***/ "./lib/mol-util/debug.js":
/*!*******************************!*\
  !*** ./lib/mol-util/debug.js ***!
  \*******************************/
/*! exports provided: isProductionMode, isDebugMode, setProductionMode, setDebugMode */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* WEBPACK VAR INJECTION */(function(process) {/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isProductionMode", function() { return isProductionMode; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isDebugMode", function() { return isDebugMode; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setProductionMode", function() { return setProductionMode; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setDebugMode", function() { return setDebugMode; });
/**
 * Copyright (c) 2019-2020 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */
var _a, _b, _c;
/**
 * on node `process.env.NODE_ENV` is available, in webpack build it is automatically set
 * by the DefinePlugin to the webpack `mode` value
 */
var isProductionMode = typeof process !== 'undefined' && ((_a = process.env) === null || _a === void 0 ? void 0 : "development") === 'production';
/**
 * set to true to enable more comprehensive checks and assertions,
 * mostly used in `mol-gl` and in valence-model calculation
 */
var isDebugMode = typeof process !== 'undefined' && (((_b = process.env) === null || _b === void 0 ? void 0 : undefined) === '*' || ((_c = process.env) === null || _c === void 0 ? void 0 : undefined) === 'molstar');

function setProductionMode(value) {
    if (typeof value !== 'undefined')
        isProductionMode = value;
}
function setDebugMode(value) {
    if (typeof value !== 'undefined')
        isDebugMode = value;
}
//# sourceMappingURL=debug.js.map
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(/*! ./../../node_modules/process/browser.js */ "./node_modules/process/browser.js")))

/***/ }),

/***/ "./lib/mol-util/download.js":
/*!**********************************!*\
  !*** ./lib/mol-util/download.js ***!
  \**********************************/
/*! exports provided: download */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "download", function() { return download; });
/**
 * Copyright (c) 2018-2019 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */
function openUrl(url) {
    var opened = window.open(url, '_blank');
    if (!opened) {
        window.location.href = url;
    }
}
function click(node) {
    try {
        node.dispatchEvent(new MouseEvent('click'));
    }
    catch (e) {
        var evt = document.createEvent('MouseEvents');
        evt.initMouseEvent('click', true, true, window, 0, 0, 0, 80, 20, false, false, false, false, 0, null);
        node.dispatchEvent(evt);
    }
}
function download(data, downloadName) {
    // using ideas from https://github.com/eligrey/FileSaver.js/blob/master/FileSaver.js
    if (downloadName === void 0) { downloadName = 'download'; }
    if (!data)
        return;
    if ('download' in HTMLAnchorElement.prototype) {
        var a_1 = document.createElement('a');
        a_1.download = downloadName;
        a_1.rel = 'noopener';
        if (typeof data === 'string') {
            a_1.href = data;
            click(a_1);
        }
        else {
            a_1.href = URL.createObjectURL(data);
            setTimeout(function () { return URL.revokeObjectURL(a_1.href); }, 4E4); // 40s
            setTimeout(function () { return click(a_1); });
        }
    }
    else if (typeof navigator !== 'undefined' && navigator.msSaveOrOpenBlob) {
        // native saveAs in IE 10+
        navigator.msSaveOrOpenBlob(data, downloadName);
    }
    else {
        var ua = window.navigator.userAgent;
        var isSafari = /Safari/i.test(ua);
        var isChromeIos_1 = /CriOS\/[\d]+/.test(ua);
        var open_1 = function (str) {
            openUrl(isChromeIos_1 ? str : str.replace(/^data:[^;]*;/, 'data:attachment/file;'));
        };
        if ((isSafari || isChromeIos_1) && FileReader) {
            if (data instanceof Blob) {
                // no downloading of blob urls in Safari
                var reader_1 = new FileReader();
                reader_1.onloadend = function () { return open_1(reader_1.result); };
                reader_1.readAsDataURL(data);
            }
            else {
                open_1(data);
            }
        }
        else {
            var url_1 = URL.createObjectURL(data);
            location.href = url_1;
            setTimeout(function () { return URL.revokeObjectURL(url_1); }, 4E4); // 40s
        }
    }
}
//# sourceMappingURL=download.js.map

/***/ }),

/***/ "./lib/mol-util/file-info.js":
/*!***********************************!*\
  !*** ./lib/mol-util/file-info.js ***!
  \***********************************/
/*! exports provided: getFileInfo */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getFileInfo", function() { return getFileInfo; });
/**
 * Copyright (c) 2018 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */
// TODO only support compressed files for which uncompression support is available???
// TODO store globally with decompression plugins?
var compressedExtList = ['gz', 'zip'];
// TODO store globally with parser plugins?
var binaryExtList = ['bcif', 'ccp4', 'dcd'];
function getFileInfo(file) {
    var path;
    var compressed;
    var protocol = '';
    if (file instanceof File) {
        path = file.name;
    }
    else if (file instanceof Blob) {
        path = '';
    }
    else {
        path = file;
    }
    var queryIndex = path.lastIndexOf('?');
    var query = queryIndex !== -1 ? path.substring(queryIndex) : '';
    path = path.substring(0, queryIndex === -1 ? path.length : queryIndex);
    var name = path.replace(/^.*[\\/]/, '');
    var base = name.substring(0, name.lastIndexOf('.'));
    var nameSplit = name.split('.');
    var ext = nameSplit.length > 1 ? (nameSplit.pop() || '').toLowerCase() : '';
    var protocolMatch = path.match(/^(.+):\/\/(.+)$/);
    if (protocolMatch) {
        protocol = protocolMatch[1].toLowerCase();
        path = protocolMatch[2] || '';
    }
    var dir = path.substring(0, path.lastIndexOf('/') + 1);
    if (compressedExtList.includes(ext)) {
        compressed = ext;
        var n = path.length - ext.length - 1;
        ext = (path.substr(0, n).split('.').pop() || '').toLowerCase();
        var m = base.length - ext.length - 1;
        base = base.substr(0, m);
    }
    else {
        compressed = false;
    }
    var binary = binaryExtList.includes(ext);
    return { path: path, name: name, ext: ext, base: base, dir: dir, compressed: compressed, binary: binary, protocol: protocol, query: query, src: file };
}
//# sourceMappingURL=file-info.js.map

/***/ }),

/***/ "./lib/mol-util/float-packing.js":
/*!***************************************!*\
  !*** ./lib/mol-util/float-packing.js ***!
  \***************************************/
/*! exports provided: encodeFloatLog, decodeFloatLog, encodeFloatRGBtoArray, decodeFloatRGB, unpackRGBAToDepth */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "encodeFloatLog", function() { return encodeFloatLog; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "decodeFloatLog", function() { return decodeFloatLog; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "encodeFloatRGBtoArray", function() { return encodeFloatRGBtoArray; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "decodeFloatRGB", function() { return decodeFloatRGB; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "unpackRGBAToDepth", function() { return unpackRGBAToDepth; });
/* harmony import */ var _mol_math_interpolate__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../mol-math/interpolate */ "./lib/mol-math/interpolate.js");
/* harmony import */ var _mol_math_approx__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../mol-math/approx */ "./lib/mol-math/approx.js");
/* harmony import */ var _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../mol-math/linear-algebra */ "./lib/mol-math/linear-algebra.js");
/**
 * Copyright (c) 2019-2020 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */



var maxFloat = 10000.0; // NOTE same constant is set in shaders
var floatLogFactor = Object(_mol_math_approx__WEBPACK_IMPORTED_MODULE_1__["fasterLog"])(maxFloat + 1);
/** encode float logarithmically */
function encodeFloatLog(value) { return Object(_mol_math_approx__WEBPACK_IMPORTED_MODULE_1__["fasterLog"])(value + 1) / floatLogFactor; }
/** decode logarithmically encoded float */
function decodeFloatLog(value) { return Object(_mol_math_approx__WEBPACK_IMPORTED_MODULE_1__["fasterExp"])(value * floatLogFactor) - 1; }
/** encode float as rgb triplet into array at offset */
function encodeFloatRGBtoArray(value, array, offset) {
    value = Object(_mol_math_interpolate__WEBPACK_IMPORTED_MODULE_0__["clamp"])(value, 0, 16777216 - 1) + 1;
    array[offset + 2] = value % 256;
    value = Math.floor(value / 256);
    array[offset + 1] = value % 256;
    value = Math.floor(value / 256);
    array[offset] = value % 256;
    return array;
}
/** decode float encoded as rgb triplet */
function decodeFloatRGB(r, g, b) {
    return (Math.floor(r) * 256 * 256 + Math.floor(g) * 256 + Math.floor(b)) - 1;
}
var UnpackDownscale = 255 / 256; // 0..1 -> fraction (excluding 1)
var PackFactors = _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_2__["Vec3"].create(256 * 256 * 256, 256 * 256, 256);
var UnpackFactors = _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_2__["Vec4"].create(UnpackDownscale / PackFactors[0], UnpackDownscale / PackFactors[1], UnpackDownscale / PackFactors[2], UnpackDownscale / 1);
var tmpDepthRGBA = Object(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_2__["Vec4"])();
function unpackRGBAToDepth(r, g, b, a) {
    _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_2__["Vec4"].set(tmpDepthRGBA, r / 255, g / 255, b / 255, a / 255);
    return _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_2__["Vec4"].dot(tmpDepthRGBA, UnpackFactors);
}
//# sourceMappingURL=float-packing.js.map

/***/ }),

/***/ "./lib/mol-util/graphql-client.js":
/*!****************************************!*\
  !*** ./lib/mol-util/graphql-client.js ***!
  \****************************************/
/*! exports provided: ClientError, GraphQLClient */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ClientError", function() { return ClientError; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "GraphQLClient", function() { return GraphQLClient; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _assets__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./assets */ "./lib/mol-util/assets.js");
/**
 * Copyright (c) 2018-2020 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 *
 * Adapted from https://github.com/prisma/graphql-request, Copyright (c) 2017 Graphcool, MIT
 */


var ClientError = /** @class */ (function (_super) {
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__extends"])(ClientError, _super);
    function ClientError(response, request) {
        var _this = this;
        var message = ClientError.extractMessage(response) + ": " + JSON.stringify({ response: response, request: request });
        _this = _super.call(this, message) || this;
        _this.response = response;
        _this.request = request;
        // this is needed as Safari doesn't support .captureStackTrace
        if (typeof Error.captureStackTrace === 'function') {
            Error.captureStackTrace(_this, ClientError);
        }
        return _this;
    }
    ClientError.extractMessage = function (response) {
        return response.errors ? response.errors[0].message : "GraphQL Error (Code: " + response.status + ")";
    };
    return ClientError;
}(Error));

var GraphQLClient = /** @class */ (function () {
    function GraphQLClient(url, assetManager) {
        this.url = url;
        this.assetManager = assetManager;
    }
    GraphQLClient.prototype.request = function (ctx, query, variables) {
        return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"])(this, void 0, void 0, function () {
            var body, url, result, errorResult;
            return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__generator"])(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        body = JSON.stringify({ query: query, variables: variables }, null, 2);
                        url = _assets__WEBPACK_IMPORTED_MODULE_1__["Asset"].getUrlAsset(this.assetManager, this.url, body);
                        return [4 /*yield*/, this.assetManager.resolve(url, 'json').runInContext(ctx)];
                    case 1:
                        result = _a.sent();
                        if (!result.data.errors && result.data.data) {
                            return [2 /*return*/, {
                                    data: result.data.data,
                                    dispose: result.dispose
                                }];
                        }
                        else {
                            errorResult = typeof result.data === 'string' ? { error: result.data } : result.data;
                            throw new ClientError(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, errorResult), { query: query, variables: variables });
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    return GraphQLClient;
}());

//# sourceMappingURL=graphql-client.js.map

/***/ }),

/***/ "./lib/mol-util/id-factory.js":
/*!************************************!*\
  !*** ./lib/mol-util/id-factory.js ***!
  \************************************/
/*! exports provided: idFactory */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "idFactory", function() { return idFactory; });
/**
 * Copyright (c) 2018 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */
/** Builds id function returning ids within [firstId, maxId) */
function idFactory(firstId, maxId) {
    if (firstId === void 0) { firstId = 0; }
    if (maxId === void 0) { maxId = Number.MAX_SAFE_INTEGER; }
    var _nextId = firstId;
    return function () {
        var ret = _nextId;
        _nextId = (_nextId + 1) % maxId;
        return ret;
    };
}
//# sourceMappingURL=id-factory.js.map

/***/ }),

/***/ "./lib/mol-util/image.js":
/*!*******************************!*\
  !*** ./lib/mol-util/image.js ***!
  \*******************************/
/*! exports provided: PixelData */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "PixelData", function() { return PixelData; });
/**
 * Copyright (c) 2019 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */

var PixelData;
(function (PixelData) {
    function create(array, width, height) {
        return { array: array, width: width, height: height };
    }
    PixelData.create = create;
    /** horizontally flips the pixel data in-place */
    function flipY(pixelData) {
        var array = pixelData.array, width = pixelData.width, height = pixelData.height;
        var width4 = width * 4;
        for (var i = 0, maxI = height / 2; i < maxI; ++i) {
            for (var j = 0, maxJ = width4; j < maxJ; ++j) {
                var index1 = i * width4 + j;
                var index2 = (height - i - 1) * width4 + j;
                var tmp = array[index1];
                array[index1] = array[index2];
                array[index2] = tmp;
            }
        }
        return pixelData;
    }
    PixelData.flipY = flipY;
})(PixelData || (PixelData = {}));
//# sourceMappingURL=image.js.map

/***/ }),

/***/ "./lib/mol-util/index.js":
/*!*******************************!*\
  !*** ./lib/mol-util/index.js ***!
  \*******************************/
/*! exports provided: ValueRef, ValueBox, ValueCell, BitFlags, StringBuilder, UUID, Mask, noop, round, arrayEqual, deepEqual, shallowEqual, shallowEqualObjects, default, defaults, extend, shallowClone, assign, merge, formatTime, formatProgress */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "noop", function() { return noop; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "round", function() { return round; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "arrayEqual", function() { return arrayEqual; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "deepEqual", function() { return deepEqual; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "shallowEqual", function() { return shallowEqual; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "shallowEqualObjects", function() { return shallowEqualObjects; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return shallowEqualArrays; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "defaults", function() { return defaults; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "extend", function() { return extend; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "shallowClone", function() { return shallowClone; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "assign", function() { return assign; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "merge", function() { return merge; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "formatTime", function() { return formatTime; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "formatProgress", function() { return formatProgress; });
/* harmony import */ var _bit_flags__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./bit-flags */ "./lib/mol-util/bit-flags.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "BitFlags", function() { return _bit_flags__WEBPACK_IMPORTED_MODULE_0__["default"]; });

/* harmony import */ var _string_builder__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./string-builder */ "./lib/mol-util/string-builder.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "StringBuilder", function() { return _string_builder__WEBPACK_IMPORTED_MODULE_1__["default"]; });

/* harmony import */ var _uuid__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./uuid */ "./lib/mol-util/uuid.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "UUID", function() { return _uuid__WEBPACK_IMPORTED_MODULE_2__["default"]; });

/* harmony import */ var _mask__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./mask */ "./lib/mol-util/mask.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Mask", function() { return _mask__WEBPACK_IMPORTED_MODULE_3__["default"]; });

/* harmony import */ var _value_cell__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./value-cell */ "./lib/mol-util/value-cell.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ValueRef", function() { return _value_cell__WEBPACK_IMPORTED_MODULE_4__["ValueRef"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ValueBox", function() { return _value_cell__WEBPACK_IMPORTED_MODULE_4__["ValueBox"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ValueCell", function() { return _value_cell__WEBPACK_IMPORTED_MODULE_4__["ValueCell"]; });

/**
 * Copyright (c) 2017-2020 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author David Sehnal <david.sehnal@gmail.com>
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */






var noop = function () { };
function round(n, d) {
    var f = Math.pow(10, d);
    return Math.round(f * n) / f;
}
function arrayEqual(arr1, arr2) {
    var length = arr1.length;
    if (length !== arr2.length)
        return false;
    for (var i = 0; i < length; i++) {
        if (arr1[i] !== arr2[i]) {
            return false;
        }
    }
    return true;
}
var hasOwnProperty = Object.prototype.hasOwnProperty;
function deepEqual(a, b) {
    // from https://github.com/epoberezkin/fast-deep-equal MIT
    if (a === b)
        return true;
    var arrA = Array.isArray(a);
    var arrB = Array.isArray(b);
    if (arrA && arrB) {
        if (a.length !== b.length)
            return false;
        for (var i = 0; i < a.length; i++) {
            if (!deepEqual(a[i], b[i]))
                return false;
        }
        return true;
    }
    if (arrA !== arrB)
        return false;
    if (a && b && typeof a === 'object' && typeof b === 'object') {
        var keys = Object.keys(a);
        if (keys.length !== Object.keys(b).length)
            return false;
        var dateA = a instanceof Date;
        var dateB = b instanceof Date;
        if (dateA && dateB)
            return a.getTime() === b.getTime();
        if (dateA !== dateB)
            return false;
        var regexpA = a instanceof RegExp;
        var regexpB = b instanceof RegExp;
        if (regexpA && regexpB)
            return a.toString() === b.toString();
        if (regexpA !== regexpB)
            return false;
        for (var i = 0; i < keys.length; i++) {
            if (!hasOwnProperty.call(b, keys[i]))
                return false;
        }
        for (var i = 0; i < keys.length; i++) {
            if (!deepEqual(a[keys[i]], b[keys[i]]))
                return false;
        }
        return true;
    }
    return false;
}
function shallowEqual(a, b) {
    if (a === b)
        return true;
    var arrA = Array.isArray(a);
    var arrB = Array.isArray(b);
    if (arrA && arrB)
        return shallowEqualArrays(a, b);
    if (arrA !== arrB)
        return false;
    if (a && b && typeof a === 'object' && typeof b === 'object') {
        return shallowEqualObjects(a, b);
    }
    return false;
}
function shallowEqualObjects(a, b) {
    if (a === b)
        return true;
    if (!a || !b)
        return false;
    var keys = Object.keys(a);
    if (Object.keys(b).length !== keys.length)
        return false;
    for (var _i = 0, keys_1 = keys; _i < keys_1.length; _i++) {
        var k = keys_1[_i];
        if (!hasOwnProperty.call(a, k) || a[k] !== b[k])
            return false;
    }
    return true;
}
function shallowEqualArrays(a, b) {
    if (a === b)
        return true;
    if (!a || !b)
        return false;
    if (a.length !== b.length)
        return false;
    for (var i = 0, il = a.length; i < il; ++i) {
        if (a[i] !== b[i])
            return false;
    }
    return true;
}
/** Returns `value` if not `undefined`, otherwise returns `defaultValue` */
function defaults(value, defaultValue) {
    return value !== undefined ? value : defaultValue;
}
function extend(object, source, guard) {
    var v;
    var s = source;
    var o = object;
    var g = guard;
    for (var _i = 0, _a = Object.keys(source); _i < _a.length; _i++) {
        var k = _a[_i];
        v = s[k];
        if (v !== void 0)
            o[k] = v;
        else if (guard)
            o[k] = g[k];
    }
    if (guard) {
        for (var _b = 0, _c = Object.keys(guard); _b < _c.length; _b++) {
            var k = _c[_b];
            v = o[k];
            if (v === void 0)
                o[k] = g[k];
        }
    }
    return object;
}
function shallowClone(o) {
    return extend({}, o);
}
function _assign(target) {
    for (var s = 1; s < arguments.length; s++) {
        var from = arguments[s];
        for (var _i = 0, _a = Object.keys(from); _i < _a.length; _i++) {
            var key = _a[_i];
            if (hasOwnProperty.call(from, key)) {
                target[key] = from[key];
            }
        }
    }
    return target;
}
var assign = Object.assign || _assign;
function _shallowMerge1(source, update) {
    var changed = false;
    for (var _i = 0, _a = Object.keys(update); _i < _a.length; _i++) {
        var k = _a[_i];
        if (!hasOwnProperty.call(update, k))
            continue;
        if (update[k] !== source[k]) {
            changed = true;
            break;
        }
    }
    if (!changed)
        return source;
    return assign(shallowClone(source), update);
}
function _shallowMerge(source) {
    var ret = source;
    for (var s = 1; s < arguments.length; s++) {
        if (!arguments[s])
            continue;
        ret = _shallowMerge1(source, arguments[s]);
        if (ret !== source) {
            for (var i = s + 1; i < arguments.length; i++) {
                ret = assign(ret, arguments[i]);
            }
            break;
        }
    }
    return ret;
}
var merge = _shallowMerge;
function padTime(n) { return (n < 10 ? '0' : '') + n; }
function formatTime(d) {
    var h = d.getHours(), m = d.getMinutes(), s = d.getSeconds();
    return h + ":" + padTime(m) + ":" + padTime(s);
}
function formatProgress(p) {
    var tp = p.root.progress;
    if (tp.isIndeterminate)
        return tp.message;
    var x = (100 * tp.current / tp.max).toFixed(2);
    return tp.message + " " + x + "%";
}
//# sourceMappingURL=index.js.map

/***/ }),

/***/ "./lib/mol-util/input/input-observer.js":
/*!**********************************************!*\
  !*** ./lib/mol-util/input/input-observer.js ***!
  \**********************************************/
/*! exports provided: getButtons, getButton, getModifiers, DefaultInputObserverProps, ModifiersKeys, ButtonsType, default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getButtons", function() { return getButtons; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getButton", function() { return getButton; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getModifiers", function() { return getModifiers; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DefaultInputObserverProps", function() { return DefaultInputObserverProps; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ModifiersKeys", function() { return ModifiersKeys; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ButtonsType", function() { return ButtonsType; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var rxjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! rxjs */ "./node_modules/rxjs/_esm5/index.js");
/* harmony import */ var _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../mol-math/linear-algebra */ "./lib/mol-math/linear-algebra.js");
/* harmony import */ var _mol_util__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../mol-util */ "./lib/mol-util/index.js");
/**
 * Copyright (c) 2018-2020 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */




function getButtons(event) {
    if (typeof event === 'object') {
        if ('buttons' in event) {
            return event.buttons;
        }
        else if ('which' in event) {
            var b = event.which; // 'any' to support older browsers
            if (b === 2) {
                return 4;
            }
            else if (b === 3) {
                return 2;
            }
            else if (b > 0) {
                return 1 << (b - 1);
            }
        }
    }
    return 0;
}
function getButton(event) {
    if (typeof event === 'object') {
        if ('button' in event) {
            var b = event.button;
            if (b === 1) {
                return 4;
            }
            else if (b === 2) {
                return 2;
            }
            else if (b >= 0) {
                return 1 << b;
            }
        }
    }
    return 0;
}
function getModifiers(event) {
    return {
        alt: 'altKey' in event ? event.altKey : false,
        shift: 'shiftKey' in event ? event.shiftKey : false,
        control: 'ctrlKey' in event ? event.ctrlKey : false,
        meta: 'metaKey' in event ? event.metaKey : false
    };
}
var DefaultInputObserverProps = {
    noScroll: true,
    noMiddleClickScroll: true,
    noContextMenu: true,
    noPinchZoom: true,
    noTextSelect: true,
    mask: function (x, y) { return true; },
    pixelScale: 1
};
var ModifiersKeys;
(function (ModifiersKeys) {
    ModifiersKeys.None = create();
    function areEqual(a, b) {
        return a.shift === b.shift && a.alt === b.alt && a.control === b.control && a.meta === b.meta;
    }
    ModifiersKeys.areEqual = areEqual;
    function size(a) {
        if (!a)
            return 0;
        var ret = 0;
        if (!!a.shift)
            ret++;
        if (!!a.alt)
            ret++;
        if (!!a.control)
            ret++;
        if (!!a.meta)
            ret++;
        return ret;
    }
    ModifiersKeys.size = size;
    function create(modifierKeys) {
        if (modifierKeys === void 0) { modifierKeys = {}; }
        return {
            shift: !!modifierKeys.shift,
            alt: !!modifierKeys.alt,
            control: !!modifierKeys.control,
            meta: !!modifierKeys.meta
        };
    }
    ModifiersKeys.create = create;
})(ModifiersKeys || (ModifiersKeys = {}));
var ButtonsType;
(function (ButtonsType) {
    ButtonsType.has = _mol_util__WEBPACK_IMPORTED_MODULE_3__["BitFlags"].has;
    ButtonsType.create = _mol_util__WEBPACK_IMPORTED_MODULE_3__["BitFlags"].create;
})(ButtonsType || (ButtonsType = {}));
function createEvents() {
    return {
        drag: new rxjs__WEBPACK_IMPORTED_MODULE_1__["Subject"](),
        interactionEnd: new rxjs__WEBPACK_IMPORTED_MODULE_1__["Subject"](),
        click: new rxjs__WEBPACK_IMPORTED_MODULE_1__["Subject"](),
        move: new rxjs__WEBPACK_IMPORTED_MODULE_1__["Subject"](),
        wheel: new rxjs__WEBPACK_IMPORTED_MODULE_1__["Subject"](),
        pinch: new rxjs__WEBPACK_IMPORTED_MODULE_1__["Subject"](),
        resize: new rxjs__WEBPACK_IMPORTED_MODULE_1__["Subject"](),
        leave: new rxjs__WEBPACK_IMPORTED_MODULE_1__["Subject"](),
        enter: new rxjs__WEBPACK_IMPORTED_MODULE_1__["Subject"](),
        modifiers: new rxjs__WEBPACK_IMPORTED_MODULE_1__["Subject"](),
        key: new rxjs__WEBPACK_IMPORTED_MODULE_1__["Subject"](),
    };
}
var AllowedNonPrintableKeys = ['Backspace', 'Delete'];
var InputObserver;
(function (InputObserver) {
    function create(props) {
        if (props === void 0) { props = {}; }
        var _a = Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, DefaultInputObserverProps), props), noScroll = _a.noScroll, noContextMenu = _a.noContextMenu;
        return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({ noScroll: noScroll,
            noContextMenu: noContextMenu, width: 0, height: 0, pixelRatio: 1 }, createEvents()), { dispose: _mol_util__WEBPACK_IMPORTED_MODULE_3__["noop"] });
    }
    InputObserver.create = create;
    function fromElement(element, props) {
        if (props === void 0) { props = {}; }
        var _a = Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, DefaultInputObserverProps), props), noScroll = _a.noScroll, noMiddleClickScroll = _a.noMiddleClickScroll, noContextMenu = _a.noContextMenu, noPinchZoom = _a.noPinchZoom, noTextSelect = _a.noTextSelect, mask = _a.mask, pixelScale = _a.pixelScale;
        var width = element.clientWidth * pixelRatio();
        var height = element.clientHeight * pixelRatio();
        var lastTouchDistance = 0;
        var pointerDown = Object(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_2__["Vec2"])();
        var pointerStart = Object(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_2__["Vec2"])();
        var pointerEnd = Object(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_2__["Vec2"])();
        var pointerDelta = Object(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_2__["Vec2"])();
        var rectSize = Object(_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_2__["Vec2"])();
        var modifierKeys = {
            shift: false,
            alt: false,
            control: false,
            meta: false
        };
        function pixelRatio() {
            return window.devicePixelRatio * pixelScale;
        }
        function getModifierKeys() {
            return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, modifierKeys);
        }
        var dragging = 0 /* Stopped */;
        var disposed = false;
        var buttons = ButtonsType.create(0 /* None */);
        var button = 0 /* None */;
        var isInside = false;
        var events = createEvents();
        var drag = events.drag, interactionEnd = events.interactionEnd, wheel = events.wheel, pinch = events.pinch, click = events.click, move = events.move, leave = events.leave, enter = events.enter, resize = events.resize, modifiers = events.modifiers, key = events.key;
        attach();
        return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({ get noScroll() { return noScroll; }, set noScroll(value) { noScroll = value; }, get noContextMenu() { return noContextMenu; }, set noContextMenu(value) { noContextMenu = value; }, get width() { return width; },
            get height() { return height; },
            get pixelRatio() { return pixelRatio(); } }, events), { dispose: dispose });
        function attach() {
            element.addEventListener('contextmenu', onContextMenu, false);
            element.addEventListener('wheel', onMouseWheel, false);
            element.addEventListener('mousedown', onMouseDown, false);
            // for dragging to work outside canvas bounds,
            // mouse move/up events have to be added to a parent, i.e. window
            window.addEventListener('mousemove', onMouseMove, false);
            window.addEventListener('mouseup', onMouseUp, false);
            element.addEventListener('mouseenter', onMouseEnter, false);
            element.addEventListener('mouseleave', onMouseLeave, false);
            element.addEventListener('touchstart', onTouchStart, false);
            element.addEventListener('touchmove', onTouchMove, false);
            element.addEventListener('touchend', onTouchEnd, false);
            // reset buttons and modifier keys state when browser window looses focus
            window.addEventListener('blur', handleBlur);
            window.addEventListener('keyup', handleKeyUp, false);
            window.addEventListener('keydown', handleKeyDown, false);
            window.addEventListener('keypress', handleKeyPress, false);
            window.addEventListener('resize', onResize, false);
        }
        function dispose() {
            if (disposed)
                return;
            disposed = true;
            element.removeEventListener('contextmenu', onContextMenu, false);
            element.removeEventListener('wheel', onMouseWheel, false);
            element.removeEventListener('mousedown', onMouseDown, false);
            window.removeEventListener('mousemove', onMouseMove, false);
            window.removeEventListener('mouseup', onMouseUp, false);
            element.removeEventListener('mouseenter', onMouseEnter, false);
            element.removeEventListener('mouseleave', onMouseLeave, false);
            element.removeEventListener('touchstart', onTouchStart, false);
            element.removeEventListener('touchmove', onTouchMove, false);
            element.removeEventListener('touchend', onTouchEnd, false);
            window.removeEventListener('blur', handleBlur);
            window.removeEventListener('keyup', handleKeyUp, false);
            window.removeEventListener('keydown', handleKeyDown, false);
            window.removeEventListener('keypress', handleKeyPress, false);
            window.removeEventListener('resize', onResize, false);
        }
        function onContextMenu(event) {
            if (!mask(event.clientX, event.clientY))
                return;
            if (noContextMenu) {
                event.preventDefault();
            }
        }
        function updateModifierKeys(event) {
            modifierKeys.alt = event.altKey;
            modifierKeys.shift = event.shiftKey;
            modifierKeys.control = event.ctrlKey;
            modifierKeys.meta = event.metaKey;
        }
        function handleBlur() {
            if (buttons || modifierKeys.shift || modifierKeys.alt || modifierKeys.meta || modifierKeys.control) {
                buttons = 0;
                modifierKeys.shift = modifierKeys.alt = modifierKeys.control = modifierKeys.meta = false;
            }
        }
        function handleKeyDown(event) {
            var changed = false;
            if (!modifierKeys.alt && event.altKey) {
                changed = true;
                modifierKeys.alt = true;
            }
            if (!modifierKeys.shift && event.shiftKey) {
                changed = true;
                modifierKeys.shift = true;
            }
            if (!modifierKeys.control && event.ctrlKey) {
                changed = true;
                modifierKeys.control = true;
            }
            if (!modifierKeys.meta && event.metaKey) {
                changed = true;
                modifierKeys.meta = true;
            }
            if (changed && isInside)
                modifiers.next(getModifierKeys());
        }
        function handleKeyUp(event) {
            var changed = false;
            if (modifierKeys.alt && !event.altKey) {
                changed = true;
                modifierKeys.alt = false;
            }
            if (modifierKeys.shift && !event.shiftKey) {
                changed = true;
                modifierKeys.shift = false;
            }
            if (modifierKeys.control && !event.ctrlKey) {
                changed = true;
                modifierKeys.control = false;
            }
            if (modifierKeys.meta && !event.metaKey) {
                changed = true;
                modifierKeys.meta = false;
            }
            if (changed && isInside)
                modifiers.next(getModifierKeys());
            if (AllowedNonPrintableKeys.includes(event.key))
                handleKeyPress(event);
        }
        function handleKeyPress(event) {
            key.next({
                key: event.key,
                modifiers: getModifierKeys()
            });
        }
        function getCenterTouch(ev) {
            var t0 = ev.touches[0];
            var t1 = ev.touches[1];
            return {
                clientX: (t0.clientX + t1.clientX) / 2,
                clientY: (t0.clientY + t1.clientY) / 2,
                pageX: (t0.pageX + t1.pageX) / 2,
                pageY: (t0.pageY + t1.pageY) / 2
            };
        }
        function getTouchDistance(ev) {
            var dx = ev.touches[0].pageX - ev.touches[1].pageX;
            var dy = ev.touches[0].pageY - ev.touches[1].pageY;
            return Math.sqrt(dx * dx + dy * dy);
        }
        function onTouchStart(ev) {
            if (ev.touches.length === 1) {
                buttons = button = 1 /* Primary */;
                onPointerDown(ev.touches[0]);
            }
            else if (ev.touches.length === 2) {
                buttons = 2 /* Secondary */ & 4 /* Auxilary */;
                button = 2 /* Secondary */;
                onPointerDown(getCenterTouch(ev));
                var touchDistance = getTouchDistance(ev);
                lastTouchDistance = touchDistance;
                pinch.next({
                    distance: touchDistance,
                    fraction: 1,
                    delta: 0,
                    isStart: true,
                    buttons: buttons,
                    button: button,
                    modifiers: getModifierKeys()
                });
            }
            else if (ev.touches.length === 3) {
                buttons = button = 8 /* Forth */;
                onPointerDown(getCenterTouch(ev));
            }
        }
        function onTouchEnd(ev) {
            endDrag();
        }
        function onTouchMove(ev) {
            button = 0 /* None */;
            if (noPinchZoom) {
                ev.preventDefault();
                ev.stopPropagation();
                if (ev.originalEvent) {
                    ev.originalEvent.preventDefault();
                    ev.originalEvent.stopPropagation();
                }
            }
            if (ev.touches.length === 1) {
                buttons = 1 /* Primary */;
                onPointerMove(ev.touches[0]);
            }
            else if (ev.touches.length === 2) {
                var touchDistance = getTouchDistance(ev);
                var touchDelta = lastTouchDistance - touchDistance;
                if (Math.abs(touchDelta) < 4) {
                    buttons = 2 /* Secondary */;
                    onPointerMove(getCenterTouch(ev));
                }
                else {
                    buttons = 4 /* Auxilary */;
                    updateModifierKeys(ev);
                    pinch.next({
                        delta: touchDelta,
                        fraction: lastTouchDistance / touchDistance,
                        distance: touchDistance,
                        isStart: false,
                        buttons: buttons,
                        button: button,
                        modifiers: getModifierKeys()
                    });
                }
                lastTouchDistance = touchDistance;
            }
            else if (ev.touches.length === 3) {
                buttons = 8 /* Forth */;
                onPointerMove(getCenterTouch(ev));
            }
        }
        function onMouseDown(ev) {
            updateModifierKeys(ev);
            buttons = getButtons(ev);
            button = getButton(ev);
            if (noMiddleClickScroll && buttons === 4 /* Auxilary */) {
                ev.preventDefault;
            }
            onPointerDown(ev);
        }
        function onMouseMove(ev) {
            updateModifierKeys(ev);
            buttons = getButtons(ev);
            button = 0 /* None */;
            onPointerMove(ev);
        }
        function onMouseUp(ev) {
            updateModifierKeys(ev);
            buttons = getButtons(ev);
            button = getButton(ev);
            onPointerUp(ev);
            endDrag();
        }
        function endDrag() {
            interactionEnd.next();
        }
        function onPointerDown(ev) {
            if (!mask(ev.clientX, ev.clientY))
                return;
            eventOffset(pointerStart, ev);
            _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_2__["Vec2"].copy(pointerDown, pointerStart);
            if (insideBounds(pointerStart)) {
                dragging = 1 /* Started */;
            }
        }
        function onPointerUp(ev) {
            dragging = 0 /* Stopped */;
            if (!mask(ev.clientX, ev.clientY))
                return;
            eventOffset(pointerEnd, ev);
            if (_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_2__["Vec2"].distance(pointerEnd, pointerDown) < 4) {
                var pageX = ev.pageX, pageY = ev.pageY;
                var x = pointerEnd[0], y = pointerEnd[1];
                click.next({ x: x, y: y, pageX: pageX, pageY: pageY, buttons: buttons, button: button, modifiers: getModifierKeys() });
            }
        }
        function onPointerMove(ev) {
            var _a;
            eventOffset(pointerEnd, ev);
            var pageX = ev.pageX, pageY = ev.pageY;
            var x = pointerEnd[0], y = pointerEnd[1];
            var inside = insideBounds(pointerEnd);
            move.next({ x: x, y: y, pageX: pageX, pageY: pageY, buttons: buttons, button: button, modifiers: getModifierKeys(), inside: inside });
            if (dragging === 0 /* Stopped */)
                return;
            if (noTextSelect) {
                (_a = ev.preventDefault) === null || _a === void 0 ? void 0 : _a.call(ev);
            }
            _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_2__["Vec2"].div(pointerDelta, _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_2__["Vec2"].sub(pointerDelta, pointerEnd, pointerStart), getClientSize(rectSize));
            if (_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_2__["Vec2"].magnitude(pointerDelta) < _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_2__["EPSILON"])
                return;
            var isStart = dragging === 1 /* Started */;
            if (isStart && !mask(ev.clientX, ev.clientY))
                return;
            var dx = pointerDelta[0], dy = pointerDelta[1];
            drag.next({ x: x, y: y, dx: dx, dy: dy, pageX: pageX, pageY: pageY, buttons: buttons, button: button, modifiers: getModifierKeys(), isStart: isStart });
            _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_2__["Vec2"].copy(pointerStart, pointerEnd);
            dragging = 2 /* Moving */;
        }
        function onMouseWheel(ev) {
            if (!mask(ev.clientX, ev.clientY))
                return;
            eventOffset(pointerEnd, ev);
            var pageX = ev.pageX, pageY = ev.pageY;
            var x = pointerEnd[0], y = pointerEnd[1];
            if (noScroll) {
                ev.preventDefault();
            }
            var scale = 1;
            switch (ev.deltaMode) {
                case 0:
                    scale = 1;
                    break; // pixels
                case 1:
                    scale = 40;
                    break; // lines
                case 2:
                    scale = 800;
                    break; // pages
            }
            var dx = (ev.deltaX || 0) * scale;
            var dy = (ev.deltaY || 0) * scale;
            var dz = (ev.deltaZ || 0) * scale;
            buttons = button = 4 /* Auxilary */;
            if (dx || dy || dz) {
                wheel.next({ x: x, y: y, pageX: pageX, pageY: pageY, dx: dx, dy: dy, dz: dz, buttons: buttons, button: button, modifiers: getModifierKeys() });
            }
        }
        function onMouseEnter(ev) {
            isInside = true;
            enter.next();
        }
        function onMouseLeave(ev) {
            isInside = false;
            leave.next();
        }
        function onResize(ev) {
            resize.next();
        }
        function insideBounds(pos) {
            if (element instanceof Window || element instanceof Document || element === document.body) {
                return true;
            }
            else {
                var rect = element.getBoundingClientRect();
                return pos[0] >= 0 && pos[1] >= 0 && pos[0] < rect.width && pos[1] < rect.height;
            }
        }
        function getClientSize(out) {
            out[0] = element.clientWidth;
            out[1] = element.clientHeight;
            return out;
        }
        function eventOffset(out, ev) {
            width = element.clientWidth * pixelRatio();
            height = element.clientHeight * pixelRatio();
            var cx = ev.clientX || 0;
            var cy = ev.clientY || 0;
            var rect = element.getBoundingClientRect();
            out[0] = cx - rect.left;
            out[1] = cy - rect.top;
            return out;
        }
    }
    InputObserver.fromElement = fromElement;
})(InputObserver || (InputObserver = {}));
/* harmony default export */ __webpack_exports__["default"] = (InputObserver);
//# sourceMappingURL=input-observer.js.map

/***/ }),

/***/ "./lib/mol-util/legend.js":
/*!********************************!*\
  !*** ./lib/mol-util/legend.js ***!
  \********************************/
/*! exports provided: TableLegend, ScaleLegend */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "TableLegend", function() { return TableLegend; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ScaleLegend", function() { return ScaleLegend; });
/**
 * Copyright (c) 2018-2019 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */
function TableLegend(table) {
    return { kind: 'table-legend', table: table };
}
function ScaleLegend(minLabel, maxLabel, colors) {
    return { kind: 'scale-legend', minLabel: minLabel, maxLabel: maxLabel, colors: colors };
}
//# sourceMappingURL=legend.js.map

/***/ }),

/***/ "./lib/mol-util/log-entry.js":
/*!***********************************!*\
  !*** ./lib/mol-util/log-entry.js ***!
  \***********************************/
/*! exports provided: LogEntry */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "LogEntry", function() { return LogEntry; });
/**
 * Copyright (c) 2018 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author David Sehnal <david.sehnal@gmail.com>
 */

var LogEntry;
(function (LogEntry) {
    function message(msg) { return { type: 'message', timestamp: new Date(), message: msg }; }
    LogEntry.message = message;
    function error(msg) { return { type: 'error', timestamp: new Date(), message: msg }; }
    LogEntry.error = error;
    function warning(msg) { return { type: 'warning', timestamp: new Date(), message: msg }; }
    LogEntry.warning = warning;
    function info(msg) { return { type: 'info', timestamp: new Date(), message: msg }; }
    LogEntry.info = info;
})(LogEntry || (LogEntry = {}));
//# sourceMappingURL=log-entry.js.map

/***/ }),

/***/ "./lib/mol-util/lru-cache.js":
/*!***********************************!*\
  !*** ./lib/mol-util/lru-cache.js ***!
  \***********************************/
/*! exports provided: LRUCache */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "LRUCache", function() { return LRUCache; });
/* harmony import */ var _mol_data_generic__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../mol-data/generic */ "./lib/mol-data/generic.js");
/**
 * Copyright (c) 2019 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * Adapted from LiteMol.
 * @author David Sehnal <david.sehnal@gmail.com>
 */


var LRUCache;
(function (LRUCache) {
    function entry(key, data) {
        return { key: key, data: data };
    }
    function create(capacity) {
        return {
            entries: Object(_mol_data_generic__WEBPACK_IMPORTED_MODULE_0__["LinkedList"])(),
            capacity: Math.max(1, capacity)
        };
    }
    LRUCache.create = create;
    function get(cache, key) {
        for (var e = cache.entries.first; e; e = e.next) {
            if (e.value.key === key) {
                cache.entries.remove(e);
                cache.entries.addLast(e.value);
                return e.value.data;
            }
        }
        return void 0;
    }
    LRUCache.get = get;
    function set(cache, key, data) {
        var removed = undefined;
        if (cache.entries.count >= cache.capacity) {
            var first = cache.entries.first;
            removed = first.value.data;
            cache.entries.remove(first);
        }
        cache.entries.addLast(entry(key, data));
        return removed;
    }
    LRUCache.set = set;
})(LRUCache || (LRUCache = {}));
//# sourceMappingURL=lru-cache.js.map

/***/ }),

/***/ "./lib/mol-util/marker-action.js":
/*!***************************************!*\
  !*** ./lib/mol-util/marker-action.js ***!
  \***************************************/
/*! exports provided: MarkerAction, MarkerActions, applyMarkerActionAtPosition, applyMarkerAction */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MarkerAction", function() { return MarkerAction; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MarkerActions", function() { return MarkerActions; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "applyMarkerActionAtPosition", function() { return applyMarkerActionAtPosition; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "applyMarkerAction", function() { return applyMarkerAction; });
/* harmony import */ var _mol_data_int__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../mol-data/int */ "./lib/mol-data/int.js");
/* harmony import */ var _bit_flags__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./bit-flags */ "./lib/mol-util/bit-flags.js");
/**
 * Copyright (c) 2018-2020 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */


var MarkerAction;
(function (MarkerAction) {
    MarkerAction[MarkerAction["None"] = 0] = "None";
    MarkerAction[MarkerAction["Highlight"] = 1] = "Highlight";
    MarkerAction[MarkerAction["RemoveHighlight"] = 2] = "RemoveHighlight";
    MarkerAction[MarkerAction["Select"] = 4] = "Select";
    MarkerAction[MarkerAction["Deselect"] = 8] = "Deselect";
    MarkerAction[MarkerAction["Toggle"] = 16] = "Toggle";
    MarkerAction[MarkerAction["Clear"] = 32] = "Clear";
})(MarkerAction || (MarkerAction = {}));
var MarkerActions;
(function (MarkerActions) {
    MarkerActions.is = _bit_flags__WEBPACK_IMPORTED_MODULE_1__["default"].has;
    MarkerActions.All = (MarkerAction.Highlight | MarkerAction.RemoveHighlight |
        MarkerAction.Select | MarkerAction.Deselect | MarkerAction.Toggle |
        MarkerAction.Clear);
    MarkerActions.Highlighting = (MarkerAction.Highlight | MarkerAction.RemoveHighlight |
        MarkerAction.Clear);
    MarkerActions.Selecting = (MarkerAction.Select | MarkerAction.Deselect | MarkerAction.Toggle |
        MarkerAction.Clear);
})(MarkerActions || (MarkerActions = {}));
function applyMarkerActionAtPosition(array, i, action) {
    var v = array[i];
    switch (action) {
        case MarkerAction.Highlight:
            if (v % 2 === 0) {
                array[i] = v + 1;
                return true;
            }
            return false;
        case MarkerAction.RemoveHighlight:
            if (v % 2 !== 0) {
                array[i] = v - 1;
                return true;
            }
            return false;
        case MarkerAction.Select:
            if (v < 2) {
                array[i] = v + 2;
                return true;
            }
            return false;
        case MarkerAction.Deselect:
            array[i] = v % 2;
            return array[i] !== v;
        case MarkerAction.Toggle:
            if (v >= 2)
                array[i] = v - 2;
            else
                array[i] = v + 2;
            return true;
        case MarkerAction.Clear:
            array[i] = 0;
            return v !== 0;
    }
    return false;
}
function applyMarkerAction(array, set, action) {
    var changed = false;
    if (_mol_data_int__WEBPACK_IMPORTED_MODULE_0__["Interval"].is(set)) {
        for (var i = _mol_data_int__WEBPACK_IMPORTED_MODULE_0__["Interval"].start(set), _i = _mol_data_int__WEBPACK_IMPORTED_MODULE_0__["Interval"].end(set); i < _i; i++) {
            changed = applyMarkerActionAtPosition(array, i, action) || changed;
        }
    }
    else {
        for (var i = 0, _i = set.length; i < _i; i++) {
            changed = applyMarkerActionAtPosition(array, set[i], action) || changed;
        }
    }
    return changed;
}
//# sourceMappingURL=marker-action.js.map

/***/ }),

/***/ "./lib/mol-util/mask.js":
/*!******************************!*\
  !*** ./lib/mol-util/mask.js ***!
  \******************************/
/*! exports provided: sortAsc, default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "sortAsc", function() { return sortAsc; });
/**
 * Copyright (c) 2017 Mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author David Sehnal <david.sehnal@gmail.com>
 */
// TODO check if the removal of FastSet and the removal of the context object for forEach
// have any performance implications
function _ascSort(a, b) {
    return a - b;
}
function sortAsc(array) {
    Array.prototype.sort.call(array, _ascSort);
    return array;
}
var Mask;
(function (Mask) {
    var EmptyMask = /** @class */ (function () {
        function EmptyMask() {
            this.size = 0;
        }
        EmptyMask.prototype.has = function (i) { return false; };
        EmptyMask.prototype.forEach = function (f, ctx) { return ctx; };
        return EmptyMask;
    }());
    var SingletonMask = /** @class */ (function () {
        function SingletonMask(idx) {
            this.idx = idx;
            this.size = 1;
        }
        SingletonMask.prototype.has = function (i) { return i === this.idx; };
        SingletonMask.prototype.forEach = function (f, ctx) { f(this.idx, ctx); return ctx; };
        return SingletonMask;
    }());
    var BitMask = /** @class */ (function () {
        function BitMask(mask, size) {
            this.mask = mask;
            this.size = size;
            this.length = mask.length;
        }
        BitMask.prototype.has = function (i) { return i < this.length && !!this.mask[i]; };
        BitMask.prototype._forEach = function (f, ctx) {
            for (var i = 0; i < this.length; i++) {
                if (this.mask[i])
                    f(i, ctx);
            }
        };
        BitMask.prototype.forEach = function (f, ctx) {
            this._forEach(f, ctx);
            return ctx;
        };
        return BitMask;
    }());
    var AllMask = /** @class */ (function () {
        function AllMask(size) {
            this.size = size;
        }
        AllMask.prototype.has = function (i) { return true; };
        AllMask.prototype._forEach = function (f, ctx) {
            for (var i = 0; i < this.size; i++) {
                f(i, ctx);
            }
        };
        AllMask.prototype.forEach = function (f, ctx) {
            this._forEach(f, ctx);
            return ctx;
        };
        return AllMask;
    }());
    var SetMask = /** @class */ (function () {
        function SetMask(set) {
            this.set = set;
            this._flat = void 0;
            this.size = set.size;
        }
        SetMask.prototype.has = function (i) { return this.set.has(i); };
        SetMask.prototype._forEach = function (f, ctx) {
            for (var _i = 0, _a = this.flatten(); _i < _a.length; _i++) {
                var idx = _a[_i];
                f(idx, ctx);
            }
        };
        SetMask.prototype.flatten = function () {
            if (this._flat)
                return this._flat;
            var indices = new Int32Array(this.size);
            var offset = 0;
            this.set.forEach(function (i) { return indices[offset++] = i; });
            sortAsc(indices);
            this._flat = indices;
            return this._flat;
        };
        SetMask.prototype.forEach = function (f, ctx) {
            this._forEach(f, ctx);
            return ctx;
        };
        return SetMask;
    }());
    function always(size) { return new AllMask(size); }
    Mask.always = always;
    Mask.never = new EmptyMask();
    function ofSet(set) {
        return new SetMask(set);
    }
    Mask.ofSet = ofSet;
    function singleton(i) {
        return new SingletonMask(i);
    }
    Mask.singleton = singleton;
    function ofUniqueIndices(indices) {
        var len = indices.length;
        if (len === 0)
            return new EmptyMask();
        if (len === 1)
            return new SingletonMask(indices[0]);
        var max = 0;
        for (var _i = 0, _a = indices; _i < _a.length; _i++) {
            var i = _a[_i];
            if (i > max)
                max = i;
        }
        if (len === max)
            return new AllMask(len);
        var f = len / max;
        if (f < 1 / 12) {
            var set = new Set();
            for (var _b = 0, _c = indices; _b < _c.length; _b++) {
                var i = _c[_b];
                set.add(i);
            }
            return new SetMask(set);
        }
        var mask = new Int8Array(max + 1);
        for (var _d = 0, _e = indices; _d < _e.length; _d++) {
            var i = _e[_d];
            mask[i] = 1;
        }
        return new BitMask(mask, indices.length);
    }
    Mask.ofUniqueIndices = ofUniqueIndices;
    function ofMask(mask, size) {
        return new BitMask(mask, size);
    }
    Mask.ofMask = ofMask;
    function hasAny(mask, xs) {
        for (var _i = 0, xs_1 = xs; _i < xs_1.length; _i++) {
            var x = xs_1[_i];
            if (mask.has(x))
                return true;
        }
        return false;
    }
    Mask.hasAny = hasAny;
    function complement(mask, against) {
        var count = 0;
        var max = 0;
        against.forEach(function (i) {
            if (!mask.has(i)) {
                count++;
                if (i > max)
                    max = i;
            }
        });
        if (count / max < 1 / 12) {
            // set based
            var set_1 = new Set();
            against.forEach(function (i) {
                if (!mask.has(i)) {
                    set_1.add(i);
                }
            });
            return ofSet(set_1);
        }
        else {
            // mask based
            var target_1 = new Uint8Array(max + 1);
            against.forEach(function (i) {
                if (!mask.has(i)) {
                    target_1[i] = 1;
                }
            });
            return ofMask(target_1, count);
        }
    }
    Mask.complement = complement;
})(Mask || (Mask = {}));
/* harmony default export */ __webpack_exports__["default"] = (Mask);
//# sourceMappingURL=mask.js.map

/***/ }),

/***/ "./lib/mol-util/memoize.js":
/*!*********************************!*\
  !*** ./lib/mol-util/memoize.js ***!
  \*********************************/
/*! exports provided: memoizeLatest, memoize1 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "memoizeLatest", function() { return memoizeLatest; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "memoize1", function() { return memoize1; });
/**
 * Copyright (c) 2018 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author David Sehnal <david.sehnal@gmail.com>
 */
/** Cache the latest result from calls to a function with any number of arguments */
function memoizeLatest(f) {
    var lastArgs = void 0, value = void 0;
    return function () {
        var args = [];
        for (var _a = 0; _a < arguments.length; _a++) {
            args[_a] = arguments[_a];
        }
        if (!lastArgs || lastArgs.length !== args.length) {
            lastArgs = args;
            value = f.apply(void 0, args);
            return value;
        }
        for (var i = 0, _i = args.length; i < _i; i++) {
            if (args[i] !== lastArgs[i]) {
                lastArgs = args;
                value = f.apply(void 0, args);
                return value;
            }
        }
        return value;
    };
}
/** Cache all results from calls to a function with a single argument */
function memoize1(f) {
    var cache = new Map();
    return function (a) {
        if (cache.has(a))
            return cache.get(a);
        var v = f(a);
        cache.set(a, v);
        return v;
    };
}
//# sourceMappingURL=memoize.js.map

/***/ }),

/***/ "./lib/mol-util/monadic-parser.js":
/*!****************************************!*\
  !*** ./lib/mol-util/monadic-parser.js ***!
  \****************************************/
/*! exports provided: MonadicParser */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MonadicParser", function() { return MonadicParser; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/**
 * Copyright (c) 2018 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author David Sehnal <david.sehnal@gmail.com>
 */

/**
 * Adapted from Parsimmon (https://github.com/jneen/parsimmon)
 * Copyright (c) 2011-present J. Adkisson (http://jneen.net).
 */
var MonadicParser = /** @class */ (function () {
    function MonadicParser(_) {
        this._ = _;
    }
    MonadicParser.prototype.parse = function (input) {
        var result = this.skip(MonadicParser.eof)._(input, 0);
        if (result.status) {
            return { success: true, value: result.value };
        }
        return { success: false, index: makeLineColumnIndex(input, result.furthest), expected: result.expected };
    };
    ;
    MonadicParser.prototype.tryParse = function (str) {
        var result = this.parse(str);
        if (result.success) {
            return result.value;
        }
        else {
            var msg = formatError(str, result);
            var err = new Error(msg);
            throw err;
        }
    };
    MonadicParser.prototype.or = function (alternative) {
        return MonadicParser.alt(this, alternative);
    };
    MonadicParser.prototype.trim = function (parser) {
        return this.wrap(parser, parser);
    };
    MonadicParser.prototype.wrap = function (leftParser, rightParser) {
        return seqPick(1, typeof leftParser === 'string' ? MonadicParser.string(leftParser) : leftParser, this, typeof rightParser === 'string' ? MonadicParser.string(rightParser) : rightParser);
    };
    MonadicParser.prototype.thru = function (wrapper) {
        return wrapper(this);
    };
    MonadicParser.prototype.then = function (next) {
        return seqPick(1, this, next);
    };
    MonadicParser.prototype.many = function () {
        var _this = this;
        return new MonadicParser(function (input, i) {
            var accum = [];
            var result = void 0;
            while (true) {
                result = mergeReplies(_this._(input, i), result);
                if (result.status) {
                    if (i === result.index) {
                        throw new Error('infinite loop detected in .many() parser --- calling .many() on a parser which can accept zero characters is usually the cause');
                    }
                    i = result.index;
                    accum.push(result.value);
                }
                else {
                    return mergeReplies(makeSuccess(i, accum), result);
                }
            }
        });
    };
    ;
    MonadicParser.prototype.times = function (min, _max) {
        var _this = this;
        var max = typeof _max === 'undefined' ? min : _max;
        return new MonadicParser(function (input, i) {
            var accum = [];
            var result = void 0;
            var prevResult = void 0;
            var times;
            for (times = 0; times < min; times++) {
                result = _this._(input, i);
                prevResult = mergeReplies(result, prevResult);
                if (result.status) {
                    i = result.index;
                    accum.push(result.value);
                }
                else {
                    return prevResult;
                }
            }
            for (; times < max; times += 1) {
                result = _this._(input, i);
                prevResult = mergeReplies(result, prevResult);
                if (result.status) {
                    i = result.index;
                    accum.push(result.value);
                }
                else {
                    break;
                }
            }
            return mergeReplies(makeSuccess(i, accum), prevResult);
        });
    };
    ;
    MonadicParser.prototype.result = function (res) {
        return this.map(function () { return res; });
    };
    ;
    MonadicParser.prototype.atMost = function (n) {
        return this.times(0, n);
    };
    ;
    MonadicParser.prototype.atLeast = function (n) {
        return MonadicParser.seq(this.times(n), this.many()).map(function (r) { return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__spreadArrays"])(r[0], r[1]); });
    };
    ;
    MonadicParser.prototype.map = function (f) {
        var _this = this;
        return new MonadicParser(function (input, i) {
            var result = _this._(input, i);
            if (!result.status) {
                return result;
            }
            return mergeReplies(makeSuccess(result.index, f(result.value)), result);
        });
    };
    MonadicParser.prototype.skip = function (next) {
        return seqPick(0, this, next);
    };
    MonadicParser.prototype.mark = function () {
        return MonadicParser.seq(MonadicParser.index, this, MonadicParser.index).map(function (r) { return ({ start: r[0], value: r[1], end: r[2] }); });
    };
    MonadicParser.prototype.node = function (name) {
        return MonadicParser.seq(MonadicParser.index, this, MonadicParser.index).map(function (r) { return ({ name: name, start: r[0], value: r[1], end: r[2] }); });
    };
    ;
    MonadicParser.prototype.sepBy = function (separator) {
        return MonadicParser.sepBy(this, separator);
    };
    MonadicParser.prototype.sepBy1 = function (separator) {
        return MonadicParser.sepBy1(this, separator);
    };
    MonadicParser.prototype.lookahead = function (x) {
        return this.skip(MonadicParser.lookahead(x));
    };
    ;
    MonadicParser.prototype.notFollowedBy = function (x) {
        return this.skip(MonadicParser.notFollowedBy(x));
    };
    ;
    MonadicParser.prototype.desc = function (expected) {
        var _this = this;
        return new MonadicParser(function (input, i) {
            var reply = _this._(input, i);
            if (!reply.status) {
                reply.expected = [expected];
            }
            return reply;
        });
    };
    ;
    MonadicParser.prototype.fallback = function (result) {
        return this.or(MonadicParser.succeed(result));
    };
    ;
    MonadicParser.prototype.ap = function (other) {
        return MonadicParser.seq(other, this).map(function (_a) {
            var f = _a[0], x = _a[1];
            return f(x);
        });
    };
    ;
    MonadicParser.prototype.chain = function (f) {
        var _this = this;
        return new MonadicParser(function (input, i) {
            var result = _this._(input, i);
            if (!result.status) {
                return result;
            }
            var nextParser = f(result.value);
            return mergeReplies(nextParser._(input, result.index), result);
        });
    };
    ;
    return MonadicParser;
}());

(function (MonadicParser) {
    function seq() {
        var parsers = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            parsers[_i] = arguments[_i];
        }
        var numParsers = parsers.length;
        return new MonadicParser(function (input, index) {
            var result;
            var accum = new Array(numParsers);
            var i = index;
            for (var j = 0; j < numParsers; j++) {
                result = mergeReplies(parsers[j]._(input, i), result);
                if (!result.status) {
                    return result;
                }
                accum[j] = result.value;
                i = result.index;
            }
            return mergeReplies(makeSuccess(i, accum), result);
        });
    }
    MonadicParser.seq = seq;
    function alt() {
        var parsers = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            parsers[_i] = arguments[_i];
        }
        var numParsers = parsers.length;
        if (numParsers === 0) {
            return fail('zero alternates');
        }
        return new MonadicParser(function (input, i) {
            var result;
            for (var j = 0; j < parsers.length; j++) {
                result = mergeReplies(parsers[j]._(input, i), result);
                if (result.status) {
                    return result;
                }
            }
            return result;
        });
    }
    MonadicParser.alt = alt;
    function sepBy(parser, separator) {
        return sepBy1(parser, separator).or(succeed([]));
    }
    MonadicParser.sepBy = sepBy;
    function sepBy1(parser, separator) {
        var pairs = separator.then(parser).many();
        return seq(parser, pairs).map(function (r) { return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__spreadArrays"])([r[0]], r[1]); });
    }
    MonadicParser.sepBy1 = sepBy1;
    function string(str) {
        var expected = "'" + str + "'";
        if (str.length === 1) {
            var code_1 = str.charCodeAt(0);
            return new MonadicParser(function (input, i) { return input.charCodeAt(i) === code_1 ? makeSuccess(i + 1, str) : makeFailure(i, expected); });
        }
        return new MonadicParser(function (input, i) {
            var j = i + str.length;
            if (input.slice(i, j) === str)
                return makeSuccess(j, str);
            else
                return makeFailure(i, expected);
        });
    }
    MonadicParser.string = string;
    function flags(re) {
        var s = '' + re;
        return s.slice(s.lastIndexOf('/') + 1);
    }
    function anchoredRegexp(re) {
        return RegExp('^(?:' + re.source + ')', flags(re));
    }
    function regexp(re, group) {
        if (group === void 0) { group = 0; }
        var anchored = anchoredRegexp(re);
        var expected = '' + re;
        return new MonadicParser(function (input, i) {
            var match = anchored.exec(input.slice(i));
            if (match) {
                if (0 <= group && group <= match.length) {
                    var fullMatch = match[0];
                    var groupMatch = match[group];
                    return makeSuccess(i + fullMatch.length, groupMatch);
                }
                var message = "invalid match group (0 to " + match.length + ") in " + expected;
                return makeFailure(i, message);
            }
            return makeFailure(i, expected);
        });
    }
    MonadicParser.regexp = regexp;
    function succeed(value) {
        return new MonadicParser(function (input, i) { return makeSuccess(i, value); });
    }
    MonadicParser.succeed = succeed;
    function fail(expected) {
        return new MonadicParser(function (input, i) { return makeFailure(i, expected); });
    }
    MonadicParser.fail = fail;
    function lookahead(x) {
        if (isParser(x)) {
            return new MonadicParser(function (input, i) {
                var result = x._(input, i);
                if (result.status) {
                    result.index = i;
                    result.value = null;
                }
                return result;
            });
        }
        else if (typeof x === 'string') {
            return lookahead(string(x));
        }
        else if (x instanceof RegExp) {
            return lookahead(regexp(x));
        }
        throw new Error('not a string, regexp, or parser: ' + x);
    }
    MonadicParser.lookahead = lookahead;
    function notFollowedBy(parser) {
        return new MonadicParser(function (input, i) {
            var result = parser._(input, i);
            return result.status
                ? makeFailure(i, 'not "' + input.slice(i, result.index) + '"')
                : makeSuccess(i, null);
        });
    }
    MonadicParser.notFollowedBy = notFollowedBy;
    function test(predicate) {
        return new MonadicParser(function (input, i) {
            var char = input.charAt(i);
            if (i < input.length && predicate(char)) {
                return makeSuccess(i + 1, char);
            }
            else {
                return makeFailure(i, 'a character ' + predicate);
            }
        });
    }
    MonadicParser.test = test;
    function oneOf(str) {
        return test(function (ch) { return str.indexOf(ch) >= 0; });
    }
    MonadicParser.oneOf = oneOf;
    function noneOf(str) {
        return test(function (ch) { return str.indexOf(ch) < 0; });
    }
    MonadicParser.noneOf = noneOf;
    function range(begin, end) {
        return test(function (ch) { return begin <= ch && ch <= end; }).desc(begin + '-' + end);
    }
    MonadicParser.range = range;
    function takeWhile(predicate) {
        return new MonadicParser(function (input, i) {
            var j = i;
            while (j < input.length && predicate(input.charAt(j))) {
                j++;
            }
            return makeSuccess(j, input.slice(i, j));
        });
    }
    MonadicParser.takeWhile = takeWhile;
    function lazy(f) {
        var parser = new MonadicParser(function (input, i) {
            var a = f()._;
            parser._ = a;
            return a(input, i);
        });
        return parser;
    }
    MonadicParser.lazy = lazy;
    function empty() {
        return fail('empty');
    }
    MonadicParser.empty = empty;
    MonadicParser.index = new MonadicParser(function (input, i) {
        return makeSuccess(i, makeLineColumnIndex(input, i));
    });
    MonadicParser.anyChar = new MonadicParser(function (input, i) {
        if (i >= input.length) {
            return makeFailure(i, 'any character');
        }
        return makeSuccess(i + 1, input.charAt(i));
    });
    MonadicParser.all = new MonadicParser(function (input, i) {
        return makeSuccess(input.length, input.slice(i));
    });
    MonadicParser.eof = new MonadicParser(function (input, i) {
        if (i < input.length) {
            return makeFailure(i, 'EOF');
        }
        return makeSuccess(i, null);
    });
    MonadicParser.digit = regexp(/[0-9]/).desc('a digit');
    MonadicParser.digits = regexp(/[0-9]*/).desc('optional digits');
    MonadicParser.letter = regexp(/[a-z]/i).desc('a letter');
    MonadicParser.letters = regexp(/[a-z]*/i).desc('optional letters');
    MonadicParser.optWhitespace = regexp(/\s*/).desc('optional whitespace');
    MonadicParser.whitespace = regexp(/\s+/).desc('whitespace');
    MonadicParser.cr = string('\r');
    MonadicParser.lf = string('\n');
    MonadicParser.crlf = string('\r\n');
    MonadicParser.newline = alt(MonadicParser.crlf, MonadicParser.lf, MonadicParser.cr).desc('newline');
    MonadicParser.end = alt(MonadicParser.newline, MonadicParser.eof);
})(MonadicParser || (MonadicParser = {}));
function seqPick(idx) {
    var parsers = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        parsers[_i - 1] = arguments[_i];
    }
    var numParsers = parsers.length;
    return new MonadicParser(function (input, index) {
        var result;
        var picked;
        var i = index;
        for (var j = 0; j < numParsers; j++) {
            result = mergeReplies(parsers[j]._(input, i), result);
            if (!result.status) {
                return result;
            }
            if (idx === j)
                picked = result.value;
            i = result.index;
        }
        return mergeReplies(makeSuccess(i, picked), result);
    });
}
function makeSuccess(index, value) {
    return { status: true, index: index, value: value };
}
function makeFailure(index, expected) {
    return { status: false, furthest: index, expected: [expected] };
}
function mergeReplies(result, last) {
    if (!last || result.status || last.status || result.furthest > last.furthest) {
        return result;
    }
    var expected = result.furthest === last.furthest
        ? unsafeUnion(result.expected, last.expected)
        : last.expected;
    return { status: result.status, furthest: last.furthest, expected: expected };
}
function makeLineColumnIndex(input, i) {
    var lines = input.slice(0, i).split('\n');
    // Note that unlike the character offset, the line and column offsets are
    // 1-based.
    var lineWeAreUpTo = lines.length;
    var columnWeAreUpTo = lines[lines.length - 1].length + 1;
    return { offset: i, line: lineWeAreUpTo, column: columnWeAreUpTo };
}
function formatExpected(expected) {
    if (expected.length === 1) {
        return expected[0];
    }
    return 'one of ' + expected.join(', ');
}
function formatGot(input, error) {
    var index = error.index;
    var i = index.offset;
    if (i === input.length) {
        return ', got the end of the input';
    }
    var prefix = i > 0 ? '\'...' : '\'';
    var suffix = input.length - i > 12 ? '...\'' : '\'';
    return " at line " + index.line + " column " + index.column + ", got " + prefix + input.slice(i, i + 12) + suffix;
}
function formatError(input, error) {
    return "expected " + formatExpected(error.expected) + formatGot(input, error);
}
function unsafeUnion(xs, ys) {
    var xn = xs.length;
    var yn = ys.length;
    if (xn === 0)
        return ys;
    else if (yn === 0)
        return xs;
    var set = new Set();
    var ret = [];
    for (var i = 0; i < xn; i++) {
        if (!set.has(xs[i])) {
            ret[ret.length] = xs[i];
            set.add(xs[i]);
        }
    }
    for (var i = 0; i < yn; i++) {
        if (!set.has(ys[i])) {
            ret[ret.length] = ys[i];
            set.add(ys[i]);
        }
    }
    ret.sort();
    return ret;
}
function isParser(obj) {
    return obj instanceof MonadicParser;
}
//# sourceMappingURL=monadic-parser.js.map

/***/ }),

/***/ "./lib/mol-util/now.js":
/*!*****************************!*\
  !*** ./lib/mol-util/now.js ***!
  \*****************************/
/*! exports provided: now, formatTimespan */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* WEBPACK VAR INJECTION */(function(process) {/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "now", function() { return now; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "formatTimespan", function() { return formatTimespan; });
/**
 * Copyright (c) 2017 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author David Sehnal <david.sehnal@gmail.com>
 */
var now = (function () {
    if (typeof window !== 'undefined' && window.performance) {
        var perf_1 = window.performance;
        return function () { return perf_1.now(); };
    }
    else if (typeof process !== 'undefined' && process.hrtime !== 'undefined' && typeof process.hrtime === 'function') {
        return function () {
            var t = process.hrtime();
            return t[0] * 1000 + t[1] / 1000000;
        };
    }
    else if (Date.now) {
        return function () { return Date.now(); };
    }
    else {
        return function () { return +new Date(); };
    }
}());
function formatTimespan(t, includeMsZeroes) {
    if (includeMsZeroes === void 0) { includeMsZeroes = true; }
    if (isNaN(t))
        return 'n/a';
    var h = Math.floor(t / (60 * 60 * 1000)), m = Math.floor(t / (60 * 1000) % 60), s = Math.floor(t / 1000 % 60), ms = Math.floor(t % 1000).toString();
    while (ms.length < 3)
        ms = '0' + ms;
    while (!includeMsZeroes && ms.length > 1 && ms[ms.length - 1] === '0')
        ms = ms.substr(0, ms.length - 1);
    if (h > 0)
        return h + "h" + m + "m" + s + "." + ms + "s";
    if (m > 0)
        return m + "m" + s + "." + ms + "s";
    if (s > 0)
        return s + "." + ms + "s";
    return t.toFixed(0) + "ms";
}

//# sourceMappingURL=now.js.map
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(/*! ./../../node_modules/process/browser.js */ "./node_modules/process/browser.js")))

/***/ }),

/***/ "./lib/mol-util/number.js":
/*!********************************!*\
  !*** ./lib/mol-util/number.js ***!
  \********************************/
/*! exports provided: getMantissaMultiplier, integerDigitCount, getArrayDigitCount, isInteger, getPrecision, toPrecision */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getMantissaMultiplier", function() { return getMantissaMultiplier; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "integerDigitCount", function() { return integerDigitCount; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getArrayDigitCount", function() { return getArrayDigitCount; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isInteger", function() { return isInteger; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getPrecision", function() { return getPrecision; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "toPrecision", function() { return toPrecision; });
/**
 * Copyright (c) 2018-2019 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author David Sehnal <david.sehnal@gmail.com>
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */
/**
 * Determine the number of digits in a floating point number
 * Find a number M such that round(M * v) - M * v <= delta.
 * If no such M exists, return -1.
 */
function getMantissaMultiplier(v, maxDigits, delta) {
    var m = 1, i;
    for (i = 0; i < maxDigits; i++) {
        var mv = m * v;
        if (Math.abs(Math.round(mv) - mv) <= delta)
            return i;
        m *= 10;
    }
    return -1;
}
function integerDigitCount(v, delta) {
    var f = Math.abs(v);
    if (f < delta)
        return 0;
    return Math.floor(Math.log10(Math.abs(v))) + 1;
}
/**
 * Determine the maximum number of digits in a floating point array.
 * Find a number M such that round(M * v) - M * v <= delta.
 * If no such M exists, return -1.
 */
function getArrayDigitCount(xs, maxDigits, delta) {
    var mantissaDigits = 1;
    var integerDigits = 0;
    for (var i = 0, _i = xs.length; i < _i; i++) {
        if (mantissaDigits >= 0) {
            var t = getMantissaMultiplier(xs[i], maxDigits, delta);
            if (t < 0)
                mantissaDigits = -1;
            else if (t > mantissaDigits)
                mantissaDigits = t;
        }
        var abs = Math.abs(xs[i]);
        if (abs > delta) {
            var d = Math.floor(Math.log10(Math.abs(abs))) + 1;
            if (d > integerDigits)
                integerDigits = d;
        }
    }
    return { mantissaDigits: mantissaDigits, integerDigits: integerDigits };
}
function isInteger(s) {
    s = s.trim();
    var n = parseInt(s, 10);
    return isNaN(n) ? false : n.toString() === s;
}
function getPrecision(v) {
    if (!isFinite(v))
        return 0;
    var e = 1;
    var p = 0;
    while (Math.round(v * e) / e !== v) {
        e *= 10;
        ++p;
    }
    return p;
}
function toPrecision(v, precision) {
    return parseFloat(v.toPrecision(precision));
}
//# sourceMappingURL=number.js.map

/***/ }),

/***/ "./lib/mol-util/object.js":
/*!********************************!*\
  !*** ./lib/mol-util/object.js ***!
  \********************************/
/*! exports provided: assignIfUndefined, shallowMerge2, shallowEqual, shallowMerge, shallowMergeArray, deepClone, mapObjectMap, objectForEach */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "assignIfUndefined", function() { return assignIfUndefined; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "shallowMerge2", function() { return shallowMerge2; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "shallowEqual", function() { return shallowEqual; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "shallowMerge", function() { return shallowMerge; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "shallowMergeArray", function() { return shallowMergeArray; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "deepClone", function() { return deepClone; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "mapObjectMap", function() { return mapObjectMap; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "objectForEach", function() { return objectForEach; });
/**
 * Copyright (c) 2017 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author David Sehnal <david.sehnal@gmail.com>
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */
var hasOwnProperty = Object.prototype.hasOwnProperty;
/** Assign to the object if a given property in update is undefined */
function assignIfUndefined(to, full) {
    for (var _i = 0, _a = Object.keys(full); _i < _a.length; _i++) {
        var k = _a[_i];
        if (!hasOwnProperty.call(full, k))
            continue;
        if (typeof to[k] === 'undefined') {
            to[k] = full[k];
        }
    }
    return to;
}
/** Create new object if any property in "update" changes in "source". */
function shallowMerge2(source, update) {
    // Adapted from LiteMol (https://github.com/dsehnal/LiteMol)
    var changed = false;
    for (var _i = 0, _a = Object.keys(update); _i < _a.length; _i++) {
        var k = _a[_i];
        if (!hasOwnProperty.call(update, k))
            continue;
        if (update[k] !== source[k]) {
            changed = true;
            break;
        }
    }
    if (!changed)
        return source;
    return Object.assign({}, source, update);
}
function shallowEqual(a, b) {
    if (!a) {
        if (!b)
            return true;
        return false;
    }
    if (!b)
        return false;
    var keys = Object.keys(a);
    if (Object.keys(b).length !== keys.length)
        return false;
    for (var _i = 0, keys_1 = keys; _i < keys_1.length; _i++) {
        var k = keys_1[_i];
        if (!hasOwnProperty.call(a, k) || a[k] !== b[k])
            return false;
    }
    return true;
}
function shallowMerge(source) {
    var rest = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        rest[_i - 1] = arguments[_i];
    }
    return shallowMergeArray(source, rest);
}
function shallowMergeArray(source, rest) {
    // Adapted from LiteMol (https://github.com/dsehnal/LiteMol)
    var ret = source;
    for (var s = 0; s < rest.length; s++) {
        if (!rest[s])
            continue;
        ret = shallowMerge2(source, rest[s]);
        if (ret !== source) {
            for (var i = s + 1; i < rest.length; i++) {
                ret = Object.assign(ret, rest[i]);
            }
            break;
        }
    }
    return ret;
}
/** Simple deep clone for number, boolean, string, null, undefined, object, array */
function deepClone(source) {
    if (null === source || 'object' !== typeof source)
        return source;
    if (source instanceof Array) {
        var copy = [];
        for (var i = 0, len = source.length; i < len; i++) {
            copy[i] = deepClone(source[i]);
        }
        return copy;
    }
    // `instanceof Object` does not find `Object.create(null)`
    if (typeof source === 'object' && !('prototype' in source)) {
        var copy = {};
        for (var k in source) {
            if (hasOwnProperty.call(source, k))
                copy[k] = deepClone(source[k]);
        }
        return copy;
    }
    throw new Error("Can't clone, type \"" + typeof source + "\" unsupported");
}
function mapObjectMap(o, f) {
    var ret = {};
    for (var _i = 0, _a = Object.keys(o); _i < _a.length; _i++) {
        var k = _a[_i];
        ret[k] = f(o[k]);
    }
    return ret;
}
function objectForEach(o, f) {
    if (!o)
        return;
    for (var _i = 0, _a = Object.keys(o); _i < _a.length; _i++) {
        var k = _a[_i];
        f(o[k], k);
    }
}
//# sourceMappingURL=object.js.map

/***/ }),

/***/ "./lib/mol-util/param-definition.js":
/*!******************************************!*\
  !*** ./lib/mol-util/param-definition.js ***!
  \******************************************/
/*! exports provided: ParamDefinition */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ParamDefinition", function() { return ParamDefinition; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _index__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./index */ "./lib/mol-util/index.js");
/* harmony import */ var _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../mol-math/linear-algebra */ "./lib/mol-math/linear-algebra.js");
/* harmony import */ var _object__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./object */ "./lib/mol-util/object.js");
/* harmony import */ var _string__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./string */ "./lib/mol-util/string.js");
/* harmony import */ var _color_lists__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./color/lists */ "./lib/mol-util/color/lists.js");
/* harmony import */ var _assets__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ./assets */ "./lib/mol-util/assets.js");
/**
 * Copyright (c) 2018-2020 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 * @author David Sehnal <david.sehnal@gmail.com>
 */







var ParamDefinition;
(function (ParamDefinition) {
    ParamDefinition.Essential = { isEssential: true };
    function setInfo(param, info) {
        if (!info)
            return param;
        if (info.label)
            param.label = info.label;
        if (info.description)
            param.description = info.description;
        if (info.legend)
            param.legend = info.legend;
        if (info.fieldLabels)
            param.fieldLabels = info.fieldLabels;
        if (info.isHidden)
            param.isHidden = info.isHidden;
        if (info.shortLabel)
            param.shortLabel = info.shortLabel;
        if (info.twoColumns)
            param.twoColumns = info.twoColumns;
        if (info.isEssential)
            param.isEssential = info.isEssential;
        if (info.category)
            param.category = info.category;
        if (info.hideIf)
            param.hideIf = info.hideIf;
        if (info.help)
            param.help = info.help;
        return param;
    }
    function Optional(p) {
        var ret = Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, p);
        ret.isOptional = true;
        return ret;
    }
    ParamDefinition.Optional = Optional;
    function Value(defaultValue, info) {
        return setInfo({ type: 'value', defaultValue: defaultValue }, info);
    }
    ParamDefinition.Value = Value;
    function Select(defaultValue, options, info) {
        return setInfo({ type: 'select', defaultValue: checkDefaultKey(defaultValue, options), options: options, cycle: info === null || info === void 0 ? void 0 : info.cycle }, info);
    }
    ParamDefinition.Select = Select;
    function MultiSelect(defaultValue, options, info) {
        // TODO: check if default value is a subset of options?
        var ret = setInfo({ type: 'multi-select', defaultValue: defaultValue, options: options }, info);
        if (info === null || info === void 0 ? void 0 : info.emptyValue)
            ret.emptyValue = info.emptyValue;
        return ret;
    }
    ParamDefinition.MultiSelect = MultiSelect;
    function Boolean(defaultValue, info) {
        return setInfo({ type: 'boolean', defaultValue: defaultValue }, info);
    }
    ParamDefinition.Boolean = Boolean;
    function Text(defaultValue, info) {
        if (defaultValue === void 0) { defaultValue = ''; }
        return setInfo({ type: 'text', defaultValue: defaultValue }, info);
    }
    ParamDefinition.Text = Text;
    function Color(defaultValue, info) {
        var ret = setInfo({ type: 'color', defaultValue: defaultValue }, info);
        if (info === null || info === void 0 ? void 0 : info.isExpanded)
            ret.isExpanded = info.isExpanded;
        return ret;
    }
    ParamDefinition.Color = Color;
    function ColorList(defaultValue, info) {
        var def;
        if (typeof defaultValue === 'string') {
            var colors = Object(_color_lists__WEBPACK_IMPORTED_MODULE_5__["getColorListFromName"])(defaultValue);
            def = { kind: colors.type !== 'qualitative' ? 'interpolate' : 'set', colors: colors.list };
        }
        else {
            def = defaultValue;
        }
        return setInfo({ type: 'color-list', presetKind: (info === null || info === void 0 ? void 0 : info.presetKind) || 'all', defaultValue: def, offsets: !!(info === null || info === void 0 ? void 0 : info.offsets) }, info);
    }
    ParamDefinition.ColorList = ColorList;
    function Vec3(defaultValue, range, info) {
        return setInfo(setRange({ type: 'vec3', defaultValue: defaultValue }, range), info);
    }
    ParamDefinition.Vec3 = Vec3;
    function Mat4(defaultValue, info) {
        return setInfo({ type: 'mat4', defaultValue: defaultValue }, info);
    }
    ParamDefinition.Mat4 = Mat4;
    function Url(url, info) {
        var defaultValue = typeof url === 'string' ? _assets__WEBPACK_IMPORTED_MODULE_6__["Asset"].Url(url) : _assets__WEBPACK_IMPORTED_MODULE_6__["Asset"].Url(url.url, { body: url.body });
        var ret = setInfo({ type: 'url', defaultValue: defaultValue }, info);
        return ret;
    }
    ParamDefinition.Url = Url;
    function File(info) {
        var ret = setInfo({ type: 'file', defaultValue: null }, info);
        if (info === null || info === void 0 ? void 0 : info.accept)
            ret.accept = info.accept;
        return ret;
    }
    ParamDefinition.File = File;
    function FileList(info) {
        var ret = setInfo({ type: 'file-list', defaultValue: null }, info);
        if (info === null || info === void 0 ? void 0 : info.accept)
            ret.accept = info.accept;
        return ret;
    }
    ParamDefinition.FileList = FileList;
    function setRange(p, range) {
        if (!range)
            return p;
        if (typeof range.min !== 'undefined')
            p.min = range.min;
        if (typeof range.max !== 'undefined')
            p.max = range.max;
        if (typeof range.step !== 'undefined')
            p.step = range.step;
        return p;
    }
    function Numeric(defaultValue, range, info) {
        var ret = setInfo(setRange({ type: 'number', defaultValue: defaultValue }, range), info);
        if (info === null || info === void 0 ? void 0 : info.immediateUpdate)
            ret.immediateUpdate = true;
        return ret;
    }
    ParamDefinition.Numeric = Numeric;
    function Interval(defaultValue, range, info) {
        return setInfo(setRange({ type: 'interval', defaultValue: defaultValue }, range), info);
    }
    ParamDefinition.Interval = Interval;
    function LineGraph(defaultValue, info) {
        return setInfo({ type: 'line-graph', defaultValue: defaultValue }, info);
    }
    ParamDefinition.LineGraph = LineGraph;
    function Group(params, info) {
        var ret = setInfo({ type: 'group', defaultValue: (info === null || info === void 0 ? void 0 : info.customDefault) || getDefaultValues(params), params: params }, info);
        if (info === null || info === void 0 ? void 0 : info.isExpanded)
            ret.isExpanded = info.isExpanded;
        if (info === null || info === void 0 ? void 0 : info.isFlat)
            ret.isFlat = info.isFlat;
        if (info === null || info === void 0 ? void 0 : info.pivot)
            ret.pivot = info.pivot;
        return ret;
    }
    ParamDefinition.Group = Group;
    function EmptyGroup(info) {
        return Group({}, info);
    }
    ParamDefinition.EmptyGroup = EmptyGroup;
    function Mapped(defaultKey, names, map, info) {
        var name = checkDefaultKey(defaultKey, names);
        return setInfo({
            type: 'mapped',
            defaultValue: { name: name, params: map(name).defaultValue },
            select: Select(name, names, info),
            map: map
        }, info);
    }
    ParamDefinition.Mapped = Mapped;
    function MappedStatic(defaultKey, map, info) {
        var options = (info === null || info === void 0 ? void 0 : info.options) ? info.options
            : Object.keys(map).map(function (k) { return [k, map[k].label || Object(_string__WEBPACK_IMPORTED_MODULE_4__["stringToWords"])(k)]; });
        var name = checkDefaultKey(defaultKey, options);
        return setInfo({
            type: 'mapped',
            defaultValue: { name: name, params: map[name].defaultValue },
            select: Select(name, options, info),
            map: function (key) { return map[key]; }
        }, info);
    }
    ParamDefinition.MappedStatic = MappedStatic;
    function ObjectList(element, getLabel, info) {
        return setInfo({ type: 'object-list', element: element, getLabel: getLabel, ctor: _defaultObjectListCtor, defaultValue: (info === null || info === void 0 ? void 0 : info.defaultValue) || [] }, info);
    }
    ParamDefinition.ObjectList = ObjectList;
    function _defaultObjectListCtor() { return getDefaultValues(this.element); }
    function unsetGetValue() {
        throw new Error('getValue not set. Fix runtime.');
    }
    function ValueRef(getOptions, resolveRef, info) {
        var _a;
        return setInfo({ type: 'value-ref', defaultValue: { ref: (_a = info === null || info === void 0 ? void 0 : info.defaultRef) !== null && _a !== void 0 ? _a : '', getValue: unsetGetValue }, getOptions: getOptions, resolveRef: resolveRef }, info);
    }
    ParamDefinition.ValueRef = ValueRef;
    function DataRef(info) {
        var _a;
        return setInfo({ type: 'data-ref', defaultValue: { ref: (_a = info === null || info === void 0 ? void 0 : info.defaultRef) !== null && _a !== void 0 ? _a : '', getValue: unsetGetValue } }, info);
    }
    ParamDefinition.DataRef = DataRef;
    function Converted(fromValue, toValue, converted) {
        return { type: 'converted', defaultValue: toValue(converted.defaultValue), converted: converted, fromValue: fromValue, toValue: toValue };
    }
    ParamDefinition.Converted = Converted;
    function Conditioned(defaultValue, conditionParams, conditionForValue, conditionedValue, info) {
        var options = Object.keys(conditionParams).map(function (k) { return [k, k]; });
        return setInfo({ type: 'conditioned', select: Select(conditionForValue(defaultValue), options, info), defaultValue: defaultValue, conditionParams: conditionParams, conditionForValue: conditionForValue, conditionedValue: conditionedValue }, info);
    }
    ParamDefinition.Conditioned = Conditioned;
    function Script(defaultValue, info) {
        return setInfo({ type: 'script', defaultValue: defaultValue }, info);
    }
    ParamDefinition.Script = Script;
    function For(params) {
        return 0;
    }
    ParamDefinition.For = For;
    function getDefaultValues(params) {
        var d = {};
        for (var _a = 0, _b = Object.keys(params); _a < _b.length; _a++) {
            var k = _b[_a];
            if (params[k].isOptional)
                continue;
            d[k] = params[k].defaultValue;
        }
        return d;
    }
    ParamDefinition.getDefaultValues = getDefaultValues;
    function _resolveRef(resolve, ref) {
        return function () { return resolve(ref); };
    }
    function resolveRefValue(p, value, getData) {
        if (!value)
            return;
        if (p.type === 'value-ref') {
            var v = value;
            if (!v.ref)
                v.getValue = function () { throw new Error('Unset ref in ValueRef value.'); };
            else
                v.getValue = _resolveRef(p.resolveRef, v.ref);
        }
        else if (p.type === 'data-ref') {
            var v = value;
            if (!v.ref)
                v.getValue = function () { throw new Error('Unset ref in ValueRef value.'); };
            else
                v.getValue = _resolveRef(getData, v.ref);
        }
        else if (p.type === 'group') {
            resolveRefs(p.params, value, getData);
        }
        else if (p.type === 'mapped') {
            var v = value;
            var param = p.map(v.name);
            resolveRefValue(param, v.params, getData);
        }
        else if (p.type === 'object-list') {
            if (!hasValueRef(p.element))
                return;
            for (var _a = 0, value_1 = value; _a < value_1.length; _a++) {
                var e = value_1[_a];
                resolveRefs(p.element, e, getData);
            }
        }
    }
    function hasParamValueRef(p) {
        if (p.type === 'value-ref' || p.type === 'data-ref') {
            return true;
        }
        else if (p.type === 'group') {
            if (hasValueRef(p.params))
                return true;
        }
        else if (p.type === 'mapped') {
            for (var _a = 0, _b = p.select.options; _a < _b.length; _a++) {
                var o = _b[_a][0];
                if (hasParamValueRef(p.map(o)))
                    return true;
            }
        }
        else if (p.type === 'object-list') {
            return hasValueRef(p.element);
        }
        return false;
    }
    function hasValueRef(params) {
        for (var _a = 0, _b = Object.keys(params); _a < _b.length; _a++) {
            var n = _b[_a];
            if (hasParamValueRef(params[n]))
                return true;
        }
        return false;
    }
    function resolveRefs(params, values, getData) {
        for (var _a = 0, _b = Object.keys(params); _a < _b.length; _a++) {
            var n = _b[_a];
            resolveRefValue(params[n], values === null || values === void 0 ? void 0 : values[n], getData);
        }
    }
    ParamDefinition.resolveRefs = resolveRefs;
    function setDefaultValues(params, defaultValues) {
        for (var _a = 0, _b = Object.keys(params); _a < _b.length; _a++) {
            var k = _b[_a];
            if (params[k].isOptional)
                continue;
            params[k].defaultValue = defaultValues[k];
        }
    }
    ParamDefinition.setDefaultValues = setDefaultValues;
    function clone(params) {
        return Object(_object__WEBPACK_IMPORTED_MODULE_3__["deepClone"])(params);
    }
    ParamDefinition.clone = clone;
    function validate(params, values) {
        // TODO
        return void 0;
    }
    ParamDefinition.validate = validate;
    function areEqual(params, a, b) {
        if (a === b)
            return true;
        if (typeof a !== 'object' || typeof b !== 'object')
            return false;
        for (var _a = 0, _b = Object.keys(params); _a < _b.length; _a++) {
            var k = _b[_a];
            if (!isParamEqual(params[k], a[k], b[k]))
                return false;
        }
        return true;
    }
    ParamDefinition.areEqual = areEqual;
    function isParamEqual(p, a, b) {
        if (a === b)
            return true;
        if (p.type === 'group') {
            return areEqual(p.params, a, b);
        }
        else if (p.type === 'mapped') {
            var u = a, v = b;
            if (u.name !== v.name)
                return false;
            var map = p.map(u.name);
            return isParamEqual(map, u.params, v.params);
        }
        else if (p.type === 'multi-select') {
            var u = a, v = b;
            if (u.length !== v.length)
                return false;
            if (u.length < 10) {
                for (var i = 0, _i = u.length; i < _i; i++) {
                    if (u[i] === v[i])
                        continue;
                    if (v.indexOf(u[i]) < 0)
                        return false;
                }
            }
            else {
                // TODO: should the value of multiselect be a set?
                var vSet = new Set(v);
                for (var i = 0, _i = u.length; i < _i; i++) {
                    if (u[i] === v[i])
                        continue;
                    if (!vSet.has(u[i]))
                        return false;
                }
            }
            return true;
        }
        else if (p.type === 'interval') {
            return a[0] === b[0] && a[1] === b[1];
        }
        else if (p.type === 'line-graph') {
            var u = a, v = b;
            if (u.length !== v.length)
                return false;
            for (var i = 0, _i = u.length; i < _i; i++) {
                if (!_mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_2__["Vec2"].areEqual(u[i], v[i]))
                    return false;
            }
            return true;
        }
        else if (p.type === 'vec3') {
            return _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_2__["Vec3"].equals(a, b);
        }
        else if (p.type === 'mat4') {
            return _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_2__["Mat4"].areEqual(a, b, _mol_math_linear_algebra__WEBPACK_IMPORTED_MODULE_2__["EPSILON"]);
        }
        else if (p.type === 'script') {
            var u = a, v = b;
            return u.language === v.language && u.expression === v.expression;
        }
        else if (p.type === 'object-list') {
            var u = a, v = b;
            var l = u.length;
            if (l !== v.length)
                return false;
            for (var i = 0; i < l; i++) {
                if (!areEqual(p.element, u[i], v[i]))
                    return false;
            }
            return true;
        }
        else if (typeof a === 'object' && typeof b === 'object') {
            return Object(_index__WEBPACK_IMPORTED_MODULE_1__["shallowEqualObjects"])(a, b);
        }
        // a === b was checked at the top.
        return false;
    }
    ParamDefinition.isParamEqual = isParamEqual;
    function merge(params, a, b) {
        if (a === undefined)
            return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, b);
        if (b === undefined)
            return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, a);
        var o = Object.create(null);
        for (var _a = 0, _b = Object.keys(params); _a < _b.length; _a++) {
            var k = _b[_a];
            o[k] = mergeParam(params[k], a[k], b[k]);
        }
        return o;
    }
    ParamDefinition.merge = merge;
    function mergeParam(p, a, b) {
        if (a === undefined)
            return typeof b === 'object' && !Array.isArray(b) ? Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, b) : b;
        if (b === undefined)
            return typeof a === 'object' && !Array.isArray(a) ? Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, a) : a;
        if (p.type === 'group') {
            return merge(p.params, a, b);
        }
        else if (p.type === 'mapped') {
            var u = a, v = b;
            if (u.name !== v.name)
                return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, v);
            var map = p.map(v.name);
            return {
                name: v.name,
                params: mergeParam(map, u.params, v.params)
            };
        }
        else if (p.type === 'value') {
            return b;
        }
        else if (typeof a === 'object' && typeof b === 'object') {
            if (Array.isArray(b)) {
                return b;
            }
            return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, a), b);
        }
        else {
            return b;
        }
    }
    ParamDefinition.mergeParam = mergeParam;
    function selectHasOption(p, v) {
        for (var _a = 0, _b = p.options; _a < _b.length; _a++) {
            var o = _b[_a];
            if (o[0] === v)
                return true;
        }
        return false;
    }
    function normalizeParam(p, value, defaultIfUndefined) {
        if (value === void 0 || value === null) {
            return defaultIfUndefined ? p.defaultValue : void 0;
        }
        // TODO: is this a good idea and will work well?
        // if (typeof p.defaultValue !== typeof value) {
        //     return p.defaultValue;
        // }
        if (p.type === 'value') {
            return value;
        }
        else if (p.type === 'group') {
            var ret = Object.create(null);
            for (var _a = 0, _b = Object.keys(p.params); _a < _b.length; _a++) {
                var key = _b[_a];
                var param = p.params[key];
                if (value[key] === void 0) {
                    if (defaultIfUndefined)
                        ret[key] = param.defaultValue;
                }
                else {
                    ret[key] = normalizeParam(param, value[key], defaultIfUndefined);
                }
            }
            return ret;
        }
        else if (p.type === 'mapped') {
            var v = value;
            if (typeof v.name !== 'string') {
                return p.defaultValue;
            }
            if (typeof v.params === 'undefined') {
                return defaultIfUndefined ? p.defaultValue : void 0;
            }
            if (!selectHasOption(p.select, v.name)) {
                return p.defaultValue;
            }
            var param = p.map(v.name);
            return {
                name: v.name,
                params: normalizeParam(param, v.params, defaultIfUndefined)
            };
        }
        else if (p.type === 'select') {
            if (!selectHasOption(p, value))
                return p.defaultValue;
            return value;
        }
        else if (p.type === 'multi-select') {
            if (!Array.isArray(value))
                return p.defaultValue;
            var ret = value.filter(function (v) { return selectHasOption(this, v); }, p);
            if (value.length > 0 && ret.length === 0)
                return p.defaultValue;
            return ret;
        }
        else if (p.type === 'object-list') {
            if (!Array.isArray(value))
                return p.defaultValue;
            return value.map(function (v) { return normalizeParams(p.element, v, defaultIfUndefined ? 'all' : 'skip'); });
        }
        // TODO: validate/normalize all param types "properly"??
        return value;
    }
    function normalizeParams(p, value, defaultIfUndefined) {
        if (typeof value !== 'object' || value === null) {
            return defaultIfUndefined ? getDefaultValues(p) : value;
        }
        var ret = Object.create(null);
        for (var _a = 0, _b = Object.keys(p); _a < _b.length; _a++) {
            var key = _b[_a];
            var param = p[key];
            if (value[key] === void 0) {
                if (defaultIfUndefined === 'all')
                    ret[key] = param.defaultValue;
            }
            else {
                ret[key] = normalizeParam(param, value[key], defaultIfUndefined !== 'skip');
            }
        }
        return ret;
    }
    ParamDefinition.normalizeParams = normalizeParams;
    /**
     * Map an object to a list of [K, string][] to be used as options, stringToWords for key used by default (or identity of null).
     *
     * if options is { [string]: string } and mapping is not provided, use the Value.
     */
    function objectToOptions(options, f) {
        var ret = [];
        for (var _a = 0, _b = Object.keys(options); _a < _b.length; _a++) {
            var k = _b[_a];
            if (!f) {
                if (typeof options[k] === 'string')
                    ret.push([k, options[k]]);
                else
                    ret.push([k, f === null ? k : Object(_string__WEBPACK_IMPORTED_MODULE_4__["stringToWords"])(k)]);
            }
            else {
                var o = f(k, options[k]);
                ret.push(typeof o === 'string' ? [k, o] : [k, o[0], o[1]]);
            }
        }
        return ret;
    }
    ParamDefinition.objectToOptions = objectToOptions;
    /**
     * Map array of options using stringToWords by default (or identity of null).
     */
    function arrayToOptions(xs, f) {
        var ret = [];
        for (var _a = 0, xs_1 = xs; _a < xs_1.length; _a++) {
            var x = xs_1[_a];
            if (!f) {
                ret.push([x, f === null ? x : Object(_string__WEBPACK_IMPORTED_MODULE_4__["stringToWords"])(x)]);
            }
            else {
                ret.push([x, f(x)]);
            }
        }
        return ret;
    }
    ParamDefinition.arrayToOptions = arrayToOptions;
    function optionLabel(param, value) {
        for (var _a = 0, _b = param.options; _a < _b.length; _a++) {
            var o = _b[_a];
            if (o[0] === value)
                return o[1];
        }
        return '';
    }
    ParamDefinition.optionLabel = optionLabel;
    function checkDefaultKey(k, options) {
        for (var _a = 0, options_1 = options; _a < options_1.length; _a++) {
            var o = options_1[_a];
            if (o[0] === k)
                return k;
        }
        return options.length > 0 ? options[0][0] : void 0;
    }
})(ParamDefinition || (ParamDefinition = {}));
//# sourceMappingURL=param-definition.js.map

/***/ }),

/***/ "./lib/mol-util/param-mapping.js":
/*!***************************************!*\
  !*** ./lib/mol-util/param-mapping.js ***!
  \***************************************/
/*! exports provided: ParamMapping */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ParamMapping", function() { return ParamMapping; });
/* harmony import */ var immer__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! immer */ "./node_modules/immer/dist/immer.esm.js");
/**
 * Copyright (c) 2020 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author David Sehnal <david.sehnal@gmail.com>
 */

function ParamMapping(def) {
    return function (_a) {
        var values = _a.values, update = _a.update, apply = _a.apply;
        return ({
            params: typeof def.params === 'function' ? def.params : function (ctx) { return def.params; },
            getTarget: def.target,
            getValues: values,
            update: function (s, ctx) {
                var t = def.target(ctx);
                return Object(immer__WEBPACK_IMPORTED_MODULE_0__["produce"])(t, function (t1) { return update(s, t1, ctx); });
            },
            apply: apply ? apply : function () { }
        });
    };
}
//# sourceMappingURL=param-mapping.js.map

/***/ }),

/***/ "./lib/mol-util/polyfill.js":
/*!**********************************!*\
  !*** ./lib/mol-util/polyfill.js ***!
  \**********************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * Copyright (c) 2020 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */
if (typeof window !== 'undefined') {
    (function () {
        // Console-polyfill. MIT license.
        // https://github.com/paulmillr/console-polyfill
        // Make it safe to do console.log() always.
        window.console = window.console || {};
        var con = window.console;
        var prop, method;
        var empty = {};
        var dummy = function () { };
        var properties = 'memory'.split(',');
        var methods = ('assert,clear,count,debug,dir,dirxml,error,exception,group,' +
            'groupCollapsed,groupEnd,info,log,markTimeline,profile,profiles,profileEnd,' +
            'show,table,time,timeEnd,timeline,timelineEnd,timeStamp,trace,warn').split(',');
        while ((prop = properties.pop()))
            if (!con[prop])
                con[prop] = empty;
        while ((method = methods.pop()))
            if (!con[method])
                con[method] = dummy;
    })();
}
if (typeof window.HTMLCanvasElement !== 'undefined' && !window.HTMLCanvasElement.prototype.toBlob) {
    // http://code.google.com/p/chromium/issues/detail?id=67587#57
    Object.defineProperty(window.HTMLCanvasElement.prototype, 'toBlob', {
        value: function (callback, type, quality) {
            var bin = window.atob(this.toDataURL(type, quality).split(',')[1]);
            var len = bin.length;
            var len32 = len >> 2;
            var a8 = new Uint8Array(len);
            var a32 = new Uint32Array(a8.buffer, 0, len32);
            var j = 0;
            for (var i = 0; i < len32; i++) {
                a32[i] = (bin.charCodeAt(j++) |
                    bin.charCodeAt(j++) << 8 |
                    bin.charCodeAt(j++) << 16 |
                    bin.charCodeAt(j++) << 24);
            }
            var tailLength = len & 3;
            while (tailLength--) {
                a8[j] = bin.charCodeAt(j++);
            }
            callback(new window.Blob([a8], { 'type': type || 'image/png' }));
        }
    });
}
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Math/cbrt
Math.cbrt = Math.cbrt || function (x) {
    var y = Math.pow(Math.abs(x), 1 / 3);
    return x < 0 ? -y : y;
};
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Math/sign
if (!Math.sign) {
    Math.sign = function (x) {
        // If x is NaN, the result is NaN.
        // If x is -0, the result is -0.
        // If x is +0, the result is +0.
        // If x is negative and not -0, the result is -1.
        // If x is positive and not +0, the result is +1.
        x = +x; // convert to a number
        if (x === 0 || isNaN(x)) {
            return Number(x);
        }
        return x > 0 ? 1 : -1;
    };
}
if (!Number.isInteger) {
    // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Number/isInteger
    Number.isInteger = function isInteger(nVal) {
        return typeof nVal === 'number' && isFinite(nVal) && nVal > -9007199254740992 && nVal < 9007199254740992 && Math.floor(nVal) === nVal;
    };
}
if (!Number.isNaN) {
    // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Number/isNaN
    Number.isNaN = function isNaN(value) {
        return value !== value; // eslint-disable-line no-self-compare
    };
}
if (!Object.assign) {
    // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/assign
    Object.defineProperty(Object, 'assign', {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (target /* , firstSource */) {
            'use strict';
            if (target === undefined || target === null) {
                throw new TypeError('Cannot convert first argument to object');
            }
            var to = Object(target);
            var hasPendingException = false;
            var pendingException;
            for (var i = 1; i < arguments.length; i++) {
                var nextSource = arguments[i];
                if (nextSource === undefined || nextSource === null) {
                    continue;
                }
                var keysArray = Object.keys(Object(nextSource));
                for (var nextIndex = 0, len = keysArray.length; nextIndex < len; nextIndex++) {
                    var nextKey = keysArray[nextIndex];
                    try {
                        var desc = Object.getOwnPropertyDescriptor(nextSource, nextKey);
                        if (desc !== undefined && desc.enumerable) {
                            to[nextKey] = nextSource[nextKey];
                        }
                    }
                    catch (e) {
                        if (!hasPendingException) {
                            hasPendingException = true;
                            pendingException = e;
                        }
                    }
                }
                if (hasPendingException) {
                    throw pendingException;
                }
            }
            return to;
        }
    });
}
if (!String.prototype.startsWith) {
    /* ! https://mths.be/startswith v0.2.0 by @mathias */
    (function () {
        'use strict'; // needed to support `apply`/`call` with `undefined`/`null`
        var defineProperty = (function () {
            // IE 8 only supports `Object.defineProperty` on DOM elements
            var result;
            try {
                var object = {};
                var $defineProperty = Object.defineProperty;
                result = $defineProperty(object, object, object) && $defineProperty;
            }
            catch (error) { } // eslint-disable-line no-empty
            return result;
        }());
        var toString = {}.toString;
        var startsWith = function (search) {
            if (this === null) {
                throw TypeError();
            }
            var string = String(this);
            if (search && toString.call(search) === '[object RegExp]') {
                throw TypeError();
            }
            var stringLength = string.length;
            var searchString = String(search);
            var searchLength = searchString.length;
            var position = arguments.length > 1 ? arguments[1] : undefined;
            // `ToInteger`
            var pos = position ? Number(position) : 0;
            if (Number.isNaN(pos)) {
                pos = 0;
            }
            var start = Math.min(Math.max(pos, 0), stringLength);
            // Avoid the `indexOf` call if no match is possible
            if (searchLength + start > stringLength) {
                return false;
            }
            var index = -1;
            while (++index < searchLength) {
                if (string.charCodeAt(start + index) !== searchString.charCodeAt(index)) {
                    return false;
                }
            }
            return true;
        };
        if (defineProperty) {
            defineProperty(String.prototype, 'startsWith', {
                'value': startsWith,
                'configurable': true,
                'writable': true
            });
        }
        else {
            // eslint-disable-next-line no-extend-native
            String.prototype.startsWith = startsWith;
        }
    }());
}
if (!String.prototype.endsWith) {
    // eslint-disable-next-line no-extend-native
    String.prototype.endsWith = function (searchString, position) {
        var subjectString = this.toString();
        if (typeof position !== 'number' || !isFinite(position) || Math.floor(position) !== position || position > subjectString.length) {
            position = subjectString.length;
        }
        position -= searchString.length;
        var lastIndex = subjectString.indexOf(searchString, position);
        return lastIndex !== -1 && lastIndex === position;
    };
}
if (!String.prototype.repeat) {
    // eslint-disable-next-line no-extend-native
    String.prototype.repeat = function (count) {
        'use strict';
        if (this === null) {
            throw new TypeError('can\'t convert ' + this + ' to object');
        }
        var str = '' + this;
        count = +count;
        if (Number.isNaN(count)) {
            count = 0;
        }
        if (count < 0) {
            throw new RangeError('repeat count must be non-negative');
        }
        if (count === Infinity) {
            throw new RangeError('repeat count must be less than infinity');
        }
        count = Math.floor(count);
        if (str.length === 0 || count === 0) {
            return '';
        }
        // Ensuring count is a 31-bit integer allows us to heavily optimize the
        // main part. But anyway, most current (August 2014) browsers can't handle
        // strings 1 << 28 chars or longer, so:
        if (str.length * count >= 1 << 28) {
            throw new RangeError('repeat count must not overflow maximum string size');
        }
        var rpt = '';
        for (;;) {
            if ((count & 1) === 1) {
                rpt += str;
            }
            count >>>= 1;
            if (count === 0) {
                break;
            }
            str += str;
        }
        // Could we try:
        // return Array(count + 1).join(this);
        return rpt;
    };
}
if (!String.prototype.includes) {
    // eslint-disable-next-line no-extend-native
    String.prototype.includes = function (search, start) {
        'use strict';
        if (typeof start !== 'number') {
            start = 0;
        }
        if (start + search.length > this.length) {
            return false;
        }
        else {
            return this.indexOf(search, start) !== -1;
        }
    };
}
if (!Array.prototype.includes) {
    // eslint-disable-next-line no-extend-native
    Array.prototype.includes = function (searchElement /* , fromIndex */) {
        'use strict';
        if (this == null) {
            throw new TypeError('Array.prototype.includes called on null or undefined');
        }
        var O = Object(this);
        var len = parseInt(O.length, 10) || 0;
        if (len === 0) {
            return false;
        }
        var n = parseInt(arguments[1], 10) || 0;
        var k;
        if (n >= 0) {
            k = n;
        }
        else {
            k = len + n;
            if (k < 0) {
                k = 0;
            }
        }
        var currentElement;
        while (k < len) {
            currentElement = O[k];
            if (searchElement === currentElement ||
                (Number.isNaN(searchElement) && Number.isNaN(currentElement))) {
                return true;
            }
            k++;
        }
        return false;
    };
}
// Production steps of ECMA-262, Edition 6, 22.1.2.1
// Reference: https://people.mozilla.org/~jorendorff/es6-draft.html#sec-array.from
if (!Array.from) {
    Array.from = (function () {
        var toStr = Object.prototype.toString;
        var isCallable = function (fn) {
            return typeof fn === 'function' || toStr.call(fn) === '[object Function]';
        };
        var toInteger = function (value) {
            var number = Number(value);
            if (isNaN(number)) {
                return 0;
            }
            if (number === 0 || !isFinite(number)) {
                return number;
            }
            return (number > 0 ? 1 : -1) * Math.floor(Math.abs(number));
        };
        var maxSafeInteger = Math.pow(2, 53) - 1;
        var toLength = function (value) {
            var len = toInteger(value);
            return Math.min(Math.max(len, 0), maxSafeInteger);
        };
        // The length property of the from method is 1.
        return function from(arrayLike /* , mapFn, thisArg */) {
            // 1. Let C be the this value.
            var C = this;
            // 2. Let items be ToObject(arrayLike).
            var items = Object(arrayLike);
            // 3. ReturnIfAbrupt(items).
            if (arrayLike == null) {
                throw new TypeError('Array.from requires an array-like object - not null or undefined');
            }
            // 4. If mapfn is undefined, then let mapping be false.
            var mapFn = arguments.length > 1 ? arguments[1] : void undefined;
            var T;
            if (typeof mapFn !== 'undefined') {
                // 5. else
                // 5. a If IsCallable(mapfn) is false, throw a TypeError exception.
                if (!isCallable(mapFn)) {
                    throw new TypeError('Array.from: when provided, the second argument must be a function');
                }
                // 5. b. If thisArg was supplied, let T be thisArg; else let T be undefined.
                if (arguments.length > 2) {
                    T = arguments[2];
                }
            }
            // 10. Let lenValue be Get(items, "length").
            // 11. Let len be ToLength(lenValue).
            var len = toLength(items.length);
            // 13. If IsConstructor(C) is true, then
            // 13. a. Let A be the result of calling the [[Construct]] internal method of C with an argument list containing the single item len.
            // 14. a. Else, Let A be ArrayCreate(len).
            var A = isCallable(C) ? Object(new C(len)) : new Array(len);
            // 16. Let k be 0.
            var k = 0;
            // 17. Repeat, while k < len… (also steps a - h)
            var kValue;
            while (k < len) {
                kValue = items[k];
                if (mapFn) {
                    A[k] = typeof T === 'undefined' ? mapFn(kValue, k) : mapFn.call(T, kValue, k);
                }
                else {
                    A[k] = kValue;
                }
                k += 1;
            }
            // 18. Let putStatus be Put(A, "length", len, true).
            A.length = len;
            // 20. Return A.
            return A;
        };
    }());
}
if (typeof window !== 'undefined') {
    (function () {
        // http://paulirish.com/2011/requestanimationframe-for-smart-animating/
        // http://my.opera.com/emoller/blog/2011/12/20/requestanimationframe-for-smart-er-animating
        // requestAnimationFrame polyfill by Erik Möller. fixes from Paul Irish and Tino Zijdel
        // MIT license
        var lastTime = 0;
        var vendors = ['ms', 'moz', 'webkit', 'o'];
        for (var x = 0; x < vendors.length && !window.requestAnimationFrame; ++x) {
            window.requestAnimationFrame = (window[vendors[x] + 'RequestAnimationFrame']);
            window.cancelAnimationFrame = (window[vendors[x] + 'CancelAnimationFrame'] ||
                window[vendors[x] + 'CancelRequestAnimationFrame']);
        }
        if (!window.requestAnimationFrame) {
            window.requestAnimationFrame = function (callback /* , element */) {
                var currTime = new Date().getTime();
                var timeToCall = Math.max(0, 16 - (currTime - lastTime));
                var id = window.setTimeout(function () {
                    var time = currTime + timeToCall;
                    callback(time);
                }, timeToCall);
                lastTime = currTime + timeToCall;
                return id;
            };
        }
        if (!window.cancelAnimationFrame) {
            window.cancelAnimationFrame = function (id) {
                clearTimeout(id);
            };
        }
    }());
}
if (Function.prototype.name === undefined && Object.defineProperty !== undefined) {
    // Missing in IE9-11.
    // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Function/name
    // eslint-disable-next-line no-extend-native
    Object.defineProperty(Function.prototype, 'name', {
        get: function () {
            return this.toString().match(/^\s*function\s*(\S*)\s*\(/)[1];
        }
    });
}
if (typeof window !== 'undefined') {
    if (window.performance === undefined) {
        /* global self */
        window.performance = {};
    }
    if (window.performance.now === undefined) {
        (function () {
            var start = Date.now();
            window.performance.now = function () {
                return Date.now() - start;
            };
        })();
    }
}
if (Object.defineProperty !== undefined) {
    // Missing in IE < 13
    // MIT license
    // Copyright (c) 2016 Financial Times
    // https://github.com/Financial-Times/polyfill-service
    if (Number.MAX_SAFE_INTEGER === undefined) {
        Object.defineProperty(Number, 'MAX_SAFE_INTEGER', {
            enumerable: false,
            configurable: false,
            writable: false,
            value: Math.pow(2, 53) - 1
        });
    }
    if (Number.MIN_SAFE_INTEGER === undefined) {
        Object.defineProperty(Number, 'MIN_SAFE_INTEGER', {
            enumerable: false,
            configurable: false,
            writable: false,
            value: -(Math.pow(2, 53) - 1)
        });
    }
}
if (!Object.entries) {
    Object.entries = function (obj) {
        var ownProps = Object.keys(obj), i = ownProps.length, resArray = new Array(i); // preallocate the Array
        while (i--)
            resArray[i] = [ownProps[i], obj[ownProps[i]]];
        return resArray;
    };
}
// from https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/find
// https://tc39.github.io/ecma262/#sec-array.prototype.find
if (!Array.prototype.find) {
    Object.defineProperty(Array.prototype, 'find', {
        value: function (predicate) {
            // 1. Let O be ? ToObject(this value).
            if (this == null) {
                throw TypeError('"this" is null or not defined');
            }
            var o = Object(this);
            // 2. Let len be ? ToLength(? Get(O, "length")).
            var len = o.length >>> 0;
            // 3. If IsCallable(predicate) is false, throw a TypeError exception.
            if (typeof predicate !== 'function') {
                throw TypeError('predicate must be a function');
            }
            // 4. If thisArg was supplied, let T be thisArg; else let T be undefined.
            var thisArg = arguments[1];
            // 5. Let k be 0.
            var k = 0;
            // 6. Repeat, while k < len
            while (k < len) {
                // a. Let Pk be ! ToString(k).
                // b. Let kValue be ? Get(O, Pk).
                // c. Let testResult be ToBoolean(? Call(predicate, T, « kValue, k, O »)).
                // d. If testResult is true, return kValue.
                var kValue = o[k];
                if (predicate.call(thisArg, kValue, k, o)) {
                    return kValue;
                }
                // e. Increase k by 1.
                k++;
            }
            // 7. Return undefined.
            return undefined;
        },
        configurable: true,
        writable: true
    });
}
// from https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/fill
if (!Array.prototype.fill) {
    Object.defineProperty(Array.prototype, 'fill', {
        value: function (value) {
            // Steps 1-2.
            if (this == null) {
                throw new TypeError('this is null or not defined');
            }
            var O = Object(this);
            // Steps 3-5.
            var len = O.length >>> 0;
            // Steps 6-7.
            var start = arguments[1];
            var relativeStart = start >> 0;
            // Step 8.
            var k = relativeStart < 0 ?
                Math.max(len + relativeStart, 0) :
                Math.min(relativeStart, len);
            // Steps 9-10.
            var end = arguments[2];
            var relativeEnd = end === undefined ?
                len : end >> 0;
            // Step 11.
            var finalValue = relativeEnd < 0 ?
                Math.max(len + relativeEnd, 0) :
                Math.min(relativeEnd, len);
            // Step 12.
            while (k < finalValue) {
                O[k] = value;
                k++;
            }
            // Step 13.
            return O;
        }
    });
}
if (!Array.prototype.copyWithin) {
    Object.defineProperty(Array.prototype, 'copyWithin', {
        value: function (target, start /* , end*/) {
            // Steps 1-2.
            if (this == null) {
                throw new TypeError('this is null or not defined');
            }
            var O = Object(this);
            // Steps 3-5.
            var len = O.length >>> 0;
            // Steps 6-8.
            var relativeTarget = target >> 0;
            var to = relativeTarget < 0 ?
                Math.max(len + relativeTarget, 0) :
                Math.min(relativeTarget, len);
            // Steps 9-11.
            var relativeStart = start >> 0;
            var from = relativeStart < 0 ?
                Math.max(len + relativeStart, 0) :
                Math.min(relativeStart, len);
            // Steps 12-14.
            var end = arguments[2];
            var relativeEnd = end === undefined ? len : end >> 0;
            var final = relativeEnd < 0 ?
                Math.max(len + relativeEnd, 0) :
                Math.min(relativeEnd, len);
            // Step 15.
            var count = Math.min(final - from, len - to);
            // Steps 16-17.
            var direction = 1;
            if (from < to && to < (from + count)) {
                direction = -1;
                from += count - 1;
                to += count - 1;
            }
            // Step 18.
            while (count > 0) {
                if (from in O) {
                    O[to] = O[from];
                }
                else {
                    delete O[to];
                }
                from += direction;
                to += direction;
                count--;
            }
            // Step 19.
            return O;
        },
        configurable: true,
        writable: true
    });
}
if (!Int8Array.prototype.copyWithin) {
    Object.defineProperty(Int8Array.prototype, 'copyWithin', { value: Array.prototype.copyWithin });
}
if (!Int16Array.prototype.copyWithin) {
    Object.defineProperty(Int16Array.prototype, 'copyWithin', { value: Array.prototype.copyWithin });
}
if (!Int32Array.prototype.copyWithin) {
    Object.defineProperty(Int32Array.prototype, 'copyWithin', { value: Array.prototype.copyWithin });
}
if (!Uint8Array.prototype.copyWithin) {
    Object.defineProperty(Uint8Array.prototype, 'copyWithin', { value: Array.prototype.copyWithin });
}
if (!Uint16Array.prototype.copyWithin) {
    Object.defineProperty(Uint16Array.prototype, 'copyWithin', { value: Array.prototype.copyWithin });
}
if (!Uint32Array.prototype.copyWithin) {
    Object.defineProperty(Uint32Array.prototype, 'copyWithin', { value: Array.prototype.copyWithin });
}
if (!Float32Array.prototype.copyWithin) {
    Object.defineProperty(Float32Array.prototype, 'copyWithin', { value: Array.prototype.copyWithin });
}
if (!Float64Array.prototype.copyWithin) {
    Object.defineProperty(Float64Array.prototype, 'copyWithin', { value: Array.prototype.copyWithin });
}
//# sourceMappingURL=polyfill.js.map

/***/ }),

/***/ "./lib/mol-util/reference-cache.js":
/*!*****************************************!*\
  !*** ./lib/mol-util/reference-cache.js ***!
  \*****************************************/
/*! exports provided: createReference, createReferenceItem, createReferenceCache */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createReference", function() { return createReference; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createReferenceItem", function() { return createReferenceItem; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createReferenceCache", function() { return createReferenceCache; });
/**
 * Copyright (c) 2018-2020 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */
function createReference(value, usageCount) {
    if (usageCount === void 0) { usageCount = 0; }
    return { value: value, usageCount: usageCount };
}
function createReferenceItem(ref) {
    return {
        free: function () {
            ref.usageCount -= 1;
        },
        value: ref.value
    };
}
function createReferenceCache(hashFn, ctor, deleteFn) {
    var map = new Map();
    return {
        get: function (props) {
            var id = hashFn(props);
            var ref = map.get(id);
            if (!ref) {
                ref = createReference(ctor(props));
                map.set(id, ref);
            }
            ref.usageCount += 1;
            return createReferenceItem(ref);
        },
        clear: function () {
            map.forEach(function (ref, id) {
                if (ref.usageCount <= 0) {
                    if (ref.usageCount < 0) {
                        console.warn('Reference usageCount below zero.');
                    }
                    deleteFn(ref.value);
                    map.delete(id);
                }
            });
        },
        get count() {
            return map.size;
        },
        dispose: function () {
            map.forEach(function (ref) { return deleteFn(ref.value); });
            map.clear();
        },
    };
}
//# sourceMappingURL=reference-cache.js.map

/***/ }),

/***/ "./lib/mol-util/rx-event-helper.js":
/*!*****************************************!*\
  !*** ./lib/mol-util/rx-event-helper.js ***!
  \*****************************************/
/*! exports provided: RxEventHelper */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "RxEventHelper", function() { return RxEventHelper; });
/* harmony import */ var rxjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! rxjs */ "./node_modules/rxjs/_esm5/index.js");
/**
 * Copyright (c) 2018 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author David Sehnal <david.sehnal@gmail.com>
 */


var RxEventHelper;
(function (RxEventHelper) {
    function create() {
        var helper = new _RxEventHelper();
        var ret = (function () { return helper.create(); });
        ret.dispose = function () { return helper.dispose(); };
        ret.behavior = function (v) { return helper.behavior(v); };
        return ret;
    }
    RxEventHelper.create = create;
})(RxEventHelper || (RxEventHelper = {}));
var _RxEventHelper = /** @class */ (function () {
    function _RxEventHelper() {
        this._eventList = [];
        this._disposed = false;
    }
    _RxEventHelper.prototype.create = function () {
        var s = new rxjs__WEBPACK_IMPORTED_MODULE_0__["Subject"]();
        this._eventList.push(s);
        return s;
    };
    _RxEventHelper.prototype.behavior = function (v) {
        var s = new rxjs__WEBPACK_IMPORTED_MODULE_0__["BehaviorSubject"](v);
        this._eventList.push(s);
        return s;
    };
    _RxEventHelper.prototype.dispose = function () {
        if (this._disposed)
            return;
        for (var _i = 0, _a = this._eventList; _i < _a.length; _i++) {
            var e = _a[_i];
            e.complete();
        }
        this._disposed = true;
    };
    return _RxEventHelper;
}());
//# sourceMappingURL=rx-event-helper.js.map

/***/ }),

/***/ "./lib/mol-util/set.js":
/*!*****************************!*\
  !*** ./lib/mol-util/set.js ***!
  \*****************************/
/*! exports provided: SetUtils */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SetUtils", function() { return SetUtils; });
/* harmony import */ var _mol_data_util_array__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../mol-data/util/array */ "./lib/mol-data/util/array.js");
/**
 * Copyright (c) 2018-2020 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */

// TODO use set@@iterator when targeting es6
var SetUtils;
(function (SetUtils) {
    function toArray(set) {
        return Object(_mol_data_util_array__WEBPACK_IMPORTED_MODULE_0__["iterableToArray"])(set.values());
    }
    SetUtils.toArray = toArray;
    /** Test if set a contains all elements of set b. */
    function isSuperset(setA, setB) {
        var flag = true;
        setB.forEach(function (elem) {
            if (!setA.has(elem))
                flag = false;
        });
        return flag;
    }
    SetUtils.isSuperset = isSuperset;
    /** Add all elements from `sets` to `out` */
    function add(out) {
        var sets = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            sets[_i - 1] = arguments[_i];
        }
        for (var i = 0; i < sets.length; i++) {
            sets[i].forEach(function (elem) { return out.add(elem); });
        }
        return out;
    }
    SetUtils.add = add;
    /** Create set containing elements of both set a and set b. */
    function union(setA, setB) {
        var union = new Set(setA);
        setB.forEach(function (elem) { return union.add(elem); });
        return union;
    }
    SetUtils.union = union;
    function unionMany() {
        var sets = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            sets[_i] = arguments[_i];
        }
        if (sets.length === 0)
            return new Set();
        if (sets.length === 1)
            new Set(sets[0]);
        var union = new Set(sets[0]);
        for (var i = 1, il = sets.length; i < il; i++) {
            sets[i].forEach(function (elem) { return union.add(elem); });
        }
        return union;
    }
    SetUtils.unionMany = unionMany;
    function unionManyArrays(arrays) {
        if (arrays.length === 0)
            return new Set();
        var union = new Set(arrays[0]);
        for (var i = 1; i < arrays.length; i++) {
            for (var _i = 0, _a = arrays[i]; _i < _a.length; _i++) {
                var elem = _a[_i];
                union.add(elem);
            }
        }
        return union;
    }
    SetUtils.unionManyArrays = unionManyArrays;
    /** Create set containing elements of set a that are also in set b. */
    function intersection(setA, setB) {
        var intersection = new Set();
        setB.forEach(function (elem) {
            if (setA.has(elem))
                intersection.add(elem);
        });
        return intersection;
    }
    SetUtils.intersection = intersection;
    function areIntersecting(setA, setB) {
        var flag = false;
        setB.forEach(function (elem) {
            if (setA.has(elem))
                flag = true;
        });
        return flag;
    }
    SetUtils.areIntersecting = areIntersecting;
    function intersectionSize(setA, setB) {
        var count = 0;
        setB.forEach(function (elem) {
            if (setA.has(elem))
                count += 1;
        });
        return count;
    }
    SetUtils.intersectionSize = intersectionSize;
    /** Create set containing elements of set a that are not in set b. */
    function difference(setA, setB) {
        var difference = new Set(setA);
        setB.forEach(function (elem) { return difference.delete(elem); });
        return difference;
    }
    SetUtils.difference = difference;
    /** Number of elements that are in set a but not in set b. */
    function differenceSize(setA, setB) {
        var count = setA.size;
        setA.forEach(function (elem) {
            if (setB.has(elem))
                count -= 1;
        });
        return count;
    }
    SetUtils.differenceSize = differenceSize;
    /** Test if set a and b contain the same elements. */
    function areEqual(setA, setB) {
        if (setA.size !== setB.size)
            return false;
        var flag = true;
        setB.forEach(function (elem) {
            if (!setA.has(elem))
                flag = false;
        });
        return flag;
    }
    SetUtils.areEqual = areEqual;
})(SetUtils || (SetUtils = {}));
//# sourceMappingURL=set.js.map

/***/ }),

/***/ "./lib/mol-util/string-builder.js":
/*!****************************************!*\
  !*** ./lib/mol-util/string-builder.js ***!
  \****************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/**
 * Copyright (c) 2017 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * Adapted from CIFTools.js (https://github.com/dsehnal/CIFTools.js)
 *
 * @author David Sehnal <david.sehnal@gmail.com>
 */
var StringBuilder;
(function (StringBuilder) {
    function create(chunkCapacity) {
        if (chunkCapacity === void 0) { chunkCapacity = 512; }
        return {
            current: [],
            offset: 0,
            capacity: chunkCapacity,
            chunks: []
        };
    }
    StringBuilder.create = create;
    function getString(builder) {
        if (!builder.chunks.length) {
            if (builder.current.length === builder.offset)
                return builder.current.join('');
            return builder.current.splice(0, builder.offset).join('');
        }
        if (builder.offset > 0) {
            builder.chunks[builder.chunks.length] = builder.current.length === builder.offset
                ? builder.current.join('')
                : builder.current.slice(0, builder.offset).join('');
        }
        return builder.chunks.join('');
    }
    StringBuilder.getString = getString;
    function getSize(builder) {
        var size = 0;
        for (var _i = 0, _a = builder.chunks; _i < _a.length; _i++) {
            var c = _a[_i];
            size += c.length;
        }
        for (var i = 0; i < builder.offset; i++)
            size += builder.current[i].length;
        return size;
    }
    StringBuilder.getSize = getSize;
    function getChunks(builder) {
        if (builder.offset > 0) {
            if (builder.current.length === builder.offset)
                builder.chunks[builder.chunks.length] = builder.current.join('');
            else
                builder.chunks[builder.chunks.length] = builder.current.slice(0, builder.offset).join('');
            builder.offset = 0;
        }
        return builder.chunks;
    }
    StringBuilder.getChunks = getChunks;
    var __paddingSpaces = [];
    (function () {
        var s = '';
        for (var i = 0; i < 512 /* Count */; i++) {
            __paddingSpaces[i] = s;
            s = s + ' ';
        }
    })();
    function newline(builder) {
        writeSafe(builder, '\n');
    }
    StringBuilder.newline = newline;
    function whitespace(builder, len) {
        if (len > 0)
            writeSafe(builder, __paddingSpaces[len]);
    }
    StringBuilder.whitespace = whitespace;
    function whitespace1(builder) {
        writeSafe(builder, ' ');
    }
    StringBuilder.whitespace1 = whitespace1;
    function write(builder, val) {
        if (!val)
            return;
        if (builder.offset === builder.capacity) {
            builder.chunks[builder.chunks.length] = builder.current.join('');
            builder.offset = 0;
        }
        builder.current[builder.offset++] = val;
    }
    StringBuilder.write = write;
    /** Write without check. */
    function writeSafe(builder, val) {
        if (builder.offset === builder.capacity) {
            builder.chunks[builder.chunks.length] = builder.current.join('');
            builder.offset = 0;
        }
        builder.current[builder.offset++] = val;
    }
    StringBuilder.writeSafe = writeSafe;
    function writePadLeft(builder, val, totalWidth) {
        if (!val) {
            whitespace(builder, totalWidth);
            return;
        }
        var padding = totalWidth - val.length;
        whitespace(builder, padding);
        writeSafe(builder, val);
    }
    StringBuilder.writePadLeft = writePadLeft;
    function writePadRight(builder, val, totalWidth) {
        if (!val) {
            whitespace(builder, totalWidth);
            return;
        }
        var padding = totalWidth - val.length;
        writeSafe(builder, val);
        whitespace(builder, padding);
    }
    StringBuilder.writePadRight = writePadRight;
    function writeInteger(builder, val) {
        writeSafe(builder, '' + val);
    }
    StringBuilder.writeInteger = writeInteger;
    function writeIntegerAndSpace(builder, val) {
        writeSafe(builder, '' + val + ' ');
    }
    StringBuilder.writeIntegerAndSpace = writeIntegerAndSpace;
    function writeIntegerPadLeft(builder, val, totalWidth) {
        var s = '' + val;
        var padding = totalWidth - s.length;
        whitespace(builder, padding);
        writeSafe(builder, s);
    }
    StringBuilder.writeIntegerPadLeft = writeIntegerPadLeft;
    function writeIntegerPadRight(builder, val, totalWidth) {
        var s = '' + val;
        var padding = totalWidth - s.length;
        writeSafe(builder, s);
        whitespace(builder, padding);
    }
    StringBuilder.writeIntegerPadRight = writeIntegerPadRight;
    /**
     * @example writeFloat(123.2123, 100) -- 2 decim
     */
    function writeFloat(builder, val, precisionMultiplier) {
        writeSafe(builder, '' + Math.round(precisionMultiplier * val) / precisionMultiplier);
    }
    StringBuilder.writeFloat = writeFloat;
    function writeFloatPadLeft(builder, val, precisionMultiplier, totalWidth) {
        var s = '' + Math.round(precisionMultiplier * val) / precisionMultiplier;
        var padding = totalWidth - s.length;
        whitespace(builder, padding);
        writeSafe(builder, s);
    }
    StringBuilder.writeFloatPadLeft = writeFloatPadLeft;
    function writeFloatPadRight(builder, val, precisionMultiplier, totalWidth) {
        var s = '' + Math.round(precisionMultiplier * val) / precisionMultiplier;
        var padding = totalWidth - s.length;
        writeSafe(builder, s);
        whitespace(builder, padding);
    }
    StringBuilder.writeFloatPadRight = writeFloatPadRight;
})(StringBuilder || (StringBuilder = {}));
/* harmony default export */ __webpack_exports__["default"] = (StringBuilder);
//# sourceMappingURL=string-builder.js.map

/***/ }),

/***/ "./lib/mol-util/string.js":
/*!********************************!*\
  !*** ./lib/mol-util/string.js ***!
  \********************************/
/*! exports provided: indentString, splitCamelCase, camelCaseToWords, lowerCase, upperCase, upperCaseAny, capitalize, splitSnakeCase, snakeCaseToWords, splitKebabCase, kebabCaseToWords, stringToWords, substringStartsWith, interpolate, trimChar, trimCharStart, trimCharEnd, stripTags */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "indentString", function() { return indentString; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "splitCamelCase", function() { return splitCamelCase; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "camelCaseToWords", function() { return camelCaseToWords; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "lowerCase", function() { return lowerCase; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "upperCase", function() { return upperCase; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "upperCaseAny", function() { return upperCaseAny; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "capitalize", function() { return capitalize; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "splitSnakeCase", function() { return splitSnakeCase; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "snakeCaseToWords", function() { return snakeCaseToWords; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "splitKebabCase", function() { return splitKebabCase; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "kebabCaseToWords", function() { return kebabCaseToWords; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "stringToWords", function() { return stringToWords; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "substringStartsWith", function() { return substringStartsWith; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "interpolate", function() { return interpolate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "trimChar", function() { return trimChar; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "trimCharStart", function() { return trimCharStart; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "trimCharEnd", function() { return trimCharEnd; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "stripTags", function() { return stripTags; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/**
 * Copyright (c) 2018-2019 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 * @author David Sehnal <david.sehnal@gmail.com>
 */

var reLine = /^/mg;
function indentString(str, count, indent) {
    return count === 0 ? str : str.replace(reLine, indent.repeat(count));
}
/** Add space between camelCase text. */
function splitCamelCase(str, separator) {
    if (separator === void 0) { separator = ' '; }
    return str.replace(/([a-z\xE0-\xFF])([A-Z\xC0\xDF])/g, "$1" + separator + "$2");
}
/** Split camelCase text and capitalize. */
function camelCaseToWords(str) {
    return capitalize(splitCamelCase(str));
}
var lowerCase = function (str) { return str.toLowerCase(); };
var upperCase = function (str) { return str.toUpperCase(); };
/** Return upper case if string, otherwise return empty string */
function upperCaseAny(value) {
    if (!value)
        return '';
    return typeof value === 'string' ? value.toUpperCase() : ("" + value).toUpperCase();
}
/** Uppercase the first character of each word. */
function capitalize(str) {
    return str.toLowerCase().replace(/^\w|\s\w/g, upperCase);
}
function splitSnakeCase(str) {
    return str.replace(/_/g, ' ');
}
function snakeCaseToWords(str) {
    return capitalize(splitSnakeCase(str));
}
function splitKebabCase(str) {
    return str.replace(/-/g, ' ');
}
function kebabCaseToWords(str) {
    return capitalize(splitKebabCase(str));
}
function stringToWords(str) {
    return capitalize(splitCamelCase(splitSnakeCase(splitKebabCase(str))));
}
function substringStartsWith(str, start, end, target) {
    var len = target.length;
    if (len > end - start)
        return false;
    for (var i = 0; i < len; i++) {
        if (str.charCodeAt(start + i) !== target.charCodeAt(i))
            return false;
    }
    return true;
}
function interpolate(str, params) {
    var names = Object.keys(params);
    var values = Object.values(params);
    return new (Function.bind.apply(Function, Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__spreadArrays"])([void 0], names, ["return `" + str + "`;"])))().apply(void 0, values);
}
function trimChar(str, char) {
    var start = 0;
    var end = str.length;
    while (start < end && str[start] === char)
        ++start;
    while (end > start && str[end - 1] === char)
        --end;
    return (start > 0 || end < str.length) ? str.substring(start, end) : str;
}
function trimCharStart(str, char) {
    var start = 0;
    var end = str.length;
    while (start < end && str[start] === char)
        ++start;
    return (start > 0) ? str.substring(start, end) : str;
}
function trimCharEnd(str, char) {
    var end = str.length;
    while (end > 0 && str[end - 1] === char)
        --end;
    return (end < str.length) ? str.substring(0, end) : str;
}
/** Simple function to strip tags from a string */
function stripTags(str) {
    return str.replace(/<\/?[^>]+>/g, '');
}
//# sourceMappingURL=string.js.map

/***/ }),

/***/ "./lib/mol-util/type-helpers.js":
/*!**************************************!*\
  !*** ./lib/mol-util/type-helpers.js ***!
  \**************************************/
/*! exports provided: ObjectKeys */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ObjectKeys", function() { return ObjectKeys; });
/**
 * Copyright (c) 2018-2020 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 * @author David Sehnal <david.sehnal@gmail.com>
 */
function ObjectKeys(o) {
    return Object.keys(o);
}
;
//# sourceMappingURL=type-helpers.js.map

/***/ }),

/***/ "./lib/mol-util/url.js":
/*!*****************************!*\
  !*** ./lib/mol-util/url.js ***!
  \*****************************/
/*! exports provided: urlQueryParameter, urlCombine */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "urlQueryParameter", function() { return urlQueryParameter; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "urlCombine", function() { return urlCombine; });
/**
 * Copyright (c) 2018 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */
function urlQueryParameter(id) {
    if (typeof window === 'undefined')
        return undefined;
    var a = new RegExp(id + "=([^&#=]*)");
    var m = a.exec(window.location.search);
    return m ? decodeURIComponent(m[1]) : undefined;
}
function urlCombine(base, query) {
    return "" + base + (base[base.length - 1] === '/' || query[0] === '/' ? '' : '/') + query;
}
//# sourceMappingURL=url.js.map

/***/ }),

/***/ "./lib/mol-util/uuid.js":
/*!******************************!*\
  !*** ./lib/mol-util/uuid.js ***!
  \******************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* WEBPACK VAR INJECTION */(function(Buffer) {/* harmony import */ var _mol_util_now__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../mol-util/now */ "./lib/mol-util/now.js");
/**
 * Copyright (c) 2017 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author David Sehnal <david.sehnal@gmail.com>
 */

var UUID;
(function (UUID) {
    var _btoa = typeof btoa !== 'undefined' ? btoa : function (s) { return Buffer.from(s).toString('base64'); };
    var chars = [];
    /** Creates a 22 characters 'base64' encoded UUID */
    function create22() {
        var d = (+new Date()) + Object(_mol_util_now__WEBPACK_IMPORTED_MODULE_0__["now"])();
        for (var i = 0; i < 16; i++) {
            chars[i] = String.fromCharCode((d + Math.random() * 0xff) % 0xff | 0);
            d = Math.floor(d / 0xff);
        }
        return _btoa(chars.join('')).replace(/\+/g, '-').replace(/\//g, '_').substr(0, 22);
    }
    UUID.create22 = create22;
    function createv4() {
        var d = (+new Date()) + Object(_mol_util_now__WEBPACK_IMPORTED_MODULE_0__["now"])();
        var uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
            var r = (d + Math.random() * 16) % 16 | 0;
            d = Math.floor(d / 16);
            return (c === 'x' ? r : (r & 0x3 | 0x8)).toString(16);
        });
        return uuid;
    }
    UUID.createv4 = createv4;
    function is(x) {
        return typeof x === 'string';
    }
    UUID.is = is;
})(UUID || (UUID = {}));
/* harmony default export */ __webpack_exports__["default"] = (UUID);
//# sourceMappingURL=uuid.js.map
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(/*! ./../../node_modules/node-libs-browser/node_modules/buffer/index.js */ "./node_modules/node-libs-browser/node_modules/buffer/index.js").Buffer))

/***/ }),

/***/ "./lib/mol-util/value-cell.js":
/*!************************************!*\
  !*** ./lib/mol-util/value-cell.js ***!
  \************************************/
/*! exports provided: ValueRef, ValueBox, ValueCell */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ValueRef", function() { return ValueRef; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ValueBox", function() { return ValueBox; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ValueCell", function() { return ValueCell; });
/* harmony import */ var _id_factory__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./id-factory */ "./lib/mol-util/id-factory.js");
/**
 * Copyright (c) 2018 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author David Sehnal <david.sehnal@gmail.com>
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */

var ValueRef;
(function (ValueRef) {
    function create(ref) { return { ref: ref }; }
    ValueRef.create = create;
    function set(ref, value) { ref.ref = value; return ref; }
    ValueRef.set = set;
})(ValueRef || (ValueRef = {}));
var getNextId = Object(_id_factory__WEBPACK_IMPORTED_MODULE_0__["idFactory"])(0, 0x7FFFFFFF);
var ValueBox;
(function (ValueBox) {
    function create(value, metadata) {
        return { id: getNextId(), version: 0, value: value, metadata: metadata };
    }
    ValueBox.create = create;
    /** The box.metadata is carried over from the old box */
    function withValue(box, value) {
        return { id: box.id, version: box.version + 1, value: value, metadata: box.metadata };
    }
    ValueBox.withValue = withValue;
})(ValueBox || (ValueBox = {}));
var ValueCell;
(function (ValueCell) {
    function create(value, metadata) {
        return ValueRef.create(ValueBox.create(value, metadata));
    }
    ValueCell.create = create;
    /** The box.metadata is carried over from the old box */
    function update(cell, value) {
        return ValueRef.set(cell, ValueBox.withValue(cell.ref, value));
    }
    ValueCell.update = update;
    function set(cell, box) {
        return ValueRef.set(cell, box);
    }
    ValueCell.set = set;
    /** Updates the cell if the value is has changed, comparing by reference */
    function updateIfChanged(cell, value) {
        return cell.ref.value !== value ? update(cell, value) : cell;
    }
    ValueCell.updateIfChanged = updateIfChanged;
})(ValueCell || (ValueCell = {}));

//# sourceMappingURL=value-cell.js.map

/***/ }),

/***/ "./lib/mol-util/zip/bin.js":
/*!*********************************!*\
  !*** ./lib/mol-util/zip/bin.js ***!
  \*********************************/
/*! exports provided: toUint32, toInt32, readUshort, writeUshort, readUint, writeUint, readUTF8, writeUTF8, sizeUTF8 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "toUint32", function() { return toUint32; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "toInt32", function() { return toInt32; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "readUshort", function() { return readUshort; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "writeUshort", function() { return writeUshort; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "readUint", function() { return readUint; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "writeUint", function() { return writeUint; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "readUTF8", function() { return readUTF8; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "writeUTF8", function() { return writeUTF8; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "sizeUTF8", function() { return sizeUTF8; });
/**
 * Copyright (c) 2020 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 *
 * ported from https://github.com/photopea/UZIP.js/blob/master/UZIP.js
 * MIT License, Copyright (c) 2018 Photopea
 */
function toUint32(x) {
    return x >>> 0;
}
function toInt32(x) {
    return x >> 0;
}
function readUshort(buff, p) {
    return (buff[p]) | (buff[p + 1] << 8);
}
function writeUshort(buff, p, n) {
    buff[p] = (n) & 255;
    buff[p + 1] = (n >> 8) & 255;
}
function readUint(buff, p) {
    return (buff[p + 3] * (256 * 256 * 256)) + ((buff[p + 2] << 16) | (buff[p + 1] << 8) | buff[p]);
}
function writeUint(buff, p, n) {
    buff[p] = n & 255;
    buff[p + 1] = (n >> 8) & 255;
    buff[p + 2] = (n >> 16) & 255;
    buff[p + 3] = (n >> 24) & 255;
}
function readASCII(buff, p, l) {
    var s = '';
    for (var i = 0; i < l; i++)
        s += String.fromCharCode(buff[p + i]);
    return s;
}
// function writeASCII(data: Uint8Array, p: number, s: string){
//     for(let i=0; i<s.length; i++) data[p+i] = s.charCodeAt(i);
// }
function pad(n) {
    return n.length < 2 ? '0' + n : n;
}
function readUTF8(buff, p, l) {
    var s = '', ns;
    for (var i = 0; i < l; i++)
        s += '%' + pad(buff[p + i].toString(16));
    try {
        ns = decodeURIComponent(s);
    }
    catch (e) {
        return readASCII(buff, p, l);
    }
    return ns;
}
function writeUTF8(buff, p, str) {
    var strl = str.length;
    var i = 0;
    for (var ci = 0; ci < strl; ci++) {
        var code = str.charCodeAt(ci);
        if ((code & (0xffffffff - (1 << 7) + 1)) === 0) {
            buff[p + i] = (code);
            i++;
        }
        else if ((code & (0xffffffff - (1 << 11) + 1)) === 0) {
            buff[p + i] = (192 | (code >> 6));
            buff[p + i + 1] = (128 | ((code >> 0) & 63));
            i += 2;
        }
        else if ((code & (0xffffffff - (1 << 16) + 1)) === 0) {
            buff[p + i] = (224 | (code >> 12));
            buff[p + i + 1] = (128 | ((code >> 6) & 63));
            buff[p + i + 2] = (128 | ((code >> 0) & 63));
            i += 3;
        }
        else if ((code & (0xffffffff - (1 << 21) + 1)) === 0) {
            buff[p + i] = (240 | (code >> 18));
            buff[p + i + 1] = (128 | ((code >> 12) & 63));
            buff[p + i + 2] = (128 | ((code >> 6) & 63));
            buff[p + i + 3] = (128 | ((code >> 0) & 63));
            i += 4;
        }
        else
            throw 'e';
    }
    return i;
}
function sizeUTF8(str) {
    var strl = str.length;
    var i = 0;
    for (var ci = 0; ci < strl; ci++) {
        var code = str.charCodeAt(ci);
        if ((code & (0xffffffff - (1 << 7) + 1)) === 0) {
            i++;
        }
        else if ((code & (0xffffffff - (1 << 11) + 1)) === 0) {
            i += 2;
        }
        else if ((code & (0xffffffff - (1 << 16) + 1)) === 0) {
            i += 3;
        }
        else if ((code & (0xffffffff - (1 << 21) + 1)) === 0) {
            i += 4;
        }
        else {
            throw 'e';
        }
    }
    return i;
}
//# sourceMappingURL=bin.js.map

/***/ }),

/***/ "./lib/mol-util/zip/checksum.js":
/*!**************************************!*\
  !*** ./lib/mol-util/zip/checksum.js ***!
  \**************************************/
/*! exports provided: crc, adler */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "crc", function() { return crc; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "adler", function() { return adler; });
/**
 * Copyright (c) 2020 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 *
 * ported from https://github.com/photopea/UZIP.js/blob/master/UZIP.js
 * MIT License, Copyright (c) 2018 Photopea
 */
var CrcTable = (function () {
    var tab = new Uint32Array(256);
    for (var n = 0; n < 256; n++) {
        var c = n;
        for (var k = 0; k < 8; k++) {
            if (c & 1)
                c = 0xedb88320 ^ (c >>> 1);
            else
                c = c >>> 1;
        }
        tab[n] = c;
    }
    return tab;
})();
function _crc(c, buf, off, len) {
    for (var i = 0; i < len; i++) {
        c = CrcTable[(c ^ buf[off + i]) & 0xff] ^ (c >>> 8);
    }
    return c;
}
function crc(b, o, l) {
    return _crc(0xffffffff, b, o, l) ^ 0xffffffff;
}
function adler(data, o, len) {
    var a = 1, b = 0;
    var off = o;
    var end = o + len;
    while (off < end) {
        var eend = Math.min(off + 5552, end);
        while (off < eend) {
            a += data[off++];
            b += a;
        }
        a = a % 65521;
        b = b % 65521;
    }
    return (b << 16) | a;
}
//# sourceMappingURL=checksum.js.map

/***/ }),

/***/ "./lib/mol-util/zip/deflate.js":
/*!*************************************!*\
  !*** ./lib/mol-util/zip/deflate.js ***!
  \*************************************/
/*! exports provided: _deflateRaw */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_deflateRaw", function() { return _deflateRaw; });
/* harmony import */ var _huffman__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./huffman */ "./lib/mol-util/zip/huffman.js");
/* harmony import */ var _util__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./util */ "./lib/mol-util/zip/util.js");
/**
 * Copyright (c) 2020 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 *
 * ported from https://github.com/photopea/UZIP.js/blob/master/UZIP.js
 * MIT License, Copyright (c) 2018 Photopea
 */


function _deflateRaw(data, out, opos, lvl) {
    var opts = [
        /*
            ush good_length; /* reduce lazy search above this match length
            ush max_lazy;    /* do not perform lazy search above this match length
            ush nice_length; /* quit search above this match length
        */
        /*      good lazy nice chain */
        /* 0 */ [0, 0, 0, 0, 0],
        /* 1 */ [4, 4, 8, 4, 0],
        /* 2 */ [4, 5, 16, 8, 0],
        /* 3 */ [4, 6, 16, 16, 0],
        /* 4 */ [4, 10, 16, 32, 0],
        /* 5 */ [8, 16, 32, 32, 0],
        /* 6 */ [8, 16, 128, 128, 0],
        /* 7 */ [8, 32, 128, 256, 0],
        /* 8 */ [32, 128, 258, 1024, 1],
        /* 9 */ [32, 258, 258, 4096, 1] /* max compression */
    ];
    var opt = opts[lvl];
    var i = 0, pos = opos << 3, cvrd = 0;
    var dlen = data.length;
    if (lvl === 0) {
        while (i < dlen) {
            var len = Math.min(0xffff, dlen - i);
            _putsE(out, pos, (i + len === dlen ? 1 : 0));
            pos = _copyExact(data, i, len, out, pos + 8);
            i += len;
        }
        return pos >>> 3;
    }
    var lits = _util__WEBPACK_IMPORTED_MODULE_1__["U"].lits, strt = _util__WEBPACK_IMPORTED_MODULE_1__["U"].strt, prev = _util__WEBPACK_IMPORTED_MODULE_1__["U"].prev;
    var li = 0, lc = 0, bs = 0, ebits = 0, c = 0, nc = 0; // last_item, literal_count, block_start
    if (dlen > 2) {
        nc = _hash(data, 0);
        strt[nc] = 0;
    }
    // let nmch = 0
    // let nmci = 0
    for (i = 0; i < dlen; i++) {
        c = nc;
        //*
        if (i + 1 < dlen - 2) {
            nc = _hash(data, i + 1);
            var ii = ((i + 1) & 0x7fff);
            prev[ii] = strt[nc];
            strt[nc] = ii;
        } // */
        if (cvrd <= i) {
            if ((li > 14000 || lc > 26697) && (dlen - i) > 100) {
                if (cvrd < i) {
                    lits[li] = i - cvrd;
                    li += 2;
                    cvrd = i;
                }
                pos = _writeBlock(((i === dlen - 1) || (cvrd === dlen)) ? 1 : 0, lits, li, ebits, data, bs, i - bs, out, pos);
                li = lc = ebits = 0;
                bs = i;
            }
            var mch = 0;
            // if(nmci==i) mch= nmch;  else
            if (i < dlen - 2) {
                mch = _bestMatch(data, i, prev, c, Math.min(opt[2], dlen - i), opt[3]);
            }
            /*
            if(mch!=0 && opt[4]==1 && (mch>>>16)<opt[1] && i+1<dlen-2) {
                nmch = UZIP.F._bestMatch(data, i+1, prev, nc, opt[2], opt[3]);  nmci=i+1;
                //var mch2 = UZIP.F._bestMatch(data, i+2, prev, nnc);  //nmci=i+1;
                if((nmch>>>16)>(mch>>>16)) mch=0;
            }//*/
            // const len = mch>>>16, dst = mch & 0xffff;  // if(i-dst<0) throw "e";
            if (mch !== 0) {
                var len = mch >>> 16, dst = mch & 0xffff; // if(i-dst<0) throw "e";
                var lgi = _goodIndex(len, _util__WEBPACK_IMPORTED_MODULE_1__["U"].of0);
                _util__WEBPACK_IMPORTED_MODULE_1__["U"].lhst[257 + lgi]++;
                var dgi = _goodIndex(dst, _util__WEBPACK_IMPORTED_MODULE_1__["U"].df0);
                _util__WEBPACK_IMPORTED_MODULE_1__["U"].dhst[dgi]++;
                ebits += _util__WEBPACK_IMPORTED_MODULE_1__["U"].exb[lgi] + _util__WEBPACK_IMPORTED_MODULE_1__["U"].dxb[dgi];
                lits[li] = (len << 23) | (i - cvrd);
                lits[li + 1] = (dst << 16) | (lgi << 8) | dgi;
                li += 2;
                cvrd = i + len;
            }
            else {
                _util__WEBPACK_IMPORTED_MODULE_1__["U"].lhst[data[i]]++;
            }
            lc++;
        }
    }
    if (bs !== i || data.length === 0) {
        if (cvrd < i) {
            lits[li] = i - cvrd;
            li += 2;
            cvrd = i;
        }
        pos = _writeBlock(1, lits, li, ebits, data, bs, i - bs, out, pos);
        li = 0;
        lc = 0;
        li = lc = ebits = 0;
        bs = i;
    }
    while ((pos & 7) !== 0)
        pos++;
    return pos >>> 3;
}
function _bestMatch(data, i, prev, c, nice, chain) {
    var ci = (i & 0x7fff), pi = prev[ci];
    // console.log("----", i);
    var dif = ((ci - pi + (1 << 15)) & 0x7fff);
    if (pi === ci || c !== _hash(data, i - dif))
        return 0;
    var tl = 0, td = 0; // top length, top distance
    var dlim = Math.min(0x7fff, i);
    while (dif <= dlim && --chain !== 0 && pi !== ci /* && c==UZIP.F._hash(data,i-dif)*/) {
        if (tl === 0 || (data[i + tl] === data[i + tl - dif])) {
            var cl = _howLong(data, i, dif);
            if (cl > tl) {
                tl = cl;
                td = dif;
                if (tl >= nice)
                    break; //*
                if (dif + 2 < cl)
                    cl = dif + 2;
                var maxd = 0; // pi does not point to the start of the word
                for (var j = 0; j < cl - 2; j++) {
                    var ei = (i - dif + j + (1 << 15)) & 0x7fff;
                    var li = prev[ei];
                    var curd = (ei - li + (1 << 15)) & 0x7fff;
                    if (curd > maxd) {
                        maxd = curd;
                        pi = ei;
                    }
                }
            }
        }
        ci = pi;
        pi = prev[ci];
        dif += ((ci - pi + (1 << 15)) & 0x7fff);
    }
    return (tl << 16) | td;
}
function _howLong(data, i, dif) {
    if (data[i] !== data[i - dif] || data[i + 1] !== data[i + 1 - dif] || data[i + 2] !== data[i + 2 - dif])
        return 0;
    var oi = i, l = Math.min(data.length, i + 258);
    i += 3;
    // while(i+4<l && data[i]==data[i-dif] && data[i+1]==data[i+1-dif] && data[i+2]==data[i+2-dif] && data[i+3]==data[i+3-dif]) i+=4;
    while (i < l && data[i] === data[i - dif])
        i++;
    return i - oi;
}
function _hash(data, i) {
    return (((data[i] << 8) | data[i + 1]) + (data[i + 2] << 4)) & 0xffff;
    // var hash_shift = 0, hash_mask = 255;
    // var h = data[i+1] % 251;
    // h = (((h << 8) + data[i+2]) % 251);
    // h = (((h << 8) + data[i+2]) % 251);
    // h = ((h<<hash_shift) ^ (c) ) & hash_mask;
    // return h | (data[i]<<8);
    // return (data[i] | (data[i+1]<<8));
}
function _writeBlock(BFINAL, lits, li, ebits, data, o0, l0, out, pos) {
    _util__WEBPACK_IMPORTED_MODULE_1__["U"].lhst[256]++;
    var _a = getTrees(), ML = _a[0], MD = _a[1], MH = _a[2], numl = _a[3], numd = _a[4], numh = _a[5], lset = _a[6], dset = _a[7];
    var cstSize = (((pos + 3) & 7) === 0 ? 0 : 8 - ((pos + 3) & 7)) + 32 + (l0 << 3);
    var fxdSize = ebits + contSize(_util__WEBPACK_IMPORTED_MODULE_1__["U"].fltree, _util__WEBPACK_IMPORTED_MODULE_1__["U"].lhst) + contSize(_util__WEBPACK_IMPORTED_MODULE_1__["U"].fdtree, _util__WEBPACK_IMPORTED_MODULE_1__["U"].dhst);
    var dynSize = ebits + contSize(_util__WEBPACK_IMPORTED_MODULE_1__["U"].ltree, _util__WEBPACK_IMPORTED_MODULE_1__["U"].lhst) + contSize(_util__WEBPACK_IMPORTED_MODULE_1__["U"].dtree, _util__WEBPACK_IMPORTED_MODULE_1__["U"].dhst);
    dynSize += 14 + 3 * numh + contSize(_util__WEBPACK_IMPORTED_MODULE_1__["U"].itree, _util__WEBPACK_IMPORTED_MODULE_1__["U"].ihst) + (_util__WEBPACK_IMPORTED_MODULE_1__["U"].ihst[16] * 2 + _util__WEBPACK_IMPORTED_MODULE_1__["U"].ihst[17] * 3 + _util__WEBPACK_IMPORTED_MODULE_1__["U"].ihst[18] * 7);
    for (var j = 0; j < 286; j++)
        _util__WEBPACK_IMPORTED_MODULE_1__["U"].lhst[j] = 0;
    for (var j = 0; j < 30; j++)
        _util__WEBPACK_IMPORTED_MODULE_1__["U"].dhst[j] = 0;
    for (var j = 0; j < 19; j++)
        _util__WEBPACK_IMPORTED_MODULE_1__["U"].ihst[j] = 0;
    var BTYPE = (cstSize < fxdSize && cstSize < dynSize) ? 0 : (fxdSize < dynSize ? 1 : 2);
    _putsF(out, pos, BFINAL);
    _putsF(out, pos + 1, BTYPE);
    pos += 3;
    // let opos = pos;
    if (BTYPE === 0) {
        while ((pos & 7) !== 0)
            pos++;
        pos = _copyExact(data, o0, l0, out, pos);
    }
    else {
        var ltree = void 0, dtree = void 0;
        if (BTYPE === 1) {
            ltree = _util__WEBPACK_IMPORTED_MODULE_1__["U"].fltree;
            dtree = _util__WEBPACK_IMPORTED_MODULE_1__["U"].fdtree;
        }
        else if (BTYPE === 2) {
            Object(_util__WEBPACK_IMPORTED_MODULE_1__["makeCodes"])(_util__WEBPACK_IMPORTED_MODULE_1__["U"].ltree, ML);
            Object(_util__WEBPACK_IMPORTED_MODULE_1__["revCodes"])(_util__WEBPACK_IMPORTED_MODULE_1__["U"].ltree, ML);
            Object(_util__WEBPACK_IMPORTED_MODULE_1__["makeCodes"])(_util__WEBPACK_IMPORTED_MODULE_1__["U"].dtree, MD);
            Object(_util__WEBPACK_IMPORTED_MODULE_1__["revCodes"])(_util__WEBPACK_IMPORTED_MODULE_1__["U"].dtree, MD);
            Object(_util__WEBPACK_IMPORTED_MODULE_1__["makeCodes"])(_util__WEBPACK_IMPORTED_MODULE_1__["U"].itree, MH);
            Object(_util__WEBPACK_IMPORTED_MODULE_1__["revCodes"])(_util__WEBPACK_IMPORTED_MODULE_1__["U"].itree, MH);
            ltree = _util__WEBPACK_IMPORTED_MODULE_1__["U"].ltree;
            dtree = _util__WEBPACK_IMPORTED_MODULE_1__["U"].dtree;
            _putsE(out, pos, numl - 257);
            pos += 5; // 286
            _putsE(out, pos, numd - 1);
            pos += 5; // 30
            _putsE(out, pos, numh - 4);
            pos += 4; // 19
            for (var i = 0; i < numh; i++)
                _putsE(out, pos + i * 3, _util__WEBPACK_IMPORTED_MODULE_1__["U"].itree[(_util__WEBPACK_IMPORTED_MODULE_1__["U"].ordr[i] << 1) + 1]);
            pos += 3 * numh;
            pos = _codeTiny(lset, _util__WEBPACK_IMPORTED_MODULE_1__["U"].itree, out, pos);
            pos = _codeTiny(dset, _util__WEBPACK_IMPORTED_MODULE_1__["U"].itree, out, pos);
        }
        else {
            throw new Error("unknown BTYPE " + BTYPE);
        }
        var off = o0;
        for (var si = 0; si < li; si += 2) {
            var qb = lits[si], len = (qb >>> 23), end = off + (qb & ((1 << 23) - 1));
            while (off < end)
                pos = _writeLit(data[off++], ltree, out, pos);
            if (len !== 0) {
                var qc = lits[si + 1], dst = (qc >> 16), lgi = (qc >> 8) & 255, dgi = (qc & 255);
                pos = _writeLit(257 + lgi, ltree, out, pos);
                _putsE(out, pos, len - _util__WEBPACK_IMPORTED_MODULE_1__["U"].of0[lgi]);
                pos += _util__WEBPACK_IMPORTED_MODULE_1__["U"].exb[lgi];
                pos = _writeLit(dgi, dtree, out, pos);
                _putsF(out, pos, dst - _util__WEBPACK_IMPORTED_MODULE_1__["U"].df0[dgi]);
                pos += _util__WEBPACK_IMPORTED_MODULE_1__["U"].dxb[dgi];
                off += len;
            }
        }
        pos = _writeLit(256, ltree, out, pos);
    }
    // console.log(pos-opos, fxdSize, dynSize, cstSize);
    return pos;
}
function _copyExact(data, off, len, out, pos) {
    var p8 = (pos >>> 3);
    out[p8] = (len);
    out[p8 + 1] = (len >>> 8);
    out[p8 + 2] = 255 - out[p8];
    out[p8 + 3] = 255 - out[p8 + 1];
    p8 += 4;
    out.set(new Uint8Array(data.buffer, off, len), p8);
    // for(var i=0; i<len; i++) out[p8+i]=data[off+i];
    return pos + ((len + 4) << 3);
}
/*
    Interesting facts:
    - decompressed block can have bytes, which do not occur in a Huffman tree (copied from the previous block by reference)
*/
function getTrees() {
    var ML = Object(_huffman__WEBPACK_IMPORTED_MODULE_0__["_hufTree"])(_util__WEBPACK_IMPORTED_MODULE_1__["U"].lhst, _util__WEBPACK_IMPORTED_MODULE_1__["U"].ltree, 15);
    var MD = Object(_huffman__WEBPACK_IMPORTED_MODULE_0__["_hufTree"])(_util__WEBPACK_IMPORTED_MODULE_1__["U"].dhst, _util__WEBPACK_IMPORTED_MODULE_1__["U"].dtree, 15);
    var lset = [];
    var numl = _lenCodes(_util__WEBPACK_IMPORTED_MODULE_1__["U"].ltree, lset);
    var dset = [];
    var numd = _lenCodes(_util__WEBPACK_IMPORTED_MODULE_1__["U"].dtree, dset);
    for (var i = 0; i < lset.length; i += 2)
        _util__WEBPACK_IMPORTED_MODULE_1__["U"].ihst[lset[i]]++;
    for (var i = 0; i < dset.length; i += 2)
        _util__WEBPACK_IMPORTED_MODULE_1__["U"].ihst[dset[i]]++;
    var MH = Object(_huffman__WEBPACK_IMPORTED_MODULE_0__["_hufTree"])(_util__WEBPACK_IMPORTED_MODULE_1__["U"].ihst, _util__WEBPACK_IMPORTED_MODULE_1__["U"].itree, 7);
    var numh = 19;
    while (numh > 4 && _util__WEBPACK_IMPORTED_MODULE_1__["U"].itree[(_util__WEBPACK_IMPORTED_MODULE_1__["U"].ordr[numh - 1] << 1) + 1] === 0)
        numh--;
    return [ML, MD, MH, numl, numd, numh, lset, dset];
}
function contSize(tree, hst) {
    var s = 0;
    for (var i = 0; i < hst.length; i++)
        s += hst[i] * tree[(i << 1) + 1];
    return s;
}
function _codeTiny(set, tree, out, pos) {
    for (var i = 0; i < set.length; i += 2) {
        var l = set[i], rst = set[i + 1]; // console.log(l, pos, tree[(l<<1)+1]);
        pos = _writeLit(l, tree, out, pos);
        var rsl = l === 16 ? 2 : (l === 17 ? 3 : 7);
        if (l > 15) {
            _putsE(out, pos, rst);
            pos += rsl;
        }
    }
    return pos;
}
function _lenCodes(tree, set) {
    var len = tree.length;
    while (len !== 2 && tree[len - 1] === 0)
        len -= 2; // when no distances, keep one code with length 0
    for (var i = 0; i < len; i += 2) {
        var l = tree[i + 1], nxt = (i + 3 < len ? tree[i + 3] : -1), nnxt = (i + 5 < len ? tree[i + 5] : -1), prv = (i === 0 ? -1 : tree[i - 1]);
        if (l === 0 && nxt === l && nnxt === l) {
            var lz = i + 5;
            while (lz + 2 < len && tree[lz + 2] === l)
                lz += 2;
            var zc = Math.min((lz + 1 - i) >>> 1, 138);
            if (zc < 11)
                set.push(17, zc - 3);
            else
                set.push(18, zc - 11);
            i += zc * 2 - 2;
        }
        else if (l === prv && nxt === l && nnxt === l) {
            var lz = i + 5;
            while (lz + 2 < len && tree[lz + 2] === l)
                lz += 2;
            var zc = Math.min((lz + 1 - i) >>> 1, 6);
            set.push(16, zc - 3);
            i += zc * 2 - 2;
        }
        else {
            set.push(l, 0);
        }
    }
    return len >>> 1;
}
function _goodIndex(v, arr) {
    var i = 0;
    if (arr[i | 16] <= v)
        i |= 16;
    if (arr[i | 8] <= v)
        i |= 8;
    if (arr[i | 4] <= v)
        i |= 4;
    if (arr[i | 2] <= v)
        i |= 2;
    if (arr[i | 1] <= v)
        i |= 1;
    return i;
}
function _writeLit(ch, ltree, out, pos) {
    _putsF(out, pos, ltree[ch << 1]);
    return pos + ltree[(ch << 1) + 1];
}
function _putsE(dt, pos, val) {
    val = val << (pos & 7);
    var o = (pos >>> 3);
    dt[o] |= val;
    dt[o + 1] |= (val >>> 8);
}
function _putsF(dt, pos, val) {
    val = val << (pos & 7);
    var o = (pos >>> 3);
    dt[o] |= val;
    dt[o + 1] |= (val >>> 8);
    dt[o + 2] |= (val >>> 16);
}
//# sourceMappingURL=deflate.js.map

/***/ }),

/***/ "./lib/mol-util/zip/huffman.js":
/*!*************************************!*\
  !*** ./lib/mol-util/zip/huffman.js ***!
  \*************************************/
/*! exports provided: _hufTree */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_hufTree", function() { return _hufTree; });
/**
 * Copyright (c) 2020 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 *
 * ported from https://github.com/photopea/UZIP.js/blob/master/UZIP.js
 * MIT License, Copyright (c) 2018 Photopea
 */
function _hufTree(hst, tree, MAXL) {
    var list = [];
    var hl = hst.length, tl = tree.length;
    for (var i = 0; i < tl; i += 2) {
        tree[i] = 0;
        tree[i + 1] = 0;
    }
    for (var i = 0; i < hl; i++)
        if (hst[i] !== 0)
            list.push({ lit: i, f: hst[i], d: undefined });
    var end = list.length, l2 = list.slice(0);
    if (end === 0)
        return 0; // empty histogram (usually for dist)
    if (end === 1) {
        var lit = list[0].lit, l2_1 = lit === 0 ? 1 : 0;
        tree[(lit << 1) + 1] = 1;
        tree[(l2_1 << 1) + 1] = 1;
        return 1;
    }
    list.sort(function (a, b) { return a.f - b.f; });
    var a = list[0], b = list[1], i0 = 0, i1 = 1, i2 = 2;
    list[0] = {
        lit: -1,
        f: a.f + b.f,
        l: a,
        r: b,
        d: 0
    };
    while (i1 !== end - 1) {
        if (i0 !== i1 && (i2 === end || list[i0].f < list[i2].f)) {
            a = list[i0++];
        }
        else {
            a = list[i2++];
        }
        if (i0 !== i1 && (i2 === end || list[i0].f < list[i2].f)) {
            b = list[i0++];
        }
        else {
            b = list[i2++];
        }
        list[i1++] = {
            lit: -1,
            f: a.f + b.f,
            l: a,
            r: b,
            d: undefined
        };
    }
    var maxl = setDepth(list[i1 - 1], 0);
    if (maxl > MAXL) {
        restrictDepth(l2, MAXL, maxl);
        maxl = MAXL;
    }
    for (var i = 0; i < end; i++)
        tree[(l2[i].lit << 1) + 1] = l2[i].d;
    return maxl;
}
function setDepth(t, d) {
    if (t.lit !== -1) {
        t.d = d;
        return d;
    }
    return Math.max(setDepth(t.l, d + 1), setDepth(t.r, d + 1));
}
function restrictDepth(dps, MD, maxl) {
    var i = 0, bCost = 1 << (maxl - MD), dbt = 0;
    dps.sort(function (a, b) { return b.d === a.d ? a.f - b.f : b.d - a.d; });
    for (i = 0; i < dps.length; i++) {
        if (dps[i].d > MD) {
            var od = dps[i].d;
            dps[i].d = MD;
            dbt += bCost - (1 << (maxl - od));
        }
        else {
            break;
        }
    }
    dbt = dbt >>> (maxl - MD);
    while (dbt > 0) {
        var od = dps[i].d;
        if (od < MD) {
            dps[i].d++;
            dbt -= (1 << (MD - od - 1));
        }
        else {
            i++;
        }
    }
    for (; i >= 0; i--) {
        if (dps[i].d === MD && dbt < 0) {
            dps[i].d--;
            dbt++;
        }
    }
    if (dbt !== 0)
        console.log('debt left');
}
//# sourceMappingURL=huffman.js.map

/***/ }),

/***/ "./lib/mol-util/zip/inflate.js":
/*!*************************************!*\
  !*** ./lib/mol-util/zip/inflate.js ***!
  \*************************************/
/*! exports provided: _inflate */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_inflate", function() { return _inflate; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _util__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./util */ "./lib/mol-util/zip/util.js");
/**
 * Copyright (c) 2020 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 *
 * ported from https://github.com/photopea/UZIP.js/blob/master/UZIP.js
 * MIT License, Copyright (c) 2018 Photopea
 */


function InflateContext(data, buf) {
    var noBuf = buf === undefined;
    if (buf === undefined)
        buf = new Uint8Array((data.length >>> 2) << 3);
    return {
        data: data,
        buf: buf,
        noBuf: noBuf,
        BFINAL: 0,
        off: 0,
        pos: 0
    };
}
function inflateBlocks(ctx, count) {
    var data = ctx.data, noBuf = ctx.noBuf;
    var buf = ctx.buf, BFINAL = ctx.BFINAL, off = ctx.off, pos = ctx.pos;
    var iBlock = 0;
    while (BFINAL === 0 && iBlock < count) {
        var lmap = void 0, dmap = void 0;
        var ML = 0, MD = 0;
        BFINAL = _bitsF(data, pos, 1);
        iBlock += 1;
        var BTYPE = _bitsF(data, pos + 1, 2);
        pos += 3;
        if (BTYPE === 0) {
            // uncompressed block
            if ((pos & 7) !== 0)
                pos += 8 - (pos & 7);
            var p8 = (pos >>> 3) + 4;
            var len = data[p8 - 4] | (data[p8 - 3] << 8);
            if (noBuf)
                buf = _check(buf, off + len);
            buf.set(new Uint8Array(data.buffer, data.byteOffset + p8, len), off);
            pos = ((p8 + len) << 3);
            off += len;
            continue;
        }
        // grow output buffer if not provided
        if (noBuf)
            buf = _check(buf, off + (1 << 17));
        if (BTYPE === 1) {
            // block compressed with fixed Huffman codes
            lmap = _util__WEBPACK_IMPORTED_MODULE_1__["U"].flmap;
            dmap = _util__WEBPACK_IMPORTED_MODULE_1__["U"].fdmap;
            ML = (1 << 9) - 1;
            MD = (1 << 5) - 1;
        }
        else if (BTYPE === 2) {
            // block compressed with dynamic Huffman codes
            var HLIT = _bitsE(data, pos, 5) + 257;
            var HDIST = _bitsE(data, pos + 5, 5) + 1;
            var HCLEN = _bitsE(data, pos + 10, 4) + 4;
            pos += 14;
            for (var i = 0; i < 38; i += 2) {
                _util__WEBPACK_IMPORTED_MODULE_1__["U"].itree[i] = 0;
                _util__WEBPACK_IMPORTED_MODULE_1__["U"].itree[i + 1] = 0;
            }
            var tl = 1;
            for (var i = 0; i < HCLEN; i++) {
                var l = _bitsE(data, pos + i * 3, 3);
                _util__WEBPACK_IMPORTED_MODULE_1__["U"].itree[(_util__WEBPACK_IMPORTED_MODULE_1__["U"].ordr[i] << 1) + 1] = l;
                if (l > tl)
                    tl = l;
            }
            pos += 3 * HCLEN;
            Object(_util__WEBPACK_IMPORTED_MODULE_1__["makeCodes"])(_util__WEBPACK_IMPORTED_MODULE_1__["U"].itree, tl);
            Object(_util__WEBPACK_IMPORTED_MODULE_1__["codes2map"])(_util__WEBPACK_IMPORTED_MODULE_1__["U"].itree, tl, _util__WEBPACK_IMPORTED_MODULE_1__["U"].imap);
            lmap = _util__WEBPACK_IMPORTED_MODULE_1__["U"].lmap;
            dmap = _util__WEBPACK_IMPORTED_MODULE_1__["U"].dmap;
            pos = _decodeTiny(_util__WEBPACK_IMPORTED_MODULE_1__["U"].imap, (1 << tl) - 1, HLIT + HDIST, data, pos, _util__WEBPACK_IMPORTED_MODULE_1__["U"].ttree);
            var mx0 = _copyOut(_util__WEBPACK_IMPORTED_MODULE_1__["U"].ttree, 0, HLIT, _util__WEBPACK_IMPORTED_MODULE_1__["U"].ltree);
            ML = (1 << mx0) - 1;
            var mx1 = _copyOut(_util__WEBPACK_IMPORTED_MODULE_1__["U"].ttree, HLIT, HDIST, _util__WEBPACK_IMPORTED_MODULE_1__["U"].dtree);
            MD = (1 << mx1) - 1;
            Object(_util__WEBPACK_IMPORTED_MODULE_1__["makeCodes"])(_util__WEBPACK_IMPORTED_MODULE_1__["U"].ltree, mx0);
            Object(_util__WEBPACK_IMPORTED_MODULE_1__["codes2map"])(_util__WEBPACK_IMPORTED_MODULE_1__["U"].ltree, mx0, lmap);
            Object(_util__WEBPACK_IMPORTED_MODULE_1__["makeCodes"])(_util__WEBPACK_IMPORTED_MODULE_1__["U"].dtree, mx1);
            Object(_util__WEBPACK_IMPORTED_MODULE_1__["codes2map"])(_util__WEBPACK_IMPORTED_MODULE_1__["U"].dtree, mx1, dmap);
        }
        else {
            throw new Error("unknown BTYPE " + BTYPE);
        }
        while (true) {
            var code = lmap[_get17(data, pos) & ML];
            pos += code & 15;
            var lit = code >>> 4;
            if ((lit >>> 8) === 0) {
                buf[off++] = lit;
            }
            else if (lit === 256) {
                break;
            }
            else {
                var end = off + lit - 254;
                if (lit > 264) {
                    var ebs = _util__WEBPACK_IMPORTED_MODULE_1__["U"].ldef[lit - 257];
                    end = off + (ebs >>> 3) + _bitsE(data, pos, ebs & 7);
                    pos += ebs & 7;
                }
                var dcode = dmap[_get17(data, pos) & MD];
                pos += dcode & 15;
                var dlit = dcode >>> 4;
                var dbs = _util__WEBPACK_IMPORTED_MODULE_1__["U"].ddef[dlit];
                var dst = (dbs >>> 4) + _bitsF(data, pos, dbs & 15);
                pos += dbs & 15;
                if (noBuf)
                    buf = _check(buf, off + (1 << 17));
                while (off < end) {
                    buf[off] = buf[off++ - dst];
                    buf[off] = buf[off++ - dst];
                    buf[off] = buf[off++ - dst];
                    buf[off] = buf[off++ - dst];
                }
                off = end;
            }
        }
    }
    ctx.buf = buf;
    ctx.BFINAL = BFINAL;
    ctx.off = off;
    ctx.pos = pos;
}
// https://tools.ietf.org/html/rfc1951
function _inflate(runtime, data, buf) {
    return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"])(this, void 0, void 0, function () {
        var ctx;
        return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__generator"])(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (data[0] === 3 && data[1] === 0)
                        return [2 /*return*/, (buf ? buf : new Uint8Array(0))];
                    ctx = InflateContext(data, buf);
                    _a.label = 1;
                case 1:
                    if (!(ctx.BFINAL === 0)) return [3 /*break*/, 4];
                    if (!runtime.shouldUpdate) return [3 /*break*/, 3];
                    return [4 /*yield*/, runtime.update({ message: 'Inflating blocks...', current: ctx.pos, max: data.length })];
                case 2:
                    _a.sent();
                    _a.label = 3;
                case 3:
                    inflateBlocks(ctx, 100);
                    return [3 /*break*/, 1];
                case 4: return [2 /*return*/, ctx.buf.length === ctx.off ? ctx.buf : ctx.buf.slice(0, ctx.off)];
            }
        });
    });
}
function _check(buf, len) {
    var bl = buf.length;
    if (len <= bl)
        return buf;
    var nbuf = new Uint8Array(Math.max(bl << 1, len));
    nbuf.set(buf, 0);
    return nbuf;
}
function _decodeTiny(lmap, LL, len, data, pos, tree) {
    var i = 0;
    while (i < len) {
        var code = lmap[_get17(data, pos) & LL];
        pos += code & 15;
        var lit = code >>> 4;
        if (lit <= 15) {
            tree[i] = lit;
            i++;
        }
        else {
            var ll = 0, n = 0;
            if (lit === 16) {
                n = (3 + _bitsE(data, pos, 2));
                pos += 2;
                ll = tree[i - 1];
            }
            else if (lit === 17) {
                n = (3 + _bitsE(data, pos, 3));
                pos += 3;
            }
            else if (lit === 18) {
                n = (11 + _bitsE(data, pos, 7));
                pos += 7;
            }
            var ni = i + n;
            while (i < ni) {
                tree[i] = ll;
                i++;
            }
        }
    }
    return pos;
}
function _copyOut(src, off, len, tree) {
    var mx = 0, i = 0;
    var tl = tree.length >>> 1;
    while (i < len) {
        var v = src[i + off];
        tree[(i << 1)] = 0;
        tree[(i << 1) + 1] = v;
        if (v > mx)
            mx = v;
        i++;
    }
    while (i < tl) {
        tree[(i << 1)] = 0;
        tree[(i << 1) + 1] = 0;
        i++;
    }
    return mx;
}
function _bitsE(dt, pos, length) {
    return ((dt[pos >>> 3] | (dt[(pos >>> 3) + 1] << 8)) >>> (pos & 7)) & ((1 << length) - 1);
}
function _bitsF(dt, pos, length) {
    return ((dt[pos >>> 3] | (dt[(pos >>> 3) + 1] << 8) | (dt[(pos >>> 3) + 2] << 16)) >>> (pos & 7)) & ((1 << length) - 1);
}
function _get17(dt, pos) {
    return (dt[pos >>> 3] | (dt[(pos >>> 3) + 1] << 8) | (dt[(pos >>> 3) + 2] << 16)) >>> (pos & 7);
}
//# sourceMappingURL=inflate.js.map

/***/ }),

/***/ "./lib/mol-util/zip/util.js":
/*!**********************************!*\
  !*** ./lib/mol-util/zip/util.js ***!
  \**********************************/
/*! exports provided: U, codes2map, makeCodes, revCodes */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "U", function() { return U; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "codes2map", function() { return codes2map; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "makeCodes", function() { return makeCodes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "revCodes", function() { return revCodes; });
/**
 * Copyright (c) 2020 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 *
 * ported from https://github.com/photopea/UZIP.js/blob/master/UZIP.js
 * MIT License, Copyright (c) 2018 Photopea
 */
var U = (function () {
    var u16 = Uint16Array, u32 = Uint32Array;
    return {
        next_code: new u16(16),
        bl_count: new u16(16),
        ordr: [16, 17, 18, 0, 8, 7, 9, 6, 10, 5, 11, 4, 12, 3, 13, 2, 14, 1, 15],
        of0: [3, 4, 5, 6, 7, 8, 9, 10, 11, 13, 15, 17, 19, 23, 27, 31, 35, 43, 51, 59, 67, 83, 99, 115, 131, 163, 195, 227, 258, 999, 999, 999],
        exb: [0, 0, 0, 0, 0, 0, 0, 0, 1, 1, 1, 1, 2, 2, 2, 2, 3, 3, 3, 3, 4, 4, 4, 4, 5, 5, 5, 5, 0, 0, 0, 0],
        ldef: new u16(32),
        df0: [1, 2, 3, 4, 5, 7, 9, 13, 17, 25, 33, 49, 65, 97, 129, 193, 257, 385, 513, 769, 1025, 1537, 2049, 3073, 4097, 6145, 8193, 12289, 16385, 24577, 65535, 65535],
        dxb: [0, 0, 0, 0, 1, 1, 2, 2, 3, 3, 4, 4, 5, 5, 6, 6, 7, 7, 8, 8, 9, 9, 10, 10, 11, 11, 12, 12, 13, 13, 0, 0],
        ddef: new u32(32),
        flmap: new u16(512),
        fltree: [],
        fdmap: new u16(32),
        fdtree: [],
        lmap: new u16(32768),
        ltree: [], ttree: [],
        dmap: new u16(32768),
        dtree: [],
        imap: new u16(512),
        itree: [],
        // rev9 : new u16(  512)
        rev15: new u16(1 << 15),
        lhst: new u32(286), dhst: new u32(30), ihst: new u32(19),
        lits: new u32(15000),
        strt: new u16(1 << 16),
        prev: new u16(1 << 15)
    };
})();
(function () {
    var len = 1 << 15;
    for (var i = 0; i < len; i++) {
        var x = i;
        x = (((x & 0xaaaaaaaa) >>> 1) | ((x & 0x55555555) << 1));
        x = (((x & 0xcccccccc) >>> 2) | ((x & 0x33333333) << 2));
        x = (((x & 0xf0f0f0f0) >>> 4) | ((x & 0x0f0f0f0f) << 4));
        x = (((x & 0xff00ff00) >>> 8) | ((x & 0x00ff00ff) << 8));
        U.rev15[i] = (((x >>> 16) | (x << 16))) >>> 17;
    }
    function pushV(tgt, n, sv) {
        while (n-- !== 0)
            tgt.push(0, sv);
    }
    for (var i = 0; i < 32; i++) {
        U.ldef[i] = (U.of0[i] << 3) | U.exb[i];
        U.ddef[i] = (U.df0[i] << 4) | U.dxb[i];
    }
    pushV(U.fltree, 144, 8);
    pushV(U.fltree, 255 - 143, 9);
    pushV(U.fltree, 279 - 255, 7);
    pushV(U.fltree, 287 - 279, 8);
    /*
    var i = 0;
    for(; i<=143; i++) U.fltree.push(0,8);
    for(; i<=255; i++) U.fltree.push(0,9);
    for(; i<=279; i++) U.fltree.push(0,7);
    for(; i<=287; i++) U.fltree.push(0,8);
    */
    makeCodes(U.fltree, 9);
    codes2map(U.fltree, 9, U.flmap);
    revCodes(U.fltree, 9);
    pushV(U.fdtree, 32, 5);
    // for(i=0;i<32; i++) U.fdtree.push(0,5);
    makeCodes(U.fdtree, 5);
    codes2map(U.fdtree, 5, U.fdmap);
    revCodes(U.fdtree, 5);
    pushV(U.itree, 19, 0);
    pushV(U.ltree, 286, 0);
    pushV(U.dtree, 30, 0);
    pushV(U.ttree, 320, 0);
    /*
    for(var i=0; i< 19; i++) U.itree.push(0,0);
    for(var i=0; i<286; i++) U.ltree.push(0,0);
    for(var i=0; i< 30; i++) U.dtree.push(0,0);
    for(var i=0; i<320; i++) U.ttree.push(0,0);
    */
})();
function codes2map(tree, MAX_BITS, map) {
    var max_code = tree.length;
    var r15 = U.rev15;
    for (var i = 0; i < max_code; i += 2) {
        if (tree[i + 1] !== 0) {
            var lit = i >> 1;
            var cl = tree[i + 1], val = (lit << 4) | cl; // :  (0x8000 | (U.of0[lit-257]<<7) | (U.exb[lit-257]<<4) | cl);
            var rest = (MAX_BITS - cl);
            var i0 = tree[i] << rest;
            var i1 = i0 + (1 << rest);
            // tree[i]=r15[i0]>>>(15-MAX_BITS);
            while (i0 !== i1) {
                var p0 = r15[i0] >>> (15 - MAX_BITS);
                map[p0] = val;
                i0++;
            }
        }
    }
}
function makeCodes(tree, MAX_BITS) {
    var max_code = tree.length;
    var bl_count = U.bl_count;
    for (var i = 0; i <= MAX_BITS; i++)
        bl_count[i] = 0;
    for (var i = 1; i < max_code; i += 2)
        bl_count[tree[i]]++;
    var next_code = U.next_code; // smallest code for each length
    var code = 0;
    bl_count[0] = 0;
    for (var bits = 1; bits <= MAX_BITS; bits++) {
        code = (code + bl_count[bits - 1]) << 1;
        next_code[bits] = code;
    }
    for (var n = 0; n < max_code; n += 2) {
        var len = tree[n + 1];
        if (len !== 0) {
            tree[n] = next_code[len];
            next_code[len]++;
        }
    }
}
function revCodes(tree, MAX_BITS) {
    var r15 = U.rev15, imb = 15 - MAX_BITS;
    for (var i = 0; i < tree.length; i += 2) {
        var i0 = (tree[i] << (MAX_BITS - tree[i + 1]));
        tree[i] = r15[i0] >>> imb;
    }
}
//# sourceMappingURL=util.js.map

/***/ }),

/***/ "./lib/mol-util/zip/zip.js":
/*!*********************************!*\
  !*** ./lib/mol-util/zip/zip.js ***!
  \*********************************/
/*! exports provided: unzip, inflateRaw, inflate, ungzip, deflate, zip */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "unzip", function() { return unzip; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "inflateRaw", function() { return inflateRaw; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "inflate", function() { return inflate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ungzip", function() { return ungzip; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "deflate", function() { return deflate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "zip", function() { return zip; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _bin__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./bin */ "./lib/mol-util/zip/bin.js");
/* harmony import */ var _checksum__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./checksum */ "./lib/mol-util/zip/checksum.js");
/* harmony import */ var _inflate__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./inflate */ "./lib/mol-util/zip/inflate.js");
/* harmony import */ var _deflate__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./deflate */ "./lib/mol-util/zip/deflate.js");
/**
 * Copyright (c) 2020 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 *
 * ported from https://github.com/photopea/UZIP.js/blob/master/UZIP.js
 * MIT License, Copyright (c) 2018 Photopea
 *
 * - added `ungzip`
 */





function unzip(runtime, buf, onlyNames) {
    if (onlyNames === void 0) { onlyNames = false; }
    return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"])(this, void 0, void 0, function () {
        var out, data, eocd, o, cnu, coffs, i, csize, usize, nl, el, cl, roff;
        return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__generator"])(this, function (_a) {
            switch (_a.label) {
                case 0:
                    out = Object.create(null);
                    data = new Uint8Array(buf);
                    eocd = data.length - 4;
                    while (Object(_bin__WEBPACK_IMPORTED_MODULE_1__["readUint"])(data, eocd) !== 0x06054b50)
                        eocd--;
                    o = eocd;
                    o += 4; // sign  = 0x06054b50
                    o += 4; // disks = 0;
                    cnu = Object(_bin__WEBPACK_IMPORTED_MODULE_1__["readUshort"])(data, o);
                    o += 2;
                    // const cnt = readUshort(data, o);
                    o += 2;
                    // const csize = readUint(data, o);
                    o += 4;
                    coffs = Object(_bin__WEBPACK_IMPORTED_MODULE_1__["readUint"])(data, o);
                    o += 4;
                    o = coffs;
                    i = 0;
                    _a.label = 1;
                case 1:
                    if (!(i < cnu)) return [3 /*break*/, 4];
                    // const sign = readUint(data, o);
                    o += 4;
                    o += 4; // versions;
                    o += 4; // flag + compr
                    o += 4; // time
                    // const crc32 = readUint(data, o);
                    o += 4;
                    csize = Object(_bin__WEBPACK_IMPORTED_MODULE_1__["readUint"])(data, o);
                    o += 4;
                    usize = Object(_bin__WEBPACK_IMPORTED_MODULE_1__["readUint"])(data, o);
                    o += 4;
                    nl = Object(_bin__WEBPACK_IMPORTED_MODULE_1__["readUshort"])(data, o);
                    el = Object(_bin__WEBPACK_IMPORTED_MODULE_1__["readUshort"])(data, o + 2);
                    cl = Object(_bin__WEBPACK_IMPORTED_MODULE_1__["readUshort"])(data, o + 4);
                    o += 6; // name, extra, comment
                    o += 8; // disk, attribs
                    roff = Object(_bin__WEBPACK_IMPORTED_MODULE_1__["readUint"])(data, o);
                    o += 4;
                    o += nl + el + cl;
                    return [4 /*yield*/, _readLocal(runtime, data, roff, out, csize, usize, onlyNames)];
                case 2:
                    _a.sent();
                    _a.label = 3;
                case 3:
                    i++;
                    return [3 /*break*/, 1];
                case 4: 
                // console.log(out);
                return [2 /*return*/, out];
            }
        });
    });
}
function _readLocal(runtime, data, o, out, csize, usize, onlyNames) {
    return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"])(this, void 0, void 0, function () {
        var cmpr, nlen, elen, name, file, buf;
        return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__generator"])(this, function (_a) {
            switch (_a.label) {
                case 0:
                    // const sign  = readUint(data, o);
                    o += 4;
                    // const ver   = readUshort(data, o);
                    o += 2;
                    // const gpflg = readUshort(data, o);
                    o += 2;
                    cmpr = Object(_bin__WEBPACK_IMPORTED_MODULE_1__["readUshort"])(data, o);
                    o += 2;
                    // const time  = readUint(data, o);
                    o += 4;
                    // const crc32 = readUint(data, o);
                    o += 4;
                    // var csize = rUi(data, o);  o+=4;
                    // var usize = rUi(data, o);  o+=4;
                    o += 8;
                    nlen = Object(_bin__WEBPACK_IMPORTED_MODULE_1__["readUshort"])(data, o);
                    o += 2;
                    elen = Object(_bin__WEBPACK_IMPORTED_MODULE_1__["readUshort"])(data, o);
                    o += 2;
                    name = Object(_bin__WEBPACK_IMPORTED_MODULE_1__["readUTF8"])(data, o, nlen);
                    o += nlen; // console.log(name);
                    o += elen;
                    if (onlyNames) {
                        out[name] = { size: usize, csize: csize };
                        return [2 /*return*/];
                    }
                    file = new Uint8Array(data.buffer, o);
                    if (!(cmpr === 0)) return [3 /*break*/, 1];
                    out[name] = new Uint8Array(file.buffer.slice(o, o + csize));
                    return [3 /*break*/, 4];
                case 1:
                    if (!(cmpr === 8)) return [3 /*break*/, 3];
                    buf = new Uint8Array(usize);
                    return [4 /*yield*/, inflateRaw(runtime, file, buf)];
                case 2:
                    _a.sent();
                    out[name] = buf;
                    return [3 /*break*/, 4];
                case 3: throw "unknown compression method: " + cmpr;
                case 4: return [2 /*return*/];
            }
        });
    });
}
function inflateRaw(runtime, file, buf) {
    return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"])(this, void 0, void 0, function () {
        return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__generator"])(this, function (_a) {
            return [2 /*return*/, Object(_inflate__WEBPACK_IMPORTED_MODULE_3__["_inflate"])(runtime, file, buf)];
        });
    });
}
function inflate(runtime, file, buf) {
    // const CMF = file[0]
    // const FLG = file[1]
    // const CM = (CMF&15)
    // const CINFO = (CMF>>>4);
    // console.log(CM, CINFO,CMF,FLG);
    return inflateRaw(runtime, new Uint8Array(file.buffer, file.byteOffset + 2, file.length - 6), buf);
}
// https://tools.ietf.org/html/rfc1952
function ungzip(runtime, file, buf) {
    return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"])(this, void 0, void 0, function () {
        var flg, o, xlen, zero, zero, crc32, isize, blocks, inflated, crcValue;
        return Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__generator"])(this, function (_a) {
            switch (_a.label) {
                case 0:
                    flg = file[3];
                    o = 10;
                    if (flg & 4) { // FEXTRA
                        xlen = Object(_bin__WEBPACK_IMPORTED_MODULE_1__["readUshort"])(file, o);
                        // console.log('FEXTRA', xlen)
                        o += xlen;
                    }
                    if (flg & 8) { // FNAME
                        zero = o;
                        while (file[zero] !== 0)
                            ++zero;
                        // const name = readUTF8(file, o, zero - o)
                        // console.log('FNAME', name, zero - o)
                        o = zero + 1;
                    }
                    if (flg & 16) { // FCOMMENT
                        zero = o;
                        while (file[zero] !== 0)
                            ++zero;
                        // const comment = readUTF8(file, o, zero - o)
                        // console.log('FCOMMENT', comment)
                        o = zero + 1;
                    }
                    if (flg & 1) { // FHCRC
                        // const hcrc = readUshort(file, o)
                        // console.log('FHCRC', hcrc)
                        o += 2;
                    }
                    crc32 = Object(_bin__WEBPACK_IMPORTED_MODULE_1__["toInt32"])(Object(_bin__WEBPACK_IMPORTED_MODULE_1__["readUint"])(file, file.length - 8));
                    isize = Object(_bin__WEBPACK_IMPORTED_MODULE_1__["readUint"])(file, file.length - 4);
                    if (buf === undefined)
                        buf = new Uint8Array(isize);
                    blocks = new Uint8Array(file.buffer, file.byteOffset + o, file.length - o - 8);
                    return [4 /*yield*/, inflateRaw(runtime, blocks, buf)];
                case 1:
                    inflated = _a.sent();
                    crcValue = Object(_checksum__WEBPACK_IMPORTED_MODULE_2__["crc"])(inflated, 0, inflated.length);
                    if (crc32 !== crcValue) {
                        console.error("ungzip: checksums don't match");
                    }
                    return [2 /*return*/, inflated];
            }
        });
    });
}
function deflate(data, opts /* , buf, off*/) {
    if (opts === undefined)
        opts = { level: 6 };
    var off = 0;
    var buf = new Uint8Array(50 + Math.floor(data.length * 1.1));
    buf[off] = 120;
    buf[off + 1] = 156;
    off += 2;
    off = Object(_deflate__WEBPACK_IMPORTED_MODULE_4__["_deflateRaw"])(data, buf, off, opts.level);
    var crcValue = Object(_checksum__WEBPACK_IMPORTED_MODULE_2__["adler"])(data, 0, data.length);
    buf[off + 0] = ((crcValue >>> 24) & 255);
    buf[off + 1] = ((crcValue >>> 16) & 255);
    buf[off + 2] = ((crcValue >>> 8) & 255);
    buf[off + 3] = ((crcValue >>> 0) & 255);
    return new Uint8Array(buf.buffer, 0, off + 4);
}
function deflateRaw(data, opts) {
    if (opts === undefined)
        opts = { level: 6 };
    var buf = new Uint8Array(50 + Math.floor(data.length * 1.1));
    var off = Object(_deflate__WEBPACK_IMPORTED_MODULE_4__["_deflateRaw"])(data, buf, 0, opts.level);
    return new Uint8Array(buf.buffer, 0, off);
}
function zip(obj, noCmpr) {
    if (noCmpr === void 0) { noCmpr = false; }
    var tot = 0;
    var zpd = {};
    for (var p in obj) {
        var cpr = !_noNeed(p) && !noCmpr, buf = obj[p];
        var crcValue = Object(_checksum__WEBPACK_IMPORTED_MODULE_2__["crc"])(buf, 0, buf.length);
        zpd[p] = {
            cpr: cpr,
            usize: buf.length,
            crc: crcValue,
            file: (cpr ? deflateRaw(buf) : buf)
        };
    }
    for (var p in zpd)
        tot += zpd[p].file.length + 30 + 46 + 2 * Object(_bin__WEBPACK_IMPORTED_MODULE_1__["sizeUTF8"])(p);
    tot += 22;
    var data = new Uint8Array(tot);
    var o = 0;
    var fof = [];
    for (var p in zpd) {
        var file = zpd[p];
        fof.push(o);
        o = _writeHeader(data, o, p, file, 0);
    }
    var i = 0, ioff = o;
    for (var p in zpd) {
        var file = zpd[p];
        fof.push(o);
        o = _writeHeader(data, o, p, file, 1, fof[i++]);
    }
    var csize = o - ioff;
    Object(_bin__WEBPACK_IMPORTED_MODULE_1__["writeUint"])(data, o, 0x06054b50);
    o += 4;
    o += 4; // disks
    Object(_bin__WEBPACK_IMPORTED_MODULE_1__["writeUshort"])(data, o, i);
    o += 2;
    Object(_bin__WEBPACK_IMPORTED_MODULE_1__["writeUshort"])(data, o, i);
    o += 2; // number of c d records
    Object(_bin__WEBPACK_IMPORTED_MODULE_1__["writeUint"])(data, o, csize);
    o += 4;
    Object(_bin__WEBPACK_IMPORTED_MODULE_1__["writeUint"])(data, o, ioff);
    o += 4;
    o += 2;
    return data.buffer;
}
// no need to compress .PNG, .ZIP, .JPEG ....
function _noNeed(fn) {
    var ext = fn.split('.').pop().toLowerCase();
    return 'png,jpg,jpeg,zip'.indexOf(ext) !== -1;
}
function _writeHeader(data, o, p, obj, t, roff) {
    if (roff === void 0) { roff = 0; }
    var file = obj.file;
    Object(_bin__WEBPACK_IMPORTED_MODULE_1__["writeUint"])(data, o, t === 0 ? 0x04034b50 : 0x02014b50);
    o += 4; // sign
    if (t === 1)
        o += 2; // ver made by
    Object(_bin__WEBPACK_IMPORTED_MODULE_1__["writeUshort"])(data, o, 20);
    o += 2; // ver
    Object(_bin__WEBPACK_IMPORTED_MODULE_1__["writeUshort"])(data, o, 0);
    o += 2; // gflip
    Object(_bin__WEBPACK_IMPORTED_MODULE_1__["writeUshort"])(data, o, obj.cpr ? 8 : 0);
    o += 2; // cmpr
    Object(_bin__WEBPACK_IMPORTED_MODULE_1__["writeUint"])(data, o, 0);
    o += 4; // time
    Object(_bin__WEBPACK_IMPORTED_MODULE_1__["writeUint"])(data, o, obj.crc);
    o += 4; // crc32
    Object(_bin__WEBPACK_IMPORTED_MODULE_1__["writeUint"])(data, o, file.length);
    o += 4; // csize
    Object(_bin__WEBPACK_IMPORTED_MODULE_1__["writeUint"])(data, o, obj.usize);
    o += 4; // usize
    Object(_bin__WEBPACK_IMPORTED_MODULE_1__["writeUshort"])(data, o, Object(_bin__WEBPACK_IMPORTED_MODULE_1__["sizeUTF8"])(p));
    o += 2; // nlen
    Object(_bin__WEBPACK_IMPORTED_MODULE_1__["writeUshort"])(data, o, 0);
    o += 2; // elen
    if (t === 1) {
        o += 2; // comment length
        o += 2; // disk number
        o += 6; // attributes
        Object(_bin__WEBPACK_IMPORTED_MODULE_1__["writeUint"])(data, o, roff);
        o += 4; // usize
    }
    var nlen = Object(_bin__WEBPACK_IMPORTED_MODULE_1__["writeUTF8"])(data, o, p);
    o += nlen;
    if (t === 0) {
        data.set(file, o);
        o += file.length;
    }
    return o;
}
//# sourceMappingURL=zip.js.map

/***/ }),

/***/ "./node_modules/asn1.js/lib/asn1.js":
/*!******************************************!*\
  !*** ./node_modules/asn1.js/lib/asn1.js ***!
  \******************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


const asn1 = exports;

asn1.bignum = __webpack_require__(/*! bn.js */ "./node_modules/asn1.js/node_modules/bn.js/lib/bn.js");

asn1.define = __webpack_require__(/*! ./asn1/api */ "./node_modules/asn1.js/lib/asn1/api.js").define;
asn1.base = __webpack_require__(/*! ./asn1/base */ "./node_modules/asn1.js/lib/asn1/base/index.js");
asn1.constants = __webpack_require__(/*! ./asn1/constants */ "./node_modules/asn1.js/lib/asn1/constants/index.js");
asn1.decoders = __webpack_require__(/*! ./asn1/decoders */ "./node_modules/asn1.js/lib/asn1/decoders/index.js");
asn1.encoders = __webpack_require__(/*! ./asn1/encoders */ "./node_modules/asn1.js/lib/asn1/encoders/index.js");


/***/ }),

/***/ "./node_modules/asn1.js/lib/asn1/api.js":
/*!**********************************************!*\
  !*** ./node_modules/asn1.js/lib/asn1/api.js ***!
  \**********************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


const encoders = __webpack_require__(/*! ./encoders */ "./node_modules/asn1.js/lib/asn1/encoders/index.js");
const decoders = __webpack_require__(/*! ./decoders */ "./node_modules/asn1.js/lib/asn1/decoders/index.js");
const inherits = __webpack_require__(/*! inherits */ "./node_modules/inherits/inherits_browser.js");

const api = exports;

api.define = function define(name, body) {
  return new Entity(name, body);
};

function Entity(name, body) {
  this.name = name;
  this.body = body;

  this.decoders = {};
  this.encoders = {};
}

Entity.prototype._createNamed = function createNamed(Base) {
  const name = this.name;

  function Generated(entity) {
    this._initNamed(entity, name);
  }
  inherits(Generated, Base);
  Generated.prototype._initNamed = function _initNamed(entity, name) {
    Base.call(this, entity, name);
  };

  return new Generated(this);
};

Entity.prototype._getDecoder = function _getDecoder(enc) {
  enc = enc || 'der';
  // Lazily create decoder
  if (!this.decoders.hasOwnProperty(enc))
    this.decoders[enc] = this._createNamed(decoders[enc]);
  return this.decoders[enc];
};

Entity.prototype.decode = function decode(data, enc, options) {
  return this._getDecoder(enc).decode(data, options);
};

Entity.prototype._getEncoder = function _getEncoder(enc) {
  enc = enc || 'der';
  // Lazily create encoder
  if (!this.encoders.hasOwnProperty(enc))
    this.encoders[enc] = this._createNamed(encoders[enc]);
  return this.encoders[enc];
};

Entity.prototype.encode = function encode(data, enc, /* internal */ reporter) {
  return this._getEncoder(enc).encode(data, reporter);
};


/***/ }),

/***/ "./node_modules/asn1.js/lib/asn1/base/buffer.js":
/*!******************************************************!*\
  !*** ./node_modules/asn1.js/lib/asn1/base/buffer.js ***!
  \******************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


const inherits = __webpack_require__(/*! inherits */ "./node_modules/inherits/inherits_browser.js");
const Reporter = __webpack_require__(/*! ../base/reporter */ "./node_modules/asn1.js/lib/asn1/base/reporter.js").Reporter;
const Buffer = __webpack_require__(/*! safer-buffer */ "./node_modules/safer-buffer/safer.js").Buffer;

function DecoderBuffer(base, options) {
  Reporter.call(this, options);
  if (!Buffer.isBuffer(base)) {
    this.error('Input not Buffer');
    return;
  }

  this.base = base;
  this.offset = 0;
  this.length = base.length;
}
inherits(DecoderBuffer, Reporter);
exports.DecoderBuffer = DecoderBuffer;

DecoderBuffer.isDecoderBuffer = function isDecoderBuffer(data) {
  if (data instanceof DecoderBuffer) {
    return true;
  }

  // Or accept compatible API
  const isCompatible = typeof data === 'object' &&
    Buffer.isBuffer(data.base) &&
    data.constructor.name === 'DecoderBuffer' &&
    typeof data.offset === 'number' &&
    typeof data.length === 'number' &&
    typeof data.save === 'function' &&
    typeof data.restore === 'function' &&
    typeof data.isEmpty === 'function' &&
    typeof data.readUInt8 === 'function' &&
    typeof data.skip === 'function' &&
    typeof data.raw === 'function';

  return isCompatible;
};

DecoderBuffer.prototype.save = function save() {
  return { offset: this.offset, reporter: Reporter.prototype.save.call(this) };
};

DecoderBuffer.prototype.restore = function restore(save) {
  // Return skipped data
  const res = new DecoderBuffer(this.base);
  res.offset = save.offset;
  res.length = this.offset;

  this.offset = save.offset;
  Reporter.prototype.restore.call(this, save.reporter);

  return res;
};

DecoderBuffer.prototype.isEmpty = function isEmpty() {
  return this.offset === this.length;
};

DecoderBuffer.prototype.readUInt8 = function readUInt8(fail) {
  if (this.offset + 1 <= this.length)
    return this.base.readUInt8(this.offset++, true);
  else
    return this.error(fail || 'DecoderBuffer overrun');
};

DecoderBuffer.prototype.skip = function skip(bytes, fail) {
  if (!(this.offset + bytes <= this.length))
    return this.error(fail || 'DecoderBuffer overrun');

  const res = new DecoderBuffer(this.base);

  // Share reporter state
  res._reporterState = this._reporterState;

  res.offset = this.offset;
  res.length = this.offset + bytes;
  this.offset += bytes;
  return res;
};

DecoderBuffer.prototype.raw = function raw(save) {
  return this.base.slice(save ? save.offset : this.offset, this.length);
};

function EncoderBuffer(value, reporter) {
  if (Array.isArray(value)) {
    this.length = 0;
    this.value = value.map(function(item) {
      if (!EncoderBuffer.isEncoderBuffer(item))
        item = new EncoderBuffer(item, reporter);
      this.length += item.length;
      return item;
    }, this);
  } else if (typeof value === 'number') {
    if (!(0 <= value && value <= 0xff))
      return reporter.error('non-byte EncoderBuffer value');
    this.value = value;
    this.length = 1;
  } else if (typeof value === 'string') {
    this.value = value;
    this.length = Buffer.byteLength(value);
  } else if (Buffer.isBuffer(value)) {
    this.value = value;
    this.length = value.length;
  } else {
    return reporter.error('Unsupported type: ' + typeof value);
  }
}
exports.EncoderBuffer = EncoderBuffer;

EncoderBuffer.isEncoderBuffer = function isEncoderBuffer(data) {
  if (data instanceof EncoderBuffer) {
    return true;
  }

  // Or accept compatible API
  const isCompatible = typeof data === 'object' &&
    data.constructor.name === 'EncoderBuffer' &&
    typeof data.length === 'number' &&
    typeof data.join === 'function';

  return isCompatible;
};

EncoderBuffer.prototype.join = function join(out, offset) {
  if (!out)
    out = Buffer.alloc(this.length);
  if (!offset)
    offset = 0;

  if (this.length === 0)
    return out;

  if (Array.isArray(this.value)) {
    this.value.forEach(function(item) {
      item.join(out, offset);
      offset += item.length;
    });
  } else {
    if (typeof this.value === 'number')
      out[offset] = this.value;
    else if (typeof this.value === 'string')
      out.write(this.value, offset);
    else if (Buffer.isBuffer(this.value))
      this.value.copy(out, offset);
    offset += this.length;
  }

  return out;
};


/***/ }),

/***/ "./node_modules/asn1.js/lib/asn1/base/index.js":
/*!*****************************************************!*\
  !*** ./node_modules/asn1.js/lib/asn1/base/index.js ***!
  \*****************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


const base = exports;

base.Reporter = __webpack_require__(/*! ./reporter */ "./node_modules/asn1.js/lib/asn1/base/reporter.js").Reporter;
base.DecoderBuffer = __webpack_require__(/*! ./buffer */ "./node_modules/asn1.js/lib/asn1/base/buffer.js").DecoderBuffer;
base.EncoderBuffer = __webpack_require__(/*! ./buffer */ "./node_modules/asn1.js/lib/asn1/base/buffer.js").EncoderBuffer;
base.Node = __webpack_require__(/*! ./node */ "./node_modules/asn1.js/lib/asn1/base/node.js");


/***/ }),

/***/ "./node_modules/asn1.js/lib/asn1/base/node.js":
/*!****************************************************!*\
  !*** ./node_modules/asn1.js/lib/asn1/base/node.js ***!
  \****************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


const Reporter = __webpack_require__(/*! ../base/reporter */ "./node_modules/asn1.js/lib/asn1/base/reporter.js").Reporter;
const EncoderBuffer = __webpack_require__(/*! ../base/buffer */ "./node_modules/asn1.js/lib/asn1/base/buffer.js").EncoderBuffer;
const DecoderBuffer = __webpack_require__(/*! ../base/buffer */ "./node_modules/asn1.js/lib/asn1/base/buffer.js").DecoderBuffer;
const assert = __webpack_require__(/*! minimalistic-assert */ "./node_modules/minimalistic-assert/index.js");

// Supported tags
const tags = [
  'seq', 'seqof', 'set', 'setof', 'objid', 'bool',
  'gentime', 'utctime', 'null_', 'enum', 'int', 'objDesc',
  'bitstr', 'bmpstr', 'charstr', 'genstr', 'graphstr', 'ia5str', 'iso646str',
  'numstr', 'octstr', 'printstr', 't61str', 'unistr', 'utf8str', 'videostr'
];

// Public methods list
const methods = [
  'key', 'obj', 'use', 'optional', 'explicit', 'implicit', 'def', 'choice',
  'any', 'contains'
].concat(tags);

// Overrided methods list
const overrided = [
  '_peekTag', '_decodeTag', '_use',
  '_decodeStr', '_decodeObjid', '_decodeTime',
  '_decodeNull', '_decodeInt', '_decodeBool', '_decodeList',

  '_encodeComposite', '_encodeStr', '_encodeObjid', '_encodeTime',
  '_encodeNull', '_encodeInt', '_encodeBool'
];

function Node(enc, parent, name) {
  const state = {};
  this._baseState = state;

  state.name = name;
  state.enc = enc;

  state.parent = parent || null;
  state.children = null;

  // State
  state.tag = null;
  state.args = null;
  state.reverseArgs = null;
  state.choice = null;
  state.optional = false;
  state.any = false;
  state.obj = false;
  state.use = null;
  state.useDecoder = null;
  state.key = null;
  state['default'] = null;
  state.explicit = null;
  state.implicit = null;
  state.contains = null;

  // Should create new instance on each method
  if (!state.parent) {
    state.children = [];
    this._wrap();
  }
}
module.exports = Node;

const stateProps = [
  'enc', 'parent', 'children', 'tag', 'args', 'reverseArgs', 'choice',
  'optional', 'any', 'obj', 'use', 'alteredUse', 'key', 'default', 'explicit',
  'implicit', 'contains'
];

Node.prototype.clone = function clone() {
  const state = this._baseState;
  const cstate = {};
  stateProps.forEach(function(prop) {
    cstate[prop] = state[prop];
  });
  const res = new this.constructor(cstate.parent);
  res._baseState = cstate;
  return res;
};

Node.prototype._wrap = function wrap() {
  const state = this._baseState;
  methods.forEach(function(method) {
    this[method] = function _wrappedMethod() {
      const clone = new this.constructor(this);
      state.children.push(clone);
      return clone[method].apply(clone, arguments);
    };
  }, this);
};

Node.prototype._init = function init(body) {
  const state = this._baseState;

  assert(state.parent === null);
  body.call(this);

  // Filter children
  state.children = state.children.filter(function(child) {
    return child._baseState.parent === this;
  }, this);
  assert.equal(state.children.length, 1, 'Root node can have only one child');
};

Node.prototype._useArgs = function useArgs(args) {
  const state = this._baseState;

  // Filter children and args
  const children = args.filter(function(arg) {
    return arg instanceof this.constructor;
  }, this);
  args = args.filter(function(arg) {
    return !(arg instanceof this.constructor);
  }, this);

  if (children.length !== 0) {
    assert(state.children === null);
    state.children = children;

    // Replace parent to maintain backward link
    children.forEach(function(child) {
      child._baseState.parent = this;
    }, this);
  }
  if (args.length !== 0) {
    assert(state.args === null);
    state.args = args;
    state.reverseArgs = args.map(function(arg) {
      if (typeof arg !== 'object' || arg.constructor !== Object)
        return arg;

      const res = {};
      Object.keys(arg).forEach(function(key) {
        if (key == (key | 0))
          key |= 0;
        const value = arg[key];
        res[value] = key;
      });
      return res;
    });
  }
};

//
// Overrided methods
//

overrided.forEach(function(method) {
  Node.prototype[method] = function _overrided() {
    const state = this._baseState;
    throw new Error(method + ' not implemented for encoding: ' + state.enc);
  };
});

//
// Public methods
//

tags.forEach(function(tag) {
  Node.prototype[tag] = function _tagMethod() {
    const state = this._baseState;
    const args = Array.prototype.slice.call(arguments);

    assert(state.tag === null);
    state.tag = tag;

    this._useArgs(args);

    return this;
  };
});

Node.prototype.use = function use(item) {
  assert(item);
  const state = this._baseState;

  assert(state.use === null);
  state.use = item;

  return this;
};

Node.prototype.optional = function optional() {
  const state = this._baseState;

  state.optional = true;

  return this;
};

Node.prototype.def = function def(val) {
  const state = this._baseState;

  assert(state['default'] === null);
  state['default'] = val;
  state.optional = true;

  return this;
};

Node.prototype.explicit = function explicit(num) {
  const state = this._baseState;

  assert(state.explicit === null && state.implicit === null);
  state.explicit = num;

  return this;
};

Node.prototype.implicit = function implicit(num) {
  const state = this._baseState;

  assert(state.explicit === null && state.implicit === null);
  state.implicit = num;

  return this;
};

Node.prototype.obj = function obj() {
  const state = this._baseState;
  const args = Array.prototype.slice.call(arguments);

  state.obj = true;

  if (args.length !== 0)
    this._useArgs(args);

  return this;
};

Node.prototype.key = function key(newKey) {
  const state = this._baseState;

  assert(state.key === null);
  state.key = newKey;

  return this;
};

Node.prototype.any = function any() {
  const state = this._baseState;

  state.any = true;

  return this;
};

Node.prototype.choice = function choice(obj) {
  const state = this._baseState;

  assert(state.choice === null);
  state.choice = obj;
  this._useArgs(Object.keys(obj).map(function(key) {
    return obj[key];
  }));

  return this;
};

Node.prototype.contains = function contains(item) {
  const state = this._baseState;

  assert(state.use === null);
  state.contains = item;

  return this;
};

//
// Decoding
//

Node.prototype._decode = function decode(input, options) {
  const state = this._baseState;

  // Decode root node
  if (state.parent === null)
    return input.wrapResult(state.children[0]._decode(input, options));

  let result = state['default'];
  let present = true;

  let prevKey = null;
  if (state.key !== null)
    prevKey = input.enterKey(state.key);

  // Check if tag is there
  if (state.optional) {
    let tag = null;
    if (state.explicit !== null)
      tag = state.explicit;
    else if (state.implicit !== null)
      tag = state.implicit;
    else if (state.tag !== null)
      tag = state.tag;

    if (tag === null && !state.any) {
      // Trial and Error
      const save = input.save();
      try {
        if (state.choice === null)
          this._decodeGeneric(state.tag, input, options);
        else
          this._decodeChoice(input, options);
        present = true;
      } catch (e) {
        present = false;
      }
      input.restore(save);
    } else {
      present = this._peekTag(input, tag, state.any);

      if (input.isError(present))
        return present;
    }
  }

  // Push object on stack
  let prevObj;
  if (state.obj && present)
    prevObj = input.enterObject();

  if (present) {
    // Unwrap explicit values
    if (state.explicit !== null) {
      const explicit = this._decodeTag(input, state.explicit);
      if (input.isError(explicit))
        return explicit;
      input = explicit;
    }

    const start = input.offset;

    // Unwrap implicit and normal values
    if (state.use === null && state.choice === null) {
      let save;
      if (state.any)
        save = input.save();
      const body = this._decodeTag(
        input,
        state.implicit !== null ? state.implicit : state.tag,
        state.any
      );
      if (input.isError(body))
        return body;

      if (state.any)
        result = input.raw(save);
      else
        input = body;
    }

    if (options && options.track && state.tag !== null)
      options.track(input.path(), start, input.length, 'tagged');

    if (options && options.track && state.tag !== null)
      options.track(input.path(), input.offset, input.length, 'content');

    // Select proper method for tag
    if (state.any) {
      // no-op
    } else if (state.choice === null) {
      result = this._decodeGeneric(state.tag, input, options);
    } else {
      result = this._decodeChoice(input, options);
    }

    if (input.isError(result))
      return result;

    // Decode children
    if (!state.any && state.choice === null && state.children !== null) {
      state.children.forEach(function decodeChildren(child) {
        // NOTE: We are ignoring errors here, to let parser continue with other
        // parts of encoded data
        child._decode(input, options);
      });
    }

    // Decode contained/encoded by schema, only in bit or octet strings
    if (state.contains && (state.tag === 'octstr' || state.tag === 'bitstr')) {
      const data = new DecoderBuffer(result);
      result = this._getUse(state.contains, input._reporterState.obj)
        ._decode(data, options);
    }
  }

  // Pop object
  if (state.obj && present)
    result = input.leaveObject(prevObj);

  // Set key
  if (state.key !== null && (result !== null || present === true))
    input.leaveKey(prevKey, state.key, result);
  else if (prevKey !== null)
    input.exitKey(prevKey);

  return result;
};

Node.prototype._decodeGeneric = function decodeGeneric(tag, input, options) {
  const state = this._baseState;

  if (tag === 'seq' || tag === 'set')
    return null;
  if (tag === 'seqof' || tag === 'setof')
    return this._decodeList(input, tag, state.args[0], options);
  else if (/str$/.test(tag))
    return this._decodeStr(input, tag, options);
  else if (tag === 'objid' && state.args)
    return this._decodeObjid(input, state.args[0], state.args[1], options);
  else if (tag === 'objid')
    return this._decodeObjid(input, null, null, options);
  else if (tag === 'gentime' || tag === 'utctime')
    return this._decodeTime(input, tag, options);
  else if (tag === 'null_')
    return this._decodeNull(input, options);
  else if (tag === 'bool')
    return this._decodeBool(input, options);
  else if (tag === 'objDesc')
    return this._decodeStr(input, tag, options);
  else if (tag === 'int' || tag === 'enum')
    return this._decodeInt(input, state.args && state.args[0], options);

  if (state.use !== null) {
    return this._getUse(state.use, input._reporterState.obj)
      ._decode(input, options);
  } else {
    return input.error('unknown tag: ' + tag);
  }
};

Node.prototype._getUse = function _getUse(entity, obj) {

  const state = this._baseState;
  // Create altered use decoder if implicit is set
  state.useDecoder = this._use(entity, obj);
  assert(state.useDecoder._baseState.parent === null);
  state.useDecoder = state.useDecoder._baseState.children[0];
  if (state.implicit !== state.useDecoder._baseState.implicit) {
    state.useDecoder = state.useDecoder.clone();
    state.useDecoder._baseState.implicit = state.implicit;
  }
  return state.useDecoder;
};

Node.prototype._decodeChoice = function decodeChoice(input, options) {
  const state = this._baseState;
  let result = null;
  let match = false;

  Object.keys(state.choice).some(function(key) {
    const save = input.save();
    const node = state.choice[key];
    try {
      const value = node._decode(input, options);
      if (input.isError(value))
        return false;

      result = { type: key, value: value };
      match = true;
    } catch (e) {
      input.restore(save);
      return false;
    }
    return true;
  }, this);

  if (!match)
    return input.error('Choice not matched');

  return result;
};

//
// Encoding
//

Node.prototype._createEncoderBuffer = function createEncoderBuffer(data) {
  return new EncoderBuffer(data, this.reporter);
};

Node.prototype._encode = function encode(data, reporter, parent) {
  const state = this._baseState;
  if (state['default'] !== null && state['default'] === data)
    return;

  const result = this._encodeValue(data, reporter, parent);
  if (result === undefined)
    return;

  if (this._skipDefault(result, reporter, parent))
    return;

  return result;
};

Node.prototype._encodeValue = function encode(data, reporter, parent) {
  const state = this._baseState;

  // Decode root node
  if (state.parent === null)
    return state.children[0]._encode(data, reporter || new Reporter());

  let result = null;

  // Set reporter to share it with a child class
  this.reporter = reporter;

  // Check if data is there
  if (state.optional && data === undefined) {
    if (state['default'] !== null)
      data = state['default'];
    else
      return;
  }

  // Encode children first
  let content = null;
  let primitive = false;
  if (state.any) {
    // Anything that was given is translated to buffer
    result = this._createEncoderBuffer(data);
  } else if (state.choice) {
    result = this._encodeChoice(data, reporter);
  } else if (state.contains) {
    content = this._getUse(state.contains, parent)._encode(data, reporter);
    primitive = true;
  } else if (state.children) {
    content = state.children.map(function(child) {
      if (child._baseState.tag === 'null_')
        return child._encode(null, reporter, data);

      if (child._baseState.key === null)
        return reporter.error('Child should have a key');
      const prevKey = reporter.enterKey(child._baseState.key);

      if (typeof data !== 'object')
        return reporter.error('Child expected, but input is not object');

      const res = child._encode(data[child._baseState.key], reporter, data);
      reporter.leaveKey(prevKey);

      return res;
    }, this).filter(function(child) {
      return child;
    });
    content = this._createEncoderBuffer(content);
  } else {
    if (state.tag === 'seqof' || state.tag === 'setof') {
      // TODO(indutny): this should be thrown on DSL level
      if (!(state.args && state.args.length === 1))
        return reporter.error('Too many args for : ' + state.tag);

      if (!Array.isArray(data))
        return reporter.error('seqof/setof, but data is not Array');

      const child = this.clone();
      child._baseState.implicit = null;
      content = this._createEncoderBuffer(data.map(function(item) {
        const state = this._baseState;

        return this._getUse(state.args[0], data)._encode(item, reporter);
      }, child));
    } else if (state.use !== null) {
      result = this._getUse(state.use, parent)._encode(data, reporter);
    } else {
      content = this._encodePrimitive(state.tag, data);
      primitive = true;
    }
  }

  // Encode data itself
  if (!state.any && state.choice === null) {
    const tag = state.implicit !== null ? state.implicit : state.tag;
    const cls = state.implicit === null ? 'universal' : 'context';

    if (tag === null) {
      if (state.use === null)
        reporter.error('Tag could be omitted only for .use()');
    } else {
      if (state.use === null)
        result = this._encodeComposite(tag, primitive, cls, content);
    }
  }

  // Wrap in explicit
  if (state.explicit !== null)
    result = this._encodeComposite(state.explicit, false, 'context', result);

  return result;
};

Node.prototype._encodeChoice = function encodeChoice(data, reporter) {
  const state = this._baseState;

  const node = state.choice[data.type];
  if (!node) {
    assert(
      false,
      data.type + ' not found in ' +
            JSON.stringify(Object.keys(state.choice)));
  }
  return node._encode(data.value, reporter);
};

Node.prototype._encodePrimitive = function encodePrimitive(tag, data) {
  const state = this._baseState;

  if (/str$/.test(tag))
    return this._encodeStr(data, tag);
  else if (tag === 'objid' && state.args)
    return this._encodeObjid(data, state.reverseArgs[0], state.args[1]);
  else if (tag === 'objid')
    return this._encodeObjid(data, null, null);
  else if (tag === 'gentime' || tag === 'utctime')
    return this._encodeTime(data, tag);
  else if (tag === 'null_')
    return this._encodeNull();
  else if (tag === 'int' || tag === 'enum')
    return this._encodeInt(data, state.args && state.reverseArgs[0]);
  else if (tag === 'bool')
    return this._encodeBool(data);
  else if (tag === 'objDesc')
    return this._encodeStr(data, tag);
  else
    throw new Error('Unsupported tag: ' + tag);
};

Node.prototype._isNumstr = function isNumstr(str) {
  return /^[0-9 ]*$/.test(str);
};

Node.prototype._isPrintstr = function isPrintstr(str) {
  return /^[A-Za-z0-9 '()+,-./:=?]*$/.test(str);
};


/***/ }),

/***/ "./node_modules/asn1.js/lib/asn1/base/reporter.js":
/*!********************************************************!*\
  !*** ./node_modules/asn1.js/lib/asn1/base/reporter.js ***!
  \********************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


const inherits = __webpack_require__(/*! inherits */ "./node_modules/inherits/inherits_browser.js");

function Reporter(options) {
  this._reporterState = {
    obj: null,
    path: [],
    options: options || {},
    errors: []
  };
}
exports.Reporter = Reporter;

Reporter.prototype.isError = function isError(obj) {
  return obj instanceof ReporterError;
};

Reporter.prototype.save = function save() {
  const state = this._reporterState;

  return { obj: state.obj, pathLen: state.path.length };
};

Reporter.prototype.restore = function restore(data) {
  const state = this._reporterState;

  state.obj = data.obj;
  state.path = state.path.slice(0, data.pathLen);
};

Reporter.prototype.enterKey = function enterKey(key) {
  return this._reporterState.path.push(key);
};

Reporter.prototype.exitKey = function exitKey(index) {
  const state = this._reporterState;

  state.path = state.path.slice(0, index - 1);
};

Reporter.prototype.leaveKey = function leaveKey(index, key, value) {
  const state = this._reporterState;

  this.exitKey(index);
  if (state.obj !== null)
    state.obj[key] = value;
};

Reporter.prototype.path = function path() {
  return this._reporterState.path.join('/');
};

Reporter.prototype.enterObject = function enterObject() {
  const state = this._reporterState;

  const prev = state.obj;
  state.obj = {};
  return prev;
};

Reporter.prototype.leaveObject = function leaveObject(prev) {
  const state = this._reporterState;

  const now = state.obj;
  state.obj = prev;
  return now;
};

Reporter.prototype.error = function error(msg) {
  let err;
  const state = this._reporterState;

  const inherited = msg instanceof ReporterError;
  if (inherited) {
    err = msg;
  } else {
    err = new ReporterError(state.path.map(function(elem) {
      return '[' + JSON.stringify(elem) + ']';
    }).join(''), msg.message || msg, msg.stack);
  }

  if (!state.options.partial)
    throw err;

  if (!inherited)
    state.errors.push(err);

  return err;
};

Reporter.prototype.wrapResult = function wrapResult(result) {
  const state = this._reporterState;
  if (!state.options.partial)
    return result;

  return {
    result: this.isError(result) ? null : result,
    errors: state.errors
  };
};

function ReporterError(path, msg) {
  this.path = path;
  this.rethrow(msg);
}
inherits(ReporterError, Error);

ReporterError.prototype.rethrow = function rethrow(msg) {
  this.message = msg + ' at: ' + (this.path || '(shallow)');
  if (Error.captureStackTrace)
    Error.captureStackTrace(this, ReporterError);

  if (!this.stack) {
    try {
      // IE only adds stack when thrown
      throw new Error(this.message);
    } catch (e) {
      this.stack = e.stack;
    }
  }
  return this;
};


/***/ }),

/***/ "./node_modules/asn1.js/lib/asn1/constants/der.js":
/*!********************************************************!*\
  !*** ./node_modules/asn1.js/lib/asn1/constants/der.js ***!
  \********************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// Helper
function reverse(map) {
  const res = {};

  Object.keys(map).forEach(function(key) {
    // Convert key to integer if it is stringified
    if ((key | 0) == key)
      key = key | 0;

    const value = map[key];
    res[value] = key;
  });

  return res;
}

exports.tagClass = {
  0: 'universal',
  1: 'application',
  2: 'context',
  3: 'private'
};
exports.tagClassByName = reverse(exports.tagClass);

exports.tag = {
  0x00: 'end',
  0x01: 'bool',
  0x02: 'int',
  0x03: 'bitstr',
  0x04: 'octstr',
  0x05: 'null_',
  0x06: 'objid',
  0x07: 'objDesc',
  0x08: 'external',
  0x09: 'real',
  0x0a: 'enum',
  0x0b: 'embed',
  0x0c: 'utf8str',
  0x0d: 'relativeOid',
  0x10: 'seq',
  0x11: 'set',
  0x12: 'numstr',
  0x13: 'printstr',
  0x14: 't61str',
  0x15: 'videostr',
  0x16: 'ia5str',
  0x17: 'utctime',
  0x18: 'gentime',
  0x19: 'graphstr',
  0x1a: 'iso646str',
  0x1b: 'genstr',
  0x1c: 'unistr',
  0x1d: 'charstr',
  0x1e: 'bmpstr'
};
exports.tagByName = reverse(exports.tag);


/***/ }),

/***/ "./node_modules/asn1.js/lib/asn1/constants/index.js":
/*!**********************************************************!*\
  !*** ./node_modules/asn1.js/lib/asn1/constants/index.js ***!
  \**********************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


const constants = exports;

// Helper
constants._reverse = function reverse(map) {
  const res = {};

  Object.keys(map).forEach(function(key) {
    // Convert key to integer if it is stringified
    if ((key | 0) == key)
      key = key | 0;

    const value = map[key];
    res[value] = key;
  });

  return res;
};

constants.der = __webpack_require__(/*! ./der */ "./node_modules/asn1.js/lib/asn1/constants/der.js");


/***/ }),

/***/ "./node_modules/asn1.js/lib/asn1/decoders/der.js":
/*!*******************************************************!*\
  !*** ./node_modules/asn1.js/lib/asn1/decoders/der.js ***!
  \*******************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


const inherits = __webpack_require__(/*! inherits */ "./node_modules/inherits/inherits_browser.js");

const bignum = __webpack_require__(/*! bn.js */ "./node_modules/asn1.js/node_modules/bn.js/lib/bn.js");
const DecoderBuffer = __webpack_require__(/*! ../base/buffer */ "./node_modules/asn1.js/lib/asn1/base/buffer.js").DecoderBuffer;
const Node = __webpack_require__(/*! ../base/node */ "./node_modules/asn1.js/lib/asn1/base/node.js");

// Import DER constants
const der = __webpack_require__(/*! ../constants/der */ "./node_modules/asn1.js/lib/asn1/constants/der.js");

function DERDecoder(entity) {
  this.enc = 'der';
  this.name = entity.name;
  this.entity = entity;

  // Construct base tree
  this.tree = new DERNode();
  this.tree._init(entity.body);
}
module.exports = DERDecoder;

DERDecoder.prototype.decode = function decode(data, options) {
  if (!DecoderBuffer.isDecoderBuffer(data)) {
    data = new DecoderBuffer(data, options);
  }

  return this.tree._decode(data, options);
};

// Tree methods

function DERNode(parent) {
  Node.call(this, 'der', parent);
}
inherits(DERNode, Node);

DERNode.prototype._peekTag = function peekTag(buffer, tag, any) {
  if (buffer.isEmpty())
    return false;

  const state = buffer.save();
  const decodedTag = derDecodeTag(buffer, 'Failed to peek tag: "' + tag + '"');
  if (buffer.isError(decodedTag))
    return decodedTag;

  buffer.restore(state);

  return decodedTag.tag === tag || decodedTag.tagStr === tag ||
    (decodedTag.tagStr + 'of') === tag || any;
};

DERNode.prototype._decodeTag = function decodeTag(buffer, tag, any) {
  const decodedTag = derDecodeTag(buffer,
    'Failed to decode tag of "' + tag + '"');
  if (buffer.isError(decodedTag))
    return decodedTag;

  let len = derDecodeLen(buffer,
    decodedTag.primitive,
    'Failed to get length of "' + tag + '"');

  // Failure
  if (buffer.isError(len))
    return len;

  if (!any &&
      decodedTag.tag !== tag &&
      decodedTag.tagStr !== tag &&
      decodedTag.tagStr + 'of' !== tag) {
    return buffer.error('Failed to match tag: "' + tag + '"');
  }

  if (decodedTag.primitive || len !== null)
    return buffer.skip(len, 'Failed to match body of: "' + tag + '"');

  // Indefinite length... find END tag
  const state = buffer.save();
  const res = this._skipUntilEnd(
    buffer,
    'Failed to skip indefinite length body: "' + this.tag + '"');
  if (buffer.isError(res))
    return res;

  len = buffer.offset - state.offset;
  buffer.restore(state);
  return buffer.skip(len, 'Failed to match body of: "' + tag + '"');
};

DERNode.prototype._skipUntilEnd = function skipUntilEnd(buffer, fail) {
  for (;;) {
    const tag = derDecodeTag(buffer, fail);
    if (buffer.isError(tag))
      return tag;
    const len = derDecodeLen(buffer, tag.primitive, fail);
    if (buffer.isError(len))
      return len;

    let res;
    if (tag.primitive || len !== null)
      res = buffer.skip(len);
    else
      res = this._skipUntilEnd(buffer, fail);

    // Failure
    if (buffer.isError(res))
      return res;

    if (tag.tagStr === 'end')
      break;
  }
};

DERNode.prototype._decodeList = function decodeList(buffer, tag, decoder,
  options) {
  const result = [];
  while (!buffer.isEmpty()) {
    const possibleEnd = this._peekTag(buffer, 'end');
    if (buffer.isError(possibleEnd))
      return possibleEnd;

    const res = decoder.decode(buffer, 'der', options);
    if (buffer.isError(res) && possibleEnd)
      break;
    result.push(res);
  }
  return result;
};

DERNode.prototype._decodeStr = function decodeStr(buffer, tag) {
  if (tag === 'bitstr') {
    const unused = buffer.readUInt8();
    if (buffer.isError(unused))
      return unused;
    return { unused: unused, data: buffer.raw() };
  } else if (tag === 'bmpstr') {
    const raw = buffer.raw();
    if (raw.length % 2 === 1)
      return buffer.error('Decoding of string type: bmpstr length mismatch');

    let str = '';
    for (let i = 0; i < raw.length / 2; i++) {
      str += String.fromCharCode(raw.readUInt16BE(i * 2));
    }
    return str;
  } else if (tag === 'numstr') {
    const numstr = buffer.raw().toString('ascii');
    if (!this._isNumstr(numstr)) {
      return buffer.error('Decoding of string type: ' +
                          'numstr unsupported characters');
    }
    return numstr;
  } else if (tag === 'octstr') {
    return buffer.raw();
  } else if (tag === 'objDesc') {
    return buffer.raw();
  } else if (tag === 'printstr') {
    const printstr = buffer.raw().toString('ascii');
    if (!this._isPrintstr(printstr)) {
      return buffer.error('Decoding of string type: ' +
                          'printstr unsupported characters');
    }
    return printstr;
  } else if (/str$/.test(tag)) {
    return buffer.raw().toString();
  } else {
    return buffer.error('Decoding of string type: ' + tag + ' unsupported');
  }
};

DERNode.prototype._decodeObjid = function decodeObjid(buffer, values, relative) {
  let result;
  const identifiers = [];
  let ident = 0;
  let subident = 0;
  while (!buffer.isEmpty()) {
    subident = buffer.readUInt8();
    ident <<= 7;
    ident |= subident & 0x7f;
    if ((subident & 0x80) === 0) {
      identifiers.push(ident);
      ident = 0;
    }
  }
  if (subident & 0x80)
    identifiers.push(ident);

  const first = (identifiers[0] / 40) | 0;
  const second = identifiers[0] % 40;

  if (relative)
    result = identifiers;
  else
    result = [first, second].concat(identifiers.slice(1));

  if (values) {
    let tmp = values[result.join(' ')];
    if (tmp === undefined)
      tmp = values[result.join('.')];
    if (tmp !== undefined)
      result = tmp;
  }

  return result;
};

DERNode.prototype._decodeTime = function decodeTime(buffer, tag) {
  const str = buffer.raw().toString();

  let year;
  let mon;
  let day;
  let hour;
  let min;
  let sec;
  if (tag === 'gentime') {
    year = str.slice(0, 4) | 0;
    mon = str.slice(4, 6) | 0;
    day = str.slice(6, 8) | 0;
    hour = str.slice(8, 10) | 0;
    min = str.slice(10, 12) | 0;
    sec = str.slice(12, 14) | 0;
  } else if (tag === 'utctime') {
    year = str.slice(0, 2) | 0;
    mon = str.slice(2, 4) | 0;
    day = str.slice(4, 6) | 0;
    hour = str.slice(6, 8) | 0;
    min = str.slice(8, 10) | 0;
    sec = str.slice(10, 12) | 0;
    if (year < 70)
      year = 2000 + year;
    else
      year = 1900 + year;
  } else {
    return buffer.error('Decoding ' + tag + ' time is not supported yet');
  }

  return Date.UTC(year, mon - 1, day, hour, min, sec, 0);
};

DERNode.prototype._decodeNull = function decodeNull() {
  return null;
};

DERNode.prototype._decodeBool = function decodeBool(buffer) {
  const res = buffer.readUInt8();
  if (buffer.isError(res))
    return res;
  else
    return res !== 0;
};

DERNode.prototype._decodeInt = function decodeInt(buffer, values) {
  // Bigint, return as it is (assume big endian)
  const raw = buffer.raw();
  let res = new bignum(raw);

  if (values)
    res = values[res.toString(10)] || res;

  return res;
};

DERNode.prototype._use = function use(entity, obj) {
  if (typeof entity === 'function')
    entity = entity(obj);
  return entity._getDecoder('der').tree;
};

// Utility methods

function derDecodeTag(buf, fail) {
  let tag = buf.readUInt8(fail);
  if (buf.isError(tag))
    return tag;

  const cls = der.tagClass[tag >> 6];
  const primitive = (tag & 0x20) === 0;

  // Multi-octet tag - load
  if ((tag & 0x1f) === 0x1f) {
    let oct = tag;
    tag = 0;
    while ((oct & 0x80) === 0x80) {
      oct = buf.readUInt8(fail);
      if (buf.isError(oct))
        return oct;

      tag <<= 7;
      tag |= oct & 0x7f;
    }
  } else {
    tag &= 0x1f;
  }
  const tagStr = der.tag[tag];

  return {
    cls: cls,
    primitive: primitive,
    tag: tag,
    tagStr: tagStr
  };
}

function derDecodeLen(buf, primitive, fail) {
  let len = buf.readUInt8(fail);
  if (buf.isError(len))
    return len;

  // Indefinite form
  if (!primitive && len === 0x80)
    return null;

  // Definite form
  if ((len & 0x80) === 0) {
    // Short form
    return len;
  }

  // Long form
  const num = len & 0x7f;
  if (num > 4)
    return buf.error('length octect is too long');

  len = 0;
  for (let i = 0; i < num; i++) {
    len <<= 8;
    const j = buf.readUInt8(fail);
    if (buf.isError(j))
      return j;
    len |= j;
  }

  return len;
}


/***/ }),

/***/ "./node_modules/asn1.js/lib/asn1/decoders/index.js":
/*!*********************************************************!*\
  !*** ./node_modules/asn1.js/lib/asn1/decoders/index.js ***!
  \*********************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


const decoders = exports;

decoders.der = __webpack_require__(/*! ./der */ "./node_modules/asn1.js/lib/asn1/decoders/der.js");
decoders.pem = __webpack_require__(/*! ./pem */ "./node_modules/asn1.js/lib/asn1/decoders/pem.js");


/***/ }),

/***/ "./node_modules/asn1.js/lib/asn1/decoders/pem.js":
/*!*******************************************************!*\
  !*** ./node_modules/asn1.js/lib/asn1/decoders/pem.js ***!
  \*******************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


const inherits = __webpack_require__(/*! inherits */ "./node_modules/inherits/inherits_browser.js");
const Buffer = __webpack_require__(/*! safer-buffer */ "./node_modules/safer-buffer/safer.js").Buffer;

const DERDecoder = __webpack_require__(/*! ./der */ "./node_modules/asn1.js/lib/asn1/decoders/der.js");

function PEMDecoder(entity) {
  DERDecoder.call(this, entity);
  this.enc = 'pem';
}
inherits(PEMDecoder, DERDecoder);
module.exports = PEMDecoder;

PEMDecoder.prototype.decode = function decode(data, options) {
  const lines = data.toString().split(/[\r\n]+/g);

  const label = options.label.toUpperCase();

  const re = /^-----(BEGIN|END) ([^-]+)-----$/;
  let start = -1;
  let end = -1;
  for (let i = 0; i < lines.length; i++) {
    const match = lines[i].match(re);
    if (match === null)
      continue;

    if (match[2] !== label)
      continue;

    if (start === -1) {
      if (match[1] !== 'BEGIN')
        break;
      start = i;
    } else {
      if (match[1] !== 'END')
        break;
      end = i;
      break;
    }
  }
  if (start === -1 || end === -1)
    throw new Error('PEM section not found for: ' + label);

  const base64 = lines.slice(start + 1, end).join('');
  // Remove excessive symbols
  base64.replace(/[^a-z0-9+/=]+/gi, '');

  const input = Buffer.from(base64, 'base64');
  return DERDecoder.prototype.decode.call(this, input, options);
};


/***/ }),

/***/ "./node_modules/asn1.js/lib/asn1/encoders/der.js":
/*!*******************************************************!*\
  !*** ./node_modules/asn1.js/lib/asn1/encoders/der.js ***!
  \*******************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


const inherits = __webpack_require__(/*! inherits */ "./node_modules/inherits/inherits_browser.js");
const Buffer = __webpack_require__(/*! safer-buffer */ "./node_modules/safer-buffer/safer.js").Buffer;
const Node = __webpack_require__(/*! ../base/node */ "./node_modules/asn1.js/lib/asn1/base/node.js");

// Import DER constants
const der = __webpack_require__(/*! ../constants/der */ "./node_modules/asn1.js/lib/asn1/constants/der.js");

function DEREncoder(entity) {
  this.enc = 'der';
  this.name = entity.name;
  this.entity = entity;

  // Construct base tree
  this.tree = new DERNode();
  this.tree._init(entity.body);
}
module.exports = DEREncoder;

DEREncoder.prototype.encode = function encode(data, reporter) {
  return this.tree._encode(data, reporter).join();
};

// Tree methods

function DERNode(parent) {
  Node.call(this, 'der', parent);
}
inherits(DERNode, Node);

DERNode.prototype._encodeComposite = function encodeComposite(tag,
  primitive,
  cls,
  content) {
  const encodedTag = encodeTag(tag, primitive, cls, this.reporter);

  // Short form
  if (content.length < 0x80) {
    const header = Buffer.alloc(2);
    header[0] = encodedTag;
    header[1] = content.length;
    return this._createEncoderBuffer([ header, content ]);
  }

  // Long form
  // Count octets required to store length
  let lenOctets = 1;
  for (let i = content.length; i >= 0x100; i >>= 8)
    lenOctets++;

  const header = Buffer.alloc(1 + 1 + lenOctets);
  header[0] = encodedTag;
  header[1] = 0x80 | lenOctets;

  for (let i = 1 + lenOctets, j = content.length; j > 0; i--, j >>= 8)
    header[i] = j & 0xff;

  return this._createEncoderBuffer([ header, content ]);
};

DERNode.prototype._encodeStr = function encodeStr(str, tag) {
  if (tag === 'bitstr') {
    return this._createEncoderBuffer([ str.unused | 0, str.data ]);
  } else if (tag === 'bmpstr') {
    const buf = Buffer.alloc(str.length * 2);
    for (let i = 0; i < str.length; i++) {
      buf.writeUInt16BE(str.charCodeAt(i), i * 2);
    }
    return this._createEncoderBuffer(buf);
  } else if (tag === 'numstr') {
    if (!this._isNumstr(str)) {
      return this.reporter.error('Encoding of string type: numstr supports ' +
                                 'only digits and space');
    }
    return this._createEncoderBuffer(str);
  } else if (tag === 'printstr') {
    if (!this._isPrintstr(str)) {
      return this.reporter.error('Encoding of string type: printstr supports ' +
                                 'only latin upper and lower case letters, ' +
                                 'digits, space, apostrophe, left and rigth ' +
                                 'parenthesis, plus sign, comma, hyphen, ' +
                                 'dot, slash, colon, equal sign, ' +
                                 'question mark');
    }
    return this._createEncoderBuffer(str);
  } else if (/str$/.test(tag)) {
    return this._createEncoderBuffer(str);
  } else if (tag === 'objDesc') {
    return this._createEncoderBuffer(str);
  } else {
    return this.reporter.error('Encoding of string type: ' + tag +
                               ' unsupported');
  }
};

DERNode.prototype._encodeObjid = function encodeObjid(id, values, relative) {
  if (typeof id === 'string') {
    if (!values)
      return this.reporter.error('string objid given, but no values map found');
    if (!values.hasOwnProperty(id))
      return this.reporter.error('objid not found in values map');
    id = values[id].split(/[\s.]+/g);
    for (let i = 0; i < id.length; i++)
      id[i] |= 0;
  } else if (Array.isArray(id)) {
    id = id.slice();
    for (let i = 0; i < id.length; i++)
      id[i] |= 0;
  }

  if (!Array.isArray(id)) {
    return this.reporter.error('objid() should be either array or string, ' +
                               'got: ' + JSON.stringify(id));
  }

  if (!relative) {
    if (id[1] >= 40)
      return this.reporter.error('Second objid identifier OOB');
    id.splice(0, 2, id[0] * 40 + id[1]);
  }

  // Count number of octets
  let size = 0;
  for (let i = 0; i < id.length; i++) {
    let ident = id[i];
    for (size++; ident >= 0x80; ident >>= 7)
      size++;
  }

  const objid = Buffer.alloc(size);
  let offset = objid.length - 1;
  for (let i = id.length - 1; i >= 0; i--) {
    let ident = id[i];
    objid[offset--] = ident & 0x7f;
    while ((ident >>= 7) > 0)
      objid[offset--] = 0x80 | (ident & 0x7f);
  }

  return this._createEncoderBuffer(objid);
};

function two(num) {
  if (num < 10)
    return '0' + num;
  else
    return num;
}

DERNode.prototype._encodeTime = function encodeTime(time, tag) {
  let str;
  const date = new Date(time);

  if (tag === 'gentime') {
    str = [
      two(date.getUTCFullYear()),
      two(date.getUTCMonth() + 1),
      two(date.getUTCDate()),
      two(date.getUTCHours()),
      two(date.getUTCMinutes()),
      two(date.getUTCSeconds()),
      'Z'
    ].join('');
  } else if (tag === 'utctime') {
    str = [
      two(date.getUTCFullYear() % 100),
      two(date.getUTCMonth() + 1),
      two(date.getUTCDate()),
      two(date.getUTCHours()),
      two(date.getUTCMinutes()),
      two(date.getUTCSeconds()),
      'Z'
    ].join('');
  } else {
    this.reporter.error('Encoding ' + tag + ' time is not supported yet');
  }

  return this._encodeStr(str, 'octstr');
};

DERNode.prototype._encodeNull = function encodeNull() {
  return this._createEncoderBuffer('');
};

DERNode.prototype._encodeInt = function encodeInt(num, values) {
  if (typeof num === 'string') {
    if (!values)
      return this.reporter.error('String int or enum given, but no values map');
    if (!values.hasOwnProperty(num)) {
      return this.reporter.error('Values map doesn\'t contain: ' +
                                 JSON.stringify(num));
    }
    num = values[num];
  }

  // Bignum, assume big endian
  if (typeof num !== 'number' && !Buffer.isBuffer(num)) {
    const numArray = num.toArray();
    if (!num.sign && numArray[0] & 0x80) {
      numArray.unshift(0);
    }
    num = Buffer.from(numArray);
  }

  if (Buffer.isBuffer(num)) {
    let size = num.length;
    if (num.length === 0)
      size++;

    const out = Buffer.alloc(size);
    num.copy(out);
    if (num.length === 0)
      out[0] = 0;
    return this._createEncoderBuffer(out);
  }

  if (num < 0x80)
    return this._createEncoderBuffer(num);

  if (num < 0x100)
    return this._createEncoderBuffer([0, num]);

  let size = 1;
  for (let i = num; i >= 0x100; i >>= 8)
    size++;

  const out = new Array(size);
  for (let i = out.length - 1; i >= 0; i--) {
    out[i] = num & 0xff;
    num >>= 8;
  }
  if(out[0] & 0x80) {
    out.unshift(0);
  }

  return this._createEncoderBuffer(Buffer.from(out));
};

DERNode.prototype._encodeBool = function encodeBool(value) {
  return this._createEncoderBuffer(value ? 0xff : 0);
};

DERNode.prototype._use = function use(entity, obj) {
  if (typeof entity === 'function')
    entity = entity(obj);
  return entity._getEncoder('der').tree;
};

DERNode.prototype._skipDefault = function skipDefault(dataBuffer, reporter, parent) {
  const state = this._baseState;
  let i;
  if (state['default'] === null)
    return false;

  const data = dataBuffer.join();
  if (state.defaultBuffer === undefined)
    state.defaultBuffer = this._encodeValue(state['default'], reporter, parent).join();

  if (data.length !== state.defaultBuffer.length)
    return false;

  for (i=0; i < data.length; i++)
    if (data[i] !== state.defaultBuffer[i])
      return false;

  return true;
};

// Utility methods

function encodeTag(tag, primitive, cls, reporter) {
  let res;

  if (tag === 'seqof')
    tag = 'seq';
  else if (tag === 'setof')
    tag = 'set';

  if (der.tagByName.hasOwnProperty(tag))
    res = der.tagByName[tag];
  else if (typeof tag === 'number' && (tag | 0) === tag)
    res = tag;
  else
    return reporter.error('Unknown tag: ' + tag);

  if (res >= 0x1f)
    return reporter.error('Multi-octet tag encoding unsupported');

  if (!primitive)
    res |= 0x20;

  res |= (der.tagClassByName[cls || 'universal'] << 6);

  return res;
}


/***/ }),

/***/ "./node_modules/asn1.js/lib/asn1/encoders/index.js":
/*!*********************************************************!*\
  !*** ./node_modules/asn1.js/lib/asn1/encoders/index.js ***!
  \*********************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


const encoders = exports;

encoders.der = __webpack_require__(/*! ./der */ "./node_modules/asn1.js/lib/asn1/encoders/der.js");
encoders.pem = __webpack_require__(/*! ./pem */ "./node_modules/asn1.js/lib/asn1/encoders/pem.js");


/***/ }),

/***/ "./node_modules/asn1.js/lib/asn1/encoders/pem.js":
/*!*******************************************************!*\
  !*** ./node_modules/asn1.js/lib/asn1/encoders/pem.js ***!
  \*******************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


const inherits = __webpack_require__(/*! inherits */ "./node_modules/inherits/inherits_browser.js");

const DEREncoder = __webpack_require__(/*! ./der */ "./node_modules/asn1.js/lib/asn1/encoders/der.js");

function PEMEncoder(entity) {
  DEREncoder.call(this, entity);
  this.enc = 'pem';
}
inherits(PEMEncoder, DEREncoder);
module.exports = PEMEncoder;

PEMEncoder.prototype.encode = function encode(data, options) {
  const buf = DEREncoder.prototype.encode.call(this, data);

  const p = buf.toString('base64');
  const out = [ '-----BEGIN ' + options.label + '-----' ];
  for (let i = 0; i < p.length; i += 64)
    out.push(p.slice(i, i + 64));
  out.push('-----END ' + options.label + '-----');
  return out.join('\n');
};


/***/ }),

/***/ "./node_modules/asn1.js/node_modules/bn.js/lib/bn.js":
/*!***********************************************************!*\
  !*** ./node_modules/asn1.js/node_modules/bn.js/lib/bn.js ***!
  \***********************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {(function (module, exports) {
  'use strict';

  // Utils
  function assert (val, msg) {
    if (!val) throw new Error(msg || 'Assertion failed');
  }

  // Could use `inherits` module, but don't want to move from single file
  // architecture yet.
  function inherits (ctor, superCtor) {
    ctor.super_ = superCtor;
    var TempCtor = function () {};
    TempCtor.prototype = superCtor.prototype;
    ctor.prototype = new TempCtor();
    ctor.prototype.constructor = ctor;
  }

  // BN

  function BN (number, base, endian) {
    if (BN.isBN(number)) {
      return number;
    }

    this.negative = 0;
    this.words = null;
    this.length = 0;

    // Reduction context
    this.red = null;

    if (number !== null) {
      if (base === 'le' || base === 'be') {
        endian = base;
        base = 10;
      }

      this._init(number || 0, base || 10, endian || 'be');
    }
  }
  if (typeof module === 'object') {
    module.exports = BN;
  } else {
    exports.BN = BN;
  }

  BN.BN = BN;
  BN.wordSize = 26;

  var Buffer;
  try {
    Buffer = __webpack_require__(/*! buffer */ 11).Buffer;
  } catch (e) {
  }

  BN.isBN = function isBN (num) {
    if (num instanceof BN) {
      return true;
    }

    return num !== null && typeof num === 'object' &&
      num.constructor.wordSize === BN.wordSize && Array.isArray(num.words);
  };

  BN.max = function max (left, right) {
    if (left.cmp(right) > 0) return left;
    return right;
  };

  BN.min = function min (left, right) {
    if (left.cmp(right) < 0) return left;
    return right;
  };

  BN.prototype._init = function init (number, base, endian) {
    if (typeof number === 'number') {
      return this._initNumber(number, base, endian);
    }

    if (typeof number === 'object') {
      return this._initArray(number, base, endian);
    }

    if (base === 'hex') {
      base = 16;
    }
    assert(base === (base | 0) && base >= 2 && base <= 36);

    number = number.toString().replace(/\s+/g, '');
    var start = 0;
    if (number[0] === '-') {
      start++;
    }

    if (base === 16) {
      this._parseHex(number, start);
    } else {
      this._parseBase(number, base, start);
    }

    if (number[0] === '-') {
      this.negative = 1;
    }

    this.strip();

    if (endian !== 'le') return;

    this._initArray(this.toArray(), base, endian);
  };

  BN.prototype._initNumber = function _initNumber (number, base, endian) {
    if (number < 0) {
      this.negative = 1;
      number = -number;
    }
    if (number < 0x4000000) {
      this.words = [ number & 0x3ffffff ];
      this.length = 1;
    } else if (number < 0x10000000000000) {
      this.words = [
        number & 0x3ffffff,
        (number / 0x4000000) & 0x3ffffff
      ];
      this.length = 2;
    } else {
      assert(number < 0x20000000000000); // 2 ^ 53 (unsafe)
      this.words = [
        number & 0x3ffffff,
        (number / 0x4000000) & 0x3ffffff,
        1
      ];
      this.length = 3;
    }

    if (endian !== 'le') return;

    // Reverse the bytes
    this._initArray(this.toArray(), base, endian);
  };

  BN.prototype._initArray = function _initArray (number, base, endian) {
    // Perhaps a Uint8Array
    assert(typeof number.length === 'number');
    if (number.length <= 0) {
      this.words = [ 0 ];
      this.length = 1;
      return this;
    }

    this.length = Math.ceil(number.length / 3);
    this.words = new Array(this.length);
    for (var i = 0; i < this.length; i++) {
      this.words[i] = 0;
    }

    var j, w;
    var off = 0;
    if (endian === 'be') {
      for (i = number.length - 1, j = 0; i >= 0; i -= 3) {
        w = number[i] | (number[i - 1] << 8) | (number[i - 2] << 16);
        this.words[j] |= (w << off) & 0x3ffffff;
        this.words[j + 1] = (w >>> (26 - off)) & 0x3ffffff;
        off += 24;
        if (off >= 26) {
          off -= 26;
          j++;
        }
      }
    } else if (endian === 'le') {
      for (i = 0, j = 0; i < number.length; i += 3) {
        w = number[i] | (number[i + 1] << 8) | (number[i + 2] << 16);
        this.words[j] |= (w << off) & 0x3ffffff;
        this.words[j + 1] = (w >>> (26 - off)) & 0x3ffffff;
        off += 24;
        if (off >= 26) {
          off -= 26;
          j++;
        }
      }
    }
    return this.strip();
  };

  function parseHex (str, start, end) {
    var r = 0;
    var len = Math.min(str.length, end);
    for (var i = start; i < len; i++) {
      var c = str.charCodeAt(i) - 48;

      r <<= 4;

      // 'a' - 'f'
      if (c >= 49 && c <= 54) {
        r |= c - 49 + 0xa;

      // 'A' - 'F'
      } else if (c >= 17 && c <= 22) {
        r |= c - 17 + 0xa;

      // '0' - '9'
      } else {
        r |= c & 0xf;
      }
    }
    return r;
  }

  BN.prototype._parseHex = function _parseHex (number, start) {
    // Create possibly bigger array to ensure that it fits the number
    this.length = Math.ceil((number.length - start) / 6);
    this.words = new Array(this.length);
    for (var i = 0; i < this.length; i++) {
      this.words[i] = 0;
    }

    var j, w;
    // Scan 24-bit chunks and add them to the number
    var off = 0;
    for (i = number.length - 6, j = 0; i >= start; i -= 6) {
      w = parseHex(number, i, i + 6);
      this.words[j] |= (w << off) & 0x3ffffff;
      // NOTE: `0x3fffff` is intentional here, 26bits max shift + 24bit hex limb
      this.words[j + 1] |= w >>> (26 - off) & 0x3fffff;
      off += 24;
      if (off >= 26) {
        off -= 26;
        j++;
      }
    }
    if (i + 6 !== start) {
      w = parseHex(number, start, i + 6);
      this.words[j] |= (w << off) & 0x3ffffff;
      this.words[j + 1] |= w >>> (26 - off) & 0x3fffff;
    }
    this.strip();
  };

  function parseBase (str, start, end, mul) {
    var r = 0;
    var len = Math.min(str.length, end);
    for (var i = start; i < len; i++) {
      var c = str.charCodeAt(i) - 48;

      r *= mul;

      // 'a'
      if (c >= 49) {
        r += c - 49 + 0xa;

      // 'A'
      } else if (c >= 17) {
        r += c - 17 + 0xa;

      // '0' - '9'
      } else {
        r += c;
      }
    }
    return r;
  }

  BN.prototype._parseBase = function _parseBase (number, base, start) {
    // Initialize as zero
    this.words = [ 0 ];
    this.length = 1;

    // Find length of limb in base
    for (var limbLen = 0, limbPow = 1; limbPow <= 0x3ffffff; limbPow *= base) {
      limbLen++;
    }
    limbLen--;
    limbPow = (limbPow / base) | 0;

    var total = number.length - start;
    var mod = total % limbLen;
    var end = Math.min(total, total - mod) + start;

    var word = 0;
    for (var i = start; i < end; i += limbLen) {
      word = parseBase(number, i, i + limbLen, base);

      this.imuln(limbPow);
      if (this.words[0] + word < 0x4000000) {
        this.words[0] += word;
      } else {
        this._iaddn(word);
      }
    }

    if (mod !== 0) {
      var pow = 1;
      word = parseBase(number, i, number.length, base);

      for (i = 0; i < mod; i++) {
        pow *= base;
      }

      this.imuln(pow);
      if (this.words[0] + word < 0x4000000) {
        this.words[0] += word;
      } else {
        this._iaddn(word);
      }
    }
  };

  BN.prototype.copy = function copy (dest) {
    dest.words = new Array(this.length);
    for (var i = 0; i < this.length; i++) {
      dest.words[i] = this.words[i];
    }
    dest.length = this.length;
    dest.negative = this.negative;
    dest.red = this.red;
  };

  BN.prototype.clone = function clone () {
    var r = new BN(null);
    this.copy(r);
    return r;
  };

  BN.prototype._expand = function _expand (size) {
    while (this.length < size) {
      this.words[this.length++] = 0;
    }
    return this;
  };

  // Remove leading `0` from `this`
  BN.prototype.strip = function strip () {
    while (this.length > 1 && this.words[this.length - 1] === 0) {
      this.length--;
    }
    return this._normSign();
  };

  BN.prototype._normSign = function _normSign () {
    // -0 = 0
    if (this.length === 1 && this.words[0] === 0) {
      this.negative = 0;
    }
    return this;
  };

  BN.prototype.inspect = function inspect () {
    return (this.red ? '<BN-R: ' : '<BN: ') + this.toString(16) + '>';
  };

  /*

  var zeros = [];
  var groupSizes = [];
  var groupBases = [];

  var s = '';
  var i = -1;
  while (++i < BN.wordSize) {
    zeros[i] = s;
    s += '0';
  }
  groupSizes[0] = 0;
  groupSizes[1] = 0;
  groupBases[0] = 0;
  groupBases[1] = 0;
  var base = 2 - 1;
  while (++base < 36 + 1) {
    var groupSize = 0;
    var groupBase = 1;
    while (groupBase < (1 << BN.wordSize) / base) {
      groupBase *= base;
      groupSize += 1;
    }
    groupSizes[base] = groupSize;
    groupBases[base] = groupBase;
  }

  */

  var zeros = [
    '',
    '0',
    '00',
    '000',
    '0000',
    '00000',
    '000000',
    '0000000',
    '00000000',
    '000000000',
    '0000000000',
    '00000000000',
    '000000000000',
    '0000000000000',
    '00000000000000',
    '000000000000000',
    '0000000000000000',
    '00000000000000000',
    '000000000000000000',
    '0000000000000000000',
    '00000000000000000000',
    '000000000000000000000',
    '0000000000000000000000',
    '00000000000000000000000',
    '000000000000000000000000',
    '0000000000000000000000000'
  ];

  var groupSizes = [
    0, 0,
    25, 16, 12, 11, 10, 9, 8,
    8, 7, 7, 7, 7, 6, 6,
    6, 6, 6, 6, 6, 5, 5,
    5, 5, 5, 5, 5, 5, 5,
    5, 5, 5, 5, 5, 5, 5
  ];

  var groupBases = [
    0, 0,
    33554432, 43046721, 16777216, 48828125, 60466176, 40353607, 16777216,
    43046721, 10000000, 19487171, 35831808, 62748517, 7529536, 11390625,
    16777216, 24137569, 34012224, 47045881, 64000000, 4084101, 5153632,
    6436343, 7962624, 9765625, 11881376, 14348907, 17210368, 20511149,
    24300000, 28629151, 33554432, 39135393, 45435424, 52521875, 60466176
  ];

  BN.prototype.toString = function toString (base, padding) {
    base = base || 10;
    padding = padding | 0 || 1;

    var out;
    if (base === 16 || base === 'hex') {
      out = '';
      var off = 0;
      var carry = 0;
      for (var i = 0; i < this.length; i++) {
        var w = this.words[i];
        var word = (((w << off) | carry) & 0xffffff).toString(16);
        carry = (w >>> (24 - off)) & 0xffffff;
        if (carry !== 0 || i !== this.length - 1) {
          out = zeros[6 - word.length] + word + out;
        } else {
          out = word + out;
        }
        off += 2;
        if (off >= 26) {
          off -= 26;
          i--;
        }
      }
      if (carry !== 0) {
        out = carry.toString(16) + out;
      }
      while (out.length % padding !== 0) {
        out = '0' + out;
      }
      if (this.negative !== 0) {
        out = '-' + out;
      }
      return out;
    }

    if (base === (base | 0) && base >= 2 && base <= 36) {
      // var groupSize = Math.floor(BN.wordSize * Math.LN2 / Math.log(base));
      var groupSize = groupSizes[base];
      // var groupBase = Math.pow(base, groupSize);
      var groupBase = groupBases[base];
      out = '';
      var c = this.clone();
      c.negative = 0;
      while (!c.isZero()) {
        var r = c.modn(groupBase).toString(base);
        c = c.idivn(groupBase);

        if (!c.isZero()) {
          out = zeros[groupSize - r.length] + r + out;
        } else {
          out = r + out;
        }
      }
      if (this.isZero()) {
        out = '0' + out;
      }
      while (out.length % padding !== 0) {
        out = '0' + out;
      }
      if (this.negative !== 0) {
        out = '-' + out;
      }
      return out;
    }

    assert(false, 'Base should be between 2 and 36');
  };

  BN.prototype.toNumber = function toNumber () {
    var ret = this.words[0];
    if (this.length === 2) {
      ret += this.words[1] * 0x4000000;
    } else if (this.length === 3 && this.words[2] === 0x01) {
      // NOTE: at this stage it is known that the top bit is set
      ret += 0x10000000000000 + (this.words[1] * 0x4000000);
    } else if (this.length > 2) {
      assert(false, 'Number can only safely store up to 53 bits');
    }
    return (this.negative !== 0) ? -ret : ret;
  };

  BN.prototype.toJSON = function toJSON () {
    return this.toString(16);
  };

  BN.prototype.toBuffer = function toBuffer (endian, length) {
    assert(typeof Buffer !== 'undefined');
    return this.toArrayLike(Buffer, endian, length);
  };

  BN.prototype.toArray = function toArray (endian, length) {
    return this.toArrayLike(Array, endian, length);
  };

  BN.prototype.toArrayLike = function toArrayLike (ArrayType, endian, length) {
    var byteLength = this.byteLength();
    var reqLength = length || Math.max(1, byteLength);
    assert(byteLength <= reqLength, 'byte array longer than desired length');
    assert(reqLength > 0, 'Requested array length <= 0');

    this.strip();
    var littleEndian = endian === 'le';
    var res = new ArrayType(reqLength);

    var b, i;
    var q = this.clone();
    if (!littleEndian) {
      // Assume big-endian
      for (i = 0; i < reqLength - byteLength; i++) {
        res[i] = 0;
      }

      for (i = 0; !q.isZero(); i++) {
        b = q.andln(0xff);
        q.iushrn(8);

        res[reqLength - i - 1] = b;
      }
    } else {
      for (i = 0; !q.isZero(); i++) {
        b = q.andln(0xff);
        q.iushrn(8);

        res[i] = b;
      }

      for (; i < reqLength; i++) {
        res[i] = 0;
      }
    }

    return res;
  };

  if (Math.clz32) {
    BN.prototype._countBits = function _countBits (w) {
      return 32 - Math.clz32(w);
    };
  } else {
    BN.prototype._countBits = function _countBits (w) {
      var t = w;
      var r = 0;
      if (t >= 0x1000) {
        r += 13;
        t >>>= 13;
      }
      if (t >= 0x40) {
        r += 7;
        t >>>= 7;
      }
      if (t >= 0x8) {
        r += 4;
        t >>>= 4;
      }
      if (t >= 0x02) {
        r += 2;
        t >>>= 2;
      }
      return r + t;
    };
  }

  BN.prototype._zeroBits = function _zeroBits (w) {
    // Short-cut
    if (w === 0) return 26;

    var t = w;
    var r = 0;
    if ((t & 0x1fff) === 0) {
      r += 13;
      t >>>= 13;
    }
    if ((t & 0x7f) === 0) {
      r += 7;
      t >>>= 7;
    }
    if ((t & 0xf) === 0) {
      r += 4;
      t >>>= 4;
    }
    if ((t & 0x3) === 0) {
      r += 2;
      t >>>= 2;
    }
    if ((t & 0x1) === 0) {
      r++;
    }
    return r;
  };

  // Return number of used bits in a BN
  BN.prototype.bitLength = function bitLength () {
    var w = this.words[this.length - 1];
    var hi = this._countBits(w);
    return (this.length - 1) * 26 + hi;
  };

  function toBitArray (num) {
    var w = new Array(num.bitLength());

    for (var bit = 0; bit < w.length; bit++) {
      var off = (bit / 26) | 0;
      var wbit = bit % 26;

      w[bit] = (num.words[off] & (1 << wbit)) >>> wbit;
    }

    return w;
  }

  // Number of trailing zero bits
  BN.prototype.zeroBits = function zeroBits () {
    if (this.isZero()) return 0;

    var r = 0;
    for (var i = 0; i < this.length; i++) {
      var b = this._zeroBits(this.words[i]);
      r += b;
      if (b !== 26) break;
    }
    return r;
  };

  BN.prototype.byteLength = function byteLength () {
    return Math.ceil(this.bitLength() / 8);
  };

  BN.prototype.toTwos = function toTwos (width) {
    if (this.negative !== 0) {
      return this.abs().inotn(width).iaddn(1);
    }
    return this.clone();
  };

  BN.prototype.fromTwos = function fromTwos (width) {
    if (this.testn(width - 1)) {
      return this.notn(width).iaddn(1).ineg();
    }
    return this.clone();
  };

  BN.prototype.isNeg = function isNeg () {
    return this.negative !== 0;
  };

  // Return negative clone of `this`
  BN.prototype.neg = function neg () {
    return this.clone().ineg();
  };

  BN.prototype.ineg = function ineg () {
    if (!this.isZero()) {
      this.negative ^= 1;
    }

    return this;
  };

  // Or `num` with `this` in-place
  BN.prototype.iuor = function iuor (num) {
    while (this.length < num.length) {
      this.words[this.length++] = 0;
    }

    for (var i = 0; i < num.length; i++) {
      this.words[i] = this.words[i] | num.words[i];
    }

    return this.strip();
  };

  BN.prototype.ior = function ior (num) {
    assert((this.negative | num.negative) === 0);
    return this.iuor(num);
  };

  // Or `num` with `this`
  BN.prototype.or = function or (num) {
    if (this.length > num.length) return this.clone().ior(num);
    return num.clone().ior(this);
  };

  BN.prototype.uor = function uor (num) {
    if (this.length > num.length) return this.clone().iuor(num);
    return num.clone().iuor(this);
  };

  // And `num` with `this` in-place
  BN.prototype.iuand = function iuand (num) {
    // b = min-length(num, this)
    var b;
    if (this.length > num.length) {
      b = num;
    } else {
      b = this;
    }

    for (var i = 0; i < b.length; i++) {
      this.words[i] = this.words[i] & num.words[i];
    }

    this.length = b.length;

    return this.strip();
  };

  BN.prototype.iand = function iand (num) {
    assert((this.negative | num.negative) === 0);
    return this.iuand(num);
  };

  // And `num` with `this`
  BN.prototype.and = function and (num) {
    if (this.length > num.length) return this.clone().iand(num);
    return num.clone().iand(this);
  };

  BN.prototype.uand = function uand (num) {
    if (this.length > num.length) return this.clone().iuand(num);
    return num.clone().iuand(this);
  };

  // Xor `num` with `this` in-place
  BN.prototype.iuxor = function iuxor (num) {
    // a.length > b.length
    var a;
    var b;
    if (this.length > num.length) {
      a = this;
      b = num;
    } else {
      a = num;
      b = this;
    }

    for (var i = 0; i < b.length; i++) {
      this.words[i] = a.words[i] ^ b.words[i];
    }

    if (this !== a) {
      for (; i < a.length; i++) {
        this.words[i] = a.words[i];
      }
    }

    this.length = a.length;

    return this.strip();
  };

  BN.prototype.ixor = function ixor (num) {
    assert((this.negative | num.negative) === 0);
    return this.iuxor(num);
  };

  // Xor `num` with `this`
  BN.prototype.xor = function xor (num) {
    if (this.length > num.length) return this.clone().ixor(num);
    return num.clone().ixor(this);
  };

  BN.prototype.uxor = function uxor (num) {
    if (this.length > num.length) return this.clone().iuxor(num);
    return num.clone().iuxor(this);
  };

  // Not ``this`` with ``width`` bitwidth
  BN.prototype.inotn = function inotn (width) {
    assert(typeof width === 'number' && width >= 0);

    var bytesNeeded = Math.ceil(width / 26) | 0;
    var bitsLeft = width % 26;

    // Extend the buffer with leading zeroes
    this._expand(bytesNeeded);

    if (bitsLeft > 0) {
      bytesNeeded--;
    }

    // Handle complete words
    for (var i = 0; i < bytesNeeded; i++) {
      this.words[i] = ~this.words[i] & 0x3ffffff;
    }

    // Handle the residue
    if (bitsLeft > 0) {
      this.words[i] = ~this.words[i] & (0x3ffffff >> (26 - bitsLeft));
    }

    // And remove leading zeroes
    return this.strip();
  };

  BN.prototype.notn = function notn (width) {
    return this.clone().inotn(width);
  };

  // Set `bit` of `this`
  BN.prototype.setn = function setn (bit, val) {
    assert(typeof bit === 'number' && bit >= 0);

    var off = (bit / 26) | 0;
    var wbit = bit % 26;

    this._expand(off + 1);

    if (val) {
      this.words[off] = this.words[off] | (1 << wbit);
    } else {
      this.words[off] = this.words[off] & ~(1 << wbit);
    }

    return this.strip();
  };

  // Add `num` to `this` in-place
  BN.prototype.iadd = function iadd (num) {
    var r;

    // negative + positive
    if (this.negative !== 0 && num.negative === 0) {
      this.negative = 0;
      r = this.isub(num);
      this.negative ^= 1;
      return this._normSign();

    // positive + negative
    } else if (this.negative === 0 && num.negative !== 0) {
      num.negative = 0;
      r = this.isub(num);
      num.negative = 1;
      return r._normSign();
    }

    // a.length > b.length
    var a, b;
    if (this.length > num.length) {
      a = this;
      b = num;
    } else {
      a = num;
      b = this;
    }

    var carry = 0;
    for (var i = 0; i < b.length; i++) {
      r = (a.words[i] | 0) + (b.words[i] | 0) + carry;
      this.words[i] = r & 0x3ffffff;
      carry = r >>> 26;
    }
    for (; carry !== 0 && i < a.length; i++) {
      r = (a.words[i] | 0) + carry;
      this.words[i] = r & 0x3ffffff;
      carry = r >>> 26;
    }

    this.length = a.length;
    if (carry !== 0) {
      this.words[this.length] = carry;
      this.length++;
    // Copy the rest of the words
    } else if (a !== this) {
      for (; i < a.length; i++) {
        this.words[i] = a.words[i];
      }
    }

    return this;
  };

  // Add `num` to `this`
  BN.prototype.add = function add (num) {
    var res;
    if (num.negative !== 0 && this.negative === 0) {
      num.negative = 0;
      res = this.sub(num);
      num.negative ^= 1;
      return res;
    } else if (num.negative === 0 && this.negative !== 0) {
      this.negative = 0;
      res = num.sub(this);
      this.negative = 1;
      return res;
    }

    if (this.length > num.length) return this.clone().iadd(num);

    return num.clone().iadd(this);
  };

  // Subtract `num` from `this` in-place
  BN.prototype.isub = function isub (num) {
    // this - (-num) = this + num
    if (num.negative !== 0) {
      num.negative = 0;
      var r = this.iadd(num);
      num.negative = 1;
      return r._normSign();

    // -this - num = -(this + num)
    } else if (this.negative !== 0) {
      this.negative = 0;
      this.iadd(num);
      this.negative = 1;
      return this._normSign();
    }

    // At this point both numbers are positive
    var cmp = this.cmp(num);

    // Optimization - zeroify
    if (cmp === 0) {
      this.negative = 0;
      this.length = 1;
      this.words[0] = 0;
      return this;
    }

    // a > b
    var a, b;
    if (cmp > 0) {
      a = this;
      b = num;
    } else {
      a = num;
      b = this;
    }

    var carry = 0;
    for (var i = 0; i < b.length; i++) {
      r = (a.words[i] | 0) - (b.words[i] | 0) + carry;
      carry = r >> 26;
      this.words[i] = r & 0x3ffffff;
    }
    for (; carry !== 0 && i < a.length; i++) {
      r = (a.words[i] | 0) + carry;
      carry = r >> 26;
      this.words[i] = r & 0x3ffffff;
    }

    // Copy rest of the words
    if (carry === 0 && i < a.length && a !== this) {
      for (; i < a.length; i++) {
        this.words[i] = a.words[i];
      }
    }

    this.length = Math.max(this.length, i);

    if (a !== this) {
      this.negative = 1;
    }

    return this.strip();
  };

  // Subtract `num` from `this`
  BN.prototype.sub = function sub (num) {
    return this.clone().isub(num);
  };

  function smallMulTo (self, num, out) {
    out.negative = num.negative ^ self.negative;
    var len = (self.length + num.length) | 0;
    out.length = len;
    len = (len - 1) | 0;

    // Peel one iteration (compiler can't do it, because of code complexity)
    var a = self.words[0] | 0;
    var b = num.words[0] | 0;
    var r = a * b;

    var lo = r & 0x3ffffff;
    var carry = (r / 0x4000000) | 0;
    out.words[0] = lo;

    for (var k = 1; k < len; k++) {
      // Sum all words with the same `i + j = k` and accumulate `ncarry`,
      // note that ncarry could be >= 0x3ffffff
      var ncarry = carry >>> 26;
      var rword = carry & 0x3ffffff;
      var maxJ = Math.min(k, num.length - 1);
      for (var j = Math.max(0, k - self.length + 1); j <= maxJ; j++) {
        var i = (k - j) | 0;
        a = self.words[i] | 0;
        b = num.words[j] | 0;
        r = a * b + rword;
        ncarry += (r / 0x4000000) | 0;
        rword = r & 0x3ffffff;
      }
      out.words[k] = rword | 0;
      carry = ncarry | 0;
    }
    if (carry !== 0) {
      out.words[k] = carry | 0;
    } else {
      out.length--;
    }

    return out.strip();
  }

  // TODO(indutny): it may be reasonable to omit it for users who don't need
  // to work with 256-bit numbers, otherwise it gives 20% improvement for 256-bit
  // multiplication (like elliptic secp256k1).
  var comb10MulTo = function comb10MulTo (self, num, out) {
    var a = self.words;
    var b = num.words;
    var o = out.words;
    var c = 0;
    var lo;
    var mid;
    var hi;
    var a0 = a[0] | 0;
    var al0 = a0 & 0x1fff;
    var ah0 = a0 >>> 13;
    var a1 = a[1] | 0;
    var al1 = a1 & 0x1fff;
    var ah1 = a1 >>> 13;
    var a2 = a[2] | 0;
    var al2 = a2 & 0x1fff;
    var ah2 = a2 >>> 13;
    var a3 = a[3] | 0;
    var al3 = a3 & 0x1fff;
    var ah3 = a3 >>> 13;
    var a4 = a[4] | 0;
    var al4 = a4 & 0x1fff;
    var ah4 = a4 >>> 13;
    var a5 = a[5] | 0;
    var al5 = a5 & 0x1fff;
    var ah5 = a5 >>> 13;
    var a6 = a[6] | 0;
    var al6 = a6 & 0x1fff;
    var ah6 = a6 >>> 13;
    var a7 = a[7] | 0;
    var al7 = a7 & 0x1fff;
    var ah7 = a7 >>> 13;
    var a8 = a[8] | 0;
    var al8 = a8 & 0x1fff;
    var ah8 = a8 >>> 13;
    var a9 = a[9] | 0;
    var al9 = a9 & 0x1fff;
    var ah9 = a9 >>> 13;
    var b0 = b[0] | 0;
    var bl0 = b0 & 0x1fff;
    var bh0 = b0 >>> 13;
    var b1 = b[1] | 0;
    var bl1 = b1 & 0x1fff;
    var bh1 = b1 >>> 13;
    var b2 = b[2] | 0;
    var bl2 = b2 & 0x1fff;
    var bh2 = b2 >>> 13;
    var b3 = b[3] | 0;
    var bl3 = b3 & 0x1fff;
    var bh3 = b3 >>> 13;
    var b4 = b[4] | 0;
    var bl4 = b4 & 0x1fff;
    var bh4 = b4 >>> 13;
    var b5 = b[5] | 0;
    var bl5 = b5 & 0x1fff;
    var bh5 = b5 >>> 13;
    var b6 = b[6] | 0;
    var bl6 = b6 & 0x1fff;
    var bh6 = b6 >>> 13;
    var b7 = b[7] | 0;
    var bl7 = b7 & 0x1fff;
    var bh7 = b7 >>> 13;
    var b8 = b[8] | 0;
    var bl8 = b8 & 0x1fff;
    var bh8 = b8 >>> 13;
    var b9 = b[9] | 0;
    var bl9 = b9 & 0x1fff;
    var bh9 = b9 >>> 13;

    out.negative = self.negative ^ num.negative;
    out.length = 19;
    /* k = 0 */
    lo = Math.imul(al0, bl0);
    mid = Math.imul(al0, bh0);
    mid = (mid + Math.imul(ah0, bl0)) | 0;
    hi = Math.imul(ah0, bh0);
    var w0 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w0 >>> 26)) | 0;
    w0 &= 0x3ffffff;
    /* k = 1 */
    lo = Math.imul(al1, bl0);
    mid = Math.imul(al1, bh0);
    mid = (mid + Math.imul(ah1, bl0)) | 0;
    hi = Math.imul(ah1, bh0);
    lo = (lo + Math.imul(al0, bl1)) | 0;
    mid = (mid + Math.imul(al0, bh1)) | 0;
    mid = (mid + Math.imul(ah0, bl1)) | 0;
    hi = (hi + Math.imul(ah0, bh1)) | 0;
    var w1 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w1 >>> 26)) | 0;
    w1 &= 0x3ffffff;
    /* k = 2 */
    lo = Math.imul(al2, bl0);
    mid = Math.imul(al2, bh0);
    mid = (mid + Math.imul(ah2, bl0)) | 0;
    hi = Math.imul(ah2, bh0);
    lo = (lo + Math.imul(al1, bl1)) | 0;
    mid = (mid + Math.imul(al1, bh1)) | 0;
    mid = (mid + Math.imul(ah1, bl1)) | 0;
    hi = (hi + Math.imul(ah1, bh1)) | 0;
    lo = (lo + Math.imul(al0, bl2)) | 0;
    mid = (mid + Math.imul(al0, bh2)) | 0;
    mid = (mid + Math.imul(ah0, bl2)) | 0;
    hi = (hi + Math.imul(ah0, bh2)) | 0;
    var w2 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w2 >>> 26)) | 0;
    w2 &= 0x3ffffff;
    /* k = 3 */
    lo = Math.imul(al3, bl0);
    mid = Math.imul(al3, bh0);
    mid = (mid + Math.imul(ah3, bl0)) | 0;
    hi = Math.imul(ah3, bh0);
    lo = (lo + Math.imul(al2, bl1)) | 0;
    mid = (mid + Math.imul(al2, bh1)) | 0;
    mid = (mid + Math.imul(ah2, bl1)) | 0;
    hi = (hi + Math.imul(ah2, bh1)) | 0;
    lo = (lo + Math.imul(al1, bl2)) | 0;
    mid = (mid + Math.imul(al1, bh2)) | 0;
    mid = (mid + Math.imul(ah1, bl2)) | 0;
    hi = (hi + Math.imul(ah1, bh2)) | 0;
    lo = (lo + Math.imul(al0, bl3)) | 0;
    mid = (mid + Math.imul(al0, bh3)) | 0;
    mid = (mid + Math.imul(ah0, bl3)) | 0;
    hi = (hi + Math.imul(ah0, bh3)) | 0;
    var w3 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w3 >>> 26)) | 0;
    w3 &= 0x3ffffff;
    /* k = 4 */
    lo = Math.imul(al4, bl0);
    mid = Math.imul(al4, bh0);
    mid = (mid + Math.imul(ah4, bl0)) | 0;
    hi = Math.imul(ah4, bh0);
    lo = (lo + Math.imul(al3, bl1)) | 0;
    mid = (mid + Math.imul(al3, bh1)) | 0;
    mid = (mid + Math.imul(ah3, bl1)) | 0;
    hi = (hi + Math.imul(ah3, bh1)) | 0;
    lo = (lo + Math.imul(al2, bl2)) | 0;
    mid = (mid + Math.imul(al2, bh2)) | 0;
    mid = (mid + Math.imul(ah2, bl2)) | 0;
    hi = (hi + Math.imul(ah2, bh2)) | 0;
    lo = (lo + Math.imul(al1, bl3)) | 0;
    mid = (mid + Math.imul(al1, bh3)) | 0;
    mid = (mid + Math.imul(ah1, bl3)) | 0;
    hi = (hi + Math.imul(ah1, bh3)) | 0;
    lo = (lo + Math.imul(al0, bl4)) | 0;
    mid = (mid + Math.imul(al0, bh4)) | 0;
    mid = (mid + Math.imul(ah0, bl4)) | 0;
    hi = (hi + Math.imul(ah0, bh4)) | 0;
    var w4 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w4 >>> 26)) | 0;
    w4 &= 0x3ffffff;
    /* k = 5 */
    lo = Math.imul(al5, bl0);
    mid = Math.imul(al5, bh0);
    mid = (mid + Math.imul(ah5, bl0)) | 0;
    hi = Math.imul(ah5, bh0);
    lo = (lo + Math.imul(al4, bl1)) | 0;
    mid = (mid + Math.imul(al4, bh1)) | 0;
    mid = (mid + Math.imul(ah4, bl1)) | 0;
    hi = (hi + Math.imul(ah4, bh1)) | 0;
    lo = (lo + Math.imul(al3, bl2)) | 0;
    mid = (mid + Math.imul(al3, bh2)) | 0;
    mid = (mid + Math.imul(ah3, bl2)) | 0;
    hi = (hi + Math.imul(ah3, bh2)) | 0;
    lo = (lo + Math.imul(al2, bl3)) | 0;
    mid = (mid + Math.imul(al2, bh3)) | 0;
    mid = (mid + Math.imul(ah2, bl3)) | 0;
    hi = (hi + Math.imul(ah2, bh3)) | 0;
    lo = (lo + Math.imul(al1, bl4)) | 0;
    mid = (mid + Math.imul(al1, bh4)) | 0;
    mid = (mid + Math.imul(ah1, bl4)) | 0;
    hi = (hi + Math.imul(ah1, bh4)) | 0;
    lo = (lo + Math.imul(al0, bl5)) | 0;
    mid = (mid + Math.imul(al0, bh5)) | 0;
    mid = (mid + Math.imul(ah0, bl5)) | 0;
    hi = (hi + Math.imul(ah0, bh5)) | 0;
    var w5 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w5 >>> 26)) | 0;
    w5 &= 0x3ffffff;
    /* k = 6 */
    lo = Math.imul(al6, bl0);
    mid = Math.imul(al6, bh0);
    mid = (mid + Math.imul(ah6, bl0)) | 0;
    hi = Math.imul(ah6, bh0);
    lo = (lo + Math.imul(al5, bl1)) | 0;
    mid = (mid + Math.imul(al5, bh1)) | 0;
    mid = (mid + Math.imul(ah5, bl1)) | 0;
    hi = (hi + Math.imul(ah5, bh1)) | 0;
    lo = (lo + Math.imul(al4, bl2)) | 0;
    mid = (mid + Math.imul(al4, bh2)) | 0;
    mid = (mid + Math.imul(ah4, bl2)) | 0;
    hi = (hi + Math.imul(ah4, bh2)) | 0;
    lo = (lo + Math.imul(al3, bl3)) | 0;
    mid = (mid + Math.imul(al3, bh3)) | 0;
    mid = (mid + Math.imul(ah3, bl3)) | 0;
    hi = (hi + Math.imul(ah3, bh3)) | 0;
    lo = (lo + Math.imul(al2, bl4)) | 0;
    mid = (mid + Math.imul(al2, bh4)) | 0;
    mid = (mid + Math.imul(ah2, bl4)) | 0;
    hi = (hi + Math.imul(ah2, bh4)) | 0;
    lo = (lo + Math.imul(al1, bl5)) | 0;
    mid = (mid + Math.imul(al1, bh5)) | 0;
    mid = (mid + Math.imul(ah1, bl5)) | 0;
    hi = (hi + Math.imul(ah1, bh5)) | 0;
    lo = (lo + Math.imul(al0, bl6)) | 0;
    mid = (mid + Math.imul(al0, bh6)) | 0;
    mid = (mid + Math.imul(ah0, bl6)) | 0;
    hi = (hi + Math.imul(ah0, bh6)) | 0;
    var w6 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w6 >>> 26)) | 0;
    w6 &= 0x3ffffff;
    /* k = 7 */
    lo = Math.imul(al7, bl0);
    mid = Math.imul(al7, bh0);
    mid = (mid + Math.imul(ah7, bl0)) | 0;
    hi = Math.imul(ah7, bh0);
    lo = (lo + Math.imul(al6, bl1)) | 0;
    mid = (mid + Math.imul(al6, bh1)) | 0;
    mid = (mid + Math.imul(ah6, bl1)) | 0;
    hi = (hi + Math.imul(ah6, bh1)) | 0;
    lo = (lo + Math.imul(al5, bl2)) | 0;
    mid = (mid + Math.imul(al5, bh2)) | 0;
    mid = (mid + Math.imul(ah5, bl2)) | 0;
    hi = (hi + Math.imul(ah5, bh2)) | 0;
    lo = (lo + Math.imul(al4, bl3)) | 0;
    mid = (mid + Math.imul(al4, bh3)) | 0;
    mid = (mid + Math.imul(ah4, bl3)) | 0;
    hi = (hi + Math.imul(ah4, bh3)) | 0;
    lo = (lo + Math.imul(al3, bl4)) | 0;
    mid = (mid + Math.imul(al3, bh4)) | 0;
    mid = (mid + Math.imul(ah3, bl4)) | 0;
    hi = (hi + Math.imul(ah3, bh4)) | 0;
    lo = (lo + Math.imul(al2, bl5)) | 0;
    mid = (mid + Math.imul(al2, bh5)) | 0;
    mid = (mid + Math.imul(ah2, bl5)) | 0;
    hi = (hi + Math.imul(ah2, bh5)) | 0;
    lo = (lo + Math.imul(al1, bl6)) | 0;
    mid = (mid + Math.imul(al1, bh6)) | 0;
    mid = (mid + Math.imul(ah1, bl6)) | 0;
    hi = (hi + Math.imul(ah1, bh6)) | 0;
    lo = (lo + Math.imul(al0, bl7)) | 0;
    mid = (mid + Math.imul(al0, bh7)) | 0;
    mid = (mid + Math.imul(ah0, bl7)) | 0;
    hi = (hi + Math.imul(ah0, bh7)) | 0;
    var w7 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w7 >>> 26)) | 0;
    w7 &= 0x3ffffff;
    /* k = 8 */
    lo = Math.imul(al8, bl0);
    mid = Math.imul(al8, bh0);
    mid = (mid + Math.imul(ah8, bl0)) | 0;
    hi = Math.imul(ah8, bh0);
    lo = (lo + Math.imul(al7, bl1)) | 0;
    mid = (mid + Math.imul(al7, bh1)) | 0;
    mid = (mid + Math.imul(ah7, bl1)) | 0;
    hi = (hi + Math.imul(ah7, bh1)) | 0;
    lo = (lo + Math.imul(al6, bl2)) | 0;
    mid = (mid + Math.imul(al6, bh2)) | 0;
    mid = (mid + Math.imul(ah6, bl2)) | 0;
    hi = (hi + Math.imul(ah6, bh2)) | 0;
    lo = (lo + Math.imul(al5, bl3)) | 0;
    mid = (mid + Math.imul(al5, bh3)) | 0;
    mid = (mid + Math.imul(ah5, bl3)) | 0;
    hi = (hi + Math.imul(ah5, bh3)) | 0;
    lo = (lo + Math.imul(al4, bl4)) | 0;
    mid = (mid + Math.imul(al4, bh4)) | 0;
    mid = (mid + Math.imul(ah4, bl4)) | 0;
    hi = (hi + Math.imul(ah4, bh4)) | 0;
    lo = (lo + Math.imul(al3, bl5)) | 0;
    mid = (mid + Math.imul(al3, bh5)) | 0;
    mid = (mid + Math.imul(ah3, bl5)) | 0;
    hi = (hi + Math.imul(ah3, bh5)) | 0;
    lo = (lo + Math.imul(al2, bl6)) | 0;
    mid = (mid + Math.imul(al2, bh6)) | 0;
    mid = (mid + Math.imul(ah2, bl6)) | 0;
    hi = (hi + Math.imul(ah2, bh6)) | 0;
    lo = (lo + Math.imul(al1, bl7)) | 0;
    mid = (mid + Math.imul(al1, bh7)) | 0;
    mid = (mid + Math.imul(ah1, bl7)) | 0;
    hi = (hi + Math.imul(ah1, bh7)) | 0;
    lo = (lo + Math.imul(al0, bl8)) | 0;
    mid = (mid + Math.imul(al0, bh8)) | 0;
    mid = (mid + Math.imul(ah0, bl8)) | 0;
    hi = (hi + Math.imul(ah0, bh8)) | 0;
    var w8 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w8 >>> 26)) | 0;
    w8 &= 0x3ffffff;
    /* k = 9 */
    lo = Math.imul(al9, bl0);
    mid = Math.imul(al9, bh0);
    mid = (mid + Math.imul(ah9, bl0)) | 0;
    hi = Math.imul(ah9, bh0);
    lo = (lo + Math.imul(al8, bl1)) | 0;
    mid = (mid + Math.imul(al8, bh1)) | 0;
    mid = (mid + Math.imul(ah8, bl1)) | 0;
    hi = (hi + Math.imul(ah8, bh1)) | 0;
    lo = (lo + Math.imul(al7, bl2)) | 0;
    mid = (mid + Math.imul(al7, bh2)) | 0;
    mid = (mid + Math.imul(ah7, bl2)) | 0;
    hi = (hi + Math.imul(ah7, bh2)) | 0;
    lo = (lo + Math.imul(al6, bl3)) | 0;
    mid = (mid + Math.imul(al6, bh3)) | 0;
    mid = (mid + Math.imul(ah6, bl3)) | 0;
    hi = (hi + Math.imul(ah6, bh3)) | 0;
    lo = (lo + Math.imul(al5, bl4)) | 0;
    mid = (mid + Math.imul(al5, bh4)) | 0;
    mid = (mid + Math.imul(ah5, bl4)) | 0;
    hi = (hi + Math.imul(ah5, bh4)) | 0;
    lo = (lo + Math.imul(al4, bl5)) | 0;
    mid = (mid + Math.imul(al4, bh5)) | 0;
    mid = (mid + Math.imul(ah4, bl5)) | 0;
    hi = (hi + Math.imul(ah4, bh5)) | 0;
    lo = (lo + Math.imul(al3, bl6)) | 0;
    mid = (mid + Math.imul(al3, bh6)) | 0;
    mid = (mid + Math.imul(ah3, bl6)) | 0;
    hi = (hi + Math.imul(ah3, bh6)) | 0;
    lo = (lo + Math.imul(al2, bl7)) | 0;
    mid = (mid + Math.imul(al2, bh7)) | 0;
    mid = (mid + Math.imul(ah2, bl7)) | 0;
    hi = (hi + Math.imul(ah2, bh7)) | 0;
    lo = (lo + Math.imul(al1, bl8)) | 0;
    mid = (mid + Math.imul(al1, bh8)) | 0;
    mid = (mid + Math.imul(ah1, bl8)) | 0;
    hi = (hi + Math.imul(ah1, bh8)) | 0;
    lo = (lo + Math.imul(al0, bl9)) | 0;
    mid = (mid + Math.imul(al0, bh9)) | 0;
    mid = (mid + Math.imul(ah0, bl9)) | 0;
    hi = (hi + Math.imul(ah0, bh9)) | 0;
    var w9 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w9 >>> 26)) | 0;
    w9 &= 0x3ffffff;
    /* k = 10 */
    lo = Math.imul(al9, bl1);
    mid = Math.imul(al9, bh1);
    mid = (mid + Math.imul(ah9, bl1)) | 0;
    hi = Math.imul(ah9, bh1);
    lo = (lo + Math.imul(al8, bl2)) | 0;
    mid = (mid + Math.imul(al8, bh2)) | 0;
    mid = (mid + Math.imul(ah8, bl2)) | 0;
    hi = (hi + Math.imul(ah8, bh2)) | 0;
    lo = (lo + Math.imul(al7, bl3)) | 0;
    mid = (mid + Math.imul(al7, bh3)) | 0;
    mid = (mid + Math.imul(ah7, bl3)) | 0;
    hi = (hi + Math.imul(ah7, bh3)) | 0;
    lo = (lo + Math.imul(al6, bl4)) | 0;
    mid = (mid + Math.imul(al6, bh4)) | 0;
    mid = (mid + Math.imul(ah6, bl4)) | 0;
    hi = (hi + Math.imul(ah6, bh4)) | 0;
    lo = (lo + Math.imul(al5, bl5)) | 0;
    mid = (mid + Math.imul(al5, bh5)) | 0;
    mid = (mid + Math.imul(ah5, bl5)) | 0;
    hi = (hi + Math.imul(ah5, bh5)) | 0;
    lo = (lo + Math.imul(al4, bl6)) | 0;
    mid = (mid + Math.imul(al4, bh6)) | 0;
    mid = (mid + Math.imul(ah4, bl6)) | 0;
    hi = (hi + Math.imul(ah4, bh6)) | 0;
    lo = (lo + Math.imul(al3, bl7)) | 0;
    mid = (mid + Math.imul(al3, bh7)) | 0;
    mid = (mid + Math.imul(ah3, bl7)) | 0;
    hi = (hi + Math.imul(ah3, bh7)) | 0;
    lo = (lo + Math.imul(al2, bl8)) | 0;
    mid = (mid + Math.imul(al2, bh8)) | 0;
    mid = (mid + Math.imul(ah2, bl8)) | 0;
    hi = (hi + Math.imul(ah2, bh8)) | 0;
    lo = (lo + Math.imul(al1, bl9)) | 0;
    mid = (mid + Math.imul(al1, bh9)) | 0;
    mid = (mid + Math.imul(ah1, bl9)) | 0;
    hi = (hi + Math.imul(ah1, bh9)) | 0;
    var w10 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w10 >>> 26)) | 0;
    w10 &= 0x3ffffff;
    /* k = 11 */
    lo = Math.imul(al9, bl2);
    mid = Math.imul(al9, bh2);
    mid = (mid + Math.imul(ah9, bl2)) | 0;
    hi = Math.imul(ah9, bh2);
    lo = (lo + Math.imul(al8, bl3)) | 0;
    mid = (mid + Math.imul(al8, bh3)) | 0;
    mid = (mid + Math.imul(ah8, bl3)) | 0;
    hi = (hi + Math.imul(ah8, bh3)) | 0;
    lo = (lo + Math.imul(al7, bl4)) | 0;
    mid = (mid + Math.imul(al7, bh4)) | 0;
    mid = (mid + Math.imul(ah7, bl4)) | 0;
    hi = (hi + Math.imul(ah7, bh4)) | 0;
    lo = (lo + Math.imul(al6, bl5)) | 0;
    mid = (mid + Math.imul(al6, bh5)) | 0;
    mid = (mid + Math.imul(ah6, bl5)) | 0;
    hi = (hi + Math.imul(ah6, bh5)) | 0;
    lo = (lo + Math.imul(al5, bl6)) | 0;
    mid = (mid + Math.imul(al5, bh6)) | 0;
    mid = (mid + Math.imul(ah5, bl6)) | 0;
    hi = (hi + Math.imul(ah5, bh6)) | 0;
    lo = (lo + Math.imul(al4, bl7)) | 0;
    mid = (mid + Math.imul(al4, bh7)) | 0;
    mid = (mid + Math.imul(ah4, bl7)) | 0;
    hi = (hi + Math.imul(ah4, bh7)) | 0;
    lo = (lo + Math.imul(al3, bl8)) | 0;
    mid = (mid + Math.imul(al3, bh8)) | 0;
    mid = (mid + Math.imul(ah3, bl8)) | 0;
    hi = (hi + Math.imul(ah3, bh8)) | 0;
    lo = (lo + Math.imul(al2, bl9)) | 0;
    mid = (mid + Math.imul(al2, bh9)) | 0;
    mid = (mid + Math.imul(ah2, bl9)) | 0;
    hi = (hi + Math.imul(ah2, bh9)) | 0;
    var w11 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w11 >>> 26)) | 0;
    w11 &= 0x3ffffff;
    /* k = 12 */
    lo = Math.imul(al9, bl3);
    mid = Math.imul(al9, bh3);
    mid = (mid + Math.imul(ah9, bl3)) | 0;
    hi = Math.imul(ah9, bh3);
    lo = (lo + Math.imul(al8, bl4)) | 0;
    mid = (mid + Math.imul(al8, bh4)) | 0;
    mid = (mid + Math.imul(ah8, bl4)) | 0;
    hi = (hi + Math.imul(ah8, bh4)) | 0;
    lo = (lo + Math.imul(al7, bl5)) | 0;
    mid = (mid + Math.imul(al7, bh5)) | 0;
    mid = (mid + Math.imul(ah7, bl5)) | 0;
    hi = (hi + Math.imul(ah7, bh5)) | 0;
    lo = (lo + Math.imul(al6, bl6)) | 0;
    mid = (mid + Math.imul(al6, bh6)) | 0;
    mid = (mid + Math.imul(ah6, bl6)) | 0;
    hi = (hi + Math.imul(ah6, bh6)) | 0;
    lo = (lo + Math.imul(al5, bl7)) | 0;
    mid = (mid + Math.imul(al5, bh7)) | 0;
    mid = (mid + Math.imul(ah5, bl7)) | 0;
    hi = (hi + Math.imul(ah5, bh7)) | 0;
    lo = (lo + Math.imul(al4, bl8)) | 0;
    mid = (mid + Math.imul(al4, bh8)) | 0;
    mid = (mid + Math.imul(ah4, bl8)) | 0;
    hi = (hi + Math.imul(ah4, bh8)) | 0;
    lo = (lo + Math.imul(al3, bl9)) | 0;
    mid = (mid + Math.imul(al3, bh9)) | 0;
    mid = (mid + Math.imul(ah3, bl9)) | 0;
    hi = (hi + Math.imul(ah3, bh9)) | 0;
    var w12 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w12 >>> 26)) | 0;
    w12 &= 0x3ffffff;
    /* k = 13 */
    lo = Math.imul(al9, bl4);
    mid = Math.imul(al9, bh4);
    mid = (mid + Math.imul(ah9, bl4)) | 0;
    hi = Math.imul(ah9, bh4);
    lo = (lo + Math.imul(al8, bl5)) | 0;
    mid = (mid + Math.imul(al8, bh5)) | 0;
    mid = (mid + Math.imul(ah8, bl5)) | 0;
    hi = (hi + Math.imul(ah8, bh5)) | 0;
    lo = (lo + Math.imul(al7, bl6)) | 0;
    mid = (mid + Math.imul(al7, bh6)) | 0;
    mid = (mid + Math.imul(ah7, bl6)) | 0;
    hi = (hi + Math.imul(ah7, bh6)) | 0;
    lo = (lo + Math.imul(al6, bl7)) | 0;
    mid = (mid + Math.imul(al6, bh7)) | 0;
    mid = (mid + Math.imul(ah6, bl7)) | 0;
    hi = (hi + Math.imul(ah6, bh7)) | 0;
    lo = (lo + Math.imul(al5, bl8)) | 0;
    mid = (mid + Math.imul(al5, bh8)) | 0;
    mid = (mid + Math.imul(ah5, bl8)) | 0;
    hi = (hi + Math.imul(ah5, bh8)) | 0;
    lo = (lo + Math.imul(al4, bl9)) | 0;
    mid = (mid + Math.imul(al4, bh9)) | 0;
    mid = (mid + Math.imul(ah4, bl9)) | 0;
    hi = (hi + Math.imul(ah4, bh9)) | 0;
    var w13 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w13 >>> 26)) | 0;
    w13 &= 0x3ffffff;
    /* k = 14 */
    lo = Math.imul(al9, bl5);
    mid = Math.imul(al9, bh5);
    mid = (mid + Math.imul(ah9, bl5)) | 0;
    hi = Math.imul(ah9, bh5);
    lo = (lo + Math.imul(al8, bl6)) | 0;
    mid = (mid + Math.imul(al8, bh6)) | 0;
    mid = (mid + Math.imul(ah8, bl6)) | 0;
    hi = (hi + Math.imul(ah8, bh6)) | 0;
    lo = (lo + Math.imul(al7, bl7)) | 0;
    mid = (mid + Math.imul(al7, bh7)) | 0;
    mid = (mid + Math.imul(ah7, bl7)) | 0;
    hi = (hi + Math.imul(ah7, bh7)) | 0;
    lo = (lo + Math.imul(al6, bl8)) | 0;
    mid = (mid + Math.imul(al6, bh8)) | 0;
    mid = (mid + Math.imul(ah6, bl8)) | 0;
    hi = (hi + Math.imul(ah6, bh8)) | 0;
    lo = (lo + Math.imul(al5, bl9)) | 0;
    mid = (mid + Math.imul(al5, bh9)) | 0;
    mid = (mid + Math.imul(ah5, bl9)) | 0;
    hi = (hi + Math.imul(ah5, bh9)) | 0;
    var w14 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w14 >>> 26)) | 0;
    w14 &= 0x3ffffff;
    /* k = 15 */
    lo = Math.imul(al9, bl6);
    mid = Math.imul(al9, bh6);
    mid = (mid + Math.imul(ah9, bl6)) | 0;
    hi = Math.imul(ah9, bh6);
    lo = (lo + Math.imul(al8, bl7)) | 0;
    mid = (mid + Math.imul(al8, bh7)) | 0;
    mid = (mid + Math.imul(ah8, bl7)) | 0;
    hi = (hi + Math.imul(ah8, bh7)) | 0;
    lo = (lo + Math.imul(al7, bl8)) | 0;
    mid = (mid + Math.imul(al7, bh8)) | 0;
    mid = (mid + Math.imul(ah7, bl8)) | 0;
    hi = (hi + Math.imul(ah7, bh8)) | 0;
    lo = (lo + Math.imul(al6, bl9)) | 0;
    mid = (mid + Math.imul(al6, bh9)) | 0;
    mid = (mid + Math.imul(ah6, bl9)) | 0;
    hi = (hi + Math.imul(ah6, bh9)) | 0;
    var w15 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w15 >>> 26)) | 0;
    w15 &= 0x3ffffff;
    /* k = 16 */
    lo = Math.imul(al9, bl7);
    mid = Math.imul(al9, bh7);
    mid = (mid + Math.imul(ah9, bl7)) | 0;
    hi = Math.imul(ah9, bh7);
    lo = (lo + Math.imul(al8, bl8)) | 0;
    mid = (mid + Math.imul(al8, bh8)) | 0;
    mid = (mid + Math.imul(ah8, bl8)) | 0;
    hi = (hi + Math.imul(ah8, bh8)) | 0;
    lo = (lo + Math.imul(al7, bl9)) | 0;
    mid = (mid + Math.imul(al7, bh9)) | 0;
    mid = (mid + Math.imul(ah7, bl9)) | 0;
    hi = (hi + Math.imul(ah7, bh9)) | 0;
    var w16 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w16 >>> 26)) | 0;
    w16 &= 0x3ffffff;
    /* k = 17 */
    lo = Math.imul(al9, bl8);
    mid = Math.imul(al9, bh8);
    mid = (mid + Math.imul(ah9, bl8)) | 0;
    hi = Math.imul(ah9, bh8);
    lo = (lo + Math.imul(al8, bl9)) | 0;
    mid = (mid + Math.imul(al8, bh9)) | 0;
    mid = (mid + Math.imul(ah8, bl9)) | 0;
    hi = (hi + Math.imul(ah8, bh9)) | 0;
    var w17 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w17 >>> 26)) | 0;
    w17 &= 0x3ffffff;
    /* k = 18 */
    lo = Math.imul(al9, bl9);
    mid = Math.imul(al9, bh9);
    mid = (mid + Math.imul(ah9, bl9)) | 0;
    hi = Math.imul(ah9, bh9);
    var w18 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w18 >>> 26)) | 0;
    w18 &= 0x3ffffff;
    o[0] = w0;
    o[1] = w1;
    o[2] = w2;
    o[3] = w3;
    o[4] = w4;
    o[5] = w5;
    o[6] = w6;
    o[7] = w7;
    o[8] = w8;
    o[9] = w9;
    o[10] = w10;
    o[11] = w11;
    o[12] = w12;
    o[13] = w13;
    o[14] = w14;
    o[15] = w15;
    o[16] = w16;
    o[17] = w17;
    o[18] = w18;
    if (c !== 0) {
      o[19] = c;
      out.length++;
    }
    return out;
  };

  // Polyfill comb
  if (!Math.imul) {
    comb10MulTo = smallMulTo;
  }

  function bigMulTo (self, num, out) {
    out.negative = num.negative ^ self.negative;
    out.length = self.length + num.length;

    var carry = 0;
    var hncarry = 0;
    for (var k = 0; k < out.length - 1; k++) {
      // Sum all words with the same `i + j = k` and accumulate `ncarry`,
      // note that ncarry could be >= 0x3ffffff
      var ncarry = hncarry;
      hncarry = 0;
      var rword = carry & 0x3ffffff;
      var maxJ = Math.min(k, num.length - 1);
      for (var j = Math.max(0, k - self.length + 1); j <= maxJ; j++) {
        var i = k - j;
        var a = self.words[i] | 0;
        var b = num.words[j] | 0;
        var r = a * b;

        var lo = r & 0x3ffffff;
        ncarry = (ncarry + ((r / 0x4000000) | 0)) | 0;
        lo = (lo + rword) | 0;
        rword = lo & 0x3ffffff;
        ncarry = (ncarry + (lo >>> 26)) | 0;

        hncarry += ncarry >>> 26;
        ncarry &= 0x3ffffff;
      }
      out.words[k] = rword;
      carry = ncarry;
      ncarry = hncarry;
    }
    if (carry !== 0) {
      out.words[k] = carry;
    } else {
      out.length--;
    }

    return out.strip();
  }

  function jumboMulTo (self, num, out) {
    var fftm = new FFTM();
    return fftm.mulp(self, num, out);
  }

  BN.prototype.mulTo = function mulTo (num, out) {
    var res;
    var len = this.length + num.length;
    if (this.length === 10 && num.length === 10) {
      res = comb10MulTo(this, num, out);
    } else if (len < 63) {
      res = smallMulTo(this, num, out);
    } else if (len < 1024) {
      res = bigMulTo(this, num, out);
    } else {
      res = jumboMulTo(this, num, out);
    }

    return res;
  };

  // Cooley-Tukey algorithm for FFT
  // slightly revisited to rely on looping instead of recursion

  function FFTM (x, y) {
    this.x = x;
    this.y = y;
  }

  FFTM.prototype.makeRBT = function makeRBT (N) {
    var t = new Array(N);
    var l = BN.prototype._countBits(N) - 1;
    for (var i = 0; i < N; i++) {
      t[i] = this.revBin(i, l, N);
    }

    return t;
  };

  // Returns binary-reversed representation of `x`
  FFTM.prototype.revBin = function revBin (x, l, N) {
    if (x === 0 || x === N - 1) return x;

    var rb = 0;
    for (var i = 0; i < l; i++) {
      rb |= (x & 1) << (l - i - 1);
      x >>= 1;
    }

    return rb;
  };

  // Performs "tweedling" phase, therefore 'emulating'
  // behaviour of the recursive algorithm
  FFTM.prototype.permute = function permute (rbt, rws, iws, rtws, itws, N) {
    for (var i = 0; i < N; i++) {
      rtws[i] = rws[rbt[i]];
      itws[i] = iws[rbt[i]];
    }
  };

  FFTM.prototype.transform = function transform (rws, iws, rtws, itws, N, rbt) {
    this.permute(rbt, rws, iws, rtws, itws, N);

    for (var s = 1; s < N; s <<= 1) {
      var l = s << 1;

      var rtwdf = Math.cos(2 * Math.PI / l);
      var itwdf = Math.sin(2 * Math.PI / l);

      for (var p = 0; p < N; p += l) {
        var rtwdf_ = rtwdf;
        var itwdf_ = itwdf;

        for (var j = 0; j < s; j++) {
          var re = rtws[p + j];
          var ie = itws[p + j];

          var ro = rtws[p + j + s];
          var io = itws[p + j + s];

          var rx = rtwdf_ * ro - itwdf_ * io;

          io = rtwdf_ * io + itwdf_ * ro;
          ro = rx;

          rtws[p + j] = re + ro;
          itws[p + j] = ie + io;

          rtws[p + j + s] = re - ro;
          itws[p + j + s] = ie - io;

          /* jshint maxdepth : false */
          if (j !== l) {
            rx = rtwdf * rtwdf_ - itwdf * itwdf_;

            itwdf_ = rtwdf * itwdf_ + itwdf * rtwdf_;
            rtwdf_ = rx;
          }
        }
      }
    }
  };

  FFTM.prototype.guessLen13b = function guessLen13b (n, m) {
    var N = Math.max(m, n) | 1;
    var odd = N & 1;
    var i = 0;
    for (N = N / 2 | 0; N; N = N >>> 1) {
      i++;
    }

    return 1 << i + 1 + odd;
  };

  FFTM.prototype.conjugate = function conjugate (rws, iws, N) {
    if (N <= 1) return;

    for (var i = 0; i < N / 2; i++) {
      var t = rws[i];

      rws[i] = rws[N - i - 1];
      rws[N - i - 1] = t;

      t = iws[i];

      iws[i] = -iws[N - i - 1];
      iws[N - i - 1] = -t;
    }
  };

  FFTM.prototype.normalize13b = function normalize13b (ws, N) {
    var carry = 0;
    for (var i = 0; i < N / 2; i++) {
      var w = Math.round(ws[2 * i + 1] / N) * 0x2000 +
        Math.round(ws[2 * i] / N) +
        carry;

      ws[i] = w & 0x3ffffff;

      if (w < 0x4000000) {
        carry = 0;
      } else {
        carry = w / 0x4000000 | 0;
      }
    }

    return ws;
  };

  FFTM.prototype.convert13b = function convert13b (ws, len, rws, N) {
    var carry = 0;
    for (var i = 0; i < len; i++) {
      carry = carry + (ws[i] | 0);

      rws[2 * i] = carry & 0x1fff; carry = carry >>> 13;
      rws[2 * i + 1] = carry & 0x1fff; carry = carry >>> 13;
    }

    // Pad with zeroes
    for (i = 2 * len; i < N; ++i) {
      rws[i] = 0;
    }

    assert(carry === 0);
    assert((carry & ~0x1fff) === 0);
  };

  FFTM.prototype.stub = function stub (N) {
    var ph = new Array(N);
    for (var i = 0; i < N; i++) {
      ph[i] = 0;
    }

    return ph;
  };

  FFTM.prototype.mulp = function mulp (x, y, out) {
    var N = 2 * this.guessLen13b(x.length, y.length);

    var rbt = this.makeRBT(N);

    var _ = this.stub(N);

    var rws = new Array(N);
    var rwst = new Array(N);
    var iwst = new Array(N);

    var nrws = new Array(N);
    var nrwst = new Array(N);
    var niwst = new Array(N);

    var rmws = out.words;
    rmws.length = N;

    this.convert13b(x.words, x.length, rws, N);
    this.convert13b(y.words, y.length, nrws, N);

    this.transform(rws, _, rwst, iwst, N, rbt);
    this.transform(nrws, _, nrwst, niwst, N, rbt);

    for (var i = 0; i < N; i++) {
      var rx = rwst[i] * nrwst[i] - iwst[i] * niwst[i];
      iwst[i] = rwst[i] * niwst[i] + iwst[i] * nrwst[i];
      rwst[i] = rx;
    }

    this.conjugate(rwst, iwst, N);
    this.transform(rwst, iwst, rmws, _, N, rbt);
    this.conjugate(rmws, _, N);
    this.normalize13b(rmws, N);

    out.negative = x.negative ^ y.negative;
    out.length = x.length + y.length;
    return out.strip();
  };

  // Multiply `this` by `num`
  BN.prototype.mul = function mul (num) {
    var out = new BN(null);
    out.words = new Array(this.length + num.length);
    return this.mulTo(num, out);
  };

  // Multiply employing FFT
  BN.prototype.mulf = function mulf (num) {
    var out = new BN(null);
    out.words = new Array(this.length + num.length);
    return jumboMulTo(this, num, out);
  };

  // In-place Multiplication
  BN.prototype.imul = function imul (num) {
    return this.clone().mulTo(num, this);
  };

  BN.prototype.imuln = function imuln (num) {
    assert(typeof num === 'number');
    assert(num < 0x4000000);

    // Carry
    var carry = 0;
    for (var i = 0; i < this.length; i++) {
      var w = (this.words[i] | 0) * num;
      var lo = (w & 0x3ffffff) + (carry & 0x3ffffff);
      carry >>= 26;
      carry += (w / 0x4000000) | 0;
      // NOTE: lo is 27bit maximum
      carry += lo >>> 26;
      this.words[i] = lo & 0x3ffffff;
    }

    if (carry !== 0) {
      this.words[i] = carry;
      this.length++;
    }

    return this;
  };

  BN.prototype.muln = function muln (num) {
    return this.clone().imuln(num);
  };

  // `this` * `this`
  BN.prototype.sqr = function sqr () {
    return this.mul(this);
  };

  // `this` * `this` in-place
  BN.prototype.isqr = function isqr () {
    return this.imul(this.clone());
  };

  // Math.pow(`this`, `num`)
  BN.prototype.pow = function pow (num) {
    var w = toBitArray(num);
    if (w.length === 0) return new BN(1);

    // Skip leading zeroes
    var res = this;
    for (var i = 0; i < w.length; i++, res = res.sqr()) {
      if (w[i] !== 0) break;
    }

    if (++i < w.length) {
      for (var q = res.sqr(); i < w.length; i++, q = q.sqr()) {
        if (w[i] === 0) continue;

        res = res.mul(q);
      }
    }

    return res;
  };

  // Shift-left in-place
  BN.prototype.iushln = function iushln (bits) {
    assert(typeof bits === 'number' && bits >= 0);
    var r = bits % 26;
    var s = (bits - r) / 26;
    var carryMask = (0x3ffffff >>> (26 - r)) << (26 - r);
    var i;

    if (r !== 0) {
      var carry = 0;

      for (i = 0; i < this.length; i++) {
        var newCarry = this.words[i] & carryMask;
        var c = ((this.words[i] | 0) - newCarry) << r;
        this.words[i] = c | carry;
        carry = newCarry >>> (26 - r);
      }

      if (carry) {
        this.words[i] = carry;
        this.length++;
      }
    }

    if (s !== 0) {
      for (i = this.length - 1; i >= 0; i--) {
        this.words[i + s] = this.words[i];
      }

      for (i = 0; i < s; i++) {
        this.words[i] = 0;
      }

      this.length += s;
    }

    return this.strip();
  };

  BN.prototype.ishln = function ishln (bits) {
    // TODO(indutny): implement me
    assert(this.negative === 0);
    return this.iushln(bits);
  };

  // Shift-right in-place
  // NOTE: `hint` is a lowest bit before trailing zeroes
  // NOTE: if `extended` is present - it will be filled with destroyed bits
  BN.prototype.iushrn = function iushrn (bits, hint, extended) {
    assert(typeof bits === 'number' && bits >= 0);
    var h;
    if (hint) {
      h = (hint - (hint % 26)) / 26;
    } else {
      h = 0;
    }

    var r = bits % 26;
    var s = Math.min((bits - r) / 26, this.length);
    var mask = 0x3ffffff ^ ((0x3ffffff >>> r) << r);
    var maskedWords = extended;

    h -= s;
    h = Math.max(0, h);

    // Extended mode, copy masked part
    if (maskedWords) {
      for (var i = 0; i < s; i++) {
        maskedWords.words[i] = this.words[i];
      }
      maskedWords.length = s;
    }

    if (s === 0) {
      // No-op, we should not move anything at all
    } else if (this.length > s) {
      this.length -= s;
      for (i = 0; i < this.length; i++) {
        this.words[i] = this.words[i + s];
      }
    } else {
      this.words[0] = 0;
      this.length = 1;
    }

    var carry = 0;
    for (i = this.length - 1; i >= 0 && (carry !== 0 || i >= h); i--) {
      var word = this.words[i] | 0;
      this.words[i] = (carry << (26 - r)) | (word >>> r);
      carry = word & mask;
    }

    // Push carried bits as a mask
    if (maskedWords && carry !== 0) {
      maskedWords.words[maskedWords.length++] = carry;
    }

    if (this.length === 0) {
      this.words[0] = 0;
      this.length = 1;
    }

    return this.strip();
  };

  BN.prototype.ishrn = function ishrn (bits, hint, extended) {
    // TODO(indutny): implement me
    assert(this.negative === 0);
    return this.iushrn(bits, hint, extended);
  };

  // Shift-left
  BN.prototype.shln = function shln (bits) {
    return this.clone().ishln(bits);
  };

  BN.prototype.ushln = function ushln (bits) {
    return this.clone().iushln(bits);
  };

  // Shift-right
  BN.prototype.shrn = function shrn (bits) {
    return this.clone().ishrn(bits);
  };

  BN.prototype.ushrn = function ushrn (bits) {
    return this.clone().iushrn(bits);
  };

  // Test if n bit is set
  BN.prototype.testn = function testn (bit) {
    assert(typeof bit === 'number' && bit >= 0);
    var r = bit % 26;
    var s = (bit - r) / 26;
    var q = 1 << r;

    // Fast case: bit is much higher than all existing words
    if (this.length <= s) return false;

    // Check bit and return
    var w = this.words[s];

    return !!(w & q);
  };

  // Return only lowers bits of number (in-place)
  BN.prototype.imaskn = function imaskn (bits) {
    assert(typeof bits === 'number' && bits >= 0);
    var r = bits % 26;
    var s = (bits - r) / 26;

    assert(this.negative === 0, 'imaskn works only with positive numbers');

    if (this.length <= s) {
      return this;
    }

    if (r !== 0) {
      s++;
    }
    this.length = Math.min(s, this.length);

    if (r !== 0) {
      var mask = 0x3ffffff ^ ((0x3ffffff >>> r) << r);
      this.words[this.length - 1] &= mask;
    }

    return this.strip();
  };

  // Return only lowers bits of number
  BN.prototype.maskn = function maskn (bits) {
    return this.clone().imaskn(bits);
  };

  // Add plain number `num` to `this`
  BN.prototype.iaddn = function iaddn (num) {
    assert(typeof num === 'number');
    assert(num < 0x4000000);
    if (num < 0) return this.isubn(-num);

    // Possible sign change
    if (this.negative !== 0) {
      if (this.length === 1 && (this.words[0] | 0) < num) {
        this.words[0] = num - (this.words[0] | 0);
        this.negative = 0;
        return this;
      }

      this.negative = 0;
      this.isubn(num);
      this.negative = 1;
      return this;
    }

    // Add without checks
    return this._iaddn(num);
  };

  BN.prototype._iaddn = function _iaddn (num) {
    this.words[0] += num;

    // Carry
    for (var i = 0; i < this.length && this.words[i] >= 0x4000000; i++) {
      this.words[i] -= 0x4000000;
      if (i === this.length - 1) {
        this.words[i + 1] = 1;
      } else {
        this.words[i + 1]++;
      }
    }
    this.length = Math.max(this.length, i + 1);

    return this;
  };

  // Subtract plain number `num` from `this`
  BN.prototype.isubn = function isubn (num) {
    assert(typeof num === 'number');
    assert(num < 0x4000000);
    if (num < 0) return this.iaddn(-num);

    if (this.negative !== 0) {
      this.negative = 0;
      this.iaddn(num);
      this.negative = 1;
      return this;
    }

    this.words[0] -= num;

    if (this.length === 1 && this.words[0] < 0) {
      this.words[0] = -this.words[0];
      this.negative = 1;
    } else {
      // Carry
      for (var i = 0; i < this.length && this.words[i] < 0; i++) {
        this.words[i] += 0x4000000;
        this.words[i + 1] -= 1;
      }
    }

    return this.strip();
  };

  BN.prototype.addn = function addn (num) {
    return this.clone().iaddn(num);
  };

  BN.prototype.subn = function subn (num) {
    return this.clone().isubn(num);
  };

  BN.prototype.iabs = function iabs () {
    this.negative = 0;

    return this;
  };

  BN.prototype.abs = function abs () {
    return this.clone().iabs();
  };

  BN.prototype._ishlnsubmul = function _ishlnsubmul (num, mul, shift) {
    var len = num.length + shift;
    var i;

    this._expand(len);

    var w;
    var carry = 0;
    for (i = 0; i < num.length; i++) {
      w = (this.words[i + shift] | 0) + carry;
      var right = (num.words[i] | 0) * mul;
      w -= right & 0x3ffffff;
      carry = (w >> 26) - ((right / 0x4000000) | 0);
      this.words[i + shift] = w & 0x3ffffff;
    }
    for (; i < this.length - shift; i++) {
      w = (this.words[i + shift] | 0) + carry;
      carry = w >> 26;
      this.words[i + shift] = w & 0x3ffffff;
    }

    if (carry === 0) return this.strip();

    // Subtraction overflow
    assert(carry === -1);
    carry = 0;
    for (i = 0; i < this.length; i++) {
      w = -(this.words[i] | 0) + carry;
      carry = w >> 26;
      this.words[i] = w & 0x3ffffff;
    }
    this.negative = 1;

    return this.strip();
  };

  BN.prototype._wordDiv = function _wordDiv (num, mode) {
    var shift = this.length - num.length;

    var a = this.clone();
    var b = num;

    // Normalize
    var bhi = b.words[b.length - 1] | 0;
    var bhiBits = this._countBits(bhi);
    shift = 26 - bhiBits;
    if (shift !== 0) {
      b = b.ushln(shift);
      a.iushln(shift);
      bhi = b.words[b.length - 1] | 0;
    }

    // Initialize quotient
    var m = a.length - b.length;
    var q;

    if (mode !== 'mod') {
      q = new BN(null);
      q.length = m + 1;
      q.words = new Array(q.length);
      for (var i = 0; i < q.length; i++) {
        q.words[i] = 0;
      }
    }

    var diff = a.clone()._ishlnsubmul(b, 1, m);
    if (diff.negative === 0) {
      a = diff;
      if (q) {
        q.words[m] = 1;
      }
    }

    for (var j = m - 1; j >= 0; j--) {
      var qj = (a.words[b.length + j] | 0) * 0x4000000 +
        (a.words[b.length + j - 1] | 0);

      // NOTE: (qj / bhi) is (0x3ffffff * 0x4000000 + 0x3ffffff) / 0x2000000 max
      // (0x7ffffff)
      qj = Math.min((qj / bhi) | 0, 0x3ffffff);

      a._ishlnsubmul(b, qj, j);
      while (a.negative !== 0) {
        qj--;
        a.negative = 0;
        a._ishlnsubmul(b, 1, j);
        if (!a.isZero()) {
          a.negative ^= 1;
        }
      }
      if (q) {
        q.words[j] = qj;
      }
    }
    if (q) {
      q.strip();
    }
    a.strip();

    // Denormalize
    if (mode !== 'div' && shift !== 0) {
      a.iushrn(shift);
    }

    return {
      div: q || null,
      mod: a
    };
  };

  // NOTE: 1) `mode` can be set to `mod` to request mod only,
  //       to `div` to request div only, or be absent to
  //       request both div & mod
  //       2) `positive` is true if unsigned mod is requested
  BN.prototype.divmod = function divmod (num, mode, positive) {
    assert(!num.isZero());

    if (this.isZero()) {
      return {
        div: new BN(0),
        mod: new BN(0)
      };
    }

    var div, mod, res;
    if (this.negative !== 0 && num.negative === 0) {
      res = this.neg().divmod(num, mode);

      if (mode !== 'mod') {
        div = res.div.neg();
      }

      if (mode !== 'div') {
        mod = res.mod.neg();
        if (positive && mod.negative !== 0) {
          mod.iadd(num);
        }
      }

      return {
        div: div,
        mod: mod
      };
    }

    if (this.negative === 0 && num.negative !== 0) {
      res = this.divmod(num.neg(), mode);

      if (mode !== 'mod') {
        div = res.div.neg();
      }

      return {
        div: div,
        mod: res.mod
      };
    }

    if ((this.negative & num.negative) !== 0) {
      res = this.neg().divmod(num.neg(), mode);

      if (mode !== 'div') {
        mod = res.mod.neg();
        if (positive && mod.negative !== 0) {
          mod.isub(num);
        }
      }

      return {
        div: res.div,
        mod: mod
      };
    }

    // Both numbers are positive at this point

    // Strip both numbers to approximate shift value
    if (num.length > this.length || this.cmp(num) < 0) {
      return {
        div: new BN(0),
        mod: this
      };
    }

    // Very short reduction
    if (num.length === 1) {
      if (mode === 'div') {
        return {
          div: this.divn(num.words[0]),
          mod: null
        };
      }

      if (mode === 'mod') {
        return {
          div: null,
          mod: new BN(this.modn(num.words[0]))
        };
      }

      return {
        div: this.divn(num.words[0]),
        mod: new BN(this.modn(num.words[0]))
      };
    }

    return this._wordDiv(num, mode);
  };

  // Find `this` / `num`
  BN.prototype.div = function div (num) {
    return this.divmod(num, 'div', false).div;
  };

  // Find `this` % `num`
  BN.prototype.mod = function mod (num) {
    return this.divmod(num, 'mod', false).mod;
  };

  BN.prototype.umod = function umod (num) {
    return this.divmod(num, 'mod', true).mod;
  };

  // Find Round(`this` / `num`)
  BN.prototype.divRound = function divRound (num) {
    var dm = this.divmod(num);

    // Fast case - exact division
    if (dm.mod.isZero()) return dm.div;

    var mod = dm.div.negative !== 0 ? dm.mod.isub(num) : dm.mod;

    var half = num.ushrn(1);
    var r2 = num.andln(1);
    var cmp = mod.cmp(half);

    // Round down
    if (cmp < 0 || r2 === 1 && cmp === 0) return dm.div;

    // Round up
    return dm.div.negative !== 0 ? dm.div.isubn(1) : dm.div.iaddn(1);
  };

  BN.prototype.modn = function modn (num) {
    assert(num <= 0x3ffffff);
    var p = (1 << 26) % num;

    var acc = 0;
    for (var i = this.length - 1; i >= 0; i--) {
      acc = (p * acc + (this.words[i] | 0)) % num;
    }

    return acc;
  };

  // In-place division by number
  BN.prototype.idivn = function idivn (num) {
    assert(num <= 0x3ffffff);

    var carry = 0;
    for (var i = this.length - 1; i >= 0; i--) {
      var w = (this.words[i] | 0) + carry * 0x4000000;
      this.words[i] = (w / num) | 0;
      carry = w % num;
    }

    return this.strip();
  };

  BN.prototype.divn = function divn (num) {
    return this.clone().idivn(num);
  };

  BN.prototype.egcd = function egcd (p) {
    assert(p.negative === 0);
    assert(!p.isZero());

    var x = this;
    var y = p.clone();

    if (x.negative !== 0) {
      x = x.umod(p);
    } else {
      x = x.clone();
    }

    // A * x + B * y = x
    var A = new BN(1);
    var B = new BN(0);

    // C * x + D * y = y
    var C = new BN(0);
    var D = new BN(1);

    var g = 0;

    while (x.isEven() && y.isEven()) {
      x.iushrn(1);
      y.iushrn(1);
      ++g;
    }

    var yp = y.clone();
    var xp = x.clone();

    while (!x.isZero()) {
      for (var i = 0, im = 1; (x.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
      if (i > 0) {
        x.iushrn(i);
        while (i-- > 0) {
          if (A.isOdd() || B.isOdd()) {
            A.iadd(yp);
            B.isub(xp);
          }

          A.iushrn(1);
          B.iushrn(1);
        }
      }

      for (var j = 0, jm = 1; (y.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
      if (j > 0) {
        y.iushrn(j);
        while (j-- > 0) {
          if (C.isOdd() || D.isOdd()) {
            C.iadd(yp);
            D.isub(xp);
          }

          C.iushrn(1);
          D.iushrn(1);
        }
      }

      if (x.cmp(y) >= 0) {
        x.isub(y);
        A.isub(C);
        B.isub(D);
      } else {
        y.isub(x);
        C.isub(A);
        D.isub(B);
      }
    }

    return {
      a: C,
      b: D,
      gcd: y.iushln(g)
    };
  };

  // This is reduced incarnation of the binary EEA
  // above, designated to invert members of the
  // _prime_ fields F(p) at a maximal speed
  BN.prototype._invmp = function _invmp (p) {
    assert(p.negative === 0);
    assert(!p.isZero());

    var a = this;
    var b = p.clone();

    if (a.negative !== 0) {
      a = a.umod(p);
    } else {
      a = a.clone();
    }

    var x1 = new BN(1);
    var x2 = new BN(0);

    var delta = b.clone();

    while (a.cmpn(1) > 0 && b.cmpn(1) > 0) {
      for (var i = 0, im = 1; (a.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
      if (i > 0) {
        a.iushrn(i);
        while (i-- > 0) {
          if (x1.isOdd()) {
            x1.iadd(delta);
          }

          x1.iushrn(1);
        }
      }

      for (var j = 0, jm = 1; (b.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
      if (j > 0) {
        b.iushrn(j);
        while (j-- > 0) {
          if (x2.isOdd()) {
            x2.iadd(delta);
          }

          x2.iushrn(1);
        }
      }

      if (a.cmp(b) >= 0) {
        a.isub(b);
        x1.isub(x2);
      } else {
        b.isub(a);
        x2.isub(x1);
      }
    }

    var res;
    if (a.cmpn(1) === 0) {
      res = x1;
    } else {
      res = x2;
    }

    if (res.cmpn(0) < 0) {
      res.iadd(p);
    }

    return res;
  };

  BN.prototype.gcd = function gcd (num) {
    if (this.isZero()) return num.abs();
    if (num.isZero()) return this.abs();

    var a = this.clone();
    var b = num.clone();
    a.negative = 0;
    b.negative = 0;

    // Remove common factor of two
    for (var shift = 0; a.isEven() && b.isEven(); shift++) {
      a.iushrn(1);
      b.iushrn(1);
    }

    do {
      while (a.isEven()) {
        a.iushrn(1);
      }
      while (b.isEven()) {
        b.iushrn(1);
      }

      var r = a.cmp(b);
      if (r < 0) {
        // Swap `a` and `b` to make `a` always bigger than `b`
        var t = a;
        a = b;
        b = t;
      } else if (r === 0 || b.cmpn(1) === 0) {
        break;
      }

      a.isub(b);
    } while (true);

    return b.iushln(shift);
  };

  // Invert number in the field F(num)
  BN.prototype.invm = function invm (num) {
    return this.egcd(num).a.umod(num);
  };

  BN.prototype.isEven = function isEven () {
    return (this.words[0] & 1) === 0;
  };

  BN.prototype.isOdd = function isOdd () {
    return (this.words[0] & 1) === 1;
  };

  // And first word and num
  BN.prototype.andln = function andln (num) {
    return this.words[0] & num;
  };

  // Increment at the bit position in-line
  BN.prototype.bincn = function bincn (bit) {
    assert(typeof bit === 'number');
    var r = bit % 26;
    var s = (bit - r) / 26;
    var q = 1 << r;

    // Fast case: bit is much higher than all existing words
    if (this.length <= s) {
      this._expand(s + 1);
      this.words[s] |= q;
      return this;
    }

    // Add bit and propagate, if needed
    var carry = q;
    for (var i = s; carry !== 0 && i < this.length; i++) {
      var w = this.words[i] | 0;
      w += carry;
      carry = w >>> 26;
      w &= 0x3ffffff;
      this.words[i] = w;
    }
    if (carry !== 0) {
      this.words[i] = carry;
      this.length++;
    }
    return this;
  };

  BN.prototype.isZero = function isZero () {
    return this.length === 1 && this.words[0] === 0;
  };

  BN.prototype.cmpn = function cmpn (num) {
    var negative = num < 0;

    if (this.negative !== 0 && !negative) return -1;
    if (this.negative === 0 && negative) return 1;

    this.strip();

    var res;
    if (this.length > 1) {
      res = 1;
    } else {
      if (negative) {
        num = -num;
      }

      assert(num <= 0x3ffffff, 'Number is too big');

      var w = this.words[0] | 0;
      res = w === num ? 0 : w < num ? -1 : 1;
    }
    if (this.negative !== 0) return -res | 0;
    return res;
  };

  // Compare two numbers and return:
  // 1 - if `this` > `num`
  // 0 - if `this` == `num`
  // -1 - if `this` < `num`
  BN.prototype.cmp = function cmp (num) {
    if (this.negative !== 0 && num.negative === 0) return -1;
    if (this.negative === 0 && num.negative !== 0) return 1;

    var res = this.ucmp(num);
    if (this.negative !== 0) return -res | 0;
    return res;
  };

  // Unsigned comparison
  BN.prototype.ucmp = function ucmp (num) {
    // At this point both numbers have the same sign
    if (this.length > num.length) return 1;
    if (this.length < num.length) return -1;

    var res = 0;
    for (var i = this.length - 1; i >= 0; i--) {
      var a = this.words[i] | 0;
      var b = num.words[i] | 0;

      if (a === b) continue;
      if (a < b) {
        res = -1;
      } else if (a > b) {
        res = 1;
      }
      break;
    }
    return res;
  };

  BN.prototype.gtn = function gtn (num) {
    return this.cmpn(num) === 1;
  };

  BN.prototype.gt = function gt (num) {
    return this.cmp(num) === 1;
  };

  BN.prototype.gten = function gten (num) {
    return this.cmpn(num) >= 0;
  };

  BN.prototype.gte = function gte (num) {
    return this.cmp(num) >= 0;
  };

  BN.prototype.ltn = function ltn (num) {
    return this.cmpn(num) === -1;
  };

  BN.prototype.lt = function lt (num) {
    return this.cmp(num) === -1;
  };

  BN.prototype.lten = function lten (num) {
    return this.cmpn(num) <= 0;
  };

  BN.prototype.lte = function lte (num) {
    return this.cmp(num) <= 0;
  };

  BN.prototype.eqn = function eqn (num) {
    return this.cmpn(num) === 0;
  };

  BN.prototype.eq = function eq (num) {
    return this.cmp(num) === 0;
  };

  //
  // A reduce context, could be using montgomery or something better, depending
  // on the `m` itself.
  //
  BN.red = function red (num) {
    return new Red(num);
  };

  BN.prototype.toRed = function toRed (ctx) {
    assert(!this.red, 'Already a number in reduction context');
    assert(this.negative === 0, 'red works only with positives');
    return ctx.convertTo(this)._forceRed(ctx);
  };

  BN.prototype.fromRed = function fromRed () {
    assert(this.red, 'fromRed works only with numbers in reduction context');
    return this.red.convertFrom(this);
  };

  BN.prototype._forceRed = function _forceRed (ctx) {
    this.red = ctx;
    return this;
  };

  BN.prototype.forceRed = function forceRed (ctx) {
    assert(!this.red, 'Already a number in reduction context');
    return this._forceRed(ctx);
  };

  BN.prototype.redAdd = function redAdd (num) {
    assert(this.red, 'redAdd works only with red numbers');
    return this.red.add(this, num);
  };

  BN.prototype.redIAdd = function redIAdd (num) {
    assert(this.red, 'redIAdd works only with red numbers');
    return this.red.iadd(this, num);
  };

  BN.prototype.redSub = function redSub (num) {
    assert(this.red, 'redSub works only with red numbers');
    return this.red.sub(this, num);
  };

  BN.prototype.redISub = function redISub (num) {
    assert(this.red, 'redISub works only with red numbers');
    return this.red.isub(this, num);
  };

  BN.prototype.redShl = function redShl (num) {
    assert(this.red, 'redShl works only with red numbers');
    return this.red.shl(this, num);
  };

  BN.prototype.redMul = function redMul (num) {
    assert(this.red, 'redMul works only with red numbers');
    this.red._verify2(this, num);
    return this.red.mul(this, num);
  };

  BN.prototype.redIMul = function redIMul (num) {
    assert(this.red, 'redMul works only with red numbers');
    this.red._verify2(this, num);
    return this.red.imul(this, num);
  };

  BN.prototype.redSqr = function redSqr () {
    assert(this.red, 'redSqr works only with red numbers');
    this.red._verify1(this);
    return this.red.sqr(this);
  };

  BN.prototype.redISqr = function redISqr () {
    assert(this.red, 'redISqr works only with red numbers');
    this.red._verify1(this);
    return this.red.isqr(this);
  };

  // Square root over p
  BN.prototype.redSqrt = function redSqrt () {
    assert(this.red, 'redSqrt works only with red numbers');
    this.red._verify1(this);
    return this.red.sqrt(this);
  };

  BN.prototype.redInvm = function redInvm () {
    assert(this.red, 'redInvm works only with red numbers');
    this.red._verify1(this);
    return this.red.invm(this);
  };

  // Return negative clone of `this` % `red modulo`
  BN.prototype.redNeg = function redNeg () {
    assert(this.red, 'redNeg works only with red numbers');
    this.red._verify1(this);
    return this.red.neg(this);
  };

  BN.prototype.redPow = function redPow (num) {
    assert(this.red && !num.red, 'redPow(normalNum)');
    this.red._verify1(this);
    return this.red.pow(this, num);
  };

  // Prime numbers with efficient reduction
  var primes = {
    k256: null,
    p224: null,
    p192: null,
    p25519: null
  };

  // Pseudo-Mersenne prime
  function MPrime (name, p) {
    // P = 2 ^ N - K
    this.name = name;
    this.p = new BN(p, 16);
    this.n = this.p.bitLength();
    this.k = new BN(1).iushln(this.n).isub(this.p);

    this.tmp = this._tmp();
  }

  MPrime.prototype._tmp = function _tmp () {
    var tmp = new BN(null);
    tmp.words = new Array(Math.ceil(this.n / 13));
    return tmp;
  };

  MPrime.prototype.ireduce = function ireduce (num) {
    // Assumes that `num` is less than `P^2`
    // num = HI * (2 ^ N - K) + HI * K + LO = HI * K + LO (mod P)
    var r = num;
    var rlen;

    do {
      this.split(r, this.tmp);
      r = this.imulK(r);
      r = r.iadd(this.tmp);
      rlen = r.bitLength();
    } while (rlen > this.n);

    var cmp = rlen < this.n ? -1 : r.ucmp(this.p);
    if (cmp === 0) {
      r.words[0] = 0;
      r.length = 1;
    } else if (cmp > 0) {
      r.isub(this.p);
    } else {
      if (r.strip !== undefined) {
        // r is BN v4 instance
        r.strip();
      } else {
        // r is BN v5 instance
        r._strip();
      }
    }

    return r;
  };

  MPrime.prototype.split = function split (input, out) {
    input.iushrn(this.n, 0, out);
  };

  MPrime.prototype.imulK = function imulK (num) {
    return num.imul(this.k);
  };

  function K256 () {
    MPrime.call(
      this,
      'k256',
      'ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f');
  }
  inherits(K256, MPrime);

  K256.prototype.split = function split (input, output) {
    // 256 = 9 * 26 + 22
    var mask = 0x3fffff;

    var outLen = Math.min(input.length, 9);
    for (var i = 0; i < outLen; i++) {
      output.words[i] = input.words[i];
    }
    output.length = outLen;

    if (input.length <= 9) {
      input.words[0] = 0;
      input.length = 1;
      return;
    }

    // Shift by 9 limbs
    var prev = input.words[9];
    output.words[output.length++] = prev & mask;

    for (i = 10; i < input.length; i++) {
      var next = input.words[i] | 0;
      input.words[i - 10] = ((next & mask) << 4) | (prev >>> 22);
      prev = next;
    }
    prev >>>= 22;
    input.words[i - 10] = prev;
    if (prev === 0 && input.length > 10) {
      input.length -= 10;
    } else {
      input.length -= 9;
    }
  };

  K256.prototype.imulK = function imulK (num) {
    // K = 0x1000003d1 = [ 0x40, 0x3d1 ]
    num.words[num.length] = 0;
    num.words[num.length + 1] = 0;
    num.length += 2;

    // bounded at: 0x40 * 0x3ffffff + 0x3d0 = 0x100000390
    var lo = 0;
    for (var i = 0; i < num.length; i++) {
      var w = num.words[i] | 0;
      lo += w * 0x3d1;
      num.words[i] = lo & 0x3ffffff;
      lo = w * 0x40 + ((lo / 0x4000000) | 0);
    }

    // Fast length reduction
    if (num.words[num.length - 1] === 0) {
      num.length--;
      if (num.words[num.length - 1] === 0) {
        num.length--;
      }
    }
    return num;
  };

  function P224 () {
    MPrime.call(
      this,
      'p224',
      'ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001');
  }
  inherits(P224, MPrime);

  function P192 () {
    MPrime.call(
      this,
      'p192',
      'ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff');
  }
  inherits(P192, MPrime);

  function P25519 () {
    // 2 ^ 255 - 19
    MPrime.call(
      this,
      '25519',
      '7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed');
  }
  inherits(P25519, MPrime);

  P25519.prototype.imulK = function imulK (num) {
    // K = 0x13
    var carry = 0;
    for (var i = 0; i < num.length; i++) {
      var hi = (num.words[i] | 0) * 0x13 + carry;
      var lo = hi & 0x3ffffff;
      hi >>>= 26;

      num.words[i] = lo;
      carry = hi;
    }
    if (carry !== 0) {
      num.words[num.length++] = carry;
    }
    return num;
  };

  // Exported mostly for testing purposes, use plain name instead
  BN._prime = function prime (name) {
    // Cached version of prime
    if (primes[name]) return primes[name];

    var prime;
    if (name === 'k256') {
      prime = new K256();
    } else if (name === 'p224') {
      prime = new P224();
    } else if (name === 'p192') {
      prime = new P192();
    } else if (name === 'p25519') {
      prime = new P25519();
    } else {
      throw new Error('Unknown prime ' + name);
    }
    primes[name] = prime;

    return prime;
  };

  //
  // Base reduction engine
  //
  function Red (m) {
    if (typeof m === 'string') {
      var prime = BN._prime(m);
      this.m = prime.p;
      this.prime = prime;
    } else {
      assert(m.gtn(1), 'modulus must be greater than 1');
      this.m = m;
      this.prime = null;
    }
  }

  Red.prototype._verify1 = function _verify1 (a) {
    assert(a.negative === 0, 'red works only with positives');
    assert(a.red, 'red works only with red numbers');
  };

  Red.prototype._verify2 = function _verify2 (a, b) {
    assert((a.negative | b.negative) === 0, 'red works only with positives');
    assert(a.red && a.red === b.red,
      'red works only with red numbers');
  };

  Red.prototype.imod = function imod (a) {
    if (this.prime) return this.prime.ireduce(a)._forceRed(this);
    return a.umod(this.m)._forceRed(this);
  };

  Red.prototype.neg = function neg (a) {
    if (a.isZero()) {
      return a.clone();
    }

    return this.m.sub(a)._forceRed(this);
  };

  Red.prototype.add = function add (a, b) {
    this._verify2(a, b);

    var res = a.add(b);
    if (res.cmp(this.m) >= 0) {
      res.isub(this.m);
    }
    return res._forceRed(this);
  };

  Red.prototype.iadd = function iadd (a, b) {
    this._verify2(a, b);

    var res = a.iadd(b);
    if (res.cmp(this.m) >= 0) {
      res.isub(this.m);
    }
    return res;
  };

  Red.prototype.sub = function sub (a, b) {
    this._verify2(a, b);

    var res = a.sub(b);
    if (res.cmpn(0) < 0) {
      res.iadd(this.m);
    }
    return res._forceRed(this);
  };

  Red.prototype.isub = function isub (a, b) {
    this._verify2(a, b);

    var res = a.isub(b);
    if (res.cmpn(0) < 0) {
      res.iadd(this.m);
    }
    return res;
  };

  Red.prototype.shl = function shl (a, num) {
    this._verify1(a);
    return this.imod(a.ushln(num));
  };

  Red.prototype.imul = function imul (a, b) {
    this._verify2(a, b);
    return this.imod(a.imul(b));
  };

  Red.prototype.mul = function mul (a, b) {
    this._verify2(a, b);
    return this.imod(a.mul(b));
  };

  Red.prototype.isqr = function isqr (a) {
    return this.imul(a, a.clone());
  };

  Red.prototype.sqr = function sqr (a) {
    return this.mul(a, a);
  };

  Red.prototype.sqrt = function sqrt (a) {
    if (a.isZero()) return a.clone();

    var mod3 = this.m.andln(3);
    assert(mod3 % 2 === 1);

    // Fast case
    if (mod3 === 3) {
      var pow = this.m.add(new BN(1)).iushrn(2);
      return this.pow(a, pow);
    }

    // Tonelli-Shanks algorithm (Totally unoptimized and slow)
    //
    // Find Q and S, that Q * 2 ^ S = (P - 1)
    var q = this.m.subn(1);
    var s = 0;
    while (!q.isZero() && q.andln(1) === 0) {
      s++;
      q.iushrn(1);
    }
    assert(!q.isZero());

    var one = new BN(1).toRed(this);
    var nOne = one.redNeg();

    // Find quadratic non-residue
    // NOTE: Max is such because of generalized Riemann hypothesis.
    var lpow = this.m.subn(1).iushrn(1);
    var z = this.m.bitLength();
    z = new BN(2 * z * z).toRed(this);

    while (this.pow(z, lpow).cmp(nOne) !== 0) {
      z.redIAdd(nOne);
    }

    var c = this.pow(z, q);
    var r = this.pow(a, q.addn(1).iushrn(1));
    var t = this.pow(a, q);
    var m = s;
    while (t.cmp(one) !== 0) {
      var tmp = t;
      for (var i = 0; tmp.cmp(one) !== 0; i++) {
        tmp = tmp.redSqr();
      }
      assert(i < m);
      var b = this.pow(c, new BN(1).iushln(m - i - 1));

      r = r.redMul(b);
      c = b.redSqr();
      t = t.redMul(c);
      m = i;
    }

    return r;
  };

  Red.prototype.invm = function invm (a) {
    var inv = a._invmp(this.m);
    if (inv.negative !== 0) {
      inv.negative = 0;
      return this.imod(inv).redNeg();
    } else {
      return this.imod(inv);
    }
  };

  Red.prototype.pow = function pow (a, num) {
    if (num.isZero()) return new BN(1).toRed(this);
    if (num.cmpn(1) === 0) return a.clone();

    var windowSize = 4;
    var wnd = new Array(1 << windowSize);
    wnd[0] = new BN(1).toRed(this);
    wnd[1] = a;
    for (var i = 2; i < wnd.length; i++) {
      wnd[i] = this.mul(wnd[i - 1], a);
    }

    var res = wnd[0];
    var current = 0;
    var currentLen = 0;
    var start = num.bitLength() % 26;
    if (start === 0) {
      start = 26;
    }

    for (i = num.length - 1; i >= 0; i--) {
      var word = num.words[i];
      for (var j = start - 1; j >= 0; j--) {
        var bit = (word >> j) & 1;
        if (res !== wnd[0]) {
          res = this.sqr(res);
        }

        if (bit === 0 && current === 0) {
          currentLen = 0;
          continue;
        }

        current <<= 1;
        current |= bit;
        currentLen++;
        if (currentLen !== windowSize && (i !== 0 || j !== 0)) continue;

        res = this.mul(res, wnd[current]);
        currentLen = 0;
        current = 0;
      }
      start = 26;
    }

    return res;
  };

  Red.prototype.convertTo = function convertTo (num) {
    var r = num.umod(this.m);

    return r === num ? r.clone() : r;
  };

  Red.prototype.convertFrom = function convertFrom (num) {
    var res = num.clone();
    res.red = null;
    return res;
  };

  //
  // Montgomery method engine
  //

  BN.mont = function mont (num) {
    return new Mont(num);
  };

  function Mont (m) {
    Red.call(this, m);

    this.shift = this.m.bitLength();
    if (this.shift % 26 !== 0) {
      this.shift += 26 - (this.shift % 26);
    }

    this.r = new BN(1).iushln(this.shift);
    this.r2 = this.imod(this.r.sqr());
    this.rinv = this.r._invmp(this.m);

    this.minv = this.rinv.mul(this.r).isubn(1).div(this.m);
    this.minv = this.minv.umod(this.r);
    this.minv = this.r.sub(this.minv);
  }
  inherits(Mont, Red);

  Mont.prototype.convertTo = function convertTo (num) {
    return this.imod(num.ushln(this.shift));
  };

  Mont.prototype.convertFrom = function convertFrom (num) {
    var r = this.imod(num.mul(this.rinv));
    r.red = null;
    return r;
  };

  Mont.prototype.imul = function imul (a, b) {
    if (a.isZero() || b.isZero()) {
      a.words[0] = 0;
      a.length = 1;
      return a;
    }

    var t = a.imul(b);
    var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
    var u = t.isub(c).iushrn(this.shift);
    var res = u;

    if (u.cmp(this.m) >= 0) {
      res = u.isub(this.m);
    } else if (u.cmpn(0) < 0) {
      res = u.iadd(this.m);
    }

    return res._forceRed(this);
  };

  Mont.prototype.mul = function mul (a, b) {
    if (a.isZero() || b.isZero()) return new BN(0)._forceRed(this);

    var t = a.mul(b);
    var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
    var u = t.isub(c).iushrn(this.shift);
    var res = u;
    if (u.cmp(this.m) >= 0) {
      res = u.isub(this.m);
    } else if (u.cmpn(0) < 0) {
      res = u.iadd(this.m);
    }

    return res._forceRed(this);
  };

  Mont.prototype.invm = function invm (a) {
    // (AR)^-1 * R^2 = (A^-1 * R^-1) * R^2 = A^-1 * R
    var res = this.imod(a._invmp(this.m).mul(this.r2));
    return res._forceRed(this);
  };
})( false || module, this);

/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(/*! ./../../../../webpack/buildin/module.js */ "./node_modules/webpack/buildin/module.js")(module)))

/***/ }),

/***/ "./node_modules/base64-js/index.js":
/*!*****************************************!*\
  !*** ./node_modules/base64-js/index.js ***!
  \*****************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.byteLength = byteLength
exports.toByteArray = toByteArray
exports.fromByteArray = fromByteArray

var lookup = []
var revLookup = []
var Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array

var code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/'
for (var i = 0, len = code.length; i < len; ++i) {
  lookup[i] = code[i]
  revLookup[code.charCodeAt(i)] = i
}

// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
revLookup['-'.charCodeAt(0)] = 62
revLookup['_'.charCodeAt(0)] = 63

function getLens (b64) {
  var len = b64.length

  if (len % 4 > 0) {
    throw new Error('Invalid string. Length must be a multiple of 4')
  }

  // Trim off extra bytes after placeholder bytes are found
  // See: https://github.com/beatgammit/base64-js/issues/42
  var validLen = b64.indexOf('=')
  if (validLen === -1) validLen = len

  var placeHoldersLen = validLen === len
    ? 0
    : 4 - (validLen % 4)

  return [validLen, placeHoldersLen]
}

// base64 is 4/3 + up to two characters of the original data
function byteLength (b64) {
  var lens = getLens(b64)
  var validLen = lens[0]
  var placeHoldersLen = lens[1]
  return ((validLen + placeHoldersLen) * 3 / 4) - placeHoldersLen
}

function _byteLength (b64, validLen, placeHoldersLen) {
  return ((validLen + placeHoldersLen) * 3 / 4) - placeHoldersLen
}

function toByteArray (b64) {
  var tmp
  var lens = getLens(b64)
  var validLen = lens[0]
  var placeHoldersLen = lens[1]

  var arr = new Arr(_byteLength(b64, validLen, placeHoldersLen))

  var curByte = 0

  // if there are placeholders, only get up to the last complete 4 chars
  var len = placeHoldersLen > 0
    ? validLen - 4
    : validLen

  var i
  for (i = 0; i < len; i += 4) {
    tmp =
      (revLookup[b64.charCodeAt(i)] << 18) |
      (revLookup[b64.charCodeAt(i + 1)] << 12) |
      (revLookup[b64.charCodeAt(i + 2)] << 6) |
      revLookup[b64.charCodeAt(i + 3)]
    arr[curByte++] = (tmp >> 16) & 0xFF
    arr[curByte++] = (tmp >> 8) & 0xFF
    arr[curByte++] = tmp & 0xFF
  }

  if (placeHoldersLen === 2) {
    tmp =
      (revLookup[b64.charCodeAt(i)] << 2) |
      (revLookup[b64.charCodeAt(i + 1)] >> 4)
    arr[curByte++] = tmp & 0xFF
  }

  if (placeHoldersLen === 1) {
    tmp =
      (revLookup[b64.charCodeAt(i)] << 10) |
      (revLookup[b64.charCodeAt(i + 1)] << 4) |
      (revLookup[b64.charCodeAt(i + 2)] >> 2)
    arr[curByte++] = (tmp >> 8) & 0xFF
    arr[curByte++] = tmp & 0xFF
  }

  return arr
}

function tripletToBase64 (num) {
  return lookup[num >> 18 & 0x3F] +
    lookup[num >> 12 & 0x3F] +
    lookup[num >> 6 & 0x3F] +
    lookup[num & 0x3F]
}

function encodeChunk (uint8, start, end) {
  var tmp
  var output = []
  for (var i = start; i < end; i += 3) {
    tmp =
      ((uint8[i] << 16) & 0xFF0000) +
      ((uint8[i + 1] << 8) & 0xFF00) +
      (uint8[i + 2] & 0xFF)
    output.push(tripletToBase64(tmp))
  }
  return output.join('')
}

function fromByteArray (uint8) {
  var tmp
  var len = uint8.length
  var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
  var parts = []
  var maxChunkLength = 16383 // must be multiple of 3

  // go through the array every three bytes, we'll deal with trailing stuff later
  for (var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength) {
    parts.push(encodeChunk(uint8, i, (i + maxChunkLength) > len2 ? len2 : (i + maxChunkLength)))
  }

  // pad the end with zeros, but make sure to not forget the extra bytes
  if (extraBytes === 1) {
    tmp = uint8[len - 1]
    parts.push(
      lookup[tmp >> 2] +
      lookup[(tmp << 4) & 0x3F] +
      '=='
    )
  } else if (extraBytes === 2) {
    tmp = (uint8[len - 2] << 8) + uint8[len - 1]
    parts.push(
      lookup[tmp >> 10] +
      lookup[(tmp >> 4) & 0x3F] +
      lookup[(tmp << 2) & 0x3F] +
      '='
    )
  }

  return parts.join('')
}


/***/ }),

/***/ "./node_modules/bn.js/lib/bn.js":
/*!**************************************!*\
  !*** ./node_modules/bn.js/lib/bn.js ***!
  \**************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {(function (module, exports) {
  'use strict';

  // Utils
  function assert (val, msg) {
    if (!val) throw new Error(msg || 'Assertion failed');
  }

  // Could use `inherits` module, but don't want to move from single file
  // architecture yet.
  function inherits (ctor, superCtor) {
    ctor.super_ = superCtor;
    var TempCtor = function () {};
    TempCtor.prototype = superCtor.prototype;
    ctor.prototype = new TempCtor();
    ctor.prototype.constructor = ctor;
  }

  // BN

  function BN (number, base, endian) {
    if (BN.isBN(number)) {
      return number;
    }

    this.negative = 0;
    this.words = null;
    this.length = 0;

    // Reduction context
    this.red = null;

    if (number !== null) {
      if (base === 'le' || base === 'be') {
        endian = base;
        base = 10;
      }

      this._init(number || 0, base || 10, endian || 'be');
    }
  }
  if (typeof module === 'object') {
    module.exports = BN;
  } else {
    exports.BN = BN;
  }

  BN.BN = BN;
  BN.wordSize = 26;

  var Buffer;
  try {
    Buffer = __webpack_require__(/*! buffer */ 9).Buffer;
  } catch (e) {
  }

  BN.isBN = function isBN (num) {
    if (num instanceof BN) {
      return true;
    }

    return num !== null && typeof num === 'object' &&
      num.constructor.wordSize === BN.wordSize && Array.isArray(num.words);
  };

  BN.max = function max (left, right) {
    if (left.cmp(right) > 0) return left;
    return right;
  };

  BN.min = function min (left, right) {
    if (left.cmp(right) < 0) return left;
    return right;
  };

  BN.prototype._init = function init (number, base, endian) {
    if (typeof number === 'number') {
      return this._initNumber(number, base, endian);
    }

    if (typeof number === 'object') {
      return this._initArray(number, base, endian);
    }

    if (base === 'hex') {
      base = 16;
    }
    assert(base === (base | 0) && base >= 2 && base <= 36);

    number = number.toString().replace(/\s+/g, '');
    var start = 0;
    if (number[0] === '-') {
      start++;
    }

    if (base === 16) {
      this._parseHex(number, start);
    } else {
      this._parseBase(number, base, start);
    }

    if (number[0] === '-') {
      this.negative = 1;
    }

    this._strip();

    if (endian !== 'le') return;

    this._initArray(this.toArray(), base, endian);
  };

  BN.prototype._initNumber = function _initNumber (number, base, endian) {
    if (number < 0) {
      this.negative = 1;
      number = -number;
    }
    if (number < 0x4000000) {
      this.words = [number & 0x3ffffff];
      this.length = 1;
    } else if (number < 0x10000000000000) {
      this.words = [
        number & 0x3ffffff,
        (number / 0x4000000) & 0x3ffffff
      ];
      this.length = 2;
    } else {
      assert(number < 0x20000000000000); // 2 ^ 53 (unsafe)
      this.words = [
        number & 0x3ffffff,
        (number / 0x4000000) & 0x3ffffff,
        1
      ];
      this.length = 3;
    }

    if (endian !== 'le') return;

    // Reverse the bytes
    this._initArray(this.toArray(), base, endian);
  };

  BN.prototype._initArray = function _initArray (number, base, endian) {
    // Perhaps a Uint8Array
    assert(typeof number.length === 'number');
    if (number.length <= 0) {
      this.words = [0];
      this.length = 1;
      return this;
    }

    this.length = Math.ceil(number.length / 3);
    this.words = new Array(this.length);
    for (var i = 0; i < this.length; i++) {
      this.words[i] = 0;
    }

    var j, w;
    var off = 0;
    if (endian === 'be') {
      for (i = number.length - 1, j = 0; i >= 0; i -= 3) {
        w = number[i] | (number[i - 1] << 8) | (number[i - 2] << 16);
        this.words[j] |= (w << off) & 0x3ffffff;
        this.words[j + 1] = (w >>> (26 - off)) & 0x3ffffff;
        off += 24;
        if (off >= 26) {
          off -= 26;
          j++;
        }
      }
    } else if (endian === 'le') {
      for (i = 0, j = 0; i < number.length; i += 3) {
        w = number[i] | (number[i + 1] << 8) | (number[i + 2] << 16);
        this.words[j] |= (w << off) & 0x3ffffff;
        this.words[j + 1] = (w >>> (26 - off)) & 0x3ffffff;
        off += 24;
        if (off >= 26) {
          off -= 26;
          j++;
        }
      }
    }
    return this._strip();
  };

  function parseHex (str, start, end) {
    var r = 0;
    var len = Math.min(str.length, end);
    var z = 0;
    for (var i = start; i < len; i++) {
      var c = str.charCodeAt(i) - 48;

      r <<= 4;

      var b;

      // 'a' - 'f'
      if (c >= 49 && c <= 54) {
        b = c - 49 + 0xa;

      // 'A' - 'F'
      } else if (c >= 17 && c <= 22) {
        b = c - 17 + 0xa;

      // '0' - '9'
      } else {
        b = c;
      }

      r |= b;
      z |= b;
    }

    assert(!(z & 0xf0), 'Invalid character in ' + str);
    return r;
  }

  BN.prototype._parseHex = function _parseHex (number, start) {
    // Create possibly bigger array to ensure that it fits the number
    this.length = Math.ceil((number.length - start) / 6);
    this.words = new Array(this.length);
    for (var i = 0; i < this.length; i++) {
      this.words[i] = 0;
    }

    var j, w;
    // Scan 24-bit chunks and add them to the number
    var off = 0;
    for (i = number.length - 6, j = 0; i >= start; i -= 6) {
      w = parseHex(number, i, i + 6);
      this.words[j] |= (w << off) & 0x3ffffff;
      // NOTE: `0x3fffff` is intentional here, 26bits max shift + 24bit hex limb
      this.words[j + 1] |= w >>> (26 - off) & 0x3fffff;
      off += 24;
      if (off >= 26) {
        off -= 26;
        j++;
      }
    }
    if (i + 6 !== start) {
      w = parseHex(number, start, i + 6);
      this.words[j] |= (w << off) & 0x3ffffff;
      this.words[j + 1] |= w >>> (26 - off) & 0x3fffff;
    }
    this._strip();
  };

  function parseBase (str, start, end, mul) {
    var r = 0;
    var b = 0;
    var len = Math.min(str.length, end);
    for (var i = start; i < len; i++) {
      var c = str.charCodeAt(i) - 48;

      r *= mul;

      // 'a'
      if (c >= 49) {
        b = c - 49 + 0xa;

      // 'A'
      } else if (c >= 17) {
        b = c - 17 + 0xa;

      // '0' - '9'
      } else {
        b = c;
      }
      assert(c >= 0 && b < mul, 'Invalid character');
      r += b;
    }
    return r;
  }

  BN.prototype._parseBase = function _parseBase (number, base, start) {
    // Initialize as zero
    this.words = [0];
    this.length = 1;

    // Find length of limb in base
    for (var limbLen = 0, limbPow = 1; limbPow <= 0x3ffffff; limbPow *= base) {
      limbLen++;
    }
    limbLen--;
    limbPow = (limbPow / base) | 0;

    var total = number.length - start;
    var mod = total % limbLen;
    var end = Math.min(total, total - mod) + start;

    var word = 0;
    for (var i = start; i < end; i += limbLen) {
      word = parseBase(number, i, i + limbLen, base);

      this.imuln(limbPow);
      if (this.words[0] + word < 0x4000000) {
        this.words[0] += word;
      } else {
        this._iaddn(word);
      }
    }

    if (mod !== 0) {
      var pow = 1;
      word = parseBase(number, i, number.length, base);

      for (i = 0; i < mod; i++) {
        pow *= base;
      }

      this.imuln(pow);
      if (this.words[0] + word < 0x4000000) {
        this.words[0] += word;
      } else {
        this._iaddn(word);
      }
    }
  };

  BN.prototype.copy = function copy (dest) {
    dest.words = new Array(this.length);
    for (var i = 0; i < this.length; i++) {
      dest.words[i] = this.words[i];
    }
    dest.length = this.length;
    dest.negative = this.negative;
    dest.red = this.red;
  };

  function move (dest, src) {
    dest.words = src.words;
    dest.length = src.length;
    dest.negative = src.negative;
    dest.red = src.red;
  }

  BN.prototype._move = function _move (dest) {
    move(dest, this);
  };

  BN.prototype.clone = function clone () {
    var r = new BN(null);
    this.copy(r);
    return r;
  };

  BN.prototype._expand = function _expand (size) {
    while (this.length < size) {
      this.words[this.length++] = 0;
    }
    return this;
  };

  // Remove leading `0` from `this`
  BN.prototype._strip = function strip () {
    while (this.length > 1 && this.words[this.length - 1] === 0) {
      this.length--;
    }
    return this._normSign();
  };

  BN.prototype._normSign = function _normSign () {
    // -0 = 0
    if (this.length === 1 && this.words[0] === 0) {
      this.negative = 0;
    }
    return this;
  };

  // Check Symbol.for because not everywhere where Symbol defined
  // See https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Symbol#Browser_compatibility
  if (typeof Symbol !== 'undefined' && typeof Symbol.for === 'function') {
    try {
      BN.prototype[Symbol.for('nodejs.util.inspect.custom')] = inspect;
    } catch (e) {
      BN.prototype.inspect = inspect;
    }
  } else {
    BN.prototype.inspect = inspect;
  }

  function inspect () {
    return (this.red ? '<BN-R: ' : '<BN: ') + this.toString(16) + '>';
  }

  /*

  var zeros = [];
  var groupSizes = [];
  var groupBases = [];

  var s = '';
  var i = -1;
  while (++i < BN.wordSize) {
    zeros[i] = s;
    s += '0';
  }
  groupSizes[0] = 0;
  groupSizes[1] = 0;
  groupBases[0] = 0;
  groupBases[1] = 0;
  var base = 2 - 1;
  while (++base < 36 + 1) {
    var groupSize = 0;
    var groupBase = 1;
    while (groupBase < (1 << BN.wordSize) / base) {
      groupBase *= base;
      groupSize += 1;
    }
    groupSizes[base] = groupSize;
    groupBases[base] = groupBase;
  }

  */

  var zeros = [
    '',
    '0',
    '00',
    '000',
    '0000',
    '00000',
    '000000',
    '0000000',
    '00000000',
    '000000000',
    '0000000000',
    '00000000000',
    '000000000000',
    '0000000000000',
    '00000000000000',
    '000000000000000',
    '0000000000000000',
    '00000000000000000',
    '000000000000000000',
    '0000000000000000000',
    '00000000000000000000',
    '000000000000000000000',
    '0000000000000000000000',
    '00000000000000000000000',
    '000000000000000000000000',
    '0000000000000000000000000'
  ];

  var groupSizes = [
    0, 0,
    25, 16, 12, 11, 10, 9, 8,
    8, 7, 7, 7, 7, 6, 6,
    6, 6, 6, 6, 6, 5, 5,
    5, 5, 5, 5, 5, 5, 5,
    5, 5, 5, 5, 5, 5, 5
  ];

  var groupBases = [
    0, 0,
    33554432, 43046721, 16777216, 48828125, 60466176, 40353607, 16777216,
    43046721, 10000000, 19487171, 35831808, 62748517, 7529536, 11390625,
    16777216, 24137569, 34012224, 47045881, 64000000, 4084101, 5153632,
    6436343, 7962624, 9765625, 11881376, 14348907, 17210368, 20511149,
    24300000, 28629151, 33554432, 39135393, 45435424, 52521875, 60466176
  ];

  BN.prototype.toString = function toString (base, padding) {
    base = base || 10;
    padding = padding | 0 || 1;

    var out;
    if (base === 16 || base === 'hex') {
      out = '';
      var off = 0;
      var carry = 0;
      for (var i = 0; i < this.length; i++) {
        var w = this.words[i];
        var word = (((w << off) | carry) & 0xffffff).toString(16);
        carry = (w >>> (24 - off)) & 0xffffff;
        if (carry !== 0 || i !== this.length - 1) {
          out = zeros[6 - word.length] + word + out;
        } else {
          out = word + out;
        }
        off += 2;
        if (off >= 26) {
          off -= 26;
          i--;
        }
      }
      if (carry !== 0) {
        out = carry.toString(16) + out;
      }
      while (out.length % padding !== 0) {
        out = '0' + out;
      }
      if (this.negative !== 0) {
        out = '-' + out;
      }
      return out;
    }

    if (base === (base | 0) && base >= 2 && base <= 36) {
      // var groupSize = Math.floor(BN.wordSize * Math.LN2 / Math.log(base));
      var groupSize = groupSizes[base];
      // var groupBase = Math.pow(base, groupSize);
      var groupBase = groupBases[base];
      out = '';
      var c = this.clone();
      c.negative = 0;
      while (!c.isZero()) {
        var r = c.modrn(groupBase).toString(base);
        c = c.idivn(groupBase);

        if (!c.isZero()) {
          out = zeros[groupSize - r.length] + r + out;
        } else {
          out = r + out;
        }
      }
      if (this.isZero()) {
        out = '0' + out;
      }
      while (out.length % padding !== 0) {
        out = '0' + out;
      }
      if (this.negative !== 0) {
        out = '-' + out;
      }
      return out;
    }

    assert(false, 'Base should be between 2 and 36');
  };

  BN.prototype.toNumber = function toNumber () {
    var ret = this.words[0];
    if (this.length === 2) {
      ret += this.words[1] * 0x4000000;
    } else if (this.length === 3 && this.words[2] === 0x01) {
      // NOTE: at this stage it is known that the top bit is set
      ret += 0x10000000000000 + (this.words[1] * 0x4000000);
    } else if (this.length > 2) {
      assert(false, 'Number can only safely store up to 53 bits');
    }
    return (this.negative !== 0) ? -ret : ret;
  };

  BN.prototype.toJSON = function toJSON () {
    return this.toString(16, 2);
  };

  if (Buffer) {
    BN.prototype.toBuffer = function toBuffer (endian, length) {
      return this.toArrayLike(Buffer, endian, length);
    };
  }

  BN.prototype.toArray = function toArray (endian, length) {
    return this.toArrayLike(Array, endian, length);
  };

  var allocate = function allocate (ArrayType, size) {
    if (ArrayType.allocUnsafe) {
      return ArrayType.allocUnsafe(size);
    }
    return new ArrayType(size);
  };

  BN.prototype.toArrayLike = function toArrayLike (ArrayType, endian, length) {
    this._strip();

    var byteLength = this.byteLength();
    var reqLength = length || Math.max(1, byteLength);
    assert(byteLength <= reqLength, 'byte array longer than desired length');
    assert(reqLength > 0, 'Requested array length <= 0');

    var res = allocate(ArrayType, reqLength);
    var postfix = endian === 'le' ? 'LE' : 'BE';
    this['_toArrayLike' + postfix](res, byteLength);
    return res;
  };

  BN.prototype._toArrayLikeLE = function _toArrayLikeLE (res, byteLength) {
    var position = 0;
    var carry = 0;

    for (var i = 0, shift = 0; i < this.length; i++) {
      var word = (this.words[i] << shift) | carry;

      res[position++] = word & 0xff;
      if (position < res.length) {
        res[position++] = (word >> 8) & 0xff;
      }
      if (position < res.length) {
        res[position++] = (word >> 16) & 0xff;
      }

      if (shift === 6) {
        if (position < res.length) {
          res[position++] = (word >> 24) & 0xff;
        }
        carry = 0;
        shift = 0;
      } else {
        carry = word >>> 24;
        shift += 2;
      }
    }

    if (position < res.length) {
      res[position++] = carry;

      while (position < res.length) {
        res[position++] = 0;
      }
    }
  };

  BN.prototype._toArrayLikeBE = function _toArrayLikeBE (res, byteLength) {
    var position = res.length - 1;
    var carry = 0;

    for (var i = 0, shift = 0; i < this.length; i++) {
      var word = (this.words[i] << shift) | carry;

      res[position--] = word & 0xff;
      if (position >= 0) {
        res[position--] = (word >> 8) & 0xff;
      }
      if (position >= 0) {
        res[position--] = (word >> 16) & 0xff;
      }

      if (shift === 6) {
        if (position >= 0) {
          res[position--] = (word >> 24) & 0xff;
        }
        carry = 0;
        shift = 0;
      } else {
        carry = word >>> 24;
        shift += 2;
      }
    }

    if (position >= 0) {
      res[position--] = carry;

      while (position >= 0) {
        res[position--] = 0;
      }
    }
  };

  if (Math.clz32) {
    BN.prototype._countBits = function _countBits (w) {
      return 32 - Math.clz32(w);
    };
  } else {
    BN.prototype._countBits = function _countBits (w) {
      var t = w;
      var r = 0;
      if (t >= 0x1000) {
        r += 13;
        t >>>= 13;
      }
      if (t >= 0x40) {
        r += 7;
        t >>>= 7;
      }
      if (t >= 0x8) {
        r += 4;
        t >>>= 4;
      }
      if (t >= 0x02) {
        r += 2;
        t >>>= 2;
      }
      return r + t;
    };
  }

  BN.prototype._zeroBits = function _zeroBits (w) {
    // Short-cut
    if (w === 0) return 26;

    var t = w;
    var r = 0;
    if ((t & 0x1fff) === 0) {
      r += 13;
      t >>>= 13;
    }
    if ((t & 0x7f) === 0) {
      r += 7;
      t >>>= 7;
    }
    if ((t & 0xf) === 0) {
      r += 4;
      t >>>= 4;
    }
    if ((t & 0x3) === 0) {
      r += 2;
      t >>>= 2;
    }
    if ((t & 0x1) === 0) {
      r++;
    }
    return r;
  };

  // Return number of used bits in a BN
  BN.prototype.bitLength = function bitLength () {
    var w = this.words[this.length - 1];
    var hi = this._countBits(w);
    return (this.length - 1) * 26 + hi;
  };

  function toBitArray (num) {
    var w = new Array(num.bitLength());

    for (var bit = 0; bit < w.length; bit++) {
      var off = (bit / 26) | 0;
      var wbit = bit % 26;

      w[bit] = (num.words[off] >>> wbit) & 0x01;
    }

    return w;
  }

  // Number of trailing zero bits
  BN.prototype.zeroBits = function zeroBits () {
    if (this.isZero()) return 0;

    var r = 0;
    for (var i = 0; i < this.length; i++) {
      var b = this._zeroBits(this.words[i]);
      r += b;
      if (b !== 26) break;
    }
    return r;
  };

  BN.prototype.byteLength = function byteLength () {
    return Math.ceil(this.bitLength() / 8);
  };

  BN.prototype.toTwos = function toTwos (width) {
    if (this.negative !== 0) {
      return this.abs().inotn(width).iaddn(1);
    }
    return this.clone();
  };

  BN.prototype.fromTwos = function fromTwos (width) {
    if (this.testn(width - 1)) {
      return this.notn(width).iaddn(1).ineg();
    }
    return this.clone();
  };

  BN.prototype.isNeg = function isNeg () {
    return this.negative !== 0;
  };

  // Return negative clone of `this`
  BN.prototype.neg = function neg () {
    return this.clone().ineg();
  };

  BN.prototype.ineg = function ineg () {
    if (!this.isZero()) {
      this.negative ^= 1;
    }

    return this;
  };

  // Or `num` with `this` in-place
  BN.prototype.iuor = function iuor (num) {
    while (this.length < num.length) {
      this.words[this.length++] = 0;
    }

    for (var i = 0; i < num.length; i++) {
      this.words[i] = this.words[i] | num.words[i];
    }

    return this._strip();
  };

  BN.prototype.ior = function ior (num) {
    assert((this.negative | num.negative) === 0);
    return this.iuor(num);
  };

  // Or `num` with `this`
  BN.prototype.or = function or (num) {
    if (this.length > num.length) return this.clone().ior(num);
    return num.clone().ior(this);
  };

  BN.prototype.uor = function uor (num) {
    if (this.length > num.length) return this.clone().iuor(num);
    return num.clone().iuor(this);
  };

  // And `num` with `this` in-place
  BN.prototype.iuand = function iuand (num) {
    // b = min-length(num, this)
    var b;
    if (this.length > num.length) {
      b = num;
    } else {
      b = this;
    }

    for (var i = 0; i < b.length; i++) {
      this.words[i] = this.words[i] & num.words[i];
    }

    this.length = b.length;

    return this._strip();
  };

  BN.prototype.iand = function iand (num) {
    assert((this.negative | num.negative) === 0);
    return this.iuand(num);
  };

  // And `num` with `this`
  BN.prototype.and = function and (num) {
    if (this.length > num.length) return this.clone().iand(num);
    return num.clone().iand(this);
  };

  BN.prototype.uand = function uand (num) {
    if (this.length > num.length) return this.clone().iuand(num);
    return num.clone().iuand(this);
  };

  // Xor `num` with `this` in-place
  BN.prototype.iuxor = function iuxor (num) {
    // a.length > b.length
    var a;
    var b;
    if (this.length > num.length) {
      a = this;
      b = num;
    } else {
      a = num;
      b = this;
    }

    for (var i = 0; i < b.length; i++) {
      this.words[i] = a.words[i] ^ b.words[i];
    }

    if (this !== a) {
      for (; i < a.length; i++) {
        this.words[i] = a.words[i];
      }
    }

    this.length = a.length;

    return this._strip();
  };

  BN.prototype.ixor = function ixor (num) {
    assert((this.negative | num.negative) === 0);
    return this.iuxor(num);
  };

  // Xor `num` with `this`
  BN.prototype.xor = function xor (num) {
    if (this.length > num.length) return this.clone().ixor(num);
    return num.clone().ixor(this);
  };

  BN.prototype.uxor = function uxor (num) {
    if (this.length > num.length) return this.clone().iuxor(num);
    return num.clone().iuxor(this);
  };

  // Not ``this`` with ``width`` bitwidth
  BN.prototype.inotn = function inotn (width) {
    assert(typeof width === 'number' && width >= 0);

    var bytesNeeded = Math.ceil(width / 26) | 0;
    var bitsLeft = width % 26;

    // Extend the buffer with leading zeroes
    this._expand(bytesNeeded);

    if (bitsLeft > 0) {
      bytesNeeded--;
    }

    // Handle complete words
    for (var i = 0; i < bytesNeeded; i++) {
      this.words[i] = ~this.words[i] & 0x3ffffff;
    }

    // Handle the residue
    if (bitsLeft > 0) {
      this.words[i] = ~this.words[i] & (0x3ffffff >> (26 - bitsLeft));
    }

    // And remove leading zeroes
    return this._strip();
  };

  BN.prototype.notn = function notn (width) {
    return this.clone().inotn(width);
  };

  // Set `bit` of `this`
  BN.prototype.setn = function setn (bit, val) {
    assert(typeof bit === 'number' && bit >= 0);

    var off = (bit / 26) | 0;
    var wbit = bit % 26;

    this._expand(off + 1);

    if (val) {
      this.words[off] = this.words[off] | (1 << wbit);
    } else {
      this.words[off] = this.words[off] & ~(1 << wbit);
    }

    return this._strip();
  };

  // Add `num` to `this` in-place
  BN.prototype.iadd = function iadd (num) {
    var r;

    // negative + positive
    if (this.negative !== 0 && num.negative === 0) {
      this.negative = 0;
      r = this.isub(num);
      this.negative ^= 1;
      return this._normSign();

    // positive + negative
    } else if (this.negative === 0 && num.negative !== 0) {
      num.negative = 0;
      r = this.isub(num);
      num.negative = 1;
      return r._normSign();
    }

    // a.length > b.length
    var a, b;
    if (this.length > num.length) {
      a = this;
      b = num;
    } else {
      a = num;
      b = this;
    }

    var carry = 0;
    for (var i = 0; i < b.length; i++) {
      r = (a.words[i] | 0) + (b.words[i] | 0) + carry;
      this.words[i] = r & 0x3ffffff;
      carry = r >>> 26;
    }
    for (; carry !== 0 && i < a.length; i++) {
      r = (a.words[i] | 0) + carry;
      this.words[i] = r & 0x3ffffff;
      carry = r >>> 26;
    }

    this.length = a.length;
    if (carry !== 0) {
      this.words[this.length] = carry;
      this.length++;
    // Copy the rest of the words
    } else if (a !== this) {
      for (; i < a.length; i++) {
        this.words[i] = a.words[i];
      }
    }

    return this;
  };

  // Add `num` to `this`
  BN.prototype.add = function add (num) {
    var res;
    if (num.negative !== 0 && this.negative === 0) {
      num.negative = 0;
      res = this.sub(num);
      num.negative ^= 1;
      return res;
    } else if (num.negative === 0 && this.negative !== 0) {
      this.negative = 0;
      res = num.sub(this);
      this.negative = 1;
      return res;
    }

    if (this.length > num.length) return this.clone().iadd(num);

    return num.clone().iadd(this);
  };

  // Subtract `num` from `this` in-place
  BN.prototype.isub = function isub (num) {
    // this - (-num) = this + num
    if (num.negative !== 0) {
      num.negative = 0;
      var r = this.iadd(num);
      num.negative = 1;
      return r._normSign();

    // -this - num = -(this + num)
    } else if (this.negative !== 0) {
      this.negative = 0;
      this.iadd(num);
      this.negative = 1;
      return this._normSign();
    }

    // At this point both numbers are positive
    var cmp = this.cmp(num);

    // Optimization - zeroify
    if (cmp === 0) {
      this.negative = 0;
      this.length = 1;
      this.words[0] = 0;
      return this;
    }

    // a > b
    var a, b;
    if (cmp > 0) {
      a = this;
      b = num;
    } else {
      a = num;
      b = this;
    }

    var carry = 0;
    for (var i = 0; i < b.length; i++) {
      r = (a.words[i] | 0) - (b.words[i] | 0) + carry;
      carry = r >> 26;
      this.words[i] = r & 0x3ffffff;
    }
    for (; carry !== 0 && i < a.length; i++) {
      r = (a.words[i] | 0) + carry;
      carry = r >> 26;
      this.words[i] = r & 0x3ffffff;
    }

    // Copy rest of the words
    if (carry === 0 && i < a.length && a !== this) {
      for (; i < a.length; i++) {
        this.words[i] = a.words[i];
      }
    }

    this.length = Math.max(this.length, i);

    if (a !== this) {
      this.negative = 1;
    }

    return this._strip();
  };

  // Subtract `num` from `this`
  BN.prototype.sub = function sub (num) {
    return this.clone().isub(num);
  };

  function smallMulTo (self, num, out) {
    out.negative = num.negative ^ self.negative;
    var len = (self.length + num.length) | 0;
    out.length = len;
    len = (len - 1) | 0;

    // Peel one iteration (compiler can't do it, because of code complexity)
    var a = self.words[0] | 0;
    var b = num.words[0] | 0;
    var r = a * b;

    var lo = r & 0x3ffffff;
    var carry = (r / 0x4000000) | 0;
    out.words[0] = lo;

    for (var k = 1; k < len; k++) {
      // Sum all words with the same `i + j = k` and accumulate `ncarry`,
      // note that ncarry could be >= 0x3ffffff
      var ncarry = carry >>> 26;
      var rword = carry & 0x3ffffff;
      var maxJ = Math.min(k, num.length - 1);
      for (var j = Math.max(0, k - self.length + 1); j <= maxJ; j++) {
        var i = (k - j) | 0;
        a = self.words[i] | 0;
        b = num.words[j] | 0;
        r = a * b + rword;
        ncarry += (r / 0x4000000) | 0;
        rword = r & 0x3ffffff;
      }
      out.words[k] = rword | 0;
      carry = ncarry | 0;
    }
    if (carry !== 0) {
      out.words[k] = carry | 0;
    } else {
      out.length--;
    }

    return out._strip();
  }

  // TODO(indutny): it may be reasonable to omit it for users who don't need
  // to work with 256-bit numbers, otherwise it gives 20% improvement for 256-bit
  // multiplication (like elliptic secp256k1).
  var comb10MulTo = function comb10MulTo (self, num, out) {
    var a = self.words;
    var b = num.words;
    var o = out.words;
    var c = 0;
    var lo;
    var mid;
    var hi;
    var a0 = a[0] | 0;
    var al0 = a0 & 0x1fff;
    var ah0 = a0 >>> 13;
    var a1 = a[1] | 0;
    var al1 = a1 & 0x1fff;
    var ah1 = a1 >>> 13;
    var a2 = a[2] | 0;
    var al2 = a2 & 0x1fff;
    var ah2 = a2 >>> 13;
    var a3 = a[3] | 0;
    var al3 = a3 & 0x1fff;
    var ah3 = a3 >>> 13;
    var a4 = a[4] | 0;
    var al4 = a4 & 0x1fff;
    var ah4 = a4 >>> 13;
    var a5 = a[5] | 0;
    var al5 = a5 & 0x1fff;
    var ah5 = a5 >>> 13;
    var a6 = a[6] | 0;
    var al6 = a6 & 0x1fff;
    var ah6 = a6 >>> 13;
    var a7 = a[7] | 0;
    var al7 = a7 & 0x1fff;
    var ah7 = a7 >>> 13;
    var a8 = a[8] | 0;
    var al8 = a8 & 0x1fff;
    var ah8 = a8 >>> 13;
    var a9 = a[9] | 0;
    var al9 = a9 & 0x1fff;
    var ah9 = a9 >>> 13;
    var b0 = b[0] | 0;
    var bl0 = b0 & 0x1fff;
    var bh0 = b0 >>> 13;
    var b1 = b[1] | 0;
    var bl1 = b1 & 0x1fff;
    var bh1 = b1 >>> 13;
    var b2 = b[2] | 0;
    var bl2 = b2 & 0x1fff;
    var bh2 = b2 >>> 13;
    var b3 = b[3] | 0;
    var bl3 = b3 & 0x1fff;
    var bh3 = b3 >>> 13;
    var b4 = b[4] | 0;
    var bl4 = b4 & 0x1fff;
    var bh4 = b4 >>> 13;
    var b5 = b[5] | 0;
    var bl5 = b5 & 0x1fff;
    var bh5 = b5 >>> 13;
    var b6 = b[6] | 0;
    var bl6 = b6 & 0x1fff;
    var bh6 = b6 >>> 13;
    var b7 = b[7] | 0;
    var bl7 = b7 & 0x1fff;
    var bh7 = b7 >>> 13;
    var b8 = b[8] | 0;
    var bl8 = b8 & 0x1fff;
    var bh8 = b8 >>> 13;
    var b9 = b[9] | 0;
    var bl9 = b9 & 0x1fff;
    var bh9 = b9 >>> 13;

    out.negative = self.negative ^ num.negative;
    out.length = 19;
    /* k = 0 */
    lo = Math.imul(al0, bl0);
    mid = Math.imul(al0, bh0);
    mid = (mid + Math.imul(ah0, bl0)) | 0;
    hi = Math.imul(ah0, bh0);
    var w0 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w0 >>> 26)) | 0;
    w0 &= 0x3ffffff;
    /* k = 1 */
    lo = Math.imul(al1, bl0);
    mid = Math.imul(al1, bh0);
    mid = (mid + Math.imul(ah1, bl0)) | 0;
    hi = Math.imul(ah1, bh0);
    lo = (lo + Math.imul(al0, bl1)) | 0;
    mid = (mid + Math.imul(al0, bh1)) | 0;
    mid = (mid + Math.imul(ah0, bl1)) | 0;
    hi = (hi + Math.imul(ah0, bh1)) | 0;
    var w1 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w1 >>> 26)) | 0;
    w1 &= 0x3ffffff;
    /* k = 2 */
    lo = Math.imul(al2, bl0);
    mid = Math.imul(al2, bh0);
    mid = (mid + Math.imul(ah2, bl0)) | 0;
    hi = Math.imul(ah2, bh0);
    lo = (lo + Math.imul(al1, bl1)) | 0;
    mid = (mid + Math.imul(al1, bh1)) | 0;
    mid = (mid + Math.imul(ah1, bl1)) | 0;
    hi = (hi + Math.imul(ah1, bh1)) | 0;
    lo = (lo + Math.imul(al0, bl2)) | 0;
    mid = (mid + Math.imul(al0, bh2)) | 0;
    mid = (mid + Math.imul(ah0, bl2)) | 0;
    hi = (hi + Math.imul(ah0, bh2)) | 0;
    var w2 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w2 >>> 26)) | 0;
    w2 &= 0x3ffffff;
    /* k = 3 */
    lo = Math.imul(al3, bl0);
    mid = Math.imul(al3, bh0);
    mid = (mid + Math.imul(ah3, bl0)) | 0;
    hi = Math.imul(ah3, bh0);
    lo = (lo + Math.imul(al2, bl1)) | 0;
    mid = (mid + Math.imul(al2, bh1)) | 0;
    mid = (mid + Math.imul(ah2, bl1)) | 0;
    hi = (hi + Math.imul(ah2, bh1)) | 0;
    lo = (lo + Math.imul(al1, bl2)) | 0;
    mid = (mid + Math.imul(al1, bh2)) | 0;
    mid = (mid + Math.imul(ah1, bl2)) | 0;
    hi = (hi + Math.imul(ah1, bh2)) | 0;
    lo = (lo + Math.imul(al0, bl3)) | 0;
    mid = (mid + Math.imul(al0, bh3)) | 0;
    mid = (mid + Math.imul(ah0, bl3)) | 0;
    hi = (hi + Math.imul(ah0, bh3)) | 0;
    var w3 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w3 >>> 26)) | 0;
    w3 &= 0x3ffffff;
    /* k = 4 */
    lo = Math.imul(al4, bl0);
    mid = Math.imul(al4, bh0);
    mid = (mid + Math.imul(ah4, bl0)) | 0;
    hi = Math.imul(ah4, bh0);
    lo = (lo + Math.imul(al3, bl1)) | 0;
    mid = (mid + Math.imul(al3, bh1)) | 0;
    mid = (mid + Math.imul(ah3, bl1)) | 0;
    hi = (hi + Math.imul(ah3, bh1)) | 0;
    lo = (lo + Math.imul(al2, bl2)) | 0;
    mid = (mid + Math.imul(al2, bh2)) | 0;
    mid = (mid + Math.imul(ah2, bl2)) | 0;
    hi = (hi + Math.imul(ah2, bh2)) | 0;
    lo = (lo + Math.imul(al1, bl3)) | 0;
    mid = (mid + Math.imul(al1, bh3)) | 0;
    mid = (mid + Math.imul(ah1, bl3)) | 0;
    hi = (hi + Math.imul(ah1, bh3)) | 0;
    lo = (lo + Math.imul(al0, bl4)) | 0;
    mid = (mid + Math.imul(al0, bh4)) | 0;
    mid = (mid + Math.imul(ah0, bl4)) | 0;
    hi = (hi + Math.imul(ah0, bh4)) | 0;
    var w4 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w4 >>> 26)) | 0;
    w4 &= 0x3ffffff;
    /* k = 5 */
    lo = Math.imul(al5, bl0);
    mid = Math.imul(al5, bh0);
    mid = (mid + Math.imul(ah5, bl0)) | 0;
    hi = Math.imul(ah5, bh0);
    lo = (lo + Math.imul(al4, bl1)) | 0;
    mid = (mid + Math.imul(al4, bh1)) | 0;
    mid = (mid + Math.imul(ah4, bl1)) | 0;
    hi = (hi + Math.imul(ah4, bh1)) | 0;
    lo = (lo + Math.imul(al3, bl2)) | 0;
    mid = (mid + Math.imul(al3, bh2)) | 0;
    mid = (mid + Math.imul(ah3, bl2)) | 0;
    hi = (hi + Math.imul(ah3, bh2)) | 0;
    lo = (lo + Math.imul(al2, bl3)) | 0;
    mid = (mid + Math.imul(al2, bh3)) | 0;
    mid = (mid + Math.imul(ah2, bl3)) | 0;
    hi = (hi + Math.imul(ah2, bh3)) | 0;
    lo = (lo + Math.imul(al1, bl4)) | 0;
    mid = (mid + Math.imul(al1, bh4)) | 0;
    mid = (mid + Math.imul(ah1, bl4)) | 0;
    hi = (hi + Math.imul(ah1, bh4)) | 0;
    lo = (lo + Math.imul(al0, bl5)) | 0;
    mid = (mid + Math.imul(al0, bh5)) | 0;
    mid = (mid + Math.imul(ah0, bl5)) | 0;
    hi = (hi + Math.imul(ah0, bh5)) | 0;
    var w5 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w5 >>> 26)) | 0;
    w5 &= 0x3ffffff;
    /* k = 6 */
    lo = Math.imul(al6, bl0);
    mid = Math.imul(al6, bh0);
    mid = (mid + Math.imul(ah6, bl0)) | 0;
    hi = Math.imul(ah6, bh0);
    lo = (lo + Math.imul(al5, bl1)) | 0;
    mid = (mid + Math.imul(al5, bh1)) | 0;
    mid = (mid + Math.imul(ah5, bl1)) | 0;
    hi = (hi + Math.imul(ah5, bh1)) | 0;
    lo = (lo + Math.imul(al4, bl2)) | 0;
    mid = (mid + Math.imul(al4, bh2)) | 0;
    mid = (mid + Math.imul(ah4, bl2)) | 0;
    hi = (hi + Math.imul(ah4, bh2)) | 0;
    lo = (lo + Math.imul(al3, bl3)) | 0;
    mid = (mid + Math.imul(al3, bh3)) | 0;
    mid = (mid + Math.imul(ah3, bl3)) | 0;
    hi = (hi + Math.imul(ah3, bh3)) | 0;
    lo = (lo + Math.imul(al2, bl4)) | 0;
    mid = (mid + Math.imul(al2, bh4)) | 0;
    mid = (mid + Math.imul(ah2, bl4)) | 0;
    hi = (hi + Math.imul(ah2, bh4)) | 0;
    lo = (lo + Math.imul(al1, bl5)) | 0;
    mid = (mid + Math.imul(al1, bh5)) | 0;
    mid = (mid + Math.imul(ah1, bl5)) | 0;
    hi = (hi + Math.imul(ah1, bh5)) | 0;
    lo = (lo + Math.imul(al0, bl6)) | 0;
    mid = (mid + Math.imul(al0, bh6)) | 0;
    mid = (mid + Math.imul(ah0, bl6)) | 0;
    hi = (hi + Math.imul(ah0, bh6)) | 0;
    var w6 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w6 >>> 26)) | 0;
    w6 &= 0x3ffffff;
    /* k = 7 */
    lo = Math.imul(al7, bl0);
    mid = Math.imul(al7, bh0);
    mid = (mid + Math.imul(ah7, bl0)) | 0;
    hi = Math.imul(ah7, bh0);
    lo = (lo + Math.imul(al6, bl1)) | 0;
    mid = (mid + Math.imul(al6, bh1)) | 0;
    mid = (mid + Math.imul(ah6, bl1)) | 0;
    hi = (hi + Math.imul(ah6, bh1)) | 0;
    lo = (lo + Math.imul(al5, bl2)) | 0;
    mid = (mid + Math.imul(al5, bh2)) | 0;
    mid = (mid + Math.imul(ah5, bl2)) | 0;
    hi = (hi + Math.imul(ah5, bh2)) | 0;
    lo = (lo + Math.imul(al4, bl3)) | 0;
    mid = (mid + Math.imul(al4, bh3)) | 0;
    mid = (mid + Math.imul(ah4, bl3)) | 0;
    hi = (hi + Math.imul(ah4, bh3)) | 0;
    lo = (lo + Math.imul(al3, bl4)) | 0;
    mid = (mid + Math.imul(al3, bh4)) | 0;
    mid = (mid + Math.imul(ah3, bl4)) | 0;
    hi = (hi + Math.imul(ah3, bh4)) | 0;
    lo = (lo + Math.imul(al2, bl5)) | 0;
    mid = (mid + Math.imul(al2, bh5)) | 0;
    mid = (mid + Math.imul(ah2, bl5)) | 0;
    hi = (hi + Math.imul(ah2, bh5)) | 0;
    lo = (lo + Math.imul(al1, bl6)) | 0;
    mid = (mid + Math.imul(al1, bh6)) | 0;
    mid = (mid + Math.imul(ah1, bl6)) | 0;
    hi = (hi + Math.imul(ah1, bh6)) | 0;
    lo = (lo + Math.imul(al0, bl7)) | 0;
    mid = (mid + Math.imul(al0, bh7)) | 0;
    mid = (mid + Math.imul(ah0, bl7)) | 0;
    hi = (hi + Math.imul(ah0, bh7)) | 0;
    var w7 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w7 >>> 26)) | 0;
    w7 &= 0x3ffffff;
    /* k = 8 */
    lo = Math.imul(al8, bl0);
    mid = Math.imul(al8, bh0);
    mid = (mid + Math.imul(ah8, bl0)) | 0;
    hi = Math.imul(ah8, bh0);
    lo = (lo + Math.imul(al7, bl1)) | 0;
    mid = (mid + Math.imul(al7, bh1)) | 0;
    mid = (mid + Math.imul(ah7, bl1)) | 0;
    hi = (hi + Math.imul(ah7, bh1)) | 0;
    lo = (lo + Math.imul(al6, bl2)) | 0;
    mid = (mid + Math.imul(al6, bh2)) | 0;
    mid = (mid + Math.imul(ah6, bl2)) | 0;
    hi = (hi + Math.imul(ah6, bh2)) | 0;
    lo = (lo + Math.imul(al5, bl3)) | 0;
    mid = (mid + Math.imul(al5, bh3)) | 0;
    mid = (mid + Math.imul(ah5, bl3)) | 0;
    hi = (hi + Math.imul(ah5, bh3)) | 0;
    lo = (lo + Math.imul(al4, bl4)) | 0;
    mid = (mid + Math.imul(al4, bh4)) | 0;
    mid = (mid + Math.imul(ah4, bl4)) | 0;
    hi = (hi + Math.imul(ah4, bh4)) | 0;
    lo = (lo + Math.imul(al3, bl5)) | 0;
    mid = (mid + Math.imul(al3, bh5)) | 0;
    mid = (mid + Math.imul(ah3, bl5)) | 0;
    hi = (hi + Math.imul(ah3, bh5)) | 0;
    lo = (lo + Math.imul(al2, bl6)) | 0;
    mid = (mid + Math.imul(al2, bh6)) | 0;
    mid = (mid + Math.imul(ah2, bl6)) | 0;
    hi = (hi + Math.imul(ah2, bh6)) | 0;
    lo = (lo + Math.imul(al1, bl7)) | 0;
    mid = (mid + Math.imul(al1, bh7)) | 0;
    mid = (mid + Math.imul(ah1, bl7)) | 0;
    hi = (hi + Math.imul(ah1, bh7)) | 0;
    lo = (lo + Math.imul(al0, bl8)) | 0;
    mid = (mid + Math.imul(al0, bh8)) | 0;
    mid = (mid + Math.imul(ah0, bl8)) | 0;
    hi = (hi + Math.imul(ah0, bh8)) | 0;
    var w8 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w8 >>> 26)) | 0;
    w8 &= 0x3ffffff;
    /* k = 9 */
    lo = Math.imul(al9, bl0);
    mid = Math.imul(al9, bh0);
    mid = (mid + Math.imul(ah9, bl0)) | 0;
    hi = Math.imul(ah9, bh0);
    lo = (lo + Math.imul(al8, bl1)) | 0;
    mid = (mid + Math.imul(al8, bh1)) | 0;
    mid = (mid + Math.imul(ah8, bl1)) | 0;
    hi = (hi + Math.imul(ah8, bh1)) | 0;
    lo = (lo + Math.imul(al7, bl2)) | 0;
    mid = (mid + Math.imul(al7, bh2)) | 0;
    mid = (mid + Math.imul(ah7, bl2)) | 0;
    hi = (hi + Math.imul(ah7, bh2)) | 0;
    lo = (lo + Math.imul(al6, bl3)) | 0;
    mid = (mid + Math.imul(al6, bh3)) | 0;
    mid = (mid + Math.imul(ah6, bl3)) | 0;
    hi = (hi + Math.imul(ah6, bh3)) | 0;
    lo = (lo + Math.imul(al5, bl4)) | 0;
    mid = (mid + Math.imul(al5, bh4)) | 0;
    mid = (mid + Math.imul(ah5, bl4)) | 0;
    hi = (hi + Math.imul(ah5, bh4)) | 0;
    lo = (lo + Math.imul(al4, bl5)) | 0;
    mid = (mid + Math.imul(al4, bh5)) | 0;
    mid = (mid + Math.imul(ah4, bl5)) | 0;
    hi = (hi + Math.imul(ah4, bh5)) | 0;
    lo = (lo + Math.imul(al3, bl6)) | 0;
    mid = (mid + Math.imul(al3, bh6)) | 0;
    mid = (mid + Math.imul(ah3, bl6)) | 0;
    hi = (hi + Math.imul(ah3, bh6)) | 0;
    lo = (lo + Math.imul(al2, bl7)) | 0;
    mid = (mid + Math.imul(al2, bh7)) | 0;
    mid = (mid + Math.imul(ah2, bl7)) | 0;
    hi = (hi + Math.imul(ah2, bh7)) | 0;
    lo = (lo + Math.imul(al1, bl8)) | 0;
    mid = (mid + Math.imul(al1, bh8)) | 0;
    mid = (mid + Math.imul(ah1, bl8)) | 0;
    hi = (hi + Math.imul(ah1, bh8)) | 0;
    lo = (lo + Math.imul(al0, bl9)) | 0;
    mid = (mid + Math.imul(al0, bh9)) | 0;
    mid = (mid + Math.imul(ah0, bl9)) | 0;
    hi = (hi + Math.imul(ah0, bh9)) | 0;
    var w9 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w9 >>> 26)) | 0;
    w9 &= 0x3ffffff;
    /* k = 10 */
    lo = Math.imul(al9, bl1);
    mid = Math.imul(al9, bh1);
    mid = (mid + Math.imul(ah9, bl1)) | 0;
    hi = Math.imul(ah9, bh1);
    lo = (lo + Math.imul(al8, bl2)) | 0;
    mid = (mid + Math.imul(al8, bh2)) | 0;
    mid = (mid + Math.imul(ah8, bl2)) | 0;
    hi = (hi + Math.imul(ah8, bh2)) | 0;
    lo = (lo + Math.imul(al7, bl3)) | 0;
    mid = (mid + Math.imul(al7, bh3)) | 0;
    mid = (mid + Math.imul(ah7, bl3)) | 0;
    hi = (hi + Math.imul(ah7, bh3)) | 0;
    lo = (lo + Math.imul(al6, bl4)) | 0;
    mid = (mid + Math.imul(al6, bh4)) | 0;
    mid = (mid + Math.imul(ah6, bl4)) | 0;
    hi = (hi + Math.imul(ah6, bh4)) | 0;
    lo = (lo + Math.imul(al5, bl5)) | 0;
    mid = (mid + Math.imul(al5, bh5)) | 0;
    mid = (mid + Math.imul(ah5, bl5)) | 0;
    hi = (hi + Math.imul(ah5, bh5)) | 0;
    lo = (lo + Math.imul(al4, bl6)) | 0;
    mid = (mid + Math.imul(al4, bh6)) | 0;
    mid = (mid + Math.imul(ah4, bl6)) | 0;
    hi = (hi + Math.imul(ah4, bh6)) | 0;
    lo = (lo + Math.imul(al3, bl7)) | 0;
    mid = (mid + Math.imul(al3, bh7)) | 0;
    mid = (mid + Math.imul(ah3, bl7)) | 0;
    hi = (hi + Math.imul(ah3, bh7)) | 0;
    lo = (lo + Math.imul(al2, bl8)) | 0;
    mid = (mid + Math.imul(al2, bh8)) | 0;
    mid = (mid + Math.imul(ah2, bl8)) | 0;
    hi = (hi + Math.imul(ah2, bh8)) | 0;
    lo = (lo + Math.imul(al1, bl9)) | 0;
    mid = (mid + Math.imul(al1, bh9)) | 0;
    mid = (mid + Math.imul(ah1, bl9)) | 0;
    hi = (hi + Math.imul(ah1, bh9)) | 0;
    var w10 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w10 >>> 26)) | 0;
    w10 &= 0x3ffffff;
    /* k = 11 */
    lo = Math.imul(al9, bl2);
    mid = Math.imul(al9, bh2);
    mid = (mid + Math.imul(ah9, bl2)) | 0;
    hi = Math.imul(ah9, bh2);
    lo = (lo + Math.imul(al8, bl3)) | 0;
    mid = (mid + Math.imul(al8, bh3)) | 0;
    mid = (mid + Math.imul(ah8, bl3)) | 0;
    hi = (hi + Math.imul(ah8, bh3)) | 0;
    lo = (lo + Math.imul(al7, bl4)) | 0;
    mid = (mid + Math.imul(al7, bh4)) | 0;
    mid = (mid + Math.imul(ah7, bl4)) | 0;
    hi = (hi + Math.imul(ah7, bh4)) | 0;
    lo = (lo + Math.imul(al6, bl5)) | 0;
    mid = (mid + Math.imul(al6, bh5)) | 0;
    mid = (mid + Math.imul(ah6, bl5)) | 0;
    hi = (hi + Math.imul(ah6, bh5)) | 0;
    lo = (lo + Math.imul(al5, bl6)) | 0;
    mid = (mid + Math.imul(al5, bh6)) | 0;
    mid = (mid + Math.imul(ah5, bl6)) | 0;
    hi = (hi + Math.imul(ah5, bh6)) | 0;
    lo = (lo + Math.imul(al4, bl7)) | 0;
    mid = (mid + Math.imul(al4, bh7)) | 0;
    mid = (mid + Math.imul(ah4, bl7)) | 0;
    hi = (hi + Math.imul(ah4, bh7)) | 0;
    lo = (lo + Math.imul(al3, bl8)) | 0;
    mid = (mid + Math.imul(al3, bh8)) | 0;
    mid = (mid + Math.imul(ah3, bl8)) | 0;
    hi = (hi + Math.imul(ah3, bh8)) | 0;
    lo = (lo + Math.imul(al2, bl9)) | 0;
    mid = (mid + Math.imul(al2, bh9)) | 0;
    mid = (mid + Math.imul(ah2, bl9)) | 0;
    hi = (hi + Math.imul(ah2, bh9)) | 0;
    var w11 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w11 >>> 26)) | 0;
    w11 &= 0x3ffffff;
    /* k = 12 */
    lo = Math.imul(al9, bl3);
    mid = Math.imul(al9, bh3);
    mid = (mid + Math.imul(ah9, bl3)) | 0;
    hi = Math.imul(ah9, bh3);
    lo = (lo + Math.imul(al8, bl4)) | 0;
    mid = (mid + Math.imul(al8, bh4)) | 0;
    mid = (mid + Math.imul(ah8, bl4)) | 0;
    hi = (hi + Math.imul(ah8, bh4)) | 0;
    lo = (lo + Math.imul(al7, bl5)) | 0;
    mid = (mid + Math.imul(al7, bh5)) | 0;
    mid = (mid + Math.imul(ah7, bl5)) | 0;
    hi = (hi + Math.imul(ah7, bh5)) | 0;
    lo = (lo + Math.imul(al6, bl6)) | 0;
    mid = (mid + Math.imul(al6, bh6)) | 0;
    mid = (mid + Math.imul(ah6, bl6)) | 0;
    hi = (hi + Math.imul(ah6, bh6)) | 0;
    lo = (lo + Math.imul(al5, bl7)) | 0;
    mid = (mid + Math.imul(al5, bh7)) | 0;
    mid = (mid + Math.imul(ah5, bl7)) | 0;
    hi = (hi + Math.imul(ah5, bh7)) | 0;
    lo = (lo + Math.imul(al4, bl8)) | 0;
    mid = (mid + Math.imul(al4, bh8)) | 0;
    mid = (mid + Math.imul(ah4, bl8)) | 0;
    hi = (hi + Math.imul(ah4, bh8)) | 0;
    lo = (lo + Math.imul(al3, bl9)) | 0;
    mid = (mid + Math.imul(al3, bh9)) | 0;
    mid = (mid + Math.imul(ah3, bl9)) | 0;
    hi = (hi + Math.imul(ah3, bh9)) | 0;
    var w12 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w12 >>> 26)) | 0;
    w12 &= 0x3ffffff;
    /* k = 13 */
    lo = Math.imul(al9, bl4);
    mid = Math.imul(al9, bh4);
    mid = (mid + Math.imul(ah9, bl4)) | 0;
    hi = Math.imul(ah9, bh4);
    lo = (lo + Math.imul(al8, bl5)) | 0;
    mid = (mid + Math.imul(al8, bh5)) | 0;
    mid = (mid + Math.imul(ah8, bl5)) | 0;
    hi = (hi + Math.imul(ah8, bh5)) | 0;
    lo = (lo + Math.imul(al7, bl6)) | 0;
    mid = (mid + Math.imul(al7, bh6)) | 0;
    mid = (mid + Math.imul(ah7, bl6)) | 0;
    hi = (hi + Math.imul(ah7, bh6)) | 0;
    lo = (lo + Math.imul(al6, bl7)) | 0;
    mid = (mid + Math.imul(al6, bh7)) | 0;
    mid = (mid + Math.imul(ah6, bl7)) | 0;
    hi = (hi + Math.imul(ah6, bh7)) | 0;
    lo = (lo + Math.imul(al5, bl8)) | 0;
    mid = (mid + Math.imul(al5, bh8)) | 0;
    mid = (mid + Math.imul(ah5, bl8)) | 0;
    hi = (hi + Math.imul(ah5, bh8)) | 0;
    lo = (lo + Math.imul(al4, bl9)) | 0;
    mid = (mid + Math.imul(al4, bh9)) | 0;
    mid = (mid + Math.imul(ah4, bl9)) | 0;
    hi = (hi + Math.imul(ah4, bh9)) | 0;
    var w13 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w13 >>> 26)) | 0;
    w13 &= 0x3ffffff;
    /* k = 14 */
    lo = Math.imul(al9, bl5);
    mid = Math.imul(al9, bh5);
    mid = (mid + Math.imul(ah9, bl5)) | 0;
    hi = Math.imul(ah9, bh5);
    lo = (lo + Math.imul(al8, bl6)) | 0;
    mid = (mid + Math.imul(al8, bh6)) | 0;
    mid = (mid + Math.imul(ah8, bl6)) | 0;
    hi = (hi + Math.imul(ah8, bh6)) | 0;
    lo = (lo + Math.imul(al7, bl7)) | 0;
    mid = (mid + Math.imul(al7, bh7)) | 0;
    mid = (mid + Math.imul(ah7, bl7)) | 0;
    hi = (hi + Math.imul(ah7, bh7)) | 0;
    lo = (lo + Math.imul(al6, bl8)) | 0;
    mid = (mid + Math.imul(al6, bh8)) | 0;
    mid = (mid + Math.imul(ah6, bl8)) | 0;
    hi = (hi + Math.imul(ah6, bh8)) | 0;
    lo = (lo + Math.imul(al5, bl9)) | 0;
    mid = (mid + Math.imul(al5, bh9)) | 0;
    mid = (mid + Math.imul(ah5, bl9)) | 0;
    hi = (hi + Math.imul(ah5, bh9)) | 0;
    var w14 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w14 >>> 26)) | 0;
    w14 &= 0x3ffffff;
    /* k = 15 */
    lo = Math.imul(al9, bl6);
    mid = Math.imul(al9, bh6);
    mid = (mid + Math.imul(ah9, bl6)) | 0;
    hi = Math.imul(ah9, bh6);
    lo = (lo + Math.imul(al8, bl7)) | 0;
    mid = (mid + Math.imul(al8, bh7)) | 0;
    mid = (mid + Math.imul(ah8, bl7)) | 0;
    hi = (hi + Math.imul(ah8, bh7)) | 0;
    lo = (lo + Math.imul(al7, bl8)) | 0;
    mid = (mid + Math.imul(al7, bh8)) | 0;
    mid = (mid + Math.imul(ah7, bl8)) | 0;
    hi = (hi + Math.imul(ah7, bh8)) | 0;
    lo = (lo + Math.imul(al6, bl9)) | 0;
    mid = (mid + Math.imul(al6, bh9)) | 0;
    mid = (mid + Math.imul(ah6, bl9)) | 0;
    hi = (hi + Math.imul(ah6, bh9)) | 0;
    var w15 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w15 >>> 26)) | 0;
    w15 &= 0x3ffffff;
    /* k = 16 */
    lo = Math.imul(al9, bl7);
    mid = Math.imul(al9, bh7);
    mid = (mid + Math.imul(ah9, bl7)) | 0;
    hi = Math.imul(ah9, bh7);
    lo = (lo + Math.imul(al8, bl8)) | 0;
    mid = (mid + Math.imul(al8, bh8)) | 0;
    mid = (mid + Math.imul(ah8, bl8)) | 0;
    hi = (hi + Math.imul(ah8, bh8)) | 0;
    lo = (lo + Math.imul(al7, bl9)) | 0;
    mid = (mid + Math.imul(al7, bh9)) | 0;
    mid = (mid + Math.imul(ah7, bl9)) | 0;
    hi = (hi + Math.imul(ah7, bh9)) | 0;
    var w16 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w16 >>> 26)) | 0;
    w16 &= 0x3ffffff;
    /* k = 17 */
    lo = Math.imul(al9, bl8);
    mid = Math.imul(al9, bh8);
    mid = (mid + Math.imul(ah9, bl8)) | 0;
    hi = Math.imul(ah9, bh8);
    lo = (lo + Math.imul(al8, bl9)) | 0;
    mid = (mid + Math.imul(al8, bh9)) | 0;
    mid = (mid + Math.imul(ah8, bl9)) | 0;
    hi = (hi + Math.imul(ah8, bh9)) | 0;
    var w17 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w17 >>> 26)) | 0;
    w17 &= 0x3ffffff;
    /* k = 18 */
    lo = Math.imul(al9, bl9);
    mid = Math.imul(al9, bh9);
    mid = (mid + Math.imul(ah9, bl9)) | 0;
    hi = Math.imul(ah9, bh9);
    var w18 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w18 >>> 26)) | 0;
    w18 &= 0x3ffffff;
    o[0] = w0;
    o[1] = w1;
    o[2] = w2;
    o[3] = w3;
    o[4] = w4;
    o[5] = w5;
    o[6] = w6;
    o[7] = w7;
    o[8] = w8;
    o[9] = w9;
    o[10] = w10;
    o[11] = w11;
    o[12] = w12;
    o[13] = w13;
    o[14] = w14;
    o[15] = w15;
    o[16] = w16;
    o[17] = w17;
    o[18] = w18;
    if (c !== 0) {
      o[19] = c;
      out.length++;
    }
    return out;
  };

  // Polyfill comb
  if (!Math.imul) {
    comb10MulTo = smallMulTo;
  }

  function bigMulTo (self, num, out) {
    out.negative = num.negative ^ self.negative;
    out.length = self.length + num.length;

    var carry = 0;
    var hncarry = 0;
    for (var k = 0; k < out.length - 1; k++) {
      // Sum all words with the same `i + j = k` and accumulate `ncarry`,
      // note that ncarry could be >= 0x3ffffff
      var ncarry = hncarry;
      hncarry = 0;
      var rword = carry & 0x3ffffff;
      var maxJ = Math.min(k, num.length - 1);
      for (var j = Math.max(0, k - self.length + 1); j <= maxJ; j++) {
        var i = k - j;
        var a = self.words[i] | 0;
        var b = num.words[j] | 0;
        var r = a * b;

        var lo = r & 0x3ffffff;
        ncarry = (ncarry + ((r / 0x4000000) | 0)) | 0;
        lo = (lo + rword) | 0;
        rword = lo & 0x3ffffff;
        ncarry = (ncarry + (lo >>> 26)) | 0;

        hncarry += ncarry >>> 26;
        ncarry &= 0x3ffffff;
      }
      out.words[k] = rword;
      carry = ncarry;
      ncarry = hncarry;
    }
    if (carry !== 0) {
      out.words[k] = carry;
    } else {
      out.length--;
    }

    return out._strip();
  }

  function jumboMulTo (self, num, out) {
    // Temporary disable, see https://github.com/indutny/bn.js/issues/211
    // var fftm = new FFTM();
    // return fftm.mulp(self, num, out);
    return bigMulTo(self, num, out);
  }

  BN.prototype.mulTo = function mulTo (num, out) {
    var res;
    var len = this.length + num.length;
    if (this.length === 10 && num.length === 10) {
      res = comb10MulTo(this, num, out);
    } else if (len < 63) {
      res = smallMulTo(this, num, out);
    } else if (len < 1024) {
      res = bigMulTo(this, num, out);
    } else {
      res = jumboMulTo(this, num, out);
    }

    return res;
  };

  // Cooley-Tukey algorithm for FFT
  // slightly revisited to rely on looping instead of recursion

  function FFTM (x, y) {
    this.x = x;
    this.y = y;
  }

  FFTM.prototype.makeRBT = function makeRBT (N) {
    var t = new Array(N);
    var l = BN.prototype._countBits(N) - 1;
    for (var i = 0; i < N; i++) {
      t[i] = this.revBin(i, l, N);
    }

    return t;
  };

  // Returns binary-reversed representation of `x`
  FFTM.prototype.revBin = function revBin (x, l, N) {
    if (x === 0 || x === N - 1) return x;

    var rb = 0;
    for (var i = 0; i < l; i++) {
      rb |= (x & 1) << (l - i - 1);
      x >>= 1;
    }

    return rb;
  };

  // Performs "tweedling" phase, therefore 'emulating'
  // behaviour of the recursive algorithm
  FFTM.prototype.permute = function permute (rbt, rws, iws, rtws, itws, N) {
    for (var i = 0; i < N; i++) {
      rtws[i] = rws[rbt[i]];
      itws[i] = iws[rbt[i]];
    }
  };

  FFTM.prototype.transform = function transform (rws, iws, rtws, itws, N, rbt) {
    this.permute(rbt, rws, iws, rtws, itws, N);

    for (var s = 1; s < N; s <<= 1) {
      var l = s << 1;

      var rtwdf = Math.cos(2 * Math.PI / l);
      var itwdf = Math.sin(2 * Math.PI / l);

      for (var p = 0; p < N; p += l) {
        var rtwdf_ = rtwdf;
        var itwdf_ = itwdf;

        for (var j = 0; j < s; j++) {
          var re = rtws[p + j];
          var ie = itws[p + j];

          var ro = rtws[p + j + s];
          var io = itws[p + j + s];

          var rx = rtwdf_ * ro - itwdf_ * io;

          io = rtwdf_ * io + itwdf_ * ro;
          ro = rx;

          rtws[p + j] = re + ro;
          itws[p + j] = ie + io;

          rtws[p + j + s] = re - ro;
          itws[p + j + s] = ie - io;

          /* jshint maxdepth : false */
          if (j !== l) {
            rx = rtwdf * rtwdf_ - itwdf * itwdf_;

            itwdf_ = rtwdf * itwdf_ + itwdf * rtwdf_;
            rtwdf_ = rx;
          }
        }
      }
    }
  };

  FFTM.prototype.guessLen13b = function guessLen13b (n, m) {
    var N = Math.max(m, n) | 1;
    var odd = N & 1;
    var i = 0;
    for (N = N / 2 | 0; N; N = N >>> 1) {
      i++;
    }

    return 1 << i + 1 + odd;
  };

  FFTM.prototype.conjugate = function conjugate (rws, iws, N) {
    if (N <= 1) return;

    for (var i = 0; i < N / 2; i++) {
      var t = rws[i];

      rws[i] = rws[N - i - 1];
      rws[N - i - 1] = t;

      t = iws[i];

      iws[i] = -iws[N - i - 1];
      iws[N - i - 1] = -t;
    }
  };

  FFTM.prototype.normalize13b = function normalize13b (ws, N) {
    var carry = 0;
    for (var i = 0; i < N / 2; i++) {
      var w = Math.round(ws[2 * i + 1] / N) * 0x2000 +
        Math.round(ws[2 * i] / N) +
        carry;

      ws[i] = w & 0x3ffffff;

      if (w < 0x4000000) {
        carry = 0;
      } else {
        carry = w / 0x4000000 | 0;
      }
    }

    return ws;
  };

  FFTM.prototype.convert13b = function convert13b (ws, len, rws, N) {
    var carry = 0;
    for (var i = 0; i < len; i++) {
      carry = carry + (ws[i] | 0);

      rws[2 * i] = carry & 0x1fff; carry = carry >>> 13;
      rws[2 * i + 1] = carry & 0x1fff; carry = carry >>> 13;
    }

    // Pad with zeroes
    for (i = 2 * len; i < N; ++i) {
      rws[i] = 0;
    }

    assert(carry === 0);
    assert((carry & ~0x1fff) === 0);
  };

  FFTM.prototype.stub = function stub (N) {
    var ph = new Array(N);
    for (var i = 0; i < N; i++) {
      ph[i] = 0;
    }

    return ph;
  };

  FFTM.prototype.mulp = function mulp (x, y, out) {
    var N = 2 * this.guessLen13b(x.length, y.length);

    var rbt = this.makeRBT(N);

    var _ = this.stub(N);

    var rws = new Array(N);
    var rwst = new Array(N);
    var iwst = new Array(N);

    var nrws = new Array(N);
    var nrwst = new Array(N);
    var niwst = new Array(N);

    var rmws = out.words;
    rmws.length = N;

    this.convert13b(x.words, x.length, rws, N);
    this.convert13b(y.words, y.length, nrws, N);

    this.transform(rws, _, rwst, iwst, N, rbt);
    this.transform(nrws, _, nrwst, niwst, N, rbt);

    for (var i = 0; i < N; i++) {
      var rx = rwst[i] * nrwst[i] - iwst[i] * niwst[i];
      iwst[i] = rwst[i] * niwst[i] + iwst[i] * nrwst[i];
      rwst[i] = rx;
    }

    this.conjugate(rwst, iwst, N);
    this.transform(rwst, iwst, rmws, _, N, rbt);
    this.conjugate(rmws, _, N);
    this.normalize13b(rmws, N);

    out.negative = x.negative ^ y.negative;
    out.length = x.length + y.length;
    return out._strip();
  };

  // Multiply `this` by `num`
  BN.prototype.mul = function mul (num) {
    var out = new BN(null);
    out.words = new Array(this.length + num.length);
    return this.mulTo(num, out);
  };

  // Multiply employing FFT
  BN.prototype.mulf = function mulf (num) {
    var out = new BN(null);
    out.words = new Array(this.length + num.length);
    return jumboMulTo(this, num, out);
  };

  // In-place Multiplication
  BN.prototype.imul = function imul (num) {
    return this.clone().mulTo(num, this);
  };

  BN.prototype.imuln = function imuln (num) {
    var isNegNum = num < 0;
    if (isNegNum) num = -num;

    assert(typeof num === 'number');
    assert(num < 0x4000000);

    // Carry
    var carry = 0;
    for (var i = 0; i < this.length; i++) {
      var w = (this.words[i] | 0) * num;
      var lo = (w & 0x3ffffff) + (carry & 0x3ffffff);
      carry >>= 26;
      carry += (w / 0x4000000) | 0;
      // NOTE: lo is 27bit maximum
      carry += lo >>> 26;
      this.words[i] = lo & 0x3ffffff;
    }

    if (carry !== 0) {
      this.words[i] = carry;
      this.length++;
    }

    return isNegNum ? this.ineg() : this;
  };

  BN.prototype.muln = function muln (num) {
    return this.clone().imuln(num);
  };

  // `this` * `this`
  BN.prototype.sqr = function sqr () {
    return this.mul(this);
  };

  // `this` * `this` in-place
  BN.prototype.isqr = function isqr () {
    return this.imul(this.clone());
  };

  // Math.pow(`this`, `num`)
  BN.prototype.pow = function pow (num) {
    var w = toBitArray(num);
    if (w.length === 0) return new BN(1);

    // Skip leading zeroes
    var res = this;
    for (var i = 0; i < w.length; i++, res = res.sqr()) {
      if (w[i] !== 0) break;
    }

    if (++i < w.length) {
      for (var q = res.sqr(); i < w.length; i++, q = q.sqr()) {
        if (w[i] === 0) continue;

        res = res.mul(q);
      }
    }

    return res;
  };

  // Shift-left in-place
  BN.prototype.iushln = function iushln (bits) {
    assert(typeof bits === 'number' && bits >= 0);
    var r = bits % 26;
    var s = (bits - r) / 26;
    var carryMask = (0x3ffffff >>> (26 - r)) << (26 - r);
    var i;

    if (r !== 0) {
      var carry = 0;

      for (i = 0; i < this.length; i++) {
        var newCarry = this.words[i] & carryMask;
        var c = ((this.words[i] | 0) - newCarry) << r;
        this.words[i] = c | carry;
        carry = newCarry >>> (26 - r);
      }

      if (carry) {
        this.words[i] = carry;
        this.length++;
      }
    }

    if (s !== 0) {
      for (i = this.length - 1; i >= 0; i--) {
        this.words[i + s] = this.words[i];
      }

      for (i = 0; i < s; i++) {
        this.words[i] = 0;
      }

      this.length += s;
    }

    return this._strip();
  };

  BN.prototype.ishln = function ishln (bits) {
    // TODO(indutny): implement me
    assert(this.negative === 0);
    return this.iushln(bits);
  };

  // Shift-right in-place
  // NOTE: `hint` is a lowest bit before trailing zeroes
  // NOTE: if `extended` is present - it will be filled with destroyed bits
  BN.prototype.iushrn = function iushrn (bits, hint, extended) {
    assert(typeof bits === 'number' && bits >= 0);
    var h;
    if (hint) {
      h = (hint - (hint % 26)) / 26;
    } else {
      h = 0;
    }

    var r = bits % 26;
    var s = Math.min((bits - r) / 26, this.length);
    var mask = 0x3ffffff ^ ((0x3ffffff >>> r) << r);
    var maskedWords = extended;

    h -= s;
    h = Math.max(0, h);

    // Extended mode, copy masked part
    if (maskedWords) {
      for (var i = 0; i < s; i++) {
        maskedWords.words[i] = this.words[i];
      }
      maskedWords.length = s;
    }

    if (s === 0) {
      // No-op, we should not move anything at all
    } else if (this.length > s) {
      this.length -= s;
      for (i = 0; i < this.length; i++) {
        this.words[i] = this.words[i + s];
      }
    } else {
      this.words[0] = 0;
      this.length = 1;
    }

    var carry = 0;
    for (i = this.length - 1; i >= 0 && (carry !== 0 || i >= h); i--) {
      var word = this.words[i] | 0;
      this.words[i] = (carry << (26 - r)) | (word >>> r);
      carry = word & mask;
    }

    // Push carried bits as a mask
    if (maskedWords && carry !== 0) {
      maskedWords.words[maskedWords.length++] = carry;
    }

    if (this.length === 0) {
      this.words[0] = 0;
      this.length = 1;
    }

    return this._strip();
  };

  BN.prototype.ishrn = function ishrn (bits, hint, extended) {
    // TODO(indutny): implement me
    assert(this.negative === 0);
    return this.iushrn(bits, hint, extended);
  };

  // Shift-left
  BN.prototype.shln = function shln (bits) {
    return this.clone().ishln(bits);
  };

  BN.prototype.ushln = function ushln (bits) {
    return this.clone().iushln(bits);
  };

  // Shift-right
  BN.prototype.shrn = function shrn (bits) {
    return this.clone().ishrn(bits);
  };

  BN.prototype.ushrn = function ushrn (bits) {
    return this.clone().iushrn(bits);
  };

  // Test if n bit is set
  BN.prototype.testn = function testn (bit) {
    assert(typeof bit === 'number' && bit >= 0);
    var r = bit % 26;
    var s = (bit - r) / 26;
    var q = 1 << r;

    // Fast case: bit is much higher than all existing words
    if (this.length <= s) return false;

    // Check bit and return
    var w = this.words[s];

    return !!(w & q);
  };

  // Return only lowers bits of number (in-place)
  BN.prototype.imaskn = function imaskn (bits) {
    assert(typeof bits === 'number' && bits >= 0);
    var r = bits % 26;
    var s = (bits - r) / 26;

    assert(this.negative === 0, 'imaskn works only with positive numbers');

    if (this.length <= s) {
      return this;
    }

    if (r !== 0) {
      s++;
    }
    this.length = Math.min(s, this.length);

    if (r !== 0) {
      var mask = 0x3ffffff ^ ((0x3ffffff >>> r) << r);
      this.words[this.length - 1] &= mask;
    }

    return this._strip();
  };

  // Return only lowers bits of number
  BN.prototype.maskn = function maskn (bits) {
    return this.clone().imaskn(bits);
  };

  // Add plain number `num` to `this`
  BN.prototype.iaddn = function iaddn (num) {
    assert(typeof num === 'number');
    assert(num < 0x4000000);
    if (num < 0) return this.isubn(-num);

    // Possible sign change
    if (this.negative !== 0) {
      if (this.length === 1 && (this.words[0] | 0) <= num) {
        this.words[0] = num - (this.words[0] | 0);
        this.negative = 0;
        return this;
      }

      this.negative = 0;
      this.isubn(num);
      this.negative = 1;
      return this;
    }

    // Add without checks
    return this._iaddn(num);
  };

  BN.prototype._iaddn = function _iaddn (num) {
    this.words[0] += num;

    // Carry
    for (var i = 0; i < this.length && this.words[i] >= 0x4000000; i++) {
      this.words[i] -= 0x4000000;
      if (i === this.length - 1) {
        this.words[i + 1] = 1;
      } else {
        this.words[i + 1]++;
      }
    }
    this.length = Math.max(this.length, i + 1);

    return this;
  };

  // Subtract plain number `num` from `this`
  BN.prototype.isubn = function isubn (num) {
    assert(typeof num === 'number');
    assert(num < 0x4000000);
    if (num < 0) return this.iaddn(-num);

    if (this.negative !== 0) {
      this.negative = 0;
      this.iaddn(num);
      this.negative = 1;
      return this;
    }

    this.words[0] -= num;

    if (this.length === 1 && this.words[0] < 0) {
      this.words[0] = -this.words[0];
      this.negative = 1;
    } else {
      // Carry
      for (var i = 0; i < this.length && this.words[i] < 0; i++) {
        this.words[i] += 0x4000000;
        this.words[i + 1] -= 1;
      }
    }

    return this._strip();
  };

  BN.prototype.addn = function addn (num) {
    return this.clone().iaddn(num);
  };

  BN.prototype.subn = function subn (num) {
    return this.clone().isubn(num);
  };

  BN.prototype.iabs = function iabs () {
    this.negative = 0;

    return this;
  };

  BN.prototype.abs = function abs () {
    return this.clone().iabs();
  };

  BN.prototype._ishlnsubmul = function _ishlnsubmul (num, mul, shift) {
    var len = num.length + shift;
    var i;

    this._expand(len);

    var w;
    var carry = 0;
    for (i = 0; i < num.length; i++) {
      w = (this.words[i + shift] | 0) + carry;
      var right = (num.words[i] | 0) * mul;
      w -= right & 0x3ffffff;
      carry = (w >> 26) - ((right / 0x4000000) | 0);
      this.words[i + shift] = w & 0x3ffffff;
    }
    for (; i < this.length - shift; i++) {
      w = (this.words[i + shift] | 0) + carry;
      carry = w >> 26;
      this.words[i + shift] = w & 0x3ffffff;
    }

    if (carry === 0) return this._strip();

    // Subtraction overflow
    assert(carry === -1);
    carry = 0;
    for (i = 0; i < this.length; i++) {
      w = -(this.words[i] | 0) + carry;
      carry = w >> 26;
      this.words[i] = w & 0x3ffffff;
    }
    this.negative = 1;

    return this._strip();
  };

  BN.prototype._wordDiv = function _wordDiv (num, mode) {
    var shift = this.length - num.length;

    var a = this.clone();
    var b = num;

    // Normalize
    var bhi = b.words[b.length - 1] | 0;
    var bhiBits = this._countBits(bhi);
    shift = 26 - bhiBits;
    if (shift !== 0) {
      b = b.ushln(shift);
      a.iushln(shift);
      bhi = b.words[b.length - 1] | 0;
    }

    // Initialize quotient
    var m = a.length - b.length;
    var q;

    if (mode !== 'mod') {
      q = new BN(null);
      q.length = m + 1;
      q.words = new Array(q.length);
      for (var i = 0; i < q.length; i++) {
        q.words[i] = 0;
      }
    }

    var diff = a.clone()._ishlnsubmul(b, 1, m);
    if (diff.negative === 0) {
      a = diff;
      if (q) {
        q.words[m] = 1;
      }
    }

    for (var j = m - 1; j >= 0; j--) {
      var qj = (a.words[b.length + j] | 0) * 0x4000000 +
        (a.words[b.length + j - 1] | 0);

      // NOTE: (qj / bhi) is (0x3ffffff * 0x4000000 + 0x3ffffff) / 0x2000000 max
      // (0x7ffffff)
      qj = Math.min((qj / bhi) | 0, 0x3ffffff);

      a._ishlnsubmul(b, qj, j);
      while (a.negative !== 0) {
        qj--;
        a.negative = 0;
        a._ishlnsubmul(b, 1, j);
        if (!a.isZero()) {
          a.negative ^= 1;
        }
      }
      if (q) {
        q.words[j] = qj;
      }
    }
    if (q) {
      q._strip();
    }
    a._strip();

    // Denormalize
    if (mode !== 'div' && shift !== 0) {
      a.iushrn(shift);
    }

    return {
      div: q || null,
      mod: a
    };
  };

  // NOTE: 1) `mode` can be set to `mod` to request mod only,
  //       to `div` to request div only, or be absent to
  //       request both div & mod
  //       2) `positive` is true if unsigned mod is requested
  BN.prototype.divmod = function divmod (num, mode, positive) {
    assert(!num.isZero());

    if (this.isZero()) {
      return {
        div: new BN(0),
        mod: new BN(0)
      };
    }

    var div, mod, res;
    if (this.negative !== 0 && num.negative === 0) {
      res = this.neg().divmod(num, mode);

      if (mode !== 'mod') {
        div = res.div.neg();
      }

      if (mode !== 'div') {
        mod = res.mod.neg();
        if (positive && mod.negative !== 0) {
          mod.iadd(num);
        }
      }

      return {
        div: div,
        mod: mod
      };
    }

    if (this.negative === 0 && num.negative !== 0) {
      res = this.divmod(num.neg(), mode);

      if (mode !== 'mod') {
        div = res.div.neg();
      }

      return {
        div: div,
        mod: res.mod
      };
    }

    if ((this.negative & num.negative) !== 0) {
      res = this.neg().divmod(num.neg(), mode);

      if (mode !== 'div') {
        mod = res.mod.neg();
        if (positive && mod.negative !== 0) {
          mod.isub(num);
        }
      }

      return {
        div: res.div,
        mod: mod
      };
    }

    // Both numbers are positive at this point

    // Strip both numbers to approximate shift value
    if (num.length > this.length || this.cmp(num) < 0) {
      return {
        div: new BN(0),
        mod: this
      };
    }

    // Very short reduction
    if (num.length === 1) {
      if (mode === 'div') {
        return {
          div: this.divn(num.words[0]),
          mod: null
        };
      }

      if (mode === 'mod') {
        return {
          div: null,
          mod: new BN(this.modrn(num.words[0]))
        };
      }

      return {
        div: this.divn(num.words[0]),
        mod: new BN(this.modrn(num.words[0]))
      };
    }

    return this._wordDiv(num, mode);
  };

  // Find `this` / `num`
  BN.prototype.div = function div (num) {
    return this.divmod(num, 'div', false).div;
  };

  // Find `this` % `num`
  BN.prototype.mod = function mod (num) {
    return this.divmod(num, 'mod', false).mod;
  };

  BN.prototype.umod = function umod (num) {
    return this.divmod(num, 'mod', true).mod;
  };

  // Find Round(`this` / `num`)
  BN.prototype.divRound = function divRound (num) {
    var dm = this.divmod(num);

    // Fast case - exact division
    if (dm.mod.isZero()) return dm.div;

    var mod = dm.div.negative !== 0 ? dm.mod.isub(num) : dm.mod;

    var half = num.ushrn(1);
    var r2 = num.andln(1);
    var cmp = mod.cmp(half);

    // Round down
    if (cmp < 0 || (r2 === 1 && cmp === 0)) return dm.div;

    // Round up
    return dm.div.negative !== 0 ? dm.div.isubn(1) : dm.div.iaddn(1);
  };

  BN.prototype.modrn = function modrn (num) {
    var isNegNum = num < 0;
    if (isNegNum) num = -num;

    assert(num <= 0x3ffffff);
    var p = (1 << 26) % num;

    var acc = 0;
    for (var i = this.length - 1; i >= 0; i--) {
      acc = (p * acc + (this.words[i] | 0)) % num;
    }

    return isNegNum ? -acc : acc;
  };

  // WARNING: DEPRECATED
  BN.prototype.modn = function modn (num) {
    return this.modrn(num);
  };

  // In-place division by number
  BN.prototype.idivn = function idivn (num) {
    var isNegNum = num < 0;
    if (isNegNum) num = -num;

    assert(num <= 0x3ffffff);

    var carry = 0;
    for (var i = this.length - 1; i >= 0; i--) {
      var w = (this.words[i] | 0) + carry * 0x4000000;
      this.words[i] = (w / num) | 0;
      carry = w % num;
    }

    this._strip();
    return isNegNum ? this.ineg() : this;
  };

  BN.prototype.divn = function divn (num) {
    return this.clone().idivn(num);
  };

  BN.prototype.egcd = function egcd (p) {
    assert(p.negative === 0);
    assert(!p.isZero());

    var x = this;
    var y = p.clone();

    if (x.negative !== 0) {
      x = x.umod(p);
    } else {
      x = x.clone();
    }

    // A * x + B * y = x
    var A = new BN(1);
    var B = new BN(0);

    // C * x + D * y = y
    var C = new BN(0);
    var D = new BN(1);

    var g = 0;

    while (x.isEven() && y.isEven()) {
      x.iushrn(1);
      y.iushrn(1);
      ++g;
    }

    var yp = y.clone();
    var xp = x.clone();

    while (!x.isZero()) {
      for (var i = 0, im = 1; (x.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
      if (i > 0) {
        x.iushrn(i);
        while (i-- > 0) {
          if (A.isOdd() || B.isOdd()) {
            A.iadd(yp);
            B.isub(xp);
          }

          A.iushrn(1);
          B.iushrn(1);
        }
      }

      for (var j = 0, jm = 1; (y.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
      if (j > 0) {
        y.iushrn(j);
        while (j-- > 0) {
          if (C.isOdd() || D.isOdd()) {
            C.iadd(yp);
            D.isub(xp);
          }

          C.iushrn(1);
          D.iushrn(1);
        }
      }

      if (x.cmp(y) >= 0) {
        x.isub(y);
        A.isub(C);
        B.isub(D);
      } else {
        y.isub(x);
        C.isub(A);
        D.isub(B);
      }
    }

    return {
      a: C,
      b: D,
      gcd: y.iushln(g)
    };
  };

  // This is reduced incarnation of the binary EEA
  // above, designated to invert members of the
  // _prime_ fields F(p) at a maximal speed
  BN.prototype._invmp = function _invmp (p) {
    assert(p.negative === 0);
    assert(!p.isZero());

    var a = this;
    var b = p.clone();

    if (a.negative !== 0) {
      a = a.umod(p);
    } else {
      a = a.clone();
    }

    var x1 = new BN(1);
    var x2 = new BN(0);

    var delta = b.clone();

    while (a.cmpn(1) > 0 && b.cmpn(1) > 0) {
      for (var i = 0, im = 1; (a.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
      if (i > 0) {
        a.iushrn(i);
        while (i-- > 0) {
          if (x1.isOdd()) {
            x1.iadd(delta);
          }

          x1.iushrn(1);
        }
      }

      for (var j = 0, jm = 1; (b.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
      if (j > 0) {
        b.iushrn(j);
        while (j-- > 0) {
          if (x2.isOdd()) {
            x2.iadd(delta);
          }

          x2.iushrn(1);
        }
      }

      if (a.cmp(b) >= 0) {
        a.isub(b);
        x1.isub(x2);
      } else {
        b.isub(a);
        x2.isub(x1);
      }
    }

    var res;
    if (a.cmpn(1) === 0) {
      res = x1;
    } else {
      res = x2;
    }

    if (res.cmpn(0) < 0) {
      res.iadd(p);
    }

    return res;
  };

  BN.prototype.gcd = function gcd (num) {
    if (this.isZero()) return num.abs();
    if (num.isZero()) return this.abs();

    var a = this.clone();
    var b = num.clone();
    a.negative = 0;
    b.negative = 0;

    // Remove common factor of two
    for (var shift = 0; a.isEven() && b.isEven(); shift++) {
      a.iushrn(1);
      b.iushrn(1);
    }

    do {
      while (a.isEven()) {
        a.iushrn(1);
      }
      while (b.isEven()) {
        b.iushrn(1);
      }

      var r = a.cmp(b);
      if (r < 0) {
        // Swap `a` and `b` to make `a` always bigger than `b`
        var t = a;
        a = b;
        b = t;
      } else if (r === 0 || b.cmpn(1) === 0) {
        break;
      }

      a.isub(b);
    } while (true);

    return b.iushln(shift);
  };

  // Invert number in the field F(num)
  BN.prototype.invm = function invm (num) {
    return this.egcd(num).a.umod(num);
  };

  BN.prototype.isEven = function isEven () {
    return (this.words[0] & 1) === 0;
  };

  BN.prototype.isOdd = function isOdd () {
    return (this.words[0] & 1) === 1;
  };

  // And first word and num
  BN.prototype.andln = function andln (num) {
    return this.words[0] & num;
  };

  // Increment at the bit position in-line
  BN.prototype.bincn = function bincn (bit) {
    assert(typeof bit === 'number');
    var r = bit % 26;
    var s = (bit - r) / 26;
    var q = 1 << r;

    // Fast case: bit is much higher than all existing words
    if (this.length <= s) {
      this._expand(s + 1);
      this.words[s] |= q;
      return this;
    }

    // Add bit and propagate, if needed
    var carry = q;
    for (var i = s; carry !== 0 && i < this.length; i++) {
      var w = this.words[i] | 0;
      w += carry;
      carry = w >>> 26;
      w &= 0x3ffffff;
      this.words[i] = w;
    }
    if (carry !== 0) {
      this.words[i] = carry;
      this.length++;
    }
    return this;
  };

  BN.prototype.isZero = function isZero () {
    return this.length === 1 && this.words[0] === 0;
  };

  BN.prototype.cmpn = function cmpn (num) {
    var negative = num < 0;

    if (this.negative !== 0 && !negative) return -1;
    if (this.negative === 0 && negative) return 1;

    this._strip();

    var res;
    if (this.length > 1) {
      res = 1;
    } else {
      if (negative) {
        num = -num;
      }

      assert(num <= 0x3ffffff, 'Number is too big');

      var w = this.words[0] | 0;
      res = w === num ? 0 : w < num ? -1 : 1;
    }
    if (this.negative !== 0) return -res | 0;
    return res;
  };

  // Compare two numbers and return:
  // 1 - if `this` > `num`
  // 0 - if `this` == `num`
  // -1 - if `this` < `num`
  BN.prototype.cmp = function cmp (num) {
    if (this.negative !== 0 && num.negative === 0) return -1;
    if (this.negative === 0 && num.negative !== 0) return 1;

    var res = this.ucmp(num);
    if (this.negative !== 0) return -res | 0;
    return res;
  };

  // Unsigned comparison
  BN.prototype.ucmp = function ucmp (num) {
    // At this point both numbers have the same sign
    if (this.length > num.length) return 1;
    if (this.length < num.length) return -1;

    var res = 0;
    for (var i = this.length - 1; i >= 0; i--) {
      var a = this.words[i] | 0;
      var b = num.words[i] | 0;

      if (a === b) continue;
      if (a < b) {
        res = -1;
      } else if (a > b) {
        res = 1;
      }
      break;
    }
    return res;
  };

  BN.prototype.gtn = function gtn (num) {
    return this.cmpn(num) === 1;
  };

  BN.prototype.gt = function gt (num) {
    return this.cmp(num) === 1;
  };

  BN.prototype.gten = function gten (num) {
    return this.cmpn(num) >= 0;
  };

  BN.prototype.gte = function gte (num) {
    return this.cmp(num) >= 0;
  };

  BN.prototype.ltn = function ltn (num) {
    return this.cmpn(num) === -1;
  };

  BN.prototype.lt = function lt (num) {
    return this.cmp(num) === -1;
  };

  BN.prototype.lten = function lten (num) {
    return this.cmpn(num) <= 0;
  };

  BN.prototype.lte = function lte (num) {
    return this.cmp(num) <= 0;
  };

  BN.prototype.eqn = function eqn (num) {
    return this.cmpn(num) === 0;
  };

  BN.prototype.eq = function eq (num) {
    return this.cmp(num) === 0;
  };

  //
  // A reduce context, could be using montgomery or something better, depending
  // on the `m` itself.
  //
  BN.red = function red (num) {
    return new Red(num);
  };

  BN.prototype.toRed = function toRed (ctx) {
    assert(!this.red, 'Already a number in reduction context');
    assert(this.negative === 0, 'red works only with positives');
    return ctx.convertTo(this)._forceRed(ctx);
  };

  BN.prototype.fromRed = function fromRed () {
    assert(this.red, 'fromRed works only with numbers in reduction context');
    return this.red.convertFrom(this);
  };

  BN.prototype._forceRed = function _forceRed (ctx) {
    this.red = ctx;
    return this;
  };

  BN.prototype.forceRed = function forceRed (ctx) {
    assert(!this.red, 'Already a number in reduction context');
    return this._forceRed(ctx);
  };

  BN.prototype.redAdd = function redAdd (num) {
    assert(this.red, 'redAdd works only with red numbers');
    return this.red.add(this, num);
  };

  BN.prototype.redIAdd = function redIAdd (num) {
    assert(this.red, 'redIAdd works only with red numbers');
    return this.red.iadd(this, num);
  };

  BN.prototype.redSub = function redSub (num) {
    assert(this.red, 'redSub works only with red numbers');
    return this.red.sub(this, num);
  };

  BN.prototype.redISub = function redISub (num) {
    assert(this.red, 'redISub works only with red numbers');
    return this.red.isub(this, num);
  };

  BN.prototype.redShl = function redShl (num) {
    assert(this.red, 'redShl works only with red numbers');
    return this.red.shl(this, num);
  };

  BN.prototype.redMul = function redMul (num) {
    assert(this.red, 'redMul works only with red numbers');
    this.red._verify2(this, num);
    return this.red.mul(this, num);
  };

  BN.prototype.redIMul = function redIMul (num) {
    assert(this.red, 'redMul works only with red numbers');
    this.red._verify2(this, num);
    return this.red.imul(this, num);
  };

  BN.prototype.redSqr = function redSqr () {
    assert(this.red, 'redSqr works only with red numbers');
    this.red._verify1(this);
    return this.red.sqr(this);
  };

  BN.prototype.redISqr = function redISqr () {
    assert(this.red, 'redISqr works only with red numbers');
    this.red._verify1(this);
    return this.red.isqr(this);
  };

  // Square root over p
  BN.prototype.redSqrt = function redSqrt () {
    assert(this.red, 'redSqrt works only with red numbers');
    this.red._verify1(this);
    return this.red.sqrt(this);
  };

  BN.prototype.redInvm = function redInvm () {
    assert(this.red, 'redInvm works only with red numbers');
    this.red._verify1(this);
    return this.red.invm(this);
  };

  // Return negative clone of `this` % `red modulo`
  BN.prototype.redNeg = function redNeg () {
    assert(this.red, 'redNeg works only with red numbers');
    this.red._verify1(this);
    return this.red.neg(this);
  };

  BN.prototype.redPow = function redPow (num) {
    assert(this.red && !num.red, 'redPow(normalNum)');
    this.red._verify1(this);
    return this.red.pow(this, num);
  };

  // Prime numbers with efficient reduction
  var primes = {
    k256: null,
    p224: null,
    p192: null,
    p25519: null
  };

  // Pseudo-Mersenne prime
  function MPrime (name, p) {
    // P = 2 ^ N - K
    this.name = name;
    this.p = new BN(p, 16);
    this.n = this.p.bitLength();
    this.k = new BN(1).iushln(this.n).isub(this.p);

    this.tmp = this._tmp();
  }

  MPrime.prototype._tmp = function _tmp () {
    var tmp = new BN(null);
    tmp.words = new Array(Math.ceil(this.n / 13));
    return tmp;
  };

  MPrime.prototype.ireduce = function ireduce (num) {
    // Assumes that `num` is less than `P^2`
    // num = HI * (2 ^ N - K) + HI * K + LO = HI * K + LO (mod P)
    var r = num;
    var rlen;

    do {
      this.split(r, this.tmp);
      r = this.imulK(r);
      r = r.iadd(this.tmp);
      rlen = r.bitLength();
    } while (rlen > this.n);

    var cmp = rlen < this.n ? -1 : r.ucmp(this.p);
    if (cmp === 0) {
      r.words[0] = 0;
      r.length = 1;
    } else if (cmp > 0) {
      r.isub(this.p);
    } else {
      if (r.strip !== undefined) {
        // r is a BN v4 instance
        r.strip();
      } else {
        // r is a BN v5 instance
        r._strip();
      }
    }

    return r;
  };

  MPrime.prototype.split = function split (input, out) {
    input.iushrn(this.n, 0, out);
  };

  MPrime.prototype.imulK = function imulK (num) {
    return num.imul(this.k);
  };

  function K256 () {
    MPrime.call(
      this,
      'k256',
      'ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f');
  }
  inherits(K256, MPrime);

  K256.prototype.split = function split (input, output) {
    // 256 = 9 * 26 + 22
    var mask = 0x3fffff;

    var outLen = Math.min(input.length, 9);
    for (var i = 0; i < outLen; i++) {
      output.words[i] = input.words[i];
    }
    output.length = outLen;

    if (input.length <= 9) {
      input.words[0] = 0;
      input.length = 1;
      return;
    }

    // Shift by 9 limbs
    var prev = input.words[9];
    output.words[output.length++] = prev & mask;

    for (i = 10; i < input.length; i++) {
      var next = input.words[i] | 0;
      input.words[i - 10] = ((next & mask) << 4) | (prev >>> 22);
      prev = next;
    }
    prev >>>= 22;
    input.words[i - 10] = prev;
    if (prev === 0 && input.length > 10) {
      input.length -= 10;
    } else {
      input.length -= 9;
    }
  };

  K256.prototype.imulK = function imulK (num) {
    // K = 0x1000003d1 = [ 0x40, 0x3d1 ]
    num.words[num.length] = 0;
    num.words[num.length + 1] = 0;
    num.length += 2;

    // bounded at: 0x40 * 0x3ffffff + 0x3d0 = 0x100000390
    var lo = 0;
    for (var i = 0; i < num.length; i++) {
      var w = num.words[i] | 0;
      lo += w * 0x3d1;
      num.words[i] = lo & 0x3ffffff;
      lo = w * 0x40 + ((lo / 0x4000000) | 0);
    }

    // Fast length reduction
    if (num.words[num.length - 1] === 0) {
      num.length--;
      if (num.words[num.length - 1] === 0) {
        num.length--;
      }
    }
    return num;
  };

  function P224 () {
    MPrime.call(
      this,
      'p224',
      'ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001');
  }
  inherits(P224, MPrime);

  function P192 () {
    MPrime.call(
      this,
      'p192',
      'ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff');
  }
  inherits(P192, MPrime);

  function P25519 () {
    // 2 ^ 255 - 19
    MPrime.call(
      this,
      '25519',
      '7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed');
  }
  inherits(P25519, MPrime);

  P25519.prototype.imulK = function imulK (num) {
    // K = 0x13
    var carry = 0;
    for (var i = 0; i < num.length; i++) {
      var hi = (num.words[i] | 0) * 0x13 + carry;
      var lo = hi & 0x3ffffff;
      hi >>>= 26;

      num.words[i] = lo;
      carry = hi;
    }
    if (carry !== 0) {
      num.words[num.length++] = carry;
    }
    return num;
  };

  // Exported mostly for testing purposes, use plain name instead
  BN._prime = function prime (name) {
    // Cached version of prime
    if (primes[name]) return primes[name];

    var prime;
    if (name === 'k256') {
      prime = new K256();
    } else if (name === 'p224') {
      prime = new P224();
    } else if (name === 'p192') {
      prime = new P192();
    } else if (name === 'p25519') {
      prime = new P25519();
    } else {
      throw new Error('Unknown prime ' + name);
    }
    primes[name] = prime;

    return prime;
  };

  //
  // Base reduction engine
  //
  function Red (m) {
    if (typeof m === 'string') {
      var prime = BN._prime(m);
      this.m = prime.p;
      this.prime = prime;
    } else {
      assert(m.gtn(1), 'modulus must be greater than 1');
      this.m = m;
      this.prime = null;
    }
  }

  Red.prototype._verify1 = function _verify1 (a) {
    assert(a.negative === 0, 'red works only with positives');
    assert(a.red, 'red works only with red numbers');
  };

  Red.prototype._verify2 = function _verify2 (a, b) {
    assert((a.negative | b.negative) === 0, 'red works only with positives');
    assert(a.red && a.red === b.red,
      'red works only with red numbers');
  };

  Red.prototype.imod = function imod (a) {
    if (this.prime) return this.prime.ireduce(a)._forceRed(this);

    move(a, a.umod(this.m)._forceRed(this));
    return a;
  };

  Red.prototype.neg = function neg (a) {
    if (a.isZero()) {
      return a.clone();
    }

    return this.m.sub(a)._forceRed(this);
  };

  Red.prototype.add = function add (a, b) {
    this._verify2(a, b);

    var res = a.add(b);
    if (res.cmp(this.m) >= 0) {
      res.isub(this.m);
    }
    return res._forceRed(this);
  };

  Red.prototype.iadd = function iadd (a, b) {
    this._verify2(a, b);

    var res = a.iadd(b);
    if (res.cmp(this.m) >= 0) {
      res.isub(this.m);
    }
    return res;
  };

  Red.prototype.sub = function sub (a, b) {
    this._verify2(a, b);

    var res = a.sub(b);
    if (res.cmpn(0) < 0) {
      res.iadd(this.m);
    }
    return res._forceRed(this);
  };

  Red.prototype.isub = function isub (a, b) {
    this._verify2(a, b);

    var res = a.isub(b);
    if (res.cmpn(0) < 0) {
      res.iadd(this.m);
    }
    return res;
  };

  Red.prototype.shl = function shl (a, num) {
    this._verify1(a);
    return this.imod(a.ushln(num));
  };

  Red.prototype.imul = function imul (a, b) {
    this._verify2(a, b);
    return this.imod(a.imul(b));
  };

  Red.prototype.mul = function mul (a, b) {
    this._verify2(a, b);
    return this.imod(a.mul(b));
  };

  Red.prototype.isqr = function isqr (a) {
    return this.imul(a, a.clone());
  };

  Red.prototype.sqr = function sqr (a) {
    return this.mul(a, a);
  };

  Red.prototype.sqrt = function sqrt (a) {
    if (a.isZero()) return a.clone();

    var mod3 = this.m.andln(3);
    assert(mod3 % 2 === 1);

    // Fast case
    if (mod3 === 3) {
      var pow = this.m.add(new BN(1)).iushrn(2);
      return this.pow(a, pow);
    }

    // Tonelli-Shanks algorithm (Totally unoptimized and slow)
    //
    // Find Q and S, that Q * 2 ^ S = (P - 1)
    var q = this.m.subn(1);
    var s = 0;
    while (!q.isZero() && q.andln(1) === 0) {
      s++;
      q.iushrn(1);
    }
    assert(!q.isZero());

    var one = new BN(1).toRed(this);
    var nOne = one.redNeg();

    // Find quadratic non-residue
    // NOTE: Max is such because of generalized Riemann hypothesis.
    var lpow = this.m.subn(1).iushrn(1);
    var z = this.m.bitLength();
    z = new BN(2 * z * z).toRed(this);

    while (this.pow(z, lpow).cmp(nOne) !== 0) {
      z.redIAdd(nOne);
    }

    var c = this.pow(z, q);
    var r = this.pow(a, q.addn(1).iushrn(1));
    var t = this.pow(a, q);
    var m = s;
    while (t.cmp(one) !== 0) {
      var tmp = t;
      for (var i = 0; tmp.cmp(one) !== 0; i++) {
        tmp = tmp.redSqr();
      }
      assert(i < m);
      var b = this.pow(c, new BN(1).iushln(m - i - 1));

      r = r.redMul(b);
      c = b.redSqr();
      t = t.redMul(c);
      m = i;
    }

    return r;
  };

  Red.prototype.invm = function invm (a) {
    var inv = a._invmp(this.m);
    if (inv.negative !== 0) {
      inv.negative = 0;
      return this.imod(inv).redNeg();
    } else {
      return this.imod(inv);
    }
  };

  Red.prototype.pow = function pow (a, num) {
    if (num.isZero()) return new BN(1).toRed(this);
    if (num.cmpn(1) === 0) return a.clone();

    var windowSize = 4;
    var wnd = new Array(1 << windowSize);
    wnd[0] = new BN(1).toRed(this);
    wnd[1] = a;
    for (var i = 2; i < wnd.length; i++) {
      wnd[i] = this.mul(wnd[i - 1], a);
    }

    var res = wnd[0];
    var current = 0;
    var currentLen = 0;
    var start = num.bitLength() % 26;
    if (start === 0) {
      start = 26;
    }

    for (i = num.length - 1; i >= 0; i--) {
      var word = num.words[i];
      for (var j = start - 1; j >= 0; j--) {
        var bit = (word >> j) & 1;
        if (res !== wnd[0]) {
          res = this.sqr(res);
        }

        if (bit === 0 && current === 0) {
          currentLen = 0;
          continue;
        }

        current <<= 1;
        current |= bit;
        currentLen++;
        if (currentLen !== windowSize && (i !== 0 || j !== 0)) continue;

        res = this.mul(res, wnd[current]);
        currentLen = 0;
        current = 0;
      }
      start = 26;
    }

    return res;
  };

  Red.prototype.convertTo = function convertTo (num) {
    var r = num.umod(this.m);

    return r === num ? r.clone() : r;
  };

  Red.prototype.convertFrom = function convertFrom (num) {
    var res = num.clone();
    res.red = null;
    return res;
  };

  //
  // Montgomery method engine
  //

  BN.mont = function mont (num) {
    return new Mont(num);
  };

  function Mont (m) {
    Red.call(this, m);

    this.shift = this.m.bitLength();
    if (this.shift % 26 !== 0) {
      this.shift += 26 - (this.shift % 26);
    }

    this.r = new BN(1).iushln(this.shift);
    this.r2 = this.imod(this.r.sqr());
    this.rinv = this.r._invmp(this.m);

    this.minv = this.rinv.mul(this.r).isubn(1).div(this.m);
    this.minv = this.minv.umod(this.r);
    this.minv = this.r.sub(this.minv);
  }
  inherits(Mont, Red);

  Mont.prototype.convertTo = function convertTo (num) {
    return this.imod(num.ushln(this.shift));
  };

  Mont.prototype.convertFrom = function convertFrom (num) {
    var r = this.imod(num.mul(this.rinv));
    r.red = null;
    return r;
  };

  Mont.prototype.imul = function imul (a, b) {
    if (a.isZero() || b.isZero()) {
      a.words[0] = 0;
      a.length = 1;
      return a;
    }

    var t = a.imul(b);
    var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
    var u = t.isub(c).iushrn(this.shift);
    var res = u;

    if (u.cmp(this.m) >= 0) {
      res = u.isub(this.m);
    } else if (u.cmpn(0) < 0) {
      res = u.iadd(this.m);
    }

    return res._forceRed(this);
  };

  Mont.prototype.mul = function mul (a, b) {
    if (a.isZero() || b.isZero()) return new BN(0)._forceRed(this);

    var t = a.mul(b);
    var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
    var u = t.isub(c).iushrn(this.shift);
    var res = u;
    if (u.cmp(this.m) >= 0) {
      res = u.isub(this.m);
    } else if (u.cmpn(0) < 0) {
      res = u.iadd(this.m);
    }

    return res._forceRed(this);
  };

  Mont.prototype.invm = function invm (a) {
    // (AR)^-1 * R^2 = (A^-1 * R^-1) * R^2 = A^-1 * R
    var res = this.imod(a._invmp(this.m).mul(this.r2));
    return res._forceRed(this);
  };
})( false || module, this);

/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(/*! ./../../webpack/buildin/module.js */ "./node_modules/webpack/buildin/module.js")(module)))

/***/ }),

/***/ "./node_modules/brorand/index.js":
/*!***************************************!*\
  !*** ./node_modules/brorand/index.js ***!
  \***************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var r;

module.exports = function rand(len) {
  if (!r)
    r = new Rand(null);

  return r.generate(len);
};

function Rand(rand) {
  this.rand = rand;
}
module.exports.Rand = Rand;

Rand.prototype.generate = function generate(len) {
  return this._rand(len);
};

// Emulate crypto API using randy
Rand.prototype._rand = function _rand(n) {
  if (this.rand.getBytes)
    return this.rand.getBytes(n);

  var res = new Uint8Array(n);
  for (var i = 0; i < res.length; i++)
    res[i] = this.rand.getByte();
  return res;
};

if (typeof self === 'object') {
  if (self.crypto && self.crypto.getRandomValues) {
    // Modern browsers
    Rand.prototype._rand = function _rand(n) {
      var arr = new Uint8Array(n);
      self.crypto.getRandomValues(arr);
      return arr;
    };
  } else if (self.msCrypto && self.msCrypto.getRandomValues) {
    // IE
    Rand.prototype._rand = function _rand(n) {
      var arr = new Uint8Array(n);
      self.msCrypto.getRandomValues(arr);
      return arr;
    };

  // Safari's WebWorkers do not have `crypto`
  } else if (typeof window === 'object') {
    // Old junk
    Rand.prototype._rand = function() {
      throw new Error('Not implemented yet');
    };
  }
} else {
  // Node.js or Web worker with no crypto support
  try {
    var crypto = __webpack_require__(/*! crypto */ 6);
    if (typeof crypto.randomBytes !== 'function')
      throw new Error('Not supported');

    Rand.prototype._rand = function _rand(n) {
      return crypto.randomBytes(n);
    };
  } catch (e) {
  }
}


/***/ }),

/***/ "./node_modules/browserify-aes/aes.js":
/*!********************************************!*\
  !*** ./node_modules/browserify-aes/aes.js ***!
  \********************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

// based on the aes implimentation in triple sec
// https://github.com/keybase/triplesec
// which is in turn based on the one from crypto-js
// https://code.google.com/p/crypto-js/

var Buffer = __webpack_require__(/*! safe-buffer */ "./node_modules/safe-buffer/index.js").Buffer

function asUInt32Array (buf) {
  if (!Buffer.isBuffer(buf)) buf = Buffer.from(buf)

  var len = (buf.length / 4) | 0
  var out = new Array(len)

  for (var i = 0; i < len; i++) {
    out[i] = buf.readUInt32BE(i * 4)
  }

  return out
}

function scrubVec (v) {
  for (var i = 0; i < v.length; v++) {
    v[i] = 0
  }
}

function cryptBlock (M, keySchedule, SUB_MIX, SBOX, nRounds) {
  var SUB_MIX0 = SUB_MIX[0]
  var SUB_MIX1 = SUB_MIX[1]
  var SUB_MIX2 = SUB_MIX[2]
  var SUB_MIX3 = SUB_MIX[3]

  var s0 = M[0] ^ keySchedule[0]
  var s1 = M[1] ^ keySchedule[1]
  var s2 = M[2] ^ keySchedule[2]
  var s3 = M[3] ^ keySchedule[3]
  var t0, t1, t2, t3
  var ksRow = 4

  for (var round = 1; round < nRounds; round++) {
    t0 = SUB_MIX0[s0 >>> 24] ^ SUB_MIX1[(s1 >>> 16) & 0xff] ^ SUB_MIX2[(s2 >>> 8) & 0xff] ^ SUB_MIX3[s3 & 0xff] ^ keySchedule[ksRow++]
    t1 = SUB_MIX0[s1 >>> 24] ^ SUB_MIX1[(s2 >>> 16) & 0xff] ^ SUB_MIX2[(s3 >>> 8) & 0xff] ^ SUB_MIX3[s0 & 0xff] ^ keySchedule[ksRow++]
    t2 = SUB_MIX0[s2 >>> 24] ^ SUB_MIX1[(s3 >>> 16) & 0xff] ^ SUB_MIX2[(s0 >>> 8) & 0xff] ^ SUB_MIX3[s1 & 0xff] ^ keySchedule[ksRow++]
    t3 = SUB_MIX0[s3 >>> 24] ^ SUB_MIX1[(s0 >>> 16) & 0xff] ^ SUB_MIX2[(s1 >>> 8) & 0xff] ^ SUB_MIX3[s2 & 0xff] ^ keySchedule[ksRow++]
    s0 = t0
    s1 = t1
    s2 = t2
    s3 = t3
  }

  t0 = ((SBOX[s0 >>> 24] << 24) | (SBOX[(s1 >>> 16) & 0xff] << 16) | (SBOX[(s2 >>> 8) & 0xff] << 8) | SBOX[s3 & 0xff]) ^ keySchedule[ksRow++]
  t1 = ((SBOX[s1 >>> 24] << 24) | (SBOX[(s2 >>> 16) & 0xff] << 16) | (SBOX[(s3 >>> 8) & 0xff] << 8) | SBOX[s0 & 0xff]) ^ keySchedule[ksRow++]
  t2 = ((SBOX[s2 >>> 24] << 24) | (SBOX[(s3 >>> 16) & 0xff] << 16) | (SBOX[(s0 >>> 8) & 0xff] << 8) | SBOX[s1 & 0xff]) ^ keySchedule[ksRow++]
  t3 = ((SBOX[s3 >>> 24] << 24) | (SBOX[(s0 >>> 16) & 0xff] << 16) | (SBOX[(s1 >>> 8) & 0xff] << 8) | SBOX[s2 & 0xff]) ^ keySchedule[ksRow++]
  t0 = t0 >>> 0
  t1 = t1 >>> 0
  t2 = t2 >>> 0
  t3 = t3 >>> 0

  return [t0, t1, t2, t3]
}

// AES constants
var RCON = [0x00, 0x01, 0x02, 0x04, 0x08, 0x10, 0x20, 0x40, 0x80, 0x1b, 0x36]
var G = (function () {
  // Compute double table
  var d = new Array(256)
  for (var j = 0; j < 256; j++) {
    if (j < 128) {
      d[j] = j << 1
    } else {
      d[j] = (j << 1) ^ 0x11b
    }
  }

  var SBOX = []
  var INV_SBOX = []
  var SUB_MIX = [[], [], [], []]
  var INV_SUB_MIX = [[], [], [], []]

  // Walk GF(2^8)
  var x = 0
  var xi = 0
  for (var i = 0; i < 256; ++i) {
    // Compute sbox
    var sx = xi ^ (xi << 1) ^ (xi << 2) ^ (xi << 3) ^ (xi << 4)
    sx = (sx >>> 8) ^ (sx & 0xff) ^ 0x63
    SBOX[x] = sx
    INV_SBOX[sx] = x

    // Compute multiplication
    var x2 = d[x]
    var x4 = d[x2]
    var x8 = d[x4]

    // Compute sub bytes, mix columns tables
    var t = (d[sx] * 0x101) ^ (sx * 0x1010100)
    SUB_MIX[0][x] = (t << 24) | (t >>> 8)
    SUB_MIX[1][x] = (t << 16) | (t >>> 16)
    SUB_MIX[2][x] = (t << 8) | (t >>> 24)
    SUB_MIX[3][x] = t

    // Compute inv sub bytes, inv mix columns tables
    t = (x8 * 0x1010101) ^ (x4 * 0x10001) ^ (x2 * 0x101) ^ (x * 0x1010100)
    INV_SUB_MIX[0][sx] = (t << 24) | (t >>> 8)
    INV_SUB_MIX[1][sx] = (t << 16) | (t >>> 16)
    INV_SUB_MIX[2][sx] = (t << 8) | (t >>> 24)
    INV_SUB_MIX[3][sx] = t

    if (x === 0) {
      x = xi = 1
    } else {
      x = x2 ^ d[d[d[x8 ^ x2]]]
      xi ^= d[d[xi]]
    }
  }

  return {
    SBOX: SBOX,
    INV_SBOX: INV_SBOX,
    SUB_MIX: SUB_MIX,
    INV_SUB_MIX: INV_SUB_MIX
  }
})()

function AES (key) {
  this._key = asUInt32Array(key)
  this._reset()
}

AES.blockSize = 4 * 4
AES.keySize = 256 / 8
AES.prototype.blockSize = AES.blockSize
AES.prototype.keySize = AES.keySize
AES.prototype._reset = function () {
  var keyWords = this._key
  var keySize = keyWords.length
  var nRounds = keySize + 6
  var ksRows = (nRounds + 1) * 4

  var keySchedule = []
  for (var k = 0; k < keySize; k++) {
    keySchedule[k] = keyWords[k]
  }

  for (k = keySize; k < ksRows; k++) {
    var t = keySchedule[k - 1]

    if (k % keySize === 0) {
      t = (t << 8) | (t >>> 24)
      t =
        (G.SBOX[t >>> 24] << 24) |
        (G.SBOX[(t >>> 16) & 0xff] << 16) |
        (G.SBOX[(t >>> 8) & 0xff] << 8) |
        (G.SBOX[t & 0xff])

      t ^= RCON[(k / keySize) | 0] << 24
    } else if (keySize > 6 && k % keySize === 4) {
      t =
        (G.SBOX[t >>> 24] << 24) |
        (G.SBOX[(t >>> 16) & 0xff] << 16) |
        (G.SBOX[(t >>> 8) & 0xff] << 8) |
        (G.SBOX[t & 0xff])
    }

    keySchedule[k] = keySchedule[k - keySize] ^ t
  }

  var invKeySchedule = []
  for (var ik = 0; ik < ksRows; ik++) {
    var ksR = ksRows - ik
    var tt = keySchedule[ksR - (ik % 4 ? 0 : 4)]

    if (ik < 4 || ksR <= 4) {
      invKeySchedule[ik] = tt
    } else {
      invKeySchedule[ik] =
        G.INV_SUB_MIX[0][G.SBOX[tt >>> 24]] ^
        G.INV_SUB_MIX[1][G.SBOX[(tt >>> 16) & 0xff]] ^
        G.INV_SUB_MIX[2][G.SBOX[(tt >>> 8) & 0xff]] ^
        G.INV_SUB_MIX[3][G.SBOX[tt & 0xff]]
    }
  }

  this._nRounds = nRounds
  this._keySchedule = keySchedule
  this._invKeySchedule = invKeySchedule
}

AES.prototype.encryptBlockRaw = function (M) {
  M = asUInt32Array(M)
  return cryptBlock(M, this._keySchedule, G.SUB_MIX, G.SBOX, this._nRounds)
}

AES.prototype.encryptBlock = function (M) {
  var out = this.encryptBlockRaw(M)
  var buf = Buffer.allocUnsafe(16)
  buf.writeUInt32BE(out[0], 0)
  buf.writeUInt32BE(out[1], 4)
  buf.writeUInt32BE(out[2], 8)
  buf.writeUInt32BE(out[3], 12)
  return buf
}

AES.prototype.decryptBlock = function (M) {
  M = asUInt32Array(M)

  // swap
  var m1 = M[1]
  M[1] = M[3]
  M[3] = m1

  var out = cryptBlock(M, this._invKeySchedule, G.INV_SUB_MIX, G.INV_SBOX, this._nRounds)
  var buf = Buffer.allocUnsafe(16)
  buf.writeUInt32BE(out[0], 0)
  buf.writeUInt32BE(out[3], 4)
  buf.writeUInt32BE(out[2], 8)
  buf.writeUInt32BE(out[1], 12)
  return buf
}

AES.prototype.scrub = function () {
  scrubVec(this._keySchedule)
  scrubVec(this._invKeySchedule)
  scrubVec(this._key)
}

module.exports.AES = AES


/***/ }),

/***/ "./node_modules/browserify-aes/authCipher.js":
/*!***************************************************!*\
  !*** ./node_modules/browserify-aes/authCipher.js ***!
  \***************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var aes = __webpack_require__(/*! ./aes */ "./node_modules/browserify-aes/aes.js")
var Buffer = __webpack_require__(/*! safe-buffer */ "./node_modules/safe-buffer/index.js").Buffer
var Transform = __webpack_require__(/*! cipher-base */ "./node_modules/cipher-base/index.js")
var inherits = __webpack_require__(/*! inherits */ "./node_modules/inherits/inherits_browser.js")
var GHASH = __webpack_require__(/*! ./ghash */ "./node_modules/browserify-aes/ghash.js")
var xor = __webpack_require__(/*! buffer-xor */ "./node_modules/buffer-xor/index.js")
var incr32 = __webpack_require__(/*! ./incr32 */ "./node_modules/browserify-aes/incr32.js")

function xorTest (a, b) {
  var out = 0
  if (a.length !== b.length) out++

  var len = Math.min(a.length, b.length)
  for (var i = 0; i < len; ++i) {
    out += (a[i] ^ b[i])
  }

  return out
}

function calcIv (self, iv, ck) {
  if (iv.length === 12) {
    self._finID = Buffer.concat([iv, Buffer.from([0, 0, 0, 1])])
    return Buffer.concat([iv, Buffer.from([0, 0, 0, 2])])
  }
  var ghash = new GHASH(ck)
  var len = iv.length
  var toPad = len % 16
  ghash.update(iv)
  if (toPad) {
    toPad = 16 - toPad
    ghash.update(Buffer.alloc(toPad, 0))
  }
  ghash.update(Buffer.alloc(8, 0))
  var ivBits = len * 8
  var tail = Buffer.alloc(8)
  tail.writeUIntBE(ivBits, 0, 8)
  ghash.update(tail)
  self._finID = ghash.state
  var out = Buffer.from(self._finID)
  incr32(out)
  return out
}
function StreamCipher (mode, key, iv, decrypt) {
  Transform.call(this)

  var h = Buffer.alloc(4, 0)

  this._cipher = new aes.AES(key)
  var ck = this._cipher.encryptBlock(h)
  this._ghash = new GHASH(ck)
  iv = calcIv(this, iv, ck)

  this._prev = Buffer.from(iv)
  this._cache = Buffer.allocUnsafe(0)
  this._secCache = Buffer.allocUnsafe(0)
  this._decrypt = decrypt
  this._alen = 0
  this._len = 0
  this._mode = mode

  this._authTag = null
  this._called = false
}

inherits(StreamCipher, Transform)

StreamCipher.prototype._update = function (chunk) {
  if (!this._called && this._alen) {
    var rump = 16 - (this._alen % 16)
    if (rump < 16) {
      rump = Buffer.alloc(rump, 0)
      this._ghash.update(rump)
    }
  }

  this._called = true
  var out = this._mode.encrypt(this, chunk)
  if (this._decrypt) {
    this._ghash.update(chunk)
  } else {
    this._ghash.update(out)
  }
  this._len += chunk.length
  return out
}

StreamCipher.prototype._final = function () {
  if (this._decrypt && !this._authTag) throw new Error('Unsupported state or unable to authenticate data')

  var tag = xor(this._ghash.final(this._alen * 8, this._len * 8), this._cipher.encryptBlock(this._finID))
  if (this._decrypt && xorTest(tag, this._authTag)) throw new Error('Unsupported state or unable to authenticate data')

  this._authTag = tag
  this._cipher.scrub()
}

StreamCipher.prototype.getAuthTag = function getAuthTag () {
  if (this._decrypt || !Buffer.isBuffer(this._authTag)) throw new Error('Attempting to get auth tag in unsupported state')

  return this._authTag
}

StreamCipher.prototype.setAuthTag = function setAuthTag (tag) {
  if (!this._decrypt) throw new Error('Attempting to set auth tag in unsupported state')

  this._authTag = tag
}

StreamCipher.prototype.setAAD = function setAAD (buf) {
  if (this._called) throw new Error('Attempting to set AAD in unsupported state')

  this._ghash.update(buf)
  this._alen += buf.length
}

module.exports = StreamCipher


/***/ }),

/***/ "./node_modules/browserify-aes/browser.js":
/*!************************************************!*\
  !*** ./node_modules/browserify-aes/browser.js ***!
  \************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var ciphers = __webpack_require__(/*! ./encrypter */ "./node_modules/browserify-aes/encrypter.js")
var deciphers = __webpack_require__(/*! ./decrypter */ "./node_modules/browserify-aes/decrypter.js")
var modes = __webpack_require__(/*! ./modes/list.json */ "./node_modules/browserify-aes/modes/list.json")

function getCiphers () {
  return Object.keys(modes)
}

exports.createCipher = exports.Cipher = ciphers.createCipher
exports.createCipheriv = exports.Cipheriv = ciphers.createCipheriv
exports.createDecipher = exports.Decipher = deciphers.createDecipher
exports.createDecipheriv = exports.Decipheriv = deciphers.createDecipheriv
exports.listCiphers = exports.getCiphers = getCiphers


/***/ }),

/***/ "./node_modules/browserify-aes/decrypter.js":
/*!**************************************************!*\
  !*** ./node_modules/browserify-aes/decrypter.js ***!
  \**************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var AuthCipher = __webpack_require__(/*! ./authCipher */ "./node_modules/browserify-aes/authCipher.js")
var Buffer = __webpack_require__(/*! safe-buffer */ "./node_modules/safe-buffer/index.js").Buffer
var MODES = __webpack_require__(/*! ./modes */ "./node_modules/browserify-aes/modes/index.js")
var StreamCipher = __webpack_require__(/*! ./streamCipher */ "./node_modules/browserify-aes/streamCipher.js")
var Transform = __webpack_require__(/*! cipher-base */ "./node_modules/cipher-base/index.js")
var aes = __webpack_require__(/*! ./aes */ "./node_modules/browserify-aes/aes.js")
var ebtk = __webpack_require__(/*! evp_bytestokey */ "./node_modules/evp_bytestokey/index.js")
var inherits = __webpack_require__(/*! inherits */ "./node_modules/inherits/inherits_browser.js")

function Decipher (mode, key, iv) {
  Transform.call(this)

  this._cache = new Splitter()
  this._last = void 0
  this._cipher = new aes.AES(key)
  this._prev = Buffer.from(iv)
  this._mode = mode
  this._autopadding = true
}

inherits(Decipher, Transform)

Decipher.prototype._update = function (data) {
  this._cache.add(data)
  var chunk
  var thing
  var out = []
  while ((chunk = this._cache.get(this._autopadding))) {
    thing = this._mode.decrypt(this, chunk)
    out.push(thing)
  }
  return Buffer.concat(out)
}

Decipher.prototype._final = function () {
  var chunk = this._cache.flush()
  if (this._autopadding) {
    return unpad(this._mode.decrypt(this, chunk))
  } else if (chunk) {
    throw new Error('data not multiple of block length')
  }
}

Decipher.prototype.setAutoPadding = function (setTo) {
  this._autopadding = !!setTo
  return this
}

function Splitter () {
  this.cache = Buffer.allocUnsafe(0)
}

Splitter.prototype.add = function (data) {
  this.cache = Buffer.concat([this.cache, data])
}

Splitter.prototype.get = function (autoPadding) {
  var out
  if (autoPadding) {
    if (this.cache.length > 16) {
      out = this.cache.slice(0, 16)
      this.cache = this.cache.slice(16)
      return out
    }
  } else {
    if (this.cache.length >= 16) {
      out = this.cache.slice(0, 16)
      this.cache = this.cache.slice(16)
      return out
    }
  }

  return null
}

Splitter.prototype.flush = function () {
  if (this.cache.length) return this.cache
}

function unpad (last) {
  var padded = last[15]
  if (padded < 1 || padded > 16) {
    throw new Error('unable to decrypt data')
  }
  var i = -1
  while (++i < padded) {
    if (last[(i + (16 - padded))] !== padded) {
      throw new Error('unable to decrypt data')
    }
  }
  if (padded === 16) return

  return last.slice(0, 16 - padded)
}

function createDecipheriv (suite, password, iv) {
  var config = MODES[suite.toLowerCase()]
  if (!config) throw new TypeError('invalid suite type')

  if (typeof iv === 'string') iv = Buffer.from(iv)
  if (config.mode !== 'GCM' && iv.length !== config.iv) throw new TypeError('invalid iv length ' + iv.length)

  if (typeof password === 'string') password = Buffer.from(password)
  if (password.length !== config.key / 8) throw new TypeError('invalid key length ' + password.length)

  if (config.type === 'stream') {
    return new StreamCipher(config.module, password, iv, true)
  } else if (config.type === 'auth') {
    return new AuthCipher(config.module, password, iv, true)
  }

  return new Decipher(config.module, password, iv)
}

function createDecipher (suite, password) {
  var config = MODES[suite.toLowerCase()]
  if (!config) throw new TypeError('invalid suite type')

  var keys = ebtk(password, false, config.key, config.iv)
  return createDecipheriv(suite, keys.key, keys.iv)
}

exports.createDecipher = createDecipher
exports.createDecipheriv = createDecipheriv


/***/ }),

/***/ "./node_modules/browserify-aes/encrypter.js":
/*!**************************************************!*\
  !*** ./node_modules/browserify-aes/encrypter.js ***!
  \**************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var MODES = __webpack_require__(/*! ./modes */ "./node_modules/browserify-aes/modes/index.js")
var AuthCipher = __webpack_require__(/*! ./authCipher */ "./node_modules/browserify-aes/authCipher.js")
var Buffer = __webpack_require__(/*! safe-buffer */ "./node_modules/safe-buffer/index.js").Buffer
var StreamCipher = __webpack_require__(/*! ./streamCipher */ "./node_modules/browserify-aes/streamCipher.js")
var Transform = __webpack_require__(/*! cipher-base */ "./node_modules/cipher-base/index.js")
var aes = __webpack_require__(/*! ./aes */ "./node_modules/browserify-aes/aes.js")
var ebtk = __webpack_require__(/*! evp_bytestokey */ "./node_modules/evp_bytestokey/index.js")
var inherits = __webpack_require__(/*! inherits */ "./node_modules/inherits/inherits_browser.js")

function Cipher (mode, key, iv) {
  Transform.call(this)

  this._cache = new Splitter()
  this._cipher = new aes.AES(key)
  this._prev = Buffer.from(iv)
  this._mode = mode
  this._autopadding = true
}

inherits(Cipher, Transform)

Cipher.prototype._update = function (data) {
  this._cache.add(data)
  var chunk
  var thing
  var out = []

  while ((chunk = this._cache.get())) {
    thing = this._mode.encrypt(this, chunk)
    out.push(thing)
  }

  return Buffer.concat(out)
}

var PADDING = Buffer.alloc(16, 0x10)

Cipher.prototype._final = function () {
  var chunk = this._cache.flush()
  if (this._autopadding) {
    chunk = this._mode.encrypt(this, chunk)
    this._cipher.scrub()
    return chunk
  }

  if (!chunk.equals(PADDING)) {
    this._cipher.scrub()
    throw new Error('data not multiple of block length')
  }
}

Cipher.prototype.setAutoPadding = function (setTo) {
  this._autopadding = !!setTo
  return this
}

function Splitter () {
  this.cache = Buffer.allocUnsafe(0)
}

Splitter.prototype.add = function (data) {
  this.cache = Buffer.concat([this.cache, data])
}

Splitter.prototype.get = function () {
  if (this.cache.length > 15) {
    var out = this.cache.slice(0, 16)
    this.cache = this.cache.slice(16)
    return out
  }
  return null
}

Splitter.prototype.flush = function () {
  var len = 16 - this.cache.length
  var padBuff = Buffer.allocUnsafe(len)

  var i = -1
  while (++i < len) {
    padBuff.writeUInt8(len, i)
  }

  return Buffer.concat([this.cache, padBuff])
}

function createCipheriv (suite, password, iv) {
  var config = MODES[suite.toLowerCase()]
  if (!config) throw new TypeError('invalid suite type')

  if (typeof password === 'string') password = Buffer.from(password)
  if (password.length !== config.key / 8) throw new TypeError('invalid key length ' + password.length)

  if (typeof iv === 'string') iv = Buffer.from(iv)
  if (config.mode !== 'GCM' && iv.length !== config.iv) throw new TypeError('invalid iv length ' + iv.length)

  if (config.type === 'stream') {
    return new StreamCipher(config.module, password, iv)
  } else if (config.type === 'auth') {
    return new AuthCipher(config.module, password, iv)
  }

  return new Cipher(config.module, password, iv)
}

function createCipher (suite, password) {
  var config = MODES[suite.toLowerCase()]
  if (!config) throw new TypeError('invalid suite type')

  var keys = ebtk(password, false, config.key, config.iv)
  return createCipheriv(suite, keys.key, keys.iv)
}

exports.createCipheriv = createCipheriv
exports.createCipher = createCipher


/***/ }),

/***/ "./node_modules/browserify-aes/ghash.js":
/*!**********************************************!*\
  !*** ./node_modules/browserify-aes/ghash.js ***!
  \**********************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var Buffer = __webpack_require__(/*! safe-buffer */ "./node_modules/safe-buffer/index.js").Buffer
var ZEROES = Buffer.alloc(16, 0)

function toArray (buf) {
  return [
    buf.readUInt32BE(0),
    buf.readUInt32BE(4),
    buf.readUInt32BE(8),
    buf.readUInt32BE(12)
  ]
}

function fromArray (out) {
  var buf = Buffer.allocUnsafe(16)
  buf.writeUInt32BE(out[0] >>> 0, 0)
  buf.writeUInt32BE(out[1] >>> 0, 4)
  buf.writeUInt32BE(out[2] >>> 0, 8)
  buf.writeUInt32BE(out[3] >>> 0, 12)
  return buf
}

function GHASH (key) {
  this.h = key
  this.state = Buffer.alloc(16, 0)
  this.cache = Buffer.allocUnsafe(0)
}

// from http://bitwiseshiftleft.github.io/sjcl/doc/symbols/src/core_gcm.js.html
// by Juho Vähä-Herttua
GHASH.prototype.ghash = function (block) {
  var i = -1
  while (++i < block.length) {
    this.state[i] ^= block[i]
  }
  this._multiply()
}

GHASH.prototype._multiply = function () {
  var Vi = toArray(this.h)
  var Zi = [0, 0, 0, 0]
  var j, xi, lsbVi
  var i = -1
  while (++i < 128) {
    xi = (this.state[~~(i / 8)] & (1 << (7 - (i % 8)))) !== 0
    if (xi) {
      // Z_i+1 = Z_i ^ V_i
      Zi[0] ^= Vi[0]
      Zi[1] ^= Vi[1]
      Zi[2] ^= Vi[2]
      Zi[3] ^= Vi[3]
    }

    // Store the value of LSB(V_i)
    lsbVi = (Vi[3] & 1) !== 0

    // V_i+1 = V_i >> 1
    for (j = 3; j > 0; j--) {
      Vi[j] = (Vi[j] >>> 1) | ((Vi[j - 1] & 1) << 31)
    }
    Vi[0] = Vi[0] >>> 1

    // If LSB(V_i) is 1, V_i+1 = (V_i >> 1) ^ R
    if (lsbVi) {
      Vi[0] = Vi[0] ^ (0xe1 << 24)
    }
  }
  this.state = fromArray(Zi)
}

GHASH.prototype.update = function (buf) {
  this.cache = Buffer.concat([this.cache, buf])
  var chunk
  while (this.cache.length >= 16) {
    chunk = this.cache.slice(0, 16)
    this.cache = this.cache.slice(16)
    this.ghash(chunk)
  }
}

GHASH.prototype.final = function (abl, bl) {
  if (this.cache.length) {
    this.ghash(Buffer.concat([this.cache, ZEROES], 16))
  }

  this.ghash(fromArray([0, abl, 0, bl]))
  return this.state
}

module.exports = GHASH


/***/ }),

/***/ "./node_modules/browserify-aes/incr32.js":
/*!***********************************************!*\
  !*** ./node_modules/browserify-aes/incr32.js ***!
  \***********************************************/
/*! no static exports found */
/***/ (function(module, exports) {

function incr32 (iv) {
  var len = iv.length
  var item
  while (len--) {
    item = iv.readUInt8(len)
    if (item === 255) {
      iv.writeUInt8(0, len)
    } else {
      item++
      iv.writeUInt8(item, len)
      break
    }
  }
}
module.exports = incr32


/***/ }),

/***/ "./node_modules/browserify-aes/modes/cbc.js":
/*!**************************************************!*\
  !*** ./node_modules/browserify-aes/modes/cbc.js ***!
  \**************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var xor = __webpack_require__(/*! buffer-xor */ "./node_modules/buffer-xor/index.js")

exports.encrypt = function (self, block) {
  var data = xor(block, self._prev)

  self._prev = self._cipher.encryptBlock(data)
  return self._prev
}

exports.decrypt = function (self, block) {
  var pad = self._prev

  self._prev = block
  var out = self._cipher.decryptBlock(block)

  return xor(out, pad)
}


/***/ }),

/***/ "./node_modules/browserify-aes/modes/cfb.js":
/*!**************************************************!*\
  !*** ./node_modules/browserify-aes/modes/cfb.js ***!
  \**************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var Buffer = __webpack_require__(/*! safe-buffer */ "./node_modules/safe-buffer/index.js").Buffer
var xor = __webpack_require__(/*! buffer-xor */ "./node_modules/buffer-xor/index.js")

function encryptStart (self, data, decrypt) {
  var len = data.length
  var out = xor(data, self._cache)
  self._cache = self._cache.slice(len)
  self._prev = Buffer.concat([self._prev, decrypt ? data : out])
  return out
}

exports.encrypt = function (self, data, decrypt) {
  var out = Buffer.allocUnsafe(0)
  var len

  while (data.length) {
    if (self._cache.length === 0) {
      self._cache = self._cipher.encryptBlock(self._prev)
      self._prev = Buffer.allocUnsafe(0)
    }

    if (self._cache.length <= data.length) {
      len = self._cache.length
      out = Buffer.concat([out, encryptStart(self, data.slice(0, len), decrypt)])
      data = data.slice(len)
    } else {
      out = Buffer.concat([out, encryptStart(self, data, decrypt)])
      break
    }
  }

  return out
}


/***/ }),

/***/ "./node_modules/browserify-aes/modes/cfb1.js":
/*!***************************************************!*\
  !*** ./node_modules/browserify-aes/modes/cfb1.js ***!
  \***************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var Buffer = __webpack_require__(/*! safe-buffer */ "./node_modules/safe-buffer/index.js").Buffer

function encryptByte (self, byteParam, decrypt) {
  var pad
  var i = -1
  var len = 8
  var out = 0
  var bit, value
  while (++i < len) {
    pad = self._cipher.encryptBlock(self._prev)
    bit = (byteParam & (1 << (7 - i))) ? 0x80 : 0
    value = pad[0] ^ bit
    out += ((value & 0x80) >> (i % 8))
    self._prev = shiftIn(self._prev, decrypt ? bit : value)
  }
  return out
}

function shiftIn (buffer, value) {
  var len = buffer.length
  var i = -1
  var out = Buffer.allocUnsafe(buffer.length)
  buffer = Buffer.concat([buffer, Buffer.from([value])])

  while (++i < len) {
    out[i] = buffer[i] << 1 | buffer[i + 1] >> (7)
  }

  return out
}

exports.encrypt = function (self, chunk, decrypt) {
  var len = chunk.length
  var out = Buffer.allocUnsafe(len)
  var i = -1

  while (++i < len) {
    out[i] = encryptByte(self, chunk[i], decrypt)
  }

  return out
}


/***/ }),

/***/ "./node_modules/browserify-aes/modes/cfb8.js":
/*!***************************************************!*\
  !*** ./node_modules/browserify-aes/modes/cfb8.js ***!
  \***************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var Buffer = __webpack_require__(/*! safe-buffer */ "./node_modules/safe-buffer/index.js").Buffer

function encryptByte (self, byteParam, decrypt) {
  var pad = self._cipher.encryptBlock(self._prev)
  var out = pad[0] ^ byteParam

  self._prev = Buffer.concat([
    self._prev.slice(1),
    Buffer.from([decrypt ? byteParam : out])
  ])

  return out
}

exports.encrypt = function (self, chunk, decrypt) {
  var len = chunk.length
  var out = Buffer.allocUnsafe(len)
  var i = -1

  while (++i < len) {
    out[i] = encryptByte(self, chunk[i], decrypt)
  }

  return out
}


/***/ }),

/***/ "./node_modules/browserify-aes/modes/ctr.js":
/*!**************************************************!*\
  !*** ./node_modules/browserify-aes/modes/ctr.js ***!
  \**************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var xor = __webpack_require__(/*! buffer-xor */ "./node_modules/buffer-xor/index.js")
var Buffer = __webpack_require__(/*! safe-buffer */ "./node_modules/safe-buffer/index.js").Buffer
var incr32 = __webpack_require__(/*! ../incr32 */ "./node_modules/browserify-aes/incr32.js")

function getBlock (self) {
  var out = self._cipher.encryptBlockRaw(self._prev)
  incr32(self._prev)
  return out
}

var blockSize = 16
exports.encrypt = function (self, chunk) {
  var chunkNum = Math.ceil(chunk.length / blockSize)
  var start = self._cache.length
  self._cache = Buffer.concat([
    self._cache,
    Buffer.allocUnsafe(chunkNum * blockSize)
  ])
  for (var i = 0; i < chunkNum; i++) {
    var out = getBlock(self)
    var offset = start + i * blockSize
    self._cache.writeUInt32BE(out[0], offset + 0)
    self._cache.writeUInt32BE(out[1], offset + 4)
    self._cache.writeUInt32BE(out[2], offset + 8)
    self._cache.writeUInt32BE(out[3], offset + 12)
  }
  var pad = self._cache.slice(0, chunk.length)
  self._cache = self._cache.slice(chunk.length)
  return xor(chunk, pad)
}


/***/ }),

/***/ "./node_modules/browserify-aes/modes/ecb.js":
/*!**************************************************!*\
  !*** ./node_modules/browserify-aes/modes/ecb.js ***!
  \**************************************************/
/*! no static exports found */
/***/ (function(module, exports) {

exports.encrypt = function (self, block) {
  return self._cipher.encryptBlock(block)
}

exports.decrypt = function (self, block) {
  return self._cipher.decryptBlock(block)
}


/***/ }),

/***/ "./node_modules/browserify-aes/modes/index.js":
/*!****************************************************!*\
  !*** ./node_modules/browserify-aes/modes/index.js ***!
  \****************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var modeModules = {
  ECB: __webpack_require__(/*! ./ecb */ "./node_modules/browserify-aes/modes/ecb.js"),
  CBC: __webpack_require__(/*! ./cbc */ "./node_modules/browserify-aes/modes/cbc.js"),
  CFB: __webpack_require__(/*! ./cfb */ "./node_modules/browserify-aes/modes/cfb.js"),
  CFB8: __webpack_require__(/*! ./cfb8 */ "./node_modules/browserify-aes/modes/cfb8.js"),
  CFB1: __webpack_require__(/*! ./cfb1 */ "./node_modules/browserify-aes/modes/cfb1.js"),
  OFB: __webpack_require__(/*! ./ofb */ "./node_modules/browserify-aes/modes/ofb.js"),
  CTR: __webpack_require__(/*! ./ctr */ "./node_modules/browserify-aes/modes/ctr.js"),
  GCM: __webpack_require__(/*! ./ctr */ "./node_modules/browserify-aes/modes/ctr.js")
}

var modes = __webpack_require__(/*! ./list.json */ "./node_modules/browserify-aes/modes/list.json")

for (var key in modes) {
  modes[key].module = modeModules[modes[key].mode]
}

module.exports = modes


/***/ }),

/***/ "./node_modules/browserify-aes/modes/list.json":
/*!*****************************************************!*\
  !*** ./node_modules/browserify-aes/modes/list.json ***!
  \*****************************************************/
/*! exports provided: aes-128-ecb, aes-192-ecb, aes-256-ecb, aes-128-cbc, aes-192-cbc, aes-256-cbc, aes128, aes192, aes256, aes-128-cfb, aes-192-cfb, aes-256-cfb, aes-128-cfb8, aes-192-cfb8, aes-256-cfb8, aes-128-cfb1, aes-192-cfb1, aes-256-cfb1, aes-128-ofb, aes-192-ofb, aes-256-ofb, aes-128-ctr, aes-192-ctr, aes-256-ctr, aes-128-gcm, aes-192-gcm, aes-256-gcm, default */
/***/ (function(module) {

module.exports = JSON.parse("{\"aes-128-ecb\":{\"cipher\":\"AES\",\"key\":128,\"iv\":0,\"mode\":\"ECB\",\"type\":\"block\"},\"aes-192-ecb\":{\"cipher\":\"AES\",\"key\":192,\"iv\":0,\"mode\":\"ECB\",\"type\":\"block\"},\"aes-256-ecb\":{\"cipher\":\"AES\",\"key\":256,\"iv\":0,\"mode\":\"ECB\",\"type\":\"block\"},\"aes-128-cbc\":{\"cipher\":\"AES\",\"key\":128,\"iv\":16,\"mode\":\"CBC\",\"type\":\"block\"},\"aes-192-cbc\":{\"cipher\":\"AES\",\"key\":192,\"iv\":16,\"mode\":\"CBC\",\"type\":\"block\"},\"aes-256-cbc\":{\"cipher\":\"AES\",\"key\":256,\"iv\":16,\"mode\":\"CBC\",\"type\":\"block\"},\"aes128\":{\"cipher\":\"AES\",\"key\":128,\"iv\":16,\"mode\":\"CBC\",\"type\":\"block\"},\"aes192\":{\"cipher\":\"AES\",\"key\":192,\"iv\":16,\"mode\":\"CBC\",\"type\":\"block\"},\"aes256\":{\"cipher\":\"AES\",\"key\":256,\"iv\":16,\"mode\":\"CBC\",\"type\":\"block\"},\"aes-128-cfb\":{\"cipher\":\"AES\",\"key\":128,\"iv\":16,\"mode\":\"CFB\",\"type\":\"stream\"},\"aes-192-cfb\":{\"cipher\":\"AES\",\"key\":192,\"iv\":16,\"mode\":\"CFB\",\"type\":\"stream\"},\"aes-256-cfb\":{\"cipher\":\"AES\",\"key\":256,\"iv\":16,\"mode\":\"CFB\",\"type\":\"stream\"},\"aes-128-cfb8\":{\"cipher\":\"AES\",\"key\":128,\"iv\":16,\"mode\":\"CFB8\",\"type\":\"stream\"},\"aes-192-cfb8\":{\"cipher\":\"AES\",\"key\":192,\"iv\":16,\"mode\":\"CFB8\",\"type\":\"stream\"},\"aes-256-cfb8\":{\"cipher\":\"AES\",\"key\":256,\"iv\":16,\"mode\":\"CFB8\",\"type\":\"stream\"},\"aes-128-cfb1\":{\"cipher\":\"AES\",\"key\":128,\"iv\":16,\"mode\":\"CFB1\",\"type\":\"stream\"},\"aes-192-cfb1\":{\"cipher\":\"AES\",\"key\":192,\"iv\":16,\"mode\":\"CFB1\",\"type\":\"stream\"},\"aes-256-cfb1\":{\"cipher\":\"AES\",\"key\":256,\"iv\":16,\"mode\":\"CFB1\",\"type\":\"stream\"},\"aes-128-ofb\":{\"cipher\":\"AES\",\"key\":128,\"iv\":16,\"mode\":\"OFB\",\"type\":\"stream\"},\"aes-192-ofb\":{\"cipher\":\"AES\",\"key\":192,\"iv\":16,\"mode\":\"OFB\",\"type\":\"stream\"},\"aes-256-ofb\":{\"cipher\":\"AES\",\"key\":256,\"iv\":16,\"mode\":\"OFB\",\"type\":\"stream\"},\"aes-128-ctr\":{\"cipher\":\"AES\",\"key\":128,\"iv\":16,\"mode\":\"CTR\",\"type\":\"stream\"},\"aes-192-ctr\":{\"cipher\":\"AES\",\"key\":192,\"iv\":16,\"mode\":\"CTR\",\"type\":\"stream\"},\"aes-256-ctr\":{\"cipher\":\"AES\",\"key\":256,\"iv\":16,\"mode\":\"CTR\",\"type\":\"stream\"},\"aes-128-gcm\":{\"cipher\":\"AES\",\"key\":128,\"iv\":12,\"mode\":\"GCM\",\"type\":\"auth\"},\"aes-192-gcm\":{\"cipher\":\"AES\",\"key\":192,\"iv\":12,\"mode\":\"GCM\",\"type\":\"auth\"},\"aes-256-gcm\":{\"cipher\":\"AES\",\"key\":256,\"iv\":12,\"mode\":\"GCM\",\"type\":\"auth\"}}");

/***/ }),

/***/ "./node_modules/browserify-aes/modes/ofb.js":
/*!**************************************************!*\
  !*** ./node_modules/browserify-aes/modes/ofb.js ***!
  \**************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(Buffer) {var xor = __webpack_require__(/*! buffer-xor */ "./node_modules/buffer-xor/index.js")

function getBlock (self) {
  self._prev = self._cipher.encryptBlock(self._prev)
  return self._prev
}

exports.encrypt = function (self, chunk) {
  while (self._cache.length < chunk.length) {
    self._cache = Buffer.concat([self._cache, getBlock(self)])
  }

  var pad = self._cache.slice(0, chunk.length)
  self._cache = self._cache.slice(chunk.length)
  return xor(chunk, pad)
}

/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(/*! ./../../node-libs-browser/node_modules/buffer/index.js */ "./node_modules/node-libs-browser/node_modules/buffer/index.js").Buffer))

/***/ }),

/***/ "./node_modules/browserify-aes/streamCipher.js":
/*!*****************************************************!*\
  !*** ./node_modules/browserify-aes/streamCipher.js ***!
  \*****************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var aes = __webpack_require__(/*! ./aes */ "./node_modules/browserify-aes/aes.js")
var Buffer = __webpack_require__(/*! safe-buffer */ "./node_modules/safe-buffer/index.js").Buffer
var Transform = __webpack_require__(/*! cipher-base */ "./node_modules/cipher-base/index.js")
var inherits = __webpack_require__(/*! inherits */ "./node_modules/inherits/inherits_browser.js")

function StreamCipher (mode, key, iv, decrypt) {
  Transform.call(this)

  this._cipher = new aes.AES(key)
  this._prev = Buffer.from(iv)
  this._cache = Buffer.allocUnsafe(0)
  this._secCache = Buffer.allocUnsafe(0)
  this._decrypt = decrypt
  this._mode = mode
}

inherits(StreamCipher, Transform)

StreamCipher.prototype._update = function (chunk) {
  return this._mode.encrypt(this, chunk, this._decrypt)
}

StreamCipher.prototype._final = function () {
  this._cipher.scrub()
}

module.exports = StreamCipher


/***/ }),

/***/ "./node_modules/browserify-cipher/browser.js":
/*!***************************************************!*\
  !*** ./node_modules/browserify-cipher/browser.js ***!
  \***************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var DES = __webpack_require__(/*! browserify-des */ "./node_modules/browserify-des/index.js")
var aes = __webpack_require__(/*! browserify-aes/browser */ "./node_modules/browserify-aes/browser.js")
var aesModes = __webpack_require__(/*! browserify-aes/modes */ "./node_modules/browserify-aes/modes/index.js")
var desModes = __webpack_require__(/*! browserify-des/modes */ "./node_modules/browserify-des/modes.js")
var ebtk = __webpack_require__(/*! evp_bytestokey */ "./node_modules/evp_bytestokey/index.js")

function createCipher (suite, password) {
  suite = suite.toLowerCase()

  var keyLen, ivLen
  if (aesModes[suite]) {
    keyLen = aesModes[suite].key
    ivLen = aesModes[suite].iv
  } else if (desModes[suite]) {
    keyLen = desModes[suite].key * 8
    ivLen = desModes[suite].iv
  } else {
    throw new TypeError('invalid suite type')
  }

  var keys = ebtk(password, false, keyLen, ivLen)
  return createCipheriv(suite, keys.key, keys.iv)
}

function createDecipher (suite, password) {
  suite = suite.toLowerCase()

  var keyLen, ivLen
  if (aesModes[suite]) {
    keyLen = aesModes[suite].key
    ivLen = aesModes[suite].iv
  } else if (desModes[suite]) {
    keyLen = desModes[suite].key * 8
    ivLen = desModes[suite].iv
  } else {
    throw new TypeError('invalid suite type')
  }

  var keys = ebtk(password, false, keyLen, ivLen)
  return createDecipheriv(suite, keys.key, keys.iv)
}

function createCipheriv (suite, key, iv) {
  suite = suite.toLowerCase()
  if (aesModes[suite]) return aes.createCipheriv(suite, key, iv)
  if (desModes[suite]) return new DES({ key: key, iv: iv, mode: suite })

  throw new TypeError('invalid suite type')
}

function createDecipheriv (suite, key, iv) {
  suite = suite.toLowerCase()
  if (aesModes[suite]) return aes.createDecipheriv(suite, key, iv)
  if (desModes[suite]) return new DES({ key: key, iv: iv, mode: suite, decrypt: true })

  throw new TypeError('invalid suite type')
}

function getCiphers () {
  return Object.keys(desModes).concat(aes.getCiphers())
}

exports.createCipher = exports.Cipher = createCipher
exports.createCipheriv = exports.Cipheriv = createCipheriv
exports.createDecipher = exports.Decipher = createDecipher
exports.createDecipheriv = exports.Decipheriv = createDecipheriv
exports.listCiphers = exports.getCiphers = getCiphers


/***/ }),

/***/ "./node_modules/browserify-des/index.js":
/*!**********************************************!*\
  !*** ./node_modules/browserify-des/index.js ***!
  \**********************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var CipherBase = __webpack_require__(/*! cipher-base */ "./node_modules/cipher-base/index.js")
var des = __webpack_require__(/*! des.js */ "./node_modules/des.js/lib/des.js")
var inherits = __webpack_require__(/*! inherits */ "./node_modules/inherits/inherits_browser.js")
var Buffer = __webpack_require__(/*! safe-buffer */ "./node_modules/safe-buffer/index.js").Buffer

var modes = {
  'des-ede3-cbc': des.CBC.instantiate(des.EDE),
  'des-ede3': des.EDE,
  'des-ede-cbc': des.CBC.instantiate(des.EDE),
  'des-ede': des.EDE,
  'des-cbc': des.CBC.instantiate(des.DES),
  'des-ecb': des.DES
}
modes.des = modes['des-cbc']
modes.des3 = modes['des-ede3-cbc']
module.exports = DES
inherits(DES, CipherBase)
function DES (opts) {
  CipherBase.call(this)
  var modeName = opts.mode.toLowerCase()
  var mode = modes[modeName]
  var type
  if (opts.decrypt) {
    type = 'decrypt'
  } else {
    type = 'encrypt'
  }
  var key = opts.key
  if (!Buffer.isBuffer(key)) {
    key = Buffer.from(key)
  }
  if (modeName === 'des-ede' || modeName === 'des-ede-cbc') {
    key = Buffer.concat([key, key.slice(0, 8)])
  }
  var iv = opts.iv
  if (!Buffer.isBuffer(iv)) {
    iv = Buffer.from(iv)
  }
  this._des = mode.create({
    key: key,
    iv: iv,
    type: type
  })
}
DES.prototype._update = function (data) {
  return Buffer.from(this._des.update(data))
}
DES.prototype._final = function () {
  return Buffer.from(this._des.final())
}


/***/ }),

/***/ "./node_modules/browserify-des/modes.js":
/*!**********************************************!*\
  !*** ./node_modules/browserify-des/modes.js ***!
  \**********************************************/
/*! no static exports found */
/***/ (function(module, exports) {

exports['des-ecb'] = {
  key: 8,
  iv: 0
}
exports['des-cbc'] = exports.des = {
  key: 8,
  iv: 8
}
exports['des-ede3-cbc'] = exports.des3 = {
  key: 24,
  iv: 8
}
exports['des-ede3'] = {
  key: 24,
  iv: 0
}
exports['des-ede-cbc'] = {
  key: 16,
  iv: 8
}
exports['des-ede'] = {
  key: 16,
  iv: 0
}


/***/ }),

/***/ "./node_modules/browserify-rsa/index.js":
/*!**********************************************!*\
  !*** ./node_modules/browserify-rsa/index.js ***!
  \**********************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(Buffer) {var BN = __webpack_require__(/*! bn.js */ "./node_modules/bn.js/lib/bn.js")
var randomBytes = __webpack_require__(/*! randombytes */ "./node_modules/randombytes/browser.js")

function blind (priv) {
  var r = getr(priv)
  var blinder = r.toRed(BN.mont(priv.modulus)).redPow(new BN(priv.publicExponent)).fromRed()
  return { blinder: blinder, unblinder: r.invm(priv.modulus) }
}

function getr (priv) {
  var len = priv.modulus.byteLength()
  var r
  do {
    r = new BN(randomBytes(len))
  } while (r.cmp(priv.modulus) >= 0 || !r.umod(priv.prime1) || !r.umod(priv.prime2))
  return r
}

function crt (msg, priv) {
  var blinds = blind(priv)
  var len = priv.modulus.byteLength()
  var blinded = new BN(msg).mul(blinds.blinder).umod(priv.modulus)
  var c1 = blinded.toRed(BN.mont(priv.prime1))
  var c2 = blinded.toRed(BN.mont(priv.prime2))
  var qinv = priv.coefficient
  var p = priv.prime1
  var q = priv.prime2
  var m1 = c1.redPow(priv.exponent1).fromRed()
  var m2 = c2.redPow(priv.exponent2).fromRed()
  var h = m1.isub(m2).imul(qinv).umod(p).imul(q)
  return m2.iadd(h).imul(blinds.unblinder).umod(priv.modulus).toArrayLike(Buffer, 'be', len)
}
crt.getr = getr

module.exports = crt

/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(/*! ./../node-libs-browser/node_modules/buffer/index.js */ "./node_modules/node-libs-browser/node_modules/buffer/index.js").Buffer))

/***/ }),

/***/ "./node_modules/browserify-sign/algos.js":
/*!***********************************************!*\
  !*** ./node_modules/browserify-sign/algos.js ***!
  \***********************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(/*! ./browser/algorithms.json */ "./node_modules/browserify-sign/browser/algorithms.json")


/***/ }),

/***/ "./node_modules/browserify-sign/browser/algorithms.json":
/*!**************************************************************!*\
  !*** ./node_modules/browserify-sign/browser/algorithms.json ***!
  \**************************************************************/
/*! exports provided: sha224WithRSAEncryption, RSA-SHA224, sha256WithRSAEncryption, RSA-SHA256, sha384WithRSAEncryption, RSA-SHA384, sha512WithRSAEncryption, RSA-SHA512, RSA-SHA1, ecdsa-with-SHA1, sha256, sha224, sha384, sha512, DSA-SHA, DSA-SHA1, DSA, DSA-WITH-SHA224, DSA-SHA224, DSA-WITH-SHA256, DSA-SHA256, DSA-WITH-SHA384, DSA-SHA384, DSA-WITH-SHA512, DSA-SHA512, DSA-RIPEMD160, ripemd160WithRSA, RSA-RIPEMD160, md5WithRSAEncryption, RSA-MD5, default */
/***/ (function(module) {

module.exports = JSON.parse("{\"sha224WithRSAEncryption\":{\"sign\":\"rsa\",\"hash\":\"sha224\",\"id\":\"302d300d06096086480165030402040500041c\"},\"RSA-SHA224\":{\"sign\":\"ecdsa/rsa\",\"hash\":\"sha224\",\"id\":\"302d300d06096086480165030402040500041c\"},\"sha256WithRSAEncryption\":{\"sign\":\"rsa\",\"hash\":\"sha256\",\"id\":\"3031300d060960864801650304020105000420\"},\"RSA-SHA256\":{\"sign\":\"ecdsa/rsa\",\"hash\":\"sha256\",\"id\":\"3031300d060960864801650304020105000420\"},\"sha384WithRSAEncryption\":{\"sign\":\"rsa\",\"hash\":\"sha384\",\"id\":\"3041300d060960864801650304020205000430\"},\"RSA-SHA384\":{\"sign\":\"ecdsa/rsa\",\"hash\":\"sha384\",\"id\":\"3041300d060960864801650304020205000430\"},\"sha512WithRSAEncryption\":{\"sign\":\"rsa\",\"hash\":\"sha512\",\"id\":\"3051300d060960864801650304020305000440\"},\"RSA-SHA512\":{\"sign\":\"ecdsa/rsa\",\"hash\":\"sha512\",\"id\":\"3051300d060960864801650304020305000440\"},\"RSA-SHA1\":{\"sign\":\"rsa\",\"hash\":\"sha1\",\"id\":\"3021300906052b0e03021a05000414\"},\"ecdsa-with-SHA1\":{\"sign\":\"ecdsa\",\"hash\":\"sha1\",\"id\":\"\"},\"sha256\":{\"sign\":\"ecdsa\",\"hash\":\"sha256\",\"id\":\"\"},\"sha224\":{\"sign\":\"ecdsa\",\"hash\":\"sha224\",\"id\":\"\"},\"sha384\":{\"sign\":\"ecdsa\",\"hash\":\"sha384\",\"id\":\"\"},\"sha512\":{\"sign\":\"ecdsa\",\"hash\":\"sha512\",\"id\":\"\"},\"DSA-SHA\":{\"sign\":\"dsa\",\"hash\":\"sha1\",\"id\":\"\"},\"DSA-SHA1\":{\"sign\":\"dsa\",\"hash\":\"sha1\",\"id\":\"\"},\"DSA\":{\"sign\":\"dsa\",\"hash\":\"sha1\",\"id\":\"\"},\"DSA-WITH-SHA224\":{\"sign\":\"dsa\",\"hash\":\"sha224\",\"id\":\"\"},\"DSA-SHA224\":{\"sign\":\"dsa\",\"hash\":\"sha224\",\"id\":\"\"},\"DSA-WITH-SHA256\":{\"sign\":\"dsa\",\"hash\":\"sha256\",\"id\":\"\"},\"DSA-SHA256\":{\"sign\":\"dsa\",\"hash\":\"sha256\",\"id\":\"\"},\"DSA-WITH-SHA384\":{\"sign\":\"dsa\",\"hash\":\"sha384\",\"id\":\"\"},\"DSA-SHA384\":{\"sign\":\"dsa\",\"hash\":\"sha384\",\"id\":\"\"},\"DSA-WITH-SHA512\":{\"sign\":\"dsa\",\"hash\":\"sha512\",\"id\":\"\"},\"DSA-SHA512\":{\"sign\":\"dsa\",\"hash\":\"sha512\",\"id\":\"\"},\"DSA-RIPEMD160\":{\"sign\":\"dsa\",\"hash\":\"rmd160\",\"id\":\"\"},\"ripemd160WithRSA\":{\"sign\":\"rsa\",\"hash\":\"rmd160\",\"id\":\"3021300906052b2403020105000414\"},\"RSA-RIPEMD160\":{\"sign\":\"rsa\",\"hash\":\"rmd160\",\"id\":\"3021300906052b2403020105000414\"},\"md5WithRSAEncryption\":{\"sign\":\"rsa\",\"hash\":\"md5\",\"id\":\"3020300c06082a864886f70d020505000410\"},\"RSA-MD5\":{\"sign\":\"rsa\",\"hash\":\"md5\",\"id\":\"3020300c06082a864886f70d020505000410\"}}");

/***/ }),

/***/ "./node_modules/browserify-sign/browser/curves.json":
/*!**********************************************************!*\
  !*** ./node_modules/browserify-sign/browser/curves.json ***!
  \**********************************************************/
/*! exports provided: 1.3.132.0.10, 1.3.132.0.33, 1.2.840.10045.3.1.1, 1.2.840.10045.3.1.7, 1.3.132.0.34, 1.3.132.0.35, default */
/***/ (function(module) {

module.exports = JSON.parse("{\"1.3.132.0.10\":\"secp256k1\",\"1.3.132.0.33\":\"p224\",\"1.2.840.10045.3.1.1\":\"p192\",\"1.2.840.10045.3.1.7\":\"p256\",\"1.3.132.0.34\":\"p384\",\"1.3.132.0.35\":\"p521\"}");

/***/ }),

/***/ "./node_modules/browserify-sign/browser/index.js":
/*!*******************************************************!*\
  !*** ./node_modules/browserify-sign/browser/index.js ***!
  \*******************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var Buffer = __webpack_require__(/*! safe-buffer */ "./node_modules/browserify-sign/node_modules/safe-buffer/index.js").Buffer
var createHash = __webpack_require__(/*! create-hash */ "./node_modules/create-hash/browser.js")
var stream = __webpack_require__(/*! readable-stream */ "./node_modules/browserify-sign/node_modules/readable-stream/readable-browser.js")
var inherits = __webpack_require__(/*! inherits */ "./node_modules/inherits/inherits_browser.js")
var sign = __webpack_require__(/*! ./sign */ "./node_modules/browserify-sign/browser/sign.js")
var verify = __webpack_require__(/*! ./verify */ "./node_modules/browserify-sign/browser/verify.js")

var algorithms = __webpack_require__(/*! ./algorithms.json */ "./node_modules/browserify-sign/browser/algorithms.json")
Object.keys(algorithms).forEach(function (key) {
  algorithms[key].id = Buffer.from(algorithms[key].id, 'hex')
  algorithms[key.toLowerCase()] = algorithms[key]
})

function Sign (algorithm) {
  stream.Writable.call(this)

  var data = algorithms[algorithm]
  if (!data) throw new Error('Unknown message digest')

  this._hashType = data.hash
  this._hash = createHash(data.hash)
  this._tag = data.id
  this._signType = data.sign
}
inherits(Sign, stream.Writable)

Sign.prototype._write = function _write (data, _, done) {
  this._hash.update(data)
  done()
}

Sign.prototype.update = function update (data, enc) {
  if (typeof data === 'string') data = Buffer.from(data, enc)

  this._hash.update(data)
  return this
}

Sign.prototype.sign = function signMethod (key, enc) {
  this.end()
  var hash = this._hash.digest()
  var sig = sign(hash, key, this._hashType, this._signType, this._tag)

  return enc ? sig.toString(enc) : sig
}

function Verify (algorithm) {
  stream.Writable.call(this)

  var data = algorithms[algorithm]
  if (!data) throw new Error('Unknown message digest')

  this._hash = createHash(data.hash)
  this._tag = data.id
  this._signType = data.sign
}
inherits(Verify, stream.Writable)

Verify.prototype._write = function _write (data, _, done) {
  this._hash.update(data)
  done()
}

Verify.prototype.update = function update (data, enc) {
  if (typeof data === 'string') data = Buffer.from(data, enc)

  this._hash.update(data)
  return this
}

Verify.prototype.verify = function verifyMethod (key, sig, enc) {
  if (typeof sig === 'string') sig = Buffer.from(sig, enc)

  this.end()
  var hash = this._hash.digest()
  return verify(sig, hash, key, this._signType, this._tag)
}

function createSign (algorithm) {
  return new Sign(algorithm)
}

function createVerify (algorithm) {
  return new Verify(algorithm)
}

module.exports = {
  Sign: createSign,
  Verify: createVerify,
  createSign: createSign,
  createVerify: createVerify
}


/***/ }),

/***/ "./node_modules/browserify-sign/browser/sign.js":
/*!******************************************************!*\
  !*** ./node_modules/browserify-sign/browser/sign.js ***!
  \******************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

// much of this based on https://github.com/indutny/self-signed/blob/gh-pages/lib/rsa.js
var Buffer = __webpack_require__(/*! safe-buffer */ "./node_modules/browserify-sign/node_modules/safe-buffer/index.js").Buffer
var createHmac = __webpack_require__(/*! create-hmac */ "./node_modules/create-hmac/browser.js")
var crt = __webpack_require__(/*! browserify-rsa */ "./node_modules/browserify-rsa/index.js")
var EC = __webpack_require__(/*! elliptic */ "./node_modules/elliptic/lib/elliptic.js").ec
var BN = __webpack_require__(/*! bn.js */ "./node_modules/bn.js/lib/bn.js")
var parseKeys = __webpack_require__(/*! parse-asn1 */ "./node_modules/parse-asn1/index.js")
var curves = __webpack_require__(/*! ./curves.json */ "./node_modules/browserify-sign/browser/curves.json")

function sign (hash, key, hashType, signType, tag) {
  var priv = parseKeys(key)
  if (priv.curve) {
    // rsa keys can be interpreted as ecdsa ones in openssl
    if (signType !== 'ecdsa' && signType !== 'ecdsa/rsa') throw new Error('wrong private key type')
    return ecSign(hash, priv)
  } else if (priv.type === 'dsa') {
    if (signType !== 'dsa') throw new Error('wrong private key type')
    return dsaSign(hash, priv, hashType)
  } else {
    if (signType !== 'rsa' && signType !== 'ecdsa/rsa') throw new Error('wrong private key type')
  }
  hash = Buffer.concat([tag, hash])
  var len = priv.modulus.byteLength()
  var pad = [0, 1]
  while (hash.length + pad.length + 1 < len) pad.push(0xff)
  pad.push(0x00)
  var i = -1
  while (++i < hash.length) pad.push(hash[i])

  var out = crt(pad, priv)
  return out
}

function ecSign (hash, priv) {
  var curveId = curves[priv.curve.join('.')]
  if (!curveId) throw new Error('unknown curve ' + priv.curve.join('.'))

  var curve = new EC(curveId)
  var key = curve.keyFromPrivate(priv.privateKey)
  var out = key.sign(hash)

  return Buffer.from(out.toDER())
}

function dsaSign (hash, priv, algo) {
  var x = priv.params.priv_key
  var p = priv.params.p
  var q = priv.params.q
  var g = priv.params.g
  var r = new BN(0)
  var k
  var H = bits2int(hash, q).mod(q)
  var s = false
  var kv = getKey(x, q, hash, algo)
  while (s === false) {
    k = makeKey(q, kv, algo)
    r = makeR(g, k, p, q)
    s = k.invm(q).imul(H.add(x.mul(r))).mod(q)
    if (s.cmpn(0) === 0) {
      s = false
      r = new BN(0)
    }
  }
  return toDER(r, s)
}

function toDER (r, s) {
  r = r.toArray()
  s = s.toArray()

  // Pad values
  if (r[0] & 0x80) r = [0].concat(r)
  if (s[0] & 0x80) s = [0].concat(s)

  var total = r.length + s.length + 4
  var res = [0x30, total, 0x02, r.length]
  res = res.concat(r, [0x02, s.length], s)
  return Buffer.from(res)
}

function getKey (x, q, hash, algo) {
  x = Buffer.from(x.toArray())
  if (x.length < q.byteLength()) {
    var zeros = Buffer.alloc(q.byteLength() - x.length)
    x = Buffer.concat([zeros, x])
  }
  var hlen = hash.length
  var hbits = bits2octets(hash, q)
  var v = Buffer.alloc(hlen)
  v.fill(1)
  var k = Buffer.alloc(hlen)
  k = createHmac(algo, k).update(v).update(Buffer.from([0])).update(x).update(hbits).digest()
  v = createHmac(algo, k).update(v).digest()
  k = createHmac(algo, k).update(v).update(Buffer.from([1])).update(x).update(hbits).digest()
  v = createHmac(algo, k).update(v).digest()
  return { k: k, v: v }
}

function bits2int (obits, q) {
  var bits = new BN(obits)
  var shift = (obits.length << 3) - q.bitLength()
  if (shift > 0) bits.ishrn(shift)
  return bits
}

function bits2octets (bits, q) {
  bits = bits2int(bits, q)
  bits = bits.mod(q)
  var out = Buffer.from(bits.toArray())
  if (out.length < q.byteLength()) {
    var zeros = Buffer.alloc(q.byteLength() - out.length)
    out = Buffer.concat([zeros, out])
  }
  return out
}

function makeKey (q, kv, algo) {
  var t
  var k

  do {
    t = Buffer.alloc(0)

    while (t.length * 8 < q.bitLength()) {
      kv.v = createHmac(algo, kv.k).update(kv.v).digest()
      t = Buffer.concat([t, kv.v])
    }

    k = bits2int(t, q)
    kv.k = createHmac(algo, kv.k).update(kv.v).update(Buffer.from([0])).digest()
    kv.v = createHmac(algo, kv.k).update(kv.v).digest()
  } while (k.cmp(q) !== -1)

  return k
}

function makeR (g, k, p, q) {
  return g.toRed(BN.mont(p)).redPow(k).fromRed().mod(q)
}

module.exports = sign
module.exports.getKey = getKey
module.exports.makeKey = makeKey


/***/ }),

/***/ "./node_modules/browserify-sign/browser/verify.js":
/*!********************************************************!*\
  !*** ./node_modules/browserify-sign/browser/verify.js ***!
  \********************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

// much of this based on https://github.com/indutny/self-signed/blob/gh-pages/lib/rsa.js
var Buffer = __webpack_require__(/*! safe-buffer */ "./node_modules/browserify-sign/node_modules/safe-buffer/index.js").Buffer
var BN = __webpack_require__(/*! bn.js */ "./node_modules/bn.js/lib/bn.js")
var EC = __webpack_require__(/*! elliptic */ "./node_modules/elliptic/lib/elliptic.js").ec
var parseKeys = __webpack_require__(/*! parse-asn1 */ "./node_modules/parse-asn1/index.js")
var curves = __webpack_require__(/*! ./curves.json */ "./node_modules/browserify-sign/browser/curves.json")

function verify (sig, hash, key, signType, tag) {
  var pub = parseKeys(key)
  if (pub.type === 'ec') {
    // rsa keys can be interpreted as ecdsa ones in openssl
    if (signType !== 'ecdsa' && signType !== 'ecdsa/rsa') throw new Error('wrong public key type')
    return ecVerify(sig, hash, pub)
  } else if (pub.type === 'dsa') {
    if (signType !== 'dsa') throw new Error('wrong public key type')
    return dsaVerify(sig, hash, pub)
  } else {
    if (signType !== 'rsa' && signType !== 'ecdsa/rsa') throw new Error('wrong public key type')
  }
  hash = Buffer.concat([tag, hash])
  var len = pub.modulus.byteLength()
  var pad = [1]
  var padNum = 0
  while (hash.length + pad.length + 2 < len) {
    pad.push(0xff)
    padNum++
  }
  pad.push(0x00)
  var i = -1
  while (++i < hash.length) {
    pad.push(hash[i])
  }
  pad = Buffer.from(pad)
  var red = BN.mont(pub.modulus)
  sig = new BN(sig).toRed(red)

  sig = sig.redPow(new BN(pub.publicExponent))
  sig = Buffer.from(sig.fromRed().toArray())
  var out = padNum < 8 ? 1 : 0
  len = Math.min(sig.length, pad.length)
  if (sig.length !== pad.length) out = 1

  i = -1
  while (++i < len) out |= sig[i] ^ pad[i]
  return out === 0
}

function ecVerify (sig, hash, pub) {
  var curveId = curves[pub.data.algorithm.curve.join('.')]
  if (!curveId) throw new Error('unknown curve ' + pub.data.algorithm.curve.join('.'))

  var curve = new EC(curveId)
  var pubkey = pub.data.subjectPrivateKey.data

  return curve.verify(hash, sig, pubkey)
}

function dsaVerify (sig, hash, pub) {
  var p = pub.data.p
  var q = pub.data.q
  var g = pub.data.g
  var y = pub.data.pub_key
  var unpacked = parseKeys.signature.decode(sig, 'der')
  var s = unpacked.s
  var r = unpacked.r
  checkValue(s, q)
  checkValue(r, q)
  var montp = BN.mont(p)
  var w = s.invm(q)
  var v = g.toRed(montp)
    .redPow(new BN(hash).mul(w).mod(q))
    .fromRed()
    .mul(y.toRed(montp).redPow(r.mul(w).mod(q)).fromRed())
    .mod(p)
    .mod(q)
  return v.cmp(r) === 0
}

function checkValue (b, q) {
  if (b.cmpn(0) <= 0) throw new Error('invalid sig')
  if (b.cmp(q) >= q) throw new Error('invalid sig')
}

module.exports = verify


/***/ }),

/***/ "./node_modules/browserify-sign/node_modules/readable-stream/errors-browser.js":
/*!*************************************************************************************!*\
  !*** ./node_modules/browserify-sign/node_modules/readable-stream/errors-browser.js ***!
  \*************************************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

var codes = {};

function createErrorType(code, message, Base) {
  if (!Base) {
    Base = Error;
  }

  function getMessage(arg1, arg2, arg3) {
    if (typeof message === 'string') {
      return message;
    } else {
      return message(arg1, arg2, arg3);
    }
  }

  var NodeError =
  /*#__PURE__*/
  function (_Base) {
    _inheritsLoose(NodeError, _Base);

    function NodeError(arg1, arg2, arg3) {
      return _Base.call(this, getMessage(arg1, arg2, arg3)) || this;
    }

    return NodeError;
  }(Base);

  NodeError.prototype.name = Base.name;
  NodeError.prototype.code = code;
  codes[code] = NodeError;
} // https://github.com/nodejs/node/blob/v10.8.0/lib/internal/errors.js


function oneOf(expected, thing) {
  if (Array.isArray(expected)) {
    var len = expected.length;
    expected = expected.map(function (i) {
      return String(i);
    });

    if (len > 2) {
      return "one of ".concat(thing, " ").concat(expected.slice(0, len - 1).join(', '), ", or ") + expected[len - 1];
    } else if (len === 2) {
      return "one of ".concat(thing, " ").concat(expected[0], " or ").concat(expected[1]);
    } else {
      return "of ".concat(thing, " ").concat(expected[0]);
    }
  } else {
    return "of ".concat(thing, " ").concat(String(expected));
  }
} // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/startsWith


function startsWith(str, search, pos) {
  return str.substr(!pos || pos < 0 ? 0 : +pos, search.length) === search;
} // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/endsWith


function endsWith(str, search, this_len) {
  if (this_len === undefined || this_len > str.length) {
    this_len = str.length;
  }

  return str.substring(this_len - search.length, this_len) === search;
} // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/includes


function includes(str, search, start) {
  if (typeof start !== 'number') {
    start = 0;
  }

  if (start + search.length > str.length) {
    return false;
  } else {
    return str.indexOf(search, start) !== -1;
  }
}

createErrorType('ERR_INVALID_OPT_VALUE', function (name, value) {
  return 'The value "' + value + '" is invalid for option "' + name + '"';
}, TypeError);
createErrorType('ERR_INVALID_ARG_TYPE', function (name, expected, actual) {
  // determiner: 'must be' or 'must not be'
  var determiner;

  if (typeof expected === 'string' && startsWith(expected, 'not ')) {
    determiner = 'must not be';
    expected = expected.replace(/^not /, '');
  } else {
    determiner = 'must be';
  }

  var msg;

  if (endsWith(name, ' argument')) {
    // For cases like 'first argument'
    msg = "The ".concat(name, " ").concat(determiner, " ").concat(oneOf(expected, 'type'));
  } else {
    var type = includes(name, '.') ? 'property' : 'argument';
    msg = "The \"".concat(name, "\" ").concat(type, " ").concat(determiner, " ").concat(oneOf(expected, 'type'));
  }

  msg += ". Received type ".concat(typeof actual);
  return msg;
}, TypeError);
createErrorType('ERR_STREAM_PUSH_AFTER_EOF', 'stream.push() after EOF');
createErrorType('ERR_METHOD_NOT_IMPLEMENTED', function (name) {
  return 'The ' + name + ' method is not implemented';
});
createErrorType('ERR_STREAM_PREMATURE_CLOSE', 'Premature close');
createErrorType('ERR_STREAM_DESTROYED', function (name) {
  return 'Cannot call ' + name + ' after a stream was destroyed';
});
createErrorType('ERR_MULTIPLE_CALLBACK', 'Callback called multiple times');
createErrorType('ERR_STREAM_CANNOT_PIPE', 'Cannot pipe, not readable');
createErrorType('ERR_STREAM_WRITE_AFTER_END', 'write after end');
createErrorType('ERR_STREAM_NULL_VALUES', 'May not write null values to stream', TypeError);
createErrorType('ERR_UNKNOWN_ENCODING', function (arg) {
  return 'Unknown encoding: ' + arg;
}, TypeError);
createErrorType('ERR_STREAM_UNSHIFT_AFTER_END_EVENT', 'stream.unshift() after end event');
module.exports.codes = codes;


/***/ }),

/***/ "./node_modules/browserify-sign/node_modules/readable-stream/lib/_stream_duplex.js":
/*!*****************************************************************************************!*\
  !*** ./node_modules/browserify-sign/node_modules/readable-stream/lib/_stream_duplex.js ***!
  \*****************************************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a duplex stream is just a stream that is both readable and writable.
// Since JS doesn't have multiple prototypal inheritance, this class
// prototypally inherits from Readable, and then parasitically from
// Writable.

/*<replacement>*/

var objectKeys = Object.keys || function (obj) {
  var keys = [];

  for (var key in obj) {
    keys.push(key);
  }

  return keys;
};
/*</replacement>*/


module.exports = Duplex;

var Readable = __webpack_require__(/*! ./_stream_readable */ "./node_modules/browserify-sign/node_modules/readable-stream/lib/_stream_readable.js");

var Writable = __webpack_require__(/*! ./_stream_writable */ "./node_modules/browserify-sign/node_modules/readable-stream/lib/_stream_writable.js");

__webpack_require__(/*! inherits */ "./node_modules/inherits/inherits_browser.js")(Duplex, Readable);

{
  // Allow the keys array to be GC'ed.
  var keys = objectKeys(Writable.prototype);

  for (var v = 0; v < keys.length; v++) {
    var method = keys[v];
    if (!Duplex.prototype[method]) Duplex.prototype[method] = Writable.prototype[method];
  }
}

function Duplex(options) {
  if (!(this instanceof Duplex)) return new Duplex(options);
  Readable.call(this, options);
  Writable.call(this, options);
  this.allowHalfOpen = true;

  if (options) {
    if (options.readable === false) this.readable = false;
    if (options.writable === false) this.writable = false;

    if (options.allowHalfOpen === false) {
      this.allowHalfOpen = false;
      this.once('end', onend);
    }
  }
}

Object.defineProperty(Duplex.prototype, 'writableHighWaterMark', {
  // making it explicit this property is not enumerable
  // because otherwise some prototype manipulation in
  // userland will fail
  enumerable: false,
  get: function get() {
    return this._writableState.highWaterMark;
  }
});
Object.defineProperty(Duplex.prototype, 'writableBuffer', {
  // making it explicit this property is not enumerable
  // because otherwise some prototype manipulation in
  // userland will fail
  enumerable: false,
  get: function get() {
    return this._writableState && this._writableState.getBuffer();
  }
});
Object.defineProperty(Duplex.prototype, 'writableLength', {
  // making it explicit this property is not enumerable
  // because otherwise some prototype manipulation in
  // userland will fail
  enumerable: false,
  get: function get() {
    return this._writableState.length;
  }
}); // the no-half-open enforcer

function onend() {
  // If the writable side ended, then we're ok.
  if (this._writableState.ended) return; // no more data can be written.
  // But allow more writes to happen in this tick.

  process.nextTick(onEndNT, this);
}

function onEndNT(self) {
  self.end();
}

Object.defineProperty(Duplex.prototype, 'destroyed', {
  // making it explicit this property is not enumerable
  // because otherwise some prototype manipulation in
  // userland will fail
  enumerable: false,
  get: function get() {
    if (this._readableState === undefined || this._writableState === undefined) {
      return false;
    }

    return this._readableState.destroyed && this._writableState.destroyed;
  },
  set: function set(value) {
    // we ignore the value if the stream
    // has not been initialized yet
    if (this._readableState === undefined || this._writableState === undefined) {
      return;
    } // backward compatibility, the user is explicitly
    // managing destroyed


    this._readableState.destroyed = value;
    this._writableState.destroyed = value;
  }
});
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(/*! ./../../../../process/browser.js */ "./node_modules/process/browser.js")))

/***/ }),

/***/ "./node_modules/browserify-sign/node_modules/readable-stream/lib/_stream_passthrough.js":
/*!**********************************************************************************************!*\
  !*** ./node_modules/browserify-sign/node_modules/readable-stream/lib/_stream_passthrough.js ***!
  \**********************************************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a passthrough stream.
// basically just the most minimal sort of Transform stream.
// Every written chunk gets output as-is.


module.exports = PassThrough;

var Transform = __webpack_require__(/*! ./_stream_transform */ "./node_modules/browserify-sign/node_modules/readable-stream/lib/_stream_transform.js");

__webpack_require__(/*! inherits */ "./node_modules/inherits/inherits_browser.js")(PassThrough, Transform);

function PassThrough(options) {
  if (!(this instanceof PassThrough)) return new PassThrough(options);
  Transform.call(this, options);
}

PassThrough.prototype._transform = function (chunk, encoding, cb) {
  cb(null, chunk);
};

/***/ }),

/***/ "./node_modules/browserify-sign/node_modules/readable-stream/lib/_stream_readable.js":
/*!*******************************************************************************************!*\
  !*** ./node_modules/browserify-sign/node_modules/readable-stream/lib/_stream_readable.js ***!
  \*******************************************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global, process) {// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.


module.exports = Readable;
/*<replacement>*/

var Duplex;
/*</replacement>*/

Readable.ReadableState = ReadableState;
/*<replacement>*/

var EE = __webpack_require__(/*! events */ "./node_modules/events/events.js").EventEmitter;

var EElistenerCount = function EElistenerCount(emitter, type) {
  return emitter.listeners(type).length;
};
/*</replacement>*/

/*<replacement>*/


var Stream = __webpack_require__(/*! ./internal/streams/stream */ "./node_modules/browserify-sign/node_modules/readable-stream/lib/internal/streams/stream-browser.js");
/*</replacement>*/


var Buffer = __webpack_require__(/*! buffer */ "./node_modules/node-libs-browser/node_modules/buffer/index.js").Buffer;

var OurUint8Array = global.Uint8Array || function () {};

function _uint8ArrayToBuffer(chunk) {
  return Buffer.from(chunk);
}

function _isUint8Array(obj) {
  return Buffer.isBuffer(obj) || obj instanceof OurUint8Array;
}
/*<replacement>*/


var debugUtil = __webpack_require__(/*! util */ 7);

var debug;

if (debugUtil && debugUtil.debuglog) {
  debug = debugUtil.debuglog('stream');
} else {
  debug = function debug() {};
}
/*</replacement>*/


var BufferList = __webpack_require__(/*! ./internal/streams/buffer_list */ "./node_modules/browserify-sign/node_modules/readable-stream/lib/internal/streams/buffer_list.js");

var destroyImpl = __webpack_require__(/*! ./internal/streams/destroy */ "./node_modules/browserify-sign/node_modules/readable-stream/lib/internal/streams/destroy.js");

var _require = __webpack_require__(/*! ./internal/streams/state */ "./node_modules/browserify-sign/node_modules/readable-stream/lib/internal/streams/state.js"),
    getHighWaterMark = _require.getHighWaterMark;

var _require$codes = __webpack_require__(/*! ../errors */ "./node_modules/browserify-sign/node_modules/readable-stream/errors-browser.js").codes,
    ERR_INVALID_ARG_TYPE = _require$codes.ERR_INVALID_ARG_TYPE,
    ERR_STREAM_PUSH_AFTER_EOF = _require$codes.ERR_STREAM_PUSH_AFTER_EOF,
    ERR_METHOD_NOT_IMPLEMENTED = _require$codes.ERR_METHOD_NOT_IMPLEMENTED,
    ERR_STREAM_UNSHIFT_AFTER_END_EVENT = _require$codes.ERR_STREAM_UNSHIFT_AFTER_END_EVENT; // Lazy loaded to improve the startup performance.


var StringDecoder;
var createReadableStreamAsyncIterator;
var from;

__webpack_require__(/*! inherits */ "./node_modules/inherits/inherits_browser.js")(Readable, Stream);

var errorOrDestroy = destroyImpl.errorOrDestroy;
var kProxyEvents = ['error', 'close', 'destroy', 'pause', 'resume'];

function prependListener(emitter, event, fn) {
  // Sadly this is not cacheable as some libraries bundle their own
  // event emitter implementation with them.
  if (typeof emitter.prependListener === 'function') return emitter.prependListener(event, fn); // This is a hack to make sure that our error handler is attached before any
  // userland ones.  NEVER DO THIS. This is here only because this code needs
  // to continue to work with older versions of Node.js that do not include
  // the prependListener() method. The goal is to eventually remove this hack.

  if (!emitter._events || !emitter._events[event]) emitter.on(event, fn);else if (Array.isArray(emitter._events[event])) emitter._events[event].unshift(fn);else emitter._events[event] = [fn, emitter._events[event]];
}

function ReadableState(options, stream, isDuplex) {
  Duplex = Duplex || __webpack_require__(/*! ./_stream_duplex */ "./node_modules/browserify-sign/node_modules/readable-stream/lib/_stream_duplex.js");
  options = options || {}; // Duplex streams are both readable and writable, but share
  // the same options object.
  // However, some cases require setting options to different
  // values for the readable and the writable sides of the duplex stream.
  // These options can be provided separately as readableXXX and writableXXX.

  if (typeof isDuplex !== 'boolean') isDuplex = stream instanceof Duplex; // object stream flag. Used to make read(n) ignore n and to
  // make all the buffer merging and length checks go away

  this.objectMode = !!options.objectMode;
  if (isDuplex) this.objectMode = this.objectMode || !!options.readableObjectMode; // the point at which it stops calling _read() to fill the buffer
  // Note: 0 is a valid value, means "don't call _read preemptively ever"

  this.highWaterMark = getHighWaterMark(this, options, 'readableHighWaterMark', isDuplex); // A linked list is used to store data chunks instead of an array because the
  // linked list can remove elements from the beginning faster than
  // array.shift()

  this.buffer = new BufferList();
  this.length = 0;
  this.pipes = null;
  this.pipesCount = 0;
  this.flowing = null;
  this.ended = false;
  this.endEmitted = false;
  this.reading = false; // a flag to be able to tell if the event 'readable'/'data' is emitted
  // immediately, or on a later tick.  We set this to true at first, because
  // any actions that shouldn't happen until "later" should generally also
  // not happen before the first read call.

  this.sync = true; // whenever we return null, then we set a flag to say
  // that we're awaiting a 'readable' event emission.

  this.needReadable = false;
  this.emittedReadable = false;
  this.readableListening = false;
  this.resumeScheduled = false;
  this.paused = true; // Should close be emitted on destroy. Defaults to true.

  this.emitClose = options.emitClose !== false; // Should .destroy() be called after 'end' (and potentially 'finish')

  this.autoDestroy = !!options.autoDestroy; // has it been destroyed

  this.destroyed = false; // Crypto is kind of old and crusty.  Historically, its default string
  // encoding is 'binary' so we have to make this configurable.
  // Everything else in the universe uses 'utf8', though.

  this.defaultEncoding = options.defaultEncoding || 'utf8'; // the number of writers that are awaiting a drain event in .pipe()s

  this.awaitDrain = 0; // if true, a maybeReadMore has been scheduled

  this.readingMore = false;
  this.decoder = null;
  this.encoding = null;

  if (options.encoding) {
    if (!StringDecoder) StringDecoder = __webpack_require__(/*! string_decoder/ */ "./node_modules/string_decoder/lib/string_decoder.js").StringDecoder;
    this.decoder = new StringDecoder(options.encoding);
    this.encoding = options.encoding;
  }
}

function Readable(options) {
  Duplex = Duplex || __webpack_require__(/*! ./_stream_duplex */ "./node_modules/browserify-sign/node_modules/readable-stream/lib/_stream_duplex.js");
  if (!(this instanceof Readable)) return new Readable(options); // Checking for a Stream.Duplex instance is faster here instead of inside
  // the ReadableState constructor, at least with V8 6.5

  var isDuplex = this instanceof Duplex;
  this._readableState = new ReadableState(options, this, isDuplex); // legacy

  this.readable = true;

  if (options) {
    if (typeof options.read === 'function') this._read = options.read;
    if (typeof options.destroy === 'function') this._destroy = options.destroy;
  }

  Stream.call(this);
}

Object.defineProperty(Readable.prototype, 'destroyed', {
  // making it explicit this property is not enumerable
  // because otherwise some prototype manipulation in
  // userland will fail
  enumerable: false,
  get: function get() {
    if (this._readableState === undefined) {
      return false;
    }

    return this._readableState.destroyed;
  },
  set: function set(value) {
    // we ignore the value if the stream
    // has not been initialized yet
    if (!this._readableState) {
      return;
    } // backward compatibility, the user is explicitly
    // managing destroyed


    this._readableState.destroyed = value;
  }
});
Readable.prototype.destroy = destroyImpl.destroy;
Readable.prototype._undestroy = destroyImpl.undestroy;

Readable.prototype._destroy = function (err, cb) {
  cb(err);
}; // Manually shove something into the read() buffer.
// This returns true if the highWaterMark has not been hit yet,
// similar to how Writable.write() returns true if you should
// write() some more.


Readable.prototype.push = function (chunk, encoding) {
  var state = this._readableState;
  var skipChunkCheck;

  if (!state.objectMode) {
    if (typeof chunk === 'string') {
      encoding = encoding || state.defaultEncoding;

      if (encoding !== state.encoding) {
        chunk = Buffer.from(chunk, encoding);
        encoding = '';
      }

      skipChunkCheck = true;
    }
  } else {
    skipChunkCheck = true;
  }

  return readableAddChunk(this, chunk, encoding, false, skipChunkCheck);
}; // Unshift should *always* be something directly out of read()


Readable.prototype.unshift = function (chunk) {
  return readableAddChunk(this, chunk, null, true, false);
};

function readableAddChunk(stream, chunk, encoding, addToFront, skipChunkCheck) {
  debug('readableAddChunk', chunk);
  var state = stream._readableState;

  if (chunk === null) {
    state.reading = false;
    onEofChunk(stream, state);
  } else {
    var er;
    if (!skipChunkCheck) er = chunkInvalid(state, chunk);

    if (er) {
      errorOrDestroy(stream, er);
    } else if (state.objectMode || chunk && chunk.length > 0) {
      if (typeof chunk !== 'string' && !state.objectMode && Object.getPrototypeOf(chunk) !== Buffer.prototype) {
        chunk = _uint8ArrayToBuffer(chunk);
      }

      if (addToFront) {
        if (state.endEmitted) errorOrDestroy(stream, new ERR_STREAM_UNSHIFT_AFTER_END_EVENT());else addChunk(stream, state, chunk, true);
      } else if (state.ended) {
        errorOrDestroy(stream, new ERR_STREAM_PUSH_AFTER_EOF());
      } else if (state.destroyed) {
        return false;
      } else {
        state.reading = false;

        if (state.decoder && !encoding) {
          chunk = state.decoder.write(chunk);
          if (state.objectMode || chunk.length !== 0) addChunk(stream, state, chunk, false);else maybeReadMore(stream, state);
        } else {
          addChunk(stream, state, chunk, false);
        }
      }
    } else if (!addToFront) {
      state.reading = false;
      maybeReadMore(stream, state);
    }
  } // We can push more data if we are below the highWaterMark.
  // Also, if we have no data yet, we can stand some more bytes.
  // This is to work around cases where hwm=0, such as the repl.


  return !state.ended && (state.length < state.highWaterMark || state.length === 0);
}

function addChunk(stream, state, chunk, addToFront) {
  if (state.flowing && state.length === 0 && !state.sync) {
    state.awaitDrain = 0;
    stream.emit('data', chunk);
  } else {
    // update the buffer info.
    state.length += state.objectMode ? 1 : chunk.length;
    if (addToFront) state.buffer.unshift(chunk);else state.buffer.push(chunk);
    if (state.needReadable) emitReadable(stream);
  }

  maybeReadMore(stream, state);
}

function chunkInvalid(state, chunk) {
  var er;

  if (!_isUint8Array(chunk) && typeof chunk !== 'string' && chunk !== undefined && !state.objectMode) {
    er = new ERR_INVALID_ARG_TYPE('chunk', ['string', 'Buffer', 'Uint8Array'], chunk);
  }

  return er;
}

Readable.prototype.isPaused = function () {
  return this._readableState.flowing === false;
}; // backwards compatibility.


Readable.prototype.setEncoding = function (enc) {
  if (!StringDecoder) StringDecoder = __webpack_require__(/*! string_decoder/ */ "./node_modules/string_decoder/lib/string_decoder.js").StringDecoder;
  var decoder = new StringDecoder(enc);
  this._readableState.decoder = decoder; // If setEncoding(null), decoder.encoding equals utf8

  this._readableState.encoding = this._readableState.decoder.encoding; // Iterate over current buffer to convert already stored Buffers:

  var p = this._readableState.buffer.head;
  var content = '';

  while (p !== null) {
    content += decoder.write(p.data);
    p = p.next;
  }

  this._readableState.buffer.clear();

  if (content !== '') this._readableState.buffer.push(content);
  this._readableState.length = content.length;
  return this;
}; // Don't raise the hwm > 1GB


var MAX_HWM = 0x40000000;

function computeNewHighWaterMark(n) {
  if (n >= MAX_HWM) {
    // TODO(ronag): Throw ERR_VALUE_OUT_OF_RANGE.
    n = MAX_HWM;
  } else {
    // Get the next highest power of 2 to prevent increasing hwm excessively in
    // tiny amounts
    n--;
    n |= n >>> 1;
    n |= n >>> 2;
    n |= n >>> 4;
    n |= n >>> 8;
    n |= n >>> 16;
    n++;
  }

  return n;
} // This function is designed to be inlinable, so please take care when making
// changes to the function body.


function howMuchToRead(n, state) {
  if (n <= 0 || state.length === 0 && state.ended) return 0;
  if (state.objectMode) return 1;

  if (n !== n) {
    // Only flow one buffer at a time
    if (state.flowing && state.length) return state.buffer.head.data.length;else return state.length;
  } // If we're asking for more than the current hwm, then raise the hwm.


  if (n > state.highWaterMark) state.highWaterMark = computeNewHighWaterMark(n);
  if (n <= state.length) return n; // Don't have enough

  if (!state.ended) {
    state.needReadable = true;
    return 0;
  }

  return state.length;
} // you can override either this method, or the async _read(n) below.


Readable.prototype.read = function (n) {
  debug('read', n);
  n = parseInt(n, 10);
  var state = this._readableState;
  var nOrig = n;
  if (n !== 0) state.emittedReadable = false; // if we're doing read(0) to trigger a readable event, but we
  // already have a bunch of data in the buffer, then just trigger
  // the 'readable' event and move on.

  if (n === 0 && state.needReadable && ((state.highWaterMark !== 0 ? state.length >= state.highWaterMark : state.length > 0) || state.ended)) {
    debug('read: emitReadable', state.length, state.ended);
    if (state.length === 0 && state.ended) endReadable(this);else emitReadable(this);
    return null;
  }

  n = howMuchToRead(n, state); // if we've ended, and we're now clear, then finish it up.

  if (n === 0 && state.ended) {
    if (state.length === 0) endReadable(this);
    return null;
  } // All the actual chunk generation logic needs to be
  // *below* the call to _read.  The reason is that in certain
  // synthetic stream cases, such as passthrough streams, _read
  // may be a completely synchronous operation which may change
  // the state of the read buffer, providing enough data when
  // before there was *not* enough.
  //
  // So, the steps are:
  // 1. Figure out what the state of things will be after we do
  // a read from the buffer.
  //
  // 2. If that resulting state will trigger a _read, then call _read.
  // Note that this may be asynchronous, or synchronous.  Yes, it is
  // deeply ugly to write APIs this way, but that still doesn't mean
  // that the Readable class should behave improperly, as streams are
  // designed to be sync/async agnostic.
  // Take note if the _read call is sync or async (ie, if the read call
  // has returned yet), so that we know whether or not it's safe to emit
  // 'readable' etc.
  //
  // 3. Actually pull the requested chunks out of the buffer and return.
  // if we need a readable event, then we need to do some reading.


  var doRead = state.needReadable;
  debug('need readable', doRead); // if we currently have less than the highWaterMark, then also read some

  if (state.length === 0 || state.length - n < state.highWaterMark) {
    doRead = true;
    debug('length less than watermark', doRead);
  } // however, if we've ended, then there's no point, and if we're already
  // reading, then it's unnecessary.


  if (state.ended || state.reading) {
    doRead = false;
    debug('reading or ended', doRead);
  } else if (doRead) {
    debug('do read');
    state.reading = true;
    state.sync = true; // if the length is currently zero, then we *need* a readable event.

    if (state.length === 0) state.needReadable = true; // call internal read method

    this._read(state.highWaterMark);

    state.sync = false; // If _read pushed data synchronously, then `reading` will be false,
    // and we need to re-evaluate how much data we can return to the user.

    if (!state.reading) n = howMuchToRead(nOrig, state);
  }

  var ret;
  if (n > 0) ret = fromList(n, state);else ret = null;

  if (ret === null) {
    state.needReadable = state.length <= state.highWaterMark;
    n = 0;
  } else {
    state.length -= n;
    state.awaitDrain = 0;
  }

  if (state.length === 0) {
    // If we have nothing in the buffer, then we want to know
    // as soon as we *do* get something into the buffer.
    if (!state.ended) state.needReadable = true; // If we tried to read() past the EOF, then emit end on the next tick.

    if (nOrig !== n && state.ended) endReadable(this);
  }

  if (ret !== null) this.emit('data', ret);
  return ret;
};

function onEofChunk(stream, state) {
  debug('onEofChunk');
  if (state.ended) return;

  if (state.decoder) {
    var chunk = state.decoder.end();

    if (chunk && chunk.length) {
      state.buffer.push(chunk);
      state.length += state.objectMode ? 1 : chunk.length;
    }
  }

  state.ended = true;

  if (state.sync) {
    // if we are sync, wait until next tick to emit the data.
    // Otherwise we risk emitting data in the flow()
    // the readable code triggers during a read() call
    emitReadable(stream);
  } else {
    // emit 'readable' now to make sure it gets picked up.
    state.needReadable = false;

    if (!state.emittedReadable) {
      state.emittedReadable = true;
      emitReadable_(stream);
    }
  }
} // Don't emit readable right away in sync mode, because this can trigger
// another read() call => stack overflow.  This way, it might trigger
// a nextTick recursion warning, but that's not so bad.


function emitReadable(stream) {
  var state = stream._readableState;
  debug('emitReadable', state.needReadable, state.emittedReadable);
  state.needReadable = false;

  if (!state.emittedReadable) {
    debug('emitReadable', state.flowing);
    state.emittedReadable = true;
    process.nextTick(emitReadable_, stream);
  }
}

function emitReadable_(stream) {
  var state = stream._readableState;
  debug('emitReadable_', state.destroyed, state.length, state.ended);

  if (!state.destroyed && (state.length || state.ended)) {
    stream.emit('readable');
    state.emittedReadable = false;
  } // The stream needs another readable event if
  // 1. It is not flowing, as the flow mechanism will take
  //    care of it.
  // 2. It is not ended.
  // 3. It is below the highWaterMark, so we can schedule
  //    another readable later.


  state.needReadable = !state.flowing && !state.ended && state.length <= state.highWaterMark;
  flow(stream);
} // at this point, the user has presumably seen the 'readable' event,
// and called read() to consume some data.  that may have triggered
// in turn another _read(n) call, in which case reading = true if
// it's in progress.
// However, if we're not ended, or reading, and the length < hwm,
// then go ahead and try to read some more preemptively.


function maybeReadMore(stream, state) {
  if (!state.readingMore) {
    state.readingMore = true;
    process.nextTick(maybeReadMore_, stream, state);
  }
}

function maybeReadMore_(stream, state) {
  // Attempt to read more data if we should.
  //
  // The conditions for reading more data are (one of):
  // - Not enough data buffered (state.length < state.highWaterMark). The loop
  //   is responsible for filling the buffer with enough data if such data
  //   is available. If highWaterMark is 0 and we are not in the flowing mode
  //   we should _not_ attempt to buffer any extra data. We'll get more data
  //   when the stream consumer calls read() instead.
  // - No data in the buffer, and the stream is in flowing mode. In this mode
  //   the loop below is responsible for ensuring read() is called. Failing to
  //   call read here would abort the flow and there's no other mechanism for
  //   continuing the flow if the stream consumer has just subscribed to the
  //   'data' event.
  //
  // In addition to the above conditions to keep reading data, the following
  // conditions prevent the data from being read:
  // - The stream has ended (state.ended).
  // - There is already a pending 'read' operation (state.reading). This is a
  //   case where the the stream has called the implementation defined _read()
  //   method, but they are processing the call asynchronously and have _not_
  //   called push() with new data. In this case we skip performing more
  //   read()s. The execution ends in this method again after the _read() ends
  //   up calling push() with more data.
  while (!state.reading && !state.ended && (state.length < state.highWaterMark || state.flowing && state.length === 0)) {
    var len = state.length;
    debug('maybeReadMore read 0');
    stream.read(0);
    if (len === state.length) // didn't get any data, stop spinning.
      break;
  }

  state.readingMore = false;
} // abstract method.  to be overridden in specific implementation classes.
// call cb(er, data) where data is <= n in length.
// for virtual (non-string, non-buffer) streams, "length" is somewhat
// arbitrary, and perhaps not very meaningful.


Readable.prototype._read = function (n) {
  errorOrDestroy(this, new ERR_METHOD_NOT_IMPLEMENTED('_read()'));
};

Readable.prototype.pipe = function (dest, pipeOpts) {
  var src = this;
  var state = this._readableState;

  switch (state.pipesCount) {
    case 0:
      state.pipes = dest;
      break;

    case 1:
      state.pipes = [state.pipes, dest];
      break;

    default:
      state.pipes.push(dest);
      break;
  }

  state.pipesCount += 1;
  debug('pipe count=%d opts=%j', state.pipesCount, pipeOpts);
  var doEnd = (!pipeOpts || pipeOpts.end !== false) && dest !== process.stdout && dest !== process.stderr;
  var endFn = doEnd ? onend : unpipe;
  if (state.endEmitted) process.nextTick(endFn);else src.once('end', endFn);
  dest.on('unpipe', onunpipe);

  function onunpipe(readable, unpipeInfo) {
    debug('onunpipe');

    if (readable === src) {
      if (unpipeInfo && unpipeInfo.hasUnpiped === false) {
        unpipeInfo.hasUnpiped = true;
        cleanup();
      }
    }
  }

  function onend() {
    debug('onend');
    dest.end();
  } // when the dest drains, it reduces the awaitDrain counter
  // on the source.  This would be more elegant with a .once()
  // handler in flow(), but adding and removing repeatedly is
  // too slow.


  var ondrain = pipeOnDrain(src);
  dest.on('drain', ondrain);
  var cleanedUp = false;

  function cleanup() {
    debug('cleanup'); // cleanup event handlers once the pipe is broken

    dest.removeListener('close', onclose);
    dest.removeListener('finish', onfinish);
    dest.removeListener('drain', ondrain);
    dest.removeListener('error', onerror);
    dest.removeListener('unpipe', onunpipe);
    src.removeListener('end', onend);
    src.removeListener('end', unpipe);
    src.removeListener('data', ondata);
    cleanedUp = true; // if the reader is waiting for a drain event from this
    // specific writer, then it would cause it to never start
    // flowing again.
    // So, if this is awaiting a drain, then we just call it now.
    // If we don't know, then assume that we are waiting for one.

    if (state.awaitDrain && (!dest._writableState || dest._writableState.needDrain)) ondrain();
  }

  src.on('data', ondata);

  function ondata(chunk) {
    debug('ondata');
    var ret = dest.write(chunk);
    debug('dest.write', ret);

    if (ret === false) {
      // If the user unpiped during `dest.write()`, it is possible
      // to get stuck in a permanently paused state if that write
      // also returned false.
      // => Check whether `dest` is still a piping destination.
      if ((state.pipesCount === 1 && state.pipes === dest || state.pipesCount > 1 && indexOf(state.pipes, dest) !== -1) && !cleanedUp) {
        debug('false write response, pause', state.awaitDrain);
        state.awaitDrain++;
      }

      src.pause();
    }
  } // if the dest has an error, then stop piping into it.
  // however, don't suppress the throwing behavior for this.


  function onerror(er) {
    debug('onerror', er);
    unpipe();
    dest.removeListener('error', onerror);
    if (EElistenerCount(dest, 'error') === 0) errorOrDestroy(dest, er);
  } // Make sure our error handler is attached before userland ones.


  prependListener(dest, 'error', onerror); // Both close and finish should trigger unpipe, but only once.

  function onclose() {
    dest.removeListener('finish', onfinish);
    unpipe();
  }

  dest.once('close', onclose);

  function onfinish() {
    debug('onfinish');
    dest.removeListener('close', onclose);
    unpipe();
  }

  dest.once('finish', onfinish);

  function unpipe() {
    debug('unpipe');
    src.unpipe(dest);
  } // tell the dest that it's being piped to


  dest.emit('pipe', src); // start the flow if it hasn't been started already.

  if (!state.flowing) {
    debug('pipe resume');
    src.resume();
  }

  return dest;
};

function pipeOnDrain(src) {
  return function pipeOnDrainFunctionResult() {
    var state = src._readableState;
    debug('pipeOnDrain', state.awaitDrain);
    if (state.awaitDrain) state.awaitDrain--;

    if (state.awaitDrain === 0 && EElistenerCount(src, 'data')) {
      state.flowing = true;
      flow(src);
    }
  };
}

Readable.prototype.unpipe = function (dest) {
  var state = this._readableState;
  var unpipeInfo = {
    hasUnpiped: false
  }; // if we're not piping anywhere, then do nothing.

  if (state.pipesCount === 0) return this; // just one destination.  most common case.

  if (state.pipesCount === 1) {
    // passed in one, but it's not the right one.
    if (dest && dest !== state.pipes) return this;
    if (!dest) dest = state.pipes; // got a match.

    state.pipes = null;
    state.pipesCount = 0;
    state.flowing = false;
    if (dest) dest.emit('unpipe', this, unpipeInfo);
    return this;
  } // slow case. multiple pipe destinations.


  if (!dest) {
    // remove all.
    var dests = state.pipes;
    var len = state.pipesCount;
    state.pipes = null;
    state.pipesCount = 0;
    state.flowing = false;

    for (var i = 0; i < len; i++) {
      dests[i].emit('unpipe', this, {
        hasUnpiped: false
      });
    }

    return this;
  } // try to find the right one.


  var index = indexOf(state.pipes, dest);
  if (index === -1) return this;
  state.pipes.splice(index, 1);
  state.pipesCount -= 1;
  if (state.pipesCount === 1) state.pipes = state.pipes[0];
  dest.emit('unpipe', this, unpipeInfo);
  return this;
}; // set up data events if they are asked for
// Ensure readable listeners eventually get something


Readable.prototype.on = function (ev, fn) {
  var res = Stream.prototype.on.call(this, ev, fn);
  var state = this._readableState;

  if (ev === 'data') {
    // update readableListening so that resume() may be a no-op
    // a few lines down. This is needed to support once('readable').
    state.readableListening = this.listenerCount('readable') > 0; // Try start flowing on next tick if stream isn't explicitly paused

    if (state.flowing !== false) this.resume();
  } else if (ev === 'readable') {
    if (!state.endEmitted && !state.readableListening) {
      state.readableListening = state.needReadable = true;
      state.flowing = false;
      state.emittedReadable = false;
      debug('on readable', state.length, state.reading);

      if (state.length) {
        emitReadable(this);
      } else if (!state.reading) {
        process.nextTick(nReadingNextTick, this);
      }
    }
  }

  return res;
};

Readable.prototype.addListener = Readable.prototype.on;

Readable.prototype.removeListener = function (ev, fn) {
  var res = Stream.prototype.removeListener.call(this, ev, fn);

  if (ev === 'readable') {
    // We need to check if there is someone still listening to
    // readable and reset the state. However this needs to happen
    // after readable has been emitted but before I/O (nextTick) to
    // support once('readable', fn) cycles. This means that calling
    // resume within the same tick will have no
    // effect.
    process.nextTick(updateReadableListening, this);
  }

  return res;
};

Readable.prototype.removeAllListeners = function (ev) {
  var res = Stream.prototype.removeAllListeners.apply(this, arguments);

  if (ev === 'readable' || ev === undefined) {
    // We need to check if there is someone still listening to
    // readable and reset the state. However this needs to happen
    // after readable has been emitted but before I/O (nextTick) to
    // support once('readable', fn) cycles. This means that calling
    // resume within the same tick will have no
    // effect.
    process.nextTick(updateReadableListening, this);
  }

  return res;
};

function updateReadableListening(self) {
  var state = self._readableState;
  state.readableListening = self.listenerCount('readable') > 0;

  if (state.resumeScheduled && !state.paused) {
    // flowing needs to be set to true now, otherwise
    // the upcoming resume will not flow.
    state.flowing = true; // crude way to check if we should resume
  } else if (self.listenerCount('data') > 0) {
    self.resume();
  }
}

function nReadingNextTick(self) {
  debug('readable nexttick read 0');
  self.read(0);
} // pause() and resume() are remnants of the legacy readable stream API
// If the user uses them, then switch into old mode.


Readable.prototype.resume = function () {
  var state = this._readableState;

  if (!state.flowing) {
    debug('resume'); // we flow only if there is no one listening
    // for readable, but we still have to call
    // resume()

    state.flowing = !state.readableListening;
    resume(this, state);
  }

  state.paused = false;
  return this;
};

function resume(stream, state) {
  if (!state.resumeScheduled) {
    state.resumeScheduled = true;
    process.nextTick(resume_, stream, state);
  }
}

function resume_(stream, state) {
  debug('resume', state.reading);

  if (!state.reading) {
    stream.read(0);
  }

  state.resumeScheduled = false;
  stream.emit('resume');
  flow(stream);
  if (state.flowing && !state.reading) stream.read(0);
}

Readable.prototype.pause = function () {
  debug('call pause flowing=%j', this._readableState.flowing);

  if (this._readableState.flowing !== false) {
    debug('pause');
    this._readableState.flowing = false;
    this.emit('pause');
  }

  this._readableState.paused = true;
  return this;
};

function flow(stream) {
  var state = stream._readableState;
  debug('flow', state.flowing);

  while (state.flowing && stream.read() !== null) {
    ;
  }
} // wrap an old-style stream as the async data source.
// This is *not* part of the readable stream interface.
// It is an ugly unfortunate mess of history.


Readable.prototype.wrap = function (stream) {
  var _this = this;

  var state = this._readableState;
  var paused = false;
  stream.on('end', function () {
    debug('wrapped end');

    if (state.decoder && !state.ended) {
      var chunk = state.decoder.end();
      if (chunk && chunk.length) _this.push(chunk);
    }

    _this.push(null);
  });
  stream.on('data', function (chunk) {
    debug('wrapped data');
    if (state.decoder) chunk = state.decoder.write(chunk); // don't skip over falsy values in objectMode

    if (state.objectMode && (chunk === null || chunk === undefined)) return;else if (!state.objectMode && (!chunk || !chunk.length)) return;

    var ret = _this.push(chunk);

    if (!ret) {
      paused = true;
      stream.pause();
    }
  }); // proxy all the other methods.
  // important when wrapping filters and duplexes.

  for (var i in stream) {
    if (this[i] === undefined && typeof stream[i] === 'function') {
      this[i] = function methodWrap(method) {
        return function methodWrapReturnFunction() {
          return stream[method].apply(stream, arguments);
        };
      }(i);
    }
  } // proxy certain important events.


  for (var n = 0; n < kProxyEvents.length; n++) {
    stream.on(kProxyEvents[n], this.emit.bind(this, kProxyEvents[n]));
  } // when we try to consume some more bytes, simply unpause the
  // underlying stream.


  this._read = function (n) {
    debug('wrapped _read', n);

    if (paused) {
      paused = false;
      stream.resume();
    }
  };

  return this;
};

if (typeof Symbol === 'function') {
  Readable.prototype[Symbol.asyncIterator] = function () {
    if (createReadableStreamAsyncIterator === undefined) {
      createReadableStreamAsyncIterator = __webpack_require__(/*! ./internal/streams/async_iterator */ "./node_modules/browserify-sign/node_modules/readable-stream/lib/internal/streams/async_iterator.js");
    }

    return createReadableStreamAsyncIterator(this);
  };
}

Object.defineProperty(Readable.prototype, 'readableHighWaterMark', {
  // making it explicit this property is not enumerable
  // because otherwise some prototype manipulation in
  // userland will fail
  enumerable: false,
  get: function get() {
    return this._readableState.highWaterMark;
  }
});
Object.defineProperty(Readable.prototype, 'readableBuffer', {
  // making it explicit this property is not enumerable
  // because otherwise some prototype manipulation in
  // userland will fail
  enumerable: false,
  get: function get() {
    return this._readableState && this._readableState.buffer;
  }
});
Object.defineProperty(Readable.prototype, 'readableFlowing', {
  // making it explicit this property is not enumerable
  // because otherwise some prototype manipulation in
  // userland will fail
  enumerable: false,
  get: function get() {
    return this._readableState.flowing;
  },
  set: function set(state) {
    if (this._readableState) {
      this._readableState.flowing = state;
    }
  }
}); // exposed for testing purposes only.

Readable._fromList = fromList;
Object.defineProperty(Readable.prototype, 'readableLength', {
  // making it explicit this property is not enumerable
  // because otherwise some prototype manipulation in
  // userland will fail
  enumerable: false,
  get: function get() {
    return this._readableState.length;
  }
}); // Pluck off n bytes from an array of buffers.
// Length is the combined lengths of all the buffers in the list.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.

function fromList(n, state) {
  // nothing buffered
  if (state.length === 0) return null;
  var ret;
  if (state.objectMode) ret = state.buffer.shift();else if (!n || n >= state.length) {
    // read it all, truncate the list
    if (state.decoder) ret = state.buffer.join('');else if (state.buffer.length === 1) ret = state.buffer.first();else ret = state.buffer.concat(state.length);
    state.buffer.clear();
  } else {
    // read part of list
    ret = state.buffer.consume(n, state.decoder);
  }
  return ret;
}

function endReadable(stream) {
  var state = stream._readableState;
  debug('endReadable', state.endEmitted);

  if (!state.endEmitted) {
    state.ended = true;
    process.nextTick(endReadableNT, state, stream);
  }
}

function endReadableNT(state, stream) {
  debug('endReadableNT', state.endEmitted, state.length); // Check that we didn't get one last unshift.

  if (!state.endEmitted && state.length === 0) {
    state.endEmitted = true;
    stream.readable = false;
    stream.emit('end');

    if (state.autoDestroy) {
      // In case of duplex streams we need a way to detect
      // if the writable side is ready for autoDestroy as well
      var wState = stream._writableState;

      if (!wState || wState.autoDestroy && wState.finished) {
        stream.destroy();
      }
    }
  }
}

if (typeof Symbol === 'function') {
  Readable.from = function (iterable, opts) {
    if (from === undefined) {
      from = __webpack_require__(/*! ./internal/streams/from */ "./node_modules/browserify-sign/node_modules/readable-stream/lib/internal/streams/from-browser.js");
    }

    return from(Readable, iterable, opts);
  };
}

function indexOf(xs, x) {
  for (var i = 0, l = xs.length; i < l; i++) {
    if (xs[i] === x) return i;
  }

  return -1;
}
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(/*! ./../../../../webpack/buildin/global.js */ "./node_modules/webpack/buildin/global.js"), __webpack_require__(/*! ./../../../../process/browser.js */ "./node_modules/process/browser.js")))

/***/ }),

/***/ "./node_modules/browserify-sign/node_modules/readable-stream/lib/_stream_transform.js":
/*!********************************************************************************************!*\
  !*** ./node_modules/browserify-sign/node_modules/readable-stream/lib/_stream_transform.js ***!
  \********************************************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a transform stream is a readable/writable stream where you do
// something with the data.  Sometimes it's called a "filter",
// but that's not a great name for it, since that implies a thing where
// some bits pass through, and others are simply ignored.  (That would
// be a valid example of a transform, of course.)
//
// While the output is causally related to the input, it's not a
// necessarily symmetric or synchronous transformation.  For example,
// a zlib stream might take multiple plain-text writes(), and then
// emit a single compressed chunk some time in the future.
//
// Here's how this works:
//
// The Transform stream has all the aspects of the readable and writable
// stream classes.  When you write(chunk), that calls _write(chunk,cb)
// internally, and returns false if there's a lot of pending writes
// buffered up.  When you call read(), that calls _read(n) until
// there's enough pending readable data buffered up.
//
// In a transform stream, the written data is placed in a buffer.  When
// _read(n) is called, it transforms the queued up data, calling the
// buffered _write cb's as it consumes chunks.  If consuming a single
// written chunk would result in multiple output chunks, then the first
// outputted bit calls the readcb, and subsequent chunks just go into
// the read buffer, and will cause it to emit 'readable' if necessary.
//
// This way, back-pressure is actually determined by the reading side,
// since _read has to be called to start processing a new chunk.  However,
// a pathological inflate type of transform can cause excessive buffering
// here.  For example, imagine a stream where every byte of input is
// interpreted as an integer from 0-255, and then results in that many
// bytes of output.  Writing the 4 bytes {ff,ff,ff,ff} would result in
// 1kb of data being output.  In this case, you could write a very small
// amount of input, and end up with a very large amount of output.  In
// such a pathological inflating mechanism, there'd be no way to tell
// the system to stop doing the transform.  A single 4MB write could
// cause the system to run out of memory.
//
// However, even in such a pathological case, only a single written chunk
// would be consumed, and then the rest would wait (un-transformed) until
// the results of the previous transformed chunk were consumed.


module.exports = Transform;

var _require$codes = __webpack_require__(/*! ../errors */ "./node_modules/browserify-sign/node_modules/readable-stream/errors-browser.js").codes,
    ERR_METHOD_NOT_IMPLEMENTED = _require$codes.ERR_METHOD_NOT_IMPLEMENTED,
    ERR_MULTIPLE_CALLBACK = _require$codes.ERR_MULTIPLE_CALLBACK,
    ERR_TRANSFORM_ALREADY_TRANSFORMING = _require$codes.ERR_TRANSFORM_ALREADY_TRANSFORMING,
    ERR_TRANSFORM_WITH_LENGTH_0 = _require$codes.ERR_TRANSFORM_WITH_LENGTH_0;

var Duplex = __webpack_require__(/*! ./_stream_duplex */ "./node_modules/browserify-sign/node_modules/readable-stream/lib/_stream_duplex.js");

__webpack_require__(/*! inherits */ "./node_modules/inherits/inherits_browser.js")(Transform, Duplex);

function afterTransform(er, data) {
  var ts = this._transformState;
  ts.transforming = false;
  var cb = ts.writecb;

  if (cb === null) {
    return this.emit('error', new ERR_MULTIPLE_CALLBACK());
  }

  ts.writechunk = null;
  ts.writecb = null;
  if (data != null) // single equals check for both `null` and `undefined`
    this.push(data);
  cb(er);
  var rs = this._readableState;
  rs.reading = false;

  if (rs.needReadable || rs.length < rs.highWaterMark) {
    this._read(rs.highWaterMark);
  }
}

function Transform(options) {
  if (!(this instanceof Transform)) return new Transform(options);
  Duplex.call(this, options);
  this._transformState = {
    afterTransform: afterTransform.bind(this),
    needTransform: false,
    transforming: false,
    writecb: null,
    writechunk: null,
    writeencoding: null
  }; // start out asking for a readable event once data is transformed.

  this._readableState.needReadable = true; // we have implemented the _read method, and done the other things
  // that Readable wants before the first _read call, so unset the
  // sync guard flag.

  this._readableState.sync = false;

  if (options) {
    if (typeof options.transform === 'function') this._transform = options.transform;
    if (typeof options.flush === 'function') this._flush = options.flush;
  } // When the writable side finishes, then flush out anything remaining.


  this.on('prefinish', prefinish);
}

function prefinish() {
  var _this = this;

  if (typeof this._flush === 'function' && !this._readableState.destroyed) {
    this._flush(function (er, data) {
      done(_this, er, data);
    });
  } else {
    done(this, null, null);
  }
}

Transform.prototype.push = function (chunk, encoding) {
  this._transformState.needTransform = false;
  return Duplex.prototype.push.call(this, chunk, encoding);
}; // This is the part where you do stuff!
// override this function in implementation classes.
// 'chunk' is an input chunk.
//
// Call `push(newChunk)` to pass along transformed output
// to the readable side.  You may call 'push' zero or more times.
//
// Call `cb(err)` when you are done with this chunk.  If you pass
// an error, then that'll put the hurt on the whole operation.  If you
// never call cb(), then you'll never get another chunk.


Transform.prototype._transform = function (chunk, encoding, cb) {
  cb(new ERR_METHOD_NOT_IMPLEMENTED('_transform()'));
};

Transform.prototype._write = function (chunk, encoding, cb) {
  var ts = this._transformState;
  ts.writecb = cb;
  ts.writechunk = chunk;
  ts.writeencoding = encoding;

  if (!ts.transforming) {
    var rs = this._readableState;
    if (ts.needTransform || rs.needReadable || rs.length < rs.highWaterMark) this._read(rs.highWaterMark);
  }
}; // Doesn't matter what the args are here.
// _transform does all the work.
// That we got here means that the readable side wants more data.


Transform.prototype._read = function (n) {
  var ts = this._transformState;

  if (ts.writechunk !== null && !ts.transforming) {
    ts.transforming = true;

    this._transform(ts.writechunk, ts.writeencoding, ts.afterTransform);
  } else {
    // mark that we need a transform, so that any data that comes in
    // will get processed, now that we've asked for it.
    ts.needTransform = true;
  }
};

Transform.prototype._destroy = function (err, cb) {
  Duplex.prototype._destroy.call(this, err, function (err2) {
    cb(err2);
  });
};

function done(stream, er, data) {
  if (er) return stream.emit('error', er);
  if (data != null) // single equals check for both `null` and `undefined`
    stream.push(data); // TODO(BridgeAR): Write a test for these two error cases
  // if there's nothing in the write buffer, then that means
  // that nothing more will ever be provided

  if (stream._writableState.length) throw new ERR_TRANSFORM_WITH_LENGTH_0();
  if (stream._transformState.transforming) throw new ERR_TRANSFORM_ALREADY_TRANSFORMING();
  return stream.push(null);
}

/***/ }),

/***/ "./node_modules/browserify-sign/node_modules/readable-stream/lib/_stream_writable.js":
/*!*******************************************************************************************!*\
  !*** ./node_modules/browserify-sign/node_modules/readable-stream/lib/_stream_writable.js ***!
  \*******************************************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global, process) {// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// A bit simpler than readable streams.
// Implement an async ._write(chunk, encoding, cb), and it'll handle all
// the drain event emission and buffering.


module.exports = Writable;
/* <replacement> */

function WriteReq(chunk, encoding, cb) {
  this.chunk = chunk;
  this.encoding = encoding;
  this.callback = cb;
  this.next = null;
} // It seems a linked list but it is not
// there will be only 2 of these for each stream


function CorkedRequest(state) {
  var _this = this;

  this.next = null;
  this.entry = null;

  this.finish = function () {
    onCorkedFinish(_this, state);
  };
}
/* </replacement> */

/*<replacement>*/


var Duplex;
/*</replacement>*/

Writable.WritableState = WritableState;
/*<replacement>*/

var internalUtil = {
  deprecate: __webpack_require__(/*! util-deprecate */ "./node_modules/util-deprecate/browser.js")
};
/*</replacement>*/

/*<replacement>*/

var Stream = __webpack_require__(/*! ./internal/streams/stream */ "./node_modules/browserify-sign/node_modules/readable-stream/lib/internal/streams/stream-browser.js");
/*</replacement>*/


var Buffer = __webpack_require__(/*! buffer */ "./node_modules/node-libs-browser/node_modules/buffer/index.js").Buffer;

var OurUint8Array = global.Uint8Array || function () {};

function _uint8ArrayToBuffer(chunk) {
  return Buffer.from(chunk);
}

function _isUint8Array(obj) {
  return Buffer.isBuffer(obj) || obj instanceof OurUint8Array;
}

var destroyImpl = __webpack_require__(/*! ./internal/streams/destroy */ "./node_modules/browserify-sign/node_modules/readable-stream/lib/internal/streams/destroy.js");

var _require = __webpack_require__(/*! ./internal/streams/state */ "./node_modules/browserify-sign/node_modules/readable-stream/lib/internal/streams/state.js"),
    getHighWaterMark = _require.getHighWaterMark;

var _require$codes = __webpack_require__(/*! ../errors */ "./node_modules/browserify-sign/node_modules/readable-stream/errors-browser.js").codes,
    ERR_INVALID_ARG_TYPE = _require$codes.ERR_INVALID_ARG_TYPE,
    ERR_METHOD_NOT_IMPLEMENTED = _require$codes.ERR_METHOD_NOT_IMPLEMENTED,
    ERR_MULTIPLE_CALLBACK = _require$codes.ERR_MULTIPLE_CALLBACK,
    ERR_STREAM_CANNOT_PIPE = _require$codes.ERR_STREAM_CANNOT_PIPE,
    ERR_STREAM_DESTROYED = _require$codes.ERR_STREAM_DESTROYED,
    ERR_STREAM_NULL_VALUES = _require$codes.ERR_STREAM_NULL_VALUES,
    ERR_STREAM_WRITE_AFTER_END = _require$codes.ERR_STREAM_WRITE_AFTER_END,
    ERR_UNKNOWN_ENCODING = _require$codes.ERR_UNKNOWN_ENCODING;

var errorOrDestroy = destroyImpl.errorOrDestroy;

__webpack_require__(/*! inherits */ "./node_modules/inherits/inherits_browser.js")(Writable, Stream);

function nop() {}

function WritableState(options, stream, isDuplex) {
  Duplex = Duplex || __webpack_require__(/*! ./_stream_duplex */ "./node_modules/browserify-sign/node_modules/readable-stream/lib/_stream_duplex.js");
  options = options || {}; // Duplex streams are both readable and writable, but share
  // the same options object.
  // However, some cases require setting options to different
  // values for the readable and the writable sides of the duplex stream,
  // e.g. options.readableObjectMode vs. options.writableObjectMode, etc.

  if (typeof isDuplex !== 'boolean') isDuplex = stream instanceof Duplex; // object stream flag to indicate whether or not this stream
  // contains buffers or objects.

  this.objectMode = !!options.objectMode;
  if (isDuplex) this.objectMode = this.objectMode || !!options.writableObjectMode; // the point at which write() starts returning false
  // Note: 0 is a valid value, means that we always return false if
  // the entire buffer is not flushed immediately on write()

  this.highWaterMark = getHighWaterMark(this, options, 'writableHighWaterMark', isDuplex); // if _final has been called

  this.finalCalled = false; // drain event flag.

  this.needDrain = false; // at the start of calling end()

  this.ending = false; // when end() has been called, and returned

  this.ended = false; // when 'finish' is emitted

  this.finished = false; // has it been destroyed

  this.destroyed = false; // should we decode strings into buffers before passing to _write?
  // this is here so that some node-core streams can optimize string
  // handling at a lower level.

  var noDecode = options.decodeStrings === false;
  this.decodeStrings = !noDecode; // Crypto is kind of old and crusty.  Historically, its default string
  // encoding is 'binary' so we have to make this configurable.
  // Everything else in the universe uses 'utf8', though.

  this.defaultEncoding = options.defaultEncoding || 'utf8'; // not an actual buffer we keep track of, but a measurement
  // of how much we're waiting to get pushed to some underlying
  // socket or file.

  this.length = 0; // a flag to see when we're in the middle of a write.

  this.writing = false; // when true all writes will be buffered until .uncork() call

  this.corked = 0; // a flag to be able to tell if the onwrite cb is called immediately,
  // or on a later tick.  We set this to true at first, because any
  // actions that shouldn't happen until "later" should generally also
  // not happen before the first write call.

  this.sync = true; // a flag to know if we're processing previously buffered items, which
  // may call the _write() callback in the same tick, so that we don't
  // end up in an overlapped onwrite situation.

  this.bufferProcessing = false; // the callback that's passed to _write(chunk,cb)

  this.onwrite = function (er) {
    onwrite(stream, er);
  }; // the callback that the user supplies to write(chunk,encoding,cb)


  this.writecb = null; // the amount that is being written when _write is called.

  this.writelen = 0;
  this.bufferedRequest = null;
  this.lastBufferedRequest = null; // number of pending user-supplied write callbacks
  // this must be 0 before 'finish' can be emitted

  this.pendingcb = 0; // emit prefinish if the only thing we're waiting for is _write cbs
  // This is relevant for synchronous Transform streams

  this.prefinished = false; // True if the error was already emitted and should not be thrown again

  this.errorEmitted = false; // Should close be emitted on destroy. Defaults to true.

  this.emitClose = options.emitClose !== false; // Should .destroy() be called after 'finish' (and potentially 'end')

  this.autoDestroy = !!options.autoDestroy; // count buffered requests

  this.bufferedRequestCount = 0; // allocate the first CorkedRequest, there is always
  // one allocated and free to use, and we maintain at most two

  this.corkedRequestsFree = new CorkedRequest(this);
}

WritableState.prototype.getBuffer = function getBuffer() {
  var current = this.bufferedRequest;
  var out = [];

  while (current) {
    out.push(current);
    current = current.next;
  }

  return out;
};

(function () {
  try {
    Object.defineProperty(WritableState.prototype, 'buffer', {
      get: internalUtil.deprecate(function writableStateBufferGetter() {
        return this.getBuffer();
      }, '_writableState.buffer is deprecated. Use _writableState.getBuffer ' + 'instead.', 'DEP0003')
    });
  } catch (_) {}
})(); // Test _writableState for inheritance to account for Duplex streams,
// whose prototype chain only points to Readable.


var realHasInstance;

if (typeof Symbol === 'function' && Symbol.hasInstance && typeof Function.prototype[Symbol.hasInstance] === 'function') {
  realHasInstance = Function.prototype[Symbol.hasInstance];
  Object.defineProperty(Writable, Symbol.hasInstance, {
    value: function value(object) {
      if (realHasInstance.call(this, object)) return true;
      if (this !== Writable) return false;
      return object && object._writableState instanceof WritableState;
    }
  });
} else {
  realHasInstance = function realHasInstance(object) {
    return object instanceof this;
  };
}

function Writable(options) {
  Duplex = Duplex || __webpack_require__(/*! ./_stream_duplex */ "./node_modules/browserify-sign/node_modules/readable-stream/lib/_stream_duplex.js"); // Writable ctor is applied to Duplexes, too.
  // `realHasInstance` is necessary because using plain `instanceof`
  // would return false, as no `_writableState` property is attached.
  // Trying to use the custom `instanceof` for Writable here will also break the
  // Node.js LazyTransform implementation, which has a non-trivial getter for
  // `_writableState` that would lead to infinite recursion.
  // Checking for a Stream.Duplex instance is faster here instead of inside
  // the WritableState constructor, at least with V8 6.5

  var isDuplex = this instanceof Duplex;
  if (!isDuplex && !realHasInstance.call(Writable, this)) return new Writable(options);
  this._writableState = new WritableState(options, this, isDuplex); // legacy.

  this.writable = true;

  if (options) {
    if (typeof options.write === 'function') this._write = options.write;
    if (typeof options.writev === 'function') this._writev = options.writev;
    if (typeof options.destroy === 'function') this._destroy = options.destroy;
    if (typeof options.final === 'function') this._final = options.final;
  }

  Stream.call(this);
} // Otherwise people can pipe Writable streams, which is just wrong.


Writable.prototype.pipe = function () {
  errorOrDestroy(this, new ERR_STREAM_CANNOT_PIPE());
};

function writeAfterEnd(stream, cb) {
  var er = new ERR_STREAM_WRITE_AFTER_END(); // TODO: defer error events consistently everywhere, not just the cb

  errorOrDestroy(stream, er);
  process.nextTick(cb, er);
} // Checks that a user-supplied chunk is valid, especially for the particular
// mode the stream is in. Currently this means that `null` is never accepted
// and undefined/non-string values are only allowed in object mode.


function validChunk(stream, state, chunk, cb) {
  var er;

  if (chunk === null) {
    er = new ERR_STREAM_NULL_VALUES();
  } else if (typeof chunk !== 'string' && !state.objectMode) {
    er = new ERR_INVALID_ARG_TYPE('chunk', ['string', 'Buffer'], chunk);
  }

  if (er) {
    errorOrDestroy(stream, er);
    process.nextTick(cb, er);
    return false;
  }

  return true;
}

Writable.prototype.write = function (chunk, encoding, cb) {
  var state = this._writableState;
  var ret = false;

  var isBuf = !state.objectMode && _isUint8Array(chunk);

  if (isBuf && !Buffer.isBuffer(chunk)) {
    chunk = _uint8ArrayToBuffer(chunk);
  }

  if (typeof encoding === 'function') {
    cb = encoding;
    encoding = null;
  }

  if (isBuf) encoding = 'buffer';else if (!encoding) encoding = state.defaultEncoding;
  if (typeof cb !== 'function') cb = nop;
  if (state.ending) writeAfterEnd(this, cb);else if (isBuf || validChunk(this, state, chunk, cb)) {
    state.pendingcb++;
    ret = writeOrBuffer(this, state, isBuf, chunk, encoding, cb);
  }
  return ret;
};

Writable.prototype.cork = function () {
  this._writableState.corked++;
};

Writable.prototype.uncork = function () {
  var state = this._writableState;

  if (state.corked) {
    state.corked--;
    if (!state.writing && !state.corked && !state.bufferProcessing && state.bufferedRequest) clearBuffer(this, state);
  }
};

Writable.prototype.setDefaultEncoding = function setDefaultEncoding(encoding) {
  // node::ParseEncoding() requires lower case.
  if (typeof encoding === 'string') encoding = encoding.toLowerCase();
  if (!(['hex', 'utf8', 'utf-8', 'ascii', 'binary', 'base64', 'ucs2', 'ucs-2', 'utf16le', 'utf-16le', 'raw'].indexOf((encoding + '').toLowerCase()) > -1)) throw new ERR_UNKNOWN_ENCODING(encoding);
  this._writableState.defaultEncoding = encoding;
  return this;
};

Object.defineProperty(Writable.prototype, 'writableBuffer', {
  // making it explicit this property is not enumerable
  // because otherwise some prototype manipulation in
  // userland will fail
  enumerable: false,
  get: function get() {
    return this._writableState && this._writableState.getBuffer();
  }
});

function decodeChunk(state, chunk, encoding) {
  if (!state.objectMode && state.decodeStrings !== false && typeof chunk === 'string') {
    chunk = Buffer.from(chunk, encoding);
  }

  return chunk;
}

Object.defineProperty(Writable.prototype, 'writableHighWaterMark', {
  // making it explicit this property is not enumerable
  // because otherwise some prototype manipulation in
  // userland will fail
  enumerable: false,
  get: function get() {
    return this._writableState.highWaterMark;
  }
}); // if we're already writing something, then just put this
// in the queue, and wait our turn.  Otherwise, call _write
// If we return false, then we need a drain event, so set that flag.

function writeOrBuffer(stream, state, isBuf, chunk, encoding, cb) {
  if (!isBuf) {
    var newChunk = decodeChunk(state, chunk, encoding);

    if (chunk !== newChunk) {
      isBuf = true;
      encoding = 'buffer';
      chunk = newChunk;
    }
  }

  var len = state.objectMode ? 1 : chunk.length;
  state.length += len;
  var ret = state.length < state.highWaterMark; // we must ensure that previous needDrain will not be reset to false.

  if (!ret) state.needDrain = true;

  if (state.writing || state.corked) {
    var last = state.lastBufferedRequest;
    state.lastBufferedRequest = {
      chunk: chunk,
      encoding: encoding,
      isBuf: isBuf,
      callback: cb,
      next: null
    };

    if (last) {
      last.next = state.lastBufferedRequest;
    } else {
      state.bufferedRequest = state.lastBufferedRequest;
    }

    state.bufferedRequestCount += 1;
  } else {
    doWrite(stream, state, false, len, chunk, encoding, cb);
  }

  return ret;
}

function doWrite(stream, state, writev, len, chunk, encoding, cb) {
  state.writelen = len;
  state.writecb = cb;
  state.writing = true;
  state.sync = true;
  if (state.destroyed) state.onwrite(new ERR_STREAM_DESTROYED('write'));else if (writev) stream._writev(chunk, state.onwrite);else stream._write(chunk, encoding, state.onwrite);
  state.sync = false;
}

function onwriteError(stream, state, sync, er, cb) {
  --state.pendingcb;

  if (sync) {
    // defer the callback if we are being called synchronously
    // to avoid piling up things on the stack
    process.nextTick(cb, er); // this can emit finish, and it will always happen
    // after error

    process.nextTick(finishMaybe, stream, state);
    stream._writableState.errorEmitted = true;
    errorOrDestroy(stream, er);
  } else {
    // the caller expect this to happen before if
    // it is async
    cb(er);
    stream._writableState.errorEmitted = true;
    errorOrDestroy(stream, er); // this can emit finish, but finish must
    // always follow error

    finishMaybe(stream, state);
  }
}

function onwriteStateUpdate(state) {
  state.writing = false;
  state.writecb = null;
  state.length -= state.writelen;
  state.writelen = 0;
}

function onwrite(stream, er) {
  var state = stream._writableState;
  var sync = state.sync;
  var cb = state.writecb;
  if (typeof cb !== 'function') throw new ERR_MULTIPLE_CALLBACK();
  onwriteStateUpdate(state);
  if (er) onwriteError(stream, state, sync, er, cb);else {
    // Check if we're actually ready to finish, but don't emit yet
    var finished = needFinish(state) || stream.destroyed;

    if (!finished && !state.corked && !state.bufferProcessing && state.bufferedRequest) {
      clearBuffer(stream, state);
    }

    if (sync) {
      process.nextTick(afterWrite, stream, state, finished, cb);
    } else {
      afterWrite(stream, state, finished, cb);
    }
  }
}

function afterWrite(stream, state, finished, cb) {
  if (!finished) onwriteDrain(stream, state);
  state.pendingcb--;
  cb();
  finishMaybe(stream, state);
} // Must force callback to be called on nextTick, so that we don't
// emit 'drain' before the write() consumer gets the 'false' return
// value, and has a chance to attach a 'drain' listener.


function onwriteDrain(stream, state) {
  if (state.length === 0 && state.needDrain) {
    state.needDrain = false;
    stream.emit('drain');
  }
} // if there's something in the buffer waiting, then process it


function clearBuffer(stream, state) {
  state.bufferProcessing = true;
  var entry = state.bufferedRequest;

  if (stream._writev && entry && entry.next) {
    // Fast case, write everything using _writev()
    var l = state.bufferedRequestCount;
    var buffer = new Array(l);
    var holder = state.corkedRequestsFree;
    holder.entry = entry;
    var count = 0;
    var allBuffers = true;

    while (entry) {
      buffer[count] = entry;
      if (!entry.isBuf) allBuffers = false;
      entry = entry.next;
      count += 1;
    }

    buffer.allBuffers = allBuffers;
    doWrite(stream, state, true, state.length, buffer, '', holder.finish); // doWrite is almost always async, defer these to save a bit of time
    // as the hot path ends with doWrite

    state.pendingcb++;
    state.lastBufferedRequest = null;

    if (holder.next) {
      state.corkedRequestsFree = holder.next;
      holder.next = null;
    } else {
      state.corkedRequestsFree = new CorkedRequest(state);
    }

    state.bufferedRequestCount = 0;
  } else {
    // Slow case, write chunks one-by-one
    while (entry) {
      var chunk = entry.chunk;
      var encoding = entry.encoding;
      var cb = entry.callback;
      var len = state.objectMode ? 1 : chunk.length;
      doWrite(stream, state, false, len, chunk, encoding, cb);
      entry = entry.next;
      state.bufferedRequestCount--; // if we didn't call the onwrite immediately, then
      // it means that we need to wait until it does.
      // also, that means that the chunk and cb are currently
      // being processed, so move the buffer counter past them.

      if (state.writing) {
        break;
      }
    }

    if (entry === null) state.lastBufferedRequest = null;
  }

  state.bufferedRequest = entry;
  state.bufferProcessing = false;
}

Writable.prototype._write = function (chunk, encoding, cb) {
  cb(new ERR_METHOD_NOT_IMPLEMENTED('_write()'));
};

Writable.prototype._writev = null;

Writable.prototype.end = function (chunk, encoding, cb) {
  var state = this._writableState;

  if (typeof chunk === 'function') {
    cb = chunk;
    chunk = null;
    encoding = null;
  } else if (typeof encoding === 'function') {
    cb = encoding;
    encoding = null;
  }

  if (chunk !== null && chunk !== undefined) this.write(chunk, encoding); // .end() fully uncorks

  if (state.corked) {
    state.corked = 1;
    this.uncork();
  } // ignore unnecessary end() calls.


  if (!state.ending) endWritable(this, state, cb);
  return this;
};

Object.defineProperty(Writable.prototype, 'writableLength', {
  // making it explicit this property is not enumerable
  // because otherwise some prototype manipulation in
  // userland will fail
  enumerable: false,
  get: function get() {
    return this._writableState.length;
  }
});

function needFinish(state) {
  return state.ending && state.length === 0 && state.bufferedRequest === null && !state.finished && !state.writing;
}

function callFinal(stream, state) {
  stream._final(function (err) {
    state.pendingcb--;

    if (err) {
      errorOrDestroy(stream, err);
    }

    state.prefinished = true;
    stream.emit('prefinish');
    finishMaybe(stream, state);
  });
}

function prefinish(stream, state) {
  if (!state.prefinished && !state.finalCalled) {
    if (typeof stream._final === 'function' && !state.destroyed) {
      state.pendingcb++;
      state.finalCalled = true;
      process.nextTick(callFinal, stream, state);
    } else {
      state.prefinished = true;
      stream.emit('prefinish');
    }
  }
}

function finishMaybe(stream, state) {
  var need = needFinish(state);

  if (need) {
    prefinish(stream, state);

    if (state.pendingcb === 0) {
      state.finished = true;
      stream.emit('finish');

      if (state.autoDestroy) {
        // In case of duplex streams we need a way to detect
        // if the readable side is ready for autoDestroy as well
        var rState = stream._readableState;

        if (!rState || rState.autoDestroy && rState.endEmitted) {
          stream.destroy();
        }
      }
    }
  }

  return need;
}

function endWritable(stream, state, cb) {
  state.ending = true;
  finishMaybe(stream, state);

  if (cb) {
    if (state.finished) process.nextTick(cb);else stream.once('finish', cb);
  }

  state.ended = true;
  stream.writable = false;
}

function onCorkedFinish(corkReq, state, err) {
  var entry = corkReq.entry;
  corkReq.entry = null;

  while (entry) {
    var cb = entry.callback;
    state.pendingcb--;
    cb(err);
    entry = entry.next;
  } // reuse the free corkReq.


  state.corkedRequestsFree.next = corkReq;
}

Object.defineProperty(Writable.prototype, 'destroyed', {
  // making it explicit this property is not enumerable
  // because otherwise some prototype manipulation in
  // userland will fail
  enumerable: false,
  get: function get() {
    if (this._writableState === undefined) {
      return false;
    }

    return this._writableState.destroyed;
  },
  set: function set(value) {
    // we ignore the value if the stream
    // has not been initialized yet
    if (!this._writableState) {
      return;
    } // backward compatibility, the user is explicitly
    // managing destroyed


    this._writableState.destroyed = value;
  }
});
Writable.prototype.destroy = destroyImpl.destroy;
Writable.prototype._undestroy = destroyImpl.undestroy;

Writable.prototype._destroy = function (err, cb) {
  cb(err);
};
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(/*! ./../../../../webpack/buildin/global.js */ "./node_modules/webpack/buildin/global.js"), __webpack_require__(/*! ./../../../../process/browser.js */ "./node_modules/process/browser.js")))

/***/ }),

/***/ "./node_modules/browserify-sign/node_modules/readable-stream/lib/internal/streams/async_iterator.js":
/*!**********************************************************************************************************!*\
  !*** ./node_modules/browserify-sign/node_modules/readable-stream/lib/internal/streams/async_iterator.js ***!
  \**********************************************************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {

var _Object$setPrototypeO;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var finished = __webpack_require__(/*! ./end-of-stream */ "./node_modules/browserify-sign/node_modules/readable-stream/lib/internal/streams/end-of-stream.js");

var kLastResolve = Symbol('lastResolve');
var kLastReject = Symbol('lastReject');
var kError = Symbol('error');
var kEnded = Symbol('ended');
var kLastPromise = Symbol('lastPromise');
var kHandlePromise = Symbol('handlePromise');
var kStream = Symbol('stream');

function createIterResult(value, done) {
  return {
    value: value,
    done: done
  };
}

function readAndResolve(iter) {
  var resolve = iter[kLastResolve];

  if (resolve !== null) {
    var data = iter[kStream].read(); // we defer if data is null
    // we can be expecting either 'end' or
    // 'error'

    if (data !== null) {
      iter[kLastPromise] = null;
      iter[kLastResolve] = null;
      iter[kLastReject] = null;
      resolve(createIterResult(data, false));
    }
  }
}

function onReadable(iter) {
  // we wait for the next tick, because it might
  // emit an error with process.nextTick
  process.nextTick(readAndResolve, iter);
}

function wrapForNext(lastPromise, iter) {
  return function (resolve, reject) {
    lastPromise.then(function () {
      if (iter[kEnded]) {
        resolve(createIterResult(undefined, true));
        return;
      }

      iter[kHandlePromise](resolve, reject);
    }, reject);
  };
}

var AsyncIteratorPrototype = Object.getPrototypeOf(function () {});
var ReadableStreamAsyncIteratorPrototype = Object.setPrototypeOf((_Object$setPrototypeO = {
  get stream() {
    return this[kStream];
  },

  next: function next() {
    var _this = this;

    // if we have detected an error in the meanwhile
    // reject straight away
    var error = this[kError];

    if (error !== null) {
      return Promise.reject(error);
    }

    if (this[kEnded]) {
      return Promise.resolve(createIterResult(undefined, true));
    }

    if (this[kStream].destroyed) {
      // We need to defer via nextTick because if .destroy(err) is
      // called, the error will be emitted via nextTick, and
      // we cannot guarantee that there is no error lingering around
      // waiting to be emitted.
      return new Promise(function (resolve, reject) {
        process.nextTick(function () {
          if (_this[kError]) {
            reject(_this[kError]);
          } else {
            resolve(createIterResult(undefined, true));
          }
        });
      });
    } // if we have multiple next() calls
    // we will wait for the previous Promise to finish
    // this logic is optimized to support for await loops,
    // where next() is only called once at a time


    var lastPromise = this[kLastPromise];
    var promise;

    if (lastPromise) {
      promise = new Promise(wrapForNext(lastPromise, this));
    } else {
      // fast path needed to support multiple this.push()
      // without triggering the next() queue
      var data = this[kStream].read();

      if (data !== null) {
        return Promise.resolve(createIterResult(data, false));
      }

      promise = new Promise(this[kHandlePromise]);
    }

    this[kLastPromise] = promise;
    return promise;
  }
}, _defineProperty(_Object$setPrototypeO, Symbol.asyncIterator, function () {
  return this;
}), _defineProperty(_Object$setPrototypeO, "return", function _return() {
  var _this2 = this;

  // destroy(err, cb) is a private API
  // we can guarantee we have that here, because we control the
  // Readable class this is attached to
  return new Promise(function (resolve, reject) {
    _this2[kStream].destroy(null, function (err) {
      if (err) {
        reject(err);
        return;
      }

      resolve(createIterResult(undefined, true));
    });
  });
}), _Object$setPrototypeO), AsyncIteratorPrototype);

var createReadableStreamAsyncIterator = function createReadableStreamAsyncIterator(stream) {
  var _Object$create;

  var iterator = Object.create(ReadableStreamAsyncIteratorPrototype, (_Object$create = {}, _defineProperty(_Object$create, kStream, {
    value: stream,
    writable: true
  }), _defineProperty(_Object$create, kLastResolve, {
    value: null,
    writable: true
  }), _defineProperty(_Object$create, kLastReject, {
    value: null,
    writable: true
  }), _defineProperty(_Object$create, kError, {
    value: null,
    writable: true
  }), _defineProperty(_Object$create, kEnded, {
    value: stream._readableState.endEmitted,
    writable: true
  }), _defineProperty(_Object$create, kHandlePromise, {
    value: function value(resolve, reject) {
      var data = iterator[kStream].read();

      if (data) {
        iterator[kLastPromise] = null;
        iterator[kLastResolve] = null;
        iterator[kLastReject] = null;
        resolve(createIterResult(data, false));
      } else {
        iterator[kLastResolve] = resolve;
        iterator[kLastReject] = reject;
      }
    },
    writable: true
  }), _Object$create));
  iterator[kLastPromise] = null;
  finished(stream, function (err) {
    if (err && err.code !== 'ERR_STREAM_PREMATURE_CLOSE') {
      var reject = iterator[kLastReject]; // reject if we are waiting for data in the Promise
      // returned by next() and store the error

      if (reject !== null) {
        iterator[kLastPromise] = null;
        iterator[kLastResolve] = null;
        iterator[kLastReject] = null;
        reject(err);
      }

      iterator[kError] = err;
      return;
    }

    var resolve = iterator[kLastResolve];

    if (resolve !== null) {
      iterator[kLastPromise] = null;
      iterator[kLastResolve] = null;
      iterator[kLastReject] = null;
      resolve(createIterResult(undefined, true));
    }

    iterator[kEnded] = true;
  });
  stream.on('readable', onReadable.bind(null, iterator));
  return iterator;
};

module.exports = createReadableStreamAsyncIterator;
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(/*! ./../../../../../../process/browser.js */ "./node_modules/process/browser.js")))

/***/ }),

/***/ "./node_modules/browserify-sign/node_modules/readable-stream/lib/internal/streams/buffer_list.js":
/*!*******************************************************************************************************!*\
  !*** ./node_modules/browserify-sign/node_modules/readable-stream/lib/internal/streams/buffer_list.js ***!
  \*******************************************************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var _require = __webpack_require__(/*! buffer */ "./node_modules/node-libs-browser/node_modules/buffer/index.js"),
    Buffer = _require.Buffer;

var _require2 = __webpack_require__(/*! util */ 8),
    inspect = _require2.inspect;

var custom = inspect && inspect.custom || 'inspect';

function copyBuffer(src, target, offset) {
  Buffer.prototype.copy.call(src, target, offset);
}

module.exports =
/*#__PURE__*/
function () {
  function BufferList() {
    _classCallCheck(this, BufferList);

    this.head = null;
    this.tail = null;
    this.length = 0;
  }

  _createClass(BufferList, [{
    key: "push",
    value: function push(v) {
      var entry = {
        data: v,
        next: null
      };
      if (this.length > 0) this.tail.next = entry;else this.head = entry;
      this.tail = entry;
      ++this.length;
    }
  }, {
    key: "unshift",
    value: function unshift(v) {
      var entry = {
        data: v,
        next: this.head
      };
      if (this.length === 0) this.tail = entry;
      this.head = entry;
      ++this.length;
    }
  }, {
    key: "shift",
    value: function shift() {
      if (this.length === 0) return;
      var ret = this.head.data;
      if (this.length === 1) this.head = this.tail = null;else this.head = this.head.next;
      --this.length;
      return ret;
    }
  }, {
    key: "clear",
    value: function clear() {
      this.head = this.tail = null;
      this.length = 0;
    }
  }, {
    key: "join",
    value: function join(s) {
      if (this.length === 0) return '';
      var p = this.head;
      var ret = '' + p.data;

      while (p = p.next) {
        ret += s + p.data;
      }

      return ret;
    }
  }, {
    key: "concat",
    value: function concat(n) {
      if (this.length === 0) return Buffer.alloc(0);
      var ret = Buffer.allocUnsafe(n >>> 0);
      var p = this.head;
      var i = 0;

      while (p) {
        copyBuffer(p.data, ret, i);
        i += p.data.length;
        p = p.next;
      }

      return ret;
    } // Consumes a specified amount of bytes or characters from the buffered data.

  }, {
    key: "consume",
    value: function consume(n, hasStrings) {
      var ret;

      if (n < this.head.data.length) {
        // `slice` is the same for buffers and strings.
        ret = this.head.data.slice(0, n);
        this.head.data = this.head.data.slice(n);
      } else if (n === this.head.data.length) {
        // First chunk is a perfect match.
        ret = this.shift();
      } else {
        // Result spans more than one buffer.
        ret = hasStrings ? this._getString(n) : this._getBuffer(n);
      }

      return ret;
    }
  }, {
    key: "first",
    value: function first() {
      return this.head.data;
    } // Consumes a specified amount of characters from the buffered data.

  }, {
    key: "_getString",
    value: function _getString(n) {
      var p = this.head;
      var c = 1;
      var ret = p.data;
      n -= ret.length;

      while (p = p.next) {
        var str = p.data;
        var nb = n > str.length ? str.length : n;
        if (nb === str.length) ret += str;else ret += str.slice(0, n);
        n -= nb;

        if (n === 0) {
          if (nb === str.length) {
            ++c;
            if (p.next) this.head = p.next;else this.head = this.tail = null;
          } else {
            this.head = p;
            p.data = str.slice(nb);
          }

          break;
        }

        ++c;
      }

      this.length -= c;
      return ret;
    } // Consumes a specified amount of bytes from the buffered data.

  }, {
    key: "_getBuffer",
    value: function _getBuffer(n) {
      var ret = Buffer.allocUnsafe(n);
      var p = this.head;
      var c = 1;
      p.data.copy(ret);
      n -= p.data.length;

      while (p = p.next) {
        var buf = p.data;
        var nb = n > buf.length ? buf.length : n;
        buf.copy(ret, ret.length - n, 0, nb);
        n -= nb;

        if (n === 0) {
          if (nb === buf.length) {
            ++c;
            if (p.next) this.head = p.next;else this.head = this.tail = null;
          } else {
            this.head = p;
            p.data = buf.slice(nb);
          }

          break;
        }

        ++c;
      }

      this.length -= c;
      return ret;
    } // Make sure the linked list only shows the minimal necessary information.

  }, {
    key: custom,
    value: function value(_, options) {
      return inspect(this, _objectSpread({}, options, {
        // Only inspect one level.
        depth: 0,
        // It should not recurse.
        customInspect: false
      }));
    }
  }]);

  return BufferList;
}();

/***/ }),

/***/ "./node_modules/browserify-sign/node_modules/readable-stream/lib/internal/streams/destroy.js":
/*!***************************************************************************************************!*\
  !*** ./node_modules/browserify-sign/node_modules/readable-stream/lib/internal/streams/destroy.js ***!
  \***************************************************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) { // undocumented cb() API, needed for core, not for public API

function destroy(err, cb) {
  var _this = this;

  var readableDestroyed = this._readableState && this._readableState.destroyed;
  var writableDestroyed = this._writableState && this._writableState.destroyed;

  if (readableDestroyed || writableDestroyed) {
    if (cb) {
      cb(err);
    } else if (err) {
      if (!this._writableState) {
        process.nextTick(emitErrorNT, this, err);
      } else if (!this._writableState.errorEmitted) {
        this._writableState.errorEmitted = true;
        process.nextTick(emitErrorNT, this, err);
      }
    }

    return this;
  } // we set destroyed to true before firing error callbacks in order
  // to make it re-entrance safe in case destroy() is called within callbacks


  if (this._readableState) {
    this._readableState.destroyed = true;
  } // if this is a duplex stream mark the writable part as destroyed as well


  if (this._writableState) {
    this._writableState.destroyed = true;
  }

  this._destroy(err || null, function (err) {
    if (!cb && err) {
      if (!_this._writableState) {
        process.nextTick(emitErrorAndCloseNT, _this, err);
      } else if (!_this._writableState.errorEmitted) {
        _this._writableState.errorEmitted = true;
        process.nextTick(emitErrorAndCloseNT, _this, err);
      } else {
        process.nextTick(emitCloseNT, _this);
      }
    } else if (cb) {
      process.nextTick(emitCloseNT, _this);
      cb(err);
    } else {
      process.nextTick(emitCloseNT, _this);
    }
  });

  return this;
}

function emitErrorAndCloseNT(self, err) {
  emitErrorNT(self, err);
  emitCloseNT(self);
}

function emitCloseNT(self) {
  if (self._writableState && !self._writableState.emitClose) return;
  if (self._readableState && !self._readableState.emitClose) return;
  self.emit('close');
}

function undestroy() {
  if (this._readableState) {
    this._readableState.destroyed = false;
    this._readableState.reading = false;
    this._readableState.ended = false;
    this._readableState.endEmitted = false;
  }

  if (this._writableState) {
    this._writableState.destroyed = false;
    this._writableState.ended = false;
    this._writableState.ending = false;
    this._writableState.finalCalled = false;
    this._writableState.prefinished = false;
    this._writableState.finished = false;
    this._writableState.errorEmitted = false;
  }
}

function emitErrorNT(self, err) {
  self.emit('error', err);
}

function errorOrDestroy(stream, err) {
  // We have tests that rely on errors being emitted
  // in the same tick, so changing this is semver major.
  // For now when you opt-in to autoDestroy we allow
  // the error to be emitted nextTick. In a future
  // semver major update we should change the default to this.
  var rState = stream._readableState;
  var wState = stream._writableState;
  if (rState && rState.autoDestroy || wState && wState.autoDestroy) stream.destroy(err);else stream.emit('error', err);
}

module.exports = {
  destroy: destroy,
  undestroy: undestroy,
  errorOrDestroy: errorOrDestroy
};
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(/*! ./../../../../../../process/browser.js */ "./node_modules/process/browser.js")))

/***/ }),

/***/ "./node_modules/browserify-sign/node_modules/readable-stream/lib/internal/streams/end-of-stream.js":
/*!*********************************************************************************************************!*\
  !*** ./node_modules/browserify-sign/node_modules/readable-stream/lib/internal/streams/end-of-stream.js ***!
  \*********************************************************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Ported from https://github.com/mafintosh/end-of-stream with
// permission from the author, Mathias Buus (@mafintosh).


var ERR_STREAM_PREMATURE_CLOSE = __webpack_require__(/*! ../../../errors */ "./node_modules/browserify-sign/node_modules/readable-stream/errors-browser.js").codes.ERR_STREAM_PREMATURE_CLOSE;

function once(callback) {
  var called = false;
  return function () {
    if (called) return;
    called = true;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    callback.apply(this, args);
  };
}

function noop() {}

function isRequest(stream) {
  return stream.setHeader && typeof stream.abort === 'function';
}

function eos(stream, opts, callback) {
  if (typeof opts === 'function') return eos(stream, null, opts);
  if (!opts) opts = {};
  callback = once(callback || noop);
  var readable = opts.readable || opts.readable !== false && stream.readable;
  var writable = opts.writable || opts.writable !== false && stream.writable;

  var onlegacyfinish = function onlegacyfinish() {
    if (!stream.writable) onfinish();
  };

  var writableEnded = stream._writableState && stream._writableState.finished;

  var onfinish = function onfinish() {
    writable = false;
    writableEnded = true;
    if (!readable) callback.call(stream);
  };

  var readableEnded = stream._readableState && stream._readableState.endEmitted;

  var onend = function onend() {
    readable = false;
    readableEnded = true;
    if (!writable) callback.call(stream);
  };

  var onerror = function onerror(err) {
    callback.call(stream, err);
  };

  var onclose = function onclose() {
    var err;

    if (readable && !readableEnded) {
      if (!stream._readableState || !stream._readableState.ended) err = new ERR_STREAM_PREMATURE_CLOSE();
      return callback.call(stream, err);
    }

    if (writable && !writableEnded) {
      if (!stream._writableState || !stream._writableState.ended) err = new ERR_STREAM_PREMATURE_CLOSE();
      return callback.call(stream, err);
    }
  };

  var onrequest = function onrequest() {
    stream.req.on('finish', onfinish);
  };

  if (isRequest(stream)) {
    stream.on('complete', onfinish);
    stream.on('abort', onclose);
    if (stream.req) onrequest();else stream.on('request', onrequest);
  } else if (writable && !stream._writableState) {
    // legacy streams
    stream.on('end', onlegacyfinish);
    stream.on('close', onlegacyfinish);
  }

  stream.on('end', onend);
  stream.on('finish', onfinish);
  if (opts.error !== false) stream.on('error', onerror);
  stream.on('close', onclose);
  return function () {
    stream.removeListener('complete', onfinish);
    stream.removeListener('abort', onclose);
    stream.removeListener('request', onrequest);
    if (stream.req) stream.req.removeListener('finish', onfinish);
    stream.removeListener('end', onlegacyfinish);
    stream.removeListener('close', onlegacyfinish);
    stream.removeListener('finish', onfinish);
    stream.removeListener('end', onend);
    stream.removeListener('error', onerror);
    stream.removeListener('close', onclose);
  };
}

module.exports = eos;

/***/ }),

/***/ "./node_modules/browserify-sign/node_modules/readable-stream/lib/internal/streams/from-browser.js":
/*!********************************************************************************************************!*\
  !*** ./node_modules/browserify-sign/node_modules/readable-stream/lib/internal/streams/from-browser.js ***!
  \********************************************************************************************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = function () {
  throw new Error('Readable.from is not available in the browser')
};


/***/ }),

/***/ "./node_modules/browserify-sign/node_modules/readable-stream/lib/internal/streams/pipeline.js":
/*!****************************************************************************************************!*\
  !*** ./node_modules/browserify-sign/node_modules/readable-stream/lib/internal/streams/pipeline.js ***!
  \****************************************************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Ported from https://github.com/mafintosh/pump with
// permission from the author, Mathias Buus (@mafintosh).


var eos;

function once(callback) {
  var called = false;
  return function () {
    if (called) return;
    called = true;
    callback.apply(void 0, arguments);
  };
}

var _require$codes = __webpack_require__(/*! ../../../errors */ "./node_modules/browserify-sign/node_modules/readable-stream/errors-browser.js").codes,
    ERR_MISSING_ARGS = _require$codes.ERR_MISSING_ARGS,
    ERR_STREAM_DESTROYED = _require$codes.ERR_STREAM_DESTROYED;

function noop(err) {
  // Rethrow the error if it exists to avoid swallowing it
  if (err) throw err;
}

function isRequest(stream) {
  return stream.setHeader && typeof stream.abort === 'function';
}

function destroyer(stream, reading, writing, callback) {
  callback = once(callback);
  var closed = false;
  stream.on('close', function () {
    closed = true;
  });
  if (eos === undefined) eos = __webpack_require__(/*! ./end-of-stream */ "./node_modules/browserify-sign/node_modules/readable-stream/lib/internal/streams/end-of-stream.js");
  eos(stream, {
    readable: reading,
    writable: writing
  }, function (err) {
    if (err) return callback(err);
    closed = true;
    callback();
  });
  var destroyed = false;
  return function (err) {
    if (closed) return;
    if (destroyed) return;
    destroyed = true; // request.destroy just do .end - .abort is what we want

    if (isRequest(stream)) return stream.abort();
    if (typeof stream.destroy === 'function') return stream.destroy();
    callback(err || new ERR_STREAM_DESTROYED('pipe'));
  };
}

function call(fn) {
  fn();
}

function pipe(from, to) {
  return from.pipe(to);
}

function popCallback(streams) {
  if (!streams.length) return noop;
  if (typeof streams[streams.length - 1] !== 'function') return noop;
  return streams.pop();
}

function pipeline() {
  for (var _len = arguments.length, streams = new Array(_len), _key = 0; _key < _len; _key++) {
    streams[_key] = arguments[_key];
  }

  var callback = popCallback(streams);
  if (Array.isArray(streams[0])) streams = streams[0];

  if (streams.length < 2) {
    throw new ERR_MISSING_ARGS('streams');
  }

  var error;
  var destroys = streams.map(function (stream, i) {
    var reading = i < streams.length - 1;
    var writing = i > 0;
    return destroyer(stream, reading, writing, function (err) {
      if (!error) error = err;
      if (err) destroys.forEach(call);
      if (reading) return;
      destroys.forEach(call);
      callback(error);
    });
  });
  return streams.reduce(pipe);
}

module.exports = pipeline;

/***/ }),

/***/ "./node_modules/browserify-sign/node_modules/readable-stream/lib/internal/streams/state.js":
/*!*************************************************************************************************!*\
  !*** ./node_modules/browserify-sign/node_modules/readable-stream/lib/internal/streams/state.js ***!
  \*************************************************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var ERR_INVALID_OPT_VALUE = __webpack_require__(/*! ../../../errors */ "./node_modules/browserify-sign/node_modules/readable-stream/errors-browser.js").codes.ERR_INVALID_OPT_VALUE;

function highWaterMarkFrom(options, isDuplex, duplexKey) {
  return options.highWaterMark != null ? options.highWaterMark : isDuplex ? options[duplexKey] : null;
}

function getHighWaterMark(state, options, duplexKey, isDuplex) {
  var hwm = highWaterMarkFrom(options, isDuplex, duplexKey);

  if (hwm != null) {
    if (!(isFinite(hwm) && Math.floor(hwm) === hwm) || hwm < 0) {
      var name = isDuplex ? duplexKey : 'highWaterMark';
      throw new ERR_INVALID_OPT_VALUE(name, hwm);
    }

    return Math.floor(hwm);
  } // Default value


  return state.objectMode ? 16 : 16 * 1024;
}

module.exports = {
  getHighWaterMark: getHighWaterMark
};

/***/ }),

/***/ "./node_modules/browserify-sign/node_modules/readable-stream/lib/internal/streams/stream-browser.js":
/*!**********************************************************************************************************!*\
  !*** ./node_modules/browserify-sign/node_modules/readable-stream/lib/internal/streams/stream-browser.js ***!
  \**********************************************************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(/*! events */ "./node_modules/events/events.js").EventEmitter;


/***/ }),

/***/ "./node_modules/browserify-sign/node_modules/readable-stream/readable-browser.js":
/*!***************************************************************************************!*\
  !*** ./node_modules/browserify-sign/node_modules/readable-stream/readable-browser.js ***!
  \***************************************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(/*! ./lib/_stream_readable.js */ "./node_modules/browserify-sign/node_modules/readable-stream/lib/_stream_readable.js");
exports.Stream = exports;
exports.Readable = exports;
exports.Writable = __webpack_require__(/*! ./lib/_stream_writable.js */ "./node_modules/browserify-sign/node_modules/readable-stream/lib/_stream_writable.js");
exports.Duplex = __webpack_require__(/*! ./lib/_stream_duplex.js */ "./node_modules/browserify-sign/node_modules/readable-stream/lib/_stream_duplex.js");
exports.Transform = __webpack_require__(/*! ./lib/_stream_transform.js */ "./node_modules/browserify-sign/node_modules/readable-stream/lib/_stream_transform.js");
exports.PassThrough = __webpack_require__(/*! ./lib/_stream_passthrough.js */ "./node_modules/browserify-sign/node_modules/readable-stream/lib/_stream_passthrough.js");
exports.finished = __webpack_require__(/*! ./lib/internal/streams/end-of-stream.js */ "./node_modules/browserify-sign/node_modules/readable-stream/lib/internal/streams/end-of-stream.js");
exports.pipeline = __webpack_require__(/*! ./lib/internal/streams/pipeline.js */ "./node_modules/browserify-sign/node_modules/readable-stream/lib/internal/streams/pipeline.js");


/***/ }),

/***/ "./node_modules/browserify-sign/node_modules/safe-buffer/index.js":
/*!************************************************************************!*\
  !*** ./node_modules/browserify-sign/node_modules/safe-buffer/index.js ***!
  \************************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

/*! safe-buffer. MIT License. Feross Aboukhadijeh <https://feross.org/opensource> */
/* eslint-disable node/no-deprecated-api */
var buffer = __webpack_require__(/*! buffer */ "./node_modules/node-libs-browser/node_modules/buffer/index.js")
var Buffer = buffer.Buffer

// alternative to using Object.keys for old browsers
function copyProps (src, dst) {
  for (var key in src) {
    dst[key] = src[key]
  }
}
if (Buffer.from && Buffer.alloc && Buffer.allocUnsafe && Buffer.allocUnsafeSlow) {
  module.exports = buffer
} else {
  // Copy properties from require('buffer')
  copyProps(buffer, exports)
  exports.Buffer = SafeBuffer
}

function SafeBuffer (arg, encodingOrOffset, length) {
  return Buffer(arg, encodingOrOffset, length)
}

SafeBuffer.prototype = Object.create(Buffer.prototype)

// Copy static methods from Buffer
copyProps(Buffer, SafeBuffer)

SafeBuffer.from = function (arg, encodingOrOffset, length) {
  if (typeof arg === 'number') {
    throw new TypeError('Argument must not be a number')
  }
  return Buffer(arg, encodingOrOffset, length)
}

SafeBuffer.alloc = function (size, fill, encoding) {
  if (typeof size !== 'number') {
    throw new TypeError('Argument must be a number')
  }
  var buf = Buffer(size)
  if (fill !== undefined) {
    if (typeof encoding === 'string') {
      buf.fill(fill, encoding)
    } else {
      buf.fill(fill)
    }
  } else {
    buf.fill(0)
  }
  return buf
}

SafeBuffer.allocUnsafe = function (size) {
  if (typeof size !== 'number') {
    throw new TypeError('Argument must be a number')
  }
  return Buffer(size)
}

SafeBuffer.allocUnsafeSlow = function (size) {
  if (typeof size !== 'number') {
    throw new TypeError('Argument must be a number')
  }
  return buffer.SlowBuffer(size)
}


/***/ }),

/***/ "./node_modules/buffer-xor/index.js":
/*!******************************************!*\
  !*** ./node_modules/buffer-xor/index.js ***!
  \******************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(Buffer) {module.exports = function xor (a, b) {
  var length = Math.min(a.length, b.length)
  var buffer = new Buffer(length)

  for (var i = 0; i < length; ++i) {
    buffer[i] = a[i] ^ b[i]
  }

  return buffer
}

/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(/*! ./../node-libs-browser/node_modules/buffer/index.js */ "./node_modules/node-libs-browser/node_modules/buffer/index.js").Buffer))

/***/ }),

/***/ "./node_modules/cipher-base/index.js":
/*!*******************************************!*\
  !*** ./node_modules/cipher-base/index.js ***!
  \*******************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var Buffer = __webpack_require__(/*! safe-buffer */ "./node_modules/safe-buffer/index.js").Buffer
var Transform = __webpack_require__(/*! stream */ "./node_modules/stream-browserify/index.js").Transform
var StringDecoder = __webpack_require__(/*! string_decoder */ "./node_modules/string_decoder/lib/string_decoder.js").StringDecoder
var inherits = __webpack_require__(/*! inherits */ "./node_modules/inherits/inherits_browser.js")

function CipherBase (hashMode) {
  Transform.call(this)
  this.hashMode = typeof hashMode === 'string'
  if (this.hashMode) {
    this[hashMode] = this._finalOrDigest
  } else {
    this.final = this._finalOrDigest
  }
  if (this._final) {
    this.__final = this._final
    this._final = null
  }
  this._decoder = null
  this._encoding = null
}
inherits(CipherBase, Transform)

CipherBase.prototype.update = function (data, inputEnc, outputEnc) {
  if (typeof data === 'string') {
    data = Buffer.from(data, inputEnc)
  }

  var outData = this._update(data)
  if (this.hashMode) return this

  if (outputEnc) {
    outData = this._toString(outData, outputEnc)
  }

  return outData
}

CipherBase.prototype.setAutoPadding = function () {}
CipherBase.prototype.getAuthTag = function () {
  throw new Error('trying to get auth tag in unsupported state')
}

CipherBase.prototype.setAuthTag = function () {
  throw new Error('trying to set auth tag in unsupported state')
}

CipherBase.prototype.setAAD = function () {
  throw new Error('trying to set aad in unsupported state')
}

CipherBase.prototype._transform = function (data, _, next) {
  var err
  try {
    if (this.hashMode) {
      this._update(data)
    } else {
      this.push(this._update(data))
    }
  } catch (e) {
    err = e
  } finally {
    next(err)
  }
}
CipherBase.prototype._flush = function (done) {
  var err
  try {
    this.push(this.__final())
  } catch (e) {
    err = e
  }

  done(err)
}
CipherBase.prototype._finalOrDigest = function (outputEnc) {
  var outData = this.__final() || Buffer.alloc(0)
  if (outputEnc) {
    outData = this._toString(outData, outputEnc, true)
  }
  return outData
}

CipherBase.prototype._toString = function (value, enc, fin) {
  if (!this._decoder) {
    this._decoder = new StringDecoder(enc)
    this._encoding = enc
  }

  if (this._encoding !== enc) throw new Error('can\'t switch encodings')

  var out = this._decoder.write(value)
  if (fin) {
    out += this._decoder.end()
  }

  return out
}

module.exports = CipherBase


/***/ }),

/***/ "./node_modules/core-util-is/lib/util.js":
/*!***********************************************!*\
  !*** ./node_modules/core-util-is/lib/util.js ***!
  \***********************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(Buffer) {// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

// NOTE: These type checking functions intentionally don't use `instanceof`
// because it is fragile and can be easily faked with `Object.create()`.

function isArray(arg) {
  if (Array.isArray) {
    return Array.isArray(arg);
  }
  return objectToString(arg) === '[object Array]';
}
exports.isArray = isArray;

function isBoolean(arg) {
  return typeof arg === 'boolean';
}
exports.isBoolean = isBoolean;

function isNull(arg) {
  return arg === null;
}
exports.isNull = isNull;

function isNullOrUndefined(arg) {
  return arg == null;
}
exports.isNullOrUndefined = isNullOrUndefined;

function isNumber(arg) {
  return typeof arg === 'number';
}
exports.isNumber = isNumber;

function isString(arg) {
  return typeof arg === 'string';
}
exports.isString = isString;

function isSymbol(arg) {
  return typeof arg === 'symbol';
}
exports.isSymbol = isSymbol;

function isUndefined(arg) {
  return arg === void 0;
}
exports.isUndefined = isUndefined;

function isRegExp(re) {
  return objectToString(re) === '[object RegExp]';
}
exports.isRegExp = isRegExp;

function isObject(arg) {
  return typeof arg === 'object' && arg !== null;
}
exports.isObject = isObject;

function isDate(d) {
  return objectToString(d) === '[object Date]';
}
exports.isDate = isDate;

function isError(e) {
  return (objectToString(e) === '[object Error]' || e instanceof Error);
}
exports.isError = isError;

function isFunction(arg) {
  return typeof arg === 'function';
}
exports.isFunction = isFunction;

function isPrimitive(arg) {
  return arg === null ||
         typeof arg === 'boolean' ||
         typeof arg === 'number' ||
         typeof arg === 'string' ||
         typeof arg === 'symbol' ||  // ES6 symbol
         typeof arg === 'undefined';
}
exports.isPrimitive = isPrimitive;

exports.isBuffer = Buffer.isBuffer;

function objectToString(o) {
  return Object.prototype.toString.call(o);
}

/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(/*! ./../../node-libs-browser/node_modules/buffer/index.js */ "./node_modules/node-libs-browser/node_modules/buffer/index.js").Buffer))

/***/ }),

/***/ "./node_modules/create-ecdh/browser.js":
/*!*********************************************!*\
  !*** ./node_modules/create-ecdh/browser.js ***!
  \*********************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(Buffer) {var elliptic = __webpack_require__(/*! elliptic */ "./node_modules/elliptic/lib/elliptic.js")
var BN = __webpack_require__(/*! bn.js */ "./node_modules/create-ecdh/node_modules/bn.js/lib/bn.js")

module.exports = function createECDH (curve) {
  return new ECDH(curve)
}

var aliases = {
  secp256k1: {
    name: 'secp256k1',
    byteLength: 32
  },
  secp224r1: {
    name: 'p224',
    byteLength: 28
  },
  prime256v1: {
    name: 'p256',
    byteLength: 32
  },
  prime192v1: {
    name: 'p192',
    byteLength: 24
  },
  ed25519: {
    name: 'ed25519',
    byteLength: 32
  },
  secp384r1: {
    name: 'p384',
    byteLength: 48
  },
  secp521r1: {
    name: 'p521',
    byteLength: 66
  }
}

aliases.p224 = aliases.secp224r1
aliases.p256 = aliases.secp256r1 = aliases.prime256v1
aliases.p192 = aliases.secp192r1 = aliases.prime192v1
aliases.p384 = aliases.secp384r1
aliases.p521 = aliases.secp521r1

function ECDH (curve) {
  this.curveType = aliases[curve]
  if (!this.curveType) {
    this.curveType = {
      name: curve
    }
  }
  this.curve = new elliptic.ec(this.curveType.name) // eslint-disable-line new-cap
  this.keys = void 0
}

ECDH.prototype.generateKeys = function (enc, format) {
  this.keys = this.curve.genKeyPair()
  return this.getPublicKey(enc, format)
}

ECDH.prototype.computeSecret = function (other, inenc, enc) {
  inenc = inenc || 'utf8'
  if (!Buffer.isBuffer(other)) {
    other = new Buffer(other, inenc)
  }
  var otherPub = this.curve.keyFromPublic(other).getPublic()
  var out = otherPub.mul(this.keys.getPrivate()).getX()
  return formatReturnValue(out, enc, this.curveType.byteLength)
}

ECDH.prototype.getPublicKey = function (enc, format) {
  var key = this.keys.getPublic(format === 'compressed', true)
  if (format === 'hybrid') {
    if (key[key.length - 1] % 2) {
      key[0] = 7
    } else {
      key[0] = 6
    }
  }
  return formatReturnValue(key, enc)
}

ECDH.prototype.getPrivateKey = function (enc) {
  return formatReturnValue(this.keys.getPrivate(), enc)
}

ECDH.prototype.setPublicKey = function (pub, enc) {
  enc = enc || 'utf8'
  if (!Buffer.isBuffer(pub)) {
    pub = new Buffer(pub, enc)
  }
  this.keys._importPublic(pub)
  return this
}

ECDH.prototype.setPrivateKey = function (priv, enc) {
  enc = enc || 'utf8'
  if (!Buffer.isBuffer(priv)) {
    priv = new Buffer(priv, enc)
  }

  var _priv = new BN(priv)
  _priv = _priv.toString(16)
  this.keys = this.curve.genKeyPair()
  this.keys._importPrivate(_priv)
  return this
}

function formatReturnValue (bn, enc, len) {
  if (!Array.isArray(bn)) {
    bn = bn.toArray()
  }
  var buf = new Buffer(bn)
  if (len && buf.length < len) {
    var zeros = new Buffer(len - buf.length)
    zeros.fill(0)
    buf = Buffer.concat([zeros, buf])
  }
  if (!enc) {
    return buf
  } else {
    return buf.toString(enc)
  }
}

/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(/*! ./../node-libs-browser/node_modules/buffer/index.js */ "./node_modules/node-libs-browser/node_modules/buffer/index.js").Buffer))

/***/ }),

/***/ "./node_modules/create-ecdh/node_modules/bn.js/lib/bn.js":
/*!***************************************************************!*\
  !*** ./node_modules/create-ecdh/node_modules/bn.js/lib/bn.js ***!
  \***************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {(function (module, exports) {
  'use strict';

  // Utils
  function assert (val, msg) {
    if (!val) throw new Error(msg || 'Assertion failed');
  }

  // Could use `inherits` module, but don't want to move from single file
  // architecture yet.
  function inherits (ctor, superCtor) {
    ctor.super_ = superCtor;
    var TempCtor = function () {};
    TempCtor.prototype = superCtor.prototype;
    ctor.prototype = new TempCtor();
    ctor.prototype.constructor = ctor;
  }

  // BN

  function BN (number, base, endian) {
    if (BN.isBN(number)) {
      return number;
    }

    this.negative = 0;
    this.words = null;
    this.length = 0;

    // Reduction context
    this.red = null;

    if (number !== null) {
      if (base === 'le' || base === 'be') {
        endian = base;
        base = 10;
      }

      this._init(number || 0, base || 10, endian || 'be');
    }
  }
  if (typeof module === 'object') {
    module.exports = BN;
  } else {
    exports.BN = BN;
  }

  BN.BN = BN;
  BN.wordSize = 26;

  var Buffer;
  try {
    Buffer = __webpack_require__(/*! buffer */ 12).Buffer;
  } catch (e) {
  }

  BN.isBN = function isBN (num) {
    if (num instanceof BN) {
      return true;
    }

    return num !== null && typeof num === 'object' &&
      num.constructor.wordSize === BN.wordSize && Array.isArray(num.words);
  };

  BN.max = function max (left, right) {
    if (left.cmp(right) > 0) return left;
    return right;
  };

  BN.min = function min (left, right) {
    if (left.cmp(right) < 0) return left;
    return right;
  };

  BN.prototype._init = function init (number, base, endian) {
    if (typeof number === 'number') {
      return this._initNumber(number, base, endian);
    }

    if (typeof number === 'object') {
      return this._initArray(number, base, endian);
    }

    if (base === 'hex') {
      base = 16;
    }
    assert(base === (base | 0) && base >= 2 && base <= 36);

    number = number.toString().replace(/\s+/g, '');
    var start = 0;
    if (number[0] === '-') {
      start++;
    }

    if (base === 16) {
      this._parseHex(number, start);
    } else {
      this._parseBase(number, base, start);
    }

    if (number[0] === '-') {
      this.negative = 1;
    }

    this.strip();

    if (endian !== 'le') return;

    this._initArray(this.toArray(), base, endian);
  };

  BN.prototype._initNumber = function _initNumber (number, base, endian) {
    if (number < 0) {
      this.negative = 1;
      number = -number;
    }
    if (number < 0x4000000) {
      this.words = [ number & 0x3ffffff ];
      this.length = 1;
    } else if (number < 0x10000000000000) {
      this.words = [
        number & 0x3ffffff,
        (number / 0x4000000) & 0x3ffffff
      ];
      this.length = 2;
    } else {
      assert(number < 0x20000000000000); // 2 ^ 53 (unsafe)
      this.words = [
        number & 0x3ffffff,
        (number / 0x4000000) & 0x3ffffff,
        1
      ];
      this.length = 3;
    }

    if (endian !== 'le') return;

    // Reverse the bytes
    this._initArray(this.toArray(), base, endian);
  };

  BN.prototype._initArray = function _initArray (number, base, endian) {
    // Perhaps a Uint8Array
    assert(typeof number.length === 'number');
    if (number.length <= 0) {
      this.words = [ 0 ];
      this.length = 1;
      return this;
    }

    this.length = Math.ceil(number.length / 3);
    this.words = new Array(this.length);
    for (var i = 0; i < this.length; i++) {
      this.words[i] = 0;
    }

    var j, w;
    var off = 0;
    if (endian === 'be') {
      for (i = number.length - 1, j = 0; i >= 0; i -= 3) {
        w = number[i] | (number[i - 1] << 8) | (number[i - 2] << 16);
        this.words[j] |= (w << off) & 0x3ffffff;
        this.words[j + 1] = (w >>> (26 - off)) & 0x3ffffff;
        off += 24;
        if (off >= 26) {
          off -= 26;
          j++;
        }
      }
    } else if (endian === 'le') {
      for (i = 0, j = 0; i < number.length; i += 3) {
        w = number[i] | (number[i + 1] << 8) | (number[i + 2] << 16);
        this.words[j] |= (w << off) & 0x3ffffff;
        this.words[j + 1] = (w >>> (26 - off)) & 0x3ffffff;
        off += 24;
        if (off >= 26) {
          off -= 26;
          j++;
        }
      }
    }
    return this.strip();
  };

  function parseHex (str, start, end) {
    var r = 0;
    var len = Math.min(str.length, end);
    for (var i = start; i < len; i++) {
      var c = str.charCodeAt(i) - 48;

      r <<= 4;

      // 'a' - 'f'
      if (c >= 49 && c <= 54) {
        r |= c - 49 + 0xa;

      // 'A' - 'F'
      } else if (c >= 17 && c <= 22) {
        r |= c - 17 + 0xa;

      // '0' - '9'
      } else {
        r |= c & 0xf;
      }
    }
    return r;
  }

  BN.prototype._parseHex = function _parseHex (number, start) {
    // Create possibly bigger array to ensure that it fits the number
    this.length = Math.ceil((number.length - start) / 6);
    this.words = new Array(this.length);
    for (var i = 0; i < this.length; i++) {
      this.words[i] = 0;
    }

    var j, w;
    // Scan 24-bit chunks and add them to the number
    var off = 0;
    for (i = number.length - 6, j = 0; i >= start; i -= 6) {
      w = parseHex(number, i, i + 6);
      this.words[j] |= (w << off) & 0x3ffffff;
      // NOTE: `0x3fffff` is intentional here, 26bits max shift + 24bit hex limb
      this.words[j + 1] |= w >>> (26 - off) & 0x3fffff;
      off += 24;
      if (off >= 26) {
        off -= 26;
        j++;
      }
    }
    if (i + 6 !== start) {
      w = parseHex(number, start, i + 6);
      this.words[j] |= (w << off) & 0x3ffffff;
      this.words[j + 1] |= w >>> (26 - off) & 0x3fffff;
    }
    this.strip();
  };

  function parseBase (str, start, end, mul) {
    var r = 0;
    var len = Math.min(str.length, end);
    for (var i = start; i < len; i++) {
      var c = str.charCodeAt(i) - 48;

      r *= mul;

      // 'a'
      if (c >= 49) {
        r += c - 49 + 0xa;

      // 'A'
      } else if (c >= 17) {
        r += c - 17 + 0xa;

      // '0' - '9'
      } else {
        r += c;
      }
    }
    return r;
  }

  BN.prototype._parseBase = function _parseBase (number, base, start) {
    // Initialize as zero
    this.words = [ 0 ];
    this.length = 1;

    // Find length of limb in base
    for (var limbLen = 0, limbPow = 1; limbPow <= 0x3ffffff; limbPow *= base) {
      limbLen++;
    }
    limbLen--;
    limbPow = (limbPow / base) | 0;

    var total = number.length - start;
    var mod = total % limbLen;
    var end = Math.min(total, total - mod) + start;

    var word = 0;
    for (var i = start; i < end; i += limbLen) {
      word = parseBase(number, i, i + limbLen, base);

      this.imuln(limbPow);
      if (this.words[0] + word < 0x4000000) {
        this.words[0] += word;
      } else {
        this._iaddn(word);
      }
    }

    if (mod !== 0) {
      var pow = 1;
      word = parseBase(number, i, number.length, base);

      for (i = 0; i < mod; i++) {
        pow *= base;
      }

      this.imuln(pow);
      if (this.words[0] + word < 0x4000000) {
        this.words[0] += word;
      } else {
        this._iaddn(word);
      }
    }
  };

  BN.prototype.copy = function copy (dest) {
    dest.words = new Array(this.length);
    for (var i = 0; i < this.length; i++) {
      dest.words[i] = this.words[i];
    }
    dest.length = this.length;
    dest.negative = this.negative;
    dest.red = this.red;
  };

  BN.prototype.clone = function clone () {
    var r = new BN(null);
    this.copy(r);
    return r;
  };

  BN.prototype._expand = function _expand (size) {
    while (this.length < size) {
      this.words[this.length++] = 0;
    }
    return this;
  };

  // Remove leading `0` from `this`
  BN.prototype.strip = function strip () {
    while (this.length > 1 && this.words[this.length - 1] === 0) {
      this.length--;
    }
    return this._normSign();
  };

  BN.prototype._normSign = function _normSign () {
    // -0 = 0
    if (this.length === 1 && this.words[0] === 0) {
      this.negative = 0;
    }
    return this;
  };

  BN.prototype.inspect = function inspect () {
    return (this.red ? '<BN-R: ' : '<BN: ') + this.toString(16) + '>';
  };

  /*

  var zeros = [];
  var groupSizes = [];
  var groupBases = [];

  var s = '';
  var i = -1;
  while (++i < BN.wordSize) {
    zeros[i] = s;
    s += '0';
  }
  groupSizes[0] = 0;
  groupSizes[1] = 0;
  groupBases[0] = 0;
  groupBases[1] = 0;
  var base = 2 - 1;
  while (++base < 36 + 1) {
    var groupSize = 0;
    var groupBase = 1;
    while (groupBase < (1 << BN.wordSize) / base) {
      groupBase *= base;
      groupSize += 1;
    }
    groupSizes[base] = groupSize;
    groupBases[base] = groupBase;
  }

  */

  var zeros = [
    '',
    '0',
    '00',
    '000',
    '0000',
    '00000',
    '000000',
    '0000000',
    '00000000',
    '000000000',
    '0000000000',
    '00000000000',
    '000000000000',
    '0000000000000',
    '00000000000000',
    '000000000000000',
    '0000000000000000',
    '00000000000000000',
    '000000000000000000',
    '0000000000000000000',
    '00000000000000000000',
    '000000000000000000000',
    '0000000000000000000000',
    '00000000000000000000000',
    '000000000000000000000000',
    '0000000000000000000000000'
  ];

  var groupSizes = [
    0, 0,
    25, 16, 12, 11, 10, 9, 8,
    8, 7, 7, 7, 7, 6, 6,
    6, 6, 6, 6, 6, 5, 5,
    5, 5, 5, 5, 5, 5, 5,
    5, 5, 5, 5, 5, 5, 5
  ];

  var groupBases = [
    0, 0,
    33554432, 43046721, 16777216, 48828125, 60466176, 40353607, 16777216,
    43046721, 10000000, 19487171, 35831808, 62748517, 7529536, 11390625,
    16777216, 24137569, 34012224, 47045881, 64000000, 4084101, 5153632,
    6436343, 7962624, 9765625, 11881376, 14348907, 17210368, 20511149,
    24300000, 28629151, 33554432, 39135393, 45435424, 52521875, 60466176
  ];

  BN.prototype.toString = function toString (base, padding) {
    base = base || 10;
    padding = padding | 0 || 1;

    var out;
    if (base === 16 || base === 'hex') {
      out = '';
      var off = 0;
      var carry = 0;
      for (var i = 0; i < this.length; i++) {
        var w = this.words[i];
        var word = (((w << off) | carry) & 0xffffff).toString(16);
        carry = (w >>> (24 - off)) & 0xffffff;
        if (carry !== 0 || i !== this.length - 1) {
          out = zeros[6 - word.length] + word + out;
        } else {
          out = word + out;
        }
        off += 2;
        if (off >= 26) {
          off -= 26;
          i--;
        }
      }
      if (carry !== 0) {
        out = carry.toString(16) + out;
      }
      while (out.length % padding !== 0) {
        out = '0' + out;
      }
      if (this.negative !== 0) {
        out = '-' + out;
      }
      return out;
    }

    if (base === (base | 0) && base >= 2 && base <= 36) {
      // var groupSize = Math.floor(BN.wordSize * Math.LN2 / Math.log(base));
      var groupSize = groupSizes[base];
      // var groupBase = Math.pow(base, groupSize);
      var groupBase = groupBases[base];
      out = '';
      var c = this.clone();
      c.negative = 0;
      while (!c.isZero()) {
        var r = c.modn(groupBase).toString(base);
        c = c.idivn(groupBase);

        if (!c.isZero()) {
          out = zeros[groupSize - r.length] + r + out;
        } else {
          out = r + out;
        }
      }
      if (this.isZero()) {
        out = '0' + out;
      }
      while (out.length % padding !== 0) {
        out = '0' + out;
      }
      if (this.negative !== 0) {
        out = '-' + out;
      }
      return out;
    }

    assert(false, 'Base should be between 2 and 36');
  };

  BN.prototype.toNumber = function toNumber () {
    var ret = this.words[0];
    if (this.length === 2) {
      ret += this.words[1] * 0x4000000;
    } else if (this.length === 3 && this.words[2] === 0x01) {
      // NOTE: at this stage it is known that the top bit is set
      ret += 0x10000000000000 + (this.words[1] * 0x4000000);
    } else if (this.length > 2) {
      assert(false, 'Number can only safely store up to 53 bits');
    }
    return (this.negative !== 0) ? -ret : ret;
  };

  BN.prototype.toJSON = function toJSON () {
    return this.toString(16);
  };

  BN.prototype.toBuffer = function toBuffer (endian, length) {
    assert(typeof Buffer !== 'undefined');
    return this.toArrayLike(Buffer, endian, length);
  };

  BN.prototype.toArray = function toArray (endian, length) {
    return this.toArrayLike(Array, endian, length);
  };

  BN.prototype.toArrayLike = function toArrayLike (ArrayType, endian, length) {
    var byteLength = this.byteLength();
    var reqLength = length || Math.max(1, byteLength);
    assert(byteLength <= reqLength, 'byte array longer than desired length');
    assert(reqLength > 0, 'Requested array length <= 0');

    this.strip();
    var littleEndian = endian === 'le';
    var res = new ArrayType(reqLength);

    var b, i;
    var q = this.clone();
    if (!littleEndian) {
      // Assume big-endian
      for (i = 0; i < reqLength - byteLength; i++) {
        res[i] = 0;
      }

      for (i = 0; !q.isZero(); i++) {
        b = q.andln(0xff);
        q.iushrn(8);

        res[reqLength - i - 1] = b;
      }
    } else {
      for (i = 0; !q.isZero(); i++) {
        b = q.andln(0xff);
        q.iushrn(8);

        res[i] = b;
      }

      for (; i < reqLength; i++) {
        res[i] = 0;
      }
    }

    return res;
  };

  if (Math.clz32) {
    BN.prototype._countBits = function _countBits (w) {
      return 32 - Math.clz32(w);
    };
  } else {
    BN.prototype._countBits = function _countBits (w) {
      var t = w;
      var r = 0;
      if (t >= 0x1000) {
        r += 13;
        t >>>= 13;
      }
      if (t >= 0x40) {
        r += 7;
        t >>>= 7;
      }
      if (t >= 0x8) {
        r += 4;
        t >>>= 4;
      }
      if (t >= 0x02) {
        r += 2;
        t >>>= 2;
      }
      return r + t;
    };
  }

  BN.prototype._zeroBits = function _zeroBits (w) {
    // Short-cut
    if (w === 0) return 26;

    var t = w;
    var r = 0;
    if ((t & 0x1fff) === 0) {
      r += 13;
      t >>>= 13;
    }
    if ((t & 0x7f) === 0) {
      r += 7;
      t >>>= 7;
    }
    if ((t & 0xf) === 0) {
      r += 4;
      t >>>= 4;
    }
    if ((t & 0x3) === 0) {
      r += 2;
      t >>>= 2;
    }
    if ((t & 0x1) === 0) {
      r++;
    }
    return r;
  };

  // Return number of used bits in a BN
  BN.prototype.bitLength = function bitLength () {
    var w = this.words[this.length - 1];
    var hi = this._countBits(w);
    return (this.length - 1) * 26 + hi;
  };

  function toBitArray (num) {
    var w = new Array(num.bitLength());

    for (var bit = 0; bit < w.length; bit++) {
      var off = (bit / 26) | 0;
      var wbit = bit % 26;

      w[bit] = (num.words[off] & (1 << wbit)) >>> wbit;
    }

    return w;
  }

  // Number of trailing zero bits
  BN.prototype.zeroBits = function zeroBits () {
    if (this.isZero()) return 0;

    var r = 0;
    for (var i = 0; i < this.length; i++) {
      var b = this._zeroBits(this.words[i]);
      r += b;
      if (b !== 26) break;
    }
    return r;
  };

  BN.prototype.byteLength = function byteLength () {
    return Math.ceil(this.bitLength() / 8);
  };

  BN.prototype.toTwos = function toTwos (width) {
    if (this.negative !== 0) {
      return this.abs().inotn(width).iaddn(1);
    }
    return this.clone();
  };

  BN.prototype.fromTwos = function fromTwos (width) {
    if (this.testn(width - 1)) {
      return this.notn(width).iaddn(1).ineg();
    }
    return this.clone();
  };

  BN.prototype.isNeg = function isNeg () {
    return this.negative !== 0;
  };

  // Return negative clone of `this`
  BN.prototype.neg = function neg () {
    return this.clone().ineg();
  };

  BN.prototype.ineg = function ineg () {
    if (!this.isZero()) {
      this.negative ^= 1;
    }

    return this;
  };

  // Or `num` with `this` in-place
  BN.prototype.iuor = function iuor (num) {
    while (this.length < num.length) {
      this.words[this.length++] = 0;
    }

    for (var i = 0; i < num.length; i++) {
      this.words[i] = this.words[i] | num.words[i];
    }

    return this.strip();
  };

  BN.prototype.ior = function ior (num) {
    assert((this.negative | num.negative) === 0);
    return this.iuor(num);
  };

  // Or `num` with `this`
  BN.prototype.or = function or (num) {
    if (this.length > num.length) return this.clone().ior(num);
    return num.clone().ior(this);
  };

  BN.prototype.uor = function uor (num) {
    if (this.length > num.length) return this.clone().iuor(num);
    return num.clone().iuor(this);
  };

  // And `num` with `this` in-place
  BN.prototype.iuand = function iuand (num) {
    // b = min-length(num, this)
    var b;
    if (this.length > num.length) {
      b = num;
    } else {
      b = this;
    }

    for (var i = 0; i < b.length; i++) {
      this.words[i] = this.words[i] & num.words[i];
    }

    this.length = b.length;

    return this.strip();
  };

  BN.prototype.iand = function iand (num) {
    assert((this.negative | num.negative) === 0);
    return this.iuand(num);
  };

  // And `num` with `this`
  BN.prototype.and = function and (num) {
    if (this.length > num.length) return this.clone().iand(num);
    return num.clone().iand(this);
  };

  BN.prototype.uand = function uand (num) {
    if (this.length > num.length) return this.clone().iuand(num);
    return num.clone().iuand(this);
  };

  // Xor `num` with `this` in-place
  BN.prototype.iuxor = function iuxor (num) {
    // a.length > b.length
    var a;
    var b;
    if (this.length > num.length) {
      a = this;
      b = num;
    } else {
      a = num;
      b = this;
    }

    for (var i = 0; i < b.length; i++) {
      this.words[i] = a.words[i] ^ b.words[i];
    }

    if (this !== a) {
      for (; i < a.length; i++) {
        this.words[i] = a.words[i];
      }
    }

    this.length = a.length;

    return this.strip();
  };

  BN.prototype.ixor = function ixor (num) {
    assert((this.negative | num.negative) === 0);
    return this.iuxor(num);
  };

  // Xor `num` with `this`
  BN.prototype.xor = function xor (num) {
    if (this.length > num.length) return this.clone().ixor(num);
    return num.clone().ixor(this);
  };

  BN.prototype.uxor = function uxor (num) {
    if (this.length > num.length) return this.clone().iuxor(num);
    return num.clone().iuxor(this);
  };

  // Not ``this`` with ``width`` bitwidth
  BN.prototype.inotn = function inotn (width) {
    assert(typeof width === 'number' && width >= 0);

    var bytesNeeded = Math.ceil(width / 26) | 0;
    var bitsLeft = width % 26;

    // Extend the buffer with leading zeroes
    this._expand(bytesNeeded);

    if (bitsLeft > 0) {
      bytesNeeded--;
    }

    // Handle complete words
    for (var i = 0; i < bytesNeeded; i++) {
      this.words[i] = ~this.words[i] & 0x3ffffff;
    }

    // Handle the residue
    if (bitsLeft > 0) {
      this.words[i] = ~this.words[i] & (0x3ffffff >> (26 - bitsLeft));
    }

    // And remove leading zeroes
    return this.strip();
  };

  BN.prototype.notn = function notn (width) {
    return this.clone().inotn(width);
  };

  // Set `bit` of `this`
  BN.prototype.setn = function setn (bit, val) {
    assert(typeof bit === 'number' && bit >= 0);

    var off = (bit / 26) | 0;
    var wbit = bit % 26;

    this._expand(off + 1);

    if (val) {
      this.words[off] = this.words[off] | (1 << wbit);
    } else {
      this.words[off] = this.words[off] & ~(1 << wbit);
    }

    return this.strip();
  };

  // Add `num` to `this` in-place
  BN.prototype.iadd = function iadd (num) {
    var r;

    // negative + positive
    if (this.negative !== 0 && num.negative === 0) {
      this.negative = 0;
      r = this.isub(num);
      this.negative ^= 1;
      return this._normSign();

    // positive + negative
    } else if (this.negative === 0 && num.negative !== 0) {
      num.negative = 0;
      r = this.isub(num);
      num.negative = 1;
      return r._normSign();
    }

    // a.length > b.length
    var a, b;
    if (this.length > num.length) {
      a = this;
      b = num;
    } else {
      a = num;
      b = this;
    }

    var carry = 0;
    for (var i = 0; i < b.length; i++) {
      r = (a.words[i] | 0) + (b.words[i] | 0) + carry;
      this.words[i] = r & 0x3ffffff;
      carry = r >>> 26;
    }
    for (; carry !== 0 && i < a.length; i++) {
      r = (a.words[i] | 0) + carry;
      this.words[i] = r & 0x3ffffff;
      carry = r >>> 26;
    }

    this.length = a.length;
    if (carry !== 0) {
      this.words[this.length] = carry;
      this.length++;
    // Copy the rest of the words
    } else if (a !== this) {
      for (; i < a.length; i++) {
        this.words[i] = a.words[i];
      }
    }

    return this;
  };

  // Add `num` to `this`
  BN.prototype.add = function add (num) {
    var res;
    if (num.negative !== 0 && this.negative === 0) {
      num.negative = 0;
      res = this.sub(num);
      num.negative ^= 1;
      return res;
    } else if (num.negative === 0 && this.negative !== 0) {
      this.negative = 0;
      res = num.sub(this);
      this.negative = 1;
      return res;
    }

    if (this.length > num.length) return this.clone().iadd(num);

    return num.clone().iadd(this);
  };

  // Subtract `num` from `this` in-place
  BN.prototype.isub = function isub (num) {
    // this - (-num) = this + num
    if (num.negative !== 0) {
      num.negative = 0;
      var r = this.iadd(num);
      num.negative = 1;
      return r._normSign();

    // -this - num = -(this + num)
    } else if (this.negative !== 0) {
      this.negative = 0;
      this.iadd(num);
      this.negative = 1;
      return this._normSign();
    }

    // At this point both numbers are positive
    var cmp = this.cmp(num);

    // Optimization - zeroify
    if (cmp === 0) {
      this.negative = 0;
      this.length = 1;
      this.words[0] = 0;
      return this;
    }

    // a > b
    var a, b;
    if (cmp > 0) {
      a = this;
      b = num;
    } else {
      a = num;
      b = this;
    }

    var carry = 0;
    for (var i = 0; i < b.length; i++) {
      r = (a.words[i] | 0) - (b.words[i] | 0) + carry;
      carry = r >> 26;
      this.words[i] = r & 0x3ffffff;
    }
    for (; carry !== 0 && i < a.length; i++) {
      r = (a.words[i] | 0) + carry;
      carry = r >> 26;
      this.words[i] = r & 0x3ffffff;
    }

    // Copy rest of the words
    if (carry === 0 && i < a.length && a !== this) {
      for (; i < a.length; i++) {
        this.words[i] = a.words[i];
      }
    }

    this.length = Math.max(this.length, i);

    if (a !== this) {
      this.negative = 1;
    }

    return this.strip();
  };

  // Subtract `num` from `this`
  BN.prototype.sub = function sub (num) {
    return this.clone().isub(num);
  };

  function smallMulTo (self, num, out) {
    out.negative = num.negative ^ self.negative;
    var len = (self.length + num.length) | 0;
    out.length = len;
    len = (len - 1) | 0;

    // Peel one iteration (compiler can't do it, because of code complexity)
    var a = self.words[0] | 0;
    var b = num.words[0] | 0;
    var r = a * b;

    var lo = r & 0x3ffffff;
    var carry = (r / 0x4000000) | 0;
    out.words[0] = lo;

    for (var k = 1; k < len; k++) {
      // Sum all words with the same `i + j = k` and accumulate `ncarry`,
      // note that ncarry could be >= 0x3ffffff
      var ncarry = carry >>> 26;
      var rword = carry & 0x3ffffff;
      var maxJ = Math.min(k, num.length - 1);
      for (var j = Math.max(0, k - self.length + 1); j <= maxJ; j++) {
        var i = (k - j) | 0;
        a = self.words[i] | 0;
        b = num.words[j] | 0;
        r = a * b + rword;
        ncarry += (r / 0x4000000) | 0;
        rword = r & 0x3ffffff;
      }
      out.words[k] = rword | 0;
      carry = ncarry | 0;
    }
    if (carry !== 0) {
      out.words[k] = carry | 0;
    } else {
      out.length--;
    }

    return out.strip();
  }

  // TODO(indutny): it may be reasonable to omit it for users who don't need
  // to work with 256-bit numbers, otherwise it gives 20% improvement for 256-bit
  // multiplication (like elliptic secp256k1).
  var comb10MulTo = function comb10MulTo (self, num, out) {
    var a = self.words;
    var b = num.words;
    var o = out.words;
    var c = 0;
    var lo;
    var mid;
    var hi;
    var a0 = a[0] | 0;
    var al0 = a0 & 0x1fff;
    var ah0 = a0 >>> 13;
    var a1 = a[1] | 0;
    var al1 = a1 & 0x1fff;
    var ah1 = a1 >>> 13;
    var a2 = a[2] | 0;
    var al2 = a2 & 0x1fff;
    var ah2 = a2 >>> 13;
    var a3 = a[3] | 0;
    var al3 = a3 & 0x1fff;
    var ah3 = a3 >>> 13;
    var a4 = a[4] | 0;
    var al4 = a4 & 0x1fff;
    var ah4 = a4 >>> 13;
    var a5 = a[5] | 0;
    var al5 = a5 & 0x1fff;
    var ah5 = a5 >>> 13;
    var a6 = a[6] | 0;
    var al6 = a6 & 0x1fff;
    var ah6 = a6 >>> 13;
    var a7 = a[7] | 0;
    var al7 = a7 & 0x1fff;
    var ah7 = a7 >>> 13;
    var a8 = a[8] | 0;
    var al8 = a8 & 0x1fff;
    var ah8 = a8 >>> 13;
    var a9 = a[9] | 0;
    var al9 = a9 & 0x1fff;
    var ah9 = a9 >>> 13;
    var b0 = b[0] | 0;
    var bl0 = b0 & 0x1fff;
    var bh0 = b0 >>> 13;
    var b1 = b[1] | 0;
    var bl1 = b1 & 0x1fff;
    var bh1 = b1 >>> 13;
    var b2 = b[2] | 0;
    var bl2 = b2 & 0x1fff;
    var bh2 = b2 >>> 13;
    var b3 = b[3] | 0;
    var bl3 = b3 & 0x1fff;
    var bh3 = b3 >>> 13;
    var b4 = b[4] | 0;
    var bl4 = b4 & 0x1fff;
    var bh4 = b4 >>> 13;
    var b5 = b[5] | 0;
    var bl5 = b5 & 0x1fff;
    var bh5 = b5 >>> 13;
    var b6 = b[6] | 0;
    var bl6 = b6 & 0x1fff;
    var bh6 = b6 >>> 13;
    var b7 = b[7] | 0;
    var bl7 = b7 & 0x1fff;
    var bh7 = b7 >>> 13;
    var b8 = b[8] | 0;
    var bl8 = b8 & 0x1fff;
    var bh8 = b8 >>> 13;
    var b9 = b[9] | 0;
    var bl9 = b9 & 0x1fff;
    var bh9 = b9 >>> 13;

    out.negative = self.negative ^ num.negative;
    out.length = 19;
    /* k = 0 */
    lo = Math.imul(al0, bl0);
    mid = Math.imul(al0, bh0);
    mid = (mid + Math.imul(ah0, bl0)) | 0;
    hi = Math.imul(ah0, bh0);
    var w0 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w0 >>> 26)) | 0;
    w0 &= 0x3ffffff;
    /* k = 1 */
    lo = Math.imul(al1, bl0);
    mid = Math.imul(al1, bh0);
    mid = (mid + Math.imul(ah1, bl0)) | 0;
    hi = Math.imul(ah1, bh0);
    lo = (lo + Math.imul(al0, bl1)) | 0;
    mid = (mid + Math.imul(al0, bh1)) | 0;
    mid = (mid + Math.imul(ah0, bl1)) | 0;
    hi = (hi + Math.imul(ah0, bh1)) | 0;
    var w1 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w1 >>> 26)) | 0;
    w1 &= 0x3ffffff;
    /* k = 2 */
    lo = Math.imul(al2, bl0);
    mid = Math.imul(al2, bh0);
    mid = (mid + Math.imul(ah2, bl0)) | 0;
    hi = Math.imul(ah2, bh0);
    lo = (lo + Math.imul(al1, bl1)) | 0;
    mid = (mid + Math.imul(al1, bh1)) | 0;
    mid = (mid + Math.imul(ah1, bl1)) | 0;
    hi = (hi + Math.imul(ah1, bh1)) | 0;
    lo = (lo + Math.imul(al0, bl2)) | 0;
    mid = (mid + Math.imul(al0, bh2)) | 0;
    mid = (mid + Math.imul(ah0, bl2)) | 0;
    hi = (hi + Math.imul(ah0, bh2)) | 0;
    var w2 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w2 >>> 26)) | 0;
    w2 &= 0x3ffffff;
    /* k = 3 */
    lo = Math.imul(al3, bl0);
    mid = Math.imul(al3, bh0);
    mid = (mid + Math.imul(ah3, bl0)) | 0;
    hi = Math.imul(ah3, bh0);
    lo = (lo + Math.imul(al2, bl1)) | 0;
    mid = (mid + Math.imul(al2, bh1)) | 0;
    mid = (mid + Math.imul(ah2, bl1)) | 0;
    hi = (hi + Math.imul(ah2, bh1)) | 0;
    lo = (lo + Math.imul(al1, bl2)) | 0;
    mid = (mid + Math.imul(al1, bh2)) | 0;
    mid = (mid + Math.imul(ah1, bl2)) | 0;
    hi = (hi + Math.imul(ah1, bh2)) | 0;
    lo = (lo + Math.imul(al0, bl3)) | 0;
    mid = (mid + Math.imul(al0, bh3)) | 0;
    mid = (mid + Math.imul(ah0, bl3)) | 0;
    hi = (hi + Math.imul(ah0, bh3)) | 0;
    var w3 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w3 >>> 26)) | 0;
    w3 &= 0x3ffffff;
    /* k = 4 */
    lo = Math.imul(al4, bl0);
    mid = Math.imul(al4, bh0);
    mid = (mid + Math.imul(ah4, bl0)) | 0;
    hi = Math.imul(ah4, bh0);
    lo = (lo + Math.imul(al3, bl1)) | 0;
    mid = (mid + Math.imul(al3, bh1)) | 0;
    mid = (mid + Math.imul(ah3, bl1)) | 0;
    hi = (hi + Math.imul(ah3, bh1)) | 0;
    lo = (lo + Math.imul(al2, bl2)) | 0;
    mid = (mid + Math.imul(al2, bh2)) | 0;
    mid = (mid + Math.imul(ah2, bl2)) | 0;
    hi = (hi + Math.imul(ah2, bh2)) | 0;
    lo = (lo + Math.imul(al1, bl3)) | 0;
    mid = (mid + Math.imul(al1, bh3)) | 0;
    mid = (mid + Math.imul(ah1, bl3)) | 0;
    hi = (hi + Math.imul(ah1, bh3)) | 0;
    lo = (lo + Math.imul(al0, bl4)) | 0;
    mid = (mid + Math.imul(al0, bh4)) | 0;
    mid = (mid + Math.imul(ah0, bl4)) | 0;
    hi = (hi + Math.imul(ah0, bh4)) | 0;
    var w4 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w4 >>> 26)) | 0;
    w4 &= 0x3ffffff;
    /* k = 5 */
    lo = Math.imul(al5, bl0);
    mid = Math.imul(al5, bh0);
    mid = (mid + Math.imul(ah5, bl0)) | 0;
    hi = Math.imul(ah5, bh0);
    lo = (lo + Math.imul(al4, bl1)) | 0;
    mid = (mid + Math.imul(al4, bh1)) | 0;
    mid = (mid + Math.imul(ah4, bl1)) | 0;
    hi = (hi + Math.imul(ah4, bh1)) | 0;
    lo = (lo + Math.imul(al3, bl2)) | 0;
    mid = (mid + Math.imul(al3, bh2)) | 0;
    mid = (mid + Math.imul(ah3, bl2)) | 0;
    hi = (hi + Math.imul(ah3, bh2)) | 0;
    lo = (lo + Math.imul(al2, bl3)) | 0;
    mid = (mid + Math.imul(al2, bh3)) | 0;
    mid = (mid + Math.imul(ah2, bl3)) | 0;
    hi = (hi + Math.imul(ah2, bh3)) | 0;
    lo = (lo + Math.imul(al1, bl4)) | 0;
    mid = (mid + Math.imul(al1, bh4)) | 0;
    mid = (mid + Math.imul(ah1, bl4)) | 0;
    hi = (hi + Math.imul(ah1, bh4)) | 0;
    lo = (lo + Math.imul(al0, bl5)) | 0;
    mid = (mid + Math.imul(al0, bh5)) | 0;
    mid = (mid + Math.imul(ah0, bl5)) | 0;
    hi = (hi + Math.imul(ah0, bh5)) | 0;
    var w5 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w5 >>> 26)) | 0;
    w5 &= 0x3ffffff;
    /* k = 6 */
    lo = Math.imul(al6, bl0);
    mid = Math.imul(al6, bh0);
    mid = (mid + Math.imul(ah6, bl0)) | 0;
    hi = Math.imul(ah6, bh0);
    lo = (lo + Math.imul(al5, bl1)) | 0;
    mid = (mid + Math.imul(al5, bh1)) | 0;
    mid = (mid + Math.imul(ah5, bl1)) | 0;
    hi = (hi + Math.imul(ah5, bh1)) | 0;
    lo = (lo + Math.imul(al4, bl2)) | 0;
    mid = (mid + Math.imul(al4, bh2)) | 0;
    mid = (mid + Math.imul(ah4, bl2)) | 0;
    hi = (hi + Math.imul(ah4, bh2)) | 0;
    lo = (lo + Math.imul(al3, bl3)) | 0;
    mid = (mid + Math.imul(al3, bh3)) | 0;
    mid = (mid + Math.imul(ah3, bl3)) | 0;
    hi = (hi + Math.imul(ah3, bh3)) | 0;
    lo = (lo + Math.imul(al2, bl4)) | 0;
    mid = (mid + Math.imul(al2, bh4)) | 0;
    mid = (mid + Math.imul(ah2, bl4)) | 0;
    hi = (hi + Math.imul(ah2, bh4)) | 0;
    lo = (lo + Math.imul(al1, bl5)) | 0;
    mid = (mid + Math.imul(al1, bh5)) | 0;
    mid = (mid + Math.imul(ah1, bl5)) | 0;
    hi = (hi + Math.imul(ah1, bh5)) | 0;
    lo = (lo + Math.imul(al0, bl6)) | 0;
    mid = (mid + Math.imul(al0, bh6)) | 0;
    mid = (mid + Math.imul(ah0, bl6)) | 0;
    hi = (hi + Math.imul(ah0, bh6)) | 0;
    var w6 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w6 >>> 26)) | 0;
    w6 &= 0x3ffffff;
    /* k = 7 */
    lo = Math.imul(al7, bl0);
    mid = Math.imul(al7, bh0);
    mid = (mid + Math.imul(ah7, bl0)) | 0;
    hi = Math.imul(ah7, bh0);
    lo = (lo + Math.imul(al6, bl1)) | 0;
    mid = (mid + Math.imul(al6, bh1)) | 0;
    mid = (mid + Math.imul(ah6, bl1)) | 0;
    hi = (hi + Math.imul(ah6, bh1)) | 0;
    lo = (lo + Math.imul(al5, bl2)) | 0;
    mid = (mid + Math.imul(al5, bh2)) | 0;
    mid = (mid + Math.imul(ah5, bl2)) | 0;
    hi = (hi + Math.imul(ah5, bh2)) | 0;
    lo = (lo + Math.imul(al4, bl3)) | 0;
    mid = (mid + Math.imul(al4, bh3)) | 0;
    mid = (mid + Math.imul(ah4, bl3)) | 0;
    hi = (hi + Math.imul(ah4, bh3)) | 0;
    lo = (lo + Math.imul(al3, bl4)) | 0;
    mid = (mid + Math.imul(al3, bh4)) | 0;
    mid = (mid + Math.imul(ah3, bl4)) | 0;
    hi = (hi + Math.imul(ah3, bh4)) | 0;
    lo = (lo + Math.imul(al2, bl5)) | 0;
    mid = (mid + Math.imul(al2, bh5)) | 0;
    mid = (mid + Math.imul(ah2, bl5)) | 0;
    hi = (hi + Math.imul(ah2, bh5)) | 0;
    lo = (lo + Math.imul(al1, bl6)) | 0;
    mid = (mid + Math.imul(al1, bh6)) | 0;
    mid = (mid + Math.imul(ah1, bl6)) | 0;
    hi = (hi + Math.imul(ah1, bh6)) | 0;
    lo = (lo + Math.imul(al0, bl7)) | 0;
    mid = (mid + Math.imul(al0, bh7)) | 0;
    mid = (mid + Math.imul(ah0, bl7)) | 0;
    hi = (hi + Math.imul(ah0, bh7)) | 0;
    var w7 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w7 >>> 26)) | 0;
    w7 &= 0x3ffffff;
    /* k = 8 */
    lo = Math.imul(al8, bl0);
    mid = Math.imul(al8, bh0);
    mid = (mid + Math.imul(ah8, bl0)) | 0;
    hi = Math.imul(ah8, bh0);
    lo = (lo + Math.imul(al7, bl1)) | 0;
    mid = (mid + Math.imul(al7, bh1)) | 0;
    mid = (mid + Math.imul(ah7, bl1)) | 0;
    hi = (hi + Math.imul(ah7, bh1)) | 0;
    lo = (lo + Math.imul(al6, bl2)) | 0;
    mid = (mid + Math.imul(al6, bh2)) | 0;
    mid = (mid + Math.imul(ah6, bl2)) | 0;
    hi = (hi + Math.imul(ah6, bh2)) | 0;
    lo = (lo + Math.imul(al5, bl3)) | 0;
    mid = (mid + Math.imul(al5, bh3)) | 0;
    mid = (mid + Math.imul(ah5, bl3)) | 0;
    hi = (hi + Math.imul(ah5, bh3)) | 0;
    lo = (lo + Math.imul(al4, bl4)) | 0;
    mid = (mid + Math.imul(al4, bh4)) | 0;
    mid = (mid + Math.imul(ah4, bl4)) | 0;
    hi = (hi + Math.imul(ah4, bh4)) | 0;
    lo = (lo + Math.imul(al3, bl5)) | 0;
    mid = (mid + Math.imul(al3, bh5)) | 0;
    mid = (mid + Math.imul(ah3, bl5)) | 0;
    hi = (hi + Math.imul(ah3, bh5)) | 0;
    lo = (lo + Math.imul(al2, bl6)) | 0;
    mid = (mid + Math.imul(al2, bh6)) | 0;
    mid = (mid + Math.imul(ah2, bl6)) | 0;
    hi = (hi + Math.imul(ah2, bh6)) | 0;
    lo = (lo + Math.imul(al1, bl7)) | 0;
    mid = (mid + Math.imul(al1, bh7)) | 0;
    mid = (mid + Math.imul(ah1, bl7)) | 0;
    hi = (hi + Math.imul(ah1, bh7)) | 0;
    lo = (lo + Math.imul(al0, bl8)) | 0;
    mid = (mid + Math.imul(al0, bh8)) | 0;
    mid = (mid + Math.imul(ah0, bl8)) | 0;
    hi = (hi + Math.imul(ah0, bh8)) | 0;
    var w8 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w8 >>> 26)) | 0;
    w8 &= 0x3ffffff;
    /* k = 9 */
    lo = Math.imul(al9, bl0);
    mid = Math.imul(al9, bh0);
    mid = (mid + Math.imul(ah9, bl0)) | 0;
    hi = Math.imul(ah9, bh0);
    lo = (lo + Math.imul(al8, bl1)) | 0;
    mid = (mid + Math.imul(al8, bh1)) | 0;
    mid = (mid + Math.imul(ah8, bl1)) | 0;
    hi = (hi + Math.imul(ah8, bh1)) | 0;
    lo = (lo + Math.imul(al7, bl2)) | 0;
    mid = (mid + Math.imul(al7, bh2)) | 0;
    mid = (mid + Math.imul(ah7, bl2)) | 0;
    hi = (hi + Math.imul(ah7, bh2)) | 0;
    lo = (lo + Math.imul(al6, bl3)) | 0;
    mid = (mid + Math.imul(al6, bh3)) | 0;
    mid = (mid + Math.imul(ah6, bl3)) | 0;
    hi = (hi + Math.imul(ah6, bh3)) | 0;
    lo = (lo + Math.imul(al5, bl4)) | 0;
    mid = (mid + Math.imul(al5, bh4)) | 0;
    mid = (mid + Math.imul(ah5, bl4)) | 0;
    hi = (hi + Math.imul(ah5, bh4)) | 0;
    lo = (lo + Math.imul(al4, bl5)) | 0;
    mid = (mid + Math.imul(al4, bh5)) | 0;
    mid = (mid + Math.imul(ah4, bl5)) | 0;
    hi = (hi + Math.imul(ah4, bh5)) | 0;
    lo = (lo + Math.imul(al3, bl6)) | 0;
    mid = (mid + Math.imul(al3, bh6)) | 0;
    mid = (mid + Math.imul(ah3, bl6)) | 0;
    hi = (hi + Math.imul(ah3, bh6)) | 0;
    lo = (lo + Math.imul(al2, bl7)) | 0;
    mid = (mid + Math.imul(al2, bh7)) | 0;
    mid = (mid + Math.imul(ah2, bl7)) | 0;
    hi = (hi + Math.imul(ah2, bh7)) | 0;
    lo = (lo + Math.imul(al1, bl8)) | 0;
    mid = (mid + Math.imul(al1, bh8)) | 0;
    mid = (mid + Math.imul(ah1, bl8)) | 0;
    hi = (hi + Math.imul(ah1, bh8)) | 0;
    lo = (lo + Math.imul(al0, bl9)) | 0;
    mid = (mid + Math.imul(al0, bh9)) | 0;
    mid = (mid + Math.imul(ah0, bl9)) | 0;
    hi = (hi + Math.imul(ah0, bh9)) | 0;
    var w9 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w9 >>> 26)) | 0;
    w9 &= 0x3ffffff;
    /* k = 10 */
    lo = Math.imul(al9, bl1);
    mid = Math.imul(al9, bh1);
    mid = (mid + Math.imul(ah9, bl1)) | 0;
    hi = Math.imul(ah9, bh1);
    lo = (lo + Math.imul(al8, bl2)) | 0;
    mid = (mid + Math.imul(al8, bh2)) | 0;
    mid = (mid + Math.imul(ah8, bl2)) | 0;
    hi = (hi + Math.imul(ah8, bh2)) | 0;
    lo = (lo + Math.imul(al7, bl3)) | 0;
    mid = (mid + Math.imul(al7, bh3)) | 0;
    mid = (mid + Math.imul(ah7, bl3)) | 0;
    hi = (hi + Math.imul(ah7, bh3)) | 0;
    lo = (lo + Math.imul(al6, bl4)) | 0;
    mid = (mid + Math.imul(al6, bh4)) | 0;
    mid = (mid + Math.imul(ah6, bl4)) | 0;
    hi = (hi + Math.imul(ah6, bh4)) | 0;
    lo = (lo + Math.imul(al5, bl5)) | 0;
    mid = (mid + Math.imul(al5, bh5)) | 0;
    mid = (mid + Math.imul(ah5, bl5)) | 0;
    hi = (hi + Math.imul(ah5, bh5)) | 0;
    lo = (lo + Math.imul(al4, bl6)) | 0;
    mid = (mid + Math.imul(al4, bh6)) | 0;
    mid = (mid + Math.imul(ah4, bl6)) | 0;
    hi = (hi + Math.imul(ah4, bh6)) | 0;
    lo = (lo + Math.imul(al3, bl7)) | 0;
    mid = (mid + Math.imul(al3, bh7)) | 0;
    mid = (mid + Math.imul(ah3, bl7)) | 0;
    hi = (hi + Math.imul(ah3, bh7)) | 0;
    lo = (lo + Math.imul(al2, bl8)) | 0;
    mid = (mid + Math.imul(al2, bh8)) | 0;
    mid = (mid + Math.imul(ah2, bl8)) | 0;
    hi = (hi + Math.imul(ah2, bh8)) | 0;
    lo = (lo + Math.imul(al1, bl9)) | 0;
    mid = (mid + Math.imul(al1, bh9)) | 0;
    mid = (mid + Math.imul(ah1, bl9)) | 0;
    hi = (hi + Math.imul(ah1, bh9)) | 0;
    var w10 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w10 >>> 26)) | 0;
    w10 &= 0x3ffffff;
    /* k = 11 */
    lo = Math.imul(al9, bl2);
    mid = Math.imul(al9, bh2);
    mid = (mid + Math.imul(ah9, bl2)) | 0;
    hi = Math.imul(ah9, bh2);
    lo = (lo + Math.imul(al8, bl3)) | 0;
    mid = (mid + Math.imul(al8, bh3)) | 0;
    mid = (mid + Math.imul(ah8, bl3)) | 0;
    hi = (hi + Math.imul(ah8, bh3)) | 0;
    lo = (lo + Math.imul(al7, bl4)) | 0;
    mid = (mid + Math.imul(al7, bh4)) | 0;
    mid = (mid + Math.imul(ah7, bl4)) | 0;
    hi = (hi + Math.imul(ah7, bh4)) | 0;
    lo = (lo + Math.imul(al6, bl5)) | 0;
    mid = (mid + Math.imul(al6, bh5)) | 0;
    mid = (mid + Math.imul(ah6, bl5)) | 0;
    hi = (hi + Math.imul(ah6, bh5)) | 0;
    lo = (lo + Math.imul(al5, bl6)) | 0;
    mid = (mid + Math.imul(al5, bh6)) | 0;
    mid = (mid + Math.imul(ah5, bl6)) | 0;
    hi = (hi + Math.imul(ah5, bh6)) | 0;
    lo = (lo + Math.imul(al4, bl7)) | 0;
    mid = (mid + Math.imul(al4, bh7)) | 0;
    mid = (mid + Math.imul(ah4, bl7)) | 0;
    hi = (hi + Math.imul(ah4, bh7)) | 0;
    lo = (lo + Math.imul(al3, bl8)) | 0;
    mid = (mid + Math.imul(al3, bh8)) | 0;
    mid = (mid + Math.imul(ah3, bl8)) | 0;
    hi = (hi + Math.imul(ah3, bh8)) | 0;
    lo = (lo + Math.imul(al2, bl9)) | 0;
    mid = (mid + Math.imul(al2, bh9)) | 0;
    mid = (mid + Math.imul(ah2, bl9)) | 0;
    hi = (hi + Math.imul(ah2, bh9)) | 0;
    var w11 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w11 >>> 26)) | 0;
    w11 &= 0x3ffffff;
    /* k = 12 */
    lo = Math.imul(al9, bl3);
    mid = Math.imul(al9, bh3);
    mid = (mid + Math.imul(ah9, bl3)) | 0;
    hi = Math.imul(ah9, bh3);
    lo = (lo + Math.imul(al8, bl4)) | 0;
    mid = (mid + Math.imul(al8, bh4)) | 0;
    mid = (mid + Math.imul(ah8, bl4)) | 0;
    hi = (hi + Math.imul(ah8, bh4)) | 0;
    lo = (lo + Math.imul(al7, bl5)) | 0;
    mid = (mid + Math.imul(al7, bh5)) | 0;
    mid = (mid + Math.imul(ah7, bl5)) | 0;
    hi = (hi + Math.imul(ah7, bh5)) | 0;
    lo = (lo + Math.imul(al6, bl6)) | 0;
    mid = (mid + Math.imul(al6, bh6)) | 0;
    mid = (mid + Math.imul(ah6, bl6)) | 0;
    hi = (hi + Math.imul(ah6, bh6)) | 0;
    lo = (lo + Math.imul(al5, bl7)) | 0;
    mid = (mid + Math.imul(al5, bh7)) | 0;
    mid = (mid + Math.imul(ah5, bl7)) | 0;
    hi = (hi + Math.imul(ah5, bh7)) | 0;
    lo = (lo + Math.imul(al4, bl8)) | 0;
    mid = (mid + Math.imul(al4, bh8)) | 0;
    mid = (mid + Math.imul(ah4, bl8)) | 0;
    hi = (hi + Math.imul(ah4, bh8)) | 0;
    lo = (lo + Math.imul(al3, bl9)) | 0;
    mid = (mid + Math.imul(al3, bh9)) | 0;
    mid = (mid + Math.imul(ah3, bl9)) | 0;
    hi = (hi + Math.imul(ah3, bh9)) | 0;
    var w12 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w12 >>> 26)) | 0;
    w12 &= 0x3ffffff;
    /* k = 13 */
    lo = Math.imul(al9, bl4);
    mid = Math.imul(al9, bh4);
    mid = (mid + Math.imul(ah9, bl4)) | 0;
    hi = Math.imul(ah9, bh4);
    lo = (lo + Math.imul(al8, bl5)) | 0;
    mid = (mid + Math.imul(al8, bh5)) | 0;
    mid = (mid + Math.imul(ah8, bl5)) | 0;
    hi = (hi + Math.imul(ah8, bh5)) | 0;
    lo = (lo + Math.imul(al7, bl6)) | 0;
    mid = (mid + Math.imul(al7, bh6)) | 0;
    mid = (mid + Math.imul(ah7, bl6)) | 0;
    hi = (hi + Math.imul(ah7, bh6)) | 0;
    lo = (lo + Math.imul(al6, bl7)) | 0;
    mid = (mid + Math.imul(al6, bh7)) | 0;
    mid = (mid + Math.imul(ah6, bl7)) | 0;
    hi = (hi + Math.imul(ah6, bh7)) | 0;
    lo = (lo + Math.imul(al5, bl8)) | 0;
    mid = (mid + Math.imul(al5, bh8)) | 0;
    mid = (mid + Math.imul(ah5, bl8)) | 0;
    hi = (hi + Math.imul(ah5, bh8)) | 0;
    lo = (lo + Math.imul(al4, bl9)) | 0;
    mid = (mid + Math.imul(al4, bh9)) | 0;
    mid = (mid + Math.imul(ah4, bl9)) | 0;
    hi = (hi + Math.imul(ah4, bh9)) | 0;
    var w13 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w13 >>> 26)) | 0;
    w13 &= 0x3ffffff;
    /* k = 14 */
    lo = Math.imul(al9, bl5);
    mid = Math.imul(al9, bh5);
    mid = (mid + Math.imul(ah9, bl5)) | 0;
    hi = Math.imul(ah9, bh5);
    lo = (lo + Math.imul(al8, bl6)) | 0;
    mid = (mid + Math.imul(al8, bh6)) | 0;
    mid = (mid + Math.imul(ah8, bl6)) | 0;
    hi = (hi + Math.imul(ah8, bh6)) | 0;
    lo = (lo + Math.imul(al7, bl7)) | 0;
    mid = (mid + Math.imul(al7, bh7)) | 0;
    mid = (mid + Math.imul(ah7, bl7)) | 0;
    hi = (hi + Math.imul(ah7, bh7)) | 0;
    lo = (lo + Math.imul(al6, bl8)) | 0;
    mid = (mid + Math.imul(al6, bh8)) | 0;
    mid = (mid + Math.imul(ah6, bl8)) | 0;
    hi = (hi + Math.imul(ah6, bh8)) | 0;
    lo = (lo + Math.imul(al5, bl9)) | 0;
    mid = (mid + Math.imul(al5, bh9)) | 0;
    mid = (mid + Math.imul(ah5, bl9)) | 0;
    hi = (hi + Math.imul(ah5, bh9)) | 0;
    var w14 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w14 >>> 26)) | 0;
    w14 &= 0x3ffffff;
    /* k = 15 */
    lo = Math.imul(al9, bl6);
    mid = Math.imul(al9, bh6);
    mid = (mid + Math.imul(ah9, bl6)) | 0;
    hi = Math.imul(ah9, bh6);
    lo = (lo + Math.imul(al8, bl7)) | 0;
    mid = (mid + Math.imul(al8, bh7)) | 0;
    mid = (mid + Math.imul(ah8, bl7)) | 0;
    hi = (hi + Math.imul(ah8, bh7)) | 0;
    lo = (lo + Math.imul(al7, bl8)) | 0;
    mid = (mid + Math.imul(al7, bh8)) | 0;
    mid = (mid + Math.imul(ah7, bl8)) | 0;
    hi = (hi + Math.imul(ah7, bh8)) | 0;
    lo = (lo + Math.imul(al6, bl9)) | 0;
    mid = (mid + Math.imul(al6, bh9)) | 0;
    mid = (mid + Math.imul(ah6, bl9)) | 0;
    hi = (hi + Math.imul(ah6, bh9)) | 0;
    var w15 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w15 >>> 26)) | 0;
    w15 &= 0x3ffffff;
    /* k = 16 */
    lo = Math.imul(al9, bl7);
    mid = Math.imul(al9, bh7);
    mid = (mid + Math.imul(ah9, bl7)) | 0;
    hi = Math.imul(ah9, bh7);
    lo = (lo + Math.imul(al8, bl8)) | 0;
    mid = (mid + Math.imul(al8, bh8)) | 0;
    mid = (mid + Math.imul(ah8, bl8)) | 0;
    hi = (hi + Math.imul(ah8, bh8)) | 0;
    lo = (lo + Math.imul(al7, bl9)) | 0;
    mid = (mid + Math.imul(al7, bh9)) | 0;
    mid = (mid + Math.imul(ah7, bl9)) | 0;
    hi = (hi + Math.imul(ah7, bh9)) | 0;
    var w16 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w16 >>> 26)) | 0;
    w16 &= 0x3ffffff;
    /* k = 17 */
    lo = Math.imul(al9, bl8);
    mid = Math.imul(al9, bh8);
    mid = (mid + Math.imul(ah9, bl8)) | 0;
    hi = Math.imul(ah9, bh8);
    lo = (lo + Math.imul(al8, bl9)) | 0;
    mid = (mid + Math.imul(al8, bh9)) | 0;
    mid = (mid + Math.imul(ah8, bl9)) | 0;
    hi = (hi + Math.imul(ah8, bh9)) | 0;
    var w17 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w17 >>> 26)) | 0;
    w17 &= 0x3ffffff;
    /* k = 18 */
    lo = Math.imul(al9, bl9);
    mid = Math.imul(al9, bh9);
    mid = (mid + Math.imul(ah9, bl9)) | 0;
    hi = Math.imul(ah9, bh9);
    var w18 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w18 >>> 26)) | 0;
    w18 &= 0x3ffffff;
    o[0] = w0;
    o[1] = w1;
    o[2] = w2;
    o[3] = w3;
    o[4] = w4;
    o[5] = w5;
    o[6] = w6;
    o[7] = w7;
    o[8] = w8;
    o[9] = w9;
    o[10] = w10;
    o[11] = w11;
    o[12] = w12;
    o[13] = w13;
    o[14] = w14;
    o[15] = w15;
    o[16] = w16;
    o[17] = w17;
    o[18] = w18;
    if (c !== 0) {
      o[19] = c;
      out.length++;
    }
    return out;
  };

  // Polyfill comb
  if (!Math.imul) {
    comb10MulTo = smallMulTo;
  }

  function bigMulTo (self, num, out) {
    out.negative = num.negative ^ self.negative;
    out.length = self.length + num.length;

    var carry = 0;
    var hncarry = 0;
    for (var k = 0; k < out.length - 1; k++) {
      // Sum all words with the same `i + j = k` and accumulate `ncarry`,
      // note that ncarry could be >= 0x3ffffff
      var ncarry = hncarry;
      hncarry = 0;
      var rword = carry & 0x3ffffff;
      var maxJ = Math.min(k, num.length - 1);
      for (var j = Math.max(0, k - self.length + 1); j <= maxJ; j++) {
        var i = k - j;
        var a = self.words[i] | 0;
        var b = num.words[j] | 0;
        var r = a * b;

        var lo = r & 0x3ffffff;
        ncarry = (ncarry + ((r / 0x4000000) | 0)) | 0;
        lo = (lo + rword) | 0;
        rword = lo & 0x3ffffff;
        ncarry = (ncarry + (lo >>> 26)) | 0;

        hncarry += ncarry >>> 26;
        ncarry &= 0x3ffffff;
      }
      out.words[k] = rword;
      carry = ncarry;
      ncarry = hncarry;
    }
    if (carry !== 0) {
      out.words[k] = carry;
    } else {
      out.length--;
    }

    return out.strip();
  }

  function jumboMulTo (self, num, out) {
    var fftm = new FFTM();
    return fftm.mulp(self, num, out);
  }

  BN.prototype.mulTo = function mulTo (num, out) {
    var res;
    var len = this.length + num.length;
    if (this.length === 10 && num.length === 10) {
      res = comb10MulTo(this, num, out);
    } else if (len < 63) {
      res = smallMulTo(this, num, out);
    } else if (len < 1024) {
      res = bigMulTo(this, num, out);
    } else {
      res = jumboMulTo(this, num, out);
    }

    return res;
  };

  // Cooley-Tukey algorithm for FFT
  // slightly revisited to rely on looping instead of recursion

  function FFTM (x, y) {
    this.x = x;
    this.y = y;
  }

  FFTM.prototype.makeRBT = function makeRBT (N) {
    var t = new Array(N);
    var l = BN.prototype._countBits(N) - 1;
    for (var i = 0; i < N; i++) {
      t[i] = this.revBin(i, l, N);
    }

    return t;
  };

  // Returns binary-reversed representation of `x`
  FFTM.prototype.revBin = function revBin (x, l, N) {
    if (x === 0 || x === N - 1) return x;

    var rb = 0;
    for (var i = 0; i < l; i++) {
      rb |= (x & 1) << (l - i - 1);
      x >>= 1;
    }

    return rb;
  };

  // Performs "tweedling" phase, therefore 'emulating'
  // behaviour of the recursive algorithm
  FFTM.prototype.permute = function permute (rbt, rws, iws, rtws, itws, N) {
    for (var i = 0; i < N; i++) {
      rtws[i] = rws[rbt[i]];
      itws[i] = iws[rbt[i]];
    }
  };

  FFTM.prototype.transform = function transform (rws, iws, rtws, itws, N, rbt) {
    this.permute(rbt, rws, iws, rtws, itws, N);

    for (var s = 1; s < N; s <<= 1) {
      var l = s << 1;

      var rtwdf = Math.cos(2 * Math.PI / l);
      var itwdf = Math.sin(2 * Math.PI / l);

      for (var p = 0; p < N; p += l) {
        var rtwdf_ = rtwdf;
        var itwdf_ = itwdf;

        for (var j = 0; j < s; j++) {
          var re = rtws[p + j];
          var ie = itws[p + j];

          var ro = rtws[p + j + s];
          var io = itws[p + j + s];

          var rx = rtwdf_ * ro - itwdf_ * io;

          io = rtwdf_ * io + itwdf_ * ro;
          ro = rx;

          rtws[p + j] = re + ro;
          itws[p + j] = ie + io;

          rtws[p + j + s] = re - ro;
          itws[p + j + s] = ie - io;

          /* jshint maxdepth : false */
          if (j !== l) {
            rx = rtwdf * rtwdf_ - itwdf * itwdf_;

            itwdf_ = rtwdf * itwdf_ + itwdf * rtwdf_;
            rtwdf_ = rx;
          }
        }
      }
    }
  };

  FFTM.prototype.guessLen13b = function guessLen13b (n, m) {
    var N = Math.max(m, n) | 1;
    var odd = N & 1;
    var i = 0;
    for (N = N / 2 | 0; N; N = N >>> 1) {
      i++;
    }

    return 1 << i + 1 + odd;
  };

  FFTM.prototype.conjugate = function conjugate (rws, iws, N) {
    if (N <= 1) return;

    for (var i = 0; i < N / 2; i++) {
      var t = rws[i];

      rws[i] = rws[N - i - 1];
      rws[N - i - 1] = t;

      t = iws[i];

      iws[i] = -iws[N - i - 1];
      iws[N - i - 1] = -t;
    }
  };

  FFTM.prototype.normalize13b = function normalize13b (ws, N) {
    var carry = 0;
    for (var i = 0; i < N / 2; i++) {
      var w = Math.round(ws[2 * i + 1] / N) * 0x2000 +
        Math.round(ws[2 * i] / N) +
        carry;

      ws[i] = w & 0x3ffffff;

      if (w < 0x4000000) {
        carry = 0;
      } else {
        carry = w / 0x4000000 | 0;
      }
    }

    return ws;
  };

  FFTM.prototype.convert13b = function convert13b (ws, len, rws, N) {
    var carry = 0;
    for (var i = 0; i < len; i++) {
      carry = carry + (ws[i] | 0);

      rws[2 * i] = carry & 0x1fff; carry = carry >>> 13;
      rws[2 * i + 1] = carry & 0x1fff; carry = carry >>> 13;
    }

    // Pad with zeroes
    for (i = 2 * len; i < N; ++i) {
      rws[i] = 0;
    }

    assert(carry === 0);
    assert((carry & ~0x1fff) === 0);
  };

  FFTM.prototype.stub = function stub (N) {
    var ph = new Array(N);
    for (var i = 0; i < N; i++) {
      ph[i] = 0;
    }

    return ph;
  };

  FFTM.prototype.mulp = function mulp (x, y, out) {
    var N = 2 * this.guessLen13b(x.length, y.length);

    var rbt = this.makeRBT(N);

    var _ = this.stub(N);

    var rws = new Array(N);
    var rwst = new Array(N);
    var iwst = new Array(N);

    var nrws = new Array(N);
    var nrwst = new Array(N);
    var niwst = new Array(N);

    var rmws = out.words;
    rmws.length = N;

    this.convert13b(x.words, x.length, rws, N);
    this.convert13b(y.words, y.length, nrws, N);

    this.transform(rws, _, rwst, iwst, N, rbt);
    this.transform(nrws, _, nrwst, niwst, N, rbt);

    for (var i = 0; i < N; i++) {
      var rx = rwst[i] * nrwst[i] - iwst[i] * niwst[i];
      iwst[i] = rwst[i] * niwst[i] + iwst[i] * nrwst[i];
      rwst[i] = rx;
    }

    this.conjugate(rwst, iwst, N);
    this.transform(rwst, iwst, rmws, _, N, rbt);
    this.conjugate(rmws, _, N);
    this.normalize13b(rmws, N);

    out.negative = x.negative ^ y.negative;
    out.length = x.length + y.length;
    return out.strip();
  };

  // Multiply `this` by `num`
  BN.prototype.mul = function mul (num) {
    var out = new BN(null);
    out.words = new Array(this.length + num.length);
    return this.mulTo(num, out);
  };

  // Multiply employing FFT
  BN.prototype.mulf = function mulf (num) {
    var out = new BN(null);
    out.words = new Array(this.length + num.length);
    return jumboMulTo(this, num, out);
  };

  // In-place Multiplication
  BN.prototype.imul = function imul (num) {
    return this.clone().mulTo(num, this);
  };

  BN.prototype.imuln = function imuln (num) {
    assert(typeof num === 'number');
    assert(num < 0x4000000);

    // Carry
    var carry = 0;
    for (var i = 0; i < this.length; i++) {
      var w = (this.words[i] | 0) * num;
      var lo = (w & 0x3ffffff) + (carry & 0x3ffffff);
      carry >>= 26;
      carry += (w / 0x4000000) | 0;
      // NOTE: lo is 27bit maximum
      carry += lo >>> 26;
      this.words[i] = lo & 0x3ffffff;
    }

    if (carry !== 0) {
      this.words[i] = carry;
      this.length++;
    }

    return this;
  };

  BN.prototype.muln = function muln (num) {
    return this.clone().imuln(num);
  };

  // `this` * `this`
  BN.prototype.sqr = function sqr () {
    return this.mul(this);
  };

  // `this` * `this` in-place
  BN.prototype.isqr = function isqr () {
    return this.imul(this.clone());
  };

  // Math.pow(`this`, `num`)
  BN.prototype.pow = function pow (num) {
    var w = toBitArray(num);
    if (w.length === 0) return new BN(1);

    // Skip leading zeroes
    var res = this;
    for (var i = 0; i < w.length; i++, res = res.sqr()) {
      if (w[i] !== 0) break;
    }

    if (++i < w.length) {
      for (var q = res.sqr(); i < w.length; i++, q = q.sqr()) {
        if (w[i] === 0) continue;

        res = res.mul(q);
      }
    }

    return res;
  };

  // Shift-left in-place
  BN.prototype.iushln = function iushln (bits) {
    assert(typeof bits === 'number' && bits >= 0);
    var r = bits % 26;
    var s = (bits - r) / 26;
    var carryMask = (0x3ffffff >>> (26 - r)) << (26 - r);
    var i;

    if (r !== 0) {
      var carry = 0;

      for (i = 0; i < this.length; i++) {
        var newCarry = this.words[i] & carryMask;
        var c = ((this.words[i] | 0) - newCarry) << r;
        this.words[i] = c | carry;
        carry = newCarry >>> (26 - r);
      }

      if (carry) {
        this.words[i] = carry;
        this.length++;
      }
    }

    if (s !== 0) {
      for (i = this.length - 1; i >= 0; i--) {
        this.words[i + s] = this.words[i];
      }

      for (i = 0; i < s; i++) {
        this.words[i] = 0;
      }

      this.length += s;
    }

    return this.strip();
  };

  BN.prototype.ishln = function ishln (bits) {
    // TODO(indutny): implement me
    assert(this.negative === 0);
    return this.iushln(bits);
  };

  // Shift-right in-place
  // NOTE: `hint` is a lowest bit before trailing zeroes
  // NOTE: if `extended` is present - it will be filled with destroyed bits
  BN.prototype.iushrn = function iushrn (bits, hint, extended) {
    assert(typeof bits === 'number' && bits >= 0);
    var h;
    if (hint) {
      h = (hint - (hint % 26)) / 26;
    } else {
      h = 0;
    }

    var r = bits % 26;
    var s = Math.min((bits - r) / 26, this.length);
    var mask = 0x3ffffff ^ ((0x3ffffff >>> r) << r);
    var maskedWords = extended;

    h -= s;
    h = Math.max(0, h);

    // Extended mode, copy masked part
    if (maskedWords) {
      for (var i = 0; i < s; i++) {
        maskedWords.words[i] = this.words[i];
      }
      maskedWords.length = s;
    }

    if (s === 0) {
      // No-op, we should not move anything at all
    } else if (this.length > s) {
      this.length -= s;
      for (i = 0; i < this.length; i++) {
        this.words[i] = this.words[i + s];
      }
    } else {
      this.words[0] = 0;
      this.length = 1;
    }

    var carry = 0;
    for (i = this.length - 1; i >= 0 && (carry !== 0 || i >= h); i--) {
      var word = this.words[i] | 0;
      this.words[i] = (carry << (26 - r)) | (word >>> r);
      carry = word & mask;
    }

    // Push carried bits as a mask
    if (maskedWords && carry !== 0) {
      maskedWords.words[maskedWords.length++] = carry;
    }

    if (this.length === 0) {
      this.words[0] = 0;
      this.length = 1;
    }

    return this.strip();
  };

  BN.prototype.ishrn = function ishrn (bits, hint, extended) {
    // TODO(indutny): implement me
    assert(this.negative === 0);
    return this.iushrn(bits, hint, extended);
  };

  // Shift-left
  BN.prototype.shln = function shln (bits) {
    return this.clone().ishln(bits);
  };

  BN.prototype.ushln = function ushln (bits) {
    return this.clone().iushln(bits);
  };

  // Shift-right
  BN.prototype.shrn = function shrn (bits) {
    return this.clone().ishrn(bits);
  };

  BN.prototype.ushrn = function ushrn (bits) {
    return this.clone().iushrn(bits);
  };

  // Test if n bit is set
  BN.prototype.testn = function testn (bit) {
    assert(typeof bit === 'number' && bit >= 0);
    var r = bit % 26;
    var s = (bit - r) / 26;
    var q = 1 << r;

    // Fast case: bit is much higher than all existing words
    if (this.length <= s) return false;

    // Check bit and return
    var w = this.words[s];

    return !!(w & q);
  };

  // Return only lowers bits of number (in-place)
  BN.prototype.imaskn = function imaskn (bits) {
    assert(typeof bits === 'number' && bits >= 0);
    var r = bits % 26;
    var s = (bits - r) / 26;

    assert(this.negative === 0, 'imaskn works only with positive numbers');

    if (this.length <= s) {
      return this;
    }

    if (r !== 0) {
      s++;
    }
    this.length = Math.min(s, this.length);

    if (r !== 0) {
      var mask = 0x3ffffff ^ ((0x3ffffff >>> r) << r);
      this.words[this.length - 1] &= mask;
    }

    return this.strip();
  };

  // Return only lowers bits of number
  BN.prototype.maskn = function maskn (bits) {
    return this.clone().imaskn(bits);
  };

  // Add plain number `num` to `this`
  BN.prototype.iaddn = function iaddn (num) {
    assert(typeof num === 'number');
    assert(num < 0x4000000);
    if (num < 0) return this.isubn(-num);

    // Possible sign change
    if (this.negative !== 0) {
      if (this.length === 1 && (this.words[0] | 0) < num) {
        this.words[0] = num - (this.words[0] | 0);
        this.negative = 0;
        return this;
      }

      this.negative = 0;
      this.isubn(num);
      this.negative = 1;
      return this;
    }

    // Add without checks
    return this._iaddn(num);
  };

  BN.prototype._iaddn = function _iaddn (num) {
    this.words[0] += num;

    // Carry
    for (var i = 0; i < this.length && this.words[i] >= 0x4000000; i++) {
      this.words[i] -= 0x4000000;
      if (i === this.length - 1) {
        this.words[i + 1] = 1;
      } else {
        this.words[i + 1]++;
      }
    }
    this.length = Math.max(this.length, i + 1);

    return this;
  };

  // Subtract plain number `num` from `this`
  BN.prototype.isubn = function isubn (num) {
    assert(typeof num === 'number');
    assert(num < 0x4000000);
    if (num < 0) return this.iaddn(-num);

    if (this.negative !== 0) {
      this.negative = 0;
      this.iaddn(num);
      this.negative = 1;
      return this;
    }

    this.words[0] -= num;

    if (this.length === 1 && this.words[0] < 0) {
      this.words[0] = -this.words[0];
      this.negative = 1;
    } else {
      // Carry
      for (var i = 0; i < this.length && this.words[i] < 0; i++) {
        this.words[i] += 0x4000000;
        this.words[i + 1] -= 1;
      }
    }

    return this.strip();
  };

  BN.prototype.addn = function addn (num) {
    return this.clone().iaddn(num);
  };

  BN.prototype.subn = function subn (num) {
    return this.clone().isubn(num);
  };

  BN.prototype.iabs = function iabs () {
    this.negative = 0;

    return this;
  };

  BN.prototype.abs = function abs () {
    return this.clone().iabs();
  };

  BN.prototype._ishlnsubmul = function _ishlnsubmul (num, mul, shift) {
    var len = num.length + shift;
    var i;

    this._expand(len);

    var w;
    var carry = 0;
    for (i = 0; i < num.length; i++) {
      w = (this.words[i + shift] | 0) + carry;
      var right = (num.words[i] | 0) * mul;
      w -= right & 0x3ffffff;
      carry = (w >> 26) - ((right / 0x4000000) | 0);
      this.words[i + shift] = w & 0x3ffffff;
    }
    for (; i < this.length - shift; i++) {
      w = (this.words[i + shift] | 0) + carry;
      carry = w >> 26;
      this.words[i + shift] = w & 0x3ffffff;
    }

    if (carry === 0) return this.strip();

    // Subtraction overflow
    assert(carry === -1);
    carry = 0;
    for (i = 0; i < this.length; i++) {
      w = -(this.words[i] | 0) + carry;
      carry = w >> 26;
      this.words[i] = w & 0x3ffffff;
    }
    this.negative = 1;

    return this.strip();
  };

  BN.prototype._wordDiv = function _wordDiv (num, mode) {
    var shift = this.length - num.length;

    var a = this.clone();
    var b = num;

    // Normalize
    var bhi = b.words[b.length - 1] | 0;
    var bhiBits = this._countBits(bhi);
    shift = 26 - bhiBits;
    if (shift !== 0) {
      b = b.ushln(shift);
      a.iushln(shift);
      bhi = b.words[b.length - 1] | 0;
    }

    // Initialize quotient
    var m = a.length - b.length;
    var q;

    if (mode !== 'mod') {
      q = new BN(null);
      q.length = m + 1;
      q.words = new Array(q.length);
      for (var i = 0; i < q.length; i++) {
        q.words[i] = 0;
      }
    }

    var diff = a.clone()._ishlnsubmul(b, 1, m);
    if (diff.negative === 0) {
      a = diff;
      if (q) {
        q.words[m] = 1;
      }
    }

    for (var j = m - 1; j >= 0; j--) {
      var qj = (a.words[b.length + j] | 0) * 0x4000000 +
        (a.words[b.length + j - 1] | 0);

      // NOTE: (qj / bhi) is (0x3ffffff * 0x4000000 + 0x3ffffff) / 0x2000000 max
      // (0x7ffffff)
      qj = Math.min((qj / bhi) | 0, 0x3ffffff);

      a._ishlnsubmul(b, qj, j);
      while (a.negative !== 0) {
        qj--;
        a.negative = 0;
        a._ishlnsubmul(b, 1, j);
        if (!a.isZero()) {
          a.negative ^= 1;
        }
      }
      if (q) {
        q.words[j] = qj;
      }
    }
    if (q) {
      q.strip();
    }
    a.strip();

    // Denormalize
    if (mode !== 'div' && shift !== 0) {
      a.iushrn(shift);
    }

    return {
      div: q || null,
      mod: a
    };
  };

  // NOTE: 1) `mode` can be set to `mod` to request mod only,
  //       to `div` to request div only, or be absent to
  //       request both div & mod
  //       2) `positive` is true if unsigned mod is requested
  BN.prototype.divmod = function divmod (num, mode, positive) {
    assert(!num.isZero());

    if (this.isZero()) {
      return {
        div: new BN(0),
        mod: new BN(0)
      };
    }

    var div, mod, res;
    if (this.negative !== 0 && num.negative === 0) {
      res = this.neg().divmod(num, mode);

      if (mode !== 'mod') {
        div = res.div.neg();
      }

      if (mode !== 'div') {
        mod = res.mod.neg();
        if (positive && mod.negative !== 0) {
          mod.iadd(num);
        }
      }

      return {
        div: div,
        mod: mod
      };
    }

    if (this.negative === 0 && num.negative !== 0) {
      res = this.divmod(num.neg(), mode);

      if (mode !== 'mod') {
        div = res.div.neg();
      }

      return {
        div: div,
        mod: res.mod
      };
    }

    if ((this.negative & num.negative) !== 0) {
      res = this.neg().divmod(num.neg(), mode);

      if (mode !== 'div') {
        mod = res.mod.neg();
        if (positive && mod.negative !== 0) {
          mod.isub(num);
        }
      }

      return {
        div: res.div,
        mod: mod
      };
    }

    // Both numbers are positive at this point

    // Strip both numbers to approximate shift value
    if (num.length > this.length || this.cmp(num) < 0) {
      return {
        div: new BN(0),
        mod: this
      };
    }

    // Very short reduction
    if (num.length === 1) {
      if (mode === 'div') {
        return {
          div: this.divn(num.words[0]),
          mod: null
        };
      }

      if (mode === 'mod') {
        return {
          div: null,
          mod: new BN(this.modn(num.words[0]))
        };
      }

      return {
        div: this.divn(num.words[0]),
        mod: new BN(this.modn(num.words[0]))
      };
    }

    return this._wordDiv(num, mode);
  };

  // Find `this` / `num`
  BN.prototype.div = function div (num) {
    return this.divmod(num, 'div', false).div;
  };

  // Find `this` % `num`
  BN.prototype.mod = function mod (num) {
    return this.divmod(num, 'mod', false).mod;
  };

  BN.prototype.umod = function umod (num) {
    return this.divmod(num, 'mod', true).mod;
  };

  // Find Round(`this` / `num`)
  BN.prototype.divRound = function divRound (num) {
    var dm = this.divmod(num);

    // Fast case - exact division
    if (dm.mod.isZero()) return dm.div;

    var mod = dm.div.negative !== 0 ? dm.mod.isub(num) : dm.mod;

    var half = num.ushrn(1);
    var r2 = num.andln(1);
    var cmp = mod.cmp(half);

    // Round down
    if (cmp < 0 || r2 === 1 && cmp === 0) return dm.div;

    // Round up
    return dm.div.negative !== 0 ? dm.div.isubn(1) : dm.div.iaddn(1);
  };

  BN.prototype.modn = function modn (num) {
    assert(num <= 0x3ffffff);
    var p = (1 << 26) % num;

    var acc = 0;
    for (var i = this.length - 1; i >= 0; i--) {
      acc = (p * acc + (this.words[i] | 0)) % num;
    }

    return acc;
  };

  // In-place division by number
  BN.prototype.idivn = function idivn (num) {
    assert(num <= 0x3ffffff);

    var carry = 0;
    for (var i = this.length - 1; i >= 0; i--) {
      var w = (this.words[i] | 0) + carry * 0x4000000;
      this.words[i] = (w / num) | 0;
      carry = w % num;
    }

    return this.strip();
  };

  BN.prototype.divn = function divn (num) {
    return this.clone().idivn(num);
  };

  BN.prototype.egcd = function egcd (p) {
    assert(p.negative === 0);
    assert(!p.isZero());

    var x = this;
    var y = p.clone();

    if (x.negative !== 0) {
      x = x.umod(p);
    } else {
      x = x.clone();
    }

    // A * x + B * y = x
    var A = new BN(1);
    var B = new BN(0);

    // C * x + D * y = y
    var C = new BN(0);
    var D = new BN(1);

    var g = 0;

    while (x.isEven() && y.isEven()) {
      x.iushrn(1);
      y.iushrn(1);
      ++g;
    }

    var yp = y.clone();
    var xp = x.clone();

    while (!x.isZero()) {
      for (var i = 0, im = 1; (x.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
      if (i > 0) {
        x.iushrn(i);
        while (i-- > 0) {
          if (A.isOdd() || B.isOdd()) {
            A.iadd(yp);
            B.isub(xp);
          }

          A.iushrn(1);
          B.iushrn(1);
        }
      }

      for (var j = 0, jm = 1; (y.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
      if (j > 0) {
        y.iushrn(j);
        while (j-- > 0) {
          if (C.isOdd() || D.isOdd()) {
            C.iadd(yp);
            D.isub(xp);
          }

          C.iushrn(1);
          D.iushrn(1);
        }
      }

      if (x.cmp(y) >= 0) {
        x.isub(y);
        A.isub(C);
        B.isub(D);
      } else {
        y.isub(x);
        C.isub(A);
        D.isub(B);
      }
    }

    return {
      a: C,
      b: D,
      gcd: y.iushln(g)
    };
  };

  // This is reduced incarnation of the binary EEA
  // above, designated to invert members of the
  // _prime_ fields F(p) at a maximal speed
  BN.prototype._invmp = function _invmp (p) {
    assert(p.negative === 0);
    assert(!p.isZero());

    var a = this;
    var b = p.clone();

    if (a.negative !== 0) {
      a = a.umod(p);
    } else {
      a = a.clone();
    }

    var x1 = new BN(1);
    var x2 = new BN(0);

    var delta = b.clone();

    while (a.cmpn(1) > 0 && b.cmpn(1) > 0) {
      for (var i = 0, im = 1; (a.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
      if (i > 0) {
        a.iushrn(i);
        while (i-- > 0) {
          if (x1.isOdd()) {
            x1.iadd(delta);
          }

          x1.iushrn(1);
        }
      }

      for (var j = 0, jm = 1; (b.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
      if (j > 0) {
        b.iushrn(j);
        while (j-- > 0) {
          if (x2.isOdd()) {
            x2.iadd(delta);
          }

          x2.iushrn(1);
        }
      }

      if (a.cmp(b) >= 0) {
        a.isub(b);
        x1.isub(x2);
      } else {
        b.isub(a);
        x2.isub(x1);
      }
    }

    var res;
    if (a.cmpn(1) === 0) {
      res = x1;
    } else {
      res = x2;
    }

    if (res.cmpn(0) < 0) {
      res.iadd(p);
    }

    return res;
  };

  BN.prototype.gcd = function gcd (num) {
    if (this.isZero()) return num.abs();
    if (num.isZero()) return this.abs();

    var a = this.clone();
    var b = num.clone();
    a.negative = 0;
    b.negative = 0;

    // Remove common factor of two
    for (var shift = 0; a.isEven() && b.isEven(); shift++) {
      a.iushrn(1);
      b.iushrn(1);
    }

    do {
      while (a.isEven()) {
        a.iushrn(1);
      }
      while (b.isEven()) {
        b.iushrn(1);
      }

      var r = a.cmp(b);
      if (r < 0) {
        // Swap `a` and `b` to make `a` always bigger than `b`
        var t = a;
        a = b;
        b = t;
      } else if (r === 0 || b.cmpn(1) === 0) {
        break;
      }

      a.isub(b);
    } while (true);

    return b.iushln(shift);
  };

  // Invert number in the field F(num)
  BN.prototype.invm = function invm (num) {
    return this.egcd(num).a.umod(num);
  };

  BN.prototype.isEven = function isEven () {
    return (this.words[0] & 1) === 0;
  };

  BN.prototype.isOdd = function isOdd () {
    return (this.words[0] & 1) === 1;
  };

  // And first word and num
  BN.prototype.andln = function andln (num) {
    return this.words[0] & num;
  };

  // Increment at the bit position in-line
  BN.prototype.bincn = function bincn (bit) {
    assert(typeof bit === 'number');
    var r = bit % 26;
    var s = (bit - r) / 26;
    var q = 1 << r;

    // Fast case: bit is much higher than all existing words
    if (this.length <= s) {
      this._expand(s + 1);
      this.words[s] |= q;
      return this;
    }

    // Add bit and propagate, if needed
    var carry = q;
    for (var i = s; carry !== 0 && i < this.length; i++) {
      var w = this.words[i] | 0;
      w += carry;
      carry = w >>> 26;
      w &= 0x3ffffff;
      this.words[i] = w;
    }
    if (carry !== 0) {
      this.words[i] = carry;
      this.length++;
    }
    return this;
  };

  BN.prototype.isZero = function isZero () {
    return this.length === 1 && this.words[0] === 0;
  };

  BN.prototype.cmpn = function cmpn (num) {
    var negative = num < 0;

    if (this.negative !== 0 && !negative) return -1;
    if (this.negative === 0 && negative) return 1;

    this.strip();

    var res;
    if (this.length > 1) {
      res = 1;
    } else {
      if (negative) {
        num = -num;
      }

      assert(num <= 0x3ffffff, 'Number is too big');

      var w = this.words[0] | 0;
      res = w === num ? 0 : w < num ? -1 : 1;
    }
    if (this.negative !== 0) return -res | 0;
    return res;
  };

  // Compare two numbers and return:
  // 1 - if `this` > `num`
  // 0 - if `this` == `num`
  // -1 - if `this` < `num`
  BN.prototype.cmp = function cmp (num) {
    if (this.negative !== 0 && num.negative === 0) return -1;
    if (this.negative === 0 && num.negative !== 0) return 1;

    var res = this.ucmp(num);
    if (this.negative !== 0) return -res | 0;
    return res;
  };

  // Unsigned comparison
  BN.prototype.ucmp = function ucmp (num) {
    // At this point both numbers have the same sign
    if (this.length > num.length) return 1;
    if (this.length < num.length) return -1;

    var res = 0;
    for (var i = this.length - 1; i >= 0; i--) {
      var a = this.words[i] | 0;
      var b = num.words[i] | 0;

      if (a === b) continue;
      if (a < b) {
        res = -1;
      } else if (a > b) {
        res = 1;
      }
      break;
    }
    return res;
  };

  BN.prototype.gtn = function gtn (num) {
    return this.cmpn(num) === 1;
  };

  BN.prototype.gt = function gt (num) {
    return this.cmp(num) === 1;
  };

  BN.prototype.gten = function gten (num) {
    return this.cmpn(num) >= 0;
  };

  BN.prototype.gte = function gte (num) {
    return this.cmp(num) >= 0;
  };

  BN.prototype.ltn = function ltn (num) {
    return this.cmpn(num) === -1;
  };

  BN.prototype.lt = function lt (num) {
    return this.cmp(num) === -1;
  };

  BN.prototype.lten = function lten (num) {
    return this.cmpn(num) <= 0;
  };

  BN.prototype.lte = function lte (num) {
    return this.cmp(num) <= 0;
  };

  BN.prototype.eqn = function eqn (num) {
    return this.cmpn(num) === 0;
  };

  BN.prototype.eq = function eq (num) {
    return this.cmp(num) === 0;
  };

  //
  // A reduce context, could be using montgomery or something better, depending
  // on the `m` itself.
  //
  BN.red = function red (num) {
    return new Red(num);
  };

  BN.prototype.toRed = function toRed (ctx) {
    assert(!this.red, 'Already a number in reduction context');
    assert(this.negative === 0, 'red works only with positives');
    return ctx.convertTo(this)._forceRed(ctx);
  };

  BN.prototype.fromRed = function fromRed () {
    assert(this.red, 'fromRed works only with numbers in reduction context');
    return this.red.convertFrom(this);
  };

  BN.prototype._forceRed = function _forceRed (ctx) {
    this.red = ctx;
    return this;
  };

  BN.prototype.forceRed = function forceRed (ctx) {
    assert(!this.red, 'Already a number in reduction context');
    return this._forceRed(ctx);
  };

  BN.prototype.redAdd = function redAdd (num) {
    assert(this.red, 'redAdd works only with red numbers');
    return this.red.add(this, num);
  };

  BN.prototype.redIAdd = function redIAdd (num) {
    assert(this.red, 'redIAdd works only with red numbers');
    return this.red.iadd(this, num);
  };

  BN.prototype.redSub = function redSub (num) {
    assert(this.red, 'redSub works only with red numbers');
    return this.red.sub(this, num);
  };

  BN.prototype.redISub = function redISub (num) {
    assert(this.red, 'redISub works only with red numbers');
    return this.red.isub(this, num);
  };

  BN.prototype.redShl = function redShl (num) {
    assert(this.red, 'redShl works only with red numbers');
    return this.red.shl(this, num);
  };

  BN.prototype.redMul = function redMul (num) {
    assert(this.red, 'redMul works only with red numbers');
    this.red._verify2(this, num);
    return this.red.mul(this, num);
  };

  BN.prototype.redIMul = function redIMul (num) {
    assert(this.red, 'redMul works only with red numbers');
    this.red._verify2(this, num);
    return this.red.imul(this, num);
  };

  BN.prototype.redSqr = function redSqr () {
    assert(this.red, 'redSqr works only with red numbers');
    this.red._verify1(this);
    return this.red.sqr(this);
  };

  BN.prototype.redISqr = function redISqr () {
    assert(this.red, 'redISqr works only with red numbers');
    this.red._verify1(this);
    return this.red.isqr(this);
  };

  // Square root over p
  BN.prototype.redSqrt = function redSqrt () {
    assert(this.red, 'redSqrt works only with red numbers');
    this.red._verify1(this);
    return this.red.sqrt(this);
  };

  BN.prototype.redInvm = function redInvm () {
    assert(this.red, 'redInvm works only with red numbers');
    this.red._verify1(this);
    return this.red.invm(this);
  };

  // Return negative clone of `this` % `red modulo`
  BN.prototype.redNeg = function redNeg () {
    assert(this.red, 'redNeg works only with red numbers');
    this.red._verify1(this);
    return this.red.neg(this);
  };

  BN.prototype.redPow = function redPow (num) {
    assert(this.red && !num.red, 'redPow(normalNum)');
    this.red._verify1(this);
    return this.red.pow(this, num);
  };

  // Prime numbers with efficient reduction
  var primes = {
    k256: null,
    p224: null,
    p192: null,
    p25519: null
  };

  // Pseudo-Mersenne prime
  function MPrime (name, p) {
    // P = 2 ^ N - K
    this.name = name;
    this.p = new BN(p, 16);
    this.n = this.p.bitLength();
    this.k = new BN(1).iushln(this.n).isub(this.p);

    this.tmp = this._tmp();
  }

  MPrime.prototype._tmp = function _tmp () {
    var tmp = new BN(null);
    tmp.words = new Array(Math.ceil(this.n / 13));
    return tmp;
  };

  MPrime.prototype.ireduce = function ireduce (num) {
    // Assumes that `num` is less than `P^2`
    // num = HI * (2 ^ N - K) + HI * K + LO = HI * K + LO (mod P)
    var r = num;
    var rlen;

    do {
      this.split(r, this.tmp);
      r = this.imulK(r);
      r = r.iadd(this.tmp);
      rlen = r.bitLength();
    } while (rlen > this.n);

    var cmp = rlen < this.n ? -1 : r.ucmp(this.p);
    if (cmp === 0) {
      r.words[0] = 0;
      r.length = 1;
    } else if (cmp > 0) {
      r.isub(this.p);
    } else {
      if (r.strip !== undefined) {
        // r is BN v4 instance
        r.strip();
      } else {
        // r is BN v5 instance
        r._strip();
      }
    }

    return r;
  };

  MPrime.prototype.split = function split (input, out) {
    input.iushrn(this.n, 0, out);
  };

  MPrime.prototype.imulK = function imulK (num) {
    return num.imul(this.k);
  };

  function K256 () {
    MPrime.call(
      this,
      'k256',
      'ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f');
  }
  inherits(K256, MPrime);

  K256.prototype.split = function split (input, output) {
    // 256 = 9 * 26 + 22
    var mask = 0x3fffff;

    var outLen = Math.min(input.length, 9);
    for (var i = 0; i < outLen; i++) {
      output.words[i] = input.words[i];
    }
    output.length = outLen;

    if (input.length <= 9) {
      input.words[0] = 0;
      input.length = 1;
      return;
    }

    // Shift by 9 limbs
    var prev = input.words[9];
    output.words[output.length++] = prev & mask;

    for (i = 10; i < input.length; i++) {
      var next = input.words[i] | 0;
      input.words[i - 10] = ((next & mask) << 4) | (prev >>> 22);
      prev = next;
    }
    prev >>>= 22;
    input.words[i - 10] = prev;
    if (prev === 0 && input.length > 10) {
      input.length -= 10;
    } else {
      input.length -= 9;
    }
  };

  K256.prototype.imulK = function imulK (num) {
    // K = 0x1000003d1 = [ 0x40, 0x3d1 ]
    num.words[num.length] = 0;
    num.words[num.length + 1] = 0;
    num.length += 2;

    // bounded at: 0x40 * 0x3ffffff + 0x3d0 = 0x100000390
    var lo = 0;
    for (var i = 0; i < num.length; i++) {
      var w = num.words[i] | 0;
      lo += w * 0x3d1;
      num.words[i] = lo & 0x3ffffff;
      lo = w * 0x40 + ((lo / 0x4000000) | 0);
    }

    // Fast length reduction
    if (num.words[num.length - 1] === 0) {
      num.length--;
      if (num.words[num.length - 1] === 0) {
        num.length--;
      }
    }
    return num;
  };

  function P224 () {
    MPrime.call(
      this,
      'p224',
      'ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001');
  }
  inherits(P224, MPrime);

  function P192 () {
    MPrime.call(
      this,
      'p192',
      'ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff');
  }
  inherits(P192, MPrime);

  function P25519 () {
    // 2 ^ 255 - 19
    MPrime.call(
      this,
      '25519',
      '7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed');
  }
  inherits(P25519, MPrime);

  P25519.prototype.imulK = function imulK (num) {
    // K = 0x13
    var carry = 0;
    for (var i = 0; i < num.length; i++) {
      var hi = (num.words[i] | 0) * 0x13 + carry;
      var lo = hi & 0x3ffffff;
      hi >>>= 26;

      num.words[i] = lo;
      carry = hi;
    }
    if (carry !== 0) {
      num.words[num.length++] = carry;
    }
    return num;
  };

  // Exported mostly for testing purposes, use plain name instead
  BN._prime = function prime (name) {
    // Cached version of prime
    if (primes[name]) return primes[name];

    var prime;
    if (name === 'k256') {
      prime = new K256();
    } else if (name === 'p224') {
      prime = new P224();
    } else if (name === 'p192') {
      prime = new P192();
    } else if (name === 'p25519') {
      prime = new P25519();
    } else {
      throw new Error('Unknown prime ' + name);
    }
    primes[name] = prime;

    return prime;
  };

  //
  // Base reduction engine
  //
  function Red (m) {
    if (typeof m === 'string') {
      var prime = BN._prime(m);
      this.m = prime.p;
      this.prime = prime;
    } else {
      assert(m.gtn(1), 'modulus must be greater than 1');
      this.m = m;
      this.prime = null;
    }
  }

  Red.prototype._verify1 = function _verify1 (a) {
    assert(a.negative === 0, 'red works only with positives');
    assert(a.red, 'red works only with red numbers');
  };

  Red.prototype._verify2 = function _verify2 (a, b) {
    assert((a.negative | b.negative) === 0, 'red works only with positives');
    assert(a.red && a.red === b.red,
      'red works only with red numbers');
  };

  Red.prototype.imod = function imod (a) {
    if (this.prime) return this.prime.ireduce(a)._forceRed(this);
    return a.umod(this.m)._forceRed(this);
  };

  Red.prototype.neg = function neg (a) {
    if (a.isZero()) {
      return a.clone();
    }

    return this.m.sub(a)._forceRed(this);
  };

  Red.prototype.add = function add (a, b) {
    this._verify2(a, b);

    var res = a.add(b);
    if (res.cmp(this.m) >= 0) {
      res.isub(this.m);
    }
    return res._forceRed(this);
  };

  Red.prototype.iadd = function iadd (a, b) {
    this._verify2(a, b);

    var res = a.iadd(b);
    if (res.cmp(this.m) >= 0) {
      res.isub(this.m);
    }
    return res;
  };

  Red.prototype.sub = function sub (a, b) {
    this._verify2(a, b);

    var res = a.sub(b);
    if (res.cmpn(0) < 0) {
      res.iadd(this.m);
    }
    return res._forceRed(this);
  };

  Red.prototype.isub = function isub (a, b) {
    this._verify2(a, b);

    var res = a.isub(b);
    if (res.cmpn(0) < 0) {
      res.iadd(this.m);
    }
    return res;
  };

  Red.prototype.shl = function shl (a, num) {
    this._verify1(a);
    return this.imod(a.ushln(num));
  };

  Red.prototype.imul = function imul (a, b) {
    this._verify2(a, b);
    return this.imod(a.imul(b));
  };

  Red.prototype.mul = function mul (a, b) {
    this._verify2(a, b);
    return this.imod(a.mul(b));
  };

  Red.prototype.isqr = function isqr (a) {
    return this.imul(a, a.clone());
  };

  Red.prototype.sqr = function sqr (a) {
    return this.mul(a, a);
  };

  Red.prototype.sqrt = function sqrt (a) {
    if (a.isZero()) return a.clone();

    var mod3 = this.m.andln(3);
    assert(mod3 % 2 === 1);

    // Fast case
    if (mod3 === 3) {
      var pow = this.m.add(new BN(1)).iushrn(2);
      return this.pow(a, pow);
    }

    // Tonelli-Shanks algorithm (Totally unoptimized and slow)
    //
    // Find Q and S, that Q * 2 ^ S = (P - 1)
    var q = this.m.subn(1);
    var s = 0;
    while (!q.isZero() && q.andln(1) === 0) {
      s++;
      q.iushrn(1);
    }
    assert(!q.isZero());

    var one = new BN(1).toRed(this);
    var nOne = one.redNeg();

    // Find quadratic non-residue
    // NOTE: Max is such because of generalized Riemann hypothesis.
    var lpow = this.m.subn(1).iushrn(1);
    var z = this.m.bitLength();
    z = new BN(2 * z * z).toRed(this);

    while (this.pow(z, lpow).cmp(nOne) !== 0) {
      z.redIAdd(nOne);
    }

    var c = this.pow(z, q);
    var r = this.pow(a, q.addn(1).iushrn(1));
    var t = this.pow(a, q);
    var m = s;
    while (t.cmp(one) !== 0) {
      var tmp = t;
      for (var i = 0; tmp.cmp(one) !== 0; i++) {
        tmp = tmp.redSqr();
      }
      assert(i < m);
      var b = this.pow(c, new BN(1).iushln(m - i - 1));

      r = r.redMul(b);
      c = b.redSqr();
      t = t.redMul(c);
      m = i;
    }

    return r;
  };

  Red.prototype.invm = function invm (a) {
    var inv = a._invmp(this.m);
    if (inv.negative !== 0) {
      inv.negative = 0;
      return this.imod(inv).redNeg();
    } else {
      return this.imod(inv);
    }
  };

  Red.prototype.pow = function pow (a, num) {
    if (num.isZero()) return new BN(1).toRed(this);
    if (num.cmpn(1) === 0) return a.clone();

    var windowSize = 4;
    var wnd = new Array(1 << windowSize);
    wnd[0] = new BN(1).toRed(this);
    wnd[1] = a;
    for (var i = 2; i < wnd.length; i++) {
      wnd[i] = this.mul(wnd[i - 1], a);
    }

    var res = wnd[0];
    var current = 0;
    var currentLen = 0;
    var start = num.bitLength() % 26;
    if (start === 0) {
      start = 26;
    }

    for (i = num.length - 1; i >= 0; i--) {
      var word = num.words[i];
      for (var j = start - 1; j >= 0; j--) {
        var bit = (word >> j) & 1;
        if (res !== wnd[0]) {
          res = this.sqr(res);
        }

        if (bit === 0 && current === 0) {
          currentLen = 0;
          continue;
        }

        current <<= 1;
        current |= bit;
        currentLen++;
        if (currentLen !== windowSize && (i !== 0 || j !== 0)) continue;

        res = this.mul(res, wnd[current]);
        currentLen = 0;
        current = 0;
      }
      start = 26;
    }

    return res;
  };

  Red.prototype.convertTo = function convertTo (num) {
    var r = num.umod(this.m);

    return r === num ? r.clone() : r;
  };

  Red.prototype.convertFrom = function convertFrom (num) {
    var res = num.clone();
    res.red = null;
    return res;
  };

  //
  // Montgomery method engine
  //

  BN.mont = function mont (num) {
    return new Mont(num);
  };

  function Mont (m) {
    Red.call(this, m);

    this.shift = this.m.bitLength();
    if (this.shift % 26 !== 0) {
      this.shift += 26 - (this.shift % 26);
    }

    this.r = new BN(1).iushln(this.shift);
    this.r2 = this.imod(this.r.sqr());
    this.rinv = this.r._invmp(this.m);

    this.minv = this.rinv.mul(this.r).isubn(1).div(this.m);
    this.minv = this.minv.umod(this.r);
    this.minv = this.r.sub(this.minv);
  }
  inherits(Mont, Red);

  Mont.prototype.convertTo = function convertTo (num) {
    return this.imod(num.ushln(this.shift));
  };

  Mont.prototype.convertFrom = function convertFrom (num) {
    var r = this.imod(num.mul(this.rinv));
    r.red = null;
    return r;
  };

  Mont.prototype.imul = function imul (a, b) {
    if (a.isZero() || b.isZero()) {
      a.words[0] = 0;
      a.length = 1;
      return a;
    }

    var t = a.imul(b);
    var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
    var u = t.isub(c).iushrn(this.shift);
    var res = u;

    if (u.cmp(this.m) >= 0) {
      res = u.isub(this.m);
    } else if (u.cmpn(0) < 0) {
      res = u.iadd(this.m);
    }

    return res._forceRed(this);
  };

  Mont.prototype.mul = function mul (a, b) {
    if (a.isZero() || b.isZero()) return new BN(0)._forceRed(this);

    var t = a.mul(b);
    var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
    var u = t.isub(c).iushrn(this.shift);
    var res = u;
    if (u.cmp(this.m) >= 0) {
      res = u.isub(this.m);
    } else if (u.cmpn(0) < 0) {
      res = u.iadd(this.m);
    }

    return res._forceRed(this);
  };

  Mont.prototype.invm = function invm (a) {
    // (AR)^-1 * R^2 = (A^-1 * R^-1) * R^2 = A^-1 * R
    var res = this.imod(a._invmp(this.m).mul(this.r2));
    return res._forceRed(this);
  };
})( false || module, this);

/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(/*! ./../../../../webpack/buildin/module.js */ "./node_modules/webpack/buildin/module.js")(module)))

/***/ }),

/***/ "./node_modules/create-hash/browser.js":
/*!*********************************************!*\
  !*** ./node_modules/create-hash/browser.js ***!
  \*********************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var inherits = __webpack_require__(/*! inherits */ "./node_modules/inherits/inherits_browser.js")
var MD5 = __webpack_require__(/*! md5.js */ "./node_modules/md5.js/index.js")
var RIPEMD160 = __webpack_require__(/*! ripemd160 */ "./node_modules/ripemd160/index.js")
var sha = __webpack_require__(/*! sha.js */ "./node_modules/sha.js/index.js")
var Base = __webpack_require__(/*! cipher-base */ "./node_modules/cipher-base/index.js")

function Hash (hash) {
  Base.call(this, 'digest')

  this._hash = hash
}

inherits(Hash, Base)

Hash.prototype._update = function (data) {
  this._hash.update(data)
}

Hash.prototype._final = function () {
  return this._hash.digest()
}

module.exports = function createHash (alg) {
  alg = alg.toLowerCase()
  if (alg === 'md5') return new MD5()
  if (alg === 'rmd160' || alg === 'ripemd160') return new RIPEMD160()

  return new Hash(sha(alg))
}


/***/ }),

/***/ "./node_modules/create-hash/md5.js":
/*!*****************************************!*\
  !*** ./node_modules/create-hash/md5.js ***!
  \*****************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var MD5 = __webpack_require__(/*! md5.js */ "./node_modules/md5.js/index.js")

module.exports = function (buffer) {
  return new MD5().update(buffer).digest()
}


/***/ }),

/***/ "./node_modules/create-hmac/browser.js":
/*!*********************************************!*\
  !*** ./node_modules/create-hmac/browser.js ***!
  \*********************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var inherits = __webpack_require__(/*! inherits */ "./node_modules/inherits/inherits_browser.js")
var Legacy = __webpack_require__(/*! ./legacy */ "./node_modules/create-hmac/legacy.js")
var Base = __webpack_require__(/*! cipher-base */ "./node_modules/cipher-base/index.js")
var Buffer = __webpack_require__(/*! safe-buffer */ "./node_modules/safe-buffer/index.js").Buffer
var md5 = __webpack_require__(/*! create-hash/md5 */ "./node_modules/create-hash/md5.js")
var RIPEMD160 = __webpack_require__(/*! ripemd160 */ "./node_modules/ripemd160/index.js")

var sha = __webpack_require__(/*! sha.js */ "./node_modules/sha.js/index.js")

var ZEROS = Buffer.alloc(128)

function Hmac (alg, key) {
  Base.call(this, 'digest')
  if (typeof key === 'string') {
    key = Buffer.from(key)
  }

  var blocksize = (alg === 'sha512' || alg === 'sha384') ? 128 : 64

  this._alg = alg
  this._key = key
  if (key.length > blocksize) {
    var hash = alg === 'rmd160' ? new RIPEMD160() : sha(alg)
    key = hash.update(key).digest()
  } else if (key.length < blocksize) {
    key = Buffer.concat([key, ZEROS], blocksize)
  }

  var ipad = this._ipad = Buffer.allocUnsafe(blocksize)
  var opad = this._opad = Buffer.allocUnsafe(blocksize)

  for (var i = 0; i < blocksize; i++) {
    ipad[i] = key[i] ^ 0x36
    opad[i] = key[i] ^ 0x5C
  }
  this._hash = alg === 'rmd160' ? new RIPEMD160() : sha(alg)
  this._hash.update(ipad)
}

inherits(Hmac, Base)

Hmac.prototype._update = function (data) {
  this._hash.update(data)
}

Hmac.prototype._final = function () {
  var h = this._hash.digest()
  var hash = this._alg === 'rmd160' ? new RIPEMD160() : sha(this._alg)
  return hash.update(this._opad).update(h).digest()
}

module.exports = function createHmac (alg, key) {
  alg = alg.toLowerCase()
  if (alg === 'rmd160' || alg === 'ripemd160') {
    return new Hmac('rmd160', key)
  }
  if (alg === 'md5') {
    return new Legacy(md5, key)
  }
  return new Hmac(alg, key)
}


/***/ }),

/***/ "./node_modules/create-hmac/legacy.js":
/*!********************************************!*\
  !*** ./node_modules/create-hmac/legacy.js ***!
  \********************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var inherits = __webpack_require__(/*! inherits */ "./node_modules/inherits/inherits_browser.js")
var Buffer = __webpack_require__(/*! safe-buffer */ "./node_modules/safe-buffer/index.js").Buffer

var Base = __webpack_require__(/*! cipher-base */ "./node_modules/cipher-base/index.js")

var ZEROS = Buffer.alloc(128)
var blocksize = 64

function Hmac (alg, key) {
  Base.call(this, 'digest')
  if (typeof key === 'string') {
    key = Buffer.from(key)
  }

  this._alg = alg
  this._key = key

  if (key.length > blocksize) {
    key = alg(key)
  } else if (key.length < blocksize) {
    key = Buffer.concat([key, ZEROS], blocksize)
  }

  var ipad = this._ipad = Buffer.allocUnsafe(blocksize)
  var opad = this._opad = Buffer.allocUnsafe(blocksize)

  for (var i = 0; i < blocksize; i++) {
    ipad[i] = key[i] ^ 0x36
    opad[i] = key[i] ^ 0x5C
  }

  this._hash = [ipad]
}

inherits(Hmac, Base)

Hmac.prototype._update = function (data) {
  this._hash.push(data)
}

Hmac.prototype._final = function () {
  var h = this._alg(Buffer.concat(this._hash))
  return this._alg(Buffer.concat([this._opad, h]))
}
module.exports = Hmac


/***/ }),

/***/ "./node_modules/crypto-browserify/index.js":
/*!*************************************************!*\
  !*** ./node_modules/crypto-browserify/index.js ***!
  \*************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.randomBytes = exports.rng = exports.pseudoRandomBytes = exports.prng = __webpack_require__(/*! randombytes */ "./node_modules/randombytes/browser.js")
exports.createHash = exports.Hash = __webpack_require__(/*! create-hash */ "./node_modules/create-hash/browser.js")
exports.createHmac = exports.Hmac = __webpack_require__(/*! create-hmac */ "./node_modules/create-hmac/browser.js")

var algos = __webpack_require__(/*! browserify-sign/algos */ "./node_modules/browserify-sign/algos.js")
var algoKeys = Object.keys(algos)
var hashes = ['sha1', 'sha224', 'sha256', 'sha384', 'sha512', 'md5', 'rmd160'].concat(algoKeys)
exports.getHashes = function () {
  return hashes
}

var p = __webpack_require__(/*! pbkdf2 */ "./node_modules/pbkdf2/browser.js")
exports.pbkdf2 = p.pbkdf2
exports.pbkdf2Sync = p.pbkdf2Sync

var aes = __webpack_require__(/*! browserify-cipher */ "./node_modules/browserify-cipher/browser.js")

exports.Cipher = aes.Cipher
exports.createCipher = aes.createCipher
exports.Cipheriv = aes.Cipheriv
exports.createCipheriv = aes.createCipheriv
exports.Decipher = aes.Decipher
exports.createDecipher = aes.createDecipher
exports.Decipheriv = aes.Decipheriv
exports.createDecipheriv = aes.createDecipheriv
exports.getCiphers = aes.getCiphers
exports.listCiphers = aes.listCiphers

var dh = __webpack_require__(/*! diffie-hellman */ "./node_modules/diffie-hellman/browser.js")

exports.DiffieHellmanGroup = dh.DiffieHellmanGroup
exports.createDiffieHellmanGroup = dh.createDiffieHellmanGroup
exports.getDiffieHellman = dh.getDiffieHellman
exports.createDiffieHellman = dh.createDiffieHellman
exports.DiffieHellman = dh.DiffieHellman

var sign = __webpack_require__(/*! browserify-sign */ "./node_modules/browserify-sign/browser/index.js")

exports.createSign = sign.createSign
exports.Sign = sign.Sign
exports.createVerify = sign.createVerify
exports.Verify = sign.Verify

exports.createECDH = __webpack_require__(/*! create-ecdh */ "./node_modules/create-ecdh/browser.js")

var publicEncrypt = __webpack_require__(/*! public-encrypt */ "./node_modules/public-encrypt/browser.js")

exports.publicEncrypt = publicEncrypt.publicEncrypt
exports.privateEncrypt = publicEncrypt.privateEncrypt
exports.publicDecrypt = publicEncrypt.publicDecrypt
exports.privateDecrypt = publicEncrypt.privateDecrypt

// the least I can do is make error messages for the rest of the node.js/crypto api.
// ;[
//   'createCredentials'
// ].forEach(function (name) {
//   exports[name] = function () {
//     throw new Error([
//       'sorry, ' + name + ' is not implemented yet',
//       'we accept pull requests',
//       'https://github.com/crypto-browserify/crypto-browserify'
//     ].join('\n'))
//   }
// })

var rf = __webpack_require__(/*! randomfill */ "./node_modules/randomfill/browser.js")

exports.randomFill = rf.randomFill
exports.randomFillSync = rf.randomFillSync

exports.createCredentials = function () {
  throw new Error([
    'sorry, createCredentials is not implemented yet',
    'we accept pull requests',
    'https://github.com/crypto-browserify/crypto-browserify'
  ].join('\n'))
}

exports.constants = {
  'DH_CHECK_P_NOT_SAFE_PRIME': 2,
  'DH_CHECK_P_NOT_PRIME': 1,
  'DH_UNABLE_TO_CHECK_GENERATOR': 4,
  'DH_NOT_SUITABLE_GENERATOR': 8,
  'NPN_ENABLED': 1,
  'ALPN_ENABLED': 1,
  'RSA_PKCS1_PADDING': 1,
  'RSA_SSLV23_PADDING': 2,
  'RSA_NO_PADDING': 3,
  'RSA_PKCS1_OAEP_PADDING': 4,
  'RSA_X931_PADDING': 5,
  'RSA_PKCS1_PSS_PADDING': 6,
  'POINT_CONVERSION_COMPRESSED': 2,
  'POINT_CONVERSION_UNCOMPRESSED': 4,
  'POINT_CONVERSION_HYBRID': 6
}


/***/ }),

/***/ "./node_modules/des.js/lib/des.js":
/*!****************************************!*\
  !*** ./node_modules/des.js/lib/des.js ***!
  \****************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.utils = __webpack_require__(/*! ./des/utils */ "./node_modules/des.js/lib/des/utils.js");
exports.Cipher = __webpack_require__(/*! ./des/cipher */ "./node_modules/des.js/lib/des/cipher.js");
exports.DES = __webpack_require__(/*! ./des/des */ "./node_modules/des.js/lib/des/des.js");
exports.CBC = __webpack_require__(/*! ./des/cbc */ "./node_modules/des.js/lib/des/cbc.js");
exports.EDE = __webpack_require__(/*! ./des/ede */ "./node_modules/des.js/lib/des/ede.js");


/***/ }),

/***/ "./node_modules/des.js/lib/des/cbc.js":
/*!********************************************!*\
  !*** ./node_modules/des.js/lib/des/cbc.js ***!
  \********************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var assert = __webpack_require__(/*! minimalistic-assert */ "./node_modules/minimalistic-assert/index.js");
var inherits = __webpack_require__(/*! inherits */ "./node_modules/inherits/inherits_browser.js");

var proto = {};

function CBCState(iv) {
  assert.equal(iv.length, 8, 'Invalid IV length');

  this.iv = new Array(8);
  for (var i = 0; i < this.iv.length; i++)
    this.iv[i] = iv[i];
}

function instantiate(Base) {
  function CBC(options) {
    Base.call(this, options);
    this._cbcInit();
  }
  inherits(CBC, Base);

  var keys = Object.keys(proto);
  for (var i = 0; i < keys.length; i++) {
    var key = keys[i];
    CBC.prototype[key] = proto[key];
  }

  CBC.create = function create(options) {
    return new CBC(options);
  };

  return CBC;
}

exports.instantiate = instantiate;

proto._cbcInit = function _cbcInit() {
  var state = new CBCState(this.options.iv);
  this._cbcState = state;
};

proto._update = function _update(inp, inOff, out, outOff) {
  var state = this._cbcState;
  var superProto = this.constructor.super_.prototype;

  var iv = state.iv;
  if (this.type === 'encrypt') {
    for (var i = 0; i < this.blockSize; i++)
      iv[i] ^= inp[inOff + i];

    superProto._update.call(this, iv, 0, out, outOff);

    for (var i = 0; i < this.blockSize; i++)
      iv[i] = out[outOff + i];
  } else {
    superProto._update.call(this, inp, inOff, out, outOff);

    for (var i = 0; i < this.blockSize; i++)
      out[outOff + i] ^= iv[i];

    for (var i = 0; i < this.blockSize; i++)
      iv[i] = inp[inOff + i];
  }
};


/***/ }),

/***/ "./node_modules/des.js/lib/des/cipher.js":
/*!***********************************************!*\
  !*** ./node_modules/des.js/lib/des/cipher.js ***!
  \***********************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var assert = __webpack_require__(/*! minimalistic-assert */ "./node_modules/minimalistic-assert/index.js");

function Cipher(options) {
  this.options = options;

  this.type = this.options.type;
  this.blockSize = 8;
  this._init();

  this.buffer = new Array(this.blockSize);
  this.bufferOff = 0;
}
module.exports = Cipher;

Cipher.prototype._init = function _init() {
  // Might be overrided
};

Cipher.prototype.update = function update(data) {
  if (data.length === 0)
    return [];

  if (this.type === 'decrypt')
    return this._updateDecrypt(data);
  else
    return this._updateEncrypt(data);
};

Cipher.prototype._buffer = function _buffer(data, off) {
  // Append data to buffer
  var min = Math.min(this.buffer.length - this.bufferOff, data.length - off);
  for (var i = 0; i < min; i++)
    this.buffer[this.bufferOff + i] = data[off + i];
  this.bufferOff += min;

  // Shift next
  return min;
};

Cipher.prototype._flushBuffer = function _flushBuffer(out, off) {
  this._update(this.buffer, 0, out, off);
  this.bufferOff = 0;
  return this.blockSize;
};

Cipher.prototype._updateEncrypt = function _updateEncrypt(data) {
  var inputOff = 0;
  var outputOff = 0;

  var count = ((this.bufferOff + data.length) / this.blockSize) | 0;
  var out = new Array(count * this.blockSize);

  if (this.bufferOff !== 0) {
    inputOff += this._buffer(data, inputOff);

    if (this.bufferOff === this.buffer.length)
      outputOff += this._flushBuffer(out, outputOff);
  }

  // Write blocks
  var max = data.length - ((data.length - inputOff) % this.blockSize);
  for (; inputOff < max; inputOff += this.blockSize) {
    this._update(data, inputOff, out, outputOff);
    outputOff += this.blockSize;
  }

  // Queue rest
  for (; inputOff < data.length; inputOff++, this.bufferOff++)
    this.buffer[this.bufferOff] = data[inputOff];

  return out;
};

Cipher.prototype._updateDecrypt = function _updateDecrypt(data) {
  var inputOff = 0;
  var outputOff = 0;

  var count = Math.ceil((this.bufferOff + data.length) / this.blockSize) - 1;
  var out = new Array(count * this.blockSize);

  // TODO(indutny): optimize it, this is far from optimal
  for (; count > 0; count--) {
    inputOff += this._buffer(data, inputOff);
    outputOff += this._flushBuffer(out, outputOff);
  }

  // Buffer rest of the input
  inputOff += this._buffer(data, inputOff);

  return out;
};

Cipher.prototype.final = function final(buffer) {
  var first;
  if (buffer)
    first = this.update(buffer);

  var last;
  if (this.type === 'encrypt')
    last = this._finalEncrypt();
  else
    last = this._finalDecrypt();

  if (first)
    return first.concat(last);
  else
    return last;
};

Cipher.prototype._pad = function _pad(buffer, off) {
  if (off === 0)
    return false;

  while (off < buffer.length)
    buffer[off++] = 0;

  return true;
};

Cipher.prototype._finalEncrypt = function _finalEncrypt() {
  if (!this._pad(this.buffer, this.bufferOff))
    return [];

  var out = new Array(this.blockSize);
  this._update(this.buffer, 0, out, 0);
  return out;
};

Cipher.prototype._unpad = function _unpad(buffer) {
  return buffer;
};

Cipher.prototype._finalDecrypt = function _finalDecrypt() {
  assert.equal(this.bufferOff, this.blockSize, 'Not enough data to decrypt');
  var out = new Array(this.blockSize);
  this._flushBuffer(out, 0);

  return this._unpad(out);
};


/***/ }),

/***/ "./node_modules/des.js/lib/des/des.js":
/*!********************************************!*\
  !*** ./node_modules/des.js/lib/des/des.js ***!
  \********************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var assert = __webpack_require__(/*! minimalistic-assert */ "./node_modules/minimalistic-assert/index.js");
var inherits = __webpack_require__(/*! inherits */ "./node_modules/inherits/inherits_browser.js");

var utils = __webpack_require__(/*! ./utils */ "./node_modules/des.js/lib/des/utils.js");
var Cipher = __webpack_require__(/*! ./cipher */ "./node_modules/des.js/lib/des/cipher.js");

function DESState() {
  this.tmp = new Array(2);
  this.keys = null;
}

function DES(options) {
  Cipher.call(this, options);

  var state = new DESState();
  this._desState = state;

  this.deriveKeys(state, options.key);
}
inherits(DES, Cipher);
module.exports = DES;

DES.create = function create(options) {
  return new DES(options);
};

var shiftTable = [
  1, 1, 2, 2, 2, 2, 2, 2,
  1, 2, 2, 2, 2, 2, 2, 1
];

DES.prototype.deriveKeys = function deriveKeys(state, key) {
  state.keys = new Array(16 * 2);

  assert.equal(key.length, this.blockSize, 'Invalid key length');

  var kL = utils.readUInt32BE(key, 0);
  var kR = utils.readUInt32BE(key, 4);

  utils.pc1(kL, kR, state.tmp, 0);
  kL = state.tmp[0];
  kR = state.tmp[1];
  for (var i = 0; i < state.keys.length; i += 2) {
    var shift = shiftTable[i >>> 1];
    kL = utils.r28shl(kL, shift);
    kR = utils.r28shl(kR, shift);
    utils.pc2(kL, kR, state.keys, i);
  }
};

DES.prototype._update = function _update(inp, inOff, out, outOff) {
  var state = this._desState;

  var l = utils.readUInt32BE(inp, inOff);
  var r = utils.readUInt32BE(inp, inOff + 4);

  // Initial Permutation
  utils.ip(l, r, state.tmp, 0);
  l = state.tmp[0];
  r = state.tmp[1];

  if (this.type === 'encrypt')
    this._encrypt(state, l, r, state.tmp, 0);
  else
    this._decrypt(state, l, r, state.tmp, 0);

  l = state.tmp[0];
  r = state.tmp[1];

  utils.writeUInt32BE(out, l, outOff);
  utils.writeUInt32BE(out, r, outOff + 4);
};

DES.prototype._pad = function _pad(buffer, off) {
  var value = buffer.length - off;
  for (var i = off; i < buffer.length; i++)
    buffer[i] = value;

  return true;
};

DES.prototype._unpad = function _unpad(buffer) {
  var pad = buffer[buffer.length - 1];
  for (var i = buffer.length - pad; i < buffer.length; i++)
    assert.equal(buffer[i], pad);

  return buffer.slice(0, buffer.length - pad);
};

DES.prototype._encrypt = function _encrypt(state, lStart, rStart, out, off) {
  var l = lStart;
  var r = rStart;

  // Apply f() x16 times
  for (var i = 0; i < state.keys.length; i += 2) {
    var keyL = state.keys[i];
    var keyR = state.keys[i + 1];

    // f(r, k)
    utils.expand(r, state.tmp, 0);

    keyL ^= state.tmp[0];
    keyR ^= state.tmp[1];
    var s = utils.substitute(keyL, keyR);
    var f = utils.permute(s);

    var t = r;
    r = (l ^ f) >>> 0;
    l = t;
  }

  // Reverse Initial Permutation
  utils.rip(r, l, out, off);
};

DES.prototype._decrypt = function _decrypt(state, lStart, rStart, out, off) {
  var l = rStart;
  var r = lStart;

  // Apply f() x16 times
  for (var i = state.keys.length - 2; i >= 0; i -= 2) {
    var keyL = state.keys[i];
    var keyR = state.keys[i + 1];

    // f(r, k)
    utils.expand(l, state.tmp, 0);

    keyL ^= state.tmp[0];
    keyR ^= state.tmp[1];
    var s = utils.substitute(keyL, keyR);
    var f = utils.permute(s);

    var t = l;
    l = (r ^ f) >>> 0;
    r = t;
  }

  // Reverse Initial Permutation
  utils.rip(l, r, out, off);
};


/***/ }),

/***/ "./node_modules/des.js/lib/des/ede.js":
/*!********************************************!*\
  !*** ./node_modules/des.js/lib/des/ede.js ***!
  \********************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var assert = __webpack_require__(/*! minimalistic-assert */ "./node_modules/minimalistic-assert/index.js");
var inherits = __webpack_require__(/*! inherits */ "./node_modules/inherits/inherits_browser.js");

var Cipher = __webpack_require__(/*! ./cipher */ "./node_modules/des.js/lib/des/cipher.js");
var DES = __webpack_require__(/*! ./des */ "./node_modules/des.js/lib/des/des.js");

function EDEState(type, key) {
  assert.equal(key.length, 24, 'Invalid key length');

  var k1 = key.slice(0, 8);
  var k2 = key.slice(8, 16);
  var k3 = key.slice(16, 24);

  if (type === 'encrypt') {
    this.ciphers = [
      DES.create({ type: 'encrypt', key: k1 }),
      DES.create({ type: 'decrypt', key: k2 }),
      DES.create({ type: 'encrypt', key: k3 })
    ];
  } else {
    this.ciphers = [
      DES.create({ type: 'decrypt', key: k3 }),
      DES.create({ type: 'encrypt', key: k2 }),
      DES.create({ type: 'decrypt', key: k1 })
    ];
  }
}

function EDE(options) {
  Cipher.call(this, options);

  var state = new EDEState(this.type, this.options.key);
  this._edeState = state;
}
inherits(EDE, Cipher);

module.exports = EDE;

EDE.create = function create(options) {
  return new EDE(options);
};

EDE.prototype._update = function _update(inp, inOff, out, outOff) {
  var state = this._edeState;

  state.ciphers[0]._update(inp, inOff, out, outOff);
  state.ciphers[1]._update(out, outOff, out, outOff);
  state.ciphers[2]._update(out, outOff, out, outOff);
};

EDE.prototype._pad = DES.prototype._pad;
EDE.prototype._unpad = DES.prototype._unpad;


/***/ }),

/***/ "./node_modules/des.js/lib/des/utils.js":
/*!**********************************************!*\
  !*** ./node_modules/des.js/lib/des/utils.js ***!
  \**********************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.readUInt32BE = function readUInt32BE(bytes, off) {
  var res =  (bytes[0 + off] << 24) |
             (bytes[1 + off] << 16) |
             (bytes[2 + off] << 8) |
             bytes[3 + off];
  return res >>> 0;
};

exports.writeUInt32BE = function writeUInt32BE(bytes, value, off) {
  bytes[0 + off] = value >>> 24;
  bytes[1 + off] = (value >>> 16) & 0xff;
  bytes[2 + off] = (value >>> 8) & 0xff;
  bytes[3 + off] = value & 0xff;
};

exports.ip = function ip(inL, inR, out, off) {
  var outL = 0;
  var outR = 0;

  for (var i = 6; i >= 0; i -= 2) {
    for (var j = 0; j <= 24; j += 8) {
      outL <<= 1;
      outL |= (inR >>> (j + i)) & 1;
    }
    for (var j = 0; j <= 24; j += 8) {
      outL <<= 1;
      outL |= (inL >>> (j + i)) & 1;
    }
  }

  for (var i = 6; i >= 0; i -= 2) {
    for (var j = 1; j <= 25; j += 8) {
      outR <<= 1;
      outR |= (inR >>> (j + i)) & 1;
    }
    for (var j = 1; j <= 25; j += 8) {
      outR <<= 1;
      outR |= (inL >>> (j + i)) & 1;
    }
  }

  out[off + 0] = outL >>> 0;
  out[off + 1] = outR >>> 0;
};

exports.rip = function rip(inL, inR, out, off) {
  var outL = 0;
  var outR = 0;

  for (var i = 0; i < 4; i++) {
    for (var j = 24; j >= 0; j -= 8) {
      outL <<= 1;
      outL |= (inR >>> (j + i)) & 1;
      outL <<= 1;
      outL |= (inL >>> (j + i)) & 1;
    }
  }
  for (var i = 4; i < 8; i++) {
    for (var j = 24; j >= 0; j -= 8) {
      outR <<= 1;
      outR |= (inR >>> (j + i)) & 1;
      outR <<= 1;
      outR |= (inL >>> (j + i)) & 1;
    }
  }

  out[off + 0] = outL >>> 0;
  out[off + 1] = outR >>> 0;
};

exports.pc1 = function pc1(inL, inR, out, off) {
  var outL = 0;
  var outR = 0;

  // 7, 15, 23, 31, 39, 47, 55, 63
  // 6, 14, 22, 30, 39, 47, 55, 63
  // 5, 13, 21, 29, 39, 47, 55, 63
  // 4, 12, 20, 28
  for (var i = 7; i >= 5; i--) {
    for (var j = 0; j <= 24; j += 8) {
      outL <<= 1;
      outL |= (inR >> (j + i)) & 1;
    }
    for (var j = 0; j <= 24; j += 8) {
      outL <<= 1;
      outL |= (inL >> (j + i)) & 1;
    }
  }
  for (var j = 0; j <= 24; j += 8) {
    outL <<= 1;
    outL |= (inR >> (j + i)) & 1;
  }

  // 1, 9, 17, 25, 33, 41, 49, 57
  // 2, 10, 18, 26, 34, 42, 50, 58
  // 3, 11, 19, 27, 35, 43, 51, 59
  // 36, 44, 52, 60
  for (var i = 1; i <= 3; i++) {
    for (var j = 0; j <= 24; j += 8) {
      outR <<= 1;
      outR |= (inR >> (j + i)) & 1;
    }
    for (var j = 0; j <= 24; j += 8) {
      outR <<= 1;
      outR |= (inL >> (j + i)) & 1;
    }
  }
  for (var j = 0; j <= 24; j += 8) {
    outR <<= 1;
    outR |= (inL >> (j + i)) & 1;
  }

  out[off + 0] = outL >>> 0;
  out[off + 1] = outR >>> 0;
};

exports.r28shl = function r28shl(num, shift) {
  return ((num << shift) & 0xfffffff) | (num >>> (28 - shift));
};

var pc2table = [
  // inL => outL
  14, 11, 17, 4, 27, 23, 25, 0,
  13, 22, 7, 18, 5, 9, 16, 24,
  2, 20, 12, 21, 1, 8, 15, 26,

  // inR => outR
  15, 4, 25, 19, 9, 1, 26, 16,
  5, 11, 23, 8, 12, 7, 17, 0,
  22, 3, 10, 14, 6, 20, 27, 24
];

exports.pc2 = function pc2(inL, inR, out, off) {
  var outL = 0;
  var outR = 0;

  var len = pc2table.length >>> 1;
  for (var i = 0; i < len; i++) {
    outL <<= 1;
    outL |= (inL >>> pc2table[i]) & 0x1;
  }
  for (var i = len; i < pc2table.length; i++) {
    outR <<= 1;
    outR |= (inR >>> pc2table[i]) & 0x1;
  }

  out[off + 0] = outL >>> 0;
  out[off + 1] = outR >>> 0;
};

exports.expand = function expand(r, out, off) {
  var outL = 0;
  var outR = 0;

  outL = ((r & 1) << 5) | (r >>> 27);
  for (var i = 23; i >= 15; i -= 4) {
    outL <<= 6;
    outL |= (r >>> i) & 0x3f;
  }
  for (var i = 11; i >= 3; i -= 4) {
    outR |= (r >>> i) & 0x3f;
    outR <<= 6;
  }
  outR |= ((r & 0x1f) << 1) | (r >>> 31);

  out[off + 0] = outL >>> 0;
  out[off + 1] = outR >>> 0;
};

var sTable = [
  14, 0, 4, 15, 13, 7, 1, 4, 2, 14, 15, 2, 11, 13, 8, 1,
  3, 10, 10, 6, 6, 12, 12, 11, 5, 9, 9, 5, 0, 3, 7, 8,
  4, 15, 1, 12, 14, 8, 8, 2, 13, 4, 6, 9, 2, 1, 11, 7,
  15, 5, 12, 11, 9, 3, 7, 14, 3, 10, 10, 0, 5, 6, 0, 13,

  15, 3, 1, 13, 8, 4, 14, 7, 6, 15, 11, 2, 3, 8, 4, 14,
  9, 12, 7, 0, 2, 1, 13, 10, 12, 6, 0, 9, 5, 11, 10, 5,
  0, 13, 14, 8, 7, 10, 11, 1, 10, 3, 4, 15, 13, 4, 1, 2,
  5, 11, 8, 6, 12, 7, 6, 12, 9, 0, 3, 5, 2, 14, 15, 9,

  10, 13, 0, 7, 9, 0, 14, 9, 6, 3, 3, 4, 15, 6, 5, 10,
  1, 2, 13, 8, 12, 5, 7, 14, 11, 12, 4, 11, 2, 15, 8, 1,
  13, 1, 6, 10, 4, 13, 9, 0, 8, 6, 15, 9, 3, 8, 0, 7,
  11, 4, 1, 15, 2, 14, 12, 3, 5, 11, 10, 5, 14, 2, 7, 12,

  7, 13, 13, 8, 14, 11, 3, 5, 0, 6, 6, 15, 9, 0, 10, 3,
  1, 4, 2, 7, 8, 2, 5, 12, 11, 1, 12, 10, 4, 14, 15, 9,
  10, 3, 6, 15, 9, 0, 0, 6, 12, 10, 11, 1, 7, 13, 13, 8,
  15, 9, 1, 4, 3, 5, 14, 11, 5, 12, 2, 7, 8, 2, 4, 14,

  2, 14, 12, 11, 4, 2, 1, 12, 7, 4, 10, 7, 11, 13, 6, 1,
  8, 5, 5, 0, 3, 15, 15, 10, 13, 3, 0, 9, 14, 8, 9, 6,
  4, 11, 2, 8, 1, 12, 11, 7, 10, 1, 13, 14, 7, 2, 8, 13,
  15, 6, 9, 15, 12, 0, 5, 9, 6, 10, 3, 4, 0, 5, 14, 3,

  12, 10, 1, 15, 10, 4, 15, 2, 9, 7, 2, 12, 6, 9, 8, 5,
  0, 6, 13, 1, 3, 13, 4, 14, 14, 0, 7, 11, 5, 3, 11, 8,
  9, 4, 14, 3, 15, 2, 5, 12, 2, 9, 8, 5, 12, 15, 3, 10,
  7, 11, 0, 14, 4, 1, 10, 7, 1, 6, 13, 0, 11, 8, 6, 13,

  4, 13, 11, 0, 2, 11, 14, 7, 15, 4, 0, 9, 8, 1, 13, 10,
  3, 14, 12, 3, 9, 5, 7, 12, 5, 2, 10, 15, 6, 8, 1, 6,
  1, 6, 4, 11, 11, 13, 13, 8, 12, 1, 3, 4, 7, 10, 14, 7,
  10, 9, 15, 5, 6, 0, 8, 15, 0, 14, 5, 2, 9, 3, 2, 12,

  13, 1, 2, 15, 8, 13, 4, 8, 6, 10, 15, 3, 11, 7, 1, 4,
  10, 12, 9, 5, 3, 6, 14, 11, 5, 0, 0, 14, 12, 9, 7, 2,
  7, 2, 11, 1, 4, 14, 1, 7, 9, 4, 12, 10, 14, 8, 2, 13,
  0, 15, 6, 12, 10, 9, 13, 0, 15, 3, 3, 5, 5, 6, 8, 11
];

exports.substitute = function substitute(inL, inR) {
  var out = 0;
  for (var i = 0; i < 4; i++) {
    var b = (inL >>> (18 - i * 6)) & 0x3f;
    var sb = sTable[i * 0x40 + b];

    out <<= 4;
    out |= sb;
  }
  for (var i = 0; i < 4; i++) {
    var b = (inR >>> (18 - i * 6)) & 0x3f;
    var sb = sTable[4 * 0x40 + i * 0x40 + b];

    out <<= 4;
    out |= sb;
  }
  return out >>> 0;
};

var permuteTable = [
  16, 25, 12, 11, 3, 20, 4, 15, 31, 17, 9, 6, 27, 14, 1, 22,
  30, 24, 8, 18, 0, 5, 29, 23, 13, 19, 2, 26, 10, 21, 28, 7
];

exports.permute = function permute(num) {
  var out = 0;
  for (var i = 0; i < permuteTable.length; i++) {
    out <<= 1;
    out |= (num >>> permuteTable[i]) & 0x1;
  }
  return out >>> 0;
};

exports.padSplit = function padSplit(num, size, group) {
  var str = num.toString(2);
  while (str.length < size)
    str = '0' + str;

  var out = [];
  for (var i = 0; i < size; i += group)
    out.push(str.slice(i, i + group));
  return out.join(' ');
};


/***/ }),

/***/ "./node_modules/diffie-hellman/browser.js":
/*!************************************************!*\
  !*** ./node_modules/diffie-hellman/browser.js ***!
  \************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(Buffer) {var generatePrime = __webpack_require__(/*! ./lib/generatePrime */ "./node_modules/diffie-hellman/lib/generatePrime.js")
var primes = __webpack_require__(/*! ./lib/primes.json */ "./node_modules/diffie-hellman/lib/primes.json")

var DH = __webpack_require__(/*! ./lib/dh */ "./node_modules/diffie-hellman/lib/dh.js")

function getDiffieHellman (mod) {
  var prime = new Buffer(primes[mod].prime, 'hex')
  var gen = new Buffer(primes[mod].gen, 'hex')

  return new DH(prime, gen)
}

var ENCODINGS = {
  'binary': true, 'hex': true, 'base64': true
}

function createDiffieHellman (prime, enc, generator, genc) {
  if (Buffer.isBuffer(enc) || ENCODINGS[enc] === undefined) {
    return createDiffieHellman(prime, 'binary', enc, generator)
  }

  enc = enc || 'binary'
  genc = genc || 'binary'
  generator = generator || new Buffer([2])

  if (!Buffer.isBuffer(generator)) {
    generator = new Buffer(generator, genc)
  }

  if (typeof prime === 'number') {
    return new DH(generatePrime(prime, generator), generator, true)
  }

  if (!Buffer.isBuffer(prime)) {
    prime = new Buffer(prime, enc)
  }

  return new DH(prime, generator, true)
}

exports.DiffieHellmanGroup = exports.createDiffieHellmanGroup = exports.getDiffieHellman = getDiffieHellman
exports.createDiffieHellman = exports.DiffieHellman = createDiffieHellman

/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(/*! ./../node-libs-browser/node_modules/buffer/index.js */ "./node_modules/node-libs-browser/node_modules/buffer/index.js").Buffer))

/***/ }),

/***/ "./node_modules/diffie-hellman/lib/dh.js":
/*!***********************************************!*\
  !*** ./node_modules/diffie-hellman/lib/dh.js ***!
  \***********************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(Buffer) {var BN = __webpack_require__(/*! bn.js */ "./node_modules/diffie-hellman/node_modules/bn.js/lib/bn.js");
var MillerRabin = __webpack_require__(/*! miller-rabin */ "./node_modules/miller-rabin/lib/mr.js");
var millerRabin = new MillerRabin();
var TWENTYFOUR = new BN(24);
var ELEVEN = new BN(11);
var TEN = new BN(10);
var THREE = new BN(3);
var SEVEN = new BN(7);
var primes = __webpack_require__(/*! ./generatePrime */ "./node_modules/diffie-hellman/lib/generatePrime.js");
var randomBytes = __webpack_require__(/*! randombytes */ "./node_modules/randombytes/browser.js");
module.exports = DH;

function setPublicKey(pub, enc) {
  enc = enc || 'utf8';
  if (!Buffer.isBuffer(pub)) {
    pub = new Buffer(pub, enc);
  }
  this._pub = new BN(pub);
  return this;
}

function setPrivateKey(priv, enc) {
  enc = enc || 'utf8';
  if (!Buffer.isBuffer(priv)) {
    priv = new Buffer(priv, enc);
  }
  this._priv = new BN(priv);
  return this;
}

var primeCache = {};
function checkPrime(prime, generator) {
  var gen = generator.toString('hex');
  var hex = [gen, prime.toString(16)].join('_');
  if (hex in primeCache) {
    return primeCache[hex];
  }
  var error = 0;

  if (prime.isEven() ||
    !primes.simpleSieve ||
    !primes.fermatTest(prime) ||
    !millerRabin.test(prime)) {
    //not a prime so +1
    error += 1;

    if (gen === '02' || gen === '05') {
      // we'd be able to check the generator
      // it would fail so +8
      error += 8;
    } else {
      //we wouldn't be able to test the generator
      // so +4
      error += 4;
    }
    primeCache[hex] = error;
    return error;
  }
  if (!millerRabin.test(prime.shrn(1))) {
    //not a safe prime
    error += 2;
  }
  var rem;
  switch (gen) {
    case '02':
      if (prime.mod(TWENTYFOUR).cmp(ELEVEN)) {
        // unsuidable generator
        error += 8;
      }
      break;
    case '05':
      rem = prime.mod(TEN);
      if (rem.cmp(THREE) && rem.cmp(SEVEN)) {
        // prime mod 10 needs to equal 3 or 7
        error += 8;
      }
      break;
    default:
      error += 4;
  }
  primeCache[hex] = error;
  return error;
}

function DH(prime, generator, malleable) {
  this.setGenerator(generator);
  this.__prime = new BN(prime);
  this._prime = BN.mont(this.__prime);
  this._primeLen = prime.length;
  this._pub = undefined;
  this._priv = undefined;
  this._primeCode = undefined;
  if (malleable) {
    this.setPublicKey = setPublicKey;
    this.setPrivateKey = setPrivateKey;
  } else {
    this._primeCode = 8;
  }
}
Object.defineProperty(DH.prototype, 'verifyError', {
  enumerable: true,
  get: function () {
    if (typeof this._primeCode !== 'number') {
      this._primeCode = checkPrime(this.__prime, this.__gen);
    }
    return this._primeCode;
  }
});
DH.prototype.generateKeys = function () {
  if (!this._priv) {
    this._priv = new BN(randomBytes(this._primeLen));
  }
  this._pub = this._gen.toRed(this._prime).redPow(this._priv).fromRed();
  return this.getPublicKey();
};

DH.prototype.computeSecret = function (other) {
  other = new BN(other);
  other = other.toRed(this._prime);
  var secret = other.redPow(this._priv).fromRed();
  var out = new Buffer(secret.toArray());
  var prime = this.getPrime();
  if (out.length < prime.length) {
    var front = new Buffer(prime.length - out.length);
    front.fill(0);
    out = Buffer.concat([front, out]);
  }
  return out;
};

DH.prototype.getPublicKey = function getPublicKey(enc) {
  return formatReturnValue(this._pub, enc);
};

DH.prototype.getPrivateKey = function getPrivateKey(enc) {
  return formatReturnValue(this._priv, enc);
};

DH.prototype.getPrime = function (enc) {
  return formatReturnValue(this.__prime, enc);
};

DH.prototype.getGenerator = function (enc) {
  return formatReturnValue(this._gen, enc);
};

DH.prototype.setGenerator = function (gen, enc) {
  enc = enc || 'utf8';
  if (!Buffer.isBuffer(gen)) {
    gen = new Buffer(gen, enc);
  }
  this.__gen = gen;
  this._gen = new BN(gen);
  return this;
};

function formatReturnValue(bn, enc) {
  var buf = new Buffer(bn.toArray());
  if (!enc) {
    return buf;
  } else {
    return buf.toString(enc);
  }
}

/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(/*! ./../../node-libs-browser/node_modules/buffer/index.js */ "./node_modules/node-libs-browser/node_modules/buffer/index.js").Buffer))

/***/ }),

/***/ "./node_modules/diffie-hellman/lib/generatePrime.js":
/*!**********************************************************!*\
  !*** ./node_modules/diffie-hellman/lib/generatePrime.js ***!
  \**********************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var randomBytes = __webpack_require__(/*! randombytes */ "./node_modules/randombytes/browser.js");
module.exports = findPrime;
findPrime.simpleSieve = simpleSieve;
findPrime.fermatTest = fermatTest;
var BN = __webpack_require__(/*! bn.js */ "./node_modules/diffie-hellman/node_modules/bn.js/lib/bn.js");
var TWENTYFOUR = new BN(24);
var MillerRabin = __webpack_require__(/*! miller-rabin */ "./node_modules/miller-rabin/lib/mr.js");
var millerRabin = new MillerRabin();
var ONE = new BN(1);
var TWO = new BN(2);
var FIVE = new BN(5);
var SIXTEEN = new BN(16);
var EIGHT = new BN(8);
var TEN = new BN(10);
var THREE = new BN(3);
var SEVEN = new BN(7);
var ELEVEN = new BN(11);
var FOUR = new BN(4);
var TWELVE = new BN(12);
var primes = null;

function _getPrimes() {
  if (primes !== null)
    return primes;

  var limit = 0x100000;
  var res = [];
  res[0] = 2;
  for (var i = 1, k = 3; k < limit; k += 2) {
    var sqrt = Math.ceil(Math.sqrt(k));
    for (var j = 0; j < i && res[j] <= sqrt; j++)
      if (k % res[j] === 0)
        break;

    if (i !== j && res[j] <= sqrt)
      continue;

    res[i++] = k;
  }
  primes = res;
  return res;
}

function simpleSieve(p) {
  var primes = _getPrimes();

  for (var i = 0; i < primes.length; i++)
    if (p.modn(primes[i]) === 0) {
      if (p.cmpn(primes[i]) === 0) {
        return true;
      } else {
        return false;
      }
    }

  return true;
}

function fermatTest(p) {
  var red = BN.mont(p);
  return TWO.toRed(red).redPow(p.subn(1)).fromRed().cmpn(1) === 0;
}

function findPrime(bits, gen) {
  if (bits < 16) {
    // this is what openssl does
    if (gen === 2 || gen === 5) {
      return new BN([0x8c, 0x7b]);
    } else {
      return new BN([0x8c, 0x27]);
    }
  }
  gen = new BN(gen);

  var num, n2;

  while (true) {
    num = new BN(randomBytes(Math.ceil(bits / 8)));
    while (num.bitLength() > bits) {
      num.ishrn(1);
    }
    if (num.isEven()) {
      num.iadd(ONE);
    }
    if (!num.testn(1)) {
      num.iadd(TWO);
    }
    if (!gen.cmp(TWO)) {
      while (num.mod(TWENTYFOUR).cmp(ELEVEN)) {
        num.iadd(FOUR);
      }
    } else if (!gen.cmp(FIVE)) {
      while (num.mod(TEN).cmp(THREE)) {
        num.iadd(FOUR);
      }
    }
    n2 = num.shrn(1);
    if (simpleSieve(n2) && simpleSieve(num) &&
      fermatTest(n2) && fermatTest(num) &&
      millerRabin.test(n2) && millerRabin.test(num)) {
      return num;
    }
  }

}


/***/ }),

/***/ "./node_modules/diffie-hellman/lib/primes.json":
/*!*****************************************************!*\
  !*** ./node_modules/diffie-hellman/lib/primes.json ***!
  \*****************************************************/
/*! exports provided: modp1, modp2, modp5, modp14, modp15, modp16, modp17, modp18, default */
/***/ (function(module) {

module.exports = JSON.parse("{\"modp1\":{\"gen\":\"02\",\"prime\":\"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a63a3620ffffffffffffffff\"},\"modp2\":{\"gen\":\"02\",\"prime\":\"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece65381ffffffffffffffff\"},\"modp5\":{\"gen\":\"02\",\"prime\":\"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca237327ffffffffffffffff\"},\"modp14\":{\"gen\":\"02\",\"prime\":\"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aacaa68ffffffffffffffff\"},\"modp15\":{\"gen\":\"02\",\"prime\":\"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a93ad2caffffffffffffffff\"},\"modp16\":{\"gen\":\"02\",\"prime\":\"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a92108011a723c12a787e6d788719a10bdba5b2699c327186af4e23c1a946834b6150bda2583e9ca2ad44ce8dbbbc2db04de8ef92e8efc141fbecaa6287c59474e6bc05d99b2964fa090c3a2233ba186515be7ed1f612970cee2d7afb81bdd762170481cd0069127d5b05aa993b4ea988d8fddc186ffb7dc90a6c08f4df435c934063199ffffffffffffffff\"},\"modp17\":{\"gen\":\"02\",\"prime\":\"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a92108011a723c12a787e6d788719a10bdba5b2699c327186af4e23c1a946834b6150bda2583e9ca2ad44ce8dbbbc2db04de8ef92e8efc141fbecaa6287c59474e6bc05d99b2964fa090c3a2233ba186515be7ed1f612970cee2d7afb81bdd762170481cd0069127d5b05aa993b4ea988d8fddc186ffb7dc90a6c08f4df435c93402849236c3fab4d27c7026c1d4dcb2602646dec9751e763dba37bdf8ff9406ad9e530ee5db382f413001aeb06a53ed9027d831179727b0865a8918da3edbebcf9b14ed44ce6cbaced4bb1bdb7f1447e6cc254b332051512bd7af426fb8f401378cd2bf5983ca01c64b92ecf032ea15d1721d03f482d7ce6e74fef6d55e702f46980c82b5a84031900b1c9e59e7c97fbec7e8f323a97a7e36cc88be0f1d45b7ff585ac54bd407b22b4154aacc8f6d7ebf48e1d814cc5ed20f8037e0a79715eef29be32806a1d58bb7c5da76f550aa3d8a1fbff0eb19ccb1a313d55cda56c9ec2ef29632387fe8d76e3c0468043e8f663f4860ee12bf2d5b0b7474d6e694f91e6dcc4024ffffffffffffffff\"},\"modp18\":{\"gen\":\"02\",\"prime\":\"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\"}}");

/***/ }),

/***/ "./node_modules/diffie-hellman/node_modules/bn.js/lib/bn.js":
/*!******************************************************************!*\
  !*** ./node_modules/diffie-hellman/node_modules/bn.js/lib/bn.js ***!
  \******************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {(function (module, exports) {
  'use strict';

  // Utils
  function assert (val, msg) {
    if (!val) throw new Error(msg || 'Assertion failed');
  }

  // Could use `inherits` module, but don't want to move from single file
  // architecture yet.
  function inherits (ctor, superCtor) {
    ctor.super_ = superCtor;
    var TempCtor = function () {};
    TempCtor.prototype = superCtor.prototype;
    ctor.prototype = new TempCtor();
    ctor.prototype.constructor = ctor;
  }

  // BN

  function BN (number, base, endian) {
    if (BN.isBN(number)) {
      return number;
    }

    this.negative = 0;
    this.words = null;
    this.length = 0;

    // Reduction context
    this.red = null;

    if (number !== null) {
      if (base === 'le' || base === 'be') {
        endian = base;
        base = 10;
      }

      this._init(number || 0, base || 10, endian || 'be');
    }
  }
  if (typeof module === 'object') {
    module.exports = BN;
  } else {
    exports.BN = BN;
  }

  BN.BN = BN;
  BN.wordSize = 26;

  var Buffer;
  try {
    Buffer = __webpack_require__(/*! buffer */ 4).Buffer;
  } catch (e) {
  }

  BN.isBN = function isBN (num) {
    if (num instanceof BN) {
      return true;
    }

    return num !== null && typeof num === 'object' &&
      num.constructor.wordSize === BN.wordSize && Array.isArray(num.words);
  };

  BN.max = function max (left, right) {
    if (left.cmp(right) > 0) return left;
    return right;
  };

  BN.min = function min (left, right) {
    if (left.cmp(right) < 0) return left;
    return right;
  };

  BN.prototype._init = function init (number, base, endian) {
    if (typeof number === 'number') {
      return this._initNumber(number, base, endian);
    }

    if (typeof number === 'object') {
      return this._initArray(number, base, endian);
    }

    if (base === 'hex') {
      base = 16;
    }
    assert(base === (base | 0) && base >= 2 && base <= 36);

    number = number.toString().replace(/\s+/g, '');
    var start = 0;
    if (number[0] === '-') {
      start++;
    }

    if (base === 16) {
      this._parseHex(number, start);
    } else {
      this._parseBase(number, base, start);
    }

    if (number[0] === '-') {
      this.negative = 1;
    }

    this.strip();

    if (endian !== 'le') return;

    this._initArray(this.toArray(), base, endian);
  };

  BN.prototype._initNumber = function _initNumber (number, base, endian) {
    if (number < 0) {
      this.negative = 1;
      number = -number;
    }
    if (number < 0x4000000) {
      this.words = [ number & 0x3ffffff ];
      this.length = 1;
    } else if (number < 0x10000000000000) {
      this.words = [
        number & 0x3ffffff,
        (number / 0x4000000) & 0x3ffffff
      ];
      this.length = 2;
    } else {
      assert(number < 0x20000000000000); // 2 ^ 53 (unsafe)
      this.words = [
        number & 0x3ffffff,
        (number / 0x4000000) & 0x3ffffff,
        1
      ];
      this.length = 3;
    }

    if (endian !== 'le') return;

    // Reverse the bytes
    this._initArray(this.toArray(), base, endian);
  };

  BN.prototype._initArray = function _initArray (number, base, endian) {
    // Perhaps a Uint8Array
    assert(typeof number.length === 'number');
    if (number.length <= 0) {
      this.words = [ 0 ];
      this.length = 1;
      return this;
    }

    this.length = Math.ceil(number.length / 3);
    this.words = new Array(this.length);
    for (var i = 0; i < this.length; i++) {
      this.words[i] = 0;
    }

    var j, w;
    var off = 0;
    if (endian === 'be') {
      for (i = number.length - 1, j = 0; i >= 0; i -= 3) {
        w = number[i] | (number[i - 1] << 8) | (number[i - 2] << 16);
        this.words[j] |= (w << off) & 0x3ffffff;
        this.words[j + 1] = (w >>> (26 - off)) & 0x3ffffff;
        off += 24;
        if (off >= 26) {
          off -= 26;
          j++;
        }
      }
    } else if (endian === 'le') {
      for (i = 0, j = 0; i < number.length; i += 3) {
        w = number[i] | (number[i + 1] << 8) | (number[i + 2] << 16);
        this.words[j] |= (w << off) & 0x3ffffff;
        this.words[j + 1] = (w >>> (26 - off)) & 0x3ffffff;
        off += 24;
        if (off >= 26) {
          off -= 26;
          j++;
        }
      }
    }
    return this.strip();
  };

  function parseHex (str, start, end) {
    var r = 0;
    var len = Math.min(str.length, end);
    for (var i = start; i < len; i++) {
      var c = str.charCodeAt(i) - 48;

      r <<= 4;

      // 'a' - 'f'
      if (c >= 49 && c <= 54) {
        r |= c - 49 + 0xa;

      // 'A' - 'F'
      } else if (c >= 17 && c <= 22) {
        r |= c - 17 + 0xa;

      // '0' - '9'
      } else {
        r |= c & 0xf;
      }
    }
    return r;
  }

  BN.prototype._parseHex = function _parseHex (number, start) {
    // Create possibly bigger array to ensure that it fits the number
    this.length = Math.ceil((number.length - start) / 6);
    this.words = new Array(this.length);
    for (var i = 0; i < this.length; i++) {
      this.words[i] = 0;
    }

    var j, w;
    // Scan 24-bit chunks and add them to the number
    var off = 0;
    for (i = number.length - 6, j = 0; i >= start; i -= 6) {
      w = parseHex(number, i, i + 6);
      this.words[j] |= (w << off) & 0x3ffffff;
      // NOTE: `0x3fffff` is intentional here, 26bits max shift + 24bit hex limb
      this.words[j + 1] |= w >>> (26 - off) & 0x3fffff;
      off += 24;
      if (off >= 26) {
        off -= 26;
        j++;
      }
    }
    if (i + 6 !== start) {
      w = parseHex(number, start, i + 6);
      this.words[j] |= (w << off) & 0x3ffffff;
      this.words[j + 1] |= w >>> (26 - off) & 0x3fffff;
    }
    this.strip();
  };

  function parseBase (str, start, end, mul) {
    var r = 0;
    var len = Math.min(str.length, end);
    for (var i = start; i < len; i++) {
      var c = str.charCodeAt(i) - 48;

      r *= mul;

      // 'a'
      if (c >= 49) {
        r += c - 49 + 0xa;

      // 'A'
      } else if (c >= 17) {
        r += c - 17 + 0xa;

      // '0' - '9'
      } else {
        r += c;
      }
    }
    return r;
  }

  BN.prototype._parseBase = function _parseBase (number, base, start) {
    // Initialize as zero
    this.words = [ 0 ];
    this.length = 1;

    // Find length of limb in base
    for (var limbLen = 0, limbPow = 1; limbPow <= 0x3ffffff; limbPow *= base) {
      limbLen++;
    }
    limbLen--;
    limbPow = (limbPow / base) | 0;

    var total = number.length - start;
    var mod = total % limbLen;
    var end = Math.min(total, total - mod) + start;

    var word = 0;
    for (var i = start; i < end; i += limbLen) {
      word = parseBase(number, i, i + limbLen, base);

      this.imuln(limbPow);
      if (this.words[0] + word < 0x4000000) {
        this.words[0] += word;
      } else {
        this._iaddn(word);
      }
    }

    if (mod !== 0) {
      var pow = 1;
      word = parseBase(number, i, number.length, base);

      for (i = 0; i < mod; i++) {
        pow *= base;
      }

      this.imuln(pow);
      if (this.words[0] + word < 0x4000000) {
        this.words[0] += word;
      } else {
        this._iaddn(word);
      }
    }
  };

  BN.prototype.copy = function copy (dest) {
    dest.words = new Array(this.length);
    for (var i = 0; i < this.length; i++) {
      dest.words[i] = this.words[i];
    }
    dest.length = this.length;
    dest.negative = this.negative;
    dest.red = this.red;
  };

  BN.prototype.clone = function clone () {
    var r = new BN(null);
    this.copy(r);
    return r;
  };

  BN.prototype._expand = function _expand (size) {
    while (this.length < size) {
      this.words[this.length++] = 0;
    }
    return this;
  };

  // Remove leading `0` from `this`
  BN.prototype.strip = function strip () {
    while (this.length > 1 && this.words[this.length - 1] === 0) {
      this.length--;
    }
    return this._normSign();
  };

  BN.prototype._normSign = function _normSign () {
    // -0 = 0
    if (this.length === 1 && this.words[0] === 0) {
      this.negative = 0;
    }
    return this;
  };

  BN.prototype.inspect = function inspect () {
    return (this.red ? '<BN-R: ' : '<BN: ') + this.toString(16) + '>';
  };

  /*

  var zeros = [];
  var groupSizes = [];
  var groupBases = [];

  var s = '';
  var i = -1;
  while (++i < BN.wordSize) {
    zeros[i] = s;
    s += '0';
  }
  groupSizes[0] = 0;
  groupSizes[1] = 0;
  groupBases[0] = 0;
  groupBases[1] = 0;
  var base = 2 - 1;
  while (++base < 36 + 1) {
    var groupSize = 0;
    var groupBase = 1;
    while (groupBase < (1 << BN.wordSize) / base) {
      groupBase *= base;
      groupSize += 1;
    }
    groupSizes[base] = groupSize;
    groupBases[base] = groupBase;
  }

  */

  var zeros = [
    '',
    '0',
    '00',
    '000',
    '0000',
    '00000',
    '000000',
    '0000000',
    '00000000',
    '000000000',
    '0000000000',
    '00000000000',
    '000000000000',
    '0000000000000',
    '00000000000000',
    '000000000000000',
    '0000000000000000',
    '00000000000000000',
    '000000000000000000',
    '0000000000000000000',
    '00000000000000000000',
    '000000000000000000000',
    '0000000000000000000000',
    '00000000000000000000000',
    '000000000000000000000000',
    '0000000000000000000000000'
  ];

  var groupSizes = [
    0, 0,
    25, 16, 12, 11, 10, 9, 8,
    8, 7, 7, 7, 7, 6, 6,
    6, 6, 6, 6, 6, 5, 5,
    5, 5, 5, 5, 5, 5, 5,
    5, 5, 5, 5, 5, 5, 5
  ];

  var groupBases = [
    0, 0,
    33554432, 43046721, 16777216, 48828125, 60466176, 40353607, 16777216,
    43046721, 10000000, 19487171, 35831808, 62748517, 7529536, 11390625,
    16777216, 24137569, 34012224, 47045881, 64000000, 4084101, 5153632,
    6436343, 7962624, 9765625, 11881376, 14348907, 17210368, 20511149,
    24300000, 28629151, 33554432, 39135393, 45435424, 52521875, 60466176
  ];

  BN.prototype.toString = function toString (base, padding) {
    base = base || 10;
    padding = padding | 0 || 1;

    var out;
    if (base === 16 || base === 'hex') {
      out = '';
      var off = 0;
      var carry = 0;
      for (var i = 0; i < this.length; i++) {
        var w = this.words[i];
        var word = (((w << off) | carry) & 0xffffff).toString(16);
        carry = (w >>> (24 - off)) & 0xffffff;
        if (carry !== 0 || i !== this.length - 1) {
          out = zeros[6 - word.length] + word + out;
        } else {
          out = word + out;
        }
        off += 2;
        if (off >= 26) {
          off -= 26;
          i--;
        }
      }
      if (carry !== 0) {
        out = carry.toString(16) + out;
      }
      while (out.length % padding !== 0) {
        out = '0' + out;
      }
      if (this.negative !== 0) {
        out = '-' + out;
      }
      return out;
    }

    if (base === (base | 0) && base >= 2 && base <= 36) {
      // var groupSize = Math.floor(BN.wordSize * Math.LN2 / Math.log(base));
      var groupSize = groupSizes[base];
      // var groupBase = Math.pow(base, groupSize);
      var groupBase = groupBases[base];
      out = '';
      var c = this.clone();
      c.negative = 0;
      while (!c.isZero()) {
        var r = c.modn(groupBase).toString(base);
        c = c.idivn(groupBase);

        if (!c.isZero()) {
          out = zeros[groupSize - r.length] + r + out;
        } else {
          out = r + out;
        }
      }
      if (this.isZero()) {
        out = '0' + out;
      }
      while (out.length % padding !== 0) {
        out = '0' + out;
      }
      if (this.negative !== 0) {
        out = '-' + out;
      }
      return out;
    }

    assert(false, 'Base should be between 2 and 36');
  };

  BN.prototype.toNumber = function toNumber () {
    var ret = this.words[0];
    if (this.length === 2) {
      ret += this.words[1] * 0x4000000;
    } else if (this.length === 3 && this.words[2] === 0x01) {
      // NOTE: at this stage it is known that the top bit is set
      ret += 0x10000000000000 + (this.words[1] * 0x4000000);
    } else if (this.length > 2) {
      assert(false, 'Number can only safely store up to 53 bits');
    }
    return (this.negative !== 0) ? -ret : ret;
  };

  BN.prototype.toJSON = function toJSON () {
    return this.toString(16);
  };

  BN.prototype.toBuffer = function toBuffer (endian, length) {
    assert(typeof Buffer !== 'undefined');
    return this.toArrayLike(Buffer, endian, length);
  };

  BN.prototype.toArray = function toArray (endian, length) {
    return this.toArrayLike(Array, endian, length);
  };

  BN.prototype.toArrayLike = function toArrayLike (ArrayType, endian, length) {
    var byteLength = this.byteLength();
    var reqLength = length || Math.max(1, byteLength);
    assert(byteLength <= reqLength, 'byte array longer than desired length');
    assert(reqLength > 0, 'Requested array length <= 0');

    this.strip();
    var littleEndian = endian === 'le';
    var res = new ArrayType(reqLength);

    var b, i;
    var q = this.clone();
    if (!littleEndian) {
      // Assume big-endian
      for (i = 0; i < reqLength - byteLength; i++) {
        res[i] = 0;
      }

      for (i = 0; !q.isZero(); i++) {
        b = q.andln(0xff);
        q.iushrn(8);

        res[reqLength - i - 1] = b;
      }
    } else {
      for (i = 0; !q.isZero(); i++) {
        b = q.andln(0xff);
        q.iushrn(8);

        res[i] = b;
      }

      for (; i < reqLength; i++) {
        res[i] = 0;
      }
    }

    return res;
  };

  if (Math.clz32) {
    BN.prototype._countBits = function _countBits (w) {
      return 32 - Math.clz32(w);
    };
  } else {
    BN.prototype._countBits = function _countBits (w) {
      var t = w;
      var r = 0;
      if (t >= 0x1000) {
        r += 13;
        t >>>= 13;
      }
      if (t >= 0x40) {
        r += 7;
        t >>>= 7;
      }
      if (t >= 0x8) {
        r += 4;
        t >>>= 4;
      }
      if (t >= 0x02) {
        r += 2;
        t >>>= 2;
      }
      return r + t;
    };
  }

  BN.prototype._zeroBits = function _zeroBits (w) {
    // Short-cut
    if (w === 0) return 26;

    var t = w;
    var r = 0;
    if ((t & 0x1fff) === 0) {
      r += 13;
      t >>>= 13;
    }
    if ((t & 0x7f) === 0) {
      r += 7;
      t >>>= 7;
    }
    if ((t & 0xf) === 0) {
      r += 4;
      t >>>= 4;
    }
    if ((t & 0x3) === 0) {
      r += 2;
      t >>>= 2;
    }
    if ((t & 0x1) === 0) {
      r++;
    }
    return r;
  };

  // Return number of used bits in a BN
  BN.prototype.bitLength = function bitLength () {
    var w = this.words[this.length - 1];
    var hi = this._countBits(w);
    return (this.length - 1) * 26 + hi;
  };

  function toBitArray (num) {
    var w = new Array(num.bitLength());

    for (var bit = 0; bit < w.length; bit++) {
      var off = (bit / 26) | 0;
      var wbit = bit % 26;

      w[bit] = (num.words[off] & (1 << wbit)) >>> wbit;
    }

    return w;
  }

  // Number of trailing zero bits
  BN.prototype.zeroBits = function zeroBits () {
    if (this.isZero()) return 0;

    var r = 0;
    for (var i = 0; i < this.length; i++) {
      var b = this._zeroBits(this.words[i]);
      r += b;
      if (b !== 26) break;
    }
    return r;
  };

  BN.prototype.byteLength = function byteLength () {
    return Math.ceil(this.bitLength() / 8);
  };

  BN.prototype.toTwos = function toTwos (width) {
    if (this.negative !== 0) {
      return this.abs().inotn(width).iaddn(1);
    }
    return this.clone();
  };

  BN.prototype.fromTwos = function fromTwos (width) {
    if (this.testn(width - 1)) {
      return this.notn(width).iaddn(1).ineg();
    }
    return this.clone();
  };

  BN.prototype.isNeg = function isNeg () {
    return this.negative !== 0;
  };

  // Return negative clone of `this`
  BN.prototype.neg = function neg () {
    return this.clone().ineg();
  };

  BN.prototype.ineg = function ineg () {
    if (!this.isZero()) {
      this.negative ^= 1;
    }

    return this;
  };

  // Or `num` with `this` in-place
  BN.prototype.iuor = function iuor (num) {
    while (this.length < num.length) {
      this.words[this.length++] = 0;
    }

    for (var i = 0; i < num.length; i++) {
      this.words[i] = this.words[i] | num.words[i];
    }

    return this.strip();
  };

  BN.prototype.ior = function ior (num) {
    assert((this.negative | num.negative) === 0);
    return this.iuor(num);
  };

  // Or `num` with `this`
  BN.prototype.or = function or (num) {
    if (this.length > num.length) return this.clone().ior(num);
    return num.clone().ior(this);
  };

  BN.prototype.uor = function uor (num) {
    if (this.length > num.length) return this.clone().iuor(num);
    return num.clone().iuor(this);
  };

  // And `num` with `this` in-place
  BN.prototype.iuand = function iuand (num) {
    // b = min-length(num, this)
    var b;
    if (this.length > num.length) {
      b = num;
    } else {
      b = this;
    }

    for (var i = 0; i < b.length; i++) {
      this.words[i] = this.words[i] & num.words[i];
    }

    this.length = b.length;

    return this.strip();
  };

  BN.prototype.iand = function iand (num) {
    assert((this.negative | num.negative) === 0);
    return this.iuand(num);
  };

  // And `num` with `this`
  BN.prototype.and = function and (num) {
    if (this.length > num.length) return this.clone().iand(num);
    return num.clone().iand(this);
  };

  BN.prototype.uand = function uand (num) {
    if (this.length > num.length) return this.clone().iuand(num);
    return num.clone().iuand(this);
  };

  // Xor `num` with `this` in-place
  BN.prototype.iuxor = function iuxor (num) {
    // a.length > b.length
    var a;
    var b;
    if (this.length > num.length) {
      a = this;
      b = num;
    } else {
      a = num;
      b = this;
    }

    for (var i = 0; i < b.length; i++) {
      this.words[i] = a.words[i] ^ b.words[i];
    }

    if (this !== a) {
      for (; i < a.length; i++) {
        this.words[i] = a.words[i];
      }
    }

    this.length = a.length;

    return this.strip();
  };

  BN.prototype.ixor = function ixor (num) {
    assert((this.negative | num.negative) === 0);
    return this.iuxor(num);
  };

  // Xor `num` with `this`
  BN.prototype.xor = function xor (num) {
    if (this.length > num.length) return this.clone().ixor(num);
    return num.clone().ixor(this);
  };

  BN.prototype.uxor = function uxor (num) {
    if (this.length > num.length) return this.clone().iuxor(num);
    return num.clone().iuxor(this);
  };

  // Not ``this`` with ``width`` bitwidth
  BN.prototype.inotn = function inotn (width) {
    assert(typeof width === 'number' && width >= 0);

    var bytesNeeded = Math.ceil(width / 26) | 0;
    var bitsLeft = width % 26;

    // Extend the buffer with leading zeroes
    this._expand(bytesNeeded);

    if (bitsLeft > 0) {
      bytesNeeded--;
    }

    // Handle complete words
    for (var i = 0; i < bytesNeeded; i++) {
      this.words[i] = ~this.words[i] & 0x3ffffff;
    }

    // Handle the residue
    if (bitsLeft > 0) {
      this.words[i] = ~this.words[i] & (0x3ffffff >> (26 - bitsLeft));
    }

    // And remove leading zeroes
    return this.strip();
  };

  BN.prototype.notn = function notn (width) {
    return this.clone().inotn(width);
  };

  // Set `bit` of `this`
  BN.prototype.setn = function setn (bit, val) {
    assert(typeof bit === 'number' && bit >= 0);

    var off = (bit / 26) | 0;
    var wbit = bit % 26;

    this._expand(off + 1);

    if (val) {
      this.words[off] = this.words[off] | (1 << wbit);
    } else {
      this.words[off] = this.words[off] & ~(1 << wbit);
    }

    return this.strip();
  };

  // Add `num` to `this` in-place
  BN.prototype.iadd = function iadd (num) {
    var r;

    // negative + positive
    if (this.negative !== 0 && num.negative === 0) {
      this.negative = 0;
      r = this.isub(num);
      this.negative ^= 1;
      return this._normSign();

    // positive + negative
    } else if (this.negative === 0 && num.negative !== 0) {
      num.negative = 0;
      r = this.isub(num);
      num.negative = 1;
      return r._normSign();
    }

    // a.length > b.length
    var a, b;
    if (this.length > num.length) {
      a = this;
      b = num;
    } else {
      a = num;
      b = this;
    }

    var carry = 0;
    for (var i = 0; i < b.length; i++) {
      r = (a.words[i] | 0) + (b.words[i] | 0) + carry;
      this.words[i] = r & 0x3ffffff;
      carry = r >>> 26;
    }
    for (; carry !== 0 && i < a.length; i++) {
      r = (a.words[i] | 0) + carry;
      this.words[i] = r & 0x3ffffff;
      carry = r >>> 26;
    }

    this.length = a.length;
    if (carry !== 0) {
      this.words[this.length] = carry;
      this.length++;
    // Copy the rest of the words
    } else if (a !== this) {
      for (; i < a.length; i++) {
        this.words[i] = a.words[i];
      }
    }

    return this;
  };

  // Add `num` to `this`
  BN.prototype.add = function add (num) {
    var res;
    if (num.negative !== 0 && this.negative === 0) {
      num.negative = 0;
      res = this.sub(num);
      num.negative ^= 1;
      return res;
    } else if (num.negative === 0 && this.negative !== 0) {
      this.negative = 0;
      res = num.sub(this);
      this.negative = 1;
      return res;
    }

    if (this.length > num.length) return this.clone().iadd(num);

    return num.clone().iadd(this);
  };

  // Subtract `num` from `this` in-place
  BN.prototype.isub = function isub (num) {
    // this - (-num) = this + num
    if (num.negative !== 0) {
      num.negative = 0;
      var r = this.iadd(num);
      num.negative = 1;
      return r._normSign();

    // -this - num = -(this + num)
    } else if (this.negative !== 0) {
      this.negative = 0;
      this.iadd(num);
      this.negative = 1;
      return this._normSign();
    }

    // At this point both numbers are positive
    var cmp = this.cmp(num);

    // Optimization - zeroify
    if (cmp === 0) {
      this.negative = 0;
      this.length = 1;
      this.words[0] = 0;
      return this;
    }

    // a > b
    var a, b;
    if (cmp > 0) {
      a = this;
      b = num;
    } else {
      a = num;
      b = this;
    }

    var carry = 0;
    for (var i = 0; i < b.length; i++) {
      r = (a.words[i] | 0) - (b.words[i] | 0) + carry;
      carry = r >> 26;
      this.words[i] = r & 0x3ffffff;
    }
    for (; carry !== 0 && i < a.length; i++) {
      r = (a.words[i] | 0) + carry;
      carry = r >> 26;
      this.words[i] = r & 0x3ffffff;
    }

    // Copy rest of the words
    if (carry === 0 && i < a.length && a !== this) {
      for (; i < a.length; i++) {
        this.words[i] = a.words[i];
      }
    }

    this.length = Math.max(this.length, i);

    if (a !== this) {
      this.negative = 1;
    }

    return this.strip();
  };

  // Subtract `num` from `this`
  BN.prototype.sub = function sub (num) {
    return this.clone().isub(num);
  };

  function smallMulTo (self, num, out) {
    out.negative = num.negative ^ self.negative;
    var len = (self.length + num.length) | 0;
    out.length = len;
    len = (len - 1) | 0;

    // Peel one iteration (compiler can't do it, because of code complexity)
    var a = self.words[0] | 0;
    var b = num.words[0] | 0;
    var r = a * b;

    var lo = r & 0x3ffffff;
    var carry = (r / 0x4000000) | 0;
    out.words[0] = lo;

    for (var k = 1; k < len; k++) {
      // Sum all words with the same `i + j = k` and accumulate `ncarry`,
      // note that ncarry could be >= 0x3ffffff
      var ncarry = carry >>> 26;
      var rword = carry & 0x3ffffff;
      var maxJ = Math.min(k, num.length - 1);
      for (var j = Math.max(0, k - self.length + 1); j <= maxJ; j++) {
        var i = (k - j) | 0;
        a = self.words[i] | 0;
        b = num.words[j] | 0;
        r = a * b + rword;
        ncarry += (r / 0x4000000) | 0;
        rword = r & 0x3ffffff;
      }
      out.words[k] = rword | 0;
      carry = ncarry | 0;
    }
    if (carry !== 0) {
      out.words[k] = carry | 0;
    } else {
      out.length--;
    }

    return out.strip();
  }

  // TODO(indutny): it may be reasonable to omit it for users who don't need
  // to work with 256-bit numbers, otherwise it gives 20% improvement for 256-bit
  // multiplication (like elliptic secp256k1).
  var comb10MulTo = function comb10MulTo (self, num, out) {
    var a = self.words;
    var b = num.words;
    var o = out.words;
    var c = 0;
    var lo;
    var mid;
    var hi;
    var a0 = a[0] | 0;
    var al0 = a0 & 0x1fff;
    var ah0 = a0 >>> 13;
    var a1 = a[1] | 0;
    var al1 = a1 & 0x1fff;
    var ah1 = a1 >>> 13;
    var a2 = a[2] | 0;
    var al2 = a2 & 0x1fff;
    var ah2 = a2 >>> 13;
    var a3 = a[3] | 0;
    var al3 = a3 & 0x1fff;
    var ah3 = a3 >>> 13;
    var a4 = a[4] | 0;
    var al4 = a4 & 0x1fff;
    var ah4 = a4 >>> 13;
    var a5 = a[5] | 0;
    var al5 = a5 & 0x1fff;
    var ah5 = a5 >>> 13;
    var a6 = a[6] | 0;
    var al6 = a6 & 0x1fff;
    var ah6 = a6 >>> 13;
    var a7 = a[7] | 0;
    var al7 = a7 & 0x1fff;
    var ah7 = a7 >>> 13;
    var a8 = a[8] | 0;
    var al8 = a8 & 0x1fff;
    var ah8 = a8 >>> 13;
    var a9 = a[9] | 0;
    var al9 = a9 & 0x1fff;
    var ah9 = a9 >>> 13;
    var b0 = b[0] | 0;
    var bl0 = b0 & 0x1fff;
    var bh0 = b0 >>> 13;
    var b1 = b[1] | 0;
    var bl1 = b1 & 0x1fff;
    var bh1 = b1 >>> 13;
    var b2 = b[2] | 0;
    var bl2 = b2 & 0x1fff;
    var bh2 = b2 >>> 13;
    var b3 = b[3] | 0;
    var bl3 = b3 & 0x1fff;
    var bh3 = b3 >>> 13;
    var b4 = b[4] | 0;
    var bl4 = b4 & 0x1fff;
    var bh4 = b4 >>> 13;
    var b5 = b[5] | 0;
    var bl5 = b5 & 0x1fff;
    var bh5 = b5 >>> 13;
    var b6 = b[6] | 0;
    var bl6 = b6 & 0x1fff;
    var bh6 = b6 >>> 13;
    var b7 = b[7] | 0;
    var bl7 = b7 & 0x1fff;
    var bh7 = b7 >>> 13;
    var b8 = b[8] | 0;
    var bl8 = b8 & 0x1fff;
    var bh8 = b8 >>> 13;
    var b9 = b[9] | 0;
    var bl9 = b9 & 0x1fff;
    var bh9 = b9 >>> 13;

    out.negative = self.negative ^ num.negative;
    out.length = 19;
    /* k = 0 */
    lo = Math.imul(al0, bl0);
    mid = Math.imul(al0, bh0);
    mid = (mid + Math.imul(ah0, bl0)) | 0;
    hi = Math.imul(ah0, bh0);
    var w0 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w0 >>> 26)) | 0;
    w0 &= 0x3ffffff;
    /* k = 1 */
    lo = Math.imul(al1, bl0);
    mid = Math.imul(al1, bh0);
    mid = (mid + Math.imul(ah1, bl0)) | 0;
    hi = Math.imul(ah1, bh0);
    lo = (lo + Math.imul(al0, bl1)) | 0;
    mid = (mid + Math.imul(al0, bh1)) | 0;
    mid = (mid + Math.imul(ah0, bl1)) | 0;
    hi = (hi + Math.imul(ah0, bh1)) | 0;
    var w1 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w1 >>> 26)) | 0;
    w1 &= 0x3ffffff;
    /* k = 2 */
    lo = Math.imul(al2, bl0);
    mid = Math.imul(al2, bh0);
    mid = (mid + Math.imul(ah2, bl0)) | 0;
    hi = Math.imul(ah2, bh0);
    lo = (lo + Math.imul(al1, bl1)) | 0;
    mid = (mid + Math.imul(al1, bh1)) | 0;
    mid = (mid + Math.imul(ah1, bl1)) | 0;
    hi = (hi + Math.imul(ah1, bh1)) | 0;
    lo = (lo + Math.imul(al0, bl2)) | 0;
    mid = (mid + Math.imul(al0, bh2)) | 0;
    mid = (mid + Math.imul(ah0, bl2)) | 0;
    hi = (hi + Math.imul(ah0, bh2)) | 0;
    var w2 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w2 >>> 26)) | 0;
    w2 &= 0x3ffffff;
    /* k = 3 */
    lo = Math.imul(al3, bl0);
    mid = Math.imul(al3, bh0);
    mid = (mid + Math.imul(ah3, bl0)) | 0;
    hi = Math.imul(ah3, bh0);
    lo = (lo + Math.imul(al2, bl1)) | 0;
    mid = (mid + Math.imul(al2, bh1)) | 0;
    mid = (mid + Math.imul(ah2, bl1)) | 0;
    hi = (hi + Math.imul(ah2, bh1)) | 0;
    lo = (lo + Math.imul(al1, bl2)) | 0;
    mid = (mid + Math.imul(al1, bh2)) | 0;
    mid = (mid + Math.imul(ah1, bl2)) | 0;
    hi = (hi + Math.imul(ah1, bh2)) | 0;
    lo = (lo + Math.imul(al0, bl3)) | 0;
    mid = (mid + Math.imul(al0, bh3)) | 0;
    mid = (mid + Math.imul(ah0, bl3)) | 0;
    hi = (hi + Math.imul(ah0, bh3)) | 0;
    var w3 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w3 >>> 26)) | 0;
    w3 &= 0x3ffffff;
    /* k = 4 */
    lo = Math.imul(al4, bl0);
    mid = Math.imul(al4, bh0);
    mid = (mid + Math.imul(ah4, bl0)) | 0;
    hi = Math.imul(ah4, bh0);
    lo = (lo + Math.imul(al3, bl1)) | 0;
    mid = (mid + Math.imul(al3, bh1)) | 0;
    mid = (mid + Math.imul(ah3, bl1)) | 0;
    hi = (hi + Math.imul(ah3, bh1)) | 0;
    lo = (lo + Math.imul(al2, bl2)) | 0;
    mid = (mid + Math.imul(al2, bh2)) | 0;
    mid = (mid + Math.imul(ah2, bl2)) | 0;
    hi = (hi + Math.imul(ah2, bh2)) | 0;
    lo = (lo + Math.imul(al1, bl3)) | 0;
    mid = (mid + Math.imul(al1, bh3)) | 0;
    mid = (mid + Math.imul(ah1, bl3)) | 0;
    hi = (hi + Math.imul(ah1, bh3)) | 0;
    lo = (lo + Math.imul(al0, bl4)) | 0;
    mid = (mid + Math.imul(al0, bh4)) | 0;
    mid = (mid + Math.imul(ah0, bl4)) | 0;
    hi = (hi + Math.imul(ah0, bh4)) | 0;
    var w4 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w4 >>> 26)) | 0;
    w4 &= 0x3ffffff;
    /* k = 5 */
    lo = Math.imul(al5, bl0);
    mid = Math.imul(al5, bh0);
    mid = (mid + Math.imul(ah5, bl0)) | 0;
    hi = Math.imul(ah5, bh0);
    lo = (lo + Math.imul(al4, bl1)) | 0;
    mid = (mid + Math.imul(al4, bh1)) | 0;
    mid = (mid + Math.imul(ah4, bl1)) | 0;
    hi = (hi + Math.imul(ah4, bh1)) | 0;
    lo = (lo + Math.imul(al3, bl2)) | 0;
    mid = (mid + Math.imul(al3, bh2)) | 0;
    mid = (mid + Math.imul(ah3, bl2)) | 0;
    hi = (hi + Math.imul(ah3, bh2)) | 0;
    lo = (lo + Math.imul(al2, bl3)) | 0;
    mid = (mid + Math.imul(al2, bh3)) | 0;
    mid = (mid + Math.imul(ah2, bl3)) | 0;
    hi = (hi + Math.imul(ah2, bh3)) | 0;
    lo = (lo + Math.imul(al1, bl4)) | 0;
    mid = (mid + Math.imul(al1, bh4)) | 0;
    mid = (mid + Math.imul(ah1, bl4)) | 0;
    hi = (hi + Math.imul(ah1, bh4)) | 0;
    lo = (lo + Math.imul(al0, bl5)) | 0;
    mid = (mid + Math.imul(al0, bh5)) | 0;
    mid = (mid + Math.imul(ah0, bl5)) | 0;
    hi = (hi + Math.imul(ah0, bh5)) | 0;
    var w5 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w5 >>> 26)) | 0;
    w5 &= 0x3ffffff;
    /* k = 6 */
    lo = Math.imul(al6, bl0);
    mid = Math.imul(al6, bh0);
    mid = (mid + Math.imul(ah6, bl0)) | 0;
    hi = Math.imul(ah6, bh0);
    lo = (lo + Math.imul(al5, bl1)) | 0;
    mid = (mid + Math.imul(al5, bh1)) | 0;
    mid = (mid + Math.imul(ah5, bl1)) | 0;
    hi = (hi + Math.imul(ah5, bh1)) | 0;
    lo = (lo + Math.imul(al4, bl2)) | 0;
    mid = (mid + Math.imul(al4, bh2)) | 0;
    mid = (mid + Math.imul(ah4, bl2)) | 0;
    hi = (hi + Math.imul(ah4, bh2)) | 0;
    lo = (lo + Math.imul(al3, bl3)) | 0;
    mid = (mid + Math.imul(al3, bh3)) | 0;
    mid = (mid + Math.imul(ah3, bl3)) | 0;
    hi = (hi + Math.imul(ah3, bh3)) | 0;
    lo = (lo + Math.imul(al2, bl4)) | 0;
    mid = (mid + Math.imul(al2, bh4)) | 0;
    mid = (mid + Math.imul(ah2, bl4)) | 0;
    hi = (hi + Math.imul(ah2, bh4)) | 0;
    lo = (lo + Math.imul(al1, bl5)) | 0;
    mid = (mid + Math.imul(al1, bh5)) | 0;
    mid = (mid + Math.imul(ah1, bl5)) | 0;
    hi = (hi + Math.imul(ah1, bh5)) | 0;
    lo = (lo + Math.imul(al0, bl6)) | 0;
    mid = (mid + Math.imul(al0, bh6)) | 0;
    mid = (mid + Math.imul(ah0, bl6)) | 0;
    hi = (hi + Math.imul(ah0, bh6)) | 0;
    var w6 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w6 >>> 26)) | 0;
    w6 &= 0x3ffffff;
    /* k = 7 */
    lo = Math.imul(al7, bl0);
    mid = Math.imul(al7, bh0);
    mid = (mid + Math.imul(ah7, bl0)) | 0;
    hi = Math.imul(ah7, bh0);
    lo = (lo + Math.imul(al6, bl1)) | 0;
    mid = (mid + Math.imul(al6, bh1)) | 0;
    mid = (mid + Math.imul(ah6, bl1)) | 0;
    hi = (hi + Math.imul(ah6, bh1)) | 0;
    lo = (lo + Math.imul(al5, bl2)) | 0;
    mid = (mid + Math.imul(al5, bh2)) | 0;
    mid = (mid + Math.imul(ah5, bl2)) | 0;
    hi = (hi + Math.imul(ah5, bh2)) | 0;
    lo = (lo + Math.imul(al4, bl3)) | 0;
    mid = (mid + Math.imul(al4, bh3)) | 0;
    mid = (mid + Math.imul(ah4, bl3)) | 0;
    hi = (hi + Math.imul(ah4, bh3)) | 0;
    lo = (lo + Math.imul(al3, bl4)) | 0;
    mid = (mid + Math.imul(al3, bh4)) | 0;
    mid = (mid + Math.imul(ah3, bl4)) | 0;
    hi = (hi + Math.imul(ah3, bh4)) | 0;
    lo = (lo + Math.imul(al2, bl5)) | 0;
    mid = (mid + Math.imul(al2, bh5)) | 0;
    mid = (mid + Math.imul(ah2, bl5)) | 0;
    hi = (hi + Math.imul(ah2, bh5)) | 0;
    lo = (lo + Math.imul(al1, bl6)) | 0;
    mid = (mid + Math.imul(al1, bh6)) | 0;
    mid = (mid + Math.imul(ah1, bl6)) | 0;
    hi = (hi + Math.imul(ah1, bh6)) | 0;
    lo = (lo + Math.imul(al0, bl7)) | 0;
    mid = (mid + Math.imul(al0, bh7)) | 0;
    mid = (mid + Math.imul(ah0, bl7)) | 0;
    hi = (hi + Math.imul(ah0, bh7)) | 0;
    var w7 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w7 >>> 26)) | 0;
    w7 &= 0x3ffffff;
    /* k = 8 */
    lo = Math.imul(al8, bl0);
    mid = Math.imul(al8, bh0);
    mid = (mid + Math.imul(ah8, bl0)) | 0;
    hi = Math.imul(ah8, bh0);
    lo = (lo + Math.imul(al7, bl1)) | 0;
    mid = (mid + Math.imul(al7, bh1)) | 0;
    mid = (mid + Math.imul(ah7, bl1)) | 0;
    hi = (hi + Math.imul(ah7, bh1)) | 0;
    lo = (lo + Math.imul(al6, bl2)) | 0;
    mid = (mid + Math.imul(al6, bh2)) | 0;
    mid = (mid + Math.imul(ah6, bl2)) | 0;
    hi = (hi + Math.imul(ah6, bh2)) | 0;
    lo = (lo + Math.imul(al5, bl3)) | 0;
    mid = (mid + Math.imul(al5, bh3)) | 0;
    mid = (mid + Math.imul(ah5, bl3)) | 0;
    hi = (hi + Math.imul(ah5, bh3)) | 0;
    lo = (lo + Math.imul(al4, bl4)) | 0;
    mid = (mid + Math.imul(al4, bh4)) | 0;
    mid = (mid + Math.imul(ah4, bl4)) | 0;
    hi = (hi + Math.imul(ah4, bh4)) | 0;
    lo = (lo + Math.imul(al3, bl5)) | 0;
    mid = (mid + Math.imul(al3, bh5)) | 0;
    mid = (mid + Math.imul(ah3, bl5)) | 0;
    hi = (hi + Math.imul(ah3, bh5)) | 0;
    lo = (lo + Math.imul(al2, bl6)) | 0;
    mid = (mid + Math.imul(al2, bh6)) | 0;
    mid = (mid + Math.imul(ah2, bl6)) | 0;
    hi = (hi + Math.imul(ah2, bh6)) | 0;
    lo = (lo + Math.imul(al1, bl7)) | 0;
    mid = (mid + Math.imul(al1, bh7)) | 0;
    mid = (mid + Math.imul(ah1, bl7)) | 0;
    hi = (hi + Math.imul(ah1, bh7)) | 0;
    lo = (lo + Math.imul(al0, bl8)) | 0;
    mid = (mid + Math.imul(al0, bh8)) | 0;
    mid = (mid + Math.imul(ah0, bl8)) | 0;
    hi = (hi + Math.imul(ah0, bh8)) | 0;
    var w8 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w8 >>> 26)) | 0;
    w8 &= 0x3ffffff;
    /* k = 9 */
    lo = Math.imul(al9, bl0);
    mid = Math.imul(al9, bh0);
    mid = (mid + Math.imul(ah9, bl0)) | 0;
    hi = Math.imul(ah9, bh0);
    lo = (lo + Math.imul(al8, bl1)) | 0;
    mid = (mid + Math.imul(al8, bh1)) | 0;
    mid = (mid + Math.imul(ah8, bl1)) | 0;
    hi = (hi + Math.imul(ah8, bh1)) | 0;
    lo = (lo + Math.imul(al7, bl2)) | 0;
    mid = (mid + Math.imul(al7, bh2)) | 0;
    mid = (mid + Math.imul(ah7, bl2)) | 0;
    hi = (hi + Math.imul(ah7, bh2)) | 0;
    lo = (lo + Math.imul(al6, bl3)) | 0;
    mid = (mid + Math.imul(al6, bh3)) | 0;
    mid = (mid + Math.imul(ah6, bl3)) | 0;
    hi = (hi + Math.imul(ah6, bh3)) | 0;
    lo = (lo + Math.imul(al5, bl4)) | 0;
    mid = (mid + Math.imul(al5, bh4)) | 0;
    mid = (mid + Math.imul(ah5, bl4)) | 0;
    hi = (hi + Math.imul(ah5, bh4)) | 0;
    lo = (lo + Math.imul(al4, bl5)) | 0;
    mid = (mid + Math.imul(al4, bh5)) | 0;
    mid = (mid + Math.imul(ah4, bl5)) | 0;
    hi = (hi + Math.imul(ah4, bh5)) | 0;
    lo = (lo + Math.imul(al3, bl6)) | 0;
    mid = (mid + Math.imul(al3, bh6)) | 0;
    mid = (mid + Math.imul(ah3, bl6)) | 0;
    hi = (hi + Math.imul(ah3, bh6)) | 0;
    lo = (lo + Math.imul(al2, bl7)) | 0;
    mid = (mid + Math.imul(al2, bh7)) | 0;
    mid = (mid + Math.imul(ah2, bl7)) | 0;
    hi = (hi + Math.imul(ah2, bh7)) | 0;
    lo = (lo + Math.imul(al1, bl8)) | 0;
    mid = (mid + Math.imul(al1, bh8)) | 0;
    mid = (mid + Math.imul(ah1, bl8)) | 0;
    hi = (hi + Math.imul(ah1, bh8)) | 0;
    lo = (lo + Math.imul(al0, bl9)) | 0;
    mid = (mid + Math.imul(al0, bh9)) | 0;
    mid = (mid + Math.imul(ah0, bl9)) | 0;
    hi = (hi + Math.imul(ah0, bh9)) | 0;
    var w9 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w9 >>> 26)) | 0;
    w9 &= 0x3ffffff;
    /* k = 10 */
    lo = Math.imul(al9, bl1);
    mid = Math.imul(al9, bh1);
    mid = (mid + Math.imul(ah9, bl1)) | 0;
    hi = Math.imul(ah9, bh1);
    lo = (lo + Math.imul(al8, bl2)) | 0;
    mid = (mid + Math.imul(al8, bh2)) | 0;
    mid = (mid + Math.imul(ah8, bl2)) | 0;
    hi = (hi + Math.imul(ah8, bh2)) | 0;
    lo = (lo + Math.imul(al7, bl3)) | 0;
    mid = (mid + Math.imul(al7, bh3)) | 0;
    mid = (mid + Math.imul(ah7, bl3)) | 0;
    hi = (hi + Math.imul(ah7, bh3)) | 0;
    lo = (lo + Math.imul(al6, bl4)) | 0;
    mid = (mid + Math.imul(al6, bh4)) | 0;
    mid = (mid + Math.imul(ah6, bl4)) | 0;
    hi = (hi + Math.imul(ah6, bh4)) | 0;
    lo = (lo + Math.imul(al5, bl5)) | 0;
    mid = (mid + Math.imul(al5, bh5)) | 0;
    mid = (mid + Math.imul(ah5, bl5)) | 0;
    hi = (hi + Math.imul(ah5, bh5)) | 0;
    lo = (lo + Math.imul(al4, bl6)) | 0;
    mid = (mid + Math.imul(al4, bh6)) | 0;
    mid = (mid + Math.imul(ah4, bl6)) | 0;
    hi = (hi + Math.imul(ah4, bh6)) | 0;
    lo = (lo + Math.imul(al3, bl7)) | 0;
    mid = (mid + Math.imul(al3, bh7)) | 0;
    mid = (mid + Math.imul(ah3, bl7)) | 0;
    hi = (hi + Math.imul(ah3, bh7)) | 0;
    lo = (lo + Math.imul(al2, bl8)) | 0;
    mid = (mid + Math.imul(al2, bh8)) | 0;
    mid = (mid + Math.imul(ah2, bl8)) | 0;
    hi = (hi + Math.imul(ah2, bh8)) | 0;
    lo = (lo + Math.imul(al1, bl9)) | 0;
    mid = (mid + Math.imul(al1, bh9)) | 0;
    mid = (mid + Math.imul(ah1, bl9)) | 0;
    hi = (hi + Math.imul(ah1, bh9)) | 0;
    var w10 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w10 >>> 26)) | 0;
    w10 &= 0x3ffffff;
    /* k = 11 */
    lo = Math.imul(al9, bl2);
    mid = Math.imul(al9, bh2);
    mid = (mid + Math.imul(ah9, bl2)) | 0;
    hi = Math.imul(ah9, bh2);
    lo = (lo + Math.imul(al8, bl3)) | 0;
    mid = (mid + Math.imul(al8, bh3)) | 0;
    mid = (mid + Math.imul(ah8, bl3)) | 0;
    hi = (hi + Math.imul(ah8, bh3)) | 0;
    lo = (lo + Math.imul(al7, bl4)) | 0;
    mid = (mid + Math.imul(al7, bh4)) | 0;
    mid = (mid + Math.imul(ah7, bl4)) | 0;
    hi = (hi + Math.imul(ah7, bh4)) | 0;
    lo = (lo + Math.imul(al6, bl5)) | 0;
    mid = (mid + Math.imul(al6, bh5)) | 0;
    mid = (mid + Math.imul(ah6, bl5)) | 0;
    hi = (hi + Math.imul(ah6, bh5)) | 0;
    lo = (lo + Math.imul(al5, bl6)) | 0;
    mid = (mid + Math.imul(al5, bh6)) | 0;
    mid = (mid + Math.imul(ah5, bl6)) | 0;
    hi = (hi + Math.imul(ah5, bh6)) | 0;
    lo = (lo + Math.imul(al4, bl7)) | 0;
    mid = (mid + Math.imul(al4, bh7)) | 0;
    mid = (mid + Math.imul(ah4, bl7)) | 0;
    hi = (hi + Math.imul(ah4, bh7)) | 0;
    lo = (lo + Math.imul(al3, bl8)) | 0;
    mid = (mid + Math.imul(al3, bh8)) | 0;
    mid = (mid + Math.imul(ah3, bl8)) | 0;
    hi = (hi + Math.imul(ah3, bh8)) | 0;
    lo = (lo + Math.imul(al2, bl9)) | 0;
    mid = (mid + Math.imul(al2, bh9)) | 0;
    mid = (mid + Math.imul(ah2, bl9)) | 0;
    hi = (hi + Math.imul(ah2, bh9)) | 0;
    var w11 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w11 >>> 26)) | 0;
    w11 &= 0x3ffffff;
    /* k = 12 */
    lo = Math.imul(al9, bl3);
    mid = Math.imul(al9, bh3);
    mid = (mid + Math.imul(ah9, bl3)) | 0;
    hi = Math.imul(ah9, bh3);
    lo = (lo + Math.imul(al8, bl4)) | 0;
    mid = (mid + Math.imul(al8, bh4)) | 0;
    mid = (mid + Math.imul(ah8, bl4)) | 0;
    hi = (hi + Math.imul(ah8, bh4)) | 0;
    lo = (lo + Math.imul(al7, bl5)) | 0;
    mid = (mid + Math.imul(al7, bh5)) | 0;
    mid = (mid + Math.imul(ah7, bl5)) | 0;
    hi = (hi + Math.imul(ah7, bh5)) | 0;
    lo = (lo + Math.imul(al6, bl6)) | 0;
    mid = (mid + Math.imul(al6, bh6)) | 0;
    mid = (mid + Math.imul(ah6, bl6)) | 0;
    hi = (hi + Math.imul(ah6, bh6)) | 0;
    lo = (lo + Math.imul(al5, bl7)) | 0;
    mid = (mid + Math.imul(al5, bh7)) | 0;
    mid = (mid + Math.imul(ah5, bl7)) | 0;
    hi = (hi + Math.imul(ah5, bh7)) | 0;
    lo = (lo + Math.imul(al4, bl8)) | 0;
    mid = (mid + Math.imul(al4, bh8)) | 0;
    mid = (mid + Math.imul(ah4, bl8)) | 0;
    hi = (hi + Math.imul(ah4, bh8)) | 0;
    lo = (lo + Math.imul(al3, bl9)) | 0;
    mid = (mid + Math.imul(al3, bh9)) | 0;
    mid = (mid + Math.imul(ah3, bl9)) | 0;
    hi = (hi + Math.imul(ah3, bh9)) | 0;
    var w12 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w12 >>> 26)) | 0;
    w12 &= 0x3ffffff;
    /* k = 13 */
    lo = Math.imul(al9, bl4);
    mid = Math.imul(al9, bh4);
    mid = (mid + Math.imul(ah9, bl4)) | 0;
    hi = Math.imul(ah9, bh4);
    lo = (lo + Math.imul(al8, bl5)) | 0;
    mid = (mid + Math.imul(al8, bh5)) | 0;
    mid = (mid + Math.imul(ah8, bl5)) | 0;
    hi = (hi + Math.imul(ah8, bh5)) | 0;
    lo = (lo + Math.imul(al7, bl6)) | 0;
    mid = (mid + Math.imul(al7, bh6)) | 0;
    mid = (mid + Math.imul(ah7, bl6)) | 0;
    hi = (hi + Math.imul(ah7, bh6)) | 0;
    lo = (lo + Math.imul(al6, bl7)) | 0;
    mid = (mid + Math.imul(al6, bh7)) | 0;
    mid = (mid + Math.imul(ah6, bl7)) | 0;
    hi = (hi + Math.imul(ah6, bh7)) | 0;
    lo = (lo + Math.imul(al5, bl8)) | 0;
    mid = (mid + Math.imul(al5, bh8)) | 0;
    mid = (mid + Math.imul(ah5, bl8)) | 0;
    hi = (hi + Math.imul(ah5, bh8)) | 0;
    lo = (lo + Math.imul(al4, bl9)) | 0;
    mid = (mid + Math.imul(al4, bh9)) | 0;
    mid = (mid + Math.imul(ah4, bl9)) | 0;
    hi = (hi + Math.imul(ah4, bh9)) | 0;
    var w13 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w13 >>> 26)) | 0;
    w13 &= 0x3ffffff;
    /* k = 14 */
    lo = Math.imul(al9, bl5);
    mid = Math.imul(al9, bh5);
    mid = (mid + Math.imul(ah9, bl5)) | 0;
    hi = Math.imul(ah9, bh5);
    lo = (lo + Math.imul(al8, bl6)) | 0;
    mid = (mid + Math.imul(al8, bh6)) | 0;
    mid = (mid + Math.imul(ah8, bl6)) | 0;
    hi = (hi + Math.imul(ah8, bh6)) | 0;
    lo = (lo + Math.imul(al7, bl7)) | 0;
    mid = (mid + Math.imul(al7, bh7)) | 0;
    mid = (mid + Math.imul(ah7, bl7)) | 0;
    hi = (hi + Math.imul(ah7, bh7)) | 0;
    lo = (lo + Math.imul(al6, bl8)) | 0;
    mid = (mid + Math.imul(al6, bh8)) | 0;
    mid = (mid + Math.imul(ah6, bl8)) | 0;
    hi = (hi + Math.imul(ah6, bh8)) | 0;
    lo = (lo + Math.imul(al5, bl9)) | 0;
    mid = (mid + Math.imul(al5, bh9)) | 0;
    mid = (mid + Math.imul(ah5, bl9)) | 0;
    hi = (hi + Math.imul(ah5, bh9)) | 0;
    var w14 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w14 >>> 26)) | 0;
    w14 &= 0x3ffffff;
    /* k = 15 */
    lo = Math.imul(al9, bl6);
    mid = Math.imul(al9, bh6);
    mid = (mid + Math.imul(ah9, bl6)) | 0;
    hi = Math.imul(ah9, bh6);
    lo = (lo + Math.imul(al8, bl7)) | 0;
    mid = (mid + Math.imul(al8, bh7)) | 0;
    mid = (mid + Math.imul(ah8, bl7)) | 0;
    hi = (hi + Math.imul(ah8, bh7)) | 0;
    lo = (lo + Math.imul(al7, bl8)) | 0;
    mid = (mid + Math.imul(al7, bh8)) | 0;
    mid = (mid + Math.imul(ah7, bl8)) | 0;
    hi = (hi + Math.imul(ah7, bh8)) | 0;
    lo = (lo + Math.imul(al6, bl9)) | 0;
    mid = (mid + Math.imul(al6, bh9)) | 0;
    mid = (mid + Math.imul(ah6, bl9)) | 0;
    hi = (hi + Math.imul(ah6, bh9)) | 0;
    var w15 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w15 >>> 26)) | 0;
    w15 &= 0x3ffffff;
    /* k = 16 */
    lo = Math.imul(al9, bl7);
    mid = Math.imul(al9, bh7);
    mid = (mid + Math.imul(ah9, bl7)) | 0;
    hi = Math.imul(ah9, bh7);
    lo = (lo + Math.imul(al8, bl8)) | 0;
    mid = (mid + Math.imul(al8, bh8)) | 0;
    mid = (mid + Math.imul(ah8, bl8)) | 0;
    hi = (hi + Math.imul(ah8, bh8)) | 0;
    lo = (lo + Math.imul(al7, bl9)) | 0;
    mid = (mid + Math.imul(al7, bh9)) | 0;
    mid = (mid + Math.imul(ah7, bl9)) | 0;
    hi = (hi + Math.imul(ah7, bh9)) | 0;
    var w16 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w16 >>> 26)) | 0;
    w16 &= 0x3ffffff;
    /* k = 17 */
    lo = Math.imul(al9, bl8);
    mid = Math.imul(al9, bh8);
    mid = (mid + Math.imul(ah9, bl8)) | 0;
    hi = Math.imul(ah9, bh8);
    lo = (lo + Math.imul(al8, bl9)) | 0;
    mid = (mid + Math.imul(al8, bh9)) | 0;
    mid = (mid + Math.imul(ah8, bl9)) | 0;
    hi = (hi + Math.imul(ah8, bh9)) | 0;
    var w17 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w17 >>> 26)) | 0;
    w17 &= 0x3ffffff;
    /* k = 18 */
    lo = Math.imul(al9, bl9);
    mid = Math.imul(al9, bh9);
    mid = (mid + Math.imul(ah9, bl9)) | 0;
    hi = Math.imul(ah9, bh9);
    var w18 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w18 >>> 26)) | 0;
    w18 &= 0x3ffffff;
    o[0] = w0;
    o[1] = w1;
    o[2] = w2;
    o[3] = w3;
    o[4] = w4;
    o[5] = w5;
    o[6] = w6;
    o[7] = w7;
    o[8] = w8;
    o[9] = w9;
    o[10] = w10;
    o[11] = w11;
    o[12] = w12;
    o[13] = w13;
    o[14] = w14;
    o[15] = w15;
    o[16] = w16;
    o[17] = w17;
    o[18] = w18;
    if (c !== 0) {
      o[19] = c;
      out.length++;
    }
    return out;
  };

  // Polyfill comb
  if (!Math.imul) {
    comb10MulTo = smallMulTo;
  }

  function bigMulTo (self, num, out) {
    out.negative = num.negative ^ self.negative;
    out.length = self.length + num.length;

    var carry = 0;
    var hncarry = 0;
    for (var k = 0; k < out.length - 1; k++) {
      // Sum all words with the same `i + j = k` and accumulate `ncarry`,
      // note that ncarry could be >= 0x3ffffff
      var ncarry = hncarry;
      hncarry = 0;
      var rword = carry & 0x3ffffff;
      var maxJ = Math.min(k, num.length - 1);
      for (var j = Math.max(0, k - self.length + 1); j <= maxJ; j++) {
        var i = k - j;
        var a = self.words[i] | 0;
        var b = num.words[j] | 0;
        var r = a * b;

        var lo = r & 0x3ffffff;
        ncarry = (ncarry + ((r / 0x4000000) | 0)) | 0;
        lo = (lo + rword) | 0;
        rword = lo & 0x3ffffff;
        ncarry = (ncarry + (lo >>> 26)) | 0;

        hncarry += ncarry >>> 26;
        ncarry &= 0x3ffffff;
      }
      out.words[k] = rword;
      carry = ncarry;
      ncarry = hncarry;
    }
    if (carry !== 0) {
      out.words[k] = carry;
    } else {
      out.length--;
    }

    return out.strip();
  }

  function jumboMulTo (self, num, out) {
    var fftm = new FFTM();
    return fftm.mulp(self, num, out);
  }

  BN.prototype.mulTo = function mulTo (num, out) {
    var res;
    var len = this.length + num.length;
    if (this.length === 10 && num.length === 10) {
      res = comb10MulTo(this, num, out);
    } else if (len < 63) {
      res = smallMulTo(this, num, out);
    } else if (len < 1024) {
      res = bigMulTo(this, num, out);
    } else {
      res = jumboMulTo(this, num, out);
    }

    return res;
  };

  // Cooley-Tukey algorithm for FFT
  // slightly revisited to rely on looping instead of recursion

  function FFTM (x, y) {
    this.x = x;
    this.y = y;
  }

  FFTM.prototype.makeRBT = function makeRBT (N) {
    var t = new Array(N);
    var l = BN.prototype._countBits(N) - 1;
    for (var i = 0; i < N; i++) {
      t[i] = this.revBin(i, l, N);
    }

    return t;
  };

  // Returns binary-reversed representation of `x`
  FFTM.prototype.revBin = function revBin (x, l, N) {
    if (x === 0 || x === N - 1) return x;

    var rb = 0;
    for (var i = 0; i < l; i++) {
      rb |= (x & 1) << (l - i - 1);
      x >>= 1;
    }

    return rb;
  };

  // Performs "tweedling" phase, therefore 'emulating'
  // behaviour of the recursive algorithm
  FFTM.prototype.permute = function permute (rbt, rws, iws, rtws, itws, N) {
    for (var i = 0; i < N; i++) {
      rtws[i] = rws[rbt[i]];
      itws[i] = iws[rbt[i]];
    }
  };

  FFTM.prototype.transform = function transform (rws, iws, rtws, itws, N, rbt) {
    this.permute(rbt, rws, iws, rtws, itws, N);

    for (var s = 1; s < N; s <<= 1) {
      var l = s << 1;

      var rtwdf = Math.cos(2 * Math.PI / l);
      var itwdf = Math.sin(2 * Math.PI / l);

      for (var p = 0; p < N; p += l) {
        var rtwdf_ = rtwdf;
        var itwdf_ = itwdf;

        for (var j = 0; j < s; j++) {
          var re = rtws[p + j];
          var ie = itws[p + j];

          var ro = rtws[p + j + s];
          var io = itws[p + j + s];

          var rx = rtwdf_ * ro - itwdf_ * io;

          io = rtwdf_ * io + itwdf_ * ro;
          ro = rx;

          rtws[p + j] = re + ro;
          itws[p + j] = ie + io;

          rtws[p + j + s] = re - ro;
          itws[p + j + s] = ie - io;

          /* jshint maxdepth : false */
          if (j !== l) {
            rx = rtwdf * rtwdf_ - itwdf * itwdf_;

            itwdf_ = rtwdf * itwdf_ + itwdf * rtwdf_;
            rtwdf_ = rx;
          }
        }
      }
    }
  };

  FFTM.prototype.guessLen13b = function guessLen13b (n, m) {
    var N = Math.max(m, n) | 1;
    var odd = N & 1;
    var i = 0;
    for (N = N / 2 | 0; N; N = N >>> 1) {
      i++;
    }

    return 1 << i + 1 + odd;
  };

  FFTM.prototype.conjugate = function conjugate (rws, iws, N) {
    if (N <= 1) return;

    for (var i = 0; i < N / 2; i++) {
      var t = rws[i];

      rws[i] = rws[N - i - 1];
      rws[N - i - 1] = t;

      t = iws[i];

      iws[i] = -iws[N - i - 1];
      iws[N - i - 1] = -t;
    }
  };

  FFTM.prototype.normalize13b = function normalize13b (ws, N) {
    var carry = 0;
    for (var i = 0; i < N / 2; i++) {
      var w = Math.round(ws[2 * i + 1] / N) * 0x2000 +
        Math.round(ws[2 * i] / N) +
        carry;

      ws[i] = w & 0x3ffffff;

      if (w < 0x4000000) {
        carry = 0;
      } else {
        carry = w / 0x4000000 | 0;
      }
    }

    return ws;
  };

  FFTM.prototype.convert13b = function convert13b (ws, len, rws, N) {
    var carry = 0;
    for (var i = 0; i < len; i++) {
      carry = carry + (ws[i] | 0);

      rws[2 * i] = carry & 0x1fff; carry = carry >>> 13;
      rws[2 * i + 1] = carry & 0x1fff; carry = carry >>> 13;
    }

    // Pad with zeroes
    for (i = 2 * len; i < N; ++i) {
      rws[i] = 0;
    }

    assert(carry === 0);
    assert((carry & ~0x1fff) === 0);
  };

  FFTM.prototype.stub = function stub (N) {
    var ph = new Array(N);
    for (var i = 0; i < N; i++) {
      ph[i] = 0;
    }

    return ph;
  };

  FFTM.prototype.mulp = function mulp (x, y, out) {
    var N = 2 * this.guessLen13b(x.length, y.length);

    var rbt = this.makeRBT(N);

    var _ = this.stub(N);

    var rws = new Array(N);
    var rwst = new Array(N);
    var iwst = new Array(N);

    var nrws = new Array(N);
    var nrwst = new Array(N);
    var niwst = new Array(N);

    var rmws = out.words;
    rmws.length = N;

    this.convert13b(x.words, x.length, rws, N);
    this.convert13b(y.words, y.length, nrws, N);

    this.transform(rws, _, rwst, iwst, N, rbt);
    this.transform(nrws, _, nrwst, niwst, N, rbt);

    for (var i = 0; i < N; i++) {
      var rx = rwst[i] * nrwst[i] - iwst[i] * niwst[i];
      iwst[i] = rwst[i] * niwst[i] + iwst[i] * nrwst[i];
      rwst[i] = rx;
    }

    this.conjugate(rwst, iwst, N);
    this.transform(rwst, iwst, rmws, _, N, rbt);
    this.conjugate(rmws, _, N);
    this.normalize13b(rmws, N);

    out.negative = x.negative ^ y.negative;
    out.length = x.length + y.length;
    return out.strip();
  };

  // Multiply `this` by `num`
  BN.prototype.mul = function mul (num) {
    var out = new BN(null);
    out.words = new Array(this.length + num.length);
    return this.mulTo(num, out);
  };

  // Multiply employing FFT
  BN.prototype.mulf = function mulf (num) {
    var out = new BN(null);
    out.words = new Array(this.length + num.length);
    return jumboMulTo(this, num, out);
  };

  // In-place Multiplication
  BN.prototype.imul = function imul (num) {
    return this.clone().mulTo(num, this);
  };

  BN.prototype.imuln = function imuln (num) {
    assert(typeof num === 'number');
    assert(num < 0x4000000);

    // Carry
    var carry = 0;
    for (var i = 0; i < this.length; i++) {
      var w = (this.words[i] | 0) * num;
      var lo = (w & 0x3ffffff) + (carry & 0x3ffffff);
      carry >>= 26;
      carry += (w / 0x4000000) | 0;
      // NOTE: lo is 27bit maximum
      carry += lo >>> 26;
      this.words[i] = lo & 0x3ffffff;
    }

    if (carry !== 0) {
      this.words[i] = carry;
      this.length++;
    }

    return this;
  };

  BN.prototype.muln = function muln (num) {
    return this.clone().imuln(num);
  };

  // `this` * `this`
  BN.prototype.sqr = function sqr () {
    return this.mul(this);
  };

  // `this` * `this` in-place
  BN.prototype.isqr = function isqr () {
    return this.imul(this.clone());
  };

  // Math.pow(`this`, `num`)
  BN.prototype.pow = function pow (num) {
    var w = toBitArray(num);
    if (w.length === 0) return new BN(1);

    // Skip leading zeroes
    var res = this;
    for (var i = 0; i < w.length; i++, res = res.sqr()) {
      if (w[i] !== 0) break;
    }

    if (++i < w.length) {
      for (var q = res.sqr(); i < w.length; i++, q = q.sqr()) {
        if (w[i] === 0) continue;

        res = res.mul(q);
      }
    }

    return res;
  };

  // Shift-left in-place
  BN.prototype.iushln = function iushln (bits) {
    assert(typeof bits === 'number' && bits >= 0);
    var r = bits % 26;
    var s = (bits - r) / 26;
    var carryMask = (0x3ffffff >>> (26 - r)) << (26 - r);
    var i;

    if (r !== 0) {
      var carry = 0;

      for (i = 0; i < this.length; i++) {
        var newCarry = this.words[i] & carryMask;
        var c = ((this.words[i] | 0) - newCarry) << r;
        this.words[i] = c | carry;
        carry = newCarry >>> (26 - r);
      }

      if (carry) {
        this.words[i] = carry;
        this.length++;
      }
    }

    if (s !== 0) {
      for (i = this.length - 1; i >= 0; i--) {
        this.words[i + s] = this.words[i];
      }

      for (i = 0; i < s; i++) {
        this.words[i] = 0;
      }

      this.length += s;
    }

    return this.strip();
  };

  BN.prototype.ishln = function ishln (bits) {
    // TODO(indutny): implement me
    assert(this.negative === 0);
    return this.iushln(bits);
  };

  // Shift-right in-place
  // NOTE: `hint` is a lowest bit before trailing zeroes
  // NOTE: if `extended` is present - it will be filled with destroyed bits
  BN.prototype.iushrn = function iushrn (bits, hint, extended) {
    assert(typeof bits === 'number' && bits >= 0);
    var h;
    if (hint) {
      h = (hint - (hint % 26)) / 26;
    } else {
      h = 0;
    }

    var r = bits % 26;
    var s = Math.min((bits - r) / 26, this.length);
    var mask = 0x3ffffff ^ ((0x3ffffff >>> r) << r);
    var maskedWords = extended;

    h -= s;
    h = Math.max(0, h);

    // Extended mode, copy masked part
    if (maskedWords) {
      for (var i = 0; i < s; i++) {
        maskedWords.words[i] = this.words[i];
      }
      maskedWords.length = s;
    }

    if (s === 0) {
      // No-op, we should not move anything at all
    } else if (this.length > s) {
      this.length -= s;
      for (i = 0; i < this.length; i++) {
        this.words[i] = this.words[i + s];
      }
    } else {
      this.words[0] = 0;
      this.length = 1;
    }

    var carry = 0;
    for (i = this.length - 1; i >= 0 && (carry !== 0 || i >= h); i--) {
      var word = this.words[i] | 0;
      this.words[i] = (carry << (26 - r)) | (word >>> r);
      carry = word & mask;
    }

    // Push carried bits as a mask
    if (maskedWords && carry !== 0) {
      maskedWords.words[maskedWords.length++] = carry;
    }

    if (this.length === 0) {
      this.words[0] = 0;
      this.length = 1;
    }

    return this.strip();
  };

  BN.prototype.ishrn = function ishrn (bits, hint, extended) {
    // TODO(indutny): implement me
    assert(this.negative === 0);
    return this.iushrn(bits, hint, extended);
  };

  // Shift-left
  BN.prototype.shln = function shln (bits) {
    return this.clone().ishln(bits);
  };

  BN.prototype.ushln = function ushln (bits) {
    return this.clone().iushln(bits);
  };

  // Shift-right
  BN.prototype.shrn = function shrn (bits) {
    return this.clone().ishrn(bits);
  };

  BN.prototype.ushrn = function ushrn (bits) {
    return this.clone().iushrn(bits);
  };

  // Test if n bit is set
  BN.prototype.testn = function testn (bit) {
    assert(typeof bit === 'number' && bit >= 0);
    var r = bit % 26;
    var s = (bit - r) / 26;
    var q = 1 << r;

    // Fast case: bit is much higher than all existing words
    if (this.length <= s) return false;

    // Check bit and return
    var w = this.words[s];

    return !!(w & q);
  };

  // Return only lowers bits of number (in-place)
  BN.prototype.imaskn = function imaskn (bits) {
    assert(typeof bits === 'number' && bits >= 0);
    var r = bits % 26;
    var s = (bits - r) / 26;

    assert(this.negative === 0, 'imaskn works only with positive numbers');

    if (this.length <= s) {
      return this;
    }

    if (r !== 0) {
      s++;
    }
    this.length = Math.min(s, this.length);

    if (r !== 0) {
      var mask = 0x3ffffff ^ ((0x3ffffff >>> r) << r);
      this.words[this.length - 1] &= mask;
    }

    return this.strip();
  };

  // Return only lowers bits of number
  BN.prototype.maskn = function maskn (bits) {
    return this.clone().imaskn(bits);
  };

  // Add plain number `num` to `this`
  BN.prototype.iaddn = function iaddn (num) {
    assert(typeof num === 'number');
    assert(num < 0x4000000);
    if (num < 0) return this.isubn(-num);

    // Possible sign change
    if (this.negative !== 0) {
      if (this.length === 1 && (this.words[0] | 0) < num) {
        this.words[0] = num - (this.words[0] | 0);
        this.negative = 0;
        return this;
      }

      this.negative = 0;
      this.isubn(num);
      this.negative = 1;
      return this;
    }

    // Add without checks
    return this._iaddn(num);
  };

  BN.prototype._iaddn = function _iaddn (num) {
    this.words[0] += num;

    // Carry
    for (var i = 0; i < this.length && this.words[i] >= 0x4000000; i++) {
      this.words[i] -= 0x4000000;
      if (i === this.length - 1) {
        this.words[i + 1] = 1;
      } else {
        this.words[i + 1]++;
      }
    }
    this.length = Math.max(this.length, i + 1);

    return this;
  };

  // Subtract plain number `num` from `this`
  BN.prototype.isubn = function isubn (num) {
    assert(typeof num === 'number');
    assert(num < 0x4000000);
    if (num < 0) return this.iaddn(-num);

    if (this.negative !== 0) {
      this.negative = 0;
      this.iaddn(num);
      this.negative = 1;
      return this;
    }

    this.words[0] -= num;

    if (this.length === 1 && this.words[0] < 0) {
      this.words[0] = -this.words[0];
      this.negative = 1;
    } else {
      // Carry
      for (var i = 0; i < this.length && this.words[i] < 0; i++) {
        this.words[i] += 0x4000000;
        this.words[i + 1] -= 1;
      }
    }

    return this.strip();
  };

  BN.prototype.addn = function addn (num) {
    return this.clone().iaddn(num);
  };

  BN.prototype.subn = function subn (num) {
    return this.clone().isubn(num);
  };

  BN.prototype.iabs = function iabs () {
    this.negative = 0;

    return this;
  };

  BN.prototype.abs = function abs () {
    return this.clone().iabs();
  };

  BN.prototype._ishlnsubmul = function _ishlnsubmul (num, mul, shift) {
    var len = num.length + shift;
    var i;

    this._expand(len);

    var w;
    var carry = 0;
    for (i = 0; i < num.length; i++) {
      w = (this.words[i + shift] | 0) + carry;
      var right = (num.words[i] | 0) * mul;
      w -= right & 0x3ffffff;
      carry = (w >> 26) - ((right / 0x4000000) | 0);
      this.words[i + shift] = w & 0x3ffffff;
    }
    for (; i < this.length - shift; i++) {
      w = (this.words[i + shift] | 0) + carry;
      carry = w >> 26;
      this.words[i + shift] = w & 0x3ffffff;
    }

    if (carry === 0) return this.strip();

    // Subtraction overflow
    assert(carry === -1);
    carry = 0;
    for (i = 0; i < this.length; i++) {
      w = -(this.words[i] | 0) + carry;
      carry = w >> 26;
      this.words[i] = w & 0x3ffffff;
    }
    this.negative = 1;

    return this.strip();
  };

  BN.prototype._wordDiv = function _wordDiv (num, mode) {
    var shift = this.length - num.length;

    var a = this.clone();
    var b = num;

    // Normalize
    var bhi = b.words[b.length - 1] | 0;
    var bhiBits = this._countBits(bhi);
    shift = 26 - bhiBits;
    if (shift !== 0) {
      b = b.ushln(shift);
      a.iushln(shift);
      bhi = b.words[b.length - 1] | 0;
    }

    // Initialize quotient
    var m = a.length - b.length;
    var q;

    if (mode !== 'mod') {
      q = new BN(null);
      q.length = m + 1;
      q.words = new Array(q.length);
      for (var i = 0; i < q.length; i++) {
        q.words[i] = 0;
      }
    }

    var diff = a.clone()._ishlnsubmul(b, 1, m);
    if (diff.negative === 0) {
      a = diff;
      if (q) {
        q.words[m] = 1;
      }
    }

    for (var j = m - 1; j >= 0; j--) {
      var qj = (a.words[b.length + j] | 0) * 0x4000000 +
        (a.words[b.length + j - 1] | 0);

      // NOTE: (qj / bhi) is (0x3ffffff * 0x4000000 + 0x3ffffff) / 0x2000000 max
      // (0x7ffffff)
      qj = Math.min((qj / bhi) | 0, 0x3ffffff);

      a._ishlnsubmul(b, qj, j);
      while (a.negative !== 0) {
        qj--;
        a.negative = 0;
        a._ishlnsubmul(b, 1, j);
        if (!a.isZero()) {
          a.negative ^= 1;
        }
      }
      if (q) {
        q.words[j] = qj;
      }
    }
    if (q) {
      q.strip();
    }
    a.strip();

    // Denormalize
    if (mode !== 'div' && shift !== 0) {
      a.iushrn(shift);
    }

    return {
      div: q || null,
      mod: a
    };
  };

  // NOTE: 1) `mode` can be set to `mod` to request mod only,
  //       to `div` to request div only, or be absent to
  //       request both div & mod
  //       2) `positive` is true if unsigned mod is requested
  BN.prototype.divmod = function divmod (num, mode, positive) {
    assert(!num.isZero());

    if (this.isZero()) {
      return {
        div: new BN(0),
        mod: new BN(0)
      };
    }

    var div, mod, res;
    if (this.negative !== 0 && num.negative === 0) {
      res = this.neg().divmod(num, mode);

      if (mode !== 'mod') {
        div = res.div.neg();
      }

      if (mode !== 'div') {
        mod = res.mod.neg();
        if (positive && mod.negative !== 0) {
          mod.iadd(num);
        }
      }

      return {
        div: div,
        mod: mod
      };
    }

    if (this.negative === 0 && num.negative !== 0) {
      res = this.divmod(num.neg(), mode);

      if (mode !== 'mod') {
        div = res.div.neg();
      }

      return {
        div: div,
        mod: res.mod
      };
    }

    if ((this.negative & num.negative) !== 0) {
      res = this.neg().divmod(num.neg(), mode);

      if (mode !== 'div') {
        mod = res.mod.neg();
        if (positive && mod.negative !== 0) {
          mod.isub(num);
        }
      }

      return {
        div: res.div,
        mod: mod
      };
    }

    // Both numbers are positive at this point

    // Strip both numbers to approximate shift value
    if (num.length > this.length || this.cmp(num) < 0) {
      return {
        div: new BN(0),
        mod: this
      };
    }

    // Very short reduction
    if (num.length === 1) {
      if (mode === 'div') {
        return {
          div: this.divn(num.words[0]),
          mod: null
        };
      }

      if (mode === 'mod') {
        return {
          div: null,
          mod: new BN(this.modn(num.words[0]))
        };
      }

      return {
        div: this.divn(num.words[0]),
        mod: new BN(this.modn(num.words[0]))
      };
    }

    return this._wordDiv(num, mode);
  };

  // Find `this` / `num`
  BN.prototype.div = function div (num) {
    return this.divmod(num, 'div', false).div;
  };

  // Find `this` % `num`
  BN.prototype.mod = function mod (num) {
    return this.divmod(num, 'mod', false).mod;
  };

  BN.prototype.umod = function umod (num) {
    return this.divmod(num, 'mod', true).mod;
  };

  // Find Round(`this` / `num`)
  BN.prototype.divRound = function divRound (num) {
    var dm = this.divmod(num);

    // Fast case - exact division
    if (dm.mod.isZero()) return dm.div;

    var mod = dm.div.negative !== 0 ? dm.mod.isub(num) : dm.mod;

    var half = num.ushrn(1);
    var r2 = num.andln(1);
    var cmp = mod.cmp(half);

    // Round down
    if (cmp < 0 || r2 === 1 && cmp === 0) return dm.div;

    // Round up
    return dm.div.negative !== 0 ? dm.div.isubn(1) : dm.div.iaddn(1);
  };

  BN.prototype.modn = function modn (num) {
    assert(num <= 0x3ffffff);
    var p = (1 << 26) % num;

    var acc = 0;
    for (var i = this.length - 1; i >= 0; i--) {
      acc = (p * acc + (this.words[i] | 0)) % num;
    }

    return acc;
  };

  // In-place division by number
  BN.prototype.idivn = function idivn (num) {
    assert(num <= 0x3ffffff);

    var carry = 0;
    for (var i = this.length - 1; i >= 0; i--) {
      var w = (this.words[i] | 0) + carry * 0x4000000;
      this.words[i] = (w / num) | 0;
      carry = w % num;
    }

    return this.strip();
  };

  BN.prototype.divn = function divn (num) {
    return this.clone().idivn(num);
  };

  BN.prototype.egcd = function egcd (p) {
    assert(p.negative === 0);
    assert(!p.isZero());

    var x = this;
    var y = p.clone();

    if (x.negative !== 0) {
      x = x.umod(p);
    } else {
      x = x.clone();
    }

    // A * x + B * y = x
    var A = new BN(1);
    var B = new BN(0);

    // C * x + D * y = y
    var C = new BN(0);
    var D = new BN(1);

    var g = 0;

    while (x.isEven() && y.isEven()) {
      x.iushrn(1);
      y.iushrn(1);
      ++g;
    }

    var yp = y.clone();
    var xp = x.clone();

    while (!x.isZero()) {
      for (var i = 0, im = 1; (x.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
      if (i > 0) {
        x.iushrn(i);
        while (i-- > 0) {
          if (A.isOdd() || B.isOdd()) {
            A.iadd(yp);
            B.isub(xp);
          }

          A.iushrn(1);
          B.iushrn(1);
        }
      }

      for (var j = 0, jm = 1; (y.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
      if (j > 0) {
        y.iushrn(j);
        while (j-- > 0) {
          if (C.isOdd() || D.isOdd()) {
            C.iadd(yp);
            D.isub(xp);
          }

          C.iushrn(1);
          D.iushrn(1);
        }
      }

      if (x.cmp(y) >= 0) {
        x.isub(y);
        A.isub(C);
        B.isub(D);
      } else {
        y.isub(x);
        C.isub(A);
        D.isub(B);
      }
    }

    return {
      a: C,
      b: D,
      gcd: y.iushln(g)
    };
  };

  // This is reduced incarnation of the binary EEA
  // above, designated to invert members of the
  // _prime_ fields F(p) at a maximal speed
  BN.prototype._invmp = function _invmp (p) {
    assert(p.negative === 0);
    assert(!p.isZero());

    var a = this;
    var b = p.clone();

    if (a.negative !== 0) {
      a = a.umod(p);
    } else {
      a = a.clone();
    }

    var x1 = new BN(1);
    var x2 = new BN(0);

    var delta = b.clone();

    while (a.cmpn(1) > 0 && b.cmpn(1) > 0) {
      for (var i = 0, im = 1; (a.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
      if (i > 0) {
        a.iushrn(i);
        while (i-- > 0) {
          if (x1.isOdd()) {
            x1.iadd(delta);
          }

          x1.iushrn(1);
        }
      }

      for (var j = 0, jm = 1; (b.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
      if (j > 0) {
        b.iushrn(j);
        while (j-- > 0) {
          if (x2.isOdd()) {
            x2.iadd(delta);
          }

          x2.iushrn(1);
        }
      }

      if (a.cmp(b) >= 0) {
        a.isub(b);
        x1.isub(x2);
      } else {
        b.isub(a);
        x2.isub(x1);
      }
    }

    var res;
    if (a.cmpn(1) === 0) {
      res = x1;
    } else {
      res = x2;
    }

    if (res.cmpn(0) < 0) {
      res.iadd(p);
    }

    return res;
  };

  BN.prototype.gcd = function gcd (num) {
    if (this.isZero()) return num.abs();
    if (num.isZero()) return this.abs();

    var a = this.clone();
    var b = num.clone();
    a.negative = 0;
    b.negative = 0;

    // Remove common factor of two
    for (var shift = 0; a.isEven() && b.isEven(); shift++) {
      a.iushrn(1);
      b.iushrn(1);
    }

    do {
      while (a.isEven()) {
        a.iushrn(1);
      }
      while (b.isEven()) {
        b.iushrn(1);
      }

      var r = a.cmp(b);
      if (r < 0) {
        // Swap `a` and `b` to make `a` always bigger than `b`
        var t = a;
        a = b;
        b = t;
      } else if (r === 0 || b.cmpn(1) === 0) {
        break;
      }

      a.isub(b);
    } while (true);

    return b.iushln(shift);
  };

  // Invert number in the field F(num)
  BN.prototype.invm = function invm (num) {
    return this.egcd(num).a.umod(num);
  };

  BN.prototype.isEven = function isEven () {
    return (this.words[0] & 1) === 0;
  };

  BN.prototype.isOdd = function isOdd () {
    return (this.words[0] & 1) === 1;
  };

  // And first word and num
  BN.prototype.andln = function andln (num) {
    return this.words[0] & num;
  };

  // Increment at the bit position in-line
  BN.prototype.bincn = function bincn (bit) {
    assert(typeof bit === 'number');
    var r = bit % 26;
    var s = (bit - r) / 26;
    var q = 1 << r;

    // Fast case: bit is much higher than all existing words
    if (this.length <= s) {
      this._expand(s + 1);
      this.words[s] |= q;
      return this;
    }

    // Add bit and propagate, if needed
    var carry = q;
    for (var i = s; carry !== 0 && i < this.length; i++) {
      var w = this.words[i] | 0;
      w += carry;
      carry = w >>> 26;
      w &= 0x3ffffff;
      this.words[i] = w;
    }
    if (carry !== 0) {
      this.words[i] = carry;
      this.length++;
    }
    return this;
  };

  BN.prototype.isZero = function isZero () {
    return this.length === 1 && this.words[0] === 0;
  };

  BN.prototype.cmpn = function cmpn (num) {
    var negative = num < 0;

    if (this.negative !== 0 && !negative) return -1;
    if (this.negative === 0 && negative) return 1;

    this.strip();

    var res;
    if (this.length > 1) {
      res = 1;
    } else {
      if (negative) {
        num = -num;
      }

      assert(num <= 0x3ffffff, 'Number is too big');

      var w = this.words[0] | 0;
      res = w === num ? 0 : w < num ? -1 : 1;
    }
    if (this.negative !== 0) return -res | 0;
    return res;
  };

  // Compare two numbers and return:
  // 1 - if `this` > `num`
  // 0 - if `this` == `num`
  // -1 - if `this` < `num`
  BN.prototype.cmp = function cmp (num) {
    if (this.negative !== 0 && num.negative === 0) return -1;
    if (this.negative === 0 && num.negative !== 0) return 1;

    var res = this.ucmp(num);
    if (this.negative !== 0) return -res | 0;
    return res;
  };

  // Unsigned comparison
  BN.prototype.ucmp = function ucmp (num) {
    // At this point both numbers have the same sign
    if (this.length > num.length) return 1;
    if (this.length < num.length) return -1;

    var res = 0;
    for (var i = this.length - 1; i >= 0; i--) {
      var a = this.words[i] | 0;
      var b = num.words[i] | 0;

      if (a === b) continue;
      if (a < b) {
        res = -1;
      } else if (a > b) {
        res = 1;
      }
      break;
    }
    return res;
  };

  BN.prototype.gtn = function gtn (num) {
    return this.cmpn(num) === 1;
  };

  BN.prototype.gt = function gt (num) {
    return this.cmp(num) === 1;
  };

  BN.prototype.gten = function gten (num) {
    return this.cmpn(num) >= 0;
  };

  BN.prototype.gte = function gte (num) {
    return this.cmp(num) >= 0;
  };

  BN.prototype.ltn = function ltn (num) {
    return this.cmpn(num) === -1;
  };

  BN.prototype.lt = function lt (num) {
    return this.cmp(num) === -1;
  };

  BN.prototype.lten = function lten (num) {
    return this.cmpn(num) <= 0;
  };

  BN.prototype.lte = function lte (num) {
    return this.cmp(num) <= 0;
  };

  BN.prototype.eqn = function eqn (num) {
    return this.cmpn(num) === 0;
  };

  BN.prototype.eq = function eq (num) {
    return this.cmp(num) === 0;
  };

  //
  // A reduce context, could be using montgomery or something better, depending
  // on the `m` itself.
  //
  BN.red = function red (num) {
    return new Red(num);
  };

  BN.prototype.toRed = function toRed (ctx) {
    assert(!this.red, 'Already a number in reduction context');
    assert(this.negative === 0, 'red works only with positives');
    return ctx.convertTo(this)._forceRed(ctx);
  };

  BN.prototype.fromRed = function fromRed () {
    assert(this.red, 'fromRed works only with numbers in reduction context');
    return this.red.convertFrom(this);
  };

  BN.prototype._forceRed = function _forceRed (ctx) {
    this.red = ctx;
    return this;
  };

  BN.prototype.forceRed = function forceRed (ctx) {
    assert(!this.red, 'Already a number in reduction context');
    return this._forceRed(ctx);
  };

  BN.prototype.redAdd = function redAdd (num) {
    assert(this.red, 'redAdd works only with red numbers');
    return this.red.add(this, num);
  };

  BN.prototype.redIAdd = function redIAdd (num) {
    assert(this.red, 'redIAdd works only with red numbers');
    return this.red.iadd(this, num);
  };

  BN.prototype.redSub = function redSub (num) {
    assert(this.red, 'redSub works only with red numbers');
    return this.red.sub(this, num);
  };

  BN.prototype.redISub = function redISub (num) {
    assert(this.red, 'redISub works only with red numbers');
    return this.red.isub(this, num);
  };

  BN.prototype.redShl = function redShl (num) {
    assert(this.red, 'redShl works only with red numbers');
    return this.red.shl(this, num);
  };

  BN.prototype.redMul = function redMul (num) {
    assert(this.red, 'redMul works only with red numbers');
    this.red._verify2(this, num);
    return this.red.mul(this, num);
  };

  BN.prototype.redIMul = function redIMul (num) {
    assert(this.red, 'redMul works only with red numbers');
    this.red._verify2(this, num);
    return this.red.imul(this, num);
  };

  BN.prototype.redSqr = function redSqr () {
    assert(this.red, 'redSqr works only with red numbers');
    this.red._verify1(this);
    return this.red.sqr(this);
  };

  BN.prototype.redISqr = function redISqr () {
    assert(this.red, 'redISqr works only with red numbers');
    this.red._verify1(this);
    return this.red.isqr(this);
  };

  // Square root over p
  BN.prototype.redSqrt = function redSqrt () {
    assert(this.red, 'redSqrt works only with red numbers');
    this.red._verify1(this);
    return this.red.sqrt(this);
  };

  BN.prototype.redInvm = function redInvm () {
    assert(this.red, 'redInvm works only with red numbers');
    this.red._verify1(this);
    return this.red.invm(this);
  };

  // Return negative clone of `this` % `red modulo`
  BN.prototype.redNeg = function redNeg () {
    assert(this.red, 'redNeg works only with red numbers');
    this.red._verify1(this);
    return this.red.neg(this);
  };

  BN.prototype.redPow = function redPow (num) {
    assert(this.red && !num.red, 'redPow(normalNum)');
    this.red._verify1(this);
    return this.red.pow(this, num);
  };

  // Prime numbers with efficient reduction
  var primes = {
    k256: null,
    p224: null,
    p192: null,
    p25519: null
  };

  // Pseudo-Mersenne prime
  function MPrime (name, p) {
    // P = 2 ^ N - K
    this.name = name;
    this.p = new BN(p, 16);
    this.n = this.p.bitLength();
    this.k = new BN(1).iushln(this.n).isub(this.p);

    this.tmp = this._tmp();
  }

  MPrime.prototype._tmp = function _tmp () {
    var tmp = new BN(null);
    tmp.words = new Array(Math.ceil(this.n / 13));
    return tmp;
  };

  MPrime.prototype.ireduce = function ireduce (num) {
    // Assumes that `num` is less than `P^2`
    // num = HI * (2 ^ N - K) + HI * K + LO = HI * K + LO (mod P)
    var r = num;
    var rlen;

    do {
      this.split(r, this.tmp);
      r = this.imulK(r);
      r = r.iadd(this.tmp);
      rlen = r.bitLength();
    } while (rlen > this.n);

    var cmp = rlen < this.n ? -1 : r.ucmp(this.p);
    if (cmp === 0) {
      r.words[0] = 0;
      r.length = 1;
    } else if (cmp > 0) {
      r.isub(this.p);
    } else {
      if (r.strip !== undefined) {
        // r is BN v4 instance
        r.strip();
      } else {
        // r is BN v5 instance
        r._strip();
      }
    }

    return r;
  };

  MPrime.prototype.split = function split (input, out) {
    input.iushrn(this.n, 0, out);
  };

  MPrime.prototype.imulK = function imulK (num) {
    return num.imul(this.k);
  };

  function K256 () {
    MPrime.call(
      this,
      'k256',
      'ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f');
  }
  inherits(K256, MPrime);

  K256.prototype.split = function split (input, output) {
    // 256 = 9 * 26 + 22
    var mask = 0x3fffff;

    var outLen = Math.min(input.length, 9);
    for (var i = 0; i < outLen; i++) {
      output.words[i] = input.words[i];
    }
    output.length = outLen;

    if (input.length <= 9) {
      input.words[0] = 0;
      input.length = 1;
      return;
    }

    // Shift by 9 limbs
    var prev = input.words[9];
    output.words[output.length++] = prev & mask;

    for (i = 10; i < input.length; i++) {
      var next = input.words[i] | 0;
      input.words[i - 10] = ((next & mask) << 4) | (prev >>> 22);
      prev = next;
    }
    prev >>>= 22;
    input.words[i - 10] = prev;
    if (prev === 0 && input.length > 10) {
      input.length -= 10;
    } else {
      input.length -= 9;
    }
  };

  K256.prototype.imulK = function imulK (num) {
    // K = 0x1000003d1 = [ 0x40, 0x3d1 ]
    num.words[num.length] = 0;
    num.words[num.length + 1] = 0;
    num.length += 2;

    // bounded at: 0x40 * 0x3ffffff + 0x3d0 = 0x100000390
    var lo = 0;
    for (var i = 0; i < num.length; i++) {
      var w = num.words[i] | 0;
      lo += w * 0x3d1;
      num.words[i] = lo & 0x3ffffff;
      lo = w * 0x40 + ((lo / 0x4000000) | 0);
    }

    // Fast length reduction
    if (num.words[num.length - 1] === 0) {
      num.length--;
      if (num.words[num.length - 1] === 0) {
        num.length--;
      }
    }
    return num;
  };

  function P224 () {
    MPrime.call(
      this,
      'p224',
      'ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001');
  }
  inherits(P224, MPrime);

  function P192 () {
    MPrime.call(
      this,
      'p192',
      'ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff');
  }
  inherits(P192, MPrime);

  function P25519 () {
    // 2 ^ 255 - 19
    MPrime.call(
      this,
      '25519',
      '7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed');
  }
  inherits(P25519, MPrime);

  P25519.prototype.imulK = function imulK (num) {
    // K = 0x13
    var carry = 0;
    for (var i = 0; i < num.length; i++) {
      var hi = (num.words[i] | 0) * 0x13 + carry;
      var lo = hi & 0x3ffffff;
      hi >>>= 26;

      num.words[i] = lo;
      carry = hi;
    }
    if (carry !== 0) {
      num.words[num.length++] = carry;
    }
    return num;
  };

  // Exported mostly for testing purposes, use plain name instead
  BN._prime = function prime (name) {
    // Cached version of prime
    if (primes[name]) return primes[name];

    var prime;
    if (name === 'k256') {
      prime = new K256();
    } else if (name === 'p224') {
      prime = new P224();
    } else if (name === 'p192') {
      prime = new P192();
    } else if (name === 'p25519') {
      prime = new P25519();
    } else {
      throw new Error('Unknown prime ' + name);
    }
    primes[name] = prime;

    return prime;
  };

  //
  // Base reduction engine
  //
  function Red (m) {
    if (typeof m === 'string') {
      var prime = BN._prime(m);
      this.m = prime.p;
      this.prime = prime;
    } else {
      assert(m.gtn(1), 'modulus must be greater than 1');
      this.m = m;
      this.prime = null;
    }
  }

  Red.prototype._verify1 = function _verify1 (a) {
    assert(a.negative === 0, 'red works only with positives');
    assert(a.red, 'red works only with red numbers');
  };

  Red.prototype._verify2 = function _verify2 (a, b) {
    assert((a.negative | b.negative) === 0, 'red works only with positives');
    assert(a.red && a.red === b.red,
      'red works only with red numbers');
  };

  Red.prototype.imod = function imod (a) {
    if (this.prime) return this.prime.ireduce(a)._forceRed(this);
    return a.umod(this.m)._forceRed(this);
  };

  Red.prototype.neg = function neg (a) {
    if (a.isZero()) {
      return a.clone();
    }

    return this.m.sub(a)._forceRed(this);
  };

  Red.prototype.add = function add (a, b) {
    this._verify2(a, b);

    var res = a.add(b);
    if (res.cmp(this.m) >= 0) {
      res.isub(this.m);
    }
    return res._forceRed(this);
  };

  Red.prototype.iadd = function iadd (a, b) {
    this._verify2(a, b);

    var res = a.iadd(b);
    if (res.cmp(this.m) >= 0) {
      res.isub(this.m);
    }
    return res;
  };

  Red.prototype.sub = function sub (a, b) {
    this._verify2(a, b);

    var res = a.sub(b);
    if (res.cmpn(0) < 0) {
      res.iadd(this.m);
    }
    return res._forceRed(this);
  };

  Red.prototype.isub = function isub (a, b) {
    this._verify2(a, b);

    var res = a.isub(b);
    if (res.cmpn(0) < 0) {
      res.iadd(this.m);
    }
    return res;
  };

  Red.prototype.shl = function shl (a, num) {
    this._verify1(a);
    return this.imod(a.ushln(num));
  };

  Red.prototype.imul = function imul (a, b) {
    this._verify2(a, b);
    return this.imod(a.imul(b));
  };

  Red.prototype.mul = function mul (a, b) {
    this._verify2(a, b);
    return this.imod(a.mul(b));
  };

  Red.prototype.isqr = function isqr (a) {
    return this.imul(a, a.clone());
  };

  Red.prototype.sqr = function sqr (a) {
    return this.mul(a, a);
  };

  Red.prototype.sqrt = function sqrt (a) {
    if (a.isZero()) return a.clone();

    var mod3 = this.m.andln(3);
    assert(mod3 % 2 === 1);

    // Fast case
    if (mod3 === 3) {
      var pow = this.m.add(new BN(1)).iushrn(2);
      return this.pow(a, pow);
    }

    // Tonelli-Shanks algorithm (Totally unoptimized and slow)
    //
    // Find Q and S, that Q * 2 ^ S = (P - 1)
    var q = this.m.subn(1);
    var s = 0;
    while (!q.isZero() && q.andln(1) === 0) {
      s++;
      q.iushrn(1);
    }
    assert(!q.isZero());

    var one = new BN(1).toRed(this);
    var nOne = one.redNeg();

    // Find quadratic non-residue
    // NOTE: Max is such because of generalized Riemann hypothesis.
    var lpow = this.m.subn(1).iushrn(1);
    var z = this.m.bitLength();
    z = new BN(2 * z * z).toRed(this);

    while (this.pow(z, lpow).cmp(nOne) !== 0) {
      z.redIAdd(nOne);
    }

    var c = this.pow(z, q);
    var r = this.pow(a, q.addn(1).iushrn(1));
    var t = this.pow(a, q);
    var m = s;
    while (t.cmp(one) !== 0) {
      var tmp = t;
      for (var i = 0; tmp.cmp(one) !== 0; i++) {
        tmp = tmp.redSqr();
      }
      assert(i < m);
      var b = this.pow(c, new BN(1).iushln(m - i - 1));

      r = r.redMul(b);
      c = b.redSqr();
      t = t.redMul(c);
      m = i;
    }

    return r;
  };

  Red.prototype.invm = function invm (a) {
    var inv = a._invmp(this.m);
    if (inv.negative !== 0) {
      inv.negative = 0;
      return this.imod(inv).redNeg();
    } else {
      return this.imod(inv);
    }
  };

  Red.prototype.pow = function pow (a, num) {
    if (num.isZero()) return new BN(1).toRed(this);
    if (num.cmpn(1) === 0) return a.clone();

    var windowSize = 4;
    var wnd = new Array(1 << windowSize);
    wnd[0] = new BN(1).toRed(this);
    wnd[1] = a;
    for (var i = 2; i < wnd.length; i++) {
      wnd[i] = this.mul(wnd[i - 1], a);
    }

    var res = wnd[0];
    var current = 0;
    var currentLen = 0;
    var start = num.bitLength() % 26;
    if (start === 0) {
      start = 26;
    }

    for (i = num.length - 1; i >= 0; i--) {
      var word = num.words[i];
      for (var j = start - 1; j >= 0; j--) {
        var bit = (word >> j) & 1;
        if (res !== wnd[0]) {
          res = this.sqr(res);
        }

        if (bit === 0 && current === 0) {
          currentLen = 0;
          continue;
        }

        current <<= 1;
        current |= bit;
        currentLen++;
        if (currentLen !== windowSize && (i !== 0 || j !== 0)) continue;

        res = this.mul(res, wnd[current]);
        currentLen = 0;
        current = 0;
      }
      start = 26;
    }

    return res;
  };

  Red.prototype.convertTo = function convertTo (num) {
    var r = num.umod(this.m);

    return r === num ? r.clone() : r;
  };

  Red.prototype.convertFrom = function convertFrom (num) {
    var res = num.clone();
    res.red = null;
    return res;
  };

  //
  // Montgomery method engine
  //

  BN.mont = function mont (num) {
    return new Mont(num);
  };

  function Mont (m) {
    Red.call(this, m);

    this.shift = this.m.bitLength();
    if (this.shift % 26 !== 0) {
      this.shift += 26 - (this.shift % 26);
    }

    this.r = new BN(1).iushln(this.shift);
    this.r2 = this.imod(this.r.sqr());
    this.rinv = this.r._invmp(this.m);

    this.minv = this.rinv.mul(this.r).isubn(1).div(this.m);
    this.minv = this.minv.umod(this.r);
    this.minv = this.r.sub(this.minv);
  }
  inherits(Mont, Red);

  Mont.prototype.convertTo = function convertTo (num) {
    return this.imod(num.ushln(this.shift));
  };

  Mont.prototype.convertFrom = function convertFrom (num) {
    var r = this.imod(num.mul(this.rinv));
    r.red = null;
    return r;
  };

  Mont.prototype.imul = function imul (a, b) {
    if (a.isZero() || b.isZero()) {
      a.words[0] = 0;
      a.length = 1;
      return a;
    }

    var t = a.imul(b);
    var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
    var u = t.isub(c).iushrn(this.shift);
    var res = u;

    if (u.cmp(this.m) >= 0) {
      res = u.isub(this.m);
    } else if (u.cmpn(0) < 0) {
      res = u.iadd(this.m);
    }

    return res._forceRed(this);
  };

  Mont.prototype.mul = function mul (a, b) {
    if (a.isZero() || b.isZero()) return new BN(0)._forceRed(this);

    var t = a.mul(b);
    var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
    var u = t.isub(c).iushrn(this.shift);
    var res = u;
    if (u.cmp(this.m) >= 0) {
      res = u.isub(this.m);
    } else if (u.cmpn(0) < 0) {
      res = u.iadd(this.m);
    }

    return res._forceRed(this);
  };

  Mont.prototype.invm = function invm (a) {
    // (AR)^-1 * R^2 = (A^-1 * R^-1) * R^2 = A^-1 * R
    var res = this.imod(a._invmp(this.m).mul(this.r2));
    return res._forceRed(this);
  };
})( false || module, this);

/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(/*! ./../../../../webpack/buildin/module.js */ "./node_modules/webpack/buildin/module.js")(module)))

/***/ }),

/***/ "./node_modules/elliptic/lib/elliptic.js":
/*!***********************************************!*\
  !*** ./node_modules/elliptic/lib/elliptic.js ***!
  \***********************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var elliptic = exports;

elliptic.version = __webpack_require__(/*! ../package.json */ "./node_modules/elliptic/package.json").version;
elliptic.utils = __webpack_require__(/*! ./elliptic/utils */ "./node_modules/elliptic/lib/elliptic/utils.js");
elliptic.rand = __webpack_require__(/*! brorand */ "./node_modules/brorand/index.js");
elliptic.curve = __webpack_require__(/*! ./elliptic/curve */ "./node_modules/elliptic/lib/elliptic/curve/index.js");
elliptic.curves = __webpack_require__(/*! ./elliptic/curves */ "./node_modules/elliptic/lib/elliptic/curves.js");

// Protocols
elliptic.ec = __webpack_require__(/*! ./elliptic/ec */ "./node_modules/elliptic/lib/elliptic/ec/index.js");
elliptic.eddsa = __webpack_require__(/*! ./elliptic/eddsa */ "./node_modules/elliptic/lib/elliptic/eddsa/index.js");


/***/ }),

/***/ "./node_modules/elliptic/lib/elliptic/curve/base.js":
/*!**********************************************************!*\
  !*** ./node_modules/elliptic/lib/elliptic/curve/base.js ***!
  \**********************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var BN = __webpack_require__(/*! bn.js */ "./node_modules/elliptic/node_modules/bn.js/lib/bn.js");
var utils = __webpack_require__(/*! ../utils */ "./node_modules/elliptic/lib/elliptic/utils.js");
var getNAF = utils.getNAF;
var getJSF = utils.getJSF;
var assert = utils.assert;

function BaseCurve(type, conf) {
  this.type = type;
  this.p = new BN(conf.p, 16);

  // Use Montgomery, when there is no fast reduction for the prime
  this.red = conf.prime ? BN.red(conf.prime) : BN.mont(this.p);

  // Useful for many curves
  this.zero = new BN(0).toRed(this.red);
  this.one = new BN(1).toRed(this.red);
  this.two = new BN(2).toRed(this.red);

  // Curve configuration, optional
  this.n = conf.n && new BN(conf.n, 16);
  this.g = conf.g && this.pointFromJSON(conf.g, conf.gRed);

  // Temporary arrays
  this._wnafT1 = new Array(4);
  this._wnafT2 = new Array(4);
  this._wnafT3 = new Array(4);
  this._wnafT4 = new Array(4);

  this._bitLength = this.n ? this.n.bitLength() : 0;

  // Generalized Greg Maxwell's trick
  var adjustCount = this.n && this.p.div(this.n);
  if (!adjustCount || adjustCount.cmpn(100) > 0) {
    this.redN = null;
  } else {
    this._maxwellTrick = true;
    this.redN = this.n.toRed(this.red);
  }
}
module.exports = BaseCurve;

BaseCurve.prototype.point = function point() {
  throw new Error('Not implemented');
};

BaseCurve.prototype.validate = function validate() {
  throw new Error('Not implemented');
};

BaseCurve.prototype._fixedNafMul = function _fixedNafMul(p, k) {
  assert(p.precomputed);
  var doubles = p._getDoubles();

  var naf = getNAF(k, 1, this._bitLength);
  var I = (1 << (doubles.step + 1)) - (doubles.step % 2 === 0 ? 2 : 1);
  I /= 3;

  // Translate into more windowed form
  var repr = [];
  for (var j = 0; j < naf.length; j += doubles.step) {
    var nafW = 0;
    for (var k = j + doubles.step - 1; k >= j; k--)
      nafW = (nafW << 1) + naf[k];
    repr.push(nafW);
  }

  var a = this.jpoint(null, null, null);
  var b = this.jpoint(null, null, null);
  for (var i = I; i > 0; i--) {
    for (var j = 0; j < repr.length; j++) {
      var nafW = repr[j];
      if (nafW === i)
        b = b.mixedAdd(doubles.points[j]);
      else if (nafW === -i)
        b = b.mixedAdd(doubles.points[j].neg());
    }
    a = a.add(b);
  }
  return a.toP();
};

BaseCurve.prototype._wnafMul = function _wnafMul(p, k) {
  var w = 4;

  // Precompute window
  var nafPoints = p._getNAFPoints(w);
  w = nafPoints.wnd;
  var wnd = nafPoints.points;

  // Get NAF form
  var naf = getNAF(k, w, this._bitLength);

  // Add `this`*(N+1) for every w-NAF index
  var acc = this.jpoint(null, null, null);
  for (var i = naf.length - 1; i >= 0; i--) {
    // Count zeroes
    for (var k = 0; i >= 0 && naf[i] === 0; i--)
      k++;
    if (i >= 0)
      k++;
    acc = acc.dblp(k);

    if (i < 0)
      break;
    var z = naf[i];
    assert(z !== 0);
    if (p.type === 'affine') {
      // J +- P
      if (z > 0)
        acc = acc.mixedAdd(wnd[(z - 1) >> 1]);
      else
        acc = acc.mixedAdd(wnd[(-z - 1) >> 1].neg());
    } else {
      // J +- J
      if (z > 0)
        acc = acc.add(wnd[(z - 1) >> 1]);
      else
        acc = acc.add(wnd[(-z - 1) >> 1].neg());
    }
  }
  return p.type === 'affine' ? acc.toP() : acc;
};

BaseCurve.prototype._wnafMulAdd = function _wnafMulAdd(defW,
                                                       points,
                                                       coeffs,
                                                       len,
                                                       jacobianResult) {
  var wndWidth = this._wnafT1;
  var wnd = this._wnafT2;
  var naf = this._wnafT3;

  // Fill all arrays
  var max = 0;
  for (var i = 0; i < len; i++) {
    var p = points[i];
    var nafPoints = p._getNAFPoints(defW);
    wndWidth[i] = nafPoints.wnd;
    wnd[i] = nafPoints.points;
  }

  // Comb small window NAFs
  for (var i = len - 1; i >= 1; i -= 2) {
    var a = i - 1;
    var b = i;
    if (wndWidth[a] !== 1 || wndWidth[b] !== 1) {
      naf[a] = getNAF(coeffs[a], wndWidth[a], this._bitLength);
      naf[b] = getNAF(coeffs[b], wndWidth[b], this._bitLength);
      max = Math.max(naf[a].length, max);
      max = Math.max(naf[b].length, max);
      continue;
    }

    var comb = [
      points[a], /* 1 */
      null, /* 3 */
      null, /* 5 */
      points[b] /* 7 */
    ];

    // Try to avoid Projective points, if possible
    if (points[a].y.cmp(points[b].y) === 0) {
      comb[1] = points[a].add(points[b]);
      comb[2] = points[a].toJ().mixedAdd(points[b].neg());
    } else if (points[a].y.cmp(points[b].y.redNeg()) === 0) {
      comb[1] = points[a].toJ().mixedAdd(points[b]);
      comb[2] = points[a].add(points[b].neg());
    } else {
      comb[1] = points[a].toJ().mixedAdd(points[b]);
      comb[2] = points[a].toJ().mixedAdd(points[b].neg());
    }

    var index = [
      -3, /* -1 -1 */
      -1, /* -1 0 */
      -5, /* -1 1 */
      -7, /* 0 -1 */
      0, /* 0 0 */
      7, /* 0 1 */
      5, /* 1 -1 */
      1, /* 1 0 */
      3  /* 1 1 */
    ];

    var jsf = getJSF(coeffs[a], coeffs[b]);
    max = Math.max(jsf[0].length, max);
    naf[a] = new Array(max);
    naf[b] = new Array(max);
    for (var j = 0; j < max; j++) {
      var ja = jsf[0][j] | 0;
      var jb = jsf[1][j] | 0;

      naf[a][j] = index[(ja + 1) * 3 + (jb + 1)];
      naf[b][j] = 0;
      wnd[a] = comb;
    }
  }

  var acc = this.jpoint(null, null, null);
  var tmp = this._wnafT4;
  for (var i = max; i >= 0; i--) {
    var k = 0;

    while (i >= 0) {
      var zero = true;
      for (var j = 0; j < len; j++) {
        tmp[j] = naf[j][i] | 0;
        if (tmp[j] !== 0)
          zero = false;
      }
      if (!zero)
        break;
      k++;
      i--;
    }
    if (i >= 0)
      k++;
    acc = acc.dblp(k);
    if (i < 0)
      break;

    for (var j = 0; j < len; j++) {
      var z = tmp[j];
      var p;
      if (z === 0)
        continue;
      else if (z > 0)
        p = wnd[j][(z - 1) >> 1];
      else if (z < 0)
        p = wnd[j][(-z - 1) >> 1].neg();

      if (p.type === 'affine')
        acc = acc.mixedAdd(p);
      else
        acc = acc.add(p);
    }
  }
  // Zeroify references
  for (var i = 0; i < len; i++)
    wnd[i] = null;

  if (jacobianResult)
    return acc;
  else
    return acc.toP();
};

function BasePoint(curve, type) {
  this.curve = curve;
  this.type = type;
  this.precomputed = null;
}
BaseCurve.BasePoint = BasePoint;

BasePoint.prototype.eq = function eq(/*other*/) {
  throw new Error('Not implemented');
};

BasePoint.prototype.validate = function validate() {
  return this.curve.validate(this);
};

BaseCurve.prototype.decodePoint = function decodePoint(bytes, enc) {
  bytes = utils.toArray(bytes, enc);

  var len = this.p.byteLength();

  // uncompressed, hybrid-odd, hybrid-even
  if ((bytes[0] === 0x04 || bytes[0] === 0x06 || bytes[0] === 0x07) &&
      bytes.length - 1 === 2 * len) {
    if (bytes[0] === 0x06)
      assert(bytes[bytes.length - 1] % 2 === 0);
    else if (bytes[0] === 0x07)
      assert(bytes[bytes.length - 1] % 2 === 1);

    var res =  this.point(bytes.slice(1, 1 + len),
                          bytes.slice(1 + len, 1 + 2 * len));

    return res;
  } else if ((bytes[0] === 0x02 || bytes[0] === 0x03) &&
              bytes.length - 1 === len) {
    return this.pointFromX(bytes.slice(1, 1 + len), bytes[0] === 0x03);
  }
  throw new Error('Unknown point format');
};

BasePoint.prototype.encodeCompressed = function encodeCompressed(enc) {
  return this.encode(enc, true);
};

BasePoint.prototype._encode = function _encode(compact) {
  var len = this.curve.p.byteLength();
  var x = this.getX().toArray('be', len);

  if (compact)
    return [ this.getY().isEven() ? 0x02 : 0x03 ].concat(x);

  return [ 0x04 ].concat(x, this.getY().toArray('be', len)) ;
};

BasePoint.prototype.encode = function encode(enc, compact) {
  return utils.encode(this._encode(compact), enc);
};

BasePoint.prototype.precompute = function precompute(power) {
  if (this.precomputed)
    return this;

  var precomputed = {
    doubles: null,
    naf: null,
    beta: null
  };
  precomputed.naf = this._getNAFPoints(8);
  precomputed.doubles = this._getDoubles(4, power);
  precomputed.beta = this._getBeta();
  this.precomputed = precomputed;

  return this;
};

BasePoint.prototype._hasDoubles = function _hasDoubles(k) {
  if (!this.precomputed)
    return false;

  var doubles = this.precomputed.doubles;
  if (!doubles)
    return false;

  return doubles.points.length >= Math.ceil((k.bitLength() + 1) / doubles.step);
};

BasePoint.prototype._getDoubles = function _getDoubles(step, power) {
  if (this.precomputed && this.precomputed.doubles)
    return this.precomputed.doubles;

  var doubles = [ this ];
  var acc = this;
  for (var i = 0; i < power; i += step) {
    for (var j = 0; j < step; j++)
      acc = acc.dbl();
    doubles.push(acc);
  }
  return {
    step: step,
    points: doubles
  };
};

BasePoint.prototype._getNAFPoints = function _getNAFPoints(wnd) {
  if (this.precomputed && this.precomputed.naf)
    return this.precomputed.naf;

  var res = [ this ];
  var max = (1 << wnd) - 1;
  var dbl = max === 1 ? null : this.dbl();
  for (var i = 1; i < max; i++)
    res[i] = res[i - 1].add(dbl);
  return {
    wnd: wnd,
    points: res
  };
};

BasePoint.prototype._getBeta = function _getBeta() {
  return null;
};

BasePoint.prototype.dblp = function dblp(k) {
  var r = this;
  for (var i = 0; i < k; i++)
    r = r.dbl();
  return r;
};


/***/ }),

/***/ "./node_modules/elliptic/lib/elliptic/curve/edwards.js":
/*!*************************************************************!*\
  !*** ./node_modules/elliptic/lib/elliptic/curve/edwards.js ***!
  \*************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(/*! ../utils */ "./node_modules/elliptic/lib/elliptic/utils.js");
var BN = __webpack_require__(/*! bn.js */ "./node_modules/elliptic/node_modules/bn.js/lib/bn.js");
var inherits = __webpack_require__(/*! inherits */ "./node_modules/inherits/inherits_browser.js");
var Base = __webpack_require__(/*! ./base */ "./node_modules/elliptic/lib/elliptic/curve/base.js");

var assert = utils.assert;

function EdwardsCurve(conf) {
  // NOTE: Important as we are creating point in Base.call()
  this.twisted = (conf.a | 0) !== 1;
  this.mOneA = this.twisted && (conf.a | 0) === -1;
  this.extended = this.mOneA;

  Base.call(this, 'edwards', conf);

  this.a = new BN(conf.a, 16).umod(this.red.m);
  this.a = this.a.toRed(this.red);
  this.c = new BN(conf.c, 16).toRed(this.red);
  this.c2 = this.c.redSqr();
  this.d = new BN(conf.d, 16).toRed(this.red);
  this.dd = this.d.redAdd(this.d);

  assert(!this.twisted || this.c.fromRed().cmpn(1) === 0);
  this.oneC = (conf.c | 0) === 1;
}
inherits(EdwardsCurve, Base);
module.exports = EdwardsCurve;

EdwardsCurve.prototype._mulA = function _mulA(num) {
  if (this.mOneA)
    return num.redNeg();
  else
    return this.a.redMul(num);
};

EdwardsCurve.prototype._mulC = function _mulC(num) {
  if (this.oneC)
    return num;
  else
    return this.c.redMul(num);
};

// Just for compatibility with Short curve
EdwardsCurve.prototype.jpoint = function jpoint(x, y, z, t) {
  return this.point(x, y, z, t);
};

EdwardsCurve.prototype.pointFromX = function pointFromX(x, odd) {
  x = new BN(x, 16);
  if (!x.red)
    x = x.toRed(this.red);

  var x2 = x.redSqr();
  var rhs = this.c2.redSub(this.a.redMul(x2));
  var lhs = this.one.redSub(this.c2.redMul(this.d).redMul(x2));

  var y2 = rhs.redMul(lhs.redInvm());
  var y = y2.redSqrt();
  if (y.redSqr().redSub(y2).cmp(this.zero) !== 0)
    throw new Error('invalid point');

  var isOdd = y.fromRed().isOdd();
  if (odd && !isOdd || !odd && isOdd)
    y = y.redNeg();

  return this.point(x, y);
};

EdwardsCurve.prototype.pointFromY = function pointFromY(y, odd) {
  y = new BN(y, 16);
  if (!y.red)
    y = y.toRed(this.red);

  // x^2 = (y^2 - c^2) / (c^2 d y^2 - a)
  var y2 = y.redSqr();
  var lhs = y2.redSub(this.c2);
  var rhs = y2.redMul(this.d).redMul(this.c2).redSub(this.a);
  var x2 = lhs.redMul(rhs.redInvm());

  if (x2.cmp(this.zero) === 0) {
    if (odd)
      throw new Error('invalid point');
    else
      return this.point(this.zero, y);
  }

  var x = x2.redSqrt();
  if (x.redSqr().redSub(x2).cmp(this.zero) !== 0)
    throw new Error('invalid point');

  if (x.fromRed().isOdd() !== odd)
    x = x.redNeg();

  return this.point(x, y);
};

EdwardsCurve.prototype.validate = function validate(point) {
  if (point.isInfinity())
    return true;

  // Curve: A * X^2 + Y^2 = C^2 * (1 + D * X^2 * Y^2)
  point.normalize();

  var x2 = point.x.redSqr();
  var y2 = point.y.redSqr();
  var lhs = x2.redMul(this.a).redAdd(y2);
  var rhs = this.c2.redMul(this.one.redAdd(this.d.redMul(x2).redMul(y2)));

  return lhs.cmp(rhs) === 0;
};

function Point(curve, x, y, z, t) {
  Base.BasePoint.call(this, curve, 'projective');
  if (x === null && y === null && z === null) {
    this.x = this.curve.zero;
    this.y = this.curve.one;
    this.z = this.curve.one;
    this.t = this.curve.zero;
    this.zOne = true;
  } else {
    this.x = new BN(x, 16);
    this.y = new BN(y, 16);
    this.z = z ? new BN(z, 16) : this.curve.one;
    this.t = t && new BN(t, 16);
    if (!this.x.red)
      this.x = this.x.toRed(this.curve.red);
    if (!this.y.red)
      this.y = this.y.toRed(this.curve.red);
    if (!this.z.red)
      this.z = this.z.toRed(this.curve.red);
    if (this.t && !this.t.red)
      this.t = this.t.toRed(this.curve.red);
    this.zOne = this.z === this.curve.one;

    // Use extended coordinates
    if (this.curve.extended && !this.t) {
      this.t = this.x.redMul(this.y);
      if (!this.zOne)
        this.t = this.t.redMul(this.z.redInvm());
    }
  }
}
inherits(Point, Base.BasePoint);

EdwardsCurve.prototype.pointFromJSON = function pointFromJSON(obj) {
  return Point.fromJSON(this, obj);
};

EdwardsCurve.prototype.point = function point(x, y, z, t) {
  return new Point(this, x, y, z, t);
};

Point.fromJSON = function fromJSON(curve, obj) {
  return new Point(curve, obj[0], obj[1], obj[2]);
};

Point.prototype.inspect = function inspect() {
  if (this.isInfinity())
    return '<EC Point Infinity>';
  return '<EC Point x: ' + this.x.fromRed().toString(16, 2) +
      ' y: ' + this.y.fromRed().toString(16, 2) +
      ' z: ' + this.z.fromRed().toString(16, 2) + '>';
};

Point.prototype.isInfinity = function isInfinity() {
  // XXX This code assumes that zero is always zero in red
  return this.x.cmpn(0) === 0 &&
    (this.y.cmp(this.z) === 0 ||
    (this.zOne && this.y.cmp(this.curve.c) === 0));
};

Point.prototype._extDbl = function _extDbl() {
  // hyperelliptic.org/EFD/g1p/auto-twisted-extended-1.html
  //     #doubling-dbl-2008-hwcd
  // 4M + 4S

  // A = X1^2
  var a = this.x.redSqr();
  // B = Y1^2
  var b = this.y.redSqr();
  // C = 2 * Z1^2
  var c = this.z.redSqr();
  c = c.redIAdd(c);
  // D = a * A
  var d = this.curve._mulA(a);
  // E = (X1 + Y1)^2 - A - B
  var e = this.x.redAdd(this.y).redSqr().redISub(a).redISub(b);
  // G = D + B
  var g = d.redAdd(b);
  // F = G - C
  var f = g.redSub(c);
  // H = D - B
  var h = d.redSub(b);
  // X3 = E * F
  var nx = e.redMul(f);
  // Y3 = G * H
  var ny = g.redMul(h);
  // T3 = E * H
  var nt = e.redMul(h);
  // Z3 = F * G
  var nz = f.redMul(g);
  return this.curve.point(nx, ny, nz, nt);
};

Point.prototype._projDbl = function _projDbl() {
  // hyperelliptic.org/EFD/g1p/auto-twisted-projective.html
  //     #doubling-dbl-2008-bbjlp
  //     #doubling-dbl-2007-bl
  // and others
  // Generally 3M + 4S or 2M + 4S

  // B = (X1 + Y1)^2
  var b = this.x.redAdd(this.y).redSqr();
  // C = X1^2
  var c = this.x.redSqr();
  // D = Y1^2
  var d = this.y.redSqr();

  var nx;
  var ny;
  var nz;
  if (this.curve.twisted) {
    // E = a * C
    var e = this.curve._mulA(c);
    // F = E + D
    var f = e.redAdd(d);
    if (this.zOne) {
      // X3 = (B - C - D) * (F - 2)
      nx = b.redSub(c).redSub(d).redMul(f.redSub(this.curve.two));
      // Y3 = F * (E - D)
      ny = f.redMul(e.redSub(d));
      // Z3 = F^2 - 2 * F
      nz = f.redSqr().redSub(f).redSub(f);
    } else {
      // H = Z1^2
      var h = this.z.redSqr();
      // J = F - 2 * H
      var j = f.redSub(h).redISub(h);
      // X3 = (B-C-D)*J
      nx = b.redSub(c).redISub(d).redMul(j);
      // Y3 = F * (E - D)
      ny = f.redMul(e.redSub(d));
      // Z3 = F * J
      nz = f.redMul(j);
    }
  } else {
    // E = C + D
    var e = c.redAdd(d);
    // H = (c * Z1)^2
    var h = this.curve._mulC(this.z).redSqr();
    // J = E - 2 * H
    var j = e.redSub(h).redSub(h);
    // X3 = c * (B - E) * J
    nx = this.curve._mulC(b.redISub(e)).redMul(j);
    // Y3 = c * E * (C - D)
    ny = this.curve._mulC(e).redMul(c.redISub(d));
    // Z3 = E * J
    nz = e.redMul(j);
  }
  return this.curve.point(nx, ny, nz);
};

Point.prototype.dbl = function dbl() {
  if (this.isInfinity())
    return this;

  // Double in extended coordinates
  if (this.curve.extended)
    return this._extDbl();
  else
    return this._projDbl();
};

Point.prototype._extAdd = function _extAdd(p) {
  // hyperelliptic.org/EFD/g1p/auto-twisted-extended-1.html
  //     #addition-add-2008-hwcd-3
  // 8M

  // A = (Y1 - X1) * (Y2 - X2)
  var a = this.y.redSub(this.x).redMul(p.y.redSub(p.x));
  // B = (Y1 + X1) * (Y2 + X2)
  var b = this.y.redAdd(this.x).redMul(p.y.redAdd(p.x));
  // C = T1 * k * T2
  var c = this.t.redMul(this.curve.dd).redMul(p.t);
  // D = Z1 * 2 * Z2
  var d = this.z.redMul(p.z.redAdd(p.z));
  // E = B - A
  var e = b.redSub(a);
  // F = D - C
  var f = d.redSub(c);
  // G = D + C
  var g = d.redAdd(c);
  // H = B + A
  var h = b.redAdd(a);
  // X3 = E * F
  var nx = e.redMul(f);
  // Y3 = G * H
  var ny = g.redMul(h);
  // T3 = E * H
  var nt = e.redMul(h);
  // Z3 = F * G
  var nz = f.redMul(g);
  return this.curve.point(nx, ny, nz, nt);
};

Point.prototype._projAdd = function _projAdd(p) {
  // hyperelliptic.org/EFD/g1p/auto-twisted-projective.html
  //     #addition-add-2008-bbjlp
  //     #addition-add-2007-bl
  // 10M + 1S

  // A = Z1 * Z2
  var a = this.z.redMul(p.z);
  // B = A^2
  var b = a.redSqr();
  // C = X1 * X2
  var c = this.x.redMul(p.x);
  // D = Y1 * Y2
  var d = this.y.redMul(p.y);
  // E = d * C * D
  var e = this.curve.d.redMul(c).redMul(d);
  // F = B - E
  var f = b.redSub(e);
  // G = B + E
  var g = b.redAdd(e);
  // X3 = A * F * ((X1 + Y1) * (X2 + Y2) - C - D)
  var tmp = this.x.redAdd(this.y).redMul(p.x.redAdd(p.y)).redISub(c).redISub(d);
  var nx = a.redMul(f).redMul(tmp);
  var ny;
  var nz;
  if (this.curve.twisted) {
    // Y3 = A * G * (D - a * C)
    ny = a.redMul(g).redMul(d.redSub(this.curve._mulA(c)));
    // Z3 = F * G
    nz = f.redMul(g);
  } else {
    // Y3 = A * G * (D - C)
    ny = a.redMul(g).redMul(d.redSub(c));
    // Z3 = c * F * G
    nz = this.curve._mulC(f).redMul(g);
  }
  return this.curve.point(nx, ny, nz);
};

Point.prototype.add = function add(p) {
  if (this.isInfinity())
    return p;
  if (p.isInfinity())
    return this;

  if (this.curve.extended)
    return this._extAdd(p);
  else
    return this._projAdd(p);
};

Point.prototype.mul = function mul(k) {
  if (this._hasDoubles(k))
    return this.curve._fixedNafMul(this, k);
  else
    return this.curve._wnafMul(this, k);
};

Point.prototype.mulAdd = function mulAdd(k1, p, k2) {
  return this.curve._wnafMulAdd(1, [ this, p ], [ k1, k2 ], 2, false);
};

Point.prototype.jmulAdd = function jmulAdd(k1, p, k2) {
  return this.curve._wnafMulAdd(1, [ this, p ], [ k1, k2 ], 2, true);
};

Point.prototype.normalize = function normalize() {
  if (this.zOne)
    return this;

  // Normalize coordinates
  var zi = this.z.redInvm();
  this.x = this.x.redMul(zi);
  this.y = this.y.redMul(zi);
  if (this.t)
    this.t = this.t.redMul(zi);
  this.z = this.curve.one;
  this.zOne = true;
  return this;
};

Point.prototype.neg = function neg() {
  return this.curve.point(this.x.redNeg(),
                          this.y,
                          this.z,
                          this.t && this.t.redNeg());
};

Point.prototype.getX = function getX() {
  this.normalize();
  return this.x.fromRed();
};

Point.prototype.getY = function getY() {
  this.normalize();
  return this.y.fromRed();
};

Point.prototype.eq = function eq(other) {
  return this === other ||
         this.getX().cmp(other.getX()) === 0 &&
         this.getY().cmp(other.getY()) === 0;
};

Point.prototype.eqXToP = function eqXToP(x) {
  var rx = x.toRed(this.curve.red).redMul(this.z);
  if (this.x.cmp(rx) === 0)
    return true;

  var xc = x.clone();
  var t = this.curve.redN.redMul(this.z);
  for (;;) {
    xc.iadd(this.curve.n);
    if (xc.cmp(this.curve.p) >= 0)
      return false;

    rx.redIAdd(t);
    if (this.x.cmp(rx) === 0)
      return true;
  }
};

// Compatibility with BaseCurve
Point.prototype.toP = Point.prototype.normalize;
Point.prototype.mixedAdd = Point.prototype.add;


/***/ }),

/***/ "./node_modules/elliptic/lib/elliptic/curve/index.js":
/*!***********************************************************!*\
  !*** ./node_modules/elliptic/lib/elliptic/curve/index.js ***!
  \***********************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var curve = exports;

curve.base = __webpack_require__(/*! ./base */ "./node_modules/elliptic/lib/elliptic/curve/base.js");
curve.short = __webpack_require__(/*! ./short */ "./node_modules/elliptic/lib/elliptic/curve/short.js");
curve.mont = __webpack_require__(/*! ./mont */ "./node_modules/elliptic/lib/elliptic/curve/mont.js");
curve.edwards = __webpack_require__(/*! ./edwards */ "./node_modules/elliptic/lib/elliptic/curve/edwards.js");


/***/ }),

/***/ "./node_modules/elliptic/lib/elliptic/curve/mont.js":
/*!**********************************************************!*\
  !*** ./node_modules/elliptic/lib/elliptic/curve/mont.js ***!
  \**********************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var BN = __webpack_require__(/*! bn.js */ "./node_modules/elliptic/node_modules/bn.js/lib/bn.js");
var inherits = __webpack_require__(/*! inherits */ "./node_modules/inherits/inherits_browser.js");
var Base = __webpack_require__(/*! ./base */ "./node_modules/elliptic/lib/elliptic/curve/base.js");

var utils = __webpack_require__(/*! ../utils */ "./node_modules/elliptic/lib/elliptic/utils.js");

function MontCurve(conf) {
  Base.call(this, 'mont', conf);

  this.a = new BN(conf.a, 16).toRed(this.red);
  this.b = new BN(conf.b, 16).toRed(this.red);
  this.i4 = new BN(4).toRed(this.red).redInvm();
  this.two = new BN(2).toRed(this.red);
  this.a24 = this.i4.redMul(this.a.redAdd(this.two));
}
inherits(MontCurve, Base);
module.exports = MontCurve;

MontCurve.prototype.validate = function validate(point) {
  var x = point.normalize().x;
  var x2 = x.redSqr();
  var rhs = x2.redMul(x).redAdd(x2.redMul(this.a)).redAdd(x);
  var y = rhs.redSqrt();

  return y.redSqr().cmp(rhs) === 0;
};

function Point(curve, x, z) {
  Base.BasePoint.call(this, curve, 'projective');
  if (x === null && z === null) {
    this.x = this.curve.one;
    this.z = this.curve.zero;
  } else {
    this.x = new BN(x, 16);
    this.z = new BN(z, 16);
    if (!this.x.red)
      this.x = this.x.toRed(this.curve.red);
    if (!this.z.red)
      this.z = this.z.toRed(this.curve.red);
  }
}
inherits(Point, Base.BasePoint);

MontCurve.prototype.decodePoint = function decodePoint(bytes, enc) {
  return this.point(utils.toArray(bytes, enc), 1);
};

MontCurve.prototype.point = function point(x, z) {
  return new Point(this, x, z);
};

MontCurve.prototype.pointFromJSON = function pointFromJSON(obj) {
  return Point.fromJSON(this, obj);
};

Point.prototype.precompute = function precompute() {
  // No-op
};

Point.prototype._encode = function _encode() {
  return this.getX().toArray('be', this.curve.p.byteLength());
};

Point.fromJSON = function fromJSON(curve, obj) {
  return new Point(curve, obj[0], obj[1] || curve.one);
};

Point.prototype.inspect = function inspect() {
  if (this.isInfinity())
    return '<EC Point Infinity>';
  return '<EC Point x: ' + this.x.fromRed().toString(16, 2) +
      ' z: ' + this.z.fromRed().toString(16, 2) + '>';
};

Point.prototype.isInfinity = function isInfinity() {
  // XXX This code assumes that zero is always zero in red
  return this.z.cmpn(0) === 0;
};

Point.prototype.dbl = function dbl() {
  // http://hyperelliptic.org/EFD/g1p/auto-montgom-xz.html#doubling-dbl-1987-m-3
  // 2M + 2S + 4A

  // A = X1 + Z1
  var a = this.x.redAdd(this.z);
  // AA = A^2
  var aa = a.redSqr();
  // B = X1 - Z1
  var b = this.x.redSub(this.z);
  // BB = B^2
  var bb = b.redSqr();
  // C = AA - BB
  var c = aa.redSub(bb);
  // X3 = AA * BB
  var nx = aa.redMul(bb);
  // Z3 = C * (BB + A24 * C)
  var nz = c.redMul(bb.redAdd(this.curve.a24.redMul(c)));
  return this.curve.point(nx, nz);
};

Point.prototype.add = function add() {
  throw new Error('Not supported on Montgomery curve');
};

Point.prototype.diffAdd = function diffAdd(p, diff) {
  // http://hyperelliptic.org/EFD/g1p/auto-montgom-xz.html#diffadd-dadd-1987-m-3
  // 4M + 2S + 6A

  // A = X2 + Z2
  var a = this.x.redAdd(this.z);
  // B = X2 - Z2
  var b = this.x.redSub(this.z);
  // C = X3 + Z3
  var c = p.x.redAdd(p.z);
  // D = X3 - Z3
  var d = p.x.redSub(p.z);
  // DA = D * A
  var da = d.redMul(a);
  // CB = C * B
  var cb = c.redMul(b);
  // X5 = Z1 * (DA + CB)^2
  var nx = diff.z.redMul(da.redAdd(cb).redSqr());
  // Z5 = X1 * (DA - CB)^2
  var nz = diff.x.redMul(da.redISub(cb).redSqr());
  return this.curve.point(nx, nz);
};

Point.prototype.mul = function mul(k) {
  var t = k.clone();
  var a = this; // (N / 2) * Q + Q
  var b = this.curve.point(null, null); // (N / 2) * Q
  var c = this; // Q

  for (var bits = []; t.cmpn(0) !== 0; t.iushrn(1))
    bits.push(t.andln(1));

  for (var i = bits.length - 1; i >= 0; i--) {
    if (bits[i] === 0) {
      // N * Q + Q = ((N / 2) * Q + Q)) + (N / 2) * Q
      a = a.diffAdd(b, c);
      // N * Q = 2 * ((N / 2) * Q + Q))
      b = b.dbl();
    } else {
      // N * Q = ((N / 2) * Q + Q) + ((N / 2) * Q)
      b = a.diffAdd(b, c);
      // N * Q + Q = 2 * ((N / 2) * Q + Q)
      a = a.dbl();
    }
  }
  return b;
};

Point.prototype.mulAdd = function mulAdd() {
  throw new Error('Not supported on Montgomery curve');
};

Point.prototype.jumlAdd = function jumlAdd() {
  throw new Error('Not supported on Montgomery curve');
};

Point.prototype.eq = function eq(other) {
  return this.getX().cmp(other.getX()) === 0;
};

Point.prototype.normalize = function normalize() {
  this.x = this.x.redMul(this.z.redInvm());
  this.z = this.curve.one;
  return this;
};

Point.prototype.getX = function getX() {
  // Normalize coordinates
  this.normalize();

  return this.x.fromRed();
};


/***/ }),

/***/ "./node_modules/elliptic/lib/elliptic/curve/short.js":
/*!***********************************************************!*\
  !*** ./node_modules/elliptic/lib/elliptic/curve/short.js ***!
  \***********************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(/*! ../utils */ "./node_modules/elliptic/lib/elliptic/utils.js");
var BN = __webpack_require__(/*! bn.js */ "./node_modules/elliptic/node_modules/bn.js/lib/bn.js");
var inherits = __webpack_require__(/*! inherits */ "./node_modules/inherits/inherits_browser.js");
var Base = __webpack_require__(/*! ./base */ "./node_modules/elliptic/lib/elliptic/curve/base.js");

var assert = utils.assert;

function ShortCurve(conf) {
  Base.call(this, 'short', conf);

  this.a = new BN(conf.a, 16).toRed(this.red);
  this.b = new BN(conf.b, 16).toRed(this.red);
  this.tinv = this.two.redInvm();

  this.zeroA = this.a.fromRed().cmpn(0) === 0;
  this.threeA = this.a.fromRed().sub(this.p).cmpn(-3) === 0;

  // If the curve is endomorphic, precalculate beta and lambda
  this.endo = this._getEndomorphism(conf);
  this._endoWnafT1 = new Array(4);
  this._endoWnafT2 = new Array(4);
}
inherits(ShortCurve, Base);
module.exports = ShortCurve;

ShortCurve.prototype._getEndomorphism = function _getEndomorphism(conf) {
  // No efficient endomorphism
  if (!this.zeroA || !this.g || !this.n || this.p.modn(3) !== 1)
    return;

  // Compute beta and lambda, that lambda * P = (beta * Px; Py)
  var beta;
  var lambda;
  if (conf.beta) {
    beta = new BN(conf.beta, 16).toRed(this.red);
  } else {
    var betas = this._getEndoRoots(this.p);
    // Choose the smallest beta
    beta = betas[0].cmp(betas[1]) < 0 ? betas[0] : betas[1];
    beta = beta.toRed(this.red);
  }
  if (conf.lambda) {
    lambda = new BN(conf.lambda, 16);
  } else {
    // Choose the lambda that is matching selected beta
    var lambdas = this._getEndoRoots(this.n);
    if (this.g.mul(lambdas[0]).x.cmp(this.g.x.redMul(beta)) === 0) {
      lambda = lambdas[0];
    } else {
      lambda = lambdas[1];
      assert(this.g.mul(lambda).x.cmp(this.g.x.redMul(beta)) === 0);
    }
  }

  // Get basis vectors, used for balanced length-two representation
  var basis;
  if (conf.basis) {
    basis = conf.basis.map(function(vec) {
      return {
        a: new BN(vec.a, 16),
        b: new BN(vec.b, 16)
      };
    });
  } else {
    basis = this._getEndoBasis(lambda);
  }

  return {
    beta: beta,
    lambda: lambda,
    basis: basis
  };
};

ShortCurve.prototype._getEndoRoots = function _getEndoRoots(num) {
  // Find roots of for x^2 + x + 1 in F
  // Root = (-1 +- Sqrt(-3)) / 2
  //
  var red = num === this.p ? this.red : BN.mont(num);
  var tinv = new BN(2).toRed(red).redInvm();
  var ntinv = tinv.redNeg();

  var s = new BN(3).toRed(red).redNeg().redSqrt().redMul(tinv);

  var l1 = ntinv.redAdd(s).fromRed();
  var l2 = ntinv.redSub(s).fromRed();
  return [ l1, l2 ];
};

ShortCurve.prototype._getEndoBasis = function _getEndoBasis(lambda) {
  // aprxSqrt >= sqrt(this.n)
  var aprxSqrt = this.n.ushrn(Math.floor(this.n.bitLength() / 2));

  // 3.74
  // Run EGCD, until r(L + 1) < aprxSqrt
  var u = lambda;
  var v = this.n.clone();
  var x1 = new BN(1);
  var y1 = new BN(0);
  var x2 = new BN(0);
  var y2 = new BN(1);

  // NOTE: all vectors are roots of: a + b * lambda = 0 (mod n)
  var a0;
  var b0;
  // First vector
  var a1;
  var b1;
  // Second vector
  var a2;
  var b2;

  var prevR;
  var i = 0;
  var r;
  var x;
  while (u.cmpn(0) !== 0) {
    var q = v.div(u);
    r = v.sub(q.mul(u));
    x = x2.sub(q.mul(x1));
    var y = y2.sub(q.mul(y1));

    if (!a1 && r.cmp(aprxSqrt) < 0) {
      a0 = prevR.neg();
      b0 = x1;
      a1 = r.neg();
      b1 = x;
    } else if (a1 && ++i === 2) {
      break;
    }
    prevR = r;

    v = u;
    u = r;
    x2 = x1;
    x1 = x;
    y2 = y1;
    y1 = y;
  }
  a2 = r.neg();
  b2 = x;

  var len1 = a1.sqr().add(b1.sqr());
  var len2 = a2.sqr().add(b2.sqr());
  if (len2.cmp(len1) >= 0) {
    a2 = a0;
    b2 = b0;
  }

  // Normalize signs
  if (a1.negative) {
    a1 = a1.neg();
    b1 = b1.neg();
  }
  if (a2.negative) {
    a2 = a2.neg();
    b2 = b2.neg();
  }

  return [
    { a: a1, b: b1 },
    { a: a2, b: b2 }
  ];
};

ShortCurve.prototype._endoSplit = function _endoSplit(k) {
  var basis = this.endo.basis;
  var v1 = basis[0];
  var v2 = basis[1];

  var c1 = v2.b.mul(k).divRound(this.n);
  var c2 = v1.b.neg().mul(k).divRound(this.n);

  var p1 = c1.mul(v1.a);
  var p2 = c2.mul(v2.a);
  var q1 = c1.mul(v1.b);
  var q2 = c2.mul(v2.b);

  // Calculate answer
  var k1 = k.sub(p1).sub(p2);
  var k2 = q1.add(q2).neg();
  return { k1: k1, k2: k2 };
};

ShortCurve.prototype.pointFromX = function pointFromX(x, odd) {
  x = new BN(x, 16);
  if (!x.red)
    x = x.toRed(this.red);

  var y2 = x.redSqr().redMul(x).redIAdd(x.redMul(this.a)).redIAdd(this.b);
  var y = y2.redSqrt();
  if (y.redSqr().redSub(y2).cmp(this.zero) !== 0)
    throw new Error('invalid point');

  // XXX Is there any way to tell if the number is odd without converting it
  // to non-red form?
  var isOdd = y.fromRed().isOdd();
  if (odd && !isOdd || !odd && isOdd)
    y = y.redNeg();

  return this.point(x, y);
};

ShortCurve.prototype.validate = function validate(point) {
  if (point.inf)
    return true;

  var x = point.x;
  var y = point.y;

  var ax = this.a.redMul(x);
  var rhs = x.redSqr().redMul(x).redIAdd(ax).redIAdd(this.b);
  return y.redSqr().redISub(rhs).cmpn(0) === 0;
};

ShortCurve.prototype._endoWnafMulAdd =
    function _endoWnafMulAdd(points, coeffs, jacobianResult) {
  var npoints = this._endoWnafT1;
  var ncoeffs = this._endoWnafT2;
  for (var i = 0; i < points.length; i++) {
    var split = this._endoSplit(coeffs[i]);
    var p = points[i];
    var beta = p._getBeta();

    if (split.k1.negative) {
      split.k1.ineg();
      p = p.neg(true);
    }
    if (split.k2.negative) {
      split.k2.ineg();
      beta = beta.neg(true);
    }

    npoints[i * 2] = p;
    npoints[i * 2 + 1] = beta;
    ncoeffs[i * 2] = split.k1;
    ncoeffs[i * 2 + 1] = split.k2;
  }
  var res = this._wnafMulAdd(1, npoints, ncoeffs, i * 2, jacobianResult);

  // Clean-up references to points and coefficients
  for (var j = 0; j < i * 2; j++) {
    npoints[j] = null;
    ncoeffs[j] = null;
  }
  return res;
};

function Point(curve, x, y, isRed) {
  Base.BasePoint.call(this, curve, 'affine');
  if (x === null && y === null) {
    this.x = null;
    this.y = null;
    this.inf = true;
  } else {
    this.x = new BN(x, 16);
    this.y = new BN(y, 16);
    // Force redgomery representation when loading from JSON
    if (isRed) {
      this.x.forceRed(this.curve.red);
      this.y.forceRed(this.curve.red);
    }
    if (!this.x.red)
      this.x = this.x.toRed(this.curve.red);
    if (!this.y.red)
      this.y = this.y.toRed(this.curve.red);
    this.inf = false;
  }
}
inherits(Point, Base.BasePoint);

ShortCurve.prototype.point = function point(x, y, isRed) {
  return new Point(this, x, y, isRed);
};

ShortCurve.prototype.pointFromJSON = function pointFromJSON(obj, red) {
  return Point.fromJSON(this, obj, red);
};

Point.prototype._getBeta = function _getBeta() {
  if (!this.curve.endo)
    return;

  var pre = this.precomputed;
  if (pre && pre.beta)
    return pre.beta;

  var beta = this.curve.point(this.x.redMul(this.curve.endo.beta), this.y);
  if (pre) {
    var curve = this.curve;
    var endoMul = function(p) {
      return curve.point(p.x.redMul(curve.endo.beta), p.y);
    };
    pre.beta = beta;
    beta.precomputed = {
      beta: null,
      naf: pre.naf && {
        wnd: pre.naf.wnd,
        points: pre.naf.points.map(endoMul)
      },
      doubles: pre.doubles && {
        step: pre.doubles.step,
        points: pre.doubles.points.map(endoMul)
      }
    };
  }
  return beta;
};

Point.prototype.toJSON = function toJSON() {
  if (!this.precomputed)
    return [ this.x, this.y ];

  return [ this.x, this.y, this.precomputed && {
    doubles: this.precomputed.doubles && {
      step: this.precomputed.doubles.step,
      points: this.precomputed.doubles.points.slice(1)
    },
    naf: this.precomputed.naf && {
      wnd: this.precomputed.naf.wnd,
      points: this.precomputed.naf.points.slice(1)
    }
  } ];
};

Point.fromJSON = function fromJSON(curve, obj, red) {
  if (typeof obj === 'string')
    obj = JSON.parse(obj);
  var res = curve.point(obj[0], obj[1], red);
  if (!obj[2])
    return res;

  function obj2point(obj) {
    return curve.point(obj[0], obj[1], red);
  }

  var pre = obj[2];
  res.precomputed = {
    beta: null,
    doubles: pre.doubles && {
      step: pre.doubles.step,
      points: [ res ].concat(pre.doubles.points.map(obj2point))
    },
    naf: pre.naf && {
      wnd: pre.naf.wnd,
      points: [ res ].concat(pre.naf.points.map(obj2point))
    }
  };
  return res;
};

Point.prototype.inspect = function inspect() {
  if (this.isInfinity())
    return '<EC Point Infinity>';
  return '<EC Point x: ' + this.x.fromRed().toString(16, 2) +
      ' y: ' + this.y.fromRed().toString(16, 2) + '>';
};

Point.prototype.isInfinity = function isInfinity() {
  return this.inf;
};

Point.prototype.add = function add(p) {
  // O + P = P
  if (this.inf)
    return p;

  // P + O = P
  if (p.inf)
    return this;

  // P + P = 2P
  if (this.eq(p))
    return this.dbl();

  // P + (-P) = O
  if (this.neg().eq(p))
    return this.curve.point(null, null);

  // P + Q = O
  if (this.x.cmp(p.x) === 0)
    return this.curve.point(null, null);

  var c = this.y.redSub(p.y);
  if (c.cmpn(0) !== 0)
    c = c.redMul(this.x.redSub(p.x).redInvm());
  var nx = c.redSqr().redISub(this.x).redISub(p.x);
  var ny = c.redMul(this.x.redSub(nx)).redISub(this.y);
  return this.curve.point(nx, ny);
};

Point.prototype.dbl = function dbl() {
  if (this.inf)
    return this;

  // 2P = O
  var ys1 = this.y.redAdd(this.y);
  if (ys1.cmpn(0) === 0)
    return this.curve.point(null, null);

  var a = this.curve.a;

  var x2 = this.x.redSqr();
  var dyinv = ys1.redInvm();
  var c = x2.redAdd(x2).redIAdd(x2).redIAdd(a).redMul(dyinv);

  var nx = c.redSqr().redISub(this.x.redAdd(this.x));
  var ny = c.redMul(this.x.redSub(nx)).redISub(this.y);
  return this.curve.point(nx, ny);
};

Point.prototype.getX = function getX() {
  return this.x.fromRed();
};

Point.prototype.getY = function getY() {
  return this.y.fromRed();
};

Point.prototype.mul = function mul(k) {
  k = new BN(k, 16);
  if (this.isInfinity())
    return this;
  else if (this._hasDoubles(k))
    return this.curve._fixedNafMul(this, k);
  else if (this.curve.endo)
    return this.curve._endoWnafMulAdd([ this ], [ k ]);
  else
    return this.curve._wnafMul(this, k);
};

Point.prototype.mulAdd = function mulAdd(k1, p2, k2) {
  var points = [ this, p2 ];
  var coeffs = [ k1, k2 ];
  if (this.curve.endo)
    return this.curve._endoWnafMulAdd(points, coeffs);
  else
    return this.curve._wnafMulAdd(1, points, coeffs, 2);
};

Point.prototype.jmulAdd = function jmulAdd(k1, p2, k2) {
  var points = [ this, p2 ];
  var coeffs = [ k1, k2 ];
  if (this.curve.endo)
    return this.curve._endoWnafMulAdd(points, coeffs, true);
  else
    return this.curve._wnafMulAdd(1, points, coeffs, 2, true);
};

Point.prototype.eq = function eq(p) {
  return this === p ||
         this.inf === p.inf &&
             (this.inf || this.x.cmp(p.x) === 0 && this.y.cmp(p.y) === 0);
};

Point.prototype.neg = function neg(_precompute) {
  if (this.inf)
    return this;

  var res = this.curve.point(this.x, this.y.redNeg());
  if (_precompute && this.precomputed) {
    var pre = this.precomputed;
    var negate = function(p) {
      return p.neg();
    };
    res.precomputed = {
      naf: pre.naf && {
        wnd: pre.naf.wnd,
        points: pre.naf.points.map(negate)
      },
      doubles: pre.doubles && {
        step: pre.doubles.step,
        points: pre.doubles.points.map(negate)
      }
    };
  }
  return res;
};

Point.prototype.toJ = function toJ() {
  if (this.inf)
    return this.curve.jpoint(null, null, null);

  var res = this.curve.jpoint(this.x, this.y, this.curve.one);
  return res;
};

function JPoint(curve, x, y, z) {
  Base.BasePoint.call(this, curve, 'jacobian');
  if (x === null && y === null && z === null) {
    this.x = this.curve.one;
    this.y = this.curve.one;
    this.z = new BN(0);
  } else {
    this.x = new BN(x, 16);
    this.y = new BN(y, 16);
    this.z = new BN(z, 16);
  }
  if (!this.x.red)
    this.x = this.x.toRed(this.curve.red);
  if (!this.y.red)
    this.y = this.y.toRed(this.curve.red);
  if (!this.z.red)
    this.z = this.z.toRed(this.curve.red);

  this.zOne = this.z === this.curve.one;
}
inherits(JPoint, Base.BasePoint);

ShortCurve.prototype.jpoint = function jpoint(x, y, z) {
  return new JPoint(this, x, y, z);
};

JPoint.prototype.toP = function toP() {
  if (this.isInfinity())
    return this.curve.point(null, null);

  var zinv = this.z.redInvm();
  var zinv2 = zinv.redSqr();
  var ax = this.x.redMul(zinv2);
  var ay = this.y.redMul(zinv2).redMul(zinv);

  return this.curve.point(ax, ay);
};

JPoint.prototype.neg = function neg() {
  return this.curve.jpoint(this.x, this.y.redNeg(), this.z);
};

JPoint.prototype.add = function add(p) {
  // O + P = P
  if (this.isInfinity())
    return p;

  // P + O = P
  if (p.isInfinity())
    return this;

  // 12M + 4S + 7A
  var pz2 = p.z.redSqr();
  var z2 = this.z.redSqr();
  var u1 = this.x.redMul(pz2);
  var u2 = p.x.redMul(z2);
  var s1 = this.y.redMul(pz2.redMul(p.z));
  var s2 = p.y.redMul(z2.redMul(this.z));

  var h = u1.redSub(u2);
  var r = s1.redSub(s2);
  if (h.cmpn(0) === 0) {
    if (r.cmpn(0) !== 0)
      return this.curve.jpoint(null, null, null);
    else
      return this.dbl();
  }

  var h2 = h.redSqr();
  var h3 = h2.redMul(h);
  var v = u1.redMul(h2);

  var nx = r.redSqr().redIAdd(h3).redISub(v).redISub(v);
  var ny = r.redMul(v.redISub(nx)).redISub(s1.redMul(h3));
  var nz = this.z.redMul(p.z).redMul(h);

  return this.curve.jpoint(nx, ny, nz);
};

JPoint.prototype.mixedAdd = function mixedAdd(p) {
  // O + P = P
  if (this.isInfinity())
    return p.toJ();

  // P + O = P
  if (p.isInfinity())
    return this;

  // 8M + 3S + 7A
  var z2 = this.z.redSqr();
  var u1 = this.x;
  var u2 = p.x.redMul(z2);
  var s1 = this.y;
  var s2 = p.y.redMul(z2).redMul(this.z);

  var h = u1.redSub(u2);
  var r = s1.redSub(s2);
  if (h.cmpn(0) === 0) {
    if (r.cmpn(0) !== 0)
      return this.curve.jpoint(null, null, null);
    else
      return this.dbl();
  }

  var h2 = h.redSqr();
  var h3 = h2.redMul(h);
  var v = u1.redMul(h2);

  var nx = r.redSqr().redIAdd(h3).redISub(v).redISub(v);
  var ny = r.redMul(v.redISub(nx)).redISub(s1.redMul(h3));
  var nz = this.z.redMul(h);

  return this.curve.jpoint(nx, ny, nz);
};

JPoint.prototype.dblp = function dblp(pow) {
  if (pow === 0)
    return this;
  if (this.isInfinity())
    return this;
  if (!pow)
    return this.dbl();

  if (this.curve.zeroA || this.curve.threeA) {
    var r = this;
    for (var i = 0; i < pow; i++)
      r = r.dbl();
    return r;
  }

  // 1M + 2S + 1A + N * (4S + 5M + 8A)
  // N = 1 => 6M + 6S + 9A
  var a = this.curve.a;
  var tinv = this.curve.tinv;

  var jx = this.x;
  var jy = this.y;
  var jz = this.z;
  var jz4 = jz.redSqr().redSqr();

  // Reuse results
  var jyd = jy.redAdd(jy);
  for (var i = 0; i < pow; i++) {
    var jx2 = jx.redSqr();
    var jyd2 = jyd.redSqr();
    var jyd4 = jyd2.redSqr();
    var c = jx2.redAdd(jx2).redIAdd(jx2).redIAdd(a.redMul(jz4));

    var t1 = jx.redMul(jyd2);
    var nx = c.redSqr().redISub(t1.redAdd(t1));
    var t2 = t1.redISub(nx);
    var dny = c.redMul(t2);
    dny = dny.redIAdd(dny).redISub(jyd4);
    var nz = jyd.redMul(jz);
    if (i + 1 < pow)
      jz4 = jz4.redMul(jyd4);

    jx = nx;
    jz = nz;
    jyd = dny;
  }

  return this.curve.jpoint(jx, jyd.redMul(tinv), jz);
};

JPoint.prototype.dbl = function dbl() {
  if (this.isInfinity())
    return this;

  if (this.curve.zeroA)
    return this._zeroDbl();
  else if (this.curve.threeA)
    return this._threeDbl();
  else
    return this._dbl();
};

JPoint.prototype._zeroDbl = function _zeroDbl() {
  var nx;
  var ny;
  var nz;
  // Z = 1
  if (this.zOne) {
    // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-0.html
    //     #doubling-mdbl-2007-bl
    // 1M + 5S + 14A

    // XX = X1^2
    var xx = this.x.redSqr();
    // YY = Y1^2
    var yy = this.y.redSqr();
    // YYYY = YY^2
    var yyyy = yy.redSqr();
    // S = 2 * ((X1 + YY)^2 - XX - YYYY)
    var s = this.x.redAdd(yy).redSqr().redISub(xx).redISub(yyyy);
    s = s.redIAdd(s);
    // M = 3 * XX + a; a = 0
    var m = xx.redAdd(xx).redIAdd(xx);
    // T = M ^ 2 - 2*S
    var t = m.redSqr().redISub(s).redISub(s);

    // 8 * YYYY
    var yyyy8 = yyyy.redIAdd(yyyy);
    yyyy8 = yyyy8.redIAdd(yyyy8);
    yyyy8 = yyyy8.redIAdd(yyyy8);

    // X3 = T
    nx = t;
    // Y3 = M * (S - T) - 8 * YYYY
    ny = m.redMul(s.redISub(t)).redISub(yyyy8);
    // Z3 = 2*Y1
    nz = this.y.redAdd(this.y);
  } else {
    // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-0.html
    //     #doubling-dbl-2009-l
    // 2M + 5S + 13A

    // A = X1^2
    var a = this.x.redSqr();
    // B = Y1^2
    var b = this.y.redSqr();
    // C = B^2
    var c = b.redSqr();
    // D = 2 * ((X1 + B)^2 - A - C)
    var d = this.x.redAdd(b).redSqr().redISub(a).redISub(c);
    d = d.redIAdd(d);
    // E = 3 * A
    var e = a.redAdd(a).redIAdd(a);
    // F = E^2
    var f = e.redSqr();

    // 8 * C
    var c8 = c.redIAdd(c);
    c8 = c8.redIAdd(c8);
    c8 = c8.redIAdd(c8);

    // X3 = F - 2 * D
    nx = f.redISub(d).redISub(d);
    // Y3 = E * (D - X3) - 8 * C
    ny = e.redMul(d.redISub(nx)).redISub(c8);
    // Z3 = 2 * Y1 * Z1
    nz = this.y.redMul(this.z);
    nz = nz.redIAdd(nz);
  }

  return this.curve.jpoint(nx, ny, nz);
};

JPoint.prototype._threeDbl = function _threeDbl() {
  var nx;
  var ny;
  var nz;
  // Z = 1
  if (this.zOne) {
    // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-3.html
    //     #doubling-mdbl-2007-bl
    // 1M + 5S + 15A

    // XX = X1^2
    var xx = this.x.redSqr();
    // YY = Y1^2
    var yy = this.y.redSqr();
    // YYYY = YY^2
    var yyyy = yy.redSqr();
    // S = 2 * ((X1 + YY)^2 - XX - YYYY)
    var s = this.x.redAdd(yy).redSqr().redISub(xx).redISub(yyyy);
    s = s.redIAdd(s);
    // M = 3 * XX + a
    var m = xx.redAdd(xx).redIAdd(xx).redIAdd(this.curve.a);
    // T = M^2 - 2 * S
    var t = m.redSqr().redISub(s).redISub(s);
    // X3 = T
    nx = t;
    // Y3 = M * (S - T) - 8 * YYYY
    var yyyy8 = yyyy.redIAdd(yyyy);
    yyyy8 = yyyy8.redIAdd(yyyy8);
    yyyy8 = yyyy8.redIAdd(yyyy8);
    ny = m.redMul(s.redISub(t)).redISub(yyyy8);
    // Z3 = 2 * Y1
    nz = this.y.redAdd(this.y);
  } else {
    // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-3.html#doubling-dbl-2001-b
    // 3M + 5S

    // delta = Z1^2
    var delta = this.z.redSqr();
    // gamma = Y1^2
    var gamma = this.y.redSqr();
    // beta = X1 * gamma
    var beta = this.x.redMul(gamma);
    // alpha = 3 * (X1 - delta) * (X1 + delta)
    var alpha = this.x.redSub(delta).redMul(this.x.redAdd(delta));
    alpha = alpha.redAdd(alpha).redIAdd(alpha);
    // X3 = alpha^2 - 8 * beta
    var beta4 = beta.redIAdd(beta);
    beta4 = beta4.redIAdd(beta4);
    var beta8 = beta4.redAdd(beta4);
    nx = alpha.redSqr().redISub(beta8);
    // Z3 = (Y1 + Z1)^2 - gamma - delta
    nz = this.y.redAdd(this.z).redSqr().redISub(gamma).redISub(delta);
    // Y3 = alpha * (4 * beta - X3) - 8 * gamma^2
    var ggamma8 = gamma.redSqr();
    ggamma8 = ggamma8.redIAdd(ggamma8);
    ggamma8 = ggamma8.redIAdd(ggamma8);
    ggamma8 = ggamma8.redIAdd(ggamma8);
    ny = alpha.redMul(beta4.redISub(nx)).redISub(ggamma8);
  }

  return this.curve.jpoint(nx, ny, nz);
};

JPoint.prototype._dbl = function _dbl() {
  var a = this.curve.a;

  // 4M + 6S + 10A
  var jx = this.x;
  var jy = this.y;
  var jz = this.z;
  var jz4 = jz.redSqr().redSqr();

  var jx2 = jx.redSqr();
  var jy2 = jy.redSqr();

  var c = jx2.redAdd(jx2).redIAdd(jx2).redIAdd(a.redMul(jz4));

  var jxd4 = jx.redAdd(jx);
  jxd4 = jxd4.redIAdd(jxd4);
  var t1 = jxd4.redMul(jy2);
  var nx = c.redSqr().redISub(t1.redAdd(t1));
  var t2 = t1.redISub(nx);

  var jyd8 = jy2.redSqr();
  jyd8 = jyd8.redIAdd(jyd8);
  jyd8 = jyd8.redIAdd(jyd8);
  jyd8 = jyd8.redIAdd(jyd8);
  var ny = c.redMul(t2).redISub(jyd8);
  var nz = jy.redAdd(jy).redMul(jz);

  return this.curve.jpoint(nx, ny, nz);
};

JPoint.prototype.trpl = function trpl() {
  if (!this.curve.zeroA)
    return this.dbl().add(this);

  // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-0.html#tripling-tpl-2007-bl
  // 5M + 10S + ...

  // XX = X1^2
  var xx = this.x.redSqr();
  // YY = Y1^2
  var yy = this.y.redSqr();
  // ZZ = Z1^2
  var zz = this.z.redSqr();
  // YYYY = YY^2
  var yyyy = yy.redSqr();
  // M = 3 * XX + a * ZZ2; a = 0
  var m = xx.redAdd(xx).redIAdd(xx);
  // MM = M^2
  var mm = m.redSqr();
  // E = 6 * ((X1 + YY)^2 - XX - YYYY) - MM
  var e = this.x.redAdd(yy).redSqr().redISub(xx).redISub(yyyy);
  e = e.redIAdd(e);
  e = e.redAdd(e).redIAdd(e);
  e = e.redISub(mm);
  // EE = E^2
  var ee = e.redSqr();
  // T = 16*YYYY
  var t = yyyy.redIAdd(yyyy);
  t = t.redIAdd(t);
  t = t.redIAdd(t);
  t = t.redIAdd(t);
  // U = (M + E)^2 - MM - EE - T
  var u = m.redIAdd(e).redSqr().redISub(mm).redISub(ee).redISub(t);
  // X3 = 4 * (X1 * EE - 4 * YY * U)
  var yyu4 = yy.redMul(u);
  yyu4 = yyu4.redIAdd(yyu4);
  yyu4 = yyu4.redIAdd(yyu4);
  var nx = this.x.redMul(ee).redISub(yyu4);
  nx = nx.redIAdd(nx);
  nx = nx.redIAdd(nx);
  // Y3 = 8 * Y1 * (U * (T - U) - E * EE)
  var ny = this.y.redMul(u.redMul(t.redISub(u)).redISub(e.redMul(ee)));
  ny = ny.redIAdd(ny);
  ny = ny.redIAdd(ny);
  ny = ny.redIAdd(ny);
  // Z3 = (Z1 + E)^2 - ZZ - EE
  var nz = this.z.redAdd(e).redSqr().redISub(zz).redISub(ee);

  return this.curve.jpoint(nx, ny, nz);
};

JPoint.prototype.mul = function mul(k, kbase) {
  k = new BN(k, kbase);

  return this.curve._wnafMul(this, k);
};

JPoint.prototype.eq = function eq(p) {
  if (p.type === 'affine')
    return this.eq(p.toJ());

  if (this === p)
    return true;

  // x1 * z2^2 == x2 * z1^2
  var z2 = this.z.redSqr();
  var pz2 = p.z.redSqr();
  if (this.x.redMul(pz2).redISub(p.x.redMul(z2)).cmpn(0) !== 0)
    return false;

  // y1 * z2^3 == y2 * z1^3
  var z3 = z2.redMul(this.z);
  var pz3 = pz2.redMul(p.z);
  return this.y.redMul(pz3).redISub(p.y.redMul(z3)).cmpn(0) === 0;
};

JPoint.prototype.eqXToP = function eqXToP(x) {
  var zs = this.z.redSqr();
  var rx = x.toRed(this.curve.red).redMul(zs);
  if (this.x.cmp(rx) === 0)
    return true;

  var xc = x.clone();
  var t = this.curve.redN.redMul(zs);
  for (;;) {
    xc.iadd(this.curve.n);
    if (xc.cmp(this.curve.p) >= 0)
      return false;

    rx.redIAdd(t);
    if (this.x.cmp(rx) === 0)
      return true;
  }
};

JPoint.prototype.inspect = function inspect() {
  if (this.isInfinity())
    return '<EC JPoint Infinity>';
  return '<EC JPoint x: ' + this.x.toString(16, 2) +
      ' y: ' + this.y.toString(16, 2) +
      ' z: ' + this.z.toString(16, 2) + '>';
};

JPoint.prototype.isInfinity = function isInfinity() {
  // XXX This code assumes that zero is always zero in red
  return this.z.cmpn(0) === 0;
};


/***/ }),

/***/ "./node_modules/elliptic/lib/elliptic/curves.js":
/*!******************************************************!*\
  !*** ./node_modules/elliptic/lib/elliptic/curves.js ***!
  \******************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var curves = exports;

var hash = __webpack_require__(/*! hash.js */ "./node_modules/hash.js/lib/hash.js");
var curve = __webpack_require__(/*! ./curve */ "./node_modules/elliptic/lib/elliptic/curve/index.js");
var utils = __webpack_require__(/*! ./utils */ "./node_modules/elliptic/lib/elliptic/utils.js");

var assert = utils.assert;

function PresetCurve(options) {
  if (options.type === 'short')
    this.curve = new curve.short(options);
  else if (options.type === 'edwards')
    this.curve = new curve.edwards(options);
  else
    this.curve = new curve.mont(options);
  this.g = this.curve.g;
  this.n = this.curve.n;
  this.hash = options.hash;

  assert(this.g.validate(), 'Invalid curve');
  assert(this.g.mul(this.n).isInfinity(), 'Invalid curve, G*N != O');
}
curves.PresetCurve = PresetCurve;

function defineCurve(name, options) {
  Object.defineProperty(curves, name, {
    configurable: true,
    enumerable: true,
    get: function() {
      var curve = new PresetCurve(options);
      Object.defineProperty(curves, name, {
        configurable: true,
        enumerable: true,
        value: curve
      });
      return curve;
    }
  });
}

defineCurve('p192', {
  type: 'short',
  prime: 'p192',
  p: 'ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff',
  a: 'ffffffff ffffffff ffffffff fffffffe ffffffff fffffffc',
  b: '64210519 e59c80e7 0fa7e9ab 72243049 feb8deec c146b9b1',
  n: 'ffffffff ffffffff ffffffff 99def836 146bc9b1 b4d22831',
  hash: hash.sha256,
  gRed: false,
  g: [
    '188da80e b03090f6 7cbf20eb 43a18800 f4ff0afd 82ff1012',
    '07192b95 ffc8da78 631011ed 6b24cdd5 73f977a1 1e794811'
  ]
});

defineCurve('p224', {
  type: 'short',
  prime: 'p224',
  p: 'ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001',
  a: 'ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff fffffffe',
  b: 'b4050a85 0c04b3ab f5413256 5044b0b7 d7bfd8ba 270b3943 2355ffb4',
  n: 'ffffffff ffffffff ffffffff ffff16a2 e0b8f03e 13dd2945 5c5c2a3d',
  hash: hash.sha256,
  gRed: false,
  g: [
    'b70e0cbd 6bb4bf7f 321390b9 4a03c1d3 56c21122 343280d6 115c1d21',
    'bd376388 b5f723fb 4c22dfe6 cd4375a0 5a074764 44d58199 85007e34'
  ]
});

defineCurve('p256', {
  type: 'short',
  prime: null,
  p: 'ffffffff 00000001 00000000 00000000 00000000 ffffffff ffffffff ffffffff',
  a: 'ffffffff 00000001 00000000 00000000 00000000 ffffffff ffffffff fffffffc',
  b: '5ac635d8 aa3a93e7 b3ebbd55 769886bc 651d06b0 cc53b0f6 3bce3c3e 27d2604b',
  n: 'ffffffff 00000000 ffffffff ffffffff bce6faad a7179e84 f3b9cac2 fc632551',
  hash: hash.sha256,
  gRed: false,
  g: [
    '6b17d1f2 e12c4247 f8bce6e5 63a440f2 77037d81 2deb33a0 f4a13945 d898c296',
    '4fe342e2 fe1a7f9b 8ee7eb4a 7c0f9e16 2bce3357 6b315ece cbb64068 37bf51f5'
  ]
});

defineCurve('p384', {
  type: 'short',
  prime: null,
  p: 'ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ' +
     'fffffffe ffffffff 00000000 00000000 ffffffff',
  a: 'ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ' +
     'fffffffe ffffffff 00000000 00000000 fffffffc',
  b: 'b3312fa7 e23ee7e4 988e056b e3f82d19 181d9c6e fe814112 0314088f ' +
     '5013875a c656398d 8a2ed19d 2a85c8ed d3ec2aef',
  n: 'ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff c7634d81 ' +
     'f4372ddf 581a0db2 48b0a77a ecec196a ccc52973',
  hash: hash.sha384,
  gRed: false,
  g: [
    'aa87ca22 be8b0537 8eb1c71e f320ad74 6e1d3b62 8ba79b98 59f741e0 82542a38 ' +
    '5502f25d bf55296c 3a545e38 72760ab7',
    '3617de4a 96262c6f 5d9e98bf 9292dc29 f8f41dbd 289a147c e9da3113 b5f0b8c0 ' +
    '0a60b1ce 1d7e819d 7a431d7c 90ea0e5f'
  ]
});

defineCurve('p521', {
  type: 'short',
  prime: null,
  p: '000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ' +
     'ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ' +
     'ffffffff ffffffff ffffffff ffffffff ffffffff',
  a: '000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ' +
     'ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ' +
     'ffffffff ffffffff ffffffff ffffffff fffffffc',
  b: '00000051 953eb961 8e1c9a1f 929a21a0 b68540ee a2da725b ' +
     '99b315f3 b8b48991 8ef109e1 56193951 ec7e937b 1652c0bd ' +
     '3bb1bf07 3573df88 3d2c34f1 ef451fd4 6b503f00',
  n: '000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ' +
     'ffffffff ffffffff fffffffa 51868783 bf2f966b 7fcc0148 ' +
     'f709a5d0 3bb5c9b8 899c47ae bb6fb71e 91386409',
  hash: hash.sha512,
  gRed: false,
  g: [
    '000000c6 858e06b7 0404e9cd 9e3ecb66 2395b442 9c648139 ' +
    '053fb521 f828af60 6b4d3dba a14b5e77 efe75928 fe1dc127 ' +
    'a2ffa8de 3348b3c1 856a429b f97e7e31 c2e5bd66',
    '00000118 39296a78 9a3bc004 5c8a5fb4 2c7d1bd9 98f54449 ' +
    '579b4468 17afbd17 273e662c 97ee7299 5ef42640 c550b901 ' +
    '3fad0761 353c7086 a272c240 88be9476 9fd16650'
  ]
});

defineCurve('curve25519', {
  type: 'mont',
  prime: 'p25519',
  p: '7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed',
  a: '76d06',
  b: '1',
  n: '1000000000000000 0000000000000000 14def9dea2f79cd6 5812631a5cf5d3ed',
  hash: hash.sha256,
  gRed: false,
  g: [
    '9'
  ]
});

defineCurve('ed25519', {
  type: 'edwards',
  prime: 'p25519',
  p: '7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed',
  a: '-1',
  c: '1',
  // -121665 * (121666^(-1)) (mod P)
  d: '52036cee2b6ffe73 8cc740797779e898 00700a4d4141d8ab 75eb4dca135978a3',
  n: '1000000000000000 0000000000000000 14def9dea2f79cd6 5812631a5cf5d3ed',
  hash: hash.sha256,
  gRed: false,
  g: [
    '216936d3cd6e53fec0a4e231fdd6dc5c692cc7609525a7b2c9562d608f25d51a',

    // 4/5
    '6666666666666666666666666666666666666666666666666666666666666658'
  ]
});

var pre;
try {
  pre = __webpack_require__(/*! ./precomputed/secp256k1 */ "./node_modules/elliptic/lib/elliptic/precomputed/secp256k1.js");
} catch (e) {
  pre = undefined;
}

defineCurve('secp256k1', {
  type: 'short',
  prime: 'k256',
  p: 'ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f',
  a: '0',
  b: '7',
  n: 'ffffffff ffffffff ffffffff fffffffe baaedce6 af48a03b bfd25e8c d0364141',
  h: '1',
  hash: hash.sha256,

  // Precomputed endomorphism
  beta: '7ae96a2b657c07106e64479eac3434e99cf0497512f58995c1396c28719501ee',
  lambda: '5363ad4cc05c30e0a5261c028812645a122e22ea20816678df02967c1b23bd72',
  basis: [
    {
      a: '3086d221a7d46bcde86c90e49284eb15',
      b: '-e4437ed6010e88286f547fa90abfe4c3'
    },
    {
      a: '114ca50f7a8e2f3f657c1108d9d44cfd8',
      b: '3086d221a7d46bcde86c90e49284eb15'
    }
  ],

  gRed: false,
  g: [
    '79be667ef9dcbbac55a06295ce870b07029bfcdb2dce28d959f2815b16f81798',
    '483ada7726a3c4655da4fbfc0e1108a8fd17b448a68554199c47d08ffb10d4b8',
    pre
  ]
});


/***/ }),

/***/ "./node_modules/elliptic/lib/elliptic/ec/index.js":
/*!********************************************************!*\
  !*** ./node_modules/elliptic/lib/elliptic/ec/index.js ***!
  \********************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var BN = __webpack_require__(/*! bn.js */ "./node_modules/elliptic/node_modules/bn.js/lib/bn.js");
var HmacDRBG = __webpack_require__(/*! hmac-drbg */ "./node_modules/hmac-drbg/lib/hmac-drbg.js");
var utils = __webpack_require__(/*! ../utils */ "./node_modules/elliptic/lib/elliptic/utils.js");
var curves = __webpack_require__(/*! ../curves */ "./node_modules/elliptic/lib/elliptic/curves.js");
var rand = __webpack_require__(/*! brorand */ "./node_modules/brorand/index.js");
var assert = utils.assert;

var KeyPair = __webpack_require__(/*! ./key */ "./node_modules/elliptic/lib/elliptic/ec/key.js");
var Signature = __webpack_require__(/*! ./signature */ "./node_modules/elliptic/lib/elliptic/ec/signature.js");

function EC(options) {
  if (!(this instanceof EC))
    return new EC(options);

  // Shortcut `elliptic.ec(curve-name)`
  if (typeof options === 'string') {
    assert(curves.hasOwnProperty(options), 'Unknown curve ' + options);

    options = curves[options];
  }

  // Shortcut for `elliptic.ec(elliptic.curves.curveName)`
  if (options instanceof curves.PresetCurve)
    options = { curve: options };

  this.curve = options.curve.curve;
  this.n = this.curve.n;
  this.nh = this.n.ushrn(1);
  this.g = this.curve.g;

  // Point on curve
  this.g = options.curve.g;
  this.g.precompute(options.curve.n.bitLength() + 1);

  // Hash for function for DRBG
  this.hash = options.hash || options.curve.hash;
}
module.exports = EC;

EC.prototype.keyPair = function keyPair(options) {
  return new KeyPair(this, options);
};

EC.prototype.keyFromPrivate = function keyFromPrivate(priv, enc) {
  return KeyPair.fromPrivate(this, priv, enc);
};

EC.prototype.keyFromPublic = function keyFromPublic(pub, enc) {
  return KeyPair.fromPublic(this, pub, enc);
};

EC.prototype.genKeyPair = function genKeyPair(options) {
  if (!options)
    options = {};

  // Instantiate Hmac_DRBG
  var drbg = new HmacDRBG({
    hash: this.hash,
    pers: options.pers,
    persEnc: options.persEnc || 'utf8',
    entropy: options.entropy || rand(this.hash.hmacStrength),
    entropyEnc: options.entropy && options.entropyEnc || 'utf8',
    nonce: this.n.toArray()
  });

  var bytes = this.n.byteLength();
  var ns2 = this.n.sub(new BN(2));
  do {
    var priv = new BN(drbg.generate(bytes));
    if (priv.cmp(ns2) > 0)
      continue;

    priv.iaddn(1);
    return this.keyFromPrivate(priv);
  } while (true);
};

EC.prototype._truncateToN = function truncateToN(msg, truncOnly) {
  var delta = msg.byteLength() * 8 - this.n.bitLength();
  if (delta > 0)
    msg = msg.ushrn(delta);
  if (!truncOnly && msg.cmp(this.n) >= 0)
    return msg.sub(this.n);
  else
    return msg;
};

EC.prototype.sign = function sign(msg, key, enc, options) {
  if (typeof enc === 'object') {
    options = enc;
    enc = null;
  }
  if (!options)
    options = {};

  key = this.keyFromPrivate(key, enc);
  msg = this._truncateToN(new BN(msg, 16));

  // Zero-extend key to provide enough entropy
  var bytes = this.n.byteLength();
  var bkey = key.getPrivate().toArray('be', bytes);

  // Zero-extend nonce to have the same byte size as N
  var nonce = msg.toArray('be', bytes);

  // Instantiate Hmac_DRBG
  var drbg = new HmacDRBG({
    hash: this.hash,
    entropy: bkey,
    nonce: nonce,
    pers: options.pers,
    persEnc: options.persEnc || 'utf8'
  });

  // Number of bytes to generate
  var ns1 = this.n.sub(new BN(1));

  for (var iter = 0; true; iter++) {
    var k = options.k ?
        options.k(iter) :
        new BN(drbg.generate(this.n.byteLength()));
    k = this._truncateToN(k, true);
    if (k.cmpn(1) <= 0 || k.cmp(ns1) >= 0)
      continue;

    var kp = this.g.mul(k);
    if (kp.isInfinity())
      continue;

    var kpX = kp.getX();
    var r = kpX.umod(this.n);
    if (r.cmpn(0) === 0)
      continue;

    var s = k.invm(this.n).mul(r.mul(key.getPrivate()).iadd(msg));
    s = s.umod(this.n);
    if (s.cmpn(0) === 0)
      continue;

    var recoveryParam = (kp.getY().isOdd() ? 1 : 0) |
                        (kpX.cmp(r) !== 0 ? 2 : 0);

    // Use complement of `s`, if it is > `n / 2`
    if (options.canonical && s.cmp(this.nh) > 0) {
      s = this.n.sub(s);
      recoveryParam ^= 1;
    }

    return new Signature({ r: r, s: s, recoveryParam: recoveryParam });
  }
};

EC.prototype.verify = function verify(msg, signature, key, enc) {
  msg = this._truncateToN(new BN(msg, 16));
  key = this.keyFromPublic(key, enc);
  signature = new Signature(signature, 'hex');

  // Perform primitive values validation
  var r = signature.r;
  var s = signature.s;
  if (r.cmpn(1) < 0 || r.cmp(this.n) >= 0)
    return false;
  if (s.cmpn(1) < 0 || s.cmp(this.n) >= 0)
    return false;

  // Validate signature
  var sinv = s.invm(this.n);
  var u1 = sinv.mul(msg).umod(this.n);
  var u2 = sinv.mul(r).umod(this.n);

  if (!this.curve._maxwellTrick) {
    var p = this.g.mulAdd(u1, key.getPublic(), u2);
    if (p.isInfinity())
      return false;

    return p.getX().umod(this.n).cmp(r) === 0;
  }

  // NOTE: Greg Maxwell's trick, inspired by:
  // https://git.io/vad3K

  var p = this.g.jmulAdd(u1, key.getPublic(), u2);
  if (p.isInfinity())
    return false;

  // Compare `p.x` of Jacobian point with `r`,
  // this will do `p.x == r * p.z^2` instead of multiplying `p.x` by the
  // inverse of `p.z^2`
  return p.eqXToP(r);
};

EC.prototype.recoverPubKey = function(msg, signature, j, enc) {
  assert((3 & j) === j, 'The recovery param is more than two bits');
  signature = new Signature(signature, enc);

  var n = this.n;
  var e = new BN(msg);
  var r = signature.r;
  var s = signature.s;

  // A set LSB signifies that the y-coordinate is odd
  var isYOdd = j & 1;
  var isSecondKey = j >> 1;
  if (r.cmp(this.curve.p.umod(this.curve.n)) >= 0 && isSecondKey)
    throw new Error('Unable to find sencond key candinate');

  // 1.1. Let x = r + jn.
  if (isSecondKey)
    r = this.curve.pointFromX(r.add(this.curve.n), isYOdd);
  else
    r = this.curve.pointFromX(r, isYOdd);

  var rInv = signature.r.invm(n);
  var s1 = n.sub(e).mul(rInv).umod(n);
  var s2 = s.mul(rInv).umod(n);

  // 1.6.1 Compute Q = r^-1 (sR -  eG)
  //               Q = r^-1 (sR + -eG)
  return this.g.mulAdd(s1, r, s2);
};

EC.prototype.getKeyRecoveryParam = function(e, signature, Q, enc) {
  signature = new Signature(signature, enc);
  if (signature.recoveryParam !== null)
    return signature.recoveryParam;

  for (var i = 0; i < 4; i++) {
    var Qprime;
    try {
      Qprime = this.recoverPubKey(e, signature, i);
    } catch (e) {
      continue;
    }

    if (Qprime.eq(Q))
      return i;
  }
  throw new Error('Unable to find valid recovery factor');
};


/***/ }),

/***/ "./node_modules/elliptic/lib/elliptic/ec/key.js":
/*!******************************************************!*\
  !*** ./node_modules/elliptic/lib/elliptic/ec/key.js ***!
  \******************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var BN = __webpack_require__(/*! bn.js */ "./node_modules/elliptic/node_modules/bn.js/lib/bn.js");
var utils = __webpack_require__(/*! ../utils */ "./node_modules/elliptic/lib/elliptic/utils.js");
var assert = utils.assert;

function KeyPair(ec, options) {
  this.ec = ec;
  this.priv = null;
  this.pub = null;

  // KeyPair(ec, { priv: ..., pub: ... })
  if (options.priv)
    this._importPrivate(options.priv, options.privEnc);
  if (options.pub)
    this._importPublic(options.pub, options.pubEnc);
}
module.exports = KeyPair;

KeyPair.fromPublic = function fromPublic(ec, pub, enc) {
  if (pub instanceof KeyPair)
    return pub;

  return new KeyPair(ec, {
    pub: pub,
    pubEnc: enc
  });
};

KeyPair.fromPrivate = function fromPrivate(ec, priv, enc) {
  if (priv instanceof KeyPair)
    return priv;

  return new KeyPair(ec, {
    priv: priv,
    privEnc: enc
  });
};

KeyPair.prototype.validate = function validate() {
  var pub = this.getPublic();

  if (pub.isInfinity())
    return { result: false, reason: 'Invalid public key' };
  if (!pub.validate())
    return { result: false, reason: 'Public key is not a point' };
  if (!pub.mul(this.ec.curve.n).isInfinity())
    return { result: false, reason: 'Public key * N != O' };

  return { result: true, reason: null };
};

KeyPair.prototype.getPublic = function getPublic(compact, enc) {
  // compact is optional argument
  if (typeof compact === 'string') {
    enc = compact;
    compact = null;
  }

  if (!this.pub)
    this.pub = this.ec.g.mul(this.priv);

  if (!enc)
    return this.pub;

  return this.pub.encode(enc, compact);
};

KeyPair.prototype.getPrivate = function getPrivate(enc) {
  if (enc === 'hex')
    return this.priv.toString(16, 2);
  else
    return this.priv;
};

KeyPair.prototype._importPrivate = function _importPrivate(key, enc) {
  this.priv = new BN(key, enc || 16);

  // Ensure that the priv won't be bigger than n, otherwise we may fail
  // in fixed multiplication method
  this.priv = this.priv.umod(this.ec.curve.n);
};

KeyPair.prototype._importPublic = function _importPublic(key, enc) {
  if (key.x || key.y) {
    // Montgomery points only have an `x` coordinate.
    // Weierstrass/Edwards points on the other hand have both `x` and
    // `y` coordinates.
    if (this.ec.curve.type === 'mont') {
      assert(key.x, 'Need x coordinate');
    } else if (this.ec.curve.type === 'short' ||
               this.ec.curve.type === 'edwards') {
      assert(key.x && key.y, 'Need both x and y coordinate');
    }
    this.pub = this.ec.curve.point(key.x, key.y);
    return;
  }
  this.pub = this.ec.curve.decodePoint(key, enc);
};

// ECDH
KeyPair.prototype.derive = function derive(pub) {
  return pub.mul(this.priv).getX();
};

// ECDSA
KeyPair.prototype.sign = function sign(msg, enc, options) {
  return this.ec.sign(msg, this, enc, options);
};

KeyPair.prototype.verify = function verify(msg, signature) {
  return this.ec.verify(msg, signature, this);
};

KeyPair.prototype.inspect = function inspect() {
  return '<Key priv: ' + (this.priv && this.priv.toString(16, 2)) +
         ' pub: ' + (this.pub && this.pub.inspect()) + ' >';
};


/***/ }),

/***/ "./node_modules/elliptic/lib/elliptic/ec/signature.js":
/*!************************************************************!*\
  !*** ./node_modules/elliptic/lib/elliptic/ec/signature.js ***!
  \************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var BN = __webpack_require__(/*! bn.js */ "./node_modules/elliptic/node_modules/bn.js/lib/bn.js");

var utils = __webpack_require__(/*! ../utils */ "./node_modules/elliptic/lib/elliptic/utils.js");
var assert = utils.assert;

function Signature(options, enc) {
  if (options instanceof Signature)
    return options;

  if (this._importDER(options, enc))
    return;

  assert(options.r && options.s, 'Signature without r or s');
  this.r = new BN(options.r, 16);
  this.s = new BN(options.s, 16);
  if (options.recoveryParam === undefined)
    this.recoveryParam = null;
  else
    this.recoveryParam = options.recoveryParam;
}
module.exports = Signature;

function Position() {
  this.place = 0;
}

function getLength(buf, p) {
  var initial = buf[p.place++];
  if (!(initial & 0x80)) {
    return initial;
  }
  var octetLen = initial & 0xf;

  // Indefinite length or overflow
  if (octetLen === 0 || octetLen > 4) {
    return false;
  }

  var val = 0;
  for (var i = 0, off = p.place; i < octetLen; i++, off++) {
    val <<= 8;
    val |= buf[off];
    val >>>= 0;
  }

  // Leading zeroes
  if (val <= 0x7f) {
    return false;
  }

  p.place = off;
  return val;
}

function rmPadding(buf) {
  var i = 0;
  var len = buf.length - 1;
  while (!buf[i] && !(buf[i + 1] & 0x80) && i < len) {
    i++;
  }
  if (i === 0) {
    return buf;
  }
  return buf.slice(i);
}

Signature.prototype._importDER = function _importDER(data, enc) {
  data = utils.toArray(data, enc);
  var p = new Position();
  if (data[p.place++] !== 0x30) {
    return false;
  }
  var len = getLength(data, p);
  if (len === false) {
    return false;
  }
  if ((len + p.place) !== data.length) {
    return false;
  }
  if (data[p.place++] !== 0x02) {
    return false;
  }
  var rlen = getLength(data, p);
  if (rlen === false) {
    return false;
  }
  var r = data.slice(p.place, rlen + p.place);
  p.place += rlen;
  if (data[p.place++] !== 0x02) {
    return false;
  }
  var slen = getLength(data, p);
  if (slen === false) {
    return false;
  }
  if (data.length !== slen + p.place) {
    return false;
  }
  var s = data.slice(p.place, slen + p.place);
  if (r[0] === 0) {
    if (r[1] & 0x80) {
      r = r.slice(1);
    } else {
      // Leading zeroes
      return false;
    }
  }
  if (s[0] === 0) {
    if (s[1] & 0x80) {
      s = s.slice(1);
    } else {
      // Leading zeroes
      return false;
    }
  }

  this.r = new BN(r);
  this.s = new BN(s);
  this.recoveryParam = null;

  return true;
};

function constructLength(arr, len) {
  if (len < 0x80) {
    arr.push(len);
    return;
  }
  var octets = 1 + (Math.log(len) / Math.LN2 >>> 3);
  arr.push(octets | 0x80);
  while (--octets) {
    arr.push((len >>> (octets << 3)) & 0xff);
  }
  arr.push(len);
}

Signature.prototype.toDER = function toDER(enc) {
  var r = this.r.toArray();
  var s = this.s.toArray();

  // Pad values
  if (r[0] & 0x80)
    r = [ 0 ].concat(r);
  // Pad values
  if (s[0] & 0x80)
    s = [ 0 ].concat(s);

  r = rmPadding(r);
  s = rmPadding(s);

  while (!s[0] && !(s[1] & 0x80)) {
    s = s.slice(1);
  }
  var arr = [ 0x02 ];
  constructLength(arr, r.length);
  arr = arr.concat(r);
  arr.push(0x02);
  constructLength(arr, s.length);
  var backHalf = arr.concat(s);
  var res = [ 0x30 ];
  constructLength(res, backHalf.length);
  res = res.concat(backHalf);
  return utils.encode(res, enc);
};


/***/ }),

/***/ "./node_modules/elliptic/lib/elliptic/eddsa/index.js":
/*!***********************************************************!*\
  !*** ./node_modules/elliptic/lib/elliptic/eddsa/index.js ***!
  \***********************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var hash = __webpack_require__(/*! hash.js */ "./node_modules/hash.js/lib/hash.js");
var curves = __webpack_require__(/*! ../curves */ "./node_modules/elliptic/lib/elliptic/curves.js");
var utils = __webpack_require__(/*! ../utils */ "./node_modules/elliptic/lib/elliptic/utils.js");
var assert = utils.assert;
var parseBytes = utils.parseBytes;
var KeyPair = __webpack_require__(/*! ./key */ "./node_modules/elliptic/lib/elliptic/eddsa/key.js");
var Signature = __webpack_require__(/*! ./signature */ "./node_modules/elliptic/lib/elliptic/eddsa/signature.js");

function EDDSA(curve) {
  assert(curve === 'ed25519', 'only tested with ed25519 so far');

  if (!(this instanceof EDDSA))
    return new EDDSA(curve);

  var curve = curves[curve].curve;
  this.curve = curve;
  this.g = curve.g;
  this.g.precompute(curve.n.bitLength() + 1);

  this.pointClass = curve.point().constructor;
  this.encodingLength = Math.ceil(curve.n.bitLength() / 8);
  this.hash = hash.sha512;
}

module.exports = EDDSA;

/**
* @param {Array|String} message - message bytes
* @param {Array|String|KeyPair} secret - secret bytes or a keypair
* @returns {Signature} - signature
*/
EDDSA.prototype.sign = function sign(message, secret) {
  message = parseBytes(message);
  var key = this.keyFromSecret(secret);
  var r = this.hashInt(key.messagePrefix(), message);
  var R = this.g.mul(r);
  var Rencoded = this.encodePoint(R);
  var s_ = this.hashInt(Rencoded, key.pubBytes(), message)
               .mul(key.priv());
  var S = r.add(s_).umod(this.curve.n);
  return this.makeSignature({ R: R, S: S, Rencoded: Rencoded });
};

/**
* @param {Array} message - message bytes
* @param {Array|String|Signature} sig - sig bytes
* @param {Array|String|Point|KeyPair} pub - public key
* @returns {Boolean} - true if public key matches sig of message
*/
EDDSA.prototype.verify = function verify(message, sig, pub) {
  message = parseBytes(message);
  sig = this.makeSignature(sig);
  var key = this.keyFromPublic(pub);
  var h = this.hashInt(sig.Rencoded(), key.pubBytes(), message);
  var SG = this.g.mul(sig.S());
  var RplusAh = sig.R().add(key.pub().mul(h));
  return RplusAh.eq(SG);
};

EDDSA.prototype.hashInt = function hashInt() {
  var hash = this.hash();
  for (var i = 0; i < arguments.length; i++)
    hash.update(arguments[i]);
  return utils.intFromLE(hash.digest()).umod(this.curve.n);
};

EDDSA.prototype.keyFromPublic = function keyFromPublic(pub) {
  return KeyPair.fromPublic(this, pub);
};

EDDSA.prototype.keyFromSecret = function keyFromSecret(secret) {
  return KeyPair.fromSecret(this, secret);
};

EDDSA.prototype.makeSignature = function makeSignature(sig) {
  if (sig instanceof Signature)
    return sig;
  return new Signature(this, sig);
};

/**
* * https://tools.ietf.org/html/draft-josefsson-eddsa-ed25519-03#section-5.2
*
* EDDSA defines methods for encoding and decoding points and integers. These are
* helper convenience methods, that pass along to utility functions implied
* parameters.
*
*/
EDDSA.prototype.encodePoint = function encodePoint(point) {
  var enc = point.getY().toArray('le', this.encodingLength);
  enc[this.encodingLength - 1] |= point.getX().isOdd() ? 0x80 : 0;
  return enc;
};

EDDSA.prototype.decodePoint = function decodePoint(bytes) {
  bytes = utils.parseBytes(bytes);

  var lastIx = bytes.length - 1;
  var normed = bytes.slice(0, lastIx).concat(bytes[lastIx] & ~0x80);
  var xIsOdd = (bytes[lastIx] & 0x80) !== 0;

  var y = utils.intFromLE(normed);
  return this.curve.pointFromY(y, xIsOdd);
};

EDDSA.prototype.encodeInt = function encodeInt(num) {
  return num.toArray('le', this.encodingLength);
};

EDDSA.prototype.decodeInt = function decodeInt(bytes) {
  return utils.intFromLE(bytes);
};

EDDSA.prototype.isPoint = function isPoint(val) {
  return val instanceof this.pointClass;
};


/***/ }),

/***/ "./node_modules/elliptic/lib/elliptic/eddsa/key.js":
/*!*********************************************************!*\
  !*** ./node_modules/elliptic/lib/elliptic/eddsa/key.js ***!
  \*********************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(/*! ../utils */ "./node_modules/elliptic/lib/elliptic/utils.js");
var assert = utils.assert;
var parseBytes = utils.parseBytes;
var cachedProperty = utils.cachedProperty;

/**
* @param {EDDSA} eddsa - instance
* @param {Object} params - public/private key parameters
*
* @param {Array<Byte>} [params.secret] - secret seed bytes
* @param {Point} [params.pub] - public key point (aka `A` in eddsa terms)
* @param {Array<Byte>} [params.pub] - public key point encoded as bytes
*
*/
function KeyPair(eddsa, params) {
  this.eddsa = eddsa;
  this._secret = parseBytes(params.secret);
  if (eddsa.isPoint(params.pub))
    this._pub = params.pub;
  else
    this._pubBytes = parseBytes(params.pub);
}

KeyPair.fromPublic = function fromPublic(eddsa, pub) {
  if (pub instanceof KeyPair)
    return pub;
  return new KeyPair(eddsa, { pub: pub });
};

KeyPair.fromSecret = function fromSecret(eddsa, secret) {
  if (secret instanceof KeyPair)
    return secret;
  return new KeyPair(eddsa, { secret: secret });
};

KeyPair.prototype.secret = function secret() {
  return this._secret;
};

cachedProperty(KeyPair, 'pubBytes', function pubBytes() {
  return this.eddsa.encodePoint(this.pub());
});

cachedProperty(KeyPair, 'pub', function pub() {
  if (this._pubBytes)
    return this.eddsa.decodePoint(this._pubBytes);
  return this.eddsa.g.mul(this.priv());
});

cachedProperty(KeyPair, 'privBytes', function privBytes() {
  var eddsa = this.eddsa;
  var hash = this.hash();
  var lastIx = eddsa.encodingLength - 1;

  var a = hash.slice(0, eddsa.encodingLength);
  a[0] &= 248;
  a[lastIx] &= 127;
  a[lastIx] |= 64;

  return a;
});

cachedProperty(KeyPair, 'priv', function priv() {
  return this.eddsa.decodeInt(this.privBytes());
});

cachedProperty(KeyPair, 'hash', function hash() {
  return this.eddsa.hash().update(this.secret()).digest();
});

cachedProperty(KeyPair, 'messagePrefix', function messagePrefix() {
  return this.hash().slice(this.eddsa.encodingLength);
});

KeyPair.prototype.sign = function sign(message) {
  assert(this._secret, 'KeyPair can only verify');
  return this.eddsa.sign(message, this);
};

KeyPair.prototype.verify = function verify(message, sig) {
  return this.eddsa.verify(message, sig, this);
};

KeyPair.prototype.getSecret = function getSecret(enc) {
  assert(this._secret, 'KeyPair is public only');
  return utils.encode(this.secret(), enc);
};

KeyPair.prototype.getPublic = function getPublic(enc) {
  return utils.encode(this.pubBytes(), enc);
};

module.exports = KeyPair;


/***/ }),

/***/ "./node_modules/elliptic/lib/elliptic/eddsa/signature.js":
/*!***************************************************************!*\
  !*** ./node_modules/elliptic/lib/elliptic/eddsa/signature.js ***!
  \***************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var BN = __webpack_require__(/*! bn.js */ "./node_modules/elliptic/node_modules/bn.js/lib/bn.js");
var utils = __webpack_require__(/*! ../utils */ "./node_modules/elliptic/lib/elliptic/utils.js");
var assert = utils.assert;
var cachedProperty = utils.cachedProperty;
var parseBytes = utils.parseBytes;

/**
* @param {EDDSA} eddsa - eddsa instance
* @param {Array<Bytes>|Object} sig -
* @param {Array<Bytes>|Point} [sig.R] - R point as Point or bytes
* @param {Array<Bytes>|bn} [sig.S] - S scalar as bn or bytes
* @param {Array<Bytes>} [sig.Rencoded] - R point encoded
* @param {Array<Bytes>} [sig.Sencoded] - S scalar encoded
*/
function Signature(eddsa, sig) {
  this.eddsa = eddsa;

  if (typeof sig !== 'object')
    sig = parseBytes(sig);

  if (Array.isArray(sig)) {
    sig = {
      R: sig.slice(0, eddsa.encodingLength),
      S: sig.slice(eddsa.encodingLength)
    };
  }

  assert(sig.R && sig.S, 'Signature without R or S');

  if (eddsa.isPoint(sig.R))
    this._R = sig.R;
  if (sig.S instanceof BN)
    this._S = sig.S;

  this._Rencoded = Array.isArray(sig.R) ? sig.R : sig.Rencoded;
  this._Sencoded = Array.isArray(sig.S) ? sig.S : sig.Sencoded;
}

cachedProperty(Signature, 'S', function S() {
  return this.eddsa.decodeInt(this.Sencoded());
});

cachedProperty(Signature, 'R', function R() {
  return this.eddsa.decodePoint(this.Rencoded());
});

cachedProperty(Signature, 'Rencoded', function Rencoded() {
  return this.eddsa.encodePoint(this.R());
});

cachedProperty(Signature, 'Sencoded', function Sencoded() {
  return this.eddsa.encodeInt(this.S());
});

Signature.prototype.toBytes = function toBytes() {
  return this.Rencoded().concat(this.Sencoded());
};

Signature.prototype.toHex = function toHex() {
  return utils.encode(this.toBytes(), 'hex').toUpperCase();
};

module.exports = Signature;


/***/ }),

/***/ "./node_modules/elliptic/lib/elliptic/precomputed/secp256k1.js":
/*!*********************************************************************!*\
  !*** ./node_modules/elliptic/lib/elliptic/precomputed/secp256k1.js ***!
  \*********************************************************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = {
  doubles: {
    step: 4,
    points: [
      [
        'e60fce93b59e9ec53011aabc21c23e97b2a31369b87a5ae9c44ee89e2a6dec0a',
        'f7e3507399e595929db99f34f57937101296891e44d23f0be1f32cce69616821'
      ],
      [
        '8282263212c609d9ea2a6e3e172de238d8c39cabd5ac1ca10646e23fd5f51508',
        '11f8a8098557dfe45e8256e830b60ace62d613ac2f7b17bed31b6eaff6e26caf'
      ],
      [
        '175e159f728b865a72f99cc6c6fc846de0b93833fd2222ed73fce5b551e5b739',
        'd3506e0d9e3c79eba4ef97a51ff71f5eacb5955add24345c6efa6ffee9fed695'
      ],
      [
        '363d90d447b00c9c99ceac05b6262ee053441c7e55552ffe526bad8f83ff4640',
        '4e273adfc732221953b445397f3363145b9a89008199ecb62003c7f3bee9de9'
      ],
      [
        '8b4b5f165df3c2be8c6244b5b745638843e4a781a15bcd1b69f79a55dffdf80c',
        '4aad0a6f68d308b4b3fbd7813ab0da04f9e336546162ee56b3eff0c65fd4fd36'
      ],
      [
        '723cbaa6e5db996d6bf771c00bd548c7b700dbffa6c0e77bcb6115925232fcda',
        '96e867b5595cc498a921137488824d6e2660a0653779494801dc069d9eb39f5f'
      ],
      [
        'eebfa4d493bebf98ba5feec812c2d3b50947961237a919839a533eca0e7dd7fa',
        '5d9a8ca3970ef0f269ee7edaf178089d9ae4cdc3a711f712ddfd4fdae1de8999'
      ],
      [
        '100f44da696e71672791d0a09b7bde459f1215a29b3c03bfefd7835b39a48db0',
        'cdd9e13192a00b772ec8f3300c090666b7ff4a18ff5195ac0fbd5cd62bc65a09'
      ],
      [
        'e1031be262c7ed1b1dc9227a4a04c017a77f8d4464f3b3852c8acde6e534fd2d',
        '9d7061928940405e6bb6a4176597535af292dd419e1ced79a44f18f29456a00d'
      ],
      [
        'feea6cae46d55b530ac2839f143bd7ec5cf8b266a41d6af52d5e688d9094696d',
        'e57c6b6c97dce1bab06e4e12bf3ecd5c981c8957cc41442d3155debf18090088'
      ],
      [
        'da67a91d91049cdcb367be4be6ffca3cfeed657d808583de33fa978bc1ec6cb1',
        '9bacaa35481642bc41f463f7ec9780e5dec7adc508f740a17e9ea8e27a68be1d'
      ],
      [
        '53904faa0b334cdda6e000935ef22151ec08d0f7bb11069f57545ccc1a37b7c0',
        '5bc087d0bc80106d88c9eccac20d3c1c13999981e14434699dcb096b022771c8'
      ],
      [
        '8e7bcd0bd35983a7719cca7764ca906779b53a043a9b8bcaeff959f43ad86047',
        '10b7770b2a3da4b3940310420ca9514579e88e2e47fd68b3ea10047e8460372a'
      ],
      [
        '385eed34c1cdff21e6d0818689b81bde71a7f4f18397e6690a841e1599c43862',
        '283bebc3e8ea23f56701de19e9ebf4576b304eec2086dc8cc0458fe5542e5453'
      ],
      [
        '6f9d9b803ecf191637c73a4413dfa180fddf84a5947fbc9c606ed86c3fac3a7',
        '7c80c68e603059ba69b8e2a30e45c4d47ea4dd2f5c281002d86890603a842160'
      ],
      [
        '3322d401243c4e2582a2147c104d6ecbf774d163db0f5e5313b7e0e742d0e6bd',
        '56e70797e9664ef5bfb019bc4ddaf9b72805f63ea2873af624f3a2e96c28b2a0'
      ],
      [
        '85672c7d2de0b7da2bd1770d89665868741b3f9af7643397721d74d28134ab83',
        '7c481b9b5b43b2eb6374049bfa62c2e5e77f17fcc5298f44c8e3094f790313a6'
      ],
      [
        '948bf809b1988a46b06c9f1919413b10f9226c60f668832ffd959af60c82a0a',
        '53a562856dcb6646dc6b74c5d1c3418c6d4dff08c97cd2bed4cb7f88d8c8e589'
      ],
      [
        '6260ce7f461801c34f067ce0f02873a8f1b0e44dfc69752accecd819f38fd8e8',
        'bc2da82b6fa5b571a7f09049776a1ef7ecd292238051c198c1a84e95b2b4ae17'
      ],
      [
        'e5037de0afc1d8d43d8348414bbf4103043ec8f575bfdc432953cc8d2037fa2d',
        '4571534baa94d3b5f9f98d09fb990bddbd5f5b03ec481f10e0e5dc841d755bda'
      ],
      [
        'e06372b0f4a207adf5ea905e8f1771b4e7e8dbd1c6a6c5b725866a0ae4fce725',
        '7a908974bce18cfe12a27bb2ad5a488cd7484a7787104870b27034f94eee31dd'
      ],
      [
        '213c7a715cd5d45358d0bbf9dc0ce02204b10bdde2a3f58540ad6908d0559754',
        '4b6dad0b5ae462507013ad06245ba190bb4850f5f36a7eeddff2c27534b458f2'
      ],
      [
        '4e7c272a7af4b34e8dbb9352a5419a87e2838c70adc62cddf0cc3a3b08fbd53c',
        '17749c766c9d0b18e16fd09f6def681b530b9614bff7dd33e0b3941817dcaae6'
      ],
      [
        'fea74e3dbe778b1b10f238ad61686aa5c76e3db2be43057632427e2840fb27b6',
        '6e0568db9b0b13297cf674deccb6af93126b596b973f7b77701d3db7f23cb96f'
      ],
      [
        '76e64113f677cf0e10a2570d599968d31544e179b760432952c02a4417bdde39',
        'c90ddf8dee4e95cf577066d70681f0d35e2a33d2b56d2032b4b1752d1901ac01'
      ],
      [
        'c738c56b03b2abe1e8281baa743f8f9a8f7cc643df26cbee3ab150242bcbb891',
        '893fb578951ad2537f718f2eacbfbbbb82314eef7880cfe917e735d9699a84c3'
      ],
      [
        'd895626548b65b81e264c7637c972877d1d72e5f3a925014372e9f6588f6c14b',
        'febfaa38f2bc7eae728ec60818c340eb03428d632bb067e179363ed75d7d991f'
      ],
      [
        'b8da94032a957518eb0f6433571e8761ceffc73693e84edd49150a564f676e03',
        '2804dfa44805a1e4d7c99cc9762808b092cc584d95ff3b511488e4e74efdf6e7'
      ],
      [
        'e80fea14441fb33a7d8adab9475d7fab2019effb5156a792f1a11778e3c0df5d',
        'eed1de7f638e00771e89768ca3ca94472d155e80af322ea9fcb4291b6ac9ec78'
      ],
      [
        'a301697bdfcd704313ba48e51d567543f2a182031efd6915ddc07bbcc4e16070',
        '7370f91cfb67e4f5081809fa25d40f9b1735dbf7c0a11a130c0d1a041e177ea1'
      ],
      [
        '90ad85b389d6b936463f9d0512678de208cc330b11307fffab7ac63e3fb04ed4',
        'e507a3620a38261affdcbd9427222b839aefabe1582894d991d4d48cb6ef150'
      ],
      [
        '8f68b9d2f63b5f339239c1ad981f162ee88c5678723ea3351b7b444c9ec4c0da',
        '662a9f2dba063986de1d90c2b6be215dbbea2cfe95510bfdf23cbf79501fff82'
      ],
      [
        'e4f3fb0176af85d65ff99ff9198c36091f48e86503681e3e6686fd5053231e11',
        '1e63633ad0ef4f1c1661a6d0ea02b7286cc7e74ec951d1c9822c38576feb73bc'
      ],
      [
        '8c00fa9b18ebf331eb961537a45a4266c7034f2f0d4e1d0716fb6eae20eae29e',
        'efa47267fea521a1a9dc343a3736c974c2fadafa81e36c54e7d2a4c66702414b'
      ],
      [
        'e7a26ce69dd4829f3e10cec0a9e98ed3143d084f308b92c0997fddfc60cb3e41',
        '2a758e300fa7984b471b006a1aafbb18d0a6b2c0420e83e20e8a9421cf2cfd51'
      ],
      [
        'b6459e0ee3662ec8d23540c223bcbdc571cbcb967d79424f3cf29eb3de6b80ef',
        '67c876d06f3e06de1dadf16e5661db3c4b3ae6d48e35b2ff30bf0b61a71ba45'
      ],
      [
        'd68a80c8280bb840793234aa118f06231d6f1fc67e73c5a5deda0f5b496943e8',
        'db8ba9fff4b586d00c4b1f9177b0e28b5b0e7b8f7845295a294c84266b133120'
      ],
      [
        '324aed7df65c804252dc0270907a30b09612aeb973449cea4095980fc28d3d5d',
        '648a365774b61f2ff130c0c35aec1f4f19213b0c7e332843967224af96ab7c84'
      ],
      [
        '4df9c14919cde61f6d51dfdbe5fee5dceec4143ba8d1ca888e8bd373fd054c96',
        '35ec51092d8728050974c23a1d85d4b5d506cdc288490192ebac06cad10d5d'
      ],
      [
        '9c3919a84a474870faed8a9c1cc66021523489054d7f0308cbfc99c8ac1f98cd',
        'ddb84f0f4a4ddd57584f044bf260e641905326f76c64c8e6be7e5e03d4fc599d'
      ],
      [
        '6057170b1dd12fdf8de05f281d8e06bb91e1493a8b91d4cc5a21382120a959e5',
        '9a1af0b26a6a4807add9a2daf71df262465152bc3ee24c65e899be932385a2a8'
      ],
      [
        'a576df8e23a08411421439a4518da31880cef0fba7d4df12b1a6973eecb94266',
        '40a6bf20e76640b2c92b97afe58cd82c432e10a7f514d9f3ee8be11ae1b28ec8'
      ],
      [
        '7778a78c28dec3e30a05fe9629de8c38bb30d1f5cf9a3a208f763889be58ad71',
        '34626d9ab5a5b22ff7098e12f2ff580087b38411ff24ac563b513fc1fd9f43ac'
      ],
      [
        '928955ee637a84463729fd30e7afd2ed5f96274e5ad7e5cb09eda9c06d903ac',
        'c25621003d3f42a827b78a13093a95eeac3d26efa8a8d83fc5180e935bcd091f'
      ],
      [
        '85d0fef3ec6db109399064f3a0e3b2855645b4a907ad354527aae75163d82751',
        '1f03648413a38c0be29d496e582cf5663e8751e96877331582c237a24eb1f962'
      ],
      [
        'ff2b0dce97eece97c1c9b6041798b85dfdfb6d8882da20308f5404824526087e',
        '493d13fef524ba188af4c4dc54d07936c7b7ed6fb90e2ceb2c951e01f0c29907'
      ],
      [
        '827fbbe4b1e880ea9ed2b2e6301b212b57f1ee148cd6dd28780e5e2cf856e241',
        'c60f9c923c727b0b71bef2c67d1d12687ff7a63186903166d605b68baec293ec'
      ],
      [
        'eaa649f21f51bdbae7be4ae34ce6e5217a58fdce7f47f9aa7f3b58fa2120e2b3',
        'be3279ed5bbbb03ac69a80f89879aa5a01a6b965f13f7e59d47a5305ba5ad93d'
      ],
      [
        'e4a42d43c5cf169d9391df6decf42ee541b6d8f0c9a137401e23632dda34d24f',
        '4d9f92e716d1c73526fc99ccfb8ad34ce886eedfa8d8e4f13a7f7131deba9414'
      ],
      [
        '1ec80fef360cbdd954160fadab352b6b92b53576a88fea4947173b9d4300bf19',
        'aeefe93756b5340d2f3a4958a7abbf5e0146e77f6295a07b671cdc1cc107cefd'
      ],
      [
        '146a778c04670c2f91b00af4680dfa8bce3490717d58ba889ddb5928366642be',
        'b318e0ec3354028add669827f9d4b2870aaa971d2f7e5ed1d0b297483d83efd0'
      ],
      [
        'fa50c0f61d22e5f07e3acebb1aa07b128d0012209a28b9776d76a8793180eef9',
        '6b84c6922397eba9b72cd2872281a68a5e683293a57a213b38cd8d7d3f4f2811'
      ],
      [
        'da1d61d0ca721a11b1a5bf6b7d88e8421a288ab5d5bba5220e53d32b5f067ec2',
        '8157f55a7c99306c79c0766161c91e2966a73899d279b48a655fba0f1ad836f1'
      ],
      [
        'a8e282ff0c9706907215ff98e8fd416615311de0446f1e062a73b0610d064e13',
        '7f97355b8db81c09abfb7f3c5b2515888b679a3e50dd6bd6cef7c73111f4cc0c'
      ],
      [
        '174a53b9c9a285872d39e56e6913cab15d59b1fa512508c022f382de8319497c',
        'ccc9dc37abfc9c1657b4155f2c47f9e6646b3a1d8cb9854383da13ac079afa73'
      ],
      [
        '959396981943785c3d3e57edf5018cdbe039e730e4918b3d884fdff09475b7ba',
        '2e7e552888c331dd8ba0386a4b9cd6849c653f64c8709385e9b8abf87524f2fd'
      ],
      [
        'd2a63a50ae401e56d645a1153b109a8fcca0a43d561fba2dbb51340c9d82b151',
        'e82d86fb6443fcb7565aee58b2948220a70f750af484ca52d4142174dcf89405'
      ],
      [
        '64587e2335471eb890ee7896d7cfdc866bacbdbd3839317b3436f9b45617e073',
        'd99fcdd5bf6902e2ae96dd6447c299a185b90a39133aeab358299e5e9faf6589'
      ],
      [
        '8481bde0e4e4d885b3a546d3e549de042f0aa6cea250e7fd358d6c86dd45e458',
        '38ee7b8cba5404dd84a25bf39cecb2ca900a79c42b262e556d64b1b59779057e'
      ],
      [
        '13464a57a78102aa62b6979ae817f4637ffcfed3c4b1ce30bcd6303f6caf666b',
        '69be159004614580ef7e433453ccb0ca48f300a81d0942e13f495a907f6ecc27'
      ],
      [
        'bc4a9df5b713fe2e9aef430bcc1dc97a0cd9ccede2f28588cada3a0d2d83f366',
        'd3a81ca6e785c06383937adf4b798caa6e8a9fbfa547b16d758d666581f33c1'
      ],
      [
        '8c28a97bf8298bc0d23d8c749452a32e694b65e30a9472a3954ab30fe5324caa',
        '40a30463a3305193378fedf31f7cc0eb7ae784f0451cb9459e71dc73cbef9482'
      ],
      [
        '8ea9666139527a8c1dd94ce4f071fd23c8b350c5a4bb33748c4ba111faccae0',
        '620efabbc8ee2782e24e7c0cfb95c5d735b783be9cf0f8e955af34a30e62b945'
      ],
      [
        'dd3625faef5ba06074669716bbd3788d89bdde815959968092f76cc4eb9a9787',
        '7a188fa3520e30d461da2501045731ca941461982883395937f68d00c644a573'
      ],
      [
        'f710d79d9eb962297e4f6232b40e8f7feb2bc63814614d692c12de752408221e',
        'ea98e67232d3b3295d3b535532115ccac8612c721851617526ae47a9c77bfc82'
      ]
    ]
  },
  naf: {
    wnd: 7,
    points: [
      [
        'f9308a019258c31049344f85f89d5229b531c845836f99b08601f113bce036f9',
        '388f7b0f632de8140fe337e62a37f3566500a99934c2231b6cb9fd7584b8e672'
      ],
      [
        '2f8bde4d1a07209355b4a7250a5c5128e88b84bddc619ab7cba8d569b240efe4',
        'd8ac222636e5e3d6d4dba9dda6c9c426f788271bab0d6840dca87d3aa6ac62d6'
      ],
      [
        '5cbdf0646e5db4eaa398f365f2ea7a0e3d419b7e0330e39ce92bddedcac4f9bc',
        '6aebca40ba255960a3178d6d861a54dba813d0b813fde7b5a5082628087264da'
      ],
      [
        'acd484e2f0c7f65309ad178a9f559abde09796974c57e714c35f110dfc27ccbe',
        'cc338921b0a7d9fd64380971763b61e9add888a4375f8e0f05cc262ac64f9c37'
      ],
      [
        '774ae7f858a9411e5ef4246b70c65aac5649980be5c17891bbec17895da008cb',
        'd984a032eb6b5e190243dd56d7b7b365372db1e2dff9d6a8301d74c9c953c61b'
      ],
      [
        'f28773c2d975288bc7d1d205c3748651b075fbc6610e58cddeeddf8f19405aa8',
        'ab0902e8d880a89758212eb65cdaf473a1a06da521fa91f29b5cb52db03ed81'
      ],
      [
        'd7924d4f7d43ea965a465ae3095ff41131e5946f3c85f79e44adbcf8e27e080e',
        '581e2872a86c72a683842ec228cc6defea40af2bd896d3a5c504dc9ff6a26b58'
      ],
      [
        'defdea4cdb677750a420fee807eacf21eb9898ae79b9768766e4faa04a2d4a34',
        '4211ab0694635168e997b0ead2a93daeced1f4a04a95c0f6cfb199f69e56eb77'
      ],
      [
        '2b4ea0a797a443d293ef5cff444f4979f06acfebd7e86d277475656138385b6c',
        '85e89bc037945d93b343083b5a1c86131a01f60c50269763b570c854e5c09b7a'
      ],
      [
        '352bbf4a4cdd12564f93fa332ce333301d9ad40271f8107181340aef25be59d5',
        '321eb4075348f534d59c18259dda3e1f4a1b3b2e71b1039c67bd3d8bcf81998c'
      ],
      [
        '2fa2104d6b38d11b0230010559879124e42ab8dfeff5ff29dc9cdadd4ecacc3f',
        '2de1068295dd865b64569335bd5dd80181d70ecfc882648423ba76b532b7d67'
      ],
      [
        '9248279b09b4d68dab21a9b066edda83263c3d84e09572e269ca0cd7f5453714',
        '73016f7bf234aade5d1aa71bdea2b1ff3fc0de2a887912ffe54a32ce97cb3402'
      ],
      [
        'daed4f2be3a8bf278e70132fb0beb7522f570e144bf615c07e996d443dee8729',
        'a69dce4a7d6c98e8d4a1aca87ef8d7003f83c230f3afa726ab40e52290be1c55'
      ],
      [
        'c44d12c7065d812e8acf28d7cbb19f9011ecd9e9fdf281b0e6a3b5e87d22e7db',
        '2119a460ce326cdc76c45926c982fdac0e106e861edf61c5a039063f0e0e6482'
      ],
      [
        '6a245bf6dc698504c89a20cfded60853152b695336c28063b61c65cbd269e6b4',
        'e022cf42c2bd4a708b3f5126f16a24ad8b33ba48d0423b6efd5e6348100d8a82'
      ],
      [
        '1697ffa6fd9de627c077e3d2fe541084ce13300b0bec1146f95ae57f0d0bd6a5',
        'b9c398f186806f5d27561506e4557433a2cf15009e498ae7adee9d63d01b2396'
      ],
      [
        '605bdb019981718b986d0f07e834cb0d9deb8360ffb7f61df982345ef27a7479',
        '2972d2de4f8d20681a78d93ec96fe23c26bfae84fb14db43b01e1e9056b8c49'
      ],
      [
        '62d14dab4150bf497402fdc45a215e10dcb01c354959b10cfe31c7e9d87ff33d',
        '80fc06bd8cc5b01098088a1950eed0db01aa132967ab472235f5642483b25eaf'
      ],
      [
        '80c60ad0040f27dade5b4b06c408e56b2c50e9f56b9b8b425e555c2f86308b6f',
        '1c38303f1cc5c30f26e66bad7fe72f70a65eed4cbe7024eb1aa01f56430bd57a'
      ],
      [
        '7a9375ad6167ad54aa74c6348cc54d344cc5dc9487d847049d5eabb0fa03c8fb',
        'd0e3fa9eca8726909559e0d79269046bdc59ea10c70ce2b02d499ec224dc7f7'
      ],
      [
        'd528ecd9b696b54c907a9ed045447a79bb408ec39b68df504bb51f459bc3ffc9',
        'eecf41253136e5f99966f21881fd656ebc4345405c520dbc063465b521409933'
      ],
      [
        '49370a4b5f43412ea25f514e8ecdad05266115e4a7ecb1387231808f8b45963',
        '758f3f41afd6ed428b3081b0512fd62a54c3f3afbb5b6764b653052a12949c9a'
      ],
      [
        '77f230936ee88cbbd73df930d64702ef881d811e0e1498e2f1c13eb1fc345d74',
        '958ef42a7886b6400a08266e9ba1b37896c95330d97077cbbe8eb3c7671c60d6'
      ],
      [
        'f2dac991cc4ce4b9ea44887e5c7c0bce58c80074ab9d4dbaeb28531b7739f530',
        'e0dedc9b3b2f8dad4da1f32dec2531df9eb5fbeb0598e4fd1a117dba703a3c37'
      ],
      [
        '463b3d9f662621fb1b4be8fbbe2520125a216cdfc9dae3debcba4850c690d45b',
        '5ed430d78c296c3543114306dd8622d7c622e27c970a1de31cb377b01af7307e'
      ],
      [
        'f16f804244e46e2a09232d4aff3b59976b98fac14328a2d1a32496b49998f247',
        'cedabd9b82203f7e13d206fcdf4e33d92a6c53c26e5cce26d6579962c4e31df6'
      ],
      [
        'caf754272dc84563b0352b7a14311af55d245315ace27c65369e15f7151d41d1',
        'cb474660ef35f5f2a41b643fa5e460575f4fa9b7962232a5c32f908318a04476'
      ],
      [
        '2600ca4b282cb986f85d0f1709979d8b44a09c07cb86d7c124497bc86f082120',
        '4119b88753c15bd6a693b03fcddbb45d5ac6be74ab5f0ef44b0be9475a7e4b40'
      ],
      [
        '7635ca72d7e8432c338ec53cd12220bc01c48685e24f7dc8c602a7746998e435',
        '91b649609489d613d1d5e590f78e6d74ecfc061d57048bad9e76f302c5b9c61'
      ],
      [
        '754e3239f325570cdbbf4a87deee8a66b7f2b33479d468fbc1a50743bf56cc18',
        '673fb86e5bda30fb3cd0ed304ea49a023ee33d0197a695d0c5d98093c536683'
      ],
      [
        'e3e6bd1071a1e96aff57859c82d570f0330800661d1c952f9fe2694691d9b9e8',
        '59c9e0bba394e76f40c0aa58379a3cb6a5a2283993e90c4167002af4920e37f5'
      ],
      [
        '186b483d056a033826ae73d88f732985c4ccb1f32ba35f4b4cc47fdcf04aa6eb',
        '3b952d32c67cf77e2e17446e204180ab21fb8090895138b4a4a797f86e80888b'
      ],
      [
        'df9d70a6b9876ce544c98561f4be4f725442e6d2b737d9c91a8321724ce0963f',
        '55eb2dafd84d6ccd5f862b785dc39d4ab157222720ef9da217b8c45cf2ba2417'
      ],
      [
        '5edd5cc23c51e87a497ca815d5dce0f8ab52554f849ed8995de64c5f34ce7143',
        'efae9c8dbc14130661e8cec030c89ad0c13c66c0d17a2905cdc706ab7399a868'
      ],
      [
        '290798c2b6476830da12fe02287e9e777aa3fba1c355b17a722d362f84614fba',
        'e38da76dcd440621988d00bcf79af25d5b29c094db2a23146d003afd41943e7a'
      ],
      [
        'af3c423a95d9f5b3054754efa150ac39cd29552fe360257362dfdecef4053b45',
        'f98a3fd831eb2b749a93b0e6f35cfb40c8cd5aa667a15581bc2feded498fd9c6'
      ],
      [
        '766dbb24d134e745cccaa28c99bf274906bb66b26dcf98df8d2fed50d884249a',
        '744b1152eacbe5e38dcc887980da38b897584a65fa06cedd2c924f97cbac5996'
      ],
      [
        '59dbf46f8c94759ba21277c33784f41645f7b44f6c596a58ce92e666191abe3e',
        'c534ad44175fbc300f4ea6ce648309a042ce739a7919798cd85e216c4a307f6e'
      ],
      [
        'f13ada95103c4537305e691e74e9a4a8dd647e711a95e73cb62dc6018cfd87b8',
        'e13817b44ee14de663bf4bc808341f326949e21a6a75c2570778419bdaf5733d'
      ],
      [
        '7754b4fa0e8aced06d4167a2c59cca4cda1869c06ebadfb6488550015a88522c',
        '30e93e864e669d82224b967c3020b8fa8d1e4e350b6cbcc537a48b57841163a2'
      ],
      [
        '948dcadf5990e048aa3874d46abef9d701858f95de8041d2a6828c99e2262519',
        'e491a42537f6e597d5d28a3224b1bc25df9154efbd2ef1d2cbba2cae5347d57e'
      ],
      [
        '7962414450c76c1689c7b48f8202ec37fb224cf5ac0bfa1570328a8a3d7c77ab',
        '100b610ec4ffb4760d5c1fc133ef6f6b12507a051f04ac5760afa5b29db83437'
      ],
      [
        '3514087834964b54b15b160644d915485a16977225b8847bb0dd085137ec47ca',
        'ef0afbb2056205448e1652c48e8127fc6039e77c15c2378b7e7d15a0de293311'
      ],
      [
        'd3cc30ad6b483e4bc79ce2c9dd8bc54993e947eb8df787b442943d3f7b527eaf',
        '8b378a22d827278d89c5e9be8f9508ae3c2ad46290358630afb34db04eede0a4'
      ],
      [
        '1624d84780732860ce1c78fcbfefe08b2b29823db913f6493975ba0ff4847610',
        '68651cf9b6da903e0914448c6cd9d4ca896878f5282be4c8cc06e2a404078575'
      ],
      [
        '733ce80da955a8a26902c95633e62a985192474b5af207da6df7b4fd5fc61cd4',
        'f5435a2bd2badf7d485a4d8b8db9fcce3e1ef8e0201e4578c54673bc1dc5ea1d'
      ],
      [
        '15d9441254945064cf1a1c33bbd3b49f8966c5092171e699ef258dfab81c045c',
        'd56eb30b69463e7234f5137b73b84177434800bacebfc685fc37bbe9efe4070d'
      ],
      [
        'a1d0fcf2ec9de675b612136e5ce70d271c21417c9d2b8aaaac138599d0717940',
        'edd77f50bcb5a3cab2e90737309667f2641462a54070f3d519212d39c197a629'
      ],
      [
        'e22fbe15c0af8ccc5780c0735f84dbe9a790badee8245c06c7ca37331cb36980',
        'a855babad5cd60c88b430a69f53a1a7a38289154964799be43d06d77d31da06'
      ],
      [
        '311091dd9860e8e20ee13473c1155f5f69635e394704eaa74009452246cfa9b3',
        '66db656f87d1f04fffd1f04788c06830871ec5a64feee685bd80f0b1286d8374'
      ],
      [
        '34c1fd04d301be89b31c0442d3e6ac24883928b45a9340781867d4232ec2dbdf',
        '9414685e97b1b5954bd46f730174136d57f1ceeb487443dc5321857ba73abee'
      ],
      [
        'f219ea5d6b54701c1c14de5b557eb42a8d13f3abbcd08affcc2a5e6b049b8d63',
        '4cb95957e83d40b0f73af4544cccf6b1f4b08d3c07b27fb8d8c2962a400766d1'
      ],
      [
        'd7b8740f74a8fbaab1f683db8f45de26543a5490bca627087236912469a0b448',
        'fa77968128d9c92ee1010f337ad4717eff15db5ed3c049b3411e0315eaa4593b'
      ],
      [
        '32d31c222f8f6f0ef86f7c98d3a3335ead5bcd32abdd94289fe4d3091aa824bf',
        '5f3032f5892156e39ccd3d7915b9e1da2e6dac9e6f26e961118d14b8462e1661'
      ],
      [
        '7461f371914ab32671045a155d9831ea8793d77cd59592c4340f86cbc18347b5',
        '8ec0ba238b96bec0cbdddcae0aa442542eee1ff50c986ea6b39847b3cc092ff6'
      ],
      [
        'ee079adb1df1860074356a25aa38206a6d716b2c3e67453d287698bad7b2b2d6',
        '8dc2412aafe3be5c4c5f37e0ecc5f9f6a446989af04c4e25ebaac479ec1c8c1e'
      ],
      [
        '16ec93e447ec83f0467b18302ee620f7e65de331874c9dc72bfd8616ba9da6b5',
        '5e4631150e62fb40d0e8c2a7ca5804a39d58186a50e497139626778e25b0674d'
      ],
      [
        'eaa5f980c245f6f038978290afa70b6bd8855897f98b6aa485b96065d537bd99',
        'f65f5d3e292c2e0819a528391c994624d784869d7e6ea67fb18041024edc07dc'
      ],
      [
        '78c9407544ac132692ee1910a02439958ae04877151342ea96c4b6b35a49f51',
        'f3e0319169eb9b85d5404795539a5e68fa1fbd583c064d2462b675f194a3ddb4'
      ],
      [
        '494f4be219a1a77016dcd838431aea0001cdc8ae7a6fc688726578d9702857a5',
        '42242a969283a5f339ba7f075e36ba2af925ce30d767ed6e55f4b031880d562c'
      ],
      [
        'a598a8030da6d86c6bc7f2f5144ea549d28211ea58faa70ebf4c1e665c1fe9b5',
        '204b5d6f84822c307e4b4a7140737aec23fc63b65b35f86a10026dbd2d864e6b'
      ],
      [
        'c41916365abb2b5d09192f5f2dbeafec208f020f12570a184dbadc3e58595997',
        '4f14351d0087efa49d245b328984989d5caf9450f34bfc0ed16e96b58fa9913'
      ],
      [
        '841d6063a586fa475a724604da03bc5b92a2e0d2e0a36acfe4c73a5514742881',
        '73867f59c0659e81904f9a1c7543698e62562d6744c169ce7a36de01a8d6154'
      ],
      [
        '5e95bb399a6971d376026947f89bde2f282b33810928be4ded112ac4d70e20d5',
        '39f23f366809085beebfc71181313775a99c9aed7d8ba38b161384c746012865'
      ],
      [
        '36e4641a53948fd476c39f8a99fd974e5ec07564b5315d8bf99471bca0ef2f66',
        'd2424b1b1abe4eb8164227b085c9aa9456ea13493fd563e06fd51cf5694c78fc'
      ],
      [
        '336581ea7bfbbb290c191a2f507a41cf5643842170e914faeab27c2c579f726',
        'ead12168595fe1be99252129b6e56b3391f7ab1410cd1e0ef3dcdcabd2fda224'
      ],
      [
        '8ab89816dadfd6b6a1f2634fcf00ec8403781025ed6890c4849742706bd43ede',
        '6fdcef09f2f6d0a044e654aef624136f503d459c3e89845858a47a9129cdd24e'
      ],
      [
        '1e33f1a746c9c5778133344d9299fcaa20b0938e8acff2544bb40284b8c5fb94',
        '60660257dd11b3aa9c8ed618d24edff2306d320f1d03010e33a7d2057f3b3b6'
      ],
      [
        '85b7c1dcb3cec1b7ee7f30ded79dd20a0ed1f4cc18cbcfcfa410361fd8f08f31',
        '3d98a9cdd026dd43f39048f25a8847f4fcafad1895d7a633c6fed3c35e999511'
      ],
      [
        '29df9fbd8d9e46509275f4b125d6d45d7fbe9a3b878a7af872a2800661ac5f51',
        'b4c4fe99c775a606e2d8862179139ffda61dc861c019e55cd2876eb2a27d84b'
      ],
      [
        'a0b1cae06b0a847a3fea6e671aaf8adfdfe58ca2f768105c8082b2e449fce252',
        'ae434102edde0958ec4b19d917a6a28e6b72da1834aff0e650f049503a296cf2'
      ],
      [
        '4e8ceafb9b3e9a136dc7ff67e840295b499dfb3b2133e4ba113f2e4c0e121e5',
        'cf2174118c8b6d7a4b48f6d534ce5c79422c086a63460502b827ce62a326683c'
      ],
      [
        'd24a44e047e19b6f5afb81c7ca2f69080a5076689a010919f42725c2b789a33b',
        '6fb8d5591b466f8fc63db50f1c0f1c69013f996887b8244d2cdec417afea8fa3'
      ],
      [
        'ea01606a7a6c9cdd249fdfcfacb99584001edd28abbab77b5104e98e8e3b35d4',
        '322af4908c7312b0cfbfe369f7a7b3cdb7d4494bc2823700cfd652188a3ea98d'
      ],
      [
        'af8addbf2b661c8a6c6328655eb96651252007d8c5ea31be4ad196de8ce2131f',
        '6749e67c029b85f52a034eafd096836b2520818680e26ac8f3dfbcdb71749700'
      ],
      [
        'e3ae1974566ca06cc516d47e0fb165a674a3dabcfca15e722f0e3450f45889',
        '2aeabe7e4531510116217f07bf4d07300de97e4874f81f533420a72eeb0bd6a4'
      ],
      [
        '591ee355313d99721cf6993ffed1e3e301993ff3ed258802075ea8ced397e246',
        'b0ea558a113c30bea60fc4775460c7901ff0b053d25ca2bdeee98f1a4be5d196'
      ],
      [
        '11396d55fda54c49f19aa97318d8da61fa8584e47b084945077cf03255b52984',
        '998c74a8cd45ac01289d5833a7beb4744ff536b01b257be4c5767bea93ea57a4'
      ],
      [
        '3c5d2a1ba39c5a1790000738c9e0c40b8dcdfd5468754b6405540157e017aa7a',
        'b2284279995a34e2f9d4de7396fc18b80f9b8b9fdd270f6661f79ca4c81bd257'
      ],
      [
        'cc8704b8a60a0defa3a99a7299f2e9c3fbc395afb04ac078425ef8a1793cc030',
        'bdd46039feed17881d1e0862db347f8cf395b74fc4bcdc4e940b74e3ac1f1b13'
      ],
      [
        'c533e4f7ea8555aacd9777ac5cad29b97dd4defccc53ee7ea204119b2889b197',
        '6f0a256bc5efdf429a2fb6242f1a43a2d9b925bb4a4b3a26bb8e0f45eb596096'
      ],
      [
        'c14f8f2ccb27d6f109f6d08d03cc96a69ba8c34eec07bbcf566d48e33da6593',
        'c359d6923bb398f7fd4473e16fe1c28475b740dd098075e6c0e8649113dc3a38'
      ],
      [
        'a6cbc3046bc6a450bac24789fa17115a4c9739ed75f8f21ce441f72e0b90e6ef',
        '21ae7f4680e889bb130619e2c0f95a360ceb573c70603139862afd617fa9b9f'
      ],
      [
        '347d6d9a02c48927ebfb86c1359b1caf130a3c0267d11ce6344b39f99d43cc38',
        '60ea7f61a353524d1c987f6ecec92f086d565ab687870cb12689ff1e31c74448'
      ],
      [
        'da6545d2181db8d983f7dcb375ef5866d47c67b1bf31c8cf855ef7437b72656a',
        '49b96715ab6878a79e78f07ce5680c5d6673051b4935bd897fea824b77dc208a'
      ],
      [
        'c40747cc9d012cb1a13b8148309c6de7ec25d6945d657146b9d5994b8feb1111',
        '5ca560753be2a12fc6de6caf2cb489565db936156b9514e1bb5e83037e0fa2d4'
      ],
      [
        '4e42c8ec82c99798ccf3a610be870e78338c7f713348bd34c8203ef4037f3502',
        '7571d74ee5e0fb92a7a8b33a07783341a5492144cc54bcc40a94473693606437'
      ],
      [
        '3775ab7089bc6af823aba2e1af70b236d251cadb0c86743287522a1b3b0dedea',
        'be52d107bcfa09d8bcb9736a828cfa7fac8db17bf7a76a2c42ad961409018cf7'
      ],
      [
        'cee31cbf7e34ec379d94fb814d3d775ad954595d1314ba8846959e3e82f74e26',
        '8fd64a14c06b589c26b947ae2bcf6bfa0149ef0be14ed4d80f448a01c43b1c6d'
      ],
      [
        'b4f9eaea09b6917619f6ea6a4eb5464efddb58fd45b1ebefcdc1a01d08b47986',
        '39e5c9925b5a54b07433a4f18c61726f8bb131c012ca542eb24a8ac07200682a'
      ],
      [
        'd4263dfc3d2df923a0179a48966d30ce84e2515afc3dccc1b77907792ebcc60e',
        '62dfaf07a0f78feb30e30d6295853ce189e127760ad6cf7fae164e122a208d54'
      ],
      [
        '48457524820fa65a4f8d35eb6930857c0032acc0a4a2de422233eeda897612c4',
        '25a748ab367979d98733c38a1fa1c2e7dc6cc07db2d60a9ae7a76aaa49bd0f77'
      ],
      [
        'dfeeef1881101f2cb11644f3a2afdfc2045e19919152923f367a1767c11cceda',
        'ecfb7056cf1de042f9420bab396793c0c390bde74b4bbdff16a83ae09a9a7517'
      ],
      [
        '6d7ef6b17543f8373c573f44e1f389835d89bcbc6062ced36c82df83b8fae859',
        'cd450ec335438986dfefa10c57fea9bcc521a0959b2d80bbf74b190dca712d10'
      ],
      [
        'e75605d59102a5a2684500d3b991f2e3f3c88b93225547035af25af66e04541f',
        'f5c54754a8f71ee540b9b48728473e314f729ac5308b06938360990e2bfad125'
      ],
      [
        'eb98660f4c4dfaa06a2be453d5020bc99a0c2e60abe388457dd43fefb1ed620c',
        '6cb9a8876d9cb8520609af3add26cd20a0a7cd8a9411131ce85f44100099223e'
      ],
      [
        '13e87b027d8514d35939f2e6892b19922154596941888336dc3563e3b8dba942',
        'fef5a3c68059a6dec5d624114bf1e91aac2b9da568d6abeb2570d55646b8adf1'
      ],
      [
        'ee163026e9fd6fe017c38f06a5be6fc125424b371ce2708e7bf4491691e5764a',
        '1acb250f255dd61c43d94ccc670d0f58f49ae3fa15b96623e5430da0ad6c62b2'
      ],
      [
        'b268f5ef9ad51e4d78de3a750c2dc89b1e626d43505867999932e5db33af3d80',
        '5f310d4b3c99b9ebb19f77d41c1dee018cf0d34fd4191614003e945a1216e423'
      ],
      [
        'ff07f3118a9df035e9fad85eb6c7bfe42b02f01ca99ceea3bf7ffdba93c4750d',
        '438136d603e858a3a5c440c38eccbaddc1d2942114e2eddd4740d098ced1f0d8'
      ],
      [
        '8d8b9855c7c052a34146fd20ffb658bea4b9f69e0d825ebec16e8c3ce2b526a1',
        'cdb559eedc2d79f926baf44fb84ea4d44bcf50fee51d7ceb30e2e7f463036758'
      ],
      [
        '52db0b5384dfbf05bfa9d472d7ae26dfe4b851ceca91b1eba54263180da32b63',
        'c3b997d050ee5d423ebaf66a6db9f57b3180c902875679de924b69d84a7b375'
      ],
      [
        'e62f9490d3d51da6395efd24e80919cc7d0f29c3f3fa48c6fff543becbd43352',
        '6d89ad7ba4876b0b22c2ca280c682862f342c8591f1daf5170e07bfd9ccafa7d'
      ],
      [
        '7f30ea2476b399b4957509c88f77d0191afa2ff5cb7b14fd6d8e7d65aaab1193',
        'ca5ef7d4b231c94c3b15389a5f6311e9daff7bb67b103e9880ef4bff637acaec'
      ],
      [
        '5098ff1e1d9f14fb46a210fada6c903fef0fb7b4a1dd1d9ac60a0361800b7a00',
        '9731141d81fc8f8084d37c6e7542006b3ee1b40d60dfe5362a5b132fd17ddc0'
      ],
      [
        '32b78c7de9ee512a72895be6b9cbefa6e2f3c4ccce445c96b9f2c81e2778ad58',
        'ee1849f513df71e32efc3896ee28260c73bb80547ae2275ba497237794c8753c'
      ],
      [
        'e2cb74fddc8e9fbcd076eef2a7c72b0ce37d50f08269dfc074b581550547a4f7',
        'd3aa2ed71c9dd2247a62df062736eb0baddea9e36122d2be8641abcb005cc4a4'
      ],
      [
        '8438447566d4d7bedadc299496ab357426009a35f235cb141be0d99cd10ae3a8',
        'c4e1020916980a4da5d01ac5e6ad330734ef0d7906631c4f2390426b2edd791f'
      ],
      [
        '4162d488b89402039b584c6fc6c308870587d9c46f660b878ab65c82c711d67e',
        '67163e903236289f776f22c25fb8a3afc1732f2b84b4e95dbda47ae5a0852649'
      ],
      [
        '3fad3fa84caf0f34f0f89bfd2dcf54fc175d767aec3e50684f3ba4a4bf5f683d',
        'cd1bc7cb6cc407bb2f0ca647c718a730cf71872e7d0d2a53fa20efcdfe61826'
      ],
      [
        '674f2600a3007a00568c1a7ce05d0816c1fb84bf1370798f1c69532faeb1a86b',
        '299d21f9413f33b3edf43b257004580b70db57da0b182259e09eecc69e0d38a5'
      ],
      [
        'd32f4da54ade74abb81b815ad1fb3b263d82d6c692714bcff87d29bd5ee9f08f',
        'f9429e738b8e53b968e99016c059707782e14f4535359d582fc416910b3eea87'
      ],
      [
        '30e4e670435385556e593657135845d36fbb6931f72b08cb1ed954f1e3ce3ff6',
        '462f9bce619898638499350113bbc9b10a878d35da70740dc695a559eb88db7b'
      ],
      [
        'be2062003c51cc3004682904330e4dee7f3dcd10b01e580bf1971b04d4cad297',
        '62188bc49d61e5428573d48a74e1c655b1c61090905682a0d5558ed72dccb9bc'
      ],
      [
        '93144423ace3451ed29e0fb9ac2af211cb6e84a601df5993c419859fff5df04a',
        '7c10dfb164c3425f5c71a3f9d7992038f1065224f72bb9d1d902a6d13037b47c'
      ],
      [
        'b015f8044f5fcbdcf21ca26d6c34fb8197829205c7b7d2a7cb66418c157b112c',
        'ab8c1e086d04e813744a655b2df8d5f83b3cdc6faa3088c1d3aea1454e3a1d5f'
      ],
      [
        'd5e9e1da649d97d89e4868117a465a3a4f8a18de57a140d36b3f2af341a21b52',
        '4cb04437f391ed73111a13cc1d4dd0db1693465c2240480d8955e8592f27447a'
      ],
      [
        'd3ae41047dd7ca065dbf8ed77b992439983005cd72e16d6f996a5316d36966bb',
        'bd1aeb21ad22ebb22a10f0303417c6d964f8cdd7df0aca614b10dc14d125ac46'
      ],
      [
        '463e2763d885f958fc66cdd22800f0a487197d0a82e377b49f80af87c897b065',
        'bfefacdb0e5d0fd7df3a311a94de062b26b80c61fbc97508b79992671ef7ca7f'
      ],
      [
        '7985fdfd127c0567c6f53ec1bb63ec3158e597c40bfe747c83cddfc910641917',
        '603c12daf3d9862ef2b25fe1de289aed24ed291e0ec6708703a5bd567f32ed03'
      ],
      [
        '74a1ad6b5f76e39db2dd249410eac7f99e74c59cb83d2d0ed5ff1543da7703e9',
        'cc6157ef18c9c63cd6193d83631bbea0093e0968942e8c33d5737fd790e0db08'
      ],
      [
        '30682a50703375f602d416664ba19b7fc9bab42c72747463a71d0896b22f6da3',
        '553e04f6b018b4fa6c8f39e7f311d3176290d0e0f19ca73f17714d9977a22ff8'
      ],
      [
        '9e2158f0d7c0d5f26c3791efefa79597654e7a2b2464f52b1ee6c1347769ef57',
        '712fcdd1b9053f09003a3481fa7762e9ffd7c8ef35a38509e2fbf2629008373'
      ],
      [
        '176e26989a43c9cfeba4029c202538c28172e566e3c4fce7322857f3be327d66',
        'ed8cc9d04b29eb877d270b4878dc43c19aefd31f4eee09ee7b47834c1fa4b1c3'
      ],
      [
        '75d46efea3771e6e68abb89a13ad747ecf1892393dfc4f1b7004788c50374da8',
        '9852390a99507679fd0b86fd2b39a868d7efc22151346e1a3ca4726586a6bed8'
      ],
      [
        '809a20c67d64900ffb698c4c825f6d5f2310fb0451c869345b7319f645605721',
        '9e994980d9917e22b76b061927fa04143d096ccc54963e6a5ebfa5f3f8e286c1'
      ],
      [
        '1b38903a43f7f114ed4500b4eac7083fdefece1cf29c63528d563446f972c180',
        '4036edc931a60ae889353f77fd53de4a2708b26b6f5da72ad3394119daf408f9'
      ]
    ]
  }
};


/***/ }),

/***/ "./node_modules/elliptic/lib/elliptic/utils.js":
/*!*****************************************************!*\
  !*** ./node_modules/elliptic/lib/elliptic/utils.js ***!
  \*****************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = exports;
var BN = __webpack_require__(/*! bn.js */ "./node_modules/elliptic/node_modules/bn.js/lib/bn.js");
var minAssert = __webpack_require__(/*! minimalistic-assert */ "./node_modules/minimalistic-assert/index.js");
var minUtils = __webpack_require__(/*! minimalistic-crypto-utils */ "./node_modules/minimalistic-crypto-utils/lib/utils.js");

utils.assert = minAssert;
utils.toArray = minUtils.toArray;
utils.zero2 = minUtils.zero2;
utils.toHex = minUtils.toHex;
utils.encode = minUtils.encode;

// Represent num in a w-NAF form
function getNAF(num, w, bits) {
  var naf = new Array(Math.max(num.bitLength(), bits) + 1);
  naf.fill(0);

  var ws = 1 << (w + 1);
  var k = num.clone();

  for (var i = 0; i < naf.length; i++) {
    var z;
    var mod = k.andln(ws - 1);
    if (k.isOdd()) {
      if (mod > (ws >> 1) - 1)
        z = (ws >> 1) - mod;
      else
        z = mod;
      k.isubn(z);
    } else {
      z = 0;
    }

    naf[i] = z;
    k.iushrn(1);
  }

  return naf;
}
utils.getNAF = getNAF;

// Represent k1, k2 in a Joint Sparse Form
function getJSF(k1, k2) {
  var jsf = [
    [],
    []
  ];

  k1 = k1.clone();
  k2 = k2.clone();
  var d1 = 0;
  var d2 = 0;
  while (k1.cmpn(-d1) > 0 || k2.cmpn(-d2) > 0) {

    // First phase
    var m14 = (k1.andln(3) + d1) & 3;
    var m24 = (k2.andln(3) + d2) & 3;
    if (m14 === 3)
      m14 = -1;
    if (m24 === 3)
      m24 = -1;
    var u1;
    if ((m14 & 1) === 0) {
      u1 = 0;
    } else {
      var m8 = (k1.andln(7) + d1) & 7;
      if ((m8 === 3 || m8 === 5) && m24 === 2)
        u1 = -m14;
      else
        u1 = m14;
    }
    jsf[0].push(u1);

    var u2;
    if ((m24 & 1) === 0) {
      u2 = 0;
    } else {
      var m8 = (k2.andln(7) + d2) & 7;
      if ((m8 === 3 || m8 === 5) && m14 === 2)
        u2 = -m24;
      else
        u2 = m24;
    }
    jsf[1].push(u2);

    // Second phase
    if (2 * d1 === u1 + 1)
      d1 = 1 - d1;
    if (2 * d2 === u2 + 1)
      d2 = 1 - d2;
    k1.iushrn(1);
    k2.iushrn(1);
  }

  return jsf;
}
utils.getJSF = getJSF;

function cachedProperty(obj, name, computer) {
  var key = '_' + name;
  obj.prototype[name] = function cachedProperty() {
    return this[key] !== undefined ? this[key] :
           this[key] = computer.call(this);
  };
}
utils.cachedProperty = cachedProperty;

function parseBytes(bytes) {
  return typeof bytes === 'string' ? utils.toArray(bytes, 'hex') :
                                     bytes;
}
utils.parseBytes = parseBytes;

function intFromLE(bytes) {
  return new BN(bytes, 'hex', 'le');
}
utils.intFromLE = intFromLE;



/***/ }),

/***/ "./node_modules/elliptic/node_modules/bn.js/lib/bn.js":
/*!************************************************************!*\
  !*** ./node_modules/elliptic/node_modules/bn.js/lib/bn.js ***!
  \************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {(function (module, exports) {
  'use strict';

  // Utils
  function assert (val, msg) {
    if (!val) throw new Error(msg || 'Assertion failed');
  }

  // Could use `inherits` module, but don't want to move from single file
  // architecture yet.
  function inherits (ctor, superCtor) {
    ctor.super_ = superCtor;
    var TempCtor = function () {};
    TempCtor.prototype = superCtor.prototype;
    ctor.prototype = new TempCtor();
    ctor.prototype.constructor = ctor;
  }

  // BN

  function BN (number, base, endian) {
    if (BN.isBN(number)) {
      return number;
    }

    this.negative = 0;
    this.words = null;
    this.length = 0;

    // Reduction context
    this.red = null;

    if (number !== null) {
      if (base === 'le' || base === 'be') {
        endian = base;
        base = 10;
      }

      this._init(number || 0, base || 10, endian || 'be');
    }
  }
  if (typeof module === 'object') {
    module.exports = BN;
  } else {
    exports.BN = BN;
  }

  BN.BN = BN;
  BN.wordSize = 26;

  var Buffer;
  try {
    Buffer = __webpack_require__(/*! buffer */ 10).Buffer;
  } catch (e) {
  }

  BN.isBN = function isBN (num) {
    if (num instanceof BN) {
      return true;
    }

    return num !== null && typeof num === 'object' &&
      num.constructor.wordSize === BN.wordSize && Array.isArray(num.words);
  };

  BN.max = function max (left, right) {
    if (left.cmp(right) > 0) return left;
    return right;
  };

  BN.min = function min (left, right) {
    if (left.cmp(right) < 0) return left;
    return right;
  };

  BN.prototype._init = function init (number, base, endian) {
    if (typeof number === 'number') {
      return this._initNumber(number, base, endian);
    }

    if (typeof number === 'object') {
      return this._initArray(number, base, endian);
    }

    if (base === 'hex') {
      base = 16;
    }
    assert(base === (base | 0) && base >= 2 && base <= 36);

    number = number.toString().replace(/\s+/g, '');
    var start = 0;
    if (number[0] === '-') {
      start++;
    }

    if (base === 16) {
      this._parseHex(number, start);
    } else {
      this._parseBase(number, base, start);
    }

    if (number[0] === '-') {
      this.negative = 1;
    }

    this.strip();

    if (endian !== 'le') return;

    this._initArray(this.toArray(), base, endian);
  };

  BN.prototype._initNumber = function _initNumber (number, base, endian) {
    if (number < 0) {
      this.negative = 1;
      number = -number;
    }
    if (number < 0x4000000) {
      this.words = [ number & 0x3ffffff ];
      this.length = 1;
    } else if (number < 0x10000000000000) {
      this.words = [
        number & 0x3ffffff,
        (number / 0x4000000) & 0x3ffffff
      ];
      this.length = 2;
    } else {
      assert(number < 0x20000000000000); // 2 ^ 53 (unsafe)
      this.words = [
        number & 0x3ffffff,
        (number / 0x4000000) & 0x3ffffff,
        1
      ];
      this.length = 3;
    }

    if (endian !== 'le') return;

    // Reverse the bytes
    this._initArray(this.toArray(), base, endian);
  };

  BN.prototype._initArray = function _initArray (number, base, endian) {
    // Perhaps a Uint8Array
    assert(typeof number.length === 'number');
    if (number.length <= 0) {
      this.words = [ 0 ];
      this.length = 1;
      return this;
    }

    this.length = Math.ceil(number.length / 3);
    this.words = new Array(this.length);
    for (var i = 0; i < this.length; i++) {
      this.words[i] = 0;
    }

    var j, w;
    var off = 0;
    if (endian === 'be') {
      for (i = number.length - 1, j = 0; i >= 0; i -= 3) {
        w = number[i] | (number[i - 1] << 8) | (number[i - 2] << 16);
        this.words[j] |= (w << off) & 0x3ffffff;
        this.words[j + 1] = (w >>> (26 - off)) & 0x3ffffff;
        off += 24;
        if (off >= 26) {
          off -= 26;
          j++;
        }
      }
    } else if (endian === 'le') {
      for (i = 0, j = 0; i < number.length; i += 3) {
        w = number[i] | (number[i + 1] << 8) | (number[i + 2] << 16);
        this.words[j] |= (w << off) & 0x3ffffff;
        this.words[j + 1] = (w >>> (26 - off)) & 0x3ffffff;
        off += 24;
        if (off >= 26) {
          off -= 26;
          j++;
        }
      }
    }
    return this.strip();
  };

  function parseHex (str, start, end) {
    var r = 0;
    var len = Math.min(str.length, end);
    for (var i = start; i < len; i++) {
      var c = str.charCodeAt(i) - 48;

      r <<= 4;

      // 'a' - 'f'
      if (c >= 49 && c <= 54) {
        r |= c - 49 + 0xa;

      // 'A' - 'F'
      } else if (c >= 17 && c <= 22) {
        r |= c - 17 + 0xa;

      // '0' - '9'
      } else {
        r |= c & 0xf;
      }
    }
    return r;
  }

  BN.prototype._parseHex = function _parseHex (number, start) {
    // Create possibly bigger array to ensure that it fits the number
    this.length = Math.ceil((number.length - start) / 6);
    this.words = new Array(this.length);
    for (var i = 0; i < this.length; i++) {
      this.words[i] = 0;
    }

    var j, w;
    // Scan 24-bit chunks and add them to the number
    var off = 0;
    for (i = number.length - 6, j = 0; i >= start; i -= 6) {
      w = parseHex(number, i, i + 6);
      this.words[j] |= (w << off) & 0x3ffffff;
      // NOTE: `0x3fffff` is intentional here, 26bits max shift + 24bit hex limb
      this.words[j + 1] |= w >>> (26 - off) & 0x3fffff;
      off += 24;
      if (off >= 26) {
        off -= 26;
        j++;
      }
    }
    if (i + 6 !== start) {
      w = parseHex(number, start, i + 6);
      this.words[j] |= (w << off) & 0x3ffffff;
      this.words[j + 1] |= w >>> (26 - off) & 0x3fffff;
    }
    this.strip();
  };

  function parseBase (str, start, end, mul) {
    var r = 0;
    var len = Math.min(str.length, end);
    for (var i = start; i < len; i++) {
      var c = str.charCodeAt(i) - 48;

      r *= mul;

      // 'a'
      if (c >= 49) {
        r += c - 49 + 0xa;

      // 'A'
      } else if (c >= 17) {
        r += c - 17 + 0xa;

      // '0' - '9'
      } else {
        r += c;
      }
    }
    return r;
  }

  BN.prototype._parseBase = function _parseBase (number, base, start) {
    // Initialize as zero
    this.words = [ 0 ];
    this.length = 1;

    // Find length of limb in base
    for (var limbLen = 0, limbPow = 1; limbPow <= 0x3ffffff; limbPow *= base) {
      limbLen++;
    }
    limbLen--;
    limbPow = (limbPow / base) | 0;

    var total = number.length - start;
    var mod = total % limbLen;
    var end = Math.min(total, total - mod) + start;

    var word = 0;
    for (var i = start; i < end; i += limbLen) {
      word = parseBase(number, i, i + limbLen, base);

      this.imuln(limbPow);
      if (this.words[0] + word < 0x4000000) {
        this.words[0] += word;
      } else {
        this._iaddn(word);
      }
    }

    if (mod !== 0) {
      var pow = 1;
      word = parseBase(number, i, number.length, base);

      for (i = 0; i < mod; i++) {
        pow *= base;
      }

      this.imuln(pow);
      if (this.words[0] + word < 0x4000000) {
        this.words[0] += word;
      } else {
        this._iaddn(word);
      }
    }
  };

  BN.prototype.copy = function copy (dest) {
    dest.words = new Array(this.length);
    for (var i = 0; i < this.length; i++) {
      dest.words[i] = this.words[i];
    }
    dest.length = this.length;
    dest.negative = this.negative;
    dest.red = this.red;
  };

  BN.prototype.clone = function clone () {
    var r = new BN(null);
    this.copy(r);
    return r;
  };

  BN.prototype._expand = function _expand (size) {
    while (this.length < size) {
      this.words[this.length++] = 0;
    }
    return this;
  };

  // Remove leading `0` from `this`
  BN.prototype.strip = function strip () {
    while (this.length > 1 && this.words[this.length - 1] === 0) {
      this.length--;
    }
    return this._normSign();
  };

  BN.prototype._normSign = function _normSign () {
    // -0 = 0
    if (this.length === 1 && this.words[0] === 0) {
      this.negative = 0;
    }
    return this;
  };

  BN.prototype.inspect = function inspect () {
    return (this.red ? '<BN-R: ' : '<BN: ') + this.toString(16) + '>';
  };

  /*

  var zeros = [];
  var groupSizes = [];
  var groupBases = [];

  var s = '';
  var i = -1;
  while (++i < BN.wordSize) {
    zeros[i] = s;
    s += '0';
  }
  groupSizes[0] = 0;
  groupSizes[1] = 0;
  groupBases[0] = 0;
  groupBases[1] = 0;
  var base = 2 - 1;
  while (++base < 36 + 1) {
    var groupSize = 0;
    var groupBase = 1;
    while (groupBase < (1 << BN.wordSize) / base) {
      groupBase *= base;
      groupSize += 1;
    }
    groupSizes[base] = groupSize;
    groupBases[base] = groupBase;
  }

  */

  var zeros = [
    '',
    '0',
    '00',
    '000',
    '0000',
    '00000',
    '000000',
    '0000000',
    '00000000',
    '000000000',
    '0000000000',
    '00000000000',
    '000000000000',
    '0000000000000',
    '00000000000000',
    '000000000000000',
    '0000000000000000',
    '00000000000000000',
    '000000000000000000',
    '0000000000000000000',
    '00000000000000000000',
    '000000000000000000000',
    '0000000000000000000000',
    '00000000000000000000000',
    '000000000000000000000000',
    '0000000000000000000000000'
  ];

  var groupSizes = [
    0, 0,
    25, 16, 12, 11, 10, 9, 8,
    8, 7, 7, 7, 7, 6, 6,
    6, 6, 6, 6, 6, 5, 5,
    5, 5, 5, 5, 5, 5, 5,
    5, 5, 5, 5, 5, 5, 5
  ];

  var groupBases = [
    0, 0,
    33554432, 43046721, 16777216, 48828125, 60466176, 40353607, 16777216,
    43046721, 10000000, 19487171, 35831808, 62748517, 7529536, 11390625,
    16777216, 24137569, 34012224, 47045881, 64000000, 4084101, 5153632,
    6436343, 7962624, 9765625, 11881376, 14348907, 17210368, 20511149,
    24300000, 28629151, 33554432, 39135393, 45435424, 52521875, 60466176
  ];

  BN.prototype.toString = function toString (base, padding) {
    base = base || 10;
    padding = padding | 0 || 1;

    var out;
    if (base === 16 || base === 'hex') {
      out = '';
      var off = 0;
      var carry = 0;
      for (var i = 0; i < this.length; i++) {
        var w = this.words[i];
        var word = (((w << off) | carry) & 0xffffff).toString(16);
        carry = (w >>> (24 - off)) & 0xffffff;
        if (carry !== 0 || i !== this.length - 1) {
          out = zeros[6 - word.length] + word + out;
        } else {
          out = word + out;
        }
        off += 2;
        if (off >= 26) {
          off -= 26;
          i--;
        }
      }
      if (carry !== 0) {
        out = carry.toString(16) + out;
      }
      while (out.length % padding !== 0) {
        out = '0' + out;
      }
      if (this.negative !== 0) {
        out = '-' + out;
      }
      return out;
    }

    if (base === (base | 0) && base >= 2 && base <= 36) {
      // var groupSize = Math.floor(BN.wordSize * Math.LN2 / Math.log(base));
      var groupSize = groupSizes[base];
      // var groupBase = Math.pow(base, groupSize);
      var groupBase = groupBases[base];
      out = '';
      var c = this.clone();
      c.negative = 0;
      while (!c.isZero()) {
        var r = c.modn(groupBase).toString(base);
        c = c.idivn(groupBase);

        if (!c.isZero()) {
          out = zeros[groupSize - r.length] + r + out;
        } else {
          out = r + out;
        }
      }
      if (this.isZero()) {
        out = '0' + out;
      }
      while (out.length % padding !== 0) {
        out = '0' + out;
      }
      if (this.negative !== 0) {
        out = '-' + out;
      }
      return out;
    }

    assert(false, 'Base should be between 2 and 36');
  };

  BN.prototype.toNumber = function toNumber () {
    var ret = this.words[0];
    if (this.length === 2) {
      ret += this.words[1] * 0x4000000;
    } else if (this.length === 3 && this.words[2] === 0x01) {
      // NOTE: at this stage it is known that the top bit is set
      ret += 0x10000000000000 + (this.words[1] * 0x4000000);
    } else if (this.length > 2) {
      assert(false, 'Number can only safely store up to 53 bits');
    }
    return (this.negative !== 0) ? -ret : ret;
  };

  BN.prototype.toJSON = function toJSON () {
    return this.toString(16);
  };

  BN.prototype.toBuffer = function toBuffer (endian, length) {
    assert(typeof Buffer !== 'undefined');
    return this.toArrayLike(Buffer, endian, length);
  };

  BN.prototype.toArray = function toArray (endian, length) {
    return this.toArrayLike(Array, endian, length);
  };

  BN.prototype.toArrayLike = function toArrayLike (ArrayType, endian, length) {
    var byteLength = this.byteLength();
    var reqLength = length || Math.max(1, byteLength);
    assert(byteLength <= reqLength, 'byte array longer than desired length');
    assert(reqLength > 0, 'Requested array length <= 0');

    this.strip();
    var littleEndian = endian === 'le';
    var res = new ArrayType(reqLength);

    var b, i;
    var q = this.clone();
    if (!littleEndian) {
      // Assume big-endian
      for (i = 0; i < reqLength - byteLength; i++) {
        res[i] = 0;
      }

      for (i = 0; !q.isZero(); i++) {
        b = q.andln(0xff);
        q.iushrn(8);

        res[reqLength - i - 1] = b;
      }
    } else {
      for (i = 0; !q.isZero(); i++) {
        b = q.andln(0xff);
        q.iushrn(8);

        res[i] = b;
      }

      for (; i < reqLength; i++) {
        res[i] = 0;
      }
    }

    return res;
  };

  if (Math.clz32) {
    BN.prototype._countBits = function _countBits (w) {
      return 32 - Math.clz32(w);
    };
  } else {
    BN.prototype._countBits = function _countBits (w) {
      var t = w;
      var r = 0;
      if (t >= 0x1000) {
        r += 13;
        t >>>= 13;
      }
      if (t >= 0x40) {
        r += 7;
        t >>>= 7;
      }
      if (t >= 0x8) {
        r += 4;
        t >>>= 4;
      }
      if (t >= 0x02) {
        r += 2;
        t >>>= 2;
      }
      return r + t;
    };
  }

  BN.prototype._zeroBits = function _zeroBits (w) {
    // Short-cut
    if (w === 0) return 26;

    var t = w;
    var r = 0;
    if ((t & 0x1fff) === 0) {
      r += 13;
      t >>>= 13;
    }
    if ((t & 0x7f) === 0) {
      r += 7;
      t >>>= 7;
    }
    if ((t & 0xf) === 0) {
      r += 4;
      t >>>= 4;
    }
    if ((t & 0x3) === 0) {
      r += 2;
      t >>>= 2;
    }
    if ((t & 0x1) === 0) {
      r++;
    }
    return r;
  };

  // Return number of used bits in a BN
  BN.prototype.bitLength = function bitLength () {
    var w = this.words[this.length - 1];
    var hi = this._countBits(w);
    return (this.length - 1) * 26 + hi;
  };

  function toBitArray (num) {
    var w = new Array(num.bitLength());

    for (var bit = 0; bit < w.length; bit++) {
      var off = (bit / 26) | 0;
      var wbit = bit % 26;

      w[bit] = (num.words[off] & (1 << wbit)) >>> wbit;
    }

    return w;
  }

  // Number of trailing zero bits
  BN.prototype.zeroBits = function zeroBits () {
    if (this.isZero()) return 0;

    var r = 0;
    for (var i = 0; i < this.length; i++) {
      var b = this._zeroBits(this.words[i]);
      r += b;
      if (b !== 26) break;
    }
    return r;
  };

  BN.prototype.byteLength = function byteLength () {
    return Math.ceil(this.bitLength() / 8);
  };

  BN.prototype.toTwos = function toTwos (width) {
    if (this.negative !== 0) {
      return this.abs().inotn(width).iaddn(1);
    }
    return this.clone();
  };

  BN.prototype.fromTwos = function fromTwos (width) {
    if (this.testn(width - 1)) {
      return this.notn(width).iaddn(1).ineg();
    }
    return this.clone();
  };

  BN.prototype.isNeg = function isNeg () {
    return this.negative !== 0;
  };

  // Return negative clone of `this`
  BN.prototype.neg = function neg () {
    return this.clone().ineg();
  };

  BN.prototype.ineg = function ineg () {
    if (!this.isZero()) {
      this.negative ^= 1;
    }

    return this;
  };

  // Or `num` with `this` in-place
  BN.prototype.iuor = function iuor (num) {
    while (this.length < num.length) {
      this.words[this.length++] = 0;
    }

    for (var i = 0; i < num.length; i++) {
      this.words[i] = this.words[i] | num.words[i];
    }

    return this.strip();
  };

  BN.prototype.ior = function ior (num) {
    assert((this.negative | num.negative) === 0);
    return this.iuor(num);
  };

  // Or `num` with `this`
  BN.prototype.or = function or (num) {
    if (this.length > num.length) return this.clone().ior(num);
    return num.clone().ior(this);
  };

  BN.prototype.uor = function uor (num) {
    if (this.length > num.length) return this.clone().iuor(num);
    return num.clone().iuor(this);
  };

  // And `num` with `this` in-place
  BN.prototype.iuand = function iuand (num) {
    // b = min-length(num, this)
    var b;
    if (this.length > num.length) {
      b = num;
    } else {
      b = this;
    }

    for (var i = 0; i < b.length; i++) {
      this.words[i] = this.words[i] & num.words[i];
    }

    this.length = b.length;

    return this.strip();
  };

  BN.prototype.iand = function iand (num) {
    assert((this.negative | num.negative) === 0);
    return this.iuand(num);
  };

  // And `num` with `this`
  BN.prototype.and = function and (num) {
    if (this.length > num.length) return this.clone().iand(num);
    return num.clone().iand(this);
  };

  BN.prototype.uand = function uand (num) {
    if (this.length > num.length) return this.clone().iuand(num);
    return num.clone().iuand(this);
  };

  // Xor `num` with `this` in-place
  BN.prototype.iuxor = function iuxor (num) {
    // a.length > b.length
    var a;
    var b;
    if (this.length > num.length) {
      a = this;
      b = num;
    } else {
      a = num;
      b = this;
    }

    for (var i = 0; i < b.length; i++) {
      this.words[i] = a.words[i] ^ b.words[i];
    }

    if (this !== a) {
      for (; i < a.length; i++) {
        this.words[i] = a.words[i];
      }
    }

    this.length = a.length;

    return this.strip();
  };

  BN.prototype.ixor = function ixor (num) {
    assert((this.negative | num.negative) === 0);
    return this.iuxor(num);
  };

  // Xor `num` with `this`
  BN.prototype.xor = function xor (num) {
    if (this.length > num.length) return this.clone().ixor(num);
    return num.clone().ixor(this);
  };

  BN.prototype.uxor = function uxor (num) {
    if (this.length > num.length) return this.clone().iuxor(num);
    return num.clone().iuxor(this);
  };

  // Not ``this`` with ``width`` bitwidth
  BN.prototype.inotn = function inotn (width) {
    assert(typeof width === 'number' && width >= 0);

    var bytesNeeded = Math.ceil(width / 26) | 0;
    var bitsLeft = width % 26;

    // Extend the buffer with leading zeroes
    this._expand(bytesNeeded);

    if (bitsLeft > 0) {
      bytesNeeded--;
    }

    // Handle complete words
    for (var i = 0; i < bytesNeeded; i++) {
      this.words[i] = ~this.words[i] & 0x3ffffff;
    }

    // Handle the residue
    if (bitsLeft > 0) {
      this.words[i] = ~this.words[i] & (0x3ffffff >> (26 - bitsLeft));
    }

    // And remove leading zeroes
    return this.strip();
  };

  BN.prototype.notn = function notn (width) {
    return this.clone().inotn(width);
  };

  // Set `bit` of `this`
  BN.prototype.setn = function setn (bit, val) {
    assert(typeof bit === 'number' && bit >= 0);

    var off = (bit / 26) | 0;
    var wbit = bit % 26;

    this._expand(off + 1);

    if (val) {
      this.words[off] = this.words[off] | (1 << wbit);
    } else {
      this.words[off] = this.words[off] & ~(1 << wbit);
    }

    return this.strip();
  };

  // Add `num` to `this` in-place
  BN.prototype.iadd = function iadd (num) {
    var r;

    // negative + positive
    if (this.negative !== 0 && num.negative === 0) {
      this.negative = 0;
      r = this.isub(num);
      this.negative ^= 1;
      return this._normSign();

    // positive + negative
    } else if (this.negative === 0 && num.negative !== 0) {
      num.negative = 0;
      r = this.isub(num);
      num.negative = 1;
      return r._normSign();
    }

    // a.length > b.length
    var a, b;
    if (this.length > num.length) {
      a = this;
      b = num;
    } else {
      a = num;
      b = this;
    }

    var carry = 0;
    for (var i = 0; i < b.length; i++) {
      r = (a.words[i] | 0) + (b.words[i] | 0) + carry;
      this.words[i] = r & 0x3ffffff;
      carry = r >>> 26;
    }
    for (; carry !== 0 && i < a.length; i++) {
      r = (a.words[i] | 0) + carry;
      this.words[i] = r & 0x3ffffff;
      carry = r >>> 26;
    }

    this.length = a.length;
    if (carry !== 0) {
      this.words[this.length] = carry;
      this.length++;
    // Copy the rest of the words
    } else if (a !== this) {
      for (; i < a.length; i++) {
        this.words[i] = a.words[i];
      }
    }

    return this;
  };

  // Add `num` to `this`
  BN.prototype.add = function add (num) {
    var res;
    if (num.negative !== 0 && this.negative === 0) {
      num.negative = 0;
      res = this.sub(num);
      num.negative ^= 1;
      return res;
    } else if (num.negative === 0 && this.negative !== 0) {
      this.negative = 0;
      res = num.sub(this);
      this.negative = 1;
      return res;
    }

    if (this.length > num.length) return this.clone().iadd(num);

    return num.clone().iadd(this);
  };

  // Subtract `num` from `this` in-place
  BN.prototype.isub = function isub (num) {
    // this - (-num) = this + num
    if (num.negative !== 0) {
      num.negative = 0;
      var r = this.iadd(num);
      num.negative = 1;
      return r._normSign();

    // -this - num = -(this + num)
    } else if (this.negative !== 0) {
      this.negative = 0;
      this.iadd(num);
      this.negative = 1;
      return this._normSign();
    }

    // At this point both numbers are positive
    var cmp = this.cmp(num);

    // Optimization - zeroify
    if (cmp === 0) {
      this.negative = 0;
      this.length = 1;
      this.words[0] = 0;
      return this;
    }

    // a > b
    var a, b;
    if (cmp > 0) {
      a = this;
      b = num;
    } else {
      a = num;
      b = this;
    }

    var carry = 0;
    for (var i = 0; i < b.length; i++) {
      r = (a.words[i] | 0) - (b.words[i] | 0) + carry;
      carry = r >> 26;
      this.words[i] = r & 0x3ffffff;
    }
    for (; carry !== 0 && i < a.length; i++) {
      r = (a.words[i] | 0) + carry;
      carry = r >> 26;
      this.words[i] = r & 0x3ffffff;
    }

    // Copy rest of the words
    if (carry === 0 && i < a.length && a !== this) {
      for (; i < a.length; i++) {
        this.words[i] = a.words[i];
      }
    }

    this.length = Math.max(this.length, i);

    if (a !== this) {
      this.negative = 1;
    }

    return this.strip();
  };

  // Subtract `num` from `this`
  BN.prototype.sub = function sub (num) {
    return this.clone().isub(num);
  };

  function smallMulTo (self, num, out) {
    out.negative = num.negative ^ self.negative;
    var len = (self.length + num.length) | 0;
    out.length = len;
    len = (len - 1) | 0;

    // Peel one iteration (compiler can't do it, because of code complexity)
    var a = self.words[0] | 0;
    var b = num.words[0] | 0;
    var r = a * b;

    var lo = r & 0x3ffffff;
    var carry = (r / 0x4000000) | 0;
    out.words[0] = lo;

    for (var k = 1; k < len; k++) {
      // Sum all words with the same `i + j = k` and accumulate `ncarry`,
      // note that ncarry could be >= 0x3ffffff
      var ncarry = carry >>> 26;
      var rword = carry & 0x3ffffff;
      var maxJ = Math.min(k, num.length - 1);
      for (var j = Math.max(0, k - self.length + 1); j <= maxJ; j++) {
        var i = (k - j) | 0;
        a = self.words[i] | 0;
        b = num.words[j] | 0;
        r = a * b + rword;
        ncarry += (r / 0x4000000) | 0;
        rword = r & 0x3ffffff;
      }
      out.words[k] = rword | 0;
      carry = ncarry | 0;
    }
    if (carry !== 0) {
      out.words[k] = carry | 0;
    } else {
      out.length--;
    }

    return out.strip();
  }

  // TODO(indutny): it may be reasonable to omit it for users who don't need
  // to work with 256-bit numbers, otherwise it gives 20% improvement for 256-bit
  // multiplication (like elliptic secp256k1).
  var comb10MulTo = function comb10MulTo (self, num, out) {
    var a = self.words;
    var b = num.words;
    var o = out.words;
    var c = 0;
    var lo;
    var mid;
    var hi;
    var a0 = a[0] | 0;
    var al0 = a0 & 0x1fff;
    var ah0 = a0 >>> 13;
    var a1 = a[1] | 0;
    var al1 = a1 & 0x1fff;
    var ah1 = a1 >>> 13;
    var a2 = a[2] | 0;
    var al2 = a2 & 0x1fff;
    var ah2 = a2 >>> 13;
    var a3 = a[3] | 0;
    var al3 = a3 & 0x1fff;
    var ah3 = a3 >>> 13;
    var a4 = a[4] | 0;
    var al4 = a4 & 0x1fff;
    var ah4 = a4 >>> 13;
    var a5 = a[5] | 0;
    var al5 = a5 & 0x1fff;
    var ah5 = a5 >>> 13;
    var a6 = a[6] | 0;
    var al6 = a6 & 0x1fff;
    var ah6 = a6 >>> 13;
    var a7 = a[7] | 0;
    var al7 = a7 & 0x1fff;
    var ah7 = a7 >>> 13;
    var a8 = a[8] | 0;
    var al8 = a8 & 0x1fff;
    var ah8 = a8 >>> 13;
    var a9 = a[9] | 0;
    var al9 = a9 & 0x1fff;
    var ah9 = a9 >>> 13;
    var b0 = b[0] | 0;
    var bl0 = b0 & 0x1fff;
    var bh0 = b0 >>> 13;
    var b1 = b[1] | 0;
    var bl1 = b1 & 0x1fff;
    var bh1 = b1 >>> 13;
    var b2 = b[2] | 0;
    var bl2 = b2 & 0x1fff;
    var bh2 = b2 >>> 13;
    var b3 = b[3] | 0;
    var bl3 = b3 & 0x1fff;
    var bh3 = b3 >>> 13;
    var b4 = b[4] | 0;
    var bl4 = b4 & 0x1fff;
    var bh4 = b4 >>> 13;
    var b5 = b[5] | 0;
    var bl5 = b5 & 0x1fff;
    var bh5 = b5 >>> 13;
    var b6 = b[6] | 0;
    var bl6 = b6 & 0x1fff;
    var bh6 = b6 >>> 13;
    var b7 = b[7] | 0;
    var bl7 = b7 & 0x1fff;
    var bh7 = b7 >>> 13;
    var b8 = b[8] | 0;
    var bl8 = b8 & 0x1fff;
    var bh8 = b8 >>> 13;
    var b9 = b[9] | 0;
    var bl9 = b9 & 0x1fff;
    var bh9 = b9 >>> 13;

    out.negative = self.negative ^ num.negative;
    out.length = 19;
    /* k = 0 */
    lo = Math.imul(al0, bl0);
    mid = Math.imul(al0, bh0);
    mid = (mid + Math.imul(ah0, bl0)) | 0;
    hi = Math.imul(ah0, bh0);
    var w0 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w0 >>> 26)) | 0;
    w0 &= 0x3ffffff;
    /* k = 1 */
    lo = Math.imul(al1, bl0);
    mid = Math.imul(al1, bh0);
    mid = (mid + Math.imul(ah1, bl0)) | 0;
    hi = Math.imul(ah1, bh0);
    lo = (lo + Math.imul(al0, bl1)) | 0;
    mid = (mid + Math.imul(al0, bh1)) | 0;
    mid = (mid + Math.imul(ah0, bl1)) | 0;
    hi = (hi + Math.imul(ah0, bh1)) | 0;
    var w1 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w1 >>> 26)) | 0;
    w1 &= 0x3ffffff;
    /* k = 2 */
    lo = Math.imul(al2, bl0);
    mid = Math.imul(al2, bh0);
    mid = (mid + Math.imul(ah2, bl0)) | 0;
    hi = Math.imul(ah2, bh0);
    lo = (lo + Math.imul(al1, bl1)) | 0;
    mid = (mid + Math.imul(al1, bh1)) | 0;
    mid = (mid + Math.imul(ah1, bl1)) | 0;
    hi = (hi + Math.imul(ah1, bh1)) | 0;
    lo = (lo + Math.imul(al0, bl2)) | 0;
    mid = (mid + Math.imul(al0, bh2)) | 0;
    mid = (mid + Math.imul(ah0, bl2)) | 0;
    hi = (hi + Math.imul(ah0, bh2)) | 0;
    var w2 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w2 >>> 26)) | 0;
    w2 &= 0x3ffffff;
    /* k = 3 */
    lo = Math.imul(al3, bl0);
    mid = Math.imul(al3, bh0);
    mid = (mid + Math.imul(ah3, bl0)) | 0;
    hi = Math.imul(ah3, bh0);
    lo = (lo + Math.imul(al2, bl1)) | 0;
    mid = (mid + Math.imul(al2, bh1)) | 0;
    mid = (mid + Math.imul(ah2, bl1)) | 0;
    hi = (hi + Math.imul(ah2, bh1)) | 0;
    lo = (lo + Math.imul(al1, bl2)) | 0;
    mid = (mid + Math.imul(al1, bh2)) | 0;
    mid = (mid + Math.imul(ah1, bl2)) | 0;
    hi = (hi + Math.imul(ah1, bh2)) | 0;
    lo = (lo + Math.imul(al0, bl3)) | 0;
    mid = (mid + Math.imul(al0, bh3)) | 0;
    mid = (mid + Math.imul(ah0, bl3)) | 0;
    hi = (hi + Math.imul(ah0, bh3)) | 0;
    var w3 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w3 >>> 26)) | 0;
    w3 &= 0x3ffffff;
    /* k = 4 */
    lo = Math.imul(al4, bl0);
    mid = Math.imul(al4, bh0);
    mid = (mid + Math.imul(ah4, bl0)) | 0;
    hi = Math.imul(ah4, bh0);
    lo = (lo + Math.imul(al3, bl1)) | 0;
    mid = (mid + Math.imul(al3, bh1)) | 0;
    mid = (mid + Math.imul(ah3, bl1)) | 0;
    hi = (hi + Math.imul(ah3, bh1)) | 0;
    lo = (lo + Math.imul(al2, bl2)) | 0;
    mid = (mid + Math.imul(al2, bh2)) | 0;
    mid = (mid + Math.imul(ah2, bl2)) | 0;
    hi = (hi + Math.imul(ah2, bh2)) | 0;
    lo = (lo + Math.imul(al1, bl3)) | 0;
    mid = (mid + Math.imul(al1, bh3)) | 0;
    mid = (mid + Math.imul(ah1, bl3)) | 0;
    hi = (hi + Math.imul(ah1, bh3)) | 0;
    lo = (lo + Math.imul(al0, bl4)) | 0;
    mid = (mid + Math.imul(al0, bh4)) | 0;
    mid = (mid + Math.imul(ah0, bl4)) | 0;
    hi = (hi + Math.imul(ah0, bh4)) | 0;
    var w4 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w4 >>> 26)) | 0;
    w4 &= 0x3ffffff;
    /* k = 5 */
    lo = Math.imul(al5, bl0);
    mid = Math.imul(al5, bh0);
    mid = (mid + Math.imul(ah5, bl0)) | 0;
    hi = Math.imul(ah5, bh0);
    lo = (lo + Math.imul(al4, bl1)) | 0;
    mid = (mid + Math.imul(al4, bh1)) | 0;
    mid = (mid + Math.imul(ah4, bl1)) | 0;
    hi = (hi + Math.imul(ah4, bh1)) | 0;
    lo = (lo + Math.imul(al3, bl2)) | 0;
    mid = (mid + Math.imul(al3, bh2)) | 0;
    mid = (mid + Math.imul(ah3, bl2)) | 0;
    hi = (hi + Math.imul(ah3, bh2)) | 0;
    lo = (lo + Math.imul(al2, bl3)) | 0;
    mid = (mid + Math.imul(al2, bh3)) | 0;
    mid = (mid + Math.imul(ah2, bl3)) | 0;
    hi = (hi + Math.imul(ah2, bh3)) | 0;
    lo = (lo + Math.imul(al1, bl4)) | 0;
    mid = (mid + Math.imul(al1, bh4)) | 0;
    mid = (mid + Math.imul(ah1, bl4)) | 0;
    hi = (hi + Math.imul(ah1, bh4)) | 0;
    lo = (lo + Math.imul(al0, bl5)) | 0;
    mid = (mid + Math.imul(al0, bh5)) | 0;
    mid = (mid + Math.imul(ah0, bl5)) | 0;
    hi = (hi + Math.imul(ah0, bh5)) | 0;
    var w5 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w5 >>> 26)) | 0;
    w5 &= 0x3ffffff;
    /* k = 6 */
    lo = Math.imul(al6, bl0);
    mid = Math.imul(al6, bh0);
    mid = (mid + Math.imul(ah6, bl0)) | 0;
    hi = Math.imul(ah6, bh0);
    lo = (lo + Math.imul(al5, bl1)) | 0;
    mid = (mid + Math.imul(al5, bh1)) | 0;
    mid = (mid + Math.imul(ah5, bl1)) | 0;
    hi = (hi + Math.imul(ah5, bh1)) | 0;
    lo = (lo + Math.imul(al4, bl2)) | 0;
    mid = (mid + Math.imul(al4, bh2)) | 0;
    mid = (mid + Math.imul(ah4, bl2)) | 0;
    hi = (hi + Math.imul(ah4, bh2)) | 0;
    lo = (lo + Math.imul(al3, bl3)) | 0;
    mid = (mid + Math.imul(al3, bh3)) | 0;
    mid = (mid + Math.imul(ah3, bl3)) | 0;
    hi = (hi + Math.imul(ah3, bh3)) | 0;
    lo = (lo + Math.imul(al2, bl4)) | 0;
    mid = (mid + Math.imul(al2, bh4)) | 0;
    mid = (mid + Math.imul(ah2, bl4)) | 0;
    hi = (hi + Math.imul(ah2, bh4)) | 0;
    lo = (lo + Math.imul(al1, bl5)) | 0;
    mid = (mid + Math.imul(al1, bh5)) | 0;
    mid = (mid + Math.imul(ah1, bl5)) | 0;
    hi = (hi + Math.imul(ah1, bh5)) | 0;
    lo = (lo + Math.imul(al0, bl6)) | 0;
    mid = (mid + Math.imul(al0, bh6)) | 0;
    mid = (mid + Math.imul(ah0, bl6)) | 0;
    hi = (hi + Math.imul(ah0, bh6)) | 0;
    var w6 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w6 >>> 26)) | 0;
    w6 &= 0x3ffffff;
    /* k = 7 */
    lo = Math.imul(al7, bl0);
    mid = Math.imul(al7, bh0);
    mid = (mid + Math.imul(ah7, bl0)) | 0;
    hi = Math.imul(ah7, bh0);
    lo = (lo + Math.imul(al6, bl1)) | 0;
    mid = (mid + Math.imul(al6, bh1)) | 0;
    mid = (mid + Math.imul(ah6, bl1)) | 0;
    hi = (hi + Math.imul(ah6, bh1)) | 0;
    lo = (lo + Math.imul(al5, bl2)) | 0;
    mid = (mid + Math.imul(al5, bh2)) | 0;
    mid = (mid + Math.imul(ah5, bl2)) | 0;
    hi = (hi + Math.imul(ah5, bh2)) | 0;
    lo = (lo + Math.imul(al4, bl3)) | 0;
    mid = (mid + Math.imul(al4, bh3)) | 0;
    mid = (mid + Math.imul(ah4, bl3)) | 0;
    hi = (hi + Math.imul(ah4, bh3)) | 0;
    lo = (lo + Math.imul(al3, bl4)) | 0;
    mid = (mid + Math.imul(al3, bh4)) | 0;
    mid = (mid + Math.imul(ah3, bl4)) | 0;
    hi = (hi + Math.imul(ah3, bh4)) | 0;
    lo = (lo + Math.imul(al2, bl5)) | 0;
    mid = (mid + Math.imul(al2, bh5)) | 0;
    mid = (mid + Math.imul(ah2, bl5)) | 0;
    hi = (hi + Math.imul(ah2, bh5)) | 0;
    lo = (lo + Math.imul(al1, bl6)) | 0;
    mid = (mid + Math.imul(al1, bh6)) | 0;
    mid = (mid + Math.imul(ah1, bl6)) | 0;
    hi = (hi + Math.imul(ah1, bh6)) | 0;
    lo = (lo + Math.imul(al0, bl7)) | 0;
    mid = (mid + Math.imul(al0, bh7)) | 0;
    mid = (mid + Math.imul(ah0, bl7)) | 0;
    hi = (hi + Math.imul(ah0, bh7)) | 0;
    var w7 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w7 >>> 26)) | 0;
    w7 &= 0x3ffffff;
    /* k = 8 */
    lo = Math.imul(al8, bl0);
    mid = Math.imul(al8, bh0);
    mid = (mid + Math.imul(ah8, bl0)) | 0;
    hi = Math.imul(ah8, bh0);
    lo = (lo + Math.imul(al7, bl1)) | 0;
    mid = (mid + Math.imul(al7, bh1)) | 0;
    mid = (mid + Math.imul(ah7, bl1)) | 0;
    hi = (hi + Math.imul(ah7, bh1)) | 0;
    lo = (lo + Math.imul(al6, bl2)) | 0;
    mid = (mid + Math.imul(al6, bh2)) | 0;
    mid = (mid + Math.imul(ah6, bl2)) | 0;
    hi = (hi + Math.imul(ah6, bh2)) | 0;
    lo = (lo + Math.imul(al5, bl3)) | 0;
    mid = (mid + Math.imul(al5, bh3)) | 0;
    mid = (mid + Math.imul(ah5, bl3)) | 0;
    hi = (hi + Math.imul(ah5, bh3)) | 0;
    lo = (lo + Math.imul(al4, bl4)) | 0;
    mid = (mid + Math.imul(al4, bh4)) | 0;
    mid = (mid + Math.imul(ah4, bl4)) | 0;
    hi = (hi + Math.imul(ah4, bh4)) | 0;
    lo = (lo + Math.imul(al3, bl5)) | 0;
    mid = (mid + Math.imul(al3, bh5)) | 0;
    mid = (mid + Math.imul(ah3, bl5)) | 0;
    hi = (hi + Math.imul(ah3, bh5)) | 0;
    lo = (lo + Math.imul(al2, bl6)) | 0;
    mid = (mid + Math.imul(al2, bh6)) | 0;
    mid = (mid + Math.imul(ah2, bl6)) | 0;
    hi = (hi + Math.imul(ah2, bh6)) | 0;
    lo = (lo + Math.imul(al1, bl7)) | 0;
    mid = (mid + Math.imul(al1, bh7)) | 0;
    mid = (mid + Math.imul(ah1, bl7)) | 0;
    hi = (hi + Math.imul(ah1, bh7)) | 0;
    lo = (lo + Math.imul(al0, bl8)) | 0;
    mid = (mid + Math.imul(al0, bh8)) | 0;
    mid = (mid + Math.imul(ah0, bl8)) | 0;
    hi = (hi + Math.imul(ah0, bh8)) | 0;
    var w8 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w8 >>> 26)) | 0;
    w8 &= 0x3ffffff;
    /* k = 9 */
    lo = Math.imul(al9, bl0);
    mid = Math.imul(al9, bh0);
    mid = (mid + Math.imul(ah9, bl0)) | 0;
    hi = Math.imul(ah9, bh0);
    lo = (lo + Math.imul(al8, bl1)) | 0;
    mid = (mid + Math.imul(al8, bh1)) | 0;
    mid = (mid + Math.imul(ah8, bl1)) | 0;
    hi = (hi + Math.imul(ah8, bh1)) | 0;
    lo = (lo + Math.imul(al7, bl2)) | 0;
    mid = (mid + Math.imul(al7, bh2)) | 0;
    mid = (mid + Math.imul(ah7, bl2)) | 0;
    hi = (hi + Math.imul(ah7, bh2)) | 0;
    lo = (lo + Math.imul(al6, bl3)) | 0;
    mid = (mid + Math.imul(al6, bh3)) | 0;
    mid = (mid + Math.imul(ah6, bl3)) | 0;
    hi = (hi + Math.imul(ah6, bh3)) | 0;
    lo = (lo + Math.imul(al5, bl4)) | 0;
    mid = (mid + Math.imul(al5, bh4)) | 0;
    mid = (mid + Math.imul(ah5, bl4)) | 0;
    hi = (hi + Math.imul(ah5, bh4)) | 0;
    lo = (lo + Math.imul(al4, bl5)) | 0;
    mid = (mid + Math.imul(al4, bh5)) | 0;
    mid = (mid + Math.imul(ah4, bl5)) | 0;
    hi = (hi + Math.imul(ah4, bh5)) | 0;
    lo = (lo + Math.imul(al3, bl6)) | 0;
    mid = (mid + Math.imul(al3, bh6)) | 0;
    mid = (mid + Math.imul(ah3, bl6)) | 0;
    hi = (hi + Math.imul(ah3, bh6)) | 0;
    lo = (lo + Math.imul(al2, bl7)) | 0;
    mid = (mid + Math.imul(al2, bh7)) | 0;
    mid = (mid + Math.imul(ah2, bl7)) | 0;
    hi = (hi + Math.imul(ah2, bh7)) | 0;
    lo = (lo + Math.imul(al1, bl8)) | 0;
    mid = (mid + Math.imul(al1, bh8)) | 0;
    mid = (mid + Math.imul(ah1, bl8)) | 0;
    hi = (hi + Math.imul(ah1, bh8)) | 0;
    lo = (lo + Math.imul(al0, bl9)) | 0;
    mid = (mid + Math.imul(al0, bh9)) | 0;
    mid = (mid + Math.imul(ah0, bl9)) | 0;
    hi = (hi + Math.imul(ah0, bh9)) | 0;
    var w9 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w9 >>> 26)) | 0;
    w9 &= 0x3ffffff;
    /* k = 10 */
    lo = Math.imul(al9, bl1);
    mid = Math.imul(al9, bh1);
    mid = (mid + Math.imul(ah9, bl1)) | 0;
    hi = Math.imul(ah9, bh1);
    lo = (lo + Math.imul(al8, bl2)) | 0;
    mid = (mid + Math.imul(al8, bh2)) | 0;
    mid = (mid + Math.imul(ah8, bl2)) | 0;
    hi = (hi + Math.imul(ah8, bh2)) | 0;
    lo = (lo + Math.imul(al7, bl3)) | 0;
    mid = (mid + Math.imul(al7, bh3)) | 0;
    mid = (mid + Math.imul(ah7, bl3)) | 0;
    hi = (hi + Math.imul(ah7, bh3)) | 0;
    lo = (lo + Math.imul(al6, bl4)) | 0;
    mid = (mid + Math.imul(al6, bh4)) | 0;
    mid = (mid + Math.imul(ah6, bl4)) | 0;
    hi = (hi + Math.imul(ah6, bh4)) | 0;
    lo = (lo + Math.imul(al5, bl5)) | 0;
    mid = (mid + Math.imul(al5, bh5)) | 0;
    mid = (mid + Math.imul(ah5, bl5)) | 0;
    hi = (hi + Math.imul(ah5, bh5)) | 0;
    lo = (lo + Math.imul(al4, bl6)) | 0;
    mid = (mid + Math.imul(al4, bh6)) | 0;
    mid = (mid + Math.imul(ah4, bl6)) | 0;
    hi = (hi + Math.imul(ah4, bh6)) | 0;
    lo = (lo + Math.imul(al3, bl7)) | 0;
    mid = (mid + Math.imul(al3, bh7)) | 0;
    mid = (mid + Math.imul(ah3, bl7)) | 0;
    hi = (hi + Math.imul(ah3, bh7)) | 0;
    lo = (lo + Math.imul(al2, bl8)) | 0;
    mid = (mid + Math.imul(al2, bh8)) | 0;
    mid = (mid + Math.imul(ah2, bl8)) | 0;
    hi = (hi + Math.imul(ah2, bh8)) | 0;
    lo = (lo + Math.imul(al1, bl9)) | 0;
    mid = (mid + Math.imul(al1, bh9)) | 0;
    mid = (mid + Math.imul(ah1, bl9)) | 0;
    hi = (hi + Math.imul(ah1, bh9)) | 0;
    var w10 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w10 >>> 26)) | 0;
    w10 &= 0x3ffffff;
    /* k = 11 */
    lo = Math.imul(al9, bl2);
    mid = Math.imul(al9, bh2);
    mid = (mid + Math.imul(ah9, bl2)) | 0;
    hi = Math.imul(ah9, bh2);
    lo = (lo + Math.imul(al8, bl3)) | 0;
    mid = (mid + Math.imul(al8, bh3)) | 0;
    mid = (mid + Math.imul(ah8, bl3)) | 0;
    hi = (hi + Math.imul(ah8, bh3)) | 0;
    lo = (lo + Math.imul(al7, bl4)) | 0;
    mid = (mid + Math.imul(al7, bh4)) | 0;
    mid = (mid + Math.imul(ah7, bl4)) | 0;
    hi = (hi + Math.imul(ah7, bh4)) | 0;
    lo = (lo + Math.imul(al6, bl5)) | 0;
    mid = (mid + Math.imul(al6, bh5)) | 0;
    mid = (mid + Math.imul(ah6, bl5)) | 0;
    hi = (hi + Math.imul(ah6, bh5)) | 0;
    lo = (lo + Math.imul(al5, bl6)) | 0;
    mid = (mid + Math.imul(al5, bh6)) | 0;
    mid = (mid + Math.imul(ah5, bl6)) | 0;
    hi = (hi + Math.imul(ah5, bh6)) | 0;
    lo = (lo + Math.imul(al4, bl7)) | 0;
    mid = (mid + Math.imul(al4, bh7)) | 0;
    mid = (mid + Math.imul(ah4, bl7)) | 0;
    hi = (hi + Math.imul(ah4, bh7)) | 0;
    lo = (lo + Math.imul(al3, bl8)) | 0;
    mid = (mid + Math.imul(al3, bh8)) | 0;
    mid = (mid + Math.imul(ah3, bl8)) | 0;
    hi = (hi + Math.imul(ah3, bh8)) | 0;
    lo = (lo + Math.imul(al2, bl9)) | 0;
    mid = (mid + Math.imul(al2, bh9)) | 0;
    mid = (mid + Math.imul(ah2, bl9)) | 0;
    hi = (hi + Math.imul(ah2, bh9)) | 0;
    var w11 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w11 >>> 26)) | 0;
    w11 &= 0x3ffffff;
    /* k = 12 */
    lo = Math.imul(al9, bl3);
    mid = Math.imul(al9, bh3);
    mid = (mid + Math.imul(ah9, bl3)) | 0;
    hi = Math.imul(ah9, bh3);
    lo = (lo + Math.imul(al8, bl4)) | 0;
    mid = (mid + Math.imul(al8, bh4)) | 0;
    mid = (mid + Math.imul(ah8, bl4)) | 0;
    hi = (hi + Math.imul(ah8, bh4)) | 0;
    lo = (lo + Math.imul(al7, bl5)) | 0;
    mid = (mid + Math.imul(al7, bh5)) | 0;
    mid = (mid + Math.imul(ah7, bl5)) | 0;
    hi = (hi + Math.imul(ah7, bh5)) | 0;
    lo = (lo + Math.imul(al6, bl6)) | 0;
    mid = (mid + Math.imul(al6, bh6)) | 0;
    mid = (mid + Math.imul(ah6, bl6)) | 0;
    hi = (hi + Math.imul(ah6, bh6)) | 0;
    lo = (lo + Math.imul(al5, bl7)) | 0;
    mid = (mid + Math.imul(al5, bh7)) | 0;
    mid = (mid + Math.imul(ah5, bl7)) | 0;
    hi = (hi + Math.imul(ah5, bh7)) | 0;
    lo = (lo + Math.imul(al4, bl8)) | 0;
    mid = (mid + Math.imul(al4, bh8)) | 0;
    mid = (mid + Math.imul(ah4, bl8)) | 0;
    hi = (hi + Math.imul(ah4, bh8)) | 0;
    lo = (lo + Math.imul(al3, bl9)) | 0;
    mid = (mid + Math.imul(al3, bh9)) | 0;
    mid = (mid + Math.imul(ah3, bl9)) | 0;
    hi = (hi + Math.imul(ah3, bh9)) | 0;
    var w12 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w12 >>> 26)) | 0;
    w12 &= 0x3ffffff;
    /* k = 13 */
    lo = Math.imul(al9, bl4);
    mid = Math.imul(al9, bh4);
    mid = (mid + Math.imul(ah9, bl4)) | 0;
    hi = Math.imul(ah9, bh4);
    lo = (lo + Math.imul(al8, bl5)) | 0;
    mid = (mid + Math.imul(al8, bh5)) | 0;
    mid = (mid + Math.imul(ah8, bl5)) | 0;
    hi = (hi + Math.imul(ah8, bh5)) | 0;
    lo = (lo + Math.imul(al7, bl6)) | 0;
    mid = (mid + Math.imul(al7, bh6)) | 0;
    mid = (mid + Math.imul(ah7, bl6)) | 0;
    hi = (hi + Math.imul(ah7, bh6)) | 0;
    lo = (lo + Math.imul(al6, bl7)) | 0;
    mid = (mid + Math.imul(al6, bh7)) | 0;
    mid = (mid + Math.imul(ah6, bl7)) | 0;
    hi = (hi + Math.imul(ah6, bh7)) | 0;
    lo = (lo + Math.imul(al5, bl8)) | 0;
    mid = (mid + Math.imul(al5, bh8)) | 0;
    mid = (mid + Math.imul(ah5, bl8)) | 0;
    hi = (hi + Math.imul(ah5, bh8)) | 0;
    lo = (lo + Math.imul(al4, bl9)) | 0;
    mid = (mid + Math.imul(al4, bh9)) | 0;
    mid = (mid + Math.imul(ah4, bl9)) | 0;
    hi = (hi + Math.imul(ah4, bh9)) | 0;
    var w13 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w13 >>> 26)) | 0;
    w13 &= 0x3ffffff;
    /* k = 14 */
    lo = Math.imul(al9, bl5);
    mid = Math.imul(al9, bh5);
    mid = (mid + Math.imul(ah9, bl5)) | 0;
    hi = Math.imul(ah9, bh5);
    lo = (lo + Math.imul(al8, bl6)) | 0;
    mid = (mid + Math.imul(al8, bh6)) | 0;
    mid = (mid + Math.imul(ah8, bl6)) | 0;
    hi = (hi + Math.imul(ah8, bh6)) | 0;
    lo = (lo + Math.imul(al7, bl7)) | 0;
    mid = (mid + Math.imul(al7, bh7)) | 0;
    mid = (mid + Math.imul(ah7, bl7)) | 0;
    hi = (hi + Math.imul(ah7, bh7)) | 0;
    lo = (lo + Math.imul(al6, bl8)) | 0;
    mid = (mid + Math.imul(al6, bh8)) | 0;
    mid = (mid + Math.imul(ah6, bl8)) | 0;
    hi = (hi + Math.imul(ah6, bh8)) | 0;
    lo = (lo + Math.imul(al5, bl9)) | 0;
    mid = (mid + Math.imul(al5, bh9)) | 0;
    mid = (mid + Math.imul(ah5, bl9)) | 0;
    hi = (hi + Math.imul(ah5, bh9)) | 0;
    var w14 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w14 >>> 26)) | 0;
    w14 &= 0x3ffffff;
    /* k = 15 */
    lo = Math.imul(al9, bl6);
    mid = Math.imul(al9, bh6);
    mid = (mid + Math.imul(ah9, bl6)) | 0;
    hi = Math.imul(ah9, bh6);
    lo = (lo + Math.imul(al8, bl7)) | 0;
    mid = (mid + Math.imul(al8, bh7)) | 0;
    mid = (mid + Math.imul(ah8, bl7)) | 0;
    hi = (hi + Math.imul(ah8, bh7)) | 0;
    lo = (lo + Math.imul(al7, bl8)) | 0;
    mid = (mid + Math.imul(al7, bh8)) | 0;
    mid = (mid + Math.imul(ah7, bl8)) | 0;
    hi = (hi + Math.imul(ah7, bh8)) | 0;
    lo = (lo + Math.imul(al6, bl9)) | 0;
    mid = (mid + Math.imul(al6, bh9)) | 0;
    mid = (mid + Math.imul(ah6, bl9)) | 0;
    hi = (hi + Math.imul(ah6, bh9)) | 0;
    var w15 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w15 >>> 26)) | 0;
    w15 &= 0x3ffffff;
    /* k = 16 */
    lo = Math.imul(al9, bl7);
    mid = Math.imul(al9, bh7);
    mid = (mid + Math.imul(ah9, bl7)) | 0;
    hi = Math.imul(ah9, bh7);
    lo = (lo + Math.imul(al8, bl8)) | 0;
    mid = (mid + Math.imul(al8, bh8)) | 0;
    mid = (mid + Math.imul(ah8, bl8)) | 0;
    hi = (hi + Math.imul(ah8, bh8)) | 0;
    lo = (lo + Math.imul(al7, bl9)) | 0;
    mid = (mid + Math.imul(al7, bh9)) | 0;
    mid = (mid + Math.imul(ah7, bl9)) | 0;
    hi = (hi + Math.imul(ah7, bh9)) | 0;
    var w16 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w16 >>> 26)) | 0;
    w16 &= 0x3ffffff;
    /* k = 17 */
    lo = Math.imul(al9, bl8);
    mid = Math.imul(al9, bh8);
    mid = (mid + Math.imul(ah9, bl8)) | 0;
    hi = Math.imul(ah9, bh8);
    lo = (lo + Math.imul(al8, bl9)) | 0;
    mid = (mid + Math.imul(al8, bh9)) | 0;
    mid = (mid + Math.imul(ah8, bl9)) | 0;
    hi = (hi + Math.imul(ah8, bh9)) | 0;
    var w17 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w17 >>> 26)) | 0;
    w17 &= 0x3ffffff;
    /* k = 18 */
    lo = Math.imul(al9, bl9);
    mid = Math.imul(al9, bh9);
    mid = (mid + Math.imul(ah9, bl9)) | 0;
    hi = Math.imul(ah9, bh9);
    var w18 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w18 >>> 26)) | 0;
    w18 &= 0x3ffffff;
    o[0] = w0;
    o[1] = w1;
    o[2] = w2;
    o[3] = w3;
    o[4] = w4;
    o[5] = w5;
    o[6] = w6;
    o[7] = w7;
    o[8] = w8;
    o[9] = w9;
    o[10] = w10;
    o[11] = w11;
    o[12] = w12;
    o[13] = w13;
    o[14] = w14;
    o[15] = w15;
    o[16] = w16;
    o[17] = w17;
    o[18] = w18;
    if (c !== 0) {
      o[19] = c;
      out.length++;
    }
    return out;
  };

  // Polyfill comb
  if (!Math.imul) {
    comb10MulTo = smallMulTo;
  }

  function bigMulTo (self, num, out) {
    out.negative = num.negative ^ self.negative;
    out.length = self.length + num.length;

    var carry = 0;
    var hncarry = 0;
    for (var k = 0; k < out.length - 1; k++) {
      // Sum all words with the same `i + j = k` and accumulate `ncarry`,
      // note that ncarry could be >= 0x3ffffff
      var ncarry = hncarry;
      hncarry = 0;
      var rword = carry & 0x3ffffff;
      var maxJ = Math.min(k, num.length - 1);
      for (var j = Math.max(0, k - self.length + 1); j <= maxJ; j++) {
        var i = k - j;
        var a = self.words[i] | 0;
        var b = num.words[j] | 0;
        var r = a * b;

        var lo = r & 0x3ffffff;
        ncarry = (ncarry + ((r / 0x4000000) | 0)) | 0;
        lo = (lo + rword) | 0;
        rword = lo & 0x3ffffff;
        ncarry = (ncarry + (lo >>> 26)) | 0;

        hncarry += ncarry >>> 26;
        ncarry &= 0x3ffffff;
      }
      out.words[k] = rword;
      carry = ncarry;
      ncarry = hncarry;
    }
    if (carry !== 0) {
      out.words[k] = carry;
    } else {
      out.length--;
    }

    return out.strip();
  }

  function jumboMulTo (self, num, out) {
    var fftm = new FFTM();
    return fftm.mulp(self, num, out);
  }

  BN.prototype.mulTo = function mulTo (num, out) {
    var res;
    var len = this.length + num.length;
    if (this.length === 10 && num.length === 10) {
      res = comb10MulTo(this, num, out);
    } else if (len < 63) {
      res = smallMulTo(this, num, out);
    } else if (len < 1024) {
      res = bigMulTo(this, num, out);
    } else {
      res = jumboMulTo(this, num, out);
    }

    return res;
  };

  // Cooley-Tukey algorithm for FFT
  // slightly revisited to rely on looping instead of recursion

  function FFTM (x, y) {
    this.x = x;
    this.y = y;
  }

  FFTM.prototype.makeRBT = function makeRBT (N) {
    var t = new Array(N);
    var l = BN.prototype._countBits(N) - 1;
    for (var i = 0; i < N; i++) {
      t[i] = this.revBin(i, l, N);
    }

    return t;
  };

  // Returns binary-reversed representation of `x`
  FFTM.prototype.revBin = function revBin (x, l, N) {
    if (x === 0 || x === N - 1) return x;

    var rb = 0;
    for (var i = 0; i < l; i++) {
      rb |= (x & 1) << (l - i - 1);
      x >>= 1;
    }

    return rb;
  };

  // Performs "tweedling" phase, therefore 'emulating'
  // behaviour of the recursive algorithm
  FFTM.prototype.permute = function permute (rbt, rws, iws, rtws, itws, N) {
    for (var i = 0; i < N; i++) {
      rtws[i] = rws[rbt[i]];
      itws[i] = iws[rbt[i]];
    }
  };

  FFTM.prototype.transform = function transform (rws, iws, rtws, itws, N, rbt) {
    this.permute(rbt, rws, iws, rtws, itws, N);

    for (var s = 1; s < N; s <<= 1) {
      var l = s << 1;

      var rtwdf = Math.cos(2 * Math.PI / l);
      var itwdf = Math.sin(2 * Math.PI / l);

      for (var p = 0; p < N; p += l) {
        var rtwdf_ = rtwdf;
        var itwdf_ = itwdf;

        for (var j = 0; j < s; j++) {
          var re = rtws[p + j];
          var ie = itws[p + j];

          var ro = rtws[p + j + s];
          var io = itws[p + j + s];

          var rx = rtwdf_ * ro - itwdf_ * io;

          io = rtwdf_ * io + itwdf_ * ro;
          ro = rx;

          rtws[p + j] = re + ro;
          itws[p + j] = ie + io;

          rtws[p + j + s] = re - ro;
          itws[p + j + s] = ie - io;

          /* jshint maxdepth : false */
          if (j !== l) {
            rx = rtwdf * rtwdf_ - itwdf * itwdf_;

            itwdf_ = rtwdf * itwdf_ + itwdf * rtwdf_;
            rtwdf_ = rx;
          }
        }
      }
    }
  };

  FFTM.prototype.guessLen13b = function guessLen13b (n, m) {
    var N = Math.max(m, n) | 1;
    var odd = N & 1;
    var i = 0;
    for (N = N / 2 | 0; N; N = N >>> 1) {
      i++;
    }

    return 1 << i + 1 + odd;
  };

  FFTM.prototype.conjugate = function conjugate (rws, iws, N) {
    if (N <= 1) return;

    for (var i = 0; i < N / 2; i++) {
      var t = rws[i];

      rws[i] = rws[N - i - 1];
      rws[N - i - 1] = t;

      t = iws[i];

      iws[i] = -iws[N - i - 1];
      iws[N - i - 1] = -t;
    }
  };

  FFTM.prototype.normalize13b = function normalize13b (ws, N) {
    var carry = 0;
    for (var i = 0; i < N / 2; i++) {
      var w = Math.round(ws[2 * i + 1] / N) * 0x2000 +
        Math.round(ws[2 * i] / N) +
        carry;

      ws[i] = w & 0x3ffffff;

      if (w < 0x4000000) {
        carry = 0;
      } else {
        carry = w / 0x4000000 | 0;
      }
    }

    return ws;
  };

  FFTM.prototype.convert13b = function convert13b (ws, len, rws, N) {
    var carry = 0;
    for (var i = 0; i < len; i++) {
      carry = carry + (ws[i] | 0);

      rws[2 * i] = carry & 0x1fff; carry = carry >>> 13;
      rws[2 * i + 1] = carry & 0x1fff; carry = carry >>> 13;
    }

    // Pad with zeroes
    for (i = 2 * len; i < N; ++i) {
      rws[i] = 0;
    }

    assert(carry === 0);
    assert((carry & ~0x1fff) === 0);
  };

  FFTM.prototype.stub = function stub (N) {
    var ph = new Array(N);
    for (var i = 0; i < N; i++) {
      ph[i] = 0;
    }

    return ph;
  };

  FFTM.prototype.mulp = function mulp (x, y, out) {
    var N = 2 * this.guessLen13b(x.length, y.length);

    var rbt = this.makeRBT(N);

    var _ = this.stub(N);

    var rws = new Array(N);
    var rwst = new Array(N);
    var iwst = new Array(N);

    var nrws = new Array(N);
    var nrwst = new Array(N);
    var niwst = new Array(N);

    var rmws = out.words;
    rmws.length = N;

    this.convert13b(x.words, x.length, rws, N);
    this.convert13b(y.words, y.length, nrws, N);

    this.transform(rws, _, rwst, iwst, N, rbt);
    this.transform(nrws, _, nrwst, niwst, N, rbt);

    for (var i = 0; i < N; i++) {
      var rx = rwst[i] * nrwst[i] - iwst[i] * niwst[i];
      iwst[i] = rwst[i] * niwst[i] + iwst[i] * nrwst[i];
      rwst[i] = rx;
    }

    this.conjugate(rwst, iwst, N);
    this.transform(rwst, iwst, rmws, _, N, rbt);
    this.conjugate(rmws, _, N);
    this.normalize13b(rmws, N);

    out.negative = x.negative ^ y.negative;
    out.length = x.length + y.length;
    return out.strip();
  };

  // Multiply `this` by `num`
  BN.prototype.mul = function mul (num) {
    var out = new BN(null);
    out.words = new Array(this.length + num.length);
    return this.mulTo(num, out);
  };

  // Multiply employing FFT
  BN.prototype.mulf = function mulf (num) {
    var out = new BN(null);
    out.words = new Array(this.length + num.length);
    return jumboMulTo(this, num, out);
  };

  // In-place Multiplication
  BN.prototype.imul = function imul (num) {
    return this.clone().mulTo(num, this);
  };

  BN.prototype.imuln = function imuln (num) {
    assert(typeof num === 'number');
    assert(num < 0x4000000);

    // Carry
    var carry = 0;
    for (var i = 0; i < this.length; i++) {
      var w = (this.words[i] | 0) * num;
      var lo = (w & 0x3ffffff) + (carry & 0x3ffffff);
      carry >>= 26;
      carry += (w / 0x4000000) | 0;
      // NOTE: lo is 27bit maximum
      carry += lo >>> 26;
      this.words[i] = lo & 0x3ffffff;
    }

    if (carry !== 0) {
      this.words[i] = carry;
      this.length++;
    }

    return this;
  };

  BN.prototype.muln = function muln (num) {
    return this.clone().imuln(num);
  };

  // `this` * `this`
  BN.prototype.sqr = function sqr () {
    return this.mul(this);
  };

  // `this` * `this` in-place
  BN.prototype.isqr = function isqr () {
    return this.imul(this.clone());
  };

  // Math.pow(`this`, `num`)
  BN.prototype.pow = function pow (num) {
    var w = toBitArray(num);
    if (w.length === 0) return new BN(1);

    // Skip leading zeroes
    var res = this;
    for (var i = 0; i < w.length; i++, res = res.sqr()) {
      if (w[i] !== 0) break;
    }

    if (++i < w.length) {
      for (var q = res.sqr(); i < w.length; i++, q = q.sqr()) {
        if (w[i] === 0) continue;

        res = res.mul(q);
      }
    }

    return res;
  };

  // Shift-left in-place
  BN.prototype.iushln = function iushln (bits) {
    assert(typeof bits === 'number' && bits >= 0);
    var r = bits % 26;
    var s = (bits - r) / 26;
    var carryMask = (0x3ffffff >>> (26 - r)) << (26 - r);
    var i;

    if (r !== 0) {
      var carry = 0;

      for (i = 0; i < this.length; i++) {
        var newCarry = this.words[i] & carryMask;
        var c = ((this.words[i] | 0) - newCarry) << r;
        this.words[i] = c | carry;
        carry = newCarry >>> (26 - r);
      }

      if (carry) {
        this.words[i] = carry;
        this.length++;
      }
    }

    if (s !== 0) {
      for (i = this.length - 1; i >= 0; i--) {
        this.words[i + s] = this.words[i];
      }

      for (i = 0; i < s; i++) {
        this.words[i] = 0;
      }

      this.length += s;
    }

    return this.strip();
  };

  BN.prototype.ishln = function ishln (bits) {
    // TODO(indutny): implement me
    assert(this.negative === 0);
    return this.iushln(bits);
  };

  // Shift-right in-place
  // NOTE: `hint` is a lowest bit before trailing zeroes
  // NOTE: if `extended` is present - it will be filled with destroyed bits
  BN.prototype.iushrn = function iushrn (bits, hint, extended) {
    assert(typeof bits === 'number' && bits >= 0);
    var h;
    if (hint) {
      h = (hint - (hint % 26)) / 26;
    } else {
      h = 0;
    }

    var r = bits % 26;
    var s = Math.min((bits - r) / 26, this.length);
    var mask = 0x3ffffff ^ ((0x3ffffff >>> r) << r);
    var maskedWords = extended;

    h -= s;
    h = Math.max(0, h);

    // Extended mode, copy masked part
    if (maskedWords) {
      for (var i = 0; i < s; i++) {
        maskedWords.words[i] = this.words[i];
      }
      maskedWords.length = s;
    }

    if (s === 0) {
      // No-op, we should not move anything at all
    } else if (this.length > s) {
      this.length -= s;
      for (i = 0; i < this.length; i++) {
        this.words[i] = this.words[i + s];
      }
    } else {
      this.words[0] = 0;
      this.length = 1;
    }

    var carry = 0;
    for (i = this.length - 1; i >= 0 && (carry !== 0 || i >= h); i--) {
      var word = this.words[i] | 0;
      this.words[i] = (carry << (26 - r)) | (word >>> r);
      carry = word & mask;
    }

    // Push carried bits as a mask
    if (maskedWords && carry !== 0) {
      maskedWords.words[maskedWords.length++] = carry;
    }

    if (this.length === 0) {
      this.words[0] = 0;
      this.length = 1;
    }

    return this.strip();
  };

  BN.prototype.ishrn = function ishrn (bits, hint, extended) {
    // TODO(indutny): implement me
    assert(this.negative === 0);
    return this.iushrn(bits, hint, extended);
  };

  // Shift-left
  BN.prototype.shln = function shln (bits) {
    return this.clone().ishln(bits);
  };

  BN.prototype.ushln = function ushln (bits) {
    return this.clone().iushln(bits);
  };

  // Shift-right
  BN.prototype.shrn = function shrn (bits) {
    return this.clone().ishrn(bits);
  };

  BN.prototype.ushrn = function ushrn (bits) {
    return this.clone().iushrn(bits);
  };

  // Test if n bit is set
  BN.prototype.testn = function testn (bit) {
    assert(typeof bit === 'number' && bit >= 0);
    var r = bit % 26;
    var s = (bit - r) / 26;
    var q = 1 << r;

    // Fast case: bit is much higher than all existing words
    if (this.length <= s) return false;

    // Check bit and return
    var w = this.words[s];

    return !!(w & q);
  };

  // Return only lowers bits of number (in-place)
  BN.prototype.imaskn = function imaskn (bits) {
    assert(typeof bits === 'number' && bits >= 0);
    var r = bits % 26;
    var s = (bits - r) / 26;

    assert(this.negative === 0, 'imaskn works only with positive numbers');

    if (this.length <= s) {
      return this;
    }

    if (r !== 0) {
      s++;
    }
    this.length = Math.min(s, this.length);

    if (r !== 0) {
      var mask = 0x3ffffff ^ ((0x3ffffff >>> r) << r);
      this.words[this.length - 1] &= mask;
    }

    return this.strip();
  };

  // Return only lowers bits of number
  BN.prototype.maskn = function maskn (bits) {
    return this.clone().imaskn(bits);
  };

  // Add plain number `num` to `this`
  BN.prototype.iaddn = function iaddn (num) {
    assert(typeof num === 'number');
    assert(num < 0x4000000);
    if (num < 0) return this.isubn(-num);

    // Possible sign change
    if (this.negative !== 0) {
      if (this.length === 1 && (this.words[0] | 0) < num) {
        this.words[0] = num - (this.words[0] | 0);
        this.negative = 0;
        return this;
      }

      this.negative = 0;
      this.isubn(num);
      this.negative = 1;
      return this;
    }

    // Add without checks
    return this._iaddn(num);
  };

  BN.prototype._iaddn = function _iaddn (num) {
    this.words[0] += num;

    // Carry
    for (var i = 0; i < this.length && this.words[i] >= 0x4000000; i++) {
      this.words[i] -= 0x4000000;
      if (i === this.length - 1) {
        this.words[i + 1] = 1;
      } else {
        this.words[i + 1]++;
      }
    }
    this.length = Math.max(this.length, i + 1);

    return this;
  };

  // Subtract plain number `num` from `this`
  BN.prototype.isubn = function isubn (num) {
    assert(typeof num === 'number');
    assert(num < 0x4000000);
    if (num < 0) return this.iaddn(-num);

    if (this.negative !== 0) {
      this.negative = 0;
      this.iaddn(num);
      this.negative = 1;
      return this;
    }

    this.words[0] -= num;

    if (this.length === 1 && this.words[0] < 0) {
      this.words[0] = -this.words[0];
      this.negative = 1;
    } else {
      // Carry
      for (var i = 0; i < this.length && this.words[i] < 0; i++) {
        this.words[i] += 0x4000000;
        this.words[i + 1] -= 1;
      }
    }

    return this.strip();
  };

  BN.prototype.addn = function addn (num) {
    return this.clone().iaddn(num);
  };

  BN.prototype.subn = function subn (num) {
    return this.clone().isubn(num);
  };

  BN.prototype.iabs = function iabs () {
    this.negative = 0;

    return this;
  };

  BN.prototype.abs = function abs () {
    return this.clone().iabs();
  };

  BN.prototype._ishlnsubmul = function _ishlnsubmul (num, mul, shift) {
    var len = num.length + shift;
    var i;

    this._expand(len);

    var w;
    var carry = 0;
    for (i = 0; i < num.length; i++) {
      w = (this.words[i + shift] | 0) + carry;
      var right = (num.words[i] | 0) * mul;
      w -= right & 0x3ffffff;
      carry = (w >> 26) - ((right / 0x4000000) | 0);
      this.words[i + shift] = w & 0x3ffffff;
    }
    for (; i < this.length - shift; i++) {
      w = (this.words[i + shift] | 0) + carry;
      carry = w >> 26;
      this.words[i + shift] = w & 0x3ffffff;
    }

    if (carry === 0) return this.strip();

    // Subtraction overflow
    assert(carry === -1);
    carry = 0;
    for (i = 0; i < this.length; i++) {
      w = -(this.words[i] | 0) + carry;
      carry = w >> 26;
      this.words[i] = w & 0x3ffffff;
    }
    this.negative = 1;

    return this.strip();
  };

  BN.prototype._wordDiv = function _wordDiv (num, mode) {
    var shift = this.length - num.length;

    var a = this.clone();
    var b = num;

    // Normalize
    var bhi = b.words[b.length - 1] | 0;
    var bhiBits = this._countBits(bhi);
    shift = 26 - bhiBits;
    if (shift !== 0) {
      b = b.ushln(shift);
      a.iushln(shift);
      bhi = b.words[b.length - 1] | 0;
    }

    // Initialize quotient
    var m = a.length - b.length;
    var q;

    if (mode !== 'mod') {
      q = new BN(null);
      q.length = m + 1;
      q.words = new Array(q.length);
      for (var i = 0; i < q.length; i++) {
        q.words[i] = 0;
      }
    }

    var diff = a.clone()._ishlnsubmul(b, 1, m);
    if (diff.negative === 0) {
      a = diff;
      if (q) {
        q.words[m] = 1;
      }
    }

    for (var j = m - 1; j >= 0; j--) {
      var qj = (a.words[b.length + j] | 0) * 0x4000000 +
        (a.words[b.length + j - 1] | 0);

      // NOTE: (qj / bhi) is (0x3ffffff * 0x4000000 + 0x3ffffff) / 0x2000000 max
      // (0x7ffffff)
      qj = Math.min((qj / bhi) | 0, 0x3ffffff);

      a._ishlnsubmul(b, qj, j);
      while (a.negative !== 0) {
        qj--;
        a.negative = 0;
        a._ishlnsubmul(b, 1, j);
        if (!a.isZero()) {
          a.negative ^= 1;
        }
      }
      if (q) {
        q.words[j] = qj;
      }
    }
    if (q) {
      q.strip();
    }
    a.strip();

    // Denormalize
    if (mode !== 'div' && shift !== 0) {
      a.iushrn(shift);
    }

    return {
      div: q || null,
      mod: a
    };
  };

  // NOTE: 1) `mode` can be set to `mod` to request mod only,
  //       to `div` to request div only, or be absent to
  //       request both div & mod
  //       2) `positive` is true if unsigned mod is requested
  BN.prototype.divmod = function divmod (num, mode, positive) {
    assert(!num.isZero());

    if (this.isZero()) {
      return {
        div: new BN(0),
        mod: new BN(0)
      };
    }

    var div, mod, res;
    if (this.negative !== 0 && num.negative === 0) {
      res = this.neg().divmod(num, mode);

      if (mode !== 'mod') {
        div = res.div.neg();
      }

      if (mode !== 'div') {
        mod = res.mod.neg();
        if (positive && mod.negative !== 0) {
          mod.iadd(num);
        }
      }

      return {
        div: div,
        mod: mod
      };
    }

    if (this.negative === 0 && num.negative !== 0) {
      res = this.divmod(num.neg(), mode);

      if (mode !== 'mod') {
        div = res.div.neg();
      }

      return {
        div: div,
        mod: res.mod
      };
    }

    if ((this.negative & num.negative) !== 0) {
      res = this.neg().divmod(num.neg(), mode);

      if (mode !== 'div') {
        mod = res.mod.neg();
        if (positive && mod.negative !== 0) {
          mod.isub(num);
        }
      }

      return {
        div: res.div,
        mod: mod
      };
    }

    // Both numbers are positive at this point

    // Strip both numbers to approximate shift value
    if (num.length > this.length || this.cmp(num) < 0) {
      return {
        div: new BN(0),
        mod: this
      };
    }

    // Very short reduction
    if (num.length === 1) {
      if (mode === 'div') {
        return {
          div: this.divn(num.words[0]),
          mod: null
        };
      }

      if (mode === 'mod') {
        return {
          div: null,
          mod: new BN(this.modn(num.words[0]))
        };
      }

      return {
        div: this.divn(num.words[0]),
        mod: new BN(this.modn(num.words[0]))
      };
    }

    return this._wordDiv(num, mode);
  };

  // Find `this` / `num`
  BN.prototype.div = function div (num) {
    return this.divmod(num, 'div', false).div;
  };

  // Find `this` % `num`
  BN.prototype.mod = function mod (num) {
    return this.divmod(num, 'mod', false).mod;
  };

  BN.prototype.umod = function umod (num) {
    return this.divmod(num, 'mod', true).mod;
  };

  // Find Round(`this` / `num`)
  BN.prototype.divRound = function divRound (num) {
    var dm = this.divmod(num);

    // Fast case - exact division
    if (dm.mod.isZero()) return dm.div;

    var mod = dm.div.negative !== 0 ? dm.mod.isub(num) : dm.mod;

    var half = num.ushrn(1);
    var r2 = num.andln(1);
    var cmp = mod.cmp(half);

    // Round down
    if (cmp < 0 || r2 === 1 && cmp === 0) return dm.div;

    // Round up
    return dm.div.negative !== 0 ? dm.div.isubn(1) : dm.div.iaddn(1);
  };

  BN.prototype.modn = function modn (num) {
    assert(num <= 0x3ffffff);
    var p = (1 << 26) % num;

    var acc = 0;
    for (var i = this.length - 1; i >= 0; i--) {
      acc = (p * acc + (this.words[i] | 0)) % num;
    }

    return acc;
  };

  // In-place division by number
  BN.prototype.idivn = function idivn (num) {
    assert(num <= 0x3ffffff);

    var carry = 0;
    for (var i = this.length - 1; i >= 0; i--) {
      var w = (this.words[i] | 0) + carry * 0x4000000;
      this.words[i] = (w / num) | 0;
      carry = w % num;
    }

    return this.strip();
  };

  BN.prototype.divn = function divn (num) {
    return this.clone().idivn(num);
  };

  BN.prototype.egcd = function egcd (p) {
    assert(p.negative === 0);
    assert(!p.isZero());

    var x = this;
    var y = p.clone();

    if (x.negative !== 0) {
      x = x.umod(p);
    } else {
      x = x.clone();
    }

    // A * x + B * y = x
    var A = new BN(1);
    var B = new BN(0);

    // C * x + D * y = y
    var C = new BN(0);
    var D = new BN(1);

    var g = 0;

    while (x.isEven() && y.isEven()) {
      x.iushrn(1);
      y.iushrn(1);
      ++g;
    }

    var yp = y.clone();
    var xp = x.clone();

    while (!x.isZero()) {
      for (var i = 0, im = 1; (x.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
      if (i > 0) {
        x.iushrn(i);
        while (i-- > 0) {
          if (A.isOdd() || B.isOdd()) {
            A.iadd(yp);
            B.isub(xp);
          }

          A.iushrn(1);
          B.iushrn(1);
        }
      }

      for (var j = 0, jm = 1; (y.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
      if (j > 0) {
        y.iushrn(j);
        while (j-- > 0) {
          if (C.isOdd() || D.isOdd()) {
            C.iadd(yp);
            D.isub(xp);
          }

          C.iushrn(1);
          D.iushrn(1);
        }
      }

      if (x.cmp(y) >= 0) {
        x.isub(y);
        A.isub(C);
        B.isub(D);
      } else {
        y.isub(x);
        C.isub(A);
        D.isub(B);
      }
    }

    return {
      a: C,
      b: D,
      gcd: y.iushln(g)
    };
  };

  // This is reduced incarnation of the binary EEA
  // above, designated to invert members of the
  // _prime_ fields F(p) at a maximal speed
  BN.prototype._invmp = function _invmp (p) {
    assert(p.negative === 0);
    assert(!p.isZero());

    var a = this;
    var b = p.clone();

    if (a.negative !== 0) {
      a = a.umod(p);
    } else {
      a = a.clone();
    }

    var x1 = new BN(1);
    var x2 = new BN(0);

    var delta = b.clone();

    while (a.cmpn(1) > 0 && b.cmpn(1) > 0) {
      for (var i = 0, im = 1; (a.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
      if (i > 0) {
        a.iushrn(i);
        while (i-- > 0) {
          if (x1.isOdd()) {
            x1.iadd(delta);
          }

          x1.iushrn(1);
        }
      }

      for (var j = 0, jm = 1; (b.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
      if (j > 0) {
        b.iushrn(j);
        while (j-- > 0) {
          if (x2.isOdd()) {
            x2.iadd(delta);
          }

          x2.iushrn(1);
        }
      }

      if (a.cmp(b) >= 0) {
        a.isub(b);
        x1.isub(x2);
      } else {
        b.isub(a);
        x2.isub(x1);
      }
    }

    var res;
    if (a.cmpn(1) === 0) {
      res = x1;
    } else {
      res = x2;
    }

    if (res.cmpn(0) < 0) {
      res.iadd(p);
    }

    return res;
  };

  BN.prototype.gcd = function gcd (num) {
    if (this.isZero()) return num.abs();
    if (num.isZero()) return this.abs();

    var a = this.clone();
    var b = num.clone();
    a.negative = 0;
    b.negative = 0;

    // Remove common factor of two
    for (var shift = 0; a.isEven() && b.isEven(); shift++) {
      a.iushrn(1);
      b.iushrn(1);
    }

    do {
      while (a.isEven()) {
        a.iushrn(1);
      }
      while (b.isEven()) {
        b.iushrn(1);
      }

      var r = a.cmp(b);
      if (r < 0) {
        // Swap `a` and `b` to make `a` always bigger than `b`
        var t = a;
        a = b;
        b = t;
      } else if (r === 0 || b.cmpn(1) === 0) {
        break;
      }

      a.isub(b);
    } while (true);

    return b.iushln(shift);
  };

  // Invert number in the field F(num)
  BN.prototype.invm = function invm (num) {
    return this.egcd(num).a.umod(num);
  };

  BN.prototype.isEven = function isEven () {
    return (this.words[0] & 1) === 0;
  };

  BN.prototype.isOdd = function isOdd () {
    return (this.words[0] & 1) === 1;
  };

  // And first word and num
  BN.prototype.andln = function andln (num) {
    return this.words[0] & num;
  };

  // Increment at the bit position in-line
  BN.prototype.bincn = function bincn (bit) {
    assert(typeof bit === 'number');
    var r = bit % 26;
    var s = (bit - r) / 26;
    var q = 1 << r;

    // Fast case: bit is much higher than all existing words
    if (this.length <= s) {
      this._expand(s + 1);
      this.words[s] |= q;
      return this;
    }

    // Add bit and propagate, if needed
    var carry = q;
    for (var i = s; carry !== 0 && i < this.length; i++) {
      var w = this.words[i] | 0;
      w += carry;
      carry = w >>> 26;
      w &= 0x3ffffff;
      this.words[i] = w;
    }
    if (carry !== 0) {
      this.words[i] = carry;
      this.length++;
    }
    return this;
  };

  BN.prototype.isZero = function isZero () {
    return this.length === 1 && this.words[0] === 0;
  };

  BN.prototype.cmpn = function cmpn (num) {
    var negative = num < 0;

    if (this.negative !== 0 && !negative) return -1;
    if (this.negative === 0 && negative) return 1;

    this.strip();

    var res;
    if (this.length > 1) {
      res = 1;
    } else {
      if (negative) {
        num = -num;
      }

      assert(num <= 0x3ffffff, 'Number is too big');

      var w = this.words[0] | 0;
      res = w === num ? 0 : w < num ? -1 : 1;
    }
    if (this.negative !== 0) return -res | 0;
    return res;
  };

  // Compare two numbers and return:
  // 1 - if `this` > `num`
  // 0 - if `this` == `num`
  // -1 - if `this` < `num`
  BN.prototype.cmp = function cmp (num) {
    if (this.negative !== 0 && num.negative === 0) return -1;
    if (this.negative === 0 && num.negative !== 0) return 1;

    var res = this.ucmp(num);
    if (this.negative !== 0) return -res | 0;
    return res;
  };

  // Unsigned comparison
  BN.prototype.ucmp = function ucmp (num) {
    // At this point both numbers have the same sign
    if (this.length > num.length) return 1;
    if (this.length < num.length) return -1;

    var res = 0;
    for (var i = this.length - 1; i >= 0; i--) {
      var a = this.words[i] | 0;
      var b = num.words[i] | 0;

      if (a === b) continue;
      if (a < b) {
        res = -1;
      } else if (a > b) {
        res = 1;
      }
      break;
    }
    return res;
  };

  BN.prototype.gtn = function gtn (num) {
    return this.cmpn(num) === 1;
  };

  BN.prototype.gt = function gt (num) {
    return this.cmp(num) === 1;
  };

  BN.prototype.gten = function gten (num) {
    return this.cmpn(num) >= 0;
  };

  BN.prototype.gte = function gte (num) {
    return this.cmp(num) >= 0;
  };

  BN.prototype.ltn = function ltn (num) {
    return this.cmpn(num) === -1;
  };

  BN.prototype.lt = function lt (num) {
    return this.cmp(num) === -1;
  };

  BN.prototype.lten = function lten (num) {
    return this.cmpn(num) <= 0;
  };

  BN.prototype.lte = function lte (num) {
    return this.cmp(num) <= 0;
  };

  BN.prototype.eqn = function eqn (num) {
    return this.cmpn(num) === 0;
  };

  BN.prototype.eq = function eq (num) {
    return this.cmp(num) === 0;
  };

  //
  // A reduce context, could be using montgomery or something better, depending
  // on the `m` itself.
  //
  BN.red = function red (num) {
    return new Red(num);
  };

  BN.prototype.toRed = function toRed (ctx) {
    assert(!this.red, 'Already a number in reduction context');
    assert(this.negative === 0, 'red works only with positives');
    return ctx.convertTo(this)._forceRed(ctx);
  };

  BN.prototype.fromRed = function fromRed () {
    assert(this.red, 'fromRed works only with numbers in reduction context');
    return this.red.convertFrom(this);
  };

  BN.prototype._forceRed = function _forceRed (ctx) {
    this.red = ctx;
    return this;
  };

  BN.prototype.forceRed = function forceRed (ctx) {
    assert(!this.red, 'Already a number in reduction context');
    return this._forceRed(ctx);
  };

  BN.prototype.redAdd = function redAdd (num) {
    assert(this.red, 'redAdd works only with red numbers');
    return this.red.add(this, num);
  };

  BN.prototype.redIAdd = function redIAdd (num) {
    assert(this.red, 'redIAdd works only with red numbers');
    return this.red.iadd(this, num);
  };

  BN.prototype.redSub = function redSub (num) {
    assert(this.red, 'redSub works only with red numbers');
    return this.red.sub(this, num);
  };

  BN.prototype.redISub = function redISub (num) {
    assert(this.red, 'redISub works only with red numbers');
    return this.red.isub(this, num);
  };

  BN.prototype.redShl = function redShl (num) {
    assert(this.red, 'redShl works only with red numbers');
    return this.red.shl(this, num);
  };

  BN.prototype.redMul = function redMul (num) {
    assert(this.red, 'redMul works only with red numbers');
    this.red._verify2(this, num);
    return this.red.mul(this, num);
  };

  BN.prototype.redIMul = function redIMul (num) {
    assert(this.red, 'redMul works only with red numbers');
    this.red._verify2(this, num);
    return this.red.imul(this, num);
  };

  BN.prototype.redSqr = function redSqr () {
    assert(this.red, 'redSqr works only with red numbers');
    this.red._verify1(this);
    return this.red.sqr(this);
  };

  BN.prototype.redISqr = function redISqr () {
    assert(this.red, 'redISqr works only with red numbers');
    this.red._verify1(this);
    return this.red.isqr(this);
  };

  // Square root over p
  BN.prototype.redSqrt = function redSqrt () {
    assert(this.red, 'redSqrt works only with red numbers');
    this.red._verify1(this);
    return this.red.sqrt(this);
  };

  BN.prototype.redInvm = function redInvm () {
    assert(this.red, 'redInvm works only with red numbers');
    this.red._verify1(this);
    return this.red.invm(this);
  };

  // Return negative clone of `this` % `red modulo`
  BN.prototype.redNeg = function redNeg () {
    assert(this.red, 'redNeg works only with red numbers');
    this.red._verify1(this);
    return this.red.neg(this);
  };

  BN.prototype.redPow = function redPow (num) {
    assert(this.red && !num.red, 'redPow(normalNum)');
    this.red._verify1(this);
    return this.red.pow(this, num);
  };

  // Prime numbers with efficient reduction
  var primes = {
    k256: null,
    p224: null,
    p192: null,
    p25519: null
  };

  // Pseudo-Mersenne prime
  function MPrime (name, p) {
    // P = 2 ^ N - K
    this.name = name;
    this.p = new BN(p, 16);
    this.n = this.p.bitLength();
    this.k = new BN(1).iushln(this.n).isub(this.p);

    this.tmp = this._tmp();
  }

  MPrime.prototype._tmp = function _tmp () {
    var tmp = new BN(null);
    tmp.words = new Array(Math.ceil(this.n / 13));
    return tmp;
  };

  MPrime.prototype.ireduce = function ireduce (num) {
    // Assumes that `num` is less than `P^2`
    // num = HI * (2 ^ N - K) + HI * K + LO = HI * K + LO (mod P)
    var r = num;
    var rlen;

    do {
      this.split(r, this.tmp);
      r = this.imulK(r);
      r = r.iadd(this.tmp);
      rlen = r.bitLength();
    } while (rlen > this.n);

    var cmp = rlen < this.n ? -1 : r.ucmp(this.p);
    if (cmp === 0) {
      r.words[0] = 0;
      r.length = 1;
    } else if (cmp > 0) {
      r.isub(this.p);
    } else {
      if (r.strip !== undefined) {
        // r is BN v4 instance
        r.strip();
      } else {
        // r is BN v5 instance
        r._strip();
      }
    }

    return r;
  };

  MPrime.prototype.split = function split (input, out) {
    input.iushrn(this.n, 0, out);
  };

  MPrime.prototype.imulK = function imulK (num) {
    return num.imul(this.k);
  };

  function K256 () {
    MPrime.call(
      this,
      'k256',
      'ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f');
  }
  inherits(K256, MPrime);

  K256.prototype.split = function split (input, output) {
    // 256 = 9 * 26 + 22
    var mask = 0x3fffff;

    var outLen = Math.min(input.length, 9);
    for (var i = 0; i < outLen; i++) {
      output.words[i] = input.words[i];
    }
    output.length = outLen;

    if (input.length <= 9) {
      input.words[0] = 0;
      input.length = 1;
      return;
    }

    // Shift by 9 limbs
    var prev = input.words[9];
    output.words[output.length++] = prev & mask;

    for (i = 10; i < input.length; i++) {
      var next = input.words[i] | 0;
      input.words[i - 10] = ((next & mask) << 4) | (prev >>> 22);
      prev = next;
    }
    prev >>>= 22;
    input.words[i - 10] = prev;
    if (prev === 0 && input.length > 10) {
      input.length -= 10;
    } else {
      input.length -= 9;
    }
  };

  K256.prototype.imulK = function imulK (num) {
    // K = 0x1000003d1 = [ 0x40, 0x3d1 ]
    num.words[num.length] = 0;
    num.words[num.length + 1] = 0;
    num.length += 2;

    // bounded at: 0x40 * 0x3ffffff + 0x3d0 = 0x100000390
    var lo = 0;
    for (var i = 0; i < num.length; i++) {
      var w = num.words[i] | 0;
      lo += w * 0x3d1;
      num.words[i] = lo & 0x3ffffff;
      lo = w * 0x40 + ((lo / 0x4000000) | 0);
    }

    // Fast length reduction
    if (num.words[num.length - 1] === 0) {
      num.length--;
      if (num.words[num.length - 1] === 0) {
        num.length--;
      }
    }
    return num;
  };

  function P224 () {
    MPrime.call(
      this,
      'p224',
      'ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001');
  }
  inherits(P224, MPrime);

  function P192 () {
    MPrime.call(
      this,
      'p192',
      'ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff');
  }
  inherits(P192, MPrime);

  function P25519 () {
    // 2 ^ 255 - 19
    MPrime.call(
      this,
      '25519',
      '7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed');
  }
  inherits(P25519, MPrime);

  P25519.prototype.imulK = function imulK (num) {
    // K = 0x13
    var carry = 0;
    for (var i = 0; i < num.length; i++) {
      var hi = (num.words[i] | 0) * 0x13 + carry;
      var lo = hi & 0x3ffffff;
      hi >>>= 26;

      num.words[i] = lo;
      carry = hi;
    }
    if (carry !== 0) {
      num.words[num.length++] = carry;
    }
    return num;
  };

  // Exported mostly for testing purposes, use plain name instead
  BN._prime = function prime (name) {
    // Cached version of prime
    if (primes[name]) return primes[name];

    var prime;
    if (name === 'k256') {
      prime = new K256();
    } else if (name === 'p224') {
      prime = new P224();
    } else if (name === 'p192') {
      prime = new P192();
    } else if (name === 'p25519') {
      prime = new P25519();
    } else {
      throw new Error('Unknown prime ' + name);
    }
    primes[name] = prime;

    return prime;
  };

  //
  // Base reduction engine
  //
  function Red (m) {
    if (typeof m === 'string') {
      var prime = BN._prime(m);
      this.m = prime.p;
      this.prime = prime;
    } else {
      assert(m.gtn(1), 'modulus must be greater than 1');
      this.m = m;
      this.prime = null;
    }
  }

  Red.prototype._verify1 = function _verify1 (a) {
    assert(a.negative === 0, 'red works only with positives');
    assert(a.red, 'red works only with red numbers');
  };

  Red.prototype._verify2 = function _verify2 (a, b) {
    assert((a.negative | b.negative) === 0, 'red works only with positives');
    assert(a.red && a.red === b.red,
      'red works only with red numbers');
  };

  Red.prototype.imod = function imod (a) {
    if (this.prime) return this.prime.ireduce(a)._forceRed(this);
    return a.umod(this.m)._forceRed(this);
  };

  Red.prototype.neg = function neg (a) {
    if (a.isZero()) {
      return a.clone();
    }

    return this.m.sub(a)._forceRed(this);
  };

  Red.prototype.add = function add (a, b) {
    this._verify2(a, b);

    var res = a.add(b);
    if (res.cmp(this.m) >= 0) {
      res.isub(this.m);
    }
    return res._forceRed(this);
  };

  Red.prototype.iadd = function iadd (a, b) {
    this._verify2(a, b);

    var res = a.iadd(b);
    if (res.cmp(this.m) >= 0) {
      res.isub(this.m);
    }
    return res;
  };

  Red.prototype.sub = function sub (a, b) {
    this._verify2(a, b);

    var res = a.sub(b);
    if (res.cmpn(0) < 0) {
      res.iadd(this.m);
    }
    return res._forceRed(this);
  };

  Red.prototype.isub = function isub (a, b) {
    this._verify2(a, b);

    var res = a.isub(b);
    if (res.cmpn(0) < 0) {
      res.iadd(this.m);
    }
    return res;
  };

  Red.prototype.shl = function shl (a, num) {
    this._verify1(a);
    return this.imod(a.ushln(num));
  };

  Red.prototype.imul = function imul (a, b) {
    this._verify2(a, b);
    return this.imod(a.imul(b));
  };

  Red.prototype.mul = function mul (a, b) {
    this._verify2(a, b);
    return this.imod(a.mul(b));
  };

  Red.prototype.isqr = function isqr (a) {
    return this.imul(a, a.clone());
  };

  Red.prototype.sqr = function sqr (a) {
    return this.mul(a, a);
  };

  Red.prototype.sqrt = function sqrt (a) {
    if (a.isZero()) return a.clone();

    var mod3 = this.m.andln(3);
    assert(mod3 % 2 === 1);

    // Fast case
    if (mod3 === 3) {
      var pow = this.m.add(new BN(1)).iushrn(2);
      return this.pow(a, pow);
    }

    // Tonelli-Shanks algorithm (Totally unoptimized and slow)
    //
    // Find Q and S, that Q * 2 ^ S = (P - 1)
    var q = this.m.subn(1);
    var s = 0;
    while (!q.isZero() && q.andln(1) === 0) {
      s++;
      q.iushrn(1);
    }
    assert(!q.isZero());

    var one = new BN(1).toRed(this);
    var nOne = one.redNeg();

    // Find quadratic non-residue
    // NOTE: Max is such because of generalized Riemann hypothesis.
    var lpow = this.m.subn(1).iushrn(1);
    var z = this.m.bitLength();
    z = new BN(2 * z * z).toRed(this);

    while (this.pow(z, lpow).cmp(nOne) !== 0) {
      z.redIAdd(nOne);
    }

    var c = this.pow(z, q);
    var r = this.pow(a, q.addn(1).iushrn(1));
    var t = this.pow(a, q);
    var m = s;
    while (t.cmp(one) !== 0) {
      var tmp = t;
      for (var i = 0; tmp.cmp(one) !== 0; i++) {
        tmp = tmp.redSqr();
      }
      assert(i < m);
      var b = this.pow(c, new BN(1).iushln(m - i - 1));

      r = r.redMul(b);
      c = b.redSqr();
      t = t.redMul(c);
      m = i;
    }

    return r;
  };

  Red.prototype.invm = function invm (a) {
    var inv = a._invmp(this.m);
    if (inv.negative !== 0) {
      inv.negative = 0;
      return this.imod(inv).redNeg();
    } else {
      return this.imod(inv);
    }
  };

  Red.prototype.pow = function pow (a, num) {
    if (num.isZero()) return new BN(1).toRed(this);
    if (num.cmpn(1) === 0) return a.clone();

    var windowSize = 4;
    var wnd = new Array(1 << windowSize);
    wnd[0] = new BN(1).toRed(this);
    wnd[1] = a;
    for (var i = 2; i < wnd.length; i++) {
      wnd[i] = this.mul(wnd[i - 1], a);
    }

    var res = wnd[0];
    var current = 0;
    var currentLen = 0;
    var start = num.bitLength() % 26;
    if (start === 0) {
      start = 26;
    }

    for (i = num.length - 1; i >= 0; i--) {
      var word = num.words[i];
      for (var j = start - 1; j >= 0; j--) {
        var bit = (word >> j) & 1;
        if (res !== wnd[0]) {
          res = this.sqr(res);
        }

        if (bit === 0 && current === 0) {
          currentLen = 0;
          continue;
        }

        current <<= 1;
        current |= bit;
        currentLen++;
        if (currentLen !== windowSize && (i !== 0 || j !== 0)) continue;

        res = this.mul(res, wnd[current]);
        currentLen = 0;
        current = 0;
      }
      start = 26;
    }

    return res;
  };

  Red.prototype.convertTo = function convertTo (num) {
    var r = num.umod(this.m);

    return r === num ? r.clone() : r;
  };

  Red.prototype.convertFrom = function convertFrom (num) {
    var res = num.clone();
    res.red = null;
    return res;
  };

  //
  // Montgomery method engine
  //

  BN.mont = function mont (num) {
    return new Mont(num);
  };

  function Mont (m) {
    Red.call(this, m);

    this.shift = this.m.bitLength();
    if (this.shift % 26 !== 0) {
      this.shift += 26 - (this.shift % 26);
    }

    this.r = new BN(1).iushln(this.shift);
    this.r2 = this.imod(this.r.sqr());
    this.rinv = this.r._invmp(this.m);

    this.minv = this.rinv.mul(this.r).isubn(1).div(this.m);
    this.minv = this.minv.umod(this.r);
    this.minv = this.r.sub(this.minv);
  }
  inherits(Mont, Red);

  Mont.prototype.convertTo = function convertTo (num) {
    return this.imod(num.ushln(this.shift));
  };

  Mont.prototype.convertFrom = function convertFrom (num) {
    var r = this.imod(num.mul(this.rinv));
    r.red = null;
    return r;
  };

  Mont.prototype.imul = function imul (a, b) {
    if (a.isZero() || b.isZero()) {
      a.words[0] = 0;
      a.length = 1;
      return a;
    }

    var t = a.imul(b);
    var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
    var u = t.isub(c).iushrn(this.shift);
    var res = u;

    if (u.cmp(this.m) >= 0) {
      res = u.isub(this.m);
    } else if (u.cmpn(0) < 0) {
      res = u.iadd(this.m);
    }

    return res._forceRed(this);
  };

  Mont.prototype.mul = function mul (a, b) {
    if (a.isZero() || b.isZero()) return new BN(0)._forceRed(this);

    var t = a.mul(b);
    var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
    var u = t.isub(c).iushrn(this.shift);
    var res = u;
    if (u.cmp(this.m) >= 0) {
      res = u.isub(this.m);
    } else if (u.cmpn(0) < 0) {
      res = u.iadd(this.m);
    }

    return res._forceRed(this);
  };

  Mont.prototype.invm = function invm (a) {
    // (AR)^-1 * R^2 = (A^-1 * R^-1) * R^2 = A^-1 * R
    var res = this.imod(a._invmp(this.m).mul(this.r2));
    return res._forceRed(this);
  };
})( false || module, this);

/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(/*! ./../../../../webpack/buildin/module.js */ "./node_modules/webpack/buildin/module.js")(module)))

/***/ }),

/***/ "./node_modules/elliptic/package.json":
/*!********************************************!*\
  !*** ./node_modules/elliptic/package.json ***!
  \********************************************/
/*! exports provided: _args, _development, _from, _id, _inBundle, _integrity, _location, _phantomChildren, _requested, _requiredBy, _resolved, _spec, _where, author, bugs, dependencies, description, devDependencies, files, homepage, keywords, license, main, name, repository, scripts, version, default */
/***/ (function(module) {

module.exports = JSON.parse("{\"_args\":[[\"elliptic@6.5.3\",\"/home/khaos/syncfolder/phd/projects/www/molstar\"]],\"_development\":true,\"_from\":\"elliptic@6.5.3\",\"_id\":\"elliptic@6.5.3\",\"_inBundle\":false,\"_integrity\":\"sha512-IMqzv5wNQf+E6aHeIqATs0tOLeOTwj1QKbRcS3jBbYkl5oLAserA8yJTT7/VyHUYG91PRmPyeQDObKLPpeS4dw==\",\"_location\":\"/elliptic\",\"_phantomChildren\":{},\"_requested\":{\"type\":\"version\",\"registry\":true,\"raw\":\"elliptic@6.5.3\",\"name\":\"elliptic\",\"escapedName\":\"elliptic\",\"rawSpec\":\"6.5.3\",\"saveSpec\":null,\"fetchSpec\":\"6.5.3\"},\"_requiredBy\":[\"/browserify-sign\",\"/create-ecdh\"],\"_resolved\":\"https://registry.npmjs.org/elliptic/-/elliptic-6.5.3.tgz\",\"_spec\":\"6.5.3\",\"_where\":\"/home/khaos/syncfolder/phd/projects/www/molstar\",\"author\":{\"name\":\"Fedor Indutny\",\"email\":\"fedor@indutny.com\"},\"bugs\":{\"url\":\"https://github.com/indutny/elliptic/issues\"},\"dependencies\":{\"bn.js\":\"^4.4.0\",\"brorand\":\"^1.0.1\",\"hash.js\":\"^1.0.0\",\"hmac-drbg\":\"^1.0.0\",\"inherits\":\"^2.0.1\",\"minimalistic-assert\":\"^1.0.0\",\"minimalistic-crypto-utils\":\"^1.0.0\"},\"description\":\"EC cryptography\",\"devDependencies\":{\"brfs\":\"^1.4.3\",\"coveralls\":\"^3.0.8\",\"grunt\":\"^1.0.4\",\"grunt-browserify\":\"^5.0.0\",\"grunt-cli\":\"^1.2.0\",\"grunt-contrib-connect\":\"^1.0.0\",\"grunt-contrib-copy\":\"^1.0.0\",\"grunt-contrib-uglify\":\"^1.0.1\",\"grunt-mocha-istanbul\":\"^3.0.1\",\"grunt-saucelabs\":\"^9.0.1\",\"istanbul\":\"^0.4.2\",\"jscs\":\"^3.0.7\",\"jshint\":\"^2.10.3\",\"mocha\":\"^6.2.2\"},\"files\":[\"lib\"],\"homepage\":\"https://github.com/indutny/elliptic\",\"keywords\":[\"EC\",\"Elliptic\",\"curve\",\"Cryptography\"],\"license\":\"MIT\",\"main\":\"lib/elliptic.js\",\"name\":\"elliptic\",\"repository\":{\"type\":\"git\",\"url\":\"git+ssh://git@github.com/indutny/elliptic.git\"},\"scripts\":{\"jscs\":\"jscs benchmarks/*.js lib/*.js lib/**/*.js lib/**/**/*.js test/index.js\",\"jshint\":\"jscs benchmarks/*.js lib/*.js lib/**/*.js lib/**/**/*.js test/index.js\",\"lint\":\"npm run jscs && npm run jshint\",\"test\":\"npm run lint && npm run unit\",\"unit\":\"istanbul test _mocha --reporter=spec test/index.js\",\"version\":\"grunt dist && git add dist/\"},\"version\":\"6.5.3\"}");

/***/ }),

/***/ "./node_modules/events/events.js":
/*!***************************************!*\
  !*** ./node_modules/events/events.js ***!
  \***************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.



var R = typeof Reflect === 'object' ? Reflect : null
var ReflectApply = R && typeof R.apply === 'function'
  ? R.apply
  : function ReflectApply(target, receiver, args) {
    return Function.prototype.apply.call(target, receiver, args);
  }

var ReflectOwnKeys
if (R && typeof R.ownKeys === 'function') {
  ReflectOwnKeys = R.ownKeys
} else if (Object.getOwnPropertySymbols) {
  ReflectOwnKeys = function ReflectOwnKeys(target) {
    return Object.getOwnPropertyNames(target)
      .concat(Object.getOwnPropertySymbols(target));
  };
} else {
  ReflectOwnKeys = function ReflectOwnKeys(target) {
    return Object.getOwnPropertyNames(target);
  };
}

function ProcessEmitWarning(warning) {
  if (console && console.warn) console.warn(warning);
}

var NumberIsNaN = Number.isNaN || function NumberIsNaN(value) {
  return value !== value;
}

function EventEmitter() {
  EventEmitter.init.call(this);
}
module.exports = EventEmitter;
module.exports.once = once;

// Backwards-compat with node 0.10.x
EventEmitter.EventEmitter = EventEmitter;

EventEmitter.prototype._events = undefined;
EventEmitter.prototype._eventsCount = 0;
EventEmitter.prototype._maxListeners = undefined;

// By default EventEmitters will print a warning if more than 10 listeners are
// added to it. This is a useful default which helps finding memory leaks.
var defaultMaxListeners = 10;

function checkListener(listener) {
  if (typeof listener !== 'function') {
    throw new TypeError('The "listener" argument must be of type Function. Received type ' + typeof listener);
  }
}

Object.defineProperty(EventEmitter, 'defaultMaxListeners', {
  enumerable: true,
  get: function() {
    return defaultMaxListeners;
  },
  set: function(arg) {
    if (typeof arg !== 'number' || arg < 0 || NumberIsNaN(arg)) {
      throw new RangeError('The value of "defaultMaxListeners" is out of range. It must be a non-negative number. Received ' + arg + '.');
    }
    defaultMaxListeners = arg;
  }
});

EventEmitter.init = function() {

  if (this._events === undefined ||
      this._events === Object.getPrototypeOf(this)._events) {
    this._events = Object.create(null);
    this._eventsCount = 0;
  }

  this._maxListeners = this._maxListeners || undefined;
};

// Obviously not all Emitters should be limited to 10. This function allows
// that to be increased. Set to zero for unlimited.
EventEmitter.prototype.setMaxListeners = function setMaxListeners(n) {
  if (typeof n !== 'number' || n < 0 || NumberIsNaN(n)) {
    throw new RangeError('The value of "n" is out of range. It must be a non-negative number. Received ' + n + '.');
  }
  this._maxListeners = n;
  return this;
};

function _getMaxListeners(that) {
  if (that._maxListeners === undefined)
    return EventEmitter.defaultMaxListeners;
  return that._maxListeners;
}

EventEmitter.prototype.getMaxListeners = function getMaxListeners() {
  return _getMaxListeners(this);
};

EventEmitter.prototype.emit = function emit(type) {
  var args = [];
  for (var i = 1; i < arguments.length; i++) args.push(arguments[i]);
  var doError = (type === 'error');

  var events = this._events;
  if (events !== undefined)
    doError = (doError && events.error === undefined);
  else if (!doError)
    return false;

  // If there is no 'error' event listener then throw.
  if (doError) {
    var er;
    if (args.length > 0)
      er = args[0];
    if (er instanceof Error) {
      // Note: The comments on the `throw` lines are intentional, they show
      // up in Node's output if this results in an unhandled exception.
      throw er; // Unhandled 'error' event
    }
    // At least give some kind of context to the user
    var err = new Error('Unhandled error.' + (er ? ' (' + er.message + ')' : ''));
    err.context = er;
    throw err; // Unhandled 'error' event
  }

  var handler = events[type];

  if (handler === undefined)
    return false;

  if (typeof handler === 'function') {
    ReflectApply(handler, this, args);
  } else {
    var len = handler.length;
    var listeners = arrayClone(handler, len);
    for (var i = 0; i < len; ++i)
      ReflectApply(listeners[i], this, args);
  }

  return true;
};

function _addListener(target, type, listener, prepend) {
  var m;
  var events;
  var existing;

  checkListener(listener);

  events = target._events;
  if (events === undefined) {
    events = target._events = Object.create(null);
    target._eventsCount = 0;
  } else {
    // To avoid recursion in the case that type === "newListener"! Before
    // adding it to the listeners, first emit "newListener".
    if (events.newListener !== undefined) {
      target.emit('newListener', type,
                  listener.listener ? listener.listener : listener);

      // Re-assign `events` because a newListener handler could have caused the
      // this._events to be assigned to a new object
      events = target._events;
    }
    existing = events[type];
  }

  if (existing === undefined) {
    // Optimize the case of one listener. Don't need the extra array object.
    existing = events[type] = listener;
    ++target._eventsCount;
  } else {
    if (typeof existing === 'function') {
      // Adding the second element, need to change to array.
      existing = events[type] =
        prepend ? [listener, existing] : [existing, listener];
      // If we've already got an array, just append.
    } else if (prepend) {
      existing.unshift(listener);
    } else {
      existing.push(listener);
    }

    // Check for listener leak
    m = _getMaxListeners(target);
    if (m > 0 && existing.length > m && !existing.warned) {
      existing.warned = true;
      // No error code for this since it is a Warning
      // eslint-disable-next-line no-restricted-syntax
      var w = new Error('Possible EventEmitter memory leak detected. ' +
                          existing.length + ' ' + String(type) + ' listeners ' +
                          'added. Use emitter.setMaxListeners() to ' +
                          'increase limit');
      w.name = 'MaxListenersExceededWarning';
      w.emitter = target;
      w.type = type;
      w.count = existing.length;
      ProcessEmitWarning(w);
    }
  }

  return target;
}

EventEmitter.prototype.addListener = function addListener(type, listener) {
  return _addListener(this, type, listener, false);
};

EventEmitter.prototype.on = EventEmitter.prototype.addListener;

EventEmitter.prototype.prependListener =
    function prependListener(type, listener) {
      return _addListener(this, type, listener, true);
    };

function onceWrapper() {
  if (!this.fired) {
    this.target.removeListener(this.type, this.wrapFn);
    this.fired = true;
    if (arguments.length === 0)
      return this.listener.call(this.target);
    return this.listener.apply(this.target, arguments);
  }
}

function _onceWrap(target, type, listener) {
  var state = { fired: false, wrapFn: undefined, target: target, type: type, listener: listener };
  var wrapped = onceWrapper.bind(state);
  wrapped.listener = listener;
  state.wrapFn = wrapped;
  return wrapped;
}

EventEmitter.prototype.once = function once(type, listener) {
  checkListener(listener);
  this.on(type, _onceWrap(this, type, listener));
  return this;
};

EventEmitter.prototype.prependOnceListener =
    function prependOnceListener(type, listener) {
      checkListener(listener);
      this.prependListener(type, _onceWrap(this, type, listener));
      return this;
    };

// Emits a 'removeListener' event if and only if the listener was removed.
EventEmitter.prototype.removeListener =
    function removeListener(type, listener) {
      var list, events, position, i, originalListener;

      checkListener(listener);

      events = this._events;
      if (events === undefined)
        return this;

      list = events[type];
      if (list === undefined)
        return this;

      if (list === listener || list.listener === listener) {
        if (--this._eventsCount === 0)
          this._events = Object.create(null);
        else {
          delete events[type];
          if (events.removeListener)
            this.emit('removeListener', type, list.listener || listener);
        }
      } else if (typeof list !== 'function') {
        position = -1;

        for (i = list.length - 1; i >= 0; i--) {
          if (list[i] === listener || list[i].listener === listener) {
            originalListener = list[i].listener;
            position = i;
            break;
          }
        }

        if (position < 0)
          return this;

        if (position === 0)
          list.shift();
        else {
          spliceOne(list, position);
        }

        if (list.length === 1)
          events[type] = list[0];

        if (events.removeListener !== undefined)
          this.emit('removeListener', type, originalListener || listener);
      }

      return this;
    };

EventEmitter.prototype.off = EventEmitter.prototype.removeListener;

EventEmitter.prototype.removeAllListeners =
    function removeAllListeners(type) {
      var listeners, events, i;

      events = this._events;
      if (events === undefined)
        return this;

      // not listening for removeListener, no need to emit
      if (events.removeListener === undefined) {
        if (arguments.length === 0) {
          this._events = Object.create(null);
          this._eventsCount = 0;
        } else if (events[type] !== undefined) {
          if (--this._eventsCount === 0)
            this._events = Object.create(null);
          else
            delete events[type];
        }
        return this;
      }

      // emit removeListener for all listeners on all events
      if (arguments.length === 0) {
        var keys = Object.keys(events);
        var key;
        for (i = 0; i < keys.length; ++i) {
          key = keys[i];
          if (key === 'removeListener') continue;
          this.removeAllListeners(key);
        }
        this.removeAllListeners('removeListener');
        this._events = Object.create(null);
        this._eventsCount = 0;
        return this;
      }

      listeners = events[type];

      if (typeof listeners === 'function') {
        this.removeListener(type, listeners);
      } else if (listeners !== undefined) {
        // LIFO order
        for (i = listeners.length - 1; i >= 0; i--) {
          this.removeListener(type, listeners[i]);
        }
      }

      return this;
    };

function _listeners(target, type, unwrap) {
  var events = target._events;

  if (events === undefined)
    return [];

  var evlistener = events[type];
  if (evlistener === undefined)
    return [];

  if (typeof evlistener === 'function')
    return unwrap ? [evlistener.listener || evlistener] : [evlistener];

  return unwrap ?
    unwrapListeners(evlistener) : arrayClone(evlistener, evlistener.length);
}

EventEmitter.prototype.listeners = function listeners(type) {
  return _listeners(this, type, true);
};

EventEmitter.prototype.rawListeners = function rawListeners(type) {
  return _listeners(this, type, false);
};

EventEmitter.listenerCount = function(emitter, type) {
  if (typeof emitter.listenerCount === 'function') {
    return emitter.listenerCount(type);
  } else {
    return listenerCount.call(emitter, type);
  }
};

EventEmitter.prototype.listenerCount = listenerCount;
function listenerCount(type) {
  var events = this._events;

  if (events !== undefined) {
    var evlistener = events[type];

    if (typeof evlistener === 'function') {
      return 1;
    } else if (evlistener !== undefined) {
      return evlistener.length;
    }
  }

  return 0;
}

EventEmitter.prototype.eventNames = function eventNames() {
  return this._eventsCount > 0 ? ReflectOwnKeys(this._events) : [];
};

function arrayClone(arr, n) {
  var copy = new Array(n);
  for (var i = 0; i < n; ++i)
    copy[i] = arr[i];
  return copy;
}

function spliceOne(list, index) {
  for (; index + 1 < list.length; index++)
    list[index] = list[index + 1];
  list.pop();
}

function unwrapListeners(arr) {
  var ret = new Array(arr.length);
  for (var i = 0; i < ret.length; ++i) {
    ret[i] = arr[i].listener || arr[i];
  }
  return ret;
}

function once(emitter, name) {
  return new Promise(function (resolve, reject) {
    function eventListener() {
      if (errorListener !== undefined) {
        emitter.removeListener('error', errorListener);
      }
      resolve([].slice.call(arguments));
    };
    var errorListener;

    // Adding an error listener is not optional because
    // if an error is thrown on an event emitter we cannot
    // guarantee that the actual event we are waiting will
    // be fired. The result could be a silent way to create
    // memory or file descriptor leaks, which is something
    // we should avoid.
    if (name !== 'error') {
      errorListener = function errorListener(err) {
        emitter.removeListener(name, eventListener);
        reject(err);
      };

      emitter.once('error', errorListener);
    }

    emitter.once(name, eventListener);
  });
}


/***/ }),

/***/ "./node_modules/evp_bytestokey/index.js":
/*!**********************************************!*\
  !*** ./node_modules/evp_bytestokey/index.js ***!
  \**********************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var Buffer = __webpack_require__(/*! safe-buffer */ "./node_modules/safe-buffer/index.js").Buffer
var MD5 = __webpack_require__(/*! md5.js */ "./node_modules/md5.js/index.js")

/* eslint-disable camelcase */
function EVP_BytesToKey (password, salt, keyBits, ivLen) {
  if (!Buffer.isBuffer(password)) password = Buffer.from(password, 'binary')
  if (salt) {
    if (!Buffer.isBuffer(salt)) salt = Buffer.from(salt, 'binary')
    if (salt.length !== 8) throw new RangeError('salt should be Buffer with 8 byte length')
  }

  var keyLen = keyBits / 8
  var key = Buffer.alloc(keyLen)
  var iv = Buffer.alloc(ivLen || 0)
  var tmp = Buffer.alloc(0)

  while (keyLen > 0 || ivLen > 0) {
    var hash = new MD5()
    hash.update(tmp)
    hash.update(password)
    if (salt) hash.update(salt)
    tmp = hash.digest()

    var used = 0

    if (keyLen > 0) {
      var keyStart = key.length - keyLen
      used = Math.min(keyLen, tmp.length)
      tmp.copy(key, keyStart, 0, used)
      keyLen -= used
    }

    if (used < tmp.length && ivLen > 0) {
      var ivStart = iv.length - ivLen
      var length = Math.min(ivLen, tmp.length - used)
      tmp.copy(iv, ivStart, used, used + length)
      ivLen -= length
    }
  }

  tmp.fill(0)
  return { key: key, iv: iv }
}

module.exports = EVP_BytesToKey


/***/ }),

/***/ "./node_modules/h264-mp4-encoder/embuild/dist/h264-mp4-encoder.node.js":
/*!*****************************************************************************!*\
  !*** ./node_modules/h264-mp4-encoder/embuild/dist/h264-mp4-encoder.node.js ***!
  \*****************************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(process, Buffer) {module.exports=function(A){var B={};function Q(I){if(B[I])return B[I].exports;var g=B[I]={i:I,l:!1,exports:{}};return A[I].call(g.exports,g,g.exports,Q),g.l=!0,g.exports}return Q.m=A,Q.c=B,Q.d=function(A,B,I){Q.o(A,B)||Object.defineProperty(A,B,{enumerable:!0,get:I})},Q.r=function(A){"undefined"!=typeof Symbol&&Symbol.toStringTag&&Object.defineProperty(A,Symbol.toStringTag,{value:"Module"}),Object.defineProperty(A,"__esModule",{value:!0})},Q.t=function(A,B){if(1&B&&(A=Q(A)),8&B)return A;if(4&B&&"object"==typeof A&&A&&A.__esModule)return A;var I=Object.create(null);if(Q.r(I),Object.defineProperty(I,"default",{enumerable:!0,value:A}),2&B&&"string"!=typeof A)for(var g in A)Q.d(I,g,function(B){return A[B]}.bind(null,g));return I},Q.n=function(A){var B=A&&A.__esModule?function(){return A.default}:function(){return A};return Q.d(B,"a",B),B},Q.o=function(A,B){return Object.prototype.hasOwnProperty.call(A,B)},Q.p="",Q(Q.s=2)}([function(A,B){A.exports=__webpack_require__(/*! path */ "./node_modules/path-browserify/index.js")},function(A,B,Q){(function(B,I){var g,E=(g=(g="undefined"!=typeof document&&document.currentScript?document.currentScript.src:void 0)||B,function(A){var B;A=A||{},B||(B=void 0!==A?A:{});var E,C={};for(E in B)B.hasOwnProperty(E)&&(C[E]=B[E]);var D,i,y,F,U="./this.program";D="object"==typeof window,i="function"==typeof importScripts,y="object"==typeof process&&"object"==typeof process.versions&&"string"==typeof process.versions.node,F=!D&&!y&&!i;var c,N,H,G,o="";y?(o=i?Q(0).dirname(o)+"/":I+"/",c=function(A,B){var I=_B(A);return I?B?I:I.toString():(H||(H=Q(3)),G||(G=Q(0)),A=G.normalize(A),H.readFileSync(A,B?null:"utf8"))},N=function(A){return(A=c(A,!0)).buffer||(A=new Uint8Array(A)),a(A.buffer),A},1<process.argv.length&&(U=process.argv[1].replace(/\\/g,"/")),process.argv.slice(2),process.on("uncaughtException",(function(A){throw A})),process.on("unhandledRejection",FA),B.inspect=function(){return"[Emscripten Module object]"}):F?("undefined"!=typeof read&&(c=function(A){var B=_B(A);return B?TB(B):read(A)}),N=function(A){var B;return(B=_B(A))?B:"function"==typeof readbuffer?new Uint8Array(readbuffer(A)):(a("object"==typeof(B=read(A,"binary"))),B)},"undefined"!=typeof print&&("undefined"==typeof console&&(console={}),console.log=print,console.warn=console.error="undefined"!=typeof printErr?printErr:print)):(D||i)&&(i?o=self.location.href:document.currentScript&&(o=document.currentScript.src),g&&(o=g),o=0!==o.indexOf("blob:")?o.substr(0,o.lastIndexOf("/")+1):"",c=function(A){try{var B=new XMLHttpRequest;return B.open("GET",A,!1),B.send(null),B.responseText}catch(B){if(A=_B(A))return TB(A);throw B}},i&&(N=function(A){try{var B=new XMLHttpRequest;return B.open("GET",A,!1),B.responseType="arraybuffer",B.send(null),new Uint8Array(B.response)}catch(B){if(A=_B(A))return A;throw B}}));var w=B.print||console.log.bind(console),Y=B.printErr||console.warn.bind(console);for(E in C)C.hasOwnProperty(E)&&(B[E]=C[E]);C=null,B.thisProgram&&(U=B.thisProgram);var s,L=0;B.wasmBinary&&(s=B.wasmBinary),B.noExitRuntime&&B.noExitRuntime,"object"!=typeof WebAssembly&&Y("no native wasm support detected");var R,h=new WebAssembly.Table({initial:1182,maximum:1182,element:"anyfunc"}),k=!1;function a(A,B){A||FA("Assertion failed: "+B)}var S="undefined"!=typeof TextDecoder?new TextDecoder("utf8"):void 0;function M(A,B,Q){var I=B+Q;for(Q=B;A[Q]&&!(Q>=I);)++Q;if(16<Q-B&&A.subarray&&S)return S.decode(A.subarray(B,Q));for(I="";B<Q;){var g=A[B++];if(128&g){var E=63&A[B++];if(192==(224&g))I+=String.fromCharCode((31&g)<<6|E);else{var C=63&A[B++];65536>(g=224==(240&g)?(15&g)<<12|E<<6|C:(7&g)<<18|E<<12|C<<6|63&A[B++])?I+=String.fromCharCode(g):(g-=65536,I+=String.fromCharCode(55296|g>>10,56320|1023&g))}}else I+=String.fromCharCode(g)}return I}function J(A){return A?M(d,A,void 0):""}function V(A,B,Q,I){if(!(0<I))return 0;var g=Q;I=Q+I-1;for(var E=0;E<A.length;++E){var C=A.charCodeAt(E);if(55296<=C&&57343>=C&&(C=65536+((1023&C)<<10)|1023&A.charCodeAt(++E)),127>=C){if(Q>=I)break;B[Q++]=C}else{if(2047>=C){if(Q+1>=I)break;B[Q++]=192|C>>6}else{if(65535>=C){if(Q+2>=I)break;B[Q++]=224|C>>12}else{if(Q+3>=I)break;B[Q++]=240|C>>18,B[Q++]=128|C>>12&63}B[Q++]=128|C>>6&63}B[Q++]=128|63&C}}return B[Q]=0,Q-g}function K(A){for(var B=0,Q=0;Q<A.length;++Q){var I=A.charCodeAt(Q);55296<=I&&57343>=I&&(I=65536+((1023&I)<<10)|1023&A.charCodeAt(++Q)),127>=I?++B:B=2047>=I?B+2:65535>=I?B+3:B+4}return B}var t,n,d,r,e,l,x,Z,f,b="undefined"!=typeof TextDecoder?new TextDecoder("utf-16le"):void 0;function p(A){var B;for(B=A>>1;r[B];)++B;if(32<(B<<=1)-A&&b)return b.decode(d.subarray(A,B));B=0;for(var Q="";;){var I=r[A+2*B>>1];if(0==I)return Q;++B,Q+=String.fromCharCode(I)}}function q(A,B,Q){if(void 0===Q&&(Q=2147483647),2>Q)return 0;var I=B;Q=(Q-=2)<2*A.length?Q/2:A.length;for(var g=0;g<Q;++g)r[B>>1]=A.charCodeAt(g),B+=2;return r[B>>1]=0,B-I}function u(A){return 2*A.length}function O(A){for(var B=0,Q="";;){var I=l[A+4*B>>2];if(0==I)return Q;++B,65536<=I?(I-=65536,Q+=String.fromCharCode(55296|I>>10,56320|1023&I)):Q+=String.fromCharCode(I)}}function m(A,B,Q){if(void 0===Q&&(Q=2147483647),4>Q)return 0;var I=B;Q=I+Q-4;for(var g=0;g<A.length;++g){var E=A.charCodeAt(g);if(55296<=E&&57343>=E&&(E=65536+((1023&E)<<10)|1023&A.charCodeAt(++g)),l[B>>2]=E,(B+=4)+4>Q)break}return l[B>>2]=0,B-I}function W(A){for(var B=0,Q=0;Q<A.length;++Q){var I=A.charCodeAt(Q);55296<=I&&57343>=I&&++Q,B+=4}return B}function X(A){t=A,B.HEAP8=n=new Int8Array(A),B.HEAP16=r=new Int16Array(A),B.HEAP32=l=new Int32Array(A),B.HEAPU8=d=new Uint8Array(A),B.HEAPU16=e=new Uint16Array(A),B.HEAPU32=x=new Uint32Array(A),B.HEAPF32=Z=new Float32Array(A),B.HEAPF64=f=new Float64Array(A)}var j=B.INITIAL_MEMORY||16777216;function z(A){for(;0<A.length;){var Q=A.shift();if("function"==typeof Q)Q(B);else{var I=Q.ob;"number"==typeof I?void 0===Q.ua?B.dynCall_v(I):B.dynCall_vi(I,Q.ua):I(void 0===Q.ua?null:Q.ua)}}}(R=B.wasmMemory?B.wasmMemory:new WebAssembly.Memory({initial:j/65536,maximum:32768}))&&(t=R.buffer),j=t.byteLength,X(t),l[22752]=5334064;var v=[],T=[],P=[],_=[],$=[];function AA(){var A=B.preRun.shift();v.unshift(A)}var BA=Math.abs,QA=Math.ceil,IA=Math.floor,gA=Math.min,EA=0,CA=null,DA=null;function iA(){EA++,B.monitorRunDependencies&&B.monitorRunDependencies(EA)}function yA(){if(EA--,B.monitorRunDependencies&&B.monitorRunDependencies(EA),0==EA&&(null!==CA&&(clearInterval(CA),CA=null),DA)){var A=DA;DA=null,A()}}function FA(A){throw B.onAbort&&B.onAbort(A),w(A),Y(A),k=!0,new WebAssembly.RuntimeError("abort("+A+"). Build with -s ASSERTIONS=1 for more info.")}function UA(A,B){return String.prototype.startsWith?A.startsWith(B):0===A.indexOf(B)}B.preloadedImages={},B.preloadedAudios={};var cA,NA,HA="data:application/octet-stream;base64,",GA="data:application/octet-stream;base64,AGFzbQEAAAABqwVRYAF/AX9gAX8AYAJ/fwBgAn9/AX9gA39/fwF/YAN/f38AYAAAYAR/f39/AGAFf39/f38Bf2AGf39/f39/AX9gBH9/f38Bf2AFf39/f38AYAZ/f39/f38AYAABf2AIf39/f39/f38Bf2AHf39/f39/fwF/YAV/f35/fgF/YAd/f39/f39/AGAKf39/f39/f39/fwBgAn9+AX9gBX9/fn9/AGAFf39/f34Bf2ACf38BfmAIf39/f39/f38AYAN/fn8AYAV/fn5+fgBgC39/f39/f39/f39/AX9gA39+fwF+YAJ/fgBgDH9/f39/f39/f39/fwF/YAV/f39/fAF/YAR/f39/AX5gAn99AGAKf39/f39/f39/fwF/YAF/AX5gD39/f39/f39/f39/f39/fwBgBH9+fn8AYAd/f39/f35+AX9gBn9/f39+fgF/YAZ/fH9/f38Bf2ABfwF9YAt/f39/f39/f39/fwBgEH9/f39/f39/f39/f39/f38AYAd/f39/fn5/AGADf39+AGAJf39/f39/f39/AX9gBn9/f39/fAF/YAl/f35/f39/f38Bf2ADf399AX9gA39+fwF/YAd/fn9/f39/AX9gAn99AX9gAn5/AX9gAn5+AX9gAAF+YAR/f39+AX5gA39/fwF9YAR/f39/AX1gA39/fwF8YAR/f39/AXxgDX9/f39/f39/f39/f38AYAR/f39+AGAFf39/fn8AYAZ/f39+fn8AYAR/f399AGAEf39+fwBgA39+fgBgA399fwBgAn98AGANf39/f39/f39/f39/fwF/YAV/f35/fwF/YAd/f3x/f39/AX9gA35/fwF/YAR+fn5+AX9gBX9/f39/AX5gAn9/AX1gAn5+AX1gAX8BfGACf38BfGACfn4BfGACfH8BfALhDk4DZW52Fl9lbWJpbmRfcmVnaXN0ZXJfY2xhc3MAPANlbnYiX2VtYmluZF9yZWdpc3Rlcl9jbGFzc19jb25zdHJ1Y3RvcgAMA2Vudh9fZW1iaW5kX3JlZ2lzdGVyX2NsYXNzX3Byb3BlcnR5ABIDZW52H19lbWJpbmRfcmVnaXN0ZXJfY2xhc3NfZnVuY3Rpb24AFwNlbnYFYWJvcnQABgNlbnYKaW52b2tlX3ZpaQAFA2VudhtfX2N4YV9maW5kX21hdGNoaW5nX2NhdGNoXzIADQNlbnYLZ2V0VGVtcFJldDAADQNlbnYRX19yZXN1bWVFeGNlcHRpb24AAQNlbnYNX19hc3NlcnRfZmFpbAAHA2VudghpbnZva2VfdgABA2VudhtfX2N4YV9maW5kX21hdGNoaW5nX2NhdGNoXzMAAANlbnYRX19jeGFfYmVnaW5fY2F0Y2gAAANlbnYJaW52b2tlX2lpAAMDZW52GF9fY3hhX2FsbG9jYXRlX2V4Y2VwdGlvbgAAA2VudglpbnZva2VfdmkAAgNlbnYNaW52b2tlX2lpaWlpaQAJA2VudgtfX2N4YV90aHJvdwAFA2VudgtpbnZva2VfdmlpaQAHA2VudhRfX2N4YV9mcmVlX2V4Y2VwdGlvbgABA2VudgtpbnZva2VfaWlpaQAKA2VudgppbnZva2VfaWlpAAQDZW52Dmludm9rZV9paWlpaWlpAA8DZW52D19fY3hhX2VuZF9jYXRjaAAGA2VudhtfX2N4YV9maW5kX21hdGNoaW5nX2NhdGNoXzQAAwNlbnYSbGx2bV9laF90eXBlaWRfZm9yAAADZW52DGludm9rZV9paWlpaQAIA2VudghpbnZva2VfaQAAA2VudgxpbnZva2VfdmlpaWkACwNlbnYbX19jeGFfZmluZF9tYXRjaGluZ19jYXRjaF81AAQDZW52F19fY3hhX2dldF9leGNlcHRpb25fcHRyAAADZW52Emludm9rZV92aWlpaWlpaWlpaQApA2Vudg9pbnZva2VfaWlpaWlpaWkADgNlbnYPaW52b2tlX3ZpaWlpaWlpABcDZW52DWludm9rZV92aWlpaWkADANlbnYKaW52b2tlX2lpZgAwA2Vudg1fX2N4YV9yZXRocm93AAYDZW52DGdldHRpbWVvZmRheQADA2VudgxfX3N5c19zdGF0NjQAAwNlbnYKX19zeXNfb3BlbgAEA2Vudg1fX3N5c19mY250bDY0AAQDZW52C19fc3lzX2lvY3RsAAQWd2FzaV9zbmFwc2hvdF9wcmV2aWV3MQhmZF9jbG9zZQAAFndhc2lfc25hcHNob3RfcHJldmlldzEHZmRfcmVhZAAKFndhc2lfc25hcHNob3RfcHJldmlldzEIZmRfd3JpdGUACgNlbnYZX19jeGFfdW5jYXVnaHRfZXhjZXB0aW9ucwANA2Vudg1pbnZva2VfaWlpaWlkAC4DZW52C2ludm9rZV9maWlpADkDZW52C2ludm9rZV9kaWlpADsWd2FzaV9zbmFwc2hvdF9wcmV2aWV3MRFlbnZpcm9uX3NpemVzX2dldAADFndhc2lfc25hcHNob3RfcHJldmlldzELZW52aXJvbl9nZXQAAwNlbnYKX19tYXBfZmlsZQADA2VudgxfX3N5c19tdW5tYXAAAwNlbnYKc3RyZnRpbWVfbAAIA2VudhNpbnZva2VfaWlpaWlpaWlpaWlpAB0DZW52F2ludm9rZV92aWlpaWlpaWlpaWlpaWlpACoDZW52FV9lbWJpbmRfcmVnaXN0ZXJfdm9pZAACA2VudhVfZW1iaW5kX3JlZ2lzdGVyX2Jvb2wACwNlbnYbX2VtYmluZF9yZWdpc3Rlcl9zdGRfc3RyaW5nAAIDZW52HF9lbWJpbmRfcmVnaXN0ZXJfc3RkX3dzdHJpbmcABQNlbnYWX2VtYmluZF9yZWdpc3Rlcl9lbXZhbAACA2VudhhfZW1iaW5kX3JlZ2lzdGVyX2ludGVnZXIACwNlbnYWX2VtYmluZF9yZWdpc3Rlcl9mbG9hdAAFA2VudhxfZW1iaW5kX3JlZ2lzdGVyX21lbW9yeV92aWV3AAUDZW52FmVtc2NyaXB0ZW5fcmVzaXplX2hlYXAAAANlbnYVZW1zY3JpcHRlbl9tZW1jcHlfYmlnAAQDZW52C3NldFRlbXBSZXQwAAEDZW52EWludm9rZV9paWlqaWlpaWlpABoDZW52D2ludm9rZV92aWlpaWpqaQASA2VudgtpbnZva2VfdmlqaQALA2VudgppbnZva2VfamlpAAQDZW52Cmludm9rZV9paWoACgNlbnYNaW52b2tlX3ZpaWppaQARFndhc2lfc25hcHNob3RfcHJldmlldzEHZmRfc2VlawAIA2Vudg1pbnZva2VfaWlpaWlqAA8DZW52DGludm9rZV9qaWlpaQAIA2VudgZtZW1vcnkCAYACgIACA2VudgV0YWJsZQFwAJ4JA+4M7AwGBgABAA0AAgMFAAIDBQACAAIAAgACAAIAAgACAwUAAgACAgIFCgkEAgIDFwUBAgwCBAUBAgIBAAEHCwoCBQUOCQwBBwwDAggAAQIEAgAJAgABAQABFAcAAwMJAwMDAwEDBRgFAwMBAQEAAAIFAQUHAgICCwsHEQQCAgQEAgMBAQMBAQMBAwEDAQIBBQMCAQQBBQ0AAQEBADIHBwoBBQMDAgACAwEFBAMBAwEDBAEDAQMBBAEDAQMBAwEEAQEDBAIBAQIEAQMBAwEDAQEDAwEDAQUDAgEBAwEDAQQBAQMBAQMDAQMBAwEDAgEBAwIDAUMBAwEDAwEDAwABAQAABQUDAQMBAQEBAQEDAQQBAwMBAwEDAQEDAQMBAAIDAQMBAQMBAQEDAQMCAQEDAgEDAgEDAQMBAwEEBAEAAwEEBAEDBQIBBQEBAwMKCgEBAQICAQcHBQACAAIFBQUEAAECCgECAgcCBRYYFgcHBQAAAAAiAgICAhwoICggKCAAAgoLFhgAAgYBBgcCAgIBAAADAAUHEgsKAwIHBQUCBQIDBwMAPQIDBUBGLwcDBysYAgoDAwIAAQABAQEBAQEBBgICAQYCAgEGAgIBBgICAQYCAgEGAgIBAQYEChYYBQcHBwcHBQUHBQUHCQABAgIFBQUHCAABAgICBwUCBQUHCgABAgoFBQUFBw8AAwEDBQEKBQUHCgcAAAUCBQoHCgAFBQEAAQAAAgUFAAECAgUFAAEAAgUFAAEABQUBAAICBQUAAAEAAgIAAAAAAgIEAAEAAQEFBz8FHCwFABwCAwIBACIiAwMADTYAAwIDAQMDAwEDAQQFBQQDAwIDBAMEAQQAAQIEAAAEExAQAAMNAAABAAAAAQEBAAECBBQGBwADAwoAAQQTEBAAAwMEExAQAAMDAQENNgAAAwAAAAAEBAMEAwMCBQMAAw0KBAIBAjExAAoAAwMCAAQEBAQEBANQCA8FAAcLNEg0BCcCBQQAHAA3ChkkBwwRFgQDLBsbACIAAAAEAgAAGSRJNRlEIAICJBlCGU9MAgQNAQACAAABAAQUAAcEAwUDAAAAAwQFAAABAQQAAQIAAwADAAQAAwIAAwABAQMAAAMDAgAJAwMFBAIUAxwAAwAEAAMDAAADAAABAQAAAAAICAMDExUzHgMFBAMAAAABAQEABQMEAAEDAwEGAAICAwUAAAMDAgQDBgADAAQEAwoBAA0NDQQICggEDQQANx8fSwdOBQcIBwUECAcFBAkBAAICDwMDBAIDAAMBAAkIAAUAAAIhCgcJCB8JCAoJCAoJCAkIHwkICx04CQg6CQgHCQoNCgEAAAAEAwEJAA8DCQgDBSEJCAkICQgJCAkICQgLHQkICQgJCgQAAAIDCAAAAwEDCAcIBBECABUIFR4EAAoRBAAmCAgAAQgRCQIEFQgVHhEmCAICDgMJCQkMCQwJCwgOBwsLCwsLCwcMCwsLDgMJCQkMCQwJCwgOBwsLCwsLCwcMCwsLDwwCAw8MAwgBAAICAgACDxoSBQMEBQUPAQQCAgIEAAICAgAABAMAAg8aEgUEDwEEBAACAAQDAgIlABIjAgQJJRIjBAkABAQMAAoCDAAKAAoBAAYAAwICAgYCBgIGAgYCBgICAgICAgIGAgYCBgIGAgYCBgIGAgYCAgIGAgYCBgIGAgEAAgIBAAECAAUGBgYGBgYGBgYGBgYGBgYGBgENAwEBDQADAgEAAQIDDQMNAQMBAgEBBA0KCgoDDQQDDQQDCgQIAAEDBAMECgQIDggIAwMBDgkKDgkICAAKAAgKAA4JDgkIBA4JDgkIBAABAAEAAAICAgIDAgICAAYBAAYBAgAGAQAGAQAGAQAGAQABAAEAAQABAAEAAQABAAEDAAIBAQAFAgUEAAMCBAIBAAUCAwECBQAAAgIBAwADCgICAQAEAQcAAgEDAAAFBAQEAgYAAAMCAwMEBAEDBQACBBcFBQILBQQCAQUFBRcLBQQCBQMFBAQCAwUDBQABBgIAAwAAAQEBDQYABgEGAAEAAAEBAAEBAAQEBAMFBwcHBwMEAwMHBQsMCwsLDAwMBAAAAAYGBgYGBgYGBgYGBgYBAQEBAQEGBgYGAAABAwMAAwIAGU01BAQFAAIEBAIAAQIFBwsMFykqAwQKCAkPDhodRS4wOTsNAAEARy0REhELDxoKBAgOCC0hMkEWPkoGEAJ/AUGwyMUCC38AQfTGBQsH3Ac2EV9fd2FzbV9jYWxsX2N0b3JzAEwGbWFsbG9jAPUMBGZyZWUA9gwQX19lcnJub19sb2NhdGlvbgCMBghzZXRUaHJldwDZBhlfWlN0MTh1bmNhdWdodF9leGNlcHRpb252ANsGD19fY3hhX2Nhbl9jYXRjaADZDBVfX2N4YV9pc19wb2ludGVyX3R5cGUA2gwNX19nZXRUeXBlTmFtZQDcDCpfX2VtYmluZF9yZWdpc3Rlcl9uYXRpdmVfYW5kX2J1aWx0aW5fdHlwZXMA3QwKX19kYXRhX2VuZAMBCWR5bkNhbGxfdgCJDQpkeW5DYWxsX3ZpAIoNC2R5bkNhbGxfdmlpAIsNDGR5bkNhbGxfdmlpaQCMDQ1keW5DYWxsX3ZpaWlpAI0NDmR5bkNhbGxfdmlpaWlpAI4NEGR5bkNhbGxfdmlpaWlpaWkAjw0TZHluQ2FsbF92aWlpaWlpaWlpaQCQDRhkeW5DYWxsX3ZpaWlpaWlpaWlpaWlpaWkAkQ0QZHluQ2FsbF92aWlpaWpqaQCnDQ5keW5DYWxsX3ZpaWppaQCoDQxkeW5DYWxsX3ZpamkAqQ0JZHluQ2FsbF9pAFAKZHluQ2FsbF9paQCSDQtkeW5DYWxsX2lpaQCTDQxkeW5DYWxsX2lpaWkAlA0NZHluQ2FsbF9paWlpaQCVDQ5keW5DYWxsX2lpaWlpaQCWDQ9keW5DYWxsX2lpaWlpaWkAlw0QZHluQ2FsbF9paWlpaWlpaQCYDRNkeW5DYWxsX2lpaWlpaWlpaWlpAJkNFGR5bkNhbGxfaWlpaWlpaWlpaWlpAJoNFWR5bkNhbGxfaWlpaWlpaWlpaWlpaQCbDQ5keW5DYWxsX2lpaWlpagCqDQ5keW5DYWxsX2lpaWlpZACcDRJkeW5DYWxsX2lpaWppaWlpaWkAqw0LZHluQ2FsbF9paWoArA0LZHluQ2FsbF9paWYAnQ0LZHluQ2FsbF9qaWkArQ0NZHluQ2FsbF9qaWlpaQCuDQxkeW5DYWxsX2ZpaWkAng0MZHluQ2FsbF9kaWlpAJ8NCXN0YWNrU2F2ZQCgDQpzdGFja0FsbG9jAKENDHN0YWNrUmVzdG9yZQCiDRBfX2dyb3dXYXNtTWVtb3J5AKMNDmR5bkNhbGxfaWlpamlqAK8NDGR5bkNhbGxfamlqaQCwDQ9keW5DYWxsX2lpZGlpaWkApA0RZHluQ2FsbF9paWlpaWlpaWkApQ0PZHluQ2FsbF9paWlpaWpqALENEGR5bkNhbGxfaWlpaWlpamoAsg0PZHluQ2FsbF92aWlpaWlpAKYNCYwSAQBBAQudCU5PUFFSU1RVVldYWVpbXF1eX2BhYmNkZWZnaGlqa2xtf26AAVWBAYIBfgTGB+IGlwGsB/4LmAGGDJoBEZMBqweDB/gG/AemAZMHhgcXkwyNDJQBlQGWAZUBmwGZAZ0BnAGeAaEHoweiB6QHnwGgAd8E4wahAaIB6gTqBOcGowHsBqQB7walAaAEqAHoAYwDqQHFBKoByAS5BIQDsgGrAY0DmAOVA5cDmQOjA8YEtAG1AbYBtwGzAcoEzATOBMkEuAHNBMMBwQHEAVK5AbEBqAOwBNkDugHPBM8B0QHHAdMB2AHGAcAFyQHMAaYD3AGqA6sDrgOvA7MB3AHIAdwBygHLAdwBzQHOAdwB0AHcAdIB3AHUAdUB1gHcAdkB2gHWA8UB3APmA/cD+wOMBvED8gP0A/UDnAOyAYkD7AGzAe4B4QS/BLIB8AGyAbIBsgH0AbIB9gGyAfYBsgH5AbIB+wGyAf0BmwO1BLIB/wGyAYECsgGDArIBhQKaA7IBhwKIAq0FsgGMAo0CsgGQArIBkgKyAZQCsgGWApcCsgGWArIBmgKsAbIBnAKdArIBoAKhArIBowKyAaUCsgGnAqgCsgGqAqsCsgGyAa4CjgOwA7IBsAKyAbIC2gSyAbUCtgK5ArIBugK8ArIBpwK+ArIBsgKyAcECsgHEArIBxQKxBMYCxwLIArMEyQLKArgEoQSyAcwCsgHQAtEC0wKyAdUCsgHXArIB9gGyAdoCsgHcArIB3gLfArIB4QKyAeMCtAHkAuUCywSyAecCsgHpAuoCsgHtAu4CsgHwArIB8wL0ArIB9wKyAfoCsgH8ArIB/gKyAYADsgGFA5EB6wHzAfIB7wH1AfcB+gH8AfgB/gGAAoIChAKnAYYCigKPApECkwKVApgCmQKbAp4CogKkAqYCqQKsAq0CrwKxArMCtwK9Ar8CwALCAsMCywLNAtQC1gLYAtkC2wLdAuAC4gLmAugC6wLvAvEC9QL4AvsC/QL/AoEDrQekA5IMvwGGA6cD+AWvB88DhwzRA9UD2APuBeUFxAWSBecD4QPbA6MEjwfIBfwD/QP+A/8D8QbzBvIG9AbRA9ED0QPRA9ED0QOABIEEggSDBIQEhQSJBI0EkQSVBJkEnQSeBOoBiQKwAeMBwgHRBLQDsgP4A/kDywPjBFLnBLcMsgS2BLcEugS7BIwFjQW8BMIEwwTEBMcE0ATSBI4FjwWQBdUE1wTYBNkE1gTbAbkB3QTcBN8E3gTgBNsEuQHkBNwE3wTlBOYE4gToBOkE6gTrBOwE7QTuBKUE7wTwBNwE6wTxBPME9ASmBPUE9gT3BOsE+AT5BPoEpwT7BPwE/QTrBPgE/gT/BKgEhgWABYEF6wSCBYQFhQWpBIAFqgSrBKwEhwWIBYkF6wSKBa0ErgSvBJMDkwWUBZEDiwyVBZYFowWuBbAFsgWzBbQFtgW4BbsFvAW9BdwBrwXcAbEF3AGvBdwB3AG1BdwBtwXcAdwB3AHcAb4FtAG5BboFwQXcAdwBvgXDBcIFxQXGBccFygXeCvUFyQXbBVLSBdQFywXMBc0FzgXPBdAF1QXYBdYF2QXXBdoFtQe4B7YHuQe3B7oH0wXcBd0F3gXfBeEF4gXjBeQF0QXmBecF6AXpBeoF6wXsBe0FUrkB7wXwBfEF8gXzBfQF9gX3BY4GvwbGBrAGlgaeBq0GrgbqBMAG3gbaBvkGyAKEB4EH9gaNB44H3wYkkgeUB5UHzAelB6YHqQeqB64HsAezB7MBvge/B+AG4QbkBuYG6wbuBu4GUrkBuwefDKAMoQy8B8AH8gvdBsMH+Af5B/oH+wf2DP0L/AaAB/0GgAj/BuoIiwiMCI0IjgjSCNMI4waRCJQIlwiXCJwIoAihCKkI0QikCKcIqgirCNUH5QeXB7QI+Qf6B7UImAecB5kHzAebB7sI0gjTCMkIzwjRCLEH3wjgCOgI6QjqCNYH1wf8BbQH8gjNB/QIswf6CPMI6gjgB4MMvgzjBrMBvwm3CcAJwQnDCcQJxQnqCMgJ2AnZCZoH2gmcDNsJxQneCZsM6QnqCe8J8An3CfgJ2Af4CfsJ/An9CfcJ/gnZB4MKvQeECoUKhgqHCogKiQqKCosKjAqNCo4KjwqQCpEKkgqTCpQKlQqWCpcKmAqZCpoKmwqcCp0KngqfCqAKoQqiCqMKpAqlCqYKpwqoCqkKqgqrCqwKrQquCq8KsAqzCrQK1AvZC98K1AroC9EK6wvsC9oK3AriCtsH3AfdB98HoAbhB7UGiQuKC+IH4wfkB6kLqgusC60LsAuxC7MLtAu2C7cLuQu6C7wLpAu+C8ALwgvEC8YLyAvKC9ML/grhC98E5wu7DNYK1wrhCvIK8wr0CvUK9gr3Cu4K+Ar5CvoKgAqAC4ELhAuHC4gL6gSLC40LmgubC54LnwugC6ILpQucC50L5wjhCKELowumC1K5AbkB4wrlCuYK5wroCuoK6wrtCu4K7wrwCvEKuQH7CvsK/ArcBNwE/QrcBLkBjguQC/wK6gTqBJILgQW5AZQLlgv8CuoE6gSYC4EFuQG5AVK5Ae4H7wfxB1K5AfIH8wf1B7kB9geFCI8IkgiVCJgImgidCKIIpQioCLkBswi3CLwIvgjACMIIxAjGCMoIzAjOCLkB1QjbCOII4wjkCOUI7AjtCLkB7gjxCPYI9wj4CPkI+wj8CFK5AfcEgQmCCYMJhQmHCYoJqAuvC7ULwwvHC7sLvwtSuQH3BJkJmgmbCZ0JnwmiCasLsgu4C8ULyQu9C8EL0AvPC68J0AvPC7MJuQG4CbgJuQm5CbkJugnqBLsJuwm5AbgJuAm5CbkJuQm6CeoEuwm7CbkBvAm8CbkJuQm5Cb0J6gS7CbsJuQG8CbwJuQm5CbkJvQnqBLsJuwm5Ab4Jxgm5AdcJ3Am5AecJ7Qm5Ae4J8gm5AfUJ9gnfBLkB9Qn6Cd8EUucE6gTqBOoEUoAMhQyEDKUMpAyCDKcMqAyzDLIMqgy5AboMuQG4DL0M8gu/DMAMuQHBDFK5AbMBswHCDLkBxAzYDNUMxwy5AdcM1AzIDLkB1gzRDMoMuQHMDPQMCuzuJuwMPwAQ0QcQTRDOAxDQAxCfBEHQqQVBLzsBAEHbqQVBAToAAEHcqQVBOjsBAEHnqQVBAToAAEGAwwVBnQkRAAAaC5EGAQJ/QZgPQbQPQdgPQQBB6A9BAUHrD0EAQesPQQBBgAhB7Q9BAhAAQZgPQQFB8A9B6A9BA0EEEAFBCBD+CyIAQgU3AwBBCBD+CyIBQgY3AwBBmA9BjwhB7BBBhBFBByAAQewQQYgRQQggARACQQgQ/gsiAEIJNwMAQQgQ/gsiAUIKNwMAQZgPQZ4IQaz9A0GEEUELIABBrP0DQYgRQQwgARACQQgQ/gsiAEINNwMAQQgQ/gsiAUIONwMAQZgPQaQIQaz9A0GEEUELIABBrP0DQYgRQQwgARACQQgQ/gsiAEIPNwMAQQgQ/gsiAUIQNwMAQZgPQasIQaz9A0GEEUELIABBrP0DQYgRQQwgARACQQgQ/gsiAEIRNwMAQQgQ/gsiAUISNwMAQZgPQbUIQaz9A0GEEUELIABBrP0DQYgRQQwgARACQQgQ/gsiAEITNwMAQQgQ/gsiAUIUNwMAQZgPQboIQaz9A0GEEUELIABBrP0DQYgRQQwgARACQQgQ/gsiAEIVNwMAQQgQ/gsiAUIWNwMAQZgPQcAIQaz9A0GEEUELIABBrP0DQYgRQQwgARACQQgQ/gsiAEIXNwMAQQgQ/gsiAUIYNwMAQZgPQdYIQaz9A0GEEUELIABBrP0DQYgRQQwgARACQQgQ/gsiAEIZNwMAQQgQ/gsiAUIaNwMAQZgPQeYIQdj8A0GEEUEbIABB2PwDQYgRQRwgARACQQgQ/gsiAEIdNwMAQQgQ/gsiAUIeNwMAQZgPQfYIQaz9A0GEEUELIABBrP0DQYgRQQwgARACQQgQ/gsiAEIfNwMAQQgQ/gsiAUIgNwMAQZgPQYcJQdj8A0GEEUEbIABB2PwDQYgRQRwgARACQQgQ/gsiAEIhNwMAQZgPQY0JQQJBkBFBmBFBIiAAQQAQA0EIEP4LIgBCIzcDAEGYD0GYCUEDQZwRQYgRQSQgAEEAEANBCBD+CyIAQiU3AwBBmA9BpAlBA0GcEUGIEUEkIABBABADQQgQ/gsiAEImNwMAQZgPQbEJQQJBkBFBmBFBIiAAQQAQAwsFAEGYDwsPACAABEAgABCDARD2DAsLBwAgABENAAvAAQEHf0E4EP4LIgBBCGoiAUIANwMAIABCADcDACAAQTBqIgJCADcDACAAQShqIgNCADcDACAAQSBqIgRCADcDACAAQRhqIgVCADcDACAAQRBqIgZCADcDACAAQQo6AAsgAEH0DykAADcAACABQfwPLwAAOwAAIABBADYCNCACQQA6AAAgAEEANgIsIANBADoAACAEQqGAgIDAAjcCACAFQgA3AgAgBkKAgICA4AM3AgAgAEEANgIMIABBADoACiAACwQAIAALVQEBfyMAQSBrIgIkACAAKAI0BEAgAkG1CjYCECACQasKNgIMIAJBhAo2AgggAkEsNgIEIAJB5gk2AgBBugkgAhCHDRAEAAsgACABEIoMIAJBIGokAAuGAQEBfyABIAAoAgQiAkEBdWohASAAKAIAIQACQCABIAJBAXEEfyABKAIAIABqKAIABSAACxEAACIALAALIgFBf0wEQCAAKAIEIgFBBGoQ9QwiAiABNgIAIAAoAgAhAAwBCyABQf8BcSIBQQRqEPUMIgIgATYCAAsgAkEEaiAAIAEQgA0aIAILkgIBBH8jAEEQayIDJAAgASAAKAIEIgVBAXVqIQYgACgCACEEIAVBAXEEQCAGKAIAIARqKAIAIQQLIAIoAgAiAEFwSQRAAkACQCAAQQtPBEAgAEEQakFwcSIFEP4LIQEgAyAFQYCAgIB4cjYCCCADIAE2AgAgAyAANgIEDAELIAMgADoACyADIQEgAEUNAQsgASACQQRqIAAQgA0aCyAAIAFqQQA6AABByLIFQQA2AgAgBCAGIAMQBUHIsgUoAgAhAEHIsgVBADYCACAAQQFHBEAgAywAC0F/TARAIAMoAgAQ9gwLIANBEGokAA8LEAYhABAHGiADLAALQX9MBEAgAygCABD2DAsgABAIAAsgAxCGDAALBwAgAEEMagtYAQF/IwBBIGsiAiQAIAAoAjQEQCACQfIKNgIQIAJBqwo2AgwgAkGECjYCCCACQS42AgQgAkHmCTYCAEG6CSACEIcNEAQACyAAIAEoAgA2AgwgAkEgaiQACzgBAX8gASAAKAIEIgJBAXVqIQEgACgCACEAIAEgAkEBcQR/IAEoAgAgAGooAgAFIAALEQAAKAIAC1IBAn8jAEEQayIDJAAgASAAKAIEIgRBAXVqIQEgACgCACEAIARBAXEEQCABKAIAIABqKAIAIQALIAMgAjYCDCABIANBDGogABECACADQRBqJAALBwAgAEEQagtYAQF/IwBBIGsiAiQAIAAoAjQEQCACQaMLNgIQIAJBqwo2AgwgAkGECjYCCCACQTA2AgQgAkHmCTYCAEG6CSACEIcNEAQACyAAIAEoAgA2AhAgAkEgaiQACwcAIABBFGoLWAEBfyMAQSBrIgIkACAAKAI0BEAgAkHVCzYCECACQasKNgIMIAJBhAo2AgggAkEyNgIEIAJB5gk2AgBBugkgAhCHDRAEAAsgACABKAIANgIUIAJBIGokAAsHACAAQRhqC1gBAX8jAEEgayICJAAgACgCNARAIAJBigw2AhAgAkGrCjYCDCACQYQKNgIIIAJBNTYCBCACQeYJNgIAQboJIAIQhw0QBAALIAAgASgCADYCGCACQSBqJAALBwAgAEEcagtYAQF/IwBBIGsiAiQAIAAoAjQEQCACQboMNgIQIAJBqwo2AgwgAkGECjYCCCACQTg2AgQgAkHmCTYCAEG6CSACEIcNEAQACyAAIAEoAgA2AhwgAkEgaiQACwcAIABBIGoLWAEBfyMAQSBrIgIkACAAKAI0BEAgAkHrDDYCECACQasKNgIMIAJBhAo2AgggAkE7NgIEIAJB5gk2AgBBugkgAhCHDRAEAAsgACABKAIANgIgIAJBIGokAAsHACAAQSRqC1gBAX8jAEEgayICJAAgACgCNARAIAJBrA02AhAgAkGrCjYCDCACQYQKNgIIIAJBPjYCBCACQeYJNgIAQboJIAIQhw0QBAALIAAgASgCADYCJCACQSBqJAALBwAgAEEoagtZAQF/IwBBIGsiAiQAIAAoAjQEQCACQecNNgIQIAJBqwo2AgwgAkGECjYCCCACQcEANgIEIAJB5gk2AgBBugkgAhCHDRAEAAsgACABLQAAOgAoIAJBIGokAAs4AQF/IAEgACgCBCICQQF1aiEBIAAoAgAhACABIAJBAXEEfyABKAIAIABqKAIABSAACxEAAC0AAAtSAQJ/IwBBEGsiAyQAIAEgACgCBCIEQQF1aiEBIAAoAgAhACAEQQFxBEAgASgCACAAaigCACEACyADIAI6AA8gASADQQ9qIAARAgAgA0EQaiQACwcAIABBLGoLWQEBfyMAQSBrIgIkACAAKAI0BEAgAkGeDjYCECACQasKNgIMIAJBhAo2AgggAkHEADYCBCACQeYJNgIAQboJIAIQhw0QBAALIAAgASgCADYCLCACQSBqJAALBwAgAEEwagtZAQF/IwBBIGsiAiQAIAAoAjQEQCACQdoONgIQIAJBqwo2AgwgAkGECjYCCCACQccANgIEIAJB5gk2AgBBugkgAhCHDRAEAAsgACABLQAAOgAwIAJBIGokAAs1AQF/IAEgACgCBCICQQF1aiEBIAAoAgAhACABIAJBAXEEfyABKAIAIABqKAIABSAACxEBAAuPAgIDfwF+IwBBQGoiAiQAIAAgAUEAEHAgASgCMCIBQQJOBEADQCACQTBqIgMgACkCKDcDACACIAApAjA3AzggAiAAKQIgNwMoIAIgACkCGDcDICACIAApAhA3AxggAiAAKQIINwMQIAApAgAhBSADQQA2AgAgAiAFNwMIIAJBADYCBCACQQA2AiQgAkEANgIAIAIgAigCCEEBdSIDQQFxIANqNgIIIAIgAigCDEEBdSIDQQFxIANqNgIMIAIgAigCFEECdDYCFCAAIAJBBGogAkEBEHEaIAAgACACKAIEaiIDNgKoByADIAJBCGpBARBwIAFBAkohBCABQX9qIQEgAyEAIAQNAAsLIAJBQGskAAu0CAEIfyAAQQBBrAcQgQ0iACABKAIAQQ9qIgNBBHUiBDYCWCABKAIEIQYgAEHY/+N+NgJ0IABByP+jfjYCbCAAIANBcHEiAzYCZCAAIAZBD2oiB0FwcSIGNgJoIAAgB0EEdSIHNgJcIAAgBCAHbDYCYCAAIAdBFnQiByAEQQZ0IgRB6P8DakHo/wNxckGAgKB/ajYCeCAAIAcgBEH4/wNqQfj/A3FyQYCAYGo2AnAgACABKAIAIgggASgCBHJBD3FBAEc2AnwgACABKQIwNwIwIAAgAUEoaiIEKQIANwIoIAAgAUEgaiIHKQIANwIgIAAgASkCGDcCGCAAIAEpAhA3AhAgACABKQIINwIIIAAgASkCADcCAAJAAkACQCAABEAgBCgCACEFIAcoAgAhBCABKAIcIQcgASgCBCEJIAAgAEG7B2pBcHEiATYCvAIgAg0BIAEhBQwDC0EAIQQgAg0BDAILIAAgASAEIAdqIAVBAEdqQQFqIAlBD2pBBHVBAmogCEEPakEEdUGAA2xBgAZqbGxqQQ9qQXBxIgQ2AjggASEFCyAAIANBAm0iATYCTCAAQcgAaiIHIAE2AgAgACAEIAMgBmwiAWoiBDYCPCAAIAM2AkQgAEFAayICIAQgAUEEbWo2AgAgACAHKQIANwLkAiAAIAApAjg3AtQCIAAgAikCADcC3AILIAAgA0EgaiIBNgLIAiAAIAFBAXUiBDYCzAIgACAENgLQAiAAIAUgA0EEdEGQBGoiCWo2ArwCIAAgBSAGQSBqIAFsIghqIgIgAUECdEEIciIHajYCwAIgACACIAZBAXVBEGogBGwiA2oiBiAHajYCxAIgAyAGaiEGAkAgACgCKEUEQCAGIQEMAQsgACAENgL8AiAAIAYgCWo2AuwCIAAgATYC+AIgACAENgKAAyAAIAYgCGoiASAHajYC8AIgACABIANqIgEgB2o2AvQCIAEgA2ohASAFIAZPDQAgBkEAIAUgA0EBdCAIaiIDQQFyaiIEIAEgBCABSxsgAyAFamsQgQ0aCyAAKAIcBEAgACAAKAJYIgRBBHRBIGoiAzYC4AIgACADQQF1IgU2AuQCIAAgBEEIdCABakGQBGo2AtQCIAAgBTYC6AIgACABIAAoAlwiBEEEdEEgaiADbGoiASADQQJ0QQhyIgNqNgLYAiAAIAEgBEEDdEEQaiAFbCIFaiIBIANqNgLcAiABIAVqIQELIAAoAiAiCEEBTgRAIAAoAlgiBkEEdEEgaiIDIAAoAlwiBUEEdEEgamwhCSAFQQN0QRBqIANBAXVsIQQgBkEIdEGQBGohCiADQQJ0QQhyIQZBACEDA0AgACADQQxsaiIFIAEgCWoiByAEaiICIAZqNgKMAyAFIAYgB2o2AogDIAUgASAKajYChAMgAiAEaiEBIANBAWoiAyAIRw0ACwsL4gIBBH9BASEEAkAgAEUNAEECIQQgACgCCCAAKAIMckEASA0AIAAoAgAiBUEBSA0AIAAoAgQiBkEBSA0AIAAoAhQgACgCECAAKAIcIgcgACgCGHJyckEBSw0AIAAoAiBBCEsNAEEFIQQgBSAGciIFQQFxDQAgB0VBAnRBACAFQQ9xGyEECyAEQQEgAhtBASABGyIFRQRAIAEgACgCICAAKAIcaiAAKAIoQQBHakEBaiAAKAIAQQ9qQQR1QYADbCIEQYAGaiAAKAIEQQ9qQQR1IgZBAmpsbEEQciIHIAQgBmxqIAcgAxtBrAdqNgIAIAIgACgCACIBQQ9qQQR1IgRBBXQgBCAAKAIEQQ9qQQR1bEGkCWxBAm1BvxdqQXBxIARBA3RqQRdqQXBxIAFBL2pBcHFqIARBAnRqQRNqQXBxIARqQQ9qQXBxIARqQQ9qQXBxIARqQQ9qQXBxakEvajYCAAsgBQvnGgEifyAAIAAgARBzIQggACgCqAciBgRAIAAoAgAiCkEPakEEdSIHIAAoAgRBD2pBBHVsQaQJbEECbSELIApBL2pBcHEhDyAHQQV0QTBqIRIgB0ECdEEEaiEVIAdBA3RBCGohFgNAIAYgASAIaiIKQQ9qQXBxIgk2AtwGIAYgCUGhF2pBcHEiCTYCxAYgBiAJIAtqQQ9qQXBxIgk2ArgGIAYgCSAWakEPakFwcSIJNgK0BiAGIAkgD2pBD2pBcHEiCTYCvAYgBiAJIBVqQQ9qQXBxIgk2ApwGIAYgByAJakEPakFwcSIJNgKgBiAGIAcgCWpBD2pBcHEiCTYCqAYgBiAHIAlqQQ9qQXBxIgk2AsAGIAkgEmogCCAKa2ohCCAGKAKoByIGDQALCyAAIAMpAgA3AjggACADKQIQNwJIIABBQGsgAykCCDcCAAJAAkACQAJAIAAoAigEQCACKAIAQQFKDQFBACEGA0AgACATQQJ0IgdqIgxB7AJqIRcgDEH4AmoiGCgCACESAkAgACgCACAGdSIUQQNIDQAgACgCBCAGdSIGQQNIDQBBACADIAdqIgcoAgwiFWshFkEAIBJrIQ8gFEF+aiEdIAcoAgAhDiAXKAIAIRAgBkF+aiIcIRoDQCAQIA4gFWoiDi0AADoAACAQIBJqIhBBAWohBiAOQQFqIQcgHSEIA0AgByAWai0AACAHLQABIAdBf2otAAAgBkF/ai0AAGtqIAYtAAFraiAGIA9qIgotAABrIAcgFWotAAAgBiASai0AAGtqIgkgCUEfdSIJaiAJc0ECdkGQHWotAABBAnQiCUH/ASAJQf8BSRtB/wFzIActAAAiCSAGLQAAIgFrIgsgC0EfdSILaiALc0GQHWotAABB/wFzbCILQf//A3MgCWwgASALbGoiCUGAgP4HTw0GIAZBAWohBiAHQQFqIQcgCiAJQYCAAmpBEHY6AAAgCEF/aiIIDQALIAYgD2ogBy0AADoAACAaQX9qIhoNAAsgECASaiAOIBVqIBQQgA0aIBwhBgNAIBAgDyAQaiIHIBQQgA0aIAchECAGQX9qIgYNAAsgByAOIBUgHGxrIBQQgA0aIBgoAgAhEgsgFygCACEGIAwgEjYCRCAMIAY2AjhBASEGIBNBAWoiE0EDRw0ACwsgAEEANgLIBiACRQ0DDAILIABBADYCyAYMAQtBkB9Bnx9BgDBBvx8QCQALIAAgAikCADcC4AYgACACKQIgNwKAByAAIAIpAhg3AvgGIAAgAikCEDcC8AYgACACKQIINwLoBgsgACgC+AYiBkEAIAZBNEgbRQRAIABBMzYC+AZBMyEGCyAAKAL0BiIHQQlMBEAgAEEKNgL0BkEKIQcLIAAgACgC4AZBfXFBCEY2AqwGIAAoAhxFBEAgACADKQIANwLUAiAAIAMpAhA3AuQCIAAgAykCCDcC3AILQX8hEQJAIAAoAuQGIhlBBksEQCAZQeMARw0BIAAoAuwGIRtBBkHjAAJ/IAAoAugGIhFFBEAgACgCsAYhEQsgEUEASAsbIRkMAQsCQAJAAkACQAJAAkAgGUEBaw4GBQQDAgYBAAsgACgCVA0DCyAAKAIgQQBKIRtBBiEZDAQLQQEhEUEBIRsMAwtBASERDAILIAAoArAGIRFBAiEZDAELIAAoArAGIRFBASEZQX8hGwsgACgCsAYhCCAbQQBOBEAgACAbNgKwBgsCQAJAIBlBBkYEQEEAIQogAEEANgJUIAAgAC0AiAdBAXM6AIgHIAAgBkEeIAZBHkgbIgYgByAGIAdKGyIHNgJQQcIAIQYgACAAKAIwQQJOBH8gACgCqAciBiAHNgJQIAZBADYCVCAGIAYtAIgHQQFzOgCIByAAKALEBiEHIAZBADYCyAYgBiAHNgLEBiAGQcIAEHQgBkEAEHUgACAAKALIBiAGKALIBmo2AsgGQQEhCkHTAAUgBgsQdCAAIAoQdQwBC0EDIQYgACgCUEUNASARIAAoAiAiB0oNASARQQhKDQEgGyAHSg0BCyAAQeAGaiEeIAggEUcgEUF/SnEhJAJAIAAoAjBBAk4EQCAAKAKoByINIB4pAgA3AuAGIA0gHikCIDcCgAcgDSAeKQIYNwL4BiANQfAGaiIGIB4pAhA3AgAgDSAeKQIINwLoBiAGIAAoAvAGQQJ1NgIAIA1B4AZqISBBACEGA0AgDSgCaCAGdSElIAMgIUECdCIHaiIIKAIAISYgCCgCDCEQIAcgDWoiBygCRCECIAcoAjghCCAAKAIEIAZ1IgdBDHQgDSgCBCAGdSIfEHYhIiAAKAIAIAZ1QQx0IA0oAgAgBnUiFhB2IQwgH0EBTgRAIAIgFmshIyAQQX9qIRMgB0F/aiEXIAxBAnUhGCAiQQJ1ISdBACEcA0AgFkEBTgRAQYAgIBwgImwgJ2oiBkH/H3EiDmshGiAmIAZBDHUiFCAQbGohHUEAIQoDQCAKIAxsIBhqIgdB/x9xIQYgHSAHQQx1IgtqIgctAAAiDyEJIAcgEGogByAUIBdIGyIVLQAAIhIhASALIBNIBEAgBy0AASEJIBUtAAEhAQsgCCAGIAlB/wFxbEGAICAGayIHIA9sakELdiAabCAGIAFB/wFxbCAHIBJsakELdiAObGpBgCBqQQ12OgAAIAhBAWohCCAKQQFqIgogFkcNAAsLIAIgFkoEQCAIIAhBf2otAAAgIxCBDSAjaiEICyAcQQFqIhwgH0cNAAsLICUgH2sgAmwiBkEBTgRAQQAgAmshBwNAIAggByAIai0AADoAACAIQQFqIQggBkF/aiIGDQALC0EBIQYgIUEBaiIhQQNHDQALIA0gACgC3AY2AtwGIAAoAsgGIQYgACgCxAYhByANQQA2AsgGIA0gBiAHajYCxAYgDSAgIBEgJCAbIBkgACgCLEECdEEAEHcgACAAKALIBiANKALIBmo2AsgGAkAgGUF7akEBSw0AIAAoAjRFDQBBACEGQQAhIANAIAAgIEECdCIIaiIHKAK8AiIfIAcoAsgCIhIgACgCaCAGdSILbGpBCGohByAIIA1qIggoAuACIRUgCCgC1AIhIyAAKAJkIAZ1IhdBAXUiCCANKAJkIAZ1IhNBEHRqIBcQdiEcIAtBAXUiCiANKAJoIAZ1Ig9BEHRqIAsQdiEWIAggEyAGQQ9zIgl0aiAXEHYhCCAKIA8gCXRqIAsQdiEKAkAgBgRAIBdBAUgNASAKQYCQf2ohAiAHQX5qIR0gE0F/aiEUIAhBgJB/aiEOIAcgD0EBdGoiDEF+aiEYQQAhGgNAIA9BAU4EQEEAIA5BEHUiBkEBaiAUIAYgFEgbIA5BgIB8SBshCkEAIAYgFCAGIBNIGyAOQQBIGyEJQRAgDkEMdkEPcSIBayEQQQAhCCAjIQYDQCAHIAhBAXRqIBAgBiAJai0AAGwgASAGIApqLQAAbGo7AQAgBiAVaiEGIAhBAWoiCCAPRw0ACwsgHSAHLwEAOwEAIAwgGC8BADsBACALQQFOBEAgGiAfaiEIQQAhCiACIQYDQCAIIAZBDHZBD3EiCSAHIAZBEHVBAXRqIgEvAQJsIAEvAQBBECAJa2xqQYABakEIdjoAACAGIBZqIQYgCCASaiEIIApBAWoiCiALRw0ACwsgDiAcaiEOIBpBAWoiGiAXRw0ACwwBCyAXQQFIDQAgCkGAkH5qISUgB0F8aiEmIAdBfmohJyATQX9qIRggCEGAkH5qIQwgByAPQQF0aiIiQQJqISEgIkF+aiEDQQAhAgNAIA9BAU4EQEEAIAxBEHUiBkEBaiAYIAYgGEgbIAxBgIB8SBshCkEAIAYgGCAGIBNIGyAMQQBIGyEJQQAgGCAGQX9qIAYgE0obIAxBgIAESBshAUEAIAZBAmoiBiAYIAYgE0gbIAxBgIB4SBshECAMQQx2QQ9xQQJ0IgZBkztqLAAAIQ4gBkGSO2osAAAhGiAGQZE7aiwAACEUIAZBkDtqLAAAIR1BACEIICMhBgNAIAcgCEEBdGogBiAJai0AACAUbCABIAZqLQAAIB1saiAGIApqLQAAIBpsaiAGIBBqLQAAIA5sajsBACAGIBVqIQYgCEEBaiIIIA9HDQALCyAnIAcvAQAiBjsBACAmIAY7AQAgIiADLwEAIgY7AQAgISAGOwEAIAtBAU4EQCACIB9qIQlBACEBICUhBgNAIAkgByAGQRB1QQF0aiIIQX5qLgEAIAZBCnZBPHEiCkGQO2osAABsIAguAQAgCkGRO2osAABsaiAILgECIApBkjtqLAAAbGogCC4BBCAKQZM7aiwAAGxqQYAEakEKdSIIQQAgCEEAShsiCEH/ASAIQf8BSBs6AAAgBiAWaiEGIAkgEmohCSABQQFqIgEgC0cNAAsLIAwgHGohDCACQQFqIgIgF0cNAAsLQQEhBiAgQQFqIiBBA0cNAAsLIAAoAqgGQQAgACgCWBCBDRogACAeIBEgJCAbIBkgACgCLEECdEEBckEUEHcMAQsgACAeIBEgJCAbIBkgACgCLEECdEEAEHcLIAUgACgCyAY2AgAgBCAAKALEBjYCAEEAIQYLIAYLyQIBA38gAkEPakFwcSEDIAEoAgRBD2pBBHUhBCABKAIAIgVBD2pBBHUhAQJAIABFBEAgA0GhF2pBcHEhAwwBCyAAIAM2AtwGIAAgA0GhF2pBcHEiAzYCxAYLIAMgASAEbEGkCWxBAm1qQQ9qQXBxIQMgAARAIAAgAzYCuAYLIAFBA3QgA2pBF2pBcHEhAyAABEAgACADNgK0BgsgAUECdCEEIAMgBUEvakFwcWpBD2pBcHEhAwJAIABFBEAgAyAEakETakFwcSABakEPakFwcSABakEPakFwcSABakEPakFwcSEDDAELIAAgAzYCvAYgACADIARqQRNqQXBxIgM2ApwGIAAgASADakEPakFwcSIDNgKgBiAAIAEgA2pBD2pBcHEiAzYCqAYgACABIANqQQ9qQXBxIgM2AsAGCyABQQV0IANqIAJrQTBqC6cUAQd/IAAoAmAhBEHgHyEDAkADQAJAIAQgAyICLwECSg0AIAAoAgwgAi8BBEHxBGxKDQAgACgCIEEBaiAEbCACKAIITQ0CCyACQQxqIQMgAi0ADEEzSQ0AC0GUISECCyAAKALEBiAAKALIBmoiA0GAgIAINgAAIAAgACgCyAYiBEEEajYCyAYCQAJAAkACQAJAAkACQAJAAkACQAJAAkACQAJAAkAgA0F8IARrQQNxQQRyaiIDQQNxRQRAIABBGDYCzAYgAEHUBmoiByADNgIAIAAgAzYC2AYgAEHQBmoiBUGAgID4BkGAgIC4BiABQdMARhsiAzYCACABQYACTw0BIABBzAZqIQQgAi0AACEGIAItAAEhCEEAIQIgAEEANgLMBiAAIAYgAUEQdCADciAIIAFB0wBHQQJ0cUEIdHJyNgLQBiAAKAIsQQFqIgYhAwNAIAJBAWohAiADQQF2IgMNAAsgBCACQQF0QX9qIAYQeCABQdMARgRAIARBA0ECEHggBEEBQQEQeCAEQQFBARB4IAQgBCgCAEF/aiICNgIAIAUCfyACQQBOBEAgBSgCAAwBCyACQWBMDQQgBSgCACECIAcgBygCACIDQQRqNgIAIAMgAkEIdEGAgPwHcSACQRh0ciACQQh2QYD+A3EgAkEYdnJyNgIAIAQgBCgCAEEgaiICNgIAIAVBADYCAEEACyIDNgIAIAQgAkF/ajYCACAFIAJBAEwEfyACQWFMDQUgByAHKAIAIgJBBGo2AgAgAiADQQh0QYCA/AdxIANBGHRyIANBCHZBgP4DcSADQRh2cnI2AgAgBCAEKAIAQSBqNgIAIAVBADYCAEEABSADCzYCAAsgBEEDQQIQeCAEQQNBAxB4QQAhAiAAKAIgQQJqIgYhAwNAIAJBAWohAiADQQF2IgMNAAsgBCACQQF0QX9qIAYQeCAEIAQoAgBBf2oiAjYCACAAAn8gAkEATgRAIAUoAgAMAQsgAkFgTA0FIAUoAgAhAiAHIAcoAgAiA0EEajYCACADIAJBCHRBgID8B3EgAkEYdHIgAkEIdkGA/gNxIAJBGHZycjYCACAEIAQoAgBBIGo2AgAgBUEANgIAQQALNgLQBkEAIQIgACgCAEEPakEEdSIGIQMDQCACQQFqIQIgA0EBdiIDDQALIAQgAkEBdEF/aiAGEHhBACECIAAoAgRBD2pBBHUiBiEDA0AgAkEBaiECIANBAXYiAw0ACyAEIAJBAXRBf2ogBhB4IAAoAnwiA0EGaiIGQQhPDQUgBCAEKAIAQX1qIgI2AgAgBQJ/IAJBAE4EQCAFKAIADAELIAJBYEwNByAAIAAoAtQGIgNBBGo2AtQGIAMgACgC0AYgBkEAIAJrdnIiAkEYdCACQQh0QYCA/AdxciACQQh2QYD+A3EgAkEYdnJyNgIAIABBADYC0AYgACAAKALMBkEgaiICNgLMBiAAKAJ8IQNBAAsgBiACdHI2AgAgBCADBH8gBEEBQQEQeEEAIQIgACgCZCAAKAIAa0EBdUEBaiIGIQMDQCACQQFqIQIgA0EBdiIDDQALIAQgAkEBdEF/aiAGEHggBEEBQQEQeEEAIQIgACgCaCAAKAIEa0EBdUEBaiIGIQMDQCACQQFqIQIgA0EBdiIDDQALIAQgAkEBdEF/aiAGEHggBCgCAAUgAgtBf2oiAjYCACAFAn8gAkEATgRAIAUoAgAMAQsgAkFgTA0IIAUoAgAhAiAHIAcoAgAiA0EEajYCACADIAJBCHRBgID8B3EgAkEYdHIgAkEIdkGA/gNxIAJBGHZycjYCACAEIAQoAgBBIGoiAjYCACAFQQA2AgBBAAsiBjYCACABQdMARgRAIAQgAkF/aiIDNgIAIAUgAkEASgR/IAYFIAJBYUwNCiAHIAcoAgAiAUEEajYCACABQQFBACADa3YgBnIiA0EYdCADQQh0QYCA/AdxciADQQh2QYD+A3EgA0EYdnJyNgIAIAQgBCgCAEEgaiIDNgIAIAVBADYCAEEAC0EBIAN0ciICNgIAIAQgA0F+aiIBNgIAIANBAUwEQCADQWJMDQsgByAHKAIAIgNBBGo2AgAgAyACQQh0QYCA/AdxIAJBGHRyIAJBCHZBgP4DcSACQRh2cnI2AgAgBCAEKAIAQSBqIgE2AgAgBUEANgIAQQAhAgsgBSACNgIAIAQgAUF/aiIDNgIAIAFBAEwEQCABQWFMDQwgByAHKAIAIgNBBGo2AgAgAyACQQh0QYCA/AdxIAJBGHRyIAJBCHZBgP4DcSACQRh2cnI2AgAgBCAEKAIAQSBqIgM2AgAgBUEANgIAQQAhAgsgBSACNgIAIAQgA0F+aiIBNgIAIANBAUwEQCADQWJMDQ0gByAHKAIAIgNBBGo2AgAgAyACQQh0QYCA/AdxIAJBGHRyIAJBCHZBgP4DcSACQRh2cnI2AgAgBCAEKAIAQSBqIgE2AgAgBUEANgIAQQAhAgsgBSACNgIAIAQgAUF/aiIGNgIAIAFBAEwEQCABQWFMDQ4gByAHKAIAIgNBBGo2AgAgAyACQQh0QYCA/AdxIAJBGHRyIAJBCHZBgP4DcSACQRh2cnI2AgAgBCAEKAIAQSBqIgY2AgAgBUEANgIAQQAhAgsgBSACNgIAIAQgBkF/aiIDNgIAIAUgBkEASgR/IAIFIAZBYUwNDyAHIAcoAgAiBkEEajYCACAGQQFBACADa3YgAnIiAkEYdCACQQh0QYCA/AdxciACQQh2QYD+A3EgAkEYdnJyNgIAIAQgBCgCAEEgaiIDNgIAIAVBADYCAEEAC0EBIAN0ciICNgIAIAQgA0F/aiIBNgIAIANBAEwEQCADQWFMDRAgByAHKAIAIgNBBGo2AgAgAyACQQh0QYCA/AdxIAJBGHRyIAJBCHZBgP4DcSACQRh2cnI2AgAgBCAEKAIAQSBqIgE2AgAgBUEANgIAQQAhAgsgBSACNgIAIAQgAUF/ajYCACAFIAFBAEwEfyABQWFMDREgByAHKAIAIgNBBGo2AgAgAyACQQh0QYCA/AdxIAJBGHRyIAJBCHZBgP4DcSACQRh2cnI2AgAgBCAEKAIAQSBqNgIAIAVBADYCAEEABSACCzYCAAsgABB5DwtBoCFBnx9B1cQAQbEhEAkAC0G7IUGfH0HJOEHHIRAJAAtB6yFBnx9BzjhBxyEQCQALQeshQZ8fQc44QcchEAkAC0HrIUGfH0HOOEHHIRAJAAtBuyFBnx9ByThBxyEQCQALQeshQZ8fQc44QcchEAkAC0HrIUGfH0HOOEHHIRAJAAtB6yFBnx9BzjhBxyEQCQALQeshQZ8fQc44QcchEAkAC0HrIUGfH0HOOEHHIRAJAAtB6yFBnx9BzjhBxyEQCQALQeshQZ8fQc44QcchEAkAC0HrIUGfH0HOOEHHIRAJAAtB6yFBnx9BzjhBxyEQCQALQeshQZ8fQc44QcchEAkAC68IAQN/IAAoAsQGIAAoAsgGaiICQYCAgAg2AAAgACAAKALIBiIDQQRqNgLIBgJAAkACQAJAAkAgAkF8IANrQQNxQQRyaiICQQNxRQRAIABCmICAgICAgIDoADcCzAYgACACNgLUBiAAIAI2AtgGIABBzAZqIQNBACECIAEgACgCLEECdGpBAWoiBCEBA0AgAkEBaiECIAFBAXYiAQ0ACyADIAJBAXRBf2ogBBB4QQAhAiAAKAIsQQFqIgQhAQNAIAJBAWohAiABQQF2IgENAAsgAyACQQF0QX9qIAQQeCADIAMoAgBBf2oiAjYCACAAAn8gAkEATgRAIAAoAtAGDAELIAJBYEwNAiAAIAAoAtQGIgFBBGo2AtQGIAEgACgC0AYiAkEYdCACQQh0QYCA/AdxciACQQh2QYD+A3EgAkEYdnJyNgIAIABBADYC0AYgACAAKALMBkEgaiICNgLMBkEACyIBNgLQBiAAIAJBf2o2AswGIAAgAkEATAR/IAJBYUwNAyAAIAAoAtQGIgJBBGo2AtQGIAIgAUEIdEGAgPwHcSABQRh0ciABQQh2QYD+A3EgAUEYdnJyNgIAIABBADYC0AYgACAAKALMBkEgajYCzAZBAAUgAQs2AtAGIANBAUEBEHggA0EBQQEQeCADQQFBARB4IAAgACgCzAZBf2oiATYCzAYgAAJ/IAFBAE4EQCAAKALQBgwBCyABQWBMDQQgACAAKALUBiIBQQRqNgLUBiABIAAoAtAGIgJBGHQgAkEIdEGAgPwHcXIgAkEIdkGA/gNxIAJBGHZycjYCACAAQQA2AtAGIAAgACgCzAZBIGoiATYCzAZBAAsiAjYC0AYgACABQX5qNgLMBiAAIAFBAUwEfyABQWJMDQUgACAAKALUBiIBQQRqNgLUBiABIAJBCHRBgID8B3EgAkEYdHIgAkEIdkGA/gNxIAJBGHZycjYCACAAQQA2AtAGIAAgACgCzAZBIGo2AswGQQAFIAILNgLQBkEAIQIgACgCUEEBdEFLaiIBQR91IAFzQQFqIgQhAQNAIAJBAWohAiABQQF2IgENAAsgAyACQQF0QX9qIAQQeCADIAMoAgBBe2oiAjYCACAAAn8gAkEATgRAIAAoAtAGDAELIAJBYEwNBiAAIAAoAtQGIgNBBGo2AtQGIAMgACgC0AZBHEEAIAJrdnIiAkEYdCACQQh0QYCA/AdxciACQQh2QYD+A3EgAkEYdnJyNgIAIABBADYC0AYgACAAKALMBkEgaiICNgLMBkEAC0EcIAJ0cjYC0AYgABB5DwtBoCFBnx9B1cQAQbEhEAkAC0HrIUGfH0HOOEHHIRAJAAtB6yFBnx9BzjhBxyEQCQALQeshQZ8fQc44QcchEAkAC0HrIUGfH0HOOEHHIRAJAAtB6yFBnx9BzjhBxyEQCQALyQMBD38gAEEAIAFBD3QgAEEPdiIOIAFJG2siAEEAIAFBDnQgAEEOdiIAIAFJG2siAkEAIAFBDXQgAkENdiICIAFJG2siA0EAIAFBDHQgA0EMdiIDIAFJG2siBEEAIAFBC3QgBEELdiIEIAFJG2siBUEAIAFBCnQgBUEKdiIFIAFJG2siBkEAIAFBCXQgBkEJdiIGIAFJG2siB0EAIAFBCHQgB0EIdiIHIAFJG2siCEEAIAFBB3QgCEEHdiIIIAFJG2siCUEAIAFBBnQgCUEGdiIJIAFJG2siCkEAIAFBBXQgCkEFdiIKIAFJG2siC0EAIAFBBHQgC0EEdiILIAFJG2siDEEAIAFBA3QgDEEDdiIMIAFJG2siDUEAIAFBAnQgDUECdiINIAFJG2siD0EBdiIQIAFPQQF0IAAgAU9BDnQgDiABT0EPdHIgAiABT0ENdHIgAyABT0EMdHIgBCABT0ELdHIgBSABT0EKdHIgBiABT0EJdHIgByABT0EIdGogCCABT0EHdGogCSABT0EGdGogCiABT0EFdGogCyABT0EEdGogDCABT0EDdGogDSABT0ECdGpqIA9BACABQQF0IBAgAUkbayABT2oL7h0BCn8gACACQR52QQJxNgKAAUF/IQggACgCCEF/aiIJQT8gCUE/SRsiDUEBaiIPIAAoAvAGIhFBA3QiEGwhDiAAKAJgIQwDQAJAIAhBAWoiC0EBdCIKQcAiai8BACEJIApBkiNqLwEAIQogCEEmSg0AIAshCCAJIA1sIApqIAxsIA5KDQELCyAKQRB0IQggAkEfdiEOQQEgCUEQdCIKZ3QhCQNAIAlB//8DcSILIAhBEHZsIAlBEHYgCGxqIAsgCEH//wNxbEEQdmohCEGAgAggCSAKbEEQdiIKayEJIApB//8DRw0ACyANBH8gD0EQdCEJQQEgCCANQRB0aiILZ3QhCgNAIApB//8DcSINIAlBEHZsIApBEHYgCWxqIA0gCUH//wNxbEEQdmohCUGAgAggCiALbEEQdiILayEKIAtB//8DRw0ACyAJQf//A3EiCiARQQ12Qf//A3FsIAlBEHYgEGxqIAogEEH4/wNxbEEQdmoFQQALIQogACgCDCIJQQF1IgsgEEghDSALIBAgDRshCwJ/AkACQAJ/IAJBf0wEQCAIQf//A3EiDyAKQRB2bCAKIAhBEHZsaiAKQf//A3EgD2xBEHZqDAELIANFDQEgCEGAgHxqIAAoAvwDIAAoAvgDayIPQQIgD0ECShsiD0EMIA9BDEgbQdQCbEEIdmwiCEEUdiAKbCAKaiAIQQR2Qf//A3EiCCAKQRB2bGogCCAKQf//A3FsQRB2agsgEGsiCCAJRQ0CGiAAKALwAyEPDAELIAogEGsiCCAJRQ0BGiAAKAKQBCAAKALwAyIPa0EEdSAIaiEICyAIIAlBOGxBA3UgD2siCSAIIAlIGwsgEGoiCCARQQd0IgkgCCAJSBsiCCARQQF0IgkgCCAJShshCQJAIAMgDnJFBEAgACgCkAQhCAwBCyAAIAAoAvADIAkgEGtqIgg2ApAECyAAIAk2AoAEIAAgCCAKIBBraiIIIAsgCCALShs2ApAEAkACQCAAKAIYRQ0AIAAoAlRFDQAgACgC9ANBCHUhCAwBC0EAIQgCQCADBEADQCAIQQF0IgpBkiNqLwEAIApBwCJqLwEAakEBdiAMbCAJSARAIAghCgwDC0EpIQogCEEBaiIIQSlHDQAMAgALAAsgDkHSAGwhCwNAIAwgCyAIQQF0akHAImovAQBsIAlIBEAgCCEKDAILQSkhCiAIQQFqIghBKUcNAAsLIApBCmohCAJ/IAMEQCAAKAKEBCIKIAAoAvwDIgsgACgC+AMiCSALIAlKGyILIAlBBmoiCSALIAlIGyAIaiIIIAogCEobDAELIAAoAvgDIAhqCyEIIAAoAoQEIgkgCEEBaiIKTA0AIAkgCmpBAm0hCAsgAEEANgLsAyAAIAgQeiAAQQA2ApABIABCADcCiAEgACAAKALsAyIINgKEBCAAIAhBCHQ2AvQDAkACQAJAAkACQAJAAkAgAkEBTgRAIAAoArwCIQkgACACQQxsIABqIghB+AJqIgooAgA2ArwCIAogCTYCACAAQcACaiIJKAIAIQogCSAIQfwCaiILKAIANgIAIAsgCjYCACAAQcQCaiIJKAIAIQogCSAIQYADaiIIKAIANgIAIAggCjYCAAwBCyAEQQBKDQAgAg0AIAAoAgwiCEUNACAAKALwAyAAKALwBkEDdGsgCEEDdEwNAEEAIQggACAFQQAgBCAGIAcQeyAAIAAoAmAiCTYClAEgCUEBaiIKIQkDQCAIQQFqIQggCUEBdiIJDQALIABBzAZqIAhBAXRBf2ogChB4IAAQeSAAKAJcQQR0IQkgACgCWEEEdCEHIAAoAsgCIQsgACgC4AIhDCAAKAK8AiEIIAAoAtQCIQoDQCAKIAggBxCADSEKIAggC2ohCCAKIAxqIQogCUF/aiIJDQALIAAoAlxBA3QhCSAAKAJYQQN0IQcgACgCzAIhCyAAKALAAiEIIAAoAuQCIQwgACgC2AIhCgNAIAogCCAHEIANIQogCCALaiEIIAogDGohCiAJQX9qIgkNAAsgACgCXEEDdCEJIAAoAlhBA3QhByAAKALQAiELIAAoAsQCIQggACgC6AIhDCAAKALcAiEKA0AgCiAIIAcQgA0hCiAIIAtqIQggCiAMaiEKIAlBf2oiCQ0ACwwBCyAAIAUgAiAEIAYgBxB7A0ACQCAAKAL8BiIIRQ0AIAAoAtQGIAAoAtgGa0EDdCAAKALMBmtBIGoiCUF/TA0DIAkgCEEDdE0NACAAEHkgACAFIAIgBCAGIAcQewsgACAHEHwgACAAKALUAkEQajYC1AIgACAAKALYAkEIajYC2AIgACAAKALcAkEIajYC3AIgACAAKAKQAUEBaiIINgKQASAAKAIYBEAgACgC1AYgACgC2AZrQQN0IAAoAswGa0EgaiIJQX9MDQQgCEUNBSAAKAJgIAkgACgCyAZBA3RqQQFqbCAAKAKABCAIbGsiCSAAKAKIBGshCiAAKALsAyEIIAAgCTYCiAQgAAJ/AkAgCUEBSA0AIApBAUgNACAIIAAoAowEQQNIaiEIQQAMAQsgACgCjAQhCyAJIApxQX9MBEAgCCALQQNIayEIQQAMAQsgC0EBags2AowEIAAgACgC9AMiCSAIaiAJQQh1azYC9AMgACAIIAAoAoQEIglBA2oiCiAIIApIGyIIIAlBfWoiCSAIIAlKGxB6CyAAIAAoAogBQQFqIgk2AogBIAkgACgCWCIISA0AIABBADYCiAEgACAAKALUAiAAKALgAiAIa0EEdGo2AtQCIAAgACgC2AIgACgC5AIgCGtBA3RqNgLYAiAAIAAoAtwCIAAoAugCIAhrQQN0ajYC3AIgACgCuAZCwICBgoSIkKDAADcCACAAKAK8BkF/NgIAIAAgACgCjAFBAWoiCDYCjAEgCCAAKAJcSA0ACyAAKAKUASIJBEBBACEIIAlBAWoiCiEJA0AgCEEBaiEIIAlBAXYiCQ0ACyAAQcwGaiAIQQF0QX9qIAoQeAsgABB5IAAgACgC1AIgACgCXCIIIAAoAuACbEEEdGs2AtQCIAAgACgC2AJBACAIQQN0ayIIIAAoAuQCbGo2AtgCIAAgACgC3AIgCCAAKALoAmxqNgLcAgsgBUEGRgRAIABBADYCnAcgAEIANwLkAwsCQCAEQQFOBEAgACAEakEBOgDjAwwBCyAEDQAgAEEBNgKcBwsgACgCyAYhDAJAIAAoAmAiCSAAKAKUAUYNACAMQQN0QWBqIQpBACEIIAJBf0YiDUHSAGwhBwNAAkAgCSAHIAhBAXRqQcAiai8BAGwgCkwEQCAIIQsMAQtBKSELIAhBAWoiCEEpRw0BCwsCQCADDQAgACgC9ANBCHUgACgC+AMiCGsiCSALQQlqSARAIAAgCEF/ajYC+AMMAQsgCSALQQtqTA0AIAAgCEEBajYC+AMLIAMgDXIEQCAAIAAoAvgDNgL8AwwBCyAAQfwDaiIIIAgoAgAiCCAAKAL0A0EIdSALa0F2aiIJIAggCUobNgIACyAAQfADaiIIIAgoAgAgDCAAKALwBmtBA3RqIgg2AgACQCAAKAIMIgkEQAJAIAhBf0oNACAAKAIUBEAgACgCxAYgDGoiCEGAgIAINgAAIAAgACgCyAYiCUEEajYCyAYgCEF8IAlrQQNxQQRyaiILQQNxDQcgAEKYgICAgICAgAw3AswGIAAgCzYC1AYgACALNgLYBkGAgIDgACEJQRghCANAIAAgCEF4aiIKNgLMBiAAAn8gCEEHSgRAIAohCCAJDAELIAhBaEwNCiAAIAtBBGoiDDYC1AYgC0H/AUEAIAprdiAJciIIQRh0IAhBCHRBgID8B3FyIAhBCHZBgP4DcSAIQRh2cnI2AgAgAEEANgLQBiAAIAAoAswGQSBqIgg2AswGIAwhC0EAC0H/ASAIdHIiCTYC0AYgACAAKALwAyIKQQhqNgLwAyAKQXhIDQALIAAQeSAAKAIMIQkgACgC8AMhCAwBC0EAIQggAEEANgLwAwsgCCAJQQN0IglMDQEgACgCEA0BIAAgCTYC8AMMAQsgAEEANgLwAwsgAkEBTgRAIAAoArwCIQkgACACQQxsIABqIghB+AJqIgooAgA2ArwCIAogCTYCACAAQcACaiIJKAIAIQogCSAIQfwCaiIHKAIANgIAIAcgCjYCACAAQcQCaiIJKAIAIQogCSAIQYADaiIIKAIANgIAIAggCjYCAAsCQCAEQX9GDQAgACgCZCEMIAAoAmghDUEQIQlBACEGA0AgACAGQQJ0aiIKQbwCaiEOAkAgACgCHARAIA4oAgAhCCAOIApB1AJqIgcoAgAiCjYCACAHIAg2AgAgCUEBdCAMaiEIDAELIAlBAXQgDGohCCAKKALUAiEKIA4oAgAhByANIQsDQCAHIAogDBCADSEHIAogDGohCiAHIAhqIQcgC0F/aiILDQALIA4oAgAhCgsgCiAJayEOIA1BAU4EQEEAIAlrIQIgCCAJQX9zaiEFQQAhByAOIQoDQCAKIAkgCmotAAAgCRCBDSIKIAhqIgsgAmogBSAKai0AACAJEIENGiALIQogB0EBaiIHIA1HDQALCyAJQQFOBEAgCCAJIA1qbCELIA4gCCAJbGshCiAOIAggDUF/amxqIQJBACEHA0AgCiAOIAgQgA0iCiALaiACIAgQgA0aIAggCmohCiAHQQFqIgcgCUcNAAsLIAkgBkUiCHUhCSAMIAh1IQwgDSAIdSENIAZBAWoiBkEDRw0ACyAAIAAoAlRBAWoiCDYCVAJAIAggACgCCCIJSA0AIAlFDQAgASgCBA0AIABBADYCVAsgBEEBSA0AIAAoArwCIQkgACAEQQxsIABqIghB+AJqIgooAgA2ArwCIAogCTYCACAAQcACaiIJKAIAIQogCSAIQfwCaiIHKAIANgIAIAcgCjYCACAAQcQCaiIAKAIAIQkgACAIQYADaiIIKAIANgIAIAggCTYCAAsPC0H7IUGfH0HgOEGOIhAJAAtB+yFBnx9B4DhBjiIQCQALQfI6QZ8fQc3VAEH+OhAJAAtBoCFBnx9B1cQAQbEhEAkAC0HrIUGfH0HOOEHHIRAJAAvbAQEBfwJAAkAgAiABdkUEQCAAIAAoAgAgAWsiAzYCACABQSFPDQECfyADQQBOBEAgACgCBAwBCyADQWBMDQMgACAAKAIIIgFBBGo2AgggASAAKAIEIAJBACADa3ZyIgNBGHQgA0EIdEGAgPwHcXIgA0EIdkGA/gNxIANBGHZycjYCACAAQQA2AgQgACAAKAIAQSBqIgM2AgBBAAshASAAIAEgAiADdHI2AgQPC0G7IUGfH0HJOEHHIRAJAAtB2SFBnx9ByzhBxyEQCQALQeshQZ8fQc44QcchEAkAC6IGAQp/IAAgACgCzAZBf2oiAjYCzAYgACgCyAYhCCAAKALEBiEGAkACQAJAAkAgAAJ/IAJBAE4EQCAAKALUBiEEIAAoAtAGDAELIAJBYEwNASAAQdQGaiIDIAMoAgAiBUEEaiIENgIAIAUgAEHQBmoiBygCAEEBQQAgAmt2ciIBQRh0IAFBCHRBgID8B3FyIAFBCHZBgP4DcSABQRh2cnI2AgAgB0EANgIAIAAgACgCzAZBIGoiAjYCzAZBAAtBASACdHIiATYC0AYgBCAAKALYBiIJa0EDdCACa0EgaiIFQX9MDQFBACEDIAAgAkEAIAVrQQdxIgprIgI2AswGAkAgAkF/SgRAIAQhAgwBCyACQWBMDQMgACAEQQRqIgI2AtQGIAQgAUEIdEGAgPwHcSABQRh0ciABQQh2QYD+A3EgAUEYdnJyNgIAQQAhASAAQQA2AtAGIAAgACgCzAZBIGo2AswGCyAGIAhqIQcgACABNgLQBiACIAFBCHRBgID8B3EgAUEYdHIgAUEIdkGA/gNxIAFBGHZycjYCAAJAIAUgCmpBA3YiBkUEQEEAIQQMAQsgCSEBQQAhBEEAIQUDQEEAIAEtAAAiAkEDS0EBdCADIANBAkYiCBtBAWogAhshAyAEIAggAkEESXFqIQQgAUEBaiEBIAVBAWoiBSAGRw0ACwsgCSAEIAdqIgVHBEAgBSAJIAYQgg0LAkAgBEUEQCAGIQMMAQtBACEBAkAgBkUEQEEAIQMMAQtBACEDQQAhBANAIAUtAAAhAgJAIAFBAkcNAEECIQEgAkH/AXFBA0sNACADIAdqQQM6AAAgA0EBaiEDQQAhAQsgBUEBaiEFIAMgB2ogAjoAAEEAIAFBAWogAkH/AXEbIQEgA0EBaiEDIARBAWoiBCAGRw0ACwsgAyAHaiAFSw0ECyAAKAKAByIBBEAgByADIAAoAoQHIAERBQALIAAgACgCyAYgA2o2AsgGDwtB6yFBnx9BzjhBxyEQCQALQfshQZ8fQeA4QY4iEAkAC0HrIUGfH0HOOEHHIRAJAAtBpCJBnx9ByMQAQa8iEAkAC4sTARB/IAEgACgC+AYiByAHIAFKGyIBIAAoAvQGIgcgASAHShsiAUEzIAFBM0gbIgggACgC7ANHBEAgACAINgLsA0GwJUHAJCAAKAKAARshCkECIQkDQCAAQQIgCWtB1ABsaiIHIAhBAXQiAUGQJ2ovAQAiBEGBgH5qOwGmBCAHIAFBoCZqLwEAIgJBgYB+ajsBpAQgByABQbAlai8BADsBogQgByABIApqLwEAOwGgBCAHQZ4EaiILIAhB1gBsQQl1IgFBemwgCGpBDGwiA0H6I2ouAQAgAXQ7AQAgB0GaBGoiDCADQfYjai4BACABdDsBACAHQZYEaiINIANB8iNqLgEAIAF0OwEAIAdBnARqIg4gA0H4I2ouAQBBAXQgAXUiBTsBACAHQZgEaiIPIANB9CNqLgEAQQF0IAF1IgY7AQAgB0GUBGoiECADQfAjai4BAEEBdCABdSIBOwEAIAcgAUH//wNxIgNBD3QiEUH//wUgAmsiAU1BD3QiAiACQYCAAXIiAiACIANsIAFLGyICIAJBgMAAciICIAIgA2wgAUsbIgIgAkGAIHIiAiACIANsIAFKGyICIAJBgBByIgIgAiADbCABShsiAiACQYAIciICIAIgA2wgAUobIgIgAkGABHIiAiACIANsIAFKGyICIAJBgAJyIgIgAiADbCABShsiAiACQYABciICIAIgA2wgAUobIgIgAkHAAHIiAiACIANsIAFKGyICIAJBIHIiAiACIANsIAFKGyICIAJBEHIiAiACIANsIAFKGyICIAJBCHIiAiACIANsIAFKGyICIAJBBHIiAiACIANsIAFKGyICIAJBAnIiAiACIANsIAFKGyICIAJBAXIiAiACIANsIAFKGyICOwGsBCAHIAI7AagEIAcgBkH//wNxIgJBD3QgAU1BD3QiBiAGQYCAAXIiBiACIAZsIAFLGyIGIAZBgMAAciIGIAIgBmwgAUsbIgYgBkGAIHIiBiACIAZsIAFKGyIGIAZBgBByIgYgAiAGbCABShsiBiAGQYAIciIGIAIgBmwgAUobIgYgBkGABHIiBiACIAZsIAFKGyIGIAZBgAJyIgYgAiAGbCABShsiBiAGQYABciIGIAIgBmwgAUobIgYgBkHAAHIiBiACIAZsIAFKGyIGIAZBIHIiBiACIAZsIAFKGyIGIAZBEHIiBiACIAZsIAFKGyIGIAZBCHIiBiACIAZsIAFKGyIGIAZBBHIiBiACIAZsIAFKGyIGIAZBAnIiBiACIAZsIAFKGyIGIAZBAXIiBiACIAZsIAFKGyICOwG0BCAHIAI7AbAEIAcgAjsBrgQgByACOwGqBCAHIAVB//8DcSICQQ90IAFNQQ90IgUgBUGAgAFyIgUgAiAFbCABSxsiBSAFQYDAAHIiBSACIAVsIAFLGyIFIAVBgCByIgUgAiAFbCABShsiBSAFQYAQciIFIAIgBWwgAUobIgUgBUGACHIiBSACIAVsIAFKGyIFIAVBgARyIgUgAiAFbCABShsiBSAFQYACciIFIAIgBWwgAUobIgUgBUGAAXIiBSACIAVsIAFKGyIFIAVBwAByIgUgAiAFbCABShsiBSAFQSByIgUgAiAFbCABShsiBSAFQRByIgUgAiAFbCABShsiBSAFQQhyIgUgAiAFbCABShsiBSAFQQRyIgUgAiAFbCABShsiBSAFQQJyIgUgAiAFbCABShsiBSAFQQFyIgUgAiAFbCABShsiATsBtgQgByABOwGyBCAHIBFB//8FIARrIgFNQQ90IgIgAkGAgAFyIgIgAiADbCABSxsiAiACQYDAAHIiAiACIANsIAFLGyICIAJBgCByIgIgAiADbCABShsiAiACQYAQciICIAIgA2wgAUobIgIgAkGACHIiAiACIANsIAFKGyICIAJBgARyIgIgAiADbCABShsiAiACQYACciICIAIgA2wgAUobIgIgAkGAAXIiAiACIANsIAFKGyICIAJBwAByIgIgAiADbCABShsiAiACQSByIgIgAiADbCABShsiAiACQRByIgIgAiADbCABShsiAiACQQhyIgIgAiADbCABShsiAiACQQRyIgIgAiADbCABShsiAiACQQJyIgIgAiADbCABShsiAiACQQFyIgIgAiADbCABShsiAzsBuAQgByADOwG8BCAHIBAvAQAiAzsBzAQgByADOwHIBCAHIA8vAQAiAzsB1AQgByADOwHQBCAHIAM7Ac4EIAcgAzsBygQgByAOLwEAIgI7AdYEIAcgA0EPdCABTUEPdCIEIARBgIABciIEIAMgBGwgAUsbIgQgBEGAwAByIgQgAyAEbCABSxsiBCAEQYAgciIEIAMgBGwgAUobIgQgBEGAEHIiBCADIARsIAFKGyIEIARBgAhyIgQgAyAEbCABShsiBCAEQYAEciIEIAMgBGwgAUobIgQgBEGAAnIiBCADIARsIAFKGyIEIARBgAFyIgQgAyAEbCABShsiBCAEQcAAciIEIAMgBGwgAUobIgQgBEEgciIEIAMgBGwgAUobIgQgBEEQciIEIAMgBGwgAUobIgQgBEEIciIEIAMgBGwgAUobIgQgBEEEciIEIAMgBGwgAUobIgQgBEECciIEIAMgBGwgAUobIgQgBEEBciIEIAMgBGwgAUobIgM7AcQEIAcgAzsBwAQgByADOwG+BCAHIAM7AboEIAcgAkEPdCABTUEPdCIDIANBgIABciIDIAIgA2wgAUsbIgMgA0GAwAByIgMgAiADbCABSxsiAyADQYAgciIDIAIgA2wgAUobIgMgA0GAEHIiAyACIANsIAFKGyIDIANBgAhyIgMgAiADbCABShsiAyADQYAEciIDIAIgA2wgAUobIgMgA0GAAnIiAyACIANsIAFKGyIDIANBgAFyIgMgAiADbCABShsiAyADQcAAciIDIAIgA2wgAUobIgMgA0EgciIDIAIgA2wgAUobIgMgA0EQciIDIAIgA2wgAUobIgMgA0EIciIDIAIgA2wgAUobIgMgA0EEciIDIAIgA2wgAUobIgMgA0ECciIDIAIgA2wgAUobIgMgA0EBciIDIAIgA2wgAUobIgE7AcYEIAcgATsBwgQgByACOwHSBCAHIA0vAQAiATsB3AQgByABOwHYBCAHIAwvAQAiATsB5AQgByABOwHgBCAHIAE7Ad4EIAcgATsB2gQgByALLwEAIgE7AeYEIAcgATsB4gQgCEGAKGotAAAhCCAJQX9qIgkNAAsLC58cAQR/IABBADYClAEgACAAKAKQATYChAEgACgCvAZB/wEgAEHYAGoiBigCAEECdEEEahCBDRogACgCuAZBwAAgBigCAEEDdEEIahCBDRoCQAJAAkACQAJAAkACQAJAAkACQAJAAkACQAJAAkACQAJAAkACQAJAIAVFBEAgACgCMEECTgRAIAAoAsQGIAAoAsgGaiIGQYCAgAg2AAAgACAAKALIBiIHQQRqNgLIBiAGQXwgB2tBA3FBBHJqIgZBA3ENAyAAQX82AswGIAAgBkEEaiIHNgLUBiAAIAY2AtgGIAZBzoCDvAFBzoCCvAEgAUEGRiIJGzYCACAAQQA2AtAGIAAgACgCzAYiCEEgaiIGNgLMBiAJRQRAIAAgCEEfaiIGNgLMBiAIQWBMBEAgCEFBTA0GIAAgB0EEaiIINgLUBiAHQQA2AgAgAEEANgLQBiAAIAAoAswGQSBqIgY2AswGIAghBwsgAEEANgLQBgsgACAGQX9qNgLMBiAGQQBMBEAgBkFhTA0GIAAgB0EEajYC1AYgB0EANgIAIABBADYC0AYgACAAKALMBkEgajYCzAYLIABBADYC0AYgABB5CyAAKALEBiAAKALIBmoiBkGAgIAINgAAIAAgACgCyAYiB0EEajYCyAYgBkF8IAdrQQNxQQRyaiIGQQNxDQUgAEEYNgLMBiAAIAY2AtQGIAAgBjYC2AYgAEEAQYCAgIAGIANBAEgbQYCAgChBgICACCABQQZGG3I2AtAGDAELIAAoAsQGIAAoAsgGaiIGQYCAgAg2AAAgACAAKALIBiIHQQRqNgLIBiAGQXwgB2tBA3FBBHJqIgZBA3ENBSAAQQA2AswGIAAgBjYC1AYgACAGNgLYBiAAQYCAgKABQYCAgKAHIANBAEgbQYCAgAZBgICABCABQQZGG3IgACgCNEVBD3RyQY8gcjYC0AYLQQAhBiAAKAKEAUEBaiIJIQcDQCAGQQFqIQYgB0EBdiIHDQALIABBzAZqIgggBkEBdEF/aiAJEHhBACEGIAAoAoABQQFqIgkhBwNAIAZBAWohBiAHQQF2IgcNAAsgCCAGQQF0QX9qIAkQeEEAIQYgBEEBaiIEIQcDQCAGQQFqIQYgB0EBdiIHDQALIAggBkEBdEF/aiAEEHggACAAKALMBkF7aiIGNgLMBiAAKAJUQR9xIQcgAAJ/IAZBAE4EQCAAKALQBgwBCyAGQWBMDQYgAEHUBmoiBCAEKAIAIglBBGo2AgAgCSAAQdAGaiIJKAIAIAdBACAGa3ZyIgZBGHQgBkEIdEGAgPwHcXIgBkEIdkGA/gNxIAZBGHZycjYCACAJQQA2AgAgACAAKALMBkEgaiIGNgLMBkEACyAHIAZ0cjYC0AYgAUEGRgRAQQAhBiAALQCIB0EBaiIEIQcDQCAGQQFqIQYgB0EBdiIHDQALIAggBkEBdEF/aiAEEHgLAkAgACgCgAENACAIIAgoAgBBfmoiBjYCACACQQBKIQcgAAJ/IAZBAE4EQCAAKALQBgwBCyAGQWBMDQggAEHUBmoiBCAEKAIAIglBBGo2AgAgCSAAKALQBiAHQQAgBmt2ciIGQRh0IAZBCHRBgID8B3FyIAZBCHZBgP4DcSAGQRh2cnI2AgAgAEEANgLQBiAAIAAoAswGQSBqIgY2AswGQQALIAcgBnRyNgLQBiACQQFIDQAgCEEDQQMQeEEAIQYgAiEHA0AgBkEBaiEGIAdBAXYiBw0ACyAIIAZBAXRBf2ogAhB4IAhBBUEEEHgLQQAhBgJAIANBAEgNACABQQZGBEAgACAAKALMBkF+aiIHNgLMBiAAKAIgQQBKIQEgAAJ/IAdBAE4EQCAAKALQBgwBCyAHQWBMDQogAEHUBmoiAyADKAIAIgJBBGo2AgAgAiAAKALQBiABQQAgB2t2ciIHQRh0IAdBCHRBgID8B3FyIAdBCHZBgP4DcSAHQRh2cnI2AgAgAEEANgLQBiAAIAAoAswGQSBqIgc2AswGQQALIAEgB3RyNgLQBgwBCyAIIAgoAgBBf2oiBzYCACADQQBKIQEgAAJ/IAdBAE4EQCAAKALQBgwBCyAHQWBMDQogAEHUBmoiAiACKAIAIgRBBGo2AgAgBCAAKALQBiABQQAgB2t2ciIHQRh0IAdBCHRBgID8B3FyIAdBCHZBgP4DcSAHQRh2cnI2AgAgAEEANgLQBiAAIAAoAswGQSBqIgc2AswGQQALIAEgB3RyNgLQBiADQQFIDQAgACgCnAcEQCAIQQNBAhB4IAhBAUEBEHgLAkAgACADai0A4wMEQCAIQQNBAxB4QQAhByADIQEDQCAHQQFqIQcgAUEBdiIBDQALIAMhAgwBCyAIQQVBBRB4QQAhByAAKAIgQQFqIgIhAQNAIAdBAWohByABQQF2IgENAAsLIAggB0EBdEF/aiACEHggCEEFQQcQeEEAIQcgAyEBA0AgB0EBaiEHIAFBAXYiAQ0ACyAIIAdBAXRBf2ogAxB4IAhBAUEBEHgLIAAoAoQEIAAoAlBrQQF0QX9qIgdBH3UgB3NBAWoiASEHA0AgBkEBaiEGIAdBAXYiBw0ACyAIIAZBAXRBf2ogARB4QQAhBiAAKAKsBkEBaiIBIQcDQCAGQQFqIQYgB0EBdiIHDQALIAggBkEBdEF/aiABEHggACgCrAZBAUcEQCAIIAgoAgBBfmoiBjYCACAAAn8gBkEATgRAIAAoAtAGDAELIAZBYEwNCyAAQdQGaiIHIAcoAgAiAUEEajYCACABIAAoAtAGQQNBACAGa3ZyIgZBGHQgBkEIdEGAgPwHcXIgBkEIdkGA/gNxIAZBGHZycjYCACAAQQA2AtAGIAAgACgCzAZBIGoiBjYCzAZBAAtBAyAGdHI2AtAGCwJAIAVFDQAgACAAKAI0IgY2AqQHIAZFDQAgCEEBQQEQeCAIQQFBARB4IAhBAUEBEHggCEEBQQEQeCAIIAgoAgBBf2oiBzYCACAAAn8gB0EATgRAIAAoAtAGDAELIAdBYEwNDCAAQdQGaiIGIAYoAgAiB0EEajYCACAHIAAoAtAGIgZBGHQgBkEIdEGAgPwHcXIgBkEIdkGA/gNxIAZBGHZycjYCACAAQQA2AtAGIAAgACgCzAZBIGoiBzYCzAZBAAsiBjYC0AYgACgCNEUNACAIIAdBf2oiATYCACAHQQBMBEAgB0FhTA0NIABB1AZqIgcgBygCACIHQQRqNgIAIAcgBkEIdEGAgPwHcSAGQRh0ciAGQQh2QYD+A3EgBkEYdnJyNgIAIABBADYC0AYgACAAKALMBkEgaiIBNgLMBkEAIQYLIAAgBjYC0AYgACgCpAciA0ECTw0NIAggAUF/aiIHNgIAAn8gAUEASgRAIAYhBSADDAELIAFBYUwNDyAAQdQGaiIBIAEoAgAiAUEEajYCAEEAIQUgASADQQAgB2t2IAZyIgZBGHQgBkEIdEGAgPwHcXIgBkEIdkGA/gNxIAZBGHZycjYCACAAQQA2AtAGIAAgACgCzAZBIGoiBzYCzAYgACgCpAcLIQEgACADIAd0IAVyIgY2AtAGAkAgAQRAIAchAQwBCyAIIAdBf2oiATYCACAHQQBMBEAgB0FhTA0RIABB1AZqIgcgBygCACIHQQRqNgIAIAcgBkEIdEGAgPwHcSAGQRh0ciAGQQh2QYD+A3EgBkEYdnJyNgIAIABBADYC0AYgACAAKALMBkEgaiIBNgLMBkEAIQYLIAAgBjYC0AYLIAggAUF/aiIHNgIAIAFBAEwEQCABQWFMDREgAEHUBmoiByAHKAIAIgdBBGo2AgAgByAGQQh0QYCA/AdxIAZBGHRyIAZBCHZBgP4DcSAGQRh2cnI2AgAgAEEANgLQBiAAIAAoAswGQSBqIgc2AswGQQAhBgsgACAGNgLQBiAAIAdBf2oiCDYCzAYgB0EATARAIAdBYUwNEiAAQdQGaiIHIAcoAgAiB0EEajYCACAHIAZBCHRBgID8B3EgBkEYdHIgBkEIdkGA/gNxIAZBGHZycjYCACAAQQA2AtAGIAAgACgCzAZBIGoiCDYCzAZBACEGCyAAIAY2AtAGIAAgCEF/aiIHNgLMBiAIQQBMBEAgCEFhTA0TIABB1AZqIgcgBygCACIHQQRqNgIAIAcgBkEIdEGAgPwHcSAGQRh0ciAGQQh2QYD+A3EgBkEYdnJyNgIAIABBADYC0AYgACAAKALMBkEgaiIHNgLMBkEAIQYLIAAgBjYC0AYgACAHQX9qNgLMBiAAIAdBAEwEfyAHQWFMDRQgAEHUBmoiByAHKAIAIgdBBGo2AgAgByAGQQh0QYCA/AdxIAZBGHRyIAZBCHZBgP4DcSAGQRh2cnI2AgAgAEEANgLQBiAAIAAoAswGQSBqNgLMBkEABSAGCzYC0AYLDwtBoCFBnx9B1cQAQbEhEAkAC0HrIUGfH0HOOEHHIRAJAAtB6yFBnx9BzjhBxyEQCQALQaAhQZ8fQdXEAEGxIRAJAAtBoCFBnx9B1cQAQbEhEAkAC0HrIUGfH0HOOEHHIRAJAAtB6yFBnx9BzjhBxyEQCQALQeshQZ8fQc44QcchEAkAC0HrIUGfH0HOOEHHIRAJAAtB6yFBnx9BzjhBxyEQCQALQeshQZ8fQc44QcchEAkAC0HrIUGfH0HOOEHHIRAJAAtBuyFBnx9ByThBxyEQCQALQeshQZ8fQc44QcchEAkAC0HrIUGfH0HOOEHHIRAJAAtB6yFBnx9BzjhBxyEQCQALQeshQZ8fQc44QcchEAkAC0HrIUGfH0HOOEHHIRAJAAtB6yFBnx9BzjhBxyEQCQALv9QBAld/AX4jAEGQCWsiBiQAIAAgACgCkAEiAiAAKAJYIgUgACgChAEiB2oiA04iBCAEQQlBCCAEGyAAKAKIASIzIAVBf2pGGyACIANBf2pIGyIEIARBAnIgBCAzGyACIAdGGyIEQQRyIAQgMxsgBCACIANKGyI8NgK0ASAAKALABiE/AkACQAJAAkACQAJAAkACQAJAAkACQAJAAkACfwJAAkACQAJAAkACQAJAIAAoAnxFBEAgACgCjAEhAwwBCyAAKAKMASEDAkAgM0EEdCICQRBqIAAoAgAiBEoEQCADQQR0IQUgACgCBCEIDAELIANBBHQiBUEQaiAAKAIEIghMDQELQRAgBCACayICQRAgAkEQSBsiCWshByAAKAJEIgIgCWshDSAAKAI4IAIgA2wgM2pBBHRqIQMgACgC3AYhAiAIIAVrIgRBECAEQRBIGyIKIQgDQCAJIQQDQCACIAMtAAAiBToAACACQQFqIQIgA0EBaiEDIARBf2oiBA0ACyAHBEAgAiAFIAcQgQ0gB2ohAgsgAyANaiEDIAhBf2oiCA0AC0EQIAprIgNFDQEgAkFwaiEEA0AgAiAEKQAANwAAIAIgBCkACDcACCACQRBqIQIgA0F/aiIDDQALDAELIAAoAtwGIgJBB3ENASAAKAI4IAAoAkQiBSADbCAzakEEdGoiA0EHcQ0CQRAhBANAIAMpAgAhWSACIAMpAgg3AgggAiBZNwIAIAJBEGohAiADIAVqIQMgBEF/aiIEDQALCyAAQf////8HNgKwASAAQQA2ApgBIAAgACgC3AYiAkGABGoiBzYCkAcgACACQYACaiICNgKMByAAKAKAAUUEQCAGQfgoKQMANwO4CCAGQfAoKQMANwOwCCAGQQA2ApAFIAZBkIDAADYC8AIgBkEANgJUIAZBkIDAADYCUCAGQdgHaiAAIAZB1ABqIAZB0ABqEIUBIABBADYCuAIgACgCtAYhAgJ/QQAgACgCtAFBA3FBA0cNABpBACACKAIARQ0AGkEAIAIgACgCiAFBBHRqKAIgRQ0AGiAAIAYoAtgHIig2ArgCIChBEHYLIS4gACACKAIANgLMBSAAIAAoAogBIgRBBHQgAmoiAygCIDYCvAUgACACKAIENgLgBSAAIAMoAiQ2AsAFIAAgAigCCDYC9AUgACADKAIoNgLEBSAAIAIoAgw2AogGIAAgAygCLDYCyAUgKEH//wNxIgMgLkEQdHIgACgCjAFBFnRqIgJBgIB8cSAEQQZ0IANqIj1B//8DcXIhLyACQRB2IT4gACgCyAIhDSAAKAK8AiE2Qf////8HIQhBgIACITQgAC4BdiACQRB1Sg0FIAAuAXogPkEQdEEQdUgNBSAALgF0ID1BEHRBEHUiAkoNBSAALgF4IAJIDQUgBkGQgMAANgKABSAGIC82AogFIAAoApAHIQIgBiAvNgJMIAZBkIDAADYCSCA2IA0gBkHMAGogBkHIAGogAhCGASAAKALcBkEQIAAoApAHIAZBkAVqEIcBITggBigCkAUiAiAGKAKUBSIDIAIgA0obIgIgBigCmAUiAyAGKAKcBSIEIAMgBEobIgMgAiADShsgACgC7AMiAkEBdEGAKWovAQBIBEAgAEF/NgKYASAAQQA2ArABIAAoApAHIQIgACAAKAKMBzYCkAcgACACNgKMByAAIC47AfoBIAAgKDsB+AEgBiAvNgJEIAYgLzYC+AQgACAGQcQAahCIAUEBIQ4DQCAAIA5BAnRqIgIoAjggACgCiAEiAyACKAJEIgkgACgCjAEiBGxqQQN0aiECIAAoApAHIA5BA3RqIRICQCAAKAJ8RQ0AAkAgA0EEdEEQaiAAKAIAIgVKBEAgACgCBCEHDAELIARBBHRBEGogACgCBCIHTA0BC0EAIAVBAm0gA0EDdGsiA0EIIANBCEgbIgtrIRNBCCALayEKIAkgC2shDyAAKALcBkGAAmohAyAHQQJtIARBA3RrIgRBCCAEQQhIGyIVIQkDQCALIQQDQCADIgUgAi0AACIHOgAAIANBAWohAyACQQFqIQIgBEF/aiIEDQALIAoEQCADIAcgChCBDRogBSATakEJaiEDCyACIA9qIQIgCUF/aiIJDQALQQggFWsiAgRAIANBeGohBANAIAMgBCkAADcAACADQQhqIQMgAkF/aiICDQALCyAAKALcBkGAAmohAkEIIQkLIBJBeGohA0EAIQRBACEFA0AgAi0AACADLQAAayIHIAdBH3UiB2ogB3MgBGogAi0AASADLQABayIEIARBH3UiBGogBHNqIAItAAIgAy0AAmsiBCAEQR91IgRqIARzaiACLQADIAMtAANrIgQgBEEfdSIEaiAEc2ogAi0ABCADLQAEayIEIARBH3UiBGogBHNqIAItAAUgAy0ABWsiBCAEQR91IgRqIARzaiACLQAGIAMtAAZrIgQgBEEfdSIEaiAEc2ogAi0AByADLQAHayIEIARBH3UiBGogBHNqIQQgA0EQaiEDIAIgCWohAiAFQQFqIgVBCEcNAAsgBCAAKALsAyICQQF0QYApai8BAEgEQCAOQQFqIg5BA0cNAQwKCwsgDkEDRg0IC0EAIQkCQCAAKALgBkEASg0AIAYoApgFIgMgBigClAUiBGsiBUEAIAVrIAVBAEgbIQsgBigCnAUiBSAGKAKQBSIHayIKIApBH3UiCmogCnMhDyADIAVrIAcgBGtqIgpBACAKayAKQQBIGyAEIAVrIAcgA2tqIgogCkEfdSIKaiAKc2oiCiAEIAdqIANqIAVqQQR1IgNKBEAgBkEBNgK0CAsgCyAPaiEEIApBACADa0gEQCAGQQE2ArgICyAEIARBH3UiBWogBXMgA0wNACAKIApBH3UiBGogBHMgA0oNACAGQQE2ArwIC0EBIQMgBiAoQQFqQfz/A3EgLkEBakH8/wNxQRB0ciI0NgLgB0EAICggLnJBA3ENBhogAkEBdEGALGovAQBB/gAgLkEQdEEQdSAGKALYByIEQRB1a0EBdEF/aiIFQR91IAVzQQFqZ0EBdCAoQRB0QRB1IARBEHRBEHVrQQF0QX9qIgRBH3UgBHNBAWpnQQF0amtsQQR1IQkgOCEIQQEMBgsgAUEBSA0HIAAoAjRFDQcgAEEGNgKYASACQQdxDQIgACgCvAIgACgCiAEgACgCyAIiBSAAKAKMAWxqQQR0aiIDQQdxDQNBECEEA0AgAykCACFZIAIgAykCCDcCCCACIFk3AgAgAkEQaiECIAMgBWohAyAEQX9qIgQNAAsgByAAKALAAiAAKAKIASAAKALMAiICIAAoAowBbGpBA3RqIAIQiQEgACgCkAdBCGogACgCxAIgACgCiAEgACgC0AIiAiAAKAKMAWxqQQN0aiACEIkBQQEhIgwSC0G0KEGfH0HsNEHFKBAJAAtB1ihBnx9B7TRBxSgQCQALQbQoQZ8fQew0QcUoEAkAC0HWKEGfH0HtNEHFKBAJAAtBACEJQQAhA0H/////ByE4QQALIQcgBkHgB2ogA0ECdHIgBigC2Ac2AgAgACgCtAEhAiAAKAK0BiEFIAAoAogBIQsgBkHgB2ogA0EBaiIKQQJ0ciIEQQA2AgAgBEEEaiEDIAUgC0EEdGohDwJAIAJBAnFFDQAgBSgCACIFQYCAAkYNACAEIAU2AgQgBEEIaiEDCyAPQSBqIQUCQCACQQFxRQ0AIAUoAgAiD0GAgAJGDQAgAyAPNgIAIANBBGohAwsCQCACQQhxRQ0AIAUoAhAiAkGAgAJGDQAgAyACNgIAIANBBGohAyAAKAKIASELCyADIARrQQJ1IApqIQIgC0EATARAIAZB4AdqIAJBAnRqQSA2AgAgAkEBaiECCyAAKAKMASIKQQBMBEAgBkHgB2ogAkECdGpBgICAATYCACACQQFqIQILIAZB4AdqIAJBAnRqIAAoApQHNgIAQQEhAyAGQeAHaiACQQFqIg9BAnRqIAAoApgHNgIAIAJBE0gEQCAGIAYoAuAHIgRBgIAEakGAgHBxIARBAWpB/P8DcXI2AuAHIAJBAE4EQEEBIQUDQCAGQeAHaiAFQQJ0aigCACICQYCABGpBgIBwcSACQQFqQfz/A3FyIQRBACECAkACQAJAIANBAUgNAANAIAQgBkHgB2ogAkECdGooAgBGDQEgAkEBaiICIANHDQALDAELIAIgA0cNAQsgBkHgB2ogA0ECdGogBDYCACADQQFqIQMLIAUgD0chAiAFQQFqIQUgAg0ACwsCQCAHIANOBEAgBigC2AciAkEQdSEPIAJBEHRBEHUhEwwBCyAGKALYByICQRB1IQ8gAkEQdEEQdSETIAYoArwIIRwgBigCuAghDiAGKAK0CCESA0ACQAJAIAAuAW4gBkHgB2ogB0ECdGoiBSgCACIEIApBFnRqIgJBEHVKDQAgAC4BciACQRB2QRB0IgJBEHVIDQAgAC4BbCAEIAtBBnRqQRB0IgtBEHUiCkoNACAALgFwIApIDQAgACgC7ANBAXRBgCxqLwEAQf4AIARBEHUgD2tBAXRBf2oiCkEfdSAKc0EBamdBAXQgBEEQdEEQdSATa0EBdEF/aiIEQR91IARzQQFqZ0EBdGprbEEEdSEEIDYgDSACQRJ1bCALQRJ1amogDSAAKALcBiAGQZAFaiAHQQR0aiIKEIcBIQICQCAAKALgBkEASg0AQQEgDiAKKAIIIgsgCigCDCIVayAKKAIAIhogCigCBCIKa2oiF0EAIBdrIBdBAEgbIAogFWsgGiALa2oiFyAXQR91IhdqIBdzaiIQQQAgCiAaaiALaiAVakEEdSIXa0gbIQ5BASASIBAgF0obIRIgFSAaayIVIBVBH3UiFWogFXMgCyAKayIKQQAgCmsgCkEASBtqIgogCkEfdSIKaiAKcyAXTA0AIBxBASAQIBBBH3UiCmogCnMgF0obIRwLIAIgBGogCCAJak4NACAFKAIAITQMAQsgCSEEIAghAgsgAyAHQQFqIgdHBEAgACgCjAEhCiAAKAKIASELIAIhCCAEIQkMAQsLIAYgHDYCvAggBiAONgK4CCAGIBI2ArQIIAAoAogBIQsgAiEICyAAKALsAyEEIAAoArQGIgIgC0EEdGoiAygCLCFEIAMoAighRSADKAIkIUYgAygCICFHIAIoAhwhSCACKAIMIUkgAigCGCFKIAIoAgghSyACKAIUIUwgAigCBCFNIAIoAhAhTiACKAIAIU9B////ByErIABB////BzYCsAEgBEEBdEGALGovAQBB/gAgNEEQdSAPa0EBdEF/aiICQR91IAJzQQFqZ0EBdCA0QRB0QRB1IBNrQQF0QX9qIgJBH3UgAnNBAWpnQQF0amtsQQR1IAhqIUAgACgC3AYiAkGABGohMCACQYACaiIDIRgDQAJAIBFBAnQiAiAGQbAIamooAgBFDQBBgAJBCEGAASARQQJGIgQbQYACIBEbIkFBAXQgBBshUEEIQRAgEUECcRsiBUEIQRAgEUEBcRsiCkEQdHIhKSAKQQN0IAVBAXZyQYgBcSFCIAJBkCpqKAIAIAAoAuwDQQF0QaAqai8BAGxBBHUhKyAKQQJ2ISIgBUECdiI3QX9qIVFBACE5QQAhLCADITpBACEbA0AgOSI7QQR0ITEgO0ECdCFDIDtBAnYiNUEEciEhIDYgDSA7bGohUgNAIAAoAogBIQIgACgCjAEhBCAAKQJsIVkgBiA5OwFqIAYgLDsBaCAGIAo7AWIgBiAFOwFgIAYgBigCaDYCQCAGIAYoAmA2AjwgBkGACWogACAGQUBrIAZBPGoQhQEgBigCgAkhKgJAIBFFBEAgAkEGdCA0aiIDIFmnIgIgA0EQdEEQdSACQRB0QRB1IgdKGyIDIFlCIIinIgggA0EQdEEQdSAIQRB0QRB1IgNIGyIOQYB/aiIIIAIgCEEQdEEQdSAHShtBEHRBEHUiCCADIAggA0gbIRcgDkGAAWoiCCACIAhBEHRBEHUgB0obQRB0QRB1IgcgAyAHIANIGyEcIA5B//8DcSAEQRZ0IDRqIgdBEHYgAkEQdSICIARBBnQgQ3IiBEGEfmoiAyADIAJIGyIDIAdBEHUgA0EQdEEQdSIHShsiAiBZQjCHpyIIIARB/AFqIgQgBCAIShsiBCACQRB0QRB1IARBEHRBEHUiCEgbIhpBEHRyIglBgICAfGoiAkEQdiADIAJBEHUgB0obQRB0QRB1IgIgBCACIAhIGyECIAlBgICABGoiCUEQdiADIAlBEHUgB0obQRB0QRB1IgMgBCADIAhIGyEDICwhJCAAKAKMASEPIAAoAogBIRIgACgC7AMhBCAAKALcBiEVDAELIAAoAowBIg9BFnQgKmoiH0EQdkEBakH8/wdxIgQgACkCbCJZpyICQRB1IgMgD0EGdCBDciIHQYR+aiIIIAggA0gbIgMgBEEQdEEQdSADQRB0QRB1IgRKGyIIIFlCMIenIgkgB0H8AWoiByAHIAlKGyITIAhBEHRBEHUgE0EQdEEQdSIQSBsiGkEQdCIcIAAoAogBIhJBBnQgKmoiFEEBakF8cSIHIAIgB0EQdEEQdSACQRB0QRB1IghKGyIHIFlCIIinIgkgB0EQdEEQdSAJQRB0QRB1IgtIGyIOQf//A3FyIgdBgICABGoiCUEQdiADIAlBEHUgBEobQRB0QRB1ISAgB0GAgIB8aiIHQRB2IAMgB0EQdSAEShtBEHRBEHUhFiA2ICwiJCAOQRB0IhlBEnVqIBxBEnUgO2ogDWxqaiEHIA5BgAFqIgMgAiADQRB0QRB1IAhKG0EQdEEQdSEXIA5BgH9qIgMgAiADQRB0QRB1IAhKG0EQdEEQdSEMIAAoAtwGIhUgMWogJGohCEEAIQNBACEJA0BBACECA0AgAiAHai0AACACIAhqLQAAayIEIARBH3UiBGogBHMgA2ohAyACQQFqIgIgBUcNAAsgCEEQaiEIIAcgDWohByAJQQFqIgkgCkcNAAsgACgC7AMiBEEBdEGALGovAQBB/gAgGUEQdSAUQRB0QRB1a0EBdEF/aiICQR91IAJzQQFqZ0EBdCAcQRB1IB9BEHVrQQF0QX9qIgJBH3UgAnNBAWpnQQF0amtsQQR1IANqIUAgFyALIBcgC0gbIRwgDCALIAwgC0gbIRcgICATICAgEEgbIQMgFiATIBYgEEgbIQILAkACQAJAIBwgDkEQdEEQdSIHSA0AIBcgB0oNACADQRB0QRB1IhYgGkEQdEEQdSIDSA0AIAJBEHRBEHUiICADSg0AICQgUmohHiAVIDFqICRqIR0gBEEBdEGALGohLSAPQRZ0ICpqQRB1ISUgEkEGdCAqakEQdEEQdSEjIEAhAgNAIAZBiAlqQn83AwAgBkJ/NwOACUEAIQtBBCEPQX8hGSAOIRIgGiEVIAIhHwNAAn8gCyAcIAtBAnRBoC1qKAIAIgIgFUEQdCIDIBJB//8DcXJqIhpBEHRBEHUiE0gNABogCyAXIBNKDQAaIAsgICACIANqIgJBEHUiDkoNABogCyAWIA5IDQAaIAsgC0EBdCIMIAZBgAlqaiIQLwEAQf//A0cNABogAkEQdiEUIB4gDSAObCATakECdWohB0EAIQNBACEJIB0hCANAQQAhAgNAIAIgB2otAAAgAiAIai0AAGsiBCAEQR91IgRqIARzIANqIQMgAkEBaiICIAVHDQALIAhBEGohCCAHIA1qIQcgCUEBaiIJIApHDQALIBAgLS8BAEH+ACAOICVrQQF0QX9qIgJBH3UgAnNBAWpnQQF0IBMgI2tBAXRBf2oiAkEfdSACc0EBamdBAXRqa2xBBHUgA2oiAzsBACALIAMgH04NABoCQCAZQX9MBEAgBiAGKQOACTcDiAkgBkJ/NwOACQwBCyAGQYAJaiAMQQhyai8BACECIAYgBikDgAk3A4gJIAZCfzcDgAkgBkGACWogGUEBc0EBdGogAjsBAAsgBkGACWogC0EBc0EBdGogHzsBAEEFIQ8gGiESIBQhFSALIRkgAyEfIAtBf2oLQQFqQQNxIQsgD0F/aiIPDQALAkAgHEEDQQIgBi8BhgkiGSAGLwGECSImSSIUGyICIAYvAYIJIicgBi8BgAkiMkkiEyAGQYAJaiACQQF0ci8BACAGQYAJaiATQQF0ci8BAEkiAxtBAnRBoC1qKAIAIgQgFUEQdCIQIBJB//8DcXIiDGogEyACIAMbQQJ0QaAtaigCACICaiIOQRB0QRB1IgtIDQAgFyALSg0AICAgAiAQaiAEQYCAfHFqIgJBEHUiD0oNACAWIA9IDQAgAkEQdiEaIB4gDSAPbCALakECdWohB0EAIQNBACEJIB0hCANAQQAhAgNAIAIgB2otAAAgAiAIai0AAGsiBCAEQR91IgRqIARzIANqIQMgAkEBaiICIAVHDQALIAhBEGohCCAHIA1qIQcgCUEBaiIJIApHDQALIC0vAQBB/gAgDyAla0EBdEF/aiICQR91IAJzQQFqZ0EBdCALICNrQQF0QX9qIgJBH3UgAnNBAWpnQQF0amtsQQR1IANqIgIgH0gNAQsLIAYgKTYC8AggBiAMNgL4CCAGIAw2AjggBiApNgI0IB4gDSAGQThqIAZBNGogGBCGASAAKALgBkEISg0BIAAuAXYgEEEQdSICSg0BIAAuAXogAkgNASAALgF0IBJBEHRBEHUiAkoNASAALgF4IAJIDQEgEkH//wNBASATGyIDQYCAfEGAgAQgFBsiBCAZICYgFBsgJyAyIBMbSyIHGyICIAQgAyAHGyIDaiIEaiEnIBIgAiAEamohMiAEQQF0IBJqIRAgAkEQdiIEIANBEHYiCGoiB0EQdCAMakEQdiFTIAdBEXQgDGpBEHYhICAEIAdqQRB0IAxqQRB2IVQgAiASaiFVIAMgEmohViACQQF0IBJqIRYgA0EBdCASaiEUIAJBgIB8cSAMakEQdiFXIANBgIB8cSAMakEQdiFYIARBEXQgDGpBEHYhGSAIQRF0IAxqQRB2ISYgGCBQaiIPIEFqIQtBACESIBggQWoiFyEJIBghDgNAAn8CfyASQQVNBEBBACEHAkACQAJAAkACQAJAIBJBAWsOBQECAwQFAAsgBiAZOwHqCCAGIBY7AegIIAYgKTYC4AggBiApNgIcIAYgBigC6Ag2AiAgHiANIAZBIGogBkEcaiAPEIYBIBkhHCAWIRUgDwwHCwNAIAdBBHQhBEEAIQIDQCAJIAIgBGoiA2ogAyAYai0AACADIA9qLQAAakEBakEBdjoAACACQQFqIgIgBUcNAAsgB0EBaiIHIApHDQALIFchHCBVDAULIAYgJjsB2gggBiAUOwHYCCAGICk2AtAIIAYgKTYCJCAGIAYoAtgINgIoIB4gDSAGQShqIAZBJGogCxCGASAmIRwgFCEVIAsMBQsgGCAXIA4gF0YbIQkDQCAHQQR0IQRBACECA0AgCSACIARqIgNqIAMgGGotAAAgAyALai0AAGpBAWpBAXY6AAAgAkEBaiICIAVHDQALIAdBAWoiByAKRw0ACyBYIRwgVgwDCyAYIBcgDiAXRhshCQNAIAdBBHQhBEEAIQIDQCAJIAIgBGoiA2ogAyAPai0AACADIAtqLQAAakEBakEBdjoAACACQQFqIgIgBUcNAAsgB0EBaiIHIApHDQALIFMhHCAnDAILIAYgIDsBygggBiAQOwHICCAGICk2AsAIIAYgKTYCLCAGIAYoAsgINgIwIB4gDSAGQTBqIAZBLGogGCALIAsgDkYiAhsiCxCGASAXIAkgAhshCSAgIRwgECEVIAsMAgsgGCAXIA4gF0YbIQlBACEHA0AgB0EEdCEEQQAhAgNAIAkgAiAEaiIDaiADIAtqLQAAIAMgD2otAABqQQFqQQF2OgAAIAJBAWoiAiAFRw0ACyAHQQFqIgcgCkcNAAsgVCEcIDILIRUgCQshGkEAIQMgGiEHQQAhEyAdIQgDQEEAIQIDQCACIAdqLQAAIAIgCGotAABrIgQgBEEfdSIEaiAEcyADaiEDIAJBAWoiAiAFRw0ACyAIQRBqIQggB0EQaiEHIBNBAWoiEyAKRw0ACyAtLwEAQf4AIBxBEHQiBEEQdSAla0EBdEF/aiICQR91IAJzQQFqZ0EBdCAVQRB0QRB1ICNrQQF0QX9qIgJBH3UgAnNBAWpnQQF0amtsQQR1IANqIgIgHyACIB9IIgIbIR8gGiAOIAIbIQ4gBCAVQf//A3FyIAwgAhshDCASQQFqIhJBB0cNAAsgDEEQdiEVDAILQbAtQZ8fQc3MAEHHLRAJAAsgEiEMIBghDgsCQCARRQRAIA4gGEGABGoiAkkEQCAYQYACaiAYIA4gGEYbITogAiEYIA4hMAwCCyAYQYAGaiACIAIgDkYbITogDiEwDAELIDAgMWogJGpBECAOEIoBIBFBAksNACAwIEJqIDFqICRqQRAgDiBCahCKAQsgHyAraiErIBtBAnQiAyARQQZ0IgIgBkHwAGpqaiAMIAAoAogBIgdBBnRrIgggKmtB//8DcSAVIAAvAYwBQQZ0ayIEICpBEHZrQRB0cjYCACAGQfACaiACaiADaiAIQf//A3EgBEEQdHIiAzYCACAAKAK0BiICICFBAnRqIAIgB0EEdGpBIGoiByBRICRBAnYiCGpBAnRqKAIANgIAQQEhBANAIAAoArQGIAQgIWpBAnRqIAM2AgBBACECIARBAWoiBCAiRw0AC0EAIQQDQCAAKAK0BiAEIDVqQQJ0aiADNgIAIARBAWoiBCAiRw0ACwNAIAcgAiAIakECdGogAzYCACACQQFqIgIgN0cNAAsgG0EBaiEbIAUgLGpBD3EiLA0ACyAKIDlqQQ9xIjkNAAsgACgCiAEhAiAAKAK0BiIDIE82AgAgACgCtAYgTjYCECADIAJBBHRqIgIgRzYCICAAKAK0BiBNNgIEIAAoArQGIEw2AhQgAiBGNgIkIAAoArQGIEs2AgggACgCtAYgSjYCGCACIEU2AiggACgCtAYgSTYCDCAAKAK0BiBINgIcIAIgRDYCLCArIAAoArABIgJOBEAgAiErIDohAwwBCyAAIBE2ApgBIAAgKzYCsAEgMCEDIDohMAsgEUEBaiIRQQRHDQALIAAgMDYCkAcgACADNgKMByAAQfgBaiIFIAAoApgBQQZ0IgQgBkHwAmpqIgIpAgA3AgAgACACKQIINwKAAiAAIAIpAhA3AogCIAAgAikCGDcCkAIgACACKQIgNwKYAiAAIAIpAig3AqACIAAgAikCMDcCqAIgACACKQI4NwKwAiAAIAZB8ABqIARqIgIpAgA3ArgBIAAgAikCCDcCwAEgACACKQIQNwLIASAAIAIpAhg3AtABIAAgAikCIDcC2AEgACACKQIoNwLgASAAIAIpAjA3AugBIAAgAikCODcC8AEgKyA4TA0BIABBADYCmAEgBigC2AchAiAAIC47AfoBIAUgKDsBACAAICggAmtB//8DcSAuIAJBEHZrQRB0cjYCuAEgACAAKALsA0EBdEGALGovAQBB/gAgLkEQdEEQdSACQRB1a0EBdEF/aiIEQR91IARzQQFqZ0EBdCAoQRB0QRB1IAJBEHRBEHVrQQF0QX9qIgJBH3UgAnNBAWpnQQF0amtsQQR1IDhqNgKwAQJAIAAuAXYgPkEQdEEQdUoNACAALgF6ID5BEHRBEHVIDQAgAC4BdCA9QRB0QRB1Sg0AIAAuAXggPUEQdEEQdUgNACAGQZCAwAA2AvgIIAYgLzYCgAkgBiAvNgIYIAZBkIDAADYCFCA2IA0gBkEYaiAGQRRqIAMQhgEgBiAvNgIQIAYgLzYC8AggACAGQRBqEIgBDAILQYgrQZ8fQdLQAEH9KRAJAAtB6ClBnx9BzM8AQf0pEAkACyAAKAKYAUEASA0BCyAAKALcBiICLQDwASIDIAItAP8BIgVrIgQgBEEfdSIEaiAEcyACLQAAIgcgAi0ADyIIayIEIARBH3UiBGogBHNqIAItAIABIAItAI8BayIEIARBH3UiBGogBHNqIQQgCCAFayIFIAVBH3UiBWogBXMgByADayIDIANBH3UiA2ogA3NqIAItAAggAi0A+AFrIgIgAkEfdSICaiACc2ohAkGWASAAKALsA2shBSAAAn8CQCA8QQdxQagvai0AACIHQQFxRQ0AIAIgBU4NAEEAIAQgAkEDbEEeakoNARoLQQJBAkEBIAIgBEEDbEEeakwbIAQgBU4bQQIgB0ECcRsLIgM2ApwBIAAoApAHIgJBA3ENAiA/IDNBBXRqQTBqQQAgPEEBcSIEa3EiG0EDcQ0DIDxBHnRBH3UgP3EhEQJAAn8CQAJAIANBAU0EQCADQQFrDQIMAQtBACEFQQAhAyARQSBPBEAgES0ADyARLQAOIBEtAA0gES0ADCARLQALIBEtAAogES0ACSARLQAIIBEtAAcgES0ABiARLQAFIBEtAAQgES0AAyARLQACIBEtAAAgES0AAWpqampqampqampqampqaiEFQQghAwsCQCAERQ0AIBtBIEkNACADQQhqIQMgGy0ADyAbLQAOIBstAA0gGy0ADCAbLQALIBstAAogGy0ACSAbLQAIIBstAAcgGy0ABiAbLQAFIBstAAQgGy0AAyAbLQACIBstAAEgBSAbLQAAampqampqampqampqampqaiEFCyADIAVqIANBEEZ2QQR2QYGChAhsQYCBgoR4IAMbIgQhAyAEIQUgBAwCCyACIBEtAABBgYKECGwiAzYCDCACIAM2AgggAiADNgIEIAIgAzYCACACIBEtAAFBgYKECGwiAzYCHCACIAM2AhggAiADNgIUIAIgAzYCECACIBEtAAJBgYKECGwiAzYCLCACIAM2AiggAiADNgIkIAIgAzYCICACIBEtAANBgYKECGwiAzYCPCACIAM2AjggAiADNgI0IAIgAzYCMCACIBEtAARBgYKECGwiAzYCTCACIAM2AkggAiADNgJEIAIgAzYCQCACIBEtAAVBgYKECGwiAzYCXCACIAM2AlggAiADNgJUIAIgAzYCUCACIBEtAAZBgYKECGwiAzYCbCACIAM2AmggAiADNgJkIAIgAzYCYCACIBEtAAdBgYKECGwiAzYCfCACIAM2AnggAiADNgJ0IAIgAzYCcCACIBEtAAhBgYKECGwiAzYCjAEgAiADNgKIASACIAM2AoQBIAIgAzYCgAEgAiARLQAJQYGChAhsIgM2ApwBIAIgAzYCmAEgAiADNgKUASACIAM2ApABIAIgES0ACkGBgoQIbCIDNgKsASACIAM2AqgBIAIgAzYCpAEgAiADNgKgASACIBEtAAtBgYKECGwiAzYCvAEgAiADNgK4ASACIAM2ArQBIAIgAzYCsAEgAiARLQAMQYGChAhsIgM2AswBIAIgAzYCyAEgAiADNgLEASACIAM2AsABIAIgES0ADUGBgoQIbCIDNgLcASACIAM2AtgBIAIgAzYC1AEgAiADNgLQASACIBEtAA5BgYKECGwiAzYC7AEgAiADNgLoASACIAM2AuQBIAIgAzYC4AEgAiARLQAPQYGChAhsIgM2AvABIAMhBSADIQcMAgsgGygCCCEFIBsoAgQhAyAbKAIAIQQgGygCDAshByACIAQ2AvABIAIgBzYC7AEgAiAFNgLoASACIAM2AuQBIAIgBDYC4AEgAiAHNgLcASACIAU2AtgBIAIgAzYC1AEgAiAENgLQASACIAc2AswBIAIgBTYCyAEgAiADNgLEASACIAQ2AsABIAIgBzYCvAEgAiAFNgK4ASACIAM2ArQBIAIgBDYCsAEgAiAHNgKsASACIAU2AqgBIAIgAzYCpAEgAiAENgKgASACIAc2ApwBIAIgBTYCmAEgAiADNgKUASACIAQ2ApABIAIgBzYCjAEgAiAFNgKIASACIAM2AoQBIAIgBDYCgAEgAiAHNgJ8IAIgBTYCeCACIAM2AnQgAiAENgJwIAIgBzYCbCACIAU2AmggAiADNgJkIAIgBDYCYCACIAc2AlwgAiAFNgJYIAIgAzYCVCACIAQ2AlAgAiAHNgJMIAIgBTYCSCACIAM2AkQgAiAENgJAIAIgBzYCPCACIAU2AjggAiADNgI0IAIgBDYCMCACIAc2AiwgAiAFNgIoIAIgAzYCJCACIAQ2AiAgAiAHNgIcIAIgBTYCGCACIAM2AhQgAiAENgIQIAIgBzYCDCACIAU2AgggAiADNgIEIAIgBDYCAAsgAiAHNgL8ASACIAU2AvgBIAIgAzYC9AEgACgC3AZBECAAKAKQByAGQbAIahCHASAAKALsAyIEQQF0IgJBwC5qLwEAaiACQaAqai8BAEE/IAAoApwBQQJqZ0EBdGtsQQR1aiICIAAoArABSARAIABBBjYCmAEgACACNgKwASAAKAKMByECIAAgACgCkAc2AowHIAAgAjYCkAcLAkAgACgC4AZBAk4EQCAAKAKAAUUNAQsgACgCkAEiAiAAKAJYIgcgACgChAEiBWoiA04hISACIANBf2pOBEAgIUEJQQggIRsgACgCiAEgB0F/akYbISELIAIgBUcEQCAhQQJyICEgACgCiAEbISELAkAgAiADTARAIAAoAogBIQMMAQsgIUEEaiAhIAAoAogBIgMbISELIAAoApAHIRogACgC1AIhHyAAKALcBiE1IAYgACgCwAYiAi0AIDoAowUgBiACLQAAOgCiBSAGIAItAAE6AKEFIAYgAi0AAjoAoAUgBiACLQADOgCfBSAGIAItAAQ6AJ4FIAYgAi0ABToAnQUgBiACLQAGOgCcBSAGIAItAAc6AJsFIAYgAi0ACDoAmgUgBiACLQAJOgCZBSAGIAItAAo6AJgFIAYgAi0ACzoAlwUgBiACLQAMOgCWBSAGIAItAA06AJUFIAYgAi0ADjoAlAUgBiACLQAPOgCTBSAGIAIgA0EFdGoiAigCMDYCpAUgBiACKAI0NgKoBSAGIAIoAjg2AqwFIAYgAigCPDYCsAUgBiACKAJQNgK0BSAAQZQEaiEkICFBAnEhLCAhQQFxIS0gBEEBdEGAMGovAQAhDCAGQaQFaiE3QQAhBEEAIRUDQCAhIARB8DBqLQAAIgVxIAVBBHZyIQMgNyAEQQNxIgdBAnQiCWogBEH8////B3FrIQIgACgCvAYiCCAAKAKIAUECdGogB2pBBGohHCAIIARBAnYiB2ohF0EAIQggAkEAAn8gBUEEcUUEQCADIANBBHIiBSAEQQRJGyADICwbIgMgBSAEQQNLGyADIC0bIQMLIAMLIANBCHIgBEECSxsgAyAtGyISQQFxIhYbIQMgB0EGdCAJciIPIAAoAtwGaiITKAIwIQkgEygCICENIBMoAhAhCiATKAIAIQsgFywAACIOIBwsAAAiEEghGCAAKALsA0EBdEGgKmohFEEAIQcgAkF7aiIgQQAgEkECcSIZQQF2GyIFQSBPBEAgBS0AAyAFLQACIAUtAAAgBS0AAWpqaiEIQQIhBwsgDiAQIBgbIQ4gFC8BACEQAkAgA0UNACADQSBJDQAgB0ECaiEHIAMtAAMgAy0AAiADLQABIAggAy0AAGpqamohCAtBAiEFIA8gGmoiAyAHIAhqIAdBBEZ2QQJ2QYGChAhsQYCBgoR4IAcbIgc2AjAgAyAHNgIgIAMgBzYCECADIAc2AgAgCyAKIA0gCSAHIAcgByAHEIsBQQAgEEEDbEEEdiIPQQIgDiAOQQBIGyIIQQJGG2ohEAJAIBZFBEAgECEHDAELIAIoAgQiJiEWIBJBCHFFBEAgAiACLQADQYGChAhsIhY2AgQLAkAgCyAKIA0gCSACKAIAIg4gDiAOIA4QiwEgD0EAIAgbaiIHIBBOBEAgECEHDAELIAMgDjYCMCADIA42AiAgAyAONgIQIAMgDjYCACACLQAAIQ4gAi0ABCEWQQAhBQsgCyAKIA0gCSACLQAGIhhBAmoiECAWQf8BcSIWaiACLQAFIh5BAXRqQQZ0IAItAAciFEEDbCAQakEWdHJBgP6HeHEgHkECaiIdIAItAAMiECAWQQF0ampBAnZyIBhBAXQgFGogHWpBDnRBgID8D3FyIiVBCHQgAi0AAiIYQQJqIicgEEEBdCAWampBAnZyIiNBCHQgECACLQABIh1qIBhBAXRqQQJqQQJ2ciIUQQh0ICcgDkH/AXEiImogHUEBdGpBAnZyIg4gFCAjICUQiwFBACAPIAhBA0YbaiInIAdIBEAgAyAlNgIwIAMgIzYCICADIBQ2AhAgAyAONgIAIAItAAAhIiACLQAEIRYgAi0AASEdIAItAAIhGCACLQADIRAgAi0ABSEeQQMhBSAnIQcLIAsgCiANIAkgECAWQQFqIhZqQQ90QYCA/A9xIBAgGGpBB3RBgAFqQYD+B3EgHUEBaiIdIBhqQQF2cnIiEEEIdCAdICJqQQF2ciIYIA4gECAWIB5qQRd0QYCAgHhxciIQIBQQiwFBACAPIAhBB0YbaiIWIAdIBEAgAyAUNgIwIAMgEDYCICADIA42AhAgAyAYNgIAQQchBSAWIQcLIAIgJjYCBAsCQCAZRQ0AICAtAAAiFCEQIAsgCiANIAkgAkF+aiIeLQAAIhhBgYKECGwiHSACQX1qIiUtAAAiDkGBgoQIbCIjIAJBfGoiIi0AACIWQYGChAhsIiYgFEGBgoQIbCIZEIsBQQAgDyAIQQFGG2oiJyAHSARAIAMgGTYCMCADICY2AiAgAyAjNgIQIAMgHTYCACAeLQAAIRggJS0AACEOICAtAAAhECAiLQAAIRZBASEFICchBwsgCyAKIA0gCSAWQQJqIh4gDkEBdCAYampBBnRBgP4HcSAOIBhqQQFqQQF2ciAOIBBqIBZBAXRqQQZ0QYABakGA/gdxIBZBAWoiFiAOakEBdnIiGEEQdHIiHSAeIBBBA2xqQQZ0QYD+B3EgFEGAgIQIbCAQIBZqQQF2cnIiDkEQdCAYciIQIA4gGRCLAUEAIA8gCEEIRhtqIhYgB04NACADIBk2AjAgAyAONgIgIAMgEDYCECADIB02AgBBCCEFIBYhBwsCQCASQQdxQQdHDQAgCyAKIA0gCSACLQAAIhBBAmoiFiACLQACIhIgAi0AASIOQQF0ampBDnRBgID8D3EgDkECaiIOIAItAAMgEkEBdGpqQRZ0QYCAgHhxciAQQQF0IA5qIAJBf2oiIy0AACIOakEGdEGA/gdxciACQX5qIiYtAAAiEiAOQQF0IBZqakECdnIiFiAWQQh0IhkgAkF9aiInLQAAIhBBAmoiFCASQQF0IA5qakECdnIiHiAeQQh0IAJBfGoiMi0AACIYIBIgEEEBdGpqQQJqQQJ2ciIdICAtAAAiJSAYQQF0IBRqakECdiIiIB1BCHRyIhQQiwFBACAPIAhBBEYbaiIqIAdIBEAgAyAUNgIwIAMgHTYCICADIB42AhAgAyAWNgIAICAtAAAhJSAyLQAAIRggJy0AACEQICYtAAAhEiAjLQAAIQ5BBCEFICohBwsgCyAKIA0gCSASQQFqIiAgDmpBAXYgGXIiEiAQICBqQQF2IBRBEHZB/wFxIiBBCHRyIh4gEkEQdHIiHSAYQQFqIhggEGpBAXYgFEEIdkH/AXEiEEEIdHIiFCAeQRB0ciIeICJBCHRBgP4DcSAYICVqQQF2ciAUQRB0ciIYEIsBQQAgDyAIQQZGG2oiFCAHSARAIAMgGDYCMCADIB42AiAgAyAdNgIQIAMgEjYCACAjLQAAIQ5BBiEFIBQhBwsgCyAKIA0gCSACLQACQQFqIhIgAi0AASIYakEPdEGAgPwPcSASIAItAANqQRd0QYCAgHhxciACLQAAQQFqIhIgDmpBAXZyIBIgGGpBB3RBgP4HcXIiDiAWIA5BCHQgIHIiEiAQIBlyIhAQiwFBACAPIAhBBUYbaiIJIAdODQAgAyAQNgIwIAMgEjYCICADIBY2AhAgAyAONgIAQQUhBSAJIQcLIBwgBToAACAXIAU6AAAgACAEakF/IAUgBSAISmsgBSAIRhs6AKABIBVBAXQhFSA1IARBBnRqQaAKaiEFAkAgB0EEdEEEdSIHIAAoAuwDQQF0QYAxai8BAEoEQCATIANBEEECIAUgJBCMASIIIBVyIRUgCEEBcUUNASADQRAgAyAFQQFBfxCNAQwBCyAFQgA3AQAgBUIANwE4IAVCADcBMCAFQgA3ASggBUIANwEgIAVCADcBGCAFQgA3ARAgBUIANwEICyACIAMtAAM6AAIgAiADLQATOgABIAIgAy0AIzoAACACQXxqIAMoAjA2AgAgByAMaiEMIARBAWoiBEEQRw0ACyAAKALcBiAVOwGQFyAMIAAoArABTg0AIABBBTYCmAEgACAMNgKwASAfQQdxDQUgGkEHcQ0GIAAoAuACIQNBECECA0AgGikCACFZIB8gGikCCDcCCCAfIFk3AgAgAyAfaiEfIBpBEGohGiACQX9qIgINAAsLIAAoApgBQQRKDQELIAAuAZYHIgUgBWwgAC4BlAciByAHbGohDSAAKAL4ASICQRB0QRB1IgMgA2wgAkEQdSIEIARsaiIKIAAuAZoHIgggCGwgAC4BmAciCSAJbGpJBEAgACAEIAVBP2xqQSBqQQZ2OwGWByAAIAMgB0E/bGpBIGpBBnY7AZQHCyAKIA1PBEAgACAEIAhBP2xqQSBqQQZ2OwGaByAAIAMgCUE/bGpBIGpBBnY7AZgHCyAGIAAoAowBQRZ0IAJqQYCAfHEgACgCiAFBBnQgAmpB//8DcXIiAjYCDCAGIAI2AlggACAGQQxqEIgBDAgLIAAoApAHIgVBA3ENBCAbQRBqIgJBA3ENBUEAISIgACgCnAEiA0EATARAIBsoAhAhAiAbKAIUIQMgGygCGCEEIAUgGygCHCIHNgJ8IAUgBDYCeCAFIAM2AnQgBSACNgJwIAUgBzYCbCAFIAQ2AmggBSADNgJkIAUgAjYCYCAFIAc2AlwgBSAENgJYIAUgAzYCVCAFIAI2AlAgBSAHNgJMIAUgBDYCSCAFIAM2AkQgBSACNgJAIAUgBzYCPCAFIAQ2AjggBSADNgI0IAUgAjYCMCAFIAc2AiwgBSAENgIoIAUgAzYCJCAFIAI2AiAgBSAHNgIcIAUgBDYCGCAFIAM2AhQgBSACNgIQIAUgBzYCDCAFIAQ2AgggBSADNgIEIAUgAjYCAAwJCyADQQFGDQYgEUEQaiEDQQIhCQNAIAUhBEEAIQdBACEFIANBIEkiDUUEQEECIQUgAy0AAyADLQACIAMtAAAgAy0AAWpqaiEHCyACQSBJIgpFBEAgBUECaiEFIAItAAMgAi0AAiACLQABIAcgAi0AAGpqamohBwsgBCAFIAdqIAVBBEZ2QQJ2QYGChAhsQYCBgoR4IAUbIgc2AgQgBCAHNgJAIAQgBzYCACACQQRqIQtBACEIQQAhBSADQQRqQSBJIg9FBEAgAy0AByADLQAGIAMtAAQgAy0ABWpqaiEIQQIhBQsgBAJ/IAtBIEkiC0UEQCACLQAHIAItAAYgAi0ABSAIIAItAARqampqIQggBUECaiEFCyAFIAhqIAVBBEZ2QQJ2QYGChAhsC0GAgYKEeCAFGyITNgJEIAchCCAKRQRAQQAhCEEAIQUgBAJ/IAtFBEAgAi0AByACLQAGIAItAAQgAi0ABWpqaiEIQQIhBQsgBSAIaiAFQQRGdkECdkGBgoQIbAtBgIGChHggBRsiCDYCBAsgByEKIA1FBEBBACENQQAhBSAEAn8gD0UEQCADLQAHIAMtAAYgAy0ABCADLQAFampqIQ1BAiEFCyAFIA1qIAVBBEZ2QQJ2QYGChAhsC0GAgYKEeCAFGyIKNgJACyACQQhqIQIgA0EIaiEDIARBCGohBSAJQX9qIgkNAAsgBCAINgI0IAQgBzYCMCAEIAg2AiQgBCAHNgIgIAQgCDYCFCAEIAc2AhAgBCATNgJ0IAQgCjYCcCAEIBM2AmQgBCAKNgJgIAQgEzYCVCAEIAo2AlAgBCAEKAI4IgI2AkggBCAEKAI8IgM2AmwgBCACNgJoIAQgAzYCXCAEIAI2AlggBCADNgJMIAQgBEF4aigCACICNgIIIAQgBEF8aigCACIDNgIsIAQgAjYCKCAEIAM2AhwgBCACNgIYIAQgAzYCDAwHC0GwL0GfH0HQMEHHLxAJAAtB4S9Bnx9B0TBBxy8QCQALQbQoQZ8fQew0QcUoEAkAC0HWKEGfH0HtNEHFKBAJAAtBsC9Bnx9B9zBBzTIQCQALQeEvQZ8fQfgwQc0yEAkACyARLQAQIQIgBSARLQAYQYGChAhsIgM2AgwgBSADNgIIIAUgAkGBgoQIbCICNgIEIAUgAjYCACARLQARIQIgBSARLQAZQYGChAhsIgM2AhwgBSADNgIYIAUgAkGBgoQIbCICNgIUIAUgAjYCECARLQASIQIgBSARLQAaQYGChAhsIgM2AiwgBSADNgIoIAUgAkGBgoQIbCICNgIkIAUgAjYCICARLQATIQIgBSARLQAbQYGChAhsIgM2AjwgBSADNgI4IAUgAkGBgoQIbCICNgI0IAUgAjYCMCARLQAUIQIgBSARLQAcQYGChAhsIgM2AkwgBSADNgJIIAUgAkGBgoQIbCICNgJEIAUgAjYCQCARLQAVIQIgBSARLQAdQYGChAhsIgM2AlwgBSADNgJYIAUgAkGBgoQIbCICNgJUIAUgAjYCUCARLQAWIQIgBSARLQAeQYGChAhsIgM2AmwgBSADNgJoIAUgAkGBgoQIbCICNgJkIAUgAjYCYCARLQAXIQIgBSARLQAfQYGChAhsIgM2AnwgBSADNgJ4IAUgAkGBgoQIbCICNgJ0IAUgAjYCcAtBACEiC0F+IAAoApgBIgMgIhshHSAAKALcBiEMIAAoArgGIhQgACgCiAEiAkEDdGpBCGohGSADQQVHBEAgAkECdCAAKAK8BiICakGChIgQNgIEIAJBgoSIEDYCACAAKAKIASECCyAAQaQGaiIDIAAoAqgGIAJqLQAAIAMoAgBBBHZBkIQhcXI2AgAgBiAZLQAAOgCVBSAZQQA6AAAgBiAULQAAOgCTBSAUQQA6AAAgBiAZLQABOgCWBSAZQQA6AAEgBiAULQABOgCSBSAUQQA6AAEgBiAZLQACOgCXBSAZQQA6AAIgBiAULQACOgCRBSAUQQA6AAIgBiAZLQADOgCYBSAZQQA6AAMgBiAULQADOgCQBSAUQQA6AANBCUEIIB1BBUobIS0gDEGIF2ohHCAMQYAXaiEXIABB6ARqIRYgDEHgFGohECAMQcASaiEgIAxBgApqISMgDEHgFmohISAAQZQEaiElIAxBoApqIR4gACgCmAEhAgJAAkACQAJAAkACQANAAkACQCACQQFqIgJBBksNAAJAIAJBAWsOBgEBAQEBAgALIAAoAoABQQJGDQYgAEGUAWoiAiACKAIAQQFqNgIAIBRBADYCBCAZQQA2AgQgACgC+AEhAiAAKAK0BiIDIAMgACgCiAFBBHRqIgNBLGoiBCgCADYCECAAKAK0BiACNgIUIAAoArQGIAI2AhggACgCtAYgAjYCHCAAKAK0BiACNgIAIAAoArQGIAI2AgQgACgCtAYgAjYCCCAAKAK0BiACNgIMIAQgAjYCACADIAI2AiggAyACNgIkIAMgAjYCICAAIAAoAvgBIgI2ApgGIAAgAjYClAYgACACNgKQBiAAIAI2AowGIAAgAjYChAYgACACNgKABiAAIAI2AvwFIAAgAjYC+AUgACACNgLwBSAAIAI2AuwFIAAgAjYC6AUgACACNgLkBSAAIAI2AtwFIAAgAjYC2AUgACACNgLUBSAAIAI2AtAFIAAoAtQCIgJBB3ENBSAAKAKMByIDQQdxDQQgACgC4AIhBUEQIQQDQCADKQIAIVkgAiADKQIINwIIIAIgWTcCACACIAVqIQIgA0EQaiEDIARBf2oiBA0ACyAAKALYAiAAKALkAiAAKAKQBxCKASAAKALcAiAAKALoAiAAKAKQB0EIahCKAQwICyAMIAAoAowHQRAgLSAeICUQjAEhAiAAKALcBiACOwGQFyAdQQZOBEAgIxCOASAMIAAuAZQEIgIgDC4BgApsQYCACGpBEnUiAzsB4BYgDCADOwGACiAMIAIgDC4BggpsQYCACGpBEnUiAzsBggogDCADOwHiFiAMIAIgDC4BhApsQYCACGpBEnUiAzsBhAogDCADOwHkFiAMIAIgDC4BhgpsQYCACGpBEnUiAzsBhgogDCADOwHmFiAMIAIgDC4BiApsQYCACGpBEnUiAzsBiAogDCADOwHoFiAMIAIgDC4BigpsQYCACGpBEnUiAzsBigogDCADOwHqFiAMIAIgDC4BjApsQYCACGpBEnUiAzsB7BYgDCADOwGMCiAMIAIgDC4BjgpsQYCACGpBEnUiAzsB7hYgDCADOwGOCiAMIAIgDC4BkApsQYCACGpBEnUiAzsB8BYgDCADOwGQCiAMIAIgDC4BkgpsQYCACGpBEnUiAzsB8hYgDCADOwGSCiAMIAIgDC4BlApsQYCACGpBEnUiAzsB9BYgDCADOwGUCiAMIAIgDC4BlgpsQYCACGpBEnUiAzsB9hYgDCADOwGWCiAMIAIgDC4BmApsQYCACGpBEnUiAzsB+BYgDCADOwGYCiAMIAIgDC4BmgpsQYCACGpBEnUiAzsB+hYgDCADOwGaCiAMIAIgDC4BnApsQYCACGpBEnUiAzsB/BYgDCADOwGcCiAMIAIgDC4BngpsQYCACGpBEnUiAjsB/hYgDCACOwGeCiAjEI4BIAAvAZYEIgJBA3ENAyAMIAJBAnYiAiAMLwGACmw7AcAKIAwgDC8BggogAmw7AYALIAwgDC8BhAogAmw7AcALIAwgDC8BhgogAmw7AYAMIAwgDC8BiAogAmw7AcAMIAwgDC8BigogAmw7AYANIAwgDC8BjAogAmw7AcANIAwgDC8BjgogAmw7AYAOIAwgDC8BkAogAmw7AcAOIAwgDC8BkgogAmw7AYAPIAwgDC8BlAogAmw7AcAPIAwgDC8BlgogAmw7AYAQIAwgDC8BmAogAmw7AcAQIAwgDC8BmgogAmw7AYARIAwgDC8BnAogAmw7AcARIAwgDC8BngogAmw7AYASQf//AyECCyAAKALUAiAAKALgAiAAKAKMByAeQQQgAkEQdBCNAQtBACEVIAAoAtwGLwGQFyICQYCYA3FBAEciA0ECciADIAJBgOYAcRsiA0EEciADIAJBzAFxGyIDQQhyIAMgAkEzcRshH0EBIRMDQCAAIBNBAnRqIg4oAjggACgCiAEiBCAOKAJEIgMgACgCjAEiBWxqQQN0aiECICAgECATQQFGIhobIQsgACgCkAcgE0EDdGpBeGohEgJAIAAoAnxFDQACQCAEQQR0QRBqIAAoAgAiB0oEQCAAKAIEIQgMAQsgBUEEdEEQaiAAKAIEIghMDQELQQAgB0ECbSAEQQN0ayIEQQggBEEISBsiDWshD0EIIA1rIQkgAyANayEKIAAoAtwGIQMgCEECbSAFQQN0ayIEQQggBEEISBsiGCEIA0AgDSEEA0AgAyIFIAItAAAiBzoAACADQQFqIQMgAkEBaiECIARBf2oiBA0ACyAJBEAgAyAHIAkQgQ0aIAUgD2pBCWohAwsgAiAKaiECIAhBf2oiCA0AC0EIIBhrIgIEQCADQXhqIQQDQCADIAQpAAA3AAAgA0EIaiEDIAJBf2oiAg0ACwsgACgC3AYhAkEIIQMLIAIgEiADQQUgCyAWEIwBIQcgC0FmaiICIAIvAQAiCSALQWBqIgUvAQAiDSALQWJqIgMvAQAiCmsiDyALQWRqIgQvAQAiCGtqOwEAIAQgCiANaiINIAhrIAlrOwEAIAMgCCAPaiAJazsBACAFIAkgCCANamoiCTsBACAFIAAvAegEQRF0QRB1IgggCUEQdEEQdSIJbEHWqg1BqtUCIAlBAEgbakESdSINOwEAIBcgHCAaGyIJIA07AQAgAyADLgEAIg0gCGxB1qoNQarVAiANQQBIG2pBEnUiDTsBACAJIA07AQIgBCAELgEAIg0gCGxB1qoNQarVAiANQQBIG2pBEnUiDTsBACAJIA07AQQgAiACLgEAIg0gCGxB1qoNQarVAiANQQBIG2pBEnUiCDsBACAJIAg7AQYgAiACLwEAIgkgBS8BACIKIAMvAQAiD2siGiAELwEAIghraiINOwEAIAQgCiAPaiICIAhrIAlrIgo7AQAgAyAIIBpqIAlrIgQ7AQAgBSAJIAIgCGpqIgM7AQACQAJAAkAgAC8B6gQiAkEBcUUEQCALIAJBAXYiAiANbDsB4AEgCyACIApsOwGgASALIAIgBGw7AWAgCyACIANsOwEgQQIgFSAHGyECIAcgAyAEciAKciANckH//wNxIgRBAEciA3JFBEAgDigC1AIgDigC4AIgEhCKAQwECyAERQ0CIAdBf3MiBEEIcQRAIAtCADcBOCALQgA3ATIgC0IANwEqIAtCADcBIgsgBEEEcQRAIAtCADcBeCALQgA3AXIgC0IANwFqIAtCADcBYgsgBEECcQRAIAtCADcBuAEgC0IANwGyASALQgA3AaoBIAtCADcBogELQQ8hByAEQQFxDQEMAgtBszRBnx9BgDZBwjQQCQALIAtCADcB+AEgC0IANwHyASALQgA3AeoBIAtCADcB4gELIA4oAtQCIA4oAuACIBIgC0ECIAdBHHQQjQELIAIgA3IhFSATQQFqIhNBA0cNAAsCQCAAKAKYASIEIBVBAiAVQQJIGyISIB9ycg0AIAAoAvgBIAAoArgCRw0AQX8hAiAAQX82ApgBDAELCyAdQQZIBH8gHwUgACgCnAEgEkECdEEMQQAgHxtqIARqaiEEQQ9BACAfGwshFiAAKAKAAUECRiIFRQRAQQAhAiAAKAKUAUEBaiIHIQMDQCACQQFqIQIgA0EBdiIDDQALIABBzAZqIAJBAXRBf2ogBxB4IABBADYClAELAkACQAJAAkACQAJAIAFBAUgNACAAKAKkB0UNACAAIAAoAswGQX9qIgI2AswGIAACfyACQQBOBEAgACgC0AYMAQsgAkFgTA0CIABB1AZqIgMgAygCACIHQQRqNgIAIAcgAEHQBmoiCCgCACAiQQAgAmt2ciICQRh0IAJBCHRBgID8B3FyIAJBCHZBgP4DcSACQRh2cnI2AgAgCEEANgIAIAAgACgCzAZBIGoiAjYCzAZBAAsgIiACdHI2AtAGCyAiRQRAQQAhAiAEQXtqIAQgBRsgBCAEQQRKG0EBaiIEIQMDQCACQQFqIQIgA0EBdiIDDQALIABBzAZqIAJBAXRBf2ogBBB4CyAAKAKYAUEDRgRAIAAgACgCzAZBf2oiAjYCzAYCfyACQQBOBEAgACgC0AYMAQsgAkFgTA0DIABB1AZqIgMgAygCACIDQQRqNgIAIAMgAEHQBmoiBSgCAEEBQQAgAmt2ciICQRh0IAJBCHRBgID8B3FyIAJBCHZBgP4DcSACQRh2cnI2AgAgBUEANgIAIAAgACgCzAZBIGoiAjYCzAZBAAshBCAAIAJBf2oiAzYCzAYgAEEBIAJ0IARyIgQ2AtAGIAJBAEoEfyAEBSACQWFMDQQgAEHUBmoiAiACKAIAIgdBBGo2AgAgB0EBQQAgA2t2IARyIgJBGHQgAkEIdEGAgPwHcXIgAkEIdkGA/gNxIAJBGHZycjYCACAAQQA2AtAGIAAgACgCzAZBIGoiAzYCzAZBAAshBSAAIANBf2oiAjYCzAYgAEEBIAN0IAVyIgQ2AtAGIANBAEoEfyAEBSADQWFMDQUgAEHUBmoiAyADKAIAIgNBBGo2AgAgA0EBQQAgAmt2IARyIgJBGHQgAkEIdEGAgPwHcXIgAkEIdkGA/gNxIAJBGHZycjYCACAAQQA2AtAGIAAgACgCzAZBIGoiAjYCzAZBAAshBSAAIAJBf2oiAzYCzAYgAEEBIAJ0IAVyIgQ2AtAGIAAgAkEASgR/IAQFIAJBYUwNBiAAQdQGaiICIAIoAgAiBUEEajYCACAFQQFBACADa3YgBHIiA0EYdCADQQh0QYCA/AdxciADQQh2QYD+A3EgA0EYdnJyNgIAIABBADYC0AYgACAAKALMBkEgaiIDNgLMBkEAC0EBIAN0cjYC0AYLICINCSAAKAKYASICQQVOBEAgAkEFRgRAIABBzAZqIQVBACECA0AgBUEBQQQgACACQaAzai0AAGosAKABIgNBAEgiBBtBASADIAQbEHggAkEBaiICQRBHDQALC0EAIQIgACgCnAEiAyADQQJzIANBAXEbQQFqIgQhAwNAIAJBAWohAiADQQF2IgMNAAsgAEHMBmogAkEBdEF/aiAEEHggACgCtAYiAiACIAAoAogBQQR0aiICKAIsNgIQIAAoArQGQYCAAjYCFCAAKAK0BkGAgAI2AhggACgCtAZBgIACNgIcIAAoArQGQYCAAjYCACAAKAK0BkGAgAI2AgQgACgCtAZBgIACNgIIIAAoArQGQYCAAjYCDCACQoCAgoCAgCA3AiggAkKAgIKAgIAgNwIgDAoLQQJBBCACQQFxGyEHQQJBBCACQQJxGyEEIABBzAZqIQ9BACELIABBiAFqIRpBACEIQQAhCQNAQQAhAiAAIAtBAnQiBWpBuAFqIg0uAQBBAXRBf2oiA0EfdSADc0EBaiIKIQMDQCACQQFqIQIgA0EBdiIDDQALIA8gAkEBdEF/aiAKEHhBACECIA0uAQJBAXRBf2oiA0EfdSADc0EBaiINIQMDQCACQQFqIQIgA0EBdiIDDQALQQEhAyAPIAJBAXRBf2ogDRB4IAUgGmpB8ABqIhMoAgAhBSAAKAK0BiICIAlBBGoiDUECdGogAiAAKAKIAUEEdGpBIGoiCiAEIAhqIg5BAnRqQXxqKAIANgIAA0AgACgCtAYgAyANakECdGogBTYCAEEAIQIgA0EBaiIDIAdHDQALQQAhAwNAIAAoArQGIAMgCWpBAnRqIAU2AgAgA0EBaiIDIAdHDQALA0AgCiACIAhqQQJ0aiAFNgIAIAJBAWoiAiAERw0ACyAIIAlBBWxqQQJ0IABqQdAFaiEDIBMoAgAhBSAHIQgDQEEAIQIDQCADIAJBAnRqIAU2AgAgAkEBaiICIARHDQALIANBFGohAyAIQX9qIggNAAsgDkEDcSIIRQRAIAcgCWpBA3EiCUUNCwsgC0EBaiELDAAACwALQeshQZ8fQc44QcchEAkAC0HrIUGfH0HOOEHHIRAJAAtB6yFBnx9BzjhBxyEQCQALQeshQZ8fQc44QcchEAkAC0HrIUGfH0HOOEHHIRAJAAtBkDRBnx9B9TVBnzQQCQALQdYoQZ8fQe00QcUoEAkAC0G0KEGfH0HsNEHFKBAJAAtB6DJBnx9B+scAQYgzEAkACyAWIBJBBHRqIQUgHUEFSiIERQRAQQAhAiAdQQVHQTBsIAVqQbAzai0AAEEBaiIHIQMDQCACQQFqIQIgA0EBdiIDDQALIABBzAZqIAJBAXRBf2ogBxB4C0EAIARFIAUbRQRAQQAhAiAAKALsAyAAKAKEBGtBAXRBf2oiA0EfdSADc0EBaiIEIQMDQCACQQFqIQIgA0EBdiIDDQALIABBzAZqIAJBAXRBf2ogBBB4IAAgACgC7AM2AoQECyAdQQZOBEAgAEHMBmogIUEQIAZBlAVqEI8BCyAWBEBBD0EQIB1BBUobIQggAEHMBmohCSAGQZQFaiENQQAhAgNAIAJBoDNqLQAAIgNBA3EhBAJAIAUgAkECdnZBAXEEQCAJIAwgA0EGdGpBoApqIAggBCANaiADQQJ2IgdrIgMQjwEgAy0AAEUNASAAIAAoAqQGQQEgBCAHQQVsakEFanRyNgKkBgwBCyAGQZAFaiAEQQRyIANBAnZrakEAOgAACyACQQFqIgJBEEcNAAsgGSAGLQCRBToAACAUIAYtAJcFOgAAIBkgBi0AkgU6AAEgFCAGLQCWBToAASAZIAYtAJMFOgACIBQgBi0AlQU6AAIgGSAGLQCUBSICOgADIBQgAjoAAwsCQCASRQ0AIAZBEToAcCAGQRE6AHIgAEHMBmoiAiAXQQQgBkHxAGoiAxCPASACIBxBBCADEI8BIBJBAkgNACAGIBktAAQ6APMCIAYgFC0ABDoA8QIgBiAZLQAFOgD0AiAGIBQtAAU6APACIAIgIEEPIAZB8gJqIgMQjwEgAiAMQYATakEPIAZB8wJqIgQQjwEgAiAMQcATakEPIAZB8QJqIgUQjwEgAiAMQYAUakEPIAMQjwEgGSAGLQDxAjoABCAUIAYtAPMCOgAEIBkgBi0A8gIiBzoABSAUIAc6AAUgBiAZLQAGOgDzAiAGIBQtAAY6APECIAYgGS0ABzoA9AIgBiAULQAHOgDwAiACIBBBDyADEI8BIAIgDEGgFWpBDyAEEI8BIAIgDEHgFWpBDyAFEI8BIAIgDEGgFmpBDyADEI8BIBkgBi0A8QI6AAYgFCAGLQDzAjoABiAZIAYtAPICIgI6AAcgFCACOgAHCyAVQQFKDQAgFEEANgIEIBlBADYCBAsgACgC1AIhAyAAKALABiIEIAQgACgCiAFBBXRqIgItAD86ACAgAkEwaiEFQQAhAgNAIAIgBGogACgC4AIgAmwgA2otAA86AAAgAiAFaiADIAAoAuACQQ9sIAJqai0AADoAACACQQFqIgJBEEcNAAsgACgC2AIhAiAAKALABiIEIAQgACgCiAFBBXRqIgVBxwBqIgctAAA6ACEgBCACLQAHOgAQIAVBQGsgAiAAQeQCaiIDKAIAQQdsai0AADoAACAEIAIgAygCAGotAAc6ABEgBSACIAMoAgBBB2xqLQABOgBBIAQgAiADKAIAQQF0ai0ABzoAEiAFIAIgAygCAEEHbGotAAI6AEIgBCACIAMoAgBBA2xqLQAHOgATIAUgAiADKAIAQQdsai0AAzoAQyAEIAIgAygCAEECdGotAAc6ABQgBSACIAMoAgBBB2xqLQAEOgBEIAQgAiADKAIAQQVsai0ABzoAFSAFIAIgAygCAEEHbGotAAU6AEUgBCACIAMoAgBBBmxqLQAHOgAWIAUgAiADKAIAQQdsai0ABjoARiAEIAIgAygCAEEHbGotAAc6ABcgByACIAMoAgBBB2xqLQAHOgAAIAAoAtwCIQIgACgCwAYiBCAEIAAoAogBQQV0aiIFQc8AaiIHLQAAOgAiIAQgAi0ABzoAGCAFIAIgAEHoAmoiAygCAEEHbGotAAA6AEggBCACIAMoAgBqLQAHOgAZIAUgAiADKAIAQQdsai0AAToASSAEIAIgAygCAEEBdGotAAc6ABogBSACIAMoAgBBB2xqLQACOgBKIAQgAiADKAIAQQNsai0ABzoAGyAFIAIgAygCAEEHbGotAAM6AEsgBCACIAMoAgBBAnRqLQAHOgAcIAUgAiADKAIAQQdsai0ABDoATCAEIAIgAygCAEEFbGotAAc6AB0gBSACIAMoAgBBB2xqLQAFOgBNIAQgAiADKAIAQQZsai0ABzoAHiAFIAIgAygCAEEHbGotAAY6AE4gBCACIAMoAgBBB2xqLQAHOgAfIAcgAiADKAIAQQdsai0ABzoAAAJAIAAoAqwGDQAgACgChAQhJCAAKAKYASETIAAoAowBIQ4gACgCiAEiCiAAKAKoBmogACgCpAYiAkEUdjoAACAGQaAFaiEmAkAgIgRAIAYgAkEhcUEARzoAoAUgBiACQTBxQQBHOgCQBSAGIAJBwgBxQQBHOgChBSAGIAJB4ABxQQBHOgCUBSAGIAJBhAFxQQBHOgCiBSAGIAJBwAFxQQBHOgCYBSAGIAJBiAJxQQBHOgCjBSAGIAJBgANxQQBHOgCcBSAGIAJBoAhxQQBHOgCkBSAGIAJBgAxxQQBHOgCRBSAGIAJBwBBxQQBHOgClBSAGIAJBgBhxQQBHOgCVBSAGIAJBgCFxQQBHOgCmBSAGIAJBgDBxQQBHOgCZBSAGIAJBgMIAcUEARzoApwUgBiACQYDgAHFBAEc6AJ0FIAYgAkGAiAJxQQBHOgCoBSAGIAJBgIADcUEARzoAkgUgBiACQYCQBHFBAEc6AKkFIAYgAkGAgAZxQQBHOgCWBSAGIAJBgKAIcUEARzoAqgUgBiACQYCADHFBAEc6AJoFIAYgAkGAwBBxQQBHOgCrBSAGIAJBgIAYcUEARzoAngUgBiACQYCAwgBxQQBHOgCsBSAGIAJBgIDgAHFBAEc6AJMFIAYgAkGAgIQBcUEARzoArQUgBiACQYCAwAFxQQBHOgCXBSAGIAJBgICIAnFBAEc6AK4FIAYgAkGAgIADcUEARzoAmwUgBiACQYCAkARxQQBHOgCvBSAGIAJBgICABnFBAEc6AJ8FDAELAkAgE0EETARAIABBvAVqIQMgBkGQBWohBCAmIQVBBCEJA0BBAiEHIAQCf0ECIAJBMHENABpBASADKAIQIgtBEHRBEHUgAygCFCIPQRB0QRB1ayINIA1BH3UiDWogDXNBA0oNABogC0EQdSAPQRB1ayIIIAhBH3UiCGogCHNBA0oLOgAAAkAgAkEhcQ0AQQEhByADKAIAIg1BEHRBEHUgAygCFCILQRB0QRB1ayIIIAhBH3UiCGogCHNBA0oNACANQRB1IAtBEHVrIgcgB0EfdSIHaiAHc0EDSiEHCyAFIAc6AABBAiEHIAQCf0ECIAJB4ABxDQAaQQEgAygCFCILQRB0QRB1IAMoAhgiD0EQdEEQdWsiDSANQR91Ig1qIA1zQQNKDQAaIAtBEHUgD0EQdWsiCCAIQR91IghqIAhzQQNKCzoABAJAIAJBwgBxDQBBASEHIAMoAgQiDUEQdEEQdSADKAIYIgtBEHRBEHVrIgggCEEfdSIIaiAIc0EDSg0AIA1BEHUgC0EQdWsiByAHQR91IgdqIAdzQQNKIQcLIAUgBzoAAUECIQcgBAJ/QQIgAkHAAXENABpBASADKAIYIgtBEHRBEHUgAygCHCIPQRB0QRB1ayINIA1BH3UiDWogDXNBA0oNABogC0EQdSAPQRB1ayIIIAhBH3UiCGogCHNBA0oLOgAIAkAgAkGEAXENAEEBIQcgAygCCCINQRB0QRB1IAMoAhwiC0EQdEEQdWsiCCAIQR91IghqIAhzQQNKDQAgDUEQdSALQRB1ayIHIAdBH3UiB2ogB3NBA0ohBwsgBSAHOgACQQIhByAEAn9BAiACQYADcQ0AGkEBIAMoAhwiC0EQdEEQdSADKAIgIg9BEHRBEHVrIg0gDUEfdSINaiANc0EDSg0AGiALQRB1IA9BEHVrIgggCEEfdSIIaiAIc0EDSgs6AAwCQCACQYgCcQ0AQQEhByADKAIMIg1BEHRBEHUgAygCICILQRB0QRB1ayIIIAhBH3UiCGogCHNBA0oNACANQRB1IAtBEHVrIgcgB0EfdSIHaiAHc0EDSiEHCyAFIAc6AAMgA0EUaiEDIARBAWohBCACQQV1IQIgBUEEaiEFIAlBf2oiCQ0ACyATQQVOBEAgBkGEiJAgNgKQBQwCCyAKIAAoAqAGaiICQX9qLAAAQQVOBEAgBkGEiJAgNgKQBQsgAiwAAEEFSA0CDAELIAZBg4aMGDYCrAUgBkKDhoyYsODAgQM3AqQFIAZCg4aMmLDgwIEDNwOYBSAGQoSIkKCw4MCBAzcDkAULIAZBhIiQIDYCoAULIAAoAqAGIApqIBM6AAAgCkUEQCAGQQA2ApAFCyAORQRAIAZBADYCoAULIAZB1AVqIRsgBkHQBWohKSAAKAKcBiAKaiICLQAAIQMgAiAkOgAAIAJBf2otAAAhAiAGQcAFaiEqIAZB1wVqISMgBkHVBWohIiAGQdMFaiEhIAZB0QVqITUgBkHWBWohMSAGQdIFaiErIAZBsAVqISVBACEFA0AgAkH/AXEhLCAGKAKQBSIEBEAgBiAkICxqQQFqQQF1QQVsIgJB8jhqLQAAOgDUBSAGIAJB7jhqIgItAAA6ANAFIAYgAiAEQf8BcWotAAA6ALAFIAYgAiAGLQCRBWotAAA6ALEFIAYgAiAGLQCSBWotAAA6ALIFIAYgAiAGLQCTBWotAAA6ALMFCyADQf8BcSERIAYoAqAFIgMEQCAGIBEgJGpBAWpBAXVBBWwiAkHyOGotAAA6ANYFIAYgAkHuOGoiAi0AADoA0gUgBiACIANB/wFxai0AADoAwAUgBiACIAYtAKEFai0AADoAwQUgBiACIAYtAKIFai0AADoAwgUgBiACIAYtAKMFai0AADoAwwULIAYgJEF2akEFbCICQaQ5ai0AACIDOgDXBSAGIAM6ANUFIAYgAkGgOWoiAy0AACICOgDTBSAGIAI6ANEFQQQhAgNAIAIgJWogAyAGQZAFaiACai0AAGotAAA6AAAgJSACQRBqIgRqIAMgBkGQBWogBGotAABqLQAAOgAAIAJBAWoiAkEQRw0ACyAFBEAgBiAGKAK4BTYCtAUgBiAGKALIBTYCxAVBAiEPA0AgACAPQQJ0aiIDKALgAiECIAMoAtQCIQNBACEEICkhBSAbIQcDQCAEIQgCQCAFLQAAIgRFDQAgBkGQBWogCGoiBSgCACIJRQ0AIAMgCEEBdmoiDUEBIAQgBy0AACIHIAUtACAiCiAJQf8BcSIJEJABIAIgDWoiDUEBIAQgByAKIAkQkAEgAiANaiIJQQEgBCAHIAUtACEiDSAFLQABIgoQkAEgAiAJaiIJQQEgBCAHIA0gChCQASACIAlqIglBASAEIAcgBS0AIiINIAUtAAIiChCQASACIAlqIglBASAEIAcgDSAKEJABIAIgCWoiCUEBIAQgByAFLQAjIg0gBS0AAyIFEJABIAIgCWpBASAEIAcgDSAFEJABC0EIIQQgNSEFICIhByAIRQ0ACyACQQJ0IQpBACEEICshBSAxIQkDQCAEIQcCQCAFLQAAIgRFDQAgByAmaiIIKAIAIg1FDQAgAyACIAQgCS0AACIFIAcgKmoiCS0AACILIA1B/wFxIg0QkAEgA0EBaiACIAQgBSALIA0QkAEgA0ECaiACIAQgBSAJLQABIg0gCC0AASILEJABIANBA2ogAiAEIAUgDSALEJABIANBBGogAiAEIAUgCS0AAiINIAgtAAIiCxCQASADQQVqIAIgBCAFIA0gCxCQASADQQZqIAIgBCAFIAktAAMiCSAILQADIggQkAEgA0EHaiACIAQgBSAJIAgQkAELIAMgCmohA0EIIQQgISEFICMhCSAHRQ0ACyAPQX9qIg8NAAsMAgsgACgC4AIiB0ECdCEZIAAoAtQCIR5BACECICkhAyAbIQQDQCADLQAAIRIgBC0AACEFAkAgAiIWIAZBkAVqaiIQKAIAIgNB/wFxQQRGBEAgFiAeaiECIBJBAnZBAmohGkEQIQMDQAJAIAJBf2oiDS0AACIIIAItAAAiCWsiBCAEQR91IgRqIARzIgQgEk4NACACQX5qIg8tAAAiCyAIayIKIApBH3UiCmogCnMgBU4NACACLQABIgogCWsiEyATQR91IhNqIBNzIAVODQAgAi0AAiETAn8CQCACQX1qIhAtAAAiDiAIayIVIBVBH3UiFWogFXMgBU4NACAEIBpODQAgAkF8ai0AACEXIA0gCiAOaiAIIAlqIAtqIhVBAXRqQQRqQQN2OgAAIA8gDiAVakECakECdjoAACAOQQNsQQRqIQ8gECENQQMMAQsgCCAKaiEPQQIhFSALIRdBAgshHCANIA8gFWogF0EBdGogHHY6AAACQCAEIBpODQAgEyAJayIEIARBH3UiBGogBHMgBU4NACACIAggCWogCmoiBCATakECakECdjoAASACIAQgE0EDbGogAi0AA0EBdGpBBGpBA3Y6AAIgAiALIBNqIARBAXRqQQRqQQN2OgAADAELIAIgCSALaiAKQQF0akECakECdjoAAAsgAiAHaiECIANBf2oiAw0ACwwBCyASRQ0AIANFDQAgFiAeaiECIBBBIGohIEEAIRcDQAJAIANB/wFxBEBBACAXICBqLQAAIgtrIQ9BBCENA0AgAkF/aiITLQAAIgMgAi0AACIEayIIIAhBH3UiCGogCHMgEmsgAkF+aiIOLQAAIgggA2siCSAJQR91IglqIAlzIAVrcSACLQABIgkgBGsiCiAKQR91IgpqIApzIAVrcUF/TARAIAItAAIhCiAOIAggDyALIAJBfWotAAAiFSADayIaIBpBH3UiGmogGnMgBWtBH3UiGiADIARqQQFqQQF2IhwgFWpBAXYgCGtxIhUgFSALShsiFSAVIA9IG2o6AAAgAiAJIA8gCyAKIBxqQQF2IAlrIAogBGsiDiAOQR91Ig5qIA5zIAVrIg5BH3VxIgogCiALShsiCiAKIA9IG2o6AAEgE0EAIAsgGmsgDkEfdmoiCmsiDiAKIAggCWsgBCADa0ECdGpBBGpBA3UiCCAIIApKGyIIIAggDkgbIgggA2oiA0EAIANBAEobIgNB/wEgA0H/AUgbOgAAIAIgBCAIayIDQQAgA0EAShsiA0H/ASADQf8BSBs6AAALIAIgB2ohAiANQX9qIg0NAAsMAQsgAiAZaiECCyAXQQFqIhdBBEYNASAQIBdqLQAAIQMMAAALAAsgFkEEaiECIDUhAyAiIQQgFkEMSQ0ACyAHQQNsIScgB0F9bCEWQQAhAkEAIAdrIRpBACAZayEyQQAgB0EBdCIYayEcICshAyAxIQQDQCADLQAAIRUgBC0AACEFAkAgJiACIh1qIh8oAgAiA0H/AXFBBEYEQCAVQQJ2QQJqIRBBECEDIB4hAgNAAkAgAiAaaiINLQAAIgggAi0AACIJayIEIARBH3UiBGogBHMiBCAVTg0AIAIgHGoiDi0AACIKIAhrIgsgC0EfdSILaiALcyAFTg0AIAIgB2oiEi0AACILIAlrIg8gD0EfdSIPaiAPcyAFTg0AIAkgCmogC0EBdGpBAmohDyAIQQJqIhcgC2ogCkEBdGohEwJAIAQgEE4NACACIBhqIhQtAAAiBCAJayIgICBBH3UiIGogIHMhICACIBZqIi0tAAAiDCAIayIfIB9BH3UiH2ogH3MgBUgEQCACIDJqLQAAITcgDiAJIBdqIApqIAxqIh9BAnY6AAAgLSAfIAwgN2pBAXRqQQJqQQN2OgAAIAkgCmsgE2ogH2pBAXUhEwsgICAFTg0AIAIgJ2otAAAhCiASIAkgF2ogC2ogBGoiCUECdjoAACAUIAkgBCAKakEBdGpBAmpBA3Y6AAAgCCALayAPaiAJakEBdSEPCyANIBNBAnY6AAAgAiAPQQJ2OgAACyACQQFqIQIgA0F/aiIDDQALDAELIBVFDQAgA0UNACAdICpqIRRBACEMIB4hAgNAAkAgA0H/AXEEQEEAIAwgFGotAAAiC2shD0EEIQ0DQCACIBpqIhMtAAAiAyACLQAAIgRrIgggCEEfdSIIaiAIcyAVayACIBxqIg4tAAAiCCADayIJIAlBH3UiCWogCXMgBWtxIAIgB2oiEi0AACIJIARrIgogCkEfdSIKaiAKcyAFa3FBf0wEQCACIBhqLQAAIQogDiAIIA8gCyACIBZqLQAAIhcgA2siECAQQR91IhBqIBBzIAVrQR91IhAgAyAEakEBakEBdiIgIBdqQQF2IAhrcSIXIBcgC0obIhcgFyAPSBtqOgAAIBIgCSAPIAsgCiAgakEBdiAJayAKIARrIg4gDkEfdSIOaiAOcyAFayIOQR91cSIKIAogC0obIgogCiAPSBtqOgAAIBNBACALIBBrIA5BH3ZqIgprIg4gCiAIIAlrIAQgA2tBAnRqQQRqQQN1IgggCCAKShsiCCAIIA5IGyIIIANqIgNBACADQQBKGyIDQf8BIANB/wFIGzoAACACIAQgCGsiA0EAIANBAEobIgNB/wEgA0H/AUgbOgAACyACQQFqIQIgDUF/aiINDQALDAELIAJBBGohAgsgDEEBaiIMQQRGDQEgDCAfai0AACEDDAAACwALIB1BBGohAiAZIB5qIR4gISEDICMhBCAdQQxJDQALIBFBgChqLQAAIQMgLEGAKGotAAAhAiAkQYAoai0AACEkQQEhBQwAAAsACyAGQZAJaiQAC4MCAQR/IAAgASACQQAQcSEGIAAoAjAiBEECTgRAA0AgASABKAIAIAAoAiAgACgCHGogACgCKEEAR2pBAWogACgCAEEPakEEdUGAA2wiA0GABmogACgCBEEPakEEdSIFQQJqbGxBEHIgAyAFbGpqQawHajYCACACIAIoAgAgACgCACIFQQ9qQQR1IgNBBXQgAyAAKAIEQQ9qQQR1bEGkCWxBAm1BvxdqQXBxIANBA3RqQRdqQXBxIAVBL2pBcHFqIANBAnRqQRNqQXBxIANqQQ9qQXBxIANqQQ9qQXBxIANqQQ9qQXBxampBL2o2AgAgBEECSiEDIARBf2ohBCADDQALCyAGC4oHAQp/IwBB8AFrIgMkAAJAAkAgAUEASgRAIABBfGoiBi0AAA0BIABBfWoiCC0AAA0BIABBfmoiCS0AAA0BIABBf2oiCi0AAEEBRw0BIAAtAAAhByACKAIAIgUtADAEQEGZE0EAEIcNAkACQAJAIAdBn39qIgRBB0sNAAJAAkACQCAEQQFrDgcDAwMBAwQAAgtBoxNBABCHDQwEC0HJABCQBgwDC0HQABCQBgwCCyADQY0SNgJwIANBuhM2AmwgA0GnEzYCaCADQdAANgJkIANB1BE2AmBBqBEgA0HgAGoQhw0QBAALQZ8TQQAQhw0LQcATQQAQhw0gAyAALQAANgKgAUHHEyADQaABahCHDUEBIQQgAUEQIAFBf2pBD0kbIgtBAUcEQCABQRBGIQwDQEEgEJAGIAMgACAEai0AADYCkAFBxxMgA0GQAWoQhw0CQCAMDQAgBEEPRw0AQcwTQQAQhw0LIARBAWoiBCALRw0ACwsgAyABNgKAAUHQEyADQYABahCHDQsCQAJAAkAgB0Gff2oiBEEHSw0AAkACQCAEQQFrDgcCAgIBAgADAQsgAigCCCIERQRAIAIgAigCBEGQvwUgBSgCFG6tIAUvAQwgBS8BECAALQABIAAtAAIgAC0AAxDkASIENgIIIARFDQcgAigCBBDiASACKAIIIQQLIAIoAgQgBCAAIAFB//8DcRDlAQwDCyAGIAFBGHY6AAAgCCABQRB2OgAAIAkgAUEIdjoAACAKIAE6AAAgAigCBCACKAIIIAYgAUEEahDnAQ0CIANBjRI2AlAgA0GMFDYCTCADQfQRNgJIIANBggE2AkQgA0HUETYCQEGoESADQUBrEIcNEAQACyADQY0SNgIQIANBuhM2AgwgA0GnEzYCCCADQYUBNgIEIANB1BE2AgBBqBEgAxCHDRAEAAsgAigCBCACKAIIIAAgAUH//wNxEOYBCyADQfABaiQADwsgA0GNEjYC4AEgA0GDEjYC3AEgA0H0ETYC2AEgA0E5NgLUASADQdQRNgLQAUGoESADQdABahCHDRAEAAsgA0GNEjYCwAEgA0HcEjYCvAEgA0H0ETYCuAEgA0E6NgK0ASADQdQRNgKwAUGoESADQbABahCHDRAEAAsgA0GNEjYCMCADQdwTNgIsIANB9BE2AiggA0HzADYCJCADQdQRNgIgQagRIANBIGoQhw0QBAALuQgBA38jAEGQA2siASQAAkACQAJAAkACQAJAAkACQCAAKAI0RQRAQSQQ/gsiAkIANwIEIAJCADcCHCACQgA3AhQgAkIANwIMIAAgAjYCNCACIAA2AgAgAC0ACyICQRh0QRh1IgNBf0wEfyAAKAIEBSACC0UNASAAKAIMRQ0CIAAoAhBFDQMgACgCFEUNBCAAKAIgQXZqQSpPDQUgACgCHEELTw0GAn8gA0F/TARAIAAoAgAMAQsgAAsQ3wEhAiAAKAI0IAI2AgQgAkUNByACEOEBIAFCADcD+AIgAUIBNwOIAyABQgA3A4ADIAFCADcD8AIgAUIANwPoAiABQQE2AvwCIAEgACgCJDYC4AIgASAAKAIQNgLcAiAAKAIMIQIgAUKAgICAEDcD8AIgASACNgLYAiABQdThADYC5AIgASAALQAoNgKAAyABQQA2AtQCIAFBADYC0AIgAUHYAmogAUHUAmogAUHQAmoQfSICBEAgAkEFRg0JIAFBvRU2ArABIAFB3hc2AqwBIAFB9BE2AqgBIAFBsAE2AqQBIAFB1BE2AqABQagRIAFBoAFqEIcNEAQACyAALQAwBEAgASABKALUAjYC4AEgASABKALQAjYC5AFB8RcgAUHgAWoQhw0LIAEoAtQCQT9qQcAAbUEGdBCABiECIAAoAjQiACACNgIQIAAgASgC0AJBP2pBwABtQQZ0EIAGNgIUIAAoAhAgAUHYAmoQbyABQZADaiQADwsgAUG9FTYCwAIgAUGzFTYCvAIgAUH0FDYCuAIgAUGMATYCtAIgAUHUETYCsAJBqBEgAUGwAmoQhw0QBAALIAFBvRU2AhAgAUHoFTYCDCABQfQRNgIIIAFBkQE2AgQgAUHUETYCAEGoESABEIcNEAQACyABQb0VNgIwIAFBgBY2AiwgAUH0ETYCKCABQZIBNgIkIAFB1BE2AiBBqBEgAUEgahCHDRAEAAsgAUG9FTYCUCABQYoWNgJMIAFB9BE2AkggAUGTATYCRCABQdQRNgJAQagRIAFBQGsQhw0QBAALIAFBvRU2AnAgAUGVFjYCbCABQfQRNgJoIAFBlAE2AmQgAUHUETYCYEGoESABQeAAahCHDRAEAAsgAUG9FTYCoAIgAUGjFjYCnAIgAUH0ETYCmAIgAUGVATYClAIgAUHUETYCkAJBqBEgAUGQAmoQhw0QBAALIAFBvRU2AoACIAFB3hY2AvwBIAFB9BE2AvgBIAFBlgE2AvQBIAFB1BE2AvABQagRIAFB8AFqEIcNEAQACyABQb0VNgKQASABQeoWNgKMASABQfQRNgKIASABQZkBNgKEASABQdQRNgKAAUGoESABQYABahCHDRAEAAsgAUG9FTYC0AEgAUGsFzYCzAEgAUGPFzYCyAEgAUGvATYCxAEgAUHUETYCwAFBqBEgAUHAAWoQhw0QBAALxQQBBn8jAEGwAWsiAiQAAkACQCAAKAI0IgQEQCABKAIEIAEtAAsiAyADQRh0QRh1QQBIIgYbIAAoAgwiAyAAKAIQbCIFQQNsQQF2Rw0BIAEoAgAhByACIAM2AqQBIAIgA0EBdiIDNgKoASACIAM2AqwBIAIgByABIAYbIgE2ApgBIAIgASAFajYCnAEgAiABIAVBBWxBAnZqNgKgASACQQA2ApQBIAJCADcChAEgAkIANwJ8IAJCADcCjAEgAkIANwJ0IAIgACgCHDYCcCACIAAoAiw2AowBIAICfyAAKAIYIgEEQCACIAFB6AdsQQN2IAAoAhRuNgKAAUEyIQNBCgwBCyAAKAIgIgMLNgKEASACIAM2AogBIAJBJzYCkAEgAiAENgKUASACQQA2AmwgAkEANgJoIAQoAhAgBCgCFCACQfAAaiACQZgBaiACQegAaiACQewAahByDQIgAC0AMARAIAIgACgCNCgCDDYCICACIAIoAmw2AiRBxxogAkEgahCHDQsgACgCNCIAIAAoAgxBAWo2AgwgAkGwAWokAA8LIAJBvxg2AhAgAkHfFTYCDCACQZcYNgIIIAJBvgE2AgQgAkHUETYCAEGoESACEIcNEAQACyACQb8YNgJgIAJBrBk2AlwgAkH1GDYCWCACQcABNgJUIAJB1BE2AlBBqBEgAkHQAGoQhw0QBAALIAJBQGtBvxg2AgAgAkHYGTYCPCACQfQRNgI4IAJB5wE2AjQgAkHUETYCMEGoESACQTBqEIcNEAQAC7wFAQp/IwBBQGoiBCQAAkACQAJAIAAoAjQiAwRAIAEoAgQgAS0ACyIFIAVBGHRBGHVBAEgiAhsgACgCECAAKAIMbCIFQQJ0Rw0BIAEoAgAhByADQRhqIAVBA2xBAXZBABCNDCAAKAI0IgNBGGohBSADLAAjQX9MBEAgBSgCACEFCyAAKAIQIghFDQMgByABIAIbIQEgCCAAKAIMIgJsIgdBAnYgB2ohCEEAIQMDQCACIQYCQCAJQQFxBEBBACECIAZFDQEDQCADIAVqIAEgA0ECdCIGQQFyai0AAEGBAWwgASAGai0AAEHCAGxqIAEgBkECcmotAABBGWxqQQh2QRBqOgAAIANBAWohAyACQQFqIgIgACgCDCIGSQ0ACyAGIQIMAQtBACEKQQAhAiAGRQ0AA0AgAyAFaiABIANBAnQiAkEBcmotAAAiBkGBAWwgASACai0AACILQcIAbGogASACQQJyai0AACICQRlsakEIdkEQajoAACAFIAdqIAZBtn9sIAtBWmxqIAJB8ABsakEIdkGAAXM6AAAgBSAIaiAGQaJ/bCALQfAAbGogAkFubGpBCHZBgAFzOgAAIAUgA0EBaiICaiABIAJBAnQiAkEBcmotAABBgQFsIAEgAmotAABBwgBsaiABIAJBAnJqLQAAQRlsakEIdkEQajoAACADQQJqIQMgCEEBaiEIIAdBAWohByAKQQJqIgogACgCDCICSQ0ACwsgCUEBaiIJIAAoAhBJDQALDAILIARB2xo2AhAgBEHfFTYCDCAEQZcYNgIIIARB8gE2AgQgBEHUETYCAEGoESAEEIcNEAQACyAEQdsaNgIwIARBxhs2AiwgBEGSGzYCKCAEQfQBNgIkIARB1BE2AiBBqBEgBEEgahCHDRAEAAsgACgCNCEDCyAAIANBGGoQgAEgBEFAayQAC5kBAQJ/IwBBIGsiASQAIAAoAjQiAgRAIAIoAgQQ4AEgACgCNCgCEBD2DCAAKAI0KAIUEPYMIAAoAjQiAgRAIAIsACNBf0wEQCACKAIYEPYMCyACEPYMCyAAQQA2AjQgAUEgaiQADwsgAUHvGzYCECABQd8VNgIMIAFBlxg2AgggAUGpAjYCBCABQdQRNgIAQagRIAEQhw0QBAALoQEBAX8jAEEgayIBJAACQCAAKAI0BEAgAUHiHDYCECABQc4cNgIMIAFBjxw2AgggAUGzAjYCBCABQdQRNgIAQagRIAEQhw1ByLIFQQA2AgBBKBAKQciyBSgCACEBQciyBUEANgIAIAFBAUcNAUEAEAshARAHGiAAEIkMGiABEIQBAAsgACwAC0F/TARAIAAoAgAQ9gwLIAFBIGokACAADwsACwsAIAAQDBoQtQwAC4wHAQp/IAIuAQAhCCACLgECIQIgAy4BACEGIAMuAQIhCyAAQQA2AgACQAJAAkAgAkEQSARAIAhBEE4NASAGQRRODQIgC0EUTg0DIAEoArQBIQQgASgCtAYiAyABKAKIAUEEdGpBIGoiCSAIQQJ1IgdBAnRqKAIAIQUgAyACQQJ1IgpBAnRqIgEoAgAhAyABKAIQIQEgCSAGQQJ1IgwgB2oiBkECdGooAgAhAiAHRQRAIANBgIACIARBAnEbIQMgAUGAgAIgBEEEcRshAQsCQCAKBEAgBEEIcSEJDAELIAJBgIACIARBAXEiDRsgAiAGQQRIGyICQYCAAiAEQQhxIgkbIAIgBkEERhshAiABQYCAAiANGyABIAhBA0obIgEgAUGAgAIgBEEEcUECdhsgBxshASAFQYCAAiANGyEFCyABIAIgASAJGyAKGyACIAZBBEYbIQECQAJAIANBgIACRiIEDQAgBUGAgAJHDQBBAiECIAFBgIACRg0BC0EDQQEgBCAFQYCAAkdxIAFBgIACRnEiBBshAiADQYCAAkcNACAEDQBBAUEBQQQgAUGAgAJGGyAFQYCAAkcbIQILIAtBAnUhBAJAAkACQAJAAkACQAJAAkAgDEECRw0AIARBBEcNACAHRQRAIANBgIACRg0CDAMLIAFBgIACRg0BDAYLIAxBBEcNACAEQQJHDQAgCkUEQCAFQYCAAkYNAQwECyADQYCAAkcNAQsCQCACQX5qIgJBAk0EQCACQQFrDgIDBQELAkAgAUGAgAJHDQAgBUGAgAJHDQAgA0GAgAJGDQcgACADNgIADwsgACADQQAgA0GAgAJHGyIHQRB0QRB1IgMgBUEAIAVBgIACRxsiBUEQdEEQdSICIAMgAkobIgRBACABIAFBgIACRhsiCEEQdEEQdSIBIAQgAUgbIgEgAyACIAMgAkgbIgMgASADShtB//8DcSAHQRB1IgEgBUEQdSIDIAEgA0obIgIgCEEQdSIFIAIgBUgbIgIgASADIAEgA0gbIgEgAiABShtBEHRyNgIADwsgA0GAgAJGDQULIAAgAzYCAA8LIAVBgIACRg0DCyAAIAU2AgAPCyABQYCAAkYNAQsgACABNgIACw8LQegsQZ8fQdbCAEHuLBAJAAtBiC1Bnx9B18IAQe4sEAkAC0GOLUGfH0HYwgBB7iwQCQALQZUtQZ8fQdnCAEHuLBAJAAulCwESfyMAQaAHayIIJAAgAi4BAiEFIAIuAQAhBiACIAIoAgAiB0GDgAxxIgw2AgAgACAFQQJ1IAFsIAZBAnVqaiEGIAMoAgAiCUEQdiEQAkACQCAHQQNxIhQgDEEQdiIVQQJ0ciICRQRAIBBBEHRBEHVBAUgNASAJQRB1IQUgCUEQdEEQdSEDQQAhAANAQQAhAiAJQRB0QRB1QQFOBEADQCACIARqIAIgBmotAAA6AAAgAkEBaiICIANHDQALCyABIAZqIQYgBEEQaiEEIABBAWoiACAFRw0ACwwBCwJAQQEgAnQiEkHuwQNxRQRADAELQQEhCiAQQRB0QRB1QQFIDQAgCUEQdSELIAlBEHRBEHUhBSAGIAFBACASQYDAA3EbaiEPA0AgBUEBTgRAIA5BBHQhByAPIAEgDmxqIQxBACEDA0AgBCADIAdqaiADIAxqIgJBfmoiAC0AACACLQADaiACLQABIAItAABqQRRsaiACLQACIAAtAAFqQXtsakEQakEFdSICQf8BIAJB/wFIGyICQQAgAkEAShs6AAAgA0EBaiIDIAVHDQALCyAOQQFqIg4gC0cNAAsLIBJBsPcCcQRAIBBBEHRBEHVBAU4EQCAJQRB1IRMgCCAEIAobIQwgCUEQdEEQdSEAIAYgEkGAkQJxQQBHaiEWIAFBBWwhDiABQQJ0IQsgAUEDbCEPIAFBAXQhEQNAIABBAU4EQCANQQR0IQUgFiANQX5qIAFsaiEHQQAhAwNAIAwgAyAFamogAyAHaiICLQAAIAIgDmotAABqIAIgD2otAAAgAiARai0AAGpBFGxqIAIgC2otAAAgASACai0AAGpBe2xqQRBqQQV1IgJB/wEgAkH/AUgbIgJBACACQQBKGzoAACADQQFqIgMgAEcNAAsLIA1BAWoiDSATRw0ACwsgCkEBaiEKCyASQcCcAXEEQAJAIBBBEHRBEHVBfEgNACAIIAQgChshDiAJQRB0IhFBEHUhACAJQRB1IhNBfCATQXxKG0EEaiEPQQAhCwNAIABBAU4EQCAAIAtsIQcgBiALQX5qIAFsaiEMQQAhAwNAIAhBgAJqIAMgB2pBAXRqIAMgDGoiAi0AAyACQX5qIgUtAABqIAItAAEgAi0AAGpBFGxqIAItAAIgBS0AAWpBe2xqOwEAIANBAWoiAyAARw0ACwsgCyAPRiECIAtBAWohCyACRQ0ACyAQQRB0QRB1QQFIDQAgAEEFbCEMIBFBDnUhCyAAQQNsIQ8gEUEPdSERQQAhDQNAIAlBEHRBEHVBAU4EQCANQQR0IQUgACANbCEHQQAhAwNAIA4gAyAFamogCEGAAmogAyAHaiICQQF0ai4BACAIQYACaiACIAxqQQF0ai4BAGogCEGAAmogAiAPakEBdGouAQAgCEGAAmogAiARakEBdGouAQBqQRRsaiAIQYACaiACIAtqQQF0ai4BACAIQYACaiAAIAJqQQF0ai4BAGpBe2xqQYAEakEKdSICQf8BIAJB/wFIGyICQQAgAkEAShs6AAAgA0EBaiIDIABHDQALCyANQQFqIg0gE0cNAAsLIApBAWohCgsgEkH69QNxRQ0AIAlB//8DcUEQRw0BIBBBEEcNASAKQQJGBEBBACEGA0AgBkEEdCEFQQAhAgNAIAQgAiAFaiIDaiIAIAMgCGotAAAgAC0AAGpBAWpBAXY6AAAgAkEBaiICQRBHDQALIAZBAWoiBkEQRw0ACwwBCyAGIBVBAWpBAnYgAWwgFEEBakECdmpqIQZBACEHA0AgASAHbCEAIAdBBHQhBUEAIQIDQCAEIAIgBWpqIgMgAy0AACAGIAAgAmpqLQAAakEBakEBdjoAACACQQFqIgJBEEcNAAsgB0EBaiIHQRBHDQALCyAIQaAHaiQADwtBuStBnx9BiTRB1isQCQALoAgBB38gACEEIAIhBQNAIAQtAAcgBS0AB2siBiAGQR91IgZqIAZzIAQtAAYgBS0ABmsiBiAGQR91IgZqIAZzIAQtAAUgBS0ABWsiBiAGQR91IgZqIAZzIAQtAAQgBS0ABGsiBiAGQR91IgZqIAZzIAQtAAMgBS0AA2siBiAGQR91IgZqIAZzIAQtAAIgBS0AAmsiBiAGQR91IgZqIAZzIAQtAAEgBS0AAWsiBiAGQR91IgZqIAZzIAQtAAAgBS0AAGsiBiAGQR91IgZqIAZzIAlqampqampqaiEJIAVBEGohBSABIARqIQQgCEEBaiIIQQhHDQALIAMgCTYCACACQQhqIQQgAEEIaiEFQQAhCEEAIQYDQCAFLQAHIAQtAAdrIgcgB0EfdSIHaiAHcyAFLQAGIAQtAAZrIgcgB0EfdSIHaiAHcyAFLQAFIAQtAAVrIgcgB0EfdSIHaiAHcyAFLQAEIAQtAARrIgcgB0EfdSIHaiAHcyAFLQADIAQtAANrIgcgB0EfdSIHaiAHcyAFLQACIAQtAAJrIgcgB0EfdSIHaiAHcyAFLQABIAQtAAFrIgcgB0EfdSIHaiAHcyAFLQAAIAQtAABrIgcgB0EfdSIHaiAHcyAIampqampqamohCCAEQRBqIQQgASAFaiEFIAZBAWoiBkEIRw0ACyADIAg2AgQgAkGAAWohBEEAIQYgACABQQN0aiIKIQVBACEHA0AgBS0AByAELQAHayIAIABBH3UiAGogAHMgBS0ABiAELQAGayIAIABBH3UiAGogAHMgBS0ABSAELQAFayIAIABBH3UiAGogAHMgBS0ABCAELQAEayIAIABBH3UiAGogAHMgBS0AAyAELQADayIAIABBH3UiAGogAHMgBS0AAiAELQACayIAIABBH3UiAGogAHMgBS0AASAELQABayIAIABBH3UiAGogAHMgBS0AACAELQAAayIAIABBH3UiAGogAHMgBmpqampqampqIQYgBEEQaiEEIAEgBWohBSAHQQFqIgdBCEcNAAsgAyAGNgIIIAJBiAFqIQQgCkEIaiEFQQAhB0EAIQADQCAFLQAHIAQtAAdrIgIgAkEfdSICaiACcyAFLQAGIAQtAAZrIgIgAkEfdSICaiACcyAFLQAFIAQtAAVrIgIgAkEfdSICaiACcyAFLQAEIAQtAARrIgIgAkEfdSICaiACcyAFLQADIAQtAANrIgIgAkEfdSICaiACcyAFLQACIAQtAAJrIgIgAkEfdSICaiACcyAFLQABIAQtAAFrIgIgAkEfdSICaiACcyAFLQAAIAQtAABrIgIgAkEfdSICaiACcyAHampqampqamohByAEQRBqIQQgASAFaiEFIABBAWoiAEEIRw0ACyADIAc2AgwgCCAJaiAGaiAHagv3AwEUfyAAQYgBaiERQQEhBgNAQQhBBEEIIAAoApgBIgJBAnEbIAJBf0YiAxshC0EIQQRBCCACQQFxGyADGyEMIAZBA3RBeGohEiAAIAZBAnRqIgJByAJqIRMgAkG8AmohFEEAIQ1BACEHQQAhCANAIBQoAgAhAiATKAIAIQkgASARIA1BAnRqKAJwIgMgACgCjAFBFnRqIgRBgIAccSIOIAAoAogBQQZ0IANqIgNBB3EiD3IiCjYCACACIAkgCCAEQRN1amxqIANBEHRBE3VqIAdqIQMgACgCkAcgEmogCEEEdGogB2ohBQJAIApFBEBBACEEA0BBACECA0AgAiAFaiACIANqLQAAOgAAIAJBAWoiAiALRw0ACyADIAlqIQMgBUEQaiEFIARBAWoiBCAMRw0ACwwBC0EIIA9rIQpBCCAOQRB2Ig5rIRUgDCEQA0BBACECA0AgAiAFaiAPIAMgAkEBaiIEai0AAGwgCiACIANqLQAAbGogFWwgDyADIAIgCWpqIgItAAFsIAogAi0AAGxqIA5sakEgakEGdjoAACAEIgIgC0cNAAsgAyAJaiEDIAVBEGohBSAQQX9qIhANAAsLAkAgByALakEHcSIHRQRAIAggDGpBB3EiCEUNAQsgDUEBaiENDAELCyAGQQFqIgZBA0cNAAsLpQEAAkAgAEEHcUUEQCABQQdxRQ0BQZcuQZ8fQZ47QYYuEAkAC0HoLUGfH0GdO0GGLhAJAAsgACABKQIANwIAIAAgASACaiIBKQIANwIQIAAgASACaiIBKQIANwIgIAAgASACaiIBKQIANwIwIAAgASACaiIBKQIANwJAIAAgASACaiIBKQIANwJQIAAgASACaiIBKQIANwJgIAAgASACaikCADcCcAulAQACQCAAQQdxRQRAIAJBB3FFDQFB1ihBnx9B3TRB2S0QCQALQbQoQZ8fQdw0QdktEAkACyAAIAIpAgA3AgAgACABaiIAIAIpAhA3AgAgACABaiIAIAIpAiA3AgAgACABaiIAIAIpAjA3AgAgACABaiIAIAIpAkA3AgAgACABaiIAIAIpAlA3AgAgACABaiIAIAIpAmA3AgAgACABaiACKQJwNwIAC9sDAQF/IANBGHYgB0EYdmsiCCAIQR91IghqIAhzIANBEHZB/wFxIAdBEHZB/wFxayIIIAhBH3UiCGogCHMgA0EIdkH/AXEgB0EIdkH/AXFrIgggCEEfdSIIaiAIcyADQf8BcSAHQf8BcWsiAyADQR91IgNqIANzIAJBGHYgBkEYdmsiAyADQR91IgNqIANzIAJBEHZB/wFxIAZBEHZB/wFxayIDIANBH3UiA2ogA3MgAkEIdkH/AXEgBkEIdkH/AXFrIgMgA0EfdSIDaiADcyACQf8BcSAGQf8BcWsiAyADQR91IgNqIANzIAFBGHYgBUEYdmsiAyADQR91IgNqIANzIAFBEHZB/wFxIAVBEHZB/wFxayIDIANBH3UiA2ogA3MgAUEIdkH/AXEgBUEIdkH/AXFrIgMgA0EfdSIDaiADcyABQf8BcSAFQf8BcWsiAyADQR91IgNqIANzIABBGHYgBEEYdmsiAyADQR91IgNqIANzIABBEHZB/wFxIARBEHZB/wFxayIDIANBH3UiA2ogA3MgAEEIdkH/AXEgBEEIdkH/AXFrIgMgA0EfdSIDaiADcyAAQf8BcSAEQf8BcWsiAyADQR91IgNqIANzampqampqampqampqampqC98RASZ/IAJBA2whDSACQQF0IRBBwAAgA0EBdSILQQJ0ayEfIAIgC2tBAnQhICAEIQYgCyEeA0AgCyEMA0AgBiAAQQNqIgcgDWotAAAgAS0AM2siCiAALQADIAEtAANrIghqIgkgByAQai0AACABLQAjayIRIAIgB2otAAAgAS0AE2siEmoiDmoiEyAAIA1qLQAAIAEtADBrIhQgAC0AACABLQAAayIVaiIPIAAgEGotAAAgAS0AIGsiFiAAIAJqLQAAIAEtABBrIhdqIhhqIhlqIhogAEECaiIHIA1qLQAAIAEtADJrIhsgAC0AAiABLQACayIcaiIdIAcgEGotAAAgAS0AImsiISACIAdqLQAAIAEtABJrIiJqIiNqIiQgAEEBaiIHIA1qLQAAIAEtADFrIiUgAC0AASABLQABayImaiInIAcgEGotAAAgAS0AIWsiKCACIAdqLQAAIAEtABFrIgdqIilqIipqIitrOwEwIAYgGiArajsBICAGIAkgDmsiCSAPIBhrIg5qIg8gHSAjayIYICcgKWsiGmoiHWs7ATQgBiAPIB1qOwEkIAYgGSATayITICogJGsiD0EBdGs7ATggBiATQQF0IA9qOwEoIAYgCCAKayIKQQF0IBIgEWsiCGoiESAXIBZrIhMgFSAUayISQQF0aiIUaiIVICIgIWsiFiAcIBtrIg9BAXRqIhcgByAoayIHICYgJWsiGUEBdGoiG2oiHGs7ATIgBiAVIBxqOwEiIAYgDiAJayIJIBogGGsiDkEBdGs7ATwgBiAJQQF0IA5qOwEsIAYgCiAIQQF0ayIKIBIgE0EBdGsiCGoiCSAPIBZBAXRrIhIgGSAHQQF0ayIHaiIOazsBNiAGIAkgDmo7ASYgBiAUIBFrIgkgGyAXayIRQQF0azsBOiAGIAlBAXQgEWo7ASogBiAIIAprIgogByASayIHQQF0azsBPiAGIApBAXQgB2o7AS4gAUEEaiEBIABBBGohACAGQUBrIQYgDEF/aiIMDQALIAEgH2ohASAAICBqIQAgHkF/aiIeDQALIANBAXEiCARAIARBYGohASALIAtsIQAgBCEGA0AgASAGLwEgOwEAIAZBQGshBiABQQJqIQEgAEF/aiIADQALC0EAIQcCQCADQXtqIgFBA0sNAAJAIAFBAWsOAgEBAAsCQCALIAtsIg1FBEAMAQsgBUEUaiECQQAhAANAIAghAQJAA0AgAiABQQdxQQF0ai8BACIGIAQgAEEGdGogAUEBdGouASBqIAZBAXRLDQEgAUEBaiIBQRBHDQALQQEgAHQgB3IhBwsgAEEBaiIAIA1HDQALCyADQQhHDQACQCAHQTNxQTNGDQAgBUEkaiEAQQAhAQNAIAAgAUEHcUEBdGovAQAiBiAEIAFBAXRqLgEgaiAGQQF0Sw0BIAFBAWoiAUEQRw0ACyAIIQEDQCAAIAFBB3FBAXRqLwEAIgYgBCABQQF0ai4BYGogBkEBdEsNASABQQFqIgFBEEcNAAsgCCEBA0AgACABQQdxQQF0ai8BACIGIAQgAUEBdGouAaACaiAGQQF0Sw0BIAFBAWoiAUEQRw0ACyAIIQEDQCAAIAFBB3FBAXRqLwEAIgYgBCABQQF0ai4B4AJqIAZBAXRLDQEgAUEBaiIBQRBHDQALIAdBM3IhBwsCQCAHQcwBcUHMAUYNACAFQSRqIQAgCCEBA0AgACABQQdxQQF0ai8BACIGIAQgAUEBdGouAaABaiAGQQF0Sw0BIAFBAWoiAUEQRw0ACyAIIQEDQCAAIAFBB3FBAXRqLwEAIgYgBCABQQF0ai4B4AFqIAZBAXRLDQEgAUEBaiIBQRBHDQALIAghAQNAIAAgAUEHcUEBdGovAQAiBiAEIAFBAXRqLgGgA2ogBkEBdEsNASABQQFqIgFBEEcNAAsgCCEBA0AgACABQQdxQQF0ai8BACIGIAQgAUEBdGouAeADaiAGQQF0Sw0BIAFBAWoiAUEQRw0ACyAHQcwBciEHCwJAIAdBgOYAcUGA5gBGDQAgBUEkaiEAIAghAQNAIAAgAUEHcUEBdGovAQAiBiAEIAFBAXRqLgGgBGogBkEBdEsNASABQQFqIgFBEEcNAAsgCCEBA0AgACABQQdxQQF0ai8BACIGIAQgAUEBdGouAeAEaiAGQQF0Sw0BIAFBAWoiAUEQRw0ACyAIIQEDQCAAIAFBB3FBAXRqLwEAIgYgBCABQQF0ai4BoAZqIAZBAXRLDQEgAUEBaiIBQRBHDQALIAghAQNAIAAgAUEHcUEBdGovAQAiBiAEIAFBAXRqLgHgBmogBkEBdEsNASABQQFqIgFBEEcNAAsgB0GA5gByIQcLIAdBgJgDcUGAmANGDQAgBUEkaiEAIAghAQNAIAAgAUEHcUEBdGovAQAiBiAEIAFBAXRqLgGgBWogBkEBdEsNASABQQFqIgFBEEcNAAsgCCEBA0AgACABQQdxQQF0ai8BACIGIAQgAUEBdGouAeAFaiAGQQF0Sw0BIAFBAWoiAUEQRw0ACyAIIQEDQCAAIAFBB3FBAXRqLwEAIgYgBCABQQF0ai4BoAdqIAZBAXRLDQEgAUEBaiIBQRBHDQALIAghAQNAIAAgAUEHcUEBdGovAQAiBiAEIAFBAXRqLgHgB2ogBkEBdEsNASABQQFqIgFBEEcNAAsgB0GAmANyIQcLIAshCUEAIQwDQCALIQoDQEEAIQAgCCEBAn8gB0EBcQRAIARCADcCACAEQgA3AhggBEIANwIQIARCADcCCCAHQQF1IQcgDEEBdAwBCwNAIAQgAUEBdGoiBiAGQSBqIg0uAQAiBiAFIAFB8DFqLQAAQQF0aiICLwEAbCAFLwEMIhBB//8DcyAQIAZBAEgbakEQdSIGOwEAIA0gAi8BAiAGbDsBAEEBIAF0QQAgBhsgAHIhACABQQFqIgFBEEcNAAsgB0EBdSEHIAxBAXQiDCAARQ0AGiAMQQFyCyEMIARBQGshBCAKQX9qIgoNAAsgCUF/aiIJDQALIAwLwg0BPH8CQAJAIABBA3FFBEAgAkEDcQ0BIAFBA3ENAiABQQNqISogAUECaiErIAFBAWohLCABQQNsIhJBA2ohLSASQQJqIS4gEkEBaiEvIAFBAXQiE0EDaiEwIBNBAmohMSATQQFyITJBwAAgBEECdGshMyABIARrQQJ0ITQgBCEdA0AgBCEeA0ACQCAFQQBOBEAgACACKAIANgIAIAAgAWoiByACKAIQNgIAIAEgB2oiByACKAIgNgIAIAEgB2ogAigCMDYCAAwBCyADQThqIgcgA0EoaiIGLgEAIgkgBy4BACIIQQF1aiIUIANBMGoiHy4BACILIAMuASAiDGoiFWpBEHRBEHUiDyADQSxqIiAuAQAiDSADQTxqIiEuAQAiEEEBdWoiNSADQTRqIiIuAQAiFiADQSRqIgouAQAiF2oiNmpBEHRBEHUiEWpBIGoiGCADQS5qIiMuAQAiGSADQT5qIiQuAQAiGkEBdWoiNyADQTZqIiUuAQAiGyADQSZqIiYuAQAiHGoiOGpBEHQiOUERdSADQSpqIicuAQAiOiADQTpqIiguAQAiO0EBdWoiPCADQTJqIikuAQAiPSADQSJqIg4uAQAiPmoiP2pBEHQiQEEQdWoiQWtBBnY7AQAgHyAPIBFrQSBqIg8gQEERdSA5QRB1ayIRa0EGdjsBACAGIA8gEWpBBnY7AQAgAyAYIEFqIg9BBnY7ASAgKCAJQQF1IAhrIgggDCALayIJakEQdEEQdSILIA1BAXUgEGsiDCAXIBZrIhBqQRB0QRB1Ig1qQSBqIhYgGUEBdSAaayIXIBwgG2siEWpBEHQiGEERdSA6QQF1IDtrIhogPiA9ayIZakEQdCIbQRB1aiIca0EGdjsBACApIAsgDWtBIGoiCyAbQRF1IBhBEHVrIg1rQQZ2OwEAICcgCyANakEGdjsBACAOIBYgHGpBBnY7AQAgISAJIAhrQRB0QRB1IgggECAMa0EQdEEQdSIJakEgaiILIBEgF2tBEHQiDEERdSAZIBprQRB0IhBBEHVqIg1rQQZ2OwEAICIgCCAJa0EgaiIIIBBBEXUgDEEQdWsiCWtBBnY7AQAgICAIIAlqQQZ2OwEAIAogCyANakEGdjsBACAkIBUgFGtBEHRBEHUiCCA2IDVrQRB0QRB1IglqQSBqIhQgOCA3a0EQdCILQRF1ID8gPGtBEHQiDEEQdWoiFWtBBnY7AQAgJSAIIAlrQSBqIgggDEERdSALQRB1ayIJa0EGdjsBACAjIAggCWpBBnY7AQAgJiAUIBVqQQZ2OwEAIAAgAi0AACAPQQZ1aiIIQQAgCEEAShsiCEH/ASAIQf8BSBs6AAAgACACLQABIA4uAQBqIg5BACAOQQBKGyIOQf8BIA5B/wFIGzoAASAAIAItAAIgCi4BAGoiCkEAIApBAEobIgpB/wEgCkH/AUgbOgACIAAgAi0AAyAmLgEAaiIKQQAgCkEAShsiCkH/ASAKQf8BSBs6AAMgACABaiACLQAQIAYuAQBqIgZBACAGQQBKGyIGQf8BIAZB/wFIGzoAACAAICxqIAItABEgJy4BAGoiBkEAIAZBAEobIgZB/wEgBkH/AUgbOgAAIAAgK2ogAi0AEiAgLgEAaiIGQQAgBkEAShsiBkH/ASAGQf8BSBs6AAAgACAqaiACLQATICMuAQBqIgZBACAGQQBKGyIGQf8BIAZB/wFIGzoAACAAIBNqIAItACAgHy4BAGoiBkEAIAZBAEobIgZB/wEgBkH/AUgbOgAAIAAgMmogAi0AISApLgEAaiIGQQAgBkEAShsiBkH/ASAGQf8BSBs6AAAgACAxaiACLQAiICIuAQBqIgZBACAGQQBKGyIGQf8BIAZB/wFIGzoAACAAIDBqIAItACMgJS4BAGoiBkEAIAZBAEobIgZB/wEgBkH/AUgbOgAAIAAgEmogAi0AMCAHLgEAaiIHQQAgB0EAShsiB0H/ASAHQf8BSBs6AAAgACAvaiACLQAxICguAQBqIgdBACAHQQBKGyIHQf8BIAdB/wFIGzoAACAAIC5qIAItADIgIS4BAGoiB0EAIAdBAEobIgdB/wEgB0H/AUgbOgAAIAAgLWogAi0AMyAkLgEAaiIHQQAgB0EAShsiB0H/ASAHQf8BSBs6AAALIAJBBGohAiAAQQRqIQAgA0FAayEDIAVBAXQhBSAeQX9qIh4NAAsgAiAzaiECIAAgNGohACAdQX9qIh0NAAsPC0GAMkGfH0GaOEGTMhAJAAtBpzJBnx9BmzhBkzIQCQALQbsyQZ8fQZw4QZMyEAkAC8cDAQx/IAAhAiMAQSBrIgwhA0EBIQFBASELA0AgAyACLgEYIgQgAi4BCCIFaiIHIAIuARAiCCACLgEAIglqIgpqOwEAIAMgC0EBdCIGaiIDIAUgBGsiBCAJIAhrIgVqOwEAIAMgBmoiAyAFIARrOwEAIAMgBmoiBCAKIAdrOwEAIAQgAUEBdCIDaiIBIAIuARoiBCACLgEKIgVqIgcgAi4BEiIIIAIuAQIiCWoiCmo7AQAgASAGaiIBIAUgBGsiBCAJIAhrIgVqOwEAIAEgBmoiASAFIARrOwEAIAEgBmoiASAKIAdrOwEAIAEgA2oiASACLgEcIgQgAi4BDCIFaiIHIAIuARQiCCACLgEEIglqIgpqOwEAIAEgBmoiASAFIARrIgQgCSAIayIFajsBACABIAZqIgEgBSAEazsBACABIAZqIgEgCiAHazsBACABIANqIgMgAi4BHiIBIAIuAQ4iBGoiBSACLgEWIgcgAi4BBiICaiIIajsBACADIAZqIgMgBCABayIBIAIgB2siAmo7AQAgAyAGaiIDIAIgAWs7AQAgAyAGaiAIIAVrOwEAQXUhASAMIQIgACEDQQUgC2siC0EBRw0ACwudFAEOfyMAQTBrIgokACAKQQhBICACQQRGIgQbaiEHIAAoAgghCyAAKAIAIQggACgCBCERAkAgBEUEQCABLgEeIgRBAXQhBiACQRBGBEACfyAERQRAIAchBSAKQSBqDAELIAdBfmoiBSAGOwEAIApBEDoAICAKQSBqQQFyCyEEIAEvARYiBgRAIAVBfmoiBSAGQQF0OwEAIARBDzoAACAEQQFqIQQLIAEvARwiBgRAIAVBfmoiBSAGQQF0OwEAIARBDjoAACAEQQFqIQQLIAEvARoiBgRAIAVBfmoiBSAGQQF0OwEAIARBDToAACAEQQFqIQQLIAEvARQiBgRAIAVBfmoiBSAGQQF0OwEAIARBDDoAACAEQQFqIQQLIAEvAQ4iBgRAIAVBfmoiBSAGQQF0OwEAIARBCzoAACAEQQFqIQQLIAEvAQYiBgRAIAVBfmoiBSAGQQF0OwEAIARBCjoAACAEQQFqIQQLIAEvAQwiBgRAIAVBfmoiBSAGQQF0OwEAIARBCToAACAEQQFqIQQLIAEvARIiBgRAIAVBfmoiBSAGQQF0OwEAIARBCDoAACAEQQFqIQQLIAEvARgiBgRAIAVBfmoiBSAGQQF0OwEAIARBBzoAACAEQQFqIQQLIAEvARAiBgRAIAVBfmoiBSAGQQF0OwEAIARBBjoAACAEQQFqIQQLIAEvAQoiBgRAIAVBfmoiBSAGQQF0OwEAIARBBToAACAEQQFqIQQLIAEvAQQiBgRAIAVBfmoiBSAGQQF0OwEAIARBBDoAACAEQQFqIQQLIAEvAQIiBgRAIAVBfmoiBSAGQQF0OwEAIARBAzoAACAEQQFqIQQLIAEvAQgiBgRAIAVBfmoiBSAGQQF0OwEAIARBAjoAACAEQQFqIQQLIAEvAQAiAUUNAiAFQX5qIgUgAUEBdDsBACAEQQE6AAAMAgsCfyAERQRAIAchBSAKQSBqDAELIAdBfmoiBSAGOwEAIApBDzoAICAKQSBqQQFyCyEEIAEvARYiBgRAIAVBfmoiBSAGQQF0OwEAIARBDjoAACAEQQFqIQQLIAEvARwiBgRAIAVBfmoiBSAGQQF0OwEAIARBDToAACAEQQFqIQQLIAEvARoiBgRAIAVBfmoiBSAGQQF0OwEAIARBDDoAACAEQQFqIQQLIAEvARQiBgRAIAVBfmoiBSAGQQF0OwEAIARBCzoAACAEQQFqIQQLIAEvAQ4iBgRAIAVBfmoiBSAGQQF0OwEAIARBCjoAACAEQQFqIQQLIAEvAQYiBgRAIAVBfmoiBSAGQQF0OwEAIARBCToAACAEQQFqIQQLIAEvAQwiBgRAIAVBfmoiBSAGQQF0OwEAIARBCDoAACAEQQFqIQQLIAEvARIiBgRAIAVBfmoiBSAGQQF0OwEAIARBBzoAACAEQQFqIQQLIAEvARgiBgRAIAVBfmoiBSAGQQF0OwEAIARBBjoAACAEQQFqIQQLIAEvARAiBgRAIAVBfmoiBSAGQQF0OwEAIARBBToAACAEQQFqIQQLIAEvAQoiBgRAIAVBfmoiBSAGQQF0OwEAIARBBDoAACAEQQFqIQQLIAEvAQQiBgRAIAVBfmoiBSAGQQF0OwEAIARBAzoAACAEQQFqIQQLIAEvAQIiBgRAIAVBfmoiBSAGQQF0OwEAIARBAjoAACAEQQFqIQQLIAEvAQgiAUUNASAFQX5qIgUgAUEBdDsBACAEQQE6AAAMAQsCfyABLwEGIgRFBEAgByEFIApBIGoMAQsgB0F+aiIFIARBAXQ7AQAgCkEEOgAgIApBIGpBAXILIQQgAS8BBCIGBEAgBUF+aiIFIAZBAXQ7AQAgBEEDOgAAIARBAWohBAsgAS8BAiIGBEAgBUF+aiIFIAZBAXQ7AQAgBEECOgAAIARBAWohBAsgAS8BACIBRQ0AIAVBfmoiBSABQQF0OwEAIARBAToAAAsgByAFayIQQQF1IQ0CQCAQRQRAQQAhB0EAIQQMAQsgB0F+aiEFQQAhB0EAIQQgDUEDIA1BA0gbIg4hAQNAIAUuAQAiBkECakEESw0BIARBAXQgBkGAgAJxQQ92ciEEIAdBAWohByAFQX5qIQUgAUF/aiIBDQALIA4hBwsgAyANOgAAIAMtAAEgA0F/ai0AAGoiAUEBakEBdiABIAFBI0kbQR9xQeA0ai0AACIGIA0gB2siDkECdCAHampB4DRqLQAAIgEgAUEEdiAGQeYBRiIDGyEGAn8gEUF6IAFBf3NBcHIgAxsgCGoiAUF/Sg0AGiALIAZBACABa3YgEXIiCEEYdCAIQQh0QYCA/AdxciAIQQh2QYD+A3EgCEEYdnJyNgIAIAFBIGohASALQQRqIQtBAAsgBiABdHIhBgJAIBBFDQAgBwRAAn8gBiABIAdrIgFBf0oNABogCyAGIARBACABa3VyIgZBGHQgBkEIdEGAgPwHcXIgBkEIdkGA/gNxIAZBGHZycjYCACABQSBqIQEgC0EEaiELQQALIAQgAXRyIQYLAkAgDkUNAEECQQEgBS4BACIEQX9zIARBfmogBEECSBsiCEEFShshBCAFQX5qIQMCfwJAAkACQCAHQQJMBEAgCEF+aiEFIBBBFU4NASAFIQgLQQAhBSAIQQ5IBEAgCCEJDAMLQQEhDCAIQR1KDQEgCEFyaiEPQQ4hCUEEIQUMAgsgBUEPIAVBAXUgCEEfSiIHGyIJQQF0ayEPQQxBASAHGyEFDAELQQAMAQtBAQshBwNAAkACQCAHRQRAQQ8hCUEMIQUMAQsgD0EBIAV0ciEMAn8gBiABIAVBf3NqIAlrIgFBf0oNABogCyAMQQAgAWt1IAZyIgVBGHQgBUEIdEGAgPwHcXIgBUEIdkGA/gNxIAVBGHZycjYCACABQSBqIQEgC0EEaiELQQALIAwgAXRyIQYgDkF/aiIORQ0DIAMuAQAhCSADQX5qIQMgBCEMIAQhBSAJQX9zIAlBfmogCUECSBsiCCAEdSIJQQ5KDQELIAwgDEEGSCAJQQJKcWohBCAIIAkgDHRrIQ9BASEHDAELQQAhBwwAAAsACyANIAJODQAgCi0AICEHIApBIGogDWogAjoAAEGHN0GgNyACQQRGGyEEIA1Bf2ohAyAHIA1rIgxBAXRBf2ohCSAKQSBqQQFyIQUDQCAEIAwgAyAEai0AAGpqLQAAIgNBBHYhBAJ/IAYgASADQQ9xayIBQX9KDQAaIAsgBEEAIAFrdiAGciIGQRh0IAZBCHRBgID8B3FyIAZBCHZBgP4DcSAGQRh2cnI2AgAgAUEgaiEBIAtBBGohC0EACyAEIAF0ciEGIAkgDGsiCUEASA0BIAcgBS0AACIDQX9zaiIMQQBIDQEgBUEBaiEFQeA4IQQgAyEHIAkiA0EOSA0AC0G2OEGfH0GAO0HGOBAJAAsgACALNgIIIAAgATYCACAAIAY2AgQgCkEwaiQAC5kCAQR/AkAgBUUNACAAIAFrIgktAAAiByAALQAAIghrIgYgBkEfdSIGaiAGcyACTg0AIAAgAUEBdGstAAAiBiAHayICIAJBH3UiAmogAnMgA04NACAAIAFqLQAAIgIgCGsiASABQR91IgFqIAFzIANODQAgAAJ/IAVBA0wEQCAJIARBf3MiBSAEQQFqIgMgBiACayAIIAdrQQJ0akEEakEDdSICIAIgA0obIgIgAiAFSBsiBSAHaiICQQAgAkEAShsiAkH/ASACQf8BSBs6AABB/wEgCCAFayIFQf8BSg0BGiAFQQAgBUEAShsMAQsgCSAHIAZBAXRqIAJqQQJqQQJ2OgAAIAYgCGogAkEBdGpBAmpBAnYLOgAACwuqCAEIfyMAQbABayICJAACQAJAAkAgACgCACABTQRAIAJB6D42AmAgAkHUPjYCKEHIsgVBADYCAEEpIAJB4ABqIgYgAkEoakEEciIEEAVByLIFKAIAIQNByLIFQQA2AgAgA0EBRg0BIAJCgICAgHA3A6gBIAJBsD42AmAgAkGcPjYCKEHIsgVBADYCAEEqIAQQDSEHQciyBSgCACEDQciyBUEANgIAIANBAUYEQBAGIQEQBxoMBAsgAkIANwJMIAJCADcCVCACQRA2AlwgAkHMPzYCLEHIsgVBADYCAEErIAJBKGpB0DtBFRAUIQVByLIFKAIAIQNByLIFQQA2AgACQAJAAkACQAJAAkACQAJAAkAgA0EBRg0AQciyBUEANgIAQSwgBSABEBUhA0HIsgUoAgAhAUHIsgVBADYCACABQQFGDQBByLIFQQA2AgBBKyADQeY7QQQQFCEDQciyBSgCACEBQciyBUEANgIAIAFBAUYNACAAKAIAIQFByLIFQQA2AgBBLCADIAEQFRpByLIFKAIAIQFByLIFQQA2AgAgAUEBRg0AQQQQDiEAQciyBUEANgIAQS1BMBANIQNByLIFKAIAIQFByLIFQQA2AgAgAUEBRg0BQciyBUEANgIAQS4gAkEIaiAEEAVByLIFKAIAIQFByLIFQQA2AgAgAUEBRg0CIAIoAgggAkEIaiACLAATQQBIGyIEEIgNIgFBcE8EQEHIsgVBADYCAEEvIAJBGGoQD0HIsgUoAgAhAUHIsgVBADYCACABQQFGDQQMDAsCQAJAIAFBC08EQEHIsgVBADYCAEEtIAFBEGpBcHEiCBANIQVByLIFKAIAIQlByLIFQQA2AgAgCUEBRg0GIAIgBTYCGCACIAE2AhwgAiAIQYCAgIB4cjYCIAwBCyACIAE6ACMgAkEYaiEFIAFFDQELIAUgBCABEIANGgsgASAFakEAOgAAQciyBUEANgIAQTAgAyACQRhqQcQAQes7QSVBjTwQFhpByLIFKAIAIQFByLIFQQA2AgBBASEEIAFBAUcEQCAAIAM2AgBByLIFQQA2AgBBMSAAQazdAEEAEBJByLIFKAIAIQFByLIFQQA2AgBBACEEIAFBAUcNDAsQBiEBEAcaIAIsACNBf0wEQCACKAIYEPYMCyACLAATQQBIDQQMBQsQBiEBEAcaDAcLEAYhARAHGgwFCxAGIQEQBxoMAwsQBiEBEAcaQQEhBCACLAATQQBODQILIAIoAggQ9gwLIARFDQILIAMQ9gwLIAAQEwsgAkGwPjYCYCACQZw+NgIoIAJBzD82AiwgAiwAV0F/TARAIAIoAkwQ9gwLIAcQ4AYaIAYQ3AYgARAIAAsgACgCCCEAIAJBsAFqJAAgACABQQJ0ag8LEAYhARAHGgwBCwALIAYQ3AYgARAIAAvOCAEIfyMAQbABayICJAACQAJAAkAgACgCACIDIAFNBEAgAkHoPjYCYCACQdQ+NgIoQciyBUEANgIAQSkgAkHgAGoiBiACQShqQQRyIgQQBUHIsgUoAgAhA0HIsgVBADYCACADQQFGDQEgAkKAgICAcDcDqAEgAkGwPjYCYCACQZw+NgIoQciyBUEANgIAQSogBBANIQdByLIFKAIAIQNByLIFQQA2AgAgA0EBRgRAEAYhARAHGgwECyACQgA3AkwgAkIANwJUIAJBEDYCXCACQcw/NgIsQciyBUEANgIAQSsgAkEoakHQO0EVEBQhBUHIsgUoAgAhA0HIsgVBADYCAAJAAkACQAJAAkACQAJAAkACQCADQQFGDQBByLIFQQA2AgBBLCAFIAEQFSEDQciyBSgCACEBQciyBUEANgIAIAFBAUYNAEHIsgVBADYCAEErIANB5jtBBBAUIQNByLIFKAIAIQFByLIFQQA2AgAgAUEBRg0AIAAoAgAhAUHIsgVBADYCAEEsIAMgARAVGkHIsgUoAgAhAUHIsgVBADYCACABQQFGDQBBBBAOIQBByLIFQQA2AgBBLUEwEA0hA0HIsgUoAgAhAUHIsgVBADYCACABQQFGDQFByLIFQQA2AgBBLiACQQhqIAQQBUHIsgUoAgAhAUHIsgVBADYCACABQQFGDQIgAigCCCACQQhqIAIsABNBAEgbIgQQiA0iAUFwTwRAQciyBUEANgIAQS8gAkEYahAPQciyBSgCACEBQciyBUEANgIAIAFBAUYNBAwMCwJAAkAgAUELTwRAQciyBUEANgIAQS0gAUEQakFwcSIIEA0hBUHIsgUoAgAhCUHIsgVBADYCACAJQQFGDQYgAiAFNgIYIAIgATYCHCACIAhBgICAgHhyNgIgDAELIAIgAToAIyACQRhqIQUgAUUNAQsgBSAEIAEQgA0aCyABIAVqQQA6AABByLIFQQA2AgBBMCADIAJBGGpBxABB6ztBJUGYPBAWGkHIsgUoAgAhAUHIsgVBADYCAEEBIQQgAUEBRwRAIAAgAzYCAEHIsgVBADYCAEExIABBrN0AQQAQEkHIsgUoAgAhAUHIsgVBADYCAEEAIQQgAUEBRw0MCxAGIQEQBxogAiwAI0F/TARAIAIoAhgQ9gwLIAIsABNBAEgNBAwFCxAGIQEQBxoMBwsQBiEBEAcaDAULEAYhARAHGgwDCxAGIQEQBxpBASEEIAIsABNBAE4NAgsgAigCCBD2DAsgBEUNAgsgAxD2DAsgABATCyACQbA+NgJgIAJBnD42AiggAkHMPzYCLCACLABXQX9MBEAgAigCTBD2DAsgBxDgBhogBhDcBiABEAgACyAAIANBf2oiAzYCACADIAFLBEAgACgCCCABQQJ0aiIAIABBBGogAyABa0ECdBCCDQsgAkGwAWokAA8LEAYhARAHGgwBCwALIAYQ3AYgARAIAAvLCQEGfyMAQRBrIgUkACAAQag8NgIAIABBEGohByAAQQRqIAEQhwwhCgJAAkACQAJAAkACQAJAAkACQAJAAkAgAhCIDSIBQXBPBEBByLIFQQA2AgBBLyAHEA9ByLIFKAIAIQBByLIFQQA2AgAgAEEBRg0BDAsLAkACQCABQQtPBEBByLIFQQA2AgBBLSABQRBqQXBxIggQDSEGQciyBSgCACEJQciyBUEANgIAIAlBAUYNAyAAIAY2AhAgACAIQYCAgIB4cjYCGCAAIAE2AhQMAQsgByABOgALIAchBiABRQ0BCyAGIAIgARCADRoLIAEgBmpBADoAACAAIAM2AhwgAEEgaiEDIAQQiA0iAUFwTwRAQciyBUEANgIAQS8gAxAPQciyBSgCACEAQciyBUEANgIAIABBAUcNCwwICwJAAkAgAUELTwRAQciyBUEANgIAQS0gAUEQakFwcSIIEA0hBkHIsgUoAgAhCUHIsgVBADYCACAJQQFGDQogACAGNgIgIAAgCEGAgICAeHI2AiggACABNgIkDAELIAMgAToACyADIQYgAUUNAQsgBiAEIAEQgA0aCyABIAZqQQA6AAAgAg0EQQQQDiEBQciyBUEANgIAQS1BLBANIQRByLIFKAIAIQBByLIFQQA2AgAgAEEBRg0BQciyBUEANgIAQS1BIBANIQBByLIFKAIAIQJByLIFQQA2AgAgAkEBRg0CIAUgADYCACAFQpeAgICAhICAgH83AgQgAEEAOgAXIABBwzwpAAA3AA8gAEG8PCkAADcACCAAQbQ8KQAANwAAQciyBUEANgIAQTIgBCAFQcw8QSlB8jwQEBpByLIFKAIAIQBByLIFQQA2AgBBASECIABBAUcEQCABIAQ2AgBBACECQciyBUEANgIAQTEgAUGg2gBBABASQciyBSgCACEAQciyBUEANgIAIABBAUcNCwsQBiEAEAcaIAUsAAtBf0wEQCAFKAIAEPYMCyACDQMMBQsQBiEAEAcaDAgLEAYhABAHGiABEBMMAwsQBiEAEAcaCyAEEPYMIAEQEwwBCyAEDQFBBBAOIQFByLIFQQA2AgBBLUEsEA0hBEHIsgUoAgAhAEHIsgVBADYCAAJAAkACQCAAQQFHBEBByLIFQQA2AgBBLUEgEA0hAEHIsgUoAgAhAkHIsgVBADYCACACQQFGDQEgBSAANgIAIAVCm4CAgICEgICAfzcCBCAAQQA6ABsgAEGzPSgAADYAFyAAQaw9KQAANwAQIABBpD0pAAA3AAggAEGcPSkAADcAAEHIsgVBADYCAEEyIAQgBUHMPEEqQfI8EBAaQciyBSgCACEAQciyBUEANgIAQQEhAiAAQQFHBEAgASAENgIAQciyBUEANgIAQTEgAUGg2gBBABASQciyBSgCACEAQciyBUEANgIAQQAhAiAAQQFHDQoLEAYhABAHGiAFLAALQX9MBEAgBSgCABD2DAsgAg0CDAQLEAYhABAHGgwCCxAGIQAQBxoLIAQQ9gwLIAEQEwsgAywAC0F/Sg0CIAMoAgAQ9gwMAgsgBUEQaiQAIAAPCxAGIQAQBxoLIAcsAAtBf0oNACAHKAIAEPYMCyAKLAALQX9MBEAgCigCABD2DAsgABAIAAsAC0UAIABBqDw2AgAgACwAK0F/TARAIAAoAiAQ9gwLIAAsABtBf0wEQCAAKAIQEPYMCyAALAAPQX9MBEAgACgCBBD2DAsgAAtIACAAQag8NgIAIAAsACtBf0wEQCAAKAIgEPYMCyAALAAbQX9MBEAgACgCEBD2DAsgACwAD0F/TARAIAAoAgQQ9gwLIAAQ9gwLhwcBCH8jAEGQAWsiAyQAIANB6D42AkAgA0HUPjYCCEHIsgVBADYCAEEpIANBQGsiByADQQhqQQRyIggQBUHIsgUoAgAhAkHIsgVBADYCAAJAIAJBAUcEQCADQoCAgIBwNwOIASADQbA+NgJAIANBnD42AghByLIFQQA2AgBBKiAIEA0hCUHIsgUoAgAhAkHIsgVBADYCACACQQFGBEAQBiEBEAcaDAILIANCADcCLCADQgA3AjQgA0EQNgI8IANBzD82AgwgASgCJCEEIAEtACshAiABKAIgIQVByLIFQQA2AgBBKyADQQhqIAUgAUEgaiACQRh0QRh1QQBIIgYbIAQgAiAGGxAUIQJByLIFKAIAIQRByLIFQQA2AgACQCAEQQFGDQBByLIFQQA2AgBBKyACQbg9QQIQFCEEQciyBSgCACECQciyBUEANgIAIAJBAUYNACABKAIIIQUgAS0ADyECIAEoAgQhBkHIsgVBADYCAEErIAQgBiABQQRqIAJBGHRBGHVBAEgiBBsgBSACIAQbEBQhAkHIsgUoAgAhBEHIsgVBADYCACAEQQFGDQBByLIFQQA2AgBBKyACQbs9QQIQFCEEQciyBSgCACECQciyBUEANgIAIAJBAUYNACABKAIUIQUgAS0AGyECIAEoAhAhBkHIsgVBADYCAEErIAQgBiABQRBqIAJBGHRBGHVBAEgiBBsgBSACIAQbEBQhAkHIsgUoAgAhBEHIsgVBADYCACAEQQFGDQBByLIFQQA2AgBBKyACQb49QQEQFCECQciyBSgCACEEQciyBUEANgIAIARBAUYNACABKAIcIQFByLIFQQA2AgBBMyACIAEQFSEBQciyBSgCACECQciyBUEANgIAIAJBAUYNAEHIsgVBADYCAEErIAFBwD1BARAUGkHIsgUoAgAhAUHIsgVBADYCACABQQFGDQBByLIFQQA2AgBBLiAAIAgQBUHIsgUoAgAhAUHIsgVBADYCACABQQFGDQAgA0GwPjYCQCADQZw+NgIIIANBzD82AgwgAywAN0F/TARAIAMoAiwQ9gwLIAkQ4AYaIAcQ3AYgA0GQAWokAA8LEAYhARAHGiADQbA+NgJAIANBnD42AgggA0HMPzYCDCADLAA3QX9MBEAgAygCLBD2DAsgCRDgBhogBxDcBiABEAgACxAGIQEQBxoLIAcQ3AYgARAIAAv9BAEHfyMAQRBrIgQkAEHIsgVBADYCAEE0IAQgABAVIQdByLIFKAIAIQNByLIFQQA2AgACQAJAAkAgA0EBRwRAAkACQAJAIAQtAABFDQAgACAAKAIAQXRqKAIAaiIDKAIEIQggAygCGCEJIAMoAkwiBUF/RgRAQciyBUEANgIAIARBCGogAxD4BkHIsgUoAgAhBUHIsgVBADYCACAFQQFGDQJByLIFQQA2AgBBNiAEQQhqQbS0BRAVIQVByLIFKAIAIQZByLIFQQA2AgACQCAGQQFHBEAgBSgCACgCHCEGQciyBUEANgIAIAYgBUEgEBUhBUHIsgUoAgAhBkHIsgVBADYCACAGQQFHDQELQQAQCyEDEAcaIARBCGoQ9wcMBAsgBEEIahD3ByADIAU2AkwLQciyBUEANgIAQTcgCSABIAEgAmoiAiABIAhBsAFxQSBGGyACIAMgBUEYdEEYdRAWIQFByLIFKAIAIQNByLIFQQA2AgAgA0EBRg0BIAENACAAIAAoAgBBdGooAgBqIgMoAhAhAUHIsgVBADYCAEE4IAMgAUEFchAFQciyBSgCACEDQciyBUEANgIAIANBAUcNAEEAEAshAxAHGgwCCyAHEIUHDAQLQQAQCyEDEAcaCyAHEIUHDAELQQAQCyEDEAcaCyADEAwaIAAoAgBBdGooAgAhA0HIsgVBADYCAEE5IAAgA2oQD0HIsgUoAgAhA0HIsgVBADYCACADQQFGDQEQFwsgBEEQaiQAIAAPCxAGIQQQBxpByLIFQQA2AgBBOhAKQciyBSgCACEAQciyBUEANgIAIABBAUYEQEEAEAshABAHGiAAEIQBAAsgBBAIAAvbAgEEfwJAIAEoAjAiA0EQcQRAIAEoAiwiAyABKAIYIgJJBEAgASACNgIsIAIhAwsgAyABKAIUIgFrIgJBcE8NAQJAIAJBCk0EQCAAIAI6AAsMAQsgAkEQakFwcSIFEP4LIQQgACAFQYCAgIB4cjYCCCAAIAQ2AgAgACACNgIEIAQhAAsgASADRwRAA0AgACABLQAAOgAAIABBAWohACABQQFqIgEgA0cNAAsLIABBADoAAA8LIANBCHEEQCABKAIQIgMgASgCCCIBayICQXBPDQECQCACQQpNBEAgACACOgALDAELIAJBEGpBcHEiBRD+CyEEIAAgBUGAgICAeHI2AgggACAENgIAIAAgAjYCBCAEIQALIAEgA0cEQANAIAAgAS0AADoAACAAQQFqIQAgAUEBaiIBIANHDQALCyAAQQA6AAAPCyAAQgA3AgAgAEEANgIIDwsgABCGDAALQAAgAEGwPjYCOCAAQZw+NgIAIABBzD82AgQgACwAL0F/TARAIAAoAiQQ9gwLIABBBGoQ4AYaIABBOGoQ3AYgAAshACAAIAEgAyAEIAUQkwEaIAAgAjYCLCAAQcw9NgIAIAAL6QcBCH8jAEGQAWsiAyQAIANB6D42AkAgA0HUPjYCCEHIsgVBADYCAEEpIANBQGsiByADQQhqQQRyIggQBUHIsgUoAgAhAkHIsgVBADYCAAJAIAJBAUcEQCADQoCAgIBwNwOIASADQbA+NgJAIANBnD42AghByLIFQQA2AgBBKiAIEA0hCUHIsgUoAgAhAkHIsgVBADYCACACQQFGBEAQBiEBEAcaDAILIANCADcCLCADQgA3AjQgA0EQNgI8IANBzD82AgwgASgCJCEEIAEtACshAiABKAIgIQVByLIFQQA2AgBBKyADQQhqIAUgAUEgaiACQRh0QRh1QQBIIgYbIAQgAiAGGxAUIQJByLIFKAIAIQRByLIFQQA2AgACQCAEQQFGDQBByLIFQQA2AgBBKyACQbg9QQIQFCEEQciyBSgCACECQciyBUEANgIAIAJBAUYNACABKAIIIQUgAS0ADyECIAEoAgQhBkHIsgVBADYCAEErIAQgBiABQQRqIAJBGHRBGHVBAEgiBBsgBSACIAQbEBQhAkHIsgUoAgAhBEHIsgVBADYCACAEQQFGDQBByLIFQQA2AgBBKyACQdg9QQkQFCECQciyBSgCACEEQciyBUEANgIAIARBAUYNACABKAIsIQRByLIFQQA2AgBBMyACIAQQFSECQciyBSgCACEEQciyBUEANgIAIARBAUYNAEHIsgVBADYCAEErIAJBuz1BAhAUIQRByLIFKAIAIQJByLIFQQA2AgAgAkEBRg0AIAEoAhQhBSABLQAbIQIgASgCECEGQciyBUEANgIAQSsgBCAGIAFBEGogAkEYdEEYdUEASCIEGyAFIAIgBBsQFCECQciyBSgCACEEQciyBUEANgIAIARBAUYNAEHIsgVBADYCAEErIAJBvj1BARAUIQJByLIFKAIAIQRByLIFQQA2AgAgBEEBRg0AIAEoAhwhAUHIsgVBADYCAEEzIAIgARAVIQFByLIFKAIAIQJByLIFQQA2AgAgAkEBRg0AQciyBUEANgIAQSsgAUHAPUEBEBQaQciyBSgCACEBQciyBUEANgIAIAFBAUYNAEHIsgVBADYCAEEuIAAgCBAFQciyBSgCACEBQciyBUEANgIAIAFBAUYNACADQbA+NgJAIANBnD42AgggA0HMPzYCDCADLAA3QX9MBEAgAygCLBD2DAsgCRDgBhogBxDcBiADQZABaiQADwsQBiEBEAcaIANBsD42AkAgA0GcPjYCCCADQcw/NgIMIAMsADdBf0wEQCADKAIsEPYMCyAJEOAGGiAHENwGIAEQCAALEAYhARAHGgsgBxDcBiABEAgAC04AIAAgACgCAEF0aigCAGoiAEGwPjYCOCAAQZw+NgIAIABBzD82AgQgACwAL0F/TARAIAAoAiQQ9gwLIABBBGoQ4AYaIABBOGoQ3AYgAAtDACAAQbA+NgI4IABBnD42AgAgAEHMPzYCBCAALAAvQX9MBEAgACgCJBD2DAsgAEEEahDgBhogAEE4ahDcBiAAEPYMC1EAIAAgACgCAEF0aigCAGoiAEGwPjYCOCAAQZw+NgIAIABBzD82AgQgACwAL0F/TARAIAAoAiQQ9gwLIABBBGoQ4AYaIABBOGoQ3AYgABD2DAslACAAQcw/NgIAIAAsACtBf0wEQCAAKAIgEPYMCyAAEOAGGiAACygAIABBzD82AgAgACwAK0F/TARAIAAoAiAQ9gwLIAAQ4AYaIAAQ9gwLqQICA38DfiABKAIsIgUgASgCGCIGSQRAIAEgBjYCLCAGIQULQn8hCgJAIARBGHEiB0UNACADQQFGQQAgB0EYRhsNACAFBEAgAUEgaiEHIAUgASwAK0F/TAR/IAcoAgAFIAcLa6whCQsgA0ECSw0AAkACQAJAIANBAWsOAgABAgsgBEEIcQRAIAEoAgwgASgCCGusIQgMAgsgBiABKAIUa6whCAwBCyAJIQgLIAIgCHwiAkIAUw0AIAkgAlMNACAEQQhxIQMCQCACUA0AIAMEQCABKAIMRQ0CCyAEQRBxRQ0AIAZFDQELIAMEQCABIAU2AhAgASABKAIIIAKnajYCDAsgBEEQcQRAIAEgASgCFCACp2o2AhgLIAIhCgsgACAKNwMIIABCADcDAAsaACAAIAEgAikDCEEAIAMgASgCACgCEBEUAAtgAQN/IAAoAiwiASAAKAIYIgJJBEAgACACNgIsIAIhAQtBfyECAkAgAC0AMEEIcUUNACAAKAIQIgMgAUkEQCAAIAE2AhAgASEDCyAAKAIMIgAgA08NACAALQAAIQILIAILjgEBAn8gACgCLCIDIAAoAhgiAkkEQCAAIAI2AiwgAiEDCwJ/QX8gACgCCCAAKAIMIgJPDQAaIAFBf0YEQCAAIAM2AhAgACACQX9qNgIMQQAPCyAALQAwQRBxRQRAQX8gAkF/ai0AACABQf8BcUcNARoLIAAgAzYCECAAIAJBf2oiAjYCDCACIAE6AAAgAQsL+QMBCX8jAEEQayIHJAACQCABQX9GBEAMAQsgACgCCCEIIAAoAgwhCgJAAkAgACgCGCIGIAAoAhwiBEcEQCAAKAIsIQMMAQtBfyECIAAtADBBEHFFDQIgACgCLCEJIAAoAhQhA0HIsgVBADYCAEE7IABBIGoiBUEAEAVByLIFKAIAIQRByLIFQQA2AgAgBEEBRg0BQQohBCAFLAALQX9MBEAgACgCKEH/////B3FBf2ohBAtByLIFQQA2AgBBPCAFIARBABASQciyBSgCACEEQciyBUEANgIAIARBAUYNASAJIANrIQkgBiADayEGAn8gBSwACyICQX9MBEAgACgCICEFIAAoAiQMAQsgAkH/AXELIQIgACAFNgIUIAAgAiAFaiIENgIcIAAgBSAJaiIDNgIsIAAgBSAGaiIGNgIYCyAHIAZBAWoiAjYCDCAAIABBLGogB0EMaiACIANJGygCACIFNgIsIAAtADBBCHEEQCAKIAhrIQggAEEgaiEDIAAsACtBf0wEQCADKAIAIQMLIAAgBTYCECAAIAM2AgggACADIAhqNgIMCyAEIAZGBEAgACABQf8BcSAAKAIAKAI0EQMAIQIMAgsgACACNgIYIAYgAToAACABQf8BcSECDAELQQAQCyEAEAcaIAAQDBoQFwsgB0EQaiQAIAIL+QIBBH8jAEEQayIHJAACQAJAIABFDQAgBCgCDCEIIAIgAWsiCUEBTgRAIAAgASAJIAAoAgAoAjARBAAgCUcNAQsgCCADIAFrIgZrQQAgCCAGShsiAUEBTgRAAkAgAUELTwRAIAFBEGpBcHEiBhD+CyEIIAcgBkGAgICAeHI2AgggByAINgIAIAcgATYCBCAHIQYMAQsgByABOgALIAciBiEICyAIIAUgARCBDSABakEAOgAAIAAoAgAoAjAhCCAGLAALIQlByLIFQQA2AgAgCCAAIAcoAgAgByAJQQBIGyABEBQhCEHIsgUoAgAhCUHIsgVBADYCACAJQQFGDQIgBiwAC0F/TARAIAcoAgAQ9gwLQQAhBiABIAhHDQELIAMgAmsiAUEBTgRAQQAhBiAAIAIgASAAKAIAKAIwEQQAIAFHDQELIARBADYCDCAAIQYLIAdBEGokACAGDwsQBiEAEAcaIAYsAAtBf0wEQCAHKAIAEPYMCyAAEAgAC+4jAQh/IAAgAUHUwAAQggMhASAAQeTAADYCAEHIsgVBADYCAEEtQRwQDSECQciyBSgCACEDQciyBUEANgIAAkACQAJAAkACQAJAAkACQAJAAkACQAJAAkACQAJAAkACQAJAAkACQAJAAkACQAJAAkACQAJAAkACQCADQQFGDQBByLIFQQA2AgAgAiABQYjBABCgBCEDQciyBSgCACEFQciyBUEANgIAIAVBAUYNASACQQA2AhggAkIANwIQIAJBkMwCNgIAQciyBUEANgIAQaDMAigCACIFIAJBARAFQciyBSgCACEEQciyBUEANgIAAkAgBEEBRwRAQciyBUEANgIAQdkAIAJBEGpBABAVIQRByLIFKAIAIQZByLIFQQA2AgAgBkEBRw0BCxAGIQUQBxogAigCGCEDQciyBUEANgIAIAMQ6AFByLIFKAIAIQNByLIFQQA2AgAgA0EBRw0DQQAQCyEBEAcaIAEQhAEACyAEQQA6AABByLIFQQA2AgBB2wAgASADEAVByLIFKAIAIQJByLIFQQA2AgAgAkEBRg0AQciyBUEANgIAQS1BHBANIQJByLIFKAIAIQNByLIFQQA2AgAgA0EBRg0AQciyBUEANgIAIAIgAUGdwQAQoAQhA0HIsgUoAgAhBEHIsgVBADYCACAEQQFGDQMgAkEANgIYIAJCADcCECACQZDMAjYCAEHIsgVBADYCACAFIAJBARAFQciyBSgCACEEQciyBUEANgIAAkAgBEEBRwRAQciyBUEANgIAQdkAIAJBEGpBABAVIQRByLIFKAIAIQZByLIFQQA2AgAgBkEBRw0BCxAGIQUQBxogAigCGCEDQciyBUEANgIAIAMQ6AFByLIFKAIAIQNByLIFQQA2AgAgA0EBRw0FQQAQCyEBEAcaIAEQhAEACyAEQQA6AABByLIFQQA2AgBB2wAgASADEAVByLIFKAIAIQJByLIFQQA2AgAgAkEBRg0AQciyBUEANgIAQS1BHBANIQJByLIFKAIAIQNByLIFQQA2AgAgA0EBRg0AQciyBUEANgIAIAIgAUGywQAQoAQhA0HIsgUoAgAhBEHIsgVBADYCACAEQQFGDQUgAkEANgIYIAJCADcCECACQZDMAjYCAEHIsgVBADYCACAFIAJBARAFQciyBSgCACEEQciyBUEANgIAAkAgBEEBRwRAQciyBUEANgIAQdkAIAJBEGpBABAVIQRByLIFKAIAIQZByLIFQQA2AgAgBkEBRw0BCxAGIQUQBxogAigCGCEDQciyBUEANgIAIAMQ6AFByLIFKAIAIQNByLIFQQA2AgAgA0EBRw0HQQAQCyEBEAcaIAEQhAEACyAEQQA6AABByLIFQQA2AgBB2wAgASADEAVByLIFKAIAIQJByLIFQQA2AgAgAkEBRg0AQciyBUEANgIAQS1BHBANIQJByLIFKAIAIQNByLIFQQA2AgAgA0EBRg0AQciyBUEANgIAIAIgAUHIwQAQoAQhA0HIsgUoAgAhBEHIsgVBADYCACAEQQFGDQcgAkEANgIYIAJCADcCECACQZDMAjYCAEHIsgVBADYCACAFIAJBARAFQciyBSgCACEEQciyBUEANgIAAkAgBEEBRwRAQciyBUEANgIAQdkAIAJBEGpBABAVIQRByLIFKAIAIQZByLIFQQA2AgAgBkEBRw0BCxAGIQUQBxogAigCGCEDQciyBUEANgIAIAMQ6AFByLIFKAIAIQNByLIFQQA2AgAgA0EBRw0JQQAQCyEBEAcaIAEQhAEACyAEQQA6AABByLIFQQA2AgBB2wAgASADEAVByLIFKAIAIQJByLIFQQA2AgAgAkEBRg0AQciyBUEANgIAQS1BIBANIQJByLIFKAIAIQNByLIFQQA2AgAgA0EBRg0AQciyBUEANgIAIAIgAUHbwQAQoAQhBEHIsgUoAgAhA0HIsgVBADYCACADQQFGDQkgAkEANgIYIAJCADcCECACQcDPAjYCAEHIsgVBADYCAEHQzwIoAgAiAyACQQEQBUHIsgUoAgAhBkHIsgVBADYCAAJAIAZBAUcEQEHIsgVBADYCAEHcACACQRBqQQAQFSEGQciyBSgCACEHQciyBUEANgIAIAdBAUcNAQsQBiEFEAcaIAIoAhghA0HIsgVBADYCACADEOgBQciyBSgCACEDQciyBUEANgIAIANBAUcNC0EAEAshARAHGiABEIQBAAsgBkIANwMAIAJBBjoAHCACQaDQAjYCAEHIsgVBADYCAEHbACABIAQQBUHIsgUoAgAhAkHIsgVBADYCACACQQFGDQBByLIFQQA2AgBBLUEgEA0hAkHIsgUoAgAhBEHIsgVBADYCACAEQQFGDQBByLIFQQA2AgAgAiABQeTBABCgBCEEQciyBSgCACEGQciyBUEANgIAIAZBAUYNCyACQQA2AhggAkIANwIQIAJBwM8CNgIAQciyBUEANgIAIAMgAkEBEAVByLIFKAIAIQZByLIFQQA2AgACQCAGQQFHBEBByLIFQQA2AgBB3AAgAkEQakEAEBUhBkHIsgUoAgAhB0HIsgVBADYCACAHQQFHDQELEAYhBRAHGiACKAIYIQNByLIFQQA2AgAgAxDoAUHIsgUoAgAhA0HIsgVBADYCACADQQFHDQ1BABALIQEQBxogARCEAQALIAZCADcDACACQQI6ABwgAkGg0AI2AgBByLIFQQA2AgBB2wAgASAEEAVByLIFKAIAIQJByLIFQQA2AgAgAkEBRg0AQciyBUEANgIAQS1BIBANIQJByLIFKAIAIQRByLIFQQA2AgAgBEEBRg0AQciyBUEANgIAIAIgAUH3wQAQoAQhBEHIsgUoAgAhBkHIsgVBADYCACAGQQFGDQ0gAkEANgIYIAJCADcCECACQcDPAjYCAEHIsgVBADYCACADIAJBARAFQciyBSgCACEGQciyBUEANgIAAkAgBkEBRwRAQciyBUEANgIAQdwAIAJBEGpBABAVIQZByLIFKAIAIQdByLIFQQA2AgAgB0EBRw0BCxAGIQUQBxogAigCGCEDQciyBUEANgIAIAMQ6AFByLIFKAIAIQNByLIFQQA2AgAgA0EBRw0PQQAQCyEBEAcaIAEQhAEACyAGQgA3AwAgAkEDOgAcIAJBoNACNgIAQciyBUEANgIAQdsAIAEgBBAFQciyBSgCACECQciyBUEANgIAIAJBAUYNAEHIsgVBADYCAEEtQSAQDSECQciyBSgCACEEQciyBUEANgIAIARBAUYNAEHIsgVBADYCACACIAFBgcIAEKAEIQRByLIFKAIAIQZByLIFQQA2AgAgBkEBRg0PIAJBADYCGCACQgA3AhAgAkHAzwI2AgBByLIFQQA2AgAgAyACQQEQBUHIsgUoAgAhA0HIsgVBADYCAAJAIANBAUcEQEHIsgVBADYCAEHcACACQRBqQQAQFSEDQciyBSgCACEGQciyBUEANgIAIAZBAUcNAQsQBiEFEAcaIAIoAhghA0HIsgVBADYCACADEOgBQciyBSgCACEDQciyBUEANgIAIANBAUcNEUEAEAshARAHGiABEIQBAAsgA0IANwMAIAJBBToAHCACQaDQAjYCAEHIsgVBADYCAEHbACABIAQQBUHIsgUoAgAhA0HIsgVBADYCACADQQFGDQBByLIFQQA2AgBBLUEgEA0hA0HIsgUoAgAhBEHIsgVBADYCACAEQQFGDQBByLIFQQA2AgAgAyABQZzCACACEMUEIQRByLIFKAIAIQJByLIFQQA2AgAgAkEBRg0RIANB4MQANgIAQciyBUEANgIAQdsAIAEgAxAFQciyBSgCACECQciyBUEANgIAIAJBAUYNAEHIsgVBADYCAEEtQRwQDSECQciyBSgCACEGQciyBUEANgIAIAZBAUYNACADKAIEIQZByLIFQQA2AgAgAiAGQazCABCgBCEGQciyBSgCACEHQciyBUEANgIAIAdBAUYNEiACQQA2AhggAkIANwIQIAJBoM0CNgIAQciyBUEANgIAQbDNAigCACIHIAJBARAFQciyBSgCACEIQciyBUEANgIAAkAgCEEBRwRAQciyBUEANgIAQd4AIAJBEGpBABAVIQhByLIFKAIAIQlByLIFQQA2AgAgCUEBRw0BCxAGIQUQBxogAigCGCEDQciyBUEANgIAIAMQ6AFByLIFKAIAIQNByLIFQQA2AgAgA0EBRw0UQQAQCyEBEAcaIAEQhAEACyAIQQA7AQBByLIFQQA2AgBB3wAgBCAGEAVByLIFKAIAIQJByLIFQQA2AgAgAkEBRg0AQciyBUEANgIAQS1BMBANIQJByLIFKAIAIQZByLIFQQA2AgAgBkEBRg0AIAMoAgQhA0HIsgVBADYCAEHgACACIANBx8IAQQBBABAQGkHIsgUoAgAhA0HIsgVBADYCACADQQFGDRRByLIFQQA2AgBB3wAgBCACEAVByLIFKAIAIQJByLIFQQA2AgAgAkEBRg0AQciyBUEANgIAQS1BHBANIQJByLIFKAIAIQNByLIFQQA2AgAgA0EBRg0VQciyBUEANgIAIAIgAUHjwgAQoAQhA0HIsgUoAgAhBEHIsgVBADYCACAEQQFGDRYgAkEANgIYIAJCADcCECACQZDMAjYCAEHIsgVBADYCACAFIAJBARAFQciyBSgCACEFQciyBUEANgIAAkAgBUEBRwRAQciyBUEANgIAQdkAIAJBEGpBABAVIQVByLIFKAIAIQRByLIFQQA2AgAgBEEBRw0BCxAGIQUQBxogAigCGCEDQciyBUEANgIAIAMQ6AFByLIFKAIAIQNByLIFQQA2AgAgA0EBRw0YQQAQCyEBEAcaIAEQhAEACyAFQQA6AABByLIFQQA2AgBB2wAgASADEAVByLIFKAIAIQNByLIFQQA2AgAgA0EBRg0VQciyBUEANgIAQS1BIBANIQNByLIFKAIAIQVByLIFQQA2AgAgBUEBRg0VQciyBUEANgIAIAMgAUH9wgAgAhDFBCEFQciyBSgCACECQciyBUEANgIAIAJBAUYNGCADQeDEADYCAEHIsgVBADYCAEHbACABIAMQBUHIsgUoAgAhAkHIsgVBADYCACACQQFGDRVByLIFQQA2AgBBLUEcEA0hAkHIsgUoAgAhBEHIsgVBADYCACAEQQFGDRUgAygCBCEEQciyBUEANgIAIAIgBEGMwwAQoAQhBEHIsgUoAgAhBkHIsgVBADYCACAGQQFGDRkgAkEANgIYIAJCADcCECACQaDNAjYCAEHIsgVBADYCACAHIAJBARAFQciyBSgCACEGQciyBUEANgIAAkAgBkEBRwRAQciyBUEANgIAQd4AIAJBEGpBABAVIQZByLIFKAIAIQdByLIFQQA2AgAgB0EBRw0BCxAGIQUQBxogAigCGCEDQciyBUEANgIAIAMQ6AFByLIFKAIAIQNByLIFQQA2AgAgA0EBRw0bQQAQCyEBEAcaIAEQhAEACyAGQQA7AQBByLIFQQA2AgBB3wAgBSAEEAVByLIFKAIAIQJByLIFQQA2AgAgAkEBRg0VQciyBUEANgIAQS1BMBANIQJByLIFKAIAIQRByLIFQQA2AgAgBEEBRg0VIAMoAgQhA0HIsgVBADYCAEHgACACIANBpsMAQQBBABAQGkHIsgUoAgAhA0HIsgVBADYCACADQQFGDRtByLIFQQA2AgBB3wAgBSACEAVByLIFKAIAIQJByLIFQQA2AgAgAkEBRg0VIAAPCxAGIQUQBxoMGwsQBiEFEAcaCyACEPYMDBkLEAYhBRAHGgsgAhD2DAwXCxAGIQUQBxoLIAIQ9gwMFQsQBiEFEAcaCyACEPYMDBMLEAYhBRAHGgsgAhD2DAwRCxAGIQUQBxoLIAIQ9gwMDwsQBiEFEAcaCyACEPYMDA0LEAYhBRAHGgsgAhD2DAwLCxAGIQUQBxogAxD2DAwKCxAGIQUQBxoLIAIQ9gwMCAsQBiEFEAcaIAIQ9gwMBwsQBiEFEAcaDAYLEAYhBRAHGgsgAhD2DAwECxAGIQUQBxogAxD2DAwDCxAGIQUQBxoLIAIQ9gwMAQsQBiEFEAcaIAIQ9gwLIAEQhAMaIAUQCAALrAgBCH8jAEGwAWsiAiQAAkACQAJAIAAoAgAgAU0EQCACQeg+NgJgIAJB1D42AihByLIFQQA2AgBBKSACQeAAaiIGIAJBKGpBBHIiBBAFQciyBSgCACEDQciyBUEANgIAIANBAUYNASACQoCAgIBwNwOoASACQbA+NgJgIAJBnD42AihByLIFQQA2AgBBKiAEEA0hB0HIsgUoAgAhA0HIsgVBADYCACADQQFGBEAQBiEBEAcaDAQLIAJCADcCTCACQgA3AlQgAkEQNgJcIAJBzD82AixByLIFQQA2AgBBKyACQShqQejDAEEVEBQhBUHIsgUoAgAhA0HIsgVBADYCAAJAAkACQAJAAkACQAJAAkACQCADQQFGDQBByLIFQQA2AgBBLCAFIAEQFSEDQciyBSgCACEBQciyBUEANgIAIAFBAUYNAEHIsgVBADYCAEErIANB/sMAQQQQFCEDQciyBSgCACEBQciyBUEANgIAIAFBAUYNACAAKAIAIQFByLIFQQA2AgBBLCADIAEQFRpByLIFKAIAIQFByLIFQQA2AgAgAUEBRg0AQQQQDiEAQciyBUEANgIAQS1BMBANIQNByLIFKAIAIQFByLIFQQA2AgAgAUEBRg0BQciyBUEANgIAQS4gAkEIaiAEEAVByLIFKAIAIQFByLIFQQA2AgAgAUEBRg0CIAIoAgggAkEIaiACLAATQQBIGyIEEIgNIgFBcE8EQEHIsgVBADYCAEEvIAJBGGoQD0HIsgUoAgAhAUHIsgVBADYCACABQQFGDQQMDAsCQAJAIAFBC08EQEHIsgVBADYCAEEtIAFBEGpBcHEiCBANIQVByLIFKAIAIQlByLIFQQA2AgAgCUEBRg0GIAIgBTYCGCACIAE2AhwgAiAIQYCAgIB4cjYCIAwBCyACIAE6ACMgAkEYaiEFIAFFDQELIAUgBCABEIANGgsgASAFakEAOgAAQciyBUEANgIAQTAgAyACQRhqQcQAQYPEAEH+AEGmxAAQFhpByLIFKAIAIQFByLIFQQA2AgBBASEEIAFBAUcEQCAAIAM2AgBByLIFQQA2AgBBMSAAQazdAEEAEBJByLIFKAIAIQFByLIFQQA2AgBBACEEIAFBAUcNDAsQBiEBEAcaIAIsACNBf0wEQCACKAIYEPYMCyACLAATQQBIDQQMBQsQBiEBEAcaDAcLEAYhARAHGgwFCxAGIQEQBxoMAwsQBiEBEAcaQQEhBCACLAATQQBODQILIAIoAggQ9gwLIARFDQILIAMQ9gwLIAAQEwsgAkGwPjYCYCACQZw+NgIoIAJBzD82AiwgAiwAV0F/TARAIAIoAkwQ9gwLIAcQ4AYaIAYQ3AYgARAIAAsgACgCCCEAIAJBsAFqJAAgACABag8LEAYhARAHGgwBCwALIAYQ3AYgARAIAAuvCAEIfyMAQbABayICJAACQAJAAkAgACgCACABTQRAIAJB6D42AmAgAkHUPjYCKEHIsgVBADYCAEEpIAJB4ABqIgYgAkEoakEEciIEEAVByLIFKAIAIQNByLIFQQA2AgAgA0EBRg0BIAJCgICAgHA3A6gBIAJBsD42AmAgAkGcPjYCKEHIsgVBADYCAEEqIAQQDSEHQciyBSgCACEDQciyBUEANgIAIANBAUYEQBAGIQEQBxoMBAsgAkIANwJMIAJCADcCVCACQRA2AlwgAkHMPzYCLEHIsgVBADYCAEErIAJBKGpB6MMAQRUQFCEFQciyBSgCACEDQciyBUEANgIAAkACQAJAAkACQAJAAkACQAJAIANBAUYNAEHIsgVBADYCAEEsIAUgARAVIQNByLIFKAIAIQFByLIFQQA2AgAgAUEBRg0AQciyBUEANgIAQSsgA0H+wwBBBBAUIQNByLIFKAIAIQFByLIFQQA2AgAgAUEBRg0AIAAoAgAhAUHIsgVBADYCAEEsIAMgARAVGkHIsgUoAgAhAUHIsgVBADYCACABQQFGDQBBBBAOIQBByLIFQQA2AgBBLUEwEA0hA0HIsgUoAgAhAUHIsgVBADYCACABQQFGDQFByLIFQQA2AgBBLiACQQhqIAQQBUHIsgUoAgAhAUHIsgVBADYCACABQQFGDQIgAigCCCACQQhqIAIsABNBAEgbIgQQiA0iAUFwTwRAQciyBUEANgIAQS8gAkEYahAPQciyBSgCACEBQciyBUEANgIAIAFBAUYNBAwMCwJAAkAgAUELTwRAQciyBUEANgIAQS0gAUEQakFwcSIIEA0hBUHIsgUoAgAhCUHIsgVBADYCACAJQQFGDQYgAiAFNgIYIAIgATYCHCACIAhBgICAgHhyNgIgDAELIAIgAToAIyACQRhqIQUgAUUNAQsgBSAEIAEQgA0aCyABIAVqQQA6AABByLIFQQA2AgBBMCADIAJBGGpBxABBg8QAQYQBQabEABAWGkHIsgUoAgAhAUHIsgVBADYCAEEBIQQgAUEBRwRAIAAgAzYCAEHIsgVBADYCAEExIABBrN0AQQAQEkHIsgUoAgAhAUHIsgVBADYCAEEAIQQgAUEBRw0MCxAGIQEQBxogAiwAI0F/TARAIAIoAhgQ9gwLIAIsABNBAEgNBAwFCxAGIQEQBxoMBwsQBiEBEAcaDAULEAYhARAHGgwDCxAGIQEQBxpBASEEIAIsABNBAE4NAgsgAigCCBD2DAsgBEUNAgsgAxD2DAsgABATCyACQbA+NgJgIAJBnD42AiggAkHMPzYCLCACLABXQX9MBEAgAigCTBD2DAsgBxDgBhogBhDcBiABEAgACyAAKAIIIQAgAkGwAWokACAAIAFBA3RqDwsQBiEBEAcaDAELAAsgBhDcBiABEAgAC68IAQh/IwBBsAFrIgIkAAJAAkACQCAAKAIAIAFNBEAgAkHoPjYCYCACQdQ+NgIoQciyBUEANgIAQSkgAkHgAGoiBiACQShqQQRyIgQQBUHIsgUoAgAhA0HIsgVBADYCACADQQFGDQEgAkKAgICAcDcDqAEgAkGwPjYCYCACQZw+NgIoQciyBUEANgIAQSogBBANIQdByLIFKAIAIQNByLIFQQA2AgAgA0EBRgRAEAYhARAHGgwECyACQgA3AkwgAkIANwJUIAJBEDYCXCACQcw/NgIsQciyBUEANgIAQSsgAkEoakHowwBBFRAUIQVByLIFKAIAIQNByLIFQQA2AgACQAJAAkACQAJAAkACQAJAAkAgA0EBRg0AQciyBUEANgIAQSwgBSABEBUhA0HIsgUoAgAhAUHIsgVBADYCACABQQFGDQBByLIFQQA2AgBBKyADQf7DAEEEEBQhA0HIsgUoAgAhAUHIsgVBADYCACABQQFGDQAgACgCACEBQciyBUEANgIAQSwgAyABEBUaQciyBSgCACEBQciyBUEANgIAIAFBAUYNAEEEEA4hAEHIsgVBADYCAEEtQTAQDSEDQciyBSgCACEBQciyBUEANgIAIAFBAUYNAUHIsgVBADYCAEEuIAJBCGogBBAFQciyBSgCACEBQciyBUEANgIAIAFBAUYNAiACKAIIIAJBCGogAiwAE0EASBsiBBCIDSIBQXBPBEBByLIFQQA2AgBBLyACQRhqEA9ByLIFKAIAIQFByLIFQQA2AgAgAUEBRg0EDAwLAkACQCABQQtPBEBByLIFQQA2AgBBLSABQRBqQXBxIggQDSEFQciyBSgCACEJQciyBUEANgIAIAlBAUYNBiACIAU2AhggAiABNgIcIAIgCEGAgICAeHI2AiAMAQsgAiABOgAjIAJBGGohBSABRQ0BCyAFIAQgARCADRoLIAEgBWpBADoAAEHIsgVBADYCAEEwIAMgAkEYakHEAEGDxABBgAFBpsQAEBYaQciyBSgCACEBQciyBUEANgIAQQEhBCABQQFHBEAgACADNgIAQciyBUEANgIAQTEgAEGs3QBBABASQciyBSgCACEBQciyBUEANgIAQQAhBCABQQFHDQwLEAYhARAHGiACLAAjQX9MBEAgAigCGBD2DAsgAiwAE0EASA0EDAULEAYhARAHGgwHCxAGIQEQBxoMBQsQBiEBEAcaDAMLEAYhARAHGkEBIQQgAiwAE0EATg0CCyACKAIIEPYMCyAERQ0CCyADEPYMCyAAEBMLIAJBsD42AmAgAkGcPjYCKCACQcw/NgIsIAIsAFdBf0wEQCACKAJMEPYMCyAHEOAGGiAGENwGIAEQCAALIAAoAgghACACQbABaiQAIAAgAUEBdGoPCxAGIQEQBxoMAQsACyAGENwGIAEQCAALfAAgABCJAyAAQcgAaiIAQQAQrAEoAgBBAUEAEK0BIABBBBCsASgCAEEAOgAMIABBBBCsASgCAEI/QQAQrgEgAEEEEKwBKAIAQQE6AAwgAEEGEKwBKAIAQQA6AAwgAEEGEKwBKAIAQgdBABCuASAAQQYQrAEoAgBBAToADAuvCAEIfyMAQbABayICJAACQAJAAkAgACgCACABTQRAIAJB6D42AmAgAkHUPjYCKEHIsgVBADYCAEEpIAJB4ABqIgYgAkEoakEEciIEEAVByLIFKAIAIQNByLIFQQA2AgAgA0EBRg0BIAJCgICAgHA3A6gBIAJBsD42AmAgAkGcPjYCKEHIsgVBADYCAEEqIAQQDSEHQciyBSgCACEDQciyBUEANgIAIANBAUYEQBAGIQEQBxoMBAsgAkIANwJMIAJCADcCVCACQRA2AlwgAkHMPzYCLEHIsgVBADYCAEErIAJBKGpB6MMAQRUQFCEFQciyBSgCACEDQciyBUEANgIAAkACQAJAAkACQAJAAkACQAJAIANBAUYNAEHIsgVBADYCAEEsIAUgARAVIQNByLIFKAIAIQFByLIFQQA2AgAgAUEBRg0AQciyBUEANgIAQSsgA0H+wwBBBBAUIQNByLIFKAIAIQFByLIFQQA2AgAgAUEBRg0AIAAoAgAhAUHIsgVBADYCAEEsIAMgARAVGkHIsgUoAgAhAUHIsgVBADYCACABQQFGDQBBBBAOIQBByLIFQQA2AgBBLUEwEA0hA0HIsgUoAgAhAUHIsgVBADYCACABQQFGDQFByLIFQQA2AgBBLiACQQhqIAQQBUHIsgUoAgAhAUHIsgVBADYCACABQQFGDQIgAigCCCACQQhqIAIsABNBAEgbIgQQiA0iAUFwTwRAQciyBUEANgIAQS8gAkEYahAPQciyBSgCACEBQciyBUEANgIAIAFBAUYNBAwMCwJAAkAgAUELTwRAQciyBUEANgIAQS0gAUEQakFwcSIIEA0hBUHIsgUoAgAhCUHIsgVBADYCACAJQQFGDQYgAiAFNgIYIAIgATYCHCACIAhBgICAgHhyNgIgDAELIAIgAToAIyACQRhqIQUgAUUNAQsgBSAEIAEQgA0aCyABIAVqQQA6AABByLIFQQA2AgBBMCADIAJBGGpBxABBscQAQesAQabEABAWGkHIsgUoAgAhAUHIsgVBADYCAEEBIQQgAUEBRwRAIAAgAzYCAEHIsgVBADYCAEExIABBrN0AQQAQEkHIsgUoAgAhAUHIsgVBADYCAEEAIQQgAUEBRw0MCxAGIQEQBxogAiwAI0F/TARAIAIoAhgQ9gwLIAIsABNBAEgNBAwFCxAGIQEQBxoMBwsQBiEBEAcaDAULEAYhARAHGgwDCxAGIQEQBxpBASEEIAIsABNBAE4NAgsgAigCCBD2DAsgBEUNAgsgAxD2DAsgABATCyACQbA+NgJgIAJBnD42AiggAkHMPzYCLCACLABXQX9MBEAgAigCTBD2DAsgBxDgBhogBhDcBiABEAgACyAAKAIIIQAgAkGwAWokACAAIAFBAnRqDwsQBiEBEAcaDAELAAsgBhDcBiABEAgAC9YHAQd/IwBBsAFrIgMkAAJAAkACQCAALQAMBEAgA0HoPjYCYCADQdQ+NgIoQciyBUEANgIAQSkgA0HgAGoiAiADQShqQQRyIgQQBUHIsgUoAgAhAUHIsgVBADYCACABQQFGDQEgA0KAgICAcDcDqAEgA0GwPjYCYCADQZw+NgIoQciyBUEANgIAQSogBBANIQdByLIFKAIAIQFByLIFQQA2AgAgAUEBRgRAEAYhABAHGgwECyADQgA3AkwgA0IANwJUIANBEDYCXCADQcw/NgIsQciyBUEANgIAQSsgA0EoakHAxQBBFxAUIQVByLIFKAIAIQFByLIFQQA2AgACQAJAAkACQAJAAkACQAJAAkAgAUEBRg0AIAAoAggiABCIDSEBQciyBUEANgIAQSsgBSAAIAEQFBpByLIFKAIAIQBByLIFQQA2AgAgAEEBRg0AQQQQDiEBQciyBUEANgIAQS1BMBANIQVByLIFKAIAIQBByLIFQQA2AgAgAEEBRg0BQciyBUEANgIAQS4gA0EIaiAEEAVByLIFKAIAIQBByLIFQQA2AgAgAEEBRg0CIAMoAgggA0EIaiADLAATQQBIGyIEEIgNIgBBcE8EQEHIsgVBADYCAEEvIANBGGoQD0HIsgUoAgAhAEHIsgVBADYCACAAQQFGDQQMDAsCQAJAIABBC08EQEHIsgVBADYCAEEtIABBEGpBcHEiCBANIQZByLIFKAIAIQlByLIFQQA2AgAgCUEBRg0GIAMgBjYCGCADIAA2AhwgAyAIQYCAgIB4cjYCIAwBCyADIAA6ACMgA0EYaiEGIABFDQELIAYgBCAAEIANGgsgACAGakEAOgAAQciyBUEANgIAQTAgBSADQRhqQQJBscQAQcoBQdjFABAWGkHIsgUoAgAhAEHIsgVBADYCAEEBIQQgAEEBRwRAIAEgBTYCAEHIsgVBADYCAEExIAFBrN0AQQAQEkHIsgUoAgAhAEHIsgVBADYCAEEAIQQgAEEBRw0MCxAGIQAQBxogAywAI0F/TARAIAMoAhgQ9gwLIAMsABNBAEgNBAwFCxAGIQAQBxoMBwsQBiEAEAcaDAULEAYhABAHGgwDCxAGIQAQBxpBASEEIAMsABNBAE4NAgsgAygCCBD2DAsgBEUNAgsgBRD2DAsgARATCyADQbA+NgJgIANBnD42AiggA0HMPzYCLCADLABXQX9MBEAgAygCTBD2DAsgBxDgBhogAhDcBiAAEAgACyAAQRBqIAIQqAEgAToAACADQbABaiQADwsQBiEAEAcaDAELAAsgAhDcBiAAEAgAC9YHAQh/IwBBsAFrIgMkAAJAAkACQCAALQAMBEAgA0HoPjYCYCADQdQ+NgIoQciyBUEANgIAQSkgA0HgAGoiByADQShqQQRyIgQQBUHIsgUoAgAhAkHIsgVBADYCACACQQFGDQEgA0KAgICAcDcDqAEgA0GwPjYCYCADQZw+NgIoQciyBUEANgIAQSogBBANIQhByLIFKAIAIQJByLIFQQA2AgAgAkEBRgRAEAYhABAHGgwECyADQgA3AkwgA0IANwJUIANBEDYCXCADQcw/NgIsQciyBUEANgIAQSsgA0EoakHAxQBBFxAUIQVByLIFKAIAIQJByLIFQQA2AgACQAJAAkACQAJAAkACQAJAAkAgAkEBRg0AIAAoAggiABCIDSECQciyBUEANgIAQSsgBSAAIAIQFBpByLIFKAIAIQBByLIFQQA2AgAgAEEBRg0AQQQQDiECQciyBUEANgIAQS1BMBANIQVByLIFKAIAIQBByLIFQQA2AgAgAEEBRg0BQciyBUEANgIAQS4gA0EIaiAEEAVByLIFKAIAIQBByLIFQQA2AgAgAEEBRg0CIAMoAgggA0EIaiADLAATQQBIGyIEEIgNIgBBcE8EQEHIsgVBADYCAEEvIANBGGoQD0HIsgUoAgAhAEHIsgVBADYCACAAQQFGDQQMDAsCQAJAIABBC08EQEHIsgVBADYCAEEtIABBEGpBcHEiCRANIQZByLIFKAIAIQpByLIFQQA2AgAgCkEBRg0GIAMgBjYCGCADIAA2AhwgAyAJQYCAgIB4cjYCIAwBCyADIAA6ACMgA0EYaiEGIABFDQELIAYgBCAAEIANGgsgACAGakEAOgAAQciyBUEANgIAQTAgBSADQRhqQQJBscQAQc4BQdjFABAWGkHIsgUoAgAhAEHIsgVBADYCAEEBIQQgAEEBRwRAIAIgBTYCAEHIsgVBADYCAEExIAJBrN0AQQAQEkHIsgUoAgAhAEHIsgVBADYCAEEAIQQgAEEBRw0MCxAGIQAQBxogAywAI0F/TARAIAMoAhgQ9gwLIAMsABNBAEgNBAwFCxAGIQAQBxoMBwsQBiEAEAcaDAULEAYhABAHGgwDCxAGIQAQBxpBASEEIAMsABNBAE4NAgsgAygCCBD2DAsgBEUNAgsgBRD2DAsgAhATCyADQbA+NgJgIANBnD42AiggA0HMPzYCLCADLABXQX9MBEAgAygCTBD2DAsgCBDgBhogBxDcBiAAEAgACyAAQRBqIAIQqQEgATcDACADQbABaiQADwsQBiEAEAcaDAELAAsgBxDcBiAAEAgAC/8DAQR/IwBBEGsiBCQAIAAoAgAiAyACSQRAQQQQDiEAQciyBUEANgIAQS1BMBANIQJByLIFKAIAIQNByLIFQQA2AgACQAJAAkACQAJAIANBAUcEQEHIsgVBADYCAEEtQSAQDSEDQciyBSgCACEBQciyBUEANgIAIAFBAUYNASAEIAM2AgAgBEKTgICAgISAgIB/NwIEIANBADoAEyADQfDFACgAADYADyADQenFACkAADcACCADQeHFACkAADcAAEHIsgVBADYCAEEwIAIgBEHEAEGDxABBgAFB9cUAEBYaQciyBSgCACEDQciyBUEANgIAQQEhASADQQFGDQIgACACNgIAQciyBUEANgIAQTEgAEGs3QBBABASQciyBSgCACEDQciyBUEANgIAQQAhASADQQFGDQIACxAGIQMQBxoMAwsQBiEDEAcaDAELEAYhAxAHGiAELAALQX9MBEAgBCgCABD2DAsgAUUNAgsgAhD2DAsgABATCyADEAgACwJAIAAoAgQgA0cEQCAAKAIIIQUMAQsgACADQQEgA0EBSxsiA0EBdDYCBCAAIAAoAgggA0ECdBDqASIFNgIIIAAoAgAhAwsgBSACQQF0IgZqIgVBAmogBSADIAJrQQF0EIINIAAoAgggBmogATsBACAAIAAoAgBBAWo2AgAgBEEQaiQAC68IAQh/IwBBsAFrIgIkAAJAAkACQCAAKAIAIAFNBEAgAkHoPjYCYCACQdQ+NgIoQciyBUEANgIAQSkgAkHgAGoiBiACQShqQQRyIgQQBUHIsgUoAgAhA0HIsgVBADYCACADQQFGDQEgAkKAgICAcDcDqAEgAkGwPjYCYCACQZw+NgIoQciyBUEANgIAQSogBBANIQdByLIFKAIAIQNByLIFQQA2AgAgA0EBRgRAEAYhARAHGgwECyACQgA3AkwgAkIANwJUIAJBEDYCXCACQcw/NgIsQciyBUEANgIAQSsgAkEoakHowwBBFRAUIQVByLIFKAIAIQNByLIFQQA2AgACQAJAAkACQAJAAkACQAJAAkAgA0EBRg0AQciyBUEANgIAQSwgBSABEBUhA0HIsgUoAgAhAUHIsgVBADYCACABQQFGDQBByLIFQQA2AgBBKyADQf7DAEEEEBQhA0HIsgUoAgAhAUHIsgVBADYCACABQQFGDQAgACgCACEBQciyBUEANgIAQSwgAyABEBUaQciyBSgCACEBQciyBUEANgIAIAFBAUYNAEEEEA4hAEHIsgVBADYCAEEtQTAQDSEDQciyBSgCACEBQciyBUEANgIAIAFBAUYNAUHIsgVBADYCAEEuIAJBCGogBBAFQciyBSgCACEBQciyBUEANgIAIAFBAUYNAiACKAIIIAJBCGogAiwAE0EASBsiBBCIDSIBQXBPBEBByLIFQQA2AgBBLyACQRhqEA9ByLIFKAIAIQFByLIFQQA2AgAgAUEBRg0EDAwLAkACQCABQQtPBEBByLIFQQA2AgBBLSABQRBqQXBxIggQDSEFQciyBSgCACEJQciyBUEANgIAIAlBAUYNBiACIAU2AhggAiABNgIcIAIgCEGAgICAeHI2AiAMAQsgAiABOgAjIAJBGGohBSABRQ0BCyAFIAQgARCADRoLIAEgBWpBADoAAEHIsgVBADYCAEEwIAMgAkEYakHEAEGDxABBjAFBpsQAEBYaQciyBSgCACEBQciyBUEANgIAQQEhBCABQQFHBEAgACADNgIAQciyBUEANgIAQTEgAEGs3QBBABASQciyBSgCACEBQciyBUEANgIAQQAhBCABQQFHDQwLEAYhARAHGiACLAAjQX9MBEAgAigCGBD2DAsgAiwAE0EASA0EDAULEAYhARAHGgwHCxAGIQEQBxoMBQsQBiEBEAcaDAMLEAYhARAHGkEBIQQgAiwAE0EATg0CCyACKAIIEPYMCyAERQ0CCyADEPYMCyAAEBMLIAJBsD42AmAgAkGcPjYCKCACQcw/NgIsIAIsAFdBf0wEQCACKAJMEPYMCyAHEOAGGiAGENwGIAEQCAALIAAoAgghACACQbABaiQAIAAgAUECdGoPCxAGIQEQBxoMAQsACyAGENwGIAEQCAALrwgBCH8jAEGwAWsiAiQAAkACQAJAIAAoAgAgAU0EQCACQeg+NgJgIAJB1D42AihByLIFQQA2AgBBKSACQeAAaiIGIAJBKGpBBHIiBBAFQciyBSgCACEDQciyBUEANgIAIANBAUYNASACQoCAgIBwNwOoASACQbA+NgJgIAJBnD42AihByLIFQQA2AgBBKiAEEA0hB0HIsgUoAgAhA0HIsgVBADYCACADQQFGBEAQBiEBEAcaDAQLIAJCADcCTCACQgA3AlQgAkEQNgJcIAJBzD82AixByLIFQQA2AgBBKyACQShqQejDAEEVEBQhBUHIsgUoAgAhA0HIsgVBADYCAAJAAkACQAJAAkACQAJAAkACQCADQQFGDQBByLIFQQA2AgBBLCAFIAEQFSEDQciyBSgCACEBQciyBUEANgIAIAFBAUYNAEHIsgVBADYCAEErIANB/sMAQQQQFCEDQciyBSgCACEBQciyBUEANgIAIAFBAUYNACAAKAIAIQFByLIFQQA2AgBBLCADIAEQFRpByLIFKAIAIQFByLIFQQA2AgAgAUEBRg0AQQQQDiEAQciyBUEANgIAQS1BMBANIQNByLIFKAIAIQFByLIFQQA2AgAgAUEBRg0BQciyBUEANgIAQS4gAkEIaiAEEAVByLIFKAIAIQFByLIFQQA2AgAgAUEBRg0CIAIoAgggAkEIaiACLAATQQBIGyIEEIgNIgFBcE8EQEHIsgVBADYCAEEvIAJBGGoQD0HIsgUoAgAhAUHIsgVBADYCACABQQFGDQQMDAsCQAJAIAFBC08EQEHIsgVBADYCAEEtIAFBEGpBcHEiCBANIQVByLIFKAIAIQlByLIFQQA2AgAgCUEBRg0GIAIgBTYCGCACIAE2AhwgAiAIQYCAgIB4cjYCIAwBCyACIAE6ACMgAkEYaiEFIAFFDQELIAUgBCABEIANGgsgASAFakEAOgAAQciyBUEANgIAQTAgAyACQRhqQcQAQYPEAEGCAUGmxAAQFhpByLIFKAIAIQFByLIFQQA2AgBBASEEIAFBAUcEQCAAIAM2AgBByLIFQQA2AgBBMSAAQazdAEEAEBJByLIFKAIAIQFByLIFQQA2AgBBACEEIAFBAUcNDAsQBiEBEAcaIAIsACNBf0wEQCACKAIYEPYMCyACLAATQQBIDQQMBQsQBiEBEAcaDAcLEAYhARAHGgwFCxAGIQEQBxoMAwsQBiEBEAcaQQEhBCACLAATQQBODQILIAIoAggQ9gwLIARFDQILIAMQ9gwLIAAQEwsgAkGwPjYCYCACQZw+NgIoIAJBzD82AiwgAiwAV0F/TARAIAIoAkwQ9gwLIAcQ4AYaIAYQ3AYgARAIAAsgACgCCCEAIAJBsAFqJAAgACABQQJ0ag8LEAYhARAHGgwBCwALIAYQ3AYgARAIAAsNACAAEIQDGiAAEPYMCwMAAQsNACAAEMYEGiAAEPYMCwQAQQgLDQAgACgCEEEAEKIEpwsPACAAKAIQIAGtQQAQowQLYgEBfyAAQRRqIgBBABCsASgCACIDIAEgAiADKAIAKAIYEQUAIABBABCsASgCACEDIABBARCsASgCACADIAIQogSnIAIQwAQgAEEBEKwBKAIAIgAgASACIAAoAgAoAhgRBQALBwAgABD2DAsmAQF/IwBBEGsiAyQAIAMgAjYCDCAAQQEgASACELsBIANBEGokAAvDBgEBfyMAQRBrIgQkAAJAAkACQAJAAkACQAJAAkAgAUUEQEEEEA4hAkHIsgVBADYCAEEtQSwQDSEAQciyBSgCACEBQciyBUEANgIAAkACQCABQQFHBEBByLIFQQA2AgBBLUEwEA0hAUHIsgUoAgAhA0HIsgVBADYCACADQQFGDQEgBCABNgIAIARCrICAgICGgICAfzcCBCABQQA6ACwgAUG0xgAoAAA2ACggAUGsxgApAAA3ACAgAUGkxgApAAA3ABggAUGcxgApAAA3ABAgAUGUxgApAAA3AAggAUGMxgApAAA3AABByLIFQQA2AgBBMiAAIARBucYAQeECQaDHABAQGkHIsgUoAgAhAUHIsgVBADYCAEEBIQMgAUEBRwRAIAIgADYCAEHIsgVBADYCAEExIAJBoNoAQQAQEkHIsgUoAgAhAUHIsgVBADYCAEEAIQMgAUEBRw0FCxAGIQEQBxogBCwAC0F/TARAIAQoAgAQ9gwLIAMNAgwKCxAGIQEQBxogAhATIAEQCAALEAYhARAHGgsgABD2DCACEBMgARAIAAsgAg0HQQQQDiECQciyBUEANgIAQS1BLBANIQBByLIFKAIAIQFByLIFQQA2AgAgAUEBRg0BQciyBUEANgIAQS1BIBANIQFByLIFKAIAIQNByLIFQQA2AgAgA0EBRg0CIAQgATYCACAEQpiAgICAhICAgH83AgQgAUEAOgAYIAFB78YAKQAANwAQIAFB58YAKQAANwAIIAFB38YAKQAANwAAQciyBUEANgIAQTIgACAEQbnGAEHiAkGgxwAQEBpByLIFKAIAIQFByLIFQQA2AgBBASEDIAFBAUYNAyACIAA2AgBByLIFQQA2AgBBMSACQaDaAEEAEBJByLIFKAIAIQFByLIFQQA2AgBBACEDIAFBAUYNAwsACxAGIQEQBxoMAwsQBiEBEAcaDAELEAYhARAHGiAELAALQX9MBEAgBCgCABD2DAsgA0UNAgsgABD2DAsgAhATCyABEAgACwJAIAAoAgQgAUgNAEHEkwQoAgAiAARAIAEgAiADIAARBQAMAQtBqJoDKAIAIgEgAiADEKwGGkEKIAEQkQYLIARBEGokAAsoAQF/IwBBEGsiAiQAIAIgATYCDEHAjARBAiAAIAEQuwEgAkEQaiQACygBAX8jAEEQayICJAAgAiABNgIMQcCMBEEEIAAgARC7ASACQRBqJAALKAEBfyMAQRBrIgIkACACIAE2AgxBwIwEQQYgACABELsBIAJBEGokAAssACMAQRBrIgIkACACIAQ2AgwgACABIAAoAggoAgAgAyAEEMABIAJBEGokAAvwEAEGfyMAQbABayIFJAACQAJAAkACQAJAAkACQAJAAkACQAJAAkAgAkUEQEEEEA4hAkHIsgVBADYCAEEtQSwQDSEBQciyBSgCACEDQciyBUEANgIAAkACQCADQQFHBEBByLIFQQA2AgBBLUEwEA0hA0HIsgUoAgAhAEHIsgVBADYCACAAQQFGDQEgBSADNgIoIAVCrICAgICGgICAfzcCLCADQQA6ACwgA0G0xgAoAAA2ACggA0GsxgApAAA3ACAgA0GkxgApAAA3ABggA0GcxgApAAA3ABAgA0GUxgApAAA3AAggA0GMxgApAAA3AABByLIFQQA2AgBBMiABIAVBKGpBucYAQY8CQdnGABAQGkHIsgUoAgAhA0HIsgVBADYCAEEBIQAgA0EBRwRAIAIgATYCAEHIsgVBADYCAEExIAJBoNoAQQAQEkHIsgUoAgAhA0HIsgVBADYCAEEAIQAgA0EBRw0FCxAGIQMQBxogBSwAM0F/TARAIAUoAigQ9gwLIAANAgwKCxAGIQUQBxogAhATIAUQCAALEAYhAxAHGgsgARD2DCACEBMgAxAIAAsgA0UEQEEEEA4hAkHIsgVBADYCAEEtQSwQDSEBQciyBSgCACEDQciyBUEANgIAAkACQCADQQFHBEBByLIFQQA2AgBBLUEgEA0hA0HIsgUoAgAhAEHIsgVBADYCACAAQQFGDQEgBSADNgIoIAVCmICAgICEgICAfzcCLCADQQA6ABggA0HvxgApAAA3ABAgA0HnxgApAAA3AAggA0HfxgApAAA3AABByLIFQQA2AgBBMiABIAVBKGpBucYAQZACQdnGABAQGkHIsgUoAgAhA0HIsgVBADYCAEEBIQAgA0EBRwRAIAIgATYCAEHIsgVBADYCAEExIAJBoNoAQQAQEkHIsgUoAgAhA0HIsgVBADYCAEEAIQAgA0EBRw0FCxAGIQMQBxogBSwAM0F/TARAIAUoAigQ9gwLIAANAgwKCxAGIQUQBxogAhATIAUQCAALEAYhAxAHGgsgARD2DCACEBMgAxAIAAsgAy0AAA0FQQQQDiECQciyBUEANgIAQS1BLBANIQFByLIFKAIAIQNByLIFQQA2AgAgA0EBRg0BQciyBUEANgIAQS1BMBANIQNByLIFKAIAIQBByLIFQQA2AgAgAEEBRg0CIAUgAzYCKCAFQqOAgICAhoCAgH83AiwgA0EAOgAjIANBl8cAKAAANgAfIANBkMcAKQAANwAYIANBiMcAKQAANwAQIANBgMcAKQAANwAIIANB+MYAKQAANwAAQciyBUEANgIAQTIgASAFQShqQbnGAEGRAkHZxgAQEBpByLIFKAIAIQNByLIFQQA2AgBBASEAIANBAUYNAyACIAE2AgBByLIFQQA2AgBBMSACQaDaAEEAEBJByLIFKAIAIQNByLIFQQA2AgBBACEAIANBAUYNAwsACxAGIQUQBxogAhATIAUQCAALEAYhAxAHGgwBCxAGIQMQBxogBSwAM0F/TARAIAUoAigQ9gwLIABFDQILIAEQ9gwgAhATIAMQCAALIAAoAgQgAkgNBEHEkwQoAgBFDQEgBUHoPjYCYCAFQdQ+NgIoQciyBUEANgIAQSkgBUHgAGoiCSAFQShqQQRyIgAQBUHIsgUoAgAhCEHIsgVBADYCACAIQQFGDQIgBUKAgICAcDcDqAEgBUGwPjYCYCAFQZw+NgIoQciyBUEANgIAQSogABANIQhByLIFKAIAIQdByLIFQQA2AgAgB0EBRgRAEAYhAxAHGgwGCyAFQgA3AkwgBUIANwJUIAVBEDYCXCAFQcw/NgIsAkAgAQRAAkACQAJAAkACQAJAIAFBC08EQEHIsgVBADYCAEEtIAFBEGpB8ANxIgcQDSEGQciyBSgCACEKQciyBUEANgIAIApBAUYNAiAFIAY2AhggBSABNgIcIAUgB0GAgICAeHI2AiAgBUEYaiEHDAELIAUgAToAIyAFQRhqIgchBgsgBkEgIAEQgQ0gAWpBADoAACAHLQALIQFByLIFQQA2AgBBKyAFQShqIAUoAhggBUEYaiABQRh0QRh1QQBIIgYbIAUoAhwgASAGGxAUIQFByLIFKAIAIQZByLIFQQA2AgAgBkEBRg0BIAMQiA0hBkHIsgVBADYCAEErIAEgAyAGEBQaQciyBSgCACEDQciyBUEANgIAIANBAUYNAUHIsgVBADYCAEHEkwQoAgAhA0EuIAVBCGogABAFQciyBSgCACEBQciyBUEANgIAIAFBAUYNAkHIsgVBADYCACADIAIgBSgCCCAFQQhqIAUsABNBAEgbIAQQEkHIsgUoAgAhA0HIsgVBADYCACADQQFGDQMgBSwAE0F/TARAIAUoAggQ9gwLIAcsAAtBf0oNCiAFKAIYEPYMDAoLEAYhAxAHGgwFCxAGIQMQBxoMAgsQBiEDEAcaDAELEAYhAxAHGiAFLAATQX9KDQAgBSgCCBD2DAsgBywAC0F/Sg0BIAUoAhgQ9gwMAQtByLIFQQA2AgBBxJMEKAIAIAIgAyAEEBJByLIFKAIAIQNByLIFQQA2AgAgA0EBRw0EEAYhAxAHGgsgBUGwPjYCYCAFQZw+NgIoIAVBzD82AiwgBSwAV0F/TARAIAUoAkwQ9gwLIAgQ4AYaIAkQ3AYLIAMQCAALAkAgAUUEQEGomgMoAgAhAgwBCyAFQSA2AgQgBSABNgIAQaiaAygCACICIAUQxwYLIAIgAyAEEKwGGkEKIAIQkQYMAgsQBiEDEAcaDAILIAVBsD42AmAgBUGcPjYCKCAFQcw/NgIsIAUsAFdBf0wEQCAFKAJMEPYMCyAIEOAGGiAJENwGCyAFQbABaiQADwsgCRDcBiADEAgACyYBAX8jAEEQayIEJAAgBCADNgIMIAAgASACIAMQuwEgBEEQaiQAC7MSAQx/IwBBwAFrIgckAAJAAkACQCADDQAgBEUNAEEEEA4hAUHIsgVBADYCAEEtQSwQDSEGQciyBSgCACEFQciyBUEANgIAAkACQCAFQQFHBEBByLIFQQA2AgBBLUEwEA0hBUHIsgUoAgAhCEHIsgVBADYCACAIQQFGDQEgByAFNgIwIAdCq4CAgICGgICAfzcCNCAFQQA6ACsgBUHPxwAoAAA2ACcgBUHIxwApAAA3ACAgBUHAxwApAAA3ABggBUG4xwApAAA3ABAgBUGwxwApAAA3AAggBUGoxwApAAA3AABByLIFQQA2AgBBMiAGIAdBMGpBucYAQZMDQdTHABAQGkHIsgUoAgAhBUHIsgVBADYCAEEBIQggBUEBRwRAIAEgBjYCAEHIsgVBADYCAEExIAFBoNoAQQAQEkHIsgUoAgAhBUHIsgVBADYCAEEAIQggBUEBRw0GCxAGIQUQBxogBywAO0F/TARAIAcoAjAQ9gwLIAgNAgwECxAGIQUQBxogARATDAMLEAYhBRAHGgsgBhD2DCABEBMMAQsgBUUEQEEEEA4hAUHIsgVBADYCAEEtQSwQDSEGQciyBSgCACEFQciyBUEANgIAAkACQCAFQQFHBEBByLIFQQA2AgBBLUEgEA0hBUHIsgUoAgAhCEHIsgVBADYCACAIQQFGDQEgByAFNgIwIAdCmICAgICEgICAfzcCNCAFQQA6ABggBUHvxgApAAA3ABAgBUHnxgApAAA3AAggBUHfxgApAAA3AABByLIFQQA2AgBBMiAGIAdBMGpBucYAQZQDQdTHABAQGkHIsgUoAgAhBUHIsgVBADYCAEEBIQggBUEBRwRAIAEgBjYCAEHIsgVBADYCAEExIAFBoNoAQQAQEkHIsgUoAgAhBUHIsgVBADYCAEEAIQggBUEBRw0GCxAGIQUQBxogBywAO0F/TARAIAcoAjAQ9gwLIAgNAgwECxAGIQUQBxogARATDAMLEAYhBRAHGgsgBhD2DCABEBMMAQsCQAJAAkACQAJAIAAoAgQgAkgNACAFLQAAIAFyBEAgAUGAAnIiCBDjASIKQQAgCBCBDSEIIAdBIDYCFCAHIAE2AhAgCCAHQRBqEJkGIAcgBjYCvAEgASAIakH/ASAFIAYQjQYaCyAEBEAgCkHcxwAgChshDSAHQegAaiEOIAdB/ABqIQ8gB0E8aiEQIAdBMGpBBHIhBiAEIQkDQAJAAkAgDRCIDSIFQXBJBEACQAJAIAVBC08EQCAFQRBqQXBxIggQ/gshASAHIAhBgICAgHhyNgIoIAcgATYCICAHIAU2AiQMAQsgByAFOgArIAdBIGohASAFRQ0BCyABIA0gBRCADRoLIAEgBWpBADoAAEHIsgVBADYCAEH2ACAHQTBqIAdBIGpBAhAUGkHIsgUoAgAhBUHIsgVBADYCAAJAAkACQAJAAkACQCAFQQFHBEAgBywAK0F/TARAIAcoAiAQ9gwLQciyBUEANgIAIAdBOjoAIEErIAdBMGogB0EgakEBEBQhBUHIsgUoAgAhAUHIsgVBADYCACABQQFGDQEgBUEEaiIBIAUoAgBBdGoiCCgCAGoiCyALKAIAQbV/cUEIcjYCACABIAgoAgBqQQg2AgggASAIKAIAakEwNgJIIAEgCCgCAGoiASABKAIAQc9+cUGAAXI2AgBByLIFQQA2AgBBLCAFIAwQFSEFQciyBSgCACEBQciyBUEANgIAIAFBAUYNAiAFQQRqIgEgBSgCAEF0aiIIKAIAakEANgIIIAEgCCgCAGpBIDYCSEHIsgVBADYCAEErIAVB3ccAQQIQFBpByLIFKAIAIQVByLIFQQA2AgAgBUEBRg0DIAlBECAJQRBJGyEIIAMgDGohC0EAIQUgBCAMRiIRDQYDQCAGIAcoAjBBdGoiASgCAGoiEiASKAIAQbV/cUEIcjYCACAQIAEoAgBqQQI2AgAgDyABKAIAakEwNgIAIAYgASgCAGoiASABKAIAQc9+cUGAAXI2AgAgBSALai0AACEBQciyBUEANgIAQSwgB0EwaiABEBUaQciyBSgCACEBQciyBUEANgIAIAFBAUYNBSAQIAcoAjBBdGoiASgCAGpBADYCACAPIAEoAgBqQSA2AgBByLIFQQA2AgAgB0EgOgAgQSsgB0EwaiAHQSBqQQEQFBpByLIFKAIAIQFByLIFQQA2AgAgAUEBRg0GIAVBAWoiBSAIRw0ACyAIIQUgCUEPTQ0GDAkLEAYhBRAHGiAHLAArQX9KDRAgBygCIBD2DAwQCxAGIQUQBxoMDgsQBiEFEAcaDA0LEAYhBRAHGgwMCxAGIQUQBxoMCwsQBiEFEAcaDAoLA0BByLIFQQA2AgBBKyAHQTBqQeDHAEEDEBQaQciyBSgCACEBQciyBUEANgIAIAFBAUYNAiAFQQFqIgVBEEcNAAsMAgsgB0EgahCGDAALEAYhBRAHGgwHC0EAIQUgEUUEQANAAkAgBSALai0AACIBEP4FBEBByLIFQQA2AgAgByABOgAgQSsgB0EwaiAHQSBqQQEQFBpByLIFKAIAIQFByLIFQQA2AgAgAUEBRw0BDAkLQciyBUEANgIAIAdBLjoAIEErIAdBMGogB0EgakEBEBQaQciyBSgCACEBQciyBUEANgIAIAFBAUYNCAsgBUEBaiIFIAhHDQALC0HIsgVBADYCAEEuIAdBIGogBhAFQciyBSgCACEFQciyBUEANgIAIAVBAUYNA0HIsgVBADYCACAHIAcoAiAgB0EgaiAHLAArQQBIGzYCAEH3ACAAIAJB5McAIAcQHEHIsgUoAgAhBUHIsgVBADYCACAFQQFGDQQgBywAK0F/TARAIAcoAiAQ9gwLIAdBsD42AmggB0GcPjYCMCAHQcw/NgI0IAcsAF9Bf0wEQCAHKAJUEPYMCyAGEOAGGiAOENwGIAlBcGohCSAMQRBqIgwgBEkNAAsLIApFDQAgChDoAQsgB0HAAWokAA8LEAYhBRAHGgwCCxAGIQUQBxogBywAK0F/Sg0BIAcoAiAQ9gwMAQsQBiEFEAcaCyAHQbA+NgJoIAdBnD42AjAgB0HMPzYCNCAHLABfQX9MBEAgBygCVBD2DAsgBhDgBhogDhDcBgsgBRAICwALpQIBBH8gAEHoPjYCOCAAQdQ+NgIAQciyBUEANgIAQSkgAEE4aiIFIABBBGoiAxAFQciyBSgCACEEQciyBUEANgIAAkACQCAEQQFHBEAgAEGwPjYCOCAAQZw+NgIAIABCgICAgHA3AoABQciyBUEANgIAQSogAxANIQZByLIFKAIAIQRByLIFQQA2AgAgBEEBRg0BIABBzD82AgQgAEEkaiIEQgA3AgAgAEIANwIsIAAgAkEQcjYCNEHIsgVBADYCAEH4ACADIAEQBUHIsgUoAgAhA0HIsgVBADYCACADQQFGBEAQBiEDEAcaIAQsAAtBf0wEQCAEKAIAEPYMCyAGEOAGGgwDCyAADwsQBiEDEAcaDAELEAYhAxAHGgsgBRDcBiADEAgAC9sCAQN/IABBIGoiAiABEIoMIABBADYCLCAAKAIwIgFBCHEEQAJAIAIsAAsiA0F/TARAIAAoAiAiAyAAKAIkaiEEDAELIAIgA0H/AXFqIQQgAiEDCyAAIAQ2AhAgACADNgIMIAAgAzYCCCAAIAQ2AiwLAkAgAUEQcUUNACACAn8gAiwACyIBQQBOBEAgACACIAFB/wFxIgFqNgIsQQoMAQsgACAAKAIkIgEgACgCIGo2AiwgACgCKEH/////B3FBf2oLQQAQjQwCfyACLAALIgNBf0wEQCAAKAIgIQIgACgCJAwBCyADQf8BcQshAyAAIAI2AhQgACACNgIYIAAgAiADajYCHCAALQAwQQNxRQ0AAkAgAUF/TARAIAAgAkF+aiACQf////8HaiABQYGAgIB4aiIBQQBIIgMbIgI2AhhBASABIAMbIQEMAQsgAUUNAQsgACABIAJqNgIYCwujAQEBfyMAQSBrIgIkACACQRBqIAEgASgCACgCCBECAEHIsgVBADYCACACIAIoAhAgAkEQaiACLAAbQQBIGzYCAEH3ACAAQQFB5McAIAIQHEHIsgUoAgAhAUHIsgVBADYCACABQQFHBEAgAiwAG0F/TARAIAIoAhAQ9gwLIAJBIGokAA8LEAYhARAHGiACLAAbQX9MBEAgAigCEBD2DAsgARAIAAvCIwEGfyMAQRBrIggkACAAIAEgAhClAyEGIABBjMgANgIAAkACQAJAAkACQCACQXhqIgNBC0sNAAJAAkACQAJAAkACQCADQQFrDgsCBAYGBgABBgYGBQMLQciyBUEANgIAQS1BHBANIQJByLIFKAIAIQNByLIFQQA2AgAgA0EBRg0IQciyBUEANgIAIAIgAUGoyAAQoAQhAUHIsgUoAgAhA0HIsgVBADYCAAJAIANBAUcEQCACQQA2AhggAkIANwIQIAJB4M4CNgIAQciyBUEANgIAQfDOAigCACACQQEQBUHIsgUoAgAhA0HIsgVBADYCAAJAIANBAUcEQEHIsgVBADYCAEH7ACACQRBqQQAQFSEDQciyBSgCACEEQciyBUEANgIAIARBAUcNAQsQBiEAEAcaIAIoAhghAUHIsgVBADYCACABEOgBQciyBSgCACEBQciyBUEANgIAIAFBAUcNAkEAEAshABAHGiAAEIQBAAsgA0EANgIAQciyBUEANgIAQfwAIAYgARAFQciyBSgCACEBQciyBUEANgIAIAFBAUcNCAwKCxAGIQAQBxoLIAIQ9gwMCQtByLIFQQA2AgBBLUEcEA0hAkHIsgUoAgAhA0HIsgVBADYCACADQQFGDQdByLIFQQA2AgAgAiABQavIABCgBCEBQciyBSgCACEDQciyBUEANgIAAkAgA0EBRwRAIAJBADYCGCACQgA3AhAgAkGgzQI2AgBByLIFQQA2AgBBsM0CKAIAIAJBARAFQciyBSgCACEDQciyBUEANgIAAkAgA0EBRwRAQciyBUEANgIAQd4AIAJBEGpBABAVIQNByLIFKAIAIQRByLIFQQA2AgAgBEEBRw0BCxAGIQAQBxogAigCGCEBQciyBUEANgIAIAEQ6AFByLIFKAIAIQFByLIFQQA2AgAgAUEBRw0CQQAQCyEAEAcaIAAQhAEACyADQQA7AQBByLIFQQA2AgBB/AAgBiABEAVByLIFKAIAIQFByLIFQQA2AgAgAUEBRg0JDAcLEAYhABAHGgsgAhD2DAwIC0HIsgVBADYCAEEtQRwQDSECQciyBSgCACEDQciyBUEANgIAIANBAUYNBkHIsgVBADYCACACIAFBtMgAEKAEIQFByLIFKAIAIQNByLIFQQA2AgACQCADQQFHBEAgAkEANgIYIAJCADcCECACQaDNAjYCAEHIsgVBADYCAEGwzQIoAgAgAkEBEAVByLIFKAIAIQNByLIFQQA2AgACQCADQQFHBEBByLIFQQA2AgBB3gAgAkEQakEAEBUhA0HIsgUoAgAhBEHIsgVBADYCACAEQQFHDQELEAYhABAHGiACKAIYIQFByLIFQQA2AgAgARDoAUHIsgUoAgAhAUHIsgVBADYCACABQQFHDQJBABALIQAQBxogABCEAQALIANBADsBAEHIsgVBADYCAEH8ACAGIAEQBUHIsgUoAgAhAUHIsgVBADYCACABQQFGDQgMBgsQBiEAEAcaCyACEPYMDAcLQciyBUEANgIAQS1BMBANIQJByLIFKAIAIQNByLIFQQA2AgAgA0EBRg0FQciyBUEANgIAQeAAIAIgAUG8yABBA0EAEBAaQciyBSgCACEDQciyBUEANgIAIANBAUYNBEHIsgVBADYCAEH8ACAGIAIQBUHIsgUoAgAhAkHIsgVBADYCACACQQFGDQVByLIFQQA2AgBBLUEkEA0hAkHIsgUoAgAhA0HIsgVBADYCACADQQFGDQVByLIFQQA2AgBB/QAgAiABQcnIAEEBQQBBABAWGkHIsgUoAgAhA0HIsgVBADYCAAJAIANBAUcEQEHIsgVBADYCAEH8ACAGIAIQBUHIsgUoAgAhAkHIsgVBADYCACACQQFGDQdByLIFQQA2AgBBLUEkEA0hAkHIsgUoAgAhA0HIsgVBADYCACADQQFGDQdByLIFQQA2AgBB/QAgAiABQc/IAEEBQQBBABAWGkHIsgUoAgAhAUHIsgVBADYCACABQQFGDQFByLIFQQA2AgBB/AAgBiACEAVByLIFKAIAIQFByLIFQQA2AgAgAUEBRg0HDAULEAYhABAHGiACEPYMDAcLEAYhABAHGiACEPYMDAYLQciyBUEANgIAQS1BHBANIQJByLIFKAIAIQNByLIFQQA2AgAgA0EBRg0EQciyBUEANgIAIAIgAUHVyAAQoAQhAUHIsgUoAgAhA0HIsgVBADYCAAJAIANBAUcEQCACQQA2AhggAkIANwIQIAJBkMwCNgIAQciyBUEANgIAQaDMAigCACACQQEQBUHIsgUoAgAhA0HIsgVBADYCAAJAIANBAUcEQEHIsgVBADYCAEHZACACQRBqQQAQFSEDQciyBSgCACEEQciyBUEANgIAIARBAUcNAQsQBiEAEAcaIAIoAhghAUHIsgVBADYCACABEOgBQciyBSgCACEBQciyBUEANgIAIAFBAUcNAkEAEAshABAHGiAAEIQBAAsgA0EAOgAAQciyBUEANgIAQfwAIAYgARAFQciyBSgCACEBQciyBUEANgIAIAFBAUYNBgwECxAGIQAQBxoLIAIQ9gwMBQtByLIFQQA2AgBBLUEcEA0hAkHIsgUoAgAhA0HIsgVBADYCACADQQFGDQNByLIFQQA2AgAgAiABQebIABCgBCEEQciyBSgCACEDQciyBUEANgIAAkACQAJAAkACQAJAAkACQAJAAkACQAJAAkAgA0EBRwRAIAJBADYCGCACQgA3AhAgAkGQzAI2AgBByLIFQQA2AgBBoMwCKAIAIgMgAkEBEAVByLIFKAIAIQVByLIFQQA2AgACQCAFQQFHBEBByLIFQQA2AgBB2QAgAkEQakEAEBUhBUHIsgUoAgAhB0HIsgVBADYCACAHQQFHDQELEAYhABAHGiACKAIYIQFByLIFQQA2AgAgARDoAUHIsgUoAgAhAUHIsgVBADYCACABQQFHDQJBABALIQAQBxogABCEAQALIAVBADoAAEHIsgVBADYCAEH8ACAGIAQQBUHIsgUoAgAhAkHIsgVBADYCACACQQFGDRFByLIFQQA2AgBBLUEcEA0hAkHIsgUoAgAhBEHIsgVBADYCACAEQQFGDRFByLIFQQA2AgAgAiABQYLJABCgBCEEQciyBSgCACEFQciyBUEANgIAIAVBAUYNAiACQQA2AhggAkIANwIQIAJBkMwCNgIAQciyBUEANgIAIAMgAkEBEAVByLIFKAIAIQVByLIFQQA2AgACQCAFQQFHBEBByLIFQQA2AgBB2QAgAkEQakEAEBUhBUHIsgUoAgAhB0HIsgVBADYCACAHQQFHDQELEAYhABAHGiACKAIYIQFByLIFQQA2AgAgARDoAUHIsgUoAgAhAUHIsgVBADYCACABQQFHDQRBABALIQAQBxogABCEAQALIAVBADoAAEHIsgVBADYCAEH8ACAGIAQQBUHIsgUoAgAhAkHIsgVBADYCACACQQFGDRFByLIFQQA2AgBBLUEcEA0hAkHIsgUoAgAhBEHIsgVBADYCACAEQQFGDRFByLIFQQA2AgAgAiABQZvJABCgBCEEQciyBSgCACEFQciyBUEANgIAIAVBAUYNBCACQQA2AhggAkIANwIQIAJBkMwCNgIAQciyBUEANgIAIAMgAkEBEAVByLIFKAIAIQVByLIFQQA2AgACQCAFQQFHBEBByLIFQQA2AgBB2QAgAkEQakEAEBUhBUHIsgUoAgAhB0HIsgVBADYCACAHQQFHDQELEAYhABAHGiACKAIYIQFByLIFQQA2AgAgARDoAUHIsgUoAgAhAUHIsgVBADYCACABQQFHDQZBABALIQAQBxogABCEAQALIAVBADoAAEHIsgVBADYCAEH8ACAGIAQQBUHIsgUoAgAhAkHIsgVBADYCACACQQFGDRFByLIFQQA2AgBBLUEcEA0hAkHIsgUoAgAhBEHIsgVBADYCACAEQQFGDRFByLIFQQA2AgAgAiABQbfJABCgBCEEQciyBSgCACEFQciyBUEANgIAIAVBAUYNBiACQQA2AhggAkIANwIQIAJBkMwCNgIAQciyBUEANgIAIAMgAkEBEAVByLIFKAIAIQVByLIFQQA2AgACQCAFQQFHBEBByLIFQQA2AgBB2QAgAkEQakEAEBUhBUHIsgUoAgAhB0HIsgVBADYCACAHQQFHDQELEAYhABAHGiACKAIYIQFByLIFQQA2AgAgARDoAUHIsgUoAgAhAUHIsgVBADYCACABQQFHDQhBABALIQAQBxogABCEAQALIAVBADoAAEHIsgVBADYCAEH8ACAGIAQQBUHIsgUoAgAhAkHIsgVBADYCACACQQFGDRFByLIFQQA2AgBBLUEcEA0hAkHIsgUoAgAhBEHIsgVBADYCACAEQQFGDRFByLIFQQA2AgAgAiABQdPJABCgBCEEQciyBSgCACEFQciyBUEANgIAIAVBAUYNCCACQQA2AhggAkIANwIQIAJBkMwCNgIAQciyBUEANgIAIAMgAkEBEAVByLIFKAIAIQVByLIFQQA2AgACQCAFQQFHBEBByLIFQQA2AgBB2QAgAkEQakEAEBUhBUHIsgUoAgAhB0HIsgVBADYCACAHQQFHDQELEAYhABAHGiACKAIYIQFByLIFQQA2AgAgARDoAUHIsgUoAgAhAUHIsgVBADYCACABQQFHDQpBABALIQAQBxogABCEAQALIAVBADoAAEHIsgVBADYCAEH8ACAGIAQQBUHIsgUoAgAhAkHIsgVBADYCACACQQFGDRFByLIFQQA2AgBBLUEcEA0hAkHIsgUoAgAhBEHIsgVBADYCACAEQQFGDRFByLIFQQA2AgAgAiABQfDJABCgBCEEQciyBSgCACEFQciyBUEANgIAIAVBAUYNCiACQQA2AhggAkIANwIQIAJBkMwCNgIAQciyBUEANgIAIAMgAkEBEAVByLIFKAIAIQVByLIFQQA2AgACQCAFQQFHBEBByLIFQQA2AgBB2QAgAkEQakEAEBUhBUHIsgUoAgAhB0HIsgVBADYCACAHQQFHDQELEAYhABAHGiACKAIYIQFByLIFQQA2AgAgARDoAUHIsgUoAgAhAUHIsgVBADYCACABQQFHDQxBABALIQAQBxogABCEAQALIAVBADoAAEHIsgVBADYCAEH8ACAGIAQQBUHIsgUoAgAhAkHIsgVBADYCACACQQFGDRFByLIFQQA2AgBBLUEcEA0hAkHIsgUoAgAhBEHIsgVBADYCACAEQQFGDRFByLIFQQA2AgAgAiABQY/KABCgBCEBQciyBSgCACEEQciyBUEANgIAIARBAUYNDCACQQA2AhggAkIANwIQIAJBkMwCNgIAQciyBUEANgIAIAMgAkEBEAVByLIFKAIAIQNByLIFQQA2AgACQCADQQFHBEBByLIFQQA2AgBB2QAgAkEQakEAEBUhA0HIsgUoAgAhBEHIsgVBADYCACAEQQFHDQELEAYhABAHGiACKAIYIQFByLIFQQA2AgAgARDoAUHIsgUoAgAhAUHIsgVBADYCACABQQFHDQ5BABALIQAQBxogABCEAQALIANBADoAAEHIsgVBADYCAEH8ACAGIAEQBUHIsgUoAgAhAUHIsgVBADYCACABQQFGDREMDwsQBiEAEAcaCyACEPYMDBALEAYhABAHGgsgAhD2DAwOCxAGIQAQBxoLIAIQ9gwMDAsQBiEAEAcaCyACEPYMDAoLEAYhABAHGgsgAhD2DAwICxAGIQAQBxoLIAIQ9gwMBgsQBiEAEAcaCyACEPYMDAQLIAAoAgQoAgQhAUHIsgVBADYCAEH+ACABEA0hAUHIsgUoAgAhA0HIsgVBADYCACADQQFGDQIgASgCACEDIAEsAAshBCAIQdfKADYCAEHIsgVBADYCACAIIAI2AgggCCADIAEgBEEASBs2AgRB/wBBwIwEQavKACAIEBJByLIFKAIAIQFByLIFQQA2AgAgAUEBRg0CCyAIQRBqJAAgAA8LEAYhABAHGiACEPYMDAELEAYhABAHGgsgBhCmAxogABAIAAutDwEFfyMAQRBrIgYkACAAIAEgAhClAyEFIABCADcCLCAAQfTKADYCAAJAAkACQAJAIAJBGHRBGHVBfkwEQEHIsgVBADYCAEEtQTAQDSECQciyBSgCACEDQciyBUEANgIAIANBAUYNA0HIsgVBADYCAEHgACACIAFBkMsAQQBBABAQGkHIsgUoAgAhAUHIsgVBADYCACABQQFGDQJByLIFQQA2AgBB/AAgBSACEAVByLIFKAIAIQJByLIFQQA2AgAgAkEBRw0BDAMLAkAgAkF7aiIDQQhLDQACQAJAAkAgA0EBaw4IAwMDAwMBAwIAC0HIsgVBADYCAEEtQTAQDSECQciyBSgCACEDQciyBUEANgIAIANBAUYNBUHIsgVBADYCAEHgACACIAFBlcsAQQBBABAQGkHIsgUoAgAhAUHIsgVBADYCACABQQFHBEBByLIFQQA2AgBB/AAgBSACEAVByLIFKAIAIQJByLIFQQA2AgAgAkEBRg0GDAQLEAYhABAHGiACEPYMDAYLQciyBUEANgIAQS1BHBANIQJByLIFKAIAIQNByLIFQQA2AgAgA0EBRg0EQciyBUEANgIAIAIgAUHVyAAQoAQhA0HIsgUoAgAhBEHIsgVBADYCAAJAAkACQAJAIARBAUcEQCACQQA2AhggAkIANwIQIAJBkMwCNgIAQciyBUEANgIAQaDMAigCACACQQEQBUHIsgUoAgAhBEHIsgVBADYCAAJAIARBAUcEQEHIsgVBADYCAEHZACACQRBqQQAQFSEEQciyBSgCACEHQciyBUEANgIAIAdBAUcNAQsQBiEAEAcaIAIoAhghAUHIsgVBADYCACABEOgBQciyBSgCACEBQciyBUEANgIAIAFBAUcNAkEAEAshABAHGiAAEIQBAAsgBEEAOgAAQciyBUEANgIAQfwAIAUgAxAFQciyBSgCACECQciyBUEANgIAIAJBAUYNCUHIsgVBADYCAEEtQRwQDSECQciyBSgCACEDQciyBUEANgIAIANBAUYNCUHIsgVBADYCACACIAFBmssAEKAEIQNByLIFKAIAIQRByLIFQQA2AgAgBEEBRg0CIAJBADYCGCACQgA3AhAgAkGgzQI2AgBByLIFQQA2AgBBsM0CKAIAIAJBARAFQciyBSgCACEEQciyBUEANgIAAkAgBEEBRwRAQciyBUEANgIAQd4AIAJBEGpBABAVIQRByLIFKAIAIQdByLIFQQA2AgAgB0EBRw0BCxAGIQAQBxogAigCGCEBQciyBUEANgIAIAEQ6AFByLIFKAIAIQFByLIFQQA2AgAgAUEBRw0EQQAQCyEAEAcaIAAQhAEACyAEQQA7AQBByLIFQQA2AgBB/AAgBSADEAVByLIFKAIAIQJByLIFQQA2AgAgAkEBRg0JQciyBUEANgIAQS1BMBANIQJByLIFKAIAIQNByLIFQQA2AgAgA0EBRg0JQciyBUEANgIAQeAAIAIgAUGkywBBAEEAEBAaQciyBSgCACEBQciyBUEANgIAIAFBAUYNBEHIsgVBADYCAEH8ACAFIAIQBUHIsgUoAgAhAkHIsgVBADYCACACQQFGDQkgAEKDgICAIDcCLAwHCxAGIQAQBxoLIAIQ9gwMCAsQBiEAEAcaCyACEPYMDAYLEAYhABAHGiACEPYMDAULQciyBUEANgIAQS1BHBANIQJByLIFKAIAIQNByLIFQQA2AgAgA0EBRg0DQciyBUEANgIAIAIgAUGtywAQoAQhA0HIsgUoAgAhBEHIsgVBADYCAAJAAkAgBEEBRwRAIAJBADYCGCACQgA3AhAgAkHgzgI2AgBByLIFQQA2AgBB8M4CKAIAIAJBARAFQciyBSgCACEEQciyBUEANgIAAkAgBEEBRwRAQciyBUEANgIAQfsAIAJBEGpBABAVIQRByLIFKAIAIQdByLIFQQA2AgAgB0EBRw0BCxAGIQAQBxogAigCGCEBQciyBUEANgIAIAEQ6AFByLIFKAIAIQFByLIFQQA2AgAgAUEBRw0CQQAQCyEAEAcaIAAQhAEACyAEQQA2AgBByLIFQQA2AgBB/AAgBSADEAVByLIFKAIAIQJByLIFQQA2AgAgAkEBRg0GQciyBUEANgIAQS1BMBANIQJByLIFKAIAIQNByLIFQQA2AgAgA0EBRg0GQciyBUEANgIAQeAAIAIgAUG+ywBBAEEAEBAaQciyBSgCACEBQciyBUEANgIAIAFBAUYNAkHIsgVBADYCAEH8ACAFIAIQBUHIsgUoAgAhAkHIsgVBADYCACACQQFGDQYgAEKEgICAEDcCLAwECxAGIQAQBxoLIAIQ9gwMBQsQBiEAEAcaIAIQ9gwMBAsgACgCBCgCBCEBQciyBUEANgIAQf4AIAEQDSEBQciyBSgCACEDQciyBUEANgIAIANBAUYNAiABKAIAIQMgASwACyEEIAZBiMwANgIAQciyBUEANgIAIAYgAjYCCCAGIAMgASAEQQBIGzYCBEH/AEHAjARB28sAIAYQEkHIsgUoAgAhAkHIsgVBADYCACACQQFGDQILIAZBEGokACAADwsQBiEAEAcaIAIQ9gwMAQsQBiEAEAcaCyAFEKYDGiAAEAgACzQAIAAgARCsAyAAQRxqIAAoAjAQrAEoAgAgACgCGCAAKAIsa0EAEMAEIAAgAUEAQX8QrQMLsh8BBn8gACABQRAQpQMhBiAAQaTMADYCAEHIsgVBADYCAEEtQSAQDSECQciyBSgCACEEQciyBUEANgIAAkACQAJAAkACQAJAAkACQAJAAkACQAJAAkACQAJAAkACQAJAAkACQAJAAkACQAJAAkACQCAEQQFGDQBByLIFQQA2AgAgAiABQcDMABCgBCEFQciyBSgCACEEQciyBUEANgIAIARBAUYNASACQQA2AhggAkIANwIQIAJBwM8CNgIAQciyBUEANgIAQdDPAigCACIEIAJBARAFQciyBSgCACEDQciyBUEANgIAAkAgA0EBRwRAQciyBUEANgIAQdwAIAJBEGpBABAVIQNByLIFKAIAIQdByLIFQQA2AgAgB0EBRw0BCxAGIQEQBxogAigCGCEAQciyBUEANgIAIAAQ6AFByLIFKAIAIQBByLIFQQA2AgAgAEEBRw0DQQAQCyEBEAcaIAEQhAEACyADQgA3AwAgAkEKOgAcIAJBoNACNgIAQciyBUEANgIAQfwAIAYgBRAFQciyBSgCACECQciyBUEANgIAIAJBAUYNAEHIsgVBADYCAEEtQSAQDSECQciyBSgCACEFQciyBUEANgIAIAVBAUYNAEHIsgVBADYCACACIAFB08wAEKAEIQVByLIFKAIAIQNByLIFQQA2AgAgA0EBRg0DIAJBADYCGCACQgA3AhAgAkHAzwI2AgBByLIFQQA2AgAgBCACQQEQBUHIsgUoAgAhA0HIsgVBADYCAAJAIANBAUcEQEHIsgVBADYCAEHcACACQRBqQQAQFSEDQciyBSgCACEHQciyBUEANgIAIAdBAUcNAQsQBiEBEAcaIAIoAhghAEHIsgVBADYCACAAEOgBQciyBSgCACEAQciyBUEANgIAIABBAUcNBUEAEAshARAHGiABEIQBAAsgA0IANwMAIAJBAToAHCACQaDQAjYCAEHIsgVBADYCAEH8ACAGIAUQBUHIsgUoAgAhAkHIsgVBADYCACACQQFGDQBByLIFQQA2AgBBLUEgEA0hAkHIsgUoAgAhBUHIsgVBADYCACAFQQFGDQBByLIFQQA2AgAgAiABQdvMABCgBCEFQciyBSgCACEDQciyBUEANgIAIANBAUYNBSACQQA2AhggAkIANwIQIAJBwM8CNgIAQciyBUEANgIAIAQgAkEBEAVByLIFKAIAIQNByLIFQQA2AgACQCADQQFHBEBByLIFQQA2AgBB3AAgAkEQakEAEBUhA0HIsgUoAgAhB0HIsgVBADYCACAHQQFHDQELEAYhARAHGiACKAIYIQBByLIFQQA2AgAgABDoAUHIsgUoAgAhAEHIsgVBADYCACAAQQFHDQdBABALIQEQBxogARCEAQALIANCADcDACACQQE6ABwgAkGg0AI2AgBByLIFQQA2AgBB/AAgBiAFEAVByLIFKAIAIQJByLIFQQA2AgAgAkEBRg0AQciyBUEANgIAQS1BIBANIQJByLIFKAIAIQVByLIFQQA2AgAgBUEBRg0AQciyBUEANgIAIAIgAUH5zAAQoAQhBUHIsgUoAgAhA0HIsgVBADYCACADQQFGDQcgAkEANgIYIAJCADcCECACQcDPAjYCAEHIsgVBADYCACAEIAJBARAFQciyBSgCACEEQciyBUEANgIAAkAgBEEBRwRAQciyBUEANgIAQdwAIAJBEGpBABAVIQRByLIFKAIAIQNByLIFQQA2AgAgA0EBRw0BCxAGIQEQBxogAigCGCEAQciyBUEANgIAIAAQ6AFByLIFKAIAIQBByLIFQQA2AgAgAEEBRw0JQQAQCyEBEAcaIAEQhAEACyAEQgA3AwAgAkEEOgAcIAJBoNACNgIAQciyBUEANgIAQfwAIAYgBRAFQciyBSgCACECQciyBUEANgIAIAJBAUYNAEHIsgVBADYCAEEtQSQQDSECQciyBSgCACEEQciyBUEANgIAIARBAUYNAEHIsgVBADYCAEH9ACACIAFBgs0AQQFBAEEAEBYaQciyBSgCACEEQciyBUEANgIAIARBAUYNCUHIsgVBADYCAEH8ACAGIAIQBUHIsgUoAgAhAkHIsgVBADYCACACQQFGDQBByLIFQQA2AgBBLUEcEA0hAkHIsgUoAgAhBEHIsgVBADYCACAEQQFGDQBByLIFQQA2AgAgAiABQYbNABCgBCEFQciyBSgCACEEQciyBUEANgIAIARBAUYNCiACQQA2AhggAkIANwIQIAJBkMwCNgIAQciyBUEANgIAQaDMAigCACIEIAJBARAFQciyBSgCACEDQciyBUEANgIAAkAgA0EBRwRAQciyBUEANgIAQdkAIAJBEGpBABAVIQNByLIFKAIAIQdByLIFQQA2AgAgB0EBRw0BCxAGIQEQBxogAigCGCEAQciyBUEANgIAIAAQ6AFByLIFKAIAIQBByLIFQQA2AgAgAEEBRw0MQQAQCyEBEAcaIAEQhAEACyADQQA6AABByLIFQQA2AgBB/AAgBiAFEAVByLIFKAIAIQJByLIFQQA2AgAgAkEBRg0AQciyBUEANgIAQS1BHBANIQJByLIFKAIAIQVByLIFQQA2AgAgBUEBRg0AQciyBUEANgIAIAIgAUGXzQAQoAQhBUHIsgUoAgAhA0HIsgVBADYCACADQQFGDQwgAkEANgIYIAJCADcCECACQZDMAjYCAEHIsgVBADYCACAEIAJBARAFQciyBSgCACEDQciyBUEANgIAAkAgA0EBRwRAQciyBUEANgIAQdkAIAJBEGpBABAVIQNByLIFKAIAIQdByLIFQQA2AgAgB0EBRw0BCxAGIQEQBxogAigCGCEAQciyBUEANgIAIAAQ6AFByLIFKAIAIQBByLIFQQA2AgAgAEEBRw0OQQAQCyEBEAcaIAEQhAEACyADQQA6AABByLIFQQA2AgBB/AAgBiAFEAVByLIFKAIAIQJByLIFQQA2AgAgAkEBRg0AQciyBUEANgIAQS1BHBANIQJByLIFKAIAIQVByLIFQQA2AgAgBUEBRg0AQciyBUEANgIAIAIgAUGrzQAQoAQhBUHIsgUoAgAhA0HIsgVBADYCACADQQFGDQ4gAkEANgIYIAJCADcCECACQZDMAjYCAEHIsgVBADYCACAEIAJBARAFQciyBSgCACEDQciyBUEANgIAAkAgA0EBRwRAQciyBUEANgIAQdkAIAJBEGpBABAVIQNByLIFKAIAIQdByLIFQQA2AgAgB0EBRw0BCxAGIQEQBxogAigCGCEAQciyBUEANgIAIAAQ6AFByLIFKAIAIQBByLIFQQA2AgAgAEEBRw0QQQAQCyEBEAcaIAEQhAEACyADQQA6AABByLIFQQA2AgBB/AAgBiAFEAVByLIFKAIAIQJByLIFQQA2AgAgAkEBRg0AQciyBUEANgIAQS1BHBANIQJByLIFKAIAIQVByLIFQQA2AgAgBUEBRg0AQciyBUEANgIAIAIgAUG/zQAQoAQhBUHIsgUoAgAhA0HIsgVBADYCACADQQFGDRAgAkEANgIYIAJCADcCECACQZDMAjYCAEHIsgVBADYCACAEIAJBARAFQciyBSgCACEDQciyBUEANgIAAkAgA0EBRwRAQciyBUEANgIAQdkAIAJBEGpBABAVIQNByLIFKAIAIQdByLIFQQA2AgAgB0EBRw0BCxAGIQEQBxogAigCGCEAQciyBUEANgIAIAAQ6AFByLIFKAIAIQBByLIFQQA2AgAgAEEBRw0SQQAQCyEBEAcaIAEQhAEACyADQQA6AABByLIFQQA2AgBB/AAgBiAFEAVByLIFKAIAIQJByLIFQQA2AgAgAkEBRg0AQciyBUEANgIAQS1BHBANIQJByLIFKAIAIQVByLIFQQA2AgAgBUEBRg0AQciyBUEANgIAIAIgAUHUzQAQoAQhBUHIsgUoAgAhA0HIsgVBADYCACADQQFGDRIgAkEANgIYIAJCADcCECACQZDMAjYCAEHIsgVBADYCACAEIAJBARAFQciyBSgCACEEQciyBUEANgIAAkAgBEEBRwRAQciyBUEANgIAQdkAIAJBEGpBABAVIQRByLIFKAIAIQNByLIFQQA2AgAgA0EBRw0BCxAGIQEQBxogAigCGCEAQciyBUEANgIAIAAQ6AFByLIFKAIAIQBByLIFQQA2AgAgAEEBRw0UQQAQCyEBEAcaIAEQhAEACyAEQQA6AABByLIFQQA2AgBB/AAgBiAFEAVByLIFKAIAIQJByLIFQQA2AgAgAkEBRg0AQciyBUEANgIAQS1BKBANIQJByLIFKAIAIQRByLIFQQA2AgAgBEEBRg0AQciyBUEANgIAIAIgAUHrzQBBDkEAQQFBABDPBBpByLIFKAIAIQRByLIFQQA2AgAgBEEBRg0UQciyBUEANgIAQfwAIAYgAhAFQciyBSgCACECQciyBUEANgIAIAJBAUYNAEHIsgVBADYCAEEtQSgQDSECQciyBSgCACEEQciyBUEANgIAIARBAUYNAEHIsgVBADYCACACIAFB8c0AQcAAQd8AQQBBABDPBBpByLIFKAIAIQRByLIFQQA2AgAgBEEBRg0VQciyBUEANgIAQfwAIAYgAhAFQciyBSgCACECQciyBUEANgIAIAJBAUYNAEHIsgVBADYCAEEtQSgQDSECQciyBSgCACEEQciyBUEANgIAIARBAUYNAEHIsgVBADYCACACIAFB+s0AQQpBAEEAQQAQzwQaQciyBSgCACEEQciyBUEANgIAIARBAUYNFkHIsgVBADYCAEH8ACAGIAIQBUHIsgUoAgAhAkHIsgVBADYCACACQQFGDQBByLIFQQA2AgBBLUEoEA0hAkHIsgUoAgAhBEHIsgVBADYCACAEQQFGDQBByLIFQQA2AgAgAiABQYfOAEGAAUH+AUEAQQAQzwQaQciyBSgCACEBQciyBUEANgIAIAFBAUYNF0HIsgVBADYCAEH8ACAGIAIQBUHIsgUoAgAhAUHIsgVBADYCACABQQFHDRkLEAYhARAHGgwXCxAGIQEQBxoLIAIQ9gwMFQsQBiEBEAcaCyACEPYMDBMLEAYhARAHGgsgAhD2DAwRCxAGIQEQBxoLIAIQ9gwMDwsQBiEBEAcaIAIQ9gwMDgsQBiEBEAcaCyACEPYMDAwLEAYhARAHGgsgAhD2DAwKCxAGIQEQBxoLIAIQ9gwMCAsQBiEBEAcaCyACEPYMDAYLEAYhARAHGgsgAhD2DAwECxAGIQEQBxogAhD2DAwDCxAGIQEQBxogAhD2DAwCCxAGIQEQBxogAhD2DAwBCxAGIQEQBxogAhD2DAsgBhCmAxogARAIAAsgAEECNgIoIAALgwEAIABBHGoiAEEAEKwBKAIAQgFBABCuASAAQQMQrAEoAgBCD0EAEK4BIABBBRCsASgCAEH/AUEAEK0BIABBBhCsASgCAEH/AUEAEK0BIABBBxCsASgCAEH/AUEAEK0BIABBCBCsASgCAEH/AUEAEK0BIABBCRCsASgCAEH/AUEAEK0BC68BAgF/AX4gAEEcaiIAQQEQrAEoAgBBEGpBABCpASkDACECIABBBBCsASgCACACUDoADSAAQQUQrAEoAgAgAkIAUiIBOgANIABBBhCsASgCACABOgANIABBBxCsASgCACABOgANIABBCBCsASgCACABOgANIABBCRCsASgCACABOgANIABBChCsASgCACABOgANIABBCxCsASgCACABOgANIABBDBCsASgCACABOgANC4sPAQZ/IAAgAUEREKUDIQUgAEGYzgA2AgBByLIFQQA2AgBBLUEgEA0hAkHIsgUoAgAhA0HIsgVBADYCAAJAAkACQAJAAkACQAJAAkACQAJAAkACQAJAAkAgA0EBRg0AQciyBUEANgIAIAIgAUHAzAAQoAQhBkHIsgUoAgAhA0HIsgVBADYCACADQQFGDQEgAkEANgIYIAJCADcCECACQcDPAjYCAEHIsgVBADYCAEHQzwIoAgAiAyACQQEQBUHIsgUoAgAhBEHIsgVBADYCAAJAIARBAUcEQEHIsgVBADYCAEHcACACQRBqQQAQFSEEQciyBSgCACEHQciyBUEANgIAIAdBAUcNAQsQBiEBEAcaIAIoAhghAEHIsgVBADYCACAAEOgBQciyBSgCACEAQciyBUEANgIAIABBAUcNA0EAEAshARAHGiABEIQBAAsgBEIANwMAIAJBCjoAHCACQaDQAjYCAEHIsgVBADYCAEH8ACAFIAYQBUHIsgUoAgAhAkHIsgVBADYCACACQQFGDQBByLIFQQA2AgBBLUEgEA0hAkHIsgUoAgAhBkHIsgVBADYCACAGQQFGDQBByLIFQQA2AgAgAiABQdPMABCgBCEGQciyBSgCACEEQciyBUEANgIAIARBAUYNAyACQQA2AhggAkIANwIQIAJBwM8CNgIAQciyBUEANgIAIAMgAkEBEAVByLIFKAIAIQRByLIFQQA2AgACQCAEQQFHBEBByLIFQQA2AgBB3AAgAkEQakEAEBUhBEHIsgUoAgAhB0HIsgVBADYCACAHQQFHDQELEAYhARAHGiACKAIYIQBByLIFQQA2AgAgABDoAUHIsgUoAgAhAEHIsgVBADYCACAAQQFHDQVBABALIQEQBxogARCEAQALIARCADcDACACQQE6ABwgAkGg0AI2AgBByLIFQQA2AgBB/AAgBSAGEAVByLIFKAIAIQJByLIFQQA2AgAgAkEBRg0AQciyBUEANgIAQS1BIBANIQJByLIFKAIAIQZByLIFQQA2AgAgBkEBRg0AQciyBUEANgIAIAIgAUH5zAAQoAQhBkHIsgUoAgAhBEHIsgVBADYCACAEQQFGDQUgAkEANgIYIAJCADcCECACQcDPAjYCAEHIsgVBADYCACADIAJBARAFQciyBSgCACEDQciyBUEANgIAAkAgA0EBRwRAQciyBUEANgIAQdwAIAJBEGpBABAVIQNByLIFKAIAIQRByLIFQQA2AgAgBEEBRw0BCxAGIQEQBxogAigCGCEAQciyBUEANgIAIAAQ6AFByLIFKAIAIQBByLIFQQA2AgAgAEEBRw0HQQAQCyEBEAcaIAEQhAEACyADQgA3AwAgAkEFOgAcIAJBoNACNgIAQciyBUEANgIAQfwAIAUgBhAFQciyBSgCACECQciyBUEANgIAIAJBAUYNAEHIsgVBADYCAEEtQSQQDSECQciyBSgCACEDQciyBUEANgIAIANBAUYNAEHIsgVBADYCAEH9ACACIAFBgs0AQQFBAEEAEBYaQciyBSgCACEDQciyBUEANgIAIANBAUYNB0HIsgVBADYCAEH8ACAFIAIQBUHIsgUoAgAhAkHIsgVBADYCACACQQFGDQBByLIFQQA2AgBBLUEoEA0hAkHIsgUoAgAhA0HIsgVBADYCACADQQFGDQBByLIFQQA2AgAgAiABQevNAEEPQQBBAUEAEM8EGkHIsgUoAgAhA0HIsgVBADYCACADQQFGDQhByLIFQQA2AgBB/AAgBSACEAVByLIFKAIAIQJByLIFQQA2AgAgAkEBRg0AQciyBUEANgIAQS1BKBANIQJByLIFKAIAIQNByLIFQQA2AgAgA0EBRg0AQciyBUEANgIAIAIgAUHxzQBBwABB3wBBAEEAEM8EGkHIsgUoAgAhA0HIsgVBADYCACADQQFGDQlByLIFQQA2AgBB/AAgBSACEAVByLIFKAIAIQJByLIFQQA2AgAgAkEBRg0AQciyBUEANgIAQS1BKBANIQJByLIFKAIAIQNByLIFQQA2AgAgA0EBRg0AQciyBUEANgIAIAIgAUH6zQBBCkEAQQBBABDPBBpByLIFKAIAIQNByLIFQQA2AgAgA0EBRg0KQciyBUEANgIAQfwAIAUgAhAFQciyBSgCACECQciyBUEANgIAIAJBAUYNAEHIsgVBADYCAEEtQSgQDSECQciyBSgCACEDQciyBUEANgIAIANBAUYNAEHIsgVBADYCACACIAFBh84AQYABQf4BQQBBABDPBBpByLIFKAIAIQFByLIFQQA2AgAgAUEBRg0LQciyBUEANgIAQfwAIAUgAhAFQciyBSgCACEBQciyBUEANgIAIAFBAUcNDQsQBiEBEAcaDAsLEAYhARAHGgsgAhD2DAwJCxAGIQEQBxoLIAIQ9gwMBwsQBiEBEAcaCyACEPYMDAULEAYhARAHGiACEPYMDAQLEAYhARAHGiACEPYMDAMLEAYhARAHGiACEPYMDAILEAYhARAHGiACEPYMDAELEAYhARAHGiACEPYMCyAFEKYDGiABEAgACyAAQQI2AiggAAsWACAAQRxqQQIQrAEoAgBCH0EAEK4BC2QCAX8BfiAAQRxqIgBBARCsASgCAEEQakEAEKkBKQMAIQIgAEEDEKwBKAIAIAJQOgANIABBBBCsASgCACACQgBSIgE6AA0gAEEFEKwBKAIAIAE6AA0gAEEGEKwBKAIAIAE6AA0LjSABB38gACABQQMQpQMhBiAAQbzOADYCAEHIsgVBADYCAEEtQRwQDSECQciyBSgCACEDQciyBUEANgIAAkACQAJAAkACQAJAAkACQAJAAkACQAJAAkACQAJAAkACQAJAAkACQAJAAkACQAJAAkACQAJAIANBAUYNAEHIsgVBADYCACACIAFB2M4AEKAEIQNByLIFKAIAIQdByLIFQQA2AgAgB0EBRg0BIAJBADYCGCACQgA3AhAgAkGgzQI2AgBByLIFQQA2AgBBsM0CKAIAIgcgAkEBEAVByLIFKAIAIQRByLIFQQA2AgACQCAEQQFHBEBByLIFQQA2AgBB3gAgAkEQakEAEBUhBEHIsgUoAgAhBUHIsgVBADYCACAFQQFHDQELEAYhARAHGiACKAIYIQBByLIFQQA2AgAgABDoAUHIsgUoAgAhAEHIsgVBADYCACAAQQFHDQNBABALIQEQBxogARCEAQALIARBADsBAEHIsgVBADYCAEH8ACAGIAMQBUHIsgUoAgAhAkHIsgVBADYCACACQQFGDQBByLIFQQA2AgBBLUEgEA0hAkHIsgUoAgAhA0HIsgVBADYCACADQQFGDQBByLIFQQA2AgAgAiABQd3OABCgBCEEQciyBSgCACEDQciyBUEANgIAIANBAUYNAyACQQA2AhggAkIANwIQIAJBwM8CNgIAQciyBUEANgIAQdDPAigCACIDIAJBARAFQciyBSgCACEFQciyBUEANgIAAkAgBUEBRwRAQciyBUEANgIAQdwAIAJBEGpBABAVIQVByLIFKAIAIQhByLIFQQA2AgAgCEEBRw0BCxAGIQEQBxogAigCGCEAQciyBUEANgIAIAAQ6AFByLIFKAIAIQBByLIFQQA2AgAgAEEBRw0FQQAQCyEBEAcaIAEQhAEACyAFQgA3AwAgAkEBOgAcIAJBoNACNgIAQciyBUEANgIAQfwAIAYgBBAFQciyBSgCACECQciyBUEANgIAIAJBAUYNAEHIsgVBADYCAEEtQSAQDSECQciyBSgCACEEQciyBUEANgIAIARBAUYNAEHIsgVBADYCACACIAFB08wAEKAEIQRByLIFKAIAIQVByLIFQQA2AgAgBUEBRg0FIAJBADYCGCACQgA3AhAgAkHAzwI2AgBByLIFQQA2AgAgAyACQQEQBUHIsgUoAgAhBUHIsgVBADYCAAJAIAVBAUcEQEHIsgVBADYCAEHcACACQRBqQQAQFSEFQciyBSgCACEIQciyBUEANgIAIAhBAUcNAQsQBiEBEAcaIAIoAhghAEHIsgVBADYCACAAEOgBQciyBSgCACEAQciyBUEANgIAIABBAUcNB0EAEAshARAHGiABEIQBAAsgBUIANwMAIAJBAToAHCACQaDQAjYCAEHIsgVBADYCAEH8ACAGIAQQBUHIsgUoAgAhAkHIsgVBADYCACACQQFGDQBByLIFQQA2AgBBLUEgEA0hAkHIsgUoAgAhBEHIsgVBADYCACAEQQFGDQBByLIFQQA2AgAgAiABQfLOABCgBCEEQciyBSgCACEFQciyBUEANgIAIAVBAUYNByACQQA2AhggAkIANwIQIAJBwM8CNgIAQciyBUEANgIAIAMgAkEBEAVByLIFKAIAIQVByLIFQQA2AgACQCAFQQFHBEBByLIFQQA2AgBB3AAgAkEQakEAEBUhBUHIsgUoAgAhCEHIsgVBADYCACAIQQFHDQELEAYhARAHGiACKAIYIQBByLIFQQA2AgAgABDoAUHIsgUoAgAhAEHIsgVBADYCACAAQQFHDQlBABALIQEQBxogARCEAQALIAVCADcDACACQQE6ABwgAkGg0AI2AgBByLIFQQA2AgBB/AAgBiAEEAVByLIFKAIAIQJByLIFQQA2AgAgAkEBRg0AQciyBUEANgIAQS1BIBANIQJByLIFKAIAIQRByLIFQQA2AgAgBEEBRg0AQciyBUEANgIAIAIgAUGAzwAQoAQhBEHIsgUoAgAhBUHIsgVBADYCACAFQQFGDQkgAkEANgIYIAJCADcCECACQcDPAjYCAEHIsgVBADYCACADIAJBARAFQciyBSgCACEDQciyBUEANgIAAkAgA0EBRwRAQciyBUEANgIAQdwAIAJBEGpBABAVIQNByLIFKAIAIQVByLIFQQA2AgAgBUEBRw0BCxAGIQEQBxogAigCGCEAQciyBUEANgIAIAAQ6AFByLIFKAIAIQBByLIFQQA2AgAgAEEBRw0LQQAQCyEBEAcaIAEQhAEACyADQgA3AwAgAkEFOgAcIAJBoNACNgIAQciyBUEANgIAQfwAIAYgBBAFQciyBSgCACECQciyBUEANgIAIAJBAUYNAEHIsgVBADYCAEEtQRwQDSECQciyBSgCACEDQciyBUEANgIAIANBAUYNAEHIsgVBADYCACACIAFBj88AEKAEIQNByLIFKAIAIQRByLIFQQA2AgAgBEEBRg0LIAJBADYCGCACQgA3AhAgAkGgzQI2AgBByLIFQQA2AgAgByACQQEQBUHIsgUoAgAhBEHIsgVBADYCAAJAIARBAUcEQEHIsgVBADYCAEHeACACQRBqQQAQFSEEQciyBSgCACEFQciyBUEANgIAIAVBAUcNAQsQBiEBEAcaIAIoAhghAEHIsgVBADYCACAAEOgBQciyBSgCACEAQciyBUEANgIAIABBAUcNDUEAEAshARAHGiABEIQBAAsgBEEAOwEAQciyBUEANgIAQfwAIAYgAxAFQciyBSgCACECQciyBUEANgIAIAJBAUYNAEHIsgVBADYCAEEtQSQQDSECQciyBSgCACEDQciyBUEANgIAIANBAUYNAEHIsgVBADYCAEH9ACACIAFBgs0AQQFBAEEAEBYaQciyBSgCACEDQciyBUEANgIAIANBAUYNDUHIsgVBADYCAEH8ACAGIAIQBUHIsgUoAgAhAkHIsgVBADYCACACQQFGDQBByLIFQQA2AgBBLUEcEA0hAkHIsgUoAgAhA0HIsgVBADYCACADQQFGDQBByLIFQQA2AgAgAiABQZ3PABCgBCEDQciyBSgCACEEQciyBUEANgIAIARBAUYNDiACQQA2AhggAkIANwIQIAJBoM0CNgIAQciyBUEANgIAIAcgAkEBEAVByLIFKAIAIQdByLIFQQA2AgACQCAHQQFHBEBByLIFQQA2AgBB3gAgAkEQakEAEBUhB0HIsgUoAgAhBEHIsgVBADYCACAEQQFHDQELEAYhARAHGiACKAIYIQBByLIFQQA2AgAgABDoAUHIsgUoAgAhAEHIsgVBADYCACAAQQFHDRBBABALIQEQBxogARCEAQALIAdBADsBAEHIsgVBADYCAEH8ACAGIAMQBUHIsgUoAgAhAkHIsgVBADYCACACQQFGDQBByLIFQQA2AgBBLUEoEA0hAkHIsgUoAgAhA0HIsgVBADYCACADQQFGDQBByLIFQQA2AgAgAiABQaXPAEEEQQBBAUEBEM8EGkHIsgUoAgAhA0HIsgVBADYCACADQQFGDRBByLIFQQA2AgBB/AAgBiACEAVByLIFKAIAIQJByLIFQQA2AgAgAkEBRg0AQciyBUEANgIAQS1BKBANIQJByLIFKAIAIQNByLIFQQA2AgAgA0EBRg0AQciyBUEANgIAIAIgAUG0zwBBBkEAQQFBARDPBBpByLIFKAIAIQNByLIFQQA2AgAgA0EBRg0RQciyBUEANgIAQfwAIAYgAhAFQciyBSgCACECQciyBUEANgIAIAJBAUYNAEHIsgVBADYCAEEtQSgQDSECQciyBSgCACEDQciyBUEANgIAIANBAUYNAEHIsgVBADYCACACIAFBws8AQQlBAEEAQQEQzwQaQciyBSgCACEDQciyBUEANgIAIANBAUYNEkHIsgVBADYCAEH8ACAGIAIQBUHIsgUoAgAhAkHIsgVBADYCACACQQFGDQBByLIFQQA2AgBBLUEoEA0hAkHIsgUoAgAhA0HIsgVBADYCACADQQFGDQBByLIFQQA2AgAgAiABQcnPAEEHQQhBAEEAEM8EGkHIsgUoAgAhA0HIsgVBADYCACADQQFGDRNByLIFQQA2AgBB/AAgBiACEAVByLIFKAIAIQJByLIFQQA2AgAgAkEBRg0AQciyBUEANgIAQS1BKBANIQJByLIFKAIAIQNByLIFQQA2AgAgA0EBRg0AQciyBUEANgIAIAIgAUH6zQBBCkEAQQBBABDPBBpByLIFKAIAIQNByLIFQQA2AgAgA0EBRg0UQciyBUEANgIAQfwAIAYgAhAFQciyBSgCACECQciyBUEANgIAIAJBAUYNAEHIsgVBADYCAEEtQSgQDSECQciyBSgCACEDQciyBUEANgIAIANBAUYNAEHIsgVBADYCACACIAFBz88AQcMAQQBBAEEAEM8EGkHIsgUoAgAhA0HIsgVBADYCACADQQFGDRVByLIFQQA2AgBB/AAgBiACEAVByLIFKAIAIQJByLIFQQA2AgAgAkEBRg0AQciyBUEANgIAQS1BKBANIQJByLIFKAIAIQNByLIFQQA2AgAgA0EBRg0AQciyBUEANgIAIAIgAUHZzwBBDEEAQQBBARDPBBpByLIFKAIAIQNByLIFQQA2AgAgA0EBRg0WQciyBUEANgIAQfwAIAYgAhAFQciyBSgCACECQciyBUEANgIAIAJBAUYNAEHIsgVBADYCAEEtQSgQDSECQciyBSgCACEDQciyBUEANgIAIANBAUYNAEHIsgVBADYCACACIAFB4s8AQQ1BAEEAQQEQzwQaQciyBSgCACEDQciyBUEANgIAIANBAUYNF0HIsgVBADYCAEH8ACAGIAIQBUHIsgUoAgAhAkHIsgVBADYCACACQQFGDQBByLIFQQA2AgBBLUEoEA0hAkHIsgUoAgAhA0HIsgVBADYCACADQQFGDQBByLIFQQA2AgAgAiABQYfOAEGAAUH+AUEAQQAQzwQaQciyBSgCACEBQciyBUEANgIAIAFBAUYNGEHIsgVBADYCAEH8ACAGIAIQBUHIsgUoAgAhAUHIsgVBADYCACABQQFHDRoLEAYhARAHGgwYCxAGIQEQBxoLIAIQ9gwMFgsQBiEBEAcaCyACEPYMDBQLEAYhARAHGgsgAhD2DAwSCxAGIQEQBxoLIAIQ9gwMEAsQBiEBEAcaCyACEPYMDA4LEAYhARAHGgsgAhD2DAwMCxAGIQEQBxogAhD2DAwLCxAGIQEQBxoLIAIQ9gwMCQsQBiEBEAcaIAIQ9gwMCAsQBiEBEAcaIAIQ9gwMBwsQBiEBEAcaIAIQ9gwMBgsQBiEBEAcaIAIQ9gwMBQsQBiEBEAcaIAIQ9gwMBAsQBiEBEAcaIAIQ9gwMAwsQBiEBEAcaIAIQ9gwMAgsQBiEBEAcaIAIQ9gwMAQsQBiEBEAcaIAIQ9gwLIAYQpgMaIAEQCAALIABBBTYCKCAAC34BAX4gAEEcaiIAQQEQrAEoAgBBEGpBABCpASkDACEBIABBBRCsASgCACABUDoADSAAQQIQrAEoAgBBEGpBABCpASkDACEBIABBBhCsASgCACABUDoADSAAQQMQrAEoAgBBEGpBABCpASkDACEBIABBBxCsASgCACABUDoADQuoFgEGfyAAIAFBBBClAyEGIABB9M8ANgIAQciyBUEANgIAQS1BHBANIQJByLIFKAIAIQNByLIFQQA2AgACQAJAAkACQAJAAkACQAJAAkACQAJAAkACQAJAAkACQAJAAkACQCADQQFGDQBByLIFQQA2AgAgAiABQZDQABCgBCEDQciyBSgCACEFQciyBUEANgIAIAVBAUYNASACQQA2AhggAkIANwIQIAJBkMwCNgIAQciyBUEANgIAQaDMAigCACACQQEQBUHIsgUoAgAhBUHIsgVBADYCAAJAIAVBAUcEQEHIsgVBADYCAEHZACACQRBqQQAQFSEFQciyBSgCACEEQciyBUEANgIAIARBAUcNAQsQBiEBEAcaIAIoAhghAEHIsgVBADYCACAAEOgBQciyBSgCACEAQciyBUEANgIAIABBAUcNA0EAEAshARAHGiABEIQBAAsgBUEAOgAAQciyBUEANgIAQfwAIAYgAxAFQciyBSgCACECQciyBUEANgIAIAJBAUYNAEHIsgVBADYCAEEtQSAQDSECQciyBSgCACEDQciyBUEANgIAIANBAUYNAEHIsgVBADYCACACIAFBndAAEKAEIQVByLIFKAIAIQNByLIFQQA2AgAgA0EBRg0DIAJBADYCGCACQgA3AhAgAkHAzwI2AgBByLIFQQA2AgBB0M8CKAIAIgMgAkEBEAVByLIFKAIAIQRByLIFQQA2AgACQCAEQQFHBEBByLIFQQA2AgBB3AAgAkEQakEAEBUhBEHIsgUoAgAhB0HIsgVBADYCACAHQQFHDQELEAYhARAHGiACKAIYIQBByLIFQQA2AgAgABDoAUHIsgUoAgAhAEHIsgVBADYCACAAQQFHDQVBABALIQEQBxogARCEAQALIARCADcDACACQQY6ABwgAkGg0AI2AgBByLIFQQA2AgBB/AAgBiAFEAVByLIFKAIAIQJByLIFQQA2AgAgAkEBRg0AQciyBUEANgIAQS1BIBANIQJByLIFKAIAIQVByLIFQQA2AgAgBUEBRg0AQciyBUEANgIAIAIgAUGo0AAQoAQhBUHIsgUoAgAhBEHIsgVBADYCACAEQQFGDQUgAkEANgIYIAJCADcCECACQcDPAjYCAEHIsgVBADYCACADIAJBARAFQciyBSgCACEEQciyBUEANgIAAkAgBEEBRwRAQciyBUEANgIAQdwAIAJBEGpBABAVIQRByLIFKAIAIQdByLIFQQA2AgAgB0EBRw0BCxAGIQEQBxogAigCGCEAQciyBUEANgIAIAAQ6AFByLIFKAIAIQBByLIFQQA2AgAgAEEBRw0HQQAQCyEBEAcaIAEQhAEACyAEQgA3AwAgAkEBOgAcIAJBoNACNgIAQciyBUEANgIAQfwAIAYgBRAFQciyBSgCACECQciyBUEANgIAIAJBAUYNAEHIsgVBADYCAEEtQSAQDSECQciyBSgCACEFQciyBUEANgIAIAVBAUYNAEHIsgVBADYCACACIAFB+cwAEKAEIQVByLIFKAIAIQRByLIFQQA2AgAgBEEBRg0HIAJBADYCGCACQgA3AhAgAkHAzwI2AgBByLIFQQA2AgAgAyACQQEQBUHIsgUoAgAhBEHIsgVBADYCAAJAIARBAUcEQEHIsgVBADYCAEHcACACQRBqQQAQFSEEQciyBSgCACEHQciyBUEANgIAIAdBAUcNAQsQBiEBEAcaIAIoAhghAEHIsgVBADYCACAAEOgBQciyBSgCACEAQciyBUEANgIAIABBAUcNCUEAEAshARAHGiABEIQBAAsgBEIANwMAIAJBAToAHCACQaDQAjYCAEHIsgVBADYCAEH8ACAGIAUQBUHIsgUoAgAhAkHIsgVBADYCACACQQFGDQBByLIFQQA2AgBBLUEgEA0hAkHIsgUoAgAhBUHIsgVBADYCACAFQQFGDQBByLIFQQA2AgAgAiABQbHQABCgBCEFQciyBSgCACEEQciyBUEANgIAIARBAUYNCSACQQA2AhggAkIANwIQIAJBwM8CNgIAQciyBUEANgIAIAMgAkEBEAVByLIFKAIAIQNByLIFQQA2AgACQCADQQFHBEBByLIFQQA2AgBB3AAgAkEQakEAEBUhA0HIsgUoAgAhBEHIsgVBADYCACAEQQFHDQELEAYhARAHGiACKAIYIQBByLIFQQA2AgAgABDoAUHIsgUoAgAhAEHIsgVBADYCACAAQQFHDQtBABALIQEQBxogARCEAQALIANCADcDACACQRg6ABwgAkGg0AI2AgBByLIFQQA2AgBB/AAgBiAFEAVByLIFKAIAIQJByLIFQQA2AgAgAkEBRg0AQciyBUEANgIAQS1BHBANIQJByLIFKAIAIQNByLIFQQA2AgAgA0EBRg0AQciyBUEANgIAIAIgAUG+0AAQoAQhA0HIsgUoAgAhBUHIsgVBADYCACAFQQFGDQsgAkEANgIYIAJCADcCECACQeDOAjYCAEHIsgVBADYCAEHwzgIoAgAiBSACQQEQBUHIsgUoAgAhBEHIsgVBADYCAAJAIARBAUcEQEHIsgVBADYCAEH7ACACQRBqQQAQFSEEQciyBSgCACEHQciyBUEANgIAIAdBAUcNAQsQBiEBEAcaIAIoAhghAEHIsgVBADYCACAAEOgBQciyBSgCACEAQciyBUEANgIAIABBAUcNDUEAEAshARAHGiABEIQBAAsgBEEANgIAQciyBUEANgIAQfwAIAYgAxAFQciyBSgCACECQciyBUEANgIAIAJBAUYNAEHIsgVBADYCAEEtQRwQDSECQciyBSgCACEDQciyBUEANgIAIANBAUYNAEHIsgVBADYCACACIAFBydAAEKAEIQNByLIFKAIAIQRByLIFQQA2AgAgBEEBRg0NIAJBADYCGCACQgA3AhAgAkHgzgI2AgBByLIFQQA2AgAgBSACQQEQBUHIsgUoAgAhBUHIsgVBADYCAAJAIAVBAUcEQEHIsgVBADYCAEH7ACACQRBqQQAQFSEFQciyBSgCACEEQciyBUEANgIAIARBAUcNAQsQBiEBEAcaIAIoAhghAEHIsgVBADYCACAAEOgBQciyBSgCACEAQciyBUEANgIAIABBAUcND0EAEAshARAHGiABEIQBAAsgBUEANgIAQciyBUEANgIAQfwAIAYgAxAFQciyBSgCACECQciyBUEANgIAIAJBAUYNAEHIsgVBADYCAEEtQSgQDSECQciyBSgCACEDQciyBUEANgIAIANBAUYNAEHIsgVBADYCACACIAFB1NAAQQVBAEEAQQEQzwQaQciyBSgCACEDQciyBUEANgIAIANBAUYND0HIsgVBADYCAEH8ACAGIAIQBUHIsgUoAgAhAkHIsgVBADYCACACQQFGDQBByLIFQQA2AgBBLUEoEA0hAkHIsgUoAgAhA0HIsgVBADYCACADQQFGDQBByLIFQQA2AgAgAiABQeTQAEETQQBBAEEAEM8EGkHIsgUoAgAhAUHIsgVBADYCACABQQFGDRBByLIFQQA2AgBB/AAgBiACEAVByLIFKAIAIQFByLIFQQA2AgAgAUEBRw0SCxAGIQEQBxoMEAsQBiEBEAcaCyACEPYMDA4LEAYhARAHGgsgAhD2DAwMCxAGIQEQBxoLIAIQ9gwMCgsQBiEBEAcaCyACEPYMDAgLEAYhARAHGgsgAhD2DAwGCxAGIQEQBxoLIAIQ9gwMBAsQBiEBEAcaCyACEPYMDAILEAYhARAHGiACEPYMDAELEAYhARAHGiACEPYMCyAGEKYDGiABEAgACyAACxYAIABBHGpBAxCsASgCAEIBQQAQrgEL80IBCH8gACABQQYQpQMhCCAAQZDRADYCAEHIsgVBADYCAEEtQRwQDSEDQciyBSgCACECQciyBUEANgIAAkACQAJAAkACQAJAAkACQAJAAkACQAJAAkACQAJAAkACQAJAAkACQAJAAkACQAJAAkACQAJAAkACQAJAAkACQAJAAkACQAJAAkACQAJAAkACQAJAAkACQAJAAkACQAJAAkACQAJAIAJBAUYNAEHIsgVBADYCACADIAFBrNEAEKAEIQJByLIFKAIAIQdByLIFQQA2AgAgB0EBRg0BIANBADYCGCADQgA3AhAgA0GQzAI2AgBByLIFQQA2AgBBoMwCKAIAIgcgA0EBEAVByLIFKAIAIQVByLIFQQA2AgACQCAFQQFHBEBByLIFQQA2AgBB2QAgA0EQakEAEBUhBUHIsgUoAgAhBEHIsgVBADYCACAEQQFHDQELEAYhARAHGiADKAIYIQJByLIFQQA2AgAgAhDoAUHIsgUoAgAhAkHIsgVBADYCACACQQFHDQNBABALIQEQBxogARCEAQALIAVBADoAAEHIsgVBADYCAEH8ACAIIAIQBUHIsgUoAgAhA0HIsgVBADYCACADQQFGDQBByLIFQQA2AgBBLUEgEA0hAkHIsgUoAgAhA0HIsgVBADYCACADQQFGDQBByLIFQQA2AgAgAiABQbfRABCgBCEFQciyBSgCACEDQciyBUEANgIAIANBAUYNAyACQQA2AhggAkIANwIQIAJBwM8CNgIAQciyBUEANgIAQdDPAigCACIDIAJBARAFQciyBSgCACEEQciyBUEANgIAAkAgBEEBRwRAQciyBUEANgIAQdwAIAJBEGpBABAVIQRByLIFKAIAIQZByLIFQQA2AgAgBkEBRw0BCxAGIQEQBxogAigCGCEDQciyBUEANgIAIAMQ6AFByLIFKAIAIQNByLIFQQA2AgAgA0EBRw0FQQAQCyEBEAcaIAEQhAEACyAEQgA3AwAgAkEBOgAcIAJBoNACNgIAQciyBUEANgIAQfwAIAggBRAFQciyBSgCACECQciyBUEANgIAIAJBAUYNAEHIsgVBADYCAEEtQSAQDSECQciyBSgCACEFQciyBUEANgIAIAVBAUYNAEHIsgVBADYCACACIAFBztEAEKAEIQVByLIFKAIAIQRByLIFQQA2AgAgBEEBRg0FIAJBADYCGCACQgA3AhAgAkHAzwI2AgBByLIFQQA2AgAgAyACQQEQBUHIsgUoAgAhBEHIsgVBADYCAAJAIARBAUcEQEHIsgVBADYCAEHcACACQRBqQQAQFSEEQciyBSgCACEGQciyBUEANgIAIAZBAUcNAQsQBiEBEAcaIAIoAhghA0HIsgVBADYCACADEOgBQciyBSgCACEDQciyBUEANgIAIANBAUcNB0EAEAshARAHGiABEIQBAAsgBEIANwMAIAJBAToAHCACQaDQAjYCAEHIsgVBADYCAEH8ACAIIAUQBUHIsgUoAgAhAkHIsgVBADYCACACQQFGDQBByLIFQQA2AgBBLUEgEA0hAkHIsgUoAgAhBUHIsgVBADYCACAFQQFGDQBByLIFQQA2AgAgAiABQePRABCgBCEFQciyBSgCACEEQciyBUEANgIAIARBAUYNByACQQA2AhggAkIANwIQIAJBwM8CNgIAQciyBUEANgIAIAMgAkEBEAVByLIFKAIAIQRByLIFQQA2AgACQCAEQQFHBEBByLIFQQA2AgBB3AAgAkEQakEAEBUhBEHIsgUoAgAhBkHIsgVBADYCACAGQQFHDQELEAYhARAHGiACKAIYIQNByLIFQQA2AgAgAxDoAUHIsgUoAgAhA0HIsgVBADYCACADQQFHDQlBABALIQEQBxogARCEAQALIARCADcDACACQQE6ABwgAkGg0AI2AgBByLIFQQA2AgBB/AAgCCAFEAVByLIFKAIAIQJByLIFQQA2AgAgAkEBRg0AQciyBUEANgIAQS1BIBANIQJByLIFKAIAIQVByLIFQQA2AgAgBUEBRg0AQciyBUEANgIAIAIgAUH80QAQoAQhBUHIsgUoAgAhBEHIsgVBADYCACAEQQFGDQkgAkEANgIYIAJCADcCECACQcDPAjYCAEHIsgVBADYCACADIAJBARAFQciyBSgCACEEQciyBUEANgIAAkAgBEEBRwRAQciyBUEANgIAQdwAIAJBEGpBABAVIQRByLIFKAIAIQZByLIFQQA2AgAgBkEBRw0BCxAGIQEQBxogAigCGCEDQciyBUEANgIAIAMQ6AFByLIFKAIAIQNByLIFQQA2AgAgA0EBRw0LQQAQCyEBEAcaIAEQhAEACyAEQgA3AwAgAkEBOgAcIAJBoNACNgIAQciyBUEANgIAQfwAIAggBRAFQciyBSgCACECQciyBUEANgIAIAJBAUYNAEHIsgVBADYCAEEtQSAQDSECQciyBSgCACEFQciyBUEANgIAIAVBAUYNAEHIsgVBADYCACACIAFBmdIAEKAEIQVByLIFKAIAIQRByLIFQQA2AgAgBEEBRg0LIAJBADYCGCACQgA3AhAgAkHAzwI2AgBByLIFQQA2AgAgAyACQQEQBUHIsgUoAgAhBEHIsgVBADYCAAJAIARBAUcEQEHIsgVBADYCAEHcACACQRBqQQAQFSEEQciyBSgCACEGQciyBUEANgIAIAZBAUcNAQsQBiEBEAcaIAIoAhghA0HIsgVBADYCACADEOgBQciyBSgCACEDQciyBUEANgIAIANBAUcNDUEAEAshARAHGiABEIQBAAsgBEIANwMAIAJBAToAHCACQaDQAjYCAEHIsgVBADYCAEH8ACAIIAUQBUHIsgUoAgAhAkHIsgVBADYCACACQQFGDQBByLIFQQA2AgBBLUEgEA0hAkHIsgUoAgAhBUHIsgVBADYCACAFQQFGDQBByLIFQQA2AgAgAiABQajSABCgBCEFQciyBSgCACEEQciyBUEANgIAIARBAUYNDSACQQA2AhggAkIANwIQIAJBwM8CNgIAQciyBUEANgIAIAMgAkEBEAVByLIFKAIAIQRByLIFQQA2AgACQCAEQQFHBEBByLIFQQA2AgBB3AAgAkEQakEAEBUhBEHIsgUoAgAhBkHIsgVBADYCACAGQQFHDQELEAYhARAHGiACKAIYIQNByLIFQQA2AgAgAxDoAUHIsgUoAgAhA0HIsgVBADYCACADQQFHDQ9BABALIQEQBxogARCEAQALIARCADcDACACQQE6ABwgAkGg0AI2AgBByLIFQQA2AgBB/AAgCCAFEAVByLIFKAIAIQJByLIFQQA2AgAgAkEBRg0AQciyBUEANgIAQS1BIBANIQJByLIFKAIAIQVByLIFQQA2AgAgBUEBRg0AQciyBUEANgIAIAIgAUG60gAQoAQhBUHIsgUoAgAhBEHIsgVBADYCACAEQQFGDQ8gAkEANgIYIAJCADcCECACQcDPAjYCAEHIsgVBADYCACADIAJBARAFQciyBSgCACEEQciyBUEANgIAAkAgBEEBRwRAQciyBUEANgIAQdwAIAJBEGpBABAVIQRByLIFKAIAIQZByLIFQQA2AgAgBkEBRw0BCxAGIQEQBxogAigCGCEDQciyBUEANgIAIAMQ6AFByLIFKAIAIQNByLIFQQA2AgAgA0EBRw0RQQAQCyEBEAcaIAEQhAEACyAEQgA3AwAgAkEBOgAcIAJBoNACNgIAQciyBUEANgIAQfwAIAggBRAFQciyBSgCACECQciyBUEANgIAIAJBAUYNAEHIsgVBADYCAEEtQSAQDSECQciyBSgCACEFQciyBUEANgIAIAVBAUYNAEHIsgVBADYCACACIAFBxtIAEKAEIQVByLIFKAIAIQRByLIFQQA2AgAgBEEBRg0RIAJBADYCGCACQgA3AhAgAkHAzwI2AgBByLIFQQA2AgAgAyACQQEQBUHIsgUoAgAhBEHIsgVBADYCAAJAIARBAUcEQEHIsgVBADYCAEHcACACQRBqQQAQFSEEQciyBSgCACEGQciyBUEANgIAIAZBAUcNAQsQBiEBEAcaIAIoAhghA0HIsgVBADYCACADEOgBQciyBSgCACEDQciyBUEANgIAIANBAUcNE0EAEAshARAHGiABEIQBAAsgBEIANwMAIAJBAToAHCACQaDQAjYCAEHIsgVBADYCAEH8ACAIIAUQBUHIsgUoAgAhAkHIsgVBADYCACACQQFGDQBByLIFQQA2AgBBLUEcEA0hAkHIsgUoAgAhBUHIsgVBADYCACAFQQFGDQBByLIFQQA2AgAgAiABQdPSABCgBCEEQciyBSgCACEFQciyBUEANgIAIAVBAUYNEyACQQA2AhggAkIANwIQIAJB4M4CNgIAQciyBUEANgIAQfDOAigCACIFIAJBARAFQciyBSgCACEGQciyBUEANgIAAkAgBkEBRwRAQciyBUEANgIAQfsAIAJBEGpBABAVIQZByLIFKAIAIQlByLIFQQA2AgAgCUEBRw0BCxAGIQEQBxogAigCGCEDQciyBUEANgIAIAMQ6AFByLIFKAIAIQNByLIFQQA2AgAgA0EBRw0VQQAQCyEBEAcaIAEQhAEACyAGQQA2AgBByLIFQQA2AgBB/AAgCCAEEAVByLIFKAIAIQJByLIFQQA2AgAgAkEBRg0AQciyBUEANgIAQS1BHBANIQJByLIFKAIAIQRByLIFQQA2AgAgBEEBRg0AQciyBUEANgIAIAIgAUHn0gAQoAQhBEHIsgUoAgAhBkHIsgVBADYCACAGQQFGDRUgAkEANgIYIAJCADcCECACQeDOAjYCAEHIsgVBADYCACAFIAJBARAFQciyBSgCACEGQciyBUEANgIAAkAgBkEBRwRAQciyBUEANgIAQfsAIAJBEGpBABAVIQZByLIFKAIAIQlByLIFQQA2AgAgCUEBRw0BCxAGIQEQBxogAigCGCEDQciyBUEANgIAIAMQ6AFByLIFKAIAIQNByLIFQQA2AgAgA0EBRw0XQQAQCyEBEAcaIAEQhAEACyAGQQA2AgBByLIFQQA2AgBB/AAgCCAEEAVByLIFKAIAIQJByLIFQQA2AgAgAkEBRg0AQciyBUEANgIAQS1BHBANIQJByLIFKAIAIQRByLIFQQA2AgAgBEEBRg0AQciyBUEANgIAIAIgAUH10gAQoAQhBEHIsgUoAgAhBkHIsgVBADYCACAGQQFGDRcgAkEANgIYIAJCADcCECACQZDMAjYCAEHIsgVBADYCACAHIAJBARAFQciyBSgCACEGQciyBUEANgIAAkAgBkEBRwRAQciyBUEANgIAQdkAIAJBEGpBABAVIQZByLIFKAIAIQlByLIFQQA2AgAgCUEBRw0BCxAGIQEQBxogAigCGCEDQciyBUEANgIAIAMQ6AFByLIFKAIAIQNByLIFQQA2AgAgA0EBRw0ZQQAQCyEBEAcaIAEQhAEACyAGQQA6AABByLIFQQA2AgBB/AAgCCAEEAVByLIFKAIAIQJByLIFQQA2AgAgAkEBRg0AQciyBUEANgIAQS1BHBANIQJByLIFKAIAIQRByLIFQQA2AgAgBEEBRg0AQciyBUEANgIAIAIgAUGF0wAQoAQhBEHIsgUoAgAhBkHIsgVBADYCACAGQQFGDRkgAkEANgIYIAJCADcCECACQZDMAjYCAEHIsgVBADYCACAHIAJBARAFQciyBSgCACEGQciyBUEANgIAAkAgBkEBRwRAQciyBUEANgIAQdkAIAJBEGpBABAVIQZByLIFKAIAIQlByLIFQQA2AgAgCUEBRw0BCxAGIQEQBxogAigCGCEDQciyBUEANgIAIAMQ6AFByLIFKAIAIQNByLIFQQA2AgAgA0EBRw0bQQAQCyEBEAcaIAEQhAEACyAGQQA6AABByLIFQQA2AgBB/AAgCCAEEAVByLIFKAIAIQJByLIFQQA2AgAgAkEBRg0AQciyBUEANgIAQS1BHBANIQJByLIFKAIAIQRByLIFQQA2AgAgBEEBRg0AQciyBUEANgIAIAIgAUGP0wAQoAQhBEHIsgUoAgAhBkHIsgVBADYCACAGQQFGDRsgAkEANgIYIAJCADcCECACQZDMAjYCAEHIsgVBADYCACAHIAJBARAFQciyBSgCACEGQciyBUEANgIAAkAgBkEBRwRAQciyBUEANgIAQdkAIAJBEGpBABAVIQZByLIFKAIAIQlByLIFQQA2AgAgCUEBRw0BCxAGIQEQBxogAigCGCEDQciyBUEANgIAIAMQ6AFByLIFKAIAIQNByLIFQQA2AgAgA0EBRw0dQQAQCyEBEAcaIAEQhAEACyAGQQA6AABByLIFQQA2AgBB/AAgCCAEEAVByLIFKAIAIQJByLIFQQA2AgAgAkEBRg0AQciyBUEANgIAQS1BHBANIQJByLIFKAIAIQRByLIFQQA2AgAgBEEBRg0AQciyBUEANgIAIAIgAUGY0wAQoAQhBEHIsgUoAgAhBkHIsgVBADYCACAGQQFGDR0gAkEANgIYIAJCADcCECACQZDMAjYCAEHIsgVBADYCACAHIAJBARAFQciyBSgCACEHQciyBUEANgIAAkAgB0EBRwRAQciyBUEANgIAQdkAIAJBEGpBABAVIQdByLIFKAIAIQZByLIFQQA2AgAgBkEBRw0BCxAGIQEQBxogAigCGCEDQciyBUEANgIAIAMQ6AFByLIFKAIAIQNByLIFQQA2AgAgA0EBRw0fQQAQCyEBEAcaIAEQhAEACyAHQQA6AABByLIFQQA2AgBB/AAgCCAEEAVByLIFKAIAIQJByLIFQQA2AgAgAkEBRg0AQciyBUEANgIAQS1BIBANIQJByLIFKAIAIQdByLIFQQA2AgAgB0EBRg0AQciyBUEANgIAIAIgAUGt0wAQoAQhB0HIsgUoAgAhBEHIsgVBADYCACAEQQFGDR8gAkEANgIYIAJCADcCECACQcDPAjYCAEHIsgVBADYCACADIAJBARAFQciyBSgCACEEQciyBUEANgIAAkAgBEEBRwRAQciyBUEANgIAQdwAIAJBEGpBABAVIQRByLIFKAIAIQZByLIFQQA2AgAgBkEBRw0BCxAGIQEQBxogAigCGCEDQciyBUEANgIAIAMQ6AFByLIFKAIAIQNByLIFQQA2AgAgA0EBRw0hQQAQCyEBEAcaIAEQhAEACyAEQgA3AwAgAkEEOgAcIAJBoNACNgIAQciyBUEANgIAQfwAIAggBxAFQciyBSgCACECQciyBUEANgIAIAJBAUYNAEHIsgVBADYCAEEtQSAQDSECQciyBSgCACEHQciyBUEANgIAIAdBAUYNAEHIsgVBADYCACACIAFBxtMAEKAEIQdByLIFKAIAIQRByLIFQQA2AgAgBEEBRg0hIAJBADYCGCACQgA3AhAgAkHAzwI2AgBByLIFQQA2AgAgAyACQQEQBUHIsgUoAgAhBEHIsgVBADYCAAJAIARBAUcEQEHIsgVBADYCAEHcACACQRBqQQAQFSEEQciyBSgCACEGQciyBUEANgIAIAZBAUcNAQsQBiEBEAcaIAIoAhghA0HIsgVBADYCACADEOgBQciyBSgCACEDQciyBUEANgIAIANBAUcNI0EAEAshARAHGiABEIQBAAsgBEIANwMAIAJBBToAHCACQaDQAjYCAEHIsgVBADYCAEH8ACAIIAcQBUHIsgUoAgAhAkHIsgVBADYCACACQQFGDQBByLIFQQA2AgBBLUEgEA0hAkHIsgUoAgAhB0HIsgVBADYCACAHQQFGDQBByLIFQQA2AgAgAiABQdXTABCgBCEHQciyBSgCACEEQciyBUEANgIAIARBAUYNIyACQQA2AhggAkIANwIQIAJBwM8CNgIAQciyBUEANgIAIAMgAkEBEAVByLIFKAIAIQRByLIFQQA2AgACQCAEQQFHBEBByLIFQQA2AgBB3AAgAkEQakEAEBUhBEHIsgUoAgAhBkHIsgVBADYCACAGQQFHDQELEAYhARAHGiACKAIYIQNByLIFQQA2AgAgAxDoAUHIsgUoAgAhA0HIsgVBADYCACADQQFHDSVBABALIQEQBxogARCEAQALIARCADcDACACQQU6ABwgAkGg0AI2AgBByLIFQQA2AgBB/AAgCCAHEAVByLIFKAIAIQJByLIFQQA2AgAgAkEBRg0AQciyBUEANgIAQS1BIBANIQJByLIFKAIAIQdByLIFQQA2AgAgB0EBRg0AQciyBUEANgIAIAIgAUH5zAAQoAQhB0HIsgUoAgAhBEHIsgVBADYCACAEQQFGDSUgAkEANgIYIAJCADcCECACQcDPAjYCAEHIsgVBADYCACADIAJBARAFQciyBSgCACEEQciyBUEANgIAAkAgBEEBRwRAQciyBUEANgIAQdwAIAJBEGpBABAVIQRByLIFKAIAIQZByLIFQQA2AgAgBkEBRw0BCxAGIQEQBxogAigCGCEDQciyBUEANgIAIAMQ6AFByLIFKAIAIQNByLIFQQA2AgAgA0EBRw0nQQAQCyEBEAcaIAEQhAEACyAEQgA3AwAgAkECOgAcIAJBoNACNgIAQciyBUEANgIAQfwAIAggBxAFQciyBSgCACECQciyBUEANgIAIAJBAUYNAEHIsgVBADYCAEEtQRwQDSECQciyBSgCACEHQciyBUEANgIAIAdBAUYNAEHIsgVBADYCACACIAFB6NMAEKAEIQdByLIFKAIAIQRByLIFQQA2AgAgBEEBRg0nIAJBADYCGCACQgA3AhAgAkHgzgI2AgBByLIFQQA2AgAgBSACQQEQBUHIsgUoAgAhBUHIsgVBADYCAAJAIAVBAUcEQEHIsgVBADYCAEH7ACACQRBqQQAQFSEFQciyBSgCACEEQciyBUEANgIAIARBAUcNAQsQBiEBEAcaIAIoAhghA0HIsgVBADYCACADEOgBQciyBSgCACEDQciyBUEANgIAIANBAUcNKUEAEAshARAHGiABEIQBAAsgBUEANgIAQciyBUEANgIAQfwAIAggBxAFQciyBSgCACECQciyBUEANgIAIAJBAUYNAEHIsgVBADYCAEEtQRwQDSECQciyBSgCACEHQciyBUEANgIAIAdBAUYNAEHIsgVBADYCACACIAFB8tMAEKAEIQdByLIFKAIAIQVByLIFQQA2AgAgBUEBRg0pIAJBADYCGCACQgA3AhAgAkGgzQI2AgBByLIFQQA2AgBBsM0CKAIAIgUgAkEBEAVByLIFKAIAIQRByLIFQQA2AgACQCAEQQFHBEBByLIFQQA2AgBB3gAgAkEQakEAEBUhBEHIsgUoAgAhBkHIsgVBADYCACAGQQFHDQELEAYhARAHGiACKAIYIQNByLIFQQA2AgAgAxDoAUHIsgUoAgAhA0HIsgVBADYCACADQQFHDStBABALIQEQBxogARCEAQALIARBADsBAEHIsgVBADYCAEH8ACAIIAcQBUHIsgUoAgAhAkHIsgVBADYCACACQQFGDQBByLIFQQA2AgBBLUEcEA0hAkHIsgUoAgAhB0HIsgVBADYCACAHQQFGDQBByLIFQQA2AgAgAiABQYXUABCgBCEHQciyBSgCACEEQciyBUEANgIAIARBAUYNKyACQQA2AhggAkIANwIQIAJBoM0CNgIAQciyBUEANgIAIAUgAkEBEAVByLIFKAIAIQVByLIFQQA2AgACQCAFQQFHBEBByLIFQQA2AgBB3gAgAkEQakEAEBUhBUHIsgUoAgAhBEHIsgVBADYCACAEQQFHDQELEAYhARAHGiACKAIYIQNByLIFQQA2AgAgAxDoAUHIsgUoAgAhA0HIsgVBADYCACADQQFHDS1BABALIQEQBxogARCEAQALIAVBADsBAEHIsgVBADYCAEH8ACAIIAcQBUHIsgUoAgAhAkHIsgVBADYCACACQQFGDQBByLIFQQA2AgBBLUEgEA0hAkHIsgUoAgAhB0HIsgVBADYCACAHQQFGDQBByLIFQQA2AgAgAiABQZ3UABCgBCEHQciyBSgCACEFQciyBUEANgIAIAVBAUYNLSACQQA2AhggAkIANwIQIAJBwM8CNgIAQciyBUEANgIAIAMgAkEBEAVByLIFKAIAIQVByLIFQQA2AgACQCAFQQFHBEBByLIFQQA2AgBB3AAgAkEQakEAEBUhBUHIsgUoAgAhBEHIsgVBADYCACAEQQFHDQELEAYhARAHGiACKAIYIQNByLIFQQA2AgAgAxDoAUHIsgUoAgAhA0HIsgVBADYCACADQQFHDS9BABALIQEQBxogARCEAQALIAVCADcDACACQcAAOgAcIAJBoNACNgIAQciyBUEANgIAQfwAIAggBxAFQciyBSgCACECQciyBUEANgIAIAJBAUYNAEHIsgVBADYCAEEtQSAQDSECQciyBSgCACEHQciyBUEANgIAIAdBAUYNAEHIsgVBADYCACACIAFBtNQAEKAEIQFByLIFKAIAIQdByLIFQQA2AgAgB0EBRg0vIAJBADYCGCACQgA3AhAgAkHAzwI2AgBByLIFQQA2AgAgAyACQQEQBUHIsgUoAgAhA0HIsgVBADYCAAJAIANBAUcEQEHIsgVBADYCAEHcACACQRBqQQAQFSEDQciyBSgCACEHQciyBUEANgIAIAdBAUcNAQsQBiEBEAcaIAIoAhghA0HIsgVBADYCACADEOgBQciyBSgCACEDQciyBUEANgIAIANBAUcNMUEAEAshARAHGiABEIQBAAsgA0IANwMAIAJBwAA6ABwgAkGg0AI2AgBByLIFQQA2AgBB/AAgCCABEAVByLIFKAIAIQFByLIFQQA2AgAgAUEBRw0yCxAGIQEQBxoMMAsQBiEBEAcaCyADEPYMDC4LEAYhARAHGgsgAhD2DAwsCxAGIQEQBxoLIAIQ9gwMKgsQBiEBEAcaCyACEPYMDCgLEAYhARAHGgsgAhD2DAwmCxAGIQEQBxoLIAIQ9gwMJAsQBiEBEAcaCyACEPYMDCILEAYhARAHGgsgAhD2DAwgCxAGIQEQBxoLIAIQ9gwMHgsQBiEBEAcaCyACEPYMDBwLEAYhARAHGgsgAhD2DAwaCxAGIQEQBxoLIAIQ9gwMGAsQBiEBEAcaCyACEPYMDBYLEAYhARAHGgsgAhD2DAwUCxAGIQEQBxoLIAIQ9gwMEgsQBiEBEAcaCyACEPYMDBALEAYhARAHGgsgAhD2DAwOCxAGIQEQBxoLIAIQ9gwMDAsQBiEBEAcaCyACEPYMDAoLEAYhARAHGgsgAhD2DAwICxAGIQEQBxoLIAIQ9gwMBgsQBiEBEAcaCyACEPYMDAQLEAYhARAHGgsgAhD2DAwCCxAGIQEQBxoLIAIQ9gwLIAgQpgMaIAEQCAALIAALOgAgAEEcaiIAQQAQrAEoAgBBAkEAEK0BIABBBhCsASgCAEIBQQAQrgEgAEESEKwBKAIAQgNBABCuAQtTACAAIAEQrAMgACABQQBBARCtAyAAQRxqQQAQrAEoAgBBEGpBABCoAS0AAEUEQCAAIAFBAUESEK0DCyAAIAAoAgAoAhgRAQAgACABQRNBfxCtAwvkBQICfwF+AkAgAEEcaiIAQQAQrAEoAgBBEGpBABCoAS0AACICRQRAIABBARCsASgCAEEAOgANIABBAhCsASgCAEEAOgANIABBAxCsASgCAEEAOgANIABBBBCsASgCAEEAOgANIABBBRCsASgCAEEAOgANIABBBhCsASgCAEEAOgANIABBBxCsASgCAEEAOgANIABBCBCsASgCAEEAOgANIABBCRCsASgCAEEAOgANIABBChCsASgCAEEAOgANIABBCxCsASgCAEEAOgANIABBDBCsASgCAEEAOgANIABBDRCsASgCAEEAOgANIABBDhCsASgCAEEAOgANIABBDxCsASgCAEEAOgANIABBEBCsASgCAEEAOgANIABBERCsASgCAEEAOgANIABBEhCsASgCAEEAOgANIABBEhCsASgCAEIDQQAQrgEMAQsgACgCAEECTwRAQQEhAQNAIAAgARCsASgCAEEBOgANIAFBAWoiASAAKAIASQ0ACwsgAkF/aiIBQQFLDQAgAUEBawRAIABBBhCsASgCAEIAQQAQrgEgAEEJEKwBKAIAQegHQQAQ1wEgAEELEKwBKAIAQSBBABCtAQwBCyAAQQYQrAEoAgBCAUEAEK4BCyAAQQgQrAEoAgBBEGpBABCpASkDACEDIABBExCsASgCACADUCIBOgANIABBFBCsASgCACABOgANIABBFRCsASgCACABOgANIABBBhCsASgCAEEQakEAEKkBKQMAIQMgAEEWEKwBKAIAIANCAFIiAjoADSAAQQsQrAEoAgBBEGpBABCoAS0AACEBIABBFhCsASgCACABQcAAIAFBwABJGyIBOgAcIAFFBEAgAEEWEKwBKAIAQQE6AA0LIABBFxCsASgCACACOgANIABBCxCsASgCAEEQakEAEKgBLQAAIQEgAEEXEKwBKAIAIAFBwAAgAUHAAEkbIgE6ABwgAUUEQCAAQRcQrAEoAgBBAToADQsL1gcBB38jAEGwAWsiAyQAAkACQAJAIAAtAAwEQCADQeg+NgJgIANB1D42AihByLIFQQA2AgBBKSADQeAAaiICIANBKGpBBHIiBBAFQciyBSgCACEBQciyBUEANgIAIAFBAUYNASADQoCAgIBwNwOoASADQbA+NgJgIANBnD42AihByLIFQQA2AgBBKiAEEA0hB0HIsgUoAgAhAUHIsgVBADYCACABQQFGBEAQBiEAEAcaDAQLIANCADcCTCADQgA3AlQgA0EQNgJcIANBzD82AixByLIFQQA2AgBBKyADQShqQZ7ZAEEXEBQhBUHIsgUoAgAhAUHIsgVBADYCAAJAAkACQAJAAkACQAJAAkACQCABQQFGDQAgACgCCCIAEIgNIQFByLIFQQA2AgBBKyAFIAAgARAUGkHIsgUoAgAhAEHIsgVBADYCACAAQQFGDQBBBBAOIQFByLIFQQA2AgBBLUEwEA0hBUHIsgUoAgAhAEHIsgVBADYCACAAQQFGDQFByLIFQQA2AgBBLiADQQhqIAQQBUHIsgUoAgAhAEHIsgVBADYCACAAQQFGDQIgAygCCCADQQhqIAMsABNBAEgbIgQQiA0iAEFwTwRAQciyBUEANgIAQS8gA0EYahAPQciyBSgCACEAQciyBUEANgIAIABBAUYNBAwMCwJAAkAgAEELTwRAQciyBUEANgIAQS0gAEEQakFwcSIIEA0hBkHIsgUoAgAhCUHIsgVBADYCACAJQQFGDQYgAyAGNgIYIAMgADYCHCADIAhBgICAgHhyNgIgDAELIAMgADoAIyADQRhqIQYgAEUNAQsgBiAEIAAQgA0aCyAAIAZqQQA6AABByLIFQQA2AgBBMCAFIANBGGpBAkH42ABBzQFBttkAEBYaQciyBSgCACEAQciyBUEANgIAQQEhBCAAQQFHBEAgASAFNgIAQciyBUEANgIAQTEgAUGs3QBBABASQciyBSgCACEAQciyBUEANgIAQQAhBCAAQQFHDQwLEAYhABAHGiADLAAjQX9MBEAgAygCGBD2DAsgAywAE0EASA0EDAULEAYhABAHGgwHCxAGIQAQBxoMBQsQBiEAEAcaDAMLEAYhABAHGkEBIQQgAywAE0EATg0CCyADKAIIEPYMCyAERQ0CCyAFEPYMCyABEBMLIANBsD42AmAgA0GcPjYCKCADQcw/NgIsIAMsAFdBf0wEQCADKAJMEPYMCyAHEOAGGiACENwGIAAQCAALIABBEGogAhCxASABNgIAIANBsAFqJAAPCxAGIQAQBxoMAQsACyACENwGIAAQCAALlRUBBn8gACABQQcQpQMhBiAAQdjUADYCAEHIsgVBADYCAEEtQSAQDSECQciyBSgCACEDQciyBUEANgIAAkACQAJAAkACQAJAAkACQAJAAkACQAJAAkACQAJAAkACQAJAIANBAUYNAEHIsgVBADYCACACIAFB9NQAEKAEIQVByLIFKAIAIQNByLIFQQA2AgAgA0EBRg0BIAJBADYCGCACQgA3AhAgAkHAzwI2AgBByLIFQQA2AgBB0M8CKAIAIgMgAkEBEAVByLIFKAIAIQRByLIFQQA2AgACQCAEQQFHBEBByLIFQQA2AgBB3AAgAkEQakEAEBUhBEHIsgUoAgAhB0HIsgVBADYCACAHQQFHDQELEAYhARAHGiACKAIYIQNByLIFQQA2AgAgAxDoAUHIsgUoAgAhA0HIsgVBADYCACADQQFHDQNBABALIQEQBxogARCEAQALIARCADcDACACQQI6ABwgAkGg0AI2AgBByLIFQQA2AgBB/AAgBiAFEAVByLIFKAIAIQJByLIFQQA2AgAgAkEBRg0AQciyBUEANgIAQS1BIBANIQJByLIFKAIAIQVByLIFQQA2AgAgBUEBRg0AQciyBUEANgIAIAIgAUGC1QAQoAQhBUHIsgUoAgAhBEHIsgVBADYCACAEQQFGDQMgAkEANgIYIAJCADcCECACQcDPAjYCAEHIsgVBADYCACADIAJBARAFQciyBSgCACEEQciyBUEANgIAAkAgBEEBRwRAQciyBUEANgIAQdwAIAJBEGpBABAVIQRByLIFKAIAIQdByLIFQQA2AgAgB0EBRw0BCxAGIQEQBxogAigCGCEDQciyBUEANgIAIAMQ6AFByLIFKAIAIQNByLIFQQA2AgAgA0EBRw0FQQAQCyEBEAcaIAEQhAEACyAEQgA3AwAgAkEBOgAcIAJBoNACNgIAQciyBUEANgIAQfwAIAYgBRAFQciyBSgCACECQciyBUEANgIAIAJBAUYNAEHIsgVBADYCAEEtQSAQDSECQciyBSgCACEFQciyBUEANgIAIAVBAUYNAEHIsgVBADYCACACIAFBktUAEKAEIQVByLIFKAIAIQRByLIFQQA2AgAgBEEBRg0FIAJBADYCGCACQgA3AhAgAkHAzwI2AgBByLIFQQA2AgAgAyACQQEQBUHIsgUoAgAhBEHIsgVBADYCAAJAIARBAUcEQEHIsgVBADYCAEHcACACQRBqQQAQFSEEQciyBSgCACEHQciyBUEANgIAIAdBAUcNAQsQBiEBEAcaIAIoAhghA0HIsgVBADYCACADEOgBQciyBSgCACEDQciyBUEANgIAIANBAUcNB0EAEAshARAHGiABEIQBAAsgBEIANwMAIAJBAToAHCACQaDQAjYCAEHIsgVBADYCAEH8ACAGIAUQBUHIsgUoAgAhAkHIsgVBADYCACACQQFGDQBByLIFQQA2AgBBLUEgEA0hAkHIsgUoAgAhBUHIsgVBADYCACAFQQFGDQBByLIFQQA2AgAgAiABQaDVABCgBCEFQciyBSgCACEEQciyBUEANgIAIARBAUYNByACQQA2AhggAkIANwIQIAJBwM8CNgIAQciyBUEANgIAIAMgAkEBEAVByLIFKAIAIQRByLIFQQA2AgACQCAEQQFHBEBByLIFQQA2AgBB3AAgAkEQakEAEBUhBEHIsgUoAgAhB0HIsgVBADYCACAHQQFHDQELEAYhARAHGiACKAIYIQNByLIFQQA2AgAgAxDoAUHIsgUoAgAhA0HIsgVBADYCACADQQFHDQlBABALIQEQBxogARCEAQALIARCADcDACACQQE6ABwgAkGg0AI2AgBByLIFQQA2AgBB/AAgBiAFEAVByLIFKAIAIQJByLIFQQA2AgAgAkEBRg0AQciyBUEANgIAQS1BIBANIQJByLIFKAIAIQVByLIFQQA2AgAgBUEBRg0AQciyBUEANgIAIAIgAUH5zAAQoAQhBUHIsgUoAgAhBEHIsgVBADYCACAEQQFGDQkgAkEANgIYIAJCADcCECACQcDPAjYCAEHIsgVBADYCACADIAJBARAFQciyBSgCACEDQciyBUEANgIAAkAgA0EBRwRAQciyBUEANgIAQdwAIAJBEGpBABAVIQNByLIFKAIAIQRByLIFQQA2AgAgBEEBRw0BCxAGIQEQBxogAigCGCEDQciyBUEANgIAIAMQ6AFByLIFKAIAIQNByLIFQQA2AgAgA0EBRw0LQQAQCyEBEAcaIAEQhAEACyADQgA3AwAgAkEDOgAcIAJBoNACNgIAQciyBUEANgIAQfwAIAYgBRAFQciyBSgCACECQciyBUEANgIAIAJBAUYNAEHIsgVBADYCAEEtQRwQDSECQciyBSgCACEDQciyBUEANgIAIANBAUYNAEHIsgVBADYCACACIAFBsdUAEKAEIQNByLIFKAIAIQVByLIFQQA2AgAgBUEBRg0LIAJBADYCGCACQgA3AhAgAkGQzAI2AgBByLIFQQA2AgBBoMwCKAIAIgUgAkEBEAVByLIFKAIAIQRByLIFQQA2AgACQCAEQQFHBEBByLIFQQA2AgBB2QAgAkEQakEAEBUhBEHIsgUoAgAhB0HIsgVBADYCACAHQQFHDQELEAYhARAHGiACKAIYIQNByLIFQQA2AgAgAxDoAUHIsgUoAgAhA0HIsgVBADYCACADQQFHDQ1BABALIQEQBxogARCEAQALIARBADoAAEHIsgVBADYCAEH8ACAGIAMQBUHIsgUoAgAhAkHIsgVBADYCACACQQFGDQBByLIFQQA2AgBBLUEcEA0hAkHIsgUoAgAhA0HIsgVBADYCACADQQFGDQBByLIFQQA2AgAgAiABQb3VABCgBCEDQciyBSgCACEEQciyBUEANgIAIARBAUYNDSACQQA2AhggAkIANwIQIAJBkMwCNgIAQciyBUEANgIAIAUgAkEBEAVByLIFKAIAIQVByLIFQQA2AgACQCAFQQFHBEBByLIFQQA2AgBB2QAgAkEQakEAEBUhBUHIsgUoAgAhBEHIsgVBADYCACAEQQFHDQELEAYhARAHGiACKAIYIQNByLIFQQA2AgAgAxDoAUHIsgUoAgAhA0HIsgVBADYCACADQQFHDQ9BABALIQEQBxogARCEAQALIAVBADoAAEHIsgVBADYCAEH8ACAGIAMQBUHIsgUoAgAhAkHIsgVBADYCACACQQFGDQBByLIFQQA2AgBBLUEwEA0hAkHIsgUoAgAhA0HIsgVBADYCACADQQFGDQBByLIFQQA2AgBB4AAgAiABQcvVAEEAQQAQEBpByLIFKAIAIQFByLIFQQA2AgAgAUEBRg0PQciyBUEANgIAQfwAIAYgAhAFQciyBSgCACEBQciyBUEANgIAIAFBAUcNEQsQBiEBEAcaDA8LEAYhARAHGgsgAhD2DAwNCxAGIQEQBxoLIAIQ9gwMCwsQBiEBEAcaCyACEPYMDAkLEAYhARAHGgsgAhD2DAwHCxAGIQEQBxoLIAIQ9gwMBQsQBiEBEAcaCyACEPYMDAMLEAYhARAHGgsgAhD2DAwBCxAGIQEQBxogAhD2DAsgBhCmAxogARAIAAsgAAuwAQIBfwF+IAAgARCsAyAAIAFBAEEBEK0DIABBHGoiAkEAEKwBKAIAQRBqQQAQqAEtAAAEQEHV1QBBABC9AQ8LIAAgAUEBQQQQrQMgACAAKAIAKAIYEQEAIAJBARCsASgCAEEQakEAEKkBKQMAIQMgAkECEKwBKAIAQRBqQQAQqQEpAwBQRQRAIAJBBxCsASgCACAAKAIYQX5BfSADUBtqQQAQwAQLIAAgAUEFQX8QrQMLagIBfwF+IABBHGoiAEEBEKwBKAIAQRBqQQAQqQEpAwAhAiAAQQUQrAEoAgAgAlA6AA0gAEECEKwBKAIAQRBqQQAQqQEpAwAhAiAAQQYQrAEoAgAgAlAiAToADSAAQQcQrAEoAgAgAToADQvrBQACQAJAAkAgAkF/aiIAQRJLDQACQAJAAkACQAJAAkACQAJAAkACQAJAIABBAWsOEgcAAQIDBAUFBQIGAgUFBwgLBQgLQTAQ/gshAEHIsgVBADYCAEGBASAAIAEQFRpByLIFKAIAIQJByLIFQQA2AgAgAkEBRw0MEAYhAhAHGgwLC0EwEP4LIQBByLIFQQA2AgBBggEgACABEBUaQciyBSgCACECQciyBUEANgIAIAJBAUcNCxAGIQIQBxoMCgtBOBD+CyEAQciyBUEANgIAQYMBIAAgASACEBQaQciyBSgCACECQciyBUEANgIAIAJBAUcNChAGIQIQBxoMCQtBMBD+CyEAQciyBUEANgIAQYQBIAAgARAVGkHIsgUoAgAhAkHIsgVBADYCACACQQFHDQkQBiECEAcaDAgLQTAQ/gshAEHIsgVBADYCAEGFASAAIAEQFRpByLIFKAIAIQJByLIFQQA2AgAgAkEBRw0IEAYhAhAHGgwHC0EwEP4LIQBByLIFQQA2AgBBhgEgACABIAIQFBpByLIFKAIAIQJByLIFQQA2AgAgAkEBRw0HEAYhAhAHGgwGC0EwEP4LIQBByLIFQQA2AgBBhwEgACABQQwQFBpByLIFKAIAIQJByLIFQQA2AgAgAkEBRw0GEAYhAhAHGgwFC0EwEP4LIQBByLIFQQA2AgBBiAEgACABEBUaQciyBSgCACEBQciyBUEANgIAIAFBAUcNARAGIQIQBxoMBAtBMBD+CyEAQciyBUEANgIAQYkBIAAgARAVGkHIsgUoAgAhAUHIsgVBADYCACABQQFGDQELIAAgAjoACAwDCxAGIQIQBxoMAQsgAkHgAXFBwABGBEAgASACEL8FDwtBACEAIAJBGHRBGHVBfkoNAUE4EP4LIQBByLIFQQA2AgBBgwEgACABIAIQFBpByLIFKAIAIQJByLIFQQA2AgAgAkEBRw0BEAYhAhAHGgsgABD2DCACEAgACyAACw0AIAAQpgMaIAAQ9gwL1gcBB38jAEGwAWsiAyQAAkACQAJAIAAtAAwEQCADQeg+NgJgIANB1D42AihByLIFQQA2AgBBKSADQeAAaiICIANBKGpBBHIiBBAFQciyBSgCACEBQciyBUEANgIAIAFBAUYNASADQoCAgIBwNwOoASADQbA+NgJgIANBnD42AihByLIFQQA2AgBBKiAEEA0hB0HIsgUoAgAhAUHIsgVBADYCACABQQFGBEAQBiEAEAcaDAQLIANCADcCTCADQgA3AlQgA0EQNgJcIANBzD82AixByLIFQQA2AgBBKyADQShqQeXZAEEXEBQhBUHIsgUoAgAhAUHIsgVBADYCAAJAAkACQAJAAkACQAJAAkACQCABQQFGDQAgACgCCCIAEIgNIQFByLIFQQA2AgBBKyAFIAAgARAUGkHIsgUoAgAhAEHIsgVBADYCACAAQQFGDQBBBBAOIQFByLIFQQA2AgBBLUEwEA0hBUHIsgUoAgAhAEHIsgVBADYCACAAQQFGDQFByLIFQQA2AgBBLiADQQhqIAQQBUHIsgUoAgAhAEHIsgVBADYCACAAQQFGDQIgAygCCCADQQhqIAMsABNBAEgbIgQQiA0iAEFwTwRAQciyBUEANgIAQS8gA0EYahAPQciyBSgCACEAQciyBUEANgIAIABBAUYNBAwMCwJAAkAgAEELTwRAQciyBUEANgIAQS0gAEEQakFwcSIIEA0hBkHIsgUoAgAhCUHIsgVBADYCACAJQQFGDQYgAyAGNgIYIAMgADYCHCADIAhBgICAgHhyNgIgDAELIAMgADoAIyADQRhqIQYgAEUNAQsgBiAEIAAQgA0aCyAAIAZqQQA6AABByLIFQQA2AgBBMCAFIANBGGpBAkG/2QBBywFB/dkAEBYaQciyBSgCACEAQciyBUEANgIAQQEhBCAAQQFHBEAgASAFNgIAQciyBUEANgIAQTEgAUGs3QBBABASQciyBSgCACEAQciyBUEANgIAQQAhBCAAQQFHDQwLEAYhABAHGiADLAAjQX9MBEAgAygCGBD2DAsgAywAE0EASA0EDAULEAYhABAHGgwHCxAGIQAQBxoMBQsQBiEAEAcaDAMLEAYhABAHGkEBIQQgAywAE0EATg0CCyADKAIIEPYMCyAERQ0CCyAFEPYMCyABEBMLIANBsD42AmAgA0GcPjYCKCADQcw/NgIsIAMsAFdBf0wEQCADKAJMEPYMCyAHEOAGGiACENwGIAAQCAALIABBEGogAhCqASABOwEAIANBsAFqJAAPCxAGIQAQBxoMAQsACyACENwGIAAQCAALoQQBBX8jAEEgayIAJABByLIFQQA2AgBBLUHgCBANIQNByLIFKAIAIQFByLIFQQA2AgACQAJAIAFBAUcEQEHIsgVBADYCACADENYDIQFByLIFKAIAIQJByLIFQQA2AgAgAkEBRw0CQcj3A0Gg2gBBABAdIQEQByECIAMQ9gwMAQtByPcDQaDaAEEAEB0hARAHIQILAkACQAJAAkBByPcDEBkgAkYEQCABEB4aIABB8PYDNgIYIAEQDBogAEGd3AA2AgBBACEBQciyBUEANgIAQf8AQcCMBEGu3AAgABASQciyBSgCACECQciyBUEANgIAIAJBAUYNAQwEC0Gg2gAQGSEEIAEQDCEDAkAgAiAERgRAQQAhAUHIsgVBADYCAEGlAUHAjAQgAxAFQciyBSgCACECQciyBUEANgIAIAJBAUYNASADIAMoAgAoAgQRAQAMBQsgAEGd3AA2AhBBACEBQciyBUEANgIAQf8AQcCMBEHy2wAgAEEQahASQciyBSgCACECQciyBUEANgIAIAJBAUcNBBAGIQEQBxpByLIFQQA2AgBBOhAKQciyBSgCACEAQciyBUEANgIAIABBAUYNAgwDCxAGIQAQBxoQFyAAEAgACxAGIQEQBxpByLIFQQA2AgBBOhAKQciyBSgCACEAQciyBUEANgIAIABBAUcNAQtBABALIQAQBxogABCEAQALIAEQCAALEBcLIABBIGokACABC+oCAQV/IwBBEGsiAiQAAkAgAEUNABDeASIDRQ0AQciyBUEANgIAQaYBIAMgAEEAQQBBAUEBQQBBAEEAQQAQH0HIsgUoAgAhAUHIsgVBADYCACABQQFHBEAgAyEBDAELQaDaAEEAEBghARAHIQRBoNoAEBkhBSABEAwhAQJAAkACQCAEIAVGBEBByLIFQQA2AgBBpQFBwIwEIAEQBUHIsgUoAgAhAEHIsgVBADYCACAAQQFGDQEgASABKAIAKAIEEQEADAMLIAJBwdoANgIAQciyBUEANgIAIAIgADYCBEH/AEHAjARBsNoAIAIQEkHIsgUoAgAhAEHIsgVBADYCACAAQQFHDQIQBiEAEAcaQciyBUEANgIAQToQCkHIsgUoAgAhAUHIsgVBADYCACABQQFHDQFBABALIQAQBxogABCEAQALEAYhABAHGhAXCyAAEAgACxAXIAMQ1wMQ9gxBACEBCyACQRBqJAAgAQu/AgEEfyMAQRBrIgIkACAABEBByLIFQQA2AgBBpwEgAEEAEAVByLIFKAIAIQFByLIFQQA2AgAgAUEBRgRAQaDaAEEAEBghARAHIQNBoNoAEBkhBCABEAwhAQJAAkACQCADIARGBEBByLIFQQA2AgBBpQFBwIwEIAEQBUHIsgUoAgAhA0HIsgVBADYCACADQQFGDQEgASABKAIAKAIEEQEADAMLIAJB4NoANgIAQciyBUEANgIAQf8AQcCMBEHV2gAgAhASQciyBSgCACEBQciyBUEANgIAIAFBAUcNAhAGIQAQBxpByLIFQQA2AgBBOhAKQciyBSgCACECQciyBUEANgIAIAJBAUcNAUEAEAshABAHGiAAEIQBAAsQBiEAEAcaEBcLIAAQCAALEBcLIAAQ1wMaIAAQ9gwLIAJBEGokAAu+AgEDfyMAQRBrIgEkAAJAAkACQAJAIABFDQBByLIFQQA2AgBBqAEgAEGQvwUQBUHIsgUoAgAhAEHIsgVBADYCACAAQQFHDQBBoNoAQQAQGCEAEAchAkGg2gAQGSEDIAAQDCEAAkAgAiADRgRAQciyBUEANgIAQaUBQcCMBCAAEAVByLIFKAIAIQJByLIFQQA2AgAgAkEBRg0DIAAgACgCACgCBBEBAAwBCyABQenaADYCAEHIsgVBADYCAEH/AEHAjARB1doAIAEQEkHIsgUoAgAhAEHIsgVBADYCACAAQQFGDQMLEBcLIAFBEGokAA8LEAYhABAHGhAXDAELEAYhABAHGkHIsgVBADYCAEE6EApByLIFKAIAIQFByLIFQQA2AgAgAUEBRw0AQQAQCyEAEAcaIAAQhAEACyAAEAgAC70CAQN/IwBBEGsiASQAAkACQAJAAkAgAEUNAEHIsgVBADYCAEGpASAAQf8AEAVByLIFKAIAIQBByLIFQQA2AgAgAEEBRw0AQaDaAEEAEBghABAHIQJBoNoAEBkhAyAAEAwhAAJAIAIgA0YEQEHIsgVBADYCAEGlAUHAjAQgABAFQciyBSgCACECQciyBUEANgIAIAJBAUYNAyAAIAAoAgAoAgQRAQAMAQsgAUH52gA2AgBByLIFQQA2AgBB/wBBwIwEQdXaACABEBJByLIFKAIAIQBByLIFQQA2AgAgAEEBRg0DCxAXCyABQRBqJAAPCxAGIQAQBxoQFwwBCxAGIQAQBxpByLIFQQA2AgBBOhAKQciyBSgCACEBQciyBUEANgIAIAFBAUcNAEEAEAshABAHGiAAEIQBAAsgABAIAAutAwEEfyMAQRBrIgEkAAJAIABFBEBBACEADAELIAAQ9QwiAA0AQQQQDiEDQciyBUEANgIAQS1BMBANIQRByLIFKAIAIQBByLIFQQA2AgACQAJAAkACQAJAIABBAUcEQEHIsgVBADYCAEEtQRAQDSEAQciyBSgCACECQciyBUEANgIAIAJBAUYNASABIAA2AgAgAUKNgICAgIKAgIB/NwIEIABBADoADSAAQdLcACkAADcABSAAQc3cACkAADcAAEHIsgVBADYCAEHIsgUoAgAhAEHIsgVBADYCAEEBIQIgAEEBRg0CQaiqBSgCACEAQciyBUEANgIAQTAgBCABIABB29wAQTpB/dwAEBYaQciyBSgCACEAQciyBUEANgIAIABBAUYNAiADIAQ2AgBBACECQciyBUEANgIAQTEgA0Gs3QBBABASQciyBSgCACEAQciyBUEANgIAIABBAUYNAgALEAYhABAHGgwDCxAGIQAQBxoMAQsQBiEAEAcaIAEsAAtBf0wEQCABKAIAEPYMCyACRQ0CCyAEEPYMCyADEBMLIAAQCAALIAFBEGokACAAC9cCAQF/IwBBEGsiByQAAkACQAJAAkAgAEUEQEEAIQAMAQtByLIFQQA2AgAgACABIAIgAyAEIAUgBhCzDSEAQciyBSgCACEEQciyBUEANgIAIARBAUcNAEGg2gBBABAYIQAQByECQaDaABAZIQMgABAMIQQCQCACIANGBEBBACEAQciyBUEANgIAQaUBQcCMBCAEEAVByLIFKAIAIQJByLIFQQA2AgAgAkEBRg0DIAQgBCgCACgCBBEBAAwBCyAHQZHbADYCAEEAIQBByLIFQQA2AgBB/wBBwIwEQdXaACAHEBJByLIFKAIAIQRByLIFQQA2AgAgBEEBRg0DCxAXCyAHQRBqJAAgAA8LEAYhABAHGhAXDAELEAYhABAHGkHIsgVBADYCAEE6EApByLIFKAIAIQdByLIFQQA2AgAgB0EBRw0AQQAQCyEAEAcaIAAQhAEACyAAEAgAC8ACAQF/IwBBEGsiBCQAAkACQAJAAkAgAEUNAEHIsgVBADYCAEGsASAAIAEgAiADEBxByLIFKAIAIQBByLIFQQA2AgAgAEEBRw0AQaDaAEEAEBghABAHIQFBoNoAEBkhAiAAEAwhAAJAIAEgAkYEQEHIsgVBADYCAEGlAUHAjAQgABAFQciyBSgCACEBQciyBUEANgIAIAFBAUYNAyAAIAAoAgAoAgQRAQAMAQsgBEGm2wA2AgBByLIFQQA2AgBB/wBBwIwEQdXaACAEEBJByLIFKAIAIQBByLIFQQA2AgAgAEEBRg0DCxAXCyAEQRBqJAAPCxAGIQAQBxoQFwwBCxAGIQAQBxpByLIFQQA2AgBBOhAKQciyBSgCACEEQciyBUEANgIAIARBAUcNAEEAEAshABAHGiAAEIQBAAsgABAIAAvAAgEBfyMAQRBrIgQkAAJAAkACQAJAIABFDQBByLIFQQA2AgBBrQEgACABIAIgAxAcQciyBSgCACEAQciyBUEANgIAIABBAUcNAEGg2gBBABAYIQAQByEBQaDaABAZIQIgABAMIQACQCABIAJGBEBByLIFQQA2AgBBpQFBwIwEIAAQBUHIsgUoAgAhAUHIsgVBADYCACABQQFGDQMgACAAKAIAKAIEEQEADAELIARBxdsANgIAQciyBUEANgIAQf8AQcCMBEHV2gAgBBASQciyBSgCACEAQciyBUEANgIAIABBAUYNAwsQFwsgBEEQaiQADwsQBiEAEAcaEBcMAQsQBiEAEAcaQciyBUEANgIAQToQCkHIsgUoAgAhBEHIsgVBADYCACAEQQFHDQBBABALIQAQBxogABCEAQALIAAQCAAL3wIBAX8jAEEQayIEJAACQAJAAkACQCAARQRAQQAhAAwBC0HIsgVBADYCAEGuASAAIAEgAiADQX9Bf0EAQQBBARBEQciyBSgCACEBQciyBUEANgIAQQEhACABQQFHDQBBoNoAQQAQGCEAEAchAkGg2gAQGSEDIAAQDCEBAkAgAiADRgRAQQAhAEHIsgVBADYCAEGlAUHAjAQgARAFQciyBSgCACECQciyBUEANgIAIAJBAUYNAyABIAEoAgAoAgQRAQAMAQsgBEHj2wA2AgBBACEAQciyBUEANgIAQf8AQcCMBEHV2gAgBBASQciyBSgCACEBQciyBUEANgIAIAFBAUYNAwsQFwsgBEEQaiQAIAAPCxAGIQAQBxoQFwwBCxAGIQAQBxpByLIFQQA2AgBBOhAKQciyBSgCACEEQciyBUEANgIAIARBAUcNAEEAEAshABAHGiAAEIQBAAsgABAIAAsMACAABEAgABD2DAsL/gMBBH8jAEEQayIEJAAgACgCACIDIAJJBEBBBBAOIQBByLIFQQA2AgBBLUEwEA0hAkHIsgUoAgAhA0HIsgVBADYCAAJAAkACQAJAAkAgA0EBRwRAQciyBUEANgIAQS1BIBANIQNByLIFKAIAIQFByLIFQQA2AgAgAUEBRg0BIAQgAzYCACAEQpOAgICAhICAgH83AgQgA0EAOgATIANBy90AKAAANgAPIANBxN0AKQAANwAIIANBvN0AKQAANwAAQciyBUEANgIAQTAgAiAEQcQAQdDdAEElQfLdABAWGkHIsgUoAgAhA0HIsgVBADYCAEEBIQEgA0EBRg0CIAAgAjYCAEHIsgVBADYCAEExIABBrN0AQQAQEkHIsgUoAgAhA0HIsgVBADYCAEEAIQEgA0EBRg0CAAsQBiEDEAcaDAMLEAYhAxAHGgwBCxAGIQMQBxogBCwAC0F/TARAIAQoAgAQ9gwLIAFFDQILIAIQ9gwLIAAQEwsgAxAIAAsCQCAAKAIEIANHBEAgACgCCCEFDAELIAAgA0EBIANBAUsbIgNBAXQ2AgQgACAAKAIIIANBA3QQ6gEiBTYCCCAAKAIAIQMLIAUgAkECdCIGaiIFQQRqIAUgAyACa0ECdBCCDSAAKAIIIAZqIAE2AgAgACAAKAIAQQFqNgIAIARBEGokAAu1AwEDfyMAQRBrIgIkAAJAQQAgAEUgARsNACAAIAEQ9wwhAyABRQ0AIAMNAEEEEA4hAEHIsgVBADYCAEEtQTAQDSEDQciyBSgCACEBQciyBUEANgIAAkACQAJAAkACQCABQQFHBEBByLIFQQA2AgBBLUEQEA0hAUHIsgUoAgAhBEHIsgVBADYCACAEQQFGDQEgAiABNgIAIAJCjYCAgICCgICAfzcCBCABQQA6AA0gAUHS3AApAAA3AAUgAUHN3AApAAA3AABByLIFQQA2AgBByLIFKAIAIQFByLIFQQA2AgBBASEEIAFBAUYNAkGoqgUoAgAhAUHIsgVBADYCAEEwIAMgAiABQdvcAEHSAEH53QAQFhpByLIFKAIAIQFByLIFQQA2AgAgAUEBRg0CIAAgAzYCAEEAIQRByLIFQQA2AgBBMSAAQazdAEEAEBJByLIFKAIAIQFByLIFQQA2AgAgAUEBRg0CAAsQBiEBEAcaDAMLEAYhARAHGgwBCxAGIQEQBxogAiwAC0F/TARAIAIoAgAQ9gwLIARFDQILIAMQ9gwLIAAQEwsgARAIAAsgAkEQaiQAIAMLnQMBAX8gACABQQAQggMhASAAQgA3A4ABIABBjN4ANgIAIABCADcCbCAAQgA3AnRByLIFQQA2AgBBrwEgAUGw3gBBAUEBEBxByLIFKAIAIQJByLIFQQA2AgACQCACQQFGDQBByLIFQQA2AgBBrwEgAUG13gBBAEEBEBxByLIFKAIAIQJByLIFQQA2AgAgAkEBRg0AQciyBUEANgIAQa8BIAFBut4AQQBBABAcQciyBSgCACECQciyBUEANgIAIAJBAUYNAEHIsgVBADYCAEGvASABQb/eAEEAQQAQHEHIsgUoAgAhAkHIsgVBADYCACACQQFGDQBByLIFQQA2AgBBrwEgAUHE3gBBAEEAEBxByLIFKAIAIQJByLIFQQA2AgAgAkEBRg0AQciyBUEANgIAQa8BIAFByd4AQQBBABAcQciyBSgCACECQciyBUEANgIAIAJBAUYNAEHIsgVBADYCAEGvASABQc7eAEEAQQAQHEHIsgUoAgAhAkHIsgVBADYCACACQQFGDQAgAA8LEAYhABAHGiABEIQDGiAAEAgAC7gBACAAIABBtd4AEJIDIgE2AmwgAQRAIAAgACgCBEEAQb/eABCHAyIBNgJ4IAEgADYCQCABQoABNwMgIABB4ABqIAEgACgCYBDpASAAIAAoAgRBABCwAzcDcCAAKAJsIgEgASgCACgCFBEBACAAIAAoAgRBABCwAzcDgAEgACgCeCIBIAEoAgAoAhQRAQALIABB4ABqIAAQ7QEQkQEoAgAiASAAKAIEQbreABDfAyABKAIAKAIQEQIAC6wDAQR/IwBBEGsiAiQAIABB4ABqIQEgACgCYCEAAkADQCAAQX9qIgBBAEgNAUG63gAgASAAEJEBKAIAQShqEIMGDQALIAJBEGokACAADwtBBBAOIQBByLIFQQA2AgBBLUEsEA0hBEHIsgUoAgAhAUHIsgVBADYCAAJAAkACQAJAAkAgAUEBRwRAQciyBUEANgIAQS1BIBANIQFByLIFKAIAIQNByLIFQQA2AgAgA0EBRg0BIAIgATYCACACQpeAgICAhICAgH83AgQgAUEAOgAXIAFBiN8AKQAANwAPIAFBgd8AKQAANwAIIAFB+d4AKQAANwAAQciyBUEANgIAQTIgBCACQdPeAEGMAUGR3wAQEBpByLIFKAIAIQFByLIFQQA2AgBBASEDIAFBAUcEQCAAIAQ2AgBByLIFQQA2AgBBMSAAQaDaAEEAEBJByLIFKAIAIQFByLIFQQA2AgBBACEDIAFBAUcNBgsQBiEBEAcaIAIsAAtBf0wEQCACKAIAEPYMCyADDQIMBAsQBiEBEAcaDAILEAYhARAHGgsgBBD2DAsgABATCyABEAgLAAuUAgICfwN+IAAoAmwEQCAAKAIEQQAQsAMhBiAAKAIEIAApA3BBABCxAyAAKAJsIgEgASgCACgCFBEBACAAKAIEQQAQsAMhBAJAIAApA4ABIgUgBFQEQCAAKAJ4IgEgASkDICAFIAR9fDcDIAwBCyAFIARYBEAgACgCeCEBDAELIAAoAngiASABKQMgIAUgBH18NwMgCyABIAEoAgAoAhQRAQAgACgCBCAGQQAQsQMLIABB4ABqIgMgABDtASIBEJEBKAIAIgIgACgCBEG63gAQ3wMgAigCACgCHBECACABQQFqIgEgACgCYCICSQRAA0AgAyABEJEBKAIAIgAgACgCACgCFBEBACABQQFqIgEgAkcNAAsLC8ILAQN/IAAgAUHM3wAQggMhASAAQdzfADYCAEHIsgVBADYCAEEtQRwQDSECQciyBSgCACEDQciyBUEANgIAAkACQAJAAkACQAJAAkACQAJAAkACQCADQQFGDQBByLIFQQA2AgAgAiABQYDgABCgBBpByLIFKAIAIQNByLIFQQA2AgAgA0EBRg0BIAJBADYCGCACQgA3AhAgAkGgzQI2AgBByLIFQQA2AgBBsM0CKAIAIAJBARAFQciyBSgCACEDQciyBUEANgIAAkAgA0EBRwRAQciyBUEANgIAQd4AIAJBEGpBABAVIQNByLIFKAIAIQRByLIFQQA2AgAgBEEBRw0BCxAGIQAQBxogAigCGCEDQciyBUEANgIAIAMQ6AFByLIFKAIAIQNByLIFQQA2AgAgA0EBRw0DQQAQCyEAEAcaIAAQhAEACyADQQA7AQAgACACNgJsQciyBUEANgIAQS1BHBANIQJByLIFKAIAIQNByLIFQQA2AgAgA0EBRg0AQciyBUEANgIAIAIgAUGN4AAQoAQaQciyBSgCACEDQciyBUEANgIAIANBAUYNAyACQQA2AhggAkIANwIQIAJBkMwCNgIAQciyBUEANgIAQaDMAigCACACQQEQBUHIsgUoAgAhA0HIsgVBADYCAAJAIANBAUcEQEHIsgVBADYCAEHZACACQRBqQQAQFSEDQciyBSgCACEEQciyBUEANgIAIARBAUcNAQsQBiEAEAcaIAIoAhghA0HIsgVBADYCACADEOgBQciyBSgCACEDQciyBUEANgIAIANBAUcNBUEAEAshABAHGiAAEIQBAAsgA0EAOgAAIAAgAjYCcEHIsgVBADYCAEEtQRQQDSECQciyBSgCACEDQciyBUEANgIAIANBAUYNAEHIsgVBADYCACACIAFBn+AAQf8BEOEEGkHIsgUoAgAhA0HIsgVBADYCACADQQFGDQUgACACNgJ0QciyBUEANgIAQS1BHBANIQJByLIFKAIAIQNByLIFQQA2AgAgA0EBRg0AQciyBUEANgIAIAIgAUGo4AAQoAQaQciyBSgCACEDQciyBUEANgIAIANBAUYNBiACQQA2AhggAkIANwIQIAJB4M4CNgIAQciyBUEANgIAQfDOAigCACACQQEQBUHIsgUoAgAhA0HIsgVBADYCAAJAIANBAUcEQEHIsgVBADYCAEH7ACACQRBqQQAQFSEDQciyBSgCACEEQciyBUEANgIAIARBAUcNAQsQBiEAEAcaIAIoAhghA0HIsgVBADYCACADEOgBQciyBSgCACEDQciyBUEANgIAIANBAUcNCEEAEAshABAHGiAAEIQBAAsgA0EANgIAIAAgAjYCeEHIsgVBADYCAEEtQTAQDSECQciyBSgCACEDQciyBUEANgIAIANBAUYNAEHIsgVBADYCAEHgACACIAFBr+AAQQBBABAQGkHIsgUoAgAhA0HIsgVBADYCACADQQFGDQggACACNgJ8IAAoAmwhAkHIsgVBADYCAEHbACABIAIQBUHIsgUoAgAhAkHIsgVBADYCACACQQFGDQAgACgCcCECQciyBUEANgIAQdsAIAEgAhAFQciyBSgCACECQciyBUEANgIAIAJBAUYNACAAKAJ0IQJByLIFQQA2AgBB2wAgASACEAVByLIFKAIAIQJByLIFQQA2AgAgAkEBRg0AIAAoAnghAkHIsgVBADYCAEHbACABIAIQBUHIsgUoAgAhAkHIsgVBADYCACACQQFGDQAgACgCfCECQciyBUEANgIAQdsAIAEgAhAFQciyBSgCACECQciyBUEANgIAIAJBAUcNCgsQBiEAEAcaDAgLEAYhABAHGgsgAhD2DAwGCxAGIQAQBxoLIAIQ9gwMBAsQBiEAEAcaIAIQ9gwMAwsQBiEAEAcaCyACEPYMDAELEAYhABAHGiACEPYMCyABEIQDGiAAEAgACyAACxkAIAAoAnwgACgCIEF4akEAEMAEIAAQjQMLhwYBAn8gACABIAIQggMhAiAAQcDgADYCAEHIsgVBADYCAEEtQRwQDSEBQciyBSgCACEDQciyBUEANgIAAkACQAJAAkACQAJAAkAgA0EBRg0AQciyBUEANgIAIAEgAkHk4AAQoAQaQciyBSgCACEDQciyBUEANgIAIANBAUYNASABQQA2AhggAUIANwIQIAFBkMwCNgIAQciyBUEANgIAQaDMAigCACABQQEQBUHIsgUoAgAhA0HIsgVBADYCAAJAIANBAUcEQEHIsgVBADYCAEHZACABQRBqQQAQFSEDQciyBSgCACEEQciyBUEANgIAIARBAUcNAQsQBiEAEAcaIAEoAhghA0HIsgVBADYCACADEOgBQciyBSgCACEDQciyBUEANgIAIANBAUcNA0EAEAshABAHGiAAEIQBAAsgA0EAOgAAIAAgATYCbEHIsgVBADYCAEEtQRwQDSEBQciyBSgCACEDQciyBUEANgIAIANBAUYNAEHIsgVBADYCACABIAJB7OAAEKAEGkHIsgUoAgAhA0HIsgVBADYCACADQQFGDQMgAUEANgIYIAFCADcCECABQYDOAjYCAEHIsgVBADYCAEGQzgIoAgAgAUEBEAVByLIFKAIAIQNByLIFQQA2AgACQCADQQFHBEBByLIFQQA2AgBB+wAgAUEQakEAEBUhA0HIsgUoAgAhBEHIsgVBADYCACAEQQFHDQELEAYhABAHGiABKAIYIQNByLIFQQA2AgAgAxDoAUHIsgUoAgAhA0HIsgVBADYCACADQQFHDQVBABALIQAQBxogABCEAQALIANBADYCACAAIAE2AnAgACgCbCEBQciyBUEANgIAQdsAIAIgARAFQciyBSgCACEBQciyBUEANgIAIAFBAUYNACAAKAJwIQFByLIFQQA2AgBB2wAgAiABEAVByLIFKAIAIQFByLIFQQA2AgAgAUEBRw0GCxAGIQAQBxoMBAsQBiEAEAcaCyABEPYMDAILEAYhABAHGgsgARD2DAsgAhCEAxogABAIAAsLwQEAIAAgASACEIIDIQEgAEH84AA2AgBByLIFQQA2AgBBrwEgAUGg4QBBAEEBEBxByLIFKAIAIQJByLIFQQA2AgACQCACQQFGDQBByLIFQQA2AgBBrwEgAUGl4QBBAEEBEBxByLIFKAIAIQJByLIFQQA2AgAgAkEBRg0AQciyBUEANgIAQa8BIAFBzN8AQQFBABAcQciyBSgCACECQciyBUEANgIAIAJBAUYNACAADwsQBiEAEAcaIAEQhAMaIAAQCAALxAgBA38jAEEQayIDJAAgACABQarhABDxASAAQbjhADYCAEHIsgVBADYCAEEtQRwQDSEBQciyBSgCACECQciyBUEANgIAAkACQAJAAkACQAJAAkACQAJAIAJBAUYNAEHIsgVBADYCACABIABB3OEAEKAEGkHIsgUoAgAhAkHIsgVBADYCACACQQFGDQEgAUEANgIYIAFCADcCECABQeDOAjYCAEHIsgVBADYCAEHwzgIoAgAgAUEBEAVByLIFKAIAIQJByLIFQQA2AgACQCACQQFHBEBByLIFQQA2AgBB+wAgAUEQakEAEBUhAkHIsgUoAgAhBEHIsgVBADYCACAEQQFHDQELEAYhAxAHGiABKAIYIQJByLIFQQA2AgAgAhDoAUHIsgUoAgAhAkHIsgVBADYCACACQQFHDQNBABALIQAQBxogABCEAQALIAJBADYCACAAIAE2AnRByLIFQQA2AgBBLUEwEA0hAUHIsgUoAgAhAkHIsgVBADYCACACQQFGDQBByLIFQQA2AgBB4AAgASAAQebhAEEEQQAQEBpByLIFKAIAIQJByLIFQQA2AgAgAkEBRg0DIAAgATYCeEHIsgVBADYCAEEtQTAQDSEBQciyBSgCACECQciyBUEANgIAIAJBAUYNAEHIsgVBADYCAEHgACABIABB8uEAQQxBABAQGkHIsgUoAgAhAkHIsgVBADYCACACQQFGDQQgACABNgJ8QciyBUEANgIAQS1BMBANIQFByLIFKAIAIQJByLIFQQA2AgAgAkEBRg0AQciyBUEANgIAQeAAIAEgAEGl4QBBAUEAEBAaQciyBSgCACECQciyBUEANgIAIAJBAUYNBSAAIAE2AoABIAAoAnQhAUHIsgVBADYCAEHbACAAIAEQBUHIsgUoAgAhAUHIsgVBADYCACABQQFGDQAgACgCeCEBQciyBUEANgIAQdsAIAAgARAFQciyBSgCACEBQciyBUEANgIAIAFBAUYNACAAKAJ8IQFByLIFQQA2AgBB2wAgACABEAVByLIFKAIAIQFByLIFQQA2AgAgAUEBRg0AIAAoAoABIQFByLIFQQA2AgBB2wAgACABEAVByLIFKAIAIQFByLIFQQA2AgAgAUEBRg0AIANB7cilkwc2AgwgACgCeCEBQciyBUEANgIAQbYBIAEgA0EMakEEQQAQHEHIsgUoAgAhAUHIsgVBADYCACABQQFGDQYgA0EAOgALIAAoAoABIQFByLIFQQA2AgBBtgEgASADQQtqQQFBABAcQciyBSgCACEBQciyBUEANgIAIAFBAUYNByADQRBqJAAgAA8LEAYhAxAHGgwHCxAGIQMQBxoLIAEQ9gwMBQsQBiEDEAcaIAEQ9gwMBAsQBiEDEAcaIAEQ9gwMAwsQBiEDEAcaIAEQ9gwMAgsQBiEDEAcaDAELEAYhAxAHGgsgABCEAxogAxAIAAsaACAAKAKAASAAKAIgQWhqQQAQwAQgABCNAwvUAQEBfyAAIAFBoOEAEPEBIABBhOIANgIAQciyBUEANgIAQS1BMBANIQFByLIFKAIAIQJByLIFQQA2AgACQAJAAkAgAkEBRwRAQciyBUEANgIAQeAAIAEgAEGo4gBBAEEAEBAaQciyBSgCACECQciyBUEANgIAIAJBAUYNASAAIAE2AnRByLIFQQA2AgBB2wAgACABEAVByLIFKAIAIQFByLIFQQA2AgAgAUEBRw0DCxAGIQIQBxoMAQsQBiECEAcaIAEQ9gwLIAAQhAMaIAIQCAALIAALGQAgACgCdCAAKAIgQXxqQQAQwAQgABCNAwvUAQEBfyAAIAFBpeEAEPEBIABBuOIANgIAQciyBUEANgIAQS1BMBANIQFByLIFKAIAIQJByLIFQQA2AgACQAJAAkAgAkEBRwRAQciyBUEANgIAQeAAIAEgAEGo4gBBAEEAEBAaQciyBSgCACECQciyBUEANgIAIAJBAUYNASAAIAE2AnRByLIFQQA2AgBB2wAgACABEAVByLIFKAIAIQFByLIFQQA2AgAgAUEBRw0DCxAGIQIQBxoMAQsQBiECEAcaIAEQ9gwLIAAQhAMaIAIQCAALIAAL1AEBAX8gACABIAIQggMhAiAAQeTiADYCAEHIsgVBADYCAEEtQTAQDSEBQciyBSgCACEDQciyBUEANgIAAkACQAJAIANBAUcEQEHIsgVBADYCAEHgACABIAJBqOIAQQBBABAQGkHIsgUoAgAhA0HIsgVBADYCACADQQFGDQEgACABNgJsQciyBUEANgIAQdsAIAIgARAFQciyBSgCACEBQciyBUEANgIAIAFBAUcNAwsQBiEAEAcaDAELEAYhABAHGiABEPYMCyACEIQDGiAAEAgACyAACxYAIAAoAmwgACgCIEEAEMAEIAAQjQMLGQAgACABQazlABCCAxogAEG85QA2AgAgAAuzAwEEfyMAQRBrIgIkACAAKAJAKAJAIgFFBEBBBBAOIQBByLIFQQA2AgBBLUEsEA0hBEHIsgUoAgAhAUHIsgVBADYCAAJAAkACQAJAAkAgAUEBRwRAQciyBUEANgIAQS1BIBANIQFByLIFKAIAIQNByLIFQQA2AgAgA0EBRg0BIAIgATYCACACQp2AgICAhICAgH83AgQgAUEAOgAdIAFB9eUAKQAANwAVIAFB8OUAKQAANwAQIAFB6OUAKQAANwAIIAFB4OUAKQAANwAAQciyBUEANgIAQTIgBCACQf7lAEElQaTmABAQGkHIsgUoAgAhAUHIsgVBADYCAEEBIQMgAUEBRg0CIAAgBDYCAEHIsgVBADYCAEExIABBoNoAQQAQEkHIsgUoAgAhAUHIsgVBADYCAEEAIQMgAUEBRg0CAAsQBiEBEAcaDAMLEAYhARAHGgwBCxAGIQEQBxogAiwAC0F/TARAIAIoAgAQ9gwLIANFDQILIAQQ9gwLIAAQEwsgARAIAAsgAEGu5gBBs+YAIAFBKGoQrQVBqeYAEK0FRhtBAEEBEJwDIAAQjQMgAkEQaiQAC/4EAQF/IAAgAUHg5gAQggMhASAAQfDmADYCAEHIsgVBADYCAEGvASABQZTnAEEAQQEQHEHIsgUoAgAhAkHIsgVBADYCAAJAIAJBAUYNAEHIsgVBADYCAEGvASABQZnnAEEAQQEQHEHIsgUoAgAhAkHIsgVBADYCACACQQFGDQBByLIFQQA2AgBBrwEgAUGe5wBBAEEBEBxByLIFKAIAIQJByLIFQQA2AgAgAkEBRg0AQciyBUEANgIAQa8BIAFBo+cAQQBBABAcQciyBSgCACECQciyBUEANgIAIAJBAUYNAEHIsgVBADYCAEGvASABQajnAEEAQQEQHEHIsgUoAgAhAkHIsgVBADYCACACQQFGDQBByLIFQQA2AgBBrwEgAUGt5wBBAEEBEBxByLIFKAIAIQJByLIFQQA2AgAgAkEBRg0AQciyBUEANgIAQa8BIAFBsucAQQBBARAcQciyBSgCACECQciyBUEANgIAIAJBAUYNAEHIsgVBADYCAEGvASABQbfnAEEAQQEQHEHIsgUoAgAhAkHIsgVBADYCACACQQFGDQBByLIFQQA2AgBBrwEgAUG85wBBAEEBEBxByLIFKAIAIQJByLIFQQA2AgAgAkEBRg0AQciyBUEANgIAQa8BIAFBwecAQQBBARAcQciyBSgCACECQciyBUEANgIAIAJBAUYNAEHIsgVBADYCAEGvASABQcbnAEEAQQEQHEHIsgUoAgAhAkHIsgVBADYCACACQQFGDQBByLIFQQA2AgBBrwEgAUHL5wBBAEEBEBxByLIFKAIAIQJByLIFQQA2AgAgAkEBRg0AIAAPCxAGIQAQBxogARCEAxogABAIAAtlAQR/IAAoAlQEQCAAQdQAaiEDIABB4ABqIQQDQCAAKAIEIAAgAyABEIUDKAIAKAIAEIcDIgIgADYCQCAEIAIgACgCYBDpASACIAIoAgAoAggRAQAgAUEBaiIBIAAoAlRJDQALCwucEQEEfyAAIAEgAhCCAyEBIABBgOgANgIAQciyBUEANgIAQccBIAEgAUGk6ABBBhAcQciyBSgCACECQciyBUEANgIAAkACQAJAAkACQAJAAkACQAJAAkACQAJAAkACQCACQQFGDQBByLIFQQA2AgBBLUEcEA0hAkHIsgUoAgAhBEHIsgVBADYCACAEQQFGDQBByLIFQQA2AgAgAiABQa7oABCgBCEFQciyBSgCACEEQciyBUEANgIAIARBAUYNASACQQA2AhggAkIANwIQIAJBoM0CNgIAQciyBUEANgIAQbDNAigCACIEIAJBARAFQciyBSgCACEDQciyBUEANgIAAkAgA0EBRwRAQciyBUEANgIAQd4AIAJBEGpBABAVIQNByLIFKAIAIQZByLIFQQA2AgAgBkEBRw0BCxAGIQQQBxogAigCGCEAQciyBUEANgIAIAAQ6AFByLIFKAIAIQBByLIFQQA2AgAgAEEBRw0DQQAQCyEBEAcaIAEQhAEACyADQQA7AQBByLIFQQA2AgBB2wAgASAFEAVByLIFKAIAIQJByLIFQQA2AgAgAkEBRg0AQciyBUEANgIAQccBIAEgAUHB6ABBEBAcQciyBSgCACECQciyBUEANgIAIAJBAUYNAEHIsgVBADYCAEEtQRwQDSECQciyBSgCACEFQciyBUEANgIAIAVBAUYNAEHIsgVBADYCACACIAFBy+gAEKAEIQVByLIFKAIAIQNByLIFQQA2AgAgA0EBRg0DIAJBADYCGCACQgA3AhAgAkGgzQI2AgBByLIFQQA2AgAgBCACQQEQBUHIsgUoAgAhA0HIsgVBADYCAAJAIANBAUcEQEHIsgVBADYCAEHeACACQRBqQQAQFSEDQciyBSgCACEGQciyBUEANgIAIAZBAUcNAQsQBiEEEAcaIAIoAhghAEHIsgVBADYCACAAEOgBQciyBSgCACEAQciyBUEANgIAIABBAUcNBUEAEAshARAHGiABEIQBAAsgA0EAOwEAQciyBUEANgIAQdsAIAEgBRAFQciyBSgCACECQciyBUEANgIAIAJBAUYNAEHIsgVBADYCAEEtQRwQDSECQciyBSgCACEFQciyBUEANgIAIAVBAUYNAEHIsgVBADYCACACIAFB0egAEKAEIQVByLIFKAIAIQNByLIFQQA2AgAgA0EBRg0FIAJBADYCGCACQgA3AhAgAkGgzQI2AgBByLIFQQA2AgAgBCACQQEQBUHIsgUoAgAhA0HIsgVBADYCAAJAIANBAUcEQEHIsgVBADYCAEHeACACQRBqQQAQFSEDQciyBSgCACEGQciyBUEANgIAIAZBAUcNAQsQBiEEEAcaIAIoAhghAEHIsgVBADYCACAAEOgBQciyBSgCACEAQciyBUEANgIAIABBAUcNB0EAEAshARAHGiABEIQBAAsgA0EAOwEAQciyBUEANgIAQdsAIAEgBRAFQciyBSgCACECQciyBUEANgIAIAJBAUYNAEHIsgVBADYCAEHHASABIAFB2OgAQQ4QHEHIsgUoAgAhAkHIsgVBADYCACACQQFGDQBByLIFQQA2AgBBLUEkEA0hAkHIsgUoAgAhBUHIsgVBADYCACAFQQFGDQdByLIFQQA2AgBB/QAgAiABQeLoAEEAQQBBABAWIQVByLIFKAIAIQNByLIFQQA2AgAgA0EBRg0IIAJBAToADyACQSA2AhRByLIFQQA2AgBByAEgBUHx6ABBABASQciyBSgCACEFQciyBUEANgIAIAVBAUYNB0HIsgVBADYCAEHbACABIAIQBUHIsgUoAgAhAkHIsgVBADYCACACQQFGDQdByLIFQQA2AgBBLUEcEA0hAkHIsgUoAgAhBUHIsgVBADYCACAFQQFGDQdByLIFQQA2AgAgAiABQfLoABCgBCEFQciyBSgCACEDQciyBUEANgIAIANBAUYNCSACQQA2AhggAkIANwIQIAJBoM0CNgIAQciyBUEANgIAIAQgAkEBEAVByLIFKAIAIQNByLIFQQA2AgACQCADQQFHBEBByLIFQQA2AgBB3gAgAkEQakEAEBUhA0HIsgUoAgAhBkHIsgVBADYCACAGQQFHDQELEAYhBBAHGiACKAIYIQBByLIFQQA2AgAgABDoAUHIsgUoAgAhAEHIsgVBADYCACAAQQFHDQtBABALIQEQBxogARCEAQALIANBADsBAEHIsgVBADYCAEHbACABIAUQBUHIsgUoAgAhAkHIsgVBADYCACACQQFGDQdByLIFQQA2AgBBLUEcEA0hAkHIsgUoAgAhBUHIsgVBADYCACAFQQFGDQdByLIFQQA2AgAgAiABQfjoABCgBCEFQciyBSgCACEDQciyBUEANgIAIANBAUYNCyACQQA2AhggAkIANwIQIAJBoM0CNgIAQciyBUEANgIAIAQgAkEBEAVByLIFKAIAIQRByLIFQQA2AgACQCAEQQFHBEBByLIFQQA2AgBB3gAgAkEQakEAEBUhBEHIsgUoAgAhA0HIsgVBADYCACADQQFHDQELEAYhBBAHGiACKAIYIQBByLIFQQA2AgAgABDoAUHIsgUoAgAhAEHIsgVBADYCACAAQQFHDQ1BABALIQEQBxogARCEAQALIARBADsBAEHIsgVBADYCAEHbACABIAUQBUHIsgUoAgAhAkHIsgVBADYCACACQQFGDQdByLIFQQA2AgBBrwEgAUGF6QBBAEEBEBxByLIFKAIAIQJByLIFQQA2AgAgAkEBRg0HIAAPCxAGIQQQBxoMDAsQBiEEEAcaCyACEPYMDAoLEAYhBBAHGgsgAhD2DAwICxAGIQQQBxoLIAIQ9gwMBgsQBiEEEAcaDAULEAYhBBAHGiACEPYMDAQLEAYhBBAHGgsgAhD2DAwCCxAGIQQQBxoLIAIQ9gwLIAEQhAMaIAQQCAALdQAgABCJAyAAQcgAaiIAQQEQrAEoAgBBAUEAEN0BIABBBRCsASgCAEEAOgAMIABBBRCsASgCAEHMjARBDkEAEL8EIABBBRCsASgCAEEBOgAMIABBBxCsASgCAEIYQQAQowQgAEEIEKwBKAIAQv//A0EAEKMEC88BAQJ/IAAgAUG06QAQggMhASAAQcTpADYCAEHIsgVBADYCAEEtQTAQDSECQciyBSgCACEDQciyBUEANgIAAkACQAJAIANBAUcEQEHIsgVBADYCAEHgACACIAFB6OkAQQBBABAQGkHIsgUoAgAhA0HIsgVBADYCACADQQFGDQFByLIFQQA2AgBB2wAgASACEAVByLIFKAIAIQJByLIFQQA2AgAgAkEBRw0DCxAGIQAQBxoMAQsQBiEAEAcaIAIQ9gwLIAEQhAMaIAAQCAALIAALHwAgAEHIAGpBABCsASgCACAAKAIgQQAQwAQgABCNAwuyDQEFfyAAIAFBmOoAEIIDIQEgAEGo6gA2AgBByLIFQQA2AgBBxwEgASABQczqAEEGEBxByLIFKAIAIQJByLIFQQA2AgACQAJAAkACQAJAAkACQAJAAkACQCACQQFGDQBByLIFQQA2AgBBLUEcEA0hAkHIsgUoAgAhA0HIsgVBADYCACADQQFGDQBByLIFQQA2AgAgAiABQdbqABCgBCEFQciyBSgCACEDQciyBUEANgIAIANBAUYNASACQQA2AhggAkIANwIQIAJBoM0CNgIAQciyBUEANgIAQbDNAigCACIDIAJBARAFQciyBSgCACEEQciyBUEANgIAAkAgBEEBRwRAQciyBUEANgIAQd4AIAJBEGpBABAVIQRByLIFKAIAIQZByLIFQQA2AgAgBkEBRw0BCxAGIQAQBxogAigCGCEDQciyBUEANgIAIAMQ6AFByLIFKAIAIQNByLIFQQA2AgAgA0EBRw0DQQAQCyEBEAcaIAEQhAEACyAEQQA7AQBByLIFQQA2AgBB2wAgASAFEAVByLIFKAIAIQJByLIFQQA2AgAgAkEBRg0AQciyBUEANgIAQccBIAEgAUHp6gBBEBAcQciyBSgCACECQciyBUEANgIAIAJBAUYNAEHIsgVBADYCAEEtQRwQDSECQciyBSgCACEFQciyBUEANgIAIAVBAUYNAEHIsgVBADYCACACIAFB8+oAEKAEIQVByLIFKAIAIQRByLIFQQA2AgAgBEEBRg0DIAJBADYCGCACQgA3AhAgAkGgzQI2AgBByLIFQQA2AgAgAyACQQEQBUHIsgUoAgAhBEHIsgVBADYCAAJAIARBAUcEQEHIsgVBADYCAEHeACACQRBqQQAQFSEEQciyBSgCACEGQciyBUEANgIAIAZBAUcNAQsQBiEAEAcaIAIoAhghA0HIsgVBADYCACADEOgBQciyBSgCACEDQciyBUEANgIAIANBAUcNBUEAEAshARAHGiABEIQBAAsgBEEAOwEAQciyBUEANgIAQdsAIAEgBRAFQciyBSgCACECQciyBUEANgIAIAJBAUYNAEHIsgVBADYCAEEtQRwQDSECQciyBSgCACEFQciyBUEANgIAIAVBAUYNAEHIsgVBADYCACACIAFB+eoAEKAEIQVByLIFKAIAIQRByLIFQQA2AgAgBEEBRg0FIAJBADYCGCACQgA3AhAgAkGgzQI2AgBByLIFQQA2AgAgAyACQQEQBUHIsgUoAgAhA0HIsgVBADYCAAJAIANBAUcEQEHIsgVBADYCAEHeACACQRBqQQAQFSEDQciyBSgCACEEQciyBUEANgIAIARBAUcNAQsQBiEAEAcaIAIoAhghA0HIsgVBADYCACADEOgBQciyBSgCACEDQciyBUEANgIAIANBAUcNB0EAEAshARAHGiABEIQBAAsgA0EAOwEAQciyBUEANgIAQdsAIAEgBRAFQciyBSgCACECQciyBUEANgIAIAJBAUYNAEHIsgVBADYCAEHHASABIAFBgOsAQQ4QHEHIsgUoAgAhAkHIsgVBADYCACACQQFGDQBByLIFQQA2AgBBLUEkEA0hAkHIsgUoAgAhA0HIsgVBADYCACADQQFGDQdByLIFQQA2AgBB/QAgAiABQYrrAEEAQQBBABAWIQNByLIFKAIAIQVByLIFQQA2AgAgBUEBRg0IIAJBAToADyACQSA2AhRByLIFQQA2AgBByAEgA0GZ6wBBABASQciyBSgCACEDQciyBUEANgIAIANBAUYNB0HIsgVBADYCAEHbACABIAIQBUHIsgUoAgAhAkHIsgVBADYCACACQQFGDQdByLIFQQA2AgBBxwEgASABQajrAEEEEBxByLIFKAIAIQJByLIFQQA2AgAgAkEBRg0HQciyBUEANgIAQa8BIAFBsusAQQFBARAcQciyBSgCACECQciyBUEANgIAIAJBAUYNB0HIsgVBADYCAEGvASABQbfrAEEAQQEQHEHIsgUoAgAhAkHIsgVBADYCACACQQFGDQdByLIFQQA2AgBBrwEgAUG86wBBAEEBEBxByLIFKAIAIQJByLIFQQA2AgAgAkEBRg0HQciyBUEANgIAQa8BIAFBwesAQQBBARAcQciyBSgCACECQciyBUEANgIAIAJBAUYNByAADwsQBiEAEAcaDAgLEAYhABAHGgsgAhD2DAwGCxAGIQAQBxoLIAIQ9gwMBAsQBiEAEAcaCyACEPYMDAILEAYhABAHGgwBCxAGIQAQBxogAhD2DAsgARCEAxogABAIAAuEAQAgABCJAyAAQcgAaiIAQQEQrAEoAgBBAUEAEN0BIABBBRCsASgCAEEAOgAMIABBBRCsASgCAEHajARBDkEAEL8EIABBBRCsASgCAEEBOgAMIABBBxCsASgCAEEAOgAMIABBBxCsASgCAEHojARBBEEAEL8EIABBBxCsASgCAEEBOgAMC5MNAQV/IAAgAUHw6wAQggMhASAAQYDsADYCAEHIsgVBADYCAEHHASABIAFBpOwAQQYQHEHIsgUoAgAhAkHIsgVBADYCAAJAAkACQAJAAkACQAJAAkACQAJAAkAgAkEBRg0AQciyBUEANgIAQS1BHBANIQJByLIFKAIAIQNByLIFQQA2AgAgA0EBRg0AQciyBUEANgIAIAIgAUGu7AAQoAQhBUHIsgUoAgAhA0HIsgVBADYCACADQQFGDQEgAkEANgIYIAJCADcCECACQaDNAjYCAEHIsgVBADYCAEGwzQIoAgAiAyACQQEQBUHIsgUoAgAhBEHIsgVBADYCAAJAIARBAUcEQEHIsgVBADYCAEHeACACQRBqQQAQFSEEQciyBSgCACEGQciyBUEANgIAIAZBAUcNAQsQBiEAEAcaIAIoAhghA0HIsgVBADYCACADEOgBQciyBSgCACEDQciyBUEANgIAIANBAUcNA0EAEAshARAHGiABEIQBAAsgBEEAOwEAQciyBUEANgIAQdsAIAEgBRAFQciyBSgCACECQciyBUEANgIAIAJBAUYNAEHIsgVBADYCAEHHASABIAFBwewAQQgQHEHIsgUoAgAhAkHIsgVBADYCACACQQFGDQBByLIFQQA2AgBBLUEcEA0hAkHIsgUoAgAhBUHIsgVBADYCACAFQQFGDQBByLIFQQA2AgAgAiABQcvsABCgBCEFQciyBSgCACEEQciyBUEANgIAIARBAUYNAyACQQA2AhggAkIANwIQIAJBoM0CNgIAQciyBUEANgIAIAMgAkEBEAVByLIFKAIAIQRByLIFQQA2AgACQCAEQQFHBEBByLIFQQA2AgBB3gAgAkEQakEAEBUhBEHIsgUoAgAhBkHIsgVBADYCACAGQQFHDQELEAYhABAHGiACKAIYIQNByLIFQQA2AgAgAxDoAUHIsgUoAgAhA0HIsgVBADYCACADQQFHDQVBABALIQEQBxogARCEAQALIARBADsBAEHIsgVBADYCAEHbACABIAUQBUHIsgUoAgAhAkHIsgVBADYCACACQQFGDQBByLIFQQA2AgBBLUEcEA0hAkHIsgUoAgAhBUHIsgVBADYCACAFQQFGDQBByLIFQQA2AgAgAiABQdjsABCgBCEFQciyBSgCACEEQciyBUEANgIAIARBAUYNBSACQQA2AhggAkIANwIQIAJBoM0CNgIAQciyBUEANgIAIAMgAkEBEAVByLIFKAIAIQRByLIFQQA2AgACQCAEQQFHBEBByLIFQQA2AgBB3gAgAkEQakEAEBUhBEHIsgUoAgAhBkHIsgVBADYCACAGQQFHDQELEAYhABAHGiACKAIYIQNByLIFQQA2AgAgAxDoAUHIsgUoAgAhA0HIsgVBADYCACADQQFHDQdBABALIQEQBxogARCEAQALIARBADsBAEHIsgVBADYCAEHbACABIAUQBUHIsgUoAgAhAkHIsgVBADYCACACQQFGDQBByLIFQQA2AgBBxwEgASABQePsAEEEEBxByLIFKAIAIQJByLIFQQA2AgAgAkEBRg0AQciyBUEANgIAQS1BHBANIQJByLIFKAIAIQVByLIFQQA2AgAgBUEBRg0AQciyBUEANgIAIAIgAUHt7AAQoAQhBUHIsgUoAgAhBEHIsgVBADYCACAEQQFGDQcgAkEANgIYIAJCADcCECACQaDNAjYCAEHIsgVBADYCACADIAJBARAFQciyBSgCACEDQciyBUEANgIAAkAgA0EBRwRAQciyBUEANgIAQd4AIAJBEGpBABAVIQNByLIFKAIAIQRByLIFQQA2AgAgBEEBRw0BCxAGIQAQBxogAigCGCEDQciyBUEANgIAIAMQ6AFByLIFKAIAIQNByLIFQQA2AgAgA0EBRw0JQQAQCyEBEAcaIAEQhAEACyADQQA7AQBByLIFQQA2AgBB2wAgASAFEAVByLIFKAIAIQJByLIFQQA2AgAgAkEBRg0AQciyBUEANgIAQccBIAEgAUH67ABBAhAcQciyBSgCACECQciyBUEANgIAIAJBAUYNAEHIsgVBADYCAEGvASABQYTtAEEBQQEQHEHIsgUoAgAhAkHIsgVBADYCACACQQFHDQoLEAYhABAHGgwICxAGIQAQBxoLIAIQ9gwMBgsQBiEAEAcaCyACEPYMDAQLEAYhABAHGgsgAhD2DAwCCxAGIQAQBxoLIAIQ9gwLIAEQhAMaIAAQCAALIAALQAAgABCJAyAAQcgAaiIAQQEQrAEoAgBBAUEAEN0BIABBAxCsASgCAEECQQAQ3QEgAEEEEKwBKAIAQRBBABDdAQv6AQEBfyAAIAEgAhCCAyEBIABBuO0ANgIAQciyBUEANgIAQdEBIAEQD0HIsgUoAgAhAkHIsgVBADYCAAJAAkACQAJAIAJBAUYNAEHIsgVBADYCAEEtQSQQDSECQciyBSgCACEDQciyBUEANgIAIANBAUYNAEHIsgVBADYCAEH9ACACIAFB3O0AQQBBAEEAEBYaQciyBSgCACEDQciyBUEANgIAIANBAUYNAUHIsgVBADYCAEHbACABIAIQBUHIsgUoAgAhAkHIsgVBADYCACACQQFHDQMLEAYhABAHGgwBCxAGIQAQBxogAhD2DAsgARCEAxogABAIAAsgAAslACAAQQBBAhCOAyAAEKADQQFxRQRAIABBAkF/EI4DCyAAEJADC0gBA38gAEHIAGpBAhCsASgCACICQRhqQQAQiQIoAgAhASAAIAAQoAMiA0H+//8HcSADQQFyIAEbEKEDIAIgAUU6AA0gABCVAwuvCAEIfyMAQbABayICJAACQAJAAkAgACgCACABTQRAIAJB6D42AmAgAkHUPjYCKEHIsgVBADYCAEEpIAJB4ABqIgYgAkEoakEEciIEEAVByLIFKAIAIQNByLIFQQA2AgAgA0EBRg0BIAJCgICAgHA3A6gBIAJBsD42AmAgAkGcPjYCKEHIsgVBADYCAEEqIAQQDSEHQciyBSgCACEDQciyBUEANgIAIANBAUYEQBAGIQEQBxoMBAsgAkIANwJMIAJCADcCVCACQRA2AlwgAkHMPzYCLEHIsgVBADYCAEErIAJBKGpBjO4AQRUQFCEFQciyBSgCACEDQciyBUEANgIAAkACQAJAAkACQAJAAkACQAJAIANBAUYNAEHIsgVBADYCAEEsIAUgARAVIQNByLIFKAIAIQFByLIFQQA2AgAgAUEBRg0AQciyBUEANgIAQSsgA0Gi7gBBBBAUIQNByLIFKAIAIQFByLIFQQA2AgAgAUEBRg0AIAAoAgAhAUHIsgVBADYCAEEsIAMgARAVGkHIsgUoAgAhAUHIsgVBADYCACABQQFGDQBBBBAOIQBByLIFQQA2AgBBLUEwEA0hA0HIsgUoAgAhAUHIsgVBADYCACABQQFGDQFByLIFQQA2AgBBLiACQQhqIAQQBUHIsgUoAgAhAUHIsgVBADYCACABQQFGDQIgAigCCCACQQhqIAIsABNBAEgbIgQQiA0iAUFwTwRAQciyBUEANgIAQS8gAkEYahAPQciyBSgCACEBQciyBUEANgIAIAFBAUYNBAwMCwJAAkAgAUELTwRAQciyBUEANgIAQS0gAUEQakFwcSIIEA0hBUHIsgUoAgAhCUHIsgVBADYCACAJQQFGDQYgAiAFNgIYIAIgATYCHCACIAhBgICAgHhyNgIgDAELIAIgAToAIyACQRhqIQUgAUUNAQsgBSAEIAEQgA0aCyABIAVqQQA6AABByLIFQQA2AgBBMCADIAJBGGpBxABBsu4AQYoBQafuABAWGkHIsgUoAgAhAUHIsgVBADYCAEEBIQQgAUEBRwRAIAAgAzYCAEHIsgVBADYCAEExIABBrN0AQQAQEkHIsgUoAgAhAUHIsgVBADYCAEEAIQQgAUEBRw0MCxAGIQEQBxogAiwAI0F/TARAIAIoAhgQ9gwLIAIsABNBAEgNBAwFCxAGIQEQBxoMBwsQBiEBEAcaDAULEAYhARAHGgwDCxAGIQEQBxpBASEEIAIsABNBAE4NAgsgAigCCBD2DAsgBEUNAgsgAxD2DAsgABATCyACQbA+NgJgIAJBnD42AiggAkHMPzYCLCACLABXQX9MBEAgAigCTBD2DAsgBxDgBhogBhDcBiABEAgACyAAKAIIIQAgAkGwAWokACAAIAFBAnRqDwsQBiEBEAcaDAELAAsgBhDcBiABEAgAC9gWAQV/IAAgASACEIIDIQEgAEHg7gA2AgBByLIFQQA2AgBBxwEgASABQYTvAEEGEBxByLIFKAIAIQNByLIFQQA2AgACQAJAIANBAUYNAEHIsgVBADYCAEEtQRwQDSEDQciyBSgCACEEQciyBUEANgIAIARBAUYNAEHIsgVBADYCACADIAFBju8AEKAEIQZByLIFKAIAIQRByLIFQQA2AgACQAJAAkACQAJAAkACQAJAAkACQAJAAkACQAJAAkAgBEEBRwRAIANBADYCGCADQgA3AhAgA0GgzQI2AgBByLIFQQA2AgBBsM0CKAIAIgQgA0EBEAVByLIFKAIAIQVByLIFQQA2AgACQCAFQQFHBEBByLIFQQA2AgBB3gAgA0EQakEAEBUhBUHIsgUoAgAhB0HIsgVBADYCACAHQQFHDQELEAYhBBAHGiADKAIYIQBByLIFQQA2AgAgABDoAUHIsgUoAgAhAEHIsgVBADYCACAAQQFHDQJBABALIQEQBxogARCEAQALIAVBADsBAEHIsgVBADYCAEHbACABIAYQBUHIsgUoAgAhA0HIsgVBADYCACADQQFGDRBByLIFQQA2AgBBLUEcEA0hA0HIsgUoAgAhBkHIsgVBADYCACAGQQFGDRBByLIFQQA2AgAgAyABQaHvABCgBCEGQciyBSgCACEFQciyBUEANgIAIAVBAUYNAiADQQA2AhggA0IANwIQIANBoM0CNgIAQciyBUEANgIAIAQgA0EBEAVByLIFKAIAIQVByLIFQQA2AgACQCAFQQFHBEBByLIFQQA2AgBB3gAgA0EQakEAEBUhBUHIsgUoAgAhB0HIsgVBADYCACAHQQFHDQELEAYhBBAHGiADKAIYIQBByLIFQQA2AgAgABDoAUHIsgUoAgAhAEHIsgVBADYCACAAQQFHDQRBABALIQEQBxogARCEAQALIAVBADsBAEHIsgVBADYCAEHbACABIAYQBUHIsgUoAgAhA0HIsgVBADYCACADQQFGDRBByLIFQQA2AgBBxwEgASABQa7vAEEGEBxByLIFKAIAIQNByLIFQQA2AgAgA0EBRg0QQciyBUEANgIAQS1BHBANIQNByLIFKAIAIQZByLIFQQA2AgAgBkEBRg0QQciyBUEANgIAIAMgAUG47wAQoAQhBkHIsgUoAgAhBUHIsgVBADYCACAFQQFGDQQgA0EANgIYIANCADcCECADQaDNAjYCAEHIsgVBADYCACAEIANBARAFQciyBSgCACEFQciyBUEANgIAAkAgBUEBRwRAQciyBUEANgIAQd4AIANBEGpBABAVIQVByLIFKAIAIQdByLIFQQA2AgAgB0EBRw0BCxAGIQQQBxogAygCGCEAQciyBUEANgIAIAAQ6AFByLIFKAIAIQBByLIFQQA2AgAgAEEBRw0GQQAQCyEBEAcaIAEQhAEACyAFQQA7AQBByLIFQQA2AgBB2wAgASAGEAVByLIFKAIAIQNByLIFQQA2AgAgA0EBRg0QQciyBUEANgIAQS1BHBANIQNByLIFKAIAIQZByLIFQQA2AgAgBkEBRg0QQciyBUEANgIAIAMgAUHB7wAQoAQhBkHIsgUoAgAhBUHIsgVBADYCACAFQQFGDQYgA0EANgIYIANCADcCECADQaDNAjYCAEHIsgVBADYCACAEIANBARAFQciyBSgCACEFQciyBUEANgIAAkAgBUEBRwRAQciyBUEANgIAQd4AIANBEGpBABAVIQVByLIFKAIAIQdByLIFQQA2AgAgB0EBRw0BCxAGIQQQBxogAygCGCEAQciyBUEANgIAIAAQ6AFByLIFKAIAIQBByLIFQQA2AgAgAEEBRw0IQQAQCyEBEAcaIAEQhAEACyAFQQA7AQBByLIFQQA2AgBB2wAgASAGEAVByLIFKAIAIQNByLIFQQA2AgAgA0EBRg0QQciyBUEANgIAQS1BHBANIQNByLIFKAIAIQZByLIFQQA2AgAgBkEBRg0QQciyBUEANgIAIAMgAUHM7wAQoAQhBkHIsgUoAgAhBUHIsgVBADYCACAFQQFGDQggA0EANgIYIANCADcCECADQaDNAjYCAEHIsgVBADYCACAEIANBARAFQciyBSgCACEFQciyBUEANgIAAkAgBUEBRwRAQciyBUEANgIAQd4AIANBEGpBABAVIQVByLIFKAIAIQdByLIFQQA2AgAgB0EBRw0BCxAGIQQQBxogAygCGCEAQciyBUEANgIAIAAQ6AFByLIFKAIAIQBByLIFQQA2AgAgAEEBRw0KQQAQCyEBEAcaIAEQhAEACyAFQQA7AQBByLIFQQA2AgBB2wAgASAGEAVByLIFKAIAIQNByLIFQQA2AgAgA0EBRg0QQciyBUEANgIAQS1BHBANIQNByLIFKAIAIQZByLIFQQA2AgAgBkEBRg0QQciyBUEANgIAIAMgAUHa7wAQoAQhBkHIsgUoAgAhBUHIsgVBADYCACAFQQFGDQogA0EANgIYIANCADcCECADQaDNAjYCAEHIsgVBADYCACAEIANBARAFQciyBSgCACEEQciyBUEANgIAAkAgBEEBRwRAQciyBUEANgIAQd4AIANBEGpBABAVIQRByLIFKAIAIQVByLIFQQA2AgAgBUEBRw0BCxAGIQQQBxogAygCGCEAQciyBUEANgIAIAAQ6AFByLIFKAIAIQBByLIFQQA2AgAgAEEBRw0MQQAQCyEBEAcaIAEQhAEACyAEQQA7AQBByLIFQQA2AgBB2wAgASAGEAVByLIFKAIAIQNByLIFQQA2AgAgA0EBRg0QQciyBUEANgIAQS1BHBANIQNByLIFKAIAIQRByLIFQQA2AgAgBEEBRg0QQciyBUEANgIAIAMgAUHl7wAQoAQhBEHIsgUoAgAhBkHIsgVBADYCACAGQQFGDQwgA0EANgIYIANCADcCECADQeDOAjYCAEHIsgVBADYCAEHwzgIoAgAgA0EBEAVByLIFKAIAIQZByLIFQQA2AgACQCAGQQFHBEBByLIFQQA2AgBB+wAgA0EQakEAEBUhBkHIsgUoAgAhBUHIsgVBADYCACAFQQFHDQELEAYhBBAHGiADKAIYIQBByLIFQQA2AgAgABDoAUHIsgUoAgAhAEHIsgVBADYCACAAQQFHDQ5BABALIQEQBxogARCEAQALIAZBADYCAEHIsgVBADYCAEHbACABIAQQBUHIsgUoAgAhA0HIsgVBADYCACADQQFGDRBByLIFQQA2AgAgAhCtBSEDQciyBSgCACEEQciyBUEANgIAIARBAUYNEEHIsgVBADYCAEHv7wAQrQUhBEHIsgUoAgAhBkHIsgVBADYCACAGQQFGDRAgAyAERw0OQciyBUEANgIAQa8BIAFB9O8AQQFBARAcQciyBSgCACEDQciyBUEANgIAIANBAUYNEEHIsgVBADYCAEGvASABQfnvAEEAQQEQHEHIsgUoAgAhA0HIsgVBADYCACADQQFHDQ8MEAsQBiEEEAcaCyADEPYMDA8LEAYhBBAHGgsgAxD2DAwNCxAGIQQQBxoLIAMQ9gwMCwsQBiEEEAcaCyADEPYMDAkLEAYhBBAHGgsgAxD2DAwHCxAGIQQQBxoLIAMQ9gwMBQsQBiEEEAcaCyADEPYMDAMLQciyBUEANgIAIAIQrQUhA0HIsgUoAgAhBEHIsgVBADYCACAEQQFGDQFByLIFQQA2AgBB/u8AEK0FIQRByLIFKAIAIQJByLIFQQA2AgAgAkEBRg0BIAMgBEcNAEHIsgVBADYCAEGvASABQf7vAEEAQQAQHEHIsgUoAgAhA0HIsgVBADYCACADQQFGDQELIAAPCxAGIQQQBxoLIAEQhAMaIAQQCAAL1QgBBX8CQAJAAkAgAUUNAEEcEP4LIQJByLIFQQA2AgAgAiAAQYPwABCgBCEFQciyBSgCACEEQciyBUEANgIAIARBAUYNASACQQA2AhggAkIANwIQIAJB4M4CNgIAQciyBUEANgIAQfDOAigCACIEIAJBARAFQciyBSgCACEDQciyBUEANgIAAkAgA0EBRwRAQciyBUEANgIAQfsAIAJBEGpBABAVIQNByLIFKAIAIQZByLIFQQA2AgAgBkEBRw0BCxAGIQAQBxogAigCGCEBQciyBUEANgIAIAEQ6AFByLIFKAIAIQFByLIFQQA2AgAgAUEBRw0DQQAQCyECEAcaIAIQhAEACyADQQA2AgAgACAFEIwDQRwQ/gshAkHIsgVBADYCACACIABBlPAAEKAEIQVByLIFKAIAIQNByLIFQQA2AgACQAJAAkAgA0EBRwRAIAJBADYCGCACQgA3AhAgAkHgzgI2AgBByLIFQQA2AgAgBCACQQEQBUHIsgUoAgAhA0HIsgVBADYCAAJAIANBAUcEQEHIsgVBADYCAEH7ACACQRBqQQAQFSEDQciyBSgCACEGQciyBUEANgIAIAZBAUcNAQsQBiEAEAcaIAIoAhghAUHIsgVBADYCACABEOgBQciyBSgCACEBQciyBUEANgIAIAFBAUcNB0EAEAshAhAHGiACEIQBAAsgA0EANgIAIAAgBRCMA0EcEP4LIQJByLIFQQA2AgAgAiAAQaPwABCgBCEFQciyBSgCACEDQciyBUEANgIAIANBAUYNASACQQA2AhggAkIANwIQIAJB4M4CNgIAQciyBUEANgIAIAQgAkEBEAVByLIFKAIAIQNByLIFQQA2AgACQCADQQFHBEBByLIFQQA2AgBB+wAgAkEQakEAEBUhA0HIsgUoAgAhBkHIsgVBADYCACAGQQFHDQELEAYhABAHGiACKAIYIQFByLIFQQA2AgAgARDoAUHIsgUoAgAhAUHIsgVBADYCACABQQFHDQdBABALIQIQBxogAhCEAQALIANBADYCACAAIAUQjANBHBD+CyECQciyBUEANgIAIAIgAEGx8AAQoAQhBUHIsgUoAgAhA0HIsgVBADYCACADQQFGDQIgAkEANgIYIAJCADcCECACQeDOAjYCAEHIsgVBADYCACAEIAJBARAFQciyBSgCACEEQciyBUEANgIAIARBAUcEQEHIsgVBADYCAEH7ACACQRBqQQAQFSEEQciyBSgCACEDQciyBUEANgIAIANBAUcNBAsQBiEAEAcaIAIoAhghAUHIsgVBADYCACABEOgBQciyBSgCACEBQciyBUEANgIAIAFBAUcNBkEAEAshAhAHGiACEIQBAAsQBiEAEAcaDAULEAYhABAHGgwECxAGIQAQBxoMAwsgBEEANgIAIAAgBRCMAyABQQJHDQAgACAAQcDwAEEUEJsDCw8LEAYhABAHGgsgAhD2DCAAEAgAC5UBACAAEIkDIABByABqIgBBARCsASgCAEEBQQAQ3QEgAEECEKwBKAIAQQBBABDdASAAQQMQrAEoAgBBADoADCAAQQMQrAEoAgBByvAAQQZBABC/BCAAQQMQrAEoAgBBAToADCAAQQQQrAEoAgBBAkEAEN0BIABBBRCsASgCAEEQQQAQ3QEgAEEGEKwBKAIAQQBBABDdAQulBAECfwJAAkACQCAAKAJAQShqEK0FQdDwABCtBUcEQCAAQcgAaiICQQAQrAEoAgAiAQRAIAEgASgCACgCBBEBAAsgAkEBEKwBKAIAIgEEQCABIAEoAgAoAgQRAQALIAJBAhCsASgCACIBBEAgASABKAIAKAIEEQEACyACQQMQrAEoAgAiAQRAIAEgASgCACgCBBEBAAsgAkEEEKwBKAIAIgEEQCABIAEoAgAoAgQRAQALIAJBBRCsASgCACIBBEAgASABKAIAKAIEEQEACyACQQYQrAEoAgAiAQRAIAEgASgCACgCBBEBAAsgAkEHEKwBKAIAIgEEQCABIAEoAgAoAgQRAQALIAJBCBCsASgCACIBBEAgASABKAIAKAIEEQEACyACQQgQjgIgAkEHEI4CIAJBBhCOAiACQQUQjgIgAkEEEI4CIAJBAxCOAiACQQIQjgIgAkEBEI4CIAJBABCOAiAAQShqEK0FQf7vABCtBUYEQEEwEP4LIQIgACgCICEBQciyBUEANgIAQeAAIAIgAEHV8AAgAUEAEBAaQciyBSgCACEBQciyBUEANgIAIAFBAUYNBCAAIAIQjAMgAEEAQX8QjgMLIAAoAlQNAQwCCyAAQQBBAxCOAyAAIABByABqQQIQrAEoAgBBABCiBKdB/wFxEIsCIABBA0F/EI4DIAAoAlRFDQELIAAQjwMLIAAQkAMPCxAGIQAQBxogAhD2DCAAEAgAC9MIAQh/IwBBsAFrIgIkAAJAAkACQCAAKAIAIgMgAU0EQCACQeg+NgJgIAJB1D42AihByLIFQQA2AgBBKSACQeAAaiIGIAJBKGpBBHIiBBAFQciyBSgCACEDQciyBUEANgIAIANBAUYNASACQoCAgIBwNwOoASACQbA+NgJgIAJBnD42AihByLIFQQA2AgBBKiAEEA0hB0HIsgUoAgAhA0HIsgVBADYCACADQQFGBEAQBiEBEAcaDAQLIAJCADcCTCACQgA3AlQgAkEQNgJcIAJBzD82AixByLIFQQA2AgBBKyACQShqQYzxAEEVEBQhBUHIsgUoAgAhA0HIsgVBADYCAAJAAkACQAJAAkACQAJAAkACQCADQQFGDQBByLIFQQA2AgBBLCAFIAEQFSEDQciyBSgCACEBQciyBUEANgIAIAFBAUYNAEHIsgVBADYCAEErIANBovEAQQQQFCEDQciyBSgCACEBQciyBUEANgIAIAFBAUYNACAAKAIAIQFByLIFQQA2AgBBLCADIAEQFRpByLIFKAIAIQFByLIFQQA2AgAgAUEBRg0AQQQQDiEAQciyBUEANgIAQS1BMBANIQNByLIFKAIAIQFByLIFQQA2AgAgAUEBRg0BQciyBUEANgIAQS4gAkEIaiAEEAVByLIFKAIAIQFByLIFQQA2AgAgAUEBRg0CIAIoAgggAkEIaiACLAATQQBIGyIEEIgNIgFBcE8EQEHIsgVBADYCAEEvIAJBGGoQD0HIsgUoAgAhAUHIsgVBADYCACABQQFGDQQMDAsCQAJAIAFBC08EQEHIsgVBADYCAEEtIAFBEGpBcHEiCBANIQVByLIFKAIAIQlByLIFQQA2AgAgCUEBRg0GIAIgBTYCGCACIAE2AhwgAiAIQYCAgIB4cjYCIAwBCyACIAE6ACMgAkEYaiEFIAFFDQELIAUgBCABEIANGgsgASAFakEAOgAAQciyBUEANgIAQTAgAyACQRhqQcQAQafxAEHrAEHN8QAQFhpByLIFKAIAIQFByLIFQQA2AgBBASEEIAFBAUcEQCAAIAM2AgBByLIFQQA2AgBBMSAAQazdAEEAEBJByLIFKAIAIQFByLIFQQA2AgBBACEEIAFBAUcNDAsQBiEBEAcaIAIsACNBf0wEQCACKAIYEPYMCyACLAATQQBIDQQMBQsQBiEBEAcaDAcLEAYhARAHGgwFCxAGIQEQBxoMAwsQBiEBEAcaQQEhBCACLAATQQBODQILIAIoAggQ9gwLIARFDQILIAMQ9gwLIAAQEwsgAkGwPjYCYCACQZw+NgIoIAJBzD82AiwgAiwAV0F/TARAIAIoAkwQ9gwLIAcQ4AYaIAYQ3AYgARAIAAsgACADQX9qIgM2AgAgAyABSwRAIAAoAgggAUECdGoiACAAQQRqIAMgAWtBAnQQgg0LIAJBsAFqJAAPCxAGIQEQBxoMAQsACyAGENwGIAEQCAALmwcBBH8gACABIAIQggMhAiAAQdzxADYCAEHIsgVBADYCAEEtQRwQDSEBQciyBSgCACEDQciyBUEANgIAAkACQAJAAkACQAJAAkACQCADQQFGDQBByLIFQQA2AgAgASACQYDyABCgBCEDQciyBSgCACEEQciyBUEANgIAIARBAUYNASABQQA2AhggAUIANwIQIAFB4M4CNgIAQciyBUEANgIAQfDOAigCACIEIAFBARAFQciyBSgCACEFQciyBUEANgIAAkAgBUEBRwRAQciyBUEANgIAQfsAIAFBEGpBABAVIQVByLIFKAIAIQZByLIFQQA2AgAgBkEBRw0BCxAGIQAQBxogASgCGCEDQciyBUEANgIAIAMQ6AFByLIFKAIAIQNByLIFQQA2AgAgA0EBRw0DQQAQCyEBEAcaIAEQhAEACyAFQQA2AgAgAUEBOgANQciyBUEANgIAQdsAIAIgAxAFQciyBSgCACEDQciyBUEANgIAIANBAUYNAEHIsgVBADYCAEEtQSAQDSEDQciyBSgCACEFQciyBUEANgIAIAVBAUYNA0HIsgVBADYCACADIAJBi/IAIAEQxQQhBUHIsgUoAgAhAUHIsgVBADYCACABQQFGDQRByLIFQQA2AgBB2wAgAiADEAVByLIFKAIAIQFByLIFQQA2AgAgAUEBRg0DQciyBUEANgIAQS1BHBANIQFByLIFKAIAIQZByLIFQQA2AgAgBkEBRg0DIAMoAgQhA0HIsgVBADYCACABIANBk/IAEKAEIQNByLIFKAIAIQZByLIFQQA2AgAgBkEBRg0FIAFBADYCGCABQgA3AhAgAUHgzgI2AgBByLIFQQA2AgAgBCABQQEQBUHIsgUoAgAhBEHIsgVBADYCAAJAIARBAUcEQEHIsgVBADYCAEH7ACABQRBqQQAQFSEEQciyBSgCACEGQciyBUEANgIAIAZBAUcNAQsQBiEAEAcaIAEoAhghA0HIsgVBADYCACADEOgBQciyBSgCACEDQciyBUEANgIAIANBAUcNB0EAEAshARAHGiABEIQBAAsgBEEANgIAQciyBUEANgIAQd8AIAUgAxAFQciyBSgCACEBQciyBUEANgIAIAFBAUYNAyAADwsQBiEAEAcaDAYLEAYhABAHGgsgARD2DAwECxAGIQAQBxoMAwsQBiEAEAcaIAMQ9gwMAgsQBiEAEAcaCyABEPYMCyACEIQDGiAAEAgAC0UBAX8gAEHIAGoiAUEAEKwBKAIAQQA6AAwgAUEAEKwBKAIAIAApAyBCAoinQQAQ1wEgAUEAEKwBKAIAQQE6AAwgABCNAwuUCQEGfyAAIAFByPIAEIIDIQEgAEHY8gA2AgBByLIFQQA2AgBB0QEgARAPQciyBSgCACECQciyBUEANgIAAkACQAJAAkACQAJAAkACQAJAAkAgAkEBRg0AQciyBUEANgIAQccBIAEgAUH88gBBARAcQciyBSgCACECQciyBUEANgIAIAJBAUYNAEHIsgVBADYCAEEtQRwQDSECQciyBSgCACEDQciyBUEANgIAIANBAUYNAUHIsgVBADYCACACIAFBhfMAEKAEIQNByLIFKAIAIQRByLIFQQA2AgAgBEEBRg0CIAJBADYCGCACQgA3AhAgAkHgzgI2AgBByLIFQQA2AgBB8M4CKAIAIAJBARAFQciyBSgCACEEQciyBUEANgIAAkAgBEEBRwRAQciyBUEANgIAQfsAIAJBEGpBABAVIQRByLIFKAIAIQVByLIFQQA2AgAgBUEBRw0BCxAGIQAQBxogAigCGCEDQciyBUEANgIAIAMQ6AFByLIFKAIAIQNByLIFQQA2AgAgA0EBRw0EQQAQCyEBEAcaIAEQhAEACyAEQQA2AgBByLIFQQA2AgBB2wAgASADEAVByLIFKAIAIQNByLIFQQA2AgAgA0EBRg0BQciyBUEANgIAQS1BIBANIQNByLIFKAIAIQRByLIFQQA2AgAgBEEBRg0EQciyBUEANgIAIAMgAUGS8wAgAhDFBCEEQciyBSgCACECQciyBUEANgIAIAJBAUYNBUHIsgVBADYCAEEtQRwQDSECQciyBSgCACEFQciyBUEANgIAIAVBAUYNBEHIsgVBADYCACACIAFBm/MAEKAEIQVByLIFKAIAIQZByLIFQQA2AgAgBkEBRg0GIAJBADYCGCACQgA3AhAgAkHAzwI2AgBByLIFQQA2AgBB0M8CKAIAIAJBARAFQciyBSgCACEGQciyBUEANgIAAkAgBkEBRwRAQciyBUEANgIAQdwAIAJBEGpBABAVIQZByLIFKAIAIQdByLIFQQA2AgAgB0EBRw0BCxAGIQAQBxogAigCGCEDQciyBUEANgIAIAMQ6AFByLIFKAIAIQNByLIFQQA2AgAgA0EBRw0IQQAQCyEBEAcaIAEQhAEACyAGQgA3AwBByLIFQQA2AgBB3wAgBCAFEAVByLIFKAIAIQJByLIFQQA2AgAgAkEBRg0EQciyBUEANgIAQS1BJBANIQJByLIFKAIAIQVByLIFQQA2AgAgBUEBRg0EQciyBUEANgIAQf0AIAIgAUGl8wBBAUEAQQAQFhpByLIFKAIAIQVByLIFQQA2AgAgBUEBRg0IQciyBUEANgIAQd8AIAQgAhAFQciyBSgCACECQciyBUEANgIAIAJBAUYNBEHIsgVBADYCAEHbACABIAMQBUHIsgUoAgAhAkHIsgVBADYCACACQQFGDQQgAA8LEAYhABAHGgwICxAGIQAQBxoMBwsQBiEAEAcaCyACEPYMDAULEAYhABAHGgwECxAGIQAQBxogAxD2DAwDCxAGIQAQBxoLIAIQ9gwMAQsQBiEAEAcaIAIQ9gwLIAEQhAMaIAAQCAALCQAgAEEBEJ8DC+kJAQV/IAAgAUHU8wAQggMhASAAQeTzADYCAEHIsgVBADYCAEEtQSQQDSECQciyBSgCACEDQciyBUEANgIAAkACQAJAAkACQAJAAkACQAJAAkAgA0EBRg0AQciyBUEANgIAQf0AIAIgAUGI9ABBAEEAQQAQFhpByLIFKAIAIQNByLIFQQA2AgAgA0EBRg0BIAJBBDYCFEHIsgVBADYCAEHbACABIAIQBUHIsgUoAgAhAkHIsgVBADYCACACQQFGDQBByLIFQQA2AgBBLUEcEA0hAkHIsgUoAgAhA0HIsgVBADYCACADQQFGDQBByLIFQQA2AgAgAiABQZv0ABCgBCEFQciyBSgCACEDQciyBUEANgIAIANBAUYNAiACQQA2AhggAkIANwIQIAJBoM0CNgIAQciyBUEANgIAQbDNAigCACIDIAJBARAFQciyBSgCACEEQciyBUEANgIAAkAgBEEBRwRAQciyBUEANgIAQd4AIAJBEGpBABAVIQRByLIFKAIAIQZByLIFQQA2AgAgBkEBRw0BCxAGIQAQBxogAigCGCEDQciyBUEANgIAIAMQ6AFByLIFKAIAIQNByLIFQQA2AgAgA0EBRw0EQQAQCyEBEAcaIAEQhAEACyAEQQA7AQBByLIFQQA2AgBB2wAgASAFEAVByLIFKAIAIQJByLIFQQA2AgAgAkEBRg0AQciyBUEANgIAQS1BHBANIQJByLIFKAIAIQVByLIFQQA2AgAgBUEBRg0AQciyBUEANgIAIAIgAUGq9AAQoAQhBUHIsgUoAgAhBEHIsgVBADYCACAEQQFGDQQgAkEANgIYIAJCADcCECACQaDNAjYCAEHIsgVBADYCACADIAJBARAFQciyBSgCACEEQciyBUEANgIAAkAgBEEBRwRAQciyBUEANgIAQd4AIAJBEGpBABAVIQRByLIFKAIAIQZByLIFQQA2AgAgBkEBRw0BCxAGIQAQBxogAigCGCEDQciyBUEANgIAIAMQ6AFByLIFKAIAIQNByLIFQQA2AgAgA0EBRw0GQQAQCyEBEAcaIAEQhAEACyAEQQA7AQBByLIFQQA2AgBB2wAgASAFEAVByLIFKAIAIQJByLIFQQA2AgAgAkEBRg0AQciyBUEANgIAQS1BHBANIQJByLIFKAIAIQVByLIFQQA2AgAgBUEBRg0AQciyBUEANgIAIAIgAUHA9AAQoAQhBUHIsgUoAgAhBEHIsgVBADYCACAEQQFGDQYgAkEANgIYIAJCADcCECACQaDNAjYCAEHIsgVBADYCACADIAJBARAFQciyBSgCACEDQciyBUEANgIAAkAgA0EBRwRAQciyBUEANgIAQd4AIAJBEGpBABAVIQNByLIFKAIAIQRByLIFQQA2AgAgBEEBRw0BCxAGIQAQBxogAigCGCEDQciyBUEANgIAIAMQ6AFByLIFKAIAIQNByLIFQQA2AgAgA0EBRw0IQQAQCyEBEAcaIAEQhAEACyADQQA7AQBByLIFQQA2AgBB2wAgASAFEAVByLIFKAIAIQJByLIFQQA2AgAgAkEBRw0JCxAGIQAQBxoMBwsQBiEAEAcaIAIQ9gwMBgsQBiEAEAcaCyACEPYMDAQLEAYhABAHGgsgAhD2DAwCCxAGIQAQBxoLIAIQ9gwLIAEQhAMaIAAQCAALIAALUwAgABCJAyAAQcgAaiIAQQAQrAEoAgBBzPQAQQAQtQQgAEEBEKwBKAIAQQFBABDdASAAQQIQrAEoAgBBAUEAEN0BIABBAxCsASgCAEEBQQAQ3QEL1AsBBX8gACABQfj0ABCCAyEBIABBiPUANgIAQciyBUEANgIAQS1BHBANIQJByLIFKAIAIQNByLIFQQA2AgACQAJAAkACQAJAAkACQAJAAkACQAJAIANBAUYNAEHIsgVBADYCACACIAFBrPUAEKAEIQNByLIFKAIAIQRByLIFQQA2AgAgBEEBRg0BIAJBADYCGCACQgA3AhAgAkHgzgI2AgBByLIFQQA2AgBB8M4CKAIAIAJBARAFQciyBSgCACEEQciyBUEANgIAAkAgBEEBRwRAQciyBUEANgIAQfsAIAJBEGpBABAVIQRByLIFKAIAIQVByLIFQQA2AgAgBUEBRw0BCxAGIQAQBxogAigCGCEDQciyBUEANgIAIAMQ6AFByLIFKAIAIQNByLIFQQA2AgAgA0EBRw0DQQAQCyEBEAcaIAEQhAEACyAEQQA2AgBByLIFQQA2AgBB2wAgASADEAVByLIFKAIAIQJByLIFQQA2AgAgAkEBRg0AQciyBUEANgIAQS1BHBANIQJByLIFKAIAIQNByLIFQQA2AgAgA0EBRg0AQciyBUEANgIAIAIgAUGz9QAQoAQhBEHIsgUoAgAhA0HIsgVBADYCACADQQFGDQMgAkEANgIYIAJCADcCECACQZDMAjYCAEHIsgVBADYCAEGgzAIoAgAiAyACQQEQBUHIsgUoAgAhBUHIsgVBADYCAAJAIAVBAUcEQEHIsgVBADYCAEHZACACQRBqQQAQFSEFQciyBSgCACEGQciyBUEANgIAIAZBAUcNAQsQBiEAEAcaIAIoAhghA0HIsgVBADYCACADEOgBQciyBSgCACEDQciyBUEANgIAIANBAUcNBUEAEAshARAHGiABEIQBAAsgBUEAOgAAQciyBUEANgIAQdsAIAEgBBAFQciyBSgCACECQciyBUEANgIAIAJBAUYNAEHIsgVBADYCAEEtQRwQDSECQciyBSgCACEEQciyBUEANgIAIARBAUYNAEHIsgVBADYCACACIAFBwvUAEKAEIQRByLIFKAIAIQVByLIFQQA2AgAgBUEBRg0FIAJBADYCGCACQgA3AhAgAkGQzAI2AgBByLIFQQA2AgAgAyACQQEQBUHIsgUoAgAhBUHIsgVBADYCAAJAIAVBAUcEQEHIsgVBADYCAEHZACACQRBqQQAQFSEFQciyBSgCACEGQciyBUEANgIAIAZBAUcNAQsQBiEAEAcaIAIoAhghA0HIsgVBADYCACADEOgBQciyBSgCACEDQciyBUEANgIAIANBAUcNB0EAEAshARAHGiABEIQBAAsgBUEAOgAAQciyBUEANgIAQdsAIAEgBBAFQciyBSgCACECQciyBUEANgIAIAJBAUYNAEHIsgVBADYCAEEtQRwQDSECQciyBSgCACEEQciyBUEANgIAIARBAUYNAEHIsgVBADYCACACIAFBzPUAEKAEIQRByLIFKAIAIQVByLIFQQA2AgAgBUEBRg0HIAJBADYCGCACQgA3AhAgAkGQzAI2AgBByLIFQQA2AgAgAyACQQEQBUHIsgUoAgAhA0HIsgVBADYCAAJAIANBAUcEQEHIsgVBADYCAEHZACACQRBqQQAQFSEDQciyBSgCACEFQciyBUEANgIAIAVBAUcNAQsQBiEAEAcaIAIoAhghA0HIsgVBADYCACADEOgBQciyBSgCACEDQciyBUEANgIAIANBAUcNCUEAEAshARAHGiABEIQBAAsgA0EAOgAAQciyBUEANgIAQdsAIAEgBBAFQciyBSgCACECQciyBUEANgIAIAJBAUYNAEHIsgVBADYCAEGvASABQdj1AEEAQQEQHEHIsgUoAgAhAkHIsgVBADYCACACQQFHDQoLEAYhABAHGgwICxAGIQAQBxoLIAIQ9gwMBgsQBiEAEAcaCyACEPYMDAQLEAYhABAHGgsgAhD2DAwCCxAGIQAQBxoLIAIQ9gwLIAEQhAMaIAAQCAALIAALMwAgABCJAyAAQcgAaiIAQQAQrAEoAgBB8NLR6QZBABDXASAAQQEQrAEoAgBBAUEAEK0BC4MHAQV/IwBBEGsiAiQAAkAgAEHd9QAQkQMiBEUNACAEQef1ACACQQxqQQAQkwMaAkACQAJAAkACQAJAAkACQCACKAIMIgFFBEBBBBAOIQNByLIFQQA2AgBBLUEsEA0hBEHIsgUoAgAhAUHIsgVBADYCAAJAAkAgAUEBRwRAQciyBUEANgIAQS1BIBANIQFByLIFKAIAIQBByLIFQQA2AgAgAEEBRg0BIAIgATYCACACQpeAgICAhICAgH83AgQgAUEAOgAXIAFBhvYAKQAANwAPIAFB//UAKQAANwAIIAFB9/UAKQAANwAAQciyBUEANgIAQTIgBCACQY/2AEHOAEG19gAQEBpByLIFKAIAIQFByLIFQQA2AgBBASEAIAFBAUcEQCADIAQ2AgBBACEAQciyBUEANgIAQTEgA0Gg2gBBABASQciyBSgCACEBQciyBUEANgIAIAFBAUcNBQsQBiEBEAcaIAIsAAtBf0wEQCACKAIAEPYMCyAADQIMCgsQBiEBEAcaIAMQEyABEAgACxAGIQEQBxoLIAQQ9gwgAxATIAEQCAALIAFBEGpBABCxASgCACEDIARBu/YAIAJBDGpBABCTAxogAigCDCIFDQdBBBAOIQNByLIFQQA2AgBBLUEsEA0hBEHIsgUoAgAhAUHIsgVBADYCACABQQFGDQFByLIFQQA2AgBBLUEgEA0hAUHIsgUoAgAhAEHIsgVBADYCACAAQQFGDQIgAiABNgIAIAJCl4CAgICEgICAfzcCBCABQQA6ABcgAUGG9gApAAA3AA8gAUH/9QApAAA3AAggAUH39QApAAA3AABByLIFQQA2AgBBMiAEIAJBj/YAQdQAQbX2ABAQGkHIsgUoAgAhAUHIsgVBADYCAEEBIQAgAUEBRg0DIAMgBDYCAEHIsgVBADYCAEExIANBoNoAQQAQEkHIsgUoAgAhAUHIsgVBADYCAEEAIQAgAUEBRg0DCwALEAYhARAHGgwDCxAGIQEQBxoMAQsQBiEBEAcaIAIsAAtBf0wEQCACKAIAEPYMCyAARQ0CCyAEEPYMCyADEBMLIAEQCAALQQAhASAFQRBqQQAQsQEoAgAgA3INACAAKAJgRQ0AIABB4ABqIQMDQCAEIAMgARCRASgCAEYEQCADIAEQkgEMAgsgAUEBaiIBIAMoAgBJDQALCyAAEJUDIAJBEGokAAuADgEFfyAAIAFB9PYAEIIDIQEgAEGE9wA2AgBByLIFQQA2AgBBLUEcEA0hAkHIsgUoAgAhA0HIsgVBADYCAAJAAkACQAJAAkACQAJAAkACQAJAAkACQAJAIANBAUYNAEHIsgVBADYCACACIAFBqPcAEKAEIQNByLIFKAIAIQVByLIFQQA2AgAgBUEBRg0BIAJBADYCGCACQgA3AhAgAkHgzgI2AgBByLIFQQA2AgBB8M4CKAIAIAJBARAFQciyBSgCACEFQciyBUEANgIAAkAgBUEBRwRAQciyBUEANgIAQfsAIAJBEGpBABAVIQVByLIFKAIAIQRByLIFQQA2AgAgBEEBRw0BCxAGIQAQBxogAigCGCEDQciyBUEANgIAIAMQ6AFByLIFKAIAIQNByLIFQQA2AgAgA0EBRw0DQQAQCyEBEAcaIAEQhAEACyAFQQA2AgBByLIFQQA2AgBB2wAgASADEAVByLIFKAIAIQJByLIFQQA2AgAgAkEBRg0AQciyBUEANgIAQS1BHBANIQJByLIFKAIAIQNByLIFQQA2AgAgA0EBRg0AQciyBUEANgIAIAIgAUGv9wAQoAQhBUHIsgUoAgAhA0HIsgVBADYCACADQQFGDQMgAkEANgIYIAJCADcCECACQZDMAjYCAEHIsgVBADYCAEGgzAIoAgAiAyACQQEQBUHIsgUoAgAhBEHIsgVBADYCAAJAIARBAUcEQEHIsgVBADYCAEHZACACQRBqQQAQFSEEQciyBSgCACEGQciyBUEANgIAIAZBAUcNAQsQBiEAEAcaIAIoAhghA0HIsgVBADYCACADEOgBQciyBSgCACEDQciyBUEANgIAIANBAUcNBUEAEAshARAHGiABEIQBAAsgBEEAOgAAQciyBUEANgIAQdsAIAEgBRAFQciyBSgCACECQciyBUEANgIAIAJBAUYNAEHIsgVBADYCAEEtQRwQDSECQciyBSgCACEFQciyBUEANgIAIAVBAUYNAEHIsgVBADYCACACIAFBvvcAEKAEIQVByLIFKAIAIQRByLIFQQA2AgAgBEEBRg0FIAJBADYCGCACQgA3AhAgAkGgzQI2AgBByLIFQQA2AgBBsM0CKAIAIAJBARAFQciyBSgCACEEQciyBUEANgIAAkAgBEEBRwRAQciyBUEANgIAQd4AIAJBEGpBABAVIQRByLIFKAIAIQZByLIFQQA2AgAgBkEBRw0BCxAGIQAQBxogAigCGCEDQciyBUEANgIAIAMQ6AFByLIFKAIAIQNByLIFQQA2AgAgA0EBRw0HQQAQCyEBEAcaIAEQhAEACyAEQQA7AQBByLIFQQA2AgBB2wAgASAFEAVByLIFKAIAIQJByLIFQQA2AgAgAkEBRg0AQciyBUEANgIAQS1BHBANIQJByLIFKAIAIQVByLIFQQA2AgAgBUEBRg0AQciyBUEANgIAIAIgAUHG9wAQoAQhBUHIsgUoAgAhBEHIsgVBADYCACAEQQFGDQcgAkEANgIYIAJCADcCECACQZDMAjYCAEHIsgVBADYCACADIAJBARAFQciyBSgCACEEQciyBUEANgIAAkAgBEEBRwRAQciyBUEANgIAQdkAIAJBEGpBABAVIQRByLIFKAIAIQZByLIFQQA2AgAgBkEBRw0BCxAGIQAQBxogAigCGCEDQciyBUEANgIAIAMQ6AFByLIFKAIAIQNByLIFQQA2AgAgA0EBRw0JQQAQCyEBEAcaIAEQhAEACyAEQQA6AABByLIFQQA2AgBB2wAgASAFEAVByLIFKAIAIQJByLIFQQA2AgAgAkEBRg0AQciyBUEANgIAQS1BHBANIQJByLIFKAIAIQVByLIFQQA2AgAgBUEBRg0AQciyBUEANgIAIAIgAUHX9wAQoAQhBUHIsgUoAgAhBEHIsgVBADYCACAEQQFGDQkgAkEANgIYIAJCADcCECACQZDMAjYCAEHIsgVBADYCACADIAJBARAFQciyBSgCACEDQciyBUEANgIAAkAgA0EBRwRAQciyBUEANgIAQdkAIAJBEGpBABAVIQNByLIFKAIAIQRByLIFQQA2AgAgBEEBRw0BCxAGIQAQBxogAigCGCEDQciyBUEANgIAIAMQ6AFByLIFKAIAIQNByLIFQQA2AgAgA0EBRw0LQQAQCyEBEAcaIAEQhAEACyADQQA6AABByLIFQQA2AgBB2wAgASAFEAVByLIFKAIAIQJByLIFQQA2AgAgAkEBRw0MCxAGIQAQBxoMCgsQBiEAEAcaCyACEPYMDAgLEAYhABAHGgsgAhD2DAwGCxAGIQAQBxoLIAIQ9gwMBAsQBiEAEAcaCyACEPYMDAILEAYhABAHGgsgAhD2DAsgARCEAxogABAIAAsgAAvfBAEEfyAAIAFBkPgAEIIDIQIgAEGg+AA2AgBByLIFQQA2AgBB0QEgAhAPQciyBSgCACEBQciyBUEANgIAAkACQAJAAkAgAUEBRwRAQciyBUEANgIAQS1BHBANIQFByLIFKAIAIQNByLIFQQA2AgAgA0EBRg0BQciyBUEANgIAIAEgAkHE+AAQoAQhA0HIsgUoAgAhBEHIsgVBADYCACAEQQFGDQIgAUEANgIYIAFCADcCECABQeDOAjYCAEHIsgVBADYCAEHwzgIoAgAgAUEBEAVByLIFKAIAIQRByLIFQQA2AgACQCAEQQFHBEBByLIFQQA2AgBB+wAgAUEQakEAEBUhBEHIsgUoAgAhBUHIsgVBADYCACAFQQFHDQELEAYhABAHGiABKAIYIQNByLIFQQA2AgAgAxDoAUHIsgUoAgAhA0HIsgVBADYCACADQQFHDQRBABALIQEQBxogARCEAQALIARBADYCACABQQE6AAxByLIFQQA2AgBB2wAgAiADEAVByLIFKAIAIQFByLIFQQA2AgAgAUEBRg0BQciyBUEANgIAQa8BIAJBz/gAQQBBABAcQciyBSgCACEBQciyBUEANgIAIAFBAUYNAUHIsgVBADYCAEGvASACQdT4AEEAQQAQHEHIsgUoAgAhAUHIsgVBADYCACABQQFGDQFByLIFQQA2AgBBrwEgAkHZ+ABBAEEAEBxByLIFKAIAIQFByLIFQQA2AgAgAUEBRg0BIAAPCxAGIQAQBxoMAwsQBiEAEAcaDAILEAYhABAHGgsgARD2DAsgAhCEAxogABAIAAuSAQEFfyMAQRBrIgIkACAAEI0DIABByABqQQIQrAEhASAAKAJgIAEoAgAiAUEQakEAELEBKAIARwRAIAAoAgQQ2QMiAygCACEEIAMsAAshBSACQZL5ADYCACACIAQgAyAFQQBIGzYCBEHe+AAgAhC8ASABQQA6AAwgASAAKAJgQQAQ1wEgAUEBOgAMCyACQRBqJAAL0RQBBX8gACABQcD5ABCCAyEBIABB0PkANgIAQciyBUEANgIAQS1BIBANIQJByLIFKAIAIQRByLIFQQA2AgACQAJAAkACQAJAAkACQAJAAkACQAJAAkACQAJAAkACQAJAIARBAUYNAEHIsgVBADYCACACIAFB9PkAEKAEIQVByLIFKAIAIQRByLIFQQA2AgAgBEEBRg0BIAJBADYCGCACQgA3AhAgAkHAzwI2AgBByLIFQQA2AgBB0M8CKAIAIgQgAkEBEAVByLIFKAIAIQNByLIFQQA2AgACQCADQQFHBEBByLIFQQA2AgBB3AAgAkEQakEAEBUhA0HIsgUoAgAhBkHIsgVBADYCACAGQQFHDQELEAYhBBAHGiACKAIYIQBByLIFQQA2AgAgABDoAUHIsgUoAgAhAEHIsgVBADYCACAAQQFHDQNBABALIQEQBxogARCEAQALIANCADcDACACQQI6ABwgAkGg0AI2AgBByLIFQQA2AgBB2wAgASAFEAVByLIFKAIAIQJByLIFQQA2AgAgAkEBRg0AQciyBUEANgIAQS1BIBANIQJByLIFKAIAIQVByLIFQQA2AgAgBUEBRg0AQciyBUEANgIAIAIgAUH6+QAQoAQhBUHIsgUoAgAhA0HIsgVBADYCACADQQFGDQMgAkEANgIYIAJCADcCECACQcDPAjYCAEHIsgVBADYCACAEIAJBARAFQciyBSgCACEDQciyBUEANgIAAkAgA0EBRwRAQciyBUEANgIAQdwAIAJBEGpBABAVIQNByLIFKAIAIQZByLIFQQA2AgAgBkEBRw0BCxAGIQQQBxogAigCGCEAQciyBUEANgIAIAAQ6AFByLIFKAIAIQBByLIFQQA2AgAgAEEBRw0FQQAQCyEBEAcaIAEQhAEACyADQgA3AwAgAkEFOgAcIAJBoNACNgIAQciyBUEANgIAQdsAIAEgBRAFQciyBSgCACECQciyBUEANgIAIAJBAUYNAEHIsgVBADYCAEEtQSAQDSECQciyBSgCACEFQciyBUEANgIAIAVBAUYNAEHIsgVBADYCACACIAFB//kAEKAEIQVByLIFKAIAIQNByLIFQQA2AgAgA0EBRg0FIAJBADYCGCACQgA3AhAgAkHAzwI2AgBByLIFQQA2AgAgBCACQQEQBUHIsgUoAgAhA0HIsgVBADYCAAJAIANBAUcEQEHIsgVBADYCAEHcACACQRBqQQAQFSEDQciyBSgCACEGQciyBUEANgIAIAZBAUcNAQsQBiEEEAcaIAIoAhghAEHIsgVBADYCACAAEOgBQciyBSgCACEAQciyBUEANgIAIABBAUcNB0EAEAshARAHGiABEIQBAAsgA0IANwMAIAJBAzoAHCACQaDQAjYCAEHIsgVBADYCAEHbACABIAUQBUHIsgUoAgAhAkHIsgVBADYCACACQQFGDQBByLIFQQA2AgBBLUEgEA0hAkHIsgUoAgAhBUHIsgVBADYCACAFQQFGDQBByLIFQQA2AgAgAiABQYX6ABCgBCEFQciyBSgCACEDQciyBUEANgIAIANBAUYNByACQQA2AhggAkIANwIQIAJBwM8CNgIAQciyBUEANgIAIAQgAkEBEAVByLIFKAIAIQNByLIFQQA2AgACQCADQQFHBEBByLIFQQA2AgBB3AAgAkEQakEAEBUhA0HIsgUoAgAhBkHIsgVBADYCACAGQQFHDQELEAYhBBAHGiACKAIYIQBByLIFQQA2AgAgABDoAUHIsgUoAgAhAEHIsgVBADYCACAAQQFHDQlBABALIQEQBxogARCEAQALIANCADcDACACQQM6ABwgAkGg0AI2AgBByLIFQQA2AgBB2wAgASAFEAVByLIFKAIAIQJByLIFQQA2AgAgAkEBRg0AQciyBUEANgIAQS1BIBANIQJByLIFKAIAIQVByLIFQQA2AgAgBUEBRg0AQciyBUEANgIAIAIgAUGL+gAQoAQhBUHIsgUoAgAhA0HIsgVBADYCACADQQFGDQkgAkEANgIYIAJCADcCECACQcDPAjYCAEHIsgVBADYCACAEIAJBARAFQciyBSgCACEDQciyBUEANgIAAkAgA0EBRwRAQciyBUEANgIAQdwAIAJBEGpBABAVIQNByLIFKAIAIQZByLIFQQA2AgAgBkEBRw0BCxAGIQQQBxogAigCGCEAQciyBUEANgIAIAAQ6AFByLIFKAIAIQBByLIFQQA2AgAgAEEBRw0LQQAQCyEBEAcaIAEQhAEACyADQgA3AwAgAkEBOgAcIAJBoNACNgIAQciyBUEANgIAQdsAIAEgBRAFQciyBSgCACECQciyBUEANgIAIAJBAUYNAEHIsgVBADYCAEEtQSAQDSECQciyBSgCACEFQciyBUEANgIAIAVBAUYNAEHIsgVBADYCACACIAFBkfoAEKAEIQVByLIFKAIAIQNByLIFQQA2AgAgA0EBRg0LIAJBADYCGCACQgA3AhAgAkHAzwI2AgBByLIFQQA2AgAgBCACQQEQBUHIsgUoAgAhA0HIsgVBADYCAAJAIANBAUcEQEHIsgVBADYCAEHcACACQRBqQQAQFSEDQciyBSgCACEGQciyBUEANgIAIAZBAUcNAQsQBiEEEAcaIAIoAhghAEHIsgVBADYCACAAEOgBQciyBSgCACEAQciyBUEANgIAIABBAUcNDUEAEAshARAHGiABEIQBAAsgA0IANwMAIAJBBToAHCACQaDQAjYCAEHIsgVBADYCAEHbACABIAUQBUHIsgUoAgAhAkHIsgVBADYCACACQQFGDQBByLIFQQA2AgBBLUEgEA0hAkHIsgUoAgAhBUHIsgVBADYCACAFQQFGDQBByLIFQQA2AgAgAiABQZ/6ABCgBCEFQciyBSgCACEDQciyBUEANgIAIANBAUYNDSACQQA2AhggAkIANwIQIAJBwM8CNgIAQciyBUEANgIAIAQgAkEBEAVByLIFKAIAIQRByLIFQQA2AgACQCAEQQFHBEBByLIFQQA2AgBB3AAgAkEQakEAEBUhBEHIsgUoAgAhA0HIsgVBADYCACADQQFHDQELEAYhBBAHGiACKAIYIQBByLIFQQA2AgAgABDoAUHIsgUoAgAhAEHIsgVBADYCACAAQQFHDQ9BABALIQEQBxogARCEAQALIARCADcDACACQQU6ABwgAkGg0AI2AgBByLIFQQA2AgBB2wAgASAFEAVByLIFKAIAIQJByLIFQQA2AgAgAkEBRg0AQciyBUEANgIAQeYBIABByABqQQYQFSECQciyBSgCACEEQciyBUEANgIAIARBAUcNEAsQBiEEEAcaDA4LEAYhBBAHGgsgAhD2DAwMCxAGIQQQBxoLIAIQ9gwMCgsQBiEEEAcaCyACEPYMDAgLEAYhBBAHGgsgAhD2DAwGCxAGIQQQBxoLIAIQ9gwMBAsQBiEEEAcaCyACEPYMDAILEAYhBBAHGgsgAhD2DAsgARCEAxogBBAIAAsgAigCAEEBOgAMIAALBwAgABCJAwvRCAINfwF+IwBBgAJrIgMkACAAQcgAaiIGQQAQrAEoAgAhBCAGQQEQrAEoAgAhByAGQQIQrAEoAgAhBSAGQQMQrAEoAgAhCCAGQQQQrAEoAgAhCSAGQQUQrAEoAgAhCiAGQQYQrAEoAgAhDSADIAAoAgQQ2QMiBigCACAGIAYsAAtBAEgbNgLwAUHAjAQgAUEFQaj6ACADQfABahC/ASABQQFqIQYgBARAQeD6ACEMIARBEGpBABCpASkDACIQQgNYBEAgEKdBAnRB0PoAaigCACEMCyAELQAcIQEgACgCBBDZAyILKAIAIQ4gCywACyEPIAQtABwhBCADIAw2AuQBIAMgBDYC4AEgAyAQNwPYASADIAFBAnYiBCAERSABQQNxQQBHcmo2AtABIAMgEDcDyAEgAyAOIAsgD0EASBs2AsABQcCMBCAGQf8BcUEFQe76ACADQcABahC/AQsgBwRAIAcgBkH/AXEgAkEAIAcoAgAoAiARBwALIAUEQEHg+gAhASAFQRBqQQAQqQEpAwAiEEIHWARAIBCnQQJ0QfD9AGooAgAhAQsgBS0AHCEEIAAoAgQQ2QMiBygCACELIAcsAAshDCAFLQAcIQUgAyABNgK0ASADIAU2ArABIAMgEDcDqAEgAyAEQQJ2IgUgBUUgBEEDcUEAR3JqNgKgASADIBA3A5gBIAMgCyAHIAxBAEgbNgKQAUHAjAQgBkH/AXFBBUGQ/gAgA0GQAWoQvwELIAgEQEHg+gAhByAIQRBqQQAQqQEpAwAiEEIHWARAIBCnQQJ0QcD/AGooAgAhBwsgCC0AHCEEIAAoAgQQ2QMiBSgCACEBIAUsAAshCyAILQAcIQggAyAHNgKEASADIAg2AoABIAMgEDcDeCADIARBAnYiCCAIRSAEQQNxQQBHcmo2AnAgAyAQNwNoIAMgASAFIAtBAEgbNgJgQcCMBCAGQf8BcUEFQeD/ACADQeAAahC/AQsgCQRAIAlBEGpBABCpASkDACEQIAktABwhBCAAKAIEENkDIgUoAgAhCCAFLAALIQcgCS0AHCEJIANBwoABQbqAASAQUBs2AlQgAyAJNgJQIAMgEDcDSCADQUBrIARBAnYiCSAJRSAEQQNxQQBHcmo2AgAgAyAQNwM4IAMgCCAFIAdBAEgbNgIwQcCMBCAGQf8BcUEFQY2AASADQTBqEL8BCyAKBEBBACEFIApBEGpBABCpASkDACIQQhJYBEAgEKdBAnRB0IABaigCACEFCyAKLQAcIQQgACgCBBDZAyIAKAIAIQggACwACyEJIAotABwhCiADIAU2AiQgAyAKNgIgIAMgEDcDGCADIARBAnYiBSAFRSAEQQNxQQBHcmo2AhAgAyAQNwMIIAMgCCAAIAlBAEgbNgIAQcCMBCAGQf8BcUEFQZyBASADEL8BCyANBEAgDSAGQf8BcSACQQAgDSgCACgCIBEHAAsgA0GAAmokAAvnBAEEfyAAIAFBgIIBEIIDIQQgAEGQggE2AgBByLIFQQA2AgBB0QEgBBAPQciyBSgCACEBQciyBUEANgIAAkACQAJAAkACQAJAIAFBAUcEQEHIsgVBADYCAEEtQRwQDSEBQciyBSgCACECQciyBUEANgIAIAJBAUYNAUHIsgVBADYCACABIARBtIIBEKAEIQJByLIFKAIAIQNByLIFQQA2AgAgA0EBRg0CIAFBADYCGCABQgA3AhAgAUHgzgI2AgBByLIFQQA2AgBB8M4CKAIAIAFBARAFQciyBSgCACEDQciyBUEANgIAAkAgA0EBRwRAQciyBUEANgIAQfsAIAFBEGpBABAVIQNByLIFKAIAIQVByLIFQQA2AgAgBUEBRw0BCxAGIQAQBxogASgCGCECQciyBUEANgIAIAIQ6AFByLIFKAIAIQJByLIFQQA2AgAgAkEBRw0EQQAQCyEBEAcaIAEQhAEACyADQQA2AgBByLIFQQA2AgBB2wAgBCACEAVByLIFKAIAIQJByLIFQQA2AgAgAkEBRg0BQciyBUEANgIAQS1BIBANIQJByLIFKAIAIQNByLIFQQA2AgAgA0EBRg0EQciyBUEANgIAIAIgBEG/ggEgARDFBBpByLIFKAIAIQFByLIFQQA2AgAgAUEBRg0FQciyBUEANgIAQdsAIAQgAhAFQciyBSgCACEBQciyBUEANgIAIAFBAUYNBCAADwsQBiEAEAcaDAULEAYhABAHGgwECxAGIQAQBxoLIAEQ9gwMAgsQBiEAEAcaDAELEAYhABAHGiACEPYMCyAEEIQDGiAAEAgAC4cNAQR/IABByABqQQMQrAEoAgAhA0EcEP4LIQAgAygCBCECAkACQAJAIAFBAUYEQEHIsgVBADYCACAAIAJBx4IBEKAEIQFByLIFKAIAIQJByLIFQQA2AgACQCACQQFHBEAgAEEANgIYIABCADcCECAAQcDPAjYCAEHIsgVBADYCAEHQzwIoAgAiAiAAQQEQBUHIsgUoAgAhBEHIsgVBADYCAAJAIARBAUcEQEHIsgVBADYCAEHcACAAQRBqQQAQFSEEQciyBSgCACEFQciyBUEANgIAIAVBAUcNAQsQBiEDEAcaIAAoAhghAUHIsgVBADYCACABEOgBQciyBSgCACEBQciyBUEANgIAIAFBAUcNBkEAEAshABAHGiAAEIQBAAsgBEIANwMAIAMgARDIBEEcEP4LIQAgAygCBCEBQciyBUEANgIAIAAgAUHXggEQoAQhAUHIsgUoAgAhBEHIsgVBADYCACAEQQFGDQEgAEEANgIYIABCADcCECAAQcDPAjYCAEHIsgVBADYCACACIABBARAFQciyBSgCACECQciyBUEANgIAIAJBAUcEQEHIsgVBADYCAEHcACAAQRBqQQAQFSECQciyBSgCACEEQciyBUEANgIAIARBAUcNBAsQBiEDEAcaIAAoAhghAUHIsgVBADYCACABEOgBQciyBSgCACEBQciyBUEANgIAIAFBAUcNBUEAEAshABAHGiAAEIQBAAsQBiEDEAcaDAQLEAYhAxAHGgwDC0HIsgVBADYCACAAIAJBx4IBEKAEIQFByLIFKAIAIQJByLIFQQA2AgACQCACQQFHBEAgAEEANgIYIABCADcCECAAQeDOAjYCAEHIsgVBADYCAEHwzgIoAgAiAiAAQQEQBUHIsgUoAgAhBEHIsgVBADYCAAJAIARBAUcEQEHIsgVBADYCAEH7ACAAQRBqQQAQFSEEQciyBSgCACEFQciyBUEANgIAIAVBAUcNAQsQBiEDEAcaIAAoAhghAUHIsgVBADYCACABEOgBQciyBSgCACEBQciyBUEANgIAIAFBAUcNBUEAEAshABAHGiAAEIQBAAsgBEEANgIAIAMgARDIBEEcEP4LIQAgAygCBCEBQciyBUEANgIAIAAgAUHXggEQoAQhAUHIsgUoAgAhBEHIsgVBADYCACAEQQFGDQEgAEEANgIYIABCADcCECAAQeDOAjYCAEHIsgVBADYCACACIABBARAFQciyBSgCACECQciyBUEANgIAAkAgAkEBRwRAQciyBUEANgIAQfsAIABBEGpBABAVIQJByLIFKAIAIQRByLIFQQA2AgAgBEEBRw0BCxAGIQMQBxogACgCGCEBQciyBUEANgIAIAEQ6AFByLIFKAIAIQFByLIFQQA2AgAgAUEBRw0FQQAQCyEAEAcaIAAQhAEACyACQQA2AgAMAwsQBiEDEAcaDAMLEAYhAxAHGgwCCyACQgA3AwALIAMgARDIBEEcEP4LIQAgAygCBCEBQciyBUEANgIAIAAgAUHhggEQoAQhAUHIsgUoAgAhAkHIsgVBADYCAAJAIAJBAUcEQCAAQQA2AhggAEIANwIQIABBoM0CNgIAQciyBUEANgIAQbDNAigCACICIABBARAFQciyBSgCACEEQciyBUEANgIAAkAgBEEBRwRAQciyBUEANgIAQd4AIABBEGpBABAVIQRByLIFKAIAIQVByLIFQQA2AgAgBUEBRw0BCxAGIQMQBxogACgCGCEBQciyBUEANgIAIAEQ6AFByLIFKAIAIQFByLIFQQA2AgAgAUEBRw0DQQAQCyEAEAcaIAAQhAEACyAEQQA7AQAgAyABEMgEQRwQ/gshACADKAIEIQFByLIFQQA2AgAgACABQeuCARCgBCEBQciyBSgCACEEQciyBUEANgIAIARBAUYNASAAQQA2AhggAEIANwIQIABBoM0CNgIAQciyBUEANgIAIAIgAEEBEAVByLIFKAIAIQJByLIFQQA2AgACQCACQQFHBEBByLIFQQA2AgBB3gAgAEEQakEAEBUhAkHIsgUoAgAhBEHIsgVBADYCACAEQQFHDQELEAYhAxAHGiAAKAIYIQFByLIFQQA2AgAgARDoAUHIsgUoAgAhAUHIsgVBADYCACABQQFHDQNBABALIQAQBxogABCEAQALIAJBADsBACADIAEQyAQPCxAGIQMQBxoMAQsQBiEDEAcaCyAAEPYMIAMQCAALGAAgAEEAEJ8DIAAgABCeAxCfAiAAEIkDCyMAIABBAEEBEI4DIAAgABCeAxCfAiAAQQFBfxCOAyAAEJADC+MHAQV/IAAgAUGcgwEQggMhASAAQayDATYCAEHIsgVBADYCAEHHASABIAFB0IMBQQYQHEHIsgUoAgAhAkHIsgVBADYCAAJAAkACQAJAAkACQAJAIAJBAUYNAEHIsgVBADYCAEEtQRwQDSECQciyBSgCACEDQciyBUEANgIAIANBAUYNAEHIsgVBADYCACACIAFB2oMBEKAEIQNByLIFKAIAIQRByLIFQQA2AgAgBEEBRg0BIAJBADYCGCACQgA3AhAgAkGgzQI2AgBByLIFQQA2AgBBsM0CKAIAIgQgAkEBEAVByLIFKAIAIQVByLIFQQA2AgACQCAFQQFHBEBByLIFQQA2AgBB3gAgAkEQakEAEBUhBUHIsgUoAgAhBkHIsgVBADYCACAGQQFHDQELEAYhABAHGiACKAIYIQNByLIFQQA2AgAgAxDoAUHIsgUoAgAhA0HIsgVBADYCACADQQFHDQNBABALIQEQBxogARCEAQALIAVBADsBAEHIsgVBADYCAEHbACABIAMQBUHIsgUoAgAhAkHIsgVBADYCACACQQFGDQBByLIFQQA2AgBBxwEgASABQe2DAUEQEBxByLIFKAIAIQJByLIFQQA2AgAgAkEBRg0AQciyBUEANgIAQS1BHBANIQJByLIFKAIAIQNByLIFQQA2AgAgA0EBRg0AQciyBUEANgIAIAIgAUH3gwEQoAQhA0HIsgUoAgAhBUHIsgVBADYCACAFQQFGDQMgAkEANgIYIAJCADcCECACQaDNAjYCAEHIsgVBADYCACAEIAJBARAFQciyBSgCACEEQciyBUEANgIAAkAgBEEBRwRAQciyBUEANgIAQd4AIAJBEGpBABAVIQRByLIFKAIAIQVByLIFQQA2AgAgBUEBRw0BCxAGIQAQBxogAigCGCEDQciyBUEANgIAIAMQ6AFByLIFKAIAIQNByLIFQQA2AgAgA0EBRw0FQQAQCyEBEAcaIAEQhAEACyAEQQA7AQBByLIFQQA2AgBB2wAgASADEAVByLIFKAIAIQJByLIFQQA2AgAgAkEBRg0AQciyBUEANgIAQccBIAEgAUGBhAFBAhAcQciyBSgCACECQciyBUEANgIAIAJBAUYNAEHIsgVBADYCAEGvASABQYuEAUEBQQEQHEHIsgUoAgAhAkHIsgVBADYCACACQQFGDQBByLIFQQA2AgBBrwEgAUGQhAFBAUEBEBxByLIFKAIAIQJByLIFQQA2AgAgAkEBRw0GCxAGIQAQBxoMBAsQBiEAEAcaCyACEPYMDAILEAYhABAHGgsgAhD2DAsgARCEAxogABAIAAsgAAtRACAAEIkDIABByABqIgBBARCsASgCAEEBQQAQ3QEgAEECEKwBKAIAQQA6AAwgAEECEKwBKAIAQfCMBEEQQQAQvwQgAEECEKwBKAIAQQE6AAwLgQ0BBX8gACABQbyEARCCAyEBIABBzIQBNgIAQciyBUEANgIAQccBIAEgAUHwhAFBBhAcQciyBSgCACECQciyBUEANgIAAkACQAJAAkACQAJAAkACQAJAAkAgAkEBRg0AQciyBUEANgIAQS1BHBANIQJByLIFKAIAIQNByLIFQQA2AgAgA0EBRg0AQciyBUEANgIAIAIgAUH6hAEQoAQhBUHIsgUoAgAhA0HIsgVBADYCACADQQFGDQEgAkEANgIYIAJCADcCECACQaDNAjYCAEHIsgVBADYCAEGwzQIoAgAiAyACQQEQBUHIsgUoAgAhBEHIsgVBADYCAAJAIARBAUcEQEHIsgVBADYCAEHeACACQRBqQQAQFSEEQciyBSgCACEGQciyBUEANgIAIAZBAUcNAQsQBiEAEAcaIAIoAhghA0HIsgVBADYCACADEOgBQciyBSgCACEDQciyBUEANgIAIANBAUcNA0EAEAshARAHGiABEIQBAAsgBEEAOwEAQciyBUEANgIAQdsAIAEgBRAFQciyBSgCACECQciyBUEANgIAIAJBAUYNAEHIsgVBADYCAEHHASABIAFBjYUBQRAQHEHIsgUoAgAhAkHIsgVBADYCACACQQFGDQBByLIFQQA2AgBBLUEcEA0hAkHIsgUoAgAhBUHIsgVBADYCACAFQQFGDQBByLIFQQA2AgAgAiABQZeFARCgBCEFQciyBSgCACEEQciyBUEANgIAIARBAUYNAyACQQA2AhggAkIANwIQIAJBoM0CNgIAQciyBUEANgIAIAMgAkEBEAVByLIFKAIAIQRByLIFQQA2AgACQCAEQQFHBEBByLIFQQA2AgBB3gAgAkEQakEAEBUhBEHIsgUoAgAhBkHIsgVBADYCACAGQQFHDQELEAYhABAHGiACKAIYIQNByLIFQQA2AgAgAxDoAUHIsgUoAgAhA0HIsgVBADYCACADQQFHDQVBABALIQEQBxogARCEAQALIARBADsBAEHIsgVBADYCAEHbACABIAUQBUHIsgUoAgAhAkHIsgVBADYCACACQQFGDQBByLIFQQA2AgBBLUEcEA0hAkHIsgUoAgAhBUHIsgVBADYCACAFQQFGDQBByLIFQQA2AgAgAiABQZ2FARCgBCEFQciyBSgCACEEQciyBUEANgIAIARBAUYNBSACQQA2AhggAkIANwIQIAJBoM0CNgIAQciyBUEANgIAIAMgAkEBEAVByLIFKAIAIQNByLIFQQA2AgACQCADQQFHBEBByLIFQQA2AgBB3gAgAkEQakEAEBUhA0HIsgUoAgAhBEHIsgVBADYCACAEQQFHDQELEAYhABAHGiACKAIYIQNByLIFQQA2AgAgAxDoAUHIsgUoAgAhA0HIsgVBADYCACADQQFHDQdBABALIQEQBxogARCEAQALIANBADsBAEHIsgVBADYCAEHbACABIAUQBUHIsgUoAgAhAkHIsgVBADYCACACQQFGDQBByLIFQQA2AgBBxwEgASABQaSFAUEOEBxByLIFKAIAIQJByLIFQQA2AgAgAkEBRg0AQciyBUEANgIAQS1BJBANIQJByLIFKAIAIQNByLIFQQA2AgAgA0EBRg0HQciyBUEANgIAQf0AIAIgAUGuhQFBAEEAQQAQFiEDQciyBSgCACEFQciyBUEANgIAIAVBAUYNCCACQQE6AA8gAkEgNgIUQciyBUEANgIAQcgBIANBvYUBQQAQEkHIsgUoAgAhA0HIsgVBADYCACADQQFGDQdByLIFQQA2AgBB2wAgASACEAVByLIFKAIAIQJByLIFQQA2AgAgAkEBRg0HQciyBUEANgIAQccBIAEgAUG+hQFBBBAcQciyBSgCACECQciyBUEANgIAIAJBAUYNB0HIsgVBADYCAEGvASABQciFAUEBQQEQHEHIsgUoAgAhAkHIsgVBADYCACACQQFGDQdByLIFQQA2AgBBrwEgAUHNhQFBAUEBEBxByLIFKAIAIQJByLIFQQA2AgAgAkEBRg0HQciyBUEANgIAQa8BIAFB0oUBQQBBARAcQciyBSgCACECQciyBUEANgIAIAJBAUYNByAADwsQBiEAEAcaDAgLEAYhABAHGgsgAhD2DAwGCxAGIQAQBxoLIAIQ9gwMBAsQBiEAEAcaCyACEPYMDAILEAYhABAHGgwBCxAGIQAQBxogAhD2DAsgARCEAxogABAIAAuEAQAgABCJAyAAQcgAaiIAQQEQrAEoAgBBAUEAEN0BIABBBRCsASgCAEEAOgAMIABBBRCsASgCAEGAjQRBDkEAEL8EIABBBRCsASgCAEEBOgAMIABBBxCsASgCAEEAOgAMIABBBxCsASgCAEGOjQRBBEEAEL8EIABBBxCsASgCAEEBOgAMCx4AIAAgASACQYCGASACGxCCAxogAEGQhgE2AgAgAAsHACAAEJADC1YCAX8BfiAAIAApAyBC9////w9WIgEgACgCACgCEBECACAAKQMgUEUEQANAIAAoAgRBABC7AyACQgF8IgIgACkDIFQNAAsLIAAgASAAKAIAKAIcEQIAC4EGAQN/IAAgAUHchgEQggMhAyAAQeyGATYCAEHIsgVBADYCAEEtQSQQDSEBQciyBSgCACECQciyBUEANgIAAkACQAJAAkACQAJAAkAgAkEBRg0AQciyBUEANgIAQf0AIAEgA0GQhwFBAEEAQQAQFhpByLIFKAIAIQJByLIFQQA2AgAgAkEBRg0BIAAgATYCbEHIsgVBADYCAEEtQRwQDSEBQciyBSgCACECQciyBUEANgIAIAJBAUYNAEHIsgVBADYCACABIANBm4cBEKAEGkHIsgUoAgAhAkHIsgVBADYCACACQQFGDQIgAUEANgIYIAFCADcCECABQeDOAjYCAEHIsgVBADYCAEHwzgIoAgAgAUEBEAVByLIFKAIAIQJByLIFQQA2AgACQCACQQFHBEBByLIFQQA2AgBB+wAgAUEQakEAEBUhAkHIsgUoAgAhBEHIsgVBADYCACAEQQFHDQELEAYhABAHGiABKAIYIQJByLIFQQA2AgAgAhDoAUHIsgUoAgAhAkHIsgVBADYCACACQQFHDQRBABALIQAQBxogABCEAQALIAJBADYCACAAIAE2AnBByLIFQQA2AgBBLUEkEA0hAUHIsgUoAgAhAkHIsgVBADYCACACQQFGDQBByLIFQQA2AgBB/QAgASADQaiHAUEAQQBBARAWGkHIsgUoAgAhAkHIsgVBADYCACACQQFGDQQgACABNgJ0IAAoAmwiAkEENgIUIAFBBDYCFEHIsgVBADYCAEHbACADIAIQBUHIsgUoAgAhAUHIsgVBADYCACABQQFGDQAgACgCcCEBQciyBUEANgIAQdsAIAMgARAFQciyBSgCACEBQciyBUEANgIAIAFBAUYNACAAKAJ0IQFByLIFQQA2AgBB2wAgAyABEAVByLIFKAIAIQFByLIFQQA2AgAgAUEBRw0GCxAGIQAQBxoMBAsQBiEAEAcaIAEQ9gwMAwsQBiEAEAcaCyABEPYMDAELEAYhABAHGiABEPYMCyADEIQDGiAAEAgACyAAC1MBAX8gABCJAyAAKAJsQbmHAUEAELUEIAAoAnBBAEEAENcBIAAoAnQiAUECIAEoAgAoAhARAgAgACgCdEG5hwFBABC1BCAAKAJ0Qb6HAUEBELUECysBAX8gACgCdCIBIAApAyBC+P///z98QgKIpyABKAIAKAIQEQIAIAAQjQMLuQgBBn8gACABQeyHARCCAyEGIABB/IcBNgIAQciyBUEANgIAQS1BHBANIQFByLIFKAIAIQJByLIFQQA2AgACQAJAAkACQAJAAkACQAJAAkAgAkEBRg0AQciyBUEANgIAIAEgBkGgiAEQoAQhAkHIsgUoAgAhA0HIsgVBADYCACADQQFGDQEgAUEANgIYIAFCADcCECABQaDNAjYCAEHIsgVBADYCAEGwzQIoAgAiBCABQQEQBUHIsgUoAgAhA0HIsgVBADYCAAJAIANBAUcEQEHIsgVBADYCAEHeACABQRBqQQAQFSEDQciyBSgCACEFQciyBUEANgIAIAVBAUcNAQsQBiEAEAcaIAEoAhghAkHIsgVBADYCACACEOgBQciyBSgCACECQciyBUEANgIAIAJBAUcNA0EAEAshARAHGiABEIQBAAsgA0EAOwEAQciyBUEANgIAQdsAIAYgAhAFQciyBSgCACECQciyBUEANgIAIAJBAUYNAEHIsgVBADYCAEEtQSAQDSECQciyBSgCACEDQciyBUEANgIAIANBAUYNA0HIsgVBADYCACACIAZBq4gBIAEQxQQhA0HIsgUoAgAhAUHIsgVBADYCACABQQFGDQRByLIFQQA2AgBB2wAgBiACEAVByLIFKAIAIQFByLIFQQA2AgAgAUEBRg0DQciyBUEANgIAQS1BHBANIQFByLIFKAIAIQVByLIFQQA2AgAgBUEBRg0DIAIoAgQhBUHIsgVBADYCACABIAVBt4gBEKAEIQVByLIFKAIAIQdByLIFQQA2AgAgB0EBRg0FIAFBADYCGCABQgA3AhAgAUGgzQI2AgBByLIFQQA2AgAgBCABQQEQBUHIsgUoAgAhBEHIsgVBADYCAAJAIARBAUcEQEHIsgVBADYCAEHeACABQRBqQQAQFSEEQciyBSgCACEHQciyBUEANgIAIAdBAUcNAQsQBiEAEAcaIAEoAhghAkHIsgVBADYCACACEOgBQciyBSgCACECQciyBUEANgIAIAJBAUcNB0EAEAshARAHGiABEIQBAAsgBEEAOwEAQciyBUEANgIAQd8AIAMgBRAFQciyBSgCACEBQciyBUEANgIAIAFBAUYNA0HIsgVBADYCAEEtQSQQDSEBQciyBSgCACEEQciyBUEANgIAIARBAUYNAyACKAIEIQJByLIFQQA2AgBB/QAgASACQb6IAUEBQQBBABAWGkHIsgUoAgAhAkHIsgVBADYCACACQQFGDQdByLIFQQA2AgBB3wAgAyABEAVByLIFKAIAIQFByLIFQQA2AgAgAUEBRg0DIAAPCxAGIQAQBxoMBwsQBiEAEAcaCyABEPYMDAULEAYhABAHGgwECxAGIQAQBxogAhD2DAwDCxAGIQAQBxoLIAEQ9gwMAQsQBiEAEAcaIAEQ9gwLIAYQhAMaIAAQCAAL0A4BBX8gACABQeyIARCCAyEBIABB/IgBNgIAQciyBUEANgIAQdEBIAEQD0HIsgUoAgAhAkHIsgVBADYCAAJAAkACQAJAAkACQAJAAkACQAJAAkACQAJAIAJBAUYNAEHIsgVBADYCAEEtQRwQDSECQciyBSgCACEEQciyBUEANgIAIARBAUYNAEHIsgVBADYCACACIAFBoIkBEKAEIQVByLIFKAIAIQRByLIFQQA2AgAgBEEBRg0BIAJBADYCGCACQgA3AhAgAkGgzQI2AgBByLIFQQA2AgBBsM0CKAIAIgQgAkEBEAVByLIFKAIAIQNByLIFQQA2AgACQCADQQFHBEBByLIFQQA2AgBB3gAgAkEQakEAEBUhA0HIsgUoAgAhBkHIsgVBADYCACAGQQFHDQELEAYhBBAHGiACKAIYIQBByLIFQQA2AgAgABDoAUHIsgUoAgAhAEHIsgVBADYCACAAQQFHDQNBABALIQEQBxogARCEAQALIANBADsBAEHIsgVBADYCAEHbACABIAUQBUHIsgUoAgAhAkHIsgVBADYCACACQQFGDQBByLIFQQA2AgBBLUEcEA0hAkHIsgUoAgAhBUHIsgVBADYCACAFQQFGDQBByLIFQQA2AgAgAiABQa2JARCgBCEFQciyBSgCACEDQciyBUEANgIAIANBAUYNAyACQQA2AhggAkIANwIQIAJBoM0CNgIAQciyBUEANgIAIAQgAkEBEAVByLIFKAIAIQNByLIFQQA2AgACQCADQQFHBEBByLIFQQA2AgBB3gAgAkEQakEAEBUhA0HIsgUoAgAhBkHIsgVBADYCACAGQQFHDQELEAYhBBAHGiACKAIYIQBByLIFQQA2AgAgABDoAUHIsgUoAgAhAEHIsgVBADYCACAAQQFHDQVBABALIQEQBxogARCEAQALIANBADsBAEHIsgVBADYCAEHbACABIAUQBUHIsgUoAgAhAkHIsgVBADYCACACQQFGDQBByLIFQQA2AgBBLUEcEA0hAkHIsgUoAgAhBUHIsgVBADYCACAFQQFGDQBByLIFQQA2AgAgAiABQbiJARCgBCEFQciyBSgCACEDQciyBUEANgIAIANBAUYNBSACQQA2AhggAkIANwIQIAJBoM0CNgIAQciyBUEANgIAIAQgAkEBEAVByLIFKAIAIQNByLIFQQA2AgACQCADQQFHBEBByLIFQQA2AgBB3gAgAkEQakEAEBUhA0HIsgUoAgAhBkHIsgVBADYCACAGQQFHDQELEAYhBBAHGiACKAIYIQBByLIFQQA2AgAgABDoAUHIsgUoAgAhAEHIsgVBADYCACAAQQFHDQdBABALIQEQBxogARCEAQALIANBADsBAEHIsgVBADYCAEHbACABIAUQBUHIsgUoAgAhAkHIsgVBADYCACACQQFGDQBByLIFQQA2AgBBLUEcEA0hAkHIsgUoAgAhBUHIsgVBADYCACAFQQFGDQBByLIFQQA2AgAgAiABQcWJARCgBCEFQciyBSgCACEDQciyBUEANgIAIANBAUYNByACQQA2AhggAkIANwIQIAJBoM0CNgIAQciyBUEANgIAIAQgAkEBEAVByLIFKAIAIQNByLIFQQA2AgACQCADQQFHBEBByLIFQQA2AgBB3gAgAkEQakEAEBUhA0HIsgUoAgAhBkHIsgVBADYCACAGQQFHDQELEAYhBBAHGiACKAIYIQBByLIFQQA2AgAgABDoAUHIsgUoAgAhAEHIsgVBADYCACAAQQFHDQlBABALIQEQBxogARCEAQALIANBADsBAEHIsgVBADYCAEHbACABIAUQBUHIsgUoAgAhAkHIsgVBADYCACACQQFGDQBByLIFQQA2AgBBLUEcEA0hAkHIsgUoAgAhBUHIsgVBADYCACAFQQFGDQBByLIFQQA2AgAgAiABQdGJARCgBCEFQciyBSgCACEDQciyBUEANgIAIANBAUYNCSACQQA2AhggAkIANwIQIAJBoM0CNgIAQciyBUEANgIAIAQgAkEBEAVByLIFKAIAIQRByLIFQQA2AgACQCAEQQFHBEBByLIFQQA2AgBB3gAgAkEQakEAEBUhBEHIsgUoAgAhA0HIsgVBADYCACADQQFHDQELEAYhBBAHGiACKAIYIQBByLIFQQA2AgAgABDoAUHIsgUoAgAhAEHIsgVBADYCACAAQQFHDQtBABALIQEQBxogARCEAQALIARBADsBAEHIsgVBADYCAEHbACABIAUQBUHIsgUoAgAhAkHIsgVBADYCACACQQFGDQBByLIFQQA2AgBBxwEgASABQdmJAUECEBxByLIFKAIAIQJByLIFQQA2AgAgAkEBRw0MCxAGIQQQBxoMCgsQBiEEEAcaCyACEPYMDAgLEAYhBBAHGgsgAhD2DAwGCxAGIQQQBxoLIAIQ9gwMBAsQBiEEEAcaCyACEPYMDAILEAYhBBAHGgsgAhD2DAsgARCEAxogBBAIAAsgAAtpACAAEIkDIABByABqIgBBAhCsASgCAEHAAEEAEN0BIABBAxCsASgCAEGAgAJBABDdASAAQQQQrAEoAgBBgIACQQAQ3QEgAEEFEKwBKAIAQYCAAkEAEN0BIABBBhCsASgCAEEAQQAQ3QELiwQBAn8gACABQYyKARCCAyEBIABBnIoBNgIAQciyBUEANgIAQdEBIAEQD0HIsgUoAgAhAkHIsgVBADYCAAJAAkACQAJAAkAgAkEBRg0AQciyBUEANgIAQccBIAEgAUHAigFBBBAcQciyBSgCACECQciyBUEANgIAIAJBAUYNAEHIsgVBADYCAEEtQSQQDSECQciyBSgCACEDQciyBUEANgIAIANBAUYNAUHIsgVBADYCAEH9ACACIAFByooBQQBBAEEAEBYaQciyBSgCACEDQciyBUEANgIAIANBAUYNAiACQQQ2AhRByLIFQQA2AgBB2wAgASACEAVByLIFKAIAIQJByLIFQQA2AgAgAkEBRg0BQciyBUEANgIAQccBIAEgAUHWigFBDBAcQciyBSgCACECQciyBUEANgIAIAJBAUYNAUHIsgVBADYCAEEtQSQQDSECQciyBSgCACEDQciyBUEANgIAIANBAUYNAUHIsgVBADYCAEH9ACACIAFB4IoBQQBBAEEAEBYaQciyBSgCACEDQciyBUEANgIAIANBAUYNA0HIsgVBADYCAEHbACABIAIQBUHIsgUoAgAhAkHIsgVBADYCACACQQFGDQEgAA8LEAYhABAHGgwDCxAGIQAQBxoMAgsQBiEAEAcaIAIQ9gwMAQsQBiEAEAcaIAIQ9gwLIAEQhAMaIAAQCAAL9QICA38CfiMAQRBrIgIkACAAQQBBBRCOAwJAAkACQAJAIAAoAgRBABCwAyIEIAApAxAiBVIEQCAAKAIEIAJBD2pBAUEAELQDAkAgBSAEIAIxAA98QgF8UQRAIABByABqQQUQrAEoAgAiAUEBOgAPIABBBUF/EI4DIAFBADoADwwBC0HIsgVBADYCAEH6ASAAQQVBfxASQciyBSgCACEBQciyBUEANgIAIAFBAUcNAEGg2gAQCyEBEAdBoNoAEBlHDQQgARAMIQEgACgCBCEDQciyBUEANgIAQfsBIAMQtQ0hBEHIsgUoAgAhA0HIsgVBADYCACADQQFGDQMgBCAAKQMQfUIBUg0CIAEEQCABIAEoAgAoAgQRAQALEBcLIAAQkAMLIAJBEGokAA8LQQQQDiIAIAE2AgBByLIFQQA2AgBBMSAAQaDaAEEAEBJByLIFKAIAIQBByLIFQQA2AgAgAEEBRw0CCxAGIQEQBxoQFwsgARAICwAL9gMBBH8gACABQYyLARCCAyEDIABBnIsBNgIAQciyBUEANgIAQccBIAMgA0HAiwFBBhAcQciyBSgCACEBQciyBUEANgIAAkACQAJAAkACQCABQQFGDQBByLIFQQA2AgBBLUEcEA0hAUHIsgUoAgAhAkHIsgVBADYCACACQQFGDQBByLIFQQA2AgAgASADQcqLARCgBCECQciyBSgCACEEQciyBUEANgIAIARBAUYNASABQQA2AhggAUIANwIQIAFBoM0CNgIAQciyBUEANgIAQbDNAigCACABQQEQBUHIsgUoAgAhBEHIsgVBADYCAAJAIARBAUcEQEHIsgVBADYCAEHeACABQRBqQQAQFSEEQciyBSgCACEFQciyBUEANgIAIAVBAUcNAQsQBiEAEAcaIAEoAhghAkHIsgVBADYCACACEOgBQciyBSgCACECQciyBUEANgIAIAJBAUcNA0EAEAshARAHGiABEIQBAAsgBEEAOwEAQciyBUEANgIAQdsAIAMgAhAFQciyBSgCACEBQciyBUEANgIAIAFBAUYNAEHIsgVBADYCAEGvASADQd2LAUEAQQEQHEHIsgUoAgAhAUHIsgVBADYCACABQQFHDQQLEAYhABAHGgwCCxAGIQAQBxoLIAEQ9gwLIAMQhAMaIAAQCAALIAALHAAgABCJAyAAQcgAakEBEKwBKAIAQQFBABDdAQtZAQF/IAAgAUGMjAEQggMhASAAQZyMATYCAEHIsgVBADYCAEHRASABEA9ByLIFKAIAIQJByLIFQQA2AgAgAkEBRwRAIAAPCxAGIQAQBxogARCEAxogABAIAAu2DwEFf0EcEP4LIQICQAJAAkACQCABQQFGBEBByLIFQQA2AgAgAiAAQcCMARCgBCEFQciyBSgCACEDQciyBUEANgIAAkAgA0EBRwRAIAJBADYCGCACQgA3AhAgAkHAzwI2AgBByLIFQQA2AgBB0M8CKAIAIgMgAkEBEAVByLIFKAIAIQRByLIFQQA2AgACQCAEQQFHBEBByLIFQQA2AgBB3AAgAkEQakEAEBUhBEHIsgUoAgAhBkHIsgVBADYCACAGQQFHDQELEAYhABAHGiACKAIYIQFByLIFQQA2AgAgARDoAUHIsgUoAgAhAUHIsgVBADYCACABQQFHDQZBABALIQIQBxogAhCEAQALIARCADcDACAAIAUQjANBHBD+CyECQciyBUEANgIAIAIgAEHNjAEQoAQhBUHIsgUoAgAhBEHIsgVBADYCACAEQQFGDQEgAkEANgIYIAJCADcCECACQcDPAjYCAEHIsgVBADYCACADIAJBARAFQciyBSgCACEDQciyBUEANgIAIANBAUcEQEHIsgVBADYCAEHcACACQRBqQQAQFSEDQciyBSgCACEEQciyBUEANgIAIARBAUcNBAsQBiEAEAcaIAIoAhghAUHIsgVBADYCACABEOgBQciyBSgCACEBQciyBUEANgIAIAFBAUcNBUEAEAshAhAHGiACEIQBAAsQBiEAEAcaDAQLEAYhABAHGgwDC0HIsgVBADYCACACIABBwIwBEKAEIQVByLIFKAIAIQNByLIFQQA2AgACQCADQQFHBEAgAkEANgIYIAJCADcCECACQeDOAjYCAEHIsgVBADYCAEHwzgIoAgAiAyACQQEQBUHIsgUoAgAhBEHIsgVBADYCAAJAIARBAUcEQEHIsgVBADYCAEH7ACACQRBqQQAQFSEEQciyBSgCACEGQciyBUEANgIAIAZBAUcNAQsQBiEAEAcaIAIoAhghAUHIsgVBADYCACABEOgBQciyBSgCACEBQciyBUEANgIAIAFBAUcNBUEAEAshAhAHGiACEIQBAAsgBEEANgIAIAAgBRCMA0EcEP4LIQJByLIFQQA2AgAgAiAAQc2MARCgBCEFQciyBSgCACEEQciyBUEANgIAIARBAUYNASACQQA2AhggAkIANwIQIAJB4M4CNgIAQciyBUEANgIAIAMgAkEBEAVByLIFKAIAIQNByLIFQQA2AgACQCADQQFHBEBByLIFQQA2AgBB+wAgAkEQakEAEBUhA0HIsgUoAgAhBEHIsgVBADYCACAEQQFHDQELEAYhABAHGiACKAIYIQFByLIFQQA2AgAgARDoAUHIsgUoAgAhAUHIsgVBADYCACABQQFHDQVBABALIQIQBxogAhCEAQALIANBADYCAAwDCxAGIQAQBxoMAwsQBiEAEAcaDAILIANCADcDAAsgACAFEIwDQRwQ/gshAkHIsgVBADYCACACIABB3owBEKAEIQVByLIFKAIAIQNByLIFQQA2AgACQAJAAkACQCADQQFHBEAgAkEANgIYIAJCADcCECACQeDOAjYCAEHIsgVBADYCAEHwzgIoAgAiBiACQQEQBUHIsgUoAgAhA0HIsgVBADYCAAJAIANBAUcEQEHIsgVBADYCAEH7ACACQRBqQQAQFSEDQciyBSgCACEEQciyBUEANgIAIARBAUcNAQsQBiEAEAcaIAIoAhghAUHIsgVBADYCACABEOgBQciyBSgCACEBQciyBUEANgIAIAFBAUcNBkEAEAshAhAHGiACEIQBAAsgA0EANgIAIAAgBRCMA0EcEP4LIQIgAUEBRw0CQciyBUEANgIAIAIgAEHojAEQoAQaQciyBSgCACEBQciyBUEANgIAIAFBAUYNASACQQA2AhggAkIANwIQIAJBwM8CNgIAQciyBUEANgIAQdDPAigCACACQQEQBUHIsgUoAgAhAUHIsgVBADYCACABQQFHBEBByLIFQQA2AgBB3AAgAkEQakEAEBUhAUHIsgUoAgAhBUHIsgVBADYCACAFQQFHDQQLEAYhABAHGiACKAIYIQFByLIFQQA2AgAgARDoAUHIsgUoAgAhAUHIsgVBADYCACABQQFHDQVBABALIQIQBxogAhCEAQALEAYhABAHGgwECxAGIQAQBxoMAwtByLIFQQA2AgAgAiAAQeiMARCgBBpByLIFKAIAIQFByLIFQQA2AgAgAUEBRwRAIAJBADYCGCACQgA3AhAgAkHgzgI2AgBByLIFQQA2AgAgBiACQQEQBUHIsgUoAgAhAUHIsgVBADYCAAJAIAFBAUcEQEHIsgVBADYCAEH7ACACQRBqQQAQFSEBQciyBSgCACEFQciyBUEANgIAIAVBAUcNAQsQBiEAEAcaIAIoAhghAUHIsgVBADYCACABEOgBQciyBSgCACEBQciyBUEANgIAIAFBAUcNBEEAEAshAhAHGiACEIQBAAsgAUEANgIADAILEAYhABAHGgwCCyABQgA3AwALIAAgAhCMA0EUEP4LIQJByLIFQQA2AgAgAiAAQfGMAUHFAxDaBBpByLIFKAIAIQFByLIFQQA2AgAgAUEBRw0BEAYhABAHGgsgAhD2DCAAEAgACyAAIAIQjAMgACAAQfqMAUECEJsDC3oCAn8BfiAAIAAoAgQgAEEoahDfAyIBEJ8DIAAgARC0AiAAEIkDEKwFIQMgAEHIAGoiAEECEKwBKAIAIQIgAQRAIAIgA0EAEK4BIABBAxCsASgCACADQQAQrgEPCyACIAOnIgFBABDXASAAQQMQrAEoAgAgAUEAENcBCyMAIABBAEEBEI4DIAAgABCeAxC0AiAAQQFBfxCOAyAAEJADC1kBAX8gACABQayNARCCAyEBIABBvI0BNgIAQciyBUEANgIAQdEBIAEQD0HIsgUoAgAhAkHIsgVBADYCACACQQFHBEAgAA8LEAYhABAHGiABEIQDGiAAEAgAC5sVAQV/QRwQ/gshAgJAAkACQCABQQFGBEBByLIFQQA2AgAgAiAAQeCNARCgBCEFQciyBSgCACEDQciyBUEANgIAAkAgA0EBRwRAIAJBADYCGCACQgA3AhAgAkHAzwI2AgBByLIFQQA2AgBB0M8CKAIAIgMgAkEBEAVByLIFKAIAIQRByLIFQQA2AgACQCAEQQFHBEBByLIFQQA2AgBB3AAgAkEQakEAEBUhBEHIsgUoAgAhBkHIsgVBADYCACAGQQFHDQELEAYhABAHGiACKAIYIQFByLIFQQA2AgAgARDoAUHIsgUoAgAhAUHIsgVBADYCACABQQFHDQZBABALIQIQBxogAhCEAQALIARCADcDACAAIAUQjANBHBD+CyECQciyBUEANgIAIAIgAEHtjQEQoAQhBUHIsgUoAgAhBEHIsgVBADYCACAEQQFGDQEgAkEANgIYIAJCADcCECACQcDPAjYCAEHIsgVBADYCACADIAJBARAFQciyBSgCACEDQciyBUEANgIAIANBAUcEQEHIsgVBADYCAEHcACACQRBqQQAQFSEDQciyBSgCACEEQciyBUEANgIAIARBAUcNBAsQBiEAEAcaIAIoAhghAUHIsgVBADYCACABEOgBQciyBSgCACEBQciyBUEANgIAIAFBAUcNBUEAEAshAhAHGiACEIQBAAsQBiEAEAcaDAQLEAYhABAHGgwDC0HIsgVBADYCACACIABB4I0BEKAEIQVByLIFKAIAIQNByLIFQQA2AgACQCADQQFHBEAgAkEANgIYIAJCADcCECACQeDOAjYCAEHIsgVBADYCAEHwzgIoAgAiAyACQQEQBUHIsgUoAgAhBEHIsgVBADYCAAJAIARBAUcEQEHIsgVBADYCAEH7ACACQRBqQQAQFSEEQciyBSgCACEGQciyBUEANgIAIAZBAUcNAQsQBiEAEAcaIAIoAhghAUHIsgVBADYCACABEOgBQciyBSgCACEBQciyBUEANgIAIAFBAUcNBUEAEAshAhAHGiACEIQBAAsgBEEANgIAIAAgBRCMA0EcEP4LIQJByLIFQQA2AgAgAiAAQe2NARCgBCEFQciyBSgCACEEQciyBUEANgIAIARBAUYNASACQQA2AhggAkIANwIQIAJB4M4CNgIAQciyBUEANgIAIAMgAkEBEAVByLIFKAIAIQNByLIFQQA2AgACQCADQQFHBEBByLIFQQA2AgBB+wAgAkEQakEAEBUhA0HIsgUoAgAhBEHIsgVBADYCACAEQQFHDQELEAYhABAHGiACKAIYIQFByLIFQQA2AgAgARDoAUHIsgUoAgAhAUHIsgVBADYCACABQQFHDQVBABALIQIQBxogAhCEAQALIANBADYCAAwDCxAGIQAQBxoMAwsQBiEAEAcaDAILIANCADcDAAsgACAFEIwDQRwQ/gshAkHIsgVBADYCACACIABB/o0BEKAEIQNByLIFKAIAIQVByLIFQQA2AgACQAJAAkACQCAFQQFHBEAgAkEANgIYIAJCADcCECACQeDOAjYCAEHIsgVBADYCAEHwzgIoAgAiBSACQQEQBUHIsgUoAgAhBEHIsgVBADYCAAJAIARBAUcEQEHIsgVBADYCAEH7ACACQRBqQQAQFSEEQciyBSgCACEGQciyBUEANgIAIAZBAUcNAQsQBiEAEAcaIAIoAhghAUHIsgVBADYCACABEOgBQciyBSgCACEBQciyBUEANgIAIAFBAUcNBkEAEAshAhAHGiACEIQBAAsgBEEANgIAIAAgAxCMA0EcEP4LIQIgAUEBRw0CQciyBUEANgIAIAIgAEGIjgEQoAQaQciyBSgCACEBQciyBUEANgIAIAFBAUYNASACQQA2AhggAkIANwIQIAJBwM8CNgIAQciyBUEANgIAQdDPAigCACACQQEQBUHIsgUoAgAhAUHIsgVBADYCACABQQFHBEBByLIFQQA2AgBB3AAgAkEQakEAEBUhAUHIsgUoAgAhA0HIsgVBADYCACADQQFHDQQLEAYhABAHGiACKAIYIQFByLIFQQA2AgAgARDoAUHIsgUoAgAhAUHIsgVBADYCACABQQFHDQVBABALIQIQBxogAhCEAQALEAYhABAHGgwECxAGIQAQBxoMAwtByLIFQQA2AgAgAiAAQYiOARCgBBpByLIFKAIAIQFByLIFQQA2AgAgAUEBRwRAIAJBADYCGCACQgA3AhAgAkHgzgI2AgBByLIFQQA2AgAgBSACQQEQBUHIsgUoAgAhAUHIsgVBADYCAAJAIAFBAUcEQEHIsgVBADYCAEH7ACACQRBqQQAQFSEBQciyBSgCACEDQciyBUEANgIAIANBAUcNAQsQBiEAEAcaIAIoAhghAUHIsgVBADYCACABEOgBQciyBSgCACEBQciyBUEANgIAIAFBAUcNBEEAEAshAhAHGiACEIQBAAsgAUEANgIADAILEAYhABAHGgwCCyABQgA3AwALIAAgAhCMA0EcEP4LIQJByLIFQQA2AgAgAiAAQZGOARCgBCEBQciyBSgCACEDQciyBUEANgIAAkACQCADQQFHBEAgAkIANwEOIAJBgNECNgIAIAJCADcBFEHIsgVBADYCAEGQ0QIoAgAiAyACQQEQBUHIsgUoAgAhBEHIsgVBADYCAAJAIARBAUcEQEHIsgVBADYCAEGEAiACQRBqQQAQFSEEQciyBSgCACEGQciyBUEANgIAIAZBAUcNAQsQBiEAEAcaIAIoAhghAUHIsgVBADYCACABEOgBQciyBSgCACEBQciyBUEANgIAIAFBAUcNBEEAEAshAhAHGiACEIQBAAsgBEEANgIAIAJBAToADyAAIAEQjANBHBD+CyECQciyBUEANgIAIAIgAEGWjgEQoAQhAUHIsgUoAgAhBEHIsgVBADYCACAEQQFGDQEgAkIANwEOIAJBgNECNgIAIAJCADcBFEHIsgVBADYCACADIAJBARAFQciyBSgCACEDQciyBUEANgIAAkAgA0EBRwRAQciyBUEANgIAQYQCIAJBEGpBABAVIQNByLIFKAIAIQRByLIFQQA2AgAgBEEBRw0BCxAGIQAQBxogAigCGCEBQciyBUEANgIAIAEQ6AFByLIFKAIAIQFByLIFQQA2AgAgAUEBRw0EQQAQCyECEAcaIAIQhAEACyADQQA2AgAgAkEBOgAOIAAgARCMAyAAIABBnY4BQcYAEJsDQRwQ/gshAkHIsgVBADYCACACIABBp44BEKAEIQFByLIFKAIAIQNByLIFQQA2AgAgA0EBRg0CIAJBADYCGCACQgA3AhAgAkHgzgI2AgBByLIFQQA2AgAgBSACQQEQBUHIsgUoAgAhBUHIsgVBADYCAAJAIAVBAUcEQEHIsgVBADYCAEH7ACACQRBqQQAQFSEFQciyBSgCACEDQciyBUEANgIAIANBAUcNAQsQBiEAEAcaIAIoAhghAUHIsgVBADYCACABEOgBQciyBSgCACEBQciyBUEANgIAIAFBAUcNBEEAEAshAhAHGiACEIQBAAsgBUEANgIAIAAgARCMAw8LEAYhABAHGgwCCxAGIQAQBxoMAQsQBiEAEAcaCyACEPYMIAAQCAALrwgBCH8jAEGwAWsiAiQAAkACQAJAIAAoAgAgAU0EQCACQeg+NgJgIAJB1D42AihByLIFQQA2AgBBKSACQeAAaiIGIAJBKGpBBHIiBBAFQciyBSgCACEDQciyBUEANgIAIANBAUYNASACQoCAgIBwNwOoASACQbA+NgJgIAJBnD42AihByLIFQQA2AgBBKiAEEA0hB0HIsgUoAgAhA0HIsgVBADYCACADQQFGBEAQBiEBEAcaDAQLIAJCADcCTCACQgA3AlQgAkEQNgJcIAJBzD82AixByLIFQQA2AgBBKyACQShqQdyOAUEVEBQhBUHIsgUoAgAhA0HIsgVBADYCAAJAAkACQAJAAkACQAJAAkACQCADQQFGDQBByLIFQQA2AgBBLCAFIAEQFSEDQciyBSgCACEBQciyBUEANgIAIAFBAUYNAEHIsgVBADYCAEErIANB8o4BQQQQFCEDQciyBSgCACEBQciyBUEANgIAIAFBAUYNACAAKAIAIQFByLIFQQA2AgBBLCADIAEQFRpByLIFKAIAIQFByLIFQQA2AgAgAUEBRg0AQQQQDiEAQciyBUEANgIAQS1BMBANIQNByLIFKAIAIQFByLIFQQA2AgAgAUEBRg0BQciyBUEANgIAQS4gAkEIaiAEEAVByLIFKAIAIQFByLIFQQA2AgAgAUEBRg0CIAIoAgggAkEIaiACLAATQQBIGyIEEIgNIgFBcE8EQEHIsgVBADYCAEEvIAJBGGoQD0HIsgUoAgAhAUHIsgVBADYCACABQQFGDQQMDAsCQAJAIAFBC08EQEHIsgVBADYCAEEtIAFBEGpBcHEiCBANIQVByLIFKAIAIQlByLIFQQA2AgAgCUEBRg0GIAIgBTYCGCACIAE2AhwgAiAIQYCAgIB4cjYCIAwBCyACIAE6ACMgAkEYaiEFIAFFDQELIAUgBCABEIANGgsgASAFakEAOgAAQciyBUEANgIAQTAgAyACQRhqQcQAQfeOAUGGAUGajwEQFhpByLIFKAIAIQFByLIFQQA2AgBBASEEIAFBAUcEQCAAIAM2AgBByLIFQQA2AgBBMSAAQazdAEEAEBJByLIFKAIAIQFByLIFQQA2AgBBACEEIAFBAUcNDAsQBiEBEAcaIAIsACNBf0wEQCACKAIYEPYMCyACLAATQQBIDQQMBQsQBiEBEAcaDAcLEAYhARAHGgwFCxAGIQEQBxoMAwsQBiEBEAcaQQEhBCACLAATQQBODQILIAIoAggQ9gwLIARFDQILIAMQ9gwLIAAQEwsgAkGwPjYCYCACQZw+NgIoIAJBzD82AiwgAiwAV0F/TARAIAIoAkwQ9gwLIAcQ4AYaIAYQ3AYgARAIAAsgACgCCCEAIAJBsAFqJAAgACABQQJ0ag8LEAYhARAHGgwBCwALIAYQ3AYgARAIAAv9AQICfwF+IAAgACgCBCAAQShqEN8DIgEQnwMgACABELgCIAAQiQMQrAUhAyAAQcgAaiIAQQIQrAEoAgAhAgJAIAEEQCACIANBABCuASAAQQMQrAEoAgAgA0EAEK4BDAELIAIgA6ciAUEAENcBIABBAxCsASgCACABQQAQ1wELIABBBBCsASgCAEHoB0EAENcBIABBBhCsASgCAEMAAIA/QQAQuwIgAEEHEKwBKAIAQwAAgD9BABC7AiAAQQgQrAEoAgBBADoADCAAQQgQrAEoAgBBoI0EQcYAQQAQvwQgAEEIEKwBKAIAQQE6AAwgAEEJEKwBKAIAQQFBABDXAQvWBwEIfyMAQbABayIDJAACQAJAAkAgAC0ADARAIANB6D42AmAgA0HUPjYCKEHIsgVBADYCAEEpIANB4ABqIgcgA0EoakEEciIEEAVByLIFKAIAIQJByLIFQQA2AgAgAkEBRg0BIANCgICAgHA3A6gBIANBsD42AmAgA0GcPjYCKEHIsgVBADYCAEEqIAQQDSEIQciyBSgCACECQciyBUEANgIAIAJBAUYEQBAGIQAQBxoMBAsgA0IANwJMIANCADcCVCADQRA2AlwgA0HMPzYCLEHIsgVBADYCAEErIANBKGpBy48BQRcQFCEFQciyBSgCACECQciyBUEANgIAAkACQAJAAkACQAJAAkACQAJAIAJBAUYNACAAKAIIIgAQiA0hAkHIsgVBADYCAEErIAUgACACEBQaQciyBSgCACEAQciyBUEANgIAIABBAUYNAEEEEA4hAkHIsgVBADYCAEEtQTAQDSEFQciyBSgCACEAQciyBUEANgIAIABBAUYNAUHIsgVBADYCAEEuIANBCGogBBAFQciyBSgCACEAQciyBUEANgIAIABBAUYNAiADKAIIIANBCGogAywAE0EASBsiBBCIDSIAQXBPBEBByLIFQQA2AgBBLyADQRhqEA9ByLIFKAIAIQBByLIFQQA2AgAgAEEBRg0EDAwLAkACQCAAQQtPBEBByLIFQQA2AgBBLSAAQRBqQXBxIgkQDSEGQciyBSgCACEKQciyBUEANgIAIApBAUYNBiADIAY2AhggAyAANgIcIAMgCUGAgICAeHI2AiAMAQsgAyAAOgAjIANBGGohBiAARQ0BCyAGIAQgABCADRoLIAAgBmpBADoAAEHIsgVBADYCAEEwIAUgA0EYakECQaWPAUGLAkHjjwEQFhpByLIFKAIAIQBByLIFQQA2AgBBASEEIABBAUcEQCACIAU2AgBByLIFQQA2AgBBMSACQazdAEEAEBJByLIFKAIAIQBByLIFQQA2AgBBACEEIABBAUcNDAsQBiEAEAcaIAMsACNBf0wEQCADKAIYEPYMCyADLAATQQBIDQQMBQsQBiEAEAcaDAcLEAYhABAHGgwFCxAGIQAQBxoMAwsQBiEAEAcaQQEhBCADLAATQQBODQILIAMoAggQ9gwLIARFDQILIAUQ9gwLIAIQEwsgA0GwPjYCYCADQZw+NgIoIANBzD82AiwgAywAV0F/TARAIAMoAkwQ9gwLIAgQ4AYaIAcQ3AYgABAIAAsgAEEQaiACELkCIAE4AgAgA0GwAWokAA8LEAYhABAHGgwBCwALIAcQ3AYgABAIAAsjACAAQQBBARCOAyAAIAAQngMQuAIgAEEBQX8QjgMgABCQAwsZACAAIAFB7I8BEIIDGiAAQfyPATYCACAAC+oCAQR/IwBBEGsiASQAQQQQDiEDQciyBUEANgIAQS1BLBANIQRByLIFKAIAIQBByLIFQQA2AgACQAJAAkACQAJAIABBAUcEQEHIsgVBADYCAEEtQSAQDSEAQciyBSgCACECQciyBUEANgIAIAJBAUYNASABIAA2AgAgAUKXgICAgISAgIB/NwIEIABBADoAFyAAQa+QASkAADcADyAAQaiQASkAADcACCAAQaCQASkAADcAAEHIsgVBADYCAEEyIAQgAUG4kAFBKkHekAEQEBpByLIFKAIAIQBByLIFQQA2AgBBASECIABBAUcEQCADIAQ2AgBByLIFQQA2AgBBMSADQaDaAEEAEBJByLIFKAIAIQBByLIFQQA2AgBBACECIABBAUcNBgsQBiEAEAcaIAEsAAtBf0wEQCABKAIAEPYMCyACDQIMBAsQBiEAEAcaDAILEAYhABAHGgsgBBD2DAsgAxATCyAAEAgLAAv2AwEEfyAAIAFBjJEBEIIDIQMgAEGckQE2AgBByLIFQQA2AgBBxwEgAyADQcCRAUEGEBxByLIFKAIAIQFByLIFQQA2AgACQAJAAkACQAJAIAFBAUYNAEHIsgVBADYCAEEtQRwQDSEBQciyBSgCACECQciyBUEANgIAIAJBAUYNAEHIsgVBADYCACABIANBypEBEKAEIQJByLIFKAIAIQRByLIFQQA2AgAgBEEBRg0BIAFBADYCGCABQgA3AhAgAUGgzQI2AgBByLIFQQA2AgBBsM0CKAIAIAFBARAFQciyBSgCACEEQciyBUEANgIAAkAgBEEBRwRAQciyBUEANgIAQd4AIAFBEGpBABAVIQRByLIFKAIAIQVByLIFQQA2AgAgBUEBRw0BCxAGIQAQBxogASgCGCECQciyBUEANgIAIAIQ6AFByLIFKAIAIQJByLIFQQA2AgAgAkEBRw0DQQAQCyEBEAcaIAEQhAEACyAEQQA7AQBByLIFQQA2AgBB2wAgAyACEAVByLIFKAIAIQFByLIFQQA2AgAgAUEBRg0AQciyBUEANgIAQa8BIANB3ZEBQQFBARAcQciyBSgCACEBQciyBUEANgIAIAFBAUcNBAsQBiEAEAcaDAILEAYhABAHGgsgARD2DAsgAxCEAxogABAIAAsgAAuBDQEFfyAAIAFBjJIBEIIDIQEgAEGckgE2AgBByLIFQQA2AgBBxwEgASABQcCSAUEGEBxByLIFKAIAIQJByLIFQQA2AgACQAJAAkACQAJAAkACQAJAAkACQCACQQFGDQBByLIFQQA2AgBBLUEcEA0hAkHIsgUoAgAhA0HIsgVBADYCACADQQFGDQBByLIFQQA2AgAgAiABQcqSARCgBCEFQciyBSgCACEDQciyBUEANgIAIANBAUYNASACQQA2AhggAkIANwIQIAJBoM0CNgIAQciyBUEANgIAQbDNAigCACIDIAJBARAFQciyBSgCACEEQciyBUEANgIAAkAgBEEBRwRAQciyBUEANgIAQd4AIAJBEGpBABAVIQRByLIFKAIAIQZByLIFQQA2AgAgBkEBRw0BCxAGIQAQBxogAigCGCEDQciyBUEANgIAIAMQ6AFByLIFKAIAIQNByLIFQQA2AgAgA0EBRw0DQQAQCyEBEAcaIAEQhAEACyAEQQA7AQBByLIFQQA2AgBB2wAgASAFEAVByLIFKAIAIQJByLIFQQA2AgAgAkEBRg0AQciyBUEANgIAQccBIAEgAUHdkgFBEBAcQciyBSgCACECQciyBUEANgIAIAJBAUYNAEHIsgVBADYCAEEtQRwQDSECQciyBSgCACEFQciyBUEANgIAIAVBAUYNAEHIsgVBADYCACACIAFB55IBEKAEIQVByLIFKAIAIQRByLIFQQA2AgAgBEEBRg0DIAJBADYCGCACQgA3AhAgAkGgzQI2AgBByLIFQQA2AgAgAyACQQEQBUHIsgUoAgAhBEHIsgVBADYCAAJAIARBAUcEQEHIsgVBADYCAEHeACACQRBqQQAQFSEEQciyBSgCACEGQciyBUEANgIAIAZBAUcNAQsQBiEAEAcaIAIoAhghA0HIsgVBADYCACADEOgBQciyBSgCACEDQciyBUEANgIAIANBAUcNBUEAEAshARAHGiABEIQBAAsgBEEAOwEAQciyBUEANgIAQdsAIAEgBRAFQciyBSgCACECQciyBUEANgIAIAJBAUYNAEHIsgVBADYCAEEtQRwQDSECQciyBSgCACEFQciyBUEANgIAIAVBAUYNAEHIsgVBADYCACACIAFB7ZIBEKAEIQVByLIFKAIAIQRByLIFQQA2AgAgBEEBRg0FIAJBADYCGCACQgA3AhAgAkGgzQI2AgBByLIFQQA2AgAgAyACQQEQBUHIsgUoAgAhA0HIsgVBADYCAAJAIANBAUcEQEHIsgVBADYCAEHeACACQRBqQQAQFSEDQciyBSgCACEEQciyBUEANgIAIARBAUcNAQsQBiEAEAcaIAIoAhghA0HIsgVBADYCACADEOgBQciyBSgCACEDQciyBUEANgIAIANBAUcNB0EAEAshARAHGiABEIQBAAsgA0EAOwEAQciyBUEANgIAQdsAIAEgBRAFQciyBSgCACECQciyBUEANgIAIAJBAUYNAEHIsgVBADYCAEHHASABIAFB9JIBQQ4QHEHIsgUoAgAhAkHIsgVBADYCACACQQFGDQBByLIFQQA2AgBBLUEkEA0hAkHIsgUoAgAhA0HIsgVBADYCACADQQFGDQdByLIFQQA2AgBB/QAgAiABQf6SAUEAQQBBABAWIQNByLIFKAIAIQVByLIFQQA2AgAgBUEBRg0IIAJBAToADyACQSA2AhRByLIFQQA2AgBByAEgA0GNkwFBABASQciyBSgCACEDQciyBUEANgIAIANBAUYNB0HIsgVBADYCAEHbACABIAIQBUHIsgUoAgAhAkHIsgVBADYCACACQQFGDQdByLIFQQA2AgBBxwEgASABQY6TAUEEEBxByLIFKAIAIQJByLIFQQA2AgAgAkEBRg0HQciyBUEANgIAQa8BIAFBmJMBQQBBARAcQciyBSgCACECQciyBUEANgIAIAJBAUYNB0HIsgVBADYCAEGvASABQZ2TAUEBQQEQHEHIsgUoAgAhAkHIsgVBADYCACACQQFGDQdByLIFQQA2AgBBrwEgAUGikwFBAEEBEBxByLIFKAIAIQJByLIFQQA2AgAgAkEBRg0HIAAPCxAGIQAQBxoMCAsQBiEAEAcaCyACEPYMDAYLEAYhABAHGgsgAhD2DAwECxAGIQAQBxoLIAIQ9gwMAgsQBiEAEAcaDAELEAYhABAHGiACEPYMCyABEIQDGiAAEAgAC4QBACAAEIkDIABByABqIgBBARCsASgCAEEBQQAQ3QEgAEEFEKwBKAIAQQA6AAwgAEEFEKwBKAIAQeaNBEEOQQAQvwQgAEEFEKwBKAIAQQE6AAwgAEEHEKwBKAIAQQA6AAwgAEEHEKwBKAIAQfSNBEEEQQAQvwQgAEEHEKwBKAIAQQE6AAwLWQEBfyAAIAFB0JMBEIIDIQEgAEHgkwE2AgBByLIFQQA2AgBB0QEgARAPQciyBSgCACECQciyBUEANgIAIAJBAUcEQCAADwsQBiEAEAcaIAEQhAMaIAAQCAAL5xQBBX8gACABQayUARCCAyEBIABBvJQBNgIAQciyBUEANgIAQdEBIAEQD0HIsgUoAgAhAkHIsgVBADYCAAJAAkACQAJAAkACQAJAAkACQAJAAkACQAJAAkACQAJAAkACQCACQQFGDQBByLIFQQA2AgBBLUEcEA0hAkHIsgUoAgAhA0HIsgVBADYCACADQQFGDQBByLIFQQA2AgAgAiABQeCUARCgBCEDQciyBSgCACEEQciyBUEANgIAIARBAUYNASACQQA2AhggAkIANwIQIAJBkMwCNgIAQciyBUEANgIAQaDMAigCACIEIAJBARAFQciyBSgCACEFQciyBUEANgIAAkAgBUEBRwRAQciyBUEANgIAQdkAIAJBEGpBABAVIQVByLIFKAIAIQZByLIFQQA2AgAgBkEBRw0BCxAGIQAQBxogAigCGCEDQciyBUEANgIAIAMQ6AFByLIFKAIAIQNByLIFQQA2AgAgA0EBRw0DQQAQCyEBEAcaIAEQhAEACyAFQQA6AABByLIFQQA2AgBB2wAgASADEAVByLIFKAIAIQJByLIFQQA2AgAgAkEBRg0AQciyBUEANgIAQS1BHBANIQJByLIFKAIAIQNByLIFQQA2AgAgA0EBRg0AQciyBUEANgIAIAIgAUHxlAEQoAQhA0HIsgUoAgAhBUHIsgVBADYCACAFQQFGDQMgAkEANgIYIAJCADcCECACQZDMAjYCAEHIsgVBADYCACAEIAJBARAFQciyBSgCACEEQciyBUEANgIAAkAgBEEBRwRAQciyBUEANgIAQdkAIAJBEGpBABAVIQRByLIFKAIAIQVByLIFQQA2AgAgBUEBRw0BCxAGIQAQBxogAigCGCEDQciyBUEANgIAIAMQ6AFByLIFKAIAIQNByLIFQQA2AgAgA0EBRw0FQQAQCyEBEAcaIAEQhAEACyAEQQA6AABByLIFQQA2AgBB2wAgASADEAVByLIFKAIAIQJByLIFQQA2AgAgAkEBRg0AQciyBUEANgIAQS1BHBANIQJByLIFKAIAIQNByLIFQQA2AgAgA0EBRg0AQciyBUEANgIAIAIgAUGDlQEQoAQhA0HIsgUoAgAhBEHIsgVBADYCACAEQQFGDQUgAkEANgIYIAJCADcCECACQcDPAjYCAEHIsgVBADYCAEHQzwIoAgAgAkEBEAVByLIFKAIAIQRByLIFQQA2AgACQCAEQQFHBEBByLIFQQA2AgBB3AAgAkEQakEAEBUhBEHIsgUoAgAhBUHIsgVBADYCACAFQQFHDQELEAYhABAHGiACKAIYIQNByLIFQQA2AgAgAxDoAUHIsgUoAgAhA0HIsgVBADYCACADQQFHDQdBABALIQEQBxogARCEAQALIARCADcDAEHIsgVBADYCAEHbACABIAMQBUHIsgUoAgAhAkHIsgVBADYCACACQQFGDQBByLIFQQA2AgBBLUEcEA0hAkHIsgUoAgAhA0HIsgVBADYCACADQQFGDQBByLIFQQA2AgAgAiABQZOVARCgBCEEQciyBSgCACEDQciyBUEANgIAIANBAUYNByACQQA2AhggAkIANwIQIAJBoM0CNgIAQciyBUEANgIAQbDNAigCACIDIAJBARAFQciyBSgCACEFQciyBUEANgIAAkAgBUEBRwRAQciyBUEANgIAQd4AIAJBEGpBABAVIQVByLIFKAIAIQZByLIFQQA2AgAgBkEBRw0BCxAGIQAQBxogAigCGCEDQciyBUEANgIAIAMQ6AFByLIFKAIAIQNByLIFQQA2AgAgA0EBRw0JQQAQCyEBEAcaIAEQhAEACyAFQQA7AQBByLIFQQA2AgBB2wAgASAEEAVByLIFKAIAIQJByLIFQQA2AgAgAkEBRg0AQciyBUEANgIAQS1BHBANIQJByLIFKAIAIQRByLIFQQA2AgAgBEEBRg0AQciyBUEANgIAIAIgAUGjlQEQoAQhBEHIsgUoAgAhBUHIsgVBADYCACAFQQFGDQkgAkEANgIYIAJCADcCECACQaDNAjYCAEHIsgVBADYCACADIAJBARAFQciyBSgCACEFQciyBUEANgIAAkAgBUEBRwRAQciyBUEANgIAQd4AIAJBEGpBABAVIQVByLIFKAIAIQZByLIFQQA2AgAgBkEBRw0BCxAGIQAQBxogAigCGCEDQciyBUEANgIAIAMQ6AFByLIFKAIAIQNByLIFQQA2AgAgA0EBRw0LQQAQCyEBEAcaIAEQhAEACyAFQQA7AQBByLIFQQA2AgBB2wAgASAEEAVByLIFKAIAIQJByLIFQQA2AgAgAkEBRg0AQciyBUEANgIAQS1BHBANIQJByLIFKAIAIQRByLIFQQA2AgAgBEEBRg0AQciyBUEANgIAIAIgAUG5lQEQoAQhBEHIsgUoAgAhBUHIsgVBADYCACAFQQFGDQsgAkEANgIYIAJCADcCECACQaDNAjYCAEHIsgVBADYCACADIAJBARAFQciyBSgCACEDQciyBUEANgIAAkAgA0EBRwRAQciyBUEANgIAQd4AIAJBEGpBABAVIQNByLIFKAIAIQVByLIFQQA2AgAgBUEBRw0BCxAGIQAQBxogAigCGCEDQciyBUEANgIAIAMQ6AFByLIFKAIAIQNByLIFQQA2AgAgA0EBRw0NQQAQCyEBEAcaIAEQhAEACyADQQA7AQBByLIFQQA2AgBB2wAgASAEEAVByLIFKAIAIQJByLIFQQA2AgAgAkEBRg0AQciyBUEANgIAQS1BJBANIQJByLIFKAIAIQNByLIFQQA2AgAgA0EBRg0AQciyBUEANgIAQf0AIAIgAUHOlQFBAEEAQQAQFhpByLIFKAIAIQNByLIFQQA2AgAgA0EBRg0NIAJBqJYBNgIAQciyBUEANgIAQdsAIAEgAhAFQciyBSgCACECQciyBUEANgIAIAJBAUYNAEHIsgVBADYCAEEtQSQQDSECQciyBSgCACEDQciyBUEANgIAIANBAUYNAEHIsgVBADYCAEH9ACACIAFB2JUBQQBBAEEAEBYaQciyBSgCACEDQciyBUEANgIAIANBAUYNDiACQaiWATYCAEHIsgVBADYCAEHbACABIAIQBUHIsgUoAgAhAkHIsgVBADYCACACQQFGDQBByLIFQQA2AgBBLUEwEA0hAkHIsgUoAgAhA0HIsgVBADYCACADQQFGDQBByLIFQQA2AgBB4AAgAiABQeiVAUEAQQAQEBpByLIFKAIAIQNByLIFQQA2AgAgA0EBRg0PQciyBUEANgIAQdsAIAEgAhAFQciyBSgCACECQciyBUEANgIAIAJBAUcNEQsQBiEAEAcaDA8LEAYhABAHGgsgAhD2DAwNCxAGIQAQBxoLIAIQ9gwMCwsQBiEAEAcaCyACEPYMDAkLEAYhABAHGgsgAhD2DAwHCxAGIQAQBxoLIAIQ9gwMBQsQBiEAEAcaCyACEPYMDAMLEAYhABAHGiACEPYMDAILEAYhABAHGiACEPYMDAELEAYhABAHGiACEPYMCyABEIQDGiAAEAgACyAACwoAIAAQhAMaIAALjgEBAn8gAEEAQQgQjgMgAEHIAGoiAUEFEKwBKAIAIQIgAUEIEKwBKAIAIAJBEGpBABCqAS8BADYCFCABQQYQrAEoAgAhAiABQQkQrAEoAgAgAkEQakEAEKoBLwEANgIUIAFBBxCsASgCACECIAFBChCsASgCACACQRBqQQAQqgEvAQAQwQQgAEEIQQMQjgMLDQAgABCxBBogABD2DAsEAEEGCwcAIAAoAhgLWQEEfyAAQRhqIgMgAhCJAigCABDoASAAKAIUIgZBAWoiBSAGTwRAIAUQ4wEiBEEAIAUQgQ0aCyADIAIQiQIgBDYCACABIAMgAhCJAigCACAAKAIUQQAQswMLGQAgASAAQRhqIAIQiQIoAgAgACgCFBC1AwvuBQEFfyAAIAFBhJcBEIIDIQUgAEGUlwE2AgBByLIFQQA2AgBBLUEcEA0hAUHIsgUoAgAhAkHIsgVBADYCAAJAAkACQAJAAkACQAJAIAJBAUYNAEHIsgVBADYCACABIAVBuJcBEKAEIQJByLIFKAIAIQNByLIFQQA2AgAgA0EBRg0BIAFBADYCGCABQgA3AhAgAUHgzgI2AgBByLIFQQA2AgBB8M4CKAIAIgMgAUEBEAVByLIFKAIAIQRByLIFQQA2AgACQCAEQQFHBEBByLIFQQA2AgBB+wAgAUEQakEAEBUhBEHIsgUoAgAhBkHIsgVBADYCACAGQQFHDQELEAYhABAHGiABKAIYIQJByLIFQQA2AgAgAhDoAUHIsgUoAgAhAkHIsgVBADYCACACQQFHDQNBABALIQEQBxogARCEAQALIARBADYCAEHIsgVBADYCAEHbACAFIAIQBUHIsgUoAgAhAUHIsgVBADYCACABQQFGDQBByLIFQQA2AgBBLUEcEA0hAUHIsgUoAgAhAkHIsgVBADYCACACQQFGDQBByLIFQQA2AgAgASAFQcGXARCgBCECQciyBSgCACEEQciyBUEANgIAIARBAUYNAyABQQA2AhggAUIANwIQIAFB4M4CNgIAQciyBUEANgIAIAMgAUEBEAVByLIFKAIAIQNByLIFQQA2AgACQCADQQFHBEBByLIFQQA2AgBB+wAgAUEQakEAEBUhA0HIsgUoAgAhBEHIsgVBADYCACAEQQFHDQELEAYhABAHGiABKAIYIQJByLIFQQA2AgAgAhDoAUHIsgUoAgAhAkHIsgVBADYCACACQQFHDQVBABALIQEQBxogARCEAQALIANBADYCAEHIsgVBADYCAEHbACAFIAIQBUHIsgUoAgAhAUHIsgVBADYCACABQQFHDQYLEAYhABAHGgwECxAGIQAQBxoLIAEQ9gwMAgsQBiEAEAcaCyABEPYMCyAFEIQDGiAAEAgACyAACy8AIAAQiQMgAEHIAGoiAEEAEKwBKAIAQQFBABDXASAAQQEQrAEoAgBBAUEAENcBCxkAIAAgAUH0lwEQggMaIABBhJgBNgIAIAAL8ggBBX8gACAAQaiYAUEGEJsDQRwQ/gshAUHIsgVBADYCACABIABBspgBEKAEIQRByLIFKAIAIQJByLIFQQA2AgACQAJAAkACQCACQQFHBEAgAUEANgIYIAFCADcCECABQaDNAjYCAEHIsgVBADYCAEGwzQIoAgAiAiABQQEQBUHIsgUoAgAhA0HIsgVBADYCAAJAIANBAUcEQEHIsgVBADYCAEHeACABQRBqQQAQFSEDQciyBSgCACEFQciyBUEANgIAIAVBAUcNAQsQBiEAEAcaIAEoAhghAkHIsgVBADYCACACEOgBQciyBSgCACECQciyBUEANgIAIAJBAUcNBUEAEAshARAHGiABEIQBAAsgA0EAOwEAIAAgBBCMA0EcEP4LIQFByLIFQQA2AgAgASAAQcWYARCgBCEEQciyBSgCACEDQciyBUEANgIAIANBAUYNASABQQA2AhggAUIANwIQIAFBoM0CNgIAQciyBUEANgIAIAIgAUEBEAVByLIFKAIAIQNByLIFQQA2AgACQCADQQFHBEBByLIFQQA2AgBB3gAgAUEQakEAEBUhA0HIsgUoAgAhBUHIsgVBADYCACAFQQFHDQELEAYhABAHGiABKAIYIQJByLIFQQA2AgAgAhDoAUHIsgUoAgAhAkHIsgVBADYCACACQQFHDQVBABALIQEQBxogARCEAQALIANBADsBACAAIAQQjANBHBD+CyEBQciyBUEANgIAIAEgAEHWmAEQoAQhBEHIsgUoAgAhA0HIsgVBADYCACADQQFGDQIgAUEANgIYIAFCADcCECABQaDNAjYCAEHIsgVBADYCACACIAFBARAFQciyBSgCACECQciyBUEANgIAAkAgAkEBRwRAQciyBUEANgIAQd4AIAFBEGpBABAVIQJByLIFKAIAIQNByLIFQQA2AgAgA0EBRw0BCxAGIQAQBxogASgCGCECQciyBUEANgIAIAIQ6AFByLIFKAIAIQJByLIFQQA2AgAgAkEBRw0FQQAQCyEBEAcaIAEQhAEACyACQQA7AQAgACAEEIwDQRwQ/gshAUHIsgVBADYCACABIABB75gBEKAEIQJByLIFKAIAIQRByLIFQQA2AgAgBEEBRg0DIAFBADYCGCABQgA3AhAgAUHgzgI2AgBByLIFQQA2AgBB8M4CKAIAIAFBARAFQciyBSgCACEEQciyBUEANgIAAkAgBEEBRwRAQciyBUEANgIAQfsAIAFBEGpBABAVIQRByLIFKAIAIQNByLIFQQA2AgAgA0EBRw0BCxAGIQAQBxogASgCGCECQciyBUEANgIAIAIQ6AFByLIFKAIAIQJByLIFQQA2AgAgAkEBRw0FQQAQCyEBEAcaIAEQhAEACyAEQQA2AgAgACACEIwDIABB/ZgBQQFBARCcAyAAQYKZAUEAQQEQnAMgAEGHmQFBAEEBEJwDDwsQBiEAEAcaDAMLEAYhABAHGgwCCxAGIQAQBxoMAQsQBiEAEAcaCyABEPYMIAAQCAALtQEBAn9BJBD+CyEBQciyBUEANgIAQf0AIAEgAEGMmQFBAEEAQQAQFhpByLIFKAIAIQJByLIFQQA2AgACQAJAIAJBAUcEQCABQQQ2AhQgACABEIwDQSQQ/gshAUHIsgVBADYCAEH9ACABIABBnpkBQQBBAEEAEBYaQciyBSgCACECQciyBUEANgIAIAJBAUYNASAAIAEQjAMPCxAGIQAQBxoMAQsQBiEAEAcaCyABEPYMIAAQCAALzgQBBH8jAEEgayICJAAgACgCQCIBRQRAQQQQDiEAQciyBUEANgIAQS1BLBANIQNByLIFKAIAIQFByLIFQQA2AgACQAJAAkACQAJAIAFBAUcEQEHIsgVBADYCAEEtQSAQDSEBQciyBSgCACEEQciyBUEANgIAIARBAUYNASACIAE2AhAgAkKfgICAgISAgIB/NwIUIAFBADoAHyABQb2ZASkAADcAFyABQbaZASkAADcAECABQa6ZASkAADcACCABQaaZASkAADcAAEHIsgVBADYCAEEyIAMgAkEQakHGmQFBxwBB65kBEBAaQciyBSgCACEBQciyBUEANgIAQQEhBCABQQFGDQIgACADNgIAQciyBUEANgIAQTEgAEGg2gBBABASQciyBSgCACEBQciyBUEANgIAQQAhBCABQQFGDQIACxAGIQEQBxoMAwsQBiEBEAcaDAELEAYhARAHGiACLAAbQX9MBEAgAigCEBD2DAsgBEUNAgsgAxD2DAsgABATCyABEAgACwJAIAFBKGoiAUH0mQEQgwZFBEAgABDOAiAAEIkDIABByABqIgBBARCsASgCAEEBQQAQ3QEgAEECEKwBKAIAQQFBABDdASAAQQMQrAEoAgBBAUEAEN0BDAELIAFB+ZkBEIMGRQRAIAAQzwIgABCJAyAAQcgAakEAEKwBKAIAQbmaAUEAELUEDAELIAAoAgQQ2QMiACgCACEBIAAsAAshAyACQeuZATYCACACIAEgACADQQBIGzYCBEH+mQEgAhC8AQsgAkEgaiQAC9IDAQR/IwBBEGsiAiQAIAAoAkAiAUUEQEEEEA4hAEHIsgVBADYCAEEtQSwQDSEEQciyBSgCACEBQciyBUEANgIAAkACQAJAAkACQCABQQFHBEBByLIFQQA2AgBBLUEgEA0hAUHIsgUoAgAhA0HIsgVBADYCACADQQFGDQEgAiABNgIAIAJCn4CAgICEgICAfzcCBCABQQA6AB8gAUG9mQEpAAA3ABcgAUG2mQEpAAA3ABAgAUGumQEpAAA3AAggAUGmmQEpAAA3AABByLIFQQA2AgBBMiAEIAJBxpkBQecAQb6aARAQGkHIsgUoAgAhAUHIsgVBADYCAEEBIQMgAUEBRg0CIAAgBDYCAEHIsgVBADYCAEExIABBoNoAQQAQEkHIsgUoAgAhAUHIsgVBADYCAEEAIQMgAUEBRg0CAAsQBiEBEAcaDAMLEAYhARAHGgwBCxAGIQEQBxogAiwAC0F/TARAIAIoAgAQ9gwLIANFDQILIAQQ9gwLIAAQEwsgARAIAAsCQCABQShqIgFB9JkBEIMGRQRAIAAQzgIgABCNAwwBCyABQfmZARCDBkUEQCAAEM8CIAAQ0gIMAQtBw5oBQQAQvQELIAAQkAMgAkEQaiQAC9kDAQV/IwBBEGsiAiQAIABBAEEBEI4DIAApAxAgACgCBEEAELADfaciA0EBahDjASIBRQRAQQQQDiEAQciyBUEANgIAQS1BLBANIQNByLIFKAIAIQFByLIFQQA2AgACQAJAAkACQAJAIAFBAUcEQEHIsgVBADYCAEEtQSAQDSEBQciyBSgCACEFQciyBUEANgIAQQEhBCAFQQFGDQEgAiABNgIAIAJCnICAgICEgICAfzcCBCABQQA6ABwgAUGImwEoAAA2ABggAUGAmwEpAAA3ABAgAUH4mgEpAAA3AAggAUHwmgEpAAA3AABByLIFQQA2AgBBMiADIAJBxpkBQYEBQY2bARAQGkHIsgUoAgAhAUHIsgVBADYCACABQQFGDQIgACADNgIAQQAhBEHIsgVBADYCAEExIABBoNoAQQAQEkHIsgUoAgAhAUHIsgVBADYCACABQQFGDQIACxAGIQEQBxoMAwsQBiEBEAcaDAELEAYhARAHGiACLAALQX9MBEAgAigCABD2DAsgBEUNAgsgAxD2DAsgABATCyABEAgACyAAKAIEIAEgA0EAELMDIAEgA2pBADoAACAAQcgAakEBEKwBKAIAIAFBABC1BCABEOgBIAJBEGokAAtMAQF/IAAoAkBBKGpB+ZkBEIMGRQRAIABByABqQQEQrAEoAgAiASABQRhqQQAQiQIoAgAQiA02AhQgABCVAyABQQA2AhQPCyAAEJUDC4oKAQV/IAAgAUHAmwEQggMhASAAQdCbATYCAEHIsgVBADYCAEHHASABIAFB9JsBQQYQHEHIsgUoAgAhAkHIsgVBADYCAAJAAkACQAJAAkACQAJAAkACQCACQQFGDQBByLIFQQA2AgBBLUEcEA0hAkHIsgUoAgAhA0HIsgVBADYCACADQQFGDQBByLIFQQA2AgAgAiABQf6bARCgBCEFQciyBSgCACEDQciyBUEANgIAIANBAUYNASACQQA2AhggAkIANwIQIAJBoM0CNgIAQciyBUEANgIAQbDNAigCACIDIAJBARAFQciyBSgCACEEQciyBUEANgIAAkAgBEEBRwRAQciyBUEANgIAQd4AIAJBEGpBABAVIQRByLIFKAIAIQZByLIFQQA2AgAgBkEBRw0BCxAGIQAQBxogAigCGCEDQciyBUEANgIAIAMQ6AFByLIFKAIAIQNByLIFQQA2AgAgA0EBRw0DQQAQCyEBEAcaIAEQhAEACyAEQQA7AQBByLIFQQA2AgBB2wAgASAFEAVByLIFKAIAIQJByLIFQQA2AgAgAkEBRg0AQciyBUEANgIAQccBIAEgAUGRnAFBEBAcQciyBSgCACECQciyBUEANgIAIAJBAUYNAEHIsgVBADYCAEEtQRwQDSECQciyBSgCACEFQciyBUEANgIAIAVBAUYNAEHIsgVBADYCACACIAFBm5wBEKAEIQVByLIFKAIAIQRByLIFQQA2AgAgBEEBRg0DIAJBADYCGCACQgA3AhAgAkGgzQI2AgBByLIFQQA2AgAgAyACQQEQBUHIsgUoAgAhBEHIsgVBADYCAAJAIARBAUcEQEHIsgVBADYCAEHeACACQRBqQQAQFSEEQciyBSgCACEGQciyBUEANgIAIAZBAUcNAQsQBiEAEAcaIAIoAhghA0HIsgVBADYCACADEOgBQciyBSgCACEDQciyBUEANgIAIANBAUcNBUEAEAshARAHGiABEIQBAAsgBEEAOwEAQciyBUEANgIAQdsAIAEgBRAFQciyBSgCACECQciyBUEANgIAIAJBAUYNAEHIsgVBADYCAEEtQRwQDSECQciyBSgCACEFQciyBUEANgIAIAVBAUYNAEHIsgVBADYCACACIAFBoZwBEKAEIQVByLIFKAIAIQRByLIFQQA2AgAgBEEBRg0FIAJBADYCGCACQgA3AhAgAkGgzQI2AgBByLIFQQA2AgAgAyACQQEQBUHIsgUoAgAhA0HIsgVBADYCAAJAIANBAUcEQEHIsgVBADYCAEHeACACQRBqQQAQFSEDQciyBSgCACEEQciyBUEANgIAIARBAUcNAQsQBiEAEAcaIAIoAhghA0HIsgVBADYCACADEOgBQciyBSgCACEDQciyBUEANgIAIANBAUcNB0EAEAshARAHGiABEIQBAAsgA0EAOwEAQciyBUEANgIAQdsAIAEgBRAFQciyBSgCACECQciyBUEANgIAIAJBAUYNAEHIsgVBADYCAEHHASABIAFBqJwBQTIQHEHIsgUoAgAhAkHIsgVBADYCACACQQFGDQBByLIFQQA2AgBBrwEgAUGynAFBAUEBEBxByLIFKAIAIQJByLIFQQA2AgAgAkEBRw0ICxAGIQAQBxoMBgsQBiEAEAcaCyACEPYMDAQLEAYhABAHGgsgAhD2DAwCCxAGIQAQBxoLIAIQ9gwLIAEQhAMaIAAQCAALIAALUQAgABCJAyAAQcgAaiIAQQEQrAEoAgBBAUEAEN0BIABBBRCsASgCAEEAOgAMIABBBRCsASgCAEGAjgRBMkEAEL8EIABBBRCsASgCAEEBOgAMC7AHAQR/IAAgASACEIIDIQEgAEHonAE2AgBByLIFQQA2AgBBxwEgASABQYydAUEGEBxByLIFKAIAIQJByLIFQQA2AgACQAJAAkACQAJAAkACQCACQQFGDQBByLIFQQA2AgBBLUEcEA0hAkHIsgUoAgAhA0HIsgVBADYCACADQQFGDQBByLIFQQA2AgAgAiABQZadARCgBCEDQciyBSgCACEEQciyBUEANgIAIARBAUYNASACQQA2AhggAkIANwIQIAJBoM0CNgIAQciyBUEANgIAQbDNAigCACIEIAJBARAFQciyBSgCACEFQciyBUEANgIAAkAgBUEBRwRAQciyBUEANgIAQd4AIAJBEGpBABAVIQVByLIFKAIAIQZByLIFQQA2AgAgBkEBRw0BCxAGIQAQBxogAigCGCEDQciyBUEANgIAIAMQ6AFByLIFKAIAIQNByLIFQQA2AgAgA0EBRw0DQQAQCyEBEAcaIAEQhAEACyAFQQA7AQBByLIFQQA2AgBB2wAgASADEAVByLIFKAIAIQJByLIFQQA2AgAgAkEBRg0AQciyBUEANgIAQccBIAEgAUGpnQFBEBAcQciyBSgCACECQciyBUEANgIAIAJBAUYNAEHIsgVBADYCAEEtQRwQDSECQciyBSgCACEDQciyBUEANgIAIANBAUYNAEHIsgVBADYCACACIAFBs50BEKAEIQNByLIFKAIAIQVByLIFQQA2AgAgBUEBRg0DIAJBADYCGCACQgA3AhAgAkGgzQI2AgBByLIFQQA2AgAgBCACQQEQBUHIsgUoAgAhBEHIsgVBADYCAAJAIARBAUcEQEHIsgVBADYCAEHeACACQRBqQQAQFSEEQciyBSgCACEFQciyBUEANgIAIAVBAUcNAQsQBiEAEAcaIAIoAhghA0HIsgVBADYCACADEOgBQciyBSgCACEDQciyBUEANgIAIANBAUcNBUEAEAshARAHGiABEIQBAAsgBEEAOwEAQciyBUEANgIAQdsAIAEgAxAFQciyBSgCACECQciyBUEANgIAIAJBAUYNAEHIsgVBADYCAEHHASABIAFBvZ0BQQIQHEHIsgUoAgAhAkHIsgVBADYCACACQQFGDQBByLIFQQA2AgBBrwEgAUHHnQFBAUEBEBxByLIFKAIAIQJByLIFQQA2AgAgAkEBRw0GCxAGIQAQBxoMBAsQBiEAEAcaCyACEPYMDAILEAYhABAHGgsgAhD2DAsgARCEAxogABAIAAsgAAtRACAAEIkDIABByABqIgBBARCsASgCAEEBQQAQ3QEgAEECEKwBKAIAQQA6AAwgAEECEKwBKAIAQcCOBEEQQQAQvwQgAEECEKwBKAIAQQE6AAwL1AEBAX8gACABQfSdARDxASAAQYSeATYCAEHIsgVBADYCAEEtQTAQDSEBQciyBSgCACECQciyBUEANgIAAkACQAJAIAJBAUcEQEHIsgVBADYCAEHgACABIABBqJ4BQQBBABAQGkHIsgUoAgAhAkHIsgVBADYCACACQQFGDQEgACABNgJ0QciyBUEANgIAQdsAIAAgARAFQciyBSgCACEBQciyBUEANgIAIAFBAUcNAwsQBiECEAcaDAELEAYhAhAHGiABEPYMCyAAEIQDGiACEAgACyAAC/4EAQF/IAAgAUHUngEQggMhASAAQeSeATYCAEHIsgVBADYCAEGvASABQYifAUEBQQEQHEHIsgUoAgAhAkHIsgVBADYCAAJAIAJBAUYNAEHIsgVBADYCAEGvASABQY2fAUEBQQEQHEHIsgUoAgAhAkHIsgVBADYCACACQQFGDQBByLIFQQA2AgBBrwEgAUGSnwFBAEEBEBxByLIFKAIAIQJByLIFQQA2AgAgAkEBRg0AQciyBUEANgIAQa8BIAFBl58BQQFBARAcQciyBSgCACECQciyBUEANgIAIAJBAUYNAEHIsgVBADYCAEGvASABQZyfAUEAQQEQHEHIsgUoAgAhAkHIsgVBADYCACACQQFGDQBByLIFQQA2AgBBrwEgAUGhnwFBAUEBEBxByLIFKAIAIQJByLIFQQA2AgAgAkEBRg0AQciyBUEANgIAQa8BIAFBpp8BQQBBARAcQciyBSgCACECQciyBUEANgIAIAJBAUYNAEHIsgVBADYCAEGvASABQaufAUEAQQEQHEHIsgUoAgAhAkHIsgVBADYCACACQQFGDQBByLIFQQA2AgBBrwEgAUGwnwFBAEEBEBxByLIFKAIAIQJByLIFQQA2AgAgAkEBRg0AQciyBUEANgIAQa8BIAFBtZ8BQQBBARAcQciyBSgCACECQciyBUEANgIAIAJBAUYNAEHIsgVBADYCAEGvASABQbqfAUEAQQEQHEHIsgUoAgAhAkHIsgVBADYCACACQQFGDQBByLIFQQA2AgBBrwEgAUG/nwFBAEEBEBxByLIFKAIAIQJByLIFQQA2AgAgAkEBRg0AIAAPCxAGIQAQBxogARCEAxogABAIAAtRAQF/IAAQiQMgACgCBCAAQShqEN8DIQEgACgCBCAAQaufAUGmnwEgARsQhwMiASAANgJAIABB4ABqIAEgACgCYBDpASABIAEoAgAoAggRAQALyQgBBH8gACABQeyfARCCAyEBIABB/J8BNgIAQciyBUEANgIAQdEBIAEQD0HIsgUoAgAhAkHIsgVBADYCAAJAAkACQAJAIAJBAUcEQEHIsgVBADYCAEEtQRwQDSECQciyBSgCACEDQciyBUEANgIAIANBAUYNAUHIsgVBADYCACACIAFBoKABEKAEIQNByLIFKAIAIQRByLIFQQA2AgAgBEEBRg0CIAJBADYCGCACQgA3AhAgAkHgzgI2AgBByLIFQQA2AgBB8M4CKAIAIAJBARAFQciyBSgCACEEQciyBUEANgIAAkAgBEEBRwRAQciyBUEANgIAQfsAIAJBEGpBABAVIQRByLIFKAIAIQVByLIFQQA2AgAgBUEBRw0BCxAGIQAQBxogAigCGCEDQciyBUEANgIAIAMQ6AFByLIFKAIAIQNByLIFQQA2AgAgA0EBRw0EQQAQCyEBEAcaIAEQhAEACyAEQQA2AgAgAkEBOgAMQciyBUEANgIAQdsAIAEgAxAFQciyBSgCACECQciyBUEANgIAIAJBAUYNAUHIsgVBADYCAEGvASABQaugAUEAQQAQHEHIsgUoAgAhAkHIsgVBADYCACACQQFGDQFByLIFQQA2AgBBrwEgAUGwoAFBAEEAEBxByLIFKAIAIQJByLIFQQA2AgAgAkEBRg0BQciyBUEANgIAQa8BIAFBtaABQQBBABAcQciyBSgCACECQciyBUEANgIAIAJBAUYNAUHIsgVBADYCAEGvASABQbqgAUEAQQAQHEHIsgUoAgAhAkHIsgVBADYCACACQQFGDQFByLIFQQA2AgBBrwEgAUG/oAFBAEEAEBxByLIFKAIAIQJByLIFQQA2AgAgAkEBRg0BQciyBUEANgIAQa8BIAFBxKABQQBBABAcQciyBSgCACECQciyBUEANgIAIAJBAUYNAUHIsgVBADYCAEGvASABQcmgAUEAQQAQHEHIsgUoAgAhAkHIsgVBADYCACACQQFGDQFByLIFQQA2AgBBrwEgAUHOoAFBAEEAEBxByLIFKAIAIQJByLIFQQA2AgAgAkEBRg0BQciyBUEANgIAQa8BIAFB06ABQQBBABAcQciyBSgCACECQciyBUEANgIAIAJBAUYNAUHIsgVBADYCAEGvASABQdigAUEAQQAQHEHIsgUoAgAhAkHIsgVBADYCACACQQFGDQFByLIFQQA2AgBBrwEgAUHdoAFBAEEAEBxByLIFKAIAIQJByLIFQQA2AgAgAkEBRg0BQciyBUEANgIAQa8BIAFB4qABQQBBABAcQciyBSgCACECQciyBUEANgIAIAJBAUYNAUHIsgVBADYCAEGvASABQeegAUEAQQAQHEHIsgUoAgAhAkHIsgVBADYCACACQQFGDQEgAA8LEAYhABAHGgwDCxAGIQAQBxoMAgsQBiEAEAcaCyACEPYMCyABEIQDGiAAEAgAC5IBAQV/IwBBEGsiAiQAIAAQjQMgAEHIAGpBAhCsASEBIAAoAmAgASgCACIBQRBqQQAQsQEoAgBHBEAgACgCBBDZAyIDKAIAIQQgAywACyEFIAJBoKEBNgIAIAIgBCADIAVBAEgbNgIEQeygASACELwBIAFBADoADCABIAAoAmBBABDXASABQQE6AAwLIAJBEGokAAujCgEFfyAAIAFBzKEBEIIDIQEgAEHcoQE2AgBByLIFQQA2AgBB0QEgARAPQciyBSgCACECQciyBUEANgIAAkACQAJAAkACQAJAAkACQAJAAkACQCACQQFGDQBByLIFQQA2AgBBLUEcEA0hAkHIsgUoAgAhA0HIsgVBADYCACADQQFGDQBByLIFQQA2AgAgAiABQYCiARCgBCEDQciyBSgCACEGQciyBUEANgIAIAZBAUYNASACQQA2AhggAkIANwIQIAJB4M4CNgIAQciyBUEANgIAQfDOAigCACIGIAJBARAFQciyBSgCACEEQciyBUEANgIAAkAgBEEBRwRAQciyBUEANgIAQfsAIAJBEGpBABAVIQRByLIFKAIAIQVByLIFQQA2AgAgBUEBRw0BCxAGIQAQBxogAigCGCEDQciyBUEANgIAIAMQ6AFByLIFKAIAIQNByLIFQQA2AgAgA0EBRw0DQQAQCyEBEAcaIAEQhAEACyAEQQA2AgBByLIFQQA2AgBB2wAgASADEAVByLIFKAIAIQJByLIFQQA2AgAgAkEBRg0AQciyBUEANgIAQS1BHBANIQJByLIFKAIAIQNByLIFQQA2AgAgA0EBRg0DQciyBUEANgIAIAIgAUGLogEQoAQhA0HIsgUoAgAhBEHIsgVBADYCACAEQQFGDQQgAkEANgIYIAJCADcCECACQeDOAjYCAEHIsgVBADYCACAGIAJBARAFQciyBSgCACEEQciyBUEANgIAAkAgBEEBRwRAQciyBUEANgIAQfsAIAJBEGpBABAVIQRByLIFKAIAIQVByLIFQQA2AgAgBUEBRw0BCxAGIQAQBxogAigCGCEDQciyBUEANgIAIAMQ6AFByLIFKAIAIQNByLIFQQA2AgAgA0EBRw0GQQAQCyEBEAcaIAEQhAEACyAEQQA2AgBByLIFQQA2AgBB2wAgASADEAVByLIFKAIAIQNByLIFQQA2AgAgA0EBRg0DQciyBUEANgIAQS1BIBANIQNByLIFKAIAIQRByLIFQQA2AgAgBEEBRg0GQciyBUEANgIAIAMgAUGXogEgAhDFBCEEQciyBSgCACECQciyBUEANgIAIAJBAUYNB0HIsgVBADYCAEHbACABIAMQBUHIsgUoAgAhAkHIsgVBADYCACACQQFGDQZByLIFQQA2AgBBLUEcEA0hAkHIsgUoAgAhBUHIsgVBADYCACAFQQFGDQYgAygCBCEDQciyBUEANgIAIAIgA0GfogEQoAQhA0HIsgUoAgAhBUHIsgVBADYCACAFQQFGDQggAkEANgIYIAJCADcCECACQeDOAjYCAEHIsgVBADYCACAGIAJBARAFQciyBSgCACEGQciyBUEANgIAAkAgBkEBRwRAQciyBUEANgIAQfsAIAJBEGpBABAVIQZByLIFKAIAIQVByLIFQQA2AgAgBUEBRw0BCxAGIQAQBxogAigCGCEDQciyBUEANgIAIAMQ6AFByLIFKAIAIQNByLIFQQA2AgAgA0EBRw0KQQAQCyEBEAcaIAEQhAEACyAGQQA2AgBByLIFQQA2AgBB3wAgBCADEAVByLIFKAIAIQJByLIFQQA2AgAgAkEBRg0GIAAPCxAGIQAQBxoMCQsQBiEAEAcaCyACEPYMDAcLEAYhABAHGgwGCxAGIQAQBxoLIAIQ9gwMBAsQBiEAEAcaDAMLEAYhABAHGiADEPYMDAILEAYhABAHGgsgAhD2DAsgARCEAxogABAIAAtKAQJ/IABBAEEEEI4DIABByABqIgFBAhCsASgCAEEQakEAELEBKAIAIQIgAUEEEKwBKAIAIAJBAEc6AA0gAEEEQX8QjgMgABCQAws4AQJ/IABByABqIgFBAhCsASgCAEEQakEAELEBKAIAIQIgAUEEEKwBKAIAIAJBAEc6AA0gABCVAwvyDwEHfyAAIAFB0KIBEIIDIQcgAEHgogE2AgBByLIFQQA2AgBB0QEgBxAPQciyBSgCACEBQciyBUEANgIAAkACQAJAAkACQAJAAkACQAJAAkACQAJAAkACQAJAIAFBAUcEQEHIsgVBADYCAEEtQRwQDSEBQciyBSgCACECQciyBUEANgIAIAJBAUYNAUHIsgVBADYCACABIAdBhKMBEKAEIQJByLIFKAIAIQNByLIFQQA2AgAgA0EBRg0CIAFBADYCGCABQgA3AhAgAUHgzgI2AgBByLIFQQA2AgBB8M4CKAIAIgMgAUEBEAVByLIFKAIAIQZByLIFQQA2AgACQCAGQQFHBEBByLIFQQA2AgBB+wAgAUEQakEAEBUhBkHIsgUoAgAhBEHIsgVBADYCACAEQQFHDQELEAYhAxAHGiABKAIYIQJByLIFQQA2AgAgAhDoAUHIsgUoAgAhAkHIsgVBADYCACACQQFHDQRBABALIQEQBxogARCEAQALIAZBADYCAEHIsgVBADYCAEHbACAHIAIQBUHIsgUoAgAhAkHIsgVBADYCACACQQFGDQFByLIFQQA2AgBBLUEgEA0hAkHIsgUoAgAhBkHIsgVBADYCACAGQQFGDQRByLIFQQA2AgAgAiAHQY+jASABEMUEIQZByLIFKAIAIQFByLIFQQA2AgAgAUEBRg0FQciyBUEANgIAQdsAIAcgAhAFQciyBSgCACEBQciyBUEANgIAIAFBAUYNBEHIsgVBADYCAEEtQRwQDSEBQciyBSgCACEEQciyBUEANgIAIARBAUYNBCACKAIEIQRByLIFQQA2AgAgASAEQZejARCgBCEEQciyBSgCACEFQciyBUEANgIAIAVBAUYNBiABQQA2AhggAUIANwIQIAFB4M4CNgIAQciyBUEANgIAIAMgAUEBEAVByLIFKAIAIQVByLIFQQA2AgACQCAFQQFHBEBByLIFQQA2AgBB+wAgAUEQakEAEBUhBUHIsgUoAgAhCEHIsgVBADYCACAIQQFHDQELEAYhAxAHGiABKAIYIQJByLIFQQA2AgAgAhDoAUHIsgUoAgAhAkHIsgVBADYCACACQQFHDQhBABALIQEQBxogARCEAQALIAVBADYCAEHIsgVBADYCAEHfACAGIAQQBUHIsgUoAgAhAUHIsgVBADYCACABQQFGDQRByLIFQQA2AgBBLUEcEA0hAUHIsgUoAgAhBEHIsgVBADYCACAEQQFGDQQgAigCBCEEQciyBUEANgIAIAEgBEGiowEQoAQhBEHIsgUoAgAhBUHIsgVBADYCACAFQQFGDQggAUEANgIYIAFCADcCECABQeDOAjYCAEHIsgVBADYCACADIAFBARAFQciyBSgCACEFQciyBUEANgIAAkAgBUEBRwRAQciyBUEANgIAQfsAIAFBEGpBABAVIQVByLIFKAIAIQhByLIFQQA2AgAgCEEBRw0BCxAGIQMQBxogASgCGCECQciyBUEANgIAIAIQ6AFByLIFKAIAIQJByLIFQQA2AgAgAkEBRw0KQQAQCyEBEAcaIAEQhAEACyAFQQA2AgBByLIFQQA2AgBB3wAgBiAEEAVByLIFKAIAIQFByLIFQQA2AgAgAUEBRg0EQciyBUEANgIAQS1BHBANIQFByLIFKAIAIQRByLIFQQA2AgAgBEEBRg0EIAIoAgQhAkHIsgVBADYCACABIAJBsqMBEKAEIQJByLIFKAIAIQRByLIFQQA2AgAgBEEBRg0KIAFBADYCGCABQgA3AhAgAUHgzgI2AgBByLIFQQA2AgAgAyABQQEQBUHIsgUoAgAhBEHIsgVBADYCAAJAIARBAUcEQEHIsgVBADYCAEH7ACABQRBqQQAQFSEEQciyBSgCACEFQciyBUEANgIAIAVBAUcNAQsQBiEDEAcaIAEoAhghAkHIsgVBADYCACACEOgBQciyBSgCACECQciyBUEANgIAIAJBAUcNDEEAEAshARAHGiABEIQBAAsgBEEANgIAQciyBUEANgIAQd8AIAYgAhAFQciyBSgCACEBQciyBUEANgIAIAFBAUYNBEHIsgVBADYCAEEtQRwQDSEBQciyBSgCACECQciyBUEANgIAIAJBAUYNDEHIsgVBADYCACABIAdByaMBEKAEIQJByLIFKAIAIQRByLIFQQA2AgAgBEEBRg0NIAFBADYCGCABQgA3AhAgAUHgzgI2AgBByLIFQQA2AgAgAyABQQEQBUHIsgUoAgAhA0HIsgVBADYCAAJAIANBAUcEQEHIsgVBADYCAEH7ACABQRBqQQAQFSEDQciyBSgCACEEQciyBUEANgIAIARBAUcNAQsQBiEDEAcaIAEoAhghAkHIsgVBADYCACACEOgBQciyBSgCACECQciyBUEANgIAIAJBAUcND0EAEAshARAHGiABEIQBAAsgA0EANgIAIAFBAToADUHIsgVBADYCAEHfACAGIAIQBUHIsgUoAgAhAUHIsgVBADYCACABQQFGDQwgAA8LEAYhAxAHGgwOCxAGIQMQBxoMDQsQBiEDEAcaCyABEPYMDAsLEAYhAxAHGgwKCxAGIQMQBxogAhD2DAwJCxAGIQMQBxoLIAEQ9gwMBwsQBiEDEAcaCyABEPYMDAULEAYhAxAHGgsgARD2DAwDCxAGIQMQBxoMAgsQBiEDEAcaCyABEPYMCyAHEIQDGiADEAgAC+ABAQl/IAAQjQMgAEHIAGoiAEECEKwBKAIAQRBqQQAQsQEoAgAhAyAAQQMQrAEoAgBBFGpBABCsASgCACECIABBAxCsASgCAEEUakEBEKwBKAIAIQQgAEEDEKwBKAIAQRRqQQMQrAEhACADBEAgACgCACEGIARBEGohByACQRBqIQUgA0F/aiEEQQEhAgNAIAYgAiABENcBIAFBAWohACABIARJBEAgBSAAELEBKAIAIQggBSABELEBKAIAIQkgByABELEBKAIAIAggCWtsIAJqIQILIAAhASAAIANHDQALCwvVBgEEfyAAIAFB/KMBEIIDIQEgAEGMpAE2AgBByLIFQQA2AgBB0QEgARAPQciyBSgCACECQciyBUEANgIAAkACQAJAAkACQAJAAkAgAkEBRg0AQciyBUEANgIAQccBIAEgAUGwpAFBAxAcQciyBSgCACECQciyBUEANgIAIAJBAUYNAEHIsgVBADYCAEEtQRwQDSECQciyBSgCACEDQciyBUEANgIAIANBAUYNAEHIsgVBADYCACACIAFBuaQBEKAEIQNByLIFKAIAIQRByLIFQQA2AgAgBEEBRg0BIAJBADYCGCACQgA3AhAgAkGQzAI2AgBByLIFQQA2AgBBoMwCKAIAIAJBARAFQciyBSgCACEEQciyBUEANgIAAkAgBEEBRwRAQciyBUEANgIAQdkAIAJBEGpBABAVIQRByLIFKAIAIQVByLIFQQA2AgAgBUEBRw0BCxAGIQAQBxogAigCGCEDQciyBUEANgIAIAMQ6AFByLIFKAIAIQNByLIFQQA2AgAgA0EBRw0DQQAQCyEBEAcaIAEQhAEACyAEQQA6AABByLIFQQA2AgBB2wAgASADEAVByLIFKAIAIQJByLIFQQA2AgAgAkEBRg0AQciyBUEANgIAQS1BHBANIQJByLIFKAIAIQNByLIFQQA2AgAgA0EBRg0DQciyBUEANgIAIAIgAUHDpAEQoAQhA0HIsgUoAgAhBEHIsgVBADYCACAEQQFGDQQgAkEANgIYIAJCADcCECACQeDOAjYCAEHIsgVBADYCAEHwzgIoAgAgAkEBEAVByLIFKAIAIQRByLIFQQA2AgACQCAEQQFHBEBByLIFQQA2AgBB+wAgAkEQakEAEBUhBEHIsgUoAgAhBUHIsgVBADYCACAFQQFHDQELEAYhABAHGiACKAIYIQNByLIFQQA2AgAgAxDoAUHIsgUoAgAhA0HIsgVBADYCACADQQFHDQZBABALIQEQBxogARCEAQALIARBADYCAEHIsgVBADYCAEHbACABIAMQBUHIsgUoAgAhAkHIsgVBADYCACACQQFGDQMgAA8LEAYhABAHGgwFCxAGIQAQBxoLIAIQ9gwMAwsQBiEAEAcaDAILEAYhABAHGgsgAhD2DAsgARCEAxogABAIAAv+BQEEfyAAQQBBBBCOAyAAQcgAaiIBQQMQrAEoAgBBEGpBABCoAS0AACECIAFBBBCsASgCACEEQSAQ/gshAQJAAkACQCACQQRHBEBByLIFQQA2AgAgASAAQc+kASAEEMUEIQRByLIFKAIAIQNByLIFQQA2AgAgA0EBRw0BEAYhABAHGgwDC0HIsgVBADYCACABIABBz6QBIAQQxQQhBEHIsgUoAgAhA0HIsgVBADYCACADQQFGDQEgAUGQpQE2AgALIAAgBBCMA0EcEP4LIQECQAJAIAJBEEYEQEHIsgVBADYCACABIABB16QBEKAEGkHIsgUoAgAhAkHIsgVBADYCACACQQFHBEAgAUEANgIYIAFCADcCECABQaDNAjYCAEHIsgVBADYCAEGwzQIoAgAgAUEBEAVByLIFKAIAIQJByLIFQQA2AgAgAkEBRwRAQciyBUEANgIAQd4AIAFBEGpBABAVIQJByLIFKAIAIQNByLIFQQA2AgAgA0EBRw0DCxAGIQAQBxogASgCGCECQciyBUEANgIAIAIQ6AFByLIFKAIAIQJByLIFQQA2AgAgAkEBRw0FQQAQCyEBEAcaIAEQhAEACxAGIQAQBxoMBAtByLIFQQA2AgAgASAAQdekARCgBBpByLIFKAIAIQJByLIFQQA2AgAgAkEBRwRAIAFBADYCGCABQgA3AhAgAUGQzAI2AgBByLIFQQA2AgBBoMwCKAIAIAFBARAFQciyBSgCACECQciyBUEANgIAAkAgAkEBRwRAQciyBUEANgIAQdkAIAFBEGpBABAVIQJByLIFKAIAIQNByLIFQQA2AgAgA0EBRw0BCxAGIQAQBxogASgCGCECQciyBUEANgIAIAIQ6AFByLIFKAIAIQJByLIFQQA2AgAgAkEBRw0FQQAQCyEBEAcaIAEQhAEACyACQQA6AAAMAgsQBiEAEAcaDAMLIAJBADsBAAsgBCABEMgEIABBBEF/EI4DIAAQkAMPCxAGIQAQBxoLIAEQ9gwgABAIAAsTACAAKAIQQQAQogRCAXxCAYinCxIAIAAoAhAgAUEBdK1BABCjBAvTBwEFfyAAIAFB9KUBEIIDIQUgAEGEpgE2AgBByLIFQQA2AgBB0QEgBRAPQciyBSgCACEBQciyBUEANgIAAkACQAJAAkACQAJAAkACQCABQQFHBEBByLIFQQA2AgBBLUEcEA0hAUHIsgUoAgAhAkHIsgVBADYCACACQQFGDQFByLIFQQA2AgAgASAFQaimARCgBCECQciyBSgCACEDQciyBUEANgIAIANBAUYNAiABQQA2AhggAUIANwIQIAFB4M4CNgIAQciyBUEANgIAQfDOAigCACABQQEQBUHIsgUoAgAhA0HIsgVBADYCAAJAIANBAUcEQEHIsgVBADYCAEH7ACABQRBqQQAQFSEDQciyBSgCACEEQciyBUEANgIAIARBAUcNAQsQBiEAEAcaIAEoAhghAkHIsgVBADYCACACEOgBQciyBSgCACECQciyBUEANgIAIAJBAUcNBEEAEAshARAHGiABEIQBAAsgA0EANgIAIAFBAToADUHIsgVBADYCAEHbACAFIAIQBUHIsgUoAgAhAkHIsgVBADYCACACQQFGDQFByLIFQQA2AgBBLUEgEA0hAkHIsgUoAgAhA0HIsgVBADYCACADQQFGDQRByLIFQQA2AgAgAiAFQbOmASABEMUEIQNByLIFKAIAIQFByLIFQQA2AgAgAUEBRg0FQciyBUEANgIAQdsAIAUgAhAFQciyBSgCACEBQciyBUEANgIAIAFBAUYNBEHIsgVBADYCAEEtQRwQDSEBQciyBSgCACEEQciyBUEANgIAIARBAUYNBCACKAIEIQJByLIFQQA2AgAgASACQbumARCgBCECQciyBSgCACEEQciyBUEANgIAIARBAUYNBiABQQA2AhggAUIANwIQIAFBoM0CNgIAQciyBUEANgIAQbDNAigCACABQQEQBUHIsgUoAgAhBEHIsgVBADYCAAJAIARBAUcEQEHIsgVBADYCAEHeACABQRBqQQAQFSEEQciyBSgCACEGQciyBUEANgIAIAZBAUcNAQsQBiEAEAcaIAEoAhghAkHIsgVBADYCACACEOgBQciyBSgCACECQciyBUEANgIAIAJBAUcNCEEAEAshARAHGiABEIQBAAsgBEEAOwEAQciyBUEANgIAQd8AIAMgAhAFQciyBSgCACEBQciyBUEANgIAIAFBAUYNBCAADwsQBiEAEAcaDAcLEAYhABAHGgwGCxAGIQAQBxoLIAEQ9gwMBAsQBiEAEAcaDAMLEAYhABAHGiACEPYMDAILEAYhABAHGgsgARD2DAsgBRCEAxogABAIAAtMAQF/IABByABqIgFBAhCsASgCAEEAOgAMIAFBAhCsASgCACAAKQMgQvz///8ffEIBiKdBABDXASABQQIQrAEoAgBBAToADCAAEI0DC9EBAQJ/IAAgAUHspgEQggMhASAAQfymATYCAEHIsgVBADYCAEEtQSQQDSECQciyBSgCACEDQciyBUEANgIAAkACQAJAIANBAUcEQEHIsgVBADYCAEH9ACACIAFBoKcBQQBBAEEAEBYaQciyBSgCACEDQciyBUEANgIAIANBAUYNAUHIsgVBADYCAEHbACABIAIQBUHIsgUoAgAhAkHIsgVBADYCACACQQFHDQMLEAYhABAHGgwBCxAGIQAQBxogAhD2DAsgARCEAxogABAIAAsgAAvPAwEFfyMAQRBrIgIkACAAKQMQIAAoAgRBABCwA32nIgNBAWoQ4wEiAUUEQEEEEA4hAEHIsgVBADYCAEEtQSwQDSEDQciyBSgCACEBQciyBUEANgIAAkACQAJAAkACQCABQQFHBEBByLIFQQA2AgBBLUEgEA0hAUHIsgUoAgAhBUHIsgVBADYCAEEBIQQgBUEBRg0BIAIgATYCACACQpyAgICAhICAgH83AgQgAUEAOgAcIAFBwKcBKAAANgAYIAFBuKcBKQAANwAQIAFBsKcBKQAANwAIIAFBqKcBKQAANwAAQciyBUEANgIAQTIgAyACQcWnAUEoQeqnARAQGkHIsgUoAgAhAUHIsgVBADYCACABQQFGDQIgACADNgIAQQAhBEHIsgVBADYCAEExIABBoNoAQQAQEkHIsgUoAgAhAUHIsgVBADYCACABQQFGDQIACxAGIQEQBxoMAwsQBiEBEAcaDAELEAYhARAHGiACLAALQX9MBEAgAigCABD2DAsgBEUNAgsgAxD2DAsgABATCyABEAgACyAAKAIEIAEgA0EAELMDIAEgA2pBADoAACAAQcgAakEAEKwBKAIAIAFBABC1BCABEOgBIAJBEGokAAs6AQJ/IABByABqQQAQrAEoAgAiAUEYakEAEIkCKAIAIgIEQCABIAIQiA02AhQLIAAQlQMgAUEANgIUCxkAIAAgAUGYqAEQggMaIABBqKgBNgIAIAAL1x8BBn8gACAAQcyoAUEGEJsDQRwQ/gshAUHIsgVBADYCACABIABB1qgBEKAEIQVByLIFKAIAIQNByLIFQQA2AgACQAJAAkACQAJAAkACQAJAAkACQAJAAkACQAJAAkAgA0EBRwRAIAFBADYCGCABQgA3AhAgAUGgzQI2AgBByLIFQQA2AgBBsM0CKAIAIgMgAUEBEAVByLIFKAIAIQJByLIFQQA2AgACQCACQQFHBEBByLIFQQA2AgBB3gAgAUEQakEAEBUhAkHIsgUoAgAhBEHIsgVBADYCACAEQQFHDQELEAYhABAHGiABKAIYIQNByLIFQQA2AgAgAxDoAUHIsgUoAgAhA0HIsgVBADYCACADQQFHDRBBABALIQEQBxogARCEAQALIAJBADsBACAAIAUQjANBHBD+CyEBQciyBUEANgIAIAEgAEHpqAEQoAQhBUHIsgUoAgAhAkHIsgVBADYCACACQQFGDQEgAUEANgIYIAFCADcCECABQeDOAjYCAEHIsgVBADYCAEHwzgIoAgAiAiABQQEQBUHIsgUoAgAhBEHIsgVBADYCAAJAIARBAUcEQEHIsgVBADYCAEH7ACABQRBqQQAQFSEEQciyBSgCACEGQciyBUEANgIAIAZBAUcNAQsQBiEAEAcaIAEoAhghA0HIsgVBADYCACADEOgBQciyBSgCACEDQciyBUEANgIAIANBAUcNEEEAEAshARAHGiABEIQBAAsgBEEANgIAIAAgBRCMA0EcEP4LIQFByLIFQQA2AgAgASAAQfaoARCgBCEFQciyBSgCACEEQciyBUEANgIAIARBAUYNAiABQQA2AhggAUIANwIQIAFB4M4CNgIAQciyBUEANgIAIAIgAUEBEAVByLIFKAIAIQJByLIFQQA2AgACQCACQQFHBEBByLIFQQA2AgBB+wAgAUEQakEAEBUhAkHIsgUoAgAhBEHIsgVBADYCACAEQQFHDQELEAYhABAHGiABKAIYIQNByLIFQQA2AgAgAxDoAUHIsgUoAgAhA0HIsgVBADYCACADQQFHDRBBABALIQEQBxogARCEAQALIAJBADYCACAAIAUQjANBHBD+CyEBQciyBUEANgIAIAEgAEGIqQEQoAQhBUHIsgUoAgAhAkHIsgVBADYCACACQQFGDQMgAUEANgIYIAFCADcCECABQaDNAjYCAEHIsgVBADYCACADIAFBARAFQciyBSgCACECQciyBUEANgIAAkAgAkEBRwRAQciyBUEANgIAQd4AIAFBEGpBABAVIQJByLIFKAIAIQRByLIFQQA2AgAgBEEBRw0BCxAGIQAQBxogASgCGCEDQciyBUEANgIAIAMQ6AFByLIFKAIAIQNByLIFQQA2AgAgA0EBRw0QQQAQCyEBEAcaIAEQhAEACyACQQA7AQAgACAFEIwDQRwQ/gshAUHIsgVBADYCACABIABBk6kBEKAEIQVByLIFKAIAIQJByLIFQQA2AgAgAkEBRg0EIAFBADYCGCABQgA3AhAgAUGgzQI2AgBByLIFQQA2AgAgAyABQQEQBUHIsgUoAgAhAkHIsgVBADYCAAJAIAJBAUcEQEHIsgVBADYCAEHeACABQRBqQQAQFSECQciyBSgCACEEQciyBUEANgIAIARBAUcNAQsQBiEAEAcaIAEoAhghA0HIsgVBADYCACADEOgBQciyBSgCACEDQciyBUEANgIAIANBAUcNEEEAEAshARAHGiABEIQBAAsgAkEAOwEAIAAgBRCMA0EcEP4LIQFByLIFQQA2AgAgASAAQaCpARCgBCEFQciyBSgCACECQciyBUEANgIAIAJBAUYNBSABQQA2AhggAUIANwIQIAFBoM0CNgIAQciyBUEANgIAIAMgAUEBEAVByLIFKAIAIQJByLIFQQA2AgACQCACQQFHBEBByLIFQQA2AgBB3gAgAUEQakEAEBUhAkHIsgUoAgAhBEHIsgVBADYCACAEQQFHDQELEAYhABAHGiABKAIYIQNByLIFQQA2AgAgAxDoAUHIsgUoAgAhA0HIsgVBADYCACADQQFHDRBBABALIQEQBxogARCEAQALIAJBADsBACAAIAUQjANBHBD+CyEBQciyBUEANgIAIAEgAEGsqQEQoAQhBUHIsgUoAgAhAkHIsgVBADYCACACQQFGDQYgAUEANgIYIAFCADcCECABQaDNAjYCAEHIsgVBADYCACADIAFBARAFQciyBSgCACECQciyBUEANgIAAkAgAkEBRwRAQciyBUEANgIAQd4AIAFBEGpBABAVIQJByLIFKAIAIQRByLIFQQA2AgAgBEEBRw0BCxAGIQAQBxogASgCGCEDQciyBUEANgIAIAMQ6AFByLIFKAIAIQNByLIFQQA2AgAgA0EBRw0QQQAQCyEBEAcaIAEQhAEACyACQQA7AQAgACAFEIwDQRwQ/gshAUHIsgVBADYCACABIABBuqkBEKAEIQVByLIFKAIAIQJByLIFQQA2AgAgAkEBRg0HIAFBADYCGCABQgA3AhAgAUGgzQI2AgBByLIFQQA2AgAgAyABQQEQBUHIsgUoAgAhAkHIsgVBADYCAAJAIAJBAUcEQEHIsgVBADYCAEHeACABQRBqQQAQFSECQciyBSgCACEEQciyBUEANgIAIARBAUcNAQsQBiEAEAcaIAEoAhghA0HIsgVBADYCACADEOgBQciyBSgCACEDQciyBUEANgIAIANBAUcNEEEAEAshARAHGiABEIQBAAsgAkEAOwEAIAAgBRCMA0EcEP4LIQFByLIFQQA2AgAgASAAQcmpARCgBCEFQciyBSgCACECQciyBUEANgIAIAJBAUYNCCABQQA2AhggAUIANwIQIAFBoM0CNgIAQciyBUEANgIAIAMgAUEBEAVByLIFKAIAIQJByLIFQQA2AgACQCACQQFHBEBByLIFQQA2AgBB3gAgAUEQakEAEBUhAkHIsgUoAgAhBEHIsgVBADYCACAEQQFHDQELEAYhABAHGiABKAIYIQNByLIFQQA2AgAgAxDoAUHIsgUoAgAhA0HIsgVBADYCACADQQFHDRBBABALIQEQBxogARCEAQALIAJBADsBACAAIAUQjANBHBD+CyEBQciyBUEANgIAIAEgAEHaqQEQoAQhBUHIsgUoAgAhAkHIsgVBADYCACACQQFGDQkgAUEANgIYIAFCADcCECABQaDNAjYCAEHIsgVBADYCACADIAFBARAFQciyBSgCACECQciyBUEANgIAAkAgAkEBRwRAQciyBUEANgIAQd4AIAFBEGpBABAVIQJByLIFKAIAIQRByLIFQQA2AgAgBEEBRw0BCxAGIQAQBxogASgCGCEDQciyBUEANgIAIAMQ6AFByLIFKAIAIQNByLIFQQA2AgAgA0EBRw0QQQAQCyEBEAcaIAEQhAEACyACQQA7AQAgACAFEIwDIAAgAEHqqQFBCBCbA0EcEP4LIQFByLIFQQA2AgAgASAAQfSpARCgBCEFQciyBSgCACECQciyBUEANgIAIAJBAUYNCiABQQA2AhggAUIANwIQIAFBoM0CNgIAQciyBUEANgIAIAMgAUEBEAVByLIFKAIAIQJByLIFQQA2AgACQCACQQFHBEBByLIFQQA2AgBB3gAgAUEQakEAEBUhAkHIsgUoAgAhBEHIsgVBADYCACAEQQFHDQELEAYhABAHGiABKAIYIQNByLIFQQA2AgAgAxDoAUHIsgUoAgAhA0HIsgVBADYCACADQQFHDRBBABALIQEQBxogARCEAQALIAJBADsBACAAIAUQjANBHBD+CyEBQciyBUEANgIAIAEgAEH/qQEQoAQhBUHIsgUoAgAhAkHIsgVBADYCACACQQFGDQsgAUEANgIYIAFCADcCECABQaDNAjYCAEHIsgVBADYCACADIAFBARAFQciyBSgCACECQciyBUEANgIAAkAgAkEBRwRAQciyBUEANgIAQd4AIAFBEGpBABAVIQJByLIFKAIAIQRByLIFQQA2AgAgBEEBRw0BCxAGIQAQBxogASgCGCEDQciyBUEANgIAIAMQ6AFByLIFKAIAIQNByLIFQQA2AgAgA0EBRw0QQQAQCyEBEAcaIAEQhAEACyACQQA7AQAgACAFEIwDIAAgAEGIqgFBARCbAyAAIABBkqoBQQIQmwNBHBD+CyEBQciyBUEANgIAIAEgAEGcqgEQoAQhBUHIsgUoAgAhAkHIsgVBADYCACACQQFGDQwgAUEANgIYIAFCADcCECABQaDNAjYCAEHIsgVBADYCACADIAFBARAFQciyBSgCACECQciyBUEANgIAAkAgAkEBRwRAQciyBUEANgIAQd4AIAFBEGpBABAVIQJByLIFKAIAIQRByLIFQQA2AgAgBEEBRw0BCxAGIQAQBxogASgCGCEDQciyBUEANgIAIAMQ6AFByLIFKAIAIQNByLIFQQA2AgAgA0EBRw0QQQAQCyEBEAcaIAEQhAEACyACQQA7AQAgACAFEIwDQRwQ/gshAUHIsgVBADYCACABIABBqaoBEKAEIQVByLIFKAIAIQJByLIFQQA2AgAgAkEBRg0NIAFBADYCGCABQgA3AhAgAUGgzQI2AgBByLIFQQA2AgAgAyABQQEQBUHIsgUoAgAhAkHIsgVBADYCAAJAIAJBAUcEQEHIsgVBADYCAEHeACABQRBqQQAQFSECQciyBSgCACEEQciyBUEANgIAIARBAUcNAQsQBiEAEAcaIAEoAhghA0HIsgVBADYCACADEOgBQciyBSgCACEDQciyBUEANgIAIANBAUcNEEEAEAshARAHGiABEIQBAAsgAkEAOwEAIAAgBRCMA0EcEP4LIQFByLIFQQA2AgAgASAAQbiqARCgBCEFQciyBSgCACECQciyBUEANgIAIAJBAUYNDiABQQA2AhggAUIANwIQIAFBoM0CNgIAQciyBUEANgIAIAMgAUEBEAVByLIFKAIAIQNByLIFQQA2AgACQCADQQFHBEBByLIFQQA2AgBB3gAgAUEQakEAEBUhA0HIsgUoAgAhAkHIsgVBADYCACACQQFHDQELEAYhABAHGiABKAIYIQNByLIFQQA2AgAgAxDoAUHIsgUoAgAhA0HIsgVBADYCACADQQFHDRBBABALIQEQBxogARCEAQALIANBADsBACAAIAUQjAMPCxAGIQAQBxoMDgsQBiEAEAcaDA0LEAYhABAHGgwMCxAGIQAQBxoMCwsQBiEAEAcaDAoLEAYhABAHGgwJCxAGIQAQBxoMCAsQBiEAEAcaDAcLEAYhABAHGgwGCxAGIQAQBxoMBQsQBiEAEAcaDAQLEAYhABAHGgwDCxAGIQAQBxoMAgsQBiEAEAcaDAELEAYhABAHGgsgARD2DCAAEAgAC6wFAQR/IwBBIGsiAiQAIAAoAkAiAUUEQEEEEA4hAEHIsgVBADYCAEEtQSwQDSEDQciyBSgCACEBQciyBUEANgIAAkACQAJAAkACQCABQQFHBEBByLIFQQA2AgBBLUEgEA0hAUHIsgUoAgAhBEHIsgVBADYCACAEQQFGDQEgAiABNgIQIAJCn4CAgICEgICAfzcCFCABQQA6AB8gAUHmqgEpAAA3ABcgAUHfqgEpAAA3ABAgAUHXqgEpAAA3AAggAUHPqgEpAAA3AABByLIFQQA2AgBBMiADIAJBEGpB76oBQc4AQZWrARAQGkHIsgUoAgAhAUHIsgVBADYCAEEBIQQgAUEBRg0CIAAgAzYCAEHIsgVBADYCAEExIABBoNoAQQAQEkHIsgUoAgAhAUHIsgVBADYCAEEAIQQgAUEBRg0CAAsQBiEBEAcaDAMLEAYhARAHGgwBCxAGIQEQBxogAiwAG0F/TARAIAIoAhAQ9gwLIARFDQILIAMQ9gwLIAAQEwsgARAIAAsCQAJAIAFBKGoQrQVBnqsBEK0FRgRAIAAQ7AIgABCJAyAAQcgAaiIAQQEQrAEoAgBBAUEAEN0BIABBAhCsASgCAEEBQQAQ1wEgAEEDEKwBKAIAQQFBABDXAQwBCyAAKAJAQShqEK0FQaOrARCtBUYEQEEwEP4LIQFByLIFQQA2AgBB4AAgASAAQcaqAUEkQQAQEBpByLIFKAIAIQNByLIFQQA2AgAgA0EBRg0CIAAgARCMAyAAEIkDIABByABqQQAQrAEoAgBB0I4EQSRBABC/BAwBCyAAKAIEENkDIgAoAgAhASAALAALIQMgAkGVqwE2AgAgAiABIAAgA0EASBs2AgRBqKsBIAIQvAELIAJBIGokAA8LEAYhABAHGiABEPYMIAAQCAALlwEBAn8gACgCQEEoahCtBUGeqwEQrQVGBEAgABDsAiAAEI0DDwsCQCAAKAJAQShqEK0FQaOrARCtBUYEQEEwEP4LIQFByLIFQQA2AgBB4AAgASAAQcaqAUEkQQAQEBpByLIFKAIAIQJByLIFQQA2AgAgAkEBRg0BIAAgARCMAwsgABCNAw8LEAYhABAHGiABEPYMIAAQCAALlToBBn8gACABQYysARCCAyEBIABBnKwBNgIAQciyBUEANgIAQccBIAEgAUHArAFBBBAcQciyBSgCACEDQciyBUEANgIAAkACQAJAAkACQAJAAkACQAJAAkACQAJAAkACQAJAAkACQAJAAkACQAJAAkACQAJAAkACQAJAAkACQAJAAkACQAJAAkACQAJAAkACQAJAAkACQAJAAkACQAJAIANBAUYNAEHIsgVBADYCAEHHASABIAFByqwBQQIQHEHIsgUoAgAhA0HIsgVBADYCACADQQFGDQBByLIFQQA2AgBBLUEcEA0hA0HIsgUoAgAhBUHIsgVBADYCACAFQQFGDQBByLIFQQA2AgAgAyABQdSsARCgBCECQciyBSgCACEFQciyBUEANgIAIAVBAUYNASADQQA2AhggA0IANwIQIANBoM0CNgIAQciyBUEANgIAQbDNAigCACIFIANBARAFQciyBSgCACEEQciyBUEANgIAAkAgBEEBRwRAQciyBUEANgIAQd4AIANBEGpBABAVIQRByLIFKAIAIQZByLIFQQA2AgAgBkEBRw0BCxAGIQAQBxogAygCGCEFQciyBUEANgIAIAUQ6AFByLIFKAIAIQVByLIFQQA2AgAgBUEBRw0DQQAQCyEBEAcaIAEQhAEACyAEQQA7AQBByLIFQQA2AgBB2wAgASACEAVByLIFKAIAIQNByLIFQQA2AgAgA0EBRg0AQciyBUEANgIAQS1BHBANIQNByLIFKAIAIQJByLIFQQA2AgAgAkEBRg0AQciyBUEANgIAIAMgAUHnrAEQoAQhAkHIsgUoAgAhBEHIsgVBADYCACAEQQFGDQMgA0EANgIYIANCADcCECADQeDOAjYCAEHIsgVBADYCAEHwzgIoAgAgA0EBEAVByLIFKAIAIQRByLIFQQA2AgACQCAEQQFHBEBByLIFQQA2AgBB+wAgA0EQakEAEBUhBEHIsgUoAgAhBkHIsgVBADYCACAGQQFHDQELEAYhABAHGiADKAIYIQVByLIFQQA2AgAgBRDoAUHIsgUoAgAhBUHIsgVBADYCACAFQQFHDQVBABALIQEQBxogARCEAQALIARBADYCAEHIsgVBADYCAEHbACABIAIQBUHIsgUoAgAhA0HIsgVBADYCACADQQFGDQBByLIFQQA2AgBBLUEcEA0hAkHIsgUoAgAhA0HIsgVBADYCACADQQFGDQBByLIFQQA2AgAgAiABQfSsARCgBCEEQciyBSgCACEDQciyBUEANgIAIANBAUYNBSACQQA2AhggAkIANwIQIAJBkMwCNgIAQciyBUEANgIAQaDMAigCACIDIAJBARAFQciyBSgCACEGQciyBUEANgIAAkAgBkEBRwRAQciyBUEANgIAQdkAIAJBEGpBABAVIQZByLIFKAIAIQdByLIFQQA2AgAgB0EBRw0BCxAGIQAQBxogAigCGCEDQciyBUEANgIAIAMQ6AFByLIFKAIAIQNByLIFQQA2AgAgA0EBRw0HQQAQCyEBEAcaIAEQhAEACyAGQQA6AABByLIFQQA2AgBB2wAgASAEEAVByLIFKAIAIQJByLIFQQA2AgAgAkEBRg0AQciyBUEANgIAQS1BHBANIQJByLIFKAIAIQRByLIFQQA2AgAgBEEBRg0AQciyBUEANgIAIAIgAUGMrQEQoAQhBEHIsgUoAgAhBkHIsgVBADYCACAGQQFGDQcgAkEANgIYIAJCADcCECACQZDMAjYCAEHIsgVBADYCACADIAJBARAFQciyBSgCACEGQciyBUEANgIAAkAgBkEBRwRAQciyBUEANgIAQdkAIAJBEGpBABAVIQZByLIFKAIAIQdByLIFQQA2AgAgB0EBRw0BCxAGIQAQBxogAigCGCEDQciyBUEANgIAIAMQ6AFByLIFKAIAIQNByLIFQQA2AgAgA0EBRw0JQQAQCyEBEAcaIAEQhAEACyAGQQA6AABByLIFQQA2AgBB2wAgASAEEAVByLIFKAIAIQJByLIFQQA2AgAgAkEBRg0AQciyBUEANgIAQS1BHBANIQJByLIFKAIAIQRByLIFQQA2AgAgBEEBRg0AQciyBUEANgIAIAIgAUGirQEQoAQhBEHIsgUoAgAhBkHIsgVBADYCACAGQQFGDQkgAkEANgIYIAJCADcCECACQZDMAjYCAEHIsgVBADYCACADIAJBARAFQciyBSgCACEGQciyBUEANgIAAkAgBkEBRwRAQciyBUEANgIAQdkAIAJBEGpBABAVIQZByLIFKAIAIQdByLIFQQA2AgAgB0EBRw0BCxAGIQAQBxogAigCGCEDQciyBUEANgIAIAMQ6AFByLIFKAIAIQNByLIFQQA2AgAgA0EBRw0LQQAQCyEBEAcaIAEQhAEACyAGQQA6AABByLIFQQA2AgBB2wAgASAEEAVByLIFKAIAIQJByLIFQQA2AgAgAkEBRg0AQciyBUEANgIAQS1BHBANIQJByLIFKAIAIQRByLIFQQA2AgAgBEEBRg0AQciyBUEANgIAIAIgAUGtrQEQoAQhBEHIsgUoAgAhBkHIsgVBADYCACAGQQFGDQsgAkEANgIYIAJCADcCECACQZDMAjYCAEHIsgVBADYCACADIAJBARAFQciyBSgCACEGQciyBUEANgIAAkAgBkEBRwRAQciyBUEANgIAQdkAIAJBEGpBABAVIQZByLIFKAIAIQdByLIFQQA2AgAgB0EBRw0BCxAGIQAQBxogAigCGCEDQciyBUEANgIAIAMQ6AFByLIFKAIAIQNByLIFQQA2AgAgA0EBRw0NQQAQCyEBEAcaIAEQhAEACyAGQQA6AABByLIFQQA2AgBB2wAgASAEEAVByLIFKAIAIQJByLIFQQA2AgAgAkEBRg0AQciyBUEANgIAQS1BHBANIQJByLIFKAIAIQRByLIFQQA2AgAgBEEBRg0AQciyBUEANgIAIAIgAUG6rQEQoAQhBEHIsgUoAgAhBkHIsgVBADYCACAGQQFGDQ0gAkEANgIYIAJCADcCECACQZDMAjYCAEHIsgVBADYCACADIAJBARAFQciyBSgCACEGQciyBUEANgIAAkAgBkEBRwRAQciyBUEANgIAQdkAIAJBEGpBABAVIQZByLIFKAIAIQdByLIFQQA2AgAgB0EBRw0BCxAGIQAQBxogAigCGCEDQciyBUEANgIAIAMQ6AFByLIFKAIAIQNByLIFQQA2AgAgA0EBRw0PQQAQCyEBEAcaIAEQhAEACyAGQQA6AABByLIFQQA2AgBB2wAgASAEEAVByLIFKAIAIQJByLIFQQA2AgAgAkEBRg0AQciyBUEANgIAQS1BHBANIQJByLIFKAIAIQRByLIFQQA2AgAgBEEBRg0AQciyBUEANgIAIAIgAUHGrQEQoAQhBEHIsgUoAgAhBkHIsgVBADYCACAGQQFGDQ8gAkEANgIYIAJCADcCECACQZDMAjYCAEHIsgVBADYCACADIAJBARAFQciyBSgCACEGQciyBUEANgIAAkAgBkEBRwRAQciyBUEANgIAQdkAIAJBEGpBABAVIQZByLIFKAIAIQdByLIFQQA2AgAgB0EBRw0BCxAGIQAQBxogAigCGCEDQciyBUEANgIAIAMQ6AFByLIFKAIAIQNByLIFQQA2AgAgA0EBRw0RQQAQCyEBEAcaIAEQhAEACyAGQQA6AABByLIFQQA2AgBB2wAgASAEEAVByLIFKAIAIQJByLIFQQA2AgAgAkEBRg0AQciyBUEANgIAQS1BHBANIQJByLIFKAIAIQRByLIFQQA2AgAgBEEBRg0AQciyBUEANgIAIAIgAUHTrQEQoAQhBEHIsgUoAgAhBkHIsgVBADYCACAGQQFGDREgAkEANgIYIAJCADcCECACQaDNAjYCAEHIsgVBADYCACAFIAJBARAFQciyBSgCACEGQciyBUEANgIAAkAgBkEBRwRAQciyBUEANgIAQd4AIAJBEGpBABAVIQZByLIFKAIAIQdByLIFQQA2AgAgB0EBRw0BCxAGIQAQBxogAigCGCEDQciyBUEANgIAIAMQ6AFByLIFKAIAIQNByLIFQQA2AgAgA0EBRw0TQQAQCyEBEAcaIAEQhAEACyAGQQA7AQBByLIFQQA2AgBB2wAgASAEEAVByLIFKAIAIQJByLIFQQA2AgAgAkEBRg0AQciyBUEANgIAQS1BHBANIQJByLIFKAIAIQRByLIFQQA2AgAgBEEBRg0AQciyBUEANgIAIAIgAUHhrQEQoAQhBEHIsgUoAgAhBkHIsgVBADYCACAGQQFGDRMgAkEANgIYIAJCADcCECACQaDNAjYCAEHIsgVBADYCACAFIAJBARAFQciyBSgCACEGQciyBUEANgIAAkAgBkEBRwRAQciyBUEANgIAQd4AIAJBEGpBABAVIQZByLIFKAIAIQdByLIFQQA2AgAgB0EBRw0BCxAGIQAQBxogAigCGCEDQciyBUEANgIAIAMQ6AFByLIFKAIAIQNByLIFQQA2AgAgA0EBRw0VQQAQCyEBEAcaIAEQhAEACyAGQQA7AQBByLIFQQA2AgBB2wAgASAEEAVByLIFKAIAIQJByLIFQQA2AgAgAkEBRg0AQciyBUEANgIAQS1BHBANIQJByLIFKAIAIQRByLIFQQA2AgAgBEEBRg0AQciyBUEANgIAIAIgAUHwrQEQoAQhBEHIsgUoAgAhBkHIsgVBADYCACAGQQFGDRUgAkEANgIYIAJCADcCECACQaDNAjYCAEHIsgVBADYCACAFIAJBARAFQciyBSgCACEGQciyBUEANgIAAkAgBkEBRwRAQciyBUEANgIAQd4AIAJBEGpBABAVIQZByLIFKAIAIQdByLIFQQA2AgAgB0EBRw0BCxAGIQAQBxogAigCGCEDQciyBUEANgIAIAMQ6AFByLIFKAIAIQNByLIFQQA2AgAgA0EBRw0XQQAQCyEBEAcaIAEQhAEACyAGQQA7AQBByLIFQQA2AgBB2wAgASAEEAVByLIFKAIAIQJByLIFQQA2AgAgAkEBRg0AQciyBUEANgIAQS1BHBANIQJByLIFKAIAIQRByLIFQQA2AgAgBEEBRg0AQciyBUEANgIAIAIgAUGBrgEQoAQhBEHIsgUoAgAhBkHIsgVBADYCACAGQQFGDRcgAkEANgIYIAJCADcCECACQaDNAjYCAEHIsgVBADYCACAFIAJBARAFQciyBSgCACEGQciyBUEANgIAAkAgBkEBRwRAQciyBUEANgIAQd4AIAJBEGpBABAVIQZByLIFKAIAIQdByLIFQQA2AgAgB0EBRw0BCxAGIQAQBxogAigCGCEDQciyBUEANgIAIAMQ6AFByLIFKAIAIQNByLIFQQA2AgAgA0EBRw0ZQQAQCyEBEAcaIAEQhAEACyAGQQA7AQBByLIFQQA2AgBB2wAgASAEEAVByLIFKAIAIQJByLIFQQA2AgAgAkEBRg0AQciyBUEANgIAQS1BHBANIQJByLIFKAIAIQRByLIFQQA2AgAgBEEBRg0AQciyBUEANgIAIAIgAUGRrgEQoAQhBEHIsgUoAgAhBkHIsgVBADYCACAGQQFGDRkgAkEANgIYIAJCADcCECACQaDNAjYCAEHIsgVBADYCACAFIAJBARAFQciyBSgCACEGQciyBUEANgIAAkAgBkEBRwRAQciyBUEANgIAQd4AIAJBEGpBABAVIQZByLIFKAIAIQdByLIFQQA2AgAgB0EBRw0BCxAGIQAQBxogAigCGCEDQciyBUEANgIAIAMQ6AFByLIFKAIAIQNByLIFQQA2AgAgA0EBRw0bQQAQCyEBEAcaIAEQhAEACyAGQQA7AQBByLIFQQA2AgBB2wAgASAEEAVByLIFKAIAIQJByLIFQQA2AgAgAkEBRg0AQciyBUEANgIAQS1BHBANIQJByLIFKAIAIQRByLIFQQA2AgAgBEEBRg0AQciyBUEANgIAIAIgAUGbrgEQoAQhBEHIsgUoAgAhBkHIsgVBADYCACAGQQFGDRsgAkEANgIYIAJCADcCECACQaDNAjYCAEHIsgVBADYCACAFIAJBARAFQciyBSgCACEGQciyBUEANgIAAkAgBkEBRwRAQciyBUEANgIAQd4AIAJBEGpBABAVIQZByLIFKAIAIQdByLIFQQA2AgAgB0EBRw0BCxAGIQAQBxogAigCGCEDQciyBUEANgIAIAMQ6AFByLIFKAIAIQNByLIFQQA2AgAgA0EBRw0dQQAQCyEBEAcaIAEQhAEACyAGQQA7AQBByLIFQQA2AgBB2wAgASAEEAVByLIFKAIAIQJByLIFQQA2AgAgAkEBRg0AQciyBUEANgIAQS1BHBANIQJByLIFKAIAIQRByLIFQQA2AgAgBEEBRg0AQciyBUEANgIAIAIgAUGjrgEQoAQhBEHIsgUoAgAhBkHIsgVBADYCACAGQQFGDR0gAkEANgIYIAJCADcCECACQaDNAjYCAEHIsgVBADYCACAFIAJBARAFQciyBSgCACEFQciyBUEANgIAAkAgBUEBRwRAQciyBUEANgIAQd4AIAJBEGpBABAVIQVByLIFKAIAIQZByLIFQQA2AgAgBkEBRw0BCxAGIQAQBxogAigCGCEDQciyBUEANgIAIAMQ6AFByLIFKAIAIQNByLIFQQA2AgAgA0EBRw0fQQAQCyEBEAcaIAEQhAEACyAFQQA7AQBByLIFQQA2AgBB2wAgASAEEAVByLIFKAIAIQVByLIFQQA2AgAgBUEBRg0AQciyBUEANgIAQS1BHBANIQVByLIFKAIAIQJByLIFQQA2AgAgAkEBRg0AQciyBUEANgIAIAUgAUGqrgEQoAQhAkHIsgUoAgAhBEHIsgVBADYCACAEQQFGDR8gBUEANgIYIAVCADcCECAFQZDMAjYCAEHIsgVBADYCACADIAVBARAFQciyBSgCACEEQciyBUEANgIAAkAgBEEBRwRAQciyBUEANgIAQdkAIAVBEGpBABAVIQRByLIFKAIAIQZByLIFQQA2AgAgBkEBRw0BCxAGIQAQBxogBSgCGCEDQciyBUEANgIAIAMQ6AFByLIFKAIAIQNByLIFQQA2AgAgA0EBRw0hQQAQCyEBEAcaIAEQhAEACyAEQQA6AABByLIFQQA2AgBB2wAgASACEAVByLIFKAIAIQVByLIFQQA2AgAgBUEBRg0AQciyBUEANgIAQS1BHBANIQVByLIFKAIAIQJByLIFQQA2AgAgAkEBRg0AQciyBUEANgIAIAUgAUGzrgEQoAQhAkHIsgUoAgAhBEHIsgVBADYCACAEQQFGDSEgBUEANgIYIAVCADcCECAFQZDMAjYCAEHIsgVBADYCACADIAVBARAFQciyBSgCACEEQciyBUEANgIAAkAgBEEBRwRAQciyBUEANgIAQdkAIAVBEGpBABAVIQRByLIFKAIAIQZByLIFQQA2AgAgBkEBRw0BCxAGIQAQBxogBSgCGCEDQciyBUEANgIAIAMQ6AFByLIFKAIAIQNByLIFQQA2AgAgA0EBRw0jQQAQCyEBEAcaIAEQhAEACyAEQQA6AABByLIFQQA2AgBB2wAgASACEAVByLIFKAIAIQVByLIFQQA2AgAgBUEBRg0AQciyBUEANgIAQS1BHBANIQVByLIFKAIAIQJByLIFQQA2AgAgAkEBRg0AQciyBUEANgIAIAUgAUG8rgEQoAQhAkHIsgUoAgAhBEHIsgVBADYCACAEQQFGDSMgBUEANgIYIAVCADcCECAFQZDMAjYCAEHIsgVBADYCACADIAVBARAFQciyBSgCACEEQciyBUEANgIAAkAgBEEBRwRAQciyBUEANgIAQdkAIAVBEGpBABAVIQRByLIFKAIAIQZByLIFQQA2AgAgBkEBRw0BCxAGIQAQBxogBSgCGCEDQciyBUEANgIAIAMQ6AFByLIFKAIAIQNByLIFQQA2AgAgA0EBRw0lQQAQCyEBEAcaIAEQhAEACyAEQQA6AABByLIFQQA2AgBB2wAgASACEAVByLIFKAIAIQVByLIFQQA2AgAgBUEBRg0AQciyBUEANgIAQS1BHBANIQVByLIFKAIAIQJByLIFQQA2AgAgAkEBRg0AQciyBUEANgIAIAUgAUHJrgEQoAQhAkHIsgUoAgAhBEHIsgVBADYCACAEQQFGDSUgBUEANgIYIAVCADcCECAFQZDMAjYCAEHIsgVBADYCACADIAVBARAFQciyBSgCACEEQciyBUEANgIAAkAgBEEBRwRAQciyBUEANgIAQdkAIAVBEGpBABAVIQRByLIFKAIAIQZByLIFQQA2AgAgBkEBRw0BCxAGIQAQBxogBSgCGCEDQciyBUEANgIAIAMQ6AFByLIFKAIAIQNByLIFQQA2AgAgA0EBRw0nQQAQCyEBEAcaIAEQhAEACyAEQQA6AABByLIFQQA2AgBB2wAgASACEAVByLIFKAIAIQVByLIFQQA2AgAgBUEBRg0AQciyBUEANgIAQS1BHBANIQVByLIFKAIAIQJByLIFQQA2AgAgAkEBRg0AQciyBUEANgIAIAUgAUHYrgEQoAQhAkHIsgUoAgAhBEHIsgVBADYCACAEQQFGDScgBUEANgIYIAVCADcCECAFQZDMAjYCAEHIsgVBADYCACADIAVBARAFQciyBSgCACEEQciyBUEANgIAAkAgBEEBRwRAQciyBUEANgIAQdkAIAVBEGpBABAVIQRByLIFKAIAIQZByLIFQQA2AgAgBkEBRw0BCxAGIQAQBxogBSgCGCEDQciyBUEANgIAIAMQ6AFByLIFKAIAIQNByLIFQQA2AgAgA0EBRw0pQQAQCyEBEAcaIAEQhAEACyAEQQA6AABByLIFQQA2AgBB2wAgASACEAVByLIFKAIAIQVByLIFQQA2AgAgBUEBRg0AQciyBUEANgIAQS1BHBANIQVByLIFKAIAIQJByLIFQQA2AgAgAkEBRg0AQciyBUEANgIAIAUgAUHmrgEQoAQhAkHIsgUoAgAhBEHIsgVBADYCACAEQQFGDSkgBUEANgIYIAVCADcCECAFQZDMAjYCAEHIsgVBADYCACADIAVBARAFQciyBSgCACEDQciyBUEANgIAAkAgA0EBRwRAQciyBUEANgIAQdkAIAVBEGpBABAVIQNByLIFKAIAIQRByLIFQQA2AgAgBEEBRw0BCxAGIQAQBxogBSgCGCEDQciyBUEANgIAIAMQ6AFByLIFKAIAIQNByLIFQQA2AgAgA0EBRw0rQQAQCyEBEAcaIAEQhAEACyADQQA6AABByLIFQQA2AgBB2wAgASACEAVByLIFKAIAIQNByLIFQQA2AgAgA0EBRg0AQciyBUEANgIAQa8BIAFB9a4BQQBBABAcQciyBSgCACEDQciyBUEANgIAIANBAUcNLAsQBiEAEAcaDCoLEAYhABAHGgsgAxD2DAwoCxAGIQAQBxoLIAMQ9gwMJgsQBiEAEAcaCyACEPYMDCQLEAYhABAHGgsgAhD2DAwiCxAGIQAQBxoLIAIQ9gwMIAsQBiEAEAcaCyACEPYMDB4LEAYhABAHGgsgAhD2DAwcCxAGIQAQBxoLIAIQ9gwMGgsQBiEAEAcaCyACEPYMDBgLEAYhABAHGgsgAhD2DAwWCxAGIQAQBxoLIAIQ9gwMFAsQBiEAEAcaCyACEPYMDBILEAYhABAHGgsgAhD2DAwQCxAGIQAQBxoLIAIQ9gwMDgsQBiEAEAcaCyACEPYMDAwLEAYhABAHGgsgBRD2DAwKCxAGIQAQBxoLIAUQ9gwMCAsQBiEAEAcaCyAFEPYMDAYLEAYhABAHGgsgBRD2DAwECxAGIQAQBxoLIAUQ9gwMAgsQBiEAEAcaCyAFEPYMCyABEIQDGiAAEAgACyAACxwAIAAQiQMgAEHIAGpBAhCsASgCAEEBQQAQ3QELWQEBfyAAIAFBpK8BEIIDIQEgAEG0rwE2AgBByLIFQQA2AgBB0QEgARAPQciyBSgCACECQciyBUEANgIAIAJBAUcEQCAADwsQBiEAEAcaIAEQhAMaIAAQCAALohoBBX9BHBD+CyECAkACQAJAIAFBAUYEQEHIsgVBADYCACACIABB2K8BEKAEIQRByLIFKAIAIQNByLIFQQA2AgACQCADQQFHBEAgAkEANgIYIAJCADcCECACQcDPAjYCAEHIsgVBADYCAEHQzwIoAgAiAyACQQEQBUHIsgUoAgAhBUHIsgVBADYCAAJAIAVBAUcEQEHIsgVBADYCAEHcACACQRBqQQAQFSEFQciyBSgCACEGQciyBUEANgIAIAZBAUcNAQsQBiEAEAcaIAIoAhghAUHIsgVBADYCACABEOgBQciyBSgCACEBQciyBUEANgIAIAFBAUcNBkEAEAshAhAHGiACEIQBAAsgBUIANwMAIAAgBBCMA0EcEP4LIQJByLIFQQA2AgAgAiAAQeWvARCgBCEEQciyBSgCACEFQciyBUEANgIAIAVBAUYNASACQQA2AhggAkIANwIQIAJBwM8CNgIAQciyBUEANgIAIAMgAkEBEAVByLIFKAIAIQNByLIFQQA2AgAgA0EBRwRAQciyBUEANgIAQdwAIAJBEGpBABAVIQNByLIFKAIAIQVByLIFQQA2AgAgBUEBRw0ECxAGIQAQBxogAigCGCEBQciyBUEANgIAIAEQ6AFByLIFKAIAIQFByLIFQQA2AgAgAUEBRw0FQQAQCyECEAcaIAIQhAEACxAGIQAQBxoMBAsQBiEAEAcaDAMLQciyBUEANgIAIAIgAEHYrwEQoAQhBEHIsgUoAgAhA0HIsgVBADYCAAJAIANBAUcEQCACQQA2AhggAkIANwIQIAJB4M4CNgIAQciyBUEANgIAQfDOAigCACIDIAJBARAFQciyBSgCACEFQciyBUEANgIAAkAgBUEBRwRAQciyBUEANgIAQfsAIAJBEGpBABAVIQVByLIFKAIAIQZByLIFQQA2AgAgBkEBRw0BCxAGIQAQBxogAigCGCEBQciyBUEANgIAIAEQ6AFByLIFKAIAIQFByLIFQQA2AgAgAUEBRw0FQQAQCyECEAcaIAIQhAEACyAFQQA2AgAgACAEEIwDQRwQ/gshAkHIsgVBADYCACACIABB5a8BEKAEIQRByLIFKAIAIQVByLIFQQA2AgAgBUEBRg0BIAJBADYCGCACQgA3AhAgAkHgzgI2AgBByLIFQQA2AgAgAyACQQEQBUHIsgUoAgAhA0HIsgVBADYCAAJAIANBAUcEQEHIsgVBADYCAEH7ACACQRBqQQAQFSEDQciyBSgCACEFQciyBUEANgIAIAVBAUcNAQsQBiEAEAcaIAIoAhghAUHIsgVBADYCACABEOgBQciyBSgCACEBQciyBUEANgIAIAFBAUcNBUEAEAshAhAHGiACEIQBAAsgA0EANgIADAMLEAYhABAHGgwDCxAGIQAQBxoMAgsgA0IANwMACyAAIAQQjANBHBD+CyECQciyBUEANgIAIAIgAEH2rwEQoAQhBEHIsgUoAgAhA0HIsgVBADYCAAJAAkACQAJAIANBAUcEQCACQQA2AhggAkIANwIQIAJB4M4CNgIAQciyBUEANgIAQfDOAigCACIGIAJBARAFQciyBSgCACEDQciyBUEANgIAAkAgA0EBRwRAQciyBUEANgIAQfsAIAJBEGpBABAVIQNByLIFKAIAIQVByLIFQQA2AgAgBUEBRw0BCxAGIQAQBxogAigCGCEBQciyBUEANgIAIAEQ6AFByLIFKAIAIQFByLIFQQA2AgAgAUEBRw0GQQAQCyECEAcaIAIQhAEACyADQQA2AgAgACAEEIwDIAAgAEH+rwFBBBCbA0EcEP4LIQIgAUEBRw0CQciyBUEANgIAIAIgAEGIsAEQoAQaQciyBSgCACEBQciyBUEANgIAIAFBAUYNASACQQA2AhggAkIANwIQIAJBwM8CNgIAQciyBUEANgIAQdDPAigCACACQQEQBUHIsgUoAgAhAUHIsgVBADYCACABQQFHBEBByLIFQQA2AgBB3AAgAkEQakEAEBUhAUHIsgUoAgAhBEHIsgVBADYCACAEQQFHDQQLEAYhABAHGiACKAIYIQFByLIFQQA2AgAgARDoAUHIsgUoAgAhAUHIsgVBADYCACABQQFHDQVBABALIQIQBxogAhCEAQALEAYhABAHGgwECxAGIQAQBxoMAwtByLIFQQA2AgAgAiAAQYiwARCgBBpByLIFKAIAIQFByLIFQQA2AgAgAUEBRwRAIAJBADYCGCACQgA3AhAgAkHgzgI2AgBByLIFQQA2AgAgBiACQQEQBUHIsgUoAgAhAUHIsgVBADYCAAJAIAFBAUcEQEHIsgVBADYCAEH7ACACQRBqQQAQFSEBQciyBSgCACEEQciyBUEANgIAIARBAUcNAQsQBiEAEAcaIAIoAhghAUHIsgVBADYCACABEOgBQciyBSgCACEBQciyBUEANgIAIAFBAUcNBEEAEAshAhAHGiACEIQBAAsgAUEANgIADAILEAYhABAHGgwCCyABQgA3AwALIAAgAhCMAyAAIABBkbABQQgQmwNBHBD+CyECQciyBUEANgIAIAIgAEGbsAEQoAQhAUHIsgUoAgAhBEHIsgVBADYCAAJAAkACQAJAAkAgBEEBRwRAIAJBADYCGCACQgA3AhAgAkGgzQI2AgBByLIFQQA2AgBBsM0CKAIAIgQgAkEBEAVByLIFKAIAIQNByLIFQQA2AgACQCADQQFHBEBByLIFQQA2AgBB3gAgAkEQakEAEBUhA0HIsgUoAgAhBUHIsgVBADYCACAFQQFHDQELEAYhABAHGiACKAIYIQFByLIFQQA2AgAgARDoAUHIsgUoAgAhAUHIsgVBADYCACABQQFHDQdBABALIQIQBxogAhCEAQALIANBADsBACAAIAEQjANBHBD+CyECQciyBUEANgIAIAIgAEGhsAEQoAQhAUHIsgUoAgAhA0HIsgVBADYCACADQQFGDQEgAkEANgIYIAJCADcCECACQaDNAjYCAEHIsgVBADYCACAEIAJBARAFQciyBSgCACEEQciyBUEANgIAAkAgBEEBRwRAQciyBUEANgIAQd4AIAJBEGpBABAVIQRByLIFKAIAIQNByLIFQQA2AgAgA0EBRw0BCxAGIQAQBxogAigCGCEBQciyBUEANgIAIAEQ6AFByLIFKAIAIQFByLIFQQA2AgAgAUEBRw0HQQAQCyECEAcaIAIQhAEACyAEQQA7AQAgACABEIwDQRwQ/gshAkHIsgVBADYCACACIABBsbABEKAEIQRByLIFKAIAIQFByLIFQQA2AgAgAUEBRg0CIAJCADcBDiACQYDRAjYCACACQgA3ARRByLIFQQA2AgBBkNECKAIAIgEgAkEBEAVByLIFKAIAIQNByLIFQQA2AgACQCADQQFHBEBByLIFQQA2AgBBhAIgAkEQakEAEBUhA0HIsgUoAgAhBUHIsgVBADYCACAFQQFHDQELEAYhABAHGiACKAIYIQFByLIFQQA2AgAgARDoAUHIsgUoAgAhAUHIsgVBADYCACABQQFHDQdBABALIQIQBxogAhCEAQALIANBADYCACACQQE6AA4gACAEEIwDIAAgAEG4sAFBAhCbA0EwEP4LIQJByLIFQQA2AgBB4AAgAiAAQcKwAUEkQQAQEBpByLIFKAIAIQRByLIFQQA2AgAgBEEBRg0DIAAgAhCMA0EcEP4LIQJByLIFQQA2AgAgAiAAQcmwARCgBCEEQciyBSgCACEDQciyBUEANgIAIANBAUYNBCACQgA3AQ4gAkGA0QI2AgAgAkIANwEUQciyBUEANgIAIAEgAkEBEAVByLIFKAIAIQNByLIFQQA2AgACQCADQQFHBEBByLIFQQA2AgBBhAIgAkEQakEAEBUhA0HIsgUoAgAhBUHIsgVBADYCACAFQQFHDQELEAYhABAHGiACKAIYIQFByLIFQQA2AgAgARDoAUHIsgUoAgAhAUHIsgVBADYCACABQQFHDQdBABALIQIQBxogAhCEAQALIANBADYCACACQQE6AA8gACAEEIwDQRwQ/gshAkHIsgVBADYCACACIABBz7ABEKAEIQRByLIFKAIAIQNByLIFQQA2AgAgA0EBRg0FIAJCADcBDiACQYDRAjYCACACQgA3ARRByLIFQQA2AgAgASACQQEQBUHIsgUoAgAhAUHIsgVBADYCAAJAIAFBAUcEQEHIsgVBADYCAEGEAiACQRBqQQAQFSEBQciyBSgCACEDQciyBUEANgIAIANBAUcNAQsQBiEAEAcaIAIoAhghAUHIsgVBADYCACABEOgBQciyBSgCACEBQciyBUEANgIAIAFBAUcNB0EAEAshAhAHGiACEIQBAAsgAUEANgIAIAJBAToADyAAIAQQjAMPCxAGIQAQBxoMBQsQBiEAEAcaDAQLEAYhABAHGgwDCxAGIQAQBxoMAgsQBiEAEAcaDAELEAYhABAHGgsgAhD2DCAAEAgAC5MBAgJ/AX4gACAAKAIEIABBKGoQ3wMiARCfAyAAIAEQ8gIgABCJAxCsBSEDIABByABqIgBBAhCsASgCACECAkAgAQRAIAIgA0EAEK4BIABBAxCsASgCACADQQAQrgEMAQsgAiADpyIBQQAQ1wEgAEEDEKwBKAIAIAFBABDXAQsgAEEMEKwBKAIAQYCPBEEkQQAQvwQLIwAgAEEAQQEQjgMgACAAEJ4DEPICIABBAUF/EI4DIAAQkAMLvQMBBH8gACABQYCxARCCAyEEIABBkLEBNgIAQciyBUEANgIAQdEBIAQQD0HIsgUoAgAhAUHIsgVBADYCAAJAAkACQAJAAkAgAUEBRg0AQciyBUEANgIAQS1BHBANIQFByLIFKAIAIQJByLIFQQA2AgAgAkEBRg0AQciyBUEANgIAIAEgBEG0sQEQoAQhAkHIsgUoAgAhA0HIsgVBADYCACADQQFGDQEgAUEANgIYIAFCADcCECABQeDOAjYCAEHIsgVBADYCAEHwzgIoAgAgAUEBEAVByLIFKAIAIQNByLIFQQA2AgACQCADQQFHBEBByLIFQQA2AgBB+wAgAUEQakEAEBUhA0HIsgUoAgAhBUHIsgVBADYCACAFQQFHDQELEAYhABAHGiABKAIYIQJByLIFQQA2AgAgAhDoAUHIsgUoAgAhAkHIsgVBADYCACACQQFHDQNBABALIQEQBxogARCEAQALIANBADYCAEHIsgVBADYCAEHbACAEIAIQBUHIsgUoAgAhAUHIsgVBADYCACABQQFHDQQLEAYhABAHGgwCCxAGIQAQBxoLIAEQ9gwLIAQQhAMaIAAQCAALIAAL9goBBH8CQAJAIAFBAXEEQEEcEP4LIQJByLIFQQA2AgAgAiAAQbyxARCgBCEEQciyBSgCACEDQciyBUEANgIAIANBAUYNASACQQA2AhggAkIANwIQIAJBwM8CNgIAQciyBUEANgIAQdDPAigCACACQQEQBUHIsgUoAgAhA0HIsgVBADYCAAJAIANBAUcEQEHIsgVBADYCAEHcACACQRBqQQAQFSEDQciyBSgCACEFQciyBUEANgIAIAVBAUcNAQsQBiEAEAcaIAIoAhghAUHIsgVBADYCACABEOgBQciyBSgCACEBQciyBUEANgIAIAFBAUcNA0EAEAshAhAHGiACEIQBAAsgA0IANwMAIAAgBBCMAwsgAUECcQRAQRwQ/gshAkHIsgVBADYCACACIABBy7EBEKAEIQRByLIFKAIAIQNByLIFQQA2AgACQCADQQFHBEAgAkEANgIYIAJCADcCECACQeDOAjYCAEHIsgVBADYCAEHwzgIoAgAgAkEBEAVByLIFKAIAIQNByLIFQQA2AgAgA0EBRwRAQciyBUEANgIAQfsAIAJBEGpBABAVIQNByLIFKAIAIQVByLIFQQA2AgAgBUEBRw0CCxAGIQAQBxogAigCGCEBQciyBUEANgIAIAEQ6AFByLIFKAIAIQFByLIFQQA2AgAgAUEBRw0EQQAQCyECEAcaIAIQhAEACxAGIQAQBxoMAwsgA0EANgIAIAAgBBCMAwsgAUEIcQRAQRwQ/gshAkHIsgVBADYCACACIABB4rEBEKAEIQRByLIFKAIAIQNByLIFQQA2AgACQCADQQFHBEAgAkEANgIYIAJCADcCECACQeDOAjYCAEHIsgVBADYCAEHwzgIoAgAgAkEBEAVByLIFKAIAIQNByLIFQQA2AgAgA0EBRwRAQciyBUEANgIAQfsAIAJBEGpBABAVIQNByLIFKAIAIQVByLIFQQA2AgAgBUEBRw0CCxAGIQAQBxogAigCGCEBQciyBUEANgIAIAEQ6AFByLIFKAIAIQFByLIFQQA2AgAgAUEBRw0EQQAQCyECEAcaIAIQhAEACxAGIQAQBxoMAwsgA0EANgIAIAAgBBCMAwsgAUEQcQRAQRwQ/gshAkHIsgVBADYCACACIABB+LEBEKAEIQRByLIFKAIAIQNByLIFQQA2AgACQCADQQFHBEAgAkEANgIYIAJCADcCECACQeDOAjYCAEHIsgVBADYCAEHwzgIoAgAgAkEBEAVByLIFKAIAIQNByLIFQQA2AgAgA0EBRwRAQciyBUEANgIAQfsAIAJBEGpBABAVIQNByLIFKAIAIQVByLIFQQA2AgAgBUEBRw0CCxAGIQAQBxogAigCGCEBQciyBUEANgIAIAEQ6AFByLIFKAIAIQFByLIFQQA2AgAgAUEBRw0EQQAQCyECEAcaIAIQhAEACxAGIQAQBxoMAwsgA0EANgIAIAAgBBCMAwsgAUEgcQRAQRwQ/gshAkHIsgVBADYCACACIABBirIBEKAEIQFByLIFKAIAIQRByLIFQQA2AgACQCAEQQFHBEAgAkEANgIYIAJCADcCECACQeDOAjYCAEHIsgVBADYCAEHwzgIoAgAgAkEBEAVByLIFKAIAIQRByLIFQQA2AgAgBEEBRwRAQciyBUEANgIAQfsAIAJBEGpBABAVIQRByLIFKAIAIQNByLIFQQA2AgAgA0EBRw0CCxAGIQAQBxogAigCGCEBQciyBUEANgIAIAEQ6AFByLIFKAIAIQFByLIFQQA2AgAgAUEBRw0EQQAQCyECEAcaIAIQhAEACxAGIQAQBxoMAwsgBEEANgIAIAAgARCMAwsPCxAGIQAQBxoLIAIQ9gwgABAIAAsjACAAQQBBAxCOAyAAIAAQoAMQ9gIgAEEDQX8QjgMgABCQAwu9AwEEfyAAIAFBxLIBEIIDIQQgAEHUsgE2AgBByLIFQQA2AgBB0QEgBBAPQciyBSgCACEBQciyBUEANgIAAkACQAJAAkACQCABQQFGDQBByLIFQQA2AgBBLUEcEA0hAUHIsgUoAgAhAkHIsgVBADYCACACQQFGDQBByLIFQQA2AgAgASAEQfiyARCgBCECQciyBSgCACEDQciyBUEANgIAIANBAUYNASABQQA2AhggAUIANwIQIAFB4M4CNgIAQciyBUEANgIAQfDOAigCACABQQEQBUHIsgUoAgAhA0HIsgVBADYCAAJAIANBAUcEQEHIsgVBADYCAEH7ACABQRBqQQAQFSEDQciyBSgCACEFQciyBUEANgIAIAVBAUcNAQsQBiEAEAcaIAEoAhghAkHIsgVBADYCACACEOgBQciyBSgCACECQciyBUEANgIAIAJBAUcNA0EAEAshARAHGiABEIQBAAsgA0EANgIAQciyBUEANgIAQdsAIAQgAhAFQciyBSgCACEBQciyBUEANgIAIAFBAUcNBAsQBiEAEAcaDAILEAYhABAHGgsgARD2DAsgBBCEAxogABAIAAsgAAuWDgEFfwJAAkAgAUEBcQRAQRwQ/gshAkHIsgVBADYCACACIABBhLMBEKAEIQVByLIFKAIAIQNByLIFQQA2AgAgA0EBRg0BIAJBADYCGCACQgA3AhAgAkHgzgI2AgBByLIFQQA2AgBB8M4CKAIAIAJBARAFQciyBSgCACEDQciyBUEANgIAAkAgA0EBRwRAQciyBUEANgIAQfsAIAJBEGpBABAVIQNByLIFKAIAIQRByLIFQQA2AgAgBEEBRw0BCxAGIQAQBxogAigCGCEBQciyBUEANgIAIAEQ6AFByLIFKAIAIQFByLIFQQA2AgAgAUEBRw0DQQAQCyECEAcaIAIQhAEACyADQQA2AgAgACAFEIwDCyABQQRxBEBBHBD+CyECQciyBUEANgIAIAIgAEGPswEQoAQhBUHIsgUoAgAhA0HIsgVBADYCAAJAIANBAUcEQCACQQA2AhggAkIANwIQIAJB4M4CNgIAQciyBUEANgIAQfDOAigCACACQQEQBUHIsgUoAgAhA0HIsgVBADYCACADQQFHBEBByLIFQQA2AgBB+wAgAkEQakEAEBUhA0HIsgUoAgAhBEHIsgVBADYCACAEQQFHDQILEAYhABAHGiACKAIYIQFByLIFQQA2AgAgARDoAUHIsgUoAgAhAUHIsgVBADYCACABQQFHDQRBABALIQIQBxogAhCEAQALEAYhABAHGgwDCyADQQA2AgAgACAFEIwDC0EgEP4LIQJByLIFQQA2AgBB5gEgAEHIAGpBAhAVIQVByLIFKAIAIQNByLIFQQA2AgACQAJAAkACQCADQQFGDQAgBSgCACEFQciyBUEANgIAIAIgAEGgswEgBRDFBCEFQciyBSgCACEDQciyBUEANgIAIANBAUYNACAAIAIQjAMgAUGAAnFFDQNBHBD+CyECQciyBUEANgIAIAIgAEGoswEQoAQhA0HIsgUoAgAhBEHIsgVBADYCACAEQQFGDQEgAkEANgIYIAJCADcCECACQeDOAjYCAEHIsgVBADYCAEHwzgIoAgAgAkEBEAVByLIFKAIAIQRByLIFQQA2AgAgBEEBRwRAQciyBUEANgIAQfsAIAJBEGpBABAVIQRByLIFKAIAIQZByLIFQQA2AgAgBkEBRw0DCxAGIQAQBxogAigCGCEBQciyBUEANgIAIAEQ6AFByLIFKAIAIQFByLIFQQA2AgAgAUEBRw0FQQAQCyECEAcaIAIQhAEACxAGIQAQBxoMBAsQBiEAEAcaDAMLIARBADYCACAFIAMQyAQLIAFBgARxBEBBHBD+CyECQciyBUEANgIAIAIgAEG3swEQoAQhA0HIsgUoAgAhBEHIsgVBADYCAAJAIARBAUcEQCACQQA2AhggAkIANwIQIAJB4M4CNgIAQciyBUEANgIAQfDOAigCACACQQEQBUHIsgUoAgAhBEHIsgVBADYCACAEQQFHBEBByLIFQQA2AgBB+wAgAkEQakEAEBUhBEHIsgUoAgAhBkHIsgVBADYCACAGQQFHDQILEAYhABAHGiACKAIYIQFByLIFQQA2AgAgARDoAUHIsgUoAgAhAUHIsgVBADYCACABQQFHDQRBABALIQIQBxogAhCEAQALEAYhABAHGgwDCyAEQQA2AgAgBSADEMgECyABQYAIcQRAQRwQ/gshAkHIsgVBADYCACACIABBwrMBEKAEIQNByLIFKAIAIQRByLIFQQA2AgACQCAEQQFHBEAgAkEANgIYIAJCADcCECACQeDOAjYCAEHIsgVBADYCAEHwzgIoAgAgAkEBEAVByLIFKAIAIQRByLIFQQA2AgAgBEEBRwRAQciyBUEANgIAQfsAIAJBEGpBABAVIQRByLIFKAIAIQZByLIFQQA2AgAgBkEBRw0CCxAGIQAQBxogAigCGCEBQciyBUEANgIAIAEQ6AFByLIFKAIAIQFByLIFQQA2AgAgAUEBRw0EQQAQCyECEAcaIAIQhAEACxAGIQAQBxoMAwsgBEEANgIAIAUgAxDIBAsgAUGAEHEEQEEcEP4LIQJByLIFQQA2AgAgAiAAQc6zARCgBCEAQciyBSgCACEBQciyBUEANgIAAkAgAUEBRwRAIAJBADYCGCACQgA3AhAgAkHgzgI2AgBByLIFQQA2AgBB8M4CKAIAIAJBARAFQciyBSgCACEBQciyBUEANgIAIAFBAUcEQEHIsgVBADYCAEH7ACACQRBqQQAQFSEBQciyBSgCACEDQciyBUEANgIAIANBAUcNAgsQBiEAEAcaIAIoAhghAUHIsgVBADYCACABEOgBQciyBSgCACEBQciyBUEANgIAIAFBAUcNBEEAEAshAhAHGiACEIQBAAsQBiEAEAcaDAMLIAFBADYCACAFIAAQyAQLDwsQBiEAEAcaCyACEPYMIAAQCAALIwAgAEEAQQMQjgMgACAAEKADEPkCIABBA0F/EI4DIAAQkAML6wMBAX8gACABQZS0ARCCAyEBIABBpLQBNgIAQciyBUEANgIAQa8BIAFByLQBQQBBARAcQciyBSgCACECQciyBUEANgIAAkAgAkEBRg0AQciyBUEANgIAQa8BIAFBzbQBQQBBABAcQciyBSgCACECQciyBUEANgIAIAJBAUYNAEHIsgVBADYCAEGvASABQdK0AUEAQQEQHEHIsgUoAgAhAkHIsgVBADYCACACQQFGDQBByLIFQQA2AgBBrwEgAUHXtAFBAEEBEBxByLIFKAIAIQJByLIFQQA2AgAgAkEBRg0AQciyBUEANgIAQa8BIAFB3LQBQQBBARAcQciyBSgCACECQciyBUEANgIAIAJBAUYNAEHIsgVBADYCAEGvASABQeG0AUEAQQEQHEHIsgUoAgAhAkHIsgVBADYCACACQQFGDQBByLIFQQA2AgBBrwEgAUHmtAFBAEEBEBxByLIFKAIAIQJByLIFQQA2AgAgAkEBRg0AQciyBUEANgIAQa8BIAFB67QBQQBBARAcQciyBSgCACECQciyBUEANgIAIAJBAUYNAEHIsgVBADYCAEGvASABQfC0AUEAQQEQHEHIsgUoAgAhAkHIsgVBADYCACACQQFGDQAgAA8LEAYhABAHGiABEIQDGiAAEAgACzcAIAAoAkBBKGoQrQVB9bQBEK0FRgRAIABB+rQBQQBBARCcAyAAQf+0AUEAQQEQnAMLIAAQjQMLmAMBAn8gACABQay1ARCCAyEBIABBvLUBNgIAQciyBUEANgIAQdEBIAEQD0HIsgUoAgAhAkHIsgVBADYCAAJAAkACQAJAAkAgAkEBRg0AQciyBUEANgIAQS1BJBANIQJByLIFKAIAIQNByLIFQQA2AgAgA0EBRg0AQciyBUEANgIAQf0AIAIgAUHgtQFBAEEAQQAQFhpByLIFKAIAIQNByLIFQQA2AgAgA0EBRg0BQciyBUEANgIAQdsAIAEgAhAFQciyBSgCACECQciyBUEANgIAIAJBAUYNAEHIsgVBADYCAEEtQSQQDSECQciyBSgCACEDQciyBUEANgIAIANBAUYNAEHIsgVBADYCAEH9ACACIAFB5bUBQQBBAEEAEBYaQciyBSgCACEDQciyBUEANgIAIANBAUYNAkHIsgVBADYCAEHbACABIAIQBUHIsgUoAgAhAkHIsgVBADYCACACQQFHDQQLEAYhABAHGgwCCxAGIQAQBxogAhD2DAwBCxAGIQAQBxogAhD2DAsgARCEAxogABAIAAsgAAssACAAQQBBAxCOAyAAKAIEQQAQsAMgACkDEFQEQCAAQQNBfxCOAwsgABCQAwuMAQEBfyAAIAFBlLYBEIIDIQEgAEGktgE2AgBByLIFQQA2AgBB0QEgARAPQciyBSgCACECQciyBUEANgIAAkAgAkEBRg0AQciyBUEANgIAQccBIAEgAUHItgFBCBAcQciyBSgCACECQciyBUEANgIAIAJBAUYNACAADwsQBiEAEAcaIAEQhAMaIAAQCAALDgAgABCJAyAAQQEQoQMLj/QBAQZ/IAAgASACEIIDIQEgAEGAtwE2AgBByLIFQQA2AgAgAhCtBSEDQciyBSgCACEEQciyBUEANgIAAkACQCAEQQFGDQBByLIFQQA2AgBBpLcBEK0FIQRByLIFKAIAIQVByLIFQQA2AgAgBUEBRg0AAkACQCADIARGBEBByLIFQQA2AgBBLUEcEA0hAkHIsgUoAgAhA0HIsgVBADYCACADQQFGDQNByLIFQQA2AgAgAiABQam3ARCgBCEDQciyBSgCACEEQciyBUEANgIAAkACQAJAIARBAUcEQCACQQA2AhggAkIANwIQIAJB4M4CNgIAQciyBUEANgIAQfDOAigCACIEIAJBARAFQciyBSgCACEFQciyBUEANgIAAkAgBUEBRwRAQciyBUEANgIAQfsAIAJBEGpBABAVIQVByLIFKAIAIQZByLIFQQA2AgAgBkEBRw0BCxAGIQAQBxogAigCGCEDQciyBUEANgIAIAMQ6AFByLIFKAIAIQNByLIFQQA2AgAgA0EBRw0CQQAQCyEBEAcaIAEQhAEACyAFQQA2AgBByLIFQQA2AgBB2wAgASADEAVByLIFKAIAIQJByLIFQQA2AgAgAkEBRg0HQciyBUEANgIAQS1BHBANIQJByLIFKAIAIQNByLIFQQA2AgAgA0EBRg0HQciyBUEANgIAIAIgAUG0twEQoAQhA0HIsgUoAgAhBUHIsgVBADYCACAFQQFGDQIgAkEANgIYIAJCADcCECACQeDOAjYCAEHIsgVBADYCACAEIAJBARAFQciyBSgCACEEQciyBUEANgIAAkAgBEEBRwRAQciyBUEANgIAQfsAIAJBEGpBABAVIQRByLIFKAIAIQVByLIFQQA2AgAgBUEBRw0BCxAGIQAQBxogAigCGCEDQciyBUEANgIAIAMQ6AFByLIFKAIAIQNByLIFQQA2AgAgA0EBRw0EQQAQCyEBEAcaIAEQhAEACyAEQQA2AgBByLIFQQA2AgBB2wAgASADEAVByLIFKAIAIQJByLIFQQA2AgAgAkEBRw0FDAcLEAYhABAHGgsgAhD2DAwGCxAGIQAQBxoLIAIQ9gwMBAtByLIFQQA2AgAgAhCtBSEDQciyBSgCACEEQciyBUEANgIAIARBAUYNAkHIsgVBADYCAEG/twEQrQUhBEHIsgUoAgAhBUHIsgVBADYCACAFQQFGDQIgAyAERgRAQciyBUEANgIAQS1BHBANIQJByLIFKAIAIQNByLIFQQA2AgAgA0EBRg0DQciyBUEANgIAIAIgAUHEtwEQoAQhBEHIsgUoAgAhA0HIsgVBADYCAAJAAkACQAJAAkAgA0EBRwRAIAJBADYCGCACQgA3AhAgAkHgzgI2AgBByLIFQQA2AgBB8M4CKAIAIgMgAkEBEAVByLIFKAIAIQVByLIFQQA2AgACQCAFQQFHBEBByLIFQQA2AgBB+wAgAkEQakEAEBUhBUHIsgUoAgAhBkHIsgVBADYCACAGQQFHDQELEAYhABAHGiACKAIYIQNByLIFQQA2AgAgAxDoAUHIsgUoAgAhA0HIsgVBADYCACADQQFHDQJBABALIQEQBxogARCEAQALIAVBADYCAEHIsgVBADYCAEHbACABIAQQBUHIsgUoAgAhAkHIsgVBADYCACACQQFGDQlByLIFQQA2AgBBLUEcEA0hAkHIsgUoAgAhBEHIsgVBADYCACAEQQFGDQlByLIFQQA2AgAgAiABQam3ARCgBCEEQciyBSgCACEFQciyBUEANgIAIAVBAUYNAiACQQA2AhggAkIANwIQIAJB4M4CNgIAQciyBUEANgIAIAMgAkEBEAVByLIFKAIAIQVByLIFQQA2AgACQCAFQQFHBEBByLIFQQA2AgBB+wAgAkEQakEAEBUhBUHIsgUoAgAhBkHIsgVBADYCACAGQQFHDQELEAYhABAHGiACKAIYIQNByLIFQQA2AgAgAxDoAUHIsgUoAgAhA0HIsgVBADYCACADQQFHDQRBABALIQEQBxogARCEAQALIAVBADYCAEHIsgVBADYCAEHbACABIAQQBUHIsgUoAgAhAkHIsgVBADYCACACQQFGDQlByLIFQQA2AgBBLUEcEA0hAkHIsgUoAgAhBEHIsgVBADYCACAEQQFGDQlByLIFQQA2AgAgAiABQbS3ARCgBCEEQciyBSgCACEFQciyBUEANgIAIAVBAUYNBCACQQA2AhggAkIANwIQIAJB4M4CNgIAQciyBUEANgIAIAMgAkEBEAVByLIFKAIAIQNByLIFQQA2AgACQCADQQFHBEBByLIFQQA2AgBB+wAgAkEQakEAEBUhA0HIsgUoAgAhBUHIsgVBADYCACAFQQFHDQELEAYhABAHGiACKAIYIQNByLIFQQA2AgAgAxDoAUHIsgUoAgAhA0HIsgVBADYCACADQQFHDQZBABALIQEQBxogARCEAQALIANBADYCAEHIsgVBADYCAEHbACABIAQQBUHIsgUoAgAhAkHIsgVBADYCACACQQFGDQkMBwsQBiEAEAcaCyACEPYMDAgLEAYhABAHGgsgAhD2DAwGCxAGIQAQBxoLIAIQ9gwMBAtByLIFQQA2AgAgAhCtBSEDQciyBSgCACEEQciyBUEANgIAIARBAUYNAkHIsgVBADYCAEHRtwEQrQUhBEHIsgUoAgAhBUHIsgVBADYCACAFQQFGDQIgAyAERgRAQciyBUEANgIAQS1BJBANIQJByLIFKAIAIQNByLIFQQA2AgAgA0EBRg0DQciyBUEANgIAQf0AIAIgAUHWtwFBAEEAQQAQFhpByLIFKAIAIQNByLIFQQA2AgAgA0EBRg0CQciyBUEANgIAQdsAIAEgAhAFQciyBSgCACECQciyBUEANgIAIAJBAUYNAwwBC0HIsgVBADYCACACEK0FIQNByLIFKAIAIQRByLIFQQA2AgAgBEEBRg0CQciyBUEANgIAQd+3ARCtBSEEQciyBSgCACEFQciyBUEANgIAIAVBAUYNAiADIARGBEBByLIFQQA2AgBB0QEgARAPQciyBSgCACECQciyBUEANgIAIAJBAUYNA0HIsgVBADYCAEEtQRwQDSECQciyBSgCACEDQciyBUEANgIAAkACQAJAAkACQAJAAkACQCADQQFGDQBByLIFQQA2AgAgAiABQeS3ARCgBCEDQciyBSgCACEEQciyBUEANgIAIARBAUYNASACQQA2AhggAkIANwIQIAJB4M4CNgIAQciyBUEANgIAQfDOAigCACACQQEQBUHIsgUoAgAhBEHIsgVBADYCAAJAIARBAUcEQEHIsgVBADYCAEH7ACACQRBqQQAQFSEEQciyBSgCACEFQciyBUEANgIAIAVBAUcNAQsQBiEAEAcaIAIoAhghA0HIsgVBADYCACADEOgBQciyBSgCACEDQciyBUEANgIAIANBAUcNA0EAEAshARAHGiABEIQBAAsgBEEANgIAQciyBUEANgIAQdsAIAEgAxAFQciyBSgCACEDQciyBUEANgIAIANBAUYNAEHIsgVBADYCAEEtQSAQDSEDQciyBSgCACEEQciyBUEANgIAIARBAUYNBEHIsgVBADYCACADIAFB77cBIAIQxQQhBEHIsgUoAgAhAkHIsgVBADYCACACQQFGDQVByLIFQQA2AgBB2wAgASADEAVByLIFKAIAIQJByLIFQQA2AgAgAkEBRg0EQciyBUEANgIAQS1BHBANIQJByLIFKAIAIQNByLIFQQA2AgAgA0EBRg0EQciyBUEANgIAIAIgAUH3twEQoAQhA0HIsgUoAgAhBUHIsgVBADYCACAFQQFGDQYgAkEANgIYIAJCADcCECACQcDPAjYCAEHIsgVBADYCAEHQzwIoAgAgAkEBEAVByLIFKAIAIQVByLIFQQA2AgAgBUEBRwRAQciyBUEANgIAQdwAIAJBEGpBABAVIQVByLIFKAIAIQZByLIFQQA2AgAgBkEBRw0ECxAGIQAQBxogAigCGCEDQciyBUEANgIAIAMQ6AFByLIFKAIAIQNByLIFQQA2AgAgA0EBRw0HQQAQCyEBEAcaIAEQhAEACxAGIQAQBxoMCwsQBiEAEAcaCyACEPYMDAkLIAVCADcDAEHIsgVBADYCAEHfACAEIAMQBUHIsgUoAgAhAkHIsgVBADYCACACQQFHDQULEAYhABAHGgwHCxAGIQAQBxogAxD2DAwGCxAGIQAQBxoLIAIQ9gwMBAtByLIFQQA2AgAgAhCtBSEDQciyBSgCACEEQciyBUEANgIAIARBAUYNAkHIsgVBADYCAEGDuAEQrQUhBEHIsgUoAgAhBUHIsgVBADYCACAFQQFGDQIgAyAERgRAQciyBUEANgIAQdEBIAEQD0HIsgUoAgAhAkHIsgVBADYCACACQQFGDQNByLIFQQA2AgBBLUEcEA0hAkHIsgUoAgAhA0HIsgVBADYCAAJAAkACQAJAAkACQAJAAkACQAJAIANBAUYNAEHIsgVBADYCACACIAFB5LcBEKAEIQNByLIFKAIAIQRByLIFQQA2AgAgBEEBRg0BIAJBADYCGCACQgA3AhAgAkHgzgI2AgBByLIFQQA2AgBB8M4CKAIAIgQgAkEBEAVByLIFKAIAIQVByLIFQQA2AgACQCAFQQFHBEBByLIFQQA2AgBB+wAgAkEQakEAEBUhBUHIsgUoAgAhBkHIsgVBADYCACAGQQFHDQELEAYhABAHGiACKAIYIQNByLIFQQA2AgAgAxDoAUHIsgUoAgAhA0HIsgVBADYCACADQQFHDQNBABALIQEQBxogARCEAQALIAVBADYCAEHIsgVBADYCAEHbACABIAMQBUHIsgUoAgAhA0HIsgVBADYCACADQQFGDQBByLIFQQA2AgBBLUEgEA0hA0HIsgUoAgAhBUHIsgVBADYCACAFQQFGDQRByLIFQQA2AgAgAyABQe+3ASACEMUEIQVByLIFKAIAIQJByLIFQQA2AgAgAkEBRg0FQciyBUEANgIAQdsAIAEgAxAFQciyBSgCACECQciyBUEANgIAIAJBAUYNBEHIsgVBADYCAEEtQRwQDSECQciyBSgCACEGQciyBUEANgIAIAZBAUYNBCADKAIEIQZByLIFQQA2AgAgAiAGQYi4ARCgBCEGQciyBSgCACEHQciyBUEANgIAIAdBAUYNBiACQQA2AhggAkIANwIQIAJB4M4CNgIAQciyBUEANgIAIAQgAkEBEAVByLIFKAIAIQdByLIFQQA2AgACQCAHQQFHBEBByLIFQQA2AgBB+wAgAkEQakEAEBUhB0HIsgUoAgAhCEHIsgVBADYCACAIQQFHDQELEAYhABAHGiACKAIYIQNByLIFQQA2AgAgAxDoAUHIsgUoAgAhA0HIsgVBADYCACADQQFHDQhBABALIQEQBxogARCEAQALIAdBADYCAEHIsgVBADYCAEHfACAFIAYQBUHIsgUoAgAhAkHIsgVBADYCACACQQFGDQRByLIFQQA2AgBBLUEcEA0hAkHIsgUoAgAhBkHIsgVBADYCACAGQQFGDQQgAygCBCEDQciyBUEANgIAIAIgA0GUuAEQoAQhA0HIsgUoAgAhBkHIsgVBADYCACAGQQFGDQggAkEANgIYIAJCADcCECACQeDOAjYCAEHIsgVBADYCACAEIAJBARAFQciyBSgCACEEQciyBUEANgIAIARBAUcEQEHIsgVBADYCAEH7ACACQRBqQQAQFSEEQciyBSgCACEGQciyBUEANgIAIAZBAUcNBAsQBiEAEAcaIAIoAhghA0HIsgVBADYCACADEOgBQciyBSgCACEDQciyBUEANgIAIANBAUcNCUEAEAshARAHGiABEIQBAAsQBiEAEAcaDA0LEAYhABAHGgsgAhD2DAwLCyAEQQA2AgBByLIFQQA2AgBB3wAgBSADEAVByLIFKAIAIQJByLIFQQA2AgAgAkEBRw0HCxAGIQAQBxoMCQsQBiEAEAcaIAMQ9gwMCAsQBiEAEAcaCyACEPYMDAYLEAYhABAHGgsgAhD2DAwEC0HIsgVBADYCACACEK0FIQNByLIFKAIAIQRByLIFQQA2AgAgBEEBRg0CQciyBUEANgIAQaG4ARCtBSEEQciyBSgCACEFQciyBUEANgIAIAVBAUYNAiADIARGBEBByLIFQQA2AgBBrwEgAUGmuAFBAUEBEBxByLIFKAIAIQJByLIFQQA2AgAgAkEBRw0BDAMLQciyBUEANgIAIAIQrQUhA0HIsgUoAgAhBEHIsgVBADYCACAEQQFGDQJByLIFQQA2AgBBq7gBEK0FIQRByLIFKAIAIQVByLIFQQA2AgAgBUEBRg0CIAMgBEYEQEHIsgVBADYCAEEtQRwQDSECQciyBSgCACEDQciyBUEANgIAIANBAUYNA0HIsgVBADYCACACIAFBsLgBEKAEIQNByLIFKAIAIQRByLIFQQA2AgACQCAEQQFHBEAgAkEANgIYIAJCADcCECACQcDPAjYCAEHIsgVBADYCAEHQzwIoAgAgAkEBEAVByLIFKAIAIQRByLIFQQA2AgACQCAEQQFHBEBByLIFQQA2AgBB3AAgAkEQakEAEBUhBEHIsgUoAgAhBUHIsgVBADYCACAFQQFHDQELEAYhABAHGiACKAIYIQNByLIFQQA2AgAgAxDoAUHIsgUoAgAhA0HIsgVBADYCACADQQFHDQJBABALIQEQBxogARCEAQALIARCADcDAEHIsgVBADYCAEHbACABIAMQBUHIsgUoAgAhAkHIsgVBADYCACACQQFHDQMMBQsQBiEAEAcaCyACEPYMDAQLQciyBUEANgIAIAIQrQUhA0HIsgUoAgAhBEHIsgVBADYCACAEQQFGDQJByLIFQQA2AgBBtrgBEK0FIQRByLIFKAIAIQVByLIFQQA2AgAgBUEBRg0CIAMgBEYEQEHIsgVBADYCAEEtQRwQDSECQciyBSgCACEDQciyBUEANgIAIANBAUYNA0HIsgVBADYCACACIAFBu7gBEKAEIQNByLIFKAIAIQRByLIFQQA2AgACQCAEQQFHBEAgAkEANgIYIAJCADcCECACQeDOAjYCAEHIsgVBADYCAEHwzgIoAgAgAkEBEAVByLIFKAIAIQRByLIFQQA2AgACQCAEQQFHBEBByLIFQQA2AgBB+wAgAkEQakEAEBUhBEHIsgUoAgAhBUHIsgVBADYCACAFQQFHDQELEAYhABAHGiACKAIYIQNByLIFQQA2AgAgAxDoAUHIsgUoAgAhA0HIsgVBADYCACADQQFHDQJBABALIQEQBxogARCEAQALIARBADYCAEHIsgVBADYCAEHbACABIAMQBUHIsgUoAgAhAkHIsgVBADYCACACQQFHDQMMBQsQBiEAEAcaCyACEPYMDAQLQciyBUEANgIAIAIQrQUhA0HIsgUoAgAhBEHIsgVBADYCACAEQQFGDQJByLIFQQA2AgBBxbgBEK0FIQRByLIFKAIAIQVByLIFQQA2AgAgBUEBRg0CIAMgBEYEQEHIsgVBADYCAEEtQRwQDSECQciyBSgCACEDQciyBUEANgIAIANBAUYNA0HIsgVBADYCACACIAFBsLgBEKAEIQNByLIFKAIAIQRByLIFQQA2AgACQCAEQQFHBEAgAkEANgIYIAJCADcCECACQcDPAjYCAEHIsgVBADYCAEHQzwIoAgAgAkEBEAVByLIFKAIAIQRByLIFQQA2AgACQCAEQQFHBEBByLIFQQA2AgBB3AAgAkEQakEAEBUhBEHIsgUoAgAhBUHIsgVBADYCACAFQQFHDQELEAYhABAHGiACKAIYIQNByLIFQQA2AgAgAxDoAUHIsgUoAgAhA0HIsgVBADYCACADQQFHDQJBABALIQEQBxogARCEAQALIARCADcDAEHIsgVBADYCAEHbACABIAMQBUHIsgUoAgAhAkHIsgVBADYCACACQQFHDQMMBQsQBiEAEAcaCyACEPYMDAQLQciyBUEANgIAIAIQrQUhA0HIsgUoAgAhBEHIsgVBADYCACAEQQFGDQJByLIFQQA2AgBByrgBEK0FIQRByLIFKAIAIQVByLIFQQA2AgAgBUEBRg0CIAMgBEYEQEHIsgVBADYCAEEtQRwQDSECQciyBSgCACEDQciyBUEANgIAIANBAUYNA0HIsgVBADYCACACIAFBsLgBEKAEIQNByLIFKAIAIQRByLIFQQA2AgACQCAEQQFHBEAgAkEANgIYIAJCADcCECACQcDPAjYCAEHIsgVBADYCAEHQzwIoAgAgAkEBEAVByLIFKAIAIQRByLIFQQA2AgACQCAEQQFHBEBByLIFQQA2AgBB3AAgAkEQakEAEBUhBEHIsgUoAgAhBUHIsgVBADYCACAFQQFHDQELEAYhABAHGiACKAIYIQNByLIFQQA2AgAgAxDoAUHIsgUoAgAhA0HIsgVBADYCACADQQFHDQJBABALIQEQBxogARCEAQALIARCADcDAEHIsgVBADYCAEHbACABIAMQBUHIsgUoAgAhAkHIsgVBADYCACACQQFHDQMMBQsQBiEAEAcaCyACEPYMDAQLQciyBUEANgIAIAIQrQUhA0HIsgUoAgAhBEHIsgVBADYCACAEQQFGDQJByLIFQQA2AgBBz7gBEK0FIQRByLIFKAIAIQVByLIFQQA2AgAgBUEBRg0CIAMgBEYEQEHIsgVBADYCAEGvASABQdS4AUEBQQEQHEHIsgUoAgAhAkHIsgVBADYCACACQQFHDQEMAwtByLIFQQA2AgAgAhCtBSEDQciyBSgCACEEQciyBUEANgIAIARBAUYNAkHIsgVBADYCAEHZuAEQrQUhBEHIsgUoAgAhBUHIsgVBADYCACAFQQFGDQIgAyAERgRAQciyBUEANgIAQdEBIAEQD0HIsgUoAgAhAkHIsgVBADYCACACQQFGDQNByLIFQQA2AgBBLUEoEA0hAkHIsgUoAgAhA0HIsgVBADYCACADQQFGDQNByLIFQQA2AgAgAiABQQBBA0EAQQFBARDPBBpByLIFKAIAIQNByLIFQQA2AgAgA0EBRwRAQciyBUEANgIAQdsAIAEgAhAFQciyBSgCACECQciyBUEANgIAIAJBAUcNAgwECxAGIQAQBxogAhD2DAwEC0HIsgVBADYCACACEK0FIQNByLIFKAIAIQRByLIFQQA2AgAgBEEBRg0CQciyBUEANgIAQd64ARCtBSEEQciyBSgCACEFQciyBUEANgIAIAVBAUYNAiADIARGBEBByLIFQQA2AgBBLUEcEA0hAkHIsgUoAgAhA0HIsgVBADYCACADQQFGDQNByLIFQQA2AgAgAiABQeO4ARCgBCEDQciyBSgCACEEQciyBUEANgIAAkAgBEEBRwRAIAJBADYCGCACQgA3AhAgAkHgzgI2AgBByLIFQQA2AgBB8M4CKAIAIAJBARAFQciyBSgCACEEQciyBUEANgIAAkAgBEEBRwRAQciyBUEANgIAQfsAIAJBEGpBABAVIQRByLIFKAIAIQVByLIFQQA2AgAgBUEBRw0BCxAGIQAQBxogAigCGCEDQciyBUEANgIAIAMQ6AFByLIFKAIAIQNByLIFQQA2AgAgA0EBRw0CQQAQCyEBEAcaIAEQhAEACyAEQQA2AgBByLIFQQA2AgBB2wAgASADEAVByLIFKAIAIQJByLIFQQA2AgAgAkEBRw0DDAULEAYhABAHGgsgAhD2DAwEC0HIsgVBADYCACACEK0FIQNByLIFKAIAIQRByLIFQQA2AgAgBEEBRg0CQciyBUEANgIAQe+4ARCtBSEEQciyBSgCACEFQciyBUEANgIAIAVBAUYNAiADIARGBEBByLIFQQA2AgBBrwEgAUH0uAFBAUEBEBxByLIFKAIAIQJByLIFQQA2AgAgAkEBRg0DQciyBUEANgIAQa8BIAFB+bgBQQBBARAcQciyBSgCACECQciyBUEANgIAIAJBAUYNA0HIsgVBADYCAEGvASABQf64AUEAQQEQHEHIsgUoAgAhAkHIsgVBADYCACACQQFHDQEMAwtByLIFQQA2AgAgAhCtBSEDQciyBSgCACEEQciyBUEANgIAIARBAUYNAkHIsgVBADYCAEGDuQEQrQUhBEHIsgUoAgAhBUHIsgVBADYCACAFQQFGDQIgAyAERgRAQciyBUEANgIAQdEBIAEQD0HIsgUoAgAhAkHIsgVBADYCACACQQFGDQNByLIFQQA2AgBBLUEcEA0hAkHIsgUoAgAhA0HIsgVBADYCACADQQFGDQNByLIFQQA2AgAgAiABQYi5ARCgBCEDQciyBSgCACEEQciyBUEANgIAAkACQAJAAkACQAJAAkACQAJAIARBAUcEQCACQQA2AhggAkIANwIQIAJBoM0CNgIAQciyBUEANgIAQbDNAigCACIEIAJBARAFQciyBSgCACEFQciyBUEANgIAAkAgBUEBRwRAQciyBUEANgIAQd4AIAJBEGpBABAVIQVByLIFKAIAIQZByLIFQQA2AgAgBkEBRw0BCxAGIQAQBxogAigCGCEDQciyBUEANgIAIAMQ6AFByLIFKAIAIQNByLIFQQA2AgAgA0EBRw0CQQAQCyEBEAcaIAEQhAEACyAFQQA7AQBByLIFQQA2AgBB2wAgASADEAVByLIFKAIAIQJByLIFQQA2AgAgAkEBRg0NQciyBUEANgIAQS1BHBANIQJByLIFKAIAIQNByLIFQQA2AgAgA0EBRg0NQciyBUEANgIAIAIgAUGTuQEQoAQhA0HIsgUoAgAhBUHIsgVBADYCACAFQQFGDQIgAkEANgIYIAJCADcCECACQaDNAjYCAEHIsgVBADYCACAEIAJBARAFQciyBSgCACEEQciyBUEANgIAAkAgBEEBRwRAQciyBUEANgIAQd4AIAJBEGpBABAVIQRByLIFKAIAIQVByLIFQQA2AgAgBUEBRw0BCxAGIQAQBxogAigCGCEDQciyBUEANgIAIAMQ6AFByLIFKAIAIQNByLIFQQA2AgAgA0EBRw0EQQAQCyEBEAcaIAEQhAEACyAEQQA7AQBByLIFQQA2AgBB2wAgASADEAVByLIFKAIAIQJByLIFQQA2AgAgAkEBRg0NQciyBUEANgIAQS1BHBANIQJByLIFKAIAIQNByLIFQQA2AgAgA0EBRg0NQciyBUEANgIAIAIgAUGeuQEQoAQhBEHIsgUoAgAhA0HIsgVBADYCACADQQFGDQQgAkEANgIYIAJCADcCECACQeDOAjYCAEHIsgVBADYCAEHwzgIoAgAiAyACQQEQBUHIsgUoAgAhBUHIsgVBADYCAAJAIAVBAUcEQEHIsgVBADYCAEH7ACACQRBqQQAQFSEFQciyBSgCACEGQciyBUEANgIAIAZBAUcNAQsQBiEAEAcaIAIoAhghA0HIsgVBADYCACADEOgBQciyBSgCACEDQciyBUEANgIAIANBAUcNBkEAEAshARAHGiABEIQBAAsgBUEANgIAQciyBUEANgIAQdsAIAEgBBAFQciyBSgCACECQciyBUEANgIAIAJBAUYNDUHIsgVBADYCAEEtQRwQDSECQciyBSgCACEEQciyBUEANgIAIARBAUYNDUHIsgVBADYCACACIAFBqbkBEKAEIQRByLIFKAIAIQVByLIFQQA2AgAgBUEBRg0GIAJBADYCGCACQgA3AhAgAkHgzgI2AgBByLIFQQA2AgAgAyACQQEQBUHIsgUoAgAhBUHIsgVBADYCAAJAIAVBAUcEQEHIsgVBADYCAEH7ACACQRBqQQAQFSEFQciyBSgCACEGQciyBUEANgIAIAZBAUcNAQsQBiEAEAcaIAIoAhghA0HIsgVBADYCACADEOgBQciyBSgCACEDQciyBUEANgIAIANBAUcNCEEAEAshARAHGiABEIQBAAsgBUEANgIAQciyBUEANgIAQdsAIAEgBBAFQciyBSgCACECQciyBUEANgIAIAJBAUYNDUHIsgVBADYCAEEtQRwQDSECQciyBSgCACEEQciyBUEANgIAIARBAUYNDUHIsgVBADYCACACIAFBtLkBEKAEIQRByLIFKAIAIQVByLIFQQA2AgAgBUEBRg0IIAJBADYCGCACQgA3AhAgAkHgzgI2AgBByLIFQQA2AgAgAyACQQEQBUHIsgUoAgAhA0HIsgVBADYCAAJAIANBAUcEQEHIsgVBADYCAEH7ACACQRBqQQAQFSEDQciyBSgCACEFQciyBUEANgIAIAVBAUcNAQsQBiEAEAcaIAIoAhghA0HIsgVBADYCACADEOgBQciyBSgCACEDQciyBUEANgIAIANBAUcNCkEAEAshARAHGiABEIQBAAsgA0EANgIAQciyBUEANgIAQdsAIAEgBBAFQciyBSgCACECQciyBUEANgIAIAJBAUcNCwwNCxAGIQAQBxoLIAIQ9gwMDAsQBiEAEAcaCyACEPYMDAoLEAYhABAHGgsgAhD2DAwICxAGIQAQBxoLIAIQ9gwMBgsQBiEAEAcaCyACEPYMDAQLQciyBUEANgIAIAIQrQUhA0HIsgUoAgAhBEHIsgVBADYCACAEQQFGDQJByLIFQQA2AgBBxrkBEK0FIQRByLIFKAIAIQVByLIFQQA2AgAgBUEBRg0CIAMgBEYEQEHIsgVBADYCAEHRASABEA9ByLIFKAIAIQJByLIFQQA2AgAgAkEBRg0DQciyBUEANgIAQS1BJBANIQJByLIFKAIAIQNByLIFQQA2AgACQCADQQFHBEBByLIFQQA2AgBB/QAgAiABQcu5AUEAQQBBABAWGkHIsgUoAgAhA0HIsgVBADYCACADQQFGDQFByLIFQQA2AgBB2wAgASACEAVByLIFKAIAIQJByLIFQQA2AgAgAkEBRw0DCxAGIQAQBxoMBQsQBiEAEAcaIAIQ9gwMBAtByLIFQQA2AgAgAhCtBSEDQciyBSgCACEEQciyBUEANgIAIARBAUYNAkHIsgVBADYCAEHTuQEQrQUhBEHIsgUoAgAhBUHIsgVBADYCACAFQQFGDQIgAyAERgRAQciyBUEANgIAQdEBIAEQD0HIsgUoAgAhAkHIsgVBADYCACACQQFGDQNByLIFQQA2AgBBLUEgEA0hAkHIsgUoAgAhA0HIsgVBADYCACADQQFGDQNByLIFQQA2AgAgAiABQdi5ARCgBCEDQciyBSgCACEEQciyBUEANgIAAkACQAJAAkACQAJAAkAgBEEBRwRAIAJBADYCGCACQgA3AhAgAkHAzwI2AgBByLIFQQA2AgBB0M8CKAIAIgQgAkEBEAVByLIFKAIAIQVByLIFQQA2AgACQCAFQQFHBEBByLIFQQA2AgBB3AAgAkEQakEAEBUhBUHIsgUoAgAhBkHIsgVBADYCACAGQQFHDQELEAYhABAHGiACKAIYIQNByLIFQQA2AgAgAxDoAUHIsgUoAgAhA0HIsgVBADYCACADQQFHDQJBABALIQEQBxogARCEAQALIAVCADcDACACQQE6ABwgAkGg0AI2AgBByLIFQQA2AgBB2wAgASADEAVByLIFKAIAIQJByLIFQQA2AgAgAkEBRg0LQciyBUEANgIAQS1BIBANIQJByLIFKAIAIQNByLIFQQA2AgAgA0EBRg0LQciyBUEANgIAIAIgAUHtuQEQoAQhA0HIsgUoAgAhBUHIsgVBADYCACAFQQFGDQIgAkEANgIYIAJCADcCECACQcDPAjYCAEHIsgVBADYCACAEIAJBARAFQciyBSgCACEEQciyBUEANgIAAkAgBEEBRwRAQciyBUEANgIAQdwAIAJBEGpBABAVIQRByLIFKAIAIQVByLIFQQA2AgAgBUEBRw0BCxAGIQAQBxogAigCGCEDQciyBUEANgIAIAMQ6AFByLIFKAIAIQNByLIFQQA2AgAgA0EBRw0EQQAQCyEBEAcaIAEQhAEACyAEQgA3AwAgAkEHOgAcIAJBoNACNgIAQciyBUEANgIAQdsAIAEgAxAFQciyBSgCACECQciyBUEANgIAIAJBAUYNC0HIsgVBADYCAEEtQRwQDSECQciyBSgCACEDQciyBUEANgIAIANBAUYNC0HIsgVBADYCACACIAFB9rkBEKAEIQNByLIFKAIAIQRByLIFQQA2AgAgBEEBRg0EIAJBADYCGCACQgA3AhAgAkGQzAI2AgBByLIFQQA2AgBBoMwCKAIAIgQgAkEBEAVByLIFKAIAIQVByLIFQQA2AgACQCAFQQFHBEBByLIFQQA2AgBB2QAgAkEQakEAEBUhBUHIsgUoAgAhBkHIsgVBADYCACAGQQFHDQELEAYhABAHGiACKAIYIQNByLIFQQA2AgAgAxDoAUHIsgUoAgAhA0HIsgVBADYCACADQQFHDQZBABALIQEQBxogARCEAQALIAVBADoAAEHIsgVBADYCAEHbACABIAMQBUHIsgUoAgAhAkHIsgVBADYCACACQQFGDQtByLIFQQA2AgBBLUEcEA0hAkHIsgUoAgAhA0HIsgVBADYCACADQQFGDQtByLIFQQA2AgAgAiABQYu6ARCgBCEDQciyBSgCACEFQciyBUEANgIAIAVBAUYNBiACQQA2AhggAkIANwIQIAJBkMwCNgIAQciyBUEANgIAIAQgAkEBEAVByLIFKAIAIQRByLIFQQA2AgACQCAEQQFHBEBByLIFQQA2AgBB2QAgAkEQakEAEBUhBEHIsgUoAgAhBUHIsgVBADYCACAFQQFHDQELEAYhABAHGiACKAIYIQNByLIFQQA2AgAgAxDoAUHIsgUoAgAhA0HIsgVBADYCACADQQFHDQhBABALIQEQBxogARCEAQALIARBADoAAEHIsgVBADYCAEHbACABIAMQBUHIsgUoAgAhAkHIsgVBADYCACACQQFHDQkMCwsQBiEAEAcaCyACEPYMDAoLEAYhABAHGgsgAhD2DAwICxAGIQAQBxoLIAIQ9gwMBgsQBiEAEAcaCyACEPYMDAQLQciyBUEANgIAIAIQrQUhA0HIsgUoAgAhBEHIsgVBADYCACAEQQFGDQJByLIFQQA2AgBBlboBEK0FIQRByLIFKAIAIQVByLIFQQA2AgAgBUEBRg0CIAMgBEYEQEHIsgVBADYCAEGvASABQZq6AUEAQQEQHEHIsgUoAgAhAkHIsgVBADYCACACQQFGDQNByLIFQQA2AgBBrwEgAUGfugFBAEEBEBxByLIFKAIAIQJByLIFQQA2AgAgAkEBRg0DQciyBUEANgIAQa8BIAFBpLoBQQBBARAcQciyBSgCACECQciyBUEANgIAIAJBAUYNA0HIsgVBADYCAEGvASABQam6AUEAQQEQHEHIsgUoAgAhAkHIsgVBADYCACACQQFGDQNByLIFQQA2AgBBrwEgAUGuugFBAEEBEBxByLIFKAIAIQJByLIFQQA2AgAgAkEBRg0DQciyBUEANgIAQa8BIAFBs7oBQQBBARAcQciyBSgCACECQciyBUEANgIAIAJBAUYNA0HIsgVBADYCAEGvASABQbi6AUEAQQEQHEHIsgUoAgAhAkHIsgVBADYCACACQQFGDQNByLIFQQA2AgBBrwEgAUG9ugFBAEEBEBxByLIFKAIAIQJByLIFQQA2AgAgAkEBRg0DQciyBUEANgIAQa8BIAFBwroBQQBBARAcQciyBSgCACECQciyBUEANgIAIAJBAUYNA0HIsgVBADYCAEGvASABQce6AUEAQQEQHEHIsgUoAgAhAkHIsgVBADYCACACQQFGDQNByLIFQQA2AgBBrwEgAUHMugFBAEEBEBxByLIFKAIAIQJByLIFQQA2AgAgAkEBRg0DQciyBUEANgIAQa8BIAFB0boBQQBBARAcQciyBSgCACECQciyBUEANgIAIAJBAUYNA0HIsgVBADYCAEGvASABQda6AUEAQQEQHEHIsgUoAgAhAkHIsgVBADYCACACQQFGDQNByLIFQQA2AgBBrwEgAUHbugFBAEEBEBxByLIFKAIAIQJByLIFQQA2AgAgAkEBRg0DQciyBUEANgIAQa8BIAFB4LoBQQBBARAcQciyBSgCACECQciyBUEANgIAIAJBAUYNA0HIsgVBADYCAEGvASABQeW6AUEAQQAQHEHIsgUoAgAhAkHIsgVBADYCACACQQFGDQNByLIFQQA2AgBBrwEgAUHqugFBAEEBEBxByLIFKAIAIQJByLIFQQA2AgAgAkEBRg0DQciyBUEANgIAQa8BIAFB77oBQQBBARAcQciyBSgCACECQciyBUEANgIAIAJBAUYNA0HIsgVBADYCAEGvASABQfS6AUEAQQEQHEHIsgUoAgAhAkHIsgVBADYCACACQQFGDQNByLIFQQA2AgBBrwEgAUH5ugFBAEEBEBxByLIFKAIAIQJByLIFQQA2AgAgAkEBRg0DQciyBUEANgIAQa8BIAFB/roBQQBBARAcQciyBSgCACECQciyBUEANgIAIAJBAUYNA0HIsgVBADYCAEGvASABQYO7AUEAQQEQHEHIsgUoAgAhAkHIsgVBADYCACACQQFGDQNByLIFQQA2AgBBrwEgAUGIuwFBAEEBEBxByLIFKAIAIQJByLIFQQA2AgAgAkEBRg0DQciyBUEANgIAQa8BIAFBjbsBQQBBARAcQciyBSgCACECQciyBUEANgIAIAJBAUYNA0HIsgVBADYCAEGvASABQZK7AUEAQQEQHEHIsgUoAgAhAkHIsgVBADYCACACQQFGDQNByLIFQQA2AgBBrwEgAUGXuwFBAEEBEBxByLIFKAIAIQJByLIFQQA2AgAgAkEBRg0DQciyBUEANgIAQa8BIAFBnLsBQQBBARAcQciyBSgCACECQciyBUEANgIAIAJBAUYNA0HIsgVBADYCAEGvASABQaG7AUEAQQEQHEHIsgUoAgAhAkHIsgVBADYCACACQQFGDQNByLIFQQA2AgBBrwEgAUGmuwFBAEEBEBxByLIFKAIAIQJByLIFQQA2AgAgAkEBRg0DQciyBUEANgIAQa8BIAFBq7sBQQBBARAcQciyBSgCACECQciyBUEANgIAIAJBAUYNA0HIsgVBADYCAEGvASABQbC7AUEAQQEQHEHIsgUoAgAhAkHIsgVBADYCACACQQFGDQNByLIFQQA2AgBBrwEgAUG1uwFBAEEBEBxByLIFKAIAIQJByLIFQQA2AgAgAkEBRg0DQciyBUEANgIAQa8BIAFBursBQQBBARAcQciyBSgCACECQciyBUEANgIAIAJBAUYNA0HIsgVBADYCAEGvASABQb+7AUEAQQEQHEHIsgUoAgAhAkHIsgVBADYCACACQQFGDQNByLIFQQA2AgBBrwEgAUHEuwFBAEEBEBxByLIFKAIAIQJByLIFQQA2AgAgAkEBRg0DQciyBUEANgIAQa8BIAFBybsBQQBBARAcQciyBSgCACECQciyBUEANgIAIAJBAUYNA0HIsgVBADYCAEGvASABQc67AUEAQQEQHEHIsgUoAgAhAkHIsgVBADYCACACQQFGDQNByLIFQQA2AgBBrwEgAUHTuwFBAEEBEBxByLIFKAIAIQJByLIFQQA2AgAgAkEBRg0DQciyBUEANgIAQa8BIAFB2LsBQQBBARAcQciyBSgCACECQciyBUEANgIAIAJBAUYNA0HIsgVBADYCAEGvASABQd27AUEAQQEQHEHIsgUoAgAhAkHIsgVBADYCACACQQFGDQNByLIFQQA2AgBBrwEgAUHiuwFBAEEBEBxByLIFKAIAIQJByLIFQQA2AgAgAkEBRg0DQciyBUEANgIAQa8BIAFB57sBQQBBARAcQciyBSgCACECQciyBUEANgIAIAJBAUYNA0HIsgVBADYCAEGvASABQey7AUEAQQEQHEHIsgUoAgAhAkHIsgVBADYCACACQQFGDQNByLIFQQA2AgBBrwEgAUHxuwFBAEEBEBxByLIFKAIAIQJByLIFQQA2AgAgAkEBRg0DQciyBUEANgIAQa8BIAFB9rsBQQBBARAcQciyBSgCACECQciyBUEANgIAIAJBAUYNA0HIsgVBADYCAEGvASABQfu7AUEAQQEQHEHIsgUoAgAhAkHIsgVBADYCACACQQFGDQNByLIFQQA2AgBBrwEgAUGAvAFBAEEBEBxByLIFKAIAIQJByLIFQQA2AgAgAkEBRg0DQciyBUEANgIAQa8BIAFBhbwBQQBBARAcQciyBSgCACECQciyBUEANgIAIAJBAUYNA0HIsgVBADYCAEGvASABQYq8AUEAQQEQHEHIsgUoAgAhAkHIsgVBADYCACACQQFGDQNByLIFQQA2AgBBrwEgAUGPvAFBAEEBEBxByLIFKAIAIQJByLIFQQA2AgAgAkEBRg0DQciyBUEANgIAQa8BIAFBlLwBQQBBARAcQciyBSgCACECQciyBUEANgIAIAJBAUcNAQwDC0HIsgVBADYCACACEK0FIQNByLIFKAIAIQRByLIFQQA2AgAgBEEBRg0CQciyBUEANgIAQZm8ARCtBSEEQciyBSgCACEFQciyBUEANgIAIAVBAUYNAiADIARGBEBByLIFQQA2AgBB0QEgARAPQciyBSgCACECQciyBUEANgIAIAJBAUYNA0HIsgVBADYCAEEtQSgQDSECQciyBSgCACEDQciyBUEANgIAIANBAUYNA0HIsgVBADYCACACIAFBnrwBQQtBC0EBQQAQzwQaQciyBSgCACEDQciyBUEANgIAIANBAUcEQEHIsgVBADYCAEHbACABIAIQBUHIsgUoAgAhAkHIsgVBADYCACACQQFHDQIMBAsQBiEAEAcaIAIQ9gwMBAtByLIFQQA2AgAgAhCtBSEDQciyBSgCACEEQciyBUEANgIAIARBAUYNAkHIsgVBADYCAEGovAEQrQUhBEHIsgUoAgAhBUHIsgVBADYCACAFQQFGDQIgAyAERgRAQciyBUEANgIAQdEBIAEQD0HIsgUoAgAhAkHIsgVBADYCACACQQFGDQNByLIFQQA2AgBBLUEoEA0hAkHIsgUoAgAhA0HIsgVBADYCACADQQFGDQNByLIFQQA2AgAgAiABQQBBEEERQQFBARDPBBpByLIFKAIAIQNByLIFQQA2AgAgA0EBRwRAQciyBUEANgIAQdsAIAEgAhAFQciyBSgCACECQciyBUEANgIAIAJBAUcNAgwECxAGIQAQBxogAhD2DAwEC0HIsgVBADYCACACEK0FIQNByLIFKAIAIQRByLIFQQA2AgAgBEEBRg0CQciyBUEANgIAQa28ARCtBSEEQciyBSgCACEFQciyBUEANgIAIAVBAUYNAiADIARGBEBByLIFQQA2AgBBLUEcEA0hAkHIsgUoAgAhA0HIsgVBADYCACADQQFGDQNByLIFQQA2AgAgAiABQbK8ARCgBCEDQciyBSgCACEEQciyBUEANgIAAkACQAJAIARBAUcEQCACQQA2AhggAkIANwIQIAJB4M4CNgIAQciyBUEANgIAQfDOAigCACIEIAJBARAFQciyBSgCACEFQciyBUEANgIAAkAgBUEBRwRAQciyBUEANgIAQfsAIAJBEGpBABAVIQVByLIFKAIAIQZByLIFQQA2AgAgBkEBRw0BCxAGIQAQBxogAigCGCEDQciyBUEANgIAIAMQ6AFByLIFKAIAIQNByLIFQQA2AgAgA0EBRw0CQQAQCyEBEAcaIAEQhAEACyAFQQA2AgBByLIFQQA2AgBB2wAgASADEAVByLIFKAIAIQJByLIFQQA2AgAgAkEBRg0HQciyBUEANgIAQS1BHBANIQJByLIFKAIAIQNByLIFQQA2AgAgA0EBRg0HQciyBUEANgIAIAIgAUGwuAEQoAQhA0HIsgUoAgAhBUHIsgVBADYCACAFQQFGDQIgAkEANgIYIAJCADcCECACQeDOAjYCAEHIsgVBADYCACAEIAJBARAFQciyBSgCACEEQciyBUEANgIAAkAgBEEBRwRAQciyBUEANgIAQfsAIAJBEGpBABAVIQRByLIFKAIAIQVByLIFQQA2AgAgBUEBRw0BCxAGIQAQBxogAigCGCEDQciyBUEANgIAIAMQ6AFByLIFKAIAIQNByLIFQQA2AgAgA0EBRw0EQQAQCyEBEAcaIAEQhAEACyAEQQA2AgBByLIFQQA2AgBB2wAgASADEAVByLIFKAIAIQJByLIFQQA2AgAgAkEBRw0FDAcLEAYhABAHGgsgAhD2DAwGCxAGIQAQBxoLIAIQ9gwMBAtByLIFQQA2AgAgAhCtBSEDQciyBSgCACEEQciyBUEANgIAIARBAUYNAkHIsgVBADYCAEG+vAEQrQUhBEHIsgUoAgAhBUHIsgVBADYCACAFQQFGDQIgAyAERgRAQciyBUEANgIAQa8BIAFBw7wBQQFBARAcQciyBSgCACECQciyBUEANgIAIAJBAUYNA0HIsgVBADYCAEGvASABQci8AUEBQQEQHEHIsgUoAgAhAkHIsgVBADYCACACQQFGDQNByLIFQQA2AgBBrwEgAUHNvAFBAUEBEBxByLIFKAIAIQJByLIFQQA2AgAgAkEBRw0BDAMLQciyBUEANgIAIAIQrQUhA0HIsgUoAgAhBEHIsgVBADYCACAEQQFGDQJByLIFQQA2AgBB0rwBEK0FIQRByLIFKAIAIQVByLIFQQA2AgAgBUEBRg0CIAMgBEYEQEHIsgVBADYCAEHRASABEA9ByLIFKAIAIQJByLIFQQA2AgAgAkEBRg0DQciyBUEANgIAQa8BIAFByLwBQQFBARAcQciyBSgCACECQciyBUEANgIAIAJBAUYNA0HIsgVBADYCAEGvASABQZW6AUEBQQEQHEHIsgUoAgAhAkHIsgVBADYCACACQQFHDQEMAwtByLIFQQA2AgAgAhCtBSEDQciyBSgCACEEQciyBUEANgIAIARBAUYNAkHIsgVBADYCAEHXvAEQrQUhBEHIsgUoAgAhBUHIsgVBADYCACAFQQFGDQIgAyAERgRAQciyBUEANgIAQdEBIAEQD0HIsgUoAgAhAkHIsgVBADYCACACQQFGDQNByLIFQQA2AgBBLUEcEA0hAkHIsgUoAgAhA0HIsgVBADYCACADQQFGDQNByLIFQQA2AgAgAiABQdy8ARCgBCEDQciyBSgCACEEQciyBUEANgIAAkAgBEEBRwRAIAJBADYCGCACQgA3AhAgAkHgzgI2AgBByLIFQQA2AgBB8M4CKAIAIAJBARAFQciyBSgCACEEQciyBUEANgIAAkAgBEEBRwRAQciyBUEANgIAQfsAIAJBEGpBABAVIQRByLIFKAIAIQVByLIFQQA2AgAgBUEBRw0BCxAGIQAQBxogAigCGCEDQciyBUEANgIAIAMQ6AFByLIFKAIAIQNByLIFQQA2AgAgA0EBRw0CQQAQCyEBEAcaIAEQhAEACyAEQQA2AgBByLIFQQA2AgBB2wAgASADEAVByLIFKAIAIQJByLIFQQA2AgAgAkEBRw0DDAULEAYhABAHGgsgAhD2DAwEC0HIsgVBADYCACACEK0FIQNByLIFKAIAIQRByLIFQQA2AgAgBEEBRg0CQciyBUEANgIAQc28ARCtBSEEQciyBSgCACEFQciyBUEANgIAIAVBAUYNAiADIARGBEBByLIFQQA2AgBBrwEgAUHrvAFBAEEBEBxByLIFKAIAIQJByLIFQQA2AgAgAkEBRg0DQciyBUEANgIAQa8BIAFB8LwBQQBBARAcQciyBSgCACECQciyBUEANgIAIAJBAUYNA0HIsgVBADYCAEGvASABQYO5AUEAQQEQHEHIsgUoAgAhAkHIsgVBADYCACACQQFGDQNByLIFQQA2AgBBrwEgAUH1vAFBAEEBEBxByLIFKAIAIQJByLIFQQA2AgAgAkEBRg0DQciyBUEANgIAQa8BIAFB77gBQQBBARAcQciyBSgCACECQciyBUEANgIAIAJBAUYNA0HIsgVBADYCAEGvASABQaG4AUEBQQEQHEHIsgUoAgAhAkHIsgVBADYCACACQQFGDQNByLIFQQA2AgBBrwEgAUH6vAFBAUEBEBxByLIFKAIAIQJByLIFQQA2AgAgAkEBRw0BDAMLQciyBUEANgIAIAIQrQUhA0HIsgUoAgAhBEHIsgVBADYCACAEQQFGDQJByLIFQQA2AgBB/7wBEK0FIQRByLIFKAIAIQVByLIFQQA2AgAgBUEBRg0CIAMgBEYEQEHIsgVBADYCAEGvASABQde8AUEBQQEQHEHIsgUoAgAhAkHIsgVBADYCACACQQFGDQNByLIFQQA2AgBBrwEgAUGEvQFBAEEAEBxByLIFKAIAIQJByLIFQQA2AgAgAkEBRw0BDAMLQciyBUEANgIAIAIQrQUhA0HIsgUoAgAhBEHIsgVBADYCACAEQQFGDQJByLIFQQA2AgBBib0BEK0FIQRByLIFKAIAIQVByLIFQQA2AgAgBUEBRg0CIAMgBEYEQEHIsgVBADYCAEGvASABQY69AUEBQQEQHEHIsgUoAgAhAkHIsgVBADYCACACQQFGDQNByLIFQQA2AgBBrwEgAUGovAFBAEEBEBxByLIFKAIAIQJByLIFQQA2AgAgAkEBRg0DQciyBUEANgIAQa8BIAFBk70BQQFBABAcQciyBSgCACECQciyBUEANgIAIAJBAUYNA0HIsgVBADYCAEGvASABQZi9AUEAQQAQHEHIsgUoAgAhAkHIsgVBADYCACACQQFGDQNByLIFQQA2AgBBrwEgAUGdvQFBAEEBEBxByLIFKAIAIQJByLIFQQA2AgAgAkEBRw0BDAMLQciyBUEANgIAIAIQrQUhA0HIsgUoAgAhBEHIsgVBADYCACAEQQFGDQJByLIFQQA2AgBBnb0BEK0FIQRByLIFKAIAIQVByLIFQQA2AgAgBUEBRg0CIAMgBEYEQEHIsgVBADYCAEGvASABQaK9AUEBQQAQHEHIsgUoAgAhAkHIsgVBADYCACACQQFHDQEMAwtByLIFQQA2AgAgAhCtBSEDQciyBSgCACEEQciyBUEANgIAIARBAUYNAkHIsgVBADYCAEH1vAEQrQUhBEHIsgUoAgAhBUHIsgVBADYCACAFQQFGDQIgAyAERgRAQciyBUEANgIAQdEBIAEQD0HIsgUoAgAhAkHIsgVBADYCACACQQFHDQEMAwtByLIFQQA2AgAgAhCtBSEDQciyBSgCACEEQciyBUEANgIAIARBAUYNAkHIsgVBADYCAEGnvQEQrQUhBEHIsgUoAgAhBUHIsgVBADYCACAFQQFGDQIgAyAERgRAQciyBUEANgIAQS1BHBANIQJByLIFKAIAIQNByLIFQQA2AgAgA0EBRg0DQciyBUEANgIAIAIgAUGsvQEQoAQhA0HIsgUoAgAhBEHIsgVBADYCAAJAIARBAUcEQCACQQA2AhggAkIANwIQIAJBwM8CNgIAQciyBUEANgIAQdDPAigCACACQQEQBUHIsgUoAgAhBEHIsgVBADYCAAJAIARBAUcEQEHIsgVBADYCAEHcACACQRBqQQAQFSEEQciyBSgCACEFQciyBUEANgIAIAVBAUcNAQsQBiEAEAcaIAIoAhghA0HIsgVBADYCACADEOgBQciyBSgCACEDQciyBUEANgIAIANBAUcNAkEAEAshARAHGiABEIQBAAsgBEIANwMAQciyBUEANgIAQdsAIAEgAxAFQciyBSgCACECQciyBUEANgIAIAJBAUcNAwwFCxAGIQAQBxoLIAIQ9gwMBAtByLIFQQA2AgAgAhCtBSEDQciyBSgCACEEQciyBUEANgIAIARBAUYNAkHIsgVBADYCAEG0vQEQrQUhBEHIsgUoAgAhBUHIsgVBADYCACAFQQFGDQIgAyAERgRAQciyBUEANgIAQdEBIAEQD0HIsgUoAgAhAkHIsgVBADYCACACQQFGDQNByLIFQQA2AgBBrwEgAUG5vQFBAUEBEBxByLIFKAIAIQJByLIFQQA2AgAgAkEBRw0BDAMLQciyBUEANgIAIAIQrQUhA0HIsgUoAgAhBEHIsgVBADYCACAEQQFGDQJByLIFQQA2AgBBvr0BEK0FIQRByLIFKAIAIQVByLIFQQA2AgAgBUEBRg0CIAMgBEYEQEHIsgVBADYCAEEtQRwQDSECQciyBSgCACEDQciyBUEANgIAIANBAUYNA0HIsgVBADYCACACIAFBw70BEKAEIQNByLIFKAIAIQRByLIFQQA2AgACQAJAIARBAUcEQCACQQA2AhggAkIANwIQIAJB4M4CNgIAQciyBUEANgIAQfDOAigCACACQQEQBUHIsgUoAgAhBEHIsgVBADYCAAJAIARBAUcEQEHIsgVBADYCAEH7ACACQRBqQQAQFSEEQciyBSgCACEFQciyBUEANgIAIAVBAUcNAQsQBiEAEAcaIAIoAhghA0HIsgVBADYCACADEOgBQciyBSgCACEDQciyBUEANgIAIANBAUcNAkEAEAshARAHGiABEIQBAAsgBEEANgIAQciyBUEANgIAQdsAIAEgAxAFQciyBSgCACECQciyBUEANgIAIAJBAUYNBkHIsgVBADYCAEEtQSQQDSECQciyBSgCACEDQciyBUEANgIAIANBAUYNBkHIsgVBADYCAEH9ACACIAFB0b0BQQFBAEEAEBYaQciyBSgCACEDQciyBUEANgIAIANBAUYNAkHIsgVBADYCAEHbACABIAIQBUHIsgUoAgAhAkHIsgVBADYCACACQQFHDQQMBgsQBiEAEAcaCyACEPYMDAULEAYhABAHGiACEPYMDAQLQciyBUEANgIAIAIQrQUhA0HIsgUoAgAhBEHIsgVBADYCACAEQQFGDQJByLIFQQA2AgBB2L0BEK0FIQRByLIFKAIAIQVByLIFQQA2AgAgBUEBRg0CIAMgBEYEQEHIsgVBADYCAEGvASABQd64AUEBQQEQHEHIsgUoAgAhAkHIsgVBADYCACACQQFHDQEMAwtByLIFQQA2AgAgAhCtBSEDQciyBSgCACEEQciyBUEANgIAIARBAUYNAkHIsgVBADYCAEHdvQEQrQUhBEHIsgUoAgAhBUHIsgVBADYCACAFQQFGDQIgAyAERgRAQciyBUEANgIAQS1BHBANIQJByLIFKAIAIQNByLIFQQA2AgAgA0EBRg0DQciyBUEANgIAIAIgAUGwuAEQoAQhA0HIsgUoAgAhBEHIsgVBADYCAAJAIARBAUcEQCACQQA2AhggAkIANwIQIAJB4M4CNgIAQciyBUEANgIAQfDOAigCACACQQEQBUHIsgUoAgAhBEHIsgVBADYCAAJAIARBAUcEQEHIsgVBADYCAEH7ACACQRBqQQAQFSEEQciyBSgCACEFQciyBUEANgIAIAVBAUcNAQsQBiEAEAcaIAIoAhghA0HIsgVBADYCACADEOgBQciyBSgCACEDQciyBUEANgIAIANBAUcNAkEAEAshARAHGiABEIQBAAsgBEEANgIAQciyBUEANgIAQdsAIAEgAxAFQciyBSgCACECQciyBUEANgIAIAJBAUcNAwwFCxAGIQAQBxoLIAIQ9gwMBAtByLIFQQA2AgAgAhCtBSEDQciyBSgCACEEQciyBUEANgIAIARBAUYNAkHIsgVBADYCAEHivQEQrQUhBEHIsgUoAgAhBUHIsgVBADYCACAFQQFGDQIgAyAERgRAQciyBUEANgIAQa8BIAFBtL0BQQBBARAcQciyBSgCACECQciyBUEANgIAIAJBAUYNA0HIsgVBADYCAEGvASABQca5AUEAQQEQHEHIsgUoAgAhAkHIsgVBADYCACACQQFGDQNByLIFQQA2AgBBrwEgAUHTuQFBAEEBEBxByLIFKAIAIQJByLIFQQA2AgAgAkEBRw0BDAMLQciyBUEANgIAIAIQrQUhA0HIsgUoAgAhBEHIsgVBADYCACAEQQFGDQJByLIFQQA2AgBB570BEK0FIQRByLIFKAIAIQVByLIFQQA2AgAgBUEBRg0CIAMgBEYEQEHIsgVBADYCAEHRASABEA9ByLIFKAIAIQJByLIFQQA2AgAgAkEBRg0DQciyBUEANgIAQS1BHBANIQJByLIFKAIAIQNByLIFQQA2AgAgA0EBRg0DQciyBUEANgIAIAIgAUHsvQEQoAQhA0HIsgUoAgAhBEHIsgVBADYCAAJAAkACQCAEQQFHBEAgAkEANgIYIAJCADcCECACQeDOAjYCAEHIsgVBADYCAEHwzgIoAgAiBCACQQEQBUHIsgUoAgAhBUHIsgVBADYCAAJAIAVBAUcEQEHIsgVBADYCAEH7ACACQRBqQQAQFSEFQciyBSgCACEGQciyBUEANgIAIAZBAUcNAQsQBiEAEAcaIAIoAhghA0HIsgVBADYCACADEOgBQciyBSgCACEDQciyBUEANgIAIANBAUcNAkEAEAshARAHGiABEIQBAAsgBUEANgIAQciyBUEANgIAQdsAIAEgAxAFQciyBSgCACECQciyBUEANgIAIAJBAUYNB0HIsgVBADYCAEEtQRwQDSECQciyBSgCACEDQciyBUEANgIAIANBAUYNB0HIsgVBADYCACACIAFB+L0BEKAEIQNByLIFKAIAIQVByLIFQQA2AgAgBUEBRg0CIAJBADYCGCACQgA3AhAgAkHgzgI2AgBByLIFQQA2AgAgBCACQQEQBUHIsgUoAgAhBEHIsgVBADYCAAJAIARBAUcEQEHIsgVBADYCAEH7ACACQRBqQQAQFSEEQciyBSgCACEFQciyBUEANgIAIAVBAUcNAQsQBiEAEAcaIAIoAhghA0HIsgVBADYCACADEOgBQciyBSgCACEDQciyBUEANgIAIANBAUcNBEEAEAshARAHGiABEIQBAAsgBEEANgIAQciyBUEANgIAQdsAIAEgAxAFQciyBSgCACECQciyBUEANgIAIAJBAUcNBQwHCxAGIQAQBxoLIAIQ9gwMBgsQBiEAEAcaCyACEPYMDAQLQciyBUEANgIAIAIQrQUhA0HIsgUoAgAhBEHIsgVBADYCACAEQQFGDQJByLIFQQA2AgBBh74BEK0FIQRByLIFKAIAIQVByLIFQQA2AgAgBUEBRg0CIAMgBEYEQEHIsgVBADYCAEGvASABQd64AUEBQQEQHEHIsgUoAgAhAkHIsgVBADYCACACQQFGDQNByLIFQQA2AgBBrwEgAUGZvAFBAEEBEBxByLIFKAIAIQJByLIFQQA2AgAgAkEBRg0DQciyBUEANgIAQa8BIAFB570BQQBBARAcQciyBSgCACECQciyBUEANgIAIAJBAUYNA0HIsgVBADYCAEGvASABQeK9AUEAQQEQHEHIsgUoAgAhAkHIsgVBADYCACACQQFHDQEMAwtByLIFQQA2AgAgAhCtBSEDQciyBSgCACEEQciyBUEANgIAIARBAUYNAkHIsgVBADYCAEHwvAEQrQUhBEHIsgUoAgAhBUHIsgVBADYCACAFQQFGDQIgAyAERgRAQciyBUEANgIAQdEBIAEQD0HIsgUoAgAhAkHIsgVBADYCACACQQFGDQNByLIFQQA2AgBBxwEgASABQe25AUEEEBxByLIFKAIAIQJByLIFQQA2AgAgAkEBRw0BDAMLQciyBUEANgIAIAIQrQUhA0HIsgUoAgAhBEHIsgVBADYCACAEQQFGDQJByLIFQQA2AgBBjL4BEK0FIQRByLIFKAIAIQVByLIFQQA2AgAgBUEBRg0CIAMgBEYEQEHIsgVBADYCAEEtQRwQDSECQciyBSgCACEDQciyBUEANgIAIANBAUYNA0HIsgVBADYCACACIAFBkb4BEKAEIQNByLIFKAIAIQRByLIFQQA2AgACQCAEQQFHBEAgAkEANgIYIAJCADcCECACQeDOAjYCAEHIsgVBADYCAEHwzgIoAgAgAkEBEAVByLIFKAIAIQRByLIFQQA2AgACQCAEQQFHBEBByLIFQQA2AgBB+wAgAkEQakEAEBUhBEHIsgUoAgAhBUHIsgVBADYCACAFQQFHDQELEAYhABAHGiACKAIYIQNByLIFQQA2AgAgAxDoAUHIsgUoAgAhA0HIsgVBADYCACADQQFHDQJBABALIQEQBxogARCEAQALIARBADYCAEHIsgVBADYCAEHbACABIAMQBUHIsgUoAgAhAkHIsgVBADYCACACQQFHDQMMBQsQBiEAEAcaCyACEPYMDAQLQciyBUEANgIAIAIQrQUhBEHIsgUoAgAhA0HIsgVBADYCACADQQFGDQJByLIFQQA2AgBBmL4BEK0FIQNByLIFKAIAIQVByLIFQQA2AgAgBUEBRg0CIAMgBEYEQEHIsgVBADYCAEHRASABEA9ByLIFKAIAIQJByLIFQQA2AgAgAkEBRg0DQciyBUEANgIAQS1BHBANIQJByLIFKAIAIQNByLIFQQA2AgACQAJAAkACQAJAAkACQAJAIANBAUYNAEHIsgVBADYCACACIAFB5LcBEKAEIQRByLIFKAIAIQNByLIFQQA2AgAgA0EBRg0BIAJBADYCGCACQgA3AhAgAkHgzgI2AgBByLIFQQA2AgBB8M4CKAIAIgYgAkEBEAVByLIFKAIAIQNByLIFQQA2AgACQCADQQFHBEBByLIFQQA2AgBB+wAgAkEQakEAEBUhBUHIsgUoAgAhA0HIsgVBADYCACADQQFHDQELEAYhABAHGiACKAIYIQNByLIFQQA2AgAgAxDoAUHIsgUoAgAhA0HIsgVBADYCACADQQFHDQNBABALIQEQBxogARCEAQALIAVBADYCAEHIsgVBADYCAEHbACABIAQQBUHIsgUoAgAhA0HIsgVBADYCACADQQFGDQBByLIFQQA2AgBBLUEgEA0hA0HIsgUoAgAhBEHIsgVBADYCACAEQQFGDQRByLIFQQA2AgAgAyABQe+3ASACEMUEIQVByLIFKAIAIQJByLIFQQA2AgAgAkEBRg0FQciyBUEANgIAQdsAIAEgAxAFQciyBSgCACECQciyBUEANgIAIAJBAUYNBEHIsgVBADYCAEEtQRwQDSECQciyBSgCACEEQciyBUEANgIAIARBAUYNBCADKAIEIQNByLIFQQA2AgAgAiADQfe3ARCgBCEEQciyBSgCACEDQciyBUEANgIAIANBAUYNBiACQQA2AhggAkIANwIQIAJB4M4CNgIAQciyBUEANgIAIAYgAkEBEAVByLIFKAIAIQNByLIFQQA2AgAgA0EBRwRAQciyBUEANgIAQfsAIAJBEGpBABAVIQZByLIFKAIAIQNByLIFQQA2AgAgA0EBRw0ECxAGIQAQBxogAigCGCEDQciyBUEANgIAIAMQ6AFByLIFKAIAIQNByLIFQQA2AgAgA0EBRw0HQQAQCyEBEAcaIAEQhAEACxAGIQAQBxoMCwsQBiEAEAcaCyACEPYMDAkLIAZBADYCAEHIsgVBADYCAEHfACAFIAQQBUHIsgUoAgAhAkHIsgVBADYCACACQQFHDQULEAYhABAHGgwHCxAGIQAQBxogAxD2DAwGCxAGIQAQBxoLIAIQ9gwMBAtByLIFQQA2AgAgAhCtBSEEQciyBSgCACEDQciyBUEANgIAIANBAUYNAkHIsgVBADYCAEGdvgEQrQUhBUHIsgUoAgAhA0HIsgVBADYCACADQQFGDQIgBCAFRgRAQciyBUEANgIAQdEBIAEQD0HIsgUoAgAhAkHIsgVBADYCACACQQFGDQNByLIFQQA2AgBBLUEcEA0hAkHIsgUoAgAhA0HIsgVBADYCAAJAAkACQAJAAkACQAJAAkACQAJAIANBAUYNAEHIsgVBADYCACACIAFB5LcBEKAEIQVByLIFKAIAIQNByLIFQQA2AgAgA0EBRg0BIAJBADYCGCACQgA3AhAgAkHgzgI2AgBByLIFQQA2AgBB8M4CKAIAIgQgAkEBEAVByLIFKAIAIQNByLIFQQA2AgACQCADQQFHBEBByLIFQQA2AgBB+wAgAkEQakEAEBUhBkHIsgUoAgAhA0HIsgVBADYCACADQQFHDQELEAYhABAHGiACKAIYIQNByLIFQQA2AgAgAxDoAUHIsgUoAgAhA0HIsgVBADYCACADQQFHDQNBABALIQEQBxogARCEAQALIAZBADYCAEHIsgVBADYCAEHbACABIAUQBUHIsgUoAgAhA0HIsgVBADYCACADQQFGDQBByLIFQQA2AgBBLUEgEA0hA0HIsgUoAgAhBUHIsgVBADYCACAFQQFGDQRByLIFQQA2AgAgAyABQe+3ASACEMUEIQVByLIFKAIAIQJByLIFQQA2AgAgAkEBRg0FQciyBUEANgIAQdsAIAEgAxAFQciyBSgCACECQciyBUEANgIAIAJBAUYNBEHIsgVBADYCAEEtQRwQDSECQciyBSgCACEGQciyBUEANgIAIAZBAUYNBCADKAIEIQZByLIFQQA2AgAgAiAGQaK+ARCgBCEHQciyBSgCACEGQciyBUEANgIAIAZBAUYNBiACQQA2AhggAkIANwIQIAJB4M4CNgIAQciyBUEANgIAIAQgAkEBEAVByLIFKAIAIQZByLIFQQA2AgACQCAGQQFHBEBByLIFQQA2AgBB+wAgAkEQakEAEBUhCEHIsgUoAgAhBkHIsgVBADYCACAGQQFHDQELEAYhABAHGiACKAIYIQNByLIFQQA2AgAgAxDoAUHIsgUoAgAhA0HIsgVBADYCACADQQFHDQhBABALIQEQBxogARCEAQALIAhBADYCAEHIsgVBADYCAEHfACAFIAcQBUHIsgUoAgAhAkHIsgVBADYCACACQQFGDQRByLIFQQA2AgBBLUEcEA0hAkHIsgUoAgAhBkHIsgVBADYCACAGQQFGDQQgAygCBCEDQciyBUEANgIAIAIgA0G3vgEQoAQhBkHIsgUoAgAhA0HIsgVBADYCACADQQFGDQggAkEANgIYIAJCADcCECACQeDOAjYCAEHIsgVBADYCACAEIAJBARAFQciyBSgCACEDQciyBUEANgIAIANBAUcEQEHIsgVBADYCAEH7ACACQRBqQQAQFSEEQciyBSgCACEDQciyBUEANgIAIANBAUcNBAsQBiEAEAcaIAIoAhghA0HIsgVBADYCACADEOgBQciyBSgCACEDQciyBUEANgIAIANBAUcNCUEAEAshARAHGiABEIQBAAsQBiEAEAcaDA0LEAYhABAHGgsgAhD2DAwLCyAEQQA2AgBByLIFQQA2AgBB3wAgBSAGEAVByLIFKAIAIQJByLIFQQA2AgAgAkEBRw0HCxAGIQAQBxoMCQsQBiEAEAcaIAMQ9gwMCAsQBiEAEAcaCyACEPYMDAYLEAYhABAHGgsgAhD2DAwEC0HIsgVBADYCACACEK0FIQRByLIFKAIAIQNByLIFQQA2AgAgA0EBRg0CQciyBUEANgIAQci+ARCtBSEFQciyBSgCACEDQciyBUEANgIAIANBAUYNAiAEIAVGBEBByLIFQQA2AgBB0QEgARAPQciyBSgCACECQciyBUEANgIAIAJBAUYNA0HIsgVBADYCAEEtQRwQDSECQciyBSgCACEDQciyBUEANgIAAkACQAJAAkACQAJAAkACQCADQQFGDQBByLIFQQA2AgAgAiABQeS3ARCgBCEEQciyBSgCACEDQciyBUEANgIAIANBAUYNASACQQA2AhggAkIANwIQIAJB4M4CNgIAQciyBUEANgIAQfDOAigCACIGIAJBARAFQciyBSgCACEDQciyBUEANgIAAkAgA0EBRwRAQciyBUEANgIAQfsAIAJBEGpBABAVIQVByLIFKAIAIQNByLIFQQA2AgAgA0EBRw0BCxAGIQAQBxogAigCGCEDQciyBUEANgIAIAMQ6AFByLIFKAIAIQNByLIFQQA2AgAgA0EBRw0DQQAQCyEBEAcaIAEQhAEACyAFQQA2AgBByLIFQQA2AgBB2wAgASAEEAVByLIFKAIAIQNByLIFQQA2AgAgA0EBRg0AQciyBUEANgIAQS1BIBANIQNByLIFKAIAIQRByLIFQQA2AgAgBEEBRg0EQciyBUEANgIAIAMgAUHvtwEgAhDFBCEFQciyBSgCACECQciyBUEANgIAIAJBAUYNBUHIsgVBADYCAEHbACABIAMQBUHIsgUoAgAhAkHIsgVBADYCACACQQFGDQRByLIFQQA2AgBBLUEcEA0hAkHIsgUoAgAhBEHIsgVBADYCACAEQQFGDQQgAygCBCEDQciyBUEANgIAIAIgA0HNvgEQoAQhBEHIsgUoAgAhA0HIsgVBADYCACADQQFGDQYgAkEANgIYIAJCADcCECACQeDOAjYCAEHIsgVBADYCACAGIAJBARAFQciyBSgCACEDQciyBUEANgIAIANBAUcEQEHIsgVBADYCAEH7ACACQRBqQQAQFSEGQciyBSgCACEDQciyBUEANgIAIANBAUcNBAsQBiEAEAcaIAIoAhghA0HIsgVBADYCACADEOgBQciyBSgCACEDQciyBUEANgIAIANBAUcNB0EAEAshARAHGiABEIQBAAsQBiEAEAcaDAsLEAYhABAHGgsgAhD2DAwJCyAGQQA2AgBByLIFQQA2AgBB3wAgBSAEEAVByLIFKAIAIQJByLIFQQA2AgAgAkEBRw0FCxAGIQAQBxoMBwsQBiEAEAcaIAMQ9gwMBgsQBiEAEAcaCyACEPYMDAQLQciyBUEANgIAIAIQrQUhBEHIsgUoAgAhA0HIsgVBADYCACADQQFGDQJByLIFQQA2AgBB2r4BEK0FIQVByLIFKAIAIQNByLIFQQA2AgAgA0EBRg0CIAQgBUYEQEHIsgVBADYCAEHRASABEA9ByLIFKAIAIQJByLIFQQA2AgAgAkEBRg0DQciyBUEANgIAQS1BHBANIQJByLIFKAIAIQNByLIFQQA2AgACQAJAAkACQAJAAkACQAJAAkACQCADQQFGDQBByLIFQQA2AgAgAiABQeS3ARCgBCEFQciyBSgCACEDQciyBUEANgIAIANBAUYNASACQQA2AhggAkIANwIQIAJB4M4CNgIAQciyBUEANgIAQfDOAigCACIEIAJBARAFQciyBSgCACEDQciyBUEANgIAAkAgA0EBRwRAQciyBUEANgIAQfsAIAJBEGpBABAVIQZByLIFKAIAIQNByLIFQQA2AgAgA0EBRw0BCxAGIQAQBxogAigCGCEDQciyBUEANgIAIAMQ6AFByLIFKAIAIQNByLIFQQA2AgAgA0EBRw0DQQAQCyEBEAcaIAEQhAEACyAGQQA2AgBByLIFQQA2AgBB2wAgASAFEAVByLIFKAIAIQNByLIFQQA2AgAgA0EBRg0AQciyBUEANgIAQS1BIBANIQNByLIFKAIAIQVByLIFQQA2AgAgBUEBRg0EQciyBUEANgIAIAMgAUHvtwEgAhDFBCEFQciyBSgCACECQciyBUEANgIAIAJBAUYNBUHIsgVBADYCAEHbACABIAMQBUHIsgUoAgAhAkHIsgVBADYCACACQQFGDQRByLIFQQA2AgBBLUEcEA0hAkHIsgUoAgAhBkHIsgVBADYCACAGQQFGDQQgAygCBCEGQciyBUEANgIAIAIgBkGIuAEQoAQhB0HIsgUoAgAhBkHIsgVBADYCACAGQQFGDQYgAkEANgIYIAJCADcCECACQeDOAjYCAEHIsgVBADYCACAEIAJBARAFQciyBSgCACEGQciyBUEANgIAAkAgBkEBRwRAQciyBUEANgIAQfsAIAJBEGpBABAVIQhByLIFKAIAIQZByLIFQQA2AgAgBkEBRw0BCxAGIQAQBxogAigCGCEDQciyBUEANgIAIAMQ6AFByLIFKAIAIQNByLIFQQA2AgAgA0EBRw0IQQAQCyEBEAcaIAEQhAEACyAIQQA2AgBByLIFQQA2AgBB3wAgBSAHEAVByLIFKAIAIQJByLIFQQA2AgAgAkEBRg0EQciyBUEANgIAQS1BHBANIQJByLIFKAIAIQZByLIFQQA2AgAgBkEBRg0EIAMoAgQhA0HIsgVBADYCACACIANB374BEKAEIQZByLIFKAIAIQNByLIFQQA2AgAgA0EBRg0IIAJBADYCGCACQgA3AhAgAkHgzgI2AgBByLIFQQA2AgAgBCACQQEQBUHIsgUoAgAhA0HIsgVBADYCACADQQFHBEBByLIFQQA2AgBB+wAgAkEQakEAEBUhBEHIsgUoAgAhA0HIsgVBADYCACADQQFHDQQLEAYhABAHGiACKAIYIQNByLIFQQA2AgAgAxDoAUHIsgUoAgAhA0HIsgVBADYCACADQQFHDQlBABALIQEQBxogARCEAQALEAYhABAHGgwNCxAGIQAQBxoLIAIQ9gwMCwsgBEEANgIAQciyBUEANgIAQd8AIAUgBhAFQciyBSgCACECQciyBUEANgIAIAJBAUcNBwsQBiEAEAcaDAkLEAYhABAHGiADEPYMDAgLEAYhABAHGgsgAhD2DAwGCxAGIQAQBxoLIAIQ9gwMBAtByLIFQQA2AgAgAhCtBSEEQciyBSgCACEDQciyBUEANgIAIANBAUYNAkHIsgVBADYCAEHrvgEQrQUhBUHIsgUoAgAhA0HIsgVBADYCACADQQFGDQIgBCAFRgRAQciyBUEANgIAQS1BHBANIQJByLIFKAIAIQNByLIFQQA2AgAgA0EBRg0DQciyBUEANgIAIAIgAUHwvgEQoAQhBEHIsgUoAgAhA0HIsgVBADYCAAJAIANBAUcEQCACQQA2AhggAkIANwIQIAJB4M4CNgIAQciyBUEANgIAQfDOAigCACACQQEQBUHIsgUoAgAhA0HIsgVBADYCAAJAIANBAUcEQEHIsgVBADYCAEH7ACACQRBqQQAQFSEFQciyBSgCACEDQciyBUEANgIAIANBAUcNAQsQBiEAEAcaIAIoAhghA0HIsgVBADYCACADEOgBQciyBSgCACEDQciyBUEANgIAIANBAUcNAkEAEAshARAHGiABEIQBAAsgBUEANgIAQciyBUEANgIAQdsAIAEgBBAFQciyBSgCACECQciyBUEANgIAIAJBAUcNAwwFCxAGIQAQBxoLIAIQ9gwMBAtByLIFQQA2AgAgAhCtBSEEQciyBSgCACEDQciyBUEANgIAIANBAUYNAkHIsgVBADYCAEH6vgEQrQUhBUHIsgUoAgAhA0HIsgVBADYCACADQQFGDQIgBCAFRgRAQciyBUEANgIAQS1BHBANIQJByLIFKAIAIQNByLIFQQA2AgAgA0EBRg0DQciyBUEANgIAIAIgAUG7uAEQoAQhBEHIsgUoAgAhA0HIsgVBADYCAAJAIANBAUcEQCACQQA2AhggAkIANwIQIAJB4M4CNgIAQciyBUEANgIAQfDOAigCACACQQEQBUHIsgUoAgAhA0HIsgVBADYCAAJAIANBAUcEQEHIsgVBADYCAEH7ACACQRBqQQAQFSEFQciyBSgCACEDQciyBUEANgIAIANBAUcNAQsQBiEAEAcaIAIoAhghA0HIsgVBADYCACADEOgBQciyBSgCACEDQciyBUEANgIAIANBAUcNAkEAEAshARAHGiABEIQBAAsgBUEANgIAQciyBUEANgIAQdsAIAEgBBAFQciyBSgCACECQciyBUEANgIAIAJBAUcNAwwFCxAGIQAQBxoLIAIQ9gwMBAtByLIFQQA2AgAgAhCtBSEEQciyBSgCACEDQciyBUEANgIAIANBAUYNAkHIsgVBADYCAEH/vgEQrQUhBUHIsgUoAgAhA0HIsgVBADYCACADQQFGDQIgBCAFRgRAQciyBUEANgIAQS1BHBANIQJByLIFKAIAIQNByLIFQQA2AgAgA0EBRg0DQciyBUEANgIAIAIgAUG7uAEQoAQhBEHIsgUoAgAhA0HIsgVBADYCAAJAIANBAUcEQCACQQA2AhggAkIANwIQIAJB4M4CNgIAQciyBUEANgIAQfDOAigCACACQQEQBUHIsgUoAgAhA0HIsgVBADYCAAJAIANBAUcEQEHIsgVBADYCAEH7ACACQRBqQQAQFSEFQciyBSgCACEDQciyBUEANgIAIANBAUcNAQsQBiEAEAcaIAIoAhghA0HIsgVBADYCACADEOgBQciyBSgCACEDQciyBUEANgIAIANBAUcNAkEAEAshARAHGiABEIQBAAsgBUEANgIAQciyBUEANgIAQdsAIAEgBBAFQciyBSgCACECQciyBUEANgIAIAJBAUcNAwwFCxAGIQAQBxoLIAIQ9gwMBAtByLIFQQA2AgAgAhCtBSEEQciyBSgCACEDQciyBUEANgIAIANBAUYNAkHIsgVBADYCAEGEvQEQrQUhBUHIsgUoAgAhA0HIsgVBADYCACADQQFGDQIgBCAFRgRAQciyBUEANgIAQa8BIAFBhL8BQQFBARAcQciyBSgCACECQciyBUEANgIAIAJBAUYNA0HIsgVBADYCAEGvASABQYm/AUEAQQAQHEHIsgUoAgAhAkHIsgVBADYCACACQQFHDQEMAwtByLIFQQA2AgAgAhCtBSEEQciyBSgCACEDQciyBUEANgIAIANBAUYNAkHIsgVBADYCAEGTvQEQrQUhBUHIsgUoAgAhA0HIsgVBADYCACADQQFGDQIgBCAFRgRAQciyBUEANgIAQa8BIAFBjr8BQQFBARAcQciyBSgCACECQciyBUEANgIAIAJBAUYNA0HIsgVBADYCAEGvASABQZO/AUEAQQEQHEHIsgUoAgAhAkHIsgVBADYCACACQQFGDQNByLIFQQA2AgBBrwEgAUHPuAFBAEEBEBxByLIFKAIAIQJByLIFQQA2AgAgAkEBRg0DQciyBUEANgIAQa8BIAFBvrwBQQFBARAcQciyBSgCACECQciyBUEANgIAIAJBAUYNA0HIsgVBADYCAEGvASABQZi9AUEAQQAQHEHIsgUoAgAhAkHIsgVBADYCACACQQFHDQEMAwtByLIFQQA2AgAgAhCtBSEEQciyBSgCACEDQciyBUEANgIAIANBAUYNAkHIsgVBADYCAEGTvwEQrQUhBUHIsgUoAgAhA0HIsgVBADYCACADQQFGDQIgBCAFRgRAQciyBUEANgIAQa8BIAFBmL8BQQBBARAcQciyBSgCACECQciyBUEANgIAIAJBAUYNA0HIsgVBADYCAEGvASABQZ2/AUEAQQEQHEHIsgUoAgAhAkHIsgVBADYCACACQQFGDQNByLIFQQA2AgBBrwEgAUGivwFBAEEBEBxByLIFKAIAIQJByLIFQQA2AgAgAkEBRg0DQciyBUEANgIAQa8BIAFBp78BQQBBARAcQciyBSgCACECQciyBUEANgIAIAJBAUYNA0HIsgVBADYCAEGvASABQay/AUEAQQEQHEHIsgUoAgAhAkHIsgVBADYCACACQQFGDQNByLIFQQA2AgBBrwEgAUGxvwFBAEEBEBxByLIFKAIAIQJByLIFQQA2AgAgAkEBRw0BDAMLQciyBUEANgIAIAIQrQUhBEHIsgUoAgAhA0HIsgVBADYCACADQQFGDQJByLIFQQA2AgBBor0BEK0FIQVByLIFKAIAIQNByLIFQQA2AgAgA0EBRg0CIAQgBUYEQEHIsgVBADYCAEHRASABEA9ByLIFKAIAIQJByLIFQQA2AgAgAkEBRg0DQciyBUEANgIAQS1BHBANIQJByLIFKAIAIQNByLIFQQA2AgAgA0EBRg0DQciyBUEANgIAIAIgAUG2vwEQoAQhBUHIsgUoAgAhA0HIsgVBADYCAAJAAkACQAJAAkACQAJAAkACQCADQQFHBEAgAkEANgIYIAJCADcCECACQeDOAjYCAEHIsgVBADYCAEHwzgIoAgAiAyACQQEQBUHIsgUoAgAhBEHIsgVBADYCAAJAIARBAUcEQEHIsgVBADYCAEH7ACACQRBqQQAQFSEGQciyBSgCACEEQciyBUEANgIAIARBAUcNAQsQBiEAEAcaIAIoAhghA0HIsgVBADYCACADEOgBQciyBSgCACEDQciyBUEANgIAIANBAUcNAkEAEAshARAHGiABEIQBAAsgBkEANgIAQciyBUEANgIAQdsAIAEgBRAFQciyBSgCACECQciyBUEANgIAIAJBAUYNDUHIsgVBADYCAEEtQRwQDSECQciyBSgCACEEQciyBUEANgIAIARBAUYNDUHIsgVBADYCACACIAFBvr8BEKAEIQVByLIFKAIAIQRByLIFQQA2AgAgBEEBRg0CIAJBADYCGCACQgA3AhAgAkHgzgI2AgBByLIFQQA2AgAgAyACQQEQBUHIsgUoAgAhBEHIsgVBADYCAAJAIARBAUcEQEHIsgVBADYCAEH7ACACQRBqQQAQFSEGQciyBSgCACEEQciyBUEANgIAIARBAUcNAQsQBiEAEAcaIAIoAhghA0HIsgVBADYCACADEOgBQciyBSgCACEDQciyBUEANgIAIANBAUcNBEEAEAshARAHGiABEIQBAAsgBkEANgIAQciyBUEANgIAQdsAIAEgBRAFQciyBSgCACECQciyBUEANgIAIAJBAUYNDUHIsgVBADYCAEEtQRwQDSECQciyBSgCACEEQciyBUEANgIAIARBAUYNDUHIsgVBADYCACACIAFB278BEKAEIQVByLIFKAIAIQRByLIFQQA2AgAgBEEBRg0EIAJBADYCGCACQgA3AhAgAkHgzgI2AgBByLIFQQA2AgAgAyACQQEQBUHIsgUoAgAhBEHIsgVBADYCAAJAIARBAUcEQEHIsgVBADYCAEH7ACACQRBqQQAQFSEGQciyBSgCACEEQciyBUEANgIAIARBAUcNAQsQBiEAEAcaIAIoAhghA0HIsgVBADYCACADEOgBQciyBSgCACEDQciyBUEANgIAIANBAUcNBkEAEAshARAHGiABEIQBAAsgBkEANgIAQciyBUEANgIAQdsAIAEgBRAFQciyBSgCACECQciyBUEANgIAIAJBAUYNDUHIsgVBADYCAEEtQRwQDSECQciyBSgCACEEQciyBUEANgIAIARBAUYNDUHIsgVBADYCACACIAFB8b8BEKAEIQVByLIFKAIAIQRByLIFQQA2AgAgBEEBRg0GIAJBADYCGCACQgA3AhAgAkHgzgI2AgBByLIFQQA2AgAgAyACQQEQBUHIsgUoAgAhBEHIsgVBADYCAAJAIARBAUcEQEHIsgVBADYCAEH7ACACQRBqQQAQFSEGQciyBSgCACEEQciyBUEANgIAIARBAUcNAQsQBiEAEAcaIAIoAhghA0HIsgVBADYCACADEOgBQciyBSgCACEDQciyBUEANgIAIANBAUcNCEEAEAshARAHGiABEIQBAAsgBkEANgIAQciyBUEANgIAQdsAIAEgBRAFQciyBSgCACECQciyBUEANgIAIAJBAUYNDUHIsgVBADYCAEEtQRwQDSECQciyBSgCACEEQciyBUEANgIAIARBAUYNDUHIsgVBADYCACACIAFBg8ABEKAEIQVByLIFKAIAIQRByLIFQQA2AgAgBEEBRg0IIAJBADYCGCACQgA3AhAgAkHgzgI2AgBByLIFQQA2AgAgAyACQQEQBUHIsgUoAgAhA0HIsgVBADYCAAJAIANBAUcEQEHIsgVBADYCAEH7ACACQRBqQQAQFSEEQciyBSgCACEDQciyBUEANgIAIANBAUcNAQsQBiEAEAcaIAIoAhghA0HIsgVBADYCACADEOgBQciyBSgCACEDQciyBUEANgIAIANBAUcNCkEAEAshARAHGiABEIQBAAsgBEEANgIAQciyBUEANgIAQdsAIAEgBRAFQciyBSgCACECQciyBUEANgIAIAJBAUcNCwwNCxAGIQAQBxoLIAIQ9gwMDAsQBiEAEAcaCyACEPYMDAoLEAYhABAHGgsgAhD2DAwICxAGIQAQBxoLIAIQ9gwMBgsQBiEAEAcaCyACEPYMDAQLQciyBUEANgIAIAIQrQUhBEHIsgUoAgAhA0HIsgVBADYCACADQQFGDQJByLIFQQA2AgBBlsABEK0FIQVByLIFKAIAIQNByLIFQQA2AgAgA0EBRg0CAkAgBCAFRwRAQciyBUEANgIAIAIQrQUhBEHIsgUoAgAhA0HIsgVBADYCACADQQFGDQRByLIFQQA2AgBBm8ABEK0FIQVByLIFKAIAIQNByLIFQQA2AgAgA0EBRg0EIAQgBUcNAQtByLIFQQA2AgBBLUEcEA0hAkHIsgUoAgAhA0HIsgVBADYCACADQQFGDQNByLIFQQA2AgAgAiABQbC4ARCgBCEEQciyBSgCACEDQciyBUEANgIAAkAgA0EBRwRAIAJBADYCGCACQgA3AhAgAkHAzwI2AgBByLIFQQA2AgBB0M8CKAIAIAJBARAFQciyBSgCACEDQciyBUEANgIAAkAgA0EBRwRAQciyBUEANgIAQdwAIAJBEGpBABAVIQVByLIFKAIAIQNByLIFQQA2AgAgA0EBRw0BCxAGIQAQBxogAigCGCEDQciyBUEANgIAIAMQ6AFByLIFKAIAIQNByLIFQQA2AgAgA0EBRw0CQQAQCyEBEAcaIAEQhAEACyAFQgA3AwBByLIFQQA2AgBB2wAgASAEEAVByLIFKAIAIQJByLIFQQA2AgAgAkEBRw0DDAULEAYhABAHGgsgAhD2DAwEC0HIsgVBADYCACACEK0FIQRByLIFKAIAIQNByLIFQQA2AgAgA0EBRg0CQciyBUEANgIAQaDAARCtBSEFQciyBSgCACEDQciyBUEANgIAIANBAUYNAiAEIAVGBEBByLIFQQA2AgBBLUEcEA0hAkHIsgUoAgAhA0HIsgVBADYCACADQQFGDQNByLIFQQA2AgAgAiABQZG+ARCgBCEEQciyBSgCACEDQciyBUEANgIAAkAgA0EBRwRAIAJBADYCGCACQgA3AhAgAkHgzgI2AgBByLIFQQA2AgBB8M4CKAIAIAJBARAFQciyBSgCACEDQciyBUEANgIAAkAgA0EBRwRAQciyBUEANgIAQfsAIAJBEGpBABAVIQVByLIFKAIAIQNByLIFQQA2AgAgA0EBRw0BCxAGIQAQBxogAigCGCEDQciyBUEANgIAIAMQ6AFByLIFKAIAIQNByLIFQQA2AgAgA0EBRw0CQQAQCyEBEAcaIAEQhAEACyAFQQA2AgBByLIFQQA2AgBB2wAgASAEEAVByLIFKAIAIQJByLIFQQA2AgAgAkEBRw0DDAULEAYhABAHGgsgAhD2DAwEC0HIsgVBADYCACACEK0FIQNByLIFKAIAIQJByLIFQQA2AgAgAkEBRg0CQciyBUEANgIAQaXAARCtBSEEQciyBSgCACECQciyBUEANgIAIAJBAUYNAiADIARGBEBByLIFQQA2AgBBrwEgAUHZuAFBAUEBEBxByLIFKAIAIQJByLIFQQA2AgAgAkEBRw0BDAMLIABBAToALQsgAA8LEAYhABAHGiACEPYMDAELEAYhABAHGgsgARCEAxogABAIAAuhAQAgAEIANwJIIAAgATYCBCAAQeDAATYCACAAQgA3AlAgAEIANwJYIABCADcCYCAAQQA2AmgCQAJAIAJFDQAgAi0AAEUNACACKAAAIQIgAEEAOgAsIAAgAjYCKAwBCyAAQQA2AiggAEEAOgAsCyAAQQA2AkAgAEIANwMgIABBADoALSAAQgA3AwggAEH/AToARCAAQgA3AxAgAEEAOgAYIAALQQAgACgCCCEAQciyBUEANgIAIAAQ6AFByLIFKAIAIQBByLIFQQA2AgAgAEEBRwRADwtBABALIQAQBxogABCEAQALxgQBBX8gAEHgwAE2AgAgAEHIAGohBAJAAkACQCAAKAJIBEADQEHIsgVBADYCAEHmASAEIAEQFSECQciyBSgCACEDQciyBUEANgIAIANBAUYNAiACKAIAIgIEQCACIAIoAgAoAgQRAQALIAFBAWoiASAEKAIASQ0ACwsgACgCVARAIABB1ABqIQJBACEBA0BByLIFQQA2AgBBzwIgAiABEBUhA0HIsgUoAgAhBUHIsgVBADYCACAFQQFGDQMgAygCACIDBEAgAxD2DAsgAUEBaiIBIAIoAgBJDQALCyAAKAJgBEAgAEHgAGohA0EAIQEDQEHIsgVBADYCAEHQAiADIAEQFSECQciyBSgCACEFQciyBUEANgIAIAVBAUYEQEEAEAshARAHGgwFCyACKAIAIgIEQCACIAIoAgAoAgQRAQALIAFBAWoiASADKAIASQ0ACwsgACgCaCEBQciyBUEANgIAIAEQ6AFByLIFKAIAIQFByLIFQQA2AgACQAJAIAFBAUcEQCAAKAJcIQFByLIFQQA2AgAgARDoAUHIsgUoAgAhAUHIsgVBADYCACABQQFGDQEgACgCUCEBQciyBUEANgIAIAEQ6AFByLIFKAIAIQFByLIFQQA2AgAgAUEBRg0CIAAPC0EAEAshARAHGiABEIQBAAtBABALIQEQBxogARCEAQALQQAQCyEBEAcaIAEQhAEAC0EAEAshARAHGgwBC0EAEAshARAHGgsgAEHgAGoQgwMgAEHUAGoQgwMgBBCDAyABEIQBAAuuCAEIfyMAQbABayICJAACQAJAAkAgACgCACABTQRAIAJB6D42AmAgAkHUPjYCKEHIsgVBADYCAEEpIAJB4ABqIgYgAkEoakEEciIEEAVByLIFKAIAIQNByLIFQQA2AgAgA0EBRg0BIAJCgICAgHA3A6gBIAJBsD42AmAgAkGcPjYCKEHIsgVBADYCAEEqIAQQDSEHQciyBSgCACEDQciyBUEANgIAIANBAUYEQBAGIQEQBxoMBAsgAkIANwJMIAJCADcCVCACQRA2AlwgAkHMPzYCLEHIsgVBADYCAEErIAJBKGpBvNABQRUQFCEFQciyBSgCACEDQciyBUEANgIAAkACQAJAAkACQAJAAkACQAJAIANBAUYNAEHIsgVBADYCAEEsIAUgARAVIQNByLIFKAIAIQFByLIFQQA2AgAgAUEBRg0AQciyBUEANgIAQSsgA0HS0AFBBBAUIQNByLIFKAIAIQFByLIFQQA2AgAgAUEBRg0AIAAoAgAhAUHIsgVBADYCAEEsIAMgARAVGkHIsgUoAgAhAUHIsgVBADYCACABQQFGDQBBBBAOIQBByLIFQQA2AgBBLUEwEA0hA0HIsgUoAgAhAUHIsgVBADYCACABQQFGDQFByLIFQQA2AgBBLiACQQhqIAQQBUHIsgUoAgAhAUHIsgVBADYCACABQQFGDQIgAigCCCACQQhqIAIsABNBAEgbIgQQiA0iAUFwTwRAQciyBUEANgIAQS8gAkEYahAPQciyBSgCACEBQciyBUEANgIAIAFBAUYNBAwMCwJAAkAgAUELTwRAQciyBUEANgIAQS0gAUEQakFwcSIIEA0hBUHIsgUoAgAhCUHIsgVBADYCACAJQQFGDQYgAiAFNgIYIAIgATYCHCACIAhBgICAgHhyNgIgDAELIAIgAToAIyACQRhqIQUgAUUNAQsgBSAEIAEQgA0aCyABIAVqQQA6AABByLIFQQA2AgBBMCADIAJBGGpBxABBiNEBQTtB/dABEBYaQciyBSgCACEBQciyBUEANgIAQQEhBCABQQFHBEAgACADNgIAQciyBUEANgIAQTEgAEGs3QBBABASQciyBSgCACEBQciyBUEANgIAQQAhBCABQQFHDQwLEAYhARAHGiACLAAjQX9MBEAgAigCGBD2DAsgAiwAE0EASA0EDAULEAYhARAHGgwHCxAGIQEQBxoMBQsQBiEBEAcaDAMLEAYhARAHGkEBIQQgAiwAE0EATg0CCyACKAIIEPYMCyAERQ0CCyADEPYMCyAAEBMLIAJBsD42AmAgAkGcPjYCKCACQcw/NgIsIAIsAFdBf0wEQCACKAJMEPYMCyAHEOAGGiAGENwGIAEQCAALIAAoAgghACACQbABaiQAIAAgAUECdGoPCxAGIQEQBxoMAQsACyAGENwGIAEQCAALCgAgABCEAxD2DAuEAwECfyMAQRBrIgMkACAAIAEgAhCIAyIARQRAQQQQDiEAQciyBUEANgIAQS1BLBANIQJByLIFKAIAIQFByLIFQQA2AgACQAJAAkACQAJAIAFBAUcEQEHIsgVBADYCAEEtQSAQDSEBQciyBSgCACEEQciyBUEANgIAIARBAUYNASADIAE2AgAgA0KWgICAgISAgIB/NwIEIAFBADoAFiABQZLBASkAADcADiABQYzBASkAADcACCABQYTBASkAADcAAEHIsgVBADYCAEEyIAIgA0GbwQFBzwBBv8EBEBAaQciyBSgCACEBQciyBUEANgIAQQEhBCABQQFGDQIgACACNgIAQciyBUEANgIAQTEgAEGg2gBBABASQciyBSgCACEBQciyBUEANgIAQQAhBCABQQFGDQIACxAGIQEQBxoMAwsQBiEBEAcaDAELEAYhARAHGiADLAALQX9MBEAgAygCABD2DAsgBEUNAgsgAhD2DAsgABATCyABEAgACyADQRBqJAAgAAu9NAEEfyMAQRBrIgQkAAJAAkACQAJAIAJFBEBBiAEQ/gshAUHIsgVBADYCAEHRAiABIAAQFRpByLIFKAIAIQNByLIFQQA2AgAgA0EBRw0EEAYhAxAHGgwBCwJAIAFFDQAgAUEoaiEFQa3LARCtBSEDAkACQANAIAFBKGoQrQUgA0YNASABKAJAIgENAAsgBRCtBUH+ywEQrQVHDQEgAhCtBUGDzAEQrQVHDQJBiAEQ/gshAUHIsgVBADYCAEHSAiABIAAQFRpByLIFKAIAIQNByLIFQQA2AgAgA0EBRw0GEAYhAxAHGgwDCyAFEK0FIQFBrcsBEK0FIQMgAhCtBSEGIAEgA0YEQEGtywEQrQUgBkYEQEEEEA4hAkHIsgVBADYCAEEtQSwQDSEAQciyBSgCACEBQciyBUEANgIAAkACQCABQQFHBEBByLIFQQA2AgBBLUHAABANIQFByLIFKAIAIQNByLIFQQA2AgAgA0EBRg0BIAQgATYCACAEQrSAgICAiICAgH83AgQgAUEAOgA0IAFB4ssBKAAANgAwIAFB2ssBKQAANwAoIAFB0ssBKQAANwAgIAFByssBKQAANwAYIAFBwssBKQAANwAQIAFBussBKQAANwAIIAFBsssBKQAANwAAQciyBUEANgIAQTIgACAEQZvBAUGUBkHnywEQEBpByLIFKAIAIQNByLIFQQA2AgBBASEBIANBAUcEQCACIAA2AgBByLIFQQA2AgBBMSACQaDaAEEAEBJByLIFKAIAIQNByLIFQQA2AgBBACEBIANBAUcNCgsQBiEDEAcaIAQsAAtBf0wEQCAEKAIAEPYMCyABDQIMCAsQBiEDEAcaIAIQEwwHCxAGIQMQBxoLIAAQ9gwgAhATDAULQfAAEP4LIQFByLIFQQA2AgBB0wIgASAAIAIQFBpByLIFKAIAIQNByLIFQQA2AgAgA0EBRw0GEAYhAxAHGgwDC0HbxAEQrQUgBkYEQEGAARD+CyEBQciyBUEANgIAQdQCIAEgABAVGkHIsgUoAgAhA0HIsgVBADYCACADQQFHDQYQBiEDEAcaDAMLIAUQrQVB78sBEK0FRw0BIAIQrQVB9MsBEK0FRgRAQfgAEP4LIQFByLIFQQA2AgBB1QIgASAAEBUaQciyBSgCACEDQciyBUEANgIAIANBAUcNBhAGIQMQBxoMAwsgAhCtBUH5ywEQrQVHDQFB+AAQ/gshAUHIsgVBADYCAEHWAiABIAAQFRpByLIFKAIAIQNByLIFQQA2AgAgA0EBRw0FEAYhAxAHGgwCCyAFEK0FQYvHARCtBUcNACACEK0FQYjMARCtBUYEQEHwABD+CyEBQciyBUEANgIAIAEgABD6ARpByLIFKAIAIQNByLIFQQA2AgAgA0EBRw0FEAYhAxAHGgwCCwJAIAIQrQVBjcwBEK0FRwRAQaDMASEDQebRASEBDAELQfAAEP4LIQFByLIFQQA2AgBB2AIgASAAEBUaQciyBSgCACEDQciyBUEANgIAIANBAUcNBRAGIQMQBxoMAgsDQCACIAEQgwYEQCADQQRqIgMoAgAiAQ0BDAILC0HwABD+CyEBQciyBUEANgIAQdkCIAEgACACEBQaQciyBSgCACEDQciyBUEANgIAIANBAUcNBBAGIQMQBxoMAQsCQCACLQAAQa1/aiIBQSZLDQACQAJAAkACQAJAAkACQAJAAkACQAJAAkACQAJAAkACQAJAAkACQAJAIAFBAWsOJhQUFBQUFBQUFBQUFBQBFAIDBAUGBwgJFBQKCwwNFA4PEBESFBQTAAsgAhCtBUHUzQEQrQVGBEBB8AAQ/gshAUHIsgVBADYCAEHaAiABIAAgAhAUGkHIsgUoAgAhA0HIsgVBADYCACADQQFHDRgQBiEDEAcaDBULIAIQrQVB2c0BEK0FRw0TQfAAEP4LIQFByLIFQQA2AgBB2wIgASAAEBUaQciyBSgCACEDQciyBUEANgIAIANBAUcNFxAGIQMQBxoMFAsgAhCtBUHezQEQrQVGBEBB8AAQ/gshAUHIsgVBADYCAEHcAiABIAAQFRpByLIFKAIAIQNByLIFQQA2AgAgA0EBRw0XEAYhAxAHGgwUCyACEK0FQePNARCtBUYEQEHwABD+CyEBQciyBUEANgIAQd0CIAEgABAVGkHIsgUoAgAhA0HIsgVBADYCACADQQFHDRcQBiEDEAcaDBQLIAIQrQVB6M0BEK0FRgRAQfAAEP4LIQFByLIFQQA2AgBB3gIgASAAEBUaQciyBSgCACEDQciyBUEANgIAIANBAUcNFxAGIQMQBxoMFAsgAhCtBUHtzQEQrQVGBEBB8AAQ/gshAUHIsgVBADYCAEHfAiABIAAgAhAUGkHIsgUoAgAhA0HIsgVBADYCACADQQFHDRcQBiEDEAcaDBQLIAIQrQVB8s0BEK0FRgRAQfAAEP4LIQFByLIFQQA2AgBB4AIgASAAIAIQFBpByLIFKAIAIQNByLIFQQA2AgAgA0EBRw0XEAYhAxAHGgwUCyACEK0FQffNARCtBUcNEkHwABD+CyEBQciyBUEANgIAQeACIAEgACACEBQaQciyBSgCACEDQciyBUEANgIAIANBAUcNFhAGIQMQBxoMEwsgAhCtBUH8zQEQrQVGBEBB8AAQ/gshAUHIsgVBADYCAEHhAiABIAAgAhAUGkHIsgUoAgAhA0HIsgVBADYCACADQQFHDRYQBiEDEAcaDBMLIAIQrQVBgc4BEK0FRgRAQfAAEP4LIQFByLIFQQA2AgBB4gIgASAAEBUaQciyBSgCACEDQciyBUEANgIAIANBAUcNFhAGIQMQBxoMEwsgAhCtBUGGzgEQrQVHDRFB8AAQ/gshAUHIsgVBADYCAEHjAiABIAAQFRpByLIFKAIAIQNByLIFQQA2AgAgA0EBRw0VEAYhAxAHGgwSCyACEK0FQYvOARCtBUYEQEHwABD+CyEBQciyBUEANgIAQeQCIAEgABAVGkHIsgUoAgAhA0HIsgVBADYCACADQQFHDRUQBiEDEAcaDBILIAIQrQVBkM4BEK0FRgRAQfAAEP4LIQFByLIFQQA2AgBB5QIgASAAEBUaQciyBSgCACEDQciyBUEANgIAIANBAUcNFRAGIQMQBxoMEgsgAhCtBUGVzgEQrQVGBEBB8AAQ/gshAUHIsgVBADYCAEHmAiABIAAQFRpByLIFKAIAIQNByLIFQQA2AgAgA0EBRw0VEAYhAxAHGgwSCyACEK0FQZrOARCtBUYEQEHwABD+CyEBQciyBUEANgIAQeECIAEgACACEBQaQciyBSgCACEDQciyBUEANgIAIANBAUcNFRAGIQMQBxoMEgsgAhCtBUGfzgEQrQVHDRBB8AAQ/gshAUHIsgVBADYCAEHnAiABIAAQFRpByLIFKAIAIQNByLIFQQA2AgAgA0EBRw0UEAYhAxAHGgwRCyACEK0FQaTOARCtBUYEQEHwABD+CyEBQciyBUEANgIAQegCIAEgABAVGkHIsgUoAgAhA0HIsgVBADYCACADQQFHDRQQBiEDEAcaDBELIAIQrQVBqc4BEK0FRgRAQfAAEP4LIQFByLIFQQA2AgBB6QIgASAAEBUaQciyBSgCACEDQciyBUEANgIAIANBAUcNFBAGIQMQBxoMEQsgAhCtBUGuzgEQrQVHDQ9B8AAQ/gshAUHIsgVBADYCAEHqAiABIAAQFRpByLIFKAIAIQNByLIFQQA2AgAgA0EBRw0TEAYhAxAHGgwQCyACEK0FQbPOARCtBUYEQEHwABD+CyEBQciyBUEANgIAIAEgAEEAEKYCGkHIsgUoAgAhA0HIsgVBADYCACADQQFHDRMQBiEDEAcaDBALIAIQrQVBuM4BEK0FRgRAQfgAEP4LIQFByLIFQQA2AgBB7AIgASAAEBUaQciyBSgCACEDQciyBUEANgIAIANBAUcNExAGIQMQBxoMEAsgAhCtBUG9zgEQrQVHDQ5B8AAQ/gshAUHIsgVBADYCAEHtAiABIAAQFRpByLIFKAIAIQNByLIFQQA2AgAgA0EBRw0SEAYhAxAHGgwPCyACEK0FQcLOARCtBUcNDUHwABD+CyEBQciyBUEANgIAQe4CIAEgABAVGkHIsgUoAgAhA0HIsgVBADYCACADQQFHDREQBiEDEAcaDA4LIAIQrQVBg8wBEK0FRgRAQfAAEP4LIQFByLIFQQA2AgBB7wIgASAAEBUaQciyBSgCACEDQciyBUEANgIAIANBAUcNERAGIQMQBxoMDgsgAhCtBUHHzgEQrQVGBEBB8AAQ/gshAUHIsgVBADYCAEHhAiABIAAgAhAUGkHIsgUoAgAhA0HIsgVBADYCACADQQFHDREQBiEDEAcaDA4LIAIQrQVBzM4BEK0FRgRAQfAAEP4LIQFByLIFQQA2AgBB2gIgASAAIAIQFBpByLIFKAIAIQNByLIFQQA2AgAgA0EBRw0REAYhAxAHGgwOCyACEK0FQdHOARCtBUcNDEHwABD+CyEBQciyBUEANgIAQfACIAEgABAVGkHIsgUoAgAhA0HIsgVBADYCACADQQFHDRAQBiEDEAcaDA0LIAIQrQVB1s4BEK0FRgRAQfAAEP4LIQFByLIFQQA2AgBB4QIgASAAIAIQFBpByLIFKAIAIQNByLIFQQA2AgAgA0EBRw0QEAYhAxAHGgwNCyACEK0FQdvOARCtBUcNC0HwABD+CyEBQciyBUEANgIAQeACIAEgACACEBQaQciyBSgCACEDQciyBUEANgIAIANBAUcNDxAGIQMQBxoMDAsgAhCtBUHgzgEQrQVHDQpB8AAQ/gshAUHIsgVBADYCAEHaAiABIABB4M4BEBQaQciyBSgCACEDQciyBUEANgIAIANBAUcNDhAGIQMQBxoMCwsgAhCtBUHlzgEQrQVGBEBB8AAQ/gshAUHIsgVBADYCAEHxAiABIAAQFRpByLIFKAIAIQNByLIFQQA2AgAgA0EBRw0OEAYhAxAHGgwLCyACEK0FQerOARCtBUYEQEHwABD+CyEBQciyBUEANgIAQfICIAEgABAVGkHIsgUoAgAhA0HIsgVBADYCACADQQFHDQ4QBiEDEAcaDAsLIAIQrQVB784BEK0FRgRAQfAAEP4LIQFByLIFQQA2AgAgASAAEL0CGkHIsgUoAgAhA0HIsgVBADYCACADQQFHDQ4QBiEDEAcaDAsLIAIQrQVB9M4BEK0FRgRAQfAAEP4LIQFByLIFQQA2AgBB4QIgASAAIAIQFBpByLIFKAIAIQNByLIFQQA2AgAgA0EBRw0OEAYhAxAHGgwLCyACEK0FQfnOARCtBUYEQEHwABD+CyEBQciyBUEANgIAQeACIAEgACACEBQaQciyBSgCACEDQciyBUEANgIAIANBAUcNDhAGIQMQBxoMCwsgAhCtBUH+zgEQrQVGBEBB8AAQ/gshAUHIsgVBADYCAEH0AiABIAAQFRpByLIFKAIAIQNByLIFQQA2AgAgA0EBRw0OEAYhAxAHGgwLCyACEK0FQYPPARCtBUcNCUHwABD+CyEBQciyBUEANgIAQfUCIAEgABAVGkHIsgUoAgAhA0HIsgVBADYCACADQQFHDQ0QBiEDEAcaDAoLIAIQrQVBiM8BEK0FRw0IQfAAEP4LIQFByLIFQQA2AgBB9gIgASAAEBUaQciyBSgCACEDQciyBUEANgIAIANBAUcNDBAGIQMQBxoMCQsgAhCtBUGNzwEQrQVHDQdB8AAQ/gshAUHIsgVBADYCAEH3AiABIAAQFRpByLIFKAIAIQNByLIFQQA2AgAgA0EBRw0LEAYhAxAHGgwICyACEK0FQZLPARCtBUcNBkHwABD+CyEBQciyBUEANgIAQfgCIAEgABAVGkHIsgUoAgAhA0HIsgVBADYCACADQQFHDQoQBiEDEAcaDAcLIAIQrQVBl88BEK0FRgRAQfAAEP4LIQFByLIFQQA2AgAgASAAEM0CGkHIsgUoAgAhA0HIsgVBADYCACADQQFHDQoQBiEDEAcaDAcLIAIQrQVBnM8BEK0FRw0FQfAAEP4LIQFByLIFQQA2AgBB2gIgASAAIAIQFBpByLIFKAIAIQNByLIFQQA2AgAgA0EBRw0JEAYhAxAHGgwGCyACEK0FQaHPARCtBUYEQEHwABD+CyEBQciyBUEANgIAQfoCIAEgABAVGkHIsgUoAgAhA0HIsgVBADYCACADQQFHDQkQBiEDEAcaDAYLIAIQrQVBps8BEK0FRgRAQfAAEP4LIQFByLIFQQA2AgBB+wIgASAAIAIQFBpByLIFKAIAIQNByLIFQQA2AgAgA0EBRw0JEAYhAxAHGgwGCyACEK0FQavPARCtBUYEQEHwABD+CyEBQciyBUEANgIAQfsCIAEgACACEBQaQciyBSgCACEDQciyBUEANgIAIANBAUcNCRAGIQMQBxoMBgsgAhCtBUGwzwEQrQVGBEBB+AAQ/gshAUHIsgVBADYCAEH8AiABIAAQFRpByLIFKAIAIQNByLIFQQA2AgAgA0EBRw0JEAYhAxAHGgwGCyACEK0FQbXPARCtBUYEQEHwABD+CyEBQciyBUEANgIAQf0CIAEgABAVGkHIsgUoAgAhA0HIsgVBADYCACADQQFHDQkQBiEDEAcaDAYLIAIQrQVBus8BEK0FRgRAQfAAEP4LIQFByLIFQQA2AgBB/gIgASAAEBUaQciyBSgCACEDQciyBUEANgIAIANBAUcNCRAGIQMQBxoMBgsgAhCtBUG/zwEQrQVGBEBB8AAQ/gshAUHIsgVBADYCAEH/AiABIAAQFRpByLIFKAIAIQNByLIFQQA2AgAgA0EBRw0JEAYhAxAHGgwGCyACEK0FQcTPARCtBUYEQEHwABD+CyEBQciyBUEANgIAQYADIAEgABAVGkHIsgUoAgAhA0HIsgVBADYCACADQQFHDQkQBiEDEAcaDAYLIAIQrQVByc8BEK0FRgRAQfAAEP4LIQFByLIFQQA2AgBBgQMgASAAEBUaQciyBSgCACEDQciyBUEANgIAIANBAUcNCRAGIQMQBxoMBgsgAhCtBUHOzwEQrQVGBEBB8AAQ/gshAUHIsgVBADYCAEGCAyABIAAQFRpByLIFKAIAIQNByLIFQQA2AgAgA0EBRw0JEAYhAxAHGgwGCyACEK0FQdPPARCtBUYEQEHwABD+CyEBQciyBUEANgIAQYMDIAEgABAVGkHIsgUoAgAhA0HIsgVBADYCACADQQFHDQkQBiEDEAcaDAYLIAIQrQVB2M8BEK0FRgRAQfAAEP4LIQFByLIFQQA2AgBB4QIgASAAIAIQFBpByLIFKAIAIQNByLIFQQA2AgAgA0EBRw0JEAYhAxAHGgwGCyACEK0FQd3PARCtBUYEQEHwABD+CyEBQciyBUEANgIAIAEgACACEKYCGkHIsgUoAgAhA0HIsgVBADYCACADQQFHDQkQBiEDEAcaDAYLIAIQrQVB4s8BEK0FRw0EQfAAEP4LIQFByLIFQQA2AgBB4AIgASAAIAIQFBpByLIFKAIAIQNByLIFQQA2AgAgA0EBRw0IEAYhAxAHGgwFCyACEK0FQefPARCtBUYEQEHwABD+CyEBQciyBUEANgIAIAEgABDrAhpByLIFKAIAIQNByLIFQQA2AgAgA0EBRw0IEAYhAxAHGgwFCyACEK0FQezPARCtBUYEQEHwABD+CyEBQciyBUEANgIAQYUDIAEgABAVGkHIsgUoAgAhA0HIsgVBADYCACADQQFHDQgQBiEDEAcaDAULIAIQrQVB8c8BEK0FRgRAQfAAEP4LIQFByLIFQQA2AgBBhgMgASAAEBUaQciyBSgCACEDQciyBUEANgIAIANBAUcNCBAGIQMQBxoMBQsgAhCtBUH2zwEQrQVGBEBB8AAQ/gshAUHIsgVBADYCAEGHAyABIAAQFRpByLIFKAIAIQNByLIFQQA2AgAgA0EBRw0IEAYhAxAHGgwFCyACEK0FQfvPARCtBUYEQEHwABD+CyEBQciyBUEANgIAQYgDIAEgABAVGkHIsgUoAgAhA0HIsgVBADYCACADQQFHDQgQBiEDEAcaDAULIAIQrQVBgNABEK0FRw0DQfAAEP4LIQFByLIFQQA2AgBB4AIgASAAIAIQFBpByLIFKAIAIQNByLIFQQA2AgAgA0EBRw0HEAYhAxAHGgwECyACEK0FQYvHARCtBUYEQEHwABD+CyEBQciyBUEANgIAQYkDIAEgABAVGkHIsgUoAgAhA0HIsgVBADYCACADQQFHDQcQBiEDEAcaDAQLIAIQrQVBhdABEK0FRgRAQfAAEP4LIQFByLIFQQA2AgBB3wIgASAAQYXQARAUGkHIsgUoAgAhA0HIsgVBADYCACADQQFHDQcQBiEDEAcaDAQLIAIQrQVBitABEK0FRgRAQfAAEP4LIQFByLIFQQA2AgBBigMgASAAEBUaQciyBSgCACEDQciyBUEANgIAIANBAUcNBxAGIQMQBxoMBAsgAhCtBUGP0AEQrQVHDQJB8AAQ/gshAUHIsgVBADYCAEHgAiABIAAgAhAUGkHIsgUoAgAhA0HIsgVBADYCACADQQFHDQYQBiEDEAcaDAMLIAIQrQVBlNABEK0FRw0BQfAAEP4LIQFByLIFQQA2AgBBiwMgASAAEBUaQciyBSgCACEDQciyBUEANgIAIANBAUcNBRAGIQMQBxoMAgsgAhCtBUGZ0AEQrQVHDQBB8AAQ/gshAUHIsgVBADYCAEHaAiABIAAgAhAUGkHIsgUoAgAhA0HIsgVBADYCACADQQFHDQQQBiEDEAcaDAELQfAAEP4LIQFByLIFQQA2AgBBjAMgASAAIAIQFBpByLIFKAIAIQNByLIFQQA2AgAgA0EBRw0DEAYhAxAHGgsgARD2DAsgAxAICwALIARBEGokACABC8UBAQR/IAAoAkgEQCAAQcgAaiECA0AgAiABEKwBKAIAIgMgAygCACgCFBEBACABQQFqIgEgAigCAEkNAAsLIAAoAlQEQCAAQdQAaiECIABB4ABqIQRBACEBA0ACQCACIAEQhQMoAgAtAARFDQAgAiABEIUDKAIALQAFRQ0AIAAoAgQgACACIAEQhQMoAgAoAgAQhwMiAyAANgJAIAQgAyAAKAJgEOkBIAMgAygCACgCCBEBAAsgAUEBaiIBIAIoAgBJDQALCwvhEwIIfwV+IwBB8AJrIgIkACAAQQAQsAMhDCAAENkDIgMoAgAhBiADLAALIQQgAiAMNwOoASACIAYgAyAEQQBIGzYCoAFBysEBIAJBoAFqEL0BIAAQuQMhBiAAIAJB2wJqQQRBABCzAyACQQA6AN8CAn8gBkEBRwRAIAatIQpBCAwBCyAAELoDIQogACACQdsCahDgA0EQCyEDIAJB2wJqEK0FQd3BARCtBUYEQCAAIAJB4AJqQRBBABCzAyADQRBqIQMLAkACQAJAAn8gClAEQCAAQQAQsgMgDH0hCgsgCiADrSINVAsEQCACQeg+NgKIAiACQdQ+NgLQAUHIsgVBADYCAEEpIAJBiAJqIgYgAkHQAWpBBHIiBBAFQciyBSgCACEBQciyBUEANgIAIAFBAUYNASACQoCAgIBwNwPQAiACQbA+NgKIAiACQZw+NgLQAUHIsgVBADYCAEEqIAQQDSEHQciyBSgCACEBQciyBUEANgIAIAFBAUYEQBAGIQMQBxoMBAsgAkIANwL0ASACQgA3AvwBIAJBEDYChAIgAkHMPzYC1AFByLIFQQA2AgBBKyACQdABakHiwQFBFhAUIQVByLIFKAIAIQFByLIFQQA2AgACQAJAAkACQAJAAkACQAJAAkACQAJAIAFBAUYNACACQdsCahCIDSEBQciyBUEANgIAQSsgBSACQdsCaiABEBQhBUHIsgUoAgAhAUHIsgVBADYCACABQQFGDQBByLIFQQA2AgBBKyAFQfnBAUETEBQhBUHIsgUoAgAhAUHIsgVBADYCACABQQFGDQBByLIFQQA2AgBBjQMgBSAKpyAKQiCIpxBHIQVByLIFKAIAIQFByLIFQQA2AgAgAUEBRg0AQciyBUEANgIAQSsgBUGNwgFBHxAUIQVByLIFKAIAIQFByLIFQQA2AgAgAUEBRg0AQciyBUEANgIAQSwgBSADEBUaQciyBSgCACEDQciyBUEANgIAIANBAUYNAEHIsgVBADYCAEH+ACAAEA0hA0HIsgUoAgAhAEHIsgVBADYCACAAQQFGDQAgAygCACEBIAMsAAshBUHIsgVBADYCAEEuIAJBwAFqIAQQBUHIsgUoAgAhAEHIsgVBADYCACAAQQFGDQFByLIFQQA2AgAgAkG6wgE2AgAgAiABIAMgBUEASBs2AgQgAiACKALAASACQcABaiACLADLAUEASBs2AghB/wBBwIwEQa3CASACEBJByLIFKAIAIQNByLIFQQA2AgAgA0EBRg0CIAIsAMsBQX9MBEAgAigCwAEQ9gwLQQQQDiEAQciyBUEANgIAQS1BLBANIQFByLIFKAIAIQNByLIFQQA2AgAgA0EBRg0DQciyBUEANgIAQS4gAkGwAWogBBAFQciyBSgCACEDQciyBUEANgIAIANBAUYNBCACKAKwASACQbABaiACLAC7AUEASBsiBBCIDSIDQXBPBEBByLIFQQA2AgBBLyACQcABahAPQciyBSgCACEDQciyBUEANgIAIANBAUYNBgwOCwJAAkAgA0ELTwRAQciyBUEANgIAQS0gA0EQakFwcSIJEA0hBUHIsgUoAgAhCEHIsgVBADYCACAIQQFGDQggAiAFNgLAASACIAM2AsQBIAIgCUGAgICAeHI2AsgBDAELIAIgAzoAywEgAkHAAWohBSADRQ0BCyAFIAQgAxCADRoLIAMgBWpBADoAAEHIsgVBADYCAEEyIAEgAkHAAWpBm8EBQZYBQbrCARAQGkHIsgUoAgAhA0HIsgVBADYCAEEBIQQgA0EBRwRAIAAgATYCAEHIsgVBADYCAEExIABBoNoAQQAQEkHIsgUoAgAhA0HIsgVBADYCAEEAIQQgA0EBRw0OCxAGIQMQBxogAiwAywFBf0wEQCACKALAARD2DAsgAiwAuwFBAEgNBgwHCxAGIQMQBxoMCQsQBiEDEAcaDAgLEAYhAxAHGiACLADLAUF/Sg0HIAIoAsABEPYMDAcLEAYhAxAHGgwFCxAGIQMQBxoMAwsQBiEDEAcaQQEhBCACLAC7AUEATg0CCyACKAKwARD2DAsgBEUNAgsgARD2DAsgABATCyACQbA+NgKIAiACQZw+NgLQASACQcw/NgLUASACLAD/AUF/TARAIAIoAvQBEPYMCyAHEOAGGiAGENwGIAMQCAALIAAQ2QMiBCgCACEHIAQsAAshBSACIAM2ApgBIAIgCiANfSILNwOQASACIAs3A4gBIAIgByAEIAVBAEgbNgKAASACIAJB2wJqNgKEAUHDwgEgAkGAAWoQvQEgDCANfCENIAogDHwiCiABKQMQVgRAIAAQ2QMiBCgCACEHIAQsAAshBSACIAEpAxA3A3ggAiAKNwNwIAIgAUEoaiIINgJoIAJBusIBNgJgIAIgByAEIAVBAEgbNgJkIAIgAkHbAmo2AmxBwIwEQfbCASACQeAAahC6ASAAENkDIgQoAgAhByAELAALIQUgASkDECEOIAIgCjcDWCACIAs3A1AgAiADNgJIIAJBQGsgDDcDACACIA43AzggAiAINgI0IAIgByAEIAVBAEgbNgIwQdvDASACQTBqEL0BIAEpAxAgDX0hCwsgACABIAJB2wJqEIcDIgMgCzcDICADIAZBAUY6ABggAyALIA18NwMQIAMgDDcDCCACQdsCahCtBUHdwQEQrQVGBEAgAyACKQPgAjcBLiADIAIpA+gCNwE2CwJAAkACQCADLQAtRQ0AAkACQCADLQAoEPoFRQ0AIAMtACkQ+gVFDQAgAy0AKhD6BUUNAEEBIQYgAy0AKyIEEPoFIQcgBEEgRg0BIAcNAQtBACEGCyADQShqIQQgABDZAyIAKAIAIAAgACwAC0EASBshAAJAIAZFBEAgAiAENgIoIAIgADYCJCACQbrCATYCIEGVxAEgAkEgahC8AQwBCyACIAQ2AhQgAiAANgIQQbfEASACQRBqEL0BCyALUA0AQTAQ/gshAEHIsgVBADYCAEHgACAAIANB28QBIAunQQAQEBpByLIFKAIAIQZByLIFQQA2AgAgBkEBRg0BIANByABqIAAgAygCSBCLAwsgAyABNgJAIAMoAgAoAgwhAEHIsgVBADYCACAAIAMQD0HIsgUoAgAhAEHIsgVBADYCACAAQQFGBEBBoNoAEAshAhAHQaDaABAZRw0CIAIQDCECIAMgAygCACgCBBEBAEEEEA4iAyACNgIAQciyBUEANgIAQTEgA0Gg2gBBABASQciyBSgCACECQciyBUEANgIAIAJBAUcNBBAGIQIQBxoQFyACEAgACyACQfACaiQAIAMPCxAGIQIQBxogABD2DAsgAhAIAAsQBiEDEAcaDAELAAsgBhDcBiADEAgAC/8DAQR/IwBBEGsiBCQAIAAoAgAiAyACSQRAQQQQDiEAQciyBUEANgIAQS1BMBANIQJByLIFKAIAIQNByLIFQQA2AgACQAJAAkACQAJAIANBAUcEQEHIsgVBADYCAEEtQSAQDSEDQciyBSgCACEBQciyBUEANgIAIAFBAUYNASAEIAM2AgAgBEKTgICAgISAgIB/NwIEIANBADoAEyADQbnRASgAADYADyADQbLRASkAADcACCADQarRASkAADcAAEHIsgVBADYCAEEwIAIgBEHEAEHX0AFB6wBBvtEBEBYaQciyBSgCACEDQciyBUEANgIAQQEhASADQQFGDQIgACACNgIAQciyBUEANgIAQTEgAEGs3QBBABASQciyBSgCACEDQciyBUEANgIAQQAhASADQQFGDQIACxAGIQMQBxoMAwsQBiEDEAcaDAELEAYhAxAHGiAELAALQX9MBEAgBCgCABD2DAsgAUUNAgsgAhD2DAsgABATCyADEAgACwJAIAAoAgQgA0cEQCAAKAIIIQUMAQsgACADQQEgA0EBSxsiA0EBdDYCBCAAIAAoAgggA0EDdBDqASIFNgIIIAAoAgAhAwsgBSACQQJ0IgZqIgVBBGogBSADIAJrQQJ0EIINIAAoAgggBmogATYCACAAIAAoAgBBAWo2AgAgBEEQaiQAC5QDAQN/IwBBEGsiAiQAIAFFBEBBBBAOIQBByLIFQQA2AgBBLUEsEA0hBEHIsgUoAgAhAUHIsgVBADYCAAJAAkACQAJAAkAgAUEBRwRAQciyBUEANgIAQS1BIBANIQFByLIFKAIAIQNByLIFQQA2AgAgA0EBRg0BIAIgATYCACACQpuAgICAhICAgH83AgQgAUEAOgAbIAFB2soBKAAANgAXIAFB08oBKQAANwAQIAFBy8oBKQAANwAIIAFBw8oBKQAANwAAQciyBUEANgIAQTIgBCACQZvBAUHJBEHfygEQEBpByLIFKAIAIQFByLIFQQA2AgBBASEDIAFBAUcEQCAAIAQ2AgBByLIFQQA2AgBBMSAAQaDaAEEAEBJByLIFKAIAIQFByLIFQQA2AgBBACEDIAFBAUcNBgsQBiEBEAcaIAIsAAtBf0wEQCACKAIAEPYMCyADDQIMBAsQBiEBEAcaDAILEAYhARAHGgsgBBD2DAsgABATCyABEAgLAAsgAEHIAGogASAAKAJIEIsDIAJBEGokAAuTAQEFfyMAQSBrIgEkAAJAIABBKGoiAxCtBUUNACAAKQMgQsGEPVQNACAAKAIEENkDIgIoAgAhBCACLAALIQUgASAAKQMgNwMQIAEgAzYCCCABQYfFATYCACABIAQgAiAFQQBIGzYCBEHgxAEgARC9AQsgAEEAQX8QjgMgACgCVARAIAAQjwMLIAAQkAMgAUEgaiQAC8oKAgd/An4jAEHAAWsiAyQAAkACQAJAIAIgACgCSCABayIEIAQgAksbIAFqIgYgAUsEQCAAQcgAaiEEA0AgBCABEKwBKAIAIgIgACgCBEEAIAIoAgAoAhgRBQAgACgCBEEAELADIQogACkDECELIAQgARCsASgCACECIAogC1YEQCACKAIIIQIgACgCBEEAELADIQogAyAAKQMQNwMQIAMgCjcDCCADIAI2AgBBgcYBIAMQvQFByLIFQQA2AgAgA0HoPjYCcCADQdQ+NgI4QSkgA0HwAGoiBiADQThqQQRyIgUQBUHIsgUoAgAhAkHIsgVBADYCACACQQFGDQMgA0KAgICAcDcDuAEgA0GwPjYCcCADQZw+NgI4QciyBUEANgIAQSogBRANIQhByLIFKAIAIQJByLIFQQA2AgAgAkEBRgRAEAYhARAHGgwGCyADQgA3AlwgA0IANwJkIANBEDYCbCADQcw/NgI8QciyBUEANgIAQSsgA0E4akHPxgFBBhAUIQdByLIFKAIAIQJByLIFQQA2AgACQAJAAkACQAJAAkACQAJAAkAgAkEBRg0AIABBKGoiABCIDSECQciyBUEANgIAQSsgByAAIAIQFCECQciyBSgCACEAQciyBUEANgIAIABBAUYNAEHIsgVBADYCAEErIAJB1sYBQSUQFCECQciyBSgCACEAQciyBUEANgIAIABBAUYNAEHIsgVBADYCAEHmASAEIAEQFSEAQciyBSgCACEBQciyBUEANgIAIAFBAUYNACAAKAIAKAIIIgEQiA0hAEHIsgVBADYCAEErIAIgASAAEBQaQciyBSgCACEBQciyBUEANgIAIAFBAUYNAEEEEA4hAEHIsgVBADYCAEEtQSwQDSECQciyBSgCACEBQciyBUEANgIAIAFBAUYNAUHIsgVBADYCAEEuIANBGGogBRAFQciyBSgCACEBQciyBUEANgIAIAFBAUYNAiADKAIYIANBGGogAywAI0EASBsiBBCIDSIBQXBPBEBByLIFQQA2AgBBLyADQShqEA9ByLIFKAIAIQFByLIFQQA2AgAgAUEBRg0EDA4LAkACQCABQQtPBEBByLIFQQA2AgBBLSABQRBqQXBxIgkQDSEFQciyBSgCACEHQciyBUEANgIAIAdBAUYNBiADIAU2AiggAyABNgIsIAMgCUGAgICAeHI2AjAMAQsgAyABOgAzIANBKGohBSABRQ0BCyAFIAQgARCADRoLIAEgBWpBADoAAEHIsgVBADYCAEEyIAIgA0EoakGbwQFBiANB/MYBEBAaQciyBSgCACEBQciyBUEANgIAQQEhBCABQQFHBEAgACACNgIAQciyBUEANgIAQTEgAEGg2gBBABASQciyBSgCACEBQciyBUEANgIAQQAhBCABQQFHDQ4LEAYhARAHGiADLAAzQX9MBEAgAygCKBD2DAsgAywAI0EASA0EDAULEAYhARAHGgwHCxAGIQEQBxoMBQsQBiEBEAcaDAMLEAYhARAHGkEBIQQgAywAI0EATg0CCyADKAIYEPYMCyAERQ0CCyACEPYMCyAAEBMLIANBsD42AnAgA0GcPjYCOCADQcw/NgI8IAMsAGdBf0wEQCADKAJcEPYMCyAIEOAGGiAGENwGIAEQCAALIAIgAigCACgCCBEAACECQciMBCgCACgCAEEFQQQgAkEIRhtOBEAgBCABEKwBKAIAIgJBAEEBQQAgAigCACgCIBEHAAsgAUEBaiIBIAZHDQALCyADQcABaiQADwsQBiEBEAcaDAELAAsgBhDcBiABEAgAC6wHAgp/An4jAEGAAWsiAiQAIABBKGoiBhCtBSEFQYvHARCtBSEHIAAoAgQQ2QMiASgCACEDIAEsAAshBCACIAZBnMcBIAAtACgbNgJ0IAIgAyABIARBAEgbNgJwQZDHASACQfAAahC9ASAAKAIEQQAQsAMhCyAAKQMQIgwgC1YEQCAAQdQAaiEIIABB4ABqIQkgBSAHRyEHIAJBQGshCgNAAkAgDCALfSIMQgdYBEAgACgCBCEBAkAgBw0AIAxCBFINACABELkDIgNFDQIgACgCBBDZAyIBKAIAIQQgASwACyEFIAIgAzYCKCACQdLHATYCICACIAQgASAFQQBIGzYCJEGhxwEgAkEgahC8AQwCCyABENkDIgEoAgAhAyABLAALIQQgCiAAKQMQIAt9NwMAIAIgBjYCOCACQdLHATYCMCACIAMgASAEQQBIGzYCNEHhxwEgAkEwahC8AUIAIQwgACkDECALUQ0BA0AgACgCBBC2AxogDEIBfCIMIAApAxAgC31UDQALDAELIAAoAgQgABCKAyIFIAA2AkAgCSAFIAAoAmAQ6QEgBUEoaiEDQQAhAQJAAkAgACgCVCIERQ0AA0AgCCABEIUDKAIAKAIAEK0FIAMQrQVHBEAgAUEBaiIBIARHDQEMAgsLIAggARCFAygCACIBDQELIAUtAC0NASAAKAIEENkDIgEoAgAhBCABLAALIQUgAiADNgJcIAIgBjYCWCACQdLHATYCUCACIAQgASAFQQBIGzYCVEGXyAEgAkHQAGoQvQEMAQsgASABKAIIQQFqIgQ2AgggBEECSQ0AIAEtAAVFDQAgACgCBBDZAyIBKAIAIQQgASwACyEFIAIgAzYCbCACIAY2AmggAkHSxwE2AmAgAiAEIAEgBUEASBs2AmRBxcgBIAJB4ABqELwBCyAAKAIEQQAQsAMhCyAAKQMQIgwgC1YNAAsLIAAoAlQiBARAIABB1ABqIQMgAEEoaiEHQQAhAQNAAkAgAyABEIUDKAIALQAERQ0AIAMgARCFAygCACgCCA0AIAAoAgQQ2QMiCCgCACEFIAgsAAshCSACIAMgARCFAygCACgCADYCHCACIAc2AhggAiAFIAggCUEASBs2AhQgAkHSxwE2AhBB8sgBIAJBEGoQvAELIAFBAWoiASAERw0ACwsgACgCBBDZAyIBKAIAIQAgASwACyEDIAIgBjYCBCACIAAgASADQQBIGzYCAEGdyQEgAhC9ASACQYABaiQAC4EBAgR/AX4jAEEQayIBJAAgACgCBEEAELADIgUgACkDEFIEQCAAKAIEENkDIgIoAgAhAyACLAALIQQgASAAKQMQIAAoAgRBABCwA303AwggASADIAIgBEEASBs2AgBBjMUBIAEQvQEgACkDECEFCyAAKAIEIAVBABCxAyABQRBqJAALjQEBBH8jAEEQayIDJAACQCABRQ0AAkAgAC0AKEUNACAAQShqIgQgARCoBUUNASAELQAARQ0AIAAoAgQQ2QMiAigCACEEIAIsAAshBSADIAE2AgQgAyAEIAIgBUEASBs2AgBBo8UBIAMQvQEgARCqBSIBDQAgACECDAELIAAgARCSAyECCyADQRBqJAAgAguRAQEDfyMAQRBrIgMkACADQQA2AgwgASADQQxqEKkFGgJ/QQAgACgCYEUNABogAEHgAGohAAJAA0AgACACEJEBKAIAQShqIAEQqAUEQCADKAIMIgRFDQIgAyAEQX9qNgIMCyACQQFqIgIgACgCAEkNAAtBAAwBCyAAIAIQkQEoAgAgARCRAwshAiADQRBqJAAgAguMAQEFfyMAQRBrIgQkAAJAIAFFDQACQCAALQAoRQ0AIABBKGoiBSABEKgFRQ0BIAUtAABFDQAgACgCBBDZAyIFKAIAIQcgBSwACyEIIAQgATYCBCAEIAcgBSAIQQBIGzYCAEG+xQEgBBC9ASABEKoFIgFFDQELIAAgASACIAMQlAMhBgsgBEEQaiQAIAYLjAIBBX8jAEEQayIFJAACfyAAKAJIIgcEQCAAQcgAaiEIA0BBASAIIAQQrAEoAgAiBiABIAIgAyAGKAIAKAIkEQoADQIaIARBAWoiBCAHRw0ACwtBACEEIAVBADYCDCABIAVBDGoQqQUaIAAoAmAEQCAAQeAAaiEGA0AgBiAEEJEBKAIAQShqIAEQqAUEQCAFKAIMIgdFBEAgBiAEEJEBKAIAIAEgAiADEJMDDAQLIAUgB0F/ajYCDAsgBEEBaiIEIAYoAgBJDQALCyAAKAIEENkDIgQoAgAhBiAELAALIQIgBSABNgIEIAUgBiAEIAJBAEgbNgIAQd3FASAFEL0BQQALIQcgBUEQaiQAIAcLpwEBBX8jAEEQayICJAAgAEEAIAAoAgAoAhARAgAgABCWAyAAKAJgIgMEQCAAQeAAaiEFA0AgBSABEJEBKAIAIgQgBCgCACgCFBEBACABQQFqIgEgA0cNAAsLIAAoAgQQ2QMiASgCACEEIAEsAAshAyACIABBKGo2AgQgAiAEIAEgA0EASBs2AgBBqsoBIAIQvQEgAEEAIAAoAgAoAhwRAgAgAkEQaiQAC/sBAQZ/IwBBEGsiBCQAIAAoAkghBSAAKAIEENkDIgEoAgAhBiABLAALIQMgBCAAQShqNgIEIAQgBiABIANBAEgbNgIAQY3KASAEEL0BQX8gBSIBIAFBf0sbIgVBAEsEQCAAQcgAaiEDA0AgAyACEKwBKAIAIgEgACgCBEEAIAEoAgAoAhwRBQAgAyACEKwBKAIAIgEgASgCACgCCBEAACEBQciMBCgCACgCAEEFQQQgAUEIRhsiAU4EQEHAjAQgAUGiygFBABDBASADIAIQrAEoAgAiAUEAQQBBACABKAIAKAIgEQcACyACQQFqIgIgBUcNAAsLIARBEGokAAtCAQF+IAApAxBQRQRAIAAoAgRBABCwAyEBIAAoAgQgACkDCEEAELEDIAAgACgCACgCFBEBACAAKAIEIAFBABCxAwsLfgEBfyAAIAAoAgRBABCwAzcDCCAAKAIEIQICQCABRQRAIAJBABC+AyAAKAIEIABBKGoiAUEEELUDDAELIAJBARC+AyAAKAIEIABBKGoiAUEEELUDIAAoAgRCABC/AwsgARCtBUHdwQEQrQVGBEAgACgCBCAAQS5qQRAQtQMLC/sEAgN/A34jAEEwayICJAAgACAAKAIEQQAQsAMiBTcDECAAIAUgACkDCCIGfSIHNwMgIAIgBzcDGCACIAU3AxAgAiAGNwMIIAIgAEEoaiIDNgIAQa/JASACEL0BAkAgAQRAIAAoAgQgACkDCEIIfEEAELEDIAAoAgQgACkDIBC/AwwBCyAAKQMgQoCAgIAQWgRAQQQQDiEBQciyBUEANgIAQS1BLBANIQNByLIFKAIAIQBByLIFQQA2AgACQAJAAkACQAJAIABBAUcEQEHIsgVBADYCAEEtQcAAEA0hAEHIsgUoAgAhBEHIsgVBADYCACAEQQFGDQEgAiAANgIgIAJCsICAgICIgICAfzcCJCAAQQA6ADAgAEH4yQEpAAA3ACggAEHwyQEpAAA3ACAgAEHoyQEpAAA3ABggAEHgyQEpAAA3ABAgAEHYyQEpAAA3AAggAEHQyQEpAAA3AABByLIFQQA2AgBBMiADIAJBIGpBm8EBQZwEQYHKARAQGkHIsgUoAgAhAEHIsgVBADYCAEEBIQQgAEEBRg0CIAEgAzYCAEHIsgVBADYCAEExIAFBoNoAQQAQEkHIsgUoAgAhAEHIsgVBADYCAEEAIQQgAEEBRg0CAAsQBiEAEAcaDAMLEAYhABAHGgwBCxAGIQAQBxogAiwAK0F/TARAIAIoAiAQ9gwLIARFDQILIAMQ9gwLIAEQEwsgABAIAAsgACgCBCAAKQMIQQAQsQMgACgCBCAAKAIgEL4DCyAAKAIEIAApAxBBABCxAyAAIAApAyBCcEJ4IAEbfDcDICADEK0FQd3BARCtBUYEQCAAIAApAyBCcHw3AyALIAJBMGokAAu6BAEEf0EcEP4LIQFByLIFQQA2AgAgASAAQevKARCgBCEDQciyBSgCACECQciyBUEANgIAAkACQCACQQFHBEAgAUEANgIYIAFCADcCECABQZDMAjYCAEHIsgVBADYCAEGgzAIoAgAgAUEBEAVByLIFKAIAIQJByLIFQQA2AgACQCACQQFHBEBByLIFQQA2AgBB2QAgAUEQakEAEBUhAkHIsgUoAgAhBEHIsgVBADYCACAEQQFHDQELEAYhABAHGiABKAIYIQJByLIFQQA2AgAgAhDoAUHIsgUoAgAhAkHIsgVBADYCACACQQFHDQNBABALIQEQBxogARCEAQALIAJBADoAACAAQcgAaiICIAMgACgCSBCLA0EcEP4LIQFByLIFQQA2AgAgASAAQfPKARCgBCEAQciyBSgCACEDQciyBUEANgIAIANBAUYNASABQQA2AhggAUIANwIQIAFBgM4CNgIAQciyBUEANgIAQZDOAigCACABQQEQBUHIsgUoAgAhA0HIsgVBADYCAAJAIANBAUcEQEHIsgVBADYCAEH7ACABQRBqQQAQFSEDQciyBSgCACEEQciyBUEANgIAIARBAUcNAQsQBiEAEAcaIAEoAhghAkHIsgVBADYCACACEOgBQciyBSgCACECQciyBUEANgIAIAJBAUcNA0EAEAshARAHGiABEIQBAAsgA0EANgIAIAIgACACKAIAEIsDDwsQBiEAEAcaDAELEAYhABAHGgsgARD2DCAAEAgAC2cBAX9BMBD+CyEEQciyBUEANgIAQeAAIAQgASACIANBABAQGkHIsgUoAgAhAUHIsgVBADYCACABQQFHBEAgBEEBOgAMIABByABqIAQgACgCSBCLAw8LEAYhABAHGiAEEPYMIAAQCAALNQEBf0EMEP4LIgRBADYCCCAEIAM6AAUgBCACOgAEIAQgATYCACAAQdQAaiAEIAAoAlQQnQML/gMBBH8jAEEQayIEJAAgACgCACIDIAJJBEBBBBAOIQBByLIFQQA2AgBBLUEwEA0hAkHIsgUoAgAhA0HIsgVBADYCAAJAAkACQAJAAkAgA0EBRwRAQciyBUEANgIAQS1BIBANIQNByLIFKAIAIQFByLIFQQA2AgAgAUEBRg0BIAQgAzYCACAEQpOAgICAhICAgH83AgQgA0EAOgATIANBudEBKAAANgAPIANBstEBKQAANwAIIANBqtEBKQAANwAAQciyBUEANgIAQTAgAiAEQcQAQYjRAUE7Qb7RARAWGkHIsgUoAgAhA0HIsgVBADYCAEEBIQEgA0EBRg0CIAAgAjYCAEHIsgVBADYCAEExIABBrN0AQQAQEkHIsgUoAgAhA0HIsgVBADYCAEEAIQEgA0EBRg0CAAsQBiEDEAcaDAMLEAYhAxAHGgwBCxAGIQMQBxogBCwAC0F/TARAIAQoAgAQ9gwLIAFFDQILIAIQ9gwLIAAQEwsgAxAIAAsCQCAAKAIEIANHBEAgACgCCCEFDAELIAAgA0EBIANBAUsbIgNBAXQ2AgQgACAAKAIIIANBA3QQ6gEiBTYCCCAAKAIAIQMLIAUgAkECdCIGaiIFQQRqIAUgAyACa0ECdBCCDSAAKAIIIAZqIAE2AgAgACAAKAIAQQFqNgIAIARBEGokAAs5AQF/QevKASAAQcgAaiIAQQAQrAEoAgAoAggQgwYEfyABBSAAQQAQrAEoAgBBEGpBABCoAS0AAAsLMQBB68oBIABByABqIgBBABCsASgCACgCCBCDBkUEQCAAQQAQrAEoAgAgAUEAEK0BCws5AQF/QfPKASAAQcgAaiIAQQEQrAEoAgAoAggQgwYEfyABBSAAQQEQrAEoAgBBEGpBABCxASgCAAsLMQBB88oBIABByABqIgBBARCsASgCACgCCBCDBkUEQCAAQQEQrAEoAgAgAUEAEKIDCwvWBwEHfyMAQbABayIDJAACQAJAAkAgAC0ADARAIANB6D42AmAgA0HUPjYCKEHIsgVBADYCAEEpIANB4ABqIgIgA0EoakEEciIEEAVByLIFKAIAIQFByLIFQQA2AgAgAUEBRg0BIANCgICAgHA3A6gBIANBsD42AmAgA0GcPjYCKEHIsgVBADYCAEEqIAQQDSEHQciyBSgCACEBQciyBUEANgIAIAFBAUYEQBAGIQAQBxoMBAsgA0IANwJMIANCADcCVCADQRA2AlwgA0HMPzYCLEHIsgVBADYCAEErIANBKGpBxdEBQRcQFCEFQciyBSgCACEBQciyBUEANgIAAkACQAJAAkACQAJAAkACQAJAIAFBAUYNACAAKAIIIgAQiA0hAUHIsgVBADYCAEErIAUgACABEBQaQciyBSgCACEAQciyBUEANgIAIABBAUYNAEEEEA4hAUHIsgVBADYCAEEtQTAQDSEFQciyBSgCACEAQciyBUEANgIAIABBAUYNAUHIsgVBADYCAEEuIANBCGogBBAFQciyBSgCACEAQciyBUEANgIAIABBAUYNAiADKAIIIANBCGogAywAE0EASBsiBBCIDSIAQXBPBEBByLIFQQA2AgBBLyADQRhqEA9ByLIFKAIAIQBByLIFQQA2AgAgAEEBRg0EDAwLAkACQCAAQQtPBEBByLIFQQA2AgBBLSAAQRBqQXBxIggQDSEGQciyBSgCACEJQciyBUEANgIAIAlBAUYNBiADIAY2AhggAyAANgIcIAMgCEGAgICAeHI2AiAMAQsgAyAAOgAjIANBGGohBiAARQ0BCyAGIAQgABCADRoLIAAgBmpBADoAAEHIsgVBADYCAEEwIAUgA0EYakECQdfQAUHMAUHd0QEQFhpByLIFKAIAIQBByLIFQQA2AgBBASEEIABBAUcEQCABIAU2AgBByLIFQQA2AgBBMSABQazdAEEAEBJByLIFKAIAIQBByLIFQQA2AgBBACEEIABBAUcNDAsQBiEAEAcaIAMsACNBf0wEQCADKAIYEPYMCyADLAATQQBIDQQMBQsQBiEAEAcaDAcLEAYhABAHGgwFCxAGIQAQBxoMAwsQBiEAEAcaQQEhBCADLAATQQBODQILIAMoAggQ9gwLIARFDQILIAUQ9gwLIAEQEwsgA0GwPjYCYCADQZw+NgIoIANBzD82AiwgAywAV0F/TARAIAMoAkwQ9gwLIAcQ4AYaIAIQ3AYgABAIAAsgAEEQaiACELEBIAE2AgAgA0GwAWokAA8LEAYhABAHGgwBCwALIAIQ3AYgABAIAAuxDAEJfyMAQdAAayIDJAACQAJAAkACQCAALQAoRQ0AIABBKGohCSADQQA2AkggAyADQUBrNgJEIAMgA0FAazYCQCADQThqIQdBASEEIAAhBQJAAkACQANAAkACQCAEQf8BcUUNACAFQShqIggQiA0iBEFwTwRAQciyBUEANgIAQS8gA0EwahAPQciyBSgCACEEQciyBUEANgIAIARBAUYNBAALAkACQCAEQQtPBEBByLIFQQA2AgBBLSAEQRBqQXBxIgoQDSEGQciyBSgCACELQciyBUEANgIAIAtBAUYNBCADIAY2AjAgAyAENgI0IAMgCkGAgICAeHI2AjgMAQsgAyAEOgA7IANBMGohBiAERQ0BCyAGIAggBBCADRoLIAQgBmpBADoAAEHIsgVBADYCAEEtQRQQDSEEQciyBSgCACEGQciyBUEANgIAIAZBAUYNBCAEIAMpAzA3AgggBCAHKAIANgIQIAdBADYCACADQgA3AzAgBCADQUBrNgIAIAQgAygCRCIGNgIEIAYgBDYCACADIAQ2AkQgAyADKAJIQQFqNgJIIAMsADtBf0oNACADKAIwEPYMCyAFKAJAIgVFDQQgBS0AKCEEDAELCxAGIQUQBxoMBgsQBiEFEAcaDAULEAYhBRAHGiADLAA7QX9KDQQgAygCMBD2DAwECyADKAJEIQQgA0EANgI4IANCADcDMAJAIANBQGsgBEYEQCADQTBqIQcMAQsCQAJAAkADQAJAQciyBUEANgIAQY4DIANBIGogBEEIakEuEBJByLIFKAIAIQVByLIFQQA2AgAgBUEBRg0AQciyBUEANgIAQY8DIANBMGogAygCICADQSBqIAMtACsiBUEYdEEYdUEASCIGGyADKAIkIAUgBhsQFBpByLIFKAIAIQVByLIFQQA2AgAgBUEBRg0CIAMsACtBf0wEQCADKAIgEPYMCyAEKAIEIgQgA0FAa0cNAQwECwsQBiEFEAcaDAELEAYhBRAHGiADLAArQX9KDQAgAygCIBD2DAsgA0EwaiEHDAQLAkAgAy0AOyIEQRh0QRh1IgVBf0wEQCADKAI0IgQNASADQTBqIQcMAgsgBQ0AIANBMGohBwwBC0HIsgVBADYCAEE8IANBMGogBEF/akEAEBJByLIFKAIAIQRByLIFQQA2AgAgA0EwaiEHIARBAUYNAgsgACgCBCEEQciyBUEANgIAQf4AIAQQDSEEQciyBSgCACEFQciyBUEANgIAIAVBAUYNASAEKAIAIQUgBCwACyEGQciyBUEANgIAIAMgCTYCFCADIAMoAjAgA0EwaiADLAA7QQBIGzYCGCADIAUgBCAGQQBIGzYCEEGQA0HAjAQgAUEEQfnKASADQRBqECJByLIFKAIAIQRByLIFQQA2AgAgBEEBRg0BIAMsADtBf0wEQCADKAIwEPYMCyADKAJIRQ0AIAMoAkQiBCgCACIFIAMoAkAiBigCBDYCBCAGKAIEIAU2AgAgA0EANgJIIAQgA0FAa0YNAANAIAQoAgQhBSAELAATQX9MBEAgBCgCCBD2DAsgBBD2DCAFIgQgA0FAa0cNAAsLIAAoAkgiBwRAIABByABqIQYgAUEBakH/AXEhCEEAIQQDQAJAAkAgBiAEEKwBKAIAIgUgBSgCACgCCBEAAEEIRw0AQciMBCgCACgCAEEESg0AIAMgACgCBBDZAyIFKAIAIAUgBSwAC0EASBs2AgBBwIwEIAhBBEGMywEgAxC/AQwBCyAGIAQQrAEoAgAiBSAIIAJBACAFKAIAKAIgEQcACyAEQQFqIgQgB0cNAAsLIAAoAmAiBgRAIABB4ABqIQdBACEEIAFBAWpB/wFxIQgDQCAHIAQQkQEoAgAiBSAIIAIgBSgCACgCIBEFACAEQQFqIgQgBkcNAAsLIANB0ABqJAAPCxAGIQUQBxoLIAcsAAtBf0oNACADKAIwEPYMCwJAIAMoAkhFDQAgAygCRCIEKAIAIgYgAygCQCICKAIENgIEIAIoAgQgBjYCACADQQA2AkggBCADQUBrRg0AA0AgBCgCBCEGIAQsABNBf0wEQCAEKAIIEPYMCyAEEPYMIAYiBCADQUBrRw0ACwsgBRAIAAu/AgEGfyAAQgA3AgAgAEEANgIIAkACQCABKAIEIAEtAAsiAyADQRh0QRh1QQBIIgUbIgNBAWoiBEFwTwRAQciyBUEANgIAQS8gABAPQciyBSgCACEBQciyBUEANgIAIAFBAUYNAQALIAEoAgAhBgJAAkAgBEELTwRAQciyBUEANgIAQS0gA0ERakFwcSIHEA0hBEHIsgUoAgAhCEHIsgVBADYCACAIQQFGDQMgACAENgIAIAAgAzYCBCAAIAdBgICAgHhyNgIIDAELIAAgAzoACyAAIQQgA0UNAQsgBCAGIAEgBRsgAxCADRoLIAMgBGpBADoAAEHIsgVBADYCAEE7IAAgAhAFQciyBSgCACEBQciyBUEANgIAIAFBAUcNAQsQBiEBEAcaIAAsAAtBf0wEQCAAKAIAEPYMCyABEAgACws3ACAAIAE2AgQgAEHI0wE2AgAgAEEANgIoIABCADcDGCAAQgA3AxAgACACOgAIIABCADcCICAAC8wBAQR/IABByNMBNgIAAkACQCAAKAIcBEAgAEEcaiEDA0BByLIFQQA2AgBB5gEgAyABEBUhAkHIsgUoAgAhBEHIsgVBADYCACAEQQFGDQIgAigCACICBEAgAiACKAIAKAIEEQEACyABQQFqIgEgAygCAEkNAAsLIAAoAiQhAUHIsgVBADYCACABEOgBQciyBSgCACEBQciyBUEANgIAIAFBAUYNASAADwtBABALIQEQBxogAxCDAyABEIQBAAtBABALIQEQBxogARCEAQALCgAgABCmAxD2DAuSAwEDfyMAQRBrIgIkACABRQRAQQQQDiEAQciyBUEANgIAQS1BLBANIQRByLIFKAIAIQFByLIFQQA2AgACQAJAAkACQAJAIAFBAUcEQEHIsgVBADYCAEEtQSAQDSEBQciyBSgCACEDQciyBUEANgIAIANBAUYNASACIAE2AgAgAkKbgICAgISAgIB/NwIEIAFBADoAGyABQfvTASgAADYAFyABQfTTASkAADcAECABQezTASkAADcACCABQeTTASkAADcAAEHIsgVBADYCAEEyIAQgAkGA1AFBL0Gq1AEQEBpByLIFKAIAIQFByLIFQQA2AgBBASEDIAFBAUcEQCAAIAQ2AgBByLIFQQA2AgBBMSAAQaDaAEEAEBJByLIFKAIAIQFByLIFQQA2AgBBACEDIAFBAUcNBgsQBiEBEAcaIAIsAAtBf0wEQCACKAIAEPYMCyADDQIMBAsQBiEBEAcaDAILEAYhARAHGgsgBBD2DAsgABATCyABEAgLAAsgAEEcaiABIAAoAhwQiwMgAkEQaiQAC04BA38gACgCHCIFBH8gAEEcaiEGAkADQCAGIAQQrAEoAgAiACABIAIgAyAAKAIAKAIkEQoADQEgBEEBaiIEIAVHDQALQQAPC0EBBSAECwtAAQJ/IAAoAhwEQCAAQRxqIQFBACEAA0AgASAAEKwBKAIAIgIgAigCACgCFBEBACAAQQFqIgAgASgCAEkNAAsLCzkAIAAgARCsAyAAIAFBACAAKAIoEK0DIAAgACgCACgCGBEBACAAIAEgACgCKEF/EK0DIAFBADoAWAvABAEEfyMAQTBrIgIkACABENkDIgMoAgAhBCADLAALIQUgAiABQQAQsAM3AxggAiAEIAMgBUEASBs2AhBBttQBIAJBEGoQvQEgARC2AyEDAkAgAC0ACCIEBEAgAyAERg0BQQQQDiEBQciyBUEANgIAQS1BLBANIQNByLIFKAIAIQBByLIFQQA2AgACQAJAAkACQAJAIABBAUcEQEHIsgVBADYCAEEtQSAQDSEAQciyBSgCACEEQciyBUEANgIAIARBAUYNASACIAA2AiAgAkKegICAgISAgIB/NwIkIABBADoAHiAAQe/UASkAADcAFiAAQenUASkAADcAECAAQeHUASkAADcACCAAQdnUASkAADcAAEHIsgVBADYCAEEyIAMgAkEgakGA1AFB3gBB+NQBEBAaQciyBSgCACEAQciyBUEANgIAQQEhBCAAQQFGDQIgASADNgIAQciyBUEANgIAQTEgAUGg2gBBABASQciyBSgCACEAQciyBUEANgIAQQAhBCAAQQFGDQIACxAGIQAQBxoMAwsQBiEAEAcaDAELEAYhABAHGiACLAArQX9MBEAgAigCIBD2DAsgBEUNAgsgAxD2DAsgARATCyAAEAgACyAAIAM6AAgLIAAgARDMAzYCGCAAIAFBABCwAzcDECABENkDIgEoAgAhAyABLAALIQQgAC0ACCEFIAIgACgCGCIANgIMIAIgADYCCCACIAU2AgQgAiADIAEgBEEASBs2AgBBg9UBIAIQvQEgAkEwaiQAC70FAgR/AX4jAEEwayIFJAACQCADIAAoAhwgAmsiBCAEIANLGyACaiIGIAJLBEAgAEEcaiEHA0AgByACEKwBKAIAIQMgACgCGCEEIAFBABCwAyEIIAQgACkDECAIfadqIQQCQCADIAMoAgAoAggRAABBCUYEQCAEQQFIDQEgAyAErTcDECADIAFBACADKAIAKAIYEQUADAELIARBAEgNAyADIAFBACADKAIAKAIYEQUAIAMgAygCACgCCBEAACEEQciMBCgCACgCAEEFQQQgBEEIRhtIDQAgA0EAQQFBACADKAIAKAIgEQcACyACQQFqIgIgBkcNAAsLIAVBMGokAA8LIAEQ2QMiAygCACEEIAMsAAshASAALQAIIQYgACgCGCEAIAUgAjYCECAFIAA2AgwgBSAGNgIIIAVB9tUBNgIAIAUgBCADIAFBAEgbNgIEQcCMBEG41QEgBRC6AUEEEA4hA0HIsgVBADYCAEEtQSwQDSEEQciyBSgCACECQciyBUEANgIAAkACQAJAAkACQCACQQFHBEBByLIFQQA2AgBBLUEgEA0hAkHIsgUoAgAhAEHIsgVBADYCACAAQQFGDQEgBSACNgIgIAVCkoCAgICEgICAfzcCJCACQQA6ABIgAkGV1gEvAAA7ABAgAkGN1gEpAAA3AAggAkGF1gEpAAA3AABByLIFQQA2AgBBMiAEIAVBIGpBgNQBQYwBQfbVARAQGkHIsgUoAgAhAkHIsgVBADYCAEEBIQAgAkEBRg0CIAMgBDYCAEHIsgVBADYCAEExIANBoNoAQQAQEkHIsgUoAgAhAkHIsgVBADYCAEEAIQAgAkEBRg0CAAsQBiECEAcaDAMLEAYhAhAHGgwBCxAGIQIQBxogBSwAK0F/TARAIAUoAiAQ9gwLIABFDQILIAQQ9gwLIAMQEwsgAhAIAAv0AQIEfwN+IwBBEGsiAiQAIAAgACgCACgCGBEBAAJAIAAoAhwiA0UEQCACQZoBNgIIIAJBgNQBNgIEIAJBttYBNgIAQcCMBEGY1gEgAhC6AQwBCyAAQRxqIQQgASAALQAIELsDIAFBABCwAyEHIAFBABDNAyABQQAQsAMhCEEAIQADQCAEIAAQrAEoAgAiBSABQQAgBSgCACgCHBEFACAAQQFqIgAgA0cNAAsgASIALQBaIgMEQCAAQgBBCCADa0H/AXEQywMLIAFBABCwAyEGIAEgB0EAELEDIAEgBiAIfacQzQMgASAGQQAQsQMLIAJBEGokAAuOAQEEfyMAQRBrIgMkACAAIAAoAgAoAhgRAQACQCAAKAIcIgQEQCAAQRxqIQVBACEAA0AgBSAAEKwBKAIAIgYgASACQQAgBigCACgCIBEHACAAQQFqIgAgBEcNAAsMAQsgA0HHATYCCCADQYDUATYCBCADQbbWATYCAEHAjARBmNYBIAMQugELIANBEGokAAuhAwIDfwF+IwBBEGsiAiQAAn8gAEHIAGogACgCRA0AGgJAIAENACAAKAIAIgENAEEEEA4hAEHIsgVBADYCAEEtQSwQDSEEQciyBSgCACEBQciyBUEANgIAAkACQAJAAkACQCABQQFHBEBByLIFQQA2AgBBLUEgEA0hAUHIsgUoAgAhA0HIsgVBADYCACADQQFGDQEgAiABNgIAIAJCloCAgICEgICAfzcCBCABQQA6ABYgAUH+1gEpAAA3AA4gAUH41gEpAAA3AAggAUHw1gEpAAA3AABByLIFQQA2AgBBMiAEIAJBh9cBQSdBrtcBEBAaQciyBSgCACEBQciyBUEANgIAQQEhAyABQQFGDQIgACAENgIAQciyBUEANgIAQTEgAEGg2gBBABASQciyBSgCACEBQciyBUEANgIAQQAhAyABQQFGDQIACxAGIQEQBxoMAwsQBiEBEAcaDAELEAYhARAHGiACLAALQX9MBEAgAigCABD2DAsgA0UNAgsgBBD2DAsgABATCyABEAgACyABKAI8CykDACEFIAJBEGokACAFC44JAQR/IwBBEGsiAyQAAkACQAJAAkAgACgCRARAIAApA1AgAVYNAUEEEA4hAkHIsgVBADYCAEEtQSwQDSEFQciyBSgCACEAQciyBUEANgIAAkACQAJAAkAgAEEBRwRAQciyBUEANgIAQS1BIBANIQBByLIFKAIAIQRByLIFQQA2AgAgBEEBRg0BIAMgADYCACADQpWAgICAhICAgH83AgQgAEEAOgAVIABBx9cBKQAANwANIABBwtcBKQAANwAIIABButcBKQAANwAAQciyBUEANgIAQTIgBSADQYfXAUEvQdDXARAQGkHIsgUoAgAhAEHIsgVBADYCAEEBIQQgAEEBRg0CIAIgBTYCAEHIsgVBADYCAEExIAJBoNoAQQAQEkHIsgUoAgAhAEHIsgVBADYCAEEAIQQgAEEBRg0CDAkLEAYhABAHGgwDCxAGIQAQBxoMAQsQBiEAEAcaIAMsAAtBf0wEQCADKAIAEPYMCyAERQ0FCyAFEPYMCyACEBMMAwsCQCACDQAgACgCACICDQBBBBAOIQJByLIFQQA2AgBBLUEsEA0hBUHIsgUoAgAhAEHIsgVBADYCAAJAAkACQCAAQQFHBEBByLIFQQA2AgBBLUEgEA0hAEHIsgUoAgAhBEHIsgVBADYCACAEQQFGDQEgAyAANgIAIANCloCAgICEgICAfzcCBCAAQQA6ABYgAEH+1gEpAAA3AA4gAEH41gEpAAA3AAggAEHw1gEpAAA3AABByLIFQQA2AgBBMiAFIANBh9cBQTdB0NcBEBAaQciyBSgCACEAQciyBUEANgIAQQEhBCAAQQFHBEAgAiAFNgIAQciyBUEANgIAQTEgAkGg2gBBABASQciyBSgCACEAQciyBUEANgIAQQAhBCAAQQFHDQkLEAYhABAHGiADLAALQX9MBEAgAygCABD2DAsgBEUNBwwCCxAGIQAQBxoMAgsQBiEAEAcaCyAFEPYMCyACEBMgABAIAAsgAiABIAIoAgAoAgwREwBFDQFBBBAOIQJByLIFQQA2AgBBLUEwEA0hBUHIsgUoAgAhAEHIsgVBADYCAAJAAkACQCAAQQFHBEBByLIFQQA2AgBBLUEQEA0hAEHIsgUoAgAhBEHIsgVBADYCACAEQQFGDQEgAyAANgIAIANCi4CAgICCgICAfzcCBCAAQQA6AAsgAEHj1wEoAAA2AAcgAEHc1wEpAAA3AABByLIFQQA2AgBBqKoFKAIAIQZByLIFKAIAIQBByLIFQQA2AgBBASEEAkAgAEEBRg0AQciyBUEANgIAQTAgBSADIAZBh9cBQTlB0NcBEBYaQciyBSgCACEAQciyBUEANgIAIABBAUYNACACIAU2AgBBACEEQciyBUEANgIAQTEgAkGs3QBBABASQciyBSgCACEAQciyBUEANgIAIABBAUcNCAsQBiEAEAcaIAMsAAtBf0wEQCADKAIAEPYMCyAERQ0GDAILEAYhABAHGgwCCxAGIQAQBxoLIAUQ9gwLIAIQEyAAEAgACyAAIAE3A0gLIANBEGokAA8LIAAQCAALAAuiAwIDfwF+IwBBEGsiAiQAAn8gAEHQAGogACgCRA0AGgJAIAENACAAKAIAIgENAEEEEA4hAEHIsgVBADYCAEEtQSwQDSEEQciyBSgCACEBQciyBUEANgIAAkACQAJAAkACQCABQQFHBEBByLIFQQA2AgBBLUEgEA0hAUHIsgUoAgAhA0HIsgVBADYCACADQQFGDQEgAiABNgIAIAJCloCAgICEgICAfzcCBCABQQA6ABYgAUH+1gEpAAA3AA4gAUH41gEpAAA3AAggAUHw1gEpAAA3AABByLIFQQA2AgBBMiAEIAJBh9cBQcQAQejXARAQGkHIsgUoAgAhAUHIsgVBADYCAEEBIQMgAUEBRg0CIAAgBDYCAEHIsgVBADYCAEExIABBoNoAQQAQEkHIsgUoAgAhAUHIsgVBADYCAEEAIQMgAUEBRg0CAAsQBiEBEAcaDAMLEAYhARAHGgwBCxAGIQEQBxogAiwAC0F/TARAIAIoAgAQ9gwLIANFDQILIAQQ9gwLIAAQEwsgARAIAAsgASgCOAspAwAhBSACQRBqJAAgBQvgDwICfwJ+IwBBMGsiBCQAAkAgAkUNAAJAAkAgAUUEQEEEEA4hAkHIsgVBADYCAEEtQSwQDSEBQciyBSgCACEAQciyBUEANgIAAkACQCAAQQFHBEBByLIFQQA2AgBBLUEgEA0hAEHIsgUoAgAhA0HIsgVBADYCACADQQFGDQEgBCAANgIgIARClYCAgICEgICAfzcCJCAAQQA6ABUgAEH91wEpAAA3AA0gAEH41wEpAAA3AAggAEHw1wEpAAA3AABByLIFQQA2AgBBMiABIARBIGpBh9cBQc0AQYbYARAQGkHIsgUoAgAhAEHIsgVBADYCAEEBIQMgAEEBRwRAIAIgATYCAEHIsgVBADYCAEExIAJBoNoAQQAQEkHIsgUoAgAhAEHIsgVBADYCAEEAIQMgAEEBRw0GCxAGIQAQBxogBCwAK0F/TARAIAQoAiAQ9gwLIAMNAgwECxAGIQAQBxogAhATDAMLEAYhABAHGgsgARD2DCACEBMMAQsgAC0AWARAIARBzgA2AgggBEGH1wE2AgQgBEGu2AE2AgBBwIwEQZDYASAEELoBCyAAKAJEIgUEQCAAKQNIIgYgAq0iB3wgACkDUFYEQEEEEA4hAkHIsgVBADYCAEEtQSwQDSEBQciyBSgCACEAQciyBUEANgIAAkACQCAAQQFHBEBByLIFQQA2AgBBLUEwEA0hAEHIsgUoAgAhA0HIsgVBADYCACADQQFGDQEgBCAANgIgIARCp4CAgICGgICAfzcCJCAAQQA6ACcgAEHf2AEpAAA3AB8gAEHY2AEpAAA3ABggAEHQ2AEpAAA3ABAgAEHI2AEpAAA3AAggAEHA2AEpAAA3AABByLIFQQA2AgBBMiABIARBIGpBh9cBQdIAQYbYARAQGkHIsgUoAgAhAEHIsgVBADYCAEEBIQMgAEEBRwRAIAIgATYCAEHIsgVBADYCAEExIAJBoNoAQQAQEkHIsgUoAgAhAEHIsgVBADYCAEEAIQMgAEEBRw0HCxAGIQAQBxogBCwAK0F/TARAIAQoAiAQ9gwLIAMNAgwFCxAGIQAQBxogAhATDAQLEAYhABAHGgsgARD2DCACEBMMAgsgASAFIAanaiACEIANGiAAIAApA0ggB3w3A0gMAwsCQCADDQAgACgCACIDDQBBBBAOIQJByLIFQQA2AgBBLUEsEA0hAUHIsgUoAgAhAEHIsgVBADYCAAJAAkAgAEEBRwRAQciyBUEANgIAQS1BIBANIQBByLIFKAIAIQNByLIFQQA2AgAgA0EBRg0BIAQgADYCICAEQpaAgICAhICAgH83AiQgAEEAOgAWIABB/tYBKQAANwAOIABB+NYBKQAANwAIIABB8NYBKQAANwAAQciyBUEANgIAQTIgASAEQSBqQYfXAUHbAEGG2AEQEBpByLIFKAIAIQBByLIFQQA2AgBBASEDIABBAUcEQCACIAE2AgBByLIFQQA2AgBBMSACQaDaAEEAEBJByLIFKAIAIQBByLIFQQA2AgBBACEDIABBAUcNBgsQBiEAEAcaIAQsACtBf0wEQCAEKAIgEPYMCyADDQIMBAsQBiEAEAcaIAIQEwwDCxAGIQAQBxoLIAEQ9gwgAhATDAELIAMgASACrSIGIARBGGpCACADKAIAKAIQERAABEBBBBAOIQJByLIFQQA2AgBBLUEwEA0hAUHIsgUoAgAhAEHIsgVBADYCAAJAAkAgAEEBRwRAQciyBUEANgIAQS1BEBANIQBByLIFKAIAIQNByLIFQQA2AgAgA0EBRg0BIAQgADYCICAEQouAgICAgoCAgH83AiQgAEEAOgALIABB79gBKAAANgAHIABB6NgBKQAANwAAQciyBUEANgIAQaiqBSgCACEFQciyBSgCACEAQciyBUEANgIAQQEhAwJAIABBAUYNAEHIsgVBADYCAEEwIAEgBEEgaiAFQYfXAUHeAEGG2AEQFhpByLIFKAIAIQBByLIFQQA2AgAgAEEBRg0AIAIgATYCAEEAIQNByLIFQQA2AgBBMSACQazdAEEAEBJByLIFKAIAIQBByLIFQQA2AgAgAEEBRw0GCxAGIQAQBxogBCwAK0F/TARAIAQoAiAQ9gwLIAMNAgwECxAGIQAQBxogAhATDAMLEAYhABAHGgsgARD2DCACEBMMAQsgBCkDGCAGUQ0CQQQQDiECQciyBUEANgIAQS1BLBANIQFByLIFKAIAIQBByLIFQQA2AgACQAJAAkAgAEEBRwRAQciyBUEANgIAQS1BMBANIQBByLIFKAIAIQNByLIFQQA2AgAgA0EBRg0BIAQgADYCICAEQqWAgICAhoCAgH83AiQgAEEAOgAlIABBkdkBKQAANwAdIABBjNkBKQAANwAYIABBhNkBKQAANwAQIABB/NgBKQAANwAIIABB9NgBKQAANwAAQciyBUEANgIAQTIgASAEQSBqQYfXAUHgAEGG2AEQEBpByLIFKAIAIQBByLIFQQA2AgBBASEDIABBAUcEQCACIAE2AgBByLIFQQA2AgBBMSACQaDaAEEAEBJByLIFKAIAIQBByLIFQQA2AgBBACEDIABBAUcNBgsQBiEAEAcaIAQsACtBf0wEQCAEKAIgEPYMCyADDQIMBAsQBiEAEAcaDAILEAYhABAHGgsgARD2DAsgAhATCyAAEAgLAAsgBEEwaiQACyEBAX4gACADELADIQQgACABIAIgAxCzAyAAIAQgAxCxAwuXDQIDfwN+IwBBIGsiAyQAAkACQAJAIAAtAFpBf2pB/wFxQQZNBEBBBBAOIQJByLIFQQA2AgBBLUEsEA0hAUHIsgUoAgAhAEHIsgVBADYCAAJAAkAgAEEBRwRAQciyBUEANgIAQS1BwAAQDSEAQciyBSgCACEEQciyBUEANgIAIARBAUYNASADIAA2AhAgA0K8gICAgIiAgIB/NwIUIABBADoAPCAAQdLZASgAADYAOCAAQcrZASkAADcAMCAAQcLZASkAADcAKCAAQbrZASkAADcAICAAQbLZASkAADcAGCAAQarZASkAADcAECAAQaLZASkAADcACCAAQZrZASkAADcAAEHIsgVBADYCAEEyIAEgA0EQakGH1wFBjgFB19kBEBAaQciyBSgCACEAQciyBUEANgIAQQEhBCAAQQFHBEAgAiABNgIAQciyBUEANgIAQTEgAkGg2gBBABASQciyBSgCACEAQciyBUEANgIAQQAhBCAAQQFHDQYLEAYhABAHGiADLAAbQX9MBEAgAygCEBD2DAsgBA0CDAQLEAYhABAHGiACEBMMAwsQBiEAEAcaCyABEPYMIAIQEwwBCyABRQ0CIAJFDQIgACgCRCIFBEAgACkDSCIGIAKtIgd8IAApA1AiCFYEfiAAIAcgCHxCAYYiBjcDUCAAIAUgBqcQ6gEiBTYCRCAAKQNIBSAGC6cgBWogASACEIANGiAAIAApA0ggB3w3A0gMAwsgACgCACIERQRAQQQQDiECQciyBUEANgIAQS1BLBANIQFByLIFKAIAIQBByLIFQQA2AgACQAJAIABBAUcEQEHIsgVBADYCAEEtQSAQDSEAQciyBSgCACEEQciyBUEANgIAIARBAUYNASADIAA2AhAgA0KWgICAgISAgIB/NwIUIABBADoAFiAAQf7WASkAADcADiAAQfjWASkAADcACCAAQfDWASkAADcAAEHIsgVBADYCAEEyIAEgA0EQakGH1wFBoAFB19kBEBAaQciyBSgCACEAQciyBUEANgIAQQEhBCAAQQFHBEAgAiABNgIAQciyBUEANgIAQTEgAkGg2gBBABASQciyBSgCACEAQciyBUEANgIAQQAhBCAAQQFHDQYLEAYhABAHGiADLAAbQX9MBEAgAygCEBD2DAsgBA0CDAQLEAYhABAHGiACEBMMAwsQBiEAEAcaCyABEPYMIAIQEwwBCyAEIAEgAq0iBiADQQhqQgAgBCgCACgCFBEQAARAQQQQDiECQciyBUEANgIAQS1BMBANIQFByLIFKAIAIQBByLIFQQA2AgACQAJAIABBAUcEQEHIsgVBADYCAEEtQRAQDSEAQciyBSgCACEEQciyBUEANgIAIARBAUYNASADIAA2AhAgA0KMgICAgIKAgIB/NwIUIABBADoADCAAQerZASgAADYACCAAQeLZASkAADcAAEHIsgVBADYCAEGoqgUoAgAhBUHIsgUoAgAhAEHIsgVBADYCAEEBIQQCQCAAQQFGDQBByLIFQQA2AgBBMCABIANBEGogBUGH1wFBowFB19kBEBYaQciyBSgCACEAQciyBUEANgIAIABBAUYNACACIAE2AgBBACEEQciyBUEANgIAQTEgAkGs3QBBABASQciyBSgCACEAQciyBUEANgIAIABBAUcNBgsQBiEAEAcaIAMsABtBf0wEQCADKAIQEPYMCyAEDQIMBAsQBiEAEAcaIAIQEwwDCxAGIQAQBxoLIAEQ9gwgAhATDAELIAMpAwggBlENAkEEEA4hAkHIsgVBADYCAEEtQSwQDSEBQciyBSgCACEAQciyBUEANgIAAkACQAJAIABBAUcEQEHIsgVBADYCAEEtQSAQDSEAQciyBSgCACEEQciyBUEANgIAIARBAUYNASADIAA2AhAgA0KVgICAgISAgIB/NwIUIABBADoAFSAAQfzZASkAADcADSAAQffZASkAADcACCAAQe/ZASkAADcAAEHIsgVBADYCAEEyIAEgA0EQakGH1wFBpQFB19kBEBAaQciyBSgCACEAQciyBUEANgIAQQEhBCAAQQFHBEAgAiABNgIAQciyBUEANgIAQTEgAkGg2gBBABASQciyBSgCACEAQciyBUEANgIAQQAhBCAAQQFHDQYLEAYhABAHGiADLAAbQX9MBEAgAygCEBD2DAsgBA0CDAQLEAYhABAHGgwCCxAGIQAQBxoLIAEQ9gwLIAIQEwsgABAICwALIANBIGokAAsrAQF/IwBBEGsiASQAIAAgAUEPakEBQQAQswMgAS0ADyEAIAFBEGokACAACz0BAX8jAEEQayIBJAAgACABQQ5qQQJBABCzAyABLwAOIQAgAUEQaiQAIABBCHRBgID8B3EgAEEYdHJBEHYLRQEDfyMAQRBrIgEkACAAIAFBDWpBA0EAELMDIAEtAA0hACABLQAOIQIgAS0ADyEDIAFBEGokACADIAJBCHQgAEEQdHJyC0sBAX8jAEEQayIBJAAgACABQQxqQQRBABCzAyABKAAMIQAgAUEQaiQAIABBCHRBgID8B3EgAEEYdHIgAEEIdkGA/gNxIABBGHZycguIAQIBfwF+IwBBEGsiASQAIAAgAUEIakEIQQAQswMgASkACCECIAFBEGokACACQiiGQoCAgICAgMD/AIMgAkI4hoQgAkIYhkKAgICAgOA/gyACQgiGQoCAgIDwH4OEhCACQgiIQoCAgPgPgyACQhiIQoCA/AeDhCACQiiIQoD+A4MgAkI4iISEhAsnAQF/IwBBEGsiAiQAIAIgAToADyAAIAJBD2pBARC1AyACQRBqJAALMwEBfyMAQRBrIgIkACACIAFBGHQgAUEIdHJBEHY7AA4gACACQQ5qQQIQtQMgAkEQaiQACzsBAX8jAEEQayICJAAgAiABOgAPIAIgAUEIdjoADiACIAFBEHY6AA0gACACQQ1qQQMQtQMgAkEQaiQAC0cBAX8jAEEQayICJAAgAiABQQh0QYCA/AdxIAFBGHRyIAFBCHZBgP4DcSABQRh2cnI2AAwgACACQQxqQQQQtQMgAkEQaiQAC4IBAQF/IwBBEGsiAiQAIAIgAUIohkKAgICAgIDA/wCDIAFCOIaEIAFCGIZCgICAgIDgP4MgAUIIhkKAgICA8B+DhIQgAUIIiEKAgID4D4MgAUIYiEKAgPwHg4QgAUIoiEKA/gODIAFCOIiEhIQ3AAggACACQQhqQQgQtQMgAkEQaiQAC0sBAn8jAEEQayIBJAAgACABQQ5qQQFBABCzAyABLQAOIQIgACABQQ9qQQFBABCzAyABLQAPIQAgAUEQaiQAIACzQwAAgDuUIAKzkguuCAEJfyMAQbABayICJAACQAJAAkAgAUMAAIBDYEEBc0UEQCACQeg+NgJgIAJB1D42AihByLIFQQA2AgBBKSACQeAAaiIFIAJBKGpBBHIiAxAFQciyBSgCACEAQciyBUEANgIAIABBAUYNASACQoCAgIBwNwOoASACQbA+NgJgIAJBnD42AihByLIFQQA2AgBBKiADEA0hCEHIsgUoAgAhAEHIsgVBADYCACAAQQFGBEAQBiEAEAcaDAQLIAJCADcCTCACQgA3AlQgAkEQNgJcIAJBzD82AixByLIFQQA2AgBBlAMgAkEoaiABECMhBEHIsgUoAgAhAEHIsgVBADYCAAJAAkACQAJAAkACQAJAAkACQCAAQQFGDQBByLIFQQA2AgBBKyAEQYXaAUENEBQaQciyBSgCACEAQciyBUEANgIAIABBAUYNAEEEEA4hBEHIsgVBADYCAEEtQTAQDSEHQciyBSgCACEAQciyBUEANgIAIABBAUYNAUHIsgVBADYCAEEuIAJBCGogAxAFQciyBSgCACEAQciyBUEANgIAIABBAUYNAiACKAIIIAJBCGogAiwAE0EASBsiAxCIDSIAQXBPBEBByLIFQQA2AgBBLyACQRhqEA9ByLIFKAIAIQBByLIFQQA2AgAgAEEBRg0EDAwLAkACQCAAQQtPBEBByLIFQQA2AgBBLSAAQRBqQXBxIgkQDSEGQciyBSgCACEKQciyBUEANgIAIApBAUYNBiACIAY2AhggAiAANgIcIAIgCUGAgICAeHI2AiAMAQsgAiAAOgAjIAJBGGohBiAARQ0BCyAGIAMgABCADRoLIAAgBmpBADoAAEHIsgVBADYCAEEwIAcgAkEYakHEAEGH1wFBngJBk9oBEBYaQciyBSgCACEAQciyBUEANgIAQQEhAyAAQQFHBEAgBCAHNgIAQciyBUEANgIAQTEgBEGs3QBBABASQciyBSgCACEAQciyBUEANgIAQQAhAyAAQQFHDQwLEAYhABAHGiACLAAjQX9MBEAgAigCGBD2DAsgAiwAE0EASA0EDAULEAYhABAHGgwHCxAGIQAQBxoMBQsQBiEAEAcaDAMLEAYhABAHGkEBIQMgAiwAE0EATg0CCyACKAIIEPYMCyADRQ0CCyAHEPYMCyAEEBMLIAJBsD42AmAgAkGcPjYCKCACQcw/NgIsIAIsAFdBf0wEQCACKAJMEPYMCyAIEOAGGiAFENwGIAAQCAALIAICfyABQwAAgE9dIAFDAAAAAGBxBEAgAakMAQtBAAsiBToAKCAAIAJBKGpBARC1AyACAn8gASAFs5NDAACAQ5QiAUMAAIBPXSABQwAAAABgcQRAIAGpDAELQQALOgAoIAAgAkEoakEBELUDIAJBsAFqJAAPCxAGIQAQBxoMAQsACyAFENwGIAAQCAALbwECfyMAQRBrIgEkACAAIAFBDmpBAkEAELMDIAEvAA4hAiAAIAFBDmpBAkEAELMDIAEvAA4hACABQRBqJAAgAEEIdEGAgPwHcSAAQRh0ckEQdrNDAACAN5QgAkEIdEGAgPwHcSACQRh0ckEQdrOSC8gIAQl/IwBBsAFrIgMkAAJAAkACQCABQwAAgEdgQQFzRQRAIANB6D42AmAgA0HUPjYCKEHIsgVBADYCAEEpIANB4ABqIgAgA0EoakEEciIEEAVByLIFKAIAIQJByLIFQQA2AgAgAkEBRg0BIANCgICAgHA3A6gBIANBsD42AmAgA0GcPjYCKEHIsgVBADYCAEEqIAQQDSEIQciyBSgCACECQciyBUEANgIAIAJBAUYEQBAGIQIQBxoMBAsgA0IANwJMIANCADcCVCADQRA2AlwgA0HMPzYCLEHIsgVBADYCAEGUAyADQShqIAEQIyEFQciyBSgCACECQciyBUEANgIAAkACQAJAAkACQAJAAkACQAJAIAJBAUYNAEHIsgVBADYCAEErIAVBhdoBQQ0QFBpByLIFKAIAIQJByLIFQQA2AgAgAkEBRg0AQQQQDiEFQciyBUEANgIAQS1BMBANIQdByLIFKAIAIQJByLIFQQA2AgAgAkEBRg0BQciyBUEANgIAQS4gA0EIaiAEEAVByLIFKAIAIQJByLIFQQA2AgAgAkEBRg0CIAMoAgggA0EIaiADLAATQQBIGyIEEIgNIgJBcE8EQEHIsgVBADYCAEEvIANBGGoQD0HIsgUoAgAhAkHIsgVBADYCACACQQFGDQQMDAsCQAJAIAJBC08EQEHIsgVBADYCAEEtIAJBEGpBcHEiCRANIQZByLIFKAIAIQpByLIFQQA2AgAgCkEBRg0GIAMgBjYCGCADIAI2AhwgAyAJQYCAgIB4cjYCIAwBCyADIAI6ACMgA0EYaiEGIAJFDQELIAYgBCACEIANGgsgAiAGakEAOgAAQciyBUEANgIAQTAgByADQRhqQcQAQYfXAUG1AkGg2gEQFhpByLIFKAIAIQJByLIFQQA2AgBBASEEIAJBAUcEQCAFIAc2AgBByLIFQQA2AgBBMSAFQazdAEEAEBJByLIFKAIAIQJByLIFQQA2AgBBACEEIAJBAUcNDAsQBiECEAcaIAMsACNBf0wEQCADKAIYEPYMCyADLAATQQBIDQQMBQsQBiECEAcaDAcLEAYhAhAHGgwFCxAGIQIQBxoMAwsQBiECEAcaQQEhBCADLAATQQBODQILIAMoAggQ9gwLIARFDQILIAcQ9gwLIAUQEwsgA0GwPjYCYCADQZw+NgIoIANBzD82AiwgAywAV0F/TARAIAMoAkwQ9gwLIAgQ4AYaIAAQ3AYgAhAIAAsgAwJ/IAFDAACAT10gAUMAAAAAYHEEQCABqQwBC0EACyICQRh0IAJBCHRyQRB2OwAoIAAgA0EoakECELUDIAMCfyABIAKzk0MAAIBHlCIBQwAAgE9dIAFDAAAAAGBxBEAgAakMAQtBAAsiAkEYdCACQQh0ckEQdjsAKCAAIANBKGpBAhC1AyADQbABaiQADwsQBiECEAcaDAELAAsgABDcBiACEAgAC0wBAX8jAEEQayIBJAAgACABQQxqQQRBABCzAyABKAAMIQAgAUEQaiQAIABBCHRBgID8B3EgAEEYdHIgAEEIdkGA/gNxIABBGHZycr4LSgECfyMAQRBrIgIkACACIAG8IgNBGHQgA0EIdEGAgPwHcXIgA0EIdkGA/gNxIANBGHZycjYADCAAIAJBDGpBBBC1AyACQRBqJAALVgEEf0HAACEDQcAAEOMBIQIDQAJAIAEgA0cNACACIAFBAXQiAxDqASICDQBBAA8LIAAgASACaiIEQQFBABCzAyABQQFqIQEgBC0AAA0ACyACIAEQ6gELQQEBfyMAQRBrIgIkAAJAIAFFBEAgAkEAOgAPIAAgAkEPakEBELUDDAELIAAgASABEIgNQQFqELUDCyACQRBqJAAL9AQBA38jAEEgayIFJAACQCACBEBBACECA0AgACAFQRBqQQFBABCzAyACQRlGBEBBBBAOIQJByLIFQQA2AgBBLUEwEA0hBkHIsgUoAgAhBEHIsgVBADYCAAJAAkACQAJAAkAgBEEBRwRAQciyBUEANgIAQS1BMBANIQRByLIFKAIAIQBByLIFQQA2AgAgAEEBRg0BIAUgBDYCECAFQqCAgICAhoCAgH83AhQgBEEAOgAgIARBxdoBKQAANwAYIARBvdoBKQAANwAQIARBtdoBKQAANwAIIARBrdoBKQAANwAAQciyBUEANgIAQTAgBiAFQRBqQcQAQYfXAUGAA0HO2gEQFhpByLIFKAIAIQRByLIFQQA2AgBBASEAIARBAUYNAiACIAY2AgBByLIFQQA2AgBBMSACQazdAEEAEBJByLIFKAIAIQRByLIFQQA2AgBBACEAIARBAUYNAgALEAYhBBAHGgwDCxAGIQQQBxoMAQsQBiEEEAcaIAUsABtBf0wEQCAFKAIQEPYMCyAARQ0CCyAGEPYMCyACEBMLIAQQCAALIAQgBS0AECIGaiEEIAJBAWohAiAGQf8BRg0ACwwBCyAAIAVBEGpBAUEAELMDIAUtABAhBAsCQCADRQ0AIAQgA0F/aiICTQ0AIAVBkAM2AgggBUGH1wE2AgQgBUHg2gE2AgBBwIwEQZDYASAFELoBIAIhBAsgASAEbCICQQFqEOMBIQQgAgRAIAAgBCACQQAQswMLIAIgBGpBADoAAAJAIANFDQAgAkF/cyADakH/AXEiAkUNACAAIAIQ9QwiBiACQQAQswMgBhD2DAsgBUEgaiQAIAQL/AgBBX8jAEGwAWsiBSQAIAEEfyAEQX9qIgYgARCIDSIHIAYgB0kbBUEACyIGIAJuIQICQAJAAkACQCADBEAgAkH/AU8EQANAIAVB/wE6ACAgACAFQSBqQQEQtQMgAkGBfmoiAkH+AUsNAAsLIAUgAjoAICAAIAVBIGpBARC1AwwBCyACQYACTwRAIAVB6D42AlggBUHUPjYCIEHIsgVBADYCAEEpIAVB2ABqIgAgBUEgakEEciIBEAVByLIFKAIAIQZByLIFQQA2AgAgBkEBRg0CIAVCgICAgHA3A6ABIAVBsD42AlggBUGcPjYCIEHIsgVBADYCAEEqIAEQDSEEQciyBSgCACEGQciyBUEANgIAIAZBAUYEQBAGIQYQBxoMBQsgBUIANwJEIAVCADcCTCAFQRA2AlQgBUHMPzYCJEHIsgVBADYCAEErIAVBIGpB/doBQQoQFCEDQciyBSgCACEGQciyBUEANgIAAkACQAJAAkACQAJAAkACQAJAIAZBAUYNAEHIsgVBADYCAEEsIAMgAhAVGkHIsgUoAgAhBkHIsgVBADYCACAGQQFGDQBBBBAOIQJByLIFQQA2AgBBLUEwEA0hA0HIsgUoAgAhBkHIsgVBADYCACAGQQFGDQFByLIFQQA2AgBBLiAFIAEQBUHIsgUoAgAhBkHIsgVBADYCACAGQQFGDQIgBSgCACAFIAUsAAtBAEgbIgEQiA0iBkFwTwRAQciyBUEANgIAQS8gBUEQahAPQciyBSgCACEGQciyBUEANgIAIAZBAUYNBAwNCwJAAkAgBkELTwRAQciyBUEANgIAQS0gBkEQakFwcSIIEA0hB0HIsgUoAgAhCUHIsgVBADYCACAJQQFGDQYgBSAHNgIQIAUgBjYCFCAFIAhBgICAgHhyNgIYDAELIAUgBjoAGyAFQRBqIQcgBkUNAQsgByABIAYQgA0aCyAGIAdqQQA6AABByLIFQQA2AgBBMCADIAVBEGpBxABBh9cBQcUDQYjbARAWGkHIsgUoAgAhBkHIsgVBADYCAEEBIQEgBkEBRwRAIAIgAzYCAEHIsgVBADYCAEExIAJBrN0AQQAQEkHIsgUoAgAhBkHIsgVBADYCAEEAIQEgBkEBRw0NCxAGIQYQBxogBSwAG0F/TARAIAUoAhAQ9gwLIAUsAAtBAEgNBAwFCxAGIQYQBxoMBwsQBiEGEAcaDAULEAYhBhAHGgwDCxAGIQYQBxpBASEBIAUsAAtBAE4NAgsgBSgCABD2DAsgAUUNAgsgAxD2DAsgAhATCyAFQbA+NgJYIAVBnD42AiAgBUHMPzYCJCAFLABPQX9MBEAgBSgCRBD2DAsgBBDgBhogABDcBiAGEAgACyAFIAI6ACAgACAFQSBqQQEQtQMLIAYEQCAAIAEgBhC1AwsCQCAERQ0AIAVBADoArwEgBiAEQX9qIgJPDQADQCAAIAVBrwFqQQEQtQMgBkEBaiIGIAJHDQALCyAFQbABaiQADwsQBiEGEAcaDAELAAsgABDcBiAGEAgAC9UGAgN/AX4jAEEQayIDJAACQAJAIAFFBEBBBBAOIQBByLIFQQA2AgBBLUEsEA0hAUHIsgUoAgAhAkHIsgVBADYCAAJAAkAgAkEBRwRAQciyBUEANgIAQS1BIBANIQJByLIFKAIAIQRByLIFQQA2AgAgBEEBRg0BIAMgAjYCACADQp2AgICAhICAgH83AgQgAkEAOgAdIAJBsNsBKQAANwAVIAJBq9sBKQAANwAQIAJBo9sBKQAANwAIIAJBm9sBKQAANwAAQciyBUEANgIAQTIgASADQYfXAUHcA0G52wEQEBpByLIFKAIAIQJByLIFQQA2AgBBASEEIAJBAUcEQCAAIAE2AgBByLIFQQA2AgBBMSAAQaDaAEEAEBJByLIFKAIAIQJByLIFQQA2AgBBACEEIAJBAUcNBgsQBiECEAcaIAMsAAtBf0wEQCADKAIAEPYMCyAEDQIMBAsQBiECEAcaIAAQEwwDCxAGIQIQBxoLIAEQ9gwgABATDAELIAFBwABNBEAgAEHZAGohBCAALQBYIQIDQCAAIAJB/wFxBH8gAgUgACAEQQFBABCzAyAAQQg6AFhBCAtBf2oiAjoAWCAALQBZIAJB/wFxdkEBca0gBUIBhoQhBSABQX9qIgFB/wFxDQALIANBEGokACAFDwtBBBAOIQBByLIFQQA2AgBBLUEsEA0hAUHIsgUoAgAhAkHIsgVBADYCAAJAAkACQCACQQFHBEBByLIFQQA2AgBBLUEgEA0hAkHIsgUoAgAhBEHIsgVBADYCACAEQQFGDQEgAyACNgIAIANCn4CAgICEgICAfzcCBCACQQA6AB8gAkHZ2wEpAAA3ABcgAkHS2wEpAAA3ABAgAkHK2wEpAAA3AAggAkHC2wEpAAA3AABByLIFQQA2AgBBMiABIANBh9cBQd0DQbnbARAQGkHIsgUoAgAhAkHIsgVBADYCAEEBIQQgAkEBRwRAIAAgATYCAEHIsgVBADYCAEExIABBoNoAQQAQEkHIsgUoAgAhAkHIsgVBADYCAEEAIQQgAkEBRw0GCxAGIQIQBxogAywAC0F/TARAIAMoAgAQ9gwLIAQNAgwECxAGIQIQBxoMAgsQBiECEAcaCyABEPYMCyAAEBMLIAIQCAsAC6IEAgR/An4jAEEQayIFJAAgAkHAAE0EQCACBEAgAEHbAGohBiAALQBbIQQgAC0AWiEDIAKtIQcDQCAAIANBAWoiAzoAWiAAIAQgASAHQn98IghC/////w+DiEIBg0IIIAOtQv8Bg31C/////w+DhqdyIgQ6AFsgA0H/AXFBCEYEQEEAIQQgACAGQQEQtQMgAEEAOwFaQQAhAwsgB6chAiAIIQcgAkH/AXFBAUcNAAsLIAVBEGokAA8LQQQQDiEDQciyBUEANgIAQS1BLBANIQRByLIFKAIAIQBByLIFQQA2AgACQAJAAkACQAJAIABBAUcEQEHIsgVBADYCAEEtQSAQDSEAQciyBSgCACECQciyBUEANgIAIAJBAUYNASAFIAA2AgAgBUKfgICAgISAgIB/NwIEIABBADoAHyAAQdnbASkAADcAFyAAQdLbASkAADcAECAAQcrbASkAADcACCAAQcLbASkAADcAAEHIsgVBADYCAEEyIAQgBUGH1wFB9ANB4tsBEBAaQciyBSgCACEAQciyBUEANgIAQQEhAiAAQQFHBEAgAyAENgIAQciyBUEANgIAQTEgA0Gg2gBBABASQciyBSgCACEAQciyBUEANgIAQQAhAiAAQQFHDQYLEAYhABAHGiAFLAALQX9MBEAgBSgCABD2DAsgAg0CDAQLEAYhABAHGgwCCxAGIQAQBxoLIAQQ9gwLIAMQEwsgABAICwALVwEEfyMAQRBrIgEkAANAAkAgACABQQ9qQQFBABCzAyABLQAPIgRB/wBxIANBB3RyIQMgAkH/AXFBAksNACACQQFqIQIgBEGAAXENAQsLIAFBEGokACADC/gHAQh/IwBBsAFrIgMkAAJAAkACQCABQYCAgIABTwRAIANB6D42AmAgA0HUPjYCKEHIsgVBADYCAEEpIANB4ABqIgQgA0EoakEEciIAEAVByLIFKAIAIQJByLIFQQA2AgAgAkEBRg0BIANCgICAgHA3A6gBIANBsD42AmAgA0GcPjYCKEHIsgVBADYCAEEqIAAQDSEHQciyBSgCACECQciyBUEANgIAIAJBAUYEQBAGIQIQBxoMBAsgA0IANwJMIANCADcCVCADQRA2AlwgA0HMPzYCLEHIsgVBADYCAEErIANBKGpB7NsBQQ4QFCEFQciyBSgCACECQciyBUEANgIAAkACQAJAAkACQAJAAkACQAJAIAJBAUYNAEHIsgVBADYCAEEsIAUgARAVGkHIsgUoAgAhAkHIsgVBADYCACACQQFGDQBBBBAOIQFByLIFQQA2AgBBLUEwEA0hBUHIsgUoAgAhAkHIsgVBADYCACACQQFGDQFByLIFQQA2AgBBLiADQQhqIAAQBUHIsgUoAgAhAkHIsgVBADYCACACQQFGDQIgAygCCCADQQhqIAMsABNBAEgbIgAQiA0iAkFwTwRAQciyBUEANgIAQS8gA0EYahAPQciyBSgCACECQciyBUEANgIAIAJBAUYNBAwMCwJAAkAgAkELTwRAQciyBUEANgIAQS0gAkEQakFwcSIIEA0hBkHIsgUoAgAhCUHIsgVBADYCACAJQQFGDQYgAyAGNgIYIAMgAjYCHCADIAhBgICAgHhyNgIgDAELIAMgAjoAIyADQRhqIQYgAkUNAQsgBiAAIAIQgA0aCyACIAZqQQA6AABByLIFQQA2AgBBMCAFIANBGGpBxABBh9cBQaQEQfvbARAWGkHIsgUoAgAhAkHIsgVBADYCAEEBIQAgAkEBRwRAIAEgBTYCAEHIsgVBADYCAEExIAFBrN0AQQAQEkHIsgUoAgAhAkHIsgVBADYCAEEAIQAgAkEBRw0MCxAGIQIQBxogAywAI0F/TARAIAMoAhgQ9gwLIAMsABNBAEgNBAwFCxAGIQIQBxoMBwsQBiECEAcaDAULEAYhAhAHGgwDCxAGIQIQBxpBASEAIAMsABNBAE4NAgsgAygCCBD2DAsgAEUNAgsgBRD2DAsgARATCyADQbA+NgJgIANBnD42AiggA0HMPzYCLCADLABXQX9MBEAgAygCTBD2DAsgBxDgBhogBBDcBiACEAgAC0EEIQIDQCACQQFKIQQgAyABIAJBf2oiAkEHbHZB/wBxIARBB3RyOgAoIAAgA0EoakEBELUDIAQNAAsgA0GwAWokAA8LEAYhAhAHGgwBCwALIAQQ3AYgAhAIAAub5gMBA39B35MEQQM6AABB0JMEQQE2AgBB65MEQQQ6AABB+5MEQQM6AABB7JMEQQI2AgBB4JMEQcHMhZMHNgIAQYeUBEEJOgAAQdSTBEGL3AEvAAA7AQBB1pMEQY3cAS0AADoAAEHwkwRBj9wBLwAAOwEAQfKTBEGR3AEtAAA6AABB15MEQQA6AABB5JMEQQA6AABB85MEQQA6AABBiJQEQQM2AgBBl5QEQQM6AABBo5QEQQg6AABBmJQEQsHGocvmrdm55QA3AwBBpJQEQQQ2AgBBs5QEQQM6AABBhJQEQZvcAS0AADoAAEH8kwRBk9wBKQAANwIAQYyUBEGd3AEvAAA7AQBBjpQEQZ/cAS0AADoAAEGqlARBo9wBLQAAOgAAQaiUBEGh3AEvAAA7AQBBhZQEQQA6AABBj5QEQQA6AABBoJQEQQA6AABBv5QEQQU6AABBq5QEQQA6AABBuJQEQancAS0AADoAAEG0lARBpdwBKAAANgIAQc+UBEEDOgAAQcCUBEEFNgIAQbmUBEEAOgAAQcaUBEGt3AEtAAA6AABBxJQEQavcAS8AADsBAEHblARBBzoAAEHHlARBADoAAEHTlARBstwBKAAANgAAQdCUBEGv3AEoAAA2AgBB65QEQQM6AABB3JQEQQY2AgBB15QEQQA6AABB4pQEQbncAS0AADoAAEHglARBt9wBLwAAOwEAQeOUBEEAOgAAQciyBUEANgIAQS1BEBANIQBByLIFKAIAIQFByLIFQQA2AgACfwJAAkACQAJAAkACQAJAAkACQAJAAkACQAJAAkACQAJAAkACQAJAAkACQAJAAkACQAJAAkACQAJAAkACQAJAAkACQAJAAkACQAJAAkACQAJAAkACQAJAAkACQAJAAkACQAJAAkACQAJAAkACQAJAAkACQAJAAkACQAJAAkACQAJAAkACQAJAAkACQAJAAkACQAJAAkACQAJAAkACQAJAAkACQAJAAkACQAJAAkACQAJAAkACQAJAAkACQAJAAkACQAJAAkACQAJAAkACQAJAAkACQAJAAkACQAJAAkACQAJAAkACQAJAAkACQAJAAkACQAJAAkACQAJAAkACQAJAAkACQAJAAkACQAJAAkACQAJAAkACQAJAAkACQAJAAkACQAJAAkACQAJAAkACQAJAAkACQAJAAkACQAJAAkACQAJAAkACQAJAAkAgAUEBRwRAQeyUBCAANgIAQfCUBEKOgICAgIKAgIB/NwMAIABBADoADiAAQcHcASkAADcABiAAQbvcASkAADcAAEGHlQRBAzoAAEH4lARBBzYCAEH8lARBytwBLwAAOwEAQf6UBEHM3AEtAAA6AABB/5QEQQA6AABByLIFQQA2AgBBLUEgEA0hAEHIsgUoAgAhAUHIsgVBADYCACABQQFGDQFBiJUEIAA2AgBBjJUEQpSAgICAhICAgH83AgAgAEEAOgAUIABB3twBKAAANgAQIABB1twBKQAANwAIIABBztwBKQAANwAAQaOVBEEDOgAAQZSVBEEINgIAQa+VBEEIOgAAQb+VBEEDOgAAQbCVBEEJNgIAQaSVBELBzMnLhq2atukANwIAQcuVBEEJOgAAQZiVBEHj3AEvAAA7AQBBmpUEQeXcAS0AADoAAEG0lQRB59wBLwAAOwEAQbaVBEHp3AEtAAA6AABByJUEQfPcAS0AADoAAEHAlQRB69wBKQAANwMAQZuVBEEAOgAAQayVBEEAOgAAQbeVBEEAOgAAQduVBEEDOgAAQcyVBEEKNgIAQeeVBEEEOgAAQdyVBEHB0rmrBzYCAEHolQRBCzYCAEH3lQRBAzoAAEGDlgRBBDoAAEHQlQRB9dwBLwAAOwEAQdKVBEH33AEtAAA6AABB7JUEQfncAS8AADsBAEHulQRB+9wBLQAAOgAAQcmVBEEAOgAAQdOVBEEAOgAAQeCVBEEAOgAAQe+VBEEAOgAAQZOWBEEDOgAAQYSWBEEMNgIAQfiVBEHB1oXzBjYCAEH8lQRBADoAAEGKlgRB/9wBLQAAOgAAQYiWBEH93AEvAAA7AQBBn5YEQQg6AABBi5YEQQA6AABBr5YEQQM6AABBoJYEQQ02AgBBlJYEQsHWrYvGrNqw7gA3AgBBnJYEQQA6AABBppYEQYPdAS0AADoAAEGklgRBgd0BLwAAOwEAQbuWBEEIOgAAQaeWBEEAOgAAQcuWBEEDOgAAQbyWBEEONgIAQbCWBELB2ImL5q3asO4ANwMAQbiWBEEAOgAAQcKWBEGH3QEtAAA6AABBwJYEQYXdAS8AADsBAEHXlgRBBToAAEHDlgRBADoAAEHQlgRBjd0BLQAAOgAAQcyWBEGJ3QEoAAA2AgBB55YEQQM6AABB2JYEQQ82AgBB0ZYEQQA6AABB3pYEQZHdAS0AADoAAEHclgRBj90BLwAAOwEAQd+WBEEAOgAAQciyBUEANgIAQS1BIBANIQBByLIFKAIAIQFByLIFQQA2AgAgAUEBRg0CQeiWBCAANgIAQeyWBEKUgICAgISAgIB/NwIAIABBADoAFCAAQaPdASgAADYAECAAQZvdASkAADcACCAAQZPdASkAADcAAEGDlwRBAzoAAEH0lgRBEDYCAEH4lgRBqN0BLwAAOwEAQfqWBEGq3QEtAAA6AABB+5YEQQA6AABByLIFQQA2AgBBLUEQEA0hAEHIsgUoAgAhAUHIsgVBADYCACABQQFGDQNBhJcEIAA2AgBBiJcEQo6AgICAgoCAgH83AwAgAEEAOgAOIABBst0BKQAANwAGIABBrN0BKQAANwAAQZ+XBEEDOgAAQZCXBEERNgIAQauXBEEHOgAAQbuXBEEDOgAAQayXBEESNgIAQZSXBEG73QEvAAA7AQBBlpcEQb3dAS0AADoAAEGglwRBv90BKAAANgIAQaOXBEHC3QEoAAA2AABBsJcEQcfdAS8AADsBAEGylwRByd0BLQAAOgAAQZeXBEEAOgAAQaeXBEEAOgAAQciyBUEANgIAQbOXBEEAOgAAQS1BIBANIQBByLIFKAIAIQFByLIFQQA2AgAgAUEBRg0EQbyXBCAANgIAQcCXBEKagICAgISAgIB/NwMAIABBADoAGiAAQePdAS8AADsAGCAAQdvdASkAADcAECAAQdPdASkAADcACCAAQcvdASkAADcAAEHXlwRBAzoAAEHIlwRBEzYCAEHjlwRBBjoAAEHzlwRBAzoAAEHklwRBFDYCAEHMlwRB5t0BLwAAOwEAQc6XBEHo3QEtAAA6AABB2JcEQerdASgAADYCAEHclwRB7t0BLwAAOwEAQeiXBEHx3QEvAAA7AQBB6pcEQfPdAS0AADoAAEHPlwRBADoAAEHelwRBADoAAEHIsgVBADYCAEHrlwRBADoAAEEtQSAQDSEAQciyBSgCACEBQciyBUEANgIAIAFBAUYNBUH0lwQgADYCAEH4lwRCkICAgICEgICAfzcDACAAQQA6ABAgAEH93QEpAAA3AAggAEH13QEpAAA3AABBj5gEQQM6AABBgJgEQRU2AgBBm5gEQQY6AABBq5gEQQM6AABBnJgEQRY2AgBBhJgEQYbeAS8AADsBAEGGmARBiN4BLQAAOgAAQZCYBEGK3gEoAAA2AgBBlJgEQY7eAS8AADsBAEGgmARBkd4BLwAAOwEAQaKYBEGT3gEtAAA6AABBh5gEQQA6AABBlpgEQQA6AABByLIFQQA2AgBBo5gEQQA6AABBLUHAABANIQBByLIFKAIAIQFByLIFQQA2AgAgAUEBRg0GQayYBCAANgIAQbCYBEK+gICAgIiAgIB/NwMAIABBADoAPiAAQcveASkAADcANiAAQcXeASkAADcAMCAAQb3eASkAADcAKCAAQbXeASkAADcAICAAQa3eASkAADcAGCAAQaXeASkAADcAECAAQZ3eASkAADcACCAAQZXeASkAADcAAEHHmARBAzoAAEG4mARBFzYCAEHTmARBCToAAEHjmARBAzoAAEHUmARBGDYCAEG8mARB1N4BLwAAOwEAQb6YBEHW3gEtAAA6AABByJgEQdjeASkAADcDAEHQmARB4N4BLQAAOgAAQdiYBEHi3gEvAAA7AQBB2pgEQeTeAS0AADoAAEG/mARBADoAAEHRmARBADoAAEHvmARBCDoAAEHkmARCweS1q+at2rDuADcCAEHwmARBGTYCAEH/mARBAzoAAEH0mARB5t4BLwAAOwEAQfaYBEHo3gEtAAA6AABB25gEQQA6AABB7JgEQQA6AABB95gEQQA6AABByLIFQQA2AgBBLUEgEA0hAEHIsgUoAgAhAUHIsgVBADYCACABQQFGDQdBgJkEIAA2AgBBhJkEQpOAgICAhICAgH83AgAgAEEAOgATIABB+d4BKAAANgAPIABB8t4BKQAANwAIIABB6t4BKQAANwAAQZuZBEEDOgAAQYyZBEEaNgIAQaeZBEEHOgAAQbeZBEEDOgAAQaiZBEEbNgIAQZCZBEH+3gEvAAA7AQBBkpkEQYDfAS0AADoAAEGcmQRBgt8BKAAANgIAQZ+ZBEGF3wEoAAA2AABBrJkEQYrfAS8AADsBAEGumQRBjN8BLQAAOgAAQZOZBEEAOgAAQaOZBEEAOgAAQciyBUEANgIAQa+ZBEEAOgAAQS1BIBANIQBByLIFKAIAIQFByLIFQQA2AgAgAUEBRg0IQbiZBCAANgIAQbyZBEKSgICAgISAgIB/NwIAIABBADoAEiAAQZ7fAS8AADsAECAAQZbfASkAADcACCAAQY7fASkAADcAAEHTmQRBAzoAAEHEmQRBHDYCAEHfmQRBBjoAAEHvmQRBAzoAAEHgmQRBHTYCAEHImQRBod8BLwAAOwEAQcqZBEGj3wEtAAA6AABB1JkEQaXfASgAADYCAEHYmQRBqd8BLwAAOwAAQeSZBEGs3wEvAAA7AQBB5pkEQa7fAS0AADoAAEHLmQRBADoAAEHamQRBADoAAEH7mQRBCDoAAEHwmQRCwebNi9at2bnlADcDAEH8mQRBHjYCAEGLmgRBAzoAAEGAmgRBsN8BLwAAOwEAQYKaBEGy3wEtAAA6AABB55kEQQA6AABB+JkEQQA6AABBg5oEQQA6AABByLIFQQA2AgBBLUEwEA0hAEHIsgUoAgAhAUHIsgVBADYCACABQQFGDQlBjJoEIAA2AgBBkJoEQqaAgICAhoCAgH83AwAgAEEAOgAmIABB0t8BKQAANwAeIABBzN8BKQAANwAYIABBxN8BKQAANwAQIABBvN8BKQAANwAIIABBtN8BKQAANwAAQaeaBEEDOgAAQZiaBEEfNgIAQZyaBEHb3wEvAAA7AQBBnpoEQd3fAS0AADoAAEGfmgRBADoAAEHIsgVBADYCAEEtQSAQDSEAQciyBSgCACEBQciyBUEANgIAIAFBAUYNCkGomgQgADYCAEGsmgRClICAgICEgICAfzcCACAAQQA6ABQgAEHv3wEoAAA2ABAgAEHn3wEpAAA3AAggAEHf3wEpAAA3AABBw5oEQQM6AABBtJoEQSA2AgBBuJoEQfTfAS8AADsBAEG6mgRB9t8BLQAAOgAAQbuaBEEAOgAAQciyBUEANgIAQS1BIBANIQBByLIFKAIAIQFByLIFQQA2AgAgAUEBRg0LQcSaBCAANgIAQciaBEKUgICAgISAgIB/NwMAIABBADoAFCAAQYjgASgAADYAECAAQYDgASkAADcACCAAQfjfASkAADcAAEHfmgRBAzoAAEHQmgRBITYCAEHrmgRBBjoAAEH7mgRBAzoAAEHsmgRBIjYCAEHUmgRBjeABLwAAOwEAQdaaBEGP4AEtAAA6AABB4JoEQZHgASgAADYCAEHkmgRBleABLwAAOwEAQfCaBEGY4AEvAAA7AQBB8poEQZrgAS0AADoAAEHXmgRBADoAAEHmmgRBADoAAEGHmwRBBzoAAEGImwRBIzYCAEGXmwRBAzoAAEGjmwRBBjoAAEH8mgRBnOABKAAANgIAQf+aBEGf4AEoAAA2AABBjJsEQaTgAS8AADsBAEGOmwRBpuABLQAAOgAAQZibBEGo4AEoAAA2AgBBnJsEQazgAS8AADsBAEHzmgRBADoAAEGDmwRBADoAAEGPmwRBADoAAEGzmwRBAzoAAEGkmwRBJDYCAEGemwRBADoAAEGqmwRBseABLQAAOgAAQaibBEGv4AEvAAA7AQBBv5sEQQY6AABBq5sEQQA6AABBuJsEQbfgAS8AADsAAEG0mwRBs+ABKAAANgIAQc+bBEEDOgAAQcCbBEElNgIAQbqbBEEAOgAAQcabBEG84AEtAAA6AABBxJsEQbrgAS8AADsBAEHHmwRBADoAAEHIsgVBADYCAEEtQRAQDSEAQciyBSgCACEBQciyBUEANgIAIAFBAUYNDEHQmwQgADYCAEHUmwRCi4CAgICCgICAfzcCACAAQQA6AAsgAEHF4AEoAAA2AAcgAEG+4AEpAAA3AABB65sEQQM6AABB3JsEQSY2AgBB4JsEQcrgAS8AADsBAEHimwRBzOABLQAAOgAAQeObBEEAOgAAQciyBUEANgIAQS1BEBANIQBByLIFKAIAIQFByLIFQQA2AgAgAUEBRg0NQeybBCAANgIAQfCbBEKPgICAgIKAgIB/NwMAIABBADoADyAAQdXgASkAADcAByAAQc7gASkAADcAAEGHnARBAzoAAEH4mwRBJzYCAEH8mwRB3uABLwAAOwEAQf6bBEHg4AEtAAA6AABB/5sEQQA6AABByLIFQQA2AgBBLUEgEA0hAEHIsgUoAgAhAUHIsgVBADYCACABQQFGDQ5BiJwEIAA2AgBBjJwEQpKAgICAhICAgH83AgAgAEEAOgASIABB8uABLwAAOwAQIABB6uABKQAANwAIIABB4uABKQAANwAAQaOcBEEDOgAAQZScBEEoNgIAQa+cBEEHOgAAQb+cBEEDOgAAQbCcBEEpNgIAQZicBEH14AEvAAA7AQBBmpwEQffgAS0AADoAAEGknARB+eABKAAANgIAQaecBEH84AEoAAA2AABBtJwEQYHhAS8AADsBAEG2nARBg+EBLQAAOgAAQZucBEEAOgAAQaucBEEAOgAAQcucBEEHOgAAQcycBEEqNgIAQducBEEDOgAAQeecBEEHOgAAQcCcBEGF4QEoAAA2AgBBw5wEQYjhASgAADYAAEHQnARBjeEBLwAAOwEAQdKcBEGP4QEtAAA6AABB3JwEQZHhASgAADYCAEHfnARBlOEBKAAANgAAQbecBEEAOgAAQcecBEEAOgAAQdOcBEEAOgAAQfecBEEDOgAAQeicBEErNgIAQeOcBEEAOgAAQe6cBEGb4QEtAAA6AABB7JwEQZnhAS8AADsBAEGDnQRBCDoAAEHvnARBADoAAEGTnQRBAzoAAEGEnQRBLDYCAEH4nARCwsKxy+at2bnlADcDAEGAnQRBADoAAEGKnQRBn+EBLQAAOgAAQYidBEGd4QEvAAA7AQBBn50EQQY6AABBi50EQQA6AABBmJ0EQaXhAS8AADsAAEGUnQRBoeEBKAAANgIAQa+dBEEDOgAAQaCdBEEtNgIAQZqdBEEAOgAAQaadBEGq4QEtAAA6AABBpJ0EQajhAS8AADsBAEG7nQRBBDoAAEGnnQRBADoAAEHLnQRBAzoAAEG8nQRBLjYCAEGwnQRBwsLNiwY2AgBBtJ0EQQA6AABBwp0EQa7hAS0AADoAAEHAnQRBrOEBLwAAOwEAQcOdBEEAOgAAQciyBUEANgIAQS1BEBANIQBByLIFKAIAIQFByLIFQQA2AgAgAUEBRg0PQcydBCAANgIAQdCdBEKOgICAgIKAgIB/NwMAIABBADoADiAAQbbhASkAADcABiAAQbDhASkAADcAAEHnnQRBAzoAAEHYnQRBLzYCAEHcnQRBv+EBLwAAOwEAQd6dBEHB4QEtAAA6AABB350EQQA6AABByLIFQQA2AgBBLUEQEA0hAEHIsgUoAgAhAUHIsgVBADYCACABQQFGDRBB6J0EIAA2AgBB7J0EQo+AgICAgoCAgH83AgAgAEEAOgAPIABByuEBKQAANwAHIABBw+EBKQAANwAAQYOeBEEDOgAAQfSdBEEwNgIAQZ+eBEEDOgAAQZCeBEExNgIAQY6eBEGAFDsBAEGrngRBBToAAEH4nQRB0+EBLwAAOwEAQfqdBEHV4QEtAAA6AABBhJ4EQdfhASkAADcCAEGMngRB3+EBLwAAOwEAQZSeBEHi4QEvAAA7AQBBlp4EQeThAS0AADoAAEH7nQRBADoAAEGXngRBADoAAEGsngRBMjYCAEG7ngRBAzoAAEHHngRBBzoAAEHXngRBAzoAAEHIngRBMzYCAEGkngRB6uEBLQAAOgAAQaCeBEHm4QEoAAA2AgBBsJ4EQezhAS8AADsBAEGyngRB7uEBLQAAOgAAQbyeBEHw4QEoAAA2AgBBv54EQfPhASgAADYAAEGlngRBADoAAEGzngRBADoAAEHDngRBADoAAEHOngRB+uEBLQAAOgAAQcyeBEH44QEvAAA7AQBBz54EQQA6AABByLIFQQA2AgBBLUEQEA0hAEHIsgUoAgAhAUHIsgVBADYCACABQQFGDRFB2J4EIAA2AgBB3J4EQo6AgICAgoCAgH83AgAgAEEAOgAOIABBguIBKQAANwAGIABB/OEBKQAANwAAQfOeBEEDOgAAQeSeBEE0NgIAQf+eBEEIOgAAQY+fBEEDOgAAQYCfBEE1NgIAQfSeBELC0L3Thq6duekANwIAQZufBEEGOgAAQeieBEGL4gEvAAA7AQBB6p4EQY3iAS0AADoAAEGEnwRBj+IBLwAAOwEAQYafBEGR4gEtAAA6AABBlJ8EQZfiAS8AADsBAEGQnwRBk+IBKAAANgIAQeueBEEAOgAAQfyeBEEAOgAAQYefBEEAOgAAQaufBEEDOgAAQZyfBEE2NgIAQbefBEEFOgAAQbifBEE3NgIAQcefBEEDOgAAQaCfBEGa4gEvAAA7AQBBop8EQZziAS0AADoAAEGsnwRBnuIBKAAANgIAQbCfBEGi4gEtAAA6AABBvJ8EQaTiAS8AADsBAEG+nwRBpuIBLQAAOgAAQZafBEEAOgAAQaOfBEEAOgAAQbGfBEEAOgAAQdOfBEEJOgAAQb+fBEEAOgAAQdCfBEGw4gEtAAA6AABByJ8EQajiASkAADcDAEHjnwRBAzoAAEHUnwRBODYCAEHRnwRBADoAAEHanwRBtOIBLQAAOgAAQdifBEGy4gEvAAA7AQBB758EQQc6AABB258EQQA6AABB558EQbniASgAADYAAEHknwRBtuIBKAAANgIAQf+fBEEDOgAAQfCfBEE5NgIAQeufBEEAOgAAQfafBEHA4gEtAAA6AABB9J8EQb7iAS8AADsBAEGLoARBBzoAAEH3nwRBADoAAEGDoARBxeIBKAAANgAAQYCgBEHC4gEoAAA2AgBBm6AEQQM6AABBjKAEQTo2AgBBh6AEQQA6AABBkqAEQcziAS0AADoAAEGQoARByuIBLwAAOwEAQZOgBEEAOgAAQciyBUEANgIAQS1BEBANIQBByLIFKAIAIQFByLIFQQA2AgAgAUEBRg0SQZygBCAANgIAQaCgBEKNgICAgIKAgIB/NwMAIABBADoADSAAQdPiASkAADcABSAAQc7iASkAADcAAEG3oARBAzoAAEGooARBOzYCAEHDoARBBzoAAEHToARBAzoAAEHEoARBPDYCAEGsoARB3OIBLwAAOwEAQa6gBEHe4gEtAAA6AABBuKAEQeDiASgAADYCAEG7oARB4+IBKAAANgAAQcigBEHo4gEvAAA7AQBByqAEQeriAS0AADoAAEGvoARBADoAAEG/oARBADoAAEHfoARBBDoAAEHUoARBwuSF0wY2AgBB4KAEQT02AgBB76AEQQM6AABB+6AEQQY6AABBi6EEQQM6AABB/KAEQT42AgBB5KAEQeziAS8AADsBAEHmoARB7uIBLQAAOgAAQfCgBEHw4gEoAAA2AgBB9KAEQfTiAS8AADsBAEHLoARBADoAAEHYoARBADoAAEHnoARBADoAAEH2oARBADoAAEGCoQRB+eIBLQAAOgAAQYChBEH34gEvAAA7AQBBg6EEQQA6AABByLIFQQA2AgBBLUEQEA0hAEHIsgUoAgAhAUHIsgVBADYCACABQQFGDRNBjKEEIAA2AgBBkKEEQo+AgICAgoCAgH83AwAgAEEAOgAPIABBguMBKQAANwAHIABB++IBKQAANwAAQaehBEEDOgAAQZihBEE/NgIAQbOhBEEGOgAAQcOhBEEDOgAAQbShBEHAADYCAEGcoQRBi+MBLwAAOwEAQZ6hBEGN4wEtAAA6AABBqKEEQY/jASgAADYCAEGsoQRBk+MBLwAAOwEAQbihBEGW4wEvAAA7AQBBuqEEQZjjAS0AADoAAEGfoQRBADoAAEGuoQRBADoAAEHPoQRBCDoAAEHEoQRCwuqdy+at2bnlADcCAEHQoQRBwQA2AgBB36EEQQM6AABB66EEQQk6AABB+6EEQQM6AABB7KEEQcIANgIAQdShBEGa4wEvAAA7AQBB1qEEQZzjAS0AADoAAEHgoQRBnuMBKQAANwMAQeihBEGm4wEtAAA6AABBu6EEQQA6AABBzKEEQQA6AABB16EEQQA6AABB6aEEQQA6AABB8qEEQarjAS0AADoAAEHwoQRBqOMBLwAAOwEAQYeiBEEHOgAAQfOhBEEAOgAAQf+hBEGv4wEoAAA2AABB/KEEQazjASgAADYCAEGXogRBAzoAAEGIogRBwwA2AgBBg6IEQQA6AABBjqIEQbbjAS0AADoAAEGMogRBtOMBLwAAOwEAQY+iBEEAOgAAQciyBUEANgIAQS1BEBANIQBByLIFKAIAIQFByLIFQQA2AgAgAUEBRg0UQZiiBCAANgIAQZyiBEKLgICAgIKAgIB/NwIAIABBADoACyAAQb/jASgAADYAByAAQbjjASkAADcAAEGzogRBAzoAAEGkogRBxAA2AgBBv6IEQQU6AABBz6IEQQM6AABBwKIEQcUANgIAQaiiBEHE4wEvAAA7AQBBqqIEQcbjAS0AADoAAEG0ogRByOMBKAAANgIAQbiiBEHM4wEtAAA6AABBxKIEQc7jAS8AADsBAEHGogRB0OMBLQAAOgAAQauiBEEAOgAAQbmiBEEAOgAAQciyBUEANgIAQceiBEEAOgAAQS1BIBANIQBByLIFKAIAIQFByLIFQQA2AgAgAUEBRg0VQdCiBCAANgIAQdSiBEKfgICAgISAgIB/NwIAIABBADoAHyAAQenjASkAADcAFyAAQeLjASkAADcAECAAQdrjASkAADcACCAAQdLjASkAADcAAEHrogRBAzoAAEHcogRBxgA2AgBB4KIEQfLjAS8AADsBAEHiogRB9OMBLQAAOgAAQeOiBEEAOgAAQciyBUEANgIAQS1BEBANIQBByLIFKAIAIQFByLIFQQA2AgAgAUEBRg0WQeyiBCAANgIAQfCiBEKMgICAgIKAgIB/NwMAIABBADoADCAAQf7jASgAADYACCAAQfbjASkAADcAAEGHowRBAzoAAEH4ogRBxwA2AgBB/KIEQYPkAS8AADsBAEH+ogRBheQBLQAAOgAAQf+iBEEAOgAAQciyBUEANgIAQS1BIBANIQBByLIFKAIAIQFByLIFQQA2AgAgAUEBRg0XQYijBCAANgIAQYyjBEKSgICAgISAgIB/NwIAIABBADoAEiAAQZfkAS8AADsAECAAQY/kASkAADcACCAAQYfkASkAADcAAEGjowRBAzoAAEGUowRByAA2AgBBmKMEQZrkAS8AADsBAEGaowRBnOQBLQAAOgAAQZujBEEAOgAAQciyBUEANgIAQS1BIBANIQBByLIFKAIAIQFByLIFQQA2AgAgAUEBRg0YQaSjBCAANgIAQaijBEKRgICAgISAgIB/NwMAIABBADoAESAAQa7kAS0AADoAECAAQabkASkAADcACCAAQZ7kASkAADcAAEG/owRBAzoAAEGwowRByQA2AgBBy6MEQQc6AABB26MEQQM6AABBzKMEQcoANgIAQbSjBEGw5AEvAAA7AQBBtqMEQbLkAS0AADoAAEHAowRBtOQBKAAANgIAQcOjBEG35AEoAAA2AABB0KMEQbzkAS8AADsBAEHSowRBvuQBLQAAOgAAQbejBEEAOgAAQcejBEEAOgAAQciyBUEANgIAQdOjBEEAOgAAQS1BEBANIQBByLIFKAIAIQFByLIFQQA2AgAgAUEBRg0ZQdyjBCAANgIAQeCjBEKOgICAgIKAgIB/NwMAIABBADoADiAAQcbkASkAADcABiAAQcDkASkAADcAAEH3owRBAzoAAEHoowRBywA2AgBBg6QEQQg6AABBk6QEQQM6AABBhKQEQcwANgIAQfijBELD0IXr9s2cue8ANwMAQZ+kBEEHOgAAQeyjBEHP5AEvAAA7AQBB7qMEQdHkAS0AADoAAEGIpARB0+QBLwAAOwEAQYqkBEHV5AEtAAA6AABBl6QEQdrkASgAADYAAEGUpARB1+QBKAAANgIAQe+jBEEAOgAAQYCkBEEAOgAAQYukBEEAOgAAQa+kBEEDOgAAQaCkBEHNADYCAEG7pARBBzoAAEG8pARBzgA2AgBBy6QEQQM6AABBpKQEQd/kAS8AADsBAEGmpARB4eQBLQAAOgAAQbCkBEHj5AEoAAA2AgBBs6QEQebkASgAADYAAEHApARB6+QBLwAAOwEAQcKkBEHt5AEtAAA6AABBm6QEQQA6AABBp6QEQQA6AABBt6QEQQA6AABB16QEQQg6AABBw6QEQQA6AABB56QEQQM6AABB2KQEQc8ANgIAQcykBELD0IW7lozdsOkANwIAQdSkBEEAOgAAQd6kBEHx5AEtAAA6AABB3KQEQe/kAS8AADsBAEHzpARBBzoAAEHfpARBADoAAEHrpARB9uQBKAAANgAAQeikBEHz5AEoAAA2AgBBg6UEQQM6AABB9KQEQdAANgIAQe+kBEEAOgAAQfqkBEH95AEtAAA6AABB+KQEQfvkAS8AADsBAEGPpQRBCDoAAEH7pARBADoAAEGfpQRBAzoAAEGQpQRB0QA2AgBBhKUEQsPQ1au3rdm55QA3AgBBjKUEQQA6AABBlqUEQYHlAS0AADoAAEGUpQRB/+QBLwAAOwEAQaulBEEEOgAAQZelBEEAOgAAQbulBEEDOgAAQaylBEHSADYCAEGgpQRBzcLJywY2AgBBpKUEQQA6AABBsqUEQYXlAS0AADoAAEGwpQRBg+UBLwAAOwEAQbOlBEEAOgAAQciyBUEANgIAQS1BEBANIQBByLIFKAIAIQFByLIFQQA2AgAgAUEBRg0aQbylBCAANgIAQcClBEKOgICAgIKAgIB/NwMAIABBADoADiAAQY3lASkAADcABiAAQYflASkAADcAAEHXpQRBAzoAAEHIpQRB0wA2AgBB46UEQQc6AABB86UEQQM6AABB5KUEQdQANgIAQcylBEGW5QEvAAA7AQBBzqUEQZjlAS0AADoAAEHYpQRBmuUBKAAANgIAQdulBEGd5QEoAAA2AABB6KUEQaLlAS8AADsBAEHqpQRBpOUBLQAAOgAAQc+lBEEAOgAAQd+lBEEAOgAAQciyBUEANgIAQeulBEEAOgAAQS1BIBANIQBByLIFKAIAIQFByLIFQQA2AgAgAUEBRg0bQfSlBCAANgIAQfilBEKWgICAgISAgIB/NwMAIABBADoAFiAAQbTlASkAADcADiAAQa7lASkAADcACCAAQablASkAADcAAEGPpgRBAzoAAEGApgRB1QA2AgBBm6YEQQg6AABBq6YEQQM6AABBnKYEQdYANgIAQZCmBELD0JWT9+3asuUANwMAQYSmBEG95QEvAAA7AQBBhqYEQb/lAS0AADoAAEGgpgRBweUBLwAAOwEAQaKmBEHD5QEtAAA6AABBh6YEQQA6AABBmKYEQQA6AABBo6YEQQA6AABByLIFQQA2AgBBLUHgABANIQBByLIFKAIAIQFByLIFQQA2AgAgAUEBRg0cQaymBCAANgIAQbCmBELQgICAgIyAgIB/NwMAIABBxeUBQdAAEIANQQA6AFBBx6YEQQM6AABBuKYEQdcANgIAQdOmBEEHOgAAQeOmBEEDOgAAQdSmBEHYADYCAEG8pgRBluYBLwAAOwEAQb6mBEGY5gEtAAA6AABByKYEQZrmASgAADYCAEHLpgRBneYBKAAANgAAQdimBEGi5gEvAAA7AQBB2qYEQaTmAS0AADoAAEG/pgRBADoAAEHPpgRBADoAAEHvpgRBCDoAAEHkpgRCw9CVy9fMm7flADcCAEHwpgRB2QA2AgBB/6YEQQM6AABB9KYEQabmAS8AADsBAEH2pgRBqOYBLQAAOgAAQdumBEEAOgAAQeymBEEAOgAAQfemBEEAOgAAQciyBUEANgIAQS1BIBANIQBByLIFKAIAIQFByLIFQQA2AgAgAUEBRg0dQYCnBCAANgIAQYSnBEKQgICAgISAgIB/NwIAIABBADoAECAAQbLmASkAADcACCAAQarmASkAADcAAEGbpwRBAzoAAEGMpwRB2gA2AgBBp6cEQQY6AABBt6cEQQM6AABBqKcEQdsANgIAQZCnBEG75gEvAAA7AQBBkqcEQb3mAS0AADoAAEGcpwRBv+YBKAAANgIAQaCnBEHD5gEvAAA7AABBrKcEQcbmAS8AADsBAEGupwRByOYBLQAAOgAAQZOnBEEAOgAAQaKnBEEAOgAAQcOnBEEHOgAAQcSnBEHcADYCAEHTpwRBAzoAAEHfpwRBCDoAAEHUpwRCw97Jm5ft2LDuADcCAEHgpwRB3QA2AgBB76cEQQM6AABBuKcEQcrmASgAADYCAEG7pwRBzeYBKAAANgAAQcinBEHS5gEvAAA7AQBByqcEQdTmAS0AADoAAEGvpwRBADoAAEG/pwRBADoAAEHLpwRBADoAAEHcpwRBADoAAEHmpwRB2OYBLQAAOgAAQeSnBEHW5gEvAAA7AQBB56cEQQA6AABByLIFQQA2AgBBLUEwEA0hAEHIsgUoAgAhAUHIsgVBADYCACABQQFGDR5B8KcEIAA2AgBB9KcEQqqAgICAhoCAgH83AgAgAEEAOgAqIABBgucBLwAAOwAoIABB+uYBKQAANwAgIABB8uYBKQAANwAYIABB6uYBKQAANwAQIABB4uYBKQAANwAIIABB2uYBKQAANwAAQYuoBEEDOgAAQfynBEHeADYCAEGAqARBhecBLwAAOwEAQYKoBEGH5wEtAAA6AABBg6gEQQA6AABByLIFQQA2AgBBLUEwEA0hAEHIsgUoAgAhAUHIsgVBADYCACABQQFGDR9BjKgEIAA2AgBBkKgEQqmAgICAhoCAgH83AwAgAEEAOgApIABBsecBLQAAOgAoIABBqecBKQAANwAgIABBoecBKQAANwAYIABBmecBKQAANwAQIABBkecBKQAANwAIIABBiecBKQAANwAAQaeoBEEDOgAAQZioBEHfADYCAEGcqARBs+cBLwAAOwEAQZ6oBEG15wEtAAA6AABBn6gEQQA6AABByLIFQQA2AgBBLUEwEA0hAEHIsgUoAgAhAUHIsgVBADYCACABQQFGDSBBqKgEIAA2AgBBrKgEQq2AgICAhoCAgH83AgAgAEEAOgAtIABB3OcBKQAANwAlIABB1+cBKQAANwAgIABBz+cBKQAANwAYIABBx+cBKQAANwAQIABBv+cBKQAANwAIIABBt+cBKQAANwAAQcOoBEEDOgAAQbSoBEHgADYCAEHPqARBBDoAAEHfqARBAzoAAEHQqARB4QA2AgBBxKgEQcPklasGNgIAQbioBEHl5wEvAAA7AQBBuqgEQefnAS0AADoAAEHUqARB6ecBLwAAOwEAQdaoBEHr5wEtAAA6AABBu6gEQQA6AABByKgEQQA6AABB16gEQQA6AABByLIFQQA2AgBBLUEgEA0hAEHIsgUoAgAhAUHIsgVBADYCACABQQFGDSFB4KgEIAA2AgBB5KgEQp6AgICAhICAgH83AgAgAEEAOgAeIABBg+gBKQAANwAWIABB/ecBKQAANwAQIABB9ecBKQAANwAIIABB7ecBKQAANwAAQfuoBEEDOgAAQeyoBEHiADYCAEHwqARBjOgBLwAAOwEAQfKoBEGO6AEtAAA6AABB86gEQQA6AABByLIFQQA2AgBBLUEgEA0hAEHIsgUoAgAhAUHIsgVBADYCACABQQFGDSJB/KgEIAA2AgBBgKkEQpuAgICAhICAgH83AwAgAEEAOgAbIABBp+gBKAAANgAXIABBoOgBKQAANwAQIABBmOgBKQAANwAIIABBkOgBKQAANwAAQZepBEEDOgAAQYipBEHjADYCAEGjqQRBCToAAEGzqQRBAzoAAEGkqQRB5AA2AgBBjKkEQazoAS8AADsBAEGOqQRBrugBLQAAOgAAQZipBEGw6AEpAAA3AwBBoKkEQbjoAS0AADoAAEGoqQRBuugBLwAAOwEAQaqpBEG86AEtAAA6AABBj6kEQQA6AABBoakEQQA6AABByLIFQQA2AgBBq6kEQQA6AABBLUEgEA0hAEHIsgUoAgAhAUHIsgVBADYCACABQQFGDSNBtKkEIAA2AgBBuKkEQpCAgICAhICAgH83AwAgAEEAOgAQIABBxugBKQAANwAIIABBvugBKQAANwAAQc+pBEEDOgAAQcCpBEHlADYCAEHbqQRBBToAAEHrqQRBAzoAAEHcqQRB5gA2AgBBxKkEQc/oAS8AADsBAEHGqQRB0egBLQAAOgAAQdCpBEHT6AEoAAA2AgBB1KkEQdfoAS0AADoAAEHgqQRB2egBLwAAOwEAQeKpBEHb6AEtAAA6AABBx6kEQQA6AABB1akEQQA6AABB96kEQQY6AABB+KkEQecANgIAQYeqBEEDOgAAQZOqBEEGOgAAQeypBEHd6AEoAAA2AgBB8KkEQeHoAS8AADsAAEH8qQRB5OgBLwAAOwEAQf6pBEHm6AEtAAA6AABBiKoEQejoASgAADYCAEGMqgRB7OgBLwAAOwEAQeOpBEEAOgAAQfKpBEEAOgAAQf+pBEEAOgAAQaOqBEEDOgAAQZSqBEHoADYCAEGOqgRBADoAAEGaqgRB8egBLQAAOgAAQZiqBEHv6AEvAAA7AQBBr6oEQQY6AABBm6oEQQA6AABBqKoEQffoAS8AADsAAEGkqgRB8+gBKAAANgIAQb+qBEEDOgAAQbCqBEHpADYCAEGqqgRBADoAAEG2qgRB/OgBLQAAOgAAQbSqBEH66AEvAAA7AQBBt6oEQQA6AABByLIFQQA2AgBBLUEgEA0hAEHIsgUoAgAhAUHIsgVBADYCACABQQFGDSRBwKoEIAA2AgBBxKoEQpSAgICAhICAgH83AgAgAEEAOgAUIABBjukBKAAANgAQIABBhukBKQAANwAIIABB/ugBKQAANwAAQduqBEEDOgAAQcyqBEHqADYCAEHnqgRBCDoAAEH3qgRBAzoAAEHoqgRB6wA2AgBB3KoEQsTKsYv2rpi55QA3AgBB0KoEQZPpAS8AADsBAEHSqgRBlekBLQAAOgAAQeyqBEGX6QEvAAA7AQBB7qoEQZnpAS0AADoAAEHTqgRBADoAAEHkqgRBADoAAEHvqgRBADoAAEHIsgVBADYCAEEtQSAQDSEAQciyBSgCACEBQciyBUEANgIAIAFBAUYNJUH4qgQgADYCAEH8qgRCkoCAgICEgICAfzcCACAAQQA6ABIgAEGr6QEvAAA7ABAgAEGj6QEpAAA3AAggAEGb6QEpAAA3AABBk6sEQQM6AABBhKsEQewANgIAQZ+rBEEGOgAAQa+rBEEDOgAAQaCrBEHtADYCAEGIqwRBrukBLwAAOwEAQYqrBEGw6QEtAAA6AABBlKsEQbLpASgAADYCAEGYqwRBtukBLwAAOwAAQaSrBEG56QEvAAA7AQBBpqsEQbvpAS0AADoAAEGLqwRBADoAAEGaqwRBADoAAEG7qwRBBToAAEG8qwRB7gA2AgBBy6sEQQM6AABBsKsEQb3pASgAADYCAEG0qwRBwekBLQAAOgAAQcCrBEHD6QEvAAA7AQBBwqsEQcXpAS0AADoAAEGnqwRBADoAAEG1qwRBADoAAEHDqwRBADoAAEHIsgVBADYCAEEtQSAQDSEAQciyBSgCACEBQciyBUEANgIAIAFBAUYNJkHMqwQgADYCAEHQqwRCmoCAgICEgICAfzcDACAAQQA6ABogAEHf6QEvAAA7ABggAEHX6QEpAAA3ABAgAEHP6QEpAAA3AAggAEHH6QEpAAA3AABB56sEQQM6AABB2KsEQe8ANgIAQfOrBEEFOgAAQYOsBEEDOgAAQfSrBEHwADYCAEHcqwRB4ukBLwAAOwEAQd6rBEHk6QEtAAA6AABB6KsEQebpASgAADYCAEHsqwRB6ukBLQAAOgAAQfirBEHs6QEvAAA7AQBB+qsEQe7pAS0AADoAAEHfqwRBADoAAEHtqwRBADoAAEHIsgVBADYCAEH7qwRBADoAAEEtQSAQDSEAQciyBSgCACEBQciyBUEANgIAIAFBAUYNJ0GErAQgADYCAEGIrARCkYCAgICEgICAfzcDACAAQQA6ABEgAEGA6gEtAAA6ABAgAEH46QEpAAA3AAggAEHw6QEpAAA3AABBn6wEQQM6AABBkKwEQfEANgIAQZSsBEGC6gEvAAA7AQBBlqwEQYTqAS0AADoAAEGXrARBADoAAEHIsgVBADYCAEEtQRAQDSEAQciyBSgCACEBQciyBUEANgIAIAFBAUYNKEGgrAQgADYCAEGkrARCjYCAgICCgICAfzcCACAAQQA6AA0gAEGL6gEpAAA3AAUgAEGG6gEpAAA3AABBu6wEQQM6AABBrKwEQfIANgIAQcesBEEFOgAAQdesBEEDOgAAQcisBEHzADYCAEGwrARBlOoBLwAAOwEAQbKsBEGW6gEtAAA6AABBvKwEQZjqASgAADYCAEHArARBnOoBLQAAOgAAQcysBEGe6gEvAAA7AQBBzqwEQaDqAS0AADoAAEGzrARBADoAAEHBrARBADoAAEHIsgVBADYCAEHPrARBADoAAEEtQSAQDSEAQciyBSgCACEBQciyBUEANgIAIAFBAUYNKUHYrAQgADYCAEHcrARCnICAgICEgICAfzcCACAAQQA6ABwgAEG66gEoAAA2ABggAEGy6gEpAAA3ABAgAEGq6gEpAAA3AAggAEGi6gEpAAA3AABB86wEQQM6AABB5KwEQfQANgIAQeisBEG/6gEvAAA7AQBB6qwEQcHqAS0AADoAAEHrrARBADoAAEHIsgVBADYCAEEtQRAQDSEAQciyBSgCACEBQciyBUEANgIAIAFBAUYNKkH0rAQgADYCAEH4rARCjoCAgICCgICAfzcDACAAQQA6AA4gAEHJ6gEpAAA3AAYgAEHD6gEpAAA3AABBj60EQQM6AABBgK0EQfUANgIAQZutBEEFOgAAQautBEEDOgAAQZytBEH2ADYCAEGErQRB0uoBLwAAOwEAQYatBEHU6gEtAAA6AABBkK0EQdbqASgAADYCAEGUrQRB2uoBLQAAOgAAQaCtBEHc6gEvAAA7AQBBoq0EQd7qAS0AADoAAEGHrQRBADoAAEGVrQRBADoAAEG3rQRBCDoAAEGsrQRCxPS98/bsmrThADcCAEG4rQRB9wA2AgBBx60EQQM6AABB060EQQQ6AABByK0EQcXMpdsGNgIAQdStBEH4ADYCAEHjrQRBAzoAAEG8rQRB4OoBLwAAOwEAQb6tBEHi6gEtAAA6AABB2q0EQebqAS0AADoAAEHYrQRB5OoBLwAAOwEAQaOtBEEAOgAAQbStBEEAOgAAQb+tBEEAOgAAQcytBEEAOgAAQdutBEEAOgAAQciyBUEANgIAQS1BIBANIQBByLIFKAIAIQFByLIFQQA2AgAgAUEBRg0rQeStBCAANgIAQeitBEKSgICAgISAgIB/NwMAIABBADoAEiAAQfjqAS8AADsAECAAQfDqASkAADcACCAAQejqASkAADcAAEH/rQRBAzoAAEHwrQRB+QA2AgBBi64EQQY6AABBm64EQQM6AABBjK4EQfoANgIAQfStBEH76gEvAAA7AQBB9q0EQf3qAS0AADoAAEGArgRB/+oBKAAANgIAQYSuBEGD6wEvAAA7AQBBkK4EQYbrAS8AADsBAEGSrgRBiOsBLQAAOgAAQfetBEEAOgAAQYauBEEAOgAAQaeuBEEHOgAAQaiuBEH7ADYCAEG3rgRBAzoAAEHDrgRBBzoAAEGcrgRBiusBKAAANgIAQZ+uBEGN6wEoAAA2AABBrK4EQZLrAS8AADsBAEGurgRBlOsBLQAAOgAAQbiuBEGW6wEoAAA2AgBBu64EQZnrASgAADYAAEGTrgRBADoAAEGjrgRBADoAAEGvrgRBADoAAEHTrgRBAzoAAEHErgRB/AA2AgBBv64EQQA6AABByq4EQaDrAS0AADoAAEHIrgRBnusBLwAAOwEAQcuuBEEAOgAAQciyBUEANgIAQS1BIBANIQBByLIFKAIAIQFByLIFQQA2AgAgAUEBRg0sQdSuBCAANgIAQdiuBEKbgICAgISAgIB/NwMAIABBADoAGyAAQbnrASgAADYAFyAAQbLrASkAADcAECAAQarrASkAADcACCAAQaLrASkAADcAAEHvrgRBAzoAAEHgrgRB/QA2AgBB+64EQQk6AABBi68EQQM6AABB/K4EQf4ANgIAQeSuBEG+6wEvAAA7AQBB5q4EQcDrAS0AADoAAEHwrgRBwusBKQAANwMAQfiuBEHK6wEtAAA6AABBgK8EQczrAS8AADsBAEGCrwRBzusBLQAAOgAAQeeuBEEAOgAAQfmuBEEAOgAAQZevBEEIOgAAQYyvBELF5tH75q3asO4ANwIAQZivBEH/ADYCAEGnrwRBAzoAAEGzrwRBAzoAAEHDrwRBAzoAAEG0rwRBgAE2AgBBnK8EQdDrAS8AADsBAEGerwRB0usBLQAAOgAAQaivBEHU6wEvAAA7AQBBqq8EQdbrAS0AADoAAEGDrwRBADoAAEGUrwRBADoAAEGfrwRBADoAAEGrrwRBADoAAEG6rwRB2usBLQAAOgAAQbivBEHY6wEvAAA7AQBBz68EQQY6AABBu68EQQA6AABByK8EQeDrAS8AADsAAEHErwRB3OsBKAAANgIAQd+vBEEDOgAAQdCvBEGBATYCAEHKrwRBADoAAEHWrwRB5esBLQAAOgAAQdSvBEHj6wEvAAA7AQBB668EQQQ6AABB168EQQA6AABB+68EQQM6AABB7K8EQYIBNgIAQeCvBEHGwrm7BjYCAEHkrwRBADoAAEHyrwRB6esBLQAAOgAAQfCvBEHn6wEvAAA7AQBBh7AEQQc6AABB868EQQA6AABB/68EQe7rASgAADYAAEH8rwRB6+sBKAAANgIAQZewBEEDOgAAQYiwBEGDATYCAEGDsARBADoAAEGOsARB9esBLQAAOgAAQYywBEHz6wEvAAA7AQBBo7AEQQU6AABBj7AEQQA6AABBnLAEQfvrAS0AADoAAEGYsARB9+sBKAAANgIAQbOwBEEDOgAAQaSwBEGEATYCAEGdsARBADoAAEGqsARB/+sBLQAAOgAAQaiwBEH96wEvAAA7AQBBv7AEQQY6AABBq7AEQQA6AABBuLAEQYXsAS8AADsAAEG0sARBgewBKAAANgIAQc+wBEEDOgAAQcCwBEGFATYCAEG6sARBADoAAEHGsARBiuwBLQAAOgAAQcSwBEGI7AEvAAA7AQBBx7AEQQA6AABByLIFQQA2AgBBLUEgEA0hAEHIsgUoAgAhAUHIsgVBADYCACABQQFGDS1B0LAEIAA2AgBB1LAEQpKAgICAhICAgH83AgAgAEEAOgASIABBnOwBLwAAOwAQIABBlOwBKQAANwAIIABBjOwBKQAANwAAQeuwBEEDOgAAQdywBEGGATYCAEH3sARBBzoAAEGHsQRBAzoAAEH4sARBhwE2AgBB4LAEQZ/sAS8AADsBAEHisARBoewBLQAAOgAAQeywBEGj7AEoAAA2AgBB77AEQabsASgAADYAAEH8sARBq+wBLwAAOwEAQf6wBEGt7AEtAAA6AABB47AEQQA6AABB87AEQQA6AABByLIFQQA2AgBB/7AEQQA6AABBLUEgEA0hAEHIsgUoAgAhAUHIsgVBADYCACABQQFGDS5BiLEEIAA2AgBBjLEEQpSAgICAhICAgH83AgAgAEEAOgAUIABBv+wBKAAANgAQIABBt+wBKQAANwAIIABBr+wBKQAANwAAQaOxBEEDOgAAQZSxBEGIATYCAEGvsQRBAzoAAEG/sQRBAzoAAEGwsQRBiQE2AgBBmLEEQcTsAS8AADsBAEGasQRBxuwBLQAAOgAAQaSxBEHI7AEvAAA7AQBBprEEQcrsAS0AADoAAEG0sQRBzOwBLwAAOwEAQbaxBEHO7AEtAAA6AABBm7EEQQA6AABBp7EEQQA6AABBy7EEQQY6AABBzLEEQYoBNgIAQduxBEEDOgAAQcCxBEHQ7AEoAAA2AgBBxLEEQdTsAS8AADsBAEHQsQRB1+wBLwAAOwEAQdKxBEHZ7AEtAAA6AABBt7EEQQA6AABBxrEEQQA6AABB07EEQQA6AABByLIFQQA2AgBBLUEgEA0hAEHIsgUoAgAhAUHIsgVBADYCACABQQFGDS9B3LEEIAA2AgBB4LEEQp2AgICAhICAgH83AwAgAEEAOgAdIABB8OwBKQAANwAVIABB6+wBKQAANwAQIABB4+wBKQAANwAIIABB2+wBKQAANwAAQfexBEEDOgAAQeixBEGLATYCAEHssQRB+ewBLwAAOwEAQe6xBEH77AEtAAA6AABB77EEQQA6AABByLIFQQA2AgBBLUEgEA0hAEHIsgUoAgAhAUHIsgVBADYCACABQQFGDTBB+LEEIAA2AgBB/LEEQpmAgICAhICAgH83AgAgAEEAOgAZIABBle0BLQAAOgAYIABBje0BKQAANwAQIABBhe0BKQAANwAIIABB/ewBKQAANwAAQZOyBEEDOgAAQYSyBEGMATYCAEGIsgRBl+0BLwAAOwEAQYqyBEGZ7QEtAAA6AABBi7IEQQA6AABByLIFQQA2AgBBLUEgEA0hAEHIsgUoAgAhAUHIsgVBADYCACABQQFGDTFBlLIEIAA2AgBBmLIEQpCAgICAhICAgH83AwAgAEEAOgAQIABBo+0BKQAANwAIIABBm+0BKQAANwAAQa+yBEEDOgAAQaCyBEGNATYCAEGksgRBrO0BLwAAOwEAQaayBEGu7QEtAAA6AABBp7IEQQA6AABByLIFQQA2AgBBLUEQEA0hAEHIsgUoAgAhAUHIsgVBADYCACABQQFGDTJBsLIEIAA2AgBBtLIEQo+AgICAgoCAgH83AgAgAEEAOgAPIABBt+0BKQAANwAHIABBsO0BKQAANwAAQcuyBEEDOgAAQbyyBEGOATYCAEHAsgRBwO0BLwAAOwEAQcKyBEHC7QEtAAA6AABBw7IEQQA6AABByLIFQQA2AgBBLUEQEA0hAEHIsgUoAgAhAUHIsgVBADYCACABQQFGDTNBzLIEIAA2AgBB0LIEQo+AgICAgoCAgH83AwAgAEEAOgAPIABBy+0BKQAANwAHIABBxO0BKQAANwAAQeeyBEEDOgAAQdiyBEGPATYCAEHzsgRBBToAAEGDswRBAzoAAEH0sgRBkAE2AgBB3LIEQdTtAS8AADsBAEHesgRB1u0BLQAAOgAAQeiyBEHY7QEoAAA2AgBB7LIEQdztAS0AADoAAEH4sgRB3u0BLwAAOwEAQfqyBEHg7QEtAAA6AABB37IEQQA6AABB7bIEQQA6AABBj7MEQQg6AABBhLMEQsbkpavHrdqw7gA3AgBBkLMEQZEBNgIAQZ+zBEEDOgAAQauzBEECOgAAQayzBEGSATYCAEG7swRBAzoAAEGgswRBx8IBOwEAQZSzBEHi7QEvAAA7AQBBlrMEQeTtAS0AADoAAEGwswRB5u0BLwAAOwEAQbKzBEHo7QEtAAA6AABB+7IEQQA6AABBjLMEQQA6AABBl7MEQQA6AABBorMEQQA6AABBx7MEQQQ6AABBs7MEQQA6AABB17MEQQM6AABByLMEQZMBNgIAQbyzBEHHwuX7BjYCAEHAswRBADoAAEHOswRB7O0BLQAAOgAAQcyzBEHq7QEvAAA7AQBB47MEQQU6AABBz7MEQQA6AABB3LMEQfLtAS0AADoAAEHYswRB7u0BKAAANgIAQfOzBEEDOgAAQeSzBEGUATYCAEHdswRBADoAAEHqswRB9u0BLQAAOgAAQeizBEH07QEvAAA7AQBB67MEQQA6AABByLIFQQA2AgBBLUEgEA0hAEHIsgUoAgAhAUHIsgVBADYCACABQQFGDTRB9LMEIAA2AgBB+LMEQpCAgICAhICAgH83AwAgAEEAOgAQIABBgO4BKQAANwAIIABB+O0BKQAANwAAQY+0BEEDOgAAQYC0BEGVATYCAEGbtARBCDoAAEGrtARBAzoAAEGctARBlgE2AgBBkLQEQsfKvZP3rNqw7gA3AwBBt7QEQQY6AABBhLQEQYnuAS8AADsBAEGGtARBi+4BLQAAOgAAQaC0BEGN7gEvAAA7AQBBorQEQY/uAS0AADoAAEGwtARBle4BLwAAOwAAQay0BEGR7gEoAAA2AgBBh7QEQQA6AABBmLQEQQA6AABBo7QEQQA6AABBx7QEQQM6AABBuLQEQZcBNgIAQdO0BEEEOgAAQci0BEHHypXTBzYCAEHUtARBmAE2AgBB47QEQQM6AABB77QEQQo6AABBvLQEQZjuAS8AADsBAEG+tARBmu4BLQAAOgAAQdi0BEGc7gEvAAA7AQBB2rQEQZ7uAS0AADoAAEGytARBADoAAEG/tARBADoAAEHMtARBADoAAEHbtARBADoAAEHstARBqO4BLwAAOwEAQeS0BEGg7gEpAAA3AgBB/7QEQQM6AABB8LQEQZkBNgIAQe60BEEAOgAAQfa0BEGt7gEtAAA6AABB9LQEQavuAS8AADsBAEH3tARBADoAAEHIsgVBADYCAEEtQSAQDSEAQciyBSgCACEBQciyBUEANgIAIAFBAUYNNUGAtQQgADYCAEGEtQRCl4CAgICEgICAfzcCACAAQQA6ABcgAEG+7gEpAAA3AA8gAEG37gEpAAA3AAggAEGv7gEpAAA3AABBm7UEQQM6AABBjLUEQZoBNgIAQae1BEEFOgAAQbe1BEEDOgAAQai1BEGbATYCAEGQtQRBx+4BLwAAOwEAQZK1BEHJ7gEtAAA6AABBnLUEQcvuASgAADYCAEGgtQRBz+4BLQAAOgAAQay1BEHR7gEvAAA7AQBBrrUEQdPuAS0AADoAAEGTtQRBADoAAEGhtQRBADoAAEHDtQRBCDoAAEG4tQRCx8Kxy7as2rDuADcDAEHEtQRBnAE2AgBB07UEQQM6AABB37UEQQQ6AABB1LUEQc3CucMHNgIAQeC1BEGdATYCAEHvtQRBAzoAAEHItQRB1e4BLwAAOwEAQcq1BEHX7gEtAAA6AABB5rUEQdvuAS0AADoAAEHktQRB2e4BLwAAOwEAQa+1BEEAOgAAQcC1BEEAOgAAQcu1BEEAOgAAQdi1BEEAOgAAQee1BEEAOgAAQciyBUEANgIAQS1BMBANIQBByLIFKAIAIQFByLIFQQA2AgAgAUEBRg02QfC1BCAANgIAQfS1BEKigICAgIaAgIB/NwIAIABBADoAIiAAQf3uAS8AADsAICAAQfXuASkAADcAGCAAQe3uASkAADcAECAAQeXuASkAADcACCAAQd3uASkAADcAAEGLtgRBAzoAAEH8tQRBngE2AgBBgLYEQYDvAS8AADsBAEGCtgRBgu8BLQAAOgAAQYO2BEEAOgAAQciyBUEANgIAQS1BIBANIQBByLIFKAIAIQFByLIFQQA2AgAgAUEBRg03QYy2BCAANgIAQZC2BEKegICAgISAgIB/NwMAIABBADoAHiAAQZrvASkAADcAFiAAQZTvASkAADcAECAAQYzvASkAADcACCAAQYTvASkAADcAAEGntgRBAzoAAEGYtgRBnwE2AgBBs7YEQQU6AABBw7YEQQM6AABBtLYEQaABNgIAQZy2BEGj7wEvAAA7AQBBnrYEQaXvAS0AADoAAEGotgRBp+8BKAAANgIAQay2BEGr7wEtAAA6AABBuLYEQa3vAS8AADsBAEG6tgRBr+8BLQAAOgAAQZ+2BEEAOgAAQa22BEEAOgAAQc+2BEEJOgAAQdC2BEGhATYCAEHftgRBAzoAAEHrtgRBBjoAAEHEtgRBse8BKQAANwIAQcy2BEG57wEtAAA6AABB1LYEQbvvAS8AADsBAEHWtgRBve8BLQAAOgAAQeC2BEG/7wEoAAA2AgBB5LYEQcPvAS8AADsBAEG7tgRBADoAAEHNtgRBADoAAEHXtgRBADoAAEH7tgRBAzoAAEHstgRBogE2AgBB5rYEQQA6AABB8rYEQcjvAS0AADoAAEHwtgRBxu8BLwAAOwEAQYe3BEEFOgAAQfO2BEEAOgAAQYC3BEHO7wEtAAA6AABB/LYEQcrvASgAADYCAEGXtwRBAzoAAEGItwRBowE2AgBBgbcEQQA6AABBjrcEQdLvAS0AADoAAEGMtwRB0O8BLwAAOwEAQY+3BEEAOgAAQciyBUEANgIAQS1BIBANIQBByLIFKAIAIQFByLIFQQA2AgAgAUEBRg04QZi3BCAANgIAQZy3BEKYgICAgISAgIB/NwIAIABBADoAGCAAQeTvASkAADcAECAAQdzvASkAADcACCAAQdTvASkAADcAAEGztwRBAzoAAEGktwRBpAE2AgBBqLcEQe3vAS8AADsBAEGqtwRB7+8BLQAAOgAAQau3BEEAOgAAQciyBUEANgIAQS1BIBANIQBByLIFKAIAIQFByLIFQQA2AgAgAUEBRg05QbS3BCAANgIAQbi3BEKVgICAgISAgIB/NwMAIABBADoAFSAAQf7vASkAADcADSAAQfnvASkAADcACCAAQfHvASkAADcAAEHPtwRBAzoAAEHAtwRBpQE2AgBB27cEQQc6AABB67cEQQM6AABB3LcEQaYBNgIAQcS3BEGH8AEvAAA7AQBBxrcEQYnwAS0AADoAAEHQtwRBi/ABKAAANgIAQdO3BEGO8AEoAAA2AABB4LcEQZPwAS8AADsBAEHitwRBlfABLQAAOgAAQce3BEEAOgAAQde3BEEAOgAAQciyBUEANgIAQeO3BEEAOgAAQS1BMBANIQBByLIFKAIAIQFByLIFQQA2AgAgAUEBRg06Qey3BCAANgIAQfC3BEKhgICAgIaAgIB/NwMAIABBADoAISAAQbfwAS0AADoAICAAQa/wASkAADcAGCAAQafwASkAADcAECAAQZ/wASkAADcACCAAQZfwASkAADcAAEGHuARBAzoAAEH4twRBpwE2AgBBk7gEQQg6AABBo7gEQQM6AABBlLgEQagBNgIAQYi4BELH6qmLpq6YuukANwMAQa+4BEEIOgAAQb+4BEEDOgAAQbC4BEGpATYCAEGkuARCx+6lm4btybTuADcCAEH8twRBufABLwAAOwEAQf63BEG78AEtAAA6AABBmLgEQb3wAS8AADsBAEGauARBv/ABLQAAOgAAQf+3BEEAOgAAQZC4BEEAOgAAQZu4BEEAOgAAQay4BEEAOgAAQcu4BEEFOgAAQcy4BEGqATYCAEHbuARBAzoAAEG2uARBw/ABLQAAOgAAQbS4BEHB8AEvAAA7AQBBwLgEQcXwASgAADYCAEHEuARByfABLQAAOgAAQdC4BEHL8AEvAAA7AQBB0rgEQc3wAS0AADoAAEG3uARBADoAAEHFuARBADoAAEHTuARBADoAAEHIsgVBADYCAEEtQSAQDSEAQciyBSgCACEBQciyBUEANgIAIAFBAUYNO0HcuAQgADYCAEHguARCl4CAgICEgICAfzcDACAAQQA6ABcgAEHe8AEpAAA3AA8gAEHX8AEpAAA3AAggAEHP8AEpAAA3AABB97gEQQM6AABB6LgEQasBNgIAQYO5BEEFOgAAQZO5BEEDOgAAQYS5BEGsATYCAEHsuARB5/ABLwAAOwEAQe64BEHp8AEtAAA6AABB+LgEQevwASgAADYCAEH8uARB7/ABLQAAOgAAQYi5BEHx8AEvAAA7AQBBirkEQfPwAS0AADoAAEHvuARBADoAAEH9uARBADoAAEGfuQRBCDoAAEGUuQRCyMLdi5at2rDuADcCAEGguQRBrQE2AgBBr7kEQQM6AABBu7kEQQY6AABBy7kEQQM6AABBvLkEQa4BNgIAQaS5BEH18AEvAAA7AQBBprkEQffwAS0AADoAAEGwuQRB+fABKAAANgIAQbS5BEH98AEvAAA7AQBBi7kEQQA6AABBnLkEQQA6AABBp7kEQQA6AABBtrkEQQA6AABBwrkEQYLxAS0AADoAAEHAuQRBgPEBLwAAOwEAQde5BEEGOgAAQcO5BEEAOgAAQdC5BEGI8QEvAAA7AABBzLkEQYTxASgAADYCAEHnuQRBAzoAAEHYuQRBrwE2AgBB0rkEQQA6AABB3rkEQY3xAS0AADoAAEHcuQRBi/EBLwAAOwEAQfO5BEEKOgAAQd+5BEEAOgAAQfC5BEGX8QEvAAA7AABB6LkEQY/xASkAADcDAEGDugRBAzoAAEH0uQRBsAE2AgBB8rkEQQA6AABB+rkEQZzxAS0AADoAAEH4uQRBmvEBLwAAOwEAQY+6BEEJOgAAQfu5BEEAOgAAQYy6BEGm8QEtAAA6AABBhLoEQZ7xASkAADcCAEGfugRBAzoAAEGQugRBsQE2AgBBjboEQQA6AABBlroEQarxAS0AADoAAEGUugRBqPEBLwAAOwEAQau6BEEFOgAAQZe6BEEAOgAAQaS6BEGw8QEtAAA6AABBoLoEQazxASgAADYCAEG7ugRBAzoAAEGsugRBsgE2AgBBpboEQQA6AABBsroEQbTxAS0AADoAAEGwugRBsvEBLwAAOwEAQce6BEEHOgAAQbO6BEEAOgAAQb+6BEG58QEoAAA2AABBvLoEQbbxASgAADYCAEHXugRBAzoAAEHIugRBswE2AgBBw7oEQQA6AABBzroEQcDxAS0AADoAAEHMugRBvvEBLwAAOwEAQeO6BEEFOgAAQc+6BEEAOgAAQdy6BEHG8QEtAAA6AABB2LoEQcLxASgAADYCAEHzugRBAzoAAEHkugRBtAE2AgBB3boEQQA6AABB6roEQcrxAS0AADoAAEHougRByPEBLwAAOwEAQf+6BEEJOgAAQeu6BEEAOgAAQfy6BEHU8QEtAAA6AABB9LoEQczxASkAADcCAEGPuwRBAzoAAEGAuwRBtQE2AgBB/boEQQA6AABBhrsEQdjxAS0AADoAAEGEuwRB1vEBLwAAOwEAQZu7BEEIOgAAQYe7BEEAOgAAQau7BEEDOgAAQZy7BEG2ATYCAEGQuwRCw+S9i8au2rDuADcDAEGYuwRBADoAAEGiuwRB3PEBLQAAOgAAQaC7BEHa8QEvAAA7AQBBo7sEQQA6AABByLIFQQA2AgBBLUEQEA0hAEHIsgUoAgAhAUHIsgVBADYCACABQQFGDTxBrLsEIAA2AgBBsLsEQo2AgICAgoCAgH83AwAgAEEAOgANIABB4/EBKQAANwAFIABB3vEBKQAANwAAQce7BEEDOgAAQbi7BEG3ATYCAEHTuwRBCToAAEHjuwRBAzoAAEHUuwRBuAE2AgBBvLsEQezxAS8AADsBAEG+uwRB7vEBLQAAOgAAQci7BEHw8QEpAAA3AwBB0LsEQfjxAS0AADoAAEHYuwRB+vEBLwAAOwEAQdq7BEH88QEtAAA6AABBv7sEQQA6AABB0bsEQQA6AABB77sEQQQ6AABB5LsEQcjqwYsGNgIAQfC7BEG5ATYCAEH/uwRBAzoAAEGLvARBBDoAAEGAvARBycSF8wY2AgBBjLwEQboBNgIAQZu8BEEDOgAAQfS7BEH+8QEvAAA7AQBB9rsEQYDyAS0AADoAAEGSvARBhPIBLQAAOgAAQZC8BEGC8gEvAAA7AQBB27sEQQA6AABB6LsEQQA6AABB97sEQQA6AABBhLwEQQA6AABBp7wEQQQ6AABBk7wEQQA6AABBt7wEQQM6AABBqLwEQbsBNgIAQZy8BEHJzon7BjYCAEGgvARBADoAAEGuvARBiPIBLQAAOgAAQay8BEGG8gEvAAA7AQBBw7wEQQk6AABBr7wEQQA6AABBwLwEQZLyAS0AADoAAEG4vARBivIBKQAANwMAQdO8BEEDOgAAQcS8BEG8ATYCAEHBvARBADoAAEHKvARBlvIBLQAAOgAAQci8BEGU8gEvAAA7AQBB37wEQQM6AABBy7wEQQA6AABB1rwEQZryAS0AADoAAEHUvARBmPIBLwAAOwEAQe+8BEEDOgAAQeC8BEG9ATYCAEHXvARBADoAAEHmvARBnvIBLQAAOgAAQeS8BEGc8gEvAAA7AQBB57wEQQA6AABByLIFQQA2AgBBLUEgEA0hAEHIsgUoAgAhAUHIsgVBADYCACABQQFGDT1B8LwEIAA2AgBB9LwEQpGAgICAhICAgH83AgAgAEEAOgARIABBsPIBLQAAOgAQIABBqPIBKQAANwAIIABBoPIBKQAANwAAQYu9BEEDOgAAQfy8BEG+ATYCAEGAvQRBsvIBLwAAOwEAQYK9BEG08gEtAAA6AABBg70EQQA6AABByLIFQQA2AgBBLUEQEA0hAEHIsgUoAgAhAUHIsgVBADYCACABQQFGDT5BjL0EIAA2AgBBkL0EQo2AgICAgoCAgH83AwAgAEEAOgANIABBu/IBKQAANwAFIABBtvIBKQAANwAAQae9BEEDOgAAQZi9BEG/ATYCAEGzvQRBCToAAEHDvQRBAzoAAEG0vQRBwAE2AgBBnL0EQcTyAS8AADsBAEGevQRBxvIBLQAAOgAAQai9BEHI8gEpAAA3AwBBsL0EQdDyAS0AADoAAEG4vQRB0vIBLwAAOwEAQbq9BEHU8gEtAAA6AABBn70EQQA6AABBsb0EQQA6AABByLIFQQA2AgBBu70EQQA6AABBLUEgEA0hAEHIsgUoAgAhAUHIsgVBADYCACABQQFGDT9BxL0EIAA2AgBByL0EQpeAgICAhICAgH83AwAgAEEAOgAXIABB5fIBKQAANwAPIABB3vIBKQAANwAIIABB1vIBKQAANwAAQd+9BEEDOgAAQdC9BEHBATYCAEHrvQRBBToAAEH7vQRBAzoAAEHsvQRBwgE2AgBB1L0EQe7yAS8AADsBAEHWvQRB8PIBLQAAOgAAQeC9BEHy8gEoAAA2AgBB5L0EQfbyAS0AADoAAEHwvQRB+PIBLwAAOwEAQfK9BEH68gEtAAA6AABB170EQQA6AABB5b0EQQA6AABByLIFQQA2AgBB870EQQA6AABBLUHAABANIQBByLIFKAIAIQFByLIFQQA2AgAgAUEBRg1AQfy9BCAANgIAQYC+BEK6gICAgIiAgIB/NwMAIABBADoAOiAAQbTzAS8AADsAOCAAQazzASkAADcAMCAAQaTzASkAADcAKCAAQZzzASkAADcAICAAQZTzASkAADcAGCAAQYzzASkAADcAECAAQYTzASkAADcACCAAQfzyASkAADcAAEGXvgRBAzoAAEGIvgRBwwE2AgBBjL4EQbfzAS8AADsBAEGOvgRBufMBLQAAOgAAQY++BEEAOgAAQciyBUEANgIAQS1BEBANIQBByLIFKAIAIQFByLIFQQA2AgAgAUEBRg1BQZi+BCAANgIAQZy+BEKNgICAgIKAgIB/NwIAIABBADoADSAAQcDzASkAADcABSAAQbvzASkAADcAAEGzvgRBAzoAAEGkvgRBxAE2AgBBz74EQQM6AABBwL4EQcUBNgIAQb6+BEGAFDsBAEGovgRByfMBLwAAOwEAQaq+BEHL8wEtAAA6AABBtL4EQc3zASkAADcCAEG8vgRB1fMBLwAAOwEAQcS+BEHY8wEvAAA7AQBBxr4EQdrzAS0AADoAAEGrvgRBADoAAEHHvgRBADoAAEHIsgVBADYCAEEtQSAQDSEAQciyBSgCACEBQciyBUEANgIAIAFBAUYNQkHQvgQgADYCAEHUvgRClYCAgICEgICAfzcCACAAQQA6ABUgAEHp8wEpAAA3AA0gAEHk8wEpAAA3AAggAEHc8wEpAAA3AABB674EQQM6AABB3L4EQcYBNgIAQfe+BEEGOgAAQYe/BEEDOgAAQfi+BEHHATYCAEHgvgRB8vMBLwAAOwEAQeK+BEH08wEtAAA6AABB7L4EQfbzASgAADYCAEHwvgRB+vMBLwAAOwAAQfy+BEH98wEvAAA7AQBB/r4EQf/zAS0AADoAAEHjvgRBADoAAEHyvgRBADoAAEGTvwRBBzoAAEGUvwRByAE2AgBBo78EQQM6AABBiL8EQYH0ASgAADYCAEGLvwRBhPQBKAAANgAAQZi/BEGJ9AEvAAA7AQBBmr8EQYv0AS0AADoAAEH/vgRBADoAAEGPvwRBADoAAEGbvwRBADoAAEHIsgVBADYCAEEtQRAQDSEAQciyBSgCACEBQciyBUEANgIAIAFBAUYNQ0GkvwQgADYCAEGovwRCj4CAgICCgICAfzcDACAAQQA6AA8gAEGU9AEpAAA3AAcgAEGN9AEpAAA3AABBv78EQQM6AABBsL8EQckBNgIAQbS/BEGd9AEvAAA7AQBBtr8EQZ/0AS0AADoAAEG3vwRBADoAAEHIsgVBADYCAEEtQSAQDSEAQciyBSgCACEBQciyBUEANgIAIAFBAUYNREHAvwQgADYCAEHEvwRCk4CAgICEgICAfzcCACAAQQA6ABMgAEGw9AEoAAA2AA8gAEGp9AEpAAA3AAggAEGh9AEpAAA3AABB278EQQM6AABBzL8EQcoBNgIAQee/BEEHOgAAQfe/BEEDOgAAQei/BEHLATYCAEHQvwRBtfQBLwAAOwEAQdK/BEG39AEtAAA6AABB3L8EQbn0ASgAADYCAEHfvwRBvPQBKAAANgAAQey/BEHB9AEvAAA7AQBB7r8EQcP0AS0AADoAAEHTvwRBADoAAEHjvwRBADoAAEGDwARBCDoAAEH4vwRCysLZi+at2bnlADcDAEGEwARBzAE2AgBBk8AEQQM6AABBn8AEQQY6AABBr8AEQQM6AABBoMAEQc0BNgIAQYjABEHF9AEvAAA7AQBBisAEQcf0AS0AADoAAEGUwARByfQBKAAANgIAQZjABEHN9AEvAAA7AABB778EQQA6AABBgMAEQQA6AABBi8AEQQA6AABBmsAEQQA6AABBpsAEQdL0AS0AADoAAEGkwARB0PQBLwAAOwEAQbvABEEIOgAAQafABEEAOgAAQcvABEEDOgAAQbzABEHOATYCAEGwwARCysLBi+at2bnlADcDAEG4wARBADoAAEHCwARB1vQBLQAAOgAAQcDABEHU9AEvAAA7AQBBw8AEQQA6AABByLIFQQA2AgBBLUEQEA0hAEHIsgUoAgAhAUHIsgVBADYCACABQQFGDUVBzMAEIAA2AgBB0MAEQo2AgICAgoCAgH83AwAgAEEAOgANIABB3fQBKQAANwAFIABB2PQBKQAANwAAQefABEEDOgAAQdjABEHPATYCAEHcwARB5vQBLwAAOwEAQd7ABEHo9AEtAAA6AABB38AEQQA6AABByLIFQQA2AgBBLUEQEA0hAEHIsgUoAgAhAUHIsgVBADYCACABQQFGDUZB6MAEIAA2AgBB7MAEQoyAgICAgoCAgH83AgAgAEEAOgAMIABB8vQBKAAANgAIIABB6vQBKQAANwAAQYPBBEEDOgAAQfTABEHQATYCAEH4wARB9/QBLwAAOwEAQfrABEH59AEtAAA6AABB+8AEQQA6AABByLIFQQA2AgBBLUEQEA0hAEHIsgUoAgAhAUHIsgVBADYCACABQQFGDUdBhMEEIAA2AgBBiMEEQouAgICAgoCAgH83AwAgAEEAOgALIABBgvUBKAAANgAHIABB+/QBKQAANwAAQZ/BBEEDOgAAQZDBBEHRATYCAEGrwQRBBjoAAEG7wQRBAzoAAEGswQRB0gE2AgBBlMEEQYf1AS8AADsBAEGWwQRBifUBLQAAOgAAQaDBBEGL9QEoAAA2AgBBpMEEQY/1AS8AADsBAEGwwQRBkvUBLwAAOwEAQbLBBEGU9QEtAAA6AABBl8EEQQA6AABBpsEEQQA6AABByLIFQQA2AgBBs8EEQQA6AABBLUEQEA0hAEHIsgUoAgAhAUHIsgVBADYCACABQQFGDUhBvMEEIAA2AgBBwMEEQo+AgICAgoCAgH83AwAgAEEAOgAPIABBnfUBKQAANwAHIABBlvUBKQAANwAAQdfBBEEDOgAAQcjBBEHTATYCAEHMwQRBpvUBLwAAOwEAQc7BBEGo9QEtAAA6AABBz8EEQQA6AABByLIFQQA2AgBBLUEgEA0hAEHIsgUoAgAhAUHIsgVBADYCACABQQFGDUlB2MEEIAA2AgBB3MEEQpiAgICAhICAgH83AgAgAEEAOgAYIABBuvUBKQAANwAQIABBsvUBKQAANwAIIABBqvUBKQAANwAAQfPBBEEDOgAAQeTBBEHUATYCAEH/wQRBBToAAEGPwgRBAzoAAEGAwgRB1QE2AgBB6MEEQcP1AS8AADsBAEHqwQRBxfUBLQAAOgAAQfTBBEHH9QEoAAA2AgBB+MEEQcv1AS0AADoAAEGEwgRBzfUBLwAAOwEAQYbCBEHP9QEtAAA6AABB68EEQQA6AABB+cEEQQA6AABBm8IEQQc6AABBnMIEQdYBNgIAQavCBEEDOgAAQZDCBEHR9QEoAAA2AgBBk8IEQdT1ASgAADYAAEGgwgRB2fUBLwAAOwEAQaLCBEHb9QEtAAA6AABBh8IEQQA6AABBl8IEQQA6AABBo8IEQQA6AABByLIFQQA2AgBBLUEQEA0hAEHIsgUoAgAhAUHIsgVBADYCACABQQFGDUpBrMIEIAA2AgBBsMIEQo+AgICAgoCAgH83AwAgAEEAOgAPIABB5PUBKQAANwAHIABB3fUBKQAANwAAQcfCBEEDOgAAQbjCBEHXATYCAEHTwgRBCDoAAEHjwgRBAzoAAEHUwgRB2AE2AgBByMIEQsvCzcPWrZq56QA3AwBB78IEQQY6AABBvMIEQe31AS8AADsBAEG+wgRB7/UBLQAAOgAAQdjCBEHx9QEvAAA7AQBB2sIEQfP1AS0AADoAAEHowgRB+fUBLwAAOwAAQeTCBEH19QEoAAA2AgBBv8IEQQA6AABB0MIEQQA6AABB28IEQQA6AABB/8IEQQM6AABB8MIEQdkBNgIAQYvDBEEEOgAAQYDDBEHLwt3LBjYCAEGMwwRB2gE2AgBBm8MEQQM6AABBp8MEQQY6AABB9MIEQfz1AS8AADsBAEH2wgRB/vUBLQAAOgAAQZDDBEGA9gEvAAA7AQBBksMEQYL2AS0AADoAAEHqwgRBADoAAEH3wgRBADoAAEGEwwRBADoAAEGTwwRBADoAAEGgwwRBiPYBLwAAOwAAQZzDBEGE9gEoAAA2AgBBt8MEQQM6AABBqMMEQdsBNgIAQaLDBEEAOgAAQa7DBEGN9gEtAAA6AABBrMMEQYv2AS8AADsBAEHDwwRBCToAAEGvwwRBADoAAEHAwwRBl/YBLQAAOgAAQbjDBEGP9gEpAAA3AwBB08MEQQM6AABBxMMEQdwBNgIAQcHDBEEAOgAAQcrDBEGb9gEtAAA6AABByMMEQZn2AS8AADsBAEHfwwRBBToAAEHLwwRBADoAAEHYwwRBofYBLQAAOgAAQdTDBEGd9gEoAAA2AgBB78MEQQM6AABB4MMEQd0BNgIAQdnDBEEAOgAAQebDBEGl9gEtAAA6AABB5MMEQaP2AS8AADsBAEHnwwRBADoAAEHIsgVBADYCAEEtQRAQDSEAQciyBSgCACEBQciyBUEANgIAIAFBAUYNS0HwwwQgADYCAEH0wwRCj4CAgICCgICAfzcCACAAQQA6AA8gAEGu9gEpAAA3AAcgAEGn9gEpAAA3AABBi8QEQQM6AABB/MMEQd4BNgIAQYDEBEG39gEvAAA7AQBBgsQEQbn2AS0AADoAAEGDxARBADoAAEHIsgVBADYCAEEtQRAQDSEAQciyBSgCACEBQciyBUEANgIAIAFBAUYNTEGMxAQgADYCAEGQxARCjYCAgICCgICAfzcDACAAQQA6AA0gAEHA9gEpAAA3AAUgAEG79gEpAAA3AABBp8QEQQM6AABBmMQEQd8BNgIAQZzEBEHJ9gEvAAA7AQBBnsQEQcv2AS0AADoAAEGfxARBADoAAEHIsgVBADYCAEEtQSAQDSEAQciyBSgCACEBQciyBUEANgIAIAFBAUYNTUGoxAQgADYCAEGsxARCkICAgICEgICAfzcCACAAQQA6ABAgAEHV9gEpAAA3AAggAEHN9gEpAAA3AABBw8QEQQM6AABBtMQEQeABNgIAQbjEBEHe9gEvAAA7AQBBusQEQeD2AS0AADoAAEG7xARBADoAAEHIsgVBADYCAEEtQRAQDSEAQciyBSgCACEBQciyBUEANgIAIAFBAUYNTkHExAQgADYCAEHIxARCjoCAgICCgICAfzcDACAAQQA6AA4gAEHo9gEpAAA3AAYgAEHi9gEpAAA3AABB38QEQQM6AABB0MQEQeEBNgIAQdTEBEHx9gEvAAA7AQBB1sQEQfP2AS0AADoAAEHXxARBADoAAEHIsgVBADYCAEEtQRAQDSEAQciyBSgCACEBQciyBUEANgIAIAFBAUYNT0HgxAQgADYCAEHkxARCi4CAgICCgICAfzcCACAAQQA6AAsgAEH89gEoAAA2AAcgAEH19gEpAAA3AABB+8QEQQM6AABB7MQEQeIBNgIAQfDEBEGB9wEvAAA7AQBB8sQEQYP3AS0AADoAAEHzxARBADoAAEHIsgVBADYCAEEtQRAQDSEAQciyBSgCACEBQciyBUEANgIAIAFBAUYNUEH8xAQgADYCAEGAxQRCj4CAgICCgICAfzcDACAAQQA6AA8gAEGM9wEpAAA3AAcgAEGF9wEpAAA3AABBl8UEQQM6AABBiMUEQeMBNgIAQaPFBEEIOgAAQbPFBEEDOgAAQaTFBEHkATYCAEGYxQRCy9K1k9bOm7L1ADcDAEG/xQRBBzoAAEGMxQRBlfcBLwAAOwEAQY7FBEGX9wEtAAA6AABBqMUEQZn3AS8AADsBAEGqxQRBm/cBLQAAOgAAQbfFBEGg9wEoAAA2AABBtMUEQZ33ASgAADYCAEGPxQRBADoAAEGgxQRBADoAAEGrxQRBADoAAEHPxQRBAzoAAEHAxQRB5QE2AgBB28UEQQQ6AABB0MUEQcvetcsGNgIAQdzFBEHmATYCAEHrxQRBAzoAAEH3xQRBBToAAEHExQRBpfcBLwAAOwEAQcbFBEGn9wEtAAA6AABB4MUEQan3AS8AADsBAEHixQRBq/cBLQAAOgAAQbvFBEEAOgAAQcfFBEEAOgAAQdTFBEEAOgAAQePFBEEAOgAAQfDFBEGx9wEtAAA6AABB7MUEQa33ASgAADYCAEGHxgRBAzoAAEH4xQRB5wE2AgBB8cUEQQA6AABB/sUEQbX3AS0AADoAAEH8xQRBs/cBLwAAOwEAQZPGBEEGOgAAQf/FBEEAOgAAQYzGBEG79wEvAAA7AQBBiMYEQbf3ASgAADYCAEGjxgRBAzoAAEGUxgRB6AE2AgBBjsYEQQA6AABBmsYEQcD3AS0AADoAAEGYxgRBvvcBLwAAOwEAQa/GBEEIOgAAQZvGBEEAOgAAQb/GBEEDOgAAQbDGBEHpATYCAEGkxgRCy97Nk5es2bDuADcCAEGsxgRBADoAAEG2xgRBxPcBLQAAOgAAQbTGBEHC9wEvAAA7AQBBy8YEQQY6AABBt8YEQQA6AABBxMYEQcr3AS8AADsBAEHAxgRBxvcBKAAANgIAQdvGBEEDOgAAQczGBEHqATYCAEHGxgRBADoAAEHSxgRBz/cBLQAAOgAAQdDGBEHN9wEvAAA7AQBB08YEQQA6AABByLIFQQA2AgBBLUEQEA0hAEHIsgUoAgAhAUHIsgVBADYCACABQQFGDVFB3MYEIAA2AgBB4MYEQo+AgICAgoCAgH83AwAgAEEAOgAPIABB2PcBKQAANwAHIABB0fcBKQAANwAAQffGBEEDOgAAQejGBEHrATYCAEGDxwRBCDoAAEGTxwRBAzoAAEGExwRB7AE2AgBB+MYEQsvCyavGrdqw7gA3AwBB7MYEQeH3AS8AADsBAEHuxgRB4/cBLQAAOgAAQYjHBEHl9wEvAAA7AQBBiscEQef3AS0AADoAAEHvxgRBADoAAEGAxwRBADoAAEGLxwRBADoAAEHIsgVBADYCAEEtQRAQDSEAQciyBSgCACEBQciyBUEANgIAIAFBAUYNUkGUxwQgADYCAEGYxwRCjYCAgICCgICAfzcDACAAQQA6AA0gAEHu9wEpAAA3AAUgAEHp9wEpAAA3AABBr8cEQQM6AABBoMcEQe0BNgIAQbvHBEEGOgAAQcvHBEEDOgAAQbzHBEHuATYCAEGkxwRB9/cBLwAAOwEAQabHBEH59wEtAAA6AABBsMcEQfv3ASgAADYCAEG0xwRB//cBLwAAOwEAQcDHBEGC+AEvAAA7AQBBwscEQYT4AS0AADoAAEGnxwRBADoAAEG2xwRBADoAAEHIsgVBADYCAEHDxwRBADoAAEEtQSAQDSEAQciyBSgCACEBQciyBUEANgIAIAFBAUYNU0HMxwQgADYCAEHQxwRCkoCAgICEgICAfzcDACAAQQA6ABIgAEGW+AEvAAA7ABAgAEGO+AEpAAA3AAggAEGG+AEpAAA3AABB58cEQQM6AABB2McEQe8BNgIAQfPHBEEFOgAAQYPIBEEDOgAAQfTHBEHwATYCAEHcxwRBmfgBLwAAOwEAQd7HBEGb+AEtAAA6AABB6McEQZ34ASgAADYCAEHsxwRBofgBLQAAOgAAQfjHBEGj+AEvAAA7AQBB+scEQaX4AS0AADoAAEHfxwRBADoAAEHtxwRBADoAAEGPyARBBzoAAEGQyARB8QE2AgBBn8gEQQM6AABBq8gEQQc6AABBhMgEQaf4ASgAADYCAEGHyARBqvgBKAAANgAAQZTIBEGv+AEvAAA7AQBBlsgEQbH4AS0AADoAAEGgyARBs/gBKAAANgIAQaPIBEG2+AEoAAA2AABB+8cEQQA6AABBi8gEQQA6AABBl8gEQQA6AABBu8gEQQM6AABBrMgEQfIBNgIAQafIBEEAOgAAQbLIBEG9+AEtAAA6AABBsMgEQbv4AS8AADsBAEHHyARBBjoAAEGzyARBADoAAEHAyARBw/gBLwAAOwAAQbzIBEG/+AEoAAA2AgBB18gEQQM6AABByMgEQfMBNgIAQcLIBEEAOgAAQc7IBEHI+AEtAAA6AABBzMgEQcb4AS8AADsBAEHjyARBBjoAAEHPyARBADoAAEHcyARBzvgBLwAAOwEAQdjIBEHK+AEoAAA2AgBB88gEQQM6AABB5MgEQfQBNgIAQd7IBEEAOgAAQerIBEHT+AEtAAA6AABB6MgEQdH4AS8AADsBAEH/yARBBToAAEHryARBADoAAEH4yARB2fgBLQAAOgAAQfTIBEHV+AEoAAA2AgBBj8kEQQM6AABBgMkEQfUBNgIAQfnIBEEAOgAAQYbJBEHd+AEtAAA6AABBhMkEQdv4AS8AADsBAEGbyQRBAzoAAEGHyQRBADoAAEGSyQRB4fgBLQAAOgAAQZDJBEHf+AEvAAA7AQBBq8kEQQM6AABBnMkEQfYBNgIAQZPJBEEAOgAAQaLJBEHl+AEtAAA6AABBoMkEQeP4AS8AADsBAEG3yQRBBToAAEGjyQRBADoAAEGwyQRB6/gBLQAAOgAAQazJBEHn+AEoAAA2AgBBx8kEQQM6AABBuMkEQfcBNgIAQbHJBEEAOgAAQb7JBEHv+AEtAAA6AABBvMkEQe34AS8AADsBAEHTyQRBBzoAAEG/yQRBADoAAEHLyQRB9PgBKAAANgAAQcjJBEHx+AEoAAA2AgBB48kEQQM6AABB1MkEQfgBNgIAQc/JBEEAOgAAQdrJBEH7+AEtAAA6AABB2MkEQfn4AS8AADsBAEHvyQRBCDoAAEHbyQRBADoAAEH/yQRBAzoAAEHwyQRB+QE2AgBB5MkEQszK6buGrdqw7gA3AgBB7MkEQQA6AABB9skEQf/4AS0AADoAAEH0yQRB/fgBLwAAOwEAQffJBEEAOgAAQciyBUEANgIAQS1BMBANIQBByLIFKAIAIQFByLIFQQA2AgAgAUEBRg1UQYDKBCAANgIAQYTKBEKggICAgIaAgIB/NwIAIABBADoAICAAQZn5ASkAADcAGCAAQZH5ASkAADcAECAAQYn5ASkAADcACCAAQYH5ASkAADcAAEGbygRBAzoAAEGMygRB+gE2AgBBp8oEQQc6AABBt8oEQQM6AABBqMoEQfsBNgIAQZDKBEGi+QEvAAA7AQBBksoEQaT5AS0AADoAAEGcygRBpvkBKAAANgIAQZ/KBEGp+QEoAAA2AABBrMoEQa75AS8AADsBAEGuygRBsPkBLQAAOgAAQZPKBEEAOgAAQaPKBEEAOgAAQcLKBEGAFDsBAEHEygRB/AE2AgBB08oEQQM6AABB38oEQQU6AABBuMoEQbL5ASkAADcDAEHAygRBuvkBLwAAOwAAQcjKBEG9+QEvAAA7AQBBysoEQb/5AS0AADoAAEHUygRBwfkBKAAANgIAQdjKBEHF+QEtAAA6AABBr8oEQQA6AABBy8oEQQA6AABB78oEQQM6AABB4MoEQf0BNgIAQdnKBEEAOgAAQebKBEHJ+QEtAAA6AABB5MoEQcf5AS8AADsBAEH7ygRBBDoAAEHnygRBADoAAEGLywRBAzoAAEH8ygRB/gE2AgBB8MoEQcze6csGNgIAQfTKBEEAOgAAQYLLBEHN+QEtAAA6AABBgMsEQcv5AS8AADsBAEGDywRBADoAAEHIsgVBADYCAEEtQSAQDSEAQciyBSgCACEBQciyBUEANgIAIAFBAUYNVUGMywQgADYCAEGQywRCnICAgICEgICAfzcDACAAQQA6ABwgAEHn+QEoAAA2ABggAEHf+QEpAAA3ABAgAEHX+QEpAAA3AAggAEHP+QEpAAA3AABBp8sEQQM6AABBmMsEQf8BNgIAQcPLBEEDOgAAQbTLBEGAAjYCAEGyywRBgBQ7AQBBnMsEQez5AS8AADsBAEGeywRB7vkBLQAAOgAAQajLBEHw+QEpAAA3AwBBsMsEQfj5AS8AADsAAEG4ywRB+/kBLwAAOwEAQbrLBEH9+QEtAAA6AABBn8sEQQA6AABBu8sEQQA6AABByLIFQQA2AgBBLUEQEA0hAEHIsgUoAgAhAUHIsgVBADYCACABQQFGDVZBxMsEIAA2AgBByMsEQoyAgICAgoCAgH83AwAgAEEAOgAMIABBh/oBKAAANgAIIABB//kBKQAANwAAQd/LBEEDOgAAQdDLBEGBAjYCAEHrywRBBToAAEH7ywRBAzoAAEHsywRBggI2AgBB1MsEQYz6AS8AADsBAEHWywRBjvoBLQAAOgAAQeDLBEGQ+gEoAAA2AgBB5MsEQZT6AS0AADoAAEHwywRBlvoBLwAAOwEAQfLLBEGY+gEtAAA6AABB18sEQQA6AABB5csEQQA6AABBh8wEQQc6AABBiMwEQYMCNgIAQZfMBEEDOgAAQaPMBEEFOgAAQfzLBEGa+gEoAAA2AgBB/8sEQZ36ASgAADYAAEGMzARBovoBLwAAOwEAQY7MBEGk+gEtAAA6AABBmMwEQab6ASgAADYCAEGczARBqvoBLQAAOgAAQfPLBEEAOgAAQYPMBEEAOgAAQY/MBEEAOgAAQbPMBEEDOgAAQaTMBEGEAjYCAEGdzARBADoAAEGqzARBrvoBLQAAOgAAQajMBEGs+gEvAAA7AQBBq8wEQQA6AABByLIFQQA2AgBBLUEgEA0hAEHIsgUoAgAhAUHIsgVBADYCACABQQFGDVdBtMwEIAA2AgBBuMwEQpiAgICAhICAgH83AwAgAEEAOgAYIABBwPoBKQAANwAQIABBuPoBKQAANwAIIABBsPoBKQAANwAAQc/MBEEDOgAAQcDMBEGFAjYCAEHbzARBBjoAAEHrzARBAzoAAEHczARBhgI2AgBBxMwEQcn6AS8AADsBAEHGzARBy/oBLQAAOgAAQdDMBEHN+gEoAAA2AgBB1MwEQdH6AS8AADsBAEHgzARB1PoBLwAAOwEAQeLMBEHW+gEtAAA6AABBx8wEQQA6AABB1swEQQA6AABB9swEQYAUOwEAQfjMBEGHAjYCAEGHzQRBAzoAAEGTzQRBCDoAAEGIzQRCzcKRq6eu2bnlADcDAEGUzQRBiAI2AgBBo80EQQM6AABB7MwEQdj6ASkAADcCAEH0zARB4PoBLwAAOwEAQfzMBEHj+gEvAAA7AQBB/swEQeX6AS0AADoAAEHjzARBADoAAEH/zARBADoAAEGQzQRBADoAAEGazQRB6foBLQAAOgAAQZjNBEHn+gEvAAA7AQBBr80EQQY6AABBm80EQQA6AABBqM0EQe/6AS8AADsAAEGkzQRB6/oBKAAANgIAQb/NBEEDOgAAQbDNBEGJAjYCAEGqzQRBADoAAEG2zQRB9PoBLQAAOgAAQbTNBEHy+gEvAAA7AQBBt80EQQA6AABByLIFQQA2AgBBLUEQEA0hAEHIsgUoAgAhAUHIsgVBADYCACABQQFGDVhBwM0EIAA2AgBBxM0EQouAgICAgoCAgH83AgAgAEEAOgALIABB/foBKAAANgAHIABB9voBKQAANwAAQdvNBEEDOgAAQczNBEGKAjYCAEHnzQRBCDoAAEH3zQRBAzoAAEHozQRBiwI2AgBB3M0EQs3CpaOHrZq26QA3AgBBg84EQQc6AABB0M0EQYL7AS8AADsBAEHSzQRBhPsBLQAAOgAAQezNBEGG+wEvAAA7AQBB7s0EQYj7AS0AADoAAEH7zQRBjfsBKAAANgAAQfjNBEGK+wEoAAA2AgBB080EQQA6AABB5M0EQQA6AABB780EQQA6AABBk84EQQM6AABBhM4EQYwCNgIAQZ/OBEEJOgAAQaDOBEGNAjYCAEGvzgRBAzoAAEGIzgRBkvsBLwAAOwEAQYrOBEGU+wEtAAA6AABBlM4EQZb7ASkAADcCAEGczgRBnvsBLQAAOgAAQaTOBEGg+wEvAAA7AQBBps4EQaL7AS0AADoAAEH/zQRBADoAAEGLzgRBADoAAEGdzgRBADoAAEG7zgRBCDoAAEGnzgRBADoAAEHLzgRBAzoAAEG8zgRBjgI2AgBBsM4EQs3CuaOWzduz7wA3AwBBuM4EQQA6AABBws4EQab7AS0AADoAAEHAzgRBpPsBLwAAOwEAQdfOBEEFOgAAQcPOBEEAOgAAQdDOBEGs+wEtAAA6AABBzM4EQaj7ASgAADYCAEHnzgRBAzoAAEHYzgRBjwI2AgBB0c4EQQA6AABB3s4EQbD7AS0AADoAAEHczgRBrvsBLwAAOwEAQd/OBEEAOgAAQciyBUEANgIAQS1BIBANIQBByLIFKAIAIQFByLIFQQA2AgAgAUEBRg1ZQejOBCAANgIAQezOBEKUgICAgISAgIB/NwIAIABBADoAFCAAQcL7ASgAADYAECAAQbr7ASkAADcACCAAQbL7ASkAADcAAEGDzwRBAzoAAEH0zgRBkAI2AgBBj88EQQc6AABBn88EQQM6AABBkM8EQZECNgIAQfjOBEHH+wEvAAA7AQBB+s4EQcn7AS0AADoAAEGEzwRBy/sBKAAANgIAQYfPBEHO+wEoAAA2AABBlM8EQdP7AS8AADsBAEGWzwRB1fsBLQAAOgAAQfvOBEEAOgAAQYvPBEEAOgAAQavPBEEFOgAAQazPBEGSAjYCAEG7zwRBAzoAAEHHzwRBBToAAEGgzwRB1/sBKAAANgIAQaTPBEHb+wEtAAA6AABBsM8EQd37AS8AADsBAEGyzwRB3/sBLQAAOgAAQbzPBEHh+wEoAAA2AgBBwM8EQeX7AS0AADoAAEGXzwRBADoAAEGlzwRBADoAAEGzzwRBADoAAEHXzwRBAzoAAEHIzwRBkwI2AgBBwc8EQQA6AABBzs8EQen7AS0AADoAAEHMzwRB5/sBLwAAOwEAQePPBEEGOgAAQc/PBEEAOgAAQdzPBEHv+wEvAAA7AQBB2M8EQev7ASgAADYCAEHzzwRBAzoAAEHkzwRBlAI2AgBB3s8EQQA6AABB6s8EQfT7AS0AADoAAEHozwRB8vsBLwAAOwEAQf/PBEEGOgAAQevPBEEAOgAAQfjPBEH6+wEvAAA7AABB9M8EQfb7ASgAADYCAEGP0ARBAzoAAEGA0ARBlQI2AgBB+s8EQQA6AABBhtAEQf/7AS0AADoAAEGE0ARB/fsBLwAAOwEAQZvQBEEFOgAAQYfQBEEAOgAAQZTQBEGF/AEtAAA6AABBkNAEQYH8ASgAADYCAEGr0ARBAzoAAEGc0ARBlgI2AgBBldAEQQA6AABBotAEQYn8AS0AADoAAEGg0ARBh/wBLwAAOwEAQaPQBEEAOgAAQciyBUEANgIAQS1BIBANIQBByLIFKAIAIQFByLIFQQA2AgAgAUEBRg1aQazQBCAANgIAQbDQBEKYgICAgISAgIB/NwMAIABBADoAGCAAQZv8ASkAADcAECAAQZP8ASkAADcACCAAQYv8ASkAADcAAEHH0ARBAzoAAEG40ARBlwI2AgBBvNAEQaT8AS8AADsBAEG+0ARBpvwBLQAAOgAAQb/QBEEAOgAAQciyBUEANgIAQS1BEBANIQBByLIFKAIAIQFByLIFQQA2AgAgAUEBRg1bQcjQBCAANgIAQczQBEKPgICAgIKAgIB/NwIAIABBADoADyAAQa/8ASkAADcAByAAQaj8ASkAADcAAEHj0ARBAzoAAEHU0ARBmAI2AgBB2NAEQbj8AS8AADsBAEHa0ARBuvwBLQAAOgAAQdvQBEEAOgAAQciyBUEANgIAQS1BEBANIQBByLIFKAIAIQFByLIFQQA2AgAgAUEBRg1cQeTQBCAANgIAQejQBEKLgICAgIKAgIB/NwMAIABBADoACyAAQcP8ASgAADYAByAAQbz8ASkAADcAAEH/0ARBAzoAAEHw0ARBmQI2AgBB9NAEQcj8AS8AADsBAEH20ARByvwBLQAAOgAAQffQBEEAOgAAQciyBUEANgIAQS1BIBANIQBByLIFKAIAIQFByLIFQQA2AgAgAUEBRg1dQYDRBCAANgIAQYTRBEKRgICAgISAgIB/NwIAIABBADoAESAAQdz8AS0AADoAECAAQdT8ASkAADcACCAAQcz8ASkAADcAAEGb0QRBAzoAAEGM0QRBmgI2AgBBkNEEQd78AS8AADsBAEGS0QRB4PwBLQAAOgAAQZPRBEEAOgAAQciyBUEANgIAQS1BIBANIQBByLIFKAIAIQFByLIFQQA2AgAgAUEBRg1eQZzRBCAANgIAQaDRBEKRgICAgISAgIB/NwMAIABBADoAESAAQfL8AS0AADoAECAAQer8ASkAADcACCAAQeL8ASkAADcAAEG30QRBAzoAAEGo0QRBmwI2AgBBw9EEQQg6AABB09EEQQM6AABBxNEEQZwCNgIAQbjRBELNwrGL9qzYufkANwMAQd/RBEEHOgAAQazRBEH0/AEvAAA7AQBBrtEEQfb8AS0AADoAAEHI0QRB+PwBLwAAOwEAQcrRBEH6/AEtAAA6AABB19EEQf/8ASgAADYAAEHU0QRB/PwBKAAANgIAQa/RBEEAOgAAQcDRBEEAOgAAQcvRBEEAOgAAQe/RBEEDOgAAQeDRBEGdAjYCAEH70QRBBjoAAEH80QRBngI2AgBBi9IEQQM6AABB5NEEQYT9AS8AADsBAEHm0QRBhv0BLQAAOgAAQfDRBEGI/QEoAAA2AgBB9NEEQYz9AS8AADsBAEGA0gRBj/0BLwAAOwEAQYLSBEGR/QEtAAA6AABB29EEQQA6AABB59EEQQA6AABB9tEEQQA6AABBl9IEQQg6AABBg9IEQQA6AABBp9IEQQM6AABBmNIEQZ8CNgIAQYzSBELNwrnLhq6duekANwIAQZTSBEEAOgAAQZ7SBEGV/QEtAAA6AABBnNIEQZP9AS8AADsBAEGf0gRBADoAAEHIsgVBADYCAEEtQSAQDSEAQciyBSgCACEBQciyBUEANgIAIAFBAUYNX0Go0gQgADYCAEGs0gRCkICAgICEgICAfzcCACAAQQA6ABAgAEGf/QEpAAA3AAggAEGX/QEpAAA3AABBw9IEQQM6AABBtNIEQaACNgIAQc/SBEEGOgAAQd/SBEEDOgAAQdDSBEGhAjYCAEG40gRBqP0BLwAAOwEAQbrSBEGq/QEtAAA6AABBxNIEQaz9ASgAADYCAEHI0gRBsP0BLwAAOwAAQdTSBEGz/QEvAAA7AQBB1tIEQbX9AS0AADoAAEG70gRBADoAAEHK0gRBADoAAEHr0gRBCToAAEHs0gRBogI2AgBB+9IEQQM6AABBh9MEQQU6AABB4NIEQbf9ASkAADcDAEHo0gRBv/0BLQAAOgAAQfDSBEHB/QEvAAA7AQBB8tIEQcP9AS0AADoAAEH80gRBxf0BKAAANgIAQYDTBEHJ/QEtAAA6AABB19IEQQA6AABB6dIEQQA6AABB89IEQQA6AABBl9MEQQM6AABBiNMEQaMCNgIAQYHTBEEAOgAAQY7TBEHN/QEtAAA6AABBjNMEQcv9AS8AADsBAEGP0wRBADoAAEHIsgVBADYCAEEtQSAQDSEAQciyBSgCACEBQciyBUEANgIAIAFBAUYNYEGY0wQgADYCAEGc0wRCkoCAgICEgICAfzcCACAAQQA6ABIgAEHf/QEvAAA7ABAgAEHX/QEpAAA3AAggAEHP/QEpAAA3AABBs9MEQQM6AABBpNMEQaQCNgIAQajTBEHi/QEvAAA7AQBBqtMEQeT9AS0AADoAAEGr0wRBADoAAEHIsgVBADYCAEEtQRAQDSEAQciyBSgCACEBQciyBUEANgIAIAFBAUYNYUG00wQgADYCAEG40wRCj4CAgICCgICAfzcDACAAQQA6AA8gAEHt/QEpAAA3AAcgAEHm/QEpAAA3AABBz9MEQQM6AABBwNMEQaUCNgIAQdvTBEEFOgAAQevTBEEDOgAAQdzTBEGmAjYCAEHE0wRB9v0BLwAAOwEAQcbTBEH4/QEtAAA6AABB0NMEQfr9ASgAADYCAEHU0wRB/v0BLQAAOgAAQeDTBEGA/gEvAAA7AQBB4tMEQYL+AS0AADoAAEHH0wRBADoAAEHV0wRBADoAAEH30wRBCToAAEH40wRBpwI2AgBBh9QEQQM6AABBk9QEQQc6AABB7NMEQYT+ASkAADcCAEH00wRBjP4BLQAAOgAAQfzTBEGO/gEvAAA7AQBB/tMEQZD+AS0AADoAAEGI1ARBkv4BKAAANgIAQYvUBEGV/gEoAAA2AABB49MEQQA6AABB9dMEQQA6AABB/9MEQQA6AABBo9QEQQM6AABBlNQEQagCNgIAQY/UBEEAOgAAQZrUBEGc/gEtAAA6AABBmNQEQZr+AS8AADsBAEGb1ARBADoAAEHIsgVBADYCAEEtQRAQDSEAQciyBSgCACEBQciyBUEANgIAIAFBAUYNYkGk1AQgADYCAEGo1ARCj4CAgICCgICAfzcDACAAQQA6AA8gAEGl/gEpAAA3AAcgAEGe/gEpAAA3AABBv9QEQQM6AABBsNQEQakCNgIAQcvUBEEFOgAAQdvUBEEDOgAAQczUBEGqAjYCAEG01ARBrv4BLwAAOwEAQbbUBEGw/gEtAAA6AABBwNQEQbL+ASgAADYCAEHE1ARBtv4BLQAAOgAAQdDUBEG4/gEvAAA7AQBB0tQEQbr+AS0AADoAAEG31ARBADoAAEHF1ARBADoAAEHIsgVBADYCAEHT1ARBADoAAEEtQSAQDSEAQciyBSgCACEBQciyBUEANgIAIAFBAUYNY0Hc1AQgADYCAEHg1ARCkYCAgICEgICAfzcDACAAQQA6ABEgAEHM/gEtAAA6ABAgAEHE/gEpAAA3AAggAEG8/gEpAAA3AABB99QEQQM6AABB6NQEQasCNgIAQezUBEHO/gEvAAA7AQBB7tQEQdD+AS0AADoAAEHv1ARBADoAAEHIsgVBADYCAEEtQSAQDSEAQciyBSgCACEBQciyBUEANgIAIAFBAUYNZEH41AQgADYCAEH81ARClYCAgICEgICAfzcCACAAQQA6ABUgAEHf/gEpAAA3AA0gAEHa/gEpAAA3AAggAEHS/gEpAAA3AABBk9UEQQM6AABBhNUEQawCNgIAQa/VBEEDOgAAQaDVBEGtAjYCAEGe1QRBgBQ7AQBBu9UEQQU6AABBiNUEQej+AS8AADsBAEGK1QRB6v4BLQAAOgAAQZTVBEHs/gEpAAA3AgBBnNUEQfT+AS8AADsBAEGk1QRB9/4BLwAAOwEAQabVBEH5/gEtAAA6AABBi9UEQQA6AABBp9UEQQA6AABBvNUEQa4CNgIAQcvVBEEDOgAAQbTVBEH//gEtAAA6AABBsNUEQfv+ASgAADYCAEHA1QRBgf8BLwAAOwEAQcLVBEGD/wEtAAA6AABBtdUEQQA6AABBw9UEQQA6AABByLIFQQA2AgBBLUEQEA0hAEHIsgUoAgAhAUHIsgVBADYCACABQQFGDWVBzNUEIAA2AgBB0NUEQo6AgICAgoCAgH83AwAgAEEAOgAOIABBi/8BKQAANwAGIABBhf8BKQAANwAAQefVBEEDOgAAQdjVBEGvAjYCAEHc1QRBlP8BLwAAOwEAQd7VBEGW/wEtAAA6AABB39UEQQA6AABByLIFQQA2AgBBLUEgEA0hAEHIsgUoAgAhAUHIsgVBADYCACABQQFGDWZB6NUEIAA2AgBB7NUEQp2AgICAhICAgH83AgAgAEEAOgAdIABBrf8BKQAANwAVIABBqP8BKQAANwAQIABBoP8BKQAANwAIIABBmP8BKQAANwAAQYPWBEEDOgAAQfTVBEGwAjYCAEH41QRBtv8BLwAAOwEAQfrVBEG4/wEtAAA6AABB+9UEQQA6AABByLIFQQA2AgBBLUEgEA0hAEHIsgUoAgAhAUHIsgVBADYCACABQQFGDWdBhNYEIAA2AgBBiNYEQp2AgICAhICAgH83AwAgAEEAOgAdIABBz/8BKQAANwAVIABByv8BKQAANwAQIABBwv8BKQAANwAIIABBuv8BKQAANwAAQZ/WBEEDOgAAQZDWBEGxAjYCAEGr1gRBBjoAAEG71gRBAzoAAEGs1gRBsgI2AgBBlNYEQdj/AS8AADsBAEGW1gRB2v8BLQAAOgAAQaDWBEHc/wEoAAA2AgBBpNYEQeD/AS8AADsBAEGw1gRB4/8BLwAAOwEAQbLWBEHl/wEtAAA6AABBl9YEQQA6AABBptYEQQA6AABByLIFQQA2AgBBs9YEQQA6AABBLUEwEA0hAEHIsgUoAgAhAUHIsgVBADYCACABQQFGDWhBvNYEIAA2AgBBwNYEQq6AgICAhoCAgH83AwAgAEEAOgAuIABBjYACKQAANwAmIABBh4ACKQAANwAgIABB//8BKQAANwAYIABB9/8BKQAANwAQIABB7/8BKQAANwAIIABB5/8BKQAANwAAQdfWBEEDOgAAQcjWBEGzAjYCAEHj1gRBBjoAAEHz1gRBAzoAAEHk1gRBtAI2AgBBzNYEQZaAAi8AADsBAEHO1gRBmIACLQAAOgAAQdjWBEGagAIoAAA2AgBB3NYEQZ6AAi8AADsBAEHo1gRBoYACLwAAOwEAQerWBEGjgAItAAA6AABBz9YEQQA6AABB3tYEQQA6AABByLIFQQA2AgBB69YEQQA6AABBLUEgEA0hAEHIsgUoAgAhAUHIsgVBADYCACABQQFGDWlB9NYEIAA2AgBB+NYEQpOAgICAhICAgH83AwAgAEEAOgATIABBtIACKAAANgAPIABBrYACKQAANwAIIABBpYACKQAANwAAQY/XBEEDOgAAQYDXBEG1AjYCAEGb1wRBBDoAAEGr1wRBAzoAAEGc1wRBtgI2AgBBkNcEQc7ShZsHNgIAQYTXBEG5gAIvAAA7AQBBhtcEQbuAAi0AADoAAEGg1wRBvYACLwAAOwEAQaLXBEG/gAItAAA6AABBh9cEQQA6AABBlNcEQQA6AABBo9cEQQA6AABByLIFQQA2AgBBLUEgEA0hAEHIsgUoAgAhAUHIsgVBADYCACABQQFGDWpBrNcEIAA2AgBBsNcEQpmAgICAhICAgH83AwAgAEEAOgAZIABB2YACLQAAOgAYIABB0YACKQAANwAQIABByYACKQAANwAIIABBwYACKQAANwAAQcfXBEEDOgAAQbjXBEG3AjYCAEHT1wRBBjoAAEHj1wRBAzoAAEHU1wRBuAI2AgBBvNcEQduAAi8AADsBAEG+1wRB3YACLQAAOgAAQcjXBEHfgAIoAAA2AgBBzNcEQeOAAi8AADsBAEHY1wRB5oACLwAAOwEAQdrXBEHogAItAAA6AABBv9cEQQA6AABBztcEQQA6AABByLIFQQA2AgBB29cEQQA6AABBLUEwEA0hAEHIsgUoAgAhAUHIsgVBADYCACABQQFGDWtB5NcEIAA2AgBB6NcEQqWAgICAhoCAgH83AwAgAEEAOgAlIABBh4ECKQAANwAdIABBgoECKQAANwAYIABB+oACKQAANwAQIABB8oACKQAANwAIIABB6oACKQAANwAAQf/XBEEDOgAAQfDXBEG5AjYCAEH01wRBkIECLwAAOwEAQfbXBEGSgQItAAA6AABB99cEQQA6AABByLIFQQA2AgBBLUEwEA0hAEHIsgUoAgAhAUHIsgVBADYCACABQQFGDWxBgNgEIAA2AgBBhNgEQqWAgICAhoCAgH83AgAgAEEAOgAlIABBsYECKQAANwAdIABBrIECKQAANwAYIABBpIECKQAANwAQIABBnIECKQAANwAIIABBlIECKQAANwAAQZvYBEEDOgAAQYzYBEG6AjYCAEGn2ARBBToAAEG32ARBAzoAAEGo2ARBuwI2AgBBkNgEQbqBAi8AADsBAEGS2ARBvIECLQAAOgAAQZzYBEG+gQIoAAA2AgBBoNgEQcKBAi0AADoAAEGs2ARBxIECLwAAOwEAQa7YBEHGgQItAAA6AABBk9gEQQA6AABBodgEQQA6AABBwtgEQYAUOwEAQcTYBEG8AjYCAEHT2ARBAzoAAEHf2ARBCToAAEG42ARByIECKQAANwMAQcDYBEHQgQIvAAA7AABByNgEQdOBAi8AADsBAEHK2ARB1YECLQAAOgAAQdTYBEHXgQIpAAA3AgBB3NgEQd+BAi0AADoAAEGv2ARBADoAAEHL2ARBADoAAEHv2ARBAzoAAEHg2ARBvQI2AgBB3dgEQQA6AABB5tgEQeOBAi0AADoAAEHk2ARB4YECLwAAOwEAQfvYBEEEOgAAQefYBEEAOgAAQYvZBEEDOgAAQfzYBEG+AjYCAEHw2ARBzs6s+gY2AgBB9NgEQQA6AABBgtkEQeeBAi0AADoAAEGA2QRB5YECLwAAOwEAQYPZBEEAOgAAQciyBUEANgIAQS1BIBANIQBByLIFKAIAIQFByLIFQQA2AgAgAUEBRg1tQYzZBCAANgIAQZDZBEKcgICAgISAgIB/NwMAIABBADoAHCAAQYGCAigAADYAGCAAQfmBAikAADcAECAAQfGBAikAADcACCAAQemBAikAADcAAEGn2QRBAzoAAEGY2QRBvwI2AgBBnNkEQYaCAi8AADsBAEGe2QRBiIICLQAAOgAAQZ/ZBEEAOgAAQciyBUEANgIAQS1BIBANIQBByLIFKAIAIQFByLIFQQA2AgAgAUEBRg1uQajZBCAANgIAQazZBEKQgICAgISAgIB/NwIAIABBADoAECAAQZKCAikAADcACCAAQYqCAikAADcAAEHD2QRBAzoAAEG02QRBwAI2AgBBuNkEQZuCAi8AADsBAEG62QRBnYICLQAAOgAAQbvZBEEAOgAAQciyBUEANgIAQS1BwAAQDSEAQciyBSgCACEBQciyBUEANgIAIAFBAUYNb0HE2QQgADYCAEHI2QRCs4CAgICIgICAfzcDACAAQQA6ADMgAEHOggIoAAA2AC8gAEHHggIpAAA3ACggAEG/ggIpAAA3ACAgAEG3ggIpAAA3ABggAEGvggIpAAA3ABAgAEGnggIpAAA3AAggAEGfggIpAAA3AABB39kEQQM6AABB0NkEQcECNgIAQdTZBEHTggIvAAA7AQBB1tkEQdWCAi0AADoAAEHX2QRBADoAAEHIsgVBADYCAEEtQSAQDSEAQciyBSgCACEBQciyBUEANgIAIAFBAUYNcEHg2QQgADYCAEHk2QRCl4CAgICEgICAfzcCACAAQQA6ABcgAEHmggIpAAA3AA8gAEHfggIpAAA3AAggAEHXggIpAAA3AABB+9kEQQM6AABB7NkEQcICNgIAQYfaBEEIOgAAQZfaBEEDOgAAQYjaBEHDAjYCAEH82QRCzvKF6/aumb3pADcCAEGj2gRBCDoAAEGz2gRBAzoAAEGk2gRBxAI2AgBBmNoEQs7yhfO27Zu25QA3AwBB8NkEQe+CAi8AADsBAEHy2QRB8YICLQAAOgAAQYzaBEHzggIvAAA7AQBBjtoEQfWCAi0AADoAAEHz2QRBADoAAEGE2gRBADoAAEGP2gRBADoAAEGg2gRBADoAAEG/2gRBBToAAEHA2gRBxQI2AgBBz9oEQQM6AABB29oEQQU6AABBqtoEQfmCAi0AADoAAEGo2gRB94ICLwAAOwEAQbTaBEH7ggIoAAA2AgBBuNoEQf+CAi0AADoAAEHE2gRBgYMCLwAAOwEAQcbaBEGDgwItAAA6AABBq9oEQQA6AABBudoEQQA6AABBx9oEQQA6AABB1NoEQYmDAi0AADoAAEHQ2gRBhYMCKAAANgIAQevaBEEDOgAAQdzaBEHGAjYCAEHV2gRBADoAAEHi2gRBjYMCLQAAOgAAQeDaBEGLgwIvAAA7AQBB49oEQQA6AABByLIFQQA2AgBBLUEgEA0hAEHIsgUoAgAhAUHIsgVBADYCACABQQFGDXFB7NoEIAA2AgBB8NoEQp+AgICAhICAgH83AwAgAEEAOgAfIABBpoMCKQAANwAXIABBn4MCKQAANwAQIABBl4MCKQAANwAIIABBj4MCKQAANwAAQYfbBEEDOgAAQfjaBEHHAjYCAEGT2wRBBjoAAEGj2wRBAzoAAEGU2wRByAI2AgBB/NoEQa+DAi8AADsBAEH+2gRBsYMCLQAAOgAAQYjbBEGzgwIoAAA2AgBBjNsEQbeDAi8AADsBAEGY2wRBuoMCLwAAOwEAQZrbBEG8gwItAAA6AABB/9oEQQA6AABBjtsEQQA6AABBr9sEQQU6AABBsNsEQckCNgIAQb/bBEEDOgAAQcvbBEEFOgAAQaTbBEG+gwIoAAA2AgBBqNsEQcKDAi0AADoAAEG02wRBxIMCLwAAOwEAQbbbBEHGgwItAAA6AABBwNsEQciDAigAADYCAEHE2wRBzIMCLQAAOgAAQZvbBEEAOgAAQanbBEEAOgAAQbfbBEEAOgAAQdvbBEEDOgAAQczbBEHKAjYCAEHF2wRBADoAAEHS2wRB0IMCLQAAOgAAQdDbBEHOgwIvAAA7AQBB59sEQQU6AABB09sEQQA6AABB4NsEQdaDAi0AADoAAEHc2wRB0oMCKAAANgIAQffbBEEDOgAAQejbBEHLAjYCAEHh2wRBADoAAEHu2wRB2oMCLQAAOgAAQezbBEHYgwIvAAA7AQBB79sEQQA6AABByLIFQQA2AgBBLUEgEA0hAEHIsgUoAgAhAUHIsgVBADYCACABQQFGDXJB+NsEIAA2AgBB/NsEQpGAgICAhICAgH83AgAgAEEAOgARIABB7IMCLQAAOgAQIABB5IMCKQAANwAIIABB3IMCKQAANwAAQZPcBEEDOgAAQYTcBEHMAjYCAEGI3ARB7oMCLwAAOwEAQYrcBEHwgwItAAA6AABBi9wEQQA6AABByLIFQQA2AgBBLUEgEA0hAEHIsgUoAgAhAUHIsgVBADYCACABQQFGDXNBlNwEIAA2AgBBmNwEQpyAgICAhICAgH83AwAgAEEAOgAcIABBioQCKAAANgAYIABBgoQCKQAANwAQIABB+oMCKQAANwAIIABB8oMCKQAANwAAQa/cBEEDOgAAQaDcBEHNAjYCAEGk3ARBj4QCLwAAOwEAQabcBEGRhAItAAA6AABBp9wEQQA6AABByLIFQQA2AgBBLUEgEA0hAEHIsgUoAgAhAUHIsgVBADYCACABQQFGDXRBsNwEIAA2AgBBtNwEQpGAgICAhICAgH83AgAgAEEAOgARIABBo4QCLQAAOgAQIABBm4QCKQAANwAIIABBk4QCKQAANwAAQcvcBEEDOgAAQbzcBEHOAjYCAEHA3ARBpYQCLwAAOwEAQcLcBEGnhAItAAA6AABBw9wEQQA6AABByLIFQQA2AgBBLUEQEA0hAEHIsgUoAgAhAUHIsgVBADYCACABQQFGDXVBzNwEIAA2AgBB0NwEQo6AgICAgoCAgH83AwAgAEEAOgAOIABBr4QCKQAANwAGIABBqYQCKQAANwAAQefcBEEDOgAAQdjcBEHPAjYCAEGD3QRBAzoAAEH03ARB0AI2AgBB8twEQYAUOwEAQY/dBEEHOgAAQdzcBEG4hAIvAAA7AQBB3twEQbqEAi0AADoAAEHo3ARBvIQCKQAANwMAQfDcBEHEhAIvAAA7AABB+NwEQceEAi8AADsBAEH63ARByYQCLQAAOgAAQd/cBEEAOgAAQfvcBEEAOgAAQZDdBEHRAjYCAEGf3QRBAzoAAEGH3QRBzoQCKAAANgAAQYTdBEHLhAIoAAA2AgBBlN0EQdOEAi8AADsBAEGW3QRB1YQCLQAAOgAAQYvdBEEAOgAAQZfdBEEAOgAAQciyBUEANgIAQS1BIBANIQBByLIFKAIAIQFByLIFQQA2AgAgAUEBRg12QaDdBCAANgIAQaTdBEKVgICAgISAgIB/NwIAIABBADoAFSAAQeSEAikAADcADSAAQd+EAikAADcACCAAQdeEAikAADcAAEG73QRBAzoAAEGs3QRB0gI2AgBBsN0EQe2EAi8AADsBAEGy3QRB74QCLQAAOgAAQbPdBEEAOgAAQciyBUEANgIAQS1BIBANIQBByLIFKAIAIQFByLIFQQA2AgAgAUEBRg13QbzdBCAANgIAQcDdBEKQgICAgISAgIB/NwMAIABBADoAECAAQfmEAikAADcACCAAQfGEAikAADcAAEHX3QRBAzoAAEHI3QRB0wI2AgBB890EQQM6AABB5N0EQdQCNgIAQeLdBEGAFDsBAEH/3QRBBzoAAEHM3QRBgoUCLwAAOwEAQc7dBEGEhQItAAA6AABB2N0EQYaFAikAADcDAEHg3QRBjoUCLwAAOwAAQejdBEGRhQIvAAA7AQBB6t0EQZOFAi0AADoAAEHP3QRBADoAAEHr3QRBADoAAEGA3gRB1QI2AgBBj94EQQM6AABB990EQZiFAigAADYAAEH03QRBlYUCKAAANgIAQYTeBEGdhQIvAAA7AQBBht4EQZ+FAi0AADoAAEH73QRBADoAAEGH3gRBADoAAEHIsgVBADYCAEEtQSAQDSEAQciyBSgCACEBQciyBUEANgIAIAFBAUYNeEGQ3gQgADYCAEGU3gRCnoCAgICEgICAfzcCACAAQQA6AB4gAEG3hQIpAAA3ABYgAEGxhQIpAAA3ABAgAEGphQIpAAA3AAggAEGhhQIpAAA3AABBq94EQQM6AABBnN4EQdYCNgIAQbfeBEEHOgAAQcfeBEEDOgAAQbjeBEHXAjYCAEGg3gRBwIUCLwAAOwEAQaLeBEHChQItAAA6AABBrN4EQcSFAigAADYCAEGv3gRBx4UCKAAANgAAQbzeBEHMhQIvAAA7AQBBvt4EQc6FAi0AADoAAEGj3gRBADoAAEGz3gRBADoAAEHIsgVBADYCAEG/3gRBADoAAEEtQSAQDSEAQciyBSgCACEBQciyBUEANgIAIAFBAUYNeUHI3gQgADYCAEHM3gRCkoCAgICEgICAfzcCACAAQQA6ABIgAEHghQIvAAA7ABAgAEHYhQIpAAA3AAggAEHQhQIpAAA3AABB494EQQM6AABB1N4EQdgCNgIAQf/eBEEDOgAAQfDeBEHZAjYCAEHu3gRBgBQ7AQBBi98EQQQ6AABB2N4EQeOFAi8AADsBAEHa3gRB5YUCLQAAOgAAQeTeBEHnhQIpAAA3AgBB7N4EQe+FAi8AADsBAEH03gRB8oUCLwAAOwEAQfbeBEH0hQItAAA6AABB294EQQA6AABB994EQQA6AABBm98EQQM6AABBjN8EQdoCNgIAQYDfBEHQwrHLBjYCAEGn3wRBBjoAAEGo3wRB2wI2AgBBt98EQQM6AABBkN8EQfaFAi8AADsBAEGS3wRB+IUCLQAAOgAAQZzfBEH6hQIoAAA2AgBBoN8EQf6FAi8AADsAAEGs3wRBgYYCLwAAOwEAQa7fBEGDhgItAAA6AABBhN8EQQA6AABBk98EQQA6AABBot8EQQA6AABBw98EQQk6AABBr98EQQA6AABBwN8EQY2GAi0AADoAAEG43wRBhYYCKQAANwMAQdPfBEEDOgAAQcTfBEHcAjYCAEHB3wRBADoAAEHK3wRBkYYCLQAAOgAAQcjfBEGPhgIvAAA7AQBB398EQQo6AABBy98EQQA6AABB3N8EQZuGAi8AADsBAEHU3wRBk4YCKQAANwIAQe/fBEEDOgAAQeDfBEHdAjYCAEHe3wRBADoAAEHm3wRBoIYCLQAAOgAAQeTfBEGehgIvAAA7AQBB598EQQA6AABByLIFQQA2AgBBLUEgEA0hAEHIsgUoAgAhAUHIsgVBADYCACABQQFGDXpB8N8EIAA2AgBB9N8EQpGAgICAhICAgH83AgAgAEEAOgARIABBsoYCLQAAOgAQIABBqoYCKQAANwAIIABBooYCKQAANwAAQYvgBEEDOgAAQfzfBEHeAjYCAEGA4ARBtIYCLwAAOwEAQYLgBEG2hgItAAA6AABBg+AEQQA6AABByLIFQQA2AgBBLUEgEA0hAEHIsgUoAgAhAUHIsgVBADYCACABQQFGDXtBjOAEIAA2AgBBkOAEQpmAgICAhICAgH83AwAgAEEAOgAZIABB0IYCLQAAOgAYIABByIYCKQAANwAQIABBwIYCKQAANwAIIABBuIYCKQAANwAAQafgBEEDOgAAQZjgBEHfAjYCAEGc4ARB0oYCLwAAOwEAQZ7gBEHUhgItAAA6AABBn+AEQQA6AABByLIFQQA2AgBBLUEQEA0hAEHIsgUoAgAhAUHIsgVBADYCACABQQFGDXxBqOAEIAA2AgBBrOAEQo6AgICAgoCAgH83AgAgAEEAOgAOIABB3IYCKQAANwAGIABB1oYCKQAANwAAQcPgBEEDOgAAQbTgBEHgAjYCAEHP4ARBBzoAAEHf4ARBAzoAAEHQ4ARB4QI2AgBBuOAEQeWGAi8AADsBAEG64ARB54YCLQAAOgAAQcTgBEHphgIoAAA2AgBBx+AEQeyGAigAADYAAEHU4ARB8YYCLwAAOwEAQdbgBEHzhgItAAA6AABBu+AEQQA6AABBy+AEQQA6AABB6uAEQYAUOwEAQezgBEHiAjYCAEH74ARBAzoAAEGH4QRBBzoAAEHg4ARB9YYCKQAANwMAQejgBEH9hgIvAAA7AQBB8OAEQYCHAi8AADsBAEHy4ARBgocCLQAAOgAAQfzgBEGEhwIoAAA2AgBB/+AEQYeHAigAADYAAEHX4ARBADoAAEHz4ARBADoAAEGX4QRBAzoAAEGI4QRB4wI2AgBBg+EEQQA6AABBjuEEQY6HAi0AADoAAEGM4QRBjIcCLwAAOwEAQY/hBEEAOgAAQciyBUEANgIAQS1BIBANIQBByLIFKAIAIQFByLIFQQA2AgAgAUEBRg19QZjhBCAANgIAQZzhBEKegICAgISAgIB/NwIAIABBADoAHiAAQaaHAikAADcAFiAAQaCHAikAADcAECAAQZiHAikAADcACCAAQZCHAikAADcAAEGz4QRBAzoAAEGk4QRB5AI2AgBBqOEEQa+HAi8AADsBAEGq4QRBsYcCLQAAOgAAQavhBEEAOgAAQciyBUEANgIAQS1BEBANIQBByLIFKAIAIQFByLIFQQA2AgAgAUEBRg1+QbThBCAANgIAQbjhBEKPgICAgIKAgIB/NwMAIABBADoADyAAQbqHAikAADcAByAAQbOHAikAADcAAEHP4QRBAzoAAEHA4QRB5QI2AgBB2+EEQQc6AABB6+EEQQM6AABB3OEEQeYCNgIAQcThBEHDhwIvAAA7AQBBxuEEQcWHAi0AADoAAEHQ4QRBx4cCKAAANgIAQdPhBEHKhwIoAAA2AABB4OEEQc+HAi8AADsBAEHi4QRB0YcCLQAAOgAAQcfhBEEAOgAAQdfhBEEAOgAAQffhBEEGOgAAQfjhBEHnAjYCAEGH4gRBAzoAAEHs4QRB04cCKAAANgIAQfDhBEHXhwIvAAA7AABB/OEEQdqHAi8AADsBAEH+4QRB3IcCLQAAOgAAQePhBEEAOgAAQfLhBEEAOgAAQf/hBEEAOgAAQciyBUEANgIAQS1BIBANIQBByLIFKAIAIQFByLIFQQA2AgAgAUEBRg1/QYjiBCAANgIAQYziBEKdgICAgISAgIB/NwIAIABBADoAHSAAQfOHAikAADcAFSAAQe6HAikAADcAECAAQeaHAikAADcACCAAQd6HAikAADcAAEGj4gRBAzoAAEGU4gRB6AI2AgBBr+IEQQU6AABBv+IEQQM6AABBsOIEQekCNgIAQZjiBEH8hwIvAAA7AQBBmuIEQf6HAi0AADoAAEGk4gRBgIgCKAAANgIAQajiBEGEiAItAAA6AABBtOIEQYaIAi8AADsBAEG24gRBiIgCLQAAOgAAQZviBEEAOgAAQaniBEEAOgAAQciyBUEANgIAQbfiBEEAOgAAQS1BMBANIQBByLIFKAIAIQFByLIFQQA2AgAgAUEBRg2AAUHA4gQgADYCAEHE4gRCpYCAgICGgICAfzcCACAAQQA6ACUgAEGniAIpAAA3AB0gAEGiiAIpAAA3ABggAEGaiAIpAAA3ABAgAEGSiAIpAAA3AAggAEGKiAIpAAA3AABB2+IEQQM6AABBzOIEQeoCNgIAQefiBEEHOgAAQffiBEEDOgAAQejiBEHrAjYCAEHQ4gRBsIgCLwAAOwEAQdLiBEGyiAItAAA6AABB3OIEQbSIAigAADYCAEHf4gRBt4gCKAAANgAAQeziBEG8iAIvAAA7AQBB7uIEQb6IAi0AADoAAEHT4gRBADoAAEHj4gRBADoAAEGD4wRBBzoAAEGE4wRB7AI2AgBBk+MEQQM6AABBn+MEQQU6AABB+OIEQcCIAigAADYCAEH74gRBw4gCKAAANgAAQYjjBEHIiAIvAAA7AQBBiuMEQcqIAi0AADoAAEGU4wRBzIgCKAAANgIAQZjjBEHQiAItAAA6AABB7+IEQQA6AABB/+IEQQA6AABBi+MEQQA6AABBr+MEQQM6AABBoOMEQe0CNgIAQZnjBEEAOgAAQabjBEHUiAItAAA6AABBpOMEQdKIAi8AADsBAEG74wRBBToAAEGn4wRBADoAAEG04wRB2ogCLQAAOgAAQbDjBEHWiAIoAAA2AgBBy+MEQQM6AABBvOMEQe4CNgIAQbXjBEEAOgAAQcLjBEHeiAItAAA6AABBwOMEQdyIAi8AADsBAEHD4wRBADoAAEHIsgVBADYCAEEtQSAQDSEAQciyBSgCACEBQciyBUEANgIAIAFBAUYNgQFBzOMEIAA2AgBB0OMEQp2AgICAhICAgH83AwAgAEEAOgAdIABB9YgCKQAANwAVIABB8IgCKQAANwAQIABB6IgCKQAANwAIIABB4IgCKQAANwAAQefjBEEDOgAAQdjjBEHvAjYCAEHc4wRB/ogCLwAAOwEAQd7jBEGAiQItAAA6AABB3+MEQQA6AABByLIFQQA2AgBBLUEgEA0hAEHIsgUoAgAhAUHIsgVBADYCACABQQFGDYIBQejjBCAANgIAQezjBEKSgICAgISAgIB/NwIAIABBADoAEiAAQZKJAi8AADsAECAAQYqJAikAADcACCAAQYKJAikAADcAAEGD5ARBAzoAAEH04wRB8AI2AgBB+OMEQZWJAi8AADsBAEH64wRBl4kCLQAAOgAAQfvjBEEAOgAAQciyBUEANgIAQS1BIBANIQBByLIFKAIAIQFByLIFQQA2AgAgAUEBRg2DAUGE5AQgADYCAEGI5ARCkYCAgICEgICAfzcDACAAQQA6ABEgAEGpiQItAAA6ABAgAEGhiQIpAAA3AAggAEGZiQIpAAA3AABBn+QEQQM6AABBkOQEQfECNgIAQavkBEEIOgAAQbvkBEEDOgAAQazkBEHyAjYCAEGg5ARC08K5m7fN3LT0ADcDAEHH5ARBBToAAEGU5ARBq4kCLwAAOwEAQZbkBEGtiQItAAA6AABBsOQEQa+JAi8AADsBAEGy5ARBsYkCLQAAOgAAQcDkBEG3iQItAAA6AABBvOQEQbOJAigAADYCAEGX5ARBADoAAEGo5ARBADoAAEGz5ARBADoAAEHX5ARBAzoAAEHI5ARB8wI2AgBB4+QEQQc6AABB5OQEQfQCNgIAQfPkBEEDOgAAQczkBEG5iQIvAAA7AQBBzuQEQbuJAi0AADoAAEHY5ARBvYkCKAAANgIAQdvkBEHAiQIoAAA2AABB6OQEQcWJAi8AADsBAEHq5ARBx4kCLQAAOgAAQcHkBEEAOgAAQc/kBEEAOgAAQd/kBEEAOgAAQf/kBEEIOgAAQevkBEEAOgAAQY/lBEEDOgAAQYDlBEH1AjYCAEH05ARC09KNy8at2rDuADcCAEH85ARBADoAAEGG5QRBy4kCLQAAOgAAQYTlBEHJiQIvAAA7AQBBm+UEQQU6AABBh+UEQQA6AABBlOUEQdGJAi0AADoAAEGQ5QRBzYkCKAAANgIAQavlBEEDOgAAQZzlBEH2AjYCAEGV5QRBADoAAEGi5QRB1YkCLQAAOgAAQaDlBEHTiQIvAAA7AQBBt+UEQQY6AABBo+UEQQA6AABBsOUEQduJAi8AADsAAEGs5QRB14kCKAAANgIAQcflBEEDOgAAQbjlBEH3AjYCAEGy5QRBADoAAEG+5QRB4IkCLQAAOgAAQbzlBEHeiQIvAAA7AQBBv+UEQQA6AABByLIFQQA2AgBBLUEQEA0hAEHIsgUoAgAhAUHIsgVBADYCACABQQFGDYQBQcjlBCAANgIAQczlBEKPgICAgIKAgIB/NwIAIABBADoADyAAQemJAikAADcAByAAQeKJAikAADcAAEHj5QRBAzoAAEHU5QRB+AI2AgBB2OUEQfKJAi8AADsBAEHa5QRB9IkCLQAAOgAAQdvlBEEAOgAAQciyBUEANgIAQS1BIBANIQBByLIFKAIAIQFByLIFQQA2AgAgAUEBRg2FAUHk5QQgADYCAEHo5QRCk4CAgICEgICAfzcDACAAQQA6ABMgAEGFigIoAAA2AA8gAEH+iQIpAAA3AAggAEH2iQIpAAA3AABB/+UEQQM6AABB8OUEQfkCNgIAQfTlBEGKigIvAAA7AQBB9uUEQYyKAi0AADoAAEH35QRBADoAAEHIsgVBADYCAEEtQRAQDSEAQciyBSgCACEBQciyBUEANgIAIAFBAUYNhgFBgOYEIAA2AgBBhOYEQo6AgICAgoCAgH83AgAgAEEAOgAOIABBlIoCKQAANwAGIABBjooCKQAANwAAQZvmBEEDOgAAQYzmBEH6AjYCAEGn5gRBBDoAAEG35gRBAzoAAEGo5gRB+wI2AgBBnOYEQdPQhfMGNgIAQcPmBEEGOgAAQZDmBEGdigIvAAA7AQBBkuYEQZ+KAi0AADoAAEGs5gRBoYoCLwAAOwEAQa7mBEGjigItAAA6AABBvOYEQamKAi8AADsBAEG45gRBpYoCKAAANgIAQZPmBEEAOgAAQaDmBEEAOgAAQa/mBEEAOgAAQdPmBEEDOgAAQcTmBEH8AjYCAEHI5gRBrIoCLwAAOwEAQcrmBEGuigItAAA6AABBvuYEQQA6AABBy+YEQQA6AABByLIFQQA2AgBBLUEgEA0hAEHIsgUoAgAhAUHIsgVBADYCACABQQFGDYcBQdTmBCAANgIAQdjmBEKSgICAgISAgIB/NwMAIABBADoAEiAAQcCKAi8AADsAECAAQbiKAikAADcACCAAQbCKAikAADcAAEHv5gRBAzoAAEHg5gRB/QI2AgBB5OYEQcOKAi8AADsBAEHm5gRBxYoCLQAAOgAAQefmBEEAOgAAQciyBUEANgIAQS1BIBANIQBByLIFKAIAIQFByLIFQQA2AgAgAUEBRg2IAUHw5gQgADYCAEH05gRCkICAgICEgICAfzcCACAAQQA6ABAgAEHPigIpAAA3AAggAEHHigIpAAA3AABBi+cEQQM6AABB/OYEQf4CNgIAQYDnBEHYigIvAAA7AQBBgucEQdqKAi0AADoAAEGD5wRBADoAAEHIsgVBADYCAEEtQSAQDSEAQciyBSgCACEBQciyBUEANgIAIAFBAUYNiQFBjOcEIAA2AgBBkOcEQpSAgICAhICAgH83AwAgAEEAOgAUIABB7IoCKAAANgAQIABB5IoCKQAANwAIIABB3IoCKQAANwAAQafnBEEDOgAAQZjnBEH/AjYCAEGc5wRB8YoCLwAAOwEAQZ7nBEHzigItAAA6AABBn+cEQQA6AABByLIFQQA2AgBBLUEQEA0hAEHIsgUoAgAhAUHIsgVBADYCACABQQFGDYoBQajnBCAANgIAQaznBEKOgICAgIKAgIB/NwIAIABBADoADiAAQfuKAikAADcABiAAQfWKAikAADcAAEHD5wRBAzoAAEG05wRBgAM2AgBBz+cEQQY6AABB3+cEQQM6AABB0OcEQYEDNgIAQbjnBEGEiwIvAAA7AQBBuucEQYaLAi0AADoAAEHE5wRBiIsCKAAANgIAQcjnBEGMiwIvAAA7AABB1OcEQY+LAi8AADsBAEHW5wRBkYsCLQAAOgAAQbvnBEEAOgAAQcrnBEEAOgAAQevnBEEJOgAAQeznBEGCAzYCAEH75wRBAzoAAEHg5wRBk4sCKQAANwMAQejnBEGbiwItAAA6AABB8OcEQZ2LAi8AADsBAEHy5wRBn4sCLQAAOgAAQdfnBEEAOgAAQennBEEAOgAAQfPnBEEAOgAAQciyBUEANgIAQS1BEBANIQBByLIFKAIAIQFByLIFQQA2AgAgAUEBRg2LAUH85wQgADYCAEGA6ARCjYCAgICCgICAfzcDACAAQQA6AA0gAEGmiwIpAAA3AAUgAEGhiwIpAAA3AABBl+gEQQM6AABBiOgEQYMDNgIAQYzoBEGviwIvAAA7AQBBjugEQbGLAi0AADoAAEGP6ARBADoAAEHIsgVBADYCAEEtQRAQDSEAQciyBSgCACEBQciyBUEANgIAIAFBAUYNjAFBmOgEIAA2AgBBnOgEQo2AgICAgoCAgH83AgAgAEEAOgANIABBuIsCKQAANwAFIABBs4sCKQAANwAAQbPoBEEDOgAAQaToBEGEAzYCAEGo6ARBwYsCLwAAOwEAQaroBEHDiwItAAA6AABBq+gEQQA6AABByLIFQQA2AgBBLUEgEA0hAEHIsgUoAgAhAUHIsgVBADYCACABQQFGDY0BQbToBCAANgIAQbjoBEKWgICAgISAgIB/NwMAIABBADoAFiAAQdOLAikAADcADiAAQc2LAikAADcACCAAQcWLAikAADcAAEHP6ARBAzoAAEHA6ARBhQM2AgBB2+gEQQk6AABB6+gEQQM6AABB3OgEQYYDNgIAQcToBEHciwIvAAA7AQBBxugEQd6LAi0AADoAAEHQ6ARB4IsCKQAANwMAQdjoBEHoiwItAAA6AABB4OgEQeqLAi8AADsBAEHi6ARB7IsCLQAAOgAAQcfoBEEAOgAAQdnoBEEAOgAAQfboBEGAFDsBAEH46ARBhwM2AgBBh+kEQQM6AABBk+kEQQY6AABB7OgEQe6LAikAADcCAEH06ARB9osCLwAAOwEAQfzoBEH5iwIvAAA7AQBB/ugEQfuLAi0AADoAAEGI6QRB/YsCKAAANgIAQYzpBEGBjAIvAAA7AQBB4+gEQQA6AABB/+gEQQA6AABBo+kEQQM6AABBlOkEQYgDNgIAQY7pBEEAOgAAQZrpBEGGjAItAAA6AABBmOkEQYSMAi8AADsBAEGv6QRBCjoAAEGb6QRBADoAAEGs6QRBkIwCLwAAOwEAQaTpBEGIjAIpAAA3AgBBv+kEQQM6AABBsOkEQYkDNgIAQa7pBEEAOgAAQbbpBEGVjAItAAA6AABBtOkEQZOMAi8AADsBAEHL6QRBBToAAEG36QRBADoAAEHE6QRBm4wCLQAAOgAAQcDpBEGXjAIoAAA2AgBB2+kEQQM6AABBzOkEQYoDNgIAQcXpBEEAOgAAQdLpBEGfjAItAAA6AABB0OkEQZ2MAi8AADsBAEHn6QRBBjoAAEHT6QRBADoAAEHg6QRBpYwCLwAAOwAAQdzpBEGhjAIoAAA2AgBB9+kEQQM6AABB6OkEQYsDNgIAQeLpBEEAOgAAQe7pBEGqjAItAAA6AABB7OkEQaiMAi8AADsBAEGD6gRBBzoAAEHv6QRBADoAAEH76QRBr4wCKAAANgAAQfjpBEGsjAIoAAA2AgBBk+oEQQM6AABBhOoEQYwDNgIAQf/pBEEAOgAAQYrqBEG2jAItAAA6AABBiOoEQbSMAi8AADsBAEGf6gRBBzoAAEGL6gRBADoAAEGX6gRBu4wCKAAANgAAQZTqBEG4jAIoAAA2AgBBr+oEQQM6AABBoOoEQY0DNgIAQZvqBEEAOgAAQabqBEHCjAItAAA6AABBpOoEQcCMAi8AADsBAEG76gRBBjoAAEGn6gRBADoAAEG06gRByIwCLwAAOwEAQbDqBEHEjAIoAAA2AgBBy+oEQQM6AABBvOoEQY4DNgIAQbbqBEEAOgAAQcLqBEHNjAItAAA6AABBwOoEQcuMAi8AADsBAEHD6gRBADoAAEHIsgVBADYCAEEtQSAQDSEAQciyBSgCACEBQciyBUEANgIAIAFBAUYNjgFBzOoEIAA2AgBB0OoEQpGAgICAhICAgH83AwAgAEEAOgARIABB34wCLQAAOgAQIABB14wCKQAANwAIIABBz4wCKQAANwAAQefqBEEDOgAAQdjqBEGPAzYCAEHc6gRB4YwCLwAAOwEAQd7qBEHjjAItAAA6AABB3+oEQQA6AABByLIFQQA2AgBBLUEQEA0hAEHIsgUoAgAhAUHIsgVBADYCACABQQFGDY8BQejqBCAANgIAQezqBEKPgICAgIKAgIB/NwIAIABBADoADyAAQeyMAikAADcAByAAQeWMAikAADcAAEGD6wRBAzoAAEH06gRBkAM2AgBB+OoEQfWMAi8AADsBAEH66gRB94wCLQAAOgAAQfvqBEEAOgAAQciyBUEANgIAQS1BIBANIQBByLIFKAIAIQFByLIFQQA2AgAgAUEBRg2QAUGE6wQgADYCAEGI6wRCkoCAgICEgICAfzcDACAAQQA6ABIgAEGJjQIvAAA7ABAgAEGBjQIpAAA3AAggAEH5jAIpAAA3AABBn+sEQQM6AABBkOsEQZEDNgIAQavrBEEJOgAAQbvrBEEDOgAAQazrBEGSAzYCAEGU6wRBjI0CLwAAOwEAQZbrBEGOjQItAAA6AABBoOsEQZCNAikAADcDAEGo6wRBmI0CLQAAOgAAQbDrBEGajQIvAAA7AQBBsusEQZyNAi0AADoAAEGX6wRBADoAAEGp6wRBADoAAEHIsgVBADYCAEGz6wRBADoAAEEtQRAQDSEAQciyBSgCACEBQciyBUEANgIAIAFBAUYNkQFBvOsEIAA2AgBBwOsEQoyAgICAgoCAgH83AwAgAEEAOgAMIABBpo0CKAAANgAIIABBno0CKQAANwAAQdfrBEEDOgAAQcjrBEGTAzYCAEHj6wRBBzoAAEHz6wRBAzoAAEHk6wRBlAM2AgBBzOsEQauNAi8AADsBAEHO6wRBrY0CLQAAOgAAQdjrBEGvjQIoAAA2AgBB2+sEQbKNAigAADYAAEHo6wRBt40CLwAAOwEAQerrBEG5jQItAAA6AABBz+sEQQA6AABB3+sEQQA6AABB/+sEQQU6AABBgOwEQZUDNgIAQY/sBEEDOgAAQfTrBEG7jQIoAAA2AgBB+OsEQb+NAi0AADoAAEGE7ARBwY0CLwAAOwEAQYbsBEHDjQItAAA6AABB6+sEQQA6AABB+esEQQA6AABBh+wEQQA6AABByLIFQQA2AgBBLUEgEA0hAEHIsgUoAgAhAUHIsgVBADYCACABQQFGDZIBQZDsBCAANgIAQZTsBEKUgICAgISAgIB/NwIAIABBADoAFCAAQdWNAigAADYAECAAQc2NAikAADcACCAAQcWNAikAADcAAEGr7ARBAzoAAEGc7ARBlgM2AgBBt+wEQQU6AABBx+wEQQM6AABBuOwEQZcDNgIAQaDsBEHajQIvAAA7AQBBouwEQdyNAi0AADoAAEGs7ARB3o0CKAAANgIAQbDsBEHijQItAAA6AABBvOwEQeSNAi8AADsBAEG+7ARB5o0CLQAAOgAAQaPsBEEAOgAAQbHsBEEAOgAAQdPsBEEGOgAAQdTsBEGYAzYCAEHj7ARBAzoAAEHv7ARBCToAAEHI7ARB6I0CKAAANgIAQczsBEHsjQIvAAA7AQBB2OwEQe+NAi8AADsBAEHa7ARB8Y0CLQAAOgAAQeTsBEHzjQIpAAA3AgBB7OwEQfuNAi0AADoAAEG/7ARBADoAAEHO7ARBADoAAEHb7ARBADoAAEH/7ARBAzoAAEHw7ARBmQM2AgBB7ewEQQA6AABB9uwEQf+NAi0AADoAAEH07ARB/Y0CLwAAOwEAQYvtBEEEOgAAQffsBEEAOgAAQZvtBEEDOgAAQYztBEGaAzYCAEGA7QRB0+rNqwc2AgBBhO0EQQA6AABBku0EQYOOAi0AADoAAEGQ7QRBgY4CLwAAOwEAQaftBEEIOgAAQZPtBEEAOgAAQbftBEEDOgAAQajtBEGbAzYCAEGc7QRC0+q1q6au2rDuADcCAEGk7QRBADoAAEGu7QRBh44CLQAAOgAAQaztBEGFjgIvAAA7AQBBw+0EQQc6AABBr+0EQQA6AABBu+0EQYyOAigAADYAAEG47QRBiY4CKAAANgIAQdPtBEEDOgAAQcTtBEGcAzYCAEG/7QRBADoAAEHK7QRBk44CLQAAOgAAQcjtBEGRjgIvAAA7AQBB3+0EQQc6AABBy+0EQQA6AABB1+0EQZiOAigAADYAAEHU7QRBlY4CKAAANgIAQe/tBEEDOgAAQeDtBEGdAzYCAEHb7QRBADoAAEHm7QRBn44CLQAAOgAAQeTtBEGdjgIvAAA7AQBB5+0EQQA6AABByLIFQQA2AgBBLUEgEA0hAEHIsgUoAgAhAUHIsgVBADYCACABQQFGDZMBQfDtBCAANgIAQfTtBEKQgICAgISAgIB/NwIAIABBADoAECAAQamOAikAADcACCAAQaGOAikAADcAAEGL7gRBAzoAAEH87QRBngM2AgBBl+4EQQY6AABBp+4EQQM6AABBmO4EQZ8DNgIAQYDuBEGyjgIvAAA7AQBBgu4EQbSOAi0AADoAAEGM7gRBto4CKAAANgIAQZDuBEG6jgIvAAA7AABBnO4EQb2OAi8AADsBAEGe7gRBv44CLQAAOgAAQYPuBEEAOgAAQZLuBEEAOgAAQbPuBEEIOgAAQajuBELUwqHLxq7asO4ANwMAQbTuBEGgAzYCAEHD7gRBAzoAAEG47gRBwY4CLwAAOwEAQbruBEHDjgItAAA6AABBn+4EQQA6AABBsO4EQQA6AABBu+4EQQA6AABByLIFQQA2AgBBLUEQEA0hAEHIsgUoAgAhAUHIsgVBADYCACABQQFGDZQBQcTuBCAANgIAQcjuBEKLgICAgIKAgIB/NwMAIABBADoACyAAQcyOAigAADYAByAAQcWOAikAADcAAEHf7gRBAzoAAEHQ7gRBoQM2AgBB6+4EQQU6AABB++4EQQM6AABB7O4EQaIDNgIAQdTuBEHRjgIvAAA7AQBB1u4EQdOOAi0AADoAAEHg7gRB1Y4CKAAANgIAQeTuBEHZjgItAAA6AABB8O4EQduOAi8AADsBAEHy7gRB3Y4CLQAAOgAAQdfuBEEAOgAAQeXuBEEAOgAAQYfvBEEFOgAAQYjvBEGjAzYCAEGX7wRBAzoAAEGj7wRBBjoAAEH87gRB344CKAAANgIAQYDvBEHjjgItAAA6AABBjO8EQeWOAi8AADsBAEGO7wRB544CLQAAOgAAQZjvBEHpjgIoAAA2AgBBnO8EQe2OAi8AADsBAEHz7gRBADoAAEGB7wRBADoAAEGP7wRBADoAAEGz7wRBAzoAAEGk7wRBpAM2AgBBnu8EQQA6AABBqu8EQfKOAi0AADoAAEGo7wRB8I4CLwAAOwEAQb/vBEEFOgAAQavvBEEAOgAAQbjvBEH4jgItAAA6AABBtO8EQfSOAigAADYCAEHP7wRBAzoAAEHA7wRBpQM2AgBBue8EQQA6AABBxu8EQfyOAi0AADoAAEHE7wRB+o4CLwAAOwEAQdvvBEEGOgAAQcfvBEEAOgAAQdTvBEGCjwIvAAA7AQBB0O8EQf6OAigAADYCAEHr7wRBAzoAAEHc7wRBpgM2AgBB1u8EQQA6AABB4u8EQYePAi0AADoAAEHg7wRBhY8CLwAAOwEAQffvBEEFOgAAQePvBEEAOgAAQfDvBEGNjwItAAA6AABB7O8EQYmPAigAADYCAEGH8ARBAzoAAEH47wRBpwM2AgBB8e8EQQA6AABB/u8EQZGPAi0AADoAAEH87wRBj48CLwAAOwEAQZPwBEEFOgAAQf/vBEEAOgAAQYzwBEGXjwItAAA6AABBiPAEQZOPAigAADYCAEGj8ARBAzoAAEGU8ARBqAM2AgBBjfAEQQA6AABBmvAEQZuPAi0AADoAAEGY8ARBmY8CLwAAOwEAQa/wBEEHOgAAQZvwBEEAOgAAQafwBEGgjwIoAAA2AABBpPAEQZ2PAigAADYCAEG/8ARBAzoAAEGw8ARBqQM2AgBBq/AEQQA6AABBtvAEQaePAi0AADoAAEG08ARBpY8CLwAAOwEAQcvwBEEEOgAAQbfwBEEAOgAAQdvwBEEDOgAAQczwBEGqAzYCAEHA8ARB1NCFywY2AgBBxPAEQQA6AABB0vAEQauPAi0AADoAAEHQ8ARBqY8CLwAAOwEAQefwBEEHOgAAQdPwBEEAOgAAQd/wBEGwjwIoAAA2AABB3PAEQa2PAigAADYCAEH38ARBAzoAAEHo8ARBqwM2AgBB4/AEQQA6AABB7vAEQbePAi0AADoAAEHs8ARBtY8CLwAAOwEAQYPxBEEFOgAAQe/wBEEAOgAAQfzwBEG9jwItAAA6AABB+PAEQbmPAigAADYCAEGT8QRBAzoAAEGE8QRBrAM2AgBB/fAEQQA6AABBivEEQcGPAi0AADoAAEGI8QRBv48CLwAAOwEAQZ/xBEEIOgAAQYvxBEEAOgAAQa/xBEEDOgAAQaDxBEGtAzYCAEGU8QRC1NKdk5fN27zhADcCAEGc8QRBADoAAEGm8QRBxY8CLQAAOgAAQaTxBEHDjwIvAAA7AQBBu/EEQQM6AABBp/EEQQA6AABBsvEEQcmPAi0AADoAAEGw8QRBx48CLwAAOwEAQcvxBEEDOgAAQbzxBEGuAzYCAEGz8QRBADoAAEHC8QRBzY8CLQAAOgAAQcDxBEHLjwIvAAA7AQBB1/EEQQc6AABBw/EEQQA6AABBz/EEQdKPAigAADYAAEHM8QRBz48CKAAANgIAQefxBEEDOgAAQdjxBEGvAzYCAEHT8QRBADoAAEHe8QRB2Y8CLQAAOgAAQdzxBEHXjwIvAAA7AQBB3/EEQQA6AABByLIFQQA2AgBBLUEgEA0hAEHIsgUoAgAhAUHIsgVBADYCACABQQFGDZUBQejxBCAANgIAQezxBEKVgICAgISAgIB/NwIAIABBADoAFSAAQeiPAikAADcADSAAQeOPAikAADcACCAAQduPAikAADcAAEGD8gRBAzoAAEH08QRBsAM2AgBBj/IEQQc6AABBn/IEQQM6AABBkPIEQbEDNgIAQfjxBEHxjwIvAAA7AQBB+vEEQfOPAi0AADoAAEGE8gRB9Y8CKAAANgIAQYfyBEH4jwIoAAA2AABBlPIEQf2PAi8AADsBAEGW8gRB/48CLQAAOgAAQfvxBEEAOgAAQYvyBEEAOgAAQavyBEEIOgAAQaDyBELUwrWLto7asusANwMAQazyBEGyAzYCAEG78gRBAzoAAEGw8gRBgZACLwAAOwEAQbLyBEGDkAItAAA6AABBl/IEQQA6AABBqPIEQQA6AABBs/IEQQA6AABByLIFQQA2AgBBLUEQEA0hAEHIsgUoAgAhAUHIsgVBADYCACABQQFGDZYBQbzyBCAANgIAQcDyBEKNgICAgIKAgIB/NwMAIABBADoADSAAQYqQAikAADcABSAAQYWQAikAADcAAEHX8gRBAzoAAEHI8gRBswM2AgBBzPIEQZOQAi8AADsBAEHO8gRBlZACLQAAOgAAQc/yBEEAOgAAQciyBUEANgIAQS1BIBANIQBByLIFKAIAIQFByLIFQQA2AgAgAUEBRg2XAUHY8gQgADYCAEHc8gRClYCAgICEgICAfzcCACAAQQA6ABUgAEGkkAIpAAA3AA0gAEGfkAIpAAA3AAggAEGXkAIpAAA3AABB8/IEQQM6AABB5PIEQbQDNgIAQf/yBEEJOgAAQY/zBEEDOgAAQYDzBEG1AzYCAEHo8gRBrZACLwAAOwEAQeryBEGvkAItAAA6AABB9PIEQbGQAikAADcCAEH88gRBuZACLQAAOgAAQYTzBEG7kAIvAAA7AQBBhvMEQb2QAi0AADoAAEHr8gRBADoAAEH98gRBADoAAEGb8wRBCToAAEGc8wRBtgM2AgBBq/MEQQM6AABBt/MEQQY6AABBkPMEQb+QAikAADcDAEGY8wRBx5ACLQAAOgAAQaDzBEHJkAIvAAA7AQBBovMEQcuQAi0AADoAAEGs8wRBzZACKAAANgIAQbDzBEHRkAIvAAA7AABBh/MEQQA6AABBmfMEQQA6AABBo/MEQQA6AABBx/MEQQM6AABBuPMEQbcDNgIAQbLzBEEAOgAAQb7zBEHWkAItAAA6AABBvPMEQdSQAi8AADsBAEHT8wRBBjoAAEG/8wRBADoAAEHM8wRB3JACLwAAOwEAQcjzBEHYkAIoAAA2AgBB4/MEQQM6AABB1PMEQbgDNgIAQc7zBEEAOgAAQdrzBEHhkAItAAA6AABB2PMEQd+QAi8AADsBAEHv8wRBBzoAAEHb8wRBADoAAEHn8wRB5pACKAAANgAAQeTzBEHjkAIoAAA2AgBB//MEQQM6AABB8PMEQbkDNgIAQevzBEEAOgAAQfbzBEHtkAItAAA6AABB9PMEQeuQAi8AADsBAEGL9ARBBzoAAEH38wRBADoAAEGD9ARB8pACKAAANgAAQYD0BEHvkAIoAAA2AgBBm/QEQQM6AABBjPQEQboDNgIAQYf0BEEAOgAAQZL0BEH5kAItAAA6AABBkPQEQfeQAi8AADsBAEGT9ARBADoAAEHIsgVBADYCAEEtQRAQDSEAQciyBSgCACEBQciyBUEANgIAIAFBAUYNmAFBnPQEIAA2AgBBoPQEQo6AgICAgoCAgH83AwAgAEEAOgAOIABBgZECKQAANwAGIABB+5ACKQAANwAAQbf0BEEDOgAAQaj0BEG7AzYCAEHD9ARBBzoAAEHT9ARBAzoAAEHE9ARBvAM2AgBBrPQEQYqRAi8AADsBAEGu9ARBjJECLQAAOgAAQbj0BEGOkQIoAAA2AgBBu/QEQZGRAigAADYAAEHI9ARBlpECLwAAOwEAQcr0BEGYkQItAAA6AABBr/QEQQA6AABBv/QEQQA6AABByLIFQQA2AgBBy/QEQQA6AABBLUEQEA0hAEHIsgUoAgAhAUHIsgVBADYCACABQQFGDZkBQdT0BCAANgIAQdj0BEKOgICAgIKAgIB/NwMAIABBADoADiAAQaCRAikAADcABiAAQZqRAikAADcAAEHv9ARBAzoAAEHg9ARBvQM2AgBB+/QEQQY6AABBi/UEQQM6AABB/PQEQb4DNgIAQeT0BEGpkQIvAAA7AQBB5vQEQauRAi0AADoAAEHw9ARBrZECKAAANgIAQfT0BEGxkQIvAAA7AQBBgPUEQbSRAi8AADsBAEGC9QRBtpECLQAAOgAAQef0BEEAOgAAQfb0BEEAOgAAQZf1BEEDOgAAQZj1BEG/AzYCAEGn9QRBAzoAAEGz9QRBCDoAAEGo9QRC1OrZy+at2rDuADcDAEG09QRBwAM2AgBBw/UEQQM6AABBjPUEQbiRAi8AADsBAEGO9QRBupECLQAAOgAAQZz1BEG8kQIvAAA7AQBBnvUEQb6RAi0AADoAAEGD9QRBADoAAEGP9QRBADoAAEGf9QRBADoAAEGw9QRBADoAAEG69QRBwpECLQAAOgAAQbj1BEHAkQIvAAA7AQBBz/UEQQY6AABBu/UEQQA6AABByPUEQciRAi8AADsAAEHE9QRBxJECKAAANgIAQd/1BEEDOgAAQdD1BEHBAzYCAEHK9QRBADoAAEHW9QRBzZECLQAAOgAAQdT1BEHLkQIvAAA7AQBB6/UEQQg6AABB1/UEQQA6AABB+/UEQQM6AABB7PUEQcIDNgIAQeD1BELVzoWTl43dtOMANwMAQej1BEEAOgAAQfL1BEHRkQItAAA6AABB8PUEQc+RAi8AADsBAEHz9QRBADoAAEHIsgVBADYCAEEtQRAQDSEAQciyBSgCACEBQciyBUEANgIAIAFBAUYNmgFB/PUEIAA2AgBBgPYEQo6AgICAgoCAgH83AwAgAEEAOgAOIABB2ZECKQAANwAGIABB05ECKQAANwAAQZf2BEEDOgAAQYj2BEHDAzYCAEGj9gRBCToAAEGz9gRBAzoAAEGk9gRBxAM2AgBBjPYEQeKRAi8AADsBAEGO9gRB5JECLQAAOgAAQZj2BEHmkQIpAAA3AwBBoPYEQe6RAi0AADoAAEGo9gRB8JECLwAAOwEAQar2BEHykQItAAA6AABBj/YEQQA6AABBofYEQQA6AABBv/YEQQc6AABBwPYEQcUDNgIAQc/2BEEDOgAAQbT2BEH0kQIoAAA2AgBBt/YEQfeRAigAADYAAEHE9gRB/JECLwAAOwEAQcb2BEH+kQItAAA6AABBq/YEQQA6AABBu/YEQQA6AABBx/YEQQA6AABByLIFQQA2AgBBLUEQEA0hAEHIsgUoAgAhAUHIsgVBADYCACABQQFGDZsBQdD2BCAANgIAQdT2BEKMgICAgIKAgIB/NwIAIABBADoADCAAQYiSAigAADYACCAAQYCSAikAADcAAEHr9gRBAzoAAEHc9gRBxgM2AgBB9/YEQQQ6AABBh/cEQQM6AABB+PYEQccDNgIAQez2BEHV5JGrBzYCAEGT9wRBBToAAEHg9gRBjZICLwAAOwEAQeL2BEGPkgItAAA6AABB/PYEQZGSAi8AADsBAEH+9gRBk5ICLQAAOgAAQYz3BEGZkgItAAA6AABBiPcEQZWSAigAADYCAEHj9gRBADoAAEHw9gRBADoAAEH/9gRBADoAAEGj9wRBAzoAAEGU9wRByAM2AgBBr/cEQQM6AABBsPcEQckDNgIAQb/3BEEDOgAAQZj3BEGbkgIvAAA7AQBBmvcEQZ2SAi0AADoAAEGk9wRBn5ICLwAAOwEAQab3BEGhkgItAAA6AABBtPcEQaOSAi8AADsBAEG29wRBpZICLQAAOgAAQY33BEEAOgAAQZv3BEEAOgAAQaf3BEEAOgAAQcv3BEEFOgAAQbf3BEEAOgAAQcT3BEGrkgItAAA6AABBwPcEQaeSAigAADYCAEHb9wRBAzoAAEHM9wRBygM2AgBBxfcEQQA6AABB0vcEQa+SAi0AADoAAEHQ9wRBrZICLwAAOwEAQef3BEEKOgAAQdP3BEEAOgAAQeT3BEG5kgIvAAA7AQBB3PcEQbGSAikAADcCAEH39wRBAzoAAEHo9wRBywM2AgBB5vcEQQA6AABB7vcEQb6SAi0AADoAAEHs9wRBvJICLwAAOwEAQYP4BEEIOgAAQe/3BEEAOgAAQZP4BEEDOgAAQYT4BEHMAzYCAEH49wRC1t6xi4busN7rADcDAEGA+ARBADoAAEGK+ARBwpICLQAAOgAAQYj4BEHAkgIvAAA7AQBBn/gEQQU6AABBi/gEQQA6AABBmPgEQciSAi0AADoAAEGU+ARBxJICKAAANgIAQa/4BEEDOgAAQaD4BEHNAzYCAEGZ+ARBADoAAEGm+ARBzJICLQAAOgAAQaT4BEHKkgIvAAA7AQBBp/gEQQA6AABByLIFQQA2AgBBLUEgEA0hAEHIsgUoAgAhAUHIsgVBADYCACABQQFGDZwBQbD4BCAANgIAQbT4BEKSgICAgISAgIB/NwIAIABBADoAEiAAQd6SAi8AADsAECAAQdaSAikAADcACCAAQc6SAikAADcAAEHL+ARBAzoAAEG8+ARBzgM2AgBB1/gEQQY6AABB5/gEQQM6AABB2PgEQc8DNgIAQcD4BEHhkgIvAAA7AQBBwvgEQeOSAi0AADoAAEHM+ARB5ZICKAAANgIAQdD4BEHpkgIvAAA7AABB3PgEQeySAi8AADsBAEHe+ARB7pICLQAAOgAAQcP4BEEAOgAAQdL4BEEAOgAAQfP4BEEFOgAAQfT4BEHQAzYCAEGD+QRBAzoAAEGP+QRBBToAAEHo+ARB8JICKAAANgIAQez4BEH0kgItAAA6AABB+PgEQfaSAi8AADsBAEH6+ARB+JICLQAAOgAAQYT5BEH6kgIoAAA2AgBBiPkEQf6SAi0AADoAAEHf+ARBADoAAEHt+ARBADoAAEH7+ARBADoAAEGf+QRBAzoAAEGQ+QRB0QM2AgBBifkEQQA6AABBlvkEQYKTAi0AADoAAEGU+QRBgJMCLwAAOwEAQav5BEEFOgAAQZf5BEEAOgAAQaT5BEGIkwItAAA6AABBoPkEQYSTAigAADYCAEG7+QRBAzoAAEGs+QRB0gM2AgBBpfkEQQA6AABBsvkEQYyTAi0AADoAAEGw+QRBipMCLwAAOwEAQbP5BEEAOgAAQciyBUEANgIAQS1BIBANIQBByLIFKAIAIQFByLIFQQA2AgAgAUEBRg2dAUG8+QQgADYCAEHA+QRCkYCAgICEgICAfzcDACAAQQA6ABEgAEGekwItAAA6ABAgAEGWkwIpAAA3AAggAEGOkwIpAAA3AABB1/kEQQM6AABByPkEQdMDNgIAQeP5BEEHOgAAQfP5BEEDOgAAQeT5BEHUAzYCAEHM+QRBoJMCLwAAOwEAQc75BEGikwItAAA6AABB2PkEQaSTAigAADYCAEHb+QRBp5MCKAAANgAAQej5BEGskwIvAAA7AQBB6vkEQa6TAi0AADoAAEHP+QRBADoAAEHf+QRBADoAAEH/+QRBBToAAEGA+gRB1QM2AgBBj/oEQQM6AABB9PkEQbCTAigAADYCAEH4+QRBtJMCLQAAOgAAQYT6BEG2kwIvAAA7AQBBhvoEQbiTAi0AADoAAEHr+QRBADoAAEH5+QRBADoAAEGH+gRBADoAAEHIsgVBADYCAEEtQRAQDSEAQciyBSgCACEBQciyBUEANgIAIAFBAUYNngFBkPoEIAA2AgBBlPoEQo2AgICAgoCAgH83AgAgAEEAOgANIABBv5MCKQAANwAFIABBupMCKQAANwAAQav6BEEDOgAAQZz6BEHWAzYCAEG3+gRBBToAAEHH+gRBAzoAAEG4+gRB1wM2AgBBoPoEQciTAi8AADsBAEGi+gRBypMCLQAAOgAAQaz6BEHMkwIoAAA2AgBBsPoEQdCTAi0AADoAAEG8+gRB0pMCLwAAOwEAQb76BEHUkwItAAA6AABBo/oEQQA6AABBsfoEQQA6AABB0/oEQQM6AABB1PoEQdgDNgIAQeP6BEEDOgAAQe/6BEEGOgAAQcj6BEHWkwIvAAA7AQBByvoEQdiTAi0AADoAAEHY+gRB2pMCLwAAOwEAQdr6BEHckwItAAA6AABB5PoEQd6TAigAADYCAEHo+gRB4pMCLwAAOwAAQb/6BEEAOgAAQcv6BEEAOgAAQdv6BEEAOgAAQf/6BEEDOgAAQfD6BEHZAzYCAEHq+gRBADoAAEH2+gRB55MCLQAAOgAAQfT6BEHlkwIvAAA7AQBBi/sEQQc6AABB9/oEQQA6AABBg/sEQeyTAigAADYAAEGA+wRB6ZMCKAAANgIAQZv7BEEDOgAAQYz7BEHaAzYCAEGH+wRBADoAAEGS+wRB85MCLQAAOgAAQZD7BEHxkwIvAAA7AQBBp/sEQQY6AABBk/sEQQA6AABBoPsEQfmTAi8AADsAAEGc+wRB9ZMCKAAANgIAQbf7BEEDOgAAQaj7BEHbAzYCAEGi+wRBADoAAEGu+wRB/pMCLQAAOgAAQaz7BEH8kwIvAAA7AQBBr/sEQQA6AABByLIFQQA2AgBBLUEQEA0hAEHIsgUoAgAhAUHIsgVBADYCACABQQFGDZ8BQbj7BCAANgIAQbz7BEKPgICAgIKAgIB/NwIAIABBADoADyAAQYeUAikAADcAByAAQYCUAikAADcAAEHT+wRBAzoAAEHE+wRB3AM2AgBB3/sEQQc6AABB7/sEQQM6AABB4PsEQd0DNgIAQcj7BEGQlAIvAAA7AQBByvsEQZKUAi0AADoAAEHU+wRBlJQCKAAANgIAQdf7BEGXlAIoAAA2AABB5PsEQZyUAi8AADsBAEHm+wRBnpQCLQAAOgAAQcv7BEEAOgAAQdv7BEEAOgAAQciyBUEANgIAQef7BEEAOgAAQS1BMBANIQBByLIFKAIAIQFByLIFQQA2AgAgAUEBRg2gAUHw+wQgADYCAEH0+wRCoYCAgICGgICAfzcCACAAQQA6ACEgAEHAlAItAAA6ACAgAEG4lAIpAAA3ABggAEGwlAIpAAA3ABAgAEGolAIpAAA3AAggAEGglAIpAAA3AABBi/wEQQM6AABB/PsEQd4DNgIAQZf8BEEGOgAAQaf8BEEDOgAAQZj8BEHfAzYCAEGA/ARBwpQCLwAAOwEAQYL8BEHElAItAAA6AABBjPwEQcaUAigAADYCAEGQ/ARBypQCLwAAOwAAQZz8BEHNlAIvAAA7AQBBnvwEQc+UAi0AADoAAEGD/ARBADoAAEGS/ARBADoAAEHIsgVBADYCAEGf/ARBADoAAEEtQRAQDSEAQciyBSgCACEBQciyBUEANgIAIAFBAUYNoQFBqPwEIAA2AgBBrPwEQo6AgICAgoCAgH83AgAgAEEAOgAOIABB15QCKQAANwAGIABB0ZQCKQAANwAAQcP8BEEDOgAAQbT8BEHgAzYCAEG4/ARB4JQCLwAAOwEAQbr8BEHilAItAAA6AABBu/wEQQA6AABByLIFQQA2AgBBLUEQEA0hAEHIsgUoAgAhAUHIsgVBADYCACABQQFGDaIBQcT8BCAANgIAQcj8BEKPgICAgIKAgIB/NwMAIABBADoADyAAQeuUAikAADcAByAAQeSUAikAADcAAEHf/ARBAzoAAEHQ/ARB4QM2AgBB6/wEQQQ6AABB+/wEQQM6AABB7PwEQeIDNgIAQeD8BEHa6rGrBzYCAEGH/QRBBDoAAEGX/QRBAzoAAEGI/QRB4wM2AgBB/PwEQdrqucsGNgIAQdT8BEH0lAIvAAA7AQBB1vwEQfaUAi0AADoAAEHw/ARB+JQCLwAAOwEAQfL8BEH6lAItAAA6AABB1/wEQQA6AABB5PwEQQA6AABB8/wEQQA6AABBgP0EQQA6AABBjv0EQf6UAi0AADoAAEGM/QRB/JQCLwAAOwEAQY/9BEEAOgAAQciyBUEANgIAQS1BMBANIQBByLIFKAIAIQFByLIFQQA2AgAgAUEBRg2jAUGY/QQgADYCAEGc/QRCpYCAgICGgICAfzcCACAAQQA6ACUgAEGdlQIpAAA3AB0gAEGYlQIpAAA3ABggAEGQlQIpAAA3ABAgAEGIlQIpAAA3AAggAEGAlQIpAAA3AABBs/0EQQM6AABBpP0EQeQDNgIAQaj9BEGmlQIvAAA7AQBBqv0EQaiVAi0AADoAAEGr/QRBADoAAEHIsgVBADYCAEEtQTAQDSEAQciyBSgCACEBQciyBUEANgIAIAFBAUYNpAFBtP0EIAA2AgBBuP0EQq6AgICAhoCAgH83AwAgAEEAOgAuIABB0JUCKQAANwAmIABBypUCKQAANwAgIABBwpUCKQAANwAYIABBupUCKQAANwAQIABBspUCKQAANwAIIABBqpUCKQAANwAAQdD9BEIANwMAQcj9BEIANwMAQcD9BEIANwMAQdj9BEEANgIADwsQBiECEAcaQdyUBAykAQsQBiECEAcaQfiUBAyjAQsQBiECEAcaQdiWBAyiAQsQBiECEAcaQfSWBAyhAQsQBiECEAcaQayXBAygAQsQBiECEAcaQeSXBAyfAQsQBiECEAcaQZyYBAyeAQsQBiECEAcaQfCYBAydAQsQBiECEAcaQaiZBAycAQsQBiECEAcaQfyZBAybAQsQBiECEAcaQZiaBAyaAQsQBiECEAcaQbSaBAyZAQsQBiECEAcaQcCbBAyYAQsQBiECEAcaQdybBAyXAQsQBiECEAcaQfibBAyWAQsQBiECEAcaQbydBAyVAQsQBiECEAcaQdidBAyUAQsQBiECEAcaQcieBAyTAQsQBiECEAcaQYygBAySAQsQBiECEAcaQfygBAyRAQsQBiECEAcaQYiiBAyQAQsQBiECEAcaQcCiBAyPAQsQBiECEAcaQdyiBAyOAQsQBiECEAcaQfiiBAyNAQsQBiECEAcaQZSjBAyMAQsQBiECEAcaQcyjBAyLAQsQBiECEAcaQaylBAyKAQsQBiECEAcaQeSlBAyJAQsQBiECEAcaQZymBAyIAQsQBiECEAcaQfCmBAyHAQsQBiECEAcaQeCnBAyGAQsQBiECEAcaQfynBAyFAQsQBiECEAcaQZioBAyEAQsQBiECEAcaQdCoBAyDAQsQBiECEAcaQeyoBAyCAQsQBiECEAcaQaSpBAyBAQsQBiECEAcaQbCqBAyAAQsQBiECEAcaQeiqBAx/CxAGIQIQBxpBvKsEDH4LEAYhAhAHGkH0qwQMfQsQBiECEAcaQZCsBAx8CxAGIQIQBxpByKwEDHsLEAYhAhAHGkHkrAQMegsQBiECEAcaQdStBAx5CxAGIQIQBxpBxK4EDHgLEAYhAhAHGkHAsAQMdwsQBiECEAcaQfiwBAx2CxAGIQIQBxpBzLEEDHULEAYhAhAHGkHosQQMdAsQBiECEAcaQYSyBAxzCxAGIQIQBxpBoLIEDHILEAYhAhAHGkG8sgQMcQsQBiECEAcaQeSzBAxwCxAGIQIQBxpB8LQEDG8LEAYhAhAHGkHgtQQMbgsQBiECEAcaQfy1BAxtCxAGIQIQBxpBiLcEDGwLEAYhAhAHGkGktwQMawsQBiECEAcaQdy3BAxqCxAGIQIQBxpBzLgEDGkLEAYhAhAHGkGcuwQMaAsQBiECEAcaQeC8BAxnCxAGIQIQBxpB/LwEDGYLEAYhAhAHGkG0vQQMZQsQBiECEAcaQey9BAxkCxAGIQIQBxpBiL4EDGMLEAYhAhAHGkHAvgQMYgsQBiECEAcaQZS/BAxhCxAGIQIQBxpBsL8EDGALEAYhAhAHGkG8wAQMXwsQBiECEAcaQdjABAxeCxAGIQIQBxpB9MAEDF0LEAYhAhAHGkGswQQMXAsQBiECEAcaQcjBBAxbCxAGIQIQBxpBnMIEDFoLEAYhAhAHGkHgwwQMWQsQBiECEAcaQfzDBAxYCxAGIQIQBxpBmMQEDFcLEAYhAhAHGkG0xAQMVgsQBiECEAcaQdDEBAxVCxAGIQIQBxpB7MQEDFQLEAYhAhAHGkHMxgQMUwsQBiECEAcaQYTHBAxSCxAGIQIQBxpBvMcEDFELEAYhAhAHGkHwyQQMUAsQBiECEAcaQfzKBAxPCxAGIQIQBxpBtMsEDE4LEAYhAhAHGkGkzAQMTQsQBiECEAcaQbDNBAxMCxAGIQIQBxpB2M4EDEsLEAYhAhAHGkGc0AQMSgsQBiECEAcaQbjQBAxJCxAGIQIQBxpB1NAEDEgLEAYhAhAHGkHw0AQMRwsQBiECEAcaQYzRBAxGCxAGIQIQBxpBmNIEDEULEAYhAhAHGkGI0wQMRAsQBiECEAcaQaTTBAxDCxAGIQIQBxpBlNQEDEILEAYhABAHGiAAIQJBzNQEDEELEAYhABAHGiAAIQJB6NQEDEALEAYhABAHGiAAIQJBvNUEDD8LEAYhABAHGiAAIQJB2NUEDD4LEAYhABAHGiAAIQJB9NUEDD0LEAYhABAHGiAAIQJBrNYEDDwLEAYhABAHGiAAIQJB5NYEDDsLEAYhABAHGiAAIQJBnNcEDDoLEAYhABAHGiAAIQJB1NcEDDkLEAYhABAHGiAAIQJB8NcEDDgLEAYhABAHGiAAIQJB/NgEDDcLEAYhABAHGiAAIQJBmNkEDDYLEAYhABAHGiAAIQJBtNkEDDULEAYhABAHGiAAIQJB0NkEDDQLEAYhABAHGiAAIQJB3NoEDDMLEAYhABAHGiAAIQJB6NsEDDILEAYhABAHGiAAIQJBhNwEDDELEAYhABAHGiAAIQJBoNwEDDALEAYhABAHGiAAIQJBvNwEDC8LEAYhABAHGiAAIQJBkN0EDC4LEAYhABAHGiAAIQJBrN0EDC0LEAYhABAHGiAAIQJBgN4EDCwLEAYhABAHGiAAIQJBuN4EDCsLEAYhABAHGiAAIQJB4N8EDCoLEAYhABAHGiAAIQJB/N8EDCkLEAYhABAHGiAAIQJBmOAEDCgLEAYhABAHGiAAIQJBiOEEDCcLEAYhABAHGiAAIQJBpOEEDCYLEAYhABAHGiAAIQJB+OEEDCULEAYhABAHGiAAIQJBsOIEDCQLEAYhABAHGiAAIQJBvOMEDCMLEAYhABAHGiAAIQJB2OMEDCILEAYhABAHGiAAIQJB9OMEDCELEAYhABAHGiAAIQJBuOUEDCALEAYhABAHGiAAIQJB1OUEDB8LEAYhABAHGiAAIQJB8OUEDB4LEAYhABAHGiAAIQJBxOYEDB0LEAYhABAHGiAAIQJB4OYEDBwLEAYhABAHGiAAIQJB/OYEDBsLEAYhABAHGiAAIQJBmOcEDBoLEAYhABAHGiAAIQJB7OcEDBkLEAYhABAHGiAAIQJBiOgEDBgLEAYhABAHGiAAIQJBpOgEDBcLEAYhABAHGiAAIQJBvOoEDBYLEAYhABAHGiAAIQJB2OoEDBULEAYhABAHGiAAIQJB9OoEDBQLEAYhABAHGiAAIQJBrOsEDBMLEAYhABAHGiAAIQJBgOwEDBILEAYhABAHGiAAIQJB4O0EDBELEAYhABAHGiAAIQJBtO4EDBALEAYhABAHGiAAIQJB2PEEDA8LEAYhABAHGiAAIQJBrPIEDA4LEAYhABAHGiAAIQJByPIEDA0LEAYhABAHGiAAIQJBjPQEDAwLEAYhABAHGiAAIQJBxPQEDAsLEAYhABAHGiAAIQJB7PUEDAoLEAYhABAHGiAAIQJBwPYEDAkLEAYhABAHGiAAIQJBoPgEDAgLEAYhABAHGiAAIQJBrPkEDAcLEAYhABAHGiAAIQJBgPoEDAYLEAYhABAHGiAAIQJBqPsEDAULEAYhABAHGiAAIQJB4PsEDAQLEAYhABAHGiAAIQJBmPwEDAMLEAYhABAHGiAAIQJBtPwEDAILEAYhABAHGiAAIQJBiP0EDAELEAYhABAHGiAAIQJBpP0ECyEAA0AgAEF/aiwAAEF/TARAIABBdGooAgAQ9gwLIABBZGohASAAQXNqLAAAQX9MBEAgAEFoaigCABD2DAsgASIAQdCTBEcNAAsgAhAIAAtRAQF/Qdz9BCEAA0AgAEF/aiwAAEF/TARAIABBdGooAgAQ9gwLIABBc2osAABBf0wEQCAAQWhqKAIAEPYMCyAAQWRqIgEhACABQdCTBEcNAAsL8AQBCX8jAEEgayIDJABB4P0EQgA3AgBB7P0EQgA3AgBB3P0EQeD9BDYCAEH4/QRB6P0ENgIAQej9BEHs/QQ2AgBB9P0EQdz9BDYCAAJAAkBB0JMEKAIABEBB0JMEIQRB0JMEIQYDQEHIsgVBADYCAEGWAyADQQhqIARBBGoQFSEAQciyBSgCACECQciyBUEANgIAAkACQCACQQFHBEAgAyAGNgIUQciyBUEANgIAQZcDIANBGGpB3P0EIAAgA0EIahAcQciyBSgCACEAQciyBUEANgIAIABBAUYNASADLAATQX9MBEAgAygCCBD2DAsgBCgCACEHQez9BCgCACIFIQBB7P0EIQIgBUUEQEHs/QQiACECDAMLA0ACQCAHIAAoAhAiAUgEQCAAKAIAIgENASAAIQIMBQsgASAHTg0EIABBBGohAiAAKAIEIgFFDQQgAiEACyAAIQIgASEADAAACwALEAYhABAHGkHs/QQoAgAhBQwFCxAGIQAQBxogAywAE0F/TARAIAMoAggQ9gwLQez9BCgCACEFDAQLIAIoAgBFBEBByLIFQQA2AgBBLUEYEA0hAUHIsgUoAgAhCEHIsgVBADYCACAIQQFGDQMgASAANgIIIAFCADcCACABIAetIAatQiCGhDcCECACIAE2AgBB6P0EKAIAKAIAIgAEQEHo/QQgADYCACACKAIAIQELQez9BCgCACABENIDQfD9BEHw/QQoAgBBAWo2AgALIAQoAhwhACAEQRxqIgYhBCAADQALCyADQSBqJAAPCxAGIQAQBxoLQej9BCAFENMDQdz9BEHg/QQoAgAQ1AMgABAIAAu9AgEEfwJAAkAgASgCBCIEBEAgAUEIaiEHIAFBBGohBgNAAkAgByACIARBEGoiBRDIBQRAIAQoAgAiBQ0BDAQLIAcgBSACEMgFRQ0EIARBBGohBiAEKAIEIgVFDQQgBiEECyAEIQYgBSEEDAAACwALIAFBBGohBAsgBCEGCwJAIAAgBigCACIFBH9BAAVBIBD+CyEFQciyBUEANgIAQZYDIAVBEGogAxAVGkHIsgUoAgAhAkHIsgVBADYCACACQQFGDQEgAygCDCECIAUgBDYCCCAFQgA3AgAgBSACNgIcIAYgBTYCAAJ/IAUgASgCACgCACIERQ0AGiABIAQ2AgAgBigCAAshBCABKAIEIAQQ0gMgASABKAIIQQFqNgIIQQELOgAEIAAgBTYCAA8LEAYhBBAHGiAFEPYMIAQQCAALnQQBA38gASAAIAFGIgI6AAwCQCACDQADQCABKAIIIgMtAAwNAQJAIAMgAygCCCICKAIAIgRGBEACQCACKAIEIgRFDQAgBC0ADA0AIARBDGohBAwCCwJAIAEgAygCAEYEQCADIQQMAQsgAyADKAIEIgQoAgAiATYCBCAEIAEEfyABIAM2AgggAygCCAUgAgs2AgggAygCCCICIAIoAgAgA0dBAnRqIAQ2AgAgBCADNgIAIAMgBDYCCCAEKAIIIQILIARBAToADCACQQA6AAwgAiACKAIAIgMoAgQiBDYCACAEBEAgBCACNgIICyADIAIoAgg2AgggAigCCCIEIAQoAgAgAkdBAnRqIAM2AgAgAyACNgIEIAIgAzYCCA8LAkAgBEUNACAELQAMDQAgBEEMaiEEDAELAkAgASADKAIARwRAIAMhAQwBCyADIAEoAgQiBDYCACABIAQEfyAEIAM2AgggAygCCAUgAgs2AgggAygCCCICIAIoAgAgA0dBAnRqIAE2AgAgASADNgIEIAMgATYCCCABKAIIIQILIAFBAToADCACQQA6AAwgAiACKAIEIgMoAgAiBDYCBCAEBEAgBCACNgIICyADIAIoAgg2AgggAigCCCIEIAQoAgAgAkdBAnRqIAM2AgAgAyACNgIAIAIgAzYCCAwCCyADQQE6AAwgAiAAIAJGOgAMIARBAToAACACIQEgACACRw0ACwsLIAAgAQRAIAAgASgCABDTAyAAIAEoAgQQ0wMgARD2DAsLMwAgAQRAIAAgASgCABDUAyAAIAEoAgQQ1AMgASwAG0F/TARAIAEoAhAQ9gwLIAEQ9gwLCx4AQej9BEHs/QQoAgAQ0wNB3P0EQeD9BCgCABDUAwtjACAAQQA2AtwIIABBADYCACAAQgA3AzggAEIANwMIIABBQGtCADcDACAAQgA3A0ggAEIANwNQIABCADcAVSAAQgA3AxAgAEIANwMYIABCADcDICAAQgA3AyggAEIANwAtIAALlgMBBH8gACgCFCIBBEAgASABKAIAKAIEEQEACyAAQSRqIQMCQAJAAkACQAJAIAAoAiQEQEEAIQEDQEHIsgVBADYCAEGZAyADIAEQFSECQciyBSgCACEEQciyBUEANgIAIARBAUYNAiACKAIAIgIEQCACIAIoAgAoAgQRAQALIAFBAWoiASADKAIASQ0ACwsgACgCRCEBQciyBUEANgIAIAEQ6AFByLIFKAIAIQFByLIFQQA2AgAgAUEBRg0BIAAoAtwIIgEEQCABEPYMIABBADYC3AgLIAAoAgAiAQRAIAEgASgCACgCBBEBAAsgACgCLCEBQciyBUEANgIAIAEQ6AFByLIFKAIAIQFByLIFQQA2AgAgAUEBRg0CIAAoAiAhAUHIsgVBADYCACABEOgBQciyBSgCACEBQciyBUEANgIAIAFBAUYNAyAADwtBABALIQEQBxoMAwtBABALIQEQBxoMAgtBABALIQEQBxogARCEAQALQQAQCyEBEAcaIAEQhAEACyADEIMDIABBGGoQgwMgARCEAQALrwgBCH8jAEGwAWsiAiQAAkACQAJAIAAoAgAgAU0EQCACQeg+NgJgIAJB1D42AihByLIFQQA2AgBBKSACQeAAaiIGIAJBKGpBBHIiBBAFQciyBSgCACEDQciyBUEANgIAIANBAUYNASACQoCAgIBwNwOoASACQbA+NgJgIAJBnD42AihByLIFQQA2AgBBKiAEEA0hB0HIsgUoAgAhA0HIsgVBADYCACADQQFGBEAQBiEBEAcaDAQLIAJCADcCTCACQgA3AlQgAkEQNgJcIAJBzD82AixByLIFQQA2AgBBKyACQShqQYeoAkEVEBQhBUHIsgUoAgAhA0HIsgVBADYCAAJAAkACQAJAAkACQAJAAkACQCADQQFGDQBByLIFQQA2AgBBLCAFIAEQFSEDQciyBSgCACEBQciyBUEANgIAIAFBAUYNAEHIsgVBADYCAEErIANBnagCQQQQFCEDQciyBSgCACEBQciyBUEANgIAIAFBAUYNACAAKAIAIQFByLIFQQA2AgBBLCADIAEQFRpByLIFKAIAIQFByLIFQQA2AgAgAUEBRg0AQQQQDiEAQciyBUEANgIAQS1BMBANIQNByLIFKAIAIQFByLIFQQA2AgAgAUEBRg0BQciyBUEANgIAQS4gAkEIaiAEEAVByLIFKAIAIQFByLIFQQA2AgAgAUEBRg0CIAIoAgggAkEIaiACLAATQQBIGyIEEIgNIgFBcE8EQEHIsgVBADYCAEEvIAJBGGoQD0HIsgUoAgAhAUHIsgVBADYCACABQQFGDQQMDAsCQAJAIAFBC08EQEHIsgVBADYCAEEtIAFBEGpBcHEiCBANIQVByLIFKAIAIQlByLIFQQA2AgAgCUEBRg0GIAIgBTYCGCACIAE2AhwgAiAIQYCAgIB4cjYCIAwBCyACIAE6ACMgAkEYaiEFIAFFDQELIAUgBCABEIANGgsgASAFakEAOgAAQciyBUEANgIAQTAgAyACQRhqQcQAQaKoAkGgAkHFqAIQFhpByLIFKAIAIQFByLIFQQA2AgBBASEEIAFBAUcEQCAAIAM2AgBByLIFQQA2AgBBMSAAQazdAEEAEBJByLIFKAIAIQFByLIFQQA2AgBBACEEIAFBAUcNDAsQBiEBEAcaIAIsACNBf0wEQCACKAIYEPYMCyACLAATQQBIDQQMBQsQBiEBEAcaDAcLEAYhARAHGgwFCxAGIQEQBxoMAwsQBiEBEAcaQQEhBCACLAATQQBODQILIAIoAggQ9gwLIARFDQILIAMQ9gwLIAAQEwsgAkGwPjYCYCACQZw+NgIoIAJBzD82AiwgAiwAV0F/TARAIAIoAkwQ9gwLIAcQ4AYaIAYQ3AYgARAIAAsgACgCCCEAIAJBsAFqJAAgACABQQJ0ag8LEAYhARAHGgwBCwALIAYQ3AYgARAIAAuGAwEEfyMAQRBrIgIkACAAKAIAIgBFBEBBBBAOIQBByLIFQQA2AgBBLUEsEA0hBEHIsgUoAgAhAUHIsgVBADYCAAJAAkACQAJAAkAgAUEBRwRAQciyBUEANgIAQS1BIBANIQFByLIFKAIAIQNByLIFQQA2AgAgA0EBRg0BIAIgATYCACACQpiAgICAhICAgH83AgQgAUEAOgAYIAFB6ZUCKQAANwAQIAFB4ZUCKQAANwAIIAFB2ZUCKQAANwAAQciyBUEANgIAQTIgBCACQfKVAkHZAEGWlgIQEBpByLIFKAIAIQFByLIFQQA2AgBBASEDIAFBAUcEQCAAIAQ2AgBByLIFQQA2AgBBMSAAQaDaAEEAEBJByLIFKAIAIQFByLIFQQA2AgBBACEDIAFBAUcNBgsQBiEBEAcaIAIsAAtBf0wEQCACKAIAEPYMCyADDQIMBAsQBiEBEAcaDAILEAYhARAHGgsgBBD2DAsgABATCyABEAgLAAsgACgCLCEAIAJBEGokACAAC7YNAQZ/IwBBwAFrIgQkAAJAAkAgACgCAARAQQQQDiEAQciyBUEANgIAQS1BLBANIQVByLIFKAIAIQNByLIFQQA2AgACQAJAAkAgA0EBRwRAQciyBUEANgIAQS1BIBANIQNByLIFKAIAIQJByLIFQQA2AgAgAkEBRg0BIAQgAzYCGCAEQpmAgICAhICAgH83AhwgA0EAOgAZIANBgpcCLQAAOgAYIANB+pYCKQAANwAQIANB8pYCKQAANwAIIANB6pYCKQAANwAAQciyBUEANgIAQTIgBSAEQRhqQfKVAkGJA0GElwIQEBpByLIFKAIAIQNByLIFQQA2AgBBASECIANBAUcEQCAAIAU2AgBByLIFQQA2AgBBMSAAQaDaAEEAEBJByLIFKAIAIQNByLIFQQA2AgBBACECIANBAUcNBgsQBiEDEAcaIAQsACNBf0wEQCAEKAIYEPYMCyACDQIMBgsQBiEDEAcaDAILEAYhAxAHGgsgBRD2DAsgABATDAILQcAAEP4LIQYCQAJAAkACQAJAAkACQAJAAkACQAJAAkACQAJAAkAgARCIDSIDQXBPBEBByLIFQQA2AgBBLyAEQbABahAPQciyBSgCACEEQciyBUEANgIAIARBAUYNAQwQCwJAAkAgA0ELTwRAQciyBUEANgIAQS0gA0EQakFwcSIHEA0hBUHIsgUoAgAhCEHIsgVBADYCACAIQQFGDQMgBCAFNgKwASAEIAM2ArQBIAQgB0GAgICAeHI2ArgBDAELIAQgAzoAuwEgBEGwAWohBSADRQ0BCyAFIAEgAxCADRoLIAMgBWpBADoAAEEAIQMgAgRAQciyBUEANgIAQS1BIBANIQVByLIFKAIAIQNByLIFQQA2AgAgA0EBRg0CQciyBUEANgIAIAUgAhDuBSEDQciyBSgCACECQciyBUEANgIAIAJBAUYNAwtByLIFQQA2AgBBmwMgBiAEQbABakEDIAMQGiEDQciyBSgCACEFQciyBUEANgIAIAVBAUYNASAAIAY2AgAgBCwAuwFBf0wEQCAEKAKwARD2DCAAKAIAIQMLIARBADoAoAEgBEEAOgCrASADKAIAKAIIIQVByLIFQQA2AgAgBSADIARBoAFqQQAQFCEDQciyBSgCACEFQciyBUEANgIAIAVBAUYNBSAELACrAUF/TARAIAQoAqABEPYMCyADRQ0MIARB6D42AlAgBEHUPjYCGEHIsgVBADYCAEEpIARB0ABqIgAgBEEYakEEciIFEAVByLIFKAIAIQNByLIFQQA2AgAgA0EBRg0NIARCgICAgHA3A5gBIARBsD42AlAgBEGcPjYCGEHIsgVBADYCAEEqIAUQDSECQciyBSgCACEDQciyBUEANgIAIANBAUYEQBAGIQMQBxoMDwsgBEIANwI8IARCADcCRCAEQRA2AkwgBEHMPzYCHEHIsgVBADYCAEErIARBGGpBiZcCQQUQFCEGQciyBSgCACEDQciyBUEANgIAIANBAUYNBiABEIgNIQNByLIFQQA2AgBBKyAGIAEgAxAUIQZByLIFKAIAIQNByLIFQQA2AgAgA0EBRg0GQciyBUEANgIAQSsgBkGPlwJBCBAUGkHIsgUoAgAhA0HIsgVBADYCACADQQFGDQZBBBAOIQZByLIFQQA2AgBBLUEsEA0hAUHIsgUoAgAhA0HIsgVBADYCACADQQFGDQdByLIFQQA2AgBBLiAEQQhqIAUQBUHIsgUoAgAhA0HIsgVBADYCAEEBIQUgA0EBRg0IQciyBUEANgIAQTIgASAEQQhqQfKVAkGPA0GElwIQEBpByLIFKAIAIQNByLIFQQA2AgAgA0EBRwRAIAYgATYCAEEAIQVByLIFQQA2AgBBMSAGQaDaAEEAEBJByLIFKAIAIQNByLIFQQA2AgAgA0EBRw0QCxAGIQMQBxogBCwAE0F/TARAIAQoAggQ9gwLIAUNCQwLCxAGIQMQBxoMAwsQBiEDEAcaDAELEAYhAxAHGiAFEPYMCyAELAC7AUF/Sg0AIAQoArABEPYMCyAGEPYMIAMQCAALEAYhAxAHGiAELACrAUF/Sg0KIAQoAqABEPYMIAMQCAALEAYhAxAHGgwECxAGIQMQBxoMAgsQBiEDEAcaCyABEPYMCyAGEBMLIARBsD42AlAgBEGcPjYCGCAEQcw/NgIcIAQsAEdBf0wEQCAEKAI8EPYMCyACEOAGGiAAENwGIAMQCAALIABCADcDCCAEQcABaiQADwsQBiEDEAcaCyAAENwGIAMQCAALAAsgAxAIAAuXDAEEfyMAQaABayIEJAAgAwRAIANBADYCAAsCQAJAAkACQAJAAkACQCAAKAIUIAEgAiADEJMDRQRAIARB6D42AlAgBEHUPjYCGEHIsgVBADYCAEEpIARB0ABqIgIgBEEYakEEciIAEAVByLIFKAIAIQNByLIFQQA2AgAgA0EBRg0DIARCgICAgHA3A5gBIARBsD42AlAgBEGcPjYCGEHIsgVBADYCAEEqIAAQDSEFQciyBSgCACEDQciyBUEANgIAIANBAUYEQBAGIQMQBxoMCAsgBEIANwI8IARCADcCRCAEQRA2AkwgBEHMPzYCHEHIsgVBADYCAEErIARBGGpBgJoCQRMQFCEGQciyBSgCACEDQciyBUEANgIAAkACQAJAAkACQAJAIANBAUYNACABEIgNIQNByLIFQQA2AgBBKyAGIAEgAxAUGkHIsgUoAgAhA0HIsgVBADYCACADQQFGDQBBBBAOIQFByLIFQQA2AgBBLUEsEA0hBkHIsgUoAgAhA0HIsgVBADYCACADQQFGDQFByLIFQQA2AgBBLiAEQQhqIAAQBUHIsgUoAgAhA0HIsgVBADYCACADQQFGDQJByLIFQQA2AgBBMiAGIARBCGpB8pUCQesFQZSaAhAQGkHIsgUoAgAhA0HIsgVBADYCAEEBIQAgA0EBRwRAIAEgBjYCAEHIsgVBADYCAEExIAFBoNoAQQAQEkHIsgUoAgAhA0HIsgVBADYCAEEAIQAgA0EBRw0JCxAGIQMQBxogBCwAE0F/TARAIAQoAggQ9gwLIAANAwwFCxAGIQMQBxoMBAsQBiEDEAcaDAILEAYhAxAHGgsgBhD2DAsgARATCyAEQbA+NgJQIARBnD42AhggBEHMPzYCHCAELABHQX9MBEAgBCgCPBD2DAsgBRDgBhogAhDcBgwBCyACKAIAIgMgAygCACgCCBEAAEEFSQ0EIARB6D42AlAgBEHUPjYCGEHIsgVBADYCAEEpIARB0ABqIgAgBEEYakEEciIFEAVByLIFKAIAIQNByLIFQQA2AgAgA0EBRg0DIARCgICAgHA3A5gBIARBsD42AlAgBEGcPjYCGEHIsgVBADYCAEEqIAUQDSEGQciyBSgCACEDQciyBUEANgIAIANBAUYEQBAGIQMQBxoMBgsgBEIANwI8IARCADcCRCAEQRA2AkwgBEHMPzYCHEHIsgVBADYCAEErIARBGGpBqJoCQRkQFCEHQciyBSgCACEDQciyBUEANgIAAkACQAJAAkACQAJAIANBAUYNACABEIgNIQNByLIFQQA2AgBBKyAHIAEgAxAUIQFByLIFKAIAIQNByLIFQQA2AgAgA0EBRg0AQciyBUEANgIAQSsgAUHCmgJBBhAUIQFByLIFKAIAIQNByLIFQQA2AgAgA0EBRg0AIAIoAgAiAygCACgCCCECQciyBUEANgIAIAIgAxANIQJByLIFKAIAIQNByLIFQQA2AgAgA0EBRg0AQciyBUEANgIAQTMgASACEBUaQciyBSgCACEDQciyBUEANgIAIANBAUYNAEEEEA4hAkHIsgVBADYCAEEtQSwQDSEBQciyBSgCACEDQciyBUEANgIAIANBAUYNAUHIsgVBADYCAEEuIARBCGogBRAFQciyBSgCACEDQciyBUEANgIAQQEhBSADQQFGDQJByLIFQQA2AgBBMiABIARBCGpB8pUCQfgFQZSaAhAQGkHIsgUoAgAhA0HIsgVBADYCACADQQFHBEAgAiABNgIAQQAhBUHIsgVBADYCAEExIAJBoNoAQQAQEkHIsgUoAgAhA0HIsgVBADYCACADQQFHDQgLEAYhAxAHGiAELAATQX9MBEAgBCgCCBD2DAsgBQ0DDAULEAYhAxAHGgwECxAGIQMQBxoMAgsQBiEDEAcaCyABEPYMCyACEBMLIARBsD42AlAgBEGcPjYCGCAEQcw/NgIcIAQsAEdBf0wEQCAEKAI8EPYMCyAGEOAGGiAAENwGCyADEAgLAAsQBiEDEAcaDAMLEAYhAxAHGgwBCyAEQaABaiQADwsgABDcBiADEAgACyACENwGIAMQCAALuwEAIAAgAjYCECAAIAEgAxDaAyAAIABBAEEAEIcDIgE2AhQgASABKAIAKAIIEQEAIAQEQCAAIAYgByAIIAkQ3QMLIABBypYCIABBOGpBABDbAyAAQdOXAiAAQTxqQQAQ2wMgAEHnlwIgAEFAa0EAENsDIAAgACgCFEGilgIgBEEARxDeAxogACgCFCIEQQAgBCgCACgCEBECACAFBEAgACAAKAIUQaeWAhCRAyIEQayWAiAEKAJgEN4DGgsLiQEBAX8gACgCFEH5ngIQkQMiBUUEQCAAIAAoAhRB+Z4CQQAQ3gMhBQsCQCABRQ0AQQAhACAFKAJsIAFBABC1BCAFKAJwIAJBABDXASAFKAJ0IgEgBCABKAIAKAIQEQIAIARFDQADQCAFKAJ0IAMgAEECdGooAgAgABC1BCAAQQFqIgAgBEcNAAsLC7MDAQF/IwBBEGsiBCQAIAAgASACEIcDIQAgAUUEQEEEEA4hAEHIsgVBADYCAEEtQSwQDSECQciyBSgCACEBQciyBUEANgIAAkACQAJAAkACQCABQQFHBEBByLIFQQA2AgBBLUEgEA0hAUHIsgUoAgAhA0HIsgVBADYCACADQQFGDQEgBCABNgIAIARCnYCAgICEgICAfzcCBCABQQA6AB0gAUHnmQIpAAA3ABUgAUHimQIpAAA3ABAgAUHamQIpAAA3AAggAUHSmQIpAAA3AABByLIFQQA2AgBBMiACIARB8pUCQa8FQfCZAhAQGkHIsgUoAgAhAUHIsgVBADYCAEEBIQMgAUEBRg0CIAAgAjYCAEHIsgVBADYCAEExIABBoNoAQQAQEkHIsgUoAgAhAUHIsgVBADYCAEEAIQMgAUEBRg0CAAsQBiEBEAcaDAMLEAYhARAHGgwBCxAGIQEQBxogBCwAC0F/TARAIAQoAgAQ9gwLIANFDQILIAIQ9gwLIAAQEwsgARAIAAsgACABNgJAIAFB4ABqIAAgAxDpASAAIAAoAgAoAggRAQAgBEEQaiQAIAALYQEBf0EBIQICfwJAIAEQrQUiAUGilgIQrQVGDQBBsZYCEK0FIAFGDQBBAiECQbaWAhCtBSABRg0AQbuWAhCtBSABRg0AQQBBwJYCEK0FIAFHDQEaCyAAKAIQIAJxQQBHCwtgAQF/QQEhAgJAAkAgARCtBSIBQaKWAhCtBUYNAEGxlgIQrQUgAUYNAEECIQJBtpYCEK0FIAFGDQBBu5YCEK0FIAFGDQBBwJYCEK0FIAFHDQELIAAgACgCECACcjYCEAsLnwMBBH8jAEEQayIEJAACQCAAKAIAIgAEQCAAKAI0KAIAQQFHDQELQQQQDiEFQciyBUEANgIAQS1BLBANIQZByLIFKAIAIQBByLIFQQA2AgACQAJAAkACQAJAIABBAUcEQEHIsgVBADYCAEEtQTAQDSEAQciyBSgCACEHQciyBUEANgIAIAdBAUYNASAEIAA2AgAgBEKkgICAgIaAgIB/NwIEIABBADoAJCAAQc2ZAigAADYAICAAQcWZAikAADcAGCAAQb2ZAikAADcAECAAQbWZAikAADcACCAAQa2ZAikAADcAAEHIsgVBADYCAEEyIAYgBCABIAIgAxAQGkHIsgUoAgAhAEHIsgVBADYCAEEBIQEgAEEBRwRAIAUgBjYCAEHIsgVBADYCAEExIAVBoNoAQQAQEkHIsgUoAgAhAEHIsgVBADYCAEEAIQEgAEEBRw0GCxAGIQAQBxogBCwAC0F/TARAIAQoAgAQ9gwLIAENAgwECxAGIQAQBxoMAgsQBiEAEAcaCyAGEPYMCyAFEBMLIAAQCAsACyAEQRBqJAAL/wMBBH8jAEEQayIEJAAgACgCACIDIAJJBEBBBBAOIQBByLIFQQA2AgBBLUEwEA0hAkHIsgUoAgAhA0HIsgVBADYCAAJAAkACQAJAAkAgA0EBRwRAQciyBUEANgIAQS1BIBANIQNByLIFKAIAIQFByLIFQQA2AgAgAUEBRg0BIAQgAzYCACAEQpOAgICAhICAgH83AgQgA0EAOgATIANB36gCKAAANgAPIANB2KgCKQAANwAIIANB0KgCKQAANwAAQciyBUEANgIAQTAgAiAEQcQAQeuoAkGCAUHkqAIQFhpByLIFKAIAIQNByLIFQQA2AgBBASEBIANBAUYNAiAAIAI2AgBByLIFQQA2AgBBMSAAQazdAEEAEBJByLIFKAIAIQNByLIFQQA2AgBBACEBIANBAUYNAgALEAYhAxAHGgwDCxAGIQMQBxoMAQsQBiEDEAcaIAQsAAtBf0wEQCAEKAIAEPYMCyABRQ0CCyACEPYMCyAAEBMLIAMQCAALAkAgACgCBCADRwRAIAAoAgghBQwBCyAAIANBASADQQFLGyIDQQF0NgIEIAAgACgCCCADQQN0EOoBIgU2AgggACgCACEDCyAFIAJBAnQiBmoiBUEEaiAFIAMgAmtBAnQQgg0gACgCCCAGaiABNgIAIAAgACgCAEEBajYCACAEQRBqJAAL/wMBBH8jAEEQayIEJAAgACgCACIDIAJJBEBBBBAOIQBByLIFQQA2AgBBLUEwEA0hAkHIsgUoAgAhA0HIsgVBADYCAAJAAkACQAJAAkAgA0EBRwRAQciyBUEANgIAQS1BIBANIQNByLIFKAIAIQFByLIFQQA2AgAgAUEBRg0BIAQgAzYCACAEQpOAgICAhICAgH83AgQgA0EAOgATIANB36gCKAAANgAPIANB2KgCKQAANwAIIANB0KgCKQAANwAAQciyBUEANgIAQTAgAiAEQcQAQaKoAkGgAkHkqAIQFhpByLIFKAIAIQNByLIFQQA2AgBBASEBIANBAUYNAiAAIAI2AgBByLIFQQA2AgBBMSAAQazdAEEAEBJByLIFKAIAIQNByLIFQQA2AgBBACEBIANBAUYNAgALEAYhAxAHGgwDCxAGIQMQBxoMAQsQBiEDEAcaIAQsAAtBf0wEQCAEKAIAEPYMCyABRQ0CCyACEPYMCyAAEBMLIAMQCAALAkAgACgCBCADRwRAIAAoAgghBQwBCyAAIANBASADQQFLGyIDQQF0NgIEIAAgACgCCCADQQN0EOoBIgU2AgggACgCACEDCyAFIAJBAnQiBmoiBUEEaiAFIAMgAmtBAnQQgg0gACgCCCAGaiABNgIAIAAgACgCAEEBajYCACAEQRBqJAALqQ8CBX8CfiMAQRBrIgUkAAJAIAAoAhRB+pcCEJEDIgRFDQAgBCgCYA0AAkAgBCgCQCIDKAJgRQ0AIANB4ABqIQJBACEDA0AgBCACIAMQkQEoAgBGBEAgAiADEJIBDAILIANBAWoiAyACKAIASQ0ACwsgBCAEKAIAKAIEEQEACwJAIAAoAhRBjpgCEJEDIgJFDQAgAigCYCIDQQFLDQAgA0EBawRAAkAgAigCQCIDKAJgRQ0AIANB4ABqIQRBACEDA0AgAiAEIAMQkQEoAgBGBEAgBCADEJIBDAILIANBAWoiAyAEKAIASQ0ACwsgAiACKAIAKAIEEQEADAELQQAhAyACQeAAakEAEJEBKAIAQShqEK0FQZ2YAhCtBUcNAAJAIAIoAkAiBCgCYEUNACAEQeAAaiEEA0AgAiAEIAMQkQEoAgBGBEAgBCADEJIBDAILIANBAWoiAyAEKAIASQ0ACwsgAiACKAIAKAIEEQEACwJAIAAoAhRBopgCEJEDIgRFDQAgACAFIAVBDGoQ5QMgBSgCACIGQRhqIgIgBSgCDCIDELEBKAIAEOMBIAZBJGogAxCwASgCACACIAMQsQEoAgAQgA0aIAIgAxCxASgCAA0AAkAgBCgCQCIDKAJgRQ0AIANB4ABqIQJBACEDA0AgBCACIAMQkQEoAgBGBEAgAiADEJIBDAILIANBAWoiAyACKAIASQ0ACwsgBCAEKAIAKAIEEQEACwJAIAAoAhRBxpgCEJEDIgRFDQAgBCgCYA0AAkAgBCgCQCIDKAJgRQ0AIANB4ABqIQJBACEDA0AgBCACIAMQkQEoAgBGBEAgAiADEJIBDAILIANBAWoiAyACKAIASQ0ACwsgBCAEKAIAKAIEEQEACwJAAkAgACgCJARAIABBJGohAkEAIQMDQCACIAMQ2AMoAgBFBEBBBBAOIQNByLIFQQA2AgBBLUEsEA0hBEHIsgUoAgAhAkHIsgVBADYCAAJAAkACQAJAIAJBAUcEQEHIsgVBADYCAEEtQSAQDSECQciyBSgCACEBQciyBUEANgIAIAFBAUYNASAFIAI2AgAgBUKegICAgISAgIB/NwIEIAJBADoAHiACQeaYAikAADcAFiACQeCYAikAADcAECACQdiYAikAADcACCACQdCYAikAADcAAEHIsgVBADYCAEEyIAQgBUHylQJBvgRB75gCEBAaQciyBSgCACECQciyBUEANgIAQQEhASACQQFGDQIgAyAENgIAQciyBUEANgIAQTEgA0Gg2gBBABASQciyBSgCACECQciyBUEANgIAQQAhASACQQFGDQIMCQsQBiECEAcaDAMLEAYhAhAHGgwBCxAGIQIQBxogBSwAC0F/TARAIAUoAgAQ9gwLIAFFDQULIAQQ9gwLIAMQEwwDCyACIAMQ2AMoAgAiBCABIAQoAgAoAggRAgAgA0EBaiIDIAIoAgBJDQALCyAAKAIUIgNBACADKAIAKAIcEQIAIABBABCwAyAAQQAQsgNUBEAgACgCFCICRQRAQQQQDiEDQciyBUEANgIAQS1BLBANIQRByLIFKAIAIQJByLIFQQA2AgACQAJAAkAgAkEBRwRAQciyBUEANgIAQS1BIBANIQJByLIFKAIAIQFByLIFQQA2AgAgAUEBRg0BIAUgAjYCACAFQpaAgICAhICAgH83AgQgAkEAOgAWIAJBiZkCKQAANwAOIAJBg5kCKQAANwAIIAJB+5gCKQAANwAAQciyBUEANgIAQTIgBCAFQfKVAkHJBEHvmAIQEBpByLIFKAIAIQJByLIFQQA2AgBBASEBIAJBAUcEQCADIAQ2AgBByLIFQQA2AgBBMSADQaDaAEEAEBJByLIFKAIAIQJByLIFQQA2AgBBACEBIAJBAUcNCAsQBiECEAcaIAUsAAtBf0wEQCAFKAIAEPYMCyABRQ0GDAILEAYhAhAHGgwCCxAGIQIQBxoLIAQQ9gwLIAMQEyACEAgACyAAQQAQsgMhByAAQQAQsAMhCCAAQQBBxZYCEIcDIgNFBEBBBBAOIQNByLIFQQA2AgBBLUEsEA0hBEHIsgUoAgAhAkHIsgVBADYCAAJAAkACQCACQQFHBEBByLIFQQA2AgBBLUEgEA0hAkHIsgUoAgAhAUHIsgVBADYCACABQQFGDQEgBSACNgIAIAVCmoCAgICEgICAfzcCBCACQQA6ABogAkGqmQIvAAA7ABggAkGimQIpAAA3ABAgAkGamQIpAAA3AAggAkGSmQIpAAA3AABByLIFQQA2AgBBMiAEIAVB8pUCQdMEQe+YAhAQGkHIsgUoAgAhAkHIsgVBADYCAEEBIQEgAkEBRwRAIAMgBDYCAEEAIQFByLIFQQA2AgBBMSADQaDaAEEAEBJByLIFKAIAIQJByLIFQQA2AgAgAkEBRw0ICxAGIQIQBxogBSwAC0F/TARAIAUoAgAQ9gwLIAFFDQYMAgsQBiECEAcaDAILEAYhAhAHGgsgBBD2DAsgAxATIAIQCAALIAMgAjYCQCADQgAgByAIfSIHQnh8IgggCCAHVhs3AyAgAkHgAGogAyACKAJgEOkBIAMgAygCACgCFBEBAAsgBUEQaiQADwsgAhAIAAsAC6EMAQR/IwBBoAFrIgMkACACBEAgAkEANgIACwJAAkACQAJAAkACQAJAIAAoAhRBsZgCIAEgAhCTA0UEQCADQeg+NgJQIANB1D42AhhByLIFQQA2AgBBKSADQdAAaiIBIANBGGpBBHIiABAFQciyBSgCACECQciyBUEANgIAIAJBAUYNAyADQoCAgIBwNwOYASADQbA+NgJQIANBnD42AhhByLIFQQA2AgBBKiAAEA0hBUHIsgUoAgAhAkHIsgVBADYCACACQQFGBEAQBiECEAcaDAgLIANCADcCPCADQgA3AkQgA0EQNgJMIANBzD82AhxByLIFQQA2AgBBKyADQRhqQf+aAkEREBQhBkHIsgUoAgAhAkHIsgVBADYCAAJAAkACQAJAAkACQCACQQFGDQBBsZgCEIgNIQJByLIFQQA2AgBBKyAGQbGYAiACEBQaQciyBSgCACECQciyBUEANgIAIAJBAUYNAEEEEA4hBEHIsgVBADYCAEEtQSwQDSEGQciyBSgCACECQciyBUEANgIAIAJBAUYNAUHIsgVBADYCAEEuIANBCGogABAFQciyBSgCACECQciyBUEANgIAIAJBAUYNAkHIsgVBADYCAEEyIAYgA0EIakHylQJB4gZBkZsCEBAaQciyBSgCACECQciyBUEANgIAQQEhACACQQFHBEAgBCAGNgIAQciyBUEANgIAQTEgBEGg2gBBABASQciyBSgCACECQciyBUEANgIAQQAhACACQQFHDQkLEAYhAhAHGiADLAATQX9MBEAgAygCCBD2DAsgAA0DDAULEAYhAhAHGgwECxAGIQIQBxoMAgsQBiECEAcaCyAGEPYMCyAEEBMLIANBsD42AlAgA0GcPjYCGCADQcw/NgIcIAMsAEdBf0wEQCADKAI8EPYMCyAFEOAGGiABENwGDAELIAEoAgAiAiACKAIAKAIIEQAAQQdGDQQgA0HoPjYCUCADQdQ+NgIYQciyBUEANgIAQSkgA0HQAGoiACADQRhqQQRyIgUQBUHIsgUoAgAhAkHIsgVBADYCACACQQFGDQMgA0KAgICAcDcDmAEgA0GwPjYCUCADQZw+NgIYQciyBUEANgIAQSogBRANIQZByLIFKAIAIQJByLIFQQA2AgAgAkEBRgRAEAYhAhAHGgwGCyADQgA3AjwgA0IANwJEIANBEDYCTCADQcw/NgIcQciyBUEANgIAQSsgA0EYakGomgJBGRAUIQRByLIFKAIAIQJByLIFQQA2AgACQAJAAkACQAJAAkAgAkEBRg0AQbGYAhCIDSECQciyBUEANgIAQSsgBEGxmAIgAhAUIQRByLIFKAIAIQJByLIFQQA2AgAgAkEBRg0AQciyBUEANgIAQSsgBEGjmwJBCBAUIQRByLIFKAIAIQJByLIFQQA2AgAgAkEBRg0AIAEoAgAiAigCACgCCCEBQciyBUEANgIAIAEgAhANIQFByLIFKAIAIQJByLIFQQA2AgAgAkEBRg0AQciyBUEANgIAQTMgBCABEBUaQciyBSgCACECQciyBUEANgIAIAJBAUYNAEEEEA4hAUHIsgVBADYCAEEtQSwQDSEEQciyBSgCACECQciyBUEANgIAIAJBAUYNAUHIsgVBADYCAEEuIANBCGogBRAFQciyBSgCACECQciyBUEANgIAQQEhBSACQQFGDQJByLIFQQA2AgBBMiAEIANBCGpB8pUCQecGQZGbAhAQGkHIsgUoAgAhAkHIsgVBADYCACACQQFHBEAgASAENgIAQQAhBUHIsgVBADYCAEExIAFBoNoAQQAQEkHIsgUoAgAhAkHIsgVBADYCACACQQFHDQgLEAYhAhAHGiADLAATQX9MBEAgAygCCBD2DAsgBQ0DDAULEAYhAhAHGgwECxAGIQIQBxoMAgsQBiECEAcaCyAEEPYMCyABEBMLIANBsD42AlAgA0GcPjYCGCADQcw/NgIcIAMsAEdBf0wEQCADKAI8EPYMCyAGEOAGGiAAENwGCyACEAgLAAsQBiECEAcaDAMLEAYhAhAHGgwBCyADQaABaiQADwsgABDcBiACEAgACyABENwGIAIQCAALmwECAn8BfiMAQRBrIgIkAAJAIAAoAgAiA0UNACADKAI0KAIAQQFHBEAQrAUhBCAAQfKVAkGIBkHJmgIQ4QMgAkEANgIMIAJBADYCCCAAQcqWAiACQQxqIAJBCGoQ2wMgAigCDCAEIAIoAggQowQgACABEOQDIAAoAgAiA0UNAQsgAyADKAIAKAIEEQEACyAAQQA2AgAgAkEQaiQAC6UGAQV/IwBBoAFrIgIkAAJAAkACQAJAIAAoAiRFDQAgAEEkaiEDQQAhAANAIAMgABDYAygCACgCDCABRg0CIABB/v8DSw0BIABBAWoiACADKAIASQ0ACwsgAkHoPjYCUCACQdQ+NgIYQciyBUEANgIAQSkgAkHQAGoiAyACQRhqQQRyIgQQBUHIsgUoAgAhAEHIsgVBADYCACAAQQFGDQEgAkKAgICAcDcDmAEgAkGwPjYCUCACQZw+NgIYQciyBUEANgIAQSogBBANIQZByLIFKAIAIQBByLIFQQA2AgAgAEEBRgRAEAYhABAHGgwDCyACQgA3AjwgAkIANwJEIAJBEDYCTCACQcw/NgIcQciyBUEANgIAQSsgAkEYakGppgJBCRAUIQVByLIFKAIAIQBByLIFQQA2AgACQAJAAkACQAJAAkACQCAAQQFGDQBByLIFQQA2AgBBLCAFIAEQFSEBQciyBSgCACEAQciyBUEANgIAIABBAUYNAEHIsgVBADYCAEErIAFBs6YCQQ4QFBpByLIFKAIAIQBByLIFQQA2AgAgAEEBRg0AQQQQDiEBQciyBUEANgIAQS1BLBANIQVByLIFKAIAIQBByLIFQQA2AgAgAEEBRg0BQciyBUEANgIAQS4gAkEIaiAEEAVByLIFKAIAIQBByLIFQQA2AgBBASEEIABBAUYNAkHIsgVBADYCAEEyIAUgAkEIakHylQJB+xZBwqYCEBAaQciyBSgCACEAQciyBUEANgIAIABBAUYNAyABIAU2AgBBACEEQciyBUEANgIAQTEgAUGg2gBBABASQciyBSgCACEAQciyBUEANgIAIABBAUYNAwALEAYhABAHGgwFCxAGIQAQBxoMAwsQBiEAEAcaDAELEAYhABAHGiACLAATQX9MBEAgAigCCBD2DAsgBEUNAgsgBRD2DAsgARATCyACQbA+NgJQIAJBnD42AhggAkHMPzYCHCACLABHQX9MBEAgAigCPBD2DAsgBhDgBhogAxDcBiAAEAgACyACQaABaiQAIABB//8DcQ8LEAYhABAHGgsgAxDcBiAAEAgAC5cMAQR/IwBBoAFrIgQkACADBEAgA0EANgIACwJAAkACQAJAAkACQAJAIAAoAhQgASACIAMQkwNFBEAgBEHoPjYCUCAEQdQ+NgIYQciyBUEANgIAQSkgBEHQAGoiAiAEQRhqQQRyIgAQBUHIsgUoAgAhA0HIsgVBADYCACADQQFGDQMgBEKAgICAcDcDmAEgBEGwPjYCUCAEQZw+NgIYQciyBUEANgIAQSogABANIQVByLIFKAIAIQNByLIFQQA2AgAgA0EBRgRAEAYhAxAHGgwICyAEQgA3AjwgBEIANwJEIARBEDYCTCAEQcw/NgIcQciyBUEANgIAQSsgBEEYakGAmgJBExAUIQZByLIFKAIAIQNByLIFQQA2AgACQAJAAkACQAJAAkAgA0EBRg0AIAEQiA0hA0HIsgVBADYCAEErIAYgASADEBQaQciyBSgCACEDQciyBUEANgIAIANBAUYNAEEEEA4hAUHIsgVBADYCAEEtQSwQDSEGQciyBSgCACEDQciyBUEANgIAIANBAUYNAUHIsgVBADYCAEEuIARBCGogABAFQciyBSgCACEDQciyBUEANgIAIANBAUYNAkHIsgVBADYCAEEyIAYgBEEIakHylQJBmAZB3JoCEBAaQciyBSgCACEDQciyBUEANgIAQQEhACADQQFHBEAgASAGNgIAQciyBUEANgIAQTEgAUGg2gBBABASQciyBSgCACEDQciyBUEANgIAQQAhACADQQFHDQkLEAYhAxAHGiAELAATQX9MBEAgBCgCCBD2DAsgAA0DDAULEAYhAxAHGgwECxAGIQMQBxoMAgsQBiEDEAcaCyAGEPYMCyABEBMLIARBsD42AlAgBEGcPjYCGCAEQcw/NgIcIAQsAEdBf0wEQCAEKAI8EPYMCyAFEOAGGiACENwGDAELIAIoAgAiAyADKAIAKAIIEQAAQQVGDQQgBEHoPjYCUCAEQdQ+NgIYQciyBUEANgIAQSkgBEHQAGoiACAEQRhqQQRyIgUQBUHIsgUoAgAhA0HIsgVBADYCACADQQFGDQMgBEKAgICAcDcDmAEgBEGwPjYCUCAEQZw+NgIYQciyBUEANgIAQSogBRANIQZByLIFKAIAIQNByLIFQQA2AgAgA0EBRgRAEAYhAxAHGgwGCyAEQgA3AjwgBEIANwJEIARBEDYCTCAEQcw/NgIcQciyBUEANgIAQSsgBEEYakGomgJBGRAUIQdByLIFKAIAIQNByLIFQQA2AgACQAJAAkACQAJAAkAgA0EBRg0AIAEQiA0hA0HIsgVBADYCAEErIAcgASADEBQhAUHIsgUoAgAhA0HIsgVBADYCACADQQFGDQBByLIFQQA2AgBBKyABQcKaAkEGEBQhAUHIsgUoAgAhA0HIsgVBADYCACADQQFGDQAgAigCACIDKAIAKAIIIQJByLIFQQA2AgAgAiADEA0hAkHIsgUoAgAhA0HIsgVBADYCACADQQFGDQBByLIFQQA2AgBBMyABIAIQFRpByLIFKAIAIQNByLIFQQA2AgAgA0EBRg0AQQQQDiECQciyBUEANgIAQS1BLBANIQFByLIFKAIAIQNByLIFQQA2AgAgA0EBRg0BQciyBUEANgIAQS4gBEEIaiAFEAVByLIFKAIAIQNByLIFQQA2AgBBASEFIANBAUYNAkHIsgVBADYCAEEyIAEgBEEIakHylQJBnQZB3JoCEBAaQciyBSgCACEDQciyBUEANgIAIANBAUcEQCACIAE2AgBBACEFQciyBUEANgIAQTEgAkGg2gBBABASQciyBSgCACEDQciyBUEANgIAIANBAUcNCAsQBiEDEAcaIAQsABNBf0wEQCAEKAIIEPYMCyAFDQMMBQsQBiEDEAcaDAQLEAYhAxAHGgwCCxAGIQMQBxoLIAEQ9gwLIAIQEwsgBEGwPjYCUCAEQZw+NgIYIARBzD82AhwgBCwAR0F/TARAIAQoAjwQ9gwLIAYQ4AYaIAAQ3AYLIAMQCAsACxAGIQMQBxoMAwsQBiEDEAcaDAELIARBoAFqJAAPCyAAENwGIAMQCAALIAIQ3AYgAxAIAAvIDwEHfyMAQSBrIgIkACAAQfKVAkGIB0GsmwIQ4QMCQAJAAkACQAJAAkACQAJAIAAgACgCFEGnlgIQkQMiA0G1mwIgAygCYBDeAyIDRQRAQQQQDiEDQciyBUEANgIAQS1BLBANIQVByLIFKAIAIQBByLIFQQA2AgACQAJAAkAgAEEBRwRAQciyBUEANgIAQS1BIBANIQBByLIFKAIAIQRByLIFQQA2AgAgBEEBRg0BIAIgADYCECACQpuAgICAhICAgH83AhQgAEEAOgAbIABB0ZsCKAAANgAXIABBypsCKQAANwAQIABBwpsCKQAANwAIIABBupsCKQAANwAAQciyBUEANgIAQTIgBSACQRBqQfKVAkGMB0GsmwIQEBpByLIFKAIAIQBByLIFQQA2AgBBASEEIABBAUcEQCADIAU2AgBByLIFQQA2AgBBMSADQaDaAEEAEBJByLIFKAIAIQBByLIFQQA2AgBBACEEIABBAUcNBgsQBiEAEAcaIAIsABtBf0wEQCACKAIQEPYMCyAEDQIMDAsQBiEAEAcaDAILEAYhABAHGgsgBRD2DAsgAxATDAgLIABBGGogABDqAyIFIAAoAhgQ4gMgAkEANgIMIANBppcCIAJBDGpBABCTAxogAigCDCIGRQRAQQQQDiEDQciyBUEANgIAQS1BLBANIQVByLIFKAIAIQBByLIFQQA2AgACQAJAAkAgAEEBRwRAQciyBUEANgIAQS1BMBANIQBByLIFKAIAIQRByLIFQQA2AgAgBEEBRg0BIAIgADYCECACQqSAgICAhoCAgH83AhQgAEEAOgAkIABB9psCKAAANgAgIABB7psCKQAANwAYIABB5psCKQAANwAQIABB3psCKQAANwAIIABB1psCKQAANwAAQciyBUEANgIAQTIgBSACQRBqQfKVAkGXB0GsmwIQEBpByLIFKAIAIQBByLIFQQA2AgBBASEEIABBAUcEQCADIAU2AgBBACEEQciyBUEANgIAQTEgA0Gg2gBBABASQciyBSgCACEAQciyBUEANgIAIABBAUcNBgsQBiEAEAcaIAIsABtBf0wEQCACKAIQEPYMCyAERQ0MDAILEAYhABAHGgwCCxAGIQAQBxoLIAUQ9gwLIAMQEyAAEAgACyAGIAVBABDXARCrBSIEEIgNQQVPBEAgABDZAyIGKAIAIQcgBiwACyEIIAJBrJsCNgIAIAIgByAGIAhBAEgbNgIEQfubAiACELwBCyACQQA2AgggA0G4lwIgAkEIakEAEJMDGiACKAIIIgZFBEBBBBAOIQNByLIFQQA2AgBBLUEsEA0hBUHIsgUoAgAhAEHIsgVBADYCAAJAAkACQCAAQQFHBEBByLIFQQA2AgBBLUEwEA0hAEHIsgUoAgAhBEHIsgVBADYCACAEQQFGDQEgAiAANgIQIAJCoYCAgICGgICAfzcCFCAAQQA6ACEgAEHHnAItAAA6ACAgAEG/nAIpAAA3ABggAEG3nAIpAAA3ABAgAEGvnAIpAAA3AAggAEGnnAIpAAA3AABByLIFQQA2AgBBMiAFIAJBEGpB8pUCQacHQaybAhAQGkHIsgUoAgAhAEHIsgVBADYCAEEBIQQgAEEBRwRAIAMgBTYCAEEAIQRByLIFQQA2AgBBMSADQaDaAEEAEBJByLIFKAIAIQBByLIFQQA2AgAgAEEBRw0GCxAGIQAQBxogAiwAG0F/TARAIAIoAhAQ9gwLIARFDQwMAgsQBiEAEAcaDAILEAYhABAHGgsgBRD2DAsgAxATIAAQCAALIAYgBEEAELUEIAJBADYCDCADQcmcAiACQQxqQQAQkwMaIAIoAgwiBg0GQQQQDiEDQciyBUEANgIAQS1BLBANIQVByLIFKAIAIQBByLIFQQA2AgAgAEEBRg0BQciyBUEANgIAQS1BMBANIQBByLIFKAIAIQRByLIFQQA2AgAgBEEBRg0CIAIgADYCECACQqSAgICAhoCAgH83AhQgAEEAOgAkIABB9psCKAAANgAgIABB7psCKQAANwAYIABB5psCKQAANwAQIABB3psCKQAANwAIIABB1psCKQAANwAAQciyBUEANgIAQTIgBSACQRBqQfKVAkGuB0GsmwIQEBpByLIFKAIAIQBByLIFQQA2AgBBASEEIABBAUYNAyADIAU2AgBByLIFQQA2AgBBMSADQaDaAEEAEBJByLIFKAIAIQBByLIFQQA2AgBBACEEIABBAUYNAwsACxAGIQAQBxoMAwsQBiEAEAcaDAELEAYhABAHGiACLAAbQX9MBEAgAigCEBD2DAsgBEUNAwsgBRD2DAsgAxATIAAQCAALIAYgAUHoByABG0EAENcBAkAgBEHllgIQgwZFBEBBkAMQ/gshAUHIsgVBADYCAEGcAyABIAAgAxAUGkHIsgUoAgAhA0HIsgVBADYCACADQQFHDQEQBiECEAcaIAEQ9gwgAhAIAAtBiAIQ/gshBkHIsgVBADYCAEGdAyAGIAAgAxAUIQFByLIFKAIAIQNByLIFQQA2AgAgA0EBRw0AEAYhAhAHGiAGEPYMIAIQCAALIABBJGogASAAKAIkEOMDIARB5ZYCEIMGBEAgACAFQeKcAkIBEOsDCyAAIAUQ7AMgAkEgaiQAIAUPCyAAEAgAC6sGAgR/AX4jAEEQayICJAAgAEHtpQIgAiACQQxqENsDAkACQAJAAkAgAigCACACKAIMEKIEIgWnIgNBgIAETw0AQciyBUEANgIAQZ4DIAAgAxAVGkHIsgUoAgAhAUHIsgVBADYCACABQQFHDQBBoNoAEAshARAHQaDaABAZRw0BIAEQDCIBBEAgASABKAIAKAIEEQEAC0HIsgVBADYCAEGfAyAAQfKVAkGIBkHJmgIQHEHIsgUoAgAhAUHIsgVBADYCAAJAIAFBAUYNACACQQA2AgBByLIFQQA2AgAgAkEANgIMQaADIABB7aUCIAIgAkEMahAcQciyBSgCACEBQciyBUEANgIAIAFBAUYNAEHIsgVBADYCAEGhAyACKAIAIAVCAXxC/////w+DIAIoAgwQtA1ByLIFKAIAIQFByLIFQQA2AgAgAUEBRw0ECxAGIQEQBxoQFwwBC0EBIQMDQEHIsgVBADYCAEGeAyAAIAMQFRpByLIFKAIAIQFByLIFQQA2AgAgAUEBRgRAQaDaABALIQEQB0Gg2gAQGUcNAiABEAwiAUUNBCABIAEoAgAoAgQRAQAMBAsgA0EBaiIDQYCABEcNAAtBBBAOIQNByLIFQQA2AgBBLUEsEA0hAEHIsgUoAgAhAUHIsgVBADYCAAJAAkACQCABQQFHBEBByLIFQQA2AgBBLUEgEA0hAUHIsgUoAgAhBEHIsgVBADYCACAEQQFGDQEgAiABNgIAIAJCmICAgICEgICAfzcCBCABQQA6ABggAUGTpgIpAAA3ABAgAUGLpgIpAAA3AAggAUGDpgIpAAA3AABByLIFQQA2AgBBMiAAIAJB8pUCQcYWQZymAhAQGkHIsgUoAgAhAUHIsgVBADYCAEEBIQQgAUEBRwRAIAMgADYCAEHIsgVBADYCAEExIANBoNoAQQAQEkHIsgUoAgAhAUHIsgVBADYCAEEAIQQgAUEBRw0GCxAGIQEQBxogAiwAC0F/TARAIAIoAgAQ9gwLIAQNAgwECxAGIQEQBxoMAgsQBiEBEAcaCyAAEPYMCyADEBMLIAEQCAsACxAXIAJBEGokACADC7EBAQF/IwBBIGsiBCQAIAAgARDtAyEBAkACQCACBEAgAi0AAA0BCyAEIAE2AgAgAEHcAGpBgAhBmJcCIAQQlQYaDAELIAQgAjYCFCAEIAE2AhAgAEHcAGpBgAhB76YCIARBEGoQlQYaCyAAQfKVAkGIBkHJmgIQ4QMgBEEANgIcIARBADYCGCAAIABB3ABqIARBHGogBEEYahDbAyAEKAIcIAMgBCgCGBCjBCAEQSBqJAALmgcBA38jAEEgayICJAAgACABEO0DIQEgAkGYnQI2AgQgAiABNgIAIABB3ABqIgNBgAhB76YCIAIQlQYaIAAoAhQhAQJAAkACQAJ/IAAtAFwEQCABIAMQkQMhAQsgAUULBEBBBBAOIQBByLIFQQA2AgBBLUEsEA0hBEHIsgUoAgAhAUHIsgVBADYCAAJAAkACQCABQQFHBEBByLIFQQA2AgBBLUEgEA0hAUHIsgUoAgAhA0HIsgVBADYCACADQQFGDQEgAiABNgIQIAJCm4CAgICEgICAfzcCFCABQQA6ABsgAUHDnQIoAAA2ABcgAUG8nQIpAAA3ABAgAUG0nQIpAAA3AAggAUGsnQIpAAA3AABByLIFQQA2AgBBMiAEIAJBEGpB8pUCQc4IQcidAhAQGkHIsgUoAgAhAUHIsgVBADYCAEEBIQMgAUEBRwRAIAAgBDYCAEHIsgVBADYCAEExIABBoNoAQQAQEkHIsgUoAgAhAUHIsgVBADYCAEEAIQMgAUEBRw0GCxAGIQEQBxogAiwAG0F/TARAIAIoAhAQ9gwLIAMNAgwHCxAGIQEQBxoMAgsQBiEBEAcaCyAEEPYMCyAAEBMMAwsgAkEANgIMIAFB2Z0CIAJBDGpBABCTAxogAigCDCIDRQRAQQQQDiEAQciyBUEANgIAQS1BLBANIQRByLIFKAIAIQFByLIFQQA2AgACQAJAAkAgAUEBRwRAQciyBUEANgIAQS1BMBANIQFByLIFKAIAIQNByLIFQQA2AgAgA0EBRg0BIAIgATYCECACQqCAgICAhoCAgH83AhQgAUEAOgAgIAFBgZ4CKQAANwAYIAFB+Z0CKQAANwAQIAFB8Z0CKQAANwAIIAFB6Z0CKQAANwAAQciyBUEANgIAQTIgBCACQRBqQfKVAkHTCEHInQIQEBpByLIFKAIAIQFByLIFQQA2AgBBASEDIAFBAUcEQCAAIAQ2AgBBACEDQciyBUEANgIAQTEgAEGg2gBBABASQciyBSgCACEBQciyBUEANgIAIAFBAUcNBgsQBiEBEAcaIAIsABtBf0wEQCACKAIQEPYMCyADRQ0HDAILEAYhARAHGgwCCxAGIQEQBxoLIAQQ9gwLIAAQEyABEAgACyADQRBqQQAQsQEiAyADKAIAQQFqNgIAIAAgAUGKngIgASgCYBDeAyEBDAELAAsgASABEKADQQFyEKEDIAJBIGokAA8LIAEQCAALngYBBX8jAEGgAWsiAiQAAkACQAJAAkAgAUUNACAAKAIYRQ0AIABBGGohA0EAIQADQCADIAAQsQEoAgAgAUYNAiAAQQFqIgAgAygCAEkNAAsLIAJB6D42AlAgAkHUPjYCGEHIsgVBADYCAEEpIAJB0ABqIgMgAkEYakEEciIEEAVByLIFKAIAIQBByLIFQQA2AgAgAEEBRg0BIAJCgICAgHA3A5gBIAJBsD42AlAgAkGcPjYCGEHIsgVBADYCAEEqIAQQDSEGQciyBSgCACEAQciyBUEANgIAIABBAUYEQBAGIQAQBxoMAwsgAkIANwI8IAJCADcCRCACQRA2AkwgAkHMPzYCHEHIsgVBADYCAEErIAJBGGpBqaYCQQkQFCEFQciyBSgCACEAQciyBUEANgIAAkACQAJAAkACQAJAAkAgAEEBRg0AQciyBUEANgIAQSwgBSABEBUhAUHIsgUoAgAhAEHIsgVBADYCACAAQQFGDQBByLIFQQA2AgBBKyABQbOmAkEOEBQaQciyBSgCACEAQciyBUEANgIAIABBAUYNAEEEEA4hAUHIsgVBADYCAEEtQSwQDSEFQciyBSgCACEAQciyBUEANgIAIABBAUYNAUHIsgVBADYCAEEuIAJBCGogBBAFQciyBSgCACEAQciyBUEANgIAQQEhBCAAQQFGDQJByLIFQQA2AgBBMiAFIAJBCGpB8pUCQYsXQdGmAhAQGkHIsgUoAgAhAEHIsgVBADYCACAAQQFGDQMgASAFNgIAQQAhBEHIsgVBADYCAEExIAFBoNoAQQAQEkHIsgUoAgAhAEHIsgVBADYCACAAQQFGDQMACxAGIQAQBxoMBQsQBiEAEAcaDAMLEAYhABAHGgwBCxAGIQAQBxogAiwAE0F/TARAIAIoAggQ9gwLIARFDQILIAUQ9gwLIAEQEwsgAkGwPjYCUCACQZw+NgIYIAJBzD82AhwgAiwAR0F/TARAIAIoAjwQ9gwLIAYQ4AYaIAMQ3AYgABAIAAsgAkGgAWokACAAQf//A3EPCxAGIQAQBxoLIAMQ3AYgABAIAAvTAQEBfyMAQaAIayIDJAAgA0EANgIcIANBADYCGCADIAE2AhAgA0H9nAI2AhQgA0EgakGACEH3nAIgA0EQahCVBhogACgCFCADQSBqIANBHGpBABCTAxogA0GInQI2AgQgAyABNgIAIANBIGpBgAhB95wCIAMQlQYaIAAoAhQgA0EgaiADQRhqQQAQkwMaAkAgAygCHEUNACADKAIYIgBFDQAgAEEQaiACIAAoAhAQ4gMgAygCHEEQakEAELEBIgAgACgCAEEBajYCAAsgA0GgCGokAAujAQEBfyMAQSBrIgQkACAAIAEQ7QMhAQJAAkAgAgRAIAItAAANAQsgBCABNgIAIABB3ABqQYAIQZiXAiAEEJUGGgwBCyAEIAI2AhQgBCABNgIQIABB3ABqQYAIQe+mAiAEQRBqEJUGGgsgAEHylQJBrQZB7poCEOEDIAAgAEHcAGogBEEcaiAEQRhqEOgDIAQoAhwgAyAEKAIYELsCIARBIGokAAu3AwECfyMAQUBqIgUkACAAIAEQ6QMhASAAKAIwIgYEQCAAIAYQ7QMhBiAFQe2cAjYCNCAFIAY2AjAgAEHcAGoiBkGACEHvpgIgBUEwahCVBhogACAGIAEQ7gMLIAAgAUGinwIgA7MQ7wMgACABQa2fAiAEsxDvAyAAIAEQ7QMhAyAFQbyeAjYCJCAFIAM2AiAgAEHcAGoiA0GACEHvpgIgBUEgahCVBhogACgCFCEEIAAgAC0AXAR/IAQgAxCRAwUgBAtBuZ8CQQAQ3gMaIAAgARDtAyEEIAVBxp4CNgIUIAUgBDYCECADQYAIQe+mAiAFQRBqEJUGGiAAKAIUIQQgAAJ/IAAtAFwEQCAEIAMQkQMhBAsgBAtBw58CIAQoAmAQ3gMaIAAgARDtAyEEIAVB2p4CNgIEIAUgBDYCACADQYAIQe+mAiAFEJUGGiAAIAMgBUE8akEAENsDIAUoAjxBEGpBABCxASIDIAMoAgBBAWo2AgAgACABQf6eAiACEOsDIABBJGogACABEOcDENgDKAIAIgAoAqwBQRBqQQAQsQEoAgBFBEAgACACNwMwCyAFQUBrJAAgAQtlACAAIAAgASACIAMgBBDwAyIBQcifAiADrRDrAyAAIAFB558CIAStEOsDIAAgAUGHoAIgBa0Q6wMgACABQbqgAiAGrRDrAyAAIAFB7qACIAetEOsDIAAgAUGfoQIgCK0Q6wMgAQuuBAEDfyMAQUBqIgQkAAJAAkACQAJ/IAAgARDzAyIFQcOfAhCFBkUEQCAAIAEQ7QMhASAEQe6hAjYCFCAEIAE2AhAgAEHcAGoiAUGACEHvpgIgBEEQahCVBhogACgCFCIFIAAtAFxFDQEaIAUgARCRAwwBCyAFQb6fAhCFBg0DIAAgARDtAyEBIARB0KECNgIkIAQgATYCICAAQdwAaiIBQYAIQe+mAiAEQSBqEJUGGiAAKAIUIgUgAC0AXEUNABogBSABEJEDCyIFQYyiAiAEQTxqQQAQkwNFDQAgBUGsogIgBEE4akEAEJMDRQ0AQQAhASAFQdyiAiAEQTRqQQAQkwMNAQsgABDZAyIBKAIAIQAgASwACyEDIARBtqMCNgIAIAQgACABIANBAEgbNgIEQcCMBEGNowIgBBC6AQwBCyAEKAI8QRBqQQAQqQEoAgAiBgRAA0AgAyAEKAI4QRBqIAEQqgEvAQBGBEAgBCgCNCIFQRhqIgAgARCxASgCABDjASAFQSRqIAEQsAEoAgAgACABELEBKAIAEIANIQUgACABELEBGiAFIAIgAxCCBiEAIAUQ9gwgAEUNAwsgAUEBaiIBIAZHDQALCyAEKAI4IgFBEGogAyABKAIQEK8BIAQoAjQiASABIAEoAgAoAgwRAAAiAEEBaiABKAIAKAIQEQIAIAEgAiADIAAQvwQgBCgCPEEQakEAEKkBIgEgASkDAEIBfDcDAAsgBEFAayQAC8YBAQN/IwBBIGsiAyQAIAAgARDtAyECIANBxp4CNgIUIAMgAjYCECAAQdwAaiIEQYAIQe+mAiADQRBqEJUGGiAAKAIUIQICfwJ/IAAtAFwEQCACIAQQkQMhAgsgAigCYEEBRwsEQCAAENkDIgIoAgAhBCACLAALIQAgAyABNgIIIANB8acCNgIAIAMgBCACIABBAEgbNgIEQcCMBEG6pwIgAxC6AUEADAELIAJB4ABqQQAQkQEoAgBBKGoLIQAgA0EgaiQAIAALsQcBBH8jAEHQAGsiBCQAIAAgARDtAyEBIARB7qECNgI0IAQgATYCMCAAQdwAaiIFQYAIQe+mAiAEQTBqEJUGGiAAKAIUIQECQAJAAkACfyAALQBcBEAgASAFEJEDIQELIAELQdKjAiAEQcwAakEAEJMDRQ0AIAFB8aMCIARByABqQQAQkwNFDQAgAUGfpAIgBEHEAGpBABCTAw0BCyAAENkDIgEoAgAhACABLAALIQMgBEGFpQI2AiAgBCAAIAEgA0EASBs2AiRBwIwEQc6kAiAEQSBqELoBDAELIAQoAkwiBUUEQEEEEA4hAUHIsgVBADYCAEEtQSwQDSEDQciyBSgCACEAQciyBUEANgIAAkACQAJAAkACQCAAQQFHBEBByLIFQQA2AgBBLUEgEA0hAEHIsgUoAgAhBUHIsgVBADYCACAFQQFGDQEgBCAANgI4IARCmICAgICEgICAfzcCPCAAQQA6ABggAEGwpQIpAAA3ABAgAEGopQIpAAA3AAggAEGgpQIpAAA3AABByLIFQQA2AgBBMiADIARBOGpB8pUCQb8PQYWlAhAQGkHIsgUoAgAhAEHIsgVBADYCAEEBIQUgAEEBRg0CIAEgAzYCAEHIsgVBADYCAEExIAFBoNoAQQAQEkHIsgUoAgAhAEHIsgVBADYCAEEAIQUgAEEBRg0CAAsQBiEAEAcaDAMLEAYhABAHGgwBCxAGIQAQBxogBCwAQ0F/TARAIAQoAjgQ9gwLIAVFDQILIAMQ9gwLIAEQEwsgABAIAAtBACEBIAVBEGpBABCoAS0AACIHBEADQCADIAQoAkhBEGogARCqAS8BAEYEQCAEKAJEIgZBGGoiBSABELEBKAIAEOMBIAZBJGogARCwASgCACAFIAEQsQEoAgAQgA0hBiAFIAEQsQEaIAYgAiADEIIGRQRAIAAQ2QMiACgCACEDIAAsAAshBSAEIAE2AhQgBCADIAAgBUEASBs2AhBBuaUCIARBEGoQvQEgBhD2DAwECyAGEPYMCyABQQFqIgEgB0cNAAsLIAQoAkgiAUEQaiADIAEoAhAQrwEgBCgCRCIBIAEgASgCACgCDBEAACIFQQFqIAEoAgAoAhARAgAgASACIAMgBRC/BCAEKAJMQRBqQQAQqAEiASABLQAAQQFqOgAAIAAQ2QMiASgCACEAIAEsAAshAyAEIAQoAkxBEGpBABCoAS0AADYCBCAEIAAgASADQQBIGzYCAEHSpQIgBBC9AQsgBEHQAGokAAs+ACAAQfKVAkHeF0HjpgIQ4QMgAEEkaiAAIAEQ5wMQ2AMoAgAgAiADIAQgBSAGEJoFIAAoAjgQrAVBABCjBAv/AwEEfyMAQRBrIgUkACAAKAIAIgMgAkkEQEEEEA4hAEHIsgVBADYCAEEtQTAQDSECQciyBSgCACEDQciyBUEANgIAAkACQAJAAkACQCADQQFHBEBByLIFQQA2AgBBLUEgEA0hA0HIsgUoAgAhBEHIsgVBADYCACAEQQFGDQEgBSADNgIAIAVCk4CAgICEgICAfzcCBCADQQA6ABMgA0HfqAIoAAA2AA8gA0HYqAIpAAA3AAggA0HQqAIpAAA3AABByLIFQQA2AgBBMCACIAVBxABB66gCQYQBQeSoAhAWGkHIsgUoAgAhA0HIsgVBADYCAEEBIQQgA0EBRg0CIAAgAjYCAEHIsgVBADYCAEExIABBrN0AQQAQEkHIsgUoAgAhA0HIsgVBADYCAEEAIQQgA0EBRg0CAAsQBiEDEAcaDAMLEAYhAxAHGgwBCxAGIQMQBxogBSwAC0F/TARAIAUoAgAQ9gwLIARFDQILIAIQ9gwLIAAQEwsgAxAIAAsCQCAAKAIEIANHBEAgACgCCCEEDAELIAAgA0EBIANBAUsbIgNBAXQ2AgQgACAAKAIIIANBBHQQ6gEiBDYCCCAAKAIAIQMLIAQgAkEDdCIGaiIEQQhqIAQgAyACa0EDdBCCDSAAKAIIIAZqIAE3AwAgACAAKAIAQQFqNgIAIAVBEGokAAv4AgEDfyMAQRBrIgIkACABRQRAQQQQDiEBQciyBUEANgIAQS1BLBANIQRByLIFKAIAIQBByLIFQQA2AgACQAJAAkACQAJAIABBAUcEQEHIsgVBADYCAEEtQRAQDSEAQciyBSgCACEDQciyBUEANgIAIANBAUYNASACIAA2AgAgAkKNgICAgIKAgIB/NwIEIABBADoADSAAQYWnAikAADcABSAAQYCnAikAADcAAEHIsgVBADYCAEEyIAQgAkHylQJBzhlBjqcCEBAaQciyBSgCACEAQciyBUEANgIAQQEhAyAAQQFHBEAgASAENgIAQciyBUEANgIAQTEgAUGg2gBBABASQciyBSgCACEAQciyBUEANgIAQQAhAyAAQQFHDQYLEAYhABAHGiACLAALQX9MBEAgAigCABD2DAsgAw0CDAQLEAYhABAHGgwCCxAGIQAQBxoLIAQQ9gwLIAEQEwsgABAICwALIAAoAjwgAUEAENcBIAJBEGokAAu2BQEEfyMAQaABayIEJAACQAJAIABBEGoiBigCACIARQ0AIAYhBQNAIAUgACAAKAIQIAFIIgcbIQUgACAHQQJ0aigCACIADQALIAUgBkYNACAFKAIQIAFKDQAgAiAFKAIUIgBBEGogAEEEaiADGxCKDAwBCyAEQeg+NgJQIARB1D42AhhByLIFQQA2AgBBKSAEQdAAaiIFIARBGGpBBHIiABAFQciyBSgCACEHQciyBUEANgIAAkAgB0EBRwRAIARCgICAgHA3A5gBIARBsD42AlAgBEGcPjYCGEHIsgVBADYCAEEqIAAQDSEHQciyBSgCACEGQciyBUEANgIAIAZBAUYEQBAGIQAQBxoMAgsgBEIANwI8IARCADcCRCAEQRA2AkwgBEHMPzYCHEHIsgVBADYCAEErIARBGGpBjqkCQQoQFCEGQciyBSgCACEDQciyBUEANgIAAkACQAJAIANBAUYNAEHIsgVBADYCAEEzIAYgARAVIQFByLIFKAIAIQZByLIFQQA2AgAgBkEBRg0AQciyBUEANgIAQSsgAUGZqQJBARAUGkHIsgUoAgAhAUHIsgVBADYCACABQQFGDQBByLIFQQA2AgBBLiAEQQhqIAAQBUHIsgUoAgAhAEHIsgVBADYCACAAQQFGDQEgAiwAC0F/TARAIAIoAgAQ9gwLIAIgBCkDCDcCACACIAQoAhA2AgggBEGwPjYCUCAEQZw+NgIYIARBzD82AhwgBCwAR0F/TARAIAQoAjwQ9gwLIAcQ4AYaIAUQ3AYMBQsQBiEAEAcaDAELEAYhABAHGgsgBEGwPjYCUCAEQZw+NgIYIARBzD82AhwgBCwAR0F/TARAIAQoAjwQ9gwLIAcQ4AYaIAUQ3AYgABAIAAsQBiEAEAcaCyAFENwGIAAQCAALIARBoAFqJAAgAgv9BgENfyMAQZABayIIJAAgCCABEPoDIQVByLIFQQA2AgBBogMgBSAIQYwBahAVGkHIsgUoAgAhAkHIsgVBADYCAAJAIAJBAUcEQAJ/AkAgCCAFKAIAQXRqKAIAaigCEEECRw0AIABBEGoiBygCACICRQ0AIAgoAowBIQYgByEDA0AgAyACIAIoAhAgBkgiBBshAyACIARBAnRqKAIAIgINAAsgAyAHRg0AIAYgAygCEEgNACADKAIUKAIADAELIABBBGohCQJAIAAoAgQiAkUNACAAQQhqIQcgCSEEAkACQANAQciyBUEANgIAIAcgAkEQaiABEMgFIQNByLIFKAIAIQZByLIFQQA2AgAgBkEBRg0BIAQgAiADGyEEIAJBBEEAIAMbaigCACICDQALIAQgCUYNAkHIsgVBADYCACAHIAEgBEEQahDIBSECQciyBSgCACEDQciyBUEANgIAIANBAUYNASACDQIgBCgCHCgCAAwDCxAGIQQQBxoMBAsQBiEEEAcaDAMLQQAgCSAAKAIAIgNGDQAaIAEoAgQgAS0ACyICIAJBGHRBGHVBAEgiAhshBiABKAIAIAEgAhshAANAAn8gAyIBKAIcIgosAA8iAkF/TARAIAooAgghAiAKKAIEDAELIAJB/wFxIQIgCkEEagshCwJAIAYEQCACIAZIDQEgAiALaiEMIAAtAAAhByALIQMDQCACIAZrIgJBAWoiBCACSQ0CIAMgByAEEIQGIgJFDQIgAiAAIAYQggYEQCAMIAJBAWoiA2siAiAGTg0BDAMLCyACIAxGDQEgAiALRw0BCyANQQFqIQ0gCigCACEOCwJAIAEoAgQiAkUEQCABKAIIIgMoAgAgAUYNASABQQhqIQQDQCAEKAIAIgJBCGohBCACIAIoAggiAygCAEcNAAsMAQsDQCACIgMoAgAiAg0ACwsgAyAJRw0ACyAOQQAgDUEBRhsLIQQgBUG8qQI2AjwgBUGoqQI2AgAgBUHMPzYCCCAFQQhqIQIgBUE8aiEDIAUsADNBf0wEQCAFKAIoEPYMCyACEOAGGiADENwGIAhBkAFqJAAgBA8LEAYhBBAHGgsgBUG8qQI2AjwgBUGoqQI2AgAgBUHMPzYCCCAFQQhqIQIgBUE8aiEDIAUsADNBf0wEQCAFKAIoEPYMCyACEOAGGiADENwGIAQQCAALrQIBBH8gAEH0qQI2AjwgAEHgqQI2AgAgAEEANgIEQciyBUEANgIAQSkgAEE8aiIEIABBCGoiAhAFQciyBSgCACEDQciyBUEANgIAAkACQCADQQFHBEAgAEG8qQI2AjwgAEGoqQI2AgAgAEKAgICAcDcChAFByLIFQQA2AgBBKiACEA0hBUHIsgUoAgAhA0HIsgVBADYCACADQQFGDQEgAEHMPzYCCCAAQShqIgNCADcCACAAQgA3AjAgAEEINgI4QciyBUEANgIAQfgAIAIgARAFQciyBSgCACECQciyBUEANgIAIAJBAUYEQBAGIQIQBxogAywAC0F/TARAIAMoAgAQ9gwLIAUQ4AYaDAMLIAAPCxAGIQIQBxoMAQsQBiECEAcaCyAEENwGIAIQCAALVQEBfyMAQRBrIgIkACAAQfKVAkGIBkHJmgIQ4QMgAkEANgIMIAJBADYCCCAAQZunAiACQQxqIAJBCGoQ2wMgAigCDCABrSACKAIIEKMEIAJBEGokAAtCACAAQbypAjYCPCAAQaipAjYCACAAQcw/NgIIIAAsADNBf0wEQCAAKAIoEPYMCyAAQQhqEOAGGiAAQTxqENwGIAALRQAgAEG8qQI2AjwgAEGoqQI2AgAgAEHMPzYCCCAALAAzQX9MBEAgACgCKBD2DAsgAEEIahDgBhogAEE8ahDcBiAAEPYMC1AAIAAgACgCAEF0aigCAGoiAEG8qQI2AjwgAEGoqQI2AgAgAEHMPzYCCCAALAAzQX9MBEAgACgCKBD2DAsgAEEIahDgBhogAEE8ahDcBiAAC1MAIAAgACgCAEF0aigCAGoiAEG8qQI2AjwgAEGoqQI2AgAgAEHMPzYCCCAALAAzQX9MBEAgACgCKBD2DAsgAEEIahDgBhogAEE8ahDcBiAAEPYMC1EBAX9BzIIFIQADQCAAQX9qLAAAQX9MBEAgAEF0aigCABD2DAsgAEFzaiwAAEF/TARAIABBaGooAgAQ9gwLIABBZGoiASEAIAFBgP4ERw0ACwtRAQF/QdCeBSEAA0AgAEF/aiwAAEF/TARAIABBdGooAgAQ9gwLIABBc2osAABBf0wEQCAAQWhqKAIAEPYMCyAAQWRqIgEhACABQdCCBUcNAAsLUQEBf0HMoAUhAANAIABBf2osAABBf0wEQCAAQXRqKAIAEPYMCyAAQXNqLAAAQX9MBEAgAEFoaigCABD2DAsgAEFkaiIBIQAgAUHQngVHDQALC4wBAEGjoQUsAABBf0wEQEGYoQUoAgAQ9gwLQZehBSwAAEF/TARAQYyhBSgCABD2DAtBh6EFLAAAQX9MBEBB/KAFKAIAEPYMC0H7oAUsAABBf0wEQEHwoAUoAgAQ9gwLQeugBSwAAEF/TARAQeCgBSgCABD2DAtB36AFLAAAQX9MBEBB1KAFKAIAEPYMCwtRAQF/QbSmBSEAA0AgAEF/aiwAAEF/TARAIABBdGooAgAQ9gwLIABBc2osAABBf0wEQCAAQWhqKAIAEPYMCyAAQWRqIgEhACABQbChBUcNAAsLugEAQa+nBSwAAEF/TARAQaSnBSgCABD2DAtBo6cFLAAAQX9MBEBBmKcFKAIAEPYMC0GTpwUsAABBf0wEQEGIpwUoAgAQ9gwLQYenBSwAAEF/TARAQfymBSgCABD2DAtB96YFLAAAQX9MBEBB7KYFKAIAEPYMC0HrpgUsAABBf0wEQEHgpgUoAgAQ9gwLQdumBSwAAEF/TARAQdCmBSgCABD2DAtBz6YFLAAAQX9MBEBBxKYFKAIAEPYMCwv4BAEJfyMAQSBrIgMkAEG0pwVCADcCAEHApwVCADcCAEGwpwVBtKcFNgIAQcynBUG8pwU2AgBBvKcFQcCnBTYCAEHIpwVBsKcFNgIAAkACQEGA/gQoAgBB/wFHBEBBgP4EIQRBgP4EIQYDQEHIsgVBADYCAEGWAyADQQhqIARBBGoQFSEAQciyBSgCACECQciyBUEANgIAAkACQCACQQFHBEAgAyAGNgIUQciyBUEANgIAQawDIANBGGpBsKcFIAAgA0EIahAcQciyBSgCACEAQciyBUEANgIAIABBAUYNASADLAATQX9MBEAgAygCCBD2DAsgBCgCACEHQcCnBSgCACIFIQBBwKcFIQIgBUUEQEHApwUiACECDAMLA0ACQCAHIAAoAhAiAUgEQCAAKAIAIgENASAAIQIMBQsgASAHTg0EIABBBGohAiAAKAIEIgFFDQQgAiEACyAAIQIgASEADAAACwALEAYhABAHGkHApwUoAgAhBQwFCxAGIQAQBxogAywAE0F/TARAIAMoAggQ9gwLQcCnBSgCACEFDAQLIAIoAgBFBEBByLIFQQA2AgBBLUEYEA0hAUHIsgUoAgAhCEHIsgVBADYCACAIQQFGDQMgASAANgIIIAFCADcCACABIAetIAatQiCGhDcCECACIAE2AgBBvKcFKAIAKAIAIgAEQEG8pwUgADYCACACKAIAIQELQcCnBSgCACABENIDQcSnBUHEpwUoAgBBAWo2AgALIAQoAhwhACAEQRxqIgYhBCAAQf8BRw0ACwsgA0EgaiQADwsQBiEAEAcaC0G8pwUgBRCHBEGwpwVBtKcFKAIAEIgEIAAQCAALIAAgAQRAIAAgASgCABCHBCAAIAEoAgQQhwQgARD2DAsLMwAgAQRAIAAgASgCABCIBCAAIAEoAgQQiAQgASwAG0F/TARAIAEoAhAQ9gwLIAEQ9gwLCx4AQbynBUHApwUoAgAQhwRBsKcFQbSnBSgCABCIBAvwBAEJfyMAQSBrIgMkAEHUpwVCADcCAEHgpwVCADcCAEHQpwVB1KcFNgIAQeynBUHcpwU2AgBB3KcFQeCnBTYCAEHopwVB0KcFNgIAAkACQEHQggUoAgAEQEHQggUhBEHQggUhBgNAQciyBUEANgIAQZYDIANBCGogBEEEahAVIQBByLIFKAIAIQJByLIFQQA2AgACQAJAIAJBAUcEQCADIAY2AhRByLIFQQA2AgBBrQMgA0EYakHQpwUgACADQQhqEBxByLIFKAIAIQBByLIFQQA2AgAgAEEBRg0BIAMsABNBf0wEQCADKAIIEPYMCyAEKAIAIQdB4KcFKAIAIgUhAEHgpwUhAiAFRQRAQeCnBSIAIQIMAwsDQAJAIAcgACgCECIBSARAIAAoAgAiAQ0BIAAhAgwFCyABIAdODQQgAEEEaiECIAAoAgQiAUUNBCACIQALIAAhAiABIQAMAAALAAsQBiEAEAcaQeCnBSgCACEFDAULEAYhABAHGiADLAATQX9MBEAgAygCCBD2DAtB4KcFKAIAIQUMBAsgAigCAEUEQEHIsgVBADYCAEEtQRgQDSEBQciyBSgCACEIQciyBUEANgIAIAhBAUYNAyABIAA2AgggAUIANwIAIAEgB60gBq1CIIaENwIQIAIgATYCAEHcpwUoAgAoAgAiAARAQdynBSAANgIAIAIoAgAhAQtB4KcFKAIAIAEQ0gNB5KcFQeSnBSgCAEEBajYCAAsgBCgCHCEAIARBHGoiBiEEIAANAAsLIANBIGokAA8LEAYhABAHGgtB3KcFIAUQiwRB0KcFQdSnBSgCABCMBCAAEAgACyAAIAEEQCAAIAEoAgAQiwQgACABKAIEEIsEIAEQ9gwLCzMAIAEEQCAAIAEoAgAQjAQgACABKAIEEIwEIAEsABtBf0wEQCABKAIQEPYMCyABEPYMCwseAEHcpwVB4KcFKAIAEIsEQdCnBUHUpwUoAgAQjAQL+AQBCX8jAEEgayIDJABB9KcFQgA3AgBBgKgFQgA3AgBB8KcFQfSnBTYCAEGMqAVB/KcFNgIAQfynBUGAqAU2AgBBiKgFQfCnBTYCAAJAAkBB0J4FKAIAQf8BRwRAQdCeBSEEQdCeBSEGA0BByLIFQQA2AgBBlgMgA0EIaiAEQQRqEBUhAEHIsgUoAgAhAkHIsgVBADYCAAJAAkAgAkEBRwRAIAMgBjYCFEHIsgVBADYCAEGuAyADQRhqQfCnBSAAIANBCGoQHEHIsgUoAgAhAEHIsgVBADYCACAAQQFGDQEgAywAE0F/TARAIAMoAggQ9gwLIAQoAgAhB0GAqAUoAgAiBSEAQYCoBSECIAVFBEBBgKgFIgAhAgwDCwNAAkAgByAAKAIQIgFIBEAgACgCACIBDQEgACECDAULIAEgB04NBCAAQQRqIQIgACgCBCIBRQ0EIAIhAAsgACECIAEhAAwAAAsACxAGIQAQBxpBgKgFKAIAIQUMBQsQBiEAEAcaIAMsABNBf0wEQCADKAIIEPYMC0GAqAUoAgAhBQwECyACKAIARQRAQciyBUEANgIAQS1BGBANIQFByLIFKAIAIQhByLIFQQA2AgAgCEEBRg0DIAEgADYCCCABQgA3AgAgASAHrSAGrUIghoQ3AhAgAiABNgIAQfynBSgCACgCACIABEBB/KcFIAA2AgAgAigCACEBC0GAqAUoAgAgARDSA0GEqAVBhKgFKAIAQQFqNgIACyAEKAIcIQAgBEEcaiIGIQQgAEH/AUcNAAsLIANBIGokAA8LEAYhABAHGgtB/KcFIAUQjwRB8KcFQfSnBSgCABCQBCAAEAgACyAAIAEEQCAAIAEoAgAQjwQgACABKAIEEI8EIAEQ9gwLCzMAIAEEQCAAIAEoAgAQkAQgACABKAIEEJAEIAEsABtBf0wEQCABKAIQEPYMCyABEPYMCwseAEH8pwVBgKgFKAIAEI8EQfCnBUH0pwUoAgAQkAQL+AQBCX8jAEEgayIDJABBlKgFQgA3AgBBoKgFQgA3AgBBkKgFQZSoBTYCAEGsqAVBnKgFNgIAQZyoBUGgqAU2AgBBqKgFQZCoBTYCAAJAAkBB0KAFKAIAQf8BRwRAQdCgBSEEQdCgBSEGA0BByLIFQQA2AgBBlgMgA0EIaiAEQQRqEBUhAEHIsgUoAgAhAkHIsgVBADYCAAJAAkAgAkEBRwRAIAMgBjYCFEHIsgVBADYCAEGvAyADQRhqQZCoBSAAIANBCGoQHEHIsgUoAgAhAEHIsgVBADYCACAAQQFGDQEgAywAE0F/TARAIAMoAggQ9gwLIAQoAgAhB0GgqAUoAgAiBSEAQaCoBSECIAVFBEBBoKgFIgAhAgwDCwNAAkAgByAAKAIQIgFIBEAgACgCACIBDQEgACECDAULIAEgB04NBCAAQQRqIQIgACgCBCIBRQ0EIAIhAAsgACECIAEhAAwAAAsACxAGIQAQBxpBoKgFKAIAIQUMBQsQBiEAEAcaIAMsABNBf0wEQCADKAIIEPYMC0GgqAUoAgAhBQwECyACKAIARQRAQciyBUEANgIAQS1BGBANIQFByLIFKAIAIQhByLIFQQA2AgAgCEEBRg0DIAEgADYCCCABQgA3AgAgASAHrSAGrUIghoQ3AhAgAiABNgIAQZyoBSgCACgCACIABEBBnKgFIAA2AgAgAigCACEBC0GgqAUoAgAgARDSA0GkqAVBpKgFKAIAQQFqNgIACyAEKAIcIQAgBEEcaiIGIQQgAEH/AUcNAAsLIANBIGokAA8LEAYhABAHGgtBnKgFIAUQkwRBkKgFQZSoBSgCABCUBCAAEAgACyAAIAEEQCAAIAEoAgAQkwQgACABKAIEEJMEIAEQ9gwLCzMAIAEEQCAAIAEoAgAQlAQgACABKAIEEJQEIAEsABtBf0wEQCABKAIQEPYMCyABEPYMCwseAEGcqAVBoKgFKAIAEJMEQZCoBUGUqAUoAgAQlAQL8AQBCX8jAEEgayIDJABBtKgFQgA3AgBBwKgFQgA3AgBBsKgFQbSoBTYCAEHMqAVBvKgFNgIAQbyoBUHAqAU2AgBByKgFQbCoBTYCAAJAAkBBsKEFKAIABEBBsKEFIQRBsKEFIQYDQEHIsgVBADYCAEGWAyADQQhqIARBBGoQFSEAQciyBSgCACECQciyBUEANgIAAkACQCACQQFHBEAgAyAGNgIUQciyBUEANgIAQbADIANBGGpBsKgFIAAgA0EIahAcQciyBSgCACEAQciyBUEANgIAIABBAUYNASADLAATQX9MBEAgAygCCBD2DAsgBCgCACEHQcCoBSgCACIFIQBBwKgFIQIgBUUEQEHAqAUiACECDAMLA0ACQCAHIAAoAhAiAUgEQCAAKAIAIgENASAAIQIMBQsgASAHTg0EIABBBGohAiAAKAIEIgFFDQQgAiEACyAAIQIgASEADAAACwALEAYhABAHGkHAqAUoAgAhBQwFCxAGIQAQBxogAywAE0F/TARAIAMoAggQ9gwLQcCoBSgCACEFDAQLIAIoAgBFBEBByLIFQQA2AgBBLUEYEA0hAUHIsgUoAgAhCEHIsgVBADYCACAIQQFGDQMgASAANgIIIAFCADcCACABIAetIAatQiCGhDcCECACIAE2AgBBvKgFKAIAKAIAIgAEQEG8qAUgADYCACACKAIAIQELQcCoBSgCACABENIDQcSoBUHEqAUoAgBBAWo2AgALIAQoAhwhACAEQRxqIgYhBCAADQALCyADQSBqJAAPCxAGIQAQBxoLQbyoBSAFEJcEQbCoBUG0qAUoAgAQmAQgABAIAAsgACABBEAgACABKAIAEJcEIAAgASgCBBCXBCABEPYMCwszACABBEAgACABKAIAEJgEIAAgASgCBBCYBCABLAAbQX9MBEAgASgCEBD2DAsgARD2DAsLHgBBvKgFQcCoBSgCABCXBEGwqAVBtKgFKAIAEJgEC/gEAQl/IwBBIGsiAyQAQdSoBUIANwIAQeCoBUIANwIAQdCoBUHUqAU2AgBB7KgFQdyoBTYCAEHcqAVB4KgFNgIAQeioBUHQqAU2AgACQAJAQcCmBSgCAEH/AUcEQEHApgUhBEHApgUhBgNAQciyBUEANgIAQZYDIANBCGogBEEEahAVIQBByLIFKAIAIQJByLIFQQA2AgACQAJAIAJBAUcEQCADIAY2AhRByLIFQQA2AgBBsQMgA0EYakHQqAUgACADQQhqEBxByLIFKAIAIQBByLIFQQA2AgAgAEEBRg0BIAMsABNBf0wEQCADKAIIEPYMCyAEKAIAIQdB4KgFKAIAIgUhAEHgqAUhAiAFRQRAQeCoBSIAIQIMAwsDQAJAIAcgACgCECIBSARAIAAoAgAiAQ0BIAAhAgwFCyABIAdODQQgAEEEaiECIAAoAgQiAUUNBCACIQALIAAhAiABIQAMAAALAAsQBiEAEAcaQeCoBSgCACEFDAULEAYhABAHGiADLAATQX9MBEAgAygCCBD2DAtB4KgFKAIAIQUMBAsgAigCAEUEQEHIsgVBADYCAEEtQRgQDSEBQciyBSgCACEIQciyBUEANgIAIAhBAUYNAyABIAA2AgggAUIANwIAIAEgB60gBq1CIIaENwIQIAIgATYCAEHcqAUoAgAoAgAiAARAQdyoBSAANgIAIAIoAgAhAQtB4KgFKAIAIAEQ0gNB5KgFQeSoBSgCAEEBajYCAAsgBCgCHCEAIARBHGoiBiEEIABB/wFHDQALCyADQSBqJAAPCxAGIQAQBxoLQdyoBSAFEJsEQdCoBUHUqAUoAgAQnAQgABAIAAsgACABBEAgACABKAIAEJsEIAAgASgCBBCbBCABEPYMCwszACABBEAgACABKAIAEJwEIAAgASgCBBCcBCABLAAbQX9MBEAgASgCEBD2DAsgARD2DAsLHgBB3KgFQeCoBSgCABCbBEHQqAVB1KgFKAIAEJwEC4wBAEHPqQUsAABBf0wEQEHEqQUoAgAQ9gwLQb+pBSwAAEF/TARAQbSpBSgCABD2DAtBr6kFLAAAQX9MBEBBpKkFKAIAEPYMC0GfqQUsAABBf0wEQEGUqQUoAgAQ9gwLQY+pBSwAAEF/TARAQYSpBSgCABD2DAtB/6gFLAAAQX9MBEBB9KgFKAIAEPYMCwuipwEBA39Bj/4EQQg6AABBm/4EQQg6AABBhP4EQunaweOW7di09AA3AgBBq/4EQQQ6AABBkP4EQunaweOW7di09AA3AwBBt/4EQQU6AABBnP4EQoGAgIDQjp2zODcCAEHH/gRBBToAAEG4/gRBAjYCAEGs/gRB0KoCKAAANgIAQbD+BEHUqgItAAA6AABBgP4EQQA2AgBBjP4EQQA6AABBmP4EQQA6AABBpP4EQQA6AABBsf4EQQA6AABB0/4EQQY6AABB4/4EQQQ6AABB1P4EQoOAgICwztq08wA3AgBB7/4EQQU6AABBwP4EQdqqAi0AADoAAEG8/gRB1qoCKAAANgIAQcj+BEHcqgIoAAA2AgBBzP4EQeCqAi8AADsBAEHk/gRB46oCKAAANgIAQej+BEHnqgItAAA6AABBwf4EQQA6AABBzv4EQQA6AABB3P4EQQA6AABB//4EQQQ6AABB8P4EQQY2AgBB6f4EQQA6AABBi/8EQQQ6AABB9P4EQejoteMGNgIAQfj+BEEAOgAAQZv/BEEDOgAAQYz/BEEHNgIAQYD/BEHIqLXiBDYCAEGE/wRBADoAAEGS/wRB66oCLQAAOgAAQZD/BEHpqgIvAAA7AQBBp/8EQQM6AABBk/8EQQA6AABBnv8EQe+qAi0AADoAAEGc/wRB7aoCLwAAOwEAQbf/BEEEOgAAQaj/BEEINgIAQZ//BEEAOgAAQcP/BEEEOgAAQaz/BEH16qWjBjYCAEGw/wRBADoAAEHT/wRBBDoAAEHE/wRBCTYCAEG4/wRB1aqlogQ2AgBBvP8EQQA6AABB3/8EQQQ6AABByP8EQenmyZsGNgIAQcz/BEEAOgAAQe//BEEEOgAAQeD/BEEKNgIAQdT/BEHJpsmaBDYCAEHY/wRBADoAAEH7/wRBBDoAAEHk/wRB7dLNgQc2AgBB6P8EQQA6AABBi4AFQQM6AABB/P8EQQw2AgBB8P8EQc2SzYEFNgIAQfT/BEEAOgAAQYKABUHzqgItAAA6AABBgIAFQfGqAi8AADsBAEGXgAVBAzoAAEGDgAVBADoAAEGOgAVB96oCLQAAOgAAQYyABUH1qgIvAAA7AQBBp4AFQQQ6AABBmIAFQQ02AgBBj4AFQQA6AABBs4AFQQQ6AABBnIAFQerglbsGNgIAQaCABUEAOgAAQcOABUEDOgAAQbSABUEONgIAQaiABUHKoJW6BDYCAEGsgAVBADoAAEG6gAVB+6oCLQAAOgAAQbiABUH5qgIvAAA7AQBBz4AFQQM6AABBu4AFQQA6AABBxoAFQf+qAi0AADoAAEHEgAVB/aoCLwAAOwEAQd+ABUEDOgAAQdCABUEPNgIAQceABUEAOgAAQdaABUGDqwItAAA6AABB1IAFQYGrAi8AADsBAEHrgAVBAzoAAEHXgAVBADoAAEHigAVBh6sCLQAAOgAAQeCABUGFqwIvAAA7AQBB+4AFQQg6AABB7IAFQRA2AgBB44AFQQA6AABBh4EFQQg6AABB8IAFQuTqyYvGrtq37gA3AwBB+IAFQQA6AABBl4EFQQg6AABBiIEFQRE2AgBB/IAFQuTqyYvGrtq37gA3AgBBhIEFQQA6AABBo4EFQQk6AABBjIEFQuTC0avGrtq25QA3AgBBlIEFQQA6AABBoIEFQZGrAi0AADoAAEGYgQVBiasCKQAANwMAQbOBBUEGOgAAQaSBBUESNgIAQaGBBUEAOgAAQayBBUGXqwIvAAAiADsBAEGogQVBk6sCKAAAIgE2AgBBv4EFQQY6AABBroEFQQA6AABBuIEFIAA7AABBtIEFIAE2AgBBz4EFQQc6AABBwIEFQRU2AgBBuoEFQQA6AABBx4EFQZ2rAigAACIANgAAQcSBBUGaqwIoAAAiATYCAEHbgQVBBzoAAEHLgQVBADoAAEHTgQUgADYAAEHQgQUgATYCAEHrgQVBBjoAAEHcgQVBGDYCAEHXgQVBADoAAEHkgQVBpqsCLwAAOwEAQeCBBUGiqwIoAAA2AgBB94EFQQc6AABB5oEFQQA6AABB74EFQayrAigAADYAAEHsgQVBqasCKAAANgIAQYeCBUEDOgAAQfiBBUEZNgIAQfOBBUEAOgAAQf6BBUGzqwItAAA6AABB/IEFQbGrAi8AADsBAEGTggVBAzoAAEH/gQVBADoAAEGKggVBt6sCLQAAOgAAQYiCBUG1qwIvAAA7AQBBo4IFQQM6AABBlIIFQRs2AgBBi4IFQQA6AABBmoIFQburAi0AADoAAEGYggVBuasCLwAAOwEAQa+CBUEDOgAAQZuCBUEAOgAAQaaCBUG/qwItAAA6AABBpIIFQb2rAi8AADsBAEGwggVB/wE2AgBBp4IFQQA6AABBxIIFQgA3AgBBvIIFQgA3AgBBtIIFQgA3AgBB34IFQQU6AABB0IIFQQE2AgBB64IFQQU6AABB7IIFQQI2AgBB1IIFQcGrAigAADYCAEHYggVBxasCLQAAOgAAQeCCBUHHqwIoAAA2AgBB5IIFQcurAi0AADoAAEHZggVBADoAAEHlggVBADoAAEHIsgVBADYCAEEtQRAQDSEAQciyBSgCACEBQciyBUEANgIAAkACQAJAAkACQAJAAkACQAJAAkACQAJAAkACQAJAAkACQAJAAkACQAJAAkACQAJAAkACQAJ/QeyCBSABQQFGDQAaQfCCBSAANgIAQfSCBUKLgICAgIKAgIB/NwIAIABBADoACyAAQdSrAigAADYAByAAQc2rAikAADcAAEHIsgVBADYCAEEtQRAQDSEBQciyBSgCACECQciyBUEANgIAIAJBAUYNAUH8ggUgATYCAEGAgwVCjICAgICCgICAfzcDACABQQA6AAwgAUHhqwIoAAA2AAggAUHZqwIpAAA3AABBl4MFQQc6AABBiIMFQQM2AgBBo4MFQQc6AABBs4MFQQU6AABBpIMFQQQ2AgBBjIMFQearAigAADYCAEGPgwVB6asCKAAANgAAQZiDBUHuqwIoAAA2AgBBm4MFQfGrAigAADYAAEGogwVB9qsCKAAANgIAQayDBUH6qwItAAA6AABBk4MFQQA6AABBn4MFQQA6AABBv4MFQQU6AABBwIMFQQU2AgBBz4MFQQU6AABB24MFQQU6AABBtIMFQfyrAigAADYCAEG4gwVBgKwCLQAAOgAAQcSDBUGCrAIoAAA2AgBByIMFQYasAi0AADoAAEHQgwVBiKwCKAAANgIAQdSDBUGMrAItAAA6AABBrYMFQQA6AABBuYMFQQA6AABByYMFQQA6AABB64MFQQQ6AABB3IMFQQY2AgBB1YMFQQA6AABB94MFQQQ6AABB4IMFQebqudsGNgIAQeSDBUEAOgAAQYeEBUEGOgAAQfiDBUEHNgIAQeyDBUHG6rnbBjYCAEHwgwVBADoAAEGAhAVBkqwCLwAAOwAAQfyDBUGOrAIoAAA2AgBBk4QFQQY6AABBgoQFQQA6AABBjIQFQZmsAi8AADsBAEGIhAVBlawCKAAANgIAQaOEBUEGOgAAQZSEBUEINgIAQY6EBUEAOgAAQZyEBUGgrAIvAAA7AQBBmIQFQZysAigAADYCAEGvhAVBBzoAAEGehAVBADoAAEGnhAVBpqwCKAAANgAAQaSEBUGjrAIoAAA2AgBBv4QFQQQ6AABBsIQFQQk2AgBBq4QFQQA6AABBy4QFQQQ6AABBtIQFQerC6dMHNgIAQbiEBUEAOgAAQduEBUEFOgAAQcyEBUEKNgIAQcCEBUHKwunTBzYCAEHEhAVBADoAAEHUhAVBr6wCLQAAOgAAQdCEBUGrrAIoAAA2AgBB54QFQQU6AABB1YQFQQA6AABB4IQFQbWsAi0AADoAAEHchAVBsawCKAAANgIAQfeEBUEGOgAAQeiEBUELNgIAQeGEBUEAOgAAQfCEBUG7rAIvAAA7AABB7IQFQbesAigAADYCAEGDhQVBBzoAAEHyhAVBADoAAEH7hAVBwawCKAAANgAAQfiEBUG+rAIoAAA2AgBBk4UFQQY6AABBhIUFQQw2AgBB/4QFQQA6AABBjIUFQcqsAi8AADsBAEGIhQVBxqwCKAAANgIAQZ+FBUEGOgAAQY6FBUEAOgAAQZiFBUHRrAIvAAA7AABBlIUFQc2sAigAADYCAEGvhQVBBToAAEGghQVBDTYCAEGahQVBADoAAEGohQVB2KwCLQAAOgAAQaSFBUHUrAIoAAA2AgBBu4UFQQU6AABBqYUFQQA6AABBtIUFQd6sAi0AADoAAEGwhQVB2qwCKAAANgIAQcuFBUEDOgAAQbyFBUEONgIAQbWFBUEAOgAAQcKFBUHirAItAAA6AABBwIUFQeCsAi8AADsBAEHXhQVBAzoAAEHDhQVBADoAAEHOhQVB5qwCLQAAOgAAQcyFBUHkrAIvAAA7AQBB54UFQQY6AABB2IUFQQ82AgBBz4UFQQA6AABB4IUFQeysAi8AADsAAEHchQVB6KwCKAAANgIAQfOFBUEDOgAAQeKFBUEAOgAAQeqFBUHxrAItAAA6AABB6IUFQe+sAi8AADsBAEGDhgVBAzoAAEH0hQVBEDYCAEHrhQVBADoAAEH6hQVB9awCLQAAOgAAQfiFBUHzrAIvAAA7AQBBj4YFQQM6AABB+4UFQQA6AABBhoYFQfmsAi0AADoAAEGEhgVB96wCLwAAOwEAQZ+GBUEGOgAAQZCGBUERNgIAQYeGBUEAOgAAQZiGBUH/rAIvAAA7AABBlIYFQfusAigAADYCAEGrhgVBBjoAAEGahgVBADoAAEGkhgVBhq0CLwAAOwEAQaCGBUGCrQIoAAA2AgBBu4YFQQQ6AABBrIYFQRI2AgBBpoYFQQA6AABBx4YFQQQ6AABBsIYFQfLejdsGNgIAQbSGBUEAOgAAQdeGBUEGOgAAQciGBUETNgIAQbyGBUHS3o3bBjYCAEHAhgVBADoAAEHQhgVBja0CLwAAOwAAQcyGBUGJrQIoAAA2AgBB44YFQQY6AABB0oYFQQA6AABB3IYFQZStAi8AADsBAEHYhgVBkK0CKAAANgIAQfOGBUEKOgAAQeSGBUEUNgIAQd6GBUEAOgAAQfCGBUGfrQIvAAA7AABB6IYFQZetAikAADcDAEH/hgVBCjoAAEHyhgVBADoAAEH8hgVBqq0CLwAAOwEAQfSGBUGirQIpAAA3AgBBgIcFQRU2AgBB/oYFQQA6AABByLIFQQA2AgBBLUEQEA0hAEHIsgUoAgAhAUHIsgVBADYCAEGAhwUgAUEBRg0AGkGEhwUgADYCAEGIhwVCi4CAgICCgICAfzcDACAAQQA6AAsgAEG0rQIoAAA2AAcgAEGtrQIpAAA3AABByLIFQQA2AgBBLUEQEA0hAUHIsgUoAgAhAkHIsgVBADYCACACQQFGDQJBkIcFIAE2AgBBlIcFQouAgICAgoCAgH83AgAgAUEAOgALIAFBwK0CKAAANgAHIAFBua0CKQAANwAAQauHBUEDOgAAQZyHBUEWNgIAQbeHBUEDOgAAQceHBUEKOgAAQbiHBUEXNgIAQaCHBUHFrQIvAAA7AQBBoocFQcetAi0AADoAAEGshwVBya0CLwAAOwEAQa6HBUHLrQItAAA6AABBvIcFQc2tAikAADcCAEHEhwVB1a0CLwAAOwEAQaOHBUEAOgAAQa+HBUEAOgAAQciyBUEANgIAQcaHBUEAOgAAQS1BEBANIQBByLIFKAIAIQFByLIFQQA2AgAgAUEBRg0DQciHBSAANgIAQcyHBUKLgICAgIKAgIB/NwIAIABBADoACyAAQd+tAigAADYAByAAQditAikAADcAAEHjhwVBBjoAAEHUhwVBGDYCAEHvhwVBBjoAAEH/hwVBCjoAAEHwhwVBGTYCAEHYhwVB5K0CKAAANgIAQdyHBUHorQIvAAA7AQBB5IcFQeutAigAADYCAEHohwVB760CLwAAOwAAQfSHBUHyrQIpAAA3AgBB/IcFQfqtAi8AADsBAEHehwVBADoAAEHqhwVBADoAAEGKiAVBgBQ7AQBBjIgFQRo2AgBBmogFQYAUOwEAQYCIBUH9rQIpAAA3AwBBiIgFQYWuAi8AADsBAEGQiAVBiK4CKQAANwMAQZiIBUGQrgIvAAA7AQBB/ocFQQA6AABByLIFQQA2AgBBLUEQEA0hAEHIsgUoAgAhAUHIsgVBADYCACABQQFGDQRBnIgFIAA2AgBBoIgFQouAgICAgoCAgH83AwAgAEEAOgALIABBmq4CKAAANgAHIABBk64CKQAANwAAQbeIBUEHOgAAQaiIBUEbNgIAQcOIBUEHOgAAQdOIBUEHOgAAQcSIBUEcNgIAQayIBUGfrgIoAAA2AgBBr4gFQaKuAigAADYAAEG4iAVBp64CKAAANgIAQbuIBUGqrgIoAAA2AABByIgFQa+uAigAADYCAEHLiAVBsq4CKAAANgAAQbOIBUEAOgAAQb+IBUEAOgAAQd+IBUEIOgAAQdSIBULU5KWD14XSt/AANwIAQeCIBUEdNgIAQe+IBUEFOgAAQfuIBUEFOgAAQYuJBUEIOgAAQfyIBUEeNgIAQeSIBUG3rgIoAAA2AgBB6IgFQbuuAi0AADoAAEHwiAVBva4CKAAANgIAQfSIBUHBrgItAAA6AABBz4gFQQA6AABB3IgFQQA6AABB6YgFQQA6AABB9YgFQQA6AABBl4kFQQk6AABBgIkFQurC6dPnrJ236wA3AwBBiIkFQQA6AABBlIkFQcuuAi0AADoAAEGMiQVBw64CKQAANwIAQaeJBUEGOgAAQZiJBUEfNgIAQZWJBUEAOgAAQaCJBUHRrgIvAAA7AABBnIkFQc2uAigAADYCAEGziQVBBjoAAEGiiQVBADoAAEGsiQVB2K4CLwAAOwEAQaiJBUHUrgIoAAA2AgBBw4kFQQY6AABBtIkFQSA2AgBBrokFQQA6AABBvIkFQd+uAi8AADsBAEG4iQVB264CKAAANgIAQc+JBUEGOgAAQb6JBUEAOgAAQciJBUHmrgIvAAA7AABBxIkFQeKuAigAADYCAEHfiQVBCToAAEHQiQVBITYCAEHKiQVBADoAAEHciQVB8a4CLQAAOgAAQdSJBUHprgIpAAA3AgBB64kFQQk6AABB3YkFQQA6AABB6IkFQfuuAi0AADoAAEHgiQVB864CKQAANwMAQeyJBUEiNgIAQemJBUEAOgAAQciyBUEANgIAQS1BEBANIQBByLIFKAIAIQFByLIFQQA2AgBB7IkFIAFBAUYNABpB8IkFIAA2AgBB9IkFQoyAgICAgoCAgH83AgAgAEEAOgAMIABBha8CKAAANgAIIABB/a4CKQAANwAAQciyBUEANgIAQS1BEBANIQFByLIFKAIAIQJByLIFQQA2AgAgAkEBRg0FQfyJBSABNgIAQYCKBUKMgICAgIKAgIB/NwMAIAFBADoADCABQZKvAigAADYACCABQYqvAikAADcAAEGXigVBBDoAAEGIigVCo4CAgJDs2LTkADcDAEGjigVBBDoAAEGzigVBBToAAEGkigVBJDYCAEGYigVBwcalowY2AgBBv4oFQQU6AABBqIoFQZevAigAADYCAEGsigVBm68CLQAAOgAAQbSKBUGdrwIoAAA2AgBBuIoFQaGvAi0AADoAAEGQigVBADoAAEGcigVBADoAAEGtigVBADoAAEHPigVBBDoAAEHAigVCpYCAgPCs2LblADcDAEHbigVBBDoAAEHQigVBx8K1qwY2AgBB3IoFQSY2AgBB64oFQQk6AABB94oFQQo6AABB4IoFQaOvAikAADcDAEHoigVBq68CLQAAOgAAQeyKBUGtrwIpAAA3AgBB9IoFQbWvAi8AADsBAEG5igVBADoAAEHIigVBADoAAEHUigVBADoAAEHpigVBADoAAEGHiwVBBjoAAEH4igVBJzYCAEH2igVBADoAAEGAiwVBvK8CLwAAOwAAQfyKBUG4rwIoAAA2AgBBk4sFQQY6AABBgosFQQA6AABBjIsFQcOvAi8AADsBAEGIiwVBv68CKAAANgIAQaOLBUEFOgAAQZSLBUEoNgIAQY6LBUEAOgAAQZyLBUHKrwItAAA6AABBmIsFQcavAigAADYCAEGviwVBBToAAEGdiwVBADoAAEGoiwVB0K8CLQAAOgAAQaSLBUHMrwIoAAA2AgBBv4sFQQo6AABBsIsFQSk2AgBBqYsFQQA6AABBvIsFQdqvAi8AADsBAEG0iwVB0q8CKQAANwIAQcuLBUEKOgAAQb6LBUEAOgAAQciLBUHlrwIvAAA7AQBBwIsFQd2vAikAADcDAEHbiwVBBDoAAEHMiwVBKjYCAEHKiwVBADoAAEHniwVBBDoAAEHQiwVB4sLNmwc2AgBB1IsFQQA6AABB94sFQQQ6AABB6IsFQSs2AgBB3IsFQcLCzZsHNgIAQeCLBUEAOgAAQYOMBUEEOgAAQeyLBUHz3tXjBjYCAEHwiwVBADoAAEGTjAVBBDoAAEGEjAVBLDYCAEH4iwVB097V4wY2AgBB/IsFQQA6AABBn4wFQQQ6AABBiIwFQfDqudsGNgIAQYyMBUEAOgAAQa+MBUEFOgAAQaCMBUEtNgIAQZSMBUHQ6rnbBjYCAEGYjAVBADoAAEGojAVB7K8CLQAAOgAAQaSMBUHorwIoAAA2AgBBu4wFQQU6AABBqYwFQQA6AABBtIwFQfKvAi0AADoAAEGwjAVB7q8CKAAANgIAQcuMBUEKOgAAQbyMBUEuNgIAQbWMBUEAOgAAQciMBUH8rwIvAAA7AQBBwIwFQfSvAikAADcDAEHXjAVBCjoAAEHKjAVBADoAAEHUjAVBh7ACLwAAOwEAQcyMBUH/rwIpAAA3AgBB2IwFQS82AgBB1owFQQA6AABByLIFQQA2AgBBLUEQEA0hAEHIsgUoAgAhAUHIsgVBADYCAEHYjAUgAUEBRg0AGkHcjAUgADYCAEHgjAVCj4CAgICCgICAfzcDACAAQQA6AA8gAEGRsAIpAAA3AAcgAEGKsAIpAAA3AABByLIFQQA2AgBBLUEgEA0hAUHIsgUoAgAhAkHIsgVBADYCACACQQFGDQZB6IwFIAE2AgBB7IwFQpCAgICAhICAgH83AgAgAUEAOgAQIAFBorACKQAANwAIIAFBmrACKQAANwAAQfSMBUEwNgIAQciyBUEANgIAQS1BIBANIQFByLIFKAIAIQBByLIFQQA2AgBB9IwFIABBAUYNABpB+IwFIAE2AgBB/IwFQpCAgICAhICAgH83AgAgAUEAOgAQIAFBs7ACKQAANwAIIAFBq7ACKQAANwAAQciyBUEANgIAQS1BIBANIQBByLIFKAIAIQJByLIFQQA2AgAgAkEBRg0HQYSNBSAANgIAQYiNBUKRgICAgISAgIB/NwMAIABBADoAESAAQcywAi0AADoAECAAQcSwAikAADcACCAAQbywAikAADcAAEGfjQVBBjoAAEGQjQVBMTYCAEGrjQVBBjoAAEG7jQVBBjoAAEGsjQVBMjYCAEGUjQVBzrACKAAANgIAQZiNBUHSsAIvAAA7AABBoI0FQdWwAigAADYCAEGkjQVB2bACLwAAOwEAQbCNBUHcsAIoAAA2AgBBtI0FQeCwAi8AADsBAEGajQVBADoAAEGmjQVBADoAAEHHjQVBBjoAAEHIjQVBMzYCAEHXjQVBCDoAAEHMjQVC5MLJ2/aumLvlADcCAEHjjQVBCDoAAEHYjQVCxMLJ2/aumLvlADcDAEHkjQVBNDYCAEG8jQVB47ACKAAANgIAQcCNBUHnsAIvAAA7AABBto0FQQA6AABBwo0FQQA6AABB1I0FQQA6AABB4I0FQQA6AABByLIFQQA2AgBBLUEgEA0hAUHIsgUoAgAhAEHIsgVBADYCAEHkjQUgAEEBRg0AGkHojQUgATYCAEHsjQVCkICAgICEgICAfzcCACABQQA6ABAgAUHysAIpAAA3AAggAUHqsAIpAAA3AABByLIFQQA2AgBBLUEgEA0hAEHIsgUoAgAhAkHIsgVBADYCACACQQFGDQhB9I0FIAA2AgBB+I0FQpGAgICAhICAgH83AwAgAEEAOgARIABBi7ECLQAAOgAQIABBg7ECKQAANwAIIABB+7ACKQAANwAAQYCOBUE1NgIAQY6OBUGAFDsBAEGrjgVBBzoAAEGcjgVBNjYCAEGajgVBgBQ7AQBBt44FQQg6AABBhI4FQY2xAikAADcCAEGMjgVBlbECLwAAOwEAQZCOBUGYsQIpAAA3AwBBmI4FQaCxAi8AADsBAEGgjgVBo7ECKAAANgIAQaOOBUGmsQIoAAA2AABBp44FQQA6AABBx44FQQk6AABBuI4FQTc2AgBBrI4FQtDewevi6Ju26wA3AgBB044FQQk6AABB1I4FQTg2AgBB444FQQU6AABBvI4FQauxAikAADcCAEHEjgVBs7ECLQAAOgAAQciOBUG1sQIpAAA3AwBB0I4FQb2xAi0AADoAAEHYjgVBv7ECKAAANgIAQdyOBUHDsQItAAA6AABBtI4FQQA6AABBxY4FQQA6AABB0Y4FQQA6AABB744FQQU6AABB3Y4FQQA6AABB6I4FQcmxAi0AADoAAEHkjgVBxbECKAAANgIAQfCOBUE5NgIAQemOBUEAOgAAQciyBUEANgIAQS1BEBANIQBByLIFKAIAIQFByLIFQQA2AgBB8I4FIAFBAUYNABpB9I4FIAA2AgBB+I4FQoyAgICAgoCAgH83AwAgAEEAOgAMIABB07ECKAAANgAIIABBy7ECKQAANwAAQciyBUEANgIAQS1BEBANIQFByLIFKAIAIQJByLIFQQA2AgAgAkEBRg0JQYCPBSABNgIAQYSPBUKNgICAgIKAgIB/NwIAIAFBADoADSABQd2xAikAADcABSABQdixAikAADcAAEGbjwVBBjoAAEGMjwVBOjYCAEGnjwVBBjoAAEG3jwVBBDoAAEHDjwVBBDoAAEGojwVCu4CAgLCsnbb0ADcDAEHTjwVBBzoAAEHEjwVBPDYCAEG4jwVBw+qxowc2AgBBkI8FQeaxAigAADYCAEGUjwVB6rECLwAAOwEAQZyPBUHtsQIoAAA2AgBBoI8FQfGxAi8AADsAAEGWjwVBADoAAEGijwVBADoAAEGwjwVBADoAAEG8jwVBADoAAEHfjwVBBzoAAEHgjwVBPTYCAEHvjwVBBToAAEH7jwVBBjoAAEHLjwVB97ECKAAANgAAQciPBUH0sQIoAAA2AgBB1I8FQfyxAigAADYCAEHXjwVB/7ECKAAANgAAQeSPBUGEsgIoAAA2AgBB6I8FQYiyAi0AADoAAEHPjwVBADoAAEHbjwVBADoAAEHpjwVBADoAAEH0jwVBjrICLwAAOwEAQfCPBUGKsgIoAAA2AgBB/I8FQT42AgBB9o8FQQA6AABByLIFQQA2AgBBLUEQEA0hAEHIsgUoAgAhAUHIsgVBADYCAEH8jwUgAUEBRg0AGkGAkAUgADYCAEGEkAVCjICAgICCgICAfzcCACAAQQA6AAwgAEGZsgIoAAA2AAggAEGRsgIpAAA3AABByLIFQQA2AgBBLUEQEA0hAUHIsgUoAgAhAkHIsgVBADYCACACQQFGDQpBjJAFIAE2AgBBkJAFQo2AgICAgoCAgH83AwAgAUEAOgANIAFBo7ICKQAANwAFIAFBnrICKQAANwAAQaeQBUEHOgAAQZiQBUE/NgIAQbOQBUEIOgAAQcOQBUEGOgAAQbSQBUHAADYCAEGokAVC0N7B++KonbfrADcDAEHPkAVBBjoAAEGckAVBrLICKAAANgIAQZ+QBUGvsgIoAAA2AABBuJAFQbSyAigAADYCAEG8kAVBuLICLwAAOwEAQciQBUG/sgIvAAA7AABBxJAFQbuyAigAADYCAEGjkAVBADoAAEGwkAVBADoAAEG+kAVBADoAAEHQkAVBwQA2AgBBypAFQQA6AABByLIFQQA2AgBBLUEQEA0hAEHIsgUoAgAhAUHIsgVBADYCAEHQkAUgAUEBRg0AGkHUkAUgADYCAEHYkAVCjoCAgICCgICAfzcDACAAQQA6AA4gAEHIsgIpAAA3AAYgAEHCsgIpAAA3AABByLIFQQA2AgBBLUEQEA0hAUHIsgUoAgAhAkHIsgVBADYCACACQQFGDQtB4JAFIAE2AgBB5JAFQo+AgICAgoCAgH83AgAgAUEAOgAPIAFB2LICKQAANwAHIAFB0bICKQAANwAAQfuQBUEHOgAAQeyQBUHCADYCAEGHkQVBBzoAAEGXkQVBBzoAAEGIkQVBwwA2AgBB8JAFQeGyAigAADYCAEHzkAVB5LICKAAANgAAQfyQBUHpsgIoAAA2AgBB/5AFQeyyAigAADYAAEGMkQVB8bICKAAANgIAQY+RBUH0sgIoAAA2AABB95AFQQA6AABBg5EFQQA6AABBo5EFQQg6AABBmJEFQs7K3YPyqpi75QA3AwBBpJEFQcQANgIAQZORBUEAOgAAQaCRBUEAOgAAQciyBUEANgIAQS1BEBANIQBByLIFKAIAIQFByLIFQQA2AgBBpJEFIAFBAUYNABpBqJEFIAA2AgBBrJEFQouAgICAgoCAgH83AgAgAEEAOgALIABBgLMCKAAANgAHIABB+bICKQAANwAAQciyBUEANgIAQS1BEBANIQFByLIFKAIAIQJByLIFQQA2AgAgAkEBRg0MQbSRBSABNgIAQbiRBUKLgICAgIKAgIB/NwMAIAFBADoACyABQYyzAigAADYAByABQYWzAikAADcAAEHPkQVBBDoAAEHAkQVCxYCAgKCumLvlADcDAEHbkQVBBDoAAEHrkQVBCToAAEHckQVBxgA2AgBB0JEFQdLC2asGNgIAQfeRBUEJOgAAQeCRBUGRswIpAAA3AwBB6JEFQZmzAi0AADoAAEHskQVBm7MCKQAANwIAQfSRBUGjswItAAA6AABByJEFQQA6AABB1JEFQQA6AABB6ZEFQQA6AABBh5IFQQc6AABB+JEFQccANgIAQZOSBUEHOgAAQZSSBULIgICAwO2bs+kANwIAQaOSBUEEOgAAQa+SBUEFOgAAQfyRBUGlswIoAAA2AgBB/5EFQaizAigAADYAAEGIkgVBrbMCKAAANgIAQYuSBUGwswIoAAA2AABB9ZEFQQA6AABBg5IFQQA6AABBj5IFQQA6AABBnJIFQQA6AABBqJIFQbmzAi0AADoAAEGkkgVBtbMCKAAANgIAQb+SBUEGOgAAQbCSBUHJADYCAEGpkgVBADoAAEG4kgVBv7MCLwAAOwAAQbSSBUG7swIoAAA2AgBBy5IFQQY6AABBupIFQQA6AABBxJIFQcazAi8AADsBAEHAkgVBwrMCKAAANgIAQduSBUEIOgAAQcySBUHKADYCAEHGkgVBADoAAEHnkgVBCToAAEHQkgVC4calo4aunbfrADcDAEHYkgVBADoAAEHkkgVB0bMCLQAAOgAAQdySBUHJswIpAAA3AgBB95IFQQg6AABB6JIFQcsANgIAQeWSBUEAOgAAQYOTBUEJOgAAQeySBULhxqWjpq2YvfoANwIAQfSSBUEAOgAAQYCTBUHbswItAAA6AABB+JIFQdOzAikAADcDAEGTkwVBBToAAEGEkwVBzAA2AgBBgZMFQQA6AABBjJMFQeGzAi0AADoAAEGIkwVB3bMCKAAANgIAQZ+TBUEFOgAAQY2TBUEAOgAAQZiTBUHnswItAAA6AABBlJMFQeOzAigAADYCAEGvkwVBBToAAEGgkwVBzQA2AgBBmZMFQQA6AABBqJMFQe2zAi0AADoAAEGkkwVB6bMCKAAANgIAQbuTBUEFOgAAQamTBUEAOgAAQbSTBUHzswItAAA6AABBsJMFQe+zAigAADYCAEHLkwVBBzoAAEG8kwVBzgA2AgBBtZMFQQA6AABBw5MFQfizAigAADYAAEHAkwVB9bMCKAAANgIAQdeTBUEHOgAAQceTBUEAOgAAQc+TBUGAtAIoAAA2AABBzJMFQf2zAigAADYCAEHYkwVBzwA2AgBB05MFQQA6AABByLIFQQA2AgBBLUEQEA0hAEHIsgUoAgAhAUHIsgVBADYCAEHYkwUgAUEBRg0AGkHckwUgADYCAEHgkwVCjICAgICCgICAfzcDACAAQQA6AAwgAEGNtAIoAAA2AAggAEGFtAIpAAA3AABByLIFQQA2AgBBLUEQEA0hAUHIsgUoAgAhAkHIsgVBADYCACACQQFGDQ1B6JMFIAE2AgBB7JMFQouAgICAgoCAgH83AgAgAUEAOgALIAFBmbQCKAAANgAHIAFBkrQCKQAANwAAQYOUBUEIOgAAQfSTBUHQADYCAEGPlAVBCToAAEH4kwVC6MLJo6bu27HrADcDAEGflAVBBDoAAEGrlAVBBDoAAEGQlAVC0YCAgODsm7brADcDAEG7lAVBCDoAAEGslAVB0gA2AgBBoJQFQcbesdsGNgIAQbCUBULm3rHbpu7bsesANwMAQceUBUEJOgAAQYSUBUGetAIpAAA3AgBBjJQFQaa0Ai0AADoAAEGAlAVBADoAAEGNlAVBADoAAEGYlAVBADoAAEGklAVBADoAAEG4lAVBADoAAEHIlAVB0wA2AgBBxJQFQbC0Ai0AADoAAEG8lAVBqLQCKQAANwIAQcWUBUEAOgAAQciyBUEANgIAQS1BEBANIQBByLIFKAIAIQFByLIFQQA2AgBByJQFIAFBAUYNABpBzJQFIAA2AgBB0JQFQoyAgICAgoCAgH83AwAgAEEAOgAMIABBurQCKAAANgAIIABBsrQCKQAANwAAQciyBUEANgIAQS1BEBANIQFByLIFKAIAIQJByLIFQQA2AgAgAkEBRg0OQdiUBSABNgIAQdyUBUKNgICAgIKAgIB/NwIAIAFBADoADSABQcS0AikAADcABSABQb+0AikAADcAAEHzlAVBBToAAEHklAVB1AA2AgBB/5QFQQU6AABBj5UFQQo6AABBgJUFQdUANgIAQeiUBUHNtAIoAAA2AgBB7JQFQdG0Ai0AADoAAEH0lAVB07QCKAAANgIAQfiUBUHXtAItAAA6AABBhJUFQdm0AikAADcCAEGMlQVB4bQCLwAAOwEAQe2UBUEAOgAAQfmUBUEAOgAAQciyBUEANgIAQY6VBUEAOgAAQS1BEBANIQBByLIFKAIAIQFByLIFQQA2AgAgAUEBRg0PQZCVBSAANgIAQZSVBUKLgICAgIKAgIB/NwIAIABBADoACyAAQeu0AigAADYAByAAQeS0AikAADcAAEGrlQVBBToAAEGclQVB1gA2AgBBt5UFQQU6AABBx5UFQQU6AABBuJUFQdcANgIAQaCVBUHwtAIoAAA2AgBBpJUFQfS0Ai0AADoAAEGslQVB9rQCKAAANgIAQbCVBUH6tAItAAA6AABBvJUFQfy0AigAADYCAEHAlQVBgLUCLQAAOgAAQaWVBUEAOgAAQbGVBUEAOgAAQdOVBUEFOgAAQdSVBUHYADYCAEHjlQVBBzoAAEHvlQVBBzoAAEHIlQVBgrUCKAAANgIAQcyVBUGGtQItAAA6AABB2JUFQYi1AigAADYCAEHblQVBi7UCKAAANgAAQeSVBUGQtQIoAAA2AgBB55UFQZO1AigAADYAAEHBlQVBADoAAEHNlQVBADoAAEHflQVBADoAAEH/lQVBBjoAAEHwlQVB2QA2AgBB65UFQQA6AABB+JUFQZy1Ai8AADsAAEH0lQVBmLUCKAAANgIAQYuWBUEGOgAAQfqVBUEAOgAAQYSWBUGjtQIvAAA7AQBBgJYFQZ+1AigAADYCAEGblgVBCToAAEGMlgVB2gA2AgBBhpYFQQA6AABBmJYFQa61Ai0AADoAAEGQlgVBprUCKQAANwMAQaeWBUEJOgAAQZmWBUEAOgAAQaSWBUG4tQItAAA6AABBnJYFQbC1AikAADcCAEG3lgVBCjoAAEGolgVB2wA2AgBBpZYFQQA6AABBtJYFQcK1Ai8AADsBAEGslgVBurUCKQAANwIAQcOWBUEKOgAAQbaWBUEAOgAAQcCWBUHNtQIvAAA7AABBuJYFQcW1AikAADcDAEHTlgVBCjoAAEHElgVB3AA2AgBBwpYFQQA6AABB0JYFQdi1Ai8AADsAAEHIlgVB0LUCKQAANwMAQdKWBUEAOgAAQciyBUEANgIAQS1BEBANIQBByLIFKAIAIQFByLIFQQA2AgAgAUEBRg0QQdSWBSAANgIAQdiWBUKLgICAgIKAgIB/NwMAIABBADoACyAAQeK1AigAADYAByAAQdu1AikAADcAAEHglgVB3QA2AgBByLIFQQA2AgBBLUEQEA0hAEHIsgUoAgAhAUHIsgVBADYCAEHglgUgAUEBRg0AGkHklgUgADYCAEHolgVCj4CAgICCgICAfzcDACAAQQA6AA8gAEHutQIpAAA3AAcgAEHntQIpAAA3AABByLIFQQA2AgBBLUEQEA0hAUHIsgUoAgAhAkHIsgVBADYCACACQQFGDRFB8JYFIAE2AgBB9JYFQo+AgICAgoCAgH83AgAgAUEAOgAPIAFB/rUCKQAANwAHIAFB97UCKQAANwAAQfyWBUHeADYCAEHIsgVBADYCAEEtQRAQDSEAQciyBSgCACEBQciyBUEANgIAQfyWBSABQQFGDQAaQYCXBSAANgIAQYSXBUKPgICAgIKAgIB/NwIAIABBADoADyAAQY62AikAADcAByAAQYe2AikAADcAAEHIsgVBADYCAEEtQSAQDSEBQciyBSgCACECQciyBUEANgIAIAJBAUYNEkGMlwUgATYCAEGQlwVCkICAgICEgICAfzcDACABQQA6ABAgAUGftgIpAAA3AAggAUGXtgIpAAA3AABBmJcFQd8ANgIAQciyBUEANgIAQS1BEBANIQBByLIFKAIAIQFByLIFQQA2AgBBmJcFIAFBAUYNABpBnJcFIAA2AgBBoJcFQo2AgICAgoCAgH83AwAgAEEAOgANIABBrbYCKQAANwAFIABBqLYCKQAANwAAQciyBUEANgIAQS1BEBANIQFByLIFKAIAIQJByLIFQQA2AgAgAkEBRg0TQaiXBSABNgIAQayXBUKOgICAgIKAgIB/NwIAIAFBADoADiABQby2AikAADcABiABQba2AikAADcAAEHDlwVBCDoAAEG0lwVB4AA2AgBBz5cFQQk6AABBuJcFQvPYvbun7tux6wA3AwBB35cFQQc6AABB0JcFQeEANgIAQeuXBUEIOgAAQeCXBULC0p2DoqiYt+QANwMAQeyXBUHiADYCAEH7lwVBBjoAAEHElwVBxbYCKQAANwIAQcyXBUHNtgItAAA6AABB1JcFQc+2AigAADYCAEHXlwVB0rYCKAAANgAAQcCXBUEAOgAAQc2XBUEAOgAAQduXBUEAOgAAQeiXBUEAOgAAQYeYBUEGOgAAQYiYBUHjADYCAEH0lwVB27YCLwAAOwEAQfCXBUHXtgIoAAA2AgBB/JcFQd62AigAADYCAEGAmAVB4rYCLwAAOwAAQfaXBUEAOgAAQYKYBUEAOgAAQciyBUEANgIAQS1BEBANIQBByLIFKAIAIQFByLIFQQA2AgBBiJgFIAFBAUYNABpBjJgFIAA2AgBBkJgFQo2AgICAgoCAgH83AwAgAEEAOgANIABB6rYCKQAANwAFIABB5bYCKQAANwAAQciyBUEANgIAQS1BEBANIQFByLIFKAIAIQJByLIFQQA2AgAgAkEBRg0UQZiYBSABNgIAQZyYBUKOgICAgIKAgIB/NwIAIAFBADoADiABQfm2AikAADcABiABQfO2AikAADcAAEGzmAVBCDoAAEGkmAVB5AA2AgBBv5gFQQg6AABBqJgFQuHGvau3jt204wA3AwBBz5gFQQY6AABBwJgFQeUANgIAQbSYBULBxr2rt47dtOMANwIAQduYBUEFOgAAQcSYBUGCtwIoAAA2AgBByJgFQYa3Ai8AADsAAEHQmAVBibcCKAAANgIAQdSYBUGNtwItAAA6AABBsJgFQQA6AABBvJgFQQA6AABBypgFQQA6AABB65gFQQY6AABB3JgFQeYANgIAQfeYBUEGOgAAQfiYBUHnADYCAEGHmQVBBzoAAEHgmAVBj7cCKAAANgIAQeSYBUGTtwIvAAA7AQBB7JgFQZa3AigAADYCAEHwmAVBmrcCLwAAOwAAQfyYBUGdtwIoAAA2AgBB/5gFQaC3AigAADYAAEHVmAVBADoAAEHmmAVBADoAAEHymAVBADoAAEGTmQVBBjoAAEGDmQVBADoAAEGMmQVBqbcCLwAAOwEAQYiZBUGltwIoAAA2AgBBo5kFQQU6AABBlJkFQegANgIAQY6ZBUEAOgAAQZyZBUGwtwItAAA6AABBmJkFQay3AigAADYCAEGvmQVBBToAAEGdmQVBADoAAEGomQVBtrcCLQAAOgAAQaSZBUGytwIoAAA2AgBBsJkFQekANgIAQamZBUEAOgAAQciyBUEANgIAQS1BEBANIQBByLIFKAIAIQFByLIFQQA2AgBBsJkFIAFBAUYNABpBtJkFIAA2AgBBuJkFQoyAgICAgoCAgH83AwAgAEEAOgAMIABBwLcCKAAANgAIIABBuLcCKQAANwAAQciyBUEANgIAQS1BEBANIQFByLIFKAIAIQJByLIFQQA2AgAgAkEBRg0VQcCZBSABNgIAQcSZBUKNgICAgIKAgIB/NwIAIAFBADoADSABQcq3AikAADcABSABQcW3AikAADcAAEHbmQVBBjoAAEHMmQVB6gA2AgBB55kFQQY6AABB95kFQQg6AABB6JkFQesANgIAQYOaBUEIOgAAQeyZBULz8rWDh+2bt/kANwIAQfiZBULT8rWDh+2bt/kANwMAQYSaBUHsADYCAEGTmgVBCToAAEHQmQVB07cCKAAANgIAQdSZBUHXtwIvAAA7AQBB3JkFQdq3AigAADYCAEHgmQVB3rcCLwAAOwAAQdaZBUEAOgAAQeKZBUEAOgAAQfSZBUEAOgAAQYCaBUEAOgAAQZ6aBUGAFDsBAEGgmgVB7QA2AgBBr5oFQQY6AABBu5oFQQY6AABBkJoFQem3Ai0AADoAAEGImgVB4bcCKQAANwMAQZSaBUHrtwIpAAA3AgBBnJoFQfO3Ai8AADsBAEGkmgVB9rcCKAAANgIAQaiaBUH6twIvAAA7AABBkZoFQQA6AABBqpoFQQA6AABBtJoFQYG4Ai8AADsBAEGwmgVB/bcCKAAANgIAQcuaBUEKOgAAQbyaBUHuADYCAEG2mgVBADoAAEHImgVBjLgCLwAAOwEAQcCaBUGEuAIpAAA3AwBBypoFQQA6AABByLIFQQA2AgBBLUEQEA0hAEHIsgUoAgAhAUHIsgVBADYCACABQQFGDRZBzJoFIAA2AgBB0JoFQouAgICAgoCAgH83AwAgAEEAOgALIABBlrgCKAAANgAHIABBj7gCKQAANwAAQeeaBUEGOgAAQdiaBUHvADYCAEHzmgVBBjoAAEGDmwVBBzoAAEH0mgVB8AA2AgBB3JoFQZu4AigAADYCAEHgmgVBn7gCLwAAOwAAQeiaBUGiuAIoAAA2AgBB7JoFQaa4Ai8AADsBAEH4mgVBqbgCKAAANgIAQfuaBUGsuAIoAAA2AABB4poFQQA6AABB7poFQQA6AABBj5sFQQg6AABBhJsFQtPYvbuHxNKw7QA3AgBBn5sFQQQ6AABBkJsFQvGAgICwjNu64gA3AwBBq5sFQQQ6AABBoJsFQcPY1ZMGNgIAQaybBUHyADYCAEG7mwVBBToAAEHHmwVBBToAAEGwmwVBsbgCKAAANgIAQbSbBUG1uAItAAA6AABB/5oFQQA6AABBjJsFQQA6AABBmJsFQQA6AABBpJsFQQA6AABBtZsFQQA6AABBwJsFQbu4Ai0AADoAAEG8mwVBt7gCKAAANgIAQdebBUEFOgAAQcibBUHzADYCAEHBmwVBADoAAEHQmwVBwbgCLQAAOgAAQcybBUG9uAIoAAA2AgBB45sFQQU6AABB0ZsFQQA6AABB3JsFQce4Ai0AADoAAEHYmwVBw7gCKAAANgIAQfObBUEIOgAAQeSbBUH0ADYCAEHdmwVBADoAAEH/mwVBCDoAAEHomwVC5t6x28btm7nlADcDAEHwmwVBADoAAEGPnAVBBjoAAEGAnAVB9QA2AgBB9JsFQsbesdvG7Zu55QA3AgBB/JsFQQA6AABBiJwFQc24Ai8AADsAAEGEnAVBybgCKAAANgIAQZucBUEGOgAAQYqcBUEAOgAAQZScBUHUuAIvAAA7AQBBkJwFQdC4AigAADYCAEGcnAVB9gA2AgBBlpwFQQA6AABByLIFQQA2AgBBLUEQEA0hAEHIsgUoAgAhAUHIsgVBADYCAEGcnAUgAUEBRg0AGkGgnAUgADYCAEGknAVCi4CAgICCgICAfzcCACAAQQA6AAsgAEHeuAIoAAA2AAcgAEHXuAIpAAA3AABByLIFQQA2AgBBLUEQEA0hAUHIsgUoAgAhAkHIsgVBADYCACACQQFGDRdBrJwFIAE2AgBBsJwFQoyAgICAgoCAgH83AwAgAUEAOgAMIAFB67gCKAAANgAIIAFB47gCKQAANwAAQbicBUH3ADYCAEHIsgVBADYCAEEtQRAQDSEAQciyBSgCACEBQciyBUEANgIAIAFBAUcNGEG4nAULIQAQBiECEAcaDBgLEAYhAhAHGiAAEPYMQeyCBSEADBcLEAYhAhAHGiAAEPYMQYCHBSEADBYLQbiHBSEAEAYhAhAHGgwVC0GMiAUhABAGIQIQBxoMFAsQBiECEAcaIAAQ9gxB7IkFIQAMEwsQBiECEAcaIAAQ9gxB2IwFIQAMEgsQBiECEAcaIAEQ9gxB9IwFIQAMEQsQBiECEAcaIAEQ9gxB5I0FIQAMEAsQBiECEAcaIAAQ9gxB8I4FIQAMDwsQBiECEAcaIAAQ9gxB/I8FIQAMDgsQBiECEAcaIAAQ9gxB0JAFIQAMDQsQBiECEAcaIAAQ9gxBpJEFIQAMDAsQBiECEAcaIAAQ9gxB2JMFIQAMCwsQBiECEAcaIAAQ9gxByJQFIQAMCgtBgJUFIQAQBiECEAcaDAkLQcSWBSEAEAYhAhAHGgwICxAGIQIQBxogABD2DEHglgUhAAwHCxAGIQIQBxogABD2DEH8lgUhAAwGCxAGIQIQBxogABD2DEGYlwUhAAwFCxAGIQIQBxogABD2DEGImAUhAAwECxAGIQIQBxogABD2DEGwmQUhAAwDC0G8mgUhABAGIQIQBxoMAgsQBiECEAcaIAAQ9gxBnJwFIQAMAQtBvJwFIAA2AgBBwJwFQoyAgICAgoCAgH83AwAgAEEAOgAMIABB+LgCKAAANgAIIABB8LgCKQAANwAAQciyBUEANgIAQS1BEBANIQFByLIFKAIAIQJByLIFQQA2AgAgAkEBRw0BEAYhAhAHGiAAEPYMQbicBSEACwNAIABBf2osAABBf0wEQCAAQXRqKAIAEPYMCyAAQWRqIQEgAEFzaiwAAEF/TARAIABBaGooAgAQ9gwLIAEiAEHQggVHDQALIAIQCAALQcicBSABNgIAQcycBUKNgICAgIKAgIB/NwIAIAFBADoADSABQYK5AikAADcABSABQf24AikAADcAAEHjnAVBCToAAEHUnAVB+AA2AgBB75wFQQk6AABB/5wFQQQ6AABBi50FQQQ6AABB8JwFQvmAgIDArN2y9AA3AwBBm50FQQg6AABBjJ0FQfoANgIAQYCdBUHE6pWjBzYCAEHYnAVBi7kCKQAANwMAQeCcBUGTuQItAAA6AABB5JwFQZW5AikAADcCAEHsnAVBnbkCLQAAOgAAQeGcBUEAOgAAQe2cBUEAOgAAQficBUEAOgAAQYSdBUEAOgAAQaedBUEJOgAAQZCdBULw6rnbpu7bsesANwMAQaidBUH7ADYCAEG3nQVBCDoAAEGsnQVC5OTV67bum7bvADcCAEHDnQVBCToAAEHTnQVBCDoAAEHEnQVB/AA2AgBBnJ0FQZ+5AikAADcCAEGknQVBp7kCLQAAOgAAQbidBUGpuQIpAAA3AwBBwJ0FQbG5Ai0AADoAAEGYnQVBADoAAEGlnQVBADoAAEG0nQVBADoAAEHBnQVBADoAAEHfnQVBCToAAEHInQVC4caFg9eMm7bhADcDAEHQnQVBADoAAEHcnQVBu7kCLQAAOgAAQdSdBUGzuQIpAAA3AgBB750FQQk6AABB4J0FQf0ANgIAQd2dBUEAOgAAQeydBUHFuQItAAA6AABB5J0FQb25AikAADcCAEH7nQVBCjoAAEHtnQVBADoAAEH4nQVBz7kCLwAAOwEAQfCdBUHHuQIpAAA3AwBBi54FQQk6AABB/J0FQf4ANgIAQfqdBUEAOgAAQYieBUHauQItAAA6AABBgJ4FQdK5AikAADcDAEGXngVBCjoAAEGJngVBADoAAEGUngVB5LkCLwAAOwEAQYyeBUHcuQIpAAA3AgBBp54FQQQ6AABBmJ4FQf8BNgIAQZaeBUEAOgAAQbOeBUEEOgAAQZyeBUHu3rmrBjYCAEGgngVBADoAAEGongVB7t65qwY2AgBBrJ4FQQA6AABBxJ4FQgA3AgBBvJ4FQgA3AgBBtJ4FQgA3AgBBzJ4FQQA2AgBB354FQQg6AABB654FQQU6AABB1J4FQu/Ykev2zd205QA3AgBB+54FQQY6AABB7J4FQQE2AgBBh58FQQY6AABB4J4FQee5AigAACIBNgIAQeSeBUHruQItAAAiAjoAAEHwngVB7bkCKAAANgIAQfSeBUHxuQIvAAA7AQBB/J4FQfS5AigAADYCAEGAnwVB+LkCLwAAOwAAQdCeBUEANgIAQdyeBUEAOgAAQeWeBUEAOgAAQfaeBUEAOgAAQZefBUEJOgAAQYifBUECNgIAQaKfBUGAFDsBAEGknwVBBjYCAEGznwVBCjoAAEGMnwVB+7kCKQAANwIAQZSfBUGDugItAAA6AABBmJ8FQYW6AikAADcDAEGgnwVBjboCLwAAOwAAQaifBUGQugIpAAA3AwBBsJ8FQZi6Ai8AADsAAEGCnwVBADoAAEGVnwVBADoAAEGynwVBADoAAEG0nwVBEBD+CyIANgIAQbifBUKLgICAgIKAgIB/NwMAIABBADoACyAAQaK6AigAADYAByAAQZu6AikAADcAAEHPnwVBBToAAEHAnwVBCTYCAEHbnwVBBToAAEHrnwVBBjoAAEHcnwVBCjYCAEHEnwVBp7oCKAAANgIAQcifBUGrugItAAA6AABB0J8FIAE2AgBB1J8FIAI6AABB4J8FQa26AigAADYCAEHknwVBsboCLwAAOwEAQcmfBUEAOgAAQdWfBUEAOgAAQfefBUEHOgAAQfifBUELNgIAQYegBUEHOgAAQZOgBUEHOgAAQeyfBUG0ugIoAAA2AgBB758FQbe6AigAADYAAEH8nwVBvLoCKAAANgIAQf+fBUG/ugIoAAA2AABBiKAFQcS6AigAADYCAEGLoAVBx7oCKAAANgAAQeafBUEAOgAAQfOfBUEAOgAAQYOgBUEAOgAAQaOgBUEIOgAAQZSgBUEONgIAQY+gBUEAOgAAQa+gBUEIOgAAQZigBULy0rm7xu6bt+UANwMAQaCgBUEAOgAAQbCgBUH/ATYCAEGkoAVC0tK5u8bum7flADcCAEGsoAVBADoAAEHEoAVCADcCAEG8oAVCADcCAEG0oAVCADcCAEHfoAVBBjoAAEHroAVBBjoAAEH7oAVBAzoAAEHsoAVBATYCAEHUoAVBzLoCKAAANgIAQdigBUHQugIvAAA7AABB4KAFQdO6AigAADYCAEHkoAVB17oCLwAAOwEAQfCgBUHaugIvAAA7AQBB8qAFQdy6Ai0AADoAAEHQoAVBADYCAEHaoAVBADoAAEHmoAVBADoAAEGHoQVBAzoAAEGIoQVB/wE2AgBBjKEFQgA3AgBBlKEFQgA3AgBBnKEFQgA3AgBB/KAFQd66Ai8AADsBAEH+oAVB4LoCLQAAOgAAQfOgBUEAOgAAQf+gBUEAOgAAQb+hBUEDOgAAQbChBUHR4Ag2AgBBtKEFQeK6Ai8AADsBAEG2oQVB5LoCLQAAOgAAQbehBUEAOgAAQciyBUEANgIAQS1BEBANIQBByLIFKAIAIQFByLIFQQA2AgACQAJ/AkACQAJAIAFBAUcEQEHAoQUgADYCAEHEoQVCjYCAgICCgICAfzcCACAAQQA6AA0gAEHrugIpAAA3AAUgAEHmugIpAAA3AABB26EFQQM6AABBzKEFQdHgCDYCAEHnoQVBBjoAAEH3oQVBAzoAAEHooQVB0+AINgIAQdChBUH0ugIvAAA7AQBB0qEFQfa6Ai0AADoAAEHcoQVB+LoCKAAANgIAQeChBUH8ugIvAAA7AABB7KEFQf+6Ai8AADsBAEHuoQVBgbsCLQAAOgAAQdOhBUEAOgAAQeKhBUEAOgAAQYOiBUEHOgAAQYSiBUHU4Ag2AgBBk6IFQQM6AABB+KEFQYO7AigAADYCAEH7oQVBhrsCKAAANgAAQYiiBUGLuwIvAAA7AQBBiqIFQY27Ai0AADoAAEHvoQVBADoAAEH/oQVBADoAAEGLogVBADoAAEHIsgVBADYCAEEtQRAQDSEAQciyBSgCACEBQciyBUEANgIAIAFBAUYNAUGUogUgADYCAEGYogVCjoCAgICCgICAfzcDACAAQQA6AA4gAEGVuwIpAAA3AAYgAEGPuwIpAAA3AABBr6IFQQM6AABBoKIFQdXgCDYCAEG7ogVBBzoAAEHLogVBAzoAAEG8ogVB1uAINgIAQaSiBUGeuwIvAAA7AQBBpqIFQaC7Ai0AADoAAEGwogVBorsCKAAANgIAQbOiBUGluwIoAAA2AABBwKIFQaq7Ai8AADsBAEHCogVBrLsCLQAAOgAAQaeiBUEAOgAAQbeiBUEAOgAAQdeiBUEHOgAAQdiiBUHX4Ag2AgBB56IFQQM6AABB86IFQQc6AABBzKIFQa67AigAADYCAEHPogVBsbsCKAAANgAAQdyiBUG2uwIvAAA7AQBB3qIFQbi7Ai0AADoAAEHoogVBursCKAAANgIAQeuiBUG9uwIoAAA2AABBw6IFQQA6AABB06IFQQA6AABB36IFQQA6AABBg6MFQQM6AABB9KIFQdjgCDYCAEHvogVBADoAAEH6ogVBxLsCLQAAOgAAQfiiBUHCuwIvAAA7AQBBj6MFQQY6AABB+6IFQQA6AABBiKMFQcq7Ai8AADsAAEGEowVBxrsCKAAANgIAQZ+jBUEDOgAAQZCjBUHZ4Ag2AgBBiqMFQQA6AABBlqMFQc+7Ai0AADoAAEGUowVBzbsCLwAAOwEAQaujBUEHOgAAQZejBUEAOgAAQaOjBUHUuwIoAAA2AABBoKMFQdG7AigAADYCAEG7owVBAzoAAEGsowVB2uAINgIAQaejBUEAOgAAQbKjBUHbuwItAAA6AABBsKMFQdm7Ai8AADsBAEHHowVBBToAAEGzowVBADoAAEHAowVB4bsCLQAAOgAAQbyjBUHduwIoAAA2AgBB16MFQQM6AABByKMFQdvgCDYCAEHBowVBADoAAEHOowVB5bsCLQAAOgAAQcyjBUHjuwIvAAA7AQBB46MFQQo6AABBz6MFQQA6AABB4KMFQe+7Ai8AADsAAEHYowVB57sCKQAANwMAQfOjBUEDOgAAQeSjBUHc4Ag2AgBB4qMFQQA6AABB6qMFQfS7Ai0AADoAAEHoowVB8rsCLwAAOwEAQeujBUEAOgAAQciyBUEANgIAQS1BEBANIQBByLIFKAIAIQFByLIFQQA2AgAgAUEBRg0CQfSjBSAANgIAQfijBUKLgICAgIKAgIB/NwMAIABBADoACyAAQf27AigAADYAByAAQfa7AikAADcAAEGPpAVBAzoAAEGApAVB3eAINgIAQZukBUEIOgAAQaukBUEDOgAAQZykBUHe4Ag2AgBBkKQFQtDeyaPX7tmw7AA3AwBBt6QFQQU6AABBhKQFQYK8Ai8AADsBAEGGpAVBhLwCLQAAOgAAQaCkBUGGvAIvAAA7AQBBoqQFQYi8Ai0AADoAAEGwpAVBjrwCLQAAOgAAQaykBUGKvAIoAAA2AgBBh6QFQQA6AABBmKQFQQA6AABBo6QFQQA6AABBx6QFQQM6AABBuKQFQd/gCDYCAEHTpAVBBjoAAEHUpAVB4OAINgIAQeOkBUEDOgAAQbykBUGQvAIvAAA7AQBBvqQFQZK8Ai0AADoAAEHIpAVBlLwCKAAANgIAQcykBUGYvAIvAAA7AQBB2KQFQZu8Ai8AADsBAEHapAVBnbwCLQAAOgAAQbGkBUEAOgAAQb+kBUEAOgAAQc6kBUEAOgAAQe+kBUEGOgAAQdukBUEAOgAAQeikBUGjvAIvAAA7AABB5KQFQZ+8AigAADYCAEH/pAVBAzoAAEHwpAVB4eAINgIAQeqkBUEAOgAAQfakBUGovAItAAA6AABB9KQFQaa8Ai8AADsBAEGLpQVBBjoAAEH3pAVBADoAAEGEpQVBrrwCLwAAOwEAQYClBUGqvAIoAAA2AgBBm6UFQQM6AABBjKUFQeLgCDYCAEGGpQVBADoAAEGSpQVBs7wCLQAAOgAAQZClBUGxvAIvAAA7AQBBp6UFQQc6AABBk6UFQQA6AABBn6UFQbi8AigAADYAAEGcpQVBtbwCKAAANgIAQbelBUEDOgAAQailBUHj4Ag2AgBBo6UFQQA6AABBrqUFQb+8Ai0AADoAAEGspQVBvbwCLwAAOwEAQa+lBUEAOgAAQciyBUEANgIAQS1BEBANIQBByLIFKAIAIQFByLIFQQA2AgAgAUEBRg0DQbilBSAANgIAQbylBUKLgICAgIKAgIB/NwIAIABBADoACyAAQci8AigAADYAByAAQcG8AikAADcAAEHTpQVBAzoAAEHEpQVB5OAINgIAQd+lBUEJOgAAQe+lBUEDOgAAQeClBUHl4Ag2AgBByKUFQc28Ai8AADsBAEHKpQVBz7wCLQAAOgAAQdSlBUHRvAIpAAA3AgBB3KUFQdm8Ai0AADoAAEHkpQVB27wCLwAAOwEAQealBUHdvAItAAA6AABBy6UFQQA6AABB3aUFQQA6AABByLIFQQA2AgBB56UFQQA6AABBLUEQEA0hAEHIsgUoAgAhAUHIsgVBADYCACABQQFHDQUQBiECEAcaQeClBQwECxAGIQAQBxogABAIAAsQBiECEAcaQYSiBQwCCxAGIQIQBxpB5KMFDAELEAYhAhAHGkGopQULIQADQCAAQX9qLAAAQX9MBEAgAEF0aigCABD2DAsgAEFkaiEBIABBc2osAABBf0wEQCAAQWhqKAIAEPYMCyABIgBBsKEFRw0ACyACEAgAC0HwpQUgADYCAEH0pQVCi4CAgICCgICAfzcCACAAQQA6AAsgAEHmvAIoAAA2AAcgAEHfvAIpAAA3AABBi6YFQQM6AABB/KUFQebgCDYCAEGXpgVBBToAAEGYpgVCADcDAEGgpgVCADcDAEGopgVCADcDAEGApgVB67wCLwAAOwEAQYKmBUHtvAItAAA6AABBjKYFQe+8AigAADYCAEGQpgVB87wCLQAAOgAAQYOmBUEAOgAAQZGmBUEAOgAAQbCmBUEANgIAQc+mBUEEOgAAQcCmBUKAgICA4O2bt+UANwMAQdumBUEEOgAAQeumBUEFOgAAQdymBUECNgIAQdCmBUHO3rmrBjYCAEH3pgVBBToAAEHgpgVB9bwCKAAANgIAQeSmBUH5vAItAAA6AABB7KYFQfu8AigAADYCAEHwpgVB/7wCLQAAOgAAQcimBUEAOgAAQdSmBUEAOgAAQeWmBUEAOgAAQYenBUEIOgAAQfimBUEENgIAQfymBULl8MHjlu3YtPQANwIAQZOnBUEIOgAAQYinBULF8MHjlu3YtPQANwMAQZSnBUH/ATYCAEGYpwVCADcDAEGgpwVCADcCAEGopwVCADcDAEHxpgVBADoAAEGEpwVBADoAAEGQpwVBADoAABCGBBCKBBCOBBCSBBCWBBCaBEH/qAVBAjoAAEHwqAVBGzYCAEGPqQVBBjoAAEGAqQVBDDYCAEH0qAVBwpoBOwEAQZ+pBUEGOgAAQZCpBUEMNgIAQa+pBUEDOgAAQaCpBUENNgIAQYSpBUGBvQIoAAA2AgBBiKkFQYW9Ai8AADsAAEGUqQVBiL0CKAAANgIAQZipBUGMvQIvAAA7AABB9qgFQQA6AABBiqkFQQA6AABBmqkFQQA6AABBsKkFQQ42AgBBv6kFQQg6AABBtKkFQomhubrUwYKNCjcCAEHAqQVB/wE2AgBBxKkFQgA3AgBBpqkFQZG9Ai0AADoAAEGkqQVBj70CLwAAOwEAQaepBUEAOgAAQbypBUEAOgAAQcypBUEANgIACyIAIABBADsBDCAAIAI2AgggACABNgIEIABBnL0CNgIAIAALcQEDfyMAQRBrIgQkAEEAIQMCQCABRQ0AIAAoAgggARCFBg0AIAAoAgQoAgQQ2QMiAygCACEFIAMsAAshBiAEIAE2AgQgBCAFIAMgBkEASBs2AgBBxL0CIAQQvQEgAiAANgIAQQEhAwsgBEEQaiQAIAML9QMCA38BfiMAQRBrIgIkAAJ+AkAgACAAKAIAKAIIEQAAIgNBBE0EQAJAAkACQAJAIANBAWsOBAABAgMFCyAAQRBqIAEQqgEzAQAMBQsgAEEQaiABELEBNQIADAQLIABBEGogARCxATUCAAwDCyAAQRBqIAEQqQEpAwAMAgtBBBAOIQBByLIFQQA2AgBBLUEsEA0hA0HIsgUoAgAhAUHIsgVBADYCAAJAAkACQAJAAkAgAUEBRwRAQciyBUEANgIAQS1BIBANIQFByLIFKAIAIQRByLIFQQA2AgAgBEEBRg0BIAIgATYCACACQpeAgICAhICAgH83AgQgAUEAOgAXIAFB8r0CKQAANwAPIAFB670CKQAANwAIIAFB470CKQAANwAAQciyBUEANgIAQTIgAyACQfu9AkHFAEGjvgIQEBpByLIFKAIAIQFByLIFQQA2AgBBASEEIAFBAUYNAiAAIAM2AgBByLIFQQA2AgBBMSAAQaDaAEEAEBJByLIFKAIAIQFByLIFQQA2AgBBACEEIAFBAUYNAgALEAYhARAHGgwDCxAGIQEQBxoMAQsQBiEBEAcaIAIsAAtBf0wEQCACKAIAEPYMCyAERQ0CCyADEPYMCyAAEBMLIAEQCAALIABBEGogARCoATEAAAshBSACQRBqJAAgBQvoAwEDfyMAQRBrIgMkAAJAAkAgACAAKAIAKAIIEQAAIgRBBE0EQAJAAkACQAJAIARBAWsOBAABAgMFCyAAIAGnQf//A3EgAhDdAQwFCyAAIAGnIAIQogMMBAsgACABpyACENcBDAMLIAAgASACEK4BDAILQQQQDiEAQciyBUEANgIAQS1BLBANIQRByLIFKAIAIQJByLIFQQA2AgACQAJAAkACQAJAIAJBAUcEQEHIsgVBADYCAEEtQSAQDSECQciyBSgCACEFQciyBUEANgIAIAVBAUYNASADIAI2AgAgA0KXgICAgISAgIB/NwIEIAJBADoAFyACQfK9AikAADcADyACQeu9AikAADcACCACQeO9AikAADcAAEHIsgVBADYCAEEyIAQgA0H7vQJB3QBBrL4CEBAaQciyBSgCACECQciyBUEANgIAQQEhBSACQQFGDQIgACAENgIAQciyBUEANgIAQTEgAEGg2gBBABASQciyBSgCACECQciyBUEANgIAQQAhBSACQQFGDQIACxAGIQIQBxoMAwsQBiECEAcaDAELEAYhAhAHGiADLAALQX9MBEAgAygCABD2DAsgBUUNAgsgBBD2DAsgABATCyACEAgACyAAIAGnQf8BcSACEK0BCyADQRBqJAAL9AMBA38jAEEQayIEJAAgACgCACIDIAJJBEBBBBAOIQBByLIFQQA2AgBBLUEwEA0hA0HIsgUoAgAhAkHIsgVBADYCAAJAAkACQAJAAkAgAkEBRwRAQciyBUEANgIAQS1BIBANIQJByLIFKAIAIQFByLIFQQA2AgAgAUEBRg0BIAQgAjYCACAEQpOAgICAhICAgH83AgQgAkEAOgATIAJBrdQCKAAANgAPIAJBptQCKQAANwAIIAJBntQCKQAANwAAQciyBUEANgIAQTAgAyAEQcQAQbLUAkH+AEHV1AIQFhpByLIFKAIAIQJByLIFQQA2AgBBASEBIAJBAUYNAiAAIAM2AgBByLIFQQA2AgBBMSAAQazdAEEAEBJByLIFKAIAIQJByLIFQQA2AgBBACEBIAJBAUYNAgALEAYhAhAHGgwDCxAGIQIQBxoMAQsQBiECEAcaIAQsAAtBf0wEQCAEKAIAEPYMCyABRQ0CCyADEPYMCyAAEBMLIAIQCAALAkAgACgCBCADRwRAIAAoAgghBQwBCyAAIANBASADQQFLG0EBdCIDNgIEIAAgACgCCCADEOoBIgU2AgggACgCACEDCyACIAVqIgVBAWogBSADIAJrEIINIAAoAgggAmogAToAACAAIAAoAgBBAWo2AgAgBEEQaiQAC+EBAQN/IwBBMGsiBCQAAkBBACAALQANIAIbDQAgACgCBCgCBBDZAyICKAIAIAIgAiwAC0EASBshBSAAQRBqIQIgACgCCCEAIAMEQCACIAMQqAEtAAAhBiAEIAIgAxCoAS0AADYCICAEIAY2AhwgBCADNgIYIAQgADYCFCAEIAU2AhBBwIwEIAFBBEG1vgIgBEEQahC/AQwBCyACQQAQqAEtAAAhAyAEIAJBABCoAS0AADYCDCAEIAM2AgggBCAANgIEIAQgBTYCAEHAjAQgAUEEQdC+AiAEEL8BCyAEQTBqJAAL4QEBA38jAEEwayIEJAACQEEAIAAtAA0gAhsNACAAKAIEKAIEENkDIgIoAgAgAiACLAALQQBIGyEFIABBEGohAiAAKAIIIQAgAwRAIAIgAxCqAS8BACEGIAQgAiADEKoBLwEANgIgIAQgBjYCHCAEIAM2AhggBCAANgIUIAQgBTYCEEHAjAQgAUEEQee+AiAEQRBqEL8BDAELIAJBABCqAS8BACEDIAQgAkEAEKoBLwEANgIMIAQgAzYCCCAEIAA2AgQgBCAFNgIAQcCMBCABQQRBgr8CIAQQvwELIARBMGokAAvhAQEDfyMAQTBrIgQkAAJAQQAgAC0ADSACGw0AIAAoAgQoAgQQ2QMiAigCACACIAIsAAtBAEgbIQUgAEEQaiECIAAoAgghACADBEAgAiADELEBKAIAIQYgBCACIAMQsQEoAgA2AiAgBCAGNgIcIAQgAzYCGCAEIAA2AhQgBCAFNgIQQcCMBCABQQRBmb8CIARBEGoQvwEMAQsgAkEAELEBKAIAIQMgBCACQQAQsQEoAgA2AgwgBCADNgIIIAQgADYCBCAEIAU2AgBBwIwEIAFBBEG0vwIgBBC/AQsgBEEwaiQAC+EBAQN/IwBBMGsiBCQAAkBBACAALQANIAIbDQAgACgCBCgCBBDZAyICKAIAIAIgAiwAC0EASBshBSAAQRBqIQIgACgCCCEAIAMEQCACIAMQsQEoAgAhBiAEIAIgAxCxASgCADYCICAEIAY2AhwgBCADNgIYIAQgADYCFCAEIAU2AhBBwIwEIAFBBEHLvwIgBEEQahC/AQwBCyACQQAQsQEoAgAhAyAEIAJBABCxASgCADYCDCAEIAM2AgggBCAANgIEIAQgBTYCAEHAjAQgAUEEQea/AiAEEL8BCyAEQTBqJAAL4wECAn8BfiMAQUBqIgQkAAJAQQAgAC0ADSACGw0AIAAoAgQoAgQQ2QMiAigCACACIAIsAAtBAEgbIQUgAEEQaiECIAAoAgghACADBEAgAiADEKkBKQMAIQYgBCACIAMQqQEpAwA3AzggBCAGNwMwIAQgAzYCKCAEIAA2AiQgBCAFNgIgQcCMBCABQQRB/b8CIARBIGoQvwEMAQsgAkEAEKkBKQMAIQYgBCACQQAQqQEpAwA3AxAgBCAGNwMIIAQgADYCBCAEIAU2AgBBwIwEIAFBBEGdwAIgBBC/AQsgBEFAayQACygBAX4gAC0ADUUEQCABIAAtABwQygMhAyAAQRBqIAIQqQEgAzcDAAsLIgAgAC0ADUUEQCABIABBEGogAhCpASkDACAALQAcEMsDCwutAgIEfwJ+IwBB4ABrIgQkAAJAQQAgAC0ADSACGw0AIAAtABwiAkECdiIFIAVFIAJBA3FBAEdyaiEFIAAoAgQoAgQQ2QMiAigCACACIAIsAAtBAEgbIQYgAEEQaiECIAAoAgghByADBEAgAiADEKkBKQMAIQggAiADEKkBKQMAIQkgBCAALQAcNgJYIAQgCTcDUCAEIAU2AkggBEFAayAINwMAIAQgAzYCOCAEIAc2AjQgBCAGNgIwQcCMBCABQQRBucACIARBMGoQvwEMAQsgAkEAEKkBKQMAIQggAkEAEKkBKQMAIQkgBCAALQAcNgIgIAQgCTcDGCAEIAU2AhAgBCAINwMIIAQgBzYCBCAEIAY2AgBBwIwEIAFBBEHiwAIgBBC/AQsgBEHgAGokAAtEAQF9IAAtAA1FBEACfSAALQAOBEAgARDAAwwBCyAALQAPBEAgARDCAwwBCyABEMQDCyEDIABBEGogAhC5AiADOAIACwtUAgF/AX0gAC0ADUUEQCAALQAOBEAgASAAQRBqIAIQuQIqAgAQwQMPCyAALQAPIQMgAEEQaiACELkCKgIAIQQgAwRAIAEgBBDDAw8LIAEgBBDFAwsLwwECAn8BfSMAQTBrIgQkAAJAQQAgAC0ADSACGw0AIAAoAgQoAgQQ2QMiAigCACACIAIsAAtBAEgbIQIgAEEQaiEFIAAoAgghACADBEAgBCAFIAMQuQIqAgC7OQMgIAQgAzYCGCAEIAA2AhQgBCACNgIQQcCMBCABQQRBh8ECIARBEGoQvwEMAQsgBUEAELkCKgIAIQYgBCAANgIEIAQgAjYCACAEIAa7OQMIQcCMBCABQQRBmcECIAQQvwELIARBMGokAAvdAgEBfyAAQgA3AhQgAEEcaiIGQgA3AgAgAEEAOwEMIAAgAjYCCCAAIAE2AgQgACAEOgARIABBADoAECAAIAM6AA8gACAFOgAOIABBsMECNgIAIABBATYCGCAGQQE2AgBByLIFQQA2AgBBvwNBAEEEEBUhBUHIsgUoAgAhA0HIsgVBADYCAAJAAkAgA0EBRg0AIAAgBTYCIEHIsgVBADYCAEHAAyAAQRhqIgVBABAVIQNByLIFKAIAIQRByLIFQQA2AgAgBEEBRwRAIANBADYCAEHIsgVBADYCAEHAAyAFQQAQFSEFQciyBSgCACEDQciyBUEANgIAIANBAUYNASAFQQA2AgAgAA8LEAYhBRAHGgwBCxAGIQUQBxoLIAAoAiAhAEHIsgVBADYCACAAEOgBQciyBSgCACEAQciyBUEANgIAIABBAUYEQEEAEAshABAHGiAAEIQBAAsgBRAIAAviAQEFfyAAQbDBAjYCAAJAAkAgACgCGCIEBEAgAEEYaiEDA0BByLIFQQA2AgBBwAMgAyABEBUhAkHIsgUoAgAhBUHIsgVBADYCACAFQQFGDQIgAigCACECQciyBUEANgIAIAIQ6AFByLIFKAIAIQJByLIFQQA2AgAgAkEBRg0CIAFBAWoiASAERw0ACwsgACgCICEBQciyBUEANgIAIAEQ6AFByLIFKAIAIQFByLIFQQA2AgAgAUEBRg0BIAAPC0EAEAshARAHGiADEIMDIAEQhAEAC0EAEAshARAHGiABEIQBAAsKACAAELEEEPYMCzoBAX8gACgCGCECIABBGGoiACABELQEIAIgAUkEQANAIAAgAhCJAkEANgIAIAJBAWoiAiABRw0ACwsLrQMBA38jAEEQayICJAAgACABNgIEIAAgATYCACABQYCAgIAETwRAQQQQDiEAQciyBUEANgIAQS1BMBANIQRByLIFKAIAIQFByLIFQQA2AgACQAJAAkACQAJAIAFBAUcEQEHIsgVBADYCAEEtQTAQDSEBQciyBSgCACEDQciyBUEANgIAIANBAUYNASACIAE2AgAgAkKggICAgIaAgIB/NwIEIAFBADoAICABQZrVAikAADcAGCABQZLVAikAADcAECABQYrVAikAADcACCABQYLVAikAADcAAEHIsgVBADYCAEEwIAQgAkHEAEGy1AJBigFBo9UCEBYaQciyBSgCACEBQciyBUEANgIAQQEhAyABQQFHBEAgACAENgIAQciyBUEANgIAQTEgAEGs3QBBABASQciyBSgCACEBQciyBUEANgIAQQAhAyABQQFHDQYLEAYhARAHGiACLAALQX9MBEAgAigCABD2DAsgAw0CDAQLEAYhARAHGgwCCxAGIQEQBxoLIAQQ9gwLIAAQEwsgARAICwALIAAgACgCCCABQQJ0EOoBNgIIIAJBEGokAAuKCQEHfyMAQbABayIDJAACQAJAAkAgAC0ADARAIANB6D42AmAgA0HUPjYCKEHIsgVBADYCAEEpIANB4ABqIgEgA0EoakEEciIEEAVByLIFKAIAIQJByLIFQQA2AgAgAkEBRg0BIANCgICAgHA3A6gBIANBsD42AmAgA0GcPjYCKEHIsgVBADYCAEEqIAQQDSEHQciyBSgCACECQciyBUEANgIAIAJBAUYEQBAGIQAQBxoMBAsgA0IANwJMIANCADcCVCADQRA2AlwgA0HMPzYCLEHIsgVBADYCAEErIANBKGpB2MECQQkQFCEFQciyBSgCACECQciyBUEANgIAAkACQAJAAkACQAJAAkACQAJAIAJBAUYNACAAKAIIIgAQiA0hAkHIsgVBADYCAEErIAUgACACEBQhAkHIsgUoAgAhAEHIsgVBADYCACAAQQFGDQBByLIFQQA2AgBBKyACQeLBAkEMEBQaQciyBSgCACEAQciyBUEANgIAIABBAUYNAEEEEA4hAkHIsgVBADYCAEEtQTAQDSEFQciyBSgCACEAQciyBUEANgIAIABBAUYNAUHIsgVBADYCAEEuIANBCGogBBAFQciyBSgCACEAQciyBUEANgIAIABBAUYNAiADKAIIIANBCGogAywAE0EASBsiBBCIDSIAQXBPBEBByLIFQQA2AgBBLyADQRhqEA9ByLIFKAIAIQBByLIFQQA2AgAgAEEBRg0EDAwLAkACQCAAQQtPBEBByLIFQQA2AgBBLSAAQRBqQXBxIggQDSEGQciyBSgCACEJQciyBUEANgIAIAlBAUYNBiADIAY2AhggAyAANgIcIAMgCEGAgICAeHI2AiAMAQsgAyAAOgAjIANBGGohBiAARQ0BCyAGIAQgABCADRoLIAAgBmpBADoAAEHIsgVBADYCAEEwIAUgA0EYakECQfu9AkHmAkGsvgIQFhpByLIFKAIAIQBByLIFQQA2AgBBASEEIABBAUcEQCACIAU2AgBByLIFQQA2AgBBMSACQazdAEEAEBJByLIFKAIAIQBByLIFQQA2AgBBACEEIABBAUcNDAsQBiEAEAcaIAMsACNBf0wEQCADKAIYEPYMCyADLAATQQBIDQQMBQsQBiEAEAcaDAcLEAYhABAHGgwFCxAGIQAQBxoMAwsQBiEAEAcaQQEhBCADLAATQQBODQILIAMoAggQ9gwLIARFDQILIAUQ9gwLIAIQEwsgA0GwPjYCYCADQZw+NgIoIANBzD82AiwgAywAV0F/TARAIAMoAkwQ9gwLIAcQ4AYaIAEQ3AYgABAIAAsgAEEYaiIEIAIQiQIoAgAQ6AECQCAAKAIUIgcEQCAHQQFqIgYgB08EQCAGEOMBIgVBACAGEIENGgsgBCACEIkCIAU2AgAgAUUNASAEIAIQiQIoAgAgASAAKAIUEIgGDAELIAEEQCABEIgNQQFqEOMBIgAgARCHBiAEIAIQiQIgADYCAAwBCyAEIAIQiQJBADYCAAsgA0GwAWokAA8LEAYhABAHGgwBCwALIAEQ3AYgABAIAAvmAQEFfwJAIAAtAA0NAAJ/IAJBAWogAC0ADkUNABpBACECIAAgACgCACgCDBEAAAshBiACIAZPDQAgAEEYaiEHA0AgByACEIkCIgQoAgAQ6AEgBEEANgIAAkAgAC0ADwRAIAQgAUECQQEgAC0AERsgAC0AECAALQAUEMgDNgIADAELIAAoAhQiAwRAAn8gA0EBaiIFIANJBEBBACEDQX8MAQsgBRDjASIDQQAgBRCBDRogACgCFAshBSAEIAM2AgAgASADIAVBABCzAwwBCyAEIAEQxgM2AgALIAJBAWoiAiAGRw0ACwsLpgEBBH8CQCAALQANDQACfyACQQFqIAAtAA5FDQAaQQAhAiAAIAAoAgAoAgwRAAALIQQgAiAETw0AIABBGGohBQNAIAUgAhCJAiEDAkAgAC0ADwRAIAEgAygCAEECQQEgAC0AERsgAC0AECAAKAIUEMkDDAELIAMoAgAhAyAAKAIUIgYEQCABIAMgBhC1AwwBCyABIAMQxwMLIAJBAWoiAiAERw0ACwsLhgQBCH8jAEHwAGsiBCQAAkBBACAALQANIAIbDQAgAC0ADkUEQAJAIAMEQCAEIAM2AhAgBEHQAGpBIEHvwQIgBEEQahCVBhoMAQsgBEEAOgBQCyAALQARIQUgACgCBCgCBBDZAyICKAIAIQYgAiwACyEHIAAoAgghCCAEIABBGGogAxCJAigCADYCDCAEIAg2AgQgBCAGIAIgB0EASBs2AgAgBCAEQdAAajYCCEHAjAQgAUEEQfTBAkGFwgIgBRsgBBC/AQwBC0HIjAQoAgAoAgBBBU4EQCAAIAAoAgAoAgwRAAAhCSAAKAIEKAIEENkDIgIoAgAhAyACLAALIQUgACgCCCEGIAQgCTYCOCAEIAY2AjQgBCADIAIgBUEASBs2AjBBwIwEIAFBBUGVwgIgBEEwahC/ASAJRQ0BIABBGGohCkEAIQIDQCAKIAIQiQIhBSAALQARIQYgACgCBCgCBBDZAyIDKAIAIQcgAywACyEIIAAoAgghCyAEIAUoAgA2AiwgBCACNgIoIAQgCzYCJCAEIAcgAyAIQQBIGzYCIEHAjAQgAUEFQajCAkG7wgIgBhsgBEEgahC/ASACQQFqIgIgCUcNAAsMAQsgBCAAKAIEKAIEENkDIgAoAgAgACAALAALQQBIGzYCQEHAjAQgAUEEQc3CAiAEQUBrEL8BCyAEQfAAaiQAC5AFAQJ/IABBKGoiBUIANwIAIABCADcCICAAQQA7AQwgACACNgIIIAAgATYCBCAAIAQ2AhQgAEEANgIQIABB+MICNgIAIABCADcCGCAFQQE2AgAgAEEBNgIkQciyBUEANgIAQb8DQQBBBBAVIQRByLIFKAIAIQFByLIFQQA2AgACQAJAIAFBAUYNACAAQoGAgIAQNwIYIAAgBDYCLCAAKAIgIQRByLIFQQA2AgBBvwMgBEEEEBUhBEHIsgUoAgAhAUHIsgVBADYCACABQQFGDQAgACAENgIgQciyBUEANgIAQcEDIABBJGoiAUEAEBUhBEHIsgUoAgAhAkHIsgVBADYCAAJAIAJBAUYNACAEQQA2AgAgACgCFCEEQciyBUEANgIAQfsAIABBGGoiAkEAEBUhBUHIsgUoAgAhBkHIsgVBADYCACAGQQFGDQAgBSAENgIAQQAhBCADBEBByLIFQQA2AgBBwgMgAxANIQRByLIFKAIAIQVByLIFQQA2AgAgBUEBRg0CIARBACADEIENGgtByLIFQQA2AgBBwQMgAUEAEBUhAUHIsgUoAgAhBUHIsgVBADYCACAFQQFGDQEgASAENgIAQciyBUEANgIAQfsAIAJBABAVIQRByLIFKAIAIQFByLIFQQA2AgAgAUEBRg0BIAQgAzYCACAADwsQBiEEEAcaDAELEAYhBBAHGgsgACgCLCEDQciyBUEANgIAIAMQ6AFByLIFKAIAIQNByLIFQQA2AgACQCADQQFHBEAgACgCICEAQciyBUEANgIAIAAQ6AFByLIFKAIAIQBByLIFQQA2AgAgAEEBRg0BIAQQCAALQQAQCyEAEAcaIAAQhAEAC0EAEAshABAHGiAAEIQBAAuqAgEFfyAAQfjCAjYCAAJAAkACQCAAKAIkIgQEQCAAQSRqIQMDQEHIsgVBADYCAEHBAyADIAEQFSECQciyBSgCACEFQciyBUEANgIAIAVBAUYNAiACKAIAIQJByLIFQQA2AgAgAhDoAUHIsgUoAgAhAkHIsgVBADYCACACQQFGDQIgAUEBaiIBIARHDQALCyAAKAIsIQFByLIFQQA2AgAgARDoAUHIsgUoAgAhAUHIsgVBADYCACABQQFGDQEgACgCICEBQciyBUEANgIAIAEQ6AFByLIFKAIAIQFByLIFQQA2AgAgAUEBRg0CIAAPC0EAEAshARAHGiADEIMDIABBGGoQgwMgARCEAQALQQAQCyEBEAcaIAEQhAEAC0EAEAshARAHGiABEIQBAAsKACAAELoEEPYMC1kBBH8gACgCJCECIABBJGoiAyABEL0EIABBGGoiBCABEL4EIAIgAUkEQANAIAMgAhCwAUEANgIAIAAoAhQhBSAEIAIQsQEgBTYCACACQQFqIgIgAUcNAAsLC60DAQN/IwBBEGsiAiQAIAAgATYCBCAAIAE2AgAgAUGAgICABE8EQEEEEA4hAEHIsgVBADYCAEEtQTAQDSEEQciyBSgCACEBQciyBUEANgIAAkACQAJAAkACQCABQQFHBEBByLIFQQA2AgBBLUEwEA0hAUHIsgUoAgAhA0HIsgVBADYCACADQQFGDQEgAiABNgIAIAJCoICAgICGgICAfzcCBCABQQA6ACAgAUGa1QIpAAA3ABggAUGS1QIpAAA3ABAgAUGK1QIpAAA3AAggAUGC1QIpAAA3AABByLIFQQA2AgBBMCAEIAJBxABBstQCQYwBQaPVAhAWGkHIsgUoAgAhAUHIsgVBADYCAEEBIQMgAUEBRwRAIAAgBDYCAEHIsgVBADYCAEExIABBrN0AQQAQEkHIsgUoAgAhAUHIsgVBADYCAEEAIQMgAUEBRw0GCxAGIQEQBxogAiwAC0F/TARAIAIoAgAQ9gwLIAMNAgwECxAGIQEQBxoMAgsQBiEBEAcaCyAEEPYMCyAAEBMLIAEQCAsACyAAIAAoAgggAUECdBDqATYCCCACQRBqJAALrQMBA38jAEEQayICJAAgACABNgIEIAAgATYCACABQYCAgIAETwRAQQQQDiEAQciyBUEANgIAQS1BMBANIQRByLIFKAIAIQFByLIFQQA2AgACQAJAAkACQAJAIAFBAUcEQEHIsgVBADYCAEEtQTAQDSEBQciyBSgCACEDQciyBUEANgIAIANBAUYNASACIAE2AgAgAkKggICAgIaAgIB/NwIEIAFBADoAICABQZrVAikAADcAGCABQZLVAikAADcAECABQYrVAikAADcACCABQYLVAikAADcAAEHIsgVBADYCAEEwIAQgAkHEAEGy1AJBggFBo9UCEBYaQciyBSgCACEBQciyBUEANgIAQQEhAyABQQFHBEAgACAENgIAQciyBUEANgIAQTEgAEGs3QBBABASQciyBSgCACEBQciyBUEANgIAQQAhAyABQQFHDQYLEAYhARAHGiACLAALQX9MBEAgAigCABD2DAsgAw0CDAQLEAYhARAHGgwCCxAGIQEQBxoLIAQQ9gwLIAAQEwsgARAICwALIAAgACgCCCABQQJ0EOoBNgIIIAJBEGokAAv5EgEGfyMAQbABayIEJAACQAJAAkACQAJAAkACQAJAAkACQAJAIAAtAAwEQCAEQeg+NgJgIARB1D42AihByLIFQQA2AgBBKSAEQeAAaiICIARBKGpBBHIiARAFQciyBSgCACEDQciyBUEANgIAIANBAUYNASAEQoCAgIBwNwOoASAEQbA+NgJgIARBnD42AihByLIFQQA2AgBBKiABEA0hBkHIsgUoAgAhA0HIsgVBADYCACADQQFGBEAQBiEAEAcaDAwLIARCADcCTCAEQgA3AlQgBEEQNgJcIARBzD82AixByLIFQQA2AgBBKyAEQShqQdjBAkEJEBQhB0HIsgUoAgAhA0HIsgVBADYCAAJAAkACQAJAAkACQAJAAkACQCADQQFGDQAgACgCCCIAEIgNIQNByLIFQQA2AgBBKyAHIAAgAxAUIQNByLIFKAIAIQBByLIFQQA2AgAgAEEBRg0AQciyBUEANgIAQSsgA0HiwQJBDBAUGkHIsgUoAgAhAEHIsgVBADYCACAAQQFGDQBBBBAOIQNByLIFQQA2AgBBLUEwEA0hB0HIsgUoAgAhAEHIsgVBADYCACAAQQFGDQFByLIFQQA2AgBBLiAEQQhqIAEQBUHIsgUoAgAhAEHIsgVBADYCACAAQQFGDQIgBCgCCCAEQQhqIAQsABNBAEgbIgEQiA0iAEFwTwRAQciyBUEANgIAQS8gBEEYahAPQciyBSgCACEAQciyBUEANgIAIABBAUYNBAwUCwJAAkAgAEELTwRAQciyBUEANgIAQS0gAEEQakFwcSIJEA0hBUHIsgUoAgAhCEHIsgVBADYCACAIQQFGDQYgBCAFNgIYIAQgADYCHCAEIAlBgICAgHhyNgIgDAELIAQgADoAIyAEQRhqIQUgAEUNAQsgBSABIAAQgA0aCyAAIAVqQQA6AABByLIFQQA2AgBBMCAHIARBGGpBAkH7vQJBkARBrL4CEBYaQciyBSgCACEAQciyBUEANgIAQQEhASAAQQFHBEAgAyAHNgIAQciyBUEANgIAQTEgA0Gs3QBBABASQciyBSgCACEAQciyBUEANgIAQQAhASAAQQFHDRQLEAYhABAHGiAELAAjQX9MBEAgBCgCGBD2DAsgBCwAE0EASA0EDAULEAYhABAHGgwHCxAGIQAQBxoMBQsQBiEAEAcaDAMLEAYhABAHGkEBIQEgBCwAE0EATg0CCyAEKAIIEPYMCyABRQ0CCyAHEPYMCyADEBMLIARBsD42AmAgBEGcPjYCKCAEQcw/NgIsIAQsAFdBf0wEQCAEKAJMEPYMCyAGEOAGGiACENwGIAAQCAALAkAgACgCECIGBEAgBiACSQRAIARB6D42AmAgBEHUPjYCKEHIsgVBADYCAEEpIARB4ABqIgEgBEEoakEEciIGEAVByLIFKAIAIQNByLIFQQA2AgAgA0EBRg0EIARCgICAgHA3A6gBIARBsD42AmAgBEGcPjYCKEHIsgVBADYCAEEqIAYQDSEHQciyBSgCACEDQciyBUEANgIAIANBAUYEQBAGIQAQBxoMDAsgBEIANwJMIARCADcCVCAEQRA2AlwgBEHMPzYCLCAAKAIEQShqIgMQiA0hBUHIsgVBADYCAEErIARBKGogAyAFEBQhBUHIsgUoAgAhA0HIsgVBADYCAAJAAkACQCADQQFGDQBByLIFQQA2AgBBKyAFQaDDAkEBEBQhBUHIsgUoAgAhA0HIsgVBADYCACADQQFGDQAgACgCCCIDEIgNIQhByLIFQQA2AgBBKyAFIAMgCBAUIQVByLIFKAIAIQNByLIFQQA2AgAgA0EBRg0AQciyBUEANgIAQSsgBUGiwwJBDBAUIQVByLIFKAIAIQNByLIFQQA2AgAgA0EBRg0AQciyBUEANgIAQSwgBSACEBUhAkHIsgUoAgAhA0HIsgVBADYCACADQQFGDQBByLIFQQA2AgBBKyACQa/DAkEaEBQhAkHIsgUoAgAhA0HIsgVBADYCACADQQFGDQAgACgCECEAQciyBUEANgIAQSwgAiAAEBUaQciyBSgCACEAQciyBUEANgIAIABBAUYNAEEEEA4hA0HIsgVBADYCAEEtQSwQDSECQciyBSgCACEAQciyBUEANgIAIABBAUYNAUHIsgVBADYCAEEuIARBCGogBhAFQciyBSgCACEAQciyBUEANgIAIABBAUYNAiAEKAIIIARBCGogBCwAE0EASBsiBhCIDSIAQXBPBEBByLIFQQA2AgBBLyAEQRhqEA9ByLIFKAIAIQBByLIFQQA2AgAgAEEBRw0QDAkLAkACQCAAQQtPBEBByLIFQQA2AgBBLSAAQRBqQXBxIgkQDSEFQciyBSgCACEIQciyBUEANgIAIAhBAUYNCyAEIAU2AhggBCAANgIcIAQgCUGAgICAeHI2AiAMAQsgBCAAOgAjIARBGGohBSAARQ0BCyAFIAYgABCADRoLIAAgBWpBADoAAEHIsgVBADYCAEEyIAIgBEEYakH7vQJBlgRBrL4CEBAaQciyBSgCACEAQciyBUEANgIAQQEhBiAAQQFHBEAgAyACNgIAQciyBUEANgIAQTEgA0Gg2gBBABASQciyBSgCACEAQciyBUEANgIAQQAhBiAAQQFHDRALEAYhABAHGiAELAAjQX9MBEAgBCgCGBD2DAsgBCwAE0EATg0KDAkLEAYhABAHGgwMCxAGIQAQBxoMCgsQBiEAEAcaDAgLIABBJGoiBiADELABKAIARQRAIAAoAhAiBwRAIAcQ4wEiBUEAIAcQgQ0aCyAGIAMQsAEgBTYCACAAKAIQIQcgAEEYaiADELEBIAc2AgALIAFFDQEgBiADELABKAIAIAEgAhCADRoMAQsgAEEkaiIGIAMQsAEoAgAQ6AEgAQRAIAIQ4wEhByAGIAMQsAEgBzYCACAGIAMQsAEoAgAgASACEIANGiAAQRhqIAMQsQEgAjYCAAwBCyAGIAMQsAFBADYCACAAQRhqIAMQsQFBADYCAAsgBEGwAWokAA8LEAYhABAHGgwJCxAGIQAQBxoMBgsQBiEAEAcaQQEhBiAELAATQQBODQILIAQoAggQ9gwLIAZFDQILIAIQ9gwLIAMQEwsgBEGwPjYCYCAEQZw+NgIoIARBzD82AiwgBCwAV0F/TARAIAQoAkwQ9gwLIAcQ4AYaIAEQ3AYgABAIAAsgARDcBiAAEAgACwALIAIQ3AYgABAIAAvdAwEDfyMAQRBrIgQkACAAKAIQBEBBBBAOIQBByLIFQQA2AgBBLUEsEA0hAUHIsgUoAgAhAkHIsgVBADYCAAJAAkACQAJAAkAgAkEBRwRAQciyBUEANgIAQS1BMBANIQJByLIFKAIAIQNByLIFQQA2AgAgA0EBRg0BIAQgAjYCACAEQqmAgICAhoCAgH83AgQgAkEAOgApIAJB8sMCLQAAOgAoIAJB6sMCKQAANwAgIAJB4sMCKQAANwAYIAJB2sMCKQAANwAQIAJB0sMCKQAANwAIIAJBysMCKQAANwAAQciyBUEANgIAQTIgASAEQfu9AkGwBEH0wwIQEBpByLIFKAIAIQJByLIFQQA2AgBBASEDIAJBAUYNAiAAIAE2AgBByLIFQQA2AgBBMSAAQaDaAEEAEBJByLIFKAIAIQJByLIFQQA2AgBBACEDIAJBAUYNAgALEAYhAhAHGgwDCxAGIQIQBxoMAQsQBiECEAcaIAQsAAtBf0wEQCAEKAIAEPYMCyADRQ0CCyABEPYMCyAAEBMLIAIQCAALIABBJGoiAyACELABKAIABEAgAyACELABKAIAIAEQ6gEhBSADIAIQsAEgBTYCAAsgAEEYaiACELEBIAE2AgAgBEEQaiQAC0UBAX8gAEEANgIQIAAgACgCACgCDBEAAARAA0AgACABIAIQwAQgAkEBaiICIAAgACgCACgCDBEAAEkNAAsLIAAgATYCEAtaAQJ/IAAtAA1FBEAgAEEkaiIDIAIQsAEoAgAQ6AEgAEEYaiIAIAIQsQEoAgAQ4wEhBCADIAIQsAEgBDYCACABIAMgAhCwASgCACAAIAIQsQEoAgBBABCzAwsLKgAgAC0ADUUEQCABIABBJGogAhCwASgCACAAQRhqIAIQsQEoAgAQtQMLC+4XAQx/IwBB8AJrIgQkAAJAAkACQAJAAkACQEEAIAAtAA0gAhsNACAAQRhqIAMQsQEoAgAhByAAQSRqIAMQsAEhAyAHRQRAIAAoAgQoAgQQ2QMiAygCACECIAMsAAshBiAEIAAoAgg2AgQgBEEANgIIIAQgAiADIAZBAEgbNgIAQcCMBCABQQVBgcQCIAQQvwEMAQsgAygCACEMAkACQAJAAkACQCAHQRBNBEAgBEHoPjYCoAIgBEHUPjYC6AFByLIFQQA2AgBBKSAEQaACaiIIIARB6AFqQQRyIgYQBUHIsgUoAgAhA0HIsgVBADYCACADQQFGDQEgBEKAgICAcDcD6AIgBEGwPjYCoAIgBEGcPjYC6AFByLIFQQA2AgBBKiAGEA0hCkHIsgUoAgAhA0HIsgVBADYCACADQQFGBEAQBiEDEAcaDAwLIARCADcCjAIgBEIANwKUAiAEQRA2ApwCIARBzD82AuwBQciyBUEANgIAIARB6D42ApgBIARB1D42AmBBKSAEQZgBaiINIARB4ABqQQRyIgkQBUHIsgUoAgAhA0HIsgVBADYCACADQQFGDQIgBEKAgICAcDcD4AEgBEGwPjYCmAEgBEGcPjYCYEHIsgVBADYCAEEqIAkQDSEPQciyBSgCACEDQciyBUEANgIAIANBAUYEQBAGIQMQBxoMCwsgBEIANwKEASAEQgA3AowBIARBEDYClAEgBEHMPzYCZEHIsgVBADYCAEErIARB6AFqQZfEAkECEBQaQciyBSgCACEDQciyBUEANgIAIANBAUYNByAEQbQCaiELIARB9AFqIQ5BACEDA0AgAwRAQciyBUEANgIAIARBIDoAUEErIARB6AFqIARB0ABqQQEQFBpByLIFKAIAIQJByLIFQQA2AgAgAkEBRg0KCyAGIAQoAugBQXRqIgIoAgBqIgUgBSgCAEG1f3FBCHI2AgAgDiACKAIAakECNgIAIAsgAigCAGpBMDYCACAGIAIoAgBqIgIgAigCAEHPfnFBgAFyNgIAIAMgDGoiAi0AACEFQciyBUEANgIAQSwgBEHoAWogBRAVGkHIsgUoAgAhBUHIsgVBADYCACAFQQFHBEAgAi0AACICEP4FIQVByLIFQQA2AgAgBCACQS4gBRs6AFBBKyAEQeAAaiAEQdAAakEBEBQaQciyBSgCACECQciyBUEANgIAIAJBAUYNCiADQQFqIgMgB0YNBwwBCwsQBiEDEAcaDAkLQQAhAgJ/QQAgACgCBCgCQCIFKAJAIgZFDQAaQQAgBkEoahCtBUG4xAIQrQVHDQAaIAVBKGoQrQVBvcQCEK0FRwshAwJAIAdBgAFJBEAgByEGDAELIAchBiADDQAgB0GAAUHIjAQoAgAoAgAiA0EEShshBiADQQVIIQILIARB6D42AqACIARB1D42AugBQciyBUEANgIAQSkgBEGgAmoiBSAEQegBakEEciIDEAVByLIFKAIAIQtByLIFQQA2AgAgC0EBRg0CIARCgICAgHA3A+gCIARBsD42AqACIARBnD42AugBQciyBUEANgIAQSogAxANIQtByLIFKAIAIQNByLIFQQA2AgAgA0EBRgRAEAYhAxAHGgwECyAEQgA3AowCIARCADcClAIgBEEQNgKcAiAEQcw/NgLsAUHIsgVBADYCACAEQeg+NgKYASAEQdQ+NgJgQSkgBEGYAWoiDiAEQeAAakEEciIDEAVByLIFKAIAIQlByLIFQQA2AgACQCAJQQFHBEAgBEKAgICAcDcD4AEgBEGwPjYCmAEgBEGcPjYCYEHIsgVBADYCAEEqIAMQDSEJQciyBSgCACEDQciyBUEANgIAIANBAUYEQBAGIQMQBxoMAgsgBEIANwKEASAEQgA3AowBIARBEDYClAEgBEHMPzYCZCAAKAIEKAIEIQNByLIFQQA2AgBB/gAgAxANIQNByLIFKAIAIQhByLIFQQA2AgACQAJAIAhBAUYNACADKAIAIQggAywACyEKIAAoAgghDUHIsgVBADYCACAEIA02AkQgBCAHNgJIIAQgCCADIApBAEgbNgJAQZADQcCMBCABQQVBgcQCIARBQGsQIkHIsgUoAgAhA0HIsgVBADYCACADQQFGDQAgACgCBCgCBCEDQciyBUEANgIAQf4AIAMQDSEDQciyBSgCACEHQciyBUEANgIAIAdBAUYNACADKAIAIQcgAywACyEIIAAoAgghCkHIsgVBADYCACAEIAo2AjQgBCAHIAMgCEEASBs2AjBBwwNBwIwEIAFBBSAMIAZBwsQCIARBMGoQIUHIsgUoAgAhA0HIsgVBADYCACADQQFGDQAgAkUNASAAKAIEKAIEIQNByLIFQQA2AgBB/gAgAxANIQNByLIFKAIAIQJByLIFQQA2AgAgAkEBRg0AIAMoAgAhAiADLAALIQZByLIFQQA2AgAgBCACIAMgBkEASBs2AiBBkANBwIwEIAFBBEHLxAIgBEEgahAiQciyBSgCACEDQciyBUEANgIAIANBAUcNAQsQBiEDEAcaIARBsD42ApgBIARBnD42AmAgBEHMPzYCZCAELACPAUF/TARAIAQoAoQBEPYMCyAJEOAGGgwCCyAEQbA+NgKYASAEQZw+NgJgIARBzD82AmQgBCwAjwFBf0wEQCAEKAKEARD2DAsgCRDgBhogDhDcBiAEQbA+NgKgAiAEQZw+NgLoASAEQcw/NgLsASAELACXAkF/TARAIAQoAowCEPYMCyALEOAGGiAFENwGDAcLEAYhAxAHGgsgDhDcBiAEQbA+NgKgAiAEQZw+NgLoASAEQcw/NgLsASAELACXAkF/TARAIAQoAowCEPYMCyALEOAGGiAFENwGIAMQCAALEAYhAxAHGgwJCxAGIQMQBxoMBwsQBiEDEAcaCyAFENwGIAMQCAALQciyBUEANgIAQSsgBEHoAWpBmsQCQQMQFCEDQciyBSgCACECQciyBUEANgIAIAJBAUYNAUHIsgVBADYCAEEuIARB0ABqIAkQBUHIsgUoAgAhAkHIsgVBADYCAAJAAkACQCACQQFHBEBByLIFQQA2AgBBKyADIAQoAlAgBEHQAGogBC0AWyICQRh0QRh1QQBIIgUbIAQoAlQgAiAFGxAUIQNByLIFKAIAIQJByLIFQQA2AgAgAkEBRg0BQciyBUEANgIAQSsgA0GexAJBARAUGkHIsgUoAgAhA0HIsgVBADYCACADQQFGDQEgBCwAW0F/TARAIAQoAlAQ9gwLIAAoAgQoAgQhA0HIsgVBADYCAEH+ACADEA0hA0HIsgUoAgAhAkHIsgVBADYCACACQQFGDQUgACgCCCECIAMoAgAhBSADLAALIQxByLIFQQA2AgBBLiAEQdAAaiAGEAVByLIFKAIAIQZByLIFQQA2AgAgBkEBRg0CQciyBUEANgIAIAQgAjYCFCAEIAc2AhggBCAFIAMgDEEASBs2AhAgBCAEKAJQIARB0ABqIAQsAFtBAEgbNgIcQZADQcCMBCABQQVBoMQCIARBEGoQIkHIsgUoAgAhA0HIsgVBADYCACADQQFGDQMgBCwAW0F/TARAIAQoAlAQ9gwLIARBsD42ApgBIARBnD42AmAgBEHMPzYCZCAELACPAUF/TARAIAQoAoQBEPYMCyAPEOAGGiANENwGIARBsD42AqACIARBnD42AugBIARBzD82AuwBIAQsAJcCQX9MBEAgBCgCjAIQ9gwLIAoQ4AYaIAgQ3AYMBAsQBiEDEAcaDAYLEAYhAxAHGiAELABbQX9KDQUgBCgCUBD2DAwFCxAGIQMQBxoMBAsQBiEDEAcaIAQsAFtBf0oNAyAEKAJQEPYMDAMLIARB8AJqJAAPCxAGIQMQBxoMAQsQBiEDEAcaCyAEQbA+NgKYASAEQZw+NgJgIARBzD82AmQgBCwAjwFBf0wEQCAEKAKEARD2DAsgDxDgBhoLIA0Q3AYgBEGwPjYCoAIgBEGcPjYC6AEgBEHMPzYC7AEgBCwAlwJBf0wEQCAEKAKMAhD2DAsgChDgBhogCBDcBiADEAgACyAIENwGIAMQCAALPgAgAEEAOwEMIAAgAjYCCCAAIAE2AgQgAEIANwIUIABB+MQCNgIAIAAgAzYCECAAQQA2AhwgA0EBOgAMIAALzAEBBH8gAEH4xAI2AgACQAJAIAAoAhQEQCAAQRRqIQMDQEHIsgVBADYCAEHmASADIAEQFSECQciyBSgCACEEQciyBUEANgIAIARBAUYNAiACKAIAIgIEQCACIAIoAgAoAgQRAQALIAFBAWoiASADKAIASQ0ACwsgACgCHCEBQciyBUEANgIAIAEQ6AFByLIFKAIAIQFByLIFQQA2AgAgAUEBRg0BIAAPC0EAEAshARAHGiADEIMDIAEQhAEAC0EAEAshARAHGiABEIQBAAsKACAAEMYEEPYMC+QJAQN/IwBBEGsiAiQAAkACQAJAIAFFBEBBBBAOIQBByLIFQQA2AgBBLUEsEA0hBEHIsgUoAgAhAUHIsgVBADYCAAJAAkAgAUEBRwRAQciyBUEANgIAQS1BIBANIQFByLIFKAIAIQNByLIFQQA2AgAgA0EBRg0BIAIgATYCACACQpuAgICAhICAgH83AgQgAUEAOgAbIAFBv8UCKAAANgAXIAFBuMUCKQAANwAQIAFBsMUCKQAANwAIIAFBqMUCKQAANwAAQciyBUEANgIAQTIgBCACQfu9AkGyBUHExQIQEBpByLIFKAIAIQFByLIFQQA2AgBBASEDIAFBAUcEQCAAIAQ2AgBByLIFQQA2AgBBMSAAQaDaAEEAEBJByLIFKAIAIQFByLIFQQA2AgBBACEDIAFBAUcNBgsQBiEBEAcaIAIsAAtBf0wEQCACKAIAEPYMCyADDQIMBAsQBiEBEAcaIAAQEwwDCxAGIQEQBxoLIAQQ9gwgABATDAELIAEgASgCACgCCBEAAEEIRgRAQQQQDiEAQciyBUEANgIAQS1BLBANIQRByLIFKAIAIQFByLIFQQA2AgACQAJAIAFBAUcEQEHIsgVBADYCAEEtQcAAEA0hAUHIsgUoAgAhA0HIsgVBADYCACADQQFGDQEgAiABNgIAIAJCt4CAgICIgICAfzcCBCABQQA6ADcgAUH/xQIpAAA3AC8gAUH4xQIpAAA3ACggAUHwxQIpAAA3ACAgAUHoxQIpAAA3ABggAUHgxQIpAAA3ABAgAUHYxQIpAAA3AAggAUHQxQIpAAA3AABByLIFQQA2AgBBMiAEIAJB+70CQbMFQcTFAhAQGkHIsgUoAgAhAUHIsgVBADYCAEEBIQMgAUEBRwRAIAAgBDYCAEHIsgVBADYCAEExIABBoNoAQQAQEkHIsgUoAgAhAUHIsgVBADYCAEEAIQMgAUEBRw0GCxAGIQEQBxogAiwAC0F/TARAIAIoAgAQ9gwLIAMNAgwECxAGIQEQBxogABATDAMLEAYhARAHGgsgBBD2DCAAEBMMAQsgASABKAIAKAIIEQAAQQlHDQJBBBAOIQBByLIFQQA2AgBBLUEsEA0hBEHIsgUoAgAhAUHIsgVBADYCAAJAAkACQCABQQFHBEBByLIFQQA2AgBBLUHAABANIQFByLIFKAIAIQNByLIFQQA2AgAgA0EBRg0BIAIgATYCACACQryAgICAiICAgH83AgQgAUEAOgA8IAFBwMYCKAAANgA4IAFBuMYCKQAANwAwIAFBsMYCKQAANwAoIAFBqMYCKQAANwAgIAFBoMYCKQAANwAYIAFBmMYCKQAANwAQIAFBkMYCKQAANwAIIAFBiMYCKQAANwAAQciyBUEANgIAQTIgBCACQfu9AkG0BUHExQIQEBpByLIFKAIAIQFByLIFQQA2AgBBASEDIAFBAUcEQCAAIAQ2AgBByLIFQQA2AgBBMSAAQaDaAEEAEBJByLIFKAIAIQFByLIFQQA2AgBBACEDIAFBAUcNBgsQBiEBEAcaIAIsAAtBf0wEQCACKAIAEPYMCyADDQIMBAsQBiEBEAcaDAILEAYhARAHGgsgBBD2DAsgABATCyABEAgLAAsgAEEUaiABIAAoAhQQiwMgAUEAIAEoAgAoAhARAgAgAkEQaiQAC+IEAQZ/IwBBIGsiBCQAIAAoAggiBkUEQEEEEA4hBUHIsgVBADYCAEEtQSwQDSEDQciyBSgCACEAQciyBUEANgIAAkACQAJAAkACQCAAQQFHBEBByLIFQQA2AgBBLUEgEA0hAEHIsgUoAgAhAkHIsgVBADYCACACQQFGDQEgBCAANgIQIARCmICAgICEgICAfzcCFCAAQQA6ABggAEHVxgIpAAA3ABAgAEHNxgIpAAA3AAggAEHFxgIpAAA3AABByLIFQQA2AgBBMiADIARBEGpB+70CQbwFQd7GAhAQGkHIsgUoAgAhAEHIsgVBADYCAEEBIQIgAEEBRg0CIAUgAzYCAEHIsgVBADYCAEExIAVBoNoAQQAQEkHIsgUoAgAhAEHIsgVBADYCAEEAIQIgAEEBRg0CAAsQBiEAEAcaDAMLEAYhABAHGgwBCxAGIQAQBxogBCwAG0F/TARAIAQoAhAQ9gwLIAJFDQILIAMQ9gwLIAUQEwsgABAIAAsCQCAGIAEQqAVFDQACQCABIARBEGoQqQUiCEUNACAEKAIQIAAgACgCACgCDBEAAE8NASADRQ0AIAMgBCgCEDYCAAsgACgCBCgCBBDZAyIGKAIAIQcgBiwACyEJIAQgATYCBCAEIAcgBiAJQQBIGzYCAEHEvQIgBBC9AQJAIAEQqgUiAUUEQCAIDQIgAiAANgIADAELIAAoAhQiBkUNASAAQRRqIQcDQCAHIAUQrAEoAgAiACABIAIgAyAAKAIAKAIkEQoADQEgBUEBaiIFIAZHDQALQQAhBQwBC0EBIQULIARBIGokACAFC7AEAQV/IwBBIGsiBCQAIAIEQEEEEA4hAkHIsgVBADYCAEEtQSwQDSEFQciyBSgCACEDQciyBUEANgIAAkACQAJAAkACQCADQQFHBEBByLIFQQA2AgBBLUEgEA0hA0HIsgUoAgAhAEHIsgVBADYCACAAQQFGDQEgBCADNgIQIARCnICAgICEgICAfzcCFCADQQA6ABwgA0GDxwIoAAA2ABggA0H7xgIpAAA3ABAgA0HzxgIpAAA3AAggA0HrxgIpAAA3AABByLIFQQA2AgBBMiAFIARBEGpB+70CQe8FQYjHAhAQGkHIsgUoAgAhA0HIsgVBADYCAEEBIQAgA0EBRg0CIAIgBTYCAEHIsgVBADYCAEExIAJBoNoAQQAQEkHIsgUoAgAhA0HIsgVBADYCAEEAIQAgA0EBRg0CAAsQBiEDEAcaDAMLEAYhAxAHGgwBCxAGIQMQBxogBCwAG0F/TARAIAQoAhAQ9gwLIABFDQILIAUQ9gwLIAIQEwsgAxAIAAsCQCAALQANDQAgACgCFCIGRQRAIARB+AU2AgggBEH7vQI2AgQgBEGrxwI2AgBBwIwEQY3HAiAEELoBDAELIABBFGohB0EAIQIgACAAKAIAKAIMEQAAIQUDQCAHIAIQrAEoAgAiAyAFIAMoAgAoAhARAgAgAkEBaiICIAZHDQALIAVFDQBBACECA0AgACABIAIgACgCACgCKBEFACACQQFqIgIgBUcNAAsLIARBIGokAAtEAQJ/IAAoAhQEQCAAQRRqIQNBACEAA0AgAyAAEKwBKAIAIgQgASACIAQoAgAoAhgRBQAgAEEBaiIAIAMoAgBJDQALCwv3CAEJfyMAQUBqIgMkAAJAAkAgAgRAQQQQDiECQciyBUEANgIAQS1BLBANIQFByLIFKAIAIQBByLIFQQA2AgACQAJAAkACQCAAQQFHBEBByLIFQQA2AgBBLUEgEA0hAEHIsgUoAgAhBEHIsgVBADYCACAEQQFGDQEgAyAANgIwIANCnICAgICEgICAfzcCNCAAQQA6ABwgAEGDxwIoAAA2ABggAEH7xgIpAAA3ABAgAEHzxgIpAAA3AAggAEHrxgIpAAA3AABByLIFQQA2AgBBMiABIANBMGpB+70CQZEGQb7HAhAQGkHIsgUoAgAhAEHIsgVBADYCAEEBIQQgAEEBRg0CIAIgATYCAEHIsgVBADYCAEExIAJBoNoAQQAQEkHIsgUoAgAhAEHIsgVBADYCAEEAIQQgAEEBRg0CDAcLEAYhABAHGgwDCxAGIQAQBxoMAQsQBiEAEAcaIAMsADtBf0wEQCADKAIwEPYMCyAERQ0DCyABEPYMCyACEBMMAQsCQCAALQANDQAgACgCFEUEQCADQZoGNgIIIANB+70CNgIEIANBq8cCNgIAQcCMBEGNxwIgAxC6AQwBCwJAIAAgACgCACgCDBEAACIEIABBFGoiAkEAEKwBKAIAIgUgBSgCACgCDBEAAEYNACAAKAIEKAIEENkDIgUoAgAhByAFLAALIQggACgCBCEJIAAoAgghCiACQQAQrAEoAgAoAgghCyACQQAQrAEoAgAiBiAGKAIAKAIMEQAAIQYgAyAENgIoIAMgBjYCJCADIAs2AiAgAyAKNgIcIAMgCUEoajYCGCADIAcgBSAIQQBIGzYCFCADQb7HAjYCEEHAjARBxMcCIANBEGoQugEgAkEAEKwBKAIAIgIgAigCACgCDBEAACAERg0AQQQQDiEBQciyBUEANgIAQS1BLBANIQRByLIFKAIAIQJByLIFQQA2AgACQAJAAkAgAkEBRwRAQciyBUEANgIAQS1BwAAQDSECQciyBSgCACEAQciyBUEANgIAIABBAUYNASADIAI2AjAgA0K8gICAgIiAgIB/NwI0IAJBADoAPCACQbjIAigAADYAOCACQbDIAikAADcAMCACQajIAikAADcAKCACQaDIAikAADcAICACQZjIAikAADcAGCACQZDIAikAADcAECACQYjIAikAADcACCACQYDIAikAADcAAEHIsgVBADYCAEEyIAQgA0EwakH7vQJBpwZBvscCEBAaQciyBSgCACEAQciyBUEANgIAQQEhAiAAQQFHBEAgASAENgIAQciyBUEANgIAQTEgAUGg2gBBABASQciyBSgCACEAQciyBUEANgIAQQAhAiAAQQFHDQgLEAYhABAHGiADLAA7QX9MBEAgAygCMBD2DAsgAkUNBgwCCxAGIQAQBxoMAgsQBiEAEAcaCyAEEPYMCyABEBMgABAIAAsgBEUNAEEAIQIDQCAAIAEgAiAAKAIAKAIsEQUAIAJBAWoiAiAERw0ACwsgA0FAayQADwsgABAIAAsAC0QBAn8gACgCFARAIABBFGohA0EAIQADQCADIAAQrAEoAgAiBCABIAIgBCgCACgCHBEFACAAQQFqIgAgAygCAEkNAAsLC6gEAQV/IwBBIGsiBCQAIAMEQEEEEA4hAEHIsgVBADYCAEEtQSwQDSEFQciyBSgCACEDQciyBUEANgIAAkACQAJAAkACQCADQQFHBEBByLIFQQA2AgBBLUEgEA0hA0HIsgUoAgAhAkHIsgVBADYCACACQQFGDQEgBCADNgIQIARCnICAgICEgICAfzcCFCADQQA6ABwgA0GDxwIoAAA2ABggA0H7xgIpAAA3ABAgA0HzxgIpAAA3AAggA0HrxgIpAAA3AABByLIFQQA2AgBBMiAFIARBEGpB+70CQbkGQb3IAhAQGkHIsgUoAgAhA0HIsgVBADYCAEEBIQIgA0EBRg0CIAAgBTYCAEHIsgVBADYCAEExIABBoNoAQQAQEkHIsgUoAgAhA0HIsgVBADYCAEEAIQIgA0EBRg0CAAsQBiEDEAcaDAMLEAYhAxAHGgwBCxAGIQMQBxogBCwAG0F/TARAIAQoAhAQ9gwLIAJFDQILIAUQ9gwLIAAQEwsgAxAIAAsCQCAALQANDQAgACgCFCIGRQRAIARBwwY2AgggBEH7vQI2AgQgBEGrxwI2AgBBwIwEQY3HAiAEELoBDAELIAAgACgCACgCDBEAACIHRQ0AIABBFGohCCABQQFqQf8BcSEBA0BBACEAA0AgCCAAEKwBKAIAIgMgASACIAUgAygCACgCIBEHACAAQQFqIgAgBkcNAAsgBUEBaiIFIAdHDQALCyAEQSBqJAALWAAgAEEAOwEMIAAgAjYCCCAAIAE2AgQgAEIANwIcIABBzMgCNgIAIAAgBjoAGSAAIAU6ABggAEIANwMQIAAgAzoADiAAQQA2AiQgACAEIAMgBBs6AA8gAAvMAQEEfyAAQczIAjYCAAJAAkAgACgCHARAIABBHGohAwNAQciyBUEANgIAQcQDIAMgARAVIQJByLIFKAIAIQRByLIFQQA2AgAgBEEBRg0CIAIoAgAiAgRAIAIgAigCACgCBBEBAAsgAUEBaiIBIAMoAgBJDQALCyAAKAIkIQFByLIFQQA2AgAgARDoAUHIsgUoAgAhAUHIsgVBADYCACABQQFGDQEgAA8LQQAQCyEBEAcaIAMQgwMgARCEAQALQQAQCyEBEAcaIAEQhAEAC64IAQh/IwBBsAFrIgIkAAJAAkACQCAAKAIAIAFNBEAgAkHoPjYCYCACQdQ+NgIoQciyBUEANgIAQSkgAkHgAGoiBiACQShqQQRyIgQQBUHIsgUoAgAhA0HIsgVBADYCACADQQFGDQEgAkKAgICAcDcDqAEgAkGwPjYCYCACQZw+NgIoQciyBUEANgIAQSogBBANIQdByLIFKAIAIQNByLIFQQA2AgAgA0EBRgRAEAYhARAHGgwECyACQgA3AkwgAkIANwJUIAJBEDYCXCACQcw/NgIsQciyBUEANgIAQSsgAkEoakHc1AJBFRAUIQVByLIFKAIAIQNByLIFQQA2AgACQAJAAkACQAJAAkACQAJAAkAgA0EBRg0AQciyBUEANgIAQSwgBSABEBUhA0HIsgUoAgAhAUHIsgVBADYCACABQQFGDQBByLIFQQA2AgBBKyADQfLUAkEEEBQhA0HIsgUoAgAhAUHIsgVBADYCACABQQFGDQAgACgCACEBQciyBUEANgIAQSwgAyABEBUaQciyBSgCACEBQciyBUEANgIAIAFBAUYNAEEEEA4hAEHIsgVBADYCAEEtQTAQDSEDQciyBSgCACEBQciyBUEANgIAIAFBAUYNAUHIsgVBADYCAEEuIAJBCGogBBAFQciyBSgCACEBQciyBUEANgIAIAFBAUYNAiACKAIIIAJBCGogAiwAE0EASBsiBBCIDSIBQXBPBEBByLIFQQA2AgBBLyACQRhqEA9ByLIFKAIAIQFByLIFQQA2AgAgAUEBRg0EDAwLAkACQCABQQtPBEBByLIFQQA2AgBBLSABQRBqQXBxIggQDSEFQciyBSgCACEJQciyBUEANgIAIAlBAUYNBiACIAU2AhggAiABNgIcIAIgCEGAgICAeHI2AiAMAQsgAiABOgAjIAJBGGohBSABRQ0BCyAFIAQgARCADRoLIAEgBWpBADoAAEHIsgVBADYCAEEwIAMgAkEYakHEAEH40wJBIUH31AIQFhpByLIFKAIAIQFByLIFQQA2AgBBASEEIAFBAUcEQCAAIAM2AgBByLIFQQA2AgBBMSAAQazdAEEAEBJByLIFKAIAIQFByLIFQQA2AgBBACEEIAFBAUcNDAsQBiEBEAcaIAIsACNBf0wEQCACKAIYEPYMCyACLAATQQBIDQQMBQsQBiEBEAcaDAcLEAYhARAHGgwFCxAGIQEQBxoMAwsQBiEBEAcaQQEhBCACLAATQQBODQILIAIoAggQ9gwLIARFDQILIAMQ9gwLIAAQEwsgAkGwPjYCYCACQZw+NgIoIAJBzD82AiwgAiwAV0F/TARAIAIoAkwQ9gwLIAcQ4AYaIAYQ3AYgARAIAAsgACgCCCEAIAJBsAFqJAAgACABQQJ0ag8LEAYhARAHGgwBCwALIAYQ3AYgARAIAAsKACAAENAEEPYMC8kGAQN/IwBBEGsiAiQAAkACQAJAAkAgAC0ADiABTQRAIAAtAA8gAU8NAQtBBBAOIQFByLIFQQA2AgBBLUEsEA0hBEHIsgUoAgAhAEHIsgVBADYCAAJAAkAgAEEBRwRAQciyBUEANgIAQS1BwAAQDSEAQciyBSgCACEDQciyBUEANgIAIANBAUYNASACIAA2AgAgAkK4gICAgIiAgIB/NwIEIABBADoAOCAAQajJAikAADcAMCAAQaDJAikAADcAKCAAQZjJAikAADcAICAAQZDJAikAADcAGCAAQYjJAikAADcAECAAQYDJAikAADcACCAAQfjIAikAADcAAEHIsgVBADYCAEEyIAQgAkH7vQJB5gZBsckCEBAaQciyBSgCACEAQciyBUEANgIAQQEhAyAAQQFHBEAgASAENgIAQciyBUEANgIAQTEgAUGg2gBBABASQciyBSgCACEAQciyBUEANgIAQQAhAyAAQQFHDQYLEAYhABAHGiACLAALQX9MBEAgAigCABD2DAsgAw0CDAQLEAYhABAHGiABEBMMAwsQBiEAEAcaCyAEEPYMIAEQEwwBCyAAIAAoAgQgASAAKAIAKAIoEQQAIgENAkEEEA4hAUHIsgVBADYCAEEtQSwQDSEEQciyBSgCACEAQciyBUEANgIAAkACQAJAIABBAUcEQEHIsgVBADYCAEEtQSAQDSEAQciyBSgCACEDQciyBUEANgIAIANBAUYNASACIAA2AgAgAkKdgICAgISAgIB/NwIEIABBADoAHSAAQdTJAikAADcAFSAAQc/JAikAADcAECAAQcfJAikAADcACCAAQb/JAikAADcAAEHIsgVBADYCAEEyIAQgAkH7vQJB6QZBsckCEBAaQciyBSgCACEAQciyBUEANgIAQQEhAyAAQQFHBEAgASAENgIAQciyBUEANgIAQTEgAUGg2gBBABASQciyBSgCACEAQciyBUEANgIAQQAhAyAAQQFHDQYLEAYhABAHGiACLAALQX9MBEAgAigCABD2DAsgAw0CDAQLEAYhABAHGgwCCxAGIQAQBxoLIAQQ9gwLIAEQEwsgABAICwALIABBHGogASAAKAIcENQEIAJBEGokACABC/4DAQR/IwBBEGsiBCQAIAAoAgAiAyACSQRAQQQQDiEAQciyBUEANgIAQS1BMBANIQJByLIFKAIAIQNByLIFQQA2AgACQAJAAkACQAJAIANBAUcEQEHIsgVBADYCAEEtQSAQDSEDQciyBSgCACEBQciyBUEANgIAIAFBAUYNASAEIAM2AgAgBEKTgICAgISAgIB/NwIEIANBADoAEyADQa3UAigAADYADyADQabUAikAADcACCADQZ7UAikAADcAAEHIsgVBADYCAEEwIAIgBEHEAEH40wJBIUHV1AIQFhpByLIFKAIAIQNByLIFQQA2AgBBASEBIANBAUYNAiAAIAI2AgBByLIFQQA2AgBBMSAAQazdAEEAEBJByLIFKAIAIQNByLIFQQA2AgBBACEBIANBAUYNAgALEAYhAxAHGgwDCxAGIQMQBxoMAQsQBiEDEAcaIAQsAAtBf0wEQCAEKAIAEPYMCyABRQ0CCyACEPYMCyAAEBMLIAMQCAALAkAgACgCBCADRwRAIAAoAgghBQwBCyAAIANBASADQQFLGyIDQQF0NgIEIAAgACgCCCADQQN0EOoBIgU2AgggACgCACEDCyAFIAJBAnQiBmoiBUEEaiAFIAMgAmtBAnQQgg0gACgCCCAGaiABNgIAIAAgACgCAEEBajYCACAEQRBqJAALLAACQCAALQAYRQ0AIAAtABlFDQAgACAALQAOENMEIgAgACgCACgCCBEBAAsL0AIBBn8jAEEQayIFJAACQAJAAkACQCAAKAIIIgYEQCAGLQAADQELIAAoAhxFDQMgAEEcaiEAA0AgACAEENEEKAIAIAEgAiADEKkDRQRAIARBAWoiBCAAKAIASQ0BDAMLC0EBIQQMAwsgBiABEKgFRQ0CIAEgBUEMahCpBSIHBEAgBSgCDCAAIAAoAgAoAgwRAABPDQMLIAAoAgQoAgQQ2QMiBigCACEIIAYsAAshCSAFIAE2AgQgBSAIIAYgCUEASBs2AgBB3ckCIAUQvQEgARCqBSIBRQRAIAcNAyACIAA2AgAMAgsgAEEcaiEAIAcEQCAAIAUoAgwQ0QQoAgAgASACIAMQqQMhBAwDCyAAKAIARQ0CA0AgACAEENEEKAIAIAEgAiADEKkDDQIgBEEBaiIEIAAoAgBJDQALC0EAIQQMAQtBASEECyAFQRBqJAAgBAu0BwICfwJ+IwBBMGsiAyQAAkACQCACBEBBBBAOIQBByLIFQQA2AgBBLUEsEA0hBEHIsgUoAgAhAUHIsgVBADYCAAJAAkACQAJAIAFBAUcEQEHIsgVBADYCAEEtQSAQDSEBQciyBSgCACECQciyBUEANgIAIAJBAUYNASADIAE2AiAgA0KcgICAgISAgIB/NwIkIAFBADoAHCABQYPHAigAADYAGCABQfvGAikAADcAECABQfPGAikAADcACCABQevGAikAADcAAEHIsgVBADYCAEEyIAQgA0EgakH7vQJBugdBiMcCEBAaQciyBSgCACECQciyBUEANgIAQQEhASACQQFGDQIgACAENgIAQciyBUEANgIAQTEgAEGg2gBBABASQciyBSgCACECQciyBUEANgIAQQAhASACQQFGDQIMBwsQBiECEAcaDAMLEAYhAhAHGgwBCxAGIQIQBxogAywAK0F/TARAIAMoAiAQ9gwLIAFFDQMLIAQQ9gwLIAAQEwwBCwJAIAAtAA0NACABQQAQsAMhBQNAAkAgACkDEFBFBEAgAUEAELADIAApAxAgBXxaDQELQciyBUEANgIAQcUDIAEgA0EgakEBQQAQHEHIsgUoAgAhAkHIsgVBADYCACACQQFGBEBBoNoAEAshAhAHQaDaABAZRw0EIAIQDCECQciyBUEANgIAQfsBIAEQtQ0hBUHIsgUoAgAhBEHIsgVBADYCAAJAIARBAUYNAEHIsgVBADYCAEHGAyABELUNIQZByLIFKAIAIQFByLIFQQA2AgAgAUEBRg0AIAUgBloEQCACBEAgAiACKAIAKAIEEQEACxAXDAMLQQQQDiIAIAI2AgBByLIFQQA2AgBBMSAAQaDaAEEAEBJByLIFKAIAIQBByLIFQQA2AgAgAEEBRw0GCxAGIQAQBxoQFyAAEAgACyADLQAgIgIgAC0ADkkNACACIAAtAA9LDQAgACACENMEIgIgASACKAIAKAIMEQIADAELCwJAIAAtABhFDQAgACgCHA0AIAAoAgQoAgQQ2QMiASgCACECIAEsAAshBCADIAAtAA42AhggA0GIxwI2AhAgAyACIAEgBEEASBs2AhRB7skCIANBEGoQvAEMAQsgAC0AGUUNACAAKAIcQQJJDQAgACgCBCgCBBDZAyIBKAIAIQIgASwACyEEIAMgAC0ADjYCCCADQYjHAjYCACADIAIgASAEQQBIGzYCBEGcygIgAxC8AQsgA0EwaiQADwsgAhAIAAsAC8wDAQJ/IwBBEGsiAyQAIAIEQEEEEA4hAEHIsgVBADYCAEEtQSwQDSEEQciyBSgCACECQciyBUEANgIAAkACQAJAAkACQCACQQFHBEBByLIFQQA2AgBBLUEgEA0hAkHIsgUoAgAhAUHIsgVBADYCACABQQFGDQEgAyACNgIAIANCnICAgICEgICAfzcCBCACQQA6ABwgAkGDxwIoAAA2ABggAkH7xgIpAAA3ABAgAkHzxgIpAAA3AAggAkHrxgIpAAA3AABByLIFQQA2AgBBMiAEIANB+70CQewHQb7HAhAQGkHIsgUoAgAhAkHIsgVBADYCAEEBIQEgAkEBRg0CIAAgBDYCAEHIsgVBADYCAEExIABBoNoAQQAQEkHIsgUoAgAhAkHIsgVBADYCAEEAIQEgAkEBRg0CAAsQBiECEAcaDAMLEAYhAhAHGgwBCxAGIQIQBxogAywAC0F/TARAIAMoAgAQ9gwLIAFFDQILIAQQ9gwLIAAQEwsgAhAIAAsCQCAALQANDQAgACgCHEUNACAAQRxqIQJBACEAA0AgAiAAENEEKAIAIgQgASAEKAIAKAIQEQIAIABBAWoiACACKAIASQ0ACwsgA0EQaiQAC7AEAQN/IwBBIGsiBCQAIAMEQEEEEA4hAEHIsgVBADYCAEEtQSwQDSEBQciyBSgCACEDQciyBUEANgIAAkACQAJAAkACQCADQQFHBEBByLIFQQA2AgBBLUEgEA0hA0HIsgUoAgAhAkHIsgVBADYCACACQQFGDQEgBCADNgIQIARCnICAgICEgICAfzcCFCADQQA6ABwgA0GDxwIoAAA2ABggA0H7xgIpAAA3ABAgA0HzxgIpAAA3AAggA0HrxgIpAAA3AABByLIFQQA2AgBBMiABIARBEGpB+70CQfoHQb3IAhAQGkHIsgUoAgAhA0HIsgVBADYCAEEBIQIgA0EBRg0CIAAgATYCAEHIsgVBADYCAEExIABBoNoAQQAQEkHIsgUoAgAhA0HIsgVBADYCAEEAIQIgA0EBRg0CAAsQBiEDEAcaDAMLEAYhAxAHGgwBCxAGIQMQBxogBCwAG0F/TARAIAQoAhAQ9gwLIAJFDQILIAEQ9gwLIAAQEwsgAxAIAAsCQEEAIAAtAA0gAhsNACAAKAIIBEAgACgCBCgCBBDZAyIDKAIAIQUgAywACyEGIAQgACgCCDYCBCAEIAUgAyAGQQBIGzYCAEHAjAQgAUEEQcLEAiAEEL8BIAFBAWohAQsgACgCHEUNACAAQRxqIQNBACEAIAFB/wFxIQUDQCADIAAQ0QQoAgAiASAFIAIgASgCACgCFBEFACAAQQFqIgAgAygCAEkNAAsLIARBIGokAAspACAAQQA7AQwgACACNgIIIAAgATYCBCAAIAM2AhAgAEHcygI2AgAgAAubBQEFfyMAQUBqIgIkACACQQA2AiggAkIANwMgIAAoAhAhA0HIsgVBADYCAEHHA0Hc/QQgAyACQSBqQQAQGhpByLIFKAIAIQNByLIFQQA2AgACfwJAIANBAUYNAAJ/AkAgAiwAKyIEQX9MBEBBACACKAIkQQNHDQIaIAIoAiAhAwwBCyACQSBqIQNBACAEQQNHDQEaCyADLQACQR9xIAMtAAFBH3FBBXQgAy0AAEEfcUEKdHJyCyEIIAAoAgQoAgQhA0HIsgVBADYCAEH+ACADEA0hA0HIsgUoAgAhBEHIsgVBADYCACAEQQFGDQAgACgCCCEEIAMoAgAhBSADLAALIQYgACgCECEAIAJBADYCOEHIsgVBADYCACACQgA3AzBBxwNB3P0EIAAgAkEwakEBEBohAEHIsgUoAgAhB0HIsgVBADYCAAJAAkACQCAHQQFGDQBByLIFQQA2AgBBlgMgAkEQaiAAEBUhAEHIsgUoAgAhB0HIsgVBADYCACAHQQFGDQAgBSADIAZBAEgbIQMgAiwAO0F/TARAIAIoAjAQ9gwLIAAoAgAhBSAALAALIQYgAiADNgIAQciyBUEANgIAIAIgBDYCBCACIAg2AgwgAiAFIAJBEGogBkEASBs2AghBkANBwIwEIAFBBUGEywIgAhAiQciyBSgCACEDQciyBUEANgIAIANBAUYNASAALAALQX9MBEAgACgCABD2DAsgAiwAK0F/TARAIAIoAiAQ9gwLIAJBQGskAA8LEAYhAxAHGiACLAA7QX9KDQEgAigCMBD2DAwBCxAGIQMQBxogACwAC0F/Sg0AIAAoAgAQ9gwLIAJBIGoMAQsQBiEDEAcaIAJBIGoLLAALQX9MBEAgAigCIBD2DAsgAxAIAAsEAEEBCwQAQQoLygECAX8BfiMAQRBrIgIkACABQRAQygMhBEHIsgVBADYCACACQQA6AAMgAkEDOgALIAIgBKciAUEfcUHgAHI6AAIgAiABQQV2QR9xQeAAcjoAASACIAFBCnZBH3FB4AByOgAAQcgDQdz9BCACEBUhAUHIsgUoAgAhA0HIsgVBADYCACADQQFHBEAgACABNgIQIAIsAAtBf0wEQCACKAIAEPYMCyACQRBqJAAPCxAGIQEQBxogAiwAC0F/TARAIAIoAgAQ9gwLIAEQCAALAwABC50CAgF/AX4jAEEQayICJAAgAkEANgIIIAJCADcDACAAKAIQIQBByLIFQQA2AgBBxwNB3P0EIAAgAkEAEBoaQciyBSgCACEAQciyBUEANgIAAkAgAEEBRg0AAn4CQCACLAALIgNBf0wEQEIAIAIoAgRBA0cNAhogAigCACEADAELIAIhAEIAIANBA0cNARoLIAAxAAJCH4MgADEAAUIFhkLgB4MgADEAAEIKhkKA+AGDhIQLIQRByLIFQQA2AgBByQMgASAEQRAQtA1ByLIFKAIAIQBByLIFQQA2AgAgAEEBRg0AIAIsAAtBf0wEQCACKAIAEPYMCyACQRBqJAAPCxAGIQAQBxogAiwAC0F/TARAIAIoAgAQ9gwLIAAQCAALKQAgAEEAOwEMIAAgAjYCCCAAIAE2AgQgACADNgIQIABBpMsCNgIAIAALmQMBBX8jAEEwayICJAAgACgCBCgCBBDZAyEEIAAoAgghCCAEKAIAIQUgBCwACyEGIAAoAhAhAyACQQA2AihByLIFQQA2AgAgAkIANwMgQcoDQbCnBSADIAJBIGpBARAaIQNByLIFKAIAIQdByLIFQQA2AgACQAJAIAdBAUYNAEHIsgVBADYCAEGWAyACQRBqIAMQFSEDQciyBSgCACEHQciyBUEANgIAIAdBAUYNACAFIAQgBkEASBshBCACLAArQX9MBEAgAigCIBD2DAsgAygCACEFIAMsAAshBiAAKAIQIQAgAiAENgIAQciyBUEANgIAIAIgCDYCBCACIAA2AgwgAiAFIAJBEGogBkEASBs2AghBkANBwIwEIAFBBEHMywIgAhAiQciyBSgCACEAQciyBUEANgIAIABBAUYNASADLAALQX9MBEAgAygCABD2DAsgAkEwaiQADwsQBiEAEAcaIAIsACtBf0wEQCACKAIgEPYMCyAAEAgACxAGIQIQBxogAywAC0F/TARAIAMoAgAQ9gwLIAIQCAALtgUBBH8jAEGgAWsiBCQAAkACQCAAQRBqIgYoAgAiAEUNACAGIQUDQCAFIAAgACgCECABSCIHGyEFIAAgB0ECdGooAgAiAA0ACyAFIAZGDQAgBSgCECABSg0AIAIgBSgCFCIAQRBqIABBBGogAxsQigwMAQsgBEHoPjYCUCAEQdQ+NgIYQciyBUEANgIAQSkgBEHQAGoiBSAEQRhqQQRyIgAQBUHIsgUoAgAhB0HIsgVBADYCAAJAIAdBAUcEQCAEQoCAgIBwNwOYASAEQbA+NgJQIARBnD42AhhByLIFQQA2AgBBKiAAEA0hB0HIsgUoAgAhBkHIsgVBADYCACAGQQFGBEAQBiEAEAcaDAILIARCADcCPCAEQgA3AkQgBEEQNgJMIARBzD82AhxByLIFQQA2AgBBKyAEQRhqQarVAkEKEBQhBkHIsgUoAgAhA0HIsgVBADYCAAJAAkACQCADQQFGDQBByLIFQQA2AgBBMyAGIAEQFSEBQciyBSgCACEGQciyBUEANgIAIAZBAUYNAEHIsgVBADYCAEErIAFBtdUCQQEQFBpByLIFKAIAIQFByLIFQQA2AgAgAUEBRg0AQciyBUEANgIAQS4gBEEIaiAAEAVByLIFKAIAIQBByLIFQQA2AgAgAEEBRg0BIAIsAAtBf0wEQCACKAIAEPYMCyACIAQpAwg3AgAgAiAEKAIQNgIIIARBsD42AlAgBEGcPjYCGCAEQcw/NgIcIAQsAEdBf0wEQCAEKAI8EPYMCyAHEOAGGiAFENwGDAULEAYhABAHGgwBCxAGIQAQBxoLIARBsD42AlAgBEGcPjYCGCAEQcw/NgIcIAQsAEdBf0wEQCAEKAI8EPYMCyAHEOAGGiAFENwGIAAQCAALEAYhABAHGgsgBRDcBiAAEAgACyAEQaABaiQAIAILBABBCwsOACAAIAFBCBDKAz4CEAsOACABIAA1AhBBCBDLAwsDAAALTQEBfyAAQZDMAjYCACAAKAIYIQFByLIFQQA2AgAgARDoAUHIsgUoAgAhAUHIsgVBADYCACABQQFGBEBBABALIQAQBxogABCEAQALIAALUAEBfyAAQZDMAjYCACAAKAIYIQFByLIFQQA2AgAgARDoAUHIsgUoAgAhAUHIsgVBADYCACABQQFGBEBBABALIQAQBxogABCEAQALIAAQ9gwLBABBAAsHACAAKAIQCyQAIAAgATYCECAAIAE2AhQgAEEYaiIAIAAoAgAgARDqATYCAAshACAALQANRQRAIAEQtgMhASAAQRBqIAIQqAEgAToAAAsLHQAgAC0ADUUEQCABIABBEGogAhCoAS0AABC7AwsLTQEBfyAAQaDNAjYCACAAKAIYIQFByLIFQQA2AgAgARDoAUHIsgUoAgAhAUHIsgVBADYCACABQQFGBEBBABALIQAQBxogABCEAQALIAALUAEBfyAAQaDNAjYCACAAKAIYIQFByLIFQQA2AgAgARDoAUHIsgUoAgAhAUHIsgVBADYCACABQQFGBEBBABALIQAQBxogABCEAQALIAAQ9gwLDAAgAEEQaiABEPIEC6kDAQN/IwBBEGsiAiQAIAAgATYCBCAAIAE2AgAgAUF/TARAQQQQDiEAQciyBUEANgIAQS1BMBANIQRByLIFKAIAIQFByLIFQQA2AgACQAJAAkACQAJAIAFBAUcEQEHIsgVBADYCAEEtQTAQDSEBQciyBSgCACEDQciyBUEANgIAIANBAUYNASACIAE2AgAgAkKggICAgIaAgIB/NwIEIAFBADoAICABQZrVAikAADcAGCABQZLVAikAADcAECABQYrVAikAADcACCABQYLVAikAADcAAEHIsgVBADYCAEEwIAQgAkHEAEGy1AJBgAFBo9UCEBYaQciyBSgCACEBQciyBUEANgIAQQEhAyABQQFHBEAgACAENgIAQciyBUEANgIAQTEgAEGs3QBBABASQciyBSgCACEBQciyBUEANgIAQQAhAyABQQFHDQYLEAYhARAHGiACLAALQX9MBEAgAigCABD2DAsgAw0CDAQLEAYhARAHGgwCCxAGIQEQBxoLIAQQ9gwLIAAQEwsgARAICwALIAAgACgCCCABQQF0EOoBNgIIIAJBEGokAAshACAALQANRQRAIAEQtwMhASAAQRBqIAIQqgEgATsBAAsLHQAgAC0ADUUEQCABIABBEGogAhCqAS8BABC8AwsLTQEBfyAAQYDOAjYCACAAKAIYIQFByLIFQQA2AgAgARDoAUHIsgUoAgAhAUHIsgVBADYCACABQQFGBEBBABALIQAQBxogABCEAQALIAALUAEBfyAAQYDOAjYCACAAKAIYIQFByLIFQQA2AgAgARDoAUHIsgUoAgAhAUHIsgVBADYCACABQQFGBEBBABALIQAQBxogABCEAQALIAAQ9gwLBABBAgsMACAAQRBqIAEQvgQLIQAgAC0ADUUEQCABELgDIQEgAEEQaiACELEBIAE2AgALCx0AIAAtAA1FBEAgASAAQRBqIAIQsQEoAgAQvQMLC00BAX8gAEHgzgI2AgAgACgCGCEBQciyBUEANgIAIAEQ6AFByLIFKAIAIQFByLIFQQA2AgAgAUEBRgRAQQAQCyEAEAcaIAAQhAEACyAAC1ABAX8gAEHgzgI2AgAgACgCGCEBQciyBUEANgIAIAEQ6AFByLIFKAIAIQFByLIFQQA2AgAgAUEBRgRAQQAQCyEAEAcaIAAQhAEACyAAEPYMCwQAQQMLIQAgAC0ADUUEQCABELkDIQEgAEEQaiACELEBIAE2AgALCx0AIAAtAA1FBEAgASAAQRBqIAIQsQEoAgAQvgMLC1ABAX8gAEHAzwI2AgAgACgCGCEBQciyBUEANgIAIAEQ6AFByLIFKAIAIQFByLIFQQA2AgAgAUEBRgRAQQAQCyEAEAcaIAAQhAEACyAAEPYMCwQAQQQLDAAgAEEQaiABEIMFC60DAQN/IwBBEGsiAiQAIAAgATYCBCAAIAE2AgAgAUGAgICAAk8EQEEEEA4hAEHIsgVBADYCAEEtQTAQDSEEQciyBSgCACEBQciyBUEANgIAAkACQAJAAkACQCABQQFHBEBByLIFQQA2AgBBLUEwEA0hAUHIsgUoAgAhA0HIsgVBADYCACADQQFGDQEgAiABNgIAIAJCoICAgICGgICAfzcCBCABQQA6ACAgAUGa1QIpAAA3ABggAUGS1QIpAAA3ABAgAUGK1QIpAAA3AAggAUGC1QIpAAA3AABByLIFQQA2AgBBMCAEIAJBxABBstQCQYQBQaPVAhAWGkHIsgUoAgAhAUHIsgVBADYCAEEBIQMgAUEBRwRAIAAgBDYCAEHIsgVBADYCAEExIABBrN0AQQAQEkHIsgUoAgAhAUHIsgVBADYCAEEAIQMgAUEBRw0GCxAGIQEQBxogAiwAC0F/TARAIAIoAgAQ9gwLIAMNAgwECxAGIQEQBxoMAgsQBiEBEAcaCyAEEPYMCyAAEBMLIAEQCAsACyAAIAAoAgggAUEDdBDqATYCCCACQRBqJAALIwEBfiAALQANRQRAIAEQugMhAyAAQRBqIAIQqQEgAzcDAAsLHQAgAC0ADUUEQCABIABBEGogAhCpASkDABC/AwsLTQEBfyAAQcDPAjYCACAAKAIYIQFByLIFQQA2AgAgARDoAUHIsgUoAgAhAUHIsgVBADYCACABQQFGBEBBABALIQAQBxogABCEAQALIAALTQEBfyAAQYDRAjYCACAAKAIYIQFByLIFQQA2AgAgARDoAUHIsgUoAgAhAUHIsgVBADYCACABQQFGBEBBABALIQAQBxogABCEAQALIAALUAEBfyAAQYDRAjYCACAAKAIYIQFByLIFQQA2AgAgARDoAUHIsgUoAgAhAUHIsgVBADYCACABQQFGBEBBABALIQAQBxogABCEAQALIAAQ9gwLBABBBQsMACAAQRBqIAEQiwULrQMBA38jAEEQayICJAAgACABNgIEIAAgATYCACABQYCAgIAETwRAQQQQDiEAQciyBUEANgIAQS1BMBANIQRByLIFKAIAIQFByLIFQQA2AgACQAJAAkACQAJAIAFBAUcEQEHIsgVBADYCAEEtQTAQDSEBQciyBSgCACEDQciyBUEANgIAIANBAUYNASACIAE2AgAgAkKggICAgIaAgIB/NwIEIAFBADoAICABQZrVAikAADcAGCABQZLVAikAADcAECABQYrVAikAADcACCABQYLVAikAADcAAEHIsgVBADYCAEEwIAQgAkHEAEGy1AJBhgFBo9UCEBYaQciyBSgCACEBQciyBUEANgIAQQEhAyABQQFHBEAgACAENgIAQciyBUEANgIAQTEgAEGs3QBBABASQciyBSgCACEBQciyBUEANgIAQQAhAyABQQFHDQYLEAYhARAHGiACLAALQX9MBEAgAigCABD2DAsgAw0CDAQLEAYhARAHGgwCCxAGIQEQBxoLIAQQ9gwLIAAQEwsgARAICwALIAAgACgCCCABQQJ0EOoBNgIIIAJBEGokAAsEAEEHCwcAIAAoAiQLBABBCQsHACAAKAIcCwwAIABBHGogARCRBQusAwEDfyMAQRBrIgIkACAAIAE2AgQgACABNgIAIAFBgICAgARPBEBBBBAOIQBByLIFQQA2AgBBLUEwEA0hBEHIsgUoAgAhAUHIsgVBADYCAAJAAkACQAJAAkAgAUEBRwRAQciyBUEANgIAQS1BMBANIQFByLIFKAIAIQNByLIFQQA2AgAgA0EBRg0BIAIgATYCACACQqCAgICAhoCAgH83AgQgAUEAOgAgIAFBmtUCKQAANwAYIAFBktUCKQAANwAQIAFBitUCKQAANwAIIAFBgtUCKQAANwAAQciyBUEANgIAQTAgBCACQcQAQfjTAkEhQaPVAhAWGkHIsgUoAgAhAUHIsgVBADYCAEEBIQMgAUEBRwRAIAAgBDYCAEHIsgVBADYCAEExIABBrN0AQQAQEkHIsgUoAgAhAUHIsgVBADYCAEEAIQMgAUEBRw0GCxAGIQEQBxogAiwAC0F/TARAIAIoAgAQ9gwLIAMNAgwECxAGIQEQBxoMAgsQBiEBEAcaCyAEEPYMCyAAEBMLIAEQCAsACyAAIAAoAgggAUECdBDqATYCCCACQRBqJAALgxoBCX8jAEEQayIIJAAgAEIANwL4ASAAIAI2AgggACABNgIEIABBwNUCNgIAIABCADcCFCAAQgA3AzAgAEEANgLMASAAQQA2ArwBIABBADoAaCAAQoGAgIBwNwNgIABCADcDWCAAQQA2AlAgAEEANgKAAiAAQgA3AhwgAEKAgICAEDcCJCAAQgA3AzggAEFAa0IANwMAIABCADcDSEHIsgVBADYCAEGnBCACQczVAiAIQQxqQQAQGiECQciyBSgCACEBQciyBUEANgIAIABB+AFqIQkCQAJAAkACQAJAAkACQAJAIAFBAUYNACACBEBByLIFQQA2AgBB+wAgCCgCDEEQakEAEBUhAUHIsgUoAgAhA0HIsgVBADYCACADQQFGDQEgACABKAIANgIMCyAAKAIIIQFByLIFQQA2AgBBpwQgAUHe1QIgAEHsAGoiBEEAEBohAUHIsgUoAgAhA0HIsgVBADYCACADQQFGDQAgASACcSICQQFGBEAgBCgCACEBQciyBUEANgIAQfsAIAFBEGpBABAVIQFByLIFKAIAIQNByLIFQQA2AgAgA0EBRg0BIAAgATUCADcDWAsgACgCCCEBQciyBUEANgIAQacEIAFB99UCIABB8ABqQQAQGiEBQciyBSgCACEDQciyBUEANgIAIANBAUYNACAAKAIIIQNByLIFQQA2AgBBpwQgA0GK1gIgAEH0AGpBABAaIQNByLIFKAIAIQRByLIFQQA2AgAgBEEBRg0AIAAoAgghBEHIsgVBADYCAEGnBCAEQaLWAiAAQfgAakEAEBohBEHIsgUoAgAhBUHIsgVBADYCACAFQQFGDQAgACgCCCEFQciyBUEANgIAQacEIAVBvdYCIABB/ABqQQAQGiEFQciyBSgCACEGQciyBUEANgIAIAZBAUYNACAAKAIIIQZByLIFQQA2AgBBpwQgBkHd1gIgAEEQakEAEBohBkHIsgUoAgAhB0HIsgVBADYCACAHQQFGDQAgAEEANgKAASAAKAIIIQdByLIFQQA2AgBBpwQgB0H41gIgAEGAAWpBABAaIQdByLIFKAIAIQpByLIFQQA2AgAgCkEBRg0FIAEgAnEgA3EgBHEgBXEgBnEhAyAAQYQBaiECIAAoAgghAQJAIAcEQEHIsgVBADYCAEGnBCABQZzXAiACQQAQGiECQciyBSgCACEBQciyBUEANgIAIAFBAUYNByAAKAIIIQFByLIFQQA2AgBBpwQgAUHB1wIgAEGMAWpBABAaIQFByLIFKAIAIQRByLIFQQA2AgAgBEEBRg0HIABBIDoAiAEgAiADcSABcSECDAELQciyBUEANgIAQacEIAFB7NcCIAJBABAaIQVByLIFKAIAIQJByLIFQQA2AgAgAkEBRg0GIAAoAgghAkHIsgVBADYCAEGnBCACQZHYAiAAQYwBakEAEBohBkHIsgUoAgAhAkHIsgVBADYCACACQQFGDQYgACgCCCEBQQAhAkHIsgVBADYCAEGnBCABQbzYAiAIQQAQGiEBQciyBSgCACEEQciyBUEANgIAIARBAUYNAiABRQ0AQciyBUEANgIAQdkAIAgoAgBBEGpBABAVIQFByLIFKAIAIQJByLIFQQA2AgAgAkEBRg0CIAMgBXEgBnEhAiABLQAAIQEgAEEAOgCJASAAIAE6AIgBCyAAKAIIIQFByLIFQQA2AgBBpwQgAUHf2AIgAEGQAWpBABAaIQFByLIFKAIAIQNByLIFQQA2AgAgA0EBRg0FIAAoAgghA0HIsgVBADYCAEGnBCADQYPZAiAAQZQBakEAEBohA0HIsgUoAgAhBEHIsgVBADYCACAEQQFGDQUgACgCCCEEQciyBUEANgIAQacEIARBr9kCIABBmAFqQQAQGiEEQciyBSgCACEFQciyBUEANgIAIAVBAUYNBSAAKAIIIQVByLIFQQA2AgBBpwQgBUHg2QIgAEGcAWpBABAaIQVByLIFKAIAIQZByLIFQQA2AgAgBkEBRg0FIAAoAgghBkHIsgVBADYCAEGnBCAGQZjaAiAAQaABakEAEBohBkHIsgUoAgAhB0HIsgVBADYCACAHQQFGDQUgACgCCCEHQciyBUEANgIAQacEIAdBxdoCIABBpAFqIgtBABAaIQdByLIFKAIAIQpByLIFQQA2AgAgCkEBRg0EIAEgAnEgA3EgBHEgBXEgBnEhAiAAKAIIIQECfyAHBEBByLIFQQA2AgBBpwQgAUHp2gIgAEGoAWpBABAaIQFByLIFKAIAIQNByLIFQQA2AgAgA0EBRg0GIAEgAnEMAQtByLIFQQA2AgBBpwQgAUGW2wIgC0EAEBohAUHIsgUoAgAhA0HIsgVBADYCACADQQFGDQUgACgCCCEDQciyBUEANgIAQacEIANButsCIABBqAFqQQAQGiEDQciyBSgCACEEQciyBUEANgIAIARBAUYNBSABIAJxIANxCyECIAAoAgghAUHIsgVBADYCAEGnBCABQefbAiAAQawBakEAEBohAUHIsgUoAgAhA0HIsgVBADYCACADQQFGDQQgACgCCCEDQciyBUEANgIAQacEIANBi9wCIABBsAFqQQAQGiEDQciyBSgCACEEQciyBUEANgIAIARBAUYNBCAAKAIIIQRByLIFQQA2AgBBpwQgBEG43AIgAEG0AWpBABAaIQRByLIFKAIAIQVByLIFQQA2AgAgBUEBRg0EIABBADYC2AEgAEIANwPQASAAKAIIIQVByLIFQQA2AgBBpwQgBUHl3AIgAEHQAWpBABAaIQVByLIFKAIAIQZByLIFQQA2AgAgBkEBRg0CIAEgAnEgA3EgBHEhAiAFBEAgACgCCCEBQciyBUEANgIAQacEIAFBid0CIABB1AFqQQAQGiEBQciyBSgCACEDQciyBUEANgIAIANBAUYNAyAAKAIIIQNByLIFQQA2AgBBpwQgA0G23QIgAEHYAWpBABAaIQNByLIFKAIAIQRByLIFQQA2AgAgBEEBRg0DIAEgAnEgA3EhAgsgAEIANwLcASAAKAIIIQFByLIFQQA2AgBBpwQgAUHk3QIgAEHcAWpBABAaIQFByLIFKAIAIQNByLIFQQA2AgAgA0EBRg0DIAEEQCAAKAIIIQFByLIFQQA2AgBBpwQgAUGI3gIgAEHgAWpBABAaIQFByLIFKAIAIQNByLIFQQA2AgAgA0EBRg0EIAEgAnEhAgtByLIFQQA2AgBBqAQgABANGkHIsgUoAgAhAUHIsgVBADYCACABQQFGDQMgAkUEQEEEEA4hAkHIsgVBADYCAEEtQSwQDSEBQciyBSgCACEAQciyBUEANgIAAkACQCAAQQFHBEBByLIFQQA2AgBBLUEQEA0hAEHIsgUoAgAhA0HIsgVBADYCACADQQFGDQEgCCAANgIAIAhCjYCAgICCgICAfzcCBCAAQQA6AA0gAEG73gIpAAA3AAUgAEG23gIpAAA3AABByLIFQQA2AgBBMiABIAhBxN4CQesBQeneAhAQGkHIsgUoAgAhAEHIsgVBADYCAEEBIQMgAEEBRwRAIAIgATYCAEHIsgVBADYCAEExIAJBoNoAQQAQEkHIsgUoAgAhAEHIsgVBADYCAEEAIQMgAEEBRw0MCxAGIQAQBxogCCwAC0F/TARAIAgoAgAQ9gwLIAMNAgwKCxAGIQAQBxogAhATDAkLEAYhABAHGgsgARD2DCACEBMMBwtByLIFQQA2AgBBqQQgABAPQciyBSgCACECQciyBUEANgIAIAJBAUYNAyAAKAIIIQJByLIFQQA2AgBBqgQgAkHy3gIQFSECQciyBSgCACEBQciyBUEANgIAAkAgAUEBRwRAIAIEQCACKAJ0IQJByLIFQQA2AgBB+wAgAkEYaiIBQQAQFSEDQciyBSgCACEEQciyBUEANgIAIARBAUYNAiADKAIAIQNByLIFQQA2AgBBwgMgAxANIQNByLIFKAIAIQRByLIFQQA2AgAgBEEBRg0CQciyBUEANgIAQcEDIAJBJGpBABAVIQJByLIFKAIAIQRByLIFQQA2AgAgBEEBRg0CIAIoAgAhAkHIsgVBADYCAEH7ACABQQAQFSEEQciyBSgCACEFQciyBUEANgIAIAVBAUYNAiADIAIgBCgCABCADSECQciyBUEANgIAQfsAIAFBABAVIQFByLIFKAIAIQNByLIFQQA2AgAgA0EBRg0CIAEoAgAhAUHIsgVBADYCAEGrBCAJIAIgARAUGkHIsgUoAgAhAUHIsgVBADYCACABQQFGDQIgAhD2DAsgCEEQaiQAIAAPCxAGIQAQBxoMBwsQBiEAEAcaDAYLEAYhABAHGgwFCxAGIQAQBxoMBAsQBiEAEAcaDAMLEAYhABAHGgwCCxAGIQAQBxoMAQsQBiEAEAcaCyAJLAALQX9MBEAgCSgCABD2DAsgABAICwALwAEBBn8gAEEANgL0ASAAQgA3AuwBIABCADcC5AECQCAAKAIIQYzqAhCRAyIBRQ0AIAFBm+oCIABB5AFqIgNBABCTAxogAUGr6gIgAEHoAWoiBEEAEJMDGiABQcLqAiAAQewBaiIFQQAQkwMaIAFB3+oCIABB8AFqIgZBABCTAxogAUH26gIgAEH0AWoiAEEAEJMDGiADKAIARQ0AIAQoAgBFDQAgBSgCAEUNACAGKAIARQ0AIAAoAgBBAEchAgsgAguJAQECfwJAIAAoAghB6OMCEJEDIgFFDQAgASgCYEEBRw0AIAFB4ABqQQAQkQEoAgAiAUEoaiICEK0FQYzrAhCtBUcEQCACEK0FQZHrAhCtBUcNAQsgAUHIAGoiAUEEEKwBKAIAIQIgAUEFEKwBKAIAIQEgACACQQAQogQgAUEAEKIEQgOIfj4CYAsLqwEBAX8gAEHA1QI2AgAgACgCICEBQciyBUEANgIAIAEQ6AFByLIFKAIAIQFByLIFQQA2AgACQCABQQFGDQAgAEEANgIgIAAoAjghAUHIsgVBADYCACABEOgBQciyBSgCACEBQciyBUEANgIAIAFBAUYNACAAQQA2AjggACwAgwJBf0wEQCAAKAL4ARD2DAsgAA8LQQAQCyEBEAcaIABB+AFqEIkMGiABEIQBAAuuAQEBfyAAQcDVAjYCACAAKAIgIQFByLIFQQA2AgAgARDoAUHIsgUoAgAhAUHIsgVBADYCAAJAIAFBAUYNACAAQQA2AiAgACgCOCEBQciyBUEANgIAIAEQ6AFByLIFKAIAIQFByLIFQQA2AgAgAUEBRg0AIABBADYCOCAALACDAkF/TARAIAAoAvgBEPYMCyAAEPYMDwtBABALIQEQBxogAEH4AWoQiQwaIAEQhAEAC7oCAgd/AX4jAEEgayICJAAgACgCQARAIABBQGshBCAAKAIEQQAQsAMhCCAAKAIEIAAoAjggACgCQBC1AyAAKAIEENkDIgEoAgAhBSABLAALIQYgACgCDCEHIAAoAkAhAyACIAAoAkQ2AhggAiADNgIUIAIgAzYCECACIAg3AwggAiAHNgIEIAIgBSABIAZBAEgbNgIAQajgAiACEL4BIAAgACgCKCAAKAKkAUEQakEAELEBKAIAQQFqIAAoAkQQmQUgACgCqAEiASABKAIAKAIIEQAAIQMgACgCqAEhAQJAIANBA0YEQCABQRBqIAinIAEoAhAQ4gMMAQsgAUEQaiAIIAEoAhAQ9gMLIAAoAqQBQRBqQQAQsQEiACAAKAIAQQFqNgIAIARCADcDCCAEQgA3AwALIAJBIGokAAvIBAIHfwF+IwBBEGsiBiQAIAAoAqwBQRBqQQAQsQEoAgAhBwJ+IAAoArwBIgRBf2ogAUkEQCAAKAK4ASEFIAApA8ABDAELIABBADYCuAFBASEEQgALIQogBSAHSQRAA0AgACgCsAFBEGogBRCxASgCACEDIAAoArQBQRBqIAUQsQEoAgAhCCADIARqIglBf2ogAU8EQCACBEAgAiAIrSABIARrrX4gCnw3AwALIAAgCjcDwAEgACAENgK8ASAAIAU2ArgBIAZBEGokAA8LIAogAyAIbK18IQogCSEEIAVBAWoiBSAHRw0ACwtBBBAOIQVByLIFQQA2AgBBLUEsEA0hAEHIsgUoAgAhA0HIsgVBADYCAAJAAkACQAJAAkAgA0EBRwRAQciyBUEANgIAQS1BIBANIQNByLIFKAIAIQRByLIFQQA2AgAgBEEBRg0BIAYgAzYCACAGQpaAgICAhICAgH83AgQgA0EAOgAWIANBj+QCKQAANwAOIANBieQCKQAANwAIIANBgeQCKQAANwAAQciyBUEANgIAQTIgACAGQcTeAkHMCEGY5AIQEBpByLIFKAIAIQNByLIFQQA2AgBBASEEIANBAUYNAiAFIAA2AgBByLIFQQA2AgBBMSAFQaDaAEEAEBJByLIFKAIAIQNByLIFQQA2AgBBACEEIANBAUYNAgALEAYhAxAHGgwDCxAGIQMQBxoMAQsQBiEDEAcaIAYsAAtBf0wEQCAGKAIAEPYMCyAERQ0CCyAAEPYMCyAFEBMLIAMQCAALqwEBAX8CQCAAKAKQAUEQakEAELEBKAIAIgQEQCAAKAKYAUEQaiAEQX9qELEBKAIAIANGDQELIAAoApQBIgRBEGogAiAEKAIQEOIDIAAoApgBIgJBEGogAyACKAIQEOIDIAAoApwBIgJBEGpBASACKAIQEOIDIAAoAqABIgJBEGogASADa0EBaiACKAIQEOIDIAAoApABQRBqQQAQsQEiACAAKAIAQQFqNgIACwvKBwEGfyMAQUBqIgckACAAKAIEENkDIgYoAgAhCCAGLAALIQogACgCDCEJIAAoAighCyAHIAI2AiAgByACNgIcIAcgCzYCGCAHIAk2AhRBACEJIAcgCCAGIApBAEgbNgIQQYvfAiAHQRBqEL4BAkAgAQ0AIAJFDQBBBBAOIQBByLIFQQA2AgBBLUEsEA0hAUHIsgUoAgAhAkHIsgVBADYCAAJAAkACQAJAAkAgAkEBRwRAQciyBUEANgIAQS1BEBANIQJByLIFKAIAIQZByLIFQQA2AgAgBkEBRg0BIAcgAjYCMCAHQo6AgICAgoCAgH83AjQgAkEAOgAOIAJBw98CKQAANwAGIAJBvd8CKQAANwAAQciyBUEANgIAQTIgASAHQTBqQcTeAkGdA0HM3wIQEBpByLIFKAIAIQJByLIFQQA2AgBBASEGIAJBAUYNAiAAIAE2AgBByLIFQQA2AgBBMSAAQaDaAEEAEBJByLIFKAIAIQJByLIFQQA2AgBBACEGIAJBAUYNAgALEAYhAhAHGgwDCxAGIQIQBxoMAQsQBiECEAcaIAcsADtBf0wEQCAHKAIwEPYMCyAGRQ0CCyABEPYMCyAAEBMLIAIQCAALAkAgACgCZEEBaiIGQQFLDQACQCAGQQFrBEAgACgCCEHY3wIQkQNFBEAgACgCCEH23wIQkQNFDQILIABBADYCZCAAIAEtAABBA3ZBD3E6AGgLIAEtAABBA3ZBD3EhCQwBCyAAQQE2AmQLAkAgA0J/Ug0AQn8hAyAAKAKsAUEQakEAELEBKAIAIgZBAUsNACAGQQFrBEAgACkDMCEDDAELIAAoArQBQRBqQQAQsQE1AgAhAwsgACgCBBDZAyIGKAIAIQggBiwACyEKIAcgAzcDCCAHIAggBiAKQQBIGzYCAEGU4AIgBxC+AQJAIAAoAmQNACAALQBoIAlGDQAgABCXBSAAIAk6AGgLIAAoAjghBgJAIAAoAkAiCCACaiAAKAI8IgpLBEAgACAGIAIgCmoQ6gEiBjYCOCAGRQ0BIAAgACgCPCACajYCPCAAKAJAIQgLIAYgCGogASACEIANGiAAIAAoAkAgAmo2AkAgACAAKAJEQQFqNgJEIAAgACkDSCADfDcDSCAAIAAoAiggAhCbBSAAIAMQnAUgACAAKAIoIAQQnQUgACAAKAIoIAUQngUgABCfBQRAIAAQlwUgACAJOgBoCyAAIAMQoAUQrAUhAyAAKAJ8IANBABCjBCAAKAJ4IANBABCjBCAAIAAoAihBAWo2AigLIAdBQGskAAvrAgEFfyMAQSBrIgQkACAAKAJgIgNBAk8EQCACIAIgA3AEfyAAKAIEENkDIgMoAgAhBSADLAALIQYgACgCYCEHIAQgATYCECAEIAc2AgwgBCACNgIIIARB1uMCNgIAIAQgBSADIAZBAEgbNgIEQcCMBEGR4wIgBBC6ASAAKAJgBSADC24hAgsCQAJAIAFBAUcNACAAKAKEAUEQakEAELEBKAIADQAgAkEAIAAoAoABIgEbRQRAIAEEQCABQQBBABDXAQsgAEEAEKEFDAILIAEgAkEAENcBDAELAkAgACgCgAEiAUUNACABQRBqQQAQsQEoAgAiA0EAIAIgA0YbDQEgA0UNACAAKAKAAUEAQQAQ1wEgACgChAFBEGpBABCxASgCACIFRQ0AQQEhAQNAIAAgAxChBSABQQFqIgEgBU0NAAsLIAAgAhChBQsgACgChAFBEGpBABCxASIAIAAoAgBBAWo2AgAgBEEgaiQAC5YBAQN/AkACQCAAKAKsAUEQakEAELEBKAIAIgJFDQAgACgCtAFBEGogAkF/aiIDELEBNQIAIAFSDQAgAEGwAWohAiADIQQMAQsgAEGsAWohAiAAKAKwASIDQRBqQQEgAygCEBDiAyAAKAK0ASIAQRBqIAGnIAAoAhAQ4gMLIAIoAgBBEGogBBCxASIAIAAoAgBBAWo2AgALngoBBX8jAEEQayIFJAAgAEHQAWohBAJAAkACQAJAIAAoAtABDQAgAlANASAAQafkAhCiBSIDQazkAiAEQQAQkwNFBEBBBBAOIQRByLIFQQA2AgBBLUEsEA0hAUHIsgUoAgAhAEHIsgVBADYCAAJAAkACQAJAIABBAUcEQEHIsgVBADYCAEEtQfAAEA0hAEHIsgUoAgAhA0HIsgVBADYCACADQQFGDQEgBSAANgIAIAVC44CAgICOgICAfzcCBCAAQbzkAkHjABCADUEAOgBjQciyBUEANgIAQTIgASAFQcTeAkHOCUGg5QIQEBpByLIFKAIAIQBByLIFQQA2AgBBASEDIABBAUYNAiAEIAE2AgBBACEDQciyBUEANgIAQTEgBEGg2gBBABASQciyBSgCACEAQciyBUEANgIAIABBAUYNAgwJCxAGIQAQBxoMAwsQBiEAEAcaDAELEAYhABAHGiAFLAALQX9MBEAgBSgCABD2DAsgA0UNBQsgARD2DAsgBBATDAMLIANBt+UCIABB1AFqIgZBABCTA0UEQEEEEA4hBEHIsgVBADYCAEEtQSwQDSEBQciyBSgCACEAQciyBUEANgIAAkACQAJAIABBAUcEQEHIsgVBADYCAEEtQYABEA0hAEHIsgUoAgAhA0HIsgVBADYCACADQQFGDQEgBSAANgIAIAVC8oCAgICQgICAfzcCBCAAQdDlAkHyABCADUEAOgByQciyBUEANgIAQTIgASAFQcTeAkHSCUGg5QIQEBpByLIFKAIAIQBByLIFQQA2AgBBASEDIABBAUcEQCAEIAE2AgBByLIFQQA2AgBBMSAEQaDaAEEAEBJByLIFKAIAIQBByLIFQQA2AgBBACEDIABBAUcNCQsQBiEAEAcaIAUsAAtBf0wEQCAFKAIAEPYMCyADRQ0HDAILEAYhABAHGgwCCxAGIQAQBxoLIAEQ9gwLIAQQEyAAEAgACyADQcPmAiAAQdgBaiIHQQAQkwNFBEBBBBAOIQRByLIFQQA2AgBBLUEsEA0hAUHIsgUoAgAhAEHIsgVBADYCAAJAAkACQCAAQQFHBEBByLIFQQA2AgBBLUGAARANIQBByLIFKAIAIQNByLIFQQA2AgAgA0EBRg0BIAUgADYCACAFQvSAgICAkICAgH83AgQgAEHd5gJB9AAQgA1BADoAdEHIsgVBADYCAEEyIAEgBUHE3gJB1glBoOUCEBAaQciyBSgCACEAQciyBUEANgIAQQEhAyAAQQFHBEAgBCABNgIAQQAhA0HIsgVBADYCAEExIARBoNoAQQAQEkHIsgUoAgAhAEHIsgVBADYCACAAQQFHDQkLEAYhABAHGiAFLAALQX9MBEAgBSgCABD2DAsgA0UNBwwCCxAGIQAQBxoMAgsQBiEAEAcaCyABEPYMCyAEEBMgABAIAAsgAUECSQ0AIAYoAgAiA0EQaiABQX9qIAMoAhAQ4gMgBygCACIBQRBqQQAgASgCEBDiAyAEKAIAQRBqQQAQsQEiASABKAIAQQFqNgIAC0EAIQECQAJAIAQoAgBBEGpBABCxASgCACIDRQ0AIAAoAtgBQRBqIANBf2oiAxCxATUCACACUg0AIABB1AFqIQQgAyEBDAELIAAoAtQBIgNBEGpBASADKAIQEOIDIAAoAtgBIgBBEGogAqcgACgCEBDiAwsgBCgCAEEQaiABELEBIgAgACgCAEEBajYCAAsgBUEQaiQADwsgABAIAAsAC/0GAQN/IwBBEGsiBCQAIAAoAtwBIQMCQAJAAkAgAgRAIANFDQEgACgC4AEiAkEQaiABIAIoAhAQ4gMgACgC3AFBEGpBABCxASIAIAAoAgBBAWo2AgAMAQsgAw0AIABB0ucCEKIFIgJB1+cCIABB3AFqIgNBABCTA0UEQEEEEA4hAkHIsgVBADYCAEEtQSwQDSEDQciyBSgCACEAQciyBUEANgIAAkACQAJAAkAgAEEBRwRAQciyBUEANgIAQS1B8AAQDSEAQciyBSgCACEBQciyBUEANgIAIAFBAUYNASAEIAA2AgAgBELjgICAgI6AgIB/NwIEIABB5+cCQeMAEIANQQA6AGNByLIFQQA2AgBBMiADIARBxN4CQZwLQcvoAhAQGkHIsgUoAgAhAEHIsgVBADYCAEEBIQEgAEEBRg0CIAIgAzYCAEEAIQFByLIFQQA2AgBBMSACQaDaAEEAEBJByLIFKAIAIQBByLIFQQA2AgAgAEEBRg0CDAgLEAYhABAHGgwDCxAGIQAQBxoMAQsQBiEAEAcaIAQsAAtBf0wEQCAEKAIAEPYMCyABRQ0ECyADEPYMCyACEBMMAgsgAkHd6AIgAEHgAWoiAUEAEJMDRQRAQQQQDiECQciyBUEANgIAQS1BLBANIQNByLIFKAIAIQBByLIFQQA2AgACQAJAAkAgAEEBRwRAQciyBUEANgIAQS1B8AAQDSEAQciyBSgCACEBQciyBUEANgIAIAFBAUYNASAEIAA2AgAgBELugICAgI6AgIB/NwIEIABB9+gCQe4AEIANQQA6AG5ByLIFQQA2AgBBMiADIARBxN4CQaALQcvoAhAQGkHIsgUoAgAhAEHIsgVBADYCAEEBIQEgAEEBRwRAIAIgAzYCAEHIsgVBADYCAEExIAJBoNoAQQAQEkHIsgUoAgAhAEHIsgVBADYCAEEAIQEgAEEBRw0ICxAGIQAQBxogBCwAC0F/TARAIAQoAgAQ9gwLIAFFDQYMAgsQBiEAEAcaDAILEAYhABAHGgsgAxD2DAsgAhATIAAQCAALIAAoAoQBQRBqQQAQsQEoAgAiBUECSQ0AQQEhAANAIAEoAgAiAkEQaiAAIAIoAhAQ4gMgAygCAEEQakEAELEBIgIgAigCAEEBajYCACAAQQFqIgAgBUcNAAsLIARBEGokAA8LIAAQCAALAAu7AwIEfwF+IwBBEGsiASQAAn8gACgCUCICBEAgACgCRCACTwwBCyAAKQNYIgVQBEBBBBAOIQJByLIFQQA2AgBBLUEsEA0hBEHIsgUoAgAhAEHIsgVBADYCAAJAAkACQAJAAkAgAEEBRwRAQciyBUEANgIAQS1BMBANIQBByLIFKAIAIQNByLIFQQA2AgAgA0EBRg0BIAEgADYCACABQqSAgICAhoCAgH83AgQgAEEAOgAkIABBgOMCKAAANgAgIABB+OICKQAANwAYIABB8OICKQAANwAQIABB6OICKQAANwAIIABB4OICKQAANwAAQciyBUEANgIAQTIgBCABQcTeAkHsBEGF4wIQEBpByLIFKAIAIQBByLIFQQA2AgBBASEDIABBAUYNAiACIAQ2AgBByLIFQQA2AgBBMSACQaDaAEEAEBJByLIFKAIAIQBByLIFQQA2AgBBACEDIABBAUYNAgALEAYhABAHGgwDCxAGIQAQBxoMAQsQBiEAEAcaIAEsAAtBf0wEQCABKAIAEPYMCyADRQ0CCyAEEPYMCyACEBMLIAAQCAALIAApA0ggBVoLIQAgAUEQaiQAIAALjwEBAn8gACgCdCICIAJBABCiBCABfEEAEKMEIAAoAnRBABCiBCEBIAAoAgQoAjxBEGpBABCxASgCACECIAAoAmxBEGpBABCxASEDIAAoAnAgASACrX4gAzUCAIBBABCjBCAAKAIEIQIgACgCcEEAEKIEIQEgAigCQEEAEKIEIAFUBEAgAigCQCABQQAQowQLC78BAQF/AkAgACgCjAEiAiACKAIAKAIIEQAAIgJBA0sNAAJAAkACQCACQQFrDgMBAwACCyAAKAKMASIAQRBqIAEgACgCEBDiAw8LIAAoAowBIgBBEGogAUH//wNxIAAoAhAQrwEPCyAALQCIAUEERgRAIAAtAIkBRQRAIABBAToAiQEgACABQQR0OgCKAQ8LIABBADoAiQEgAC0AigEgAUEPcXIhAQsgACgCjAEiAEEQaiABQf8BcSAAKAIQEKQECwvDAwEDfyMAQRBrIgMkACAAKAIIQb3iAhCRAyICRQRAQQQQDiECQciyBUEANgIAQS1BLBANIQFByLIFKAIAIQBByLIFQQA2AgACQAJAAkACQAJAIABBAUcEQEHIsgVBADYCAEEtQSAQDSEAQciyBSgCACEEQciyBUEANgIAIARBAUYNASADIAA2AgAgA0KdgICAgISAgIB/NwIEIABBADoAHSAAQfvpAikAADcAFSAAQfbpAikAADcAECAAQe7pAikAADcACCAAQebpAikAADcAAEHIsgVBADYCAEEyIAEgA0HE3gJBrwtBhOoCEBAaQciyBSgCACEAQciyBUEANgIAQQEhBCAAQQFGDQIgAiABNgIAQciyBUEANgIAQTEgAkGg2gBBABASQciyBSgCACEAQciyBUEANgIAQQAhBCAAQQFGDQIACxAGIQAQBxoMAwsQBiEAEAcaDAELEAYhABAHGiADLAALQX9MBEAgAygCABD2DAsgBEUNAgsgARD2DAsgAhATCyAAEAgACyAAKAIEIAIgARCHAyIAIAI2AkAgAkHgAGogACACKAJgEOkBIAAgACgCACgCCBEBACADQRBqJAAgAAu1BQIGfwF8IwBBEGsiBCQAIAAQpAUgABCXBQJAIAAoAoABDQAgAC0AiAFBBEcNACAALQCJAUUNACAAKAKMASICQRBqIAAtAIoBIAIoAhAQpAQgACgCjAEiAiACQQAQogRCAXxBABCjBAsgACgCCEHu4AIgBEEMakEAEJMDBEAgBCgCDCEGAkAgACgCgAEiAgRAIAJBEGpBABCxASgCACICDQELQQAhAiAAKAKMASIDIAMoAgAoAgwRAAAiB0UNAEEBIQMDQCAAKAKMASADQX9qEKIEpyIFIAIgAiAFSRshAiADQQFqIgMgB00NAAsLIAYgACgCYCACbK1BABCuAQsCQCABQQFxDQAgACgCCEGq4QIgBEEIakEAEJMDBEAgBCgCCCAAEKUFQQAQ1wELIAAoAghB5OECIARBCGpBABCTA0UNACAEKAIIAn9BACAAKAJ0QQAQogRQDQAaIAAQpgW6RAAAAAAAACBAoiAAKAJsQRBqQQAQsQEoAgC4oiAAKAJ0QQAQogS6o5siCEQAAAAAAADwQWMgCEQAAAAAAAAAAGZxBEAgCKsMAQtBAAtBABDXAQsgBEEANgIEIAAoAghBnuICIARBBGpBABCTAxoCQCAEKAIEIgJFDQAgAkEYakEAELEBKAIADQAgACgCCEGz4gIQkgMiAEUNAAJAIAAoAkAiBSgCYEUNACAFQeAAaiEDQQAhAgNAIAAgAyACEJEBKAIARgRAIAMgAhCSAQwCCyACQQFqIgIgAygCAEkNAAsLIAAgACgCACgCBBEBACAFKAJgDQAgBSgCQCICKAJgBEAgAkHgAGohA0EAIQIDQAJAIAUgAyACEJEBKAIARgRAIAMgAhCSAQwBCyACQQFqIgIgAygCAEkNAQsLIAVFDQELIAUgBSgCACgCBBEBAAsgBEEQaiQAC7QCAQR/AkACfyAALACDAiIBQX9MBEAgACgC/AEMAQsgAUH/AXELRQ0AIABB+AFqIQIgACgCCEHy3gIQkQMiAQR/IAEFIABB0eICEKIFCygCdCEDAn8gAiwACyIBQX9MBEAgACgC+AEhAiAAKAL8AQwBCyABQf8BcQshBEEAIQEgAyACIARBABC/BAJ/IAAoAgQhAEHW4gItAABFBEAgACgCFAwBCyAAKAIUQdbiAhCRAwsiAkUNACACQfQAaiIAKAIAIgMgAygCACgCDBEAACEDIAAoAgAhACADBEADQCAAQRhqIAEQiQIoAgBB2+ICEIMGRQ0CIAIoAnQhACABQQFqIgEgA0cNAAsLIAAgACAAKAIAKAIMEQAAIgFBAWogACgCACgCEBECACAAQdviAiABELUECwvQAwIJfwV+IwBBEGsiAyQAIAAoAmxBEGpBABCxATUCACENIAAoAoQBQRBqQQAQsQEoAgAhCSADQgA3AwggCQRAQQEhBkEBIQcDQAJ/AkAgACgCgAEiAkUNACACQRBqQQAQsQEoAgAiAkUNACAAKAJgIAJsDAELIAAtAIgBQQRGBEAgACgCjAEgBkF/akEBdiICEKIEpyIIIAhBBHYgAhtBD3EgACgCYGwMAQsgACgCYCAAKAKMASAGQX9qEKIEp2wLIQIgACAGIAMQmAUCfyACIAVqIAMpAwAiCyADKQMIIA18Ig5UDQAaIAsgCn0iDFBFBEAgBSAMIAGtIA4gCn1+fEJ/fCAMgKdrIgEgBCABIARLGyEECyACIAVqIQUCfwJAIAAoAoABIgFFDQAgAUEQakEAELEBKAIAIgFFDQAgACgCYCABbAwBCyAALQCIAUEERgRAIAAoAowBIAdBf2pBAXYiARCiBKciCCAIQQR2IAEbQQ9xIAAoAmBsDAELIAAoAmAgACgCjAEgB0F/ahCiBKdsCyEBIAAgB0EBaiIHIANBCGoQmAUgBSABawshBSALIQogAiEBIAZBAWoiBiAJTQ0ACwsgA0EQaiQAIARBA3QLlQECAn8BfgJ/AkAgACgCgAEiAUUNACABQRBqQQAQsQEoAgAiAUUNACAANQJgIAGtfiEDIAAoAoQBQRBqQQAQsQEMAQsgACgCjAEiASABKAIAKAIMEQAAIgIEQEEBIQEDQCAAKAKMASABQX9qEKIEQv////8PgyADfCEDIAFBAWoiASACTQ0ACwsgAEHgAGoLNQIAIAN+CwwAIAAoAnRBABCiBAufAQEDfwJAIABFDQAgAUUNACAALQAAIgRFDQAgAS0AACICRQ0AAkAgAkEqRg0AA0ACQEG46wIgAkEYdEEYdSICQQMQhAYNACAEQRh0QRh1EP0FIAIQ/QVHDQMgAUEBaiEBIAAtAAEiBEUNACAAQQFqIQAgAS0AACICDQEMAgsLIAEtAAAiAEUNACAAQdsARg0AIABBLkcNAQtBASEDCyADC78DAQN/IwBBIGsiAyQAAkAgAEUNAANAIAAtAAAiAkUNASACQS5GDQEgAEEBaiEAIAJB2wBHDQALIAFFBEBBBBAOIQBByLIFQQA2AgBBLUEsEA0hBEHIsgUoAgAhAkHIsgVBADYCAAJAAkACQAJAAkAgAkEBRwRAQciyBUEANgIAQS1BIBANIQJByLIFKAIAIQFByLIFQQA2AgAgAUEBRg0BIAMgAjYCECADQpiAgICAhICAgH83AhQgAkEAOgAYIAJBy+sCKQAANwAQIAJBw+sCKQAANwAIIAJBu+sCKQAANwAAQciyBUEANgIAQTIgBCADQRBqQdTrAkE+QfjrAhAQGkHIsgUoAgAhAkHIsgVBADYCAEEBIQEgAkEBRg0CIAAgBDYCAEHIsgVBADYCAEExIABBoNoAQQAQEkHIsgUoAgAhAkHIsgVBADYCAEEAIQEgAkEBRg0CAAsQBiECEAcaDAMLEAYhAhAHGgwBCxAGIQIQBxogAywAG0F/TARAIAMoAhAQ9gwLIAFFDQILIAQQ9gwLIAAQEwsgAhAIAAsgAyABNgIAIABBiuwCIAMQnwZBAUYhBAsgA0EgaiQAIAQLNQECfwJAIABFDQADQCAALQAAIgJFDQEgAEEBaiEAIAJBLkcNAAsgAEEAIAAtAAAbIQELIAEL2QIBAn8jAEEQayIBJABBjewCIQACQEGdnwJBjewCEIUGRQ0AQZ2fAkGS7AIQhQZFDQBBnZ8CQZjsAhCFBkUNAEGdnwJBnewCEIUGRQ0AQZ2fAkGi7AIQhQZFDQBBnZ8CQafsAhCFBkUNAEGs7AIhAEGdnwJBrOwCEIUGRQ0AQZ2fAkGx7AIQhQZFDQBBnZ8CQbfsAhCFBkUNAEGdnwJBvewCEIUGRQ0AQZ2fAkHC7AIQhQZFDQBBnZ8CQcfsAhCFBkUNAEGdnwJBzOwCEIUGRQ0AQdHsAiEAQZ2fAkHR7AIQhQZFDQBBnZ8CQdbsAhCFBkUNAEGdnwJB3OwCEIUGRQ0AQeHsAiEAQZ2fAkHh7AIQhQZFDQBBnZ8CQebsAhCFBkUNAEHp7AIhAEGdnwJB6ewCEIUGRQ0AIAFBnZ8CNgIAQe7sAiABEL0BQZ2fAiEACyABQRBqJAAgAAsQABD5BULoB39CgOGW4Qd8CykAIAAoAAAiAEEYdCAAQQh0QYCA/AdxciAAQQh2QYD+A3EgAEEYdnJyC4kHAQV/IAAgAUEAEKUDIQUgAEGc7QI2AgBByLIFQQA2AgBBLUEcEA0hAkHIsgUoAgAhBEHIsgVBADYCAAJAAkACQAJAAkACQAJAAkAgBEEBRg0AQciyBUEANgIAIAIgAUG47QIQoAQhBEHIsgUoAgAhA0HIsgVBADYCACADQQFGDQEgAkEANgIYIAJCADcCECACQeDOAjYCAEHIsgVBADYCAEHwzgIoAgAgAkEBEAVByLIFKAIAIQNByLIFQQA2AgACQCADQQFHBEBByLIFQQA2AgBB+wAgAkEQakEAEBUhA0HIsgUoAgAhBkHIsgVBADYCACAGQQFHDQELEAYhARAHGiACKAIYIQBByLIFQQA2AgAgABDoAUHIsgUoAgAhAEHIsgVBADYCACAAQQFHDQNBABALIQIQBxogAhCEAQALIANBADYCAEHIsgVBADYCAEH8ACAFIAQQBUHIsgUoAgAhAkHIsgVBADYCACACQQFGDQBByLIFQQA2AgBBLUEcEA0hAkHIsgUoAgAhBEHIsgVBADYCACAEQQFGDQBByLIFQQA2AgAgAiABQc3tAhCgBCEEQciyBSgCACEDQciyBUEANgIAIANBAUYNAyACQQA2AhggAkIANwIQIAJBoM0CNgIAQciyBUEANgIAQbDNAigCACACQQEQBUHIsgUoAgAhA0HIsgVBADYCAAJAIANBAUcEQEHIsgVBADYCAEHeACACQRBqQQAQFSEDQciyBSgCACEGQciyBUEANgIAIAZBAUcNAQsQBiEBEAcaIAIoAhghAEHIsgVBADYCACAAEOgBQciyBSgCACEAQciyBUEANgIAIABBAUcNBUEAEAshAhAHGiACEIQBAAsgA0EAOwEAQciyBUEANgIAQfwAIAUgBBAFQciyBSgCACECQciyBUEANgIAIAJBAUYNAEHIsgVBADYCAEEtQTAQDSECQciyBSgCACEEQciyBUEANgIAIARBAUYNAEHIsgVBADYCAEHgACACIAFB4e0CQQBBABAQGkHIsgUoAgAhAUHIsgVBADYCACABQQFGDQVByLIFQQA2AgBB/AAgBSACEAVByLIFKAIAIQJByLIFQQA2AgAgAkEBRw0HCxAGIQEQBxoMBQsQBiEBEAcaCyACEPYMDAMLEAYhARAHGgsgAhD2DAwBCxAGIQEQBxogAhD2DAsgBRCmAxogARAIAAsgAAsuACAAIAEQrAMgAEEcakECEKwBKAIAIAAoAhhBempBABDABCAAIAFBAEF/EK0DC9oMAQZ/IAAgAUEAEKUDIQYgAEGE7gI2AgBByLIFQQA2AgBBLUEwEA0hAkHIsgUoAgAhA0HIsgVBADYCAAJAAkACQAJAAkACQAJAAkACQAJAAkACQAJAIANBAUYNAEHIsgVBADYCAEHgACACIAFBoO4CQQNBABAQGkHIsgUoAgAhA0HIsgVBADYCACADQQFGDQFByLIFQQA2AgBB/AAgBiACEAVByLIFKAIAIQJByLIFQQA2AgAgAkEBRg0AQciyBUEANgIAQS1BIBANIQJByLIFKAIAIQNByLIFQQA2AgAgA0EBRg0AQciyBUEANgIAIAIgAUGt7gIQoAQhA0HIsgUoAgAhBEHIsgVBADYCACAEQQFGDQIgAkEANgIYIAJCADcCECACQcDPAjYCAEHIsgVBADYCAEHQzwIoAgAiBCACQQEQBUHIsgUoAgAhBUHIsgVBADYCAAJAIAVBAUcEQEHIsgVBADYCAEHcACACQRBqQQAQFSEFQciyBSgCACEHQciyBUEANgIAIAdBAUcNAQsQBiEBEAcaIAIoAhghAEHIsgVBADYCACAAEOgBQciyBSgCACEAQciyBUEANgIAIABBAUcNBEEAEAshAhAHGiACEIQBAAsgBUIANwMAIAJBAToAHCACQaDQAjYCAEHIsgVBADYCAEH8ACAGIAMQBUHIsgUoAgAhAkHIsgVBADYCACACQQFGDQBByLIFQQA2AgBBLUEgEA0hAkHIsgUoAgAhA0HIsgVBADYCACADQQFGDQBByLIFQQA2AgAgAiABQbruAhCgBCEDQciyBSgCACEFQciyBUEANgIAIAVBAUYNBCACQQA2AhggAkIANwIQIAJBwM8CNgIAQciyBUEANgIAIAQgAkEBEAVByLIFKAIAIQRByLIFQQA2AgACQCAEQQFHBEBByLIFQQA2AgBB3AAgAkEQakEAEBUhBEHIsgUoAgAhBUHIsgVBADYCACAFQQFHDQELEAYhARAHGiACKAIYIQBByLIFQQA2AgAgABDoAUHIsgUoAgAhAEHIsgVBADYCACAAQQFHDQZBABALIQIQBxogAhCEAQALIARCADcDACACQQc6ABwgAkGg0AI2AgBByLIFQQA2AgBB/AAgBiADEAVByLIFKAIAIQJByLIFQQA2AgAgAkEBRg0AQciyBUEANgIAQS1BHBANIQJByLIFKAIAIQNByLIFQQA2AgAgA0EBRg0GQciyBUEANgIAIAIgAUHD7gIQoAQhA0HIsgUoAgAhBEHIsgVBADYCACAEQQFGDQcgAkEANgIYIAJCADcCECACQZDMAjYCAEHIsgVBADYCAEGgzAIoAgAgAkEBEAVByLIFKAIAIQRByLIFQQA2AgACQCAEQQFHBEBByLIFQQA2AgBB2QAgAkEQakEAEBUhBEHIsgUoAgAhBUHIsgVBADYCACAFQQFHDQELEAYhARAHGiACKAIYIQBByLIFQQA2AgAgABDoAUHIsgUoAgAhAEHIsgVBADYCACAAQQFHDQlBABALIQIQBxogAhCEAQALIARBADoAAEHIsgVBADYCAEH8ACAGIAMQBUHIsgUoAgAhA0HIsgVBADYCACADQQFGDQZByLIFQQA2AgBBLUEgEA0hA0HIsgUoAgAhBEHIsgVBADYCACAEQQFGDQlByLIFQQA2AgAgAyABQdDuAiACEMUEIQFByLIFKAIAIQJByLIFQQA2AgAgAkEBRg0KQciyBUEANgIAQfwAIAYgAxAFQciyBSgCACECQciyBUEANgIAIAJBAUYNCUHIsgVBADYCAEEtQSQQDSECQciyBSgCACEEQciyBUEANgIAIARBAUYNCSADKAIEIQNByLIFQQA2AgBB/QAgAiADQdnuAkEBQQBBABAWGkHIsgUoAgAhA0HIsgVBADYCACADQQFGDQtByLIFQQA2AgBB3wAgASACEAVByLIFKAIAIQJByLIFQQA2AgAgAkEBRg0JIABBAjYCKCAADwsQBiEBEAcaDAsLEAYhARAHGiACEPYMDAoLEAYhARAHGgsgAhD2DAwICxAGIQEQBxoLIAIQ9gwMBgsQBiEBEAcaDAULEAYhARAHGgsgAhD2DAwDCxAGIQEQBxoMAgsQBiEBEAcaIAMQ9gwMAQsQBiEBEAcaIAIQ9gwLIAYQpgMaIAEQCAALwAMCBX8BfiMAQRBrIgIkACAAQRxqIgBBARCsASgCAEEQakEAEKkBKQMAIQYgAEEEEKwBKAIAQRRqQQAQrAEoAgAiAEUEQEEEEA4hAEHIsgVBADYCAEEtQSwQDSEDQciyBSgCACEBQciyBUEANgIAAkACQAJAAkACQCABQQFHBEBByLIFQQA2AgBBLUEgEA0hAUHIsgUoAgAhBUHIsgVBADYCAEEBIQQgBUEBRg0BIAIgATYCACACQpuAgICAhICAgH83AgQgAUEAOgAbIAFB9+4CKAAANgAXIAFB8O4CKQAANwAQIAFB6O4CKQAANwAIIAFB4O4CKQAANwAAQciyBUEANgIAQTIgAyACQfzuAkHNAEGn7wIQEBpByLIFKAIAIQFByLIFQQA2AgAgAUEBRg0CIAAgAzYCAEEAIQRByLIFQQA2AgBBMSAAQaDaAEEAEBJByLIFKAIAIQFByLIFQQA2AgAgAUEBRg0CAAsQBiEBEAcaDAMLEAYhARAHGgwBCxAGIQEQBxogAiwAC0F/TARAIAIoAgAQ9gwLIARFDQILIAMQ9gwLIAAQEwsgARAIAAsgACAGUDoAESACQRBqJAALiQcBBX8gACABQQAQpQMhBSAAQbjvAjYCAEHIsgVBADYCAEEtQRwQDSECQciyBSgCACEEQciyBUEANgIAAkACQAJAAkACQAJAAkACQCAEQQFGDQBByLIFQQA2AgAgAiABQdTvAhCgBCEEQciyBSgCACEDQciyBUEANgIAIANBAUYNASACQQA2AhggAkIANwIQIAJB4M4CNgIAQciyBUEANgIAQfDOAigCACACQQEQBUHIsgUoAgAhA0HIsgVBADYCAAJAIANBAUcEQEHIsgVBADYCAEH7ACACQRBqQQAQFSEDQciyBSgCACEGQciyBUEANgIAIAZBAUcNAQsQBiEBEAcaIAIoAhghAEHIsgVBADYCACAAEOgBQciyBSgCACEAQciyBUEANgIAIABBAUcNA0EAEAshAhAHGiACEIQBAAsgA0EANgIAQciyBUEANgIAQfwAIAUgBBAFQciyBSgCACECQciyBUEANgIAIAJBAUYNAEHIsgVBADYCAEEtQRwQDSECQciyBSgCACEEQciyBUEANgIAIARBAUYNAEHIsgVBADYCACACIAFB4e8CEKAEIQRByLIFKAIAIQNByLIFQQA2AgAgA0EBRg0DIAJBADYCGCACQgA3AhAgAkGgzQI2AgBByLIFQQA2AgBBsM0CKAIAIAJBARAFQciyBSgCACEDQciyBUEANgIAAkAgA0EBRwRAQciyBUEANgIAQd4AIAJBEGpBABAVIQNByLIFKAIAIQZByLIFQQA2AgAgBkEBRw0BCxAGIQEQBxogAigCGCEAQciyBUEANgIAIAAQ6AFByLIFKAIAIQBByLIFQQA2AgAgAEEBRw0FQQAQCyECEAcaIAIQhAEACyADQQA7AQBByLIFQQA2AgBB/AAgBSAEEAVByLIFKAIAIQJByLIFQQA2AgAgAkEBRg0AQciyBUEANgIAQS1BMBANIQJByLIFKAIAIQRByLIFQQA2AgAgBEEBRg0AQciyBUEANgIAQeAAIAIgAUHw7wJBAEEAEBAaQciyBSgCACEBQciyBUEANgIAIAFBAUYNBUHIsgVBADYCAEH8ACAFIAIQBUHIsgUoAgAhAkHIsgVBADYCACACQQFHDQcLEAYhARAHGgwFCxAGIQEQBxoLIAIQ9gwMAwsQBiEBEAcaCyACEPYMDAELEAYhARAHGiACEPYMCyAFEKYDGiABEAgACyAAC80BAQN/IAAgAUEAEKUDIQMgAEGE8AI2AgBByLIFQQA2AgBBLUEwEA0hAkHIsgUoAgAhBEHIsgVBADYCAAJAAkACQCAEQQFHBEBByLIFQQA2AgBB4AAgAiABQaDuAkEDQQAQEBpByLIFKAIAIQFByLIFQQA2AgAgAUEBRg0BQciyBUEANgIAQfwAIAMgAhAFQciyBSgCACEBQciyBUEANgIAIAFBAUcNAwsQBiEAEAcaDAELEAYhABAHGiACEPYMCyADEKYDGiAAEAgACyAAC+UJAQZ/IAAgAUEAEKUDIQYgAEGo8AI2AgBByLIFQQA2AgBBLUEwEA0hAkHIsgUoAgAhA0HIsgVBADYCAAJAAkACQAJAAkACQAJAAkACQAJAIANBAUYNAEHIsgVBADYCAEHgACACIAFBoO4CQQNBABAQGkHIsgUoAgAhA0HIsgVBADYCACADQQFGDQFByLIFQQA2AgBB/AAgBiACEAVByLIFKAIAIQJByLIFQQA2AgAgAkEBRg0AQciyBUEANgIAQS1BIBANIQJByLIFKAIAIQNByLIFQQA2AgAgA0EBRg0AQciyBUEANgIAIAIgAUGt7gIQoAQhA0HIsgUoAgAhBEHIsgVBADYCACAEQQFGDQIgAkEANgIYIAJCADcCECACQcDPAjYCAEHIsgVBADYCAEHQzwIoAgAiBCACQQEQBUHIsgUoAgAhBUHIsgVBADYCAAJAIAVBAUcEQEHIsgVBADYCAEHcACACQRBqQQAQFSEFQciyBSgCACEHQciyBUEANgIAIAdBAUcNAQsQBiEBEAcaIAIoAhghAEHIsgVBADYCACAAEOgBQciyBSgCACEAQciyBUEANgIAIABBAUcNBEEAEAshAhAHGiACEIQBAAsgBUIANwMAIAJBAToAHCACQaDQAjYCAEHIsgVBADYCAEH8ACAGIAMQBUHIsgUoAgAhAkHIsgVBADYCACACQQFGDQBByLIFQQA2AgBBLUEgEA0hAkHIsgUoAgAhA0HIsgVBADYCACADQQFGDQBByLIFQQA2AgAgAiABQbruAhCgBCEDQciyBSgCACEFQciyBUEANgIAIAVBAUYNBCACQQA2AhggAkIANwIQIAJBwM8CNgIAQciyBUEANgIAIAQgAkEBEAVByLIFKAIAIQRByLIFQQA2AgACQCAEQQFHBEBByLIFQQA2AgBB3AAgAkEQakEAEBUhBEHIsgUoAgAhBUHIsgVBADYCACAFQQFHDQELEAYhARAHGiACKAIYIQBByLIFQQA2AgAgABDoAUHIsgUoAgAhAEHIsgVBADYCACAAQQFHDQZBABALIQIQBxogAhCEAQALIARCADcDACACQQc6ABwgAkGg0AI2AgBByLIFQQA2AgBB/AAgBiADEAVByLIFKAIAIQJByLIFQQA2AgAgAkEBRg0AQciyBUEANgIAQS1BJBANIQJByLIFKAIAIQNByLIFQQA2AgAgA0EBRg0AQciyBUEANgIAQf0AIAIgAUHE8AJBAUEAQQAQFhpByLIFKAIAIQNByLIFQQA2AgAgA0EBRg0GQciyBUEANgIAQfwAIAYgAhAFQciyBSgCACECQciyBUEANgIAIAJBAUYNAEHIsgVBADYCAEEtQSQQDSECQciyBSgCACEDQciyBUEANgIAIANBAUYNAEHIsgVBADYCAEH9ACACIAFBzvACQQFBAEEAEBYaQciyBSgCACEBQciyBUEANgIAIAFBAUYNB0HIsgVBADYCAEH8ACAGIAIQBUHIsgUoAgAhAkHIsgVBADYCACACQQFHDQkLEAYhARAHGgwHCxAGIQEQBxogAhD2DAwGCxAGIQEQBxoLIAIQ9gwMBAsQBiEBEAcaCyACEPYMDAILEAYhARAHGiACEPYMDAELEAYhARAHGiACEPYMCyAGEKYDGiABEAgACyAAQQI2AiggAAtDAgF/AX4gAEEcaiIAQQEQrAEoAgBBEGpBABCpASkDACECIABBAxCsASgCACACUCIBOgARIABBBBCsASgCACABOgARC9MPAQZ/IAAgAUEAEKUDIQYgAEHg8AI2AgBByLIFQQA2AgBBLUEwEA0hAkHIsgUoAgAhA0HIsgVBADYCAAJAAkACQAJAAkACQAJAAkACQAJAAkACQAJAAkACQCADQQFGDQBByLIFQQA2AgBB4AAgAiABQaDuAkEDQQAQEBpByLIFKAIAIQNByLIFQQA2AgAgA0EBRg0BQciyBUEANgIAQfwAIAYgAhAFQciyBSgCACECQciyBUEANgIAIAJBAUYNAEHIsgVBADYCAEEtQSAQDSECQciyBSgCACEDQciyBUEANgIAIANBAUYNAEHIsgVBADYCACACIAFBre4CEKAEIQNByLIFKAIAIQRByLIFQQA2AgAgBEEBRg0CIAJBADYCGCACQgA3AhAgAkHAzwI2AgBByLIFQQA2AgBB0M8CKAIAIgQgAkEBEAVByLIFKAIAIQVByLIFQQA2AgACQCAFQQFHBEBByLIFQQA2AgBB3AAgAkEQakEAEBUhBUHIsgUoAgAhB0HIsgVBADYCACAHQQFHDQELEAYhARAHGiACKAIYIQBByLIFQQA2AgAgABDoAUHIsgUoAgAhAEHIsgVBADYCACAAQQFHDQRBABALIQIQBxogAhCEAQALIAVCADcDACACQQE6ABwgAkGg0AI2AgBByLIFQQA2AgBB/AAgBiADEAVByLIFKAIAIQJByLIFQQA2AgAgAkEBRg0AQciyBUEANgIAQS1BIBANIQJByLIFKAIAIQNByLIFQQA2AgAgA0EBRg0AQciyBUEANgIAIAIgAUG67gIQoAQhA0HIsgUoAgAhBUHIsgVBADYCACAFQQFGDQQgAkEANgIYIAJCADcCECACQcDPAjYCAEHIsgVBADYCACAEIAJBARAFQciyBSgCACEEQciyBUEANgIAAkAgBEEBRwRAQciyBUEANgIAQdwAIAJBEGpBABAVIQRByLIFKAIAIQVByLIFQQA2AgAgBUEBRw0BCxAGIQEQBxogAigCGCEAQciyBUEANgIAIAAQ6AFByLIFKAIAIQBByLIFQQA2AgAgAEEBRw0GQQAQCyECEAcaIAIQhAEACyAEQgA3AwAgAkEHOgAcIAJBoNACNgIAQciyBUEANgIAQfwAIAYgAxAFQciyBSgCACECQciyBUEANgIAIAJBAUYNAEHIsgVBADYCAEEtQRwQDSECQciyBSgCACEDQciyBUEANgIAIANBAUYNBkHIsgVBADYCACACIAFB/PACEKAEIQNByLIFKAIAIQRByLIFQQA2AgAgBEEBRg0HIAJBADYCGCACQgA3AhAgAkGQzAI2AgBByLIFQQA2AgBBoMwCKAIAIAJBARAFQciyBSgCACEEQciyBUEANgIAAkAgBEEBRwRAQciyBUEANgIAQdkAIAJBEGpBABAVIQRByLIFKAIAIQVByLIFQQA2AgAgBUEBRw0BCxAGIQEQBxogAigCGCEAQciyBUEANgIAIAAQ6AFByLIFKAIAIQBByLIFQQA2AgAgAEEBRw0JQQAQCyECEAcaIAIQhAEACyAEQQA6AABByLIFQQA2AgBB/AAgBiADEAVByLIFKAIAIQNByLIFQQA2AgAgA0EBRg0GQciyBUEANgIAQS1BIBANIQNByLIFKAIAIQRByLIFQQA2AgAgBEEBRg0JQciyBUEANgIAIAMgAUGG8QIgAhDFBCECQciyBSgCACEEQciyBUEANgIAIARBAUYNCkHIsgVBADYCAEH8ACAGIAMQBUHIsgUoAgAhBEHIsgVBADYCACAEQQFGDQlByLIFQQA2AgBBLUEkEA0hBEHIsgUoAgAhBUHIsgVBADYCACAFQQFGDQkgAygCBCEFQciyBUEANgIAQf0AIAQgBUGM8QJBAUEAQQAQFhpByLIFKAIAIQVByLIFQQA2AgAgBUEBRg0LQciyBUEANgIAQd8AIAIgBBAFQciyBSgCACEEQciyBUEANgIAIARBAUYNCUHIsgVBADYCAEEtQSQQDSEEQciyBSgCACEFQciyBUEANgIAIAVBAUYNCSADKAIEIQNByLIFQQA2AgBB/QAgBCADQZzxAkEBQQBBABAWGkHIsgUoAgAhA0HIsgVBADYCACADQQFGDQxByLIFQQA2AgBB3wAgAiAEEAVByLIFKAIAIQJByLIFQQA2AgAgAkEBRg0JQciyBUEANgIAQS1BJBANIQJByLIFKAIAIQNByLIFQQA2AgAgA0EBRg0JQciyBUEANgIAQf0AIAIgAUGl8QJBAEEAQQAQFhpByLIFKAIAIQFByLIFQQA2AgAgAUEBRg0NQciyBUEANgIAQfwAIAYgAhAFQciyBSgCACECQciyBUEANgIAIAJBAUYNCUHIsgVBADYCAEHmASAAQRxqQQUQFSECQciyBSgCACEBQciyBUEANgIAIAFBAUYNCSACKAIAQQE6ABAgAEECNgIoIAAPCxAGIQEQBxoMDQsQBiEBEAcaIAIQ9gwMDAsQBiEBEAcaCyACEPYMDAoLEAYhARAHGgsgAhD2DAwICxAGIQEQBxoMBwsQBiEBEAcaCyACEPYMDAULEAYhARAHGgwECxAGIQEQBxogAxD2DAwDCxAGIQEQBxogBBD2DAwCCxAGIQEQBxogBBD2DAwBCxAGIQEQBxogAhD2DAsgBhCmAxogARAIAAvVBgIFfwF+IwBBEGsiASQAIABBHGoiAEEBEKwBKAIAQRBqQQAQqQEpAwAhBgJAAkACQCAAQQQQrAEoAgBBFGpBABCsASgCACICRQRAQQQQDiEDQciyBUEANgIAQS1BLBANIQJByLIFKAIAIQBByLIFQQA2AgACQAJAIABBAUcEQEHIsgVBADYCAEEtQSAQDSEAQciyBSgCACEEQciyBUEANgIAQQEhBSAEQQFGDQEgASAANgIAIAFCm4CAgICEgICAfzcCBCAAQQA6ABsgAEH37gIoAAA2ABcgAEHw7gIpAAA3ABAgAEHo7gIpAAA3AAggAEHg7gIpAAA3AABByLIFQQA2AgBBMiACIAFB/O4CQacBQafvAhAQGkHIsgUoAgAhAEHIsgVBADYCACAAQQFHBEAgAyACNgIAQQAhBUHIsgVBADYCAEExIANBoNoAQQAQEkHIsgUoAgAhAEHIsgVBADYCACAAQQFHDQYLEAYhABAHGiABLAALQX9MBEAgASgCABD2DAsgBQ0CDAQLEAYhABAHGiADEBMMAwsQBiEAEAcaCyACEPYMIAMQEwwBCyACIAZQIgM6ABEgAEEEEKwBKAIAQRRqQQEQrAEoAgAiAg0CQQQQDiEDQciyBUEANgIAQS1BLBANIQJByLIFKAIAIQBByLIFQQA2AgACQAJAAkAgAEEBRwRAQciyBUEANgIAQS1BIBANIQBByLIFKAIAIQRByLIFQQA2AgAgBEEBRg0BIAEgADYCACABQpuAgICAhICAgH83AgQgAEEAOgAbIABB9+4CKAAANgAXIABB8O4CKQAANwAQIABB6O4CKQAANwAIIABB4O4CKQAANwAAQciyBUEANgIAQTIgAiABQfzuAkGrAUGn7wIQEBpByLIFKAIAIQBByLIFQQA2AgBBASEEIABBAUcEQCADIAI2AgBByLIFQQA2AgBBMSADQaDaAEEAEBJByLIFKAIAIQBByLIFQQA2AgBBACEEIABBAUcNBgsQBiEAEAcaIAEsAAtBf0wEQCABKAIAEPYMCyAEDQIMBAsQBiEAEAcaDAILEAYhABAHGgsgAhD2DAsgAxATCyAAEAgLAAsgAiADOgARIABBBRCsASgCACADOgARIAFBEGokAAvlDAEGfyAAIAEgAhClAyEHIABBvPECNgIAQciyBUEANgIAQS1BHBANIQJByLIFKAIAIQNByLIFQQA2AgACQAJAAkACQAJAAkACQAJAAkACQAJAAkAgA0EBRg0AQciyBUEANgIAIAIgAUHY8QIQoAQhA0HIsgUoAgAhBEHIsgVBADYCACAEQQFGDQEgAkEANgIYIAJCADcCECACQZDMAjYCAEHIsgVBADYCAEGgzAIoAgAgAkEBEAVByLIFKAIAIQRByLIFQQA2AgACQCAEQQFHBEBByLIFQQA2AgBB2QAgAkEQakEAEBUhBEHIsgUoAgAhBUHIsgVBADYCACAFQQFHDQELEAYhARAHGiACKAIYIQNByLIFQQA2AgAgAxDoAUHIsgUoAgAhA0HIsgVBADYCACADQQFHDQNBABALIQIQBxogAhCEAQALIARBADoAAEHIsgVBADYCAEH8ACAHIAMQBUHIsgUoAgAhA0HIsgVBADYCACADQQFGDQBByLIFQQA2AgBBLUEgEA0hA0HIsgUoAgAhBEHIsgVBADYCACAEQQFGDQNByLIFQQA2AgAgAyABQeXxAiACEMUEIQFByLIFKAIAIQJByLIFQQA2AgAgAkEBRg0EIANBqPUCNgIAQciyBUEANgIAQfwAIAcgAxAFQciyBSgCACECQciyBUEANgIAIAJBAUYNA0HIsgVBADYCAEEtQTAQDSECQciyBSgCACEEQciyBUEANgIAIARBAUYNAyADKAIEIQRByLIFQQA2AgBB4AAgAiAEQaDuAkEDQQMQEBpByLIFKAIAIQRByLIFQQA2AgAgBEEBRg0FQciyBUEANgIAQd8AIAEgAhAFQciyBSgCACECQciyBUEANgIAIAJBAUYNA0HIsgVBADYCAEEtQSAQDSECQciyBSgCACEEQciyBUEANgIAIARBAUYNAyADKAIEIQRByLIFQQA2AgAgAiAEQa3uAhCgBCEEQciyBSgCACEFQciyBUEANgIAIAVBAUYNBiACQQA2AhggAkIANwIQIAJBwM8CNgIAQciyBUEANgIAQdDPAigCACIFIAJBARAFQciyBSgCACEGQciyBUEANgIAAkAgBkEBRwRAQciyBUEANgIAQdwAIAJBEGpBABAVIQZByLIFKAIAIQhByLIFQQA2AgAgCEEBRw0BCxAGIQEQBxogAigCGCEDQciyBUEANgIAIAMQ6AFByLIFKAIAIQNByLIFQQA2AgAgA0EBRw0IQQAQCyECEAcaIAIQhAEACyAGQgA3AwAgAkEBOgAcIAJBoNACNgIAQciyBUEANgIAQd8AIAEgBBAFQciyBSgCACECQciyBUEANgIAIAJBAUYNA0HIsgVBADYCAEEtQSAQDSECQciyBSgCACEEQciyBUEANgIAIARBAUYNAyADKAIEIQRByLIFQQA2AgAgAiAEQbruAhCgBCEEQciyBSgCACEGQciyBUEANgIAIAZBAUYNCCACQQA2AhggAkIANwIQIAJBwM8CNgIAQciyBUEANgIAIAUgAkEBEAVByLIFKAIAIQVByLIFQQA2AgACQCAFQQFHBEBByLIFQQA2AgBB3AAgAkEQakEAEBUhBUHIsgUoAgAhBkHIsgVBADYCACAGQQFHDQELEAYhARAHGiACKAIYIQNByLIFQQA2AgAgAxDoAUHIsgUoAgAhA0HIsgVBADYCACADQQFHDQpBABALIQIQBxogAhCEAQALIAVCADcDACACQQc6ABwgAkGg0AI2AgBByLIFQQA2AgBB3wAgASAEEAVByLIFKAIAIQJByLIFQQA2AgAgAkEBRg0DQciyBUEANgIAQS1BJBANIQJByLIFKAIAIQRByLIFQQA2AgAgBEEBRg0DIAMoAgQhA0HIsgVBADYCAEH9ACACIANB7vECQQFBAEEAEBYaQciyBSgCACEDQciyBUEANgIAIANBAUYNCkHIsgVBADYCAEHfACABIAIQBUHIsgUoAgAhAkHIsgVBADYCACACQQFGDQMgAA8LEAYhARAHGgwKCxAGIQEQBxoLIAIQ9gwMCAsQBiEBEAcaDAcLEAYhARAHGiADEPYMDAYLEAYhARAHGiACEPYMDAULEAYhARAHGgsgAhD2DAwDCxAGIQEQBxoLIAIQ9gwMAQsQBiEBEAcaIAIQ9gwLIAcQpgMaIAEQCAALngECAX8BfiAAQRRqIgBBABCsASgCACIDIAEgAiADKAIAKAIYEQUAIABBARCsASgCACIDIAEgAiADKAIAKAIYEQUAIABBARCsASgCAEEQaiACEKkBKQMAIQQgAEEDEKwBKAIAIARQOgARIABBAhCsASgCACIDIAEgAiADKAIAKAIYEQUAIABBAxCsASgCACIAIAEgAiAAKAIAKAIYEQUACzsCAX8BfiAAQRRqIgNBARCsASgCAEEQaiACEKkBKQMAIQQgA0EDEKwBKAIAIARQOgARIAAgASACEM0EC6ADAQN/IAAgASACEKUDIQQgAEH88QI2AgBByLIFQQA2AgBBLUEgEA0hAkHIsgUoAgAhA0HIsgVBADYCAAJAAkACQAJAIANBAUcEQEHIsgVBADYCACACIAFBmPICEKAEIQFByLIFKAIAIQNByLIFQQA2AgAgA0EBRg0BIAJBADYCGCACQgA3AhAgAkHAzwI2AgBByLIFQQA2AgBB0M8CKAIAIAJBARAFQciyBSgCACEDQciyBUEANgIAAkAgA0EBRwRAQciyBUEANgIAQdwAIAJBEGpBABAVIQNByLIFKAIAIQVByLIFQQA2AgAgBUEBRw0BCxAGIQAQBxogAigCGCEBQciyBUEANgIAIAEQ6AFByLIFKAIAIQFByLIFQQA2AgAgAUEBRw0DQQAQCyECEAcaIAIQhAEACyADQgA3AwAgAkEoOgAcIAJBoNACNgIAQciyBUEANgIAQfwAIAQgARAFQciyBSgCACECQciyBUEANgIAIAJBAUcNBAsQBiEAEAcaDAILEAYhABAHGgsgAhD2DAsgBBCmAxogABAIAAsgAAvqCQEGfyAAIAFBABClAyEHIABBtPICNgIAQciyBUEANgIAQS1BHBANIQJByLIFKAIAIQNByLIFQQA2AgACQAJAAkACQAJAAkACQAJAAkACQCADQQFGDQBByLIFQQA2AgAgAiABQdDyAhCgBCEDQciyBSgCACEEQciyBUEANgIAIARBAUYNASACQQA2AhggAkIANwIQIAJBkMwCNgIAQciyBUEANgIAQaDMAigCACIFIAJBARAFQciyBSgCACEEQciyBUEANgIAAkAgBEEBRwRAQciyBUEANgIAQdkAIAJBEGpBABAVIQRByLIFKAIAIQZByLIFQQA2AgAgBkEBRw0BCxAGIQEQBxogAigCGCEAQciyBUEANgIAIAAQ6AFByLIFKAIAIQBByLIFQQA2AgAgAEEBRw0DQQAQCyECEAcaIAIQhAEACyAEQQA6AABByLIFQQA2AgBB/AAgByADEAVByLIFKAIAIQNByLIFQQA2AgAgA0EBRg0AQciyBUEANgIAQS1BIBANIQNByLIFKAIAIQRByLIFQQA2AgAgBEEBRg0DQciyBUEANgIAIAMgAUHf8gIgAhDFBCEEQciyBSgCACECQciyBUEANgIAIAJBAUYNBEHIsgVBADYCAEH8ACAHIAMQBUHIsgUoAgAhAkHIsgVBADYCACACQQFGDQNByLIFQQA2AgBBLUEcEA0hAkHIsgUoAgAhA0HIsgVBADYCACADQQFGDQNByLIFQQA2AgAgAiABQeryAhCgBCEDQciyBSgCACEGQciyBUEANgIAIAZBAUYNBSACQQA2AhggAkIANwIQIAJBkMwCNgIAQciyBUEANgIAIAUgAkEBEAVByLIFKAIAIQVByLIFQQA2AgACQCAFQQFHBEBByLIFQQA2AgBB2QAgAkEQakEAEBUhBUHIsgUoAgAhBkHIsgVBADYCACAGQQFHDQELEAYhARAHGiACKAIYIQBByLIFQQA2AgAgABDoAUHIsgUoAgAhAEHIsgVBADYCACAAQQFHDQdBABALIQIQBxogAhCEAQALIAVBADoAAEHIsgVBADYCAEHfACAEIAMQBUHIsgUoAgAhAkHIsgVBADYCACACQQFGDQNByLIFQQA2AgBBLUEcEA0hAkHIsgUoAgAhA0HIsgVBADYCACADQQFGDQNByLIFQQA2AgAgAiABQe3yAhCgBCEBQciyBSgCACEDQciyBUEANgIAIANBAUYNByACQQA2AhggAkIANwIQIAJB4M4CNgIAQciyBUEANgIAQfDOAigCACACQQEQBUHIsgUoAgAhA0HIsgVBADYCAAJAIANBAUcEQEHIsgVBADYCAEH7ACACQRBqQQAQFSEDQciyBSgCACEFQciyBUEANgIAIAVBAUcNAQsQBiEBEAcaIAIoAhghAEHIsgVBADYCACAAEOgBQciyBSgCACEAQciyBUEANgIAIABBAUcNCUEAEAshAhAHGiACEIQBAAsgA0EANgIAQciyBUEANgIAQd8AIAQgARAFQciyBSgCACECQciyBUEANgIAIAJBAUYNAyAADwsQBiEBEAcaDAgLEAYhARAHGgsgAhD2DAwGCxAGIQEQBxoMBQsQBiEBEAcaIAMQ9gwMBAsQBiEBEAcaCyACEPYMDAILEAYhARAHGgsgAhD2DAsgBxCmAxogARAIAAvNAQEDfyAAIAFBABClAyEDIABB/PICNgIAQciyBUEANgIAQS1BMBANIQJByLIFKAIAIQRByLIFQQA2AgACQAJAAkAgBEEBRwRAQciyBUEANgIAQeAAIAIgAUGY8wJBAEEAEBAaQciyBSgCACEBQciyBUEANgIAIAFBAUYNAUHIsgVBADYCAEH8ACADIAIQBUHIsgUoAgAhAUHIsgVBADYCACABQQFHDQMLEAYhABAHGgwBCxAGIQAQBxogAhD2DAsgAxCmAxogABAIAAsgAAsrACAAIAEQrAMgAEEcakEAEKwBKAIAIAAoAhhBABDABCAAIAFBAEF/EK0DC8UFAQF/AkACQAJAIAFBQGoiAkEKTQRAAkACQAJAAkACQAJAAkACQAJAIAJBAWsOCgECAwQFBgcGBwgAC0EwEP4LIQJByLIFQQA2AgBBrwQgAiAAEBUaQciyBSgCACEBQciyBUEANgIAIAFBAUcNCRAGIQEQBxoMCwtBMBD+CyECQciyBUEANgIAQbAEIAIgABAVGkHIsgUoAgAhAUHIsgVBADYCACABQQFHDQgQBiEBEAcaDAoLQTAQ/gshAkHIsgVBADYCAEGxBCACIAAQFRpByLIFKAIAIQFByLIFQQA2AgAgAUEBRw0HEAYhARAHGgwJC0EwEP4LIQJByLIFQQA2AgBBsgQgAiAAEBUaQciyBSgCACEBQciyBUEANgIAIAFBAUcNBhAGIQEQBxoMCAtBMBD+CyECQciyBUEANgIAQbMEIAIgABAVGkHIsgUoAgAhAUHIsgVBADYCACABQQFHDQUQBiEBEAcaDAcLQTAQ/gshAkHIsgVBADYCAEG0BCACIAAQFRpByLIFKAIAIQFByLIFQQA2AgAgAUEBRw0EEAYhARAHGgwGC0EwEP4LIQJByLIFQQA2AgBBtQQgAiAAIAEQFBpByLIFKAIAIQFByLIFQQA2AgAgAUEBRw0DEAYhARAHGgwFC0EwEP4LIQJByLIFQQA2AgBBtgQgAiAAIAEQFBpByLIFKAIAIQFByLIFQQA2AgAgAUEBRw0CEAYhARAHGgwEC0EwEP4LIQJByLIFQQA2AgBBtwQgAiAAEBUaQciyBSgCACEBQciyBUEANgIAIAFBAUcNARAGIQEQBxoMAwtBACECIAFB4AFxQcAARw0AQTAQ/gshAkHIsgVBADYCAEG4BCACIAAQFRpByLIFKAIAIQBByLIFQQA2AgAgAEEBRg0BIAIgAToACAsgAg8LEAYhARAHGgsgAhD2DCABEAgAC7EYAQR/IAAgASACEKUDIQUgAEGU+AI2AgACQAJAAkACQCACQX9qIgJBwgBLDQACQAJAAkACQAJAAkACQAJAAkAgAkEBaw5CAgMECQkJCQkJCQAJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJBQYHAQtByLIFQQA2AgBBLUEcEA0hAkHIsgUoAgAhA0HIsgVBADYCACADQQFGDQpByLIFQQA2AgAgAiABQbD4AhCgBCEDQciyBSgCACEEQciyBUEANgIAAkAgBEEBRwRAIAJBADYCGCACQgA3AhAgAkGQzAI2AgBByLIFQQA2AgBBoMwCKAIAIAJBARAFQciyBSgCACEEQciyBUEANgIAAkAgBEEBRwRAQciyBUEANgIAQdkAIAJBEGpBABAVIQRByLIFKAIAIQZByLIFQQA2AgAgBkEBRw0BCxAGIQAQBxogAigCGCEBQciyBUEANgIAIAEQ6AFByLIFKAIAIQFByLIFQQA2AgAgAUEBRw0CQQAQCyEAEAcaIAAQhAEACyAEQQA6AABByLIFQQA2AgBB/AAgBSADEAVByLIFKAIAIQJByLIFQQA2AgAgAkEBRg0MQciyBUEANgIAQS1BKBANIQJByLIFKAIAIQNByLIFQQA2AgAgA0EBRg0MQciyBUEANgIAIAIgAUG7+AJBAUH/AUEAQQAQzwQaQciyBSgCACEBQciyBUEANgIAIAFBAUYNCyACQcT5AjYCAEHIsgVBADYCAEH8ACAFIAIQBUHIsgUoAgAhAUHIsgVBADYCACABQQFHDQoMDAsQBiEAEAcaCyACEPYMDAsLQciyBUEANgIAQS1BHBANIQJByLIFKAIAIQNByLIFQQA2AgAgA0EBRg0JQciyBUEANgIAIAIgAUHG+AIQoAQhAUHIsgUoAgAhA0HIsgVBADYCAAJAIANBAUcEQCACQQA2AhggAkIANwIQIAJB4M4CNgIAQciyBUEANgIAQfDOAigCACACQQEQBUHIsgUoAgAhA0HIsgVBADYCACADQQFHBEBByLIFQQA2AgBB+wAgAkEQakEAEBUhA0HIsgUoAgAhBEHIsgVBADYCACAEQQFHDQkLEAYhABAHGiACKAIYIQFByLIFQQA2AgAgARDoAUHIsgUoAgAhAUHIsgVBADYCACABQQFHDQFBABALIQAQBxogABCEAQALEAYhABAHGgsgAhD2DAwKC0HIsgVBADYCAEEtQRwQDSECQciyBSgCACEDQciyBUEANgIAIANBAUYNCEHIsgVBADYCACACIAFBz/gCEKAEIQFByLIFKAIAIQNByLIFQQA2AgACQCADQQFHBEAgAkEANgIYIAJCADcCECACQeDOAjYCAEHIsgVBADYCAEHwzgIoAgAgAkEBEAVByLIFKAIAIQNByLIFQQA2AgACQCADQQFHBEBByLIFQQA2AgBB+wAgAkEQakEAEBUhA0HIsgUoAgAhBEHIsgVBADYCACAEQQFHDQELEAYhABAHGiACKAIYIQFByLIFQQA2AgAgARDoAUHIsgUoAgAhAUHIsgVBADYCACABQQFHDQJBABALIQAQBxogABCEAQALIANBADYCAEHIsgVBADYCAEH8ACAFIAEQBUHIsgUoAgAhAUHIsgVBADYCACABQQFGDQoMCAsQBiEAEAcaCyACEPYMDAkLQciyBUEANgIAQS1BHBANIQJByLIFKAIAIQNByLIFQQA2AgAgA0EBRg0HQciyBUEANgIAIAIgAUHc+AIQoAQhAUHIsgUoAgAhA0HIsgVBADYCAAJAIANBAUcEQCACQgA3AQ4gAkGA0QI2AgAgAkIANwEUQciyBUEANgIAQZDRAigCACACQQEQBUHIsgUoAgAhA0HIsgVBADYCAAJAIANBAUcEQEHIsgVBADYCAEGEAiACQRBqQQAQFSEDQciyBSgCACEEQciyBUEANgIAIARBAUcNAQsQBiEAEAcaIAIoAhghAUHIsgVBADYCACABEOgBQciyBSgCACEBQciyBUEANgIAIAFBAUcNAkEAEAshABAHGiAAEIQBAAsgA0EANgIAQciyBUEANgIAQfwAIAUgARAFQciyBSgCACEBQciyBUEANgIAIAFBAUYNCQwHCxAGIQAQBxoLIAIQ9gwMCAtByLIFQQA2AgBBLUEcEA0hAkHIsgUoAgAhA0HIsgVBADYCACADQQFGDQZByLIFQQA2AgAgAiABQeX4AhCgBCEBQciyBSgCACEDQciyBUEANgIAAkAgA0EBRwRAIAJBADYCGCACQgA3AhAgAkHgzgI2AgBByLIFQQA2AgBB8M4CKAIAIAJBARAFQciyBSgCACEDQciyBUEANgIAAkAgA0EBRwRAQciyBUEANgIAQfsAIAJBEGpBABAVIQNByLIFKAIAIQRByLIFQQA2AgAgBEEBRw0BCxAGIQAQBxogAigCGCEBQciyBUEANgIAIAEQ6AFByLIFKAIAIQFByLIFQQA2AgAgAUEBRw0CQQAQCyEAEAcaIAAQhAEACyADQQA2AgBByLIFQQA2AgBB/AAgBSABEAVByLIFKAIAIQFByLIFQQA2AgAgAUEBRg0IDAYLEAYhABAHGgsgAhD2DAwHC0HIsgVBADYCAEEtQRwQDSECQciyBSgCACEDQciyBUEANgIAIANBAUYNBUHIsgVBADYCACACIAFB8PgCEKAEIQFByLIFKAIAIQNByLIFQQA2AgACQCADQQFHBEAgAkEANgIYIAJCADcCECACQeDOAjYCAEHIsgVBADYCAEHwzgIoAgAgAkEBEAVByLIFKAIAIQNByLIFQQA2AgACQCADQQFHBEBByLIFQQA2AgBB+wAgAkEQakEAEBUhA0HIsgUoAgAhBEHIsgVBADYCACAEQQFHDQELEAYhABAHGiACKAIYIQFByLIFQQA2AgAgARDoAUHIsgUoAgAhAUHIsgVBADYCACABQQFHDQJBABALIQAQBxogABCEAQALIANBADYCAEHIsgVBADYCAEH8ACAFIAEQBUHIsgUoAgAhAUHIsgVBADYCACABQQFGDQcMBQsQBiEAEAcaCyACEPYMDAYLQciyBUEANgIAQS1BHBANIQJByLIFKAIAIQNByLIFQQA2AgAgA0EBRg0EQciyBUEANgIAIAIgAUH6+AIQoAQhAUHIsgUoAgAhA0HIsgVBADYCAAJAIANBAUcEQCACQQA2AhggAkIANwIQIAJB4M4CNgIAQciyBUEANgIAQfDOAigCACACQQEQBUHIsgUoAgAhA0HIsgVBADYCAAJAIANBAUcEQEHIsgVBADYCAEH7ACACQRBqQQAQFSEDQciyBSgCACEEQciyBUEANgIAIARBAUcNAQsQBiEAEAcaIAIoAhghAUHIsgVBADYCACABEOgBQciyBSgCACEBQciyBUEANgIAIAFBAUcNAkEAEAshABAHGiAAEIQBAAsgA0EANgIAQciyBUEANgIAQfwAIAUgARAFQciyBSgCACEBQciyBUEANgIAIAFBAUYNBgwECxAGIQAQBxoLIAIQ9gwMBQtByLIFQQA2AgBBLUEcEA0hAkHIsgUoAgAhA0HIsgVBADYCACADQQFGDQNByLIFQQA2AgAgAiABQYT5AhCgBCEBQciyBSgCACEDQciyBUEANgIAAkAgA0EBRwRAIAJBADYCGCACQgA3AhAgAkHgzgI2AgBByLIFQQA2AgBB8M4CKAIAIAJBARAFQciyBSgCACEDQciyBUEANgIAAkAgA0EBRwRAQciyBUEANgIAQfsAIAJBEGpBABAVIQNByLIFKAIAIQRByLIFQQA2AgAgBEEBRw0BCxAGIQAQBxogAigCGCEBQciyBUEANgIAIAEQ6AFByLIFKAIAIQFByLIFQQA2AgAgAUEBRw0CQQAQCyEAEAcaIAAQhAEACyADQQA2AgBByLIFQQA2AgBB/AAgBSABEAVByLIFKAIAIQFByLIFQQA2AgAgAUEBRg0FDAMLEAYhABAHGgsgAhD2DAwECyADQQA2AgBByLIFQQA2AgBB/AAgBSABEAVByLIFKAIAIQFByLIFQQA2AgAgAUEBRg0CCyAADwsQBiEAEAcaIAIQ9gwMAQsQBiEAEAcaCyAFEKYDGiAAEAgAC80BAQN/IAAgAUEAEKUDIQMgAEGY+QI2AgBByLIFQQA2AgBBLUEwEA0hAkHIsgUoAgAhBEHIsgVBADYCAAJAAkACQCAEQQFHBEBByLIFQQA2AgBB4AAgAiABQbT5AkEAQQAQEBpByLIFKAIAIQFByLIFQQA2AgAgAUEBRg0BQciyBUEANgIAQfwAIAMgAhAFQciyBSgCACEBQciyBUEANgIAIAFBAUcNAwsQBiEAEAcaDAELEAYhABAHGiACEPYMCyADEKYDGiAAEAgACyAAC+4BAAJAAkACQAJAIAJBf2oiAEHCAEsNAAJAIABBBGsOPAEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQALQTAQ/gshAEHIsgVBADYCAEGHASAAIAEgAhAUGkHIsgUoAgAhAkHIsgVBADYCACACQQFHDQEQBiECEAcaDAMLQTAQ/gshAEHIsgVBADYCAEHMBCAAIAEQFRpByLIFKAIAIQFByLIFQQA2AgAgAUEBRg0BIAAgAjoACAsgAA8LEAYhAhAHGgsgABD2DCACEAgACw0AIAAQ0AQaIAAQ9gwLlwEAIAAgASACEJIFGiAAQQA2AqwCIABCADcCpAIgAEGQ+wI2AgAgAEIANwKEAiAAQgA3AowCIABCADcClAIgAEIANwO4AiAAQgA3A8ACIABCADcDyAIgAEIANwPQAiAAQgA3A9gCIABCADcD4AIgAEIANwPoAiAAQQA2AvACIABCADcD+AIgAEIANwOAAyAAQQA2AogDIAALowEBAX8gAEGQ+wI2AgAgACgCpAIiAQRAIAEgASgCACgCBBEBAAsgAEEANgKkAiAAKAKoAiEBQciyBUEANgIAIAEQ6AFByLIFKAIAIQFByLIFQQA2AgAgAUEBRwRAIABBADYCqAIgACgCuAIiAQRAIAEgASgCACgCBBEBAAsgAEEANgK4AiAAEJUFGiAADwtBABALIQEQBxogABCVBRogARCEAQALpgEBAX8gAEGQ+wI2AgAgACgCpAIiAQRAIAEgASgCACgCBBEBAAsgAEEANgKkAiAAKAKoAiEBQciyBUEANgIAIAEQ6AFByLIFKAIAIQFByLIFQQA2AgAgAUEBRwRAIABBADYCqAIgACgCuAIiAQRAIAEgASgCACgCBBEBAAsgAEEANgK4AiAAEJUFGiAAEPYMDwtBABALIQEQBxogABCVBRogARCEAQAL2gEAAkAgACgCvAJFDQAgACgC5AIgACgC3AJBEGpBABCxAS8BAEEAEN0BIAAoAsgCQRBqQQAQqQEpAwBQRQRAIAAoAugCIAAoAsQCQRBqQQAQqQEpAwAgACgCyAJBEGpBABCpASkDAICnQf//A3FBABDdAQsgACgC7AIgACgC0AJBEGpBABCxASgCAEEDdEEAENcBIAAQpwVQDQAgACgC8AIgACgCxAJBEGpBABCpASkDACAAKAJsQRBqQQAQsQEoAgCtfkIDhiAAEKcFgKdBABDXAQsgAEEAEKMFC60CAQV/AkAgASgCBCABLQALIgAgAEEYdEEYdSIHQQBIGyIFIAIoAgQgAi0ACyIAIABBGHRBGHUiA0EASBsiBk8EQCAGRQ0BQQAhACACKAIAIAIgA0EASBshBSABKAIAIAEgB0EASBshAwNAIAAgA2osAAAQ/wVBGHRBGHUiASAAIAVqLAAAEP8FQRh0QRh1IgJIIAQgASACTHFyIQQgASACRw0CIABBAWoiACAGRw0AC0EADwsgBUUEQEEBDwtBACEAIAIoAgAgAiADQQBIGyEDIAEoAgAgASAHQQBIGyEGA0AgACAGaiwAABD/BUEYdEEYdSIBIAAgA2osAAAQ/wVBGHRBGHUiAkggBCABIAJMcXIhBCABIAJHDQEgAEEBaiIAIAVHDQALQQEPCyAEC+4BAQN/IABBADsBBCAAQdD7AjYCACAAQdT9AjYCCCAAQcj8AjYCECAAQfgAaiICQej9AjYCACAAQQA2AgxByLIFQQA2AgBBKSACIABBFGoiARAFQciyBSgCACEDQciyBUEANgIAAkAgA0EBRwRAIABB3PwCNgJ4IABBtPwCNgIIIABByPwCNgIQIABCgICAgHA3AsABQciyBUEANgIAQdUEIAEQDRpByLIFKAIAIQFByLIFQQA2AgAgAUEBRgRAEAYhARAHGgwCCyAAQgA3AsgBIABBADYC0AEgAA8LEAYhARAHGgsgAhDcBiABEAgAC/YCAQZ/IwBBEGsiAiQAIAAQ4gYhBSAAQgA3AjQgAEEANgIoIABCADcCICAAQdz+AjYCACAAQgA3AjwgAEIANwJEIABCADcCTCAAQgA3AlQgAEIANwBbIAJBCGogAEEEaiIGENsKIQFByLIFQQA2AgBB1gQgAUG8tAUQFSEDQciyBSgCACEEQciyBUEANgIAAkACQAJAIARBAUcEQCABEPcHIAMEQCACIAYQ2wohAUHIsgVBADYCAEE2IAFBvLQFEBUhA0HIsgUoAgAhBEHIsgVBADYCACAEQQFGDQIgACADNgJEIAEQ9wcgACAAKAJEIgEgASgCACgCHBEAADoAYgsgACgCACgCDCEBQciyBUEANgIAIAEgAEEAQYAgEBQaQciyBSgCACEBQciyBUEANgIAIAFBAUcNAhAGIQAQBxoMAwtBABALIQAQBxogABCEAQALEAYhABAHGiABEPcHDAELIAJBEGokACAADwsgBRDgBhogABAIAAuYAgEEfyAAAn8gAkF+aiICQQFLBEBBDCEDQQAMAQsgAkEBawR/QRwFQTwLIQNBAQs6AAUgAEEBOgAEAn8gASwAC0F/TARAIAEoAgAMAQsgAQshBCAAQQhqIQICQAJAIAAoAlQNAAJAIANBdGoiBkEQSwRAIANBPEcNAkHX/wIhBQwBC0HQ/wIhBQJAIAZBAWsOEAICAgICAgICAgICAgICAgABC0HT/wIhBQsgACAEIAUQmAYiBDYCVCAERQ0AIAAgAzYCbCACIAAoAghBdGooAgBqQQAQkwcMAQsgAiACKAIAQXRqKAIAaiIDIAMoAhBBBHIQkwcLIABByAFqIAEQigwgAiAAKAIIQXRqKAIAai0AEEEFcUEARwuoAgEFfyMAQSBrIgQkACAALQAEBEAgAEEIaiABEJYHCyAALQAFBEAgBEEYaiAAQRBqIgIQgwchBQJAIAIgAigCAEF0aigCAGoiAy0AEEEFcQ0AIAMoAhgiAygCACgCECEGQciyBUEANgIAIAYgBEEIaiADIAFBEBC2DUHIsgUoAgAhA0HIsgVBADYCAAJAIANBAUcEQCAEKQMQQn9SDQIgAiACKAIAQXRqKAIAaiICKAIQIQNByLIFQQA2AgBBOCACIANBBHIQBUHIsgUoAgAhAkHIsgVBADYCACACQQFHDQIQBiEAEAcaDAELEAYhABAHGgsgBRCFByAAEAgACyAFEIUHCyAAKAIIQXRqKAIAIABBCGpqLQAQIQAgBEEgaiQAIABBBXFBAEcLPQEBfyAAQQhqIgUgASACpxCRB0EBIQEgBSAAKAIIQXRqKAIAai0AEEEFcQR/IAEFIAMgADQCDDcDAEEACws5ACAAQRBqIAEgAqcQsgdBASEBIAAoAghBdGooAgAgAEEIamotABBBBXEEfyABBSADIAI3AwBBAAsLwQEBBX8gAEEIaiEBAkACQCAAKAJUIgIEQCAAQRRqIgQoAgAoAhghA0HIsgVBADYCACADIAQQDSEDQciyBSgCACEFQciyBUEANgIAIAVBAUYNAiACEJQGIQIgAEEANgJUIARBAEEAIAAoAhQoAgwRBAAaIAIgA3JFDQELIAEgASgCAEF0aigCAGoiACAAKAIQQQRyEJMHCyABIAEoAgBBdGooAgBqLQAQQQVxQQBHDwsQBiEAEAcaIAIQlAYaIAAQCAALhAEBAn8jAEEQayICJAAgAiAAQcgBahCHDCEAQciyBUEANgIAQdcEIAAgARAVIQFByLIFKAIAIQNByLIFQQA2AgAgA0EBRwRAIAAsAAtBf0wEQCAAKAIAEPYMCyACQRBqJAAgAQ8LEAYhAhAHGiAALAALQX9MBEAgACgCABD2DAsgAhAIAAtLAQJ/QdQBEP4LIQBByLIFQQA2AgBB2AQgABANGkHIsgUoAgAhAUHIsgVBADYCACABQQFHBEAgAA8LEAYhARAHGiAAEPYMIAEQCAALUwEBfyAAQdD7AjYCACAALADTAUF/TARAIAAoAsgBEPYMCyAAQbT8AjYCCCAAQfgAaiIBQdz8AjYCACAAQcj8AjYCECAAQRRqENMFGiABENwGIAALpgIBAn8gAEHc/gI2AgACQAJAIAAoAkAiAUUNAEHIsgVBADYCAEHZBCAAEA0aQciyBSgCACECQciyBUEANgIAAkAgAkEBRwRAIAEQlAYaIABBADYCQCAAKAIAKAIMIQFByLIFQQA2AgAgASAAQQBBABAUGkHIsgUoAgAhAUHIsgVBADYCACABQQFHDQJBABALIQIQBxoMAQtBABALIQIQBxogARCUBhoLIAIQDBpByLIFQQA2AgBBOhAKQciyBSgCACEBQciyBUEANgIAIAFBAUYNAQsCQCAALQBgRQ0AIAAoAiAiAUUNACABEPYMCwJAIAAtAGFFDQAgACgCOCIBRQ0AIAEQ9gwLIAAQ4AYaIAAPC0EAEAshARAHGiAAEOAGGiABEIQBAAtWAQF/IABB0PsCNgIAIAAsANMBQX9MBEAgACgCyAEQ9gwLIABBtPwCNgIIIABB+ABqIgFB3PwCNgIAIABByPwCNgIQIABBFGoQ0wUaIAEQ3AYgABD2DAsxACAAQdz8AjYCcCAAQbT8AjYCACAAQcj8AjYCCCAAQQxqENMFGiAAQfAAahDcBiAACzoBAn8gAEHI/AI2AgAgAEHoAGoiAUHc/AI2AgAgAEF4aiICQbT8AjYCACAAQQRqENMFGiABENwGIAILPwAgACAAKAIAQXRqKAIAaiIAQdz8AjYCcCAAQbT8AjYCACAAQcj8AjYCCCAAQQxqENMFGiAAQfAAahDcBiAACzQAIABB3PwCNgJwIABBtPwCNgIAIABByPwCNgIIIABBDGoQ0wUaIABB8ABqENwGIAAQ9gwLPQECfyAAQcj8AjYCACAAQegAaiIBQdz8AjYCACAAQXhqIgJBtPwCNgIAIABBBGoQ0wUaIAEQ3AYgAhD2DAtCACAAIAAoAgBBdGooAgBqIgBB3PwCNgJwIABBtPwCNgIAIABByPwCNgIIIABBDGoQ0wUaIABB8ABqENwGIAAQ9gwL6wMCBX8BfiMAQRBrIgQkAAJAIAAoAkBFDQACQCAAKAJEIgIEQAJAIAAoAlwiAUEQcQRAIAAoAhggACgCFEcEQEF/IQMgAEF/IAAoAgAoAjQRAwBBf0YNBQsgAEHIAGohBQNAIAAoAkQiASAFIAAoAiAiAiACIAAoAjRqIARBDGogASgCACgCFBEIACECQX8hAyAAKAIgIgEgBCgCDCABayIBIAAoAkAQhg0gAUcNBSACQQFGDQALIAJBAkYNBCAAKAJAEMMGRQ0BDAQLIAFBCHFFDQAgBCAAKQJQNwMAAn8gAC0AYgRAIAAoAhAgACgCDGusIQZBAAwBCyACIAIoAgAoAhgRAAAhASAAKAIoIAAoAiQiAmusIQYgAUEBTgRAIAAoAhAgACgCDGsgAWysIAZ8IQZBAAwBC0EAIAAoAgwiASAAKAIQRg0AGiAAKAJEIgMgBCAAKAIgIAIgASAAKAIIayADKAIAKAIgEQgAIQEgACgCJCABayAAKAIga6wgBnwhBkEBCyEBIAAoAkBCACAGfUEBEJMGDQIgAQRAIAAgBCkDADcCSAsgAEEANgJcIABBADYCECAAQgA3AgggACAAKAIgIgE2AiggACABNgIkC0EAIQMMAgsQ4AUAC0F/IQMLIARBEGokACADCwoAIAAQ0wUQ9gwLlQIBAX8gACAAKAIAKAIYEQAAGiAAIAFBvLQFEPwHIgE2AkQgAC0AYiECIAAgASABKAIAKAIcEQAAIgE6AGIgASACRwRAIABCADcCCCAAQgA3AhggAEIANwIQIAAtAGAhAiABBEACQCACRQ0AIAAoAiAiAUUNACABEPYMCyAAIAAtAGE6AGAgACAAKAI8NgI0IAAoAjghASAAQgA3AjggACABNgIgIABBADoAYQ8LAkAgAg0AIAAoAiAiASAAQSxqRg0AIABBADoAYSAAIAE2AjggACAAKAI0IgE2AjwgARD+CyEBIABBAToAYCAAIAE2AiAPCyAAIAAoAjQiATYCPCABEP4LIQEgAEEBOgBhIAAgATYCOAsLiQIBAn8gAEIANwIIIABCADcCGCAAQgA3AhACQCAALQBgRQ0AIAAoAiAiA0UNACADEPYMCwJAIAAtAGFFDQAgACgCOCIDRQ0AIAMQ9gwLIAAgAjYCNCAAAn8CQAJAIAJBCU8EQCAALQBiIQMCQCABRQ0AIANB/wFxRQ0AIABBADoAYCAAIAE2AiAMAwsgAhD+CyEEIABBAToAYCAAIAQ2AiAMAQsgAEEAOgBgIABBCDYCNCAAIABBLGo2AiAgAC0AYiEDCyADQf8BcQ0AIAAgAkEIIAJBCEobIgM2AjxBACABDQEaIAMQ/gshAUEBDAELQQAhASAAQQA2AjxBAAs6AGEgACABNgI4IAALpQEBAn4gASgCRCIEBEAgBCAEKAIAKAIYEQAAIQRCfyEFAkAgASgCQEUNACACUEVBACAEQQFIGw0AIAEgASgCACgCGBEAAA0AIANBAksNACABKAJAIASsIAJ+QgAgBEEAShsgAxCTBg0AAn4gASgCQCIDKAJMQX9MBEAgAxDCBgwBCyADEMIGCyEFIAEpAkghBgsgACAFNwMIIAAgBjcDAA8LEOAFAAslAQJ/QQQQDiIAIgEQ/wsaIAFB9PgDNgIAIABBsPkDQdoEEBEAC2sAAkAgASgCQARAIAEgASgCACgCGBEAAEUNAQsgAEJ/NwMIIABCADcDAA8LIAEoAkAgAikDCEEAEJMGBEAgAEJ/NwMIIABCADcDAA8LIAEgAikDADcCSCAAIAIpAwg3AwggACACKQMANwMAC7IFAQV/IwBBEGsiBCQAAkACQCAAKAJARQRAQX8hAQwBCwJ/IAAtAFxBCHEEQCAAKAIMIQFBAAwBCyAAQQA2AhwgAEIANwIUIABBNEE8IAAtAGIiARtqKAIAIQMgAEEgQTggARtqKAIAIQEgAEEINgJcIAAgATYCCCAAIAEgA2oiATYCECAAIAE2AgxBAQshAyABRQRAIAAgBEEQaiIBNgIQIAAgATYCDCAAIARBD2o2AggLAn8gAwRAIAAoAhAhAkEADAELIAAoAhAiAiAAKAIIa0ECbSIDQQQgA0EESRsLIQMCfyABIAJGBEAgACgCCCABIANrIAMQgg0gAC0AYgRAQX8gACgCCCIBIANqIAAoAhAgA2sgAWsgACgCQBCbBiICRQ0CGiAAIAAoAgggA2oiATYCDCAAIAEgAmo2AhAgAS0AAAwCCyAAKAIoIgIgACgCJCIBRwRAIAAoAiAgASACIAFrEIINIAAoAighAiAAKAIkIQELIAAgACgCICIFIAIgAWtqIgE2AiQgACAAQSxqIAVGBH9BCAUgACgCNAsgBWoiAjYCKCAAIAApAkg3AlBBfyABIAIgAWsiAiAAKAI8IANrIgUgAiAFSRsgACgCQBCbBiICRQ0BGiAAKAJEIgFFDQMgACAAKAIkIAJqIgI2AiggASAAQcgAaiAAKAIgIAIgAEEkaiAAKAIIIgUgA2ogBSAAKAI8aiAEQQhqIAEoAgAoAhARDgBBA0YEQCAAIAAoAig2AhAgACAAKAIgIgE2AgwgACABNgIIIAEtAAAMAgtBfyAEKAIIIgIgACgCCCADaiIBRg0BGiAAIAI2AhAgACABNgIMIAEtAAAMAQsgAS0AAAshASAAKAIIIARBD2pHDQAgAEEANgIQIABCADcCCAsgBEEQaiQAIAEPCxDgBQALbQECf0F/IQICQCAAKAJARQ0AIAAoAgggACgCDCIDTw0AIAFBf0YEQCAAIANBf2o2AgxBAA8LIAAtAFhBEHFFBEAgA0F/ai0AACABQf8BcUcNAQsgACADQX9qIgI2AgwgAiABOgAAIAEhAgsgAgvPBAEIfyMAQRBrIgQkAAJ/AkAgACgCQEUNAAJAIAAtAFxBEHEEQCAAKAIUIQUgACgCHCEHDAELIABBADYCECAAQgA3AggCQCAAKAI0IgJBCU8EQCAALQBiBEAgACAAKAIgIgU2AhggACAFNgIUIAAgAiAFakF/aiIHNgIcDAILIAAgACgCOCIFNgIYIAAgBTYCFCAAIAUgACgCPGpBf2oiBzYCHAwBCyAAQQA2AhwgAEIANwIUCyAAQRA2AlwLIAAoAhghAiABQX9GBH8gBQUgAgR/IAIFIAAgBEEQajYCHCAAIARBD2o2AhQgACAEQQ9qNgIYIARBD2oLIAE6AAAgACAAKAIYQQFqIgI2AhggACgCFAshAyACIANHBEACQCAALQBiBEBBfyADIAIgA2siAiAAKAJAEIYNIAJHDQQaDAELIAQgACgCICIGNgIIAkAgACgCRCIIRQ0AIABByABqIQkDQCAIIAkgAyACIARBBGogBiAGIAAoAjRqIARBCGogCCgCACgCDBEOACECIAAoAhQiAyAEKAIERg0EIAJBA0YEQCADIAAoAhggA2siAiAAKAJAEIYNIAJHDQUMAwsgAkEBSw0EIAAoAiAiAyAEKAIIIANrIgMgACgCQBCGDSADRw0EIAJBAUcNAiAAIAQoAgQiAzYCFCAAIAAoAhgiAjYCHCAAKAJEIghFDQEgACgCICEGDAAACwALEOAFAAsgACAHNgIcIAAgBTYCFCAAIAU2AhgLQQAgASABQX9GGwwBC0F/CyEGIARBEGokACAGC/ABAQF/IABB5P8CNgIAQciyBUEANgIAQZYDIABBBGogARAVIQFByLIFKAIAIQRByLIFQQA2AgACQCAEQQFHBEAgAEIANwMYIAAgAjYCFCAAQQA6ABAgAEIANwMgIANFBEBByLIFQQA2AgBB+AQQGyEDQciyBSgCACECQciyBUEANgIAIAJBAUYNAgsgACAAQSBqNgI8IAAgAEEYajYCOCAAIABBFGo2AjQgACAAQRBqNgIwIAAgATYCLCAAIAM2AiggAA8LEAYhABAHGiAAEAgACxAGIQAQBxogASwAC0F/TARAIAEoAgAQ9gwLIAAQCAALpAEBAn8gAEHk/wI2AgACQAJAIAAtABBFDQAgACgCKCIBKAIAKAIYIQJByLIFQQA2AgAgAiABEA0hAUHIsgUoAgAhAkHIsgVBADYCACACQQFGDQEgAQ0AIABBADoAEAsgACgCKCIBBEAgASABKAIAKAIEEQEACyAALAAPQX9MBEAgACgCBBD2DAsgAA8LQQAQCyEBEAcaIABBBGoQiQwaIAEQhAEAC6cBAQJ/IABB5P8CNgIAAkACQCAALQAQRQ0AIAAoAigiASgCACgCGCECQciyBUEANgIAIAIgARANIQFByLIFKAIAIQJByLIFQQA2AgAgAkEBRg0BIAENACAAQQA6ABALIAAoAigiAQRAIAEgASgCACgCBBEBAAsgACwAD0F/TARAIAAoAgQQ9gwLIAAQ9gwPC0EAEAshARAHGiAAQQRqEIkMGiABEIQBAAuOAgEDfyMAQRBrIgQkAEEBIQMCQAJAIAAtABANAAJ/IAEsAAsiA0F/TARAIAEoAgQMAQsgA0H/AXELBEAgAEEEaiABEIoMCyACBEAgACACNgIUCyAAKAIoIQEgBCAAQQRqEIcMIQMgACgCFCECIAEoAgAoAgghBUHIsgVBADYCACAFIAEgAyACEBQhAUHIsgUoAgAhAkHIsgVBADYCACACQQFGDQEgAywAC0F/TARAIAMoAgAQ9gwLQQEhAyABDQAgACgCKCIBIABBGGogASgCACgCHBEDAA0AIABBAToAEEEAIQMLIARBEGokACADDwsQBiEAEAcaIAMsAAtBf0wEQCADKAIAEPYMCyAAEAgACzYBAn9BASECAkAgAC0AEEUNACAAKAIoIgMgASADKAIAKAIMERMADQAgACABNwMgQQAhAgsgAgtfAQJ/IANCADcDAEEBIQUCQCAALQAQRQ0AIAAoAigiBiABIAIgAyAEIAYoAgAoAhAREAANACAAIAApAyAgAykDAHwiAjcDIEEAIQUgAiAAKQMYVw0AIAAgAjcDGAsgBQtfAQJ/IANCADcDAEEBIQUCQCAALQAQRQ0AIAAoAigiBiABIAIgAyAEIAYoAgAoAhQREAANACAAIAApAyAgAykDAHwiAjcDIEEAIQUgAiAAKQMYVw0AIAAgAjcDGAsgBQs1AQJ/IAAtABBFBEBBAA8LQQEhASAAKAIoIgIgAigCACgCGBEAAAR/IAEFIABBADoAEEEACwsiACAALQAQRQRAQQAPCyAAKAIoIgAgASAAKAIAKAIcEQMACzIAIABBADYCHCAAQYyAAzYCACAAIAEpAgA3AgQgACABKQIINwIMIAAgASkCEDcCFCAACz4BAX8gAkEAIAJBf2pBA0kbIQIgACgCBCEDIAAgASwAC0F/TAR/IAEoAgAFIAELIAIgAxEDACIBNgIcIAFFCxQAIAAoAhwgASAAKAIIERMAQQBHCxoAIAAoAhwgASACIAMgBCAAKAIMERAAQQBHCxoAIAAoAhwgASACIAMgBCAAKAIQERAAQQBHCxIAIAAoAhwgACgCFBEAAEEARwsUACAAKAIcIAEgACgCGBEDAEEARwtSAQJ/IwBB4ABrIgIkACABQgA3AwBBASEDIAAsAAtBf0wEfyAAKAIABSAACyACQQhqECYQigZFBEAgASACKQMwNwMAQQAhAwsgAkHgAGokACADCxkAQdupBSwAAEF/TARAQdCpBSgCABD2DAsLGQBB56kFLAAAQX9MBEBB3KkFKAIAEPYMCwsJAEGoqgUoAgALTQIBfwJ+IwBBEGsiACQAAn4gAEEIakEAECVFBEAgACgCDEHoB22sIQEgADQCCELoB34MAQsgAEIANwMIQgALIQIgAEEQaiQAIAEgAnwLHAAgAEEgckGff2pBGkkEf0EBBSAAEPsFQQBHCwsKACAAQVBqQQpJCwcAIAAQ+wULEwAgAEEgciAAIABBv39qQRpJGwsLACAAQWBqQd8ASQsUACAAQd8AcSAAIABBn39qQRpJGwsuAQJ/IwBBEGsiASQAIAFBDGogABD6DCECIAEoAgwhACABQRBqJABBACAAIAIbC2YBA38gAkUEQEEADwsCQCAALQAAIgNFDQADQAJAIAMgAS0AACIFRw0AIAJBf2oiAkUNACAFRQ0AIAFBAWohASAALQABIQMgAEEBaiEAIAMNAQwCCwsgAyEECyAEQf8BcSABLQAAawtDAQN/AkAgAkUNAANAIAAtAAAiBCABLQAAIgVGBEAgAUEBaiEBIABBAWohACACQX9qIgINAQwCCwsgBCAFayEDCyADC00BAn8gAS0AACECAkAgAC0AACIDRQ0AIAIgA0cNAANAIAEtAAEhAiAALQABIgNFDQEgAUEBaiEBIABBAWohACACIANGDQALCyADIAJrC+gBAQJ/IAJBAEchAwJAAkACQAJAIAJFDQAgAEEDcUUNACABQf8BcSEEA0AgAC0AACAERg0CIABBAWohACACQX9qIgJBAEchAyACRQ0BIABBA3ENAAsLIANFDQELIAAtAAAgAUH/AXFGDQECQCACQQRPBEAgAUH/AXFBgYKECGwhBANAIAAoAgAgBHMiA0F/cyADQf/9+3dqcUGAgYKEeHENAiAAQQRqIQAgAkF8aiICQQNLDQALCyACRQ0BCyABQf8BcSEDA0AgAC0AACADRg0CIABBAWohACACQX9qIgINAAsLQQAPCyAAC3MBA38CQCAALQAAIgJFDQADQCABLQAAIgRFBEAgAiEDDAILAkAgAiAERg0AIAIQ/QUgAS0AABD9BUYNACAALQAAIQMMAgsgAUEBaiEBIAAtAAEhAiAAQQFqIQAgAg0ACwsgA0H/AXEQ/QUgAS0AABD9BWsLGgAgACABEIkGIgBBACAALQAAIAFB/wFxRhsLyAEBAX8CQAJAIAAgAXNBA3ENACABQQNxBEADQCAAIAEtAAAiAjoAACACRQ0DIABBAWohACABQQFqIgFBA3ENAAsLIAEoAgAiAkF/cyACQf/9+3dqcUGAgYKEeHENAANAIAAgAjYCACABKAIEIQIgAEEEaiEAIAFBBGohASACQf/9+3dqIAJBf3NxQYCBgoR4cUUNAAsLIAAgAS0AACICOgAAIAJFDQADQCAAIAEtAAEiAjoAASAAQQFqIQAgAUEBaiEBIAINAAsLC/oBAQF/AkACQAJAIAAgAXNBA3ENACACQQBHIQMCQCACRQ0AIAFBA3FFDQADQCAAIAEtAAAiAzoAACADRQ0EIABBAWohACABQQFqIQEgAkF/aiICQQBHIQMgAkUNASABQQNxDQALCyADRQ0BIAEtAABFDQIgAkEESQ0AA0AgASgCACIDQX9zIANB//37d2pxQYCBgoR4cQ0BIAAgAzYCACAAQQRqIQAgAUEEaiEBIAJBfGoiAkEDSw0ACwsgAkUNAANAIAAgAS0AACIDOgAAIANFDQIgAEEBaiEAIAFBAWohASACQX9qIgINAAsLQQAhAgsgAEEAIAIQgQ0aC9sBAQJ/AkAgAUH/AXEiAwRAIABBA3EEQANAIAAtAAAiAkUNAyACIAFB/wFxRg0DIABBAWoiAEEDcQ0ACwsCQCAAKAIAIgJBf3MgAkH//ft3anFBgIGChHhxDQAgA0GBgoQIbCEDA0AgAiADcyICQX9zIAJB//37d2pxQYCBgoR4cQ0BIAAoAgQhAiAAQQRqIQAgAkH//ft3aiACQX9zcUGAgYKEeHFFDQALCwNAIAAiAi0AACIDBEAgAkEBaiEAIAMgAUH/AXFHDQELCyACDwsgABCIDSAAag8LIAALHAAgAEGBYE8Ef0GoqgVBACAAazYCAEF/BSAACwuOAQEDfwJAAkADQCAAIAJBwIEDai0AAEcEQEHXACEEIAJBAWoiAkHXAEcNAQwCCwsgAiEEIAINAEGgggMhAwwBC0GgggMhAgNAIAItAAAhACACQQFqIgMhAiAADQAgAyECIARBf2oiBA0ACwsgASgCFCIABH8gACgCACAAKAIEIAMQzwcFQQALIgAgAyAAGwsGAEGoqgULuwEBAn8jAEGgAWsiBCQAIARBCGpBsJADQZABEIANGgJAAkAgAUF/akH/////B08EQCABDQFBASEBIARBnwFqIQALIAQgADYCNCAEIAA2AhwgBEF+IABrIgUgASABIAVLGyIBNgI4IAQgACABaiIANgIkIAQgADYCGCAEQQhqIAIgAxCsBiEAIAFFDQEgBCgCHCIBIAEgBCgCGEZrQQA6AAAMAQtBqKoFQT02AgBBfyEACyAEQaABaiQAIAALNAEBfyAAKAIUIgMgASACIAAoAhAgA2siAyADIAJLGyIDEIANGiAAIAAoAhQgA2o2AhQgAguNAQECfyMAQaABayICJAAgAkEIakGwkANBkAEQgA0aIAIgADYCNCACIAA2AhwgAkF+IABrIgNB/////wdB/////wcgA0sbIgM2AjggAiAAIANqIgA2AiQgAiAANgIYIAJBCGpBnMcAIAEQrwYgAwRAIAIoAhwiAyADIAIoAhhGa0EAOgAACyACQaABaiQACw4AIABBqJoDKAIAEJEGC4YBAQF/IAEoAkxBAEgEQAJAIAEsAEsgAEH/AXFGDQAgASgCFCICIAEoAhBPDQAgASACQQFqNgIUIAIgADoAAA8LIAEgABCEDQ8LAkACQCABLABLIABB/wFxRg0AIAEoAhQiAiABKAIQTw0AIAEgAkEBajYCFCACIAA6AAAMAQsgASAAEIQNCwt9ACACQQFGBEAgASAAKAIIIAAoAgRrrH0hAQsCQCAAKAIUIAAoAhxLBEAgAEEAQQAgACgCJBEEABogACgCFEUNAQsgAEEANgIcIABCADcDECAAIAEgAiAAKAIoERsAQgBTDQAgAEIANwIEIAAgACgCAEFvcTYCAEEADwtBfwsgACAAKAJMQX9MBEAgACABIAIQkgYPCyAAIAEgAhCSBguXAQEEfyAAKAJMQQBOBH9BAQVBAAsaIAAoAgBBAXEiBEUEQCAAKAI0IgEEQCABIAAoAjg2AjgLIAAoAjgiAgRAIAIgATYCNAsgAEG4qgUoAgBGBEBBuKoFIAI2AgALCyAAEMMGIQMgACAAKAIMEQAAIQEgACgCYCICBEAgAhD2DAsgASADciEDIARFBEAgABD2DCADDwsgAwsqAQF/IwBBEGsiBCQAIAQgAzYCDCAAIAEgAiADEI0GIQMgBEEQaiQAIAMLCQAgACgCPBAqC8QCAQJ/IwBBIGsiAyQAAn8CQAJAQcCRAyABLAAAEIYGRQRAQaiqBUEcNgIADAELQZgJEPUMIgINAQtBAAwBCyACQQBBkAEQgQ0aIAFBKxCGBkUEQCACQQhBBCABLQAAQfIARhs2AgALAkAgAS0AAEHhAEcEQCACKAIAIQEMAQsgAEEDQQAQKCIBQYAIcUUEQCADIAFBgAhyNgIQIABBBCADQRBqECgaCyACIAIoAgBBgAFyIgE2AgALIAJB/wE6AEsgAkGACDYCMCACIAA2AjwgAiACQZgBajYCLAJAIAFBCHENACADIANBGGo2AgAgAEGTqAEgAxApDQAgAkEKOgBLCyACQYwFNgIoIAJBjQU2AiQgAkGOBTYCICACQY8FNgIMQeypBSgCAEUEQCACQX82AkwLIAIQyAYLIQIgA0EgaiQAIAILcQEDfyMAQRBrIgIkAAJAAkBBxJEDIAEsAAAQhgZFBEBBqKoFQRw2AgAMAQsgARDFBiEEIAJBtgM2AgAgACAEQYCAAnIgAhAnEIoGIgBBAEgNASAAIAEQlwYiAw0BIAAQKhoLQQAhAwsgAkEQaiQAIAMLIgEBfyMAQRBrIgIkACACIAE2AgwgACABEI8GIAJBEGokAAt8AQJ/IAAgAC0ASiIBQX9qIAFyOgBKIAAoAhQgACgCHEsEQCAAQQBBACAAKAIkEQQAGgsgAEEANgIcIABCADcDECAAKAIAIgFBBHEEQCAAIAFBIHI2AgBBfw8LIAAgACgCLCAAKAIwaiICNgIIIAAgAjYCBCABQRt0QR91C7QBAQN/IAIoAkxBAE4Ef0EBBSAFCxogAiACLQBKIgNBf2ogA3I6AEoCfyABIgUgAigCCCACKAIEIgRrIgNBAUgNABogACAEIAMgBSADIAVJGyIEEIANGiACIAIoAgQgBGo2AgQgACAEaiEAIAUgBGsLIgMEQANAAkAgAhCaBkUEQCACIAAgAyACKAIgEQQAIgRBAWpBAUsNAQsgBSADaw8LIAAgBGohACADIARrIgMNAAsLIAELVQECfyABIAAoAlQiAyADQQAgAkGAAmoiARCEBiIEIANrIAEgBBsiASACIAEgAkkbIgIQgA0aIAAgASADaiIBNgJUIAAgATYCCCAAIAIgA2o2AgQgAgtKAQF/IwBBkAFrIgMkACADQQBBkAEQgQ0iA0F/NgJMIAMgADYCLCADQZAFNgIgIAMgADYCVCADIAEgAhC8BiEAIANBkAFqJAAgAAsLACAAIAEgAhCcBgsoAQF/IwBBEGsiAyQAIAMgAjYCDCAAIAEgAhCdBiECIANBEGokACACC5QCAAJAIAAEfyABQf8ATQ0BAkBB1JAEKAIAKAIARQRAIAFBgH9xQYC/A0YNA0GoqgVBGTYCAAwBCyABQf8PTQRAIAAgAUE/cUGAAXI6AAEgACABQQZ2QcABcjoAAEECDwsgAUGAsANPQQAgAUGAQHFBgMADRxtFBEAgACABQT9xQYABcjoAAiAAIAFBDHZB4AFyOgAAIAAgAUEGdkE/cUGAAXI6AAFBAw8LIAFBgIB8akH//z9NBEAgACABQT9xQYABcjoAAyAAIAFBEnZB8AFyOgAAIAAgAUEGdkE/cUGAAXI6AAIgACABQQx2QT9xQYABcjoAAUEEDwtBqKoFQRk2AgALQX8FQQELDwsgACABOgAAQQELFAAgAEUEQEEADwsgACABQQAQoAYLfwIBfwF+IAC9IgNCNIinQf8PcSICQf8PRwR8IAJFBEAgASAARAAAAAAAAAAAYQR/QQAFIABEAAAAAAAA8EOiIAEQogYhACABKAIAQUBqCzYCACAADwsgASACQYJ4ajYCACADQv////////+HgH+DQoCAgICAgIDwP4S/BSAACwv8AgEDfyMAQdABayIFJAAgBSACNgLMAUEAIQIgBUGgAWpBAEEoEIENGiAFIAUoAswBNgLIAQJAQQAgASAFQcgBaiAFQdAAaiAFQaABaiADIAQQpAZBAEgEQEF/IQEMAQsgACgCTEEATgRAQQEhAgsgACgCACEGIAAsAEpBAEwEQCAAIAZBX3E2AgALIAZBIHEhBgJ/IAAoAjAEQCAAIAEgBUHIAWogBUHQAGogBUGgAWogAyAEEKQGDAELIABB0AA2AjAgACAFQdAAajYCECAAIAU2AhwgACAFNgIUIAAoAiwhByAAIAU2AiwgACABIAVByAFqIAVB0ABqIAVBoAFqIAMgBBCkBiIBIAdFDQAaIABBAEEAIAAoAiQRBAAaIABBADYCMCAAIAc2AiwgAEEANgIcIABBADYCECAAKAIUIQMgAEEANgIUIAFBfyADGwshASAAIAAoAgAiAyAGcjYCAEF/IAEgA0EgcRshASACRQ0ACyAFQdABaiQAIAEL2xECD38BfiMAQdAAayIHJAAgByABNgJMIAdBN2ohFSAHQThqIRJBACEBAkACQANAAkAgD0EASA0AIAFB/////wcgD2tKBEBBqKoFQT02AgBBfyEPDAELIAEgD2ohDwsgBygCTCIMIQECQAJAAkACfwJAAkACQAJAAkACQAJAAkACQCAMLQAAIggEQANAAkACQAJAIAhB/wFxIghFBEAgASEIDAELIAhBJUcNASABIQgDQCABLQABQSVHDQEgByABQQJqIgk2AkwgCEEBaiEIIAEtAAIhCiAJIQEgCkElRg0ACwsgCCAMayEBIAAEQCAAIAwgARClBgsgAQ0RQX8hEUEBIQggBygCTCwAARD7BSEJIAcoAkwhAQJAIAlFDQAgAS0AAkEkRw0AIAEsAAFBUGohEUEBIRNBAyEICyAHIAEgCGoiATYCTEEAIQgCQCABLAAAIhBBYGoiCkEfSwRAIAEhCQwBCyABIQlBASAKdCIKQYnRBHFFDQADQCAHIAFBAWoiCTYCTCAIIApyIQggASwAASIQQWBqIgpBH0sNASAJIQFBASAKdCIKQYnRBHENAAsLAkAgEEEqRgRAIAcCfwJAIAksAAEQ+wVFDQAgBygCTCIJLQACQSRHDQAgCSwAAUECdCAEakHAfmpBCjYCACAJLAABQQN0IANqQYB9aigCACENQQEhEyAJQQNqDAELIBMNFUEAIRNBACENIAAEQCACIAIoAgAiAUEEajYCACABKAIAIQ0LIAcoAkxBAWoLIgE2AkwgDUF/Sg0BQQAgDWshDSAIQYDAAHIhCAwBCyAHQcwAahCmBiINQQBIDRMgBygCTCEBC0F/IQsCQCABLQAAQS5HDQAgAS0AAUEqRgRAAkAgASwAAhD7BUUNACAHKAJMIgEtAANBJEcNACABLAACQQJ0IARqQcB+akEKNgIAIAEsAAJBA3QgA2pBgH1qKAIAIQsgByABQQRqIgE2AkwMAgsgEw0UIAAEfyACIAIoAgAiAUEEajYCACABKAIABUEACyELIAcgBygCTEECaiIBNgJMDAELIAcgAUEBajYCTCAHQcwAahCmBiELIAcoAkwhAQtBACEJA0AgCSEKQX8hDiABLAAAQb9/akE5Sw0UIAcgAUEBaiIQNgJMIAEsAAAhCSAQIQEgCSAKQTpsakGfkQNqLQAAIglBf2pBCEkNAAsgCUUNEwJAAkACQCAJQRNGBEAgEUF/TA0BDBcLIBFBAEgNASAEIBFBAnRqIAk2AgAgByADIBFBA3RqKQMANwNAC0EAIQEgAEUNEwwBCyAARQ0RIAdBQGsgCSACIAYQpwYgBygCTCEQCyAIQf//e3EiFCAIIAhBgMAAcRshCEEAIQ5ByJEDIREgEiEJIBBBf2osAAAiAUFfcSABIAFBD3FBA0YbIAEgChsiAUGof2oiEEEgTQ0BAkACfwJAAkAgAUG/f2oiCkEGSwRAIAFB0wBHDRQgC0UNASAHKAJADAMLIApBAWsOAxMBEwgLQQAhASAAQSAgDUEAIAgQqAYMAgsgB0EANgIMIAcgBykDQD4CCCAHIAdBCGo2AkBBfyELIAdBCGoLIQlBACEBAkADQCAJKAIAIgpFDQECQCAHQQRqIAoQoQYiCkEASCIMDQAgCiALIAFrSw0AIAlBBGohCSALIAEgCmoiAUsNAQwCCwtBfyEOIAwNFQsgAEEgIA0gASAIEKgGIAFFBEBBACEBDAELQQAhCiAHKAJAIQkDQCAJKAIAIgxFDQEgB0EEaiAMEKEGIgwgCmoiCiABSg0BIAAgB0EEaiAMEKUGIAlBBGohCSAKIAFJDQALCyAAQSAgDSABIAhBgMAAcxCoBiANIAEgDSABShshAQwRCyAHIAFBAWoiCTYCTCABLQABIQggCSEBDAELCyAQQQFrDh8MDAwMDAwMDAEMAwQBAQEMBAwMDAwIBQYMDAIMCQwMBwsgDyEOIAANDyATRQ0MQQEhAQNAIAQgAUECdGooAgAiCARAIAMgAUEDdGogCCACIAYQpwZBASEOIAFBAWoiAUEKRw0BDBELC0EBIQ4gAUEJSw0PA0AgASIIQQFqIgFBCkcEQCAEIAFBAnRqKAIARQ0BCwtBf0EBIAhBCUkbIQ4MDwsgACAHKwNAIA0gCyAIIAEgBREnACEBDAwLIAcoAkAiAUHSkQMgARsiDEEAIAsQhAYiASALIAxqIAEbIQkgFCEIIAEgDGsgCyABGyELDAkLIAcgBykDQDwAN0EBIQsgFSEMIBQhCAwICyAHKQNAIhZCf1cEQCAHQgAgFn0iFjcDQEEBIQ5ByJEDDAYLIAhBgBBxBEBBASEOQcmRAwwGC0HKkQNByJEDIAhBAXEiDhsMBQsgBykDQCASEKkGIQwgCEEIcUUNBSALIBIgDGsiAUEBaiALIAFKGyELDAULIAtBCCALQQhLGyELIAhBCHIhCEH4ACEBCyAHKQNAIBIgAUEgcRCqBiEMIAhBCHFFDQMgBykDQFANAyABQQR2QciRA2ohEUECIQ4MAwtBACEBIApB/wFxIghBB0sNBQJAAkACQAJAAkACQAJAIAhBAWsOBwECAwQMBQYACyAHKAJAIA82AgAMCwsgBygCQCAPNgIADAoLIAcoAkAgD6w3AwAMCQsgBygCQCAPOwEADAgLIAcoAkAgDzoAAAwHCyAHKAJAIA82AgAMBgsgBygCQCAPrDcDAAwFCyAHKQNAIRZByJEDCyERIBYgEhCrBiEMCyAIQf//e3EgCCALQX9KGyEIIAcpA0AhFgJ/AkAgCw0AIBZQRQ0AIBIhDEEADAELIAsgFlAgEiAMa2oiASALIAFKGwshCwsgAEEgIA4gCSAMayIKIAsgCyAKSBsiEGoiCSANIA0gCUgbIgEgCSAIEKgGIAAgESAOEKUGIABBMCABIAkgCEGAgARzEKgGIABBMCAQIApBABCoBiAAIAwgChClBiAAQSAgASAJIAhBgMAAcxCoBgwBCwtBACEODAELQX8hDgsgB0HQAGokACAOCxgAIAAtAABBIHFFBEAgASACIAAQhQ0aCwtEAQN/IAAoAgAsAAAQ+wUEQANAIAAoAgAiAiwAACEDIAAgAkEBajYCACADIAFBCmxqQVBqIQEgAiwAARD7BQ0ACwsgAQvGAgACQCABQRRLDQAgAUF3aiIBQQlLDQACQAJAAkACQAJAAkACQAJAAkACQCABQQFrDgkBAgMEBQYHCAkACyACIAIoAgAiAUEEajYCACAAIAEoAgA2AgAPCyACIAIoAgAiAUEEajYCACAAIAE0AgA3AwAPCyACIAIoAgAiAUEEajYCACAAIAE1AgA3AwAPCyACIAIoAgBBB2pBeHEiAUEIajYCACAAIAEpAwA3AwAPCyACIAIoAgAiAUEEajYCACAAIAEyAQA3AwAPCyACIAIoAgAiAUEEajYCACAAIAEzAQA3AwAPCyACIAIoAgAiAUEEajYCACAAIAEwAAA3AwAPCyACIAIoAgAiAUEEajYCACAAIAExAAA3AwAPCyACIAIoAgBBB2pBeHEiAUEIajYCACAAIAEpAwA3AwAPCyAAIAIgAxECAAsLbgEBfyMAQYACayIFJAACQCACIANMDQAgBEGAwARxDQAgBSABIAIgA2siAkGAAiACQYACSSIDGxCBDRogA0UEQANAIAAgBUGAAhClBiACQYB+aiICQf8BSw0ACwsgACAFIAIQpQYLIAVBgAJqJAALLQAgAFBFBEADQCABQX9qIgEgAKdBB3FBMHI6AAAgAEIDiCIAQgBSDQALCyABCzUAIABQRQRAA0AgAUF/aiIBIACnQQ9xQbCVA2otAAAgAnI6AAAgAEIEiCIAQgBSDQALCyABC4MBAgN/AX4CQCAAQoCAgIAQVARAIAAhBQwBCwNAIAFBf2oiASAAIABCCoAiBUIKfn2nQTByOgAAIABC/////58BViECIAUhACACDQALCyAFpyICBEADQCABQX9qIgEgAiACQQpuIgNBCmxrQTByOgAAIAJBCUshBCADIQIgBA0ACwsgAQsRACAAIAEgAkGRBUGSBRCjBgulFwMQfwJ+AXwjAEGwBGsiCiQAIApBADYCLAJ/IAG9IhZCf1cEQEEBIREgAZoiAb0hFkHAlQMMAQsgBEGAEHEEQEEBIRFBw5UDDAELQcaVA0HBlQMgBEEBcSIRGwshFQJAIBZCgICAgICAgPj/AINCgICAgICAgPj/AFEEQCAAQSAgAiARQQNqIgwgBEH//3txEKgGIAAgFSAREKUGIABB25UDQd+VAyAFQQV2QQFxIgYbQdOVA0HXlQMgBhsgASABYhtBAxClBiAAQSAgAiAMIARBgMAAcxCoBgwBCyAKQRBqIRACQAJ/AkAgASAKQSxqEKIGIgEgAaAiAUQAAAAAAAAAAGIEQCAKIAooAiwiBkF/ajYCLCAFQSByIhNB4QBHDQEMAwsgBUEgciITQeEARg0CIAooAiwhCEEGIAMgA0EASBsMAQsgCiAGQWNqIgg2AiwgAUQAAAAAAACwQaIhAUEGIAMgA0EASBsLIQsgCkEwaiAKQdACaiAIQQBIGyIOIQkDQCAJAn8gAUQAAAAAAADwQWMgAUQAAAAAAAAAAGZxBEAgAasMAQtBAAsiBjYCACAJQQRqIQkgASAGuKFEAAAAAGXNzUGiIgFEAAAAAAAAAABiDQALAkAgCEEBSARAIAkhBiAOIQcMAQsgDiEHA0AgCEEdIAhBHUgbIQgCQCAJQXxqIgYgB0kNACAIrSEXQgAhFgNAIAYgFkL/////D4MgBjUCACAXhnwiFiAWQoCU69wDgCIWQoCU69wDfn0+AgAgBkF8aiIGIAdPDQALIBanIgZFDQAgB0F8aiIHIAY2AgALA0AgCSIGIAdLBEAgBkF8aiIJKAIARQ0BCwsgCiAKKAIsIAhrIgg2AiwgBiEJIAhBAEoNAAsLIAhBf0wEQCALQRlqQQltQQFqIRIgE0HmAEYhFANAQQlBACAIayAIQXdIGyEMAkAgByAGTwRAIAcgB0EEaiAHKAIAGyEHDAELQYCU69wDIAx2IQ1BfyAMdEF/cyEPQQAhCCAHIQkDQCAJIAkoAgAiAyAMdiAIajYCACADIA9xIA1sIQggCUEEaiIJIAZJDQALIAcgB0EEaiAHKAIAGyEHIAhFDQAgBiAINgIAIAZBBGohBgsgCiAKKAIsIAxqIgg2AiwgDiAHIBQbIgkgEkECdGogBiAGIAlrQQJ1IBJKGyEGIAhBAEgNAAsLQQAhCQJAIAcgBk8NACAOIAdrQQJ1QQlsIQlBCiEIIAcoAgAiA0EKSQ0AA0AgCUEBaiEJIAMgCEEKbCIITw0ACwsgC0EAIAkgE0HmAEYbayATQecARiALQQBHcWsiCCAGIA5rQQJ1QQlsQXdqSARAIAhBgMgAaiIDQQltIg1BAnQgDmpBhGBqIQxBCiEIIAMgDUEJbGsiA0EHTARAA0AgCEEKbCEIIANBAWoiA0EIRw0ACwsCQEEAIAYgDEEEaiISRiAMKAIAIg0gDSAIbiIPIAhsayIDGw0ARAAAAAAAAOA/RAAAAAAAAPA/RAAAAAAAAPg/IAMgCEEBdiIURhtEAAAAAAAA+D8gBiASRhsgAyAUSRshGEQBAAAAAABAQ0QAAAAAAABAQyAPQQFxGyEBAkAgEUUNACAVLQAAQS1HDQAgGJohGCABmiEBCyAMIA0gA2siAzYCACABIBigIAFhDQAgDCADIAhqIgk2AgAgCUGAlOvcA08EQANAIAxBADYCACAMQXxqIgwgB0kEQCAHQXxqIgdBADYCAAsgDCAMKAIAQQFqIgk2AgAgCUH/k+vcA0sNAAsLIA4gB2tBAnVBCWwhCUEKIQggBygCACIDQQpJDQADQCAJQQFqIQkgAyAIQQpsIghPDQALCyAMQQRqIgggBiAGIAhLGyEGCwJ/A0BBACAGIgggB00NARogCEF8aiIGKAIARQ0AC0EBCyEUAkAgE0HnAEcEQCAEQQhxIQ8MAQsgCUF/c0F/IAtBASALGyIGIAlKIAlBe0pxIgMbIAZqIQtBf0F+IAMbIAVqIQUgBEEIcSIPDQBBCSEGAkAgFEUNACAIQXxqKAIAIgxFDQBBCiEDQQAhBiAMQQpwDQADQCAGQQFqIQYgDCADQQpsIgNwRQ0ACwsgCCAOa0ECdUEJbEF3aiEDIAVBX3FBxgBGBEBBACEPIAsgAyAGayIGQQAgBkEAShsiBiALIAZIGyELDAELQQAhDyALIAMgCWogBmsiBkEAIAZBAEobIgYgCyAGSBshCwsgCyAPciITQQBHIQMgAEEgIAICfyAJQQAgCUEAShsgBUFfcSINQcYARg0AGiAQIAkgCUEfdSIGaiAGc60gEBCrBiIGa0EBTARAA0AgBkF/aiIGQTA6AAAgECAGa0ECSA0ACwsgBkF+aiISIAU6AAAgBkF/akEtQSsgCUEASBs6AAAgECASawsgCyARaiADampBAWoiDCAEEKgGIAAgFSAREKUGIABBMCACIAwgBEGAgARzEKgGAkACQAJAIA1BxgBGBEAgCkEQakEIciENIApBEGpBCXIhCSAOIAcgByAOSxsiAyEHA0AgBzUCACAJEKsGIQYCQCADIAdHBEAgBiAKQRBqTQ0BA0AgBkF/aiIGQTA6AAAgBiAKQRBqSw0ACwwBCyAGIAlHDQAgCkEwOgAYIA0hBgsgACAGIAkgBmsQpQYgB0EEaiIHIA5NDQALIBMEQCAAQeOVA0EBEKUGCyAHIAhPDQEgC0EBSA0BA0AgBzUCACAJEKsGIgYgCkEQaksEQANAIAZBf2oiBkEwOgAAIAYgCkEQaksNAAsLIAAgBiALQQkgC0EJSBsQpQYgC0F3aiEGIAdBBGoiByAITw0DIAtBCUohAyAGIQsgAw0ACwwCCwJAIAtBAEgNACAIIAdBBGogFBshDSAKQRBqQQhyIQ4gCkEQakEJciEIIAchCQNAIAggCTUCACAIEKsGIgZGBEAgCkEwOgAYIA4hBgsCQCAHIAlHBEAgBiAKQRBqTQ0BA0AgBkF/aiIGQTA6AAAgBiAKQRBqSw0ACwwBCyAAIAZBARClBiAGQQFqIQYgD0VBACALQQFIGw0AIABB45UDQQEQpQYLIAAgBiAIIAZrIgMgCyALIANKGxClBiALIANrIQsgCUEEaiIJIA1PDQEgC0F/Sg0ACwsgAEEwIAtBEmpBEkEAEKgGIAAgEiAQIBJrEKUGDAILIAshBgsgAEEwIAZBCWpBCUEAEKgGCyAAQSAgAiAMIARBgMAAcxCoBgwBCyAVQQlqIBUgBUEgcSIJGyELAkAgA0ELSw0AQQwgA2siBkUNAEQAAAAAAAAgQCEYA0AgGEQAAAAAAAAwQKIhGCAGQX9qIgYNAAsgCy0AAEEtRgRAIBggAZogGKGgmiEBDAELIAEgGKAgGKEhAQsgECAKKAIsIgYgBkEfdSIGaiAGc60gEBCrBiIGRgRAIApBMDoADyAKQQ9qIQYLIBFBAnIhDyAKKAIsIQcgBkF+aiINIAVBD2o6AAAgBkF/akEtQSsgB0EASBs6AAAgBEEIcSEIIApBEGohBwNAIAciBgJ/IAGZRAAAAAAAAOBBYwRAIAGqDAELQYCAgIB4CyIHQbCVA2otAAAgCXI6AAAgASAHt6FEAAAAAAAAMECiIQECQCAGQQFqIgcgCkEQamtBAUcNAAJAIAgNACADQQBKDQAgAUQAAAAAAAAAAGENAQsgBkEuOgABIAZBAmohBwsgAUQAAAAAAAAAAGINAAsgAEEgIAIgDwJ/AkAgA0UNACAHIAprQW5qIANODQAgAyAQaiANa0ECagwBCyAQIApBEGprIA1rIAdqCyIGaiIMIAQQqAYgACALIA8QpQYgAEEwIAIgDCAEQYCABHMQqAYgACAKQRBqIAcgCkEQamsiBxClBiAAQTAgBiAHIBAgDWsiCWprQQBBABCoBiAAIA0gCRClBiAAQSAgAiAMIARBgMAAcxCoBgsgCkGwBGokACACIAwgDCACSBsLKQAgASABKAIAQQ9qQXBxIgFBEGo2AgAgACABKQMAIAEpAwgQ1wY5AwALEAAgACABIAJBAEEAEKMGGgvkAQEEfyMAQSBrIgMkACADIAE2AhAgAyACIAAoAjAiBEEAR2s2AhQgACgCLCEFIAMgBDYCHCADIAU2AhgCQAJAAn8gACgCPCADQRBqQQIgA0EMahArEMkGBEAgA0F/NgIMQX8MAQsgAygCDCIEQQBKDQEgBAshAiAAIAAoAgAgAkEwcUEQc3I2AgAMAQsgBCADKAIUIgZNBEAgBCECDAELIAAgACgCLCIFNgIEIAAgBSAEIAZrajYCCCAAKAIwRQ0AIAAgBUEBajYCBCABIAJqQX9qIAUtAAA6AAALIANBIGokACACCxAAIABBIEYgAEF3akEFSXILRgICfwF+IAAgATcDcCAAIAAoAggiAiAAKAIEIgNrrCIENwN4AkAgAVANACAEIAFXDQAgACADIAGnajYCaA8LIAAgAjYCaAvCAQIDfwF+AkACQCAAKQNwIgRQRQRAIAApA3ggBFkNAQsgABDBBiIDQX9KDQELIABBADYCaEF/DwsgACgCCCEBAkACQCAAKQNwIgRQDQAgBCAAKQN4Qn+FfCIEIAEgACgCBCICa6xZDQAgACACIASnajYCaAwBCyAAIAE2AmgLAkAgAUUEQCAAKAIEIQIMAQsgACAAKQN4IAEgACgCBCICa0EBaqx8NwN4CyACQX9qIgAtAAAgA0cEQCAAIAM6AAALIAML5QoCBX8EfiMAQRBrIgckAAJAAkACQAJAAkACQCABQSRNBEADQAJ/IAAoAgQiBCAAKAJoSQRAIAAgBEEBajYCBCAELQAADAELIAAQswYLIgQQsQYNAAsCQCAEQVVqIgVBAksNACAFQQFrRQ0AQX9BACAEQS1GGyEGIAAoAgQiBCAAKAJoSQRAIAAgBEEBajYCBCAELQAAIQQMAQsgABCzBiEECwJAAkAgAUFvcQ0AIARBMEcNAAJ/IAAoAgQiBCAAKAJoSQRAIAAgBEEBajYCBCAELQAADAELIAAQswYLIgRBX3FB2ABGBEBBECEBAn8gACgCBCIEIAAoAmhJBEAgACAEQQFqNgIEIAQtAAAMAQsgABCzBgsiBEHxlQNqLQAAQRBJDQUgACgCaEUEQEIAIQMgAg0KDAkLIAAgACgCBCIEQX9qNgIEIAJFDQggACAEQX5qNgIEQgAhAwwJCyABDQFBCCEBDAQLIAFBCiABGyIBIARB8ZUDai0AAEsNACAAKAJoBEAgACAAKAIEQX9qNgIEC0IAIQMgAEIAELIGQaiqBUEcNgIADAcLIAFBCkcNAiAEQVBqIgJBCU0EQEEAIQEDQCACIAFBCmxqIQECfyAAKAIEIgQgACgCaEkEQCAAIARBAWo2AgQgBC0AAAwBCyAAELMGCyIEQVBqIgJBCU1BACABQZmz5swBSRsNAAsgAa0hCQsgAkEJSw0BIAlCCn4hCiACrSELA0AgCiALfCEJAn8gACgCBCIEIAAoAmhJBEAgACAEQQFqNgIEIAQtAAAMAQsgABCzBgsiBEFQaiICQQlLDQIgCUKas+bMmbPmzBlaDQIgCUIKfiIKIAKtIgtCf4VYDQALQQohAQwDC0GoqgVBHDYCAEIAIQMMBQtBCiEBIAJBCU0NAQwCCyABIAFBf2pxBEAgASAEQfGVA2otAAAiAksEQEEAIQUDQCACIAEgBWxqIgVBxuPxOE1BACABAn8gACgCBCIEIAAoAmhJBEAgACAEQQFqNgIEIAQtAAAMAQsgABCzBgsiBEHxlQNqLQAAIgJLGw0ACyAFrSEJCyABIAJNDQEgAa0hCgNAIAkgCn4iCyACrUL/AYMiDEJ/hVYNAiALIAx8IQkgAQJ/IAAoAgQiBCAAKAJoSQRAIAAgBEEBajYCBCAELQAADAELIAAQswYLIgRB8ZUDai0AACICTQ0CIAcgCiAJENUGIAcpAwhQDQALDAELQn8gAUEXbEEFdkEHcUHxlwNqLAAAIgitIgqIIgsCfiABIARB8ZUDai0AACICSwRAQQAhBQNAIAIgBSAIdHIiBUH///8/TUEAIAECfyAAKAIEIgQgACgCaEkEQCAAIARBAWo2AgQgBC0AAAwBCyAAELMGCyIEQfGVA2otAAAiAksbDQALIAWtIQkLIAkLVA0AIAEgAk0NAANAIAKtQv8BgyAJIAqGhCEJAn8gACgCBCIEIAAoAmhJBEAgACAEQQFqNgIEIAQtAAAMAQsgABCzBgshBCAJIAtWDQEgASAEQfGVA2otAAAiAksNAAsLIAEgBEHxlQNqLQAATQ0AA0AgAQJ/IAAoAgQiBCAAKAJoSQRAIAAgBEEBajYCBCAELQAADAELIAAQswYLQfGVA2otAABLDQALQaiqBUHEADYCACAGQQAgA0IBg1AbIQYgAyEJCyAAKAJoBEAgACAAKAIEQX9qNgIECwJAIAkgA1QNAAJAIAOnQQFxDQAgBg0AQaiqBUHEADYCACADQn98IQMMAwsgCSADWA0AQaiqBUHEADYCAAwCCyAJIAasIgOFIAN9IQMMAQtCACEDIABCABCyBgsgB0EQaiQAIAML5QIBBn8jAEEQayIHJAAgA0GsqgUgAxsiBSgCACEDAkACQAJAIAFFBEAgAw0BDAMLQX4hBCACRQ0CIAAgB0EMaiAAGyEGAkAgAwRAIAIhAAwBCyABLQAAIgNBGHRBGHUiAEEATgRAIAYgAzYCACAAQQBHIQQMBAsgASwAACEAQdSQBCgCACgCAEUEQCAGIABB/78DcTYCAEEBIQQMBAsgAEH/AXFBvn5qIgNBMksNASADQQJ0QYCYA2ooAgAhAyACQX9qIgBFDQIgAUEBaiEBCyABLQAAIghBA3YiCUFwaiADQRp1IAlqckEHSw0AA0AgAEF/aiEAIAhBgH9qIANBBnRyIgNBAE4EQCAFQQA2AgAgBiADNgIAIAIgAGshBAwECyAARQ0CIAFBAWoiAS0AACIIQcABcUGAAUYNAAsLIAVBADYCAEGoqgVBGTYCAEF/IQQMAQsgBSADNgIACyAHQRBqJAAgBAs1ACAAIAE3AwAgACACQv///////z+DIARCMIinQYCAAnEgAkIwiKdB//8BcXKtQjCGhDcDCAvEAgEBfyMAQdAAayIEJAACQCADQYCAAU4EQCAEQSBqIAEgAkIAQoCAgICAgID//wAQ1AYgBCkDKCECIAQpAyAhASADQf//AUgEQCADQYGAf2ohAwwCCyAEQRBqIAEgAkIAQoCAgICAgID//wAQ1AYgA0H9/wIgA0H9/wJIG0GCgH5qIQMgBCkDGCECIAQpAxAhAQwBCyADQYGAf0oNACAEQUBrIAEgAkIAQoCAgICAgMAAENQGIAQpA0ghAiAEKQNAIQEgA0GDgH5KBEAgA0H+/wBqIQMMAQsgBEEwaiABIAJCAEKAgICAgIDAABDUBiADQYaAfSADQYaAfUobQfz/AWohAyAEKQM4IQIgBCkDMCEBCyAEIAEgAkIAIANB//8Aaq1CMIYQ1AYgACAEKQMINwMIIAAgBCkDADcDACAEQdAAaiQAC64IAgZ/An4jAEEwayIGJAACQCACQQJNBEAgAUEEaiEFIAJBAnQiAkGcmgNqKAIAIQggAkGQmgNqKAIAIQkDQAJ/IAEoAgQiAiABKAJoSQRAIAUgAkEBajYCACACLQAADAELIAEQswYLIgIQsQYNAAsCQCACQVVqIgRBAksEQEEBIQcMAQtBASEHIARBAWtFDQBBf0EBIAJBLUYbIQcgASgCBCICIAEoAmhJBEAgBSACQQFqNgIAIAItAAAhAgwBCyABELMGIQILQQAhBAJAAkADQCAEQcyZA2osAAAgAkEgckYEQAJAIARBBksNACABKAIEIgIgASgCaEkEQCAFIAJBAWo2AgAgAi0AACECDAELIAEQswYhAgsgBEEBaiIEQQhHDQEMAgsLIARBA0cEQCAEQQhGDQEgA0UNAiAEQQRJDQIgBEEIRg0BCyABKAJoIgEEQCAFIAUoAgBBf2o2AgALIANFDQAgBEEESQ0AA0AgAQRAIAUgBSgCAEF/ajYCAAsgBEF/aiIEQQNLDQALCyAGIAeyQwAAgH+UENAGIAYpAwghCiAGKQMAIQsMAgsCQAJAAkAgBA0AQQAhBANAIARB1ZkDaiwAACACQSByRw0BAkAgBEEBSw0AIAEoAgQiAiABKAJoSQRAIAUgAkEBajYCACACLQAAIQIMAQsgARCzBiECCyAEQQFqIgRBA0cNAAsMAQsCQAJAIARBA0sNACAEQQFrDgMAAAIBCyABKAJoBEAgBSAFKAIAQX9qNgIAC0GoqgVBHDYCAAwCCwJAIAJBMEcNAAJ/IAEoAgQiBCABKAJoSQRAIAUgBEEBajYCACAELQAADAELIAEQswYLQV9xQdgARgRAIAZBEGogASAJIAggByADELkGIAYpAxghCiAGKQMQIQsMBQsgASgCaEUNACAFIAUoAgBBf2o2AgALIAZBIGogASACIAkgCCAHIAMQugYgBikDKCEKIAYpAyAhCwwDCwJAAn8gASgCBCICIAEoAmhJBEAgBSACQQFqNgIAIAItAAAMAQsgARCzBgtBKEYEQEEBIQQMAQtCgICAgICA4P//ACEKIAEoAmhFDQMgBSAFKAIAQX9qNgIADAMLA0ACfyABKAIEIgIgASgCaEkEQCAFIAJBAWo2AgAgAi0AAAwBCyABELMGCyICQb9/aiEHAkACQCACQVBqQQpJDQAgB0EaSQ0AIAJBn39qIQcgAkHfAEYNACAHQRpPDQELIARBAWohBAwBCwtCgICAgICA4P//ACEKIAJBKUYNAiABKAJoIgIEQCAFIAUoAgBBf2o2AgALIAMEQCAERQ0DA0AgBEF/aiEEIAIEQCAFIAUoAgBBf2o2AgALIAQNAAsMAwtBqKoFQRw2AgALIAFCABCyBgtCACEKCyAAIAs3AwAgACAKNwMIIAZBMGokAAu1DQIIfwd+IwBBsANrIgYkAAJ/IAEoAgQiByABKAJoSQRAIAEgB0EBajYCBCAHLQAADAELIAEQswYLIQcCQAJ/A0ACQCAHQTBHBEAgB0EuRw0EIAEoAgQiByABKAJoTw0BIAEgB0EBajYCBCAHLQAADAMLIAEoAgQiByABKAJoSQRAQQEhCSABIAdBAWo2AgQgBy0AACEHDAIFQQEhCSABELMGIQcMAgsACwsgARCzBgshB0EBIQogB0EwRw0AA0AgEkJ/fCESAn8gASgCBCIHIAEoAmhJBEAgASAHQQFqNgIEIActAAAMAQsgARCzBgsiB0EwRg0AC0EBIQkLQoCAgICAgMD/PyEQA0ACQCAHQSByIQsCQAJAIAdBUGoiDEEKSQ0AIAdBLkdBACALQZ9/akEFSxsNAiAHQS5HDQAgCg0CQQEhCiAPIRIMAQsgC0Gpf2ogDCAHQTlKGyEHAkAgD0IHVwRAIAcgCEEEdGohCAwBCyAPQhxXBEAgBkEwaiAHENEGIAZBIGogEyAQQgBCgICAgICAwP0/ENQGIAZBEGogBikDICITIAYpAygiECAGKQMwIAYpAzgQ1AYgBiAOIBEgBikDECAGKQMYEMoGIAYpAwghESAGKQMAIQ4MAQsgDQ0AIAdFDQAgBkHQAGogEyAQQgBCgICAgICAgP8/ENQGIAZBQGsgDiARIAYpA1AgBikDWBDKBiAGKQNIIRFBASENIAYpA0AhDgsgD0IBfCEPQQEhCQsgASgCBCIHIAEoAmhJBEAgASAHQQFqNgIEIActAAAhBwwCBSABELMGIQcMAgsACwsCfgJAAkAgCUUEQCABKAJoRQRAIAUNAwwCCyABIAEoAgQiB0F/ajYCBCAFRQ0BIAEgB0F+ajYCBCAKRQ0CIAEgB0F9ajYCBAwCCyAPQgdXBEAgDyEQA0AgCEEEdCEIIBBCAXwiEEIIUg0ACwsCQCAHQV9xQdAARgRAIAEgBRC7BiIQQoCAgICAgICAgH9SDQEgBQRAQgAhECABKAJoRQ0CIAEgASgCBEF/ajYCBAwCC0IAIQ4gAUIAELIGQgAMBAtCACEQIAEoAmhFDQAgASABKAIEQX9qNgIECyAIRQRAIAZB8ABqIAS3RAAAAAAAAAAAohDPBiAGKQNwIQ4gBikDeAwDCyASIA8gChtCAoYgEHxCYHwiD0EAIANrrFUEQEGoqgVBxAA2AgAgBkGgAWogBBDRBiAGQZABaiAGKQOgASAGKQOoAUJ/Qv///////7///wAQ1AYgBkGAAWogBikDkAEgBikDmAFCf0L///////+///8AENQGIAYpA4ABIQ4gBikDiAEMAwsgDyADQZ5+aqxZBEAgCEF/SgRAA0AgBkGgA2ogDiARQgBCgICAgICAwP+/fxDKBiAOIBEQzQYhByAGQZADaiAOIBEgDiAGKQOgAyAHQQBIIgEbIBEgBikDqAMgARsQygYgD0J/fCEPIAYpA5gDIREgBikDkAMhDiAIQQF0IAdBf0pyIghBf0oNAAsLAn4gDyADrH1CIHwiEqciB0EAIAdBAEobIAIgEiACrFMbIgdB8QBOBEAgBkGAA2ogBBDRBiAGKQOIAyESIAYpA4ADIRNCAAwBCyAGQeACakGQASAHaxD+DBDPBiAGQdACaiAEENEGIAZB8AJqIAYpA+ACIAYpA+gCIAYpA9ACIhMgBikD2AIiEhC2BiAGKQP4AiEUIAYpA/ACCyEQIAZBwAJqIAggCEEBcUUgDiARQgBCABDMBkEARyAHQSBIcXEiB2oQ0gYgBkGwAmogEyASIAYpA8ACIAYpA8gCENQGIAZBkAJqIAYpA7ACIAYpA7gCIBAgFBDKBiAGQaACakIAIA4gBxtCACARIAcbIBMgEhDUBiAGQYACaiAGKQOgAiAGKQOoAiAGKQOQAiAGKQOYAhDKBiAGQfABaiAGKQOAAiAGKQOIAiAQIBQQ1gYgBikD8AEiDiAGKQP4ASIRQgBCABDMBkUEQEGoqgVBxAA2AgALIAZB4AFqIA4gESAPpxC3BiAGKQPgASEOIAYpA+gBDAMLQaiqBUHEADYCACAGQdABaiAEENEGIAZBwAFqIAYpA9ABIAYpA9gBQgBCgICAgICAwAAQ1AYgBkGwAWogBikDwAEgBikDyAFCAEKAgICAgIDAABDUBiAGKQOwASEOIAYpA7gBDAILIAFCABCyBgsgBkHgAGogBLdEAAAAAAAAAACiEM8GIAYpA2AhDiAGKQNoCyEPIAAgDjcDACAAIA83AwggBkGwA2okAAvmGwMMfwZ+AXwjAEGAxgBrIgckAEEAIAMgBGoiEWshEgJAAn8DQAJAIAJBMEcEQCACQS5HDQQgASgCBCIIIAEoAmhPDQEgASAIQQFqNgIEIAgtAAAMAwsgASgCBCIIIAEoAmhJBEBBASEJIAEgCEEBajYCBCAILQAAIQIMAgVBASEJIAEQswYhAgwCCwALCyABELMGCyECQQEhCiACQTBHDQADQCATQn98IRMCfyABKAIEIgggASgCaEkEQCABIAhBAWo2AgQgCC0AAAwBCyABELMGCyICQTBGDQALQQEhCQsgB0EANgKABiACQVBqIQwgAAJ+AkACQAJAAkACQAJAIAJBLkYiCw0AIAxBCU0NAEEAIQgMAQtBACEIA0ACQCALQQFxBEAgCkUEQCAUIRNBASEKDAILIAlBAEchCQwECyAUQgF8IRQgCEH8D0wEQCAUpyAOIAJBMEcbIQ4gB0GABmogCEECdGoiCSANBH8gAiAJKAIAQQpsakFQagUgDAs2AgBBASEJQQAgDUEBaiICIAJBCUYiAhshDSACIAhqIQgMAQsgAkEwRg0AIAcgBygC8EVBAXI2AvBFCwJ/IAEoAgQiAiABKAJoSQRAIAEgAkEBajYCBCACLQAADAELIAEQswYLIgJBUGohDCACQS5GIgsNACAMQQpJDQALCyATIBQgChshEwJAIAlFDQAgAkFfcUHFAEcNAAJAIAEgBhC7BiIVQoCAgICAgICAgH9SDQAgBkUNBEIAIRUgASgCaEUNACABIAEoAgRBf2o2AgQLIBMgFXwhEwwECyAJQQBHIQkgAkEASA0BCyABKAJoRQ0AIAEgASgCBEF/ajYCBAsgCQ0BQaiqBUEcNgIACyABQgAQsgZCACETQgAMAQsgBygCgAYiAUUEQCAHIAW3RAAAAAAAAAAAohDPBiAHKQMIIRMgBykDAAwBCwJAIBRCCVUNACATIBRSDQAgA0EeTEEAIAEgA3YbDQAgB0EwaiAFENEGIAdBIGogARDSBiAHQRBqIAcpAzAgBykDOCAHKQMgIAcpAygQ1AYgBykDGCETIAcpAxAMAQsgEyAEQX5trFUEQEGoqgVBxAA2AgAgB0HgAGogBRDRBiAHQdAAaiAHKQNgIAcpA2hCf0L///////+///8AENQGIAdBQGsgBykDUCAHKQNYQn9C////////v///ABDUBiAHKQNIIRMgBykDQAwBCyATIARBnn5qrFMEQEGoqgVBxAA2AgAgB0GQAWogBRDRBiAHQYABaiAHKQOQASAHKQOYAUIAQoCAgICAgMAAENQGIAdB8ABqIAcpA4ABIAcpA4gBQgBCgICAgICAwAAQ1AYgBykDeCETIAcpA3AMAQsgDQRAIA1BCEwEQCAHQYAGaiAIQQJ0aiICKAIAIQEDQCABQQpsIQEgDUEBaiINQQlHDQALIAIgATYCAAsgCEEBaiEICyATpyEKAkAgDkEISg0AIA4gCkoNACAKQRFKDQAgCkEJRgRAIAdBwAFqIAUQ0QYgB0GwAWogBygCgAYQ0gYgB0GgAWogBykDwAEgBykDyAEgBykDsAEgBykDuAEQ1AYgBykDqAEhEyAHKQOgAQwCCyAKQQhMBEAgB0GQAmogBRDRBiAHQYACaiAHKAKABhDSBiAHQfABaiAHKQOQAiAHKQOYAiAHKQOAAiAHKQOIAhDUBiAHQeABakEAIAprQQJ0QZCaA2ooAgAQ0QYgB0HQAWogBykD8AEgBykD+AEgBykD4AEgBykD6AEQzgYgBykD2AEhEyAHKQPQAQwCCyADIApBfWxqQRtqIgJBHkxBACAHKAKABiIBIAJ2Gw0AIAdB4AJqIAUQ0QYgB0HQAmogARDSBiAHQcACaiAHKQPgAiAHKQPoAiAHKQPQAiAHKQPYAhDUBiAHQbACaiAKQQJ0QciZA2ooAgAQ0QYgB0GgAmogBykDwAIgBykDyAIgBykDsAIgBykDuAIQ1AYgBykDqAIhEyAHKQOgAgwBC0EAIQ0CQCAKQQlvIgFFBEBBACECDAELIAEgAUEJaiAKQX9KGyEGAkAgCEUEQEEAIQJBACEIDAELQYCU69wDQQAgBmtBAnRBkJoDaigCACILbSEPQQAhCUEAIQFBACECA0AgB0GABmogAUECdGoiDCAMKAIAIgwgC24iDiAJaiIJNgIAIAJBAWpB/w9xIAIgCUUgASACRnEiCRshAiAKQXdqIAogCRshCiAPIAwgCyAObGtsIQkgAUEBaiIBIAhHDQALIAlFDQAgB0GABmogCEECdGogCTYCACAIQQFqIQgLIAogBmtBCWohCgsDQCAHQYAGaiACQQJ0aiEOAkADQCAKQSROBEAgCkEkRw0CIA4oAgBB0en5BE8NAgsgCEH/D2ohDEEAIQkgCCELA0AgCyEIAn9BACAJrSAHQYAGaiAMQf8PcSIBQQJ0aiILNQIAQh2GfCITQoGU69wDVA0AGiATIBNCgJTr3AOAIhRCgJTr3AN+fSETIBSnCyEJIAsgE6ciDDYCACAIIAggCCABIAwbIAEgAkYbIAEgCEF/akH/D3FHGyELIAFBf2ohDCABIAJHDQALIA1BY2ohDSAJRQ0ACyALIAJBf2pB/w9xIgJGBEAgB0GABmogC0H+D2pB/w9xQQJ0aiIBIAEoAgAgB0GABmogC0F/akH/D3EiCEECdGooAgByNgIACyAKQQlqIQogB0GABmogAkECdGogCTYCAAwBCwsCQANAIAhBAWpB/w9xIQYgB0GABmogCEF/akH/D3FBAnRqIRADQEEJQQEgCkEtShshDAJAA0AgAiELQQAhAQJAA0ACQCABIAtqQf8PcSICIAhGDQAgB0GABmogAkECdGooAgAiAiABQQJ0QeCZA2ooAgAiCUkNACACIAlLDQIgAUEBaiIBQQRHDQELCyAKQSRHDQBCACETQQAhAUIAIRQDQCAIIAEgC2pB/w9xIgJGBEAgCEEBakH/D3EiCEECdCAHakEANgL8BQsgB0HwBWogEyAUQgBCgICAgOWat47AABDUBiAHQeAFaiAHQYAGaiACQQJ0aigCABDSBiAHQdAFaiAHKQPwBSAHKQP4BSAHKQPgBSAHKQPoBRDKBiAHKQPYBSEUIAcpA9AFIRMgAUEBaiIBQQRHDQALIAdBwAVqIAUQ0QYgB0GwBWogEyAUIAcpA8AFIAcpA8gFENQGIAcpA7gFIRRCACETIAcpA7AFIRUgDUHxAGoiCSAEayIBQQAgAUEAShsgAyABIANIIgwbIgJB8ABMDQIMBQsgDCANaiENIAsgCCICRg0AC0GAlOvcAyAMdiEOQX8gDHRBf3MhD0EAIQEgCyECA0AgB0GABmogC0ECdGoiCSAJKAIAIgkgDHYgAWoiATYCACACQQFqQf8PcSACIAFFIAIgC0ZxIgEbIQIgCkF3aiAKIAEbIQogCSAPcSAObCEBIAtBAWpB/w9xIgsgCEcNAAsgAUUNASACIAZHBEAgB0GABmogCEECdGogATYCACAGIQgMAwsgECAQKAIAQQFyNgIAIAYhAgwBCwsLIAdBgAVqQeEBIAJrEP4MEM8GIAdBoAVqIAcpA4AFIAcpA4gFIBUgFBC2BiAHKQOoBSEXIAcpA6AFIRggB0HwBGpB8QAgAmsQ/gwQzwYgB0GQBWogFSAUIAcpA/AEIAcpA/gEEP0MIAdB4ARqIBUgFCAHKQOQBSITIAcpA5gFIhYQ1gYgB0HQBGogGCAXIAcpA+AEIAcpA+gEEMoGIAcpA9gEIRQgBykD0AQhFQsCQCALQQRqQf8PcSIKIAhGDQACQCAHQYAGaiAKQQJ0aigCACIKQf/Jte4BTQRAIApFQQAgC0EFakH/D3EgCEYbDQEgB0HgA2ogBbdEAAAAAAAA0D+iEM8GIAdB0ANqIBMgFiAHKQPgAyAHKQPoAxDKBiAHKQPYAyEWIAcpA9ADIRMMAQsgCkGAyrXuAUcEQCAHQcAEaiAFt0QAAAAAAADoP6IQzwYgB0GwBGogEyAWIAcpA8AEIAcpA8gEEMoGIAcpA7gEIRYgBykDsAQhEwwBCyAFtyEZIAggC0EFakH/D3FGBEAgB0GABGogGUQAAAAAAADgP6IQzwYgB0HwA2ogEyAWIAcpA4AEIAcpA4gEEMoGIAcpA/gDIRYgBykD8AMhEwwBCyAHQaAEaiAZRAAAAAAAAOg/ohDPBiAHQZAEaiATIBYgBykDoAQgBykDqAQQygYgBykDmAQhFiAHKQOQBCETCyACQe8ASg0AIAdBwANqIBMgFkIAQoCAgICAgMD/PxD9DCAHKQPAAyAHKQPIA0IAQgAQzAYNACAHQbADaiATIBZCAEKAgICAgIDA/z8QygYgBykDuAMhFiAHKQOwAyETCyAHQaADaiAVIBQgEyAWEMoGIAdBkANqIAcpA6ADIAcpA6gDIBggFxDWBiAHKQOYAyEUIAcpA5ADIRUCQCAJQf////8HcUF+IBFrTA0AIAdBgANqIBUgFEIAQoCAgICAgID/PxDUBiATIBZCAEIAEMwGIQkgFSAUENcGmSEZIAcpA4gDIBQgGUQAAAAAAAAAR2YiCBshFCAHKQOAAyAVIAgbIRUgDCAIQQFzIAEgAkdycSAJQQBHcUVBACAIIA1qIg1B7gBqIBJMGw0AQaiqBUHEADYCAAsgB0HwAmogFSAUIA0QtwYgBykD+AIhEyAHKQPwAgs3AwAgACATNwMIIAdBgMYAaiQAC4UEAgR/AX4CQAJ/IAAoAgQiAiAAKAJoSQRAIAAgAkEBajYCBCACLQAADAELIAAQswYLIgJBVWoiA0ECTUEAIANBAWsbRQRAIAJBUGohAwwBCyACQS1GIQUCfyAAKAIEIgMgACgCaEkEQCAAIANBAWo2AgQgAy0AAAwBCyAAELMGCyIEQVBqIQMCQCABRQ0AIANBCkkNACAAKAJoRQ0AIAAgACgCBEF/ajYCBAsgBCECCwJAIANBCkkEQEEAIQMDQCACIANBCmxqIQMCfyAAKAIEIgIgACgCaEkEQCAAIAJBAWo2AgQgAi0AAAwBCyAAELMGCyICQVBqIgRBCU1BACADQVBqIgNBzJmz5gBIGw0ACyADrCEGAkAgBEEKTw0AA0AgAq0gBkIKfnxCUHwhBgJ/IAAoAgQiAiAAKAJoSQRAIAAgAkEBajYCBCACLQAADAELIAAQswYLIgJBUGoiBEEJSw0BIAZCro+F18fC66MBUw0ACwsgBEEKSQRAA0ACfyAAKAIEIgIgACgCaEkEQCAAIAJBAWo2AgQgAi0AAAwBCyAAELMGC0FQakEKSQ0ACwsgACgCaARAIAAgACgCBEF/ajYCBAtCACAGfSAGIAUbIQYMAQtCgICAgICAgICAfyEGIAAoAmhFDQAgACAAKAIEQX9qNgIEQoCAgICAgICAgH8PCyAGC8ETAg5/A34jAEGwAmsiBiQAIAAoAkxBAE4Ef0EBBSADCxoCQCABLQAAIgRFDQAgAEEEaiEHAkADQAJAAkAgBEH/AXEQsQYEQANAIAEiBEEBaiEBIAQtAAEQsQYNAAsgAEIAELIGA0ACfyAAKAIEIgEgACgCaEkEQCAHIAFBAWo2AgAgAS0AAAwBCyAAELMGCxCxBg0ACwJAIAAoAmhFBEAgBygCACEBDAELIAcgBygCAEF/aiIBNgIACyABIAAoAghrrCAAKQN4IBF8fCERDAELAn8CQAJAIAEtAAAiBEElRgRAIAEtAAEiA0EqRg0BIANBJUcNAgsgAEIAELIGIAEgBEElRmohBAJ/IAAoAgQiASAAKAJoSQRAIAcgAUEBajYCACABLQAADAELIAAQswYLIgEgBC0AAEcEQCAAKAJoBEAgByAHKAIAQX9qNgIAC0EAIQ0gAUEATg0IDAULIBFCAXwhEQwDC0EAIQggAUECagwBCwJAIAMQ+wVFDQAgAS0AAkEkRw0AIAIgAS0AAUFQahC9BiEIIAFBA2oMAQsgAigCACEIIAJBBGohAiABQQFqCyEEQQAhDUEAIQEgBC0AABD7BQRAA0AgBC0AACABQQpsakFQaiEBIAQtAAEhAyAEQQFqIQQgAxD7BQ0ACwsCfyAEIAQtAAAiBUHtAEcNABpBACEJIAhBAEchDSAELQABIQVBACEKIARBAWoLIQMgBUH/AXFBv39qIgtBOUsNASADQQFqIQRBAyEFAkACQAJAAkACQAJAIAtBAWsOOQcEBwQEBAcHBwcDBwcHBwcHBAcHBwcEBwcEBwcHBwcEBwQEBAQEAAQFBwEHBAQEBwcEAgQHBwQHAgQLIANBAmogBCADLQABQegARiIDGyEEQX5BfyADGyEFDAQLIANBAmogBCADLQABQewARiIDGyEEQQNBASADGyEFDAMLQQEhBQwCC0ECIQUMAQtBACEFIAMhBAtBASAFIAQtAAAiA0EvcUEDRiILGyEOAkAgA0EgciADIAsbIgxB2wBGDQACQCAMQe4ARwRAIAxB4wBHDQEgAUEBIAFBAUobIQEMAgsgCCAOIBEQvgYMAgsgAEIAELIGA0ACfyAAKAIEIgMgACgCaEkEQCAHIANBAWo2AgAgAy0AAAwBCyAAELMGCxCxBg0ACwJAIAAoAmhFBEAgBygCACEDDAELIAcgBygCAEF/aiIDNgIACyADIAAoAghrrCAAKQN4IBF8fCERCyAAIAGsIhIQsgYCQCAAKAIEIgUgACgCaCIDSQRAIAcgBUEBajYCAAwBCyAAELMGQQBIDQIgACgCaCEDCyADBEAgByAHKAIAQX9qNgIACwJAAkAgDEGof2oiA0EgSwRAIAxBv39qIgFBBksNAkEBIAF0QfEAcUUNAgwBC0EQIQUCQAJAAkACQAJAIANBAWsOHwYGBAYGBgYGBQYEAQUFBQYABgYGBgYCAwYGBAYBBgYDC0EAIQUMAgtBCiEFDAELQQghBQsgACAFQQBCfxC0BiESIAApA3hCACAAKAIEIAAoAghrrH1RDQYCQCAIRQ0AIAxB8ABHDQAgCCASPgIADAMLIAggDiASEL4GDAILAkAgDEHvAXFB4wBGBEAgBkEgakF/QYECEIENGiAGQQA6ACAgDEHzAEcNASAGQQA6AEEgBkEAOgAuIAZBADYBKgwBCyAGQSBqIAQtAAEiBUHeAEYiA0GBAhCBDRogBkEAOgAgIARBAmogBEEBaiADGyELAn8CQAJAIARBAkEBIAMbai0AACIEQS1HBEAgBEHdAEYNASAFQd4ARyEFIAsMAwsgBiAFQd4ARyIFOgBODAELIAYgBUHeAEciBToAfgsgC0EBagshBANAAkAgBC0AACIDQS1HBEAgA0UNByADQd0ARw0BDAMLQS0hAyAELQABIhBFDQAgEEHdAEYNACAEQQFqIQsCQCAEQX9qLQAAIgQgEE8EQCAQIQMMAQsDQCAEQQFqIgQgBkEgamogBToAACAEIAstAAAiA0kNAAsLIAshBAsgAyAGaiAFOgAhIARBAWohBAwAAAsACyABQQFqQR8gDEHjAEYiCxshBQJAAkACQCAOQQFHIgxFBEAgCCEDIA0EQCAFQQJ0EPUMIgNFDQQLIAZCADcDqAJBACEBA0AgAyEKAkADQAJ/IAAoAgQiAyAAKAJoSQRAIAcgA0EBajYCACADLQAADAELIAAQswYLIgMgBmotACFFDQEgBiADOgAbIAZBHGogBkEbakEBIAZBqAJqELUGIgNBfkYNACADQX9GDQUgCgRAIAogAUECdGogBigCHDYCACABQQFqIQELIA1FDQAgASAFRw0ACyAKIAVBAXRBAXIiBUECdBD3DCIDDQEMBAsLAn9BASAGQagCaiIDRQ0AGiADKAIARQtFDQJBACEJDAELIA0EQEEAIQEgBRD1DCIDRQ0DA0AgAyEJA0ACfyAAKAIEIgMgACgCaEkEQCAHIANBAWo2AgAgAy0AAAwBCyAAELMGCyIDIAZqLQAhRQRAQQAhCgwECyABIAlqIAM6AAAgAUEBaiIBIAVHDQALQQAhCiAJIAVBAXRBAXIiBRD3DCIDDQALDAcLQQAhASAIBEADQAJ/IAAoAgQiAyAAKAJoSQRAIAcgA0EBajYCACADLQAADAELIAAQswYLIgMgBmotACEEQCABIAhqIAM6AAAgAUEBaiEBDAEFQQAhCiAIIQkMAwsAAAsACwNAAn8gACgCBCIBIAAoAmhJBEAgByABQQFqNgIAIAEtAAAMAQsgABCzBgsgBmotACENAAtBACEJQQAhCkEAIQELAkAgACgCaEUEQCAHKAIAIQMMAQsgByAHKAIAQX9qIgM2AgALIAApA3ggAyAAKAIIa6x8IhNQDQcgEiATUkEAIAsbDQcCQCANRQ0AIAxFBEAgCCAKNgIADAELIAggCTYCAAsgCw0DIAoEQCAKIAFBAnRqQQA2AgALIAlFBEBBACEJDAQLIAEgCWpBADoAAAwDC0EAIQkMBAtBACEJQQAhCgwDCyAGIAAgDkEAELgGIAApA3hCACAAKAIEIAAoAghrrH1RDQQgCEUNACAOQQJLDQAgBikDCCESIAYpAwAhEwJAAkACQCAOQQFrDgIBAgALIAggEyASENgGOAIADAILIAggEyASENcGOQMADAELIAggEzcDACAIIBI3AwgLIAAoAgQgACgCCGusIAApA3ggEXx8IREgDyAIQQBHaiEPCyAEQQFqIQEgBC0AASIEDQEMAwsLIA9BfyAPGyEPCyANRQ0AIAkQ9gwgChD2DAsgBkGwAmokACAPCzABAX8jAEEQayICIAA2AgwgAiAAIAFBAnQgAUEAR0ECdGtqIgBBBGo2AgggACgCAAtOAAJAIABFDQAgAUECaiIBQQVLDQACQAJAAkACQCABQQFrDgUBAgIEAwALIAAgAjwAAA8LIAAgAj0BAA8LIAAgAj4CAA8LIAAgAjcDAAsLPAEBfyMAQRBrIgMkACAAKAI8IAGnIAFCIIinIAJB/wFxIANBCGoQSRDJBhogAykDCCEBIANBEGokACABCwQAQgALQQECfyMAQRBrIgEkAEF/IQICQCAAEJoGDQAgACABQQ9qQQEgACgCIBEEAEEBRw0AIAEtAA8hAgsgAUEQaiQAIAILYAICfwF+IAAoAighAUEBIQIgAEIAIAAtAABBgAFxBH9BAkEBIAAoAhQgACgCHEsbBSACCyABERsAIgNCAFkEfiAAKAIUIAAoAhxrrCADIAAoAgggACgCBGusfXwFIAMLC3kBAX8gAARAIAAoAkxBf0wEQCAAEMQGDwsgABDEBg8LQaCSBCgCAARAQaCSBCgCABDDBiEBC0G4qgUoAgAiAARAA0AgACgCTEEATgR/QQEFQQALGiAAKAIUIAAoAhxLBEAgABDEBiABciEBCyAAKAI4IgANAAsLIAELaQECfwJAIAAoAhQgACgCHE0NACAAQQBBACAAKAIkEQQAGiAAKAIUDQBBfw8LIAAoAgQiASAAKAIIIgJJBEAgACABIAJrrEEBIAAoAigRGwAaCyAAQQA2AhwgAEIANwMQIABCADcCBEEAC3YBAX9BAiEBAn8gAEErEIYGRQRAIAAtAABB8gBHIQELIAFBgAFyCyABIABB+AAQhgYbIgFBgIAgciABIABB5QAQhgYbIgEgAUHAAHIgAC0AACIAQfIARhsiAUGABHIgASAAQfcARhsiAUGACHIgASAAQeEARhsLyQIBBn8jAEEgayIDJAAgAyAAKAIcIgQ2AhAgACgCFCEFIAMgAjYCHCADIAE2AhggAyAFIARrIgE2AhQgASACaiEFQQIhBiADQRBqIQECfwJAAkAgACgCPCADQRBqQQIgA0EMahAsEMkGRQRAA0AgBSADKAIMIgRGDQIgBEF/TA0DIAFBCGogASAEIAEoAgQiB0siCBsiASAEIAdBACAIG2siByABKAIAajYCACABIAEoAgQgB2s2AgQgBSAEayEFIAAoAjwgASAGIAhrIgYgA0EMahAsEMkGRQ0ACwsgA0F/NgIMIAVBf0cNAQsgACAAKAIsIgE2AhwgACABNgIUIAAgASAAKAIwajYCECACDAELIABBADYCHCAAQgA3AxAgACAAKAIAQSByNgIAQQAgBkECRg0AGiACIAEoAgRrCyEEIANBIGokACAECyYBAX8jAEEQayICJAAgAiABNgIMIABBnMcAIAEQrwYgAkEQaiQACy4BAX8gAEG4qgUoAgA2AjhBuKoFKAIAIgEEQCABIAA2AjQLQbiqBSAANgIAIAALFgAgAEUEQEEADwtBqKoFIAA2AgBBfwvICQIEfwR+IwBB8ABrIgUkACAEQv///////////wCDIQoCQAJAIAFCf3wiCUJ/USACQv///////////wCDIgsgCSABVK18Qn98IglC////////v///AFYgCUL///////+///8AURtFBEAgA0J/fCIJQn9SIAogCSADVK18Qn98IglC////////v///AFQgCUL///////+///8AURsNAQsgAVAgC0KAgICAgIDA//8AVCALQoCAgICAgMD//wBRG0UEQCACQoCAgICAgCCEIQQgASEDDAILIANQIApCgICAgICAwP//AFQgCkKAgICAgIDA//8AURtFBEAgBEKAgICAgIAghCEEDAILIAEgC0KAgICAgIDA//8AhYRQBEBCgICAgICA4P//ACACIAEgA4UgAiAEhUKAgICAgICAgIB/hYRQIgYbIQRCACABIAYbIQMMAgsgAyAKQoCAgICAgMD//wCFhFANASABIAuEUARAIAMgCoRCAFINAiABIAODIQMgAiAEgyEEDAILIAMgCoRQRQ0AIAEhAyACIQQMAQsgAyABIAMgAVYgCiALViAKIAtRGyIHGyEKIAQgAiAHGyILQv///////z+DIQkgAiAEIAcbIgJCMIinQf//AXEhCCALQjCIp0H//wFxIgZFBEAgBUHgAGogCiAJIAogCSAJUCIGG3kgBkEGdK18pyIGQXFqEMsGIAUpA2ghCSAFKQNgIQpBECAGayEGCyABIAMgBxshAyACQv///////z+DIQEgCAR+IAEFIAVB0ABqIAMgASADIAEgAVAiBxt5IAdBBnStfKciB0FxahDLBkEQIAdrIQggBSkDUCEDIAUpA1gLQgOGIANCPYiEQoCAgICAgIAEhCEEIAlCA4YgCkI9iIQhASACIAuFIQkCfiADQgOGIgMgBiAIayIHRQ0AGiAHQf8ASwRAQgAhBEIBDAELIAVBQGsgAyAEQYABIAdrEMsGIAVBMGogAyAEIAcQ0wYgBSkDOCEEIAUpAzAgBSkDQCAFKQNIhEIAUq2ECyEDIAFCgICAgICAgASEIQwgCkIDhiECAkAgCUJ/VwRAIAIgA30iASAMIAR9IAIgA1StfSIDhFAEQEIAIQNCACEEDAMLIANC/////////wNWDQEgBUEgaiABIAMgASADIANQIgcbeSAHQQZ0rXynQXRqIgcQywYgBiAHayEGIAUpAyghAyAFKQMgIQEMAQsgAiADfCIBIANUrSAEIAx8fCIDQoCAgICAgIAIg1ANACABQgGDIANCP4YgAUIBiISEIQEgBkEBaiEGIANCAYghAwsgC0KAgICAgICAgIB/gyEEIAZB//8BTgRAIARCgICAgICAwP//AIQhBEIAIQMMAQtBACEHAkAgBkEASgRAIAYhBwwBCyAFQRBqIAEgAyAGQf8AahDLBiAFIAEgA0EBIAZrENMGIAUpAwAgBSkDECAFKQMYhEIAUq2EIQEgBSkDCCEDCyADQgOIQv///////z+DIASEIAetQjCGhCADQj2GIAFCA4iEIgQgAadBB3EiBkEES618IgMgBFStfCADQgGDQgAgBkEERhsiASADfCIDIAFUrXwhBAsgACADNwMAIAAgBDcDCCAFQfAAaiQAC1ABAX4CQCADQcAAcQRAIAEgA0FAaq2GIQJCACEBDAELIANFDQAgAiADrSIEhiABQcAAIANrrYiEIQIgASAEhiEBCyAAIAE3AwAgACACNwMIC9sBAgF/An5BASEEAkAgAEIAUiABQv///////////wCDIgVCgICAgICAwP//AFYgBUKAgICAgIDA//8AURsNACACQgBSIANC////////////AIMiBkKAgICAgIDA//8AViAGQoCAgICAgMD//wBRGw0AIAAgAoQgBSAGhIRQBEBBAA8LIAEgA4NCAFkEQEF/IQQgACACVCABIANTIAEgA1EbDQEgACAChSABIAOFhEIAUg8LQX8hBCAAIAJWIAEgA1UgASADURsNACAAIAKFIAEgA4WEQgBSIQQLIAQL2AECAX8BfkF/IQICQCAAQgBSIAFC////////////AIMiA0KAgICAgIDA//8AViADQoCAgICAgMD//wBRGw0AIAAgA0KAgICAgICA/z+EhFAEQEEADwsgAUKAgICAgICA/z+DQgBZBEAgAEIAVCABQoCAgICAgID/P1MgAUKAgICAgICA/z9RGw0BIAAgAUKAgICAgICA/z+FhEIAUg8LIABCAFYgAUKAgICAgICA/z9VIAFCgICAgICAgP8/URsNACAAIAFCgICAgICAgP8/hYRCAFIhAgsgAguOEQIFfwx+IwBBwAFrIgUkACAEQv///////z+DIRIgAkL///////8/gyEOIAIgBIVCgICAgICAgICAf4MhESAEQjCIp0H//wFxIQcCQAJAAkAgAkIwiKdB//8BcSIIQX9qQf3/AU0EQCAHQX9qQf7/AUkNAQsgAVAgAkL///////////8AgyILQoCAgICAgMD//wBUIAtCgICAgICAwP//AFEbRQRAIAJCgICAgICAIIQhEQwCCyADUCAEQv///////////wCDIgJCgICAgICAwP//AFQgAkKAgICAgIDA//8AURtFBEAgBEKAgICAgIAghCERIAMhAQwCCyABIAtCgICAgICAwP//AIWEUARAIAMgAkKAgICAgIDA//8AhYRQBEBCACEBQoCAgICAgOD//wAhEQwDCyARQoCAgICAgMD//wCEIRFCACEBDAILIAMgAkKAgICAgIDA//8AhYRQBEBCACEBDAILIAEgC4RQDQIgAiADhFAEQCARQoCAgICAgMD//wCEIRFCACEBDAILIAtC////////P1gEQCAFQbABaiABIA4gASAOIA5QIgYbeSAGQQZ0rXynIgZBcWoQywZBECAGayEGIAUpA7gBIQ4gBSkDsAEhAQsgAkL///////8/Vg0AIAVBoAFqIAMgEiADIBIgElAiCRt5IAlBBnStfKciCUFxahDLBiAGIAlqQXBqIQYgBSkDqAEhEiAFKQOgASEDCyAFQZABaiASQoCAgICAgMAAhCIUQg+GIANCMYiEIgJChMn5zr/mvIL1ACACfSIEENUGIAVBgAFqQgAgBSkDmAF9IAQQ1QYgBUHwAGogBSkDiAFCAYYgBSkDgAFCP4iEIgQgAhDVBiAFQeAAaiAEQgAgBSkDeH0Q1QYgBUHQAGogBSkDaEIBhiAFKQNgQj+IhCIEIAIQ1QYgBUFAayAEQgAgBSkDWH0Q1QYgBUEwaiAFKQNIQgGGIAUpA0BCP4iEIgQgAhDVBiAFQSBqIARCACAFKQM4fRDVBiAFQRBqIAUpAyhCAYYgBSkDIEI/iIQiBCACENUGIAUgBEIAIAUpAxh9ENUGIAYgCCAHa2ohBwJ+QgAgBSkDCEIBhiAFKQMAQj+IhEJ/fCILQv////8PgyIEIAJCIIgiDH4iECALQiCIIgsgAkL/////D4MiCn58IgJCIIYiDSAEIAp+fCIKIA1UrSALIAx+IAIgEFStQiCGIAJCIIiEfHwgCiAEIANCEYhC/////w+DIgx+IhAgCyADQg+GQoCA/v8PgyINfnwiAkIghiIPIAQgDX58IA9UrSALIAx+IAIgEFStQiCGIAJCIIiEfHx8IgIgClStfCACQgBSrXx9IgpC/////w+DIgwgBH4iECALIAx+Ig0gBCAKQiCIIg9+fCIKQiCGfCIMIBBUrSALIA9+IAogDVStQiCGIApCIIiEfHwgDEIAIAJ9IgJCIIgiCiAEfiIQIAJC/////w+DIg0gC358IgJCIIYiDyAEIA1+fCAPVK0gCiALfiACIBBUrUIghiACQiCIhHx8fCICIAxUrXwgAkJ+fCIQIAJUrXxCf3wiCkL/////D4MiAiAOQgKGIAFCPoiEQv////8PgyIEfiIMIAFCHohC/////w+DIgsgCkIgiCIKfnwiDSAMVK0gDSAQQiCIIgwgDkIeiEL//+//D4NCgIAQhCIOfnwiDyANVK18IAogDn58IAIgDn4iEyAEIAp+fCINIBNUrUIghiANQiCIhHwgDyANQiCGfCINIA9UrXwgDSALIAx+IhMgEEL/////D4MiECAEfnwiDyATVK0gDyACIAFCAoZC/P///w+DIhN+fCIVIA9UrXx8Ig8gDVStfCAPIAogE34iDSAOIBB+fCIKIAQgDH58IgQgAiALfnwiAkIgiCACIARUrSAKIA1UrSAEIApUrXx8QiCGhHwiCiAPVK18IAogFSAMIBN+IgQgCyAQfnwiC0IgiCALIARUrUIghoR8IgQgFVStIAQgAkIghnwgBFStfHwiBCAKVK18IgJC/////////wBYBEAgAUIxhiAEQv////8PgyIBIANC/////w+DIgt+IgpCAFKtfUIAIAp9IhAgBEIgiCIKIAt+Ig0gASADQiCIIgx+fCIOQiCGIg9UrX0gAkL/////D4MgC34gASASQv////8Pg358IAogDH58IA4gDVStQiCGIA5CIIiEfCAEIBRCIIh+IAMgAkIgiH58IAIgDH58IAogEn58QiCGfH0hCyAHQX9qIQcgECAPfQwBCyAEQiGIIQwgAUIwhiACQj+GIARCAYiEIgRC/////w+DIgEgA0L/////D4MiC34iCkIAUq19QgAgCn0iECABIANCIIgiCn4iDSAMIAJCH4aEIg9C/////w+DIg4gC358IgxCIIYiE1StfSAKIA5+IAJCAYgiDkL/////D4MgC358IAEgEkL/////D4N+fCAMIA1UrUIghiAMQiCIhHwgBCAUQiCIfiADIAJCIYh+fCAKIA5+fCAPIBJ+fEIghnx9IQsgDiECIBAgE30LIQEgB0GAgAFOBEAgEUKAgICAgIDA//8AhCERQgAhAQwBCyAHQf//AGohCCAHQYGAf0wEQAJAIAgNACAEIAFCAYYgA1YgC0IBhiABQj+IhCIBIBRWIAEgFFEbrXwiASAEVK0gAkL///////8/g3wiA0KAgICAgIDAAINQDQAgAyARhCERDAILQgAhAQwBCyAEIAFCAYYgA1ogC0IBhiABQj+IhCIBIBRaIAEgFFEbrXwiASAEVK0gAkL///////8/gyAIrUIwhoR8IBGEIRELIAAgATcDACAAIBE3AwggBUHAAWokAA8LIABCADcDACAAIBFCgICAgICA4P//ACACIAOEQgBSGzcDCCAFQcABaiQAC/4BAgJ/BH4jAEEQayICJAAgAb0iBUKAgICAgICAgIB/gyEHAn4gBUL///////////8AgyIEQoCAgICAgIB4fEL/////////7/8AWARAIARCPIYhBiAEQgSIQoCAgICAgICAPHwMAQsgBEKAgICAgICA+P8AWgRAIAVCPIYhBiAFQgSIQoCAgICAgMD//wCEDAELIARQBEBCAAwBCyACIARCACAFp2dBIGogBEIgiKdnIARCgICAgBBUGyIDQTFqEMsGIAIpAwAhBiACKQMIQoCAgICAgMAAhUGM+AAgA2utQjCGhAshBCAAIAY3AwAgACAEIAeENwMIIAJBEGokAAvLAQIEfwJ+IwBBEGsiAyQAIAG8IgRBgICAgHhxIQUCfiAEQf////8HcSICQYCAgHxqQf////cHTQRAIAKtQhmGQoCAgICAgIDAP3wMAQsgAkGAgID8B08EQCAErUIZhkKAgICAgIDA//8AhAwBCyACRQRAQgAMAQsgAyACrUIAIAJnIgJB0QBqEMsGIAMpAwAhBiADKQMIQoCAgICAgMAAhUGJ/wAgAmutQjCGhAshByAAIAY3AwAgACAHIAWtQiCGhDcDCCADQRBqJAALfwICfwF+IwBBEGsiAyQAIAACfiABRQRAQgAMAQsgAyABIAFBH3UiAmogAnMiAq1CACACZyICQdEAahDLBiADKQMIQoCAgICAgMAAhUGegAEgAmutQjCGfCABQYCAgIB4ca1CIIaEIQQgAykDAAs3AwAgACAENwMIIANBEGokAAtnAgF/AX4jAEEQayICJAAgAAJ+IAFFBEBCAAwBCyACIAGtQgBB8AAgAWdBH3MiAWsQywYgAikDCEKAgICAgIDAAIUgAUH//wBqrUIwhnwhAyACKQMACzcDACAAIAM3AwggAkEQaiQAC1ABAX4CQCADQcAAcQRAIAIgA0FAaq2IIQFCACECDAELIANFDQAgAkHAACADa62GIAEgA60iBIiEIQEgAiAEiCECCyAAIAE3AwAgACACNwMIC54LAgV/D34jAEHgAGsiBSQAIAJCIIYgAUIgiIQhDiAEQi+GIANCEYiEIQsgBEL///////8/gyIMQg+GIANCMYiEIRAgAiAEhUKAgICAgICAgIB/gyEKIAJC////////P4MiDUIgiCERIAxCEYghEiAEQjCIp0H//wFxIQYCQAJ/IAJCMIinQf//AXEiCEF/akH9/wFNBEBBACAGQX9qQf7/AUkNARoLIAFQIAJC////////////AIMiD0KAgICAgIDA//8AVCAPQoCAgICAgMD//wBRG0UEQCACQoCAgICAgCCEIQoMAgsgA1AgBEL///////////8AgyICQoCAgICAgMD//wBUIAJCgICAgICAwP//AFEbRQRAIARCgICAgICAIIQhCiADIQEMAgsgASAPQoCAgICAgMD//wCFhFAEQCACIAOEUARAQoCAgICAgOD//wAhCkIAIQEMAwsgCkKAgICAgIDA//8AhCEKQgAhAQwCCyADIAJCgICAgICAwP//AIWEUARAIAEgD4QhAkIAIQEgAlAEQEKAgICAgIDg//8AIQoMAwsgCkKAgICAgIDA//8AhCEKDAILIAEgD4RQBEBCACEBDAILIAIgA4RQBEBCACEBDAILIA9C////////P1gEQCAFQdAAaiABIA0gASANIA1QIgcbeSAHQQZ0rXynIgdBcWoQywYgBSkDWCINQiCGIAUpA1AiAUIgiIQhDiANQiCIIRFBECAHayEHCyAHIAJC////////P1YNABogBUFAayADIAwgAyAMIAxQIgkbeSAJQQZ0rXynIglBcWoQywYgBSkDSCICQg+GIAUpA0AiA0IxiIQhECACQi+GIANCEYiEIQsgAkIRiCESIAcgCWtBEGoLIQcgC0L/////D4MiAiABQv////8PgyIEfiITIANCD4ZCgID+/w+DIgEgDkL/////D4MiA358Ig5CIIYiDCABIAR+fCILIAxUrSACIAN+IhUgASANQv////8PgyIMfnwiDyAQQv////8PgyINIAR+fCIQIA4gE1StQiCGIA5CIIiEfCITIAIgDH4iFiABIBFCgIAEhCIOfnwiESADIA1+fCIUIBJC/////weDQoCAgIAIhCIBIAR+fCISQiCGfCIXfCEEIAYgCGogB2pBgYB/aiEGAkAgDCANfiIYIAIgDn58IgIgGFStIAIgASADfnwiAyACVK18IAMgDyAVVK0gECAPVK18fCICIANUrXwgASAOfnwgASAMfiIDIA0gDn58IgEgA1StQiCGIAFCIIiEfCACIAFCIIZ8IgEgAlStfCABIBIgFFStIBEgFlStIBQgEVStfHxCIIYgEkIgiIR8IgMgAVStfCADIBMgEFStIBcgE1StfHwiAiADVK18IgFCgICAgICAwACDUEUEQCAGQQFqIQYMAQsgC0I/iCEDIAFCAYYgAkI/iIQhASACQgGGIARCP4iEIQIgC0IBhiELIAMgBEIBhoQhBAsgBkH//wFOBEAgCkKAgICAgIDA//8AhCEKQgAhAQwBCwJ+IAZBAEwEQEEBIAZrIghB/wBNBEAgBUEwaiALIAQgBkH/AGoiBhDLBiAFQSBqIAIgASAGEMsGIAVBEGogCyAEIAgQ0wYgBSACIAEgCBDTBiAFKQMwIAUpAziEQgBSrSAFKQMgIAUpAxCEhCELIAUpAyggBSkDGIQhBCAFKQMAIQIgBSkDCAwCC0IAIQEMAgsgAUL///////8/gyAGrUIwhoQLIAqEIQogC1AgBEJ/VSAEQoCAgICAgICAgH9RG0UEQCAKIAJCAXwiASACVK18IQoMAQsgCyAEQoCAgICAgICAgH+FhFBFBEAgAiEBDAELIAogAiACQgGDfCIBIAJUrXwhCgsgACABNwMAIAAgCjcDCCAFQeAAaiQAC2wBA34gACACQiCIIgMgAUIgiCIEfkIAfCACQv////8PgyICIAFC/////w+DIgF+IgVCIIggAiAEfnwiAkIgiHwgASADfiACQv////8Pg3wiAkIgiHw3AwggACAFQv////8PgyACQiCGhDcDAAtBAQF/IwBBEGsiBSQAIAUgASACIAMgBEKAgICAgICAgIB/hRDKBiAAIAUpAwA3AwAgACAFKQMINwMIIAVBEGokAAvZAwICfwJ+IwBBIGsiAiQAAkAgAUL///////////8AgyIEQoCAgICAgMD/Q3wgBEKAgICAgIDAgLx/fFQEQCABQgSGIABCPIiEIQQgAEL//////////w+DIgBCgYCAgICAgIAIWgRAIARCgYCAgICAgIDAAHwhBQwCCyAEQoCAgICAgICAQH0hBSAAQoCAgICAgICACIVCAFINASAFQgGDIAV8IQUMAQsgAFAgBEKAgICAgIDA//8AVCAEQoCAgICAgMD//wBRG0UEQCABQgSGIABCPIiEQv////////8Dg0KAgICAgICA/P8AhCEFDAELQoCAgICAgID4/wAhBSAEQv///////7//wwBWDQBCACEFIARCMIinIgNBkfcASQ0AIAJBEGogACABQv///////z+DQoCAgICAgMAAhCIEIANB/4h/ahDLBiACIAAgBEGB+AAgA2sQ0wYgAikDCEIEhiACKQMAIgRCPIiEIQUgAikDECACKQMYhEIAUq0gBEL//////////w+DhCIEQoGAgICAgICACFoEQCAFQgF8IQUMAQsgBEKAgICAgICAgAiFQgBSDQAgBUIBgyAFfCEFCyACQSBqJAAgBSABQoCAgICAgICAgH+DhL8LtgMCA38BfiMAQSBrIgMkAAJAIAFC////////////AIMiBUKAgICAgIDAv0B8IAVCgICAgICAwMC/f3xUBEAgAUIZiKchAiAAUCABQv///w+DIgVCgICACFQgBUKAgIAIURtFBEAgAkGBgICABGohAgwCCyACQYCAgIAEaiECIAAgBUKAgIAIhYRCAFINASACQQFxIAJqIQIMAQsgAFAgBUKAgICAgIDA//8AVCAFQoCAgICAgMD//wBRG0UEQCABQhmIp0H///8BcUGAgID+B3IhAgwBC0GAgID8ByECIAVC////////v7/AAFYNAEEAIQIgBUIwiKciBEGR/gBJDQAgA0EQaiAAIAFC////////P4NCgICAgICAwACEIgUgBEH/gX9qEMsGIAMgACAFQYH/ACAEaxDTBiADKQMIIgVCGYinIQIgAykDACADKQMQIAMpAxiEQgBSrYQiAFAgBUL///8PgyIFQoCAgAhUIAVCgICACFEbRQRAIAJBAWohAgwBCyAAIAVCgICACIWEQgBSDQAgAkEBcSACaiECCyADQSBqJAAgAiABQiCIp0GAgICAeHFyvgsfAEHIsgUoAgBFBEBBzLIFIAE2AgBByLIFIAA2AgALCzMBAX8gAgRAIAAhAwNAIAMgASgCADYCACADQQRqIQMgAUEEaiEBIAJBf2oiAg0ACwsgAAsHABAtQQBKCwgAIAAQ3QYaC3MBAX8gAEGUnQM2AgBByLIFQQA2AgBBlQUgAEEAEAVByLIFKAIAIQFByLIFQQA2AgAgAUEBRwRAIABBHGoQ9wcgACgCIBD2DCAAKAIkEPYMIAAoAjAQ9gwgACgCPBD2DCAADwtBABALIQAQBxogABCEAQALPAECfyAAKAIoIQIDQCACBEAgASAAIAJBf2oiAkECdCIDIAAoAiRqKAIAIAAoAiAgA2ooAgARBQAMAQsLCwcAIAAoAhQLFQAgAEG0mgM2AgAgAEEEahD3ByAACwoAIAAQ4AYQ9gwLKgAgAEG0mgM2AgAgAEEEahDdCiAAQgA3AhggAEIANwIQIABCADcCCCAACwQAIAALCAAgABDlBhoLEgAgAEJ/NwMIIABCADcDACAACwgAIAAQ5QYaC70BAQR/IwBBEGsiBCQAA0ACQCAFIAJODQACQCAAKAIMIgMgACgCECIGSQRAIARB/////wc2AgwgBCAGIANrNgIIIAQgAiAFazYCBCAEQQxqIARBCGogBEEEahDoBhDoBiEDIAEgACgCDCADKAIAIgMQ6QYgACAAKAIMIANqNgIMDAELIAAgACgCACgCKBEAACIDQX9GDQEgASADOgAAQQEhAwsgASADaiEBIAMgBWohBQwBCwsgBEEQaiQAIAULCQAgACABEOoGCxEAIAIEQCAAIAEgAhCADRoLCygBAn8jAEEQayICJAAgASgCACAAKAIASCEDIAJBEGokACABIAAgAxsLBABBfwsvACAAIAAoAgAoAiQRAABBf0YEQEF/DwsgACAAKAIMIgBBAWo2AgwgACwAABDtBgsIACAAQf8BcQsEAEF/C7IBAQR/IwBBEGsiBSQAA0ACQCAEIAJODQAgACgCGCIDIAAoAhwiBk8EQCAAIAEsAAAQ7QYgACgCACgCNBEDAEF/Rg0BIARBAWohBCABQQFqIQEMAgUgBSAGIANrNgIMIAUgAiAEazYCCCAFQQxqIAVBCGoQ6AYhAyAAKAIYIAEgAygCACIDEOkGIAAgAyAAKAIYajYCGCADIARqIQQgASADaiEBDAILAAsLIAVBEGokACAEC0YAAkAgAgRAQciyBUEANgIAIAAgASACENoGGkHIsgUoAgAhAkHIsgVBADYCACACQQFGDQELDwtBABALIQAQBxogABCEAQALDAAgAEEIahDcBiAACxMAIAAgACgCAEF0aigCAGoQ8QYLCgAgABDxBhD2DAsTACAAIAAoAgBBdGooAgBqEPMGC+ICAQN/IwBBIGsiBCQAIABBADoAACABIAEoAgBBdGooAgBqEIIHIQMgASABKAIAQXRqKAIAaiEFAkACQCADBEAgBSgCSARAIAEgASgCAEF0aigCAGooAkgQ9wYLAkAgAg0AIAEgASgCAEF0aigCAGooAgRBgCBxRQ0AIARBGGogASABKAIAQXRqKAIAahD4BkHIsgVBADYCAEGXBSAEQRhqEA0hAkHIsgUoAgAhA0HIsgVBADYCACADQQFGDQMgBEEYahD3ByAEQRBqIAEQ+gYhAyAEQQhqEPsGIQUDQAJAIAMgBRD8BkUNACACQYDAACADEP0GEP4GRQ0AIAMQ/wYaDAELCyADIAUQgAdFDQAgASABKAIAQXRqKAIAakEGEIEHCyAAIAEgASgCAEF0aigCAGoQggc6AAAMAQsgBUEEEIEHCyAEQSBqJAAgAA8LEAYhARAHGiAEQRhqEPcHIAEQCAALBwAgABCCBwvvAwEEfyMAQRBrIgMkACAAKAIAQXRqKAIAIQFByLIFQQA2AgAgACABaigCGCECQciyBSgCACEBQciyBUEANgIAAkACQAJAAkACQCABQQFHBEAgAkUNBEHIsgVBADYCAEE0IANBCGogABAVIQJByLIFKAIAIQFByLIFQQA2AgAgAUEBRg0CIAItAABFDQEgACgCAEF0aigCACEBQciyBUEANgIAIAAgAWooAhghBEHIsgUoAgAhAUHIsgVBADYCAAJAIAFBAUYNAEHIsgVBADYCAEGZBSAEEA0hBEHIsgUoAgAhAUHIsgVBADYCACABQQFGDQAgBEF/Rw0CIAAoAgBBdGooAgAhAUHIsgVBADYCAEGaBSAAIAFqQQEQBUHIsgUoAgAhAUHIsgVBADYCACABQQFHDQILQQAQCyEBEAcaIAIQhQcMAwtBABALIQEQBxoMAgsgAhCFBwwCC0EAEAshARAHGgsgARAMGiAAKAIAQXRqKAIAIQFByLIFQQA2AgBBOSAAIAFqEA9ByLIFKAIAIQFByLIFQQA2AgAgAUEBRg0BEBcLIANBEGokAA8LEAYhAxAHGkHIsgVBADYCAEE6EApByLIFKAIAIQBByLIFQQA2AgAgAEEBRwRAIAMQCAALQQAQCyEAEAcaIAAQhAEACw0AIAAgAUEcahDbChoLCwAgAEG0tAUQ/AcLVwEBfyABKAIAQXRqKAIAIQJByLIFQQA2AgAgASACaigCGCEBQciyBSgCACECQciyBUEANgIAIAJBAUcEQCAAIAE2AgAgAA8LQQAQCyEAEAcaIAAQhAEACwsAIABBADYCACAACwwAIAAgARCHB0EBcwsQACAAKAIAEIgHQRh0QRh1CycBAX8gAkEATgR/IAAoAgggAkH/AXFBAXRqLwEAIAFxQQBHBSADCwsNACAAKAIAEIkHGiAACwkAIAAgARCHBwsPACAAIAAoAhAgAXIQkwcLCAAgACgCEEULVQAgACABNgIEIABBADoAACABIAEoAgBBdGooAgBqEIIHBEAgASABKAIAQXRqKAIAaigCSARAIAEgASgCAEF0aigCAGooAkgQ9wYLIABBAToAAAsgAAsPACAAIAAoAgAoAhgRAAALqgMBAn8gACgCBCIBKAIAQXRqKAIAIQJByLIFQQA2AgAgASACaigCGCEBQciyBSgCACECQciyBUEANgIAAkAgAkEBRg0AAkAgAUUNACAAKAIEIgEoAgBBdGooAgAhAkHIsgVBADYCACABIAJqEIIHIQFByLIFKAIAIQJByLIFQQA2AgAgAkEBRg0BIAFFDQAgACgCBCIBIAEoAgBBdGooAgBqKAIEQYDAAHFFDQAQ2wYNACAAKAIEIgEoAgBBdGooAgAhAkHIsgVBADYCACABIAJqKAIYIQJByLIFKAIAIQFByLIFQQA2AgACQCABQQFGDQBByLIFQQA2AgBBmQUgAhANIQJByLIFKAIAIQFByLIFQQA2AgAgAUEBRg0AIAJBf0cNASAAKAIEIgEoAgBBdGooAgAhAkHIsgVBADYCAEGaBSABIAJqQQEQBUHIsgUoAgAhAUHIsgVBADYCACABQQFHDQELQQAQCyEBEAcaIAEQDBpByLIFQQA2AgBBOhAKQciyBSgCACEBQciyBUEANgIAIAFBAUYNAQsPC0EAEAshABAHGiAAEIQBAAsdACAAIAAoAhBBAXI2AhAgAC0AFEEBcQRAECQACwsQACAAEMoHIAEQygdzQQFzCyoBAX8gACgCDCIBIAAoAhBGBEAgACAAKAIAKAIkEQAADwsgASwAABDtBgs0AQF/IAAoAgwiASAAKAIQRgRAIAAgACgCACgCKBEAAA8LIAAgAUEBajYCDCABLAAAEO0GCwcAIAAgAUYLPQEBfyAAKAIYIgIgACgCHEYEQCAAIAEQ7QYgACgCACgCNBEDAA8LIAAgAkEBajYCGCACIAE6AAAgARDtBgsWACAAIAAoAhhFIAAoAhAgAXJyNgIQCwsAIABB+LIFEPwHCxkAIAAgASACIAMgBCAFIAAoAgAoAhARCQALCQAgACABEJAHC80EAQV/IwBBIGsiAiQAIAJBADYCHAJAAkAgAkEYaiAAQQAQ9QYtAAAEQCACQRBqIAAgACgCAEF0aigCAGoQ+AZByLIFQQA2AgBBnAUgAkEQahANIQVByLIFKAIAIQNByLIFQQA2AgACQAJAAn8CQAJAIANBAUYNACACQQhqIAAQ+gYhAyACEPsGIQQgACgCAEF0aigCACEGIAQoAgAhBCADKAIAIQNByLIFQQA2AgBBnQUgBSADIAQgACAGaiACQRxqIAJBFGoQFhpByLIFKAIAIQNByLIFQQA2AgAgA0EBRg0AIAJBEGoQ9wcgAigCFEGAgICAeE4NASACIAIoAhxBBHI2AhxBgICAgHgMAgtBABALIQEQBxogAkEQahD3ByABEAwaIAIgAigCHEEBciIBNgIcIAAgACgCAEF0aigCAGogARCMByAAKAIAQXRqKAIAIQFByLIFQQA2AgAgACABaigCFCEBQciyBSgCACEDQciyBUEANgIAIANBAUcEQCABQQFxRQ0DQciyBUEANgIAQZ8FEApByLIFKAIAIQJByLIFQQA2AgAgAkEBRw0HCxAGIQAQBxpByLIFQQA2AgBBOhAKQciyBSgCACECQciyBUEANgIAIAJBAUYNBSAAEAgACyACKAIUQf////8HSgRAIAIgAigCHEEEcjYCHEH/////BwwBCyACKAIUCyEDIAEgAzYCAAwBCxAXCyAAIAAoAgBBdGooAgBqIAIoAhwQgQcLIAJBIGokACAADwtBABALIQIQBxogAhCEAQsAC58DAQN/IwBBEGsiBCQAIABBADYCBAJAAkACf0EEIARBCGogAEEBEPUGLQAARQ0AGiAAKAIAQXRqKAIAIQNByLIFQQA2AgAgACADaigCGCEFQciyBSgCACEDQciyBUEANgIAAkAgA0EBRg0AQciyBUEANgIAQaAFIAUgASACEBQhAUHIsgUoAgAhA0HIsgVBADYCACADQQFGDQAgACABNgIEQQBBBiABIAJGGwwBC0EAEAshAhAHGiACEAwaIAAgACgCAEF0aigCAGpBARCMByAAKAIAQXRqKAIAIQJByLIFQQA2AgAgACACaigCFCECQciyBSgCACEBQciyBUEANgIAAkAgAUEBRwRAIAJBAXFFDQFByLIFQQA2AgBBnwUQCkHIsgUoAgAhAEHIsgVBADYCACAAQQFHDQQLEAYhBBAHGkHIsgVBADYCAEE6EApByLIFKAIAIQBByLIFQQA2AgAgAEEBRg0CIAQQCAALEBdBAQshAiAAIAAoAgBBdGooAgBqIAIQgQcgBEEQaiQADwtBABALIQAQBxogABCEAQsACxMAIAAgASACIAAoAgAoAiARBAALIQAgACAAKAIYRSABciIBNgIQIAAoAhQgAXEEQBDEBwALCxcAIAAgASACIAMgBCABKAIAKAIQERQACw0AIAApAwggASkDCFELhQQBBH8jAEEwayIDJAAgACAAKAIAQXRqKAIAaiAAIAAoAgBBdGooAgBqKAIQQX1xIgUQkwcCQAJAIANBKGogAEEBEPUGLQAABEAgACgCAEF0aigCACEEQciyBUEANgIAIAAgBGooAhghAkHIsgUoAgAhBEHIsgVBADYCAAJAAkACQAJAIARBAUYNAEHIsgVBADYCAEGhBSADQRhqIAIgAUEIELYNQciyBSgCACECQciyBUEANgIAIAJBAUYNACADQQhqEOUGIQJByLIFQQA2AgAgA0EYaiACEJUHIQRByLIFKAIAIQJByLIFQQA2AgAgAkEBRg0BIAVBBHIgBSAEGyEFDAMLQQAQCyECEAcaDAELQQAQCyECEAcaCyACEAwaIAAgACgCAEF0aigCAGogBUEBciIFEIwHIAAoAgBBdGooAgAhAkHIsgVBADYCACAAIAJqKAIUIQJByLIFKAIAIQRByLIFQQA2AgACQCAEQQFHBEAgAkEBcUUNAUHIsgVBADYCAEGfBRAKQciyBSgCACEAQciyBUEANgIAIABBAUcNBQsQBiEDEAcaQciyBUEANgIAQToQCkHIsgUoAgAhAEHIsgVBADYCACAAQQFGDQMgAxAIAAsQFwsgACAAKAIAQXRqKAIAaiAFEIEHCyADQTBqJAAPC0EAEAshABAHGiAAEIQBCwALCwAgAEGstAUQ/AcLDAAgACABEJ0HQQFzCwoAIAAoAgAQngcLEwAgACABIAIgACgCACgCDBEEAAsNACAAKAIAEJ8HGiAACwkAIAAgARCdBwsQACAAEMsHIAEQywdzQQFzCycBAX8gACgCDCIBIAAoAhBGBEAgACAAKAIAKAIkEQAADwsgASgCAAsxAQF/IAAoAgwiASAAKAIQRgRAIAAgACgCACgCKBEAAA8LIAAgAUEEajYCDCABKAIACzcBAX8gACgCGCICIAAoAhxGBEAgACABIAAoAgAoAjQRAwAPCyAAIAJBBGo2AhggAiABNgIAIAELDAAgAEEEahDcBiAACxMAIAAgACgCAEF0aigCAGoQoQcLCgAgABChBxD2DAsTACAAIAAoAgBBdGooAgBqEKMHCwsAIABBiLMFEPwHCzAAAkBBfyAAKAJMEIoHRQRAIAAoAkwhAAwBCyAAIAAQqAciADYCTAsgAEEYdEEYdQsIACAAKAIARQubAQECfyMAQRBrIgEkACABQQhqIAAQ+AZByLIFQQA2AgBBlwUgAUEIahANIQBByLIFKAIAIQJByLIFQQA2AgACQCACQQFGDQBByLIFQQA2AgBBowUgAEEgEBUhAkHIsgUoAgAhAEHIsgVBADYCACAAQQFGDQAgAUEIahD3ByABQRBqJAAgAg8LEAYhAhAHGiABQQhqEPcHIAIQCAALFwAgACABIAIgAyAEIAAoAgAoAhARCAALFwAgACABIAIgAyAEIAAoAgAoAhgRCAALzwQBB38jAEEgayIDJABByLIFQQA2AgBBNCADQRhqIAAQFSEEQciyBSgCACECQciyBUEANgIAAkACQAJAIAJBAUcEQAJAIAQtAABFDQAgACAAKAIAQXRqKAIAaigCBBogA0EQaiAAIAAoAgBBdGooAgBqEPgGQciyBUEANgIAQaQFIANBEGoQDSEFQciyBSgCACECQciyBUEANgIAAkACQCACQQFHBEAgA0EQahD3ByADQQhqIAAQ+gYhBiAAKAIAQXRqKAIAIQJByLIFQQA2AgBBpQUgACACaiIHEA0hCEHIsgUoAgAhAkHIsgVBADYCACACQQFGDQEgBigCACECQciyBUEANgIAQaYFIAUgAiAHIAggARAQIQFByLIFKAIAIQJByLIFQQA2AgAgAkEBRg0BIAMgATYCECADQRBqEKcHRQ0DIAAoAgBBdGooAgAhAkHIsgVBADYCAEGaBSAAIAJqQQUQBUHIsgUoAgAhAkHIsgVBADYCACACQQFHDQNBABALIQIQBxoMAgtBABALIQIQBxogA0EQahD3BwwBC0EAEAshAhAHGgsgBBCFBwwCCyAEEIUHDAILQQAQCyECEAcaCyACEAwaIAAoAgBBdGooAgAhBEHIsgVBADYCAEE5IAAgBGoQD0HIsgUoAgAhBEHIsgVBADYCACAEQQFGDQEQFwsgA0EgaiQAIAAPCxAGIQMQBxpByLIFQQA2AgBBOhAKQciyBSgCACEAQciyBUEANgIAIABBAUcEQCADEAgAC0EAEAshABAHGiAAEIQBAAu9BAEHfyMAQSBrIgMkAEHIsgVBADYCAEE0IANBGGogABAVIQRByLIFKAIAIQJByLIFQQA2AgACQAJAAkAgAkEBRwRAAkAgBC0AAEUNACADQRBqIAAgACgCAEF0aigCAGoQ+AZByLIFQQA2AgBBpAUgA0EQahANIQVByLIFKAIAIQJByLIFQQA2AgACQAJAIAJBAUcEQCADQRBqEPcHIANBCGogABD6BiEGIAAoAgBBdGooAgAhAkHIsgVBADYCAEGlBSAAIAJqIgcQDSEIQciyBSgCACECQciyBUEANgIAIAJBAUYNASAGKAIAIQJByLIFQQA2AgBBpwUgBSACIAcgCCABEBAhAUHIsgUoAgAhAkHIsgVBADYCACACQQFGDQEgAyABNgIQIANBEGoQpwdFDQMgACgCAEF0aigCACECQciyBUEANgIAQZoFIAAgAmpBBRAFQciyBSgCACECQciyBUEANgIAIAJBAUcNA0EAEAshAhAHGgwCC0EAEAshAhAHGiADQRBqEPcHDAELQQAQCyECEAcaCyAEEIUHDAILIAQQhQcMAgtBABALIQIQBxoLIAIQDBogACgCAEF0aigCACEEQciyBUEANgIAQTkgACAEahAPQciyBSgCACEEQciyBUEANgIAIARBAUYNARAXCyADQSBqJAAgAA8LEAYhAxAHGkHIsgVBADYCAEE6EApByLIFKAIAIQBByLIFQQA2AgAgAEEBRwRAIAMQCAALQQAQCyEAEAcaIAAQhAEAC8QEAQd/IwBBIGsiAyQAQciyBUEANgIAQTQgA0EYaiAAEBUhBEHIsgUoAgAhAkHIsgVBADYCAAJAAkACQCACQQFHBEACQCAELQAARQ0AIANBEGogACAAKAIAQXRqKAIAahD4BkHIsgVBADYCAEGkBSADQRBqEA0hBUHIsgUoAgAhAkHIsgVBADYCAAJAAkAgAkEBRwRAIANBEGoQ9wcgA0EIaiAAEPoGIQYgACgCAEF0aigCACECQciyBUEANgIAQaUFIAAgAmoiBxANIQhByLIFKAIAIQJByLIFQQA2AgAgAkEBRg0BIAYoAgAhAkHIsgVBADYCAEGoBSAFIAIgByAIIAGnIAFCIIinEEohBUHIsgUoAgAhAkHIsgVBADYCACACQQFGDQEgAyAFNgIQIANBEGoQpwdFDQMgACgCAEF0aigCACECQciyBUEANgIAQZoFIAAgAmpBBRAFQciyBSgCACECQciyBUEANgIAIAJBAUcNA0EAEAshAhAHGgwCC0EAEAshAhAHGiADQRBqEPcHDAELQQAQCyECEAcaCyAEEIUHDAILIAQQhQcMAgtBABALIQIQBxoLIAIQDBogACgCAEF0aigCACEEQciyBUEANgIAQTkgACAEahAPQciyBSgCACEEQciyBUEANgIAIARBAUYNARAXCyADQSBqJAAgAA8LEAYhAxAHGkHIsgVBADYCAEE6EApByLIFKAIAIQBByLIFQQA2AgAgAEEBRwRAIAMQCAALQQAQCyEAEAcaIAAQhAEACxcAIAAgASACIAMgBCAAKAIAKAIcERUAC74EAQd/IwBBIGsiAyQAQciyBUEANgIAQTQgA0EYaiAAEBUhBEHIsgUoAgAhAkHIsgVBADYCAAJAAkACQCACQQFHBEACQCAELQAARQ0AIANBEGogACAAKAIAQXRqKAIAahD4BkHIsgVBADYCAEGkBSADQRBqEA0hBUHIsgUoAgAhAkHIsgVBADYCAAJAAkAgAkEBRwRAIANBEGoQ9wcgA0EIaiAAEPoGIQYgACgCAEF0aigCACECQciyBUEANgIAQaUFIAAgAmoiBxANIQhByLIFKAIAIQJByLIFQQA2AgAgAkEBRg0BIAYoAgAhAkHIsgVBADYCAEGpBSAFIAIgByAIIAG7EC4hBUHIsgUoAgAhAkHIsgVBADYCACACQQFGDQEgAyAFNgIQIANBEGoQpwdFDQMgACgCAEF0aigCACECQciyBUEANgIAQZoFIAAgAmpBBRAFQciyBSgCACECQciyBUEANgIAIAJBAUcNA0EAEAshAhAHGgwCC0EAEAshAhAHGiADQRBqEPcHDAELQQAQCyECEAcaCyAEEIUHDAILIAQQhQcMAgtBABALIQIQBxoLIAIQDBogACgCAEF0aigCACEEQciyBUEANgIAQTkgACAEahAPQciyBSgCACEEQciyBUEANgIAIARBAUYNARAXCyADQSBqJAAgAA8LEAYhAxAHGkHIsgVBADYCAEE6EApByLIFKAIAIQBByLIFQQA2AgAgAEEBRwRAIAMQCAALQQAQCyEAEAcaIAAQhAEACxcAIAAgASACIAMgBCAAKAIAKAIgER4ACykBAX8CQCAAKAIAIgJFDQAgAiABEIsHQX8QigdFDQAgAEEANgIACyAAC7ADAQR/IwBBEGsiBSQAQciyBUEANgIAQTQgBUEIaiAAEBUhBEHIsgUoAgAhA0HIsgVBADYCAAJAAkACQCADQQFHBEAgBC0AACEDAkAgAkUNACADRQ0AIAAoAgBBdGooAgAhA0HIsgVBADYCACAAIANqKAIYIQZByLIFKAIAIQNByLIFQQA2AgACQCADQQFGDQBByLIFQQA2AgBBqgUgBiABIAIQFCEBQciyBSgCACEDQciyBUEANgIAIANBAUYNACABIAJGDQEgACgCAEF0aigCACEDQciyBUEANgIAQZoFIAAgA2pBARAFQciyBSgCACEDQciyBUEANgIAIANBAUcNAQtBABALIQMQBxogBBCFBwwCCyAEEIUHDAILQQAQCyEDEAcaCyADEAwaIAAoAgBBdGooAgAhBEHIsgVBADYCAEE5IAAgBGoQD0HIsgUoAgAhBEHIsgVBADYCACAEQQFGDQEQFwsgBUEQaiQADwsQBiEFEAcaQciyBUEANgIAQToQCkHIsgUoAgAhAEHIsgVBADYCACAAQQFHBEAgBRAIAAtBABALIQAQBxogABCEAQALEwAgACABIAIgACgCACgCMBEEAAspAQF/AkAgACgCACICRQ0AIAIgARCgB0F/EIoHRQ0AIABBADYCAAsgAAsMACAAQQxqENwGIAALCgAgAEF4ahC1BwsTACAAIAAoAgBBdGooAgBqELUHCwoAIAAQtQcQ9gwLCgAgAEF4ahC4BwsTACAAIAAoAgBBdGooAgBqELgHCwYAQaScAwsmAAJAIAJBAUYNACACQYACSg0AIAAgAhCiDA8LIABBrZwDEL0HGgsiAQF/IwBBEGsiAiQAIAAgASABEIgNEIgMIAJBEGokACAACz0CAX8BfiMAQRBrIgMkACADIAIpAgAiBDcDACADIAQ3AwggACADIAEQpgwgAEGAnQM2AgAgA0EQaiQAIAALCgAgABCnDBogAAsKACAAEL8HEPYMCwkAIAAgARDCBwskAQJ/IwBBEGsiAiQAIAAgARDIByEDIAJBEGokACABIAAgAxsLCgAgABDdBhD2DAucAQECfyMAQRBrIgAkAEEQEA4hASAAQQhqEMUHIQBByLIFQQA2AgBBrAUgAUGcnQMgABAUGkHIsgUoAgAhAEHIsgVBADYCAAJAAkAgAEEBRwRAQciyBUEANgIAQTEgAUHknQNBrQUQEkHIsgUoAgAhAUHIsgVBADYCACABQQFHDQIQBiEAEAcaDAELEAYhABAHGiABEBMLIAAQCAsAC04BAX8jAEEQayIBJAACQEHQsgUtAABBAXENAEHQsgUQqwxFDQBB0LIFEK8MCyABQQhqQQFBpJIEEMkHIAAgASkDCDcCACABQRBqJAAgAAtAACAAQQA2AhQgACABNgIYIABBADYCDCAAQoKggIDgADcCBCAAIAFFNgIQIABBIGpBAEEoEIENGiAAQRxqEN0KCzUBAX8jAEEQayICJAAgAiAAKAIANgIMIAAgASgCADYCACABIAJBDGooAgA2AgAgAkEQaiQACw0AIAAoAgAgASgCAEkLEAAgACACNgIEIAAgATYCAAssAQF/IAAoAgAiAQRAIAEQiAdBfxCKB0UEQCAAKAIARQ8LIABBADYCAAtBAQssAQF/IAAoAgAiAQRAIAEQngdBfxCKB0UEQCAAKAIARQ8LIABBADYCAAtBAQsRACAAIAEgACgCACgCHBEDAAsRACAAIAEgACgCACgCLBEDAAsMACAAIAEoAgA2AgALxAIBC38gACgCCCAAKAIAQaLa79cGaiIFENAHIQQgACgCDCAFENAHIQMgACgCECAFENAHIQYCQCAEIAFBAnZPDQAgAyABIARBAnRrIgdPDQAgBiAHTw0AIAMgBnJBA3ENACAGQQJ2IQogA0ECdiELQQAhBwNAIAAgByAEQQF2IglqIgxBAXQiDSALakECdGoiAygCACAFENAHIQYgASADKAIEIAUQ0AciA00NASAGIAEgA2tPDQEgACADIAZqai0AAA0BIAIgACADahCDBiIDRQRAIAAgCiANakECdGoiBCgCACAFENAHIQMgASAEKAIEIAUQ0AciBE0NAiADIAEgBGtPDQJBACAAIARqIAAgAyAEamotAAAbIQgMAgsgBEEBRg0BIAkgBCAJayADQQBIIgMbIQQgByAMIAMbIQcMAAALAAsgCAspACAAQQh0QYCA/AdxIABBGHRyIABBCHZBgP4DcSAAQRh2cnIgACABGwuOAQEDfyMAQRBrIgAkAAJAIABBDGogAEEIahAxDQBB1LIFIAAoAgxBAnRBBGoQ9QwiATYCACABRQ0AAkAgACgCCBD1DCIBBEBB1LIFKAIAIgINAQtB1LIFQQA2AgAMAQsgAiAAKAIMQQJ0akEANgIAQdSyBSgCACABEDJFDQBB1LIFQQA2AgALIABBEGokAAuTAQEFfyAAEIgNIQQCQAJAQdSyBSgCAEUNACAALQAARQ0AIABBPRCGBg0AQdSyBSgCACgCACIBRQ0AA0AgACABIAQQgQYhA0HUsgUoAgAhASADRQRAIAEgAkECdGooAgAiAyAEaiIFLQAAQT1GDQMLIAEgAkEBaiICQQJ0aigCACIBDQALC0EADwsgBUEBakEAIAMbC78FAQl/IwBBkAJrIgUkAAJAIAEtAAANAEGgogMQ0gciAQRAIAEtAAANAQsgAEEMbEGwogNqENIHIgEEQCABLQAADQELQfiiAxDSByIBBEAgAS0AAA0BC0H9ogMhAQsCQANAAkAgASACai0AACIDRQ0AIANBL0YNAEEPIQMgAkEBaiICQQ9HDQEMAgsLIAIhAwtB/aIDIQQCQAJAAkACQAJAIAEtAAAiAkEuRg0AIAEgA2otAAANACABIQQgAkHDAEcNAQsgBC0AAUUNAQsgBEH9ogMQgwZFDQAgBEGFowMQgwYNAQsgAEUEQEHUoQMhAiAELQABQS5GDQILQQAhAgwBC0HgsgUoAgAiAgRAA0AgBCACQQhqEIMGRQ0CIAIoAhgiAg0ACwtB4LIFKAIAIgIEQANAIAQgAkEIahCDBkUNAiACKAIYIgINAAsLAkACQAJAQfCpBSgCAA0AQYujAxDSByICRQ0AIAItAABFDQAgA0EBaiEIQf4BIANrIQkDQCACQToQiQYiASACayABLQAAIgpBAEdrIgYgCUkEfyAFQRBqIAIgBhCADRogBUEQaiAGaiICQS86AAAgAkEBaiAEIAMQgA0aIAVBEGogBiAIampBADoAACAFQRBqIAVBDGoQMyICBEBBHBD1DCIBDQQgAiAFKAIMEDQQigYaDAMLIAEtAAAFIAoLQQBHIAFqIgItAAANAAsLQRwQ9QwiAkUNASACQdShAykCADcCACACQQhqIgEgBCADEIANGiABIANqQQA6AAAgAkHgsgUoAgA2AhhB4LIFIAI2AgAgAiEHDAELIAEgAjYCACABIAUoAgw2AgQgAUEIaiICIAQgAxCADRogAiADakEAOgAAIAFB4LIFKAIANgIYQeCyBSABNgIAIAEhBwsgB0HUoQMgACAHchshAgsgBUGQAmokACACCxcAIABBAEcgAEHwoQNHcSAAQYiiA0dxC9gBAQR/IwBBIGsiBiQAAn8CQCACENQHBEADQCAAIAN2QQFxBEAgAiADQQJ0aiADIAEQ0wc2AgALIANBAWoiA0EGRw0ACwwBCwNAQQEgA3QgAHEhBSAGQQhqIANBAnRqAn8CQCACRQ0AIAUNACACIANBAnRqKAIADAELIAMgAUGYowMgBRsQ0wcLIgU2AgAgBCAFQQBHaiEEIANBAWoiA0EGRw0ACyAEQQFLDQBB8KEDIARBAWsNARogBigCCEHUoQNHDQBBiKIDDAELIAILIQMgBkEgaiQAIAMLYwECfyMAQRBrIgMkACADIAI2AgwgAyACNgIIQX8hBAJAQQBBACABIAIQjQYiAkEASA0AIAAgAkEBaiIAEPUMIgI2AgAgAkUNACACIAAgASADKAIMEI0GIQQLIANBEGokACAECxcAIAAQ+wVBAEcgAEEgckGff2pBBklyCwQAIAMLDwAgABDUBwRAIAAQ9gwLCyMBAn8gACEBA0AgASICQQRqIQEgAigCAA0ACyACIABrQQJ1CwYAQZyjAwsGAEGgqQMLBgBBsLUDC7sDAQV/IwBBEGsiByQAAkACQAJAAkAgAARAIAJBBE8NASACIQMMAgsgASgCACIAKAIAIgNFDQMDQEEBIQUgA0GAAU8EQEF/IQYgB0EMaiADQQAQoAYiBUF/Rg0FCyAAKAIEIQMgAEEEaiEAIAQgBWoiBCEGIAMNAAsMAwsgASgCACEFIAIhAwNAAn8gBSgCACIEQX9qQf8ATwRAIARFBEAgAEEAOgAAIAFBADYCAAwFC0F/IQYgACAEQQAQoAYiBEF/Rg0FIAMgBGshAyAAIARqDAELIAAgBDoAACADQX9qIQMgASgCACEFIABBAWoLIQAgASAFQQRqIgU2AgAgA0EDSw0ACwsgAwRAIAEoAgAhBQNAAn8gBSgCACIEQX9qQf8ATwRAIARFBEAgAEEAOgAAIAFBADYCAAwFC0F/IQYgB0EMaiAEQQAQoAYiBEF/Rg0FIAMgBEkNBCAAIAUoAgBBABCgBhogAyAEayEDIAAgBGoMAQsgACAEOgAAIANBf2ohAyABKAIAIQUgAEEBagshACABIAVBBGoiBTYCACADDQALCyACIQYMAQsgAiADayEGCyAHQRBqJAAgBgvpAgEFfyMAQZACayIGJAAgBiABKAIAIgg2AgwgACAGQRBqIAAbIQdBACEEAkAgA0GAAiAAGyIDRQ0AIAhFDQACQCADIAJNIgUEQAwBCyACQSBLDQAMAQsDQCACIAMgAiAFQQFxGyIFayECIAcgBkEMaiAFEN4HIgVBf0YEQEEAIQMgBigCDCEIQX8hBAwCCyAHIAUgB2ogByAGQRBqRiIJGyEHIAQgBWohBCAGKAIMIQggA0EAIAUgCRtrIgNFDQEgCEUNASACIANPIgUNACACQSFPDQALCwJAAkAgCEUNACADRQ0AIAJFDQADQCAHIAgoAgBBABCgBiIFQQFqQQFNBEBBfyEJIAUNAyAGQQA2AgwMAgsgBiAGKAIMQQRqIgg2AgwgBCAFaiEEIAMgBWsiA0UNASAFIAdqIQcgBCEJIAJBf2oiAg0ACwwBCyAEIQkLIAAEQCABIAYoAgw2AgALIAZBkAJqJAAgCQulCAEFfyABKAIAIQQCQAJAAkACQAJAAkACQAJ/AkACQAJAAkAgA0UNACADKAIAIgZFDQAgAEUEQCACIQMMAwsgA0EANgIAIAIhAwwBCwJAQdSQBCgCACgCAEUEQCAARQ0BIAJFDQwgAiEGA0AgBCwAACIDBEAgACADQf+/A3E2AgAgAEEEaiEAIARBAWohBCAGQX9qIgYNAQwOCwsgAEEANgIAIAFBADYCACACIAZrDwsgAiEDIABFDQMMBQsgBBCIDQ8LQQEhBQwDC0EADAELQQELIQUDQCAFRQRAIAQtAABBA3YiBUFwaiAGQRp1IAVqckEHSw0DAn8gBEEBaiIFIAZBgICAEHFFDQAaIAUtAABBwAFxQYABRw0EIARBAmoiBSAGQYCAIHFFDQAaIAUtAABBwAFxQYABRw0EIARBA2oLIQQgA0F/aiEDQQEhBQwBCwNAAkAgBC0AACIGQX9qQf4ASw0AIARBA3ENACAEKAIAIgZB//37d2ogBnJBgIGChHhxDQADQCADQXxqIQMgBCgCBCEGIARBBGoiBSEEIAYgBkH//ft3anJBgIGChHhxRQ0ACyAFIQQLIAZB/wFxIgVBf2pB/gBNBEAgA0F/aiEDIARBAWohBAwBCwsgBUG+fmoiBUEySw0DIARBAWohBCAFQQJ0QYCYA2ooAgAhBkEAIQUMAAALAAsDQCAFRQRAIANFDQcDQAJAAkACQCAELQAAIgVBf2oiB0H+AEsEQCAFIQYMAQsgBEEDcQ0BIANBBUkNAQJAA0AgBCgCACIGQf/9+3dqIAZyQYCBgoR4cQ0BIAAgBkH/AXE2AgAgACAELQABNgIEIAAgBC0AAjYCCCAAIAQtAAM2AgwgAEEQaiEAIARBBGohBCADQXxqIgNBBEsNAAsgBC0AACEGCyAGQf8BcSIFQX9qIQcLIAdB/gBLDQELIAAgBTYCACAAQQRqIQAgBEEBaiEEIANBf2oiAw0BDAkLCyAFQb5+aiIFQTJLDQMgBEEBaiEEIAVBAnRBgJgDaigCACEGQQEhBQwBCyAELQAAIgdBA3YiBUFwaiAFIAZBGnVqckEHSw0BAkACQAJ/IARBAWoiCCAHQYB/aiAGQQZ0ciIFQX9KDQAaIAgtAABBgH9qIgdBP0sNASAEQQJqIgggByAFQQZ0ciIFQX9KDQAaIAgtAABBgH9qIgdBP0sNASAHIAVBBnRyIQUgBEEDagshBCAAIAU2AgAgA0F/aiEDIABBBGohAAwBC0GoqgVBGTYCACAEQX9qIQQMBQtBACEFDAAACwALIARBf2ohBCAGDQEgBC0AACEGCyAGQf8BcQ0AIAAEQCAAQQA2AgAgAUEANgIACyACIANrDwtBqKoFQRk2AgAgAEUNAQsgASAENgIAC0F/DwsgASAENgIAIAILjAMBBn8jAEGQCGsiBiQAIAYgASgCACIJNgIMIAAgBkEQaiAAGyEHAkAgA0GAAiAAGyIDRQ0AIAlFDQAgAkECdiIFIANPIQogAkGDAU1BACAFIANJGw0AA0AgAiADIAUgChsiBWshAiAHIAZBDGogBSAEEOAHIgVBf0YEQEEAIQMgBigCDCEJQX8hCAwCCyAHIAcgBUECdGogByAGQRBqRiIKGyEHIAUgCGohCCAGKAIMIQkgA0EAIAUgChtrIgNFDQEgCUUNASACQQJ2IgUgA08hCiACQYMBSw0AIAUgA08NAAsLAkACQCAJRQ0AIANFDQAgAkUNAANAIAcgCSACIAQQtQYiBUECakECTQRAIAVBAWoiAkEBTQRAIAJBAWsNBCAGQQA2AgwMAwsgBEEANgIADAILIAYgBigCDCAFaiIJNgIMIAhBAWohCCADQX9qIgNFDQEgB0EEaiEHIAIgBWshAiAIIQUgAg0ACwwBCyAIIQULIAAEQCABIAYoAgw2AgALIAZBkAhqJAAgBQvKAgEDfyMAQRBrIgUkAAJ/QQAgAUUNABoCQCACRQ0AIAAgBUEMaiAAGyEAIAEtAAAiA0EYdEEYdSIEQQBOBEAgACADNgIAIARBAEcMAgsgASwAACEEQdSQBCgCACgCAEUEQCAAIARB/78DcTYCAEEBDAILIARB/wFxQb5+aiIDQTJLDQAgA0ECdEGAmANqKAIAIQMgAkEDTQRAIAMgAkEGbEF6anRBAEgNAQsgAS0AASIEQQN2IgJBcGogAiADQRp1anJBB0sNACAEQYB/aiADQQZ0ciICQQBOBEAgACACNgIAQQIMAgsgAS0AAkGAf2oiA0E/Sw0AIAMgAkEGdHIiAkEATgRAIAAgAjYCAEEDDAILIAEtAANBgH9qIgFBP0sNACAAIAEgAkEGdHI2AgBBBAwBC0GoqgVBGTYCAEF/CyEBIAVBEGokACABCxEAQQRBAUHUkAQoAgAoAgAbCxQAQQAgACABIAJB5LIFIAIbELUGCzEBAX9B1JAEKAIAIQEgAARAQdSQBEGQqgUgACAAQX9GGzYCAAtBfyABIAFBkKoFRhsLfAEBfyMAQZABayIEJAAgBCAANgIsIAQgADYCBCAEQQA2AgAgBEF/NgJMIARBfyAAQf////8HaiAAQQBIGzYCCCAEQgAQsgYgBCACQQEgAxC0BiEDIAEEQCABIAAgBCgCBCAEKAJ4aiAEKAIIa2o2AgALIARBkAFqJAAgAwsNACAAIAEgAkJ/EOYHCxYAIAAgASACQoCAgICAgICAgH8Q5gcLMgIBfwF9IwBBEGsiAiQAIAIgACABQQAQ6gcgAikDACACKQMIENgGIQMgAkEQaiQAIAMLnwECAX8DfiMAQaABayIEJAAgBEEQakEAQZABEIENGiAEQX82AlwgBCABNgI8IARBfzYCGCAEIAE2AhQgBEEQakIAELIGIAQgBEEQaiADQQEQuAYgBCkDCCEFIAQpAwAhBiACBEAgAiABIAEgBCkDiAEgBCgCFCAEKAIYa6x8IgenaiAHUBs2AgALIAAgBjcDACAAIAU3AwggBEGgAWokAAsyAgF/AXwjAEEQayICJAAgAiAAIAFBARDqByACKQMAIAIpAwgQ1wYhAyACQRBqJAAgAwszAQF/IwBBEGsiAyQAIAMgASACQQIQ6gcgACADKQMANwMAIAAgAykDCDcDCCADQRBqJAALLwAjAEEQayIDJAAgAyABIAIQ7AcgACADKQMANwMAIAAgAykDCDcDCCADQRBqJAALVAECfwJAA0AgAyAERwRAQX8hACABIAJGDQIgASwAACIFIAMsAAAiBkgNAiAGIAVIBEBBAQ8FIANBAWohAyABQQFqIQEMAgsACwsgASACRyEACyAACxsAIwBBEGsiASQAIAAgAiADEPAHIAFBEGokAAuXAQEEfyMAQRBrIgUkACABIAIQ9QsiBEFvTQRAAkAgBEEKTQRAIAAgBBDLCSAAIQMMAQsgACAEEOILQQFqIgYQ4wsiAxDkCyAAIAYQ5QsgACAEEMoJCwNAIAEgAkcEQCADIAEQyQkgA0EBaiEDIAFBAWohAQwBCwsgBUEAOgAPIAMgBUEPahDJCSAFQRBqJAAPCyAAEIYMAAtAAQF/QQAhAAN/IAEgAkYEfyAABSABLAAAIABBBHRqIgBBgICAgH9xIgNBGHYgA3IgAHMhACABQQFqIQEMAQsLC1QBAn8CQANAIAMgBEcEQEF/IQAgASACRg0CIAEoAgAiBSADKAIAIgZIDQIgBiAFSARAQQEPBSADQQRqIQMgAUEEaiEBDAILAAsLIAEgAkchAAsgAAsbACMAQRBrIgEkACAAIAIgAxD0ByABQRBqJAALmwEBBH8jAEEQayIFJAAgASACEMsLIgRB7////wNNBEACQCAEQQFNBEAgACAEEMsJIAAhAwwBCyAAIAQQ9gtBAWoiBhD3CyIDEOQLIAAgBhDlCyAAIAQQygkLA0AgASACRwRAIAMgARDOByADQQRqIQMgAUEEaiEBDAELCyAFQQA2AgwgAyAFQQxqEM4HIAVBEGokAA8LIAAQhgwAC0ABAX9BACEAA38gASACRgR/IAAFIAEoAgAgAEEEdGoiAEGAgICAf3EiA0EYdiADciAAcyEAIAFBBGohAQwBCwsLrAQBAn8jAEEgayIGJAAgBiABNgIYAkACQCADKAIEQQFxRQRAIAZBfzYCACAGIAAgASACIAMgBCAGIAAoAgAoAhARCQAiATYCGCAGKAIAIgNBAU0EQCADQQFrDQIgBUEBOgAADAMLIAVBAToAACAEQQQ2AgAMAgsgBiADEPgGQciyBUEANgIAQZcFIAYQDSEBQciyBSgCACEAQciyBUEANgIAAkACQAJAAkAgAEEBRwRAIAYQ9wcgBiADEPgGQciyBUEANgIAQcAFIAYQDSEDQciyBSgCACEAQciyBUEANgIAIABBAUYNASAGEPcHQQAhAEHIsgVBADYCAEHBBSAGIAMQBUHIsgUoAgAhB0HIsgVBADYCACAHQQFGDQJByLIFQQA2AgBBwgUgBkEMciADEAVByLIFKAIAIQNByLIFQQA2AgBBASEAIANBAUYNAkHIsgVBADYCAEHDBSAGQRhqIAIgBiAGQRhqIgMgASAEQQEQICEBQciyBSgCACEEQciyBUEANgIAIARBAUYNAyAFIAEgBkY6AAAgBigCGCEBA0AgA0F0ahCJDCIDIAZHDQALDAYLEAYhARAHGiAGEPcHDAMLEAYhARAHGiAGEPcHDAILEAYhARAHGiAARQ0BIAYgAEEMbGohAwNAIANBdGoQiQwiAyAGRw0ACwwBCxAGIQEQBxoDQCADQXRqEIkMIgMgBkcNAAsLIAEQCAALIAVBADoAAAsgBkEgaiQAIAELCgAgACgCABDQCgsLACAAQdy0BRD8BwsRACAAIAEgASgCACgCGBECAAsRACAAIAEgASgCACgCHBECAAucBwEMfyMAQYABayIIJAAgCCABNgJ4IAIgAxD9ByEJIAhBxAU2AgQgCEEIakEAIAhBBGoQ/gchDiAIQRBqIQoCQAJAIAlB5QBPBEAgCRD1DCIKRQRAQciyBUEANgIAQcUFEApByLIFKAIAIQFByLIFQQA2AgAgAUEBRw0DEAYhARAHGgwCCyAOIAoQ/wcLIAohByACIQEDQCABIANGBEACQAJAA0ACQEHIsgVBADYCAEHGBSAAIAhB+ABqEBUhAUHIsgUoAgAhB0HIsgVBADYCACAHQQFGDQAgCUEARyABcUUEQEHIsgVBADYCAEHHBSAAIAhB+ABqEBUhAUHIsgUoAgAhB0HIsgVBADYCACAHQQFGDQQgAUUNAyAFIAUoAgBBAnI2AgAMAwtByLIFQQA2AgBByAUgABANIQ9ByLIFKAIAIQFByLIFQQA2AgACQCABQQFHBEAgBg0BQciyBUEANgIAQckFIAQgDxAVIQ9ByLIFKAIAIQFByLIFQQA2AgAgAUEBRw0BCxAGIQEQBxoMBwsgDEEBaiENQQAhECAKIQcgAiEBA0AgASADRgRAIA0hDCAQRQ0DQciyBUEANgIAQcoFIAAQDRpByLIFKAIAIQFByLIFQQA2AgAgAUEBRwRAIAohByACIQEgCSALakECSQ0EA0AgASADRgRADAYFAkAgBy0AAEECRw0AIAEQgQggDUYNACAHQQA6AAAgC0F/aiELCyAHQQFqIQcgAUEMaiEBDAELAAALAAsQBiEBEAcaDAgLAkAgBy0AAEEBRw0AIAEgDBCCCCwAACERAkAgBg0AQciyBUEANgIAQckFIAQgEUEYdEEYdRAVIRFByLIFKAIAIRJByLIFQQA2AgAgEkEBRw0AEAYhARAHGgwJCwJAIA9B/wFxIBFB/wFxRgRAQQEhECABEIEIIA1HDQIgB0ECOgAAIAtBAWohCwwBCyAHQQA6AAALIAlBf2ohCQsgB0EBaiEHIAFBDGohAQwAAAsACwsQBiEBEAcaDAQLAkACQANAIAIgA0YNASAKLQAAQQJHBEAgCkEBaiEKIAJBDGohAgwBCwsgAiEDDAELIAUgBSgCAEEEcjYCAAsgDhCDCCAIQYABaiQAIAMPCxAGIQEQBxoFAkAgARCECEUEQCAHQQE6AAAMAQsgB0ECOgAAIAtBAWohCyAJQX9qIQkLIAdBAWohByABQQxqIQEMAQsLCyAOEIMIIAEQCAsACygAIAAoAgAiACABELkKIgEQ2QpFBEAQ4AUACyAAQRBqIAEQzgooAgALCgAgASAAa0EMbQtdAQF/IwBBEGsiAyQAIAMgATYCDEHIsgVBADYCACAAIANBDGogAhDqCBpByLIFKAIAIQJByLIFQQA2AgAgAkEBRwRAIANBEGokACAADwtBABALIQMQBxogAxCEAQALWwEBfyAAKAIAIQIgACABNgIAAkAgAkUNACAAEOsIKAIAIQBByLIFQQA2AgAgACACEA9ByLIFKAIAIQBByLIFQQA2AgAgAEEBRw0AQQAQCyEAEAcaIAAQhAEACwsRACAAIAEgACgCACgCDBEDAAsVACAAEK0IBEAgACgCBA8LIAAtAAsLCgAgABCvCCABagsJACAAQQAQ/wcLCAAgABCBCEULDwAgASACIAMgBCAFEIYIC+0GAQN/IwBBkAJrIgUkACAFIAE2AoACIAUgADYCiAIgAhCHCCEHIAVB0AFqIAIgBUH/AWoQiAggBUHAAWoQiQgiAhCKCCEGQciyBUEANgIAQcwFIAIgBhAFQciyBSgCACEGQciyBUEANgIAAkACQAJAIAZBAUcEQCAFIAJBABCCCCIGNgK8ASAFIAVBEGo2AgwgBUEANgIIA0ACQEHIsgVBADYCAEHGBSAFQYgCaiAFQYACahAVIQBByLIFKAIAIQFByLIFQQA2AgAgAUEBRg0AIABFDQQgBSgCvAEgAhCBCCAGakYEQCACEIEIIQAgAhCBCCEGQciyBUEANgIAQcwFIAIgBkEBdBAFQciyBSgCACEGQciyBUEANgIAIAZBAUYNBCACEIoIIQZByLIFQQA2AgBBzAUgAiAGEAVByLIFKAIAIQZByLIFQQA2AgAgBkEBRg0EIAUgAkEAEIIIIgYgAGo2ArwBC0HIsgVBADYCAEHIBSAFQYgCahANIQBByLIFKAIAIQFByLIFQQA2AgAgAUEBRg0AQciyBUEANgIAIAAgByAGIAVBvAFqIAVBCGogBSwA/wEgBUHQAWogBUEQaiAFQQxqQcDBAxCMCCEAQciyBSgCACEBQciyBUEANgIAIAFBAUYNACAADQRByLIFQQA2AgBBygUgBUGIAmoQDRpByLIFKAIAIQBByLIFQQA2AgAgAEEBRw0BCwsQBiEGEAcaDAMLEAYhBhAHGgwCCxAGIQYQBxoMAQsCQCAFQdABahCBCEUNACAFKAIMIgAgBUEQamtBnwFKDQAgBSAAQQRqNgIMIAAgBSgCCDYCAAtByLIFQQA2AgBBzgUgBiAFKAK8ASADIAcQGiEGQciyBSgCACEAQciyBUEANgIAAkAgAEEBRg0AIAQgBjYCAEHIsgVBADYCACAFQdABaiAFQRBqIAUoAgwgAxCOCEHIsgUoAgAhBkHIsgVBADYCACAGQQFGDQBByLIFQQA2AgBBxwUgBUGIAmogBUGAAmoQFSEGQciyBSgCACEAQciyBUEANgIAIABBAUYNACAGBEAgAyADKAIAQQJyNgIACyAFKAKIAiEGIAIQiQwaIAVB0AFqEIkMGiAFQZACaiQAIAYPCxAGIQYQBxoLIAIQiQwaIAVB0AFqEIkMGiAGEAgACy4AAkAgACgCBEHKAHEiAARAIABBwABGBEBBCA8LIABBCEcNAUEQDwtBAA8LQQoLyQEBA38jAEEQayIDJAAgA0EIaiABEPgGQciyBUEANgIAQcAFIANBCGoQDSEBQciyBSgCACEEQciyBUEANgIAAkAgBEEBRg0AQciyBUEANgIAQdAFIAEQDSEEQciyBSgCACEFQciyBUEANgIAIAVBAUYNACACIAQ6AABByLIFQQA2AgBB0QUgACABEAVByLIFKAIAIQFByLIFQQA2AgAgAUEBRg0AIANBCGoQ9wcgA0EQaiQADwsQBiEBEAcaIANBCGoQ9wcgARAIAAtOAQJ/IwBBEGsiASQAQciyBUEANgIAQciyBSgCACECQciyBUEANgIAIAJBAUcEQCAAEKwIIAFBEGokACAADwtBABALIQAQBxogABCEAQALGwEBf0EKIQEgABCtCAR/IAAQrghBf2oFIAELCwsAIAAgAUEAEI0MC/MCAQN/IwBBEGsiCiQAIAogADoADwJAAkACQAJAIAMoAgAgAkcNACAAQf8BcSILIAktABhGIgxFBEAgCS0AGSALRw0BCyADIAJBAWo2AgAgAkErQS0gDBs6AAAMAQsgBhCBCEUNASAAIAVHDQFBACEAIAgoAgAiCSAHa0GfAUoNAiAEKAIAIQAgCCAJQQRqNgIAIAkgADYCAAtBACEAIARBADYCAAwBC0F/IQAgCSAJQRpqIApBD2oQsAggCWsiCUEXSg0AAkAgAUF4aiIGQQJLBEAgAUEQRw0BIAlBFkgNASADKAIAIgYgAkYNAiAGIAJrQQJKDQIgBkF/ai0AAEEwRw0CQQAhACAEQQA2AgAgAyAGQQFqNgIAIAYgCUHAwQNqLQAAOgAADAILIAZBAWtFDQAgCSABTg0BCyADIAMoAgAiAEEBajYCACAAIAlBwMEDai0AADoAACAEIAQoAgBBAWo2AgBBACEACyAKQRBqJAAgAAvRAQICfwF+IwBBEGsiBCQAAn8CQAJAAkAgACABRwRAQaiqBSgCACEFQaiqBUEANgIAIAAgBEEMaiADEKoIEOgHIQYCQEGoqgUoAgAiAARAIAQoAgwgAUcNASAAQcQARg0FDAQLQaiqBSAFNgIAIAQoAgwgAUYNAwsgAkEENgIADAELIAJBBDYCAAtBAAwCCyAGQoCAgIB4Uw0AIAZC/////wdVDQAgBqcMAQsgAkEENgIAQf////8HIAZCAVkNABpBgICAgHgLIQAgBEEQaiQAIAALsgEBAn8CQCAAEIEIRQ0AIAIgAWtBBUgNACABIAIQ9AggAkF8aiEEIAAQrwgiAiAAEIEIaiEFA0ACQCACLAAAIQAgASAETw0AAkAgAEEBSA0AIABB/wBODQAgASgCACACLAAARg0AIANBBDYCAA8LIAJBAWogAiAFIAJrQQFKGyECIAFBBGohAQwBCwsgAEEBSA0AIABB/wBODQAgBCgCAEF/aiACLAAASQ0AIANBBDYCAAsLDwAgASACIAMgBCAFEJAIC/AGAgN/AX4jAEGQAmsiBSQAIAUgATYCgAIgBSAANgKIAiACEIcIIQcgBUHQAWogAiAFQf8BahCICCAFQcABahCJCCICEIoIIQZByLIFQQA2AgBBzAUgAiAGEAVByLIFKAIAIQZByLIFQQA2AgACQAJAAkAgBkEBRwRAIAUgAkEAEIIIIgY2ArwBIAUgBUEQajYCDCAFQQA2AggDQAJAQciyBUEANgIAQcYFIAVBiAJqIAVBgAJqEBUhAEHIsgUoAgAhAUHIsgVBADYCACABQQFGDQAgAEUNBCAFKAK8ASACEIEIIAZqRgRAIAIQgQghACACEIEIIQZByLIFQQA2AgBBzAUgAiAGQQF0EAVByLIFKAIAIQZByLIFQQA2AgAgBkEBRg0EIAIQigghBkHIsgVBADYCAEHMBSACIAYQBUHIsgUoAgAhBkHIsgVBADYCACAGQQFGDQQgBSACQQAQgggiBiAAajYCvAELQciyBUEANgIAQcgFIAVBiAJqEA0hAEHIsgUoAgAhAUHIsgVBADYCACABQQFGDQBByLIFQQA2AgAgACAHIAYgBUG8AWogBUEIaiAFLAD/ASAFQdABaiAFQRBqIAVBDGpBwMEDEIwIIQBByLIFKAIAIQFByLIFQQA2AgAgAUEBRg0AIAANBEHIsgVBADYCAEHKBSAFQYgCahANGkHIsgUoAgAhAEHIsgVBADYCACAAQQFHDQELCxAGIQYQBxoMAwsQBiEGEAcaDAILEAYhBhAHGgwBCwJAIAVB0AFqEIEIRQ0AIAUoAgwiACAFQRBqa0GfAUoNACAFIABBBGo2AgwgACAFKAIINgIAC0HIsgVBADYCAEHTBSAGIAUoArwBIAMgBxC3DSEIQciyBSgCACEGQciyBUEANgIAAkAgBkEBRg0AIAQgCDcDAEHIsgVBADYCACAFQdABaiAFQRBqIAUoAgwgAxCOCEHIsgUoAgAhBkHIsgVBADYCACAGQQFGDQBByLIFQQA2AgBBxwUgBUGIAmogBUGAAmoQFSEGQciyBSgCACEAQciyBUEANgIAIABBAUYNACAGBEAgAyADKAIAQQJyNgIACyAFKAKIAiEGIAIQiQwaIAVB0AFqEIkMGiAFQZACaiQAIAYPCxAGIQYQBxoLIAIQiQwaIAVB0AFqEIkMGiAGEAgAC+YBAgJ/AX4jAEEQayIEJAACQAJAAkACQCAAIAFHBEBBqKoFKAIAIQVBqKoFQQA2AgAgACAEQQxqIAMQqggQ6AchBgJAQaiqBSgCACIABEAgBCgCDCABRw0BIABBxABGDQUMBAtBqKoFIAU2AgAgBCgCDCABRg0DCyACQQQ2AgAMAQsgAkEENgIAC0IAIQYMAgsgBkKAgICAgICAgIB/Uw0AQv///////////wAgBlkNAQsgAkEENgIAIAZCAVkEQEL///////////8AIQYMAQtCgICAgICAgICAfyEGCyAEQRBqJAAgBgsPACABIAIgAyAEIAUQkwgL7QYBA38jAEGQAmsiBSQAIAUgATYCgAIgBSAANgKIAiACEIcIIQcgBUHQAWogAiAFQf8BahCICCAFQcABahCJCCICEIoIIQZByLIFQQA2AgBBzAUgAiAGEAVByLIFKAIAIQZByLIFQQA2AgACQAJAAkAgBkEBRwRAIAUgAkEAEIIIIgY2ArwBIAUgBUEQajYCDCAFQQA2AggDQAJAQciyBUEANgIAQcYFIAVBiAJqIAVBgAJqEBUhAEHIsgUoAgAhAUHIsgVBADYCACABQQFGDQAgAEUNBCAFKAK8ASACEIEIIAZqRgRAIAIQgQghACACEIEIIQZByLIFQQA2AgBBzAUgAiAGQQF0EAVByLIFKAIAIQZByLIFQQA2AgAgBkEBRg0EIAIQigghBkHIsgVBADYCAEHMBSACIAYQBUHIsgUoAgAhBkHIsgVBADYCACAGQQFGDQQgBSACQQAQgggiBiAAajYCvAELQciyBUEANgIAQcgFIAVBiAJqEA0hAEHIsgUoAgAhAUHIsgVBADYCACABQQFGDQBByLIFQQA2AgAgACAHIAYgBUG8AWogBUEIaiAFLAD/ASAFQdABaiAFQRBqIAVBDGpBwMEDEIwIIQBByLIFKAIAIQFByLIFQQA2AgAgAUEBRg0AIAANBEHIsgVBADYCAEHKBSAFQYgCahANGkHIsgUoAgAhAEHIsgVBADYCACAAQQFHDQELCxAGIQYQBxoMAwsQBiEGEAcaDAILEAYhBhAHGgwBCwJAIAVB0AFqEIEIRQ0AIAUoAgwiACAFQRBqa0GfAUoNACAFIABBBGo2AgwgACAFKAIINgIAC0HIsgVBADYCAEHUBSAGIAUoArwBIAMgBxAaIQZByLIFKAIAIQBByLIFQQA2AgACQCAAQQFGDQAgBCAGOwEAQciyBUEANgIAIAVB0AFqIAVBEGogBSgCDCADEI4IQciyBSgCACEGQciyBUEANgIAIAZBAUYNAEHIsgVBADYCAEHHBSAFQYgCaiAFQYACahAVIQZByLIFKAIAIQBByLIFQQA2AgAgAEEBRg0AIAYEQCADIAMoAgBBAnI2AgALIAUoAogCIQYgAhCJDBogBUHQAWoQiQwaIAVBkAJqJAAgBg8LEAYhBhAHGgsgAhCJDBogBUHQAWoQiQwaIAYQCAAL7QECA38BfiMAQRBrIgQkAAJ/AkACQAJAAkAgACABRwRAAkAgAC0AACIFQS1HDQAgAEEBaiIAIAFHDQAgAkEENgIADAILQaiqBSgCACEGQaiqBUEANgIAIAAgBEEMaiADEKoIEOcHIQcCQEGoqgUoAgAiAARAIAQoAgwgAUcNASAAQcQARg0FDAQLQaiqBSAGNgIAIAQoAgwgAUYNAwsgAkEENgIADAELIAJBBDYCAAtBAAwDCyAHQv//A1gNAQsgAkEENgIAQf//AwwBC0EAIAenIgBrIAAgBUEtRhsLIQAgBEEQaiQAIABB//8DcQsPACABIAIgAyAEIAUQlggL7QYBA38jAEGQAmsiBSQAIAUgATYCgAIgBSAANgKIAiACEIcIIQcgBUHQAWogAiAFQf8BahCICCAFQcABahCJCCICEIoIIQZByLIFQQA2AgBBzAUgAiAGEAVByLIFKAIAIQZByLIFQQA2AgACQAJAAkAgBkEBRwRAIAUgAkEAEIIIIgY2ArwBIAUgBUEQajYCDCAFQQA2AggDQAJAQciyBUEANgIAQcYFIAVBiAJqIAVBgAJqEBUhAEHIsgUoAgAhAUHIsgVBADYCACABQQFGDQAgAEUNBCAFKAK8ASACEIEIIAZqRgRAIAIQgQghACACEIEIIQZByLIFQQA2AgBBzAUgAiAGQQF0EAVByLIFKAIAIQZByLIFQQA2AgAgBkEBRg0EIAIQigghBkHIsgVBADYCAEHMBSACIAYQBUHIsgUoAgAhBkHIsgVBADYCACAGQQFGDQQgBSACQQAQgggiBiAAajYCvAELQciyBUEANgIAQcgFIAVBiAJqEA0hAEHIsgUoAgAhAUHIsgVBADYCACABQQFGDQBByLIFQQA2AgAgACAHIAYgBUG8AWogBUEIaiAFLAD/ASAFQdABaiAFQRBqIAVBDGpBwMEDEIwIIQBByLIFKAIAIQFByLIFQQA2AgAgAUEBRg0AIAANBEHIsgVBADYCAEHKBSAFQYgCahANGkHIsgUoAgAhAEHIsgVBADYCACAAQQFHDQELCxAGIQYQBxoMAwsQBiEGEAcaDAILEAYhBhAHGgwBCwJAIAVB0AFqEIEIRQ0AIAUoAgwiACAFQRBqa0GfAUoNACAFIABBBGo2AgwgACAFKAIINgIAC0HIsgVBADYCAEHVBSAGIAUoArwBIAMgBxAaIQZByLIFKAIAIQBByLIFQQA2AgACQCAAQQFGDQAgBCAGNgIAQciyBUEANgIAIAVB0AFqIAVBEGogBSgCDCADEI4IQciyBSgCACEGQciyBUEANgIAIAZBAUYNAEHIsgVBADYCAEHHBSAFQYgCaiAFQYACahAVIQZByLIFKAIAIQBByLIFQQA2AgAgAEEBRg0AIAYEQCADIAMoAgBBAnI2AgALIAUoAogCIQYgAhCJDBogBUHQAWoQiQwaIAVBkAJqJAAgBg8LEAYhBhAHGgsgAhCJDBogBUHQAWoQiQwaIAYQCAAL6AECA38BfiMAQRBrIgQkAAJ/AkACQAJAAkAgACABRwRAAkAgAC0AACIFQS1HDQAgAEEBaiIAIAFHDQAgAkEENgIADAILQaiqBSgCACEGQaiqBUEANgIAIAAgBEEMaiADEKoIEOcHIQcCQEGoqgUoAgAiAARAIAQoAgwgAUcNASAAQcQARg0FDAQLQaiqBSAGNgIAIAQoAgwgAUYNAwsgAkEENgIADAELIAJBBDYCAAtBAAwDCyAHQv////8PWA0BCyACQQQ2AgBBfwwBC0EAIAenIgBrIAAgBUEtRhsLIQAgBEEQaiQAIAALDwAgASACIAMgBCAFEJkIC+0GAQN/IwBBkAJrIgUkACAFIAE2AoACIAUgADYCiAIgAhCHCCEHIAVB0AFqIAIgBUH/AWoQiAggBUHAAWoQiQgiAhCKCCEGQciyBUEANgIAQcwFIAIgBhAFQciyBSgCACEGQciyBUEANgIAAkACQAJAIAZBAUcEQCAFIAJBABCCCCIGNgK8ASAFIAVBEGo2AgwgBUEANgIIA0ACQEHIsgVBADYCAEHGBSAFQYgCaiAFQYACahAVIQBByLIFKAIAIQFByLIFQQA2AgAgAUEBRg0AIABFDQQgBSgCvAEgAhCBCCAGakYEQCACEIEIIQAgAhCBCCEGQciyBUEANgIAQcwFIAIgBkEBdBAFQciyBSgCACEGQciyBUEANgIAIAZBAUYNBCACEIoIIQZByLIFQQA2AgBBzAUgAiAGEAVByLIFKAIAIQZByLIFQQA2AgAgBkEBRg0EIAUgAkEAEIIIIgYgAGo2ArwBC0HIsgVBADYCAEHIBSAFQYgCahANIQBByLIFKAIAIQFByLIFQQA2AgAgAUEBRg0AQciyBUEANgIAIAAgByAGIAVBvAFqIAVBCGogBSwA/wEgBUHQAWogBUEQaiAFQQxqQcDBAxCMCCEAQciyBSgCACEBQciyBUEANgIAIAFBAUYNACAADQRByLIFQQA2AgBBygUgBUGIAmoQDRpByLIFKAIAIQBByLIFQQA2AgAgAEEBRw0BCwsQBiEGEAcaDAMLEAYhBhAHGgwCCxAGIQYQBxoMAQsCQCAFQdABahCBCEUNACAFKAIMIgAgBUEQamtBnwFKDQAgBSAAQQRqNgIMIAAgBSgCCDYCAAtByLIFQQA2AgBB1gUgBiAFKAK8ASADIAcQGiEGQciyBSgCACEAQciyBUEANgIAAkAgAEEBRg0AIAQgBjYCAEHIsgVBADYCACAFQdABaiAFQRBqIAUoAgwgAxCOCEHIsgUoAgAhBkHIsgVBADYCACAGQQFGDQBByLIFQQA2AgBBxwUgBUGIAmogBUGAAmoQFSEGQciyBSgCACEAQciyBUEANgIAIABBAUYNACAGBEAgAyADKAIAQQJyNgIACyAFKAKIAiEGIAIQiQwaIAVB0AFqEIkMGiAFQZACaiQAIAYPCxAGIQYQBxoLIAIQiQwaIAVB0AFqEIkMGiAGEAgACw8AIAEgAiADIAQgBRCbCAvwBgIDfwF+IwBBkAJrIgUkACAFIAE2AoACIAUgADYCiAIgAhCHCCEHIAVB0AFqIAIgBUH/AWoQiAggBUHAAWoQiQgiAhCKCCEGQciyBUEANgIAQcwFIAIgBhAFQciyBSgCACEGQciyBUEANgIAAkACQAJAIAZBAUcEQCAFIAJBABCCCCIGNgK8ASAFIAVBEGo2AgwgBUEANgIIA0ACQEHIsgVBADYCAEHGBSAFQYgCaiAFQYACahAVIQBByLIFKAIAIQFByLIFQQA2AgAgAUEBRg0AIABFDQQgBSgCvAEgAhCBCCAGakYEQCACEIEIIQAgAhCBCCEGQciyBUEANgIAQcwFIAIgBkEBdBAFQciyBSgCACEGQciyBUEANgIAIAZBAUYNBCACEIoIIQZByLIFQQA2AgBBzAUgAiAGEAVByLIFKAIAIQZByLIFQQA2AgAgBkEBRg0EIAUgAkEAEIIIIgYgAGo2ArwBC0HIsgVBADYCAEHIBSAFQYgCahANIQBByLIFKAIAIQFByLIFQQA2AgAgAUEBRg0AQciyBUEANgIAIAAgByAGIAVBvAFqIAVBCGogBSwA/wEgBUHQAWogBUEQaiAFQQxqQcDBAxCMCCEAQciyBSgCACEBQciyBUEANgIAIAFBAUYNACAADQRByLIFQQA2AgBBygUgBUGIAmoQDRpByLIFKAIAIQBByLIFQQA2AgAgAEEBRw0BCwsQBiEGEAcaDAMLEAYhBhAHGgwCCxAGIQYQBxoMAQsCQCAFQdABahCBCEUNACAFKAIMIgAgBUEQamtBnwFKDQAgBSAAQQRqNgIMIAAgBSgCCDYCAAtByLIFQQA2AgBB1wUgBiAFKAK8ASADIAcQtw0hCEHIsgUoAgAhBkHIsgVBADYCAAJAIAZBAUYNACAEIAg3AwBByLIFQQA2AgAgBUHQAWogBUEQaiAFKAIMIAMQjghByLIFKAIAIQZByLIFQQA2AgAgBkEBRg0AQciyBUEANgIAQccFIAVBiAJqIAVBgAJqEBUhBkHIsgUoAgAhAEHIsgVBADYCACAAQQFGDQAgBgRAIAMgAygCAEECcjYCAAsgBSgCiAIhBiACEIkMGiAFQdABahCJDBogBUGQAmokACAGDwsQBiEGEAcaCyACEIkMGiAFQdABahCJDBogBhAIAAvhAQIDfwF+IwBBEGsiBCQAAn4CQAJAAkACQCAAIAFHBEACQCAALQAAIgVBLUcNACAAQQFqIgAgAUcNACACQQQ2AgAMAgtBqKoFKAIAIQZBqKoFQQA2AgAgACAEQQxqIAMQqggQ5wchBwJAQaiqBSgCACIABEAgBCgCDCABRw0BIABBxABGDQUMBAtBqKoFIAY2AgAgBCgCDCABRg0DCyACQQQ2AgAMAQsgAkEENgIAC0IADAMLQn8gB1oNAQsgAkEENgIAQn8MAQtCACAHfSAHIAVBLUYbCyEHIARBEGokACAHCw8AIAEgAiADIAQgBRCeCAuZBwICfwF9IwBBkAJrIgUkACAFIAE2AoACIAUgADYCiAIgBUHQAWogAiAFQeABaiAFQd8BaiAFQd4BahCfCCAFQcABahCJCCICEIoIIQBByLIFQQA2AgBBzAUgAiAAEAVByLIFKAIAIQBByLIFQQA2AgACQAJAAkAgAEEBRwRAIAUgAkEAEIIIIgA2ArwBIAUgBUEQajYCDCAFQQA2AgggBUEBOgAHIAVBxQA6AAYDQAJAQciyBUEANgIAQcYFIAVBiAJqIAVBgAJqEBUhAUHIsgUoAgAhBkHIsgVBADYCACAGQQFGDQAgAUUNBCAFKAK8ASACEIEIIABqRgRAIAIQgQghASACEIEIIQBByLIFQQA2AgBBzAUgAiAAQQF0EAVByLIFKAIAIQBByLIFQQA2AgAgAEEBRg0EIAIQigghAEHIsgVBADYCAEHMBSACIAAQBUHIsgUoAgAhAEHIsgVBADYCACAAQQFGDQQgBSACQQAQgggiACABajYCvAELQciyBUEANgIAQcgFIAVBiAJqEA0hAUHIsgUoAgAhBkHIsgVBADYCACAGQQFGDQBByLIFQQA2AgAgASAFQQdqIAVBBmogACAFQbwBaiAFLADfASAFLADeASAFQdABaiAFQRBqIAVBDGogBUEIaiAFQeABahCgCCEBQciyBSgCACEGQciyBUEANgIAIAZBAUYNACABDQRByLIFQQA2AgBBygUgBUGIAmoQDRpByLIFKAIAIQFByLIFQQA2AgAgAUEBRw0BCwsQBiEAEAcaDAMLEAYhABAHGgwCCxAGIQAQBxoMAQsCQCAFQdABahCBCEUNACAFLQAHRQ0AIAUoAgwiASAFQRBqa0GfAUoNACAFIAFBBGo2AgwgASAFKAIINgIAC0HIsgVBADYCAEHZBSAAIAUoArwBIAMQLyEHQciyBSgCACEAQciyBUEANgIAAkAgAEEBRg0AIAQgBzgCAEHIsgVBADYCACAFQdABaiAFQRBqIAUoAgwgAxCOCEHIsgUoAgAhAEHIsgVBADYCACAAQQFGDQBByLIFQQA2AgBBxwUgBUGIAmogBUGAAmoQFSEAQciyBSgCACEBQciyBUEANgIAIAFBAUYNACAABEAgAyADKAIAQQJyNgIACyAFKAKIAiEAIAIQiQwaIAVB0AFqEIkMGiAFQZACaiQAIAAPCxAGIQAQBxoLIAIQiQwaIAVB0AFqEIkMGiAAEAgAC+wCAQJ/IwBBEGsiBSQAIAVBCGogARD4BkHIsgVBADYCAEGXBSAFQQhqEA0hAUHIsgUoAgAhBkHIsgVBADYCAAJAAkACQCAGQQFGDQBByLIFQQA2AgBB2gUgAUHAwQNB4MEDIAIQGhpByLIFKAIAIQJByLIFQQA2AgAgAkEBRg0AQciyBUEANgIAQcAFIAVBCGoQDSECQciyBSgCACEBQciyBUEANgIAIAFBAUYNAUHIsgVBADYCAEHbBSACEA0hAUHIsgUoAgAhBkHIsgVBADYCACAGQQFGDQEgAyABOgAAQciyBUEANgIAQdAFIAIQDSEDQciyBSgCACEBQciyBUEANgIAIAFBAUYNASAEIAM6AABByLIFQQA2AgBB0QUgACACEAVByLIFKAIAIQJByLIFQQA2AgAgAkEBRg0BIAVBCGoQ9wcgBUEQaiQADwsQBiECEAcaDAELEAYhAhAHGgsgBUEIahD3ByACEAgAC/oDAQF/IwBBEGsiDCQAIAwgADoADwJAAkAgACAFRgRAIAEtAABFDQFBACEAIAFBADoAACAEIAQoAgAiC0EBajYCACALQS46AAAgBxCBCEUNAiAJKAIAIgsgCGtBnwFKDQIgCigCACEFIAkgC0EEajYCACALIAU2AgAMAgsCQCAAIAZHDQAgBxCBCEUNACABLQAARQ0BQQAhACAJKAIAIgsgCGtBnwFKDQIgCigCACEAIAkgC0EEajYCACALIAA2AgBBACEAIApBADYCAAwCC0F/IQAgCyALQSBqIAxBD2oQsAggC2siC0EfSg0BIAtBwMEDai0AACEFAkAgC0FqaiIAQQNNBEACQAJAIABBAmsOAgAAAQsgAyAEKAIAIgtHBEBBfyEAIAtBf2otAABB3wBxIAItAABB/wBxRw0FCyAEIAtBAWo2AgAgCyAFOgAAQQAhAAwECyACQdAAOgAADAELIAIsAAAiACAFQd8AcUcNACACIABBgAFyOgAAIAEtAABFDQAgAUEAOgAAIAcQgQhFDQAgCSgCACIAIAhrQZ8BSg0AIAooAgAhASAJIABBBGo2AgAgACABNgIACyAEIAQoAgAiAEEBajYCACAAIAU6AABBACEAIAtBFUoNASAKIAooAgBBAWo2AgAMAQtBfyEACyAMQRBqJAAgAAucAQICfwF9IwBBEGsiAyQAAkACQCAAIAFHBEBBqKoFKAIAIQRBqKoFQQA2AgAQqggaIAAgA0EMahDpByEFAkBBqKoFKAIAIgAEQCADKAIMIAFHDQEgAEHEAEcNBCACQQQ2AgAMBAtBqKoFIAQ2AgAgAygCDCABRg0DCyACQQQ2AgAMAQsgAkEENgIAC0MAAAAAIQULIANBEGokACAFCw8AIAEgAiADIAQgBRCjCAuZBwICfwF8IwBBkAJrIgUkACAFIAE2AoACIAUgADYCiAIgBUHQAWogAiAFQeABaiAFQd8BaiAFQd4BahCfCCAFQcABahCJCCICEIoIIQBByLIFQQA2AgBBzAUgAiAAEAVByLIFKAIAIQBByLIFQQA2AgACQAJAAkAgAEEBRwRAIAUgAkEAEIIIIgA2ArwBIAUgBUEQajYCDCAFQQA2AgggBUEBOgAHIAVBxQA6AAYDQAJAQciyBUEANgIAQcYFIAVBiAJqIAVBgAJqEBUhAUHIsgUoAgAhBkHIsgVBADYCACAGQQFGDQAgAUUNBCAFKAK8ASACEIEIIABqRgRAIAIQgQghASACEIEIIQBByLIFQQA2AgBBzAUgAiAAQQF0EAVByLIFKAIAIQBByLIFQQA2AgAgAEEBRg0EIAIQigghAEHIsgVBADYCAEHMBSACIAAQBUHIsgUoAgAhAEHIsgVBADYCACAAQQFGDQQgBSACQQAQgggiACABajYCvAELQciyBUEANgIAQcgFIAVBiAJqEA0hAUHIsgUoAgAhBkHIsgVBADYCACAGQQFGDQBByLIFQQA2AgAgASAFQQdqIAVBBmogACAFQbwBaiAFLADfASAFLADeASAFQdABaiAFQRBqIAVBDGogBUEIaiAFQeABahCgCCEBQciyBSgCACEGQciyBUEANgIAIAZBAUYNACABDQRByLIFQQA2AgBBygUgBUGIAmoQDRpByLIFKAIAIQFByLIFQQA2AgAgAUEBRw0BCwsQBiEAEAcaDAMLEAYhABAHGgwCCxAGIQAQBxoMAQsCQCAFQdABahCBCEUNACAFLQAHRQ0AIAUoAgwiASAFQRBqa0GfAUoNACAFIAFBBGo2AgwgASAFKAIINgIAC0HIsgVBADYCAEHcBSAAIAUoArwBIAMQMCEHQciyBSgCACEAQciyBUEANgIAAkAgAEEBRg0AIAQgBzkDAEHIsgVBADYCACAFQdABaiAFQRBqIAUoAgwgAxCOCEHIsgUoAgAhAEHIsgVBADYCACAAQQFGDQBByLIFQQA2AgBBxwUgBUGIAmogBUGAAmoQFSEAQciyBSgCACEBQciyBUEANgIAIAFBAUYNACAABEAgAyADKAIAQQJyNgIACyAFKAKIAiEAIAIQiQwaIAVB0AFqEIkMGiAFQZACaiQAIAAPCxAGIQAQBxoLIAIQiQwaIAVB0AFqEIkMGiAAEAgAC6ABAgJ/AXwjAEEQayIDJAACQAJAIAAgAUcEQEGoqgUoAgAhBEGoqgVBADYCABCqCBogACADQQxqEOsHIQUCQEGoqgUoAgAiAARAIAMoAgwgAUcNASAAQcQARw0EIAJBBDYCAAwEC0GoqgUgBDYCACADKAIMIAFGDQMLIAJBBDYCAAwBCyACQQQ2AgALRAAAAAAAAAAAIQULIANBEGokACAFCw8AIAEgAiADIAQgBRCmCAuqBwICfwF+IwBBoAJrIgUkACAFIAE2ApACIAUgADYCmAIgBUHgAWogAiAFQfABaiAFQe8BaiAFQe4BahCfCCAFQdABahCJCCICEIoIIQBByLIFQQA2AgBBzAUgAiAAEAVByLIFKAIAIQBByLIFQQA2AgACQAJAAkAgAEEBRwRAIAUgAkEAEIIIIgA2AswBIAUgBUEgajYCHCAFQQA2AhggBUEBOgAXIAVBxQA6ABYDQAJAQciyBUEANgIAQcYFIAVBmAJqIAVBkAJqEBUhAUHIsgUoAgAhBkHIsgVBADYCACAGQQFGDQAgAUUNBCAFKALMASACEIEIIABqRgRAIAIQgQghASACEIEIIQBByLIFQQA2AgBBzAUgAiAAQQF0EAVByLIFKAIAIQBByLIFQQA2AgAgAEEBRg0EIAIQigghAEHIsgVBADYCAEHMBSACIAAQBUHIsgUoAgAhAEHIsgVBADYCACAAQQFGDQQgBSACQQAQgggiACABajYCzAELQciyBUEANgIAQcgFIAVBmAJqEA0hAUHIsgUoAgAhBkHIsgVBADYCACAGQQFGDQBByLIFQQA2AgAgASAFQRdqIAVBFmogACAFQcwBaiAFLADvASAFLADuASAFQeABaiAFQSBqIAVBHGogBUEYaiAFQfABahCgCCEBQciyBSgCACEGQciyBUEANgIAIAZBAUYNACABDQRByLIFQQA2AgBBygUgBUGYAmoQDRpByLIFKAIAIQFByLIFQQA2AgAgAUEBRw0BCwsQBiEAEAcaDAMLEAYhABAHGgwCCxAGIQAQBxoMAQsCQCAFQeABahCBCEUNACAFLQAXRQ0AIAUoAhwiASAFQSBqa0GfAUoNACAFIAFBBGo2AhwgASAFKAIYNgIAC0HIsgVBADYCAEHdBSAFIAAgBSgCzAEgAxAcQciyBSgCACEAQciyBUEANgIAAkAgAEEBRg0AIAUpAwghByAEIAUpAwA3AwAgBCAHNwMIQciyBUEANgIAIAVB4AFqIAVBIGogBSgCHCADEI4IQciyBSgCACEAQciyBUEANgIAIABBAUYNAEHIsgVBADYCAEHHBSAFQZgCaiAFQZACahAVIQBByLIFKAIAIQFByLIFQQA2AgAgAUEBRg0AIAAEQCADIAMoAgBBAnI2AgALIAUoApgCIQAgAhCJDBogBUHgAWoQiQwaIAVBoAJqJAAgAA8LEAYhABAHGgsgAhCJDBogBUHgAWoQiQwaIAAQCAALswECAn8CfiMAQSBrIgQkAAJAAkAgASACRwRAQaiqBSgCACEFQaiqBUEANgIAIAQgASAEQRxqEPgLIAQpAwghBiAEKQMAIQcCQEGoqgUoAgAiAQRAIAQoAhwgAkcNASABQcQARw0EIANBBDYCAAwEC0GoqgUgBTYCACAEKAIcIAJGDQMLIANBBDYCAAwBCyADQQQ2AgALQgAhB0IAIQYLIAAgBzcDACAAIAY3AwggBEEgaiQAC5EIAQJ/IwBBkAJrIgAkACAAIAI2AoACIAAgATYCiAIgAEHQAWoQiQghB0HIsgVBADYCACAAQRBqIAMQ+AZByLIFKAIAIQNByLIFQQA2AgACQAJAAkACQAJAAkAgA0EBRwRAQciyBUEANgIAQZcFIABBEGoQDSEDQciyBSgCACEBQciyBUEANgIAIAFBAUYNAUHIsgVBADYCAEHaBSADQcDBA0HawQMgAEHgAWoQGhpByLIFKAIAIQNByLIFQQA2AgAgA0EBRg0BIABBEGoQ9wcgAEHAAWoQiQgiAxCKCCEBQciyBUEANgIAQcwFIAMgARAFQciyBSgCACEBQciyBUEANgIAIAFBAUYNAiAAIANBABCCCCIBNgK8ASAAIABBEGo2AgwgAEEANgIIA0ACQEHIsgVBADYCAEHGBSAAQYgCaiAAQYACahAVIQJByLIFKAIAIQZByLIFQQA2AgAgBkEBRg0AIAJFDQYgACgCvAEgAxCBCCABakYEQCADEIEIIQIgAxCBCCEBQciyBUEANgIAQcwFIAMgAUEBdBAFQciyBSgCACEBQciyBUEANgIAIAFBAUYNBiADEIoIIQFByLIFQQA2AgBBzAUgAyABEAVByLIFKAIAIQFByLIFQQA2AgAgAUEBRg0GIAAgA0EAEIIIIgEgAmo2ArwBC0HIsgVBADYCAEHIBSAAQYgCahANIQJByLIFKAIAIQZByLIFQQA2AgAgBkEBRg0AQciyBUEANgIAIAJBECABIABBvAFqIABBCGpBACAHIABBEGogAEEMaiAAQeABahCMCCECQciyBSgCACEGQciyBUEANgIAIAZBAUYNACACDQZByLIFQQA2AgBBygUgAEGIAmoQDRpByLIFKAIAIQJByLIFQQA2AgAgAkEBRw0BCwsQBiEBEAcaDAULEAYhARAHGgwFCxAGIQEQBxogAEEQahD3BwwECxAGIQEQBxoMAgsQBiEBEAcaDAELQciyBUEANgIAQcwFIAMgACgCvAEgAWsQBUHIsgUoAgAhAUHIsgVBADYCAAJAIAFBAUYNACADEK8IIQFByLIFQQA2AgBB3gUQGyECQciyBSgCACEGQciyBUEANgIAIAZBAUYNACAAIAU2AgBByLIFQQA2AgBB3wUgASACQeHBAyAAEBohAUHIsgUoAgAhAkHIsgVBADYCACACQQFGDQAgAUEBRwRAIARBBDYCAAtByLIFQQA2AgBBxwUgAEGIAmogAEGAAmoQFSEBQciyBSgCACECQciyBUEANgIAIAJBAUYNACABBEAgBCAEKAIAQQJyNgIACyAAKAKIAiEBIAMQiQwaIAcQiQwaIABBkAJqJAAgAQ8LEAYhARAHGgsgAxCJDBoLIAcQiQwaIAEQCAALFQAgACABIAIgAyAAKAIAKAIgEQoAC4ABAQJ/AkACQEGMtAUtAABBAXENAEGMtAUQqwxFDQBByLIFQQA2AgBB4AVB/////wdB5cMDQQAQFCEAQciyBSgCACEBQciyBUEANgIAIAFBAUYNAUGItAUgADYCAEGMtAUQrwwLQYi0BSgCAA8LEAYhABAHGkGMtAUQsQwgABAIAAtDAQF/IwBBEGsiBCQAIAQgATYCDCAEIAM2AgggBCAEQQxqELEIIQEgACACIAQoAggQnQYhACABELIIIARBEGokACAACy0BAX8gACEBQQAhAANAIABBA0cEQCABIABBAnRqQQA2AgAgAEEBaiEADAELCwsKACAALAALQQBICw4AIAAoAghB/////wdxCxIAIAAQrQgEQCAAKAIADwsgAAsyACACLQAAIQIDQAJAIAAgAUcEfyAALQAAIAJHDQEgAAUgAQsPCyAAQQFqIQAMAAALAAsRACAAIAEoAgAQ5Qc2AgAgAAtHAAJAIAAoAgAiAARAQciyBUEANgIAIAAQ5QcaQciyBSgCACEAQciyBUEANgIAIABBAUYNAQsPC0EAEAshABAHGiAAEIQBAAusBAECfyMAQSBrIgYkACAGIAE2AhgCQAJAIAMoAgRBAXFFBEAgBkF/NgIAIAYgACABIAIgAyAEIAYgACgCACgCEBEJACIBNgIYIAYoAgAiA0EBTQRAIANBAWsNAiAFQQE6AAAMAwsgBUEBOgAAIARBBDYCAAwCCyAGIAMQ+AZByLIFQQA2AgBB4gUgBhANIQFByLIFKAIAIQBByLIFQQA2AgACQAJAAkACQCAAQQFHBEAgBhD3ByAGIAMQ+AZByLIFQQA2AgBB4wUgBhANIQNByLIFKAIAIQBByLIFQQA2AgAgAEEBRg0BIAYQ9wdBACEAQciyBUEANgIAQeQFIAYgAxAFQciyBSgCACEHQciyBUEANgIAIAdBAUYNAkHIsgVBADYCAEHlBSAGQQxyIAMQBUHIsgUoAgAhA0HIsgVBADYCAEEBIQAgA0EBRg0CQciyBUEANgIAQeYFIAZBGGogAiAGIAZBGGoiAyABIARBARAgIQFByLIFKAIAIQRByLIFQQA2AgAgBEEBRg0DIAUgASAGRjoAACAGKAIYIQEDQCADQXRqEIkMIgMgBkcNAAsMBgsQBiEBEAcaIAYQ9wcMAwsQBiEBEAcaIAYQ9wcMAgsQBiEBEAcaIABFDQEgBiAAQQxsaiEDA0AgA0F0ahCJDCIDIAZHDQALDAELEAYhARAHGgNAIANBdGoQiQwiAyAGRw0ACwsgARAIAAsgBUEAOgAACyAGQSBqJAAgAQsLACAAQeS0BRD8BwuOBwEMfyMAQYABayIIJAAgCCABNgJ4IAIgAxD9ByEJIAhBxAU2AgQgCEEIakEAIAhBBGoQ/gchDiAIQRBqIQoCQAJAIAlB5QBPBEAgCRD1DCIKRQRAQciyBUEANgIAQcUFEApByLIFKAIAIQFByLIFQQA2AgAgAUEBRw0DEAYhARAHGgwCCyAOIAoQ/wcLIAohByACIQEDQCABIANGBEACQAJAA0ACQEHIsgVBADYCAEHnBSAAIAhB+ABqEBUhAUHIsgUoAgAhB0HIsgVBADYCACAHQQFGDQAgCUEARyABcUUEQEHIsgVBADYCAEHoBSAAIAhB+ABqEBUhAUHIsgUoAgAhB0HIsgVBADYCACAHQQFGDQQgAUUNAyAFIAUoAgBBAnI2AgAMAwtByLIFQQA2AgBB6QUgABANIQ9ByLIFKAIAIQFByLIFQQA2AgACQCABQQFHBEAgBg0BQciyBUEANgIAQeoFIAQgDxAVIQ9ByLIFKAIAIQFByLIFQQA2AgAgAUEBRw0BCxAGIQEQBxoMBwsgDEEBaiENQQAhECAKIQcgAiEBA0AgASADRgRAIA0hDCAQRQ0DQciyBUEANgIAQesFIAAQDRpByLIFKAIAIQFByLIFQQA2AgAgAUEBRwRAIAohByACIQEgCSALakECSQ0EA0AgASADRgRADAYFAkAgBy0AAEECRw0AIAEQgQggDUYNACAHQQA6AAAgC0F/aiELCyAHQQFqIQcgAUEMaiEBDAELAAALAAsQBiEBEAcaDAgLAkAgBy0AAEEBRw0AIAEgDBC2CCgCACERAkAgBg0AQciyBUEANgIAQeoFIAQgERAVIRFByLIFKAIAIRJByLIFQQA2AgAgEkEBRw0AEAYhARAHGgwJCwJAIA8gEUYEQEEBIRAgARCBCCANRw0CIAdBAjoAACALQQFqIQsMAQsgB0EAOgAACyAJQX9qIQkLIAdBAWohByABQQxqIQEMAAALAAsLEAYhARAHGgwECwJAAkADQCACIANGDQEgCi0AAEECRwRAIApBAWohCiACQQxqIQIMAQsLIAIhAwwBCyAFIAUoAgBBBHI2AgALIA4QgwggCEGAAWokACADDwsQBiEBEAcaBQJAIAEQhAhFBEAgB0EBOgAADAELIAdBAjoAACALQQFqIQsgCUF/aiEJCyAHQQFqIQcgAUEMaiEBDAELCwsgDhCDCCABEAgLAAsNACAAEK8IIAFBAnRqCw8AIAEgAiADIAQgBRC4CAv4BgEEfyMAQeACayIFJAAgBSABNgLQAiAFIAA2AtgCIAIQhwghByACIAVB4AFqELkIIQggBUHQAWogAiAFQcwCahC6CCAFQcABahCJCCICEIoIIQZByLIFQQA2AgBBzAUgAiAGEAVByLIFKAIAIQZByLIFQQA2AgACQAJAAkAgBkEBRwRAIAUgAkEAEIIIIgY2ArwBIAUgBUEQajYCDCAFQQA2AggDQAJAQciyBUEANgIAQecFIAVB2AJqIAVB0AJqEBUhAEHIsgUoAgAhAUHIsgVBADYCACABQQFGDQAgAEUNBCAFKAK8ASACEIEIIAZqRgRAIAIQgQghACACEIEIIQZByLIFQQA2AgBBzAUgAiAGQQF0EAVByLIFKAIAIQZByLIFQQA2AgAgBkEBRg0EIAIQigghBkHIsgVBADYCAEHMBSACIAYQBUHIsgUoAgAhBkHIsgVBADYCACAGQQFGDQQgBSACQQAQgggiBiAAajYCvAELQciyBUEANgIAQekFIAVB2AJqEA0hAEHIsgUoAgAhAUHIsgVBADYCACABQQFGDQBByLIFQQA2AgAgACAHIAYgBUG8AWogBUEIaiAFKALMAiAFQdABaiAFQRBqIAVBDGogCBC7CCEAQciyBSgCACEBQciyBUEANgIAIAFBAUYNACAADQRByLIFQQA2AgBB6wUgBUHYAmoQDRpByLIFKAIAIQBByLIFQQA2AgAgAEEBRw0BCwsQBiEGEAcaDAMLEAYhBhAHGgwCCxAGIQYQBxoMAQsCQCAFQdABahCBCEUNACAFKAIMIgAgBUEQamtBnwFKDQAgBSAAQQRqNgIMIAAgBSgCCDYCAAtByLIFQQA2AgBBzgUgBiAFKAK8ASADIAcQGiEGQciyBSgCACEAQciyBUEANgIAAkAgAEEBRg0AIAQgBjYCAEHIsgVBADYCACAFQdABaiAFQRBqIAUoAgwgAxCOCEHIsgUoAgAhBkHIsgVBADYCACAGQQFGDQBByLIFQQA2AgBB6AUgBUHYAmogBUHQAmoQFSEGQciyBSgCACEAQciyBUEANgIAIABBAUYNACAGBEAgAyADKAIAQQJyNgIACyAFKALYAiEGIAIQiQwaIAVB0AFqEIkMGiAFQeACaiQAIAYPCxAGIQYQBxoLIAIQiQwaIAVB0AFqEIkMGiAGEAgACwkAIAAgARDUCAvJAQEDfyMAQRBrIgMkACADQQhqIAEQ+AZByLIFQQA2AgBB4wUgA0EIahANIQFByLIFKAIAIQRByLIFQQA2AgACQCAEQQFGDQBByLIFQQA2AgBB7QUgARANIQRByLIFKAIAIQVByLIFQQA2AgAgBUEBRg0AIAIgBDYCAEHIsgVBADYCAEHuBSAAIAEQBUHIsgUoAgAhAUHIsgVBADYCACABQQFGDQAgA0EIahD3ByADQRBqJAAPCxAGIQEQBxogA0EIahD3ByABEAgAC/cCAQJ/IwBBEGsiCiQAIAogADYCDAJAAkACQAJAIAMoAgAgAkcNACAJKAJgIABGIgtFBEAgCSgCZCAARw0BCyADIAJBAWo2AgAgAkErQS0gCxs6AAAMAQsgBhCBCEUNASAAIAVHDQFBACEAIAgoAgAiCSAHa0GfAUoNAiAEKAIAIQAgCCAJQQRqNgIAIAkgADYCAAtBACEAIARBADYCAAwBC0F/IQAgCSAJQegAaiAKQQxqENAIIAlrIglB3ABKDQAgCUECdSEGAkAgAUF4aiIFQQJLBEAgAUEQRw0BIAlB2ABIDQEgAygCACIJIAJGDQIgCSACa0ECSg0CIAlBf2otAABBMEcNAkEAIQAgBEEANgIAIAMgCUEBajYCACAJIAZBwMEDai0AADoAAAwCCyAFQQFrRQ0AIAYgAU4NAQsgAyADKAIAIgBBAWo2AgAgACAGQcDBA2otAAA6AAAgBCAEKAIAQQFqNgIAQQAhAAsgCkEQaiQAIAALDwAgASACIAMgBCAFEL0IC/sGAgR/AX4jAEHgAmsiBSQAIAUgATYC0AIgBSAANgLYAiACEIcIIQcgAiAFQeABahC5CCEIIAVB0AFqIAIgBUHMAmoQugggBUHAAWoQiQgiAhCKCCEGQciyBUEANgIAQcwFIAIgBhAFQciyBSgCACEGQciyBUEANgIAAkACQAJAIAZBAUcEQCAFIAJBABCCCCIGNgK8ASAFIAVBEGo2AgwgBUEANgIIA0ACQEHIsgVBADYCAEHnBSAFQdgCaiAFQdACahAVIQBByLIFKAIAIQFByLIFQQA2AgAgAUEBRg0AIABFDQQgBSgCvAEgAhCBCCAGakYEQCACEIEIIQAgAhCBCCEGQciyBUEANgIAQcwFIAIgBkEBdBAFQciyBSgCACEGQciyBUEANgIAIAZBAUYNBCACEIoIIQZByLIFQQA2AgBBzAUgAiAGEAVByLIFKAIAIQZByLIFQQA2AgAgBkEBRg0EIAUgAkEAEIIIIgYgAGo2ArwBC0HIsgVBADYCAEHpBSAFQdgCahANIQBByLIFKAIAIQFByLIFQQA2AgAgAUEBRg0AQciyBUEANgIAIAAgByAGIAVBvAFqIAVBCGogBSgCzAIgBUHQAWogBUEQaiAFQQxqIAgQuwghAEHIsgUoAgAhAUHIsgVBADYCACABQQFGDQAgAA0EQciyBUEANgIAQesFIAVB2AJqEA0aQciyBSgCACEAQciyBUEANgIAIABBAUcNAQsLEAYhBhAHGgwDCxAGIQYQBxoMAgsQBiEGEAcaDAELAkAgBUHQAWoQgQhFDQAgBSgCDCIAIAVBEGprQZ8BSg0AIAUgAEEEajYCDCAAIAUoAgg2AgALQciyBUEANgIAQdMFIAYgBSgCvAEgAyAHELcNIQlByLIFKAIAIQZByLIFQQA2AgACQCAGQQFGDQAgBCAJNwMAQciyBUEANgIAIAVB0AFqIAVBEGogBSgCDCADEI4IQciyBSgCACEGQciyBUEANgIAIAZBAUYNAEHIsgVBADYCAEHoBSAFQdgCaiAFQdACahAVIQZByLIFKAIAIQBByLIFQQA2AgAgAEEBRg0AIAYEQCADIAMoAgBBAnI2AgALIAUoAtgCIQYgAhCJDBogBUHQAWoQiQwaIAVB4AJqJAAgBg8LEAYhBhAHGgsgAhCJDBogBUHQAWoQiQwaIAYQCAALDwAgASACIAMgBCAFEL8IC/gGAQR/IwBB4AJrIgUkACAFIAE2AtACIAUgADYC2AIgAhCHCCEHIAIgBUHgAWoQuQghCCAFQdABaiACIAVBzAJqELoIIAVBwAFqEIkIIgIQigghBkHIsgVBADYCAEHMBSACIAYQBUHIsgUoAgAhBkHIsgVBADYCAAJAAkACQCAGQQFHBEAgBSACQQAQgggiBjYCvAEgBSAFQRBqNgIMIAVBADYCCANAAkBByLIFQQA2AgBB5wUgBUHYAmogBUHQAmoQFSEAQciyBSgCACEBQciyBUEANgIAIAFBAUYNACAARQ0EIAUoArwBIAIQgQggBmpGBEAgAhCBCCEAIAIQgQghBkHIsgVBADYCAEHMBSACIAZBAXQQBUHIsgUoAgAhBkHIsgVBADYCACAGQQFGDQQgAhCKCCEGQciyBUEANgIAQcwFIAIgBhAFQciyBSgCACEGQciyBUEANgIAIAZBAUYNBCAFIAJBABCCCCIGIABqNgK8AQtByLIFQQA2AgBB6QUgBUHYAmoQDSEAQciyBSgCACEBQciyBUEANgIAIAFBAUYNAEHIsgVBADYCACAAIAcgBiAFQbwBaiAFQQhqIAUoAswCIAVB0AFqIAVBEGogBUEMaiAIELsIIQBByLIFKAIAIQFByLIFQQA2AgAgAUEBRg0AIAANBEHIsgVBADYCAEHrBSAFQdgCahANGkHIsgUoAgAhAEHIsgVBADYCACAAQQFHDQELCxAGIQYQBxoMAwsQBiEGEAcaDAILEAYhBhAHGgwBCwJAIAVB0AFqEIEIRQ0AIAUoAgwiACAFQRBqa0GfAUoNACAFIABBBGo2AgwgACAFKAIINgIAC0HIsgVBADYCAEHUBSAGIAUoArwBIAMgBxAaIQZByLIFKAIAIQBByLIFQQA2AgACQCAAQQFGDQAgBCAGOwEAQciyBUEANgIAIAVB0AFqIAVBEGogBSgCDCADEI4IQciyBSgCACEGQciyBUEANgIAIAZBAUYNAEHIsgVBADYCAEHoBSAFQdgCaiAFQdACahAVIQZByLIFKAIAIQBByLIFQQA2AgAgAEEBRg0AIAYEQCADIAMoAgBBAnI2AgALIAUoAtgCIQYgAhCJDBogBUHQAWoQiQwaIAVB4AJqJAAgBg8LEAYhBhAHGgsgAhCJDBogBUHQAWoQiQwaIAYQCAALDwAgASACIAMgBCAFEMEIC/gGAQR/IwBB4AJrIgUkACAFIAE2AtACIAUgADYC2AIgAhCHCCEHIAIgBUHgAWoQuQghCCAFQdABaiACIAVBzAJqELoIIAVBwAFqEIkIIgIQigghBkHIsgVBADYCAEHMBSACIAYQBUHIsgUoAgAhBkHIsgVBADYCAAJAAkACQCAGQQFHBEAgBSACQQAQgggiBjYCvAEgBSAFQRBqNgIMIAVBADYCCANAAkBByLIFQQA2AgBB5wUgBUHYAmogBUHQAmoQFSEAQciyBSgCACEBQciyBUEANgIAIAFBAUYNACAARQ0EIAUoArwBIAIQgQggBmpGBEAgAhCBCCEAIAIQgQghBkHIsgVBADYCAEHMBSACIAZBAXQQBUHIsgUoAgAhBkHIsgVBADYCACAGQQFGDQQgAhCKCCEGQciyBUEANgIAQcwFIAIgBhAFQciyBSgCACEGQciyBUEANgIAIAZBAUYNBCAFIAJBABCCCCIGIABqNgK8AQtByLIFQQA2AgBB6QUgBUHYAmoQDSEAQciyBSgCACEBQciyBUEANgIAIAFBAUYNAEHIsgVBADYCACAAIAcgBiAFQbwBaiAFQQhqIAUoAswCIAVB0AFqIAVBEGogBUEMaiAIELsIIQBByLIFKAIAIQFByLIFQQA2AgAgAUEBRg0AIAANBEHIsgVBADYCAEHrBSAFQdgCahANGkHIsgUoAgAhAEHIsgVBADYCACAAQQFHDQELCxAGIQYQBxoMAwsQBiEGEAcaDAILEAYhBhAHGgwBCwJAIAVB0AFqEIEIRQ0AIAUoAgwiACAFQRBqa0GfAUoNACAFIABBBGo2AgwgACAFKAIINgIAC0HIsgVBADYCAEHVBSAGIAUoArwBIAMgBxAaIQZByLIFKAIAIQBByLIFQQA2AgACQCAAQQFGDQAgBCAGNgIAQciyBUEANgIAIAVB0AFqIAVBEGogBSgCDCADEI4IQciyBSgCACEGQciyBUEANgIAIAZBAUYNAEHIsgVBADYCAEHoBSAFQdgCaiAFQdACahAVIQZByLIFKAIAIQBByLIFQQA2AgAgAEEBRg0AIAYEQCADIAMoAgBBAnI2AgALIAUoAtgCIQYgAhCJDBogBUHQAWoQiQwaIAVB4AJqJAAgBg8LEAYhBhAHGgsgAhCJDBogBUHQAWoQiQwaIAYQCAALDwAgASACIAMgBCAFEMMIC/gGAQR/IwBB4AJrIgUkACAFIAE2AtACIAUgADYC2AIgAhCHCCEHIAIgBUHgAWoQuQghCCAFQdABaiACIAVBzAJqELoIIAVBwAFqEIkIIgIQigghBkHIsgVBADYCAEHMBSACIAYQBUHIsgUoAgAhBkHIsgVBADYCAAJAAkACQCAGQQFHBEAgBSACQQAQgggiBjYCvAEgBSAFQRBqNgIMIAVBADYCCANAAkBByLIFQQA2AgBB5wUgBUHYAmogBUHQAmoQFSEAQciyBSgCACEBQciyBUEANgIAIAFBAUYNACAARQ0EIAUoArwBIAIQgQggBmpGBEAgAhCBCCEAIAIQgQghBkHIsgVBADYCAEHMBSACIAZBAXQQBUHIsgUoAgAhBkHIsgVBADYCACAGQQFGDQQgAhCKCCEGQciyBUEANgIAQcwFIAIgBhAFQciyBSgCACEGQciyBUEANgIAIAZBAUYNBCAFIAJBABCCCCIGIABqNgK8AQtByLIFQQA2AgBB6QUgBUHYAmoQDSEAQciyBSgCACEBQciyBUEANgIAIAFBAUYNAEHIsgVBADYCACAAIAcgBiAFQbwBaiAFQQhqIAUoAswCIAVB0AFqIAVBEGogBUEMaiAIELsIIQBByLIFKAIAIQFByLIFQQA2AgAgAUEBRg0AIAANBEHIsgVBADYCAEHrBSAFQdgCahANGkHIsgUoAgAhAEHIsgVBADYCACAAQQFHDQELCxAGIQYQBxoMAwsQBiEGEAcaDAILEAYhBhAHGgwBCwJAIAVB0AFqEIEIRQ0AIAUoAgwiACAFQRBqa0GfAUoNACAFIABBBGo2AgwgACAFKAIINgIAC0HIsgVBADYCAEHWBSAGIAUoArwBIAMgBxAaIQZByLIFKAIAIQBByLIFQQA2AgACQCAAQQFGDQAgBCAGNgIAQciyBUEANgIAIAVB0AFqIAVBEGogBSgCDCADEI4IQciyBSgCACEGQciyBUEANgIAIAZBAUYNAEHIsgVBADYCAEHoBSAFQdgCaiAFQdACahAVIQZByLIFKAIAIQBByLIFQQA2AgAgAEEBRg0AIAYEQCADIAMoAgBBAnI2AgALIAUoAtgCIQYgAhCJDBogBUHQAWoQiQwaIAVB4AJqJAAgBg8LEAYhBhAHGgsgAhCJDBogBUHQAWoQiQwaIAYQCAALDwAgASACIAMgBCAFEMUIC/sGAgR/AX4jAEHgAmsiBSQAIAUgATYC0AIgBSAANgLYAiACEIcIIQcgAiAFQeABahC5CCEIIAVB0AFqIAIgBUHMAmoQugggBUHAAWoQiQgiAhCKCCEGQciyBUEANgIAQcwFIAIgBhAFQciyBSgCACEGQciyBUEANgIAAkACQAJAIAZBAUcEQCAFIAJBABCCCCIGNgK8ASAFIAVBEGo2AgwgBUEANgIIA0ACQEHIsgVBADYCAEHnBSAFQdgCaiAFQdACahAVIQBByLIFKAIAIQFByLIFQQA2AgAgAUEBRg0AIABFDQQgBSgCvAEgAhCBCCAGakYEQCACEIEIIQAgAhCBCCEGQciyBUEANgIAQcwFIAIgBkEBdBAFQciyBSgCACEGQciyBUEANgIAIAZBAUYNBCACEIoIIQZByLIFQQA2AgBBzAUgAiAGEAVByLIFKAIAIQZByLIFQQA2AgAgBkEBRg0EIAUgAkEAEIIIIgYgAGo2ArwBC0HIsgVBADYCAEHpBSAFQdgCahANIQBByLIFKAIAIQFByLIFQQA2AgAgAUEBRg0AQciyBUEANgIAIAAgByAGIAVBvAFqIAVBCGogBSgCzAIgBUHQAWogBUEQaiAFQQxqIAgQuwghAEHIsgUoAgAhAUHIsgVBADYCACABQQFGDQAgAA0EQciyBUEANgIAQesFIAVB2AJqEA0aQciyBSgCACEAQciyBUEANgIAIABBAUcNAQsLEAYhBhAHGgwDCxAGIQYQBxoMAgsQBiEGEAcaDAELAkAgBUHQAWoQgQhFDQAgBSgCDCIAIAVBEGprQZ8BSg0AIAUgAEEEajYCDCAAIAUoAgg2AgALQciyBUEANgIAQdcFIAYgBSgCvAEgAyAHELcNIQlByLIFKAIAIQZByLIFQQA2AgACQCAGQQFGDQAgBCAJNwMAQciyBUEANgIAIAVB0AFqIAVBEGogBSgCDCADEI4IQciyBSgCACEGQciyBUEANgIAIAZBAUYNAEHIsgVBADYCAEHoBSAFQdgCaiAFQdACahAVIQZByLIFKAIAIQBByLIFQQA2AgAgAEEBRg0AIAYEQCADIAMoAgBBAnI2AgALIAUoAtgCIQYgAhCJDBogBUHQAWoQiQwaIAVB4AJqJAAgBg8LEAYhBhAHGgsgAhCJDBogBUHQAWoQiQwaIAYQCAALDwAgASACIAMgBCAFEMcIC5kHAgJ/AX0jAEHwAmsiBSQAIAUgATYC4AIgBSAANgLoAiAFQcgBaiACIAVB4AFqIAVB3AFqIAVB2AFqEMgIIAVBuAFqEIkIIgIQigghAEHIsgVBADYCAEHMBSACIAAQBUHIsgUoAgAhAEHIsgVBADYCAAJAAkACQCAAQQFHBEAgBSACQQAQgggiADYCtAEgBSAFQRBqNgIMIAVBADYCCCAFQQE6AAcgBUHFADoABgNAAkBByLIFQQA2AgBB5wUgBUHoAmogBUHgAmoQFSEBQciyBSgCACEGQciyBUEANgIAIAZBAUYNACABRQ0EIAUoArQBIAIQgQggAGpGBEAgAhCBCCEBIAIQgQghAEHIsgVBADYCAEHMBSACIABBAXQQBUHIsgUoAgAhAEHIsgVBADYCACAAQQFGDQQgAhCKCCEAQciyBUEANgIAQcwFIAIgABAFQciyBSgCACEAQciyBUEANgIAIABBAUYNBCAFIAJBABCCCCIAIAFqNgK0AQtByLIFQQA2AgBB6QUgBUHoAmoQDSEBQciyBSgCACEGQciyBUEANgIAIAZBAUYNAEHIsgVBADYCACABIAVBB2ogBUEGaiAAIAVBtAFqIAUoAtwBIAUoAtgBIAVByAFqIAVBEGogBUEMaiAFQQhqIAVB4AFqEMkIIQFByLIFKAIAIQZByLIFQQA2AgAgBkEBRg0AIAENBEHIsgVBADYCAEHrBSAFQegCahANGkHIsgUoAgAhAUHIsgVBADYCACABQQFHDQELCxAGIQAQBxoMAwsQBiEAEAcaDAILEAYhABAHGgwBCwJAIAVByAFqEIEIRQ0AIAUtAAdFDQAgBSgCDCIBIAVBEGprQZ8BSg0AIAUgAUEEajYCDCABIAUoAgg2AgALQciyBUEANgIAQdkFIAAgBSgCtAEgAxAvIQdByLIFKAIAIQBByLIFQQA2AgACQCAAQQFGDQAgBCAHOAIAQciyBUEANgIAIAVByAFqIAVBEGogBSgCDCADEI4IQciyBSgCACEAQciyBUEANgIAIABBAUYNAEHIsgVBADYCAEHoBSAFQegCaiAFQeACahAVIQBByLIFKAIAIQFByLIFQQA2AgAgAUEBRg0AIAAEQCADIAMoAgBBAnI2AgALIAUoAugCIQAgAhCJDBogBUHIAWoQiQwaIAVB8AJqJAAgAA8LEAYhABAHGgsgAhCJDBogBUHIAWoQiQwaIAAQCAAL7AIBAn8jAEEQayIFJAAgBUEIaiABEPgGQciyBUEANgIAQeIFIAVBCGoQDSEBQciyBSgCACEGQciyBUEANgIAAkACQAJAIAZBAUYNAEHIsgVBADYCAEHwBSABQcDBA0HgwQMgAhAaGkHIsgUoAgAhAkHIsgVBADYCACACQQFGDQBByLIFQQA2AgBB4wUgBUEIahANIQJByLIFKAIAIQFByLIFQQA2AgAgAUEBRg0BQciyBUEANgIAQfEFIAIQDSEBQciyBSgCACEGQciyBUEANgIAIAZBAUYNASADIAE2AgBByLIFQQA2AgBB7QUgAhANIQNByLIFKAIAIQFByLIFQQA2AgAgAUEBRg0BIAQgAzYCAEHIsgVBADYCAEHuBSAAIAIQBUHIsgUoAgAhAkHIsgVBADYCACACQQFGDQEgBUEIahD3ByAFQRBqJAAPCxAGIQIQBxoMAQsQBiECEAcaCyAFQQhqEPcHIAIQCAALhAQBAX8jAEEQayIMJAAgDCAANgIMAkACQCAAIAVGBEAgAS0AAEUNAUEAIQAgAUEAOgAAIAQgBCgCACILQQFqNgIAIAtBLjoAACAHEIEIRQ0CIAkoAgAiCyAIa0GfAUoNAiAKKAIAIQUgCSALQQRqNgIAIAsgBTYCAAwCCwJAIAAgBkcNACAHEIEIRQ0AIAEtAABFDQFBACEAIAkoAgAiCyAIa0GfAUoNAiAKKAIAIQAgCSALQQRqNgIAIAsgADYCAEEAIQAgCkEANgIADAILQX8hACALIAtBgAFqIAxBDGoQ0AggC2siC0H8AEoNASALQQJ1QcDBA2otAAAhBQJAIAtBqH9qQR53IgBBA00EQAJAAkAgAEECaw4CAAABCyADIAQoAgAiC0cEQEF/IQAgC0F/ai0AAEHfAHEgAi0AAEH/AHFHDQULIAQgC0EBajYCACALIAU6AABBACEADAQLIAJB0AA6AAAMAQsgAiwAACIAIAVB3wBxRw0AIAIgAEGAAXI6AAAgAS0AAEUNACABQQA6AAAgBxCBCEUNACAJKAIAIgAgCGtBnwFKDQAgCigCACEBIAkgAEEEajYCACAAIAE2AgALIAQgBCgCACIAQQFqNgIAIAAgBToAAEEAIQAgC0HUAEoNASAKIAooAgBBAWo2AgAMAQtBfyEACyAMQRBqJAAgAAsPACABIAIgAyAEIAUQywgLmQcCAn8BfCMAQfACayIFJAAgBSABNgLgAiAFIAA2AugCIAVByAFqIAIgBUHgAWogBUHcAWogBUHYAWoQyAggBUG4AWoQiQgiAhCKCCEAQciyBUEANgIAQcwFIAIgABAFQciyBSgCACEAQciyBUEANgIAAkACQAJAIABBAUcEQCAFIAJBABCCCCIANgK0ASAFIAVBEGo2AgwgBUEANgIIIAVBAToAByAFQcUAOgAGA0ACQEHIsgVBADYCAEHnBSAFQegCaiAFQeACahAVIQFByLIFKAIAIQZByLIFQQA2AgAgBkEBRg0AIAFFDQQgBSgCtAEgAhCBCCAAakYEQCACEIEIIQEgAhCBCCEAQciyBUEANgIAQcwFIAIgAEEBdBAFQciyBSgCACEAQciyBUEANgIAIABBAUYNBCACEIoIIQBByLIFQQA2AgBBzAUgAiAAEAVByLIFKAIAIQBByLIFQQA2AgAgAEEBRg0EIAUgAkEAEIIIIgAgAWo2ArQBC0HIsgVBADYCAEHpBSAFQegCahANIQFByLIFKAIAIQZByLIFQQA2AgAgBkEBRg0AQciyBUEANgIAIAEgBUEHaiAFQQZqIAAgBUG0AWogBSgC3AEgBSgC2AEgBUHIAWogBUEQaiAFQQxqIAVBCGogBUHgAWoQyQghAUHIsgUoAgAhBkHIsgVBADYCACAGQQFGDQAgAQ0EQciyBUEANgIAQesFIAVB6AJqEA0aQciyBSgCACEBQciyBUEANgIAIAFBAUcNAQsLEAYhABAHGgwDCxAGIQAQBxoMAgsQBiEAEAcaDAELAkAgBUHIAWoQgQhFDQAgBS0AB0UNACAFKAIMIgEgBUEQamtBnwFKDQAgBSABQQRqNgIMIAEgBSgCCDYCAAtByLIFQQA2AgBB3AUgACAFKAK0ASADEDAhB0HIsgUoAgAhAEHIsgVBADYCAAJAIABBAUYNACAEIAc5AwBByLIFQQA2AgAgBUHIAWogBUEQaiAFKAIMIAMQjghByLIFKAIAIQBByLIFQQA2AgAgAEEBRg0AQciyBUEANgIAQegFIAVB6AJqIAVB4AJqEBUhAEHIsgUoAgAhAUHIsgVBADYCACABQQFGDQAgAARAIAMgAygCAEECcjYCAAsgBSgC6AIhACACEIkMGiAFQcgBahCJDBogBUHwAmokACAADwsQBiEAEAcaCyACEIkMGiAFQcgBahCJDBogABAIAAsPACABIAIgAyAEIAUQzQgLqgcCAn8BfiMAQYADayIFJAAgBSABNgLwAiAFIAA2AvgCIAVB2AFqIAIgBUHwAWogBUHsAWogBUHoAWoQyAggBUHIAWoQiQgiAhCKCCEAQciyBUEANgIAQcwFIAIgABAFQciyBSgCACEAQciyBUEANgIAAkACQAJAIABBAUcEQCAFIAJBABCCCCIANgLEASAFIAVBIGo2AhwgBUEANgIYIAVBAToAFyAFQcUAOgAWA0ACQEHIsgVBADYCAEHnBSAFQfgCaiAFQfACahAVIQFByLIFKAIAIQZByLIFQQA2AgAgBkEBRg0AIAFFDQQgBSgCxAEgAhCBCCAAakYEQCACEIEIIQEgAhCBCCEAQciyBUEANgIAQcwFIAIgAEEBdBAFQciyBSgCACEAQciyBUEANgIAIABBAUYNBCACEIoIIQBByLIFQQA2AgBBzAUgAiAAEAVByLIFKAIAIQBByLIFQQA2AgAgAEEBRg0EIAUgAkEAEIIIIgAgAWo2AsQBC0HIsgVBADYCAEHpBSAFQfgCahANIQFByLIFKAIAIQZByLIFQQA2AgAgBkEBRg0AQciyBUEANgIAIAEgBUEXaiAFQRZqIAAgBUHEAWogBSgC7AEgBSgC6AEgBUHYAWogBUEgaiAFQRxqIAVBGGogBUHwAWoQyQghAUHIsgUoAgAhBkHIsgVBADYCACAGQQFGDQAgAQ0EQciyBUEANgIAQesFIAVB+AJqEA0aQciyBSgCACEBQciyBUEANgIAIAFBAUcNAQsLEAYhABAHGgwDCxAGIQAQBxoMAgsQBiEAEAcaDAELAkAgBUHYAWoQgQhFDQAgBS0AF0UNACAFKAIcIgEgBUEgamtBnwFKDQAgBSABQQRqNgIcIAEgBSgCGDYCAAtByLIFQQA2AgBB3QUgBSAAIAUoAsQBIAMQHEHIsgUoAgAhAEHIsgVBADYCAAJAIABBAUYNACAFKQMIIQcgBCAFKQMANwMAIAQgBzcDCEHIsgVBADYCACAFQdgBaiAFQSBqIAUoAhwgAxCOCEHIsgUoAgAhAEHIsgVBADYCACAAQQFGDQBByLIFQQA2AgBB6AUgBUH4AmogBUHwAmoQFSEAQciyBSgCACEBQciyBUEANgIAIAFBAUYNACAABEAgAyADKAIAQQJyNgIACyAFKAL4AiEAIAIQiQwaIAVB2AFqEIkMGiAFQYADaiQAIAAPCxAGIQAQBxoLIAIQiQwaIAVB2AFqEIkMGiAAEAgAC5EIAQJ/IwBB4AJrIgAkACAAIAI2AtACIAAgATYC2AIgAEHQAWoQiQghB0HIsgVBADYCACAAQRBqIAMQ+AZByLIFKAIAIQNByLIFQQA2AgACQAJAAkACQAJAAkAgA0EBRwRAQciyBUEANgIAQeIFIABBEGoQDSEDQciyBSgCACEBQciyBUEANgIAIAFBAUYNAUHIsgVBADYCAEHwBSADQcDBA0HawQMgAEHgAWoQGhpByLIFKAIAIQNByLIFQQA2AgAgA0EBRg0BIABBEGoQ9wcgAEHAAWoQiQgiAxCKCCEBQciyBUEANgIAQcwFIAMgARAFQciyBSgCACEBQciyBUEANgIAIAFBAUYNAiAAIANBABCCCCIBNgK8ASAAIABBEGo2AgwgAEEANgIIA0ACQEHIsgVBADYCAEHnBSAAQdgCaiAAQdACahAVIQJByLIFKAIAIQZByLIFQQA2AgAgBkEBRg0AIAJFDQYgACgCvAEgAxCBCCABakYEQCADEIEIIQIgAxCBCCEBQciyBUEANgIAQcwFIAMgAUEBdBAFQciyBSgCACEBQciyBUEANgIAIAFBAUYNBiADEIoIIQFByLIFQQA2AgBBzAUgAyABEAVByLIFKAIAIQFByLIFQQA2AgAgAUEBRg0GIAAgA0EAEIIIIgEgAmo2ArwBC0HIsgVBADYCAEHpBSAAQdgCahANIQJByLIFKAIAIQZByLIFQQA2AgAgBkEBRg0AQciyBUEANgIAIAJBECABIABBvAFqIABBCGpBACAHIABBEGogAEEMaiAAQeABahC7CCECQciyBSgCACEGQciyBUEANgIAIAZBAUYNACACDQZByLIFQQA2AgBB6wUgAEHYAmoQDRpByLIFKAIAIQJByLIFQQA2AgAgAkEBRw0BCwsQBiEBEAcaDAULEAYhARAHGgwFCxAGIQEQBxogAEEQahD3BwwECxAGIQEQBxoMAgsQBiEBEAcaDAELQciyBUEANgIAQcwFIAMgACgCvAEgAWsQBUHIsgUoAgAhAUHIsgVBADYCAAJAIAFBAUYNACADEK8IIQFByLIFQQA2AgBB3gUQGyECQciyBSgCACEGQciyBUEANgIAIAZBAUYNACAAIAU2AgBByLIFQQA2AgBB3wUgASACQeHBAyAAEBohAUHIsgUoAgAhAkHIsgVBADYCACACQQFGDQAgAUEBRwRAIARBBDYCAAtByLIFQQA2AgBB6AUgAEHYAmogAEHQAmoQFSEBQciyBSgCACECQciyBUEANgIAIAJBAUYNACABBEAgBCAEKAIAQQJyNgIACyAAKALYAiEBIAMQiQwaIAcQiQwaIABB4AJqJAAgAQ8LEAYhARAHGgsgAxCJDBoLIAcQiQwaIAEQCAALFQAgACABIAIgAyAAKAIAKAIwEQoACzIAIAIoAgAhAgNAAkAgACABRwR/IAAoAgAgAkcNASAABSABCw8LIABBBGohAAwAAAsACw8AIAAgACgCACgCDBEAAAsPACAAIAAoAgAoAhARAAALEQAgACABIAEoAgAoAhQRAgALogEBAn8jAEEQayICJAAgAkEIaiAAEPgGQciyBUEANgIAQeIFIAJBCGoQDSEAQciyBSgCACEDQciyBUEANgIAAkAgA0EBRg0AQciyBUEANgIAQfAFIABBwMEDQdrBAyABEBoaQciyBSgCACEAQciyBUEANgIAIABBAUYNACACQQhqEPcHIAJBEGokACABDwsQBiEBEAcaIAJBCGoQ9wcgARAIAAvUAgEBfyMAQTBrIgUkACAFIAE2AigCQCACKAIEQQFxRQRAIAAgASACIAMgBCAAKAIAKAIYEQgAIQIMAQsgBUEYaiACEPgGQciyBUEANgIAQcAFIAVBGGoQDSECQciyBSgCACEBQciyBUEANgIAAkAgAUEBRwRAIAVBGGoQ9wcCQCAEBEAgBUEYaiACEPkHDAELIAVBGGogAhD6BwsgBSAFQRhqENYINgIQA0AgBSAFQRhqENcINgIIIAVBEGogBUEIahDYCEUEQCAFKAIoIQIgBUEYahCJDBoMBAsgBUEQaigCACwAACECQciyBUEANgIAQfIFIAVBKGogAhAVGkHIsgUoAgAhAkHIsgVBADYCACACQQFHBEAgBUEQahDZCAwBCwsQBiECEAcaIAVBGGoQiQwaDAELEAYhAhAHGiAFQRhqEPcHCyACEAgACyAFQTBqJAAgAgsoAQF/IwBBEGsiASQAIAFBCGogABCvCBDaCCgCACEAIAFBEGokACAACy4BAX8jAEEQayIBJAAgAUEIaiAAEK8IIAAQgQhqENoIKAIAIQAgAUEQaiQAIAALEAAgACgCACABKAIARkEBcwsPACAAIAAoAgBBAWo2AgALCwAgACABNgIAIAALkQIBBH8jAEEgayIFJAAgBSIAQfDBAy8AADsBHCAAQezBAygAADYCGCAAQRhqQQFyQeTBA0EBIAIoAgQQ3AggAigCBCEGIABBcGoiBSIIJAAQqgghByAAIAQ2AgAgBSAFIAZBCXZBAXFBDWogByAAQRhqIAAQ3QggBWoiBiACEN4IIQcgCEFgaiIEJAAgAEEIaiACEPgGQciyBUEANgIAQfMFIAUgByAGIAQgAEEUaiAAQRBqIABBCGoQIUHIsgUoAgAhBUHIsgVBADYCACAFQQFHBEAgAEEIahD3ByABIAQgACgCFCAAKAIQIAIgAxCmASECIABBIGokACACDwsQBiECEAcaIABBCGoQ9wcgAhAIAAuPAQEBfyADQYAQcQRAIABBKzoAACAAQQFqIQALIANBgARxBEAgAEEjOgAAIABBAWohAAsDQCABLQAAIgQEQCAAIAQ6AAAgAEEBaiEAIAFBAWohAQwBCwsgAAJ/Qe8AIANBygBxIgFBwABGDQAaQdgAQfgAIANBgIABcRsgAUEIRg0AGkHkAEH1ACACGws6AAALRQEBfyMAQRBrIgUkACAFIAI2AgwgBSAENgIIIAUgBUEMahCxCCECIAAgASADIAUoAggQjQYhACACELIIIAVBEGokACAAC2wBAX8gAigCBEGwAXEiAkEgRgRAIAEPCwJAIAJBEEcNAAJAIAAtAAAiA0FVaiICQQJLDQAgAkEBa0UNACAAQQFqDwsgASAAa0ECSA0AIANBMEcNACAALQABQSByQfgARw0AIABBAmohAAsgAAvPBgEIfyMAQRBrIgokACAGEPkGIQsgCiAGEPgHIgYQ0wgCQAJAAkACQAJAIAoQhAgEQEHIsgVBADYCAEHaBSALIAAgAiADEBoaQciyBSgCACEGQciyBUEANgIAIAZBAUYNASAFIAMgAiAAa2oiBjYCAAwFCyAFIAM2AgACQCAAIgktAAAiB0FVaiIIQQJLDQAgCEEBa0UNAEHIsgVBADYCAEGjBSALIAdBGHRBGHUQFSEIQciyBSgCACEHQciyBUEANgIAIAdBAUYNAiAFIAUoAgAiB0EBajYCACAHIAg6AAAgAEEBaiEJCwJAIAIgCWtBAkgNACAJLQAAQTBHDQAgCS0AAUEgckH4AEcNAEHIsgVBADYCAEGjBSALQTAQFSEIQciyBSgCACEHQciyBUEANgIAIAdBAUYNAiAFIAUoAgAiB0EBajYCACAHIAg6AAAgCSwAASEIQciyBUEANgIAQaMFIAsgCBAVIQhByLIFKAIAIQdByLIFQQA2AgAgB0EBRg0CIAUgBSgCACIHQQFqNgIAIAcgCDoAACAJQQJqIQkLQQAhCEHIsgVBADYCACAJIAIQ4AhByLIFKAIAIQdByLIFQQA2AgAgB0EBRg0BQciyBUEANgIAQdAFIAYQDSEOQciyBSgCACEGQciyBUEANgIAIAZBAUYNAkEAIQcgCSEGAkADQCAGIAJPBEAgBSgCACEGQciyBUEANgIAIAMgCSAAa2ogBhDgCEHIsgUoAgAhBkHIsgVBADYCACAGQQFGDQIgBSgCACEGDAcLAkAgCiAHEIIILQAARQ0AIAggCiAHEIIILAAARw0AIAUgBSgCACIIQQFqNgIAIAggDjoAACAHIAcgChCBCEF/aklqIQdBACEICyAGLAAAIQxByLIFQQA2AgBBowUgCyAMEBUhDEHIsgUoAgAhDUHIsgVBADYCACANQQFHBEAgBSAFKAIAIg1BAWo2AgAgDSAMOgAAIAZBAWohBiAIQQFqIQgMAQsLEAYhBhAHGgwECxAGIQYQBxoMAwsQBiEGEAcaDAILEAYhBhAHGgwBCxAGIQYQBxoLIAoQiQwaIAYQCAALIAQgBiADIAEgAGtqIAEgAkYbNgIAIAoQiQwaIApBEGokAAsJACAAIAEQ/QgLBwAgACgCDAuAAgEFfyMAQSBrIgUkACAFIgBCJTcDGCAAQRhqQQFyQebBA0EBIAIoAgQQ3AggAigCBCEGIABBYGoiBSIIJAAQqgghByAAIAQ3AwAgBSAFIAZBCXZBAXFBF2ogByAAQRhqIAAQ3QggBWoiByACEN4IIQkgCEFQaiIGJAAgAEEIaiACEPgGQciyBUEANgIAQfMFIAUgCSAHIAYgAEEUaiAAQRBqIABBCGoQIUHIsgUoAgAhBUHIsgVBADYCACAFQQFHBEAgAEEIahD3ByABIAYgACgCFCAAKAIQIAIgAxCmASECIABBIGokACACDwsQBiECEAcaIABBCGoQ9wcgAhAIAAuRAgEEfyMAQSBrIgUkACAFIgBB8MEDLwAAOwEcIABB7MEDKAAANgIYIABBGGpBAXJB5MEDQQAgAigCBBDcCCACKAIEIQYgAEFwaiIFIggkABCqCCEHIAAgBDYCACAFIAUgBkEJdkEBcUEMciAHIABBGGogABDdCCAFaiIGIAIQ3gghByAIQWBqIgQkACAAQQhqIAIQ+AZByLIFQQA2AgBB8wUgBSAHIAYgBCAAQRRqIABBEGogAEEIahAhQciyBSgCACEFQciyBUEANgIAIAVBAUcEQCAAQQhqEPcHIAEgBCAAKAIUIAAoAhAgAiADEKYBIQIgAEEgaiQAIAIPCxAGIQIQBxogAEEIahD3ByACEAgAC4MCAQV/IwBBIGsiBSQAIAUiAEIlNwMYIABBGGpBAXJB5sEDQQAgAigCBBDcCCACKAIEIQYgAEFgaiIFIggkABCqCCEHIAAgBDcDACAFIAUgBkEJdkEBcUEWckEBaiAHIABBGGogABDdCCAFaiIHIAIQ3gghCSAIQVBqIgYkACAAQQhqIAIQ+AZByLIFQQA2AgBB8wUgBSAJIAcgBiAAQRRqIABBEGogAEEIahAhQciyBSgCACEFQciyBUEANgIAIAVBAUcEQCAAQQhqEPcHIAEgBiAAKAIUIAAoAhAgAiADEKYBIQIgAEEgaiQAIAIPCxAGIQIQBxogAEEIahD3ByACEAgAC44HAQd/IwBB0AFrIgAkACAAQiU3A8gBIABByAFqQQFyQenBAyACKAIEEOYIIQYgACAAQaABajYCnAEQqgghBQJ/IAYEQCACKAIIIQcgACAEOQMoIAAgBzYCICAAQaABakEeIAUgAEHIAWogAEEgahDdCAwBCyAAIAQ5AzAgAEGgAWpBHiAFIABByAFqIABBMGoQ3QgLIQUgAEHEBTYCUCAAQZABakEAIABB0ABqEP4HIQcCQAJAAkAgBUEeTgRAAkAgBgRAQciyBUEANgIAQd4FEBshBUHIsgUoAgAhBkHIsgVBADYCACAGQQFGDQQgACACKAIINgIAQciyBUEANgIAIAAgBDkDCEH1BSAAQZwBaiAFIABByAFqIAAQGiEFQciyBSgCACEGQciyBUEANgIAIAZBAUcNAQwEC0HIsgVBADYCAEHeBRAbIQVByLIFKAIAIQZByLIFQQA2AgAgBkEBRg0DIAAgBDkDEEHIsgVBADYCAEH1BSAAQZwBaiAFIABByAFqIABBEGoQGiEFQciyBSgCACEGQciyBUEANgIAIAZBAUYNAwsgACgCnAEiBkUEQEHIsgVBADYCAEHFBRAKQciyBSgCACEAQciyBUEANgIAIABBAUYNAwwCCyAHIAYQ/wcLIAAoApwBIgYgBSAGaiIIIAIQ3gghCSAAQcQFNgJEIABByABqQQAgAEHEAGoQ/gchBgJAAn8gACgCnAEgAEGgAWpGBEAgAEHQAGohBSAAQaABagwBCyAFQQF0EPUMIgVFBEBByLIFQQA2AgBBxQUQCkHIsgUoAgAhAEHIsgVBADYCACAAQQFHDQMQBiECEAcaDAILIAYgBRD/ByAAKAKcAQshCkHIsgVBADYCACAAQThqIAIQ+AZByLIFKAIAIQtByLIFQQA2AgACQAJAIAtBAUcEQEHIsgVBADYCAEH2BSAKIAkgCCAFIABBxABqIABBQGsgAEE4ahAhQciyBSgCACEIQciyBUEANgIAIAhBAUYNASAAQThqEPcHQciyBUEANgIAQTcgASAFIAAoAkQgACgCQCACIAMQFiECQciyBSgCACEFQciyBUEANgIAIAVBAUYNAiAGEIMIIAcQgwggAEHQAWokACACDwsQBiECEAcaDAILEAYhAhAHGiAAQThqEPcHDAELEAYhAhAHGgsgBhCDCAwCCwALEAYhAhAHGgsgBxCDCCACEAgAC9ABAQN/IAJBgBBxBEAgAEErOgAAIABBAWohAAsgAkGACHEEQCAAQSM6AAAgAEEBaiEACyACQYQCcSIEQYQCRwRAIABBrtQAOwAAQQEhBSAAQQJqIQALIAJBgIABcSEDA0AgAS0AACICBEAgACACOgAAIABBAWohACABQQFqIQEMAQsLIAACfwJAIARBgAJHBEAgBEEERw0BQcYAQeYAIAMbDAILQcUAQeUAIAMbDAELQcEAQeEAIAMbIARBhAJGDQAaQccAQecAIAMbCzoAACAFCwcAIAAoAggLegEBfyMAQRBrIgQkACAEIAE2AgwgBCADNgIIIAQgBEEMahCxCCEBQciyBUEANgIAQfgFIAAgAiAEKAIIEBQhAEHIsgUoAgAhAkHIsgVBADYCACACQQFHBEAgARCyCCAEQRBqJAAgAA8LEAYhBBAHGiABELIIIAQQCAAL3QoBCn8jAEEQayILJAAgBhD5BiEMIAsgBhD4ByIPENMIIAUgAzYCAAJAAkACQAJAAkACQAJAAkAgACIJLQAAIgdBVWoiBkECSw0AIAZBAWtFDQBByLIFQQA2AgBBowUgDCAHQRh0QRh1EBUhBkHIsgUoAgAhB0HIsgVBADYCACAHQQFGDQEgBSAFKAIAIgdBAWo2AgAgByAGOgAAIABBAWohCQsCQAJAIAIgCSIGa0EBTA0AIAktAABBMEcNACAJLQABQSByQfgARw0AQciyBUEANgIAQaMFIAxBMBAVIQZByLIFKAIAIQdByLIFQQA2AgAgB0EBRg0FIAUgBSgCACIHQQFqNgIAIAcgBjoAACAJLAABIQZByLIFQQA2AgBBowUgDCAGEBUhBkHIsgUoAgAhB0HIsgVBADYCACAHQQFGDQUgBSAFKAIAIgdBAWo2AgAgByAGOgAAIAlBAmoiCSEGA0AgBiACTw0CIAYsAAAhB0HIsgVBADYCAEHeBRAbIQhByLIFKAIAIQpByLIFQQA2AgACQCAKQQFGDQBByLIFQQA2AgAgByAIENcHIQdByLIFKAIAIQhByLIFQQA2AgAgCEEBRg0AIAdFDQMgBkEBaiEGDAELCxAGIQYQBxoMCAsDQCAGIAJPDQEgBiwAACEHQciyBUEANgIAQd4FEBsaQciyBSgCACEKQciyBUEANgIAIApBAUYNBkHIsgVBADYCACAHEPsFIQdByLIFKAIAIQhByLIFQQA2AgAgCEEBRg0GIAdFDQEgBkEBaiEGDAAACwALIAsQhAgEQCAFKAIAIQdByLIFQQA2AgBB2gUgDCAJIAYgBxAaGkHIsgUoAgAhB0HIsgVBADYCACAHQQFGDQQgBSAFKAIAIAYgCWtqNgIADAMLQQAhCEHIsgVBADYCACAJIAYQ4AhByLIFKAIAIQdByLIFQQA2AgAgB0EBRg0DQciyBUEANgIAQdAFIA8QDSEQQciyBSgCACEHQciyBUEANgIAIAdBAUYNAUEAIQogCSEHA0AgByAGTwRAIAUoAgAhB0HIsgVBADYCACADIAkgAGtqIAcQ4AhByLIFKAIAIQdByLIFQQA2AgAgB0EBRw0EEAYhBhAHGgwICwJAIAsgChCCCCwAAEEBSA0AIAggCyAKEIIILAAARw0AIAUgBSgCACIIQQFqNgIAIAggEDoAACAKIAogCxCBCEF/aklqIQpBACEICyAHLAAAIQ1ByLIFQQA2AgBBowUgDCANEBUhDUHIsgUoAgAhDkHIsgVBADYCACAOQQFHBEAgBSAFKAIAIg5BAWo2AgAgDiANOgAAIAdBAWohByAIQQFqIQgMAQsLEAYhBhAHGgwGCxAGIQYQBxoMBQsQBiEGEAcaDAQLA0ACQCAGIAJJBEAgBi0AACIHQS5HDQFByLIFQQA2AgBB2wUgDxANIQdByLIFKAIAIQhByLIFQQA2AgAgCEEBRg0DIAUgBSgCACIIQQFqNgIAIAggBzoAACAGQQFqIQYLIAUoAgAhB0HIsgVBADYCAEHaBSAMIAYgAiAHEBoaQciyBSgCACEHQciyBUEANgIAIAdBAUYNAiAFIAUoAgAgAiAGa2oiBjYCACAEIAYgAyABIABraiABIAJGGzYCACALEIkMGiALQRBqJAAPC0HIsgVBADYCAEGjBSAMIAdBGHRBGHUQFSEHQciyBSgCACEIQciyBUEANgIAIAhBAUYNAyAFIAUoAgAiCEEBajYCACAIIAc6AAAgBkEBaiEGDAAACwALEAYhBhAHGgwCCxAGIQYQBxoMAQsQBiEGEAcaCyALEIkMGiAGEAgACxUAIAAgARDOByAAQQRqIAIQzgcgAAsHACAAQQRqC7gHAQd/IwBBgAJrIgAkACAAQiU3A/gBIABB+AFqQQFyQerBAyACKAIEEOYIIQYgACAAQdABajYCzAEQqgghBwJ/IAYEQCACKAIIIQggACAFNwNIIABBQGsgBDcDACAAIAg2AjAgAEHQAWpBHiAHIABB+AFqIABBMGoQ3QgMAQsgACAENwNQIAAgBTcDWCAAQdABakEeIAcgAEH4AWogAEHQAGoQ3QgLIQcgAEHEBTYCgAEgAEHAAWpBACAAQYABahD+ByEIAkACQAJAIAdBHk4EQAJAIAYEQEHIsgVBADYCAEHeBRAbIQdByLIFKAIAIQZByLIFQQA2AgAgBkEBRg0EIAIoAgghBiAAIAQ3AxAgACAFNwMYIAAgBjYCAEHIsgVBADYCAEH1BSAAQcwBaiAHIABB+AFqIAAQGiEHQciyBSgCACEGQciyBUEANgIAIAZBAUcNAQwEC0HIsgVBADYCAEHeBRAbIQdByLIFKAIAIQZByLIFQQA2AgAgBkEBRg0DIAAgBDcDIEHIsgVBADYCACAAIAU3AyhB9QUgAEHMAWogByAAQfgBaiAAQSBqEBohB0HIsgUoAgAhBkHIsgVBADYCACAGQQFGDQMLIAAoAswBIgZFBEBByLIFQQA2AgBBxQUQCkHIsgUoAgAhAEHIsgVBADYCACAAQQFGDQMMAgsgCCAGEP8HCyAAKALMASIGIAYgB2oiCSACEN4IIQogAEHEBTYCdCAAQfgAakEAIABB9ABqEP4HIQYCQAJ/IAAoAswBIABB0AFqRgRAIABBgAFqIQcgAEHQAWoMAQsgB0EBdBD1DCIHRQRAQciyBUEANgIAQcUFEApByLIFKAIAIQBByLIFQQA2AgAgAEEBRw0DEAYhAhAHGgwCCyAGIAcQ/wcgACgCzAELIQtByLIFQQA2AgAgAEHoAGogAhD4BkHIsgUoAgAhDEHIsgVBADYCAAJAAkAgDEEBRwRAQciyBUEANgIAQfYFIAsgCiAJIAcgAEH0AGogAEHwAGogAEHoAGoQIUHIsgUoAgAhCUHIsgVBADYCACAJQQFGDQEgAEHoAGoQ9wdByLIFQQA2AgBBNyABIAcgACgCdCAAKAJwIAIgAxAWIQJByLIFKAIAIQdByLIFQQA2AgAgB0EBRg0CIAYQgwggCBCDCCAAQYACaiQAIAIPCxAGIQIQBxoMAgsQBiECEAcaIABB6ABqEPcHDAELEAYhAhAHGgsgBhCDCAwCCwALEAYhAhAHGgsgCBCDCCACEAgAC/sBAQR/IwBB4ABrIgAkACAAQfbBAy8AADsBXCAAQfLBAygAADYCWBCqCCEFIAAgBDYCACAAQUBrIABBQGtBFCAFIABB2ABqIAAQ3QgiBiAAQUBraiIEIAIQ3gghBSAAQQhqIAIQ+AZByLIFQQA2AgBBlwUgAEEIahANIQdByLIFKAIAIQhByLIFQQA2AgAgCEEBRwRAIABBCGoQ9wcgByAAQUBrIAQgAEEQahCpCBogASAAQRBqIABBEGogBmoiBiAFIABrIABqQVBqIAQgBUYbIAYgAiADEKYBIQIgAEHgAGokACACDwsQBiECEAcaIABBCGoQ9wcgAhAIAAvUAgEBfyMAQTBrIgUkACAFIAE2AigCQCACKAIEQQFxRQRAIAAgASACIAMgBCAAKAIAKAIYEQgAIQIMAQsgBUEYaiACEPgGQciyBUEANgIAQeMFIAVBGGoQDSECQciyBSgCACEBQciyBUEANgIAAkAgAUEBRwRAIAVBGGoQ9wcCQCAEBEAgBUEYaiACEPkHDAELIAVBGGogAhD6BwsgBSAFQRhqENYINgIQA0AgBSAFQRhqEO8INgIIIAVBEGogBUEIahDYCEUEQCAFKAIoIQIgBUEYahCJDBoMBAsgBUEQaigCACgCACECQciyBUEANgIAQfsFIAVBKGogAhAVGkHIsgUoAgAhAkHIsgVBADYCACACQQFHBEAgBUEQahDwCAwBCwsQBiECEAcaIAVBGGoQiQwaDAELEAYhAhAHGiAFQRhqEPcHCyACEAgACyAFQTBqJAAgAgsxAQF/IwBBEGsiASQAIAFBCGogABCvCCAAEIEIQQJ0ahDaCCgCACEAIAFBEGokACAACw8AIAAgACgCAEEEajYCAAuhAgEEfyMAQSBrIgUkACAFIgBB8MEDLwAAOwEcIABB7MEDKAAANgIYIABBGGpBAXJB5MEDQQEgAigCBBDcCCACKAIEIQYgAEFwaiIFIggkABCqCCEHIAAgBDYCACAFIAUgBkEJdkEBcSIEQQ1qIAcgAEEYaiAAEN0IIAVqIgYgAhDeCCEHIAggBEEDdEHgAHJBC2pB8ABxayIEJAAgAEEIaiACEPgGQciyBUEANgIAQfwFIAUgByAGIAQgAEEUaiAAQRBqIABBCGoQIUHIsgUoAgAhBUHIsgVBADYCACAFQQFHBEAgAEEIahD3ByABIAQgACgCFCAAKAIQIAIgAxDzCCECIABBIGokACACDwsQBiECEAcaIABBCGoQ9wcgAhAIAAvYBgEIfyMAQRBrIgokACAGEJcHIQsgCiAGELQIIgYQ0wgCQAJAAkACQAJAIAoQhAgEQEHIsgVBADYCAEHwBSALIAAgAiADEBoaQciyBSgCACEGQciyBUEANgIAIAZBAUYNASAFIAMgAiAAa0ECdGoiBjYCAAwFCyAFIAM2AgACQCAAIgktAAAiB0FVaiIIQQJLDQAgCEEBa0UNAEHIsgVBADYCAEH9BSALIAdBGHRBGHUQFSEIQciyBSgCACEHQciyBUEANgIAIAdBAUYNAiAFIAUoAgAiB0EEajYCACAHIAg2AgAgAEEBaiEJCwJAIAIgCWtBAkgNACAJLQAAQTBHDQAgCS0AAUEgckH4AEcNAEHIsgVBADYCAEH9BSALQTAQFSEIQciyBSgCACEHQciyBUEANgIAIAdBAUYNAiAFIAUoAgAiB0EEajYCACAHIAg2AgAgCSwAASEIQciyBUEANgIAQf0FIAsgCBAVIQhByLIFKAIAIQdByLIFQQA2AgAgB0EBRg0CIAUgBSgCACIHQQRqNgIAIAcgCDYCACAJQQJqIQkLQQAhCEHIsgVBADYCACAJIAIQ4AhByLIFKAIAIQdByLIFQQA2AgAgB0EBRg0BQciyBUEANgIAQe0FIAYQDSEOQciyBSgCACEGQciyBUEANgIAIAZBAUYNAkEAIQcgCSEGAkADQCAGIAJPBEAgBSgCACEGQciyBUEANgIAIAMgCSAAa0ECdGogBhD0CEHIsgUoAgAhBkHIsgVBADYCACAGQQFGDQIgBSgCACEGDAcLAkAgCiAHEIIILQAARQ0AIAggCiAHEIIILAAARw0AIAUgBSgCACIIQQRqNgIAIAggDjYCACAHIAcgChCBCEF/aklqIQdBACEICyAGLAAAIQxByLIFQQA2AgBB/QUgCyAMEBUhDEHIsgUoAgAhDUHIsgVBADYCACANQQFHBEAgBSAFKAIAIg1BBGo2AgAgDSAMNgIAIAZBAWohBiAIQQFqIQgMAQsLEAYhBhAHGgwECxAGIQYQBxoMAwsQBiEGEAcaDAILEAYhBhAHGgwBCxAGIQYQBxoLIAoQiQwaIAYQCAALIAQgBiADIAEgAGtBAnRqIAEgAkYbNgIAIAoQiQwaIApBEGokAAv9AQEEfyMAQRBrIgkkAAJAAkAgAEUNACAEKAIMIQYgAiABayIHQQFOBEAgACABIAdBAnUiBxCzByAHRw0BCyAGIAMgAWtBAnUiCGtBACAGIAhKGyIBQQFOBEBBACEIIAkgASAFEPUIIgYQrwghBUHIsgVBADYCAEH/BSAAIAUgARAUIQVByLIFKAIAIQdByLIFQQA2AgAgB0EBRg0CIAYQiQwaIAEgBUcNAQsgAyACayIBQQFOBEBBACEIIAAgAiABQQJ1IgEQswcgAUcNAQsgBCgCDBogBEEANgIMIAAhCAsgCUEQaiQAIAgPCxAGIQAQBxogBhCJDBogABAIAAsJACAAIAEQ/ggLHwEBfyMAQRBrIgMkACAAIAEgAhCdDCADQRBqJAAgAAuQAgEFfyMAQSBrIgUkACAFIgBCJTcDGCAAQRhqQQFyQebBA0EBIAIoAgQQ3AggAigCBCEGIABBYGoiBSIIJAAQqgghByAAIAQ3AwAgBSAFIAZBCXZBAXEiBkEXaiAHIABBGGogABDdCCAFaiIHIAIQ3gghCSAIIAZBA3RBsAFyQQtqQfABcWsiBiQAIABBCGogAhD4BkHIsgVBADYCAEH8BSAFIAkgByAGIABBFGogAEEQaiAAQQhqECFByLIFKAIAIQVByLIFQQA2AgAgBUEBRwRAIABBCGoQ9wcgASAGIAAoAhQgACgCECACIAMQ8wghAiAAQSBqJAAgAg8LEAYhAhAHGiAAQQhqEPcHIAIQCAALkgIBBH8jAEEgayIFJAAgBSIAQfDBAy8AADsBHCAAQezBAygAADYCGCAAQRhqQQFyQeTBA0EAIAIoAgQQ3AggAigCBCEGIABBcGoiBSIIJAAQqgghByAAIAQ2AgAgBSAFIAZBCXZBAXFBDHIgByAAQRhqIAAQ3QggBWoiBiACEN4IIQcgCEGgf2oiBCQAIABBCGogAhD4BkHIsgVBADYCAEH8BSAFIAcgBiAEIABBFGogAEEQaiAAQQhqECFByLIFKAIAIQVByLIFQQA2AgAgBUEBRwRAIABBCGoQ9wcgASAEIAAoAhQgACgCECACIAMQ8wghAiAAQSBqJAAgAg8LEAYhAhAHGiAAQQhqEPcHIAIQCAALjwIBBX8jAEEgayIFJAAgBSIAQiU3AxggAEEYakEBckHmwQNBACACKAIEENwIIAIoAgQhBiAAQWBqIgUiCCQAEKoIIQcgACAENwMAIAUgBSAGQQl2QQFxQRZyIgZBAWogByAAQRhqIAAQ3QggBWoiByACEN4IIQkgCCAGQQN0QQtqQfABcWsiBiQAIABBCGogAhD4BkHIsgVBADYCAEH8BSAFIAkgByAGIABBFGogAEEQaiAAQQhqECFByLIFKAIAIQVByLIFQQA2AgAgBUEBRwRAIABBCGoQ9wcgASAGIAAoAhQgACgCECACIAMQ8wghAiAAQSBqJAAgAg8LEAYhAhAHGiAAQQhqEPcHIAIQCAALjwcBB38jAEGAA2siACQAIABCJTcD+AIgAEH4AmpBAXJB6cEDIAIoAgQQ5gghBiAAIABB0AJqNgLMAhCqCCEFAn8gBgRAIAIoAgghByAAIAQ5AyggACAHNgIgIABB0AJqQR4gBSAAQfgCaiAAQSBqEN0IDAELIAAgBDkDMCAAQdACakEeIAUgAEH4AmogAEEwahDdCAshBSAAQcQFNgJQIABBwAJqQQAgAEHQAGoQ/gchBwJAAkACQCAFQR5OBEACQCAGBEBByLIFQQA2AgBB3gUQGyEFQciyBSgCACEGQciyBUEANgIAIAZBAUYNBCAAIAIoAgg2AgBByLIFQQA2AgAgACAEOQMIQfUFIABBzAJqIAUgAEH4AmogABAaIQVByLIFKAIAIQZByLIFQQA2AgAgBkEBRw0BDAQLQciyBUEANgIAQd4FEBshBUHIsgUoAgAhBkHIsgVBADYCACAGQQFGDQMgACAEOQMQQciyBUEANgIAQfUFIABBzAJqIAUgAEH4AmogAEEQahAaIQVByLIFKAIAIQZByLIFQQA2AgAgBkEBRg0DCyAAKALMAiIGRQRAQciyBUEANgIAQcUFEApByLIFKAIAIQBByLIFQQA2AgAgAEEBRg0DDAILIAcgBhD/BwsgACgCzAIiBiAFIAZqIgggAhDeCCEJIABBxAU2AkQgAEHIAGpBACAAQcQAahD+ByEGAkACfyAAKALMAiAAQdACakYEQCAAQdAAaiEFIABB0AJqDAELIAVBA3QQ9QwiBUUEQEHIsgVBADYCAEHFBRAKQciyBSgCACEAQciyBUEANgIAIABBAUcNAxAGIQIQBxoMAgsgBiAFEP8HIAAoAswCCyEKQciyBUEANgIAIABBOGogAhD4BkHIsgUoAgAhC0HIsgVBADYCAAJAAkAgC0EBRwRAQciyBUEANgIAQYAGIAogCSAIIAUgAEHEAGogAEFAayAAQThqECFByLIFKAIAIQhByLIFQQA2AgAgCEEBRg0BIABBOGoQ9wdByLIFQQA2AgBBgQYgASAFIAAoAkQgACgCQCACIAMQFiECQciyBSgCACEFQciyBUEANgIAIAVBAUYNAiAGEIMIIAcQgwggAEGAA2okACACDwsQBiECEAcaDAILEAYhAhAHGiAAQThqEPcHDAELEAYhAhAHGgsgBhCDCAwCCwALEAYhAhAHGgsgBxCDCCACEAgAC+wKAQp/IwBBEGsiCyQAIAYQlwchDCALIAYQtAgiDxDTCCAFIAM2AgACQAJAAkACQAJAAkACQAJAIAAiCS0AACIHQVVqIgZBAksNACAGQQFrRQ0AQciyBUEANgIAQf0FIAwgB0EYdEEYdRAVIQZByLIFKAIAIQdByLIFQQA2AgAgB0EBRg0BIAUgBSgCACIHQQRqNgIAIAcgBjYCACAAQQFqIQkLAkACQCACIAkiBmtBAUwNACAJLQAAQTBHDQAgCS0AAUEgckH4AEcNAEHIsgVBADYCAEH9BSAMQTAQFSEGQciyBSgCACEHQciyBUEANgIAIAdBAUYNBSAFIAUoAgAiB0EEajYCACAHIAY2AgAgCSwAASEGQciyBUEANgIAQf0FIAwgBhAVIQZByLIFKAIAIQdByLIFQQA2AgAgB0EBRg0FIAUgBSgCACIHQQRqNgIAIAcgBjYCACAJQQJqIgkhBgNAIAYgAk8NAiAGLAAAIQdByLIFQQA2AgBB3gUQGyEIQciyBSgCACEKQciyBUEANgIAAkAgCkEBRg0AQciyBUEANgIAIAcgCBDXByEHQciyBSgCACEIQciyBUEANgIAIAhBAUYNACAHRQ0DIAZBAWohBgwBCwsQBiEGEAcaDAgLA0AgBiACTw0BIAYsAAAhB0HIsgVBADYCAEHeBRAbGkHIsgUoAgAhCkHIsgVBADYCACAKQQFGDQZByLIFQQA2AgAgBxD7BSEHQciyBSgCACEIQciyBUEANgIAIAhBAUYNBiAHRQ0BIAZBAWohBgwAAAsACyALEIQIBEAgBSgCACEHQciyBUEANgIAQfAFIAwgCSAGIAcQGhpByLIFKAIAIQdByLIFQQA2AgAgB0EBRg0EIAUgBSgCACAGIAlrQQJ0ajYCAAwDC0EAIQhByLIFQQA2AgAgCSAGEOAIQciyBSgCACEHQciyBUEANgIAIAdBAUYNA0HIsgVBADYCAEHtBSAPEA0hEEHIsgUoAgAhB0HIsgVBADYCACAHQQFGDQFBACEKIAkhBwNAIAcgBk8EQCAFKAIAIQdByLIFQQA2AgAgAyAJIABrQQJ0aiAHEPQIQciyBSgCACEHQciyBUEANgIAIAdBAUcNBBAGIQYQBxoMCAsCQCALIAoQgggsAABBAUgNACAIIAsgChCCCCwAAEcNACAFIAUoAgAiCEEEajYCACAIIBA2AgAgCiAKIAsQgQhBf2pJaiEKQQAhCAsgBywAACENQciyBUEANgIAQf0FIAwgDRAVIQ1ByLIFKAIAIQ5ByLIFQQA2AgAgDkEBRwRAIAUgBSgCACIOQQRqNgIAIA4gDTYCACAHQQFqIQcgCEEBaiEIDAELCxAGIQYQBxoMBgsQBiEGEAcaDAULEAYhBhAHGgwECwJAA0AgBiACSQRAIAYtAAAiB0EuRgRAQciyBUEANgIAQfEFIA8QDSEIQciyBSgCACEHQciyBUEANgIAIAdBAUYNBCAFIAUoAgAiCkEEaiIHNgIAIAogCDYCACAGQQFqIQYMAwtByLIFQQA2AgBB/QUgDCAHQRh0QRh1EBUhB0HIsgUoAgAhCEHIsgVBADYCACAIQQFGDQUgBSAFKAIAIghBBGo2AgAgCCAHNgIAIAZBAWohBgwBCwsgBSgCACEHC0HIsgVBADYCAEHwBSAMIAYgAiAHEBoaQciyBSgCACEHQciyBUEANgIAIAdBAUYNACAFIAUoAgAgAiAGa0ECdGoiBjYCACAEIAYgAyABIABrQQJ0aiABIAJGGzYCACALEIkMGiALQRBqJAAPCxAGIQYQBxoMAgsQBiEGEAcaDAELEAYhBhAHGgsgCxCJDBogBhAIAAu5BwEHfyMAQbADayIAJAAgAEIlNwOoAyAAQagDakEBckHqwQMgAigCBBDmCCEGIAAgAEGAA2o2AvwCEKoIIQcCfyAGBEAgAigCCCEIIAAgBTcDSCAAQUBrIAQ3AwAgACAINgIwIABBgANqQR4gByAAQagDaiAAQTBqEN0IDAELIAAgBDcDUCAAIAU3A1ggAEGAA2pBHiAHIABBqANqIABB0ABqEN0ICyEHIABBxAU2AoABIABB8AJqQQAgAEGAAWoQ/gchCAJAAkACQCAHQR5OBEACQCAGBEBByLIFQQA2AgBB3gUQGyEHQciyBSgCACEGQciyBUEANgIAIAZBAUYNBCACKAIIIQYgACAENwMQIAAgBTcDGCAAIAY2AgBByLIFQQA2AgBB9QUgAEH8AmogByAAQagDaiAAEBohB0HIsgUoAgAhBkHIsgVBADYCACAGQQFHDQEMBAtByLIFQQA2AgBB3gUQGyEHQciyBSgCACEGQciyBUEANgIAIAZBAUYNAyAAIAQ3AyBByLIFQQA2AgAgACAFNwMoQfUFIABB/AJqIAcgAEGoA2ogAEEgahAaIQdByLIFKAIAIQZByLIFQQA2AgAgBkEBRg0DCyAAKAL8AiIGRQRAQciyBUEANgIAQcUFEApByLIFKAIAIQBByLIFQQA2AgAgAEEBRg0DDAILIAggBhD/BwsgACgC/AIiBiAGIAdqIgkgAhDeCCEKIABBxAU2AnQgAEH4AGpBACAAQfQAahD+ByEGAkACfyAAKAL8AiAAQYADakYEQCAAQYABaiEHIABBgANqDAELIAdBA3QQ9QwiB0UEQEHIsgVBADYCAEHFBRAKQciyBSgCACEAQciyBUEANgIAIABBAUcNAxAGIQIQBxoMAgsgBiAHEP8HIAAoAvwCCyELQciyBUEANgIAIABB6ABqIAIQ+AZByLIFKAIAIQxByLIFQQA2AgACQAJAIAxBAUcEQEHIsgVBADYCAEGABiALIAogCSAHIABB9ABqIABB8ABqIABB6ABqECFByLIFKAIAIQlByLIFQQA2AgAgCUEBRg0BIABB6ABqEPcHQciyBUEANgIAQYEGIAEgByAAKAJ0IAAoAnAgAiADEBYhAkHIsgUoAgAhB0HIsgVBADYCACAHQQFGDQIgBhCDCCAIEIMIIABBsANqJAAgAg8LEAYhAhAHGgwCCxAGIQIQBxogAEHoAGoQ9wcMAQsQBiECEAcaCyAGEIMIDAILAAsQBiECEAcaCyAIEIMIIAIQCAALiAIBBH8jAEHQAWsiACQAIABB9sEDLwAAOwHMASAAQfLBAygAADYCyAEQqgghBSAAIAQ2AgAgAEGwAWogAEGwAWpBFCAFIABByAFqIAAQ3QgiBiAAQbABamoiBCACEN4IIQUgAEEIaiACEPgGQciyBUEANgIAQeIFIABBCGoQDSEHQciyBSgCACEIQciyBUEANgIAIAhBAUcEQCAAQQhqEPcHIAcgAEGwAWogBCAAQRBqEM8IGiABIABBEGogAEEQaiAGQQJ0aiIGIAUgAGtBAnQgAGpB0HpqIAQgBUYbIAYgAiADEPMIIQIgAEHQAWokACACDwsQBiECEAcaIABBCGoQ9wcgAhAIAAstAAJAIAAgAUYNAANAIAAgAUF/aiIBTw0BIAAgARCxCSAAQQFqIQAMAAALAAsLLQACQCAAIAFGDQADQCAAIAFBfGoiAU8NASAAIAEQxwcgAEEEaiEADAAACwALC5cEAQN/IwBBIGsiCCQAIAggAjYCECAIIAE2AhggCEEIaiADEPgGQciyBUEANgIAQZcFIAhBCGoQDSEBQciyBSgCACECQciyBUEANgIAIAJBAUcEQCAIQQhqEPcHIARBADYCAEEAIQICQANAIAYgB0YNASACDQECQCAIQRhqIAhBEGoQgAcNAAJAIAEgBiwAABCACUElRgRAIAZBAWoiAiAHRg0CQQAhCgJ/AkAgASACLAAAEIAJIglBxQBGDQAgCUH/AXFBMEYNACAGIQIgCQwBCyAGQQJqIgYgB0YNAyAJIQogASAGLAAAEIAJCyEGIAggACAIKAIYIAgoAhAgAyAEIAUgBiAKIAAoAgAoAiQRDgA2AhggAkECaiEGDAELIAFBgMAAIAYsAAAQ/gYEQANAAkAgByAGQQFqIgZGBEAgByEGDAELIAFBgMAAIAYsAAAQ/gYNAQsLA0AgCEEYaiAIQRBqEPwGRQ0CIAFBgMAAIAhBGGoQ/QYQ/gZFDQIgCEEYahD/BhoMAAALAAsgASAIQRhqEP0GEIAIIAEgBiwAABCACEYEQCAGQQFqIQYgCEEYahD/BhoMAQsgBEEENgIACyAEKAIAIQIMAQsLIARBBDYCAAsgCEEYaiAIQRBqEIAHBEAgBCAEKAIAQQJyNgIACyAIKAIYIQYgCEEgaiQAIAYPCxAGIQYQBxogCEEIahD3ByAGEAgACxMAIAAgAUEAIAAoAgAoAiQRBAALQQEBfyMAQRBrIgYkACAGQqWQ6anSyc6S0wA3AwggACABIAIgAyAEIAUgBkEIaiAGQRBqEP8IIQAgBkEQaiQAIAALMQAgACABIAIgAyAEIAUgAEEIaiAAKAIIKAIUEQAAIgAQrwggABCvCCAAEIEIahD/CAuDAQEBfyMAQRBrIgYkACAGIAE2AgggBiADEPgGQciyBUEANgIAQZcFIAYQDSEDQciyBSgCACEBQciyBUEANgIAIAFBAUcEQCAGEPcHIAAgBUEYaiAGQQhqIAIgBCADEIQJIAYoAgghACAGQRBqJAAgAA8LEAYhABAHGiAGEPcHIAAQCAALQAAgAiADIABBCGogACgCCCgCABEAACIAIABBqAFqIAUgBEEAEPsHIABrIgBBpwFMBEAgASAAQQxtQQdvNgIACwuDAQEBfyMAQRBrIgYkACAGIAE2AgggBiADEPgGQciyBUEANgIAQZcFIAYQDSEDQciyBSgCACEBQciyBUEANgIAIAFBAUcEQCAGEPcHIAAgBUEQaiAGQQhqIAIgBCADEIYJIAYoAgghACAGQRBqJAAgAA8LEAYhABAHGiAGEPcHIAAQCAALQAAgAiADIABBCGogACgCCCgCBBEAACIAIABBoAJqIAUgBEEAEPsHIABrIgBBnwJMBEAgASAAQQxtQQxvNgIACwuBAQEBfyMAQRBrIgYkACAGIAE2AgggBiADEPgGQciyBUEANgIAQZcFIAYQDSEDQciyBSgCACEBQciyBUEANgIAIAFBAUcEQCAGEPcHIAVBFGogBkEIaiACIAQgAxCICSAGKAIIIQAgBkEQaiQAIAAPCxAGIQAQBxogBhD3ByAAEAgAC0IAIAEgAiADIARBBBCJCSEBIAMtAABBBHFFBEAgACABQdAPaiABQewOaiABIAFB5ABIGyABQcUASBtBlHFqNgIACwveAQECfyMAQRBrIgUkACAFIAE2AggCQCAAIAVBCGoQgAcEQCACIAIoAgBBBnI2AgBBACEBDAELIANBgBAgABD9BiIBEP4GRQRAIAIgAigCAEEEcjYCAEEAIQEMAQsgAyABEIAJIQEDQAJAIAAQ/wYaIAFBUGohASAAIAVBCGoQ/AYhBiAEQQJIDQAgBkUNACADQYAQIAAQ/QYiBhD+BkUNAiAEQX9qIQQgAyAGEIAJIAFBCmxqIQEMAQsLIAAgBUEIahCAB0UNACACIAIoAgBBAnI2AgALIAVBEGokACABC/AHAQJ/IwBBIGsiByQAIAcgATYCGCAEQQA2AgAgB0EIaiADEPgGQciyBUEANgIAQZcFIAdBCGoQDSEIQciyBSgCACEJQciyBUEANgIAAn8CQAJAAkACQAJAAkACQAJAAkACQAJAAkACQAJAAkACQAJAAkACQAJAAkACQAJAAkAgCUEBRwRAIAdBCGoQ9wcgBkG/f2oiCUE4SwRAIAZBJUcNGCAHQRhqIAIgBCAIEIsJDBkLIAlBAWsOOAIXBRcGFwcIFxcXCxcXFxcPEBEXFxcUFhcXFxcXFxcBAgMEBBcXAhcJFxcKDBcNFw4XDBcXEhMVAQsQBiEEEAcaIAdBCGoQ9wcgBBAIAAsgACAFQRhqIAdBGGogAiAEIAgQhAkMFgsgACAFQRBqIAdBGGogAiAEIAgQhgkMFQsgAEEIaiAAKAIIKAIMEQAAIQEgByAAIAcoAhggAiADIAQgBSABEK8IIAEQrwggARCBCGoQ/wg2AhgMFAsgBUEMaiAHQRhqIAIgBCAIEIwJDBMLIAdCpdq9qcLsy5L5ADcDCCAHIAAgASACIAMgBCAFIAdBCGogB0EQahD/CDYCGAwSCyAHQqWytanSrcuS5AA3AwggByAAIAEgAiADIAQgBSAHQQhqIAdBEGoQ/wg2AhgMEQsgBUEIaiAHQRhqIAIgBCAIEI0JDBALIAVBCGogB0EYaiACIAQgCBCOCQwPCyAFQRxqIAdBGGogAiAEIAgQjwkMDgsgBUEQaiAHQRhqIAIgBCAIEJAJDA0LIAVBBGogB0EYaiACIAQgCBCRCQwMCyAHQRhqIAIgBCAIEJIJDAsLIAAgBUEIaiAHQRhqIAIgBCAIEJMJDAoLIAdB/8EDKAAANgAPIAdB+MEDKQAANwMIIAcgACABIAIgAyAEIAUgB0EIaiAHQRNqEP8INgIYDAkLIAdBh8IDLQAAOgAMIAdBg8IDKAAANgIIIAcgACABIAIgAyAEIAUgB0EIaiAHQQ1qEP8INgIYDAgLIAUgB0EYaiACIAQgCBCUCQwHCyAHQqWQ6anSyc6S0wA3AwggByAAIAEgAiADIAQgBSAHQQhqIAdBEGoQ/wg2AhgMBgsgBUEYaiAHQRhqIAIgBCAIEJUJDAULIAAgASACIAMgBCAFIAAoAgAoAhQRCQAMBQsgAEEIaiAAKAIIKAIYEQAAIQEgByAAIAcoAhggAiADIAQgBSABEK8IIAEQrwggARCBCGoQ/wg2AhgMAwsgBUEUaiAHQRhqIAIgBCAIEIgJDAILIAVBFGogB0EYaiACIAQgCBCWCQwBCyAEIAQoAgBBBHI2AgALIAcoAhgLIQQgB0EgaiQAIAQLZQEBfyMAQRBrIgQkACAEIAE2AghBBiEBAkACQCAAIARBCGoQgAcNAEEEIQEgAyAAEP0GEIAJQSVHDQBBAiEBIAAQ/wYgBEEIahCAB0UNAQsgAiACKAIAIAFyNgIACyAEQRBqJAALPgAgASACIAMgBEECEIkJIQEgAygCACECAkAgAUF/akEeSw0AIAJBBHENACAAIAE2AgAPCyADIAJBBHI2AgALOwAgASACIAMgBEECEIkJIQEgAygCACECAkAgAUEXSg0AIAJBBHENACAAIAE2AgAPCyADIAJBBHI2AgALPgAgASACIAMgBEECEIkJIQEgAygCACECAkAgAUF/akELSw0AIAJBBHENACAAIAE2AgAPCyADIAJBBHI2AgALPAAgASACIAMgBEEDEIkJIQEgAygCACECAkAgAUHtAkoNACACQQRxDQAgACABNgIADwsgAyACQQRyNgIACz4AIAEgAiADIARBAhCJCSEBIAMoAgAhAgJAIAFBDEoNACACQQRxDQAgACABQX9qNgIADwsgAyACQQRyNgIACzsAIAEgAiADIARBAhCJCSEBIAMoAgAhAgJAIAFBO0oNACACQQRxDQAgACABNgIADwsgAyACQQRyNgIAC2EBAX8jAEEQayIEJAAgBCABNgIIA0ACQCAAIARBCGoQ/AZFDQAgA0GAwAAgABD9BhD+BkUNACAAEP8GGgwBCwsgACAEQQhqEIAHBEAgAiACKAIAQQJyNgIACyAEQRBqJAALgwEAIABBCGogACgCCCgCCBEAACIAEIEIQQAgAEEMahCBCGtGBEAgBCAEKAIAQQRyNgIADwsgAiADIAAgAEEYaiAFIARBABD7ByAAayEAAkAgASgCACIEQQxHDQAgAA0AIAFBADYCAA8LAkAgBEELSg0AIABBDEcNACABIARBDGo2AgALCzsAIAEgAiADIARBAhCJCSEBIAMoAgAhAgJAIAFBPEoNACACQQRxDQAgACABNgIADwsgAyACQQRyNgIACzsAIAEgAiADIARBARCJCSEBIAMoAgAhAgJAIAFBBkoNACACQQRxDQAgACABNgIADwsgAyACQQRyNgIACygAIAEgAiADIARBBBCJCSEBIAMtAABBBHFFBEAgACABQZRxajYCAAsLlwQBA38jAEEgayIIJAAgCCACNgIQIAggATYCGCAIQQhqIAMQ+AZByLIFQQA2AgBB4gUgCEEIahANIQFByLIFKAIAIQJByLIFQQA2AgAgAkEBRwRAIAhBCGoQ9wcgBEEANgIAQQAhAgJAA0AgBiAHRg0BIAINAQJAIAhBGGogCEEQahCcBw0AAkAgASAGKAIAEJgJQSVGBEAgBkEEaiICIAdGDQJBACEKAn8CQCABIAIoAgAQmAkiCUHFAEYNACAJQf8BcUEwRg0AIAYhAiAJDAELIAZBCGoiBiAHRg0DIAkhCiABIAYoAgAQmAkLIQYgCCAAIAgoAhggCCgCECADIAQgBSAGIAogACgCACgCJBEOADYCGCACQQhqIQYMAQsgAUGAwAAgBigCABCaBwRAA0ACQCAHIAZBBGoiBkYEQCAHIQYMAQsgAUGAwAAgBigCABCaBw0BCwsDQCAIQRhqIAhBEGoQmAdFDQIgAUGAwAAgCEEYahCZBxCaB0UNAiAIQRhqEJsHGgwAAAsACyABIAhBGGoQmQcQzAcgASAGKAIAEMwHRgRAIAZBBGohBiAIQRhqEJsHGgwBCyAEQQQ2AgALIAQoAgAhAgwBCwsgBEEENgIACyAIQRhqIAhBEGoQnAcEQCAEIAQoAgBBAnI2AgALIAgoAhghBiAIQSBqJAAgBg8LEAYhBhAHGiAIQQhqEPcHIAYQCAALEwAgACABQQAgACgCACgCNBEEAAteAQF/IwBBIGsiBiQAIAZBuMMDKQMANwMYIAZBsMMDKQMANwMQIAZBqMMDKQMANwMIIAZBoMMDKQMANwMAIAAgASACIAMgBCAFIAYgBkEgahCXCSEAIAZBIGokACAACzQAIAAgASACIAMgBCAFIABBCGogACgCCCgCFBEAACIAEK8IIAAQrwggABCBCEECdGoQlwkLgwEBAX8jAEEQayIGJAAgBiABNgIIIAYgAxD4BkHIsgVBADYCAEHiBSAGEA0hA0HIsgUoAgAhAUHIsgVBADYCACABQQFHBEAgBhD3ByAAIAVBGGogBkEIaiACIAQgAxCcCSAGKAIIIQAgBkEQaiQAIAAPCxAGIQAQBxogBhD3ByAAEAgAC0AAIAIgAyAAQQhqIAAoAggoAgARAAAiACAAQagBaiAFIARBABC1CCAAayIAQacBTARAIAEgAEEMbUEHbzYCAAsLgwEBAX8jAEEQayIGJAAgBiABNgIIIAYgAxD4BkHIsgVBADYCAEHiBSAGEA0hA0HIsgUoAgAhAUHIsgVBADYCACABQQFHBEAgBhD3ByAAIAVBEGogBkEIaiACIAQgAxCeCSAGKAIIIQAgBkEQaiQAIAAPCxAGIQAQBxogBhD3ByAAEAgAC0AAIAIgAyAAQQhqIAAoAggoAgQRAAAiACAAQaACaiAFIARBABC1CCAAayIAQZ8CTARAIAEgAEEMbUEMbzYCAAsLgQEBAX8jAEEQayIGJAAgBiABNgIIIAYgAxD4BkHIsgVBADYCAEHiBSAGEA0hA0HIsgUoAgAhAUHIsgVBADYCACABQQFHBEAgBhD3ByAFQRRqIAZBCGogAiAEIAMQoAkgBigCCCEAIAZBEGokACAADwsQBiEAEAcaIAYQ9wcgABAIAAtCACABIAIgAyAEQQQQoQkhASADLQAAQQRxRQRAIAAgAUHQD2ogAUHsDmogASABQeQASBsgAUHFAEgbQZRxajYCAAsL3gEBAn8jAEEQayIFJAAgBSABNgIIAkAgACAFQQhqEJwHBEAgAiACKAIAQQZyNgIAQQAhAQwBCyADQYAQIAAQmQciARCaB0UEQCACIAIoAgBBBHI2AgBBACEBDAELIAMgARCYCSEBA0ACQCAAEJsHGiABQVBqIQEgACAFQQhqEJgHIQYgBEECSA0AIAZFDQAgA0GAECAAEJkHIgYQmgdFDQIgBEF/aiEEIAMgBhCYCSABQQpsaiEBDAELCyAAIAVBCGoQnAdFDQAgAiACKAIAQQJyNgIACyAFQRBqJAAgAQu6CAECfyMAQUBqIgckACAHIAE2AjggBEEANgIAIAcgAxD4BkHIsgVBADYCAEHiBSAHEA0hCEHIsgUoAgAhCUHIsgVBADYCAAJ/AkACQAJAAkACQAJAAkACQAJAAkACQAJAAkACQAJAAkACQAJAAkACQAJAAkACQAJAIAlBAUcEQCAHEPcHIAZBv39qIglBOEsEQCAGQSVHDRggB0E4aiACIAQgCBCjCQwZCyAJQQFrDjgCFwUXBhcHCBcXFwsXFxcXDxARFxcXFBYXFxcXFxcXAQIDBAQXFwIXCRcXCgwXDRcOFwwXFxITFQELEAYhBBAHGiAHEPcHIAQQCAALIAAgBUEYaiAHQThqIAIgBCAIEJwJDBYLIAAgBUEQaiAHQThqIAIgBCAIEJ4JDBULIABBCGogACgCCCgCDBEAACEBIAcgACAHKAI4IAIgAyAEIAUgARCvCCABEK8IIAEQgQhBAnRqEJcJNgI4DBQLIAVBDGogB0E4aiACIAQgCBCkCQwTCyAHQajCAykDADcDGCAHQaDCAykDADcDECAHQZjCAykDADcDCCAHQZDCAykDADcDACAHIAAgASACIAMgBCAFIAcgB0EgahCXCTYCOAwSCyAHQcjCAykDADcDGCAHQcDCAykDADcDECAHQbjCAykDADcDCCAHQbDCAykDADcDACAHIAAgASACIAMgBCAFIAcgB0EgahCXCTYCOAwRCyAFQQhqIAdBOGogAiAEIAgQpQkMEAsgBUEIaiAHQThqIAIgBCAIEKYJDA8LIAVBHGogB0E4aiACIAQgCBCnCQwOCyAFQRBqIAdBOGogAiAEIAgQqAkMDQsgBUEEaiAHQThqIAIgBCAIEKkJDAwLIAdBOGogAiAEIAgQqgkMCwsgACAFQQhqIAdBOGogAiAEIAgQqwkMCgsgB0HQwgNBLBCADSIGIAAgASACIAMgBCAFIAYgBkEsahCXCTYCOAwJCyAHQZDDAygCADYCECAHQYjDAykDADcDCCAHQYDDAykDADcDACAHIAAgASACIAMgBCAFIAcgB0EUahCXCTYCOAwICyAFIAdBOGogAiAEIAgQrAkMBwsgB0G4wwMpAwA3AxggB0GwwwMpAwA3AxAgB0GowwMpAwA3AwggB0GgwwMpAwA3AwAgByAAIAEgAiADIAQgBSAHIAdBIGoQlwk2AjgMBgsgBUEYaiAHQThqIAIgBCAIEK0JDAULIAAgASACIAMgBCAFIAAoAgAoAhQRCQAMBQsgAEEIaiAAKAIIKAIYEQAAIQEgByAAIAcoAjggAiADIAQgBSABEK8IIAEQrwggARCBCEECdGoQlwk2AjgMAwsgBUEUaiAHQThqIAIgBCAIEKAJDAILIAVBFGogB0E4aiACIAQgCBCuCQwBCyAEIAQoAgBBBHI2AgALIAcoAjgLIQQgB0FAayQAIAQLZQEBfyMAQRBrIgQkACAEIAE2AghBBiEBAkACQCAAIARBCGoQnAcNAEEEIQEgAyAAEJkHEJgJQSVHDQBBAiEBIAAQmwcgBEEIahCcB0UNAQsgAiACKAIAIAFyNgIACyAEQRBqJAALPgAgASACIAMgBEECEKEJIQEgAygCACECAkAgAUF/akEeSw0AIAJBBHENACAAIAE2AgAPCyADIAJBBHI2AgALOwAgASACIAMgBEECEKEJIQEgAygCACECAkAgAUEXSg0AIAJBBHENACAAIAE2AgAPCyADIAJBBHI2AgALPgAgASACIAMgBEECEKEJIQEgAygCACECAkAgAUF/akELSw0AIAJBBHENACAAIAE2AgAPCyADIAJBBHI2AgALPAAgASACIAMgBEEDEKEJIQEgAygCACECAkAgAUHtAkoNACACQQRxDQAgACABNgIADwsgAyACQQRyNgIACz4AIAEgAiADIARBAhChCSEBIAMoAgAhAgJAIAFBDEoNACACQQRxDQAgACABQX9qNgIADwsgAyACQQRyNgIACzsAIAEgAiADIARBAhChCSEBIAMoAgAhAgJAIAFBO0oNACACQQRxDQAgACABNgIADwsgAyACQQRyNgIAC2EBAX8jAEEQayIEJAAgBCABNgIIA0ACQCAAIARBCGoQmAdFDQAgA0GAwAAgABCZBxCaB0UNACAAEJsHGgwBCwsgACAEQQhqEJwHBEAgAiACKAIAQQJyNgIACyAEQRBqJAALgwEAIABBCGogACgCCCgCCBEAACIAEIEIQQAgAEEMahCBCGtGBEAgBCAEKAIAQQRyNgIADwsgAiADIAAgAEEYaiAFIARBABC1CCAAayEAAkAgASgCACIEQQxHDQAgAA0AIAFBADYCAA8LAkAgBEELSg0AIABBDEcNACABIARBDGo2AgALCzsAIAEgAiADIARBAhChCSEBIAMoAgAhAgJAIAFBPEoNACACQQRxDQAgACABNgIADwsgAyACQQRyNgIACzsAIAEgAiADIARBARChCSEBIAMoAgAhAgJAIAFBBkoNACACQQRxDQAgACABNgIADwsgAyACQQRyNgIACygAIAEgAiADIARBBBChCSEBIAMtAABBBHFFBEAgACABQZRxajYCAAsLSgAjAEGAAWsiAiQAIAIgAkH0AGo2AgwgAEEIaiACQRBqIAJBDGogBCAFIAYQsAkgAkEQaiACKAIMIAEQ+QshASACQYABaiQAIAELZAEBfyMAQRBrIgYkACAGQQA6AA8gBiAFOgAOIAYgBDoADSAGQSU6AAwgBQRAIAZBDWogBkEOahCxCQsgAiABIAEgAigCABCyCSAGQQxqIAMgACgCABA1IAFqNgIAIAZBEGokAAs1AQF/IwBBEGsiAiQAIAIgAC0AADoADyAAIAEtAAA6AAAgASACQQ9qLQAAOgAAIAJBEGokAAsHACABIABrC0oAIwBBoANrIgIkACACIAJBoANqNgIMIABBCGogAkEQaiACQQxqIAQgBSAGELQJIAJBEGogAigCDCABEPoLIQEgAkGgA2okACABC4IBAQF/IwBBkAFrIgYkACAGIAZBhAFqNgIcIAAgBkEgaiAGQRxqIAMgBCAFELAJIAZCADcDECAGIAZBIGo2AgwgASAGQQxqIAEgAigCABC1CSAGQRBqIAAoAgAQtgkiAEF/RgRAQfTHAxC3CQALIAIgASAAQQJ0ajYCACAGQZABaiQACwoAIAEgAGtBAnULcwEBfyMAQRBrIgUkACAFIAQ2AgwgBUEIaiAFQQxqELEIIQRByLIFQQA2AgAgACABIAIgAxDgByEAQciyBSgCACEBQciyBUEANgIAIAFBAUcEQCAEELIIIAVBEGokACAADwsQBiEFEAcaIAQQsgggBRAIAAtTAQF/QQgQDiEBQciyBUEANgIAQYQGIAEgABAVGkHIsgUoAgAhAEHIsgVBADYCACAAQQFHBEAgAUHg+ANBhQYQEQALEAYhABAHGiABEBMgABAIAAsFAEH/AAsIACAAEIkIGgsXACMAQRBrIgEkACAAEJQMIAFBEGokAAsMACAAQYKGgCA2AAALCABB/////wcLDAAgAEEBQS0Q9QgaC9AGAQJ/IwBBoAJrIgAkACAAIAI2ApACIAAgATYCmAIgAEGHBjYCECAAQZgBaiAAQaABaiAAQRBqEP4HIQFByLIFQQA2AgAgAEGQAWogBBD4BkHIsgUoAgAhB0HIsgVBADYCAAJAAkACQAJAAkACQAJ/AkACQAJAIAdBAUcEQEHIsgVBADYCAEGXBSAAQZABahANIQdByLIFKAIAIQhByLIFQQA2AgAgCEEBRg0BIABBADoAjwEgBCgCBCEEQciyBUEANgIAQYgGIABBmAJqIAIgAyAAQZABaiAEIAUgAEGPAWogByABIABBlAFqIABBhAJqEDYhBEHIsgUoAgAhAkHIsgVBADYCACACQQFGDQYgBEUNBSAAQdvDAygAADYAhwEgAEHUwwMpAAA3A4ABQciyBUEANgIAQdoFIAcgAEGAAWogAEGKAWogAEH2AGoQGhpByLIFKAIAIQRByLIFQQA2AgAgBEEBRg0CIABBxAU2AgQgAEEIakEAIABBBGoQ/gchByAAQRBqIAAoApQBIAEoAgBrQeMASA0EGiAHIAAoApQBIAEoAgBrQQJqEPUMEP8HIAcoAgANA0HIsgVBADYCAEHFBRAKQciyBSgCACEEQciyBUEANgIAIARBAUYNBwwKCxAGIQQQBxoMCAsQBiEEEAcaDAYLEAYhBBAHGgwFCyAHKAIACyECIAAtAI8BBEAgAkEtOgAAIAJBAWohAgsgASgCACEEA0AgBCAAKAKUAU8EQCACQQA6AAAgACAGNgIAIABBEGpBwMMDIAAQnwZBAUcEQEHIsgVBADYCAEGJBkHEwwMQD0HIsgUoAgAhBEHIsgVBADYCACAEQQFHDQgMBQsgBxCDCAUgAiAAQfYAaiAAQYABaiAEELAIIABrIABqLQAKOgAAIAJBAWohAiAEQQFqIQQMAQsLC0HIsgVBADYCAEHHBSAAQZgCaiAAQZACahAVIQRByLIFKAIAIQJByLIFQQA2AgAgAkEBRg0AIAQEQCAFIAUoAgBBAnI2AgALIAAoApgCIQQgAEGQAWoQ9wcgARCDCCAAQaACaiQAIAQPCxAGIQQQBxoMAQsQBiEEEAcaIAcQgwgLIABBkAFqEPcHCyABEIMIIAQQCAALAAu+GwEIfyMAQbAEayILJAAgCyAKNgKkBCALIAE2AqgEIAtBhwY2AmggCyALQYgBaiALQZABaiALQegAahD+ByIPKAIAIgE2AoQBIAsgAUGQA2o2AoABIAtB6ABqEIkIIREgC0HYAGoQiQghDiALQcgAahCJCCEMIAtBOGoQiQghDSALQShqEIkIIRBByLIFQQA2AgBBigYgAiADIAtB+ABqIAtB9wBqIAtB9gBqIBEgDiAMIA0gC0EkahAfQciyBSgCACECQciyBUEANgIAAkACQAJAIAJBAUcEQCAJIAgoAgA2AgAgBEGABHEhEkEAIQFBACEEA0AgBCEKAn8CQAJAAkACQAJ/AkAgAUEERg0AQciyBUEANgIAQcYFIAAgC0GoBGoQFSEEQciyBSgCACECQciyBUEANgIAIAJBAUYNCSAERQ0AIAtB+ABqIAFqLAAAIgRBBEsNBUEAIQICQAJAAkACQAJAAkAgBEEBaw4EAAQDBQELIAFBA0YNCkHIsgVBADYCAEHIBSAAEA0hBEHIsgUoAgAhAkHIsgVBADYCACACQQFGDQ4gB0GAwAAgBBD+BgRAQciyBUEANgIAQYsGIAtBGGogAEEAEBJByLIFKAIAIQRByLIFQQA2AgAgBEEBRwRAIAssABghBEHIsgVBADYCAEE7IBAgBBAFQciyBSgCACEEQciyBUEANgIAIARBAUcNAwsQBiELEAcaDBELIAUgBSgCAEEEcjYCAEEADAYLIAFBA0YNCQsDQEHIsgVBADYCAEHGBSAAIAtBqARqEBUhBEHIsgUoAgAhAkHIsgVBADYCACACQQFGDQ4gBEUNCUHIsgVBADYCAEHIBSAAEA0hBEHIsgUoAgAhAkHIsgVBADYCACACQQFGDQ4gB0GAwAAgBBD+BkUNCUHIsgVBADYCAEGLBiALQRhqIABBABASQciyBSgCACEEQciyBUEANgIAIARBAUcEQCALLAAYIQRByLIFQQA2AgBBOyAQIAQQBUHIsgUoAgAhBEHIsgVBADYCACAEQQFHDQELCxAGIQsQBxoMDgsgDBCBCEEAIA0QgQhrRg0HAkAgDBCBCARAIA0QgQgNAQsgDBCBCARAQciyBUEANgIAQcgFIAAQDSEEQciyBSgCACECQciyBUEANgIAIAJBAUYNDSAMQQAQgggtAAAgBEH/AXFGBEBByLIFQQA2AgBBygUgABANGkHIsgUoAgAhBEHIsgVBADYCACAEQQFGDQ4gDCAKIAwQgQhBAUsbDAsLIAZBAToAAAwJC0HIsgVBADYCAEHIBSAAEA0hBEHIsgUoAgAhAkHIsgVBADYCACACQQFGDQwgDUEAEIIILQAAIARB/wFxRw0IQciyBUEANgIAQcoFIAAQDRpByLIFKAIAIQRByLIFQQA2AgAgBEEBRg0MIAZBAToAACANIAogDRCBCEEBSxsMCQtByLIFQQA2AgBByAUgABANIQRByLIFKAIAIQJByLIFQQA2AgAgAkEBRg0LIAxBABCCCC0AACAEQf8BcUYEQEHIsgVBADYCAEHKBSAAEA0aQciyBSgCACEEQciyBUEANgIAIARBAUYNDCAMIAogDBCBCEEBSxsMCQtByLIFQQA2AgBByAUgABANIQRByLIFKAIAIQJByLIFQQA2AgAgAkEBRg0LIA1BABCCCC0AACAEQf8BcUYEQEHIsgVBADYCAEHKBSAAEA0aQciyBSgCACEEQciyBUEANgIAIARBAUYNDCAGQQE6AAAgDSAKIA0QgQhBAUsbDAkLIAUgBSgCAEEEcjYCAEEADAMLAkAgAUECSQ0AIAoNACASDQBBACABQQJGIAstAHtBAEdxRQ0IGgsgCyAOENYINgIQIAtBGGogC0EQahDCCSEEAkAgAUUNACABIAtqLQB3QQFLDQADQAJAIAsgDhDXCDYCECAEIAtBEGoQ2AhFDQAgB0GAwAAgBCgCACwAABD+BkUNACAEENkIDAELCyALIA4Q1gg2AhAgBCgCACALKAIQayIEIBAQgQhNBEAgCyAQENcINgIQIAtBEGpBACAEaxDUCSEEIBAQ1wghAiAOENYIIQNByLIFQQA2AgAgBCACIAMQwwkhBEHIsgUoAgAhAkHIsgVBADYCACACQQFGDQUgBA0BCyALIA4Q1gg2AgggC0EQaiALQQhqEMIJGiALIAsoAhA2AhgLIAsgCygCGDYCEAJAAkADQCALIA4Q1wg2AgggC0EQaiALQQhqENgIRQ0CQciyBUEANgIAQcYFIAAgC0GoBGoQFSEEQciyBSgCACECQciyBUEANgIAAkAgAkEBRg0AIARFDQNByLIFQQA2AgBByAUgABANIQRByLIFKAIAIQJByLIFQQA2AgAgAkEBRg0AIAsoAhAtAAAgBEH/AXFHDQNByLIFQQA2AgBBygUgABANGkHIsgUoAgAhBEHIsgVBADYCACAEQQFGDQIgC0EQahDZCAwBCwsQBiELEAcaDA4LEAYhCxAHGgwNCyASRQ0GIAsgDhDXCDYCCCALQRBqIAtBCGoQ2AhFDQYgBSAFKAIAQQRyNgIAQQAMAgsCQANAAkBByLIFQQA2AgBBxgUgACALQagEahAVIQRByLIFKAIAIQNByLIFQQA2AgAgA0EBRg0AIARFDQJByLIFQQA2AgBByAUgABANIQRByLIFKAIAIQNByLIFQQA2AgAgA0EBRg0GAn8gB0GAECAEEP4GBEAgCSgCACIDIAsoAqQERgRAQciyBUEANgIAQY0GIAggCSALQaQEahASQciyBSgCACEDQciyBUEANgIAIANBAUYNCSAJKAIAIQMLIAkgA0EBajYCACADIAQ6AAAgAkEBagwBCyAREIEIIQMgAkUNAyADRQ0DIAstAHYgBEH/AXFHDQMgCygChAEiBCALKAKAAUYEQEHIsgVBADYCAEGOBiAPIAtBhAFqIAtBgAFqEBJByLIFKAIAIQRByLIFQQA2AgAgBEEBRg0IIAsoAoQBIQQLIAsgBEEEajYChAEgBCACNgIAQQALIQJByLIFQQA2AgBBygUgABANGkHIsgUoAgAhBEHIsgVBADYCACAEQQFHDQELCxAGIQsQBxoMDAsgDygCACEDAkAgAkUNACADIAsoAoQBIgRGDQAgCygCgAEgBEYEQEHIsgVBADYCAEGOBiAPIAtBhAFqIAtBgAFqEBJByLIFKAIAIQRByLIFQQA2AgAgBEEBRg0GIAsoAoQBIQQLIAsgBEEEajYChAEgBCACNgIACwJAIAsoAiRBAUgNAEHIsgVBADYCAEHHBSAAIAtBqARqEBUhBEHIsgUoAgAhAkHIsgVBADYCACACQQFGDQUCQCAERQRAQciyBUEANgIAQcgFIAAQDSEEQciyBSgCACECQciyBUEANgIAIAJBAUYNByALLQB3IARB/wFxRg0BCyAFIAUoAgBBBHI2AgBBAAwDC0HIsgVBADYCAEHKBSAAEA0aQciyBSgCACEEQciyBUEANgIAIARBAUYNBQNAIAsoAiRBAUgNAUHIsgVBADYCAEHHBSAAIAtBqARqEBUhBEHIsgUoAgAhAkHIsgVBADYCAAJAIAJBAUYNAAJAIARFBEBByLIFQQA2AgBByAUgABANIQRByLIFKAIAIQJByLIFQQA2AgAgAkEBRg0CIAdBgBAgBBD+Bg0BCyAFIAUoAgBBBHI2AgBBAAwFCyAJKAIAIAsoAqQERgRAQciyBUEANgIAQY0GIAggCSALQaQEahASQciyBSgCACEEQciyBUEANgIAIARBAUYNAQtByLIFQQA2AgBByAUgABANIQRByLIFKAIAIQJByLIFQQA2AgAgAkEBRg0AIAkgCSgCACICQQFqNgIAIAIgBDoAAEHIsgVBADYCACALIAsoAiRBf2o2AiRBygUgABANGkHIsgUoAgAhBEHIsgVBADYCACAEQQFHDQELCxAGIQsQBxoMDAsgCiAIKAIAIAkoAgBHDQYaIAUgBSgCAEEEcjYCAEEADAELAkAgCkUNAEEBIQQDQCAEIAoQgQhPDQFByLIFQQA2AgBBxwUgACALQagEahAVIQJByLIFKAIAIQlByLIFQQA2AgACQCAJQQFGDQACQCACRQRAQciyBUEANgIAQcgFIAAQDSECQciyBSgCACEJQciyBUEANgIAIAlBAUYNAiAKIAQQgggtAAAgAkH/AXFGDQELIAUgBSgCAEEEcjYCAEEADAQLQciyBUEANgIAQcoFIAAQDRpByLIFKAIAIQJByLIFQQA2AgAgBEEBaiEEIAJBAUcNAQsLEAYhCxAHGgwLCwJAIA8oAgAgCygChAFGDQAgC0EANgIYIA8oAgAhAEHIsgVBADYCACARIAAgCygChAEgC0EYahCOCEHIsgUoAgAhAEHIsgVBADYCACAAQQFHBEAgCygCGEUNASAFIAUoAgBBBHI2AgBBAAwCCxAGIQsQBxoMCwtBAQshACAQEIkMGiANEIkMGiAMEIkMGiAOEIkMGiAREIkMGiAPEIMIIAtBsARqJAAgAA8LEAYhCxAHGgwICxAGIQsQBxoMBwsQBiELEAcaDAYLIAoLIQQgAUEBaiEBDAAACwALEAYhCxAHGgwCCxAGIQsQBxoMAQsQBiELEAcaCyAQEIkMGiANEIkMGiAMEIkMGiAOEIkMGiAREIkMGiAPEIMIIAsQCAALoQIBAX8jAEEQayIKJAAgCQJ/IAAEQCAKIAEQzQkiABDOCSACIAooAgA2AAAgCiAAEM8JIAggChDQCSAKEIkMGiAKIAAQ+gcgByAKENAJIAoQiQwaIAMgABDRCDoAACAEIAAQ0gg6AAAgCiAAENMIIAUgChDQCSAKEIkMGiAKIAAQ+QcgBiAKENAJIAoQiQwaIAAQ0QkMAQsgCiABENIJIgAQzgkgAiAKKAIANgAAIAogABDPCSAIIAoQ0AkgChCJDBogCiAAEPoHIAcgChDQCSAKEIkMGiADIAAQ0Qg6AAAgBCAAENIIOgAAIAogABDTCCAFIAoQ0AkgChCJDBogCiAAEPkHIAYgChDQCSAKEIkMGiAAENEJCzYCACAKQRBqJAALIwAgASgCABCJB0EYdEEYdSECIAAgASgCADYCBCAAIAI6AAALDgAgACABKAIANgIAIAALCwAgACABIAIQ0wkLywEBBn8jAEEQayIEJAAgABDrCCgCACEFAn8gAigCACAAKAIAayIDQf////8HSQRAIANBAXQMAQtBfwsiA0EBIAMbIQMgASgCACEGIAAoAgAhByAFQYcGRgR/QQAFIAAoAgALIAMQ9wwiCARAIAYgB2shBiAFQYcGRwRAIAAQ1QkaCyAEQcQFNgIEIAAgBEEIaiAIIARBBGoQ/gciBRDWCSAFEIMIIAEgBiAAKAIAajYCACACIAMgACgCAGo2AgAgBEEQaiQADwsQ/QsAC9QBAQZ/IwBBEGsiBCQAIAAQ6wgoAgAhBQJ/IAIoAgAgACgCAGsiA0H/////B0kEQCADQQF0DAELQX8LIgNBBCADGyEDIAEoAgAhBiAAKAIAIQcgBUGHBkYEf0EABSAAKAIACyADEPcMIggEQCAGIAdrQQJ1IQYgBUGHBkcEQCAAENUJGgsgBEHEBTYCBCAAIARBCGogCCAEQQRqEP4HIgUQ1gkgBRCDCCABIAAoAgAgBkECdGo2AgAgAiAAKAIAIANBfHFqNgIAIARBEGokAA8LEP0LAAu6BQECfyMAQaABayIAJAAgACACNgKQASAAIAE2ApgBIABBhwY2AhQgAEEYaiAAQSBqIABBFGoQ/gchB0HIsgVBADYCACAAQRBqIAQQ+AZByLIFKAIAIQFByLIFQQA2AgACQAJAAkACQAJAAkAgAUEBRwRAQciyBUEANgIAQZcFIABBEGoQDSEBQciyBSgCACEIQciyBUEANgIAIAhBAUYNASAAQQA6AA8gBCgCBCEEQciyBUEANgIAQYgGIABBmAFqIAIgAyAAQRBqIAQgBSAAQQ9qIAEgByAAQRRqIABBhAFqEDYhBEHIsgUoAgAhAkHIsgVBADYCACACQQFGDQQgBEUNAyAGEMcJIAAtAA9FDQJByLIFQQA2AgBBowUgAUEtEBUhBEHIsgUoAgAhAkHIsgVBADYCACACQQFGDQRByLIFQQA2AgBBOyAGIAQQBUHIsgUoAgAhBEHIsgVBADYCACAEQQFHDQIMBAsQBiEEEAcaDAULEAYhBBAHGgwDC0HIsgVBADYCAEGjBSABQTAQFSEBQciyBSgCACEEQciyBUEANgIAIARBAUcEQCAHKAIAIgQgACgCFCIIQX9qIgIgBCACSxshAyABQf8BcSEBA0ACQCAEIAJJBEAgBC0AACABRg0BIAQhAwtByLIFQQA2AgBBkAYgBiADIAgQFBpByLIFKAIAIQRByLIFQQA2AgAgBEEBRw0DEAYhBBAHGgwFCyAEQQFqIQQMAAALAAsQBiEEEAcaDAILQciyBUEANgIAQccFIABBmAFqIABBkAFqEBUhBEHIsgUoAgAhAkHIsgVBADYCACACQQFGDQAgBARAIAUgBSgCAEECcjYCAAsgACgCmAEhBCAAQRBqEPcHIAcQgwggAEGgAWokACAEDwsQBiEEEAcaCyAAQRBqEPcHCyAHEIMIIAQQCAALWAECfyMAQRBrIgEkAAJAIAAQrQgEQCAAKAIAIQIgAUEAOgAPIAIgAUEPahDJCSAAQQAQygkMAQsgAUEAOgAOIAAgAUEOahDJCSAAQQAQywkLIAFBEGokAAsLACAAIAEgAhDMCQsMACAAIAEtAAA6AAALCQAgACABNgIECwkAIAAgAToACwuqAgEEfyMAQSBrIgUkACAAEIEIIQQgABCKCCEDAkAgASACEPULIgZFDQAgASAAEK8IIAAQrwggABCBCGoQ+wsEQAJ/IwBBEGsiAyQAIAVBEGoiBCABIAIQ8AcgA0EQaiQAIAQiAQsQrwghAyABEIEIIQJByLIFQQA2AgBBjwMgACADIAIQFBpByLIFKAIAIQNByLIFQQA2AgAgA0EBRwRAIAEQiQwaDAILEAYhAxAHGiABEIkMGiADEAgACyADIARrIAZJBEAgACADIAQgBmogA2sgBCAEEJAMCyAAEK8IIARqIQMDQCABIAJHBEAgAyABEMkJIAFBAWohASADQQFqIQMMAQsLIAVBADoADyADIAVBD2oQyQkgACAEIAZqEM0LCyAFQSBqJAAgAAsLACAAQcCzBRD8BwsRACAAIAEgASgCACgCLBECAAsRACAAIAEgASgCACgCIBECAAsJACAAIAEQ5QkLDwAgACAAKAIAKAIkEQAACwsAIABBuLMFEPwHC3kBAX8jAEEgayIDJAAgAyABNgIQIAMgADYCGCADIAI2AggDQAJAAn9BASADQRhqIANBEGoQ2AhFDQAaIANBGGooAgAtAAAgA0EIaigCAC0AAEYNAUEACyECIANBIGokACACDwsgA0EYahDZCCADQQhqENkIDAAACwALOQEBfyMAQRBrIgIkACACIAAoAgA2AgggAkEIaiIAIAAoAgAgAWo2AgAgAigCCCEBIAJBEGokACABCxQBAX8gACgCACEBIABBADYCACABCyAAIAAgARDVCRD/ByABEOsIKAIAIQEgABDrCCABNgIAC+AGAQJ/IwBB8ARrIgAkACAAIAI2AuAEIAAgATYC6AQgAEGHBjYCECAAQcgBaiAAQdABaiAAQRBqEP4HIQFByLIFQQA2AgAgAEHAAWogBBD4BkHIsgUoAgAhB0HIsgVBADYCAAJAAkACQAJAAkACQAJ/AkACQAJAIAdBAUcEQEHIsgVBADYCAEHiBSAAQcABahANIQdByLIFKAIAIQhByLIFQQA2AgAgCEEBRg0BIABBADoAvwEgBCgCBCEEQciyBUEANgIAQZEGIABB6ARqIAIgAyAAQcABaiAEIAUgAEG/AWogByABIABBxAFqIABB4ARqEDYhBEHIsgUoAgAhAkHIsgVBADYCACACQQFGDQYgBEUNBSAAQdvDAygAADYAtwEgAEHUwwMpAAA3A7ABQciyBUEANgIAQfAFIAcgAEGwAWogAEG6AWogAEGAAWoQGhpByLIFKAIAIQRByLIFQQA2AgAgBEEBRg0CIABBxAU2AgQgAEEIakEAIABBBGoQ/gchByAAQRBqIAAoAsQBIAEoAgBrQYkDSA0EGiAHIAAoAsQBIAEoAgBrQQJ1QQJqEPUMEP8HIAcoAgANA0HIsgVBADYCAEHFBRAKQciyBSgCACEEQciyBUEANgIAIARBAUYNBwwKCxAGIQQQBxoMCAsQBiEEEAcaDAYLEAYhBBAHGgwFCyAHKAIACyECIAAtAL8BBEAgAkEtOgAAIAJBAWohAgsgASgCACEEA0AgBCAAKALEAU8EQCACQQA6AAAgACAGNgIAIABBEGpBwMMDIAAQnwZBAUcEQEHIsgVBADYCAEGJBkHEwwMQD0HIsgUoAgAhBEHIsgVBADYCACAEQQFHDQgMBQsgBxCDCAUgAiAAQbABaiAAQYABaiAAQYABahBmIAQQ0AggAEGAAWprQQJ1ai0AADoAACACQQFqIQIgBEEEaiEEDAELCwtByLIFQQA2AgBB6AUgAEHoBGogAEHgBGoQFSEEQciyBSgCACECQciyBUEANgIAIAJBAUYNACAEBEAgBSAFKAIAQQJyNgIACyAAKALoBCEEIABBwAFqEPcHIAEQgwggAEHwBGokACAEDwsQBiEEEAcaDAELEAYhBBAHGiAHEIMICyAAQcABahD3BwsgARCDCCAEEAgACwAL5xwBCX8jAEGwBGsiCyQAIAsgCjYCpAQgCyABNgKoBCALQYcGNgJgIAsgC0GIAWogC0GQAWogC0HgAGoQ/gciECgCACIBNgKEASALIAFBkANqNgKAASALQeAAahCJCCESIAtB0ABqEIkIIQ4gC0FAaxCJCCEMIAtBMGoQiQghDSALQSBqEIkIIRFByLIFQQA2AgBBkgYgAiADIAtB+ABqIAtB9ABqIAtB8ABqIBIgDiAMIA0gC0EcahAfQciyBSgCACECQciyBUEANgIAAkACQAJAIAJBAUcEQCAJIAgoAgA2AgAgBEGABHEhE0EAIQpBACEEA0AgBCEPAn8CQAJAAkACQAJ/AkAgCkEERg0AQciyBUEANgIAQecFIAAgC0GoBGoQFSEEQciyBSgCACECQciyBUEANgIAIAJBAUYNCSAERQ0AIAtB+ABqIApqLAAAIgRBBEsNBUEAIQICQAJAAkACQAJAAkAgBEEBaw4EAAQDBQELIApBA0YNCkHIsgVBADYCAEHpBSAAEA0hBEHIsgUoAgAhAkHIsgVBADYCACACQQFGDQ5ByLIFQQA2AgBBkwYgB0GAwAAgBBAUIQRByLIFKAIAIQJByLIFQQA2AgAgAkEBRg0OIAQEQEHIsgVBADYCAEGUBiALQRBqIABBABASQciyBSgCACEEQciyBUEANgIAIARBAUcEQCALKAIQIQRByLIFQQA2AgBBlQYgESAEEAVByLIFKAIAIQRByLIFQQA2AgAgBEEBRw0DCxAGIQsQBxoMEQsgBSAFKAIAQQRyNgIAQQAMBgsgCkEDRg0JCwNAQciyBUEANgIAQecFIAAgC0GoBGoQFSEEQciyBSgCACECQciyBUEANgIAIAJBAUYNDiAERQ0JQciyBUEANgIAQekFIAAQDSEEQciyBSgCACECQciyBUEANgIAIAJBAUYNDkHIsgVBADYCAEGTBiAHQYDAACAEEBQhBEHIsgUoAgAhAkHIsgVBADYCACACQQFGDQ4gBEUNCUHIsgVBADYCAEGUBiALQRBqIABBABASQciyBSgCACEEQciyBUEANgIAIARBAUcEQCALKAIQIQRByLIFQQA2AgBBlQYgESAEEAVByLIFKAIAIQRByLIFQQA2AgAgBEEBRw0BCwsQBiELEAcaDA4LIAwQgQhBACANEIEIa0YNBwJAIAwQgQgEQCANEIEIDQELIAwQgQgEQEHIsgVBADYCAEHpBSAAEA0hBEHIsgUoAgAhAkHIsgVBADYCACACQQFGDQ0gDBCvCCgCACAERgRAQciyBUEANgIAQesFIAAQDRpByLIFKAIAIQRByLIFQQA2AgAgBEEBRg0OIAwgDyAMEIEIQQFLGwwLCyAGQQE6AAAMCQtByLIFQQA2AgBB6QUgABANIQRByLIFKAIAIQJByLIFQQA2AgAgAkEBRg0MIAQgDRCvCCgCAEcNCEHIsgVBADYCAEHrBSAAEA0aQciyBSgCACEEQciyBUEANgIAIARBAUYNDCAGQQE6AAAgDSAPIA0QgQhBAUsbDAkLQciyBUEANgIAQekFIAAQDSEEQciyBSgCACECQciyBUEANgIAIAJBAUYNCyAMEK8IKAIAIARGBEBByLIFQQA2AgBB6wUgABANGkHIsgUoAgAhBEHIsgVBADYCACAEQQFGDQwgDCAPIAwQgQhBAUsbDAkLQciyBUEANgIAQekFIAAQDSEEQciyBSgCACECQciyBUEANgIAIAJBAUYNCyANEK8IKAIAIARGBEBByLIFQQA2AgBB6wUgABANGkHIsgUoAgAhBEHIsgVBADYCACAEQQFGDQwgBkEBOgAAIA0gDyANEIEIQQFLGwwJCyAFIAUoAgBBBHI2AgBBAAwDCwJAIApBAkkNACAPDQAgEw0AQQAgCkECRiALLQB7QQBHcUUNCBoLIAsgDhDWCDYCCCALQRBqIAtBCGoQwgkhBAJAIApFDQAgCiALai0Ad0EBSw0AAkADQCALIA4Q7wg2AgggBCALQQhqENgIRQ0BIAQoAgAoAgAhAkHIsgVBADYCAEGTBiAHQYDAACACEBQhAkHIsgUoAgAhA0HIsgVBADYCACADQQFHBEAgAkUNAiAEEPAIDAELCxAGIQsQBxoMDgsgCyAOENYINgIIIAQoAgAgCygCCGtBAnUiBCAREIEITQRAIAsgERDvCDYCCCALQQhqQQAgBGsQ5AkhBCAREO8IIQIgDhDWCCEDQciyBUEANgIAIAQgAiADENsJIQRByLIFKAIAIQJByLIFQQA2AgAgAkEBRg0FIAQNAQsgCyAOENYINgIAIAtBCGogCxDCCRogCyALKAIINgIQCyALIAsoAhA2AggCQAJAA0AgCyAOEO8INgIAIAtBCGogCxDYCEUNAkHIsgVBADYCAEHnBSAAIAtBqARqEBUhBEHIsgUoAgAhAkHIsgVBADYCAAJAIAJBAUYNACAERQ0DQciyBUEANgIAQekFIAAQDSEEQciyBSgCACECQciyBUEANgIAIAJBAUYNACAEIAsoAggoAgBHDQNByLIFQQA2AgBB6wUgABANGkHIsgUoAgAhBEHIsgVBADYCACAEQQFGDQIgC0EIahDwCAwBCwsQBiELEAcaDA4LEAYhCxAHGgwNCyATRQ0GIAsgDhDvCDYCACALQQhqIAsQ2AhFDQYgBSAFKAIAQQRyNgIAQQAMAgsCQANAAkBByLIFQQA2AgBB5wUgACALQagEahAVIQRByLIFKAIAIQNByLIFQQA2AgAgA0EBRg0AIARFDQJByLIFQQA2AgBB6QUgABANIQRByLIFKAIAIQNByLIFQQA2AgAgA0EBRg0GQciyBUEANgIAQZMGIAdBgBAgBBAUIQNByLIFKAIAIQFByLIFQQA2AgAgAUEBRg0GAn8gAwRAIAkoAgAiAyALKAKkBEYEQEHIsgVBADYCAEGXBiAIIAkgC0GkBGoQEkHIsgUoAgAhA0HIsgVBADYCACADQQFGDQkgCSgCACEDCyAJIANBBGo2AgAgAyAENgIAIAJBAWoMAQsgEhCBCCEDIAJFDQMgA0UNAyAEIAsoAnBHDQMgCygChAEiBCALKAKAAUYEQEHIsgVBADYCAEGOBiAQIAtBhAFqIAtBgAFqEBJByLIFKAIAIQRByLIFQQA2AgAgBEEBRg0IIAsoAoQBIQQLIAsgBEEEajYChAEgBCACNgIAQQALIQJByLIFQQA2AgBB6wUgABANGkHIsgUoAgAhBEHIsgVBADYCACAEQQFHDQELCxAGIQsQBxoMDAsgECgCACEDAkAgAkUNACADIAsoAoQBIgRGDQAgCygCgAEgBEYEQEHIsgVBADYCAEGOBiAQIAtBhAFqIAtBgAFqEBJByLIFKAIAIQRByLIFQQA2AgAgBEEBRg0GIAsoAoQBIQQLIAsgBEEEajYChAEgBCACNgIACwJAIAsoAhxBAUgNAEHIsgVBADYCAEHoBSAAIAtBqARqEBUhBEHIsgUoAgAhAkHIsgVBADYCACACQQFGDQUCQCAERQRAQciyBUEANgIAQekFIAAQDSEEQciyBSgCACECQciyBUEANgIAIAJBAUYNByAEIAsoAnRGDQELIAUgBSgCAEEEcjYCAEEADAMLQciyBUEANgIAQesFIAAQDRpByLIFKAIAIQRByLIFQQA2AgAgBEEBRg0FA0AgCygCHEEBSA0BQciyBUEANgIAQegFIAAgC0GoBGoQFSEEQciyBSgCACECQciyBUEANgIAAkAgAkEBRg0AAkAgBEUEQEHIsgVBADYCAEHpBSAAEA0hBEHIsgUoAgAhAkHIsgVBADYCACACQQFGDQJByLIFQQA2AgBBkwYgB0GAECAEEBQhBEHIsgUoAgAhAkHIsgVBADYCACACQQFGDQIgBA0BCyAFIAUoAgBBBHI2AgBBAAwFCyAJKAIAIAsoAqQERgRAQciyBUEANgIAQZcGIAggCSALQaQEahASQciyBSgCACEEQciyBUEANgIAIARBAUYNAQtByLIFQQA2AgBB6QUgABANIQRByLIFKAIAIQJByLIFQQA2AgAgAkEBRg0AIAkgCSgCACICQQRqNgIAIAIgBDYCAEHIsgVBADYCACALIAsoAhxBf2o2AhxB6wUgABANGkHIsgUoAgAhBEHIsgVBADYCACAEQQFHDQELCxAGIQsQBxoMDAsgDyAIKAIAIAkoAgBHDQYaIAUgBSgCAEEEcjYCAEEADAELAkAgD0UNAEEBIQQDQCAEIA8QgQhPDQFByLIFQQA2AgBB6AUgACALQagEahAVIQJByLIFKAIAIQlByLIFQQA2AgACQCAJQQFGDQACQCACRQRAQciyBUEANgIAQekFIAAQDSECQciyBSgCACEJQciyBUEANgIAIAlBAUYNAiACIA8gBBC2CCgCAEYNAQsgBSAFKAIAQQRyNgIAQQAMBAtByLIFQQA2AgBB6wUgABANGkHIsgUoAgAhAkHIsgVBADYCACAEQQFqIQQgAkEBRw0BCwsQBiELEAcaDAsLAkAgECgCACALKAKEAUYNACALQQA2AhAgECgCACEAQciyBUEANgIAIBIgACALKAKEASALQRBqEI4IQciyBSgCACEAQciyBUEANgIAIABBAUcEQCALKAIQRQ0BIAUgBSgCAEEEcjYCAEEADAILEAYhCxAHGgwLC0EBCyEAIBEQiQwaIA0QiQwaIAwQiQwaIA4QiQwaIBIQiQwaIBAQgwggC0GwBGokACAADwsQBiELEAcaDAgLEAYhCxAHGgwHCxAGIQsQBxoMBgsgDwshBCAKQQFqIQoMAAALAAsQBiELEAcaDAILEAYhCxAHGgwBCxAGIQsQBxoLIBEQiQwaIA0QiQwaIAwQiQwaIA4QiQwaIBIQiQwaIBAQgwggCxAIAAuhAgEBfyMAQRBrIgokACAJAn8gAARAIAogARDgCSIAEM4JIAIgCigCADYAACAKIAAQzwkgCCAKEOEJIAoQiQwaIAogABD6ByAHIAoQ4QkgChCJDBogAyAAENEINgIAIAQgABDSCDYCACAKIAAQ0wggBSAKENAJIAoQiQwaIAogABD5ByAGIAoQ4QkgChCJDBogABDRCQwBCyAKIAEQ4gkiABDOCSACIAooAgA2AAAgCiAAEM8JIAggChDhCSAKEIkMGiAKIAAQ+gcgByAKEOEJIAoQiQwaIAMgABDRCDYCACAEIAAQ0gg2AgAgCiAAENMIIAUgChDQCSAKEIkMGiAKIAAQ+QcgBiAKEOEJIAoQiQwaIAAQ0QkLNgIAIApBEGokAAsUACAAIAEoAgAQnwcgASgCABDJBwsLACAAIAEgAhDjCQumBQECfyMAQcADayIAJAAgACACNgKwAyAAIAE2ArgDIABBhwY2AhQgAEEYaiAAQSBqIABBFGoQ/gchB0HIsgVBADYCACAAQRBqIAQQ+AZByLIFKAIAIQFByLIFQQA2AgACQAJAAkACQAJAAkACQCABQQFHBEBByLIFQQA2AgBB4gUgAEEQahANIQFByLIFKAIAIQhByLIFQQA2AgAgCEEBRg0BIABBADoADyAEKAIEIQRByLIFQQA2AgBBkQYgAEG4A2ogAiADIABBEGogBCAFIABBD2ogASAHIABBFGogAEGwA2oQNiEEQciyBSgCACECQciyBUEANgIAIAJBAUYNBSAERQ0DIAYQ3QkgAC0AD0UNAkHIsgVBADYCAEH9BSABQS0QFSEEQciyBSgCACECQciyBUEANgIAIAJBAUYNBUHIsgVBADYCAEGVBiAGIAQQBUHIsgUoAgAhBEHIsgVBADYCACAEQQFHDQIMBQsQBiEEEAcaDAYLEAYhBBAHGgwEC0HIsgVBADYCAEH9BSABQTAQFSEBQciyBSgCACEEQciyBUEANgIAIARBAUYNASAHKAIAIQQgACgCFCIDQXxqIQIDQAJAIAQgAk8NACAEKAIAIAFHDQAgBEEEaiEEDAELC0HIsgVBADYCAEGYBiAGIAQgAxAUGkHIsgUoAgAhBEHIsgVBADYCACAEQQFHDQAQBiEEEAcaDAMLQciyBUEANgIAQegFIABBuANqIABBsANqEBUhBEHIsgUoAgAhAkHIsgVBADYCACACQQFGDQEgBARAIAUgBSgCAEECcjYCAAsgACgCuAMhBCAAQRBqEPcHIAcQgwggAEHAA2okACAEDwsQBiEEEAcaDAELEAYhBBAHGgsgAEEQahD3BwsgBxCDCCAEEAgAC1gBAn8jAEEQayIBJAACQCAAEK0IBEAgACgCACECIAFBADYCDCACIAFBDGoQzgcgAEEAEMoJDAELIAFBADYCCCAAIAFBCGoQzgcgAEEAEMsJCyABQRBqJAALCwAgACABIAIQ3wkLqAIBBH8jAEEQayIFJAAgABCBCCEEIAAQzAshAwJAIAEgAhDLCyIGRQ0AIAEgABCvCCAAEK8IIAAQgQhBAnRqEPsLBEACfyMAQRBrIgMkACAFIAEgAhD0ByADQRBqJAAgBSIBCxCvCCEDIAEQgQghAkHIsgVBADYCAEGZBiAAIAMgAhAUGkHIsgUoAgAhA0HIsgVBADYCACADQQFHBEAgARCJDBoMAgsQBiEDEAcaIAEQiQwaIAMQCAALIAMgBGsgBkkEQCAAIAMgBCAGaiADayAEIAQQmQwLIAAQrwggBEECdGohAwNAIAEgAkcEQCADIAEQzgcgAUEEaiEBIANBBGohAwwBCwsgBUEANgIAIAMgBRDOByAAIAQgBmoQzQsLIAVBEGokACAACwsAIABB0LMFEPwHCwkAIAAgARDmCQsLACAAQcizBRD8Bwt5AQF/IwBBIGsiAyQAIAMgATYCECADIAA2AhggAyACNgIIA0ACQAJ/QQEgA0EYaiADQRBqENgIRQ0AGiADQRhqKAIAKAIAIANBCGooAgAoAgBGDQFBAAshAiADQSBqJAAgAg8LIANBGGoQ8AggA0EIahDwCAwAAAsACzwBAX8jAEEQayICJAAgAiAAKAIANgIIIAJBCGoiACAAKAIAIAFBAnRqNgIAIAIoAgghASACQRBqJAAgAQtXAQF/IwBBEGsiAiQAIAAQrQgEQCAAIAAoAgAgABCuCBDRCwsgACABKAIINgIIIAAgASkCADcCACABQQAQywkgAkEAOgAPIAEgAkEPahDJCSACQRBqJAALVwEBfyMAQRBrIgIkACAAEK0IBEAgACAAKAIAIAAQrggQ0QsLIAAgASgCCDYCCCAAIAEpAgA3AgAgAUEAEMsJIAJBADYCDCABIAJBDGoQzgcgAkEQaiQAC/8IAQt/IwBB0ANrIgAkACAAIAU3AxAgACAGNwMYIAAgAEHgAmo2AtwCIABB4AJqQeQAQd/DAyAAQRBqEJUGIQcgAEHEBTYCMCAAQegBakEAIABBMGoQ/gchDyAAQcQFNgIwIABB4AFqQQAgAEEwahD+ByELIABB8AFqIQkCQAJAAkAgB0HkAE8EQEHIsgVBADYCAEHeBRAbIQdByLIFKAIAIQhByLIFQQA2AgAgCEEBRg0CIAAgBTcDAEHIsgVBADYCACAAIAY3AwhB9QUgAEHcAmogB0HfwwMgABAaIQdByLIFKAIAIQhByLIFQQA2AgAgCEEBRg0CIAAoAtwCIghFBEBByLIFQQA2AgBBxQUQCkHIsgUoAgAhAEHIsgVBADYCACAAQQFHDQIMAwsgDyAIEP8HIAsgBxD1DBD/ByALEOgJBEBByLIFQQA2AgBBxQUQCkHIsgUoAgAhAEHIsgVBADYCACAAQQFGDQMMAgsgCygCACEJC0HIsgVBADYCACAAQdgBaiADEPgGQciyBSgCACEIQciyBUEANgIAAkACQAJAAkACQAJAAkAgCEEBRwRAQciyBUEANgIAQZcFIABB2AFqEA0hEUHIsgUoAgAhCEHIsgVBADYCACAIQQFGDQFByLIFQQA2AgBB2gUgESAAKALcAiIIIAcgCGogCRAaGkHIsgUoAgAhCEHIsgVBADYCACAIQQFGDQEgBwRAIAAoAtwCLQAAQS1GIRALIABBwAFqEIkIIQ0gAEGwAWoQiQghCCAAQaABahCJCCEKQciyBUEANgIAQZoGIAIgECAAQdgBaiAAQdABaiAAQc8BaiAAQc4BaiANIAggCiAAQZwBahAfQciyBSgCACECQciyBUEANgIAIAJBAUYNAiAAQcQFNgIkIABBKGpBACAAQSRqEP4HIQ4CfyAHIAAoApwBIgJKBEAgChCBCCAHIAJrQQF0QQFyagwBCyAKEIEIQQJqCyEMIABBMGohAiAIEIEIIAxqIAAoApwBaiIMQeUASQ0DIA4gDBD1DBD/ByAOKAIAIgINA0HIsgVBADYCAEHFBRAKQciyBSgCACEHQciyBUEANgIAIAdBAUcNCBAGIQcQBxoMBAsQBiEHEAcaDAkLEAYhBxAHGgwECxAGIQcQBxoMAgsgAygCBCEMQciyBUEANgIAQZsGIAIgAEEkaiAAQSBqIAwgCSAHIAlqIBEgECAAQdABaiAALADPASAALADOASANIAggCiAAKAKcARA3QciyBSgCACEHQciyBUEANgIAIAdBAUcEQEHIsgVBADYCAEE3IAEgAiAAKAIkIAAoAiAgAyAEEBYhB0HIsgUoAgAhCUHIsgVBADYCACAJQQFHDQQLEAYhBxAHGgsgDhCDCAsgChCJDBogCBCJDBogDRCJDBoLIABB2AFqEPcHDAMLIA4QgwggChCJDBogCBCJDBogDRCJDBogAEHYAWoQ9wcgCxCDCCAPEIMIIABB0ANqJAAgBw8LAAsQBiEHEAcaCyALEIMIIA8QgwggBxAIAAsNACAAKAIAQQBHQQFzC9sCAQF/IwBBEGsiCiQAIAkCfyAABEAgAhDNCSEAAkAgAQRAIAogABDOCSADIAooAgA2AAAgCiAAEM8JIAggChDQCSAKEIkMGgwBCyAKIAAQ6wkgAyAKKAIANgAAIAogABD6ByAIIAoQ0AkgChCJDBoLIAQgABDRCDoAACAFIAAQ0gg6AAAgCiAAENMIIAYgChDQCSAKEIkMGiAKIAAQ+QcgByAKENAJIAoQiQwaIAAQ0QkMAQsgAhDSCSEAAkAgAQRAIAogABDOCSADIAooAgA2AAAgCiAAEM8JIAggChDQCSAKEIkMGgwBCyAKIAAQ6wkgAyAKKAIANgAAIAogABD6ByAIIAoQ0AkgChCJDBoLIAQgABDRCDoAACAFIAAQ0gg6AAAgCiAAENMIIAYgChDQCSAKEIkMGiAKIAAQ+QcgByAKENAJIAoQiQwaIAAQ0QkLNgIAIApBEGokAAuKBgEKfyMAQRBrIhUkACACIAA2AgAgA0GABHEhFwNAAkACQAJAAkAgFkEERgRAIA0QgQhBAUsEQCAVIA0Q1gg2AgggAiAVQQhqQQEQ1AkgDRDXCCACKAIAEOwJNgIACyADQbABcSIPQRBGDQIgD0EgRw0BIAEgAigCADYCAAwCCyAIIBZqLAAAIg9BBEsNAwJAAkACQAJAAkAgD0EBaw4EAQMCBAALIAEgAigCADYCAAwHCyABIAIoAgA2AgAgBkEgEMwHIQ8gAiACKAIAIhBBAWo2AgAgECAPOgAADAYLIA0QhAgNBSANQQAQgggtAAAhDyACIAIoAgAiEEEBajYCACAQIA86AAAMBQsgDBCECCEPIBdFDQQgDw0EIAIgDBDWCCAMENcIIAIoAgAQ7Ak2AgAMBAsgAigCACEYIARBAWogBCAHGyIEIQ8DQAJAIA8gBU8NACAGQYAQIA8sAAAQ/gZFDQAgD0EBaiEPDAELCyAOIhBBAU4EQANAAkAgEEEBSCIRDQAgDyAETQ0AIA9Bf2oiDy0AACERIAIgAigCACISQQFqNgIAIBIgEToAACAQQX9qIRAMAQsLIBEEf0EABSAGQTAQzAcLIRIDQCACIAIoAgAiEUEBajYCACAQQQFOBEAgESASOgAAIBBBf2ohEAwBCwsgESAJOgAACyAEIA9GBEAgBkEwEMwHIQ8gAiACKAIAIhBBAWo2AgAgECAPOgAADAMLAn9BfyALEIQIDQAaIAtBABCCCCwAAAshE0EAIRBBACEUA0AgBCAPRg0DAkAgECATRwRAIBAhEQwBCyACIAIoAgAiEUEBajYCACARIAo6AABBACERIBRBAWoiFCALEIEITwRAIBAhEwwBCyALIBQQgggtAABB/wBGBEBBfyETDAELIAsgFBCCCCwAACETCyAPQX9qIg8tAAAhECACIAIoAgAiEkEBajYCACASIBA6AAAgEUEBaiEQDAAACwALIAEgADYCAAsgFUEQaiQADwsgGCACKAIAEOAICyAWQQFqIRYMAAALAAsRACAAIAEgASgCACgCKBECAAskACAAEPMJIQAgARDzCSAAayIBBEAgAiAAIAEQgg0LIAEgAmoL+QUBCX8jAEHAAWsiACQAIABBuAFqIAMQ+AZByLIFQQA2AgBBlwUgAEG4AWoQDSEMQciyBSgCACEGQciyBUEANgIAAkACQAJAAkACQAJAAkACQCAGQQFHBEAgBRCBCARAIAVBABCCCC0AACEGQciyBUEANgIAQaMFIAxBLRAVIQdByLIFKAIAIQlByLIFQQA2AgAgCUEBRg0CIAZB/wFxIAdB/wFxRiELCyAAQaABahCJCCEJIABBkAFqEIkIIQYgAEGAAWoQiQghB0HIsgVBADYCAEGaBiACIAsgAEG4AWogAEGwAWogAEGvAWogAEGuAWogCSAGIAcgAEH8AGoQH0HIsgUoAgAhAkHIsgVBADYCACACQQFGDQIgAEHEBTYCBCAAQQhqQQAgAEEEahD+ByEKAn8gBRCBCCAAKAJ8SgRAIAUQgQghAiAAKAJ8IQggBxCBCCACIAhrQQF0akEBagwBCyAHEIEIQQJqCyEIIABBEGohAiAGEIEIIAhqIAAoAnxqIghB5QBJDQQgCiAIEPUMEP8HIAooAgAiAg0EQciyBUEANgIAQcUFEApByLIFKAIAIQVByLIFQQA2AgAgBUEBRg0DAAsQBiEFEAcaDAYLEAYhBRAHGgwFCxAGIQUQBxoMAwsQBiEFEAcaDAELIAMoAgQhCCAFEK8IIQ0gBRCvCCEOIAUQgQghBUHIsgVBADYCAEGbBiACIABBBGogACAIIA0gBSAOaiAMIAsgAEGwAWogACwArwEgACwArgEgCSAGIAcgACgCfBA3QciyBSgCACEFQciyBUEANgIAIAVBAUcEQEHIsgVBADYCAEE3IAEgAiAAKAIEIAAoAgAgAyAEEBYhBUHIsgUoAgAhA0HIsgVBADYCACADQQFHDQQLEAYhBRAHGgsgChCDCAsgBxCJDBogBhCJDBogCRCJDBoLIABBuAFqEPcHIAUQCAALIAoQgwggBxCJDBogBhCJDBogCRCJDBogAEG4AWoQ9wcgAEHAAWokACAFC4kJAQt/IwBBsAhrIgAkACAAIAU3AxAgACAGNwMYIAAgAEHAB2o2ArwHIABBwAdqQeQAQd/DAyAAQRBqEJUGIQcgAEHEBTYCMCAAQZgEakEAIABBMGoQ/gchDyAAQcQFNgIwIABBkARqQQAgAEEwahD+ByELIABBoARqIQkCQAJAAkAgB0HkAE8EQEHIsgVBADYCAEHeBRAbIQdByLIFKAIAIQhByLIFQQA2AgAgCEEBRg0CIAAgBTcDAEHIsgVBADYCACAAIAY3AwhB9QUgAEG8B2ogB0HfwwMgABAaIQdByLIFKAIAIQhByLIFQQA2AgAgCEEBRg0CIAAoArwHIghFBEBByLIFQQA2AgBBxQUQCkHIsgUoAgAhAEHIsgVBADYCACAAQQFHDQIMAwsgDyAIEP8HIAsgB0ECdBD1DBD/ByALEOgJBEBByLIFQQA2AgBBxQUQCkHIsgUoAgAhAEHIsgVBADYCACAAQQFGDQMMAgsgCygCACEJC0HIsgVBADYCACAAQYgEaiADEPgGQciyBSgCACEIQciyBUEANgIAAkACQAJAAkACQAJAAkAgCEEBRwRAQciyBUEANgIAQeIFIABBiARqEA0hEUHIsgUoAgAhCEHIsgVBADYCACAIQQFGDQFByLIFQQA2AgBB8AUgESAAKAK8ByIIIAcgCGogCRAaGkHIsgUoAgAhCEHIsgVBADYCACAIQQFGDQEgBwRAIAAoArwHLQAAQS1GIRALIABB6ANqEIkIIQ0gAEHYA2oQiQghCCAAQcgDahCJCCEKQciyBUEANgIAQZwGIAIgECAAQYgEaiAAQYAEaiAAQfwDaiAAQfgDaiANIAggCiAAQcQDahAfQciyBSgCACECQciyBUEANgIAIAJBAUYNAiAAQcQFNgIkIABBKGpBACAAQSRqEP4HIQ4CfyAHIAAoAsQDIgJKBEAgChCBCCAHIAJrQQF0QQFyagwBCyAKEIEIQQJqCyEMIABBMGohAiAIEIEIIAxqIAAoAsQDaiIMQeUASQ0DIA4gDEECdBD1DBD/ByAOKAIAIgINA0HIsgVBADYCAEHFBRAKQciyBSgCACEHQciyBUEANgIAIAdBAUcNCBAGIQcQBxoMBAsQBiEHEAcaDAkLEAYhBxAHGgwECxAGIQcQBxoMAgsgAygCBCEMQciyBUEANgIAQZ0GIAIgAEEkaiAAQSBqIAwgCSAJIAdBAnRqIBEgECAAQYAEaiAAKAL8AyAAKAL4AyANIAggCiAAKALEAxA3QciyBSgCACEHQciyBUEANgIAIAdBAUcEQEHIsgVBADYCAEGBBiABIAIgACgCJCAAKAIgIAMgBBAWIQdByLIFKAIAIQlByLIFQQA2AgAgCUEBRw0ECxAGIQcQBxoLIA4QgwgLIAoQiQwaIAgQiQwaIA0QiQwaCyAAQYgEahD3BwwDCyAOEIMIIAoQiQwaIAgQiQwaIA0QiQwaIABBiARqEPcHIAsQgwggDxCDCCAAQbAIaiQAIAcPCwALEAYhBxAHGgsgCxCDCCAPEIMIIAcQCAAL2wIBAX8jAEEQayIKJAAgCQJ/IAAEQCACEOAJIQACQCABBEAgCiAAEM4JIAMgCigCADYAACAKIAAQzwkgCCAKEOEJIAoQiQwaDAELIAogABDrCSADIAooAgA2AAAgCiAAEPoHIAggChDhCSAKEIkMGgsgBCAAENEINgIAIAUgABDSCDYCACAKIAAQ0wggBiAKENAJIAoQiQwaIAogABD5ByAHIAoQ4QkgChCJDBogABDRCQwBCyACEOIJIQACQCABBEAgCiAAEM4JIAMgCigCADYAACAKIAAQzwkgCCAKEOEJIAoQiQwaDAELIAogABDrCSADIAooAgA2AAAgCiAAEPoHIAggChDhCSAKEIkMGgsgBCAAENEINgIAIAUgABDSCDYCACAKIAAQ0wggBiAKENAJIAoQiQwaIAogABD5ByAHIAoQ4QkgChCJDBogABDRCQs2AgAgCkEQaiQAC5cGAQp/IwBBEGsiFSQAIAIgADYCACADQYAEcSEXAkADQCAWQQRGBEACQCANEIEIQQFLBEAgFSANENYINgIIIAIgFUEIakEBEOQJIA0Q7wggAigCABDxCTYCAAsgA0GwAXEiD0EQRg0DIA9BIEcNACABIAIoAgA2AgAMAwsFAkAgCCAWaiwAACIPQQRLDQACQAJAAkACQAJAIA9BAWsOBAEDAgQACyABIAIoAgA2AgAMBAsgASACKAIANgIAIAZBIBDNByEPIAIgAigCACIQQQRqNgIAIBAgDzYCAAwDCyANEIQIDQIgDUEAELYIKAIAIQ8gAiACKAIAIhBBBGo2AgAgECAPNgIADAILIAwQhAghDyAXRQ0BIA8NASACIAwQ1gggDBDvCCACKAIAEPEJNgIADAELIAIoAgAhGCAEQQRqIAQgBxsiBCEPA0ACQCAPIAVPDQAgBkGAECAPKAIAEJoHRQ0AIA9BBGohDwwBCwsgDiIQQQFOBEADQAJAIBBBAUgiEQ0AIA8gBE0NACAPQXxqIg8oAgAhESACIAIoAgAiEkEEajYCACASIBE2AgAgEEF/aiEQDAELCyARBH9BAAUgBkEwEM0HCyETIAIoAgAhEQNAIBFBBGohEiAQQQFOBEAgESATNgIAIBBBf2ohECASIREMAQsLIAIgEjYCACARIAk2AgALAkAgBCAPRgRAIAZBMBDNByEQIAIgAigCACIRQQRqIg82AgAgESAQNgIADAELAn9BfyALEIQIDQAaIAtBABCCCCwAAAshE0EAIRBBACEUA0AgBCAPRwRAAkAgECATRwRAIBAhEQwBCyACIAIoAgAiEUEEajYCACARIAo2AgBBACERIBRBAWoiFCALEIEITwRAIBAhEwwBCyALIBQQgggtAABB/wBGBEBBfyETDAELIAsgFBCCCCwAACETCyAPQXxqIg8oAgAhECACIAIoAgAiEkEEajYCACASIBA2AgAgEUEBaiEQDAELCyACKAIAIQ8LIBggDxD0CAsgFkEBaiEWDAELCyABIAA2AgALIBVBEGokAAsRACAAEPMJIAEQ8wkgAhD0CQv8BQEJfyMAQfADayIAJAAgAEHoA2ogAxD4BkHIsgVBADYCAEHiBSAAQegDahANIQxByLIFKAIAIQZByLIFQQA2AgACQAJAAkACQAJAAkACQAJAIAZBAUcEQCAFEIEIBEAgBUEAELYIKAIAIQZByLIFQQA2AgBB/QUgDEEtEBUhB0HIsgUoAgAhCUHIsgVBADYCACAJQQFGDQIgBiAHRiELCyAAQcgDahCJCCEJIABBuANqEIkIIQYgAEGoA2oQiQghB0HIsgVBADYCAEGcBiACIAsgAEHoA2ogAEHgA2ogAEHcA2ogAEHYA2ogCSAGIAcgAEGkA2oQH0HIsgUoAgAhAkHIsgVBADYCACACQQFGDQIgAEHEBTYCBCAAQQhqQQAgAEEEahD+ByEKAn8gBRCBCCAAKAKkA0oEQCAFEIEIIQIgACgCpAMhCCAHEIEIIAIgCGtBAXRqQQFqDAELIAcQgQhBAmoLIQggAEEQaiECIAYQgQggCGogACgCpANqIghB5QBJDQQgCiAIQQJ0EPUMEP8HIAooAgAiAg0EQciyBUEANgIAQcUFEApByLIFKAIAIQVByLIFQQA2AgAgBUEBRg0DAAsQBiEFEAcaDAYLEAYhBRAHGgwFCxAGIQUQBxoMAwsQBiEFEAcaDAELIAMoAgQhCCAFEK8IIQ0gBRCvCCEOIAUQgQghBUHIsgVBADYCAEGdBiACIABBBGogACAIIA0gDiAFQQJ0aiAMIAsgAEHgA2ogACgC3AMgACgC2AMgCSAGIAcgACgCpAMQN0HIsgUoAgAhBUHIsgVBADYCACAFQQFHBEBByLIFQQA2AgBBgQYgASACIAAoAgQgACgCACADIAQQFiEFQciyBSgCACEDQciyBUEANgIAIANBAUcNBAsQBiEFEAcaCyAKEIMICyAHEIkMGiAGEIkMGiAJEIkMGgsgAEHoA2oQ9wcgBRAIAAsgChCDCCAHEIkMGiAGEIkMGiAJEIkMGiAAQegDahD3ByAAQfADaiQAIAULJwEBfyMAQRBrIgEkACABIAA2AgggAUEIaigCACEAIAFBEGokACAACyYBAX8gASAAayIBQQJ1IQMgAQRAIAIgACABEIINCyACIANBAnRqCxYAQX8CfyABEK8IGkH/////BwtBARsL4AIBAX8jAEEgayIBJAAgAUEQahCJCCEEQciyBUEANgIAIAQQ9wkhA0HIsgUoAgAhAkHIsgVBADYCAAJAAkAgAkEBRg0AIAUQrwghAiAFEK8IIQYgBRCBCCEFQciyBUEANgIAQZ8GIAFBCGogAyACIAUgBmoQGhpByLIFKAIAIQVByLIFQQA2AgAgBUEBRg0AIAQQrwghBUHIsgVBADYCAEHIsgUoAgAhAkHIsgVBADYCAAJAIAJBAUcEQCAAEIkIIQJByLIFQQA2AgAgAhD3CSEAQciyBSgCACEDQciyBUEANgIAIANBAUYNASAFEIgNIQNByLIFQQA2AgBBoQYgASAAIAUgAyAFahAaGkHIsgUoAgAhBUHIsgVBADYCACAFQQFGDQEgBBCJDBogAUEgaiQADwsQBiEBEAcaDAILEAYhARAHGiACEIkMGgwBCxAGIQEQBxoLIAQQiQwaIAEQCAALJQEBfyMAQRBrIgEkACABQQhqIAAQ2ggoAgAhACABQRBqJAAgAAtAACMAQRBrIgAkACAAIAE2AggDQCACIANJBEAgAEEIaiACEPkJIAJBAWohAgwBCwsgACgCCCECIABBEGokACACCw8AIAAoAgAgASwAABCTDAvRAwECfyMAQSBrIgEkACABQRBqEIkIIQZByLIFQQA2AgAgAUEIahD7CSEEQciyBSgCACECQciyBUEANgIAAkACQAJAIAJBAUcEQEHIsgVBADYCACAGEPcJIQJByLIFKAIAIQNByLIFQQA2AgAgA0EBRg0BIAUQrwghAyAFEK8IIQcgBRCBCCEFQciyBUEANgIAQaMGIAQgAiADIAcgBUECdGoQGhpByLIFKAIAIQVByLIFQQA2AgAgBUEBRg0BIAYQrwghBUHIsgVBADYCAEHIsgUoAgAhAkHIsgVBADYCACACQQFHDQIQBiEBEAcaDAMLEAYhARAHGgwCCxAGIQEQBxoMAQsgABCJCCEEQciyBUEANgIAIAFBCGoQ/QkhAkHIsgUoAgAhAEHIsgVBADYCAAJAAkAgAEEBRwRAQciyBUEANgIAIAQQ9wkhAEHIsgUoAgAhA0HIsgVBADYCACADQQFGDQEgBRCIDSEDQciyBUEANgIAQaYGIAIgACAFIAMgBWoQGhpByLIFKAIAIQVByLIFQQA2AgAgBUEBRg0BIAYQiQwaIAFBIGokAA8LEAYhARAHGgwBCxAGIQEQBxoLIAQQiQwaCyAGEIkMGiABEAgACxIAIAAQ/wkgAEHczAM2AgAgAAu0AQECfyMAQUBqIgQkACAEIAE2AjggBEEwaiEFAkADQCACIANJBEAgBCACNgIIIAAgBEEwaiACIAMgBEEIaiAEQRBqIAUgBEEMaiAAKAIAKAIMEQ4AQQJGDQIgBEEQaiEBIAQoAgggAkYNAgNAIAEgBCgCDE8EQCAEKAIIIQIMAwUgBEE4aiABEPkJIAFBAWohAQwBCwAACwALCyAEKAI4IQEgBEFAayQAIAEPC0H0xwMQtwkACxIAIAAQ/wkgAEG8zQM2AgAgAAvZAQECfyMAQaABayIEJAAgBCABNgKYASAEQZABaiEFAkADQCACIANJBEAgBCACNgIIIAAgBEGQAWogAiACQSBqIAMgAyACa0EgShsgBEEIaiAEQRBqIAUgBEEMaiAAKAIAKAIQEQ4AQQJGDQIgBEEQaiEBIAQoAgggAkYNAgNAIAEgBCgCDE8EQCAEKAIIIQIMAwUgBCABKAIANgIEIAQoApgBIARBBGooAgAQnAwgAUEEaiEBDAELAAALAAsLIAQoApgBIQEgBEGgAWokACABDwtB9McDELcJAAsRACAAEIIKGiAAQejLAzYCAAuHAQEDfyAAQbjEAzYCACAAKAIIIQFByLIFQQA2AgBB3gUQGyECQciyBSgCACEDQciyBUEANgIAAkAgA0EBRwRAIAEgAkYNASAAKAIIIQFByLIFQQA2AgAgARDZB0HIsgUoAgAhAUHIsgVBADYCACABQQFHDQELQQAQCyEBEAcaIAEQhAEACyAAC/wSAQR/QeDABRCCChpB4MAFQfDDAzYCAEHIsgVBADYCAEGoBkHwwAVBHBAVIQFByLIFKAIAIQBByLIFQQA2AgACQAJAAkACQCAAQQFHBEBByLIFQQA2AgBBqQZBkMIFQeXDAxAVIQJByLIFKAIAIQBByLIFQQA2AgAgAEEBRg0BIAEiABC2CiEDIAAQtwogACADELgKQaC+BRCCChpBoL4FQcDQAzYCAEHIsgVBADYCAEGqBkHgwAVBoL4FEAVByLIFKAIAIQBByLIFQQA2AgAgAEEBRg0CQai+BRCCChpBqL4FQeDQAzYCAEHIsgVBADYCAEGrBkHgwAVBqL4FEAVByLIFKAIAIQBByLIFQQA2AgAgAEEBRg0CELsKQciyBUEANgIAQawGQeDABUGwvgUQBUHIsgUoAgAhAEHIsgVBADYCACAAQQFGDQJByLIFQQA2AgAQvApByLIFKAIAIQBByLIFQQA2AgAgAEEBRg0CQciyBUEANgIAQa4GQeDABUHAvgUQBUHIsgUoAgAhAEHIsgVBADYCACAAQQFGDQJByLIFQQA2AgAQvQpByLIFKAIAIQBByLIFQQA2AgAgAEEBRg0CQciyBUEANgIAQbAGQeDABUHIvgUQBUHIsgUoAgAhAEHIsgVBADYCACAAQQFGDQJByLIFQQA2AgBBsQYQCkHIsgUoAgAhAEHIsgVBADYCACAAQQFGDQJByLIFQQA2AgBBsgZB4MAFQdC+BRAFQciyBSgCACEAQciyBUEANgIAIABBAUYNAkHIsgVBADYCABC/CkHIsgUoAgAhAEHIsgVBADYCACAAQQFGDQJByLIFQQA2AgBBtAZB4MAFQeC+BRAFQciyBSgCACEAQciyBUEANgIAIABBAUYNAkHIsgVBADYCAEHovgUQ/wlByLIFKAIAIQBByLIFQQA2AgAgAEEBRg0CQciyBUEANgIAQbYGQeDABUHovgUQBUHIsgUoAgAhAEHIsgVBADYCACAAQQFGDQJB8L4FEIIKGkH4vgVBrtgAOwEAQfC+BUHoxAM2AgBB/L4FEIkIGkHIsgVBADYCAEG3BkHgwAVB8L4FEAVByLIFKAIAIQBByLIFQQA2AgAgAEEBRg0CQZC/BRCCChpBmL8FQq6AgIDABTcCAEGQvwVBkMUDNgIAQaC/BRCJCBpByLIFQQA2AgBBuAZB4MAFQZC/BRAFQciyBSgCACEAQciyBUEANgIAIABBAUYNAkGwvwUQggoaQbC/BUGA0QM2AgBByLIFQQA2AgBBuQZB4MAFQbC/BRAFQciyBSgCACEAQciyBUEANgIAIABBAUYNAkG4vwUQggoaQbi/BUH00gM2AgBByLIFQQA2AgBBugZB4MAFQbi/BRAFQciyBSgCACEAQciyBUEANgIAIABBAUYNAkHAvwUQggoaQcC/BUHI1AM2AgBByLIFQQA2AgBBuwZB4MAFQcC/BRAFQciyBSgCACEAQciyBUEANgIAIABBAUYNAkHIvwUQggoaQci/BUGw1gM2AgBByLIFQQA2AgBBvAZB4MAFQci/BRAFQciyBSgCACEAQciyBUEANgIAIABBAUYNAkHIsgVBADYCABDACkHIsgUoAgAhAEHIsgVBADYCACAAQQFGDQJByLIFQQA2AgBBvgZB4MAFQdC/BRAFQciyBSgCACEAQciyBUEANgIAIABBAUYNAkHIsgVBADYCABDBCkHIsgUoAgAhAEHIsgVBADYCACAAQQFGDQJByLIFQQA2AgBBwAZB4MAFQdi/BRAFQciyBSgCACEAQciyBUEANgIAIABBAUYNAkHIsgVBADYCABDCCkHIsgUoAgAhAEHIsgVBADYCACAAQQFGDQJByLIFQQA2AgBBwgZB4MAFQeC/BRAFQciyBSgCACEAQciyBUEANgIAIABBAUYNAkHIsgVBADYCABDDCkHIsgUoAgAhAEHIsgVBADYCACAAQQFGDQJByLIFQQA2AgBBxAZB4MAFQei/BRAFQciyBSgCACEAQciyBUEANgIAIABBAUYNAkHIsgVBADYCABDECkHIsgUoAgAhAEHIsgVBADYCACAAQQFGDQJByLIFQQA2AgBBxgZB4MAFQfC/BRAFQciyBSgCACEAQciyBUEANgIAIABBAUYNAkHIsgVBADYCABDFCkHIsgUoAgAhAEHIsgVBADYCACAAQQFGDQJByLIFQQA2AgBByAZB4MAFQfi/BRAFQciyBSgCACEAQciyBUEANgIAIABBAUYNAkHIsgVBADYCABDGCkHIsgUoAgAhAEHIsgVBADYCACAAQQFGDQJByLIFQQA2AgBBygZB4MAFQYDABRAFQciyBSgCACEAQciyBUEANgIAIABBAUYNAkHIsgVBADYCABDHCkHIsgUoAgAhAEHIsgVBADYCACAAQQFGDQJByLIFQQA2AgBBzAZB4MAFQYjABRAFQciyBSgCACEAQciyBUEANgIAIABBAUYNAkGQwAUQggoaQZjABUH08QM2AgBBkMAFQfjXAzYCAEGYwAVBqNgDNgIAQciyBUEANgIAQc0GQeDABUGQwAUQBUHIsgUoAgAhAEHIsgVBADYCACAAQQFGDQJBoMAFEIIKGkGowAVBmPIDNgIAQaDABUGA2gM2AgBBqMAFQbDaAzYCAEHIsgVBADYCAEHOBkHgwAVBoMAFEAVByLIFKAIAIQBByLIFQQA2AgAgAEEBRg0CQciyBUEANgIAQc8GEApByLIFKAIAIQBByLIFQQA2AgAgAEEBRg0CQciyBUEANgIAQdAGQeDABUGwwAUQBUHIsgUoAgAhAEHIsgVBADYCACAAQQFGDQJByLIFQQA2AgBB0QYQCkHIsgUoAgAhAEHIsgVBADYCACAAQQFGDQJByLIFQQA2AgBB0gZB4MAFQcDABRAFQciyBSgCACEAQciyBUEANgIAIABBAUYNAkHIsgVBADYCABDKCkHIsgUoAgAhAEHIsgVBADYCACAAQQFGDQJByLIFQQA2AgBB1AZB4MAFQdDABRAFQciyBSgCACEAQciyBUEANgIAIABBAUYNAkHIsgVBADYCABDLCkHIsgUoAgAhAEHIsgVBADYCACAAQQFGDQJByLIFQQA2AgBB1gZB4MAFQdjABRAFQciyBSgCACEAQciyBUEANgIAIABBAUYNAg8LEAYhABAHGgwDCxAGIQAQBxoMAQsQBiEAEAcaIAIQiQwaCyABELEKCyAAEAgACx0AIABBADYCBCAAQbzyAzYCACAAQZTIAzYCACAAC30BAn8gABCyCiECAkAgAUUNAEHIsgVBADYCAEHXBiAAIAEQBUHIsgUoAgAhA0HIsgVBADYCACADQQFHBEBByLIFQQA2AgBB2AYgACABEAVByLIFKAIAIQFByLIFQQA2AgAgAUEBRw0BCxAGIQAQBxogAhC1CiAAEAgACyAACxAAIAAgAUHosgUQuQoQugoLEAAgACABQfCyBRC5ChC6CgsQACAAIAFBtLQFELkKELoKCwUAELwKCxAAIAAgAUGstAUQuQoQugoLBQAQvQoLEAAgACABQby0BRC5ChC6CgsFABC+CgsQACAAIAFBxLQFELkKELoKCwUAEL8KCxAAIAAgAUHMtAUQuQoQugoLCQBB6L4FEP8JCxAAIAAgAUHUtAUQuQoQugoLEAAgACABQdy0BRC5ChC6CgsQACAAIAFB5LQFELkKELoKCxAAIAAgAUH4sgUQuQoQugoLEAAgACABQYCzBRC5ChC6CgsQACAAIAFBiLMFELkKELoKCxAAIAAgAUGQswUQuQoQugoLBQAQwAoLEAAgACABQbizBRC5ChC6CgsFABDBCgsQACAAIAFBwLMFELkKELoKCwUAEMIKCxAAIAAgAUHIswUQuQoQugoLBQAQwwoLEAAgACABQdCzBRC5ChC6CgsFABDECgsQACAAIAFB2LMFELkKELoKCwUAEMUKCxAAIAAgAUHgswUQuQoQugoLBQAQxgoLEAAgACABQeizBRC5ChC6CgsFABDHCgsQACAAIAFB8LMFELkKELoKCxAAIAAgAUGYswUQuQoQugoLEAAgACABQaCzBRC5ChC6CgsFABDICgsQACAAIAFBqLMFELkKELoKCwUAEMkKCxAAIAAgAUGwswUQuQoQugoLBQAQygoLEAAgACABQfizBRC5ChC6CgsFABDLCgsQACAAIAFBgLQFELkKELoKCwwAIAAQzAogABC1CgtqAQJ/IwBBEGsiASQAIABCADcDACABQQA2AgxByLIFQQA2AgAgAEEQaiABQQxqIAFBCGoQ1AsaQciyBSgCACECQciyBUEANgIAIAJBAUcEQCABQRBqJAAgAA8LQQAQCyEAEAcaIAAQhAEAC0ABAX8gABDVCyABSQRAEKkMAAsgACAAEGIgARDWCyICNgIAIAAgAjYCBCAAEFogAiABQQJ0ajYCACAAQQAQ1wsLjwEBAn8jAEEQayIDJAAgAyAAIAEQ2AsiASgCBCECAkADQCACIAEoAghGDQEgABBiGiABKAIEIQJByLIFQQA2AgAgAhDfC0HIsgUoAgAhAkHIsgVBADYCACACQQFHBEAgASABKAIEQQRqIgI2AgQMAQsLEAYhAhAHGiABENoLIAIQCAALIAEQ2gsgA0EQaiQACyAAIAAoAgAEQCAAELcKIAAQYiAAKAIAIAAQ2wsQ3AsLCxAAIAAoAgQgACgCAGtBAnULDAAgACAAKAIAEOALCywAIAAoAgAaIAAoAgAgABDbC0ECdGoaIAAoAgAaIAAoAgAgABC2CkECdGoaC1kBAn8jAEEgayIBJAAgAUEANgIMIAFB2wY2AgggASABKQMINwMAIAACfyABQRBqIgIgASkCADcCBCACIAA2AgAgAgsQ4AogACgCBCEAIAFBIGokACAAQX9qC6oBAQJ/IwBBEGsiBCQAIAEQzwogBEEIaiABENMKIQMCQCAAQRBqIgEQtgogAk0EQEHIsgVBADYCAEHcBiABIAJBAWoQBUHIsgUoAgAhAEHIsgVBADYCACAAQQFGDQELIAEgAhDOCigCAARAIAEgAhDOCigCABDQCgsgAxDVCSEAIAEgAhDOCiAANgIAIAMQ1QogBEEQaiQADwsQBiECEAcaIAMQ1QogAhAIAAsxAEGwvgUQggoaQby+BUEAOgAAQbi+BUEANgIAQbC+BUGExAM2AgBBuL4FEOQKNgIACxUAQcC+BRCCChpBwL4FQczIAzYCAAsVAEHIvgUQggoaQci+BUHgyQM2AgALVwECf0HQvgUQggoaQdC+BUG4xAM2AgBByLIFQQA2AgBB3gUQGyEAQciyBSgCACEBQciyBUEANgIAIAFBAUcEQEHYvgUgADYCAA8LEAYhABAHGiAAEAgACxUAQeC+BRCCChpB4L4FQfTKAzYCAAsVAEHQvwUQggoaQdC/BUGI3gM2AgALFQBB2L8FEIIKGkHYvwVBnN8DNgIACxUAQeC/BRCCChpB4L8FQZDgAzYCAAsVAEHovwUQggoaQei/BUGE4QM2AgALFQBB8L8FEIIKGkHwvwVB+OEDNgIACxUAQfi/BRCCChpB+L8FQZzjAzYCAAsVAEGAwAUQggoaQYDABUHA5AM2AgALFQBBiMAFEIIKGkGIwAVB5OUDNgIAC1EBAX9BsMAFEIIKGkHIsgVBADYCAEHdBkG4wAUQDRpByLIFKAIAIQBByLIFQQA2AgAgAEEBRwRAQbDABUHs2wM2AgAPCxAGIQAQBxogABAIAAtRAQF/QcDABRCCChpByLIFQQA2AgBB3QZByMAFEA0aQciyBSgCACEAQciyBUEANgIAIABBAUcEQEHAwAVBiN0DNgIADwsQBiEAEAcaIAAQCAALFQBB0MAFEIIKGkHQwAVBiOcDNgIACxUAQdjABRCCChpB2MAFQYDoAzYCAAs1ACAAKAIAGiAAKAIAIAAQ2wtBAnRqGiAAKAIAIAAQtgpBAnRqGiAAKAIAIAAQ2wtBAnRqGgt1AQF/AkACQEGYtAUtAABBAXENAEGYtAUQqwxFDQBByLIFQQA2AgBB3gYQGxpByLIFKAIAIQBByLIFQQA2AgAgAEEBRg0BQZS0BUGQtAU2AgBBmLQFEK8MC0GUtAUoAgAPCxAGIQAQBxpBmLQFELEMIAAQCAALDQAgACgCACABQQJ0agsUACAAQQRqIgAgACgCAEEBajYCAAsjACAAQQRqENIKQX9GBH8gACAAKAIAKAIIEQEAQQAFQQALGgsUABCBCkGQtAVB4MAFNgIAQZC0BQsTACAAIAAoAgBBf2oiADYCACAACycBAX8jAEEQayICJAAgAiABNgIMIAAgAkEMahDOByACQRBqJAAgAAtGAQF/IAAQtgoiAiABSQRAIAAgASACaxDYCg8LIAIgAUsEQCAAKAIAIAFBAnRqIQEgABC2CiECIAAgARDgCyAAIAIQuAoLCxwBAX8gACgCACEBIABBADYCACABBEAgARDQCgsLVgECfyAAQfDDAzYCACAAQRBqIQEDQCACIAEQtgpJBEAgASACEM4KKAIABEAgASACEM4KKAIAENAKCyACQQFqIQIMAQsLIABBsAFqEIkMGiABELEKIAALCgAgABDWChD2DAvKAQECfyMAQSBrIgMkAAJAAkAgABBaKAIAIAAoAgRrQQJ1IAFPBEAgACABELQKDAELIAAQYiECIANBCGogACAAELYKIAFqEOkLIAAQtgogAhDqCyECQciyBUEANgIAQd8GIAIgARAFQciyBSgCACEBQciyBUEANgIAIAFBAUYNAUHIsgVBADYCAEHgBiAAIAIQBUHIsgUoAgAhAEHIsgVBADYCACAAQQFGDQEgAhDtCwsgA0EgaiQADwsQBiEAEAcaIAIQ7QsgABAIAAskAQF/IABBEGoiABC2CiABSwR/IAAgARDOCigCAEEARwUgAgsLEQBBnLQFEM0KENsKGkGctAULFQAgACABKAIAIgE2AgAgARDPCiAAC3UBAX8CQAJAQaS0BS0AAEEBcQ0AQaS0BRCrDEUNAEHIsgVBADYCAEHhBhAbGkHIsgUoAgAhAEHIsgVBADYCACAAQQFGDQFBoLQFQZy0BTYCAEGktAUQrwwLQaC0BSgCAA8LEAYhABAHGkGktAUQsQwgABAIAAtPAQJ/QciyBUEANgIAQeIGEBshAUHIsgUoAgAhAkHIsgVBADYCACACQQFHBEAgACABKAIAIgE2AgAgARDPCg8LQQAQCyEAEAcaIAAQhAEACw8AIAAoAgAgARC5ChDZCgsfACAAAn9BqLQFQai0BSgCAEEBaiIANgIAIAALNgIECz4BAn8jAEEQayICJAAgACgCAEF/RwRAIAICfyACQQhqIgMgARDaCBogAwsQ2ggaIAAgAhD8CwsgAkEQaiQACxQAIAAEQCAAIAAoAgAoAgQRAQALCw0AIAAoAgAoAgAQ9AsLJABBACEAIAJB/wBNBH8Q5AogAkEBdGovAQAgAXFBAEcFIAALCz4BAX9ByLIFQQA2AgBByLIFKAIAIQBByLIFQQA2AgAgAEEBRwRAQZyjAygCAA8LQQAQCyEAEAcaIAAQhAEAC0cAA0AgASACRkUEQEEAIQAgAyABKAIAQf8ATQR/EOQKIAEoAgBBAXRqLwEABSAACzsBACADQQJqIQMgAUEEaiEBDAELCyACC0EAA0ACQCACIANHBH8gAigCAEH/AEsNARDkCiACKAIAQQF0ai8BACABcUUNASACBSADCw8LIAJBBGohAgwAAAsAC0EAAkADQCACIANGDQECQCACKAIAQf8ASw0AEOQKIAIoAgBBAXRqLwEAIAFxRQ0AIAJBBGohAgwBCwsgAiEDCyADCxoAIAFB/wBNBH8Q6QogAUECdGooAgAFIAELCz4BAX9ByLIFQQA2AgBByLIFKAIAIQBByLIFQQA2AgAgAEEBRwRAQaCpAygCAA8LQQAQCyEAEAcaIAAQhAEACz4AA0AgASACRkUEQCABIAEoAgAiAEH/AE0EfxDpCiABKAIAQQJ0aigCAAUgAAs2AgAgAUEEaiEBDAELCyACCxoAIAFB/wBNBH8Q7AogAUECdGooAgAFIAELCz4BAX9ByLIFQQA2AgBByLIFKAIAIQBByLIFQQA2AgAgAEEBRwRAQbC1AygCAA8LQQAQCyEAEAcaIAAQhAEACz4AA0AgASACRkUEQCABIAEoAgAiAEH/AE0EfxDsCiABKAIAQQJ0aigCAAUgAAs2AgAgAUEEaiEBDAELCyACCwQAIAELKgADQCABIAJGRQRAIAMgASwAADYCACADQQRqIQMgAUEBaiEBDAELCyACCxMAIAEgAiABQYABSRtBGHRBGHULNQADQCABIAJGRQRAIAQgASgCACIAIAMgAEGAAUkbOgAAIARBAWohBCABQQRqIQEMAQsLIAILKQEBfyAAQYTEAzYCAAJAIAAoAggiAUUNACAALQAMRQ0AIAEQ9gwLIAALCgAgABDyChD2DAsjACABQQBOBH8Q6QogAUH/AXFBAnRqKAIABSABC0EYdEEYdQs9AANAIAEgAkZFBEAgASABLAAAIgBBAE4EfxDpCiABLAAAQQJ0aigCAAUgAAs6AAAgAUEBaiEBDAELCyACCyMAIAFBAE4EfxDsCiABQf8BcUECdGooAgAFIAELQRh0QRh1Cz0AA0AgASACRkUEQCABIAEsAAAiAEEATgR/EOwKIAEsAABBAnRqKAIABSAACzoAACABQQFqIQEMAQsLIAILKgADQCABIAJGRQRAIAMgAS0AADoAACADQQFqIQMgAUEBaiEBDAELCyACCwwAIAEgAiABQX9KGws0AANAIAEgAkZFBEAgBCABLAAAIgAgAyAAQX9KGzoAACAEQQFqIQQgAUEBaiEBDAELCyACCxIAIAQgAjYCACAHIAU2AgBBAwsLACAEIAI2AgBBAws3ACMAQRBrIgAkACAAIAQ2AgwgACADIAJrNgIIIABBDGogAEEIahD+CigCACEDIABBEGokACADCwkAIAAgARD/CgskAQJ/IwBBEGsiAiQAIAEgABDIByEDIAJBEGokACABIAAgAxsLCgAgABCAChD2DAvnAwEFfyMAQRBrIgkkACACIQgDQAJAIAMgCEYEQCADIQgMAQsgCCgCAEUNACAIQQRqIQgMAQsLIAcgBTYCACAEIAI2AgBBASEKA0ACQAJAAkAgBSAGRg0AIAIgA0YNACAJIAEpAgA3AwgCQAJAAkAgBSAEIAggAmtBAnUgBiAFayABIAAoAggQggsiC0EBaiIMQQFNBEAgDEEBa0UNBSAHIAU2AgADQAJAIAIgBCgCAEYNACAFIAIoAgAgCUEIaiAAKAIIEIMLIghBf0YNACAHIAcoAgAgCGoiBTYCACACQQRqIQIMAQsLIAQgAjYCAAwBCyAHIAcoAgAgC2oiBTYCACAFIAZGDQIgAyAIRgRAIAQoAgAhAiADIQgMBwsgCUEEakEAIAEgACgCCBCDCyIIQX9HDQELQQIhCgwDCyAJQQRqIQUgCCAGIAcoAgBrSwRADAMLA0AgCARAIAUtAAAhAiAHIAcoAgAiC0EBajYCACALIAI6AAAgCEF/aiEIIAVBAWohBQwBCwsgBCAEKAIAQQRqIgI2AgAgAiEIA0AgAyAIRgRAIAMhCAwFCyAIKAIARQ0EIAhBBGohCAwAAAsACyAEKAIAIQILIAIgA0chCgsgCUEQaiQAIAoPCyAHKAIAIQUMAAALAAt1AQF/IwBBEGsiBiQAIAYgBTYCDCAGQQhqIAZBDGoQsQghBUHIsgVBADYCACAAIAEgAiADIAQQ3wchAEHIsgUoAgAhAUHIsgVBADYCACABQQFHBEAgBRCyCCAGQRBqJAAgAA8LEAYhBhAHGiAFELIIIAYQCAALcQEBfyMAQRBrIgQkACAEIAM2AgwgBEEIaiAEQQxqELEIIQNByLIFQQA2AgAgACABIAIQoAYhAEHIsgUoAgAhAUHIsgVBADYCACABQQFHBEAgAxCyCCAEQRBqJAAgAA8LEAYhBBAHGiADELIIIAQQCAALwAMBA38jAEEQayIJJAAgAiEIA0ACQCADIAhGBEAgAyEIDAELIAgtAABFDQAgCEEBaiEIDAELCyAHIAU2AgAgBCACNgIAA0ACQAJ/AkAgBSAGRg0AIAIgA0YNACAJIAEpAgA3AwgCQAJAAkACQCAFIAQgCCACayAGIAVrQQJ1IAEgACgCCBCFCyIKQX9GBEADQAJAIAcgBTYCACACIAQoAgBGDQACQCAFIAIgCCACayAJQQhqIAAoAggQhgsiBUECaiIGQQJLDQBBASEFAkAgBkEBaw4CAAEHCyAEIAI2AgAMBAsgAiAFaiECIAcoAgBBBGohBQwBCwsgBCACNgIADAULIAcgBygCACAKQQJ0aiIFNgIAIAUgBkYNAyAEKAIAIQIgAyAIRgRAIAMhCAwICyAFIAJBASABIAAoAggQhgtFDQELQQIMBAsgByAHKAIAQQRqNgIAIAQgBCgCAEEBaiICNgIAIAIhCANAIAMgCEYEQCADIQgMBgsgCC0AAEUNBSAIQQFqIQgMAAALAAsgBCACNgIAQQEMAgsgBCgCACECCyACIANHCyEIIAlBEGokACAIDwsgBygCACEFDAAACwALdQEBfyMAQRBrIgYkACAGIAU2AgwgBkEIaiAGQQxqELEIIQVByLIFQQA2AgAgACABIAIgAyAEEOEHIQBByLIFKAIAIQFByLIFQQA2AgAgAUEBRwRAIAUQsgggBkEQaiQAIAAPCxAGIQYQBxogBRCyCCAGEAgAC3MBAX8jAEEQayIFJAAgBSAENgIMIAVBCGogBUEMahCxCCEEQciyBUEANgIAIAAgASACIAMQtQYhAEHIsgUoAgAhAUHIsgVBADYCACABQQFHBEAgBBCyCCAFQRBqJAAgAA8LEAYhBRAHGiAEELIIIAUQCAALlAEBAX8jAEEQayIFJAAgBCACNgIAAn9BAiAFQQxqQQAgASAAKAIIEIMLIgFBAWpBAkkNABpBASABQX9qIgEgAyAEKAIAa0sNABogBUEMaiECA38gAQR/IAItAAAhACAEIAQoAgAiA0EBajYCACADIAA6AAAgAUF/aiEBIAJBAWohAgwBBUEACwsLIQIgBUEQaiQAIAILmgEBAn8gACgCCCEBQciyBUEANgIAQesGQQBBAEEEIAEQGiEBQciyBSgCACECQciyBUEANgIAAkAgAkEBRg0AQX8hAgJAIAEEfyACBSAAKAIIIgANAUEBCw8LQciyBUEANgIAQewGIAAQDSEAQciyBSgCACEBQciyBUEANgIAIAFBAUYNACAAQQFGDwtBABALIQAQBxogABCEAQALcQEBfyMAQRBrIgQkACAEIAM2AgwgBEEIaiAEQQxqELEIIQNByLIFQQA2AgAgACABIAIQ4gchAEHIsgUoAgAhAUHIsgVBADYCACABQQFHBEAgAxCyCCAEQRBqJAAgAA8LEAYhBBAHGiADELIIIAQQCAALawEDfyMAQRBrIgEkACABIAA2AgwgAUEIaiABQQxqELEIIQBByLIFQQA2AgAQ4wchAkHIsgUoAgAhA0HIsgVBADYCACADQQFHBEAgABCyCCABQRBqJAAgAg8LEAYhARAHGiAAELIIIAEQCAALWgEEfwNAAkAgAiADRg0AIAYgBE8NACACIAMgAmsgASAAKAIIEIwLIgdBAmoiCEECTQRAQQEhByAIQQJrDQELIAZBAWohBiAFIAdqIQUgAiAHaiECDAELCyAFC3EBAX8jAEEQayIEJAAgBCADNgIMIARBCGogBEEMahCxCCEDQciyBUEANgIAIAAgASACEOQHIQBByLIFKAIAIQFByLIFQQA2AgAgAUEBRwRAIAMQsgggBEEQaiQAIAAPCxAGIQQQBxogAxCyCCAEEAgAC1ABAX8gACgCCCIARQRAQQEPC0HIsgVBADYCAEHsBiAAEA0hAEHIsgUoAgAhAUHIsgVBADYCACABQQFHBEAgAA8LQQAQCyEAEAcaIAAQhAEAC00AIwBBEGsiACQAIAAgAjYCDCAAIAU2AgggAiADIABBDGogBSAGIABBCGoQjwshBSAEIAAoAgw2AgAgByAAKAIINgIAIABBEGokACAFC78FAQJ/IAIgADYCACAFIAM2AgAgAigCACEGAkACQANAIAYgAU8EQEEAIQAMAwtBAiEAIAYvAQAiA0H//8MASw0CAkACQCADQf8ATQRAQQEhACAEIAUoAgAiBmtBAUgNBSAFIAZBAWo2AgAgBiADOgAADAELIANB/w9NBEAgBCAFKAIAIgZrQQJIDQQgBSAGQQFqNgIAIAYgA0EGdkHAAXI6AAAgBSAFKAIAIgZBAWo2AgAgBiADQT9xQYABcjoAAAwBCyADQf+vA00EQCAEIAUoAgAiBmtBA0gNBCAFIAZBAWo2AgAgBiADQQx2QeABcjoAACAFIAUoAgAiBkEBajYCACAGIANBBnZBP3FBgAFyOgAAIAUgBSgCACIGQQFqNgIAIAYgA0E/cUGAAXI6AAAMAQsgA0H/twNNBEBBASEAIAEgBmtBBEgNBSAGLwECIgdBgPgDcUGAuANHDQIgBCAFKAIAa0EESA0FIAdB/wdxIANBCnRBgPgDcSADQcAHcSIAQQp0cnJBgIAEakH//8MASw0CIAIgBkECajYCACAFIAUoAgAiBkEBajYCACAGIABBBnZBAWoiAEECdkHwAXI6AAAgBSAFKAIAIgZBAWo2AgAgBiAAQQR0QTBxIANBAnZBD3FyQYABcjoAACAFIAUoAgAiBkEBajYCACAGIAdBBnZBD3EgA0EEdEEwcXJBgAFyOgAAIAUgBSgCACIDQQFqNgIAIAMgB0E/cUGAAXI6AAAMAQsgA0GAwANJDQQgBCAFKAIAIgZrQQNIDQMgBSAGQQFqNgIAIAYgA0EMdkHgAXI6AAAgBSAFKAIAIgZBAWo2AgAgBiADQQZ2QT9xQYABcjoAACAFIAUoAgAiBkEBajYCACAGIANBP3FBgAFyOgAACyACIAIoAgBBAmoiBjYCAAwBCwtBAg8LQQEPCyAAC00AIwBBEGsiACQAIAAgAjYCDCAAIAU2AgggAiADIABBDGogBSAGIABBCGoQkQshBSAEIAAoAgw2AgAgByAAKAIINgIAIABBEGokACAFC58FAQV/IAIgADYCACAFIAM2AgACQANAIAIoAgAiAyABTwRAQQAhCQwCC0EBIQkgBSgCACIAIARPDQECQCADLQAAIgZB///DAEsNACACAn8gBkEYdEEYdUEATgRAIAAgBjsBACADQQFqDAELIAZBwgFJDQEgBkHfAU0EQCABIANrQQJIDQQgAy0AASIHQcABcUGAAUcNAkECIQkgB0E/cSAGQQZ0QcAPcXIiBkH//8MASw0EIAAgBjsBACADQQJqDAELIAZB7wFNBEAgASADa0EDSA0EIAMtAAIhCCADLQABIQcCQAJAIAZB7QFHBEAgBkHgAUcNASAHQeABcUGgAUcNBQwCCyAHQeABcUGAAUcNBAwBCyAHQcABcUGAAUcNAwsgCEHAAXFBgAFHDQJBAiEJIAhBP3EgB0E/cUEGdCAGQQx0cnIiBkH//wNxQf//wwBLDQQgACAGOwEAIANBA2oMAQsgBkH0AUsNASABIANrQQRIDQMgAy0AAyEIIAMtAAIhByADLQABIQMCQAJAIAZBkH5qIgpBBEsNAAJAAkAgCkEBaw4EAgICAQALIANB8ABqQf8BcUEwTw0EDAILIANB8AFxQYABRw0DDAELIANBwAFxQYABRw0CCyAHQcABcUGAAUcNASAIQcABcUGAAUcNASAEIABrQQRIDQNBAiEJIAhBP3EiCCAHQQZ0IgpBwB9xIANBDHRBgOAPcSAGQQdxIgZBEnRycnJB///DAEsNAyAAIANBAnQiA0HAAXEgBkEIdHIgB0EEdkEDcSADQTxxcnJBwP8AakGAsANyOwEAIAUgAEECajYCACAAIApBwAdxIAhyQYC4A3I7AQIgAigCAEEEags2AgAgBSAFKAIAQQJqNgIADAELC0ECDwsgCQsLACACIAMgBBCTCwuCBAEHfyAAIQMDQAJAIAYgAk8NACADIAFPDQAgAy0AACIEQf//wwBLDQACfyADQQFqIARBGHRBGHVBAE4NABogBEHCAUkNASAEQd8BTQRAIAEgA2tBAkgNAiADLQABIgVBwAFxQYABRw0CIAVBP3EgBEEGdEHAD3FyQf//wwBLDQIgA0ECagwBCwJAAkACQAJAAkAgBEHvAU0EQCABIANrQQNIDQcgAy0AAiEHIAMtAAEhBSAEQe0BRg0BIARB4AFGBEAgBUHgAXFBoAFGDQYMCAsgBUHAAXFBgAFHDQcMBQsgBEH0AUsNBiACIAZrQQJJDQYgASADa0EESA0GIAMtAAMhCCADLQACIQcgAy0AASEFAkAgBEGQfmoiCUEESw0AIAlBAWsOBAAAAAMCCyAFQcABcUGAAUcNBgwDCyAFQeABcUGAAUYNAwwFCyAFQfAAakH/AXFBMEkNAQwECyAFQfABcUGAAUcNAwsgB0HAAXFBgAFHDQIgCEHAAXFBgAFHDQIgCEE/cSAHQQZ0QcAfcSAEQRJ0QYCA8ABxIAVBP3FBDHRycnJB///DAEsNAiAGQQFqIQYgA0EEagwBCyAHQcABcUGAAUcNASAHQT9xIARBDHRBgOADcSAFQT9xQQZ0cnJB///DAEsNASADQQNqCyEDIAZBAWohBgwBCwsgAyAAawtNACMAQRBrIgAkACAAIAI2AgwgACAFNgIIIAIgAyAAQQxqIAUgBiAAQQhqEJULIQUgBCAAKAIMNgIAIAcgACgCCDYCACAAQRBqJAAgBQvXAwEBfyACIAA2AgAgBSADNgIAIAIoAgAhAwJAA0AgAyABTwRAQQAhBgwCC0ECIQYgAygCACIDQf//wwBLDQEgA0GAcHFBgLADRg0BAkACQCADQf8ATQRAQQEhBiAEIAUoAgAiAGtBAUgNBCAFIABBAWo2AgAgACADOgAADAELIANB/w9NBEAgBCAFKAIAIgZrQQJIDQIgBSAGQQFqNgIAIAYgA0EGdkHAAXI6AAAgBSAFKAIAIgZBAWo2AgAgBiADQT9xQYABcjoAAAwBCyAEIAUoAgAiBmshACADQf//A00EQCAAQQNIDQIgBSAGQQFqNgIAIAYgA0EMdkHgAXI6AAAgBSAFKAIAIgZBAWo2AgAgBiADQQZ2QT9xQYABcjoAACAFIAUoAgAiBkEBajYCACAGIANBP3FBgAFyOgAADAELIABBBEgNASAFIAZBAWo2AgAgBiADQRJ2QfABcjoAACAFIAUoAgAiBkEBajYCACAGIANBDHZBP3FBgAFyOgAAIAUgBSgCACIGQQFqNgIAIAYgA0EGdkE/cUGAAXI6AAAgBSAFKAIAIgZBAWo2AgAgBiADQT9xQYABcjoAAAsgAiACKAIAQQRqIgM2AgAMAQsLQQEPCyAGC00AIwBBEGsiACQAIAAgAjYCDCAAIAU2AgggAiADIABBDGogBSAGIABBCGoQlwshBSAEIAAoAgw2AgAgByAAKAIINgIAIABBEGokACAFC7oEAQZ/IAIgADYCACAFIAM2AgADQCACKAIAIgMgAU8EQEEADwtBASEJAkACQAJAIAUoAgAiCyAETw0AIAMsAAAiAEH/AXEhBiAAQQBOBEAgBkH//8MASw0DQQEhAAwCCyAGQcIBSQ0CIAZB3wFNBEAgASADa0ECSA0BQQIhCSADLQABIgdBwAFxQYABRw0BQQIhACAHQT9xIAZBBnRBwA9xciIGQf//wwBNDQIMAQsCQCAGQe8BTQRAIAEgA2tBA0gNAiADLQACIQggAy0AASEHAkACQCAGQe0BRwRAIAZB4AFHDQEgB0HgAXFBoAFGDQIMBwsgB0HgAXFBgAFGDQEMBgsgB0HAAXFBgAFHDQULIAhBwAFxQYABRg0BDAQLIAZB9AFLDQMgASADa0EESA0BIAMtAAMhCiADLQACIQggAy0AASEHAkACQCAGQZB+aiIAQQRLDQACQAJAIABBAWsOBAICAgEACyAHQfAAakH/AXFBME8NBgwCCyAHQfABcUGAAUcNBQwBCyAHQcABcUGAAUcNBAsgCEHAAXFBgAFHDQMgCkHAAXFBgAFHDQNBBCEAQQIhCSAKQT9xIAhBBnRBwB9xIAZBEnRBgIDwAHEgB0E/cUEMdHJyciIGQf//wwBLDQEMAgtBAyEAQQIhCSAIQT9xIAZBDHRBgOADcSAHQT9xQQZ0cnIiBkH//8MATQ0BCyAJDwsgCyAGNgIAIAIgACADajYCACAFIAUoAgBBBGo2AgAMAQsLQQILCwAgAiADIAQQmQsL9QMBB38gACEDA0ACQCAHIAJPDQAgAyABTw0AIAMsAAAiBEH/AXEhBQJ/IARBAE4EQCAFQf//wwBLDQIgA0EBagwBCyAFQcIBSQ0BIAVB3wFNBEAgASADa0ECSA0CIAMtAAEiBEHAAXFBgAFHDQIgBEE/cSAFQQZ0QcAPcXJB///DAEsNAiADQQJqDAELAkACQAJAAkACQCAFQe8BTQRAIAEgA2tBA0gNByADLQACIQYgAy0AASEEIAVB7QFGDQEgBUHgAUYEQCAEQeABcUGgAUYNBgwICyAEQcABcUGAAUcNBwwFCyAFQfQBSw0GIAEgA2tBBEgNBiADLQADIQggAy0AAiEGIAMtAAEhBAJAIAVBkH5qIglBBEsNACAJQQFrDgQAAAADAgsgBEHAAXFBgAFHDQYMAwsgBEHgAXFBgAFGDQMMBQsgBEHwAGpB/wFxQTBJDQEMBAsgBEHwAXFBgAFHDQMLIAZBwAFxQYABRw0CIAhBwAFxQYABRw0CIAhBP3EgBkEGdEHAH3EgBUESdEGAgPAAcSAEQT9xQQx0cnJyQf//wwBLDQIgA0EEagwBCyAGQcABcUGAAUcNASAGQT9xIAVBDHRBgOADcSAEQT9xQQZ0cnJB///DAEsNASADQQNqCyEDIAdBAWohBwwBCwsgAyAAawsWACAAQejEAzYCACAAQQxqEIkMGiAACwoAIAAQmgsQ9gwLFgAgAEGQxQM2AgAgAEEQahCJDBogAAsKACAAEJwLEPYMCwcAIAAsAAgLBwAgACwACQsNACAAIAFBDGoQhwwaCw0AIAAgAUEQahCHDBoLDAAgAEGwxQMQvQcaCwwAIABBuMUDEKQLGgsiAQF/IwBBEGsiAiQAIAAgASABENoHEJUMIAJBEGokACAACwwAIABBzMUDEL0HGgsMACAAQdTFAxCkCxoLDwAgACABIAEQiA0QiwwaC3IAAkACQEHwtAUtAABBAXENAEHwtAUQqwxFDQBByLIFQQA2AgBB8AYQCkHIsgUoAgAhAEHIsgVBADYCACAAQQFGDQFB7LQFQaC2BTYCAEHwtAUQrwwLQey0BSgCAA8LEAYhABAHGkHwtAUQsQwgABAIAAvYAQEBfwJAQci3BS0AAEEBcQ0AQci3BRCrDEUNAEGgtgUhAANAIAAQiQhBDGoiAEHItwVHDQALQci3BRCvDAtBoLYFQdDoAxCnC0GstgVB1+gDEKcLQbi2BUHe6AMQpwtBxLYFQeboAxCnC0HQtgVB8OgDEKcLQdy2BUH56AMQpwtB6LYFQYDpAxCnC0H0tgVBiekDEKcLQYC3BUGN6QMQpwtBjLcFQZHpAxCnC0GYtwVBlekDEKcLQaS3BUGZ6QMQpwtBsLcFQZ3pAxCnC0G8twVBoekDEKcLCxwAQci3BSEAA0AgAEF0ahCJDCIAQaC2BUcNAAsLcgACQAJAQfi0BS0AAEEBcQ0AQfi0BRCrDEUNAEHIsgVBADYCAEHyBhAKQciyBSgCACEAQciyBUEANgIAIABBAUYNAUH0tAVB0LcFNgIAQfi0BRCvDAtB9LQFKAIADwsQBiEAEAcaQfi0BRCxDCAAEAgAC9gBAQF/AkBB+LgFLQAAQQFxDQBB+LgFEKsMRQ0AQdC3BSEAA0AgABCJCEEMaiIAQfi4BUcNAAtB+LgFEK8MC0HQtwVBqOkDEK4LQdy3BUHE6QMQrgtB6LcFQeDpAxCuC0H0twVBgOoDEK4LQYC4BUGo6gMQrgtBjLgFQczqAxCuC0GYuAVB6OoDEK4LQaS4BUGM6wMQrgtBsLgFQZzrAxCuC0G8uAVBrOsDEK4LQci4BUG86wMQrgtB1LgFQczrAxCuC0HguAVB3OsDEK4LQey4BUHs6wMQrgsLHABB+LgFIQADQCAAQXRqEIkMIgBB0LcFRw0ACwsOACAAIAEgARDaBxCWDAtyAAJAAkBBgLUFLQAAQQFxDQBBgLUFEKsMRQ0AQciyBUEANgIAQfQGEApByLIFKAIAIQBByLIFQQA2AgAgAEEBRg0BQfy0BUGAuQU2AgBBgLUFEK8MC0H8tAUoAgAPCxAGIQAQBxpBgLUFELEMIAAQCAALxgIBAX8CQEGguwUtAABBAXENAEGguwUQqwxFDQBBgLkFIQADQCAAEIkIQQxqIgBBoLsFRw0AC0GguwUQrwwLQYC5BUH86wMQpwtBjLkFQYTsAxCnC0GYuQVBjewDEKcLQaS5BUGT7AMQpwtBsLkFQZnsAxCnC0G8uQVBnewDEKcLQci5BUGi7AMQpwtB1LkFQafsAxCnC0HguQVBruwDEKcLQey5BUG47AMQpwtB+LkFQcDsAxCnC0GEugVByewDEKcLQZC6BUHS7AMQpwtBnLoFQdbsAxCnC0GougVB2uwDEKcLQbS6BUHe7AMQpwtBwLoFQZnsAxCnC0HMugVB4uwDEKcLQdi6BUHm7AMQpwtB5LoFQersAxCnC0HwugVB7uwDEKcLQfy6BUHy7AMQpwtBiLsFQfbsAxCnC0GUuwVB+uwDEKcLCxwAQaC7BSEAA0AgAEF0ahCJDCIAQYC5BUcNAAsLcgACQAJAQYi1BS0AAEEBcQ0AQYi1BRCrDEUNAEHIsgVBADYCAEH2BhAKQciyBSgCACEAQciyBUEANgIAIABBAUYNAUGEtQVBsLsFNgIAQYi1BRCvDAtBhLUFKAIADwsQBiEAEAcaQYi1BRCxDCAAEAgAC8YCAQF/AkBB0L0FLQAAQQFxDQBB0L0FEKsMRQ0AQbC7BSEAA0AgABCJCEEMaiIAQdC9BUcNAAtB0L0FEK8MC0GwuwVBgO0DEK4LQby7BUGg7QMQrgtByLsFQcTtAxCuC0HUuwVB3O0DEK4LQeC7BUH07QMQrgtB7LsFQYTuAxCuC0H4uwVBmO4DEK4LQYS8BUGs7gMQrgtBkLwFQcjuAxCuC0GcvAVB8O4DEK4LQai8BUGQ7wMQrgtBtLwFQbTvAxCuC0HAvAVB2O8DEK4LQcy8BUHo7wMQrgtB2LwFQfjvAxCuC0HkvAVBiPADEK4LQfC8BUH07QMQrgtB/LwFQZjwAxCuC0GIvQVBqPADEK4LQZS9BUG48AMQrgtBoL0FQcjwAxCuC0GsvQVB2PADEK4LQbi9BUHo8AMQrgtBxL0FQfjwAxCuCwscAEHQvQUhAANAIABBdGoQiQwiAEGwuwVHDQALC3IAAkACQEGQtQUtAABBAXENAEGQtQUQqwxFDQBByLIFQQA2AgBB+AYQCkHIsgUoAgAhAEHIsgVBADYCACAAQQFGDQFBjLUFQeC9BTYCAEGQtQUQrwwLQYy1BSgCAA8LEAYhABAHGkGQtQUQsQwgABAIAAtUAQF/AkBB+L0FLQAAQQFxDQBB+L0FEKsMRQ0AQeC9BSEAA0AgABCJCEEMaiIAQfi9BUcNAAtB+L0FEK8MC0HgvQVBiPEDEKcLQey9BUGL8QMQpwsLHABB+L0FIQADQCAAQXRqEIkMIgBB4L0FRw0ACwtyAAJAAkBBmLUFLQAAQQFxDQBBmLUFEKsMRQ0AQciyBUEANgIAQfoGEApByLIFKAIAIQBByLIFQQA2AgAgAEEBRg0BQZS1BUGAvgU2AgBBmLUFEK8MC0GUtQUoAgAPCxAGIQAQBxpBmLUFELEMIAAQCAALVAEBfwJAQZi+BS0AAEEBcQ0AQZi+BRCrDEUNAEGAvgUhAANAIAAQiQhBDGoiAEGYvgVHDQALQZi+BRCvDAtBgL4FQZDxAxCuC0GMvgVBnPEDEK4LCxwAQZi+BSEAA0AgAEF0ahCJDCIAQYC+BUcNAAsLbQACQAJAQai1BS0AAEEBcQ0AQai1BRCrDEUNAEHIsgVBADYCAEGpBkGctQVB7MUDEBUaQciyBSgCACEAQciyBUEANgIAIABBAUYNAUGotQUQrwwLQZy1BQ8LEAYhABAHGkGotQUQsQwgABAIAAsKAEGctQUQiQwaC20AAkACQEG4tQUtAABBAXENAEG4tQUQqwxFDQBByLIFQQA2AgBB/QZBrLUFQfjFAxAVGkHIsgUoAgAhAEHIsgVBADYCACAAQQFGDQFBuLUFEK8MC0GstQUPCxAGIQAQBxpBuLUFELEMIAAQCAALCgBBrLUFEIkMGgttAAJAAkBByLUFLQAAQQFxDQBByLUFEKsMRQ0AQciyBUEANgIAQakGQby1BUGcxgMQFRpByLIFKAIAIQBByLIFQQA2AgAgAEEBRg0BQci1BRCvDAtBvLUFDwsQBiEAEAcaQci1BRCxDCAAEAgACwoAQby1BRCJDBoLbQACQAJAQdi1BS0AAEEBcQ0AQdi1BRCrDEUNAEHIsgVBADYCAEH9BkHMtQVBqMYDEBUaQciyBSgCACEAQciyBUEANgIAIABBAUYNAUHYtQUQrwwLQcy1BQ8LEAYhABAHGkHYtQUQsQwgABAIAAsKAEHMtQUQiQwaC20AAkACQEHotQUtAABBAXENAEHotQUQqwxFDQBByLIFQQA2AgBBqQZB3LUFQczGAxAVGkHIsgUoAgAhAEHIsgVBADYCACAAQQFGDQFB6LUFEK8MC0HctQUPCxAGIQAQBxpB6LUFELEMIAAQCAALCgBB3LUFEIkMGgttAAJAAkBB+LUFLQAAQQFxDQBB+LUFEKsMRQ0AQciyBUEANgIAQf0GQey1BUHkxgMQFRpByLIFKAIAIQBByLIFQQA2AgAgAEEBRg0BQfi1BRCvDAtB7LUFDwsQBiEAEAcaQfi1BRCxDCAAEAgACwoAQey1BRCJDBoLbQACQAJAQYi2BS0AAEEBcQ0AQYi2BRCrDEUNAEHIsgVBADYCAEGpBkH8tQVBuMcDEBUaQciyBSgCACEAQciyBUEANgIAIABBAUYNAUGItgUQrwwLQfy1BQ8LEAYhABAHGkGItgUQsQwgABAIAAsKAEH8tQUQiQwaC20AAkACQEGYtgUtAABBAXENAEGYtgUQqwxFDQBByLIFQQA2AgBB/QZBjLYFQcTHAxAVGkHIsgUoAgAhAEHIsgVBADYCACAAQQFGDQFBmLYFEK8MC0GMtgUPCxAGIQAQBxpBmLYFELEMIAAQCAALCgBBjLYFEIkMGgsJACAAIAEQtQkLGwEBf0EBIQEgABCtCAR/IAAQrghBf2oFIAELCxkAIAAQrQgEQCAAIAEQygkPCyAAIAEQywkLfQEDfyAAKAIAIQFByLIFQQA2AgBB3gUQGyECQciyBSgCACEDQciyBUEANgIAAkAgA0EBRg0AIAEgAkcEQCAAKAIAIQFByLIFQQA2AgAgARDZB0HIsgUoAgAhAUHIsgVBADYCACABQQFGDQELDwtBABALIQAQBxogABCEAQALCgAgABDQCxD2DAsMACAAQQhqEM4LIAALCQAgASACENILCzoAQciyBUEANgIAIAAQ9gxByLIFKAIAIQBByLIFQQA2AgAgAEEBRwRADwtBABALIQAQBxogABCEAQALBwAgABD2DAsVACAAIAEQ3QsgAEEQakEAOgBwIAALegECfyMAQRBrIgEkACAAEGIaIAFB/////wM2AgxByLIFQQA2AgAgAUH/////BzYCCCABQQxqIAFBCGoQ/gohAEHIsgUoAgAhAkHIsgVBADYCACACQQFHBEAgACgCACEAIAFBEGokACAADwtBABALIQEQBxogARCEAQALCQAgACABEN4LCywAIAAoAgAaIAAoAgAgABDbC0ECdGoaIAAoAgAgABDbC0ECdGoaIAAoAgAaCyQAIAAgATYCACAAIAEoAgQiATYCBCAAIAEgAkECdGo2AgggAAsHACABEN8LCw8AIAAoAgAgACgCBDYCBAsSACAAEFooAgAgACgCAGtBAnULPgBByLIFQQA2AgAgACABIAIQ4QtByLIFKAIAIQBByLIFQQA2AgAgAEEBRwRADwtBABALIQAQBxogABCEAQALCQAgAEEANgIACyUAAkAgAUEcSw0AIAAtAHANACAAQQE6AHAgAA8LIAFBAnQQ/gsLCQAgAEEANgIAC1wBAn8gACgCBCECAkADQCABIAJGDQEgABBiGkHIsgVBADYCACACQXxqIQJByLIFKAIAIQNByLIFQQA2AgAgA0EBRw0AC0EAEAshAhAHGiACEIQBAAsgACABNgIECxcAIAAgAUYEQCAAQQA6AHAPCyABEPYMCyQAIABBC08EfyAAQRBqQXBxIgAgAEF/aiIAIABBC0YbBUEKCwsXAEF/IABJBEBBqPEDEOYLAAsgABD+CwsJACAAIAE2AgALEAAgACABQYCAgIB4cjYCCAtTAQF/QQgQDiEBQciyBUEANgIAQYkHIAEgABAVGkHIsgUoAgAhAEHIsgVBADYCACAAQQFHBEAgAUHA+ANBigcQEQALEAYhABAHGiABEBMgABAIAAsUACAAIAEQgQwgAEGg+AM2AgAgAAsMACAAEKoINgIAIAALWwECfyMAQRBrIgIkACACIAE2AgwgABDVCyIDIAFPBEAgABDbCyIAIANBAXZJBEAgAiAAQQF0NgIIIAJBCGogAkEMahDBBygCACEDCyACQRBqJAAgAw8LEKkMAAt0AQN/IwBBEGsiBCQAIARBADYCDCAAQQxqIgYgBEEMahDdCyAGQQRqIAMQ2ggaIAEEQCAAEO4LIAEQ1gshBQsgACAFNgIAIAAgBSACQQJ0aiICNgIIIAAgAjYCBCAAEFYgBSABQQJ0ajYCACAEQRBqJAAgAAuTAQECfyMAQRBrIgMkACADIABBCGogARDvCyIBKAIAIQICQANAIAIgASgCBEYNASAAEO4LGiABKAIAIQJByLIFQQA2AgAgAhDfC0HIsgUoAgAhAkHIsgVBADYCACACQQFHBEAgASABKAIAQQRqIgI2AgAMAQsLEAYhAhAHGiABEPALIAIQCAALIAEQ8AsgA0EQaiQAC1QBAX8gABDMCiAAEGIgACgCACAAKAIEIAFBBGoiAhDxCyAAIAIQxwcgAEEEaiABQQhqEMcHIAAQWiABEFYQxwcgASABKAIENgIAIAAgABC2ChDXCwsxACAAIAAoAgQQ8wsgACgCAARAIAAQ7gsgACgCACAAEFYoAgAgACgCAGtBAnUQ3AsLCwoAIABBDGoQ8gsLKwEBfyAAIAEoAgA2AgAgASgCACEDIAAgATYCCCAAIAMgAkECdGo2AgQgAAsPACAAKAIIIAAoAgA2AgALKAAgAyADKAIAIAIgAWsiAmsiADYCACACQQFOBEAgACABIAIQgA0aCwsKACAAQQRqKAIAC1gBAX8CQANAIAAoAgggAUYNASAAEO4LGiAAIAAoAghBfGo2AghByLIFQQA2AgBByLIFKAIAIQJByLIFQQA2AgAgAkEBRw0AC0EAEAshABAHGiAAEIQBAAsLOAECfyAAKAIAIAAoAggiAkEBdWohASAAKAIEIQAgASACQQFxBH8gASgCACAAaigCAAUgAAsRAQALCQAgACABELIJCyQAIABBAk8EfyAAQQRqQXxxIgAgAEF/aiIAIABBAkYbBUEBCwseAEH/////AyAASQRAQajxAxDmCwALIABBAnQQ/gsLNAEBfyMAQRBrIgMkACADIAEgAhCqCBDtByAAIAMpAwA3AwAgACADKQMINwMIIANBEGokAAtGAQF/IwBBEGsiAyQAIAMgAjYCCANAIAAgAUcEQCADQQhqIAAsAAAQsQcaIABBAWohAAwBCwsgAygCCCEAIANBEGokACAAC0YBAX8jAEEQayIDJAAgAyACNgIIA0AgACABRwRAIANBCGogACgCABC0BxogAEEEaiEADAELCyADKAIIIQAgA0EQaiQAIAALDQAgACACSSABIABNcQvMAwEBfwNAIAAoAgBBAUYNAAsCQAJAIAAoAgBFBEACQCAAQQEQ5AtByLIFQQA2AgBByLIFKAIAIQJByLIFQQA2AgACQCACQQFGDQBByLIFQQA2AgBB4wYgARAPQciyBSgCACEBQciyBUEANgIAIAFBAUYNAEHIsgVBADYCAEHIsgUoAgAhAUHIsgVBADYCACABQQFGDQAgAEF/NgIAQciyBUEANgIAQciyBSgCACEBQciyBUEANgIAIAFBAUYNAEHIsgVBADYCAEHIsgUoAgAhAUHIsgVBADYCACABQQFHDQELQQAQCyEBEAcaIAEQDBpByLIFQQA2AgBByLIFKAIAIQFByLIFQQA2AgACQCABQQFGDQAgAEEAEOQLQciyBUEANgIAQciyBSgCACEAQciyBUEANgIAIABBAUYNAEHIsgVBADYCAEHIsgUoAgAhAEHIsgVBADYCACAAQQFGDQBByLIFQQA2AgBBnwUQCkHIsgUoAgAhAEHIsgVBADYCACAAQQFHDQQLEAYhARAHGkHIsgVBADYCAEE6EApByLIFKAIAIQBByLIFQQA2AgAgAEEBRg0CIAEQCAALCw8LQQAQCyEAEAcaIAAQhAELAAsZAQF/QQQQDiIAELkMIABByPcDQfMIEBEAC0YBAX8gAEEBIAAbIQECQANAIAEQ9QwiAA0BQfzCBSgCACIABEAgABEGAAwBCwtBBBAOIgAQuQwgAEHI9wNB8wgQEQALIAALDQAgAEGU9wM2AgAgAAs7AQJ/IAEQiA0iAkENahD+CyIDQQA2AgggAyACNgIEIAMgAjYCACAAIAMQViABIAJBAWoQgA02AgAgAAtOACAAEP8LGiAAQdz3AzYCAEHIsgVBADYCAEH0CCAAQQRqIAEQFRpByLIFKAIAIQFByLIFQQA2AgAgAUEBRwRADwsQBiEAEAcaIAAQCAALVwAgABD/CxogAEHw9wM2AgAgARCvCCEBQciyBUEANgIAQfQIIABBBGogARAVGkHIsgUoAgAhAUHIsgVBADYCACABQQFHBEAgAA8LEAYhABAHGiAAEAgAC1AAIAAQ/wsaIABB8PcDNgIAQciyBUEANgIAQfQIIABBBGogARAVGkHIsgUoAgAhAUHIsgVBADYCACABQQFHBEAgAA8LEAYhABAHGiAAEAgACykBAX8gAgRAIAAhAwNAIAMgATYCACADQQRqIQMgAkF/aiICDQALCyAAC2kBAX8CQCAAIAFrQQJ1IAJJBEADQCAAIAJBf2oiAkECdCIDaiABIANqKAIANgIAIAINAAwCAAsACyACRQ0AIAAhAwNAIAMgASgCADYCACADQQRqIQMgAUEEaiEBIAJBf2oiAg0ACwsgAAsKAEHs8gMQ5gsAC0sBAn8jAEEQayIDJAAgACECAkAgARCtCEUEQCACIAEoAgg2AgggAiABKQIANwIADAELIAAgASgCACABKAIEEIgMCyADQRBqJAAgAAt6AQN/IwBBEGsiAyQAQW8gAk8EQAJAIAJBCk0EQCAAIAIQywkgACEEDAELIAAgAhDiC0EBaiIFEOMLIgQQ5AsgACAFEOULIAAgAhDKCQsgBCABIAIQ6QYgA0EAOgAPIAIgBGogA0EPahDJCSADQRBqJAAPCyAAEIYMAAsbACAAEK0IBEAgACAAKAIAIAAQrggQ0QsLIAALHQAgACABRwR/IAAgARCvCCABEIEIEIsMBSAACxoLdwEEfyMAQRBrIgQkAAJAIAAQiggiAyACTwRAIAAQrwgiAyEFIAIiBgRAIAUgASAGEIINCyAEQQA6AA8gAiADaiAEQQ9qEMkJIAAgAhDNCwwBCyAAIAMgAiADayAAEIEIIgNBACADIAIgARCMDAsgBEEQaiQAIAALggIBA38jAEEQayIIJABBbyIJIAFBf3NqIAJPBEAgABCvCCEKAn8gCUEBdkFwaiABSwRAIAggAUEBdDYCCCAIIAEgAmo2AgwgCEEMaiAIQQhqEMEHKAIAEOILDAELIAlBf2oLQQFqIgkQ4wshAiAEBEAgAiAKIAQQ6QYLIAYEQCACIARqIAcgBhDpBgsgAyAFayIDIARrIgcEQCACIARqIAZqIAQgCmogBWogBxDpBgsgAUEBaiIEQQtHBEAgACAKIAQQ0QsLIAAgAhDkCyAAIAkQ5QsgACADIAZqIgQQygkgCEEAOgAHIAIgBGogCEEHahDJCSAIQRBqJAAPCyAAEIYMAAslAQF/IAAQgQgiAyABSQRAIAAgASADayACEI4MDwsgACABEI8MC3MBBH8jAEEQayIFJAAgAQRAIAAQigghAyAAEIEIIgQgAWohBiADIARrIAFJBEAgACADIAYgA2sgBCAEEJAMCyAEIAAQrwgiA2ogASACEJEMIAAgBhDNCyAFQQA6AA8gAyAGaiAFQQ9qEMkJCyAFQRBqJAALXgECfyMAQRBrIgIkAAJAIAAQrQgEQCAAKAIAIQMgAkEAOgAPIAEgA2ogAkEPahDJCSAAIAEQygkMAQsgAkEAOgAOIAAgAWogAkEOahDJCSAAIAEQywkLIAJBEGokAAvDAQEDfyMAQRBrIgUkAEFvIgYgAWsgAk8EQCAAEK8IIQcCfyAGQQF2QXBqIAFLBEAgBSABQQF0NgIIIAUgASACajYCDCAFQQxqIAVBCGoQwQcoAgAQ4gsMAQsgBkF/agtBAWoiBhDjCyECIAQEQCACIAcgBBDpBgsgAyAEayIDBEAgAiAEaiAEIAdqIAMQ6QYLIAFBAWoiAUELRwRAIAAgByABENELCyAAIAIQ5AsgACAGEOULIAVBEGokAA8LIAAQhgwACxQAIAEEQCAAIAIQ7QYgARCBDRoLC38BA38jAEEQayIFJAACQCAAEIoIIgQgABCBCCIDayACTwRAIAJFDQEgABCvCCIEIANqIAEgAhDpBiAAIAIgA2oiAhDNCyAFQQA6AA8gAiAEaiAFQQ9qEMkJDAELIAAgBCACIANqIARrIAMgA0EAIAIgARCMDAsgBUEQaiQAIAALvQEBA38jAEEQayIDJAAgAyABOgAPAkACQAJAAkAgABCtCARAIAAQrgghASAAKAIEIgQgAUF/aiICRg0BDAMLQQohBEEKIQIgAC0ACyIBQQpHDQELIAAgAkEBIAIgAhCQDCAEIQEgABCtCA0BCyAAIQIgACABQQFqEMsJDAELIAAoAgAhAiAAIARBAWoQygkgBCEBCyABIAJqIgAgA0EPahDJCSADQQA6AA4gAEEBaiADQQ5qEMkJIANBEGokAAs+AQF/IwBBEGsiASQAAkAgAEEBEMsJIABBAUEtEJEMIAFBADoADyAAQQFqIAFBD2oQyQkgAUEQaiQADwALAAuBAQEDfyMAQRBrIgMkAEHv////AyACTwRAAkAgAkEBTQRAIAAgAhDLCSAAIQQMAQsgACACEPYLQQFqIgUQ9wsiBBDkCyAAIAUQ5QsgACACEMoJCyAEIAEgAhDwBiADQQA2AgwgBCACQQJ0aiADQQxqEM4HIANBEGokAA8LIAAQhgwAC20BAn8jAEEQayIEJAACQCAAEMwLIgMgAk8EQCAAEK8IIgMgASACEJcMIARBADYCDCADIAJBAnRqIARBDGoQzgcgACACEM0LDAELIAAgAyACIANrIAAQgQgiA0EAIAMgAiABEJgMCyAEQRBqJAALRgACQCACBEBByLIFQQA2AgAgACABIAIQhQwaQciyBSgCACECQciyBUEANgIAIAJBAUYNAQsPC0EAEAshABAHGiAAEIQBAAuXAgEDfyMAQRBrIggkAEHv////AyIJIAFBf3NqIAJPBEAgABCvCCEKAn8gCUEBdkFwaiABSwRAIAggAUEBdDYCCCAIIAEgAmo2AgwgCEEMaiAIQQhqEMEHKAIAEPYLDAELIAlBf2oLQQFqIgkQ9wshAiAEBEAgAiAKIAQQ8AYLIAYEQCAEQQJ0IAJqIAcgBhDwBgsgAyAFayIDIARrIgcEQCAEQQJ0IgQgAmogBkECdGogBCAKaiAFQQJ0aiAHEPAGCyABQQFqIgFBAkcEQCAAIAogARDRCwsgACACEOQLIAAgCRDlCyAAIAMgBmoiARDKCSAIQQA2AgQgAiABQQJ0aiAIQQRqEM4HIAhBEGokAA8LIAAQhgwAC8wBAQN/IwBBEGsiBSQAQe////8DIgYgAWsgAk8EQCAAEK8IIQcCfyAGQQF2QXBqIAFLBEAgBSABQQF0NgIIIAUgASACajYCDCAFQQxqIAVBCGoQwQcoAgAQ9gsMAQsgBkF/agtBAWoiBhD3CyECIAQEQCACIAcgBBDwBgsgAyAEayIDBEAgBEECdCIEIAJqIAQgB2ogAxDwBgsgAUEBaiIBQQJHBEAgACAHIAEQ0QsLIAAgAhDkCyAAIAYQ5QsgBUEQaiQADwsgABCGDAALRgACQCABBEBByLIFQQA2AgAgACACIAEQhAwaQciyBSgCACEBQciyBUEANgIAIAFBAUYNAQsPC0EAEAshABAHGiAAEIQBAAuFAQEDfyMAQRBrIgUkAAJAIAAQzAsiBCAAEIEIIgNrIAJPBEAgAkUNASAAEK8IIgQgA0ECdGogASACEPAGIAAgAiADaiICEM0LIAVBADYCDCAEIAJBAnRqIAVBDGoQzgcMAQsgACAEIAIgA2ogBGsgAyADQQAgAiABEJgMCyAFQRBqJAAgAAvAAQEDfyMAQRBrIgMkACADIAE2AgwCQAJAAkACQCAAEK0IBEAgABCuCCEBIAAoAgQiBCABQX9qIgJGDQEMAwtBASEEQQEhAiAALQALIgFBAUcNAQsgACACQQEgAiACEJkMIAQhASAAEK0IDQELIAAhAiAAIAFBAWoQywkMAQsgACgCACECIAAgBEEBahDKCSAEIQELIAIgAUECdGoiACADQQxqEM4HIANBADYCCCAAQQRqIANBCGoQzgcgA0EQaiQAC4EBAQN/IwBBEGsiAyQAQe////8DIAFPBEACQCABQQFNBEAgACABEMsJIAAhBAwBCyAAIAEQ9gtBAWoiBRD3CyIEEOQLIAAgBRDlCyAAIAEQygkLIAQgASACEJoMIANBADYCDCAEIAFBAnRqIANBDGoQzgcgA0EQaiQADwsgABCGDAALRAEBfyAAQdSQBCgCABCLBiIAEIgNIgJBgAhPBEAgASAAQf8HEIANGiABQQA6AP8HQcQADwsgASAAIAJBAWoQgA0aQQALCwAgACACIAEQyQcLTwEBfyMAQRBrIgMkACADQQhqIAAgASAAKAIAKAIMEQUAIANBCGoiACgCBCACKAIEEIoHBH8gACgCACACKAIARgVBAAshACADQRBqJAAgAAsaACAAIAEoAgQQigcEfyACIAEoAgBGBUEACwtrAQN/IwBBkAhrIgIkAEGoqgUoAgAhBCABIAJBEGoQngwgAkEQahCjDCIDLQAARQRAIAIgATYCACACQRBqQYAIQfzzAyACEJUGGiACQRBqIQMLQaiqBSAENgIAIAAgAxC9BxogAkGQCGokAAs3AQF/AkAgAEEBaiICQQFNBEAgAkEBa0UNAUGoqgUoAgAhAAtBkPMDIQEgAEEcRg0AEAQACyABC7ABAQJ/IwBBEGsiAyQAAkAgASgCAARAIAIQhAhFBEAgAkH58gNB+fIDEIgNEJIMGgsgAyABKAIEIgQgASgCACAEKAIAKAIYEQUAQciyBUEANgIAQfcIIAIgAxAVGkHIsgUoAgAhAUHIsgVBADYCACABQQFGDQEgAxCJDBoLIAAgAikCADcCACAAIAIoAgg2AgggAhCsCCADQRBqJAAPCxAGIQIQBxogAxCJDBogAhAIAAsRACAAIAEQrwggARCBCBCSDAvKAQECfyMAQSBrIgMkACADIAIQvQchAkHIsgVBADYCAEH4CCADQRBqIAEgAhASQciyBSgCACEEQciyBUEANgIAAkACQCAEQQFHBEBByLIFQQA2AgBB+QggACADQRBqEBUaQciyBSgCACEEQciyBUEANgIAIARBAUYNASADQRBqEIkMGiACEIkMGiAAQYTzAzYCACAAIAEpAgA3AgggA0EgaiQADwsQBiEAEAcaDAELEAYhABAHGiADQRBqEIkMGgsgAhCJDBogABAIAAsKACAAEL4MGiAACwoAIAAQpwwQ9gwLCgBBjfQDEOYLAAsvAQF/IwBBEGsiAiQAIAIgATYCDEGU9AMoAgAiAiAAIAEQrAYaQQogAhCRBhAEAAsiAQF/IwBBEGsiASQAIAEgABCsDBCtDCEAIAFBEGokACAACyMAIABBADYCDCAAIAE2AgQgACABNgIAIAAgAUEBajYCCCAACzQBAn8jAEEQayIBJAAgAUEIaiAAKAIEENoIKAIALQAARQRAIAAQrgwhAgsgAUEQaiQAIAILNwECfwJAIAAoAggiAC0AACICQQFHBH8gAkECcQ0BIABBAjoAAEEBBSABCw8LQZj0A0EAEKoMAAseAQF/IwBBEGsiASQAIAEgABCsDBCwDCABQRBqJAALMwEBfyMAQRBrIgEkACABQQhqIAAoAgQQ2ggoAgBBAToAACAAKAIIQQE6AAAgAUEQaiQACyMBAX8jAEEQayIBJAAgASAAEKwMKAIIQQA6AAAgAUEQaiQACwYAQfTCBQv2AQEEfyMAQTBrIgAkAAJAAkBB9MIFKAIAIgFFDQAgAUEwaiICELQMBEAgAAJ/IAIpAwBCgdasmfTIk6bDAFEEQCABKAIsDAELIAFB0ABqCzYCLCABKAIAIgIoAgQhAUGw9wMgAiAAQSxqQbD3AygCACgCEBEEAA0CIAAgATYCFCAAQbyTBCgCADYCEEH79AMgAEEQahCqDAALIABBvJMEKAIANgIgQaT1AyAAQSBqEKoMAAtByvUDQQAQqgwAC0G8kwQoAgAhAiAAIAAoAiwiAyADKAIAKAIIEQAANgIIIAAgATYCBCAAIAI2AgBBzvQDIAAQqgwACxcAIAApAwBCgH6DQoDWrJn0yJOmwwBRC2QBAX9ByLIFQQA2AgBByLIFKAIAIQBByLIFQQA2AgACQCAAQQFHBEBB9MIFKAIAIgBFDQEgAEEwahC0DEUNASAAKAIMELYMAAtBABALIQAQBxogABCEAQALQbiTBCgCABC2DAAL3QEBAX9ByLIFQQA2AgAgABAKQciyBSgCACEAQciyBUEANgIAAkACQCAAQQFHBEBByLIFQQA2AgBB/ghB3/UDQQAQBUHIsgUoAgAhAEHIsgVBADYCACAAQQFHDQELQQAQCyEAEAcaIAAQDBpByLIFQQA2AgBB/ghBh/YDQQAQBUHIsgUoAgAhAEHIsgVBADYCACAAQQFHDQBBABALIQEQBxpByLIFQQA2AgBBOhAKQciyBSgCACEAQciyBUEANgIAIABBAUYNASABEIQBCwALQQAQCyEAEAcaIAAQhAEACwwAQbn2A0EAEKoMAAsGAEHX9gMLEQAgABD/CxogAEHw9gM2AgALBgBB/PYDCxUAIABB3PcDNgIAIABBBGoQvAwgAAsfAAJAIAAoAgBBdGoiAEEIahDSCkF/Sg0AIAAQ9gwLCwoAIAAQuwwQ9gwLFQAgAEHw9wM2AgAgAEEEahC8DCAACwoAIAAQvgwQ9gwLDQAgABC7DBogABD2DAsGAEGA+QMLCwAgACABQQAQwwwLLQAgAkUEQCAAKAIEIAEoAgRGDwsgACABRgRAQQEPCyAAKAIEIAEoAgQQgwZFC6QBAQF/IwBBQGoiAyQAAn9BASAAIAFBABDDDA0AGkEAIAFFDQAaQQAgAUGQ+gMQxQwiAUUNABogA0F/NgIUIAMgADYCECADQQA2AgwgAyABNgIIIANBGGpBAEEnEIENGiADQQE2AjggASADQQhqIAIoAgBBASABKAIAKAIcEQcAQQAgAygCIEEBRw0AGiACIAMoAhg2AgBBAQshACADQUBrJAAgAAulAgEEfyMAQUBqIgIkACAAKAIAIgVBfGooAgAhAyAFQXhqKAIAIQUgAkEANgIUIAJB4PkDNgIQIAIgADYCDCACIAE2AgggAkEYakEAQScQgQ0aIAAgBWohAAJAIAMgAUEAEMMMBEAgAkEBNgI4IAMgAkEIaiAAIABBAUEAIAMoAgAoAhQRDAAgAEEAIAIoAiBBAUYbIQQMAQsgAyACQQhqIABBAUEAIAMoAgAoAhgRCwAgAigCLCIAQQFLDQAgAEEBawRAIAIoAhxBACACKAIoQQFGG0EAIAIoAiRBAUYbQQAgAigCMEEBRhshBAwBCyACKAIgQQFHBEAgAigCMA0BIAIoAiRBAUcNASACKAIoQQFHDQELIAIoAhghBAsgAkFAayQAIAQLXQEBfyAAKAIQIgNFBEAgAEEBNgIkIAAgAjYCGCAAIAE2AhAPCwJAIAEgA0YEQCAAKAIYQQJHDQEgACACNgIYDwsgAEEBOgA2IABBAjYCGCAAIAAoAiRBAWo2AiQLCxoAIAAgASgCCEEAEMMMBEAgASACIAMQxgwLCzMAIAAgASgCCEEAEMMMBEAgASACIAMQxgwPCyAAKAIIIgAgASACIAMgACgCACgCHBEHAAtSAQF/IAAoAgQhBCAAKAIAIgAgAQJ/QQAgAkUNABogBEEIdSIBIARBAXFFDQAaIAIoAgAgAWooAgALIAJqIANBAiAEQQJxGyAAKAIAKAIcEQcAC3ABAn8gACABKAIIQQAQwwwEQCABIAIgAxDGDA8LIAAoAgwhBCAAQRBqIgUgASACIAMQyQwCQCAEQQJIDQAgBSAEQQN0aiEEIABBGGohAANAIAAgASACIAMQyQwgAS0ANg0BIABBCGoiACAESQ0ACwsLPgEBfwJAIAAgASAALQAIQRhxBH9BAQUgAUUNASABQcD6AxDFDCIARQ0BIAAtAAhBGHFBAEcLEMMMIQILIAIL6QMBBH8jAEFAaiIFJAACQAJAAkAgAUHM/ANBABDDDARAIAJBADYCAAwBCyAAIAEQywwEQEEBIQMgAigCACIBRQ0DIAIgASgCADYCAAwDCyABRQ0BIAFB8PoDEMUMIgFFDQIgAigCACIEBEAgAiAEKAIANgIACyABKAIIIgQgACgCCCIGQX9zcUEHcQ0CIARBf3MgBnFB4ABxDQJBASEDIAAoAgwgASgCDEEAEMMMDQIgACgCDEHA/ANBABDDDARAIAEoAgwiAUUNAyABQaT7AxDFDEUhAwwDCyAAKAIMIgRFDQFBACEDIARB8PoDEMUMIgQEQCAALQAIQQFxRQ0DIAQgASgCDBDNDCEDDAMLIAAoAgwiBEUNAiAEQeD7AxDFDCIEBEAgAC0ACEEBcUUNAyAEIAEoAgwQzgwhAwwDCyAAKAIMIgBFDQIgAEGQ+gMQxQwiAEUNAiABKAIMIgFFDQIgAUGQ+gMQxQwiAUUNAiAFQX82AhQgBSAANgIQIAVBADYCDCAFIAE2AgggBUEYakEAQScQgQ0aIAVBATYCOCABIAVBCGogAigCAEEBIAEoAgAoAhwRBwAgBSgCIEEBRw0CIAIoAgBFDQAgAiAFKAIYNgIAC0EBIQMMAQtBACEDCyAFQUBrJAAgAwucAQECfwJAA0AgAUUEQEEADwsgAUHw+gMQxQwiAUUNASABKAIIIAAoAghBf3NxDQEgACgCDCABKAIMQQAQwwwEQEEBDwsgAC0ACEEBcUUNASAAKAIMIgNFDQEgA0Hw+gMQxQwiAwRAIAEoAgwhASADIQAMAQsLIAAoAgwiAEUNACAAQeD7AxDFDCIARQ0AIAAgASgCDBDODCECCyACC08BAX8CQCABRQ0AIAFB4PsDEMUMIgFFDQAgASgCCCAAKAIIQX9zcQ0AIAAoAgwgASgCDEEAEMMMRQ0AIAAoAhAgASgCEEEAEMMMIQILIAILowEAIABBAToANQJAIAAoAgQgAkcNACAAQQE6ADQgACgCECICRQRAIABBATYCJCAAIAM2AhggACABNgIQIANBAUcNASAAKAIwQQFHDQEgAEEBOgA2DwsgASACRgRAIAAoAhgiAkECRgRAIAAgAzYCGCADIQILIAAoAjBBAUcNASACQQFHDQEgAEEBOgA2DwsgAEEBOgA2IAAgACgCJEEBajYCJAsLIAACQCAAKAIEIAFHDQAgACgCHEEBRg0AIAAgAjYCHAsLqAQBBH8gACABKAIIIAQQwwwEQCABIAIgAxDQDA8LAkAgACABKAIAIAQQwwwEQAJAIAIgASgCEEcEQCABKAIUIAJHDQELIANBAUcNAiABQQE2AiAPCyABIAM2AiAgASgCLEEERwRAIABBEGoiBSAAKAIMQQN0aiEDIAECfwJAA0ACQCAFIANPDQAgAUEAOwE0IAUgASACIAJBASAEENIMIAEtADYNAAJAIAEtADVFDQAgAS0ANARAQQEhBiABKAIYQQFGDQRBASEHQQEhCCAALQAIQQJxDQEMBAtBASEHIAghBiAALQAIQQFxRQ0DCyAFQQhqIQUMAQsLIAghBkEEIAdFDQEaC0EDCzYCLCAGQQFxDQILIAEgAjYCFCABIAEoAihBAWo2AiggASgCJEEBRw0BIAEoAhhBAkcNASABQQE6ADYPCyAAKAIMIQUgAEEQaiIGIAEgAiADIAQQ0wwgBUECSA0AIAYgBUEDdGohBiAAQRhqIQUCQCAAKAIIIgBBAnFFBEAgASgCJEEBRw0BCwNAIAEtADYNAiAFIAEgAiADIAQQ0wwgBUEIaiIFIAZJDQALDAELIABBAXFFBEADQCABLQA2DQIgASgCJEEBRg0CIAUgASACIAMgBBDTDCAFQQhqIgUgBkkNAAwCAAsACwNAIAEtADYNASABKAIkQQFGBEAgASgCGEEBRg0CCyAFIAEgAiADIAQQ0wwgBUEIaiIFIAZJDQALCwtLAQJ/IAAoAgQiBkEIdSEHIAAoAgAiACABIAIgBkEBcQR/IAMoAgAgB2ooAgAFIAcLIANqIARBAiAGQQJxGyAFIAAoAgAoAhQRDAALSQECfyAAKAIEIgVBCHUhBiAAKAIAIgAgASAFQQFxBH8gAigCACAGaigCAAUgBgsgAmogA0ECIAVBAnEbIAQgACgCACgCGBELAAv1AQAgACABKAIIIAQQwwwEQCABIAIgAxDQDA8LAkAgACABKAIAIAQQwwwEQAJAIAIgASgCEEcEQCABKAIUIAJHDQELIANBAUcNAiABQQE2AiAPCyABIAM2AiACQCABKAIsQQRGDQAgAUEAOwE0IAAoAggiACABIAIgAkEBIAQgACgCACgCFBEMACABLQA1BEAgAUEDNgIsIAEtADRFDQEMAwsgAUEENgIsCyABIAI2AhQgASABKAIoQQFqNgIoIAEoAiRBAUcNASABKAIYQQJHDQEgAUEBOgA2DwsgACgCCCIAIAEgAiADIAQgACgCACgCGBELAAsLlAEAIAAgASgCCCAEEMMMBEAgASACIAMQ0AwPCwJAIAAgASgCACAEEMMMRQ0AAkAgAiABKAIQRwRAIAEoAhQgAkcNAQsgA0EBRw0BIAFBATYCIA8LIAEgAjYCFCABIAM2AiAgASABKAIoQQFqNgIoAkAgASgCJEEBRw0AIAEoAhhBAkcNACABQQE6ADYLIAFBBDYCLAsLlwIBBn8gACABKAIIIAUQwwwEQCABIAIgAyAEEM8MDwsgAS0ANSEHIAAoAgwhBiABQQA6ADUgAS0ANCEIIAFBADoANCAAQRBqIgkgASACIAMgBCAFENIMIAcgAS0ANSIKciEHIAggAS0ANCILciEIAkAgBkECSA0AIAkgBkEDdGohCSAAQRhqIQYDQCABLQA2DQECQCALBEAgASgCGEEBRg0DIAAtAAhBAnENAQwDCyAKRQ0AIAAtAAhBAXFFDQILIAFBADsBNCAGIAEgAiADIAQgBRDSDCABLQA1IgogB3IhByABLQA0IgsgCHIhCCAGQQhqIgYgCUkNAAsLIAEgB0H/AXFBAEc6ADUgASAIQf8BcUEARzoANAs5ACAAIAEoAgggBRDDDARAIAEgAiADIAQQzwwPCyAAKAIIIgAgASACIAMgBCAFIAAoAgAoAhQRDAALHAAgACABKAIIIAUQwwwEQCABIAIgAyAEEM8MCwtDAQF/IwBBEGsiAyQAIAMgAigCADYCDCAAIAEgA0EMaiAAKAIAKAIQEQQAIgAEQCACIAMoAgw2AgALIANBEGokACAACxcAIABFBEBBAA8LIABB8PoDEMUMQQBHCyMBAn8gABCIDUEBaiIBEPUMIgJFBEBBAA8LIAIgACABEIANCyoBAX8jAEEQayIBJAAgASAANgIMIAEoAgwoAgQQ2wwhACABQRBqJAAgAAvhAQBBwPwDQeD/AxA4Qdj8A0Hl/wNBAUEBQQAQORDeDBDfDBDgDBDhDBDiDBDjDBDkDBDlDBDmDBDnDBDoDEHsEEHPgAQQOkG4hgRB24AEEDpBkIcEQQRB/IAEEDtB7IcEQQJBiYEEEDtByIgEQQRBmIEEEDtB9IgEQaeBBBA8EOkMQdWBBBDqDEH6gQQQ6wxBoYIEEOwMQcCCBBDtDEHoggQQ7gxBhYMEEO8MEPAMEPEMQfCDBBDqDEGQhAQQ6wxBsYQEEOwMQdKEBBDtDEH0hAQQ7gxBlYUEEO8MEPIMEPMMCzABAX8jAEEQayIAJAAgAEHq/wM2AgxB5PwDIAAoAgxBAUGAf0H/ABA9IABBEGokAAswAQF/IwBBEGsiACQAIABB7/8DNgIMQfz8AyAAKAIMQQFBgH9B/wAQPSAAQRBqJAALLwEBfyMAQRBrIgAkACAAQfv/AzYCDEHw/AMgACgCDEEBQQBB/wEQPSAAQRBqJAALMgEBfyMAQRBrIgAkACAAQYmABDYCDEGI/QMgACgCDEECQYCAfkH//wEQPSAAQRBqJAALMAEBfyMAQRBrIgAkACAAQY+ABDYCDEGU/QMgACgCDEECQQBB//8DED0gAEEQaiQACzYBAX8jAEEQayIAJAAgAEGegAQ2AgxBoP0DIAAoAgxBBEGAgICAeEH/////BxA9IABBEGokAAsuAQF/IwBBEGsiACQAIABBooAENgIMQaz9AyAAKAIMQQRBAEF/ED0gAEEQaiQACzYBAX8jAEEQayIAJAAgAEGvgAQ2AgxBuP0DIAAoAgxBBEGAgICAeEH/////BxA9IABBEGokAAsuAQF/IwBBEGsiACQAIABBtIAENgIMQcT9AyAAKAIMQQRBAEF/ED0gAEEQaiQACyoBAX8jAEEQayIAJAAgAEHCgAQ2AgxB0P0DIAAoAgxBBBA+IABBEGokAAsqAQF/IwBBEGsiACQAIABByIAENgIMQdz9AyAAKAIMQQgQPiAAQRBqJAALKgEBfyMAQRBrIgAkACAAQbeBBDYCDEGciQRBACAAKAIMED8gAEEQaiQACygBAX8jAEEQayIBJAAgASAANgIMQcSJBEEAIAEoAgwQPyABQRBqJAALKAEBfyMAQRBrIgEkACABIAA2AgxB7IkEQQEgASgCDBA/IAFBEGokAAsoAQF/IwBBEGsiASQAIAEgADYCDEGUigRBAiABKAIMED8gAUEQaiQACygBAX8jAEEQayIBJAAgASAANgIMQbyKBEEDIAEoAgwQPyABQRBqJAALKAEBfyMAQRBrIgEkACABIAA2AgxB5IoEQQQgASgCDBA/IAFBEGokAAsoAQF/IwBBEGsiASQAIAEgADYCDEGMiwRBBSABKAIMED8gAUEQaiQACyoBAX8jAEEQayIAJAAgAEGrgwQ2AgxBtIsEQQQgACgCDBA/IABBEGokAAsqAQF/IwBBEGsiACQAIABByYMENgIMQdyLBEEFIAAoAgwQPyAAQRBqJAALKgEBfyMAQRBrIgAkACAAQbeFBDYCDEGEjARBBiAAKAIMED8gAEEQaiQACyoBAX8jAEEQayIAJAAgAEHWhQQ2AgxBrIwEQQcgACgCDBA/IABBEGokAAsnAQF/IwBBEGsiASQAIAEgADYCDCABKAIMIQAQ3QwgAUEQaiQAIAAL7y4BC38jAEEQayILJAACQAJAAkACQAJAAkACQAJAAkACQAJAIABB9AFNBEBBhMMFKAIAIgZBECAAQQtqQXhxIABBC0kbIgRBA3YiAXYiAEEDcQRAIABBf3NBAXEgAWoiBEEDdCICQbTDBWooAgAiAUEIaiEAAkAgASgCCCIDIAJBrMMFaiICRgRAQYTDBSAGQX4gBHdxNgIADAELQZTDBSgCABogAyACNgIMIAIgAzYCCAsgASAEQQN0IgNBA3I2AgQgASADaiIBIAEoAgRBAXI2AgQMDAsgBEGMwwUoAgAiCE0NASAABEACQCAAIAF0QQIgAXQiAEEAIABrcnEiAEEAIABrcUF/aiIAIABBDHZBEHEiAHYiAUEFdkEIcSIDIAByIAEgA3YiAEECdkEEcSIBciAAIAF2IgBBAXZBAnEiAXIgACABdiIAQQF2QQFxIgFyIAAgAXZqIgNBA3QiAkG0wwVqKAIAIgEoAggiACACQazDBWoiAkYEQEGEwwUgBkF+IAN3cSIGNgIADAELQZTDBSgCABogACACNgIMIAIgADYCCAsgAUEIaiEAIAEgBEEDcjYCBCABIARqIgIgA0EDdCIFIARrIgNBAXI2AgQgASAFaiADNgIAIAgEQCAIQQN2IgVBA3RBrMMFaiEEQZjDBSgCACEBAn8gBkEBIAV0IgVxRQRAQYTDBSAFIAZyNgIAIAQMAQsgBCgCCAshBSAEIAE2AgggBSABNgIMIAEgBDYCDCABIAU2AggLQZjDBSACNgIAQYzDBSADNgIADAwLQYjDBSgCACIJRQ0BIAlBACAJa3FBf2oiACAAQQx2QRBxIgB2IgFBBXZBCHEiAyAAciABIAN2IgBBAnZBBHEiAXIgACABdiIAQQF2QQJxIgFyIAAgAXYiAEEBdkEBcSIBciAAIAF2akECdEG0xQVqKAIAIgIoAgRBeHEgBGshASACIQMDQAJAIAMoAhAiAEUEQCADKAIUIgBFDQELIAAoAgRBeHEgBGsiAyABIAMgAUkiAxshASAAIAIgAxshAiAAIQMMAQsLIAIoAhghCiACIAIoAgwiBUcEQEGUwwUoAgAgAigCCCIATQRAIAAoAgwaCyAAIAU2AgwgBSAANgIIDAsLIAJBFGoiAygCACIARQRAIAIoAhAiAEUNAyACQRBqIQMLA0AgAyEHIAAiBUEUaiIDKAIAIgANACAFQRBqIQMgBSgCECIADQALIAdBADYCAAwKC0F/IQQgAEG/f0sNACAAQQtqIgBBeHEhBEGIwwUoAgAiCEUNAAJ/QQAgAEEIdiIARQ0AGkEfIARB////B0sNABogACAAQYD+P2pBEHZBCHEiAXQiACAAQYDgH2pBEHZBBHEiAHQiAyADQYCAD2pBEHZBAnEiA3RBD3YgACABciADcmsiAEEBdCAEIABBFWp2QQFxckEcagshB0EAIARrIQMCQAJAAkAgB0ECdEG0xQVqKAIAIgFFBEBBACEADAELIARBAEEZIAdBAXZrIAdBH0YbdCECQQAhAANAAkAgASgCBEF4cSAEayIGIANPDQAgASEFIAYiAw0AQQAhAyABIQAMAwsgACABKAIUIgYgBiABIAJBHXZBBHFqKAIQIgFGGyAAIAYbIQAgAiABQQBHdCECIAENAAsLIAAgBXJFBEBBAiAHdCIAQQAgAGtyIAhxIgBFDQMgAEEAIABrcUF/aiIAIABBDHZBEHEiAHYiAUEFdkEIcSICIAByIAEgAnYiAEECdkEEcSIBciAAIAF2IgBBAXZBAnEiAXIgACABdiIAQQF2QQFxIgFyIAAgAXZqQQJ0QbTFBWooAgAhAAsgAEUNAQsDQCAAKAIEQXhxIARrIgYgA0khAiAGIAMgAhshAyAAIAUgAhshBSAAKAIQIgEEfyABBSAAKAIUCyIADQALCyAFRQ0AIANBjMMFKAIAIARrTw0AIAUoAhghByAFIAUoAgwiAkcEQEGUwwUoAgAgBSgCCCIATQRAIAAoAgwaCyAAIAI2AgwgAiAANgIIDAkLIAVBFGoiASgCACIARQRAIAUoAhAiAEUNAyAFQRBqIQELA0AgASEGIAAiAkEUaiIBKAIAIgANACACQRBqIQEgAigCECIADQALIAZBADYCAAwIC0GMwwUoAgAiACAETwRAQZjDBSgCACEBAkAgACAEayIDQRBPBEBBjMMFIAM2AgBBmMMFIAEgBGoiAjYCACACIANBAXI2AgQgACABaiADNgIAIAEgBEEDcjYCBAwBC0GYwwVBADYCAEGMwwVBADYCACABIABBA3I2AgQgACABaiIAIAAoAgRBAXI2AgQLIAFBCGohAAwKC0GQwwUoAgAiAiAESwRAQZDDBSACIARrIgE2AgBBnMMFQZzDBSgCACIAIARqIgM2AgAgAyABQQFyNgIEIAAgBEEDcjYCBCAAQQhqIQAMCgtBACEAIARBL2oiCAJ/QdzGBSgCAARAQeTGBSgCAAwBC0HoxgVCfzcCAEHgxgVCgKCAgICABDcCAEHcxgUgC0EMakFwcUHYqtWqBXM2AgBB8MYFQQA2AgBBwMYFQQA2AgBBgCALIgFqIgZBACABayIHcSIFIARNDQlBvMYFKAIAIgEEQEG0xgUoAgAiAyAFaiIJIANNDQogCSABSw0KC0HAxgUtAABBBHENBAJAAkBBnMMFKAIAIgEEQEHExgUhAANAIAAoAgAiAyABTQRAIAMgACgCBGogAUsNAwsgACgCCCIADQALC0EAEPwMIgJBf0YNBSAFIQZB4MYFKAIAIgBBf2oiASACcQRAIAUgAmsgASACakEAIABrcWohBgsgBiAETQ0FIAZB/v///wdLDQVBvMYFKAIAIgAEQEG0xgUoAgAiASAGaiIDIAFNDQYgAyAASw0GCyAGEPwMIgAgAkcNAQwHCyAGIAJrIAdxIgZB/v///wdLDQQgBhD8DCICIAAoAgAgACgCBGpGDQMgAiEACwJAIARBMGogBk0NACAAQX9GDQBB5MYFKAIAIgEgCCAGa2pBACABa3EiAUH+////B0sEQCAAIQIMBwsgARD8DEF/RwRAIAEgBmohBiAAIQIMBwtBACAGaxD8DBoMBAsgACECIABBf0cNBQwDC0EAIQUMBwtBACECDAULIAJBf0cNAgtBwMYFQcDGBSgCAEEEcjYCAAsgBUH+////B0sNASAFEPwMIgJBABD8DCIATw0BIAJBf0YNASAAQX9GDQEgACACayIGIARBKGpNDQELQbTGBUG0xgUoAgAgBmoiADYCACAAQbjGBSgCAEsEQEG4xgUgADYCAAsCQAJAAkBBnMMFKAIAIgEEQEHExgUhAANAIAIgACgCACIDIAAoAgQiBWpGDQIgACgCCCIADQALDAILQZTDBSgCACIAQQAgAiAATxtFBEBBlMMFIAI2AgALQQAhAEHIxgUgBjYCAEHExgUgAjYCAEGkwwVBfzYCAEGowwVB3MYFKAIANgIAQdDGBUEANgIAA0AgAEEDdCIBQbTDBWogAUGswwVqIgM2AgAgAUG4wwVqIAM2AgAgAEEBaiIAQSBHDQALQZDDBSAGQVhqIgBBeCACa0EHcUEAIAJBCGpBB3EbIgFrIgM2AgBBnMMFIAEgAmoiATYCACABIANBAXI2AgQgACACakEoNgIEQaDDBUHsxgUoAgA2AgAMAgsgAC0ADEEIcQ0AIAIgAU0NACADIAFLDQAgACAFIAZqNgIEQZzDBSABQXggAWtBB3FBACABQQhqQQdxGyIAaiIDNgIAQZDDBUGQwwUoAgAgBmoiAiAAayIANgIAIAMgAEEBcjYCBCABIAJqQSg2AgRBoMMFQezGBSgCADYCAAwBCyACQZTDBSgCACIFSQRAQZTDBSACNgIAIAIhBQsgAiAGaiEDQcTGBSEAAkACQAJAAkACQAJAA0AgAyAAKAIARwRAIAAoAggiAA0BDAILCyAALQAMQQhxRQ0BC0HExgUhAANAIAAoAgAiAyABTQRAIAMgACgCBGoiAyABSw0DCyAAKAIIIQAMAAALAAsgACACNgIAIAAgACgCBCAGajYCBCACQXggAmtBB3FBACACQQhqQQdxG2oiByAEQQNyNgIEIANBeCADa0EHcUEAIANBCGpBB3EbaiICIAdrIARrIQAgBCAHaiEDIAEgAkYEQEGcwwUgAzYCAEGQwwVBkMMFKAIAIABqIgA2AgAgAyAAQQFyNgIEDAMLIAJBmMMFKAIARgRAQZjDBSADNgIAQYzDBUGMwwUoAgAgAGoiADYCACADIABBAXI2AgQgACADaiAANgIADAMLIAIoAgQiAUEDcUEBRgRAIAFBeHEhCAJAIAFB/wFNBEAgAigCCCIGIAFBA3YiCUEDdEGswwVqRxogAigCDCIEIAZGBEBBhMMFQYTDBSgCAEF+IAl3cTYCAAwCCyAGIAQ2AgwgBCAGNgIIDAELIAIoAhghCQJAIAIgAigCDCIGRwRAIAUgAigCCCIBTQRAIAEoAgwaCyABIAY2AgwgBiABNgIIDAELAkAgAkEUaiIBKAIAIgQNACACQRBqIgEoAgAiBA0AQQAhBgwBCwNAIAEhBSAEIgZBFGoiASgCACIEDQAgBkEQaiEBIAYoAhAiBA0ACyAFQQA2AgALIAlFDQACQCACIAIoAhwiBEECdEG0xQVqIgEoAgBGBEAgASAGNgIAIAYNAUGIwwVBiMMFKAIAQX4gBHdxNgIADAILIAlBEEEUIAkoAhAgAkYbaiAGNgIAIAZFDQELIAYgCTYCGCACKAIQIgEEQCAGIAE2AhAgASAGNgIYCyACKAIUIgFFDQAgBiABNgIUIAEgBjYCGAsgAiAIaiECIAAgCGohAAsgAiACKAIEQX5xNgIEIAMgAEEBcjYCBCAAIANqIAA2AgAgAEH/AU0EQCAAQQN2IgFBA3RBrMMFaiEAAn9BhMMFKAIAIgRBASABdCIBcUUEQEGEwwUgASAEcjYCACAADAELIAAoAggLIQEgACADNgIIIAEgAzYCDCADIAA2AgwgAyABNgIIDAMLIAMCf0EAIABBCHYiBEUNABpBHyAAQf///wdLDQAaIAQgBEGA/j9qQRB2QQhxIgF0IgQgBEGA4B9qQRB2QQRxIgR0IgIgAkGAgA9qQRB2QQJxIgJ0QQ92IAEgBHIgAnJrIgFBAXQgACABQRVqdkEBcXJBHGoLIgE2AhwgA0IANwIQIAFBAnRBtMUFaiEEAkBBiMMFKAIAIgJBASABdCIFcUUEQEGIwwUgAiAFcjYCACAEIAM2AgAgAyAENgIYDAELIABBAEEZIAFBAXZrIAFBH0YbdCEBIAQoAgAhAgNAIAIiBCgCBEF4cSAARg0DIAFBHXYhAiABQQF0IQEgBCACQQRxakEQaiIFKAIAIgINAAsgBSADNgIAIAMgBDYCGAsgAyADNgIMIAMgAzYCCAwCC0GQwwUgBkFYaiIAQXggAmtBB3FBACACQQhqQQdxGyIFayIHNgIAQZzDBSACIAVqIgU2AgAgBSAHQQFyNgIEIAAgAmpBKDYCBEGgwwVB7MYFKAIANgIAIAEgA0EnIANrQQdxQQAgA0FZakEHcRtqQVFqIgAgACABQRBqSRsiBUEbNgIEIAVBzMYFKQIANwIQIAVBxMYFKQIANwIIQczGBSAFQQhqNgIAQcjGBSAGNgIAQcTGBSACNgIAQdDGBUEANgIAIAVBGGohAANAIABBBzYCBCAAQQhqIQIgAEEEaiEAIAMgAksNAAsgASAFRg0DIAUgBSgCBEF+cTYCBCABIAUgAWsiBkEBcjYCBCAFIAY2AgAgBkH/AU0EQCAGQQN2IgNBA3RBrMMFaiEAAn9BhMMFKAIAIgJBASADdCIDcUUEQEGEwwUgAiADcjYCACAADAELIAAoAggLIQMgACABNgIIIAMgATYCDCABIAA2AgwgASADNgIIDAQLIAFCADcCECABAn9BACAGQQh2IgNFDQAaQR8gBkH///8HSw0AGiADIANBgP4/akEQdkEIcSIAdCIDIANBgOAfakEQdkEEcSIDdCICIAJBgIAPakEQdkECcSICdEEPdiAAIANyIAJyayIAQQF0IAYgAEEVanZBAXFyQRxqCyIANgIcIABBAnRBtMUFaiEDAkBBiMMFKAIAIgJBASAAdCIFcUUEQEGIwwUgAiAFcjYCACADIAE2AgAgASADNgIYDAELIAZBAEEZIABBAXZrIABBH0YbdCEAIAMoAgAhAgNAIAIiAygCBEF4cSAGRg0EIABBHXYhAiAAQQF0IQAgAyACQQRxakEQaiIFKAIAIgINAAsgBSABNgIAIAEgAzYCGAsgASABNgIMIAEgATYCCAwDCyAEKAIIIgAgAzYCDCAEIAM2AgggA0EANgIYIAMgBDYCDCADIAA2AggLIAdBCGohAAwFCyADKAIIIgAgATYCDCADIAE2AgggAUEANgIYIAEgAzYCDCABIAA2AggLQZDDBSgCACIAIARNDQBBkMMFIAAgBGsiATYCAEGcwwVBnMMFKAIAIgAgBGoiAzYCACADIAFBAXI2AgQgACAEQQNyNgIEIABBCGohAAwDC0GoqgVBMDYCAEEAIQAMAgsCQCAHRQ0AAkAgBSgCHCIBQQJ0QbTFBWoiACgCACAFRgRAIAAgAjYCACACDQFBiMMFIAhBfiABd3EiCDYCAAwCCyAHQRBBFCAHKAIQIAVGG2ogAjYCACACRQ0BCyACIAc2AhggBSgCECIABEAgAiAANgIQIAAgAjYCGAsgBSgCFCIARQ0AIAIgADYCFCAAIAI2AhgLAkAgA0EPTQRAIAUgAyAEaiIAQQNyNgIEIAAgBWoiACAAKAIEQQFyNgIEDAELIAUgBEEDcjYCBCAEIAVqIgIgA0EBcjYCBCACIANqIAM2AgAgA0H/AU0EQCADQQN2IgFBA3RBrMMFaiEAAn9BhMMFKAIAIgNBASABdCIBcUUEQEGEwwUgASADcjYCACAADAELIAAoAggLIQEgACACNgIIIAEgAjYCDCACIAA2AgwgAiABNgIIDAELIAICf0EAIANBCHYiAUUNABpBHyADQf///wdLDQAaIAEgAUGA/j9qQRB2QQhxIgB0IgEgAUGA4B9qQRB2QQRxIgF0IgQgBEGAgA9qQRB2QQJxIgR0QQ92IAAgAXIgBHJrIgBBAXQgAyAAQRVqdkEBcXJBHGoLIgA2AhwgAkIANwIQIABBAnRBtMUFaiEBAkACQCAIQQEgAHQiBHFFBEBBiMMFIAQgCHI2AgAgASACNgIAIAIgATYCGAwBCyADQQBBGSAAQQF2ayAAQR9GG3QhACABKAIAIQQDQCAEIgEoAgRBeHEgA0YNAiAAQR12IQQgAEEBdCEAIAEgBEEEcWpBEGoiBigCACIEDQALIAYgAjYCACACIAE2AhgLIAIgAjYCDCACIAI2AggMAQsgASgCCCIAIAI2AgwgASACNgIIIAJBADYCGCACIAE2AgwgAiAANgIICyAFQQhqIQAMAQsCQCAKRQ0AAkAgAigCHCIDQQJ0QbTFBWoiACgCACACRgRAIAAgBTYCACAFDQFBiMMFIAlBfiADd3E2AgAMAgsgCkEQQRQgCigCECACRhtqIAU2AgAgBUUNAQsgBSAKNgIYIAIoAhAiAARAIAUgADYCECAAIAU2AhgLIAIoAhQiAEUNACAFIAA2AhQgACAFNgIYCwJAIAFBD00EQCACIAEgBGoiAEEDcjYCBCAAIAJqIgAgACgCBEEBcjYCBAwBCyACIARBA3I2AgQgAiAEaiIDIAFBAXI2AgQgASADaiABNgIAIAgEQCAIQQN2IgVBA3RBrMMFaiEEQZjDBSgCACEAAn9BASAFdCIFIAZxRQRAQYTDBSAFIAZyNgIAIAQMAQsgBCgCCAshBSAEIAA2AgggBSAANgIMIAAgBDYCDCAAIAU2AggLQZjDBSADNgIAQYzDBSABNgIACyACQQhqIQALIAtBEGokACAAC6oNAQd/AkAgAEUNACAAQXhqIgIgAEF8aigCACIBQXhxIgBqIQUCQCABQQFxDQAgAUEDcUUNASACIAIoAgAiAWsiAkGUwwUoAgAiBEkNASAAIAFqIQAgAkGYwwUoAgBHBEAgAUH/AU0EQCACKAIIIgcgAUEDdiIGQQN0QazDBWpHGiAHIAIoAgwiA0YEQEGEwwVBhMMFKAIAQX4gBndxNgIADAMLIAcgAzYCDCADIAc2AggMAgsgAigCGCEGAkAgAiACKAIMIgNHBEAgBCACKAIIIgFNBEAgASgCDBoLIAEgAzYCDCADIAE2AggMAQsCQCACQRRqIgEoAgAiBA0AIAJBEGoiASgCACIEDQBBACEDDAELA0AgASEHIAQiA0EUaiIBKAIAIgQNACADQRBqIQEgAygCECIEDQALIAdBADYCAAsgBkUNAQJAIAIgAigCHCIEQQJ0QbTFBWoiASgCAEYEQCABIAM2AgAgAw0BQYjDBUGIwwUoAgBBfiAEd3E2AgAMAwsgBkEQQRQgBigCECACRhtqIAM2AgAgA0UNAgsgAyAGNgIYIAIoAhAiAQRAIAMgATYCECABIAM2AhgLIAIoAhQiAUUNASADIAE2AhQgASADNgIYDAELIAUoAgQiAUEDcUEDRw0AQYzDBSAANgIAIAUgAUF+cTYCBCACIABBAXI2AgQgACACaiAANgIADwsgBSACTQ0AIAUoAgQiAUEBcUUNAAJAIAFBAnFFBEAgBUGcwwUoAgBGBEBBnMMFIAI2AgBBkMMFQZDDBSgCACAAaiIANgIAIAIgAEEBcjYCBCACQZjDBSgCAEcNA0GMwwVBADYCAEGYwwVBADYCAA8LIAVBmMMFKAIARgRAQZjDBSACNgIAQYzDBUGMwwUoAgAgAGoiADYCACACIABBAXI2AgQgACACaiAANgIADwsgAUF4cSAAaiEAAkAgAUH/AU0EQCAFKAIMIQQgBSgCCCIDIAFBA3YiBUEDdEGswwVqIgFHBEBBlMMFKAIAGgsgAyAERgRAQYTDBUGEwwUoAgBBfiAFd3E2AgAMAgsgASAERwRAQZTDBSgCABoLIAMgBDYCDCAEIAM2AggMAQsgBSgCGCEGAkAgBSAFKAIMIgNHBEBBlMMFKAIAIAUoAggiAU0EQCABKAIMGgsgASADNgIMIAMgATYCCAwBCwJAIAVBFGoiASgCACIEDQAgBUEQaiIBKAIAIgQNAEEAIQMMAQsDQCABIQcgBCIDQRRqIgEoAgAiBA0AIANBEGohASADKAIQIgQNAAsgB0EANgIACyAGRQ0AAkAgBSAFKAIcIgRBAnRBtMUFaiIBKAIARgRAIAEgAzYCACADDQFBiMMFQYjDBSgCAEF+IAR3cTYCAAwCCyAGQRBBFCAGKAIQIAVGG2ogAzYCACADRQ0BCyADIAY2AhggBSgCECIBBEAgAyABNgIQIAEgAzYCGAsgBSgCFCIBRQ0AIAMgATYCFCABIAM2AhgLIAIgAEEBcjYCBCAAIAJqIAA2AgAgAkGYwwUoAgBHDQFBjMMFIAA2AgAPCyAFIAFBfnE2AgQgAiAAQQFyNgIEIAAgAmogADYCAAsgAEH/AU0EQCAAQQN2IgFBA3RBrMMFaiEAAn9BhMMFKAIAIgRBASABdCIBcUUEQEGEwwUgASAEcjYCACAADAELIAAoAggLIQEgACACNgIIIAEgAjYCDCACIAA2AgwgAiABNgIIDwsgAkIANwIQIAICf0EAIABBCHYiBEUNABpBHyAAQf///wdLDQAaIAQgBEGA/j9qQRB2QQhxIgF0IgQgBEGA4B9qQRB2QQRxIgR0IgMgA0GAgA9qQRB2QQJxIgN0QQ92IAEgBHIgA3JrIgFBAXQgACABQRVqdkEBcXJBHGoLIgE2AhwgAUECdEG0xQVqIQQCQAJAAkBBiMMFKAIAIgNBASABdCIFcUUEQEGIwwUgAyAFcjYCACAEIAI2AgAgAiAENgIYDAELIABBAEEZIAFBAXZrIAFBH0YbdCEBIAQoAgAhAwNAIAMiBCgCBEF4cSAARg0CIAFBHXYhAyABQQF0IQEgBCADQQRxakEQaiIFKAIAIgMNAAsgBSACNgIAIAIgBDYCGAsgAiACNgIMIAIgAjYCCAwBCyAEKAIIIgAgAjYCDCAEIAI2AgggAkEANgIYIAIgBDYCDCACIAA2AggLQaTDBUGkwwUoAgBBf2oiAjYCACACDQBBzMYFIQIDQCACKAIAIgBBCGohAiAADQALQaTDBUF/NgIACwuGAQECfyAARQRAIAEQ9QwPCyABQUBPBEBBqKoFQTA2AgBBAA8LIABBeGpBECABQQtqQXhxIAFBC0kbEPgMIgIEQCACQQhqDwsgARD1DCICRQRAQQAPCyACIABBfEF4IABBfGooAgAiA0EDcRsgA0F4cWoiAyABIAMgAUkbEIANGiAAEPYMIAILvwcBCX8gACgCBCIGQQNxIQIgACAGQXhxIgVqIQMCQEGUwwUoAgAiCSAASw0AIAJBAUYNAAsCQCACRQRAQQAhAiABQYACSQ0BIAUgAUEEak8EQCAAIQIgBSABa0HkxgUoAgBBAXRNDQILQQAPCwJAIAUgAU8EQCAFIAFrIgJBEEkNASAAIAZBAXEgAXJBAnI2AgQgACABaiIBIAJBA3I2AgQgAyADKAIEQQFyNgIEIAEgAhD7DAwBC0EAIQIgA0GcwwUoAgBGBEBBkMMFKAIAIAVqIgMgAU0NAiAAIAZBAXEgAXJBAnI2AgQgACABaiICIAMgAWsiAUEBcjYCBEGQwwUgATYCAEGcwwUgAjYCAAwBCyADQZjDBSgCAEYEQEGMwwUoAgAgBWoiAyABSQ0CAkAgAyABayICQRBPBEAgACAGQQFxIAFyQQJyNgIEIAAgAWoiASACQQFyNgIEIAAgA2oiAyACNgIAIAMgAygCBEF+cTYCBAwBCyAAIAZBAXEgA3JBAnI2AgQgACADaiIBIAEoAgRBAXI2AgRBACECQQAhAQtBmMMFIAE2AgBBjMMFIAI2AgAMAQsgAygCBCIEQQJxDQEgBEF4cSAFaiIHIAFJDQEgByABayEKAkAgBEH/AU0EQCADKAIMIQIgAygCCCIDIARBA3YiBEEDdEGswwVqRxogAiADRgRAQYTDBUGEwwUoAgBBfiAEd3E2AgAMAgsgAyACNgIMIAIgAzYCCAwBCyADKAIYIQgCQCADIAMoAgwiBEcEQCAJIAMoAggiAk0EQCACKAIMGgsgAiAENgIMIAQgAjYCCAwBCwJAIANBFGoiAigCACIFDQAgA0EQaiICKAIAIgUNAEEAIQQMAQsDQCACIQkgBSIEQRRqIgIoAgAiBQ0AIARBEGohAiAEKAIQIgUNAAsgCUEANgIACyAIRQ0AAkAgAyADKAIcIgVBAnRBtMUFaiICKAIARgRAIAIgBDYCACAEDQFBiMMFQYjDBSgCAEF+IAV3cTYCAAwCCyAIQRBBFCAIKAIQIANGG2ogBDYCACAERQ0BCyAEIAg2AhggAygCECICBEAgBCACNgIQIAIgBDYCGAsgAygCFCIDRQ0AIAQgAzYCFCADIAQ2AhgLIApBD00EQCAAIAZBAXEgB3JBAnI2AgQgACAHaiIBIAEoAgRBAXI2AgQMAQsgACAGQQFxIAFyQQJyNgIEIAAgAWoiASAKQQNyNgIEIAAgB2oiAyADKAIEQQFyNgIEIAEgChD7DAsgACECCyACC9gCAQZ/QYB/IABNBEBBqKoFQTA2AgBBAA8LQRAgAEELakF4cSAAQQtJGyIAQcwAahD1DCIBRQRAQQAPCyABQXhqIQMCQCABQT9xRQRAIAMhAgwBCyABQXxqIgUoAgAiBkF4cSABQT9qQUBxQXhqIgEgAUFAayABIANrQQ9LGyICIANrIgFrIQQgBkEDcUUEQCADKAIAIQMgAiAENgIEIAIgASADajYCAAwBCyACIAQgAigCBEEBcXJBAnI2AgQgAiAEaiIEIAQoAgRBAXI2AgQgBSABIAUoAgBBAXFyQQJyNgIAIAIgAigCBEEBcjYCBCADIAEQ+wwLAkAgAigCBCIBQQNxRQ0AIAFBeHEiAyAAQRBqTQ0AIAIgACABQQFxckECcjYCBCAAIAJqIgEgAyAAayIAQQNyNgIEIAIgA2oiAyADKAIEQQFyNgIEIAEgABD7DAsgAkEIagsqAAJ/An9BMEGAfyABSQ0BGiABEPkMIgFFCwRAQTAPCyAAIAE2AgBBAAsLrAwBBn8gACABaiEFAkACQCAAKAIEIgJBAXENACACQQNxRQ0BIAAoAgAiAiABaiEBIAAgAmsiAEGYwwUoAgBHBEBBlMMFKAIAIQcgAkH/AU0EQCAAKAIIIgMgAkEDdiIGQQN0QazDBWpHGiADIAAoAgwiBEYEQEGEwwVBhMMFKAIAQX4gBndxNgIADAMLIAMgBDYCDCAEIAM2AggMAgsgACgCGCEGAkAgACAAKAIMIgNHBEAgByAAKAIIIgJNBEAgAigCDBoLIAIgAzYCDCADIAI2AggMAQsCQCAAQRRqIgIoAgAiBA0AIABBEGoiAigCACIEDQBBACEDDAELA0AgAiEHIAQiA0EUaiICKAIAIgQNACADQRBqIQIgAygCECIEDQALIAdBADYCAAsgBkUNAQJAIAAgACgCHCIEQQJ0QbTFBWoiAigCAEYEQCACIAM2AgAgAw0BQYjDBUGIwwUoAgBBfiAEd3E2AgAMAwsgBkEQQRQgBigCECAARhtqIAM2AgAgA0UNAgsgAyAGNgIYIAAoAhAiAgRAIAMgAjYCECACIAM2AhgLIAAoAhQiAkUNASADIAI2AhQgAiADNgIYDAELIAUoAgQiAkEDcUEDRw0AQYzDBSABNgIAIAUgAkF+cTYCBCAAIAFBAXI2AgQgBSABNgIADwsCQCAFKAIEIgJBAnFFBEAgBUGcwwUoAgBGBEBBnMMFIAA2AgBBkMMFQZDDBSgCACABaiIBNgIAIAAgAUEBcjYCBCAAQZjDBSgCAEcNA0GMwwVBADYCAEGYwwVBADYCAA8LIAVBmMMFKAIARgRAQZjDBSAANgIAQYzDBUGMwwUoAgAgAWoiATYCACAAIAFBAXI2AgQgACABaiABNgIADwtBlMMFKAIAIQcgAkF4cSABaiEBAkAgAkH/AU0EQCAFKAIMIQQgBSgCCCIDIAJBA3YiBUEDdEGswwVqRxogAyAERgRAQYTDBUGEwwUoAgBBfiAFd3E2AgAMAgsgAyAENgIMIAQgAzYCCAwBCyAFKAIYIQYCQCAFIAUoAgwiA0cEQCAHIAUoAggiAk0EQCACKAIMGgsgAiADNgIMIAMgAjYCCAwBCwJAIAVBFGoiAigCACIEDQAgBUEQaiICKAIAIgQNAEEAIQMMAQsDQCACIQcgBCIDQRRqIgIoAgAiBA0AIANBEGohAiADKAIQIgQNAAsgB0EANgIACyAGRQ0AAkAgBSAFKAIcIgRBAnRBtMUFaiICKAIARgRAIAIgAzYCACADDQFBiMMFQYjDBSgCAEF+IAR3cTYCAAwCCyAGQRBBFCAGKAIQIAVGG2ogAzYCACADRQ0BCyADIAY2AhggBSgCECICBEAgAyACNgIQIAIgAzYCGAsgBSgCFCICRQ0AIAMgAjYCFCACIAM2AhgLIAAgAUEBcjYCBCAAIAFqIAE2AgAgAEGYwwUoAgBHDQFBjMMFIAE2AgAPCyAFIAJBfnE2AgQgACABQQFyNgIEIAAgAWogATYCAAsgAUH/AU0EQCABQQN2IgJBA3RBrMMFaiEBAn9BhMMFKAIAIgRBASACdCICcUUEQEGEwwUgAiAEcjYCACABDAELIAEoAggLIQIgASAANgIIIAIgADYCDCAAIAE2AgwgACACNgIIDwsgAEIANwIQIAACf0EAIAFBCHYiBEUNABpBHyABQf///wdLDQAaIAQgBEGA/j9qQRB2QQhxIgJ0IgQgBEGA4B9qQRB2QQRxIgR0IgMgA0GAgA9qQRB2QQJxIgN0QQ92IAIgBHIgA3JrIgJBAXQgASACQRVqdkEBcXJBHGoLIgI2AhwgAkECdEG0xQVqIQQCQAJAQYjDBSgCACIDQQEgAnQiBXFFBEBBiMMFIAMgBXI2AgAgBCAANgIAIAAgBDYCGAwBCyABQQBBGSACQQF2ayACQR9GG3QhAiAEKAIAIQMDQCADIgQoAgRBeHEgAUYNAiACQR12IQMgAkEBdCECIAQgA0EEcWpBEGoiBSgCACIDDQALIAUgADYCACAAIAQ2AhgLIAAgADYCDCAAIAA2AggPCyAEKAIIIgEgADYCDCAEIAA2AgggAEEANgIYIAAgBDYCDCAAIAE2AggLC1UBAn9BgMcFKAIAIgEgAEEDakF8cSICaiEAAkAgAkEBTkEAIAAgAU0bDQAgAD8AQRB0SwRAIAAQQEUNAQtBgMcFIAA2AgAgAQ8LQaiqBUEwNgIAQX8LsgYCBX8GfiMAQYABayIFJAACQAJAAkAgAyAEQgBCABDMBkUNACADIAQQ/wwhByACQjCIpyIJQf//AXEiBkH//wFGDQAgBw0BCyAFQRBqIAEgAiADIAQQ1AYgBSAFKQMQIgQgBSkDGCICIAQgAhDOBiAFKQMIIQIgBSkDACEEDAELIAEgAkL///////8/gyAGrUIwhoQiCiADIARC////////P4MgBEIwiKdB//8BcSIIrUIwhoQiBBDMBkEATARAIAEgCiADIAQQzAYEQCABIQQMAgsgBUHwAGogASACQgBCABDUBiAFKQN4IQIgBSkDcCEEDAELIAVB4ABqIAEgCkIAQoCAgICAgMC7wAAQ1AYgBUHQAGogAyAEQgBCgICAgICAwLvAABDUBiAKIAUpA2giDSAGG0L///////8/g0KAgICAgIDAAIQiCiAEIAUpA1giDiAIG0L///////8/g0KAgICAgIDAAIQiD30gASAFKQNgIAYbIgQgAyAFKQNQIAgbIgxUrX0iC0J/VSEHIAQgDH0hAyAGIA1CMIinQYh/aiAGGyIGIAggDkIwiKdBiH9qIAgbIghKBEADQAJ+IAdBAXEEQCADIAuEUARAIAVBIGogASACQgBCABDUBiAFKQMoIQIgBSkDICEEDAULIAtCAYYhCyADQj+IDAELIARCP4ghCyAEIQMgCkIBhgsgC4QiCiAPfSADQgGGIgQgDFStfSILQn9VIQcgBCAMfSEDIAZBf2oiBiAISg0ACyAIIQYLAkAgB0UNACADIgQgCyIKhEIAUg0AIAVBMGogASACQgBCABDUBiAFKQM4IQIgBSkDMCEEDAELIApC////////P1gEQANAIARCP4ghAiAGQX9qIQYgBEIBhiEEIAIgCkIBhoQiCkKAgICAgIDAAFQNAAsLIAlBgIACcSEHIAZBAEwEQCAFQUBrIAQgCkL///////8/gyAGQfgAaiAHcq1CMIaEQgBCgICAgICAwMM/ENQGIAUpA0ghAiAFKQNAIQQMAQsgCkL///////8/gyAGIAdyrUIwhoQhAgsgACAENwMAIAAgAjcDCCAFQYABaiQAC6kBAQF8RAAAAAAAAPA/IQECQCAAQYAITgRARAAAAAAAAOB/IQEgAEH/D0gEQCAAQYF4aiEADAILRAAAAAAAAPB/IQEgAEH9FyAAQf0XSBtBgnBqIQAMAQsgAEGBeEoNAEQAAAAAAAAQACEBIABBg3BKBEAgAEH+B2ohAAwBC0QAAAAAAAAAACEBIABBhmggAEGGaEobQfwPaiEACyABIABB/wdqrUI0hr+iC0QCAX8BfiABQv///////z+DIQMCfyABQjCIp0H//wFxIgJB//8BRwRAQQQgAg0BGkECQQMgACADhFAbDwsgACADhFALC4IEAQN/IAJBgARPBEAgACABIAIQQRogAA8LIAAgAmohAwJAIAAgAXNBA3FFBEACQCACQQFIBEAgACECDAELIABBA3FFBEAgACECDAELIAAhAgNAIAIgAS0AADoAACABQQFqIQEgAkEBaiICIANPDQEgAkEDcQ0ACwsCQCADQXxxIgRBwABJDQAgAiAEQUBqIgVLDQADQCACIAEoAgA2AgAgAiABKAIENgIEIAIgASgCCDYCCCACIAEoAgw2AgwgAiABKAIQNgIQIAIgASgCFDYCFCACIAEoAhg2AhggAiABKAIcNgIcIAIgASgCIDYCICACIAEoAiQ2AiQgAiABKAIoNgIoIAIgASgCLDYCLCACIAEoAjA2AjAgAiABKAI0NgI0IAIgASgCODYCOCACIAEoAjw2AjwgAUFAayEBIAJBQGsiAiAFTQ0ACwsgAiAETw0BA0AgAiABKAIANgIAIAFBBGohASACQQRqIgIgBEkNAAsMAQsgA0EESQRAIAAhAgwBCyADQXxqIgQgAEkEQCAAIQIMAQsgACECA0AgAiABLQAAOgAAIAIgAS0AAToAASACIAEtAAI6AAIgAiABLQADOgADIAFBBGohASACQQRqIgIgBE0NAAsLIAIgA0kEQANAIAIgAS0AADoAACABQQFqIQEgAkEBaiICIANHDQALCyAAC/MCAgJ/AX4CQCACRQ0AIAAgAmoiA0F/aiABOgAAIAAgAToAACACQQNJDQAgA0F+aiABOgAAIAAgAToAASADQX1qIAE6AAAgACABOgACIAJBB0kNACADQXxqIAE6AAAgACABOgADIAJBCUkNACAAQQAgAGtBA3EiBGoiAyABQf8BcUGBgoQIbCIBNgIAIAMgAiAEa0F8cSIEaiICQXxqIAE2AgAgBEEJSQ0AIAMgATYCCCADIAE2AgQgAkF4aiABNgIAIAJBdGogATYCACAEQRlJDQAgAyABNgIYIAMgATYCFCADIAE2AhAgAyABNgIMIAJBcGogATYCACACQWxqIAE2AgAgAkFoaiABNgIAIAJBZGogATYCACAEIANBBHFBGHIiBGsiAkEgSQ0AIAGtIgVCIIYgBYQhBSADIARqIQEDQCABIAU3AxggASAFNwMQIAEgBTcDCCABIAU3AwAgAUEgaiEBIAJBYGoiAkEfSw0ACwsgAAvsAgECfwJAIAAgAUYNAAJAIAEgAmogAEsEQCAAIAJqIgQgAUsNAQsgACABIAIQgA0aDwsgACABc0EDcSEDAkACQCAAIAFJBEAgAwRAIAAhAwwDCyAAQQNxRQRAIAAhAwwCCyAAIQMDQCACRQ0EIAMgAS0AADoAACABQQFqIQEgAkF/aiECIANBAWoiA0EDcQ0ACwwBCwJAIAMNACAEQQNxBEADQCACRQ0FIAAgAkF/aiICaiIDIAEgAmotAAA6AAAgA0EDcQ0ACwsgAkEDTQ0AA0AgACACQXxqIgJqIAEgAmooAgA2AgAgAkEDSw0ACwsgAkUNAgNAIAAgAkF/aiICaiABIAJqLQAAOgAAIAINAAsMAgsgAkEDTQ0AA0AgAyABKAIANgIAIAFBBGohASADQQRqIQMgAkF8aiICQQNLDQALCyACRQ0AA0AgAyABLQAAOgAAIANBAWohAyABQQFqIQEgAkF/aiICDQALCwtZAQF/IAAgAC0ASiIBQX9qIAFyOgBKIAAoAgAiAUEIcQRAIAAgAUEgcjYCAEF/DwsgAEIANwIEIAAgACgCLCIBNgIcIAAgATYCFCAAIAEgACgCMGo2AhBBAAuDAQEDfyMAQRBrIgIkACACIAE6AA8CQCAAKAIQIgNFBEAgABCDDQ0BIAAoAhAhAwsCQCAAKAIUIgQgA08NACAALABLIAFB/wFxRg0AIAAgBEEBajYCFCAEIAE6AAAMAQsgACACQQ9qQQEgACgCJBEEAEEBRw0AIAItAA8aCyACQRBqJAALuAEBBH8CQCACKAIQIgMEfyADBSACEIMNDQEgAigCEAsgAigCFCIFayABSQRAIAIgACABIAIoAiQRBAAPCwJAIAIsAEtBAEgNACABIQQDQCAEIgNFDQEgACADQX9qIgRqLQAAQQpHDQALIAIgACADIAIoAiQRBAAiBCADSQ0BIAEgA2shASAAIANqIQAgAigCFCEFIAMhBgsgBSAAIAEQgA0aIAIgAigCFCABajYCFCABIAZqIQQLIAQLOwEBfyABIQMCQCACKAJMQX9MBEAgACADIAIQhQ0hAAwBCyAAIAMgAhCFDSEACyAAIANGBEAgAQ8LIAALKQEBfyMAQRBrIgIkACACIAE2AgxBqJoDKAIAIAAgARCvBiACQRBqJAALkAEBA38gACEBAkACQCAAQQNxRQ0AIAAtAABFBEBBAA8LA0AgAUEBaiIBQQNxRQ0BIAEtAAANAAsMAQsDQCABIgJBBGohASACKAIAIgNBf3MgA0H//ft3anFBgIGChHhxRQ0ACyADQf8BcUUEQCACIABrDwsDQCACLQABIQMgAkEBaiIBIQIgAw0ACwsgASAAawsHACAAEQYACwkAIAEgABEBAAsLACABIAIgABECAAsNACABIAIgAyAAEQUACw8AIAEgAiADIAQgABEHAAsRACABIAIgAyAEIAUgABELAAsVACABIAIgAyAEIAUgBiAHIAAREQALGwAgASACIAMgBCAFIAYgByAIIAkgCiAAERIACyUAIAEgAiADIAQgBSAGIAcgCCAJIAogCyAMIA0gDiAPIAARIwALCQAgASAAEQAACwsAIAEgAiAAEQMACw0AIAEgAiADIAARBAALDwAgASACIAMgBCAAEQoACxEAIAEgAiADIAQgBSAAEQgACxMAIAEgAiADIAQgBSAGIAARCQALFQAgASACIAMgBCAFIAYgByAAEQ8ACxsAIAEgAiADIAQgBSAGIAcgCCAJIAogABEhAAsdACABIAIgAyAEIAUgBiAHIAggCSAKIAsgABEaAAsfACABIAIgAyAEIAUgBiAHIAggCSAKIAsgDCAAER0ACxEAIAEgAiADIAQgBSAAER4ACwsAIAEgAiAAETMACw0AIAEgAiADIAAROAALDQAgASACIAMgABE6AAsEACMACxAAIwAgAGtBcHEiACQAIAALBgAgACQACwYAIABAAAsTACABIAIgAyAEIAUgBiAAEScACxcAIAEgAiADIAQgBSAGIAcgCCAAEQ4ACxMAIAEgAiADIAQgBSAGIAARDAALJQAgASACIAMgBCAFrSAGrUIghoQgB60gCK1CIIaEIAkgABErAAsZACABIAIgA60gBK1CIIaEIAUgBiAAERQACxUAIAEgAq0gA61CIIaEIAQgABEYAAsZACABIAIgAyAEIAWtIAatQiCGhCAAERUACyEAIAEgAiADrSAErUIghoQgBSAGIAcgCCAJIAogABEvAAsTACABIAKtIAOtQiCGhCAAERMACxgBAX4gASACIAARFgAiA0IgiKcQQiADpwscAQF+IAEgAiADIAQgABEfACIFQiCIpxBCIAWnCyEAIAEgAiADrSAErUIghoQgBSAGrSAHrUIghoQgABEQAAsiAQF+IAEgAq0gA61CIIaEIAQgABEbACIFQiCIpxBCIAWnCyMAIAEgAiADIAQgBa0gBq1CIIaEIAetIAitQiCGhCAAESYACyUAIAEgAiADIAQgBSAGrSAHrUIghoQgCK0gCa1CIIaEIAARJQALIgBBqwEgAEGQvwUgAacgAUIgiKcgAiADIAQgBSAGQQMQQwsTACAAIAEgAqcgAkIgiKcgAxBFCxIAIAAgAUEAEEatEAetQiCGhAsXACAAIAEgAiADpyADQiCIp0EAIAQQSAsWACAAIAEgAiADIAQQS60QB61CIIaECwuo7wNWAEGACAuDFUgyNjRNUDRFbmNvZGVyAG91dHB1dEZpbGVuYW1lAHdpZHRoAGhlaWdodABmcmFtZVJhdGUAa2JwcwBzcGVlZABxdWFudGl6YXRpb25QYXJhbWV0ZXIAZ3JvdXBPZlBpY3R1cmVzAHRlbXBvcmFsRGVub2lzZQBkZXNpcmVkTmFsdUJ5dGVzAGRlYnVnAGluaXRpYWxpemUAYWRkRnJhbWVZdXYAYWRkRnJhbWVSZ2JhAGZpbmFsaXplAEVSUk9SICVzKCVkKTogJXMKICAgIEVYUFI6ICVzCiAgICBGVU5DOiAlcwoAL2hvbWUvdXNlci9oMjY0LW1wNC1lbmNvZGVyLmgAQ2Fubm90IHNldCBwcm9wZXJ0aWVzIGFmdGVyIGluaXRpYWxpemUAIXByaXZhdGVfAHZvaWQgSDI2NE1QNEVuY29kZXI6OnNldF9vdXRwdXRGaWxlbmFtZShjb25zdCBzdGQ6OnN0cmluZyAmKQB2b2lkIEgyNjRNUDRFbmNvZGVyOjpzZXRfd2lkdGgoY29uc3QgdWludDMyX3QgJikAdm9pZCBIMjY0TVA0RW5jb2Rlcjo6c2V0X2hlaWdodChjb25zdCB1aW50MzJfdCAmKQB2b2lkIEgyNjRNUDRFbmNvZGVyOjpzZXRfZnJhbWVSYXRlKGNvbnN0IHVpbnQzMl90ICYpAHZvaWQgSDI2NE1QNEVuY29kZXI6OnNldF9rYnBzKGNvbnN0IHVpbnQzMl90ICYpAHZvaWQgSDI2NE1QNEVuY29kZXI6OnNldF9zcGVlZChjb25zdCB1aW50MzJfdCAmKQB2b2lkIEgyNjRNUDRFbmNvZGVyOjpzZXRfcXVhbnRpemF0aW9uUGFyYW1ldGVyKGNvbnN0IHVpbnQzMl90ICYpAHZvaWQgSDI2NE1QNEVuY29kZXI6OnNldF9ncm91cE9mUGljdHVyZXMoY29uc3QgdWludDMyX3QgJikAdm9pZCBIMjY0TVA0RW5jb2Rlcjo6c2V0X3RlbXBvcmFsRGVub2lzZShjb25zdCBib29sICYpAHZvaWQgSDI2NE1QNEVuY29kZXI6OnNldF9kZXNpcmVkTmFsdUJ5dGVzKGNvbnN0IHVpbnQzMl90ICYpAHZvaWQgSDI2NE1QNEVuY29kZXI6OnNldF9kZWJ1Zyhjb25zdCBib29sICYpADE0SDI2NE1QNEVuY29kZXIA7P4AAIcHAABQMTRIMjY0TVA0RW5jb2RlcgAAAMz/AACgBwAAAAAAAJgHAABQSzE0SDI2NE1QNEVuY29kZXIAAMz/AADEBwAAAQAAAJgHAABpaQB2AHZpALQHAABvdXRwdXQubXA0AE5TdDNfXzIxMmJhc2ljX3N0cmluZ0ljTlNfMTFjaGFyX3RyYWl0c0ljRUVOU185YWxsb2NhdG9ySWNFRUVFAE5TdDNfXzIyMV9fYmFzaWNfc3RyaW5nX2NvbW1vbklMYjFFRUUA7P4AAD4IAABw/wAA/wcAAAAAAAABAAAAZAgAAAAAAABpaWkAdmlpaQAAAABA/gAAtAcAAHZpaQBA/gAAtAcAAGwIAABFUlJPUiAlcyglZCk6ICVzCiAgICBFWFBSOiAlcwogICAgRlVOQzogJXMKAC9ob21lL3VzZXIvaDI2NC1tcDQtZW5jb2Rlci5jcHAASW50ZXJuYWwgZXJyb3IAc2l6ZSA+PSA1AHN0YXRpYyB2b2lkIEgyNjRNUDRFbmNvZGVyUHJpdmF0ZTo6bmFsdV9jYWxsYmFjayhjb25zdCB1aW50OF90ICosIGludCwgdm9pZCAqKQBkYXRhWzBdID09IDAgJiYgZGF0YVsxXSA9PSAwICYmIGRhdGFbMl0gPT0gMCAmJiBkYXRhWzNdID09IDEAbmFsdT0AU1BTAFBQUwBVbmtub3duIGZyYW1lIHR5cGUAZmFsc2UALCBoZXg9ACUwMlgALi4uACwgYnl0ZXM9JWQKAGVuY29kZXJfcHJpdmF0ZS0+dmlkZW9fdHJhY2sgIT0gKChNUDRUcmFja0lkKTApAE1QNFdyaXRlU2FtcGxlKGVuY29kZXJfcHJpdmF0ZS0+bXA0LCBlbmNvZGVyX3ByaXZhdGUtPnZpZGVvX3RyYWNrLCBkYXRhLCBzaXplLCAoKE1QNER1cmF0aW9uKS0xKSwgMCwgMSkAQ2Fubm90IGNhbGwgaW5pdGlhbGl6ZSBtb3JlIHRoYW4gb25jZSB3aXRob3V0IGNhbGxpbmcgZmluYWxpemUAIXByaXZhdGVfAHZvaWQgSDI2NE1QNEVuY29kZXI6OmluaXRpYWxpemUoKQBwcml2YXRlXwAhb3V0cHV0RmlsZW5hbWUuZW1wdHkoKQB3aWR0aCA+IDAAaGVpZ2h0ID4gMABmcmFtZVJhdGUgPiAwAHF1YW50aXphdGlvblBhcmFtZXRlciA+PSAxMCAmJiBxdWFudGl6YXRpb25QYXJhbWV0ZXIgPD0gNTEAc3BlZWQgPD0gMTAAcHJpdmF0ZV8tPm1wNCAhPSAoKE1QNEZpbGVIYW5kbGUpMEwpAFNpemUgbXVzdCBiZSBhIG11bHRpcGxlIG9mIDIAc2l6ZW9mX3Jlc3VsdCAhPSBIMjY0RV9TVEFUVVNfU0laRV9OT1RfTVVMVElQTEVfMgBzaXplb2ZfcmVzdWx0ID09IDAAc2l6ZW9mX3BlcnNpc3Q9JWQsIHNpemVvZl9zY3JhdGNoPSVkCgBGdW5jdGlvbiBpbml0aWFsaXplIGhhcyBub3QgYmVlbiBjYWxsZWQAdm9pZCBIMjY0TVA0RW5jb2Rlcjo6YWRkRnJhbWVZdXYoY29uc3Qgc3RkOjpzdHJpbmcgJikASW5jb3JyZWN0IGJ1ZmZlciBzaXplIGZvciBZVVYgKHdpZHRoICogaGVpZ2h0ICogMyAvIDIpAHl1dl9idWZmZXIuc2l6ZSgpID09IHdpZHRoICogaGVpZ2h0ICogMyAvIDIASDI2NEVfZW5jb2RlKCBwcml2YXRlXy0+ZW5jLCBwcml2YXRlXy0+c2NyYXRjaCwgJnJ1bl9wYXJhbSwgJnl1dl9wbGFuZXMsICZjb2RlZF9kYXRhLCAmc2l6ZW9mX2NvZGVkX2RhdGEpID09IDAAZnJhbWU9JWQsIGJ5dGVzPSVkCgB2b2lkIEgyNjRNUDRFbmNvZGVyOjphZGRGcmFtZVJnYmEoY29uc3Qgc3RkOjpzdHJpbmcgJikASW5jb3JyZWN0IGJ1ZmZlciBzaXplIGZvciBSR0JBICh3aWR0aCAqIGhlaWdodCAqIDQpAHJnYmFfYnVmZmVyLnNpemUoKSA9PSB3aWR0aCAqIGhlaWdodCAqIDQAdm9pZCBIMjY0TVA0RW5jb2Rlcjo6ZmluYWxpemUoKQBGdW5jdGlvbiBmaW5hbGl6ZSB3YXMgbm90IGNhbGxlZCBiZWZvcmUgdGhlIGVuY29kZXIgZGVzdHJ1Y3RlZABwcml2YXRlXyA9PSBudWxscHRyAEgyNjRNUDRFbmNvZGVyOjp+SDI2NE1QNEVuY29kZXIoKQBBkR0LvwIQGSAlKSwwMjU3OTs8PkBBQkNFRkdISUpLTExNTk9QUFFSUlNTVFVVVlZXV1hYWVlaWltbXFxcXV1eXl5fX2BgYGFhYWJiYmNjY2NkZGRlZWVmZmZmZ2dnZ2hoaGhpaWlpampqampra2trbGxsbGxtbW1tbW5ubm5ub29vb29wcHBwcHBxcXFxcXFycnJycnJzc3Nzc3NzdHR0dHR0dXV1dXV1dXZ2dnZ2dnZ2d3d3d3d3d3d4eHh4eHh4eHl5eXl5eXl5enp6enp6enp6e3t7e3t7e3t7fHx8fHx8fHx8fX19fX19fX19fX5+fn5+fn5+fn5+f39/f39/f39/f4BvdXRfdmFsIDw9IDI1NQAvaG9tZS91c2VyL21pbmloMjY0L21pbmloMjY0ZS5oAGgyNjRlX2Rlbm9pc2VfcnVuAEHgHwuDBArgYwAjAAAAjAEAAArwYwBGAAAAjAEAAAvgjAFkAAAAhAMAAAzgjAHIAAAASAkAAA3gjAGQAQAASAkAABTgjAGQAQAASAkAABXgGAMgAwAAkBIAABbgVAYgAwAApB8AAB7gVAbQBwAApB8AAB/gEA7wCgAAUEYAACDgABSgDwAAAFAAACjgACCIEwAAAIAAACngACDUMAAAAIAAACrgACLUMAAAAIgAADLgQFZ4aQAAQK8BADPgAJCAuwAAANACAElTX0FMSUdORUQoZCwgNCkAbmFsX3N0YXJ0ACEodmFsID4+IG4pAGgyNjRlX2JzX3B1dF9iaXRzACh1bnNpZ25lZCluIDw9IDMyAC1icy0+c2hpZnQgPCAzMgAoaW50KXBvc19iaXRzID49IDAAaDI2NGVfYnNfZ2V0X3Bvc19iaXRzAGQgKyBqIDw9IHMAbmFsX3B1dF9lc2MAAAAAAACYAlUCEgLkAbABgAFVASkBBgHrAMYArQCZAIMAcgBmAFQASgBAADYALwAqACMAHwAaABYAFAARAA8ADQAMAAoACQAJAAcABwAGAAUABAABAAEAIQTPA50DZAMjA+QCtgJ2AkoCIwLwAckBpAF6AVkBPgEcAQIB6gDSAL4AsgCbAI0AgQBzAGYAXwBSAEsARQA8ADcAMwAtACkAKAAjAB8AHAAYAEHwIwtHMzMKAIIfDQB7FBAAjC4LAEIdDgA0EhIAYicNAJoZEABiEBQAkiQOAMEWEgA/DhcAACAQAHsUFAAbDRkAchwSAM8RFwBNCx0AQcAkC7gDkS2RLZEtkS2RLZEtkS2RLZEtkS2RLUQy9zapO1xAD0VMRYlFx0UERkFGJUQIQuw/zz2zO147CTuzOl46CTozPV5AiEOzRt1JDUs9TG5Nnk7OT9g/4y/tH/gP+A/4D/gP+A/4D/gP+A8AAAAAAAAAAFsNWw1bDVsNWw1bDVsNWw1bDVsNVneNIr838kwkYlZ3dHOSb7Frz2ftY8RinGFzYEtfIl40XkZeWV5rXn1eyl0YXWVcs1sAWxFcIl0zXkRfVWARTc05iSZFE1Vgqw1VG/8oqTZTRFNEAAAAAAAAAACGfIZ8hnyGfIZ8hnyGfIZ8hnyGfIZ8KoPOiXKQFpe6nf+hQ6aIqsyuEbNgtbC3/7lPvJ6+ysD3wiPFUMd8yXzJfMl8yXzJfMn+y4DOAtGE0wbWg7MAkX5u+0t4KW4kZB9ZGk8VRRBFEAAAAAAAAAAAKLEosSixKLEosSixKLEosSixKLEosYyg8I9Vf7luHV4wZUNsVXNoenuBlYKvg8qE5IX+hoaADnqWcx5tpmZtaTRs/G7DcYp0bnFSbjVrGWj9ZJBbJFK3SEs/3jWBKyQhyBZrDA4CDgIAQYEoC2UBAgMEBQYHCAkKCwwNDg8QERITFBUWFxgZGhscHR0eHyAgISIiIyMkJCUlJSYmJicnJydJU19BTElHTkVEKGQsIDgpAGgyNjRlX2NvcHlfMTZ4MTYASVNfQUxJR05FRChzLCA4KQBB8CgLAQEAQYApC/ECLQAtAC0ALQAtAC0ALQAtAC0ALQAtAC0ALQAsACwALAAoACUAIQAeABoAIAAmAC0AMwA5ADoAOgA7ADsAPABCAEkATwBWAFwAXwBiAGQAZwBqAMgALAGQAfQBWAK8AiADhAPoA2EFYQVuY2FuZCA8PSBNQVhfTVZfQ0FORABpbnRlcl9jaG9vc2VfbW9kZQAAAQAAAAQAAAAEAAAADAAAAA4ADgAOAA4ADgAOAA4ADgAOAA4ADgANAAsACgAIAAcACwAPABQAGAAcAB4AHwAhACIAJAAwADwARwBTAF8AXwBfAGAAYABgAHEAggCTAKQAtQCRAWwCSAMjBP8E7gTeBM0EvQSsBKwEbXZfaW5fcmVjdChtdl9za2lwX2EsICZlbmMtPmZyYW1lLm12X3FwZWxfbGltaXQpAHdoLnMueCA9PSAxNiAmJiB3aC5zLnkgPT0gMTYAaDI2NGVfcXBlbF9pbnRlcnBvbGF0ZV9sdW1hAEGALAu0Ag0ADQANAA0ADQANAA0ADQANAA0ADQAOAA8ADwAQABEAEgAUABUAFwAYABwAIAAlACkALQA1AD4ARgBPAFcAaQB7AIwAngCwAMMA1gDqAP0AEAGWAR0CowIqA7ADfwNNAxwD6gK5ArkCeSA8IDQAbWVfbXZfbWVkaWFucHJlZGljdG9yX2dldAB4IDwgNAB3IDw9IDQAaCA8PSA0AAAAAAAEAAAA/P8AAAAABAAAAPz/bXZfaW5fcmVjdCgqbXYsIHJhbmdlKQBtZV9zZWFyY2hfZGlhbW9uZABoMjY0ZV9jb3B5Xzh4OAAhKCh1bnNpZ25lZCkodWludHB0cl90KWQgJiA3KQBoMjY0ZV9jb3B5Xzh4OF9zACEoKHVuc2lnbmVkKSh1aW50cHRyX3QpcyAmIDcpAEHgLguTAQMABwAKAA4AEQAOAAoABwADADIAFAAnADsATgBiAF4AWQBVAFAATAB2AKEAywD2ACABXQGaAdYBEwJQAj8CLgIcAgsC+gH6AQQFBgcEBQYPSVNfQUxJR05FRChwcmVkaWN0LCA0KQBoMjY0ZV9pbnRyYV9wcmVkaWN0XzE2eDE2AElTX0FMSUdORUQodG9wLCA0KQBBgDAL5wEbABsAGwAbABsAGwAbABsAGwAbABsAHwAiACYAKQAtAEwAagCJAKcAxgDcAPMACQEgATYBWwGAAaUBygHvAUgCoQL7AlQDrQMdBI0E/ARsBdwFtQSOA2YCPwGIE6gFOAvIEFgW6BvoGwAAAAAAAAAAByMjK5t3/3eb//93m3f/dwAAAQACAAMABAAFAAYABwAIAAkABwAHAAcABwAHAAcABwAHAAcABwAYABgAGAAYABgAGAAYABgAGAAYACwALAAsACwALAAsACwALAAsACwARABEAEQARABEAEQARABEAEQARABkAGQAQfExC58BAgACAgQCBAACAAICBAIESVNfQUxJR05FRChvdXQsIDQpAGgyNjRlX3RyYW5zZm9ybV9hZGQASVNfQUxJR05FRChwcmVkLCA0KQAhKG91dF9zdHJpZGUgJSA0KQBoMjY0ZV9pbnRyYV9wcmVkaWN0X2Nocm9tYQBlbmMtPnNsaWNlLnR5cGUgIT0gU0xJQ0VfVFlQRV9JAG1iX3dyaXRlAEGhMwu2AQEEBQIDBgcICQwNCgsODwMdHhEfEiUIICYTCRQKCwIQISIVIxYnBCQoFwUYBgcBKSorGSwaLgwtLxsNHA4PAAACAwcECBENBRIJDgoPEAsBICEkIiUsKCMtJiknKisTBhgZFBoVLhwbLxYdFx4fDCEocWRhdFsxXSAmIDMpAGgyNjRlX3F1YW50X2x1bWFfZGMAIShxZGF0WzFdICYgMSkAaDI2NGVfcXVhbnRfY2hyb21hX2RjAEHgNAuzAiMjZGSlpaWl5ubm5ubm5ubmEhEQElV1ZSYGRTYn/zU3//8lEBESNFVFVjV3Z1dGeGhYR3lpWUh6alpJ/OzcSrysnMyM7d3N/a2djb3u3s7+rp6Ovh7fz//vn4+/r1//f2///08xITJTtXSVQ3WlVWR2ZVaFd2ZXRUdnWEZ4aNpI+uqayrqq24r765vLu6vczIvsnIz8rGwcvL2tTXyNXf+dbf//ffPj08P19OSztcS0o4WklJP2hNWDtuWV1Jal1sWG5qbG9+fXx7enl4f46NjIuKiYqYh4uWnZyXkpmYk5/1lJ//8ZAwEGCwAFCg8ECQ4TCA0SFwwRFhsQFRofFBkeIxgdIiccISYrICUqLyQpLjMoLTI3LDE2OzA1Oj80OT4AOD0AADwDBwoREhMDERICEQEAQaA3C7YBDx8uPElVYGpze4KIjZGUETMjNCQ1JTYmNyc4KDkpGXNjU0MzVEQ0JDUlNiYWBlRzY1NENEMzJDUlFhUGNXNURGNTQzQzJCUVBVRENHNjU0MzJBUUBRYVc2NTQzMjFBMGFhVTQzMyIxQTBhYUFTMyIiMTBhYGFDIiExIVFQUTMiISFAQUEyMRMwQUEhETAxMREgISEQERemVyb3NfbGVmdCA8IDE0AGgyNjRlX3ZsY19lbmNvZGUAQeA4CzkPERQYHSMqKioqKioqKioRARESAjIiEgIyIhITAzIiMyMTAzIDEzMjU0NzY1NDMyMTFBUWFxgZGhsAQb45C8kBBAAAAAIEAAABAgUAAAECBgAAAQMHAAABAwgAAQEDCQABAQMKAQEBBAwBAQEEDQEBAQQPAQEBBhEBAQIGFAEBAgcWAQECBxkBAQIIHAECAwggAQIDCSQCAgMJKAICBAotAgMECjICAwQLOAMDBQs/AwQGDEcDBAYMUAQFBw1aBAUIDWUEBgkOcQUHCg5/BggLD5AGCA0PogcKDhC2CAsQEMsJDBIR4goNFBH/Cw8XEv8NERkSZW5jLT5tYi5udW0AcmNfbWJfZW5kAEGROwulRCAAAP8gAv/+HwT//R4G//0cCP/8Ggv//BgO/v0WEP39ExP9/RAW/f4OGPz/Cxr8/wgc/f8GHv3/BB/+/wIg/2lsbGVnYWwgYXJyYXkgaW5kZXg6IAAgb2YgAC9ob21lL3VzZXIvbGlibXA0djIvc3JjL21wNGF0b20uaABvcGVyYXRvcltdAERlbGV0ZQAAAAAAAJQeAAA9AAAAPgAAAD8AAABhc3NlcnQgZmFpbHVyZTogKGZpbGVfKQAvaG9tZS91c2VyL2xpYm1wNHYyL3NyYy9leGNlcHRpb24uY3BwAEV4Y2VwdGlvbgBONW1wNHYyNGltcGw5RXhjZXB0aW9uRQDs/gAAfB4AAGFzc2VydCBmYWlsdXJlOiAoZnVuY3Rpb25fKQA6IAAgKAAsACkAAAAAAAAABB8AAD0AAABAAAAAQQAAADogZXJybm86IABONW1wNHYyNGltcGwxN1BsYXRmb3JtRXhjZXB0aW9uRQAAFP8AAOIeAACUHgAAOAAAAAAAAAC4HwAAQgAAAEMAAADI////yP///7gfAABEAAAARQAAABwfAABUHwAAaB8AADAfAAA4AAAAAAAAANzPAABGAAAARwAAAMj////I////3M8AAEgAAABJAAAATlN0M19fMjE5YmFzaWNfb3N0cmluZ3N0cmVhbUljTlNfMTFjaGFyX3RyYWl0c0ljRUVOU185YWxsb2NhdG9ySWNFRUVFAAAAFP8AAHAfAADczwAAAAAAAEggAABKAAAASwAAAEwAAABNAAAATgAAAE8AAABQAAAAUQAAAFIAAABTAAAAVAAAAFUAAABWAAAAVwAAAE5TdDNfXzIxNWJhc2ljX3N0cmluZ2J1ZkljTlNfMTFjaGFyX3RyYWl0c0ljRUVOU185YWxsb2NhdG9ySWNFRUVFAAAAFP8AAAQgAABczwAAYXZjQwAAAAAAAAAA3CEAAGEAAABiAAAAYwAAAGQAAABlAAAAZgAAAGcAAABoAAAAaQAAAGNvbmZpZ3VyYXRpb25WZXJzaW9uAEFWQ1Byb2ZpbGVJbmRpY2F0aW9uAHByb2ZpbGVfY29tcGF0aWJpbGl0eQBBVkNMZXZlbEluZGljYXRpb24AcmVzZXJ2ZWQAbGVuZ3RoU2l6ZU1pbnVzT25lAHJlc2VydmVkMQBudW1PZlNlcXVlbmNlUGFyYW1ldGVyU2V0cwBzZXF1ZW5jZUVudHJpZXMAc2VxdWVuY2VQYXJhbWV0ZXJTZXRMZW5ndGgAc2VxdWVuY2VQYXJhbWV0ZXJTZXROQUxVbml0AG51bU9mUGljdHVyZVBhcmFtZXRlclNldHMAcGljdHVyZUVudHJpZXMAcGljdHVyZVBhcmFtZXRlclNldExlbmd0aABwaWN0dXJlUGFyYW1ldGVyU2V0TkFMVW5pdABONW1wNHYyNGltcGwxMU1QNEF2Y0NBdG9tRQAU/wAAwSEAADRoAABpbGxlZ2FsIGFycmF5IGluZGV4OiAAIG9mIAAvaG9tZS91c2VyL2xpYm1wNHYyL3NyYy9tcDRhcnJheS5oAG9wZXJhdG9yW10AL2hvbWUvdXNlci9saWJtcDR2Mi9zcmMvbXA0cHJvcGVydHkuaAAAAAAAALQiAABqAAAAawAAAGwAAABtAAAAbgAAAG8AAABwAAAAcQAAAHIAAABzAAAAdAAAAHUAAABONW1wNHYyNGltcGwxN1NpemVUYWJsZVByb3BlcnR5RQAAAAAU/wAAkCIAAFSpAABwcm9wZXJ0eSBpcyByZWFkLW9ubHk6IABTZXRWYWx1ZQBpbGxlZ2FsIGFycmF5IGluZGV4AEluc2VydAAAAAAA/CMAAHkAAAB6AAAAYXNzZXJ0IGZhaWx1cmU6ICh2ZXJib3NpdHlfICE9IE1QNF9MT0dfTk9ORSkAL2hvbWUvdXNlci9saWJtcDR2Mi9zcmMvbG9nLmNwcAB2ZHVtcABhc3NlcnQgZmFpbHVyZTogKGZvcm1hdCkAYXNzZXJ0IGZhaWx1cmU6IChmb3JtYXRbMF0gIT0gJ1wwJykAJSpjAHZwcmludGYAYXNzZXJ0IGZhaWx1cmU6IChwQnl0ZXMgfHwgKG51bUJ5dGVzID09IDApKQBoZXhEdW1wAAA6IAAgICAAJXMATjVtcDR2MjRpbXBsM0xvZ0UAAAAA7P4AAOcjAAAAAAAAbCwAAIoAAACLAAAAjAAAAI0AAACOAAAAjwAAAJAAAABpZAByZWZJbmRleABJUElFU0lkAGxhbmd1YWdlQ29kZQB0aXRsZQB2YWx1ZQBJUE1QRGVzY3JpcHRvcklkAHByb2ZpbGVMZXZlbEluZGljYXRpb25JbmRleABPRFByb2ZpbGVMZXZlbEluZGljYXRpb24Ac2NlbmVQcm9maWxlTGV2ZWxJbmRpY2F0aW9uAGF1ZGlvUHJvZmlsZUxldmVsSW5kaWNhdGlvbgB2aXN1YWxQcm9maWxlTGV2ZWxJbmRpY2F0aW9uAGdyYXBoaWNzUHJvZmlsZUxldmVsSW5kaWNhdGlvbgBNUEVHSlByb2ZpbGVMZXZlbEluZGljYXRpb24AJXM6ICIlcyI6IGVycm9yIGluIGJhc2UgZGVzY3JpcHRvciAtIHRhZyAldQBNUDRCYXNlRGVzY3JpcHRvcgAAAAAAAAAAHCsAAIoAAACRAAAAjAAAAJIAAACOAAAAjwAAAJAAAABkYXRhAGluZm8ASVBNUFNUeXBlAElQTVBEYXRhAGZvcm1hdElkZW50aWZpZXIAYWRkaXRpb25hbElkZW50aWZpY2F0aW9uSW5mbwAlczogIiVzIjogZXJyb3IgaW4gYnl0ZXMgZGVzY3JpcHRvciAtIHRhZyAldQBNUDRCeXRlc0Rlc2NyaXB0b3IAAAAAAABIKwAAigAAAJMAAACUAAAAjQAAAI4AAACPAAAAlQAAAG9iamVjdERlc2NyaXB0b3JJZABVUkxGbGFnAGluY2x1ZGVJbmxpbmVQcm9maWxlTGV2ZWxGbGFnAHJlc2VydmVkAFVSTABPRFByb2ZpbGVMZXZlbElkAHNjZW5lUHJvZmlsZUxldmVsSWQAYXVkaW9Qcm9maWxlTGV2ZWxJZAB2aXN1YWxQcm9maWxlTGV2ZWxJZABncmFwaGljc1Byb2ZpbGVMZXZlbElkAGVzSWRzAG9jaURlc2NyAGlwbXBEZXNjclB0cgBleHREZXNjcgAAAAAAdCsAAIoAAACWAAAAlwAAAI0AAACOAAAAjwAAAJgAAAAAAAAAoCsAAIoAAACZAAAAjAAAAI0AAACOAAAAjwAAAJoAAABFU0lEAHN0cmVhbURlcGVuZGVuY2VGbGFnAE9DUnN0cmVhbUZsYWcAc3RyZWFtUHJpb3JpdHkAZGVwZW5kc09uRVNJRABPQ1JFU0lEAGRlY0NvbmZpZ0Rlc2NyAHNsQ29uZmlnRGVzY3IAaXBpUHRyAGlwSWRzAGxhbmdEZXNjcgBxb3NEZXNjcgByZWdEZXNjcgAAAAAAANQrAACKAAAAmwAAAJwAAACNAAAAjgAAAI8AAACQAAAAb2JqZWN0VHlwZUlkAHN0cmVhbVR5cGUAdXBTdHJlYW0AYnVmZmVyU2l6ZURCAG1heEJpdHJhdGUAYXZnQml0cmF0ZQBkZWNTcGVjaWZpY0luZm8AcHJvZmlsZUxldmVsSW5kaWNhdGlvbkluZGV4RGVzY3IAAAAAAAAAAAgsAACKAAAAnQAAAJ4AAACfAAAAjgAAAI8AAACgAAAAcHJlZGVmaW5lZAB1c2VBY2Nlc3NVbml0U3RhcnRGbGFnAHVzZUFjY2Vzc1VuaXRFbmRGbGFnAHVzZVJhbmRvbUFjY2Vzc1BvaW50RmxhZwBoYXNSYW5kb21BY2Nlc3NVbml0c09ubHlGbGFnAHVzZVBhZGRpbmdGbGFnAHVzZVRpbWVTdGFtcHNGbGFnAHVzZUlkbGVGbGFnAGR1cmF0aW9uRmxhZwB0aW1lU3RhbXBSZXNvbHV0aW9uAE9DUlJlc29sdXRpb24AdGltZVN0YW1wTGVuZ3RoAE9DUkxlbmd0aABBVUxlbmd0aABpbnN0YW50Qml0cmF0ZUxlbmd0aABkZWdyYWRhdGlvblByaW9ydHlMZW5ndGgAQVVTZXFOdW1MZW5ndGgAcGFja2V0U2VxTnVtTGVuZ3RoAHRpbWVTY2FsZQBhY2Nlc3NVbml0RHVyYXRpb24AY29tcG9zaXRpb25Vbml0RHVyYXRpb24Ac3RhcnREZWNvZGluZ1RpbWVTdGFtcABzdGFydENvbXBvc2l0aW9uVGltZVN0YW1wAAAAAAAAADwsAACKAAAAoQAAAIwAAACiAAAAjgAAAI8AAACjAAAAY29tcGF0aWJpbGl0eQBjb250ZW50VHlwZUZsYWcAY29udGVudElkRmxhZwBwcm90ZWN0ZWRDb250ZW50AGNvbnRlbnRUeXBlAGNvbnRlbnRJZFR5cGUAY29udGVudElkAGluY29tcGF0aWJsZSBjb250ZW50IGlkIGRlc2NyaXB0b3IATjVtcDR2MjRpbXBsMThNUDRCeXRlc0Rlc2NyaXB0b3JFAAAAFP8AAPgqAABoawAATjVtcDR2MjRpbXBsMTVNUDRJT0Rlc2NyaXB0b3JFAAAU/wAAKCsAAGhrAABONW1wNHYyNGltcGwxNE1QNE9EZXNjcmlwdG9yRQAAABT/AABUKwAAaGsAAE41bXA0djI0aW1wbDE1TVA0RVNEZXNjcmlwdG9yRQAAFP8AAIArAABoawAATjVtcDR2MjRpbXBsMjJNUDREZWNDb25maWdEZXNjcmlwdG9yRQAAABT/AACsKwAAaGsAAE41bXA0djI0aW1wbDIxTVA0U0xDb25maWdEZXNjcmlwdG9yRQAAAAAU/wAA4CsAAGhrAABONW1wNHYyNGltcGwyMk1QNENvbnRlbnRJZERlc2NyaXB0b3JFAAAAFP8AABQsAABoawAATjVtcDR2MjRpbXBsMTdNUDRCYXNlRGVzY3JpcHRvckUAAAAAFP8AAEgsAABoawAAL2hvbWUvdXNlci9saWJtcDR2Mi9zcmMvbXA0cHJvcGVydHkuaABwcm9wZXJ0eSBpcyByZWFkLW9ubHk6IABTZXRWYWx1ZQAvaG9tZS91c2VyL2xpYm1wNHYyL3NyYy9tcDRwcm9wZXJ0eS5oAHByb3BlcnR5IGlzIHJlYWQtb25seTogAFNldFZhbHVlAFBONW1wNHYyNGltcGw5RXhjZXB0aW9uRQAAzP8AAAYtAAAAAAAAlB4AACVzOiAiJXMiOiBmYWlsZWQATVA0Q3JlYXRlUHJvdmlkZXJFeAAlczogZmFpbGVkAE1QNENsb3NlAE1QNFNldFRpbWVTY2FsZQBNUDRTZXRWaWRlb1Byb2ZpbGVMZXZlbABNUDRBZGRIMjY0VmlkZW9UcmFjawBNUDRBZGRIMjY0U2VxdWVuY2VQYXJhbWV0ZXJTZXQATVA0QWRkSDI2NFBpY3R1cmVQYXJhbWV0ZXJTZXQATVA0V3JpdGVTYW1wbGUAJXM6IHVua25vd24gZXhjZXB0aW9uIGNvbnN0cnVjdGluZyBNUDRGaWxlAENvbnN0cnVjdE1QNEZpbGUAJXM6IHVuYWJsZSB0byBhbGxvY2F0ZSBNUDRGaWxlAG1hbGxvYyBmYWlsZWQAL2hvbWUvdXNlci9saWJtcDR2Mi9zcmMvbXA0dXRpbC5oAE1QNE1hbGxvYwBQTjVtcDR2MjRpbXBsMTdQbGF0Zm9ybUV4Y2VwdGlvbkUAAAAAzP8AAIcuAAAAAAAABB8AAGlsbGVnYWwgYXJyYXkgaW5kZXgAL2hvbWUvdXNlci9saWJtcDR2Mi9zcmMvbXA0YXRvbS5oAEluc2VydABNUDRSZWFsbG9jAAAAAADALwAAYQAAALAAAACxAAAAZAAAALIAAACzAAAAZwAAALQAAABpAAAAbW9vdgBmdHlwAG1kYXQAZnJlZQBza2lwAHVkdGEAbW9vZgAvaG9tZS91c2VyL2xpYm1wNHYyL3NyYy9hdG9tX3Jvb3QuY3BwAGFzc2VydCBmYWlsdXJlOiAoZmFsc2UpAEdldExhc3RNZGF0SW5kZXgATjVtcDR2MjRpbXBsMTFNUDRSb290QXRvbUUAAAAAFP8AAKIvAAA0aAAAZGF0YQAAAAAAAAAApDEAAGEAAAC3AAAAsQAAALgAAABlAAAAZgAAAGcAAABoAAAAaQAAAHR5cGVSZXNlcnZlZAB0eXBlU2V0SWRlbnRpZmllcgB0eXBlQ29kZQBsb2NhbGUAbWV0YWRhdGEAAAAAAOwxAABhAAAAuQAAALEAAABkAAAAZQAAAGYAAABnAAAAaAAAAGkAAAB2ZXJzaW9uAGZsYWdzAAAAAAAAAKAyAABhAAAAugAAALEAAABkAAAAZQAAAGYAAABnAAAAaAAAAGkAAABtZWFuAG5hbWUAaGRscgAAAAAAAPgxAABhAAAAuwAAALEAAAC8AAAAZQAAAGYAAABnAAAAaAAAAGkAAAByZXNlcnZlZDEAaGFuZGxlclR5cGUAcmVzZXJ2ZWQyAAAAAAAgMgAAYQAAAL0AAACxAAAAvgAAAGUAAABmAAAAZwAAAGgAAABpAAAAdmFsdWUAAAAAAAAASDIAAGEAAAC/AAAAsQAAAMAAAABlAAAAZgAAAGcAAABoAAAAaQAAAAAAAAB4MgAAYQAAAMEAAACxAAAAwgAAAGUAAABmAAAAZwAAAGgAAABpAAAATjVtcDR2MjRpbXBsMTFNUDREYXRhQXRvbUUAABT/AACIMQAANGgAAE41bXA0djI0aW1wbDE1TVA0SXRtZkhkbHJBdG9tRQBONW1wNHYyNGltcGwxMU1QNEZ1bGxBdG9tRQAAABT/AADPMQAANGgAABT/AACwMQAA7DEAAE41bXA0djI0aW1wbDExTVA0TWVhbkF0b21FAAAU/wAABDIAAOwxAABONW1wNHYyNGltcGwxMU1QNE5hbWVBdG9tRQAAFP8AACwyAADsMQAATjVtcDR2MjRpbXBsMThNUDRVZHRhRWxlbWVudEF0b21FAAAAFP8AAFQyAAA0aAAATjVtcDR2MjRpbXBsMTFNUDRJdGVtQXRvbUUAABT/AACEMgAANGgAAGhudGkAAAAAAAAAAFQzAABhAAAAwwAAALEAAADEAAAAZQAAAGYAAABnAAAAaAAAAGkAAABhc3NlcnQgZmFpbHVyZTogKGdyYW5kUGFyZW50KQAvaG9tZS91c2VyL2xpYm1wNHYyL3NyYy9hdG9tX2hudGkuY3BwAFJlYWQAdHJhawBzZHAgAHJ0cCAATjVtcDR2MjRpbXBsMTFNUDRIbnRpQXRvbUUAABT/AAA4MwAANGgAAGhpbmYAAAAAAAAAAOwzAABhAAAAxQAAAMYAAABkAAAAZQAAAGYAAABnAAAAaAAAAGkAAAB0cnB5AG51bXAAdHB5bABtYXhyAGRtZWQAZGltbQBkcmVwAHRtaW4AdG1heABwbWF4AGRtYXgAcGF5dABONW1wNHYyNGltcGwxMU1QNEhpbmZBdG9tRQAAFP8AANAzAAA0aAAAAAAAAKg0AABhAAAAyQAAAMoAAABkAAAAZQAAAGYAAABnAAAAaAAAAGkAAAByZXNlcnZlZDEAZGF0YVJlZmVyZW5jZUluZGV4AHJlc2VydmVkMgB3aWR0aABoZWlnaHQAcmVzZXJ2ZWQzAGNvbXByZXNzb3JOYW1lAABkZXB0aABjb2xvclRhYmxlSWQAc21pIABONW1wNHYyNGltcGwxMk1QNFZpZGVvQXRvbUUAAAAU/wAAijQAADRoAABtZXRhAAAAAAAAAAAMNQAAYQAAAMsAAACxAAAAzAAAAGUAAABmAAAAZwAAAGgAAABpAAAAbWV0YWRhdGEATjVtcDR2MjRpbXBsMTBNUDRTbWlBdG9tRQAAFP8AAPE0AAA0aAAAYXZjMQAAAAAAAAAA5DUAAGEAAADNAAAAzgAAAGQAAABlAAAAZgAAAGcAAABoAAAAaQAAAHJlc2VydmVkMQBkYXRhUmVmZXJlbmNlSW5kZXgAcmVzZXJ2ZWQyAHdpZHRoAGhlaWdodAByZXNlcnZlZDMAY29tcHJlc3Nvck5hbWUASlZUL0FWQyBDb2RpbmcAcmVzZXJ2ZWQ0AGF2Y0MAYnRydABjb2xyAHBhc3AATjVtcDR2MjRpbXBsMTFNUDRBdmMxQXRvbUUAAAAAFP8AAMY1AAA0aAAAYWMtMwAAAAAAAAAApDYAAGEAAADPAAAA0AAAAGQAAABlAAAAZgAAAGcAAABoAAAAaQAAAHJlc2VydmVkMQBkYXRhUmVmZXJlbmNlSW5kZXgAcmVzZXJ2ZWQyAGNoYW5uZWxDb3VudABzYW1wbGVTaXplAHJlc2VydmVkMwBzYW1wbGluZ1JhdGUAcmVzZXJ2ZWQ0AGRhYzMATjVtcDR2MjRpbXBsMTBNUDRBYzNBdG9tRQAAFP8AAIk2AAA0aAAAAAAAAAA3AABhAAAA0gAAALEAAADTAAAAZQAAANQAAABnAAAAaAAAAGkAAABsb2NhdGlvbgBONW1wNHYyNGltcGwxME1QNFVybEF0b21FAAAU/wAA5TYAADRoAABpbGxlZ2FsIGFycmF5IGluZGV4OiAAIG9mIABvcGVyYXRvcltdAC9ob21lL3VzZXIvbGlibXA0djIvc3JjL21wNGFycmF5LmgAAAAAAAAAAIA4AABhAAAA1gAAANcAAADYAAAAZQAAAGYAAABnAAAAaAAAAGkAAAByZXNlcnZlZDEAZGF0YVJlZmVyZW5jZUluZGV4AHNvdW5kVmVyc2lvbgByZXNlcnZlZDIAY2hhbm5lbHMAc2FtcGxlU2l6ZQBjb21wcmVzc2lvbklkAHBhY2tldFNpemUAdGltZVNjYWxlAG1wNGEAZXNkcwB3YXZlAGFsYWMAc2FtcGxlc1BlclBhY2tldABieXRlc1BlclBhY2tldABieXRlc1BlckZyYW1lAGJ5dGVzUGVyU2FtcGxlAHJlc2VydmVkNAAAAAAAAABzdHNkAGRlY29kZXJDb25maWcATjVtcDR2MjRpbXBsMTJNUDRTb3VuZEF0b21FAAAU/wAAYzgAADRoAABpbGxlZ2FsIGFycmF5IGluZGV4OiAAIG9mIAAvaG9tZS91c2VyL2xpYm1wNHYyL3NyYy9tcDRwcm9wZXJ0eS5oAERlbGV0ZQAAAAAAPDkAAGEAAADZAAAAsQAAANoAAABlAAAAZgAAAGcAAABoAAAAaQAAAGVudHJ5Q291bnQAZW50cmllcwB0cmFja0lkAE41bXA0djI0aW1wbDE1TVA0VHJlZlR5cGVBdG9tRQAAABT/AAAbOQAANGgAAGNocGwAAAAAAAAAAMg5AABhAAAA2wAAANwAAABkAAAAZQAAAGYAAABnAAAAaAAAAGkAAAByZXNlcnZlZABjaGFwdGVyY291bnQAY2hhcHRlcnMAc3RhcnR0aW1lAHRpdGxlAE41bXA0djI0aW1wbDExTVA0Q2hwbEF0b21FAAAAFP8AAKs5AAA0aAAAY29scgAAAAAAAAAAbDoAAGEAAADdAAAA3gAAAGQAAABlAAAAZgAAAGcAAABoAAAAaQAAAGNvbG9yUGFyYW1ldGVyVHlwZQBwcmltYXJpZXNJbmRleAB0cmFuc2ZlckZ1bmN0aW9uSW5kZXgAbWF0cml4SW5kZXgAbmNsYwBONW1wNHYyNGltcGwxMU1QNENvbHJBdG9tRQAU/wAAUToAADRoAABkMjYzAAAAAAAAAABoOwAAYQAAAN8AAADgAAAAZAAAAGUAAADhAAAAZwAAAGgAAABpAAAAdmVuZG9yAGRlY29kZXJWZXJzaW9uAGgyNjNMZXZlbABoMjYzUHJvZmlsZQBiaXRyAGQyNjMuYml0cgBiaXRyLmF2Z0JpdHJhdGUAYXNzZXJ0IGZhaWx1cmU6IChwUHJvcCkAL2hvbWUvdXNlci9saWJtcDR2Mi9zcmMvYXRvbV9kMjYzLmNwcABXcml0ZQBiaXRyLm1heEJpdHJhdGUATjVtcDR2MjRpbXBsMTFNUDREMjYzQXRvbUUAAAAU/wAASzsAADRoAABkYW1yAAAAAAAAAAAEPAAAYQAAAOIAAADjAAAAZAAAAGUAAABmAAAAZwAAAGgAAABpAAAAdmVuZG9yAGRlY29kZXJWZXJzaW9uAG1vZGVTZXQAbW9kZUNoYW5nZVBlcmlvZABmcmFtZXNQZXJTYW1wbGUATjVtcDR2MjRpbXBsMTFNUDREYW1yQXRvbUUAAAAU/wAA5zsAADRoAABkcmVmAAAAAAAAAAC0PAAAYQAAAOQAAACxAAAA5QAAAGUAAABmAAAAZwAAAGgAAABpAAAAZW50cnlDb3VudAB1cmwgAHVybiAAYWxpcwAlczogIiVzIjogZHJlZiBpbmNvbnNpc3RlbmN5IHdpdGggbnVtYmVyIG9mIGVudHJpZXMAUmVhZABONW1wNHYyNGltcGwxMU1QNERyZWZBdG9tRQAAABT/AACXPAAANGgAAGRhYzMAAAAAAAAAAPRAAABhAAAA5wAAAOgAAABkAAAAZQAAAGYAAABnAAAAaAAAAOkAAABmc2NvZABic2lkAGJzbW9kAGFjbW9kAGxmZW9uAGJpdF9yYXRlX2NvZGUAcmVzZXJ2ZWQAIiVzIjogdHlwZSA9IGRhYzMANDgANDQuMQAzMgBSZXNlcnZlZAAAADo9AAA9PQAAQj0AAEU9AABJbnZhbGlkIHZhbHVlACIlcyI6IGZzY29kID0gJWxsdSAoMHglMCpsbHgpIDwldSBiaXRzPiBbJXMga0h6XQBNYWluIGF1ZGlvIHNlcnZpY2U6IGNvbXBsZXRlIG1haW4gKENNKQBNYWluIGF1ZGlvIHNycnZpY2U6IG11c2ljIGFuZCBlZmZlY3RzIChNRSkAQXNzb2NpYXRlZCBzZXJ2aWNlOiB2aXN1YWxseSBpbXBhaXJlZCAoVkkpAEFzc29jaWF0ZWQgc2VydmljZTogaGVhcmluZyBpbXBhaXJlZCAoSEkpAEFzc29jaWF0ZWQgc2VydmljZTogZGlhbG9ndWUgKEQpAEFzc29jaWF0ZWQgc2VydmljZTogY29tbWVudGFyeSAoQykAQXNzb2NpYXRlZCBzZXJ2aWNlOiBlbWVyZ2VuY3kgKEUpAEFzc29jaWF0ZWQgc2VydmljZTogdm9pY2Ugb3ZlciAoVk8pIG9yIE1haW4gYXVkaW8gc2VydmljZToga2FyYW9rZQAAnz0AAMY9AADxPQAAHD4AAEY+AABnPgAAij4AAKw+AAAiJXMiOiBic21vZCA9ICVsbHUgKDB4JTAqbGx4KSA8JXUgYml0cz4gWyVzXQAxICsgMSAoQ2gxLCBDaDIpADEvMCAoQykAMi8wIChMLCBSKQAzLzAgKEwsIEMsIFIpADIvMSAoTCwgUiwgUykAMy8xIChMLCBDLCBSLCBTKQAyLzIgKEwsIFIsIFNMLCBTUikAMy8yIChMLCBDLCBSLCBTTCwgU1IpAEHA/wALsAk9PwAATj8AAFY/AABhPwAAbz8AAH0/AACOPwAAoT8AACIlcyI6IGFjbW9kID0gJWxsdSAoMHglMCpsbHgpIDwldSBiaXRzPiBbJXNdACIlcyI6IGxmZW9uID0gJWxsdSAoMHglMCpsbHgpIDwldSBiaXRzPiBbJXNdAEVOQUJMRUQARElTQUJMRUQAAAAAAAAgAAAAKAAAADAAAAA4AAAAQAAAAFAAAABgAAAAcAAAAIAAAACgAAAAwAAAAOAAAAAAAQAAQAEAAIABAADAAQAAAAIAAEACAACAAgAAIiVzIjogYml0X3JhdGVfY29kZSA9ICVsbHUgKDB4JTAqbGx4KSA8JXUgYml0cz4gWyV1IGtiaXQvc10ATjVtcDR2MjRpbXBsMTFNUDREQWMzQXRvbUUAABT/AADYQAAANGgAAGVsc3QAAAAAAAAAAJBBAABhAAAA6gAAAOsAAADsAAAAZQAAAGYAAABnAAAAaAAAAGkAAABlbnRyeUNvdW50AGVudHJpZXMAc2VnbWVudER1cmF0aW9uAG1lZGlhVGltZQBtZWRpYVJhdGUAcmVzZXJ2ZWQATjVtcDR2MjRpbXBsMTFNUDRFbHN0QXRvbUUAABT/AAB0QQAANGgAAGVuY2EAAAAAAAAAADBCAABhAAAA7QAAAO4AAABkAAAAZQAAAGYAAABnAAAAaAAAAGkAAAByZXNlcnZlZDEAZGF0YVJlZmVyZW5jZUluZGV4AHJlc2VydmVkMgB0aW1lU2NhbGUAcmVzZXJ2ZWQzAGVzZHMAc2luZgBONW1wNHYyNGltcGwxMU1QNEVuY2FBdG9tRQAU/wAAFUIAADRoAABlbmN2AAAAAAAAAAD0QgAAYQAAAO8AAADwAAAAZAAAAGUAAABmAAAAZwAAAGgAAABpAAAAcmVzZXJ2ZWQxAGRhdGFSZWZlcmVuY2VJbmRleAByZXNlcnZlZDIAd2lkdGgAaGVpZ2h0AHJlc2VydmVkMwBjb21wcmVzc29yTmFtZQAAcmVzZXJ2ZWQ0AGVzZHMAc2luZgBhdmNDAE41bXA0djI0aW1wbDExTVA0RW5jdkF0b21FAAAAFP8AANdCAAA0aAAAZnJlZQAAAAAAAAAAUEMAAGEAAADxAAAAsQAAAPIAAABlAAAA8wAAAGcAAABoAAAAaQAAAE41bXA0djI0aW1wbDExTVA0RnJlZUF0b21FAAAU/wAANEMAADRoAABmdHlwAAAAAAAAAADgQwAAYQAAAPQAAAD1AAAA9gAAAGUAAABmAAAAZwAAAGgAAABpAAAAbWFqb3JCcmFuZABtaW5vclZlcnNpb24AY29tcGF0aWJsZUJyYW5kcwBtcDQyAGlzb20ATjVtcDR2MjRpbXBsMTFNUDRGdHlwQXRvbUUAAAAU/wAAw0MAADRoAABmdGFiAAAAAAAAAABgRAAAYQAAAPcAAACxAAAAZAAAAGUAAABmAAAAZwAAAGgAAABpAAAAZW50cnlDb3VudABmb250RW50cmllcwBmb250SUQAbmFtZQBONW1wNHYyNGltcGwxMU1QNEZ0YWJBdG9tRQAAABT/AABDRAAANGgAAGdtaW4AQfmIAQuXAkUAAGEAAAD4AAAA+QAAAGQAAABlAAAAZgAAAGcAAABoAAAAaQAAAGdyYXBoaWNzTW9kZQBvcENvbG9yUmVkAG9wQ29sb3JHcmVlbgBvcENvbG9yQmx1ZQBiYWxhbmNlAHJlc2VydmVkAE41bXA0djI0aW1wbDExTVA0R21pbkF0b21FAAAAABT/AADiRAAANGgAAGhkbHIAAAAAAAAAAIBFAABhAAAA/AAAALEAAAD9AAAAZQAAAGYAAABnAAAAaAAAAGkAAAByZXNlcnZlZDEAaGFuZGxlclR5cGUAcmVzZXJ2ZWQyAG5hbWUATjVtcDR2MjRpbXBsMTFNUDRIZGxyQXRvbUUAFP8AAGVFAAA0aAAAaHJlZgBBmYsBC/cFRgAAYQAAAP4AAAD/AAAAZAAAAGUAAABmAAAAZwAAAGgAAABpAAAAcmVzZXJ2ZWQxAGRhdGFSZWZlcmVuY2VJbmRleABidXJsAE41bXA0djI0aW1wbDExTVA0SHJlZkF0b21FAAAAABT/AADiRQAANGgAAG1kaGQAAAAAAAAAAKBGAABhAAAAAQEAAAIBAAADAQAAZQAAAGYAAABnAAAAaAAAAGkAAABjcmVhdGlvblRpbWUAbW9kaWZpY2F0aW9uVGltZQB0aW1lU2NhbGUAZHVyYXRpb24AbGFuZ3VhZ2UAcmVzZXJ2ZWQATjVtcDR2MjRpbXBsMTFNUDRNZGhkQXRvbUUAAAAU/wAAg0YAADRoAABtdmhkAAAAAAAAAABQRwAAYQAAAAUBAAAGAQAABwEAAGUAAABmAAAAZwAAAGgAAABpAAAAY3JlYXRpb25UaW1lAG1vZGlmaWNhdGlvblRpbWUAdGltZVNjYWxlAGR1cmF0aW9uAHJhdGUAdm9sdW1lAHJlc2VydmVkMQBuZXh0VHJhY2tJZABONW1wNHYyNGltcGwxMU1QNE12aGRBdG9tRQAAABT/AAAzRwAANGgAAGlsbGVnYWwgYXJyYXkgaW5kZXg6IAAgb2YgAC9ob21lL3VzZXIvbGlibXA0djIvc3JjL21wNGFycmF5LmgAb3BlcmF0b3JbXQAvaG9tZS91c2VyL2xpYm1wNHYyL3NyYy9tcDRwcm9wZXJ0eS5oAHByb3BlcnR5IGlzIHJlYWQtb25seTogAFNldFZhbHVlAG1kYXQAAAAAAAAAAIBIAABhAAAACAEAALEAAAAJAQAAZQAAAAoBAABnAAAAaAAAAGkAAABhc3NlcnQgZmFpbHVyZTogKGZhbHNlKQAvaG9tZS91c2VyL2xpYm1wNHYyL3NyYy9hdG9tX21kYXQuY3BwAFdyaXRlAE41bXA0djI0aW1wbDExTVA0TWRhdEF0b21FAAAU/wAAZEgAADRoAABtcDRzAEGZkQELgxdJAABhAAAACwEAAAwBAABkAAAAZQAAAGYAAABnAAAAaAAAAGkAAAByZXNlcnZlZDEAZGF0YVJlZmVyZW5jZUluZGV4AGVzZHMATjVtcDR2MjRpbXBsMTFNUDRNcDRzQXRvbUUAAAAAFP8AAOJIAAA0aAAAbXA0dgAAAAAAAAAAxEkAAGEAAAANAQAADgEAAGQAAABlAAAAZgAAAGcAAABoAAAAaQAAAHJlc2VydmVkMQBkYXRhUmVmZXJlbmNlSW5kZXgAcmVzZXJ2ZWQyAHdpZHRoAGhlaWdodAByZXNlcnZlZDMAY29tcHJlc3Nvck5hbWUAAHJlc2VydmVkNABjb2xyAGVzZHMAcGFzcABONW1wNHYyNGltcGwxMU1QNE1wNHZBdG9tRQAAABT/AACnSQAANGgAAG5taGQAAAAAAAAAACBKAABhAAAADwEAALEAAABkAAAAZQAAAGYAAABnAAAAaAAAAGkAAABONW1wNHYyNGltcGwxMU1QNE5taGRBdG9tRQAAFP8AAARKAAA0aAAAb2hkcgAAAAAAAAAAFEsAABABAAARAQAAsQAAABIBAABlAAAAZgAAAGcAAABoAAAAaQAAAEVuY3J5cHRpb25NZXRob2QARW5jcnlwdGlvblBhZGRpbmcAUGxhaW50ZXh0TGVuZ3RoAENvbnRlbnRJRExlbmd0aABSaWdodHNJc3N1ZXJVUkxMZW5ndGgAVGV4dHVhbEhlYWRlcnNMZW5ndGgAQ29udGVudElEAFJpZ2h0c0lzc3VlclVSTABUZXh0dWFsSGVhZGVycwBONW1wNHYyNGltcGwxMU1QNE9oZHJBdG9tRQAAABT/AAD3SgAANGgAAAAAAAB4SwAAEwEAABQBAAAVAQAAFgEAABcBAABvAAAAGAEAABkBAAAaAQAAGwEAAE41bXA0djI0aW1wbDIxT2hkck1QNFN0cmluZ1Byb3BlcnR5RQAAAAAU/wAAUEsAAPyoAABwYXNwAAAAAAAAAADoSwAAYQAAABwBAAAdAQAAZAAAAGUAAABmAAAAZwAAAGgAAABpAAAAaFNwYWNpbmcAdlNwYWNpbmcATjVtcDR2MjRpbXBsMTFNUDRQYXNwQXRvbUUAAAAAFP8AAMpLAAA0aAAAcnRwIAAAAAAAAAAAtE0AAGEAAAAeAQAAHwEAACABAABlAAAAIQEAAGcAAABoAAAAaQAAAHJlc2VydmVkMQBkYXRhUmVmZXJlbmNlSW5kZXgAaGludFRyYWNrVmVyc2lvbgBoaWdoZXN0Q29tcGF0aWJsZVZlcnNpb24AbWF4UGFja2V0U2l6ZQB0aW1zAHRzcm8Ac25ybwBkZXNjcmlwdGlvbkZvcm1hdABzZHBUZXh0AGFzc2VydCBmYWlsdXJlOiAobV9wUGFyZW50QXRvbSkAL2hvbWUvdXNlci9saWJtcDR2Mi9zcmMvYXRvbV9ydHAuY3BwAEdlbmVyYXRlAHN0c2QAaG50aQAlczogIiVzIjogcnRwIGF0b20gaW4gdW5leHBlY3RlZCBjb250ZXh0LCBjYW4gbm90IGdlbmVyYXRlAHNkcCAAUmVhZABydHAgYXRvbSBpbiB1bmV4cGVjdGVkIGNvbnRleHQsIGNhbiBub3QgcmVhZABhc3NlcnQgZmFpbHVyZTogKGRhdGEgIT0gMEwpAFJlYWRIbnRpVHlwZQBONW1wNHYyNGltcGwxME1QNFJ0cEF0b21FABT/AACaTQAANGgAAHMyNjMAAAAAAAAAAFROAABhAAAAIgEAACMBAABkAAAAZQAAAGYAAABnAAAAaAAAAGkAAAByZXNlcnZlZDEAZGF0YVJlZmVyZW5jZUluZGV4AHJlc2VydmVkMgB3aWR0aABoZWlnaHQAcmVzZXJ2ZWQzAGQyNjMATjVtcDR2MjRpbXBsMTFNUDRTMjYzQXRvbUUAAAAU/wAAN04AADRoAAAAAAAA6E4AAGEAAAAkAQAAJQEAAGQAAABlAAAAZgAAAGcAAABoAAAAaQAAAHJlc2VydmVkMQBkYXRhUmVmZXJlbmNlSW5kZXgAcmVzZXJ2ZWQyAHRpbWVTY2FsZQByZXNlcnZlZDMAZGFtcgBONW1wNHYyNGltcGwxME1QNEFtckF0b21FAAAAFP8AAMxOAAA0aAAAc2R0cAAAAAAAAAAASE8AAGEAAAAmAQAAsQAAACcBAABlAAAAZgAAAGcAAABoAAAAaQAAAGRhdGEATjVtcDR2MjRpbXBsMTFNUDRTZHRwQXRvbUUAFP8AAC1PAADsMQAAc3RibAAAAAAAAAAA4E8AAGEAAAAoAQAAKQEAAGQAAABlAAAAZgAAAGcAAABoAAAAaQAAAHN0c2QAc3R0cwBjdHRzAHN0c3oAc3R6MgBzdHNjAHN0Y28AY282NABzdHNzAHN0c2gAc3RkcABzZHRwAE41bXA0djI0aW1wbDExTVA0U3RibEF0b21FAAAU/wAAxE8AADRoAABzdHNkAAAAAAAAAADAUAAAYQAAACoBAACxAAAAKwEAAGUAAABmAAAAZwAAAGgAAABpAAAAZW50cnlDb3VudABtcDRhAGVuY2EAbXA0cwBtcDR2AGVuY3YAcnRwIABzYW1yAHNhd2IAczI2MwBhdmMxAGFsYWMAdGV4dABhYy0zACVzOiAiJXMiOiBzdHNkIGluY29uc2lzdGVuY3kgd2l0aCBudW1iZXIgb2YgZW50cmllcwBSZWFkAE41bXA0djI0aW1wbDExTVA0U3RzZEF0b21FABT/AAClUAAANGgAAHN0c3oAAAAAAAAAAERRAABhAAAALAEAALEAAAAtAQAAZQAAAC4BAABnAAAAaAAAAGkAAABzYW1wbGVTaXplAHNhbXBsZUNvdW50AGVudHJpZXMAZW50cnlTaXplAE41bXA0djI0aW1wbDExTVA0U3RzekF0b21FABT/AAApUQAANGgAAHN0c2MAAAAAAAAAAPBRAABhAAAALwEAALEAAAAwAQAAZQAAAGYAAABnAAAAaAAAAGkAAABlbnRyeUNvdW50AGVudHJpZXMAZmlyc3RDaHVuawBzYW1wbGVzUGVyQ2h1bmsAc2FtcGxlRGVzY3JpcHRpb25JbmRleABmaXJzdFNhbXBsZQBONW1wNHYyNGltcGwxMU1QNFN0c2NBdG9tRQAU/wAA1VEAADRoAABzdHoyAAAAAAAAAAB8UgAAYQAAADEBAACxAAAAMgEAAGUAAABmAAAAZwAAAGgAAABpAAAAcmVzZXJ2ZWQAZmllbGRTaXplAHNhbXBsZUNvdW50AGVudHJpZXMAZW50cnlTaXplAE41bXA0djI0aW1wbDExTVA0U3R6MkF0b21FABT/AABhUgAANGgAAAAAAADoUgAAagAAADMBAABsAAAANAEAADUBAABvAAAAcAAAAHEAAAByAAAAcwAAADYBAAB1AAAATjVtcDR2MjRpbXBsMjRNUDRIYWxmU2l6ZVRhYmxlUHJvcGVydHlFABT/AADAUgAAVKkAAHN0ZHAAAAAAAAAAAGBTAABhAAAANwEAALEAAAA4AQAAZQAAAGYAAABnAAAAaAAAAGkAAABlbnRyeUNvdW50AGVudHJpZXMAcHJpb3JpdHkATjVtcDR2MjRpbXBsMTFNUDRTdGRwQXRvbUUAABT/AABEUwAANGgAAHNkcCAAAAAAAAAAAAxUAABhAAAAOQEAALEAAAA6AQAAZQAAADsBAABnAAAAaAAAAGkAAABzZHBUZXh0AGFzc2VydCBmYWlsdXJlOiAoZGF0YSAhPSAwTCkAL2hvbWUvdXNlci9saWJtcDR2Mi9zcmMvYXRvbV9zZHAuY3BwAFJlYWQATjVtcDR2MjRpbXBsMTBNUDRTZHBBdG9tRQAAAAAU/wAA71MAADRoAAB0ZXh0AEGlqAEL7CNWAABhAAAAPAEAAD0BAAA+AQAAZQAAAGYAAABnAAAAaAAAAGkAAAByZXNlcnZlZDEAZGF0YVJlZmVyZW5jZUluZGV4AGRpc3BsYXlGbGFncwB0ZXh0SnVzdGlmaWNhdGlvbgBiZ0NvbG9yUmVkAGJnQ29sb3JHcmVlbgBiZ0NvbG9yQmx1ZQBkZWZUZXh0Qm94VG9wAGRlZlRleHRCb3hMZWZ0AGRlZlRleHRCb3hCb3R0b20AZGVmVGV4dEJveFJpZ2h0AHJlc2VydmVkMgBmb250TnVtYmVyAGZvbnRGYWNlAHJlc2VydmVkMwByZXNlcnZlZDQAZm9yZUNvbG9yUmVkAGZvcmVDb2xvckdyZWVuAGZvcmVDb2xvckJsdWUAdGV4dERhdGEAYXNzZXJ0IGZhaWx1cmU6IChtX3BQYXJlbnRBdG9tKQAvaG9tZS91c2VyL2xpYm1wNHYyL3NyYy9hdG9tX3RleHQuY3BwAEdlbmVyYXRlAHN0c2QAZ21oZAAlczogIiVzIjogdGV4dCBhdG9tIGluIHVuZXhwZWN0ZWQgY29udGV4dCwgY2FuIG5vdCBnZW5lcmF0ZQBONW1wNHYyNGltcGwxMU1QNFRleHRBdG9tRQAAFP8AAORVAAA0aAAAdHgzZwAAAAAAAAAAmFcAAGEAAAA/AQAAQAEAAGQAAABlAAAAZgAAAGcAAABoAAAAaQAAAHJlc2VydmVkMQByZXNlcnZlZDIAZGF0YVJlZmVyZW5jZUluZGV4AGRpc3BsYXlGbGFncwBob3Jpem9udGFsSnVzdGlmaWNhdGlvbgB2ZXJ0aWNhbEp1c3RpZmljYXRpb24AYmdDb2xvclJlZABiZ0NvbG9yR3JlZW4AYmdDb2xvckJsdWUAYmdDb2xvckFscGhhAGRlZlRleHRCb3hUb3AAZGVmVGV4dEJveExlZnQAZGVmVGV4dEJveEJvdHRvbQBkZWZUZXh0Qm94UmlnaHQAc3RhcnRDaGFyAGVuZENoYXIAZm9udElEAGZvbnRGYWNlAGZvbnRTaXplAGZvbnRDb2xvclJlZABmb250Q29sb3JHcmVlbgBmb250Q29sb3JCbHVlAGZvbnRDb2xvckFscGhhAGZ0YWIATjVtcDR2MjRpbXBsMTFNUDRUeDNnQXRvbUUAAAAAFP8AAHpXAAA0aAAAdGtoZAAAAAAAAAAAdFgAAGEAAABBAQAAQgEAAEMBAABlAAAAZgAAAGcAAABoAAAAaQAAAGNyZWF0aW9uVGltZQBtb2RpZmljYXRpb25UaW1lAHRyYWNrSWQAcmVzZXJ2ZWQxAGR1cmF0aW9uAHJlc2VydmVkMgBsYXllcgBhbHRlcm5hdGVfZ3JvdXAAdm9sdW1lAHJlc2VydmVkMwBtYXRyaXgAd2lkdGgAaGVpZ2h0AE41bXA0djI0aW1wbDExTVA0VGtoZEF0b21FAAAAABT/AABWWAAANGgAAHRmaGQAAAAAAAAAADhZAABhAAAARAEAALEAAABFAQAAZQAAAGYAAABnAAAAaAAAAGkAAAB0cmFja0lkAGJhc2VEYXRhT2Zmc2V0AHNhbXBsZURlc2NyaXB0aW9uSW5kZXgAZGVmYXVsdFNhbXBsZUR1cmF0aW9uAGRlZmF1bHRTYW1wbGVTaXplAGRlZmF1bHRTYW1wbGVGbGFncwBONW1wNHYyNGltcGwxMU1QNFRmaGRBdG9tRQAU/wAAHVkAADRoAAB0cnVuAAAAAAAAAAAIWgAAYQAAAEYBAACxAAAARwEAAGUAAABmAAAAZwAAAGgAAABpAAAAc2FtcGxlQ291bnQAZGF0YU9mZnNldABmaXJzdFNhbXBsZUZsYWdzAHNhbXBsZXMAc2FtcGxlRHVyYXRpb24Ac2FtcGxlU2l6ZQBzYW1wbGVGbGFncwBzYW1wbGVDb21wb3NpdGlvblRpbWVPZmZzZXQATjVtcDR2MjRpbXBsMTFNUDRUcnVuQXRvbUUAAAAAFP8AAOpZAAA0aAAAdWR0YQAAAAAAAAAAoFoAAGEAAABIAQAAsQAAAEkBAABlAAAAZgAAAGcAAABoAAAAaQAAAGNocGwAY3BydABobnRpAG1ldGEAqWNweQCpZGVzAKluYW0AqWNtdACpcHJkAHRyYWsAaGluZgBuYW1lAE41bXA0djI0aW1wbDExTVA0VWR0YUF0b21FAAAU/wAAhFoAADRoAAB1cm4gAAAAAAAAAAAIWwAAYQAAAEoBAACxAAAASwEAAGUAAABmAAAAZwAAAGgAAABpAAAAbmFtZQBsb2NhdGlvbgBONW1wNHYyNGltcGwxME1QNFVybkF0b21FABT/AADuWgAANGgAAHZtaGQAAAAAAAAAAGxbAABhAAAATAEAAE0BAABkAAAAZQAAAGYAAABnAAAAaAAAAGkAAAByZXNlcnZlZABONW1wNHYyNGltcGwxMU1QNFZtaGRBdG9tRQAU/wAAUVsAADRoAAAAAAAATGAAAGEAAABOAQAAsQAAAGQAAABlAAAAZgAAAGcAAABoAAAAaQAAAGJpdHIAYXZnQml0cmF0ZQBtYXhCaXRyYXRlAGJ0cnQAYnVmZmVyU2l6ZURCAGJ1cmwAYmFzZV91cmwAY282NABlbnRyeUNvdW50AGVudHJpZXMAY2h1bmtPZmZzZXQAY3R0cwBzYW1wbGVDb3VudABzYW1wbGVPZmZzZXQAZGluZgBkcmVmAGRpbW0AYnl0ZXMAZG1heABtaWxsaVNlY3MAZG1lZABkcmVwAGVkdHMAZWxzdABlc2RzAGZybWEAZGF0YS1mb3JtYXQAZ21oZABnbWluAHRtY2QAdGV4dABobWhkAG1heFBkdVNpemUAYXZnUGR1U2l6ZQBtYXhCaXRSYXRlAGF2Z0JpdFJhdGUAc2xpZGluZ0F2Z0JpdFJhdGUAaUtNUwBrbXNfVVJJAGlTRk0Ac2VsZWN0aXZlLWVuY3J5cHRpb24AcmVzZXJ2ZWQAa2V5LWluZGljYXRvci1sZW5ndGgASVYtbGVuZ3RoAGlsc3QAqW5hbQCpQVJUAKl3cnQAqWFsYgCpZGF5AKl0b28AqWNtdACpZ2VuAHRya24AZGlzawBnbnJlAGNwaWwAdG1wbwBjb3ZyAGFBUlQALS0tLQBwZ2FwAHR2c2gAdHZzbgB0dmVuAHR2bm4AdHZlcwBkZXNjAGxkZXMAc29hbABzb2FyAHNvYWEAc29ubQBzb2NvAHNvc24AaGR2ZACpZW5jAHBjc3QAa2V5dwBjYXRnAHB1cmwAZWdpZABydG5nAHN0aWsAqWdycACpbHlyAGNwcnQAYXBJRABha0lEAHNmSUQAY25JRABhdElEAHBsSUQAZ2VJRABjbUlEAHhpZCAAaW1pZgBpcG1wX2Rlc2MAaW9kcwBtYXhyAGdyYW51bGFyaXR5AG1kaWEAbWRoZABoZGxyAG1pbmYAbWV0YQBtZmhkAHNlcXVlbmNlTnVtYmVyAHZtaGQAc21oZABubWhkAHN0YmwAbW9vZgB0cmFmAG1vb3YAbXZoZAB0cmFrAHVkdGEAbXZleAB0cmV4AG51bXAAcGFja2V0cwBvZGttAG9oZHIAcGF5dABwYXlsb2FkTnVtYmVyAHJ0cE1hcABwaW5mAHBtYXgAc2NoaQBzY2htAHNjaGVtZV90eXBlAHNjaGVtZV92ZXJzaW9uAHNpbmYAc25ybwBvZmZzZXQAc3RjbwBzdHNoAHNoYWRvd2VkU2FtcGxlTnVtYmVyAHN5bmNTYW1wbGVOdW1iZXIAc3RzcwBzYW1wbGVOdW1iZXIAc3R0cwBzYW1wbGVEZWx0YQB0aW1zAHRpbWVTY2FsZQB0bWluAHRtYXgAdGZoZAB0cnVuAHRraGQAdHJlZgBjaGFwAGRwbmQAaGludABpcGlyAG1wb2QAc3luYwB0cmFja0lkAGRlZmF1bHRTYW1wbGVEZXNyaXB0aW9uSW5kZXgAZGVmYXVsdFNhbXBsZUR1cmF0aW9uAGRlZmF1bHRTYW1wbGVTaXplAGRlZmF1bHRTYW1wbGVGbGFncwB0cnB5AHRweWwAdHNybwB3YXZlAE41bXA0djI0aW1wbDE1TVA0U3RhbmRhcmRBdG9tRQAAAAAU/wAAKmAAADRoAAAAAAAANGgAAGEAAACRAQAAsQAAAGQAAABlAAAAZgAAAGcAAABoAAAAaQAAAGFzc2VydCBmYWlsdXJlOiAoYXRvbSkAL2hvbWUvdXNlci9saWJtcDR2Mi9zcmMvbXA0YXRvbS5jcHAAQ3JlYXRlQXRvbQAiJXMiOiBwb3MgPSAweCVsbHgAdXVpZABJbnZhbGlkIGF0b20gc2l6ZSBpbiAnACcgYXRvbSwgZGF0YVNpemUgPSAAIGNhbm5vdCBiZSBsZXNzIHRoYW4gaGRyU2l6ZSA9IAAlczogIiVzIjogJXMAUmVhZEF0b20AIiVzIjogdHlwZSA9ICIlcyIgZGF0YS1zaXplID0gJWxsdSAoMHglbGx4KSBoZHIgJXUAJXM6ICIlcyI6IGludmFsaWQgYXRvbSBzaXplLCBleHRlbmRzIG91dHNpZGUgcGFyZW50IGF0b20gLSBza2lwcGluZyB0byBlbmQgb2YgIiVzIiAiJXMiICVsbHUgdnMgJWxsdQAiJXMiOiBwYXJlbnQgJXMgKCVsbHUpIHBvcyAlbGx1IGhkciAlZCBkYXRhICVsbHUgc3VtICVsbHUAJXM6ICIlcyI6IGF0b20gdHlwZSAlcyBpcyBzdXNwZWN0ACIlcyI6IEluZm86IGF0b20gdHlwZSAlcyBpcyB1bmtub3duAGRhdGEAJXM6ICIlcyI6ICVzIGF0b20gc2l6ZSAlbGx1IGlzIHN1c3BlY3QAUmVhZAAiJXMiOiBTa2lwOiAlbGx1IGJ5dGVzACIlcyI6IEZpbmRBdG9tOiBtYXRjaGVkICVzACIlcyI6IEZpbmRQcm9wZXJ0eTogbWF0Y2hlZCAlcwAiJXMiOiBGaW5kUHJvcGVydHk6IG5vIG1hdGNoIGZvciAlcwBSZWFkUHJvcGVydGllczogaW5zdWZmaWNpZW50IGRhdGEgZm9yIHByb3BlcnR5OiAlcyBwb3MgMHglbGx4IGF0b20gZW5kIDB4JWxseABhdG9tICcAJyBpcyB0b28gc21hbGw7IG92ZXJydW4gYXQgcHJvcGVydHk6IABSZWFkUHJvcGVydGllcwB1ZHRhACIlcyI6IG9mICVzAHJvb3QAJXM6ICIlcyI6IEluIHVkdGEgYXRvbSwgZW5kIHZhbHVlIGlzIG5vdCB6ZXJvICV4AFJlYWRDaGlsZEF0b21zACVzOiAiJXMiOiBJbiAlcyBhdG9tLCBleHRyYSAlbGxkIGJ5dGVzIGF0IGVuZCBvZiBhdG9tACVzOiAiJXMiOiBJbiBhdG9tICVzIHVuZXhwZWN0ZWQgY2hpbGQgYXRvbSAlcwAlczogIiVzIjogSW4gYXRvbSAlcyBtdWx0aXBsZSBjaGlsZCBhdG9tcyAlcwAlczogIiVzIjogSW4gYXRvbSAlcyBtaXNzaW5nIGNoaWxkIGF0b20gJXMAIiVzIjogZmluaXNoZWQgJXMAZW5kOiB0eXBlICVzICVsbHUgJWxsdSBzaXplICVsbHUAYXNzZXJ0IGZhaWx1cmU6IChtX3NpemUgPD0gKHVpbnQ2NF90KTB4RkZGRkZGRkYpAEZpbmlzaFdyaXRlAFdyaXRlOiAiJXMiOiB0eXBlICVzAFdyaXRlOiAAV3JpdGU6ICIlcyI6IGZpbmlzaGVkICVzAGFzc2VydCBmYWlsdXJlOiAocFByb3BlcnR5KQBBZGRQcm9wZXJ0eQB2ZXJzaW9uAGZsYWdzACIlcyI6IHR5cGUgJXMgKCVzKQAiJXMiOiA8dGFibGUgZW50cmllcyBzdXBwcmVzc2VkPgBpbHN0AGFzc2VydCBmYWlsdXJlOiAoQVRPTUlEKCB0eXBlICkgIT0gQVRPTUlEKCAiaWxzdCIgKSkAZmFjdG9yeQAtLS0tAG1lYW4AbmFtZQBtZXRhAGhkbHIAaG50aQBoaW5mAEGgzAELlrUB5mgAAOtoAADwaAAA9WgAAPpoAAD/aAAABGkAAAlpAAAOaQAAE2kAABhpAAAdaQAAImkAACdpAAAsaQAAMWkAADZpAAA7aQAAQGkAAEVpAABKaQAAT2kAAFRpAABZaQAAXmkAAGNpAABoaQAAbWkAAHJpAAB3aQAAfGkAAIFpAACGaQAAi2kAAJBpAACVaQAAmmkAAJ9pAACkaQAA+WUAAKlpAACuaQAAs2kAALhpAAAAAAAAU1ZRMwBTTUkgAGF2YzEAYWMtMwBhdmNDAGFsaXMAYWxhdwBhbGFjAGNoYXAAY2hwbABjb2xyAGQyNjMAZGFtcgBkcmVmAGRwbmQAZGFjMwBlbHN0AGVuY2EAZW5jdgBmcmVlAGZ0eXAAZnRhYgBnbWluAGhpbnQAaDI2MwBocmVmAGlwaXIAaW1hNABqcGVnAG1kaGQAbXZoZABtZGF0AG1wb2QAbXA0YQBtcDRzAG1wNHYAbm1oZABvaGRyAHBhc3AAcnRwIAByYXcgAHMyNjMAc2FtcgBzYXdiAHNkdHAAc3RibABzdHNkAHN0c3oAc3RzYwBzdHoyAHN0ZHAAc2RwIABzeW5jAHNraXAAc293dAB0ZXh0AHR4M2cAdGtoZAB0ZmhkAHRydW4AdHdvcwB1cmwgAHVybiAAdWxhdwB2bWhkAHl1djIATjVtcDR2MjRpbXBsN01QNEF0b21FAOz+AAAeaAAAaWxsZWdhbCBhcnJheSBpbmRleDogACBvZiAAL2hvbWUvdXNlci9saWJtcDR2Mi9zcmMvbXA0cHJvcGVydHkuaABvcGVyYXRvcltdAC9ob21lL3VzZXIvbGlibXA0djIvc3JjL21wNGF0b20uaABpbGxlZ2FsIGFycmF5IGluZGV4AEluc2VydABwcm9wZXJ0eSBpcyByZWFkLW9ubHk6IABTZXRWYWx1ZQCpYXJnAKlhcmsAqWNvawCpY29tAKljcHkAqWRheQCpZGlyAKllZDEAqWVkMgCpZWQzAKllZDQAqWVkNQCpZWQ2AKllZDcAqWVkOACpZWQ5AKlmbXQAqWluZgCpaXNyAKlsYWIAqWxhbACpbWFrAKluYWsAqW5hbQCpcGRrAKlwaGcAqXByZACpcHJmAKlwcmsAqXBybACpcmVxAKlzbmsAqXNubQCpc3JjAKlzd2YAqXN3awCpc3dyAKl3cnQAQWxsZgBMT09QAHB0diAAU2VsTwBXTE9DAAAAAAAAAABoawAAigAAAJIBAACMAAAAjQAAAI4AAACPAAAAkAAAAGFzc2VydCBmYWlsdXJlOiAocFByb3BlcnR5KQAvaG9tZS91c2VyL2xpYm1wNHYyL3NyYy9tcDRkZXNjcmlwdG9yLmNwcABBZGRQcm9wZXJ0eQAiJXMiOiBSZWFkRGVzY3JpcHRvcjogcG9zID0gMHglbGx4AGFzc2VydCBmYWlsdXJlOiAodGFnID09IG1fdGFnKQBSZWFkSGVhZGVyACIlcyI6IFJlYWREZXNjcmlwdG9yOiB0YWcgMHglMDJ4IGRhdGEgc2l6ZSAldSAoMHgleCkAJXM6ICIlcyI6IE92ZXJyYW4gZGVzY3JpcHRvciwgdGFnICV1IGRhdGEgc2l6ZSAldSBwcm9wZXJ0eSAldQBSZWFkUHJvcGVydGllcwBvdmVycmFuIGRlc2NyaXB0b3IAV2FybmluZyAoJXMpIGluICVzIGF0IGxpbmUgJXUAbnVtUHJvcGVydGllcyA9PSAwAE41bXA0djI0aW1wbDEzTVA0RGVzY3JpcHRvckUAAADs/gAASWsAAGFzc2VydCBmYWlsdXJlOiAoZmlsZSkAL2hvbWUvdXNlci9saWJtcDR2Mi9zcmMvbXA0ZmlsZV9pby5jcHAAR2V0UG9zaXRpb24AcG9zaXRpb24gb3V0IG9mIHJhbmdlAFNldFBvc2l0aW9uAHNlZWsgZmFpbGVkAEdldFNpemUAYXNzZXJ0IGZhaWx1cmU6IChidWYpAFJlYWRCeXRlcwBXYXJuaW5nICglcykgaW4gJXMgYXQgbGluZSAldQBtX251bVJlYWRCaXRzID4gMABub3QgZW5vdWdoIGJ5dGVzLCByZWFjaGVkIGVuZC1vZi1tZW1vcnkAcmVhZCBmYWlsZWQAbm90IGVub3VnaCBieXRlcywgcmVhY2hlZCBlbmQtb2YtZmlsZQBhc3NlcnQgZmFpbHVyZTogKG1fbnVtV3JpdGVCaXRzID09IDAgfHwgbV9udW1Xcml0ZUJpdHMgPj0gOCkAV3JpdGVCeXRlcwB3cml0ZSBmYWlsZWQAbm90IGFsbCBieXRlcyB3cml0dGVuACBvdXQgb2YgcmFuZ2UAV3JpdGVGaXhlZDE2AFdyaXRlRml4ZWQzMgBDb3VudGVkIHN0cmluZyB0b28gbG9uZyAyNSAqIDI1NQBSZWFkQ291bnRlZFN0cmluZwBjaGFyTGVuZ3RoID4gZml4ZWRMZW5ndGggLSAxAExlbmd0aCBpcyAAV3JpdGVDb3VudGVkU3RyaW5nAGFzc2VydCBmYWlsdXJlOiAobnVtQml0cyA+IDApAFJlYWRCaXRzAGFzc2VydCBmYWlsdXJlOiAobnVtQml0cyA8PSA2NCkAV3JpdGVCaXRzAG91dCBvZiByYW5nZTogAFdyaXRlTXBlZ0xlbmd0aABhYXIAYWJrAEFia2hhemlhbgBhY2UAYWNoAEFjb2xpAGFkYQBBZGFuZ21lAGFkeQBBZHlnaGU7IEFkeWdlaQBhZmEAQWZyby1Bc2lhdGljIChPdGhlcikAYWZoAGFmcgBBZnJpa2FhbnMAYWluAGFrYQBha2sAc3FpAGFsZQBBbGV1dABhbGcAQWxnb25xdWlhbiBsYW5ndWFnZXMAYWx0AFNvdXRoZXJuIEFsdGFpAGFtaABBbWhhcmljAGFuZwBFbmdsaXNoLCBPbGQgKGNhLjQ1MC0xMTAwKQBhbnAAQW5naWthAGFwYQBBcGFjaGUgbGFuZ3VhZ2VzAGFyYQBBcmFiaWMAYXJjAE9mZmljaWFsIEFyYW1haWMgKDcwMC0zMDAgQkNFKTsgSW1wZXJpYWwgQXJhbWFpYyAoNzAwLTMwMCBCQ0UpAGFyZwBBcmFnb25lc2UAaHllAGFybgBNYXB1ZHVuZ3VuOyBNYXB1Y2hlAGFycABBcmFwYWhvAGFydABBcnRpZmljaWFsIChPdGhlcikAYXJ3AEFyYXdhawBhc20AYXN0AEFzdHVyaWFuOyBCYWJsZTsgTGVvbmVzZTsgQXN0dXJsZW9uZXNlAGF0aABBdGhhcGFzY2FuIGxhbmd1YWdlcwBhdXMAQXVzdHJhbGlhbiBsYW5ndWFnZXMAYXZhAEF2YXJpYwBhdmUAQXZlc3RhbgBhd2EAQXdhZGhpAGF5bQBBeW1hcmEAYXplAEF6ZXJiYWlqYW5pAGJhZABCYW5kYSBsYW5ndWFnZXMAYmFpAEJhbWlsZWtlIGxhbmd1YWdlcwBiYWsAQmFzaGtpcgBiYWwAQmFsdWNoaQBiYW0AQmFtYmFyYQBiYW4AZXVzAEJhc3F1ZQBiYXMAYmF0AEJhbHRpYyAoT3RoZXIpAGJlagBCZWphOyBCZWRhd2l5ZXQAYmVsAEJlbGFydXNpYW4AYmVtAEJlbWJhAGJlbgBCZW5nYWxpAGJlcgBCZXJiZXIgKE90aGVyKQBiaG8AYmloAEJpaGFyaQBiaWsAQmlrb2wAYmluAEJpbmk7IEVkbwBiaXMAQmlzbGFtYQBibGEAU2lrc2lrYQBibnQAQmFudHUgKE90aGVyKQBib3MAQm9zbmlhbgBicmEAYnJlAEJyZXRvbgBidGsAQmF0YWsgbGFuZ3VhZ2VzAGJ1YQBCdXJpYXQAYnVnAGJ1bABCdWxnYXJpYW4AbXlhAEJ1cm1lc2UAYnluAEJsaW47IEJpbGluAGNhZABDYWRkbwBjYWkAQ2VudHJhbCBBbWVyaWNhbiBJbmRpYW4gKE90aGVyKQBjYXIAR2FsaWJpIENhcmliAGNhdABDYXRhbGFuOyBWYWxlbmNpYW4AY2F1AENhdWNhc2lhbiAoT3RoZXIpAGNlYgBDZWJ1YW5vAGNlbABDZWx0aWMgKE90aGVyKQBjaGEAY2hiAENoaWJjaGEAY2hlAENoZWNoZW4AY2hnAHpobwBDaGluZXNlAGNoawBjaG0AY2huAENoaW5vb2sgamFyZ29uAGNobwBDaG9jdGF3AGNocABDaGlwZXd5YW47IERlbmUgU3VsaW5lAGNocgBjaHUAQ2h1cmNoIFNsYXZpYzsgT2xkIFNsYXZvbmljOyBDaHVyY2ggU2xhdm9uaWM7IE9sZCBCdWxnYXJpYW47IE9sZCBDaHVyY2ggU2xhdm9uaWMAY2h2AENodXZhc2gAY2h5AGNtYwBDaGFtaWMgbGFuZ3VhZ2VzAGNvcABDb3B0aWMAY29yAENvcm5pc2gAY29zAGNwZQBDcmVvbGVzIGFuZCBwaWRnaW5zLCBFbmdsaXNoIGJhc2VkIChPdGhlcikAY3BmAENyZW9sZXMgYW5kIHBpZGdpbnMsIEZyZW5jaC1iYXNlZCAoT3RoZXIpAGNwcABDcmVvbGVzIGFuZCBwaWRnaW5zLCBQb3J0dWd1ZXNlLWJhc2VkIChPdGhlcikAY3JlAGNyaABDcmltZWFuIFRhdGFyOyBDcmltZWFuIFR1cmtpc2gAY3JwAENyZW9sZXMgYW5kIHBpZGdpbnMgKE90aGVyKQBjc2IAS2FzaHViaWFuAGN1cwBDdXNoaXRpYyAoT3RoZXIpAGNlcwBDemVjaABkYWsARGFrb3RhAGRhbgBEYW5pc2gAZGFyAERhcmd3YQBkYXkATGFuZCBEYXlhayBsYW5ndWFnZXMAZGVsAGRlbgBTbGF2ZSAoQXRoYXBhc2NhbikAZGdyAERvZ3JpYgBkaW4ARGlua2EAZGl2AERpdmVoaTsgRGhpdmVoaTsgTWFsZGl2aWFuAGRvaQBEb2dyaQBkcmEARHJhdmlkaWFuIChPdGhlcikAZHNiAExvd2VyIFNvcmJpYW4AZHVhAER1YWxhAGR1bQBEdXRjaCwgTWlkZGxlIChjYS4xMDUwLTEzNTApAG5sZABEdXRjaDsgRmxlbWlzaABkeXUARHl1bGEAZHpvAGVmaQBlZ3kARWd5cHRpYW4gKEFuY2llbnQpAGVrYQBFa2FqdWsAZWx4AEVsYW1pdGUAZW5nAEVuZ2xpc2gAZW5tAEVuZ2xpc2gsIE1pZGRsZSAoMTEwMC0xNTAwKQBlcG8ARXNwZXJhbnRvAGVzdABld2UARXdlAGV3bwBFd29uZG8AZmFuAGZhbwBGYXJvZXNlAGZhdABGYW50aQBmaWoARmlqaWFuAGZpbABGaWxpcGlubzsgUGlsaXBpbm8AZmluAEZpbm5pc2gAZml1AEZpbm5vLVVncmlhbiAoT3RoZXIpAGZvbgBGb24AZnJhAEZyZW5jaABmcm0ARnJlbmNoLCBNaWRkbGUgKGNhLjE0MDAtMTYwMCkAZnJvAEZyZW5jaCwgT2xkICg4NDItY2EuMTQwMCkAZnJyAE5vcnRoZXJuIEZyaXNpYW4AZnJzAEVhc3Rlcm4gRnJpc2lhbgBmcnkAV2VzdGVybiBGcmlzaWFuAGZ1bABGdWxhaABmdXIAZ2FhAGdheQBnYmEAR2JheWEAZ2VtAEdlcm1hbmljIChPdGhlcikAa2F0AGRldQBHZXJtYW4AZ2V6AGdpbABHaWxiZXJ0ZXNlAGdsYQBHYWVsaWM7IFNjb3R0aXNoIEdhZWxpYwBnbGUASXJpc2gAZ2xnAGdsdgBnbWgAR2VybWFuLCBNaWRkbGUgSGlnaCAoY2EuMTA1MC0xNTAwKQBnb2gAR2VybWFuLCBPbGQgSGlnaCAoY2EuNzUwLTEwNTApAGdvbgBHb25kaQBnb3IAR29yb250YWxvAGdvdABHb3RoaWMAZ3JiAEdyZWJvAGdyYwBHcmVlaywgQW5jaWVudCAodG8gMTQ1MykAZWxsAEdyZWVrLCBNb2Rlcm4gKDE0NTMtKQBncm4AR3VhcmFuaQBnc3cAU3dpc3MgR2VybWFuOyBBbGVtYW5uaWM7IEFsc2F0aWFuAGd1agBnd2kAaGFpAEhhaWRhAGhhdABIYWl0aWFuOyBIYWl0aWFuIENyZW9sZQBoYXUASGF1c2EAaGF3AGhlYgBIZWJyZXcAaGVyAEhlcmVybwBoaWwASGlsaWdheW5vbgBoaW0ASGltYWNoYWxpAGhpbgBIaW5kaQBoaXQASGl0dGl0ZQBobW4ASG1vbmcAaG1vAEhpcmkgTW90dQBocnYAaHNiAFVwcGVyIFNvcmJpYW4AaHVuAEh1bmdhcmlhbgBodXAAaWJhAGlibwBpc2wASWNlbGFuZGljAGlkbwBJZG8AaWlpAFNpY2h1YW4gWWk7IE51b3N1AGlqbwBJam8gbGFuZ3VhZ2VzAGlrdQBJbnVrdGl0dXQAaWxlAEludGVybGluZ3VlOyBPY2NpZGVudGFsAGlsbwBJbG9rbwBpbmEASW50ZXJsaW5ndWEgKEludGVybmF0aW9uYWwgQXV4aWxpYXJ5IExhbmd1YWdlIEFzc29jaWF0aW9uKQBpbmMASW5kaWMgKE90aGVyKQBpbmQASW5kb25lc2lhbgBpbmUASW5kby1FdXJvcGVhbiAoT3RoZXIpAGluaABJbmd1c2gAaXBrAEludXBpYXEAaXJhAElyYW5pYW4gKE90aGVyKQBpcm8ASXJvcXVvaWFuIGxhbmd1YWdlcwBpdGEASXRhbGlhbgBqYXYAamJvAExvamJhbgBqcG4AanByAEp1ZGVvLVBlcnNpYW4AanJiAEp1ZGVvLUFyYWJpYwBrYWEAS2FyYS1LYWxwYWsAa2FiAEthYnlsZQBrYWMAS2FjaGluOyBKaW5ncGhvAGthbABLYWxhYWxsaXN1dDsgR3JlZW5sYW5kaWMAa2FtAEthbWJhAGthbgBLYW5uYWRhAGthcgBLYXJlbiBsYW5ndWFnZXMAa2FzAGthdQBLYW51cmkAa2F3AGthegBLYXpha2gAa2JkAEthYmFyZGlhbgBraGEAS2hhc2kAa2hpAEtob2lzYW4gKE90aGVyKQBraG0AQ2VudHJhbCBLaG1lcgBraG8AS2hvdGFuZXNlOyBTYWthbgBraWsAS2lrdXl1OyBHaWt1eXUAa2luAEtpbnlhcndhbmRhAGtpcgBLaXJnaGl6OyBLeXJneXoAa21iAGtvawBLb25rYW5pAGtvbQBrb24AS29uZ28Aa29yAEtvcmVhbgBrb3MAa3BlAEtwZWxsZQBrcmMAS2FyYWNoYXktQmFsa2FyAGtybABrcm8AS3J1IGxhbmd1YWdlcwBrcnUAS3VydWtoAGt1YQBLdWFueWFtYTsgS3dhbnlhbWEAa3VtAEt1bXlrAGt1cgBLdXJkaXNoAGt1dABLdXRlbmFpAGxhZABMYWRpbm8AbGFoAExhaG5kYQBsYW0ATGFtYmEAbGFvAExhbwBsYXQATGF0aW4AbGF2AExhdHZpYW4AbGV6AGxpbQBMaW1idXJnYW47IExpbWJ1cmdlcjsgTGltYnVyZ2lzaABsaW4ATGluZ2FsYQBsaXQATGl0aHVhbmlhbgBsb2wATW9uZ28AbG96AGx0egBMdXhlbWJvdXJnaXNoOyBMZXR6ZWJ1cmdlc2NoAGx1YQBMdWJhLUx1bHVhAGx1YgBMdWJhLUthdGFuZ2EAbHVnAEdhbmRhAGx1aQBMdWlzZW5vAGx1bgBMdW5kYQBsdW8ATHVvIChLZW55YSBhbmQgVGFuemFuaWEpAGx1cwBMdXNoYWkAbWtkAE1hY2Vkb25pYW4AbWFkAG1hZwBNYWdhaGkAbWFoAE1hcnNoYWxsZXNlAG1haQBtYWsATWFrYXNhcgBtYWwATWFsYXlhbGFtAG1hbgBtcmkATWFvcmkAbWFwAEF1c3Ryb25lc2lhbiAoT3RoZXIpAG1hcgBNYXJhdGhpAG1hcwBNYXNhaQBtc2EATWFsYXkAbWRmAE1va3NoYQBtZHIATWFuZGFyAG1lbgBNZW5kZQBtZ2EASXJpc2gsIE1pZGRsZSAoOTAwLTEyMDApAG1pYwBNaSdrbWFxOyBNaWNtYWMAbWluAE1pbmFuZ2thYmF1AG1pcwBVbmNvZGVkIGxhbmd1YWdlcwBta2gATW9uLUtobWVyIChPdGhlcikAbWxnAG1sdABNYWx0ZXNlAG1uYwBNYW5jaHUAbW5pAG1ubwBNYW5vYm8gbGFuZ3VhZ2VzAG1vaABNb2hhd2sAbW9uAE1vbmdvbGlhbgBtb3MATW9zc2kAbXVsAE11bHRpcGxlIGxhbmd1YWdlcwBtdW4ATXVuZGEgbGFuZ3VhZ2VzAG11cwBDcmVlawBtd2wATWlyYW5kZXNlAG13cgBNYXJ3YXJpAG15bgBNYXlhbiBsYW5ndWFnZXMAbXl2AEVyenlhAG5haABOYWh1YXRsIGxhbmd1YWdlcwBuYWkATm9ydGggQW1lcmljYW4gSW5kaWFuAG5hcABOZWFwb2xpdGFuAG5hdQBOYXVydQBuYXYATmF2YWpvOyBOYXZhaG8AbmJsAE5kZWJlbGUsIFNvdXRoOyBTb3V0aCBOZGViZWxlAG5kZQBOZGViZWxlLCBOb3J0aDsgTm9ydGggTmRlYmVsZQBuZG8ATmRvbmdhAG5kcwBMb3cgR2VybWFuOyBMb3cgU2F4b247IEdlcm1hbiwgTG93OyBTYXhvbiwgTG93AG5lcABOZXBhbGkAbmV3AE5lcGFsIEJoYXNhOyBOZXdhcmkAbmlhAG5pYwBOaWdlci1Lb3Jkb2ZhbmlhbiAoT3RoZXIpAG5pdQBOaXVlYW4Abm5vAE5vcndlZ2lhbiBOeW5vcnNrOyBOeW5vcnNrLCBOb3J3ZWdpYW4Abm9iAEJva23DpWwsIE5vcndlZ2lhbjsgTm9yd2VnaWFuIEJva23DpWwAbm9nAE5vZ2FpAG5vbgBOb3JzZSwgT2xkAG5vcgBOb3J3ZWdpYW4AbnFvAG5zbwBQZWRpOyBTZXBlZGk7IE5vcnRoZXJuIFNvdGhvAG51YgBOdWJpYW4gbGFuZ3VhZ2VzAG53YwBDbGFzc2ljYWwgTmV3YXJpOyBPbGQgTmV3YXJpOyBDbGFzc2ljYWwgTmVwYWwgQmhhc2EAbnlhAENoaWNoZXdhOyBDaGV3YTsgTnlhbmphAG55bQBueW4AbnlvAE55b3JvAG56aQBOemltYQBvY2kAT2NjaXRhbiAocG9zdCAxNTAwKTsgUHJvdmVuw6dhbABvamkAT2ppYndhAG9yaQBPcml5YQBvcm0AT3JvbW8Ab3NhAE9zYWdlAG9zcwBPc3NldGlhbjsgT3NzZXRpYwBvdGEAVHVya2lzaCwgT3R0b21hbiAoMTUwMC0xOTI4KQBvdG8AT3RvbWlhbiBsYW5ndWFnZXMAcGFhAFBhcHVhbiAoT3RoZXIpAHBhZwBQYW5nYXNpbmFuAHBhbABQYWhsYXZpAHBhbQBQYW1wYW5nYTsgS2FwYW1wYW5nYW4AcGFuAFBhbmphYmk7IFB1bmphYmkAcGFwAFBhcGlhbWVudG8AcGF1AFBhbGF1YW4AcGVvAFBlcnNpYW4sIE9sZCAoY2EuNjAwLTQwMCBCLkMuKQBmYXMAUGVyc2lhbgBwaGkAUGhpbGlwcGluZSAoT3RoZXIpAHBobgBQaG9lbmljaWFuAHBsaQBwb2wAUG9saXNoAHBvbgBQb2hucGVpYW4AcG9yAFBvcnR1Z3Vlc2UAcHJhAFByYWtyaXQgbGFuZ3VhZ2VzAHBybwBQcm92ZW7Dp2FsLCBPbGQgKHRvIDE1MDApAHB1cwBQdXNodG87IFBhc2h0bwBxdWUAUXVlY2h1YQByYWoAUmFqYXN0aGFuaQByYXAAUmFwYW51aQByYXIAUmFyb3RvbmdhbjsgQ29vayBJc2xhbmRzIE1hb3JpAHJvYQBSb21hbmNlIChPdGhlcikAcm9oAFJvbWFuc2gAcm9tAFJvbWFueQByb24AUm9tYW5pYW47IE1vbGRhdmlhbjsgTW9sZG92YW4AcnVuAFJ1bmRpAHJ1cABBcm9tYW5pYW47IEFydW1hbmlhbjsgTWFjZWRvLVJvbWFuaWFuAHJ1cwBSdXNzaWFuAHNhZABTYW5kYXdlAHNhZwBTYW5nbwBzYWgAWWFrdXQAc2FpAFNvdXRoIEFtZXJpY2FuIEluZGlhbiAoT3RoZXIpAHNhbABTYWxpc2hhbiBsYW5ndWFnZXMAc2FtAFNhbWFyaXRhbiBBcmFtYWljAHNhbgBzYXMAU2FzYWsAc2F0AFNhbnRhbGkAc2NuAHNjbwBTY290cwBzZWwAU2Vsa3VwAHNlbQBTZW1pdGljIChPdGhlcikAc2dhAElyaXNoLCBPbGQgKHRvIDkwMCkAc2duAFNpZ24gTGFuZ3VhZ2VzAHNobgBzaWQAU2lkYW1vAHNpbgBTaW5oYWxhOyBTaW5oYWxlc2UAc2lvAFNpb3VhbiBsYW5ndWFnZXMAc2l0AFNpbm8tVGliZXRhbiAoT3RoZXIpAHNsYQBTbGF2aWMgKE90aGVyKQBzbGsAU2xvdmFrAHNsdgBTbG92ZW5pYW4Ac21hAFNvdXRoZXJuIFNhbWkAc21lAE5vcnRoZXJuIFNhbWkAc21pAFNhbWkgbGFuZ3VhZ2VzIChPdGhlcikAc21qAEx1bGUgU2FtaQBzbW4ASW5hcmkgU2FtaQBzbW8AU2Ftb2FuAHNtcwBTa29sdCBTYW1pAHNuYQBTaG9uYQBzbmQAU2luZGhpAHNuawBTb25pbmtlAHNvZwBTb2dkaWFuAHNvbQBTb21hbGkAc29uAFNvbmdoYWkgbGFuZ3VhZ2VzAHNvdABTb3RobywgU291dGhlcm4Ac3BhAFNwYW5pc2g7IENhc3RpbGlhbgBzcmQAU2FyZGluaWFuAHNybgBTcmFuYW4gVG9uZ28Ac3JwAFNlcmJpYW4Ac3JyAFNlcmVyAHNzYQBOaWxvLVNhaGFyYW4gKE90aGVyKQBzc3cAU3dhdGkAc3VrAFN1a3VtYQBzdW4AU3VuZGFuZXNlAHN1cwBzdXgAc3dhAFN3YWhpbGkAc3dlAFN3ZWRpc2gAc3ljAENsYXNzaWNhbCBTeXJpYWMAc3lyAFN5cmlhYwB0YWgAdGFpAFRhaSAoT3RoZXIpAHRhbQBUYW1pbAB0YXQAVGF0YXIAdGVsAFRlbHVndQB0ZW0AVGltbmUAdGVyAFRlcmVubwB0ZXQAVGV0dW0AdGdrAFRhamlrAHRnbABUYWdhbG9nAHRoYQBib2QAVGliZXRhbgB0aWcAVGlncmUAdGlyAHRpdgBUaXYAdGtsAFRva2VsYXUAdGxoAEtsaW5nb247IHRsaEluZ2FuLUhvbAB0bGkAVGxpbmdpdAB0bWgAdG9nAFRvbmdhIChOeWFzYSkAdG9uAFRvbmdhIChUb25nYSBJc2xhbmRzKQB0cGkAVG9rIFBpc2luAHRzaQBUc2ltc2hpYW4AdHNuAFRzd2FuYQB0c28AVHNvbmdhAHR1awBUdXJrbWVuAHR1bQBUdW1idWthAHR1cABUdXBpIGxhbmd1YWdlcwB0dXIAVHVya2lzaAB0dXQAQWx0YWljIChPdGhlcikAdHZsAFR1dmFsdQB0d2kAVHdpAHR5dgB1ZG0AVWRtdXJ0AHVnYQB1aWcAVWlnaHVyOyBVeWdodXIAdWtyAFVrcmFpbmlhbgB1bWIAVW1idW5kdQB1bmQAVW5kZXRlcm1pbmVkAHVyZAB1emIAVXpiZWsAdmFpAFZhaQB2ZW4AVmVuZGEAdmllAFZpZXRuYW1lc2UAdm9sAHZvdABWb3RpYwB3YWsAV2FrYXNoYW4gbGFuZ3VhZ2VzAHdhbABXYWxhbW8Ad2FyAFdhcmF5AHdhcwBXYXNobwBjeW0AV2Vsc2gAd2VuAFNvcmJpYW4gbGFuZ3VhZ2VzAHdsbgBXYWxsb29uAHdvbABXb2xvZgB4YWwAS2FsbXlrOyBPaXJhdAB4aG8AWGhvc2EAeWFvAFlhbwB5YXAAWWFwZXNlAHlpZABZaWRkaXNoAHlvcgBZb3J1YmEAeXBrAFl1cGlrIGxhbmd1YWdlcwB6YXAAWmFwb3RlYwB6YmwAQmxpc3N5bWJvbHM7IEJsaXNzeW1ib2xpY3M7IEJsaXNzAHplbgBaZW5hZ2EAemhhAFpodWFuZzsgQ2h1YW5nAHpuZABaYW5kZSBsYW5ndWFnZXMAenVsAHp1bgB6eHgATm8gbGluZ3Vpc3RpYyBjb250ZW50OyBOb3QgYXBwbGljYWJsZQB6emEAWmF6YTsgRGltaWxpOyBEaW1saTsgS2lyZGtpOyBLaXJtYW5qa2k7IFphemFraQBhc3NlcnQgZmFpbHVyZTogKG1fZmlsZSkAL2hvbWUvdXNlci9saWJtcDR2Mi9zcmMvbXA0ZmlsZS5jcHAAR2V0RmlsZW5hbWUAbWRhdABtb292AGlvZHMAc3RibABtdmhkAHRraGQAbWRoZABmcmVlAG1vb3YubXZoZC5tb2RpZmljYXRpb25UaW1lAGhpbnQAYXNzZXJ0IGZhaWx1cmU6ICghbV9maWxlKQBPcGVuAG9wZW4oACkgZmFpbGVkAG1vb3YudHJha1sldV0AdHJhay50a2hkLnRyYWNrSWQAdHJhay5tZGlhLmhkbHIuaGFuZGxlclR5cGUAbW9vdi5tdmhkLnRpbWVTY2FsZQBtb292Lm12aGQuZHVyYXRpb24AbW9vdi51ZHRhLm1ldGEuaWxzdABtb292LnVkdGEubWV0YQBoZGxyAG1vb3YudWR0YS5uYW1lAG1vb3YudWR0YS5uYW1lLnZhbHVlAG1vb3YudWR0YQBhc3NlcnQgZmFpbHVyZTogKG1fcFRyYWNrc1tpXSkARmluaXNoV3JpdGUAYXNzZXJ0IGZhaWx1cmU6IChyb290KQBhc3NlcnQgZmFpbHVyZTogKGZyZWVBdG9tKQBvcGVyYXRpb24gbm90IHBlcm1pdHRlZCBpbiByZWFkIG1vZGUAYXNzZXJ0IGZhaWx1cmU6IChwUGFyZW50QXRvbSkASW5zZXJ0Q2hpbGRBdG9tAG5vIHN1Y2ggcHJvcGVydHkgLSAARmluZEludGVnZXJQcm9wZXJ0eQB0eXBlIG1pc21hdGNoIC0gcHJvcGVydHkgACB0eXBlIABTZXRJbnRlZ2VyUHJvcGVydHkARmluZEZsb2F0UHJvcGVydHkAU2V0RmxvYXRQcm9wZXJ0eQBubyBzdWNoIHByb3BlcnR5IABGaW5kQnl0ZXNQcm9wZXJ0eQAgLSB0eXBlIABBZGRUcmFjawB0cmFrAGFzc2VydCBmYWlsdXJlOiAocFRyYWtBdG9tKQBhc3NlcnQgZmFpbHVyZTogKHBJbnRlZ2VyMzJQcm9wZXJ0eSkAJXM6ICIlcyI6IHR5cGUgdHJ1bmNhdGVkIHRvIGZvdXIgY2hhcmFjdGVycwBhc3NlcnQgZmFpbHVyZTogKHBTdHJpbmdQcm9wZXJ0eSkAdHJhay5tZGlhLm1kaGQudGltZVNjYWxlAHRraGQuZmxhZ3MAdHJlZi5tcG9kACVzLiVzAGVudHJ5Q291bnQAZW50cmllcy50cmFja0lkAG1kaWEubWluZi5kaW5mLmRyZWYAYXNzZXJ0IGZhaWx1cmU6IChwRHJlZkF0b20pAEFkZERhdGFSZWZlcmVuY2UAZHJlZi5lbnRyeUNvdW50AGFzc2VydCBmYWlsdXJlOiAocENvdW50UHJvcGVydHkpAHVybCAAdXJsIC5sb2NhdGlvbgBhc3NlcnQgZmFpbHVyZTogKHBVcmxQcm9wZXJ0eSkAbWRpYS5taW5mAG1kaWEubWluZi5zdGJsLnN0c2QAbWRpYS5taW5mLnN0Ymwuc3RzZC5lbnRyeUNvdW50AGZ0eXAAbWRpYS5taW5mLnN0Ymwuc3Rzei5zYW1wbGVTaXplAHZpZGUAdGtoZC53aWR0aAB0a2hkLmhlaWdodAB2bWhkAGVuY3YAYXZjMQBtZGlhLm1pbmYuc3RibC5zdHNkLmF2YzEud2lkdGgAbWRpYS5taW5mLnN0Ymwuc3RzZC5hdmMxLmhlaWdodABtZGlhLm1pbmYuc3RibC5zdHNkLmF2YzEuYXZjQy5BVkNQcm9maWxlSW5kaWNhdGlvbgBtZGlhLm1pbmYuc3RibC5zdHNkLmF2YzEuYXZjQy5wcm9maWxlX2NvbXBhdGliaWxpdHkAbWRpYS5taW5mLnN0Ymwuc3RzZC5hdmMxLmF2Y0MuQVZDTGV2ZWxJbmRpY2F0aW9uAG1kaWEubWluZi5zdGJsLnN0c2QuYXZjMS5hdmNDLmxlbmd0aFNpemVNaW51c09uZQBtZGlhLm1pbmYuc3RibC5zdHNkLmVuY3YuYXZjQwBtZGlhLm1pbmYuc3RibC5zdHNkLmF2YzEuYXZjQwBhdmNDLm51bU9mU2VxdWVuY2VQYXJhbWV0ZXJTZXRzAGF2Y0Muc2VxdWVuY2VFbnRyaWVzLnNlcXVlbmNlUGFyYW1ldGVyU2V0TGVuZ3RoAGF2Y0Muc2VxdWVuY2VFbnRyaWVzLnNlcXVlbmNlUGFyYW1ldGVyU2V0TkFMVW5pdAAlczogIiVzIjogQ291bGQgbm90IGZpbmQgYXZjQyBwcm9wZXJ0aWVzAEFkZEgyNjRTZXF1ZW5jZVBhcmFtZXRlclNldABhdmNDLm51bU9mUGljdHVyZVBhcmFtZXRlclNldHMAYXZjQy5waWN0dXJlRW50cmllcy5waWN0dXJlUGFyYW1ldGVyU2V0TGVuZ3RoAGF2Y0MucGljdHVyZUVudHJpZXMucGljdHVyZVBhcmFtZXRlclNldE5BTFVuaXQAJXM6ICIlcyI6IENvdWxkIG5vdCBmaW5kIGF2Y0MgcGljdHVyZSB0YWJsZSBwcm9wZXJ0aWVzAEFkZEgyNjRQaWN0dXJlUGFyYW1ldGVyU2V0AGFzc2VydCBmYWlsdXJlOiAocENvdW50KQAiJXMiOiBwaWN0dXJlIG1hdGNoZXMgJWQAIiVzIjogbmV3IHBpY3R1cmUgYWRkZWQgJWQAbW9vdi5tdmhkLm5leHRUcmFja0lkAHRvbyBtYW55IGV4aXN0aW5nIHRyYWNrcwBBbGxvY1RyYWNrSWQAVHJhY2sgaWQgACBkb2Vzbid0IGV4aXN0AEZpbmRUcmFja0luZGV4AEZpbmRUcmFrQXRvbUluZGV4AFdyaXRlU2FtcGxlAG1vb3YudHJha1sldV0uJXMAaW52YWxpZCB2YWx1ZQBTZXRUaW1lU2NhbGUAbW9vdi5pb2RzLnZpc3VhbFByb2ZpbGVMZXZlbElkACVzOiAiJXMiOiB0cmFjayAlZCBoYXMgbW9yZSB0aGFuIDEgY2hpbGQgYXRvbXMgaW4gc3RzZABHZXRUcmFja01lZGlhRGF0YU5hbWUAaWxsZWdhbCBhcnJheSBpbmRleDogACBvZiAAL2hvbWUvdXNlci9saWJtcDR2Mi9zcmMvbXA0dHJhY2suaABvcGVyYXRvcltdAGlsbGVnYWwgYXJyYXkgaW5kZXgASW5zZXJ0AC9ob21lL3VzZXIvbGlibXA0djIvc3JjL21wNGFycmF5LmgAVU5ERUZJTkVEKAApAAA8AAAAAAAAAESVAACkAQAApQEAAMT////E////RJUAAKYBAACnAQAAqJQAAOCUAAD0lAAAvJQAADwAAAAAAAAAlM8AAKgBAACpAQAAxP///8T///+UzwAAqgEAAKsBAABOU3QzX18yMTliYXNpY19pc3RyaW5nc3RyZWFtSWNOU18xMWNoYXJfdHJhaXRzSWNFRU5TXzlhbGxvY2F0b3JJY0VFRUUAAAAU/wAA/JQAAJTPAABVVEYtOAB1dGYxNgBVVEYtMTYAUy9KSVMAeG1sAFhNTABnaWYAR0lGAHBuZwBQTkcAdXJsAFVSTABkYXRlL3RpbWUAZ2VucmVzAGludGVnZXIAcmlhYXBhAFJJQUEtUEEAdXBjAFVQQwBibXAAQk1QAGJsdWVzAEJsdWVzAGNsYXNzaWNyb2NrAENsYXNzaWMgUm9jawBjb3VudHJ5AENvdW50cnkAZGFuY2UARGFuY2UAZGlzY28ARGlzY28AZ3J1bmdlAEdydW5nZQBoaXBob3AASG9wLUhvcABtZXRhbABNZXRhbABuZXdhZ2UATmV3IEFnZQBvbGRpZXMAT2xkaWVzAG90aGVyAE90aGVyAHBvcABQb3AAcmFuZF9iAFImQgByYXAAUmFwAHJlZ2dhZQBSZWdnYWUAdGVjaG5vAFRlY2hubwBpbmR1c3RyaWFsAEluZHVzdHJpYWwAYWx0ZXJuYXRpdmUAQWx0ZXJuYXRpdmUAc2thAFNrYQBkZWF0aG1ldGFsAERlYXRoIE1ldGFsAHByYW5rcwBQcmFua3MAc291bmR0cmFjawBTb3VuZHRyYWNrAGV1cm90ZWNobm8ARXVyby1UZWNobm8AYW1iaWVudABBbWJpZW50AHRyaXBob3AAdm9jYWwAVm9jYWwASmF6eitGdW5rAGZ1c2lvbgBGdXNpb24AdHJhbmNlAFRyYW5jZQBjbGFzc2ljYWwAQ2xhc3NpY2FsAGluc3RydW1lbnRhbABJbnN0cnVtZW50YWwAaG91c2UASG91c2UAc291bmRjbGlwAFNvdW5kIENsaXAAZ29zcGVsAEdvc3BlbABub2lzZQBOb2lzZQBhbHRlcm5yb2NrAEFsdGVyblJvY2sAc3BhY2UAU3BhY2UAbWVkaXRhdGl2ZQBNZWRpdGF0aXZlAGluc3RydW1lbnRhbHBvcABJbnN0cnVtZW50YWwgUG9wAGluc3RydW1lbnRhbHJvY2sASW5zdHJ1bWVudGFsIFJvY2sAZXRobmljAEV0aG5pYwBnb3RoaWMAR290aGljAHRlY2hub2luZHVzdHJpYWwAVGVjaG5vLUluZHVzdHJpYWwAZWxlY3Ryb25pYwBFbGVjdHJvbmljAHBvcGZvbGsAZXVyb2RhbmNlAEV1cm9kYW5jZQBkcmVhbQBEcmVhbQBzb3V0aGVybnJvY2sAU291dGhlcm4gUm9jawBjb21lZHkAQ29tZWR5AGdhbmdzdGEAR2FuZ3N0YQB0b3A0MABUb3AgNDAAY2hyaXN0aWFucmFwAENocmlzdGlhbiBSYXAAcG9wZnVuawBqdW5nbGUASnVuZ2xlAG5hdGl2ZWFtZXJpY2FuAE5hdGl2ZSBBbWVyaWNhbgBjYWJhcmV0AENhYmFyZXQAbmV3d2F2ZQBwc3ljaGVkZWxpYwBQc3ljaGVkZWxpYwBzaG93dHVuZXMAU2hvd3R1bmVzAHRyYWlsZXIAVHJhaWxlcgBMby1GaQB0cmliYWwAVHJpYmFsAEFjaWQgUHVuawBBY2lkIEphenoAcG9sa2EAUG9sa2EAcmV0cm8AUmV0cm8AbXVzaWNhbABNdXNpY2FsAHJvY2thbmRfcm9sbABSb2NrICYgUm9sbABIYXJkIFJvY2sARm9say1Sb2NrAG5hdGlvbmFsZm9sawBOYXRpb25hbCBGb2xrAHN3aW5nAFN3aW5nAGZhc3RmdXNpb24ARmFzdCBGdXNpb24AYmVib2IAQmVib2IAbGF0aW4ATGF0aW4AcmV2aXZhbABSZXZpdmFsAGNlbHRpYwBDZWx0aWMAYmx1ZWdyYXNzAEJsdWVncmFzcwBhdmFudGdhcmRlAEF2YW50Z2FyZGUAZ290aGljcm9jawBHb3RoaWMgUm9jawBwcm9ncmVzc2l2ZXJvY2sAUHJvZ3Jlc2l2ZSBSb2NrAHBzeWNoZWRlbGljcm9jawBQc3ljaGVkZWxpYyBSb2NrAHN5bXBob25pY3JvY2sAU1lNUEhPTklDX1JPQ0sAU2xvdyBSb2NrAGJpZ2JhbmQAY2hvcnVzAENob3J1cwBlYXN5bGlzdGVuaW5nAEVhc3kgTGlzdGVuaW5nAGh1bW91cgBIdW1vcgBzcGVlY2gAU3BlZWNoAGNoYW5zb24AQ2hhc29uAG9wZXJhAE9wZXJhAGNoYW1iZXJtdXNpYwBDaGFtYmVyIE11c2ljAHNvbmF0YQBTb25hdGEAYm9vdHliYXNzAEJvb3R5IEJhc3MAcHJpbXVzAFByaW11cwBwb3JuZ3Jvb3ZlAFBvcm4gR3Jvb3ZlAHNhdGlyZQBTYXRpcmUAc2xvd2phbQB0YW5nbwBUYW5nbwBzYW1iYQBTYW1iYQBiYWxsYWQAQmFsbGFkAHBvd2VyYmFsbGFkAFBvd2VyIEJhbGxhZAByaHl0aG1pY3NvdWwAUmh5dGhtaWMgU291bABmcmVlc3R5bGUARnJlZXN0eWxlAFB1bmsgUm9jawBEcnVtIFNvbG8AQSBjYXBlbGxhAGV1cm9ob3VzZQBFdXJvLUhvdXNlAGRhbmNlaGFsbABEYW5jZSBIYWxsAE1vdmllAG5vcm1hbABOb3JtYWwAYXVkaW9ib29rAEF1ZGlvIEJvb2sAbXVzaWN2aWRlbwBNdXNpYyBWaWRlbwBtb3ZpZQB0dnNob3cAVFYgU2hvdwBib29rbGV0AEJvb2tsZXQAaXR1bmVzAGlUdW5lcwBhb2wAQU9MAHVzYQBVbml0ZWQgU3RhdGVzAGZyYQBGcmFuY2UAZ2VyAEdlcm1hbnkAZ2JyAFVuaXRlZCBLaW5nZG9tAGF1dABBdXN0cmlhAGJlbABCZWxnaXVtAGZpbgBGaW5sYW5kAGdyYwBHcmVlY2UAaXJsAElyZWxhbmQAaXRhAEl0YWx5AGx1eABMdXhlbWJvdXJnAG5sZABOZXRoZXJsYW5kcwBwcnQAZXNwAFNwYWluAGNhbgBDYW5hZGEAc3dlAFN3ZWRlbgBub3IATm9yd2F5AGRuawBEZW5tYXJrAGNoZQBTd2l0emVybGFuZABhdXMAQXVzdHJhbGlhAG56bABOZXcgWmVhbGFuZABqcG4ASmFwYW4AY2xlYW4AQ2xlYW4AR0lGODdhAEdJRjg5YQD/2P8AAAAAAAAApgAAywEAAMwBAADNAQAAzQEAAM0BAABvAAAAzQEAAM0BAADNAQAAGwEAACIlcyI6IEZpbmRQcm9wZXJ0eTogbWF0Y2hlZCAlcwBhc3NlcnQgZmFpbHVyZTogKGZhbHNlKQAvaG9tZS91c2VyL2xpYm1wNHYyL3NyYy9tcDRwcm9wZXJ0eS5jcHAAR2V0VmFsdWUAU2V0VmFsdWUAIiVzIjogJXNbJXVdID0gJXUgKDB4JTAyeCkAIiVzIjogJXMgPSAldSAoMHglMDJ4KQAiJXMiOiAlc1sldV0gPSAldSAoMHglMDR4KQAiJXMiOiAlcyA9ICV1ICgweCUwNHgpACIlcyI6ICVzWyV1XSA9ICV1ICgweCUwNngpACIlcyI6ICVzID0gJXUgKDB4JTA2eCkAIiVzIjogJXNbJXVdID0gJXUgKDB4JTA4eCkAIiVzIjogJXMgPSAldSAoMHglMDh4KQAiJXMiOiAlc1sldV0gPSAlbGx1ICgweCUwMTZsbHgpACIlcyI6ICVzID0gJWxsdSAoMHglMDE2bGx4KQAiJXMiOiAlc1sldV0gPSAlbGx1ICgweCUwKmxseCkgPCV1IGJpdHM+ACIlcyI6ICVzID0gJWxsdSAoMHglMCpsbHgpIDwldSBiaXRzPgAiJXMiOiAlc1sldV0gPSAlZgAiJXMiOiAlcyA9ICVmAAAAAAAA/KgAABMBAADOAQAAFQEAABYBAAAXAQAAbwAAAM8BAADQAQAAGgEAABsBAABwcm9wZXJ0eSAAaXMgcmVhZC1vbmx5AFsldV0AIiVzIjogJXMlcyA9ICVscwAiJXMiOiAlcyVzID0gJXMAIiVzIjogJXMgKHNpemU9JXUpACIlcyI6ICVzWyV1XSA9ICVscwAiJXMiOiAlc1sldV0gPSAlcwAiJXMiOiA8dGFibGUgZW50cmllcyBzdXBwcmVzc2VkPgAAAAAAAAAoqQAA0QEAANIBAADTAQAA1AEAANUBAABvAAAA1gEAANcBAADYAQAAGwEAAC4AIHZhbHVlIHNpemUgACBleGNlZWRzIGZpeGVkIHZhbHVlIHNpemUgAGNhbid0IGNoYW5nZSBzaXplIG9mIGZpeGVkIHNpemVkIHByb3BlcnR5AFNldFZhbHVlU2l6ZQAiJXMiOiAlcyA9IDwldSBieXRlcz4AICAAICB8AHwAIiVzIjogJXMgPSA8JXUgYnl0ZXM+JXMAaWxzdABjb3ZyACIlcyI6ICVzACIlcyI6IDxyZW1haW5pbmcgYnl0ZXMgc3VwcmVzc2VkPgAAAAAAAAAAVKkAAGoAAADZAQAAbAAAAG0AAABuAAAAbwAAAHAAAABxAAAAcgAAAHMAAAA2AQAAdQAAAGFzc2VydCBmYWlsdXJlOiAocFByb3BlcnR5KQBBZGRQcm9wZXJ0eQBhc3NlcnQgZmFpbHVyZTogKHBQcm9wZXJ0eS0+R2V0VHlwZSgpICE9IFRhYmxlUHJvcGVydHkpAGFzc2VydCBmYWlsdXJlOiAocFByb3BlcnR5LT5HZXRUeXBlKCkgIT0gRGVzY3JpcHRvclByb3BlcnR5KQBhc3NlcnQgZmFpbHVyZTogKG1fbmFtZSkARmluZFByb3BlcnR5AGFzc2VydCBmYWlsdXJlOiAoaW5kZXggPT0gMCkAUmVhZABXYXJuaW5nICglcykgaW4gJXMgYXQgbGluZSAldQBudW1Qcm9wZXJ0aWVzID09IDAAV3JpdGUAJXM6ICIlcyI6ICVzICVzICIlcyJ0YWJsZSBlbnRyaWVzICV1IGRvZXNuJ3QgbWF0Y2ggY291bnQgJXUAYXNzZXJ0IGZhaWx1cmU6IChtX3BQcm9wZXJ0aWVzWzBdLT5HZXRDb3VudCgpID09IG51bUVudHJpZXMpAER1bXAAAAAAAAAAiKkAANoBAADbAQAA3AEAAN0BAADeAQAA3wEAAOABAADhAQAA4gEAAOMBAADkAQAAYXNzZXJ0IGZhaWx1cmU6ICh0YWcgPj0gbV90YWdzU3RhcnQgJiYgdGFnIDw9IG1fdGFnc0VuZCkAQWRkRGVzY3JpcHRvcgBhc3NlcnQgZmFpbHVyZTogKHBEZXNjcmlwdG9yKQAiJXMiOiBtYXRjaGVkICVzACVzOiAiJXMiOiBNYW5kYXRvcnkgZGVzY3JpcHRvciAweCUwMnggbWlzc2luZwAlczogIiVzIjogRGVzY3JpcHRvciAweCUwMnggaGFzIG1vcmUgdGhhbiBvbmUgaW5zdGFuY2UAAAAAAAC8qQAAywEAAOUBAADmAQAA5wEAAOgBAABvAAAA6QEAAOoBAADrAQAAGwEAACIlcyI6ICVzID0gJXMgKDB4JTA0eCkAAAAAAADsqQAAywEAAOwBAADtAQAA7gEAAO8BAABvAAAA8AEAAPEBAADyAQAAGwEAACIlcyI6ICVzID0gJXMgKDB4JTAyeCkATjVtcDR2MjRpbXBsMTFNUDRQcm9wZXJ0eUUAAADs/gAA46UAAAAAAACMpgAA8wEAAPQBAAD1AQAA9gEAAPcBAABvAAAA+AEAAPkBAAD6AQAAGwEAAE41bXA0djI0aW1wbDE5TVA0SW50ZWdlcjhQcm9wZXJ0eUUATjVtcDR2MjRpbXBsMThNUDRJbnRlZ2VyUHJvcGVydHlFAAAAABT/AABbpgAAAKYAABT/AAA4pgAAgKYAAAAAAADspgAA+wEAAPwBAAD9AQAA/gEAAP8BAABvAAAAAAIAAAECAAACAgAAGwEAAE41bXA0djI0aW1wbDIwTVA0SW50ZWdlcjE2UHJvcGVydHlFABT/AADIpgAAgKYAAAAAAABMpwAAAwIAAAQCAAAFAgAABgIAAAcCAABvAAAACAIAAAkCAAAKAgAAGwEAAE41bXA0djI0aW1wbDIwTVA0SW50ZWdlcjI0UHJvcGVydHlFABT/AAAopwAAgKYAAAAAAACspwAACwIAAAwCAAANAgAADgIAAA8CAABvAAAAEAIAABECAAASAgAAGwEAAE41bXA0djI0aW1wbDIwTVA0SW50ZWdlcjMyUHJvcGVydHlFABT/AACIpwAAgKYAAAAAAAAMqAAAEwIAABQCAAAVAgAAFgIAABcCAABvAAAAGAIAABkCAAAaAgAAGwEAAE41bXA0djI0aW1wbDIwTVA0SW50ZWdlcjY0UHJvcGVydHlFABT/AADopwAAgKYAAAAAAABsqAAAEwIAABsCAAAVAgAAFgIAABcCAABvAAAAHAIAAB0CAAAeAgAAGwEAAE41bXA0djI0aW1wbDE5TVA0Qml0ZmllbGRQcm9wZXJ0eUUAABT/AABIqAAADKgAAAAAAADMqAAAHwIAACACAAAhAgAAIgIAACMCAABvAAAAJAIAACUCAAAmAgAAGwEAAE41bXA0djI0aW1wbDE4TVA0RmxvYXQzMlByb3BlcnR5RQAAABT/AACoqAAAAKYAAE41bXA0djI0aW1wbDE3TVA0U3RyaW5nUHJvcGVydHlFAAAAABT/AADYqAAAAKYAAE41bXA0djI0aW1wbDE2TVA0Qnl0ZXNQcm9wZXJ0eUUAFP8AAAipAAAApgAATjVtcDR2MjRpbXBsMTZNUDRUYWJsZVByb3BlcnR5RQAU/wAANKkAAACmAABONW1wNHYyNGltcGwyMU1QNERlc2NyaXB0b3JQcm9wZXJ0eUUAAAAAFP8AAGCpAAAApgAATjVtcDR2MjRpbXBsMjNNUDRMYW5ndWFnZUNvZGVQcm9wZXJ0eUUAABT/AACUqQAAAKYAAE41bXA0djI0aW1wbDIwTVA0QmFzaWNUeXBlUHJvcGVydHlFABT/AADIqQAAAKYAAC9ob21lL3VzZXIvbGlibXA0djIvc3JjL21wNHByb3BlcnR5LmgAaWxsZWdhbCBhcnJheSBpbmRleAAvaG9tZS91c2VyL2xpYm1wNHYyL3NyYy9tcDRhcnJheS5oAEluc2VydABpbGxlZ2FsIGFycmF5IGluZGV4OiAAIG9mIABvcGVyYXRvcltdAHJlcXVlc3RlZCBhcnJheSBzaXplIGV4Y2VlZHMgNEdCAFJlc2l6ZQBVTkRFRklORUQoACkAAAAAAACwtQAALAIAAC0CAAAuAgAAdHJhay50a2hkLnRyYWNrSWQAdHJhay5tZGlhLm1kaGQudGltZVNjYWxlAHRyYWsudGtoZC5kdXJhdGlvbgB0cmFrLm1kaWEubWRoZC5kdXJhdGlvbgB0cmFrLnRraGQubW9kaWZpY2F0aW9uVGltZQB0cmFrLm1kaWEubWRoZC5tb2RpZmljYXRpb25UaW1lAHRyYWsubWRpYS5oZGxyLmhhbmRsZXJUeXBlAHRyYWsubWRpYS5taW5mLnN0Ymwuc3Rzei5zYW1wbGVTaXplAHRyYWsubWRpYS5taW5mLnN0Ymwuc3Rzei5zYW1wbGVDb3VudAB0cmFrLm1kaWEubWluZi5zdGJsLnN0c3ouZW50cmllcy5lbnRyeVNpemUAdHJhay5tZGlhLm1pbmYuc3RibC5zdHoyLnNhbXBsZUNvdW50AHRyYWsubWRpYS5taW5mLnN0Ymwuc3R6Mi5lbnRyaWVzLmVudHJ5U2l6ZQB0cmFrLm1kaWEubWluZi5zdGJsLnN0ejIuZmllbGRTaXplAHRyYWsubWRpYS5taW5mLnN0Ymwuc3RzYy5lbnRyeUNvdW50AHRyYWsubWRpYS5taW5mLnN0Ymwuc3RzYy5lbnRyaWVzLmZpcnN0Q2h1bmsAdHJhay5tZGlhLm1pbmYuc3RibC5zdHNjLmVudHJpZXMuc2FtcGxlc1BlckNodW5rAHRyYWsubWRpYS5taW5mLnN0Ymwuc3RzYy5lbnRyaWVzLnNhbXBsZURlc2NyaXB0aW9uSW5kZXgAdHJhay5tZGlhLm1pbmYuc3RibC5zdHNjLmVudHJpZXMuZmlyc3RTYW1wbGUAdHJhay5tZGlhLm1pbmYuc3RibC5zdGNvLmVudHJ5Q291bnQAdHJhay5tZGlhLm1pbmYuc3RibC5zdGNvLmVudHJpZXMuY2h1bmtPZmZzZXQAdHJhay5tZGlhLm1pbmYuc3RibC5jbzY0LmVudHJ5Q291bnQAdHJhay5tZGlhLm1pbmYuc3RibC5jbzY0LmVudHJpZXMuY2h1bmtPZmZzZXQAdHJhay5tZGlhLm1pbmYuc3RibC5zdHRzLmVudHJ5Q291bnQAdHJhay5tZGlhLm1pbmYuc3RibC5zdHRzLmVudHJpZXMuc2FtcGxlQ291bnQAdHJhay5tZGlhLm1pbmYuc3RibC5zdHRzLmVudHJpZXMuc2FtcGxlRGVsdGEAdHJhay5tZGlhLm1pbmYuc3RibC5jdHRzLmVudHJ5Q291bnQAdHJhay5tZGlhLm1pbmYuc3RibC5jdHRzLmVudHJpZXMuc2FtcGxlQ291bnQAdHJhay5tZGlhLm1pbmYuc3RibC5jdHRzLmVudHJpZXMuc2FtcGxlT2Zmc2V0AHRyYWsubWRpYS5taW5mLnN0Ymwuc3Rzcy5lbnRyeUNvdW50AHRyYWsubWRpYS5taW5mLnN0Ymwuc3Rzcy5lbnRyaWVzLnNhbXBsZU51bWJlcgBpbnZhbGlkIHRyYWNrAC9ob21lL3VzZXIvbGlibXA0djIvc3JjL21wNHRyYWNrLmNwcABNUDRUcmFjawB0cmFrLm1kaWEubWluZi5zdGJsLnNkdHAAIiVzIjogV3JpdGVTYW1wbGU6IHRyYWNrICV1IGlkICV1IHNpemUgJXUgKDB4JXgpIABubyBzYW1wbGUgZGF0YQBXcml0ZVNhbXBsZQB0cmFrLm1kaWEubWluZi5zdGJsLnN0c2Quc2FtcgB0cmFrLm1kaWEubWluZi5zdGJsLnN0c2Quc2F3YgAiJXMiOiBkdXJhdGlvbiAlbGx1ACIlcyI6IFdyaXRlQ2h1bms6IHRyYWNrICV1IG9mZnNldCAweCVsbHggc2l6ZSAldSAoMHgleCkgbnVtU2FtcGxlcyAldQB0cmFrLm1kaWEubWluZi5zdGJsLnN0c2QuKi5lc2RzLmRlY0NvbmZpZ0Rlc2NyLmJ1ZmZlclNpemVEQgB0cmFrLm1kaWEubWluZi5zdGJsLnN0c2QuKi5lc2RzLmRlY0NvbmZpZ0Rlc2NyLm1heEJpdHJhdGUAdHJhay5tZGlhLm1pbmYuc3RibC5zdHNkLiouZXNkcy5kZWNDb25maWdEZXNjci5hdmdCaXRyYXRlAHRyYWsudWR0YS5uYW1lLnZhbHVlAHVkdGEubmFtZQB0cmFrLm1kaWEubWluZi5zdGJsAHNkdHAAZnR5cABhdmMxAGFzc2VydCBmYWlsdXJlOiAobV9kdXJhdGlvblBlckNodW5rKQBJc0NodW5rRnVsbAAlczogIiVzIjogbnVtQnl0ZXMgJXUgbm90IGRpdmlzaWJsZSBieSBieXRlc1BlclNhbXBsZSAldSBzYW1wbGVJZCAldQBVcGRhdGVTYW1wbGVTaXplcwB0cmFrLm1kaWEubWluZi5zdGJsLnN0c2QAc2FtcGxlIGlkIG91dCBvZiByYW5nZQBHZXRTYW1wbGVUaW1lcwBjdHRzAGN0dHMuZW50cnlDb3VudABhc3NlcnQgZmFpbHVyZTogKHBDdHRzQXRvbS0+RmluZFByb3BlcnR5KCAiY3R0cy5lbnRyeUNvdW50IiwgKE1QNFByb3BlcnR5KiopJm1fcEN0dHNDb3VudFByb3BlcnR5KSkAVXBkYXRlUmVuZGVyaW5nT2Zmc2V0cwBjdHRzLmVudHJpZXMuc2FtcGxlQ291bnQAYXNzZXJ0IGZhaWx1cmU6IChwQ3R0c0F0b20tPkZpbmRQcm9wZXJ0eSggImN0dHMuZW50cmllcy5zYW1wbGVDb3VudCIsIChNUDRQcm9wZXJ0eSoqKSZtX3BDdHRzU2FtcGxlQ291bnRQcm9wZXJ0eSkpAGN0dHMuZW50cmllcy5zYW1wbGVPZmZzZXQAYXNzZXJ0IGZhaWx1cmU6IChwQ3R0c0F0b20tPkZpbmRQcm9wZXJ0eSggImN0dHMuZW50cmllcy5zYW1wbGVPZmZzZXQiLCAoTVA0UHJvcGVydHkqKikmbV9wQ3R0c1NhbXBsZU9mZnNldFByb3BlcnR5KSkAc3RzcwBzdHNzLmVudHJ5Q291bnQAYXNzZXJ0IGZhaWx1cmU6IChwU3Rzc0F0b20tPkZpbmRQcm9wZXJ0eSggInN0c3MuZW50cnlDb3VudCIsIChNUDRQcm9wZXJ0eSoqKSZtX3BTdHNzQ291bnRQcm9wZXJ0eSkpAFVwZGF0ZVN5bmNTYW1wbGVzAHN0c3MuZW50cmllcy5zYW1wbGVOdW1iZXIAYXNzZXJ0IGZhaWx1cmU6IChwU3Rzc0F0b20tPkZpbmRQcm9wZXJ0eSggInN0c3MuZW50cmllcy5zYW1wbGVOdW1iZXIiLCAoTVA0UHJvcGVydHkqKikmbV9wU3Rzc1NhbXBsZVByb3BlcnR5KSkAYXNzZXJ0IGZhaWx1cmU6IChwUGFyZW50QXRvbSkAQWRkQXRvbQB0cmFrLmVkdHMuZWxzdABlbHN0LmVudHJ5Q291bnQAZWxzdC5lbnRyaWVzLm1lZGlhVGltZQBlbHN0LmVudHJpZXMuc2VnbWVudER1cmF0aW9uAGVsc3QuZW50cmllcy5tZWRpYVJhdGUAZWxzdC5lbnRyaWVzLnJlc2VydmVkAHR3b3MAc293dABONW1wNHYyNGltcGw4TVA0VHJhY2tFAAAAAOz+AACWtQAAWy4AYXNzZXJ0IGZhaWx1cmU6IChwSW5kZXgpAC9ob21lL3VzZXIvbGlibXA0djIvc3JjL21wNHV0aWwuY3BwAE1QNE5hbWVGaXJzdEluZGV4ACV1AHZpZGUAdmlkZW8AbXA0dgBhdmMxAHMyNjMAZW5jdgBzb3VuAHNvdW5kAGF1ZGlvAGVuY2EAc2FtcgBzYXdiAG1wNGEAc2RzbQBzY2VuZQBiaWZzAG9kc20Ab2QAY250bABBdHRlbXB0IHRvIG5vcm1hbGl6ZSAlcyBkaWQgbm90IG1hdGNoAAAAAADIuQAAigAAADkCAACMAAAAOgIAAI4AAACPAAAAkAAAAGNsYXNzaWZpY2F0aW9uRW50aXR5AGNsYXNzaWZpY2F0aW9uVGFibGUAY29udGVudENsYXNzaWZpY2F0aW9uRGF0YQAAAAAAAPi5AACKAAAAOwIAAIwAAACNAAAAjgAAAI8AAAA8AgAAbGFuZ3VhZ2VDb2RlAGlzVVRGOFN0cmluZwByZXNlcnZlZABrZXl3b3JkQ291bnQAa2V5d29yZHMAc3RyaW5nAGFzc2VydCBmYWlsdXJlOiAocFByb3BlcnR5KQAvaG9tZS91c2VyL2xpYm1wNHYyL3NyYy9vY2lkZXNjcmlwdG9ycy5jcHAATXV0YXRlAAAAAAAAACi6AACKAAAAPQIAAIwAAAA+AgAAjgAAAI8AAACQAAAAcmF0aW5nRW50aXR5AHJhdGluZ0NyaXRlcmlhAHJhdGluZ0luZm8AAAAAAABouwAAigAAAD8CAACMAAAAjQAAAI4AAACPAAAAkAAAAAAAAABcugAAigAAAEACAACMAAAAjQAAAI4AAACPAAAAQQIAAGV2ZW50TmFtZQBldmVudFRleHQAAAAAAJS6AACKAAAAQgIAAIwAAACNAAAAjgAAAI8AAABDAgAAaXRlbUNvdW50AGl0ZW1zAGl0ZW1EZXNjcmlwdGlvbgBpdGVtVGV4dABub25JdGVtVGV4dAAAAAAAAAAAmLsAAIoAAABEAgAAjAAAAI0AAACOAAAAjwAAAJAAAABjcmVhdG9yQ291bnQAY3JlYXRvcnMAbmFtZQAAAAAAAMy7AACKAAAARQIAAIwAAACNAAAAjgAAAI8AAACQAAAAY29udGVudENyZWF0aW9uRGF0ZQAAAAAAALwAAIoAAABGAgAAjAAAAI0AAACOAAAAjwAAAJAAAABwYXJhbWV0ZXJDb3VudABwYXJhbWV0ZXJzAGlkAHZhbHVlAAAAAAAANLsAAIoAAABHAgAAjAAAAEgCAACOAAAAjwAAAJAAAABkYXRhAE41bXA0djI0aW1wbDI1TVA0Q29udGVudENsYXNzRGVzY3JpcHRvckUAAAAU/wAAnbkAAGhrAABONW1wNHYyNGltcGwyME1QNEtleXdvcmREZXNjcmlwdG9yRQAU/wAA1LkAAGhrAABONW1wNHYyNGltcGwxOU1QNFJhdGluZ0Rlc2NyaXB0b3JFAAAU/wAABLoAAGhrAABONW1wNHYyNGltcGwyMk1QNFNob3J0VGV4dERlc2NyaXB0b3JFAAAAFP8AADS6AABoawAATjVtcDR2MjRpbXBsMjVNUDRFeHBhbmRlZFRleHREZXNjcmlwdG9yRQAAAAAU/wAAaLoAAGhrAAAAAAAAALsAAGoAAABJAgAAbAAAAG0AAABuAAAAbwAAAHAAAABxAAAAcgAAAHMAAABKAgAASwIAAE41bXA0djI0aW1wbDIzTVA0Q3JlYXRvclRhYmxlUHJvcGVydHlFAAAU/wAA2LoAAFSpAABONW1wNHYyNGltcGwyM01QNFVua25vd25PQ0lEZXNjcmlwdG9yRQAAFP8AAAy7AABoawAATjVtcDR2MjRpbXBsMjFNUDRMYW5ndWFnZURlc2NyaXB0b3JFAAAAABT/AABAuwAAaGsAAE41bXA0djI0aW1wbDIwTVA0Q3JlYXRvckRlc2NyaXB0b3JFABT/AAB0uwAAaGsAAE41bXA0djI0aW1wbDIxTVA0Q3JlYXRpb25EZXNjcmlwdG9yRQAAAAAU/wAApLsAAGhrAABONW1wNHYyNGltcGwyNE1QNFNtcHRlQ2FtZXJhRGVzY3JpcHRvckUAFP8AANi7AABoawAAAAAAAHy9AACKAAAATQIAAIwAAACNAAAAjgAAAI8AAACQAAAAcHJlZGVmaW5lZABxdWFsaWZpZXJzAG1heERlbGF5AHByZWZNYXhEZWxheQBsb3NzUHJvYgBtYXhHYXBMb3NzAG1heEFVU2l6ZQBhdmdBVVNpemUAbWF4QVVSYXRlAAAAAAAAAEy9AACKAAAATgIAAIwAAABPAgAAjgAAAI8AAACQAAAAZGF0YQAAAAAAAAAAGL0AANoBAABQAgAA3AEAAN0BAADeAQAA3wEAAOABAADhAQAA4gEAAOMBAABRAgAATjVtcDR2MjRpbXBsMjNNUDRRb3NRdWFsaWZpZXJQcm9wZXJ0eUUAABT/AADwvAAAiKkAAE41bXA0djI0aW1wbDIyTVA0VW5rbm93blFvc1F1YWxpZmllckUAAAAU/wAAJL0AAGhrAABONW1wNHYyNGltcGwyME1QNFFvc0Rlc2NyaXB0b3JCYXNlRQAU/wAAWL0AAGhrAAAAAAAAvL0AAFICAABTAgAAVAIAAE41bXA0djI0aW1wbDE1TVA0UnRwSGludFRyYWNrRQAAFP8AAJy9AACwtQAAAAAAABy+AABbAgAAXAIAAF0CAABeAgAAXwIAAGACAABhAgAAYgIAAE41bXA0djI4cGxhdGZvcm0yaW8yMFN0YW5kYXJkRmlsZVByb3ZpZGVyRQAAFP8AAPC9AABswAAAcAAAAAAAAABIvwAAYwIAAGQCAABoAAAA+P///0i/AABlAgAAZgIAAJD///+Q////SL8AAGcCAABoAgAANL4AAJi+AADUvgAA6L4AAPy+AAAQvwAAwL4AAKy+AABcvgAASL4AAHAAAAAAAAAAdNAAAGkCAABqAgAAaAAAAPj///900AAAawIAAGwCAACQ////kP///3TQAABtAgAAbgIAAHAAAAAAAAAAlM8AAKgBAACpAQAAkP///5D///+UzwAAqgEAAKsBAABoAAAAAAAAANzPAABGAAAARwAAAJj///+Y////3M8AAEgAAABJAAAATlN0M19fMjEzYmFzaWNfZnN0cmVhbUljTlNfMTFjaGFyX3RyYWl0c0ljRUVFRQAAFP8AABi/AAB00AAAAAAAAMS/AABvAgAAcAIAAHECAAByAgAAcwIAAHQCAABZAgAAUQAAAFIAAAB1AgAAVAAAAHYCAABWAAAAdwIAAE5TdDNfXzIxM2Jhc2ljX2ZpbGVidWZJY05TXzExY2hhcl90cmFpdHNJY0VFRUUAABT/AACUvwAAXM8AAHJiAHIrYgB3K2IAAAAAAAB0wAAAeQIAAHoCAAB7AgAAfAIAAH0CAAB+AgAAfwIAAIACAAAAAAAArMAAAIECAACCAgAAgwIAAIQCAACFAgAAhgIAAIcCAACIAgAATjVtcDR2MjhwbGF0Zm9ybTJpbzRGaWxlRQBONW1wNHYyOHBsYXRmb3JtMmlvMTJGaWxlUHJvdmlkZXJFAAAAAOz+AABGwAAAFP8AACzAAABswAAATjVtcDR2MjhwbGF0Zm9ybTJpbzE4Q3VzdG9tRmlsZVByb3ZpZGVyRQAAAAAU/wAAgMAAAGzAAEHAgQMLVxkSRDsCPyxHFD0zMAobBkZLRTcPSQ6OFwNAHTxpKzYfSi0cASAlKSEIDBUWIi4QOD4LNDEYZHR1di9BCX85ESNDMkKJiosFBCYoJw0qHjWMBxpIkxOUlQBBoIIDC4oOSWxsZWdhbCBieXRlIHNlcXVlbmNlAERvbWFpbiBlcnJvcgBSZXN1bHQgbm90IHJlcHJlc2VudGFibGUATm90IGEgdHR5AFBlcm1pc3Npb24gZGVuaWVkAE9wZXJhdGlvbiBub3QgcGVybWl0dGVkAE5vIHN1Y2ggZmlsZSBvciBkaXJlY3RvcnkATm8gc3VjaCBwcm9jZXNzAEZpbGUgZXhpc3RzAFZhbHVlIHRvbyBsYXJnZSBmb3IgZGF0YSB0eXBlAE5vIHNwYWNlIGxlZnQgb24gZGV2aWNlAE91dCBvZiBtZW1vcnkAUmVzb3VyY2UgYnVzeQBJbnRlcnJ1cHRlZCBzeXN0ZW0gY2FsbABSZXNvdXJjZSB0ZW1wb3JhcmlseSB1bmF2YWlsYWJsZQBJbnZhbGlkIHNlZWsAQ3Jvc3MtZGV2aWNlIGxpbmsAUmVhZC1vbmx5IGZpbGUgc3lzdGVtAERpcmVjdG9yeSBub3QgZW1wdHkAQ29ubmVjdGlvbiByZXNldCBieSBwZWVyAE9wZXJhdGlvbiB0aW1lZCBvdXQAQ29ubmVjdGlvbiByZWZ1c2VkAEhvc3QgaXMgZG93bgBIb3N0IGlzIHVucmVhY2hhYmxlAEFkZHJlc3MgaW4gdXNlAEJyb2tlbiBwaXBlAEkvTyBlcnJvcgBObyBzdWNoIGRldmljZSBvciBhZGRyZXNzAEJsb2NrIGRldmljZSByZXF1aXJlZABObyBzdWNoIGRldmljZQBOb3QgYSBkaXJlY3RvcnkASXMgYSBkaXJlY3RvcnkAVGV4dCBmaWxlIGJ1c3kARXhlYyBmb3JtYXQgZXJyb3IASW52YWxpZCBhcmd1bWVudABBcmd1bWVudCBsaXN0IHRvbyBsb25nAFN5bWJvbGljIGxpbmsgbG9vcABGaWxlbmFtZSB0b28gbG9uZwBUb28gbWFueSBvcGVuIGZpbGVzIGluIHN5c3RlbQBObyBmaWxlIGRlc2NyaXB0b3JzIGF2YWlsYWJsZQBCYWQgZmlsZSBkZXNjcmlwdG9yAE5vIGNoaWxkIHByb2Nlc3MAQmFkIGFkZHJlc3MARmlsZSB0b28gbGFyZ2UAVG9vIG1hbnkgbGlua3MATm8gbG9ja3MgYXZhaWxhYmxlAFJlc291cmNlIGRlYWRsb2NrIHdvdWxkIG9jY3VyAFN0YXRlIG5vdCByZWNvdmVyYWJsZQBQcmV2aW91cyBvd25lciBkaWVkAE9wZXJhdGlvbiBjYW5jZWxlZABGdW5jdGlvbiBub3QgaW1wbGVtZW50ZWQATm8gbWVzc2FnZSBvZiBkZXNpcmVkIHR5cGUASWRlbnRpZmllciByZW1vdmVkAERldmljZSBub3QgYSBzdHJlYW0ATm8gZGF0YSBhdmFpbGFibGUARGV2aWNlIHRpbWVvdXQAT3V0IG9mIHN0cmVhbXMgcmVzb3VyY2VzAExpbmsgaGFzIGJlZW4gc2V2ZXJlZABQcm90b2NvbCBlcnJvcgBCYWQgbWVzc2FnZQBGaWxlIGRlc2NyaXB0b3IgaW4gYmFkIHN0YXRlAE5vdCBhIHNvY2tldABEZXN0aW5hdGlvbiBhZGRyZXNzIHJlcXVpcmVkAE1lc3NhZ2UgdG9vIGxhcmdlAFByb3RvY29sIHdyb25nIHR5cGUgZm9yIHNvY2tldABQcm90b2NvbCBub3QgYXZhaWxhYmxlAFByb3RvY29sIG5vdCBzdXBwb3J0ZWQAU29ja2V0IHR5cGUgbm90IHN1cHBvcnRlZABOb3Qgc3VwcG9ydGVkAFByb3RvY29sIGZhbWlseSBub3Qgc3VwcG9ydGVkAEFkZHJlc3MgZmFtaWx5IG5vdCBzdXBwb3J0ZWQgYnkgcHJvdG9jb2wAQWRkcmVzcyBub3QgYXZhaWxhYmxlAE5ldHdvcmsgaXMgZG93bgBOZXR3b3JrIHVucmVhY2hhYmxlAENvbm5lY3Rpb24gcmVzZXQgYnkgbmV0d29yawBDb25uZWN0aW9uIGFib3J0ZWQATm8gYnVmZmVyIHNwYWNlIGF2YWlsYWJsZQBTb2NrZXQgaXMgY29ubmVjdGVkAFNvY2tldCBub3QgY29ubmVjdGVkAENhbm5vdCBzZW5kIGFmdGVyIHNvY2tldCBzaHV0ZG93bgBPcGVyYXRpb24gYWxyZWFkeSBpbiBwcm9ncmVzcwBPcGVyYXRpb24gaW4gcHJvZ3Jlc3MAU3RhbGUgZmlsZSBoYW5kbGUAUmVtb3RlIEkvTyBlcnJvcgBRdW90YSBleGNlZWRlZABObyBtZWRpdW0gZm91bmQAV3JvbmcgbWVkaXVtIHR5cGUATm8gZXJyb3IgaW5mb3JtYXRpb24AQdSQAwsCiwIAQfuQAwsF//////8AQcCRAwthcndhAHJ3YQAtKyAgIDBYMHgAKG51bGwpAAAAAAAAAAARAAoAERERAAAAAAUAAAAAAAAJAAAAAAsAAAAAAAAAABEADwoREREDCgcAARMJCwsAAAkGCwAACwAGEQAAABEREQBBsZIDCyELAAAAAAAAAAARAAoKERERAAoAAAIACQsAAAAJAAsAAAsAQeuSAwsBDABB95IDCxUMAAAAAAwAAAAACQwAAAAAAAwAAAwAQaWTAwsBDgBBsZMDCxUNAAAABA0AAAAACQ4AAAAAAA4AAA4AQd+TAwsBEABB65MDCx4PAAAAAA8AAAAACRAAAAAAABAAABAAABIAAAASEhIAQaKUAwsOEgAAABISEgAAAAAAAAkAQdOUAwsBCwBB35QDCxUKAAAAAAoAAAAACQsAAAAAAAsAAAsAQY2VAwsBDABBmZUDC0sMAAAAAAwAAAAACQwAAAAAAAwAAAwAADAxMjM0NTY3ODlBQkNERUYtMFgrMFggMFgtMHgrMHggMHgAaW5mAElORgBuYW4ATkFOAC4AQfCVAwvzC/////////////////////////////////////////////////////////////////8AAQIDBAUGBwgJ/////////woLDA0ODxAREhMUFRYXGBkaGxwdHh8gISIj////////CgsMDQ4PEBESExQVFhcYGRobHB0eHyAhIiP/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////AAECBAcDBgUAAAAAAAAAAgAAwAMAAMAEAADABQAAwAYAAMAHAADACAAAwAkAAMAKAADACwAAwAwAAMANAADADgAAwA8AAMAQAADAEQAAwBIAAMATAADAFAAAwBUAAMAWAADAFwAAwBgAAMAZAADAGgAAwBsAAMAcAADAHQAAwB4AAMAfAADAAAAAswEAAMMCAADDAwAAwwQAAMMFAADDBgAAwwcAAMMIAADDCQAAwwoAAMMLAADDDAAAww0AANMOAADDDwAAwwAADLsBAAzDAgAMwwMADMMEAAzTaW5maW5pdHkAbmFuAAAAAAAAAADRdJ4AV529KoBwUg///z4nCgAAAGQAAADoAwAAECcAAKCGAQBAQg8AgJaYAADh9QUYAAAANQAAAHEAAABr////zvv//5K///+QCAEAAAAAAFzPAACuAgAArwIAAEwAAABNAAAAsAIAALECAABQAAAAUQAAAFIAAACyAgAAVAAAALMCAABWAAAAtAIAAAgAAAAAAAAAlM8AAKgBAACpAQAA+P////j///+UzwAAqgEAAKsBAAB4zQAAjM0AAAQAAAAAAAAA3M8AAEYAAABHAAAA/P////z////czwAASAAAAEkAAACozQAAvM0AAAwAAAAAAAAAdNAAAGkCAABqAgAABAAAAPj///900AAAawIAAGwCAAD0////9P///3TQAABtAgAAbgIAANjNAAAA0AAAFNAAACjQAAA80AAAAM4AAOzNAABpb3N0cmVhbQB1bnNwZWNpZmllZCBpb3N0cmVhbV9jYXRlZ29yeSBlcnJvcgAAAAAAAAAAtNAAALUCAAC2AgAAtwIAALgCAAC5AgAAugIAALsCAAAAAAAA5M4AAK0CAAC8AgAAvQIAAAAAAADAzgAAvgIAAL8CAABpb3NfYmFzZTo6Y2xlYXIATlN0M19fMjhpb3NfYmFzZUUAAADs/gAArM4AAE5TdDNfXzI4aW9zX2Jhc2U3ZmFpbHVyZUUAAAAU/wAAyM4AAKj5AABOU3QzX18yOWJhc2ljX2lvc0ljTlNfMTFjaGFyX3RyYWl0c0ljRUVFRQAAABT/AADwzgAAwM4AAE5TdDNfXzIxNWJhc2ljX3N0cmVhbWJ1ZkljTlNfMTFjaGFyX3RyYWl0c0ljRUVFRQAAAADs/gAAKM8AAE5TdDNfXzIxM2Jhc2ljX2lzdHJlYW1JY05TXzExY2hhcl90cmFpdHNJY0VFRUUAAHD/AABkzwAAAAAAAAEAAAAczwAAA/T//05TdDNfXzIxM2Jhc2ljX29zdHJlYW1JY05TXzExY2hhcl90cmFpdHNJY0VFRUUAAHD/AACszwAAAAAAAAEAAAAczwAAA/T//wwAAAAAAAAAlM8AAKgBAACpAQAA9P////T///+UzwAAqgEAAKsBAAAEAAAAAAAAANzPAABGAAAARwAAAPz////8////3M8AAEgAAABJAAAATlN0M19fMjE0YmFzaWNfaW9zdHJlYW1JY05TXzExY2hhcl90cmFpdHNJY0VFRUUAcP8AAETQAAADAAAAAgAAAJTPAAACAAAA3M8AAAIIAABOU3QzX18yMTlfX2lvc3RyZWFtX2NhdGVnb3J5RQAAABT/AACU0AAA8PkAAN4SBJUAAAAA////////////////wNAAABQAAABDLlVURi04AEGIogMLAtTQAEGgogMLBkxDX0FMTABBsKIDC25MQ19DVFlQRQAAAABMQ19OVU1FUklDAABMQ19USU1FAAAAAABMQ19DT0xMQVRFAABMQ19NT05FVEFSWQBMQ19NRVNTQUdFUwBMQU5HAEMuVVRGLTgAUE9TSVgATVVTTF9MT0NQQVRIAAAAAACg0gBBoKUDC/8BAgACAAIAAgACAAIAAgACAAIAAyACIAIgAiACIAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAFgBMAEwATABMAEwATABMAEwATABMAEwATABMAEwATACNgI2AjYCNgI2AjYCNgI2AjYCNgEwATABMAEwATABMAEwAjVCNUI1QjVCNUI1QjFCMUIxQjFCMUIxQjFCMUIxQjFCMUIxQjFCMUIxQjFCMUIxQjFCMUEwATABMAEwATABMAI1gjWCNYI1gjWCNYIxgjGCMYIxgjGCMYIxgjGCMYIxgjGCMYIxgjGCMYIxgjGCMYIxgjGBMAEwATABMACAEGgqQMLArDWAEG0rQML+QMBAAAAAgAAAAMAAAAEAAAABQAAAAYAAAAHAAAACAAAAAkAAAAKAAAACwAAAAwAAAANAAAADgAAAA8AAAAQAAAAEQAAABIAAAATAAAAFAAAABUAAAAWAAAAFwAAABgAAAAZAAAAGgAAABsAAAAcAAAAHQAAAB4AAAAfAAAAIAAAACEAAAAiAAAAIwAAACQAAAAlAAAAJgAAACcAAAAoAAAAKQAAACoAAAArAAAALAAAAC0AAAAuAAAALwAAADAAAAAxAAAAMgAAADMAAAA0AAAANQAAADYAAAA3AAAAOAAAADkAAAA6AAAAOwAAADwAAAA9AAAAPgAAAD8AAABAAAAAQQAAAEIAAABDAAAARAAAAEUAAABGAAAARwAAAEgAAABJAAAASgAAAEsAAABMAAAATQAAAE4AAABPAAAAUAAAAFEAAABSAAAAUwAAAFQAAABVAAAAVgAAAFcAAABYAAAAWQAAAFoAAABbAAAAXAAAAF0AAABeAAAAXwAAAGAAAABBAAAAQgAAAEMAAABEAAAARQAAAEYAAABHAAAASAAAAEkAAABKAAAASwAAAEwAAABNAAAATgAAAE8AAABQAAAAUQAAAFIAAABTAAAAVAAAAFUAAABWAAAAVwAAAFgAAABZAAAAWgAAAHsAAAB8AAAAfQAAAH4AAAB/AEGwtQMLAsDcAEHEuQML+QMBAAAAAgAAAAMAAAAEAAAABQAAAAYAAAAHAAAACAAAAAkAAAAKAAAACwAAAAwAAAANAAAADgAAAA8AAAAQAAAAEQAAABIAAAATAAAAFAAAABUAAAAWAAAAFwAAABgAAAAZAAAAGgAAABsAAAAcAAAAHQAAAB4AAAAfAAAAIAAAACEAAAAiAAAAIwAAACQAAAAlAAAAJgAAACcAAAAoAAAAKQAAACoAAAArAAAALAAAAC0AAAAuAAAALwAAADAAAAAxAAAAMgAAADMAAAA0AAAANQAAADYAAAA3AAAAOAAAADkAAAA6AAAAOwAAADwAAAA9AAAAPgAAAD8AAABAAAAAYQAAAGIAAABjAAAAZAAAAGUAAABmAAAAZwAAAGgAAABpAAAAagAAAGsAAABsAAAAbQAAAG4AAABvAAAAcAAAAHEAAAByAAAAcwAAAHQAAAB1AAAAdgAAAHcAAAB4AAAAeQAAAHoAAABbAAAAXAAAAF0AAABeAAAAXwAAAGAAAABhAAAAYgAAAGMAAABkAAAAZQAAAGYAAABnAAAAaAAAAGkAAABqAAAAawAAAGwAAABtAAAAbgAAAG8AAABwAAAAcQAAAHIAAABzAAAAdAAAAHUAAAB2AAAAdwAAAHgAAAB5AAAAegAAAHsAAAB8AAAAfQAAAH4AAAB/AEHAwQML0QEwMTIzNDU2Nzg5YWJjZGVmQUJDREVGeFgrLXBQaUluTgAlcABsAGxsAABMACUAAAAAACVwAAAAACVJOiVNOiVTICVwJUg6JU0AAAAAAAAAACUAAABtAAAALwAAACUAAABkAAAALwAAACUAAAB5AAAAJQAAAFkAAAAtAAAAJQAAAG0AAAAtAAAAJQAAAGQAAAAlAAAASQAAADoAAAAlAAAATQAAADoAAAAlAAAAUwAAACAAAAAlAAAAcAAAAAAAAAAlAAAASAAAADoAAAAlAAAATQBBoMMDC8YPJQAAAEgAAAA6AAAAJQAAAE0AAAA6AAAAJQAAAFMAAAAlTGYAbW9uZXlfZ2V0IGVycm9yADAxMjM0NTY3ODkAJS4wTGYAQwAAAAAAAHDnAACLAwAAjAMAAI0DAAAAAAAA0OcAAI4DAACPAwAAjQMAAJADAACRAwAAkgMAAJMDAACUAwAAlQMAAJYDAACXAwAAAAAAADjnAACYAwAAmQMAAI0DAACaAwAAmwMAAJwDAACdAwAAngMAAJ8DAACgAwAAAAAAAAjoAAChAwAAogMAAI0DAACjAwAApAMAAKUDAACmAwAApwMAAAAAAAAs6AAAqAMAAKkDAACNAwAAqgMAAKsDAACsAwAArQMAAK4DAAB0cnVlAAAAAHQAAAByAAAAdQAAAGUAAAAAAAAAZmFsc2UAAABmAAAAYQAAAGwAAABzAAAAZQAAAAAAAAAlbS8lZC8leQAAAAAlAAAAbQAAAC8AAAAlAAAAZAAAAC8AAAAlAAAAeQAAAAAAAAAlSDolTTolUwAAAAAlAAAASAAAADoAAAAlAAAATQAAADoAAAAlAAAAUwAAAAAAAAAlYSAlYiAlZCAlSDolTTolUyAlWQAAAAAlAAAAYQAAACAAAAAlAAAAYgAAACAAAAAlAAAAZAAAACAAAAAlAAAASAAAADoAAAAlAAAATQAAADoAAAAlAAAAUwAAACAAAAAlAAAAWQAAAAAAAAAlSTolTTolUyAlcAAlAAAASQAAADoAAAAlAAAATQAAADoAAAAlAAAAUwAAACAAAAAlAAAAcAAAAAAAAABsb2NhbGUgbm90IHN1cHBvcnRlZAAAAAAAAAAAOOQAAK8DAACwAwAAjQMAAE5TdDNfXzI2bG9jYWxlNWZhY2V0RQAAABT/AAAg5AAAZPkAAAAAAAC45AAArwMAALEDAACNAwAAsgMAALMDAAC0AwAAtQMAALYDAAC3AwAAuAMAALkDAAC6AwAAuwMAALwDAAC9AwAATlN0M19fMjVjdHlwZUl3RUUATlN0M19fMjEwY3R5cGVfYmFzZUUAAOz+AACa5AAAcP8AAIjkAAAAAAAAAgAAADjkAAACAAAAsOQAAAIAAAAAAAAATOUAAK8DAAC+AwAAjQMAAL8DAADAAwAAwQMAAMIDAADDAwAAxAMAAMUDAABOU3QzX18yN2NvZGVjdnRJY2MxMV9fbWJzdGF0ZV90RUUATlN0M19fMjEyY29kZWN2dF9iYXNlRQAAAADs/gAAKuUAAHD/AAAI5QAAAAAAAAIAAAA45AAAAgAAAETlAAACAAAAAAAAAMDlAACvAwAAxgMAAI0DAADHAwAAyAMAAMkDAADKAwAAywMAAMwDAADNAwAATlN0M19fMjdjb2RlY3Z0SURzYzExX19tYnN0YXRlX3RFRQAAcP8AAJzlAAAAAAAAAgAAADjkAAACAAAAROUAAAIAAAAAAAAANOYAAK8DAADOAwAAjQMAAM8DAADQAwAA0QMAANIDAADTAwAA1AMAANUDAABOU3QzX18yN2NvZGVjdnRJRGljMTFfX21ic3RhdGVfdEVFAABw/wAAEOYAAAAAAAACAAAAOOQAAAIAAABE5QAAAgAAAAAAAACo5gAArwMAANYDAACNAwAAzwMAANADAADRAwAA0gMAANMDAADUAwAA1QMAAE5TdDNfXzIxNl9fbmFycm93X3RvX3V0ZjhJTG0zMkVFRQAAABT/AACE5gAANOYAAAAAAAAI5wAArwMAANcDAACNAwAAzwMAANADAADRAwAA0gMAANMDAADUAwAA1QMAAE5TdDNfXzIxN19fd2lkZW5fZnJvbV91dGY4SUxtMzJFRUUAABT/AADk5gAANOYAAE5TdDNfXzI3Y29kZWN2dEl3YzExX19tYnN0YXRlX3RFRQAAAHD/AAAU5wAAAAAAAAIAAAA45AAAAgAAAETlAAACAAAATlN0M19fMjZsb2NhbGU1X19pbXBFAAAAFP8AAFjnAAA45AAATlN0M19fMjdjb2xsYXRlSWNFRQAU/wAAfOcAADjkAABOU3QzX18yN2NvbGxhdGVJd0VFABT/AACc5wAAOOQAAE5TdDNfXzI1Y3R5cGVJY0VFAAAAcP8AALznAAAAAAAAAgAAADjkAAACAAAAsOQAAAIAAABOU3QzX18yOG51bXB1bmN0SWNFRQAAAAAU/wAA8OcAADjkAABOU3QzX18yOG51bXB1bmN0SXdFRQAAAAAU/wAAFOgAADjkAAAAAAAAkOcAANgDAADZAwAAjQMAANoDAADbAwAA3AMAAAAAAACw5wAA3QMAAN4DAACNAwAA3wMAAOADAADhAwAAAAAAAEzpAACvAwAA4gMAAI0DAADjAwAA5AMAAOUDAADmAwAA5wMAAOgDAADpAwAA6gMAAOsDAADsAwAA7QMAAE5TdDNfXzI3bnVtX2dldEljTlNfMTlpc3RyZWFtYnVmX2l0ZXJhdG9ySWNOU18xMWNoYXJfdHJhaXRzSWNFRUVFRUUATlN0M19fMjlfX251bV9nZXRJY0VFAE5TdDNfXzIxNF9fbnVtX2dldF9iYXNlRQAA7P4AABLpAABw/wAA/OgAAAAAAAABAAAALOkAAAAAAABw/wAAuOgAAAAAAAACAAAAOOQAAAIAAAA06QBB8NIDC8oBIOoAAK8DAADuAwAAjQMAAO8DAADwAwAA8QMAAPIDAADzAwAA9AMAAPUDAAD2AwAA9wMAAPgDAAD5AwAATlN0M19fMjdudW1fZ2V0SXdOU18xOWlzdHJlYW1idWZfaXRlcmF0b3JJd05TXzExY2hhcl90cmFpdHNJd0VFRUVFRQBOU3QzX18yOV9fbnVtX2dldEl3RUUAAABw/wAA8OkAAAAAAAABAAAALOkAAAAAAABw/wAArOkAAAAAAAACAAAAOOQAAAIAAAAI6gBBxNQDC94BCOsAAK8DAAD6AwAAjQMAAPsDAAD8AwAA/QMAAP4DAAD/AwAAAAQAAAEEAAACBAAATlN0M19fMjdudW1fcHV0SWNOU18xOW9zdHJlYW1idWZfaXRlcmF0b3JJY05TXzExY2hhcl90cmFpdHNJY0VFRUVFRQBOU3QzX18yOV9fbnVtX3B1dEljRUUATlN0M19fMjE0X19udW1fcHV0X2Jhc2VFAADs/gAAzuoAAHD/AAC46gAAAAAAAAEAAADo6gAAAAAAAHD/AAB06gAAAAAAAAIAAAA45AAAAgAAAPDqAEGs1gMLvgHQ6wAArwMAAAMEAACNAwAABAQAAAUEAAAGBAAABwQAAAgEAAAJBAAACgQAAAsEAABOU3QzX18yN251bV9wdXRJd05TXzE5b3N0cmVhbWJ1Zl9pdGVyYXRvckl3TlNfMTFjaGFyX3RyYWl0c0l3RUVFRUVFAE5TdDNfXzI5X19udW1fcHV0SXdFRQAAAHD/AACg6wAAAAAAAAEAAADo6gAAAAAAAHD/AABc6wAAAAAAAAIAAAA45AAAAgAAALjrAEH01wMLmgvQ7AAADAQAAA0EAACNAwAADgQAAA8EAAAQBAAAEQQAABIEAAATBAAAFAQAAPj////Q7AAAFQQAABYEAAAXBAAAGAQAABkEAAAaBAAAGwQAAE5TdDNfXzI4dGltZV9nZXRJY05TXzE5aXN0cmVhbWJ1Zl9pdGVyYXRvckljTlNfMTFjaGFyX3RyYWl0c0ljRUVFRUVFAE5TdDNfXzI5dGltZV9iYXNlRQDs/gAAiewAAE5TdDNfXzIyMF9fdGltZV9nZXRfY19zdG9yYWdlSWNFRQAAAOz+AACk7AAAcP8AAETsAAAAAAAAAwAAADjkAAACAAAAnOwAAAIAAADI7AAAAAgAAAAAAAC87QAAHAQAAB0EAACNAwAAHgQAAB8EAAAgBAAAIQQAACIEAAAjBAAAJAQAAPj///+87QAAJQQAACYEAAAnBAAAKAQAACkEAAAqBAAAKwQAAE5TdDNfXzI4dGltZV9nZXRJd05TXzE5aXN0cmVhbWJ1Zl9pdGVyYXRvckl3TlNfMTFjaGFyX3RyYWl0c0l3RUVFRUVFAE5TdDNfXzIyMF9fdGltZV9nZXRfY19zdG9yYWdlSXdFRQAA7P4AAJHtAABw/wAATO0AAAAAAAADAAAAOOQAAAIAAACc7AAAAgAAALTtAAAACAAAAAAAAGDuAAAsBAAALQQAAI0DAAAuBAAATlN0M19fMjh0aW1lX3B1dEljTlNfMTlvc3RyZWFtYnVmX2l0ZXJhdG9ySWNOU18xMWNoYXJfdHJhaXRzSWNFRUVFRUUATlN0M19fMjEwX190aW1lX3B1dEUAAADs/gAAQe4AAHD/AAD87QAAAAAAAAIAAAA45AAAAgAAAFjuAAAACAAAAAAAAODuAAAvBAAAMAQAAI0DAAAxBAAATlN0M19fMjh0aW1lX3B1dEl3TlNfMTlvc3RyZWFtYnVmX2l0ZXJhdG9ySXdOU18xMWNoYXJfdHJhaXRzSXdFRUVFRUUAAAAAcP8AAJjuAAAAAAAAAgAAADjkAAACAAAAWO4AAAAIAAAAAAAAdO8AAK8DAAAyBAAAjQMAADMEAAA0BAAANQQAADYEAAA3BAAAOAQAADkEAAA6BAAAOwQAAE5TdDNfXzIxMG1vbmV5cHVuY3RJY0xiMEVFRQBOU3QzX18yMTBtb25leV9iYXNlRQAAAADs/gAAVO8AAHD/AAA47wAAAAAAAAIAAAA45AAAAgAAAGzvAAACAAAAAAAAAOjvAACvAwAAPAQAAI0DAAA9BAAAPgQAAD8EAABABAAAQQQAAEIEAABDBAAARAQAAEUEAABOU3QzX18yMTBtb25leXB1bmN0SWNMYjFFRUUAcP8AAMzvAAAAAAAAAgAAADjkAAACAAAAbO8AAAIAAAAAAAAAXPAAAK8DAABGBAAAjQMAAEcEAABIBAAASQQAAEoEAABLBAAATAQAAE0EAABOBAAATwQAAE5TdDNfXzIxMG1vbmV5cHVuY3RJd0xiMEVFRQBw/wAAQPAAAAAAAAACAAAAOOQAAAIAAABs7wAAAgAAAAAAAADQ8AAArwMAAFAEAACNAwAAUQQAAFIEAABTBAAAVAQAAFUEAABWBAAAVwQAAFgEAABZBAAATlN0M19fMjEwbW9uZXlwdW5jdEl3TGIxRUVFAHD/AAC08AAAAAAAAAIAAAA45AAAAgAAAGzvAAACAAAAAAAAAHTxAACvAwAAWgQAAI0DAABbBAAAXAQAAE5TdDNfXzI5bW9uZXlfZ2V0SWNOU18xOWlzdHJlYW1idWZfaXRlcmF0b3JJY05TXzExY2hhcl90cmFpdHNJY0VFRUVFRQBOU3QzX18yMTFfX21vbmV5X2dldEljRUUAAOz+AABS8QAAcP8AAAzxAAAAAAAAAgAAADjkAAACAAAAbPEAQZjjAwuaARjyAACvAwAAXQQAAI0DAABeBAAAXwQAAE5TdDNfXzI5bW9uZXlfZ2V0SXdOU18xOWlzdHJlYW1idWZfaXRlcmF0b3JJd05TXzExY2hhcl90cmFpdHNJd0VFRUVFRQBOU3QzX18yMTFfX21vbmV5X2dldEl3RUUAAOz+AAD28QAAcP8AALDxAAAAAAAAAgAAADjkAAACAAAAEPIAQbzkAwuaAbzyAACvAwAAYAQAAI0DAABhBAAAYgQAAE5TdDNfXzI5bW9uZXlfcHV0SWNOU18xOW9zdHJlYW1idWZfaXRlcmF0b3JJY05TXzExY2hhcl90cmFpdHNJY0VFRUVFRQBOU3QzX18yMTFfX21vbmV5X3B1dEljRUUAAOz+AACa8gAAcP8AAFTyAAAAAAAAAgAAADjkAAACAAAAtPIAQeDlAwuaAWDzAACvAwAAYwQAAI0DAABkBAAAZQQAAE5TdDNfXzI5bW9uZXlfcHV0SXdOU18xOW9zdHJlYW1idWZfaXRlcmF0b3JJd05TXzExY2hhcl90cmFpdHNJd0VFRUVFRQBOU3QzX18yMTFfX21vbmV5X3B1dEl3RUUAAOz+AAA+8wAAcP8AAPjyAAAAAAAAAgAAADjkAAACAAAAWPMAQYTnAwuvJdjzAACvAwAAZgQAAI0DAABnBAAAaAQAAGkEAABOU3QzX18yOG1lc3NhZ2VzSWNFRQBOU3QzX18yMTNtZXNzYWdlc19iYXNlRQAAAADs/gAAtfMAAHD/AACg8wAAAAAAAAIAAAA45AAAAgAAANDzAAACAAAAAAAAADD0AACvAwAAagQAAI0DAABrBAAAbAQAAG0EAABOU3QzX18yOG1lc3NhZ2VzSXdFRQAAAABw/wAAGPQAAAAAAAACAAAAOOQAAAIAAADQ8wAAAgAAAFN1bmRheQBNb25kYXkAVHVlc2RheQBXZWRuZXNkYXkAVGh1cnNkYXkARnJpZGF5AFNhdHVyZGF5AFN1bgBNb24AVHVlAFdlZABUaHUARnJpAFNhdAAAAABTAAAAdQAAAG4AAABkAAAAYQAAAHkAAAAAAAAATQAAAG8AAABuAAAAZAAAAGEAAAB5AAAAAAAAAFQAAAB1AAAAZQAAAHMAAABkAAAAYQAAAHkAAAAAAAAAVwAAAGUAAABkAAAAbgAAAGUAAABzAAAAZAAAAGEAAAB5AAAAAAAAAFQAAABoAAAAdQAAAHIAAABzAAAAZAAAAGEAAAB5AAAAAAAAAEYAAAByAAAAaQAAAGQAAABhAAAAeQAAAAAAAABTAAAAYQAAAHQAAAB1AAAAcgAAAGQAAABhAAAAeQAAAAAAAABTAAAAdQAAAG4AAAAAAAAATQAAAG8AAABuAAAAAAAAAFQAAAB1AAAAZQAAAAAAAABXAAAAZQAAAGQAAAAAAAAAVAAAAGgAAAB1AAAAAAAAAEYAAAByAAAAaQAAAAAAAABTAAAAYQAAAHQAAAAAAAAASmFudWFyeQBGZWJydWFyeQBNYXJjaABBcHJpbABNYXkASnVuZQBKdWx5AEF1Z3VzdABTZXB0ZW1iZXIAT2N0b2JlcgBOb3ZlbWJlcgBEZWNlbWJlcgBKYW4ARmViAE1hcgBBcHIASnVuAEp1bABBdWcAU2VwAE9jdABOb3YARGVjAAAASgAAAGEAAABuAAAAdQAAAGEAAAByAAAAeQAAAAAAAABGAAAAZQAAAGIAAAByAAAAdQAAAGEAAAByAAAAeQAAAAAAAABNAAAAYQAAAHIAAABjAAAAaAAAAAAAAABBAAAAcAAAAHIAAABpAAAAbAAAAAAAAABNAAAAYQAAAHkAAAAAAAAASgAAAHUAAABuAAAAZQAAAAAAAABKAAAAdQAAAGwAAAB5AAAAAAAAAEEAAAB1AAAAZwAAAHUAAABzAAAAdAAAAAAAAABTAAAAZQAAAHAAAAB0AAAAZQAAAG0AAABiAAAAZQAAAHIAAAAAAAAATwAAAGMAAAB0AAAAbwAAAGIAAABlAAAAcgAAAAAAAABOAAAAbwAAAHYAAABlAAAAbQAAAGIAAABlAAAAcgAAAAAAAABEAAAAZQAAAGMAAABlAAAAbQAAAGIAAABlAAAAcgAAAAAAAABKAAAAYQAAAG4AAAAAAAAARgAAAGUAAABiAAAAAAAAAE0AAABhAAAAcgAAAAAAAABBAAAAcAAAAHIAAAAAAAAASgAAAHUAAABuAAAAAAAAAEoAAAB1AAAAbAAAAAAAAABBAAAAdQAAAGcAAAAAAAAAUwAAAGUAAABwAAAAAAAAAE8AAABjAAAAdAAAAAAAAABOAAAAbwAAAHYAAAAAAAAARAAAAGUAAABjAAAAAAAAAEFNAFBNAAAAQQAAAE0AAAAAAAAAUAAAAE0AAAAAAAAAYWxsb2NhdG9yPFQ+OjphbGxvY2F0ZShzaXplX3QgbikgJ24nIGV4Y2VlZHMgbWF4aW11bSBzdXBwb3J0ZWQgc2l6ZQAAAAAAyOwAABUEAAAWBAAAFwQAABgEAAAZBAAAGgQAABsEAAAAAAAAtO0AACUEAAAmBAAAJwQAACgEAAApBAAAKgQAACsEAAAAAAAAZPkAAG4EAABvBAAAzQEAAE5TdDNfXzIxNF9fc2hhcmVkX2NvdW50RQAAAADs/gAASPkAAGJhc2ljX3N0cmluZwA6IAAAAAAAqPkAAHoEAAB7BAAAvQIAAABOU3QzX18yMTJzeXN0ZW1fZXJyb3JFABT/AACR+QAAYPwAAE5TdDNfXzIxNGVycm9yX2NhdGVnb3J5RQAAAADs/gAAtPkAAE5TdDNfXzIxMl9fZG9fbWVzc2FnZUUAABT/AADY+QAA0PkAAFVua25vd24gZXJyb3IgJWQAdmVjdG9yACgJAQBfX2N4YV9ndWFyZF9hY3F1aXJlIGRldGVjdGVkIHJlY3Vyc2l2ZSBpbml0aWFsaXphdGlvbgB0ZXJtaW5hdGluZyB3aXRoICVzIGV4Y2VwdGlvbiBvZiB0eXBlICVzOiAlcwB0ZXJtaW5hdGluZyB3aXRoICVzIGV4Y2VwdGlvbiBvZiB0eXBlICVzAHRlcm1pbmF0aW5nIHdpdGggJXMgZm9yZWlnbiBleGNlcHRpb24AdGVybWluYXRpbmcAdW5jYXVnaHQAdGVybWluYXRlX2hhbmRsZXIgdW5leHBlY3RlZGx5IHJldHVybmVkAHRlcm1pbmF0ZV9oYW5kbGVyIHVuZXhwZWN0ZWRseSB0aHJldyBhbiBleGNlcHRpb24AUHVyZSB2aXJ0dWFsIGZ1bmN0aW9uIGNhbGxlZCEAc3RkOjpleGNlcHRpb24AAAAAAAAAyPsAAHMEAAB/BAAAgAQAAHN0ZDo6YmFkX2FsbG9jAAAAAAAAsPsAAHMEAACBBAAAggQAAFN0OWV4Y2VwdGlvbgAAAADs/gAAoPsAAFN0OWJhZF9hbGxvYwAAAAAU/wAAuPsAALD7AAAAAAAADPwAAIoDAACDBAAAhAQAAAAAAABg/AAABQMAAIUEAAC9AgAAU3QxMWxvZ2ljX2Vycm9yABT/AAD8+wAAsPsAAAAAAABA/AAAigMAAIYEAACEBAAAU3QxMmxlbmd0aF9lcnJvcgAAAAAU/wAALPwAAAz8AABTdDEzcnVudGltZV9lcnJvcgAAABT/AABM/AAAsPsAAAAAAACw/AAAWgIAAIcEAACIBAAAc3RkOjpiYWRfY2FzdABTdDl0eXBlX2luZm8AAOz+AACO/AAAU3Q4YmFkX2Nhc3QAFP8AAKT8AACw+wAATjEwX19jeHhhYml2MTE2X19zaGltX3R5cGVfaW5mb0UAAAAAFP8AALz8AACc/AAATjEwX19jeHhhYml2MTE3X19jbGFzc190eXBlX2luZm9FAAAAFP8AAOz8AADg/AAATjEwX19jeHhhYml2MTE3X19wYmFzZV90eXBlX2luZm9FAAAAFP8AABz9AADg/AAATjEwX19jeHhhYml2MTE5X19wb2ludGVyX3R5cGVfaW5mb0UAFP8AAEz9AABA/QAATjEwX19jeHhhYml2MTIwX19mdW5jdGlvbl90eXBlX2luZm9FAAAAABT/AAB8/QAA4PwAAE4xMF9fY3h4YWJpdjEyOV9fcG9pbnRlcl90b19tZW1iZXJfdHlwZV9pbmZvRQAAABT/AACw/QAAQP0AAAAAAAAw/gAAiQQAAIoEAACLBAAAjAQAAI0EAABOMTBfX2N4eGFiaXYxMjNfX2Z1bmRhbWVudGFsX3R5cGVfaW5mb0UAFP8AAAj+AADg/AAAdgAAAPT9AAA8/gAARG4AAPT9AABI/gAAYgAAAPT9AABU/gAAYwAAAPT9AABg/gAAaAAAAPT9AABs/gAAYQAAAPT9AAB4/gAAcwAAAPT9AACE/gAAdAAAAPT9AACQ/gAAaQAAAPT9AACc/gAAagAAAPT9AACo/gAAbAAAAPT9AAC0/gAAbQAAAPT9AADA/gAAZgAAAPT9AADM/gAAZAAAAPT9AADY/gAAAAAAABD9AACJBAAAjgQAAIsEAACMBAAAjwQAAJAEAACRBAAAkgQAAAAAAABc/wAAiQQAAJMEAACLBAAAjAQAAI8EAACUBAAAlQQAAJYEAABOMTBfX2N4eGFiaXYxMjBfX3NpX2NsYXNzX3R5cGVfaW5mb0UAAAAAFP8AADT/AAAQ/QAAAAAAALj/AACJBAAAlwQAAIsEAACMBAAAjwQAAJgEAACZBAAAmgQAAE4xMF9fY3h4YWJpdjEyMV9fdm1pX2NsYXNzX3R5cGVfaW5mb0UAAAAU/wAAkP8AABD9AAAAAAAAcP0AAIkEAACbBAAAiwQAAIwEAACcBAAAdm9pZABib29sAGNoYXIAc2lnbmVkIGNoYXIAdW5zaWduZWQgY2hhcgBzaG9ydAB1bnNpZ25lZCBzaG9ydABpbnQAdW5zaWduZWQgaW50AGxvbmcAdW5zaWduZWQgbG9uZwBmbG9hdABkb3VibGUAc3RkOjpzdHJpbmcAc3RkOjpiYXNpY19zdHJpbmc8dW5zaWduZWQgY2hhcj4Ac3RkOjp3c3RyaW5nAHN0ZDo6dTE2c3RyaW5nAHN0ZDo6dTMyc3RyaW5nAGVtc2NyaXB0ZW46OnZhbABlbXNjcmlwdGVuOjptZW1vcnlfdmlldzxjaGFyPgBlbXNjcmlwdGVuOjptZW1vcnlfdmlldzxzaWduZWQgY2hhcj4AZW1zY3JpcHRlbjo6bWVtb3J5X3ZpZXc8dW5zaWduZWQgY2hhcj4AZW1zY3JpcHRlbjo6bWVtb3J5X3ZpZXc8c2hvcnQ+AGVtc2NyaXB0ZW46Om1lbW9yeV92aWV3PHVuc2lnbmVkIHNob3J0PgBlbXNjcmlwdGVuOjptZW1vcnlfdmlldzxpbnQ+AGVtc2NyaXB0ZW46Om1lbW9yeV92aWV3PHVuc2lnbmVkIGludD4AZW1zY3JpcHRlbjo6bWVtb3J5X3ZpZXc8bG9uZz4AZW1zY3JpcHRlbjo6bWVtb3J5X3ZpZXc8dW5zaWduZWQgbG9uZz4AZW1zY3JpcHRlbjo6bWVtb3J5X3ZpZXc8aW50OF90PgBlbXNjcmlwdGVuOjptZW1vcnlfdmlldzx1aW50OF90PgBlbXNjcmlwdGVuOjptZW1vcnlfdmlldzxpbnQxNl90PgBlbXNjcmlwdGVuOjptZW1vcnlfdmlldzx1aW50MTZfdD4AZW1zY3JpcHRlbjo6bWVtb3J5X3ZpZXc8aW50MzJfdD4AZW1zY3JpcHRlbjo6bWVtb3J5X3ZpZXc8dWludDMyX3Q+AGVtc2NyaXB0ZW46Om1lbW9yeV92aWV3PGZsb2F0PgBlbXNjcmlwdGVuOjptZW1vcnlfdmlldzxkb3VibGU+AE5TdDNfXzIxMmJhc2ljX3N0cmluZ0loTlNfMTFjaGFyX3RyYWl0c0loRUVOU185YWxsb2NhdG9ySWhFRUVFAAAAAHD/AAD2AgEAAAAAAAEAAABkCAAAAAAAAE5TdDNfXzIxMmJhc2ljX3N0cmluZ0l3TlNfMTFjaGFyX3RyYWl0c0l3RUVOU185YWxsb2NhdG9ySXdFRUVFAABw/wAAUAMBAAAAAAABAAAAZAgAAAAAAABOU3QzX18yMTJiYXNpY19zdHJpbmdJRHNOU18xMWNoYXJfdHJhaXRzSURzRUVOU185YWxsb2NhdG9ySURzRUVFRQAAAHD/AACoAwEAAAAAAAEAAABkCAAAAAAAAE5TdDNfXzIxMmJhc2ljX3N0cmluZ0lEaU5TXzExY2hhcl90cmFpdHNJRGlFRU5TXzlhbGxvY2F0b3JJRGlFRUVFAAAAcP8AAAQEAQAAAAAAAQAAAGQIAAAAAAAATjEwZW1zY3JpcHRlbjN2YWxFAADs/gAAYAQBAE4xMGVtc2NyaXB0ZW4xMW1lbW9yeV92aWV3SWNFRQAA7P4AAHwEAQBOMTBlbXNjcmlwdGVuMTFtZW1vcnlfdmlld0lhRUUAAOz+AACkBAEATjEwZW1zY3JpcHRlbjExbWVtb3J5X3ZpZXdJaEVFAADs/gAAzAQBAE4xMGVtc2NyaXB0ZW4xMW1lbW9yeV92aWV3SXNFRQAA7P4AAPQEAQBOMTBlbXNjcmlwdGVuMTFtZW1vcnlfdmlld0l0RUUAAOz+AAAcBQEATjEwZW1zY3JpcHRlbjExbWVtb3J5X3ZpZXdJaUVFAADs/gAARAUBAE4xMGVtc2NyaXB0ZW4xMW1lbW9yeV92aWV3SWpFRQAA7P4AAGwFAQBOMTBlbXNjcmlwdGVuMTFtZW1vcnlfdmlld0lsRUUAAOz+AACUBQEATjEwZW1zY3JpcHRlbjExbWVtb3J5X3ZpZXdJbUVFAADs/gAAvAUBAE4xMGVtc2NyaXB0ZW4xMW1lbW9yeV92aWV3SWZFRQAA7P4AAOQFAQBOMTBlbXNjcmlwdGVuMTFtZW1vcnlfdmlld0lkRUUAAOz+AAAMBgEAQcCMBAssBCMAAAIAAABEBgEAAEgAAABIAAAAAAAAAAEASAAAAEgAAAAAAAAAAQAY//8AQfmMBAsZAgAQAAAAAABIAAAASAAAAAAAAAABABj//wBBq40ECwEBAEG7jQQLAQEAQcqNBAsBQABB540ECxFIAAAASAAAAAAAAAABABj//wBBgY4ECw1IAAAASAAAAAAAAAABAEGvjgQLAyT//wBByY4ECwkCABAAAAAAAAEAQeGOBAsBAQBB8I4ECwFAAEGBjwQLAQEAQZGPBAsBAQBBoI8ECwFAAEHUkAQLAxBVAQBBkJEECwEFAEGckQQLApMCAEG0kQQLDo0CAACUAgAASFUBAAAEAEHMkQQLAQEAQduRBAsFCv////8AQaCSBAsJkAgBAFzOAAAFAEG0kgQLAo8CAEHMkgQLC40CAACMAgAAdGEBAEHkkgQLAQIAQfOSBAsF//////8AQbiTBAsGfAQAANb6";if(!UA(GA,HA)){var oA=GA;GA=B.locateFile?B.locateFile(oA,o):o+oA}function wA(){try{if(s)return new Uint8Array(s);var A=_B(GA);if(A)return A;if(N)return N(GA);throw"both async and sync fetching of the wasm failed"}catch(A){FA(A)}}T.push({ob:function(){BQ()}});var YA={},sA=[];function LA(A){if(!A||YA[A])return A;for(var B in YA)for(var Q=+B,I=YA[Q].ha,g=I.length,E=0;E<g;E++)if(I[E]===A)return Q;return A}var RA=0;function hA(A){try{return IQ(A)}catch(A){}}function kA(A){return l[gQ()>>2]=A}function aA(A,B){for(var Q=0,I=A.length-1;0<=I;I--){var g=A[I];"."===g?A.splice(I,1):".."===g?(A.splice(I,1),Q++):Q&&(A.splice(I,1),Q--)}if(B)for(;Q;Q--)A.unshift("..");return A}function SA(A){var B="/"===A.charAt(0),Q="/"===A.substr(-1);return(A=aA(A.split("/").filter((function(A){return!!A})),!B).join("/"))||B||(A="."),A&&Q&&(A+="/"),(B?"/":"")+A}function MA(A){var B=/^(\/?|)([\s\S]*?)((?:\.{1,2}|[^\/]+?|)(\.[^.\/]*|))(?:[\/]*)$/.exec(A).slice(1);return A=B[0],B=B[1],A||B?(B&&(B=B.substr(0,B.length-1)),A+B):"."}function JA(A){if("/"===A)return"/";var B=A.lastIndexOf("/");return-1===B?A:A.substr(B+1)}function VA(){var A=Array.prototype.slice.call(arguments,0);return SA(A.join("/"))}function KA(A,B){return SA(A+"/"+B)}function tA(){for(var A="",B=!1,Q=arguments.length-1;-1<=Q&&!B;Q--){if("string"!=typeof(B=0<=Q?arguments[Q]:fA.cwd()))throw new TypeError("Arguments to path.resolve must be strings");if(!B)return"";A=B+"/"+A,B="/"===B.charAt(0)}return(B?"/":"")+(A=aA(A.split("/").filter((function(A){return!!A})),!B).join("/"))||"."}function nA(A,B){function Q(A){for(var B=0;B<A.length&&""===A[B];B++);for(var Q=A.length-1;0<=Q&&""===A[Q];Q--);return B>Q?[]:A.slice(B,Q-B+1)}A=tA(A).substr(1),B=tA(B).substr(1),A=Q(A.split("/")),B=Q(B.split("/"));for(var I=Math.min(A.length,B.length),g=I,E=0;E<I;E++)if(A[E]!==B[E]){g=E;break}for(I=[],E=g;E<A.length;E++)I.push("..");return(I=I.concat(B.slice(g))).join("/")}var dA=[];function rA(A,B){dA[A]={input:[],output:[],ea:B},fA.$a(A,eA)}var eA={open:function(A){var B=dA[A.node.rdev];if(!B)throw new fA.b(43);A.tty=B,A.seekable=!1},close:function(A){A.tty.ea.flush(A.tty)},flush:function(A){A.tty.ea.flush(A.tty)},read:function(A,B,Q,I){if(!A.tty||!A.tty.ea.qb)throw new fA.b(60);for(var g=0,E=0;E<I;E++){try{var C=A.tty.ea.qb(A.tty)}catch(A){throw new fA.b(29)}if(void 0===C&&0===g)throw new fA.b(6);if(null==C)break;g++,B[Q+E]=C}return g&&(A.node.timestamp=Date.now()),g},write:function(A,B,Q,I){if(!A.tty||!A.tty.ea.Xa)throw new fA.b(60);try{for(var g=0;g<I;g++)A.tty.ea.Xa(A.tty,B[Q+g])}catch(A){throw new fA.b(29)}return I&&(A.node.timestamp=Date.now()),g}},lA={qb:function(A){if(!A.input.length){var B=null;if(y){var Q=Buffer.S?Buffer.S(256):new Buffer(256),I=0;try{I=H.readSync(process.stdin.fd,Q,0,256,null)}catch(A){if(-1==A.toString().indexOf("EOF"))throw A;I=0}B=0<I?Q.slice(0,I).toString("utf-8"):null}else"undefined"!=typeof window&&"function"==typeof window.prompt?null!==(B=window.prompt("Input: "))&&(B+="\n"):"function"==typeof readline&&null!==(B=readline())&&(B+="\n");if(!B)return null;A.input=vB(B,!0)}return A.input.shift()},Xa:function(A,B){null===B||10===B?(w(M(A.output,0)),A.output=[]):0!=B&&A.output.push(B)},flush:function(A){A.output&&0<A.output.length&&(w(M(A.output,0)),A.output=[])}},xA={Xa:function(A,B){null===B||10===B?(Y(M(A.output,0)),A.output=[]):0!=B&&A.output.push(B)},flush:function(A){A.output&&0<A.output.length&&(Y(M(A.output,0)),A.output=[])}},ZA={M:null,s:function(){return ZA.createNode(null,"/",16895,0)},createNode:function(A,B,Q,I){if(fA.$b(Q)||fA.isFIFO(Q))throw new fA.b(63);return ZA.M||(ZA.M={dir:{node:{J:ZA.g.J,A:ZA.g.A,lookup:ZA.g.lookup,R:ZA.g.R,rename:ZA.g.rename,unlink:ZA.g.unlink,rmdir:ZA.g.rmdir,readdir:ZA.g.readdir,symlink:ZA.g.symlink},stream:{K:ZA.h.K}},file:{node:{J:ZA.g.J,A:ZA.g.A},stream:{K:ZA.h.K,read:ZA.h.read,write:ZA.h.write,ia:ZA.h.ia,na:ZA.h.na,da:ZA.h.da}},link:{node:{J:ZA.g.J,A:ZA.g.A,readlink:ZA.g.readlink},stream:{}},gb:{node:{J:ZA.g.J,A:ZA.g.A},stream:fA.Kb}}),Q=fA.createNode(A,B,Q,I),fA.v(Q.mode)?(Q.g=ZA.M.dir.node,Q.h=ZA.M.dir.stream,Q.f={}):fA.isFile(Q.mode)?(Q.g=ZA.M.file.node,Q.h=ZA.M.file.stream,Q.l=0,Q.f=null):fA.ma(Q.mode)?(Q.g=ZA.M.link.node,Q.h=ZA.M.link.stream):fA.ya(Q.mode)&&(Q.g=ZA.M.gb.node,Q.h=ZA.M.gb.stream),Q.timestamp=Date.now(),A&&(A.f[B]=Q),Q},Gc:function(A){if(A.f&&A.f.subarray){for(var B=[],Q=0;Q<A.l;++Q)B.push(A.f[Q]);return B}return A.f},Hc:function(A){return A.f?A.f.subarray?A.f.subarray(0,A.l):new Uint8Array(A.f):new Uint8Array(0)},lb:function(A,B){var Q=A.f?A.f.length:0;Q>=B||(B=Math.max(B,Q*(1048576>Q?2:1.125)>>>0),0!=Q&&(B=Math.max(B,256)),Q=A.f,A.f=new Uint8Array(B),0<A.l&&A.f.set(Q.subarray(0,A.l),0))},oc:function(A,B){if(A.l!=B)if(0==B)A.f=null,A.l=0;else{if(!A.f||A.f.subarray){var Q=A.f;A.f=new Uint8Array(B),Q&&A.f.set(Q.subarray(0,Math.min(B,A.l)))}else if(A.f||(A.f=[]),A.f.length>B)A.f.length=B;else for(;A.f.length<B;)A.f.push(0);A.l=B}},g:{J:function(A){var B={};return B.dev=fA.ya(A.mode)?A.id:1,B.ino=A.id,B.mode=A.mode,B.nlink=1,B.uid=0,B.gid=0,B.rdev=A.rdev,fA.v(A.mode)?B.size=4096:fA.isFile(A.mode)?B.size=A.l:fA.ma(A.mode)?B.size=A.link.length:B.size=0,B.atime=new Date(A.timestamp),B.mtime=new Date(A.timestamp),B.ctime=new Date(A.timestamp),B.Hb=4096,B.blocks=Math.ceil(B.size/B.Hb),B},A:function(A,B){void 0!==B.mode&&(A.mode=B.mode),void 0!==B.timestamp&&(A.timestamp=B.timestamp),void 0!==B.size&&ZA.oc(A,B.size)},lookup:function(){throw fA.Na[44]},R:function(A,B,Q,I){return ZA.createNode(A,B,Q,I)},rename:function(A,B,Q){if(fA.v(A.mode)){try{var I=fA.P(B,Q)}catch(A){}if(I)for(var g in I.f)throw new fA.b(55)}delete A.parent.f[A.name],A.name=Q,B.f[Q]=A,A.parent=B},unlink:function(A,B){delete A.f[B]},rmdir:function(A,B){var Q,I=fA.P(A,B);for(Q in I.f)throw new fA.b(55);delete A.f[B]},readdir:function(A){var B,Q=[".",".."];for(B in A.f)A.f.hasOwnProperty(B)&&Q.push(B);return Q},symlink:function(A,B,Q){return(A=ZA.createNode(A,B,41471,0)).link=Q,A},readlink:function(A){if(!fA.ma(A.mode))throw new fA.b(28);return A.link}},h:{read:function(A,B,Q,I,g){var E=A.node.f;if(g>=A.node.l)return 0;if(8<(A=Math.min(A.node.l-g,I))&&E.subarray)B.set(E.subarray(g,g+A),Q);else for(I=0;I<A;I++)B[Q+I]=E[g+I];return A},write:function(A,B,Q,I,g,E){if(B.buffer===n.buffer&&(E=!1),!I)return 0;if((A=A.node).timestamp=Date.now(),B.subarray&&(!A.f||A.f.subarray)){if(E)return A.f=B.subarray(Q,Q+I),A.l=I;if(0===A.l&&0===g)return A.f=B.slice(Q,Q+I),A.l=I;if(g+I<=A.l)return A.f.set(B.subarray(Q,Q+I),g),I}if(ZA.lb(A,g+I),A.f.subarray&&B.subarray)A.f.set(B.subarray(Q,Q+I),g);else for(E=0;E<I;E++)A.f[g+E]=B[Q+E];return A.l=Math.max(A.l,g+I),I},K:function(A,B,Q){if(1===Q?B+=A.position:2===Q&&fA.isFile(A.node.mode)&&(B+=A.node.l),0>B)throw new fA.b(28);return B},ia:function(A,B,Q){ZA.lb(A.node,B+Q),A.node.l=Math.max(A.node.l,B+Q)},na:function(A,B,Q,I,g,E,C){if(!fA.isFile(A.node.mode))throw new fA.b(43);if(A=A.node.f,2&C||A.buffer!==B.buffer){if((0<g||g+I<A.length)&&(A=A.subarray?A.subarray(g,g+I):Array.prototype.slice.call(A,g,g+I)),g=!0,C=B.buffer==n.buffer,!(I=QQ(I)))throw new fA.b(48);(C?n:B).set(A,I)}else g=!1,I=A.byteOffset;return{j:I,Gb:g}},da:function(A,B,Q,I,g){if(!fA.isFile(A.node.mode))throw new fA.b(43);return 2&g||ZA.h.write(A,B,0,I,Q,!1),0}}},fA={root:null,pa:[],jb:{},streams:[],ec:1,L:null,ib:"/",Qa:!1,ub:!0,u:{},zb:{wb:{Cb:1,Db:2}},b:null,Na:{},Ub:null,Fa:0,Ic:function(A){if(!(A instanceof fA.b)){A:{var Q=Error();if(!Q.stack){try{throw Error()}catch(A){Q=A}if(!Q.stack){Q="(no stack trace available)";break A}}Q=Q.stack.toString()}throw B.extraStackTrace&&(Q+="\n"+B.extraStackTrace()),Q=function(A){return A.replace(/\b_Z[\w\d_]+/g,(function(A){return A==A?A:A+" ["+A+"]"}))}(Q),A+" : "+Q}return kA(A.B)},m:function(A,B){if(B=B||{},!(A=tA(fA.cwd(),A)))return{path:"",node:null};var Q,I={Ma:!0,Za:0};for(Q in I)void 0===B[Q]&&(B[Q]=I[Q]);if(8<B.Za)throw new fA.b(32);A=aA(A.split("/").filter((function(A){return!!A})),!1);var g=fA.root;for(I="/",Q=0;Q<A.length;Q++){var E=Q===A.length-1;if(E&&B.parent)break;if(g=fA.P(g,A[Q]),I=KA(I,A[Q]),fA.W(g)&&(!E||E&&B.Ma)&&(g=g.oa.root),!E||B.H)for(E=0;fA.ma(g.mode);)if(g=fA.readlink(I),I=tA(MA(I),g),g=fA.m(I,{Za:B.Za}).node,40<E++)throw new fA.b(32)}return{path:I,node:g}},I:function(A){for(var B;;){if(fA.Aa(A))return A=A.s.vb,B?"/"!==A[A.length-1]?A+"/"+B:A+B:A;B=B?A.name+"/"+B:A.name,A=A.parent}},Pa:function(A,B){for(var Q=0,I=0;I<B.length;I++)Q=(Q<<5)-Q+B.charCodeAt(I)|0;return(A+Q>>>0)%fA.L.length},sb:function(A){var B=fA.Pa(A.parent.id,A.name);A.Y=fA.L[B],fA.L[B]=A},tb:function(A){var B=fA.Pa(A.parent.id,A.name);if(fA.L[B]===A)fA.L[B]=A.Y;else for(B=fA.L[B];B;){if(B.Y===A){B.Y=A.Y;break}B=B.Y}},P:function(A,B){var Q=fA.bc(A);if(Q)throw new fA.b(Q,A);for(Q=fA.L[fA.Pa(A.id,B)];Q;Q=Q.Y){var I=Q.name;if(Q.parent.id===A.id&&I===B)return Q}return fA.lookup(A,B)},createNode:function(A,B,Q,I){return A=new fA.Ab(A,B,Q,I),fA.sb(A),A},La:function(A){fA.tb(A)},Aa:function(A){return A===A.parent},W:function(A){return!!A.oa},isFile:function(A){return 32768==(61440&A)},v:function(A){return 16384==(61440&A)},ma:function(A){return 40960==(61440&A)},ya:function(A){return 8192==(61440&A)},$b:function(A){return 24576==(61440&A)},isFIFO:function(A){return 4096==(61440&A)},isSocket:function(A){return 49152==(49152&A)},Vb:{r:0,rs:1052672,"r+":2,w:577,wx:705,xw:705,"w+":578,"wx+":706,"xw+":706,a:1089,ax:1217,xa:1217,"a+":1090,"ax+":1218,"xa+":1218},dc:function(A){var B=fA.Vb[A];if(void 0===B)throw Error("Unknown file open mode: "+A);return B},mb:function(A){var B=["r","w","rw"][3&A];return 512&A&&(B+="w"),B},Z:function(A,B){return fA.ub||(-1===B.indexOf("r")||292&A.mode)&&(-1===B.indexOf("w")||146&A.mode)&&(-1===B.indexOf("x")||73&A.mode)?0:2},bc:function(A){var B=fA.Z(A,"x");return B||(A.g.lookup?0:2)},Wa:function(A,B){try{return fA.P(A,B),20}catch(A){}return fA.Z(A,"wx")},Ca:function(A,B,Q){try{var I=fA.P(A,B)}catch(A){return A.B}if(A=fA.Z(A,"wx"))return A;if(Q){if(!fA.v(I.mode))return 54;if(fA.Aa(I)||fA.I(I)===fA.cwd())return 10}else if(fA.v(I.mode))return 31;return 0},cc:function(A,B){return A?fA.ma(A.mode)?32:fA.v(A.mode)&&("r"!==fA.mb(B)||512&B)?31:fA.Z(A,fA.mb(B)):44},Bb:4096,fc:function(A,B){for(B=B||fA.Bb,A=A||0;A<=B;A++)if(!fA.streams[A])return A;throw new fA.b(33)},ba:function(A){return fA.streams[A]},Sb:function(A,B,Q){fA.Ja||(fA.Ja=function(){},fA.Ja.prototype={object:{get:function(){return this.node},set:function(A){this.node=A}}});var I,g=new fA.Ja;for(I in A)g[I]=A[I];return A=g,B=fA.fc(B,Q),A.fd=B,fA.streams[B]=A},Lb:function(A){fA.streams[A]=null},Kb:{open:function(A){A.h=fA.Xb(A.node.rdev).h,A.h.open&&A.h.open(A)},K:function(){throw new fA.b(70)}},Va:function(A){return A>>8},Oc:function(A){return 255&A},X:function(A,B){return A<<8|B},$a:function(A,B){fA.jb[A]={h:B}},Xb:function(A){return fA.jb[A]},pb:function(A){var B=[];for(A=[A];A.length;){var Q=A.pop();B.push(Q),A.push.apply(A,Q.pa)}return B},yb:function(A,B){function Q(A){return fA.Fa--,B(A)}function I(A){if(A){if(!I.S)return I.S=!0,Q(A)}else++E>=g.length&&Q(null)}"function"==typeof A&&(B=A,A=!1),fA.Fa++,1<fA.Fa&&Y("warning: "+fA.Fa+" FS.syncfs operations in flight at once, probably just doing extra work");var g=fA.pb(fA.root.s),E=0;g.forEach((function(B){if(!B.type.yb)return I(null);B.type.yb(B,A,I)}))},s:function(A,B,Q){var I="/"===Q,g=!Q;if(I&&fA.root)throw new fA.b(10);if(!I&&!g){var E=fA.m(Q,{Ma:!1});if(Q=E.path,E=E.node,fA.W(E))throw new fA.b(10);if(!fA.v(E.mode))throw new fA.b(54)}return B={type:A,Rc:B,vb:Q,pa:[]},(A=A.s(B)).s=B,B.root=A,I?fA.root=A:E&&(E.oa=B,E.s&&E.s.pa.push(B)),A},Wc:function(A){if(A=fA.m(A,{Ma:!1}),!fA.W(A.node))throw new fA.b(28);var B=(A=A.node).oa,Q=fA.pb(B);Object.keys(fA.L).forEach((function(A){for(A=fA.L[A];A;){var B=A.Y;-1!==Q.indexOf(A.s)&&fA.La(A),A=B}})),A.oa=null,A.s.pa.splice(A.s.pa.indexOf(B),1)},lookup:function(A,B){return A.g.lookup(A,B)},R:function(A,B,Q){var I=fA.m(A,{parent:!0}).node;if(!(A=JA(A))||"."===A||".."===A)throw new fA.b(28);var g=fA.Wa(I,A);if(g)throw new fA.b(g);if(!I.g.R)throw new fA.b(63);return I.g.R(I,A,B,Q)},create:function(A,B){return fA.R(A,4095&(void 0!==B?B:438)|32768,0)},mkdir:function(A,B){return fA.R(A,1023&(void 0!==B?B:511)|16384,0)},Pc:function(A,B){A=A.split("/");for(var Q="",I=0;I<A.length;++I)if(A[I]){Q+="/"+A[I];try{fA.mkdir(Q,B)}catch(A){if(20!=A.B)throw A}}},Da:function(A,B,Q){return void 0===Q&&(Q=B,B=438),fA.R(A,8192|B,Q)},symlink:function(A,B){if(!tA(A))throw new fA.b(44);var Q=fA.m(B,{parent:!0}).node;if(!Q)throw new fA.b(44);B=JA(B);var I=fA.Wa(Q,B);if(I)throw new fA.b(I);if(!Q.g.symlink)throw new fA.b(63);return Q.g.symlink(Q,B,A)},rename:function(A,B){var Q=MA(A),I=MA(B),g=JA(A),E=JA(B);try{var C=fA.m(A,{parent:!0}),D=C.node,i=(C=fA.m(B,{parent:!0})).node}catch(A){throw new fA.b(10)}if(!D||!i)throw new fA.b(44);if(D.s!==i.s)throw new fA.b(75);if(C=fA.P(D,g),"."!==(I=nA(A,I)).charAt(0))throw new fA.b(28);if("."!==(I=nA(B,Q)).charAt(0))throw new fA.b(55);try{var y=fA.P(i,E)}catch(A){}if(C!==y){if(Q=fA.v(C.mode),g=fA.Ca(D,g,Q))throw new fA.b(g);if(g=y?fA.Ca(i,E,Q):fA.Wa(i,E))throw new fA.b(g);if(!D.g.rename)throw new fA.b(63);if(fA.W(C)||y&&fA.W(y))throw new fA.b(10);if(i!==D&&(g=fA.Z(D,"w")))throw new fA.b(g);try{fA.u.willMovePath&&fA.u.willMovePath(A,B)}catch(Q){Y("FS.trackingDelegate['willMovePath']('"+A+"', '"+B+"') threw an exception: "+Q.message)}fA.tb(C);try{D.g.rename(C,i,E)}catch(A){throw A}finally{fA.sb(C)}try{fA.u.onMovePath&&fA.u.onMovePath(A,B)}catch(Q){Y("FS.trackingDelegate['onMovePath']('"+A+"', '"+B+"') threw an exception: "+Q.message)}}},rmdir:function(A){var B=fA.m(A,{parent:!0}).node,Q=JA(A),I=fA.P(B,Q),g=fA.Ca(B,Q,!0);if(g)throw new fA.b(g);if(!B.g.rmdir)throw new fA.b(63);if(fA.W(I))throw new fA.b(10);try{fA.u.willDeletePath&&fA.u.willDeletePath(A)}catch(B){Y("FS.trackingDelegate['willDeletePath']('"+A+"') threw an exception: "+B.message)}B.g.rmdir(B,Q),fA.La(I);try{fA.u.onDeletePath&&fA.u.onDeletePath(A)}catch(B){Y("FS.trackingDelegate['onDeletePath']('"+A+"') threw an exception: "+B.message)}},readdir:function(A){if(!(A=fA.m(A,{H:!0}).node).g.readdir)throw new fA.b(54);return A.g.readdir(A)},unlink:function(A){var B=fA.m(A,{parent:!0}).node,Q=JA(A),I=fA.P(B,Q),g=fA.Ca(B,Q,!1);if(g)throw new fA.b(g);if(!B.g.unlink)throw new fA.b(63);if(fA.W(I))throw new fA.b(10);try{fA.u.willDeletePath&&fA.u.willDeletePath(A)}catch(B){Y("FS.trackingDelegate['willDeletePath']('"+A+"') threw an exception: "+B.message)}B.g.unlink(B,Q),fA.La(I);try{fA.u.onDeletePath&&fA.u.onDeletePath(A)}catch(B){Y("FS.trackingDelegate['onDeletePath']('"+A+"') threw an exception: "+B.message)}},readlink:function(A){if(!(A=fA.m(A).node))throw new fA.b(44);if(!A.g.readlink)throw new fA.b(28);return tA(fA.I(A.parent),A.g.readlink(A))},stat:function(A,B){if(!(A=fA.m(A,{H:!B}).node))throw new fA.b(44);if(!A.g.J)throw new fA.b(63);return A.g.J(A)},lstat:function(A){return fA.stat(A,!0)},chmod:function(A,B,Q){var I;if(!(I="string"==typeof A?fA.m(A,{H:!Q}).node:A).g.A)throw new fA.b(63);I.g.A(I,{mode:4095&B|-4096&I.mode,timestamp:Date.now()})},lchmod:function(A,B){fA.chmod(A,B,!0)},fchmod:function(A,B){if(!(A=fA.ba(A)))throw new fA.b(8);fA.chmod(A.node,B)},chown:function(A,B,Q,I){var g;if(!(g="string"==typeof A?fA.m(A,{H:!I}).node:A).g.A)throw new fA.b(63);g.g.A(g,{timestamp:Date.now()})},lchown:function(A,B,Q){fA.chown(A,B,Q,!0)},fchown:function(A,B,Q){if(!(A=fA.ba(A)))throw new fA.b(8);fA.chown(A.node,B,Q)},truncate:function(A,B){if(0>B)throw new fA.b(28);var Q;if(!(Q="string"==typeof A?fA.m(A,{H:!0}).node:A).g.A)throw new fA.b(63);if(fA.v(Q.mode))throw new fA.b(31);if(!fA.isFile(Q.mode))throw new fA.b(28);if(A=fA.Z(Q,"w"))throw new fA.b(A);Q.g.A(Q,{size:B,timestamp:Date.now()})},Fc:function(A,B){if(!(A=fA.ba(A)))throw new fA.b(8);if(0==(2097155&A.flags))throw new fA.b(28);fA.truncate(A.node,B)},Xc:function(A,B,Q){(A=fA.m(A,{H:!0}).node).g.A(A,{timestamp:Math.max(B,Q)})},open:function(A,Q,I,g,E){if(""===A)throw new fA.b(44);if(I=64&(Q="string"==typeof Q?fA.dc(Q):Q)?4095&(void 0===I?438:I)|32768:0,"object"==typeof A)var C=A;else{A=SA(A);try{C=fA.m(A,{H:!(131072&Q)}).node}catch(A){}}var D=!1;if(64&Q)if(C){if(128&Q)throw new fA.b(20)}else C=fA.R(A,I,0),D=!0;if(!C)throw new fA.b(44);if(fA.ya(C.mode)&&(Q&=-513),65536&Q&&!fA.v(C.mode))throw new fA.b(54);if(!D&&(I=fA.cc(C,Q)))throw new fA.b(I);512&Q&&fA.truncate(C,0),Q&=-131713,(g=fA.Sb({node:C,path:fA.I(C),flags:Q,seekable:!0,position:0,h:C.h,wc:[],error:!1},g,E)).h.open&&g.h.open(g),!B.logReadFiles||1&Q||(fA.Ya||(fA.Ya={}),A in fA.Ya||(fA.Ya[A]=1,Y("FS.trackingDelegate error on read file: "+A)));try{fA.u.onOpenFile&&(E=0,1!=(2097155&Q)&&(E|=fA.zb.wb.Cb),0!=(2097155&Q)&&(E|=fA.zb.wb.Db),fA.u.onOpenFile(A,E))}catch(B){Y("FS.trackingDelegate['onOpenFile']('"+A+"', flags) threw an exception: "+B.message)}return g},close:function(A){if(fA.la(A))throw new fA.b(8);A.Oa&&(A.Oa=null);try{A.h.close&&A.h.close(A)}catch(A){throw A}finally{fA.Lb(A.fd)}A.fd=null},la:function(A){return null===A.fd},K:function(A,B,Q){if(fA.la(A))throw new fA.b(8);if(!A.seekable||!A.h.K)throw new fA.b(70);if(0!=Q&&1!=Q&&2!=Q)throw new fA.b(28);return A.position=A.h.K(A,B,Q),A.wc=[],A.position},read:function(A,B,Q,I,g){if(0>I||0>g)throw new fA.b(28);if(fA.la(A))throw new fA.b(8);if(1==(2097155&A.flags))throw new fA.b(8);if(fA.v(A.node.mode))throw new fA.b(31);if(!A.h.read)throw new fA.b(28);var E=void 0!==g;if(E){if(!A.seekable)throw new fA.b(70)}else g=A.position;return B=A.h.read(A,B,Q,I,g),E||(A.position+=B),B},write:function(A,B,Q,I,g,E){if(0>I||0>g)throw new fA.b(28);if(fA.la(A))throw new fA.b(8);if(0==(2097155&A.flags))throw new fA.b(8);if(fA.v(A.node.mode))throw new fA.b(31);if(!A.h.write)throw new fA.b(28);A.seekable&&1024&A.flags&&fA.K(A,0,2);var C=void 0!==g;if(C){if(!A.seekable)throw new fA.b(70)}else g=A.position;B=A.h.write(A,B,Q,I,g,E),C||(A.position+=B);try{A.path&&fA.u.onWriteToFile&&fA.u.onWriteToFile(A.path)}catch(B){Y("FS.trackingDelegate['onWriteToFile']('"+A.path+"') threw an exception: "+B.message)}return B},ia:function(A,B,Q){if(fA.la(A))throw new fA.b(8);if(0>B||0>=Q)throw new fA.b(28);if(0==(2097155&A.flags))throw new fA.b(8);if(!fA.isFile(A.node.mode)&&!fA.v(A.node.mode))throw new fA.b(43);if(!A.h.ia)throw new fA.b(138);A.h.ia(A,B,Q)},na:function(A,B,Q,I,g,E,C){if(0!=(2&E)&&0==(2&C)&&2!=(2097155&A.flags))throw new fA.b(2);if(1==(2097155&A.flags))throw new fA.b(2);if(!A.h.na)throw new fA.b(43);return A.h.na(A,B,Q,I,g,E,C)},da:function(A,B,Q,I,g){return A&&A.h.da?A.h.da(A,B,Q,I,g):0},Qc:function(){return 0},Ra:function(A,B,Q){if(!A.h.Ra)throw new fA.b(59);return A.h.Ra(A,B,Q)},readFile:function(A,B){if((B=B||{}).flags=B.flags||"r",B.encoding=B.encoding||"binary","utf8"!==B.encoding&&"binary"!==B.encoding)throw Error('Invalid encoding type "'+B.encoding+'"');var Q,I=fA.open(A,B.flags);A=fA.stat(A).size;var g=new Uint8Array(A);return fA.read(I,g,0,A,0),"utf8"===B.encoding?Q=M(g,0):"binary"===B.encoding&&(Q=g),fA.close(I),Q},writeFile:function(A,B,Q){if((Q=Q||{}).flags=Q.flags||"w",A=fA.open(A,Q.flags,Q.mode),"string"==typeof B){var I=new Uint8Array(K(B)+1);B=V(B,I,0,I.length),fA.write(A,I,0,B,void 0,Q.Jb)}else{if(!ArrayBuffer.isView(B))throw Error("Unsupported data type");fA.write(A,B,0,B.byteLength,void 0,Q.Jb)}fA.close(A)},cwd:function(){return fA.ib},chdir:function(A){if(null===(A=fA.m(A,{H:!0})).node)throw new fA.b(44);if(!fA.v(A.node.mode))throw new fA.b(54);var B=fA.Z(A.node,"x");if(B)throw new fA.b(B);fA.ib=A.path},Ob:function(){fA.mkdir("/tmp"),fA.mkdir("/home"),fA.mkdir("/home/web_user")},Nb:function(){if(fA.mkdir("/dev"),fA.$a(fA.X(1,3),{read:function(){return 0},write:function(A,B,Q,I){return I}}),fA.Da("/dev/null",fA.X(1,3)),rA(fA.X(5,0),lA),rA(fA.X(6,0),xA),fA.Da("/dev/tty",fA.X(5,0)),fA.Da("/dev/tty1",fA.X(6,0)),"object"==typeof crypto&&"function"==typeof crypto.getRandomValues)var A=new Uint8Array(1),B=function(){return crypto.getRandomValues(A),A[0]};else if(y)try{var I=Q(4);B=function(){return I.randomBytes(1)[0]}}catch(A){}B||(B=function(){FA("random_device")}),fA.T("/dev","random",B),fA.T("/dev","urandom",B),fA.mkdir("/dev/shm"),fA.mkdir("/dev/shm/tmp")},Qb:function(){fA.mkdir("/proc"),fA.mkdir("/proc/self"),fA.mkdir("/proc/self/fd"),fA.s({s:function(){var A=fA.createNode("/proc/self","fd",16895,73);return A.g={lookup:function(A,B){var Q=fA.ba(+B);if(!Q)throw new fA.b(8);return(A={parent:null,s:{vb:"fake"},g:{readlink:function(){return Q.path}}}).parent=A}},A}},{},"/proc/self/fd")},Rb:function(){B.stdin?fA.T("/dev","stdin",B.stdin):fA.symlink("/dev/tty","/dev/stdin"),B.stdout?fA.T("/dev","stdout",null,B.stdout):fA.symlink("/dev/tty","/dev/stdout"),B.stderr?fA.T("/dev","stderr",null,B.stderr):fA.symlink("/dev/tty1","/dev/stderr"),fA.open("/dev/stdin","r"),fA.open("/dev/stdout","w"),fA.open("/dev/stderr","w")},kb:function(){fA.b||(fA.b=function(A,B){this.node=B,this.pc=function(A){this.B=A},this.pc(A),this.message="FS error"},fA.b.prototype=Error(),fA.b.prototype.constructor=fA.b,[44].forEach((function(A){fA.Na[A]=new fA.b(A),fA.Na[A].stack="<generic error, no stack>"})))},rc:function(){fA.kb(),fA.L=Array(4096),fA.s(ZA,{},"/"),fA.Ob(),fA.Nb(),fA.Qb(),fA.Ub={MEMFS:ZA}},ka:function(A,Q,I){fA.ka.Qa=!0,fA.kb(),B.stdin=A||B.stdin,B.stdout=Q||B.stdout,B.stderr=I||B.stderr,fA.Rb()},quit:function(){fA.ka.Qa=!1;var A=B._fflush;for(A&&A(0),A=0;A<fA.streams.length;A++){var Q=fA.streams[A];Q&&fA.close(Q)}},wa:function(A,B){var Q=0;return A&&(Q|=365),B&&(Q|=146),Q},Kc:function(A,B){return A=VA.apply(null,A),B&&"/"==A[0]&&(A=A.substr(1)),A},xc:function(A,B){return tA(B,A)},Uc:function(A){return SA(A)},Ec:function(A,B){return(A=fA.Ka(A,B)).exists?A.object:(kA(A.error),null)},Ka:function(A,B){try{var Q=fA.m(A,{H:!B});A=Q.path}catch(A){}var I={Aa:!1,exists:!1,error:0,name:null,path:null,object:null,hc:!1,jc:null,ic:null};try{Q=fA.m(A,{parent:!0}),I.hc=!0,I.jc=Q.path,I.ic=Q.node,I.name=JA(A),Q=fA.m(A,{H:!B}),I.exists=!0,I.path=Q.path,I.object=Q.node,I.name=Q.node.name,I.Aa="/"===Q.path}catch(A){I.error=A.B}return I},zc:function(A,B,Q,I){return A=KA("string"==typeof A?A:fA.I(A),B),fA.mkdir(A,fA.wa(Q,I))},Cc:function(A,B){for(A="string"==typeof A?A:fA.I(A),B=B.split("/").reverse();B.length;){var Q=B.pop();if(Q){var I=KA(A,Q);try{fA.mkdir(I)}catch(A){}A=I}}return I},Pb:function(A,B,Q,I,g){return A=KA("string"==typeof A?A:fA.I(A),B),fA.create(A,fA.wa(I,g))},hb:function(A,B,Q,I,g,E){if(A=B?KA("string"==typeof A?A:fA.I(A),B):A,I=fA.wa(I,g),g=fA.create(A,I),Q){if("string"==typeof Q){A=Array(Q.length),B=0;for(var C=Q.length;B<C;++B)A[B]=Q.charCodeAt(B);Q=A}fA.chmod(g,146|I),A=fA.open(g,"w"),fA.write(A,Q,0,Q.length,0,E),fA.close(A),fA.chmod(g,I)}return g},T:function(A,B,Q,I){A=KA("string"==typeof A?A:fA.I(A),B),B=fA.wa(!!Q,!!I),fA.T.Va||(fA.T.Va=64);var g=fA.X(fA.T.Va++,0);return fA.$a(g,{open:function(A){A.seekable=!1},close:function(){I&&I.buffer&&I.buffer.length&&I(10)},read:function(A,B,I,g){for(var E=0,C=0;C<g;C++){try{var D=Q()}catch(A){throw new fA.b(29)}if(void 0===D&&0===E)throw new fA.b(6);if(null==D)break;E++,B[I+C]=D}return E&&(A.node.timestamp=Date.now()),E},write:function(A,B,Q,g){for(var E=0;E<g;E++)try{I(B[Q+E])}catch(A){throw new fA.b(29)}return g&&(A.node.timestamp=Date.now()),E}}),fA.Da(A,B,g)},Bc:function(A,B,Q){return A=KA("string"==typeof A?A:fA.I(A),B),fA.symlink(Q,A)},nb:function(A){if(A.Sa||A.ac||A.link||A.f)return!0;var B=!0;if("undefined"!=typeof XMLHttpRequest)throw Error("Lazy loading should have been performed (contents set) in createLazyFile, but it was not. Lazy loading only works in web workers. Use --embed-file or --preload-file in emcc on the main thread.");if(!c)throw Error("Cannot load without read() or XMLHttpRequest.");try{A.f=vB(c(A.url),!0),A.l=A.f.length}catch(A){B=!1}return B||kA(29),B},Ac:function(A,B,Q,I,g){function E(){this.Ua=!1,this.S=[]}if(E.prototype.get=function(A){if(!(A>this.length-1||0>A)){var B=A%this.chunkSize;return this.rb(A/this.chunkSize|0)[B]}},E.prototype.Ib=function(A){this.rb=A},E.prototype.eb=function(){var A=new XMLHttpRequest;if(A.open("HEAD",Q,!1),A.send(null),!(200<=A.status&&300>A.status||304===A.status))throw Error("Couldn't load "+Q+". Status: "+A.status);var B,I=Number(A.getResponseHeader("Content-length")),g=(B=A.getResponseHeader("Accept-Ranges"))&&"bytes"===B;A=(B=A.getResponseHeader("Content-Encoding"))&&"gzip"===B;var E=1048576;g||(E=I);var C=this;C.Ib((function(A){var B=A*E,g=(A+1)*E-1;if(g=Math.min(g,I-1),void 0===C.S[A]){var D=C.S;if(B>g)throw Error("invalid range ("+B+", "+g+") or no bytes requested!");if(g>I-1)throw Error("only "+I+" bytes available! programmer error!");var i=new XMLHttpRequest;if(i.open("GET",Q,!1),I!==E&&i.setRequestHeader("Range","bytes="+B+"-"+g),"undefined"!=typeof Uint8Array&&(i.responseType="arraybuffer"),i.overrideMimeType&&i.overrideMimeType("text/plain; charset=x-user-defined"),i.send(null),!(200<=i.status&&300>i.status||304===i.status))throw Error("Couldn't load "+Q+". Status: "+i.status);B=void 0!==i.response?new Uint8Array(i.response||[]):vB(i.responseText||"",!0),D[A]=B}if(void 0===C.S[A])throw Error("doXHR failed!");return C.S[A]})),!A&&I||(E=I=1,E=I=this.rb(0).length,w("LazyFiles on gzip forces download of the whole file when length is accessed")),this.Fb=I,this.Eb=E,this.Ua=!0},"undefined"!=typeof XMLHttpRequest){if(!i)throw"Cannot do synchronous binary XHRs outside webworkers in modern browsers. Use --embed-file or --preload-file in emcc";var C=new E;Object.defineProperties(C,{length:{get:function(){return this.Ua||this.eb(),this.Fb}},chunkSize:{get:function(){return this.Ua||this.eb(),this.Eb}}}),C={Sa:!1,f:C}}else C={Sa:!1,url:Q};var D=fA.Pb(A,B,C,I,g);C.f?D.f=C.f:C.url&&(D.f=null,D.url=C.url),Object.defineProperties(D,{l:{get:function(){return this.f.length}}});var y={};return Object.keys(D.h).forEach((function(A){var B=D.h[A];y[A]=function(){if(!fA.nb(D))throw new fA.b(29);return B.apply(null,arguments)}})),y.read=function(A,B,Q,I,g){if(!fA.nb(D))throw new fA.b(29);if(g>=(A=A.node.f).length)return 0;if(I=Math.min(A.length-g,I),A.slice)for(var E=0;E<I;E++)B[Q+E]=A[g+E];else for(E=0;E<I;E++)B[Q+E]=A.get(g+E);return I},D.h=y,D},Dc:function(A,Q,I,g,E,C,D,i,y,F){function U(I){function U(B){F&&F(),i||fA.hb(A,Q,B,g,E,y),C&&C(),yA()}var N=!1;B.preloadPlugins.forEach((function(A){!N&&A.canHandle(c)&&(A.handle(I,c,U,(function(){D&&D(),yA()})),N=!0)})),N||U(I)}(void 0).ka();var c=Q?tA(KA(A,Q)):A;iA(),"string"==typeof I?(void 0).yc(I,(function(A){U(A)}),D):U(I)},indexedDB:function(){return window.indexedDB||window.mozIndexedDB||window.webkitIndexedDB||window.msIndexedDB},bb:function(){return"EM_FS_"+window.location.pathname},cb:20,ga:"FILE_DATA",Tc:function(A,B,Q){B=B||function(){},Q=Q||function(){};var I=fA.indexedDB();try{var g=I.open(fA.bb(),fA.cb)}catch(A){return Q(A)}g.onupgradeneeded=function(){w("creating db"),g.result.createObjectStore(fA.ga)},g.onsuccess=function(){var I=g.result.transaction([fA.ga],"readwrite"),E=I.objectStore(fA.ga),C=0,D=0,i=A.length;A.forEach((function(A){(A=E.put(fA.Ka(A).object.f,A)).onsuccess=function(){++C+D==i&&(0==D?B():Q())},A.onerror=function(){D++,C+D==i&&(0==D?B():Q())}})),I.onerror=Q},g.onerror=Q},Mc:function(A,B,Q){B=B||function(){},Q=Q||function(){};var I=fA.indexedDB();try{var g=I.open(fA.bb(),fA.cb)}catch(A){return Q(A)}g.onupgradeneeded=Q,g.onsuccess=function(){var I=g.result;try{var E=I.transaction([fA.ga],"readonly")}catch(A){return void Q(A)}var C=E.objectStore(fA.ga),D=0,i=0,y=A.length;A.forEach((function(A){var I=C.get(A);I.onsuccess=function(){fA.Ka(A).exists&&fA.unlink(A),fA.hb(MA(A),JA(A),I.result,!0,!0,!0),++D+i==y&&(0==i?B():Q())},I.onerror=function(){i++,D+i==y&&(0==i?B():Q())}})),E.onerror=Q},g.onerror=Q}},bA={},pA=void 0;function qA(){return l[(pA+=4)-4>>2]}function uA(A){if(!(A=fA.ba(A)))throw new fA.b(8);return A}function OA(A){switch(A){case 1:return 0;case 2:return 1;case 4:return 2;case 8:return 3;default:throw new TypeError("Unknown type size: "+A)}}var mA=void 0;function WA(A){for(var B="";d[A];)B+=mA[d[A++]];return B}var XA={},jA={},zA={};function vA(A){if(void 0===A)return"_unknown";var B=(A=A.replace(/[^a-zA-Z0-9_]/g,"$")).charCodeAt(0);return 48<=B&&57>=B?"_"+A:A}function TA(A,B){return A=vA(A),new Function("body","return function "+A+'() {\n    "use strict";    return body.apply(this, arguments);\n};\n')(B)}function PA(A){var B=Error,Q=TA(A,(function(B){this.name=A,this.message=B,void 0!==(B=Error(B).stack)&&(this.stack=this.toString()+"\n"+B.replace(/^Error(:[^\n]*)?\n/,""))}));return Q.prototype=Object.create(B.prototype),Q.prototype.constructor=Q,Q.prototype.toString=function(){return void 0===this.message?this.name:this.name+": "+this.message},Q}var _A=void 0;function $A(A){throw new _A(A)}var AB=void 0;function BB(A){throw new AB(A)}function QB(A,B,Q){function I(B){(B=Q(B)).length!==A.length&&BB("Mismatched type converter count");for(var I=0;I<A.length;++I)IB(A[I],B[I])}A.forEach((function(A){zA[A]=B}));var g=Array(B.length),E=[],C=0;B.forEach((function(A,B){jA.hasOwnProperty(A)?g[B]=jA[A]:(E.push(A),XA.hasOwnProperty(A)||(XA[A]=[]),XA[A].push((function(){g[B]=jA[A],++C===E.length&&I(g)})))})),0===E.length&&I(g)}function IB(A,B,Q){if(Q=Q||{},!("argPackAdvance"in B))throw new TypeError("registerType registeredInstance requires argPackAdvance");var I=B.name;if(A||$A('type "'+I+'" must have a positive integer typeid pointer'),jA.hasOwnProperty(A)){if(Q.Zb)return;$A("Cannot register type '"+I+"' twice")}jA[A]=B,delete zA[A],XA.hasOwnProperty(A)&&(B=XA[A],delete XA[A],B.forEach((function(A){A()})))}function gB(A){return{count:A.count,aa:A.aa,qa:A.qa,j:A.j,o:A.o,D:A.D,F:A.F}}function EB(A){$A(A.c.o.i.name+" instance already deleted")}var CB=!1;function DB(){}function iB(A){--A.count.value,0===A.count.value&&(A.D?A.F.$(A.D):A.o.i.$(A.j))}function yB(A){return"undefined"==typeof FinalizationGroup?(yB=function(A){return A},A):(CB=new FinalizationGroup((function(A){for(var B=A.next();!B.done;B=A.next())(B=B.value).j?iB(B):console.warn("object already deleted: "+B.j)})),DB=function(A){CB.unregister(A.c)},(yB=function(A){return CB.register(A,A.c,A.c),A})(A))}var FB=void 0,UB=[];function cB(){for(;UB.length;){var A=UB.pop();A.c.aa=!1,A.delete()}}function NB(){}var HB={};function GB(A,B,Q){if(void 0===A[B].N){var I=A[B];A[B]=function(){return A[B].N.hasOwnProperty(arguments.length)||$A("Function '"+Q+"' called with an invalid number of arguments ("+arguments.length+") - expects one of ("+A[B].N+")!"),A[B].N[arguments.length].apply(this,arguments)},A[B].N=[],A[B].N[I.va]=I}}function oB(A,B,Q,I,g,E,C,D){this.name=A,this.constructor=B,this.U=Q,this.$=I,this.G=g,this.Wb=E,this.ta=C,this.Tb=D,this.lc=[]}function wB(A,B,Q){for(;B!==Q;)B.ta||$A("Expected null or instance of "+Q.name+", got an instance of "+B.name),A=B.ta(A),B=B.G;return A}function YB(A,B){return null===B?(this.Ta&&$A("null is not a valid "+this.name),0):(B.c||$A('Cannot pass "'+lB(B)+'" as a '+this.name),B.c.j||$A("Cannot pass deleted object as a pointer of type "+this.name),wB(B.c.j,B.c.o.i,this.i))}function sB(A,B){if(null===B){if(this.Ta&&$A("null is not a valid "+this.name),this.Ba){var Q=this.mc();return null!==A&&A.push(this.$,Q),Q}return 0}if(B.c||$A('Cannot pass "'+lB(B)+'" as a '+this.name),B.c.j||$A("Cannot pass deleted object as a pointer of type "+this.name),!this.za&&B.c.o.za&&$A("Cannot convert argument of type "+(B.c.F?B.c.F.name:B.c.o.name)+" to parameter type "+this.name),Q=wB(B.c.j,B.c.o.i,this.i),this.Ba)switch(void 0===B.c.D&&$A("Passing raw pointer to smart pointer is illegal"),this.qc){case 0:B.c.F===this?Q=B.c.D:$A("Cannot convert argument of type "+(B.c.F?B.c.F.name:B.c.o.name)+" to parameter type "+this.name);break;case 1:Q=B.c.D;break;case 2:if(B.c.F===this)Q=B.c.D;else{var I=B.clone();Q=this.nc(Q,eB((function(){I.delete()}))),null!==A&&A.push(this.$,Q)}break;default:$A("Unsupporting sharing policy")}return Q}function LB(A,B){return null===B?(this.Ta&&$A("null is not a valid "+this.name),0):(B.c||$A('Cannot pass "'+lB(B)+'" as a '+this.name),B.c.j||$A("Cannot pass deleted object as a pointer of type "+this.name),B.c.o.za&&$A("Cannot convert argument of type "+B.c.o.name+" to parameter type "+this.name),wB(B.c.j,B.c.o.i,this.i))}function RB(A){return this.fromWireType(x[A>>2])}var hB={};function kB(A,B){return B.o&&B.j||BB("makeClassHandle requires ptr and ptrType"),!!B.F!=!!B.D&&BB("Both smartPtrType and smartPtr must be specified"),B.count={value:1},yB(Object.create(A,{c:{value:B}}))}function aB(A,B,Q,I){this.name=A,this.i=B,this.Ta=Q,this.za=I,this.Ba=!1,this.$=this.nc=this.mc=this.xb=this.qc=this.kc=void 0,void 0!==B.G?this.toWireType=sB:(this.toWireType=I?YB:LB,this.O=null)}function SB(A,Q){A=WA(A);for(var I=B["dynCall_"+A],g=[],E=1;E<A.length;++E)g.push("a"+E);return E="return function dynCall_"+A+"_"+Q+"("+g.join(", ")+") {\n",E+="    return dynCall(rawFunction"+(g.length?", ":"")+g.join(", ")+");\n","function"!=typeof(I=new Function("dynCall","rawFunction",E+"};\n")(I,Q))&&$A("unknown function pointer with signature "+A+": "+Q),I}var MB=void 0;function JB(A){var B=WA(A=yQ(A));return IQ(A),B}function VB(A,B){var Q=[],I={};throw B.forEach((function A(B){I[B]||jA[B]||(zA[B]?zA[B].forEach(A):(Q.push(B),I[B]=!0))})),new MB(A+": "+Q.map(JB).join([", "]))}function KB(A,B){for(var Q=[],I=0;I<A;I++)Q.push(l[(B>>2)+I]);return Q}function tB(A){for(;A.length;){var B=A.pop();A.pop()(B)}}function nB(A,B,Q){return A instanceof Object||$A(Q+' with invalid "this": '+A),A instanceof B.i.constructor||$A(Q+' incompatible with "this" of type '+A.constructor.name),A.c.j||$A("cannot call emscripten binding method "+Q+" on deleted object"),wB(A.c.j,A.c.o.i,B.i)}var dB=[],rB=[{},{value:void 0},{value:null},{value:!0},{value:!1}];function eB(A){switch(A){case void 0:return 1;case null:return 2;case!0:return 3;case!1:return 4;default:var B=dB.length?dB.pop():rB.length;return rB[B]={ra:1,value:A},B}}function lB(A){if(null===A)return"null";var B=typeof A;return"object"===B||"array"===B||"function"===B?A.toString():""+A}function xB(A,B){switch(B){case 2:return function(A){return this.fromWireType(Z[A>>2])};case 3:return function(A){return this.fromWireType(f[A>>3])};default:throw new TypeError("Unknown float type: "+A)}}function ZB(A,B,Q){switch(B){case 0:return Q?function(A){return n[A]}:function(A){return d[A]};case 1:return Q?function(A){return r[A>>1]}:function(A){return e[A>>1]};case 2:return Q?function(A){return l[A>>2]}:function(A){return x[A>>2]};default:throw new TypeError("Unknown integer type: "+A)}}var fB,bB={};function pB(){if(!fB){var A,B={USER:"web_user",LOGNAME:"web_user",PATH:"/",PWD:"/",HOME:"/home/web_user",LANG:("object"==typeof navigator&&navigator.languages&&navigator.languages[0]||"C").replace("-","_")+".UTF-8",_:U||"./this.program"};for(A in bB)B[A]=bB[A];var Q=[];for(A in B)Q.push(A+"="+B[A]);fB=Q}return fB}function qB(A){return 0==A%4&&(0!=A%100||0==A%400)}function uB(A,B){for(var Q=0,I=0;I<=B;Q+=A[I++]);return Q}var OB=[31,29,31,30,31,30,31,31,30,31,30,31],mB=[31,28,31,30,31,30,31,31,30,31,30,31];function WB(A,B){for(A=new Date(A.getTime());0<B;){var Q=A.getMonth(),I=(qB(A.getFullYear())?OB:mB)[Q];if(!(B>I-A.getDate())){A.setDate(A.getDate()+B);break}B-=I-A.getDate()+1,A.setDate(1),11>Q?A.setMonth(Q+1):(A.setMonth(0),A.setFullYear(A.getFullYear()+1))}return A}function XB(A,B,Q,I){A||(A=this),this.parent=A,this.s=A.s,this.oa=null,this.id=fA.ec++,this.name=B,this.mode=Q,this.g={},this.h={},this.rdev=I}Object.defineProperties(XB.prototype,{read:{get:function(){return 365==(365&this.mode)},set:function(A){A?this.mode|=365:this.mode&=-366}},write:{get:function(){return 146==(146&this.mode)},set:function(A){A?this.mode|=146:this.mode&=-147}},ac:{get:function(){return fA.v(this.mode)}},Sa:{get:function(){return fA.ya(this.mode)}}}),fA.Ab=XB,fA.rc();for(var jB=Array(256),zB=0;256>zB;++zB)jB[zB]=String.fromCharCode(zB);function vB(A,B){var Q=Array(K(A)+1);return A=V(A,Q,0,Q.length),B&&(Q.length=A),Q}function TB(A){for(var B=[],Q=0;Q<A.length;Q++){var I=A[Q];255<I&&(I&=255),B.push(String.fromCharCode(I))}return B.join("")}mA=jB,_A=B.BindingError=PA("BindingError"),AB=B.InternalError=PA("InternalError"),NB.prototype.isAliasOf=function(A){if(!(this instanceof NB&&A instanceof NB))return!1;var B=this.c.o.i,Q=this.c.j,I=A.c.o.i;for(A=A.c.j;B.G;)Q=B.ta(Q),B=B.G;for(;I.G;)A=I.ta(A),I=I.G;return B===I&&Q===A},NB.prototype.clone=function(){if(this.c.j||EB(this),this.c.qa)return this.c.count.value+=1,this;var A=yB(Object.create(Object.getPrototypeOf(this),{c:{value:gB(this.c)}}));return A.c.count.value+=1,A.c.aa=!1,A},NB.prototype.delete=function(){this.c.j||EB(this),this.c.aa&&!this.c.qa&&$A("Object already scheduled for deletion"),DB(this),iB(this.c),this.c.qa||(this.c.D=void 0,this.c.j=void 0)},NB.prototype.isDeleted=function(){return!this.c.j},NB.prototype.deleteLater=function(){return this.c.j||EB(this),this.c.aa&&!this.c.qa&&$A("Object already scheduled for deletion"),UB.push(this),1===UB.length&&FB&&FB(cB),this.c.aa=!0,this},aB.prototype.Yb=function(A){return this.xb&&(A=this.xb(A)),A},aB.prototype.ja=function(A){this.$&&this.$(A)},aB.prototype.argPackAdvance=8,aB.prototype.readValueFromPointer=RB,aB.prototype.deleteObject=function(A){null!==A&&A.delete()},aB.prototype.fromWireType=function(A){function B(){return this.Ba?kB(this.i.U,{o:this.kc,j:Q,F:this,D:A}):kB(this.i.U,{o:this,j:A})}var Q=this.Yb(A);if(!Q)return this.ja(A),null;var I=function(A,B){for(void 0===B&&$A("ptr should not be undefined");A.G;)B=A.ta(B),A=A.G;return hB[B]}(this.i,Q);if(void 0!==I)return 0===I.c.count.value?(I.c.j=Q,I.c.D=A,I.clone()):(I=I.clone(),this.ja(A),I);if(I=this.i.Wb(Q),!(I=HB[I]))return B.call(this);I=this.za?I.Mb:I.pointerType;var g=function A(B,Q,I){return Q===I?B:void 0===I.G||null===(B=A(B,Q,I.G))?null:I.Tb(B)}(Q,this.i,I.i);return null===g?B.call(this):this.Ba?kB(I.i.U,{o:I,j:g,F:this,D:A}):kB(I.i.U,{o:I,j:g})},B.getInheritedInstanceCount=function(){return Object.keys(hB).length},B.getLiveInheritedInstances=function(){var A,B=[];for(A in hB)hB.hasOwnProperty(A)&&B.push(hB[A]);return B},B.flushPendingDeletes=cB,B.setDelayFunction=function(A){FB=A,UB.length&&FB&&FB(cB)},MB=B.UnboundTypeError=PA("UnboundTypeError"),B.count_emval_handles=function(){for(var A=0,B=5;B<rB.length;++B)void 0!==rB[B]&&++A;return A},B.get_first_emval=function(){for(var A=5;A<rB.length;++A)if(void 0!==rB[A])return rB[A];return null};var PB="function"==typeof atob?atob:function(A){var B="",Q=0;A=A.replace(/[^A-Za-z0-9\+\/=]/g,"");do{var I="ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=".indexOf(A.charAt(Q++)),g="ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=".indexOf(A.charAt(Q++)),E="ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=".indexOf(A.charAt(Q++)),C="ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=".indexOf(A.charAt(Q++));I=I<<2|g>>4,g=(15&g)<<4|E>>2;var D=(3&E)<<6|C;B+=String.fromCharCode(I),64!==E&&(B+=String.fromCharCode(g)),64!==C&&(B+=String.fromCharCode(D))}while(Q<A.length);return B};function _B(A){if(UA(A,HA)){if(A=A.slice(HA.length),"boolean"==typeof y&&y){try{var B=Buffer.from(A,"base64")}catch(Q){B=new Buffer(A,"base64")}var Q=new Uint8Array(B.buffer,B.byteOffset,B.byteLength)}else try{var I=PB(A),g=new Uint8Array(I.length);for(B=0;B<I.length;++B)g[B]=I.charCodeAt(B);Q=g}catch(A){throw Error("Converting base64 string to bytes failed.")}return Q}}var $B={__assert_fail:function(A,B,Q,I){FA("Assertion failed: "+J(A)+", at: "+[B?J(B):"unknown filename",Q,I?J(I):"unknown function"])},__cxa_allocate_exception:function(A){return QQ(A)},__cxa_atexit:function(A,B){_.unshift({ob:A,ua:B})},__cxa_begin_catch:function(A){var B=YA[A];return B&&!B.fb&&(B.fb=!0,CQ.ab--),B&&(B.Ea=!1),sA.push(A),(B=LA(A))&&YA[B].ra++,A},__cxa_end_catch:function(){EQ(0);var A=sA.pop();if(A){if(A=LA(A)){var Q=YA[A];Q.ra--,0!==Q.ra||Q.Ea||(Q.ja&&B.dynCall_ii(Q.ja,A),delete YA[A],hA(A))}RA=0}},__cxa_find_matching_catch_2:function(){var A=RA;if(!A)return L=0;var B=YA[A],Q=B.type;if(!Q)return L=0,0|A;var I=Array.prototype.slice.call(arguments);iQ(Q),l[22792]=A,A=91168;for(var g=0;g<I.length;g++)if(I[g]&&DQ(I[g],Q,A))return A=l[A>>2],B.ha.push(A),L=I[g],0|A;return A=l[A>>2],L=Q,0|A},__cxa_find_matching_catch_3:function(){var A=RA;if(!A)return L=0;var B=YA[A],Q=B.type;if(!Q)return L=0,0|A;var I=Array.prototype.slice.call(arguments);iQ(Q),l[22792]=A,A=91168;for(var g=0;g<I.length;g++)if(I[g]&&DQ(I[g],Q,A))return A=l[A>>2],B.ha.push(A),L=I[g],0|A;return A=l[A>>2],L=Q,0|A},__cxa_find_matching_catch_4:function(){var A=RA;if(!A)return L=0;var B=YA[A],Q=B.type;if(!Q)return L=0,0|A;var I=Array.prototype.slice.call(arguments);iQ(Q),l[22792]=A,A=91168;for(var g=0;g<I.length;g++)if(I[g]&&DQ(I[g],Q,A))return A=l[A>>2],B.ha.push(A),L=I[g],0|A;return A=l[A>>2],L=Q,0|A},__cxa_find_matching_catch_5:function(){var A=RA;if(!A)return L=0;var B=YA[A],Q=B.type;if(!Q)return L=0,0|A;var I=Array.prototype.slice.call(arguments);iQ(Q),l[22792]=A,A=91168;for(var g=0;g<I.length;g++)if(I[g]&&DQ(I[g],Q,A))return A=l[A>>2],B.ha.push(A),L=I[g],0|A;return A=l[A>>2],L=Q,0|A},__cxa_free_exception:hA,__cxa_get_exception_ptr:function(A){return A},__cxa_rethrow:function(){var A=sA.pop();throw A=LA(A),YA[A].Ea||(sA.push(A),YA[A].Ea=!0),RA=A,A},__cxa_throw:function(A,B,Q){throw YA[A]={j:A,ha:[A],type:B,ja:Q,ra:0,fb:!1,Ea:!1},RA=A,"uncaught_exception"in CQ?CQ.ab++:CQ.ab=1,A},__cxa_uncaught_exceptions:function(){return CQ.ab},__map_file:function(){return kA(63),-1},__resumeException:function(A){throw RA||(RA=A),A},__sys_fcntl64:function(A,B,Q){pA=Q;try{var I=uA(A);switch(B){case 0:var g=qA();return 0>g?-28:fA.open(I.path,I.flags,0,g).fd;case 1:case 2:return 0;case 3:return I.flags;case 4:return g=qA(),I.flags|=g,0;case 12:return g=qA(),r[g+0>>1]=2,0;case 13:case 14:return 0;case 16:case 8:return-28;case 9:return kA(28),-1;default:return-28}}catch(A){return void 0!==fA&&A instanceof fA.b||FA(A),-A.B}},__sys_ioctl:function(A,B,Q){pA=Q;try{var I=uA(A);switch(B){case 21509:case 21505:return I.tty?0:-59;case 21510:case 21511:case 21512:case 21506:case 21507:case 21508:return I.tty?0:-59;case 21519:if(!I.tty)return-59;var g=qA();return l[g>>2]=0;case 21520:return I.tty?-28:-59;case 21531:return g=qA(),fA.Ra(I,B,g);case 21523:case 21524:return I.tty?0:-59;default:FA("bad ioctl syscall "+B)}}catch(A){return void 0!==fA&&A instanceof fA.b||FA(A),-A.B}},__sys_munmap:function(A,B){try{if(-1==(0|A)||0===B)var Q=-28;else{var I=bA[A];if(I&&B===I.Lc){var g=fA.ba(I.fd);if(2&I.Sc){var E=I.flags,C=I.offset,D=d.slice(A,A+B);fA.da(g,D,C,B,E)}bA[A]=null,I.Gb&&IQ(I.Nc)}Q=0}return Q}catch(A){return void 0!==fA&&A instanceof fA.b||FA(A),-A.B}},__sys_open:function(A,B,Q){pA=Q;try{var I=J(A),g=qA();return fA.open(I,B,g).fd}catch(A){return void 0!==fA&&A instanceof fA.b||FA(A),-A.B}},__sys_stat64:function(A,B){try{A=J(A);A:{var Q=fA.stat;try{var I=Q(A)}catch(B){if(B&&B.node&&SA(A)!==SA(fA.I(B.node))){var g=-54;break A}throw B}l[B>>2]=I.dev,l[B+4>>2]=0,l[B+8>>2]=I.ino,l[B+12>>2]=I.mode,l[B+16>>2]=I.nlink,l[B+20>>2]=I.uid,l[B+24>>2]=I.gid,l[B+28>>2]=I.rdev,l[B+32>>2]=0,NA=[I.size>>>0,(cA=I.size,1<=+BA(cA)?0<cA?(0|gA(+IA(cA/4294967296),4294967295))>>>0:~~+QA((cA-+(~~cA>>>0))/4294967296)>>>0:0)],l[B+40>>2]=NA[0],l[B+44>>2]=NA[1],l[B+48>>2]=4096,l[B+52>>2]=I.blocks,l[B+56>>2]=I.atime.getTime()/1e3|0,l[B+60>>2]=0,l[B+64>>2]=I.mtime.getTime()/1e3|0,l[B+68>>2]=0,l[B+72>>2]=I.ctime.getTime()/1e3|0,l[B+76>>2]=0,NA=[I.ino>>>0,(cA=I.ino,1<=+BA(cA)?0<cA?(0|gA(+IA(cA/4294967296),4294967295))>>>0:~~+QA((cA-+(~~cA>>>0))/4294967296)>>>0:0)],l[B+80>>2]=NA[0],l[B+84>>2]=NA[1],g=0}return g}catch(A){return void 0!==fA&&A instanceof fA.b||FA(A),-A.B}},_embind_register_bool:function(A,B,Q,I,g){var E=OA(Q);IB(A,{name:B=WA(B),fromWireType:function(A){return!!A},toWireType:function(A,B){return B?I:g},argPackAdvance:8,readValueFromPointer:function(A){if(1===Q)var I=n;else if(2===Q)I=r;else{if(4!==Q)throw new TypeError("Unknown boolean type size: "+B);I=l}return this.fromWireType(I[A>>E])},O:null})},_embind_register_class:function(A,Q,I,g,E,C,D,i,y,F,U,c,N){U=WA(U),C=SB(E,C),i&&(i=SB(D,i)),F&&(F=SB(y,F)),N=SB(c,N);var H=vA(U);!function(A,Q){B.hasOwnProperty(A)?($A("Cannot register public name '"+A+"' twice"),GB(B,A,A),B.hasOwnProperty(void 0)&&$A("Cannot register multiple overloads of a function with the same number of arguments (undefined)!"),B[A].N[void 0]=Q):B[A]=Q}(H,(function(){VB("Cannot construct "+U+" due to unbound types",[g])})),QB([A,Q,I],g?[g]:[],(function(Q){if(Q=Q[0],g)var I=Q.i,E=I.U;else E=NB.prototype;Q=TA(H,(function(){if(Object.getPrototypeOf(this)!==D)throw new _A("Use 'new' to construct "+U);if(void 0===y.V)throw new _A(U+" has no accessible constructor");var A=y.V[arguments.length];if(void 0===A)throw new _A("Tried to invoke ctor of "+U+" with invalid number of parameters ("+arguments.length+") - expected ("+Object.keys(y.V).toString()+") parameters instead!");return A.apply(this,arguments)}));var D=Object.create(E,{constructor:{value:Q}});Q.prototype=D;var y=new oB(U,Q,D,N,I,C,i,F);I=new aB(U,y,!0,!1),E=new aB(U+"*",y,!1,!1);var c=new aB(U+" const*",y,!1,!0);return HB[A]={pointerType:E,Mb:c},function(A,Q){B.hasOwnProperty(A)||BB("Replacing nonexistant public symbol"),B[A]=Q,B[A].va=void 0}(H,Q),[I,E,c]}))},_embind_register_class_constructor:function(A,B,Q,I,g,E){a(0<B);var C=KB(B,Q);g=SB(I,g);var D=[E],i=[];QB([],[A],(function(A){var Q="constructor "+(A=A[0]).name;if(void 0===A.i.V&&(A.i.V=[]),void 0!==A.i.V[B-1])throw new _A("Cannot register multiple constructors with identical number of parameters ("+(B-1)+") for class '"+A.name+"'! Overload resolution is currently only performed using the parameter count, not actual type info!");return A.i.V[B-1]=function(){VB("Cannot construct "+A.name+" due to unbound types",C)},QB([],C,(function(I){return A.i.V[B-1]=function(){arguments.length!==B-1&&$A(Q+" called with "+arguments.length+" arguments, expected "+(B-1)),i.length=0,D.length=B;for(var A=1;A<B;++A)D[A]=I[A].toWireType(i,arguments[A-1]);return A=g.apply(null,D),tB(i),I[0].fromWireType(A)},[]})),[]}))},_embind_register_class_function:function(A,B,Q,I,g,E,C,D){var i=KB(Q,I);B=WA(B),E=SB(g,E),QB([],[A],(function(A){function I(){VB("Cannot call "+g+" due to unbound types",i)}var g=(A=A[0]).name+"."+B;D&&A.i.lc.push(B);var y=A.i.U,F=y[B];return void 0===F||void 0===F.N&&F.className!==A.name&&F.va===Q-2?(I.va=Q-2,I.className=A.name,y[B]=I):(GB(y,B,g),y[B].N[Q-2]=I),QB([],i,(function(I){var D=g,i=A,F=E,U=I.length;2>U&&$A("argTypes array size mismatch! Must at least get return value and 'this' types!");var c=null!==I[1]&&null!==i,N=!1;for(i=1;i<I.length;++i)if(null!==I[i]&&void 0===I[i].O){N=!0;break}var H="void"!==I[0].name,G="",o="";for(i=0;i<U-2;++i)G+=(0!==i?", ":"")+"arg"+i,o+=(0!==i?", ":"")+"arg"+i+"Wired";D="return function "+vA(D)+"("+G+") {\nif (arguments.length !== "+(U-2)+") {\nthrowBindingError('function "+D+" called with ' + arguments.length + ' arguments, expected "+(U-2)+" args!');\n}\n",N&&(D+="var destructors = [];\n");var w=N?"destructors":"null";for(G="throwBindingError invoker fn runDestructors retType classParam".split(" "),F=[$A,F,C,tB,I[0],I[1]],c&&(D+="var thisWired = classParam.toWireType("+w+", this);\n"),i=0;i<U-2;++i)D+="var arg"+i+"Wired = argType"+i+".toWireType("+w+", arg"+i+"); // "+I[i+2].name+"\n",G.push("argType"+i),F.push(I[i+2]);if(c&&(o="thisWired"+(0<o.length?", ":"")+o),D+=(H?"var rv = ":"")+"invoker(fn"+(0<o.length?", ":"")+o+");\n",N)D+="runDestructors(destructors);\n";else for(i=c?1:2;i<I.length;++i)U=1===i?"thisWired":"arg"+(i-2)+"Wired",null!==I[i].O&&(D+=U+"_dtor("+U+"); // "+I[i].name+"\n",G.push(U+"_dtor"),F.push(I[i].O));return H&&(D+="var ret = retType.fromWireType(rv);\nreturn ret;\n"),G.push(D+"}\n"),I=function(A){var B=Function;if(!(B instanceof Function))throw new TypeError("new_ called with constructor type "+typeof B+" which is not a function");var Q=TA(B.name||"unknownFunctionName",(function(){}));return Q.prototype=B.prototype,Q=new Q,(A=B.apply(Q,A))instanceof Object?A:Q}(G).apply(null,F),void 0===y[B].N?(I.va=Q-2,y[B]=I):y[B].N[Q-2]=I,[]})),[]}))},_embind_register_class_property:function(A,B,Q,I,g,E,C,D,i,y){B=WA(B),g=SB(I,g),QB([],[A],(function(A){var I=(A=A[0]).name+"."+B,F={get:function(){VB("Cannot access "+I+" due to unbound types",[Q,C])},enumerable:!0,configurable:!0};return F.set=i?function(){VB("Cannot access "+I+" due to unbound types",[Q,C])}:function(){$A(I+" is a read-only property")},Object.defineProperty(A.i.U,B,F),QB([],i?[Q,C]:[Q],(function(Q){var C=Q[0],F={get:function(){var B=nB(this,A,I+" getter");return C.fromWireType(g(E,B))},enumerable:!0};if(i){i=SB(D,i);var U=Q[1];F.set=function(B){var Q=nB(this,A,I+" setter"),g=[];i(y,Q,U.toWireType(g,B)),tB(g)}}return Object.defineProperty(A.i.U,B,F),[]})),[]}))},_embind_register_emval:function(A,B){IB(A,{name:B=WA(B),fromWireType:function(A){var B=rB[A].value;return 4<A&&0==--rB[A].ra&&(rB[A]=void 0,dB.push(A)),B},toWireType:function(A,B){return eB(B)},argPackAdvance:8,readValueFromPointer:RB,O:null})},_embind_register_float:function(A,B,Q){Q=OA(Q),IB(A,{name:B=WA(B),fromWireType:function(A){return A},toWireType:function(A,B){if("number"!=typeof B&&"boolean"!=typeof B)throw new TypeError('Cannot convert "'+lB(B)+'" to '+this.name);return B},argPackAdvance:8,readValueFromPointer:xB(B,Q),O:null})},_embind_register_integer:function(A,B,Q,I,g){function E(A){return A}B=WA(B),-1===g&&(g=4294967295);var C=OA(Q);if(0===I){var D=32-8*Q;E=function(A){return A<<D>>>D}}var i=-1!=B.indexOf("unsigned");IB(A,{name:B,fromWireType:E,toWireType:function(A,Q){if("number"!=typeof Q&&"boolean"!=typeof Q)throw new TypeError('Cannot convert "'+lB(Q)+'" to '+this.name);if(Q<I||Q>g)throw new TypeError('Passing a number "'+lB(Q)+'" from JS side to C/C++ side to an argument of type "'+B+'", which is outside the valid range ['+I+", "+g+"]!");return i?Q>>>0:0|Q},argPackAdvance:8,readValueFromPointer:ZB(B,C,0!==I),O:null})},_embind_register_memory_view:function(A,B,Q){function I(A){var B=x;return new g(t,B[1+(A>>=2)],B[A])}var g=[Int8Array,Uint8Array,Int16Array,Uint16Array,Int32Array,Uint32Array,Float32Array,Float64Array][B];IB(A,{name:Q=WA(Q),fromWireType:I,argPackAdvance:8,readValueFromPointer:I},{Zb:!0})},_embind_register_std_string:function(A,B){var Q="std::string"===(B=WA(B));IB(A,{name:B,fromWireType:function(A){var B=x[A>>2];if(Q){var I=d[A+4+B],g=0;0!=I&&(g=I,d[A+4+B]=0);var E=A+4;for(I=0;I<=B;++I){var C=A+4+I;if(0==d[C]){if(E=J(E),void 0===D)var D=E;else D+=String.fromCharCode(0),D+=E;E=C+1}}0!=g&&(d[A+4+B]=g)}else{for(D=Array(B),I=0;I<B;++I)D[I]=String.fromCharCode(d[A+4+I]);D=D.join("")}return IQ(A),D},toWireType:function(A,B){B instanceof ArrayBuffer&&(B=new Uint8Array(B));var I="string"==typeof B;I||B instanceof Uint8Array||B instanceof Uint8ClampedArray||B instanceof Int8Array||$A("Cannot pass non-string to std::string");var g=(Q&&I?function(){return K(B)}:function(){return B.length})(),E=QQ(4+g+1);if(x[E>>2]=g,Q&&I)V(B,d,E+4,g+1);else if(I)for(I=0;I<g;++I){var C=B.charCodeAt(I);255<C&&(IQ(E),$A("String has UTF-16 code units that do not fit in 8 bits")),d[E+4+I]=C}else for(I=0;I<g;++I)d[E+4+I]=B[I];return null!==A&&A.push(IQ,E),E},argPackAdvance:8,readValueFromPointer:RB,O:function(A){IQ(A)}})},_embind_register_std_wstring:function(A,B,Q){if(Q=WA(Q),2===B)var I=p,g=q,E=u,C=function(){return e},D=1;else 4===B&&(I=O,g=m,E=W,C=function(){return x},D=2);IB(A,{name:Q,fromWireType:function(A){var Q=x[A>>2],g=C(),E=g[A+4+Q*B>>D],i=0;0!=E&&(i=E,g[A+4+Q*B>>D]=0);var y=A+4;for(E=0;E<=Q;++E){var F=A+4+E*B;if(0==g[F>>D]){if(y=I(y),void 0===U)var U=y;else U+=String.fromCharCode(0),U+=y;y=F+B}}return 0!=i&&(g[A+4+Q*B>>D]=i),IQ(A),U},toWireType:function(A,I){"string"!=typeof I&&$A("Cannot pass non-string to C++ string type "+Q);var C=E(I),i=QQ(4+C+B);return x[i>>2]=C>>D,g(I,i+4,C+B),null!==A&&A.push(IQ,i),i},argPackAdvance:8,readValueFromPointer:RB,O:function(A){IQ(A)}})},_embind_register_void:function(A,B){IB(A,{Jc:!0,name:B=WA(B),argPackAdvance:0,fromWireType:function(){},toWireType:function(){}})},abort:function(){FA()},emscripten_get_sbrk_ptr:function(){return 91008},emscripten_memcpy_big:function(A,B,Q){d.copyWithin(A,B,B+Q)},emscripten_resize_heap:function(A){A>>>=0;var B=d.length;if(2147483648<A)return!1;for(var Q=1;4>=Q;Q*=2){var I=B*(1+.2/Q);I=Math.min(I,A+100663296),0<(I=Math.max(16777216,A,I))%65536&&(I+=65536-I%65536);A:{try{R.grow(Math.min(2147483648,I)-t.byteLength+65535>>>16),X(R.buffer);var g=1;break A}catch(A){}g=void 0}if(g)return!0}return!1},environ_get:function(A,B){var Q=0;return pB().forEach((function(I,g){var E=B+Q;for(g=l[A+4*g>>2]=E,E=0;E<I.length;++E)n[g++>>0]=I.charCodeAt(E);n[g>>0]=0,Q+=I.length+1})),0},environ_sizes_get:function(A,B){var Q=pB();l[A>>2]=Q.length;var I=0;return Q.forEach((function(A){I+=A.length+1})),l[B>>2]=I,0},fd_close:function(A){try{var B=uA(A);return fA.close(B),0}catch(A){return void 0!==fA&&A instanceof fA.b||FA(A),A.B}},fd_read:function(A,B,Q,I){try{A:{for(var g=uA(A),E=A=0;E<Q;E++){var C=l[B+(8*E+4)>>2],D=fA.read(g,n,l[B+8*E>>2],C,void 0);if(0>D){var i=-1;break A}if(A+=D,D<C)break}i=A}return l[I>>2]=i,0}catch(A){return void 0!==fA&&A instanceof fA.b||FA(A),A.B}},fd_seek:function(A,B,Q,I,g){try{var E=uA(A);return-9007199254740992>=(A=4294967296*Q+(B>>>0))||9007199254740992<=A?-61:(fA.K(E,A,I),NA=[E.position>>>0,(cA=E.position,1<=+BA(cA)?0<cA?(0|gA(+IA(cA/4294967296),4294967295))>>>0:~~+QA((cA-+(~~cA>>>0))/4294967296)>>>0:0)],l[g>>2]=NA[0],l[g+4>>2]=NA[1],E.Oa&&0===A&&0===I&&(E.Oa=null),0)}catch(A){return void 0!==fA&&A instanceof fA.b||FA(A),A.B}},fd_write:function(A,B,Q,I){try{A:{for(var g=uA(A),E=A=0;E<Q;E++){var C=fA.write(g,n,l[B+8*E>>2],l[B+(8*E+4)>>2],void 0);if(0>C){var D=-1;break A}A+=C}D=A}return l[I>>2]=D,0}catch(A){return void 0!==fA&&A instanceof fA.b||FA(A),A.B}},getTempRet0:function(){return 0|L},gettimeofday:function(A){var B=Date.now();return l[A>>2]=B/1e3|0,l[A+4>>2]=B%1e3*1e3|0,0},invoke_diii:function(A,B,Q,I){var g=uQ();try{return qQ(A,B,Q,I)}catch(A){if(mQ(g),A!==A+0&&"longjmp"!==A)throw A;EQ(1,0)}},invoke_fiii:function(A,B,Q,I){var g=uQ();try{return pQ(A,B,Q,I)}catch(A){if(mQ(g),A!==A+0&&"longjmp"!==A)throw A;EQ(1,0)}},invoke_i:function(A){var B=uQ();try{return hQ(A)}catch(A){if(mQ(B),A!==A+0&&"longjmp"!==A)throw A;EQ(1,0)}},invoke_ii:function(A,B){var Q=uQ();try{return kQ(A,B)}catch(A){if(mQ(Q),A!==A+0&&"longjmp"!==A)throw A;EQ(1,0)}},invoke_iif:function(A,B,Q){var I=uQ();try{return ZQ(A,B,Q)}catch(A){if(mQ(I),A!==A+0&&"longjmp"!==A)throw A;EQ(1,0)}},invoke_iii:function(A,B,Q){var I=uQ();try{return aQ(A,B,Q)}catch(A){if(mQ(I),A!==A+0&&"longjmp"!==A)throw A;EQ(1,0)}},invoke_iiii:function(A,B,Q,I){var g=uQ();try{return SQ(A,B,Q,I)}catch(A){if(mQ(g),A!==A+0&&"longjmp"!==A)throw A;EQ(1,0)}},invoke_iiiii:function(A,B,Q,I,g){var E=uQ();try{return MQ(A,B,Q,I,g)}catch(A){if(mQ(E),A!==A+0&&"longjmp"!==A)throw A;EQ(1,0)}},invoke_iiiiid:function(A,B,Q,I,g,E){var C=uQ();try{return eQ(A,B,Q,I,g,E)}catch(A){if(mQ(C),A!==A+0&&"longjmp"!==A)throw A;EQ(1,0)}},invoke_iiiiii:function(A,B,Q,I,g,E){var C=uQ();try{return JQ(A,B,Q,I,g,E)}catch(A){if(mQ(C),A!==A+0&&"longjmp"!==A)throw A;EQ(1,0)}},invoke_iiiiiii:function(A,B,Q,I,g,E,C){var D=uQ();try{return VQ(A,B,Q,I,g,E,C)}catch(A){if(mQ(D),A!==A+0&&"longjmp"!==A)throw A;EQ(1,0)}},invoke_iiiiiiii:function(A,B,Q,I,g,E,C,D){var i=uQ();try{return KQ(A,B,Q,I,g,E,C,D)}catch(A){if(mQ(i),A!==A+0&&"longjmp"!==A)throw A;EQ(1,0)}},invoke_iiiiiiiiiii:function(A,B,Q,I,g,E,C,D,i,y,F){var U=uQ();try{return tQ(A,B,Q,I,g,E,C,D,i,y,F)}catch(A){if(mQ(U),A!==A+0&&"longjmp"!==A)throw A;EQ(1,0)}},invoke_iiiiiiiiiiii:function(A,B,Q,I,g,E,C,D,i,y,F,U){var c=uQ();try{return nQ(A,B,Q,I,g,E,C,D,i,y,F,U)}catch(A){if(mQ(c),A!==A+0&&"longjmp"!==A)throw A;EQ(1,0)}},invoke_iiiiiiiiiiiii:function(A,B,Q,I,g,E,C,D,i,y,F,U,c){var N=uQ();try{return dQ(A,B,Q,I,g,E,C,D,i,y,F,U,c)}catch(A){if(mQ(N),A!==A+0&&"longjmp"!==A)throw A;EQ(1,0)}},invoke_iiiiij:function(A,B,Q,I,g,E,C){var D=uQ();try{return rQ(A,B,Q,I,g,E,C)}catch(A){if(mQ(D),A!==A+0&&"longjmp"!==A)throw A;EQ(1,0)}},invoke_iiijiiiiii:function(A,B,Q,I,g,E,C,D,i,y,F){var U=uQ();try{return lQ(A,B,Q,I,g,E,C,D,i,y,F)}catch(A){if(mQ(U),A!==A+0&&"longjmp"!==A)throw A;EQ(1,0)}},invoke_iij:function(A,B,Q,I){var g=uQ();try{return xQ(A,B,Q,I)}catch(A){if(mQ(g),A!==A+0&&"longjmp"!==A)throw A;EQ(1,0)}},invoke_jii:function(A,B,Q){var I=uQ();try{return fQ(A,B,Q)}catch(A){if(mQ(I),A!==A+0&&"longjmp"!==A)throw A;EQ(1,0)}},invoke_jiiii:function(A,B,Q,I,g){var E=uQ();try{return bQ(A,B,Q,I,g)}catch(A){if(mQ(E),A!==A+0&&"longjmp"!==A)throw A;EQ(1,0)}},invoke_v:function(A){var B=uQ();try{FQ(A)}catch(A){if(mQ(B),A!==A+0&&"longjmp"!==A)throw A;EQ(1,0)}},invoke_vi:function(A,B){var Q=uQ();try{UQ(A,B)}catch(A){if(mQ(Q),A!==A+0&&"longjmp"!==A)throw A;EQ(1,0)}},invoke_vii:function(A,B,Q){var I=uQ();try{cQ(A,B,Q)}catch(A){if(mQ(I),A!==A+0&&"longjmp"!==A)throw A;EQ(1,0)}},invoke_viii:function(A,B,Q,I){var g=uQ();try{NQ(A,B,Q,I)}catch(A){if(mQ(g),A!==A+0&&"longjmp"!==A)throw A;EQ(1,0)}},invoke_viiii:function(A,B,Q,I,g){var E=uQ();try{HQ(A,B,Q,I,g)}catch(A){if(mQ(E),A!==A+0&&"longjmp"!==A)throw A;EQ(1,0)}},invoke_viiiii:function(A,B,Q,I,g,E){var C=uQ();try{GQ(A,B,Q,I,g,E)}catch(A){if(mQ(C),A!==A+0&&"longjmp"!==A)throw A;EQ(1,0)}},invoke_viiiiiii:function(A,B,Q,I,g,E,C,D){var i=uQ();try{oQ(A,B,Q,I,g,E,C,D)}catch(A){if(mQ(i),A!==A+0&&"longjmp"!==A)throw A;EQ(1,0)}},invoke_viiiiiiiiii:function(A,B,Q,I,g,E,C,D,i,y,F){var U=uQ();try{wQ(A,B,Q,I,g,E,C,D,i,y,F)}catch(A){if(mQ(U),A!==A+0&&"longjmp"!==A)throw A;EQ(1,0)}},invoke_viiiiiiiiiiiiiii:function(A,B,Q,I,g,E,C,D,i,y,F,U,c,N,H,G){var o=uQ();try{YQ(A,B,Q,I,g,E,C,D,i,y,F,U,c,N,H,G)}catch(A){if(mQ(o),A!==A+0&&"longjmp"!==A)throw A;EQ(1,0)}},invoke_viiiijji:function(A,B,Q,I,g,E,C,D,i,y){var F=uQ();try{sQ(A,B,Q,I,g,E,C,D,i,y)}catch(A){if(mQ(F),A!==A+0&&"longjmp"!==A)throw A;EQ(1,0)}},invoke_viijii:function(A,B,Q,I,g,E,C){var D=uQ();try{LQ(A,B,Q,I,g,E,C)}catch(A){if(mQ(D),A!==A+0&&"longjmp"!==A)throw A;EQ(1,0)}},invoke_viji:function(A,B,Q,I,g){var E=uQ();try{RQ(A,B,Q,I,g)}catch(A){if(mQ(E),A!==A+0&&"longjmp"!==A)throw A;EQ(1,0)}},llvm_eh_typeid_for:function(A){return A},memory:R,setTempRet0:function(A){L=0|A},strftime_l:function(A,B,Q,I){return function(A,B,Q,I){function g(A,B,Q){for(A="number"==typeof A?A.toString():A||"";A.length<B;)A=Q[0]+A;return A}function E(A,B){return g(A,B,"0")}function C(A,B){function Q(A){return 0>A?-1:0<A?1:0}var I;return 0===(I=Q(A.getFullYear()-B.getFullYear()))&&0===(I=Q(A.getMonth()-B.getMonth()))&&(I=Q(A.getDate()-B.getDate())),I}function D(A){switch(A.getDay()){case 0:return new Date(A.getFullYear()-1,11,29);case 1:return A;case 2:return new Date(A.getFullYear(),0,3);case 3:return new Date(A.getFullYear(),0,2);case 4:return new Date(A.getFullYear(),0,1);case 5:return new Date(A.getFullYear()-1,11,31);case 6:return new Date(A.getFullYear()-1,11,30)}}function i(A){A=WB(new Date(A.C+1900,0,1),A.Ia);var B=new Date(A.getFullYear()+1,0,4),Q=D(new Date(A.getFullYear(),0,4));return B=D(B),0>=C(Q,A)?0>=C(B,A)?A.getFullYear()+1:A.getFullYear():A.getFullYear()-1}var y=l[I+40>>2];for(var F in I={uc:l[I>>2],tc:l[I+4>>2],Ga:l[I+8>>2],sa:l[I+12>>2],fa:l[I+16>>2],C:l[I+20>>2],Ha:l[I+24>>2],Ia:l[I+28>>2],Vc:l[I+32>>2],sc:l[I+36>>2],vc:y?J(y):""},Q=J(Q),y={"%c":"%a %b %d %H:%M:%S %Y","%D":"%m/%d/%y","%F":"%Y-%m-%d","%h":"%b","%r":"%I:%M:%S %p","%R":"%H:%M","%T":"%H:%M:%S","%x":"%m/%d/%y","%X":"%H:%M:%S","%Ec":"%c","%EC":"%C","%Ex":"%m/%d/%y","%EX":"%H:%M:%S","%Ey":"%y","%EY":"%Y","%Od":"%d","%Oe":"%e","%OH":"%H","%OI":"%I","%Om":"%m","%OM":"%M","%OS":"%S","%Ou":"%u","%OU":"%U","%OV":"%V","%Ow":"%w","%OW":"%W","%Oy":"%y"})Q=Q.replace(new RegExp(F,"g"),y[F]);var U="Sunday Monday Tuesday Wednesday Thursday Friday Saturday".split(" "),c="January February March April May June July August September October November December".split(" ");for(F in y={"%a":function(A){return U[A.Ha].substring(0,3)},"%A":function(A){return U[A.Ha]},"%b":function(A){return c[A.fa].substring(0,3)},"%B":function(A){return c[A.fa]},"%C":function(A){return E((A.C+1900)/100|0,2)},"%d":function(A){return E(A.sa,2)},"%e":function(A){return g(A.sa,2," ")},"%g":function(A){return i(A).toString().substring(2)},"%G":function(A){return i(A)},"%H":function(A){return E(A.Ga,2)},"%I":function(A){return 0==(A=A.Ga)?A=12:12<A&&(A-=12),E(A,2)},"%j":function(A){return E(A.sa+uB(qB(A.C+1900)?OB:mB,A.fa-1),3)},"%m":function(A){return E(A.fa+1,2)},"%M":function(A){return E(A.tc,2)},"%n":function(){return"\n"},"%p":function(A){return 0<=A.Ga&&12>A.Ga?"AM":"PM"},"%S":function(A){return E(A.uc,2)},"%t":function(){return"\t"},"%u":function(A){return A.Ha||7},"%U":function(A){var B=new Date(A.C+1900,0,1),Q=0===B.getDay()?B:WB(B,7-B.getDay());return 0>C(Q,A=new Date(A.C+1900,A.fa,A.sa))?E(Math.ceil((31-Q.getDate()+(uB(qB(A.getFullYear())?OB:mB,A.getMonth()-1)-31)+A.getDate())/7),2):0===C(Q,B)?"01":"00"},"%V":function(A){var B=new Date(A.C+1901,0,4),Q=D(new Date(A.C+1900,0,4));B=D(B);var I=WB(new Date(A.C+1900,0,1),A.Ia);return 0>C(I,Q)?"53":0>=C(B,I)?"01":E(Math.ceil((Q.getFullYear()<A.C+1900?A.Ia+32-Q.getDate():A.Ia+1-Q.getDate())/7),2)},"%w":function(A){return A.Ha},"%W":function(A){var B=new Date(A.C,0,1),Q=1===B.getDay()?B:WB(B,0===B.getDay()?1:7-B.getDay()+1);return 0>C(Q,A=new Date(A.C+1900,A.fa,A.sa))?E(Math.ceil((31-Q.getDate()+(uB(qB(A.getFullYear())?OB:mB,A.getMonth()-1)-31)+A.getDate())/7),2):0===C(Q,B)?"01":"00"},"%y":function(A){return(A.C+1900).toString().substring(2)},"%Y":function(A){return A.C+1900},"%z":function(A){var B=0<=(A=A.sc);return A=Math.abs(A)/60,(B?"+":"-")+String("0000"+(A/60*100+A%60)).slice(-4)},"%Z":function(A){return A.vc},"%%":function(){return"%"}})0<=Q.indexOf(F)&&(Q=Q.replace(new RegExp(F,"g"),y[F](I)));return(F=vB(Q,!1)).length>B?0:(n.set(F,A),F.length-1)}(A,B,Q,I)},table:h},AQ=function(){function A(A){B.asm=A.exports,yA()}function Q(B){A(B.instance)}function I(A){return(s||!D&&!i||"function"!=typeof fetch||UA(GA,"file://")?new Promise((function(A){A(wA())})):fetch(GA,{credentials:"same-origin"}).then((function(A){if(!A.ok)throw"failed to load wasm binary file at '"+GA+"'";return A.arrayBuffer()})).catch((function(){return wA()}))).then((function(A){return WebAssembly.instantiate(A,g)})).then(A,(function(A){Y("failed to asynchronously prepare wasm: "+A),FA(A)}))}var g={env:$B,wasi_snapshot_preview1:$B};if(iA(),B.instantiateWasm)try{return B.instantiateWasm(g,A)}catch(A){return Y("Module.instantiateWasm callback failed with error: "+A),!1}return function(){if(s||"function"!=typeof WebAssembly.instantiateStreaming||UA(GA,HA)||UA(GA,"file://")||"function"!=typeof fetch)return I(Q);fetch(GA,{credentials:"same-origin"}).then((function(A){return WebAssembly.instantiateStreaming(A,g).then(Q,(function(A){Y("wasm streaming compile failed: "+A),Y("falling back to ArrayBuffer instantiation"),I(Q)}))}))}(),{}}();B.asm=AQ;var BQ=B.___wasm_call_ctors=function(){return(BQ=B.___wasm_call_ctors=B.asm.__wasm_call_ctors).apply(null,arguments)},QQ=B._malloc=function(){return(QQ=B._malloc=B.asm.malloc).apply(null,arguments)},IQ=B._free=function(){return(IQ=B._free=B.asm.free).apply(null,arguments)},gQ=B.___errno_location=function(){return(gQ=B.___errno_location=B.asm.__errno_location).apply(null,arguments)},EQ=B._setThrew=function(){return(EQ=B._setThrew=B.asm.setThrew).apply(null,arguments)},CQ=B.__ZSt18uncaught_exceptionv=function(){return(CQ=B.__ZSt18uncaught_exceptionv=B.asm._ZSt18uncaught_exceptionv).apply(null,arguments)},DQ=B.___cxa_can_catch=function(){return(DQ=B.___cxa_can_catch=B.asm.__cxa_can_catch).apply(null,arguments)},iQ=B.___cxa_is_pointer_type=function(){return(iQ=B.___cxa_is_pointer_type=B.asm.__cxa_is_pointer_type).apply(null,arguments)},yQ=B.___getTypeName=function(){return(yQ=B.___getTypeName=B.asm.__getTypeName).apply(null,arguments)};B.___embind_register_native_and_builtin_types=function(){return(B.___embind_register_native_and_builtin_types=B.asm.__embind_register_native_and_builtin_types).apply(null,arguments)};var FQ=B.dynCall_v=function(){return(FQ=B.dynCall_v=B.asm.dynCall_v).apply(null,arguments)},UQ=B.dynCall_vi=function(){return(UQ=B.dynCall_vi=B.asm.dynCall_vi).apply(null,arguments)},cQ=B.dynCall_vii=function(){return(cQ=B.dynCall_vii=B.asm.dynCall_vii).apply(null,arguments)},NQ=B.dynCall_viii=function(){return(NQ=B.dynCall_viii=B.asm.dynCall_viii).apply(null,arguments)},HQ=B.dynCall_viiii=function(){return(HQ=B.dynCall_viiii=B.asm.dynCall_viiii).apply(null,arguments)},GQ=B.dynCall_viiiii=function(){return(GQ=B.dynCall_viiiii=B.asm.dynCall_viiiii).apply(null,arguments)},oQ=B.dynCall_viiiiiii=function(){return(oQ=B.dynCall_viiiiiii=B.asm.dynCall_viiiiiii).apply(null,arguments)},wQ=B.dynCall_viiiiiiiiii=function(){return(wQ=B.dynCall_viiiiiiiiii=B.asm.dynCall_viiiiiiiiii).apply(null,arguments)},YQ=B.dynCall_viiiiiiiiiiiiiii=function(){return(YQ=B.dynCall_viiiiiiiiiiiiiii=B.asm.dynCall_viiiiiiiiiiiiiii).apply(null,arguments)},sQ=B.dynCall_viiiijji=function(){return(sQ=B.dynCall_viiiijji=B.asm.dynCall_viiiijji).apply(null,arguments)},LQ=B.dynCall_viijii=function(){return(LQ=B.dynCall_viijii=B.asm.dynCall_viijii).apply(null,arguments)},RQ=B.dynCall_viji=function(){return(RQ=B.dynCall_viji=B.asm.dynCall_viji).apply(null,arguments)},hQ=B.dynCall_i=function(){return(hQ=B.dynCall_i=B.asm.dynCall_i).apply(null,arguments)},kQ=B.dynCall_ii=function(){return(kQ=B.dynCall_ii=B.asm.dynCall_ii).apply(null,arguments)},aQ=B.dynCall_iii=function(){return(aQ=B.dynCall_iii=B.asm.dynCall_iii).apply(null,arguments)},SQ=B.dynCall_iiii=function(){return(SQ=B.dynCall_iiii=B.asm.dynCall_iiii).apply(null,arguments)},MQ=B.dynCall_iiiii=function(){return(MQ=B.dynCall_iiiii=B.asm.dynCall_iiiii).apply(null,arguments)},JQ=B.dynCall_iiiiii=function(){return(JQ=B.dynCall_iiiiii=B.asm.dynCall_iiiiii).apply(null,arguments)},VQ=B.dynCall_iiiiiii=function(){return(VQ=B.dynCall_iiiiiii=B.asm.dynCall_iiiiiii).apply(null,arguments)},KQ=B.dynCall_iiiiiiii=function(){return(KQ=B.dynCall_iiiiiiii=B.asm.dynCall_iiiiiiii).apply(null,arguments)},tQ=B.dynCall_iiiiiiiiiii=function(){return(tQ=B.dynCall_iiiiiiiiiii=B.asm.dynCall_iiiiiiiiiii).apply(null,arguments)},nQ=B.dynCall_iiiiiiiiiiii=function(){return(nQ=B.dynCall_iiiiiiiiiiii=B.asm.dynCall_iiiiiiiiiiii).apply(null,arguments)},dQ=B.dynCall_iiiiiiiiiiiii=function(){return(dQ=B.dynCall_iiiiiiiiiiiii=B.asm.dynCall_iiiiiiiiiiiii).apply(null,arguments)},rQ=B.dynCall_iiiiij=function(){return(rQ=B.dynCall_iiiiij=B.asm.dynCall_iiiiij).apply(null,arguments)},eQ=B.dynCall_iiiiid=function(){return(eQ=B.dynCall_iiiiid=B.asm.dynCall_iiiiid).apply(null,arguments)},lQ=B.dynCall_iiijiiiiii=function(){return(lQ=B.dynCall_iiijiiiiii=B.asm.dynCall_iiijiiiiii).apply(null,arguments)},xQ=B.dynCall_iij=function(){return(xQ=B.dynCall_iij=B.asm.dynCall_iij).apply(null,arguments)},ZQ=B.dynCall_iif=function(){return(ZQ=B.dynCall_iif=B.asm.dynCall_iif).apply(null,arguments)},fQ=B.dynCall_jii=function(){return(fQ=B.dynCall_jii=B.asm.dynCall_jii).apply(null,arguments)},bQ=B.dynCall_jiiii=function(){return(bQ=B.dynCall_jiiii=B.asm.dynCall_jiiii).apply(null,arguments)},pQ=B.dynCall_fiii=function(){return(pQ=B.dynCall_fiii=B.asm.dynCall_fiii).apply(null,arguments)},qQ=B.dynCall_diii=function(){return(qQ=B.dynCall_diii=B.asm.dynCall_diii).apply(null,arguments)},uQ=B.stackSave=function(){return(uQ=B.stackSave=B.asm.stackSave).apply(null,arguments)};B.stackAlloc=function(){return(B.stackAlloc=B.asm.stackAlloc).apply(null,arguments)};var OQ,mQ=B.stackRestore=function(){return(mQ=B.stackRestore=B.asm.stackRestore).apply(null,arguments)};function WQ(){function A(){if(!OQ&&(OQ=!0,B.calledRun=!0,!k)){if(B.noFSInit||fA.ka.Qa||fA.ka(),z(T),fA.ub=!1,z(P),B.onRuntimeInitialized&&B.onRuntimeInitialized(),B.postRun)for("function"==typeof B.postRun&&(B.postRun=[B.postRun]);B.postRun.length;){var A=B.postRun.shift();$.unshift(A)}z($)}}if(!(0<EA)){if(B.preRun)for("function"==typeof B.preRun&&(B.preRun=[B.preRun]);B.preRun.length;)AA();z(v),0<EA||(B.setStatus?(B.setStatus("Running..."),setTimeout((function(){setTimeout((function(){B.setStatus("")}),1),A()}),1)):A())}}if(B.__growWasmMemory=function(){return(B.__growWasmMemory=B.asm.__growWasmMemory).apply(null,arguments)},B.dynCall_iiijij=function(){return(B.dynCall_iiijij=B.asm.dynCall_iiijij).apply(null,arguments)},B.dynCall_jiji=function(){return(B.dynCall_jiji=B.asm.dynCall_jiji).apply(null,arguments)},B.dynCall_iidiiii=function(){return(B.dynCall_iidiiii=B.asm.dynCall_iidiiii).apply(null,arguments)},B.dynCall_iiiiiiiii=function(){return(B.dynCall_iiiiiiiii=B.asm.dynCall_iiiiiiiii).apply(null,arguments)},B.dynCall_iiiiijj=function(){return(B.dynCall_iiiiijj=B.asm.dynCall_iiiiijj).apply(null,arguments)},B.dynCall_iiiiiijj=function(){return(B.dynCall_iiiiiijj=B.asm.dynCall_iiiiiijj).apply(null,arguments)},B.dynCall_viiiiii=function(){return(B.dynCall_viiiiii=B.asm.dynCall_viiiiii).apply(null,arguments)},B.asm=AQ,B.FS=fA,B.then=function(A){if(OQ)A(B);else{var Q=B.onRuntimeInitialized;B.onRuntimeInitialized=function(){Q&&Q(),A(B)}}return B},DA=function A(){OQ||WQ(),OQ||(DA=A)},B.run=WQ,B.preInit)for("function"==typeof B.preInit&&(B.preInit=[B.preInit]);0<B.preInit.length;)B.preInit.pop()();return WQ(),A});A.exports=E}).call(this,"/index.js","/")},function(A,B,Q){"use strict";Q.r(B),Q.d(B,"createH264MP4Encoder",(function(){return D}));var I=Q(1),g=function(A,B,Q,I){return new(Q||(Q=Promise))((function(g,E){function C(A){try{i(I.next(A))}catch(A){E(A)}}function D(A){try{i(I.throw(A))}catch(A){E(A)}}function i(A){var B;A.done?g(A.value):(B=A.value,B instanceof Q?B:new Q((function(A){A(B)}))).then(C,D)}i((I=I.apply(A,B||[])).next())}))};const E=Q.n(I)()(),C=new Promise(A=>{E.then(()=>{A()})}),D=()=>g(void 0,void 0,void 0,(function*(){yield C;const A=new E.H264MP4Encoder;return A.FS=E.FS,A}))},function(A,B){A.exports=__webpack_require__(/*! fs */ "./node_modules/node-libs-browser/mock/empty.js")},function(A,B){A.exports=__webpack_require__(/*! crypto */ "./node_modules/crypto-browserify/index.js")}]);
//# sourceMappingURL=h264-mp4-encoder.node.js.map
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(/*! ./../../../process/browser.js */ "./node_modules/process/browser.js"), __webpack_require__(/*! ./../../../node-libs-browser/node_modules/buffer/index.js */ "./node_modules/node-libs-browser/node_modules/buffer/index.js").Buffer))

/***/ }),

/***/ "./node_modules/hash-base/index.js":
/*!*****************************************!*\
  !*** ./node_modules/hash-base/index.js ***!
  \*****************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Buffer = __webpack_require__(/*! safe-buffer */ "./node_modules/hash-base/node_modules/safe-buffer/index.js").Buffer
var Transform = __webpack_require__(/*! readable-stream */ "./node_modules/hash-base/node_modules/readable-stream/readable-browser.js").Transform
var inherits = __webpack_require__(/*! inherits */ "./node_modules/inherits/inherits_browser.js")

function throwIfNotStringOrBuffer (val, prefix) {
  if (!Buffer.isBuffer(val) && typeof val !== 'string') {
    throw new TypeError(prefix + ' must be a string or a buffer')
  }
}

function HashBase (blockSize) {
  Transform.call(this)

  this._block = Buffer.allocUnsafe(blockSize)
  this._blockSize = blockSize
  this._blockOffset = 0
  this._length = [0, 0, 0, 0]

  this._finalized = false
}

inherits(HashBase, Transform)

HashBase.prototype._transform = function (chunk, encoding, callback) {
  var error = null
  try {
    this.update(chunk, encoding)
  } catch (err) {
    error = err
  }

  callback(error)
}

HashBase.prototype._flush = function (callback) {
  var error = null
  try {
    this.push(this.digest())
  } catch (err) {
    error = err
  }

  callback(error)
}

HashBase.prototype.update = function (data, encoding) {
  throwIfNotStringOrBuffer(data, 'Data')
  if (this._finalized) throw new Error('Digest already called')
  if (!Buffer.isBuffer(data)) data = Buffer.from(data, encoding)

  // consume data
  var block = this._block
  var offset = 0
  while (this._blockOffset + data.length - offset >= this._blockSize) {
    for (var i = this._blockOffset; i < this._blockSize;) block[i++] = data[offset++]
    this._update()
    this._blockOffset = 0
  }
  while (offset < data.length) block[this._blockOffset++] = data[offset++]

  // update length
  for (var j = 0, carry = data.length * 8; carry > 0; ++j) {
    this._length[j] += carry
    carry = (this._length[j] / 0x0100000000) | 0
    if (carry > 0) this._length[j] -= 0x0100000000 * carry
  }

  return this
}

HashBase.prototype._update = function () {
  throw new Error('_update is not implemented')
}

HashBase.prototype.digest = function (encoding) {
  if (this._finalized) throw new Error('Digest already called')
  this._finalized = true

  var digest = this._digest()
  if (encoding !== undefined) digest = digest.toString(encoding)

  // reset state
  this._block.fill(0)
  this._blockOffset = 0
  for (var i = 0; i < 4; ++i) this._length[i] = 0

  return digest
}

HashBase.prototype._digest = function () {
  throw new Error('_digest is not implemented')
}

module.exports = HashBase


/***/ }),

/***/ "./node_modules/hash-base/node_modules/readable-stream/errors-browser.js":
/*!*******************************************************************************!*\
  !*** ./node_modules/hash-base/node_modules/readable-stream/errors-browser.js ***!
  \*******************************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

var codes = {};

function createErrorType(code, message, Base) {
  if (!Base) {
    Base = Error;
  }

  function getMessage(arg1, arg2, arg3) {
    if (typeof message === 'string') {
      return message;
    } else {
      return message(arg1, arg2, arg3);
    }
  }

  var NodeError =
  /*#__PURE__*/
  function (_Base) {
    _inheritsLoose(NodeError, _Base);

    function NodeError(arg1, arg2, arg3) {
      return _Base.call(this, getMessage(arg1, arg2, arg3)) || this;
    }

    return NodeError;
  }(Base);

  NodeError.prototype.name = Base.name;
  NodeError.prototype.code = code;
  codes[code] = NodeError;
} // https://github.com/nodejs/node/blob/v10.8.0/lib/internal/errors.js


function oneOf(expected, thing) {
  if (Array.isArray(expected)) {
    var len = expected.length;
    expected = expected.map(function (i) {
      return String(i);
    });

    if (len > 2) {
      return "one of ".concat(thing, " ").concat(expected.slice(0, len - 1).join(', '), ", or ") + expected[len - 1];
    } else if (len === 2) {
      return "one of ".concat(thing, " ").concat(expected[0], " or ").concat(expected[1]);
    } else {
      return "of ".concat(thing, " ").concat(expected[0]);
    }
  } else {
    return "of ".concat(thing, " ").concat(String(expected));
  }
} // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/startsWith


function startsWith(str, search, pos) {
  return str.substr(!pos || pos < 0 ? 0 : +pos, search.length) === search;
} // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/endsWith


function endsWith(str, search, this_len) {
  if (this_len === undefined || this_len > str.length) {
    this_len = str.length;
  }

  return str.substring(this_len - search.length, this_len) === search;
} // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/includes


function includes(str, search, start) {
  if (typeof start !== 'number') {
    start = 0;
  }

  if (start + search.length > str.length) {
    return false;
  } else {
    return str.indexOf(search, start) !== -1;
  }
}

createErrorType('ERR_INVALID_OPT_VALUE', function (name, value) {
  return 'The value "' + value + '" is invalid for option "' + name + '"';
}, TypeError);
createErrorType('ERR_INVALID_ARG_TYPE', function (name, expected, actual) {
  // determiner: 'must be' or 'must not be'
  var determiner;

  if (typeof expected === 'string' && startsWith(expected, 'not ')) {
    determiner = 'must not be';
    expected = expected.replace(/^not /, '');
  } else {
    determiner = 'must be';
  }

  var msg;

  if (endsWith(name, ' argument')) {
    // For cases like 'first argument'
    msg = "The ".concat(name, " ").concat(determiner, " ").concat(oneOf(expected, 'type'));
  } else {
    var type = includes(name, '.') ? 'property' : 'argument';
    msg = "The \"".concat(name, "\" ").concat(type, " ").concat(determiner, " ").concat(oneOf(expected, 'type'));
  }

  msg += ". Received type ".concat(typeof actual);
  return msg;
}, TypeError);
createErrorType('ERR_STREAM_PUSH_AFTER_EOF', 'stream.push() after EOF');
createErrorType('ERR_METHOD_NOT_IMPLEMENTED', function (name) {
  return 'The ' + name + ' method is not implemented';
});
createErrorType('ERR_STREAM_PREMATURE_CLOSE', 'Premature close');
createErrorType('ERR_STREAM_DESTROYED', function (name) {
  return 'Cannot call ' + name + ' after a stream was destroyed';
});
createErrorType('ERR_MULTIPLE_CALLBACK', 'Callback called multiple times');
createErrorType('ERR_STREAM_CANNOT_PIPE', 'Cannot pipe, not readable');
createErrorType('ERR_STREAM_WRITE_AFTER_END', 'write after end');
createErrorType('ERR_STREAM_NULL_VALUES', 'May not write null values to stream', TypeError);
createErrorType('ERR_UNKNOWN_ENCODING', function (arg) {
  return 'Unknown encoding: ' + arg;
}, TypeError);
createErrorType('ERR_STREAM_UNSHIFT_AFTER_END_EVENT', 'stream.unshift() after end event');
module.exports.codes = codes;


/***/ }),

/***/ "./node_modules/hash-base/node_modules/readable-stream/lib/_stream_duplex.js":
/*!***********************************************************************************!*\
  !*** ./node_modules/hash-base/node_modules/readable-stream/lib/_stream_duplex.js ***!
  \***********************************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a duplex stream is just a stream that is both readable and writable.
// Since JS doesn't have multiple prototypal inheritance, this class
// prototypally inherits from Readable, and then parasitically from
// Writable.

/*<replacement>*/

var objectKeys = Object.keys || function (obj) {
  var keys = [];

  for (var key in obj) {
    keys.push(key);
  }

  return keys;
};
/*</replacement>*/


module.exports = Duplex;

var Readable = __webpack_require__(/*! ./_stream_readable */ "./node_modules/hash-base/node_modules/readable-stream/lib/_stream_readable.js");

var Writable = __webpack_require__(/*! ./_stream_writable */ "./node_modules/hash-base/node_modules/readable-stream/lib/_stream_writable.js");

__webpack_require__(/*! inherits */ "./node_modules/inherits/inherits_browser.js")(Duplex, Readable);

{
  // Allow the keys array to be GC'ed.
  var keys = objectKeys(Writable.prototype);

  for (var v = 0; v < keys.length; v++) {
    var method = keys[v];
    if (!Duplex.prototype[method]) Duplex.prototype[method] = Writable.prototype[method];
  }
}

function Duplex(options) {
  if (!(this instanceof Duplex)) return new Duplex(options);
  Readable.call(this, options);
  Writable.call(this, options);
  this.allowHalfOpen = true;

  if (options) {
    if (options.readable === false) this.readable = false;
    if (options.writable === false) this.writable = false;

    if (options.allowHalfOpen === false) {
      this.allowHalfOpen = false;
      this.once('end', onend);
    }
  }
}

Object.defineProperty(Duplex.prototype, 'writableHighWaterMark', {
  // making it explicit this property is not enumerable
  // because otherwise some prototype manipulation in
  // userland will fail
  enumerable: false,
  get: function get() {
    return this._writableState.highWaterMark;
  }
});
Object.defineProperty(Duplex.prototype, 'writableBuffer', {
  // making it explicit this property is not enumerable
  // because otherwise some prototype manipulation in
  // userland will fail
  enumerable: false,
  get: function get() {
    return this._writableState && this._writableState.getBuffer();
  }
});
Object.defineProperty(Duplex.prototype, 'writableLength', {
  // making it explicit this property is not enumerable
  // because otherwise some prototype manipulation in
  // userland will fail
  enumerable: false,
  get: function get() {
    return this._writableState.length;
  }
}); // the no-half-open enforcer

function onend() {
  // If the writable side ended, then we're ok.
  if (this._writableState.ended) return; // no more data can be written.
  // But allow more writes to happen in this tick.

  process.nextTick(onEndNT, this);
}

function onEndNT(self) {
  self.end();
}

Object.defineProperty(Duplex.prototype, 'destroyed', {
  // making it explicit this property is not enumerable
  // because otherwise some prototype manipulation in
  // userland will fail
  enumerable: false,
  get: function get() {
    if (this._readableState === undefined || this._writableState === undefined) {
      return false;
    }

    return this._readableState.destroyed && this._writableState.destroyed;
  },
  set: function set(value) {
    // we ignore the value if the stream
    // has not been initialized yet
    if (this._readableState === undefined || this._writableState === undefined) {
      return;
    } // backward compatibility, the user is explicitly
    // managing destroyed


    this._readableState.destroyed = value;
    this._writableState.destroyed = value;
  }
});
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(/*! ./../../../../process/browser.js */ "./node_modules/process/browser.js")))

/***/ }),

/***/ "./node_modules/hash-base/node_modules/readable-stream/lib/_stream_passthrough.js":
/*!****************************************************************************************!*\
  !*** ./node_modules/hash-base/node_modules/readable-stream/lib/_stream_passthrough.js ***!
  \****************************************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a passthrough stream.
// basically just the most minimal sort of Transform stream.
// Every written chunk gets output as-is.


module.exports = PassThrough;

var Transform = __webpack_require__(/*! ./_stream_transform */ "./node_modules/hash-base/node_modules/readable-stream/lib/_stream_transform.js");

__webpack_require__(/*! inherits */ "./node_modules/inherits/inherits_browser.js")(PassThrough, Transform);

function PassThrough(options) {
  if (!(this instanceof PassThrough)) return new PassThrough(options);
  Transform.call(this, options);
}

PassThrough.prototype._transform = function (chunk, encoding, cb) {
  cb(null, chunk);
};

/***/ }),

/***/ "./node_modules/hash-base/node_modules/readable-stream/lib/_stream_readable.js":
/*!*************************************************************************************!*\
  !*** ./node_modules/hash-base/node_modules/readable-stream/lib/_stream_readable.js ***!
  \*************************************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global, process) {// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.


module.exports = Readable;
/*<replacement>*/

var Duplex;
/*</replacement>*/

Readable.ReadableState = ReadableState;
/*<replacement>*/

var EE = __webpack_require__(/*! events */ "./node_modules/events/events.js").EventEmitter;

var EElistenerCount = function EElistenerCount(emitter, type) {
  return emitter.listeners(type).length;
};
/*</replacement>*/

/*<replacement>*/


var Stream = __webpack_require__(/*! ./internal/streams/stream */ "./node_modules/hash-base/node_modules/readable-stream/lib/internal/streams/stream-browser.js");
/*</replacement>*/


var Buffer = __webpack_require__(/*! buffer */ "./node_modules/node-libs-browser/node_modules/buffer/index.js").Buffer;

var OurUint8Array = global.Uint8Array || function () {};

function _uint8ArrayToBuffer(chunk) {
  return Buffer.from(chunk);
}

function _isUint8Array(obj) {
  return Buffer.isBuffer(obj) || obj instanceof OurUint8Array;
}
/*<replacement>*/


var debugUtil = __webpack_require__(/*! util */ 0);

var debug;

if (debugUtil && debugUtil.debuglog) {
  debug = debugUtil.debuglog('stream');
} else {
  debug = function debug() {};
}
/*</replacement>*/


var BufferList = __webpack_require__(/*! ./internal/streams/buffer_list */ "./node_modules/hash-base/node_modules/readable-stream/lib/internal/streams/buffer_list.js");

var destroyImpl = __webpack_require__(/*! ./internal/streams/destroy */ "./node_modules/hash-base/node_modules/readable-stream/lib/internal/streams/destroy.js");

var _require = __webpack_require__(/*! ./internal/streams/state */ "./node_modules/hash-base/node_modules/readable-stream/lib/internal/streams/state.js"),
    getHighWaterMark = _require.getHighWaterMark;

var _require$codes = __webpack_require__(/*! ../errors */ "./node_modules/hash-base/node_modules/readable-stream/errors-browser.js").codes,
    ERR_INVALID_ARG_TYPE = _require$codes.ERR_INVALID_ARG_TYPE,
    ERR_STREAM_PUSH_AFTER_EOF = _require$codes.ERR_STREAM_PUSH_AFTER_EOF,
    ERR_METHOD_NOT_IMPLEMENTED = _require$codes.ERR_METHOD_NOT_IMPLEMENTED,
    ERR_STREAM_UNSHIFT_AFTER_END_EVENT = _require$codes.ERR_STREAM_UNSHIFT_AFTER_END_EVENT; // Lazy loaded to improve the startup performance.


var StringDecoder;
var createReadableStreamAsyncIterator;
var from;

__webpack_require__(/*! inherits */ "./node_modules/inherits/inherits_browser.js")(Readable, Stream);

var errorOrDestroy = destroyImpl.errorOrDestroy;
var kProxyEvents = ['error', 'close', 'destroy', 'pause', 'resume'];

function prependListener(emitter, event, fn) {
  // Sadly this is not cacheable as some libraries bundle their own
  // event emitter implementation with them.
  if (typeof emitter.prependListener === 'function') return emitter.prependListener(event, fn); // This is a hack to make sure that our error handler is attached before any
  // userland ones.  NEVER DO THIS. This is here only because this code needs
  // to continue to work with older versions of Node.js that do not include
  // the prependListener() method. The goal is to eventually remove this hack.

  if (!emitter._events || !emitter._events[event]) emitter.on(event, fn);else if (Array.isArray(emitter._events[event])) emitter._events[event].unshift(fn);else emitter._events[event] = [fn, emitter._events[event]];
}

function ReadableState(options, stream, isDuplex) {
  Duplex = Duplex || __webpack_require__(/*! ./_stream_duplex */ "./node_modules/hash-base/node_modules/readable-stream/lib/_stream_duplex.js");
  options = options || {}; // Duplex streams are both readable and writable, but share
  // the same options object.
  // However, some cases require setting options to different
  // values for the readable and the writable sides of the duplex stream.
  // These options can be provided separately as readableXXX and writableXXX.

  if (typeof isDuplex !== 'boolean') isDuplex = stream instanceof Duplex; // object stream flag. Used to make read(n) ignore n and to
  // make all the buffer merging and length checks go away

  this.objectMode = !!options.objectMode;
  if (isDuplex) this.objectMode = this.objectMode || !!options.readableObjectMode; // the point at which it stops calling _read() to fill the buffer
  // Note: 0 is a valid value, means "don't call _read preemptively ever"

  this.highWaterMark = getHighWaterMark(this, options, 'readableHighWaterMark', isDuplex); // A linked list is used to store data chunks instead of an array because the
  // linked list can remove elements from the beginning faster than
  // array.shift()

  this.buffer = new BufferList();
  this.length = 0;
  this.pipes = null;
  this.pipesCount = 0;
  this.flowing = null;
  this.ended = false;
  this.endEmitted = false;
  this.reading = false; // a flag to be able to tell if the event 'readable'/'data' is emitted
  // immediately, or on a later tick.  We set this to true at first, because
  // any actions that shouldn't happen until "later" should generally also
  // not happen before the first read call.

  this.sync = true; // whenever we return null, then we set a flag to say
  // that we're awaiting a 'readable' event emission.

  this.needReadable = false;
  this.emittedReadable = false;
  this.readableListening = false;
  this.resumeScheduled = false;
  this.paused = true; // Should close be emitted on destroy. Defaults to true.

  this.emitClose = options.emitClose !== false; // Should .destroy() be called after 'end' (and potentially 'finish')

  this.autoDestroy = !!options.autoDestroy; // has it been destroyed

  this.destroyed = false; // Crypto is kind of old and crusty.  Historically, its default string
  // encoding is 'binary' so we have to make this configurable.
  // Everything else in the universe uses 'utf8', though.

  this.defaultEncoding = options.defaultEncoding || 'utf8'; // the number of writers that are awaiting a drain event in .pipe()s

  this.awaitDrain = 0; // if true, a maybeReadMore has been scheduled

  this.readingMore = false;
  this.decoder = null;
  this.encoding = null;

  if (options.encoding) {
    if (!StringDecoder) StringDecoder = __webpack_require__(/*! string_decoder/ */ "./node_modules/string_decoder/lib/string_decoder.js").StringDecoder;
    this.decoder = new StringDecoder(options.encoding);
    this.encoding = options.encoding;
  }
}

function Readable(options) {
  Duplex = Duplex || __webpack_require__(/*! ./_stream_duplex */ "./node_modules/hash-base/node_modules/readable-stream/lib/_stream_duplex.js");
  if (!(this instanceof Readable)) return new Readable(options); // Checking for a Stream.Duplex instance is faster here instead of inside
  // the ReadableState constructor, at least with V8 6.5

  var isDuplex = this instanceof Duplex;
  this._readableState = new ReadableState(options, this, isDuplex); // legacy

  this.readable = true;

  if (options) {
    if (typeof options.read === 'function') this._read = options.read;
    if (typeof options.destroy === 'function') this._destroy = options.destroy;
  }

  Stream.call(this);
}

Object.defineProperty(Readable.prototype, 'destroyed', {
  // making it explicit this property is not enumerable
  // because otherwise some prototype manipulation in
  // userland will fail
  enumerable: false,
  get: function get() {
    if (this._readableState === undefined) {
      return false;
    }

    return this._readableState.destroyed;
  },
  set: function set(value) {
    // we ignore the value if the stream
    // has not been initialized yet
    if (!this._readableState) {
      return;
    } // backward compatibility, the user is explicitly
    // managing destroyed


    this._readableState.destroyed = value;
  }
});
Readable.prototype.destroy = destroyImpl.destroy;
Readable.prototype._undestroy = destroyImpl.undestroy;

Readable.prototype._destroy = function (err, cb) {
  cb(err);
}; // Manually shove something into the read() buffer.
// This returns true if the highWaterMark has not been hit yet,
// similar to how Writable.write() returns true if you should
// write() some more.


Readable.prototype.push = function (chunk, encoding) {
  var state = this._readableState;
  var skipChunkCheck;

  if (!state.objectMode) {
    if (typeof chunk === 'string') {
      encoding = encoding || state.defaultEncoding;

      if (encoding !== state.encoding) {
        chunk = Buffer.from(chunk, encoding);
        encoding = '';
      }

      skipChunkCheck = true;
    }
  } else {
    skipChunkCheck = true;
  }

  return readableAddChunk(this, chunk, encoding, false, skipChunkCheck);
}; // Unshift should *always* be something directly out of read()


Readable.prototype.unshift = function (chunk) {
  return readableAddChunk(this, chunk, null, true, false);
};

function readableAddChunk(stream, chunk, encoding, addToFront, skipChunkCheck) {
  debug('readableAddChunk', chunk);
  var state = stream._readableState;

  if (chunk === null) {
    state.reading = false;
    onEofChunk(stream, state);
  } else {
    var er;
    if (!skipChunkCheck) er = chunkInvalid(state, chunk);

    if (er) {
      errorOrDestroy(stream, er);
    } else if (state.objectMode || chunk && chunk.length > 0) {
      if (typeof chunk !== 'string' && !state.objectMode && Object.getPrototypeOf(chunk) !== Buffer.prototype) {
        chunk = _uint8ArrayToBuffer(chunk);
      }

      if (addToFront) {
        if (state.endEmitted) errorOrDestroy(stream, new ERR_STREAM_UNSHIFT_AFTER_END_EVENT());else addChunk(stream, state, chunk, true);
      } else if (state.ended) {
        errorOrDestroy(stream, new ERR_STREAM_PUSH_AFTER_EOF());
      } else if (state.destroyed) {
        return false;
      } else {
        state.reading = false;

        if (state.decoder && !encoding) {
          chunk = state.decoder.write(chunk);
          if (state.objectMode || chunk.length !== 0) addChunk(stream, state, chunk, false);else maybeReadMore(stream, state);
        } else {
          addChunk(stream, state, chunk, false);
        }
      }
    } else if (!addToFront) {
      state.reading = false;
      maybeReadMore(stream, state);
    }
  } // We can push more data if we are below the highWaterMark.
  // Also, if we have no data yet, we can stand some more bytes.
  // This is to work around cases where hwm=0, such as the repl.


  return !state.ended && (state.length < state.highWaterMark || state.length === 0);
}

function addChunk(stream, state, chunk, addToFront) {
  if (state.flowing && state.length === 0 && !state.sync) {
    state.awaitDrain = 0;
    stream.emit('data', chunk);
  } else {
    // update the buffer info.
    state.length += state.objectMode ? 1 : chunk.length;
    if (addToFront) state.buffer.unshift(chunk);else state.buffer.push(chunk);
    if (state.needReadable) emitReadable(stream);
  }

  maybeReadMore(stream, state);
}

function chunkInvalid(state, chunk) {
  var er;

  if (!_isUint8Array(chunk) && typeof chunk !== 'string' && chunk !== undefined && !state.objectMode) {
    er = new ERR_INVALID_ARG_TYPE('chunk', ['string', 'Buffer', 'Uint8Array'], chunk);
  }

  return er;
}

Readable.prototype.isPaused = function () {
  return this._readableState.flowing === false;
}; // backwards compatibility.


Readable.prototype.setEncoding = function (enc) {
  if (!StringDecoder) StringDecoder = __webpack_require__(/*! string_decoder/ */ "./node_modules/string_decoder/lib/string_decoder.js").StringDecoder;
  var decoder = new StringDecoder(enc);
  this._readableState.decoder = decoder; // If setEncoding(null), decoder.encoding equals utf8

  this._readableState.encoding = this._readableState.decoder.encoding; // Iterate over current buffer to convert already stored Buffers:

  var p = this._readableState.buffer.head;
  var content = '';

  while (p !== null) {
    content += decoder.write(p.data);
    p = p.next;
  }

  this._readableState.buffer.clear();

  if (content !== '') this._readableState.buffer.push(content);
  this._readableState.length = content.length;
  return this;
}; // Don't raise the hwm > 1GB


var MAX_HWM = 0x40000000;

function computeNewHighWaterMark(n) {
  if (n >= MAX_HWM) {
    // TODO(ronag): Throw ERR_VALUE_OUT_OF_RANGE.
    n = MAX_HWM;
  } else {
    // Get the next highest power of 2 to prevent increasing hwm excessively in
    // tiny amounts
    n--;
    n |= n >>> 1;
    n |= n >>> 2;
    n |= n >>> 4;
    n |= n >>> 8;
    n |= n >>> 16;
    n++;
  }

  return n;
} // This function is designed to be inlinable, so please take care when making
// changes to the function body.


function howMuchToRead(n, state) {
  if (n <= 0 || state.length === 0 && state.ended) return 0;
  if (state.objectMode) return 1;

  if (n !== n) {
    // Only flow one buffer at a time
    if (state.flowing && state.length) return state.buffer.head.data.length;else return state.length;
  } // If we're asking for more than the current hwm, then raise the hwm.


  if (n > state.highWaterMark) state.highWaterMark = computeNewHighWaterMark(n);
  if (n <= state.length) return n; // Don't have enough

  if (!state.ended) {
    state.needReadable = true;
    return 0;
  }

  return state.length;
} // you can override either this method, or the async _read(n) below.


Readable.prototype.read = function (n) {
  debug('read', n);
  n = parseInt(n, 10);
  var state = this._readableState;
  var nOrig = n;
  if (n !== 0) state.emittedReadable = false; // if we're doing read(0) to trigger a readable event, but we
  // already have a bunch of data in the buffer, then just trigger
  // the 'readable' event and move on.

  if (n === 0 && state.needReadable && ((state.highWaterMark !== 0 ? state.length >= state.highWaterMark : state.length > 0) || state.ended)) {
    debug('read: emitReadable', state.length, state.ended);
    if (state.length === 0 && state.ended) endReadable(this);else emitReadable(this);
    return null;
  }

  n = howMuchToRead(n, state); // if we've ended, and we're now clear, then finish it up.

  if (n === 0 && state.ended) {
    if (state.length === 0) endReadable(this);
    return null;
  } // All the actual chunk generation logic needs to be
  // *below* the call to _read.  The reason is that in certain
  // synthetic stream cases, such as passthrough streams, _read
  // may be a completely synchronous operation which may change
  // the state of the read buffer, providing enough data when
  // before there was *not* enough.
  //
  // So, the steps are:
  // 1. Figure out what the state of things will be after we do
  // a read from the buffer.
  //
  // 2. If that resulting state will trigger a _read, then call _read.
  // Note that this may be asynchronous, or synchronous.  Yes, it is
  // deeply ugly to write APIs this way, but that still doesn't mean
  // that the Readable class should behave improperly, as streams are
  // designed to be sync/async agnostic.
  // Take note if the _read call is sync or async (ie, if the read call
  // has returned yet), so that we know whether or not it's safe to emit
  // 'readable' etc.
  //
  // 3. Actually pull the requested chunks out of the buffer and return.
  // if we need a readable event, then we need to do some reading.


  var doRead = state.needReadable;
  debug('need readable', doRead); // if we currently have less than the highWaterMark, then also read some

  if (state.length === 0 || state.length - n < state.highWaterMark) {
    doRead = true;
    debug('length less than watermark', doRead);
  } // however, if we've ended, then there's no point, and if we're already
  // reading, then it's unnecessary.


  if (state.ended || state.reading) {
    doRead = false;
    debug('reading or ended', doRead);
  } else if (doRead) {
    debug('do read');
    state.reading = true;
    state.sync = true; // if the length is currently zero, then we *need* a readable event.

    if (state.length === 0) state.needReadable = true; // call internal read method

    this._read(state.highWaterMark);

    state.sync = false; // If _read pushed data synchronously, then `reading` will be false,
    // and we need to re-evaluate how much data we can return to the user.

    if (!state.reading) n = howMuchToRead(nOrig, state);
  }

  var ret;
  if (n > 0) ret = fromList(n, state);else ret = null;

  if (ret === null) {
    state.needReadable = state.length <= state.highWaterMark;
    n = 0;
  } else {
    state.length -= n;
    state.awaitDrain = 0;
  }

  if (state.length === 0) {
    // If we have nothing in the buffer, then we want to know
    // as soon as we *do* get something into the buffer.
    if (!state.ended) state.needReadable = true; // If we tried to read() past the EOF, then emit end on the next tick.

    if (nOrig !== n && state.ended) endReadable(this);
  }

  if (ret !== null) this.emit('data', ret);
  return ret;
};

function onEofChunk(stream, state) {
  debug('onEofChunk');
  if (state.ended) return;

  if (state.decoder) {
    var chunk = state.decoder.end();

    if (chunk && chunk.length) {
      state.buffer.push(chunk);
      state.length += state.objectMode ? 1 : chunk.length;
    }
  }

  state.ended = true;

  if (state.sync) {
    // if we are sync, wait until next tick to emit the data.
    // Otherwise we risk emitting data in the flow()
    // the readable code triggers during a read() call
    emitReadable(stream);
  } else {
    // emit 'readable' now to make sure it gets picked up.
    state.needReadable = false;

    if (!state.emittedReadable) {
      state.emittedReadable = true;
      emitReadable_(stream);
    }
  }
} // Don't emit readable right away in sync mode, because this can trigger
// another read() call => stack overflow.  This way, it might trigger
// a nextTick recursion warning, but that's not so bad.


function emitReadable(stream) {
  var state = stream._readableState;
  debug('emitReadable', state.needReadable, state.emittedReadable);
  state.needReadable = false;

  if (!state.emittedReadable) {
    debug('emitReadable', state.flowing);
    state.emittedReadable = true;
    process.nextTick(emitReadable_, stream);
  }
}

function emitReadable_(stream) {
  var state = stream._readableState;
  debug('emitReadable_', state.destroyed, state.length, state.ended);

  if (!state.destroyed && (state.length || state.ended)) {
    stream.emit('readable');
    state.emittedReadable = false;
  } // The stream needs another readable event if
  // 1. It is not flowing, as the flow mechanism will take
  //    care of it.
  // 2. It is not ended.
  // 3. It is below the highWaterMark, so we can schedule
  //    another readable later.


  state.needReadable = !state.flowing && !state.ended && state.length <= state.highWaterMark;
  flow(stream);
} // at this point, the user has presumably seen the 'readable' event,
// and called read() to consume some data.  that may have triggered
// in turn another _read(n) call, in which case reading = true if
// it's in progress.
// However, if we're not ended, or reading, and the length < hwm,
// then go ahead and try to read some more preemptively.


function maybeReadMore(stream, state) {
  if (!state.readingMore) {
    state.readingMore = true;
    process.nextTick(maybeReadMore_, stream, state);
  }
}

function maybeReadMore_(stream, state) {
  // Attempt to read more data if we should.
  //
  // The conditions for reading more data are (one of):
  // - Not enough data buffered (state.length < state.highWaterMark). The loop
  //   is responsible for filling the buffer with enough data if such data
  //   is available. If highWaterMark is 0 and we are not in the flowing mode
  //   we should _not_ attempt to buffer any extra data. We'll get more data
  //   when the stream consumer calls read() instead.
  // - No data in the buffer, and the stream is in flowing mode. In this mode
  //   the loop below is responsible for ensuring read() is called. Failing to
  //   call read here would abort the flow and there's no other mechanism for
  //   continuing the flow if the stream consumer has just subscribed to the
  //   'data' event.
  //
  // In addition to the above conditions to keep reading data, the following
  // conditions prevent the data from being read:
  // - The stream has ended (state.ended).
  // - There is already a pending 'read' operation (state.reading). This is a
  //   case where the the stream has called the implementation defined _read()
  //   method, but they are processing the call asynchronously and have _not_
  //   called push() with new data. In this case we skip performing more
  //   read()s. The execution ends in this method again after the _read() ends
  //   up calling push() with more data.
  while (!state.reading && !state.ended && (state.length < state.highWaterMark || state.flowing && state.length === 0)) {
    var len = state.length;
    debug('maybeReadMore read 0');
    stream.read(0);
    if (len === state.length) // didn't get any data, stop spinning.
      break;
  }

  state.readingMore = false;
} // abstract method.  to be overridden in specific implementation classes.
// call cb(er, data) where data is <= n in length.
// for virtual (non-string, non-buffer) streams, "length" is somewhat
// arbitrary, and perhaps not very meaningful.


Readable.prototype._read = function (n) {
  errorOrDestroy(this, new ERR_METHOD_NOT_IMPLEMENTED('_read()'));
};

Readable.prototype.pipe = function (dest, pipeOpts) {
  var src = this;
  var state = this._readableState;

  switch (state.pipesCount) {
    case 0:
      state.pipes = dest;
      break;

    case 1:
      state.pipes = [state.pipes, dest];
      break;

    default:
      state.pipes.push(dest);
      break;
  }

  state.pipesCount += 1;
  debug('pipe count=%d opts=%j', state.pipesCount, pipeOpts);
  var doEnd = (!pipeOpts || pipeOpts.end !== false) && dest !== process.stdout && dest !== process.stderr;
  var endFn = doEnd ? onend : unpipe;
  if (state.endEmitted) process.nextTick(endFn);else src.once('end', endFn);
  dest.on('unpipe', onunpipe);

  function onunpipe(readable, unpipeInfo) {
    debug('onunpipe');

    if (readable === src) {
      if (unpipeInfo && unpipeInfo.hasUnpiped === false) {
        unpipeInfo.hasUnpiped = true;
        cleanup();
      }
    }
  }

  function onend() {
    debug('onend');
    dest.end();
  } // when the dest drains, it reduces the awaitDrain counter
  // on the source.  This would be more elegant with a .once()
  // handler in flow(), but adding and removing repeatedly is
  // too slow.


  var ondrain = pipeOnDrain(src);
  dest.on('drain', ondrain);
  var cleanedUp = false;

  function cleanup() {
    debug('cleanup'); // cleanup event handlers once the pipe is broken

    dest.removeListener('close', onclose);
    dest.removeListener('finish', onfinish);
    dest.removeListener('drain', ondrain);
    dest.removeListener('error', onerror);
    dest.removeListener('unpipe', onunpipe);
    src.removeListener('end', onend);
    src.removeListener('end', unpipe);
    src.removeListener('data', ondata);
    cleanedUp = true; // if the reader is waiting for a drain event from this
    // specific writer, then it would cause it to never start
    // flowing again.
    // So, if this is awaiting a drain, then we just call it now.
    // If we don't know, then assume that we are waiting for one.

    if (state.awaitDrain && (!dest._writableState || dest._writableState.needDrain)) ondrain();
  }

  src.on('data', ondata);

  function ondata(chunk) {
    debug('ondata');
    var ret = dest.write(chunk);
    debug('dest.write', ret);

    if (ret === false) {
      // If the user unpiped during `dest.write()`, it is possible
      // to get stuck in a permanently paused state if that write
      // also returned false.
      // => Check whether `dest` is still a piping destination.
      if ((state.pipesCount === 1 && state.pipes === dest || state.pipesCount > 1 && indexOf(state.pipes, dest) !== -1) && !cleanedUp) {
        debug('false write response, pause', state.awaitDrain);
        state.awaitDrain++;
      }

      src.pause();
    }
  } // if the dest has an error, then stop piping into it.
  // however, don't suppress the throwing behavior for this.


  function onerror(er) {
    debug('onerror', er);
    unpipe();
    dest.removeListener('error', onerror);
    if (EElistenerCount(dest, 'error') === 0) errorOrDestroy(dest, er);
  } // Make sure our error handler is attached before userland ones.


  prependListener(dest, 'error', onerror); // Both close and finish should trigger unpipe, but only once.

  function onclose() {
    dest.removeListener('finish', onfinish);
    unpipe();
  }

  dest.once('close', onclose);

  function onfinish() {
    debug('onfinish');
    dest.removeListener('close', onclose);
    unpipe();
  }

  dest.once('finish', onfinish);

  function unpipe() {
    debug('unpipe');
    src.unpipe(dest);
  } // tell the dest that it's being piped to


  dest.emit('pipe', src); // start the flow if it hasn't been started already.

  if (!state.flowing) {
    debug('pipe resume');
    src.resume();
  }

  return dest;
};

function pipeOnDrain(src) {
  return function pipeOnDrainFunctionResult() {
    var state = src._readableState;
    debug('pipeOnDrain', state.awaitDrain);
    if (state.awaitDrain) state.awaitDrain--;

    if (state.awaitDrain === 0 && EElistenerCount(src, 'data')) {
      state.flowing = true;
      flow(src);
    }
  };
}

Readable.prototype.unpipe = function (dest) {
  var state = this._readableState;
  var unpipeInfo = {
    hasUnpiped: false
  }; // if we're not piping anywhere, then do nothing.

  if (state.pipesCount === 0) return this; // just one destination.  most common case.

  if (state.pipesCount === 1) {
    // passed in one, but it's not the right one.
    if (dest && dest !== state.pipes) return this;
    if (!dest) dest = state.pipes; // got a match.

    state.pipes = null;
    state.pipesCount = 0;
    state.flowing = false;
    if (dest) dest.emit('unpipe', this, unpipeInfo);
    return this;
  } // slow case. multiple pipe destinations.


  if (!dest) {
    // remove all.
    var dests = state.pipes;
    var len = state.pipesCount;
    state.pipes = null;
    state.pipesCount = 0;
    state.flowing = false;

    for (var i = 0; i < len; i++) {
      dests[i].emit('unpipe', this, {
        hasUnpiped: false
      });
    }

    return this;
  } // try to find the right one.


  var index = indexOf(state.pipes, dest);
  if (index === -1) return this;
  state.pipes.splice(index, 1);
  state.pipesCount -= 1;
  if (state.pipesCount === 1) state.pipes = state.pipes[0];
  dest.emit('unpipe', this, unpipeInfo);
  return this;
}; // set up data events if they are asked for
// Ensure readable listeners eventually get something


Readable.prototype.on = function (ev, fn) {
  var res = Stream.prototype.on.call(this, ev, fn);
  var state = this._readableState;

  if (ev === 'data') {
    // update readableListening so that resume() may be a no-op
    // a few lines down. This is needed to support once('readable').
    state.readableListening = this.listenerCount('readable') > 0; // Try start flowing on next tick if stream isn't explicitly paused

    if (state.flowing !== false) this.resume();
  } else if (ev === 'readable') {
    if (!state.endEmitted && !state.readableListening) {
      state.readableListening = state.needReadable = true;
      state.flowing = false;
      state.emittedReadable = false;
      debug('on readable', state.length, state.reading);

      if (state.length) {
        emitReadable(this);
      } else if (!state.reading) {
        process.nextTick(nReadingNextTick, this);
      }
    }
  }

  return res;
};

Readable.prototype.addListener = Readable.prototype.on;

Readable.prototype.removeListener = function (ev, fn) {
  var res = Stream.prototype.removeListener.call(this, ev, fn);

  if (ev === 'readable') {
    // We need to check if there is someone still listening to
    // readable and reset the state. However this needs to happen
    // after readable has been emitted but before I/O (nextTick) to
    // support once('readable', fn) cycles. This means that calling
    // resume within the same tick will have no
    // effect.
    process.nextTick(updateReadableListening, this);
  }

  return res;
};

Readable.prototype.removeAllListeners = function (ev) {
  var res = Stream.prototype.removeAllListeners.apply(this, arguments);

  if (ev === 'readable' || ev === undefined) {
    // We need to check if there is someone still listening to
    // readable and reset the state. However this needs to happen
    // after readable has been emitted but before I/O (nextTick) to
    // support once('readable', fn) cycles. This means that calling
    // resume within the same tick will have no
    // effect.
    process.nextTick(updateReadableListening, this);
  }

  return res;
};

function updateReadableListening(self) {
  var state = self._readableState;
  state.readableListening = self.listenerCount('readable') > 0;

  if (state.resumeScheduled && !state.paused) {
    // flowing needs to be set to true now, otherwise
    // the upcoming resume will not flow.
    state.flowing = true; // crude way to check if we should resume
  } else if (self.listenerCount('data') > 0) {
    self.resume();
  }
}

function nReadingNextTick(self) {
  debug('readable nexttick read 0');
  self.read(0);
} // pause() and resume() are remnants of the legacy readable stream API
// If the user uses them, then switch into old mode.


Readable.prototype.resume = function () {
  var state = this._readableState;

  if (!state.flowing) {
    debug('resume'); // we flow only if there is no one listening
    // for readable, but we still have to call
    // resume()

    state.flowing = !state.readableListening;
    resume(this, state);
  }

  state.paused = false;
  return this;
};

function resume(stream, state) {
  if (!state.resumeScheduled) {
    state.resumeScheduled = true;
    process.nextTick(resume_, stream, state);
  }
}

function resume_(stream, state) {
  debug('resume', state.reading);

  if (!state.reading) {
    stream.read(0);
  }

  state.resumeScheduled = false;
  stream.emit('resume');
  flow(stream);
  if (state.flowing && !state.reading) stream.read(0);
}

Readable.prototype.pause = function () {
  debug('call pause flowing=%j', this._readableState.flowing);

  if (this._readableState.flowing !== false) {
    debug('pause');
    this._readableState.flowing = false;
    this.emit('pause');
  }

  this._readableState.paused = true;
  return this;
};

function flow(stream) {
  var state = stream._readableState;
  debug('flow', state.flowing);

  while (state.flowing && stream.read() !== null) {
    ;
  }
} // wrap an old-style stream as the async data source.
// This is *not* part of the readable stream interface.
// It is an ugly unfortunate mess of history.


Readable.prototype.wrap = function (stream) {
  var _this = this;

  var state = this._readableState;
  var paused = false;
  stream.on('end', function () {
    debug('wrapped end');

    if (state.decoder && !state.ended) {
      var chunk = state.decoder.end();
      if (chunk && chunk.length) _this.push(chunk);
    }

    _this.push(null);
  });
  stream.on('data', function (chunk) {
    debug('wrapped data');
    if (state.decoder) chunk = state.decoder.write(chunk); // don't skip over falsy values in objectMode

    if (state.objectMode && (chunk === null || chunk === undefined)) return;else if (!state.objectMode && (!chunk || !chunk.length)) return;

    var ret = _this.push(chunk);

    if (!ret) {
      paused = true;
      stream.pause();
    }
  }); // proxy all the other methods.
  // important when wrapping filters and duplexes.

  for (var i in stream) {
    if (this[i] === undefined && typeof stream[i] === 'function') {
      this[i] = function methodWrap(method) {
        return function methodWrapReturnFunction() {
          return stream[method].apply(stream, arguments);
        };
      }(i);
    }
  } // proxy certain important events.


  for (var n = 0; n < kProxyEvents.length; n++) {
    stream.on(kProxyEvents[n], this.emit.bind(this, kProxyEvents[n]));
  } // when we try to consume some more bytes, simply unpause the
  // underlying stream.


  this._read = function (n) {
    debug('wrapped _read', n);

    if (paused) {
      paused = false;
      stream.resume();
    }
  };

  return this;
};

if (typeof Symbol === 'function') {
  Readable.prototype[Symbol.asyncIterator] = function () {
    if (createReadableStreamAsyncIterator === undefined) {
      createReadableStreamAsyncIterator = __webpack_require__(/*! ./internal/streams/async_iterator */ "./node_modules/hash-base/node_modules/readable-stream/lib/internal/streams/async_iterator.js");
    }

    return createReadableStreamAsyncIterator(this);
  };
}

Object.defineProperty(Readable.prototype, 'readableHighWaterMark', {
  // making it explicit this property is not enumerable
  // because otherwise some prototype manipulation in
  // userland will fail
  enumerable: false,
  get: function get() {
    return this._readableState.highWaterMark;
  }
});
Object.defineProperty(Readable.prototype, 'readableBuffer', {
  // making it explicit this property is not enumerable
  // because otherwise some prototype manipulation in
  // userland will fail
  enumerable: false,
  get: function get() {
    return this._readableState && this._readableState.buffer;
  }
});
Object.defineProperty(Readable.prototype, 'readableFlowing', {
  // making it explicit this property is not enumerable
  // because otherwise some prototype manipulation in
  // userland will fail
  enumerable: false,
  get: function get() {
    return this._readableState.flowing;
  },
  set: function set(state) {
    if (this._readableState) {
      this._readableState.flowing = state;
    }
  }
}); // exposed for testing purposes only.

Readable._fromList = fromList;
Object.defineProperty(Readable.prototype, 'readableLength', {
  // making it explicit this property is not enumerable
  // because otherwise some prototype manipulation in
  // userland will fail
  enumerable: false,
  get: function get() {
    return this._readableState.length;
  }
}); // Pluck off n bytes from an array of buffers.
// Length is the combined lengths of all the buffers in the list.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.

function fromList(n, state) {
  // nothing buffered
  if (state.length === 0) return null;
  var ret;
  if (state.objectMode) ret = state.buffer.shift();else if (!n || n >= state.length) {
    // read it all, truncate the list
    if (state.decoder) ret = state.buffer.join('');else if (state.buffer.length === 1) ret = state.buffer.first();else ret = state.buffer.concat(state.length);
    state.buffer.clear();
  } else {
    // read part of list
    ret = state.buffer.consume(n, state.decoder);
  }
  return ret;
}

function endReadable(stream) {
  var state = stream._readableState;
  debug('endReadable', state.endEmitted);

  if (!state.endEmitted) {
    state.ended = true;
    process.nextTick(endReadableNT, state, stream);
  }
}

function endReadableNT(state, stream) {
  debug('endReadableNT', state.endEmitted, state.length); // Check that we didn't get one last unshift.

  if (!state.endEmitted && state.length === 0) {
    state.endEmitted = true;
    stream.readable = false;
    stream.emit('end');

    if (state.autoDestroy) {
      // In case of duplex streams we need a way to detect
      // if the writable side is ready for autoDestroy as well
      var wState = stream._writableState;

      if (!wState || wState.autoDestroy && wState.finished) {
        stream.destroy();
      }
    }
  }
}

if (typeof Symbol === 'function') {
  Readable.from = function (iterable, opts) {
    if (from === undefined) {
      from = __webpack_require__(/*! ./internal/streams/from */ "./node_modules/hash-base/node_modules/readable-stream/lib/internal/streams/from-browser.js");
    }

    return from(Readable, iterable, opts);
  };
}

function indexOf(xs, x) {
  for (var i = 0, l = xs.length; i < l; i++) {
    if (xs[i] === x) return i;
  }

  return -1;
}
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(/*! ./../../../../webpack/buildin/global.js */ "./node_modules/webpack/buildin/global.js"), __webpack_require__(/*! ./../../../../process/browser.js */ "./node_modules/process/browser.js")))

/***/ }),

/***/ "./node_modules/hash-base/node_modules/readable-stream/lib/_stream_transform.js":
/*!**************************************************************************************!*\
  !*** ./node_modules/hash-base/node_modules/readable-stream/lib/_stream_transform.js ***!
  \**************************************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a transform stream is a readable/writable stream where you do
// something with the data.  Sometimes it's called a "filter",
// but that's not a great name for it, since that implies a thing where
// some bits pass through, and others are simply ignored.  (That would
// be a valid example of a transform, of course.)
//
// While the output is causally related to the input, it's not a
// necessarily symmetric or synchronous transformation.  For example,
// a zlib stream might take multiple plain-text writes(), and then
// emit a single compressed chunk some time in the future.
//
// Here's how this works:
//
// The Transform stream has all the aspects of the readable and writable
// stream classes.  When you write(chunk), that calls _write(chunk,cb)
// internally, and returns false if there's a lot of pending writes
// buffered up.  When you call read(), that calls _read(n) until
// there's enough pending readable data buffered up.
//
// In a transform stream, the written data is placed in a buffer.  When
// _read(n) is called, it transforms the queued up data, calling the
// buffered _write cb's as it consumes chunks.  If consuming a single
// written chunk would result in multiple output chunks, then the first
// outputted bit calls the readcb, and subsequent chunks just go into
// the read buffer, and will cause it to emit 'readable' if necessary.
//
// This way, back-pressure is actually determined by the reading side,
// since _read has to be called to start processing a new chunk.  However,
// a pathological inflate type of transform can cause excessive buffering
// here.  For example, imagine a stream where every byte of input is
// interpreted as an integer from 0-255, and then results in that many
// bytes of output.  Writing the 4 bytes {ff,ff,ff,ff} would result in
// 1kb of data being output.  In this case, you could write a very small
// amount of input, and end up with a very large amount of output.  In
// such a pathological inflating mechanism, there'd be no way to tell
// the system to stop doing the transform.  A single 4MB write could
// cause the system to run out of memory.
//
// However, even in such a pathological case, only a single written chunk
// would be consumed, and then the rest would wait (un-transformed) until
// the results of the previous transformed chunk were consumed.


module.exports = Transform;

var _require$codes = __webpack_require__(/*! ../errors */ "./node_modules/hash-base/node_modules/readable-stream/errors-browser.js").codes,
    ERR_METHOD_NOT_IMPLEMENTED = _require$codes.ERR_METHOD_NOT_IMPLEMENTED,
    ERR_MULTIPLE_CALLBACK = _require$codes.ERR_MULTIPLE_CALLBACK,
    ERR_TRANSFORM_ALREADY_TRANSFORMING = _require$codes.ERR_TRANSFORM_ALREADY_TRANSFORMING,
    ERR_TRANSFORM_WITH_LENGTH_0 = _require$codes.ERR_TRANSFORM_WITH_LENGTH_0;

var Duplex = __webpack_require__(/*! ./_stream_duplex */ "./node_modules/hash-base/node_modules/readable-stream/lib/_stream_duplex.js");

__webpack_require__(/*! inherits */ "./node_modules/inherits/inherits_browser.js")(Transform, Duplex);

function afterTransform(er, data) {
  var ts = this._transformState;
  ts.transforming = false;
  var cb = ts.writecb;

  if (cb === null) {
    return this.emit('error', new ERR_MULTIPLE_CALLBACK());
  }

  ts.writechunk = null;
  ts.writecb = null;
  if (data != null) // single equals check for both `null` and `undefined`
    this.push(data);
  cb(er);
  var rs = this._readableState;
  rs.reading = false;

  if (rs.needReadable || rs.length < rs.highWaterMark) {
    this._read(rs.highWaterMark);
  }
}

function Transform(options) {
  if (!(this instanceof Transform)) return new Transform(options);
  Duplex.call(this, options);
  this._transformState = {
    afterTransform: afterTransform.bind(this),
    needTransform: false,
    transforming: false,
    writecb: null,
    writechunk: null,
    writeencoding: null
  }; // start out asking for a readable event once data is transformed.

  this._readableState.needReadable = true; // we have implemented the _read method, and done the other things
  // that Readable wants before the first _read call, so unset the
  // sync guard flag.

  this._readableState.sync = false;

  if (options) {
    if (typeof options.transform === 'function') this._transform = options.transform;
    if (typeof options.flush === 'function') this._flush = options.flush;
  } // When the writable side finishes, then flush out anything remaining.


  this.on('prefinish', prefinish);
}

function prefinish() {
  var _this = this;

  if (typeof this._flush === 'function' && !this._readableState.destroyed) {
    this._flush(function (er, data) {
      done(_this, er, data);
    });
  } else {
    done(this, null, null);
  }
}

Transform.prototype.push = function (chunk, encoding) {
  this._transformState.needTransform = false;
  return Duplex.prototype.push.call(this, chunk, encoding);
}; // This is the part where you do stuff!
// override this function in implementation classes.
// 'chunk' is an input chunk.
//
// Call `push(newChunk)` to pass along transformed output
// to the readable side.  You may call 'push' zero or more times.
//
// Call `cb(err)` when you are done with this chunk.  If you pass
// an error, then that'll put the hurt on the whole operation.  If you
// never call cb(), then you'll never get another chunk.


Transform.prototype._transform = function (chunk, encoding, cb) {
  cb(new ERR_METHOD_NOT_IMPLEMENTED('_transform()'));
};

Transform.prototype._write = function (chunk, encoding, cb) {
  var ts = this._transformState;
  ts.writecb = cb;
  ts.writechunk = chunk;
  ts.writeencoding = encoding;

  if (!ts.transforming) {
    var rs = this._readableState;
    if (ts.needTransform || rs.needReadable || rs.length < rs.highWaterMark) this._read(rs.highWaterMark);
  }
}; // Doesn't matter what the args are here.
// _transform does all the work.
// That we got here means that the readable side wants more data.


Transform.prototype._read = function (n) {
  var ts = this._transformState;

  if (ts.writechunk !== null && !ts.transforming) {
    ts.transforming = true;

    this._transform(ts.writechunk, ts.writeencoding, ts.afterTransform);
  } else {
    // mark that we need a transform, so that any data that comes in
    // will get processed, now that we've asked for it.
    ts.needTransform = true;
  }
};

Transform.prototype._destroy = function (err, cb) {
  Duplex.prototype._destroy.call(this, err, function (err2) {
    cb(err2);
  });
};

function done(stream, er, data) {
  if (er) return stream.emit('error', er);
  if (data != null) // single equals check for both `null` and `undefined`
    stream.push(data); // TODO(BridgeAR): Write a test for these two error cases
  // if there's nothing in the write buffer, then that means
  // that nothing more will ever be provided

  if (stream._writableState.length) throw new ERR_TRANSFORM_WITH_LENGTH_0();
  if (stream._transformState.transforming) throw new ERR_TRANSFORM_ALREADY_TRANSFORMING();
  return stream.push(null);
}

/***/ }),

/***/ "./node_modules/hash-base/node_modules/readable-stream/lib/_stream_writable.js":
/*!*************************************************************************************!*\
  !*** ./node_modules/hash-base/node_modules/readable-stream/lib/_stream_writable.js ***!
  \*************************************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global, process) {// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// A bit simpler than readable streams.
// Implement an async ._write(chunk, encoding, cb), and it'll handle all
// the drain event emission and buffering.


module.exports = Writable;
/* <replacement> */

function WriteReq(chunk, encoding, cb) {
  this.chunk = chunk;
  this.encoding = encoding;
  this.callback = cb;
  this.next = null;
} // It seems a linked list but it is not
// there will be only 2 of these for each stream


function CorkedRequest(state) {
  var _this = this;

  this.next = null;
  this.entry = null;

  this.finish = function () {
    onCorkedFinish(_this, state);
  };
}
/* </replacement> */

/*<replacement>*/


var Duplex;
/*</replacement>*/

Writable.WritableState = WritableState;
/*<replacement>*/

var internalUtil = {
  deprecate: __webpack_require__(/*! util-deprecate */ "./node_modules/util-deprecate/browser.js")
};
/*</replacement>*/

/*<replacement>*/

var Stream = __webpack_require__(/*! ./internal/streams/stream */ "./node_modules/hash-base/node_modules/readable-stream/lib/internal/streams/stream-browser.js");
/*</replacement>*/


var Buffer = __webpack_require__(/*! buffer */ "./node_modules/node-libs-browser/node_modules/buffer/index.js").Buffer;

var OurUint8Array = global.Uint8Array || function () {};

function _uint8ArrayToBuffer(chunk) {
  return Buffer.from(chunk);
}

function _isUint8Array(obj) {
  return Buffer.isBuffer(obj) || obj instanceof OurUint8Array;
}

var destroyImpl = __webpack_require__(/*! ./internal/streams/destroy */ "./node_modules/hash-base/node_modules/readable-stream/lib/internal/streams/destroy.js");

var _require = __webpack_require__(/*! ./internal/streams/state */ "./node_modules/hash-base/node_modules/readable-stream/lib/internal/streams/state.js"),
    getHighWaterMark = _require.getHighWaterMark;

var _require$codes = __webpack_require__(/*! ../errors */ "./node_modules/hash-base/node_modules/readable-stream/errors-browser.js").codes,
    ERR_INVALID_ARG_TYPE = _require$codes.ERR_INVALID_ARG_TYPE,
    ERR_METHOD_NOT_IMPLEMENTED = _require$codes.ERR_METHOD_NOT_IMPLEMENTED,
    ERR_MULTIPLE_CALLBACK = _require$codes.ERR_MULTIPLE_CALLBACK,
    ERR_STREAM_CANNOT_PIPE = _require$codes.ERR_STREAM_CANNOT_PIPE,
    ERR_STREAM_DESTROYED = _require$codes.ERR_STREAM_DESTROYED,
    ERR_STREAM_NULL_VALUES = _require$codes.ERR_STREAM_NULL_VALUES,
    ERR_STREAM_WRITE_AFTER_END = _require$codes.ERR_STREAM_WRITE_AFTER_END,
    ERR_UNKNOWN_ENCODING = _require$codes.ERR_UNKNOWN_ENCODING;

var errorOrDestroy = destroyImpl.errorOrDestroy;

__webpack_require__(/*! inherits */ "./node_modules/inherits/inherits_browser.js")(Writable, Stream);

function nop() {}

function WritableState(options, stream, isDuplex) {
  Duplex = Duplex || __webpack_require__(/*! ./_stream_duplex */ "./node_modules/hash-base/node_modules/readable-stream/lib/_stream_duplex.js");
  options = options || {}; // Duplex streams are both readable and writable, but share
  // the same options object.
  // However, some cases require setting options to different
  // values for the readable and the writable sides of the duplex stream,
  // e.g. options.readableObjectMode vs. options.writableObjectMode, etc.

  if (typeof isDuplex !== 'boolean') isDuplex = stream instanceof Duplex; // object stream flag to indicate whether or not this stream
  // contains buffers or objects.

  this.objectMode = !!options.objectMode;
  if (isDuplex) this.objectMode = this.objectMode || !!options.writableObjectMode; // the point at which write() starts returning false
  // Note: 0 is a valid value, means that we always return false if
  // the entire buffer is not flushed immediately on write()

  this.highWaterMark = getHighWaterMark(this, options, 'writableHighWaterMark', isDuplex); // if _final has been called

  this.finalCalled = false; // drain event flag.

  this.needDrain = false; // at the start of calling end()

  this.ending = false; // when end() has been called, and returned

  this.ended = false; // when 'finish' is emitted

  this.finished = false; // has it been destroyed

  this.destroyed = false; // should we decode strings into buffers before passing to _write?
  // this is here so that some node-core streams can optimize string
  // handling at a lower level.

  var noDecode = options.decodeStrings === false;
  this.decodeStrings = !noDecode; // Crypto is kind of old and crusty.  Historically, its default string
  // encoding is 'binary' so we have to make this configurable.
  // Everything else in the universe uses 'utf8', though.

  this.defaultEncoding = options.defaultEncoding || 'utf8'; // not an actual buffer we keep track of, but a measurement
  // of how much we're waiting to get pushed to some underlying
  // socket or file.

  this.length = 0; // a flag to see when we're in the middle of a write.

  this.writing = false; // when true all writes will be buffered until .uncork() call

  this.corked = 0; // a flag to be able to tell if the onwrite cb is called immediately,
  // or on a later tick.  We set this to true at first, because any
  // actions that shouldn't happen until "later" should generally also
  // not happen before the first write call.

  this.sync = true; // a flag to know if we're processing previously buffered items, which
  // may call the _write() callback in the same tick, so that we don't
  // end up in an overlapped onwrite situation.

  this.bufferProcessing = false; // the callback that's passed to _write(chunk,cb)

  this.onwrite = function (er) {
    onwrite(stream, er);
  }; // the callback that the user supplies to write(chunk,encoding,cb)


  this.writecb = null; // the amount that is being written when _write is called.

  this.writelen = 0;
  this.bufferedRequest = null;
  this.lastBufferedRequest = null; // number of pending user-supplied write callbacks
  // this must be 0 before 'finish' can be emitted

  this.pendingcb = 0; // emit prefinish if the only thing we're waiting for is _write cbs
  // This is relevant for synchronous Transform streams

  this.prefinished = false; // True if the error was already emitted and should not be thrown again

  this.errorEmitted = false; // Should close be emitted on destroy. Defaults to true.

  this.emitClose = options.emitClose !== false; // Should .destroy() be called after 'finish' (and potentially 'end')

  this.autoDestroy = !!options.autoDestroy; // count buffered requests

  this.bufferedRequestCount = 0; // allocate the first CorkedRequest, there is always
  // one allocated and free to use, and we maintain at most two

  this.corkedRequestsFree = new CorkedRequest(this);
}

WritableState.prototype.getBuffer = function getBuffer() {
  var current = this.bufferedRequest;
  var out = [];

  while (current) {
    out.push(current);
    current = current.next;
  }

  return out;
};

(function () {
  try {
    Object.defineProperty(WritableState.prototype, 'buffer', {
      get: internalUtil.deprecate(function writableStateBufferGetter() {
        return this.getBuffer();
      }, '_writableState.buffer is deprecated. Use _writableState.getBuffer ' + 'instead.', 'DEP0003')
    });
  } catch (_) {}
})(); // Test _writableState for inheritance to account for Duplex streams,
// whose prototype chain only points to Readable.


var realHasInstance;

if (typeof Symbol === 'function' && Symbol.hasInstance && typeof Function.prototype[Symbol.hasInstance] === 'function') {
  realHasInstance = Function.prototype[Symbol.hasInstance];
  Object.defineProperty(Writable, Symbol.hasInstance, {
    value: function value(object) {
      if (realHasInstance.call(this, object)) return true;
      if (this !== Writable) return false;
      return object && object._writableState instanceof WritableState;
    }
  });
} else {
  realHasInstance = function realHasInstance(object) {
    return object instanceof this;
  };
}

function Writable(options) {
  Duplex = Duplex || __webpack_require__(/*! ./_stream_duplex */ "./node_modules/hash-base/node_modules/readable-stream/lib/_stream_duplex.js"); // Writable ctor is applied to Duplexes, too.
  // `realHasInstance` is necessary because using plain `instanceof`
  // would return false, as no `_writableState` property is attached.
  // Trying to use the custom `instanceof` for Writable here will also break the
  // Node.js LazyTransform implementation, which has a non-trivial getter for
  // `_writableState` that would lead to infinite recursion.
  // Checking for a Stream.Duplex instance is faster here instead of inside
  // the WritableState constructor, at least with V8 6.5

  var isDuplex = this instanceof Duplex;
  if (!isDuplex && !realHasInstance.call(Writable, this)) return new Writable(options);
  this._writableState = new WritableState(options, this, isDuplex); // legacy.

  this.writable = true;

  if (options) {
    if (typeof options.write === 'function') this._write = options.write;
    if (typeof options.writev === 'function') this._writev = options.writev;
    if (typeof options.destroy === 'function') this._destroy = options.destroy;
    if (typeof options.final === 'function') this._final = options.final;
  }

  Stream.call(this);
} // Otherwise people can pipe Writable streams, which is just wrong.


Writable.prototype.pipe = function () {
  errorOrDestroy(this, new ERR_STREAM_CANNOT_PIPE());
};

function writeAfterEnd(stream, cb) {
  var er = new ERR_STREAM_WRITE_AFTER_END(); // TODO: defer error events consistently everywhere, not just the cb

  errorOrDestroy(stream, er);
  process.nextTick(cb, er);
} // Checks that a user-supplied chunk is valid, especially for the particular
// mode the stream is in. Currently this means that `null` is never accepted
// and undefined/non-string values are only allowed in object mode.


function validChunk(stream, state, chunk, cb) {
  var er;

  if (chunk === null) {
    er = new ERR_STREAM_NULL_VALUES();
  } else if (typeof chunk !== 'string' && !state.objectMode) {
    er = new ERR_INVALID_ARG_TYPE('chunk', ['string', 'Buffer'], chunk);
  }

  if (er) {
    errorOrDestroy(stream, er);
    process.nextTick(cb, er);
    return false;
  }

  return true;
}

Writable.prototype.write = function (chunk, encoding, cb) {
  var state = this._writableState;
  var ret = false;

  var isBuf = !state.objectMode && _isUint8Array(chunk);

  if (isBuf && !Buffer.isBuffer(chunk)) {
    chunk = _uint8ArrayToBuffer(chunk);
  }

  if (typeof encoding === 'function') {
    cb = encoding;
    encoding = null;
  }

  if (isBuf) encoding = 'buffer';else if (!encoding) encoding = state.defaultEncoding;
  if (typeof cb !== 'function') cb = nop;
  if (state.ending) writeAfterEnd(this, cb);else if (isBuf || validChunk(this, state, chunk, cb)) {
    state.pendingcb++;
    ret = writeOrBuffer(this, state, isBuf, chunk, encoding, cb);
  }
  return ret;
};

Writable.prototype.cork = function () {
  this._writableState.corked++;
};

Writable.prototype.uncork = function () {
  var state = this._writableState;

  if (state.corked) {
    state.corked--;
    if (!state.writing && !state.corked && !state.bufferProcessing && state.bufferedRequest) clearBuffer(this, state);
  }
};

Writable.prototype.setDefaultEncoding = function setDefaultEncoding(encoding) {
  // node::ParseEncoding() requires lower case.
  if (typeof encoding === 'string') encoding = encoding.toLowerCase();
  if (!(['hex', 'utf8', 'utf-8', 'ascii', 'binary', 'base64', 'ucs2', 'ucs-2', 'utf16le', 'utf-16le', 'raw'].indexOf((encoding + '').toLowerCase()) > -1)) throw new ERR_UNKNOWN_ENCODING(encoding);
  this._writableState.defaultEncoding = encoding;
  return this;
};

Object.defineProperty(Writable.prototype, 'writableBuffer', {
  // making it explicit this property is not enumerable
  // because otherwise some prototype manipulation in
  // userland will fail
  enumerable: false,
  get: function get() {
    return this._writableState && this._writableState.getBuffer();
  }
});

function decodeChunk(state, chunk, encoding) {
  if (!state.objectMode && state.decodeStrings !== false && typeof chunk === 'string') {
    chunk = Buffer.from(chunk, encoding);
  }

  return chunk;
}

Object.defineProperty(Writable.prototype, 'writableHighWaterMark', {
  // making it explicit this property is not enumerable
  // because otherwise some prototype manipulation in
  // userland will fail
  enumerable: false,
  get: function get() {
    return this._writableState.highWaterMark;
  }
}); // if we're already writing something, then just put this
// in the queue, and wait our turn.  Otherwise, call _write
// If we return false, then we need a drain event, so set that flag.

function writeOrBuffer(stream, state, isBuf, chunk, encoding, cb) {
  if (!isBuf) {
    var newChunk = decodeChunk(state, chunk, encoding);

    if (chunk !== newChunk) {
      isBuf = true;
      encoding = 'buffer';
      chunk = newChunk;
    }
  }

  var len = state.objectMode ? 1 : chunk.length;
  state.length += len;
  var ret = state.length < state.highWaterMark; // we must ensure that previous needDrain will not be reset to false.

  if (!ret) state.needDrain = true;

  if (state.writing || state.corked) {
    var last = state.lastBufferedRequest;
    state.lastBufferedRequest = {
      chunk: chunk,
      encoding: encoding,
      isBuf: isBuf,
      callback: cb,
      next: null
    };

    if (last) {
      last.next = state.lastBufferedRequest;
    } else {
      state.bufferedRequest = state.lastBufferedRequest;
    }

    state.bufferedRequestCount += 1;
  } else {
    doWrite(stream, state, false, len, chunk, encoding, cb);
  }

  return ret;
}

function doWrite(stream, state, writev, len, chunk, encoding, cb) {
  state.writelen = len;
  state.writecb = cb;
  state.writing = true;
  state.sync = true;
  if (state.destroyed) state.onwrite(new ERR_STREAM_DESTROYED('write'));else if (writev) stream._writev(chunk, state.onwrite);else stream._write(chunk, encoding, state.onwrite);
  state.sync = false;
}

function onwriteError(stream, state, sync, er, cb) {
  --state.pendingcb;

  if (sync) {
    // defer the callback if we are being called synchronously
    // to avoid piling up things on the stack
    process.nextTick(cb, er); // this can emit finish, and it will always happen
    // after error

    process.nextTick(finishMaybe, stream, state);
    stream._writableState.errorEmitted = true;
    errorOrDestroy(stream, er);
  } else {
    // the caller expect this to happen before if
    // it is async
    cb(er);
    stream._writableState.errorEmitted = true;
    errorOrDestroy(stream, er); // this can emit finish, but finish must
    // always follow error

    finishMaybe(stream, state);
  }
}

function onwriteStateUpdate(state) {
  state.writing = false;
  state.writecb = null;
  state.length -= state.writelen;
  state.writelen = 0;
}

function onwrite(stream, er) {
  var state = stream._writableState;
  var sync = state.sync;
  var cb = state.writecb;
  if (typeof cb !== 'function') throw new ERR_MULTIPLE_CALLBACK();
  onwriteStateUpdate(state);
  if (er) onwriteError(stream, state, sync, er, cb);else {
    // Check if we're actually ready to finish, but don't emit yet
    var finished = needFinish(state) || stream.destroyed;

    if (!finished && !state.corked && !state.bufferProcessing && state.bufferedRequest) {
      clearBuffer(stream, state);
    }

    if (sync) {
      process.nextTick(afterWrite, stream, state, finished, cb);
    } else {
      afterWrite(stream, state, finished, cb);
    }
  }
}

function afterWrite(stream, state, finished, cb) {
  if (!finished) onwriteDrain(stream, state);
  state.pendingcb--;
  cb();
  finishMaybe(stream, state);
} // Must force callback to be called on nextTick, so that we don't
// emit 'drain' before the write() consumer gets the 'false' return
// value, and has a chance to attach a 'drain' listener.


function onwriteDrain(stream, state) {
  if (state.length === 0 && state.needDrain) {
    state.needDrain = false;
    stream.emit('drain');
  }
} // if there's something in the buffer waiting, then process it


function clearBuffer(stream, state) {
  state.bufferProcessing = true;
  var entry = state.bufferedRequest;

  if (stream._writev && entry && entry.next) {
    // Fast case, write everything using _writev()
    var l = state.bufferedRequestCount;
    var buffer = new Array(l);
    var holder = state.corkedRequestsFree;
    holder.entry = entry;
    var count = 0;
    var allBuffers = true;

    while (entry) {
      buffer[count] = entry;
      if (!entry.isBuf) allBuffers = false;
      entry = entry.next;
      count += 1;
    }

    buffer.allBuffers = allBuffers;
    doWrite(stream, state, true, state.length, buffer, '', holder.finish); // doWrite is almost always async, defer these to save a bit of time
    // as the hot path ends with doWrite

    state.pendingcb++;
    state.lastBufferedRequest = null;

    if (holder.next) {
      state.corkedRequestsFree = holder.next;
      holder.next = null;
    } else {
      state.corkedRequestsFree = new CorkedRequest(state);
    }

    state.bufferedRequestCount = 0;
  } else {
    // Slow case, write chunks one-by-one
    while (entry) {
      var chunk = entry.chunk;
      var encoding = entry.encoding;
      var cb = entry.callback;
      var len = state.objectMode ? 1 : chunk.length;
      doWrite(stream, state, false, len, chunk, encoding, cb);
      entry = entry.next;
      state.bufferedRequestCount--; // if we didn't call the onwrite immediately, then
      // it means that we need to wait until it does.
      // also, that means that the chunk and cb are currently
      // being processed, so move the buffer counter past them.

      if (state.writing) {
        break;
      }
    }

    if (entry === null) state.lastBufferedRequest = null;
  }

  state.bufferedRequest = entry;
  state.bufferProcessing = false;
}

Writable.prototype._write = function (chunk, encoding, cb) {
  cb(new ERR_METHOD_NOT_IMPLEMENTED('_write()'));
};

Writable.prototype._writev = null;

Writable.prototype.end = function (chunk, encoding, cb) {
  var state = this._writableState;

  if (typeof chunk === 'function') {
    cb = chunk;
    chunk = null;
    encoding = null;
  } else if (typeof encoding === 'function') {
    cb = encoding;
    encoding = null;
  }

  if (chunk !== null && chunk !== undefined) this.write(chunk, encoding); // .end() fully uncorks

  if (state.corked) {
    state.corked = 1;
    this.uncork();
  } // ignore unnecessary end() calls.


  if (!state.ending) endWritable(this, state, cb);
  return this;
};

Object.defineProperty(Writable.prototype, 'writableLength', {
  // making it explicit this property is not enumerable
  // because otherwise some prototype manipulation in
  // userland will fail
  enumerable: false,
  get: function get() {
    return this._writableState.length;
  }
});

function needFinish(state) {
  return state.ending && state.length === 0 && state.bufferedRequest === null && !state.finished && !state.writing;
}

function callFinal(stream, state) {
  stream._final(function (err) {
    state.pendingcb--;

    if (err) {
      errorOrDestroy(stream, err);
    }

    state.prefinished = true;
    stream.emit('prefinish');
    finishMaybe(stream, state);
  });
}

function prefinish(stream, state) {
  if (!state.prefinished && !state.finalCalled) {
    if (typeof stream._final === 'function' && !state.destroyed) {
      state.pendingcb++;
      state.finalCalled = true;
      process.nextTick(callFinal, stream, state);
    } else {
      state.prefinished = true;
      stream.emit('prefinish');
    }
  }
}

function finishMaybe(stream, state) {
  var need = needFinish(state);

  if (need) {
    prefinish(stream, state);

    if (state.pendingcb === 0) {
      state.finished = true;
      stream.emit('finish');

      if (state.autoDestroy) {
        // In case of duplex streams we need a way to detect
        // if the readable side is ready for autoDestroy as well
        var rState = stream._readableState;

        if (!rState || rState.autoDestroy && rState.endEmitted) {
          stream.destroy();
        }
      }
    }
  }

  return need;
}

function endWritable(stream, state, cb) {
  state.ending = true;
  finishMaybe(stream, state);

  if (cb) {
    if (state.finished) process.nextTick(cb);else stream.once('finish', cb);
  }

  state.ended = true;
  stream.writable = false;
}

function onCorkedFinish(corkReq, state, err) {
  var entry = corkReq.entry;
  corkReq.entry = null;

  while (entry) {
    var cb = entry.callback;
    state.pendingcb--;
    cb(err);
    entry = entry.next;
  } // reuse the free corkReq.


  state.corkedRequestsFree.next = corkReq;
}

Object.defineProperty(Writable.prototype, 'destroyed', {
  // making it explicit this property is not enumerable
  // because otherwise some prototype manipulation in
  // userland will fail
  enumerable: false,
  get: function get() {
    if (this._writableState === undefined) {
      return false;
    }

    return this._writableState.destroyed;
  },
  set: function set(value) {
    // we ignore the value if the stream
    // has not been initialized yet
    if (!this._writableState) {
      return;
    } // backward compatibility, the user is explicitly
    // managing destroyed


    this._writableState.destroyed = value;
  }
});
Writable.prototype.destroy = destroyImpl.destroy;
Writable.prototype._undestroy = destroyImpl.undestroy;

Writable.prototype._destroy = function (err, cb) {
  cb(err);
};
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(/*! ./../../../../webpack/buildin/global.js */ "./node_modules/webpack/buildin/global.js"), __webpack_require__(/*! ./../../../../process/browser.js */ "./node_modules/process/browser.js")))

/***/ }),

/***/ "./node_modules/hash-base/node_modules/readable-stream/lib/internal/streams/async_iterator.js":
/*!****************************************************************************************************!*\
  !*** ./node_modules/hash-base/node_modules/readable-stream/lib/internal/streams/async_iterator.js ***!
  \****************************************************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {

var _Object$setPrototypeO;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var finished = __webpack_require__(/*! ./end-of-stream */ "./node_modules/hash-base/node_modules/readable-stream/lib/internal/streams/end-of-stream.js");

var kLastResolve = Symbol('lastResolve');
var kLastReject = Symbol('lastReject');
var kError = Symbol('error');
var kEnded = Symbol('ended');
var kLastPromise = Symbol('lastPromise');
var kHandlePromise = Symbol('handlePromise');
var kStream = Symbol('stream');

function createIterResult(value, done) {
  return {
    value: value,
    done: done
  };
}

function readAndResolve(iter) {
  var resolve = iter[kLastResolve];

  if (resolve !== null) {
    var data = iter[kStream].read(); // we defer if data is null
    // we can be expecting either 'end' or
    // 'error'

    if (data !== null) {
      iter[kLastPromise] = null;
      iter[kLastResolve] = null;
      iter[kLastReject] = null;
      resolve(createIterResult(data, false));
    }
  }
}

function onReadable(iter) {
  // we wait for the next tick, because it might
  // emit an error with process.nextTick
  process.nextTick(readAndResolve, iter);
}

function wrapForNext(lastPromise, iter) {
  return function (resolve, reject) {
    lastPromise.then(function () {
      if (iter[kEnded]) {
        resolve(createIterResult(undefined, true));
        return;
      }

      iter[kHandlePromise](resolve, reject);
    }, reject);
  };
}

var AsyncIteratorPrototype = Object.getPrototypeOf(function () {});
var ReadableStreamAsyncIteratorPrototype = Object.setPrototypeOf((_Object$setPrototypeO = {
  get stream() {
    return this[kStream];
  },

  next: function next() {
    var _this = this;

    // if we have detected an error in the meanwhile
    // reject straight away
    var error = this[kError];

    if (error !== null) {
      return Promise.reject(error);
    }

    if (this[kEnded]) {
      return Promise.resolve(createIterResult(undefined, true));
    }

    if (this[kStream].destroyed) {
      // We need to defer via nextTick because if .destroy(err) is
      // called, the error will be emitted via nextTick, and
      // we cannot guarantee that there is no error lingering around
      // waiting to be emitted.
      return new Promise(function (resolve, reject) {
        process.nextTick(function () {
          if (_this[kError]) {
            reject(_this[kError]);
          } else {
            resolve(createIterResult(undefined, true));
          }
        });
      });
    } // if we have multiple next() calls
    // we will wait for the previous Promise to finish
    // this logic is optimized to support for await loops,
    // where next() is only called once at a time


    var lastPromise = this[kLastPromise];
    var promise;

    if (lastPromise) {
      promise = new Promise(wrapForNext(lastPromise, this));
    } else {
      // fast path needed to support multiple this.push()
      // without triggering the next() queue
      var data = this[kStream].read();

      if (data !== null) {
        return Promise.resolve(createIterResult(data, false));
      }

      promise = new Promise(this[kHandlePromise]);
    }

    this[kLastPromise] = promise;
    return promise;
  }
}, _defineProperty(_Object$setPrototypeO, Symbol.asyncIterator, function () {
  return this;
}), _defineProperty(_Object$setPrototypeO, "return", function _return() {
  var _this2 = this;

  // destroy(err, cb) is a private API
  // we can guarantee we have that here, because we control the
  // Readable class this is attached to
  return new Promise(function (resolve, reject) {
    _this2[kStream].destroy(null, function (err) {
      if (err) {
        reject(err);
        return;
      }

      resolve(createIterResult(undefined, true));
    });
  });
}), _Object$setPrototypeO), AsyncIteratorPrototype);

var createReadableStreamAsyncIterator = function createReadableStreamAsyncIterator(stream) {
  var _Object$create;

  var iterator = Object.create(ReadableStreamAsyncIteratorPrototype, (_Object$create = {}, _defineProperty(_Object$create, kStream, {
    value: stream,
    writable: true
  }), _defineProperty(_Object$create, kLastResolve, {
    value: null,
    writable: true
  }), _defineProperty(_Object$create, kLastReject, {
    value: null,
    writable: true
  }), _defineProperty(_Object$create, kError, {
    value: null,
    writable: true
  }), _defineProperty(_Object$create, kEnded, {
    value: stream._readableState.endEmitted,
    writable: true
  }), _defineProperty(_Object$create, kHandlePromise, {
    value: function value(resolve, reject) {
      var data = iterator[kStream].read();

      if (data) {
        iterator[kLastPromise] = null;
        iterator[kLastResolve] = null;
        iterator[kLastReject] = null;
        resolve(createIterResult(data, false));
      } else {
        iterator[kLastResolve] = resolve;
        iterator[kLastReject] = reject;
      }
    },
    writable: true
  }), _Object$create));
  iterator[kLastPromise] = null;
  finished(stream, function (err) {
    if (err && err.code !== 'ERR_STREAM_PREMATURE_CLOSE') {
      var reject = iterator[kLastReject]; // reject if we are waiting for data in the Promise
      // returned by next() and store the error

      if (reject !== null) {
        iterator[kLastPromise] = null;
        iterator[kLastResolve] = null;
        iterator[kLastReject] = null;
        reject(err);
      }

      iterator[kError] = err;
      return;
    }

    var resolve = iterator[kLastResolve];

    if (resolve !== null) {
      iterator[kLastPromise] = null;
      iterator[kLastResolve] = null;
      iterator[kLastReject] = null;
      resolve(createIterResult(undefined, true));
    }

    iterator[kEnded] = true;
  });
  stream.on('readable', onReadable.bind(null, iterator));
  return iterator;
};

module.exports = createReadableStreamAsyncIterator;
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(/*! ./../../../../../../process/browser.js */ "./node_modules/process/browser.js")))

/***/ }),

/***/ "./node_modules/hash-base/node_modules/readable-stream/lib/internal/streams/buffer_list.js":
/*!*************************************************************************************************!*\
  !*** ./node_modules/hash-base/node_modules/readable-stream/lib/internal/streams/buffer_list.js ***!
  \*************************************************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var _require = __webpack_require__(/*! buffer */ "./node_modules/node-libs-browser/node_modules/buffer/index.js"),
    Buffer = _require.Buffer;

var _require2 = __webpack_require__(/*! util */ 1),
    inspect = _require2.inspect;

var custom = inspect && inspect.custom || 'inspect';

function copyBuffer(src, target, offset) {
  Buffer.prototype.copy.call(src, target, offset);
}

module.exports =
/*#__PURE__*/
function () {
  function BufferList() {
    _classCallCheck(this, BufferList);

    this.head = null;
    this.tail = null;
    this.length = 0;
  }

  _createClass(BufferList, [{
    key: "push",
    value: function push(v) {
      var entry = {
        data: v,
        next: null
      };
      if (this.length > 0) this.tail.next = entry;else this.head = entry;
      this.tail = entry;
      ++this.length;
    }
  }, {
    key: "unshift",
    value: function unshift(v) {
      var entry = {
        data: v,
        next: this.head
      };
      if (this.length === 0) this.tail = entry;
      this.head = entry;
      ++this.length;
    }
  }, {
    key: "shift",
    value: function shift() {
      if (this.length === 0) return;
      var ret = this.head.data;
      if (this.length === 1) this.head = this.tail = null;else this.head = this.head.next;
      --this.length;
      return ret;
    }
  }, {
    key: "clear",
    value: function clear() {
      this.head = this.tail = null;
      this.length = 0;
    }
  }, {
    key: "join",
    value: function join(s) {
      if (this.length === 0) return '';
      var p = this.head;
      var ret = '' + p.data;

      while (p = p.next) {
        ret += s + p.data;
      }

      return ret;
    }
  }, {
    key: "concat",
    value: function concat(n) {
      if (this.length === 0) return Buffer.alloc(0);
      var ret = Buffer.allocUnsafe(n >>> 0);
      var p = this.head;
      var i = 0;

      while (p) {
        copyBuffer(p.data, ret, i);
        i += p.data.length;
        p = p.next;
      }

      return ret;
    } // Consumes a specified amount of bytes or characters from the buffered data.

  }, {
    key: "consume",
    value: function consume(n, hasStrings) {
      var ret;

      if (n < this.head.data.length) {
        // `slice` is the same for buffers and strings.
        ret = this.head.data.slice(0, n);
        this.head.data = this.head.data.slice(n);
      } else if (n === this.head.data.length) {
        // First chunk is a perfect match.
        ret = this.shift();
      } else {
        // Result spans more than one buffer.
        ret = hasStrings ? this._getString(n) : this._getBuffer(n);
      }

      return ret;
    }
  }, {
    key: "first",
    value: function first() {
      return this.head.data;
    } // Consumes a specified amount of characters from the buffered data.

  }, {
    key: "_getString",
    value: function _getString(n) {
      var p = this.head;
      var c = 1;
      var ret = p.data;
      n -= ret.length;

      while (p = p.next) {
        var str = p.data;
        var nb = n > str.length ? str.length : n;
        if (nb === str.length) ret += str;else ret += str.slice(0, n);
        n -= nb;

        if (n === 0) {
          if (nb === str.length) {
            ++c;
            if (p.next) this.head = p.next;else this.head = this.tail = null;
          } else {
            this.head = p;
            p.data = str.slice(nb);
          }

          break;
        }

        ++c;
      }

      this.length -= c;
      return ret;
    } // Consumes a specified amount of bytes from the buffered data.

  }, {
    key: "_getBuffer",
    value: function _getBuffer(n) {
      var ret = Buffer.allocUnsafe(n);
      var p = this.head;
      var c = 1;
      p.data.copy(ret);
      n -= p.data.length;

      while (p = p.next) {
        var buf = p.data;
        var nb = n > buf.length ? buf.length : n;
        buf.copy(ret, ret.length - n, 0, nb);
        n -= nb;

        if (n === 0) {
          if (nb === buf.length) {
            ++c;
            if (p.next) this.head = p.next;else this.head = this.tail = null;
          } else {
            this.head = p;
            p.data = buf.slice(nb);
          }

          break;
        }

        ++c;
      }

      this.length -= c;
      return ret;
    } // Make sure the linked list only shows the minimal necessary information.

  }, {
    key: custom,
    value: function value(_, options) {
      return inspect(this, _objectSpread({}, options, {
        // Only inspect one level.
        depth: 0,
        // It should not recurse.
        customInspect: false
      }));
    }
  }]);

  return BufferList;
}();

/***/ }),

/***/ "./node_modules/hash-base/node_modules/readable-stream/lib/internal/streams/destroy.js":
/*!*********************************************************************************************!*\
  !*** ./node_modules/hash-base/node_modules/readable-stream/lib/internal/streams/destroy.js ***!
  \*********************************************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) { // undocumented cb() API, needed for core, not for public API

function destroy(err, cb) {
  var _this = this;

  var readableDestroyed = this._readableState && this._readableState.destroyed;
  var writableDestroyed = this._writableState && this._writableState.destroyed;

  if (readableDestroyed || writableDestroyed) {
    if (cb) {
      cb(err);
    } else if (err) {
      if (!this._writableState) {
        process.nextTick(emitErrorNT, this, err);
      } else if (!this._writableState.errorEmitted) {
        this._writableState.errorEmitted = true;
        process.nextTick(emitErrorNT, this, err);
      }
    }

    return this;
  } // we set destroyed to true before firing error callbacks in order
  // to make it re-entrance safe in case destroy() is called within callbacks


  if (this._readableState) {
    this._readableState.destroyed = true;
  } // if this is a duplex stream mark the writable part as destroyed as well


  if (this._writableState) {
    this._writableState.destroyed = true;
  }

  this._destroy(err || null, function (err) {
    if (!cb && err) {
      if (!_this._writableState) {
        process.nextTick(emitErrorAndCloseNT, _this, err);
      } else if (!_this._writableState.errorEmitted) {
        _this._writableState.errorEmitted = true;
        process.nextTick(emitErrorAndCloseNT, _this, err);
      } else {
        process.nextTick(emitCloseNT, _this);
      }
    } else if (cb) {
      process.nextTick(emitCloseNT, _this);
      cb(err);
    } else {
      process.nextTick(emitCloseNT, _this);
    }
  });

  return this;
}

function emitErrorAndCloseNT(self, err) {
  emitErrorNT(self, err);
  emitCloseNT(self);
}

function emitCloseNT(self) {
  if (self._writableState && !self._writableState.emitClose) return;
  if (self._readableState && !self._readableState.emitClose) return;
  self.emit('close');
}

function undestroy() {
  if (this._readableState) {
    this._readableState.destroyed = false;
    this._readableState.reading = false;
    this._readableState.ended = false;
    this._readableState.endEmitted = false;
  }

  if (this._writableState) {
    this._writableState.destroyed = false;
    this._writableState.ended = false;
    this._writableState.ending = false;
    this._writableState.finalCalled = false;
    this._writableState.prefinished = false;
    this._writableState.finished = false;
    this._writableState.errorEmitted = false;
  }
}

function emitErrorNT(self, err) {
  self.emit('error', err);
}

function errorOrDestroy(stream, err) {
  // We have tests that rely on errors being emitted
  // in the same tick, so changing this is semver major.
  // For now when you opt-in to autoDestroy we allow
  // the error to be emitted nextTick. In a future
  // semver major update we should change the default to this.
  var rState = stream._readableState;
  var wState = stream._writableState;
  if (rState && rState.autoDestroy || wState && wState.autoDestroy) stream.destroy(err);else stream.emit('error', err);
}

module.exports = {
  destroy: destroy,
  undestroy: undestroy,
  errorOrDestroy: errorOrDestroy
};
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(/*! ./../../../../../../process/browser.js */ "./node_modules/process/browser.js")))

/***/ }),

/***/ "./node_modules/hash-base/node_modules/readable-stream/lib/internal/streams/end-of-stream.js":
/*!***************************************************************************************************!*\
  !*** ./node_modules/hash-base/node_modules/readable-stream/lib/internal/streams/end-of-stream.js ***!
  \***************************************************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Ported from https://github.com/mafintosh/end-of-stream with
// permission from the author, Mathias Buus (@mafintosh).


var ERR_STREAM_PREMATURE_CLOSE = __webpack_require__(/*! ../../../errors */ "./node_modules/hash-base/node_modules/readable-stream/errors-browser.js").codes.ERR_STREAM_PREMATURE_CLOSE;

function once(callback) {
  var called = false;
  return function () {
    if (called) return;
    called = true;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    callback.apply(this, args);
  };
}

function noop() {}

function isRequest(stream) {
  return stream.setHeader && typeof stream.abort === 'function';
}

function eos(stream, opts, callback) {
  if (typeof opts === 'function') return eos(stream, null, opts);
  if (!opts) opts = {};
  callback = once(callback || noop);
  var readable = opts.readable || opts.readable !== false && stream.readable;
  var writable = opts.writable || opts.writable !== false && stream.writable;

  var onlegacyfinish = function onlegacyfinish() {
    if (!stream.writable) onfinish();
  };

  var writableEnded = stream._writableState && stream._writableState.finished;

  var onfinish = function onfinish() {
    writable = false;
    writableEnded = true;
    if (!readable) callback.call(stream);
  };

  var readableEnded = stream._readableState && stream._readableState.endEmitted;

  var onend = function onend() {
    readable = false;
    readableEnded = true;
    if (!writable) callback.call(stream);
  };

  var onerror = function onerror(err) {
    callback.call(stream, err);
  };

  var onclose = function onclose() {
    var err;

    if (readable && !readableEnded) {
      if (!stream._readableState || !stream._readableState.ended) err = new ERR_STREAM_PREMATURE_CLOSE();
      return callback.call(stream, err);
    }

    if (writable && !writableEnded) {
      if (!stream._writableState || !stream._writableState.ended) err = new ERR_STREAM_PREMATURE_CLOSE();
      return callback.call(stream, err);
    }
  };

  var onrequest = function onrequest() {
    stream.req.on('finish', onfinish);
  };

  if (isRequest(stream)) {
    stream.on('complete', onfinish);
    stream.on('abort', onclose);
    if (stream.req) onrequest();else stream.on('request', onrequest);
  } else if (writable && !stream._writableState) {
    // legacy streams
    stream.on('end', onlegacyfinish);
    stream.on('close', onlegacyfinish);
  }

  stream.on('end', onend);
  stream.on('finish', onfinish);
  if (opts.error !== false) stream.on('error', onerror);
  stream.on('close', onclose);
  return function () {
    stream.removeListener('complete', onfinish);
    stream.removeListener('abort', onclose);
    stream.removeListener('request', onrequest);
    if (stream.req) stream.req.removeListener('finish', onfinish);
    stream.removeListener('end', onlegacyfinish);
    stream.removeListener('close', onlegacyfinish);
    stream.removeListener('finish', onfinish);
    stream.removeListener('end', onend);
    stream.removeListener('error', onerror);
    stream.removeListener('close', onclose);
  };
}

module.exports = eos;

/***/ }),

/***/ "./node_modules/hash-base/node_modules/readable-stream/lib/internal/streams/from-browser.js":
/*!**************************************************************************************************!*\
  !*** ./node_modules/hash-base/node_modules/readable-stream/lib/internal/streams/from-browser.js ***!
  \**************************************************************************************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = function () {
  throw new Error('Readable.from is not available in the browser')
};


/***/ }),

/***/ "./node_modules/hash-base/node_modules/readable-stream/lib/internal/streams/pipeline.js":
/*!**********************************************************************************************!*\
  !*** ./node_modules/hash-base/node_modules/readable-stream/lib/internal/streams/pipeline.js ***!
  \**********************************************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Ported from https://github.com/mafintosh/pump with
// permission from the author, Mathias Buus (@mafintosh).


var eos;

function once(callback) {
  var called = false;
  return function () {
    if (called) return;
    called = true;
    callback.apply(void 0, arguments);
  };
}

var _require$codes = __webpack_require__(/*! ../../../errors */ "./node_modules/hash-base/node_modules/readable-stream/errors-browser.js").codes,
    ERR_MISSING_ARGS = _require$codes.ERR_MISSING_ARGS,
    ERR_STREAM_DESTROYED = _require$codes.ERR_STREAM_DESTROYED;

function noop(err) {
  // Rethrow the error if it exists to avoid swallowing it
  if (err) throw err;
}

function isRequest(stream) {
  return stream.setHeader && typeof stream.abort === 'function';
}

function destroyer(stream, reading, writing, callback) {
  callback = once(callback);
  var closed = false;
  stream.on('close', function () {
    closed = true;
  });
  if (eos === undefined) eos = __webpack_require__(/*! ./end-of-stream */ "./node_modules/hash-base/node_modules/readable-stream/lib/internal/streams/end-of-stream.js");
  eos(stream, {
    readable: reading,
    writable: writing
  }, function (err) {
    if (err) return callback(err);
    closed = true;
    callback();
  });
  var destroyed = false;
  return function (err) {
    if (closed) return;
    if (destroyed) return;
    destroyed = true; // request.destroy just do .end - .abort is what we want

    if (isRequest(stream)) return stream.abort();
    if (typeof stream.destroy === 'function') return stream.destroy();
    callback(err || new ERR_STREAM_DESTROYED('pipe'));
  };
}

function call(fn) {
  fn();
}

function pipe(from, to) {
  return from.pipe(to);
}

function popCallback(streams) {
  if (!streams.length) return noop;
  if (typeof streams[streams.length - 1] !== 'function') return noop;
  return streams.pop();
}

function pipeline() {
  for (var _len = arguments.length, streams = new Array(_len), _key = 0; _key < _len; _key++) {
    streams[_key] = arguments[_key];
  }

  var callback = popCallback(streams);
  if (Array.isArray(streams[0])) streams = streams[0];

  if (streams.length < 2) {
    throw new ERR_MISSING_ARGS('streams');
  }

  var error;
  var destroys = streams.map(function (stream, i) {
    var reading = i < streams.length - 1;
    var writing = i > 0;
    return destroyer(stream, reading, writing, function (err) {
      if (!error) error = err;
      if (err) destroys.forEach(call);
      if (reading) return;
      destroys.forEach(call);
      callback(error);
    });
  });
  return streams.reduce(pipe);
}

module.exports = pipeline;

/***/ }),

/***/ "./node_modules/hash-base/node_modules/readable-stream/lib/internal/streams/state.js":
/*!*******************************************************************************************!*\
  !*** ./node_modules/hash-base/node_modules/readable-stream/lib/internal/streams/state.js ***!
  \*******************************************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var ERR_INVALID_OPT_VALUE = __webpack_require__(/*! ../../../errors */ "./node_modules/hash-base/node_modules/readable-stream/errors-browser.js").codes.ERR_INVALID_OPT_VALUE;

function highWaterMarkFrom(options, isDuplex, duplexKey) {
  return options.highWaterMark != null ? options.highWaterMark : isDuplex ? options[duplexKey] : null;
}

function getHighWaterMark(state, options, duplexKey, isDuplex) {
  var hwm = highWaterMarkFrom(options, isDuplex, duplexKey);

  if (hwm != null) {
    if (!(isFinite(hwm) && Math.floor(hwm) === hwm) || hwm < 0) {
      var name = isDuplex ? duplexKey : 'highWaterMark';
      throw new ERR_INVALID_OPT_VALUE(name, hwm);
    }

    return Math.floor(hwm);
  } // Default value


  return state.objectMode ? 16 : 16 * 1024;
}

module.exports = {
  getHighWaterMark: getHighWaterMark
};

/***/ }),

/***/ "./node_modules/hash-base/node_modules/readable-stream/lib/internal/streams/stream-browser.js":
/*!****************************************************************************************************!*\
  !*** ./node_modules/hash-base/node_modules/readable-stream/lib/internal/streams/stream-browser.js ***!
  \****************************************************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(/*! events */ "./node_modules/events/events.js").EventEmitter;


/***/ }),

/***/ "./node_modules/hash-base/node_modules/readable-stream/readable-browser.js":
/*!*********************************************************************************!*\
  !*** ./node_modules/hash-base/node_modules/readable-stream/readable-browser.js ***!
  \*********************************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(/*! ./lib/_stream_readable.js */ "./node_modules/hash-base/node_modules/readable-stream/lib/_stream_readable.js");
exports.Stream = exports;
exports.Readable = exports;
exports.Writable = __webpack_require__(/*! ./lib/_stream_writable.js */ "./node_modules/hash-base/node_modules/readable-stream/lib/_stream_writable.js");
exports.Duplex = __webpack_require__(/*! ./lib/_stream_duplex.js */ "./node_modules/hash-base/node_modules/readable-stream/lib/_stream_duplex.js");
exports.Transform = __webpack_require__(/*! ./lib/_stream_transform.js */ "./node_modules/hash-base/node_modules/readable-stream/lib/_stream_transform.js");
exports.PassThrough = __webpack_require__(/*! ./lib/_stream_passthrough.js */ "./node_modules/hash-base/node_modules/readable-stream/lib/_stream_passthrough.js");
exports.finished = __webpack_require__(/*! ./lib/internal/streams/end-of-stream.js */ "./node_modules/hash-base/node_modules/readable-stream/lib/internal/streams/end-of-stream.js");
exports.pipeline = __webpack_require__(/*! ./lib/internal/streams/pipeline.js */ "./node_modules/hash-base/node_modules/readable-stream/lib/internal/streams/pipeline.js");


/***/ }),

/***/ "./node_modules/hash-base/node_modules/safe-buffer/index.js":
/*!******************************************************************!*\
  !*** ./node_modules/hash-base/node_modules/safe-buffer/index.js ***!
  \******************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

/*! safe-buffer. MIT License. Feross Aboukhadijeh <https://feross.org/opensource> */
/* eslint-disable node/no-deprecated-api */
var buffer = __webpack_require__(/*! buffer */ "./node_modules/node-libs-browser/node_modules/buffer/index.js")
var Buffer = buffer.Buffer

// alternative to using Object.keys for old browsers
function copyProps (src, dst) {
  for (var key in src) {
    dst[key] = src[key]
  }
}
if (Buffer.from && Buffer.alloc && Buffer.allocUnsafe && Buffer.allocUnsafeSlow) {
  module.exports = buffer
} else {
  // Copy properties from require('buffer')
  copyProps(buffer, exports)
  exports.Buffer = SafeBuffer
}

function SafeBuffer (arg, encodingOrOffset, length) {
  return Buffer(arg, encodingOrOffset, length)
}

SafeBuffer.prototype = Object.create(Buffer.prototype)

// Copy static methods from Buffer
copyProps(Buffer, SafeBuffer)

SafeBuffer.from = function (arg, encodingOrOffset, length) {
  if (typeof arg === 'number') {
    throw new TypeError('Argument must not be a number')
  }
  return Buffer(arg, encodingOrOffset, length)
}

SafeBuffer.alloc = function (size, fill, encoding) {
  if (typeof size !== 'number') {
    throw new TypeError('Argument must be a number')
  }
  var buf = Buffer(size)
  if (fill !== undefined) {
    if (typeof encoding === 'string') {
      buf.fill(fill, encoding)
    } else {
      buf.fill(fill)
    }
  } else {
    buf.fill(0)
  }
  return buf
}

SafeBuffer.allocUnsafe = function (size) {
  if (typeof size !== 'number') {
    throw new TypeError('Argument must be a number')
  }
  return Buffer(size)
}

SafeBuffer.allocUnsafeSlow = function (size) {
  if (typeof size !== 'number') {
    throw new TypeError('Argument must be a number')
  }
  return buffer.SlowBuffer(size)
}


/***/ }),

/***/ "./node_modules/hash.js/lib/hash.js":
/*!******************************************!*\
  !*** ./node_modules/hash.js/lib/hash.js ***!
  \******************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var hash = exports;

hash.utils = __webpack_require__(/*! ./hash/utils */ "./node_modules/hash.js/lib/hash/utils.js");
hash.common = __webpack_require__(/*! ./hash/common */ "./node_modules/hash.js/lib/hash/common.js");
hash.sha = __webpack_require__(/*! ./hash/sha */ "./node_modules/hash.js/lib/hash/sha.js");
hash.ripemd = __webpack_require__(/*! ./hash/ripemd */ "./node_modules/hash.js/lib/hash/ripemd.js");
hash.hmac = __webpack_require__(/*! ./hash/hmac */ "./node_modules/hash.js/lib/hash/hmac.js");

// Proxy hash functions to the main object
hash.sha1 = hash.sha.sha1;
hash.sha256 = hash.sha.sha256;
hash.sha224 = hash.sha.sha224;
hash.sha384 = hash.sha.sha384;
hash.sha512 = hash.sha.sha512;
hash.ripemd160 = hash.ripemd.ripemd160;


/***/ }),

/***/ "./node_modules/hash.js/lib/hash/common.js":
/*!*************************************************!*\
  !*** ./node_modules/hash.js/lib/hash/common.js ***!
  \*************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(/*! ./utils */ "./node_modules/hash.js/lib/hash/utils.js");
var assert = __webpack_require__(/*! minimalistic-assert */ "./node_modules/minimalistic-assert/index.js");

function BlockHash() {
  this.pending = null;
  this.pendingTotal = 0;
  this.blockSize = this.constructor.blockSize;
  this.outSize = this.constructor.outSize;
  this.hmacStrength = this.constructor.hmacStrength;
  this.padLength = this.constructor.padLength / 8;
  this.endian = 'big';

  this._delta8 = this.blockSize / 8;
  this._delta32 = this.blockSize / 32;
}
exports.BlockHash = BlockHash;

BlockHash.prototype.update = function update(msg, enc) {
  // Convert message to array, pad it, and join into 32bit blocks
  msg = utils.toArray(msg, enc);
  if (!this.pending)
    this.pending = msg;
  else
    this.pending = this.pending.concat(msg);
  this.pendingTotal += msg.length;

  // Enough data, try updating
  if (this.pending.length >= this._delta8) {
    msg = this.pending;

    // Process pending data in blocks
    var r = msg.length % this._delta8;
    this.pending = msg.slice(msg.length - r, msg.length);
    if (this.pending.length === 0)
      this.pending = null;

    msg = utils.join32(msg, 0, msg.length - r, this.endian);
    for (var i = 0; i < msg.length; i += this._delta32)
      this._update(msg, i, i + this._delta32);
  }

  return this;
};

BlockHash.prototype.digest = function digest(enc) {
  this.update(this._pad());
  assert(this.pending === null);

  return this._digest(enc);
};

BlockHash.prototype._pad = function pad() {
  var len = this.pendingTotal;
  var bytes = this._delta8;
  var k = bytes - ((len + this.padLength) % bytes);
  var res = new Array(k + this.padLength);
  res[0] = 0x80;
  for (var i = 1; i < k; i++)
    res[i] = 0;

  // Append length
  len <<= 3;
  if (this.endian === 'big') {
    for (var t = 8; t < this.padLength; t++)
      res[i++] = 0;

    res[i++] = 0;
    res[i++] = 0;
    res[i++] = 0;
    res[i++] = 0;
    res[i++] = (len >>> 24) & 0xff;
    res[i++] = (len >>> 16) & 0xff;
    res[i++] = (len >>> 8) & 0xff;
    res[i++] = len & 0xff;
  } else {
    res[i++] = len & 0xff;
    res[i++] = (len >>> 8) & 0xff;
    res[i++] = (len >>> 16) & 0xff;
    res[i++] = (len >>> 24) & 0xff;
    res[i++] = 0;
    res[i++] = 0;
    res[i++] = 0;
    res[i++] = 0;

    for (t = 8; t < this.padLength; t++)
      res[i++] = 0;
  }

  return res;
};


/***/ }),

/***/ "./node_modules/hash.js/lib/hash/hmac.js":
/*!***********************************************!*\
  !*** ./node_modules/hash.js/lib/hash/hmac.js ***!
  \***********************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(/*! ./utils */ "./node_modules/hash.js/lib/hash/utils.js");
var assert = __webpack_require__(/*! minimalistic-assert */ "./node_modules/minimalistic-assert/index.js");

function Hmac(hash, key, enc) {
  if (!(this instanceof Hmac))
    return new Hmac(hash, key, enc);
  this.Hash = hash;
  this.blockSize = hash.blockSize / 8;
  this.outSize = hash.outSize / 8;
  this.inner = null;
  this.outer = null;

  this._init(utils.toArray(key, enc));
}
module.exports = Hmac;

Hmac.prototype._init = function init(key) {
  // Shorten key, if needed
  if (key.length > this.blockSize)
    key = new this.Hash().update(key).digest();
  assert(key.length <= this.blockSize);

  // Add padding to key
  for (var i = key.length; i < this.blockSize; i++)
    key.push(0);

  for (i = 0; i < key.length; i++)
    key[i] ^= 0x36;
  this.inner = new this.Hash().update(key);

  // 0x36 ^ 0x5c = 0x6a
  for (i = 0; i < key.length; i++)
    key[i] ^= 0x6a;
  this.outer = new this.Hash().update(key);
};

Hmac.prototype.update = function update(msg, enc) {
  this.inner.update(msg, enc);
  return this;
};

Hmac.prototype.digest = function digest(enc) {
  this.outer.update(this.inner.digest());
  return this.outer.digest(enc);
};


/***/ }),

/***/ "./node_modules/hash.js/lib/hash/ripemd.js":
/*!*************************************************!*\
  !*** ./node_modules/hash.js/lib/hash/ripemd.js ***!
  \*************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(/*! ./utils */ "./node_modules/hash.js/lib/hash/utils.js");
var common = __webpack_require__(/*! ./common */ "./node_modules/hash.js/lib/hash/common.js");

var rotl32 = utils.rotl32;
var sum32 = utils.sum32;
var sum32_3 = utils.sum32_3;
var sum32_4 = utils.sum32_4;
var BlockHash = common.BlockHash;

function RIPEMD160() {
  if (!(this instanceof RIPEMD160))
    return new RIPEMD160();

  BlockHash.call(this);

  this.h = [ 0x67452301, 0xefcdab89, 0x98badcfe, 0x10325476, 0xc3d2e1f0 ];
  this.endian = 'little';
}
utils.inherits(RIPEMD160, BlockHash);
exports.ripemd160 = RIPEMD160;

RIPEMD160.blockSize = 512;
RIPEMD160.outSize = 160;
RIPEMD160.hmacStrength = 192;
RIPEMD160.padLength = 64;

RIPEMD160.prototype._update = function update(msg, start) {
  var A = this.h[0];
  var B = this.h[1];
  var C = this.h[2];
  var D = this.h[3];
  var E = this.h[4];
  var Ah = A;
  var Bh = B;
  var Ch = C;
  var Dh = D;
  var Eh = E;
  for (var j = 0; j < 80; j++) {
    var T = sum32(
      rotl32(
        sum32_4(A, f(j, B, C, D), msg[r[j] + start], K(j)),
        s[j]),
      E);
    A = E;
    E = D;
    D = rotl32(C, 10);
    C = B;
    B = T;
    T = sum32(
      rotl32(
        sum32_4(Ah, f(79 - j, Bh, Ch, Dh), msg[rh[j] + start], Kh(j)),
        sh[j]),
      Eh);
    Ah = Eh;
    Eh = Dh;
    Dh = rotl32(Ch, 10);
    Ch = Bh;
    Bh = T;
  }
  T = sum32_3(this.h[1], C, Dh);
  this.h[1] = sum32_3(this.h[2], D, Eh);
  this.h[2] = sum32_3(this.h[3], E, Ah);
  this.h[3] = sum32_3(this.h[4], A, Bh);
  this.h[4] = sum32_3(this.h[0], B, Ch);
  this.h[0] = T;
};

RIPEMD160.prototype._digest = function digest(enc) {
  if (enc === 'hex')
    return utils.toHex32(this.h, 'little');
  else
    return utils.split32(this.h, 'little');
};

function f(j, x, y, z) {
  if (j <= 15)
    return x ^ y ^ z;
  else if (j <= 31)
    return (x & y) | ((~x) & z);
  else if (j <= 47)
    return (x | (~y)) ^ z;
  else if (j <= 63)
    return (x & z) | (y & (~z));
  else
    return x ^ (y | (~z));
}

function K(j) {
  if (j <= 15)
    return 0x00000000;
  else if (j <= 31)
    return 0x5a827999;
  else if (j <= 47)
    return 0x6ed9eba1;
  else if (j <= 63)
    return 0x8f1bbcdc;
  else
    return 0xa953fd4e;
}

function Kh(j) {
  if (j <= 15)
    return 0x50a28be6;
  else if (j <= 31)
    return 0x5c4dd124;
  else if (j <= 47)
    return 0x6d703ef3;
  else if (j <= 63)
    return 0x7a6d76e9;
  else
    return 0x00000000;
}

var r = [
  0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15,
  7, 4, 13, 1, 10, 6, 15, 3, 12, 0, 9, 5, 2, 14, 11, 8,
  3, 10, 14, 4, 9, 15, 8, 1, 2, 7, 0, 6, 13, 11, 5, 12,
  1, 9, 11, 10, 0, 8, 12, 4, 13, 3, 7, 15, 14, 5, 6, 2,
  4, 0, 5, 9, 7, 12, 2, 10, 14, 1, 3, 8, 11, 6, 15, 13
];

var rh = [
  5, 14, 7, 0, 9, 2, 11, 4, 13, 6, 15, 8, 1, 10, 3, 12,
  6, 11, 3, 7, 0, 13, 5, 10, 14, 15, 8, 12, 4, 9, 1, 2,
  15, 5, 1, 3, 7, 14, 6, 9, 11, 8, 12, 2, 10, 0, 4, 13,
  8, 6, 4, 1, 3, 11, 15, 0, 5, 12, 2, 13, 9, 7, 10, 14,
  12, 15, 10, 4, 1, 5, 8, 7, 6, 2, 13, 14, 0, 3, 9, 11
];

var s = [
  11, 14, 15, 12, 5, 8, 7, 9, 11, 13, 14, 15, 6, 7, 9, 8,
  7, 6, 8, 13, 11, 9, 7, 15, 7, 12, 15, 9, 11, 7, 13, 12,
  11, 13, 6, 7, 14, 9, 13, 15, 14, 8, 13, 6, 5, 12, 7, 5,
  11, 12, 14, 15, 14, 15, 9, 8, 9, 14, 5, 6, 8, 6, 5, 12,
  9, 15, 5, 11, 6, 8, 13, 12, 5, 12, 13, 14, 11, 8, 5, 6
];

var sh = [
  8, 9, 9, 11, 13, 15, 15, 5, 7, 7, 8, 11, 14, 14, 12, 6,
  9, 13, 15, 7, 12, 8, 9, 11, 7, 7, 12, 7, 6, 15, 13, 11,
  9, 7, 15, 11, 8, 6, 6, 14, 12, 13, 5, 14, 13, 13, 7, 5,
  15, 5, 8, 11, 14, 14, 6, 14, 6, 9, 12, 9, 12, 5, 15, 8,
  8, 5, 12, 9, 12, 5, 14, 6, 8, 13, 6, 5, 15, 13, 11, 11
];


/***/ }),

/***/ "./node_modules/hash.js/lib/hash/sha.js":
/*!**********************************************!*\
  !*** ./node_modules/hash.js/lib/hash/sha.js ***!
  \**********************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.sha1 = __webpack_require__(/*! ./sha/1 */ "./node_modules/hash.js/lib/hash/sha/1.js");
exports.sha224 = __webpack_require__(/*! ./sha/224 */ "./node_modules/hash.js/lib/hash/sha/224.js");
exports.sha256 = __webpack_require__(/*! ./sha/256 */ "./node_modules/hash.js/lib/hash/sha/256.js");
exports.sha384 = __webpack_require__(/*! ./sha/384 */ "./node_modules/hash.js/lib/hash/sha/384.js");
exports.sha512 = __webpack_require__(/*! ./sha/512 */ "./node_modules/hash.js/lib/hash/sha/512.js");


/***/ }),

/***/ "./node_modules/hash.js/lib/hash/sha/1.js":
/*!************************************************!*\
  !*** ./node_modules/hash.js/lib/hash/sha/1.js ***!
  \************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(/*! ../utils */ "./node_modules/hash.js/lib/hash/utils.js");
var common = __webpack_require__(/*! ../common */ "./node_modules/hash.js/lib/hash/common.js");
var shaCommon = __webpack_require__(/*! ./common */ "./node_modules/hash.js/lib/hash/sha/common.js");

var rotl32 = utils.rotl32;
var sum32 = utils.sum32;
var sum32_5 = utils.sum32_5;
var ft_1 = shaCommon.ft_1;
var BlockHash = common.BlockHash;

var sha1_K = [
  0x5A827999, 0x6ED9EBA1,
  0x8F1BBCDC, 0xCA62C1D6
];

function SHA1() {
  if (!(this instanceof SHA1))
    return new SHA1();

  BlockHash.call(this);
  this.h = [
    0x67452301, 0xefcdab89, 0x98badcfe,
    0x10325476, 0xc3d2e1f0 ];
  this.W = new Array(80);
}

utils.inherits(SHA1, BlockHash);
module.exports = SHA1;

SHA1.blockSize = 512;
SHA1.outSize = 160;
SHA1.hmacStrength = 80;
SHA1.padLength = 64;

SHA1.prototype._update = function _update(msg, start) {
  var W = this.W;

  for (var i = 0; i < 16; i++)
    W[i] = msg[start + i];

  for(; i < W.length; i++)
    W[i] = rotl32(W[i - 3] ^ W[i - 8] ^ W[i - 14] ^ W[i - 16], 1);

  var a = this.h[0];
  var b = this.h[1];
  var c = this.h[2];
  var d = this.h[3];
  var e = this.h[4];

  for (i = 0; i < W.length; i++) {
    var s = ~~(i / 20);
    var t = sum32_5(rotl32(a, 5), ft_1(s, b, c, d), e, W[i], sha1_K[s]);
    e = d;
    d = c;
    c = rotl32(b, 30);
    b = a;
    a = t;
  }

  this.h[0] = sum32(this.h[0], a);
  this.h[1] = sum32(this.h[1], b);
  this.h[2] = sum32(this.h[2], c);
  this.h[3] = sum32(this.h[3], d);
  this.h[4] = sum32(this.h[4], e);
};

SHA1.prototype._digest = function digest(enc) {
  if (enc === 'hex')
    return utils.toHex32(this.h, 'big');
  else
    return utils.split32(this.h, 'big');
};


/***/ }),

/***/ "./node_modules/hash.js/lib/hash/sha/224.js":
/*!**************************************************!*\
  !*** ./node_modules/hash.js/lib/hash/sha/224.js ***!
  \**************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(/*! ../utils */ "./node_modules/hash.js/lib/hash/utils.js");
var SHA256 = __webpack_require__(/*! ./256 */ "./node_modules/hash.js/lib/hash/sha/256.js");

function SHA224() {
  if (!(this instanceof SHA224))
    return new SHA224();

  SHA256.call(this);
  this.h = [
    0xc1059ed8, 0x367cd507, 0x3070dd17, 0xf70e5939,
    0xffc00b31, 0x68581511, 0x64f98fa7, 0xbefa4fa4 ];
}
utils.inherits(SHA224, SHA256);
module.exports = SHA224;

SHA224.blockSize = 512;
SHA224.outSize = 224;
SHA224.hmacStrength = 192;
SHA224.padLength = 64;

SHA224.prototype._digest = function digest(enc) {
  // Just truncate output
  if (enc === 'hex')
    return utils.toHex32(this.h.slice(0, 7), 'big');
  else
    return utils.split32(this.h.slice(0, 7), 'big');
};



/***/ }),

/***/ "./node_modules/hash.js/lib/hash/sha/256.js":
/*!**************************************************!*\
  !*** ./node_modules/hash.js/lib/hash/sha/256.js ***!
  \**************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(/*! ../utils */ "./node_modules/hash.js/lib/hash/utils.js");
var common = __webpack_require__(/*! ../common */ "./node_modules/hash.js/lib/hash/common.js");
var shaCommon = __webpack_require__(/*! ./common */ "./node_modules/hash.js/lib/hash/sha/common.js");
var assert = __webpack_require__(/*! minimalistic-assert */ "./node_modules/minimalistic-assert/index.js");

var sum32 = utils.sum32;
var sum32_4 = utils.sum32_4;
var sum32_5 = utils.sum32_5;
var ch32 = shaCommon.ch32;
var maj32 = shaCommon.maj32;
var s0_256 = shaCommon.s0_256;
var s1_256 = shaCommon.s1_256;
var g0_256 = shaCommon.g0_256;
var g1_256 = shaCommon.g1_256;

var BlockHash = common.BlockHash;

var sha256_K = [
  0x428a2f98, 0x71374491, 0xb5c0fbcf, 0xe9b5dba5,
  0x3956c25b, 0x59f111f1, 0x923f82a4, 0xab1c5ed5,
  0xd807aa98, 0x12835b01, 0x243185be, 0x550c7dc3,
  0x72be5d74, 0x80deb1fe, 0x9bdc06a7, 0xc19bf174,
  0xe49b69c1, 0xefbe4786, 0x0fc19dc6, 0x240ca1cc,
  0x2de92c6f, 0x4a7484aa, 0x5cb0a9dc, 0x76f988da,
  0x983e5152, 0xa831c66d, 0xb00327c8, 0xbf597fc7,
  0xc6e00bf3, 0xd5a79147, 0x06ca6351, 0x14292967,
  0x27b70a85, 0x2e1b2138, 0x4d2c6dfc, 0x53380d13,
  0x650a7354, 0x766a0abb, 0x81c2c92e, 0x92722c85,
  0xa2bfe8a1, 0xa81a664b, 0xc24b8b70, 0xc76c51a3,
  0xd192e819, 0xd6990624, 0xf40e3585, 0x106aa070,
  0x19a4c116, 0x1e376c08, 0x2748774c, 0x34b0bcb5,
  0x391c0cb3, 0x4ed8aa4a, 0x5b9cca4f, 0x682e6ff3,
  0x748f82ee, 0x78a5636f, 0x84c87814, 0x8cc70208,
  0x90befffa, 0xa4506ceb, 0xbef9a3f7, 0xc67178f2
];

function SHA256() {
  if (!(this instanceof SHA256))
    return new SHA256();

  BlockHash.call(this);
  this.h = [
    0x6a09e667, 0xbb67ae85, 0x3c6ef372, 0xa54ff53a,
    0x510e527f, 0x9b05688c, 0x1f83d9ab, 0x5be0cd19
  ];
  this.k = sha256_K;
  this.W = new Array(64);
}
utils.inherits(SHA256, BlockHash);
module.exports = SHA256;

SHA256.blockSize = 512;
SHA256.outSize = 256;
SHA256.hmacStrength = 192;
SHA256.padLength = 64;

SHA256.prototype._update = function _update(msg, start) {
  var W = this.W;

  for (var i = 0; i < 16; i++)
    W[i] = msg[start + i];
  for (; i < W.length; i++)
    W[i] = sum32_4(g1_256(W[i - 2]), W[i - 7], g0_256(W[i - 15]), W[i - 16]);

  var a = this.h[0];
  var b = this.h[1];
  var c = this.h[2];
  var d = this.h[3];
  var e = this.h[4];
  var f = this.h[5];
  var g = this.h[6];
  var h = this.h[7];

  assert(this.k.length === W.length);
  for (i = 0; i < W.length; i++) {
    var T1 = sum32_5(h, s1_256(e), ch32(e, f, g), this.k[i], W[i]);
    var T2 = sum32(s0_256(a), maj32(a, b, c));
    h = g;
    g = f;
    f = e;
    e = sum32(d, T1);
    d = c;
    c = b;
    b = a;
    a = sum32(T1, T2);
  }

  this.h[0] = sum32(this.h[0], a);
  this.h[1] = sum32(this.h[1], b);
  this.h[2] = sum32(this.h[2], c);
  this.h[3] = sum32(this.h[3], d);
  this.h[4] = sum32(this.h[4], e);
  this.h[5] = sum32(this.h[5], f);
  this.h[6] = sum32(this.h[6], g);
  this.h[7] = sum32(this.h[7], h);
};

SHA256.prototype._digest = function digest(enc) {
  if (enc === 'hex')
    return utils.toHex32(this.h, 'big');
  else
    return utils.split32(this.h, 'big');
};


/***/ }),

/***/ "./node_modules/hash.js/lib/hash/sha/384.js":
/*!**************************************************!*\
  !*** ./node_modules/hash.js/lib/hash/sha/384.js ***!
  \**************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(/*! ../utils */ "./node_modules/hash.js/lib/hash/utils.js");

var SHA512 = __webpack_require__(/*! ./512 */ "./node_modules/hash.js/lib/hash/sha/512.js");

function SHA384() {
  if (!(this instanceof SHA384))
    return new SHA384();

  SHA512.call(this);
  this.h = [
    0xcbbb9d5d, 0xc1059ed8,
    0x629a292a, 0x367cd507,
    0x9159015a, 0x3070dd17,
    0x152fecd8, 0xf70e5939,
    0x67332667, 0xffc00b31,
    0x8eb44a87, 0x68581511,
    0xdb0c2e0d, 0x64f98fa7,
    0x47b5481d, 0xbefa4fa4 ];
}
utils.inherits(SHA384, SHA512);
module.exports = SHA384;

SHA384.blockSize = 1024;
SHA384.outSize = 384;
SHA384.hmacStrength = 192;
SHA384.padLength = 128;

SHA384.prototype._digest = function digest(enc) {
  if (enc === 'hex')
    return utils.toHex32(this.h.slice(0, 12), 'big');
  else
    return utils.split32(this.h.slice(0, 12), 'big');
};


/***/ }),

/***/ "./node_modules/hash.js/lib/hash/sha/512.js":
/*!**************************************************!*\
  !*** ./node_modules/hash.js/lib/hash/sha/512.js ***!
  \**************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(/*! ../utils */ "./node_modules/hash.js/lib/hash/utils.js");
var common = __webpack_require__(/*! ../common */ "./node_modules/hash.js/lib/hash/common.js");
var assert = __webpack_require__(/*! minimalistic-assert */ "./node_modules/minimalistic-assert/index.js");

var rotr64_hi = utils.rotr64_hi;
var rotr64_lo = utils.rotr64_lo;
var shr64_hi = utils.shr64_hi;
var shr64_lo = utils.shr64_lo;
var sum64 = utils.sum64;
var sum64_hi = utils.sum64_hi;
var sum64_lo = utils.sum64_lo;
var sum64_4_hi = utils.sum64_4_hi;
var sum64_4_lo = utils.sum64_4_lo;
var sum64_5_hi = utils.sum64_5_hi;
var sum64_5_lo = utils.sum64_5_lo;

var BlockHash = common.BlockHash;

var sha512_K = [
  0x428a2f98, 0xd728ae22, 0x71374491, 0x23ef65cd,
  0xb5c0fbcf, 0xec4d3b2f, 0xe9b5dba5, 0x8189dbbc,
  0x3956c25b, 0xf348b538, 0x59f111f1, 0xb605d019,
  0x923f82a4, 0xaf194f9b, 0xab1c5ed5, 0xda6d8118,
  0xd807aa98, 0xa3030242, 0x12835b01, 0x45706fbe,
  0x243185be, 0x4ee4b28c, 0x550c7dc3, 0xd5ffb4e2,
  0x72be5d74, 0xf27b896f, 0x80deb1fe, 0x3b1696b1,
  0x9bdc06a7, 0x25c71235, 0xc19bf174, 0xcf692694,
  0xe49b69c1, 0x9ef14ad2, 0xefbe4786, 0x384f25e3,
  0x0fc19dc6, 0x8b8cd5b5, 0x240ca1cc, 0x77ac9c65,
  0x2de92c6f, 0x592b0275, 0x4a7484aa, 0x6ea6e483,
  0x5cb0a9dc, 0xbd41fbd4, 0x76f988da, 0x831153b5,
  0x983e5152, 0xee66dfab, 0xa831c66d, 0x2db43210,
  0xb00327c8, 0x98fb213f, 0xbf597fc7, 0xbeef0ee4,
  0xc6e00bf3, 0x3da88fc2, 0xd5a79147, 0x930aa725,
  0x06ca6351, 0xe003826f, 0x14292967, 0x0a0e6e70,
  0x27b70a85, 0x46d22ffc, 0x2e1b2138, 0x5c26c926,
  0x4d2c6dfc, 0x5ac42aed, 0x53380d13, 0x9d95b3df,
  0x650a7354, 0x8baf63de, 0x766a0abb, 0x3c77b2a8,
  0x81c2c92e, 0x47edaee6, 0x92722c85, 0x1482353b,
  0xa2bfe8a1, 0x4cf10364, 0xa81a664b, 0xbc423001,
  0xc24b8b70, 0xd0f89791, 0xc76c51a3, 0x0654be30,
  0xd192e819, 0xd6ef5218, 0xd6990624, 0x5565a910,
  0xf40e3585, 0x5771202a, 0x106aa070, 0x32bbd1b8,
  0x19a4c116, 0xb8d2d0c8, 0x1e376c08, 0x5141ab53,
  0x2748774c, 0xdf8eeb99, 0x34b0bcb5, 0xe19b48a8,
  0x391c0cb3, 0xc5c95a63, 0x4ed8aa4a, 0xe3418acb,
  0x5b9cca4f, 0x7763e373, 0x682e6ff3, 0xd6b2b8a3,
  0x748f82ee, 0x5defb2fc, 0x78a5636f, 0x43172f60,
  0x84c87814, 0xa1f0ab72, 0x8cc70208, 0x1a6439ec,
  0x90befffa, 0x23631e28, 0xa4506ceb, 0xde82bde9,
  0xbef9a3f7, 0xb2c67915, 0xc67178f2, 0xe372532b,
  0xca273ece, 0xea26619c, 0xd186b8c7, 0x21c0c207,
  0xeada7dd6, 0xcde0eb1e, 0xf57d4f7f, 0xee6ed178,
  0x06f067aa, 0x72176fba, 0x0a637dc5, 0xa2c898a6,
  0x113f9804, 0xbef90dae, 0x1b710b35, 0x131c471b,
  0x28db77f5, 0x23047d84, 0x32caab7b, 0x40c72493,
  0x3c9ebe0a, 0x15c9bebc, 0x431d67c4, 0x9c100d4c,
  0x4cc5d4be, 0xcb3e42b6, 0x597f299c, 0xfc657e2a,
  0x5fcb6fab, 0x3ad6faec, 0x6c44198c, 0x4a475817
];

function SHA512() {
  if (!(this instanceof SHA512))
    return new SHA512();

  BlockHash.call(this);
  this.h = [
    0x6a09e667, 0xf3bcc908,
    0xbb67ae85, 0x84caa73b,
    0x3c6ef372, 0xfe94f82b,
    0xa54ff53a, 0x5f1d36f1,
    0x510e527f, 0xade682d1,
    0x9b05688c, 0x2b3e6c1f,
    0x1f83d9ab, 0xfb41bd6b,
    0x5be0cd19, 0x137e2179 ];
  this.k = sha512_K;
  this.W = new Array(160);
}
utils.inherits(SHA512, BlockHash);
module.exports = SHA512;

SHA512.blockSize = 1024;
SHA512.outSize = 512;
SHA512.hmacStrength = 192;
SHA512.padLength = 128;

SHA512.prototype._prepareBlock = function _prepareBlock(msg, start) {
  var W = this.W;

  // 32 x 32bit words
  for (var i = 0; i < 32; i++)
    W[i] = msg[start + i];
  for (; i < W.length; i += 2) {
    var c0_hi = g1_512_hi(W[i - 4], W[i - 3]);  // i - 2
    var c0_lo = g1_512_lo(W[i - 4], W[i - 3]);
    var c1_hi = W[i - 14];  // i - 7
    var c1_lo = W[i - 13];
    var c2_hi = g0_512_hi(W[i - 30], W[i - 29]);  // i - 15
    var c2_lo = g0_512_lo(W[i - 30], W[i - 29]);
    var c3_hi = W[i - 32];  // i - 16
    var c3_lo = W[i - 31];

    W[i] = sum64_4_hi(
      c0_hi, c0_lo,
      c1_hi, c1_lo,
      c2_hi, c2_lo,
      c3_hi, c3_lo);
    W[i + 1] = sum64_4_lo(
      c0_hi, c0_lo,
      c1_hi, c1_lo,
      c2_hi, c2_lo,
      c3_hi, c3_lo);
  }
};

SHA512.prototype._update = function _update(msg, start) {
  this._prepareBlock(msg, start);

  var W = this.W;

  var ah = this.h[0];
  var al = this.h[1];
  var bh = this.h[2];
  var bl = this.h[3];
  var ch = this.h[4];
  var cl = this.h[5];
  var dh = this.h[6];
  var dl = this.h[7];
  var eh = this.h[8];
  var el = this.h[9];
  var fh = this.h[10];
  var fl = this.h[11];
  var gh = this.h[12];
  var gl = this.h[13];
  var hh = this.h[14];
  var hl = this.h[15];

  assert(this.k.length === W.length);
  for (var i = 0; i < W.length; i += 2) {
    var c0_hi = hh;
    var c0_lo = hl;
    var c1_hi = s1_512_hi(eh, el);
    var c1_lo = s1_512_lo(eh, el);
    var c2_hi = ch64_hi(eh, el, fh, fl, gh, gl);
    var c2_lo = ch64_lo(eh, el, fh, fl, gh, gl);
    var c3_hi = this.k[i];
    var c3_lo = this.k[i + 1];
    var c4_hi = W[i];
    var c4_lo = W[i + 1];

    var T1_hi = sum64_5_hi(
      c0_hi, c0_lo,
      c1_hi, c1_lo,
      c2_hi, c2_lo,
      c3_hi, c3_lo,
      c4_hi, c4_lo);
    var T1_lo = sum64_5_lo(
      c0_hi, c0_lo,
      c1_hi, c1_lo,
      c2_hi, c2_lo,
      c3_hi, c3_lo,
      c4_hi, c4_lo);

    c0_hi = s0_512_hi(ah, al);
    c0_lo = s0_512_lo(ah, al);
    c1_hi = maj64_hi(ah, al, bh, bl, ch, cl);
    c1_lo = maj64_lo(ah, al, bh, bl, ch, cl);

    var T2_hi = sum64_hi(c0_hi, c0_lo, c1_hi, c1_lo);
    var T2_lo = sum64_lo(c0_hi, c0_lo, c1_hi, c1_lo);

    hh = gh;
    hl = gl;

    gh = fh;
    gl = fl;

    fh = eh;
    fl = el;

    eh = sum64_hi(dh, dl, T1_hi, T1_lo);
    el = sum64_lo(dl, dl, T1_hi, T1_lo);

    dh = ch;
    dl = cl;

    ch = bh;
    cl = bl;

    bh = ah;
    bl = al;

    ah = sum64_hi(T1_hi, T1_lo, T2_hi, T2_lo);
    al = sum64_lo(T1_hi, T1_lo, T2_hi, T2_lo);
  }

  sum64(this.h, 0, ah, al);
  sum64(this.h, 2, bh, bl);
  sum64(this.h, 4, ch, cl);
  sum64(this.h, 6, dh, dl);
  sum64(this.h, 8, eh, el);
  sum64(this.h, 10, fh, fl);
  sum64(this.h, 12, gh, gl);
  sum64(this.h, 14, hh, hl);
};

SHA512.prototype._digest = function digest(enc) {
  if (enc === 'hex')
    return utils.toHex32(this.h, 'big');
  else
    return utils.split32(this.h, 'big');
};

function ch64_hi(xh, xl, yh, yl, zh) {
  var r = (xh & yh) ^ ((~xh) & zh);
  if (r < 0)
    r += 0x100000000;
  return r;
}

function ch64_lo(xh, xl, yh, yl, zh, zl) {
  var r = (xl & yl) ^ ((~xl) & zl);
  if (r < 0)
    r += 0x100000000;
  return r;
}

function maj64_hi(xh, xl, yh, yl, zh) {
  var r = (xh & yh) ^ (xh & zh) ^ (yh & zh);
  if (r < 0)
    r += 0x100000000;
  return r;
}

function maj64_lo(xh, xl, yh, yl, zh, zl) {
  var r = (xl & yl) ^ (xl & zl) ^ (yl & zl);
  if (r < 0)
    r += 0x100000000;
  return r;
}

function s0_512_hi(xh, xl) {
  var c0_hi = rotr64_hi(xh, xl, 28);
  var c1_hi = rotr64_hi(xl, xh, 2);  // 34
  var c2_hi = rotr64_hi(xl, xh, 7);  // 39

  var r = c0_hi ^ c1_hi ^ c2_hi;
  if (r < 0)
    r += 0x100000000;
  return r;
}

function s0_512_lo(xh, xl) {
  var c0_lo = rotr64_lo(xh, xl, 28);
  var c1_lo = rotr64_lo(xl, xh, 2);  // 34
  var c2_lo = rotr64_lo(xl, xh, 7);  // 39

  var r = c0_lo ^ c1_lo ^ c2_lo;
  if (r < 0)
    r += 0x100000000;
  return r;
}

function s1_512_hi(xh, xl) {
  var c0_hi = rotr64_hi(xh, xl, 14);
  var c1_hi = rotr64_hi(xh, xl, 18);
  var c2_hi = rotr64_hi(xl, xh, 9);  // 41

  var r = c0_hi ^ c1_hi ^ c2_hi;
  if (r < 0)
    r += 0x100000000;
  return r;
}

function s1_512_lo(xh, xl) {
  var c0_lo = rotr64_lo(xh, xl, 14);
  var c1_lo = rotr64_lo(xh, xl, 18);
  var c2_lo = rotr64_lo(xl, xh, 9);  // 41

  var r = c0_lo ^ c1_lo ^ c2_lo;
  if (r < 0)
    r += 0x100000000;
  return r;
}

function g0_512_hi(xh, xl) {
  var c0_hi = rotr64_hi(xh, xl, 1);
  var c1_hi = rotr64_hi(xh, xl, 8);
  var c2_hi = shr64_hi(xh, xl, 7);

  var r = c0_hi ^ c1_hi ^ c2_hi;
  if (r < 0)
    r += 0x100000000;
  return r;
}

function g0_512_lo(xh, xl) {
  var c0_lo = rotr64_lo(xh, xl, 1);
  var c1_lo = rotr64_lo(xh, xl, 8);
  var c2_lo = shr64_lo(xh, xl, 7);

  var r = c0_lo ^ c1_lo ^ c2_lo;
  if (r < 0)
    r += 0x100000000;
  return r;
}

function g1_512_hi(xh, xl) {
  var c0_hi = rotr64_hi(xh, xl, 19);
  var c1_hi = rotr64_hi(xl, xh, 29);  // 61
  var c2_hi = shr64_hi(xh, xl, 6);

  var r = c0_hi ^ c1_hi ^ c2_hi;
  if (r < 0)
    r += 0x100000000;
  return r;
}

function g1_512_lo(xh, xl) {
  var c0_lo = rotr64_lo(xh, xl, 19);
  var c1_lo = rotr64_lo(xl, xh, 29);  // 61
  var c2_lo = shr64_lo(xh, xl, 6);

  var r = c0_lo ^ c1_lo ^ c2_lo;
  if (r < 0)
    r += 0x100000000;
  return r;
}


/***/ }),

/***/ "./node_modules/hash.js/lib/hash/sha/common.js":
/*!*****************************************************!*\
  !*** ./node_modules/hash.js/lib/hash/sha/common.js ***!
  \*****************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(/*! ../utils */ "./node_modules/hash.js/lib/hash/utils.js");
var rotr32 = utils.rotr32;

function ft_1(s, x, y, z) {
  if (s === 0)
    return ch32(x, y, z);
  if (s === 1 || s === 3)
    return p32(x, y, z);
  if (s === 2)
    return maj32(x, y, z);
}
exports.ft_1 = ft_1;

function ch32(x, y, z) {
  return (x & y) ^ ((~x) & z);
}
exports.ch32 = ch32;

function maj32(x, y, z) {
  return (x & y) ^ (x & z) ^ (y & z);
}
exports.maj32 = maj32;

function p32(x, y, z) {
  return x ^ y ^ z;
}
exports.p32 = p32;

function s0_256(x) {
  return rotr32(x, 2) ^ rotr32(x, 13) ^ rotr32(x, 22);
}
exports.s0_256 = s0_256;

function s1_256(x) {
  return rotr32(x, 6) ^ rotr32(x, 11) ^ rotr32(x, 25);
}
exports.s1_256 = s1_256;

function g0_256(x) {
  return rotr32(x, 7) ^ rotr32(x, 18) ^ (x >>> 3);
}
exports.g0_256 = g0_256;

function g1_256(x) {
  return rotr32(x, 17) ^ rotr32(x, 19) ^ (x >>> 10);
}
exports.g1_256 = g1_256;


/***/ }),

/***/ "./node_modules/hash.js/lib/hash/utils.js":
/*!************************************************!*\
  !*** ./node_modules/hash.js/lib/hash/utils.js ***!
  \************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var assert = __webpack_require__(/*! minimalistic-assert */ "./node_modules/minimalistic-assert/index.js");
var inherits = __webpack_require__(/*! inherits */ "./node_modules/inherits/inherits_browser.js");

exports.inherits = inherits;

function isSurrogatePair(msg, i) {
  if ((msg.charCodeAt(i) & 0xFC00) !== 0xD800) {
    return false;
  }
  if (i < 0 || i + 1 >= msg.length) {
    return false;
  }
  return (msg.charCodeAt(i + 1) & 0xFC00) === 0xDC00;
}

function toArray(msg, enc) {
  if (Array.isArray(msg))
    return msg.slice();
  if (!msg)
    return [];
  var res = [];
  if (typeof msg === 'string') {
    if (!enc) {
      // Inspired by stringToUtf8ByteArray() in closure-library by Google
      // https://github.com/google/closure-library/blob/8598d87242af59aac233270742c8984e2b2bdbe0/closure/goog/crypt/crypt.js#L117-L143
      // Apache License 2.0
      // https://github.com/google/closure-library/blob/master/LICENSE
      var p = 0;
      for (var i = 0; i < msg.length; i++) {
        var c = msg.charCodeAt(i);
        if (c < 128) {
          res[p++] = c;
        } else if (c < 2048) {
          res[p++] = (c >> 6) | 192;
          res[p++] = (c & 63) | 128;
        } else if (isSurrogatePair(msg, i)) {
          c = 0x10000 + ((c & 0x03FF) << 10) + (msg.charCodeAt(++i) & 0x03FF);
          res[p++] = (c >> 18) | 240;
          res[p++] = ((c >> 12) & 63) | 128;
          res[p++] = ((c >> 6) & 63) | 128;
          res[p++] = (c & 63) | 128;
        } else {
          res[p++] = (c >> 12) | 224;
          res[p++] = ((c >> 6) & 63) | 128;
          res[p++] = (c & 63) | 128;
        }
      }
    } else if (enc === 'hex') {
      msg = msg.replace(/[^a-z0-9]+/ig, '');
      if (msg.length % 2 !== 0)
        msg = '0' + msg;
      for (i = 0; i < msg.length; i += 2)
        res.push(parseInt(msg[i] + msg[i + 1], 16));
    }
  } else {
    for (i = 0; i < msg.length; i++)
      res[i] = msg[i] | 0;
  }
  return res;
}
exports.toArray = toArray;

function toHex(msg) {
  var res = '';
  for (var i = 0; i < msg.length; i++)
    res += zero2(msg[i].toString(16));
  return res;
}
exports.toHex = toHex;

function htonl(w) {
  var res = (w >>> 24) |
            ((w >>> 8) & 0xff00) |
            ((w << 8) & 0xff0000) |
            ((w & 0xff) << 24);
  return res >>> 0;
}
exports.htonl = htonl;

function toHex32(msg, endian) {
  var res = '';
  for (var i = 0; i < msg.length; i++) {
    var w = msg[i];
    if (endian === 'little')
      w = htonl(w);
    res += zero8(w.toString(16));
  }
  return res;
}
exports.toHex32 = toHex32;

function zero2(word) {
  if (word.length === 1)
    return '0' + word;
  else
    return word;
}
exports.zero2 = zero2;

function zero8(word) {
  if (word.length === 7)
    return '0' + word;
  else if (word.length === 6)
    return '00' + word;
  else if (word.length === 5)
    return '000' + word;
  else if (word.length === 4)
    return '0000' + word;
  else if (word.length === 3)
    return '00000' + word;
  else if (word.length === 2)
    return '000000' + word;
  else if (word.length === 1)
    return '0000000' + word;
  else
    return word;
}
exports.zero8 = zero8;

function join32(msg, start, end, endian) {
  var len = end - start;
  assert(len % 4 === 0);
  var res = new Array(len / 4);
  for (var i = 0, k = start; i < res.length; i++, k += 4) {
    var w;
    if (endian === 'big')
      w = (msg[k] << 24) | (msg[k + 1] << 16) | (msg[k + 2] << 8) | msg[k + 3];
    else
      w = (msg[k + 3] << 24) | (msg[k + 2] << 16) | (msg[k + 1] << 8) | msg[k];
    res[i] = w >>> 0;
  }
  return res;
}
exports.join32 = join32;

function split32(msg, endian) {
  var res = new Array(msg.length * 4);
  for (var i = 0, k = 0; i < msg.length; i++, k += 4) {
    var m = msg[i];
    if (endian === 'big') {
      res[k] = m >>> 24;
      res[k + 1] = (m >>> 16) & 0xff;
      res[k + 2] = (m >>> 8) & 0xff;
      res[k + 3] = m & 0xff;
    } else {
      res[k + 3] = m >>> 24;
      res[k + 2] = (m >>> 16) & 0xff;
      res[k + 1] = (m >>> 8) & 0xff;
      res[k] = m & 0xff;
    }
  }
  return res;
}
exports.split32 = split32;

function rotr32(w, b) {
  return (w >>> b) | (w << (32 - b));
}
exports.rotr32 = rotr32;

function rotl32(w, b) {
  return (w << b) | (w >>> (32 - b));
}
exports.rotl32 = rotl32;

function sum32(a, b) {
  return (a + b) >>> 0;
}
exports.sum32 = sum32;

function sum32_3(a, b, c) {
  return (a + b + c) >>> 0;
}
exports.sum32_3 = sum32_3;

function sum32_4(a, b, c, d) {
  return (a + b + c + d) >>> 0;
}
exports.sum32_4 = sum32_4;

function sum32_5(a, b, c, d, e) {
  return (a + b + c + d + e) >>> 0;
}
exports.sum32_5 = sum32_5;

function sum64(buf, pos, ah, al) {
  var bh = buf[pos];
  var bl = buf[pos + 1];

  var lo = (al + bl) >>> 0;
  var hi = (lo < al ? 1 : 0) + ah + bh;
  buf[pos] = hi >>> 0;
  buf[pos + 1] = lo;
}
exports.sum64 = sum64;

function sum64_hi(ah, al, bh, bl) {
  var lo = (al + bl) >>> 0;
  var hi = (lo < al ? 1 : 0) + ah + bh;
  return hi >>> 0;
}
exports.sum64_hi = sum64_hi;

function sum64_lo(ah, al, bh, bl) {
  var lo = al + bl;
  return lo >>> 0;
}
exports.sum64_lo = sum64_lo;

function sum64_4_hi(ah, al, bh, bl, ch, cl, dh, dl) {
  var carry = 0;
  var lo = al;
  lo = (lo + bl) >>> 0;
  carry += lo < al ? 1 : 0;
  lo = (lo + cl) >>> 0;
  carry += lo < cl ? 1 : 0;
  lo = (lo + dl) >>> 0;
  carry += lo < dl ? 1 : 0;

  var hi = ah + bh + ch + dh + carry;
  return hi >>> 0;
}
exports.sum64_4_hi = sum64_4_hi;

function sum64_4_lo(ah, al, bh, bl, ch, cl, dh, dl) {
  var lo = al + bl + cl + dl;
  return lo >>> 0;
}
exports.sum64_4_lo = sum64_4_lo;

function sum64_5_hi(ah, al, bh, bl, ch, cl, dh, dl, eh, el) {
  var carry = 0;
  var lo = al;
  lo = (lo + bl) >>> 0;
  carry += lo < al ? 1 : 0;
  lo = (lo + cl) >>> 0;
  carry += lo < cl ? 1 : 0;
  lo = (lo + dl) >>> 0;
  carry += lo < dl ? 1 : 0;
  lo = (lo + el) >>> 0;
  carry += lo < el ? 1 : 0;

  var hi = ah + bh + ch + dh + eh + carry;
  return hi >>> 0;
}
exports.sum64_5_hi = sum64_5_hi;

function sum64_5_lo(ah, al, bh, bl, ch, cl, dh, dl, eh, el) {
  var lo = al + bl + cl + dl + el;

  return lo >>> 0;
}
exports.sum64_5_lo = sum64_5_lo;

function rotr64_hi(ah, al, num) {
  var r = (al << (32 - num)) | (ah >>> num);
  return r >>> 0;
}
exports.rotr64_hi = rotr64_hi;

function rotr64_lo(ah, al, num) {
  var r = (ah << (32 - num)) | (al >>> num);
  return r >>> 0;
}
exports.rotr64_lo = rotr64_lo;

function shr64_hi(ah, al, num) {
  return ah >>> num;
}
exports.shr64_hi = shr64_hi;

function shr64_lo(ah, al, num) {
  var r = (ah << (32 - num)) | (al >>> num);
  return r >>> 0;
}
exports.shr64_lo = shr64_lo;


/***/ }),

/***/ "./node_modules/hmac-drbg/lib/hmac-drbg.js":
/*!*************************************************!*\
  !*** ./node_modules/hmac-drbg/lib/hmac-drbg.js ***!
  \*************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var hash = __webpack_require__(/*! hash.js */ "./node_modules/hash.js/lib/hash.js");
var utils = __webpack_require__(/*! minimalistic-crypto-utils */ "./node_modules/minimalistic-crypto-utils/lib/utils.js");
var assert = __webpack_require__(/*! minimalistic-assert */ "./node_modules/minimalistic-assert/index.js");

function HmacDRBG(options) {
  if (!(this instanceof HmacDRBG))
    return new HmacDRBG(options);
  this.hash = options.hash;
  this.predResist = !!options.predResist;

  this.outLen = this.hash.outSize;
  this.minEntropy = options.minEntropy || this.hash.hmacStrength;

  this._reseed = null;
  this.reseedInterval = null;
  this.K = null;
  this.V = null;

  var entropy = utils.toArray(options.entropy, options.entropyEnc || 'hex');
  var nonce = utils.toArray(options.nonce, options.nonceEnc || 'hex');
  var pers = utils.toArray(options.pers, options.persEnc || 'hex');
  assert(entropy.length >= (this.minEntropy / 8),
         'Not enough entropy. Minimum is: ' + this.minEntropy + ' bits');
  this._init(entropy, nonce, pers);
}
module.exports = HmacDRBG;

HmacDRBG.prototype._init = function init(entropy, nonce, pers) {
  var seed = entropy.concat(nonce).concat(pers);

  this.K = new Array(this.outLen / 8);
  this.V = new Array(this.outLen / 8);
  for (var i = 0; i < this.V.length; i++) {
    this.K[i] = 0x00;
    this.V[i] = 0x01;
  }

  this._update(seed);
  this._reseed = 1;
  this.reseedInterval = 0x1000000000000;  // 2^48
};

HmacDRBG.prototype._hmac = function hmac() {
  return new hash.hmac(this.hash, this.K);
};

HmacDRBG.prototype._update = function update(seed) {
  var kmac = this._hmac()
                 .update(this.V)
                 .update([ 0x00 ]);
  if (seed)
    kmac = kmac.update(seed);
  this.K = kmac.digest();
  this.V = this._hmac().update(this.V).digest();
  if (!seed)
    return;

  this.K = this._hmac()
               .update(this.V)
               .update([ 0x01 ])
               .update(seed)
               .digest();
  this.V = this._hmac().update(this.V).digest();
};

HmacDRBG.prototype.reseed = function reseed(entropy, entropyEnc, add, addEnc) {
  // Optional entropy enc
  if (typeof entropyEnc !== 'string') {
    addEnc = add;
    add = entropyEnc;
    entropyEnc = null;
  }

  entropy = utils.toArray(entropy, entropyEnc);
  add = utils.toArray(add, addEnc);

  assert(entropy.length >= (this.minEntropy / 8),
         'Not enough entropy. Minimum is: ' + this.minEntropy + ' bits');

  this._update(entropy.concat(add || []));
  this._reseed = 1;
};

HmacDRBG.prototype.generate = function generate(len, enc, add, addEnc) {
  if (this._reseed > this.reseedInterval)
    throw new Error('Reseed is required');

  // Optional encoding
  if (typeof enc !== 'string') {
    addEnc = add;
    add = enc;
    enc = null;
  }

  // Optional additional data
  if (add) {
    add = utils.toArray(add, addEnc || 'hex');
    this._update(add);
  }

  var temp = [];
  while (temp.length < len) {
    this.V = this._hmac().update(this.V).digest();
    temp = temp.concat(this.V);
  }

  var res = temp.slice(0, len);
  this._update(add);
  this._reseed++;
  return utils.encode(res, enc);
};


/***/ }),

/***/ "./node_modules/ieee754/index.js":
/*!***************************************!*\
  !*** ./node_modules/ieee754/index.js ***!
  \***************************************/
/*! no static exports found */
/***/ (function(module, exports) {

/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */
exports.read = function (buffer, offset, isLE, mLen, nBytes) {
  var e, m
  var eLen = (nBytes * 8) - mLen - 1
  var eMax = (1 << eLen) - 1
  var eBias = eMax >> 1
  var nBits = -7
  var i = isLE ? (nBytes - 1) : 0
  var d = isLE ? -1 : 1
  var s = buffer[offset + i]

  i += d

  e = s & ((1 << (-nBits)) - 1)
  s >>= (-nBits)
  nBits += eLen
  for (; nBits > 0; e = (e * 256) + buffer[offset + i], i += d, nBits -= 8) {}

  m = e & ((1 << (-nBits)) - 1)
  e >>= (-nBits)
  nBits += mLen
  for (; nBits > 0; m = (m * 256) + buffer[offset + i], i += d, nBits -= 8) {}

  if (e === 0) {
    e = 1 - eBias
  } else if (e === eMax) {
    return m ? NaN : ((s ? -1 : 1) * Infinity)
  } else {
    m = m + Math.pow(2, mLen)
    e = e - eBias
  }
  return (s ? -1 : 1) * m * Math.pow(2, e - mLen)
}

exports.write = function (buffer, value, offset, isLE, mLen, nBytes) {
  var e, m, c
  var eLen = (nBytes * 8) - mLen - 1
  var eMax = (1 << eLen) - 1
  var eBias = eMax >> 1
  var rt = (mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0)
  var i = isLE ? 0 : (nBytes - 1)
  var d = isLE ? 1 : -1
  var s = value < 0 || (value === 0 && 1 / value < 0) ? 1 : 0

  value = Math.abs(value)

  if (isNaN(value) || value === Infinity) {
    m = isNaN(value) ? 1 : 0
    e = eMax
  } else {
    e = Math.floor(Math.log(value) / Math.LN2)
    if (value * (c = Math.pow(2, -e)) < 1) {
      e--
      c *= 2
    }
    if (e + eBias >= 1) {
      value += rt / c
    } else {
      value += rt * Math.pow(2, 1 - eBias)
    }
    if (value * c >= 2) {
      e++
      c /= 2
    }

    if (e + eBias >= eMax) {
      m = 0
      e = eMax
    } else if (e + eBias >= 1) {
      m = ((value * c) - 1) * Math.pow(2, mLen)
      e = e + eBias
    } else {
      m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen)
      e = 0
    }
  }

  for (; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8) {}

  e = (e << mLen) | m
  eLen += mLen
  for (; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8) {}

  buffer[offset + i - d] |= s * 128
}


/***/ }),

/***/ "./node_modules/immer/dist/immer.esm.js":
/*!**********************************************!*\
  !*** ./node_modules/immer/dist/immer.esm.js ***!
  \**********************************************/
/*! exports provided: default, Immer, applyPatches, castDraft, castImmutable, createDraft, current, enableAllPlugins, enableES5, enableMapSet, enablePatches, finishDraft, freeze, immerable, isDraft, isDraftable, nothing, original, produce, produceWithPatches, setAutoFreeze, setUseProxies */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Immer", function() { return on; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "applyPatches", function() { return vn; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "castDraft", function() { return K; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "castImmutable", function() { return $; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createDraft", function() { return pn; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "current", function() { return D; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "enableAllPlugins", function() { return J; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "enableES5", function() { return T; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "enableMapSet", function() { return C; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "enablePatches", function() { return F; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "finishDraft", function() { return ln; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "freeze", function() { return d; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "immerable", function() { return L; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isDraft", function() { return t; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isDraftable", function() { return r; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "nothing", function() { return H; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "original", function() { return e; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "produce", function() { return an; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "produceWithPatches", function() { return fn; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setAutoFreeze", function() { return cn; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setUseProxies", function() { return sn; });
function n(n){for(var t=arguments.length,r=Array(t>1?t-1:0),e=1;e<t;e++)r[e-1]=arguments[e];if(true){var i=Y[n],o=i?"function"==typeof i?i.apply(null,r):i:"unknown error nr: "+n;throw Error("[Immer] "+o)}throw Error("[Immer] minified error nr: "+n+(r.length?" "+r.map((function(n){return"'"+n+"'"})).join(","):"")+". Find the full error at: https://bit.ly/3cXEKWf")}function t(n){return!!n&&!!n[Q]}function r(n){return!!n&&(function(n){if(!n||"object"!=typeof n)return!1;var t=Object.getPrototypeOf(n);return!t||t===Object.prototype}(n)||Array.isArray(n)||!!n[L]||!!n.constructor[L]||s(n)||v(n))}function e(r){return t(r)||n(23,r),r[Q].t}function i(n,t,r){void 0===r&&(r=!1),0===o(n)?(r?Object.keys:Z)(n).forEach((function(e){r&&"symbol"==typeof e||t(e,n[e],n)})):n.forEach((function(r,e){return t(e,r,n)}))}function o(n){var t=n[Q];return t?t.i>3?t.i-4:t.i:Array.isArray(n)?1:s(n)?2:v(n)?3:0}function u(n,t){return 2===o(n)?n.has(t):Object.prototype.hasOwnProperty.call(n,t)}function a(n,t){return 2===o(n)?n.get(t):n[t]}function f(n,t,r){var e=o(n);2===e?n.set(t,r):3===e?(n.delete(t),n.add(r)):n[t]=r}function c(n,t){return n===t?0!==n||1/n==1/t:n!=n&&t!=t}function s(n){return X&&n instanceof Map}function v(n){return q&&n instanceof Set}function p(n){return n.o||n.t}function l(n){if(Array.isArray(n))return Array.prototype.slice.call(n);var t=nn(n);delete t[Q];for(var r=Z(t),e=0;e<r.length;e++){var i=r[e],o=t[i];!1===o.writable&&(o.writable=!0,o.configurable=!0),(o.get||o.set)&&(t[i]={configurable:!0,writable:!0,enumerable:o.enumerable,value:n[i]})}return Object.create(Object.getPrototypeOf(n),t)}function d(n,e){return void 0===e&&(e=!1),y(n)||t(n)||!r(n)?n:(o(n)>1&&(n.set=n.add=n.clear=n.delete=h),Object.freeze(n),e&&i(n,(function(n,t){return d(t,!0)}),!0),n)}function h(){n(2)}function y(n){return null==n||"object"!=typeof n||Object.isFrozen(n)}function b(t){var r=tn[t];return r||n(18,t),r}function m(n,t){tn[n]||(tn[n]=t)}function _(){return false||U||n(0),U}function j(n,t){t&&(b("Patches"),n.u=[],n.s=[],n.v=t)}function g(n){O(n),n.p.forEach(S),n.p=null}function O(n){n===U&&(U=n.l)}function w(n){return U={p:[],l:U,h:n,m:!0,_:0}}function S(n){var t=n[Q];0===t.i||1===t.i?t.j():t.g=!0}function P(t,e){e._=e.p.length;var i=e.p[0],o=void 0!==t&&t!==i;return e.h.O||b("ES5").S(e,t,o),o?(i[Q].P&&(g(e),n(4)),r(t)&&(t=M(e,t),e.l||x(e,t)),e.u&&b("Patches").M(i[Q],t,e.u,e.s)):t=M(e,i,[]),g(e),e.u&&e.v(e.u,e.s),t!==H?t:void 0}function M(n,t,r){if(y(t))return t;var e=t[Q];if(!e)return i(t,(function(i,o){return A(n,e,t,i,o,r)}),!0),t;if(e.A!==n)return t;if(!e.P)return x(n,e.t,!0),e.t;if(!e.I){e.I=!0,e.A._--;var o=4===e.i||5===e.i?e.o=l(e.k):e.o;i(3===e.i?new Set(o):o,(function(t,i){return A(n,e,o,t,i,r)})),x(n,o,!1),r&&n.u&&b("Patches").R(e,r,n.u,n.s)}return e.o}function A(e,i,o,a,c,s){if( true&&c===o&&n(5),t(c)){var v=M(e,c,s&&i&&3!==i.i&&!u(i.D,a)?s.concat(a):void 0);if(f(o,a,v),!t(v))return;e.m=!1}if(r(c)&&!y(c)){if(!e.h.N&&e._<1)return;M(e,c),i&&i.A.l||x(e,c)}}function x(n,t,r){void 0===r&&(r=!1),n.h.N&&n.m&&d(t,r)}function z(n,t){var r=n[Q];return(r?p(r):n)[t]}function I(n,t){if(t in n)for(var r=Object.getPrototypeOf(n);r;){var e=Object.getOwnPropertyDescriptor(r,t);if(e)return e;r=Object.getPrototypeOf(r)}}function E(n){n.P||(n.P=!0,n.l&&E(n.l))}function k(n){n.o||(n.o=l(n.t))}function R(n,t,r){var e=s(t)?b("MapSet").T(t,r):v(t)?b("MapSet").F(t,r):n.O?function(n,t){var r=Array.isArray(n),e={i:r?1:0,A:t?t.A:_(),P:!1,I:!1,D:{},l:t,t:n,k:null,o:null,j:null,C:!1},i=e,o=rn;r&&(i=[e],o=en);var u=Proxy.revocable(i,o),a=u.revoke,f=u.proxy;return e.k=f,e.j=a,f}(t,r):b("ES5").J(t,r);return(r?r.A:_()).p.push(e),e}function D(e){return t(e)||n(22,e),function n(t){if(!r(t))return t;var e,u=t[Q],c=o(t);if(u){if(!u.P&&(u.i<4||!b("ES5").K(u)))return u.t;u.I=!0,e=N(t,c),u.I=!1}else e=N(t,c);return i(e,(function(t,r){u&&a(u.t,t)===r||f(e,t,n(r))})),3===c?new Set(e):e}(e)}function N(n,t){switch(t){case 2:return new Map(n);case 3:return Array.from(n)}return l(n)}function T(){function r(n,t){var r=s[n];return r?r.enumerable=t:s[n]=r={configurable:!0,enumerable:t,get:function(){var t=this[Q];return true&&f(t),rn.get(t,n)},set:function(t){var r=this[Q]; true&&f(r),rn.set(r,n,t)}},r}function e(n){for(var t=n.length-1;t>=0;t--){var r=n[t][Q];if(!r.P)switch(r.i){case 5:a(r)&&E(r);break;case 4:o(r)&&E(r)}}}function o(n){for(var t=n.t,r=n.k,e=Z(r),i=e.length-1;i>=0;i--){var o=e[i];if(o!==Q){var a=t[o];if(void 0===a&&!u(t,o))return!0;var f=r[o],s=f&&f[Q];if(s?s.t!==a:!c(f,a))return!0}}var v=!!t[Q];return e.length!==Z(t).length+(v?0:1)}function a(n){var t=n.k;if(t.length!==n.t.length)return!0;var r=Object.getOwnPropertyDescriptor(t,t.length-1);return!(!r||r.get)}function f(t){t.g&&n(3,JSON.stringify(p(t)))}var s={};m("ES5",{J:function(n,t){var e=Array.isArray(n),i=function(n,t){if(n){for(var e=Array(t.length),i=0;i<t.length;i++)Object.defineProperty(e,""+i,r(i,!0));return e}var o=nn(t);delete o[Q];for(var u=Z(o),a=0;a<u.length;a++){var f=u[a];o[f]=r(f,n||!!o[f].enumerable)}return Object.create(Object.getPrototypeOf(t),o)}(e,n),o={i:e?5:4,A:t?t.A:_(),P:!1,I:!1,D:{},l:t,t:n,k:i,o:null,g:!1,C:!1};return Object.defineProperty(i,Q,{value:o,writable:!0}),i},S:function(n,r,o){o?t(r)&&r[Q].A===n&&e(n.p):(n.u&&function n(t){if(t&&"object"==typeof t){var r=t[Q];if(r){var e=r.t,o=r.k,f=r.D,c=r.i;if(4===c)i(o,(function(t){t!==Q&&(void 0!==e[t]||u(e,t)?f[t]||n(o[t]):(f[t]=!0,E(r)))})),i(e,(function(n){void 0!==o[n]||u(o,n)||(f[n]=!1,E(r))}));else if(5===c){if(a(r)&&(E(r),f.length=!0),o.length<e.length)for(var s=o.length;s<e.length;s++)f[s]=!1;else for(var v=e.length;v<o.length;v++)f[v]=!0;for(var p=Math.min(o.length,e.length),l=0;l<p;l++)void 0===f[l]&&n(o[l])}}}}(n.p[0]),e(n.p))},K:function(n){return 4===n.i?o(n):a(n)}})}function F(){function e(n){if(!r(n))return n;if(Array.isArray(n))return n.map(e);if(s(n))return new Map(Array.from(n.entries()).map((function(n){return[n[0],e(n[1])]})));if(v(n))return new Set(Array.from(n).map(e));var t=Object.create(Object.getPrototypeOf(n));for(var i in n)t[i]=e(n[i]);return t}function f(n){return t(n)?e(n):n}var c="add";m("Patches",{$:function(t,r){return r.forEach((function(r){for(var i=r.path,u=r.op,f=t,s=0;s<i.length-1;s++)"object"!=typeof(f=a(f,i[s]))&&n(15,i.join("/"));var v=o(f),p=e(r.value),l=i[i.length-1];switch(u){case"replace":switch(v){case 2:return f.set(l,p);case 3:n(16);default:return f[l]=p}case c:switch(v){case 1:return f.splice(l,0,p);case 2:return f.set(l,p);case 3:return f.add(p);default:return f[l]=p}case"remove":switch(v){case 1:return f.splice(l,1);case 2:return f.delete(l);case 3:return f.delete(r.value);default:return delete f[l]}default:n(17,u)}})),t},R:function(n,t,r,e){switch(n.i){case 0:case 4:case 2:return function(n,t,r,e){var o=n.t,s=n.o;i(n.D,(function(n,i){var v=a(o,n),p=a(s,n),l=i?u(o,n)?"replace":c:"remove";if(v!==p||"replace"!==l){var d=t.concat(n);r.push("remove"===l?{op:l,path:d}:{op:l,path:d,value:p}),e.push(l===c?{op:"remove",path:d}:"remove"===l?{op:c,path:d,value:f(v)}:{op:"replace",path:d,value:f(v)})}}))}(n,t,r,e);case 5:case 1:return function(n,t,r,e){var i=n.t,o=n.D,u=n.o;if(u.length<i.length){var a=[u,i];i=a[0],u=a[1];var s=[e,r];r=s[0],e=s[1]}for(var v=0;v<i.length;v++)if(o[v]&&u[v]!==i[v]){var p=t.concat([v]);r.push({op:"replace",path:p,value:f(u[v])}),e.push({op:"replace",path:p,value:f(i[v])})}for(var l=i.length;l<u.length;l++){var d=t.concat([l]);r.push({op:c,path:d,value:f(u[l])})}i.length<u.length&&e.push({op:"replace",path:t.concat(["length"]),value:i.length})}(n,t,r,e);case 3:return function(n,t,r,e){var i=n.t,o=n.o,u=0;i.forEach((function(n){if(!o.has(n)){var i=t.concat([u]);r.push({op:"remove",path:i,value:n}),e.unshift({op:c,path:i,value:n})}u++})),u=0,o.forEach((function(n){if(!i.has(n)){var o=t.concat([u]);r.push({op:c,path:o,value:n}),e.unshift({op:"remove",path:o,value:n})}u++}))}(n,t,r,e)}},M:function(n,t,r,e){r.push({op:"replace",path:[],value:t}),e.push({op:"replace",path:[],value:n.t})}})}function C(){function t(n,t){function r(){this.constructor=n}a(n,t),n.prototype=(r.prototype=t.prototype,new r)}function e(n){n.o||(n.D=new Map,n.o=new Map(n.t))}function o(n){n.o||(n.o=new Set,n.t.forEach((function(t){if(r(t)){var e=R(n.A.h,t,n);n.p.set(t,e),n.o.add(e)}else n.o.add(t)})))}function u(t){t.g&&n(3,JSON.stringify(p(t)))}var a=function(n,t){return(a=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(n,t){n.__proto__=t}||function(n,t){for(var r in t)t.hasOwnProperty(r)&&(n[r]=t[r])})(n,t)},f=function(){function n(n,t){return this[Q]={i:2,l:t,A:t?t.A:_(),P:!1,I:!1,o:void 0,D:void 0,t:n,k:this,C:!1,g:!1},this}t(n,Map);var o=n.prototype;return Object.defineProperty(o,"size",{get:function(){return p(this[Q]).size}}),o.has=function(n){return p(this[Q]).has(n)},o.set=function(n,t){var r=this[Q];return u(r),p(r).has(n)&&p(r).get(n)===t||(e(r),E(r),r.D.set(n,!0),r.o.set(n,t),r.D.set(n,!0)),this},o.delete=function(n){if(!this.has(n))return!1;var t=this[Q];return u(t),e(t),E(t),t.D.set(n,!1),t.o.delete(n),!0},o.clear=function(){var n=this[Q];u(n),p(n).size&&(e(n),E(n),n.D=new Map,i(n.t,(function(t){n.D.set(t,!1)})),n.o.clear())},o.forEach=function(n,t){var r=this;p(this[Q]).forEach((function(e,i){n.call(t,r.get(i),i,r)}))},o.get=function(n){var t=this[Q];u(t);var i=p(t).get(n);if(t.I||!r(i))return i;if(i!==t.t.get(n))return i;var o=R(t.A.h,i,t);return e(t),t.o.set(n,o),o},o.keys=function(){return p(this[Q]).keys()},o.values=function(){var n,t=this,r=this.keys();return(n={})[V]=function(){return t.values()},n.next=function(){var n=r.next();return n.done?n:{done:!1,value:t.get(n.value)}},n},o.entries=function(){var n,t=this,r=this.keys();return(n={})[V]=function(){return t.entries()},n.next=function(){var n=r.next();if(n.done)return n;var e=t.get(n.value);return{done:!1,value:[n.value,e]}},n},o[V]=function(){return this.entries()},n}(),c=function(){function n(n,t){return this[Q]={i:3,l:t,A:t?t.A:_(),P:!1,I:!1,o:void 0,t:n,k:this,p:new Map,g:!1,C:!1},this}t(n,Set);var r=n.prototype;return Object.defineProperty(r,"size",{get:function(){return p(this[Q]).size}}),r.has=function(n){var t=this[Q];return u(t),t.o?!!t.o.has(n)||!(!t.p.has(n)||!t.o.has(t.p.get(n))):t.t.has(n)},r.add=function(n){var t=this[Q];return u(t),this.has(n)||(o(t),E(t),t.o.add(n)),this},r.delete=function(n){if(!this.has(n))return!1;var t=this[Q];return u(t),o(t),E(t),t.o.delete(n)||!!t.p.has(n)&&t.o.delete(t.p.get(n))},r.clear=function(){var n=this[Q];u(n),p(n).size&&(o(n),E(n),n.o.clear())},r.values=function(){var n=this[Q];return u(n),o(n),n.o.values()},r.entries=function(){var n=this[Q];return u(n),o(n),n.o.entries()},r.keys=function(){return this.values()},r[V]=function(){return this.values()},r.forEach=function(n,t){for(var r=this.values(),e=r.next();!e.done;)n.call(t,e.value,e.value,this),e=r.next()},n}();m("MapSet",{T:function(n,t){return new f(n,t)},F:function(n,t){return new c(n,t)}})}function J(){T(),C(),F()}function K(n){return n}function $(n){return n}var G,U,W="undefined"!=typeof Symbol&&"symbol"==typeof Symbol("x"),X="undefined"!=typeof Map,q="undefined"!=typeof Set,B="undefined"!=typeof Proxy&&void 0!==Proxy.revocable&&"undefined"!=typeof Reflect,H=W?Symbol.for("immer-nothing"):((G={})["immer-nothing"]=!0,G),L=W?Symbol.for("immer-draftable"):"__$immer_draftable",Q=W?Symbol.for("immer-state"):"__$immer_state",V="undefined"!=typeof Symbol&&Symbol.iterator||"@@iterator",Y={0:"Illegal state",1:"Immer drafts cannot have computed properties",2:"This object has been frozen and should not be mutated",3:function(n){return"Cannot use a proxy that has been revoked. Did you pass an object from inside an immer function to an async process? "+n},4:"An immer producer returned a new value *and* modified its draft. Either return a new value *or* modify the draft.",5:"Immer forbids circular references",6:"The first or second argument to `produce` must be a function",7:"The third argument to `produce` must be a function or undefined",8:"First argument to `createDraft` must be a plain object, an array, or an immerable object",9:"First argument to `finishDraft` must be a draft returned by `createDraft`",10:"The given draft is already finalized",11:"Object.defineProperty() cannot be used on an Immer draft",12:"Object.setPrototypeOf() cannot be used on an Immer draft",13:"Immer only supports deleting array indices",14:"Immer only supports setting array indices and the 'length' property",15:function(n){return"Cannot apply patch, path doesn't resolve: "+n},16:'Sets cannot have "replace" patches.',17:function(n){return"Unsupported patch operation: "+n},18:function(n){return"The plugin for '"+n+"' has not been loaded into Immer. To enable the plugin, import and call `enable"+n+"()` when initializing your application."},20:"Cannot use proxies if Proxy, Proxy.revocable or Reflect are not available",21:function(n){return"produce can only be called on things that are draftable: plain objects, arrays, Map, Set or classes that are marked with '[immerable]: true'. Got '"+n+"'"},22:function(n){return"'current' expects a draft, got: "+n},23:function(n){return"'original' expects a draft, got: "+n}},Z="undefined"!=typeof Reflect&&Reflect.ownKeys?Reflect.ownKeys:void 0!==Object.getOwnPropertySymbols?function(n){return Object.getOwnPropertyNames(n).concat(Object.getOwnPropertySymbols(n))}:Object.getOwnPropertyNames,nn=Object.getOwnPropertyDescriptors||function(n){var t={};return Z(n).forEach((function(r){t[r]=Object.getOwnPropertyDescriptor(n,r)})),t},tn={},rn={get:function(n,t){if(t===Q)return n;var e=p(n);if(!u(e,t))return function(n,t,r){var e,i=I(t,r);return i?"value"in i?i.value:null===(e=i.get)||void 0===e?void 0:e.call(n.k):void 0}(n,e,t);var i=e[t];return n.I||!r(i)?i:i===z(n.t,t)?(k(n),n.o[t]=R(n.A.h,i,n)):i},has:function(n,t){return t in p(n)},ownKeys:function(n){return Reflect.ownKeys(p(n))},set:function(n,t,r){var e=I(p(n),t);if(null==e?void 0:e.set)return e.set.call(n.k,r),!0;if(!n.P){var i=z(p(n),t),o=null==i?void 0:i[Q];if(o&&o.t===r)return n.o[t]=r,n.D[t]=!1,!0;if(c(r,i)&&(void 0!==r||u(n.t,t)))return!0;k(n),E(n)}return n.o[t]=r,n.D[t]=!0,!0},deleteProperty:function(n,t){return void 0!==z(n.t,t)||t in n.t?(n.D[t]=!1,k(n),E(n)):delete n.D[t],n.o&&delete n.o[t],!0},getOwnPropertyDescriptor:function(n,t){var r=p(n),e=Reflect.getOwnPropertyDescriptor(r,t);return e?{writable:!0,configurable:1!==n.i||"length"!==t,enumerable:e.enumerable,value:r[t]}:e},defineProperty:function(){n(11)},getPrototypeOf:function(n){return Object.getPrototypeOf(n.t)},setPrototypeOf:function(){n(12)}},en={};i(rn,(function(n,t){en[n]=function(){return arguments[0]=arguments[0][0],t.apply(this,arguments)}})),en.deleteProperty=function(t,r){return true&&isNaN(parseInt(r))&&n(13),rn.deleteProperty.call(this,t[0],r)},en.set=function(t,r,e){return true&&"length"!==r&&isNaN(parseInt(r))&&n(14),rn.set.call(this,t[0],r,e,t[0])};var on=function(){function e(n){this.O=B,this.N=!0,"boolean"==typeof(null==n?void 0:n.useProxies)&&this.setUseProxies(n.useProxies),"boolean"==typeof(null==n?void 0:n.autoFreeze)&&this.setAutoFreeze(n.autoFreeze),this.produce=this.produce.bind(this),this.produceWithPatches=this.produceWithPatches.bind(this)}var i=e.prototype;return i.produce=function(t,e,i){if("function"==typeof t&&"function"!=typeof e){var o=e;e=t;var u=this;return function(n){var t=this;void 0===n&&(n=o);for(var r=arguments.length,i=Array(r>1?r-1:0),a=1;a<r;a++)i[a-1]=arguments[a];return u.produce(n,(function(n){var r;return(r=e).call.apply(r,[t,n].concat(i))}))}}var a;if("function"!=typeof e&&n(6),void 0!==i&&"function"!=typeof i&&n(7),r(t)){var f=w(this),c=R(this,t,void 0),s=!0;try{a=e(c),s=!1}finally{s?g(f):O(f)}return"undefined"!=typeof Promise&&a instanceof Promise?a.then((function(n){return j(f,i),P(n,f)}),(function(n){throw g(f),n})):(j(f,i),P(a,f))}if(!t||"object"!=typeof t){if((a=e(t))===H)return;return void 0===a&&(a=t),this.N&&d(a,!0),a}n(21,t)},i.produceWithPatches=function(n,t){var r,e,i=this;return"function"==typeof n?function(t){for(var r=arguments.length,e=Array(r>1?r-1:0),o=1;o<r;o++)e[o-1]=arguments[o];return i.produceWithPatches(t,(function(t){return n.apply(void 0,[t].concat(e))}))}:[this.produce(n,t,(function(n,t){r=n,e=t})),r,e]},i.createDraft=function(e){r(e)||n(8),t(e)&&(e=D(e));var i=w(this),o=R(this,e,void 0);return o[Q].C=!0,O(i),o},i.finishDraft=function(t,r){var e=t&&t[Q]; true&&(e&&e.C||n(9),e.I&&n(10));var i=e.A;return j(i,r),P(void 0,i)},i.setAutoFreeze=function(n){this.N=n},i.setUseProxies=function(t){t&&!B&&n(20),this.O=t},i.applyPatches=function(n,r){var e;for(e=r.length-1;e>=0;e--){var i=r[e];if(0===i.path.length&&"replace"===i.op){n=i.value;break}}var o=b("Patches").$;return t(n)?o(n,r):this.produce(n,(function(n){return o(n,r.slice(e+1))}))},e}(),un=new on,an=un.produce,fn=un.produceWithPatches.bind(un),cn=un.setAutoFreeze.bind(un),sn=un.setUseProxies.bind(un),vn=un.applyPatches.bind(un),pn=un.createDraft.bind(un),ln=un.finishDraft.bind(un);/* harmony default export */ __webpack_exports__["default"] = (an);
//# sourceMappingURL=immer.esm.js.map


/***/ }),

/***/ "./node_modules/immutable/dist/immutable.js":
/*!**************************************************!*\
  !*** ./node_modules/immutable/dist/immutable.js ***!
  \**************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

(function (global, factory) {
   true ? module.exports = factory() :
  undefined;
}(this, function () { 'use strict';var SLICE$0 = Array.prototype.slice;

  function createClass(ctor, superClass) {
    if (superClass) {
      ctor.prototype = Object.create(superClass.prototype);
    }
    ctor.prototype.constructor = ctor;
  }

  function Iterable(value) {
      return isIterable(value) ? value : Seq(value);
    }


  createClass(KeyedIterable, Iterable);
    function KeyedIterable(value) {
      return isKeyed(value) ? value : KeyedSeq(value);
    }


  createClass(IndexedIterable, Iterable);
    function IndexedIterable(value) {
      return isIndexed(value) ? value : IndexedSeq(value);
    }


  createClass(SetIterable, Iterable);
    function SetIterable(value) {
      return isIterable(value) && !isAssociative(value) ? value : SetSeq(value);
    }



  function isIterable(maybeIterable) {
    return !!(maybeIterable && maybeIterable[IS_ITERABLE_SENTINEL]);
  }

  function isKeyed(maybeKeyed) {
    return !!(maybeKeyed && maybeKeyed[IS_KEYED_SENTINEL]);
  }

  function isIndexed(maybeIndexed) {
    return !!(maybeIndexed && maybeIndexed[IS_INDEXED_SENTINEL]);
  }

  function isAssociative(maybeAssociative) {
    return isKeyed(maybeAssociative) || isIndexed(maybeAssociative);
  }

  function isOrdered(maybeOrdered) {
    return !!(maybeOrdered && maybeOrdered[IS_ORDERED_SENTINEL]);
  }

  Iterable.isIterable = isIterable;
  Iterable.isKeyed = isKeyed;
  Iterable.isIndexed = isIndexed;
  Iterable.isAssociative = isAssociative;
  Iterable.isOrdered = isOrdered;

  Iterable.Keyed = KeyedIterable;
  Iterable.Indexed = IndexedIterable;
  Iterable.Set = SetIterable;


  var IS_ITERABLE_SENTINEL = '@@__IMMUTABLE_ITERABLE__@@';
  var IS_KEYED_SENTINEL = '@@__IMMUTABLE_KEYED__@@';
  var IS_INDEXED_SENTINEL = '@@__IMMUTABLE_INDEXED__@@';
  var IS_ORDERED_SENTINEL = '@@__IMMUTABLE_ORDERED__@@';

  // Used for setting prototype methods that IE8 chokes on.
  var DELETE = 'delete';

  // Constants describing the size of trie nodes.
  var SHIFT = 5; // Resulted in best performance after ______?
  var SIZE = 1 << SHIFT;
  var MASK = SIZE - 1;

  // A consistent shared value representing "not set" which equals nothing other
  // than itself, and nothing that could be provided externally.
  var NOT_SET = {};

  // Boolean references, Rough equivalent of `bool &`.
  var CHANGE_LENGTH = { value: false };
  var DID_ALTER = { value: false };

  function MakeRef(ref) {
    ref.value = false;
    return ref;
  }

  function SetRef(ref) {
    ref && (ref.value = true);
  }

  // A function which returns a value representing an "owner" for transient writes
  // to tries. The return value will only ever equal itself, and will not equal
  // the return of any subsequent call of this function.
  function OwnerID() {}

  // http://jsperf.com/copy-array-inline
  function arrCopy(arr, offset) {
    offset = offset || 0;
    var len = Math.max(0, arr.length - offset);
    var newArr = new Array(len);
    for (var ii = 0; ii < len; ii++) {
      newArr[ii] = arr[ii + offset];
    }
    return newArr;
  }

  function ensureSize(iter) {
    if (iter.size === undefined) {
      iter.size = iter.__iterate(returnTrue);
    }
    return iter.size;
  }

  function wrapIndex(iter, index) {
    // This implements "is array index" which the ECMAString spec defines as:
    //
    //     A String property name P is an array index if and only if
    //     ToString(ToUint32(P)) is equal to P and ToUint32(P) is not equal
    //     to 2^32−1.
    //
    // http://www.ecma-international.org/ecma-262/6.0/#sec-array-exotic-objects
    if (typeof index !== 'number') {
      var uint32Index = index >>> 0; // N >>> 0 is shorthand for ToUint32
      if ('' + uint32Index !== index || uint32Index === 4294967295) {
        return NaN;
      }
      index = uint32Index;
    }
    return index < 0 ? ensureSize(iter) + index : index;
  }

  function returnTrue() {
    return true;
  }

  function wholeSlice(begin, end, size) {
    return (begin === 0 || (size !== undefined && begin <= -size)) &&
      (end === undefined || (size !== undefined && end >= size));
  }

  function resolveBegin(begin, size) {
    return resolveIndex(begin, size, 0);
  }

  function resolveEnd(end, size) {
    return resolveIndex(end, size, size);
  }

  function resolveIndex(index, size, defaultIndex) {
    return index === undefined ?
      defaultIndex :
      index < 0 ?
        Math.max(0, size + index) :
        size === undefined ?
          index :
          Math.min(size, index);
  }

  /* global Symbol */

  var ITERATE_KEYS = 0;
  var ITERATE_VALUES = 1;
  var ITERATE_ENTRIES = 2;

  var REAL_ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
  var FAUX_ITERATOR_SYMBOL = '@@iterator';

  var ITERATOR_SYMBOL = REAL_ITERATOR_SYMBOL || FAUX_ITERATOR_SYMBOL;


  function Iterator(next) {
      this.next = next;
    }

    Iterator.prototype.toString = function() {
      return '[Iterator]';
    };


  Iterator.KEYS = ITERATE_KEYS;
  Iterator.VALUES = ITERATE_VALUES;
  Iterator.ENTRIES = ITERATE_ENTRIES;

  Iterator.prototype.inspect =
  Iterator.prototype.toSource = function () { return this.toString(); }
  Iterator.prototype[ITERATOR_SYMBOL] = function () {
    return this;
  };


  function iteratorValue(type, k, v, iteratorResult) {
    var value = type === 0 ? k : type === 1 ? v : [k, v];
    iteratorResult ? (iteratorResult.value = value) : (iteratorResult = {
      value: value, done: false
    });
    return iteratorResult;
  }

  function iteratorDone() {
    return { value: undefined, done: true };
  }

  function hasIterator(maybeIterable) {
    return !!getIteratorFn(maybeIterable);
  }

  function isIterator(maybeIterator) {
    return maybeIterator && typeof maybeIterator.next === 'function';
  }

  function getIterator(iterable) {
    var iteratorFn = getIteratorFn(iterable);
    return iteratorFn && iteratorFn.call(iterable);
  }

  function getIteratorFn(iterable) {
    var iteratorFn = iterable && (
      (REAL_ITERATOR_SYMBOL && iterable[REAL_ITERATOR_SYMBOL]) ||
      iterable[FAUX_ITERATOR_SYMBOL]
    );
    if (typeof iteratorFn === 'function') {
      return iteratorFn;
    }
  }

  function isArrayLike(value) {
    return value && typeof value.length === 'number';
  }

  createClass(Seq, Iterable);
    function Seq(value) {
      return value === null || value === undefined ? emptySequence() :
        isIterable(value) ? value.toSeq() : seqFromValue(value);
    }

    Seq.of = function(/*...values*/) {
      return Seq(arguments);
    };

    Seq.prototype.toSeq = function() {
      return this;
    };

    Seq.prototype.toString = function() {
      return this.__toString('Seq {', '}');
    };

    Seq.prototype.cacheResult = function() {
      if (!this._cache && this.__iterateUncached) {
        this._cache = this.entrySeq().toArray();
        this.size = this._cache.length;
      }
      return this;
    };

    // abstract __iterateUncached(fn, reverse)

    Seq.prototype.__iterate = function(fn, reverse) {
      return seqIterate(this, fn, reverse, true);
    };

    // abstract __iteratorUncached(type, reverse)

    Seq.prototype.__iterator = function(type, reverse) {
      return seqIterator(this, type, reverse, true);
    };



  createClass(KeyedSeq, Seq);
    function KeyedSeq(value) {
      return value === null || value === undefined ?
        emptySequence().toKeyedSeq() :
        isIterable(value) ?
          (isKeyed(value) ? value.toSeq() : value.fromEntrySeq()) :
          keyedSeqFromValue(value);
    }

    KeyedSeq.prototype.toKeyedSeq = function() {
      return this;
    };



  createClass(IndexedSeq, Seq);
    function IndexedSeq(value) {
      return value === null || value === undefined ? emptySequence() :
        !isIterable(value) ? indexedSeqFromValue(value) :
        isKeyed(value) ? value.entrySeq() : value.toIndexedSeq();
    }

    IndexedSeq.of = function(/*...values*/) {
      return IndexedSeq(arguments);
    };

    IndexedSeq.prototype.toIndexedSeq = function() {
      return this;
    };

    IndexedSeq.prototype.toString = function() {
      return this.__toString('Seq [', ']');
    };

    IndexedSeq.prototype.__iterate = function(fn, reverse) {
      return seqIterate(this, fn, reverse, false);
    };

    IndexedSeq.prototype.__iterator = function(type, reverse) {
      return seqIterator(this, type, reverse, false);
    };



  createClass(SetSeq, Seq);
    function SetSeq(value) {
      return (
        value === null || value === undefined ? emptySequence() :
        !isIterable(value) ? indexedSeqFromValue(value) :
        isKeyed(value) ? value.entrySeq() : value
      ).toSetSeq();
    }

    SetSeq.of = function(/*...values*/) {
      return SetSeq(arguments);
    };

    SetSeq.prototype.toSetSeq = function() {
      return this;
    };



  Seq.isSeq = isSeq;
  Seq.Keyed = KeyedSeq;
  Seq.Set = SetSeq;
  Seq.Indexed = IndexedSeq;

  var IS_SEQ_SENTINEL = '@@__IMMUTABLE_SEQ__@@';

  Seq.prototype[IS_SEQ_SENTINEL] = true;



  createClass(ArraySeq, IndexedSeq);
    function ArraySeq(array) {
      this._array = array;
      this.size = array.length;
    }

    ArraySeq.prototype.get = function(index, notSetValue) {
      return this.has(index) ? this._array[wrapIndex(this, index)] : notSetValue;
    };

    ArraySeq.prototype.__iterate = function(fn, reverse) {
      var array = this._array;
      var maxIndex = array.length - 1;
      for (var ii = 0; ii <= maxIndex; ii++) {
        if (fn(array[reverse ? maxIndex - ii : ii], ii, this) === false) {
          return ii + 1;
        }
      }
      return ii;
    };

    ArraySeq.prototype.__iterator = function(type, reverse) {
      var array = this._array;
      var maxIndex = array.length - 1;
      var ii = 0;
      return new Iterator(function() 
        {return ii > maxIndex ?
          iteratorDone() :
          iteratorValue(type, ii, array[reverse ? maxIndex - ii++ : ii++])}
      );
    };



  createClass(ObjectSeq, KeyedSeq);
    function ObjectSeq(object) {
      var keys = Object.keys(object);
      this._object = object;
      this._keys = keys;
      this.size = keys.length;
    }

    ObjectSeq.prototype.get = function(key, notSetValue) {
      if (notSetValue !== undefined && !this.has(key)) {
        return notSetValue;
      }
      return this._object[key];
    };

    ObjectSeq.prototype.has = function(key) {
      return this._object.hasOwnProperty(key);
    };

    ObjectSeq.prototype.__iterate = function(fn, reverse) {
      var object = this._object;
      var keys = this._keys;
      var maxIndex = keys.length - 1;
      for (var ii = 0; ii <= maxIndex; ii++) {
        var key = keys[reverse ? maxIndex - ii : ii];
        if (fn(object[key], key, this) === false) {
          return ii + 1;
        }
      }
      return ii;
    };

    ObjectSeq.prototype.__iterator = function(type, reverse) {
      var object = this._object;
      var keys = this._keys;
      var maxIndex = keys.length - 1;
      var ii = 0;
      return new Iterator(function()  {
        var key = keys[reverse ? maxIndex - ii : ii];
        return ii++ > maxIndex ?
          iteratorDone() :
          iteratorValue(type, key, object[key]);
      });
    };

  ObjectSeq.prototype[IS_ORDERED_SENTINEL] = true;


  createClass(IterableSeq, IndexedSeq);
    function IterableSeq(iterable) {
      this._iterable = iterable;
      this.size = iterable.length || iterable.size;
    }

    IterableSeq.prototype.__iterateUncached = function(fn, reverse) {
      if (reverse) {
        return this.cacheResult().__iterate(fn, reverse);
      }
      var iterable = this._iterable;
      var iterator = getIterator(iterable);
      var iterations = 0;
      if (isIterator(iterator)) {
        var step;
        while (!(step = iterator.next()).done) {
          if (fn(step.value, iterations++, this) === false) {
            break;
          }
        }
      }
      return iterations;
    };

    IterableSeq.prototype.__iteratorUncached = function(type, reverse) {
      if (reverse) {
        return this.cacheResult().__iterator(type, reverse);
      }
      var iterable = this._iterable;
      var iterator = getIterator(iterable);
      if (!isIterator(iterator)) {
        return new Iterator(iteratorDone);
      }
      var iterations = 0;
      return new Iterator(function()  {
        var step = iterator.next();
        return step.done ? step : iteratorValue(type, iterations++, step.value);
      });
    };



  createClass(IteratorSeq, IndexedSeq);
    function IteratorSeq(iterator) {
      this._iterator = iterator;
      this._iteratorCache = [];
    }

    IteratorSeq.prototype.__iterateUncached = function(fn, reverse) {
      if (reverse) {
        return this.cacheResult().__iterate(fn, reverse);
      }
      var iterator = this._iterator;
      var cache = this._iteratorCache;
      var iterations = 0;
      while (iterations < cache.length) {
        if (fn(cache[iterations], iterations++, this) === false) {
          return iterations;
        }
      }
      var step;
      while (!(step = iterator.next()).done) {
        var val = step.value;
        cache[iterations] = val;
        if (fn(val, iterations++, this) === false) {
          break;
        }
      }
      return iterations;
    };

    IteratorSeq.prototype.__iteratorUncached = function(type, reverse) {
      if (reverse) {
        return this.cacheResult().__iterator(type, reverse);
      }
      var iterator = this._iterator;
      var cache = this._iteratorCache;
      var iterations = 0;
      return new Iterator(function()  {
        if (iterations >= cache.length) {
          var step = iterator.next();
          if (step.done) {
            return step;
          }
          cache[iterations] = step.value;
        }
        return iteratorValue(type, iterations, cache[iterations++]);
      });
    };




  // # pragma Helper functions

  function isSeq(maybeSeq) {
    return !!(maybeSeq && maybeSeq[IS_SEQ_SENTINEL]);
  }

  var EMPTY_SEQ;

  function emptySequence() {
    return EMPTY_SEQ || (EMPTY_SEQ = new ArraySeq([]));
  }

  function keyedSeqFromValue(value) {
    var seq =
      Array.isArray(value) ? new ArraySeq(value).fromEntrySeq() :
      isIterator(value) ? new IteratorSeq(value).fromEntrySeq() :
      hasIterator(value) ? new IterableSeq(value).fromEntrySeq() :
      typeof value === 'object' ? new ObjectSeq(value) :
      undefined;
    if (!seq) {
      throw new TypeError(
        'Expected Array or iterable object of [k, v] entries, '+
        'or keyed object: ' + value
      );
    }
    return seq;
  }

  function indexedSeqFromValue(value) {
    var seq = maybeIndexedSeqFromValue(value);
    if (!seq) {
      throw new TypeError(
        'Expected Array or iterable object of values: ' + value
      );
    }
    return seq;
  }

  function seqFromValue(value) {
    var seq = maybeIndexedSeqFromValue(value) ||
      (typeof value === 'object' && new ObjectSeq(value));
    if (!seq) {
      throw new TypeError(
        'Expected Array or iterable object of values, or keyed object: ' + value
      );
    }
    return seq;
  }

  function maybeIndexedSeqFromValue(value) {
    return (
      isArrayLike(value) ? new ArraySeq(value) :
      isIterator(value) ? new IteratorSeq(value) :
      hasIterator(value) ? new IterableSeq(value) :
      undefined
    );
  }

  function seqIterate(seq, fn, reverse, useKeys) {
    var cache = seq._cache;
    if (cache) {
      var maxIndex = cache.length - 1;
      for (var ii = 0; ii <= maxIndex; ii++) {
        var entry = cache[reverse ? maxIndex - ii : ii];
        if (fn(entry[1], useKeys ? entry[0] : ii, seq) === false) {
          return ii + 1;
        }
      }
      return ii;
    }
    return seq.__iterateUncached(fn, reverse);
  }

  function seqIterator(seq, type, reverse, useKeys) {
    var cache = seq._cache;
    if (cache) {
      var maxIndex = cache.length - 1;
      var ii = 0;
      return new Iterator(function()  {
        var entry = cache[reverse ? maxIndex - ii : ii];
        return ii++ > maxIndex ?
          iteratorDone() :
          iteratorValue(type, useKeys ? entry[0] : ii - 1, entry[1]);
      });
    }
    return seq.__iteratorUncached(type, reverse);
  }

  function fromJS(json, converter) {
    return converter ?
      fromJSWith(converter, json, '', {'': json}) :
      fromJSDefault(json);
  }

  function fromJSWith(converter, json, key, parentJSON) {
    if (Array.isArray(json)) {
      return converter.call(parentJSON, key, IndexedSeq(json).map(function(v, k)  {return fromJSWith(converter, v, k, json)}));
    }
    if (isPlainObj(json)) {
      return converter.call(parentJSON, key, KeyedSeq(json).map(function(v, k)  {return fromJSWith(converter, v, k, json)}));
    }
    return json;
  }

  function fromJSDefault(json) {
    if (Array.isArray(json)) {
      return IndexedSeq(json).map(fromJSDefault).toList();
    }
    if (isPlainObj(json)) {
      return KeyedSeq(json).map(fromJSDefault).toMap();
    }
    return json;
  }

  function isPlainObj(value) {
    return value && (value.constructor === Object || value.constructor === undefined);
  }

  /**
   * An extension of the "same-value" algorithm as [described for use by ES6 Map
   * and Set](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Map#Key_equality)
   *
   * NaN is considered the same as NaN, however -0 and 0 are considered the same
   * value, which is different from the algorithm described by
   * [`Object.is`](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is).
   *
   * This is extended further to allow Objects to describe the values they
   * represent, by way of `valueOf` or `equals` (and `hashCode`).
   *
   * Note: because of this extension, the key equality of Immutable.Map and the
   * value equality of Immutable.Set will differ from ES6 Map and Set.
   *
   * ### Defining custom values
   *
   * The easiest way to describe the value an object represents is by implementing
   * `valueOf`. For example, `Date` represents a value by returning a unix
   * timestamp for `valueOf`:
   *
   *     var date1 = new Date(1234567890000); // Fri Feb 13 2009 ...
   *     var date2 = new Date(1234567890000);
   *     date1.valueOf(); // 1234567890000
   *     assert( date1 !== date2 );
   *     assert( Immutable.is( date1, date2 ) );
   *
   * Note: overriding `valueOf` may have other implications if you use this object
   * where JavaScript expects a primitive, such as implicit string coercion.
   *
   * For more complex types, especially collections, implementing `valueOf` may
   * not be performant. An alternative is to implement `equals` and `hashCode`.
   *
   * `equals` takes another object, presumably of similar type, and returns true
   * if the it is equal. Equality is symmetrical, so the same result should be
   * returned if this and the argument are flipped.
   *
   *     assert( a.equals(b) === b.equals(a) );
   *
   * `hashCode` returns a 32bit integer number representing the object which will
   * be used to determine how to store the value object in a Map or Set. You must
   * provide both or neither methods, one must not exist without the other.
   *
   * Also, an important relationship between these methods must be upheld: if two
   * values are equal, they *must* return the same hashCode. If the values are not
   * equal, they might have the same hashCode; this is called a hash collision,
   * and while undesirable for performance reasons, it is acceptable.
   *
   *     if (a.equals(b)) {
   *       assert( a.hashCode() === b.hashCode() );
   *     }
   *
   * All Immutable collections implement `equals` and `hashCode`.
   *
   */
  function is(valueA, valueB) {
    if (valueA === valueB || (valueA !== valueA && valueB !== valueB)) {
      return true;
    }
    if (!valueA || !valueB) {
      return false;
    }
    if (typeof valueA.valueOf === 'function' &&
        typeof valueB.valueOf === 'function') {
      valueA = valueA.valueOf();
      valueB = valueB.valueOf();
      if (valueA === valueB || (valueA !== valueA && valueB !== valueB)) {
        return true;
      }
      if (!valueA || !valueB) {
        return false;
      }
    }
    if (typeof valueA.equals === 'function' &&
        typeof valueB.equals === 'function' &&
        valueA.equals(valueB)) {
      return true;
    }
    return false;
  }

  function deepEqual(a, b) {
    if (a === b) {
      return true;
    }

    if (
      !isIterable(b) ||
      a.size !== undefined && b.size !== undefined && a.size !== b.size ||
      a.__hash !== undefined && b.__hash !== undefined && a.__hash !== b.__hash ||
      isKeyed(a) !== isKeyed(b) ||
      isIndexed(a) !== isIndexed(b) ||
      isOrdered(a) !== isOrdered(b)
    ) {
      return false;
    }

    if (a.size === 0 && b.size === 0) {
      return true;
    }

    var notAssociative = !isAssociative(a);

    if (isOrdered(a)) {
      var entries = a.entries();
      return b.every(function(v, k)  {
        var entry = entries.next().value;
        return entry && is(entry[1], v) && (notAssociative || is(entry[0], k));
      }) && entries.next().done;
    }

    var flipped = false;

    if (a.size === undefined) {
      if (b.size === undefined) {
        if (typeof a.cacheResult === 'function') {
          a.cacheResult();
        }
      } else {
        flipped = true;
        var _ = a;
        a = b;
        b = _;
      }
    }

    var allEqual = true;
    var bSize = b.__iterate(function(v, k)  {
      if (notAssociative ? !a.has(v) :
          flipped ? !is(v, a.get(k, NOT_SET)) : !is(a.get(k, NOT_SET), v)) {
        allEqual = false;
        return false;
      }
    });

    return allEqual && a.size === bSize;
  }

  createClass(Repeat, IndexedSeq);

    function Repeat(value, times) {
      if (!(this instanceof Repeat)) {
        return new Repeat(value, times);
      }
      this._value = value;
      this.size = times === undefined ? Infinity : Math.max(0, times);
      if (this.size === 0) {
        if (EMPTY_REPEAT) {
          return EMPTY_REPEAT;
        }
        EMPTY_REPEAT = this;
      }
    }

    Repeat.prototype.toString = function() {
      if (this.size === 0) {
        return 'Repeat []';
      }
      return 'Repeat [ ' + this._value + ' ' + this.size + ' times ]';
    };

    Repeat.prototype.get = function(index, notSetValue) {
      return this.has(index) ? this._value : notSetValue;
    };

    Repeat.prototype.includes = function(searchValue) {
      return is(this._value, searchValue);
    };

    Repeat.prototype.slice = function(begin, end) {
      var size = this.size;
      return wholeSlice(begin, end, size) ? this :
        new Repeat(this._value, resolveEnd(end, size) - resolveBegin(begin, size));
    };

    Repeat.prototype.reverse = function() {
      return this;
    };

    Repeat.prototype.indexOf = function(searchValue) {
      if (is(this._value, searchValue)) {
        return 0;
      }
      return -1;
    };

    Repeat.prototype.lastIndexOf = function(searchValue) {
      if (is(this._value, searchValue)) {
        return this.size;
      }
      return -1;
    };

    Repeat.prototype.__iterate = function(fn, reverse) {
      for (var ii = 0; ii < this.size; ii++) {
        if (fn(this._value, ii, this) === false) {
          return ii + 1;
        }
      }
      return ii;
    };

    Repeat.prototype.__iterator = function(type, reverse) {var this$0 = this;
      var ii = 0;
      return new Iterator(function() 
        {return ii < this$0.size ? iteratorValue(type, ii++, this$0._value) : iteratorDone()}
      );
    };

    Repeat.prototype.equals = function(other) {
      return other instanceof Repeat ?
        is(this._value, other._value) :
        deepEqual(other);
    };


  var EMPTY_REPEAT;

  function invariant(condition, error) {
    if (!condition) throw new Error(error);
  }

  createClass(Range, IndexedSeq);

    function Range(start, end, step) {
      if (!(this instanceof Range)) {
        return new Range(start, end, step);
      }
      invariant(step !== 0, 'Cannot step a Range by 0');
      start = start || 0;
      if (end === undefined) {
        end = Infinity;
      }
      step = step === undefined ? 1 : Math.abs(step);
      if (end < start) {
        step = -step;
      }
      this._start = start;
      this._end = end;
      this._step = step;
      this.size = Math.max(0, Math.ceil((end - start) / step - 1) + 1);
      if (this.size === 0) {
        if (EMPTY_RANGE) {
          return EMPTY_RANGE;
        }
        EMPTY_RANGE = this;
      }
    }

    Range.prototype.toString = function() {
      if (this.size === 0) {
        return 'Range []';
      }
      return 'Range [ ' +
        this._start + '...' + this._end +
        (this._step !== 1 ? ' by ' + this._step : '') +
      ' ]';
    };

    Range.prototype.get = function(index, notSetValue) {
      return this.has(index) ?
        this._start + wrapIndex(this, index) * this._step :
        notSetValue;
    };

    Range.prototype.includes = function(searchValue) {
      var possibleIndex = (searchValue - this._start) / this._step;
      return possibleIndex >= 0 &&
        possibleIndex < this.size &&
        possibleIndex === Math.floor(possibleIndex);
    };

    Range.prototype.slice = function(begin, end) {
      if (wholeSlice(begin, end, this.size)) {
        return this;
      }
      begin = resolveBegin(begin, this.size);
      end = resolveEnd(end, this.size);
      if (end <= begin) {
        return new Range(0, 0);
      }
      return new Range(this.get(begin, this._end), this.get(end, this._end), this._step);
    };

    Range.prototype.indexOf = function(searchValue) {
      var offsetValue = searchValue - this._start;
      if (offsetValue % this._step === 0) {
        var index = offsetValue / this._step;
        if (index >= 0 && index < this.size) {
          return index
        }
      }
      return -1;
    };

    Range.prototype.lastIndexOf = function(searchValue) {
      return this.indexOf(searchValue);
    };

    Range.prototype.__iterate = function(fn, reverse) {
      var maxIndex = this.size - 1;
      var step = this._step;
      var value = reverse ? this._start + maxIndex * step : this._start;
      for (var ii = 0; ii <= maxIndex; ii++) {
        if (fn(value, ii, this) === false) {
          return ii + 1;
        }
        value += reverse ? -step : step;
      }
      return ii;
    };

    Range.prototype.__iterator = function(type, reverse) {
      var maxIndex = this.size - 1;
      var step = this._step;
      var value = reverse ? this._start + maxIndex * step : this._start;
      var ii = 0;
      return new Iterator(function()  {
        var v = value;
        value += reverse ? -step : step;
        return ii > maxIndex ? iteratorDone() : iteratorValue(type, ii++, v);
      });
    };

    Range.prototype.equals = function(other) {
      return other instanceof Range ?
        this._start === other._start &&
        this._end === other._end &&
        this._step === other._step :
        deepEqual(this, other);
    };


  var EMPTY_RANGE;

  createClass(Collection, Iterable);
    function Collection() {
      throw TypeError('Abstract');
    }


  createClass(KeyedCollection, Collection);function KeyedCollection() {}

  createClass(IndexedCollection, Collection);function IndexedCollection() {}

  createClass(SetCollection, Collection);function SetCollection() {}


  Collection.Keyed = KeyedCollection;
  Collection.Indexed = IndexedCollection;
  Collection.Set = SetCollection;

  var imul =
    typeof Math.imul === 'function' && Math.imul(0xffffffff, 2) === -2 ?
    Math.imul :
    function imul(a, b) {
      a = a | 0; // int
      b = b | 0; // int
      var c = a & 0xffff;
      var d = b & 0xffff;
      // Shift by 0 fixes the sign on the high part.
      return (c * d) + ((((a >>> 16) * d + c * (b >>> 16)) << 16) >>> 0) | 0; // int
    };

  // v8 has an optimization for storing 31-bit signed numbers.
  // Values which have either 00 or 11 as the high order bits qualify.
  // This function drops the highest order bit in a signed number, maintaining
  // the sign bit.
  function smi(i32) {
    return ((i32 >>> 1) & 0x40000000) | (i32 & 0xBFFFFFFF);
  }

  function hash(o) {
    if (o === false || o === null || o === undefined) {
      return 0;
    }
    if (typeof o.valueOf === 'function') {
      o = o.valueOf();
      if (o === false || o === null || o === undefined) {
        return 0;
      }
    }
    if (o === true) {
      return 1;
    }
    var type = typeof o;
    if (type === 'number') {
      if (o !== o || o === Infinity) {
        return 0;
      }
      var h = o | 0;
      if (h !== o) {
        h ^= o * 0xFFFFFFFF;
      }
      while (o > 0xFFFFFFFF) {
        o /= 0xFFFFFFFF;
        h ^= o;
      }
      return smi(h);
    }
    if (type === 'string') {
      return o.length > STRING_HASH_CACHE_MIN_STRLEN ? cachedHashString(o) : hashString(o);
    }
    if (typeof o.hashCode === 'function') {
      return o.hashCode();
    }
    if (type === 'object') {
      return hashJSObj(o);
    }
    if (typeof o.toString === 'function') {
      return hashString(o.toString());
    }
    throw new Error('Value type ' + type + ' cannot be hashed.');
  }

  function cachedHashString(string) {
    var hash = stringHashCache[string];
    if (hash === undefined) {
      hash = hashString(string);
      if (STRING_HASH_CACHE_SIZE === STRING_HASH_CACHE_MAX_SIZE) {
        STRING_HASH_CACHE_SIZE = 0;
        stringHashCache = {};
      }
      STRING_HASH_CACHE_SIZE++;
      stringHashCache[string] = hash;
    }
    return hash;
  }

  // http://jsperf.com/hashing-strings
  function hashString(string) {
    // This is the hash from JVM
    // The hash code for a string is computed as
    // s[0] * 31 ^ (n - 1) + s[1] * 31 ^ (n - 2) + ... + s[n - 1],
    // where s[i] is the ith character of the string and n is the length of
    // the string. We "mod" the result to make it between 0 (inclusive) and 2^31
    // (exclusive) by dropping high bits.
    var hash = 0;
    for (var ii = 0; ii < string.length; ii++) {
      hash = 31 * hash + string.charCodeAt(ii) | 0;
    }
    return smi(hash);
  }

  function hashJSObj(obj) {
    var hash;
    if (usingWeakMap) {
      hash = weakMap.get(obj);
      if (hash !== undefined) {
        return hash;
      }
    }

    hash = obj[UID_HASH_KEY];
    if (hash !== undefined) {
      return hash;
    }

    if (!canDefineProperty) {
      hash = obj.propertyIsEnumerable && obj.propertyIsEnumerable[UID_HASH_KEY];
      if (hash !== undefined) {
        return hash;
      }

      hash = getIENodeHash(obj);
      if (hash !== undefined) {
        return hash;
      }
    }

    hash = ++objHashUID;
    if (objHashUID & 0x40000000) {
      objHashUID = 0;
    }

    if (usingWeakMap) {
      weakMap.set(obj, hash);
    } else if (isExtensible !== undefined && isExtensible(obj) === false) {
      throw new Error('Non-extensible objects are not allowed as keys.');
    } else if (canDefineProperty) {
      Object.defineProperty(obj, UID_HASH_KEY, {
        'enumerable': false,
        'configurable': false,
        'writable': false,
        'value': hash
      });
    } else if (obj.propertyIsEnumerable !== undefined &&
               obj.propertyIsEnumerable === obj.constructor.prototype.propertyIsEnumerable) {
      // Since we can't define a non-enumerable property on the object
      // we'll hijack one of the less-used non-enumerable properties to
      // save our hash on it. Since this is a function it will not show up in
      // `JSON.stringify` which is what we want.
      obj.propertyIsEnumerable = function() {
        return this.constructor.prototype.propertyIsEnumerable.apply(this, arguments);
      };
      obj.propertyIsEnumerable[UID_HASH_KEY] = hash;
    } else if (obj.nodeType !== undefined) {
      // At this point we couldn't get the IE `uniqueID` to use as a hash
      // and we couldn't use a non-enumerable property to exploit the
      // dontEnum bug so we simply add the `UID_HASH_KEY` on the node
      // itself.
      obj[UID_HASH_KEY] = hash;
    } else {
      throw new Error('Unable to set a non-enumerable property on object.');
    }

    return hash;
  }

  // Get references to ES5 object methods.
  var isExtensible = Object.isExtensible;

  // True if Object.defineProperty works as expected. IE8 fails this test.
  var canDefineProperty = (function() {
    try {
      Object.defineProperty({}, '@', {});
      return true;
    } catch (e) {
      return false;
    }
  }());

  // IE has a `uniqueID` property on DOM nodes. We can construct the hash from it
  // and avoid memory leaks from the IE cloneNode bug.
  function getIENodeHash(node) {
    if (node && node.nodeType > 0) {
      switch (node.nodeType) {
        case 1: // Element
          return node.uniqueID;
        case 9: // Document
          return node.documentElement && node.documentElement.uniqueID;
      }
    }
  }

  // If possible, use a WeakMap.
  var usingWeakMap = typeof WeakMap === 'function';
  var weakMap;
  if (usingWeakMap) {
    weakMap = new WeakMap();
  }

  var objHashUID = 0;

  var UID_HASH_KEY = '__immutablehash__';
  if (typeof Symbol === 'function') {
    UID_HASH_KEY = Symbol(UID_HASH_KEY);
  }

  var STRING_HASH_CACHE_MIN_STRLEN = 16;
  var STRING_HASH_CACHE_MAX_SIZE = 255;
  var STRING_HASH_CACHE_SIZE = 0;
  var stringHashCache = {};

  function assertNotInfinite(size) {
    invariant(
      size !== Infinity,
      'Cannot perform this action with an infinite size.'
    );
  }

  createClass(Map, KeyedCollection);

    // @pragma Construction

    function Map(value) {
      return value === null || value === undefined ? emptyMap() :
        isMap(value) && !isOrdered(value) ? value :
        emptyMap().withMutations(function(map ) {
          var iter = KeyedIterable(value);
          assertNotInfinite(iter.size);
          iter.forEach(function(v, k)  {return map.set(k, v)});
        });
    }

    Map.of = function() {var keyValues = SLICE$0.call(arguments, 0);
      return emptyMap().withMutations(function(map ) {
        for (var i = 0; i < keyValues.length; i += 2) {
          if (i + 1 >= keyValues.length) {
            throw new Error('Missing value for key: ' + keyValues[i]);
          }
          map.set(keyValues[i], keyValues[i + 1]);
        }
      });
    };

    Map.prototype.toString = function() {
      return this.__toString('Map {', '}');
    };

    // @pragma Access

    Map.prototype.get = function(k, notSetValue) {
      return this._root ?
        this._root.get(0, undefined, k, notSetValue) :
        notSetValue;
    };

    // @pragma Modification

    Map.prototype.set = function(k, v) {
      return updateMap(this, k, v);
    };

    Map.prototype.setIn = function(keyPath, v) {
      return this.updateIn(keyPath, NOT_SET, function()  {return v});
    };

    Map.prototype.remove = function(k) {
      return updateMap(this, k, NOT_SET);
    };

    Map.prototype.deleteIn = function(keyPath) {
      return this.updateIn(keyPath, function()  {return NOT_SET});
    };

    Map.prototype.update = function(k, notSetValue, updater) {
      return arguments.length === 1 ?
        k(this) :
        this.updateIn([k], notSetValue, updater);
    };

    Map.prototype.updateIn = function(keyPath, notSetValue, updater) {
      if (!updater) {
        updater = notSetValue;
        notSetValue = undefined;
      }
      var updatedValue = updateInDeepMap(
        this,
        forceIterator(keyPath),
        notSetValue,
        updater
      );
      return updatedValue === NOT_SET ? undefined : updatedValue;
    };

    Map.prototype.clear = function() {
      if (this.size === 0) {
        return this;
      }
      if (this.__ownerID) {
        this.size = 0;
        this._root = null;
        this.__hash = undefined;
        this.__altered = true;
        return this;
      }
      return emptyMap();
    };

    // @pragma Composition

    Map.prototype.merge = function(/*...iters*/) {
      return mergeIntoMapWith(this, undefined, arguments);
    };

    Map.prototype.mergeWith = function(merger) {var iters = SLICE$0.call(arguments, 1);
      return mergeIntoMapWith(this, merger, iters);
    };

    Map.prototype.mergeIn = function(keyPath) {var iters = SLICE$0.call(arguments, 1);
      return this.updateIn(
        keyPath,
        emptyMap(),
        function(m ) {return typeof m.merge === 'function' ?
          m.merge.apply(m, iters) :
          iters[iters.length - 1]}
      );
    };

    Map.prototype.mergeDeep = function(/*...iters*/) {
      return mergeIntoMapWith(this, deepMerger, arguments);
    };

    Map.prototype.mergeDeepWith = function(merger) {var iters = SLICE$0.call(arguments, 1);
      return mergeIntoMapWith(this, deepMergerWith(merger), iters);
    };

    Map.prototype.mergeDeepIn = function(keyPath) {var iters = SLICE$0.call(arguments, 1);
      return this.updateIn(
        keyPath,
        emptyMap(),
        function(m ) {return typeof m.mergeDeep === 'function' ?
          m.mergeDeep.apply(m, iters) :
          iters[iters.length - 1]}
      );
    };

    Map.prototype.sort = function(comparator) {
      // Late binding
      return OrderedMap(sortFactory(this, comparator));
    };

    Map.prototype.sortBy = function(mapper, comparator) {
      // Late binding
      return OrderedMap(sortFactory(this, comparator, mapper));
    };

    // @pragma Mutability

    Map.prototype.withMutations = function(fn) {
      var mutable = this.asMutable();
      fn(mutable);
      return mutable.wasAltered() ? mutable.__ensureOwner(this.__ownerID) : this;
    };

    Map.prototype.asMutable = function() {
      return this.__ownerID ? this : this.__ensureOwner(new OwnerID());
    };

    Map.prototype.asImmutable = function() {
      return this.__ensureOwner();
    };

    Map.prototype.wasAltered = function() {
      return this.__altered;
    };

    Map.prototype.__iterator = function(type, reverse) {
      return new MapIterator(this, type, reverse);
    };

    Map.prototype.__iterate = function(fn, reverse) {var this$0 = this;
      var iterations = 0;
      this._root && this._root.iterate(function(entry ) {
        iterations++;
        return fn(entry[1], entry[0], this$0);
      }, reverse);
      return iterations;
    };

    Map.prototype.__ensureOwner = function(ownerID) {
      if (ownerID === this.__ownerID) {
        return this;
      }
      if (!ownerID) {
        this.__ownerID = ownerID;
        this.__altered = false;
        return this;
      }
      return makeMap(this.size, this._root, ownerID, this.__hash);
    };


  function isMap(maybeMap) {
    return !!(maybeMap && maybeMap[IS_MAP_SENTINEL]);
  }

  Map.isMap = isMap;

  var IS_MAP_SENTINEL = '@@__IMMUTABLE_MAP__@@';

  var MapPrototype = Map.prototype;
  MapPrototype[IS_MAP_SENTINEL] = true;
  MapPrototype[DELETE] = MapPrototype.remove;
  MapPrototype.removeIn = MapPrototype.deleteIn;


  // #pragma Trie Nodes



    function ArrayMapNode(ownerID, entries) {
      this.ownerID = ownerID;
      this.entries = entries;
    }

    ArrayMapNode.prototype.get = function(shift, keyHash, key, notSetValue) {
      var entries = this.entries;
      for (var ii = 0, len = entries.length; ii < len; ii++) {
        if (is(key, entries[ii][0])) {
          return entries[ii][1];
        }
      }
      return notSetValue;
    };

    ArrayMapNode.prototype.update = function(ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
      var removed = value === NOT_SET;

      var entries = this.entries;
      var idx = 0;
      for (var len = entries.length; idx < len; idx++) {
        if (is(key, entries[idx][0])) {
          break;
        }
      }
      var exists = idx < len;

      if (exists ? entries[idx][1] === value : removed) {
        return this;
      }

      SetRef(didAlter);
      (removed || !exists) && SetRef(didChangeSize);

      if (removed && entries.length === 1) {
        return; // undefined
      }

      if (!exists && !removed && entries.length >= MAX_ARRAY_MAP_SIZE) {
        return createNodes(ownerID, entries, key, value);
      }

      var isEditable = ownerID && ownerID === this.ownerID;
      var newEntries = isEditable ? entries : arrCopy(entries);

      if (exists) {
        if (removed) {
          idx === len - 1 ? newEntries.pop() : (newEntries[idx] = newEntries.pop());
        } else {
          newEntries[idx] = [key, value];
        }
      } else {
        newEntries.push([key, value]);
      }

      if (isEditable) {
        this.entries = newEntries;
        return this;
      }

      return new ArrayMapNode(ownerID, newEntries);
    };




    function BitmapIndexedNode(ownerID, bitmap, nodes) {
      this.ownerID = ownerID;
      this.bitmap = bitmap;
      this.nodes = nodes;
    }

    BitmapIndexedNode.prototype.get = function(shift, keyHash, key, notSetValue) {
      if (keyHash === undefined) {
        keyHash = hash(key);
      }
      var bit = (1 << ((shift === 0 ? keyHash : keyHash >>> shift) & MASK));
      var bitmap = this.bitmap;
      return (bitmap & bit) === 0 ? notSetValue :
        this.nodes[popCount(bitmap & (bit - 1))].get(shift + SHIFT, keyHash, key, notSetValue);
    };

    BitmapIndexedNode.prototype.update = function(ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
      if (keyHash === undefined) {
        keyHash = hash(key);
      }
      var keyHashFrag = (shift === 0 ? keyHash : keyHash >>> shift) & MASK;
      var bit = 1 << keyHashFrag;
      var bitmap = this.bitmap;
      var exists = (bitmap & bit) !== 0;

      if (!exists && value === NOT_SET) {
        return this;
      }

      var idx = popCount(bitmap & (bit - 1));
      var nodes = this.nodes;
      var node = exists ? nodes[idx] : undefined;
      var newNode = updateNode(node, ownerID, shift + SHIFT, keyHash, key, value, didChangeSize, didAlter);

      if (newNode === node) {
        return this;
      }

      if (!exists && newNode && nodes.length >= MAX_BITMAP_INDEXED_SIZE) {
        return expandNodes(ownerID, nodes, bitmap, keyHashFrag, newNode);
      }

      if (exists && !newNode && nodes.length === 2 && isLeafNode(nodes[idx ^ 1])) {
        return nodes[idx ^ 1];
      }

      if (exists && newNode && nodes.length === 1 && isLeafNode(newNode)) {
        return newNode;
      }

      var isEditable = ownerID && ownerID === this.ownerID;
      var newBitmap = exists ? newNode ? bitmap : bitmap ^ bit : bitmap | bit;
      var newNodes = exists ? newNode ?
        setIn(nodes, idx, newNode, isEditable) :
        spliceOut(nodes, idx, isEditable) :
        spliceIn(nodes, idx, newNode, isEditable);

      if (isEditable) {
        this.bitmap = newBitmap;
        this.nodes = newNodes;
        return this;
      }

      return new BitmapIndexedNode(ownerID, newBitmap, newNodes);
    };




    function HashArrayMapNode(ownerID, count, nodes) {
      this.ownerID = ownerID;
      this.count = count;
      this.nodes = nodes;
    }

    HashArrayMapNode.prototype.get = function(shift, keyHash, key, notSetValue) {
      if (keyHash === undefined) {
        keyHash = hash(key);
      }
      var idx = (shift === 0 ? keyHash : keyHash >>> shift) & MASK;
      var node = this.nodes[idx];
      return node ? node.get(shift + SHIFT, keyHash, key, notSetValue) : notSetValue;
    };

    HashArrayMapNode.prototype.update = function(ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
      if (keyHash === undefined) {
        keyHash = hash(key);
      }
      var idx = (shift === 0 ? keyHash : keyHash >>> shift) & MASK;
      var removed = value === NOT_SET;
      var nodes = this.nodes;
      var node = nodes[idx];

      if (removed && !node) {
        return this;
      }

      var newNode = updateNode(node, ownerID, shift + SHIFT, keyHash, key, value, didChangeSize, didAlter);
      if (newNode === node) {
        return this;
      }

      var newCount = this.count;
      if (!node) {
        newCount++;
      } else if (!newNode) {
        newCount--;
        if (newCount < MIN_HASH_ARRAY_MAP_SIZE) {
          return packNodes(ownerID, nodes, newCount, idx);
        }
      }

      var isEditable = ownerID && ownerID === this.ownerID;
      var newNodes = setIn(nodes, idx, newNode, isEditable);

      if (isEditable) {
        this.count = newCount;
        this.nodes = newNodes;
        return this;
      }

      return new HashArrayMapNode(ownerID, newCount, newNodes);
    };




    function HashCollisionNode(ownerID, keyHash, entries) {
      this.ownerID = ownerID;
      this.keyHash = keyHash;
      this.entries = entries;
    }

    HashCollisionNode.prototype.get = function(shift, keyHash, key, notSetValue) {
      var entries = this.entries;
      for (var ii = 0, len = entries.length; ii < len; ii++) {
        if (is(key, entries[ii][0])) {
          return entries[ii][1];
        }
      }
      return notSetValue;
    };

    HashCollisionNode.prototype.update = function(ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
      if (keyHash === undefined) {
        keyHash = hash(key);
      }

      var removed = value === NOT_SET;

      if (keyHash !== this.keyHash) {
        if (removed) {
          return this;
        }
        SetRef(didAlter);
        SetRef(didChangeSize);
        return mergeIntoNode(this, ownerID, shift, keyHash, [key, value]);
      }

      var entries = this.entries;
      var idx = 0;
      for (var len = entries.length; idx < len; idx++) {
        if (is(key, entries[idx][0])) {
          break;
        }
      }
      var exists = idx < len;

      if (exists ? entries[idx][1] === value : removed) {
        return this;
      }

      SetRef(didAlter);
      (removed || !exists) && SetRef(didChangeSize);

      if (removed && len === 2) {
        return new ValueNode(ownerID, this.keyHash, entries[idx ^ 1]);
      }

      var isEditable = ownerID && ownerID === this.ownerID;
      var newEntries = isEditable ? entries : arrCopy(entries);

      if (exists) {
        if (removed) {
          idx === len - 1 ? newEntries.pop() : (newEntries[idx] = newEntries.pop());
        } else {
          newEntries[idx] = [key, value];
        }
      } else {
        newEntries.push([key, value]);
      }

      if (isEditable) {
        this.entries = newEntries;
        return this;
      }

      return new HashCollisionNode(ownerID, this.keyHash, newEntries);
    };




    function ValueNode(ownerID, keyHash, entry) {
      this.ownerID = ownerID;
      this.keyHash = keyHash;
      this.entry = entry;
    }

    ValueNode.prototype.get = function(shift, keyHash, key, notSetValue) {
      return is(key, this.entry[0]) ? this.entry[1] : notSetValue;
    };

    ValueNode.prototype.update = function(ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
      var removed = value === NOT_SET;
      var keyMatch = is(key, this.entry[0]);
      if (keyMatch ? value === this.entry[1] : removed) {
        return this;
      }

      SetRef(didAlter);

      if (removed) {
        SetRef(didChangeSize);
        return; // undefined
      }

      if (keyMatch) {
        if (ownerID && ownerID === this.ownerID) {
          this.entry[1] = value;
          return this;
        }
        return new ValueNode(ownerID, this.keyHash, [key, value]);
      }

      SetRef(didChangeSize);
      return mergeIntoNode(this, ownerID, shift, hash(key), [key, value]);
    };



  // #pragma Iterators

  ArrayMapNode.prototype.iterate =
  HashCollisionNode.prototype.iterate = function (fn, reverse) {
    var entries = this.entries;
    for (var ii = 0, maxIndex = entries.length - 1; ii <= maxIndex; ii++) {
      if (fn(entries[reverse ? maxIndex - ii : ii]) === false) {
        return false;
      }
    }
  }

  BitmapIndexedNode.prototype.iterate =
  HashArrayMapNode.prototype.iterate = function (fn, reverse) {
    var nodes = this.nodes;
    for (var ii = 0, maxIndex = nodes.length - 1; ii <= maxIndex; ii++) {
      var node = nodes[reverse ? maxIndex - ii : ii];
      if (node && node.iterate(fn, reverse) === false) {
        return false;
      }
    }
  }

  ValueNode.prototype.iterate = function (fn, reverse) {
    return fn(this.entry);
  }

  createClass(MapIterator, Iterator);

    function MapIterator(map, type, reverse) {
      this._type = type;
      this._reverse = reverse;
      this._stack = map._root && mapIteratorFrame(map._root);
    }

    MapIterator.prototype.next = function() {
      var type = this._type;
      var stack = this._stack;
      while (stack) {
        var node = stack.node;
        var index = stack.index++;
        var maxIndex;
        if (node.entry) {
          if (index === 0) {
            return mapIteratorValue(type, node.entry);
          }
        } else if (node.entries) {
          maxIndex = node.entries.length - 1;
          if (index <= maxIndex) {
            return mapIteratorValue(type, node.entries[this._reverse ? maxIndex - index : index]);
          }
        } else {
          maxIndex = node.nodes.length - 1;
          if (index <= maxIndex) {
            var subNode = node.nodes[this._reverse ? maxIndex - index : index];
            if (subNode) {
              if (subNode.entry) {
                return mapIteratorValue(type, subNode.entry);
              }
              stack = this._stack = mapIteratorFrame(subNode, stack);
            }
            continue;
          }
        }
        stack = this._stack = this._stack.__prev;
      }
      return iteratorDone();
    };


  function mapIteratorValue(type, entry) {
    return iteratorValue(type, entry[0], entry[1]);
  }

  function mapIteratorFrame(node, prev) {
    return {
      node: node,
      index: 0,
      __prev: prev
    };
  }

  function makeMap(size, root, ownerID, hash) {
    var map = Object.create(MapPrototype);
    map.size = size;
    map._root = root;
    map.__ownerID = ownerID;
    map.__hash = hash;
    map.__altered = false;
    return map;
  }

  var EMPTY_MAP;
  function emptyMap() {
    return EMPTY_MAP || (EMPTY_MAP = makeMap(0));
  }

  function updateMap(map, k, v) {
    var newRoot;
    var newSize;
    if (!map._root) {
      if (v === NOT_SET) {
        return map;
      }
      newSize = 1;
      newRoot = new ArrayMapNode(map.__ownerID, [[k, v]]);
    } else {
      var didChangeSize = MakeRef(CHANGE_LENGTH);
      var didAlter = MakeRef(DID_ALTER);
      newRoot = updateNode(map._root, map.__ownerID, 0, undefined, k, v, didChangeSize, didAlter);
      if (!didAlter.value) {
        return map;
      }
      newSize = map.size + (didChangeSize.value ? v === NOT_SET ? -1 : 1 : 0);
    }
    if (map.__ownerID) {
      map.size = newSize;
      map._root = newRoot;
      map.__hash = undefined;
      map.__altered = true;
      return map;
    }
    return newRoot ? makeMap(newSize, newRoot) : emptyMap();
  }

  function updateNode(node, ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
    if (!node) {
      if (value === NOT_SET) {
        return node;
      }
      SetRef(didAlter);
      SetRef(didChangeSize);
      return new ValueNode(ownerID, keyHash, [key, value]);
    }
    return node.update(ownerID, shift, keyHash, key, value, didChangeSize, didAlter);
  }

  function isLeafNode(node) {
    return node.constructor === ValueNode || node.constructor === HashCollisionNode;
  }

  function mergeIntoNode(node, ownerID, shift, keyHash, entry) {
    if (node.keyHash === keyHash) {
      return new HashCollisionNode(ownerID, keyHash, [node.entry, entry]);
    }

    var idx1 = (shift === 0 ? node.keyHash : node.keyHash >>> shift) & MASK;
    var idx2 = (shift === 0 ? keyHash : keyHash >>> shift) & MASK;

    var newNode;
    var nodes = idx1 === idx2 ?
      [mergeIntoNode(node, ownerID, shift + SHIFT, keyHash, entry)] :
      ((newNode = new ValueNode(ownerID, keyHash, entry)), idx1 < idx2 ? [node, newNode] : [newNode, node]);

    return new BitmapIndexedNode(ownerID, (1 << idx1) | (1 << idx2), nodes);
  }

  function createNodes(ownerID, entries, key, value) {
    if (!ownerID) {
      ownerID = new OwnerID();
    }
    var node = new ValueNode(ownerID, hash(key), [key, value]);
    for (var ii = 0; ii < entries.length; ii++) {
      var entry = entries[ii];
      node = node.update(ownerID, 0, undefined, entry[0], entry[1]);
    }
    return node;
  }

  function packNodes(ownerID, nodes, count, excluding) {
    var bitmap = 0;
    var packedII = 0;
    var packedNodes = new Array(count);
    for (var ii = 0, bit = 1, len = nodes.length; ii < len; ii++, bit <<= 1) {
      var node = nodes[ii];
      if (node !== undefined && ii !== excluding) {
        bitmap |= bit;
        packedNodes[packedII++] = node;
      }
    }
    return new BitmapIndexedNode(ownerID, bitmap, packedNodes);
  }

  function expandNodes(ownerID, nodes, bitmap, including, node) {
    var count = 0;
    var expandedNodes = new Array(SIZE);
    for (var ii = 0; bitmap !== 0; ii++, bitmap >>>= 1) {
      expandedNodes[ii] = bitmap & 1 ? nodes[count++] : undefined;
    }
    expandedNodes[including] = node;
    return new HashArrayMapNode(ownerID, count + 1, expandedNodes);
  }

  function mergeIntoMapWith(map, merger, iterables) {
    var iters = [];
    for (var ii = 0; ii < iterables.length; ii++) {
      var value = iterables[ii];
      var iter = KeyedIterable(value);
      if (!isIterable(value)) {
        iter = iter.map(function(v ) {return fromJS(v)});
      }
      iters.push(iter);
    }
    return mergeIntoCollectionWith(map, merger, iters);
  }

  function deepMerger(existing, value, key) {
    return existing && existing.mergeDeep && isIterable(value) ?
      existing.mergeDeep(value) :
      is(existing, value) ? existing : value;
  }

  function deepMergerWith(merger) {
    return function(existing, value, key)  {
      if (existing && existing.mergeDeepWith && isIterable(value)) {
        return existing.mergeDeepWith(merger, value);
      }
      var nextValue = merger(existing, value, key);
      return is(existing, nextValue) ? existing : nextValue;
    };
  }

  function mergeIntoCollectionWith(collection, merger, iters) {
    iters = iters.filter(function(x ) {return x.size !== 0});
    if (iters.length === 0) {
      return collection;
    }
    if (collection.size === 0 && !collection.__ownerID && iters.length === 1) {
      return collection.constructor(iters[0]);
    }
    return collection.withMutations(function(collection ) {
      var mergeIntoMap = merger ?
        function(value, key)  {
          collection.update(key, NOT_SET, function(existing )
            {return existing === NOT_SET ? value : merger(existing, value, key)}
          );
        } :
        function(value, key)  {
          collection.set(key, value);
        }
      for (var ii = 0; ii < iters.length; ii++) {
        iters[ii].forEach(mergeIntoMap);
      }
    });
  }

  function updateInDeepMap(existing, keyPathIter, notSetValue, updater) {
    var isNotSet = existing === NOT_SET;
    var step = keyPathIter.next();
    if (step.done) {
      var existingValue = isNotSet ? notSetValue : existing;
      var newValue = updater(existingValue);
      return newValue === existingValue ? existing : newValue;
    }
    invariant(
      isNotSet || (existing && existing.set),
      'invalid keyPath'
    );
    var key = step.value;
    var nextExisting = isNotSet ? NOT_SET : existing.get(key, NOT_SET);
    var nextUpdated = updateInDeepMap(
      nextExisting,
      keyPathIter,
      notSetValue,
      updater
    );
    return nextUpdated === nextExisting ? existing :
      nextUpdated === NOT_SET ? existing.remove(key) :
      (isNotSet ? emptyMap() : existing).set(key, nextUpdated);
  }

  function popCount(x) {
    x = x - ((x >> 1) & 0x55555555);
    x = (x & 0x33333333) + ((x >> 2) & 0x33333333);
    x = (x + (x >> 4)) & 0x0f0f0f0f;
    x = x + (x >> 8);
    x = x + (x >> 16);
    return x & 0x7f;
  }

  function setIn(array, idx, val, canEdit) {
    var newArray = canEdit ? array : arrCopy(array);
    newArray[idx] = val;
    return newArray;
  }

  function spliceIn(array, idx, val, canEdit) {
    var newLen = array.length + 1;
    if (canEdit && idx + 1 === newLen) {
      array[idx] = val;
      return array;
    }
    var newArray = new Array(newLen);
    var after = 0;
    for (var ii = 0; ii < newLen; ii++) {
      if (ii === idx) {
        newArray[ii] = val;
        after = -1;
      } else {
        newArray[ii] = array[ii + after];
      }
    }
    return newArray;
  }

  function spliceOut(array, idx, canEdit) {
    var newLen = array.length - 1;
    if (canEdit && idx === newLen) {
      array.pop();
      return array;
    }
    var newArray = new Array(newLen);
    var after = 0;
    for (var ii = 0; ii < newLen; ii++) {
      if (ii === idx) {
        after = 1;
      }
      newArray[ii] = array[ii + after];
    }
    return newArray;
  }

  var MAX_ARRAY_MAP_SIZE = SIZE / 4;
  var MAX_BITMAP_INDEXED_SIZE = SIZE / 2;
  var MIN_HASH_ARRAY_MAP_SIZE = SIZE / 4;

  createClass(List, IndexedCollection);

    // @pragma Construction

    function List(value) {
      var empty = emptyList();
      if (value === null || value === undefined) {
        return empty;
      }
      if (isList(value)) {
        return value;
      }
      var iter = IndexedIterable(value);
      var size = iter.size;
      if (size === 0) {
        return empty;
      }
      assertNotInfinite(size);
      if (size > 0 && size < SIZE) {
        return makeList(0, size, SHIFT, null, new VNode(iter.toArray()));
      }
      return empty.withMutations(function(list ) {
        list.setSize(size);
        iter.forEach(function(v, i)  {return list.set(i, v)});
      });
    }

    List.of = function(/*...values*/) {
      return this(arguments);
    };

    List.prototype.toString = function() {
      return this.__toString('List [', ']');
    };

    // @pragma Access

    List.prototype.get = function(index, notSetValue) {
      index = wrapIndex(this, index);
      if (index >= 0 && index < this.size) {
        index += this._origin;
        var node = listNodeFor(this, index);
        return node && node.array[index & MASK];
      }
      return notSetValue;
    };

    // @pragma Modification

    List.prototype.set = function(index, value) {
      return updateList(this, index, value);
    };

    List.prototype.remove = function(index) {
      return !this.has(index) ? this :
        index === 0 ? this.shift() :
        index === this.size - 1 ? this.pop() :
        this.splice(index, 1);
    };

    List.prototype.insert = function(index, value) {
      return this.splice(index, 0, value);
    };

    List.prototype.clear = function() {
      if (this.size === 0) {
        return this;
      }
      if (this.__ownerID) {
        this.size = this._origin = this._capacity = 0;
        this._level = SHIFT;
        this._root = this._tail = null;
        this.__hash = undefined;
        this.__altered = true;
        return this;
      }
      return emptyList();
    };

    List.prototype.push = function(/*...values*/) {
      var values = arguments;
      var oldSize = this.size;
      return this.withMutations(function(list ) {
        setListBounds(list, 0, oldSize + values.length);
        for (var ii = 0; ii < values.length; ii++) {
          list.set(oldSize + ii, values[ii]);
        }
      });
    };

    List.prototype.pop = function() {
      return setListBounds(this, 0, -1);
    };

    List.prototype.unshift = function(/*...values*/) {
      var values = arguments;
      return this.withMutations(function(list ) {
        setListBounds(list, -values.length);
        for (var ii = 0; ii < values.length; ii++) {
          list.set(ii, values[ii]);
        }
      });
    };

    List.prototype.shift = function() {
      return setListBounds(this, 1);
    };

    // @pragma Composition

    List.prototype.merge = function(/*...iters*/) {
      return mergeIntoListWith(this, undefined, arguments);
    };

    List.prototype.mergeWith = function(merger) {var iters = SLICE$0.call(arguments, 1);
      return mergeIntoListWith(this, merger, iters);
    };

    List.prototype.mergeDeep = function(/*...iters*/) {
      return mergeIntoListWith(this, deepMerger, arguments);
    };

    List.prototype.mergeDeepWith = function(merger) {var iters = SLICE$0.call(arguments, 1);
      return mergeIntoListWith(this, deepMergerWith(merger), iters);
    };

    List.prototype.setSize = function(size) {
      return setListBounds(this, 0, size);
    };

    // @pragma Iteration

    List.prototype.slice = function(begin, end) {
      var size = this.size;
      if (wholeSlice(begin, end, size)) {
        return this;
      }
      return setListBounds(
        this,
        resolveBegin(begin, size),
        resolveEnd(end, size)
      );
    };

    List.prototype.__iterator = function(type, reverse) {
      var index = 0;
      var values = iterateList(this, reverse);
      return new Iterator(function()  {
        var value = values();
        return value === DONE ?
          iteratorDone() :
          iteratorValue(type, index++, value);
      });
    };

    List.prototype.__iterate = function(fn, reverse) {
      var index = 0;
      var values = iterateList(this, reverse);
      var value;
      while ((value = values()) !== DONE) {
        if (fn(value, index++, this) === false) {
          break;
        }
      }
      return index;
    };

    List.prototype.__ensureOwner = function(ownerID) {
      if (ownerID === this.__ownerID) {
        return this;
      }
      if (!ownerID) {
        this.__ownerID = ownerID;
        return this;
      }
      return makeList(this._origin, this._capacity, this._level, this._root, this._tail, ownerID, this.__hash);
    };


  function isList(maybeList) {
    return !!(maybeList && maybeList[IS_LIST_SENTINEL]);
  }

  List.isList = isList;

  var IS_LIST_SENTINEL = '@@__IMMUTABLE_LIST__@@';

  var ListPrototype = List.prototype;
  ListPrototype[IS_LIST_SENTINEL] = true;
  ListPrototype[DELETE] = ListPrototype.remove;
  ListPrototype.setIn = MapPrototype.setIn;
  ListPrototype.deleteIn =
  ListPrototype.removeIn = MapPrototype.removeIn;
  ListPrototype.update = MapPrototype.update;
  ListPrototype.updateIn = MapPrototype.updateIn;
  ListPrototype.mergeIn = MapPrototype.mergeIn;
  ListPrototype.mergeDeepIn = MapPrototype.mergeDeepIn;
  ListPrototype.withMutations = MapPrototype.withMutations;
  ListPrototype.asMutable = MapPrototype.asMutable;
  ListPrototype.asImmutable = MapPrototype.asImmutable;
  ListPrototype.wasAltered = MapPrototype.wasAltered;



    function VNode(array, ownerID) {
      this.array = array;
      this.ownerID = ownerID;
    }

    // TODO: seems like these methods are very similar

    VNode.prototype.removeBefore = function(ownerID, level, index) {
      if (index === level ? 1 << level :  false || this.array.length === 0) {
        return this;
      }
      var originIndex = (index >>> level) & MASK;
      if (originIndex >= this.array.length) {
        return new VNode([], ownerID);
      }
      var removingFirst = originIndex === 0;
      var newChild;
      if (level > 0) {
        var oldChild = this.array[originIndex];
        newChild = oldChild && oldChild.removeBefore(ownerID, level - SHIFT, index);
        if (newChild === oldChild && removingFirst) {
          return this;
        }
      }
      if (removingFirst && !newChild) {
        return this;
      }
      var editable = editableVNode(this, ownerID);
      if (!removingFirst) {
        for (var ii = 0; ii < originIndex; ii++) {
          editable.array[ii] = undefined;
        }
      }
      if (newChild) {
        editable.array[originIndex] = newChild;
      }
      return editable;
    };

    VNode.prototype.removeAfter = function(ownerID, level, index) {
      if (index === (level ? 1 << level : 0) || this.array.length === 0) {
        return this;
      }
      var sizeIndex = ((index - 1) >>> level) & MASK;
      if (sizeIndex >= this.array.length) {
        return this;
      }

      var newChild;
      if (level > 0) {
        var oldChild = this.array[sizeIndex];
        newChild = oldChild && oldChild.removeAfter(ownerID, level - SHIFT, index);
        if (newChild === oldChild && sizeIndex === this.array.length - 1) {
          return this;
        }
      }

      var editable = editableVNode(this, ownerID);
      editable.array.splice(sizeIndex + 1);
      if (newChild) {
        editable.array[sizeIndex] = newChild;
      }
      return editable;
    };



  var DONE = {};

  function iterateList(list, reverse) {
    var left = list._origin;
    var right = list._capacity;
    var tailPos = getTailOffset(right);
    var tail = list._tail;

    return iterateNodeOrLeaf(list._root, list._level, 0);

    function iterateNodeOrLeaf(node, level, offset) {
      return level === 0 ?
        iterateLeaf(node, offset) :
        iterateNode(node, level, offset);
    }

    function iterateLeaf(node, offset) {
      var array = offset === tailPos ? tail && tail.array : node && node.array;
      var from = offset > left ? 0 : left - offset;
      var to = right - offset;
      if (to > SIZE) {
        to = SIZE;
      }
      return function()  {
        if (from === to) {
          return DONE;
        }
        var idx = reverse ? --to : from++;
        return array && array[idx];
      };
    }

    function iterateNode(node, level, offset) {
      var values;
      var array = node && node.array;
      var from = offset > left ? 0 : (left - offset) >> level;
      var to = ((right - offset) >> level) + 1;
      if (to > SIZE) {
        to = SIZE;
      }
      return function()  {
        do {
          if (values) {
            var value = values();
            if (value !== DONE) {
              return value;
            }
            values = null;
          }
          if (from === to) {
            return DONE;
          }
          var idx = reverse ? --to : from++;
          values = iterateNodeOrLeaf(
            array && array[idx], level - SHIFT, offset + (idx << level)
          );
        } while (true);
      };
    }
  }

  function makeList(origin, capacity, level, root, tail, ownerID, hash) {
    var list = Object.create(ListPrototype);
    list.size = capacity - origin;
    list._origin = origin;
    list._capacity = capacity;
    list._level = level;
    list._root = root;
    list._tail = tail;
    list.__ownerID = ownerID;
    list.__hash = hash;
    list.__altered = false;
    return list;
  }

  var EMPTY_LIST;
  function emptyList() {
    return EMPTY_LIST || (EMPTY_LIST = makeList(0, 0, SHIFT));
  }

  function updateList(list, index, value) {
    index = wrapIndex(list, index);

    if (index !== index) {
      return list;
    }

    if (index >= list.size || index < 0) {
      return list.withMutations(function(list ) {
        index < 0 ?
          setListBounds(list, index).set(0, value) :
          setListBounds(list, 0, index + 1).set(index, value)
      });
    }

    index += list._origin;

    var newTail = list._tail;
    var newRoot = list._root;
    var didAlter = MakeRef(DID_ALTER);
    if (index >= getTailOffset(list._capacity)) {
      newTail = updateVNode(newTail, list.__ownerID, 0, index, value, didAlter);
    } else {
      newRoot = updateVNode(newRoot, list.__ownerID, list._level, index, value, didAlter);
    }

    if (!didAlter.value) {
      return list;
    }

    if (list.__ownerID) {
      list._root = newRoot;
      list._tail = newTail;
      list.__hash = undefined;
      list.__altered = true;
      return list;
    }
    return makeList(list._origin, list._capacity, list._level, newRoot, newTail);
  }

  function updateVNode(node, ownerID, level, index, value, didAlter) {
    var idx = (index >>> level) & MASK;
    var nodeHas = node && idx < node.array.length;
    if (!nodeHas && value === undefined) {
      return node;
    }

    var newNode;

    if (level > 0) {
      var lowerNode = node && node.array[idx];
      var newLowerNode = updateVNode(lowerNode, ownerID, level - SHIFT, index, value, didAlter);
      if (newLowerNode === lowerNode) {
        return node;
      }
      newNode = editableVNode(node, ownerID);
      newNode.array[idx] = newLowerNode;
      return newNode;
    }

    if (nodeHas && node.array[idx] === value) {
      return node;
    }

    SetRef(didAlter);

    newNode = editableVNode(node, ownerID);
    if (value === undefined && idx === newNode.array.length - 1) {
      newNode.array.pop();
    } else {
      newNode.array[idx] = value;
    }
    return newNode;
  }

  function editableVNode(node, ownerID) {
    if (ownerID && node && ownerID === node.ownerID) {
      return node;
    }
    return new VNode(node ? node.array.slice() : [], ownerID);
  }

  function listNodeFor(list, rawIndex) {
    if (rawIndex >= getTailOffset(list._capacity)) {
      return list._tail;
    }
    if (rawIndex < 1 << (list._level + SHIFT)) {
      var node = list._root;
      var level = list._level;
      while (node && level > 0) {
        node = node.array[(rawIndex >>> level) & MASK];
        level -= SHIFT;
      }
      return node;
    }
  }

  function setListBounds(list, begin, end) {
    // Sanitize begin & end using this shorthand for ToInt32(argument)
    // http://www.ecma-international.org/ecma-262/6.0/#sec-toint32
    if (begin !== undefined) {
      begin = begin | 0;
    }
    if (end !== undefined) {
      end = end | 0;
    }
    var owner = list.__ownerID || new OwnerID();
    var oldOrigin = list._origin;
    var oldCapacity = list._capacity;
    var newOrigin = oldOrigin + begin;
    var newCapacity = end === undefined ? oldCapacity : end < 0 ? oldCapacity + end : oldOrigin + end;
    if (newOrigin === oldOrigin && newCapacity === oldCapacity) {
      return list;
    }

    // If it's going to end after it starts, it's empty.
    if (newOrigin >= newCapacity) {
      return list.clear();
    }

    var newLevel = list._level;
    var newRoot = list._root;

    // New origin might need creating a higher root.
    var offsetShift = 0;
    while (newOrigin + offsetShift < 0) {
      newRoot = new VNode(newRoot && newRoot.array.length ? [undefined, newRoot] : [], owner);
      newLevel += SHIFT;
      offsetShift += 1 << newLevel;
    }
    if (offsetShift) {
      newOrigin += offsetShift;
      oldOrigin += offsetShift;
      newCapacity += offsetShift;
      oldCapacity += offsetShift;
    }

    var oldTailOffset = getTailOffset(oldCapacity);
    var newTailOffset = getTailOffset(newCapacity);

    // New size might need creating a higher root.
    while (newTailOffset >= 1 << (newLevel + SHIFT)) {
      newRoot = new VNode(newRoot && newRoot.array.length ? [newRoot] : [], owner);
      newLevel += SHIFT;
    }

    // Locate or create the new tail.
    var oldTail = list._tail;
    var newTail = newTailOffset < oldTailOffset ?
      listNodeFor(list, newCapacity - 1) :
      newTailOffset > oldTailOffset ? new VNode([], owner) : oldTail;

    // Merge Tail into tree.
    if (oldTail && newTailOffset > oldTailOffset && newOrigin < oldCapacity && oldTail.array.length) {
      newRoot = editableVNode(newRoot, owner);
      var node = newRoot;
      for (var level = newLevel; level > SHIFT; level -= SHIFT) {
        var idx = (oldTailOffset >>> level) & MASK;
        node = node.array[idx] = editableVNode(node.array[idx], owner);
      }
      node.array[(oldTailOffset >>> SHIFT) & MASK] = oldTail;
    }

    // If the size has been reduced, there's a chance the tail needs to be trimmed.
    if (newCapacity < oldCapacity) {
      newTail = newTail && newTail.removeAfter(owner, 0, newCapacity);
    }

    // If the new origin is within the tail, then we do not need a root.
    if (newOrigin >= newTailOffset) {
      newOrigin -= newTailOffset;
      newCapacity -= newTailOffset;
      newLevel = SHIFT;
      newRoot = null;
      newTail = newTail && newTail.removeBefore(owner, 0, newOrigin);

    // Otherwise, if the root has been trimmed, garbage collect.
    } else if (newOrigin > oldOrigin || newTailOffset < oldTailOffset) {
      offsetShift = 0;

      // Identify the new top root node of the subtree of the old root.
      while (newRoot) {
        var beginIndex = (newOrigin >>> newLevel) & MASK;
        if (beginIndex !== (newTailOffset >>> newLevel) & MASK) {
          break;
        }
        if (beginIndex) {
          offsetShift += (1 << newLevel) * beginIndex;
        }
        newLevel -= SHIFT;
        newRoot = newRoot.array[beginIndex];
      }

      // Trim the new sides of the new root.
      if (newRoot && newOrigin > oldOrigin) {
        newRoot = newRoot.removeBefore(owner, newLevel, newOrigin - offsetShift);
      }
      if (newRoot && newTailOffset < oldTailOffset) {
        newRoot = newRoot.removeAfter(owner, newLevel, newTailOffset - offsetShift);
      }
      if (offsetShift) {
        newOrigin -= offsetShift;
        newCapacity -= offsetShift;
      }
    }

    if (list.__ownerID) {
      list.size = newCapacity - newOrigin;
      list._origin = newOrigin;
      list._capacity = newCapacity;
      list._level = newLevel;
      list._root = newRoot;
      list._tail = newTail;
      list.__hash = undefined;
      list.__altered = true;
      return list;
    }
    return makeList(newOrigin, newCapacity, newLevel, newRoot, newTail);
  }

  function mergeIntoListWith(list, merger, iterables) {
    var iters = [];
    var maxSize = 0;
    for (var ii = 0; ii < iterables.length; ii++) {
      var value = iterables[ii];
      var iter = IndexedIterable(value);
      if (iter.size > maxSize) {
        maxSize = iter.size;
      }
      if (!isIterable(value)) {
        iter = iter.map(function(v ) {return fromJS(v)});
      }
      iters.push(iter);
    }
    if (maxSize > list.size) {
      list = list.setSize(maxSize);
    }
    return mergeIntoCollectionWith(list, merger, iters);
  }

  function getTailOffset(size) {
    return size < SIZE ? 0 : (((size - 1) >>> SHIFT) << SHIFT);
  }

  createClass(OrderedMap, Map);

    // @pragma Construction

    function OrderedMap(value) {
      return value === null || value === undefined ? emptyOrderedMap() :
        isOrderedMap(value) ? value :
        emptyOrderedMap().withMutations(function(map ) {
          var iter = KeyedIterable(value);
          assertNotInfinite(iter.size);
          iter.forEach(function(v, k)  {return map.set(k, v)});
        });
    }

    OrderedMap.of = function(/*...values*/) {
      return this(arguments);
    };

    OrderedMap.prototype.toString = function() {
      return this.__toString('OrderedMap {', '}');
    };

    // @pragma Access

    OrderedMap.prototype.get = function(k, notSetValue) {
      var index = this._map.get(k);
      return index !== undefined ? this._list.get(index)[1] : notSetValue;
    };

    // @pragma Modification

    OrderedMap.prototype.clear = function() {
      if (this.size === 0) {
        return this;
      }
      if (this.__ownerID) {
        this.size = 0;
        this._map.clear();
        this._list.clear();
        return this;
      }
      return emptyOrderedMap();
    };

    OrderedMap.prototype.set = function(k, v) {
      return updateOrderedMap(this, k, v);
    };

    OrderedMap.prototype.remove = function(k) {
      return updateOrderedMap(this, k, NOT_SET);
    };

    OrderedMap.prototype.wasAltered = function() {
      return this._map.wasAltered() || this._list.wasAltered();
    };

    OrderedMap.prototype.__iterate = function(fn, reverse) {var this$0 = this;
      return this._list.__iterate(
        function(entry ) {return entry && fn(entry[1], entry[0], this$0)},
        reverse
      );
    };

    OrderedMap.prototype.__iterator = function(type, reverse) {
      return this._list.fromEntrySeq().__iterator(type, reverse);
    };

    OrderedMap.prototype.__ensureOwner = function(ownerID) {
      if (ownerID === this.__ownerID) {
        return this;
      }
      var newMap = this._map.__ensureOwner(ownerID);
      var newList = this._list.__ensureOwner(ownerID);
      if (!ownerID) {
        this.__ownerID = ownerID;
        this._map = newMap;
        this._list = newList;
        return this;
      }
      return makeOrderedMap(newMap, newList, ownerID, this.__hash);
    };


  function isOrderedMap(maybeOrderedMap) {
    return isMap(maybeOrderedMap) && isOrdered(maybeOrderedMap);
  }

  OrderedMap.isOrderedMap = isOrderedMap;

  OrderedMap.prototype[IS_ORDERED_SENTINEL] = true;
  OrderedMap.prototype[DELETE] = OrderedMap.prototype.remove;



  function makeOrderedMap(map, list, ownerID, hash) {
    var omap = Object.create(OrderedMap.prototype);
    omap.size = map ? map.size : 0;
    omap._map = map;
    omap._list = list;
    omap.__ownerID = ownerID;
    omap.__hash = hash;
    return omap;
  }

  var EMPTY_ORDERED_MAP;
  function emptyOrderedMap() {
    return EMPTY_ORDERED_MAP || (EMPTY_ORDERED_MAP = makeOrderedMap(emptyMap(), emptyList()));
  }

  function updateOrderedMap(omap, k, v) {
    var map = omap._map;
    var list = omap._list;
    var i = map.get(k);
    var has = i !== undefined;
    var newMap;
    var newList;
    if (v === NOT_SET) { // removed
      if (!has) {
        return omap;
      }
      if (list.size >= SIZE && list.size >= map.size * 2) {
        newList = list.filter(function(entry, idx)  {return entry !== undefined && i !== idx});
        newMap = newList.toKeyedSeq().map(function(entry ) {return entry[0]}).flip().toMap();
        if (omap.__ownerID) {
          newMap.__ownerID = newList.__ownerID = omap.__ownerID;
        }
      } else {
        newMap = map.remove(k);
        newList = i === list.size - 1 ? list.pop() : list.set(i, undefined);
      }
    } else {
      if (has) {
        if (v === list.get(i)[1]) {
          return omap;
        }
        newMap = map;
        newList = list.set(i, [k, v]);
      } else {
        newMap = map.set(k, list.size);
        newList = list.set(list.size, [k, v]);
      }
    }
    if (omap.__ownerID) {
      omap.size = newMap.size;
      omap._map = newMap;
      omap._list = newList;
      omap.__hash = undefined;
      return omap;
    }
    return makeOrderedMap(newMap, newList);
  }

  createClass(ToKeyedSequence, KeyedSeq);
    function ToKeyedSequence(indexed, useKeys) {
      this._iter = indexed;
      this._useKeys = useKeys;
      this.size = indexed.size;
    }

    ToKeyedSequence.prototype.get = function(key, notSetValue) {
      return this._iter.get(key, notSetValue);
    };

    ToKeyedSequence.prototype.has = function(key) {
      return this._iter.has(key);
    };

    ToKeyedSequence.prototype.valueSeq = function() {
      return this._iter.valueSeq();
    };

    ToKeyedSequence.prototype.reverse = function() {var this$0 = this;
      var reversedSequence = reverseFactory(this, true);
      if (!this._useKeys) {
        reversedSequence.valueSeq = function()  {return this$0._iter.toSeq().reverse()};
      }
      return reversedSequence;
    };

    ToKeyedSequence.prototype.map = function(mapper, context) {var this$0 = this;
      var mappedSequence = mapFactory(this, mapper, context);
      if (!this._useKeys) {
        mappedSequence.valueSeq = function()  {return this$0._iter.toSeq().map(mapper, context)};
      }
      return mappedSequence;
    };

    ToKeyedSequence.prototype.__iterate = function(fn, reverse) {var this$0 = this;
      var ii;
      return this._iter.__iterate(
        this._useKeys ?
          function(v, k)  {return fn(v, k, this$0)} :
          ((ii = reverse ? resolveSize(this) : 0),
            function(v ) {return fn(v, reverse ? --ii : ii++, this$0)}),
        reverse
      );
    };

    ToKeyedSequence.prototype.__iterator = function(type, reverse) {
      if (this._useKeys) {
        return this._iter.__iterator(type, reverse);
      }
      var iterator = this._iter.__iterator(ITERATE_VALUES, reverse);
      var ii = reverse ? resolveSize(this) : 0;
      return new Iterator(function()  {
        var step = iterator.next();
        return step.done ? step :
          iteratorValue(type, reverse ? --ii : ii++, step.value, step);
      });
    };

  ToKeyedSequence.prototype[IS_ORDERED_SENTINEL] = true;


  createClass(ToIndexedSequence, IndexedSeq);
    function ToIndexedSequence(iter) {
      this._iter = iter;
      this.size = iter.size;
    }

    ToIndexedSequence.prototype.includes = function(value) {
      return this._iter.includes(value);
    };

    ToIndexedSequence.prototype.__iterate = function(fn, reverse) {var this$0 = this;
      var iterations = 0;
      return this._iter.__iterate(function(v ) {return fn(v, iterations++, this$0)}, reverse);
    };

    ToIndexedSequence.prototype.__iterator = function(type, reverse) {
      var iterator = this._iter.__iterator(ITERATE_VALUES, reverse);
      var iterations = 0;
      return new Iterator(function()  {
        var step = iterator.next();
        return step.done ? step :
          iteratorValue(type, iterations++, step.value, step)
      });
    };



  createClass(ToSetSequence, SetSeq);
    function ToSetSequence(iter) {
      this._iter = iter;
      this.size = iter.size;
    }

    ToSetSequence.prototype.has = function(key) {
      return this._iter.includes(key);
    };

    ToSetSequence.prototype.__iterate = function(fn, reverse) {var this$0 = this;
      return this._iter.__iterate(function(v ) {return fn(v, v, this$0)}, reverse);
    };

    ToSetSequence.prototype.__iterator = function(type, reverse) {
      var iterator = this._iter.__iterator(ITERATE_VALUES, reverse);
      return new Iterator(function()  {
        var step = iterator.next();
        return step.done ? step :
          iteratorValue(type, step.value, step.value, step);
      });
    };



  createClass(FromEntriesSequence, KeyedSeq);
    function FromEntriesSequence(entries) {
      this._iter = entries;
      this.size = entries.size;
    }

    FromEntriesSequence.prototype.entrySeq = function() {
      return this._iter.toSeq();
    };

    FromEntriesSequence.prototype.__iterate = function(fn, reverse) {var this$0 = this;
      return this._iter.__iterate(function(entry ) {
        // Check if entry exists first so array access doesn't throw for holes
        // in the parent iteration.
        if (entry) {
          validateEntry(entry);
          var indexedIterable = isIterable(entry);
          return fn(
            indexedIterable ? entry.get(1) : entry[1],
            indexedIterable ? entry.get(0) : entry[0],
            this$0
          );
        }
      }, reverse);
    };

    FromEntriesSequence.prototype.__iterator = function(type, reverse) {
      var iterator = this._iter.__iterator(ITERATE_VALUES, reverse);
      return new Iterator(function()  {
        while (true) {
          var step = iterator.next();
          if (step.done) {
            return step;
          }
          var entry = step.value;
          // Check if entry exists first so array access doesn't throw for holes
          // in the parent iteration.
          if (entry) {
            validateEntry(entry);
            var indexedIterable = isIterable(entry);
            return iteratorValue(
              type,
              indexedIterable ? entry.get(0) : entry[0],
              indexedIterable ? entry.get(1) : entry[1],
              step
            );
          }
        }
      });
    };


  ToIndexedSequence.prototype.cacheResult =
  ToKeyedSequence.prototype.cacheResult =
  ToSetSequence.prototype.cacheResult =
  FromEntriesSequence.prototype.cacheResult =
    cacheResultThrough;


  function flipFactory(iterable) {
    var flipSequence = makeSequence(iterable);
    flipSequence._iter = iterable;
    flipSequence.size = iterable.size;
    flipSequence.flip = function()  {return iterable};
    flipSequence.reverse = function () {
      var reversedSequence = iterable.reverse.apply(this); // super.reverse()
      reversedSequence.flip = function()  {return iterable.reverse()};
      return reversedSequence;
    };
    flipSequence.has = function(key ) {return iterable.includes(key)};
    flipSequence.includes = function(key ) {return iterable.has(key)};
    flipSequence.cacheResult = cacheResultThrough;
    flipSequence.__iterateUncached = function (fn, reverse) {var this$0 = this;
      return iterable.__iterate(function(v, k)  {return fn(k, v, this$0) !== false}, reverse);
    }
    flipSequence.__iteratorUncached = function(type, reverse) {
      if (type === ITERATE_ENTRIES) {
        var iterator = iterable.__iterator(type, reverse);
        return new Iterator(function()  {
          var step = iterator.next();
          if (!step.done) {
            var k = step.value[0];
            step.value[0] = step.value[1];
            step.value[1] = k;
          }
          return step;
        });
      }
      return iterable.__iterator(
        type === ITERATE_VALUES ? ITERATE_KEYS : ITERATE_VALUES,
        reverse
      );
    }
    return flipSequence;
  }


  function mapFactory(iterable, mapper, context) {
    var mappedSequence = makeSequence(iterable);
    mappedSequence.size = iterable.size;
    mappedSequence.has = function(key ) {return iterable.has(key)};
    mappedSequence.get = function(key, notSetValue)  {
      var v = iterable.get(key, NOT_SET);
      return v === NOT_SET ?
        notSetValue :
        mapper.call(context, v, key, iterable);
    };
    mappedSequence.__iterateUncached = function (fn, reverse) {var this$0 = this;
      return iterable.__iterate(
        function(v, k, c)  {return fn(mapper.call(context, v, k, c), k, this$0) !== false},
        reverse
      );
    }
    mappedSequence.__iteratorUncached = function (type, reverse) {
      var iterator = iterable.__iterator(ITERATE_ENTRIES, reverse);
      return new Iterator(function()  {
        var step = iterator.next();
        if (step.done) {
          return step;
        }
        var entry = step.value;
        var key = entry[0];
        return iteratorValue(
          type,
          key,
          mapper.call(context, entry[1], key, iterable),
          step
        );
      });
    }
    return mappedSequence;
  }


  function reverseFactory(iterable, useKeys) {
    var reversedSequence = makeSequence(iterable);
    reversedSequence._iter = iterable;
    reversedSequence.size = iterable.size;
    reversedSequence.reverse = function()  {return iterable};
    if (iterable.flip) {
      reversedSequence.flip = function () {
        var flipSequence = flipFactory(iterable);
        flipSequence.reverse = function()  {return iterable.flip()};
        return flipSequence;
      };
    }
    reversedSequence.get = function(key, notSetValue) 
      {return iterable.get(useKeys ? key : -1 - key, notSetValue)};
    reversedSequence.has = function(key )
      {return iterable.has(useKeys ? key : -1 - key)};
    reversedSequence.includes = function(value ) {return iterable.includes(value)};
    reversedSequence.cacheResult = cacheResultThrough;
    reversedSequence.__iterate = function (fn, reverse) {var this$0 = this;
      return iterable.__iterate(function(v, k)  {return fn(v, k, this$0)}, !reverse);
    };
    reversedSequence.__iterator =
      function(type, reverse)  {return iterable.__iterator(type, !reverse)};
    return reversedSequence;
  }


  function filterFactory(iterable, predicate, context, useKeys) {
    var filterSequence = makeSequence(iterable);
    if (useKeys) {
      filterSequence.has = function(key ) {
        var v = iterable.get(key, NOT_SET);
        return v !== NOT_SET && !!predicate.call(context, v, key, iterable);
      };
      filterSequence.get = function(key, notSetValue)  {
        var v = iterable.get(key, NOT_SET);
        return v !== NOT_SET && predicate.call(context, v, key, iterable) ?
          v : notSetValue;
      };
    }
    filterSequence.__iterateUncached = function (fn, reverse) {var this$0 = this;
      var iterations = 0;
      iterable.__iterate(function(v, k, c)  {
        if (predicate.call(context, v, k, c)) {
          iterations++;
          return fn(v, useKeys ? k : iterations - 1, this$0);
        }
      }, reverse);
      return iterations;
    };
    filterSequence.__iteratorUncached = function (type, reverse) {
      var iterator = iterable.__iterator(ITERATE_ENTRIES, reverse);
      var iterations = 0;
      return new Iterator(function()  {
        while (true) {
          var step = iterator.next();
          if (step.done) {
            return step;
          }
          var entry = step.value;
          var key = entry[0];
          var value = entry[1];
          if (predicate.call(context, value, key, iterable)) {
            return iteratorValue(type, useKeys ? key : iterations++, value, step);
          }
        }
      });
    }
    return filterSequence;
  }


  function countByFactory(iterable, grouper, context) {
    var groups = Map().asMutable();
    iterable.__iterate(function(v, k)  {
      groups.update(
        grouper.call(context, v, k, iterable),
        0,
        function(a ) {return a + 1}
      );
    });
    return groups.asImmutable();
  }


  function groupByFactory(iterable, grouper, context) {
    var isKeyedIter = isKeyed(iterable);
    var groups = (isOrdered(iterable) ? OrderedMap() : Map()).asMutable();
    iterable.__iterate(function(v, k)  {
      groups.update(
        grouper.call(context, v, k, iterable),
        function(a ) {return (a = a || [], a.push(isKeyedIter ? [k, v] : v), a)}
      );
    });
    var coerce = iterableClass(iterable);
    return groups.map(function(arr ) {return reify(iterable, coerce(arr))});
  }


  function sliceFactory(iterable, begin, end, useKeys) {
    var originalSize = iterable.size;

    // Sanitize begin & end using this shorthand for ToInt32(argument)
    // http://www.ecma-international.org/ecma-262/6.0/#sec-toint32
    if (begin !== undefined) {
      begin = begin | 0;
    }
    if (end !== undefined) {
      if (end === Infinity) {
        end = originalSize;
      } else {
        end = end | 0;
      }
    }

    if (wholeSlice(begin, end, originalSize)) {
      return iterable;
    }

    var resolvedBegin = resolveBegin(begin, originalSize);
    var resolvedEnd = resolveEnd(end, originalSize);

    // begin or end will be NaN if they were provided as negative numbers and
    // this iterable's size is unknown. In that case, cache first so there is
    // a known size and these do not resolve to NaN.
    if (resolvedBegin !== resolvedBegin || resolvedEnd !== resolvedEnd) {
      return sliceFactory(iterable.toSeq().cacheResult(), begin, end, useKeys);
    }

    // Note: resolvedEnd is undefined when the original sequence's length is
    // unknown and this slice did not supply an end and should contain all
    // elements after resolvedBegin.
    // In that case, resolvedSize will be NaN and sliceSize will remain undefined.
    var resolvedSize = resolvedEnd - resolvedBegin;
    var sliceSize;
    if (resolvedSize === resolvedSize) {
      sliceSize = resolvedSize < 0 ? 0 : resolvedSize;
    }

    var sliceSeq = makeSequence(iterable);

    // If iterable.size is undefined, the size of the realized sliceSeq is
    // unknown at this point unless the number of items to slice is 0
    sliceSeq.size = sliceSize === 0 ? sliceSize : iterable.size && sliceSize || undefined;

    if (!useKeys && isSeq(iterable) && sliceSize >= 0) {
      sliceSeq.get = function (index, notSetValue) {
        index = wrapIndex(this, index);
        return index >= 0 && index < sliceSize ?
          iterable.get(index + resolvedBegin, notSetValue) :
          notSetValue;
      }
    }

    sliceSeq.__iterateUncached = function(fn, reverse) {var this$0 = this;
      if (sliceSize === 0) {
        return 0;
      }
      if (reverse) {
        return this.cacheResult().__iterate(fn, reverse);
      }
      var skipped = 0;
      var isSkipping = true;
      var iterations = 0;
      iterable.__iterate(function(v, k)  {
        if (!(isSkipping && (isSkipping = skipped++ < resolvedBegin))) {
          iterations++;
          return fn(v, useKeys ? k : iterations - 1, this$0) !== false &&
                 iterations !== sliceSize;
        }
      });
      return iterations;
    };

    sliceSeq.__iteratorUncached = function(type, reverse) {
      if (sliceSize !== 0 && reverse) {
        return this.cacheResult().__iterator(type, reverse);
      }
      // Don't bother instantiating parent iterator if taking 0.
      var iterator = sliceSize !== 0 && iterable.__iterator(type, reverse);
      var skipped = 0;
      var iterations = 0;
      return new Iterator(function()  {
        while (skipped++ < resolvedBegin) {
          iterator.next();
        }
        if (++iterations > sliceSize) {
          return iteratorDone();
        }
        var step = iterator.next();
        if (useKeys || type === ITERATE_VALUES) {
          return step;
        } else if (type === ITERATE_KEYS) {
          return iteratorValue(type, iterations - 1, undefined, step);
        } else {
          return iteratorValue(type, iterations - 1, step.value[1], step);
        }
      });
    }

    return sliceSeq;
  }


  function takeWhileFactory(iterable, predicate, context) {
    var takeSequence = makeSequence(iterable);
    takeSequence.__iterateUncached = function(fn, reverse) {var this$0 = this;
      if (reverse) {
        return this.cacheResult().__iterate(fn, reverse);
      }
      var iterations = 0;
      iterable.__iterate(function(v, k, c) 
        {return predicate.call(context, v, k, c) && ++iterations && fn(v, k, this$0)}
      );
      return iterations;
    };
    takeSequence.__iteratorUncached = function(type, reverse) {var this$0 = this;
      if (reverse) {
        return this.cacheResult().__iterator(type, reverse);
      }
      var iterator = iterable.__iterator(ITERATE_ENTRIES, reverse);
      var iterating = true;
      return new Iterator(function()  {
        if (!iterating) {
          return iteratorDone();
        }
        var step = iterator.next();
        if (step.done) {
          return step;
        }
        var entry = step.value;
        var k = entry[0];
        var v = entry[1];
        if (!predicate.call(context, v, k, this$0)) {
          iterating = false;
          return iteratorDone();
        }
        return type === ITERATE_ENTRIES ? step :
          iteratorValue(type, k, v, step);
      });
    };
    return takeSequence;
  }


  function skipWhileFactory(iterable, predicate, context, useKeys) {
    var skipSequence = makeSequence(iterable);
    skipSequence.__iterateUncached = function (fn, reverse) {var this$0 = this;
      if (reverse) {
        return this.cacheResult().__iterate(fn, reverse);
      }
      var isSkipping = true;
      var iterations = 0;
      iterable.__iterate(function(v, k, c)  {
        if (!(isSkipping && (isSkipping = predicate.call(context, v, k, c)))) {
          iterations++;
          return fn(v, useKeys ? k : iterations - 1, this$0);
        }
      });
      return iterations;
    };
    skipSequence.__iteratorUncached = function(type, reverse) {var this$0 = this;
      if (reverse) {
        return this.cacheResult().__iterator(type, reverse);
      }
      var iterator = iterable.__iterator(ITERATE_ENTRIES, reverse);
      var skipping = true;
      var iterations = 0;
      return new Iterator(function()  {
        var step, k, v;
        do {
          step = iterator.next();
          if (step.done) {
            if (useKeys || type === ITERATE_VALUES) {
              return step;
            } else if (type === ITERATE_KEYS) {
              return iteratorValue(type, iterations++, undefined, step);
            } else {
              return iteratorValue(type, iterations++, step.value[1], step);
            }
          }
          var entry = step.value;
          k = entry[0];
          v = entry[1];
          skipping && (skipping = predicate.call(context, v, k, this$0));
        } while (skipping);
        return type === ITERATE_ENTRIES ? step :
          iteratorValue(type, k, v, step);
      });
    };
    return skipSequence;
  }


  function concatFactory(iterable, values) {
    var isKeyedIterable = isKeyed(iterable);
    var iters = [iterable].concat(values).map(function(v ) {
      if (!isIterable(v)) {
        v = isKeyedIterable ?
          keyedSeqFromValue(v) :
          indexedSeqFromValue(Array.isArray(v) ? v : [v]);
      } else if (isKeyedIterable) {
        v = KeyedIterable(v);
      }
      return v;
    }).filter(function(v ) {return v.size !== 0});

    if (iters.length === 0) {
      return iterable;
    }

    if (iters.length === 1) {
      var singleton = iters[0];
      if (singleton === iterable ||
          isKeyedIterable && isKeyed(singleton) ||
          isIndexed(iterable) && isIndexed(singleton)) {
        return singleton;
      }
    }

    var concatSeq = new ArraySeq(iters);
    if (isKeyedIterable) {
      concatSeq = concatSeq.toKeyedSeq();
    } else if (!isIndexed(iterable)) {
      concatSeq = concatSeq.toSetSeq();
    }
    concatSeq = concatSeq.flatten(true);
    concatSeq.size = iters.reduce(
      function(sum, seq)  {
        if (sum !== undefined) {
          var size = seq.size;
          if (size !== undefined) {
            return sum + size;
          }
        }
      },
      0
    );
    return concatSeq;
  }


  function flattenFactory(iterable, depth, useKeys) {
    var flatSequence = makeSequence(iterable);
    flatSequence.__iterateUncached = function(fn, reverse) {
      var iterations = 0;
      var stopped = false;
      function flatDeep(iter, currentDepth) {var this$0 = this;
        iter.__iterate(function(v, k)  {
          if ((!depth || currentDepth < depth) && isIterable(v)) {
            flatDeep(v, currentDepth + 1);
          } else if (fn(v, useKeys ? k : iterations++, this$0) === false) {
            stopped = true;
          }
          return !stopped;
        }, reverse);
      }
      flatDeep(iterable, 0);
      return iterations;
    }
    flatSequence.__iteratorUncached = function(type, reverse) {
      var iterator = iterable.__iterator(type, reverse);
      var stack = [];
      var iterations = 0;
      return new Iterator(function()  {
        while (iterator) {
          var step = iterator.next();
          if (step.done !== false) {
            iterator = stack.pop();
            continue;
          }
          var v = step.value;
          if (type === ITERATE_ENTRIES) {
            v = v[1];
          }
          if ((!depth || stack.length < depth) && isIterable(v)) {
            stack.push(iterator);
            iterator = v.__iterator(type, reverse);
          } else {
            return useKeys ? step : iteratorValue(type, iterations++, v, step);
          }
        }
        return iteratorDone();
      });
    }
    return flatSequence;
  }


  function flatMapFactory(iterable, mapper, context) {
    var coerce = iterableClass(iterable);
    return iterable.toSeq().map(
      function(v, k)  {return coerce(mapper.call(context, v, k, iterable))}
    ).flatten(true);
  }


  function interposeFactory(iterable, separator) {
    var interposedSequence = makeSequence(iterable);
    interposedSequence.size = iterable.size && iterable.size * 2 -1;
    interposedSequence.__iterateUncached = function(fn, reverse) {var this$0 = this;
      var iterations = 0;
      iterable.__iterate(function(v, k) 
        {return (!iterations || fn(separator, iterations++, this$0) !== false) &&
        fn(v, iterations++, this$0) !== false},
        reverse
      );
      return iterations;
    };
    interposedSequence.__iteratorUncached = function(type, reverse) {
      var iterator = iterable.__iterator(ITERATE_VALUES, reverse);
      var iterations = 0;
      var step;
      return new Iterator(function()  {
        if (!step || iterations % 2) {
          step = iterator.next();
          if (step.done) {
            return step;
          }
        }
        return iterations % 2 ?
          iteratorValue(type, iterations++, separator) :
          iteratorValue(type, iterations++, step.value, step);
      });
    };
    return interposedSequence;
  }


  function sortFactory(iterable, comparator, mapper) {
    if (!comparator) {
      comparator = defaultComparator;
    }
    var isKeyedIterable = isKeyed(iterable);
    var index = 0;
    var entries = iterable.toSeq().map(
      function(v, k)  {return [k, v, index++, mapper ? mapper(v, k, iterable) : v]}
    ).toArray();
    entries.sort(function(a, b)  {return comparator(a[3], b[3]) || a[2] - b[2]}).forEach(
      isKeyedIterable ?
      function(v, i)  { entries[i].length = 2; } :
      function(v, i)  { entries[i] = v[1]; }
    );
    return isKeyedIterable ? KeyedSeq(entries) :
      isIndexed(iterable) ? IndexedSeq(entries) :
      SetSeq(entries);
  }


  function maxFactory(iterable, comparator, mapper) {
    if (!comparator) {
      comparator = defaultComparator;
    }
    if (mapper) {
      var entry = iterable.toSeq()
        .map(function(v, k)  {return [v, mapper(v, k, iterable)]})
        .reduce(function(a, b)  {return maxCompare(comparator, a[1], b[1]) ? b : a});
      return entry && entry[0];
    } else {
      return iterable.reduce(function(a, b)  {return maxCompare(comparator, a, b) ? b : a});
    }
  }

  function maxCompare(comparator, a, b) {
    var comp = comparator(b, a);
    // b is considered the new max if the comparator declares them equal, but
    // they are not equal and b is in fact a nullish value.
    return (comp === 0 && b !== a && (b === undefined || b === null || b !== b)) || comp > 0;
  }


  function zipWithFactory(keyIter, zipper, iters) {
    var zipSequence = makeSequence(keyIter);
    zipSequence.size = new ArraySeq(iters).map(function(i ) {return i.size}).min();
    // Note: this a generic base implementation of __iterate in terms of
    // __iterator which may be more generically useful in the future.
    zipSequence.__iterate = function(fn, reverse) {
      /* generic:
      var iterator = this.__iterator(ITERATE_ENTRIES, reverse);
      var step;
      var iterations = 0;
      while (!(step = iterator.next()).done) {
        iterations++;
        if (fn(step.value[1], step.value[0], this) === false) {
          break;
        }
      }
      return iterations;
      */
      // indexed:
      var iterator = this.__iterator(ITERATE_VALUES, reverse);
      var step;
      var iterations = 0;
      while (!(step = iterator.next()).done) {
        if (fn(step.value, iterations++, this) === false) {
          break;
        }
      }
      return iterations;
    };
    zipSequence.__iteratorUncached = function(type, reverse) {
      var iterators = iters.map(function(i )
        {return (i = Iterable(i), getIterator(reverse ? i.reverse() : i))}
      );
      var iterations = 0;
      var isDone = false;
      return new Iterator(function()  {
        var steps;
        if (!isDone) {
          steps = iterators.map(function(i ) {return i.next()});
          isDone = steps.some(function(s ) {return s.done});
        }
        if (isDone) {
          return iteratorDone();
        }
        return iteratorValue(
          type,
          iterations++,
          zipper.apply(null, steps.map(function(s ) {return s.value}))
        );
      });
    };
    return zipSequence
  }


  // #pragma Helper Functions

  function reify(iter, seq) {
    return isSeq(iter) ? seq : iter.constructor(seq);
  }

  function validateEntry(entry) {
    if (entry !== Object(entry)) {
      throw new TypeError('Expected [K, V] tuple: ' + entry);
    }
  }

  function resolveSize(iter) {
    assertNotInfinite(iter.size);
    return ensureSize(iter);
  }

  function iterableClass(iterable) {
    return isKeyed(iterable) ? KeyedIterable :
      isIndexed(iterable) ? IndexedIterable :
      SetIterable;
  }

  function makeSequence(iterable) {
    return Object.create(
      (
        isKeyed(iterable) ? KeyedSeq :
        isIndexed(iterable) ? IndexedSeq :
        SetSeq
      ).prototype
    );
  }

  function cacheResultThrough() {
    if (this._iter.cacheResult) {
      this._iter.cacheResult();
      this.size = this._iter.size;
      return this;
    } else {
      return Seq.prototype.cacheResult.call(this);
    }
  }

  function defaultComparator(a, b) {
    return a > b ? 1 : a < b ? -1 : 0;
  }

  function forceIterator(keyPath) {
    var iter = getIterator(keyPath);
    if (!iter) {
      // Array might not be iterable in this environment, so we need a fallback
      // to our wrapped type.
      if (!isArrayLike(keyPath)) {
        throw new TypeError('Expected iterable or array-like: ' + keyPath);
      }
      iter = getIterator(Iterable(keyPath));
    }
    return iter;
  }

  createClass(Record, KeyedCollection);

    function Record(defaultValues, name) {
      var hasInitialized;

      var RecordType = function Record(values) {
        if (values instanceof RecordType) {
          return values;
        }
        if (!(this instanceof RecordType)) {
          return new RecordType(values);
        }
        if (!hasInitialized) {
          hasInitialized = true;
          var keys = Object.keys(defaultValues);
          setProps(RecordTypePrototype, keys);
          RecordTypePrototype.size = keys.length;
          RecordTypePrototype._name = name;
          RecordTypePrototype._keys = keys;
          RecordTypePrototype._defaultValues = defaultValues;
        }
        this._map = Map(values);
      };

      var RecordTypePrototype = RecordType.prototype = Object.create(RecordPrototype);
      RecordTypePrototype.constructor = RecordType;

      return RecordType;
    }

    Record.prototype.toString = function() {
      return this.__toString(recordName(this) + ' {', '}');
    };

    // @pragma Access

    Record.prototype.has = function(k) {
      return this._defaultValues.hasOwnProperty(k);
    };

    Record.prototype.get = function(k, notSetValue) {
      if (!this.has(k)) {
        return notSetValue;
      }
      var defaultVal = this._defaultValues[k];
      return this._map ? this._map.get(k, defaultVal) : defaultVal;
    };

    // @pragma Modification

    Record.prototype.clear = function() {
      if (this.__ownerID) {
        this._map && this._map.clear();
        return this;
      }
      var RecordType = this.constructor;
      return RecordType._empty || (RecordType._empty = makeRecord(this, emptyMap()));
    };

    Record.prototype.set = function(k, v) {
      if (!this.has(k)) {
        throw new Error('Cannot set unknown key "' + k + '" on ' + recordName(this));
      }
      if (this._map && !this._map.has(k)) {
        var defaultVal = this._defaultValues[k];
        if (v === defaultVal) {
          return this;
        }
      }
      var newMap = this._map && this._map.set(k, v);
      if (this.__ownerID || newMap === this._map) {
        return this;
      }
      return makeRecord(this, newMap);
    };

    Record.prototype.remove = function(k) {
      if (!this.has(k)) {
        return this;
      }
      var newMap = this._map && this._map.remove(k);
      if (this.__ownerID || newMap === this._map) {
        return this;
      }
      return makeRecord(this, newMap);
    };

    Record.prototype.wasAltered = function() {
      return this._map.wasAltered();
    };

    Record.prototype.__iterator = function(type, reverse) {var this$0 = this;
      return KeyedIterable(this._defaultValues).map(function(_, k)  {return this$0.get(k)}).__iterator(type, reverse);
    };

    Record.prototype.__iterate = function(fn, reverse) {var this$0 = this;
      return KeyedIterable(this._defaultValues).map(function(_, k)  {return this$0.get(k)}).__iterate(fn, reverse);
    };

    Record.prototype.__ensureOwner = function(ownerID) {
      if (ownerID === this.__ownerID) {
        return this;
      }
      var newMap = this._map && this._map.__ensureOwner(ownerID);
      if (!ownerID) {
        this.__ownerID = ownerID;
        this._map = newMap;
        return this;
      }
      return makeRecord(this, newMap, ownerID);
    };


  var RecordPrototype = Record.prototype;
  RecordPrototype[DELETE] = RecordPrototype.remove;
  RecordPrototype.deleteIn =
  RecordPrototype.removeIn = MapPrototype.removeIn;
  RecordPrototype.merge = MapPrototype.merge;
  RecordPrototype.mergeWith = MapPrototype.mergeWith;
  RecordPrototype.mergeIn = MapPrototype.mergeIn;
  RecordPrototype.mergeDeep = MapPrototype.mergeDeep;
  RecordPrototype.mergeDeepWith = MapPrototype.mergeDeepWith;
  RecordPrototype.mergeDeepIn = MapPrototype.mergeDeepIn;
  RecordPrototype.setIn = MapPrototype.setIn;
  RecordPrototype.update = MapPrototype.update;
  RecordPrototype.updateIn = MapPrototype.updateIn;
  RecordPrototype.withMutations = MapPrototype.withMutations;
  RecordPrototype.asMutable = MapPrototype.asMutable;
  RecordPrototype.asImmutable = MapPrototype.asImmutable;


  function makeRecord(likeRecord, map, ownerID) {
    var record = Object.create(Object.getPrototypeOf(likeRecord));
    record._map = map;
    record.__ownerID = ownerID;
    return record;
  }

  function recordName(record) {
    return record._name || record.constructor.name || 'Record';
  }

  function setProps(prototype, names) {
    try {
      names.forEach(setProp.bind(undefined, prototype));
    } catch (error) {
      // Object.defineProperty failed. Probably IE8.
    }
  }

  function setProp(prototype, name) {
    Object.defineProperty(prototype, name, {
      get: function() {
        return this.get(name);
      },
      set: function(value) {
        invariant(this.__ownerID, 'Cannot set on an immutable record.');
        this.set(name, value);
      }
    });
  }

  createClass(Set, SetCollection);

    // @pragma Construction

    function Set(value) {
      return value === null || value === undefined ? emptySet() :
        isSet(value) && !isOrdered(value) ? value :
        emptySet().withMutations(function(set ) {
          var iter = SetIterable(value);
          assertNotInfinite(iter.size);
          iter.forEach(function(v ) {return set.add(v)});
        });
    }

    Set.of = function(/*...values*/) {
      return this(arguments);
    };

    Set.fromKeys = function(value) {
      return this(KeyedIterable(value).keySeq());
    };

    Set.prototype.toString = function() {
      return this.__toString('Set {', '}');
    };

    // @pragma Access

    Set.prototype.has = function(value) {
      return this._map.has(value);
    };

    // @pragma Modification

    Set.prototype.add = function(value) {
      return updateSet(this, this._map.set(value, true));
    };

    Set.prototype.remove = function(value) {
      return updateSet(this, this._map.remove(value));
    };

    Set.prototype.clear = function() {
      return updateSet(this, this._map.clear());
    };

    // @pragma Composition

    Set.prototype.union = function() {var iters = SLICE$0.call(arguments, 0);
      iters = iters.filter(function(x ) {return x.size !== 0});
      if (iters.length === 0) {
        return this;
      }
      if (this.size === 0 && !this.__ownerID && iters.length === 1) {
        return this.constructor(iters[0]);
      }
      return this.withMutations(function(set ) {
        for (var ii = 0; ii < iters.length; ii++) {
          SetIterable(iters[ii]).forEach(function(value ) {return set.add(value)});
        }
      });
    };

    Set.prototype.intersect = function() {var iters = SLICE$0.call(arguments, 0);
      if (iters.length === 0) {
        return this;
      }
      iters = iters.map(function(iter ) {return SetIterable(iter)});
      var originalSet = this;
      return this.withMutations(function(set ) {
        originalSet.forEach(function(value ) {
          if (!iters.every(function(iter ) {return iter.includes(value)})) {
            set.remove(value);
          }
        });
      });
    };

    Set.prototype.subtract = function() {var iters = SLICE$0.call(arguments, 0);
      if (iters.length === 0) {
        return this;
      }
      iters = iters.map(function(iter ) {return SetIterable(iter)});
      var originalSet = this;
      return this.withMutations(function(set ) {
        originalSet.forEach(function(value ) {
          if (iters.some(function(iter ) {return iter.includes(value)})) {
            set.remove(value);
          }
        });
      });
    };

    Set.prototype.merge = function() {
      return this.union.apply(this, arguments);
    };

    Set.prototype.mergeWith = function(merger) {var iters = SLICE$0.call(arguments, 1);
      return this.union.apply(this, iters);
    };

    Set.prototype.sort = function(comparator) {
      // Late binding
      return OrderedSet(sortFactory(this, comparator));
    };

    Set.prototype.sortBy = function(mapper, comparator) {
      // Late binding
      return OrderedSet(sortFactory(this, comparator, mapper));
    };

    Set.prototype.wasAltered = function() {
      return this._map.wasAltered();
    };

    Set.prototype.__iterate = function(fn, reverse) {var this$0 = this;
      return this._map.__iterate(function(_, k)  {return fn(k, k, this$0)}, reverse);
    };

    Set.prototype.__iterator = function(type, reverse) {
      return this._map.map(function(_, k)  {return k}).__iterator(type, reverse);
    };

    Set.prototype.__ensureOwner = function(ownerID) {
      if (ownerID === this.__ownerID) {
        return this;
      }
      var newMap = this._map.__ensureOwner(ownerID);
      if (!ownerID) {
        this.__ownerID = ownerID;
        this._map = newMap;
        return this;
      }
      return this.__make(newMap, ownerID);
    };


  function isSet(maybeSet) {
    return !!(maybeSet && maybeSet[IS_SET_SENTINEL]);
  }

  Set.isSet = isSet;

  var IS_SET_SENTINEL = '@@__IMMUTABLE_SET__@@';

  var SetPrototype = Set.prototype;
  SetPrototype[IS_SET_SENTINEL] = true;
  SetPrototype[DELETE] = SetPrototype.remove;
  SetPrototype.mergeDeep = SetPrototype.merge;
  SetPrototype.mergeDeepWith = SetPrototype.mergeWith;
  SetPrototype.withMutations = MapPrototype.withMutations;
  SetPrototype.asMutable = MapPrototype.asMutable;
  SetPrototype.asImmutable = MapPrototype.asImmutable;

  SetPrototype.__empty = emptySet;
  SetPrototype.__make = makeSet;

  function updateSet(set, newMap) {
    if (set.__ownerID) {
      set.size = newMap.size;
      set._map = newMap;
      return set;
    }
    return newMap === set._map ? set :
      newMap.size === 0 ? set.__empty() :
      set.__make(newMap);
  }

  function makeSet(map, ownerID) {
    var set = Object.create(SetPrototype);
    set.size = map ? map.size : 0;
    set._map = map;
    set.__ownerID = ownerID;
    return set;
  }

  var EMPTY_SET;
  function emptySet() {
    return EMPTY_SET || (EMPTY_SET = makeSet(emptyMap()));
  }

  createClass(OrderedSet, Set);

    // @pragma Construction

    function OrderedSet(value) {
      return value === null || value === undefined ? emptyOrderedSet() :
        isOrderedSet(value) ? value :
        emptyOrderedSet().withMutations(function(set ) {
          var iter = SetIterable(value);
          assertNotInfinite(iter.size);
          iter.forEach(function(v ) {return set.add(v)});
        });
    }

    OrderedSet.of = function(/*...values*/) {
      return this(arguments);
    };

    OrderedSet.fromKeys = function(value) {
      return this(KeyedIterable(value).keySeq());
    };

    OrderedSet.prototype.toString = function() {
      return this.__toString('OrderedSet {', '}');
    };


  function isOrderedSet(maybeOrderedSet) {
    return isSet(maybeOrderedSet) && isOrdered(maybeOrderedSet);
  }

  OrderedSet.isOrderedSet = isOrderedSet;

  var OrderedSetPrototype = OrderedSet.prototype;
  OrderedSetPrototype[IS_ORDERED_SENTINEL] = true;

  OrderedSetPrototype.__empty = emptyOrderedSet;
  OrderedSetPrototype.__make = makeOrderedSet;

  function makeOrderedSet(map, ownerID) {
    var set = Object.create(OrderedSetPrototype);
    set.size = map ? map.size : 0;
    set._map = map;
    set.__ownerID = ownerID;
    return set;
  }

  var EMPTY_ORDERED_SET;
  function emptyOrderedSet() {
    return EMPTY_ORDERED_SET || (EMPTY_ORDERED_SET = makeOrderedSet(emptyOrderedMap()));
  }

  createClass(Stack, IndexedCollection);

    // @pragma Construction

    function Stack(value) {
      return value === null || value === undefined ? emptyStack() :
        isStack(value) ? value :
        emptyStack().unshiftAll(value);
    }

    Stack.of = function(/*...values*/) {
      return this(arguments);
    };

    Stack.prototype.toString = function() {
      return this.__toString('Stack [', ']');
    };

    // @pragma Access

    Stack.prototype.get = function(index, notSetValue) {
      var head = this._head;
      index = wrapIndex(this, index);
      while (head && index--) {
        head = head.next;
      }
      return head ? head.value : notSetValue;
    };

    Stack.prototype.peek = function() {
      return this._head && this._head.value;
    };

    // @pragma Modification

    Stack.prototype.push = function(/*...values*/) {
      if (arguments.length === 0) {
        return this;
      }
      var newSize = this.size + arguments.length;
      var head = this._head;
      for (var ii = arguments.length - 1; ii >= 0; ii--) {
        head = {
          value: arguments[ii],
          next: head
        };
      }
      if (this.__ownerID) {
        this.size = newSize;
        this._head = head;
        this.__hash = undefined;
        this.__altered = true;
        return this;
      }
      return makeStack(newSize, head);
    };

    Stack.prototype.pushAll = function(iter) {
      iter = IndexedIterable(iter);
      if (iter.size === 0) {
        return this;
      }
      assertNotInfinite(iter.size);
      var newSize = this.size;
      var head = this._head;
      iter.reverse().forEach(function(value ) {
        newSize++;
        head = {
          value: value,
          next: head
        };
      });
      if (this.__ownerID) {
        this.size = newSize;
        this._head = head;
        this.__hash = undefined;
        this.__altered = true;
        return this;
      }
      return makeStack(newSize, head);
    };

    Stack.prototype.pop = function() {
      return this.slice(1);
    };

    Stack.prototype.unshift = function(/*...values*/) {
      return this.push.apply(this, arguments);
    };

    Stack.prototype.unshiftAll = function(iter) {
      return this.pushAll(iter);
    };

    Stack.prototype.shift = function() {
      return this.pop.apply(this, arguments);
    };

    Stack.prototype.clear = function() {
      if (this.size === 0) {
        return this;
      }
      if (this.__ownerID) {
        this.size = 0;
        this._head = undefined;
        this.__hash = undefined;
        this.__altered = true;
        return this;
      }
      return emptyStack();
    };

    Stack.prototype.slice = function(begin, end) {
      if (wholeSlice(begin, end, this.size)) {
        return this;
      }
      var resolvedBegin = resolveBegin(begin, this.size);
      var resolvedEnd = resolveEnd(end, this.size);
      if (resolvedEnd !== this.size) {
        // super.slice(begin, end);
        return IndexedCollection.prototype.slice.call(this, begin, end);
      }
      var newSize = this.size - resolvedBegin;
      var head = this._head;
      while (resolvedBegin--) {
        head = head.next;
      }
      if (this.__ownerID) {
        this.size = newSize;
        this._head = head;
        this.__hash = undefined;
        this.__altered = true;
        return this;
      }
      return makeStack(newSize, head);
    };

    // @pragma Mutability

    Stack.prototype.__ensureOwner = function(ownerID) {
      if (ownerID === this.__ownerID) {
        return this;
      }
      if (!ownerID) {
        this.__ownerID = ownerID;
        this.__altered = false;
        return this;
      }
      return makeStack(this.size, this._head, ownerID, this.__hash);
    };

    // @pragma Iteration

    Stack.prototype.__iterate = function(fn, reverse) {
      if (reverse) {
        return this.reverse().__iterate(fn);
      }
      var iterations = 0;
      var node = this._head;
      while (node) {
        if (fn(node.value, iterations++, this) === false) {
          break;
        }
        node = node.next;
      }
      return iterations;
    };

    Stack.prototype.__iterator = function(type, reverse) {
      if (reverse) {
        return this.reverse().__iterator(type);
      }
      var iterations = 0;
      var node = this._head;
      return new Iterator(function()  {
        if (node) {
          var value = node.value;
          node = node.next;
          return iteratorValue(type, iterations++, value);
        }
        return iteratorDone();
      });
    };


  function isStack(maybeStack) {
    return !!(maybeStack && maybeStack[IS_STACK_SENTINEL]);
  }

  Stack.isStack = isStack;

  var IS_STACK_SENTINEL = '@@__IMMUTABLE_STACK__@@';

  var StackPrototype = Stack.prototype;
  StackPrototype[IS_STACK_SENTINEL] = true;
  StackPrototype.withMutations = MapPrototype.withMutations;
  StackPrototype.asMutable = MapPrototype.asMutable;
  StackPrototype.asImmutable = MapPrototype.asImmutable;
  StackPrototype.wasAltered = MapPrototype.wasAltered;


  function makeStack(size, head, ownerID, hash) {
    var map = Object.create(StackPrototype);
    map.size = size;
    map._head = head;
    map.__ownerID = ownerID;
    map.__hash = hash;
    map.__altered = false;
    return map;
  }

  var EMPTY_STACK;
  function emptyStack() {
    return EMPTY_STACK || (EMPTY_STACK = makeStack(0));
  }

  /**
   * Contributes additional methods to a constructor
   */
  function mixin(ctor, methods) {
    var keyCopier = function(key ) { ctor.prototype[key] = methods[key]; };
    Object.keys(methods).forEach(keyCopier);
    Object.getOwnPropertySymbols &&
      Object.getOwnPropertySymbols(methods).forEach(keyCopier);
    return ctor;
  }

  Iterable.Iterator = Iterator;

  mixin(Iterable, {

    // ### Conversion to other types

    toArray: function() {
      assertNotInfinite(this.size);
      var array = new Array(this.size || 0);
      this.valueSeq().__iterate(function(v, i)  { array[i] = v; });
      return array;
    },

    toIndexedSeq: function() {
      return new ToIndexedSequence(this);
    },

    toJS: function() {
      return this.toSeq().map(
        function(value ) {return value && typeof value.toJS === 'function' ? value.toJS() : value}
      ).__toJS();
    },

    toJSON: function() {
      return this.toSeq().map(
        function(value ) {return value && typeof value.toJSON === 'function' ? value.toJSON() : value}
      ).__toJS();
    },

    toKeyedSeq: function() {
      return new ToKeyedSequence(this, true);
    },

    toMap: function() {
      // Use Late Binding here to solve the circular dependency.
      return Map(this.toKeyedSeq());
    },

    toObject: function() {
      assertNotInfinite(this.size);
      var object = {};
      this.__iterate(function(v, k)  { object[k] = v; });
      return object;
    },

    toOrderedMap: function() {
      // Use Late Binding here to solve the circular dependency.
      return OrderedMap(this.toKeyedSeq());
    },

    toOrderedSet: function() {
      // Use Late Binding here to solve the circular dependency.
      return OrderedSet(isKeyed(this) ? this.valueSeq() : this);
    },

    toSet: function() {
      // Use Late Binding here to solve the circular dependency.
      return Set(isKeyed(this) ? this.valueSeq() : this);
    },

    toSetSeq: function() {
      return new ToSetSequence(this);
    },

    toSeq: function() {
      return isIndexed(this) ? this.toIndexedSeq() :
        isKeyed(this) ? this.toKeyedSeq() :
        this.toSetSeq();
    },

    toStack: function() {
      // Use Late Binding here to solve the circular dependency.
      return Stack(isKeyed(this) ? this.valueSeq() : this);
    },

    toList: function() {
      // Use Late Binding here to solve the circular dependency.
      return List(isKeyed(this) ? this.valueSeq() : this);
    },


    // ### Common JavaScript methods and properties

    toString: function() {
      return '[Iterable]';
    },

    __toString: function(head, tail) {
      if (this.size === 0) {
        return head + tail;
      }
      return head + ' ' + this.toSeq().map(this.__toStringMapper).join(', ') + ' ' + tail;
    },


    // ### ES6 Collection methods (ES6 Array and Map)

    concat: function() {var values = SLICE$0.call(arguments, 0);
      return reify(this, concatFactory(this, values));
    },

    includes: function(searchValue) {
      return this.some(function(value ) {return is(value, searchValue)});
    },

    entries: function() {
      return this.__iterator(ITERATE_ENTRIES);
    },

    every: function(predicate, context) {
      assertNotInfinite(this.size);
      var returnValue = true;
      this.__iterate(function(v, k, c)  {
        if (!predicate.call(context, v, k, c)) {
          returnValue = false;
          return false;
        }
      });
      return returnValue;
    },

    filter: function(predicate, context) {
      return reify(this, filterFactory(this, predicate, context, true));
    },

    find: function(predicate, context, notSetValue) {
      var entry = this.findEntry(predicate, context);
      return entry ? entry[1] : notSetValue;
    },

    forEach: function(sideEffect, context) {
      assertNotInfinite(this.size);
      return this.__iterate(context ? sideEffect.bind(context) : sideEffect);
    },

    join: function(separator) {
      assertNotInfinite(this.size);
      separator = separator !== undefined ? '' + separator : ',';
      var joined = '';
      var isFirst = true;
      this.__iterate(function(v ) {
        isFirst ? (isFirst = false) : (joined += separator);
        joined += v !== null && v !== undefined ? v.toString() : '';
      });
      return joined;
    },

    keys: function() {
      return this.__iterator(ITERATE_KEYS);
    },

    map: function(mapper, context) {
      return reify(this, mapFactory(this, mapper, context));
    },

    reduce: function(reducer, initialReduction, context) {
      assertNotInfinite(this.size);
      var reduction;
      var useFirst;
      if (arguments.length < 2) {
        useFirst = true;
      } else {
        reduction = initialReduction;
      }
      this.__iterate(function(v, k, c)  {
        if (useFirst) {
          useFirst = false;
          reduction = v;
        } else {
          reduction = reducer.call(context, reduction, v, k, c);
        }
      });
      return reduction;
    },

    reduceRight: function(reducer, initialReduction, context) {
      var reversed = this.toKeyedSeq().reverse();
      return reversed.reduce.apply(reversed, arguments);
    },

    reverse: function() {
      return reify(this, reverseFactory(this, true));
    },

    slice: function(begin, end) {
      return reify(this, sliceFactory(this, begin, end, true));
    },

    some: function(predicate, context) {
      return !this.every(not(predicate), context);
    },

    sort: function(comparator) {
      return reify(this, sortFactory(this, comparator));
    },

    values: function() {
      return this.__iterator(ITERATE_VALUES);
    },


    // ### More sequential methods

    butLast: function() {
      return this.slice(0, -1);
    },

    isEmpty: function() {
      return this.size !== undefined ? this.size === 0 : !this.some(function()  {return true});
    },

    count: function(predicate, context) {
      return ensureSize(
        predicate ? this.toSeq().filter(predicate, context) : this
      );
    },

    countBy: function(grouper, context) {
      return countByFactory(this, grouper, context);
    },

    equals: function(other) {
      return deepEqual(this, other);
    },

    entrySeq: function() {
      var iterable = this;
      if (iterable._cache) {
        // We cache as an entries array, so we can just return the cache!
        return new ArraySeq(iterable._cache);
      }
      var entriesSequence = iterable.toSeq().map(entryMapper).toIndexedSeq();
      entriesSequence.fromEntrySeq = function()  {return iterable.toSeq()};
      return entriesSequence;
    },

    filterNot: function(predicate, context) {
      return this.filter(not(predicate), context);
    },

    findEntry: function(predicate, context, notSetValue) {
      var found = notSetValue;
      this.__iterate(function(v, k, c)  {
        if (predicate.call(context, v, k, c)) {
          found = [k, v];
          return false;
        }
      });
      return found;
    },

    findKey: function(predicate, context) {
      var entry = this.findEntry(predicate, context);
      return entry && entry[0];
    },

    findLast: function(predicate, context, notSetValue) {
      return this.toKeyedSeq().reverse().find(predicate, context, notSetValue);
    },

    findLastEntry: function(predicate, context, notSetValue) {
      return this.toKeyedSeq().reverse().findEntry(predicate, context, notSetValue);
    },

    findLastKey: function(predicate, context) {
      return this.toKeyedSeq().reverse().findKey(predicate, context);
    },

    first: function() {
      return this.find(returnTrue);
    },

    flatMap: function(mapper, context) {
      return reify(this, flatMapFactory(this, mapper, context));
    },

    flatten: function(depth) {
      return reify(this, flattenFactory(this, depth, true));
    },

    fromEntrySeq: function() {
      return new FromEntriesSequence(this);
    },

    get: function(searchKey, notSetValue) {
      return this.find(function(_, key)  {return is(key, searchKey)}, undefined, notSetValue);
    },

    getIn: function(searchKeyPath, notSetValue) {
      var nested = this;
      // Note: in an ES6 environment, we would prefer:
      // for (var key of searchKeyPath) {
      var iter = forceIterator(searchKeyPath);
      var step;
      while (!(step = iter.next()).done) {
        var key = step.value;
        nested = nested && nested.get ? nested.get(key, NOT_SET) : NOT_SET;
        if (nested === NOT_SET) {
          return notSetValue;
        }
      }
      return nested;
    },

    groupBy: function(grouper, context) {
      return groupByFactory(this, grouper, context);
    },

    has: function(searchKey) {
      return this.get(searchKey, NOT_SET) !== NOT_SET;
    },

    hasIn: function(searchKeyPath) {
      return this.getIn(searchKeyPath, NOT_SET) !== NOT_SET;
    },

    isSubset: function(iter) {
      iter = typeof iter.includes === 'function' ? iter : Iterable(iter);
      return this.every(function(value ) {return iter.includes(value)});
    },

    isSuperset: function(iter) {
      iter = typeof iter.isSubset === 'function' ? iter : Iterable(iter);
      return iter.isSubset(this);
    },

    keyOf: function(searchValue) {
      return this.findKey(function(value ) {return is(value, searchValue)});
    },

    keySeq: function() {
      return this.toSeq().map(keyMapper).toIndexedSeq();
    },

    last: function() {
      return this.toSeq().reverse().first();
    },

    lastKeyOf: function(searchValue) {
      return this.toKeyedSeq().reverse().keyOf(searchValue);
    },

    max: function(comparator) {
      return maxFactory(this, comparator);
    },

    maxBy: function(mapper, comparator) {
      return maxFactory(this, comparator, mapper);
    },

    min: function(comparator) {
      return maxFactory(this, comparator ? neg(comparator) : defaultNegComparator);
    },

    minBy: function(mapper, comparator) {
      return maxFactory(this, comparator ? neg(comparator) : defaultNegComparator, mapper);
    },

    rest: function() {
      return this.slice(1);
    },

    skip: function(amount) {
      return this.slice(Math.max(0, amount));
    },

    skipLast: function(amount) {
      return reify(this, this.toSeq().reverse().skip(amount).reverse());
    },

    skipWhile: function(predicate, context) {
      return reify(this, skipWhileFactory(this, predicate, context, true));
    },

    skipUntil: function(predicate, context) {
      return this.skipWhile(not(predicate), context);
    },

    sortBy: function(mapper, comparator) {
      return reify(this, sortFactory(this, comparator, mapper));
    },

    take: function(amount) {
      return this.slice(0, Math.max(0, amount));
    },

    takeLast: function(amount) {
      return reify(this, this.toSeq().reverse().take(amount).reverse());
    },

    takeWhile: function(predicate, context) {
      return reify(this, takeWhileFactory(this, predicate, context));
    },

    takeUntil: function(predicate, context) {
      return this.takeWhile(not(predicate), context);
    },

    valueSeq: function() {
      return this.toIndexedSeq();
    },


    // ### Hashable Object

    hashCode: function() {
      return this.__hash || (this.__hash = hashIterable(this));
    }


    // ### Internal

    // abstract __iterate(fn, reverse)

    // abstract __iterator(type, reverse)
  });

  // var IS_ITERABLE_SENTINEL = '@@__IMMUTABLE_ITERABLE__@@';
  // var IS_KEYED_SENTINEL = '@@__IMMUTABLE_KEYED__@@';
  // var IS_INDEXED_SENTINEL = '@@__IMMUTABLE_INDEXED__@@';
  // var IS_ORDERED_SENTINEL = '@@__IMMUTABLE_ORDERED__@@';

  var IterablePrototype = Iterable.prototype;
  IterablePrototype[IS_ITERABLE_SENTINEL] = true;
  IterablePrototype[ITERATOR_SYMBOL] = IterablePrototype.values;
  IterablePrototype.__toJS = IterablePrototype.toArray;
  IterablePrototype.__toStringMapper = quoteString;
  IterablePrototype.inspect =
  IterablePrototype.toSource = function() { return this.toString(); };
  IterablePrototype.chain = IterablePrototype.flatMap;
  IterablePrototype.contains = IterablePrototype.includes;

  mixin(KeyedIterable, {

    // ### More sequential methods

    flip: function() {
      return reify(this, flipFactory(this));
    },

    mapEntries: function(mapper, context) {var this$0 = this;
      var iterations = 0;
      return reify(this,
        this.toSeq().map(
          function(v, k)  {return mapper.call(context, [k, v], iterations++, this$0)}
        ).fromEntrySeq()
      );
    },

    mapKeys: function(mapper, context) {var this$0 = this;
      return reify(this,
        this.toSeq().flip().map(
          function(k, v)  {return mapper.call(context, k, v, this$0)}
        ).flip()
      );
    }

  });

  var KeyedIterablePrototype = KeyedIterable.prototype;
  KeyedIterablePrototype[IS_KEYED_SENTINEL] = true;
  KeyedIterablePrototype[ITERATOR_SYMBOL] = IterablePrototype.entries;
  KeyedIterablePrototype.__toJS = IterablePrototype.toObject;
  KeyedIterablePrototype.__toStringMapper = function(v, k)  {return JSON.stringify(k) + ': ' + quoteString(v)};



  mixin(IndexedIterable, {

    // ### Conversion to other types

    toKeyedSeq: function() {
      return new ToKeyedSequence(this, false);
    },


    // ### ES6 Collection methods (ES6 Array and Map)

    filter: function(predicate, context) {
      return reify(this, filterFactory(this, predicate, context, false));
    },

    findIndex: function(predicate, context) {
      var entry = this.findEntry(predicate, context);
      return entry ? entry[0] : -1;
    },

    indexOf: function(searchValue) {
      var key = this.keyOf(searchValue);
      return key === undefined ? -1 : key;
    },

    lastIndexOf: function(searchValue) {
      var key = this.lastKeyOf(searchValue);
      return key === undefined ? -1 : key;
    },

    reverse: function() {
      return reify(this, reverseFactory(this, false));
    },

    slice: function(begin, end) {
      return reify(this, sliceFactory(this, begin, end, false));
    },

    splice: function(index, removeNum /*, ...values*/) {
      var numArgs = arguments.length;
      removeNum = Math.max(removeNum | 0, 0);
      if (numArgs === 0 || (numArgs === 2 && !removeNum)) {
        return this;
      }
      // If index is negative, it should resolve relative to the size of the
      // collection. However size may be expensive to compute if not cached, so
      // only call count() if the number is in fact negative.
      index = resolveBegin(index, index < 0 ? this.count() : this.size);
      var spliced = this.slice(0, index);
      return reify(
        this,
        numArgs === 1 ?
          spliced :
          spliced.concat(arrCopy(arguments, 2), this.slice(index + removeNum))
      );
    },


    // ### More collection methods

    findLastIndex: function(predicate, context) {
      var entry = this.findLastEntry(predicate, context);
      return entry ? entry[0] : -1;
    },

    first: function() {
      return this.get(0);
    },

    flatten: function(depth) {
      return reify(this, flattenFactory(this, depth, false));
    },

    get: function(index, notSetValue) {
      index = wrapIndex(this, index);
      return (index < 0 || (this.size === Infinity ||
          (this.size !== undefined && index > this.size))) ?
        notSetValue :
        this.find(function(_, key)  {return key === index}, undefined, notSetValue);
    },

    has: function(index) {
      index = wrapIndex(this, index);
      return index >= 0 && (this.size !== undefined ?
        this.size === Infinity || index < this.size :
        this.indexOf(index) !== -1
      );
    },

    interpose: function(separator) {
      return reify(this, interposeFactory(this, separator));
    },

    interleave: function(/*...iterables*/) {
      var iterables = [this].concat(arrCopy(arguments));
      var zipped = zipWithFactory(this.toSeq(), IndexedSeq.of, iterables);
      var interleaved = zipped.flatten(true);
      if (zipped.size) {
        interleaved.size = zipped.size * iterables.length;
      }
      return reify(this, interleaved);
    },

    keySeq: function() {
      return Range(0, this.size);
    },

    last: function() {
      return this.get(-1);
    },

    skipWhile: function(predicate, context) {
      return reify(this, skipWhileFactory(this, predicate, context, false));
    },

    zip: function(/*, ...iterables */) {
      var iterables = [this].concat(arrCopy(arguments));
      return reify(this, zipWithFactory(this, defaultZipper, iterables));
    },

    zipWith: function(zipper/*, ...iterables */) {
      var iterables = arrCopy(arguments);
      iterables[0] = this;
      return reify(this, zipWithFactory(this, zipper, iterables));
    }

  });

  IndexedIterable.prototype[IS_INDEXED_SENTINEL] = true;
  IndexedIterable.prototype[IS_ORDERED_SENTINEL] = true;



  mixin(SetIterable, {

    // ### ES6 Collection methods (ES6 Array and Map)

    get: function(value, notSetValue) {
      return this.has(value) ? value : notSetValue;
    },

    includes: function(value) {
      return this.has(value);
    },


    // ### More sequential methods

    keySeq: function() {
      return this.valueSeq();
    }

  });

  SetIterable.prototype.has = IterablePrototype.includes;
  SetIterable.prototype.contains = SetIterable.prototype.includes;


  // Mixin subclasses

  mixin(KeyedSeq, KeyedIterable.prototype);
  mixin(IndexedSeq, IndexedIterable.prototype);
  mixin(SetSeq, SetIterable.prototype);

  mixin(KeyedCollection, KeyedIterable.prototype);
  mixin(IndexedCollection, IndexedIterable.prototype);
  mixin(SetCollection, SetIterable.prototype);


  // #pragma Helper functions

  function keyMapper(v, k) {
    return k;
  }

  function entryMapper(v, k) {
    return [k, v];
  }

  function not(predicate) {
    return function() {
      return !predicate.apply(this, arguments);
    }
  }

  function neg(predicate) {
    return function() {
      return -predicate.apply(this, arguments);
    }
  }

  function quoteString(value) {
    return typeof value === 'string' ? JSON.stringify(value) : String(value);
  }

  function defaultZipper() {
    return arrCopy(arguments);
  }

  function defaultNegComparator(a, b) {
    return a < b ? 1 : a > b ? -1 : 0;
  }

  function hashIterable(iterable) {
    if (iterable.size === Infinity) {
      return 0;
    }
    var ordered = isOrdered(iterable);
    var keyed = isKeyed(iterable);
    var h = ordered ? 1 : 0;
    var size = iterable.__iterate(
      keyed ?
        ordered ?
          function(v, k)  { h = 31 * h + hashMerge(hash(v), hash(k)) | 0; } :
          function(v, k)  { h = h + hashMerge(hash(v), hash(k)) | 0; } :
        ordered ?
          function(v ) { h = 31 * h + hash(v) | 0; } :
          function(v ) { h = h + hash(v) | 0; }
    );
    return murmurHashOfSize(size, h);
  }

  function murmurHashOfSize(size, h) {
    h = imul(h, 0xCC9E2D51);
    h = imul(h << 15 | h >>> -15, 0x1B873593);
    h = imul(h << 13 | h >>> -13, 5);
    h = (h + 0xE6546B64 | 0) ^ size;
    h = imul(h ^ h >>> 16, 0x85EBCA6B);
    h = imul(h ^ h >>> 13, 0xC2B2AE35);
    h = smi(h ^ h >>> 16);
    return h;
  }

  function hashMerge(a, b) {
    return a ^ b + 0x9E3779B9 + (a << 6) + (a >> 2) | 0; // int
  }

  var Immutable = {

    Iterable: Iterable,

    Seq: Seq,
    Collection: Collection,
    Map: Map,
    OrderedMap: OrderedMap,
    List: List,
    Stack: Stack,
    Set: Set,
    OrderedSet: OrderedSet,

    Record: Record,
    Range: Range,
    Repeat: Repeat,

    is: is,
    fromJS: fromJS

  };

  return Immutable;

}));

/***/ }),

/***/ "./node_modules/inherits/inherits_browser.js":
/*!***************************************************!*\
  !*** ./node_modules/inherits/inherits_browser.js ***!
  \***************************************************/
/*! no static exports found */
/***/ (function(module, exports) {

if (typeof Object.create === 'function') {
  // implementation from standard node.js 'util' module
  module.exports = function inherits(ctor, superCtor) {
    if (superCtor) {
      ctor.super_ = superCtor
      ctor.prototype = Object.create(superCtor.prototype, {
        constructor: {
          value: ctor,
          enumerable: false,
          writable: true,
          configurable: true
        }
      })
    }
  };
} else {
  // old school shim for old browsers
  module.exports = function inherits(ctor, superCtor) {
    if (superCtor) {
      ctor.super_ = superCtor
      var TempCtor = function () {}
      TempCtor.prototype = superCtor.prototype
      ctor.prototype = new TempCtor()
      ctor.prototype.constructor = ctor
    }
  }
}


/***/ }),

/***/ "./node_modules/isarray/index.js":
/*!***************************************!*\
  !*** ./node_modules/isarray/index.js ***!
  \***************************************/
/*! no static exports found */
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = Array.isArray || function (arr) {
  return toString.call(arr) == '[object Array]';
};


/***/ }),

/***/ "./node_modules/md5.js/index.js":
/*!**************************************!*\
  !*** ./node_modules/md5.js/index.js ***!
  \**************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var inherits = __webpack_require__(/*! inherits */ "./node_modules/inherits/inherits_browser.js")
var HashBase = __webpack_require__(/*! hash-base */ "./node_modules/hash-base/index.js")
var Buffer = __webpack_require__(/*! safe-buffer */ "./node_modules/safe-buffer/index.js").Buffer

var ARRAY16 = new Array(16)

function MD5 () {
  HashBase.call(this, 64)

  // state
  this._a = 0x67452301
  this._b = 0xefcdab89
  this._c = 0x98badcfe
  this._d = 0x10325476
}

inherits(MD5, HashBase)

MD5.prototype._update = function () {
  var M = ARRAY16
  for (var i = 0; i < 16; ++i) M[i] = this._block.readInt32LE(i * 4)

  var a = this._a
  var b = this._b
  var c = this._c
  var d = this._d

  a = fnF(a, b, c, d, M[0], 0xd76aa478, 7)
  d = fnF(d, a, b, c, M[1], 0xe8c7b756, 12)
  c = fnF(c, d, a, b, M[2], 0x242070db, 17)
  b = fnF(b, c, d, a, M[3], 0xc1bdceee, 22)
  a = fnF(a, b, c, d, M[4], 0xf57c0faf, 7)
  d = fnF(d, a, b, c, M[5], 0x4787c62a, 12)
  c = fnF(c, d, a, b, M[6], 0xa8304613, 17)
  b = fnF(b, c, d, a, M[7], 0xfd469501, 22)
  a = fnF(a, b, c, d, M[8], 0x698098d8, 7)
  d = fnF(d, a, b, c, M[9], 0x8b44f7af, 12)
  c = fnF(c, d, a, b, M[10], 0xffff5bb1, 17)
  b = fnF(b, c, d, a, M[11], 0x895cd7be, 22)
  a = fnF(a, b, c, d, M[12], 0x6b901122, 7)
  d = fnF(d, a, b, c, M[13], 0xfd987193, 12)
  c = fnF(c, d, a, b, M[14], 0xa679438e, 17)
  b = fnF(b, c, d, a, M[15], 0x49b40821, 22)

  a = fnG(a, b, c, d, M[1], 0xf61e2562, 5)
  d = fnG(d, a, b, c, M[6], 0xc040b340, 9)
  c = fnG(c, d, a, b, M[11], 0x265e5a51, 14)
  b = fnG(b, c, d, a, M[0], 0xe9b6c7aa, 20)
  a = fnG(a, b, c, d, M[5], 0xd62f105d, 5)
  d = fnG(d, a, b, c, M[10], 0x02441453, 9)
  c = fnG(c, d, a, b, M[15], 0xd8a1e681, 14)
  b = fnG(b, c, d, a, M[4], 0xe7d3fbc8, 20)
  a = fnG(a, b, c, d, M[9], 0x21e1cde6, 5)
  d = fnG(d, a, b, c, M[14], 0xc33707d6, 9)
  c = fnG(c, d, a, b, M[3], 0xf4d50d87, 14)
  b = fnG(b, c, d, a, M[8], 0x455a14ed, 20)
  a = fnG(a, b, c, d, M[13], 0xa9e3e905, 5)
  d = fnG(d, a, b, c, M[2], 0xfcefa3f8, 9)
  c = fnG(c, d, a, b, M[7], 0x676f02d9, 14)
  b = fnG(b, c, d, a, M[12], 0x8d2a4c8a, 20)

  a = fnH(a, b, c, d, M[5], 0xfffa3942, 4)
  d = fnH(d, a, b, c, M[8], 0x8771f681, 11)
  c = fnH(c, d, a, b, M[11], 0x6d9d6122, 16)
  b = fnH(b, c, d, a, M[14], 0xfde5380c, 23)
  a = fnH(a, b, c, d, M[1], 0xa4beea44, 4)
  d = fnH(d, a, b, c, M[4], 0x4bdecfa9, 11)
  c = fnH(c, d, a, b, M[7], 0xf6bb4b60, 16)
  b = fnH(b, c, d, a, M[10], 0xbebfbc70, 23)
  a = fnH(a, b, c, d, M[13], 0x289b7ec6, 4)
  d = fnH(d, a, b, c, M[0], 0xeaa127fa, 11)
  c = fnH(c, d, a, b, M[3], 0xd4ef3085, 16)
  b = fnH(b, c, d, a, M[6], 0x04881d05, 23)
  a = fnH(a, b, c, d, M[9], 0xd9d4d039, 4)
  d = fnH(d, a, b, c, M[12], 0xe6db99e5, 11)
  c = fnH(c, d, a, b, M[15], 0x1fa27cf8, 16)
  b = fnH(b, c, d, a, M[2], 0xc4ac5665, 23)

  a = fnI(a, b, c, d, M[0], 0xf4292244, 6)
  d = fnI(d, a, b, c, M[7], 0x432aff97, 10)
  c = fnI(c, d, a, b, M[14], 0xab9423a7, 15)
  b = fnI(b, c, d, a, M[5], 0xfc93a039, 21)
  a = fnI(a, b, c, d, M[12], 0x655b59c3, 6)
  d = fnI(d, a, b, c, M[3], 0x8f0ccc92, 10)
  c = fnI(c, d, a, b, M[10], 0xffeff47d, 15)
  b = fnI(b, c, d, a, M[1], 0x85845dd1, 21)
  a = fnI(a, b, c, d, M[8], 0x6fa87e4f, 6)
  d = fnI(d, a, b, c, M[15], 0xfe2ce6e0, 10)
  c = fnI(c, d, a, b, M[6], 0xa3014314, 15)
  b = fnI(b, c, d, a, M[13], 0x4e0811a1, 21)
  a = fnI(a, b, c, d, M[4], 0xf7537e82, 6)
  d = fnI(d, a, b, c, M[11], 0xbd3af235, 10)
  c = fnI(c, d, a, b, M[2], 0x2ad7d2bb, 15)
  b = fnI(b, c, d, a, M[9], 0xeb86d391, 21)

  this._a = (this._a + a) | 0
  this._b = (this._b + b) | 0
  this._c = (this._c + c) | 0
  this._d = (this._d + d) | 0
}

MD5.prototype._digest = function () {
  // create padding and handle blocks
  this._block[this._blockOffset++] = 0x80
  if (this._blockOffset > 56) {
    this._block.fill(0, this._blockOffset, 64)
    this._update()
    this._blockOffset = 0
  }

  this._block.fill(0, this._blockOffset, 56)
  this._block.writeUInt32LE(this._length[0], 56)
  this._block.writeUInt32LE(this._length[1], 60)
  this._update()

  // produce result
  var buffer = Buffer.allocUnsafe(16)
  buffer.writeInt32LE(this._a, 0)
  buffer.writeInt32LE(this._b, 4)
  buffer.writeInt32LE(this._c, 8)
  buffer.writeInt32LE(this._d, 12)
  return buffer
}

function rotl (x, n) {
  return (x << n) | (x >>> (32 - n))
}

function fnF (a, b, c, d, m, k, s) {
  return (rotl((a + ((b & c) | ((~b) & d)) + m + k) | 0, s) + b) | 0
}

function fnG (a, b, c, d, m, k, s) {
  return (rotl((a + ((b & d) | (c & (~d))) + m + k) | 0, s) + b) | 0
}

function fnH (a, b, c, d, m, k, s) {
  return (rotl((a + (b ^ c ^ d) + m + k) | 0, s) + b) | 0
}

function fnI (a, b, c, d, m, k, s) {
  return (rotl((a + ((c ^ (b | (~d)))) + m + k) | 0, s) + b) | 0
}

module.exports = MD5


/***/ }),

/***/ "./node_modules/miller-rabin/lib/mr.js":
/*!*********************************************!*\
  !*** ./node_modules/miller-rabin/lib/mr.js ***!
  \*********************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var bn = __webpack_require__(/*! bn.js */ "./node_modules/miller-rabin/node_modules/bn.js/lib/bn.js");
var brorand = __webpack_require__(/*! brorand */ "./node_modules/brorand/index.js");

function MillerRabin(rand) {
  this.rand = rand || new brorand.Rand();
}
module.exports = MillerRabin;

MillerRabin.create = function create(rand) {
  return new MillerRabin(rand);
};

MillerRabin.prototype._randbelow = function _randbelow(n) {
  var len = n.bitLength();
  var min_bytes = Math.ceil(len / 8);

  // Generage random bytes until a number less than n is found.
  // This ensures that 0..n-1 have an equal probability of being selected.
  do
    var a = new bn(this.rand.generate(min_bytes));
  while (a.cmp(n) >= 0);

  return a;
};

MillerRabin.prototype._randrange = function _randrange(start, stop) {
  // Generate a random number greater than or equal to start and less than stop.
  var size = stop.sub(start);
  return start.add(this._randbelow(size));
};

MillerRabin.prototype.test = function test(n, k, cb) {
  var len = n.bitLength();
  var red = bn.mont(n);
  var rone = new bn(1).toRed(red);

  if (!k)
    k = Math.max(1, (len / 48) | 0);

  // Find d and s, (n - 1) = (2 ^ s) * d;
  var n1 = n.subn(1);
  for (var s = 0; !n1.testn(s); s++) {}
  var d = n.shrn(s);

  var rn1 = n1.toRed(red);

  var prime = true;
  for (; k > 0; k--) {
    var a = this._randrange(new bn(2), n1);
    if (cb)
      cb(a);

    var x = a.toRed(red).redPow(d);
    if (x.cmp(rone) === 0 || x.cmp(rn1) === 0)
      continue;

    for (var i = 1; i < s; i++) {
      x = x.redSqr();

      if (x.cmp(rone) === 0)
        return false;
      if (x.cmp(rn1) === 0)
        break;
    }

    if (i === s)
      return false;
  }

  return prime;
};

MillerRabin.prototype.getDivisor = function getDivisor(n, k) {
  var len = n.bitLength();
  var red = bn.mont(n);
  var rone = new bn(1).toRed(red);

  if (!k)
    k = Math.max(1, (len / 48) | 0);

  // Find d and s, (n - 1) = (2 ^ s) * d;
  var n1 = n.subn(1);
  for (var s = 0; !n1.testn(s); s++) {}
  var d = n.shrn(s);

  var rn1 = n1.toRed(red);

  for (; k > 0; k--) {
    var a = this._randrange(new bn(2), n1);

    var g = n.gcd(a);
    if (g.cmpn(1) !== 0)
      return g;

    var x = a.toRed(red).redPow(d);
    if (x.cmp(rone) === 0 || x.cmp(rn1) === 0)
      continue;

    for (var i = 1; i < s; i++) {
      x = x.redSqr();

      if (x.cmp(rone) === 0)
        return x.fromRed().subn(1).gcd(n);
      if (x.cmp(rn1) === 0)
        break;
    }

    if (i === s) {
      x = x.redSqr();
      return x.fromRed().subn(1).gcd(n);
    }
  }

  return false;
};


/***/ }),

/***/ "./node_modules/miller-rabin/node_modules/bn.js/lib/bn.js":
/*!****************************************************************!*\
  !*** ./node_modules/miller-rabin/node_modules/bn.js/lib/bn.js ***!
  \****************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {(function (module, exports) {
  'use strict';

  // Utils
  function assert (val, msg) {
    if (!val) throw new Error(msg || 'Assertion failed');
  }

  // Could use `inherits` module, but don't want to move from single file
  // architecture yet.
  function inherits (ctor, superCtor) {
    ctor.super_ = superCtor;
    var TempCtor = function () {};
    TempCtor.prototype = superCtor.prototype;
    ctor.prototype = new TempCtor();
    ctor.prototype.constructor = ctor;
  }

  // BN

  function BN (number, base, endian) {
    if (BN.isBN(number)) {
      return number;
    }

    this.negative = 0;
    this.words = null;
    this.length = 0;

    // Reduction context
    this.red = null;

    if (number !== null) {
      if (base === 'le' || base === 'be') {
        endian = base;
        base = 10;
      }

      this._init(number || 0, base || 10, endian || 'be');
    }
  }
  if (typeof module === 'object') {
    module.exports = BN;
  } else {
    exports.BN = BN;
  }

  BN.BN = BN;
  BN.wordSize = 26;

  var Buffer;
  try {
    Buffer = __webpack_require__(/*! buffer */ 5).Buffer;
  } catch (e) {
  }

  BN.isBN = function isBN (num) {
    if (num instanceof BN) {
      return true;
    }

    return num !== null && typeof num === 'object' &&
      num.constructor.wordSize === BN.wordSize && Array.isArray(num.words);
  };

  BN.max = function max (left, right) {
    if (left.cmp(right) > 0) return left;
    return right;
  };

  BN.min = function min (left, right) {
    if (left.cmp(right) < 0) return left;
    return right;
  };

  BN.prototype._init = function init (number, base, endian) {
    if (typeof number === 'number') {
      return this._initNumber(number, base, endian);
    }

    if (typeof number === 'object') {
      return this._initArray(number, base, endian);
    }

    if (base === 'hex') {
      base = 16;
    }
    assert(base === (base | 0) && base >= 2 && base <= 36);

    number = number.toString().replace(/\s+/g, '');
    var start = 0;
    if (number[0] === '-') {
      start++;
    }

    if (base === 16) {
      this._parseHex(number, start);
    } else {
      this._parseBase(number, base, start);
    }

    if (number[0] === '-') {
      this.negative = 1;
    }

    this.strip();

    if (endian !== 'le') return;

    this._initArray(this.toArray(), base, endian);
  };

  BN.prototype._initNumber = function _initNumber (number, base, endian) {
    if (number < 0) {
      this.negative = 1;
      number = -number;
    }
    if (number < 0x4000000) {
      this.words = [ number & 0x3ffffff ];
      this.length = 1;
    } else if (number < 0x10000000000000) {
      this.words = [
        number & 0x3ffffff,
        (number / 0x4000000) & 0x3ffffff
      ];
      this.length = 2;
    } else {
      assert(number < 0x20000000000000); // 2 ^ 53 (unsafe)
      this.words = [
        number & 0x3ffffff,
        (number / 0x4000000) & 0x3ffffff,
        1
      ];
      this.length = 3;
    }

    if (endian !== 'le') return;

    // Reverse the bytes
    this._initArray(this.toArray(), base, endian);
  };

  BN.prototype._initArray = function _initArray (number, base, endian) {
    // Perhaps a Uint8Array
    assert(typeof number.length === 'number');
    if (number.length <= 0) {
      this.words = [ 0 ];
      this.length = 1;
      return this;
    }

    this.length = Math.ceil(number.length / 3);
    this.words = new Array(this.length);
    for (var i = 0; i < this.length; i++) {
      this.words[i] = 0;
    }

    var j, w;
    var off = 0;
    if (endian === 'be') {
      for (i = number.length - 1, j = 0; i >= 0; i -= 3) {
        w = number[i] | (number[i - 1] << 8) | (number[i - 2] << 16);
        this.words[j] |= (w << off) & 0x3ffffff;
        this.words[j + 1] = (w >>> (26 - off)) & 0x3ffffff;
        off += 24;
        if (off >= 26) {
          off -= 26;
          j++;
        }
      }
    } else if (endian === 'le') {
      for (i = 0, j = 0; i < number.length; i += 3) {
        w = number[i] | (number[i + 1] << 8) | (number[i + 2] << 16);
        this.words[j] |= (w << off) & 0x3ffffff;
        this.words[j + 1] = (w >>> (26 - off)) & 0x3ffffff;
        off += 24;
        if (off >= 26) {
          off -= 26;
          j++;
        }
      }
    }
    return this.strip();
  };

  function parseHex (str, start, end) {
    var r = 0;
    var len = Math.min(str.length, end);
    for (var i = start; i < len; i++) {
      var c = str.charCodeAt(i) - 48;

      r <<= 4;

      // 'a' - 'f'
      if (c >= 49 && c <= 54) {
        r |= c - 49 + 0xa;

      // 'A' - 'F'
      } else if (c >= 17 && c <= 22) {
        r |= c - 17 + 0xa;

      // '0' - '9'
      } else {
        r |= c & 0xf;
      }
    }
    return r;
  }

  BN.prototype._parseHex = function _parseHex (number, start) {
    // Create possibly bigger array to ensure that it fits the number
    this.length = Math.ceil((number.length - start) / 6);
    this.words = new Array(this.length);
    for (var i = 0; i < this.length; i++) {
      this.words[i] = 0;
    }

    var j, w;
    // Scan 24-bit chunks and add them to the number
    var off = 0;
    for (i = number.length - 6, j = 0; i >= start; i -= 6) {
      w = parseHex(number, i, i + 6);
      this.words[j] |= (w << off) & 0x3ffffff;
      // NOTE: `0x3fffff` is intentional here, 26bits max shift + 24bit hex limb
      this.words[j + 1] |= w >>> (26 - off) & 0x3fffff;
      off += 24;
      if (off >= 26) {
        off -= 26;
        j++;
      }
    }
    if (i + 6 !== start) {
      w = parseHex(number, start, i + 6);
      this.words[j] |= (w << off) & 0x3ffffff;
      this.words[j + 1] |= w >>> (26 - off) & 0x3fffff;
    }
    this.strip();
  };

  function parseBase (str, start, end, mul) {
    var r = 0;
    var len = Math.min(str.length, end);
    for (var i = start; i < len; i++) {
      var c = str.charCodeAt(i) - 48;

      r *= mul;

      // 'a'
      if (c >= 49) {
        r += c - 49 + 0xa;

      // 'A'
      } else if (c >= 17) {
        r += c - 17 + 0xa;

      // '0' - '9'
      } else {
        r += c;
      }
    }
    return r;
  }

  BN.prototype._parseBase = function _parseBase (number, base, start) {
    // Initialize as zero
    this.words = [ 0 ];
    this.length = 1;

    // Find length of limb in base
    for (var limbLen = 0, limbPow = 1; limbPow <= 0x3ffffff; limbPow *= base) {
      limbLen++;
    }
    limbLen--;
    limbPow = (limbPow / base) | 0;

    var total = number.length - start;
    var mod = total % limbLen;
    var end = Math.min(total, total - mod) + start;

    var word = 0;
    for (var i = start; i < end; i += limbLen) {
      word = parseBase(number, i, i + limbLen, base);

      this.imuln(limbPow);
      if (this.words[0] + word < 0x4000000) {
        this.words[0] += word;
      } else {
        this._iaddn(word);
      }
    }

    if (mod !== 0) {
      var pow = 1;
      word = parseBase(number, i, number.length, base);

      for (i = 0; i < mod; i++) {
        pow *= base;
      }

      this.imuln(pow);
      if (this.words[0] + word < 0x4000000) {
        this.words[0] += word;
      } else {
        this._iaddn(word);
      }
    }
  };

  BN.prototype.copy = function copy (dest) {
    dest.words = new Array(this.length);
    for (var i = 0; i < this.length; i++) {
      dest.words[i] = this.words[i];
    }
    dest.length = this.length;
    dest.negative = this.negative;
    dest.red = this.red;
  };

  BN.prototype.clone = function clone () {
    var r = new BN(null);
    this.copy(r);
    return r;
  };

  BN.prototype._expand = function _expand (size) {
    while (this.length < size) {
      this.words[this.length++] = 0;
    }
    return this;
  };

  // Remove leading `0` from `this`
  BN.prototype.strip = function strip () {
    while (this.length > 1 && this.words[this.length - 1] === 0) {
      this.length--;
    }
    return this._normSign();
  };

  BN.prototype._normSign = function _normSign () {
    // -0 = 0
    if (this.length === 1 && this.words[0] === 0) {
      this.negative = 0;
    }
    return this;
  };

  BN.prototype.inspect = function inspect () {
    return (this.red ? '<BN-R: ' : '<BN: ') + this.toString(16) + '>';
  };

  /*

  var zeros = [];
  var groupSizes = [];
  var groupBases = [];

  var s = '';
  var i = -1;
  while (++i < BN.wordSize) {
    zeros[i] = s;
    s += '0';
  }
  groupSizes[0] = 0;
  groupSizes[1] = 0;
  groupBases[0] = 0;
  groupBases[1] = 0;
  var base = 2 - 1;
  while (++base < 36 + 1) {
    var groupSize = 0;
    var groupBase = 1;
    while (groupBase < (1 << BN.wordSize) / base) {
      groupBase *= base;
      groupSize += 1;
    }
    groupSizes[base] = groupSize;
    groupBases[base] = groupBase;
  }

  */

  var zeros = [
    '',
    '0',
    '00',
    '000',
    '0000',
    '00000',
    '000000',
    '0000000',
    '00000000',
    '000000000',
    '0000000000',
    '00000000000',
    '000000000000',
    '0000000000000',
    '00000000000000',
    '000000000000000',
    '0000000000000000',
    '00000000000000000',
    '000000000000000000',
    '0000000000000000000',
    '00000000000000000000',
    '000000000000000000000',
    '0000000000000000000000',
    '00000000000000000000000',
    '000000000000000000000000',
    '0000000000000000000000000'
  ];

  var groupSizes = [
    0, 0,
    25, 16, 12, 11, 10, 9, 8,
    8, 7, 7, 7, 7, 6, 6,
    6, 6, 6, 6, 6, 5, 5,
    5, 5, 5, 5, 5, 5, 5,
    5, 5, 5, 5, 5, 5, 5
  ];

  var groupBases = [
    0, 0,
    33554432, 43046721, 16777216, 48828125, 60466176, 40353607, 16777216,
    43046721, 10000000, 19487171, 35831808, 62748517, 7529536, 11390625,
    16777216, 24137569, 34012224, 47045881, 64000000, 4084101, 5153632,
    6436343, 7962624, 9765625, 11881376, 14348907, 17210368, 20511149,
    24300000, 28629151, 33554432, 39135393, 45435424, 52521875, 60466176
  ];

  BN.prototype.toString = function toString (base, padding) {
    base = base || 10;
    padding = padding | 0 || 1;

    var out;
    if (base === 16 || base === 'hex') {
      out = '';
      var off = 0;
      var carry = 0;
      for (var i = 0; i < this.length; i++) {
        var w = this.words[i];
        var word = (((w << off) | carry) & 0xffffff).toString(16);
        carry = (w >>> (24 - off)) & 0xffffff;
        if (carry !== 0 || i !== this.length - 1) {
          out = zeros[6 - word.length] + word + out;
        } else {
          out = word + out;
        }
        off += 2;
        if (off >= 26) {
          off -= 26;
          i--;
        }
      }
      if (carry !== 0) {
        out = carry.toString(16) + out;
      }
      while (out.length % padding !== 0) {
        out = '0' + out;
      }
      if (this.negative !== 0) {
        out = '-' + out;
      }
      return out;
    }

    if (base === (base | 0) && base >= 2 && base <= 36) {
      // var groupSize = Math.floor(BN.wordSize * Math.LN2 / Math.log(base));
      var groupSize = groupSizes[base];
      // var groupBase = Math.pow(base, groupSize);
      var groupBase = groupBases[base];
      out = '';
      var c = this.clone();
      c.negative = 0;
      while (!c.isZero()) {
        var r = c.modn(groupBase).toString(base);
        c = c.idivn(groupBase);

        if (!c.isZero()) {
          out = zeros[groupSize - r.length] + r + out;
        } else {
          out = r + out;
        }
      }
      if (this.isZero()) {
        out = '0' + out;
      }
      while (out.length % padding !== 0) {
        out = '0' + out;
      }
      if (this.negative !== 0) {
        out = '-' + out;
      }
      return out;
    }

    assert(false, 'Base should be between 2 and 36');
  };

  BN.prototype.toNumber = function toNumber () {
    var ret = this.words[0];
    if (this.length === 2) {
      ret += this.words[1] * 0x4000000;
    } else if (this.length === 3 && this.words[2] === 0x01) {
      // NOTE: at this stage it is known that the top bit is set
      ret += 0x10000000000000 + (this.words[1] * 0x4000000);
    } else if (this.length > 2) {
      assert(false, 'Number can only safely store up to 53 bits');
    }
    return (this.negative !== 0) ? -ret : ret;
  };

  BN.prototype.toJSON = function toJSON () {
    return this.toString(16);
  };

  BN.prototype.toBuffer = function toBuffer (endian, length) {
    assert(typeof Buffer !== 'undefined');
    return this.toArrayLike(Buffer, endian, length);
  };

  BN.prototype.toArray = function toArray (endian, length) {
    return this.toArrayLike(Array, endian, length);
  };

  BN.prototype.toArrayLike = function toArrayLike (ArrayType, endian, length) {
    var byteLength = this.byteLength();
    var reqLength = length || Math.max(1, byteLength);
    assert(byteLength <= reqLength, 'byte array longer than desired length');
    assert(reqLength > 0, 'Requested array length <= 0');

    this.strip();
    var littleEndian = endian === 'le';
    var res = new ArrayType(reqLength);

    var b, i;
    var q = this.clone();
    if (!littleEndian) {
      // Assume big-endian
      for (i = 0; i < reqLength - byteLength; i++) {
        res[i] = 0;
      }

      for (i = 0; !q.isZero(); i++) {
        b = q.andln(0xff);
        q.iushrn(8);

        res[reqLength - i - 1] = b;
      }
    } else {
      for (i = 0; !q.isZero(); i++) {
        b = q.andln(0xff);
        q.iushrn(8);

        res[i] = b;
      }

      for (; i < reqLength; i++) {
        res[i] = 0;
      }
    }

    return res;
  };

  if (Math.clz32) {
    BN.prototype._countBits = function _countBits (w) {
      return 32 - Math.clz32(w);
    };
  } else {
    BN.prototype._countBits = function _countBits (w) {
      var t = w;
      var r = 0;
      if (t >= 0x1000) {
        r += 13;
        t >>>= 13;
      }
      if (t >= 0x40) {
        r += 7;
        t >>>= 7;
      }
      if (t >= 0x8) {
        r += 4;
        t >>>= 4;
      }
      if (t >= 0x02) {
        r += 2;
        t >>>= 2;
      }
      return r + t;
    };
  }

  BN.prototype._zeroBits = function _zeroBits (w) {
    // Short-cut
    if (w === 0) return 26;

    var t = w;
    var r = 0;
    if ((t & 0x1fff) === 0) {
      r += 13;
      t >>>= 13;
    }
    if ((t & 0x7f) === 0) {
      r += 7;
      t >>>= 7;
    }
    if ((t & 0xf) === 0) {
      r += 4;
      t >>>= 4;
    }
    if ((t & 0x3) === 0) {
      r += 2;
      t >>>= 2;
    }
    if ((t & 0x1) === 0) {
      r++;
    }
    return r;
  };

  // Return number of used bits in a BN
  BN.prototype.bitLength = function bitLength () {
    var w = this.words[this.length - 1];
    var hi = this._countBits(w);
    return (this.length - 1) * 26 + hi;
  };

  function toBitArray (num) {
    var w = new Array(num.bitLength());

    for (var bit = 0; bit < w.length; bit++) {
      var off = (bit / 26) | 0;
      var wbit = bit % 26;

      w[bit] = (num.words[off] & (1 << wbit)) >>> wbit;
    }

    return w;
  }

  // Number of trailing zero bits
  BN.prototype.zeroBits = function zeroBits () {
    if (this.isZero()) return 0;

    var r = 0;
    for (var i = 0; i < this.length; i++) {
      var b = this._zeroBits(this.words[i]);
      r += b;
      if (b !== 26) break;
    }
    return r;
  };

  BN.prototype.byteLength = function byteLength () {
    return Math.ceil(this.bitLength() / 8);
  };

  BN.prototype.toTwos = function toTwos (width) {
    if (this.negative !== 0) {
      return this.abs().inotn(width).iaddn(1);
    }
    return this.clone();
  };

  BN.prototype.fromTwos = function fromTwos (width) {
    if (this.testn(width - 1)) {
      return this.notn(width).iaddn(1).ineg();
    }
    return this.clone();
  };

  BN.prototype.isNeg = function isNeg () {
    return this.negative !== 0;
  };

  // Return negative clone of `this`
  BN.prototype.neg = function neg () {
    return this.clone().ineg();
  };

  BN.prototype.ineg = function ineg () {
    if (!this.isZero()) {
      this.negative ^= 1;
    }

    return this;
  };

  // Or `num` with `this` in-place
  BN.prototype.iuor = function iuor (num) {
    while (this.length < num.length) {
      this.words[this.length++] = 0;
    }

    for (var i = 0; i < num.length; i++) {
      this.words[i] = this.words[i] | num.words[i];
    }

    return this.strip();
  };

  BN.prototype.ior = function ior (num) {
    assert((this.negative | num.negative) === 0);
    return this.iuor(num);
  };

  // Or `num` with `this`
  BN.prototype.or = function or (num) {
    if (this.length > num.length) return this.clone().ior(num);
    return num.clone().ior(this);
  };

  BN.prototype.uor = function uor (num) {
    if (this.length > num.length) return this.clone().iuor(num);
    return num.clone().iuor(this);
  };

  // And `num` with `this` in-place
  BN.prototype.iuand = function iuand (num) {
    // b = min-length(num, this)
    var b;
    if (this.length > num.length) {
      b = num;
    } else {
      b = this;
    }

    for (var i = 0; i < b.length; i++) {
      this.words[i] = this.words[i] & num.words[i];
    }

    this.length = b.length;

    return this.strip();
  };

  BN.prototype.iand = function iand (num) {
    assert((this.negative | num.negative) === 0);
    return this.iuand(num);
  };

  // And `num` with `this`
  BN.prototype.and = function and (num) {
    if (this.length > num.length) return this.clone().iand(num);
    return num.clone().iand(this);
  };

  BN.prototype.uand = function uand (num) {
    if (this.length > num.length) return this.clone().iuand(num);
    return num.clone().iuand(this);
  };

  // Xor `num` with `this` in-place
  BN.prototype.iuxor = function iuxor (num) {
    // a.length > b.length
    var a;
    var b;
    if (this.length > num.length) {
      a = this;
      b = num;
    } else {
      a = num;
      b = this;
    }

    for (var i = 0; i < b.length; i++) {
      this.words[i] = a.words[i] ^ b.words[i];
    }

    if (this !== a) {
      for (; i < a.length; i++) {
        this.words[i] = a.words[i];
      }
    }

    this.length = a.length;

    return this.strip();
  };

  BN.prototype.ixor = function ixor (num) {
    assert((this.negative | num.negative) === 0);
    return this.iuxor(num);
  };

  // Xor `num` with `this`
  BN.prototype.xor = function xor (num) {
    if (this.length > num.length) return this.clone().ixor(num);
    return num.clone().ixor(this);
  };

  BN.prototype.uxor = function uxor (num) {
    if (this.length > num.length) return this.clone().iuxor(num);
    return num.clone().iuxor(this);
  };

  // Not ``this`` with ``width`` bitwidth
  BN.prototype.inotn = function inotn (width) {
    assert(typeof width === 'number' && width >= 0);

    var bytesNeeded = Math.ceil(width / 26) | 0;
    var bitsLeft = width % 26;

    // Extend the buffer with leading zeroes
    this._expand(bytesNeeded);

    if (bitsLeft > 0) {
      bytesNeeded--;
    }

    // Handle complete words
    for (var i = 0; i < bytesNeeded; i++) {
      this.words[i] = ~this.words[i] & 0x3ffffff;
    }

    // Handle the residue
    if (bitsLeft > 0) {
      this.words[i] = ~this.words[i] & (0x3ffffff >> (26 - bitsLeft));
    }

    // And remove leading zeroes
    return this.strip();
  };

  BN.prototype.notn = function notn (width) {
    return this.clone().inotn(width);
  };

  // Set `bit` of `this`
  BN.prototype.setn = function setn (bit, val) {
    assert(typeof bit === 'number' && bit >= 0);

    var off = (bit / 26) | 0;
    var wbit = bit % 26;

    this._expand(off + 1);

    if (val) {
      this.words[off] = this.words[off] | (1 << wbit);
    } else {
      this.words[off] = this.words[off] & ~(1 << wbit);
    }

    return this.strip();
  };

  // Add `num` to `this` in-place
  BN.prototype.iadd = function iadd (num) {
    var r;

    // negative + positive
    if (this.negative !== 0 && num.negative === 0) {
      this.negative = 0;
      r = this.isub(num);
      this.negative ^= 1;
      return this._normSign();

    // positive + negative
    } else if (this.negative === 0 && num.negative !== 0) {
      num.negative = 0;
      r = this.isub(num);
      num.negative = 1;
      return r._normSign();
    }

    // a.length > b.length
    var a, b;
    if (this.length > num.length) {
      a = this;
      b = num;
    } else {
      a = num;
      b = this;
    }

    var carry = 0;
    for (var i = 0; i < b.length; i++) {
      r = (a.words[i] | 0) + (b.words[i] | 0) + carry;
      this.words[i] = r & 0x3ffffff;
      carry = r >>> 26;
    }
    for (; carry !== 0 && i < a.length; i++) {
      r = (a.words[i] | 0) + carry;
      this.words[i] = r & 0x3ffffff;
      carry = r >>> 26;
    }

    this.length = a.length;
    if (carry !== 0) {
      this.words[this.length] = carry;
      this.length++;
    // Copy the rest of the words
    } else if (a !== this) {
      for (; i < a.length; i++) {
        this.words[i] = a.words[i];
      }
    }

    return this;
  };

  // Add `num` to `this`
  BN.prototype.add = function add (num) {
    var res;
    if (num.negative !== 0 && this.negative === 0) {
      num.negative = 0;
      res = this.sub(num);
      num.negative ^= 1;
      return res;
    } else if (num.negative === 0 && this.negative !== 0) {
      this.negative = 0;
      res = num.sub(this);
      this.negative = 1;
      return res;
    }

    if (this.length > num.length) return this.clone().iadd(num);

    return num.clone().iadd(this);
  };

  // Subtract `num` from `this` in-place
  BN.prototype.isub = function isub (num) {
    // this - (-num) = this + num
    if (num.negative !== 0) {
      num.negative = 0;
      var r = this.iadd(num);
      num.negative = 1;
      return r._normSign();

    // -this - num = -(this + num)
    } else if (this.negative !== 0) {
      this.negative = 0;
      this.iadd(num);
      this.negative = 1;
      return this._normSign();
    }

    // At this point both numbers are positive
    var cmp = this.cmp(num);

    // Optimization - zeroify
    if (cmp === 0) {
      this.negative = 0;
      this.length = 1;
      this.words[0] = 0;
      return this;
    }

    // a > b
    var a, b;
    if (cmp > 0) {
      a = this;
      b = num;
    } else {
      a = num;
      b = this;
    }

    var carry = 0;
    for (var i = 0; i < b.length; i++) {
      r = (a.words[i] | 0) - (b.words[i] | 0) + carry;
      carry = r >> 26;
      this.words[i] = r & 0x3ffffff;
    }
    for (; carry !== 0 && i < a.length; i++) {
      r = (a.words[i] | 0) + carry;
      carry = r >> 26;
      this.words[i] = r & 0x3ffffff;
    }

    // Copy rest of the words
    if (carry === 0 && i < a.length && a !== this) {
      for (; i < a.length; i++) {
        this.words[i] = a.words[i];
      }
    }

    this.length = Math.max(this.length, i);

    if (a !== this) {
      this.negative = 1;
    }

    return this.strip();
  };

  // Subtract `num` from `this`
  BN.prototype.sub = function sub (num) {
    return this.clone().isub(num);
  };

  function smallMulTo (self, num, out) {
    out.negative = num.negative ^ self.negative;
    var len = (self.length + num.length) | 0;
    out.length = len;
    len = (len - 1) | 0;

    // Peel one iteration (compiler can't do it, because of code complexity)
    var a = self.words[0] | 0;
    var b = num.words[0] | 0;
    var r = a * b;

    var lo = r & 0x3ffffff;
    var carry = (r / 0x4000000) | 0;
    out.words[0] = lo;

    for (var k = 1; k < len; k++) {
      // Sum all words with the same `i + j = k` and accumulate `ncarry`,
      // note that ncarry could be >= 0x3ffffff
      var ncarry = carry >>> 26;
      var rword = carry & 0x3ffffff;
      var maxJ = Math.min(k, num.length - 1);
      for (var j = Math.max(0, k - self.length + 1); j <= maxJ; j++) {
        var i = (k - j) | 0;
        a = self.words[i] | 0;
        b = num.words[j] | 0;
        r = a * b + rword;
        ncarry += (r / 0x4000000) | 0;
        rword = r & 0x3ffffff;
      }
      out.words[k] = rword | 0;
      carry = ncarry | 0;
    }
    if (carry !== 0) {
      out.words[k] = carry | 0;
    } else {
      out.length--;
    }

    return out.strip();
  }

  // TODO(indutny): it may be reasonable to omit it for users who don't need
  // to work with 256-bit numbers, otherwise it gives 20% improvement for 256-bit
  // multiplication (like elliptic secp256k1).
  var comb10MulTo = function comb10MulTo (self, num, out) {
    var a = self.words;
    var b = num.words;
    var o = out.words;
    var c = 0;
    var lo;
    var mid;
    var hi;
    var a0 = a[0] | 0;
    var al0 = a0 & 0x1fff;
    var ah0 = a0 >>> 13;
    var a1 = a[1] | 0;
    var al1 = a1 & 0x1fff;
    var ah1 = a1 >>> 13;
    var a2 = a[2] | 0;
    var al2 = a2 & 0x1fff;
    var ah2 = a2 >>> 13;
    var a3 = a[3] | 0;
    var al3 = a3 & 0x1fff;
    var ah3 = a3 >>> 13;
    var a4 = a[4] | 0;
    var al4 = a4 & 0x1fff;
    var ah4 = a4 >>> 13;
    var a5 = a[5] | 0;
    var al5 = a5 & 0x1fff;
    var ah5 = a5 >>> 13;
    var a6 = a[6] | 0;
    var al6 = a6 & 0x1fff;
    var ah6 = a6 >>> 13;
    var a7 = a[7] | 0;
    var al7 = a7 & 0x1fff;
    var ah7 = a7 >>> 13;
    var a8 = a[8] | 0;
    var al8 = a8 & 0x1fff;
    var ah8 = a8 >>> 13;
    var a9 = a[9] | 0;
    var al9 = a9 & 0x1fff;
    var ah9 = a9 >>> 13;
    var b0 = b[0] | 0;
    var bl0 = b0 & 0x1fff;
    var bh0 = b0 >>> 13;
    var b1 = b[1] | 0;
    var bl1 = b1 & 0x1fff;
    var bh1 = b1 >>> 13;
    var b2 = b[2] | 0;
    var bl2 = b2 & 0x1fff;
    var bh2 = b2 >>> 13;
    var b3 = b[3] | 0;
    var bl3 = b3 & 0x1fff;
    var bh3 = b3 >>> 13;
    var b4 = b[4] | 0;
    var bl4 = b4 & 0x1fff;
    var bh4 = b4 >>> 13;
    var b5 = b[5] | 0;
    var bl5 = b5 & 0x1fff;
    var bh5 = b5 >>> 13;
    var b6 = b[6] | 0;
    var bl6 = b6 & 0x1fff;
    var bh6 = b6 >>> 13;
    var b7 = b[7] | 0;
    var bl7 = b7 & 0x1fff;
    var bh7 = b7 >>> 13;
    var b8 = b[8] | 0;
    var bl8 = b8 & 0x1fff;
    var bh8 = b8 >>> 13;
    var b9 = b[9] | 0;
    var bl9 = b9 & 0x1fff;
    var bh9 = b9 >>> 13;

    out.negative = self.negative ^ num.negative;
    out.length = 19;
    /* k = 0 */
    lo = Math.imul(al0, bl0);
    mid = Math.imul(al0, bh0);
    mid = (mid + Math.imul(ah0, bl0)) | 0;
    hi = Math.imul(ah0, bh0);
    var w0 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w0 >>> 26)) | 0;
    w0 &= 0x3ffffff;
    /* k = 1 */
    lo = Math.imul(al1, bl0);
    mid = Math.imul(al1, bh0);
    mid = (mid + Math.imul(ah1, bl0)) | 0;
    hi = Math.imul(ah1, bh0);
    lo = (lo + Math.imul(al0, bl1)) | 0;
    mid = (mid + Math.imul(al0, bh1)) | 0;
    mid = (mid + Math.imul(ah0, bl1)) | 0;
    hi = (hi + Math.imul(ah0, bh1)) | 0;
    var w1 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w1 >>> 26)) | 0;
    w1 &= 0x3ffffff;
    /* k = 2 */
    lo = Math.imul(al2, bl0);
    mid = Math.imul(al2, bh0);
    mid = (mid + Math.imul(ah2, bl0)) | 0;
    hi = Math.imul(ah2, bh0);
    lo = (lo + Math.imul(al1, bl1)) | 0;
    mid = (mid + Math.imul(al1, bh1)) | 0;
    mid = (mid + Math.imul(ah1, bl1)) | 0;
    hi = (hi + Math.imul(ah1, bh1)) | 0;
    lo = (lo + Math.imul(al0, bl2)) | 0;
    mid = (mid + Math.imul(al0, bh2)) | 0;
    mid = (mid + Math.imul(ah0, bl2)) | 0;
    hi = (hi + Math.imul(ah0, bh2)) | 0;
    var w2 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w2 >>> 26)) | 0;
    w2 &= 0x3ffffff;
    /* k = 3 */
    lo = Math.imul(al3, bl0);
    mid = Math.imul(al3, bh0);
    mid = (mid + Math.imul(ah3, bl0)) | 0;
    hi = Math.imul(ah3, bh0);
    lo = (lo + Math.imul(al2, bl1)) | 0;
    mid = (mid + Math.imul(al2, bh1)) | 0;
    mid = (mid + Math.imul(ah2, bl1)) | 0;
    hi = (hi + Math.imul(ah2, bh1)) | 0;
    lo = (lo + Math.imul(al1, bl2)) | 0;
    mid = (mid + Math.imul(al1, bh2)) | 0;
    mid = (mid + Math.imul(ah1, bl2)) | 0;
    hi = (hi + Math.imul(ah1, bh2)) | 0;
    lo = (lo + Math.imul(al0, bl3)) | 0;
    mid = (mid + Math.imul(al0, bh3)) | 0;
    mid = (mid + Math.imul(ah0, bl3)) | 0;
    hi = (hi + Math.imul(ah0, bh3)) | 0;
    var w3 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w3 >>> 26)) | 0;
    w3 &= 0x3ffffff;
    /* k = 4 */
    lo = Math.imul(al4, bl0);
    mid = Math.imul(al4, bh0);
    mid = (mid + Math.imul(ah4, bl0)) | 0;
    hi = Math.imul(ah4, bh0);
    lo = (lo + Math.imul(al3, bl1)) | 0;
    mid = (mid + Math.imul(al3, bh1)) | 0;
    mid = (mid + Math.imul(ah3, bl1)) | 0;
    hi = (hi + Math.imul(ah3, bh1)) | 0;
    lo = (lo + Math.imul(al2, bl2)) | 0;
    mid = (mid + Math.imul(al2, bh2)) | 0;
    mid = (mid + Math.imul(ah2, bl2)) | 0;
    hi = (hi + Math.imul(ah2, bh2)) | 0;
    lo = (lo + Math.imul(al1, bl3)) | 0;
    mid = (mid + Math.imul(al1, bh3)) | 0;
    mid = (mid + Math.imul(ah1, bl3)) | 0;
    hi = (hi + Math.imul(ah1, bh3)) | 0;
    lo = (lo + Math.imul(al0, bl4)) | 0;
    mid = (mid + Math.imul(al0, bh4)) | 0;
    mid = (mid + Math.imul(ah0, bl4)) | 0;
    hi = (hi + Math.imul(ah0, bh4)) | 0;
    var w4 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w4 >>> 26)) | 0;
    w4 &= 0x3ffffff;
    /* k = 5 */
    lo = Math.imul(al5, bl0);
    mid = Math.imul(al5, bh0);
    mid = (mid + Math.imul(ah5, bl0)) | 0;
    hi = Math.imul(ah5, bh0);
    lo = (lo + Math.imul(al4, bl1)) | 0;
    mid = (mid + Math.imul(al4, bh1)) | 0;
    mid = (mid + Math.imul(ah4, bl1)) | 0;
    hi = (hi + Math.imul(ah4, bh1)) | 0;
    lo = (lo + Math.imul(al3, bl2)) | 0;
    mid = (mid + Math.imul(al3, bh2)) | 0;
    mid = (mid + Math.imul(ah3, bl2)) | 0;
    hi = (hi + Math.imul(ah3, bh2)) | 0;
    lo = (lo + Math.imul(al2, bl3)) | 0;
    mid = (mid + Math.imul(al2, bh3)) | 0;
    mid = (mid + Math.imul(ah2, bl3)) | 0;
    hi = (hi + Math.imul(ah2, bh3)) | 0;
    lo = (lo + Math.imul(al1, bl4)) | 0;
    mid = (mid + Math.imul(al1, bh4)) | 0;
    mid = (mid + Math.imul(ah1, bl4)) | 0;
    hi = (hi + Math.imul(ah1, bh4)) | 0;
    lo = (lo + Math.imul(al0, bl5)) | 0;
    mid = (mid + Math.imul(al0, bh5)) | 0;
    mid = (mid + Math.imul(ah0, bl5)) | 0;
    hi = (hi + Math.imul(ah0, bh5)) | 0;
    var w5 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w5 >>> 26)) | 0;
    w5 &= 0x3ffffff;
    /* k = 6 */
    lo = Math.imul(al6, bl0);
    mid = Math.imul(al6, bh0);
    mid = (mid + Math.imul(ah6, bl0)) | 0;
    hi = Math.imul(ah6, bh0);
    lo = (lo + Math.imul(al5, bl1)) | 0;
    mid = (mid + Math.imul(al5, bh1)) | 0;
    mid = (mid + Math.imul(ah5, bl1)) | 0;
    hi = (hi + Math.imul(ah5, bh1)) | 0;
    lo = (lo + Math.imul(al4, bl2)) | 0;
    mid = (mid + Math.imul(al4, bh2)) | 0;
    mid = (mid + Math.imul(ah4, bl2)) | 0;
    hi = (hi + Math.imul(ah4, bh2)) | 0;
    lo = (lo + Math.imul(al3, bl3)) | 0;
    mid = (mid + Math.imul(al3, bh3)) | 0;
    mid = (mid + Math.imul(ah3, bl3)) | 0;
    hi = (hi + Math.imul(ah3, bh3)) | 0;
    lo = (lo + Math.imul(al2, bl4)) | 0;
    mid = (mid + Math.imul(al2, bh4)) | 0;
    mid = (mid + Math.imul(ah2, bl4)) | 0;
    hi = (hi + Math.imul(ah2, bh4)) | 0;
    lo = (lo + Math.imul(al1, bl5)) | 0;
    mid = (mid + Math.imul(al1, bh5)) | 0;
    mid = (mid + Math.imul(ah1, bl5)) | 0;
    hi = (hi + Math.imul(ah1, bh5)) | 0;
    lo = (lo + Math.imul(al0, bl6)) | 0;
    mid = (mid + Math.imul(al0, bh6)) | 0;
    mid = (mid + Math.imul(ah0, bl6)) | 0;
    hi = (hi + Math.imul(ah0, bh6)) | 0;
    var w6 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w6 >>> 26)) | 0;
    w6 &= 0x3ffffff;
    /* k = 7 */
    lo = Math.imul(al7, bl0);
    mid = Math.imul(al7, bh0);
    mid = (mid + Math.imul(ah7, bl0)) | 0;
    hi = Math.imul(ah7, bh0);
    lo = (lo + Math.imul(al6, bl1)) | 0;
    mid = (mid + Math.imul(al6, bh1)) | 0;
    mid = (mid + Math.imul(ah6, bl1)) | 0;
    hi = (hi + Math.imul(ah6, bh1)) | 0;
    lo = (lo + Math.imul(al5, bl2)) | 0;
    mid = (mid + Math.imul(al5, bh2)) | 0;
    mid = (mid + Math.imul(ah5, bl2)) | 0;
    hi = (hi + Math.imul(ah5, bh2)) | 0;
    lo = (lo + Math.imul(al4, bl3)) | 0;
    mid = (mid + Math.imul(al4, bh3)) | 0;
    mid = (mid + Math.imul(ah4, bl3)) | 0;
    hi = (hi + Math.imul(ah4, bh3)) | 0;
    lo = (lo + Math.imul(al3, bl4)) | 0;
    mid = (mid + Math.imul(al3, bh4)) | 0;
    mid = (mid + Math.imul(ah3, bl4)) | 0;
    hi = (hi + Math.imul(ah3, bh4)) | 0;
    lo = (lo + Math.imul(al2, bl5)) | 0;
    mid = (mid + Math.imul(al2, bh5)) | 0;
    mid = (mid + Math.imul(ah2, bl5)) | 0;
    hi = (hi + Math.imul(ah2, bh5)) | 0;
    lo = (lo + Math.imul(al1, bl6)) | 0;
    mid = (mid + Math.imul(al1, bh6)) | 0;
    mid = (mid + Math.imul(ah1, bl6)) | 0;
    hi = (hi + Math.imul(ah1, bh6)) | 0;
    lo = (lo + Math.imul(al0, bl7)) | 0;
    mid = (mid + Math.imul(al0, bh7)) | 0;
    mid = (mid + Math.imul(ah0, bl7)) | 0;
    hi = (hi + Math.imul(ah0, bh7)) | 0;
    var w7 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w7 >>> 26)) | 0;
    w7 &= 0x3ffffff;
    /* k = 8 */
    lo = Math.imul(al8, bl0);
    mid = Math.imul(al8, bh0);
    mid = (mid + Math.imul(ah8, bl0)) | 0;
    hi = Math.imul(ah8, bh0);
    lo = (lo + Math.imul(al7, bl1)) | 0;
    mid = (mid + Math.imul(al7, bh1)) | 0;
    mid = (mid + Math.imul(ah7, bl1)) | 0;
    hi = (hi + Math.imul(ah7, bh1)) | 0;
    lo = (lo + Math.imul(al6, bl2)) | 0;
    mid = (mid + Math.imul(al6, bh2)) | 0;
    mid = (mid + Math.imul(ah6, bl2)) | 0;
    hi = (hi + Math.imul(ah6, bh2)) | 0;
    lo = (lo + Math.imul(al5, bl3)) | 0;
    mid = (mid + Math.imul(al5, bh3)) | 0;
    mid = (mid + Math.imul(ah5, bl3)) | 0;
    hi = (hi + Math.imul(ah5, bh3)) | 0;
    lo = (lo + Math.imul(al4, bl4)) | 0;
    mid = (mid + Math.imul(al4, bh4)) | 0;
    mid = (mid + Math.imul(ah4, bl4)) | 0;
    hi = (hi + Math.imul(ah4, bh4)) | 0;
    lo = (lo + Math.imul(al3, bl5)) | 0;
    mid = (mid + Math.imul(al3, bh5)) | 0;
    mid = (mid + Math.imul(ah3, bl5)) | 0;
    hi = (hi + Math.imul(ah3, bh5)) | 0;
    lo = (lo + Math.imul(al2, bl6)) | 0;
    mid = (mid + Math.imul(al2, bh6)) | 0;
    mid = (mid + Math.imul(ah2, bl6)) | 0;
    hi = (hi + Math.imul(ah2, bh6)) | 0;
    lo = (lo + Math.imul(al1, bl7)) | 0;
    mid = (mid + Math.imul(al1, bh7)) | 0;
    mid = (mid + Math.imul(ah1, bl7)) | 0;
    hi = (hi + Math.imul(ah1, bh7)) | 0;
    lo = (lo + Math.imul(al0, bl8)) | 0;
    mid = (mid + Math.imul(al0, bh8)) | 0;
    mid = (mid + Math.imul(ah0, bl8)) | 0;
    hi = (hi + Math.imul(ah0, bh8)) | 0;
    var w8 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w8 >>> 26)) | 0;
    w8 &= 0x3ffffff;
    /* k = 9 */
    lo = Math.imul(al9, bl0);
    mid = Math.imul(al9, bh0);
    mid = (mid + Math.imul(ah9, bl0)) | 0;
    hi = Math.imul(ah9, bh0);
    lo = (lo + Math.imul(al8, bl1)) | 0;
    mid = (mid + Math.imul(al8, bh1)) | 0;
    mid = (mid + Math.imul(ah8, bl1)) | 0;
    hi = (hi + Math.imul(ah8, bh1)) | 0;
    lo = (lo + Math.imul(al7, bl2)) | 0;
    mid = (mid + Math.imul(al7, bh2)) | 0;
    mid = (mid + Math.imul(ah7, bl2)) | 0;
    hi = (hi + Math.imul(ah7, bh2)) | 0;
    lo = (lo + Math.imul(al6, bl3)) | 0;
    mid = (mid + Math.imul(al6, bh3)) | 0;
    mid = (mid + Math.imul(ah6, bl3)) | 0;
    hi = (hi + Math.imul(ah6, bh3)) | 0;
    lo = (lo + Math.imul(al5, bl4)) | 0;
    mid = (mid + Math.imul(al5, bh4)) | 0;
    mid = (mid + Math.imul(ah5, bl4)) | 0;
    hi = (hi + Math.imul(ah5, bh4)) | 0;
    lo = (lo + Math.imul(al4, bl5)) | 0;
    mid = (mid + Math.imul(al4, bh5)) | 0;
    mid = (mid + Math.imul(ah4, bl5)) | 0;
    hi = (hi + Math.imul(ah4, bh5)) | 0;
    lo = (lo + Math.imul(al3, bl6)) | 0;
    mid = (mid + Math.imul(al3, bh6)) | 0;
    mid = (mid + Math.imul(ah3, bl6)) | 0;
    hi = (hi + Math.imul(ah3, bh6)) | 0;
    lo = (lo + Math.imul(al2, bl7)) | 0;
    mid = (mid + Math.imul(al2, bh7)) | 0;
    mid = (mid + Math.imul(ah2, bl7)) | 0;
    hi = (hi + Math.imul(ah2, bh7)) | 0;
    lo = (lo + Math.imul(al1, bl8)) | 0;
    mid = (mid + Math.imul(al1, bh8)) | 0;
    mid = (mid + Math.imul(ah1, bl8)) | 0;
    hi = (hi + Math.imul(ah1, bh8)) | 0;
    lo = (lo + Math.imul(al0, bl9)) | 0;
    mid = (mid + Math.imul(al0, bh9)) | 0;
    mid = (mid + Math.imul(ah0, bl9)) | 0;
    hi = (hi + Math.imul(ah0, bh9)) | 0;
    var w9 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w9 >>> 26)) | 0;
    w9 &= 0x3ffffff;
    /* k = 10 */
    lo = Math.imul(al9, bl1);
    mid = Math.imul(al9, bh1);
    mid = (mid + Math.imul(ah9, bl1)) | 0;
    hi = Math.imul(ah9, bh1);
    lo = (lo + Math.imul(al8, bl2)) | 0;
    mid = (mid + Math.imul(al8, bh2)) | 0;
    mid = (mid + Math.imul(ah8, bl2)) | 0;
    hi = (hi + Math.imul(ah8, bh2)) | 0;
    lo = (lo + Math.imul(al7, bl3)) | 0;
    mid = (mid + Math.imul(al7, bh3)) | 0;
    mid = (mid + Math.imul(ah7, bl3)) | 0;
    hi = (hi + Math.imul(ah7, bh3)) | 0;
    lo = (lo + Math.imul(al6, bl4)) | 0;
    mid = (mid + Math.imul(al6, bh4)) | 0;
    mid = (mid + Math.imul(ah6, bl4)) | 0;
    hi = (hi + Math.imul(ah6, bh4)) | 0;
    lo = (lo + Math.imul(al5, bl5)) | 0;
    mid = (mid + Math.imul(al5, bh5)) | 0;
    mid = (mid + Math.imul(ah5, bl5)) | 0;
    hi = (hi + Math.imul(ah5, bh5)) | 0;
    lo = (lo + Math.imul(al4, bl6)) | 0;
    mid = (mid + Math.imul(al4, bh6)) | 0;
    mid = (mid + Math.imul(ah4, bl6)) | 0;
    hi = (hi + Math.imul(ah4, bh6)) | 0;
    lo = (lo + Math.imul(al3, bl7)) | 0;
    mid = (mid + Math.imul(al3, bh7)) | 0;
    mid = (mid + Math.imul(ah3, bl7)) | 0;
    hi = (hi + Math.imul(ah3, bh7)) | 0;
    lo = (lo + Math.imul(al2, bl8)) | 0;
    mid = (mid + Math.imul(al2, bh8)) | 0;
    mid = (mid + Math.imul(ah2, bl8)) | 0;
    hi = (hi + Math.imul(ah2, bh8)) | 0;
    lo = (lo + Math.imul(al1, bl9)) | 0;
    mid = (mid + Math.imul(al1, bh9)) | 0;
    mid = (mid + Math.imul(ah1, bl9)) | 0;
    hi = (hi + Math.imul(ah1, bh9)) | 0;
    var w10 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w10 >>> 26)) | 0;
    w10 &= 0x3ffffff;
    /* k = 11 */
    lo = Math.imul(al9, bl2);
    mid = Math.imul(al9, bh2);
    mid = (mid + Math.imul(ah9, bl2)) | 0;
    hi = Math.imul(ah9, bh2);
    lo = (lo + Math.imul(al8, bl3)) | 0;
    mid = (mid + Math.imul(al8, bh3)) | 0;
    mid = (mid + Math.imul(ah8, bl3)) | 0;
    hi = (hi + Math.imul(ah8, bh3)) | 0;
    lo = (lo + Math.imul(al7, bl4)) | 0;
    mid = (mid + Math.imul(al7, bh4)) | 0;
    mid = (mid + Math.imul(ah7, bl4)) | 0;
    hi = (hi + Math.imul(ah7, bh4)) | 0;
    lo = (lo + Math.imul(al6, bl5)) | 0;
    mid = (mid + Math.imul(al6, bh5)) | 0;
    mid = (mid + Math.imul(ah6, bl5)) | 0;
    hi = (hi + Math.imul(ah6, bh5)) | 0;
    lo = (lo + Math.imul(al5, bl6)) | 0;
    mid = (mid + Math.imul(al5, bh6)) | 0;
    mid = (mid + Math.imul(ah5, bl6)) | 0;
    hi = (hi + Math.imul(ah5, bh6)) | 0;
    lo = (lo + Math.imul(al4, bl7)) | 0;
    mid = (mid + Math.imul(al4, bh7)) | 0;
    mid = (mid + Math.imul(ah4, bl7)) | 0;
    hi = (hi + Math.imul(ah4, bh7)) | 0;
    lo = (lo + Math.imul(al3, bl8)) | 0;
    mid = (mid + Math.imul(al3, bh8)) | 0;
    mid = (mid + Math.imul(ah3, bl8)) | 0;
    hi = (hi + Math.imul(ah3, bh8)) | 0;
    lo = (lo + Math.imul(al2, bl9)) | 0;
    mid = (mid + Math.imul(al2, bh9)) | 0;
    mid = (mid + Math.imul(ah2, bl9)) | 0;
    hi = (hi + Math.imul(ah2, bh9)) | 0;
    var w11 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w11 >>> 26)) | 0;
    w11 &= 0x3ffffff;
    /* k = 12 */
    lo = Math.imul(al9, bl3);
    mid = Math.imul(al9, bh3);
    mid = (mid + Math.imul(ah9, bl3)) | 0;
    hi = Math.imul(ah9, bh3);
    lo = (lo + Math.imul(al8, bl4)) | 0;
    mid = (mid + Math.imul(al8, bh4)) | 0;
    mid = (mid + Math.imul(ah8, bl4)) | 0;
    hi = (hi + Math.imul(ah8, bh4)) | 0;
    lo = (lo + Math.imul(al7, bl5)) | 0;
    mid = (mid + Math.imul(al7, bh5)) | 0;
    mid = (mid + Math.imul(ah7, bl5)) | 0;
    hi = (hi + Math.imul(ah7, bh5)) | 0;
    lo = (lo + Math.imul(al6, bl6)) | 0;
    mid = (mid + Math.imul(al6, bh6)) | 0;
    mid = (mid + Math.imul(ah6, bl6)) | 0;
    hi = (hi + Math.imul(ah6, bh6)) | 0;
    lo = (lo + Math.imul(al5, bl7)) | 0;
    mid = (mid + Math.imul(al5, bh7)) | 0;
    mid = (mid + Math.imul(ah5, bl7)) | 0;
    hi = (hi + Math.imul(ah5, bh7)) | 0;
    lo = (lo + Math.imul(al4, bl8)) | 0;
    mid = (mid + Math.imul(al4, bh8)) | 0;
    mid = (mid + Math.imul(ah4, bl8)) | 0;
    hi = (hi + Math.imul(ah4, bh8)) | 0;
    lo = (lo + Math.imul(al3, bl9)) | 0;
    mid = (mid + Math.imul(al3, bh9)) | 0;
    mid = (mid + Math.imul(ah3, bl9)) | 0;
    hi = (hi + Math.imul(ah3, bh9)) | 0;
    var w12 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w12 >>> 26)) | 0;
    w12 &= 0x3ffffff;
    /* k = 13 */
    lo = Math.imul(al9, bl4);
    mid = Math.imul(al9, bh4);
    mid = (mid + Math.imul(ah9, bl4)) | 0;
    hi = Math.imul(ah9, bh4);
    lo = (lo + Math.imul(al8, bl5)) | 0;
    mid = (mid + Math.imul(al8, bh5)) | 0;
    mid = (mid + Math.imul(ah8, bl5)) | 0;
    hi = (hi + Math.imul(ah8, bh5)) | 0;
    lo = (lo + Math.imul(al7, bl6)) | 0;
    mid = (mid + Math.imul(al7, bh6)) | 0;
    mid = (mid + Math.imul(ah7, bl6)) | 0;
    hi = (hi + Math.imul(ah7, bh6)) | 0;
    lo = (lo + Math.imul(al6, bl7)) | 0;
    mid = (mid + Math.imul(al6, bh7)) | 0;
    mid = (mid + Math.imul(ah6, bl7)) | 0;
    hi = (hi + Math.imul(ah6, bh7)) | 0;
    lo = (lo + Math.imul(al5, bl8)) | 0;
    mid = (mid + Math.imul(al5, bh8)) | 0;
    mid = (mid + Math.imul(ah5, bl8)) | 0;
    hi = (hi + Math.imul(ah5, bh8)) | 0;
    lo = (lo + Math.imul(al4, bl9)) | 0;
    mid = (mid + Math.imul(al4, bh9)) | 0;
    mid = (mid + Math.imul(ah4, bl9)) | 0;
    hi = (hi + Math.imul(ah4, bh9)) | 0;
    var w13 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w13 >>> 26)) | 0;
    w13 &= 0x3ffffff;
    /* k = 14 */
    lo = Math.imul(al9, bl5);
    mid = Math.imul(al9, bh5);
    mid = (mid + Math.imul(ah9, bl5)) | 0;
    hi = Math.imul(ah9, bh5);
    lo = (lo + Math.imul(al8, bl6)) | 0;
    mid = (mid + Math.imul(al8, bh6)) | 0;
    mid = (mid + Math.imul(ah8, bl6)) | 0;
    hi = (hi + Math.imul(ah8, bh6)) | 0;
    lo = (lo + Math.imul(al7, bl7)) | 0;
    mid = (mid + Math.imul(al7, bh7)) | 0;
    mid = (mid + Math.imul(ah7, bl7)) | 0;
    hi = (hi + Math.imul(ah7, bh7)) | 0;
    lo = (lo + Math.imul(al6, bl8)) | 0;
    mid = (mid + Math.imul(al6, bh8)) | 0;
    mid = (mid + Math.imul(ah6, bl8)) | 0;
    hi = (hi + Math.imul(ah6, bh8)) | 0;
    lo = (lo + Math.imul(al5, bl9)) | 0;
    mid = (mid + Math.imul(al5, bh9)) | 0;
    mid = (mid + Math.imul(ah5, bl9)) | 0;
    hi = (hi + Math.imul(ah5, bh9)) | 0;
    var w14 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w14 >>> 26)) | 0;
    w14 &= 0x3ffffff;
    /* k = 15 */
    lo = Math.imul(al9, bl6);
    mid = Math.imul(al9, bh6);
    mid = (mid + Math.imul(ah9, bl6)) | 0;
    hi = Math.imul(ah9, bh6);
    lo = (lo + Math.imul(al8, bl7)) | 0;
    mid = (mid + Math.imul(al8, bh7)) | 0;
    mid = (mid + Math.imul(ah8, bl7)) | 0;
    hi = (hi + Math.imul(ah8, bh7)) | 0;
    lo = (lo + Math.imul(al7, bl8)) | 0;
    mid = (mid + Math.imul(al7, bh8)) | 0;
    mid = (mid + Math.imul(ah7, bl8)) | 0;
    hi = (hi + Math.imul(ah7, bh8)) | 0;
    lo = (lo + Math.imul(al6, bl9)) | 0;
    mid = (mid + Math.imul(al6, bh9)) | 0;
    mid = (mid + Math.imul(ah6, bl9)) | 0;
    hi = (hi + Math.imul(ah6, bh9)) | 0;
    var w15 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w15 >>> 26)) | 0;
    w15 &= 0x3ffffff;
    /* k = 16 */
    lo = Math.imul(al9, bl7);
    mid = Math.imul(al9, bh7);
    mid = (mid + Math.imul(ah9, bl7)) | 0;
    hi = Math.imul(ah9, bh7);
    lo = (lo + Math.imul(al8, bl8)) | 0;
    mid = (mid + Math.imul(al8, bh8)) | 0;
    mid = (mid + Math.imul(ah8, bl8)) | 0;
    hi = (hi + Math.imul(ah8, bh8)) | 0;
    lo = (lo + Math.imul(al7, bl9)) | 0;
    mid = (mid + Math.imul(al7, bh9)) | 0;
    mid = (mid + Math.imul(ah7, bl9)) | 0;
    hi = (hi + Math.imul(ah7, bh9)) | 0;
    var w16 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w16 >>> 26)) | 0;
    w16 &= 0x3ffffff;
    /* k = 17 */
    lo = Math.imul(al9, bl8);
    mid = Math.imul(al9, bh8);
    mid = (mid + Math.imul(ah9, bl8)) | 0;
    hi = Math.imul(ah9, bh8);
    lo = (lo + Math.imul(al8, bl9)) | 0;
    mid = (mid + Math.imul(al8, bh9)) | 0;
    mid = (mid + Math.imul(ah8, bl9)) | 0;
    hi = (hi + Math.imul(ah8, bh9)) | 0;
    var w17 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w17 >>> 26)) | 0;
    w17 &= 0x3ffffff;
    /* k = 18 */
    lo = Math.imul(al9, bl9);
    mid = Math.imul(al9, bh9);
    mid = (mid + Math.imul(ah9, bl9)) | 0;
    hi = Math.imul(ah9, bh9);
    var w18 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w18 >>> 26)) | 0;
    w18 &= 0x3ffffff;
    o[0] = w0;
    o[1] = w1;
    o[2] = w2;
    o[3] = w3;
    o[4] = w4;
    o[5] = w5;
    o[6] = w6;
    o[7] = w7;
    o[8] = w8;
    o[9] = w9;
    o[10] = w10;
    o[11] = w11;
    o[12] = w12;
    o[13] = w13;
    o[14] = w14;
    o[15] = w15;
    o[16] = w16;
    o[17] = w17;
    o[18] = w18;
    if (c !== 0) {
      o[19] = c;
      out.length++;
    }
    return out;
  };

  // Polyfill comb
  if (!Math.imul) {
    comb10MulTo = smallMulTo;
  }

  function bigMulTo (self, num, out) {
    out.negative = num.negative ^ self.negative;
    out.length = self.length + num.length;

    var carry = 0;
    var hncarry = 0;
    for (var k = 0; k < out.length - 1; k++) {
      // Sum all words with the same `i + j = k` and accumulate `ncarry`,
      // note that ncarry could be >= 0x3ffffff
      var ncarry = hncarry;
      hncarry = 0;
      var rword = carry & 0x3ffffff;
      var maxJ = Math.min(k, num.length - 1);
      for (var j = Math.max(0, k - self.length + 1); j <= maxJ; j++) {
        var i = k - j;
        var a = self.words[i] | 0;
        var b = num.words[j] | 0;
        var r = a * b;

        var lo = r & 0x3ffffff;
        ncarry = (ncarry + ((r / 0x4000000) | 0)) | 0;
        lo = (lo + rword) | 0;
        rword = lo & 0x3ffffff;
        ncarry = (ncarry + (lo >>> 26)) | 0;

        hncarry += ncarry >>> 26;
        ncarry &= 0x3ffffff;
      }
      out.words[k] = rword;
      carry = ncarry;
      ncarry = hncarry;
    }
    if (carry !== 0) {
      out.words[k] = carry;
    } else {
      out.length--;
    }

    return out.strip();
  }

  function jumboMulTo (self, num, out) {
    var fftm = new FFTM();
    return fftm.mulp(self, num, out);
  }

  BN.prototype.mulTo = function mulTo (num, out) {
    var res;
    var len = this.length + num.length;
    if (this.length === 10 && num.length === 10) {
      res = comb10MulTo(this, num, out);
    } else if (len < 63) {
      res = smallMulTo(this, num, out);
    } else if (len < 1024) {
      res = bigMulTo(this, num, out);
    } else {
      res = jumboMulTo(this, num, out);
    }

    return res;
  };

  // Cooley-Tukey algorithm for FFT
  // slightly revisited to rely on looping instead of recursion

  function FFTM (x, y) {
    this.x = x;
    this.y = y;
  }

  FFTM.prototype.makeRBT = function makeRBT (N) {
    var t = new Array(N);
    var l = BN.prototype._countBits(N) - 1;
    for (var i = 0; i < N; i++) {
      t[i] = this.revBin(i, l, N);
    }

    return t;
  };

  // Returns binary-reversed representation of `x`
  FFTM.prototype.revBin = function revBin (x, l, N) {
    if (x === 0 || x === N - 1) return x;

    var rb = 0;
    for (var i = 0; i < l; i++) {
      rb |= (x & 1) << (l - i - 1);
      x >>= 1;
    }

    return rb;
  };

  // Performs "tweedling" phase, therefore 'emulating'
  // behaviour of the recursive algorithm
  FFTM.prototype.permute = function permute (rbt, rws, iws, rtws, itws, N) {
    for (var i = 0; i < N; i++) {
      rtws[i] = rws[rbt[i]];
      itws[i] = iws[rbt[i]];
    }
  };

  FFTM.prototype.transform = function transform (rws, iws, rtws, itws, N, rbt) {
    this.permute(rbt, rws, iws, rtws, itws, N);

    for (var s = 1; s < N; s <<= 1) {
      var l = s << 1;

      var rtwdf = Math.cos(2 * Math.PI / l);
      var itwdf = Math.sin(2 * Math.PI / l);

      for (var p = 0; p < N; p += l) {
        var rtwdf_ = rtwdf;
        var itwdf_ = itwdf;

        for (var j = 0; j < s; j++) {
          var re = rtws[p + j];
          var ie = itws[p + j];

          var ro = rtws[p + j + s];
          var io = itws[p + j + s];

          var rx = rtwdf_ * ro - itwdf_ * io;

          io = rtwdf_ * io + itwdf_ * ro;
          ro = rx;

          rtws[p + j] = re + ro;
          itws[p + j] = ie + io;

          rtws[p + j + s] = re - ro;
          itws[p + j + s] = ie - io;

          /* jshint maxdepth : false */
          if (j !== l) {
            rx = rtwdf * rtwdf_ - itwdf * itwdf_;

            itwdf_ = rtwdf * itwdf_ + itwdf * rtwdf_;
            rtwdf_ = rx;
          }
        }
      }
    }
  };

  FFTM.prototype.guessLen13b = function guessLen13b (n, m) {
    var N = Math.max(m, n) | 1;
    var odd = N & 1;
    var i = 0;
    for (N = N / 2 | 0; N; N = N >>> 1) {
      i++;
    }

    return 1 << i + 1 + odd;
  };

  FFTM.prototype.conjugate = function conjugate (rws, iws, N) {
    if (N <= 1) return;

    for (var i = 0; i < N / 2; i++) {
      var t = rws[i];

      rws[i] = rws[N - i - 1];
      rws[N - i - 1] = t;

      t = iws[i];

      iws[i] = -iws[N - i - 1];
      iws[N - i - 1] = -t;
    }
  };

  FFTM.prototype.normalize13b = function normalize13b (ws, N) {
    var carry = 0;
    for (var i = 0; i < N / 2; i++) {
      var w = Math.round(ws[2 * i + 1] / N) * 0x2000 +
        Math.round(ws[2 * i] / N) +
        carry;

      ws[i] = w & 0x3ffffff;

      if (w < 0x4000000) {
        carry = 0;
      } else {
        carry = w / 0x4000000 | 0;
      }
    }

    return ws;
  };

  FFTM.prototype.convert13b = function convert13b (ws, len, rws, N) {
    var carry = 0;
    for (var i = 0; i < len; i++) {
      carry = carry + (ws[i] | 0);

      rws[2 * i] = carry & 0x1fff; carry = carry >>> 13;
      rws[2 * i + 1] = carry & 0x1fff; carry = carry >>> 13;
    }

    // Pad with zeroes
    for (i = 2 * len; i < N; ++i) {
      rws[i] = 0;
    }

    assert(carry === 0);
    assert((carry & ~0x1fff) === 0);
  };

  FFTM.prototype.stub = function stub (N) {
    var ph = new Array(N);
    for (var i = 0; i < N; i++) {
      ph[i] = 0;
    }

    return ph;
  };

  FFTM.prototype.mulp = function mulp (x, y, out) {
    var N = 2 * this.guessLen13b(x.length, y.length);

    var rbt = this.makeRBT(N);

    var _ = this.stub(N);

    var rws = new Array(N);
    var rwst = new Array(N);
    var iwst = new Array(N);

    var nrws = new Array(N);
    var nrwst = new Array(N);
    var niwst = new Array(N);

    var rmws = out.words;
    rmws.length = N;

    this.convert13b(x.words, x.length, rws, N);
    this.convert13b(y.words, y.length, nrws, N);

    this.transform(rws, _, rwst, iwst, N, rbt);
    this.transform(nrws, _, nrwst, niwst, N, rbt);

    for (var i = 0; i < N; i++) {
      var rx = rwst[i] * nrwst[i] - iwst[i] * niwst[i];
      iwst[i] = rwst[i] * niwst[i] + iwst[i] * nrwst[i];
      rwst[i] = rx;
    }

    this.conjugate(rwst, iwst, N);
    this.transform(rwst, iwst, rmws, _, N, rbt);
    this.conjugate(rmws, _, N);
    this.normalize13b(rmws, N);

    out.negative = x.negative ^ y.negative;
    out.length = x.length + y.length;
    return out.strip();
  };

  // Multiply `this` by `num`
  BN.prototype.mul = function mul (num) {
    var out = new BN(null);
    out.words = new Array(this.length + num.length);
    return this.mulTo(num, out);
  };

  // Multiply employing FFT
  BN.prototype.mulf = function mulf (num) {
    var out = new BN(null);
    out.words = new Array(this.length + num.length);
    return jumboMulTo(this, num, out);
  };

  // In-place Multiplication
  BN.prototype.imul = function imul (num) {
    return this.clone().mulTo(num, this);
  };

  BN.prototype.imuln = function imuln (num) {
    assert(typeof num === 'number');
    assert(num < 0x4000000);

    // Carry
    var carry = 0;
    for (var i = 0; i < this.length; i++) {
      var w = (this.words[i] | 0) * num;
      var lo = (w & 0x3ffffff) + (carry & 0x3ffffff);
      carry >>= 26;
      carry += (w / 0x4000000) | 0;
      // NOTE: lo is 27bit maximum
      carry += lo >>> 26;
      this.words[i] = lo & 0x3ffffff;
    }

    if (carry !== 0) {
      this.words[i] = carry;
      this.length++;
    }

    return this;
  };

  BN.prototype.muln = function muln (num) {
    return this.clone().imuln(num);
  };

  // `this` * `this`
  BN.prototype.sqr = function sqr () {
    return this.mul(this);
  };

  // `this` * `this` in-place
  BN.prototype.isqr = function isqr () {
    return this.imul(this.clone());
  };

  // Math.pow(`this`, `num`)
  BN.prototype.pow = function pow (num) {
    var w = toBitArray(num);
    if (w.length === 0) return new BN(1);

    // Skip leading zeroes
    var res = this;
    for (var i = 0; i < w.length; i++, res = res.sqr()) {
      if (w[i] !== 0) break;
    }

    if (++i < w.length) {
      for (var q = res.sqr(); i < w.length; i++, q = q.sqr()) {
        if (w[i] === 0) continue;

        res = res.mul(q);
      }
    }

    return res;
  };

  // Shift-left in-place
  BN.prototype.iushln = function iushln (bits) {
    assert(typeof bits === 'number' && bits >= 0);
    var r = bits % 26;
    var s = (bits - r) / 26;
    var carryMask = (0x3ffffff >>> (26 - r)) << (26 - r);
    var i;

    if (r !== 0) {
      var carry = 0;

      for (i = 0; i < this.length; i++) {
        var newCarry = this.words[i] & carryMask;
        var c = ((this.words[i] | 0) - newCarry) << r;
        this.words[i] = c | carry;
        carry = newCarry >>> (26 - r);
      }

      if (carry) {
        this.words[i] = carry;
        this.length++;
      }
    }

    if (s !== 0) {
      for (i = this.length - 1; i >= 0; i--) {
        this.words[i + s] = this.words[i];
      }

      for (i = 0; i < s; i++) {
        this.words[i] = 0;
      }

      this.length += s;
    }

    return this.strip();
  };

  BN.prototype.ishln = function ishln (bits) {
    // TODO(indutny): implement me
    assert(this.negative === 0);
    return this.iushln(bits);
  };

  // Shift-right in-place
  // NOTE: `hint` is a lowest bit before trailing zeroes
  // NOTE: if `extended` is present - it will be filled with destroyed bits
  BN.prototype.iushrn = function iushrn (bits, hint, extended) {
    assert(typeof bits === 'number' && bits >= 0);
    var h;
    if (hint) {
      h = (hint - (hint % 26)) / 26;
    } else {
      h = 0;
    }

    var r = bits % 26;
    var s = Math.min((bits - r) / 26, this.length);
    var mask = 0x3ffffff ^ ((0x3ffffff >>> r) << r);
    var maskedWords = extended;

    h -= s;
    h = Math.max(0, h);

    // Extended mode, copy masked part
    if (maskedWords) {
      for (var i = 0; i < s; i++) {
        maskedWords.words[i] = this.words[i];
      }
      maskedWords.length = s;
    }

    if (s === 0) {
      // No-op, we should not move anything at all
    } else if (this.length > s) {
      this.length -= s;
      for (i = 0; i < this.length; i++) {
        this.words[i] = this.words[i + s];
      }
    } else {
      this.words[0] = 0;
      this.length = 1;
    }

    var carry = 0;
    for (i = this.length - 1; i >= 0 && (carry !== 0 || i >= h); i--) {
      var word = this.words[i] | 0;
      this.words[i] = (carry << (26 - r)) | (word >>> r);
      carry = word & mask;
    }

    // Push carried bits as a mask
    if (maskedWords && carry !== 0) {
      maskedWords.words[maskedWords.length++] = carry;
    }

    if (this.length === 0) {
      this.words[0] = 0;
      this.length = 1;
    }

    return this.strip();
  };

  BN.prototype.ishrn = function ishrn (bits, hint, extended) {
    // TODO(indutny): implement me
    assert(this.negative === 0);
    return this.iushrn(bits, hint, extended);
  };

  // Shift-left
  BN.prototype.shln = function shln (bits) {
    return this.clone().ishln(bits);
  };

  BN.prototype.ushln = function ushln (bits) {
    return this.clone().iushln(bits);
  };

  // Shift-right
  BN.prototype.shrn = function shrn (bits) {
    return this.clone().ishrn(bits);
  };

  BN.prototype.ushrn = function ushrn (bits) {
    return this.clone().iushrn(bits);
  };

  // Test if n bit is set
  BN.prototype.testn = function testn (bit) {
    assert(typeof bit === 'number' && bit >= 0);
    var r = bit % 26;
    var s = (bit - r) / 26;
    var q = 1 << r;

    // Fast case: bit is much higher than all existing words
    if (this.length <= s) return false;

    // Check bit and return
    var w = this.words[s];

    return !!(w & q);
  };

  // Return only lowers bits of number (in-place)
  BN.prototype.imaskn = function imaskn (bits) {
    assert(typeof bits === 'number' && bits >= 0);
    var r = bits % 26;
    var s = (bits - r) / 26;

    assert(this.negative === 0, 'imaskn works only with positive numbers');

    if (this.length <= s) {
      return this;
    }

    if (r !== 0) {
      s++;
    }
    this.length = Math.min(s, this.length);

    if (r !== 0) {
      var mask = 0x3ffffff ^ ((0x3ffffff >>> r) << r);
      this.words[this.length - 1] &= mask;
    }

    return this.strip();
  };

  // Return only lowers bits of number
  BN.prototype.maskn = function maskn (bits) {
    return this.clone().imaskn(bits);
  };

  // Add plain number `num` to `this`
  BN.prototype.iaddn = function iaddn (num) {
    assert(typeof num === 'number');
    assert(num < 0x4000000);
    if (num < 0) return this.isubn(-num);

    // Possible sign change
    if (this.negative !== 0) {
      if (this.length === 1 && (this.words[0] | 0) < num) {
        this.words[0] = num - (this.words[0] | 0);
        this.negative = 0;
        return this;
      }

      this.negative = 0;
      this.isubn(num);
      this.negative = 1;
      return this;
    }

    // Add without checks
    return this._iaddn(num);
  };

  BN.prototype._iaddn = function _iaddn (num) {
    this.words[0] += num;

    // Carry
    for (var i = 0; i < this.length && this.words[i] >= 0x4000000; i++) {
      this.words[i] -= 0x4000000;
      if (i === this.length - 1) {
        this.words[i + 1] = 1;
      } else {
        this.words[i + 1]++;
      }
    }
    this.length = Math.max(this.length, i + 1);

    return this;
  };

  // Subtract plain number `num` from `this`
  BN.prototype.isubn = function isubn (num) {
    assert(typeof num === 'number');
    assert(num < 0x4000000);
    if (num < 0) return this.iaddn(-num);

    if (this.negative !== 0) {
      this.negative = 0;
      this.iaddn(num);
      this.negative = 1;
      return this;
    }

    this.words[0] -= num;

    if (this.length === 1 && this.words[0] < 0) {
      this.words[0] = -this.words[0];
      this.negative = 1;
    } else {
      // Carry
      for (var i = 0; i < this.length && this.words[i] < 0; i++) {
        this.words[i] += 0x4000000;
        this.words[i + 1] -= 1;
      }
    }

    return this.strip();
  };

  BN.prototype.addn = function addn (num) {
    return this.clone().iaddn(num);
  };

  BN.prototype.subn = function subn (num) {
    return this.clone().isubn(num);
  };

  BN.prototype.iabs = function iabs () {
    this.negative = 0;

    return this;
  };

  BN.prototype.abs = function abs () {
    return this.clone().iabs();
  };

  BN.prototype._ishlnsubmul = function _ishlnsubmul (num, mul, shift) {
    var len = num.length + shift;
    var i;

    this._expand(len);

    var w;
    var carry = 0;
    for (i = 0; i < num.length; i++) {
      w = (this.words[i + shift] | 0) + carry;
      var right = (num.words[i] | 0) * mul;
      w -= right & 0x3ffffff;
      carry = (w >> 26) - ((right / 0x4000000) | 0);
      this.words[i + shift] = w & 0x3ffffff;
    }
    for (; i < this.length - shift; i++) {
      w = (this.words[i + shift] | 0) + carry;
      carry = w >> 26;
      this.words[i + shift] = w & 0x3ffffff;
    }

    if (carry === 0) return this.strip();

    // Subtraction overflow
    assert(carry === -1);
    carry = 0;
    for (i = 0; i < this.length; i++) {
      w = -(this.words[i] | 0) + carry;
      carry = w >> 26;
      this.words[i] = w & 0x3ffffff;
    }
    this.negative = 1;

    return this.strip();
  };

  BN.prototype._wordDiv = function _wordDiv (num, mode) {
    var shift = this.length - num.length;

    var a = this.clone();
    var b = num;

    // Normalize
    var bhi = b.words[b.length - 1] | 0;
    var bhiBits = this._countBits(bhi);
    shift = 26 - bhiBits;
    if (shift !== 0) {
      b = b.ushln(shift);
      a.iushln(shift);
      bhi = b.words[b.length - 1] | 0;
    }

    // Initialize quotient
    var m = a.length - b.length;
    var q;

    if (mode !== 'mod') {
      q = new BN(null);
      q.length = m + 1;
      q.words = new Array(q.length);
      for (var i = 0; i < q.length; i++) {
        q.words[i] = 0;
      }
    }

    var diff = a.clone()._ishlnsubmul(b, 1, m);
    if (diff.negative === 0) {
      a = diff;
      if (q) {
        q.words[m] = 1;
      }
    }

    for (var j = m - 1; j >= 0; j--) {
      var qj = (a.words[b.length + j] | 0) * 0x4000000 +
        (a.words[b.length + j - 1] | 0);

      // NOTE: (qj / bhi) is (0x3ffffff * 0x4000000 + 0x3ffffff) / 0x2000000 max
      // (0x7ffffff)
      qj = Math.min((qj / bhi) | 0, 0x3ffffff);

      a._ishlnsubmul(b, qj, j);
      while (a.negative !== 0) {
        qj--;
        a.negative = 0;
        a._ishlnsubmul(b, 1, j);
        if (!a.isZero()) {
          a.negative ^= 1;
        }
      }
      if (q) {
        q.words[j] = qj;
      }
    }
    if (q) {
      q.strip();
    }
    a.strip();

    // Denormalize
    if (mode !== 'div' && shift !== 0) {
      a.iushrn(shift);
    }

    return {
      div: q || null,
      mod: a
    };
  };

  // NOTE: 1) `mode` can be set to `mod` to request mod only,
  //       to `div` to request div only, or be absent to
  //       request both div & mod
  //       2) `positive` is true if unsigned mod is requested
  BN.prototype.divmod = function divmod (num, mode, positive) {
    assert(!num.isZero());

    if (this.isZero()) {
      return {
        div: new BN(0),
        mod: new BN(0)
      };
    }

    var div, mod, res;
    if (this.negative !== 0 && num.negative === 0) {
      res = this.neg().divmod(num, mode);

      if (mode !== 'mod') {
        div = res.div.neg();
      }

      if (mode !== 'div') {
        mod = res.mod.neg();
        if (positive && mod.negative !== 0) {
          mod.iadd(num);
        }
      }

      return {
        div: div,
        mod: mod
      };
    }

    if (this.negative === 0 && num.negative !== 0) {
      res = this.divmod(num.neg(), mode);

      if (mode !== 'mod') {
        div = res.div.neg();
      }

      return {
        div: div,
        mod: res.mod
      };
    }

    if ((this.negative & num.negative) !== 0) {
      res = this.neg().divmod(num.neg(), mode);

      if (mode !== 'div') {
        mod = res.mod.neg();
        if (positive && mod.negative !== 0) {
          mod.isub(num);
        }
      }

      return {
        div: res.div,
        mod: mod
      };
    }

    // Both numbers are positive at this point

    // Strip both numbers to approximate shift value
    if (num.length > this.length || this.cmp(num) < 0) {
      return {
        div: new BN(0),
        mod: this
      };
    }

    // Very short reduction
    if (num.length === 1) {
      if (mode === 'div') {
        return {
          div: this.divn(num.words[0]),
          mod: null
        };
      }

      if (mode === 'mod') {
        return {
          div: null,
          mod: new BN(this.modn(num.words[0]))
        };
      }

      return {
        div: this.divn(num.words[0]),
        mod: new BN(this.modn(num.words[0]))
      };
    }

    return this._wordDiv(num, mode);
  };

  // Find `this` / `num`
  BN.prototype.div = function div (num) {
    return this.divmod(num, 'div', false).div;
  };

  // Find `this` % `num`
  BN.prototype.mod = function mod (num) {
    return this.divmod(num, 'mod', false).mod;
  };

  BN.prototype.umod = function umod (num) {
    return this.divmod(num, 'mod', true).mod;
  };

  // Find Round(`this` / `num`)
  BN.prototype.divRound = function divRound (num) {
    var dm = this.divmod(num);

    // Fast case - exact division
    if (dm.mod.isZero()) return dm.div;

    var mod = dm.div.negative !== 0 ? dm.mod.isub(num) : dm.mod;

    var half = num.ushrn(1);
    var r2 = num.andln(1);
    var cmp = mod.cmp(half);

    // Round down
    if (cmp < 0 || r2 === 1 && cmp === 0) return dm.div;

    // Round up
    return dm.div.negative !== 0 ? dm.div.isubn(1) : dm.div.iaddn(1);
  };

  BN.prototype.modn = function modn (num) {
    assert(num <= 0x3ffffff);
    var p = (1 << 26) % num;

    var acc = 0;
    for (var i = this.length - 1; i >= 0; i--) {
      acc = (p * acc + (this.words[i] | 0)) % num;
    }

    return acc;
  };

  // In-place division by number
  BN.prototype.idivn = function idivn (num) {
    assert(num <= 0x3ffffff);

    var carry = 0;
    for (var i = this.length - 1; i >= 0; i--) {
      var w = (this.words[i] | 0) + carry * 0x4000000;
      this.words[i] = (w / num) | 0;
      carry = w % num;
    }

    return this.strip();
  };

  BN.prototype.divn = function divn (num) {
    return this.clone().idivn(num);
  };

  BN.prototype.egcd = function egcd (p) {
    assert(p.negative === 0);
    assert(!p.isZero());

    var x = this;
    var y = p.clone();

    if (x.negative !== 0) {
      x = x.umod(p);
    } else {
      x = x.clone();
    }

    // A * x + B * y = x
    var A = new BN(1);
    var B = new BN(0);

    // C * x + D * y = y
    var C = new BN(0);
    var D = new BN(1);

    var g = 0;

    while (x.isEven() && y.isEven()) {
      x.iushrn(1);
      y.iushrn(1);
      ++g;
    }

    var yp = y.clone();
    var xp = x.clone();

    while (!x.isZero()) {
      for (var i = 0, im = 1; (x.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
      if (i > 0) {
        x.iushrn(i);
        while (i-- > 0) {
          if (A.isOdd() || B.isOdd()) {
            A.iadd(yp);
            B.isub(xp);
          }

          A.iushrn(1);
          B.iushrn(1);
        }
      }

      for (var j = 0, jm = 1; (y.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
      if (j > 0) {
        y.iushrn(j);
        while (j-- > 0) {
          if (C.isOdd() || D.isOdd()) {
            C.iadd(yp);
            D.isub(xp);
          }

          C.iushrn(1);
          D.iushrn(1);
        }
      }

      if (x.cmp(y) >= 0) {
        x.isub(y);
        A.isub(C);
        B.isub(D);
      } else {
        y.isub(x);
        C.isub(A);
        D.isub(B);
      }
    }

    return {
      a: C,
      b: D,
      gcd: y.iushln(g)
    };
  };

  // This is reduced incarnation of the binary EEA
  // above, designated to invert members of the
  // _prime_ fields F(p) at a maximal speed
  BN.prototype._invmp = function _invmp (p) {
    assert(p.negative === 0);
    assert(!p.isZero());

    var a = this;
    var b = p.clone();

    if (a.negative !== 0) {
      a = a.umod(p);
    } else {
      a = a.clone();
    }

    var x1 = new BN(1);
    var x2 = new BN(0);

    var delta = b.clone();

    while (a.cmpn(1) > 0 && b.cmpn(1) > 0) {
      for (var i = 0, im = 1; (a.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
      if (i > 0) {
        a.iushrn(i);
        while (i-- > 0) {
          if (x1.isOdd()) {
            x1.iadd(delta);
          }

          x1.iushrn(1);
        }
      }

      for (var j = 0, jm = 1; (b.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
      if (j > 0) {
        b.iushrn(j);
        while (j-- > 0) {
          if (x2.isOdd()) {
            x2.iadd(delta);
          }

          x2.iushrn(1);
        }
      }

      if (a.cmp(b) >= 0) {
        a.isub(b);
        x1.isub(x2);
      } else {
        b.isub(a);
        x2.isub(x1);
      }
    }

    var res;
    if (a.cmpn(1) === 0) {
      res = x1;
    } else {
      res = x2;
    }

    if (res.cmpn(0) < 0) {
      res.iadd(p);
    }

    return res;
  };

  BN.prototype.gcd = function gcd (num) {
    if (this.isZero()) return num.abs();
    if (num.isZero()) return this.abs();

    var a = this.clone();
    var b = num.clone();
    a.negative = 0;
    b.negative = 0;

    // Remove common factor of two
    for (var shift = 0; a.isEven() && b.isEven(); shift++) {
      a.iushrn(1);
      b.iushrn(1);
    }

    do {
      while (a.isEven()) {
        a.iushrn(1);
      }
      while (b.isEven()) {
        b.iushrn(1);
      }

      var r = a.cmp(b);
      if (r < 0) {
        // Swap `a` and `b` to make `a` always bigger than `b`
        var t = a;
        a = b;
        b = t;
      } else if (r === 0 || b.cmpn(1) === 0) {
        break;
      }

      a.isub(b);
    } while (true);

    return b.iushln(shift);
  };

  // Invert number in the field F(num)
  BN.prototype.invm = function invm (num) {
    return this.egcd(num).a.umod(num);
  };

  BN.prototype.isEven = function isEven () {
    return (this.words[0] & 1) === 0;
  };

  BN.prototype.isOdd = function isOdd () {
    return (this.words[0] & 1) === 1;
  };

  // And first word and num
  BN.prototype.andln = function andln (num) {
    return this.words[0] & num;
  };

  // Increment at the bit position in-line
  BN.prototype.bincn = function bincn (bit) {
    assert(typeof bit === 'number');
    var r = bit % 26;
    var s = (bit - r) / 26;
    var q = 1 << r;

    // Fast case: bit is much higher than all existing words
    if (this.length <= s) {
      this._expand(s + 1);
      this.words[s] |= q;
      return this;
    }

    // Add bit and propagate, if needed
    var carry = q;
    for (var i = s; carry !== 0 && i < this.length; i++) {
      var w = this.words[i] | 0;
      w += carry;
      carry = w >>> 26;
      w &= 0x3ffffff;
      this.words[i] = w;
    }
    if (carry !== 0) {
      this.words[i] = carry;
      this.length++;
    }
    return this;
  };

  BN.prototype.isZero = function isZero () {
    return this.length === 1 && this.words[0] === 0;
  };

  BN.prototype.cmpn = function cmpn (num) {
    var negative = num < 0;

    if (this.negative !== 0 && !negative) return -1;
    if (this.negative === 0 && negative) return 1;

    this.strip();

    var res;
    if (this.length > 1) {
      res = 1;
    } else {
      if (negative) {
        num = -num;
      }

      assert(num <= 0x3ffffff, 'Number is too big');

      var w = this.words[0] | 0;
      res = w === num ? 0 : w < num ? -1 : 1;
    }
    if (this.negative !== 0) return -res | 0;
    return res;
  };

  // Compare two numbers and return:
  // 1 - if `this` > `num`
  // 0 - if `this` == `num`
  // -1 - if `this` < `num`
  BN.prototype.cmp = function cmp (num) {
    if (this.negative !== 0 && num.negative === 0) return -1;
    if (this.negative === 0 && num.negative !== 0) return 1;

    var res = this.ucmp(num);
    if (this.negative !== 0) return -res | 0;
    return res;
  };

  // Unsigned comparison
  BN.prototype.ucmp = function ucmp (num) {
    // At this point both numbers have the same sign
    if (this.length > num.length) return 1;
    if (this.length < num.length) return -1;

    var res = 0;
    for (var i = this.length - 1; i >= 0; i--) {
      var a = this.words[i] | 0;
      var b = num.words[i] | 0;

      if (a === b) continue;
      if (a < b) {
        res = -1;
      } else if (a > b) {
        res = 1;
      }
      break;
    }
    return res;
  };

  BN.prototype.gtn = function gtn (num) {
    return this.cmpn(num) === 1;
  };

  BN.prototype.gt = function gt (num) {
    return this.cmp(num) === 1;
  };

  BN.prototype.gten = function gten (num) {
    return this.cmpn(num) >= 0;
  };

  BN.prototype.gte = function gte (num) {
    return this.cmp(num) >= 0;
  };

  BN.prototype.ltn = function ltn (num) {
    return this.cmpn(num) === -1;
  };

  BN.prototype.lt = function lt (num) {
    return this.cmp(num) === -1;
  };

  BN.prototype.lten = function lten (num) {
    return this.cmpn(num) <= 0;
  };

  BN.prototype.lte = function lte (num) {
    return this.cmp(num) <= 0;
  };

  BN.prototype.eqn = function eqn (num) {
    return this.cmpn(num) === 0;
  };

  BN.prototype.eq = function eq (num) {
    return this.cmp(num) === 0;
  };

  //
  // A reduce context, could be using montgomery or something better, depending
  // on the `m` itself.
  //
  BN.red = function red (num) {
    return new Red(num);
  };

  BN.prototype.toRed = function toRed (ctx) {
    assert(!this.red, 'Already a number in reduction context');
    assert(this.negative === 0, 'red works only with positives');
    return ctx.convertTo(this)._forceRed(ctx);
  };

  BN.prototype.fromRed = function fromRed () {
    assert(this.red, 'fromRed works only with numbers in reduction context');
    return this.red.convertFrom(this);
  };

  BN.prototype._forceRed = function _forceRed (ctx) {
    this.red = ctx;
    return this;
  };

  BN.prototype.forceRed = function forceRed (ctx) {
    assert(!this.red, 'Already a number in reduction context');
    return this._forceRed(ctx);
  };

  BN.prototype.redAdd = function redAdd (num) {
    assert(this.red, 'redAdd works only with red numbers');
    return this.red.add(this, num);
  };

  BN.prototype.redIAdd = function redIAdd (num) {
    assert(this.red, 'redIAdd works only with red numbers');
    return this.red.iadd(this, num);
  };

  BN.prototype.redSub = function redSub (num) {
    assert(this.red, 'redSub works only with red numbers');
    return this.red.sub(this, num);
  };

  BN.prototype.redISub = function redISub (num) {
    assert(this.red, 'redISub works only with red numbers');
    return this.red.isub(this, num);
  };

  BN.prototype.redShl = function redShl (num) {
    assert(this.red, 'redShl works only with red numbers');
    return this.red.shl(this, num);
  };

  BN.prototype.redMul = function redMul (num) {
    assert(this.red, 'redMul works only with red numbers');
    this.red._verify2(this, num);
    return this.red.mul(this, num);
  };

  BN.prototype.redIMul = function redIMul (num) {
    assert(this.red, 'redMul works only with red numbers');
    this.red._verify2(this, num);
    return this.red.imul(this, num);
  };

  BN.prototype.redSqr = function redSqr () {
    assert(this.red, 'redSqr works only with red numbers');
    this.red._verify1(this);
    return this.red.sqr(this);
  };

  BN.prototype.redISqr = function redISqr () {
    assert(this.red, 'redISqr works only with red numbers');
    this.red._verify1(this);
    return this.red.isqr(this);
  };

  // Square root over p
  BN.prototype.redSqrt = function redSqrt () {
    assert(this.red, 'redSqrt works only with red numbers');
    this.red._verify1(this);
    return this.red.sqrt(this);
  };

  BN.prototype.redInvm = function redInvm () {
    assert(this.red, 'redInvm works only with red numbers');
    this.red._verify1(this);
    return this.red.invm(this);
  };

  // Return negative clone of `this` % `red modulo`
  BN.prototype.redNeg = function redNeg () {
    assert(this.red, 'redNeg works only with red numbers');
    this.red._verify1(this);
    return this.red.neg(this);
  };

  BN.prototype.redPow = function redPow (num) {
    assert(this.red && !num.red, 'redPow(normalNum)');
    this.red._verify1(this);
    return this.red.pow(this, num);
  };

  // Prime numbers with efficient reduction
  var primes = {
    k256: null,
    p224: null,
    p192: null,
    p25519: null
  };

  // Pseudo-Mersenne prime
  function MPrime (name, p) {
    // P = 2 ^ N - K
    this.name = name;
    this.p = new BN(p, 16);
    this.n = this.p.bitLength();
    this.k = new BN(1).iushln(this.n).isub(this.p);

    this.tmp = this._tmp();
  }

  MPrime.prototype._tmp = function _tmp () {
    var tmp = new BN(null);
    tmp.words = new Array(Math.ceil(this.n / 13));
    return tmp;
  };

  MPrime.prototype.ireduce = function ireduce (num) {
    // Assumes that `num` is less than `P^2`
    // num = HI * (2 ^ N - K) + HI * K + LO = HI * K + LO (mod P)
    var r = num;
    var rlen;

    do {
      this.split(r, this.tmp);
      r = this.imulK(r);
      r = r.iadd(this.tmp);
      rlen = r.bitLength();
    } while (rlen > this.n);

    var cmp = rlen < this.n ? -1 : r.ucmp(this.p);
    if (cmp === 0) {
      r.words[0] = 0;
      r.length = 1;
    } else if (cmp > 0) {
      r.isub(this.p);
    } else {
      if (r.strip !== undefined) {
        // r is BN v4 instance
        r.strip();
      } else {
        // r is BN v5 instance
        r._strip();
      }
    }

    return r;
  };

  MPrime.prototype.split = function split (input, out) {
    input.iushrn(this.n, 0, out);
  };

  MPrime.prototype.imulK = function imulK (num) {
    return num.imul(this.k);
  };

  function K256 () {
    MPrime.call(
      this,
      'k256',
      'ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f');
  }
  inherits(K256, MPrime);

  K256.prototype.split = function split (input, output) {
    // 256 = 9 * 26 + 22
    var mask = 0x3fffff;

    var outLen = Math.min(input.length, 9);
    for (var i = 0; i < outLen; i++) {
      output.words[i] = input.words[i];
    }
    output.length = outLen;

    if (input.length <= 9) {
      input.words[0] = 0;
      input.length = 1;
      return;
    }

    // Shift by 9 limbs
    var prev = input.words[9];
    output.words[output.length++] = prev & mask;

    for (i = 10; i < input.length; i++) {
      var next = input.words[i] | 0;
      input.words[i - 10] = ((next & mask) << 4) | (prev >>> 22);
      prev = next;
    }
    prev >>>= 22;
    input.words[i - 10] = prev;
    if (prev === 0 && input.length > 10) {
      input.length -= 10;
    } else {
      input.length -= 9;
    }
  };

  K256.prototype.imulK = function imulK (num) {
    // K = 0x1000003d1 = [ 0x40, 0x3d1 ]
    num.words[num.length] = 0;
    num.words[num.length + 1] = 0;
    num.length += 2;

    // bounded at: 0x40 * 0x3ffffff + 0x3d0 = 0x100000390
    var lo = 0;
    for (var i = 0; i < num.length; i++) {
      var w = num.words[i] | 0;
      lo += w * 0x3d1;
      num.words[i] = lo & 0x3ffffff;
      lo = w * 0x40 + ((lo / 0x4000000) | 0);
    }

    // Fast length reduction
    if (num.words[num.length - 1] === 0) {
      num.length--;
      if (num.words[num.length - 1] === 0) {
        num.length--;
      }
    }
    return num;
  };

  function P224 () {
    MPrime.call(
      this,
      'p224',
      'ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001');
  }
  inherits(P224, MPrime);

  function P192 () {
    MPrime.call(
      this,
      'p192',
      'ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff');
  }
  inherits(P192, MPrime);

  function P25519 () {
    // 2 ^ 255 - 19
    MPrime.call(
      this,
      '25519',
      '7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed');
  }
  inherits(P25519, MPrime);

  P25519.prototype.imulK = function imulK (num) {
    // K = 0x13
    var carry = 0;
    for (var i = 0; i < num.length; i++) {
      var hi = (num.words[i] | 0) * 0x13 + carry;
      var lo = hi & 0x3ffffff;
      hi >>>= 26;

      num.words[i] = lo;
      carry = hi;
    }
    if (carry !== 0) {
      num.words[num.length++] = carry;
    }
    return num;
  };

  // Exported mostly for testing purposes, use plain name instead
  BN._prime = function prime (name) {
    // Cached version of prime
    if (primes[name]) return primes[name];

    var prime;
    if (name === 'k256') {
      prime = new K256();
    } else if (name === 'p224') {
      prime = new P224();
    } else if (name === 'p192') {
      prime = new P192();
    } else if (name === 'p25519') {
      prime = new P25519();
    } else {
      throw new Error('Unknown prime ' + name);
    }
    primes[name] = prime;

    return prime;
  };

  //
  // Base reduction engine
  //
  function Red (m) {
    if (typeof m === 'string') {
      var prime = BN._prime(m);
      this.m = prime.p;
      this.prime = prime;
    } else {
      assert(m.gtn(1), 'modulus must be greater than 1');
      this.m = m;
      this.prime = null;
    }
  }

  Red.prototype._verify1 = function _verify1 (a) {
    assert(a.negative === 0, 'red works only with positives');
    assert(a.red, 'red works only with red numbers');
  };

  Red.prototype._verify2 = function _verify2 (a, b) {
    assert((a.negative | b.negative) === 0, 'red works only with positives');
    assert(a.red && a.red === b.red,
      'red works only with red numbers');
  };

  Red.prototype.imod = function imod (a) {
    if (this.prime) return this.prime.ireduce(a)._forceRed(this);
    return a.umod(this.m)._forceRed(this);
  };

  Red.prototype.neg = function neg (a) {
    if (a.isZero()) {
      return a.clone();
    }

    return this.m.sub(a)._forceRed(this);
  };

  Red.prototype.add = function add (a, b) {
    this._verify2(a, b);

    var res = a.add(b);
    if (res.cmp(this.m) >= 0) {
      res.isub(this.m);
    }
    return res._forceRed(this);
  };

  Red.prototype.iadd = function iadd (a, b) {
    this._verify2(a, b);

    var res = a.iadd(b);
    if (res.cmp(this.m) >= 0) {
      res.isub(this.m);
    }
    return res;
  };

  Red.prototype.sub = function sub (a, b) {
    this._verify2(a, b);

    var res = a.sub(b);
    if (res.cmpn(0) < 0) {
      res.iadd(this.m);
    }
    return res._forceRed(this);
  };

  Red.prototype.isub = function isub (a, b) {
    this._verify2(a, b);

    var res = a.isub(b);
    if (res.cmpn(0) < 0) {
      res.iadd(this.m);
    }
    return res;
  };

  Red.prototype.shl = function shl (a, num) {
    this._verify1(a);
    return this.imod(a.ushln(num));
  };

  Red.prototype.imul = function imul (a, b) {
    this._verify2(a, b);
    return this.imod(a.imul(b));
  };

  Red.prototype.mul = function mul (a, b) {
    this._verify2(a, b);
    return this.imod(a.mul(b));
  };

  Red.prototype.isqr = function isqr (a) {
    return this.imul(a, a.clone());
  };

  Red.prototype.sqr = function sqr (a) {
    return this.mul(a, a);
  };

  Red.prototype.sqrt = function sqrt (a) {
    if (a.isZero()) return a.clone();

    var mod3 = this.m.andln(3);
    assert(mod3 % 2 === 1);

    // Fast case
    if (mod3 === 3) {
      var pow = this.m.add(new BN(1)).iushrn(2);
      return this.pow(a, pow);
    }

    // Tonelli-Shanks algorithm (Totally unoptimized and slow)
    //
    // Find Q and S, that Q * 2 ^ S = (P - 1)
    var q = this.m.subn(1);
    var s = 0;
    while (!q.isZero() && q.andln(1) === 0) {
      s++;
      q.iushrn(1);
    }
    assert(!q.isZero());

    var one = new BN(1).toRed(this);
    var nOne = one.redNeg();

    // Find quadratic non-residue
    // NOTE: Max is such because of generalized Riemann hypothesis.
    var lpow = this.m.subn(1).iushrn(1);
    var z = this.m.bitLength();
    z = new BN(2 * z * z).toRed(this);

    while (this.pow(z, lpow).cmp(nOne) !== 0) {
      z.redIAdd(nOne);
    }

    var c = this.pow(z, q);
    var r = this.pow(a, q.addn(1).iushrn(1));
    var t = this.pow(a, q);
    var m = s;
    while (t.cmp(one) !== 0) {
      var tmp = t;
      for (var i = 0; tmp.cmp(one) !== 0; i++) {
        tmp = tmp.redSqr();
      }
      assert(i < m);
      var b = this.pow(c, new BN(1).iushln(m - i - 1));

      r = r.redMul(b);
      c = b.redSqr();
      t = t.redMul(c);
      m = i;
    }

    return r;
  };

  Red.prototype.invm = function invm (a) {
    var inv = a._invmp(this.m);
    if (inv.negative !== 0) {
      inv.negative = 0;
      return this.imod(inv).redNeg();
    } else {
      return this.imod(inv);
    }
  };

  Red.prototype.pow = function pow (a, num) {
    if (num.isZero()) return new BN(1).toRed(this);
    if (num.cmpn(1) === 0) return a.clone();

    var windowSize = 4;
    var wnd = new Array(1 << windowSize);
    wnd[0] = new BN(1).toRed(this);
    wnd[1] = a;
    for (var i = 2; i < wnd.length; i++) {
      wnd[i] = this.mul(wnd[i - 1], a);
    }

    var res = wnd[0];
    var current = 0;
    var currentLen = 0;
    var start = num.bitLength() % 26;
    if (start === 0) {
      start = 26;
    }

    for (i = num.length - 1; i >= 0; i--) {
      var word = num.words[i];
      for (var j = start - 1; j >= 0; j--) {
        var bit = (word >> j) & 1;
        if (res !== wnd[0]) {
          res = this.sqr(res);
        }

        if (bit === 0 && current === 0) {
          currentLen = 0;
          continue;
        }

        current <<= 1;
        current |= bit;
        currentLen++;
        if (currentLen !== windowSize && (i !== 0 || j !== 0)) continue;

        res = this.mul(res, wnd[current]);
        currentLen = 0;
        current = 0;
      }
      start = 26;
    }

    return res;
  };

  Red.prototype.convertTo = function convertTo (num) {
    var r = num.umod(this.m);

    return r === num ? r.clone() : r;
  };

  Red.prototype.convertFrom = function convertFrom (num) {
    var res = num.clone();
    res.red = null;
    return res;
  };

  //
  // Montgomery method engine
  //

  BN.mont = function mont (num) {
    return new Mont(num);
  };

  function Mont (m) {
    Red.call(this, m);

    this.shift = this.m.bitLength();
    if (this.shift % 26 !== 0) {
      this.shift += 26 - (this.shift % 26);
    }

    this.r = new BN(1).iushln(this.shift);
    this.r2 = this.imod(this.r.sqr());
    this.rinv = this.r._invmp(this.m);

    this.minv = this.rinv.mul(this.r).isubn(1).div(this.m);
    this.minv = this.minv.umod(this.r);
    this.minv = this.r.sub(this.minv);
  }
  inherits(Mont, Red);

  Mont.prototype.convertTo = function convertTo (num) {
    return this.imod(num.ushln(this.shift));
  };

  Mont.prototype.convertFrom = function convertFrom (num) {
    var r = this.imod(num.mul(this.rinv));
    r.red = null;
    return r;
  };

  Mont.prototype.imul = function imul (a, b) {
    if (a.isZero() || b.isZero()) {
      a.words[0] = 0;
      a.length = 1;
      return a;
    }

    var t = a.imul(b);
    var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
    var u = t.isub(c).iushrn(this.shift);
    var res = u;

    if (u.cmp(this.m) >= 0) {
      res = u.isub(this.m);
    } else if (u.cmpn(0) < 0) {
      res = u.iadd(this.m);
    }

    return res._forceRed(this);
  };

  Mont.prototype.mul = function mul (a, b) {
    if (a.isZero() || b.isZero()) return new BN(0)._forceRed(this);

    var t = a.mul(b);
    var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
    var u = t.isub(c).iushrn(this.shift);
    var res = u;
    if (u.cmp(this.m) >= 0) {
      res = u.isub(this.m);
    } else if (u.cmpn(0) < 0) {
      res = u.iadd(this.m);
    }

    return res._forceRed(this);
  };

  Mont.prototype.invm = function invm (a) {
    // (AR)^-1 * R^2 = (A^-1 * R^-1) * R^2 = A^-1 * R
    var res = this.imod(a._invmp(this.m).mul(this.r2));
    return res._forceRed(this);
  };
})( false || module, this);

/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(/*! ./../../../../webpack/buildin/module.js */ "./node_modules/webpack/buildin/module.js")(module)))

/***/ }),

/***/ "./node_modules/minimalistic-assert/index.js":
/*!***************************************************!*\
  !*** ./node_modules/minimalistic-assert/index.js ***!
  \***************************************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = assert;

function assert(val, msg) {
  if (!val)
    throw new Error(msg || 'Assertion failed');
}

assert.equal = function assertEqual(l, r, msg) {
  if (l != r)
    throw new Error(msg || ('Assertion failed: ' + l + ' != ' + r));
};


/***/ }),

/***/ "./node_modules/minimalistic-crypto-utils/lib/utils.js":
/*!*************************************************************!*\
  !*** ./node_modules/minimalistic-crypto-utils/lib/utils.js ***!
  \*************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = exports;

function toArray(msg, enc) {
  if (Array.isArray(msg))
    return msg.slice();
  if (!msg)
    return [];
  var res = [];
  if (typeof msg !== 'string') {
    for (var i = 0; i < msg.length; i++)
      res[i] = msg[i] | 0;
    return res;
  }
  if (enc === 'hex') {
    msg = msg.replace(/[^a-z0-9]+/ig, '');
    if (msg.length % 2 !== 0)
      msg = '0' + msg;
    for (var i = 0; i < msg.length; i += 2)
      res.push(parseInt(msg[i] + msg[i + 1], 16));
  } else {
    for (var i = 0; i < msg.length; i++) {
      var c = msg.charCodeAt(i);
      var hi = c >> 8;
      var lo = c & 0xff;
      if (hi)
        res.push(hi, lo);
      else
        res.push(lo);
    }
  }
  return res;
}
utils.toArray = toArray;

function zero2(word) {
  if (word.length === 1)
    return '0' + word;
  else
    return word;
}
utils.zero2 = zero2;

function toHex(msg) {
  var res = '';
  for (var i = 0; i < msg.length; i++)
    res += zero2(msg[i].toString(16));
  return res;
}
utils.toHex = toHex;

utils.encode = function encode(arr, enc) {
  if (enc === 'hex')
    return toHex(arr);
  else
    return arr;
};


/***/ }),

/***/ "./node_modules/node-libs-browser/mock/empty.js":
/*!******************************************************!*\
  !*** ./node_modules/node-libs-browser/mock/empty.js ***!
  \******************************************************/
/*! no static exports found */
/***/ (function(module, exports) {



/***/ }),

/***/ "./node_modules/node-libs-browser/node_modules/buffer/index.js":
/*!*********************************************************************!*\
  !*** ./node_modules/node-libs-browser/node_modules/buffer/index.js ***!
  \*********************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <http://feross.org>
 * @license  MIT
 */
/* eslint-disable no-proto */



var base64 = __webpack_require__(/*! base64-js */ "./node_modules/base64-js/index.js")
var ieee754 = __webpack_require__(/*! ieee754 */ "./node_modules/ieee754/index.js")
var isArray = __webpack_require__(/*! isarray */ "./node_modules/isarray/index.js")

exports.Buffer = Buffer
exports.SlowBuffer = SlowBuffer
exports.INSPECT_MAX_BYTES = 50

/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Use Object implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * Due to various browser bugs, sometimes the Object implementation will be used even
 * when the browser supports typed arrays.
 *
 * Note:
 *
 *   - Firefox 4-29 lacks support for adding new properties to `Uint8Array` instances,
 *     See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438.
 *
 *   - Chrome 9-10 is missing the `TypedArray.prototype.subarray` function.
 *
 *   - IE10 has a broken `TypedArray.prototype.subarray` function which returns arrays of
 *     incorrect length in some situations.

 * We detect these buggy browsers and set `Buffer.TYPED_ARRAY_SUPPORT` to `false` so they
 * get the Object implementation, which is slower but behaves correctly.
 */
Buffer.TYPED_ARRAY_SUPPORT = global.TYPED_ARRAY_SUPPORT !== undefined
  ? global.TYPED_ARRAY_SUPPORT
  : typedArraySupport()

/*
 * Export kMaxLength after typed array support is determined.
 */
exports.kMaxLength = kMaxLength()

function typedArraySupport () {
  try {
    var arr = new Uint8Array(1)
    arr.__proto__ = {__proto__: Uint8Array.prototype, foo: function () { return 42 }}
    return arr.foo() === 42 && // typed array instances can be augmented
        typeof arr.subarray === 'function' && // chrome 9-10 lack `subarray`
        arr.subarray(1, 1).byteLength === 0 // ie10 has broken `subarray`
  } catch (e) {
    return false
  }
}

function kMaxLength () {
  return Buffer.TYPED_ARRAY_SUPPORT
    ? 0x7fffffff
    : 0x3fffffff
}

function createBuffer (that, length) {
  if (kMaxLength() < length) {
    throw new RangeError('Invalid typed array length')
  }
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    // Return an augmented `Uint8Array` instance, for best performance
    that = new Uint8Array(length)
    that.__proto__ = Buffer.prototype
  } else {
    // Fallback: Return an object instance of the Buffer class
    if (that === null) {
      that = new Buffer(length)
    }
    that.length = length
  }

  return that
}

/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */

function Buffer (arg, encodingOrOffset, length) {
  if (!Buffer.TYPED_ARRAY_SUPPORT && !(this instanceof Buffer)) {
    return new Buffer(arg, encodingOrOffset, length)
  }

  // Common case.
  if (typeof arg === 'number') {
    if (typeof encodingOrOffset === 'string') {
      throw new Error(
        'If encoding is specified then the first argument must be a string'
      )
    }
    return allocUnsafe(this, arg)
  }
  return from(this, arg, encodingOrOffset, length)
}

Buffer.poolSize = 8192 // not used by this implementation

// TODO: Legacy, not needed anymore. Remove in next major version.
Buffer._augment = function (arr) {
  arr.__proto__ = Buffer.prototype
  return arr
}

function from (that, value, encodingOrOffset, length) {
  if (typeof value === 'number') {
    throw new TypeError('"value" argument must not be a number')
  }

  if (typeof ArrayBuffer !== 'undefined' && value instanceof ArrayBuffer) {
    return fromArrayBuffer(that, value, encodingOrOffset, length)
  }

  if (typeof value === 'string') {
    return fromString(that, value, encodingOrOffset)
  }

  return fromObject(that, value)
}

/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/
Buffer.from = function (value, encodingOrOffset, length) {
  return from(null, value, encodingOrOffset, length)
}

if (Buffer.TYPED_ARRAY_SUPPORT) {
  Buffer.prototype.__proto__ = Uint8Array.prototype
  Buffer.__proto__ = Uint8Array
  if (typeof Symbol !== 'undefined' && Symbol.species &&
      Buffer[Symbol.species] === Buffer) {
    // Fix subarray() in ES2016. See: https://github.com/feross/buffer/pull/97
    Object.defineProperty(Buffer, Symbol.species, {
      value: null,
      configurable: true
    })
  }
}

function assertSize (size) {
  if (typeof size !== 'number') {
    throw new TypeError('"size" argument must be a number')
  } else if (size < 0) {
    throw new RangeError('"size" argument must not be negative')
  }
}

function alloc (that, size, fill, encoding) {
  assertSize(size)
  if (size <= 0) {
    return createBuffer(that, size)
  }
  if (fill !== undefined) {
    // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpretted as a start offset.
    return typeof encoding === 'string'
      ? createBuffer(that, size).fill(fill, encoding)
      : createBuffer(that, size).fill(fill)
  }
  return createBuffer(that, size)
}

/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/
Buffer.alloc = function (size, fill, encoding) {
  return alloc(null, size, fill, encoding)
}

function allocUnsafe (that, size) {
  assertSize(size)
  that = createBuffer(that, size < 0 ? 0 : checked(size) | 0)
  if (!Buffer.TYPED_ARRAY_SUPPORT) {
    for (var i = 0; i < size; ++i) {
      that[i] = 0
    }
  }
  return that
}

/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */
Buffer.allocUnsafe = function (size) {
  return allocUnsafe(null, size)
}
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */
Buffer.allocUnsafeSlow = function (size) {
  return allocUnsafe(null, size)
}

function fromString (that, string, encoding) {
  if (typeof encoding !== 'string' || encoding === '') {
    encoding = 'utf8'
  }

  if (!Buffer.isEncoding(encoding)) {
    throw new TypeError('"encoding" must be a valid string encoding')
  }

  var length = byteLength(string, encoding) | 0
  that = createBuffer(that, length)

  var actual = that.write(string, encoding)

  if (actual !== length) {
    // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    that = that.slice(0, actual)
  }

  return that
}

function fromArrayLike (that, array) {
  var length = array.length < 0 ? 0 : checked(array.length) | 0
  that = createBuffer(that, length)
  for (var i = 0; i < length; i += 1) {
    that[i] = array[i] & 255
  }
  return that
}

function fromArrayBuffer (that, array, byteOffset, length) {
  array.byteLength // this throws if `array` is not a valid ArrayBuffer

  if (byteOffset < 0 || array.byteLength < byteOffset) {
    throw new RangeError('\'offset\' is out of bounds')
  }

  if (array.byteLength < byteOffset + (length || 0)) {
    throw new RangeError('\'length\' is out of bounds')
  }

  if (byteOffset === undefined && length === undefined) {
    array = new Uint8Array(array)
  } else if (length === undefined) {
    array = new Uint8Array(array, byteOffset)
  } else {
    array = new Uint8Array(array, byteOffset, length)
  }

  if (Buffer.TYPED_ARRAY_SUPPORT) {
    // Return an augmented `Uint8Array` instance, for best performance
    that = array
    that.__proto__ = Buffer.prototype
  } else {
    // Fallback: Return an object instance of the Buffer class
    that = fromArrayLike(that, array)
  }
  return that
}

function fromObject (that, obj) {
  if (Buffer.isBuffer(obj)) {
    var len = checked(obj.length) | 0
    that = createBuffer(that, len)

    if (that.length === 0) {
      return that
    }

    obj.copy(that, 0, 0, len)
    return that
  }

  if (obj) {
    if ((typeof ArrayBuffer !== 'undefined' &&
        obj.buffer instanceof ArrayBuffer) || 'length' in obj) {
      if (typeof obj.length !== 'number' || isnan(obj.length)) {
        return createBuffer(that, 0)
      }
      return fromArrayLike(that, obj)
    }

    if (obj.type === 'Buffer' && isArray(obj.data)) {
      return fromArrayLike(that, obj.data)
    }
  }

  throw new TypeError('First argument must be a string, Buffer, ArrayBuffer, Array, or array-like object.')
}

function checked (length) {
  // Note: cannot use `length < kMaxLength()` here because that fails when
  // length is NaN (which is otherwise coerced to zero.)
  if (length >= kMaxLength()) {
    throw new RangeError('Attempt to allocate Buffer larger than maximum ' +
                         'size: 0x' + kMaxLength().toString(16) + ' bytes')
  }
  return length | 0
}

function SlowBuffer (length) {
  if (+length != length) { // eslint-disable-line eqeqeq
    length = 0
  }
  return Buffer.alloc(+length)
}

Buffer.isBuffer = function isBuffer (b) {
  return !!(b != null && b._isBuffer)
}

Buffer.compare = function compare (a, b) {
  if (!Buffer.isBuffer(a) || !Buffer.isBuffer(b)) {
    throw new TypeError('Arguments must be Buffers')
  }

  if (a === b) return 0

  var x = a.length
  var y = b.length

  for (var i = 0, len = Math.min(x, y); i < len; ++i) {
    if (a[i] !== b[i]) {
      x = a[i]
      y = b[i]
      break
    }
  }

  if (x < y) return -1
  if (y < x) return 1
  return 0
}

Buffer.isEncoding = function isEncoding (encoding) {
  switch (String(encoding).toLowerCase()) {
    case 'hex':
    case 'utf8':
    case 'utf-8':
    case 'ascii':
    case 'latin1':
    case 'binary':
    case 'base64':
    case 'ucs2':
    case 'ucs-2':
    case 'utf16le':
    case 'utf-16le':
      return true
    default:
      return false
  }
}

Buffer.concat = function concat (list, length) {
  if (!isArray(list)) {
    throw new TypeError('"list" argument must be an Array of Buffers')
  }

  if (list.length === 0) {
    return Buffer.alloc(0)
  }

  var i
  if (length === undefined) {
    length = 0
    for (i = 0; i < list.length; ++i) {
      length += list[i].length
    }
  }

  var buffer = Buffer.allocUnsafe(length)
  var pos = 0
  for (i = 0; i < list.length; ++i) {
    var buf = list[i]
    if (!Buffer.isBuffer(buf)) {
      throw new TypeError('"list" argument must be an Array of Buffers')
    }
    buf.copy(buffer, pos)
    pos += buf.length
  }
  return buffer
}

function byteLength (string, encoding) {
  if (Buffer.isBuffer(string)) {
    return string.length
  }
  if (typeof ArrayBuffer !== 'undefined' && typeof ArrayBuffer.isView === 'function' &&
      (ArrayBuffer.isView(string) || string instanceof ArrayBuffer)) {
    return string.byteLength
  }
  if (typeof string !== 'string') {
    string = '' + string
  }

  var len = string.length
  if (len === 0) return 0

  // Use a for loop to avoid recursion
  var loweredCase = false
  for (;;) {
    switch (encoding) {
      case 'ascii':
      case 'latin1':
      case 'binary':
        return len
      case 'utf8':
      case 'utf-8':
      case undefined:
        return utf8ToBytes(string).length
      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return len * 2
      case 'hex':
        return len >>> 1
      case 'base64':
        return base64ToBytes(string).length
      default:
        if (loweredCase) return utf8ToBytes(string).length // assume utf8
        encoding = ('' + encoding).toLowerCase()
        loweredCase = true
    }
  }
}
Buffer.byteLength = byteLength

function slowToString (encoding, start, end) {
  var loweredCase = false

  // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
  // property of a typed array.

  // This behaves neither like String nor Uint8Array in that we set start/end
  // to their upper/lower bounds if the value passed is out of range.
  // undefined is handled specially as per ECMA-262 6th Edition,
  // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
  if (start === undefined || start < 0) {
    start = 0
  }
  // Return early if start > this.length. Done here to prevent potential uint32
  // coercion fail below.
  if (start > this.length) {
    return ''
  }

  if (end === undefined || end > this.length) {
    end = this.length
  }

  if (end <= 0) {
    return ''
  }

  // Force coersion to uint32. This will also coerce falsey/NaN values to 0.
  end >>>= 0
  start >>>= 0

  if (end <= start) {
    return ''
  }

  if (!encoding) encoding = 'utf8'

  while (true) {
    switch (encoding) {
      case 'hex':
        return hexSlice(this, start, end)

      case 'utf8':
      case 'utf-8':
        return utf8Slice(this, start, end)

      case 'ascii':
        return asciiSlice(this, start, end)

      case 'latin1':
      case 'binary':
        return latin1Slice(this, start, end)

      case 'base64':
        return base64Slice(this, start, end)

      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return utf16leSlice(this, start, end)

      default:
        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
        encoding = (encoding + '').toLowerCase()
        loweredCase = true
    }
  }
}

// The property is used by `Buffer.isBuffer` and `is-buffer` (in Safari 5-7) to detect
// Buffer instances.
Buffer.prototype._isBuffer = true

function swap (b, n, m) {
  var i = b[n]
  b[n] = b[m]
  b[m] = i
}

Buffer.prototype.swap16 = function swap16 () {
  var len = this.length
  if (len % 2 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 16-bits')
  }
  for (var i = 0; i < len; i += 2) {
    swap(this, i, i + 1)
  }
  return this
}

Buffer.prototype.swap32 = function swap32 () {
  var len = this.length
  if (len % 4 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 32-bits')
  }
  for (var i = 0; i < len; i += 4) {
    swap(this, i, i + 3)
    swap(this, i + 1, i + 2)
  }
  return this
}

Buffer.prototype.swap64 = function swap64 () {
  var len = this.length
  if (len % 8 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 64-bits')
  }
  for (var i = 0; i < len; i += 8) {
    swap(this, i, i + 7)
    swap(this, i + 1, i + 6)
    swap(this, i + 2, i + 5)
    swap(this, i + 3, i + 4)
  }
  return this
}

Buffer.prototype.toString = function toString () {
  var length = this.length | 0
  if (length === 0) return ''
  if (arguments.length === 0) return utf8Slice(this, 0, length)
  return slowToString.apply(this, arguments)
}

Buffer.prototype.equals = function equals (b) {
  if (!Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer')
  if (this === b) return true
  return Buffer.compare(this, b) === 0
}

Buffer.prototype.inspect = function inspect () {
  var str = ''
  var max = exports.INSPECT_MAX_BYTES
  if (this.length > 0) {
    str = this.toString('hex', 0, max).match(/.{2}/g).join(' ')
    if (this.length > max) str += ' ... '
  }
  return '<Buffer ' + str + '>'
}

Buffer.prototype.compare = function compare (target, start, end, thisStart, thisEnd) {
  if (!Buffer.isBuffer(target)) {
    throw new TypeError('Argument must be a Buffer')
  }

  if (start === undefined) {
    start = 0
  }
  if (end === undefined) {
    end = target ? target.length : 0
  }
  if (thisStart === undefined) {
    thisStart = 0
  }
  if (thisEnd === undefined) {
    thisEnd = this.length
  }

  if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) {
    throw new RangeError('out of range index')
  }

  if (thisStart >= thisEnd && start >= end) {
    return 0
  }
  if (thisStart >= thisEnd) {
    return -1
  }
  if (start >= end) {
    return 1
  }

  start >>>= 0
  end >>>= 0
  thisStart >>>= 0
  thisEnd >>>= 0

  if (this === target) return 0

  var x = thisEnd - thisStart
  var y = end - start
  var len = Math.min(x, y)

  var thisCopy = this.slice(thisStart, thisEnd)
  var targetCopy = target.slice(start, end)

  for (var i = 0; i < len; ++i) {
    if (thisCopy[i] !== targetCopy[i]) {
      x = thisCopy[i]
      y = targetCopy[i]
      break
    }
  }

  if (x < y) return -1
  if (y < x) return 1
  return 0
}

// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function bidirectionalIndexOf (buffer, val, byteOffset, encoding, dir) {
  // Empty buffer means no match
  if (buffer.length === 0) return -1

  // Normalize byteOffset
  if (typeof byteOffset === 'string') {
    encoding = byteOffset
    byteOffset = 0
  } else if (byteOffset > 0x7fffffff) {
    byteOffset = 0x7fffffff
  } else if (byteOffset < -0x80000000) {
    byteOffset = -0x80000000
  }
  byteOffset = +byteOffset  // Coerce to Number.
  if (isNaN(byteOffset)) {
    // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : (buffer.length - 1)
  }

  // Normalize byteOffset: negative offsets start from the end of the buffer
  if (byteOffset < 0) byteOffset = buffer.length + byteOffset
  if (byteOffset >= buffer.length) {
    if (dir) return -1
    else byteOffset = buffer.length - 1
  } else if (byteOffset < 0) {
    if (dir) byteOffset = 0
    else return -1
  }

  // Normalize val
  if (typeof val === 'string') {
    val = Buffer.from(val, encoding)
  }

  // Finally, search either indexOf (if dir is true) or lastIndexOf
  if (Buffer.isBuffer(val)) {
    // Special case: looking for empty string/buffer always fails
    if (val.length === 0) {
      return -1
    }
    return arrayIndexOf(buffer, val, byteOffset, encoding, dir)
  } else if (typeof val === 'number') {
    val = val & 0xFF // Search for a byte value [0-255]
    if (Buffer.TYPED_ARRAY_SUPPORT &&
        typeof Uint8Array.prototype.indexOf === 'function') {
      if (dir) {
        return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset)
      } else {
        return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset)
      }
    }
    return arrayIndexOf(buffer, [ val ], byteOffset, encoding, dir)
  }

  throw new TypeError('val must be string, number or Buffer')
}

function arrayIndexOf (arr, val, byteOffset, encoding, dir) {
  var indexSize = 1
  var arrLength = arr.length
  var valLength = val.length

  if (encoding !== undefined) {
    encoding = String(encoding).toLowerCase()
    if (encoding === 'ucs2' || encoding === 'ucs-2' ||
        encoding === 'utf16le' || encoding === 'utf-16le') {
      if (arr.length < 2 || val.length < 2) {
        return -1
      }
      indexSize = 2
      arrLength /= 2
      valLength /= 2
      byteOffset /= 2
    }
  }

  function read (buf, i) {
    if (indexSize === 1) {
      return buf[i]
    } else {
      return buf.readUInt16BE(i * indexSize)
    }
  }

  var i
  if (dir) {
    var foundIndex = -1
    for (i = byteOffset; i < arrLength; i++) {
      if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
        if (foundIndex === -1) foundIndex = i
        if (i - foundIndex + 1 === valLength) return foundIndex * indexSize
      } else {
        if (foundIndex !== -1) i -= i - foundIndex
        foundIndex = -1
      }
    }
  } else {
    if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength
    for (i = byteOffset; i >= 0; i--) {
      var found = true
      for (var j = 0; j < valLength; j++) {
        if (read(arr, i + j) !== read(val, j)) {
          found = false
          break
        }
      }
      if (found) return i
    }
  }

  return -1
}

Buffer.prototype.includes = function includes (val, byteOffset, encoding) {
  return this.indexOf(val, byteOffset, encoding) !== -1
}

Buffer.prototype.indexOf = function indexOf (val, byteOffset, encoding) {
  return bidirectionalIndexOf(this, val, byteOffset, encoding, true)
}

Buffer.prototype.lastIndexOf = function lastIndexOf (val, byteOffset, encoding) {
  return bidirectionalIndexOf(this, val, byteOffset, encoding, false)
}

function hexWrite (buf, string, offset, length) {
  offset = Number(offset) || 0
  var remaining = buf.length - offset
  if (!length) {
    length = remaining
  } else {
    length = Number(length)
    if (length > remaining) {
      length = remaining
    }
  }

  // must be an even number of digits
  var strLen = string.length
  if (strLen % 2 !== 0) throw new TypeError('Invalid hex string')

  if (length > strLen / 2) {
    length = strLen / 2
  }
  for (var i = 0; i < length; ++i) {
    var parsed = parseInt(string.substr(i * 2, 2), 16)
    if (isNaN(parsed)) return i
    buf[offset + i] = parsed
  }
  return i
}

function utf8Write (buf, string, offset, length) {
  return blitBuffer(utf8ToBytes(string, buf.length - offset), buf, offset, length)
}

function asciiWrite (buf, string, offset, length) {
  return blitBuffer(asciiToBytes(string), buf, offset, length)
}

function latin1Write (buf, string, offset, length) {
  return asciiWrite(buf, string, offset, length)
}

function base64Write (buf, string, offset, length) {
  return blitBuffer(base64ToBytes(string), buf, offset, length)
}

function ucs2Write (buf, string, offset, length) {
  return blitBuffer(utf16leToBytes(string, buf.length - offset), buf, offset, length)
}

Buffer.prototype.write = function write (string, offset, length, encoding) {
  // Buffer#write(string)
  if (offset === undefined) {
    encoding = 'utf8'
    length = this.length
    offset = 0
  // Buffer#write(string, encoding)
  } else if (length === undefined && typeof offset === 'string') {
    encoding = offset
    length = this.length
    offset = 0
  // Buffer#write(string, offset[, length][, encoding])
  } else if (isFinite(offset)) {
    offset = offset | 0
    if (isFinite(length)) {
      length = length | 0
      if (encoding === undefined) encoding = 'utf8'
    } else {
      encoding = length
      length = undefined
    }
  // legacy write(string, encoding, offset, length) - remove in v0.13
  } else {
    throw new Error(
      'Buffer.write(string, encoding, offset[, length]) is no longer supported'
    )
  }

  var remaining = this.length - offset
  if (length === undefined || length > remaining) length = remaining

  if ((string.length > 0 && (length < 0 || offset < 0)) || offset > this.length) {
    throw new RangeError('Attempt to write outside buffer bounds')
  }

  if (!encoding) encoding = 'utf8'

  var loweredCase = false
  for (;;) {
    switch (encoding) {
      case 'hex':
        return hexWrite(this, string, offset, length)

      case 'utf8':
      case 'utf-8':
        return utf8Write(this, string, offset, length)

      case 'ascii':
        return asciiWrite(this, string, offset, length)

      case 'latin1':
      case 'binary':
        return latin1Write(this, string, offset, length)

      case 'base64':
        // Warning: maxLength not taken into account in base64Write
        return base64Write(this, string, offset, length)

      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return ucs2Write(this, string, offset, length)

      default:
        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
        encoding = ('' + encoding).toLowerCase()
        loweredCase = true
    }
  }
}

Buffer.prototype.toJSON = function toJSON () {
  return {
    type: 'Buffer',
    data: Array.prototype.slice.call(this._arr || this, 0)
  }
}

function base64Slice (buf, start, end) {
  if (start === 0 && end === buf.length) {
    return base64.fromByteArray(buf)
  } else {
    return base64.fromByteArray(buf.slice(start, end))
  }
}

function utf8Slice (buf, start, end) {
  end = Math.min(buf.length, end)
  var res = []

  var i = start
  while (i < end) {
    var firstByte = buf[i]
    var codePoint = null
    var bytesPerSequence = (firstByte > 0xEF) ? 4
      : (firstByte > 0xDF) ? 3
      : (firstByte > 0xBF) ? 2
      : 1

    if (i + bytesPerSequence <= end) {
      var secondByte, thirdByte, fourthByte, tempCodePoint

      switch (bytesPerSequence) {
        case 1:
          if (firstByte < 0x80) {
            codePoint = firstByte
          }
          break
        case 2:
          secondByte = buf[i + 1]
          if ((secondByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0x1F) << 0x6 | (secondByte & 0x3F)
            if (tempCodePoint > 0x7F) {
              codePoint = tempCodePoint
            }
          }
          break
        case 3:
          secondByte = buf[i + 1]
          thirdByte = buf[i + 2]
          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | (thirdByte & 0x3F)
            if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) {
              codePoint = tempCodePoint
            }
          }
          break
        case 4:
          secondByte = buf[i + 1]
          thirdByte = buf[i + 2]
          fourthByte = buf[i + 3]
          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | (fourthByte & 0x3F)
            if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) {
              codePoint = tempCodePoint
            }
          }
      }
    }

    if (codePoint === null) {
      // we did not generate a valid codePoint so insert a
      // replacement char (U+FFFD) and advance only 1 byte
      codePoint = 0xFFFD
      bytesPerSequence = 1
    } else if (codePoint > 0xFFFF) {
      // encode to utf16 (surrogate pair dance)
      codePoint -= 0x10000
      res.push(codePoint >>> 10 & 0x3FF | 0xD800)
      codePoint = 0xDC00 | codePoint & 0x3FF
    }

    res.push(codePoint)
    i += bytesPerSequence
  }

  return decodeCodePointsArray(res)
}

// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
var MAX_ARGUMENTS_LENGTH = 0x1000

function decodeCodePointsArray (codePoints) {
  var len = codePoints.length
  if (len <= MAX_ARGUMENTS_LENGTH) {
    return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
  }

  // Decode in chunks to avoid "call stack size exceeded".
  var res = ''
  var i = 0
  while (i < len) {
    res += String.fromCharCode.apply(
      String,
      codePoints.slice(i, i += MAX_ARGUMENTS_LENGTH)
    )
  }
  return res
}

function asciiSlice (buf, start, end) {
  var ret = ''
  end = Math.min(buf.length, end)

  for (var i = start; i < end; ++i) {
    ret += String.fromCharCode(buf[i] & 0x7F)
  }
  return ret
}

function latin1Slice (buf, start, end) {
  var ret = ''
  end = Math.min(buf.length, end)

  for (var i = start; i < end; ++i) {
    ret += String.fromCharCode(buf[i])
  }
  return ret
}

function hexSlice (buf, start, end) {
  var len = buf.length

  if (!start || start < 0) start = 0
  if (!end || end < 0 || end > len) end = len

  var out = ''
  for (var i = start; i < end; ++i) {
    out += toHex(buf[i])
  }
  return out
}

function utf16leSlice (buf, start, end) {
  var bytes = buf.slice(start, end)
  var res = ''
  for (var i = 0; i < bytes.length; i += 2) {
    res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256)
  }
  return res
}

Buffer.prototype.slice = function slice (start, end) {
  var len = this.length
  start = ~~start
  end = end === undefined ? len : ~~end

  if (start < 0) {
    start += len
    if (start < 0) start = 0
  } else if (start > len) {
    start = len
  }

  if (end < 0) {
    end += len
    if (end < 0) end = 0
  } else if (end > len) {
    end = len
  }

  if (end < start) end = start

  var newBuf
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    newBuf = this.subarray(start, end)
    newBuf.__proto__ = Buffer.prototype
  } else {
    var sliceLen = end - start
    newBuf = new Buffer(sliceLen, undefined)
    for (var i = 0; i < sliceLen; ++i) {
      newBuf[i] = this[i + start]
    }
  }

  return newBuf
}

/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */
function checkOffset (offset, ext, length) {
  if ((offset % 1) !== 0 || offset < 0) throw new RangeError('offset is not uint')
  if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length')
}

Buffer.prototype.readUIntLE = function readUIntLE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var val = this[offset]
  var mul = 1
  var i = 0
  while (++i < byteLength && (mul *= 0x100)) {
    val += this[offset + i] * mul
  }

  return val
}

Buffer.prototype.readUIntBE = function readUIntBE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) {
    checkOffset(offset, byteLength, this.length)
  }

  var val = this[offset + --byteLength]
  var mul = 1
  while (byteLength > 0 && (mul *= 0x100)) {
    val += this[offset + --byteLength] * mul
  }

  return val
}

Buffer.prototype.readUInt8 = function readUInt8 (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 1, this.length)
  return this[offset]
}

Buffer.prototype.readUInt16LE = function readUInt16LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  return this[offset] | (this[offset + 1] << 8)
}

Buffer.prototype.readUInt16BE = function readUInt16BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  return (this[offset] << 8) | this[offset + 1]
}

Buffer.prototype.readUInt32LE = function readUInt32LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return ((this[offset]) |
      (this[offset + 1] << 8) |
      (this[offset + 2] << 16)) +
      (this[offset + 3] * 0x1000000)
}

Buffer.prototype.readUInt32BE = function readUInt32BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset] * 0x1000000) +
    ((this[offset + 1] << 16) |
    (this[offset + 2] << 8) |
    this[offset + 3])
}

Buffer.prototype.readIntLE = function readIntLE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var val = this[offset]
  var mul = 1
  var i = 0
  while (++i < byteLength && (mul *= 0x100)) {
    val += this[offset + i] * mul
  }
  mul *= 0x80

  if (val >= mul) val -= Math.pow(2, 8 * byteLength)

  return val
}

Buffer.prototype.readIntBE = function readIntBE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var i = byteLength
  var mul = 1
  var val = this[offset + --i]
  while (i > 0 && (mul *= 0x100)) {
    val += this[offset + --i] * mul
  }
  mul *= 0x80

  if (val >= mul) val -= Math.pow(2, 8 * byteLength)

  return val
}

Buffer.prototype.readInt8 = function readInt8 (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 1, this.length)
  if (!(this[offset] & 0x80)) return (this[offset])
  return ((0xff - this[offset] + 1) * -1)
}

Buffer.prototype.readInt16LE = function readInt16LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  var val = this[offset] | (this[offset + 1] << 8)
  return (val & 0x8000) ? val | 0xFFFF0000 : val
}

Buffer.prototype.readInt16BE = function readInt16BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  var val = this[offset + 1] | (this[offset] << 8)
  return (val & 0x8000) ? val | 0xFFFF0000 : val
}

Buffer.prototype.readInt32LE = function readInt32LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset]) |
    (this[offset + 1] << 8) |
    (this[offset + 2] << 16) |
    (this[offset + 3] << 24)
}

Buffer.prototype.readInt32BE = function readInt32BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset] << 24) |
    (this[offset + 1] << 16) |
    (this[offset + 2] << 8) |
    (this[offset + 3])
}

Buffer.prototype.readFloatLE = function readFloatLE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)
  return ieee754.read(this, offset, true, 23, 4)
}

Buffer.prototype.readFloatBE = function readFloatBE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)
  return ieee754.read(this, offset, false, 23, 4)
}

Buffer.prototype.readDoubleLE = function readDoubleLE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 8, this.length)
  return ieee754.read(this, offset, true, 52, 8)
}

Buffer.prototype.readDoubleBE = function readDoubleBE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 8, this.length)
  return ieee754.read(this, offset, false, 52, 8)
}

function checkInt (buf, value, offset, ext, max, min) {
  if (!Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance')
  if (value > max || value < min) throw new RangeError('"value" argument is out of bounds')
  if (offset + ext > buf.length) throw new RangeError('Index out of range')
}

Buffer.prototype.writeUIntLE = function writeUIntLE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) {
    var maxBytes = Math.pow(2, 8 * byteLength) - 1
    checkInt(this, value, offset, byteLength, maxBytes, 0)
  }

  var mul = 1
  var i = 0
  this[offset] = value & 0xFF
  while (++i < byteLength && (mul *= 0x100)) {
    this[offset + i] = (value / mul) & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeUIntBE = function writeUIntBE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) {
    var maxBytes = Math.pow(2, 8 * byteLength) - 1
    checkInt(this, value, offset, byteLength, maxBytes, 0)
  }

  var i = byteLength - 1
  var mul = 1
  this[offset + i] = value & 0xFF
  while (--i >= 0 && (mul *= 0x100)) {
    this[offset + i] = (value / mul) & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeUInt8 = function writeUInt8 (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 1, 0xff, 0)
  if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value)
  this[offset] = (value & 0xff)
  return offset + 1
}

function objectWriteUInt16 (buf, value, offset, littleEndian) {
  if (value < 0) value = 0xffff + value + 1
  for (var i = 0, j = Math.min(buf.length - offset, 2); i < j; ++i) {
    buf[offset + i] = (value & (0xff << (8 * (littleEndian ? i : 1 - i)))) >>>
      (littleEndian ? i : 1 - i) * 8
  }
}

Buffer.prototype.writeUInt16LE = function writeUInt16LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value & 0xff)
    this[offset + 1] = (value >>> 8)
  } else {
    objectWriteUInt16(this, value, offset, true)
  }
  return offset + 2
}

Buffer.prototype.writeUInt16BE = function writeUInt16BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 8)
    this[offset + 1] = (value & 0xff)
  } else {
    objectWriteUInt16(this, value, offset, false)
  }
  return offset + 2
}

function objectWriteUInt32 (buf, value, offset, littleEndian) {
  if (value < 0) value = 0xffffffff + value + 1
  for (var i = 0, j = Math.min(buf.length - offset, 4); i < j; ++i) {
    buf[offset + i] = (value >>> (littleEndian ? i : 3 - i) * 8) & 0xff
  }
}

Buffer.prototype.writeUInt32LE = function writeUInt32LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset + 3] = (value >>> 24)
    this[offset + 2] = (value >>> 16)
    this[offset + 1] = (value >>> 8)
    this[offset] = (value & 0xff)
  } else {
    objectWriteUInt32(this, value, offset, true)
  }
  return offset + 4
}

Buffer.prototype.writeUInt32BE = function writeUInt32BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 24)
    this[offset + 1] = (value >>> 16)
    this[offset + 2] = (value >>> 8)
    this[offset + 3] = (value & 0xff)
  } else {
    objectWriteUInt32(this, value, offset, false)
  }
  return offset + 4
}

Buffer.prototype.writeIntLE = function writeIntLE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) {
    var limit = Math.pow(2, 8 * byteLength - 1)

    checkInt(this, value, offset, byteLength, limit - 1, -limit)
  }

  var i = 0
  var mul = 1
  var sub = 0
  this[offset] = value & 0xFF
  while (++i < byteLength && (mul *= 0x100)) {
    if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) {
      sub = 1
    }
    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeIntBE = function writeIntBE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) {
    var limit = Math.pow(2, 8 * byteLength - 1)

    checkInt(this, value, offset, byteLength, limit - 1, -limit)
  }

  var i = byteLength - 1
  var mul = 1
  var sub = 0
  this[offset + i] = value & 0xFF
  while (--i >= 0 && (mul *= 0x100)) {
    if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) {
      sub = 1
    }
    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeInt8 = function writeInt8 (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 1, 0x7f, -0x80)
  if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value)
  if (value < 0) value = 0xff + value + 1
  this[offset] = (value & 0xff)
  return offset + 1
}

Buffer.prototype.writeInt16LE = function writeInt16LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value & 0xff)
    this[offset + 1] = (value >>> 8)
  } else {
    objectWriteUInt16(this, value, offset, true)
  }
  return offset + 2
}

Buffer.prototype.writeInt16BE = function writeInt16BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 8)
    this[offset + 1] = (value & 0xff)
  } else {
    objectWriteUInt16(this, value, offset, false)
  }
  return offset + 2
}

Buffer.prototype.writeInt32LE = function writeInt32LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value & 0xff)
    this[offset + 1] = (value >>> 8)
    this[offset + 2] = (value >>> 16)
    this[offset + 3] = (value >>> 24)
  } else {
    objectWriteUInt32(this, value, offset, true)
  }
  return offset + 4
}

Buffer.prototype.writeInt32BE = function writeInt32BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
  if (value < 0) value = 0xffffffff + value + 1
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 24)
    this[offset + 1] = (value >>> 16)
    this[offset + 2] = (value >>> 8)
    this[offset + 3] = (value & 0xff)
  } else {
    objectWriteUInt32(this, value, offset, false)
  }
  return offset + 4
}

function checkIEEE754 (buf, value, offset, ext, max, min) {
  if (offset + ext > buf.length) throw new RangeError('Index out of range')
  if (offset < 0) throw new RangeError('Index out of range')
}

function writeFloat (buf, value, offset, littleEndian, noAssert) {
  if (!noAssert) {
    checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -3.4028234663852886e+38)
  }
  ieee754.write(buf, value, offset, littleEndian, 23, 4)
  return offset + 4
}

Buffer.prototype.writeFloatLE = function writeFloatLE (value, offset, noAssert) {
  return writeFloat(this, value, offset, true, noAssert)
}

Buffer.prototype.writeFloatBE = function writeFloatBE (value, offset, noAssert) {
  return writeFloat(this, value, offset, false, noAssert)
}

function writeDouble (buf, value, offset, littleEndian, noAssert) {
  if (!noAssert) {
    checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -1.7976931348623157E+308)
  }
  ieee754.write(buf, value, offset, littleEndian, 52, 8)
  return offset + 8
}

Buffer.prototype.writeDoubleLE = function writeDoubleLE (value, offset, noAssert) {
  return writeDouble(this, value, offset, true, noAssert)
}

Buffer.prototype.writeDoubleBE = function writeDoubleBE (value, offset, noAssert) {
  return writeDouble(this, value, offset, false, noAssert)
}

// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
Buffer.prototype.copy = function copy (target, targetStart, start, end) {
  if (!start) start = 0
  if (!end && end !== 0) end = this.length
  if (targetStart >= target.length) targetStart = target.length
  if (!targetStart) targetStart = 0
  if (end > 0 && end < start) end = start

  // Copy 0 bytes; we're done
  if (end === start) return 0
  if (target.length === 0 || this.length === 0) return 0

  // Fatal error conditions
  if (targetStart < 0) {
    throw new RangeError('targetStart out of bounds')
  }
  if (start < 0 || start >= this.length) throw new RangeError('sourceStart out of bounds')
  if (end < 0) throw new RangeError('sourceEnd out of bounds')

  // Are we oob?
  if (end > this.length) end = this.length
  if (target.length - targetStart < end - start) {
    end = target.length - targetStart + start
  }

  var len = end - start
  var i

  if (this === target && start < targetStart && targetStart < end) {
    // descending copy from end
    for (i = len - 1; i >= 0; --i) {
      target[i + targetStart] = this[i + start]
    }
  } else if (len < 1000 || !Buffer.TYPED_ARRAY_SUPPORT) {
    // ascending copy from start
    for (i = 0; i < len; ++i) {
      target[i + targetStart] = this[i + start]
    }
  } else {
    Uint8Array.prototype.set.call(
      target,
      this.subarray(start, start + len),
      targetStart
    )
  }

  return len
}

// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
Buffer.prototype.fill = function fill (val, start, end, encoding) {
  // Handle string cases:
  if (typeof val === 'string') {
    if (typeof start === 'string') {
      encoding = start
      start = 0
      end = this.length
    } else if (typeof end === 'string') {
      encoding = end
      end = this.length
    }
    if (val.length === 1) {
      var code = val.charCodeAt(0)
      if (code < 256) {
        val = code
      }
    }
    if (encoding !== undefined && typeof encoding !== 'string') {
      throw new TypeError('encoding must be a string')
    }
    if (typeof encoding === 'string' && !Buffer.isEncoding(encoding)) {
      throw new TypeError('Unknown encoding: ' + encoding)
    }
  } else if (typeof val === 'number') {
    val = val & 255
  }

  // Invalid ranges are not set to a default, so can range check early.
  if (start < 0 || this.length < start || this.length < end) {
    throw new RangeError('Out of range index')
  }

  if (end <= start) {
    return this
  }

  start = start >>> 0
  end = end === undefined ? this.length : end >>> 0

  if (!val) val = 0

  var i
  if (typeof val === 'number') {
    for (i = start; i < end; ++i) {
      this[i] = val
    }
  } else {
    var bytes = Buffer.isBuffer(val)
      ? val
      : utf8ToBytes(new Buffer(val, encoding).toString())
    var len = bytes.length
    for (i = 0; i < end - start; ++i) {
      this[i + start] = bytes[i % len]
    }
  }

  return this
}

// HELPER FUNCTIONS
// ================

var INVALID_BASE64_RE = /[^+\/0-9A-Za-z-_]/g

function base64clean (str) {
  // Node strips out invalid characters like \n and \t from the string, base64-js does not
  str = stringtrim(str).replace(INVALID_BASE64_RE, '')
  // Node converts strings with length < 2 to ''
  if (str.length < 2) return ''
  // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
  while (str.length % 4 !== 0) {
    str = str + '='
  }
  return str
}

function stringtrim (str) {
  if (str.trim) return str.trim()
  return str.replace(/^\s+|\s+$/g, '')
}

function toHex (n) {
  if (n < 16) return '0' + n.toString(16)
  return n.toString(16)
}

function utf8ToBytes (string, units) {
  units = units || Infinity
  var codePoint
  var length = string.length
  var leadSurrogate = null
  var bytes = []

  for (var i = 0; i < length; ++i) {
    codePoint = string.charCodeAt(i)

    // is surrogate component
    if (codePoint > 0xD7FF && codePoint < 0xE000) {
      // last char was a lead
      if (!leadSurrogate) {
        // no lead yet
        if (codePoint > 0xDBFF) {
          // unexpected trail
          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
          continue
        } else if (i + 1 === length) {
          // unpaired lead
          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
          continue
        }

        // valid lead
        leadSurrogate = codePoint

        continue
      }

      // 2 leads in a row
      if (codePoint < 0xDC00) {
        if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
        leadSurrogate = codePoint
        continue
      }

      // valid surrogate pair
      codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000
    } else if (leadSurrogate) {
      // valid bmp char, but last char was a lead
      if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
    }

    leadSurrogate = null

    // encode utf8
    if (codePoint < 0x80) {
      if ((units -= 1) < 0) break
      bytes.push(codePoint)
    } else if (codePoint < 0x800) {
      if ((units -= 2) < 0) break
      bytes.push(
        codePoint >> 0x6 | 0xC0,
        codePoint & 0x3F | 0x80
      )
    } else if (codePoint < 0x10000) {
      if ((units -= 3) < 0) break
      bytes.push(
        codePoint >> 0xC | 0xE0,
        codePoint >> 0x6 & 0x3F | 0x80,
        codePoint & 0x3F | 0x80
      )
    } else if (codePoint < 0x110000) {
      if ((units -= 4) < 0) break
      bytes.push(
        codePoint >> 0x12 | 0xF0,
        codePoint >> 0xC & 0x3F | 0x80,
        codePoint >> 0x6 & 0x3F | 0x80,
        codePoint & 0x3F | 0x80
      )
    } else {
      throw new Error('Invalid code point')
    }
  }

  return bytes
}

function asciiToBytes (str) {
  var byteArray = []
  for (var i = 0; i < str.length; ++i) {
    // Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF)
  }
  return byteArray
}

function utf16leToBytes (str, units) {
  var c, hi, lo
  var byteArray = []
  for (var i = 0; i < str.length; ++i) {
    if ((units -= 2) < 0) break

    c = str.charCodeAt(i)
    hi = c >> 8
    lo = c % 256
    byteArray.push(lo)
    byteArray.push(hi)
  }

  return byteArray
}

function base64ToBytes (str) {
  return base64.toByteArray(base64clean(str))
}

function blitBuffer (src, dst, offset, length) {
  for (var i = 0; i < length; ++i) {
    if ((i + offset >= dst.length) || (i >= src.length)) break
    dst[i + offset] = src[i]
  }
  return i
}

function isnan (val) {
  return val !== val // eslint-disable-line no-self-compare
}

/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(/*! ./../../../webpack/buildin/global.js */ "./node_modules/webpack/buildin/global.js")))

/***/ }),

/***/ "./node_modules/object-assign/index.js":
/*!*********************************************!*\
  !*** ./node_modules/object-assign/index.js ***!
  \*********************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/


/* eslint-disable no-unused-vars */
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var hasOwnProperty = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;

function toObject(val) {
	if (val === null || val === undefined) {
		throw new TypeError('Object.assign cannot be called with null or undefined');
	}

	return Object(val);
}

function shouldUseNative() {
	try {
		if (!Object.assign) {
			return false;
		}

		// Detect buggy property enumeration order in older V8 versions.

		// https://bugs.chromium.org/p/v8/issues/detail?id=4118
		var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
		test1[5] = 'de';
		if (Object.getOwnPropertyNames(test1)[0] === '5') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test2 = {};
		for (var i = 0; i < 10; i++) {
			test2['_' + String.fromCharCode(i)] = i;
		}
		var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
			return test2[n];
		});
		if (order2.join('') !== '0123456789') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test3 = {};
		'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
			test3[letter] = letter;
		});
		if (Object.keys(Object.assign({}, test3)).join('') !==
				'abcdefghijklmnopqrst') {
			return false;
		}

		return true;
	} catch (err) {
		// We don't expect any of the above to throw, but better to be safe.
		return false;
	}
}

module.exports = shouldUseNative() ? Object.assign : function (target, source) {
	var from;
	var to = toObject(target);
	var symbols;

	for (var s = 1; s < arguments.length; s++) {
		from = Object(arguments[s]);

		for (var key in from) {
			if (hasOwnProperty.call(from, key)) {
				to[key] = from[key];
			}
		}

		if (getOwnPropertySymbols) {
			symbols = getOwnPropertySymbols(from);
			for (var i = 0; i < symbols.length; i++) {
				if (propIsEnumerable.call(from, symbols[i])) {
					to[symbols[i]] = from[symbols[i]];
				}
			}
		}
	}

	return to;
};


/***/ }),

/***/ "./node_modules/parse-asn1/aesid.json":
/*!********************************************!*\
  !*** ./node_modules/parse-asn1/aesid.json ***!
  \********************************************/
/*! exports provided: 2.16.840.1.101.3.4.1.1, 2.16.840.1.101.3.4.1.2, 2.16.840.1.101.3.4.1.3, 2.16.840.1.101.3.4.1.4, 2.16.840.1.101.3.4.1.21, 2.16.840.1.101.3.4.1.22, 2.16.840.1.101.3.4.1.23, 2.16.840.1.101.3.4.1.24, 2.16.840.1.101.3.4.1.41, 2.16.840.1.101.3.4.1.42, 2.16.840.1.101.3.4.1.43, 2.16.840.1.101.3.4.1.44, default */
/***/ (function(module) {

module.exports = JSON.parse("{\"2.16.840.1.101.3.4.1.1\":\"aes-128-ecb\",\"2.16.840.1.101.3.4.1.2\":\"aes-128-cbc\",\"2.16.840.1.101.3.4.1.3\":\"aes-128-ofb\",\"2.16.840.1.101.3.4.1.4\":\"aes-128-cfb\",\"2.16.840.1.101.3.4.1.21\":\"aes-192-ecb\",\"2.16.840.1.101.3.4.1.22\":\"aes-192-cbc\",\"2.16.840.1.101.3.4.1.23\":\"aes-192-ofb\",\"2.16.840.1.101.3.4.1.24\":\"aes-192-cfb\",\"2.16.840.1.101.3.4.1.41\":\"aes-256-ecb\",\"2.16.840.1.101.3.4.1.42\":\"aes-256-cbc\",\"2.16.840.1.101.3.4.1.43\":\"aes-256-ofb\",\"2.16.840.1.101.3.4.1.44\":\"aes-256-cfb\"}");

/***/ }),

/***/ "./node_modules/parse-asn1/asn1.js":
/*!*****************************************!*\
  !*** ./node_modules/parse-asn1/asn1.js ***!
  \*****************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// from https://github.com/indutny/self-signed/blob/gh-pages/lib/asn1.js
// Fedor, you are amazing.


var asn1 = __webpack_require__(/*! asn1.js */ "./node_modules/asn1.js/lib/asn1.js")

exports.certificate = __webpack_require__(/*! ./certificate */ "./node_modules/parse-asn1/certificate.js")

var RSAPrivateKey = asn1.define('RSAPrivateKey', function () {
  this.seq().obj(
    this.key('version').int(),
    this.key('modulus').int(),
    this.key('publicExponent').int(),
    this.key('privateExponent').int(),
    this.key('prime1').int(),
    this.key('prime2').int(),
    this.key('exponent1').int(),
    this.key('exponent2').int(),
    this.key('coefficient').int()
  )
})
exports.RSAPrivateKey = RSAPrivateKey

var RSAPublicKey = asn1.define('RSAPublicKey', function () {
  this.seq().obj(
    this.key('modulus').int(),
    this.key('publicExponent').int()
  )
})
exports.RSAPublicKey = RSAPublicKey

var PublicKey = asn1.define('SubjectPublicKeyInfo', function () {
  this.seq().obj(
    this.key('algorithm').use(AlgorithmIdentifier),
    this.key('subjectPublicKey').bitstr()
  )
})
exports.PublicKey = PublicKey

var AlgorithmIdentifier = asn1.define('AlgorithmIdentifier', function () {
  this.seq().obj(
    this.key('algorithm').objid(),
    this.key('none').null_().optional(),
    this.key('curve').objid().optional(),
    this.key('params').seq().obj(
      this.key('p').int(),
      this.key('q').int(),
      this.key('g').int()
    ).optional()
  )
})

var PrivateKeyInfo = asn1.define('PrivateKeyInfo', function () {
  this.seq().obj(
    this.key('version').int(),
    this.key('algorithm').use(AlgorithmIdentifier),
    this.key('subjectPrivateKey').octstr()
  )
})
exports.PrivateKey = PrivateKeyInfo
var EncryptedPrivateKeyInfo = asn1.define('EncryptedPrivateKeyInfo', function () {
  this.seq().obj(
    this.key('algorithm').seq().obj(
      this.key('id').objid(),
      this.key('decrypt').seq().obj(
        this.key('kde').seq().obj(
          this.key('id').objid(),
          this.key('kdeparams').seq().obj(
            this.key('salt').octstr(),
            this.key('iters').int()
          )
        ),
        this.key('cipher').seq().obj(
          this.key('algo').objid(),
          this.key('iv').octstr()
        )
      )
    ),
    this.key('subjectPrivateKey').octstr()
  )
})

exports.EncryptedPrivateKey = EncryptedPrivateKeyInfo

var DSAPrivateKey = asn1.define('DSAPrivateKey', function () {
  this.seq().obj(
    this.key('version').int(),
    this.key('p').int(),
    this.key('q').int(),
    this.key('g').int(),
    this.key('pub_key').int(),
    this.key('priv_key').int()
  )
})
exports.DSAPrivateKey = DSAPrivateKey

exports.DSAparam = asn1.define('DSAparam', function () {
  this.int()
})

var ECPrivateKey = asn1.define('ECPrivateKey', function () {
  this.seq().obj(
    this.key('version').int(),
    this.key('privateKey').octstr(),
    this.key('parameters').optional().explicit(0).use(ECParameters),
    this.key('publicKey').optional().explicit(1).bitstr()
  )
})
exports.ECPrivateKey = ECPrivateKey

var ECParameters = asn1.define('ECParameters', function () {
  this.choice({
    namedCurve: this.objid()
  })
})

exports.signature = asn1.define('signature', function () {
  this.seq().obj(
    this.key('r').int(),
    this.key('s').int()
  )
})


/***/ }),

/***/ "./node_modules/parse-asn1/certificate.js":
/*!************************************************!*\
  !*** ./node_modules/parse-asn1/certificate.js ***!
  \************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// from https://github.com/Rantanen/node-dtls/blob/25a7dc861bda38cfeac93a723500eea4f0ac2e86/Certificate.js
// thanks to @Rantanen



var asn = __webpack_require__(/*! asn1.js */ "./node_modules/asn1.js/lib/asn1.js")

var Time = asn.define('Time', function () {
  this.choice({
    utcTime: this.utctime(),
    generalTime: this.gentime()
  })
})

var AttributeTypeValue = asn.define('AttributeTypeValue', function () {
  this.seq().obj(
    this.key('type').objid(),
    this.key('value').any()
  )
})

var AlgorithmIdentifier = asn.define('AlgorithmIdentifier', function () {
  this.seq().obj(
    this.key('algorithm').objid(),
    this.key('parameters').optional(),
    this.key('curve').objid().optional()
  )
})

var SubjectPublicKeyInfo = asn.define('SubjectPublicKeyInfo', function () {
  this.seq().obj(
    this.key('algorithm').use(AlgorithmIdentifier),
    this.key('subjectPublicKey').bitstr()
  )
})

var RelativeDistinguishedName = asn.define('RelativeDistinguishedName', function () {
  this.setof(AttributeTypeValue)
})

var RDNSequence = asn.define('RDNSequence', function () {
  this.seqof(RelativeDistinguishedName)
})

var Name = asn.define('Name', function () {
  this.choice({
    rdnSequence: this.use(RDNSequence)
  })
})

var Validity = asn.define('Validity', function () {
  this.seq().obj(
    this.key('notBefore').use(Time),
    this.key('notAfter').use(Time)
  )
})

var Extension = asn.define('Extension', function () {
  this.seq().obj(
    this.key('extnID').objid(),
    this.key('critical').bool().def(false),
    this.key('extnValue').octstr()
  )
})

var TBSCertificate = asn.define('TBSCertificate', function () {
  this.seq().obj(
    this.key('version').explicit(0).int().optional(),
    this.key('serialNumber').int(),
    this.key('signature').use(AlgorithmIdentifier),
    this.key('issuer').use(Name),
    this.key('validity').use(Validity),
    this.key('subject').use(Name),
    this.key('subjectPublicKeyInfo').use(SubjectPublicKeyInfo),
    this.key('issuerUniqueID').implicit(1).bitstr().optional(),
    this.key('subjectUniqueID').implicit(2).bitstr().optional(),
    this.key('extensions').explicit(3).seqof(Extension).optional()
  )
})

var X509Certificate = asn.define('X509Certificate', function () {
  this.seq().obj(
    this.key('tbsCertificate').use(TBSCertificate),
    this.key('signatureAlgorithm').use(AlgorithmIdentifier),
    this.key('signatureValue').bitstr()
  )
})

module.exports = X509Certificate


/***/ }),

/***/ "./node_modules/parse-asn1/fixProc.js":
/*!********************************************!*\
  !*** ./node_modules/parse-asn1/fixProc.js ***!
  \********************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

// adapted from https://github.com/apatil/pemstrip
var findProc = /Proc-Type: 4,ENCRYPTED[\n\r]+DEK-Info: AES-((?:128)|(?:192)|(?:256))-CBC,([0-9A-H]+)[\n\r]+([0-9A-z\n\r+/=]+)[\n\r]+/m
var startRegex = /^-----BEGIN ((?:.*? KEY)|CERTIFICATE)-----/m
var fullRegex = /^-----BEGIN ((?:.*? KEY)|CERTIFICATE)-----([0-9A-z\n\r+/=]+)-----END \1-----$/m
var evp = __webpack_require__(/*! evp_bytestokey */ "./node_modules/evp_bytestokey/index.js")
var ciphers = __webpack_require__(/*! browserify-aes */ "./node_modules/browserify-aes/browser.js")
var Buffer = __webpack_require__(/*! safe-buffer */ "./node_modules/safe-buffer/index.js").Buffer
module.exports = function (okey, password) {
  var key = okey.toString()
  var match = key.match(findProc)
  var decrypted
  if (!match) {
    var match2 = key.match(fullRegex)
    decrypted = Buffer.from(match2[2].replace(/[\r\n]/g, ''), 'base64')
  } else {
    var suite = 'aes' + match[1]
    var iv = Buffer.from(match[2], 'hex')
    var cipherText = Buffer.from(match[3].replace(/[\r\n]/g, ''), 'base64')
    var cipherKey = evp(password, iv.slice(0, 8), parseInt(match[1], 10)).key
    var out = []
    var cipher = ciphers.createDecipheriv(suite, cipherKey, iv)
    out.push(cipher.update(cipherText))
    out.push(cipher.final())
    decrypted = Buffer.concat(out)
  }
  var tag = key.match(startRegex)[1]
  return {
    tag: tag,
    data: decrypted
  }
}


/***/ }),

/***/ "./node_modules/parse-asn1/index.js":
/*!******************************************!*\
  !*** ./node_modules/parse-asn1/index.js ***!
  \******************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var asn1 = __webpack_require__(/*! ./asn1 */ "./node_modules/parse-asn1/asn1.js")
var aesid = __webpack_require__(/*! ./aesid.json */ "./node_modules/parse-asn1/aesid.json")
var fixProc = __webpack_require__(/*! ./fixProc */ "./node_modules/parse-asn1/fixProc.js")
var ciphers = __webpack_require__(/*! browserify-aes */ "./node_modules/browserify-aes/browser.js")
var compat = __webpack_require__(/*! pbkdf2 */ "./node_modules/pbkdf2/browser.js")
var Buffer = __webpack_require__(/*! safe-buffer */ "./node_modules/safe-buffer/index.js").Buffer
module.exports = parseKeys

function parseKeys (buffer) {
  var password
  if (typeof buffer === 'object' && !Buffer.isBuffer(buffer)) {
    password = buffer.passphrase
    buffer = buffer.key
  }
  if (typeof buffer === 'string') {
    buffer = Buffer.from(buffer)
  }

  var stripped = fixProc(buffer, password)

  var type = stripped.tag
  var data = stripped.data
  var subtype, ndata
  switch (type) {
    case 'CERTIFICATE':
      ndata = asn1.certificate.decode(data, 'der').tbsCertificate.subjectPublicKeyInfo
      // falls through
    case 'PUBLIC KEY':
      if (!ndata) {
        ndata = asn1.PublicKey.decode(data, 'der')
      }
      subtype = ndata.algorithm.algorithm.join('.')
      switch (subtype) {
        case '1.2.840.113549.1.1.1':
          return asn1.RSAPublicKey.decode(ndata.subjectPublicKey.data, 'der')
        case '1.2.840.10045.2.1':
          ndata.subjectPrivateKey = ndata.subjectPublicKey
          return {
            type: 'ec',
            data: ndata
          }
        case '1.2.840.10040.4.1':
          ndata.algorithm.params.pub_key = asn1.DSAparam.decode(ndata.subjectPublicKey.data, 'der')
          return {
            type: 'dsa',
            data: ndata.algorithm.params
          }
        default: throw new Error('unknown key id ' + subtype)
      }
      // throw new Error('unknown key type ' + type)
    case 'ENCRYPTED PRIVATE KEY':
      data = asn1.EncryptedPrivateKey.decode(data, 'der')
      data = decrypt(data, password)
      // falls through
    case 'PRIVATE KEY':
      ndata = asn1.PrivateKey.decode(data, 'der')
      subtype = ndata.algorithm.algorithm.join('.')
      switch (subtype) {
        case '1.2.840.113549.1.1.1':
          return asn1.RSAPrivateKey.decode(ndata.subjectPrivateKey, 'der')
        case '1.2.840.10045.2.1':
          return {
            curve: ndata.algorithm.curve,
            privateKey: asn1.ECPrivateKey.decode(ndata.subjectPrivateKey, 'der').privateKey
          }
        case '1.2.840.10040.4.1':
          ndata.algorithm.params.priv_key = asn1.DSAparam.decode(ndata.subjectPrivateKey, 'der')
          return {
            type: 'dsa',
            params: ndata.algorithm.params
          }
        default: throw new Error('unknown key id ' + subtype)
      }
      // throw new Error('unknown key type ' + type)
    case 'RSA PUBLIC KEY':
      return asn1.RSAPublicKey.decode(data, 'der')
    case 'RSA PRIVATE KEY':
      return asn1.RSAPrivateKey.decode(data, 'der')
    case 'DSA PRIVATE KEY':
      return {
        type: 'dsa',
        params: asn1.DSAPrivateKey.decode(data, 'der')
      }
    case 'EC PRIVATE KEY':
      data = asn1.ECPrivateKey.decode(data, 'der')
      return {
        curve: data.parameters.value,
        privateKey: data.privateKey
      }
    default: throw new Error('unknown key type ' + type)
  }
}
parseKeys.signature = asn1.signature
function decrypt (data, password) {
  var salt = data.algorithm.decrypt.kde.kdeparams.salt
  var iters = parseInt(data.algorithm.decrypt.kde.kdeparams.iters.toString(), 10)
  var algo = aesid[data.algorithm.decrypt.cipher.algo.join('.')]
  var iv = data.algorithm.decrypt.cipher.iv
  var cipherText = data.subjectPrivateKey
  var keylen = parseInt(algo.split('-')[1], 10) / 8
  var key = compat.pbkdf2Sync(password, salt, iters, keylen, 'sha1')
  var cipher = ciphers.createDecipheriv(algo, key, iv)
  var out = []
  out.push(cipher.update(cipherText))
  out.push(cipher.final())
  return Buffer.concat(out)
}


/***/ }),

/***/ "./node_modules/path-browserify/index.js":
/*!***********************************************!*\
  !*** ./node_modules/path-browserify/index.js ***!
  \***********************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(process) {// .dirname, .basename, and .extname methods are extracted from Node.js v8.11.1,
// backported and transplited with Babel, with backwards-compat fixes

// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

// resolves . and .. elements in a path array with directory names there
// must be no slashes, empty elements, or device names (c:\) in the array
// (so also no leading and trailing slashes - it does not distinguish
// relative and absolute paths)
function normalizeArray(parts, allowAboveRoot) {
  // if the path tries to go above the root, `up` ends up > 0
  var up = 0;
  for (var i = parts.length - 1; i >= 0; i--) {
    var last = parts[i];
    if (last === '.') {
      parts.splice(i, 1);
    } else if (last === '..') {
      parts.splice(i, 1);
      up++;
    } else if (up) {
      parts.splice(i, 1);
      up--;
    }
  }

  // if the path is allowed to go above the root, restore leading ..s
  if (allowAboveRoot) {
    for (; up--; up) {
      parts.unshift('..');
    }
  }

  return parts;
}

// path.resolve([from ...], to)
// posix version
exports.resolve = function() {
  var resolvedPath = '',
      resolvedAbsolute = false;

  for (var i = arguments.length - 1; i >= -1 && !resolvedAbsolute; i--) {
    var path = (i >= 0) ? arguments[i] : process.cwd();

    // Skip empty and invalid entries
    if (typeof path !== 'string') {
      throw new TypeError('Arguments to path.resolve must be strings');
    } else if (!path) {
      continue;
    }

    resolvedPath = path + '/' + resolvedPath;
    resolvedAbsolute = path.charAt(0) === '/';
  }

  // At this point the path should be resolved to a full absolute path, but
  // handle relative paths to be safe (might happen when process.cwd() fails)

  // Normalize the path
  resolvedPath = normalizeArray(filter(resolvedPath.split('/'), function(p) {
    return !!p;
  }), !resolvedAbsolute).join('/');

  return ((resolvedAbsolute ? '/' : '') + resolvedPath) || '.';
};

// path.normalize(path)
// posix version
exports.normalize = function(path) {
  var isAbsolute = exports.isAbsolute(path),
      trailingSlash = substr(path, -1) === '/';

  // Normalize the path
  path = normalizeArray(filter(path.split('/'), function(p) {
    return !!p;
  }), !isAbsolute).join('/');

  if (!path && !isAbsolute) {
    path = '.';
  }
  if (path && trailingSlash) {
    path += '/';
  }

  return (isAbsolute ? '/' : '') + path;
};

// posix version
exports.isAbsolute = function(path) {
  return path.charAt(0) === '/';
};

// posix version
exports.join = function() {
  var paths = Array.prototype.slice.call(arguments, 0);
  return exports.normalize(filter(paths, function(p, index) {
    if (typeof p !== 'string') {
      throw new TypeError('Arguments to path.join must be strings');
    }
    return p;
  }).join('/'));
};


// path.relative(from, to)
// posix version
exports.relative = function(from, to) {
  from = exports.resolve(from).substr(1);
  to = exports.resolve(to).substr(1);

  function trim(arr) {
    var start = 0;
    for (; start < arr.length; start++) {
      if (arr[start] !== '') break;
    }

    var end = arr.length - 1;
    for (; end >= 0; end--) {
      if (arr[end] !== '') break;
    }

    if (start > end) return [];
    return arr.slice(start, end - start + 1);
  }

  var fromParts = trim(from.split('/'));
  var toParts = trim(to.split('/'));

  var length = Math.min(fromParts.length, toParts.length);
  var samePartsLength = length;
  for (var i = 0; i < length; i++) {
    if (fromParts[i] !== toParts[i]) {
      samePartsLength = i;
      break;
    }
  }

  var outputParts = [];
  for (var i = samePartsLength; i < fromParts.length; i++) {
    outputParts.push('..');
  }

  outputParts = outputParts.concat(toParts.slice(samePartsLength));

  return outputParts.join('/');
};

exports.sep = '/';
exports.delimiter = ':';

exports.dirname = function (path) {
  if (typeof path !== 'string') path = path + '';
  if (path.length === 0) return '.';
  var code = path.charCodeAt(0);
  var hasRoot = code === 47 /*/*/;
  var end = -1;
  var matchedSlash = true;
  for (var i = path.length - 1; i >= 1; --i) {
    code = path.charCodeAt(i);
    if (code === 47 /*/*/) {
        if (!matchedSlash) {
          end = i;
          break;
        }
      } else {
      // We saw the first non-path separator
      matchedSlash = false;
    }
  }

  if (end === -1) return hasRoot ? '/' : '.';
  if (hasRoot && end === 1) {
    // return '//';
    // Backwards-compat fix:
    return '/';
  }
  return path.slice(0, end);
};

function basename(path) {
  if (typeof path !== 'string') path = path + '';

  var start = 0;
  var end = -1;
  var matchedSlash = true;
  var i;

  for (i = path.length - 1; i >= 0; --i) {
    if (path.charCodeAt(i) === 47 /*/*/) {
        // If we reached a path separator that was not part of a set of path
        // separators at the end of the string, stop now
        if (!matchedSlash) {
          start = i + 1;
          break;
        }
      } else if (end === -1) {
      // We saw the first non-path separator, mark this as the end of our
      // path component
      matchedSlash = false;
      end = i + 1;
    }
  }

  if (end === -1) return '';
  return path.slice(start, end);
}

// Uses a mixed approach for backwards-compatibility, as ext behavior changed
// in new Node.js versions, so only basename() above is backported here
exports.basename = function (path, ext) {
  var f = basename(path);
  if (ext && f.substr(-1 * ext.length) === ext) {
    f = f.substr(0, f.length - ext.length);
  }
  return f;
};

exports.extname = function (path) {
  if (typeof path !== 'string') path = path + '';
  var startDot = -1;
  var startPart = 0;
  var end = -1;
  var matchedSlash = true;
  // Track the state of characters (if any) we see before our first dot and
  // after any path separator we find
  var preDotState = 0;
  for (var i = path.length - 1; i >= 0; --i) {
    var code = path.charCodeAt(i);
    if (code === 47 /*/*/) {
        // If we reached a path separator that was not part of a set of path
        // separators at the end of the string, stop now
        if (!matchedSlash) {
          startPart = i + 1;
          break;
        }
        continue;
      }
    if (end === -1) {
      // We saw the first non-path separator, mark this as the end of our
      // extension
      matchedSlash = false;
      end = i + 1;
    }
    if (code === 46 /*.*/) {
        // If this is our first dot, mark it as the start of our extension
        if (startDot === -1)
          startDot = i;
        else if (preDotState !== 1)
          preDotState = 1;
    } else if (startDot !== -1) {
      // We saw a non-dot and non-path separator before our dot, so we should
      // have a good chance at having a non-empty extension
      preDotState = -1;
    }
  }

  if (startDot === -1 || end === -1 ||
      // We saw a non-dot character immediately before the dot
      preDotState === 0 ||
      // The (right-most) trimmed path component is exactly '..'
      preDotState === 1 && startDot === end - 1 && startDot === startPart + 1) {
    return '';
  }
  return path.slice(startDot, end);
};

function filter (xs, f) {
    if (xs.filter) return xs.filter(f);
    var res = [];
    for (var i = 0; i < xs.length; i++) {
        if (f(xs[i], i, xs)) res.push(xs[i]);
    }
    return res;
}

// String.prototype.substr - negative index don't work in IE8
var substr = 'ab'.substr(-1) === 'b'
    ? function (str, start, len) { return str.substr(start, len) }
    : function (str, start, len) {
        if (start < 0) start = str.length + start;
        return str.substr(start, len);
    }
;

/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(/*! ./../process/browser.js */ "./node_modules/process/browser.js")))

/***/ }),

/***/ "./node_modules/pbkdf2/browser.js":
/*!****************************************!*\
  !*** ./node_modules/pbkdf2/browser.js ***!
  \****************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

exports.pbkdf2 = __webpack_require__(/*! ./lib/async */ "./node_modules/pbkdf2/lib/async.js")
exports.pbkdf2Sync = __webpack_require__(/*! ./lib/sync */ "./node_modules/pbkdf2/lib/sync-browser.js")


/***/ }),

/***/ "./node_modules/pbkdf2/lib/async.js":
/*!******************************************!*\
  !*** ./node_modules/pbkdf2/lib/async.js ***!
  \******************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global, process) {var Buffer = __webpack_require__(/*! safe-buffer */ "./node_modules/safe-buffer/index.js").Buffer

var checkParameters = __webpack_require__(/*! ./precondition */ "./node_modules/pbkdf2/lib/precondition.js")
var defaultEncoding = __webpack_require__(/*! ./default-encoding */ "./node_modules/pbkdf2/lib/default-encoding.js")
var sync = __webpack_require__(/*! ./sync */ "./node_modules/pbkdf2/lib/sync-browser.js")
var toBuffer = __webpack_require__(/*! ./to-buffer */ "./node_modules/pbkdf2/lib/to-buffer.js")

var ZERO_BUF
var subtle = global.crypto && global.crypto.subtle
var toBrowser = {
  sha: 'SHA-1',
  'sha-1': 'SHA-1',
  sha1: 'SHA-1',
  sha256: 'SHA-256',
  'sha-256': 'SHA-256',
  sha384: 'SHA-384',
  'sha-384': 'SHA-384',
  'sha-512': 'SHA-512',
  sha512: 'SHA-512'
}
var checks = []
function checkNative (algo) {
  if (global.process && !global.process.browser) {
    return Promise.resolve(false)
  }
  if (!subtle || !subtle.importKey || !subtle.deriveBits) {
    return Promise.resolve(false)
  }
  if (checks[algo] !== undefined) {
    return checks[algo]
  }
  ZERO_BUF = ZERO_BUF || Buffer.alloc(8)
  var prom = browserPbkdf2(ZERO_BUF, ZERO_BUF, 10, 128, algo)
    .then(function () {
      return true
    }).catch(function () {
      return false
    })
  checks[algo] = prom
  return prom
}

function browserPbkdf2 (password, salt, iterations, length, algo) {
  return subtle.importKey(
    'raw', password, { name: 'PBKDF2' }, false, ['deriveBits']
  ).then(function (key) {
    return subtle.deriveBits({
      name: 'PBKDF2',
      salt: salt,
      iterations: iterations,
      hash: {
        name: algo
      }
    }, key, length << 3)
  }).then(function (res) {
    return Buffer.from(res)
  })
}

function resolvePromise (promise, callback) {
  promise.then(function (out) {
    process.nextTick(function () {
      callback(null, out)
    })
  }, function (e) {
    process.nextTick(function () {
      callback(e)
    })
  })
}
module.exports = function (password, salt, iterations, keylen, digest, callback) {
  if (typeof digest === 'function') {
    callback = digest
    digest = undefined
  }

  digest = digest || 'sha1'
  var algo = toBrowser[digest.toLowerCase()]

  if (!algo || typeof global.Promise !== 'function') {
    return process.nextTick(function () {
      var out
      try {
        out = sync(password, salt, iterations, keylen, digest)
      } catch (e) {
        return callback(e)
      }
      callback(null, out)
    })
  }

  checkParameters(iterations, keylen)
  password = toBuffer(password, defaultEncoding, 'Password')
  salt = toBuffer(salt, defaultEncoding, 'Salt')
  if (typeof callback !== 'function') throw new Error('No callback provided to pbkdf2')

  resolvePromise(checkNative(algo).then(function (resp) {
    if (resp) return browserPbkdf2(password, salt, iterations, keylen, algo)

    return sync(password, salt, iterations, keylen, digest)
  }), callback)
}

/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(/*! ./../../webpack/buildin/global.js */ "./node_modules/webpack/buildin/global.js"), __webpack_require__(/*! ./../../process/browser.js */ "./node_modules/process/browser.js")))

/***/ }),

/***/ "./node_modules/pbkdf2/lib/default-encoding.js":
/*!*****************************************************!*\
  !*** ./node_modules/pbkdf2/lib/default-encoding.js ***!
  \*****************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(process) {var defaultEncoding
/* istanbul ignore next */
if (process.browser) {
  defaultEncoding = 'utf-8'
} else if (process.version) {
  var pVersionMajor = parseInt(process.version.split('.')[0].slice(1), 10)

  defaultEncoding = pVersionMajor >= 6 ? 'utf-8' : 'binary'
} else {
  defaultEncoding = 'utf-8'
}
module.exports = defaultEncoding

/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(/*! ./../../process/browser.js */ "./node_modules/process/browser.js")))

/***/ }),

/***/ "./node_modules/pbkdf2/lib/precondition.js":
/*!*************************************************!*\
  !*** ./node_modules/pbkdf2/lib/precondition.js ***!
  \*************************************************/
/*! no static exports found */
/***/ (function(module, exports) {

var MAX_ALLOC = Math.pow(2, 30) - 1 // default in iojs

module.exports = function (iterations, keylen) {
  if (typeof iterations !== 'number') {
    throw new TypeError('Iterations not a number')
  }

  if (iterations < 0) {
    throw new TypeError('Bad iterations')
  }

  if (typeof keylen !== 'number') {
    throw new TypeError('Key length not a number')
  }

  if (keylen < 0 || keylen > MAX_ALLOC || keylen !== keylen) { /* eslint no-self-compare: 0 */
    throw new TypeError('Bad key length')
  }
}


/***/ }),

/***/ "./node_modules/pbkdf2/lib/sync-browser.js":
/*!*************************************************!*\
  !*** ./node_modules/pbkdf2/lib/sync-browser.js ***!
  \*************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var md5 = __webpack_require__(/*! create-hash/md5 */ "./node_modules/create-hash/md5.js")
var RIPEMD160 = __webpack_require__(/*! ripemd160 */ "./node_modules/ripemd160/index.js")
var sha = __webpack_require__(/*! sha.js */ "./node_modules/sha.js/index.js")
var Buffer = __webpack_require__(/*! safe-buffer */ "./node_modules/safe-buffer/index.js").Buffer

var checkParameters = __webpack_require__(/*! ./precondition */ "./node_modules/pbkdf2/lib/precondition.js")
var defaultEncoding = __webpack_require__(/*! ./default-encoding */ "./node_modules/pbkdf2/lib/default-encoding.js")
var toBuffer = __webpack_require__(/*! ./to-buffer */ "./node_modules/pbkdf2/lib/to-buffer.js")

var ZEROS = Buffer.alloc(128)
var sizes = {
  md5: 16,
  sha1: 20,
  sha224: 28,
  sha256: 32,
  sha384: 48,
  sha512: 64,
  rmd160: 20,
  ripemd160: 20
}

function Hmac (alg, key, saltLen) {
  var hash = getDigest(alg)
  var blocksize = (alg === 'sha512' || alg === 'sha384') ? 128 : 64

  if (key.length > blocksize) {
    key = hash(key)
  } else if (key.length < blocksize) {
    key = Buffer.concat([key, ZEROS], blocksize)
  }

  var ipad = Buffer.allocUnsafe(blocksize + sizes[alg])
  var opad = Buffer.allocUnsafe(blocksize + sizes[alg])
  for (var i = 0; i < blocksize; i++) {
    ipad[i] = key[i] ^ 0x36
    opad[i] = key[i] ^ 0x5C
  }

  var ipad1 = Buffer.allocUnsafe(blocksize + saltLen + 4)
  ipad.copy(ipad1, 0, 0, blocksize)
  this.ipad1 = ipad1
  this.ipad2 = ipad
  this.opad = opad
  this.alg = alg
  this.blocksize = blocksize
  this.hash = hash
  this.size = sizes[alg]
}

Hmac.prototype.run = function (data, ipad) {
  data.copy(ipad, this.blocksize)
  var h = this.hash(ipad)
  h.copy(this.opad, this.blocksize)
  return this.hash(this.opad)
}

function getDigest (alg) {
  function shaFunc (data) {
    return sha(alg).update(data).digest()
  }
  function rmd160Func (data) {
    return new RIPEMD160().update(data).digest()
  }

  if (alg === 'rmd160' || alg === 'ripemd160') return rmd160Func
  if (alg === 'md5') return md5
  return shaFunc
}

function pbkdf2 (password, salt, iterations, keylen, digest) {
  checkParameters(iterations, keylen)
  password = toBuffer(password, defaultEncoding, 'Password')
  salt = toBuffer(salt, defaultEncoding, 'Salt')

  digest = digest || 'sha1'

  var hmac = new Hmac(digest, password, salt.length)

  var DK = Buffer.allocUnsafe(keylen)
  var block1 = Buffer.allocUnsafe(salt.length + 4)
  salt.copy(block1, 0, 0, salt.length)

  var destPos = 0
  var hLen = sizes[digest]
  var l = Math.ceil(keylen / hLen)

  for (var i = 1; i <= l; i++) {
    block1.writeUInt32BE(i, salt.length)

    var T = hmac.run(block1, hmac.ipad1)
    var U = T

    for (var j = 1; j < iterations; j++) {
      U = hmac.run(U, hmac.ipad2)
      for (var k = 0; k < hLen; k++) T[k] ^= U[k]
    }

    T.copy(DK, destPos)
    destPos += hLen
  }

  return DK
}

module.exports = pbkdf2


/***/ }),

/***/ "./node_modules/pbkdf2/lib/to-buffer.js":
/*!**********************************************!*\
  !*** ./node_modules/pbkdf2/lib/to-buffer.js ***!
  \**********************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var Buffer = __webpack_require__(/*! safe-buffer */ "./node_modules/safe-buffer/index.js").Buffer

module.exports = function (thing, encoding, name) {
  if (Buffer.isBuffer(thing)) {
    return thing
  } else if (typeof thing === 'string') {
    return Buffer.from(thing, encoding)
  } else if (ArrayBuffer.isView(thing)) {
    return Buffer.from(thing.buffer)
  } else {
    throw new TypeError(name + ' must be a string, a Buffer, a typed array or a DataView')
  }
}


/***/ }),

/***/ "./node_modules/process-nextick-args/index.js":
/*!****************************************************!*\
  !*** ./node_modules/process-nextick-args/index.js ***!
  \****************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {

if (typeof process === 'undefined' ||
    !process.version ||
    process.version.indexOf('v0.') === 0 ||
    process.version.indexOf('v1.') === 0 && process.version.indexOf('v1.8.') !== 0) {
  module.exports = { nextTick: nextTick };
} else {
  module.exports = process
}

function nextTick(fn, arg1, arg2, arg3) {
  if (typeof fn !== 'function') {
    throw new TypeError('"callback" argument must be a function');
  }
  var len = arguments.length;
  var args, i;
  switch (len) {
  case 0:
  case 1:
    return process.nextTick(fn);
  case 2:
    return process.nextTick(function afterTickOne() {
      fn.call(null, arg1);
    });
  case 3:
    return process.nextTick(function afterTickTwo() {
      fn.call(null, arg1, arg2);
    });
  case 4:
    return process.nextTick(function afterTickThree() {
      fn.call(null, arg1, arg2, arg3);
    });
  default:
    args = new Array(len - 1);
    i = 0;
    while (i < args.length) {
      args[i++] = arguments[i];
    }
    return process.nextTick(function afterTick() {
      fn.apply(null, args);
    });
  }
}


/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(/*! ./../process/browser.js */ "./node_modules/process/browser.js")))

/***/ }),

/***/ "./node_modules/process/browser.js":
/*!*****************************************!*\
  !*** ./node_modules/process/browser.js ***!
  \*****************************************/
/*! no static exports found */
/***/ (function(module, exports) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ }),

/***/ "./node_modules/public-encrypt/browser.js":
/*!************************************************!*\
  !*** ./node_modules/public-encrypt/browser.js ***!
  \************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

exports.publicEncrypt = __webpack_require__(/*! ./publicEncrypt */ "./node_modules/public-encrypt/publicEncrypt.js")
exports.privateDecrypt = __webpack_require__(/*! ./privateDecrypt */ "./node_modules/public-encrypt/privateDecrypt.js")

exports.privateEncrypt = function privateEncrypt (key, buf) {
  return exports.publicEncrypt(key, buf, true)
}

exports.publicDecrypt = function publicDecrypt (key, buf) {
  return exports.privateDecrypt(key, buf, true)
}


/***/ }),

/***/ "./node_modules/public-encrypt/mgf.js":
/*!********************************************!*\
  !*** ./node_modules/public-encrypt/mgf.js ***!
  \********************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var createHash = __webpack_require__(/*! create-hash */ "./node_modules/create-hash/browser.js")
var Buffer = __webpack_require__(/*! safe-buffer */ "./node_modules/safe-buffer/index.js").Buffer

module.exports = function (seed, len) {
  var t = Buffer.alloc(0)
  var i = 0
  var c
  while (t.length < len) {
    c = i2ops(i++)
    t = Buffer.concat([t, createHash('sha1').update(seed).update(c).digest()])
  }
  return t.slice(0, len)
}

function i2ops (c) {
  var out = Buffer.allocUnsafe(4)
  out.writeUInt32BE(c, 0)
  return out
}


/***/ }),

/***/ "./node_modules/public-encrypt/node_modules/bn.js/lib/bn.js":
/*!******************************************************************!*\
  !*** ./node_modules/public-encrypt/node_modules/bn.js/lib/bn.js ***!
  \******************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {(function (module, exports) {
  'use strict';

  // Utils
  function assert (val, msg) {
    if (!val) throw new Error(msg || 'Assertion failed');
  }

  // Could use `inherits` module, but don't want to move from single file
  // architecture yet.
  function inherits (ctor, superCtor) {
    ctor.super_ = superCtor;
    var TempCtor = function () {};
    TempCtor.prototype = superCtor.prototype;
    ctor.prototype = new TempCtor();
    ctor.prototype.constructor = ctor;
  }

  // BN

  function BN (number, base, endian) {
    if (BN.isBN(number)) {
      return number;
    }

    this.negative = 0;
    this.words = null;
    this.length = 0;

    // Reduction context
    this.red = null;

    if (number !== null) {
      if (base === 'le' || base === 'be') {
        endian = base;
        base = 10;
      }

      this._init(number || 0, base || 10, endian || 'be');
    }
  }
  if (typeof module === 'object') {
    module.exports = BN;
  } else {
    exports.BN = BN;
  }

  BN.BN = BN;
  BN.wordSize = 26;

  var Buffer;
  try {
    Buffer = __webpack_require__(/*! buffer */ 13).Buffer;
  } catch (e) {
  }

  BN.isBN = function isBN (num) {
    if (num instanceof BN) {
      return true;
    }

    return num !== null && typeof num === 'object' &&
      num.constructor.wordSize === BN.wordSize && Array.isArray(num.words);
  };

  BN.max = function max (left, right) {
    if (left.cmp(right) > 0) return left;
    return right;
  };

  BN.min = function min (left, right) {
    if (left.cmp(right) < 0) return left;
    return right;
  };

  BN.prototype._init = function init (number, base, endian) {
    if (typeof number === 'number') {
      return this._initNumber(number, base, endian);
    }

    if (typeof number === 'object') {
      return this._initArray(number, base, endian);
    }

    if (base === 'hex') {
      base = 16;
    }
    assert(base === (base | 0) && base >= 2 && base <= 36);

    number = number.toString().replace(/\s+/g, '');
    var start = 0;
    if (number[0] === '-') {
      start++;
    }

    if (base === 16) {
      this._parseHex(number, start);
    } else {
      this._parseBase(number, base, start);
    }

    if (number[0] === '-') {
      this.negative = 1;
    }

    this.strip();

    if (endian !== 'le') return;

    this._initArray(this.toArray(), base, endian);
  };

  BN.prototype._initNumber = function _initNumber (number, base, endian) {
    if (number < 0) {
      this.negative = 1;
      number = -number;
    }
    if (number < 0x4000000) {
      this.words = [ number & 0x3ffffff ];
      this.length = 1;
    } else if (number < 0x10000000000000) {
      this.words = [
        number & 0x3ffffff,
        (number / 0x4000000) & 0x3ffffff
      ];
      this.length = 2;
    } else {
      assert(number < 0x20000000000000); // 2 ^ 53 (unsafe)
      this.words = [
        number & 0x3ffffff,
        (number / 0x4000000) & 0x3ffffff,
        1
      ];
      this.length = 3;
    }

    if (endian !== 'le') return;

    // Reverse the bytes
    this._initArray(this.toArray(), base, endian);
  };

  BN.prototype._initArray = function _initArray (number, base, endian) {
    // Perhaps a Uint8Array
    assert(typeof number.length === 'number');
    if (number.length <= 0) {
      this.words = [ 0 ];
      this.length = 1;
      return this;
    }

    this.length = Math.ceil(number.length / 3);
    this.words = new Array(this.length);
    for (var i = 0; i < this.length; i++) {
      this.words[i] = 0;
    }

    var j, w;
    var off = 0;
    if (endian === 'be') {
      for (i = number.length - 1, j = 0; i >= 0; i -= 3) {
        w = number[i] | (number[i - 1] << 8) | (number[i - 2] << 16);
        this.words[j] |= (w << off) & 0x3ffffff;
        this.words[j + 1] = (w >>> (26 - off)) & 0x3ffffff;
        off += 24;
        if (off >= 26) {
          off -= 26;
          j++;
        }
      }
    } else if (endian === 'le') {
      for (i = 0, j = 0; i < number.length; i += 3) {
        w = number[i] | (number[i + 1] << 8) | (number[i + 2] << 16);
        this.words[j] |= (w << off) & 0x3ffffff;
        this.words[j + 1] = (w >>> (26 - off)) & 0x3ffffff;
        off += 24;
        if (off >= 26) {
          off -= 26;
          j++;
        }
      }
    }
    return this.strip();
  };

  function parseHex (str, start, end) {
    var r = 0;
    var len = Math.min(str.length, end);
    for (var i = start; i < len; i++) {
      var c = str.charCodeAt(i) - 48;

      r <<= 4;

      // 'a' - 'f'
      if (c >= 49 && c <= 54) {
        r |= c - 49 + 0xa;

      // 'A' - 'F'
      } else if (c >= 17 && c <= 22) {
        r |= c - 17 + 0xa;

      // '0' - '9'
      } else {
        r |= c & 0xf;
      }
    }
    return r;
  }

  BN.prototype._parseHex = function _parseHex (number, start) {
    // Create possibly bigger array to ensure that it fits the number
    this.length = Math.ceil((number.length - start) / 6);
    this.words = new Array(this.length);
    for (var i = 0; i < this.length; i++) {
      this.words[i] = 0;
    }

    var j, w;
    // Scan 24-bit chunks and add them to the number
    var off = 0;
    for (i = number.length - 6, j = 0; i >= start; i -= 6) {
      w = parseHex(number, i, i + 6);
      this.words[j] |= (w << off) & 0x3ffffff;
      // NOTE: `0x3fffff` is intentional here, 26bits max shift + 24bit hex limb
      this.words[j + 1] |= w >>> (26 - off) & 0x3fffff;
      off += 24;
      if (off >= 26) {
        off -= 26;
        j++;
      }
    }
    if (i + 6 !== start) {
      w = parseHex(number, start, i + 6);
      this.words[j] |= (w << off) & 0x3ffffff;
      this.words[j + 1] |= w >>> (26 - off) & 0x3fffff;
    }
    this.strip();
  };

  function parseBase (str, start, end, mul) {
    var r = 0;
    var len = Math.min(str.length, end);
    for (var i = start; i < len; i++) {
      var c = str.charCodeAt(i) - 48;

      r *= mul;

      // 'a'
      if (c >= 49) {
        r += c - 49 + 0xa;

      // 'A'
      } else if (c >= 17) {
        r += c - 17 + 0xa;

      // '0' - '9'
      } else {
        r += c;
      }
    }
    return r;
  }

  BN.prototype._parseBase = function _parseBase (number, base, start) {
    // Initialize as zero
    this.words = [ 0 ];
    this.length = 1;

    // Find length of limb in base
    for (var limbLen = 0, limbPow = 1; limbPow <= 0x3ffffff; limbPow *= base) {
      limbLen++;
    }
    limbLen--;
    limbPow = (limbPow / base) | 0;

    var total = number.length - start;
    var mod = total % limbLen;
    var end = Math.min(total, total - mod) + start;

    var word = 0;
    for (var i = start; i < end; i += limbLen) {
      word = parseBase(number, i, i + limbLen, base);

      this.imuln(limbPow);
      if (this.words[0] + word < 0x4000000) {
        this.words[0] += word;
      } else {
        this._iaddn(word);
      }
    }

    if (mod !== 0) {
      var pow = 1;
      word = parseBase(number, i, number.length, base);

      for (i = 0; i < mod; i++) {
        pow *= base;
      }

      this.imuln(pow);
      if (this.words[0] + word < 0x4000000) {
        this.words[0] += word;
      } else {
        this._iaddn(word);
      }
    }
  };

  BN.prototype.copy = function copy (dest) {
    dest.words = new Array(this.length);
    for (var i = 0; i < this.length; i++) {
      dest.words[i] = this.words[i];
    }
    dest.length = this.length;
    dest.negative = this.negative;
    dest.red = this.red;
  };

  BN.prototype.clone = function clone () {
    var r = new BN(null);
    this.copy(r);
    return r;
  };

  BN.prototype._expand = function _expand (size) {
    while (this.length < size) {
      this.words[this.length++] = 0;
    }
    return this;
  };

  // Remove leading `0` from `this`
  BN.prototype.strip = function strip () {
    while (this.length > 1 && this.words[this.length - 1] === 0) {
      this.length--;
    }
    return this._normSign();
  };

  BN.prototype._normSign = function _normSign () {
    // -0 = 0
    if (this.length === 1 && this.words[0] === 0) {
      this.negative = 0;
    }
    return this;
  };

  BN.prototype.inspect = function inspect () {
    return (this.red ? '<BN-R: ' : '<BN: ') + this.toString(16) + '>';
  };

  /*

  var zeros = [];
  var groupSizes = [];
  var groupBases = [];

  var s = '';
  var i = -1;
  while (++i < BN.wordSize) {
    zeros[i] = s;
    s += '0';
  }
  groupSizes[0] = 0;
  groupSizes[1] = 0;
  groupBases[0] = 0;
  groupBases[1] = 0;
  var base = 2 - 1;
  while (++base < 36 + 1) {
    var groupSize = 0;
    var groupBase = 1;
    while (groupBase < (1 << BN.wordSize) / base) {
      groupBase *= base;
      groupSize += 1;
    }
    groupSizes[base] = groupSize;
    groupBases[base] = groupBase;
  }

  */

  var zeros = [
    '',
    '0',
    '00',
    '000',
    '0000',
    '00000',
    '000000',
    '0000000',
    '00000000',
    '000000000',
    '0000000000',
    '00000000000',
    '000000000000',
    '0000000000000',
    '00000000000000',
    '000000000000000',
    '0000000000000000',
    '00000000000000000',
    '000000000000000000',
    '0000000000000000000',
    '00000000000000000000',
    '000000000000000000000',
    '0000000000000000000000',
    '00000000000000000000000',
    '000000000000000000000000',
    '0000000000000000000000000'
  ];

  var groupSizes = [
    0, 0,
    25, 16, 12, 11, 10, 9, 8,
    8, 7, 7, 7, 7, 6, 6,
    6, 6, 6, 6, 6, 5, 5,
    5, 5, 5, 5, 5, 5, 5,
    5, 5, 5, 5, 5, 5, 5
  ];

  var groupBases = [
    0, 0,
    33554432, 43046721, 16777216, 48828125, 60466176, 40353607, 16777216,
    43046721, 10000000, 19487171, 35831808, 62748517, 7529536, 11390625,
    16777216, 24137569, 34012224, 47045881, 64000000, 4084101, 5153632,
    6436343, 7962624, 9765625, 11881376, 14348907, 17210368, 20511149,
    24300000, 28629151, 33554432, 39135393, 45435424, 52521875, 60466176
  ];

  BN.prototype.toString = function toString (base, padding) {
    base = base || 10;
    padding = padding | 0 || 1;

    var out;
    if (base === 16 || base === 'hex') {
      out = '';
      var off = 0;
      var carry = 0;
      for (var i = 0; i < this.length; i++) {
        var w = this.words[i];
        var word = (((w << off) | carry) & 0xffffff).toString(16);
        carry = (w >>> (24 - off)) & 0xffffff;
        if (carry !== 0 || i !== this.length - 1) {
          out = zeros[6 - word.length] + word + out;
        } else {
          out = word + out;
        }
        off += 2;
        if (off >= 26) {
          off -= 26;
          i--;
        }
      }
      if (carry !== 0) {
        out = carry.toString(16) + out;
      }
      while (out.length % padding !== 0) {
        out = '0' + out;
      }
      if (this.negative !== 0) {
        out = '-' + out;
      }
      return out;
    }

    if (base === (base | 0) && base >= 2 && base <= 36) {
      // var groupSize = Math.floor(BN.wordSize * Math.LN2 / Math.log(base));
      var groupSize = groupSizes[base];
      // var groupBase = Math.pow(base, groupSize);
      var groupBase = groupBases[base];
      out = '';
      var c = this.clone();
      c.negative = 0;
      while (!c.isZero()) {
        var r = c.modn(groupBase).toString(base);
        c = c.idivn(groupBase);

        if (!c.isZero()) {
          out = zeros[groupSize - r.length] + r + out;
        } else {
          out = r + out;
        }
      }
      if (this.isZero()) {
        out = '0' + out;
      }
      while (out.length % padding !== 0) {
        out = '0' + out;
      }
      if (this.negative !== 0) {
        out = '-' + out;
      }
      return out;
    }

    assert(false, 'Base should be between 2 and 36');
  };

  BN.prototype.toNumber = function toNumber () {
    var ret = this.words[0];
    if (this.length === 2) {
      ret += this.words[1] * 0x4000000;
    } else if (this.length === 3 && this.words[2] === 0x01) {
      // NOTE: at this stage it is known that the top bit is set
      ret += 0x10000000000000 + (this.words[1] * 0x4000000);
    } else if (this.length > 2) {
      assert(false, 'Number can only safely store up to 53 bits');
    }
    return (this.negative !== 0) ? -ret : ret;
  };

  BN.prototype.toJSON = function toJSON () {
    return this.toString(16);
  };

  BN.prototype.toBuffer = function toBuffer (endian, length) {
    assert(typeof Buffer !== 'undefined');
    return this.toArrayLike(Buffer, endian, length);
  };

  BN.prototype.toArray = function toArray (endian, length) {
    return this.toArrayLike(Array, endian, length);
  };

  BN.prototype.toArrayLike = function toArrayLike (ArrayType, endian, length) {
    var byteLength = this.byteLength();
    var reqLength = length || Math.max(1, byteLength);
    assert(byteLength <= reqLength, 'byte array longer than desired length');
    assert(reqLength > 0, 'Requested array length <= 0');

    this.strip();
    var littleEndian = endian === 'le';
    var res = new ArrayType(reqLength);

    var b, i;
    var q = this.clone();
    if (!littleEndian) {
      // Assume big-endian
      for (i = 0; i < reqLength - byteLength; i++) {
        res[i] = 0;
      }

      for (i = 0; !q.isZero(); i++) {
        b = q.andln(0xff);
        q.iushrn(8);

        res[reqLength - i - 1] = b;
      }
    } else {
      for (i = 0; !q.isZero(); i++) {
        b = q.andln(0xff);
        q.iushrn(8);

        res[i] = b;
      }

      for (; i < reqLength; i++) {
        res[i] = 0;
      }
    }

    return res;
  };

  if (Math.clz32) {
    BN.prototype._countBits = function _countBits (w) {
      return 32 - Math.clz32(w);
    };
  } else {
    BN.prototype._countBits = function _countBits (w) {
      var t = w;
      var r = 0;
      if (t >= 0x1000) {
        r += 13;
        t >>>= 13;
      }
      if (t >= 0x40) {
        r += 7;
        t >>>= 7;
      }
      if (t >= 0x8) {
        r += 4;
        t >>>= 4;
      }
      if (t >= 0x02) {
        r += 2;
        t >>>= 2;
      }
      return r + t;
    };
  }

  BN.prototype._zeroBits = function _zeroBits (w) {
    // Short-cut
    if (w === 0) return 26;

    var t = w;
    var r = 0;
    if ((t & 0x1fff) === 0) {
      r += 13;
      t >>>= 13;
    }
    if ((t & 0x7f) === 0) {
      r += 7;
      t >>>= 7;
    }
    if ((t & 0xf) === 0) {
      r += 4;
      t >>>= 4;
    }
    if ((t & 0x3) === 0) {
      r += 2;
      t >>>= 2;
    }
    if ((t & 0x1) === 0) {
      r++;
    }
    return r;
  };

  // Return number of used bits in a BN
  BN.prototype.bitLength = function bitLength () {
    var w = this.words[this.length - 1];
    var hi = this._countBits(w);
    return (this.length - 1) * 26 + hi;
  };

  function toBitArray (num) {
    var w = new Array(num.bitLength());

    for (var bit = 0; bit < w.length; bit++) {
      var off = (bit / 26) | 0;
      var wbit = bit % 26;

      w[bit] = (num.words[off] & (1 << wbit)) >>> wbit;
    }

    return w;
  }

  // Number of trailing zero bits
  BN.prototype.zeroBits = function zeroBits () {
    if (this.isZero()) return 0;

    var r = 0;
    for (var i = 0; i < this.length; i++) {
      var b = this._zeroBits(this.words[i]);
      r += b;
      if (b !== 26) break;
    }
    return r;
  };

  BN.prototype.byteLength = function byteLength () {
    return Math.ceil(this.bitLength() / 8);
  };

  BN.prototype.toTwos = function toTwos (width) {
    if (this.negative !== 0) {
      return this.abs().inotn(width).iaddn(1);
    }
    return this.clone();
  };

  BN.prototype.fromTwos = function fromTwos (width) {
    if (this.testn(width - 1)) {
      return this.notn(width).iaddn(1).ineg();
    }
    return this.clone();
  };

  BN.prototype.isNeg = function isNeg () {
    return this.negative !== 0;
  };

  // Return negative clone of `this`
  BN.prototype.neg = function neg () {
    return this.clone().ineg();
  };

  BN.prototype.ineg = function ineg () {
    if (!this.isZero()) {
      this.negative ^= 1;
    }

    return this;
  };

  // Or `num` with `this` in-place
  BN.prototype.iuor = function iuor (num) {
    while (this.length < num.length) {
      this.words[this.length++] = 0;
    }

    for (var i = 0; i < num.length; i++) {
      this.words[i] = this.words[i] | num.words[i];
    }

    return this.strip();
  };

  BN.prototype.ior = function ior (num) {
    assert((this.negative | num.negative) === 0);
    return this.iuor(num);
  };

  // Or `num` with `this`
  BN.prototype.or = function or (num) {
    if (this.length > num.length) return this.clone().ior(num);
    return num.clone().ior(this);
  };

  BN.prototype.uor = function uor (num) {
    if (this.length > num.length) return this.clone().iuor(num);
    return num.clone().iuor(this);
  };

  // And `num` with `this` in-place
  BN.prototype.iuand = function iuand (num) {
    // b = min-length(num, this)
    var b;
    if (this.length > num.length) {
      b = num;
    } else {
      b = this;
    }

    for (var i = 0; i < b.length; i++) {
      this.words[i] = this.words[i] & num.words[i];
    }

    this.length = b.length;

    return this.strip();
  };

  BN.prototype.iand = function iand (num) {
    assert((this.negative | num.negative) === 0);
    return this.iuand(num);
  };

  // And `num` with `this`
  BN.prototype.and = function and (num) {
    if (this.length > num.length) return this.clone().iand(num);
    return num.clone().iand(this);
  };

  BN.prototype.uand = function uand (num) {
    if (this.length > num.length) return this.clone().iuand(num);
    return num.clone().iuand(this);
  };

  // Xor `num` with `this` in-place
  BN.prototype.iuxor = function iuxor (num) {
    // a.length > b.length
    var a;
    var b;
    if (this.length > num.length) {
      a = this;
      b = num;
    } else {
      a = num;
      b = this;
    }

    for (var i = 0; i < b.length; i++) {
      this.words[i] = a.words[i] ^ b.words[i];
    }

    if (this !== a) {
      for (; i < a.length; i++) {
        this.words[i] = a.words[i];
      }
    }

    this.length = a.length;

    return this.strip();
  };

  BN.prototype.ixor = function ixor (num) {
    assert((this.negative | num.negative) === 0);
    return this.iuxor(num);
  };

  // Xor `num` with `this`
  BN.prototype.xor = function xor (num) {
    if (this.length > num.length) return this.clone().ixor(num);
    return num.clone().ixor(this);
  };

  BN.prototype.uxor = function uxor (num) {
    if (this.length > num.length) return this.clone().iuxor(num);
    return num.clone().iuxor(this);
  };

  // Not ``this`` with ``width`` bitwidth
  BN.prototype.inotn = function inotn (width) {
    assert(typeof width === 'number' && width >= 0);

    var bytesNeeded = Math.ceil(width / 26) | 0;
    var bitsLeft = width % 26;

    // Extend the buffer with leading zeroes
    this._expand(bytesNeeded);

    if (bitsLeft > 0) {
      bytesNeeded--;
    }

    // Handle complete words
    for (var i = 0; i < bytesNeeded; i++) {
      this.words[i] = ~this.words[i] & 0x3ffffff;
    }

    // Handle the residue
    if (bitsLeft > 0) {
      this.words[i] = ~this.words[i] & (0x3ffffff >> (26 - bitsLeft));
    }

    // And remove leading zeroes
    return this.strip();
  };

  BN.prototype.notn = function notn (width) {
    return this.clone().inotn(width);
  };

  // Set `bit` of `this`
  BN.prototype.setn = function setn (bit, val) {
    assert(typeof bit === 'number' && bit >= 0);

    var off = (bit / 26) | 0;
    var wbit = bit % 26;

    this._expand(off + 1);

    if (val) {
      this.words[off] = this.words[off] | (1 << wbit);
    } else {
      this.words[off] = this.words[off] & ~(1 << wbit);
    }

    return this.strip();
  };

  // Add `num` to `this` in-place
  BN.prototype.iadd = function iadd (num) {
    var r;

    // negative + positive
    if (this.negative !== 0 && num.negative === 0) {
      this.negative = 0;
      r = this.isub(num);
      this.negative ^= 1;
      return this._normSign();

    // positive + negative
    } else if (this.negative === 0 && num.negative !== 0) {
      num.negative = 0;
      r = this.isub(num);
      num.negative = 1;
      return r._normSign();
    }

    // a.length > b.length
    var a, b;
    if (this.length > num.length) {
      a = this;
      b = num;
    } else {
      a = num;
      b = this;
    }

    var carry = 0;
    for (var i = 0; i < b.length; i++) {
      r = (a.words[i] | 0) + (b.words[i] | 0) + carry;
      this.words[i] = r & 0x3ffffff;
      carry = r >>> 26;
    }
    for (; carry !== 0 && i < a.length; i++) {
      r = (a.words[i] | 0) + carry;
      this.words[i] = r & 0x3ffffff;
      carry = r >>> 26;
    }

    this.length = a.length;
    if (carry !== 0) {
      this.words[this.length] = carry;
      this.length++;
    // Copy the rest of the words
    } else if (a !== this) {
      for (; i < a.length; i++) {
        this.words[i] = a.words[i];
      }
    }

    return this;
  };

  // Add `num` to `this`
  BN.prototype.add = function add (num) {
    var res;
    if (num.negative !== 0 && this.negative === 0) {
      num.negative = 0;
      res = this.sub(num);
      num.negative ^= 1;
      return res;
    } else if (num.negative === 0 && this.negative !== 0) {
      this.negative = 0;
      res = num.sub(this);
      this.negative = 1;
      return res;
    }

    if (this.length > num.length) return this.clone().iadd(num);

    return num.clone().iadd(this);
  };

  // Subtract `num` from `this` in-place
  BN.prototype.isub = function isub (num) {
    // this - (-num) = this + num
    if (num.negative !== 0) {
      num.negative = 0;
      var r = this.iadd(num);
      num.negative = 1;
      return r._normSign();

    // -this - num = -(this + num)
    } else if (this.negative !== 0) {
      this.negative = 0;
      this.iadd(num);
      this.negative = 1;
      return this._normSign();
    }

    // At this point both numbers are positive
    var cmp = this.cmp(num);

    // Optimization - zeroify
    if (cmp === 0) {
      this.negative = 0;
      this.length = 1;
      this.words[0] = 0;
      return this;
    }

    // a > b
    var a, b;
    if (cmp > 0) {
      a = this;
      b = num;
    } else {
      a = num;
      b = this;
    }

    var carry = 0;
    for (var i = 0; i < b.length; i++) {
      r = (a.words[i] | 0) - (b.words[i] | 0) + carry;
      carry = r >> 26;
      this.words[i] = r & 0x3ffffff;
    }
    for (; carry !== 0 && i < a.length; i++) {
      r = (a.words[i] | 0) + carry;
      carry = r >> 26;
      this.words[i] = r & 0x3ffffff;
    }

    // Copy rest of the words
    if (carry === 0 && i < a.length && a !== this) {
      for (; i < a.length; i++) {
        this.words[i] = a.words[i];
      }
    }

    this.length = Math.max(this.length, i);

    if (a !== this) {
      this.negative = 1;
    }

    return this.strip();
  };

  // Subtract `num` from `this`
  BN.prototype.sub = function sub (num) {
    return this.clone().isub(num);
  };

  function smallMulTo (self, num, out) {
    out.negative = num.negative ^ self.negative;
    var len = (self.length + num.length) | 0;
    out.length = len;
    len = (len - 1) | 0;

    // Peel one iteration (compiler can't do it, because of code complexity)
    var a = self.words[0] | 0;
    var b = num.words[0] | 0;
    var r = a * b;

    var lo = r & 0x3ffffff;
    var carry = (r / 0x4000000) | 0;
    out.words[0] = lo;

    for (var k = 1; k < len; k++) {
      // Sum all words with the same `i + j = k` and accumulate `ncarry`,
      // note that ncarry could be >= 0x3ffffff
      var ncarry = carry >>> 26;
      var rword = carry & 0x3ffffff;
      var maxJ = Math.min(k, num.length - 1);
      for (var j = Math.max(0, k - self.length + 1); j <= maxJ; j++) {
        var i = (k - j) | 0;
        a = self.words[i] | 0;
        b = num.words[j] | 0;
        r = a * b + rword;
        ncarry += (r / 0x4000000) | 0;
        rword = r & 0x3ffffff;
      }
      out.words[k] = rword | 0;
      carry = ncarry | 0;
    }
    if (carry !== 0) {
      out.words[k] = carry | 0;
    } else {
      out.length--;
    }

    return out.strip();
  }

  // TODO(indutny): it may be reasonable to omit it for users who don't need
  // to work with 256-bit numbers, otherwise it gives 20% improvement for 256-bit
  // multiplication (like elliptic secp256k1).
  var comb10MulTo = function comb10MulTo (self, num, out) {
    var a = self.words;
    var b = num.words;
    var o = out.words;
    var c = 0;
    var lo;
    var mid;
    var hi;
    var a0 = a[0] | 0;
    var al0 = a0 & 0x1fff;
    var ah0 = a0 >>> 13;
    var a1 = a[1] | 0;
    var al1 = a1 & 0x1fff;
    var ah1 = a1 >>> 13;
    var a2 = a[2] | 0;
    var al2 = a2 & 0x1fff;
    var ah2 = a2 >>> 13;
    var a3 = a[3] | 0;
    var al3 = a3 & 0x1fff;
    var ah3 = a3 >>> 13;
    var a4 = a[4] | 0;
    var al4 = a4 & 0x1fff;
    var ah4 = a4 >>> 13;
    var a5 = a[5] | 0;
    var al5 = a5 & 0x1fff;
    var ah5 = a5 >>> 13;
    var a6 = a[6] | 0;
    var al6 = a6 & 0x1fff;
    var ah6 = a6 >>> 13;
    var a7 = a[7] | 0;
    var al7 = a7 & 0x1fff;
    var ah7 = a7 >>> 13;
    var a8 = a[8] | 0;
    var al8 = a8 & 0x1fff;
    var ah8 = a8 >>> 13;
    var a9 = a[9] | 0;
    var al9 = a9 & 0x1fff;
    var ah9 = a9 >>> 13;
    var b0 = b[0] | 0;
    var bl0 = b0 & 0x1fff;
    var bh0 = b0 >>> 13;
    var b1 = b[1] | 0;
    var bl1 = b1 & 0x1fff;
    var bh1 = b1 >>> 13;
    var b2 = b[2] | 0;
    var bl2 = b2 & 0x1fff;
    var bh2 = b2 >>> 13;
    var b3 = b[3] | 0;
    var bl3 = b3 & 0x1fff;
    var bh3 = b3 >>> 13;
    var b4 = b[4] | 0;
    var bl4 = b4 & 0x1fff;
    var bh4 = b4 >>> 13;
    var b5 = b[5] | 0;
    var bl5 = b5 & 0x1fff;
    var bh5 = b5 >>> 13;
    var b6 = b[6] | 0;
    var bl6 = b6 & 0x1fff;
    var bh6 = b6 >>> 13;
    var b7 = b[7] | 0;
    var bl7 = b7 & 0x1fff;
    var bh7 = b7 >>> 13;
    var b8 = b[8] | 0;
    var bl8 = b8 & 0x1fff;
    var bh8 = b8 >>> 13;
    var b9 = b[9] | 0;
    var bl9 = b9 & 0x1fff;
    var bh9 = b9 >>> 13;

    out.negative = self.negative ^ num.negative;
    out.length = 19;
    /* k = 0 */
    lo = Math.imul(al0, bl0);
    mid = Math.imul(al0, bh0);
    mid = (mid + Math.imul(ah0, bl0)) | 0;
    hi = Math.imul(ah0, bh0);
    var w0 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w0 >>> 26)) | 0;
    w0 &= 0x3ffffff;
    /* k = 1 */
    lo = Math.imul(al1, bl0);
    mid = Math.imul(al1, bh0);
    mid = (mid + Math.imul(ah1, bl0)) | 0;
    hi = Math.imul(ah1, bh0);
    lo = (lo + Math.imul(al0, bl1)) | 0;
    mid = (mid + Math.imul(al0, bh1)) | 0;
    mid = (mid + Math.imul(ah0, bl1)) | 0;
    hi = (hi + Math.imul(ah0, bh1)) | 0;
    var w1 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w1 >>> 26)) | 0;
    w1 &= 0x3ffffff;
    /* k = 2 */
    lo = Math.imul(al2, bl0);
    mid = Math.imul(al2, bh0);
    mid = (mid + Math.imul(ah2, bl0)) | 0;
    hi = Math.imul(ah2, bh0);
    lo = (lo + Math.imul(al1, bl1)) | 0;
    mid = (mid + Math.imul(al1, bh1)) | 0;
    mid = (mid + Math.imul(ah1, bl1)) | 0;
    hi = (hi + Math.imul(ah1, bh1)) | 0;
    lo = (lo + Math.imul(al0, bl2)) | 0;
    mid = (mid + Math.imul(al0, bh2)) | 0;
    mid = (mid + Math.imul(ah0, bl2)) | 0;
    hi = (hi + Math.imul(ah0, bh2)) | 0;
    var w2 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w2 >>> 26)) | 0;
    w2 &= 0x3ffffff;
    /* k = 3 */
    lo = Math.imul(al3, bl0);
    mid = Math.imul(al3, bh0);
    mid = (mid + Math.imul(ah3, bl0)) | 0;
    hi = Math.imul(ah3, bh0);
    lo = (lo + Math.imul(al2, bl1)) | 0;
    mid = (mid + Math.imul(al2, bh1)) | 0;
    mid = (mid + Math.imul(ah2, bl1)) | 0;
    hi = (hi + Math.imul(ah2, bh1)) | 0;
    lo = (lo + Math.imul(al1, bl2)) | 0;
    mid = (mid + Math.imul(al1, bh2)) | 0;
    mid = (mid + Math.imul(ah1, bl2)) | 0;
    hi = (hi + Math.imul(ah1, bh2)) | 0;
    lo = (lo + Math.imul(al0, bl3)) | 0;
    mid = (mid + Math.imul(al0, bh3)) | 0;
    mid = (mid + Math.imul(ah0, bl3)) | 0;
    hi = (hi + Math.imul(ah0, bh3)) | 0;
    var w3 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w3 >>> 26)) | 0;
    w3 &= 0x3ffffff;
    /* k = 4 */
    lo = Math.imul(al4, bl0);
    mid = Math.imul(al4, bh0);
    mid = (mid + Math.imul(ah4, bl0)) | 0;
    hi = Math.imul(ah4, bh0);
    lo = (lo + Math.imul(al3, bl1)) | 0;
    mid = (mid + Math.imul(al3, bh1)) | 0;
    mid = (mid + Math.imul(ah3, bl1)) | 0;
    hi = (hi + Math.imul(ah3, bh1)) | 0;
    lo = (lo + Math.imul(al2, bl2)) | 0;
    mid = (mid + Math.imul(al2, bh2)) | 0;
    mid = (mid + Math.imul(ah2, bl2)) | 0;
    hi = (hi + Math.imul(ah2, bh2)) | 0;
    lo = (lo + Math.imul(al1, bl3)) | 0;
    mid = (mid + Math.imul(al1, bh3)) | 0;
    mid = (mid + Math.imul(ah1, bl3)) | 0;
    hi = (hi + Math.imul(ah1, bh3)) | 0;
    lo = (lo + Math.imul(al0, bl4)) | 0;
    mid = (mid + Math.imul(al0, bh4)) | 0;
    mid = (mid + Math.imul(ah0, bl4)) | 0;
    hi = (hi + Math.imul(ah0, bh4)) | 0;
    var w4 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w4 >>> 26)) | 0;
    w4 &= 0x3ffffff;
    /* k = 5 */
    lo = Math.imul(al5, bl0);
    mid = Math.imul(al5, bh0);
    mid = (mid + Math.imul(ah5, bl0)) | 0;
    hi = Math.imul(ah5, bh0);
    lo = (lo + Math.imul(al4, bl1)) | 0;
    mid = (mid + Math.imul(al4, bh1)) | 0;
    mid = (mid + Math.imul(ah4, bl1)) | 0;
    hi = (hi + Math.imul(ah4, bh1)) | 0;
    lo = (lo + Math.imul(al3, bl2)) | 0;
    mid = (mid + Math.imul(al3, bh2)) | 0;
    mid = (mid + Math.imul(ah3, bl2)) | 0;
    hi = (hi + Math.imul(ah3, bh2)) | 0;
    lo = (lo + Math.imul(al2, bl3)) | 0;
    mid = (mid + Math.imul(al2, bh3)) | 0;
    mid = (mid + Math.imul(ah2, bl3)) | 0;
    hi = (hi + Math.imul(ah2, bh3)) | 0;
    lo = (lo + Math.imul(al1, bl4)) | 0;
    mid = (mid + Math.imul(al1, bh4)) | 0;
    mid = (mid + Math.imul(ah1, bl4)) | 0;
    hi = (hi + Math.imul(ah1, bh4)) | 0;
    lo = (lo + Math.imul(al0, bl5)) | 0;
    mid = (mid + Math.imul(al0, bh5)) | 0;
    mid = (mid + Math.imul(ah0, bl5)) | 0;
    hi = (hi + Math.imul(ah0, bh5)) | 0;
    var w5 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w5 >>> 26)) | 0;
    w5 &= 0x3ffffff;
    /* k = 6 */
    lo = Math.imul(al6, bl0);
    mid = Math.imul(al6, bh0);
    mid = (mid + Math.imul(ah6, bl0)) | 0;
    hi = Math.imul(ah6, bh0);
    lo = (lo + Math.imul(al5, bl1)) | 0;
    mid = (mid + Math.imul(al5, bh1)) | 0;
    mid = (mid + Math.imul(ah5, bl1)) | 0;
    hi = (hi + Math.imul(ah5, bh1)) | 0;
    lo = (lo + Math.imul(al4, bl2)) | 0;
    mid = (mid + Math.imul(al4, bh2)) | 0;
    mid = (mid + Math.imul(ah4, bl2)) | 0;
    hi = (hi + Math.imul(ah4, bh2)) | 0;
    lo = (lo + Math.imul(al3, bl3)) | 0;
    mid = (mid + Math.imul(al3, bh3)) | 0;
    mid = (mid + Math.imul(ah3, bl3)) | 0;
    hi = (hi + Math.imul(ah3, bh3)) | 0;
    lo = (lo + Math.imul(al2, bl4)) | 0;
    mid = (mid + Math.imul(al2, bh4)) | 0;
    mid = (mid + Math.imul(ah2, bl4)) | 0;
    hi = (hi + Math.imul(ah2, bh4)) | 0;
    lo = (lo + Math.imul(al1, bl5)) | 0;
    mid = (mid + Math.imul(al1, bh5)) | 0;
    mid = (mid + Math.imul(ah1, bl5)) | 0;
    hi = (hi + Math.imul(ah1, bh5)) | 0;
    lo = (lo + Math.imul(al0, bl6)) | 0;
    mid = (mid + Math.imul(al0, bh6)) | 0;
    mid = (mid + Math.imul(ah0, bl6)) | 0;
    hi = (hi + Math.imul(ah0, bh6)) | 0;
    var w6 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w6 >>> 26)) | 0;
    w6 &= 0x3ffffff;
    /* k = 7 */
    lo = Math.imul(al7, bl0);
    mid = Math.imul(al7, bh0);
    mid = (mid + Math.imul(ah7, bl0)) | 0;
    hi = Math.imul(ah7, bh0);
    lo = (lo + Math.imul(al6, bl1)) | 0;
    mid = (mid + Math.imul(al6, bh1)) | 0;
    mid = (mid + Math.imul(ah6, bl1)) | 0;
    hi = (hi + Math.imul(ah6, bh1)) | 0;
    lo = (lo + Math.imul(al5, bl2)) | 0;
    mid = (mid + Math.imul(al5, bh2)) | 0;
    mid = (mid + Math.imul(ah5, bl2)) | 0;
    hi = (hi + Math.imul(ah5, bh2)) | 0;
    lo = (lo + Math.imul(al4, bl3)) | 0;
    mid = (mid + Math.imul(al4, bh3)) | 0;
    mid = (mid + Math.imul(ah4, bl3)) | 0;
    hi = (hi + Math.imul(ah4, bh3)) | 0;
    lo = (lo + Math.imul(al3, bl4)) | 0;
    mid = (mid + Math.imul(al3, bh4)) | 0;
    mid = (mid + Math.imul(ah3, bl4)) | 0;
    hi = (hi + Math.imul(ah3, bh4)) | 0;
    lo = (lo + Math.imul(al2, bl5)) | 0;
    mid = (mid + Math.imul(al2, bh5)) | 0;
    mid = (mid + Math.imul(ah2, bl5)) | 0;
    hi = (hi + Math.imul(ah2, bh5)) | 0;
    lo = (lo + Math.imul(al1, bl6)) | 0;
    mid = (mid + Math.imul(al1, bh6)) | 0;
    mid = (mid + Math.imul(ah1, bl6)) | 0;
    hi = (hi + Math.imul(ah1, bh6)) | 0;
    lo = (lo + Math.imul(al0, bl7)) | 0;
    mid = (mid + Math.imul(al0, bh7)) | 0;
    mid = (mid + Math.imul(ah0, bl7)) | 0;
    hi = (hi + Math.imul(ah0, bh7)) | 0;
    var w7 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w7 >>> 26)) | 0;
    w7 &= 0x3ffffff;
    /* k = 8 */
    lo = Math.imul(al8, bl0);
    mid = Math.imul(al8, bh0);
    mid = (mid + Math.imul(ah8, bl0)) | 0;
    hi = Math.imul(ah8, bh0);
    lo = (lo + Math.imul(al7, bl1)) | 0;
    mid = (mid + Math.imul(al7, bh1)) | 0;
    mid = (mid + Math.imul(ah7, bl1)) | 0;
    hi = (hi + Math.imul(ah7, bh1)) | 0;
    lo = (lo + Math.imul(al6, bl2)) | 0;
    mid = (mid + Math.imul(al6, bh2)) | 0;
    mid = (mid + Math.imul(ah6, bl2)) | 0;
    hi = (hi + Math.imul(ah6, bh2)) | 0;
    lo = (lo + Math.imul(al5, bl3)) | 0;
    mid = (mid + Math.imul(al5, bh3)) | 0;
    mid = (mid + Math.imul(ah5, bl3)) | 0;
    hi = (hi + Math.imul(ah5, bh3)) | 0;
    lo = (lo + Math.imul(al4, bl4)) | 0;
    mid = (mid + Math.imul(al4, bh4)) | 0;
    mid = (mid + Math.imul(ah4, bl4)) | 0;
    hi = (hi + Math.imul(ah4, bh4)) | 0;
    lo = (lo + Math.imul(al3, bl5)) | 0;
    mid = (mid + Math.imul(al3, bh5)) | 0;
    mid = (mid + Math.imul(ah3, bl5)) | 0;
    hi = (hi + Math.imul(ah3, bh5)) | 0;
    lo = (lo + Math.imul(al2, bl6)) | 0;
    mid = (mid + Math.imul(al2, bh6)) | 0;
    mid = (mid + Math.imul(ah2, bl6)) | 0;
    hi = (hi + Math.imul(ah2, bh6)) | 0;
    lo = (lo + Math.imul(al1, bl7)) | 0;
    mid = (mid + Math.imul(al1, bh7)) | 0;
    mid = (mid + Math.imul(ah1, bl7)) | 0;
    hi = (hi + Math.imul(ah1, bh7)) | 0;
    lo = (lo + Math.imul(al0, bl8)) | 0;
    mid = (mid + Math.imul(al0, bh8)) | 0;
    mid = (mid + Math.imul(ah0, bl8)) | 0;
    hi = (hi + Math.imul(ah0, bh8)) | 0;
    var w8 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w8 >>> 26)) | 0;
    w8 &= 0x3ffffff;
    /* k = 9 */
    lo = Math.imul(al9, bl0);
    mid = Math.imul(al9, bh0);
    mid = (mid + Math.imul(ah9, bl0)) | 0;
    hi = Math.imul(ah9, bh0);
    lo = (lo + Math.imul(al8, bl1)) | 0;
    mid = (mid + Math.imul(al8, bh1)) | 0;
    mid = (mid + Math.imul(ah8, bl1)) | 0;
    hi = (hi + Math.imul(ah8, bh1)) | 0;
    lo = (lo + Math.imul(al7, bl2)) | 0;
    mid = (mid + Math.imul(al7, bh2)) | 0;
    mid = (mid + Math.imul(ah7, bl2)) | 0;
    hi = (hi + Math.imul(ah7, bh2)) | 0;
    lo = (lo + Math.imul(al6, bl3)) | 0;
    mid = (mid + Math.imul(al6, bh3)) | 0;
    mid = (mid + Math.imul(ah6, bl3)) | 0;
    hi = (hi + Math.imul(ah6, bh3)) | 0;
    lo = (lo + Math.imul(al5, bl4)) | 0;
    mid = (mid + Math.imul(al5, bh4)) | 0;
    mid = (mid + Math.imul(ah5, bl4)) | 0;
    hi = (hi + Math.imul(ah5, bh4)) | 0;
    lo = (lo + Math.imul(al4, bl5)) | 0;
    mid = (mid + Math.imul(al4, bh5)) | 0;
    mid = (mid + Math.imul(ah4, bl5)) | 0;
    hi = (hi + Math.imul(ah4, bh5)) | 0;
    lo = (lo + Math.imul(al3, bl6)) | 0;
    mid = (mid + Math.imul(al3, bh6)) | 0;
    mid = (mid + Math.imul(ah3, bl6)) | 0;
    hi = (hi + Math.imul(ah3, bh6)) | 0;
    lo = (lo + Math.imul(al2, bl7)) | 0;
    mid = (mid + Math.imul(al2, bh7)) | 0;
    mid = (mid + Math.imul(ah2, bl7)) | 0;
    hi = (hi + Math.imul(ah2, bh7)) | 0;
    lo = (lo + Math.imul(al1, bl8)) | 0;
    mid = (mid + Math.imul(al1, bh8)) | 0;
    mid = (mid + Math.imul(ah1, bl8)) | 0;
    hi = (hi + Math.imul(ah1, bh8)) | 0;
    lo = (lo + Math.imul(al0, bl9)) | 0;
    mid = (mid + Math.imul(al0, bh9)) | 0;
    mid = (mid + Math.imul(ah0, bl9)) | 0;
    hi = (hi + Math.imul(ah0, bh9)) | 0;
    var w9 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w9 >>> 26)) | 0;
    w9 &= 0x3ffffff;
    /* k = 10 */
    lo = Math.imul(al9, bl1);
    mid = Math.imul(al9, bh1);
    mid = (mid + Math.imul(ah9, bl1)) | 0;
    hi = Math.imul(ah9, bh1);
    lo = (lo + Math.imul(al8, bl2)) | 0;
    mid = (mid + Math.imul(al8, bh2)) | 0;
    mid = (mid + Math.imul(ah8, bl2)) | 0;
    hi = (hi + Math.imul(ah8, bh2)) | 0;
    lo = (lo + Math.imul(al7, bl3)) | 0;
    mid = (mid + Math.imul(al7, bh3)) | 0;
    mid = (mid + Math.imul(ah7, bl3)) | 0;
    hi = (hi + Math.imul(ah7, bh3)) | 0;
    lo = (lo + Math.imul(al6, bl4)) | 0;
    mid = (mid + Math.imul(al6, bh4)) | 0;
    mid = (mid + Math.imul(ah6, bl4)) | 0;
    hi = (hi + Math.imul(ah6, bh4)) | 0;
    lo = (lo + Math.imul(al5, bl5)) | 0;
    mid = (mid + Math.imul(al5, bh5)) | 0;
    mid = (mid + Math.imul(ah5, bl5)) | 0;
    hi = (hi + Math.imul(ah5, bh5)) | 0;
    lo = (lo + Math.imul(al4, bl6)) | 0;
    mid = (mid + Math.imul(al4, bh6)) | 0;
    mid = (mid + Math.imul(ah4, bl6)) | 0;
    hi = (hi + Math.imul(ah4, bh6)) | 0;
    lo = (lo + Math.imul(al3, bl7)) | 0;
    mid = (mid + Math.imul(al3, bh7)) | 0;
    mid = (mid + Math.imul(ah3, bl7)) | 0;
    hi = (hi + Math.imul(ah3, bh7)) | 0;
    lo = (lo + Math.imul(al2, bl8)) | 0;
    mid = (mid + Math.imul(al2, bh8)) | 0;
    mid = (mid + Math.imul(ah2, bl8)) | 0;
    hi = (hi + Math.imul(ah2, bh8)) | 0;
    lo = (lo + Math.imul(al1, bl9)) | 0;
    mid = (mid + Math.imul(al1, bh9)) | 0;
    mid = (mid + Math.imul(ah1, bl9)) | 0;
    hi = (hi + Math.imul(ah1, bh9)) | 0;
    var w10 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w10 >>> 26)) | 0;
    w10 &= 0x3ffffff;
    /* k = 11 */
    lo = Math.imul(al9, bl2);
    mid = Math.imul(al9, bh2);
    mid = (mid + Math.imul(ah9, bl2)) | 0;
    hi = Math.imul(ah9, bh2);
    lo = (lo + Math.imul(al8, bl3)) | 0;
    mid = (mid + Math.imul(al8, bh3)) | 0;
    mid = (mid + Math.imul(ah8, bl3)) | 0;
    hi = (hi + Math.imul(ah8, bh3)) | 0;
    lo = (lo + Math.imul(al7, bl4)) | 0;
    mid = (mid + Math.imul(al7, bh4)) | 0;
    mid = (mid + Math.imul(ah7, bl4)) | 0;
    hi = (hi + Math.imul(ah7, bh4)) | 0;
    lo = (lo + Math.imul(al6, bl5)) | 0;
    mid = (mid + Math.imul(al6, bh5)) | 0;
    mid = (mid + Math.imul(ah6, bl5)) | 0;
    hi = (hi + Math.imul(ah6, bh5)) | 0;
    lo = (lo + Math.imul(al5, bl6)) | 0;
    mid = (mid + Math.imul(al5, bh6)) | 0;
    mid = (mid + Math.imul(ah5, bl6)) | 0;
    hi = (hi + Math.imul(ah5, bh6)) | 0;
    lo = (lo + Math.imul(al4, bl7)) | 0;
    mid = (mid + Math.imul(al4, bh7)) | 0;
    mid = (mid + Math.imul(ah4, bl7)) | 0;
    hi = (hi + Math.imul(ah4, bh7)) | 0;
    lo = (lo + Math.imul(al3, bl8)) | 0;
    mid = (mid + Math.imul(al3, bh8)) | 0;
    mid = (mid + Math.imul(ah3, bl8)) | 0;
    hi = (hi + Math.imul(ah3, bh8)) | 0;
    lo = (lo + Math.imul(al2, bl9)) | 0;
    mid = (mid + Math.imul(al2, bh9)) | 0;
    mid = (mid + Math.imul(ah2, bl9)) | 0;
    hi = (hi + Math.imul(ah2, bh9)) | 0;
    var w11 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w11 >>> 26)) | 0;
    w11 &= 0x3ffffff;
    /* k = 12 */
    lo = Math.imul(al9, bl3);
    mid = Math.imul(al9, bh3);
    mid = (mid + Math.imul(ah9, bl3)) | 0;
    hi = Math.imul(ah9, bh3);
    lo = (lo + Math.imul(al8, bl4)) | 0;
    mid = (mid + Math.imul(al8, bh4)) | 0;
    mid = (mid + Math.imul(ah8, bl4)) | 0;
    hi = (hi + Math.imul(ah8, bh4)) | 0;
    lo = (lo + Math.imul(al7, bl5)) | 0;
    mid = (mid + Math.imul(al7, bh5)) | 0;
    mid = (mid + Math.imul(ah7, bl5)) | 0;
    hi = (hi + Math.imul(ah7, bh5)) | 0;
    lo = (lo + Math.imul(al6, bl6)) | 0;
    mid = (mid + Math.imul(al6, bh6)) | 0;
    mid = (mid + Math.imul(ah6, bl6)) | 0;
    hi = (hi + Math.imul(ah6, bh6)) | 0;
    lo = (lo + Math.imul(al5, bl7)) | 0;
    mid = (mid + Math.imul(al5, bh7)) | 0;
    mid = (mid + Math.imul(ah5, bl7)) | 0;
    hi = (hi + Math.imul(ah5, bh7)) | 0;
    lo = (lo + Math.imul(al4, bl8)) | 0;
    mid = (mid + Math.imul(al4, bh8)) | 0;
    mid = (mid + Math.imul(ah4, bl8)) | 0;
    hi = (hi + Math.imul(ah4, bh8)) | 0;
    lo = (lo + Math.imul(al3, bl9)) | 0;
    mid = (mid + Math.imul(al3, bh9)) | 0;
    mid = (mid + Math.imul(ah3, bl9)) | 0;
    hi = (hi + Math.imul(ah3, bh9)) | 0;
    var w12 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w12 >>> 26)) | 0;
    w12 &= 0x3ffffff;
    /* k = 13 */
    lo = Math.imul(al9, bl4);
    mid = Math.imul(al9, bh4);
    mid = (mid + Math.imul(ah9, bl4)) | 0;
    hi = Math.imul(ah9, bh4);
    lo = (lo + Math.imul(al8, bl5)) | 0;
    mid = (mid + Math.imul(al8, bh5)) | 0;
    mid = (mid + Math.imul(ah8, bl5)) | 0;
    hi = (hi + Math.imul(ah8, bh5)) | 0;
    lo = (lo + Math.imul(al7, bl6)) | 0;
    mid = (mid + Math.imul(al7, bh6)) | 0;
    mid = (mid + Math.imul(ah7, bl6)) | 0;
    hi = (hi + Math.imul(ah7, bh6)) | 0;
    lo = (lo + Math.imul(al6, bl7)) | 0;
    mid = (mid + Math.imul(al6, bh7)) | 0;
    mid = (mid + Math.imul(ah6, bl7)) | 0;
    hi = (hi + Math.imul(ah6, bh7)) | 0;
    lo = (lo + Math.imul(al5, bl8)) | 0;
    mid = (mid + Math.imul(al5, bh8)) | 0;
    mid = (mid + Math.imul(ah5, bl8)) | 0;
    hi = (hi + Math.imul(ah5, bh8)) | 0;
    lo = (lo + Math.imul(al4, bl9)) | 0;
    mid = (mid + Math.imul(al4, bh9)) | 0;
    mid = (mid + Math.imul(ah4, bl9)) | 0;
    hi = (hi + Math.imul(ah4, bh9)) | 0;
    var w13 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w13 >>> 26)) | 0;
    w13 &= 0x3ffffff;
    /* k = 14 */
    lo = Math.imul(al9, bl5);
    mid = Math.imul(al9, bh5);
    mid = (mid + Math.imul(ah9, bl5)) | 0;
    hi = Math.imul(ah9, bh5);
    lo = (lo + Math.imul(al8, bl6)) | 0;
    mid = (mid + Math.imul(al8, bh6)) | 0;
    mid = (mid + Math.imul(ah8, bl6)) | 0;
    hi = (hi + Math.imul(ah8, bh6)) | 0;
    lo = (lo + Math.imul(al7, bl7)) | 0;
    mid = (mid + Math.imul(al7, bh7)) | 0;
    mid = (mid + Math.imul(ah7, bl7)) | 0;
    hi = (hi + Math.imul(ah7, bh7)) | 0;
    lo = (lo + Math.imul(al6, bl8)) | 0;
    mid = (mid + Math.imul(al6, bh8)) | 0;
    mid = (mid + Math.imul(ah6, bl8)) | 0;
    hi = (hi + Math.imul(ah6, bh8)) | 0;
    lo = (lo + Math.imul(al5, bl9)) | 0;
    mid = (mid + Math.imul(al5, bh9)) | 0;
    mid = (mid + Math.imul(ah5, bl9)) | 0;
    hi = (hi + Math.imul(ah5, bh9)) | 0;
    var w14 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w14 >>> 26)) | 0;
    w14 &= 0x3ffffff;
    /* k = 15 */
    lo = Math.imul(al9, bl6);
    mid = Math.imul(al9, bh6);
    mid = (mid + Math.imul(ah9, bl6)) | 0;
    hi = Math.imul(ah9, bh6);
    lo = (lo + Math.imul(al8, bl7)) | 0;
    mid = (mid + Math.imul(al8, bh7)) | 0;
    mid = (mid + Math.imul(ah8, bl7)) | 0;
    hi = (hi + Math.imul(ah8, bh7)) | 0;
    lo = (lo + Math.imul(al7, bl8)) | 0;
    mid = (mid + Math.imul(al7, bh8)) | 0;
    mid = (mid + Math.imul(ah7, bl8)) | 0;
    hi = (hi + Math.imul(ah7, bh8)) | 0;
    lo = (lo + Math.imul(al6, bl9)) | 0;
    mid = (mid + Math.imul(al6, bh9)) | 0;
    mid = (mid + Math.imul(ah6, bl9)) | 0;
    hi = (hi + Math.imul(ah6, bh9)) | 0;
    var w15 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w15 >>> 26)) | 0;
    w15 &= 0x3ffffff;
    /* k = 16 */
    lo = Math.imul(al9, bl7);
    mid = Math.imul(al9, bh7);
    mid = (mid + Math.imul(ah9, bl7)) | 0;
    hi = Math.imul(ah9, bh7);
    lo = (lo + Math.imul(al8, bl8)) | 0;
    mid = (mid + Math.imul(al8, bh8)) | 0;
    mid = (mid + Math.imul(ah8, bl8)) | 0;
    hi = (hi + Math.imul(ah8, bh8)) | 0;
    lo = (lo + Math.imul(al7, bl9)) | 0;
    mid = (mid + Math.imul(al7, bh9)) | 0;
    mid = (mid + Math.imul(ah7, bl9)) | 0;
    hi = (hi + Math.imul(ah7, bh9)) | 0;
    var w16 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w16 >>> 26)) | 0;
    w16 &= 0x3ffffff;
    /* k = 17 */
    lo = Math.imul(al9, bl8);
    mid = Math.imul(al9, bh8);
    mid = (mid + Math.imul(ah9, bl8)) | 0;
    hi = Math.imul(ah9, bh8);
    lo = (lo + Math.imul(al8, bl9)) | 0;
    mid = (mid + Math.imul(al8, bh9)) | 0;
    mid = (mid + Math.imul(ah8, bl9)) | 0;
    hi = (hi + Math.imul(ah8, bh9)) | 0;
    var w17 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w17 >>> 26)) | 0;
    w17 &= 0x3ffffff;
    /* k = 18 */
    lo = Math.imul(al9, bl9);
    mid = Math.imul(al9, bh9);
    mid = (mid + Math.imul(ah9, bl9)) | 0;
    hi = Math.imul(ah9, bh9);
    var w18 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w18 >>> 26)) | 0;
    w18 &= 0x3ffffff;
    o[0] = w0;
    o[1] = w1;
    o[2] = w2;
    o[3] = w3;
    o[4] = w4;
    o[5] = w5;
    o[6] = w6;
    o[7] = w7;
    o[8] = w8;
    o[9] = w9;
    o[10] = w10;
    o[11] = w11;
    o[12] = w12;
    o[13] = w13;
    o[14] = w14;
    o[15] = w15;
    o[16] = w16;
    o[17] = w17;
    o[18] = w18;
    if (c !== 0) {
      o[19] = c;
      out.length++;
    }
    return out;
  };

  // Polyfill comb
  if (!Math.imul) {
    comb10MulTo = smallMulTo;
  }

  function bigMulTo (self, num, out) {
    out.negative = num.negative ^ self.negative;
    out.length = self.length + num.length;

    var carry = 0;
    var hncarry = 0;
    for (var k = 0; k < out.length - 1; k++) {
      // Sum all words with the same `i + j = k` and accumulate `ncarry`,
      // note that ncarry could be >= 0x3ffffff
      var ncarry = hncarry;
      hncarry = 0;
      var rword = carry & 0x3ffffff;
      var maxJ = Math.min(k, num.length - 1);
      for (var j = Math.max(0, k - self.length + 1); j <= maxJ; j++) {
        var i = k - j;
        var a = self.words[i] | 0;
        var b = num.words[j] | 0;
        var r = a * b;

        var lo = r & 0x3ffffff;
        ncarry = (ncarry + ((r / 0x4000000) | 0)) | 0;
        lo = (lo + rword) | 0;
        rword = lo & 0x3ffffff;
        ncarry = (ncarry + (lo >>> 26)) | 0;

        hncarry += ncarry >>> 26;
        ncarry &= 0x3ffffff;
      }
      out.words[k] = rword;
      carry = ncarry;
      ncarry = hncarry;
    }
    if (carry !== 0) {
      out.words[k] = carry;
    } else {
      out.length--;
    }

    return out.strip();
  }

  function jumboMulTo (self, num, out) {
    var fftm = new FFTM();
    return fftm.mulp(self, num, out);
  }

  BN.prototype.mulTo = function mulTo (num, out) {
    var res;
    var len = this.length + num.length;
    if (this.length === 10 && num.length === 10) {
      res = comb10MulTo(this, num, out);
    } else if (len < 63) {
      res = smallMulTo(this, num, out);
    } else if (len < 1024) {
      res = bigMulTo(this, num, out);
    } else {
      res = jumboMulTo(this, num, out);
    }

    return res;
  };

  // Cooley-Tukey algorithm for FFT
  // slightly revisited to rely on looping instead of recursion

  function FFTM (x, y) {
    this.x = x;
    this.y = y;
  }

  FFTM.prototype.makeRBT = function makeRBT (N) {
    var t = new Array(N);
    var l = BN.prototype._countBits(N) - 1;
    for (var i = 0; i < N; i++) {
      t[i] = this.revBin(i, l, N);
    }

    return t;
  };

  // Returns binary-reversed representation of `x`
  FFTM.prototype.revBin = function revBin (x, l, N) {
    if (x === 0 || x === N - 1) return x;

    var rb = 0;
    for (var i = 0; i < l; i++) {
      rb |= (x & 1) << (l - i - 1);
      x >>= 1;
    }

    return rb;
  };

  // Performs "tweedling" phase, therefore 'emulating'
  // behaviour of the recursive algorithm
  FFTM.prototype.permute = function permute (rbt, rws, iws, rtws, itws, N) {
    for (var i = 0; i < N; i++) {
      rtws[i] = rws[rbt[i]];
      itws[i] = iws[rbt[i]];
    }
  };

  FFTM.prototype.transform = function transform (rws, iws, rtws, itws, N, rbt) {
    this.permute(rbt, rws, iws, rtws, itws, N);

    for (var s = 1; s < N; s <<= 1) {
      var l = s << 1;

      var rtwdf = Math.cos(2 * Math.PI / l);
      var itwdf = Math.sin(2 * Math.PI / l);

      for (var p = 0; p < N; p += l) {
        var rtwdf_ = rtwdf;
        var itwdf_ = itwdf;

        for (var j = 0; j < s; j++) {
          var re = rtws[p + j];
          var ie = itws[p + j];

          var ro = rtws[p + j + s];
          var io = itws[p + j + s];

          var rx = rtwdf_ * ro - itwdf_ * io;

          io = rtwdf_ * io + itwdf_ * ro;
          ro = rx;

          rtws[p + j] = re + ro;
          itws[p + j] = ie + io;

          rtws[p + j + s] = re - ro;
          itws[p + j + s] = ie - io;

          /* jshint maxdepth : false */
          if (j !== l) {
            rx = rtwdf * rtwdf_ - itwdf * itwdf_;

            itwdf_ = rtwdf * itwdf_ + itwdf * rtwdf_;
            rtwdf_ = rx;
          }
        }
      }
    }
  };

  FFTM.prototype.guessLen13b = function guessLen13b (n, m) {
    var N = Math.max(m, n) | 1;
    var odd = N & 1;
    var i = 0;
    for (N = N / 2 | 0; N; N = N >>> 1) {
      i++;
    }

    return 1 << i + 1 + odd;
  };

  FFTM.prototype.conjugate = function conjugate (rws, iws, N) {
    if (N <= 1) return;

    for (var i = 0; i < N / 2; i++) {
      var t = rws[i];

      rws[i] = rws[N - i - 1];
      rws[N - i - 1] = t;

      t = iws[i];

      iws[i] = -iws[N - i - 1];
      iws[N - i - 1] = -t;
    }
  };

  FFTM.prototype.normalize13b = function normalize13b (ws, N) {
    var carry = 0;
    for (var i = 0; i < N / 2; i++) {
      var w = Math.round(ws[2 * i + 1] / N) * 0x2000 +
        Math.round(ws[2 * i] / N) +
        carry;

      ws[i] = w & 0x3ffffff;

      if (w < 0x4000000) {
        carry = 0;
      } else {
        carry = w / 0x4000000 | 0;
      }
    }

    return ws;
  };

  FFTM.prototype.convert13b = function convert13b (ws, len, rws, N) {
    var carry = 0;
    for (var i = 0; i < len; i++) {
      carry = carry + (ws[i] | 0);

      rws[2 * i] = carry & 0x1fff; carry = carry >>> 13;
      rws[2 * i + 1] = carry & 0x1fff; carry = carry >>> 13;
    }

    // Pad with zeroes
    for (i = 2 * len; i < N; ++i) {
      rws[i] = 0;
    }

    assert(carry === 0);
    assert((carry & ~0x1fff) === 0);
  };

  FFTM.prototype.stub = function stub (N) {
    var ph = new Array(N);
    for (var i = 0; i < N; i++) {
      ph[i] = 0;
    }

    return ph;
  };

  FFTM.prototype.mulp = function mulp (x, y, out) {
    var N = 2 * this.guessLen13b(x.length, y.length);

    var rbt = this.makeRBT(N);

    var _ = this.stub(N);

    var rws = new Array(N);
    var rwst = new Array(N);
    var iwst = new Array(N);

    var nrws = new Array(N);
    var nrwst = new Array(N);
    var niwst = new Array(N);

    var rmws = out.words;
    rmws.length = N;

    this.convert13b(x.words, x.length, rws, N);
    this.convert13b(y.words, y.length, nrws, N);

    this.transform(rws, _, rwst, iwst, N, rbt);
    this.transform(nrws, _, nrwst, niwst, N, rbt);

    for (var i = 0; i < N; i++) {
      var rx = rwst[i] * nrwst[i] - iwst[i] * niwst[i];
      iwst[i] = rwst[i] * niwst[i] + iwst[i] * nrwst[i];
      rwst[i] = rx;
    }

    this.conjugate(rwst, iwst, N);
    this.transform(rwst, iwst, rmws, _, N, rbt);
    this.conjugate(rmws, _, N);
    this.normalize13b(rmws, N);

    out.negative = x.negative ^ y.negative;
    out.length = x.length + y.length;
    return out.strip();
  };

  // Multiply `this` by `num`
  BN.prototype.mul = function mul (num) {
    var out = new BN(null);
    out.words = new Array(this.length + num.length);
    return this.mulTo(num, out);
  };

  // Multiply employing FFT
  BN.prototype.mulf = function mulf (num) {
    var out = new BN(null);
    out.words = new Array(this.length + num.length);
    return jumboMulTo(this, num, out);
  };

  // In-place Multiplication
  BN.prototype.imul = function imul (num) {
    return this.clone().mulTo(num, this);
  };

  BN.prototype.imuln = function imuln (num) {
    assert(typeof num === 'number');
    assert(num < 0x4000000);

    // Carry
    var carry = 0;
    for (var i = 0; i < this.length; i++) {
      var w = (this.words[i] | 0) * num;
      var lo = (w & 0x3ffffff) + (carry & 0x3ffffff);
      carry >>= 26;
      carry += (w / 0x4000000) | 0;
      // NOTE: lo is 27bit maximum
      carry += lo >>> 26;
      this.words[i] = lo & 0x3ffffff;
    }

    if (carry !== 0) {
      this.words[i] = carry;
      this.length++;
    }

    return this;
  };

  BN.prototype.muln = function muln (num) {
    return this.clone().imuln(num);
  };

  // `this` * `this`
  BN.prototype.sqr = function sqr () {
    return this.mul(this);
  };

  // `this` * `this` in-place
  BN.prototype.isqr = function isqr () {
    return this.imul(this.clone());
  };

  // Math.pow(`this`, `num`)
  BN.prototype.pow = function pow (num) {
    var w = toBitArray(num);
    if (w.length === 0) return new BN(1);

    // Skip leading zeroes
    var res = this;
    for (var i = 0; i < w.length; i++, res = res.sqr()) {
      if (w[i] !== 0) break;
    }

    if (++i < w.length) {
      for (var q = res.sqr(); i < w.length; i++, q = q.sqr()) {
        if (w[i] === 0) continue;

        res = res.mul(q);
      }
    }

    return res;
  };

  // Shift-left in-place
  BN.prototype.iushln = function iushln (bits) {
    assert(typeof bits === 'number' && bits >= 0);
    var r = bits % 26;
    var s = (bits - r) / 26;
    var carryMask = (0x3ffffff >>> (26 - r)) << (26 - r);
    var i;

    if (r !== 0) {
      var carry = 0;

      for (i = 0; i < this.length; i++) {
        var newCarry = this.words[i] & carryMask;
        var c = ((this.words[i] | 0) - newCarry) << r;
        this.words[i] = c | carry;
        carry = newCarry >>> (26 - r);
      }

      if (carry) {
        this.words[i] = carry;
        this.length++;
      }
    }

    if (s !== 0) {
      for (i = this.length - 1; i >= 0; i--) {
        this.words[i + s] = this.words[i];
      }

      for (i = 0; i < s; i++) {
        this.words[i] = 0;
      }

      this.length += s;
    }

    return this.strip();
  };

  BN.prototype.ishln = function ishln (bits) {
    // TODO(indutny): implement me
    assert(this.negative === 0);
    return this.iushln(bits);
  };

  // Shift-right in-place
  // NOTE: `hint` is a lowest bit before trailing zeroes
  // NOTE: if `extended` is present - it will be filled with destroyed bits
  BN.prototype.iushrn = function iushrn (bits, hint, extended) {
    assert(typeof bits === 'number' && bits >= 0);
    var h;
    if (hint) {
      h = (hint - (hint % 26)) / 26;
    } else {
      h = 0;
    }

    var r = bits % 26;
    var s = Math.min((bits - r) / 26, this.length);
    var mask = 0x3ffffff ^ ((0x3ffffff >>> r) << r);
    var maskedWords = extended;

    h -= s;
    h = Math.max(0, h);

    // Extended mode, copy masked part
    if (maskedWords) {
      for (var i = 0; i < s; i++) {
        maskedWords.words[i] = this.words[i];
      }
      maskedWords.length = s;
    }

    if (s === 0) {
      // No-op, we should not move anything at all
    } else if (this.length > s) {
      this.length -= s;
      for (i = 0; i < this.length; i++) {
        this.words[i] = this.words[i + s];
      }
    } else {
      this.words[0] = 0;
      this.length = 1;
    }

    var carry = 0;
    for (i = this.length - 1; i >= 0 && (carry !== 0 || i >= h); i--) {
      var word = this.words[i] | 0;
      this.words[i] = (carry << (26 - r)) | (word >>> r);
      carry = word & mask;
    }

    // Push carried bits as a mask
    if (maskedWords && carry !== 0) {
      maskedWords.words[maskedWords.length++] = carry;
    }

    if (this.length === 0) {
      this.words[0] = 0;
      this.length = 1;
    }

    return this.strip();
  };

  BN.prototype.ishrn = function ishrn (bits, hint, extended) {
    // TODO(indutny): implement me
    assert(this.negative === 0);
    return this.iushrn(bits, hint, extended);
  };

  // Shift-left
  BN.prototype.shln = function shln (bits) {
    return this.clone().ishln(bits);
  };

  BN.prototype.ushln = function ushln (bits) {
    return this.clone().iushln(bits);
  };

  // Shift-right
  BN.prototype.shrn = function shrn (bits) {
    return this.clone().ishrn(bits);
  };

  BN.prototype.ushrn = function ushrn (bits) {
    return this.clone().iushrn(bits);
  };

  // Test if n bit is set
  BN.prototype.testn = function testn (bit) {
    assert(typeof bit === 'number' && bit >= 0);
    var r = bit % 26;
    var s = (bit - r) / 26;
    var q = 1 << r;

    // Fast case: bit is much higher than all existing words
    if (this.length <= s) return false;

    // Check bit and return
    var w = this.words[s];

    return !!(w & q);
  };

  // Return only lowers bits of number (in-place)
  BN.prototype.imaskn = function imaskn (bits) {
    assert(typeof bits === 'number' && bits >= 0);
    var r = bits % 26;
    var s = (bits - r) / 26;

    assert(this.negative === 0, 'imaskn works only with positive numbers');

    if (this.length <= s) {
      return this;
    }

    if (r !== 0) {
      s++;
    }
    this.length = Math.min(s, this.length);

    if (r !== 0) {
      var mask = 0x3ffffff ^ ((0x3ffffff >>> r) << r);
      this.words[this.length - 1] &= mask;
    }

    return this.strip();
  };

  // Return only lowers bits of number
  BN.prototype.maskn = function maskn (bits) {
    return this.clone().imaskn(bits);
  };

  // Add plain number `num` to `this`
  BN.prototype.iaddn = function iaddn (num) {
    assert(typeof num === 'number');
    assert(num < 0x4000000);
    if (num < 0) return this.isubn(-num);

    // Possible sign change
    if (this.negative !== 0) {
      if (this.length === 1 && (this.words[0] | 0) < num) {
        this.words[0] = num - (this.words[0] | 0);
        this.negative = 0;
        return this;
      }

      this.negative = 0;
      this.isubn(num);
      this.negative = 1;
      return this;
    }

    // Add without checks
    return this._iaddn(num);
  };

  BN.prototype._iaddn = function _iaddn (num) {
    this.words[0] += num;

    // Carry
    for (var i = 0; i < this.length && this.words[i] >= 0x4000000; i++) {
      this.words[i] -= 0x4000000;
      if (i === this.length - 1) {
        this.words[i + 1] = 1;
      } else {
        this.words[i + 1]++;
      }
    }
    this.length = Math.max(this.length, i + 1);

    return this;
  };

  // Subtract plain number `num` from `this`
  BN.prototype.isubn = function isubn (num) {
    assert(typeof num === 'number');
    assert(num < 0x4000000);
    if (num < 0) return this.iaddn(-num);

    if (this.negative !== 0) {
      this.negative = 0;
      this.iaddn(num);
      this.negative = 1;
      return this;
    }

    this.words[0] -= num;

    if (this.length === 1 && this.words[0] < 0) {
      this.words[0] = -this.words[0];
      this.negative = 1;
    } else {
      // Carry
      for (var i = 0; i < this.length && this.words[i] < 0; i++) {
        this.words[i] += 0x4000000;
        this.words[i + 1] -= 1;
      }
    }

    return this.strip();
  };

  BN.prototype.addn = function addn (num) {
    return this.clone().iaddn(num);
  };

  BN.prototype.subn = function subn (num) {
    return this.clone().isubn(num);
  };

  BN.prototype.iabs = function iabs () {
    this.negative = 0;

    return this;
  };

  BN.prototype.abs = function abs () {
    return this.clone().iabs();
  };

  BN.prototype._ishlnsubmul = function _ishlnsubmul (num, mul, shift) {
    var len = num.length + shift;
    var i;

    this._expand(len);

    var w;
    var carry = 0;
    for (i = 0; i < num.length; i++) {
      w = (this.words[i + shift] | 0) + carry;
      var right = (num.words[i] | 0) * mul;
      w -= right & 0x3ffffff;
      carry = (w >> 26) - ((right / 0x4000000) | 0);
      this.words[i + shift] = w & 0x3ffffff;
    }
    for (; i < this.length - shift; i++) {
      w = (this.words[i + shift] | 0) + carry;
      carry = w >> 26;
      this.words[i + shift] = w & 0x3ffffff;
    }

    if (carry === 0) return this.strip();

    // Subtraction overflow
    assert(carry === -1);
    carry = 0;
    for (i = 0; i < this.length; i++) {
      w = -(this.words[i] | 0) + carry;
      carry = w >> 26;
      this.words[i] = w & 0x3ffffff;
    }
    this.negative = 1;

    return this.strip();
  };

  BN.prototype._wordDiv = function _wordDiv (num, mode) {
    var shift = this.length - num.length;

    var a = this.clone();
    var b = num;

    // Normalize
    var bhi = b.words[b.length - 1] | 0;
    var bhiBits = this._countBits(bhi);
    shift = 26 - bhiBits;
    if (shift !== 0) {
      b = b.ushln(shift);
      a.iushln(shift);
      bhi = b.words[b.length - 1] | 0;
    }

    // Initialize quotient
    var m = a.length - b.length;
    var q;

    if (mode !== 'mod') {
      q = new BN(null);
      q.length = m + 1;
      q.words = new Array(q.length);
      for (var i = 0; i < q.length; i++) {
        q.words[i] = 0;
      }
    }

    var diff = a.clone()._ishlnsubmul(b, 1, m);
    if (diff.negative === 0) {
      a = diff;
      if (q) {
        q.words[m] = 1;
      }
    }

    for (var j = m - 1; j >= 0; j--) {
      var qj = (a.words[b.length + j] | 0) * 0x4000000 +
        (a.words[b.length + j - 1] | 0);

      // NOTE: (qj / bhi) is (0x3ffffff * 0x4000000 + 0x3ffffff) / 0x2000000 max
      // (0x7ffffff)
      qj = Math.min((qj / bhi) | 0, 0x3ffffff);

      a._ishlnsubmul(b, qj, j);
      while (a.negative !== 0) {
        qj--;
        a.negative = 0;
        a._ishlnsubmul(b, 1, j);
        if (!a.isZero()) {
          a.negative ^= 1;
        }
      }
      if (q) {
        q.words[j] = qj;
      }
    }
    if (q) {
      q.strip();
    }
    a.strip();

    // Denormalize
    if (mode !== 'div' && shift !== 0) {
      a.iushrn(shift);
    }

    return {
      div: q || null,
      mod: a
    };
  };

  // NOTE: 1) `mode` can be set to `mod` to request mod only,
  //       to `div` to request div only, or be absent to
  //       request both div & mod
  //       2) `positive` is true if unsigned mod is requested
  BN.prototype.divmod = function divmod (num, mode, positive) {
    assert(!num.isZero());

    if (this.isZero()) {
      return {
        div: new BN(0),
        mod: new BN(0)
      };
    }

    var div, mod, res;
    if (this.negative !== 0 && num.negative === 0) {
      res = this.neg().divmod(num, mode);

      if (mode !== 'mod') {
        div = res.div.neg();
      }

      if (mode !== 'div') {
        mod = res.mod.neg();
        if (positive && mod.negative !== 0) {
          mod.iadd(num);
        }
      }

      return {
        div: div,
        mod: mod
      };
    }

    if (this.negative === 0 && num.negative !== 0) {
      res = this.divmod(num.neg(), mode);

      if (mode !== 'mod') {
        div = res.div.neg();
      }

      return {
        div: div,
        mod: res.mod
      };
    }

    if ((this.negative & num.negative) !== 0) {
      res = this.neg().divmod(num.neg(), mode);

      if (mode !== 'div') {
        mod = res.mod.neg();
        if (positive && mod.negative !== 0) {
          mod.isub(num);
        }
      }

      return {
        div: res.div,
        mod: mod
      };
    }

    // Both numbers are positive at this point

    // Strip both numbers to approximate shift value
    if (num.length > this.length || this.cmp(num) < 0) {
      return {
        div: new BN(0),
        mod: this
      };
    }

    // Very short reduction
    if (num.length === 1) {
      if (mode === 'div') {
        return {
          div: this.divn(num.words[0]),
          mod: null
        };
      }

      if (mode === 'mod') {
        return {
          div: null,
          mod: new BN(this.modn(num.words[0]))
        };
      }

      return {
        div: this.divn(num.words[0]),
        mod: new BN(this.modn(num.words[0]))
      };
    }

    return this._wordDiv(num, mode);
  };

  // Find `this` / `num`
  BN.prototype.div = function div (num) {
    return this.divmod(num, 'div', false).div;
  };

  // Find `this` % `num`
  BN.prototype.mod = function mod (num) {
    return this.divmod(num, 'mod', false).mod;
  };

  BN.prototype.umod = function umod (num) {
    return this.divmod(num, 'mod', true).mod;
  };

  // Find Round(`this` / `num`)
  BN.prototype.divRound = function divRound (num) {
    var dm = this.divmod(num);

    // Fast case - exact division
    if (dm.mod.isZero()) return dm.div;

    var mod = dm.div.negative !== 0 ? dm.mod.isub(num) : dm.mod;

    var half = num.ushrn(1);
    var r2 = num.andln(1);
    var cmp = mod.cmp(half);

    // Round down
    if (cmp < 0 || r2 === 1 && cmp === 0) return dm.div;

    // Round up
    return dm.div.negative !== 0 ? dm.div.isubn(1) : dm.div.iaddn(1);
  };

  BN.prototype.modn = function modn (num) {
    assert(num <= 0x3ffffff);
    var p = (1 << 26) % num;

    var acc = 0;
    for (var i = this.length - 1; i >= 0; i--) {
      acc = (p * acc + (this.words[i] | 0)) % num;
    }

    return acc;
  };

  // In-place division by number
  BN.prototype.idivn = function idivn (num) {
    assert(num <= 0x3ffffff);

    var carry = 0;
    for (var i = this.length - 1; i >= 0; i--) {
      var w = (this.words[i] | 0) + carry * 0x4000000;
      this.words[i] = (w / num) | 0;
      carry = w % num;
    }

    return this.strip();
  };

  BN.prototype.divn = function divn (num) {
    return this.clone().idivn(num);
  };

  BN.prototype.egcd = function egcd (p) {
    assert(p.negative === 0);
    assert(!p.isZero());

    var x = this;
    var y = p.clone();

    if (x.negative !== 0) {
      x = x.umod(p);
    } else {
      x = x.clone();
    }

    // A * x + B * y = x
    var A = new BN(1);
    var B = new BN(0);

    // C * x + D * y = y
    var C = new BN(0);
    var D = new BN(1);

    var g = 0;

    while (x.isEven() && y.isEven()) {
      x.iushrn(1);
      y.iushrn(1);
      ++g;
    }

    var yp = y.clone();
    var xp = x.clone();

    while (!x.isZero()) {
      for (var i = 0, im = 1; (x.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
      if (i > 0) {
        x.iushrn(i);
        while (i-- > 0) {
          if (A.isOdd() || B.isOdd()) {
            A.iadd(yp);
            B.isub(xp);
          }

          A.iushrn(1);
          B.iushrn(1);
        }
      }

      for (var j = 0, jm = 1; (y.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
      if (j > 0) {
        y.iushrn(j);
        while (j-- > 0) {
          if (C.isOdd() || D.isOdd()) {
            C.iadd(yp);
            D.isub(xp);
          }

          C.iushrn(1);
          D.iushrn(1);
        }
      }

      if (x.cmp(y) >= 0) {
        x.isub(y);
        A.isub(C);
        B.isub(D);
      } else {
        y.isub(x);
        C.isub(A);
        D.isub(B);
      }
    }

    return {
      a: C,
      b: D,
      gcd: y.iushln(g)
    };
  };

  // This is reduced incarnation of the binary EEA
  // above, designated to invert members of the
  // _prime_ fields F(p) at a maximal speed
  BN.prototype._invmp = function _invmp (p) {
    assert(p.negative === 0);
    assert(!p.isZero());

    var a = this;
    var b = p.clone();

    if (a.negative !== 0) {
      a = a.umod(p);
    } else {
      a = a.clone();
    }

    var x1 = new BN(1);
    var x2 = new BN(0);

    var delta = b.clone();

    while (a.cmpn(1) > 0 && b.cmpn(1) > 0) {
      for (var i = 0, im = 1; (a.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
      if (i > 0) {
        a.iushrn(i);
        while (i-- > 0) {
          if (x1.isOdd()) {
            x1.iadd(delta);
          }

          x1.iushrn(1);
        }
      }

      for (var j = 0, jm = 1; (b.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
      if (j > 0) {
        b.iushrn(j);
        while (j-- > 0) {
          if (x2.isOdd()) {
            x2.iadd(delta);
          }

          x2.iushrn(1);
        }
      }

      if (a.cmp(b) >= 0) {
        a.isub(b);
        x1.isub(x2);
      } else {
        b.isub(a);
        x2.isub(x1);
      }
    }

    var res;
    if (a.cmpn(1) === 0) {
      res = x1;
    } else {
      res = x2;
    }

    if (res.cmpn(0) < 0) {
      res.iadd(p);
    }

    return res;
  };

  BN.prototype.gcd = function gcd (num) {
    if (this.isZero()) return num.abs();
    if (num.isZero()) return this.abs();

    var a = this.clone();
    var b = num.clone();
    a.negative = 0;
    b.negative = 0;

    // Remove common factor of two
    for (var shift = 0; a.isEven() && b.isEven(); shift++) {
      a.iushrn(1);
      b.iushrn(1);
    }

    do {
      while (a.isEven()) {
        a.iushrn(1);
      }
      while (b.isEven()) {
        b.iushrn(1);
      }

      var r = a.cmp(b);
      if (r < 0) {
        // Swap `a` and `b` to make `a` always bigger than `b`
        var t = a;
        a = b;
        b = t;
      } else if (r === 0 || b.cmpn(1) === 0) {
        break;
      }

      a.isub(b);
    } while (true);

    return b.iushln(shift);
  };

  // Invert number in the field F(num)
  BN.prototype.invm = function invm (num) {
    return this.egcd(num).a.umod(num);
  };

  BN.prototype.isEven = function isEven () {
    return (this.words[0] & 1) === 0;
  };

  BN.prototype.isOdd = function isOdd () {
    return (this.words[0] & 1) === 1;
  };

  // And first word and num
  BN.prototype.andln = function andln (num) {
    return this.words[0] & num;
  };

  // Increment at the bit position in-line
  BN.prototype.bincn = function bincn (bit) {
    assert(typeof bit === 'number');
    var r = bit % 26;
    var s = (bit - r) / 26;
    var q = 1 << r;

    // Fast case: bit is much higher than all existing words
    if (this.length <= s) {
      this._expand(s + 1);
      this.words[s] |= q;
      return this;
    }

    // Add bit and propagate, if needed
    var carry = q;
    for (var i = s; carry !== 0 && i < this.length; i++) {
      var w = this.words[i] | 0;
      w += carry;
      carry = w >>> 26;
      w &= 0x3ffffff;
      this.words[i] = w;
    }
    if (carry !== 0) {
      this.words[i] = carry;
      this.length++;
    }
    return this;
  };

  BN.prototype.isZero = function isZero () {
    return this.length === 1 && this.words[0] === 0;
  };

  BN.prototype.cmpn = function cmpn (num) {
    var negative = num < 0;

    if (this.negative !== 0 && !negative) return -1;
    if (this.negative === 0 && negative) return 1;

    this.strip();

    var res;
    if (this.length > 1) {
      res = 1;
    } else {
      if (negative) {
        num = -num;
      }

      assert(num <= 0x3ffffff, 'Number is too big');

      var w = this.words[0] | 0;
      res = w === num ? 0 : w < num ? -1 : 1;
    }
    if (this.negative !== 0) return -res | 0;
    return res;
  };

  // Compare two numbers and return:
  // 1 - if `this` > `num`
  // 0 - if `this` == `num`
  // -1 - if `this` < `num`
  BN.prototype.cmp = function cmp (num) {
    if (this.negative !== 0 && num.negative === 0) return -1;
    if (this.negative === 0 && num.negative !== 0) return 1;

    var res = this.ucmp(num);
    if (this.negative !== 0) return -res | 0;
    return res;
  };

  // Unsigned comparison
  BN.prototype.ucmp = function ucmp (num) {
    // At this point both numbers have the same sign
    if (this.length > num.length) return 1;
    if (this.length < num.length) return -1;

    var res = 0;
    for (var i = this.length - 1; i >= 0; i--) {
      var a = this.words[i] | 0;
      var b = num.words[i] | 0;

      if (a === b) continue;
      if (a < b) {
        res = -1;
      } else if (a > b) {
        res = 1;
      }
      break;
    }
    return res;
  };

  BN.prototype.gtn = function gtn (num) {
    return this.cmpn(num) === 1;
  };

  BN.prototype.gt = function gt (num) {
    return this.cmp(num) === 1;
  };

  BN.prototype.gten = function gten (num) {
    return this.cmpn(num) >= 0;
  };

  BN.prototype.gte = function gte (num) {
    return this.cmp(num) >= 0;
  };

  BN.prototype.ltn = function ltn (num) {
    return this.cmpn(num) === -1;
  };

  BN.prototype.lt = function lt (num) {
    return this.cmp(num) === -1;
  };

  BN.prototype.lten = function lten (num) {
    return this.cmpn(num) <= 0;
  };

  BN.prototype.lte = function lte (num) {
    return this.cmp(num) <= 0;
  };

  BN.prototype.eqn = function eqn (num) {
    return this.cmpn(num) === 0;
  };

  BN.prototype.eq = function eq (num) {
    return this.cmp(num) === 0;
  };

  //
  // A reduce context, could be using montgomery or something better, depending
  // on the `m` itself.
  //
  BN.red = function red (num) {
    return new Red(num);
  };

  BN.prototype.toRed = function toRed (ctx) {
    assert(!this.red, 'Already a number in reduction context');
    assert(this.negative === 0, 'red works only with positives');
    return ctx.convertTo(this)._forceRed(ctx);
  };

  BN.prototype.fromRed = function fromRed () {
    assert(this.red, 'fromRed works only with numbers in reduction context');
    return this.red.convertFrom(this);
  };

  BN.prototype._forceRed = function _forceRed (ctx) {
    this.red = ctx;
    return this;
  };

  BN.prototype.forceRed = function forceRed (ctx) {
    assert(!this.red, 'Already a number in reduction context');
    return this._forceRed(ctx);
  };

  BN.prototype.redAdd = function redAdd (num) {
    assert(this.red, 'redAdd works only with red numbers');
    return this.red.add(this, num);
  };

  BN.prototype.redIAdd = function redIAdd (num) {
    assert(this.red, 'redIAdd works only with red numbers');
    return this.red.iadd(this, num);
  };

  BN.prototype.redSub = function redSub (num) {
    assert(this.red, 'redSub works only with red numbers');
    return this.red.sub(this, num);
  };

  BN.prototype.redISub = function redISub (num) {
    assert(this.red, 'redISub works only with red numbers');
    return this.red.isub(this, num);
  };

  BN.prototype.redShl = function redShl (num) {
    assert(this.red, 'redShl works only with red numbers');
    return this.red.shl(this, num);
  };

  BN.prototype.redMul = function redMul (num) {
    assert(this.red, 'redMul works only with red numbers');
    this.red._verify2(this, num);
    return this.red.mul(this, num);
  };

  BN.prototype.redIMul = function redIMul (num) {
    assert(this.red, 'redMul works only with red numbers');
    this.red._verify2(this, num);
    return this.red.imul(this, num);
  };

  BN.prototype.redSqr = function redSqr () {
    assert(this.red, 'redSqr works only with red numbers');
    this.red._verify1(this);
    return this.red.sqr(this);
  };

  BN.prototype.redISqr = function redISqr () {
    assert(this.red, 'redISqr works only with red numbers');
    this.red._verify1(this);
    return this.red.isqr(this);
  };

  // Square root over p
  BN.prototype.redSqrt = function redSqrt () {
    assert(this.red, 'redSqrt works only with red numbers');
    this.red._verify1(this);
    return this.red.sqrt(this);
  };

  BN.prototype.redInvm = function redInvm () {
    assert(this.red, 'redInvm works only with red numbers');
    this.red._verify1(this);
    return this.red.invm(this);
  };

  // Return negative clone of `this` % `red modulo`
  BN.prototype.redNeg = function redNeg () {
    assert(this.red, 'redNeg works only with red numbers');
    this.red._verify1(this);
    return this.red.neg(this);
  };

  BN.prototype.redPow = function redPow (num) {
    assert(this.red && !num.red, 'redPow(normalNum)');
    this.red._verify1(this);
    return this.red.pow(this, num);
  };

  // Prime numbers with efficient reduction
  var primes = {
    k256: null,
    p224: null,
    p192: null,
    p25519: null
  };

  // Pseudo-Mersenne prime
  function MPrime (name, p) {
    // P = 2 ^ N - K
    this.name = name;
    this.p = new BN(p, 16);
    this.n = this.p.bitLength();
    this.k = new BN(1).iushln(this.n).isub(this.p);

    this.tmp = this._tmp();
  }

  MPrime.prototype._tmp = function _tmp () {
    var tmp = new BN(null);
    tmp.words = new Array(Math.ceil(this.n / 13));
    return tmp;
  };

  MPrime.prototype.ireduce = function ireduce (num) {
    // Assumes that `num` is less than `P^2`
    // num = HI * (2 ^ N - K) + HI * K + LO = HI * K + LO (mod P)
    var r = num;
    var rlen;

    do {
      this.split(r, this.tmp);
      r = this.imulK(r);
      r = r.iadd(this.tmp);
      rlen = r.bitLength();
    } while (rlen > this.n);

    var cmp = rlen < this.n ? -1 : r.ucmp(this.p);
    if (cmp === 0) {
      r.words[0] = 0;
      r.length = 1;
    } else if (cmp > 0) {
      r.isub(this.p);
    } else {
      if (r.strip !== undefined) {
        // r is BN v4 instance
        r.strip();
      } else {
        // r is BN v5 instance
        r._strip();
      }
    }

    return r;
  };

  MPrime.prototype.split = function split (input, out) {
    input.iushrn(this.n, 0, out);
  };

  MPrime.prototype.imulK = function imulK (num) {
    return num.imul(this.k);
  };

  function K256 () {
    MPrime.call(
      this,
      'k256',
      'ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f');
  }
  inherits(K256, MPrime);

  K256.prototype.split = function split (input, output) {
    // 256 = 9 * 26 + 22
    var mask = 0x3fffff;

    var outLen = Math.min(input.length, 9);
    for (var i = 0; i < outLen; i++) {
      output.words[i] = input.words[i];
    }
    output.length = outLen;

    if (input.length <= 9) {
      input.words[0] = 0;
      input.length = 1;
      return;
    }

    // Shift by 9 limbs
    var prev = input.words[9];
    output.words[output.length++] = prev & mask;

    for (i = 10; i < input.length; i++) {
      var next = input.words[i] | 0;
      input.words[i - 10] = ((next & mask) << 4) | (prev >>> 22);
      prev = next;
    }
    prev >>>= 22;
    input.words[i - 10] = prev;
    if (prev === 0 && input.length > 10) {
      input.length -= 10;
    } else {
      input.length -= 9;
    }
  };

  K256.prototype.imulK = function imulK (num) {
    // K = 0x1000003d1 = [ 0x40, 0x3d1 ]
    num.words[num.length] = 0;
    num.words[num.length + 1] = 0;
    num.length += 2;

    // bounded at: 0x40 * 0x3ffffff + 0x3d0 = 0x100000390
    var lo = 0;
    for (var i = 0; i < num.length; i++) {
      var w = num.words[i] | 0;
      lo += w * 0x3d1;
      num.words[i] = lo & 0x3ffffff;
      lo = w * 0x40 + ((lo / 0x4000000) | 0);
    }

    // Fast length reduction
    if (num.words[num.length - 1] === 0) {
      num.length--;
      if (num.words[num.length - 1] === 0) {
        num.length--;
      }
    }
    return num;
  };

  function P224 () {
    MPrime.call(
      this,
      'p224',
      'ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001');
  }
  inherits(P224, MPrime);

  function P192 () {
    MPrime.call(
      this,
      'p192',
      'ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff');
  }
  inherits(P192, MPrime);

  function P25519 () {
    // 2 ^ 255 - 19
    MPrime.call(
      this,
      '25519',
      '7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed');
  }
  inherits(P25519, MPrime);

  P25519.prototype.imulK = function imulK (num) {
    // K = 0x13
    var carry = 0;
    for (var i = 0; i < num.length; i++) {
      var hi = (num.words[i] | 0) * 0x13 + carry;
      var lo = hi & 0x3ffffff;
      hi >>>= 26;

      num.words[i] = lo;
      carry = hi;
    }
    if (carry !== 0) {
      num.words[num.length++] = carry;
    }
    return num;
  };

  // Exported mostly for testing purposes, use plain name instead
  BN._prime = function prime (name) {
    // Cached version of prime
    if (primes[name]) return primes[name];

    var prime;
    if (name === 'k256') {
      prime = new K256();
    } else if (name === 'p224') {
      prime = new P224();
    } else if (name === 'p192') {
      prime = new P192();
    } else if (name === 'p25519') {
      prime = new P25519();
    } else {
      throw new Error('Unknown prime ' + name);
    }
    primes[name] = prime;

    return prime;
  };

  //
  // Base reduction engine
  //
  function Red (m) {
    if (typeof m === 'string') {
      var prime = BN._prime(m);
      this.m = prime.p;
      this.prime = prime;
    } else {
      assert(m.gtn(1), 'modulus must be greater than 1');
      this.m = m;
      this.prime = null;
    }
  }

  Red.prototype._verify1 = function _verify1 (a) {
    assert(a.negative === 0, 'red works only with positives');
    assert(a.red, 'red works only with red numbers');
  };

  Red.prototype._verify2 = function _verify2 (a, b) {
    assert((a.negative | b.negative) === 0, 'red works only with positives');
    assert(a.red && a.red === b.red,
      'red works only with red numbers');
  };

  Red.prototype.imod = function imod (a) {
    if (this.prime) return this.prime.ireduce(a)._forceRed(this);
    return a.umod(this.m)._forceRed(this);
  };

  Red.prototype.neg = function neg (a) {
    if (a.isZero()) {
      return a.clone();
    }

    return this.m.sub(a)._forceRed(this);
  };

  Red.prototype.add = function add (a, b) {
    this._verify2(a, b);

    var res = a.add(b);
    if (res.cmp(this.m) >= 0) {
      res.isub(this.m);
    }
    return res._forceRed(this);
  };

  Red.prototype.iadd = function iadd (a, b) {
    this._verify2(a, b);

    var res = a.iadd(b);
    if (res.cmp(this.m) >= 0) {
      res.isub(this.m);
    }
    return res;
  };

  Red.prototype.sub = function sub (a, b) {
    this._verify2(a, b);

    var res = a.sub(b);
    if (res.cmpn(0) < 0) {
      res.iadd(this.m);
    }
    return res._forceRed(this);
  };

  Red.prototype.isub = function isub (a, b) {
    this._verify2(a, b);

    var res = a.isub(b);
    if (res.cmpn(0) < 0) {
      res.iadd(this.m);
    }
    return res;
  };

  Red.prototype.shl = function shl (a, num) {
    this._verify1(a);
    return this.imod(a.ushln(num));
  };

  Red.prototype.imul = function imul (a, b) {
    this._verify2(a, b);
    return this.imod(a.imul(b));
  };

  Red.prototype.mul = function mul (a, b) {
    this._verify2(a, b);
    return this.imod(a.mul(b));
  };

  Red.prototype.isqr = function isqr (a) {
    return this.imul(a, a.clone());
  };

  Red.prototype.sqr = function sqr (a) {
    return this.mul(a, a);
  };

  Red.prototype.sqrt = function sqrt (a) {
    if (a.isZero()) return a.clone();

    var mod3 = this.m.andln(3);
    assert(mod3 % 2 === 1);

    // Fast case
    if (mod3 === 3) {
      var pow = this.m.add(new BN(1)).iushrn(2);
      return this.pow(a, pow);
    }

    // Tonelli-Shanks algorithm (Totally unoptimized and slow)
    //
    // Find Q and S, that Q * 2 ^ S = (P - 1)
    var q = this.m.subn(1);
    var s = 0;
    while (!q.isZero() && q.andln(1) === 0) {
      s++;
      q.iushrn(1);
    }
    assert(!q.isZero());

    var one = new BN(1).toRed(this);
    var nOne = one.redNeg();

    // Find quadratic non-residue
    // NOTE: Max is such because of generalized Riemann hypothesis.
    var lpow = this.m.subn(1).iushrn(1);
    var z = this.m.bitLength();
    z = new BN(2 * z * z).toRed(this);

    while (this.pow(z, lpow).cmp(nOne) !== 0) {
      z.redIAdd(nOne);
    }

    var c = this.pow(z, q);
    var r = this.pow(a, q.addn(1).iushrn(1));
    var t = this.pow(a, q);
    var m = s;
    while (t.cmp(one) !== 0) {
      var tmp = t;
      for (var i = 0; tmp.cmp(one) !== 0; i++) {
        tmp = tmp.redSqr();
      }
      assert(i < m);
      var b = this.pow(c, new BN(1).iushln(m - i - 1));

      r = r.redMul(b);
      c = b.redSqr();
      t = t.redMul(c);
      m = i;
    }

    return r;
  };

  Red.prototype.invm = function invm (a) {
    var inv = a._invmp(this.m);
    if (inv.negative !== 0) {
      inv.negative = 0;
      return this.imod(inv).redNeg();
    } else {
      return this.imod(inv);
    }
  };

  Red.prototype.pow = function pow (a, num) {
    if (num.isZero()) return new BN(1).toRed(this);
    if (num.cmpn(1) === 0) return a.clone();

    var windowSize = 4;
    var wnd = new Array(1 << windowSize);
    wnd[0] = new BN(1).toRed(this);
    wnd[1] = a;
    for (var i = 2; i < wnd.length; i++) {
      wnd[i] = this.mul(wnd[i - 1], a);
    }

    var res = wnd[0];
    var current = 0;
    var currentLen = 0;
    var start = num.bitLength() % 26;
    if (start === 0) {
      start = 26;
    }

    for (i = num.length - 1; i >= 0; i--) {
      var word = num.words[i];
      for (var j = start - 1; j >= 0; j--) {
        var bit = (word >> j) & 1;
        if (res !== wnd[0]) {
          res = this.sqr(res);
        }

        if (bit === 0 && current === 0) {
          currentLen = 0;
          continue;
        }

        current <<= 1;
        current |= bit;
        currentLen++;
        if (currentLen !== windowSize && (i !== 0 || j !== 0)) continue;

        res = this.mul(res, wnd[current]);
        currentLen = 0;
        current = 0;
      }
      start = 26;
    }

    return res;
  };

  Red.prototype.convertTo = function convertTo (num) {
    var r = num.umod(this.m);

    return r === num ? r.clone() : r;
  };

  Red.prototype.convertFrom = function convertFrom (num) {
    var res = num.clone();
    res.red = null;
    return res;
  };

  //
  // Montgomery method engine
  //

  BN.mont = function mont (num) {
    return new Mont(num);
  };

  function Mont (m) {
    Red.call(this, m);

    this.shift = this.m.bitLength();
    if (this.shift % 26 !== 0) {
      this.shift += 26 - (this.shift % 26);
    }

    this.r = new BN(1).iushln(this.shift);
    this.r2 = this.imod(this.r.sqr());
    this.rinv = this.r._invmp(this.m);

    this.minv = this.rinv.mul(this.r).isubn(1).div(this.m);
    this.minv = this.minv.umod(this.r);
    this.minv = this.r.sub(this.minv);
  }
  inherits(Mont, Red);

  Mont.prototype.convertTo = function convertTo (num) {
    return this.imod(num.ushln(this.shift));
  };

  Mont.prototype.convertFrom = function convertFrom (num) {
    var r = this.imod(num.mul(this.rinv));
    r.red = null;
    return r;
  };

  Mont.prototype.imul = function imul (a, b) {
    if (a.isZero() || b.isZero()) {
      a.words[0] = 0;
      a.length = 1;
      return a;
    }

    var t = a.imul(b);
    var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
    var u = t.isub(c).iushrn(this.shift);
    var res = u;

    if (u.cmp(this.m) >= 0) {
      res = u.isub(this.m);
    } else if (u.cmpn(0) < 0) {
      res = u.iadd(this.m);
    }

    return res._forceRed(this);
  };

  Mont.prototype.mul = function mul (a, b) {
    if (a.isZero() || b.isZero()) return new BN(0)._forceRed(this);

    var t = a.mul(b);
    var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
    var u = t.isub(c).iushrn(this.shift);
    var res = u;
    if (u.cmp(this.m) >= 0) {
      res = u.isub(this.m);
    } else if (u.cmpn(0) < 0) {
      res = u.iadd(this.m);
    }

    return res._forceRed(this);
  };

  Mont.prototype.invm = function invm (a) {
    // (AR)^-1 * R^2 = (A^-1 * R^-1) * R^2 = A^-1 * R
    var res = this.imod(a._invmp(this.m).mul(this.r2));
    return res._forceRed(this);
  };
})( false || module, this);

/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(/*! ./../../../../webpack/buildin/module.js */ "./node_modules/webpack/buildin/module.js")(module)))

/***/ }),

/***/ "./node_modules/public-encrypt/privateDecrypt.js":
/*!*******************************************************!*\
  !*** ./node_modules/public-encrypt/privateDecrypt.js ***!
  \*******************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var parseKeys = __webpack_require__(/*! parse-asn1 */ "./node_modules/parse-asn1/index.js")
var mgf = __webpack_require__(/*! ./mgf */ "./node_modules/public-encrypt/mgf.js")
var xor = __webpack_require__(/*! ./xor */ "./node_modules/public-encrypt/xor.js")
var BN = __webpack_require__(/*! bn.js */ "./node_modules/public-encrypt/node_modules/bn.js/lib/bn.js")
var crt = __webpack_require__(/*! browserify-rsa */ "./node_modules/browserify-rsa/index.js")
var createHash = __webpack_require__(/*! create-hash */ "./node_modules/create-hash/browser.js")
var withPublic = __webpack_require__(/*! ./withPublic */ "./node_modules/public-encrypt/withPublic.js")
var Buffer = __webpack_require__(/*! safe-buffer */ "./node_modules/safe-buffer/index.js").Buffer

module.exports = function privateDecrypt (privateKey, enc, reverse) {
  var padding
  if (privateKey.padding) {
    padding = privateKey.padding
  } else if (reverse) {
    padding = 1
  } else {
    padding = 4
  }

  var key = parseKeys(privateKey)
  var k = key.modulus.byteLength()
  if (enc.length > k || new BN(enc).cmp(key.modulus) >= 0) {
    throw new Error('decryption error')
  }
  var msg
  if (reverse) {
    msg = withPublic(new BN(enc), key)
  } else {
    msg = crt(enc, key)
  }
  var zBuffer = Buffer.alloc(k - msg.length)
  msg = Buffer.concat([zBuffer, msg], k)
  if (padding === 4) {
    return oaep(key, msg)
  } else if (padding === 1) {
    return pkcs1(key, msg, reverse)
  } else if (padding === 3) {
    return msg
  } else {
    throw new Error('unknown padding')
  }
}

function oaep (key, msg) {
  var k = key.modulus.byteLength()
  var iHash = createHash('sha1').update(Buffer.alloc(0)).digest()
  var hLen = iHash.length
  if (msg[0] !== 0) {
    throw new Error('decryption error')
  }
  var maskedSeed = msg.slice(1, hLen + 1)
  var maskedDb = msg.slice(hLen + 1)
  var seed = xor(maskedSeed, mgf(maskedDb, hLen))
  var db = xor(maskedDb, mgf(seed, k - hLen - 1))
  if (compare(iHash, db.slice(0, hLen))) {
    throw new Error('decryption error')
  }
  var i = hLen
  while (db[i] === 0) {
    i++
  }
  if (db[i++] !== 1) {
    throw new Error('decryption error')
  }
  return db.slice(i)
}

function pkcs1 (key, msg, reverse) {
  var p1 = msg.slice(0, 2)
  var i = 2
  var status = 0
  while (msg[i++] !== 0) {
    if (i >= msg.length) {
      status++
      break
    }
  }
  var ps = msg.slice(2, i - 1)

  if ((p1.toString('hex') !== '0002' && !reverse) || (p1.toString('hex') !== '0001' && reverse)) {
    status++
  }
  if (ps.length < 8) {
    status++
  }
  if (status) {
    throw new Error('decryption error')
  }
  return msg.slice(i)
}
function compare (a, b) {
  a = Buffer.from(a)
  b = Buffer.from(b)
  var dif = 0
  var len = a.length
  if (a.length !== b.length) {
    dif++
    len = Math.min(a.length, b.length)
  }
  var i = -1
  while (++i < len) {
    dif += (a[i] ^ b[i])
  }
  return dif
}


/***/ }),

/***/ "./node_modules/public-encrypt/publicEncrypt.js":
/*!******************************************************!*\
  !*** ./node_modules/public-encrypt/publicEncrypt.js ***!
  \******************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var parseKeys = __webpack_require__(/*! parse-asn1 */ "./node_modules/parse-asn1/index.js")
var randomBytes = __webpack_require__(/*! randombytes */ "./node_modules/randombytes/browser.js")
var createHash = __webpack_require__(/*! create-hash */ "./node_modules/create-hash/browser.js")
var mgf = __webpack_require__(/*! ./mgf */ "./node_modules/public-encrypt/mgf.js")
var xor = __webpack_require__(/*! ./xor */ "./node_modules/public-encrypt/xor.js")
var BN = __webpack_require__(/*! bn.js */ "./node_modules/public-encrypt/node_modules/bn.js/lib/bn.js")
var withPublic = __webpack_require__(/*! ./withPublic */ "./node_modules/public-encrypt/withPublic.js")
var crt = __webpack_require__(/*! browserify-rsa */ "./node_modules/browserify-rsa/index.js")
var Buffer = __webpack_require__(/*! safe-buffer */ "./node_modules/safe-buffer/index.js").Buffer

module.exports = function publicEncrypt (publicKey, msg, reverse) {
  var padding
  if (publicKey.padding) {
    padding = publicKey.padding
  } else if (reverse) {
    padding = 1
  } else {
    padding = 4
  }
  var key = parseKeys(publicKey)
  var paddedMsg
  if (padding === 4) {
    paddedMsg = oaep(key, msg)
  } else if (padding === 1) {
    paddedMsg = pkcs1(key, msg, reverse)
  } else if (padding === 3) {
    paddedMsg = new BN(msg)
    if (paddedMsg.cmp(key.modulus) >= 0) {
      throw new Error('data too long for modulus')
    }
  } else {
    throw new Error('unknown padding')
  }
  if (reverse) {
    return crt(paddedMsg, key)
  } else {
    return withPublic(paddedMsg, key)
  }
}

function oaep (key, msg) {
  var k = key.modulus.byteLength()
  var mLen = msg.length
  var iHash = createHash('sha1').update(Buffer.alloc(0)).digest()
  var hLen = iHash.length
  var hLen2 = 2 * hLen
  if (mLen > k - hLen2 - 2) {
    throw new Error('message too long')
  }
  var ps = Buffer.alloc(k - mLen - hLen2 - 2)
  var dblen = k - hLen - 1
  var seed = randomBytes(hLen)
  var maskedDb = xor(Buffer.concat([iHash, ps, Buffer.alloc(1, 1), msg], dblen), mgf(seed, dblen))
  var maskedSeed = xor(seed, mgf(maskedDb, hLen))
  return new BN(Buffer.concat([Buffer.alloc(1), maskedSeed, maskedDb], k))
}
function pkcs1 (key, msg, reverse) {
  var mLen = msg.length
  var k = key.modulus.byteLength()
  if (mLen > k - 11) {
    throw new Error('message too long')
  }
  var ps
  if (reverse) {
    ps = Buffer.alloc(k - mLen - 3, 0xff)
  } else {
    ps = nonZero(k - mLen - 3)
  }
  return new BN(Buffer.concat([Buffer.from([0, reverse ? 1 : 2]), ps, Buffer.alloc(1), msg], k))
}
function nonZero (len) {
  var out = Buffer.allocUnsafe(len)
  var i = 0
  var cache = randomBytes(len * 2)
  var cur = 0
  var num
  while (i < len) {
    if (cur === cache.length) {
      cache = randomBytes(len * 2)
      cur = 0
    }
    num = cache[cur++]
    if (num) {
      out[i++] = num
    }
  }
  return out
}


/***/ }),

/***/ "./node_modules/public-encrypt/withPublic.js":
/*!***************************************************!*\
  !*** ./node_modules/public-encrypt/withPublic.js ***!
  \***************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var BN = __webpack_require__(/*! bn.js */ "./node_modules/public-encrypt/node_modules/bn.js/lib/bn.js")
var Buffer = __webpack_require__(/*! safe-buffer */ "./node_modules/safe-buffer/index.js").Buffer

function withPublic (paddedMsg, key) {
  return Buffer.from(paddedMsg
    .toRed(BN.mont(key.modulus))
    .redPow(new BN(key.publicExponent))
    .fromRed()
    .toArray())
}

module.exports = withPublic


/***/ }),

/***/ "./node_modules/public-encrypt/xor.js":
/*!********************************************!*\
  !*** ./node_modules/public-encrypt/xor.js ***!
  \********************************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = function xor (a, b) {
  var len = a.length
  var i = -1
  while (++i < len) {
    a[i] ^= b[i]
  }
  return a
}


/***/ }),

/***/ "./node_modules/randombytes/browser.js":
/*!*********************************************!*\
  !*** ./node_modules/randombytes/browser.js ***!
  \*********************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global, process) {

// limit of Crypto.getRandomValues()
// https://developer.mozilla.org/en-US/docs/Web/API/Crypto/getRandomValues
var MAX_BYTES = 65536

// Node supports requesting up to this number of bytes
// https://github.com/nodejs/node/blob/master/lib/internal/crypto/random.js#L48
var MAX_UINT32 = 4294967295

function oldBrowser () {
  throw new Error('Secure random number generation is not supported by this browser.\nUse Chrome, Firefox or Internet Explorer 11')
}

var Buffer = __webpack_require__(/*! safe-buffer */ "./node_modules/safe-buffer/index.js").Buffer
var crypto = global.crypto || global.msCrypto

if (crypto && crypto.getRandomValues) {
  module.exports = randomBytes
} else {
  module.exports = oldBrowser
}

function randomBytes (size, cb) {
  // phantomjs needs to throw
  if (size > MAX_UINT32) throw new RangeError('requested too many random bytes')

  var bytes = Buffer.allocUnsafe(size)

  if (size > 0) {  // getRandomValues fails on IE if size == 0
    if (size > MAX_BYTES) { // this is the max bytes crypto.getRandomValues
      // can do at once see https://developer.mozilla.org/en-US/docs/Web/API/window.crypto.getRandomValues
      for (var generated = 0; generated < size; generated += MAX_BYTES) {
        // buffer.slice automatically checks if the end is past the end of
        // the buffer so we don't have to here
        crypto.getRandomValues(bytes.slice(generated, generated + MAX_BYTES))
      }
    } else {
      crypto.getRandomValues(bytes)
    }
  }

  if (typeof cb === 'function') {
    return process.nextTick(function () {
      cb(null, bytes)
    })
  }

  return bytes
}

/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(/*! ./../webpack/buildin/global.js */ "./node_modules/webpack/buildin/global.js"), __webpack_require__(/*! ./../process/browser.js */ "./node_modules/process/browser.js")))

/***/ }),

/***/ "./node_modules/randomfill/browser.js":
/*!********************************************!*\
  !*** ./node_modules/randomfill/browser.js ***!
  \********************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global, process) {

function oldBrowser () {
  throw new Error('secure random number generation not supported by this browser\nuse chrome, FireFox or Internet Explorer 11')
}
var safeBuffer = __webpack_require__(/*! safe-buffer */ "./node_modules/safe-buffer/index.js")
var randombytes = __webpack_require__(/*! randombytes */ "./node_modules/randombytes/browser.js")
var Buffer = safeBuffer.Buffer
var kBufferMaxLength = safeBuffer.kMaxLength
var crypto = global.crypto || global.msCrypto
var kMaxUint32 = Math.pow(2, 32) - 1
function assertOffset (offset, length) {
  if (typeof offset !== 'number' || offset !== offset) { // eslint-disable-line no-self-compare
    throw new TypeError('offset must be a number')
  }

  if (offset > kMaxUint32 || offset < 0) {
    throw new TypeError('offset must be a uint32')
  }

  if (offset > kBufferMaxLength || offset > length) {
    throw new RangeError('offset out of range')
  }
}

function assertSize (size, offset, length) {
  if (typeof size !== 'number' || size !== size) { // eslint-disable-line no-self-compare
    throw new TypeError('size must be a number')
  }

  if (size > kMaxUint32 || size < 0) {
    throw new TypeError('size must be a uint32')
  }

  if (size + offset > length || size > kBufferMaxLength) {
    throw new RangeError('buffer too small')
  }
}
if ((crypto && crypto.getRandomValues) || !process.browser) {
  exports.randomFill = randomFill
  exports.randomFillSync = randomFillSync
} else {
  exports.randomFill = oldBrowser
  exports.randomFillSync = oldBrowser
}
function randomFill (buf, offset, size, cb) {
  if (!Buffer.isBuffer(buf) && !(buf instanceof global.Uint8Array)) {
    throw new TypeError('"buf" argument must be a Buffer or Uint8Array')
  }

  if (typeof offset === 'function') {
    cb = offset
    offset = 0
    size = buf.length
  } else if (typeof size === 'function') {
    cb = size
    size = buf.length - offset
  } else if (typeof cb !== 'function') {
    throw new TypeError('"cb" argument must be a function')
  }
  assertOffset(offset, buf.length)
  assertSize(size, offset, buf.length)
  return actualFill(buf, offset, size, cb)
}

function actualFill (buf, offset, size, cb) {
  if (process.browser) {
    var ourBuf = buf.buffer
    var uint = new Uint8Array(ourBuf, offset, size)
    crypto.getRandomValues(uint)
    if (cb) {
      process.nextTick(function () {
        cb(null, buf)
      })
      return
    }
    return buf
  }
  if (cb) {
    randombytes(size, function (err, bytes) {
      if (err) {
        return cb(err)
      }
      bytes.copy(buf, offset)
      cb(null, buf)
    })
    return
  }
  var bytes = randombytes(size)
  bytes.copy(buf, offset)
  return buf
}
function randomFillSync (buf, offset, size) {
  if (typeof offset === 'undefined') {
    offset = 0
  }
  if (!Buffer.isBuffer(buf) && !(buf instanceof global.Uint8Array)) {
    throw new TypeError('"buf" argument must be a Buffer or Uint8Array')
  }

  assertOffset(offset, buf.length)

  if (size === undefined) size = buf.length - offset

  assertSize(size, offset, buf.length)

  return actualFill(buf, offset, size)
}

/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(/*! ./../webpack/buildin/global.js */ "./node_modules/webpack/buildin/global.js"), __webpack_require__(/*! ./../process/browser.js */ "./node_modules/process/browser.js")))

/***/ }),

/***/ "./node_modules/react-dom/cjs/react-dom.development.js":
/*!*************************************************************!*\
  !*** ./node_modules/react-dom/cjs/react-dom.development.js ***!
  \*************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v17.0.1
 * react-dom.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



if (true) {
  (function() {
'use strict';

var React = __webpack_require__(/*! react */ "./node_modules/react/index.js");
var _assign = __webpack_require__(/*! object-assign */ "./node_modules/object-assign/index.js");
var Scheduler = __webpack_require__(/*! scheduler */ "./node_modules/scheduler/index.js");
var tracing = __webpack_require__(/*! scheduler/tracing */ "./node_modules/scheduler/tracing.js");

var ReactSharedInternals = React.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;

// by calls to these methods by a Babel plugin.
//
// In PROD (or in packages without access to React internals),
// they are left as they are instead.

function warn(format) {
  {
    for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    printWarning('warn', format, args);
  }
}
function error(format) {
  {
    for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
      args[_key2 - 1] = arguments[_key2];
    }

    printWarning('error', format, args);
  }
}

function printWarning(level, format, args) {
  // When changing this logic, you might want to also
  // update consoleWithStackDev.www.js as well.
  {
    var ReactDebugCurrentFrame = ReactSharedInternals.ReactDebugCurrentFrame;
    var stack = ReactDebugCurrentFrame.getStackAddendum();

    if (stack !== '') {
      format += '%s';
      args = args.concat([stack]);
    }

    var argsWithFormat = args.map(function (item) {
      return '' + item;
    }); // Careful: RN currently depends on this prefix

    argsWithFormat.unshift('Warning: ' + format); // We intentionally don't use spread (or .apply) directly because it
    // breaks IE9: https://github.com/facebook/react/issues/13610
    // eslint-disable-next-line react-internal/no-production-logging

    Function.prototype.apply.call(console[level], console, argsWithFormat);
  }
}

if (!React) {
  {
    throw Error( "ReactDOM was loaded before React. Make sure you load the React package before loading ReactDOM." );
  }
}

var FunctionComponent = 0;
var ClassComponent = 1;
var IndeterminateComponent = 2; // Before we know whether it is function or class

var HostRoot = 3; // Root of a host tree. Could be nested inside another node.

var HostPortal = 4; // A subtree. Could be an entry point to a different renderer.

var HostComponent = 5;
var HostText = 6;
var Fragment = 7;
var Mode = 8;
var ContextConsumer = 9;
var ContextProvider = 10;
var ForwardRef = 11;
var Profiler = 12;
var SuspenseComponent = 13;
var MemoComponent = 14;
var SimpleMemoComponent = 15;
var LazyComponent = 16;
var IncompleteClassComponent = 17;
var DehydratedFragment = 18;
var SuspenseListComponent = 19;
var FundamentalComponent = 20;
var ScopeComponent = 21;
var Block = 22;
var OffscreenComponent = 23;
var LegacyHiddenComponent = 24;

// Filter certain DOM attributes (e.g. src, href) if their values are empty strings.

var enableProfilerTimer = true; // Record durations for commit and passive effects phases.

var enableFundamentalAPI = false; // Experimental Scope support.
var enableNewReconciler = false; // Errors that are thrown while unmounting (or after in the case of passive effects)
var warnAboutStringRefs = false;

var allNativeEvents = new Set();
/**
 * Mapping from registration name to event name
 */


var registrationNameDependencies = {};
/**
 * Mapping from lowercase registration names to the properly cased version,
 * used to warn in the case of missing event handlers. Available
 * only in true.
 * @type {Object}
 */

var possibleRegistrationNames =  {} ; // Trust the developer to only use possibleRegistrationNames in true

function registerTwoPhaseEvent(registrationName, dependencies) {
  registerDirectEvent(registrationName, dependencies);
  registerDirectEvent(registrationName + 'Capture', dependencies);
}
function registerDirectEvent(registrationName, dependencies) {
  {
    if (registrationNameDependencies[registrationName]) {
      error('EventRegistry: More than one plugin attempted to publish the same ' + 'registration name, `%s`.', registrationName);
    }
  }

  registrationNameDependencies[registrationName] = dependencies;

  {
    var lowerCasedName = registrationName.toLowerCase();
    possibleRegistrationNames[lowerCasedName] = registrationName;

    if (registrationName === 'onDoubleClick') {
      possibleRegistrationNames.ondblclick = registrationName;
    }
  }

  for (var i = 0; i < dependencies.length; i++) {
    allNativeEvents.add(dependencies[i]);
  }
}

var canUseDOM = !!(typeof window !== 'undefined' && typeof window.document !== 'undefined' && typeof window.document.createElement !== 'undefined');

// A reserved attribute.
// It is handled by React separately and shouldn't be written to the DOM.
var RESERVED = 0; // A simple string attribute.
// Attributes that aren't in the filter are presumed to have this type.

var STRING = 1; // A string attribute that accepts booleans in React. In HTML, these are called
// "enumerated" attributes with "true" and "false" as possible values.
// When true, it should be set to a "true" string.
// When false, it should be set to a "false" string.

var BOOLEANISH_STRING = 2; // A real boolean attribute.
// When true, it should be present (set either to an empty string or its name).
// When false, it should be omitted.

var BOOLEAN = 3; // An attribute that can be used as a flag as well as with a value.
// When true, it should be present (set either to an empty string or its name).
// When false, it should be omitted.
// For any other value, should be present with that value.

var OVERLOADED_BOOLEAN = 4; // An attribute that must be numeric or parse as a numeric.
// When falsy, it should be removed.

var NUMERIC = 5; // An attribute that must be positive numeric or parse as a positive numeric.
// When falsy, it should be removed.

var POSITIVE_NUMERIC = 6;

/* eslint-disable max-len */
var ATTRIBUTE_NAME_START_CHAR = ":A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD";
/* eslint-enable max-len */

var ATTRIBUTE_NAME_CHAR = ATTRIBUTE_NAME_START_CHAR + "\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040";
var ROOT_ATTRIBUTE_NAME = 'data-reactroot';
var VALID_ATTRIBUTE_NAME_REGEX = new RegExp('^[' + ATTRIBUTE_NAME_START_CHAR + '][' + ATTRIBUTE_NAME_CHAR + ']*$');
var hasOwnProperty = Object.prototype.hasOwnProperty;
var illegalAttributeNameCache = {};
var validatedAttributeNameCache = {};
function isAttributeNameSafe(attributeName) {
  if (hasOwnProperty.call(validatedAttributeNameCache, attributeName)) {
    return true;
  }

  if (hasOwnProperty.call(illegalAttributeNameCache, attributeName)) {
    return false;
  }

  if (VALID_ATTRIBUTE_NAME_REGEX.test(attributeName)) {
    validatedAttributeNameCache[attributeName] = true;
    return true;
  }

  illegalAttributeNameCache[attributeName] = true;

  {
    error('Invalid attribute name: `%s`', attributeName);
  }

  return false;
}
function shouldIgnoreAttribute(name, propertyInfo, isCustomComponentTag) {
  if (propertyInfo !== null) {
    return propertyInfo.type === RESERVED;
  }

  if (isCustomComponentTag) {
    return false;
  }

  if (name.length > 2 && (name[0] === 'o' || name[0] === 'O') && (name[1] === 'n' || name[1] === 'N')) {
    return true;
  }

  return false;
}
function shouldRemoveAttributeWithWarning(name, value, propertyInfo, isCustomComponentTag) {
  if (propertyInfo !== null && propertyInfo.type === RESERVED) {
    return false;
  }

  switch (typeof value) {
    case 'function': // $FlowIssue symbol is perfectly valid here

    case 'symbol':
      // eslint-disable-line
      return true;

    case 'boolean':
      {
        if (isCustomComponentTag) {
          return false;
        }

        if (propertyInfo !== null) {
          return !propertyInfo.acceptsBooleans;
        } else {
          var prefix = name.toLowerCase().slice(0, 5);
          return prefix !== 'data-' && prefix !== 'aria-';
        }
      }

    default:
      return false;
  }
}
function shouldRemoveAttribute(name, value, propertyInfo, isCustomComponentTag) {
  if (value === null || typeof value === 'undefined') {
    return true;
  }

  if (shouldRemoveAttributeWithWarning(name, value, propertyInfo, isCustomComponentTag)) {
    return true;
  }

  if (isCustomComponentTag) {
    return false;
  }

  if (propertyInfo !== null) {

    switch (propertyInfo.type) {
      case BOOLEAN:
        return !value;

      case OVERLOADED_BOOLEAN:
        return value === false;

      case NUMERIC:
        return isNaN(value);

      case POSITIVE_NUMERIC:
        return isNaN(value) || value < 1;
    }
  }

  return false;
}
function getPropertyInfo(name) {
  return properties.hasOwnProperty(name) ? properties[name] : null;
}

function PropertyInfoRecord(name, type, mustUseProperty, attributeName, attributeNamespace, sanitizeURL, removeEmptyString) {
  this.acceptsBooleans = type === BOOLEANISH_STRING || type === BOOLEAN || type === OVERLOADED_BOOLEAN;
  this.attributeName = attributeName;
  this.attributeNamespace = attributeNamespace;
  this.mustUseProperty = mustUseProperty;
  this.propertyName = name;
  this.type = type;
  this.sanitizeURL = sanitizeURL;
  this.removeEmptyString = removeEmptyString;
} // When adding attributes to this list, be sure to also add them to
// the `possibleStandardNames` module to ensure casing and incorrect
// name warnings.


var properties = {}; // These props are reserved by React. They shouldn't be written to the DOM.

var reservedProps = ['children', 'dangerouslySetInnerHTML', // TODO: This prevents the assignment of defaultValue to regular
// elements (not just inputs). Now that ReactDOMInput assigns to the
// defaultValue property -- do we need this?
'defaultValue', 'defaultChecked', 'innerHTML', 'suppressContentEditableWarning', 'suppressHydrationWarning', 'style'];
reservedProps.forEach(function (name) {
  properties[name] = new PropertyInfoRecord(name, RESERVED, false, // mustUseProperty
  name, // attributeName
  null, // attributeNamespace
  false, // sanitizeURL
  false);
}); // A few React string attributes have a different name.
// This is a mapping from React prop names to the attribute names.

[['acceptCharset', 'accept-charset'], ['className', 'class'], ['htmlFor', 'for'], ['httpEquiv', 'http-equiv']].forEach(function (_ref) {
  var name = _ref[0],
      attributeName = _ref[1];
  properties[name] = new PropertyInfoRecord(name, STRING, false, // mustUseProperty
  attributeName, // attributeName
  null, // attributeNamespace
  false, // sanitizeURL
  false);
}); // These are "enumerated" HTML attributes that accept "true" and "false".
// In React, we let users pass `true` and `false` even though technically
// these aren't boolean attributes (they are coerced to strings).

['contentEditable', 'draggable', 'spellCheck', 'value'].forEach(function (name) {
  properties[name] = new PropertyInfoRecord(name, BOOLEANISH_STRING, false, // mustUseProperty
  name.toLowerCase(), // attributeName
  null, // attributeNamespace
  false, // sanitizeURL
  false);
}); // These are "enumerated" SVG attributes that accept "true" and "false".
// In React, we let users pass `true` and `false` even though technically
// these aren't boolean attributes (they are coerced to strings).
// Since these are SVG attributes, their attribute names are case-sensitive.

['autoReverse', 'externalResourcesRequired', 'focusable', 'preserveAlpha'].forEach(function (name) {
  properties[name] = new PropertyInfoRecord(name, BOOLEANISH_STRING, false, // mustUseProperty
  name, // attributeName
  null, // attributeNamespace
  false, // sanitizeURL
  false);
}); // These are HTML boolean attributes.

['allowFullScreen', 'async', // Note: there is a special case that prevents it from being written to the DOM
// on the client side because the browsers are inconsistent. Instead we call focus().
'autoFocus', 'autoPlay', 'controls', 'default', 'defer', 'disabled', 'disablePictureInPicture', 'disableRemotePlayback', 'formNoValidate', 'hidden', 'loop', 'noModule', 'noValidate', 'open', 'playsInline', 'readOnly', 'required', 'reversed', 'scoped', 'seamless', // Microdata
'itemScope'].forEach(function (name) {
  properties[name] = new PropertyInfoRecord(name, BOOLEAN, false, // mustUseProperty
  name.toLowerCase(), // attributeName
  null, // attributeNamespace
  false, // sanitizeURL
  false);
}); // These are the few React props that we set as DOM properties
// rather than attributes. These are all booleans.

['checked', // Note: `option.selected` is not updated if `select.multiple` is
// disabled with `removeAttribute`. We have special logic for handling this.
'multiple', 'muted', 'selected' // NOTE: if you add a camelCased prop to this list,
// you'll need to set attributeName to name.toLowerCase()
// instead in the assignment below.
].forEach(function (name) {
  properties[name] = new PropertyInfoRecord(name, BOOLEAN, true, // mustUseProperty
  name, // attributeName
  null, // attributeNamespace
  false, // sanitizeURL
  false);
}); // These are HTML attributes that are "overloaded booleans": they behave like
// booleans, but can also accept a string value.

['capture', 'download' // NOTE: if you add a camelCased prop to this list,
// you'll need to set attributeName to name.toLowerCase()
// instead in the assignment below.
].forEach(function (name) {
  properties[name] = new PropertyInfoRecord(name, OVERLOADED_BOOLEAN, false, // mustUseProperty
  name, // attributeName
  null, // attributeNamespace
  false, // sanitizeURL
  false);
}); // These are HTML attributes that must be positive numbers.

['cols', 'rows', 'size', 'span' // NOTE: if you add a camelCased prop to this list,
// you'll need to set attributeName to name.toLowerCase()
// instead in the assignment below.
].forEach(function (name) {
  properties[name] = new PropertyInfoRecord(name, POSITIVE_NUMERIC, false, // mustUseProperty
  name, // attributeName
  null, // attributeNamespace
  false, // sanitizeURL
  false);
}); // These are HTML attributes that must be numbers.

['rowSpan', 'start'].forEach(function (name) {
  properties[name] = new PropertyInfoRecord(name, NUMERIC, false, // mustUseProperty
  name.toLowerCase(), // attributeName
  null, // attributeNamespace
  false, // sanitizeURL
  false);
});
var CAMELIZE = /[\-\:]([a-z])/g;

var capitalize = function (token) {
  return token[1].toUpperCase();
}; // This is a list of all SVG attributes that need special casing, namespacing,
// or boolean value assignment. Regular attributes that just accept strings
// and have the same names are omitted, just like in the HTML attribute filter.
// Some of these attributes can be hard to find. This list was created by
// scraping the MDN documentation.


['accent-height', 'alignment-baseline', 'arabic-form', 'baseline-shift', 'cap-height', 'clip-path', 'clip-rule', 'color-interpolation', 'color-interpolation-filters', 'color-profile', 'color-rendering', 'dominant-baseline', 'enable-background', 'fill-opacity', 'fill-rule', 'flood-color', 'flood-opacity', 'font-family', 'font-size', 'font-size-adjust', 'font-stretch', 'font-style', 'font-variant', 'font-weight', 'glyph-name', 'glyph-orientation-horizontal', 'glyph-orientation-vertical', 'horiz-adv-x', 'horiz-origin-x', 'image-rendering', 'letter-spacing', 'lighting-color', 'marker-end', 'marker-mid', 'marker-start', 'overline-position', 'overline-thickness', 'paint-order', 'panose-1', 'pointer-events', 'rendering-intent', 'shape-rendering', 'stop-color', 'stop-opacity', 'strikethrough-position', 'strikethrough-thickness', 'stroke-dasharray', 'stroke-dashoffset', 'stroke-linecap', 'stroke-linejoin', 'stroke-miterlimit', 'stroke-opacity', 'stroke-width', 'text-anchor', 'text-decoration', 'text-rendering', 'underline-position', 'underline-thickness', 'unicode-bidi', 'unicode-range', 'units-per-em', 'v-alphabetic', 'v-hanging', 'v-ideographic', 'v-mathematical', 'vector-effect', 'vert-adv-y', 'vert-origin-x', 'vert-origin-y', 'word-spacing', 'writing-mode', 'xmlns:xlink', 'x-height' // NOTE: if you add a camelCased prop to this list,
// you'll need to set attributeName to name.toLowerCase()
// instead in the assignment below.
].forEach(function (attributeName) {
  var name = attributeName.replace(CAMELIZE, capitalize);
  properties[name] = new PropertyInfoRecord(name, STRING, false, // mustUseProperty
  attributeName, null, // attributeNamespace
  false, // sanitizeURL
  false);
}); // String SVG attributes with the xlink namespace.

['xlink:actuate', 'xlink:arcrole', 'xlink:role', 'xlink:show', 'xlink:title', 'xlink:type' // NOTE: if you add a camelCased prop to this list,
// you'll need to set attributeName to name.toLowerCase()
// instead in the assignment below.
].forEach(function (attributeName) {
  var name = attributeName.replace(CAMELIZE, capitalize);
  properties[name] = new PropertyInfoRecord(name, STRING, false, // mustUseProperty
  attributeName, 'http://www.w3.org/1999/xlink', false, // sanitizeURL
  false);
}); // String SVG attributes with the xml namespace.

['xml:base', 'xml:lang', 'xml:space' // NOTE: if you add a camelCased prop to this list,
// you'll need to set attributeName to name.toLowerCase()
// instead in the assignment below.
].forEach(function (attributeName) {
  var name = attributeName.replace(CAMELIZE, capitalize);
  properties[name] = new PropertyInfoRecord(name, STRING, false, // mustUseProperty
  attributeName, 'http://www.w3.org/XML/1998/namespace', false, // sanitizeURL
  false);
}); // These attribute exists both in HTML and SVG.
// The attribute name is case-sensitive in SVG so we can't just use
// the React name like we do for attributes that exist only in HTML.

['tabIndex', 'crossOrigin'].forEach(function (attributeName) {
  properties[attributeName] = new PropertyInfoRecord(attributeName, STRING, false, // mustUseProperty
  attributeName.toLowerCase(), // attributeName
  null, // attributeNamespace
  false, // sanitizeURL
  false);
}); // These attributes accept URLs. These must not allow javascript: URLS.
// These will also need to accept Trusted Types object in the future.

var xlinkHref = 'xlinkHref';
properties[xlinkHref] = new PropertyInfoRecord('xlinkHref', STRING, false, // mustUseProperty
'xlink:href', 'http://www.w3.org/1999/xlink', true, // sanitizeURL
false);
['src', 'href', 'action', 'formAction'].forEach(function (attributeName) {
  properties[attributeName] = new PropertyInfoRecord(attributeName, STRING, false, // mustUseProperty
  attributeName.toLowerCase(), // attributeName
  null, // attributeNamespace
  true, // sanitizeURL
  true);
});

// and any newline or tab are filtered out as if they're not part of the URL.
// https://url.spec.whatwg.org/#url-parsing
// Tab or newline are defined as \r\n\t:
// https://infra.spec.whatwg.org/#ascii-tab-or-newline
// A C0 control is a code point in the range \u0000 NULL to \u001F
// INFORMATION SEPARATOR ONE, inclusive:
// https://infra.spec.whatwg.org/#c0-control-or-space

/* eslint-disable max-len */

var isJavaScriptProtocol = /^[\u0000-\u001F ]*j[\r\n\t]*a[\r\n\t]*v[\r\n\t]*a[\r\n\t]*s[\r\n\t]*c[\r\n\t]*r[\r\n\t]*i[\r\n\t]*p[\r\n\t]*t[\r\n\t]*\:/i;
var didWarn = false;

function sanitizeURL(url) {
  {
    if (!didWarn && isJavaScriptProtocol.test(url)) {
      didWarn = true;

      error('A future version of React will block javascript: URLs as a security precaution. ' + 'Use event handlers instead if you can. If you need to generate unsafe HTML try ' + 'using dangerouslySetInnerHTML instead. React was passed %s.', JSON.stringify(url));
    }
  }
}

/**
 * Get the value for a property on a node. Only used in DEV for SSR validation.
 * The "expected" argument is used as a hint of what the expected value is.
 * Some properties have multiple equivalent values.
 */
function getValueForProperty(node, name, expected, propertyInfo) {
  {
    if (propertyInfo.mustUseProperty) {
      var propertyName = propertyInfo.propertyName;
      return node[propertyName];
    } else {
      if ( propertyInfo.sanitizeURL) {
        // If we haven't fully disabled javascript: URLs, and if
        // the hydration is successful of a javascript: URL, we
        // still want to warn on the client.
        sanitizeURL('' + expected);
      }

      var attributeName = propertyInfo.attributeName;
      var stringValue = null;

      if (propertyInfo.type === OVERLOADED_BOOLEAN) {
        if (node.hasAttribute(attributeName)) {
          var value = node.getAttribute(attributeName);

          if (value === '') {
            return true;
          }

          if (shouldRemoveAttribute(name, expected, propertyInfo, false)) {
            return value;
          }

          if (value === '' + expected) {
            return expected;
          }

          return value;
        }
      } else if (node.hasAttribute(attributeName)) {
        if (shouldRemoveAttribute(name, expected, propertyInfo, false)) {
          // We had an attribute but shouldn't have had one, so read it
          // for the error message.
          return node.getAttribute(attributeName);
        }

        if (propertyInfo.type === BOOLEAN) {
          // If this was a boolean, it doesn't matter what the value is
          // the fact that we have it is the same as the expected.
          return expected;
        } // Even if this property uses a namespace we use getAttribute
        // because we assume its namespaced name is the same as our config.
        // To use getAttributeNS we need the local name which we don't have
        // in our config atm.


        stringValue = node.getAttribute(attributeName);
      }

      if (shouldRemoveAttribute(name, expected, propertyInfo, false)) {
        return stringValue === null ? expected : stringValue;
      } else if (stringValue === '' + expected) {
        return expected;
      } else {
        return stringValue;
      }
    }
  }
}
/**
 * Get the value for a attribute on a node. Only used in DEV for SSR validation.
 * The third argument is used as a hint of what the expected value is. Some
 * attributes have multiple equivalent values.
 */

function getValueForAttribute(node, name, expected) {
  {
    if (!isAttributeNameSafe(name)) {
      return;
    } // If the object is an opaque reference ID, it's expected that
    // the next prop is different than the server value, so just return
    // expected


    if (isOpaqueHydratingObject(expected)) {
      return expected;
    }

    if (!node.hasAttribute(name)) {
      return expected === undefined ? undefined : null;
    }

    var value = node.getAttribute(name);

    if (value === '' + expected) {
      return expected;
    }

    return value;
  }
}
/**
 * Sets the value for a property on a node.
 *
 * @param {DOMElement} node
 * @param {string} name
 * @param {*} value
 */

function setValueForProperty(node, name, value, isCustomComponentTag) {
  var propertyInfo = getPropertyInfo(name);

  if (shouldIgnoreAttribute(name, propertyInfo, isCustomComponentTag)) {
    return;
  }

  if (shouldRemoveAttribute(name, value, propertyInfo, isCustomComponentTag)) {
    value = null;
  } // If the prop isn't in the special list, treat it as a simple attribute.


  if (isCustomComponentTag || propertyInfo === null) {
    if (isAttributeNameSafe(name)) {
      var _attributeName = name;

      if (value === null) {
        node.removeAttribute(_attributeName);
      } else {
        node.setAttribute(_attributeName,  '' + value);
      }
    }

    return;
  }

  var mustUseProperty = propertyInfo.mustUseProperty;

  if (mustUseProperty) {
    var propertyName = propertyInfo.propertyName;

    if (value === null) {
      var type = propertyInfo.type;
      node[propertyName] = type === BOOLEAN ? false : '';
    } else {
      // Contrary to `setAttribute`, object properties are properly
      // `toString`ed by IE8/9.
      node[propertyName] = value;
    }

    return;
  } // The rest are treated as attributes with special cases.


  var attributeName = propertyInfo.attributeName,
      attributeNamespace = propertyInfo.attributeNamespace;

  if (value === null) {
    node.removeAttribute(attributeName);
  } else {
    var _type = propertyInfo.type;
    var attributeValue;

    if (_type === BOOLEAN || _type === OVERLOADED_BOOLEAN && value === true) {
      // If attribute type is boolean, we know for sure it won't be an execution sink
      // and we won't require Trusted Type here.
      attributeValue = '';
    } else {
      // `setAttribute` with objects becomes only `[object]` in IE8/9,
      // ('' + value) makes it output the correct toString()-value.
      {
        attributeValue = '' + value;
      }

      if (propertyInfo.sanitizeURL) {
        sanitizeURL(attributeValue.toString());
      }
    }

    if (attributeNamespace) {
      node.setAttributeNS(attributeNamespace, attributeName, attributeValue);
    } else {
      node.setAttribute(attributeName, attributeValue);
    }
  }
}

// ATTENTION
// When adding new symbols to this file,
// Please consider also adding to 'react-devtools-shared/src/backend/ReactSymbols'
// The Symbol used to tag the ReactElement-like types. If there is no native Symbol
// nor polyfill, then a plain number is used for performance.
var REACT_ELEMENT_TYPE = 0xeac7;
var REACT_PORTAL_TYPE = 0xeaca;
var REACT_FRAGMENT_TYPE = 0xeacb;
var REACT_STRICT_MODE_TYPE = 0xeacc;
var REACT_PROFILER_TYPE = 0xead2;
var REACT_PROVIDER_TYPE = 0xeacd;
var REACT_CONTEXT_TYPE = 0xeace;
var REACT_FORWARD_REF_TYPE = 0xead0;
var REACT_SUSPENSE_TYPE = 0xead1;
var REACT_SUSPENSE_LIST_TYPE = 0xead8;
var REACT_MEMO_TYPE = 0xead3;
var REACT_LAZY_TYPE = 0xead4;
var REACT_BLOCK_TYPE = 0xead9;
var REACT_SERVER_BLOCK_TYPE = 0xeada;
var REACT_FUNDAMENTAL_TYPE = 0xead5;
var REACT_SCOPE_TYPE = 0xead7;
var REACT_OPAQUE_ID_TYPE = 0xeae0;
var REACT_DEBUG_TRACING_MODE_TYPE = 0xeae1;
var REACT_OFFSCREEN_TYPE = 0xeae2;
var REACT_LEGACY_HIDDEN_TYPE = 0xeae3;

if (typeof Symbol === 'function' && Symbol.for) {
  var symbolFor = Symbol.for;
  REACT_ELEMENT_TYPE = symbolFor('react.element');
  REACT_PORTAL_TYPE = symbolFor('react.portal');
  REACT_FRAGMENT_TYPE = symbolFor('react.fragment');
  REACT_STRICT_MODE_TYPE = symbolFor('react.strict_mode');
  REACT_PROFILER_TYPE = symbolFor('react.profiler');
  REACT_PROVIDER_TYPE = symbolFor('react.provider');
  REACT_CONTEXT_TYPE = symbolFor('react.context');
  REACT_FORWARD_REF_TYPE = symbolFor('react.forward_ref');
  REACT_SUSPENSE_TYPE = symbolFor('react.suspense');
  REACT_SUSPENSE_LIST_TYPE = symbolFor('react.suspense_list');
  REACT_MEMO_TYPE = symbolFor('react.memo');
  REACT_LAZY_TYPE = symbolFor('react.lazy');
  REACT_BLOCK_TYPE = symbolFor('react.block');
  REACT_SERVER_BLOCK_TYPE = symbolFor('react.server.block');
  REACT_FUNDAMENTAL_TYPE = symbolFor('react.fundamental');
  REACT_SCOPE_TYPE = symbolFor('react.scope');
  REACT_OPAQUE_ID_TYPE = symbolFor('react.opaque.id');
  REACT_DEBUG_TRACING_MODE_TYPE = symbolFor('react.debug_trace_mode');
  REACT_OFFSCREEN_TYPE = symbolFor('react.offscreen');
  REACT_LEGACY_HIDDEN_TYPE = symbolFor('react.legacy_hidden');
}

var MAYBE_ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
var FAUX_ITERATOR_SYMBOL = '@@iterator';
function getIteratorFn(maybeIterable) {
  if (maybeIterable === null || typeof maybeIterable !== 'object') {
    return null;
  }

  var maybeIterator = MAYBE_ITERATOR_SYMBOL && maybeIterable[MAYBE_ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL];

  if (typeof maybeIterator === 'function') {
    return maybeIterator;
  }

  return null;
}

// Helpers to patch console.logs to avoid logging during side-effect free
// replaying on render function. This currently only patches the object
// lazily which won't cover if the log function was extracted eagerly.
// We could also eagerly patch the method.
var disabledDepth = 0;
var prevLog;
var prevInfo;
var prevWarn;
var prevError;
var prevGroup;
var prevGroupCollapsed;
var prevGroupEnd;

function disabledLog() {}

disabledLog.__reactDisabledLog = true;
function disableLogs() {
  {
    if (disabledDepth === 0) {
      /* eslint-disable react-internal/no-production-logging */
      prevLog = console.log;
      prevInfo = console.info;
      prevWarn = console.warn;
      prevError = console.error;
      prevGroup = console.group;
      prevGroupCollapsed = console.groupCollapsed;
      prevGroupEnd = console.groupEnd; // https://github.com/facebook/react/issues/19099

      var props = {
        configurable: true,
        enumerable: true,
        value: disabledLog,
        writable: true
      }; // $FlowFixMe Flow thinks console is immutable.

      Object.defineProperties(console, {
        info: props,
        log: props,
        warn: props,
        error: props,
        group: props,
        groupCollapsed: props,
        groupEnd: props
      });
      /* eslint-enable react-internal/no-production-logging */
    }

    disabledDepth++;
  }
}
function reenableLogs() {
  {
    disabledDepth--;

    if (disabledDepth === 0) {
      /* eslint-disable react-internal/no-production-logging */
      var props = {
        configurable: true,
        enumerable: true,
        writable: true
      }; // $FlowFixMe Flow thinks console is immutable.

      Object.defineProperties(console, {
        log: _assign({}, props, {
          value: prevLog
        }),
        info: _assign({}, props, {
          value: prevInfo
        }),
        warn: _assign({}, props, {
          value: prevWarn
        }),
        error: _assign({}, props, {
          value: prevError
        }),
        group: _assign({}, props, {
          value: prevGroup
        }),
        groupCollapsed: _assign({}, props, {
          value: prevGroupCollapsed
        }),
        groupEnd: _assign({}, props, {
          value: prevGroupEnd
        })
      });
      /* eslint-enable react-internal/no-production-logging */
    }

    if (disabledDepth < 0) {
      error('disabledDepth fell below zero. ' + 'This is a bug in React. Please file an issue.');
    }
  }
}

var ReactCurrentDispatcher = ReactSharedInternals.ReactCurrentDispatcher;
var prefix;
function describeBuiltInComponentFrame(name, source, ownerFn) {
  {
    if (prefix === undefined) {
      // Extract the VM specific prefix used by each line.
      try {
        throw Error();
      } catch (x) {
        var match = x.stack.trim().match(/\n( *(at )?)/);
        prefix = match && match[1] || '';
      }
    } // We use the prefix to ensure our stacks line up with native stack frames.


    return '\n' + prefix + name;
  }
}
var reentry = false;
var componentFrameCache;

{
  var PossiblyWeakMap = typeof WeakMap === 'function' ? WeakMap : Map;
  componentFrameCache = new PossiblyWeakMap();
}

function describeNativeComponentFrame(fn, construct) {
  // If something asked for a stack inside a fake render, it should get ignored.
  if (!fn || reentry) {
    return '';
  }

  {
    var frame = componentFrameCache.get(fn);

    if (frame !== undefined) {
      return frame;
    }
  }

  var control;
  reentry = true;
  var previousPrepareStackTrace = Error.prepareStackTrace; // $FlowFixMe It does accept undefined.

  Error.prepareStackTrace = undefined;
  var previousDispatcher;

  {
    previousDispatcher = ReactCurrentDispatcher.current; // Set the dispatcher in DEV because this might be call in the render function
    // for warnings.

    ReactCurrentDispatcher.current = null;
    disableLogs();
  }

  try {
    // This should throw.
    if (construct) {
      // Something should be setting the props in the constructor.
      var Fake = function () {
        throw Error();
      }; // $FlowFixMe


      Object.defineProperty(Fake.prototype, 'props', {
        set: function () {
          // We use a throwing setter instead of frozen or non-writable props
          // because that won't throw in a non-strict mode function.
          throw Error();
        }
      });

      if (typeof Reflect === 'object' && Reflect.construct) {
        // We construct a different control for this case to include any extra
        // frames added by the construct call.
        try {
          Reflect.construct(Fake, []);
        } catch (x) {
          control = x;
        }

        Reflect.construct(fn, [], Fake);
      } else {
        try {
          Fake.call();
        } catch (x) {
          control = x;
        }

        fn.call(Fake.prototype);
      }
    } else {
      try {
        throw Error();
      } catch (x) {
        control = x;
      }

      fn();
    }
  } catch (sample) {
    // This is inlined manually because closure doesn't do it for us.
    if (sample && control && typeof sample.stack === 'string') {
      // This extracts the first frame from the sample that isn't also in the control.
      // Skipping one frame that we assume is the frame that calls the two.
      var sampleLines = sample.stack.split('\n');
      var controlLines = control.stack.split('\n');
      var s = sampleLines.length - 1;
      var c = controlLines.length - 1;

      while (s >= 1 && c >= 0 && sampleLines[s] !== controlLines[c]) {
        // We expect at least one stack frame to be shared.
        // Typically this will be the root most one. However, stack frames may be
        // cut off due to maximum stack limits. In this case, one maybe cut off
        // earlier than the other. We assume that the sample is longer or the same
        // and there for cut off earlier. So we should find the root most frame in
        // the sample somewhere in the control.
        c--;
      }

      for (; s >= 1 && c >= 0; s--, c--) {
        // Next we find the first one that isn't the same which should be the
        // frame that called our sample function and the control.
        if (sampleLines[s] !== controlLines[c]) {
          // In V8, the first line is describing the message but other VMs don't.
          // If we're about to return the first line, and the control is also on the same
          // line, that's a pretty good indicator that our sample threw at same line as
          // the control. I.e. before we entered the sample frame. So we ignore this result.
          // This can happen if you passed a class to function component, or non-function.
          if (s !== 1 || c !== 1) {
            do {
              s--;
              c--; // We may still have similar intermediate frames from the construct call.
              // The next one that isn't the same should be our match though.

              if (c < 0 || sampleLines[s] !== controlLines[c]) {
                // V8 adds a "new" prefix for native classes. Let's remove it to make it prettier.
                var _frame = '\n' + sampleLines[s].replace(' at new ', ' at ');

                {
                  if (typeof fn === 'function') {
                    componentFrameCache.set(fn, _frame);
                  }
                } // Return the line we found.


                return _frame;
              }
            } while (s >= 1 && c >= 0);
          }

          break;
        }
      }
    }
  } finally {
    reentry = false;

    {
      ReactCurrentDispatcher.current = previousDispatcher;
      reenableLogs();
    }

    Error.prepareStackTrace = previousPrepareStackTrace;
  } // Fallback to just using the name if we couldn't make it throw.


  var name = fn ? fn.displayName || fn.name : '';
  var syntheticFrame = name ? describeBuiltInComponentFrame(name) : '';

  {
    if (typeof fn === 'function') {
      componentFrameCache.set(fn, syntheticFrame);
    }
  }

  return syntheticFrame;
}

function describeClassComponentFrame(ctor, source, ownerFn) {
  {
    return describeNativeComponentFrame(ctor, true);
  }
}
function describeFunctionComponentFrame(fn, source, ownerFn) {
  {
    return describeNativeComponentFrame(fn, false);
  }
}

function shouldConstruct(Component) {
  var prototype = Component.prototype;
  return !!(prototype && prototype.isReactComponent);
}

function describeUnknownElementTypeFrameInDEV(type, source, ownerFn) {

  if (type == null) {
    return '';
  }

  if (typeof type === 'function') {
    {
      return describeNativeComponentFrame(type, shouldConstruct(type));
    }
  }

  if (typeof type === 'string') {
    return describeBuiltInComponentFrame(type);
  }

  switch (type) {
    case REACT_SUSPENSE_TYPE:
      return describeBuiltInComponentFrame('Suspense');

    case REACT_SUSPENSE_LIST_TYPE:
      return describeBuiltInComponentFrame('SuspenseList');
  }

  if (typeof type === 'object') {
    switch (type.$$typeof) {
      case REACT_FORWARD_REF_TYPE:
        return describeFunctionComponentFrame(type.render);

      case REACT_MEMO_TYPE:
        // Memo may contain any component type so we recursively resolve it.
        return describeUnknownElementTypeFrameInDEV(type.type, source, ownerFn);

      case REACT_BLOCK_TYPE:
        return describeFunctionComponentFrame(type._render);

      case REACT_LAZY_TYPE:
        {
          var lazyComponent = type;
          var payload = lazyComponent._payload;
          var init = lazyComponent._init;

          try {
            // Lazy may contain any component type so we recursively resolve it.
            return describeUnknownElementTypeFrameInDEV(init(payload), source, ownerFn);
          } catch (x) {}
        }
    }
  }

  return '';
}

function describeFiber(fiber) {
  var owner =  fiber._debugOwner ? fiber._debugOwner.type : null ;
  var source =  fiber._debugSource ;

  switch (fiber.tag) {
    case HostComponent:
      return describeBuiltInComponentFrame(fiber.type);

    case LazyComponent:
      return describeBuiltInComponentFrame('Lazy');

    case SuspenseComponent:
      return describeBuiltInComponentFrame('Suspense');

    case SuspenseListComponent:
      return describeBuiltInComponentFrame('SuspenseList');

    case FunctionComponent:
    case IndeterminateComponent:
    case SimpleMemoComponent:
      return describeFunctionComponentFrame(fiber.type);

    case ForwardRef:
      return describeFunctionComponentFrame(fiber.type.render);

    case Block:
      return describeFunctionComponentFrame(fiber.type._render);

    case ClassComponent:
      return describeClassComponentFrame(fiber.type);

    default:
      return '';
  }
}

function getStackByFiberInDevAndProd(workInProgress) {
  try {
    var info = '';
    var node = workInProgress;

    do {
      info += describeFiber(node);
      node = node.return;
    } while (node);

    return info;
  } catch (x) {
    return '\nError generating stack: ' + x.message + '\n' + x.stack;
  }
}

function getWrappedName(outerType, innerType, wrapperName) {
  var functionName = innerType.displayName || innerType.name || '';
  return outerType.displayName || (functionName !== '' ? wrapperName + "(" + functionName + ")" : wrapperName);
}

function getContextName(type) {
  return type.displayName || 'Context';
}

function getComponentName(type) {
  if (type == null) {
    // Host root, text node or just invalid type.
    return null;
  }

  {
    if (typeof type.tag === 'number') {
      error('Received an unexpected object in getComponentName(). ' + 'This is likely a bug in React. Please file an issue.');
    }
  }

  if (typeof type === 'function') {
    return type.displayName || type.name || null;
  }

  if (typeof type === 'string') {
    return type;
  }

  switch (type) {
    case REACT_FRAGMENT_TYPE:
      return 'Fragment';

    case REACT_PORTAL_TYPE:
      return 'Portal';

    case REACT_PROFILER_TYPE:
      return 'Profiler';

    case REACT_STRICT_MODE_TYPE:
      return 'StrictMode';

    case REACT_SUSPENSE_TYPE:
      return 'Suspense';

    case REACT_SUSPENSE_LIST_TYPE:
      return 'SuspenseList';
  }

  if (typeof type === 'object') {
    switch (type.$$typeof) {
      case REACT_CONTEXT_TYPE:
        var context = type;
        return getContextName(context) + '.Consumer';

      case REACT_PROVIDER_TYPE:
        var provider = type;
        return getContextName(provider._context) + '.Provider';

      case REACT_FORWARD_REF_TYPE:
        return getWrappedName(type, type.render, 'ForwardRef');

      case REACT_MEMO_TYPE:
        return getComponentName(type.type);

      case REACT_BLOCK_TYPE:
        return getComponentName(type._render);

      case REACT_LAZY_TYPE:
        {
          var lazyComponent = type;
          var payload = lazyComponent._payload;
          var init = lazyComponent._init;

          try {
            return getComponentName(init(payload));
          } catch (x) {
            return null;
          }
        }
    }
  }

  return null;
}

var ReactDebugCurrentFrame = ReactSharedInternals.ReactDebugCurrentFrame;
var current = null;
var isRendering = false;
function getCurrentFiberOwnerNameInDevOrNull() {
  {
    if (current === null) {
      return null;
    }

    var owner = current._debugOwner;

    if (owner !== null && typeof owner !== 'undefined') {
      return getComponentName(owner.type);
    }
  }

  return null;
}

function getCurrentFiberStackInDev() {
  {
    if (current === null) {
      return '';
    } // Safe because if current fiber exists, we are reconciling,
    // and it is guaranteed to be the work-in-progress version.


    return getStackByFiberInDevAndProd(current);
  }
}

function resetCurrentFiber() {
  {
    ReactDebugCurrentFrame.getCurrentStack = null;
    current = null;
    isRendering = false;
  }
}
function setCurrentFiber(fiber) {
  {
    ReactDebugCurrentFrame.getCurrentStack = getCurrentFiberStackInDev;
    current = fiber;
    isRendering = false;
  }
}
function setIsRendering(rendering) {
  {
    isRendering = rendering;
  }
}
function getIsRendering() {
  {
    return isRendering;
  }
}

// Flow does not allow string concatenation of most non-string types. To work
// around this limitation, we use an opaque type that can only be obtained by
// passing the value through getToStringValue first.
function toString(value) {
  return '' + value;
}
function getToStringValue(value) {
  switch (typeof value) {
    case 'boolean':
    case 'number':
    case 'object':
    case 'string':
    case 'undefined':
      return value;

    default:
      // function, symbol are assigned as empty strings
      return '';
  }
}

var hasReadOnlyValue = {
  button: true,
  checkbox: true,
  image: true,
  hidden: true,
  radio: true,
  reset: true,
  submit: true
};
function checkControlledValueProps(tagName, props) {
  {
    if (!(hasReadOnlyValue[props.type] || props.onChange || props.onInput || props.readOnly || props.disabled || props.value == null)) {
      error('You provided a `value` prop to a form field without an ' + '`onChange` handler. This will render a read-only field. If ' + 'the field should be mutable use `defaultValue`. Otherwise, ' + 'set either `onChange` or `readOnly`.');
    }

    if (!(props.onChange || props.readOnly || props.disabled || props.checked == null)) {
      error('You provided a `checked` prop to a form field without an ' + '`onChange` handler. This will render a read-only field. If ' + 'the field should be mutable use `defaultChecked`. Otherwise, ' + 'set either `onChange` or `readOnly`.');
    }
  }
}

function isCheckable(elem) {
  var type = elem.type;
  var nodeName = elem.nodeName;
  return nodeName && nodeName.toLowerCase() === 'input' && (type === 'checkbox' || type === 'radio');
}

function getTracker(node) {
  return node._valueTracker;
}

function detachTracker(node) {
  node._valueTracker = null;
}

function getValueFromNode(node) {
  var value = '';

  if (!node) {
    return value;
  }

  if (isCheckable(node)) {
    value = node.checked ? 'true' : 'false';
  } else {
    value = node.value;
  }

  return value;
}

function trackValueOnNode(node) {
  var valueField = isCheckable(node) ? 'checked' : 'value';
  var descriptor = Object.getOwnPropertyDescriptor(node.constructor.prototype, valueField);
  var currentValue = '' + node[valueField]; // if someone has already defined a value or Safari, then bail
  // and don't track value will cause over reporting of changes,
  // but it's better then a hard failure
  // (needed for certain tests that spyOn input values and Safari)

  if (node.hasOwnProperty(valueField) || typeof descriptor === 'undefined' || typeof descriptor.get !== 'function' || typeof descriptor.set !== 'function') {
    return;
  }

  var get = descriptor.get,
      set = descriptor.set;
  Object.defineProperty(node, valueField, {
    configurable: true,
    get: function () {
      return get.call(this);
    },
    set: function (value) {
      currentValue = '' + value;
      set.call(this, value);
    }
  }); // We could've passed this the first time
  // but it triggers a bug in IE11 and Edge 14/15.
  // Calling defineProperty() again should be equivalent.
  // https://github.com/facebook/react/issues/11768

  Object.defineProperty(node, valueField, {
    enumerable: descriptor.enumerable
  });
  var tracker = {
    getValue: function () {
      return currentValue;
    },
    setValue: function (value) {
      currentValue = '' + value;
    },
    stopTracking: function () {
      detachTracker(node);
      delete node[valueField];
    }
  };
  return tracker;
}

function track(node) {
  if (getTracker(node)) {
    return;
  } // TODO: Once it's just Fiber we can move this to node._wrapperState


  node._valueTracker = trackValueOnNode(node);
}
function updateValueIfChanged(node) {
  if (!node) {
    return false;
  }

  var tracker = getTracker(node); // if there is no tracker at this point it's unlikely
  // that trying again will succeed

  if (!tracker) {
    return true;
  }

  var lastValue = tracker.getValue();
  var nextValue = getValueFromNode(node);

  if (nextValue !== lastValue) {
    tracker.setValue(nextValue);
    return true;
  }

  return false;
}

function getActiveElement(doc) {
  doc = doc || (typeof document !== 'undefined' ? document : undefined);

  if (typeof doc === 'undefined') {
    return null;
  }

  try {
    return doc.activeElement || doc.body;
  } catch (e) {
    return doc.body;
  }
}

var didWarnValueDefaultValue = false;
var didWarnCheckedDefaultChecked = false;
var didWarnControlledToUncontrolled = false;
var didWarnUncontrolledToControlled = false;

function isControlled(props) {
  var usesChecked = props.type === 'checkbox' || props.type === 'radio';
  return usesChecked ? props.checked != null : props.value != null;
}
/**
 * Implements an <input> host component that allows setting these optional
 * props: `checked`, `value`, `defaultChecked`, and `defaultValue`.
 *
 * If `checked` or `value` are not supplied (or null/undefined), user actions
 * that affect the checked state or value will trigger updates to the element.
 *
 * If they are supplied (and not null/undefined), the rendered element will not
 * trigger updates to the element. Instead, the props must change in order for
 * the rendered element to be updated.
 *
 * The rendered element will be initialized as unchecked (or `defaultChecked`)
 * with an empty value (or `defaultValue`).
 *
 * See http://www.w3.org/TR/2012/WD-html5-20121025/the-input-element.html
 */


function getHostProps(element, props) {
  var node = element;
  var checked = props.checked;

  var hostProps = _assign({}, props, {
    defaultChecked: undefined,
    defaultValue: undefined,
    value: undefined,
    checked: checked != null ? checked : node._wrapperState.initialChecked
  });

  return hostProps;
}
function initWrapperState(element, props) {
  {
    checkControlledValueProps('input', props);

    if (props.checked !== undefined && props.defaultChecked !== undefined && !didWarnCheckedDefaultChecked) {
      error('%s contains an input of type %s with both checked and defaultChecked props. ' + 'Input elements must be either controlled or uncontrolled ' + '(specify either the checked prop, or the defaultChecked prop, but not ' + 'both). Decide between using a controlled or uncontrolled input ' + 'element and remove one of these props. More info: ' + 'https://reactjs.org/link/controlled-components', getCurrentFiberOwnerNameInDevOrNull() || 'A component', props.type);

      didWarnCheckedDefaultChecked = true;
    }

    if (props.value !== undefined && props.defaultValue !== undefined && !didWarnValueDefaultValue) {
      error('%s contains an input of type %s with both value and defaultValue props. ' + 'Input elements must be either controlled or uncontrolled ' + '(specify either the value prop, or the defaultValue prop, but not ' + 'both). Decide between using a controlled or uncontrolled input ' + 'element and remove one of these props. More info: ' + 'https://reactjs.org/link/controlled-components', getCurrentFiberOwnerNameInDevOrNull() || 'A component', props.type);

      didWarnValueDefaultValue = true;
    }
  }

  var node = element;
  var defaultValue = props.defaultValue == null ? '' : props.defaultValue;
  node._wrapperState = {
    initialChecked: props.checked != null ? props.checked : props.defaultChecked,
    initialValue: getToStringValue(props.value != null ? props.value : defaultValue),
    controlled: isControlled(props)
  };
}
function updateChecked(element, props) {
  var node = element;
  var checked = props.checked;

  if (checked != null) {
    setValueForProperty(node, 'checked', checked, false);
  }
}
function updateWrapper(element, props) {
  var node = element;

  {
    var controlled = isControlled(props);

    if (!node._wrapperState.controlled && controlled && !didWarnUncontrolledToControlled) {
      error('A component is changing an uncontrolled input to be controlled. ' + 'This is likely caused by the value changing from undefined to ' + 'a defined value, which should not happen. ' + 'Decide between using a controlled or uncontrolled input ' + 'element for the lifetime of the component. More info: https://reactjs.org/link/controlled-components');

      didWarnUncontrolledToControlled = true;
    }

    if (node._wrapperState.controlled && !controlled && !didWarnControlledToUncontrolled) {
      error('A component is changing a controlled input to be uncontrolled. ' + 'This is likely caused by the value changing from a defined to ' + 'undefined, which should not happen. ' + 'Decide between using a controlled or uncontrolled input ' + 'element for the lifetime of the component. More info: https://reactjs.org/link/controlled-components');

      didWarnControlledToUncontrolled = true;
    }
  }

  updateChecked(element, props);
  var value = getToStringValue(props.value);
  var type = props.type;

  if (value != null) {
    if (type === 'number') {
      if (value === 0 && node.value === '' || // We explicitly want to coerce to number here if possible.
      // eslint-disable-next-line
      node.value != value) {
        node.value = toString(value);
      }
    } else if (node.value !== toString(value)) {
      node.value = toString(value);
    }
  } else if (type === 'submit' || type === 'reset') {
    // Submit/reset inputs need the attribute removed completely to avoid
    // blank-text buttons.
    node.removeAttribute('value');
    return;
  }

  {
    // When syncing the value attribute, the value comes from a cascade of
    // properties:
    //  1. The value React property
    //  2. The defaultValue React property
    //  3. Otherwise there should be no change
    if (props.hasOwnProperty('value')) {
      setDefaultValue(node, props.type, value);
    } else if (props.hasOwnProperty('defaultValue')) {
      setDefaultValue(node, props.type, getToStringValue(props.defaultValue));
    }
  }

  {
    // When syncing the checked attribute, it only changes when it needs
    // to be removed, such as transitioning from a checkbox into a text input
    if (props.checked == null && props.defaultChecked != null) {
      node.defaultChecked = !!props.defaultChecked;
    }
  }
}
function postMountWrapper(element, props, isHydrating) {
  var node = element; // Do not assign value if it is already set. This prevents user text input
  // from being lost during SSR hydration.

  if (props.hasOwnProperty('value') || props.hasOwnProperty('defaultValue')) {
    var type = props.type;
    var isButton = type === 'submit' || type === 'reset'; // Avoid setting value attribute on submit/reset inputs as it overrides the
    // default value provided by the browser. See: #12872

    if (isButton && (props.value === undefined || props.value === null)) {
      return;
    }

    var initialValue = toString(node._wrapperState.initialValue); // Do not assign value if it is already set. This prevents user text input
    // from being lost during SSR hydration.

    if (!isHydrating) {
      {
        // When syncing the value attribute, the value property should use
        // the wrapperState._initialValue property. This uses:
        //
        //   1. The value React property when present
        //   2. The defaultValue React property when present
        //   3. An empty string
        if (initialValue !== node.value) {
          node.value = initialValue;
        }
      }
    }

    {
      // Otherwise, the value attribute is synchronized to the property,
      // so we assign defaultValue to the same thing as the value property
      // assignment step above.
      node.defaultValue = initialValue;
    }
  } // Normally, we'd just do `node.checked = node.checked` upon initial mount, less this bug
  // this is needed to work around a chrome bug where setting defaultChecked
  // will sometimes influence the value of checked (even after detachment).
  // Reference: https://bugs.chromium.org/p/chromium/issues/detail?id=608416
  // We need to temporarily unset name to avoid disrupting radio button groups.


  var name = node.name;

  if (name !== '') {
    node.name = '';
  }

  {
    // When syncing the checked attribute, both the checked property and
    // attribute are assigned at the same time using defaultChecked. This uses:
    //
    //   1. The checked React property when present
    //   2. The defaultChecked React property when present
    //   3. Otherwise, false
    node.defaultChecked = !node.defaultChecked;
    node.defaultChecked = !!node._wrapperState.initialChecked;
  }

  if (name !== '') {
    node.name = name;
  }
}
function restoreControlledState(element, props) {
  var node = element;
  updateWrapper(node, props);
  updateNamedCousins(node, props);
}

function updateNamedCousins(rootNode, props) {
  var name = props.name;

  if (props.type === 'radio' && name != null) {
    var queryRoot = rootNode;

    while (queryRoot.parentNode) {
      queryRoot = queryRoot.parentNode;
    } // If `rootNode.form` was non-null, then we could try `form.elements`,
    // but that sometimes behaves strangely in IE8. We could also try using
    // `form.getElementsByName`, but that will only return direct children
    // and won't include inputs that use the HTML5 `form=` attribute. Since
    // the input might not even be in a form. It might not even be in the
    // document. Let's just use the local `querySelectorAll` to ensure we don't
    // miss anything.


    var group = queryRoot.querySelectorAll('input[name=' + JSON.stringify('' + name) + '][type="radio"]');

    for (var i = 0; i < group.length; i++) {
      var otherNode = group[i];

      if (otherNode === rootNode || otherNode.form !== rootNode.form) {
        continue;
      } // This will throw if radio buttons rendered by different copies of React
      // and the same name are rendered into the same form (same as #1939).
      // That's probably okay; we don't support it just as we don't support
      // mixing React radio buttons with non-React ones.


      var otherProps = getFiberCurrentPropsFromNode(otherNode);

      if (!otherProps) {
        {
          throw Error( "ReactDOMInput: Mixing React and non-React radio inputs with the same `name` is not supported." );
        }
      } // We need update the tracked value on the named cousin since the value
      // was changed but the input saw no event or value set


      updateValueIfChanged(otherNode); // If this is a controlled radio button group, forcing the input that
      // was previously checked to update will cause it to be come re-checked
      // as appropriate.

      updateWrapper(otherNode, otherProps);
    }
  }
} // In Chrome, assigning defaultValue to certain input types triggers input validation.
// For number inputs, the display value loses trailing decimal points. For email inputs,
// Chrome raises "The specified value <x> is not a valid email address".
//
// Here we check to see if the defaultValue has actually changed, avoiding these problems
// when the user is inputting text
//
// https://github.com/facebook/react/issues/7253


function setDefaultValue(node, type, value) {
  if ( // Focused number inputs synchronize on blur. See ChangeEventPlugin.js
  type !== 'number' || getActiveElement(node.ownerDocument) !== node) {
    if (value == null) {
      node.defaultValue = toString(node._wrapperState.initialValue);
    } else if (node.defaultValue !== toString(value)) {
      node.defaultValue = toString(value);
    }
  }
}

var didWarnSelectedSetOnOption = false;
var didWarnInvalidChild = false;

function flattenChildren(children) {
  var content = ''; // Flatten children. We'll warn if they are invalid
  // during validateProps() which runs for hydration too.
  // Note that this would throw on non-element objects.
  // Elements are stringified (which is normally irrelevant
  // but matters for <fbt>).

  React.Children.forEach(children, function (child) {
    if (child == null) {
      return;
    }

    content += child; // Note: we don't warn about invalid children here.
    // Instead, this is done separately below so that
    // it happens during the hydration code path too.
  });
  return content;
}
/**
 * Implements an <option> host component that warns when `selected` is set.
 */


function validateProps(element, props) {
  {
    // This mirrors the code path above, but runs for hydration too.
    // Warn about invalid children here so that client and hydration are consistent.
    // TODO: this seems like it could cause a DEV-only throw for hydration
    // if children contains a non-element object. We should try to avoid that.
    if (typeof props.children === 'object' && props.children !== null) {
      React.Children.forEach(props.children, function (child) {
        if (child == null) {
          return;
        }

        if (typeof child === 'string' || typeof child === 'number') {
          return;
        }

        if (typeof child.type !== 'string') {
          return;
        }

        if (!didWarnInvalidChild) {
          didWarnInvalidChild = true;

          error('Only strings and numbers are supported as <option> children.');
        }
      });
    } // TODO: Remove support for `selected` in <option>.


    if (props.selected != null && !didWarnSelectedSetOnOption) {
      error('Use the `defaultValue` or `value` props on <select> instead of ' + 'setting `selected` on <option>.');

      didWarnSelectedSetOnOption = true;
    }
  }
}
function postMountWrapper$1(element, props) {
  // value="" should make a value attribute (#6219)
  if (props.value != null) {
    element.setAttribute('value', toString(getToStringValue(props.value)));
  }
}
function getHostProps$1(element, props) {
  var hostProps = _assign({
    children: undefined
  }, props);

  var content = flattenChildren(props.children);

  if (content) {
    hostProps.children = content;
  }

  return hostProps;
}

var didWarnValueDefaultValue$1;

{
  didWarnValueDefaultValue$1 = false;
}

function getDeclarationErrorAddendum() {
  var ownerName = getCurrentFiberOwnerNameInDevOrNull();

  if (ownerName) {
    return '\n\nCheck the render method of `' + ownerName + '`.';
  }

  return '';
}

var valuePropNames = ['value', 'defaultValue'];
/**
 * Validation function for `value` and `defaultValue`.
 */

function checkSelectPropTypes(props) {
  {
    checkControlledValueProps('select', props);

    for (var i = 0; i < valuePropNames.length; i++) {
      var propName = valuePropNames[i];

      if (props[propName] == null) {
        continue;
      }

      var isArray = Array.isArray(props[propName]);

      if (props.multiple && !isArray) {
        error('The `%s` prop supplied to <select> must be an array if ' + '`multiple` is true.%s', propName, getDeclarationErrorAddendum());
      } else if (!props.multiple && isArray) {
        error('The `%s` prop supplied to <select> must be a scalar ' + 'value if `multiple` is false.%s', propName, getDeclarationErrorAddendum());
      }
    }
  }
}

function updateOptions(node, multiple, propValue, setDefaultSelected) {
  var options = node.options;

  if (multiple) {
    var selectedValues = propValue;
    var selectedValue = {};

    for (var i = 0; i < selectedValues.length; i++) {
      // Prefix to avoid chaos with special keys.
      selectedValue['$' + selectedValues[i]] = true;
    }

    for (var _i = 0; _i < options.length; _i++) {
      var selected = selectedValue.hasOwnProperty('$' + options[_i].value);

      if (options[_i].selected !== selected) {
        options[_i].selected = selected;
      }

      if (selected && setDefaultSelected) {
        options[_i].defaultSelected = true;
      }
    }
  } else {
    // Do not set `select.value` as exact behavior isn't consistent across all
    // browsers for all cases.
    var _selectedValue = toString(getToStringValue(propValue));

    var defaultSelected = null;

    for (var _i2 = 0; _i2 < options.length; _i2++) {
      if (options[_i2].value === _selectedValue) {
        options[_i2].selected = true;

        if (setDefaultSelected) {
          options[_i2].defaultSelected = true;
        }

        return;
      }

      if (defaultSelected === null && !options[_i2].disabled) {
        defaultSelected = options[_i2];
      }
    }

    if (defaultSelected !== null) {
      defaultSelected.selected = true;
    }
  }
}
/**
 * Implements a <select> host component that allows optionally setting the
 * props `value` and `defaultValue`. If `multiple` is false, the prop must be a
 * stringable. If `multiple` is true, the prop must be an array of stringables.
 *
 * If `value` is not supplied (or null/undefined), user actions that change the
 * selected option will trigger updates to the rendered options.
 *
 * If it is supplied (and not null/undefined), the rendered options will not
 * update in response to user actions. Instead, the `value` prop must change in
 * order for the rendered options to update.
 *
 * If `defaultValue` is provided, any options with the supplied values will be
 * selected.
 */


function getHostProps$2(element, props) {
  return _assign({}, props, {
    value: undefined
  });
}
function initWrapperState$1(element, props) {
  var node = element;

  {
    checkSelectPropTypes(props);
  }

  node._wrapperState = {
    wasMultiple: !!props.multiple
  };

  {
    if (props.value !== undefined && props.defaultValue !== undefined && !didWarnValueDefaultValue$1) {
      error('Select elements must be either controlled or uncontrolled ' + '(specify either the value prop, or the defaultValue prop, but not ' + 'both). Decide between using a controlled or uncontrolled select ' + 'element and remove one of these props. More info: ' + 'https://reactjs.org/link/controlled-components');

      didWarnValueDefaultValue$1 = true;
    }
  }
}
function postMountWrapper$2(element, props) {
  var node = element;
  node.multiple = !!props.multiple;
  var value = props.value;

  if (value != null) {
    updateOptions(node, !!props.multiple, value, false);
  } else if (props.defaultValue != null) {
    updateOptions(node, !!props.multiple, props.defaultValue, true);
  }
}
function postUpdateWrapper(element, props) {
  var node = element;
  var wasMultiple = node._wrapperState.wasMultiple;
  node._wrapperState.wasMultiple = !!props.multiple;
  var value = props.value;

  if (value != null) {
    updateOptions(node, !!props.multiple, value, false);
  } else if (wasMultiple !== !!props.multiple) {
    // For simplicity, reapply `defaultValue` if `multiple` is toggled.
    if (props.defaultValue != null) {
      updateOptions(node, !!props.multiple, props.defaultValue, true);
    } else {
      // Revert the select back to its default unselected state.
      updateOptions(node, !!props.multiple, props.multiple ? [] : '', false);
    }
  }
}
function restoreControlledState$1(element, props) {
  var node = element;
  var value = props.value;

  if (value != null) {
    updateOptions(node, !!props.multiple, value, false);
  }
}

var didWarnValDefaultVal = false;

/**
 * Implements a <textarea> host component that allows setting `value`, and
 * `defaultValue`. This differs from the traditional DOM API because value is
 * usually set as PCDATA children.
 *
 * If `value` is not supplied (or null/undefined), user actions that affect the
 * value will trigger updates to the element.
 *
 * If `value` is supplied (and not null/undefined), the rendered element will
 * not trigger updates to the element. Instead, the `value` prop must change in
 * order for the rendered element to be updated.
 *
 * The rendered element will be initialized with an empty value, the prop
 * `defaultValue` if specified, or the children content (deprecated).
 */
function getHostProps$3(element, props) {
  var node = element;

  if (!(props.dangerouslySetInnerHTML == null)) {
    {
      throw Error( "`dangerouslySetInnerHTML` does not make sense on <textarea>." );
    }
  } // Always set children to the same thing. In IE9, the selection range will
  // get reset if `textContent` is mutated.  We could add a check in setTextContent
  // to only set the value if/when the value differs from the node value (which would
  // completely solve this IE9 bug), but Sebastian+Sophie seemed to like this
  // solution. The value can be a boolean or object so that's why it's forced
  // to be a string.


  var hostProps = _assign({}, props, {
    value: undefined,
    defaultValue: undefined,
    children: toString(node._wrapperState.initialValue)
  });

  return hostProps;
}
function initWrapperState$2(element, props) {
  var node = element;

  {
    checkControlledValueProps('textarea', props);

    if (props.value !== undefined && props.defaultValue !== undefined && !didWarnValDefaultVal) {
      error('%s contains a textarea with both value and defaultValue props. ' + 'Textarea elements must be either controlled or uncontrolled ' + '(specify either the value prop, or the defaultValue prop, but not ' + 'both). Decide between using a controlled or uncontrolled textarea ' + 'and remove one of these props. More info: ' + 'https://reactjs.org/link/controlled-components', getCurrentFiberOwnerNameInDevOrNull() || 'A component');

      didWarnValDefaultVal = true;
    }
  }

  var initialValue = props.value; // Only bother fetching default value if we're going to use it

  if (initialValue == null) {
    var children = props.children,
        defaultValue = props.defaultValue;

    if (children != null) {
      {
        error('Use the `defaultValue` or `value` props instead of setting ' + 'children on <textarea>.');
      }

      {
        if (!(defaultValue == null)) {
          {
            throw Error( "If you supply `defaultValue` on a <textarea>, do not pass children." );
          }
        }

        if (Array.isArray(children)) {
          if (!(children.length <= 1)) {
            {
              throw Error( "<textarea> can only have at most one child." );
            }
          }

          children = children[0];
        }

        defaultValue = children;
      }
    }

    if (defaultValue == null) {
      defaultValue = '';
    }

    initialValue = defaultValue;
  }

  node._wrapperState = {
    initialValue: getToStringValue(initialValue)
  };
}
function updateWrapper$1(element, props) {
  var node = element;
  var value = getToStringValue(props.value);
  var defaultValue = getToStringValue(props.defaultValue);

  if (value != null) {
    // Cast `value` to a string to ensure the value is set correctly. While
    // browsers typically do this as necessary, jsdom doesn't.
    var newValue = toString(value); // To avoid side effects (such as losing text selection), only set value if changed

    if (newValue !== node.value) {
      node.value = newValue;
    }

    if (props.defaultValue == null && node.defaultValue !== newValue) {
      node.defaultValue = newValue;
    }
  }

  if (defaultValue != null) {
    node.defaultValue = toString(defaultValue);
  }
}
function postMountWrapper$3(element, props) {
  var node = element; // This is in postMount because we need access to the DOM node, which is not
  // available until after the component has mounted.

  var textContent = node.textContent; // Only set node.value if textContent is equal to the expected
  // initial value. In IE10/IE11 there is a bug where the placeholder attribute
  // will populate textContent as well.
  // https://developer.microsoft.com/microsoft-edge/platform/issues/101525/

  if (textContent === node._wrapperState.initialValue) {
    if (textContent !== '' && textContent !== null) {
      node.value = textContent;
    }
  }
}
function restoreControlledState$2(element, props) {
  // DOM component is still mounted; update
  updateWrapper$1(element, props);
}

var HTML_NAMESPACE = 'http://www.w3.org/1999/xhtml';
var MATH_NAMESPACE = 'http://www.w3.org/1998/Math/MathML';
var SVG_NAMESPACE = 'http://www.w3.org/2000/svg';
var Namespaces = {
  html: HTML_NAMESPACE,
  mathml: MATH_NAMESPACE,
  svg: SVG_NAMESPACE
}; // Assumes there is no parent namespace.

function getIntrinsicNamespace(type) {
  switch (type) {
    case 'svg':
      return SVG_NAMESPACE;

    case 'math':
      return MATH_NAMESPACE;

    default:
      return HTML_NAMESPACE;
  }
}
function getChildNamespace(parentNamespace, type) {
  if (parentNamespace == null || parentNamespace === HTML_NAMESPACE) {
    // No (or default) parent namespace: potential entry point.
    return getIntrinsicNamespace(type);
  }

  if (parentNamespace === SVG_NAMESPACE && type === 'foreignObject') {
    // We're leaving SVG.
    return HTML_NAMESPACE;
  } // By default, pass namespace below.


  return parentNamespace;
}

/* globals MSApp */

/**
 * Create a function which has 'unsafe' privileges (required by windows8 apps)
 */
var createMicrosoftUnsafeLocalFunction = function (func) {
  if (typeof MSApp !== 'undefined' && MSApp.execUnsafeLocalFunction) {
    return function (arg0, arg1, arg2, arg3) {
      MSApp.execUnsafeLocalFunction(function () {
        return func(arg0, arg1, arg2, arg3);
      });
    };
  } else {
    return func;
  }
};

var reusableSVGContainer;
/**
 * Set the innerHTML property of a node
 *
 * @param {DOMElement} node
 * @param {string} html
 * @internal
 */

var setInnerHTML = createMicrosoftUnsafeLocalFunction(function (node, html) {
  if (node.namespaceURI === Namespaces.svg) {

    if (!('innerHTML' in node)) {
      // IE does not have innerHTML for SVG nodes, so instead we inject the
      // new markup in a temp node and then move the child nodes across into
      // the target node
      reusableSVGContainer = reusableSVGContainer || document.createElement('div');
      reusableSVGContainer.innerHTML = '<svg>' + html.valueOf().toString() + '</svg>';
      var svgNode = reusableSVGContainer.firstChild;

      while (node.firstChild) {
        node.removeChild(node.firstChild);
      }

      while (svgNode.firstChild) {
        node.appendChild(svgNode.firstChild);
      }

      return;
    }
  }

  node.innerHTML = html;
});

/**
 * HTML nodeType values that represent the type of the node
 */
var ELEMENT_NODE = 1;
var TEXT_NODE = 3;
var COMMENT_NODE = 8;
var DOCUMENT_NODE = 9;
var DOCUMENT_FRAGMENT_NODE = 11;

/**
 * Set the textContent property of a node. For text updates, it's faster
 * to set the `nodeValue` of the Text node directly instead of using
 * `.textContent` which will remove the existing node and create a new one.
 *
 * @param {DOMElement} node
 * @param {string} text
 * @internal
 */

var setTextContent = function (node, text) {
  if (text) {
    var firstChild = node.firstChild;

    if (firstChild && firstChild === node.lastChild && firstChild.nodeType === TEXT_NODE) {
      firstChild.nodeValue = text;
      return;
    }
  }

  node.textContent = text;
};

// List derived from Gecko source code:
// https://github.com/mozilla/gecko-dev/blob/4e638efc71/layout/style/test/property_database.js
var shorthandToLonghand = {
  animation: ['animationDelay', 'animationDirection', 'animationDuration', 'animationFillMode', 'animationIterationCount', 'animationName', 'animationPlayState', 'animationTimingFunction'],
  background: ['backgroundAttachment', 'backgroundClip', 'backgroundColor', 'backgroundImage', 'backgroundOrigin', 'backgroundPositionX', 'backgroundPositionY', 'backgroundRepeat', 'backgroundSize'],
  backgroundPosition: ['backgroundPositionX', 'backgroundPositionY'],
  border: ['borderBottomColor', 'borderBottomStyle', 'borderBottomWidth', 'borderImageOutset', 'borderImageRepeat', 'borderImageSlice', 'borderImageSource', 'borderImageWidth', 'borderLeftColor', 'borderLeftStyle', 'borderLeftWidth', 'borderRightColor', 'borderRightStyle', 'borderRightWidth', 'borderTopColor', 'borderTopStyle', 'borderTopWidth'],
  borderBlockEnd: ['borderBlockEndColor', 'borderBlockEndStyle', 'borderBlockEndWidth'],
  borderBlockStart: ['borderBlockStartColor', 'borderBlockStartStyle', 'borderBlockStartWidth'],
  borderBottom: ['borderBottomColor', 'borderBottomStyle', 'borderBottomWidth'],
  borderColor: ['borderBottomColor', 'borderLeftColor', 'borderRightColor', 'borderTopColor'],
  borderImage: ['borderImageOutset', 'borderImageRepeat', 'borderImageSlice', 'borderImageSource', 'borderImageWidth'],
  borderInlineEnd: ['borderInlineEndColor', 'borderInlineEndStyle', 'borderInlineEndWidth'],
  borderInlineStart: ['borderInlineStartColor', 'borderInlineStartStyle', 'borderInlineStartWidth'],
  borderLeft: ['borderLeftColor', 'borderLeftStyle', 'borderLeftWidth'],
  borderRadius: ['borderBottomLeftRadius', 'borderBottomRightRadius', 'borderTopLeftRadius', 'borderTopRightRadius'],
  borderRight: ['borderRightColor', 'borderRightStyle', 'borderRightWidth'],
  borderStyle: ['borderBottomStyle', 'borderLeftStyle', 'borderRightStyle', 'borderTopStyle'],
  borderTop: ['borderTopColor', 'borderTopStyle', 'borderTopWidth'],
  borderWidth: ['borderBottomWidth', 'borderLeftWidth', 'borderRightWidth', 'borderTopWidth'],
  columnRule: ['columnRuleColor', 'columnRuleStyle', 'columnRuleWidth'],
  columns: ['columnCount', 'columnWidth'],
  flex: ['flexBasis', 'flexGrow', 'flexShrink'],
  flexFlow: ['flexDirection', 'flexWrap'],
  font: ['fontFamily', 'fontFeatureSettings', 'fontKerning', 'fontLanguageOverride', 'fontSize', 'fontSizeAdjust', 'fontStretch', 'fontStyle', 'fontVariant', 'fontVariantAlternates', 'fontVariantCaps', 'fontVariantEastAsian', 'fontVariantLigatures', 'fontVariantNumeric', 'fontVariantPosition', 'fontWeight', 'lineHeight'],
  fontVariant: ['fontVariantAlternates', 'fontVariantCaps', 'fontVariantEastAsian', 'fontVariantLigatures', 'fontVariantNumeric', 'fontVariantPosition'],
  gap: ['columnGap', 'rowGap'],
  grid: ['gridAutoColumns', 'gridAutoFlow', 'gridAutoRows', 'gridTemplateAreas', 'gridTemplateColumns', 'gridTemplateRows'],
  gridArea: ['gridColumnEnd', 'gridColumnStart', 'gridRowEnd', 'gridRowStart'],
  gridColumn: ['gridColumnEnd', 'gridColumnStart'],
  gridColumnGap: ['columnGap'],
  gridGap: ['columnGap', 'rowGap'],
  gridRow: ['gridRowEnd', 'gridRowStart'],
  gridRowGap: ['rowGap'],
  gridTemplate: ['gridTemplateAreas', 'gridTemplateColumns', 'gridTemplateRows'],
  listStyle: ['listStyleImage', 'listStylePosition', 'listStyleType'],
  margin: ['marginBottom', 'marginLeft', 'marginRight', 'marginTop'],
  marker: ['markerEnd', 'markerMid', 'markerStart'],
  mask: ['maskClip', 'maskComposite', 'maskImage', 'maskMode', 'maskOrigin', 'maskPositionX', 'maskPositionY', 'maskRepeat', 'maskSize'],
  maskPosition: ['maskPositionX', 'maskPositionY'],
  outline: ['outlineColor', 'outlineStyle', 'outlineWidth'],
  overflow: ['overflowX', 'overflowY'],
  padding: ['paddingBottom', 'paddingLeft', 'paddingRight', 'paddingTop'],
  placeContent: ['alignContent', 'justifyContent'],
  placeItems: ['alignItems', 'justifyItems'],
  placeSelf: ['alignSelf', 'justifySelf'],
  textDecoration: ['textDecorationColor', 'textDecorationLine', 'textDecorationStyle'],
  textEmphasis: ['textEmphasisColor', 'textEmphasisStyle'],
  transition: ['transitionDelay', 'transitionDuration', 'transitionProperty', 'transitionTimingFunction'],
  wordWrap: ['overflowWrap']
};

/**
 * CSS properties which accept numbers but are not in units of "px".
 */
var isUnitlessNumber = {
  animationIterationCount: true,
  borderImageOutset: true,
  borderImageSlice: true,
  borderImageWidth: true,
  boxFlex: true,
  boxFlexGroup: true,
  boxOrdinalGroup: true,
  columnCount: true,
  columns: true,
  flex: true,
  flexGrow: true,
  flexPositive: true,
  flexShrink: true,
  flexNegative: true,
  flexOrder: true,
  gridArea: true,
  gridRow: true,
  gridRowEnd: true,
  gridRowSpan: true,
  gridRowStart: true,
  gridColumn: true,
  gridColumnEnd: true,
  gridColumnSpan: true,
  gridColumnStart: true,
  fontWeight: true,
  lineClamp: true,
  lineHeight: true,
  opacity: true,
  order: true,
  orphans: true,
  tabSize: true,
  widows: true,
  zIndex: true,
  zoom: true,
  // SVG-related properties
  fillOpacity: true,
  floodOpacity: true,
  stopOpacity: true,
  strokeDasharray: true,
  strokeDashoffset: true,
  strokeMiterlimit: true,
  strokeOpacity: true,
  strokeWidth: true
};
/**
 * @param {string} prefix vendor-specific prefix, eg: Webkit
 * @param {string} key style name, eg: transitionDuration
 * @return {string} style name prefixed with `prefix`, properly camelCased, eg:
 * WebkitTransitionDuration
 */

function prefixKey(prefix, key) {
  return prefix + key.charAt(0).toUpperCase() + key.substring(1);
}
/**
 * Support style names that may come passed in prefixed by adding permutations
 * of vendor prefixes.
 */


var prefixes = ['Webkit', 'ms', 'Moz', 'O']; // Using Object.keys here, or else the vanilla for-in loop makes IE8 go into an
// infinite loop, because it iterates over the newly added props too.

Object.keys(isUnitlessNumber).forEach(function (prop) {
  prefixes.forEach(function (prefix) {
    isUnitlessNumber[prefixKey(prefix, prop)] = isUnitlessNumber[prop];
  });
});

/**
 * Convert a value into the proper css writable value. The style name `name`
 * should be logical (no hyphens), as specified
 * in `CSSProperty.isUnitlessNumber`.
 *
 * @param {string} name CSS property name such as `topMargin`.
 * @param {*} value CSS property value such as `10px`.
 * @return {string} Normalized style value with dimensions applied.
 */

function dangerousStyleValue(name, value, isCustomProperty) {
  // Note that we've removed escapeTextForBrowser() calls here since the
  // whole string will be escaped when the attribute is injected into
  // the markup. If you provide unsafe user data here they can inject
  // arbitrary CSS which may be problematic (I couldn't repro this):
  // https://www.owasp.org/index.php/XSS_Filter_Evasion_Cheat_Sheet
  // http://www.thespanner.co.uk/2007/11/26/ultimate-xss-css-injection/
  // This is not an XSS hole but instead a potential CSS injection issue
  // which has lead to a greater discussion about how we're going to
  // trust URLs moving forward. See #2115901
  var isEmpty = value == null || typeof value === 'boolean' || value === '';

  if (isEmpty) {
    return '';
  }

  if (!isCustomProperty && typeof value === 'number' && value !== 0 && !(isUnitlessNumber.hasOwnProperty(name) && isUnitlessNumber[name])) {
    return value + 'px'; // Presumes implicit 'px' suffix for unitless numbers
  }

  return ('' + value).trim();
}

var uppercasePattern = /([A-Z])/g;
var msPattern = /^ms-/;
/**
 * Hyphenates a camelcased CSS property name, for example:
 *
 *   > hyphenateStyleName('backgroundColor')
 *   < "background-color"
 *   > hyphenateStyleName('MozTransition')
 *   < "-moz-transition"
 *   > hyphenateStyleName('msTransition')
 *   < "-ms-transition"
 *
 * As Modernizr suggests (http://modernizr.com/docs/#prefixed), an `ms` prefix
 * is converted to `-ms-`.
 */

function hyphenateStyleName(name) {
  return name.replace(uppercasePattern, '-$1').toLowerCase().replace(msPattern, '-ms-');
}

var warnValidStyle = function () {};

{
  // 'msTransform' is correct, but the other prefixes should be capitalized
  var badVendoredStyleNamePattern = /^(?:webkit|moz|o)[A-Z]/;
  var msPattern$1 = /^-ms-/;
  var hyphenPattern = /-(.)/g; // style values shouldn't contain a semicolon

  var badStyleValueWithSemicolonPattern = /;\s*$/;
  var warnedStyleNames = {};
  var warnedStyleValues = {};
  var warnedForNaNValue = false;
  var warnedForInfinityValue = false;

  var camelize = function (string) {
    return string.replace(hyphenPattern, function (_, character) {
      return character.toUpperCase();
    });
  };

  var warnHyphenatedStyleName = function (name) {
    if (warnedStyleNames.hasOwnProperty(name) && warnedStyleNames[name]) {
      return;
    }

    warnedStyleNames[name] = true;

    error('Unsupported style property %s. Did you mean %s?', name, // As Andi Smith suggests
    // (http://www.andismith.com/blog/2012/02/modernizr-prefixed/), an `-ms` prefix
    // is converted to lowercase `ms`.
    camelize(name.replace(msPattern$1, 'ms-')));
  };

  var warnBadVendoredStyleName = function (name) {
    if (warnedStyleNames.hasOwnProperty(name) && warnedStyleNames[name]) {
      return;
    }

    warnedStyleNames[name] = true;

    error('Unsupported vendor-prefixed style property %s. Did you mean %s?', name, name.charAt(0).toUpperCase() + name.slice(1));
  };

  var warnStyleValueWithSemicolon = function (name, value) {
    if (warnedStyleValues.hasOwnProperty(value) && warnedStyleValues[value]) {
      return;
    }

    warnedStyleValues[value] = true;

    error("Style property values shouldn't contain a semicolon. " + 'Try "%s: %s" instead.', name, value.replace(badStyleValueWithSemicolonPattern, ''));
  };

  var warnStyleValueIsNaN = function (name, value) {
    if (warnedForNaNValue) {
      return;
    }

    warnedForNaNValue = true;

    error('`NaN` is an invalid value for the `%s` css style property.', name);
  };

  var warnStyleValueIsInfinity = function (name, value) {
    if (warnedForInfinityValue) {
      return;
    }

    warnedForInfinityValue = true;

    error('`Infinity` is an invalid value for the `%s` css style property.', name);
  };

  warnValidStyle = function (name, value) {
    if (name.indexOf('-') > -1) {
      warnHyphenatedStyleName(name);
    } else if (badVendoredStyleNamePattern.test(name)) {
      warnBadVendoredStyleName(name);
    } else if (badStyleValueWithSemicolonPattern.test(value)) {
      warnStyleValueWithSemicolon(name, value);
    }

    if (typeof value === 'number') {
      if (isNaN(value)) {
        warnStyleValueIsNaN(name, value);
      } else if (!isFinite(value)) {
        warnStyleValueIsInfinity(name, value);
      }
    }
  };
}

var warnValidStyle$1 = warnValidStyle;

/**
 * Operations for dealing with CSS properties.
 */

/**
 * This creates a string that is expected to be equivalent to the style
 * attribute generated by server-side rendering. It by-passes warnings and
 * security checks so it's not safe to use this value for anything other than
 * comparison. It is only used in DEV for SSR validation.
 */

function createDangerousStringForStyles(styles) {
  {
    var serialized = '';
    var delimiter = '';

    for (var styleName in styles) {
      if (!styles.hasOwnProperty(styleName)) {
        continue;
      }

      var styleValue = styles[styleName];

      if (styleValue != null) {
        var isCustomProperty = styleName.indexOf('--') === 0;
        serialized += delimiter + (isCustomProperty ? styleName : hyphenateStyleName(styleName)) + ':';
        serialized += dangerousStyleValue(styleName, styleValue, isCustomProperty);
        delimiter = ';';
      }
    }

    return serialized || null;
  }
}
/**
 * Sets the value for multiple styles on a node.  If a value is specified as
 * '' (empty string), the corresponding style property will be unset.
 *
 * @param {DOMElement} node
 * @param {object} styles
 */

function setValueForStyles(node, styles) {
  var style = node.style;

  for (var styleName in styles) {
    if (!styles.hasOwnProperty(styleName)) {
      continue;
    }

    var isCustomProperty = styleName.indexOf('--') === 0;

    {
      if (!isCustomProperty) {
        warnValidStyle$1(styleName, styles[styleName]);
      }
    }

    var styleValue = dangerousStyleValue(styleName, styles[styleName], isCustomProperty);

    if (styleName === 'float') {
      styleName = 'cssFloat';
    }

    if (isCustomProperty) {
      style.setProperty(styleName, styleValue);
    } else {
      style[styleName] = styleValue;
    }
  }
}

function isValueEmpty(value) {
  return value == null || typeof value === 'boolean' || value === '';
}
/**
 * Given {color: 'red', overflow: 'hidden'} returns {
 *   color: 'color',
 *   overflowX: 'overflow',
 *   overflowY: 'overflow',
 * }. This can be read as "the overflowY property was set by the overflow
 * shorthand". That is, the values are the property that each was derived from.
 */


function expandShorthandMap(styles) {
  var expanded = {};

  for (var key in styles) {
    var longhands = shorthandToLonghand[key] || [key];

    for (var i = 0; i < longhands.length; i++) {
      expanded[longhands[i]] = key;
    }
  }

  return expanded;
}
/**
 * When mixing shorthand and longhand property names, we warn during updates if
 * we expect an incorrect result to occur. In particular, we warn for:
 *
 * Updating a shorthand property (longhand gets overwritten):
 *   {font: 'foo', fontVariant: 'bar'} -> {font: 'baz', fontVariant: 'bar'}
 *   becomes .style.font = 'baz'
 * Removing a shorthand property (longhand gets lost too):
 *   {font: 'foo', fontVariant: 'bar'} -> {fontVariant: 'bar'}
 *   becomes .style.font = ''
 * Removing a longhand property (should revert to shorthand; doesn't):
 *   {font: 'foo', fontVariant: 'bar'} -> {font: 'foo'}
 *   becomes .style.fontVariant = ''
 */


function validateShorthandPropertyCollisionInDev(styleUpdates, nextStyles) {
  {
    if (!nextStyles) {
      return;
    }

    var expandedUpdates = expandShorthandMap(styleUpdates);
    var expandedStyles = expandShorthandMap(nextStyles);
    var warnedAbout = {};

    for (var key in expandedUpdates) {
      var originalKey = expandedUpdates[key];
      var correctOriginalKey = expandedStyles[key];

      if (correctOriginalKey && originalKey !== correctOriginalKey) {
        var warningKey = originalKey + ',' + correctOriginalKey;

        if (warnedAbout[warningKey]) {
          continue;
        }

        warnedAbout[warningKey] = true;

        error('%s a style property during rerender (%s) when a ' + 'conflicting property is set (%s) can lead to styling bugs. To ' + "avoid this, don't mix shorthand and non-shorthand properties " + 'for the same value; instead, replace the shorthand with ' + 'separate values.', isValueEmpty(styleUpdates[originalKey]) ? 'Removing' : 'Updating', originalKey, correctOriginalKey);
      }
    }
  }
}

// For HTML, certain tags should omit their close tag. We keep a list for
// those special-case tags.
var omittedCloseTags = {
  area: true,
  base: true,
  br: true,
  col: true,
  embed: true,
  hr: true,
  img: true,
  input: true,
  keygen: true,
  link: true,
  meta: true,
  param: true,
  source: true,
  track: true,
  wbr: true // NOTE: menuitem's close tag should be omitted, but that causes problems.

};

// `omittedCloseTags` except that `menuitem` should still have its closing tag.

var voidElementTags = _assign({
  menuitem: true
}, omittedCloseTags);

var HTML = '__html';

function assertValidProps(tag, props) {
  if (!props) {
    return;
  } // Note the use of `==` which checks for null or undefined.


  if (voidElementTags[tag]) {
    if (!(props.children == null && props.dangerouslySetInnerHTML == null)) {
      {
        throw Error( tag + " is a void element tag and must neither have `children` nor use `dangerouslySetInnerHTML`." );
      }
    }
  }

  if (props.dangerouslySetInnerHTML != null) {
    if (!(props.children == null)) {
      {
        throw Error( "Can only set one of `children` or `props.dangerouslySetInnerHTML`." );
      }
    }

    if (!(typeof props.dangerouslySetInnerHTML === 'object' && HTML in props.dangerouslySetInnerHTML)) {
      {
        throw Error( "`props.dangerouslySetInnerHTML` must be in the form `{__html: ...}`. Please visit https://reactjs.org/link/dangerously-set-inner-html for more information." );
      }
    }
  }

  {
    if (!props.suppressContentEditableWarning && props.contentEditable && props.children != null) {
      error('A component is `contentEditable` and contains `children` managed by ' + 'React. It is now your responsibility to guarantee that none of ' + 'those nodes are unexpectedly modified or duplicated. This is ' + 'probably not intentional.');
    }
  }

  if (!(props.style == null || typeof props.style === 'object')) {
    {
      throw Error( "The `style` prop expects a mapping from style properties to values, not a string. For example, style={{marginRight: spacing + 'em'}} when using JSX." );
    }
  }
}

function isCustomComponent(tagName, props) {
  if (tagName.indexOf('-') === -1) {
    return typeof props.is === 'string';
  }

  switch (tagName) {
    // These are reserved SVG and MathML elements.
    // We don't mind this list too much because we expect it to never grow.
    // The alternative is to track the namespace in a few places which is convoluted.
    // https://w3c.github.io/webcomponents/spec/custom/#custom-elements-core-concepts
    case 'annotation-xml':
    case 'color-profile':
    case 'font-face':
    case 'font-face-src':
    case 'font-face-uri':
    case 'font-face-format':
    case 'font-face-name':
    case 'missing-glyph':
      return false;

    default:
      return true;
  }
}

// When adding attributes to the HTML or SVG allowed attribute list, be sure to
// also add them to this module to ensure casing and incorrect name
// warnings.
var possibleStandardNames = {
  // HTML
  accept: 'accept',
  acceptcharset: 'acceptCharset',
  'accept-charset': 'acceptCharset',
  accesskey: 'accessKey',
  action: 'action',
  allowfullscreen: 'allowFullScreen',
  alt: 'alt',
  as: 'as',
  async: 'async',
  autocapitalize: 'autoCapitalize',
  autocomplete: 'autoComplete',
  autocorrect: 'autoCorrect',
  autofocus: 'autoFocus',
  autoplay: 'autoPlay',
  autosave: 'autoSave',
  capture: 'capture',
  cellpadding: 'cellPadding',
  cellspacing: 'cellSpacing',
  challenge: 'challenge',
  charset: 'charSet',
  checked: 'checked',
  children: 'children',
  cite: 'cite',
  class: 'className',
  classid: 'classID',
  classname: 'className',
  cols: 'cols',
  colspan: 'colSpan',
  content: 'content',
  contenteditable: 'contentEditable',
  contextmenu: 'contextMenu',
  controls: 'controls',
  controlslist: 'controlsList',
  coords: 'coords',
  crossorigin: 'crossOrigin',
  dangerouslysetinnerhtml: 'dangerouslySetInnerHTML',
  data: 'data',
  datetime: 'dateTime',
  default: 'default',
  defaultchecked: 'defaultChecked',
  defaultvalue: 'defaultValue',
  defer: 'defer',
  dir: 'dir',
  disabled: 'disabled',
  disablepictureinpicture: 'disablePictureInPicture',
  disableremoteplayback: 'disableRemotePlayback',
  download: 'download',
  draggable: 'draggable',
  enctype: 'encType',
  enterkeyhint: 'enterKeyHint',
  for: 'htmlFor',
  form: 'form',
  formmethod: 'formMethod',
  formaction: 'formAction',
  formenctype: 'formEncType',
  formnovalidate: 'formNoValidate',
  formtarget: 'formTarget',
  frameborder: 'frameBorder',
  headers: 'headers',
  height: 'height',
  hidden: 'hidden',
  high: 'high',
  href: 'href',
  hreflang: 'hrefLang',
  htmlfor: 'htmlFor',
  httpequiv: 'httpEquiv',
  'http-equiv': 'httpEquiv',
  icon: 'icon',
  id: 'id',
  innerhtml: 'innerHTML',
  inputmode: 'inputMode',
  integrity: 'integrity',
  is: 'is',
  itemid: 'itemID',
  itemprop: 'itemProp',
  itemref: 'itemRef',
  itemscope: 'itemScope',
  itemtype: 'itemType',
  keyparams: 'keyParams',
  keytype: 'keyType',
  kind: 'kind',
  label: 'label',
  lang: 'lang',
  list: 'list',
  loop: 'loop',
  low: 'low',
  manifest: 'manifest',
  marginwidth: 'marginWidth',
  marginheight: 'marginHeight',
  max: 'max',
  maxlength: 'maxLength',
  media: 'media',
  mediagroup: 'mediaGroup',
  method: 'method',
  min: 'min',
  minlength: 'minLength',
  multiple: 'multiple',
  muted: 'muted',
  name: 'name',
  nomodule: 'noModule',
  nonce: 'nonce',
  novalidate: 'noValidate',
  open: 'open',
  optimum: 'optimum',
  pattern: 'pattern',
  placeholder: 'placeholder',
  playsinline: 'playsInline',
  poster: 'poster',
  preload: 'preload',
  profile: 'profile',
  radiogroup: 'radioGroup',
  readonly: 'readOnly',
  referrerpolicy: 'referrerPolicy',
  rel: 'rel',
  required: 'required',
  reversed: 'reversed',
  role: 'role',
  rows: 'rows',
  rowspan: 'rowSpan',
  sandbox: 'sandbox',
  scope: 'scope',
  scoped: 'scoped',
  scrolling: 'scrolling',
  seamless: 'seamless',
  selected: 'selected',
  shape: 'shape',
  size: 'size',
  sizes: 'sizes',
  span: 'span',
  spellcheck: 'spellCheck',
  src: 'src',
  srcdoc: 'srcDoc',
  srclang: 'srcLang',
  srcset: 'srcSet',
  start: 'start',
  step: 'step',
  style: 'style',
  summary: 'summary',
  tabindex: 'tabIndex',
  target: 'target',
  title: 'title',
  type: 'type',
  usemap: 'useMap',
  value: 'value',
  width: 'width',
  wmode: 'wmode',
  wrap: 'wrap',
  // SVG
  about: 'about',
  accentheight: 'accentHeight',
  'accent-height': 'accentHeight',
  accumulate: 'accumulate',
  additive: 'additive',
  alignmentbaseline: 'alignmentBaseline',
  'alignment-baseline': 'alignmentBaseline',
  allowreorder: 'allowReorder',
  alphabetic: 'alphabetic',
  amplitude: 'amplitude',
  arabicform: 'arabicForm',
  'arabic-form': 'arabicForm',
  ascent: 'ascent',
  attributename: 'attributeName',
  attributetype: 'attributeType',
  autoreverse: 'autoReverse',
  azimuth: 'azimuth',
  basefrequency: 'baseFrequency',
  baselineshift: 'baselineShift',
  'baseline-shift': 'baselineShift',
  baseprofile: 'baseProfile',
  bbox: 'bbox',
  begin: 'begin',
  bias: 'bias',
  by: 'by',
  calcmode: 'calcMode',
  capheight: 'capHeight',
  'cap-height': 'capHeight',
  clip: 'clip',
  clippath: 'clipPath',
  'clip-path': 'clipPath',
  clippathunits: 'clipPathUnits',
  cliprule: 'clipRule',
  'clip-rule': 'clipRule',
  color: 'color',
  colorinterpolation: 'colorInterpolation',
  'color-interpolation': 'colorInterpolation',
  colorinterpolationfilters: 'colorInterpolationFilters',
  'color-interpolation-filters': 'colorInterpolationFilters',
  colorprofile: 'colorProfile',
  'color-profile': 'colorProfile',
  colorrendering: 'colorRendering',
  'color-rendering': 'colorRendering',
  contentscripttype: 'contentScriptType',
  contentstyletype: 'contentStyleType',
  cursor: 'cursor',
  cx: 'cx',
  cy: 'cy',
  d: 'd',
  datatype: 'datatype',
  decelerate: 'decelerate',
  descent: 'descent',
  diffuseconstant: 'diffuseConstant',
  direction: 'direction',
  display: 'display',
  divisor: 'divisor',
  dominantbaseline: 'dominantBaseline',
  'dominant-baseline': 'dominantBaseline',
  dur: 'dur',
  dx: 'dx',
  dy: 'dy',
  edgemode: 'edgeMode',
  elevation: 'elevation',
  enablebackground: 'enableBackground',
  'enable-background': 'enableBackground',
  end: 'end',
  exponent: 'exponent',
  externalresourcesrequired: 'externalResourcesRequired',
  fill: 'fill',
  fillopacity: 'fillOpacity',
  'fill-opacity': 'fillOpacity',
  fillrule: 'fillRule',
  'fill-rule': 'fillRule',
  filter: 'filter',
  filterres: 'filterRes',
  filterunits: 'filterUnits',
  floodopacity: 'floodOpacity',
  'flood-opacity': 'floodOpacity',
  floodcolor: 'floodColor',
  'flood-color': 'floodColor',
  focusable: 'focusable',
  fontfamily: 'fontFamily',
  'font-family': 'fontFamily',
  fontsize: 'fontSize',
  'font-size': 'fontSize',
  fontsizeadjust: 'fontSizeAdjust',
  'font-size-adjust': 'fontSizeAdjust',
  fontstretch: 'fontStretch',
  'font-stretch': 'fontStretch',
  fontstyle: 'fontStyle',
  'font-style': 'fontStyle',
  fontvariant: 'fontVariant',
  'font-variant': 'fontVariant',
  fontweight: 'fontWeight',
  'font-weight': 'fontWeight',
  format: 'format',
  from: 'from',
  fx: 'fx',
  fy: 'fy',
  g1: 'g1',
  g2: 'g2',
  glyphname: 'glyphName',
  'glyph-name': 'glyphName',
  glyphorientationhorizontal: 'glyphOrientationHorizontal',
  'glyph-orientation-horizontal': 'glyphOrientationHorizontal',
  glyphorientationvertical: 'glyphOrientationVertical',
  'glyph-orientation-vertical': 'glyphOrientationVertical',
  glyphref: 'glyphRef',
  gradienttransform: 'gradientTransform',
  gradientunits: 'gradientUnits',
  hanging: 'hanging',
  horizadvx: 'horizAdvX',
  'horiz-adv-x': 'horizAdvX',
  horizoriginx: 'horizOriginX',
  'horiz-origin-x': 'horizOriginX',
  ideographic: 'ideographic',
  imagerendering: 'imageRendering',
  'image-rendering': 'imageRendering',
  in2: 'in2',
  in: 'in',
  inlist: 'inlist',
  intercept: 'intercept',
  k1: 'k1',
  k2: 'k2',
  k3: 'k3',
  k4: 'k4',
  k: 'k',
  kernelmatrix: 'kernelMatrix',
  kernelunitlength: 'kernelUnitLength',
  kerning: 'kerning',
  keypoints: 'keyPoints',
  keysplines: 'keySplines',
  keytimes: 'keyTimes',
  lengthadjust: 'lengthAdjust',
  letterspacing: 'letterSpacing',
  'letter-spacing': 'letterSpacing',
  lightingcolor: 'lightingColor',
  'lighting-color': 'lightingColor',
  limitingconeangle: 'limitingConeAngle',
  local: 'local',
  markerend: 'markerEnd',
  'marker-end': 'markerEnd',
  markerheight: 'markerHeight',
  markermid: 'markerMid',
  'marker-mid': 'markerMid',
  markerstart: 'markerStart',
  'marker-start': 'markerStart',
  markerunits: 'markerUnits',
  markerwidth: 'markerWidth',
  mask: 'mask',
  maskcontentunits: 'maskContentUnits',
  maskunits: 'maskUnits',
  mathematical: 'mathematical',
  mode: 'mode',
  numoctaves: 'numOctaves',
  offset: 'offset',
  opacity: 'opacity',
  operator: 'operator',
  order: 'order',
  orient: 'orient',
  orientation: 'orientation',
  origin: 'origin',
  overflow: 'overflow',
  overlineposition: 'overlinePosition',
  'overline-position': 'overlinePosition',
  overlinethickness: 'overlineThickness',
  'overline-thickness': 'overlineThickness',
  paintorder: 'paintOrder',
  'paint-order': 'paintOrder',
  panose1: 'panose1',
  'panose-1': 'panose1',
  pathlength: 'pathLength',
  patterncontentunits: 'patternContentUnits',
  patterntransform: 'patternTransform',
  patternunits: 'patternUnits',
  pointerevents: 'pointerEvents',
  'pointer-events': 'pointerEvents',
  points: 'points',
  pointsatx: 'pointsAtX',
  pointsaty: 'pointsAtY',
  pointsatz: 'pointsAtZ',
  prefix: 'prefix',
  preservealpha: 'preserveAlpha',
  preserveaspectratio: 'preserveAspectRatio',
  primitiveunits: 'primitiveUnits',
  property: 'property',
  r: 'r',
  radius: 'radius',
  refx: 'refX',
  refy: 'refY',
  renderingintent: 'renderingIntent',
  'rendering-intent': 'renderingIntent',
  repeatcount: 'repeatCount',
  repeatdur: 'repeatDur',
  requiredextensions: 'requiredExtensions',
  requiredfeatures: 'requiredFeatures',
  resource: 'resource',
  restart: 'restart',
  result: 'result',
  results: 'results',
  rotate: 'rotate',
  rx: 'rx',
  ry: 'ry',
  scale: 'scale',
  security: 'security',
  seed: 'seed',
  shaperendering: 'shapeRendering',
  'shape-rendering': 'shapeRendering',
  slope: 'slope',
  spacing: 'spacing',
  specularconstant: 'specularConstant',
  specularexponent: 'specularExponent',
  speed: 'speed',
  spreadmethod: 'spreadMethod',
  startoffset: 'startOffset',
  stddeviation: 'stdDeviation',
  stemh: 'stemh',
  stemv: 'stemv',
  stitchtiles: 'stitchTiles',
  stopcolor: 'stopColor',
  'stop-color': 'stopColor',
  stopopacity: 'stopOpacity',
  'stop-opacity': 'stopOpacity',
  strikethroughposition: 'strikethroughPosition',
  'strikethrough-position': 'strikethroughPosition',
  strikethroughthickness: 'strikethroughThickness',
  'strikethrough-thickness': 'strikethroughThickness',
  string: 'string',
  stroke: 'stroke',
  strokedasharray: 'strokeDasharray',
  'stroke-dasharray': 'strokeDasharray',
  strokedashoffset: 'strokeDashoffset',
  'stroke-dashoffset': 'strokeDashoffset',
  strokelinecap: 'strokeLinecap',
  'stroke-linecap': 'strokeLinecap',
  strokelinejoin: 'strokeLinejoin',
  'stroke-linejoin': 'strokeLinejoin',
  strokemiterlimit: 'strokeMiterlimit',
  'stroke-miterlimit': 'strokeMiterlimit',
  strokewidth: 'strokeWidth',
  'stroke-width': 'strokeWidth',
  strokeopacity: 'strokeOpacity',
  'stroke-opacity': 'strokeOpacity',
  suppresscontenteditablewarning: 'suppressContentEditableWarning',
  suppresshydrationwarning: 'suppressHydrationWarning',
  surfacescale: 'surfaceScale',
  systemlanguage: 'systemLanguage',
  tablevalues: 'tableValues',
  targetx: 'targetX',
  targety: 'targetY',
  textanchor: 'textAnchor',
  'text-anchor': 'textAnchor',
  textdecoration: 'textDecoration',
  'text-decoration': 'textDecoration',
  textlength: 'textLength',
  textrendering: 'textRendering',
  'text-rendering': 'textRendering',
  to: 'to',
  transform: 'transform',
  typeof: 'typeof',
  u1: 'u1',
  u2: 'u2',
  underlineposition: 'underlinePosition',
  'underline-position': 'underlinePosition',
  underlinethickness: 'underlineThickness',
  'underline-thickness': 'underlineThickness',
  unicode: 'unicode',
  unicodebidi: 'unicodeBidi',
  'unicode-bidi': 'unicodeBidi',
  unicoderange: 'unicodeRange',
  'unicode-range': 'unicodeRange',
  unitsperem: 'unitsPerEm',
  'units-per-em': 'unitsPerEm',
  unselectable: 'unselectable',
  valphabetic: 'vAlphabetic',
  'v-alphabetic': 'vAlphabetic',
  values: 'values',
  vectoreffect: 'vectorEffect',
  'vector-effect': 'vectorEffect',
  version: 'version',
  vertadvy: 'vertAdvY',
  'vert-adv-y': 'vertAdvY',
  vertoriginx: 'vertOriginX',
  'vert-origin-x': 'vertOriginX',
  vertoriginy: 'vertOriginY',
  'vert-origin-y': 'vertOriginY',
  vhanging: 'vHanging',
  'v-hanging': 'vHanging',
  videographic: 'vIdeographic',
  'v-ideographic': 'vIdeographic',
  viewbox: 'viewBox',
  viewtarget: 'viewTarget',
  visibility: 'visibility',
  vmathematical: 'vMathematical',
  'v-mathematical': 'vMathematical',
  vocab: 'vocab',
  widths: 'widths',
  wordspacing: 'wordSpacing',
  'word-spacing': 'wordSpacing',
  writingmode: 'writingMode',
  'writing-mode': 'writingMode',
  x1: 'x1',
  x2: 'x2',
  x: 'x',
  xchannelselector: 'xChannelSelector',
  xheight: 'xHeight',
  'x-height': 'xHeight',
  xlinkactuate: 'xlinkActuate',
  'xlink:actuate': 'xlinkActuate',
  xlinkarcrole: 'xlinkArcrole',
  'xlink:arcrole': 'xlinkArcrole',
  xlinkhref: 'xlinkHref',
  'xlink:href': 'xlinkHref',
  xlinkrole: 'xlinkRole',
  'xlink:role': 'xlinkRole',
  xlinkshow: 'xlinkShow',
  'xlink:show': 'xlinkShow',
  xlinktitle: 'xlinkTitle',
  'xlink:title': 'xlinkTitle',
  xlinktype: 'xlinkType',
  'xlink:type': 'xlinkType',
  xmlbase: 'xmlBase',
  'xml:base': 'xmlBase',
  xmllang: 'xmlLang',
  'xml:lang': 'xmlLang',
  xmlns: 'xmlns',
  'xml:space': 'xmlSpace',
  xmlnsxlink: 'xmlnsXlink',
  'xmlns:xlink': 'xmlnsXlink',
  xmlspace: 'xmlSpace',
  y1: 'y1',
  y2: 'y2',
  y: 'y',
  ychannelselector: 'yChannelSelector',
  z: 'z',
  zoomandpan: 'zoomAndPan'
};

var ariaProperties = {
  'aria-current': 0,
  // state
  'aria-details': 0,
  'aria-disabled': 0,
  // state
  'aria-hidden': 0,
  // state
  'aria-invalid': 0,
  // state
  'aria-keyshortcuts': 0,
  'aria-label': 0,
  'aria-roledescription': 0,
  // Widget Attributes
  'aria-autocomplete': 0,
  'aria-checked': 0,
  'aria-expanded': 0,
  'aria-haspopup': 0,
  'aria-level': 0,
  'aria-modal': 0,
  'aria-multiline': 0,
  'aria-multiselectable': 0,
  'aria-orientation': 0,
  'aria-placeholder': 0,
  'aria-pressed': 0,
  'aria-readonly': 0,
  'aria-required': 0,
  'aria-selected': 0,
  'aria-sort': 0,
  'aria-valuemax': 0,
  'aria-valuemin': 0,
  'aria-valuenow': 0,
  'aria-valuetext': 0,
  // Live Region Attributes
  'aria-atomic': 0,
  'aria-busy': 0,
  'aria-live': 0,
  'aria-relevant': 0,
  // Drag-and-Drop Attributes
  'aria-dropeffect': 0,
  'aria-grabbed': 0,
  // Relationship Attributes
  'aria-activedescendant': 0,
  'aria-colcount': 0,
  'aria-colindex': 0,
  'aria-colspan': 0,
  'aria-controls': 0,
  'aria-describedby': 0,
  'aria-errormessage': 0,
  'aria-flowto': 0,
  'aria-labelledby': 0,
  'aria-owns': 0,
  'aria-posinset': 0,
  'aria-rowcount': 0,
  'aria-rowindex': 0,
  'aria-rowspan': 0,
  'aria-setsize': 0
};

var warnedProperties = {};
var rARIA = new RegExp('^(aria)-[' + ATTRIBUTE_NAME_CHAR + ']*$');
var rARIACamel = new RegExp('^(aria)[A-Z][' + ATTRIBUTE_NAME_CHAR + ']*$');
var hasOwnProperty$1 = Object.prototype.hasOwnProperty;

function validateProperty(tagName, name) {
  {
    if (hasOwnProperty$1.call(warnedProperties, name) && warnedProperties[name]) {
      return true;
    }

    if (rARIACamel.test(name)) {
      var ariaName = 'aria-' + name.slice(4).toLowerCase();
      var correctName = ariaProperties.hasOwnProperty(ariaName) ? ariaName : null; // If this is an aria-* attribute, but is not listed in the known DOM
      // DOM properties, then it is an invalid aria-* attribute.

      if (correctName == null) {
        error('Invalid ARIA attribute `%s`. ARIA attributes follow the pattern aria-* and must be lowercase.', name);

        warnedProperties[name] = true;
        return true;
      } // aria-* attributes should be lowercase; suggest the lowercase version.


      if (name !== correctName) {
        error('Invalid ARIA attribute `%s`. Did you mean `%s`?', name, correctName);

        warnedProperties[name] = true;
        return true;
      }
    }

    if (rARIA.test(name)) {
      var lowerCasedName = name.toLowerCase();
      var standardName = ariaProperties.hasOwnProperty(lowerCasedName) ? lowerCasedName : null; // If this is an aria-* attribute, but is not listed in the known DOM
      // DOM properties, then it is an invalid aria-* attribute.

      if (standardName == null) {
        warnedProperties[name] = true;
        return false;
      } // aria-* attributes should be lowercase; suggest the lowercase version.


      if (name !== standardName) {
        error('Unknown ARIA attribute `%s`. Did you mean `%s`?', name, standardName);

        warnedProperties[name] = true;
        return true;
      }
    }
  }

  return true;
}

function warnInvalidARIAProps(type, props) {
  {
    var invalidProps = [];

    for (var key in props) {
      var isValid = validateProperty(type, key);

      if (!isValid) {
        invalidProps.push(key);
      }
    }

    var unknownPropString = invalidProps.map(function (prop) {
      return '`' + prop + '`';
    }).join(', ');

    if (invalidProps.length === 1) {
      error('Invalid aria prop %s on <%s> tag. ' + 'For details, see https://reactjs.org/link/invalid-aria-props', unknownPropString, type);
    } else if (invalidProps.length > 1) {
      error('Invalid aria props %s on <%s> tag. ' + 'For details, see https://reactjs.org/link/invalid-aria-props', unknownPropString, type);
    }
  }
}

function validateProperties(type, props) {
  if (isCustomComponent(type, props)) {
    return;
  }

  warnInvalidARIAProps(type, props);
}

var didWarnValueNull = false;
function validateProperties$1(type, props) {
  {
    if (type !== 'input' && type !== 'textarea' && type !== 'select') {
      return;
    }

    if (props != null && props.value === null && !didWarnValueNull) {
      didWarnValueNull = true;

      if (type === 'select' && props.multiple) {
        error('`value` prop on `%s` should not be null. ' + 'Consider using an empty array when `multiple` is set to `true` ' + 'to clear the component or `undefined` for uncontrolled components.', type);
      } else {
        error('`value` prop on `%s` should not be null. ' + 'Consider using an empty string to clear the component or `undefined` ' + 'for uncontrolled components.', type);
      }
    }
  }
}

var validateProperty$1 = function () {};

{
  var warnedProperties$1 = {};
  var _hasOwnProperty = Object.prototype.hasOwnProperty;
  var EVENT_NAME_REGEX = /^on./;
  var INVALID_EVENT_NAME_REGEX = /^on[^A-Z]/;
  var rARIA$1 = new RegExp('^(aria)-[' + ATTRIBUTE_NAME_CHAR + ']*$');
  var rARIACamel$1 = new RegExp('^(aria)[A-Z][' + ATTRIBUTE_NAME_CHAR + ']*$');

  validateProperty$1 = function (tagName, name, value, eventRegistry) {
    if (_hasOwnProperty.call(warnedProperties$1, name) && warnedProperties$1[name]) {
      return true;
    }

    var lowerCasedName = name.toLowerCase();

    if (lowerCasedName === 'onfocusin' || lowerCasedName === 'onfocusout') {
      error('React uses onFocus and onBlur instead of onFocusIn and onFocusOut. ' + 'All React events are normalized to bubble, so onFocusIn and onFocusOut ' + 'are not needed/supported by React.');

      warnedProperties$1[name] = true;
      return true;
    } // We can't rely on the event system being injected on the server.


    if (eventRegistry != null) {
      var registrationNameDependencies = eventRegistry.registrationNameDependencies,
          possibleRegistrationNames = eventRegistry.possibleRegistrationNames;

      if (registrationNameDependencies.hasOwnProperty(name)) {
        return true;
      }

      var registrationName = possibleRegistrationNames.hasOwnProperty(lowerCasedName) ? possibleRegistrationNames[lowerCasedName] : null;

      if (registrationName != null) {
        error('Invalid event handler property `%s`. Did you mean `%s`?', name, registrationName);

        warnedProperties$1[name] = true;
        return true;
      }

      if (EVENT_NAME_REGEX.test(name)) {
        error('Unknown event handler property `%s`. It will be ignored.', name);

        warnedProperties$1[name] = true;
        return true;
      }
    } else if (EVENT_NAME_REGEX.test(name)) {
      // If no event plugins have been injected, we are in a server environment.
      // So we can't tell if the event name is correct for sure, but we can filter
      // out known bad ones like `onclick`. We can't suggest a specific replacement though.
      if (INVALID_EVENT_NAME_REGEX.test(name)) {
        error('Invalid event handler property `%s`. ' + 'React events use the camelCase naming convention, for example `onClick`.', name);
      }

      warnedProperties$1[name] = true;
      return true;
    } // Let the ARIA attribute hook validate ARIA attributes


    if (rARIA$1.test(name) || rARIACamel$1.test(name)) {
      return true;
    }

    if (lowerCasedName === 'innerhtml') {
      error('Directly setting property `innerHTML` is not permitted. ' + 'For more information, lookup documentation on `dangerouslySetInnerHTML`.');

      warnedProperties$1[name] = true;
      return true;
    }

    if (lowerCasedName === 'aria') {
      error('The `aria` attribute is reserved for future use in React. ' + 'Pass individual `aria-` attributes instead.');

      warnedProperties$1[name] = true;
      return true;
    }

    if (lowerCasedName === 'is' && value !== null && value !== undefined && typeof value !== 'string') {
      error('Received a `%s` for a string attribute `is`. If this is expected, cast ' + 'the value to a string.', typeof value);

      warnedProperties$1[name] = true;
      return true;
    }

    if (typeof value === 'number' && isNaN(value)) {
      error('Received NaN for the `%s` attribute. If this is expected, cast ' + 'the value to a string.', name);

      warnedProperties$1[name] = true;
      return true;
    }

    var propertyInfo = getPropertyInfo(name);
    var isReserved = propertyInfo !== null && propertyInfo.type === RESERVED; // Known attributes should match the casing specified in the property config.

    if (possibleStandardNames.hasOwnProperty(lowerCasedName)) {
      var standardName = possibleStandardNames[lowerCasedName];

      if (standardName !== name) {
        error('Invalid DOM property `%s`. Did you mean `%s`?', name, standardName);

        warnedProperties$1[name] = true;
        return true;
      }
    } else if (!isReserved && name !== lowerCasedName) {
      // Unknown attributes should have lowercase casing since that's how they
      // will be cased anyway with server rendering.
      error('React does not recognize the `%s` prop on a DOM element. If you ' + 'intentionally want it to appear in the DOM as a custom ' + 'attribute, spell it as lowercase `%s` instead. ' + 'If you accidentally passed it from a parent component, remove ' + 'it from the DOM element.', name, lowerCasedName);

      warnedProperties$1[name] = true;
      return true;
    }

    if (typeof value === 'boolean' && shouldRemoveAttributeWithWarning(name, value, propertyInfo, false)) {
      if (value) {
        error('Received `%s` for a non-boolean attribute `%s`.\n\n' + 'If you want to write it to the DOM, pass a string instead: ' + '%s="%s" or %s={value.toString()}.', value, name, name, value, name);
      } else {
        error('Received `%s` for a non-boolean attribute `%s`.\n\n' + 'If you want to write it to the DOM, pass a string instead: ' + '%s="%s" or %s={value.toString()}.\n\n' + 'If you used to conditionally omit it with %s={condition && value}, ' + 'pass %s={condition ? value : undefined} instead.', value, name, name, value, name, name, name);
      }

      warnedProperties$1[name] = true;
      return true;
    } // Now that we've validated casing, do not validate
    // data types for reserved props


    if (isReserved) {
      return true;
    } // Warn when a known attribute is a bad type


    if (shouldRemoveAttributeWithWarning(name, value, propertyInfo, false)) {
      warnedProperties$1[name] = true;
      return false;
    } // Warn when passing the strings 'false' or 'true' into a boolean prop


    if ((value === 'false' || value === 'true') && propertyInfo !== null && propertyInfo.type === BOOLEAN) {
      error('Received the string `%s` for the boolean attribute `%s`. ' + '%s ' + 'Did you mean %s={%s}?', value, name, value === 'false' ? 'The browser will interpret it as a truthy value.' : 'Although this works, it will not work as expected if you pass the string "false".', name, value);

      warnedProperties$1[name] = true;
      return true;
    }

    return true;
  };
}

var warnUnknownProperties = function (type, props, eventRegistry) {
  {
    var unknownProps = [];

    for (var key in props) {
      var isValid = validateProperty$1(type, key, props[key], eventRegistry);

      if (!isValid) {
        unknownProps.push(key);
      }
    }

    var unknownPropString = unknownProps.map(function (prop) {
      return '`' + prop + '`';
    }).join(', ');

    if (unknownProps.length === 1) {
      error('Invalid value for prop %s on <%s> tag. Either remove it from the element, ' + 'or pass a string or number value to keep it in the DOM. ' + 'For details, see https://reactjs.org/link/attribute-behavior ', unknownPropString, type);
    } else if (unknownProps.length > 1) {
      error('Invalid values for props %s on <%s> tag. Either remove them from the element, ' + 'or pass a string or number value to keep them in the DOM. ' + 'For details, see https://reactjs.org/link/attribute-behavior ', unknownPropString, type);
    }
  }
};

function validateProperties$2(type, props, eventRegistry) {
  if (isCustomComponent(type, props)) {
    return;
  }

  warnUnknownProperties(type, props, eventRegistry);
}

var IS_EVENT_HANDLE_NON_MANAGED_NODE = 1;
var IS_NON_DELEGATED = 1 << 1;
var IS_CAPTURE_PHASE = 1 << 2;
var IS_REPLAYED = 1 << 4;
// set to LEGACY_FB_SUPPORT. LEGACY_FB_SUPPORT only gets set when
// we call willDeferLaterForLegacyFBSupport, thus not bailing out
// will result in endless cycles like an infinite loop.
// We also don't want to defer during event replaying.

var SHOULD_NOT_PROCESS_POLYFILL_EVENT_PLUGINS = IS_EVENT_HANDLE_NON_MANAGED_NODE | IS_NON_DELEGATED | IS_CAPTURE_PHASE;

/**
 * Gets the target node from a native browser event by accounting for
 * inconsistencies in browser DOM APIs.
 *
 * @param {object} nativeEvent Native browser event.
 * @return {DOMEventTarget} Target node.
 */

function getEventTarget(nativeEvent) {
  // Fallback to nativeEvent.srcElement for IE9
  // https://github.com/facebook/react/issues/12506
  var target = nativeEvent.target || nativeEvent.srcElement || window; // Normalize SVG <use> element events #4963

  if (target.correspondingUseElement) {
    target = target.correspondingUseElement;
  } // Safari may fire events on text nodes (Node.TEXT_NODE is 3).
  // @see http://www.quirksmode.org/js/events_properties.html


  return target.nodeType === TEXT_NODE ? target.parentNode : target;
}

var restoreImpl = null;
var restoreTarget = null;
var restoreQueue = null;

function restoreStateOfTarget(target) {
  // We perform this translation at the end of the event loop so that we
  // always receive the correct fiber here
  var internalInstance = getInstanceFromNode(target);

  if (!internalInstance) {
    // Unmounted
    return;
  }

  if (!(typeof restoreImpl === 'function')) {
    {
      throw Error( "setRestoreImplementation() needs to be called to handle a target for controlled events. This error is likely caused by a bug in React. Please file an issue." );
    }
  }

  var stateNode = internalInstance.stateNode; // Guard against Fiber being unmounted.

  if (stateNode) {
    var _props = getFiberCurrentPropsFromNode(stateNode);

    restoreImpl(internalInstance.stateNode, internalInstance.type, _props);
  }
}

function setRestoreImplementation(impl) {
  restoreImpl = impl;
}
function enqueueStateRestore(target) {
  if (restoreTarget) {
    if (restoreQueue) {
      restoreQueue.push(target);
    } else {
      restoreQueue = [target];
    }
  } else {
    restoreTarget = target;
  }
}
function needsStateRestore() {
  return restoreTarget !== null || restoreQueue !== null;
}
function restoreStateIfNeeded() {
  if (!restoreTarget) {
    return;
  }

  var target = restoreTarget;
  var queuedTargets = restoreQueue;
  restoreTarget = null;
  restoreQueue = null;
  restoreStateOfTarget(target);

  if (queuedTargets) {
    for (var i = 0; i < queuedTargets.length; i++) {
      restoreStateOfTarget(queuedTargets[i]);
    }
  }
}

// the renderer. Such as when we're dispatching events or if third party
// libraries need to call batchedUpdates. Eventually, this API will go away when
// everything is batched by default. We'll then have a similar API to opt-out of
// scheduled work and instead do synchronous work.
// Defaults

var batchedUpdatesImpl = function (fn, bookkeeping) {
  return fn(bookkeeping);
};

var discreteUpdatesImpl = function (fn, a, b, c, d) {
  return fn(a, b, c, d);
};

var flushDiscreteUpdatesImpl = function () {};

var batchedEventUpdatesImpl = batchedUpdatesImpl;
var isInsideEventHandler = false;
var isBatchingEventUpdates = false;

function finishEventHandler() {
  // Here we wait until all updates have propagated, which is important
  // when using controlled components within layers:
  // https://github.com/facebook/react/issues/1698
  // Then we restore state of any controlled component.
  var controlledComponentsHavePendingUpdates = needsStateRestore();

  if (controlledComponentsHavePendingUpdates) {
    // If a controlled event was fired, we may need to restore the state of
    // the DOM node back to the controlled value. This is necessary when React
    // bails out of the update without touching the DOM.
    flushDiscreteUpdatesImpl();
    restoreStateIfNeeded();
  }
}

function batchedUpdates(fn, bookkeeping) {
  if (isInsideEventHandler) {
    // If we are currently inside another batch, we need to wait until it
    // fully completes before restoring state.
    return fn(bookkeeping);
  }

  isInsideEventHandler = true;

  try {
    return batchedUpdatesImpl(fn, bookkeeping);
  } finally {
    isInsideEventHandler = false;
    finishEventHandler();
  }
}
function batchedEventUpdates(fn, a, b) {
  if (isBatchingEventUpdates) {
    // If we are currently inside another batch, we need to wait until it
    // fully completes before restoring state.
    return fn(a, b);
  }

  isBatchingEventUpdates = true;

  try {
    return batchedEventUpdatesImpl(fn, a, b);
  } finally {
    isBatchingEventUpdates = false;
    finishEventHandler();
  }
}
function discreteUpdates(fn, a, b, c, d) {
  var prevIsInsideEventHandler = isInsideEventHandler;
  isInsideEventHandler = true;

  try {
    return discreteUpdatesImpl(fn, a, b, c, d);
  } finally {
    isInsideEventHandler = prevIsInsideEventHandler;

    if (!isInsideEventHandler) {
      finishEventHandler();
    }
  }
}
function flushDiscreteUpdatesIfNeeded(timeStamp) {
  {
    if (!isInsideEventHandler) {
      flushDiscreteUpdatesImpl();
    }
  }
}
function setBatchingImplementation(_batchedUpdatesImpl, _discreteUpdatesImpl, _flushDiscreteUpdatesImpl, _batchedEventUpdatesImpl) {
  batchedUpdatesImpl = _batchedUpdatesImpl;
  discreteUpdatesImpl = _discreteUpdatesImpl;
  flushDiscreteUpdatesImpl = _flushDiscreteUpdatesImpl;
  batchedEventUpdatesImpl = _batchedEventUpdatesImpl;
}

function isInteractive(tag) {
  return tag === 'button' || tag === 'input' || tag === 'select' || tag === 'textarea';
}

function shouldPreventMouseEvent(name, type, props) {
  switch (name) {
    case 'onClick':
    case 'onClickCapture':
    case 'onDoubleClick':
    case 'onDoubleClickCapture':
    case 'onMouseDown':
    case 'onMouseDownCapture':
    case 'onMouseMove':
    case 'onMouseMoveCapture':
    case 'onMouseUp':
    case 'onMouseUpCapture':
    case 'onMouseEnter':
      return !!(props.disabled && isInteractive(type));

    default:
      return false;
  }
}
/**
 * @param {object} inst The instance, which is the source of events.
 * @param {string} registrationName Name of listener (e.g. `onClick`).
 * @return {?function} The stored callback.
 */


function getListener(inst, registrationName) {
  var stateNode = inst.stateNode;

  if (stateNode === null) {
    // Work in progress (ex: onload events in incremental mode).
    return null;
  }

  var props = getFiberCurrentPropsFromNode(stateNode);

  if (props === null) {
    // Work in progress.
    return null;
  }

  var listener = props[registrationName];

  if (shouldPreventMouseEvent(registrationName, inst.type, props)) {
    return null;
  }

  if (!(!listener || typeof listener === 'function')) {
    {
      throw Error( "Expected `" + registrationName + "` listener to be a function, instead got a value of `" + typeof listener + "` type." );
    }
  }

  return listener;
}

var passiveBrowserEventsSupported = false; // Check if browser support events with passive listeners
// https://developer.mozilla.org/en-US/docs/Web/API/EventTarget/addEventListener#Safely_detecting_option_support

if (canUseDOM) {
  try {
    var options = {}; // $FlowFixMe: Ignore Flow complaining about needing a value

    Object.defineProperty(options, 'passive', {
      get: function () {
        passiveBrowserEventsSupported = true;
      }
    });
    window.addEventListener('test', options, options);
    window.removeEventListener('test', options, options);
  } catch (e) {
    passiveBrowserEventsSupported = false;
  }
}

function invokeGuardedCallbackProd(name, func, context, a, b, c, d, e, f) {
  var funcArgs = Array.prototype.slice.call(arguments, 3);

  try {
    func.apply(context, funcArgs);
  } catch (error) {
    this.onError(error);
  }
}

var invokeGuardedCallbackImpl = invokeGuardedCallbackProd;

{
  // In DEV mode, we swap out invokeGuardedCallback for a special version
  // that plays more nicely with the browser's DevTools. The idea is to preserve
  // "Pause on exceptions" behavior. Because React wraps all user-provided
  // functions in invokeGuardedCallback, and the production version of
  // invokeGuardedCallback uses a try-catch, all user exceptions are treated
  // like caught exceptions, and the DevTools won't pause unless the developer
  // takes the extra step of enabling pause on caught exceptions. This is
  // unintuitive, though, because even though React has caught the error, from
  // the developer's perspective, the error is uncaught.
  //
  // To preserve the expected "Pause on exceptions" behavior, we don't use a
  // try-catch in DEV. Instead, we synchronously dispatch a fake event to a fake
  // DOM node, and call the user-provided callback from inside an event handler
  // for that fake event. If the callback throws, the error is "captured" using
  // a global event handler. But because the error happens in a different
  // event loop context, it does not interrupt the normal program flow.
  // Effectively, this gives us try-catch behavior without actually using
  // try-catch. Neat!
  // Check that the browser supports the APIs we need to implement our special
  // DEV version of invokeGuardedCallback
  if (typeof window !== 'undefined' && typeof window.dispatchEvent === 'function' && typeof document !== 'undefined' && typeof document.createEvent === 'function') {
    var fakeNode = document.createElement('react');

    invokeGuardedCallbackImpl = function invokeGuardedCallbackDev(name, func, context, a, b, c, d, e, f) {
      // If document doesn't exist we know for sure we will crash in this method
      // when we call document.createEvent(). However this can cause confusing
      // errors: https://github.com/facebookincubator/create-react-app/issues/3482
      // So we preemptively throw with a better message instead.
      if (!(typeof document !== 'undefined')) {
        {
          throw Error( "The `document` global was defined when React was initialized, but is not defined anymore. This can happen in a test environment if a component schedules an update from an asynchronous callback, but the test has already finished running. To solve this, you can either unmount the component at the end of your test (and ensure that any asynchronous operations get canceled in `componentWillUnmount`), or you can change the test itself to be asynchronous." );
        }
      }

      var evt = document.createEvent('Event');
      var didCall = false; // Keeps track of whether the user-provided callback threw an error. We
      // set this to true at the beginning, then set it to false right after
      // calling the function. If the function errors, `didError` will never be
      // set to false. This strategy works even if the browser is flaky and
      // fails to call our global error handler, because it doesn't rely on
      // the error event at all.

      var didError = true; // Keeps track of the value of window.event so that we can reset it
      // during the callback to let user code access window.event in the
      // browsers that support it.

      var windowEvent = window.event; // Keeps track of the descriptor of window.event to restore it after event
      // dispatching: https://github.com/facebook/react/issues/13688

      var windowEventDescriptor = Object.getOwnPropertyDescriptor(window, 'event');

      function restoreAfterDispatch() {
        // We immediately remove the callback from event listeners so that
        // nested `invokeGuardedCallback` calls do not clash. Otherwise, a
        // nested call would trigger the fake event handlers of any call higher
        // in the stack.
        fakeNode.removeEventListener(evtType, callCallback, false); // We check for window.hasOwnProperty('event') to prevent the
        // window.event assignment in both IE <= 10 as they throw an error
        // "Member not found" in strict mode, and in Firefox which does not
        // support window.event.

        if (typeof window.event !== 'undefined' && window.hasOwnProperty('event')) {
          window.event = windowEvent;
        }
      } // Create an event handler for our fake event. We will synchronously
      // dispatch our fake event using `dispatchEvent`. Inside the handler, we
      // call the user-provided callback.


      var funcArgs = Array.prototype.slice.call(arguments, 3);

      function callCallback() {
        didCall = true;
        restoreAfterDispatch();
        func.apply(context, funcArgs);
        didError = false;
      } // Create a global error event handler. We use this to capture the value
      // that was thrown. It's possible that this error handler will fire more
      // than once; for example, if non-React code also calls `dispatchEvent`
      // and a handler for that event throws. We should be resilient to most of
      // those cases. Even if our error event handler fires more than once, the
      // last error event is always used. If the callback actually does error,
      // we know that the last error event is the correct one, because it's not
      // possible for anything else to have happened in between our callback
      // erroring and the code that follows the `dispatchEvent` call below. If
      // the callback doesn't error, but the error event was fired, we know to
      // ignore it because `didError` will be false, as described above.


      var error; // Use this to track whether the error event is ever called.

      var didSetError = false;
      var isCrossOriginError = false;

      function handleWindowError(event) {
        error = event.error;
        didSetError = true;

        if (error === null && event.colno === 0 && event.lineno === 0) {
          isCrossOriginError = true;
        }

        if (event.defaultPrevented) {
          // Some other error handler has prevented default.
          // Browsers silence the error report if this happens.
          // We'll remember this to later decide whether to log it or not.
          if (error != null && typeof error === 'object') {
            try {
              error._suppressLogging = true;
            } catch (inner) {// Ignore.
            }
          }
        }
      } // Create a fake event type.


      var evtType = "react-" + (name ? name : 'invokeguardedcallback'); // Attach our event handlers

      window.addEventListener('error', handleWindowError);
      fakeNode.addEventListener(evtType, callCallback, false); // Synchronously dispatch our fake event. If the user-provided function
      // errors, it will trigger our global error handler.

      evt.initEvent(evtType, false, false);
      fakeNode.dispatchEvent(evt);

      if (windowEventDescriptor) {
        Object.defineProperty(window, 'event', windowEventDescriptor);
      }

      if (didCall && didError) {
        if (!didSetError) {
          // The callback errored, but the error event never fired.
          error = new Error('An error was thrown inside one of your components, but React ' + "doesn't know what it was. This is likely due to browser " + 'flakiness. React does its best to preserve the "Pause on ' + 'exceptions" behavior of the DevTools, which requires some ' + "DEV-mode only tricks. It's possible that these don't work in " + 'your browser. Try triggering the error in production mode, ' + 'or switching to a modern browser. If you suspect that this is ' + 'actually an issue with React, please file an issue.');
        } else if (isCrossOriginError) {
          error = new Error("A cross-origin error was thrown. React doesn't have access to " + 'the actual error object in development. ' + 'See https://reactjs.org/link/crossorigin-error for more information.');
        }

        this.onError(error);
      } // Remove our event listeners


      window.removeEventListener('error', handleWindowError);

      if (!didCall) {
        // Something went really wrong, and our event was not dispatched.
        // https://github.com/facebook/react/issues/16734
        // https://github.com/facebook/react/issues/16585
        // Fall back to the production implementation.
        restoreAfterDispatch();
        return invokeGuardedCallbackProd.apply(this, arguments);
      }
    };
  }
}

var invokeGuardedCallbackImpl$1 = invokeGuardedCallbackImpl;

var hasError = false;
var caughtError = null; // Used by event system to capture/rethrow the first error.

var hasRethrowError = false;
var rethrowError = null;
var reporter = {
  onError: function (error) {
    hasError = true;
    caughtError = error;
  }
};
/**
 * Call a function while guarding against errors that happens within it.
 * Returns an error if it throws, otherwise null.
 *
 * In production, this is implemented using a try-catch. The reason we don't
 * use a try-catch directly is so that we can swap out a different
 * implementation in DEV mode.
 *
 * @param {String} name of the guard to use for logging or debugging
 * @param {Function} func The function to invoke
 * @param {*} context The context to use when calling the function
 * @param {...*} args Arguments for function
 */

function invokeGuardedCallback(name, func, context, a, b, c, d, e, f) {
  hasError = false;
  caughtError = null;
  invokeGuardedCallbackImpl$1.apply(reporter, arguments);
}
/**
 * Same as invokeGuardedCallback, but instead of returning an error, it stores
 * it in a global so it can be rethrown by `rethrowCaughtError` later.
 * TODO: See if caughtError and rethrowError can be unified.
 *
 * @param {String} name of the guard to use for logging or debugging
 * @param {Function} func The function to invoke
 * @param {*} context The context to use when calling the function
 * @param {...*} args Arguments for function
 */

function invokeGuardedCallbackAndCatchFirstError(name, func, context, a, b, c, d, e, f) {
  invokeGuardedCallback.apply(this, arguments);

  if (hasError) {
    var error = clearCaughtError();

    if (!hasRethrowError) {
      hasRethrowError = true;
      rethrowError = error;
    }
  }
}
/**
 * During execution of guarded functions we will capture the first error which
 * we will rethrow to be handled by the top level error handler.
 */

function rethrowCaughtError() {
  if (hasRethrowError) {
    var error = rethrowError;
    hasRethrowError = false;
    rethrowError = null;
    throw error;
  }
}
function hasCaughtError() {
  return hasError;
}
function clearCaughtError() {
  if (hasError) {
    var error = caughtError;
    hasError = false;
    caughtError = null;
    return error;
  } else {
    {
      {
        throw Error( "clearCaughtError was called but no error was captured. This error is likely caused by a bug in React. Please file an issue." );
      }
    }
  }
}

/**
 * `ReactInstanceMap` maintains a mapping from a public facing stateful
 * instance (key) and the internal representation (value). This allows public
 * methods to accept the user facing instance as an argument and map them back
 * to internal methods.
 *
 * Note that this module is currently shared and assumed to be stateless.
 * If this becomes an actual Map, that will break.
 */
function get(key) {
  return key._reactInternals;
}
function has(key) {
  return key._reactInternals !== undefined;
}
function set(key, value) {
  key._reactInternals = value;
}

// Don't change these two values. They're used by React Dev Tools.
var NoFlags =
/*                      */
0;
var PerformedWork =
/*                */
1; // You can change the rest (and add more).

var Placement =
/*                    */
2;
var Update =
/*                       */
4;
var PlacementAndUpdate =
/*           */
6;
var Deletion =
/*                     */
8;
var ContentReset =
/*                 */
16;
var Callback =
/*                     */
32;
var DidCapture =
/*                   */
64;
var Ref =
/*                          */
128;
var Snapshot =
/*                     */
256;
var Passive =
/*                      */
512; // TODO (effects) Remove this bit once the new reconciler is synced to the old.

var PassiveUnmountPendingDev =
/*     */
8192;
var Hydrating =
/*                    */
1024;
var HydratingAndUpdate =
/*           */
1028; // Passive & Update & Callback & Ref & Snapshot

var LifecycleEffectMask =
/*          */
932; // Union of all host effects

var HostEffectMask =
/*               */
2047; // These are not really side effects, but we still reuse this field.

var Incomplete =
/*                   */
2048;
var ShouldCapture =
/*                */
4096;
var ForceUpdateForLegacySuspense =
/* */
16384; // Static tags describe aspects of a fiber that are not specific to a render,

var ReactCurrentOwner = ReactSharedInternals.ReactCurrentOwner;
function getNearestMountedFiber(fiber) {
  var node = fiber;
  var nearestMounted = fiber;

  if (!fiber.alternate) {
    // If there is no alternate, this might be a new tree that isn't inserted
    // yet. If it is, then it will have a pending insertion effect on it.
    var nextNode = node;

    do {
      node = nextNode;

      if ((node.flags & (Placement | Hydrating)) !== NoFlags) {
        // This is an insertion or in-progress hydration. The nearest possible
        // mounted fiber is the parent but we need to continue to figure out
        // if that one is still mounted.
        nearestMounted = node.return;
      }

      nextNode = node.return;
    } while (nextNode);
  } else {
    while (node.return) {
      node = node.return;
    }
  }

  if (node.tag === HostRoot) {
    // TODO: Check if this was a nested HostRoot when used with
    // renderContainerIntoSubtree.
    return nearestMounted;
  } // If we didn't hit the root, that means that we're in an disconnected tree
  // that has been unmounted.


  return null;
}
function getSuspenseInstanceFromFiber(fiber) {
  if (fiber.tag === SuspenseComponent) {
    var suspenseState = fiber.memoizedState;

    if (suspenseState === null) {
      var current = fiber.alternate;

      if (current !== null) {
        suspenseState = current.memoizedState;
      }
    }

    if (suspenseState !== null) {
      return suspenseState.dehydrated;
    }
  }

  return null;
}
function getContainerFromFiber(fiber) {
  return fiber.tag === HostRoot ? fiber.stateNode.containerInfo : null;
}
function isFiberMounted(fiber) {
  return getNearestMountedFiber(fiber) === fiber;
}
function isMounted(component) {
  {
    var owner = ReactCurrentOwner.current;

    if (owner !== null && owner.tag === ClassComponent) {
      var ownerFiber = owner;
      var instance = ownerFiber.stateNode;

      if (!instance._warnedAboutRefsInRender) {
        error('%s is accessing isMounted inside its render() function. ' + 'render() should be a pure function of props and state. It should ' + 'never access something that requires stale data from the previous ' + 'render, such as refs. Move this logic to componentDidMount and ' + 'componentDidUpdate instead.', getComponentName(ownerFiber.type) || 'A component');
      }

      instance._warnedAboutRefsInRender = true;
    }
  }

  var fiber = get(component);

  if (!fiber) {
    return false;
  }

  return getNearestMountedFiber(fiber) === fiber;
}

function assertIsMounted(fiber) {
  if (!(getNearestMountedFiber(fiber) === fiber)) {
    {
      throw Error( "Unable to find node on an unmounted component." );
    }
  }
}

function findCurrentFiberUsingSlowPath(fiber) {
  var alternate = fiber.alternate;

  if (!alternate) {
    // If there is no alternate, then we only need to check if it is mounted.
    var nearestMounted = getNearestMountedFiber(fiber);

    if (!(nearestMounted !== null)) {
      {
        throw Error( "Unable to find node on an unmounted component." );
      }
    }

    if (nearestMounted !== fiber) {
      return null;
    }

    return fiber;
  } // If we have two possible branches, we'll walk backwards up to the root
  // to see what path the root points to. On the way we may hit one of the
  // special cases and we'll deal with them.


  var a = fiber;
  var b = alternate;

  while (true) {
    var parentA = a.return;

    if (parentA === null) {
      // We're at the root.
      break;
    }

    var parentB = parentA.alternate;

    if (parentB === null) {
      // There is no alternate. This is an unusual case. Currently, it only
      // happens when a Suspense component is hidden. An extra fragment fiber
      // is inserted in between the Suspense fiber and its children. Skip
      // over this extra fragment fiber and proceed to the next parent.
      var nextParent = parentA.return;

      if (nextParent !== null) {
        a = b = nextParent;
        continue;
      } // If there's no parent, we're at the root.


      break;
    } // If both copies of the parent fiber point to the same child, we can
    // assume that the child is current. This happens when we bailout on low
    // priority: the bailed out fiber's child reuses the current child.


    if (parentA.child === parentB.child) {
      var child = parentA.child;

      while (child) {
        if (child === a) {
          // We've determined that A is the current branch.
          assertIsMounted(parentA);
          return fiber;
        }

        if (child === b) {
          // We've determined that B is the current branch.
          assertIsMounted(parentA);
          return alternate;
        }

        child = child.sibling;
      } // We should never have an alternate for any mounting node. So the only
      // way this could possibly happen is if this was unmounted, if at all.


      {
        {
          throw Error( "Unable to find node on an unmounted component." );
        }
      }
    }

    if (a.return !== b.return) {
      // The return pointer of A and the return pointer of B point to different
      // fibers. We assume that return pointers never criss-cross, so A must
      // belong to the child set of A.return, and B must belong to the child
      // set of B.return.
      a = parentA;
      b = parentB;
    } else {
      // The return pointers point to the same fiber. We'll have to use the
      // default, slow path: scan the child sets of each parent alternate to see
      // which child belongs to which set.
      //
      // Search parent A's child set
      var didFindChild = false;
      var _child = parentA.child;

      while (_child) {
        if (_child === a) {
          didFindChild = true;
          a = parentA;
          b = parentB;
          break;
        }

        if (_child === b) {
          didFindChild = true;
          b = parentA;
          a = parentB;
          break;
        }

        _child = _child.sibling;
      }

      if (!didFindChild) {
        // Search parent B's child set
        _child = parentB.child;

        while (_child) {
          if (_child === a) {
            didFindChild = true;
            a = parentB;
            b = parentA;
            break;
          }

          if (_child === b) {
            didFindChild = true;
            b = parentB;
            a = parentA;
            break;
          }

          _child = _child.sibling;
        }

        if (!didFindChild) {
          {
            throw Error( "Child was not found in either parent set. This indicates a bug in React related to the return pointer. Please file an issue." );
          }
        }
      }
    }

    if (!(a.alternate === b)) {
      {
        throw Error( "Return fibers should always be each others' alternates. This error is likely caused by a bug in React. Please file an issue." );
      }
    }
  } // If the root is not a host container, we're in a disconnected tree. I.e.
  // unmounted.


  if (!(a.tag === HostRoot)) {
    {
      throw Error( "Unable to find node on an unmounted component." );
    }
  }

  if (a.stateNode.current === a) {
    // We've determined that A is the current branch.
    return fiber;
  } // Otherwise B has to be current branch.


  return alternate;
}
function findCurrentHostFiber(parent) {
  var currentParent = findCurrentFiberUsingSlowPath(parent);

  if (!currentParent) {
    return null;
  } // Next we'll drill down this component to find the first HostComponent/Text.


  var node = currentParent;

  while (true) {
    if (node.tag === HostComponent || node.tag === HostText) {
      return node;
    } else if (node.child) {
      node.child.return = node;
      node = node.child;
      continue;
    }

    if (node === currentParent) {
      return null;
    }

    while (!node.sibling) {
      if (!node.return || node.return === currentParent) {
        return null;
      }

      node = node.return;
    }

    node.sibling.return = node.return;
    node = node.sibling;
  } // Flow needs the return null here, but ESLint complains about it.
  // eslint-disable-next-line no-unreachable


  return null;
}
function findCurrentHostFiberWithNoPortals(parent) {
  var currentParent = findCurrentFiberUsingSlowPath(parent);

  if (!currentParent) {
    return null;
  } // Next we'll drill down this component to find the first HostComponent/Text.


  var node = currentParent;

  while (true) {
    if (node.tag === HostComponent || node.tag === HostText || enableFundamentalAPI ) {
      return node;
    } else if (node.child && node.tag !== HostPortal) {
      node.child.return = node;
      node = node.child;
      continue;
    }

    if (node === currentParent) {
      return null;
    }

    while (!node.sibling) {
      if (!node.return || node.return === currentParent) {
        return null;
      }

      node = node.return;
    }

    node.sibling.return = node.return;
    node = node.sibling;
  } // Flow needs the return null here, but ESLint complains about it.
  // eslint-disable-next-line no-unreachable


  return null;
}
function doesFiberContain(parentFiber, childFiber) {
  var node = childFiber;
  var parentFiberAlternate = parentFiber.alternate;

  while (node !== null) {
    if (node === parentFiber || node === parentFiberAlternate) {
      return true;
    }

    node = node.return;
  }

  return false;
}

var attemptUserBlockingHydration;
function setAttemptUserBlockingHydration(fn) {
  attemptUserBlockingHydration = fn;
}
var attemptContinuousHydration;
function setAttemptContinuousHydration(fn) {
  attemptContinuousHydration = fn;
}
var attemptHydrationAtCurrentPriority;
function setAttemptHydrationAtCurrentPriority(fn) {
  attemptHydrationAtCurrentPriority = fn;
}
var attemptHydrationAtPriority;
function setAttemptHydrationAtPriority(fn) {
  attemptHydrationAtPriority = fn;
} // TODO: Upgrade this definition once we're on a newer version of Flow that
var hasScheduledReplayAttempt = false; // The queue of discrete events to be replayed.

var queuedDiscreteEvents = []; // Indicates if any continuous event targets are non-null for early bailout.
// if the last target was dehydrated.

var queuedFocus = null;
var queuedDrag = null;
var queuedMouse = null; // For pointer events there can be one latest event per pointerId.

var queuedPointers = new Map();
var queuedPointerCaptures = new Map(); // We could consider replaying selectionchange and touchmoves too.

var queuedExplicitHydrationTargets = [];
function hasQueuedDiscreteEvents() {
  return queuedDiscreteEvents.length > 0;
}
var discreteReplayableEvents = ['mousedown', 'mouseup', 'touchcancel', 'touchend', 'touchstart', 'auxclick', 'dblclick', 'pointercancel', 'pointerdown', 'pointerup', 'dragend', 'dragstart', 'drop', 'compositionend', 'compositionstart', 'keydown', 'keypress', 'keyup', 'input', 'textInput', // Intentionally camelCase
'copy', 'cut', 'paste', 'click', 'change', 'contextmenu', 'reset', 'submit'];
function isReplayableDiscreteEvent(eventType) {
  return discreteReplayableEvents.indexOf(eventType) > -1;
}

function createQueuedReplayableEvent(blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent) {
  return {
    blockedOn: blockedOn,
    domEventName: domEventName,
    eventSystemFlags: eventSystemFlags | IS_REPLAYED,
    nativeEvent: nativeEvent,
    targetContainers: [targetContainer]
  };
}

function queueDiscreteEvent(blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent) {
  var queuedEvent = createQueuedReplayableEvent(blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent);
  queuedDiscreteEvents.push(queuedEvent);
} // Resets the replaying for this type of continuous event to no event.

function clearIfContinuousEvent(domEventName, nativeEvent) {
  switch (domEventName) {
    case 'focusin':
    case 'focusout':
      queuedFocus = null;
      break;

    case 'dragenter':
    case 'dragleave':
      queuedDrag = null;
      break;

    case 'mouseover':
    case 'mouseout':
      queuedMouse = null;
      break;

    case 'pointerover':
    case 'pointerout':
      {
        var pointerId = nativeEvent.pointerId;
        queuedPointers.delete(pointerId);
        break;
      }

    case 'gotpointercapture':
    case 'lostpointercapture':
      {
        var _pointerId = nativeEvent.pointerId;
        queuedPointerCaptures.delete(_pointerId);
        break;
      }
  }
}

function accumulateOrCreateContinuousQueuedReplayableEvent(existingQueuedEvent, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent) {
  if (existingQueuedEvent === null || existingQueuedEvent.nativeEvent !== nativeEvent) {
    var queuedEvent = createQueuedReplayableEvent(blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent);

    if (blockedOn !== null) {
      var _fiber2 = getInstanceFromNode(blockedOn);

      if (_fiber2 !== null) {
        // Attempt to increase the priority of this target.
        attemptContinuousHydration(_fiber2);
      }
    }

    return queuedEvent;
  } // If we have already queued this exact event, then it's because
  // the different event systems have different DOM event listeners.
  // We can accumulate the flags, and the targetContainers, and
  // store a single event to be replayed.


  existingQueuedEvent.eventSystemFlags |= eventSystemFlags;
  var targetContainers = existingQueuedEvent.targetContainers;

  if (targetContainer !== null && targetContainers.indexOf(targetContainer) === -1) {
    targetContainers.push(targetContainer);
  }

  return existingQueuedEvent;
}

function queueIfContinuousEvent(blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent) {
  // These set relatedTarget to null because the replayed event will be treated as if we
  // moved from outside the window (no target) onto the target once it hydrates.
  // Instead of mutating we could clone the event.
  switch (domEventName) {
    case 'focusin':
      {
        var focusEvent = nativeEvent;
        queuedFocus = accumulateOrCreateContinuousQueuedReplayableEvent(queuedFocus, blockedOn, domEventName, eventSystemFlags, targetContainer, focusEvent);
        return true;
      }

    case 'dragenter':
      {
        var dragEvent = nativeEvent;
        queuedDrag = accumulateOrCreateContinuousQueuedReplayableEvent(queuedDrag, blockedOn, domEventName, eventSystemFlags, targetContainer, dragEvent);
        return true;
      }

    case 'mouseover':
      {
        var mouseEvent = nativeEvent;
        queuedMouse = accumulateOrCreateContinuousQueuedReplayableEvent(queuedMouse, blockedOn, domEventName, eventSystemFlags, targetContainer, mouseEvent);
        return true;
      }

    case 'pointerover':
      {
        var pointerEvent = nativeEvent;
        var pointerId = pointerEvent.pointerId;
        queuedPointers.set(pointerId, accumulateOrCreateContinuousQueuedReplayableEvent(queuedPointers.get(pointerId) || null, blockedOn, domEventName, eventSystemFlags, targetContainer, pointerEvent));
        return true;
      }

    case 'gotpointercapture':
      {
        var _pointerEvent = nativeEvent;
        var _pointerId2 = _pointerEvent.pointerId;
        queuedPointerCaptures.set(_pointerId2, accumulateOrCreateContinuousQueuedReplayableEvent(queuedPointerCaptures.get(_pointerId2) || null, blockedOn, domEventName, eventSystemFlags, targetContainer, _pointerEvent));
        return true;
      }
  }

  return false;
} // Check if this target is unblocked. Returns true if it's unblocked.

function attemptExplicitHydrationTarget(queuedTarget) {
  // TODO: This function shares a lot of logic with attemptToDispatchEvent.
  // Try to unify them. It's a bit tricky since it would require two return
  // values.
  var targetInst = getClosestInstanceFromNode(queuedTarget.target);

  if (targetInst !== null) {
    var nearestMounted = getNearestMountedFiber(targetInst);

    if (nearestMounted !== null) {
      var tag = nearestMounted.tag;

      if (tag === SuspenseComponent) {
        var instance = getSuspenseInstanceFromFiber(nearestMounted);

        if (instance !== null) {
          // We're blocked on hydrating this boundary.
          // Increase its priority.
          queuedTarget.blockedOn = instance;
          attemptHydrationAtPriority(queuedTarget.lanePriority, function () {
            Scheduler.unstable_runWithPriority(queuedTarget.priority, function () {
              attemptHydrationAtCurrentPriority(nearestMounted);
            });
          });
          return;
        }
      } else if (tag === HostRoot) {
        var root = nearestMounted.stateNode;

        if (root.hydrate) {
          queuedTarget.blockedOn = getContainerFromFiber(nearestMounted); // We don't currently have a way to increase the priority of
          // a root other than sync.

          return;
        }
      }
    }
  }

  queuedTarget.blockedOn = null;
}

function attemptReplayContinuousQueuedEvent(queuedEvent) {
  if (queuedEvent.blockedOn !== null) {
    return false;
  }

  var targetContainers = queuedEvent.targetContainers;

  while (targetContainers.length > 0) {
    var targetContainer = targetContainers[0];
    var nextBlockedOn = attemptToDispatchEvent(queuedEvent.domEventName, queuedEvent.eventSystemFlags, targetContainer, queuedEvent.nativeEvent);

    if (nextBlockedOn !== null) {
      // We're still blocked. Try again later.
      var _fiber3 = getInstanceFromNode(nextBlockedOn);

      if (_fiber3 !== null) {
        attemptContinuousHydration(_fiber3);
      }

      queuedEvent.blockedOn = nextBlockedOn;
      return false;
    } // This target container was successfully dispatched. Try the next.


    targetContainers.shift();
  }

  return true;
}

function attemptReplayContinuousQueuedEventInMap(queuedEvent, key, map) {
  if (attemptReplayContinuousQueuedEvent(queuedEvent)) {
    map.delete(key);
  }
}

function replayUnblockedEvents() {
  hasScheduledReplayAttempt = false; // First replay discrete events.

  while (queuedDiscreteEvents.length > 0) {
    var nextDiscreteEvent = queuedDiscreteEvents[0];

    if (nextDiscreteEvent.blockedOn !== null) {
      // We're still blocked.
      // Increase the priority of this boundary to unblock
      // the next discrete event.
      var _fiber4 = getInstanceFromNode(nextDiscreteEvent.blockedOn);

      if (_fiber4 !== null) {
        attemptUserBlockingHydration(_fiber4);
      }

      break;
    }

    var targetContainers = nextDiscreteEvent.targetContainers;

    while (targetContainers.length > 0) {
      var targetContainer = targetContainers[0];
      var nextBlockedOn = attemptToDispatchEvent(nextDiscreteEvent.domEventName, nextDiscreteEvent.eventSystemFlags, targetContainer, nextDiscreteEvent.nativeEvent);

      if (nextBlockedOn !== null) {
        // We're still blocked. Try again later.
        nextDiscreteEvent.blockedOn = nextBlockedOn;
        break;
      } // This target container was successfully dispatched. Try the next.


      targetContainers.shift();
    }

    if (nextDiscreteEvent.blockedOn === null) {
      // We've successfully replayed the first event. Let's try the next one.
      queuedDiscreteEvents.shift();
    }
  } // Next replay any continuous events.


  if (queuedFocus !== null && attemptReplayContinuousQueuedEvent(queuedFocus)) {
    queuedFocus = null;
  }

  if (queuedDrag !== null && attemptReplayContinuousQueuedEvent(queuedDrag)) {
    queuedDrag = null;
  }

  if (queuedMouse !== null && attemptReplayContinuousQueuedEvent(queuedMouse)) {
    queuedMouse = null;
  }

  queuedPointers.forEach(attemptReplayContinuousQueuedEventInMap);
  queuedPointerCaptures.forEach(attemptReplayContinuousQueuedEventInMap);
}

function scheduleCallbackIfUnblocked(queuedEvent, unblocked) {
  if (queuedEvent.blockedOn === unblocked) {
    queuedEvent.blockedOn = null;

    if (!hasScheduledReplayAttempt) {
      hasScheduledReplayAttempt = true; // Schedule a callback to attempt replaying as many events as are
      // now unblocked. This first might not actually be unblocked yet.
      // We could check it early to avoid scheduling an unnecessary callback.

      Scheduler.unstable_scheduleCallback(Scheduler.unstable_NormalPriority, replayUnblockedEvents);
    }
  }
}

function retryIfBlockedOn(unblocked) {
  // Mark anything that was blocked on this as no longer blocked
  // and eligible for a replay.
  if (queuedDiscreteEvents.length > 0) {
    scheduleCallbackIfUnblocked(queuedDiscreteEvents[0], unblocked); // This is a exponential search for each boundary that commits. I think it's
    // worth it because we expect very few discrete events to queue up and once
    // we are actually fully unblocked it will be fast to replay them.

    for (var i = 1; i < queuedDiscreteEvents.length; i++) {
      var queuedEvent = queuedDiscreteEvents[i];

      if (queuedEvent.blockedOn === unblocked) {
        queuedEvent.blockedOn = null;
      }
    }
  }

  if (queuedFocus !== null) {
    scheduleCallbackIfUnblocked(queuedFocus, unblocked);
  }

  if (queuedDrag !== null) {
    scheduleCallbackIfUnblocked(queuedDrag, unblocked);
  }

  if (queuedMouse !== null) {
    scheduleCallbackIfUnblocked(queuedMouse, unblocked);
  }

  var unblock = function (queuedEvent) {
    return scheduleCallbackIfUnblocked(queuedEvent, unblocked);
  };

  queuedPointers.forEach(unblock);
  queuedPointerCaptures.forEach(unblock);

  for (var _i = 0; _i < queuedExplicitHydrationTargets.length; _i++) {
    var queuedTarget = queuedExplicitHydrationTargets[_i];

    if (queuedTarget.blockedOn === unblocked) {
      queuedTarget.blockedOn = null;
    }
  }

  while (queuedExplicitHydrationTargets.length > 0) {
    var nextExplicitTarget = queuedExplicitHydrationTargets[0];

    if (nextExplicitTarget.blockedOn !== null) {
      // We're still blocked.
      break;
    } else {
      attemptExplicitHydrationTarget(nextExplicitTarget);

      if (nextExplicitTarget.blockedOn === null) {
        // We're unblocked.
        queuedExplicitHydrationTargets.shift();
      }
    }
  }
}

var DiscreteEvent = 0;
var UserBlockingEvent = 1;
var ContinuousEvent = 2;

/**
 * Generate a mapping of standard vendor prefixes using the defined style property and event name.
 *
 * @param {string} styleProp
 * @param {string} eventName
 * @returns {object}
 */

function makePrefixMap(styleProp, eventName) {
  var prefixes = {};
  prefixes[styleProp.toLowerCase()] = eventName.toLowerCase();
  prefixes['Webkit' + styleProp] = 'webkit' + eventName;
  prefixes['Moz' + styleProp] = 'moz' + eventName;
  return prefixes;
}
/**
 * A list of event names to a configurable list of vendor prefixes.
 */


var vendorPrefixes = {
  animationend: makePrefixMap('Animation', 'AnimationEnd'),
  animationiteration: makePrefixMap('Animation', 'AnimationIteration'),
  animationstart: makePrefixMap('Animation', 'AnimationStart'),
  transitionend: makePrefixMap('Transition', 'TransitionEnd')
};
/**
 * Event names that have already been detected and prefixed (if applicable).
 */

var prefixedEventNames = {};
/**
 * Element to check for prefixes on.
 */

var style = {};
/**
 * Bootstrap if a DOM exists.
 */

if (canUseDOM) {
  style = document.createElement('div').style; // On some platforms, in particular some releases of Android 4.x,
  // the un-prefixed "animation" and "transition" properties are defined on the
  // style object but the events that fire will still be prefixed, so we need
  // to check if the un-prefixed events are usable, and if not remove them from the map.

  if (!('AnimationEvent' in window)) {
    delete vendorPrefixes.animationend.animation;
    delete vendorPrefixes.animationiteration.animation;
    delete vendorPrefixes.animationstart.animation;
  } // Same as above


  if (!('TransitionEvent' in window)) {
    delete vendorPrefixes.transitionend.transition;
  }
}
/**
 * Attempts to determine the correct vendor prefixed event name.
 *
 * @param {string} eventName
 * @returns {string}
 */


function getVendorPrefixedEventName(eventName) {
  if (prefixedEventNames[eventName]) {
    return prefixedEventNames[eventName];
  } else if (!vendorPrefixes[eventName]) {
    return eventName;
  }

  var prefixMap = vendorPrefixes[eventName];

  for (var styleProp in prefixMap) {
    if (prefixMap.hasOwnProperty(styleProp) && styleProp in style) {
      return prefixedEventNames[eventName] = prefixMap[styleProp];
    }
  }

  return eventName;
}

var ANIMATION_END = getVendorPrefixedEventName('animationend');
var ANIMATION_ITERATION = getVendorPrefixedEventName('animationiteration');
var ANIMATION_START = getVendorPrefixedEventName('animationstart');
var TRANSITION_END = getVendorPrefixedEventName('transitionend');

var topLevelEventsToReactNames = new Map();
var eventPriorities = new Map(); // We store most of the events in this module in pairs of two strings so we can re-use
// the code required to apply the same logic for event prioritization and that of the
// SimpleEventPlugin. This complicates things slightly, but the aim is to reduce code
// duplication (for which there would be quite a bit). For the events that are not needed
// for the SimpleEventPlugin (otherDiscreteEvents) we process them separately as an
// array of top level events.
// Lastly, we ignore prettier so we can keep the formatting sane.
// prettier-ignore

var discreteEventPairsForSimpleEventPlugin = ['cancel', 'cancel', 'click', 'click', 'close', 'close', 'contextmenu', 'contextMenu', 'copy', 'copy', 'cut', 'cut', 'auxclick', 'auxClick', 'dblclick', 'doubleClick', // Careful!
'dragend', 'dragEnd', 'dragstart', 'dragStart', 'drop', 'drop', 'focusin', 'focus', // Careful!
'focusout', 'blur', // Careful!
'input', 'input', 'invalid', 'invalid', 'keydown', 'keyDown', 'keypress', 'keyPress', 'keyup', 'keyUp', 'mousedown', 'mouseDown', 'mouseup', 'mouseUp', 'paste', 'paste', 'pause', 'pause', 'play', 'play', 'pointercancel', 'pointerCancel', 'pointerdown', 'pointerDown', 'pointerup', 'pointerUp', 'ratechange', 'rateChange', 'reset', 'reset', 'seeked', 'seeked', 'submit', 'submit', 'touchcancel', 'touchCancel', 'touchend', 'touchEnd', 'touchstart', 'touchStart', 'volumechange', 'volumeChange'];
var otherDiscreteEvents = ['change', 'selectionchange', 'textInput', 'compositionstart', 'compositionend', 'compositionupdate'];


var userBlockingPairsForSimpleEventPlugin = ['drag', 'drag', 'dragenter', 'dragEnter', 'dragexit', 'dragExit', 'dragleave', 'dragLeave', 'dragover', 'dragOver', 'mousemove', 'mouseMove', 'mouseout', 'mouseOut', 'mouseover', 'mouseOver', 'pointermove', 'pointerMove', 'pointerout', 'pointerOut', 'pointerover', 'pointerOver', 'scroll', 'scroll', 'toggle', 'toggle', 'touchmove', 'touchMove', 'wheel', 'wheel']; // prettier-ignore

var continuousPairsForSimpleEventPlugin = ['abort', 'abort', ANIMATION_END, 'animationEnd', ANIMATION_ITERATION, 'animationIteration', ANIMATION_START, 'animationStart', 'canplay', 'canPlay', 'canplaythrough', 'canPlayThrough', 'durationchange', 'durationChange', 'emptied', 'emptied', 'encrypted', 'encrypted', 'ended', 'ended', 'error', 'error', 'gotpointercapture', 'gotPointerCapture', 'load', 'load', 'loadeddata', 'loadedData', 'loadedmetadata', 'loadedMetadata', 'loadstart', 'loadStart', 'lostpointercapture', 'lostPointerCapture', 'playing', 'playing', 'progress', 'progress', 'seeking', 'seeking', 'stalled', 'stalled', 'suspend', 'suspend', 'timeupdate', 'timeUpdate', TRANSITION_END, 'transitionEnd', 'waiting', 'waiting'];
/**
 * Turns
 * ['abort', ...]
 *
 * into
 *
 * topLevelEventsToReactNames = new Map([
 *   ['abort', 'onAbort'],
 * ]);
 *
 * and registers them.
 */

function registerSimplePluginEventsAndSetTheirPriorities(eventTypes, priority) {
  // As the event types are in pairs of two, we need to iterate
  // through in twos. The events are in pairs of two to save code
  // and improve init perf of processing this array, as it will
  // result in far fewer object allocations and property accesses
  // if we only use three arrays to process all the categories of
  // instead of tuples.
  for (var i = 0; i < eventTypes.length; i += 2) {
    var topEvent = eventTypes[i];
    var event = eventTypes[i + 1];
    var capitalizedEvent = event[0].toUpperCase() + event.slice(1);
    var reactName = 'on' + capitalizedEvent;
    eventPriorities.set(topEvent, priority);
    topLevelEventsToReactNames.set(topEvent, reactName);
    registerTwoPhaseEvent(reactName, [topEvent]);
  }
}

function setEventPriorities(eventTypes, priority) {
  for (var i = 0; i < eventTypes.length; i++) {
    eventPriorities.set(eventTypes[i], priority);
  }
}

function getEventPriorityForPluginSystem(domEventName) {
  var priority = eventPriorities.get(domEventName); // Default to a ContinuousEvent. Note: we might
  // want to warn if we can't detect the priority
  // for the event.

  return priority === undefined ? ContinuousEvent : priority;
}
function registerSimpleEvents() {
  registerSimplePluginEventsAndSetTheirPriorities(discreteEventPairsForSimpleEventPlugin, DiscreteEvent);
  registerSimplePluginEventsAndSetTheirPriorities(userBlockingPairsForSimpleEventPlugin, UserBlockingEvent);
  registerSimplePluginEventsAndSetTheirPriorities(continuousPairsForSimpleEventPlugin, ContinuousEvent);
  setEventPriorities(otherDiscreteEvents, DiscreteEvent);
}

var Scheduler_now = Scheduler.unstable_now;

{
  // Provide explicit error message when production+profiling bundle of e.g.
  // react-dom is used with production (non-profiling) bundle of
  // scheduler/tracing
  if (!(tracing.__interactionsRef != null && tracing.__interactionsRef.current != null)) {
    {
      throw Error( "It is not supported to run the profiling version of a renderer (for example, `react-dom/profiling`) without also replacing the `scheduler/tracing` module with `scheduler/tracing-profiling`. Your bundler might have a setting for aliasing both modules. Learn more at https://reactjs.org/link/profiling" );
    }
  }
}
// ascending numbers so we can compare them like numbers. They start at 90 to
// avoid clashing with Scheduler's priorities.

var ImmediatePriority = 99;
var UserBlockingPriority = 98;
var NormalPriority = 97;
var LowPriority = 96;
var IdlePriority = 95; // NoPriority is the absence of priority. Also React-only.

var NoPriority = 90;
var initialTimeMs = Scheduler_now(); // If the initial timestamp is reasonably small, use Scheduler's `now` directly.

var SyncLanePriority = 15;
var SyncBatchedLanePriority = 14;
var InputDiscreteHydrationLanePriority = 13;
var InputDiscreteLanePriority = 12;
var InputContinuousHydrationLanePriority = 11;
var InputContinuousLanePriority = 10;
var DefaultHydrationLanePriority = 9;
var DefaultLanePriority = 8;
var TransitionHydrationPriority = 7;
var TransitionPriority = 6;
var RetryLanePriority = 5;
var SelectiveHydrationLanePriority = 4;
var IdleHydrationLanePriority = 3;
var IdleLanePriority = 2;
var OffscreenLanePriority = 1;
var NoLanePriority = 0;
var TotalLanes = 31;
var NoLanes =
/*                        */
0;
var NoLane =
/*                          */
0;
var SyncLane =
/*                        */
1;
var SyncBatchedLane =
/*                 */
2;
var InputDiscreteHydrationLane =
/*      */
4;
var InputDiscreteLanes =
/*                    */
24;
var InputContinuousHydrationLane =
/*           */
32;
var InputContinuousLanes =
/*                  */
192;
var DefaultHydrationLane =
/*            */
256;
var DefaultLanes =
/*                   */
3584;
var TransitionHydrationLane =
/*                */
4096;
var TransitionLanes =
/*                       */
4186112;
var RetryLanes =
/*                            */
62914560;
var SomeRetryLane =
/*                  */
33554432;
var SelectiveHydrationLane =
/*          */
67108864;
var NonIdleLanes =
/*                                 */
134217727;
var IdleHydrationLane =
/*               */
134217728;
var IdleLanes =
/*                             */
805306368;
var OffscreenLane =
/*                   */
1073741824;
var NoTimestamp = -1;
function setCurrentUpdateLanePriority(newLanePriority) {
} // "Registers" used to "return" multiple values
// Used by getHighestPriorityLanes and getNextLanes:

var return_highestLanePriority = DefaultLanePriority;

function getHighestPriorityLanes(lanes) {
  if ((SyncLane & lanes) !== NoLanes) {
    return_highestLanePriority = SyncLanePriority;
    return SyncLane;
  }

  if ((SyncBatchedLane & lanes) !== NoLanes) {
    return_highestLanePriority = SyncBatchedLanePriority;
    return SyncBatchedLane;
  }

  if ((InputDiscreteHydrationLane & lanes) !== NoLanes) {
    return_highestLanePriority = InputDiscreteHydrationLanePriority;
    return InputDiscreteHydrationLane;
  }

  var inputDiscreteLanes = InputDiscreteLanes & lanes;

  if (inputDiscreteLanes !== NoLanes) {
    return_highestLanePriority = InputDiscreteLanePriority;
    return inputDiscreteLanes;
  }

  if ((lanes & InputContinuousHydrationLane) !== NoLanes) {
    return_highestLanePriority = InputContinuousHydrationLanePriority;
    return InputContinuousHydrationLane;
  }

  var inputContinuousLanes = InputContinuousLanes & lanes;

  if (inputContinuousLanes !== NoLanes) {
    return_highestLanePriority = InputContinuousLanePriority;
    return inputContinuousLanes;
  }

  if ((lanes & DefaultHydrationLane) !== NoLanes) {
    return_highestLanePriority = DefaultHydrationLanePriority;
    return DefaultHydrationLane;
  }

  var defaultLanes = DefaultLanes & lanes;

  if (defaultLanes !== NoLanes) {
    return_highestLanePriority = DefaultLanePriority;
    return defaultLanes;
  }

  if ((lanes & TransitionHydrationLane) !== NoLanes) {
    return_highestLanePriority = TransitionHydrationPriority;
    return TransitionHydrationLane;
  }

  var transitionLanes = TransitionLanes & lanes;

  if (transitionLanes !== NoLanes) {
    return_highestLanePriority = TransitionPriority;
    return transitionLanes;
  }

  var retryLanes = RetryLanes & lanes;

  if (retryLanes !== NoLanes) {
    return_highestLanePriority = RetryLanePriority;
    return retryLanes;
  }

  if (lanes & SelectiveHydrationLane) {
    return_highestLanePriority = SelectiveHydrationLanePriority;
    return SelectiveHydrationLane;
  }

  if ((lanes & IdleHydrationLane) !== NoLanes) {
    return_highestLanePriority = IdleHydrationLanePriority;
    return IdleHydrationLane;
  }

  var idleLanes = IdleLanes & lanes;

  if (idleLanes !== NoLanes) {
    return_highestLanePriority = IdleLanePriority;
    return idleLanes;
  }

  if ((OffscreenLane & lanes) !== NoLanes) {
    return_highestLanePriority = OffscreenLanePriority;
    return OffscreenLane;
  }

  {
    error('Should have found matching lanes. This is a bug in React.');
  } // This shouldn't be reachable, but as a fallback, return the entire bitmask.


  return_highestLanePriority = DefaultLanePriority;
  return lanes;
}

function schedulerPriorityToLanePriority(schedulerPriorityLevel) {
  switch (schedulerPriorityLevel) {
    case ImmediatePriority:
      return SyncLanePriority;

    case UserBlockingPriority:
      return InputContinuousLanePriority;

    case NormalPriority:
    case LowPriority:
      // TODO: Handle LowSchedulerPriority, somehow. Maybe the same lane as hydration.
      return DefaultLanePriority;

    case IdlePriority:
      return IdleLanePriority;

    default:
      return NoLanePriority;
  }
}
function lanePriorityToSchedulerPriority(lanePriority) {
  switch (lanePriority) {
    case SyncLanePriority:
    case SyncBatchedLanePriority:
      return ImmediatePriority;

    case InputDiscreteHydrationLanePriority:
    case InputDiscreteLanePriority:
    case InputContinuousHydrationLanePriority:
    case InputContinuousLanePriority:
      return UserBlockingPriority;

    case DefaultHydrationLanePriority:
    case DefaultLanePriority:
    case TransitionHydrationPriority:
    case TransitionPriority:
    case SelectiveHydrationLanePriority:
    case RetryLanePriority:
      return NormalPriority;

    case IdleHydrationLanePriority:
    case IdleLanePriority:
    case OffscreenLanePriority:
      return IdlePriority;

    case NoLanePriority:
      return NoPriority;

    default:
      {
        {
          throw Error( "Invalid update priority: " + lanePriority + ". This is a bug in React." );
        }
      }

  }
}
function getNextLanes(root, wipLanes) {
  // Early bailout if there's no pending work left.
  var pendingLanes = root.pendingLanes;

  if (pendingLanes === NoLanes) {
    return_highestLanePriority = NoLanePriority;
    return NoLanes;
  }

  var nextLanes = NoLanes;
  var nextLanePriority = NoLanePriority;
  var expiredLanes = root.expiredLanes;
  var suspendedLanes = root.suspendedLanes;
  var pingedLanes = root.pingedLanes; // Check if any work has expired.

  if (expiredLanes !== NoLanes) {
    nextLanes = expiredLanes;
    nextLanePriority = return_highestLanePriority = SyncLanePriority;
  } else {
    // Do not work on any idle work until all the non-idle work has finished,
    // even if the work is suspended.
    var nonIdlePendingLanes = pendingLanes & NonIdleLanes;

    if (nonIdlePendingLanes !== NoLanes) {
      var nonIdleUnblockedLanes = nonIdlePendingLanes & ~suspendedLanes;

      if (nonIdleUnblockedLanes !== NoLanes) {
        nextLanes = getHighestPriorityLanes(nonIdleUnblockedLanes);
        nextLanePriority = return_highestLanePriority;
      } else {
        var nonIdlePingedLanes = nonIdlePendingLanes & pingedLanes;

        if (nonIdlePingedLanes !== NoLanes) {
          nextLanes = getHighestPriorityLanes(nonIdlePingedLanes);
          nextLanePriority = return_highestLanePriority;
        }
      }
    } else {
      // The only remaining work is Idle.
      var unblockedLanes = pendingLanes & ~suspendedLanes;

      if (unblockedLanes !== NoLanes) {
        nextLanes = getHighestPriorityLanes(unblockedLanes);
        nextLanePriority = return_highestLanePriority;
      } else {
        if (pingedLanes !== NoLanes) {
          nextLanes = getHighestPriorityLanes(pingedLanes);
          nextLanePriority = return_highestLanePriority;
        }
      }
    }
  }

  if (nextLanes === NoLanes) {
    // This should only be reachable if we're suspended
    // TODO: Consider warning in this path if a fallback timer is not scheduled.
    return NoLanes;
  } // If there are higher priority lanes, we'll include them even if they
  // are suspended.


  nextLanes = pendingLanes & getEqualOrHigherPriorityLanes(nextLanes); // If we're already in the middle of a render, switching lanes will interrupt
  // it and we'll lose our progress. We should only do this if the new lanes are
  // higher priority.

  if (wipLanes !== NoLanes && wipLanes !== nextLanes && // If we already suspended with a delay, then interrupting is fine. Don't
  // bother waiting until the root is complete.
  (wipLanes & suspendedLanes) === NoLanes) {
    getHighestPriorityLanes(wipLanes);
    var wipLanePriority = return_highestLanePriority;

    if (nextLanePriority <= wipLanePriority) {
      return wipLanes;
    } else {
      return_highestLanePriority = nextLanePriority;
    }
  } // Check for entangled lanes and add them to the batch.
  //
  // A lane is said to be entangled with another when it's not allowed to render
  // in a batch that does not also include the other lane. Typically we do this
  // when multiple updates have the same source, and we only want to respond to
  // the most recent event from that source.
  //
  // Note that we apply entanglements *after* checking for partial work above.
  // This means that if a lane is entangled during an interleaved event while
  // it's already rendering, we won't interrupt it. This is intentional, since
  // entanglement is usually "best effort": we'll try our best to render the
  // lanes in the same batch, but it's not worth throwing out partially
  // completed work in order to do it.
  //
  // For those exceptions where entanglement is semantically important, like
  // useMutableSource, we should ensure that there is no partial work at the
  // time we apply the entanglement.


  var entangledLanes = root.entangledLanes;

  if (entangledLanes !== NoLanes) {
    var entanglements = root.entanglements;
    var lanes = nextLanes & entangledLanes;

    while (lanes > 0) {
      var index = pickArbitraryLaneIndex(lanes);
      var lane = 1 << index;
      nextLanes |= entanglements[index];
      lanes &= ~lane;
    }
  }

  return nextLanes;
}
function getMostRecentEventTime(root, lanes) {
  var eventTimes = root.eventTimes;
  var mostRecentEventTime = NoTimestamp;

  while (lanes > 0) {
    var index = pickArbitraryLaneIndex(lanes);
    var lane = 1 << index;
    var eventTime = eventTimes[index];

    if (eventTime > mostRecentEventTime) {
      mostRecentEventTime = eventTime;
    }

    lanes &= ~lane;
  }

  return mostRecentEventTime;
}

function computeExpirationTime(lane, currentTime) {
  // TODO: Expiration heuristic is constant per lane, so could use a map.
  getHighestPriorityLanes(lane);
  var priority = return_highestLanePriority;

  if (priority >= InputContinuousLanePriority) {
    // User interactions should expire slightly more quickly.
    //
    // NOTE: This is set to the corresponding constant as in Scheduler.js. When
    // we made it larger, a product metric in www regressed, suggesting there's
    // a user interaction that's being starved by a series of synchronous
    // updates. If that theory is correct, the proper solution is to fix the
    // starvation. However, this scenario supports the idea that expiration
    // times are an important safeguard when starvation does happen.
    //
    // Also note that, in the case of user input specifically, this will soon no
    // longer be an issue because we plan to make user input synchronous by
    // default (until you enter `startTransition`, of course.)
    //
    // If weren't planning to make these updates synchronous soon anyway, I
    // would probably make this number a configurable parameter.
    return currentTime + 250;
  } else if (priority >= TransitionPriority) {
    return currentTime + 5000;
  } else {
    // Anything idle priority or lower should never expire.
    return NoTimestamp;
  }
}

function markStarvedLanesAsExpired(root, currentTime) {
  // TODO: This gets called every time we yield. We can optimize by storing
  // the earliest expiration time on the root. Then use that to quickly bail out
  // of this function.
  var pendingLanes = root.pendingLanes;
  var suspendedLanes = root.suspendedLanes;
  var pingedLanes = root.pingedLanes;
  var expirationTimes = root.expirationTimes; // Iterate through the pending lanes and check if we've reached their
  // expiration time. If so, we'll assume the update is being starved and mark
  // it as expired to force it to finish.

  var lanes = pendingLanes;

  while (lanes > 0) {
    var index = pickArbitraryLaneIndex(lanes);
    var lane = 1 << index;
    var expirationTime = expirationTimes[index];

    if (expirationTime === NoTimestamp) {
      // Found a pending lane with no expiration time. If it's not suspended, or
      // if it's pinged, assume it's CPU-bound. Compute a new expiration time
      // using the current time.
      if ((lane & suspendedLanes) === NoLanes || (lane & pingedLanes) !== NoLanes) {
        // Assumes timestamps are monotonically increasing.
        expirationTimes[index] = computeExpirationTime(lane, currentTime);
      }
    } else if (expirationTime <= currentTime) {
      // This lane expired
      root.expiredLanes |= lane;
    }

    lanes &= ~lane;
  }
} // This returns the highest priority pending lanes regardless of whether they
function getLanesToRetrySynchronouslyOnError(root) {
  var everythingButOffscreen = root.pendingLanes & ~OffscreenLane;

  if (everythingButOffscreen !== NoLanes) {
    return everythingButOffscreen;
  }

  if (everythingButOffscreen & OffscreenLane) {
    return OffscreenLane;
  }

  return NoLanes;
}
function returnNextLanesPriority() {
  return return_highestLanePriority;
}
function includesNonIdleWork(lanes) {
  return (lanes & NonIdleLanes) !== NoLanes;
}
function includesOnlyRetries(lanes) {
  return (lanes & RetryLanes) === lanes;
}
function includesOnlyTransitions(lanes) {
  return (lanes & TransitionLanes) === lanes;
} // To ensure consistency across multiple updates in the same event, this should
// be a pure function, so that it always returns the same lane for given inputs.

function findUpdateLane(lanePriority, wipLanes) {
  switch (lanePriority) {
    case NoLanePriority:
      break;

    case SyncLanePriority:
      return SyncLane;

    case SyncBatchedLanePriority:
      return SyncBatchedLane;

    case InputDiscreteLanePriority:
      {
        var _lane = pickArbitraryLane(InputDiscreteLanes & ~wipLanes);

        if (_lane === NoLane) {
          // Shift to the next priority level
          return findUpdateLane(InputContinuousLanePriority, wipLanes);
        }

        return _lane;
      }

    case InputContinuousLanePriority:
      {
        var _lane2 = pickArbitraryLane(InputContinuousLanes & ~wipLanes);

        if (_lane2 === NoLane) {
          // Shift to the next priority level
          return findUpdateLane(DefaultLanePriority, wipLanes);
        }

        return _lane2;
      }

    case DefaultLanePriority:
      {
        var _lane3 = pickArbitraryLane(DefaultLanes & ~wipLanes);

        if (_lane3 === NoLane) {
          // If all the default lanes are already being worked on, look for a
          // lane in the transition range.
          _lane3 = pickArbitraryLane(TransitionLanes & ~wipLanes);

          if (_lane3 === NoLane) {
            // All the transition lanes are taken, too. This should be very
            // rare, but as a last resort, pick a default lane. This will have
            // the effect of interrupting the current work-in-progress render.
            _lane3 = pickArbitraryLane(DefaultLanes);
          }
        }

        return _lane3;
      }

    case TransitionPriority: // Should be handled by findTransitionLane instead

    case RetryLanePriority:
      // Should be handled by findRetryLane instead
      break;

    case IdleLanePriority:
      var lane = pickArbitraryLane(IdleLanes & ~wipLanes);

      if (lane === NoLane) {
        lane = pickArbitraryLane(IdleLanes);
      }

      return lane;
  }

  {
    {
      throw Error( "Invalid update priority: " + lanePriority + ". This is a bug in React." );
    }
  }
} // To ensure consistency across multiple updates in the same event, this should
// be pure function, so that it always returns the same lane for given inputs.

function findTransitionLane(wipLanes, pendingLanes) {
  // First look for lanes that are completely unclaimed, i.e. have no
  // pending work.
  var lane = pickArbitraryLane(TransitionLanes & ~pendingLanes);

  if (lane === NoLane) {
    // If all lanes have pending work, look for a lane that isn't currently
    // being worked on.
    lane = pickArbitraryLane(TransitionLanes & ~wipLanes);

    if (lane === NoLane) {
      // If everything is being worked on, pick any lane. This has the
      // effect of interrupting the current work-in-progress.
      lane = pickArbitraryLane(TransitionLanes);
    }
  }

  return lane;
} // To ensure consistency across multiple updates in the same event, this should
// be pure function, so that it always returns the same lane for given inputs.

function findRetryLane(wipLanes) {
  // This is a fork of `findUpdateLane` designed specifically for Suspense
  // "retries" — a special update that attempts to flip a Suspense boundary
  // from its placeholder state to its primary/resolved state.
  var lane = pickArbitraryLane(RetryLanes & ~wipLanes);

  if (lane === NoLane) {
    lane = pickArbitraryLane(RetryLanes);
  }

  return lane;
}

function getHighestPriorityLane(lanes) {
  return lanes & -lanes;
}

function getLowestPriorityLane(lanes) {
  // This finds the most significant non-zero bit.
  var index = 31 - clz32(lanes);
  return index < 0 ? NoLanes : 1 << index;
}

function getEqualOrHigherPriorityLanes(lanes) {
  return (getLowestPriorityLane(lanes) << 1) - 1;
}

function pickArbitraryLane(lanes) {
  // This wrapper function gets inlined. Only exists so to communicate that it
  // doesn't matter which bit is selected; you can pick any bit without
  // affecting the algorithms where its used. Here I'm using
  // getHighestPriorityLane because it requires the fewest operations.
  return getHighestPriorityLane(lanes);
}

function pickArbitraryLaneIndex(lanes) {
  return 31 - clz32(lanes);
}

function laneToIndex(lane) {
  return pickArbitraryLaneIndex(lane);
}

function includesSomeLane(a, b) {
  return (a & b) !== NoLanes;
}
function isSubsetOfLanes(set, subset) {
  return (set & subset) === subset;
}
function mergeLanes(a, b) {
  return a | b;
}
function removeLanes(set, subset) {
  return set & ~subset;
} // Seems redundant, but it changes the type from a single lane (used for
// updates) to a group of lanes (used for flushing work).

function laneToLanes(lane) {
  return lane;
}
function higherPriorityLane(a, b) {
  // This works because the bit ranges decrease in priority as you go left.
  return a !== NoLane && a < b ? a : b;
}
function createLaneMap(initial) {
  // Intentionally pushing one by one.
  // https://v8.dev/blog/elements-kinds#avoid-creating-holes
  var laneMap = [];

  for (var i = 0; i < TotalLanes; i++) {
    laneMap.push(initial);
  }

  return laneMap;
}
function markRootUpdated(root, updateLane, eventTime) {
  root.pendingLanes |= updateLane; // TODO: Theoretically, any update to any lane can unblock any other lane. But
  // it's not practical to try every single possible combination. We need a
  // heuristic to decide which lanes to attempt to render, and in which batches.
  // For now, we use the same heuristic as in the old ExpirationTimes model:
  // retry any lane at equal or lower priority, but don't try updates at higher
  // priority without also including the lower priority updates. This works well
  // when considering updates across different priority levels, but isn't
  // sufficient for updates within the same priority, since we want to treat
  // those updates as parallel.
  // Unsuspend any update at equal or lower priority.

  var higherPriorityLanes = updateLane - 1; // Turns 0b1000 into 0b0111

  root.suspendedLanes &= higherPriorityLanes;
  root.pingedLanes &= higherPriorityLanes;
  var eventTimes = root.eventTimes;
  var index = laneToIndex(updateLane); // We can always overwrite an existing timestamp because we prefer the most
  // recent event, and we assume time is monotonically increasing.

  eventTimes[index] = eventTime;
}
function markRootSuspended(root, suspendedLanes) {
  root.suspendedLanes |= suspendedLanes;
  root.pingedLanes &= ~suspendedLanes; // The suspended lanes are no longer CPU-bound. Clear their expiration times.

  var expirationTimes = root.expirationTimes;
  var lanes = suspendedLanes;

  while (lanes > 0) {
    var index = pickArbitraryLaneIndex(lanes);
    var lane = 1 << index;
    expirationTimes[index] = NoTimestamp;
    lanes &= ~lane;
  }
}
function markRootPinged(root, pingedLanes, eventTime) {
  root.pingedLanes |= root.suspendedLanes & pingedLanes;
}
function markDiscreteUpdatesExpired(root) {
  root.expiredLanes |= InputDiscreteLanes & root.pendingLanes;
}
function hasDiscreteLanes(lanes) {
  return (lanes & InputDiscreteLanes) !== NoLanes;
}
function markRootMutableRead(root, updateLane) {
  root.mutableReadLanes |= updateLane & root.pendingLanes;
}
function markRootFinished(root, remainingLanes) {
  var noLongerPendingLanes = root.pendingLanes & ~remainingLanes;
  root.pendingLanes = remainingLanes; // Let's try everything again

  root.suspendedLanes = 0;
  root.pingedLanes = 0;
  root.expiredLanes &= remainingLanes;
  root.mutableReadLanes &= remainingLanes;
  root.entangledLanes &= remainingLanes;
  var entanglements = root.entanglements;
  var eventTimes = root.eventTimes;
  var expirationTimes = root.expirationTimes; // Clear the lanes that no longer have pending work

  var lanes = noLongerPendingLanes;

  while (lanes > 0) {
    var index = pickArbitraryLaneIndex(lanes);
    var lane = 1 << index;
    entanglements[index] = NoLanes;
    eventTimes[index] = NoTimestamp;
    expirationTimes[index] = NoTimestamp;
    lanes &= ~lane;
  }
}
function markRootEntangled(root, entangledLanes) {
  root.entangledLanes |= entangledLanes;
  var entanglements = root.entanglements;
  var lanes = entangledLanes;

  while (lanes > 0) {
    var index = pickArbitraryLaneIndex(lanes);
    var lane = 1 << index;
    entanglements[index] |= entangledLanes;
    lanes &= ~lane;
  }
}
var clz32 = Math.clz32 ? Math.clz32 : clz32Fallback; // Count leading zeros. Only used on lanes, so assume input is an integer.
// Based on:
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Math/clz32

var log = Math.log;
var LN2 = Math.LN2;

function clz32Fallback(lanes) {
  if (lanes === 0) {
    return 32;
  }

  return 31 - (log(lanes) / LN2 | 0) | 0;
}

// Intentionally not named imports because Rollup would use dynamic dispatch for
var UserBlockingPriority$1 = Scheduler.unstable_UserBlockingPriority,
    runWithPriority = Scheduler.unstable_runWithPriority; // TODO: can we stop exporting these?

var _enabled = true; // This is exported in FB builds for use by legacy FB layer infra.
// We'd like to remove this but it's not clear if this is safe.

function setEnabled(enabled) {
  _enabled = !!enabled;
}
function isEnabled() {
  return _enabled;
}
function createEventListenerWrapperWithPriority(targetContainer, domEventName, eventSystemFlags) {
  var eventPriority = getEventPriorityForPluginSystem(domEventName);
  var listenerWrapper;

  switch (eventPriority) {
    case DiscreteEvent:
      listenerWrapper = dispatchDiscreteEvent;
      break;

    case UserBlockingEvent:
      listenerWrapper = dispatchUserBlockingUpdate;
      break;

    case ContinuousEvent:
    default:
      listenerWrapper = dispatchEvent;
      break;
  }

  return listenerWrapper.bind(null, domEventName, eventSystemFlags, targetContainer);
}

function dispatchDiscreteEvent(domEventName, eventSystemFlags, container, nativeEvent) {
  {
    flushDiscreteUpdatesIfNeeded(nativeEvent.timeStamp);
  }

  discreteUpdates(dispatchEvent, domEventName, eventSystemFlags, container, nativeEvent);
}

function dispatchUserBlockingUpdate(domEventName, eventSystemFlags, container, nativeEvent) {
  {
    runWithPriority(UserBlockingPriority$1, dispatchEvent.bind(null, domEventName, eventSystemFlags, container, nativeEvent));
  }
}

function dispatchEvent(domEventName, eventSystemFlags, targetContainer, nativeEvent) {
  if (!_enabled) {
    return;
  }

  var allowReplay = true;

  {
    // TODO: replaying capture phase events is currently broken
    // because we used to do it during top-level native bubble handlers
    // but now we use different bubble and capture handlers.
    // In eager mode, we attach capture listeners early, so we need
    // to filter them out until we fix the logic to handle them correctly.
    // This could've been outside the flag but I put it inside to reduce risk.
    allowReplay = (eventSystemFlags & IS_CAPTURE_PHASE) === 0;
  }

  if (allowReplay && hasQueuedDiscreteEvents() && isReplayableDiscreteEvent(domEventName)) {
    // If we already have a queue of discrete events, and this is another discrete
    // event, then we can't dispatch it regardless of its target, since they
    // need to dispatch in order.
    queueDiscreteEvent(null, // Flags that we're not actually blocked on anything as far as we know.
    domEventName, eventSystemFlags, targetContainer, nativeEvent);
    return;
  }

  var blockedOn = attemptToDispatchEvent(domEventName, eventSystemFlags, targetContainer, nativeEvent);

  if (blockedOn === null) {
    // We successfully dispatched this event.
    if (allowReplay) {
      clearIfContinuousEvent(domEventName, nativeEvent);
    }

    return;
  }

  if (allowReplay) {
    if (isReplayableDiscreteEvent(domEventName)) {
      // This this to be replayed later once the target is available.
      queueDiscreteEvent(blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent);
      return;
    }

    if (queueIfContinuousEvent(blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent)) {
      return;
    } // We need to clear only if we didn't queue because
    // queueing is accummulative.


    clearIfContinuousEvent(domEventName, nativeEvent);
  } // This is not replayable so we'll invoke it but without a target,
  // in case the event system needs to trace it.


  dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, null, targetContainer);
} // Attempt dispatching an event. Returns a SuspenseInstance or Container if it's blocked.

function attemptToDispatchEvent(domEventName, eventSystemFlags, targetContainer, nativeEvent) {
  // TODO: Warn if _enabled is false.
  var nativeEventTarget = getEventTarget(nativeEvent);
  var targetInst = getClosestInstanceFromNode(nativeEventTarget);

  if (targetInst !== null) {
    var nearestMounted = getNearestMountedFiber(targetInst);

    if (nearestMounted === null) {
      // This tree has been unmounted already. Dispatch without a target.
      targetInst = null;
    } else {
      var tag = nearestMounted.tag;

      if (tag === SuspenseComponent) {
        var instance = getSuspenseInstanceFromFiber(nearestMounted);

        if (instance !== null) {
          // Queue the event to be replayed later. Abort dispatching since we
          // don't want this event dispatched twice through the event system.
          // TODO: If this is the first discrete event in the queue. Schedule an increased
          // priority for this boundary.
          return instance;
        } // This shouldn't happen, something went wrong but to avoid blocking
        // the whole system, dispatch the event without a target.
        // TODO: Warn.


        targetInst = null;
      } else if (tag === HostRoot) {
        var root = nearestMounted.stateNode;

        if (root.hydrate) {
          // If this happens during a replay something went wrong and it might block
          // the whole system.
          return getContainerFromFiber(nearestMounted);
        }

        targetInst = null;
      } else if (nearestMounted !== targetInst) {
        // If we get an event (ex: img onload) before committing that
        // component's mount, ignore it for now (that is, treat it as if it was an
        // event on a non-React tree). We might also consider queueing events and
        // dispatching them after the mount.
        targetInst = null;
      }
    }
  }

  dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, targetInst, targetContainer); // We're not blocked on anything.

  return null;
}

function addEventBubbleListener(target, eventType, listener) {
  target.addEventListener(eventType, listener, false);
  return listener;
}
function addEventCaptureListener(target, eventType, listener) {
  target.addEventListener(eventType, listener, true);
  return listener;
}
function addEventCaptureListenerWithPassiveFlag(target, eventType, listener, passive) {
  target.addEventListener(eventType, listener, {
    capture: true,
    passive: passive
  });
  return listener;
}
function addEventBubbleListenerWithPassiveFlag(target, eventType, listener, passive) {
  target.addEventListener(eventType, listener, {
    passive: passive
  });
  return listener;
}

/**
 * These variables store information about text content of a target node,
 * allowing comparison of content before and after a given event.
 *
 * Identify the node where selection currently begins, then observe
 * both its text content and its current position in the DOM. Since the
 * browser may natively replace the target node during composition, we can
 * use its position to find its replacement.
 *
 *
 */
var root = null;
var startText = null;
var fallbackText = null;
function initialize(nativeEventTarget) {
  root = nativeEventTarget;
  startText = getText();
  return true;
}
function reset() {
  root = null;
  startText = null;
  fallbackText = null;
}
function getData() {
  if (fallbackText) {
    return fallbackText;
  }

  var start;
  var startValue = startText;
  var startLength = startValue.length;
  var end;
  var endValue = getText();
  var endLength = endValue.length;

  for (start = 0; start < startLength; start++) {
    if (startValue[start] !== endValue[start]) {
      break;
    }
  }

  var minEnd = startLength - start;

  for (end = 1; end <= minEnd; end++) {
    if (startValue[startLength - end] !== endValue[endLength - end]) {
      break;
    }
  }

  var sliceTail = end > 1 ? 1 - end : undefined;
  fallbackText = endValue.slice(start, sliceTail);
  return fallbackText;
}
function getText() {
  if ('value' in root) {
    return root.value;
  }

  return root.textContent;
}

/**
 * `charCode` represents the actual "character code" and is safe to use with
 * `String.fromCharCode`. As such, only keys that correspond to printable
 * characters produce a valid `charCode`, the only exception to this is Enter.
 * The Tab-key is considered non-printable and does not have a `charCode`,
 * presumably because it does not produce a tab-character in browsers.
 *
 * @param {object} nativeEvent Native browser event.
 * @return {number} Normalized `charCode` property.
 */
function getEventCharCode(nativeEvent) {
  var charCode;
  var keyCode = nativeEvent.keyCode;

  if ('charCode' in nativeEvent) {
    charCode = nativeEvent.charCode; // FF does not set `charCode` for the Enter-key, check against `keyCode`.

    if (charCode === 0 && keyCode === 13) {
      charCode = 13;
    }
  } else {
    // IE8 does not implement `charCode`, but `keyCode` has the correct value.
    charCode = keyCode;
  } // IE and Edge (on Windows) and Chrome / Safari (on Windows and Linux)
  // report Enter as charCode 10 when ctrl is pressed.


  if (charCode === 10) {
    charCode = 13;
  } // Some non-printable keys are reported in `charCode`/`keyCode`, discard them.
  // Must not discard the (non-)printable Enter-key.


  if (charCode >= 32 || charCode === 13) {
    return charCode;
  }

  return 0;
}

function functionThatReturnsTrue() {
  return true;
}

function functionThatReturnsFalse() {
  return false;
} // This is intentionally a factory so that we have different returned constructors.
// If we had a single constructor, it would be megamorphic and engines would deopt.


function createSyntheticEvent(Interface) {
  /**
   * Synthetic events are dispatched by event plugins, typically in response to a
   * top-level event delegation handler.
   *
   * These systems should generally use pooling to reduce the frequency of garbage
   * collection. The system should check `isPersistent` to determine whether the
   * event should be released into the pool after being dispatched. Users that
   * need a persisted event should invoke `persist`.
   *
   * Synthetic events (and subclasses) implement the DOM Level 3 Events API by
   * normalizing browser quirks. Subclasses do not necessarily have to implement a
   * DOM interface; custom application-specific events can also subclass this.
   */
  function SyntheticBaseEvent(reactName, reactEventType, targetInst, nativeEvent, nativeEventTarget) {
    this._reactName = reactName;
    this._targetInst = targetInst;
    this.type = reactEventType;
    this.nativeEvent = nativeEvent;
    this.target = nativeEventTarget;
    this.currentTarget = null;

    for (var _propName in Interface) {
      if (!Interface.hasOwnProperty(_propName)) {
        continue;
      }

      var normalize = Interface[_propName];

      if (normalize) {
        this[_propName] = normalize(nativeEvent);
      } else {
        this[_propName] = nativeEvent[_propName];
      }
    }

    var defaultPrevented = nativeEvent.defaultPrevented != null ? nativeEvent.defaultPrevented : nativeEvent.returnValue === false;

    if (defaultPrevented) {
      this.isDefaultPrevented = functionThatReturnsTrue;
    } else {
      this.isDefaultPrevented = functionThatReturnsFalse;
    }

    this.isPropagationStopped = functionThatReturnsFalse;
    return this;
  }

  _assign(SyntheticBaseEvent.prototype, {
    preventDefault: function () {
      this.defaultPrevented = true;
      var event = this.nativeEvent;

      if (!event) {
        return;
      }

      if (event.preventDefault) {
        event.preventDefault(); // $FlowFixMe - flow is not aware of `unknown` in IE
      } else if (typeof event.returnValue !== 'unknown') {
        event.returnValue = false;
      }

      this.isDefaultPrevented = functionThatReturnsTrue;
    },
    stopPropagation: function () {
      var event = this.nativeEvent;

      if (!event) {
        return;
      }

      if (event.stopPropagation) {
        event.stopPropagation(); // $FlowFixMe - flow is not aware of `unknown` in IE
      } else if (typeof event.cancelBubble !== 'unknown') {
        // The ChangeEventPlugin registers a "propertychange" event for
        // IE. This event does not support bubbling or cancelling, and
        // any references to cancelBubble throw "Member not found".  A
        // typeof check of "unknown" circumvents this issue (and is also
        // IE specific).
        event.cancelBubble = true;
      }

      this.isPropagationStopped = functionThatReturnsTrue;
    },

    /**
     * We release all dispatched `SyntheticEvent`s after each event loop, adding
     * them back into the pool. This allows a way to hold onto a reference that
     * won't be added back into the pool.
     */
    persist: function () {// Modern event system doesn't use pooling.
    },

    /**
     * Checks if this event should be released back into the pool.
     *
     * @return {boolean} True if this should not be released, false otherwise.
     */
    isPersistent: functionThatReturnsTrue
  });

  return SyntheticBaseEvent;
}
/**
 * @interface Event
 * @see http://www.w3.org/TR/DOM-Level-3-Events/
 */


var EventInterface = {
  eventPhase: 0,
  bubbles: 0,
  cancelable: 0,
  timeStamp: function (event) {
    return event.timeStamp || Date.now();
  },
  defaultPrevented: 0,
  isTrusted: 0
};
var SyntheticEvent = createSyntheticEvent(EventInterface);

var UIEventInterface = _assign({}, EventInterface, {
  view: 0,
  detail: 0
});

var SyntheticUIEvent = createSyntheticEvent(UIEventInterface);
var lastMovementX;
var lastMovementY;
var lastMouseEvent;

function updateMouseMovementPolyfillState(event) {
  if (event !== lastMouseEvent) {
    if (lastMouseEvent && event.type === 'mousemove') {
      lastMovementX = event.screenX - lastMouseEvent.screenX;
      lastMovementY = event.screenY - lastMouseEvent.screenY;
    } else {
      lastMovementX = 0;
      lastMovementY = 0;
    }

    lastMouseEvent = event;
  }
}
/**
 * @interface MouseEvent
 * @see http://www.w3.org/TR/DOM-Level-3-Events/
 */


var MouseEventInterface = _assign({}, UIEventInterface, {
  screenX: 0,
  screenY: 0,
  clientX: 0,
  clientY: 0,
  pageX: 0,
  pageY: 0,
  ctrlKey: 0,
  shiftKey: 0,
  altKey: 0,
  metaKey: 0,
  getModifierState: getEventModifierState,
  button: 0,
  buttons: 0,
  relatedTarget: function (event) {
    if (event.relatedTarget === undefined) return event.fromElement === event.srcElement ? event.toElement : event.fromElement;
    return event.relatedTarget;
  },
  movementX: function (event) {
    if ('movementX' in event) {
      return event.movementX;
    }

    updateMouseMovementPolyfillState(event);
    return lastMovementX;
  },
  movementY: function (event) {
    if ('movementY' in event) {
      return event.movementY;
    } // Don't need to call updateMouseMovementPolyfillState() here
    // because it's guaranteed to have already run when movementX
    // was copied.


    return lastMovementY;
  }
});

var SyntheticMouseEvent = createSyntheticEvent(MouseEventInterface);
/**
 * @interface DragEvent
 * @see http://www.w3.org/TR/DOM-Level-3-Events/
 */

var DragEventInterface = _assign({}, MouseEventInterface, {
  dataTransfer: 0
});

var SyntheticDragEvent = createSyntheticEvent(DragEventInterface);
/**
 * @interface FocusEvent
 * @see http://www.w3.org/TR/DOM-Level-3-Events/
 */

var FocusEventInterface = _assign({}, UIEventInterface, {
  relatedTarget: 0
});

var SyntheticFocusEvent = createSyntheticEvent(FocusEventInterface);
/**
 * @interface Event
 * @see http://www.w3.org/TR/css3-animations/#AnimationEvent-interface
 * @see https://developer.mozilla.org/en-US/docs/Web/API/AnimationEvent
 */

var AnimationEventInterface = _assign({}, EventInterface, {
  animationName: 0,
  elapsedTime: 0,
  pseudoElement: 0
});

var SyntheticAnimationEvent = createSyntheticEvent(AnimationEventInterface);
/**
 * @interface Event
 * @see http://www.w3.org/TR/clipboard-apis/
 */

var ClipboardEventInterface = _assign({}, EventInterface, {
  clipboardData: function (event) {
    return 'clipboardData' in event ? event.clipboardData : window.clipboardData;
  }
});

var SyntheticClipboardEvent = createSyntheticEvent(ClipboardEventInterface);
/**
 * @interface Event
 * @see http://www.w3.org/TR/DOM-Level-3-Events/#events-compositionevents
 */

var CompositionEventInterface = _assign({}, EventInterface, {
  data: 0
});

var SyntheticCompositionEvent = createSyntheticEvent(CompositionEventInterface);
/**
 * @interface Event
 * @see http://www.w3.org/TR/2013/WD-DOM-Level-3-Events-20131105
 *      /#events-inputevents
 */
// Happens to share the same list for now.

var SyntheticInputEvent = SyntheticCompositionEvent;
/**
 * Normalization of deprecated HTML5 `key` values
 * @see https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent#Key_names
 */

var normalizeKey = {
  Esc: 'Escape',
  Spacebar: ' ',
  Left: 'ArrowLeft',
  Up: 'ArrowUp',
  Right: 'ArrowRight',
  Down: 'ArrowDown',
  Del: 'Delete',
  Win: 'OS',
  Menu: 'ContextMenu',
  Apps: 'ContextMenu',
  Scroll: 'ScrollLock',
  MozPrintableKey: 'Unidentified'
};
/**
 * Translation from legacy `keyCode` to HTML5 `key`
 * Only special keys supported, all others depend on keyboard layout or browser
 * @see https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent#Key_names
 */

var translateToKey = {
  '8': 'Backspace',
  '9': 'Tab',
  '12': 'Clear',
  '13': 'Enter',
  '16': 'Shift',
  '17': 'Control',
  '18': 'Alt',
  '19': 'Pause',
  '20': 'CapsLock',
  '27': 'Escape',
  '32': ' ',
  '33': 'PageUp',
  '34': 'PageDown',
  '35': 'End',
  '36': 'Home',
  '37': 'ArrowLeft',
  '38': 'ArrowUp',
  '39': 'ArrowRight',
  '40': 'ArrowDown',
  '45': 'Insert',
  '46': 'Delete',
  '112': 'F1',
  '113': 'F2',
  '114': 'F3',
  '115': 'F4',
  '116': 'F5',
  '117': 'F6',
  '118': 'F7',
  '119': 'F8',
  '120': 'F9',
  '121': 'F10',
  '122': 'F11',
  '123': 'F12',
  '144': 'NumLock',
  '145': 'ScrollLock',
  '224': 'Meta'
};
/**
 * @param {object} nativeEvent Native browser event.
 * @return {string} Normalized `key` property.
 */

function getEventKey(nativeEvent) {
  if (nativeEvent.key) {
    // Normalize inconsistent values reported by browsers due to
    // implementations of a working draft specification.
    // FireFox implements `key` but returns `MozPrintableKey` for all
    // printable characters (normalized to `Unidentified`), ignore it.
    var key = normalizeKey[nativeEvent.key] || nativeEvent.key;

    if (key !== 'Unidentified') {
      return key;
    }
  } // Browser does not implement `key`, polyfill as much of it as we can.


  if (nativeEvent.type === 'keypress') {
    var charCode = getEventCharCode(nativeEvent); // The enter-key is technically both printable and non-printable and can
    // thus be captured by `keypress`, no other non-printable key should.

    return charCode === 13 ? 'Enter' : String.fromCharCode(charCode);
  }

  if (nativeEvent.type === 'keydown' || nativeEvent.type === 'keyup') {
    // While user keyboard layout determines the actual meaning of each
    // `keyCode` value, almost all function keys have a universal value.
    return translateToKey[nativeEvent.keyCode] || 'Unidentified';
  }

  return '';
}
/**
 * Translation from modifier key to the associated property in the event.
 * @see http://www.w3.org/TR/DOM-Level-3-Events/#keys-Modifiers
 */


var modifierKeyToProp = {
  Alt: 'altKey',
  Control: 'ctrlKey',
  Meta: 'metaKey',
  Shift: 'shiftKey'
}; // Older browsers (Safari <= 10, iOS Safari <= 10.2) do not support
// getModifierState. If getModifierState is not supported, we map it to a set of
// modifier keys exposed by the event. In this case, Lock-keys are not supported.

function modifierStateGetter(keyArg) {
  var syntheticEvent = this;
  var nativeEvent = syntheticEvent.nativeEvent;

  if (nativeEvent.getModifierState) {
    return nativeEvent.getModifierState(keyArg);
  }

  var keyProp = modifierKeyToProp[keyArg];
  return keyProp ? !!nativeEvent[keyProp] : false;
}

function getEventModifierState(nativeEvent) {
  return modifierStateGetter;
}
/**
 * @interface KeyboardEvent
 * @see http://www.w3.org/TR/DOM-Level-3-Events/
 */


var KeyboardEventInterface = _assign({}, UIEventInterface, {
  key: getEventKey,
  code: 0,
  location: 0,
  ctrlKey: 0,
  shiftKey: 0,
  altKey: 0,
  metaKey: 0,
  repeat: 0,
  locale: 0,
  getModifierState: getEventModifierState,
  // Legacy Interface
  charCode: function (event) {
    // `charCode` is the result of a KeyPress event and represents the value of
    // the actual printable character.
    // KeyPress is deprecated, but its replacement is not yet final and not
    // implemented in any major browser. Only KeyPress has charCode.
    if (event.type === 'keypress') {
      return getEventCharCode(event);
    }

    return 0;
  },
  keyCode: function (event) {
    // `keyCode` is the result of a KeyDown/Up event and represents the value of
    // physical keyboard key.
    // The actual meaning of the value depends on the users' keyboard layout
    // which cannot be detected. Assuming that it is a US keyboard layout
    // provides a surprisingly accurate mapping for US and European users.
    // Due to this, it is left to the user to implement at this time.
    if (event.type === 'keydown' || event.type === 'keyup') {
      return event.keyCode;
    }

    return 0;
  },
  which: function (event) {
    // `which` is an alias for either `keyCode` or `charCode` depending on the
    // type of the event.
    if (event.type === 'keypress') {
      return getEventCharCode(event);
    }

    if (event.type === 'keydown' || event.type === 'keyup') {
      return event.keyCode;
    }

    return 0;
  }
});

var SyntheticKeyboardEvent = createSyntheticEvent(KeyboardEventInterface);
/**
 * @interface PointerEvent
 * @see http://www.w3.org/TR/pointerevents/
 */

var PointerEventInterface = _assign({}, MouseEventInterface, {
  pointerId: 0,
  width: 0,
  height: 0,
  pressure: 0,
  tangentialPressure: 0,
  tiltX: 0,
  tiltY: 0,
  twist: 0,
  pointerType: 0,
  isPrimary: 0
});

var SyntheticPointerEvent = createSyntheticEvent(PointerEventInterface);
/**
 * @interface TouchEvent
 * @see http://www.w3.org/TR/touch-events/
 */

var TouchEventInterface = _assign({}, UIEventInterface, {
  touches: 0,
  targetTouches: 0,
  changedTouches: 0,
  altKey: 0,
  metaKey: 0,
  ctrlKey: 0,
  shiftKey: 0,
  getModifierState: getEventModifierState
});

var SyntheticTouchEvent = createSyntheticEvent(TouchEventInterface);
/**
 * @interface Event
 * @see http://www.w3.org/TR/2009/WD-css3-transitions-20090320/#transition-events-
 * @see https://developer.mozilla.org/en-US/docs/Web/API/TransitionEvent
 */

var TransitionEventInterface = _assign({}, EventInterface, {
  propertyName: 0,
  elapsedTime: 0,
  pseudoElement: 0
});

var SyntheticTransitionEvent = createSyntheticEvent(TransitionEventInterface);
/**
 * @interface WheelEvent
 * @see http://www.w3.org/TR/DOM-Level-3-Events/
 */

var WheelEventInterface = _assign({}, MouseEventInterface, {
  deltaX: function (event) {
    return 'deltaX' in event ? event.deltaX : // Fallback to `wheelDeltaX` for Webkit and normalize (right is positive).
    'wheelDeltaX' in event ? -event.wheelDeltaX : 0;
  },
  deltaY: function (event) {
    return 'deltaY' in event ? event.deltaY : // Fallback to `wheelDeltaY` for Webkit and normalize (down is positive).
    'wheelDeltaY' in event ? -event.wheelDeltaY : // Fallback to `wheelDelta` for IE<9 and normalize (down is positive).
    'wheelDelta' in event ? -event.wheelDelta : 0;
  },
  deltaZ: 0,
  // Browsers without "deltaMode" is reporting in raw wheel delta where one
  // notch on the scroll is always +/- 120, roughly equivalent to pixels.
  // A good approximation of DOM_DELTA_LINE (1) is 5% of viewport size or
  // ~40 pixels, for DOM_DELTA_SCREEN (2) it is 87.5% of viewport size.
  deltaMode: 0
});

var SyntheticWheelEvent = createSyntheticEvent(WheelEventInterface);

var END_KEYCODES = [9, 13, 27, 32]; // Tab, Return, Esc, Space

var START_KEYCODE = 229;
var canUseCompositionEvent = canUseDOM && 'CompositionEvent' in window;
var documentMode = null;

if (canUseDOM && 'documentMode' in document) {
  documentMode = document.documentMode;
} // Webkit offers a very useful `textInput` event that can be used to
// directly represent `beforeInput`. The IE `textinput` event is not as
// useful, so we don't use it.


var canUseTextInputEvent = canUseDOM && 'TextEvent' in window && !documentMode; // In IE9+, we have access to composition events, but the data supplied
// by the native compositionend event may be incorrect. Japanese ideographic
// spaces, for instance (\u3000) are not recorded correctly.

var useFallbackCompositionData = canUseDOM && (!canUseCompositionEvent || documentMode && documentMode > 8 && documentMode <= 11);
var SPACEBAR_CODE = 32;
var SPACEBAR_CHAR = String.fromCharCode(SPACEBAR_CODE);

function registerEvents() {
  registerTwoPhaseEvent('onBeforeInput', ['compositionend', 'keypress', 'textInput', 'paste']);
  registerTwoPhaseEvent('onCompositionEnd', ['compositionend', 'focusout', 'keydown', 'keypress', 'keyup', 'mousedown']);
  registerTwoPhaseEvent('onCompositionStart', ['compositionstart', 'focusout', 'keydown', 'keypress', 'keyup', 'mousedown']);
  registerTwoPhaseEvent('onCompositionUpdate', ['compositionupdate', 'focusout', 'keydown', 'keypress', 'keyup', 'mousedown']);
} // Track whether we've ever handled a keypress on the space key.


var hasSpaceKeypress = false;
/**
 * Return whether a native keypress event is assumed to be a command.
 * This is required because Firefox fires `keypress` events for key commands
 * (cut, copy, select-all, etc.) even though no character is inserted.
 */

function isKeypressCommand(nativeEvent) {
  return (nativeEvent.ctrlKey || nativeEvent.altKey || nativeEvent.metaKey) && // ctrlKey && altKey is equivalent to AltGr, and is not a command.
  !(nativeEvent.ctrlKey && nativeEvent.altKey);
}
/**
 * Translate native top level events into event types.
 */


function getCompositionEventType(domEventName) {
  switch (domEventName) {
    case 'compositionstart':
      return 'onCompositionStart';

    case 'compositionend':
      return 'onCompositionEnd';

    case 'compositionupdate':
      return 'onCompositionUpdate';
  }
}
/**
 * Does our fallback best-guess model think this event signifies that
 * composition has begun?
 */


function isFallbackCompositionStart(domEventName, nativeEvent) {
  return domEventName === 'keydown' && nativeEvent.keyCode === START_KEYCODE;
}
/**
 * Does our fallback mode think that this event is the end of composition?
 */


function isFallbackCompositionEnd(domEventName, nativeEvent) {
  switch (domEventName) {
    case 'keyup':
      // Command keys insert or clear IME input.
      return END_KEYCODES.indexOf(nativeEvent.keyCode) !== -1;

    case 'keydown':
      // Expect IME keyCode on each keydown. If we get any other
      // code we must have exited earlier.
      return nativeEvent.keyCode !== START_KEYCODE;

    case 'keypress':
    case 'mousedown':
    case 'focusout':
      // Events are not possible without cancelling IME.
      return true;

    default:
      return false;
  }
}
/**
 * Google Input Tools provides composition data via a CustomEvent,
 * with the `data` property populated in the `detail` object. If this
 * is available on the event object, use it. If not, this is a plain
 * composition event and we have nothing special to extract.
 *
 * @param {object} nativeEvent
 * @return {?string}
 */


function getDataFromCustomEvent(nativeEvent) {
  var detail = nativeEvent.detail;

  if (typeof detail === 'object' && 'data' in detail) {
    return detail.data;
  }

  return null;
}
/**
 * Check if a composition event was triggered by Korean IME.
 * Our fallback mode does not work well with IE's Korean IME,
 * so just use native composition events when Korean IME is used.
 * Although CompositionEvent.locale property is deprecated,
 * it is available in IE, where our fallback mode is enabled.
 *
 * @param {object} nativeEvent
 * @return {boolean}
 */


function isUsingKoreanIME(nativeEvent) {
  return nativeEvent.locale === 'ko';
} // Track the current IME composition status, if any.


var isComposing = false;
/**
 * @return {?object} A SyntheticCompositionEvent.
 */

function extractCompositionEvent(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget) {
  var eventType;
  var fallbackData;

  if (canUseCompositionEvent) {
    eventType = getCompositionEventType(domEventName);
  } else if (!isComposing) {
    if (isFallbackCompositionStart(domEventName, nativeEvent)) {
      eventType = 'onCompositionStart';
    }
  } else if (isFallbackCompositionEnd(domEventName, nativeEvent)) {
    eventType = 'onCompositionEnd';
  }

  if (!eventType) {
    return null;
  }

  if (useFallbackCompositionData && !isUsingKoreanIME(nativeEvent)) {
    // The current composition is stored statically and must not be
    // overwritten while composition continues.
    if (!isComposing && eventType === 'onCompositionStart') {
      isComposing = initialize(nativeEventTarget);
    } else if (eventType === 'onCompositionEnd') {
      if (isComposing) {
        fallbackData = getData();
      }
    }
  }

  var listeners = accumulateTwoPhaseListeners(targetInst, eventType);

  if (listeners.length > 0) {
    var event = new SyntheticCompositionEvent(eventType, domEventName, null, nativeEvent, nativeEventTarget);
    dispatchQueue.push({
      event: event,
      listeners: listeners
    });

    if (fallbackData) {
      // Inject data generated from fallback path into the synthetic event.
      // This matches the property of native CompositionEventInterface.
      event.data = fallbackData;
    } else {
      var customData = getDataFromCustomEvent(nativeEvent);

      if (customData !== null) {
        event.data = customData;
      }
    }
  }
}

function getNativeBeforeInputChars(domEventName, nativeEvent) {
  switch (domEventName) {
    case 'compositionend':
      return getDataFromCustomEvent(nativeEvent);

    case 'keypress':
      /**
       * If native `textInput` events are available, our goal is to make
       * use of them. However, there is a special case: the spacebar key.
       * In Webkit, preventing default on a spacebar `textInput` event
       * cancels character insertion, but it *also* causes the browser
       * to fall back to its default spacebar behavior of scrolling the
       * page.
       *
       * Tracking at:
       * https://code.google.com/p/chromium/issues/detail?id=355103
       *
       * To avoid this issue, use the keypress event as if no `textInput`
       * event is available.
       */
      var which = nativeEvent.which;

      if (which !== SPACEBAR_CODE) {
        return null;
      }

      hasSpaceKeypress = true;
      return SPACEBAR_CHAR;

    case 'textInput':
      // Record the characters to be added to the DOM.
      var chars = nativeEvent.data; // If it's a spacebar character, assume that we have already handled
      // it at the keypress level and bail immediately. Android Chrome
      // doesn't give us keycodes, so we need to ignore it.

      if (chars === SPACEBAR_CHAR && hasSpaceKeypress) {
        return null;
      }

      return chars;

    default:
      // For other native event types, do nothing.
      return null;
  }
}
/**
 * For browsers that do not provide the `textInput` event, extract the
 * appropriate string to use for SyntheticInputEvent.
 */


function getFallbackBeforeInputChars(domEventName, nativeEvent) {
  // If we are currently composing (IME) and using a fallback to do so,
  // try to extract the composed characters from the fallback object.
  // If composition event is available, we extract a string only at
  // compositionevent, otherwise extract it at fallback events.
  if (isComposing) {
    if (domEventName === 'compositionend' || !canUseCompositionEvent && isFallbackCompositionEnd(domEventName, nativeEvent)) {
      var chars = getData();
      reset();
      isComposing = false;
      return chars;
    }

    return null;
  }

  switch (domEventName) {
    case 'paste':
      // If a paste event occurs after a keypress, throw out the input
      // chars. Paste events should not lead to BeforeInput events.
      return null;

    case 'keypress':
      /**
       * As of v27, Firefox may fire keypress events even when no character
       * will be inserted. A few possibilities:
       *
       * - `which` is `0`. Arrow keys, Esc key, etc.
       *
       * - `which` is the pressed key code, but no char is available.
       *   Ex: 'AltGr + d` in Polish. There is no modified character for
       *   this key combination and no character is inserted into the
       *   document, but FF fires the keypress for char code `100` anyway.
       *   No `input` event will occur.
       *
       * - `which` is the pressed key code, but a command combination is
       *   being used. Ex: `Cmd+C`. No character is inserted, and no
       *   `input` event will occur.
       */
      if (!isKeypressCommand(nativeEvent)) {
        // IE fires the `keypress` event when a user types an emoji via
        // Touch keyboard of Windows.  In such a case, the `char` property
        // holds an emoji character like `\uD83D\uDE0A`.  Because its length
        // is 2, the property `which` does not represent an emoji correctly.
        // In such a case, we directly return the `char` property instead of
        // using `which`.
        if (nativeEvent.char && nativeEvent.char.length > 1) {
          return nativeEvent.char;
        } else if (nativeEvent.which) {
          return String.fromCharCode(nativeEvent.which);
        }
      }

      return null;

    case 'compositionend':
      return useFallbackCompositionData && !isUsingKoreanIME(nativeEvent) ? null : nativeEvent.data;

    default:
      return null;
  }
}
/**
 * Extract a SyntheticInputEvent for `beforeInput`, based on either native
 * `textInput` or fallback behavior.
 *
 * @return {?object} A SyntheticInputEvent.
 */


function extractBeforeInputEvent(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget) {
  var chars;

  if (canUseTextInputEvent) {
    chars = getNativeBeforeInputChars(domEventName, nativeEvent);
  } else {
    chars = getFallbackBeforeInputChars(domEventName, nativeEvent);
  } // If no characters are being inserted, no BeforeInput event should
  // be fired.


  if (!chars) {
    return null;
  }

  var listeners = accumulateTwoPhaseListeners(targetInst, 'onBeforeInput');

  if (listeners.length > 0) {
    var event = new SyntheticInputEvent('onBeforeInput', 'beforeinput', null, nativeEvent, nativeEventTarget);
    dispatchQueue.push({
      event: event,
      listeners: listeners
    });
    event.data = chars;
  }
}
/**
 * Create an `onBeforeInput` event to match
 * http://www.w3.org/TR/2013/WD-DOM-Level-3-Events-20131105/#events-inputevents.
 *
 * This event plugin is based on the native `textInput` event
 * available in Chrome, Safari, Opera, and IE. This event fires after
 * `onKeyPress` and `onCompositionEnd`, but before `onInput`.
 *
 * `beforeInput` is spec'd but not implemented in any browsers, and
 * the `input` event does not provide any useful information about what has
 * actually been added, contrary to the spec. Thus, `textInput` is the best
 * available event to identify the characters that have actually been inserted
 * into the target node.
 *
 * This plugin is also responsible for emitting `composition` events, thus
 * allowing us to share composition fallback code for both `beforeInput` and
 * `composition` event types.
 */


function extractEvents(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget, eventSystemFlags, targetContainer) {
  extractCompositionEvent(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget);
  extractBeforeInputEvent(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget);
}

/**
 * @see http://www.whatwg.org/specs/web-apps/current-work/multipage/the-input-element.html#input-type-attr-summary
 */
var supportedInputTypes = {
  color: true,
  date: true,
  datetime: true,
  'datetime-local': true,
  email: true,
  month: true,
  number: true,
  password: true,
  range: true,
  search: true,
  tel: true,
  text: true,
  time: true,
  url: true,
  week: true
};

function isTextInputElement(elem) {
  var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();

  if (nodeName === 'input') {
    return !!supportedInputTypes[elem.type];
  }

  if (nodeName === 'textarea') {
    return true;
  }

  return false;
}

/**
 * Checks if an event is supported in the current execution environment.
 *
 * NOTE: This will not work correctly for non-generic events such as `change`,
 * `reset`, `load`, `error`, and `select`.
 *
 * Borrows from Modernizr.
 *
 * @param {string} eventNameSuffix Event name, e.g. "click".
 * @return {boolean} True if the event is supported.
 * @internal
 * @license Modernizr 3.0.0pre (Custom Build) | MIT
 */

function isEventSupported(eventNameSuffix) {
  if (!canUseDOM) {
    return false;
  }

  var eventName = 'on' + eventNameSuffix;
  var isSupported = (eventName in document);

  if (!isSupported) {
    var element = document.createElement('div');
    element.setAttribute(eventName, 'return;');
    isSupported = typeof element[eventName] === 'function';
  }

  return isSupported;
}

function registerEvents$1() {
  registerTwoPhaseEvent('onChange', ['change', 'click', 'focusin', 'focusout', 'input', 'keydown', 'keyup', 'selectionchange']);
}

function createAndAccumulateChangeEvent(dispatchQueue, inst, nativeEvent, target) {
  // Flag this event loop as needing state restore.
  enqueueStateRestore(target);
  var listeners = accumulateTwoPhaseListeners(inst, 'onChange');

  if (listeners.length > 0) {
    var event = new SyntheticEvent('onChange', 'change', null, nativeEvent, target);
    dispatchQueue.push({
      event: event,
      listeners: listeners
    });
  }
}
/**
 * For IE shims
 */


var activeElement = null;
var activeElementInst = null;
/**
 * SECTION: handle `change` event
 */

function shouldUseChangeEvent(elem) {
  var nodeName = elem.nodeName && elem.nodeName.toLowerCase();
  return nodeName === 'select' || nodeName === 'input' && elem.type === 'file';
}

function manualDispatchChangeEvent(nativeEvent) {
  var dispatchQueue = [];
  createAndAccumulateChangeEvent(dispatchQueue, activeElementInst, nativeEvent, getEventTarget(nativeEvent)); // If change and propertychange bubbled, we'd just bind to it like all the
  // other events and have it go through ReactBrowserEventEmitter. Since it
  // doesn't, we manually listen for the events and so we have to enqueue and
  // process the abstract event manually.
  //
  // Batching is necessary here in order to ensure that all event handlers run
  // before the next rerender (including event handlers attached to ancestor
  // elements instead of directly on the input). Without this, controlled
  // components don't work properly in conjunction with event bubbling because
  // the component is rerendered and the value reverted before all the event
  // handlers can run. See https://github.com/facebook/react/issues/708.

  batchedUpdates(runEventInBatch, dispatchQueue);
}

function runEventInBatch(dispatchQueue) {
  processDispatchQueue(dispatchQueue, 0);
}

function getInstIfValueChanged(targetInst) {
  var targetNode = getNodeFromInstance(targetInst);

  if (updateValueIfChanged(targetNode)) {
    return targetInst;
  }
}

function getTargetInstForChangeEvent(domEventName, targetInst) {
  if (domEventName === 'change') {
    return targetInst;
  }
}
/**
 * SECTION: handle `input` event
 */


var isInputEventSupported = false;

if (canUseDOM) {
  // IE9 claims to support the input event but fails to trigger it when
  // deleting text, so we ignore its input events.
  isInputEventSupported = isEventSupported('input') && (!document.documentMode || document.documentMode > 9);
}
/**
 * (For IE <=9) Starts tracking propertychange events on the passed-in element
 * and override the value property so that we can distinguish user events from
 * value changes in JS.
 */


function startWatchingForValueChange(target, targetInst) {
  activeElement = target;
  activeElementInst = targetInst;
  activeElement.attachEvent('onpropertychange', handlePropertyChange);
}
/**
 * (For IE <=9) Removes the event listeners from the currently-tracked element,
 * if any exists.
 */


function stopWatchingForValueChange() {
  if (!activeElement) {
    return;
  }

  activeElement.detachEvent('onpropertychange', handlePropertyChange);
  activeElement = null;
  activeElementInst = null;
}
/**
 * (For IE <=9) Handles a propertychange event, sending a `change` event if
 * the value of the active element has changed.
 */


function handlePropertyChange(nativeEvent) {
  if (nativeEvent.propertyName !== 'value') {
    return;
  }

  if (getInstIfValueChanged(activeElementInst)) {
    manualDispatchChangeEvent(nativeEvent);
  }
}

function handleEventsForInputEventPolyfill(domEventName, target, targetInst) {
  if (domEventName === 'focusin') {
    // In IE9, propertychange fires for most input events but is buggy and
    // doesn't fire when text is deleted, but conveniently, selectionchange
    // appears to fire in all of the remaining cases so we catch those and
    // forward the event if the value has changed
    // In either case, we don't want to call the event handler if the value
    // is changed from JS so we redefine a setter for `.value` that updates
    // our activeElementValue variable, allowing us to ignore those changes
    //
    // stopWatching() should be a noop here but we call it just in case we
    // missed a blur event somehow.
    stopWatchingForValueChange();
    startWatchingForValueChange(target, targetInst);
  } else if (domEventName === 'focusout') {
    stopWatchingForValueChange();
  }
} // For IE8 and IE9.


function getTargetInstForInputEventPolyfill(domEventName, targetInst) {
  if (domEventName === 'selectionchange' || domEventName === 'keyup' || domEventName === 'keydown') {
    // On the selectionchange event, the target is just document which isn't
    // helpful for us so just check activeElement instead.
    //
    // 99% of the time, keydown and keyup aren't necessary. IE8 fails to fire
    // propertychange on the first input event after setting `value` from a
    // script and fires only keydown, keypress, keyup. Catching keyup usually
    // gets it and catching keydown lets us fire an event for the first
    // keystroke if user does a key repeat (it'll be a little delayed: right
    // before the second keystroke). Other input methods (e.g., paste) seem to
    // fire selectionchange normally.
    return getInstIfValueChanged(activeElementInst);
  }
}
/**
 * SECTION: handle `click` event
 */


function shouldUseClickEvent(elem) {
  // Use the `click` event to detect changes to checkbox and radio inputs.
  // This approach works across all browsers, whereas `change` does not fire
  // until `blur` in IE8.
  var nodeName = elem.nodeName;
  return nodeName && nodeName.toLowerCase() === 'input' && (elem.type === 'checkbox' || elem.type === 'radio');
}

function getTargetInstForClickEvent(domEventName, targetInst) {
  if (domEventName === 'click') {
    return getInstIfValueChanged(targetInst);
  }
}

function getTargetInstForInputOrChangeEvent(domEventName, targetInst) {
  if (domEventName === 'input' || domEventName === 'change') {
    return getInstIfValueChanged(targetInst);
  }
}

function handleControlledInputBlur(node) {
  var state = node._wrapperState;

  if (!state || !state.controlled || node.type !== 'number') {
    return;
  }

  {
    // If controlled, assign the value attribute to the current value on blur
    setDefaultValue(node, 'number', node.value);
  }
}
/**
 * This plugin creates an `onChange` event that normalizes change events
 * across form elements. This event fires at a time when it's possible to
 * change the element's value without seeing a flicker.
 *
 * Supported elements are:
 * - input (see `isTextInputElement`)
 * - textarea
 * - select
 */


function extractEvents$1(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget, eventSystemFlags, targetContainer) {
  var targetNode = targetInst ? getNodeFromInstance(targetInst) : window;
  var getTargetInstFunc, handleEventFunc;

  if (shouldUseChangeEvent(targetNode)) {
    getTargetInstFunc = getTargetInstForChangeEvent;
  } else if (isTextInputElement(targetNode)) {
    if (isInputEventSupported) {
      getTargetInstFunc = getTargetInstForInputOrChangeEvent;
    } else {
      getTargetInstFunc = getTargetInstForInputEventPolyfill;
      handleEventFunc = handleEventsForInputEventPolyfill;
    }
  } else if (shouldUseClickEvent(targetNode)) {
    getTargetInstFunc = getTargetInstForClickEvent;
  }

  if (getTargetInstFunc) {
    var inst = getTargetInstFunc(domEventName, targetInst);

    if (inst) {
      createAndAccumulateChangeEvent(dispatchQueue, inst, nativeEvent, nativeEventTarget);
      return;
    }
  }

  if (handleEventFunc) {
    handleEventFunc(domEventName, targetNode, targetInst);
  } // When blurring, set the value attribute for number inputs


  if (domEventName === 'focusout') {
    handleControlledInputBlur(targetNode);
  }
}

function registerEvents$2() {
  registerDirectEvent('onMouseEnter', ['mouseout', 'mouseover']);
  registerDirectEvent('onMouseLeave', ['mouseout', 'mouseover']);
  registerDirectEvent('onPointerEnter', ['pointerout', 'pointerover']);
  registerDirectEvent('onPointerLeave', ['pointerout', 'pointerover']);
}
/**
 * For almost every interaction we care about, there will be both a top-level
 * `mouseover` and `mouseout` event that occurs. Only use `mouseout` so that
 * we do not extract duplicate events. However, moving the mouse into the
 * browser from outside will not fire a `mouseout` event. In this case, we use
 * the `mouseover` top-level event.
 */


function extractEvents$2(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget, eventSystemFlags, targetContainer) {
  var isOverEvent = domEventName === 'mouseover' || domEventName === 'pointerover';
  var isOutEvent = domEventName === 'mouseout' || domEventName === 'pointerout';

  if (isOverEvent && (eventSystemFlags & IS_REPLAYED) === 0) {
    // If this is an over event with a target, we might have already dispatched
    // the event in the out event of the other target. If this is replayed,
    // then it's because we couldn't dispatch against this target previously
    // so we have to do it now instead.
    var related = nativeEvent.relatedTarget || nativeEvent.fromElement;

    if (related) {
      // If the related node is managed by React, we can assume that we have
      // already dispatched the corresponding events during its mouseout.
      if (getClosestInstanceFromNode(related) || isContainerMarkedAsRoot(related)) {
        return;
      }
    }
  }

  if (!isOutEvent && !isOverEvent) {
    // Must not be a mouse or pointer in or out - ignoring.
    return;
  }

  var win; // TODO: why is this nullable in the types but we read from it?

  if (nativeEventTarget.window === nativeEventTarget) {
    // `nativeEventTarget` is probably a window object.
    win = nativeEventTarget;
  } else {
    // TODO: Figure out why `ownerDocument` is sometimes undefined in IE8.
    var doc = nativeEventTarget.ownerDocument;

    if (doc) {
      win = doc.defaultView || doc.parentWindow;
    } else {
      win = window;
    }
  }

  var from;
  var to;

  if (isOutEvent) {
    var _related = nativeEvent.relatedTarget || nativeEvent.toElement;

    from = targetInst;
    to = _related ? getClosestInstanceFromNode(_related) : null;

    if (to !== null) {
      var nearestMounted = getNearestMountedFiber(to);

      if (to !== nearestMounted || to.tag !== HostComponent && to.tag !== HostText) {
        to = null;
      }
    }
  } else {
    // Moving to a node from outside the window.
    from = null;
    to = targetInst;
  }

  if (from === to) {
    // Nothing pertains to our managed components.
    return;
  }

  var SyntheticEventCtor = SyntheticMouseEvent;
  var leaveEventType = 'onMouseLeave';
  var enterEventType = 'onMouseEnter';
  var eventTypePrefix = 'mouse';

  if (domEventName === 'pointerout' || domEventName === 'pointerover') {
    SyntheticEventCtor = SyntheticPointerEvent;
    leaveEventType = 'onPointerLeave';
    enterEventType = 'onPointerEnter';
    eventTypePrefix = 'pointer';
  }

  var fromNode = from == null ? win : getNodeFromInstance(from);
  var toNode = to == null ? win : getNodeFromInstance(to);
  var leave = new SyntheticEventCtor(leaveEventType, eventTypePrefix + 'leave', from, nativeEvent, nativeEventTarget);
  leave.target = fromNode;
  leave.relatedTarget = toNode;
  var enter = null; // We should only process this nativeEvent if we are processing
  // the first ancestor. Next time, we will ignore the event.

  var nativeTargetInst = getClosestInstanceFromNode(nativeEventTarget);

  if (nativeTargetInst === targetInst) {
    var enterEvent = new SyntheticEventCtor(enterEventType, eventTypePrefix + 'enter', to, nativeEvent, nativeEventTarget);
    enterEvent.target = toNode;
    enterEvent.relatedTarget = fromNode;
    enter = enterEvent;
  }

  accumulateEnterLeaveTwoPhaseListeners(dispatchQueue, leave, enter, from, to);
}

/**
 * inlined Object.is polyfill to avoid requiring consumers ship their own
 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
 */
function is(x, y) {
  return x === y && (x !== 0 || 1 / x === 1 / y) || x !== x && y !== y // eslint-disable-line no-self-compare
  ;
}

var objectIs = typeof Object.is === 'function' ? Object.is : is;

var hasOwnProperty$2 = Object.prototype.hasOwnProperty;
/**
 * Performs equality by iterating through keys on an object and returning false
 * when any key has values which are not strictly equal between the arguments.
 * Returns true when the values of all keys are strictly equal.
 */

function shallowEqual(objA, objB) {
  if (objectIs(objA, objB)) {
    return true;
  }

  if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
    return false;
  }

  var keysA = Object.keys(objA);
  var keysB = Object.keys(objB);

  if (keysA.length !== keysB.length) {
    return false;
  } // Test for A's keys different from B.


  for (var i = 0; i < keysA.length; i++) {
    if (!hasOwnProperty$2.call(objB, keysA[i]) || !objectIs(objA[keysA[i]], objB[keysA[i]])) {
      return false;
    }
  }

  return true;
}

/**
 * Given any node return the first leaf node without children.
 *
 * @param {DOMElement|DOMTextNode} node
 * @return {DOMElement|DOMTextNode}
 */

function getLeafNode(node) {
  while (node && node.firstChild) {
    node = node.firstChild;
  }

  return node;
}
/**
 * Get the next sibling within a container. This will walk up the
 * DOM if a node's siblings have been exhausted.
 *
 * @param {DOMElement|DOMTextNode} node
 * @return {?DOMElement|DOMTextNode}
 */


function getSiblingNode(node) {
  while (node) {
    if (node.nextSibling) {
      return node.nextSibling;
    }

    node = node.parentNode;
  }
}
/**
 * Get object describing the nodes which contain characters at offset.
 *
 * @param {DOMElement|DOMTextNode} root
 * @param {number} offset
 * @return {?object}
 */


function getNodeForCharacterOffset(root, offset) {
  var node = getLeafNode(root);
  var nodeStart = 0;
  var nodeEnd = 0;

  while (node) {
    if (node.nodeType === TEXT_NODE) {
      nodeEnd = nodeStart + node.textContent.length;

      if (nodeStart <= offset && nodeEnd >= offset) {
        return {
          node: node,
          offset: offset - nodeStart
        };
      }

      nodeStart = nodeEnd;
    }

    node = getLeafNode(getSiblingNode(node));
  }
}

/**
 * @param {DOMElement} outerNode
 * @return {?object}
 */

function getOffsets(outerNode) {
  var ownerDocument = outerNode.ownerDocument;
  var win = ownerDocument && ownerDocument.defaultView || window;
  var selection = win.getSelection && win.getSelection();

  if (!selection || selection.rangeCount === 0) {
    return null;
  }

  var anchorNode = selection.anchorNode,
      anchorOffset = selection.anchorOffset,
      focusNode = selection.focusNode,
      focusOffset = selection.focusOffset; // In Firefox, anchorNode and focusNode can be "anonymous divs", e.g. the
  // up/down buttons on an <input type="number">. Anonymous divs do not seem to
  // expose properties, triggering a "Permission denied error" if any of its
  // properties are accessed. The only seemingly possible way to avoid erroring
  // is to access a property that typically works for non-anonymous divs and
  // catch any error that may otherwise arise. See
  // https://bugzilla.mozilla.org/show_bug.cgi?id=208427

  try {
    /* eslint-disable no-unused-expressions */
    anchorNode.nodeType;
    focusNode.nodeType;
    /* eslint-enable no-unused-expressions */
  } catch (e) {
    return null;
  }

  return getModernOffsetsFromPoints(outerNode, anchorNode, anchorOffset, focusNode, focusOffset);
}
/**
 * Returns {start, end} where `start` is the character/codepoint index of
 * (anchorNode, anchorOffset) within the textContent of `outerNode`, and
 * `end` is the index of (focusNode, focusOffset).
 *
 * Returns null if you pass in garbage input but we should probably just crash.
 *
 * Exported only for testing.
 */

function getModernOffsetsFromPoints(outerNode, anchorNode, anchorOffset, focusNode, focusOffset) {
  var length = 0;
  var start = -1;
  var end = -1;
  var indexWithinAnchor = 0;
  var indexWithinFocus = 0;
  var node = outerNode;
  var parentNode = null;

  outer: while (true) {
    var next = null;

    while (true) {
      if (node === anchorNode && (anchorOffset === 0 || node.nodeType === TEXT_NODE)) {
        start = length + anchorOffset;
      }

      if (node === focusNode && (focusOffset === 0 || node.nodeType === TEXT_NODE)) {
        end = length + focusOffset;
      }

      if (node.nodeType === TEXT_NODE) {
        length += node.nodeValue.length;
      }

      if ((next = node.firstChild) === null) {
        break;
      } // Moving from `node` to its first child `next`.


      parentNode = node;
      node = next;
    }

    while (true) {
      if (node === outerNode) {
        // If `outerNode` has children, this is always the second time visiting
        // it. If it has no children, this is still the first loop, and the only
        // valid selection is anchorNode and focusNode both equal to this node
        // and both offsets 0, in which case we will have handled above.
        break outer;
      }

      if (parentNode === anchorNode && ++indexWithinAnchor === anchorOffset) {
        start = length;
      }

      if (parentNode === focusNode && ++indexWithinFocus === focusOffset) {
        end = length;
      }

      if ((next = node.nextSibling) !== null) {
        break;
      }

      node = parentNode;
      parentNode = node.parentNode;
    } // Moving from `node` to its next sibling `next`.


    node = next;
  }

  if (start === -1 || end === -1) {
    // This should never happen. (Would happen if the anchor/focus nodes aren't
    // actually inside the passed-in node.)
    return null;
  }

  return {
    start: start,
    end: end
  };
}
/**
 * In modern non-IE browsers, we can support both forward and backward
 * selections.
 *
 * Note: IE10+ supports the Selection object, but it does not support
 * the `extend` method, which means that even in modern IE, it's not possible
 * to programmatically create a backward selection. Thus, for all IE
 * versions, we use the old IE API to create our selections.
 *
 * @param {DOMElement|DOMTextNode} node
 * @param {object} offsets
 */

function setOffsets(node, offsets) {
  var doc = node.ownerDocument || document;
  var win = doc && doc.defaultView || window; // Edge fails with "Object expected" in some scenarios.
  // (For instance: TinyMCE editor used in a list component that supports pasting to add more,
  // fails when pasting 100+ items)

  if (!win.getSelection) {
    return;
  }

  var selection = win.getSelection();
  var length = node.textContent.length;
  var start = Math.min(offsets.start, length);
  var end = offsets.end === undefined ? start : Math.min(offsets.end, length); // IE 11 uses modern selection, but doesn't support the extend method.
  // Flip backward selections, so we can set with a single range.

  if (!selection.extend && start > end) {
    var temp = end;
    end = start;
    start = temp;
  }

  var startMarker = getNodeForCharacterOffset(node, start);
  var endMarker = getNodeForCharacterOffset(node, end);

  if (startMarker && endMarker) {
    if (selection.rangeCount === 1 && selection.anchorNode === startMarker.node && selection.anchorOffset === startMarker.offset && selection.focusNode === endMarker.node && selection.focusOffset === endMarker.offset) {
      return;
    }

    var range = doc.createRange();
    range.setStart(startMarker.node, startMarker.offset);
    selection.removeAllRanges();

    if (start > end) {
      selection.addRange(range);
      selection.extend(endMarker.node, endMarker.offset);
    } else {
      range.setEnd(endMarker.node, endMarker.offset);
      selection.addRange(range);
    }
  }
}

function isTextNode(node) {
  return node && node.nodeType === TEXT_NODE;
}

function containsNode(outerNode, innerNode) {
  if (!outerNode || !innerNode) {
    return false;
  } else if (outerNode === innerNode) {
    return true;
  } else if (isTextNode(outerNode)) {
    return false;
  } else if (isTextNode(innerNode)) {
    return containsNode(outerNode, innerNode.parentNode);
  } else if ('contains' in outerNode) {
    return outerNode.contains(innerNode);
  } else if (outerNode.compareDocumentPosition) {
    return !!(outerNode.compareDocumentPosition(innerNode) & 16);
  } else {
    return false;
  }
}

function isInDocument(node) {
  return node && node.ownerDocument && containsNode(node.ownerDocument.documentElement, node);
}

function isSameOriginFrame(iframe) {
  try {
    // Accessing the contentDocument of a HTMLIframeElement can cause the browser
    // to throw, e.g. if it has a cross-origin src attribute.
    // Safari will show an error in the console when the access results in "Blocked a frame with origin". e.g:
    // iframe.contentDocument.defaultView;
    // A safety way is to access one of the cross origin properties: Window or Location
    // Which might result in "SecurityError" DOM Exception and it is compatible to Safari.
    // https://html.spec.whatwg.org/multipage/browsers.html#integration-with-idl
    return typeof iframe.contentWindow.location.href === 'string';
  } catch (err) {
    return false;
  }
}

function getActiveElementDeep() {
  var win = window;
  var element = getActiveElement();

  while (element instanceof win.HTMLIFrameElement) {
    if (isSameOriginFrame(element)) {
      win = element.contentWindow;
    } else {
      return element;
    }

    element = getActiveElement(win.document);
  }

  return element;
}
/**
 * @ReactInputSelection: React input selection module. Based on Selection.js,
 * but modified to be suitable for react and has a couple of bug fixes (doesn't
 * assume buttons have range selections allowed).
 * Input selection module for React.
 */

/**
 * @hasSelectionCapabilities: we get the element types that support selection
 * from https://html.spec.whatwg.org/#do-not-apply, looking at `selectionStart`
 * and `selectionEnd` rows.
 */


function hasSelectionCapabilities(elem) {
  var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
  return nodeName && (nodeName === 'input' && (elem.type === 'text' || elem.type === 'search' || elem.type === 'tel' || elem.type === 'url' || elem.type === 'password') || nodeName === 'textarea' || elem.contentEditable === 'true');
}
function getSelectionInformation() {
  var focusedElem = getActiveElementDeep();
  return {
    focusedElem: focusedElem,
    selectionRange: hasSelectionCapabilities(focusedElem) ? getSelection(focusedElem) : null
  };
}
/**
 * @restoreSelection: If any selection information was potentially lost,
 * restore it. This is useful when performing operations that could remove dom
 * nodes and place them back in, resulting in focus being lost.
 */

function restoreSelection(priorSelectionInformation) {
  var curFocusedElem = getActiveElementDeep();
  var priorFocusedElem = priorSelectionInformation.focusedElem;
  var priorSelectionRange = priorSelectionInformation.selectionRange;

  if (curFocusedElem !== priorFocusedElem && isInDocument(priorFocusedElem)) {
    if (priorSelectionRange !== null && hasSelectionCapabilities(priorFocusedElem)) {
      setSelection(priorFocusedElem, priorSelectionRange);
    } // Focusing a node can change the scroll position, which is undesirable


    var ancestors = [];
    var ancestor = priorFocusedElem;

    while (ancestor = ancestor.parentNode) {
      if (ancestor.nodeType === ELEMENT_NODE) {
        ancestors.push({
          element: ancestor,
          left: ancestor.scrollLeft,
          top: ancestor.scrollTop
        });
      }
    }

    if (typeof priorFocusedElem.focus === 'function') {
      priorFocusedElem.focus();
    }

    for (var i = 0; i < ancestors.length; i++) {
      var info = ancestors[i];
      info.element.scrollLeft = info.left;
      info.element.scrollTop = info.top;
    }
  }
}
/**
 * @getSelection: Gets the selection bounds of a focused textarea, input or
 * contentEditable node.
 * -@input: Look up selection bounds of this input
 * -@return {start: selectionStart, end: selectionEnd}
 */

function getSelection(input) {
  var selection;

  if ('selectionStart' in input) {
    // Modern browser with input or textarea.
    selection = {
      start: input.selectionStart,
      end: input.selectionEnd
    };
  } else {
    // Content editable or old IE textarea.
    selection = getOffsets(input);
  }

  return selection || {
    start: 0,
    end: 0
  };
}
/**
 * @setSelection: Sets the selection bounds of a textarea or input and focuses
 * the input.
 * -@input     Set selection bounds of this input or textarea
 * -@offsets   Object of same form that is returned from get*
 */

function setSelection(input, offsets) {
  var start = offsets.start;
  var end = offsets.end;

  if (end === undefined) {
    end = start;
  }

  if ('selectionStart' in input) {
    input.selectionStart = start;
    input.selectionEnd = Math.min(end, input.value.length);
  } else {
    setOffsets(input, offsets);
  }
}

var skipSelectionChangeEvent = canUseDOM && 'documentMode' in document && document.documentMode <= 11;

function registerEvents$3() {
  registerTwoPhaseEvent('onSelect', ['focusout', 'contextmenu', 'dragend', 'focusin', 'keydown', 'keyup', 'mousedown', 'mouseup', 'selectionchange']);
}

var activeElement$1 = null;
var activeElementInst$1 = null;
var lastSelection = null;
var mouseDown = false;
/**
 * Get an object which is a unique representation of the current selection.
 *
 * The return value will not be consistent across nodes or browsers, but
 * two identical selections on the same node will return identical objects.
 */

function getSelection$1(node) {
  if ('selectionStart' in node && hasSelectionCapabilities(node)) {
    return {
      start: node.selectionStart,
      end: node.selectionEnd
    };
  } else {
    var win = node.ownerDocument && node.ownerDocument.defaultView || window;
    var selection = win.getSelection();
    return {
      anchorNode: selection.anchorNode,
      anchorOffset: selection.anchorOffset,
      focusNode: selection.focusNode,
      focusOffset: selection.focusOffset
    };
  }
}
/**
 * Get document associated with the event target.
 */


function getEventTargetDocument(eventTarget) {
  return eventTarget.window === eventTarget ? eventTarget.document : eventTarget.nodeType === DOCUMENT_NODE ? eventTarget : eventTarget.ownerDocument;
}
/**
 * Poll selection to see whether it's changed.
 *
 * @param {object} nativeEvent
 * @param {object} nativeEventTarget
 * @return {?SyntheticEvent}
 */


function constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget) {
  // Ensure we have the right element, and that the user is not dragging a
  // selection (this matches native `select` event behavior). In HTML5, select
  // fires only on input and textarea thus if there's no focused element we
  // won't dispatch.
  var doc = getEventTargetDocument(nativeEventTarget);

  if (mouseDown || activeElement$1 == null || activeElement$1 !== getActiveElement(doc)) {
    return;
  } // Only fire when selection has actually changed.


  var currentSelection = getSelection$1(activeElement$1);

  if (!lastSelection || !shallowEqual(lastSelection, currentSelection)) {
    lastSelection = currentSelection;
    var listeners = accumulateTwoPhaseListeners(activeElementInst$1, 'onSelect');

    if (listeners.length > 0) {
      var event = new SyntheticEvent('onSelect', 'select', null, nativeEvent, nativeEventTarget);
      dispatchQueue.push({
        event: event,
        listeners: listeners
      });
      event.target = activeElement$1;
    }
  }
}
/**
 * This plugin creates an `onSelect` event that normalizes select events
 * across form elements.
 *
 * Supported elements are:
 * - input (see `isTextInputElement`)
 * - textarea
 * - contentEditable
 *
 * This differs from native browser implementations in the following ways:
 * - Fires on contentEditable fields as well as inputs.
 * - Fires for collapsed selection.
 * - Fires after user input.
 */


function extractEvents$3(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget, eventSystemFlags, targetContainer) {

  var targetNode = targetInst ? getNodeFromInstance(targetInst) : window;

  switch (domEventName) {
    // Track the input node that has focus.
    case 'focusin':
      if (isTextInputElement(targetNode) || targetNode.contentEditable === 'true') {
        activeElement$1 = targetNode;
        activeElementInst$1 = targetInst;
        lastSelection = null;
      }

      break;

    case 'focusout':
      activeElement$1 = null;
      activeElementInst$1 = null;
      lastSelection = null;
      break;
    // Don't fire the event while the user is dragging. This matches the
    // semantics of the native select event.

    case 'mousedown':
      mouseDown = true;
      break;

    case 'contextmenu':
    case 'mouseup':
    case 'dragend':
      mouseDown = false;
      constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget);
      break;
    // Chrome and IE fire non-standard event when selection is changed (and
    // sometimes when it hasn't). IE's event fires out of order with respect
    // to key and input events on deletion, so we discard it.
    //
    // Firefox doesn't support selectionchange, so check selection status
    // after each key entry. The selection changes after keydown and before
    // keyup, but we check on keydown as well in the case of holding down a
    // key, when multiple keydown events are fired but only one keyup is.
    // This is also our approach for IE handling, for the reason above.

    case 'selectionchange':
      if (skipSelectionChangeEvent) {
        break;
      }

    // falls through

    case 'keydown':
    case 'keyup':
      constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget);
  }
}

function extractEvents$4(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget, eventSystemFlags, targetContainer) {
  var reactName = topLevelEventsToReactNames.get(domEventName);

  if (reactName === undefined) {
    return;
  }

  var SyntheticEventCtor = SyntheticEvent;
  var reactEventType = domEventName;

  switch (domEventName) {
    case 'keypress':
      // Firefox creates a keypress event for function keys too. This removes
      // the unwanted keypress events. Enter is however both printable and
      // non-printable. One would expect Tab to be as well (but it isn't).
      if (getEventCharCode(nativeEvent) === 0) {
        return;
      }

    /* falls through */

    case 'keydown':
    case 'keyup':
      SyntheticEventCtor = SyntheticKeyboardEvent;
      break;

    case 'focusin':
      reactEventType = 'focus';
      SyntheticEventCtor = SyntheticFocusEvent;
      break;

    case 'focusout':
      reactEventType = 'blur';
      SyntheticEventCtor = SyntheticFocusEvent;
      break;

    case 'beforeblur':
    case 'afterblur':
      SyntheticEventCtor = SyntheticFocusEvent;
      break;

    case 'click':
      // Firefox creates a click event on right mouse clicks. This removes the
      // unwanted click events.
      if (nativeEvent.button === 2) {
        return;
      }

    /* falls through */

    case 'auxclick':
    case 'dblclick':
    case 'mousedown':
    case 'mousemove':
    case 'mouseup': // TODO: Disabled elements should not respond to mouse events

    /* falls through */

    case 'mouseout':
    case 'mouseover':
    case 'contextmenu':
      SyntheticEventCtor = SyntheticMouseEvent;
      break;

    case 'drag':
    case 'dragend':
    case 'dragenter':
    case 'dragexit':
    case 'dragleave':
    case 'dragover':
    case 'dragstart':
    case 'drop':
      SyntheticEventCtor = SyntheticDragEvent;
      break;

    case 'touchcancel':
    case 'touchend':
    case 'touchmove':
    case 'touchstart':
      SyntheticEventCtor = SyntheticTouchEvent;
      break;

    case ANIMATION_END:
    case ANIMATION_ITERATION:
    case ANIMATION_START:
      SyntheticEventCtor = SyntheticAnimationEvent;
      break;

    case TRANSITION_END:
      SyntheticEventCtor = SyntheticTransitionEvent;
      break;

    case 'scroll':
      SyntheticEventCtor = SyntheticUIEvent;
      break;

    case 'wheel':
      SyntheticEventCtor = SyntheticWheelEvent;
      break;

    case 'copy':
    case 'cut':
    case 'paste':
      SyntheticEventCtor = SyntheticClipboardEvent;
      break;

    case 'gotpointercapture':
    case 'lostpointercapture':
    case 'pointercancel':
    case 'pointerdown':
    case 'pointermove':
    case 'pointerout':
    case 'pointerover':
    case 'pointerup':
      SyntheticEventCtor = SyntheticPointerEvent;
      break;
  }

  var inCapturePhase = (eventSystemFlags & IS_CAPTURE_PHASE) !== 0;

  {
    // Some events don't bubble in the browser.
    // In the past, React has always bubbled them, but this can be surprising.
    // We're going to try aligning closer to the browser behavior by not bubbling
    // them in React either. We'll start by not bubbling onScroll, and then expand.
    var accumulateTargetOnly = !inCapturePhase && // TODO: ideally, we'd eventually add all events from
    // nonDelegatedEvents list in DOMPluginEventSystem.
    // Then we can remove this special list.
    // This is a breaking change that can wait until React 18.
    domEventName === 'scroll';

    var _listeners = accumulateSinglePhaseListeners(targetInst, reactName, nativeEvent.type, inCapturePhase, accumulateTargetOnly);

    if (_listeners.length > 0) {
      // Intentionally create event lazily.
      var _event = new SyntheticEventCtor(reactName, reactEventType, null, nativeEvent, nativeEventTarget);

      dispatchQueue.push({
        event: _event,
        listeners: _listeners
      });
    }
  }
}

// TODO: remove top-level side effect.
registerSimpleEvents();
registerEvents$2();
registerEvents$1();
registerEvents$3();
registerEvents();

function extractEvents$5(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget, eventSystemFlags, targetContainer) {
  // TODO: we should remove the concept of a "SimpleEventPlugin".
  // This is the basic functionality of the event system. All
  // the other plugins are essentially polyfills. So the plugin
  // should probably be inlined somewhere and have its logic
  // be core the to event system. This would potentially allow
  // us to ship builds of React without the polyfilled plugins below.
  extractEvents$4(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget, eventSystemFlags);
  var shouldProcessPolyfillPlugins = (eventSystemFlags & SHOULD_NOT_PROCESS_POLYFILL_EVENT_PLUGINS) === 0; // We don't process these events unless we are in the
  // event's native "bubble" phase, which means that we're
  // not in the capture phase. That's because we emulate
  // the capture phase here still. This is a trade-off,
  // because in an ideal world we would not emulate and use
  // the phases properly, like we do with the SimpleEvent
  // plugin. However, the plugins below either expect
  // emulation (EnterLeave) or use state localized to that
  // plugin (BeforeInput, Change, Select). The state in
  // these modules complicates things, as you'll essentially
  // get the case where the capture phase event might change
  // state, only for the following bubble event to come in
  // later and not trigger anything as the state now
  // invalidates the heuristics of the event plugin. We
  // could alter all these plugins to work in such ways, but
  // that might cause other unknown side-effects that we
  // can't forsee right now.

  if (shouldProcessPolyfillPlugins) {
    extractEvents$2(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget, eventSystemFlags);
    extractEvents$1(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget);
    extractEvents$3(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget);
    extractEvents(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget);
  }
} // List of events that need to be individually attached to media elements.


var mediaEventTypes = ['abort', 'canplay', 'canplaythrough', 'durationchange', 'emptied', 'encrypted', 'ended', 'error', 'loadeddata', 'loadedmetadata', 'loadstart', 'pause', 'play', 'playing', 'progress', 'ratechange', 'seeked', 'seeking', 'stalled', 'suspend', 'timeupdate', 'volumechange', 'waiting']; // We should not delegate these events to the container, but rather
// set them on the actual target element itself. This is primarily
// because these events do not consistently bubble in the DOM.

var nonDelegatedEvents = new Set(['cancel', 'close', 'invalid', 'load', 'scroll', 'toggle'].concat(mediaEventTypes));

function executeDispatch(event, listener, currentTarget) {
  var type = event.type || 'unknown-event';
  event.currentTarget = currentTarget;
  invokeGuardedCallbackAndCatchFirstError(type, listener, undefined, event);
  event.currentTarget = null;
}

function processDispatchQueueItemsInOrder(event, dispatchListeners, inCapturePhase) {
  var previousInstance;

  if (inCapturePhase) {
    for (var i = dispatchListeners.length - 1; i >= 0; i--) {
      var _dispatchListeners$i = dispatchListeners[i],
          instance = _dispatchListeners$i.instance,
          currentTarget = _dispatchListeners$i.currentTarget,
          listener = _dispatchListeners$i.listener;

      if (instance !== previousInstance && event.isPropagationStopped()) {
        return;
      }

      executeDispatch(event, listener, currentTarget);
      previousInstance = instance;
    }
  } else {
    for (var _i = 0; _i < dispatchListeners.length; _i++) {
      var _dispatchListeners$_i = dispatchListeners[_i],
          _instance = _dispatchListeners$_i.instance,
          _currentTarget = _dispatchListeners$_i.currentTarget,
          _listener = _dispatchListeners$_i.listener;

      if (_instance !== previousInstance && event.isPropagationStopped()) {
        return;
      }

      executeDispatch(event, _listener, _currentTarget);
      previousInstance = _instance;
    }
  }
}

function processDispatchQueue(dispatchQueue, eventSystemFlags) {
  var inCapturePhase = (eventSystemFlags & IS_CAPTURE_PHASE) !== 0;

  for (var i = 0; i < dispatchQueue.length; i++) {
    var _dispatchQueue$i = dispatchQueue[i],
        event = _dispatchQueue$i.event,
        listeners = _dispatchQueue$i.listeners;
    processDispatchQueueItemsInOrder(event, listeners, inCapturePhase); //  event system doesn't use pooling.
  } // This would be a good time to rethrow if any of the event handlers threw.


  rethrowCaughtError();
}

function dispatchEventsForPlugins(domEventName, eventSystemFlags, nativeEvent, targetInst, targetContainer) {
  var nativeEventTarget = getEventTarget(nativeEvent);
  var dispatchQueue = [];
  extractEvents$5(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget, eventSystemFlags);
  processDispatchQueue(dispatchQueue, eventSystemFlags);
}

function listenToNonDelegatedEvent(domEventName, targetElement) {
  var isCapturePhaseListener = false;
  var listenerSet = getEventListenerSet(targetElement);
  var listenerSetKey = getListenerSetKey(domEventName, isCapturePhaseListener);

  if (!listenerSet.has(listenerSetKey)) {
    addTrappedEventListener(targetElement, domEventName, IS_NON_DELEGATED, isCapturePhaseListener);
    listenerSet.add(listenerSetKey);
  }
}
var listeningMarker = '_reactListening' + Math.random().toString(36).slice(2);
function listenToAllSupportedEvents(rootContainerElement) {
  {
    if (rootContainerElement[listeningMarker]) {
      // Performance optimization: don't iterate through events
      // for the same portal container or root node more than once.
      // TODO: once we remove the flag, we may be able to also
      // remove some of the bookkeeping maps used for laziness.
      return;
    }

    rootContainerElement[listeningMarker] = true;
    allNativeEvents.forEach(function (domEventName) {
      if (!nonDelegatedEvents.has(domEventName)) {
        listenToNativeEvent(domEventName, false, rootContainerElement, null);
      }

      listenToNativeEvent(domEventName, true, rootContainerElement, null);
    });
  }
}
function listenToNativeEvent(domEventName, isCapturePhaseListener, rootContainerElement, targetElement) {
  var eventSystemFlags = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 0;
  var target = rootContainerElement; // selectionchange needs to be attached to the document
  // otherwise it won't capture incoming events that are only
  // triggered on the document directly.

  if (domEventName === 'selectionchange' && rootContainerElement.nodeType !== DOCUMENT_NODE) {
    target = rootContainerElement.ownerDocument;
  } // If the event can be delegated (or is capture phase), we can
  // register it to the root container. Otherwise, we should
  // register the event to the target element and mark it as
  // a non-delegated event.


  if (targetElement !== null && !isCapturePhaseListener && nonDelegatedEvents.has(domEventName)) {
    // For all non-delegated events, apart from scroll, we attach
    // their event listeners to the respective elements that their
    // events fire on. That means we can skip this step, as event
    // listener has already been added previously. However, we
    // special case the scroll event because the reality is that any
    // element can scroll.
    // TODO: ideally, we'd eventually apply the same logic to all
    // events from the nonDelegatedEvents list. Then we can remove
    // this special case and use the same logic for all events.
    if (domEventName !== 'scroll') {
      return;
    }

    eventSystemFlags |= IS_NON_DELEGATED;
    target = targetElement;
  }

  var listenerSet = getEventListenerSet(target);
  var listenerSetKey = getListenerSetKey(domEventName, isCapturePhaseListener); // If the listener entry is empty or we should upgrade, then
  // we need to trap an event listener onto the target.

  if (!listenerSet.has(listenerSetKey)) {
    if (isCapturePhaseListener) {
      eventSystemFlags |= IS_CAPTURE_PHASE;
    }

    addTrappedEventListener(target, domEventName, eventSystemFlags, isCapturePhaseListener);
    listenerSet.add(listenerSetKey);
  }
}

function addTrappedEventListener(targetContainer, domEventName, eventSystemFlags, isCapturePhaseListener, isDeferredListenerForLegacyFBSupport) {
  var listener = createEventListenerWrapperWithPriority(targetContainer, domEventName, eventSystemFlags); // If passive option is not supported, then the event will be
  // active and not passive.

  var isPassiveListener = undefined;

  if (passiveBrowserEventsSupported) {
    // Browsers introduced an intervention, making these events
    // passive by default on document. React doesn't bind them
    // to document anymore, but changing this now would undo
    // the performance wins from the change. So we emulate
    // the existing behavior manually on the roots now.
    // https://github.com/facebook/react/issues/19651
    if (domEventName === 'touchstart' || domEventName === 'touchmove' || domEventName === 'wheel') {
      isPassiveListener = true;
    }
  }

  targetContainer =  targetContainer;
  var unsubscribeListener; // When legacyFBSupport is enabled, it's for when we


  if (isCapturePhaseListener) {
    if (isPassiveListener !== undefined) {
      unsubscribeListener = addEventCaptureListenerWithPassiveFlag(targetContainer, domEventName, listener, isPassiveListener);
    } else {
      unsubscribeListener = addEventCaptureListener(targetContainer, domEventName, listener);
    }
  } else {
    if (isPassiveListener !== undefined) {
      unsubscribeListener = addEventBubbleListenerWithPassiveFlag(targetContainer, domEventName, listener, isPassiveListener);
    } else {
      unsubscribeListener = addEventBubbleListener(targetContainer, domEventName, listener);
    }
  }
}

function isMatchingRootContainer(grandContainer, targetContainer) {
  return grandContainer === targetContainer || grandContainer.nodeType === COMMENT_NODE && grandContainer.parentNode === targetContainer;
}

function dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, targetInst, targetContainer) {
  var ancestorInst = targetInst;

  if ((eventSystemFlags & IS_EVENT_HANDLE_NON_MANAGED_NODE) === 0 && (eventSystemFlags & IS_NON_DELEGATED) === 0) {
    var targetContainerNode = targetContainer; // If we are using the legacy FB support flag, we

    if (targetInst !== null) {
      // The below logic attempts to work out if we need to change
      // the target fiber to a different ancestor. We had similar logic
      // in the legacy event system, except the big difference between
      // systems is that the modern event system now has an event listener
      // attached to each React Root and React Portal Root. Together,
      // the DOM nodes representing these roots are the "rootContainer".
      // To figure out which ancestor instance we should use, we traverse
      // up the fiber tree from the target instance and attempt to find
      // root boundaries that match that of our current "rootContainer".
      // If we find that "rootContainer", we find the parent fiber
      // sub-tree for that root and make that our ancestor instance.
      var node = targetInst;

      mainLoop: while (true) {
        if (node === null) {
          return;
        }

        var nodeTag = node.tag;

        if (nodeTag === HostRoot || nodeTag === HostPortal) {
          var container = node.stateNode.containerInfo;

          if (isMatchingRootContainer(container, targetContainerNode)) {
            break;
          }

          if (nodeTag === HostPortal) {
            // The target is a portal, but it's not the rootContainer we're looking for.
            // Normally portals handle their own events all the way down to the root.
            // So we should be able to stop now. However, we don't know if this portal
            // was part of *our* root.
            var grandNode = node.return;

            while (grandNode !== null) {
              var grandTag = grandNode.tag;

              if (grandTag === HostRoot || grandTag === HostPortal) {
                var grandContainer = grandNode.stateNode.containerInfo;

                if (isMatchingRootContainer(grandContainer, targetContainerNode)) {
                  // This is the rootContainer we're looking for and we found it as
                  // a parent of the Portal. That means we can ignore it because the
                  // Portal will bubble through to us.
                  return;
                }
              }

              grandNode = grandNode.return;
            }
          } // Now we need to find it's corresponding host fiber in the other
          // tree. To do this we can use getClosestInstanceFromNode, but we
          // need to validate that the fiber is a host instance, otherwise
          // we need to traverse up through the DOM till we find the correct
          // node that is from the other tree.


          while (container !== null) {
            var parentNode = getClosestInstanceFromNode(container);

            if (parentNode === null) {
              return;
            }

            var parentTag = parentNode.tag;

            if (parentTag === HostComponent || parentTag === HostText) {
              node = ancestorInst = parentNode;
              continue mainLoop;
            }

            container = container.parentNode;
          }
        }

        node = node.return;
      }
    }
  }

  batchedEventUpdates(function () {
    return dispatchEventsForPlugins(domEventName, eventSystemFlags, nativeEvent, ancestorInst);
  });
}

function createDispatchListener(instance, listener, currentTarget) {
  return {
    instance: instance,
    listener: listener,
    currentTarget: currentTarget
  };
}

function accumulateSinglePhaseListeners(targetFiber, reactName, nativeEventType, inCapturePhase, accumulateTargetOnly) {
  var captureName = reactName !== null ? reactName + 'Capture' : null;
  var reactEventName = inCapturePhase ? captureName : reactName;
  var listeners = [];
  var instance = targetFiber;
  var lastHostComponent = null; // Accumulate all instances and listeners via the target -> root path.

  while (instance !== null) {
    var _instance2 = instance,
        stateNode = _instance2.stateNode,
        tag = _instance2.tag; // Handle listeners that are on HostComponents (i.e. <div>)

    if (tag === HostComponent && stateNode !== null) {
      lastHostComponent = stateNode; // createEventHandle listeners


      if (reactEventName !== null) {
        var listener = getListener(instance, reactEventName);

        if (listener != null) {
          listeners.push(createDispatchListener(instance, listener, lastHostComponent));
        }
      }
    } // If we are only accumulating events for the target, then we don't
    // continue to propagate through the React fiber tree to find other
    // listeners.


    if (accumulateTargetOnly) {
      break;
    }

    instance = instance.return;
  }

  return listeners;
} // We should only use this function for:
// - BeforeInputEventPlugin
// - ChangeEventPlugin
// - SelectEventPlugin
// This is because we only process these plugins
// in the bubble phase, so we need to accumulate two
// phase event listeners (via emulation).

function accumulateTwoPhaseListeners(targetFiber, reactName) {
  var captureName = reactName + 'Capture';
  var listeners = [];
  var instance = targetFiber; // Accumulate all instances and listeners via the target -> root path.

  while (instance !== null) {
    var _instance3 = instance,
        stateNode = _instance3.stateNode,
        tag = _instance3.tag; // Handle listeners that are on HostComponents (i.e. <div>)

    if (tag === HostComponent && stateNode !== null) {
      var currentTarget = stateNode;
      var captureListener = getListener(instance, captureName);

      if (captureListener != null) {
        listeners.unshift(createDispatchListener(instance, captureListener, currentTarget));
      }

      var bubbleListener = getListener(instance, reactName);

      if (bubbleListener != null) {
        listeners.push(createDispatchListener(instance, bubbleListener, currentTarget));
      }
    }

    instance = instance.return;
  }

  return listeners;
}

function getParent(inst) {
  if (inst === null) {
    return null;
  }

  do {
    inst = inst.return; // TODO: If this is a HostRoot we might want to bail out.
    // That is depending on if we want nested subtrees (layers) to bubble
    // events to their parent. We could also go through parentNode on the
    // host node but that wouldn't work for React Native and doesn't let us
    // do the portal feature.
  } while (inst && inst.tag !== HostComponent);

  if (inst) {
    return inst;
  }

  return null;
}
/**
 * Return the lowest common ancestor of A and B, or null if they are in
 * different trees.
 */


function getLowestCommonAncestor(instA, instB) {
  var nodeA = instA;
  var nodeB = instB;
  var depthA = 0;

  for (var tempA = nodeA; tempA; tempA = getParent(tempA)) {
    depthA++;
  }

  var depthB = 0;

  for (var tempB = nodeB; tempB; tempB = getParent(tempB)) {
    depthB++;
  } // If A is deeper, crawl up.


  while (depthA - depthB > 0) {
    nodeA = getParent(nodeA);
    depthA--;
  } // If B is deeper, crawl up.


  while (depthB - depthA > 0) {
    nodeB = getParent(nodeB);
    depthB--;
  } // Walk in lockstep until we find a match.


  var depth = depthA;

  while (depth--) {
    if (nodeA === nodeB || nodeB !== null && nodeA === nodeB.alternate) {
      return nodeA;
    }

    nodeA = getParent(nodeA);
    nodeB = getParent(nodeB);
  }

  return null;
}

function accumulateEnterLeaveListenersForEvent(dispatchQueue, event, target, common, inCapturePhase) {
  var registrationName = event._reactName;
  var listeners = [];
  var instance = target;

  while (instance !== null) {
    if (instance === common) {
      break;
    }

    var _instance4 = instance,
        alternate = _instance4.alternate,
        stateNode = _instance4.stateNode,
        tag = _instance4.tag;

    if (alternate !== null && alternate === common) {
      break;
    }

    if (tag === HostComponent && stateNode !== null) {
      var currentTarget = stateNode;

      if (inCapturePhase) {
        var captureListener = getListener(instance, registrationName);

        if (captureListener != null) {
          listeners.unshift(createDispatchListener(instance, captureListener, currentTarget));
        }
      } else if (!inCapturePhase) {
        var bubbleListener = getListener(instance, registrationName);

        if (bubbleListener != null) {
          listeners.push(createDispatchListener(instance, bubbleListener, currentTarget));
        }
      }
    }

    instance = instance.return;
  }

  if (listeners.length !== 0) {
    dispatchQueue.push({
      event: event,
      listeners: listeners
    });
  }
} // We should only use this function for:
// - EnterLeaveEventPlugin
// This is because we only process this plugin
// in the bubble phase, so we need to accumulate two
// phase event listeners.


function accumulateEnterLeaveTwoPhaseListeners(dispatchQueue, leaveEvent, enterEvent, from, to) {
  var common = from && to ? getLowestCommonAncestor(from, to) : null;

  if (from !== null) {
    accumulateEnterLeaveListenersForEvent(dispatchQueue, leaveEvent, from, common, false);
  }

  if (to !== null && enterEvent !== null) {
    accumulateEnterLeaveListenersForEvent(dispatchQueue, enterEvent, to, common, true);
  }
}
function getListenerSetKey(domEventName, capture) {
  return domEventName + "__" + (capture ? 'capture' : 'bubble');
}

var didWarnInvalidHydration = false;
var DANGEROUSLY_SET_INNER_HTML = 'dangerouslySetInnerHTML';
var SUPPRESS_CONTENT_EDITABLE_WARNING = 'suppressContentEditableWarning';
var SUPPRESS_HYDRATION_WARNING = 'suppressHydrationWarning';
var AUTOFOCUS = 'autoFocus';
var CHILDREN = 'children';
var STYLE = 'style';
var HTML$1 = '__html';
var HTML_NAMESPACE$1 = Namespaces.html;
var warnedUnknownTags;
var suppressHydrationWarning;
var validatePropertiesInDevelopment;
var warnForTextDifference;
var warnForPropDifference;
var warnForExtraAttributes;
var warnForInvalidEventListener;
var canDiffStyleForHydrationWarning;
var normalizeMarkupForTextOrAttribute;
var normalizeHTML;

{
  warnedUnknownTags = {
    // There are working polyfills for <dialog>. Let people use it.
    dialog: true,
    // Electron ships a custom <webview> tag to display external web content in
    // an isolated frame and process.
    // This tag is not present in non Electron environments such as JSDom which
    // is often used for testing purposes.
    // @see https://electronjs.org/docs/api/webview-tag
    webview: true
  };

  validatePropertiesInDevelopment = function (type, props) {
    validateProperties(type, props);
    validateProperties$1(type, props);
    validateProperties$2(type, props, {
      registrationNameDependencies: registrationNameDependencies,
      possibleRegistrationNames: possibleRegistrationNames
    });
  }; // IE 11 parses & normalizes the style attribute as opposed to other
  // browsers. It adds spaces and sorts the properties in some
  // non-alphabetical order. Handling that would require sorting CSS
  // properties in the client & server versions or applying
  // `expectedStyle` to a temporary DOM node to read its `style` attribute
  // normalized. Since it only affects IE, we're skipping style warnings
  // in that browser completely in favor of doing all that work.
  // See https://github.com/facebook/react/issues/11807


  canDiffStyleForHydrationWarning = canUseDOM && !document.documentMode; // HTML parsing normalizes CR and CRLF to LF.
  // It also can turn \u0000 into \uFFFD inside attributes.
  // https://www.w3.org/TR/html5/single-page.html#preprocessing-the-input-stream
  // If we have a mismatch, it might be caused by that.
  // We will still patch up in this case but not fire the warning.

  var NORMALIZE_NEWLINES_REGEX = /\r\n?/g;
  var NORMALIZE_NULL_AND_REPLACEMENT_REGEX = /\u0000|\uFFFD/g;

  normalizeMarkupForTextOrAttribute = function (markup) {
    var markupString = typeof markup === 'string' ? markup : '' + markup;
    return markupString.replace(NORMALIZE_NEWLINES_REGEX, '\n').replace(NORMALIZE_NULL_AND_REPLACEMENT_REGEX, '');
  };

  warnForTextDifference = function (serverText, clientText) {
    if (didWarnInvalidHydration) {
      return;
    }

    var normalizedClientText = normalizeMarkupForTextOrAttribute(clientText);
    var normalizedServerText = normalizeMarkupForTextOrAttribute(serverText);

    if (normalizedServerText === normalizedClientText) {
      return;
    }

    didWarnInvalidHydration = true;

    error('Text content did not match. Server: "%s" Client: "%s"', normalizedServerText, normalizedClientText);
  };

  warnForPropDifference = function (propName, serverValue, clientValue) {
    if (didWarnInvalidHydration) {
      return;
    }

    var normalizedClientValue = normalizeMarkupForTextOrAttribute(clientValue);
    var normalizedServerValue = normalizeMarkupForTextOrAttribute(serverValue);

    if (normalizedServerValue === normalizedClientValue) {
      return;
    }

    didWarnInvalidHydration = true;

    error('Prop `%s` did not match. Server: %s Client: %s', propName, JSON.stringify(normalizedServerValue), JSON.stringify(normalizedClientValue));
  };

  warnForExtraAttributes = function (attributeNames) {
    if (didWarnInvalidHydration) {
      return;
    }

    didWarnInvalidHydration = true;
    var names = [];
    attributeNames.forEach(function (name) {
      names.push(name);
    });

    error('Extra attributes from the server: %s', names);
  };

  warnForInvalidEventListener = function (registrationName, listener) {
    if (listener === false) {
      error('Expected `%s` listener to be a function, instead got `false`.\n\n' + 'If you used to conditionally omit it with %s={condition && value}, ' + 'pass %s={condition ? value : undefined} instead.', registrationName, registrationName, registrationName);
    } else {
      error('Expected `%s` listener to be a function, instead got a value of `%s` type.', registrationName, typeof listener);
    }
  }; // Parse the HTML and read it back to normalize the HTML string so that it
  // can be used for comparison.


  normalizeHTML = function (parent, html) {
    // We could have created a separate document here to avoid
    // re-initializing custom elements if they exist. But this breaks
    // how <noscript> is being handled. So we use the same document.
    // See the discussion in https://github.com/facebook/react/pull/11157.
    var testElement = parent.namespaceURI === HTML_NAMESPACE$1 ? parent.ownerDocument.createElement(parent.tagName) : parent.ownerDocument.createElementNS(parent.namespaceURI, parent.tagName);
    testElement.innerHTML = html;
    return testElement.innerHTML;
  };
}

function getOwnerDocumentFromRootContainer(rootContainerElement) {
  return rootContainerElement.nodeType === DOCUMENT_NODE ? rootContainerElement : rootContainerElement.ownerDocument;
}

function noop() {}

function trapClickOnNonInteractiveElement(node) {
  // Mobile Safari does not fire properly bubble click events on
  // non-interactive elements, which means delegated click listeners do not
  // fire. The workaround for this bug involves attaching an empty click
  // listener on the target node.
  // https://www.quirksmode.org/blog/archives/2010/09/click_event_del.html
  // Just set it using the onclick property so that we don't have to manage any
  // bookkeeping for it. Not sure if we need to clear it when the listener is
  // removed.
  // TODO: Only do this for the relevant Safaris maybe?
  node.onclick = noop;
}

function setInitialDOMProperties(tag, domElement, rootContainerElement, nextProps, isCustomComponentTag) {
  for (var propKey in nextProps) {
    if (!nextProps.hasOwnProperty(propKey)) {
      continue;
    }

    var nextProp = nextProps[propKey];

    if (propKey === STYLE) {
      {
        if (nextProp) {
          // Freeze the next style object so that we can assume it won't be
          // mutated. We have already warned for this in the past.
          Object.freeze(nextProp);
        }
      } // Relies on `updateStylesByID` not mutating `styleUpdates`.


      setValueForStyles(domElement, nextProp);
    } else if (propKey === DANGEROUSLY_SET_INNER_HTML) {
      var nextHtml = nextProp ? nextProp[HTML$1] : undefined;

      if (nextHtml != null) {
        setInnerHTML(domElement, nextHtml);
      }
    } else if (propKey === CHILDREN) {
      if (typeof nextProp === 'string') {
        // Avoid setting initial textContent when the text is empty. In IE11 setting
        // textContent on a <textarea> will cause the placeholder to not
        // show within the <textarea> until it has been focused and blurred again.
        // https://github.com/facebook/react/issues/6731#issuecomment-254874553
        var canSetTextContent = tag !== 'textarea' || nextProp !== '';

        if (canSetTextContent) {
          setTextContent(domElement, nextProp);
        }
      } else if (typeof nextProp === 'number') {
        setTextContent(domElement, '' + nextProp);
      }
    } else if (propKey === SUPPRESS_CONTENT_EDITABLE_WARNING || propKey === SUPPRESS_HYDRATION_WARNING) ; else if (propKey === AUTOFOCUS) ; else if (registrationNameDependencies.hasOwnProperty(propKey)) {
      if (nextProp != null) {
        if ( typeof nextProp !== 'function') {
          warnForInvalidEventListener(propKey, nextProp);
        }

        if (propKey === 'onScroll') {
          listenToNonDelegatedEvent('scroll', domElement);
        }
      }
    } else if (nextProp != null) {
      setValueForProperty(domElement, propKey, nextProp, isCustomComponentTag);
    }
  }
}

function updateDOMProperties(domElement, updatePayload, wasCustomComponentTag, isCustomComponentTag) {
  // TODO: Handle wasCustomComponentTag
  for (var i = 0; i < updatePayload.length; i += 2) {
    var propKey = updatePayload[i];
    var propValue = updatePayload[i + 1];

    if (propKey === STYLE) {
      setValueForStyles(domElement, propValue);
    } else if (propKey === DANGEROUSLY_SET_INNER_HTML) {
      setInnerHTML(domElement, propValue);
    } else if (propKey === CHILDREN) {
      setTextContent(domElement, propValue);
    } else {
      setValueForProperty(domElement, propKey, propValue, isCustomComponentTag);
    }
  }
}

function createElement(type, props, rootContainerElement, parentNamespace) {
  var isCustomComponentTag; // We create tags in the namespace of their parent container, except HTML
  // tags get no namespace.

  var ownerDocument = getOwnerDocumentFromRootContainer(rootContainerElement);
  var domElement;
  var namespaceURI = parentNamespace;

  if (namespaceURI === HTML_NAMESPACE$1) {
    namespaceURI = getIntrinsicNamespace(type);
  }

  if (namespaceURI === HTML_NAMESPACE$1) {
    {
      isCustomComponentTag = isCustomComponent(type, props); // Should this check be gated by parent namespace? Not sure we want to
      // allow <SVG> or <mATH>.

      if (!isCustomComponentTag && type !== type.toLowerCase()) {
        error('<%s /> is using incorrect casing. ' + 'Use PascalCase for React components, ' + 'or lowercase for HTML elements.', type);
      }
    }

    if (type === 'script') {
      // Create the script via .innerHTML so its "parser-inserted" flag is
      // set to true and it does not execute
      var div = ownerDocument.createElement('div');

      div.innerHTML = '<script><' + '/script>'; // eslint-disable-line
      // This is guaranteed to yield a script element.

      var firstChild = div.firstChild;
      domElement = div.removeChild(firstChild);
    } else if (typeof props.is === 'string') {
      // $FlowIssue `createElement` should be updated for Web Components
      domElement = ownerDocument.createElement(type, {
        is: props.is
      });
    } else {
      // Separate else branch instead of using `props.is || undefined` above because of a Firefox bug.
      // See discussion in https://github.com/facebook/react/pull/6896
      // and discussion in https://bugzilla.mozilla.org/show_bug.cgi?id=1276240
      domElement = ownerDocument.createElement(type); // Normally attributes are assigned in `setInitialDOMProperties`, however the `multiple` and `size`
      // attributes on `select`s needs to be added before `option`s are inserted.
      // This prevents:
      // - a bug where the `select` does not scroll to the correct option because singular
      //  `select` elements automatically pick the first item #13222
      // - a bug where the `select` set the first item as selected despite the `size` attribute #14239
      // See https://github.com/facebook/react/issues/13222
      // and https://github.com/facebook/react/issues/14239

      if (type === 'select') {
        var node = domElement;

        if (props.multiple) {
          node.multiple = true;
        } else if (props.size) {
          // Setting a size greater than 1 causes a select to behave like `multiple=true`, where
          // it is possible that no option is selected.
          //
          // This is only necessary when a select in "single selection mode".
          node.size = props.size;
        }
      }
    }
  } else {
    domElement = ownerDocument.createElementNS(namespaceURI, type);
  }

  {
    if (namespaceURI === HTML_NAMESPACE$1) {
      if (!isCustomComponentTag && Object.prototype.toString.call(domElement) === '[object HTMLUnknownElement]' && !Object.prototype.hasOwnProperty.call(warnedUnknownTags, type)) {
        warnedUnknownTags[type] = true;

        error('The tag <%s> is unrecognized in this browser. ' + 'If you meant to render a React component, start its name with ' + 'an uppercase letter.', type);
      }
    }
  }

  return domElement;
}
function createTextNode(text, rootContainerElement) {
  return getOwnerDocumentFromRootContainer(rootContainerElement).createTextNode(text);
}
function setInitialProperties(domElement, tag, rawProps, rootContainerElement) {
  var isCustomComponentTag = isCustomComponent(tag, rawProps);

  {
    validatePropertiesInDevelopment(tag, rawProps);
  } // TODO: Make sure that we check isMounted before firing any of these events.


  var props;

  switch (tag) {
    case 'dialog':
      listenToNonDelegatedEvent('cancel', domElement);
      listenToNonDelegatedEvent('close', domElement);
      props = rawProps;
      break;

    case 'iframe':
    case 'object':
    case 'embed':
      // We listen to this event in case to ensure emulated bubble
      // listeners still fire for the load event.
      listenToNonDelegatedEvent('load', domElement);
      props = rawProps;
      break;

    case 'video':
    case 'audio':
      // We listen to these events in case to ensure emulated bubble
      // listeners still fire for all the media events.
      for (var i = 0; i < mediaEventTypes.length; i++) {
        listenToNonDelegatedEvent(mediaEventTypes[i], domElement);
      }

      props = rawProps;
      break;

    case 'source':
      // We listen to this event in case to ensure emulated bubble
      // listeners still fire for the error event.
      listenToNonDelegatedEvent('error', domElement);
      props = rawProps;
      break;

    case 'img':
    case 'image':
    case 'link':
      // We listen to these events in case to ensure emulated bubble
      // listeners still fire for error and load events.
      listenToNonDelegatedEvent('error', domElement);
      listenToNonDelegatedEvent('load', domElement);
      props = rawProps;
      break;

    case 'details':
      // We listen to this event in case to ensure emulated bubble
      // listeners still fire for the toggle event.
      listenToNonDelegatedEvent('toggle', domElement);
      props = rawProps;
      break;

    case 'input':
      initWrapperState(domElement, rawProps);
      props = getHostProps(domElement, rawProps); // We listen to this event in case to ensure emulated bubble
      // listeners still fire for the invalid event.

      listenToNonDelegatedEvent('invalid', domElement);

      break;

    case 'option':
      validateProps(domElement, rawProps);
      props = getHostProps$1(domElement, rawProps);
      break;

    case 'select':
      initWrapperState$1(domElement, rawProps);
      props = getHostProps$2(domElement, rawProps); // We listen to this event in case to ensure emulated bubble
      // listeners still fire for the invalid event.

      listenToNonDelegatedEvent('invalid', domElement);

      break;

    case 'textarea':
      initWrapperState$2(domElement, rawProps);
      props = getHostProps$3(domElement, rawProps); // We listen to this event in case to ensure emulated bubble
      // listeners still fire for the invalid event.

      listenToNonDelegatedEvent('invalid', domElement);

      break;

    default:
      props = rawProps;
  }

  assertValidProps(tag, props);
  setInitialDOMProperties(tag, domElement, rootContainerElement, props, isCustomComponentTag);

  switch (tag) {
    case 'input':
      // TODO: Make sure we check if this is still unmounted or do any clean
      // up necessary since we never stop tracking anymore.
      track(domElement);
      postMountWrapper(domElement, rawProps, false);
      break;

    case 'textarea':
      // TODO: Make sure we check if this is still unmounted or do any clean
      // up necessary since we never stop tracking anymore.
      track(domElement);
      postMountWrapper$3(domElement);
      break;

    case 'option':
      postMountWrapper$1(domElement, rawProps);
      break;

    case 'select':
      postMountWrapper$2(domElement, rawProps);
      break;

    default:
      if (typeof props.onClick === 'function') {
        // TODO: This cast may not be sound for SVG, MathML or custom elements.
        trapClickOnNonInteractiveElement(domElement);
      }

      break;
  }
} // Calculate the diff between the two objects.

function diffProperties(domElement, tag, lastRawProps, nextRawProps, rootContainerElement) {
  {
    validatePropertiesInDevelopment(tag, nextRawProps);
  }

  var updatePayload = null;
  var lastProps;
  var nextProps;

  switch (tag) {
    case 'input':
      lastProps = getHostProps(domElement, lastRawProps);
      nextProps = getHostProps(domElement, nextRawProps);
      updatePayload = [];
      break;

    case 'option':
      lastProps = getHostProps$1(domElement, lastRawProps);
      nextProps = getHostProps$1(domElement, nextRawProps);
      updatePayload = [];
      break;

    case 'select':
      lastProps = getHostProps$2(domElement, lastRawProps);
      nextProps = getHostProps$2(domElement, nextRawProps);
      updatePayload = [];
      break;

    case 'textarea':
      lastProps = getHostProps$3(domElement, lastRawProps);
      nextProps = getHostProps$3(domElement, nextRawProps);
      updatePayload = [];
      break;

    default:
      lastProps = lastRawProps;
      nextProps = nextRawProps;

      if (typeof lastProps.onClick !== 'function' && typeof nextProps.onClick === 'function') {
        // TODO: This cast may not be sound for SVG, MathML or custom elements.
        trapClickOnNonInteractiveElement(domElement);
      }

      break;
  }

  assertValidProps(tag, nextProps);
  var propKey;
  var styleName;
  var styleUpdates = null;

  for (propKey in lastProps) {
    if (nextProps.hasOwnProperty(propKey) || !lastProps.hasOwnProperty(propKey) || lastProps[propKey] == null) {
      continue;
    }

    if (propKey === STYLE) {
      var lastStyle = lastProps[propKey];

      for (styleName in lastStyle) {
        if (lastStyle.hasOwnProperty(styleName)) {
          if (!styleUpdates) {
            styleUpdates = {};
          }

          styleUpdates[styleName] = '';
        }
      }
    } else if (propKey === DANGEROUSLY_SET_INNER_HTML || propKey === CHILDREN) ; else if (propKey === SUPPRESS_CONTENT_EDITABLE_WARNING || propKey === SUPPRESS_HYDRATION_WARNING) ; else if (propKey === AUTOFOCUS) ; else if (registrationNameDependencies.hasOwnProperty(propKey)) {
      // This is a special case. If any listener updates we need to ensure
      // that the "current" fiber pointer gets updated so we need a commit
      // to update this element.
      if (!updatePayload) {
        updatePayload = [];
      }
    } else {
      // For all other deleted properties we add it to the queue. We use
      // the allowed property list in the commit phase instead.
      (updatePayload = updatePayload || []).push(propKey, null);
    }
  }

  for (propKey in nextProps) {
    var nextProp = nextProps[propKey];
    var lastProp = lastProps != null ? lastProps[propKey] : undefined;

    if (!nextProps.hasOwnProperty(propKey) || nextProp === lastProp || nextProp == null && lastProp == null) {
      continue;
    }

    if (propKey === STYLE) {
      {
        if (nextProp) {
          // Freeze the next style object so that we can assume it won't be
          // mutated. We have already warned for this in the past.
          Object.freeze(nextProp);
        }
      }

      if (lastProp) {
        // Unset styles on `lastProp` but not on `nextProp`.
        for (styleName in lastProp) {
          if (lastProp.hasOwnProperty(styleName) && (!nextProp || !nextProp.hasOwnProperty(styleName))) {
            if (!styleUpdates) {
              styleUpdates = {};
            }

            styleUpdates[styleName] = '';
          }
        } // Update styles that changed since `lastProp`.


        for (styleName in nextProp) {
          if (nextProp.hasOwnProperty(styleName) && lastProp[styleName] !== nextProp[styleName]) {
            if (!styleUpdates) {
              styleUpdates = {};
            }

            styleUpdates[styleName] = nextProp[styleName];
          }
        }
      } else {
        // Relies on `updateStylesByID` not mutating `styleUpdates`.
        if (!styleUpdates) {
          if (!updatePayload) {
            updatePayload = [];
          }

          updatePayload.push(propKey, styleUpdates);
        }

        styleUpdates = nextProp;
      }
    } else if (propKey === DANGEROUSLY_SET_INNER_HTML) {
      var nextHtml = nextProp ? nextProp[HTML$1] : undefined;
      var lastHtml = lastProp ? lastProp[HTML$1] : undefined;

      if (nextHtml != null) {
        if (lastHtml !== nextHtml) {
          (updatePayload = updatePayload || []).push(propKey, nextHtml);
        }
      }
    } else if (propKey === CHILDREN) {
      if (typeof nextProp === 'string' || typeof nextProp === 'number') {
        (updatePayload = updatePayload || []).push(propKey, '' + nextProp);
      }
    } else if (propKey === SUPPRESS_CONTENT_EDITABLE_WARNING || propKey === SUPPRESS_HYDRATION_WARNING) ; else if (registrationNameDependencies.hasOwnProperty(propKey)) {
      if (nextProp != null) {
        // We eagerly listen to this even though we haven't committed yet.
        if ( typeof nextProp !== 'function') {
          warnForInvalidEventListener(propKey, nextProp);
        }

        if (propKey === 'onScroll') {
          listenToNonDelegatedEvent('scroll', domElement);
        }
      }

      if (!updatePayload && lastProp !== nextProp) {
        // This is a special case. If any listener updates we need to ensure
        // that the "current" props pointer gets updated so we need a commit
        // to update this element.
        updatePayload = [];
      }
    } else if (typeof nextProp === 'object' && nextProp !== null && nextProp.$$typeof === REACT_OPAQUE_ID_TYPE) {
      // If we encounter useOpaqueReference's opaque object, this means we are hydrating.
      // In this case, call the opaque object's toString function which generates a new client
      // ID so client and server IDs match and throws to rerender.
      nextProp.toString();
    } else {
      // For any other property we always add it to the queue and then we
      // filter it out using the allowed property list during the commit.
      (updatePayload = updatePayload || []).push(propKey, nextProp);
    }
  }

  if (styleUpdates) {
    {
      validateShorthandPropertyCollisionInDev(styleUpdates, nextProps[STYLE]);
    }

    (updatePayload = updatePayload || []).push(STYLE, styleUpdates);
  }

  return updatePayload;
} // Apply the diff.

function updateProperties(domElement, updatePayload, tag, lastRawProps, nextRawProps) {
  // Update checked *before* name.
  // In the middle of an update, it is possible to have multiple checked.
  // When a checked radio tries to change name, browser makes another radio's checked false.
  if (tag === 'input' && nextRawProps.type === 'radio' && nextRawProps.name != null) {
    updateChecked(domElement, nextRawProps);
  }

  var wasCustomComponentTag = isCustomComponent(tag, lastRawProps);
  var isCustomComponentTag = isCustomComponent(tag, nextRawProps); // Apply the diff.

  updateDOMProperties(domElement, updatePayload, wasCustomComponentTag, isCustomComponentTag); // TODO: Ensure that an update gets scheduled if any of the special props
  // changed.

  switch (tag) {
    case 'input':
      // Update the wrapper around inputs *after* updating props. This has to
      // happen after `updateDOMProperties`. Otherwise HTML5 input validations
      // raise warnings and prevent the new value from being assigned.
      updateWrapper(domElement, nextRawProps);
      break;

    case 'textarea':
      updateWrapper$1(domElement, nextRawProps);
      break;

    case 'select':
      // <select> value update needs to occur after <option> children
      // reconciliation
      postUpdateWrapper(domElement, nextRawProps);
      break;
  }
}

function getPossibleStandardName(propName) {
  {
    var lowerCasedName = propName.toLowerCase();

    if (!possibleStandardNames.hasOwnProperty(lowerCasedName)) {
      return null;
    }

    return possibleStandardNames[lowerCasedName] || null;
  }
}

function diffHydratedProperties(domElement, tag, rawProps, parentNamespace, rootContainerElement) {
  var isCustomComponentTag;
  var extraAttributeNames;

  {
    suppressHydrationWarning = rawProps[SUPPRESS_HYDRATION_WARNING] === true;
    isCustomComponentTag = isCustomComponent(tag, rawProps);
    validatePropertiesInDevelopment(tag, rawProps);
  } // TODO: Make sure that we check isMounted before firing any of these events.


  switch (tag) {
    case 'dialog':
      listenToNonDelegatedEvent('cancel', domElement);
      listenToNonDelegatedEvent('close', domElement);
      break;

    case 'iframe':
    case 'object':
    case 'embed':
      // We listen to this event in case to ensure emulated bubble
      // listeners still fire for the load event.
      listenToNonDelegatedEvent('load', domElement);
      break;

    case 'video':
    case 'audio':
      // We listen to these events in case to ensure emulated bubble
      // listeners still fire for all the media events.
      for (var i = 0; i < mediaEventTypes.length; i++) {
        listenToNonDelegatedEvent(mediaEventTypes[i], domElement);
      }

      break;

    case 'source':
      // We listen to this event in case to ensure emulated bubble
      // listeners still fire for the error event.
      listenToNonDelegatedEvent('error', domElement);
      break;

    case 'img':
    case 'image':
    case 'link':
      // We listen to these events in case to ensure emulated bubble
      // listeners still fire for error and load events.
      listenToNonDelegatedEvent('error', domElement);
      listenToNonDelegatedEvent('load', domElement);
      break;

    case 'details':
      // We listen to this event in case to ensure emulated bubble
      // listeners still fire for the toggle event.
      listenToNonDelegatedEvent('toggle', domElement);
      break;

    case 'input':
      initWrapperState(domElement, rawProps); // We listen to this event in case to ensure emulated bubble
      // listeners still fire for the invalid event.

      listenToNonDelegatedEvent('invalid', domElement);

      break;

    case 'option':
      validateProps(domElement, rawProps);
      break;

    case 'select':
      initWrapperState$1(domElement, rawProps); // We listen to this event in case to ensure emulated bubble
      // listeners still fire for the invalid event.

      listenToNonDelegatedEvent('invalid', domElement);

      break;

    case 'textarea':
      initWrapperState$2(domElement, rawProps); // We listen to this event in case to ensure emulated bubble
      // listeners still fire for the invalid event.

      listenToNonDelegatedEvent('invalid', domElement);

      break;
  }

  assertValidProps(tag, rawProps);

  {
    extraAttributeNames = new Set();
    var attributes = domElement.attributes;

    for (var _i = 0; _i < attributes.length; _i++) {
      var name = attributes[_i].name.toLowerCase();

      switch (name) {
        // Built-in SSR attribute is allowed
        case 'data-reactroot':
          break;
        // Controlled attributes are not validated
        // TODO: Only ignore them on controlled tags.

        case 'value':
          break;

        case 'checked':
          break;

        case 'selected':
          break;

        default:
          // Intentionally use the original name.
          // See discussion in https://github.com/facebook/react/pull/10676.
          extraAttributeNames.add(attributes[_i].name);
      }
    }
  }

  var updatePayload = null;

  for (var propKey in rawProps) {
    if (!rawProps.hasOwnProperty(propKey)) {
      continue;
    }

    var nextProp = rawProps[propKey];

    if (propKey === CHILDREN) {
      // For text content children we compare against textContent. This
      // might match additional HTML that is hidden when we read it using
      // textContent. E.g. "foo" will match "f<span>oo</span>" but that still
      // satisfies our requirement. Our requirement is not to produce perfect
      // HTML and attributes. Ideally we should preserve structure but it's
      // ok not to if the visible content is still enough to indicate what
      // even listeners these nodes might be wired up to.
      // TODO: Warn if there is more than a single textNode as a child.
      // TODO: Should we use domElement.firstChild.nodeValue to compare?
      if (typeof nextProp === 'string') {
        if (domElement.textContent !== nextProp) {
          if ( !suppressHydrationWarning) {
            warnForTextDifference(domElement.textContent, nextProp);
          }

          updatePayload = [CHILDREN, nextProp];
        }
      } else if (typeof nextProp === 'number') {
        if (domElement.textContent !== '' + nextProp) {
          if ( !suppressHydrationWarning) {
            warnForTextDifference(domElement.textContent, nextProp);
          }

          updatePayload = [CHILDREN, '' + nextProp];
        }
      }
    } else if (registrationNameDependencies.hasOwnProperty(propKey)) {
      if (nextProp != null) {
        if ( typeof nextProp !== 'function') {
          warnForInvalidEventListener(propKey, nextProp);
        }

        if (propKey === 'onScroll') {
          listenToNonDelegatedEvent('scroll', domElement);
        }
      }
    } else if ( // Convince Flow we've calculated it (it's DEV-only in this method.)
    typeof isCustomComponentTag === 'boolean') {
      // Validate that the properties correspond to their expected values.
      var serverValue = void 0;
      var propertyInfo = getPropertyInfo(propKey);

      if (suppressHydrationWarning) ; else if (propKey === SUPPRESS_CONTENT_EDITABLE_WARNING || propKey === SUPPRESS_HYDRATION_WARNING || // Controlled attributes are not validated
      // TODO: Only ignore them on controlled tags.
      propKey === 'value' || propKey === 'checked' || propKey === 'selected') ; else if (propKey === DANGEROUSLY_SET_INNER_HTML) {
        var serverHTML = domElement.innerHTML;
        var nextHtml = nextProp ? nextProp[HTML$1] : undefined;

        if (nextHtml != null) {
          var expectedHTML = normalizeHTML(domElement, nextHtml);

          if (expectedHTML !== serverHTML) {
            warnForPropDifference(propKey, serverHTML, expectedHTML);
          }
        }
      } else if (propKey === STYLE) {
        // $FlowFixMe - Should be inferred as not undefined.
        extraAttributeNames.delete(propKey);

        if (canDiffStyleForHydrationWarning) {
          var expectedStyle = createDangerousStringForStyles(nextProp);
          serverValue = domElement.getAttribute('style');

          if (expectedStyle !== serverValue) {
            warnForPropDifference(propKey, serverValue, expectedStyle);
          }
        }
      } else if (isCustomComponentTag) {
        // $FlowFixMe - Should be inferred as not undefined.
        extraAttributeNames.delete(propKey.toLowerCase());
        serverValue = getValueForAttribute(domElement, propKey, nextProp);

        if (nextProp !== serverValue) {
          warnForPropDifference(propKey, serverValue, nextProp);
        }
      } else if (!shouldIgnoreAttribute(propKey, propertyInfo, isCustomComponentTag) && !shouldRemoveAttribute(propKey, nextProp, propertyInfo, isCustomComponentTag)) {
        var isMismatchDueToBadCasing = false;

        if (propertyInfo !== null) {
          // $FlowFixMe - Should be inferred as not undefined.
          extraAttributeNames.delete(propertyInfo.attributeName);
          serverValue = getValueForProperty(domElement, propKey, nextProp, propertyInfo);
        } else {
          var ownNamespace = parentNamespace;

          if (ownNamespace === HTML_NAMESPACE$1) {
            ownNamespace = getIntrinsicNamespace(tag);
          }

          if (ownNamespace === HTML_NAMESPACE$1) {
            // $FlowFixMe - Should be inferred as not undefined.
            extraAttributeNames.delete(propKey.toLowerCase());
          } else {
            var standardName = getPossibleStandardName(propKey);

            if (standardName !== null && standardName !== propKey) {
              // If an SVG prop is supplied with bad casing, it will
              // be successfully parsed from HTML, but will produce a mismatch
              // (and would be incorrectly rendered on the client).
              // However, we already warn about bad casing elsewhere.
              // So we'll skip the misleading extra mismatch warning in this case.
              isMismatchDueToBadCasing = true; // $FlowFixMe - Should be inferred as not undefined.

              extraAttributeNames.delete(standardName);
            } // $FlowFixMe - Should be inferred as not undefined.


            extraAttributeNames.delete(propKey);
          }

          serverValue = getValueForAttribute(domElement, propKey, nextProp);
        }

        if (nextProp !== serverValue && !isMismatchDueToBadCasing) {
          warnForPropDifference(propKey, serverValue, nextProp);
        }
      }
    }
  }

  {
    // $FlowFixMe - Should be inferred as not undefined.
    if (extraAttributeNames.size > 0 && !suppressHydrationWarning) {
      // $FlowFixMe - Should be inferred as not undefined.
      warnForExtraAttributes(extraAttributeNames);
    }
  }

  switch (tag) {
    case 'input':
      // TODO: Make sure we check if this is still unmounted or do any clean
      // up necessary since we never stop tracking anymore.
      track(domElement);
      postMountWrapper(domElement, rawProps, true);
      break;

    case 'textarea':
      // TODO: Make sure we check if this is still unmounted or do any clean
      // up necessary since we never stop tracking anymore.
      track(domElement);
      postMountWrapper$3(domElement);
      break;

    case 'select':
    case 'option':
      // For input and textarea we current always set the value property at
      // post mount to force it to diverge from attributes. However, for
      // option and select we don't quite do the same thing and select
      // is not resilient to the DOM state changing so we don't do that here.
      // TODO: Consider not doing this for input and textarea.
      break;

    default:
      if (typeof rawProps.onClick === 'function') {
        // TODO: This cast may not be sound for SVG, MathML or custom elements.
        trapClickOnNonInteractiveElement(domElement);
      }

      break;
  }

  return updatePayload;
}
function diffHydratedText(textNode, text) {
  var isDifferent = textNode.nodeValue !== text;
  return isDifferent;
}
function warnForUnmatchedText(textNode, text) {
  {
    warnForTextDifference(textNode.nodeValue, text);
  }
}
function warnForDeletedHydratableElement(parentNode, child) {
  {
    if (didWarnInvalidHydration) {
      return;
    }

    didWarnInvalidHydration = true;

    error('Did not expect server HTML to contain a <%s> in <%s>.', child.nodeName.toLowerCase(), parentNode.nodeName.toLowerCase());
  }
}
function warnForDeletedHydratableText(parentNode, child) {
  {
    if (didWarnInvalidHydration) {
      return;
    }

    didWarnInvalidHydration = true;

    error('Did not expect server HTML to contain the text node "%s" in <%s>.', child.nodeValue, parentNode.nodeName.toLowerCase());
  }
}
function warnForInsertedHydratedElement(parentNode, tag, props) {
  {
    if (didWarnInvalidHydration) {
      return;
    }

    didWarnInvalidHydration = true;

    error('Expected server HTML to contain a matching <%s> in <%s>.', tag, parentNode.nodeName.toLowerCase());
  }
}
function warnForInsertedHydratedText(parentNode, text) {
  {
    if (text === '') {
      // We expect to insert empty text nodes since they're not represented in
      // the HTML.
      // TODO: Remove this special case if we can just avoid inserting empty
      // text nodes.
      return;
    }

    if (didWarnInvalidHydration) {
      return;
    }

    didWarnInvalidHydration = true;

    error('Expected server HTML to contain a matching text node for "%s" in <%s>.', text, parentNode.nodeName.toLowerCase());
  }
}
function restoreControlledState$3(domElement, tag, props) {
  switch (tag) {
    case 'input':
      restoreControlledState(domElement, props);
      return;

    case 'textarea':
      restoreControlledState$2(domElement, props);
      return;

    case 'select':
      restoreControlledState$1(domElement, props);
      return;
  }
}

var validateDOMNesting = function () {};

var updatedAncestorInfo = function () {};

{
  // This validation code was written based on the HTML5 parsing spec:
  // https://html.spec.whatwg.org/multipage/syntax.html#has-an-element-in-scope
  //
  // Note: this does not catch all invalid nesting, nor does it try to (as it's
  // not clear what practical benefit doing so provides); instead, we warn only
  // for cases where the parser will give a parse tree differing from what React
  // intended. For example, <b><div></div></b> is invalid but we don't warn
  // because it still parses correctly; we do warn for other cases like nested
  // <p> tags where the beginning of the second element implicitly closes the
  // first, causing a confusing mess.
  // https://html.spec.whatwg.org/multipage/syntax.html#special
  var specialTags = ['address', 'applet', 'area', 'article', 'aside', 'base', 'basefont', 'bgsound', 'blockquote', 'body', 'br', 'button', 'caption', 'center', 'col', 'colgroup', 'dd', 'details', 'dir', 'div', 'dl', 'dt', 'embed', 'fieldset', 'figcaption', 'figure', 'footer', 'form', 'frame', 'frameset', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'head', 'header', 'hgroup', 'hr', 'html', 'iframe', 'img', 'input', 'isindex', 'li', 'link', 'listing', 'main', 'marquee', 'menu', 'menuitem', 'meta', 'nav', 'noembed', 'noframes', 'noscript', 'object', 'ol', 'p', 'param', 'plaintext', 'pre', 'script', 'section', 'select', 'source', 'style', 'summary', 'table', 'tbody', 'td', 'template', 'textarea', 'tfoot', 'th', 'thead', 'title', 'tr', 'track', 'ul', 'wbr', 'xmp']; // https://html.spec.whatwg.org/multipage/syntax.html#has-an-element-in-scope

  var inScopeTags = ['applet', 'caption', 'html', 'table', 'td', 'th', 'marquee', 'object', 'template', // https://html.spec.whatwg.org/multipage/syntax.html#html-integration-point
  // TODO: Distinguish by namespace here -- for <title>, including it here
  // errs on the side of fewer warnings
  'foreignObject', 'desc', 'title']; // https://html.spec.whatwg.org/multipage/syntax.html#has-an-element-in-button-scope

  var buttonScopeTags = inScopeTags.concat(['button']); // https://html.spec.whatwg.org/multipage/syntax.html#generate-implied-end-tags

  var impliedEndTags = ['dd', 'dt', 'li', 'option', 'optgroup', 'p', 'rp', 'rt'];
  var emptyAncestorInfo = {
    current: null,
    formTag: null,
    aTagInScope: null,
    buttonTagInScope: null,
    nobrTagInScope: null,
    pTagInButtonScope: null,
    listItemTagAutoclosing: null,
    dlItemTagAutoclosing: null
  };

  updatedAncestorInfo = function (oldInfo, tag) {
    var ancestorInfo = _assign({}, oldInfo || emptyAncestorInfo);

    var info = {
      tag: tag
    };

    if (inScopeTags.indexOf(tag) !== -1) {
      ancestorInfo.aTagInScope = null;
      ancestorInfo.buttonTagInScope = null;
      ancestorInfo.nobrTagInScope = null;
    }

    if (buttonScopeTags.indexOf(tag) !== -1) {
      ancestorInfo.pTagInButtonScope = null;
    } // See rules for 'li', 'dd', 'dt' start tags in
    // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inbody


    if (specialTags.indexOf(tag) !== -1 && tag !== 'address' && tag !== 'div' && tag !== 'p') {
      ancestorInfo.listItemTagAutoclosing = null;
      ancestorInfo.dlItemTagAutoclosing = null;
    }

    ancestorInfo.current = info;

    if (tag === 'form') {
      ancestorInfo.formTag = info;
    }

    if (tag === 'a') {
      ancestorInfo.aTagInScope = info;
    }

    if (tag === 'button') {
      ancestorInfo.buttonTagInScope = info;
    }

    if (tag === 'nobr') {
      ancestorInfo.nobrTagInScope = info;
    }

    if (tag === 'p') {
      ancestorInfo.pTagInButtonScope = info;
    }

    if (tag === 'li') {
      ancestorInfo.listItemTagAutoclosing = info;
    }

    if (tag === 'dd' || tag === 'dt') {
      ancestorInfo.dlItemTagAutoclosing = info;
    }

    return ancestorInfo;
  };
  /**
   * Returns whether
   */


  var isTagValidWithParent = function (tag, parentTag) {
    // First, let's check if we're in an unusual parsing mode...
    switch (parentTag) {
      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inselect
      case 'select':
        return tag === 'option' || tag === 'optgroup' || tag === '#text';

      case 'optgroup':
        return tag === 'option' || tag === '#text';
      // Strictly speaking, seeing an <option> doesn't mean we're in a <select>
      // but

      case 'option':
        return tag === '#text';
      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intd
      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-incaption
      // No special behavior since these rules fall back to "in body" mode for
      // all except special table nodes which cause bad parsing behavior anyway.
      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intr

      case 'tr':
        return tag === 'th' || tag === 'td' || tag === 'style' || tag === 'script' || tag === 'template';
      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intbody

      case 'tbody':
      case 'thead':
      case 'tfoot':
        return tag === 'tr' || tag === 'style' || tag === 'script' || tag === 'template';
      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-incolgroup

      case 'colgroup':
        return tag === 'col' || tag === 'template';
      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intable

      case 'table':
        return tag === 'caption' || tag === 'colgroup' || tag === 'tbody' || tag === 'tfoot' || tag === 'thead' || tag === 'style' || tag === 'script' || tag === 'template';
      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inhead

      case 'head':
        return tag === 'base' || tag === 'basefont' || tag === 'bgsound' || tag === 'link' || tag === 'meta' || tag === 'title' || tag === 'noscript' || tag === 'noframes' || tag === 'style' || tag === 'script' || tag === 'template';
      // https://html.spec.whatwg.org/multipage/semantics.html#the-html-element

      case 'html':
        return tag === 'head' || tag === 'body' || tag === 'frameset';

      case 'frameset':
        return tag === 'frame';

      case '#document':
        return tag === 'html';
    } // Probably in the "in body" parsing mode, so we outlaw only tag combos
    // where the parsing rules cause implicit opens or closes to be added.
    // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inbody


    switch (tag) {
      case 'h1':
      case 'h2':
      case 'h3':
      case 'h4':
      case 'h5':
      case 'h6':
        return parentTag !== 'h1' && parentTag !== 'h2' && parentTag !== 'h3' && parentTag !== 'h4' && parentTag !== 'h5' && parentTag !== 'h6';

      case 'rp':
      case 'rt':
        return impliedEndTags.indexOf(parentTag) === -1;

      case 'body':
      case 'caption':
      case 'col':
      case 'colgroup':
      case 'frameset':
      case 'frame':
      case 'head':
      case 'html':
      case 'tbody':
      case 'td':
      case 'tfoot':
      case 'th':
      case 'thead':
      case 'tr':
        // These tags are only valid with a few parents that have special child
        // parsing rules -- if we're down here, then none of those matched and
        // so we allow it only if we don't know what the parent is, as all other
        // cases are invalid.
        return parentTag == null;
    }

    return true;
  };
  /**
   * Returns whether
   */


  var findInvalidAncestorForTag = function (tag, ancestorInfo) {
    switch (tag) {
      case 'address':
      case 'article':
      case 'aside':
      case 'blockquote':
      case 'center':
      case 'details':
      case 'dialog':
      case 'dir':
      case 'div':
      case 'dl':
      case 'fieldset':
      case 'figcaption':
      case 'figure':
      case 'footer':
      case 'header':
      case 'hgroup':
      case 'main':
      case 'menu':
      case 'nav':
      case 'ol':
      case 'p':
      case 'section':
      case 'summary':
      case 'ul':
      case 'pre':
      case 'listing':
      case 'table':
      case 'hr':
      case 'xmp':
      case 'h1':
      case 'h2':
      case 'h3':
      case 'h4':
      case 'h5':
      case 'h6':
        return ancestorInfo.pTagInButtonScope;

      case 'form':
        return ancestorInfo.formTag || ancestorInfo.pTagInButtonScope;

      case 'li':
        return ancestorInfo.listItemTagAutoclosing;

      case 'dd':
      case 'dt':
        return ancestorInfo.dlItemTagAutoclosing;

      case 'button':
        return ancestorInfo.buttonTagInScope;

      case 'a':
        // Spec says something about storing a list of markers, but it sounds
        // equivalent to this check.
        return ancestorInfo.aTagInScope;

      case 'nobr':
        return ancestorInfo.nobrTagInScope;
    }

    return null;
  };

  var didWarn$1 = {};

  validateDOMNesting = function (childTag, childText, ancestorInfo) {
    ancestorInfo = ancestorInfo || emptyAncestorInfo;
    var parentInfo = ancestorInfo.current;
    var parentTag = parentInfo && parentInfo.tag;

    if (childText != null) {
      if (childTag != null) {
        error('validateDOMNesting: when childText is passed, childTag should be null');
      }

      childTag = '#text';
    }

    var invalidParent = isTagValidWithParent(childTag, parentTag) ? null : parentInfo;
    var invalidAncestor = invalidParent ? null : findInvalidAncestorForTag(childTag, ancestorInfo);
    var invalidParentOrAncestor = invalidParent || invalidAncestor;

    if (!invalidParentOrAncestor) {
      return;
    }

    var ancestorTag = invalidParentOrAncestor.tag;
    var warnKey = !!invalidParent + '|' + childTag + '|' + ancestorTag;

    if (didWarn$1[warnKey]) {
      return;
    }

    didWarn$1[warnKey] = true;
    var tagDisplayName = childTag;
    var whitespaceInfo = '';

    if (childTag === '#text') {
      if (/\S/.test(childText)) {
        tagDisplayName = 'Text nodes';
      } else {
        tagDisplayName = 'Whitespace text nodes';
        whitespaceInfo = " Make sure you don't have any extra whitespace between tags on " + 'each line of your source code.';
      }
    } else {
      tagDisplayName = '<' + childTag + '>';
    }

    if (invalidParent) {
      var info = '';

      if (ancestorTag === 'table' && childTag === 'tr') {
        info += ' Add a <tbody>, <thead> or <tfoot> to your code to match the DOM tree generated by ' + 'the browser.';
      }

      error('validateDOMNesting(...): %s cannot appear as a child of <%s>.%s%s', tagDisplayName, ancestorTag, whitespaceInfo, info);
    } else {
      error('validateDOMNesting(...): %s cannot appear as a descendant of ' + '<%s>.', tagDisplayName, ancestorTag);
    }
  };
}

var SUPPRESS_HYDRATION_WARNING$1;

{
  SUPPRESS_HYDRATION_WARNING$1 = 'suppressHydrationWarning';
}

var SUSPENSE_START_DATA = '$';
var SUSPENSE_END_DATA = '/$';
var SUSPENSE_PENDING_START_DATA = '$?';
var SUSPENSE_FALLBACK_START_DATA = '$!';
var STYLE$1 = 'style';
var eventsEnabled = null;
var selectionInformation = null;

function shouldAutoFocusHostComponent(type, props) {
  switch (type) {
    case 'button':
    case 'input':
    case 'select':
    case 'textarea':
      return !!props.autoFocus;
  }

  return false;
}
function getRootHostContext(rootContainerInstance) {
  var type;
  var namespace;
  var nodeType = rootContainerInstance.nodeType;

  switch (nodeType) {
    case DOCUMENT_NODE:
    case DOCUMENT_FRAGMENT_NODE:
      {
        type = nodeType === DOCUMENT_NODE ? '#document' : '#fragment';
        var root = rootContainerInstance.documentElement;
        namespace = root ? root.namespaceURI : getChildNamespace(null, '');
        break;
      }

    default:
      {
        var container = nodeType === COMMENT_NODE ? rootContainerInstance.parentNode : rootContainerInstance;
        var ownNamespace = container.namespaceURI || null;
        type = container.tagName;
        namespace = getChildNamespace(ownNamespace, type);
        break;
      }
  }

  {
    var validatedTag = type.toLowerCase();
    var ancestorInfo = updatedAncestorInfo(null, validatedTag);
    return {
      namespace: namespace,
      ancestorInfo: ancestorInfo
    };
  }
}
function getChildHostContext(parentHostContext, type, rootContainerInstance) {
  {
    var parentHostContextDev = parentHostContext;
    var namespace = getChildNamespace(parentHostContextDev.namespace, type);
    var ancestorInfo = updatedAncestorInfo(parentHostContextDev.ancestorInfo, type);
    return {
      namespace: namespace,
      ancestorInfo: ancestorInfo
    };
  }
}
function getPublicInstance(instance) {
  return instance;
}
function prepareForCommit(containerInfo) {
  eventsEnabled = isEnabled();
  selectionInformation = getSelectionInformation();
  var activeInstance = null;

  setEnabled(false);
  return activeInstance;
}
function resetAfterCommit(containerInfo) {
  restoreSelection(selectionInformation);
  setEnabled(eventsEnabled);
  eventsEnabled = null;
  selectionInformation = null;
}
function createInstance(type, props, rootContainerInstance, hostContext, internalInstanceHandle) {
  var parentNamespace;

  {
    // TODO: take namespace into account when validating.
    var hostContextDev = hostContext;
    validateDOMNesting(type, null, hostContextDev.ancestorInfo);

    if (typeof props.children === 'string' || typeof props.children === 'number') {
      var string = '' + props.children;
      var ownAncestorInfo = updatedAncestorInfo(hostContextDev.ancestorInfo, type);
      validateDOMNesting(null, string, ownAncestorInfo);
    }

    parentNamespace = hostContextDev.namespace;
  }

  var domElement = createElement(type, props, rootContainerInstance, parentNamespace);
  precacheFiberNode(internalInstanceHandle, domElement);
  updateFiberProps(domElement, props);
  return domElement;
}
function appendInitialChild(parentInstance, child) {
  parentInstance.appendChild(child);
}
function finalizeInitialChildren(domElement, type, props, rootContainerInstance, hostContext) {
  setInitialProperties(domElement, type, props, rootContainerInstance);
  return shouldAutoFocusHostComponent(type, props);
}
function prepareUpdate(domElement, type, oldProps, newProps, rootContainerInstance, hostContext) {
  {
    var hostContextDev = hostContext;

    if (typeof newProps.children !== typeof oldProps.children && (typeof newProps.children === 'string' || typeof newProps.children === 'number')) {
      var string = '' + newProps.children;
      var ownAncestorInfo = updatedAncestorInfo(hostContextDev.ancestorInfo, type);
      validateDOMNesting(null, string, ownAncestorInfo);
    }
  }

  return diffProperties(domElement, type, oldProps, newProps);
}
function shouldSetTextContent(type, props) {
  return type === 'textarea' || type === 'option' || type === 'noscript' || typeof props.children === 'string' || typeof props.children === 'number' || typeof props.dangerouslySetInnerHTML === 'object' && props.dangerouslySetInnerHTML !== null && props.dangerouslySetInnerHTML.__html != null;
}
function createTextInstance(text, rootContainerInstance, hostContext, internalInstanceHandle) {
  {
    var hostContextDev = hostContext;
    validateDOMNesting(null, text, hostContextDev.ancestorInfo);
  }

  var textNode = createTextNode(text, rootContainerInstance);
  precacheFiberNode(internalInstanceHandle, textNode);
  return textNode;
}
// if a component just imports ReactDOM (e.g. for findDOMNode).
// Some environments might not have setTimeout or clearTimeout.

var scheduleTimeout = typeof setTimeout === 'function' ? setTimeout : undefined;
var cancelTimeout = typeof clearTimeout === 'function' ? clearTimeout : undefined;
var noTimeout = -1; // -------------------
function commitMount(domElement, type, newProps, internalInstanceHandle) {
  // Despite the naming that might imply otherwise, this method only
  // fires if there is an `Update` effect scheduled during mounting.
  // This happens if `finalizeInitialChildren` returns `true` (which it
  // does to implement the `autoFocus` attribute on the client). But
  // there are also other cases when this might happen (such as patching
  // up text content during hydration mismatch). So we'll check this again.
  if (shouldAutoFocusHostComponent(type, newProps)) {
    domElement.focus();
  }
}
function commitUpdate(domElement, updatePayload, type, oldProps, newProps, internalInstanceHandle) {
  // Update the props handle so that we know which props are the ones with
  // with current event handlers.
  updateFiberProps(domElement, newProps); // Apply the diff to the DOM node.

  updateProperties(domElement, updatePayload, type, oldProps, newProps);
}
function resetTextContent(domElement) {
  setTextContent(domElement, '');
}
function commitTextUpdate(textInstance, oldText, newText) {
  textInstance.nodeValue = newText;
}
function appendChild(parentInstance, child) {
  parentInstance.appendChild(child);
}
function appendChildToContainer(container, child) {
  var parentNode;

  if (container.nodeType === COMMENT_NODE) {
    parentNode = container.parentNode;
    parentNode.insertBefore(child, container);
  } else {
    parentNode = container;
    parentNode.appendChild(child);
  } // This container might be used for a portal.
  // If something inside a portal is clicked, that click should bubble
  // through the React tree. However, on Mobile Safari the click would
  // never bubble through the *DOM* tree unless an ancestor with onclick
  // event exists. So we wouldn't see it and dispatch it.
  // This is why we ensure that non React root containers have inline onclick
  // defined.
  // https://github.com/facebook/react/issues/11918


  var reactRootContainer = container._reactRootContainer;

  if ((reactRootContainer === null || reactRootContainer === undefined) && parentNode.onclick === null) {
    // TODO: This cast may not be sound for SVG, MathML or custom elements.
    trapClickOnNonInteractiveElement(parentNode);
  }
}
function insertBefore(parentInstance, child, beforeChild) {
  parentInstance.insertBefore(child, beforeChild);
}
function insertInContainerBefore(container, child, beforeChild) {
  if (container.nodeType === COMMENT_NODE) {
    container.parentNode.insertBefore(child, beforeChild);
  } else {
    container.insertBefore(child, beforeChild);
  }
}

function removeChild(parentInstance, child) {
  parentInstance.removeChild(child);
}
function removeChildFromContainer(container, child) {
  if (container.nodeType === COMMENT_NODE) {
    container.parentNode.removeChild(child);
  } else {
    container.removeChild(child);
  }
}
function hideInstance(instance) {
  // TODO: Does this work for all element types? What about MathML? Should we
  // pass host context to this method?
  instance = instance;
  var style = instance.style;

  if (typeof style.setProperty === 'function') {
    style.setProperty('display', 'none', 'important');
  } else {
    style.display = 'none';
  }
}
function hideTextInstance(textInstance) {
  textInstance.nodeValue = '';
}
function unhideInstance(instance, props) {
  instance = instance;
  var styleProp = props[STYLE$1];
  var display = styleProp !== undefined && styleProp !== null && styleProp.hasOwnProperty('display') ? styleProp.display : null;
  instance.style.display = dangerousStyleValue('display', display);
}
function unhideTextInstance(textInstance, text) {
  textInstance.nodeValue = text;
}
function clearContainer(container) {
  if (container.nodeType === ELEMENT_NODE) {
    container.textContent = '';
  } else if (container.nodeType === DOCUMENT_NODE) {
    var body = container.body;

    if (body != null) {
      body.textContent = '';
    }
  }
} // -------------------
function canHydrateInstance(instance, type, props) {
  if (instance.nodeType !== ELEMENT_NODE || type.toLowerCase() !== instance.nodeName.toLowerCase()) {
    return null;
  } // This has now been refined to an element node.


  return instance;
}
function canHydrateTextInstance(instance, text) {
  if (text === '' || instance.nodeType !== TEXT_NODE) {
    // Empty strings are not parsed by HTML so there won't be a correct match here.
    return null;
  } // This has now been refined to a text node.


  return instance;
}
function isSuspenseInstancePending(instance) {
  return instance.data === SUSPENSE_PENDING_START_DATA;
}
function isSuspenseInstanceFallback(instance) {
  return instance.data === SUSPENSE_FALLBACK_START_DATA;
}

function getNextHydratable(node) {
  // Skip non-hydratable nodes.
  for (; node != null; node = node.nextSibling) {
    var nodeType = node.nodeType;

    if (nodeType === ELEMENT_NODE || nodeType === TEXT_NODE) {
      break;
    }
  }

  return node;
}

function getNextHydratableSibling(instance) {
  return getNextHydratable(instance.nextSibling);
}
function getFirstHydratableChild(parentInstance) {
  return getNextHydratable(parentInstance.firstChild);
}
function hydrateInstance(instance, type, props, rootContainerInstance, hostContext, internalInstanceHandle) {
  precacheFiberNode(internalInstanceHandle, instance); // TODO: Possibly defer this until the commit phase where all the events
  // get attached.

  updateFiberProps(instance, props);
  var parentNamespace;

  {
    var hostContextDev = hostContext;
    parentNamespace = hostContextDev.namespace;
  }

  return diffHydratedProperties(instance, type, props, parentNamespace);
}
function hydrateTextInstance(textInstance, text, internalInstanceHandle) {
  precacheFiberNode(internalInstanceHandle, textInstance);
  return diffHydratedText(textInstance, text);
}
function getNextHydratableInstanceAfterSuspenseInstance(suspenseInstance) {
  var node = suspenseInstance.nextSibling; // Skip past all nodes within this suspense boundary.
  // There might be nested nodes so we need to keep track of how
  // deep we are and only break out when we're back on top.

  var depth = 0;

  while (node) {
    if (node.nodeType === COMMENT_NODE) {
      var data = node.data;

      if (data === SUSPENSE_END_DATA) {
        if (depth === 0) {
          return getNextHydratableSibling(node);
        } else {
          depth--;
        }
      } else if (data === SUSPENSE_START_DATA || data === SUSPENSE_FALLBACK_START_DATA || data === SUSPENSE_PENDING_START_DATA) {
        depth++;
      }
    }

    node = node.nextSibling;
  } // TODO: Warn, we didn't find the end comment boundary.


  return null;
} // Returns the SuspenseInstance if this node is a direct child of a
// SuspenseInstance. I.e. if its previous sibling is a Comment with
// SUSPENSE_x_START_DATA. Otherwise, null.

function getParentSuspenseInstance(targetInstance) {
  var node = targetInstance.previousSibling; // Skip past all nodes within this suspense boundary.
  // There might be nested nodes so we need to keep track of how
  // deep we are and only break out when we're back on top.

  var depth = 0;

  while (node) {
    if (node.nodeType === COMMENT_NODE) {
      var data = node.data;

      if (data === SUSPENSE_START_DATA || data === SUSPENSE_FALLBACK_START_DATA || data === SUSPENSE_PENDING_START_DATA) {
        if (depth === 0) {
          return node;
        } else {
          depth--;
        }
      } else if (data === SUSPENSE_END_DATA) {
        depth++;
      }
    }

    node = node.previousSibling;
  }

  return null;
}
function commitHydratedContainer(container) {
  // Retry if any event replaying was blocked on this.
  retryIfBlockedOn(container);
}
function commitHydratedSuspenseInstance(suspenseInstance) {
  // Retry if any event replaying was blocked on this.
  retryIfBlockedOn(suspenseInstance);
}
function didNotMatchHydratedContainerTextInstance(parentContainer, textInstance, text) {
  {
    warnForUnmatchedText(textInstance, text);
  }
}
function didNotMatchHydratedTextInstance(parentType, parentProps, parentInstance, textInstance, text) {
  if ( parentProps[SUPPRESS_HYDRATION_WARNING$1] !== true) {
    warnForUnmatchedText(textInstance, text);
  }
}
function didNotHydrateContainerInstance(parentContainer, instance) {
  {
    if (instance.nodeType === ELEMENT_NODE) {
      warnForDeletedHydratableElement(parentContainer, instance);
    } else if (instance.nodeType === COMMENT_NODE) ; else {
      warnForDeletedHydratableText(parentContainer, instance);
    }
  }
}
function didNotHydrateInstance(parentType, parentProps, parentInstance, instance) {
  if ( parentProps[SUPPRESS_HYDRATION_WARNING$1] !== true) {
    if (instance.nodeType === ELEMENT_NODE) {
      warnForDeletedHydratableElement(parentInstance, instance);
    } else if (instance.nodeType === COMMENT_NODE) ; else {
      warnForDeletedHydratableText(parentInstance, instance);
    }
  }
}
function didNotFindHydratableContainerInstance(parentContainer, type, props) {
  {
    warnForInsertedHydratedElement(parentContainer, type);
  }
}
function didNotFindHydratableContainerTextInstance(parentContainer, text) {
  {
    warnForInsertedHydratedText(parentContainer, text);
  }
}
function didNotFindHydratableInstance(parentType, parentProps, parentInstance, type, props) {
  if ( parentProps[SUPPRESS_HYDRATION_WARNING$1] !== true) {
    warnForInsertedHydratedElement(parentInstance, type);
  }
}
function didNotFindHydratableTextInstance(parentType, parentProps, parentInstance, text) {
  if ( parentProps[SUPPRESS_HYDRATION_WARNING$1] !== true) {
    warnForInsertedHydratedText(parentInstance, text);
  }
}
function didNotFindHydratableSuspenseInstance(parentType, parentProps, parentInstance) {
  if ( parentProps[SUPPRESS_HYDRATION_WARNING$1] !== true) ;
}
var clientId = 0;
function makeClientIdInDEV(warnOnAccessInDEV) {
  var id = 'r:' + (clientId++).toString(36);
  return {
    toString: function () {
      warnOnAccessInDEV();
      return id;
    },
    valueOf: function () {
      warnOnAccessInDEV();
      return id;
    }
  };
}
function isOpaqueHydratingObject(value) {
  return value !== null && typeof value === 'object' && value.$$typeof === REACT_OPAQUE_ID_TYPE;
}
function makeOpaqueHydratingObject(attemptToReadValue) {
  return {
    $$typeof: REACT_OPAQUE_ID_TYPE,
    toString: attemptToReadValue,
    valueOf: attemptToReadValue
  };
}
function preparePortalMount(portalInstance) {
  {
    listenToAllSupportedEvents(portalInstance);
  }
}

var randomKey = Math.random().toString(36).slice(2);
var internalInstanceKey = '__reactFiber$' + randomKey;
var internalPropsKey = '__reactProps$' + randomKey;
var internalContainerInstanceKey = '__reactContainer$' + randomKey;
var internalEventHandlersKey = '__reactEvents$' + randomKey;
function precacheFiberNode(hostInst, node) {
  node[internalInstanceKey] = hostInst;
}
function markContainerAsRoot(hostRoot, node) {
  node[internalContainerInstanceKey] = hostRoot;
}
function unmarkContainerAsRoot(node) {
  node[internalContainerInstanceKey] = null;
}
function isContainerMarkedAsRoot(node) {
  return !!node[internalContainerInstanceKey];
} // Given a DOM node, return the closest HostComponent or HostText fiber ancestor.
// If the target node is part of a hydrated or not yet rendered subtree, then
// this may also return a SuspenseComponent or HostRoot to indicate that.
// Conceptually the HostRoot fiber is a child of the Container node. So if you
// pass the Container node as the targetNode, you will not actually get the
// HostRoot back. To get to the HostRoot, you need to pass a child of it.
// The same thing applies to Suspense boundaries.

function getClosestInstanceFromNode(targetNode) {
  var targetInst = targetNode[internalInstanceKey];

  if (targetInst) {
    // Don't return HostRoot or SuspenseComponent here.
    return targetInst;
  } // If the direct event target isn't a React owned DOM node, we need to look
  // to see if one of its parents is a React owned DOM node.


  var parentNode = targetNode.parentNode;

  while (parentNode) {
    // We'll check if this is a container root that could include
    // React nodes in the future. We need to check this first because
    // if we're a child of a dehydrated container, we need to first
    // find that inner container before moving on to finding the parent
    // instance. Note that we don't check this field on  the targetNode
    // itself because the fibers are conceptually between the container
    // node and the first child. It isn't surrounding the container node.
    // If it's not a container, we check if it's an instance.
    targetInst = parentNode[internalContainerInstanceKey] || parentNode[internalInstanceKey];

    if (targetInst) {
      // Since this wasn't the direct target of the event, we might have
      // stepped past dehydrated DOM nodes to get here. However they could
      // also have been non-React nodes. We need to answer which one.
      // If we the instance doesn't have any children, then there can't be
      // a nested suspense boundary within it. So we can use this as a fast
      // bailout. Most of the time, when people add non-React children to
      // the tree, it is using a ref to a child-less DOM node.
      // Normally we'd only need to check one of the fibers because if it
      // has ever gone from having children to deleting them or vice versa
      // it would have deleted the dehydrated boundary nested inside already.
      // However, since the HostRoot starts out with an alternate it might
      // have one on the alternate so we need to check in case this was a
      // root.
      var alternate = targetInst.alternate;

      if (targetInst.child !== null || alternate !== null && alternate.child !== null) {
        // Next we need to figure out if the node that skipped past is
        // nested within a dehydrated boundary and if so, which one.
        var suspenseInstance = getParentSuspenseInstance(targetNode);

        while (suspenseInstance !== null) {
          // We found a suspense instance. That means that we haven't
          // hydrated it yet. Even though we leave the comments in the
          // DOM after hydrating, and there are boundaries in the DOM
          // that could already be hydrated, we wouldn't have found them
          // through this pass since if the target is hydrated it would
          // have had an internalInstanceKey on it.
          // Let's get the fiber associated with the SuspenseComponent
          // as the deepest instance.
          var targetSuspenseInst = suspenseInstance[internalInstanceKey];

          if (targetSuspenseInst) {
            return targetSuspenseInst;
          } // If we don't find a Fiber on the comment, it might be because
          // we haven't gotten to hydrate it yet. There might still be a
          // parent boundary that hasn't above this one so we need to find
          // the outer most that is known.


          suspenseInstance = getParentSuspenseInstance(suspenseInstance); // If we don't find one, then that should mean that the parent
          // host component also hasn't hydrated yet. We can return it
          // below since it will bail out on the isMounted check later.
        }
      }

      return targetInst;
    }

    targetNode = parentNode;
    parentNode = targetNode.parentNode;
  }

  return null;
}
/**
 * Given a DOM node, return the ReactDOMComponent or ReactDOMTextComponent
 * instance, or null if the node was not rendered by this React.
 */

function getInstanceFromNode(node) {
  var inst = node[internalInstanceKey] || node[internalContainerInstanceKey];

  if (inst) {
    if (inst.tag === HostComponent || inst.tag === HostText || inst.tag === SuspenseComponent || inst.tag === HostRoot) {
      return inst;
    } else {
      return null;
    }
  }

  return null;
}
/**
 * Given a ReactDOMComponent or ReactDOMTextComponent, return the corresponding
 * DOM node.
 */

function getNodeFromInstance(inst) {
  if (inst.tag === HostComponent || inst.tag === HostText) {
    // In Fiber this, is just the state node right now. We assume it will be
    // a host component or host text.
    return inst.stateNode;
  } // Without this first invariant, passing a non-DOM-component triggers the next
  // invariant for a missing parent, which is super confusing.


  {
    {
      throw Error( "getNodeFromInstance: Invalid argument." );
    }
  }
}
function getFiberCurrentPropsFromNode(node) {
  return node[internalPropsKey] || null;
}
function updateFiberProps(node, props) {
  node[internalPropsKey] = props;
}
function getEventListenerSet(node) {
  var elementListenerSet = node[internalEventHandlersKey];

  if (elementListenerSet === undefined) {
    elementListenerSet = node[internalEventHandlersKey] = new Set();
  }

  return elementListenerSet;
}

var loggedTypeFailures = {};
var ReactDebugCurrentFrame$1 = ReactSharedInternals.ReactDebugCurrentFrame;

function setCurrentlyValidatingElement(element) {
  {
    if (element) {
      var owner = element._owner;
      var stack = describeUnknownElementTypeFrameInDEV(element.type, element._source, owner ? owner.type : null);
      ReactDebugCurrentFrame$1.setExtraStackFrame(stack);
    } else {
      ReactDebugCurrentFrame$1.setExtraStackFrame(null);
    }
  }
}

function checkPropTypes(typeSpecs, values, location, componentName, element) {
  {
    // $FlowFixMe This is okay but Flow doesn't know it.
    var has = Function.call.bind(Object.prototype.hasOwnProperty);

    for (var typeSpecName in typeSpecs) {
      if (has(typeSpecs, typeSpecName)) {
        var error$1 = void 0; // Prop type validation may throw. In case they do, we don't want to
        // fail the render phase where it didn't fail before. So we log it.
        // After these have been cleaned up, we'll let them throw.

        try {
          // This is intentionally an invariant that gets caught. It's the same
          // behavior as without this statement except with a better message.
          if (typeof typeSpecs[typeSpecName] !== 'function') {
            var err = Error((componentName || 'React class') + ': ' + location + ' type `' + typeSpecName + '` is invalid; ' + 'it must be a function, usually from the `prop-types` package, but received `' + typeof typeSpecs[typeSpecName] + '`.' + 'This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.');
            err.name = 'Invariant Violation';
            throw err;
          }

          error$1 = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED');
        } catch (ex) {
          error$1 = ex;
        }

        if (error$1 && !(error$1 instanceof Error)) {
          setCurrentlyValidatingElement(element);

          error('%s: type specification of %s' + ' `%s` is invalid; the type checker ' + 'function must return `null` or an `Error` but returned a %s. ' + 'You may have forgotten to pass an argument to the type checker ' + 'creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and ' + 'shape all require an argument).', componentName || 'React class', location, typeSpecName, typeof error$1);

          setCurrentlyValidatingElement(null);
        }

        if (error$1 instanceof Error && !(error$1.message in loggedTypeFailures)) {
          // Only monitor this failure once because there tends to be a lot of the
          // same error.
          loggedTypeFailures[error$1.message] = true;
          setCurrentlyValidatingElement(element);

          error('Failed %s type: %s', location, error$1.message);

          setCurrentlyValidatingElement(null);
        }
      }
    }
  }
}

var valueStack = [];
var fiberStack;

{
  fiberStack = [];
}

var index = -1;

function createCursor(defaultValue) {
  return {
    current: defaultValue
  };
}

function pop(cursor, fiber) {
  if (index < 0) {
    {
      error('Unexpected pop.');
    }

    return;
  }

  {
    if (fiber !== fiberStack[index]) {
      error('Unexpected Fiber popped.');
    }
  }

  cursor.current = valueStack[index];
  valueStack[index] = null;

  {
    fiberStack[index] = null;
  }

  index--;
}

function push(cursor, value, fiber) {
  index++;
  valueStack[index] = cursor.current;

  {
    fiberStack[index] = fiber;
  }

  cursor.current = value;
}

var warnedAboutMissingGetChildContext;

{
  warnedAboutMissingGetChildContext = {};
}

var emptyContextObject = {};

{
  Object.freeze(emptyContextObject);
} // A cursor to the current merged context object on the stack.


var contextStackCursor = createCursor(emptyContextObject); // A cursor to a boolean indicating whether the context has changed.

var didPerformWorkStackCursor = createCursor(false); // Keep track of the previous context object that was on the stack.
// We use this to get access to the parent context after we have already
// pushed the next context provider, and now need to merge their contexts.

var previousContext = emptyContextObject;

function getUnmaskedContext(workInProgress, Component, didPushOwnContextIfProvider) {
  {
    if (didPushOwnContextIfProvider && isContextProvider(Component)) {
      // If the fiber is a context provider itself, when we read its context
      // we may have already pushed its own child context on the stack. A context
      // provider should not "see" its own child context. Therefore we read the
      // previous (parent) context instead for a context provider.
      return previousContext;
    }

    return contextStackCursor.current;
  }
}

function cacheContext(workInProgress, unmaskedContext, maskedContext) {
  {
    var instance = workInProgress.stateNode;
    instance.__reactInternalMemoizedUnmaskedChildContext = unmaskedContext;
    instance.__reactInternalMemoizedMaskedChildContext = maskedContext;
  }
}

function getMaskedContext(workInProgress, unmaskedContext) {
  {
    var type = workInProgress.type;
    var contextTypes = type.contextTypes;

    if (!contextTypes) {
      return emptyContextObject;
    } // Avoid recreating masked context unless unmasked context has changed.
    // Failing to do this will result in unnecessary calls to componentWillReceiveProps.
    // This may trigger infinite loops if componentWillReceiveProps calls setState.


    var instance = workInProgress.stateNode;

    if (instance && instance.__reactInternalMemoizedUnmaskedChildContext === unmaskedContext) {
      return instance.__reactInternalMemoizedMaskedChildContext;
    }

    var context = {};

    for (var key in contextTypes) {
      context[key] = unmaskedContext[key];
    }

    {
      var name = getComponentName(type) || 'Unknown';
      checkPropTypes(contextTypes, context, 'context', name);
    } // Cache unmasked context so we can avoid recreating masked context unless necessary.
    // Context is created before the class component is instantiated so check for instance.


    if (instance) {
      cacheContext(workInProgress, unmaskedContext, context);
    }

    return context;
  }
}

function hasContextChanged() {
  {
    return didPerformWorkStackCursor.current;
  }
}

function isContextProvider(type) {
  {
    var childContextTypes = type.childContextTypes;
    return childContextTypes !== null && childContextTypes !== undefined;
  }
}

function popContext(fiber) {
  {
    pop(didPerformWorkStackCursor, fiber);
    pop(contextStackCursor, fiber);
  }
}

function popTopLevelContextObject(fiber) {
  {
    pop(didPerformWorkStackCursor, fiber);
    pop(contextStackCursor, fiber);
  }
}

function pushTopLevelContextObject(fiber, context, didChange) {
  {
    if (!(contextStackCursor.current === emptyContextObject)) {
      {
        throw Error( "Unexpected context found on stack. This error is likely caused by a bug in React. Please file an issue." );
      }
    }

    push(contextStackCursor, context, fiber);
    push(didPerformWorkStackCursor, didChange, fiber);
  }
}

function processChildContext(fiber, type, parentContext) {
  {
    var instance = fiber.stateNode;
    var childContextTypes = type.childContextTypes; // TODO (bvaughn) Replace this behavior with an invariant() in the future.
    // It has only been added in Fiber to match the (unintentional) behavior in Stack.

    if (typeof instance.getChildContext !== 'function') {
      {
        var componentName = getComponentName(type) || 'Unknown';

        if (!warnedAboutMissingGetChildContext[componentName]) {
          warnedAboutMissingGetChildContext[componentName] = true;

          error('%s.childContextTypes is specified but there is no getChildContext() method ' + 'on the instance. You can either define getChildContext() on %s or remove ' + 'childContextTypes from it.', componentName, componentName);
        }
      }

      return parentContext;
    }

    var childContext = instance.getChildContext();

    for (var contextKey in childContext) {
      if (!(contextKey in childContextTypes)) {
        {
          throw Error( (getComponentName(type) || 'Unknown') + ".getChildContext(): key \"" + contextKey + "\" is not defined in childContextTypes." );
        }
      }
    }

    {
      var name = getComponentName(type) || 'Unknown';
      checkPropTypes(childContextTypes, childContext, 'child context', name);
    }

    return _assign({}, parentContext, childContext);
  }
}

function pushContextProvider(workInProgress) {
  {
    var instance = workInProgress.stateNode; // We push the context as early as possible to ensure stack integrity.
    // If the instance does not exist yet, we will push null at first,
    // and replace it on the stack later when invalidating the context.

    var memoizedMergedChildContext = instance && instance.__reactInternalMemoizedMergedChildContext || emptyContextObject; // Remember the parent context so we can merge with it later.
    // Inherit the parent's did-perform-work value to avoid inadvertently blocking updates.

    previousContext = contextStackCursor.current;
    push(contextStackCursor, memoizedMergedChildContext, workInProgress);
    push(didPerformWorkStackCursor, didPerformWorkStackCursor.current, workInProgress);
    return true;
  }
}

function invalidateContextProvider(workInProgress, type, didChange) {
  {
    var instance = workInProgress.stateNode;

    if (!instance) {
      {
        throw Error( "Expected to have an instance by this point. This error is likely caused by a bug in React. Please file an issue." );
      }
    }

    if (didChange) {
      // Merge parent and own context.
      // Skip this if we're not updating due to sCU.
      // This avoids unnecessarily recomputing memoized values.
      var mergedContext = processChildContext(workInProgress, type, previousContext);
      instance.__reactInternalMemoizedMergedChildContext = mergedContext; // Replace the old (or empty) context with the new one.
      // It is important to unwind the context in the reverse order.

      pop(didPerformWorkStackCursor, workInProgress);
      pop(contextStackCursor, workInProgress); // Now push the new context and mark that it has changed.

      push(contextStackCursor, mergedContext, workInProgress);
      push(didPerformWorkStackCursor, didChange, workInProgress);
    } else {
      pop(didPerformWorkStackCursor, workInProgress);
      push(didPerformWorkStackCursor, didChange, workInProgress);
    }
  }
}

function findCurrentUnmaskedContext(fiber) {
  {
    // Currently this is only used with renderSubtreeIntoContainer; not sure if it
    // makes sense elsewhere
    if (!(isFiberMounted(fiber) && fiber.tag === ClassComponent)) {
      {
        throw Error( "Expected subtree parent to be a mounted class component. This error is likely caused by a bug in React. Please file an issue." );
      }
    }

    var node = fiber;

    do {
      switch (node.tag) {
        case HostRoot:
          return node.stateNode.context;

        case ClassComponent:
          {
            var Component = node.type;

            if (isContextProvider(Component)) {
              return node.stateNode.__reactInternalMemoizedMergedChildContext;
            }

            break;
          }
      }

      node = node.return;
    } while (node !== null);

    {
      {
        throw Error( "Found unexpected detached subtree parent. This error is likely caused by a bug in React. Please file an issue." );
      }
    }
  }
}

var LegacyRoot = 0;
var BlockingRoot = 1;
var ConcurrentRoot = 2;

var rendererID = null;
var injectedHook = null;
var hasLoggedError = false;
var isDevToolsPresent = typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ !== 'undefined';
function injectInternals(internals) {
  if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined') {
    // No DevTools
    return false;
  }

  var hook = __REACT_DEVTOOLS_GLOBAL_HOOK__;

  if (hook.isDisabled) {
    // This isn't a real property on the hook, but it can be set to opt out
    // of DevTools integration and associated warnings and logs.
    // https://github.com/facebook/react/issues/3877
    return true;
  }

  if (!hook.supportsFiber) {
    {
      error('The installed version of React DevTools is too old and will not work ' + 'with the current version of React. Please update React DevTools. ' + 'https://reactjs.org/link/react-devtools');
    } // DevTools exists, even though it doesn't support Fiber.


    return true;
  }

  try {
    rendererID = hook.inject(internals); // We have successfully injected, so now it is safe to set up hooks.

    injectedHook = hook;
  } catch (err) {
    // Catch all errors because it is unsafe to throw during initialization.
    {
      error('React instrumentation encountered an error: %s.', err);
    }
  } // DevTools exists


  return true;
}
function onScheduleRoot(root, children) {
  {
    if (injectedHook && typeof injectedHook.onScheduleFiberRoot === 'function') {
      try {
        injectedHook.onScheduleFiberRoot(rendererID, root, children);
      } catch (err) {
        if ( !hasLoggedError) {
          hasLoggedError = true;

          error('React instrumentation encountered an error: %s', err);
        }
      }
    }
  }
}
function onCommitRoot(root, priorityLevel) {
  if (injectedHook && typeof injectedHook.onCommitFiberRoot === 'function') {
    try {
      var didError = (root.current.flags & DidCapture) === DidCapture;

      if (enableProfilerTimer) {
        injectedHook.onCommitFiberRoot(rendererID, root, priorityLevel, didError);
      } else {
        injectedHook.onCommitFiberRoot(rendererID, root, undefined, didError);
      }
    } catch (err) {
      {
        if (!hasLoggedError) {
          hasLoggedError = true;

          error('React instrumentation encountered an error: %s', err);
        }
      }
    }
  }
}
function onCommitUnmount(fiber) {
  if (injectedHook && typeof injectedHook.onCommitFiberUnmount === 'function') {
    try {
      injectedHook.onCommitFiberUnmount(rendererID, fiber);
    } catch (err) {
      {
        if (!hasLoggedError) {
          hasLoggedError = true;

          error('React instrumentation encountered an error: %s', err);
        }
      }
    }
  }
}

var Scheduler_runWithPriority = Scheduler.unstable_runWithPriority,
    Scheduler_scheduleCallback = Scheduler.unstable_scheduleCallback,
    Scheduler_cancelCallback = Scheduler.unstable_cancelCallback,
    Scheduler_shouldYield = Scheduler.unstable_shouldYield,
    Scheduler_requestPaint = Scheduler.unstable_requestPaint,
    Scheduler_now$1 = Scheduler.unstable_now,
    Scheduler_getCurrentPriorityLevel = Scheduler.unstable_getCurrentPriorityLevel,
    Scheduler_ImmediatePriority = Scheduler.unstable_ImmediatePriority,
    Scheduler_UserBlockingPriority = Scheduler.unstable_UserBlockingPriority,
    Scheduler_NormalPriority = Scheduler.unstable_NormalPriority,
    Scheduler_LowPriority = Scheduler.unstable_LowPriority,
    Scheduler_IdlePriority = Scheduler.unstable_IdlePriority;

{
  // Provide explicit error message when production+profiling bundle of e.g.
  // react-dom is used with production (non-profiling) bundle of
  // scheduler/tracing
  if (!(tracing.__interactionsRef != null && tracing.__interactionsRef.current != null)) {
    {
      throw Error( "It is not supported to run the profiling version of a renderer (for example, `react-dom/profiling`) without also replacing the `scheduler/tracing` module with `scheduler/tracing-profiling`. Your bundler might have a setting for aliasing both modules. Learn more at https://reactjs.org/link/profiling" );
    }
  }
}

var fakeCallbackNode = {}; // Except for NoPriority, these correspond to Scheduler priorities. We use
// ascending numbers so we can compare them like numbers. They start at 90 to
// avoid clashing with Scheduler's priorities.

var ImmediatePriority$1 = 99;
var UserBlockingPriority$2 = 98;
var NormalPriority$1 = 97;
var LowPriority$1 = 96;
var IdlePriority$1 = 95; // NoPriority is the absence of priority. Also React-only.

var NoPriority$1 = 90;
var shouldYield = Scheduler_shouldYield;
var requestPaint = // Fall back gracefully if we're running an older version of Scheduler.
Scheduler_requestPaint !== undefined ? Scheduler_requestPaint : function () {};
var syncQueue = null;
var immediateQueueCallbackNode = null;
var isFlushingSyncQueue = false;
var initialTimeMs$1 = Scheduler_now$1(); // If the initial timestamp is reasonably small, use Scheduler's `now` directly.
// This will be the case for modern browsers that support `performance.now`. In
// older browsers, Scheduler falls back to `Date.now`, which returns a Unix
// timestamp. In that case, subtract the module initialization time to simulate
// the behavior of performance.now and keep our times small enough to fit
// within 32 bits.
// TODO: Consider lifting this into Scheduler.

var now = initialTimeMs$1 < 10000 ? Scheduler_now$1 : function () {
  return Scheduler_now$1() - initialTimeMs$1;
};
function getCurrentPriorityLevel() {
  switch (Scheduler_getCurrentPriorityLevel()) {
    case Scheduler_ImmediatePriority:
      return ImmediatePriority$1;

    case Scheduler_UserBlockingPriority:
      return UserBlockingPriority$2;

    case Scheduler_NormalPriority:
      return NormalPriority$1;

    case Scheduler_LowPriority:
      return LowPriority$1;

    case Scheduler_IdlePriority:
      return IdlePriority$1;

    default:
      {
        {
          throw Error( "Unknown priority level." );
        }
      }

  }
}

function reactPriorityToSchedulerPriority(reactPriorityLevel) {
  switch (reactPriorityLevel) {
    case ImmediatePriority$1:
      return Scheduler_ImmediatePriority;

    case UserBlockingPriority$2:
      return Scheduler_UserBlockingPriority;

    case NormalPriority$1:
      return Scheduler_NormalPriority;

    case LowPriority$1:
      return Scheduler_LowPriority;

    case IdlePriority$1:
      return Scheduler_IdlePriority;

    default:
      {
        {
          throw Error( "Unknown priority level." );
        }
      }

  }
}

function runWithPriority$1(reactPriorityLevel, fn) {
  var priorityLevel = reactPriorityToSchedulerPriority(reactPriorityLevel);
  return Scheduler_runWithPriority(priorityLevel, fn);
}
function scheduleCallback(reactPriorityLevel, callback, options) {
  var priorityLevel = reactPriorityToSchedulerPriority(reactPriorityLevel);
  return Scheduler_scheduleCallback(priorityLevel, callback, options);
}
function scheduleSyncCallback(callback) {
  // Push this callback into an internal queue. We'll flush these either in
  // the next tick, or earlier if something calls `flushSyncCallbackQueue`.
  if (syncQueue === null) {
    syncQueue = [callback]; // Flush the queue in the next tick, at the earliest.

    immediateQueueCallbackNode = Scheduler_scheduleCallback(Scheduler_ImmediatePriority, flushSyncCallbackQueueImpl);
  } else {
    // Push onto existing queue. Don't need to schedule a callback because
    // we already scheduled one when we created the queue.
    syncQueue.push(callback);
  }

  return fakeCallbackNode;
}
function cancelCallback(callbackNode) {
  if (callbackNode !== fakeCallbackNode) {
    Scheduler_cancelCallback(callbackNode);
  }
}
function flushSyncCallbackQueue() {
  if (immediateQueueCallbackNode !== null) {
    var node = immediateQueueCallbackNode;
    immediateQueueCallbackNode = null;
    Scheduler_cancelCallback(node);
  }

  flushSyncCallbackQueueImpl();
}

function flushSyncCallbackQueueImpl() {
  if (!isFlushingSyncQueue && syncQueue !== null) {
    // Prevent re-entrancy.
    isFlushingSyncQueue = true;
    var i = 0;

    {
      try {
        var _isSync2 = true;
        var _queue = syncQueue;
        runWithPriority$1(ImmediatePriority$1, function () {
          for (; i < _queue.length; i++) {
            var callback = _queue[i];

            do {
              callback = callback(_isSync2);
            } while (callback !== null);
          }
        });
        syncQueue = null;
      } catch (error) {
        // If something throws, leave the remaining callbacks on the queue.
        if (syncQueue !== null) {
          syncQueue = syncQueue.slice(i + 1);
        } // Resume flushing in the next tick


        Scheduler_scheduleCallback(Scheduler_ImmediatePriority, flushSyncCallbackQueue);
        throw error;
      } finally {
        isFlushingSyncQueue = false;
      }
    }
  }
}

// TODO: this is special because it gets imported during build.
var ReactVersion = '17.0.1';

var NoMode = 0;
var StrictMode = 1; // TODO: Remove BlockingMode and ConcurrentMode by reading from the root
// tag instead

var BlockingMode = 2;
var ConcurrentMode = 4;
var ProfileMode = 8;
var DebugTracingMode = 16;

var ReactCurrentBatchConfig = ReactSharedInternals.ReactCurrentBatchConfig;
var NoTransition = 0;
function requestCurrentTransition() {
  return ReactCurrentBatchConfig.transition;
}

var ReactStrictModeWarnings = {
  recordUnsafeLifecycleWarnings: function (fiber, instance) {},
  flushPendingUnsafeLifecycleWarnings: function () {},
  recordLegacyContextWarning: function (fiber, instance) {},
  flushLegacyContextWarning: function () {},
  discardPendingWarnings: function () {}
};

{
  var findStrictRoot = function (fiber) {
    var maybeStrictRoot = null;
    var node = fiber;

    while (node !== null) {
      if (node.mode & StrictMode) {
        maybeStrictRoot = node;
      }

      node = node.return;
    }

    return maybeStrictRoot;
  };

  var setToSortedString = function (set) {
    var array = [];
    set.forEach(function (value) {
      array.push(value);
    });
    return array.sort().join(', ');
  };

  var pendingComponentWillMountWarnings = [];
  var pendingUNSAFE_ComponentWillMountWarnings = [];
  var pendingComponentWillReceivePropsWarnings = [];
  var pendingUNSAFE_ComponentWillReceivePropsWarnings = [];
  var pendingComponentWillUpdateWarnings = [];
  var pendingUNSAFE_ComponentWillUpdateWarnings = []; // Tracks components we have already warned about.

  var didWarnAboutUnsafeLifecycles = new Set();

  ReactStrictModeWarnings.recordUnsafeLifecycleWarnings = function (fiber, instance) {
    // Dedup strategy: Warn once per component.
    if (didWarnAboutUnsafeLifecycles.has(fiber.type)) {
      return;
    }

    if (typeof instance.componentWillMount === 'function' && // Don't warn about react-lifecycles-compat polyfilled components.
    instance.componentWillMount.__suppressDeprecationWarning !== true) {
      pendingComponentWillMountWarnings.push(fiber);
    }

    if (fiber.mode & StrictMode && typeof instance.UNSAFE_componentWillMount === 'function') {
      pendingUNSAFE_ComponentWillMountWarnings.push(fiber);
    }

    if (typeof instance.componentWillReceiveProps === 'function' && instance.componentWillReceiveProps.__suppressDeprecationWarning !== true) {
      pendingComponentWillReceivePropsWarnings.push(fiber);
    }

    if (fiber.mode & StrictMode && typeof instance.UNSAFE_componentWillReceiveProps === 'function') {
      pendingUNSAFE_ComponentWillReceivePropsWarnings.push(fiber);
    }

    if (typeof instance.componentWillUpdate === 'function' && instance.componentWillUpdate.__suppressDeprecationWarning !== true) {
      pendingComponentWillUpdateWarnings.push(fiber);
    }

    if (fiber.mode & StrictMode && typeof instance.UNSAFE_componentWillUpdate === 'function') {
      pendingUNSAFE_ComponentWillUpdateWarnings.push(fiber);
    }
  };

  ReactStrictModeWarnings.flushPendingUnsafeLifecycleWarnings = function () {
    // We do an initial pass to gather component names
    var componentWillMountUniqueNames = new Set();

    if (pendingComponentWillMountWarnings.length > 0) {
      pendingComponentWillMountWarnings.forEach(function (fiber) {
        componentWillMountUniqueNames.add(getComponentName(fiber.type) || 'Component');
        didWarnAboutUnsafeLifecycles.add(fiber.type);
      });
      pendingComponentWillMountWarnings = [];
    }

    var UNSAFE_componentWillMountUniqueNames = new Set();

    if (pendingUNSAFE_ComponentWillMountWarnings.length > 0) {
      pendingUNSAFE_ComponentWillMountWarnings.forEach(function (fiber) {
        UNSAFE_componentWillMountUniqueNames.add(getComponentName(fiber.type) || 'Component');
        didWarnAboutUnsafeLifecycles.add(fiber.type);
      });
      pendingUNSAFE_ComponentWillMountWarnings = [];
    }

    var componentWillReceivePropsUniqueNames = new Set();

    if (pendingComponentWillReceivePropsWarnings.length > 0) {
      pendingComponentWillReceivePropsWarnings.forEach(function (fiber) {
        componentWillReceivePropsUniqueNames.add(getComponentName(fiber.type) || 'Component');
        didWarnAboutUnsafeLifecycles.add(fiber.type);
      });
      pendingComponentWillReceivePropsWarnings = [];
    }

    var UNSAFE_componentWillReceivePropsUniqueNames = new Set();

    if (pendingUNSAFE_ComponentWillReceivePropsWarnings.length > 0) {
      pendingUNSAFE_ComponentWillReceivePropsWarnings.forEach(function (fiber) {
        UNSAFE_componentWillReceivePropsUniqueNames.add(getComponentName(fiber.type) || 'Component');
        didWarnAboutUnsafeLifecycles.add(fiber.type);
      });
      pendingUNSAFE_ComponentWillReceivePropsWarnings = [];
    }

    var componentWillUpdateUniqueNames = new Set();

    if (pendingComponentWillUpdateWarnings.length > 0) {
      pendingComponentWillUpdateWarnings.forEach(function (fiber) {
        componentWillUpdateUniqueNames.add(getComponentName(fiber.type) || 'Component');
        didWarnAboutUnsafeLifecycles.add(fiber.type);
      });
      pendingComponentWillUpdateWarnings = [];
    }

    var UNSAFE_componentWillUpdateUniqueNames = new Set();

    if (pendingUNSAFE_ComponentWillUpdateWarnings.length > 0) {
      pendingUNSAFE_ComponentWillUpdateWarnings.forEach(function (fiber) {
        UNSAFE_componentWillUpdateUniqueNames.add(getComponentName(fiber.type) || 'Component');
        didWarnAboutUnsafeLifecycles.add(fiber.type);
      });
      pendingUNSAFE_ComponentWillUpdateWarnings = [];
    } // Finally, we flush all the warnings
    // UNSAFE_ ones before the deprecated ones, since they'll be 'louder'


    if (UNSAFE_componentWillMountUniqueNames.size > 0) {
      var sortedNames = setToSortedString(UNSAFE_componentWillMountUniqueNames);

      error('Using UNSAFE_componentWillMount in strict mode is not recommended and may indicate bugs in your code. ' + 'See https://reactjs.org/link/unsafe-component-lifecycles for details.\n\n' + '* Move code with side effects to componentDidMount, and set initial state in the constructor.\n' + '\nPlease update the following components: %s', sortedNames);
    }

    if (UNSAFE_componentWillReceivePropsUniqueNames.size > 0) {
      var _sortedNames = setToSortedString(UNSAFE_componentWillReceivePropsUniqueNames);

      error('Using UNSAFE_componentWillReceiveProps in strict mode is not recommended ' + 'and may indicate bugs in your code. ' + 'See https://reactjs.org/link/unsafe-component-lifecycles for details.\n\n' + '* Move data fetching code or side effects to componentDidUpdate.\n' + "* If you're updating state whenever props change, " + 'refactor your code to use memoization techniques or move it to ' + 'static getDerivedStateFromProps. Learn more at: https://reactjs.org/link/derived-state\n' + '\nPlease update the following components: %s', _sortedNames);
    }

    if (UNSAFE_componentWillUpdateUniqueNames.size > 0) {
      var _sortedNames2 = setToSortedString(UNSAFE_componentWillUpdateUniqueNames);

      error('Using UNSAFE_componentWillUpdate in strict mode is not recommended ' + 'and may indicate bugs in your code. ' + 'See https://reactjs.org/link/unsafe-component-lifecycles for details.\n\n' + '* Move data fetching code or side effects to componentDidUpdate.\n' + '\nPlease update the following components: %s', _sortedNames2);
    }

    if (componentWillMountUniqueNames.size > 0) {
      var _sortedNames3 = setToSortedString(componentWillMountUniqueNames);

      warn('componentWillMount has been renamed, and is not recommended for use. ' + 'See https://reactjs.org/link/unsafe-component-lifecycles for details.\n\n' + '* Move code with side effects to componentDidMount, and set initial state in the constructor.\n' + '* Rename componentWillMount to UNSAFE_componentWillMount to suppress ' + 'this warning in non-strict mode. In React 18.x, only the UNSAFE_ name will work. ' + 'To rename all deprecated lifecycles to their new names, you can run ' + '`npx react-codemod rename-unsafe-lifecycles` in your project source folder.\n' + '\nPlease update the following components: %s', _sortedNames3);
    }

    if (componentWillReceivePropsUniqueNames.size > 0) {
      var _sortedNames4 = setToSortedString(componentWillReceivePropsUniqueNames);

      warn('componentWillReceiveProps has been renamed, and is not recommended for use. ' + 'See https://reactjs.org/link/unsafe-component-lifecycles for details.\n\n' + '* Move data fetching code or side effects to componentDidUpdate.\n' + "* If you're updating state whenever props change, refactor your " + 'code to use memoization techniques or move it to ' + 'static getDerivedStateFromProps. Learn more at: https://reactjs.org/link/derived-state\n' + '* Rename componentWillReceiveProps to UNSAFE_componentWillReceiveProps to suppress ' + 'this warning in non-strict mode. In React 18.x, only the UNSAFE_ name will work. ' + 'To rename all deprecated lifecycles to their new names, you can run ' + '`npx react-codemod rename-unsafe-lifecycles` in your project source folder.\n' + '\nPlease update the following components: %s', _sortedNames4);
    }

    if (componentWillUpdateUniqueNames.size > 0) {
      var _sortedNames5 = setToSortedString(componentWillUpdateUniqueNames);

      warn('componentWillUpdate has been renamed, and is not recommended for use. ' + 'See https://reactjs.org/link/unsafe-component-lifecycles for details.\n\n' + '* Move data fetching code or side effects to componentDidUpdate.\n' + '* Rename componentWillUpdate to UNSAFE_componentWillUpdate to suppress ' + 'this warning in non-strict mode. In React 18.x, only the UNSAFE_ name will work. ' + 'To rename all deprecated lifecycles to their new names, you can run ' + '`npx react-codemod rename-unsafe-lifecycles` in your project source folder.\n' + '\nPlease update the following components: %s', _sortedNames5);
    }
  };

  var pendingLegacyContextWarning = new Map(); // Tracks components we have already warned about.

  var didWarnAboutLegacyContext = new Set();

  ReactStrictModeWarnings.recordLegacyContextWarning = function (fiber, instance) {
    var strictRoot = findStrictRoot(fiber);

    if (strictRoot === null) {
      error('Expected to find a StrictMode component in a strict mode tree. ' + 'This error is likely caused by a bug in React. Please file an issue.');

      return;
    } // Dedup strategy: Warn once per component.


    if (didWarnAboutLegacyContext.has(fiber.type)) {
      return;
    }

    var warningsForRoot = pendingLegacyContextWarning.get(strictRoot);

    if (fiber.type.contextTypes != null || fiber.type.childContextTypes != null || instance !== null && typeof instance.getChildContext === 'function') {
      if (warningsForRoot === undefined) {
        warningsForRoot = [];
        pendingLegacyContextWarning.set(strictRoot, warningsForRoot);
      }

      warningsForRoot.push(fiber);
    }
  };

  ReactStrictModeWarnings.flushLegacyContextWarning = function () {
    pendingLegacyContextWarning.forEach(function (fiberArray, strictRoot) {
      if (fiberArray.length === 0) {
        return;
      }

      var firstFiber = fiberArray[0];
      var uniqueNames = new Set();
      fiberArray.forEach(function (fiber) {
        uniqueNames.add(getComponentName(fiber.type) || 'Component');
        didWarnAboutLegacyContext.add(fiber.type);
      });
      var sortedNames = setToSortedString(uniqueNames);

      try {
        setCurrentFiber(firstFiber);

        error('Legacy context API has been detected within a strict-mode tree.' + '\n\nThe old API will be supported in all 16.x releases, but applications ' + 'using it should migrate to the new version.' + '\n\nPlease update the following components: %s' + '\n\nLearn more about this warning here: https://reactjs.org/link/legacy-context', sortedNames);
      } finally {
        resetCurrentFiber();
      }
    });
  };

  ReactStrictModeWarnings.discardPendingWarnings = function () {
    pendingComponentWillMountWarnings = [];
    pendingUNSAFE_ComponentWillMountWarnings = [];
    pendingComponentWillReceivePropsWarnings = [];
    pendingUNSAFE_ComponentWillReceivePropsWarnings = [];
    pendingComponentWillUpdateWarnings = [];
    pendingUNSAFE_ComponentWillUpdateWarnings = [];
    pendingLegacyContextWarning = new Map();
  };
}

function resolveDefaultProps(Component, baseProps) {
  if (Component && Component.defaultProps) {
    // Resolve default props. Taken from ReactElement
    var props = _assign({}, baseProps);

    var defaultProps = Component.defaultProps;

    for (var propName in defaultProps) {
      if (props[propName] === undefined) {
        props[propName] = defaultProps[propName];
      }
    }

    return props;
  }

  return baseProps;
}

// Max 31 bit integer. The max integer size in V8 for 32-bit systems.
// Math.pow(2, 30) - 1
// 0b111111111111111111111111111111
var MAX_SIGNED_31_BIT_INT = 1073741823;

var valueCursor = createCursor(null);
var rendererSigil;

{
  // Use this to detect multiple renderers using the same context
  rendererSigil = {};
}

var currentlyRenderingFiber = null;
var lastContextDependency = null;
var lastContextWithAllBitsObserved = null;
var isDisallowedContextReadInDEV = false;
function resetContextDependencies() {
  // This is called right before React yields execution, to ensure `readContext`
  // cannot be called outside the render phase.
  currentlyRenderingFiber = null;
  lastContextDependency = null;
  lastContextWithAllBitsObserved = null;

  {
    isDisallowedContextReadInDEV = false;
  }
}
function enterDisallowedContextReadInDEV() {
  {
    isDisallowedContextReadInDEV = true;
  }
}
function exitDisallowedContextReadInDEV() {
  {
    isDisallowedContextReadInDEV = false;
  }
}
function pushProvider(providerFiber, nextValue) {
  var context = providerFiber.type._context;

  {
    push(valueCursor, context._currentValue, providerFiber);
    context._currentValue = nextValue;

    {
      if (context._currentRenderer !== undefined && context._currentRenderer !== null && context._currentRenderer !== rendererSigil) {
        error('Detected multiple renderers concurrently rendering the ' + 'same context provider. This is currently unsupported.');
      }

      context._currentRenderer = rendererSigil;
    }
  }
}
function popProvider(providerFiber) {
  var currentValue = valueCursor.current;
  pop(valueCursor, providerFiber);
  var context = providerFiber.type._context;

  {
    context._currentValue = currentValue;
  }
}
function calculateChangedBits(context, newValue, oldValue) {
  if (objectIs(oldValue, newValue)) {
    // No change
    return 0;
  } else {
    var changedBits = typeof context._calculateChangedBits === 'function' ? context._calculateChangedBits(oldValue, newValue) : MAX_SIGNED_31_BIT_INT;

    {
      if ((changedBits & MAX_SIGNED_31_BIT_INT) !== changedBits) {
        error('calculateChangedBits: Expected the return value to be a ' + '31-bit integer. Instead received: %s', changedBits);
      }
    }

    return changedBits | 0;
  }
}
function scheduleWorkOnParentPath(parent, renderLanes) {
  // Update the child lanes of all the ancestors, including the alternates.
  var node = parent;

  while (node !== null) {
    var alternate = node.alternate;

    if (!isSubsetOfLanes(node.childLanes, renderLanes)) {
      node.childLanes = mergeLanes(node.childLanes, renderLanes);

      if (alternate !== null) {
        alternate.childLanes = mergeLanes(alternate.childLanes, renderLanes);
      }
    } else if (alternate !== null && !isSubsetOfLanes(alternate.childLanes, renderLanes)) {
      alternate.childLanes = mergeLanes(alternate.childLanes, renderLanes);
    } else {
      // Neither alternate was updated, which means the rest of the
      // ancestor path already has sufficient priority.
      break;
    }

    node = node.return;
  }
}
function propagateContextChange(workInProgress, context, changedBits, renderLanes) {
  var fiber = workInProgress.child;

  if (fiber !== null) {
    // Set the return pointer of the child to the work-in-progress fiber.
    fiber.return = workInProgress;
  }

  while (fiber !== null) {
    var nextFiber = void 0; // Visit this fiber.

    var list = fiber.dependencies;

    if (list !== null) {
      nextFiber = fiber.child;
      var dependency = list.firstContext;

      while (dependency !== null) {
        // Check if the context matches.
        if (dependency.context === context && (dependency.observedBits & changedBits) !== 0) {
          // Match! Schedule an update on this fiber.
          if (fiber.tag === ClassComponent) {
            // Schedule a force update on the work-in-progress.
            var update = createUpdate(NoTimestamp, pickArbitraryLane(renderLanes));
            update.tag = ForceUpdate; // TODO: Because we don't have a work-in-progress, this will add the
            // update to the current fiber, too, which means it will persist even if
            // this render is thrown away. Since it's a race condition, not sure it's
            // worth fixing.

            enqueueUpdate(fiber, update);
          }

          fiber.lanes = mergeLanes(fiber.lanes, renderLanes);
          var alternate = fiber.alternate;

          if (alternate !== null) {
            alternate.lanes = mergeLanes(alternate.lanes, renderLanes);
          }

          scheduleWorkOnParentPath(fiber.return, renderLanes); // Mark the updated lanes on the list, too.

          list.lanes = mergeLanes(list.lanes, renderLanes); // Since we already found a match, we can stop traversing the
          // dependency list.

          break;
        }

        dependency = dependency.next;
      }
    } else if (fiber.tag === ContextProvider) {
      // Don't scan deeper if this is a matching provider
      nextFiber = fiber.type === workInProgress.type ? null : fiber.child;
    } else {
      // Traverse down.
      nextFiber = fiber.child;
    }

    if (nextFiber !== null) {
      // Set the return pointer of the child to the work-in-progress fiber.
      nextFiber.return = fiber;
    } else {
      // No child. Traverse to next sibling.
      nextFiber = fiber;

      while (nextFiber !== null) {
        if (nextFiber === workInProgress) {
          // We're back to the root of this subtree. Exit.
          nextFiber = null;
          break;
        }

        var sibling = nextFiber.sibling;

        if (sibling !== null) {
          // Set the return pointer of the sibling to the work-in-progress fiber.
          sibling.return = nextFiber.return;
          nextFiber = sibling;
          break;
        } // No more siblings. Traverse up.


        nextFiber = nextFiber.return;
      }
    }

    fiber = nextFiber;
  }
}
function prepareToReadContext(workInProgress, renderLanes) {
  currentlyRenderingFiber = workInProgress;
  lastContextDependency = null;
  lastContextWithAllBitsObserved = null;
  var dependencies = workInProgress.dependencies;

  if (dependencies !== null) {
    var firstContext = dependencies.firstContext;

    if (firstContext !== null) {
      if (includesSomeLane(dependencies.lanes, renderLanes)) {
        // Context list has a pending update. Mark that this fiber performed work.
        markWorkInProgressReceivedUpdate();
      } // Reset the work-in-progress list


      dependencies.firstContext = null;
    }
  }
}
function readContext(context, observedBits) {
  {
    // This warning would fire if you read context inside a Hook like useMemo.
    // Unlike the class check below, it's not enforced in production for perf.
    if (isDisallowedContextReadInDEV) {
      error('Context can only be read while React is rendering. ' + 'In classes, you can read it in the render method or getDerivedStateFromProps. ' + 'In function components, you can read it directly in the function body, but not ' + 'inside Hooks like useReducer() or useMemo().');
    }
  }

  if (lastContextWithAllBitsObserved === context) ; else if (observedBits === false || observedBits === 0) ; else {
    var resolvedObservedBits; // Avoid deopting on observable arguments or heterogeneous types.

    if (typeof observedBits !== 'number' || observedBits === MAX_SIGNED_31_BIT_INT) {
      // Observe all updates.
      lastContextWithAllBitsObserved = context;
      resolvedObservedBits = MAX_SIGNED_31_BIT_INT;
    } else {
      resolvedObservedBits = observedBits;
    }

    var contextItem = {
      context: context,
      observedBits: resolvedObservedBits,
      next: null
    };

    if (lastContextDependency === null) {
      if (!(currentlyRenderingFiber !== null)) {
        {
          throw Error( "Context can only be read while React is rendering. In classes, you can read it in the render method or getDerivedStateFromProps. In function components, you can read it directly in the function body, but not inside Hooks like useReducer() or useMemo()." );
        }
      } // This is the first dependency for this component. Create a new list.


      lastContextDependency = contextItem;
      currentlyRenderingFiber.dependencies = {
        lanes: NoLanes,
        firstContext: contextItem,
        responders: null
      };
    } else {
      // Append a new context item.
      lastContextDependency = lastContextDependency.next = contextItem;
    }
  }

  return  context._currentValue ;
}

var UpdateState = 0;
var ReplaceState = 1;
var ForceUpdate = 2;
var CaptureUpdate = 3; // Global state that is reset at the beginning of calling `processUpdateQueue`.
// It should only be read right after calling `processUpdateQueue`, via
// `checkHasForceUpdateAfterProcessing`.

var hasForceUpdate = false;
var didWarnUpdateInsideUpdate;
var currentlyProcessingQueue;

{
  didWarnUpdateInsideUpdate = false;
  currentlyProcessingQueue = null;
}

function initializeUpdateQueue(fiber) {
  var queue = {
    baseState: fiber.memoizedState,
    firstBaseUpdate: null,
    lastBaseUpdate: null,
    shared: {
      pending: null
    },
    effects: null
  };
  fiber.updateQueue = queue;
}
function cloneUpdateQueue(current, workInProgress) {
  // Clone the update queue from current. Unless it's already a clone.
  var queue = workInProgress.updateQueue;
  var currentQueue = current.updateQueue;

  if (queue === currentQueue) {
    var clone = {
      baseState: currentQueue.baseState,
      firstBaseUpdate: currentQueue.firstBaseUpdate,
      lastBaseUpdate: currentQueue.lastBaseUpdate,
      shared: currentQueue.shared,
      effects: currentQueue.effects
    };
    workInProgress.updateQueue = clone;
  }
}
function createUpdate(eventTime, lane) {
  var update = {
    eventTime: eventTime,
    lane: lane,
    tag: UpdateState,
    payload: null,
    callback: null,
    next: null
  };
  return update;
}
function enqueueUpdate(fiber, update) {
  var updateQueue = fiber.updateQueue;

  if (updateQueue === null) {
    // Only occurs if the fiber has been unmounted.
    return;
  }

  var sharedQueue = updateQueue.shared;
  var pending = sharedQueue.pending;

  if (pending === null) {
    // This is the first update. Create a circular list.
    update.next = update;
  } else {
    update.next = pending.next;
    pending.next = update;
  }

  sharedQueue.pending = update;

  {
    if (currentlyProcessingQueue === sharedQueue && !didWarnUpdateInsideUpdate) {
      error('An update (setState, replaceState, or forceUpdate) was scheduled ' + 'from inside an update function. Update functions should be pure, ' + 'with zero side-effects. Consider using componentDidUpdate or a ' + 'callback.');

      didWarnUpdateInsideUpdate = true;
    }
  }
}
function enqueueCapturedUpdate(workInProgress, capturedUpdate) {
  // Captured updates are updates that are thrown by a child during the render
  // phase. They should be discarded if the render is aborted. Therefore,
  // we should only put them on the work-in-progress queue, not the current one.
  var queue = workInProgress.updateQueue; // Check if the work-in-progress queue is a clone.

  var current = workInProgress.alternate;

  if (current !== null) {
    var currentQueue = current.updateQueue;

    if (queue === currentQueue) {
      // The work-in-progress queue is the same as current. This happens when
      // we bail out on a parent fiber that then captures an error thrown by
      // a child. Since we want to append the update only to the work-in
      // -progress queue, we need to clone the updates. We usually clone during
      // processUpdateQueue, but that didn't happen in this case because we
      // skipped over the parent when we bailed out.
      var newFirst = null;
      var newLast = null;
      var firstBaseUpdate = queue.firstBaseUpdate;

      if (firstBaseUpdate !== null) {
        // Loop through the updates and clone them.
        var update = firstBaseUpdate;

        do {
          var clone = {
            eventTime: update.eventTime,
            lane: update.lane,
            tag: update.tag,
            payload: update.payload,
            callback: update.callback,
            next: null
          };

          if (newLast === null) {
            newFirst = newLast = clone;
          } else {
            newLast.next = clone;
            newLast = clone;
          }

          update = update.next;
        } while (update !== null); // Append the captured update the end of the cloned list.


        if (newLast === null) {
          newFirst = newLast = capturedUpdate;
        } else {
          newLast.next = capturedUpdate;
          newLast = capturedUpdate;
        }
      } else {
        // There are no base updates.
        newFirst = newLast = capturedUpdate;
      }

      queue = {
        baseState: currentQueue.baseState,
        firstBaseUpdate: newFirst,
        lastBaseUpdate: newLast,
        shared: currentQueue.shared,
        effects: currentQueue.effects
      };
      workInProgress.updateQueue = queue;
      return;
    }
  } // Append the update to the end of the list.


  var lastBaseUpdate = queue.lastBaseUpdate;

  if (lastBaseUpdate === null) {
    queue.firstBaseUpdate = capturedUpdate;
  } else {
    lastBaseUpdate.next = capturedUpdate;
  }

  queue.lastBaseUpdate = capturedUpdate;
}

function getStateFromUpdate(workInProgress, queue, update, prevState, nextProps, instance) {
  switch (update.tag) {
    case ReplaceState:
      {
        var payload = update.payload;

        if (typeof payload === 'function') {
          // Updater function
          {
            enterDisallowedContextReadInDEV();
          }

          var nextState = payload.call(instance, prevState, nextProps);

          {
            if ( workInProgress.mode & StrictMode) {
              disableLogs();

              try {
                payload.call(instance, prevState, nextProps);
              } finally {
                reenableLogs();
              }
            }

            exitDisallowedContextReadInDEV();
          }

          return nextState;
        } // State object


        return payload;
      }

    case CaptureUpdate:
      {
        workInProgress.flags = workInProgress.flags & ~ShouldCapture | DidCapture;
      }
    // Intentional fallthrough

    case UpdateState:
      {
        var _payload = update.payload;
        var partialState;

        if (typeof _payload === 'function') {
          // Updater function
          {
            enterDisallowedContextReadInDEV();
          }

          partialState = _payload.call(instance, prevState, nextProps);

          {
            if ( workInProgress.mode & StrictMode) {
              disableLogs();

              try {
                _payload.call(instance, prevState, nextProps);
              } finally {
                reenableLogs();
              }
            }

            exitDisallowedContextReadInDEV();
          }
        } else {
          // Partial state object
          partialState = _payload;
        }

        if (partialState === null || partialState === undefined) {
          // Null and undefined are treated as no-ops.
          return prevState;
        } // Merge the partial state and the previous state.


        return _assign({}, prevState, partialState);
      }

    case ForceUpdate:
      {
        hasForceUpdate = true;
        return prevState;
      }
  }

  return prevState;
}

function processUpdateQueue(workInProgress, props, instance, renderLanes) {
  // This is always non-null on a ClassComponent or HostRoot
  var queue = workInProgress.updateQueue;
  hasForceUpdate = false;

  {
    currentlyProcessingQueue = queue.shared;
  }

  var firstBaseUpdate = queue.firstBaseUpdate;
  var lastBaseUpdate = queue.lastBaseUpdate; // Check if there are pending updates. If so, transfer them to the base queue.

  var pendingQueue = queue.shared.pending;

  if (pendingQueue !== null) {
    queue.shared.pending = null; // The pending queue is circular. Disconnect the pointer between first
    // and last so that it's non-circular.

    var lastPendingUpdate = pendingQueue;
    var firstPendingUpdate = lastPendingUpdate.next;
    lastPendingUpdate.next = null; // Append pending updates to base queue

    if (lastBaseUpdate === null) {
      firstBaseUpdate = firstPendingUpdate;
    } else {
      lastBaseUpdate.next = firstPendingUpdate;
    }

    lastBaseUpdate = lastPendingUpdate; // If there's a current queue, and it's different from the base queue, then
    // we need to transfer the updates to that queue, too. Because the base
    // queue is a singly-linked list with no cycles, we can append to both
    // lists and take advantage of structural sharing.
    // TODO: Pass `current` as argument

    var current = workInProgress.alternate;

    if (current !== null) {
      // This is always non-null on a ClassComponent or HostRoot
      var currentQueue = current.updateQueue;
      var currentLastBaseUpdate = currentQueue.lastBaseUpdate;

      if (currentLastBaseUpdate !== lastBaseUpdate) {
        if (currentLastBaseUpdate === null) {
          currentQueue.firstBaseUpdate = firstPendingUpdate;
        } else {
          currentLastBaseUpdate.next = firstPendingUpdate;
        }

        currentQueue.lastBaseUpdate = lastPendingUpdate;
      }
    }
  } // These values may change as we process the queue.


  if (firstBaseUpdate !== null) {
    // Iterate through the list of updates to compute the result.
    var newState = queue.baseState; // TODO: Don't need to accumulate this. Instead, we can remove renderLanes
    // from the original lanes.

    var newLanes = NoLanes;
    var newBaseState = null;
    var newFirstBaseUpdate = null;
    var newLastBaseUpdate = null;
    var update = firstBaseUpdate;

    do {
      var updateLane = update.lane;
      var updateEventTime = update.eventTime;

      if (!isSubsetOfLanes(renderLanes, updateLane)) {
        // Priority is insufficient. Skip this update. If this is the first
        // skipped update, the previous update/state is the new base
        // update/state.
        var clone = {
          eventTime: updateEventTime,
          lane: updateLane,
          tag: update.tag,
          payload: update.payload,
          callback: update.callback,
          next: null
        };

        if (newLastBaseUpdate === null) {
          newFirstBaseUpdate = newLastBaseUpdate = clone;
          newBaseState = newState;
        } else {
          newLastBaseUpdate = newLastBaseUpdate.next = clone;
        } // Update the remaining priority in the queue.


        newLanes = mergeLanes(newLanes, updateLane);
      } else {
        // This update does have sufficient priority.
        if (newLastBaseUpdate !== null) {
          var _clone = {
            eventTime: updateEventTime,
            // This update is going to be committed so we never want uncommit
            // it. Using NoLane works because 0 is a subset of all bitmasks, so
            // this will never be skipped by the check above.
            lane: NoLane,
            tag: update.tag,
            payload: update.payload,
            callback: update.callback,
            next: null
          };
          newLastBaseUpdate = newLastBaseUpdate.next = _clone;
        } // Process this update.


        newState = getStateFromUpdate(workInProgress, queue, update, newState, props, instance);
        var callback = update.callback;

        if (callback !== null) {
          workInProgress.flags |= Callback;
          var effects = queue.effects;

          if (effects === null) {
            queue.effects = [update];
          } else {
            effects.push(update);
          }
        }
      }

      update = update.next;

      if (update === null) {
        pendingQueue = queue.shared.pending;

        if (pendingQueue === null) {
          break;
        } else {
          // An update was scheduled from inside a reducer. Add the new
          // pending updates to the end of the list and keep processing.
          var _lastPendingUpdate = pendingQueue; // Intentionally unsound. Pending updates form a circular list, but we
          // unravel them when transferring them to the base queue.

          var _firstPendingUpdate = _lastPendingUpdate.next;
          _lastPendingUpdate.next = null;
          update = _firstPendingUpdate;
          queue.lastBaseUpdate = _lastPendingUpdate;
          queue.shared.pending = null;
        }
      }
    } while (true);

    if (newLastBaseUpdate === null) {
      newBaseState = newState;
    }

    queue.baseState = newBaseState;
    queue.firstBaseUpdate = newFirstBaseUpdate;
    queue.lastBaseUpdate = newLastBaseUpdate; // Set the remaining expiration time to be whatever is remaining in the queue.
    // This should be fine because the only two other things that contribute to
    // expiration time are props and context. We're already in the middle of the
    // begin phase by the time we start processing the queue, so we've already
    // dealt with the props. Context in components that specify
    // shouldComponentUpdate is tricky; but we'll have to account for
    // that regardless.

    markSkippedUpdateLanes(newLanes);
    workInProgress.lanes = newLanes;
    workInProgress.memoizedState = newState;
  }

  {
    currentlyProcessingQueue = null;
  }
}

function callCallback(callback, context) {
  if (!(typeof callback === 'function')) {
    {
      throw Error( "Invalid argument passed as callback. Expected a function. Instead received: " + callback );
    }
  }

  callback.call(context);
}

function resetHasForceUpdateBeforeProcessing() {
  hasForceUpdate = false;
}
function checkHasForceUpdateAfterProcessing() {
  return hasForceUpdate;
}
function commitUpdateQueue(finishedWork, finishedQueue, instance) {
  // Commit the effects
  var effects = finishedQueue.effects;
  finishedQueue.effects = null;

  if (effects !== null) {
    for (var i = 0; i < effects.length; i++) {
      var effect = effects[i];
      var callback = effect.callback;

      if (callback !== null) {
        effect.callback = null;
        callCallback(callback, instance);
      }
    }
  }
}

var fakeInternalInstance = {};
var isArray = Array.isArray; // React.Component uses a shared frozen object by default.
// We'll use it to determine whether we need to initialize legacy refs.

var emptyRefsObject = new React.Component().refs;
var didWarnAboutStateAssignmentForComponent;
var didWarnAboutUninitializedState;
var didWarnAboutGetSnapshotBeforeUpdateWithoutDidUpdate;
var didWarnAboutLegacyLifecyclesAndDerivedState;
var didWarnAboutUndefinedDerivedState;
var warnOnUndefinedDerivedState;
var warnOnInvalidCallback;
var didWarnAboutDirectlyAssigningPropsToState;
var didWarnAboutContextTypeAndContextTypes;
var didWarnAboutInvalidateContextType;

{
  didWarnAboutStateAssignmentForComponent = new Set();
  didWarnAboutUninitializedState = new Set();
  didWarnAboutGetSnapshotBeforeUpdateWithoutDidUpdate = new Set();
  didWarnAboutLegacyLifecyclesAndDerivedState = new Set();
  didWarnAboutDirectlyAssigningPropsToState = new Set();
  didWarnAboutUndefinedDerivedState = new Set();
  didWarnAboutContextTypeAndContextTypes = new Set();
  didWarnAboutInvalidateContextType = new Set();
  var didWarnOnInvalidCallback = new Set();

  warnOnInvalidCallback = function (callback, callerName) {
    if (callback === null || typeof callback === 'function') {
      return;
    }

    var key = callerName + '_' + callback;

    if (!didWarnOnInvalidCallback.has(key)) {
      didWarnOnInvalidCallback.add(key);

      error('%s(...): Expected the last optional `callback` argument to be a ' + 'function. Instead received: %s.', callerName, callback);
    }
  };

  warnOnUndefinedDerivedState = function (type, partialState) {
    if (partialState === undefined) {
      var componentName = getComponentName(type) || 'Component';

      if (!didWarnAboutUndefinedDerivedState.has(componentName)) {
        didWarnAboutUndefinedDerivedState.add(componentName);

        error('%s.getDerivedStateFromProps(): A valid state object (or null) must be returned. ' + 'You have returned undefined.', componentName);
      }
    }
  }; // This is so gross but it's at least non-critical and can be removed if
  // it causes problems. This is meant to give a nicer error message for
  // ReactDOM15.unstable_renderSubtreeIntoContainer(reactDOM16Component,
  // ...)) which otherwise throws a "_processChildContext is not a function"
  // exception.


  Object.defineProperty(fakeInternalInstance, '_processChildContext', {
    enumerable: false,
    value: function () {
      {
        {
          throw Error( "_processChildContext is not available in React 16+. This likely means you have multiple copies of React and are attempting to nest a React 15 tree inside a React 16 tree using unstable_renderSubtreeIntoContainer, which isn't supported. Try to make sure you have only one copy of React (and ideally, switch to ReactDOM.createPortal)." );
        }
      }
    }
  });
  Object.freeze(fakeInternalInstance);
}

function applyDerivedStateFromProps(workInProgress, ctor, getDerivedStateFromProps, nextProps) {
  var prevState = workInProgress.memoizedState;

  {
    if ( workInProgress.mode & StrictMode) {
      disableLogs();

      try {
        // Invoke the function an extra time to help detect side-effects.
        getDerivedStateFromProps(nextProps, prevState);
      } finally {
        reenableLogs();
      }
    }
  }

  var partialState = getDerivedStateFromProps(nextProps, prevState);

  {
    warnOnUndefinedDerivedState(ctor, partialState);
  } // Merge the partial state and the previous state.


  var memoizedState = partialState === null || partialState === undefined ? prevState : _assign({}, prevState, partialState);
  workInProgress.memoizedState = memoizedState; // Once the update queue is empty, persist the derived state onto the
  // base state.

  if (workInProgress.lanes === NoLanes) {
    // Queue is always non-null for classes
    var updateQueue = workInProgress.updateQueue;
    updateQueue.baseState = memoizedState;
  }
}
var classComponentUpdater = {
  isMounted: isMounted,
  enqueueSetState: function (inst, payload, callback) {
    var fiber = get(inst);
    var eventTime = requestEventTime();
    var lane = requestUpdateLane(fiber);
    var update = createUpdate(eventTime, lane);
    update.payload = payload;

    if (callback !== undefined && callback !== null) {
      {
        warnOnInvalidCallback(callback, 'setState');
      }

      update.callback = callback;
    }

    enqueueUpdate(fiber, update);
    scheduleUpdateOnFiber(fiber, lane, eventTime);
  },
  enqueueReplaceState: function (inst, payload, callback) {
    var fiber = get(inst);
    var eventTime = requestEventTime();
    var lane = requestUpdateLane(fiber);
    var update = createUpdate(eventTime, lane);
    update.tag = ReplaceState;
    update.payload = payload;

    if (callback !== undefined && callback !== null) {
      {
        warnOnInvalidCallback(callback, 'replaceState');
      }

      update.callback = callback;
    }

    enqueueUpdate(fiber, update);
    scheduleUpdateOnFiber(fiber, lane, eventTime);
  },
  enqueueForceUpdate: function (inst, callback) {
    var fiber = get(inst);
    var eventTime = requestEventTime();
    var lane = requestUpdateLane(fiber);
    var update = createUpdate(eventTime, lane);
    update.tag = ForceUpdate;

    if (callback !== undefined && callback !== null) {
      {
        warnOnInvalidCallback(callback, 'forceUpdate');
      }

      update.callback = callback;
    }

    enqueueUpdate(fiber, update);
    scheduleUpdateOnFiber(fiber, lane, eventTime);
  }
};

function checkShouldComponentUpdate(workInProgress, ctor, oldProps, newProps, oldState, newState, nextContext) {
  var instance = workInProgress.stateNode;

  if (typeof instance.shouldComponentUpdate === 'function') {
    {
      if ( workInProgress.mode & StrictMode) {
        disableLogs();

        try {
          // Invoke the function an extra time to help detect side-effects.
          instance.shouldComponentUpdate(newProps, newState, nextContext);
        } finally {
          reenableLogs();
        }
      }
    }

    var shouldUpdate = instance.shouldComponentUpdate(newProps, newState, nextContext);

    {
      if (shouldUpdate === undefined) {
        error('%s.shouldComponentUpdate(): Returned undefined instead of a ' + 'boolean value. Make sure to return true or false.', getComponentName(ctor) || 'Component');
      }
    }

    return shouldUpdate;
  }

  if (ctor.prototype && ctor.prototype.isPureReactComponent) {
    return !shallowEqual(oldProps, newProps) || !shallowEqual(oldState, newState);
  }

  return true;
}

function checkClassInstance(workInProgress, ctor, newProps) {
  var instance = workInProgress.stateNode;

  {
    var name = getComponentName(ctor) || 'Component';
    var renderPresent = instance.render;

    if (!renderPresent) {
      if (ctor.prototype && typeof ctor.prototype.render === 'function') {
        error('%s(...): No `render` method found on the returned component ' + 'instance: did you accidentally return an object from the constructor?', name);
      } else {
        error('%s(...): No `render` method found on the returned component ' + 'instance: you may have forgotten to define `render`.', name);
      }
    }

    if (instance.getInitialState && !instance.getInitialState.isReactClassApproved && !instance.state) {
      error('getInitialState was defined on %s, a plain JavaScript class. ' + 'This is only supported for classes created using React.createClass. ' + 'Did you mean to define a state property instead?', name);
    }

    if (instance.getDefaultProps && !instance.getDefaultProps.isReactClassApproved) {
      error('getDefaultProps was defined on %s, a plain JavaScript class. ' + 'This is only supported for classes created using React.createClass. ' + 'Use a static property to define defaultProps instead.', name);
    }

    if (instance.propTypes) {
      error('propTypes was defined as an instance property on %s. Use a static ' + 'property to define propTypes instead.', name);
    }

    if (instance.contextType) {
      error('contextType was defined as an instance property on %s. Use a static ' + 'property to define contextType instead.', name);
    }

    {
      if (instance.contextTypes) {
        error('contextTypes was defined as an instance property on %s. Use a static ' + 'property to define contextTypes instead.', name);
      }

      if (ctor.contextType && ctor.contextTypes && !didWarnAboutContextTypeAndContextTypes.has(ctor)) {
        didWarnAboutContextTypeAndContextTypes.add(ctor);

        error('%s declares both contextTypes and contextType static properties. ' + 'The legacy contextTypes property will be ignored.', name);
      }
    }

    if (typeof instance.componentShouldUpdate === 'function') {
      error('%s has a method called ' + 'componentShouldUpdate(). Did you mean shouldComponentUpdate()? ' + 'The name is phrased as a question because the function is ' + 'expected to return a value.', name);
    }

    if (ctor.prototype && ctor.prototype.isPureReactComponent && typeof instance.shouldComponentUpdate !== 'undefined') {
      error('%s has a method called shouldComponentUpdate(). ' + 'shouldComponentUpdate should not be used when extending React.PureComponent. ' + 'Please extend React.Component if shouldComponentUpdate is used.', getComponentName(ctor) || 'A pure component');
    }

    if (typeof instance.componentDidUnmount === 'function') {
      error('%s has a method called ' + 'componentDidUnmount(). But there is no such lifecycle method. ' + 'Did you mean componentWillUnmount()?', name);
    }

    if (typeof instance.componentDidReceiveProps === 'function') {
      error('%s has a method called ' + 'componentDidReceiveProps(). But there is no such lifecycle method. ' + 'If you meant to update the state in response to changing props, ' + 'use componentWillReceiveProps(). If you meant to fetch data or ' + 'run side-effects or mutations after React has updated the UI, use componentDidUpdate().', name);
    }

    if (typeof instance.componentWillRecieveProps === 'function') {
      error('%s has a method called ' + 'componentWillRecieveProps(). Did you mean componentWillReceiveProps()?', name);
    }

    if (typeof instance.UNSAFE_componentWillRecieveProps === 'function') {
      error('%s has a method called ' + 'UNSAFE_componentWillRecieveProps(). Did you mean UNSAFE_componentWillReceiveProps()?', name);
    }

    var hasMutatedProps = instance.props !== newProps;

    if (instance.props !== undefined && hasMutatedProps) {
      error('%s(...): When calling super() in `%s`, make sure to pass ' + "up the same props that your component's constructor was passed.", name, name);
    }

    if (instance.defaultProps) {
      error('Setting defaultProps as an instance property on %s is not supported and will be ignored.' + ' Instead, define defaultProps as a static property on %s.', name, name);
    }

    if (typeof instance.getSnapshotBeforeUpdate === 'function' && typeof instance.componentDidUpdate !== 'function' && !didWarnAboutGetSnapshotBeforeUpdateWithoutDidUpdate.has(ctor)) {
      didWarnAboutGetSnapshotBeforeUpdateWithoutDidUpdate.add(ctor);

      error('%s: getSnapshotBeforeUpdate() should be used with componentDidUpdate(). ' + 'This component defines getSnapshotBeforeUpdate() only.', getComponentName(ctor));
    }

    if (typeof instance.getDerivedStateFromProps === 'function') {
      error('%s: getDerivedStateFromProps() is defined as an instance method ' + 'and will be ignored. Instead, declare it as a static method.', name);
    }

    if (typeof instance.getDerivedStateFromError === 'function') {
      error('%s: getDerivedStateFromError() is defined as an instance method ' + 'and will be ignored. Instead, declare it as a static method.', name);
    }

    if (typeof ctor.getSnapshotBeforeUpdate === 'function') {
      error('%s: getSnapshotBeforeUpdate() is defined as a static method ' + 'and will be ignored. Instead, declare it as an instance method.', name);
    }

    var _state = instance.state;

    if (_state && (typeof _state !== 'object' || isArray(_state))) {
      error('%s.state: must be set to an object or null', name);
    }

    if (typeof instance.getChildContext === 'function' && typeof ctor.childContextTypes !== 'object') {
      error('%s.getChildContext(): childContextTypes must be defined in order to ' + 'use getChildContext().', name);
    }
  }
}

function adoptClassInstance(workInProgress, instance) {
  instance.updater = classComponentUpdater;
  workInProgress.stateNode = instance; // The instance needs access to the fiber so that it can schedule updates

  set(instance, workInProgress);

  {
    instance._reactInternalInstance = fakeInternalInstance;
  }
}

function constructClassInstance(workInProgress, ctor, props) {
  var isLegacyContextConsumer = false;
  var unmaskedContext = emptyContextObject;
  var context = emptyContextObject;
  var contextType = ctor.contextType;

  {
    if ('contextType' in ctor) {
      var isValid = // Allow null for conditional declaration
      contextType === null || contextType !== undefined && contextType.$$typeof === REACT_CONTEXT_TYPE && contextType._context === undefined; // Not a <Context.Consumer>

      if (!isValid && !didWarnAboutInvalidateContextType.has(ctor)) {
        didWarnAboutInvalidateContextType.add(ctor);
        var addendum = '';

        if (contextType === undefined) {
          addendum = ' However, it is set to undefined. ' + 'This can be caused by a typo or by mixing up named and default imports. ' + 'This can also happen due to a circular dependency, so ' + 'try moving the createContext() call to a separate file.';
        } else if (typeof contextType !== 'object') {
          addendum = ' However, it is set to a ' + typeof contextType + '.';
        } else if (contextType.$$typeof === REACT_PROVIDER_TYPE) {
          addendum = ' Did you accidentally pass the Context.Provider instead?';
        } else if (contextType._context !== undefined) {
          // <Context.Consumer>
          addendum = ' Did you accidentally pass the Context.Consumer instead?';
        } else {
          addendum = ' However, it is set to an object with keys {' + Object.keys(contextType).join(', ') + '}.';
        }

        error('%s defines an invalid contextType. ' + 'contextType should point to the Context object returned by React.createContext().%s', getComponentName(ctor) || 'Component', addendum);
      }
    }
  }

  if (typeof contextType === 'object' && contextType !== null) {
    context = readContext(contextType);
  } else {
    unmaskedContext = getUnmaskedContext(workInProgress, ctor, true);
    var contextTypes = ctor.contextTypes;
    isLegacyContextConsumer = contextTypes !== null && contextTypes !== undefined;
    context = isLegacyContextConsumer ? getMaskedContext(workInProgress, unmaskedContext) : emptyContextObject;
  } // Instantiate twice to help detect side-effects.


  {
    if ( workInProgress.mode & StrictMode) {
      disableLogs();

      try {
        new ctor(props, context); // eslint-disable-line no-new
      } finally {
        reenableLogs();
      }
    }
  }

  var instance = new ctor(props, context);
  var state = workInProgress.memoizedState = instance.state !== null && instance.state !== undefined ? instance.state : null;
  adoptClassInstance(workInProgress, instance);

  {
    if (typeof ctor.getDerivedStateFromProps === 'function' && state === null) {
      var componentName = getComponentName(ctor) || 'Component';

      if (!didWarnAboutUninitializedState.has(componentName)) {
        didWarnAboutUninitializedState.add(componentName);

        error('`%s` uses `getDerivedStateFromProps` but its initial state is ' + '%s. This is not recommended. Instead, define the initial state by ' + 'assigning an object to `this.state` in the constructor of `%s`. ' + 'This ensures that `getDerivedStateFromProps` arguments have a consistent shape.', componentName, instance.state === null ? 'null' : 'undefined', componentName);
      }
    } // If new component APIs are defined, "unsafe" lifecycles won't be called.
    // Warn about these lifecycles if they are present.
    // Don't warn about react-lifecycles-compat polyfilled methods though.


    if (typeof ctor.getDerivedStateFromProps === 'function' || typeof instance.getSnapshotBeforeUpdate === 'function') {
      var foundWillMountName = null;
      var foundWillReceivePropsName = null;
      var foundWillUpdateName = null;

      if (typeof instance.componentWillMount === 'function' && instance.componentWillMount.__suppressDeprecationWarning !== true) {
        foundWillMountName = 'componentWillMount';
      } else if (typeof instance.UNSAFE_componentWillMount === 'function') {
        foundWillMountName = 'UNSAFE_componentWillMount';
      }

      if (typeof instance.componentWillReceiveProps === 'function' && instance.componentWillReceiveProps.__suppressDeprecationWarning !== true) {
        foundWillReceivePropsName = 'componentWillReceiveProps';
      } else if (typeof instance.UNSAFE_componentWillReceiveProps === 'function') {
        foundWillReceivePropsName = 'UNSAFE_componentWillReceiveProps';
      }

      if (typeof instance.componentWillUpdate === 'function' && instance.componentWillUpdate.__suppressDeprecationWarning !== true) {
        foundWillUpdateName = 'componentWillUpdate';
      } else if (typeof instance.UNSAFE_componentWillUpdate === 'function') {
        foundWillUpdateName = 'UNSAFE_componentWillUpdate';
      }

      if (foundWillMountName !== null || foundWillReceivePropsName !== null || foundWillUpdateName !== null) {
        var _componentName = getComponentName(ctor) || 'Component';

        var newApiName = typeof ctor.getDerivedStateFromProps === 'function' ? 'getDerivedStateFromProps()' : 'getSnapshotBeforeUpdate()';

        if (!didWarnAboutLegacyLifecyclesAndDerivedState.has(_componentName)) {
          didWarnAboutLegacyLifecyclesAndDerivedState.add(_componentName);

          error('Unsafe legacy lifecycles will not be called for components using new component APIs.\n\n' + '%s uses %s but also contains the following legacy lifecycles:%s%s%s\n\n' + 'The above lifecycles should be removed. Learn more about this warning here:\n' + 'https://reactjs.org/link/unsafe-component-lifecycles', _componentName, newApiName, foundWillMountName !== null ? "\n  " + foundWillMountName : '', foundWillReceivePropsName !== null ? "\n  " + foundWillReceivePropsName : '', foundWillUpdateName !== null ? "\n  " + foundWillUpdateName : '');
        }
      }
    }
  } // Cache unmasked context so we can avoid recreating masked context unless necessary.
  // ReactFiberContext usually updates this cache but can't for newly-created instances.


  if (isLegacyContextConsumer) {
    cacheContext(workInProgress, unmaskedContext, context);
  }

  return instance;
}

function callComponentWillMount(workInProgress, instance) {
  var oldState = instance.state;

  if (typeof instance.componentWillMount === 'function') {
    instance.componentWillMount();
  }

  if (typeof instance.UNSAFE_componentWillMount === 'function') {
    instance.UNSAFE_componentWillMount();
  }

  if (oldState !== instance.state) {
    {
      error('%s.componentWillMount(): Assigning directly to this.state is ' + "deprecated (except inside a component's " + 'constructor). Use setState instead.', getComponentName(workInProgress.type) || 'Component');
    }

    classComponentUpdater.enqueueReplaceState(instance, instance.state, null);
  }
}

function callComponentWillReceiveProps(workInProgress, instance, newProps, nextContext) {
  var oldState = instance.state;

  if (typeof instance.componentWillReceiveProps === 'function') {
    instance.componentWillReceiveProps(newProps, nextContext);
  }

  if (typeof instance.UNSAFE_componentWillReceiveProps === 'function') {
    instance.UNSAFE_componentWillReceiveProps(newProps, nextContext);
  }

  if (instance.state !== oldState) {
    {
      var componentName = getComponentName(workInProgress.type) || 'Component';

      if (!didWarnAboutStateAssignmentForComponent.has(componentName)) {
        didWarnAboutStateAssignmentForComponent.add(componentName);

        error('%s.componentWillReceiveProps(): Assigning directly to ' + "this.state is deprecated (except inside a component's " + 'constructor). Use setState instead.', componentName);
      }
    }

    classComponentUpdater.enqueueReplaceState(instance, instance.state, null);
  }
} // Invokes the mount life-cycles on a previously never rendered instance.


function mountClassInstance(workInProgress, ctor, newProps, renderLanes) {
  {
    checkClassInstance(workInProgress, ctor, newProps);
  }

  var instance = workInProgress.stateNode;
  instance.props = newProps;
  instance.state = workInProgress.memoizedState;
  instance.refs = emptyRefsObject;
  initializeUpdateQueue(workInProgress);
  var contextType = ctor.contextType;

  if (typeof contextType === 'object' && contextType !== null) {
    instance.context = readContext(contextType);
  } else {
    var unmaskedContext = getUnmaskedContext(workInProgress, ctor, true);
    instance.context = getMaskedContext(workInProgress, unmaskedContext);
  }

  {
    if (instance.state === newProps) {
      var componentName = getComponentName(ctor) || 'Component';

      if (!didWarnAboutDirectlyAssigningPropsToState.has(componentName)) {
        didWarnAboutDirectlyAssigningPropsToState.add(componentName);

        error('%s: It is not recommended to assign props directly to state ' + "because updates to props won't be reflected in state. " + 'In most cases, it is better to use props directly.', componentName);
      }
    }

    if (workInProgress.mode & StrictMode) {
      ReactStrictModeWarnings.recordLegacyContextWarning(workInProgress, instance);
    }

    {
      ReactStrictModeWarnings.recordUnsafeLifecycleWarnings(workInProgress, instance);
    }
  }

  processUpdateQueue(workInProgress, newProps, instance, renderLanes);
  instance.state = workInProgress.memoizedState;
  var getDerivedStateFromProps = ctor.getDerivedStateFromProps;

  if (typeof getDerivedStateFromProps === 'function') {
    applyDerivedStateFromProps(workInProgress, ctor, getDerivedStateFromProps, newProps);
    instance.state = workInProgress.memoizedState;
  } // In order to support react-lifecycles-compat polyfilled components,
  // Unsafe lifecycles should not be invoked for components using the new APIs.


  if (typeof ctor.getDerivedStateFromProps !== 'function' && typeof instance.getSnapshotBeforeUpdate !== 'function' && (typeof instance.UNSAFE_componentWillMount === 'function' || typeof instance.componentWillMount === 'function')) {
    callComponentWillMount(workInProgress, instance); // If we had additional state updates during this life-cycle, let's
    // process them now.

    processUpdateQueue(workInProgress, newProps, instance, renderLanes);
    instance.state = workInProgress.memoizedState;
  }

  if (typeof instance.componentDidMount === 'function') {
    workInProgress.flags |= Update;
  }
}

function resumeMountClassInstance(workInProgress, ctor, newProps, renderLanes) {
  var instance = workInProgress.stateNode;
  var oldProps = workInProgress.memoizedProps;
  instance.props = oldProps;
  var oldContext = instance.context;
  var contextType = ctor.contextType;
  var nextContext = emptyContextObject;

  if (typeof contextType === 'object' && contextType !== null) {
    nextContext = readContext(contextType);
  } else {
    var nextLegacyUnmaskedContext = getUnmaskedContext(workInProgress, ctor, true);
    nextContext = getMaskedContext(workInProgress, nextLegacyUnmaskedContext);
  }

  var getDerivedStateFromProps = ctor.getDerivedStateFromProps;
  var hasNewLifecycles = typeof getDerivedStateFromProps === 'function' || typeof instance.getSnapshotBeforeUpdate === 'function'; // Note: During these life-cycles, instance.props/instance.state are what
  // ever the previously attempted to render - not the "current". However,
  // during componentDidUpdate we pass the "current" props.
  // In order to support react-lifecycles-compat polyfilled components,
  // Unsafe lifecycles should not be invoked for components using the new APIs.

  if (!hasNewLifecycles && (typeof instance.UNSAFE_componentWillReceiveProps === 'function' || typeof instance.componentWillReceiveProps === 'function')) {
    if (oldProps !== newProps || oldContext !== nextContext) {
      callComponentWillReceiveProps(workInProgress, instance, newProps, nextContext);
    }
  }

  resetHasForceUpdateBeforeProcessing();
  var oldState = workInProgress.memoizedState;
  var newState = instance.state = oldState;
  processUpdateQueue(workInProgress, newProps, instance, renderLanes);
  newState = workInProgress.memoizedState;

  if (oldProps === newProps && oldState === newState && !hasContextChanged() && !checkHasForceUpdateAfterProcessing()) {
    // If an update was already in progress, we should schedule an Update
    // effect even though we're bailing out, so that cWU/cDU are called.
    if (typeof instance.componentDidMount === 'function') {
      workInProgress.flags |= Update;
    }

    return false;
  }

  if (typeof getDerivedStateFromProps === 'function') {
    applyDerivedStateFromProps(workInProgress, ctor, getDerivedStateFromProps, newProps);
    newState = workInProgress.memoizedState;
  }

  var shouldUpdate = checkHasForceUpdateAfterProcessing() || checkShouldComponentUpdate(workInProgress, ctor, oldProps, newProps, oldState, newState, nextContext);

  if (shouldUpdate) {
    // In order to support react-lifecycles-compat polyfilled components,
    // Unsafe lifecycles should not be invoked for components using the new APIs.
    if (!hasNewLifecycles && (typeof instance.UNSAFE_componentWillMount === 'function' || typeof instance.componentWillMount === 'function')) {
      if (typeof instance.componentWillMount === 'function') {
        instance.componentWillMount();
      }

      if (typeof instance.UNSAFE_componentWillMount === 'function') {
        instance.UNSAFE_componentWillMount();
      }
    }

    if (typeof instance.componentDidMount === 'function') {
      workInProgress.flags |= Update;
    }
  } else {
    // If an update was already in progress, we should schedule an Update
    // effect even though we're bailing out, so that cWU/cDU are called.
    if (typeof instance.componentDidMount === 'function') {
      workInProgress.flags |= Update;
    } // If shouldComponentUpdate returned false, we should still update the
    // memoized state to indicate that this work can be reused.


    workInProgress.memoizedProps = newProps;
    workInProgress.memoizedState = newState;
  } // Update the existing instance's state, props, and context pointers even
  // if shouldComponentUpdate returns false.


  instance.props = newProps;
  instance.state = newState;
  instance.context = nextContext;
  return shouldUpdate;
} // Invokes the update life-cycles and returns false if it shouldn't rerender.


function updateClassInstance(current, workInProgress, ctor, newProps, renderLanes) {
  var instance = workInProgress.stateNode;
  cloneUpdateQueue(current, workInProgress);
  var unresolvedOldProps = workInProgress.memoizedProps;
  var oldProps = workInProgress.type === workInProgress.elementType ? unresolvedOldProps : resolveDefaultProps(workInProgress.type, unresolvedOldProps);
  instance.props = oldProps;
  var unresolvedNewProps = workInProgress.pendingProps;
  var oldContext = instance.context;
  var contextType = ctor.contextType;
  var nextContext = emptyContextObject;

  if (typeof contextType === 'object' && contextType !== null) {
    nextContext = readContext(contextType);
  } else {
    var nextUnmaskedContext = getUnmaskedContext(workInProgress, ctor, true);
    nextContext = getMaskedContext(workInProgress, nextUnmaskedContext);
  }

  var getDerivedStateFromProps = ctor.getDerivedStateFromProps;
  var hasNewLifecycles = typeof getDerivedStateFromProps === 'function' || typeof instance.getSnapshotBeforeUpdate === 'function'; // Note: During these life-cycles, instance.props/instance.state are what
  // ever the previously attempted to render - not the "current". However,
  // during componentDidUpdate we pass the "current" props.
  // In order to support react-lifecycles-compat polyfilled components,
  // Unsafe lifecycles should not be invoked for components using the new APIs.

  if (!hasNewLifecycles && (typeof instance.UNSAFE_componentWillReceiveProps === 'function' || typeof instance.componentWillReceiveProps === 'function')) {
    if (unresolvedOldProps !== unresolvedNewProps || oldContext !== nextContext) {
      callComponentWillReceiveProps(workInProgress, instance, newProps, nextContext);
    }
  }

  resetHasForceUpdateBeforeProcessing();
  var oldState = workInProgress.memoizedState;
  var newState = instance.state = oldState;
  processUpdateQueue(workInProgress, newProps, instance, renderLanes);
  newState = workInProgress.memoizedState;

  if (unresolvedOldProps === unresolvedNewProps && oldState === newState && !hasContextChanged() && !checkHasForceUpdateAfterProcessing()) {
    // If an update was already in progress, we should schedule an Update
    // effect even though we're bailing out, so that cWU/cDU are called.
    if (typeof instance.componentDidUpdate === 'function') {
      if (unresolvedOldProps !== current.memoizedProps || oldState !== current.memoizedState) {
        workInProgress.flags |= Update;
      }
    }

    if (typeof instance.getSnapshotBeforeUpdate === 'function') {
      if (unresolvedOldProps !== current.memoizedProps || oldState !== current.memoizedState) {
        workInProgress.flags |= Snapshot;
      }
    }

    return false;
  }

  if (typeof getDerivedStateFromProps === 'function') {
    applyDerivedStateFromProps(workInProgress, ctor, getDerivedStateFromProps, newProps);
    newState = workInProgress.memoizedState;
  }

  var shouldUpdate = checkHasForceUpdateAfterProcessing() || checkShouldComponentUpdate(workInProgress, ctor, oldProps, newProps, oldState, newState, nextContext);

  if (shouldUpdate) {
    // In order to support react-lifecycles-compat polyfilled components,
    // Unsafe lifecycles should not be invoked for components using the new APIs.
    if (!hasNewLifecycles && (typeof instance.UNSAFE_componentWillUpdate === 'function' || typeof instance.componentWillUpdate === 'function')) {
      if (typeof instance.componentWillUpdate === 'function') {
        instance.componentWillUpdate(newProps, newState, nextContext);
      }

      if (typeof instance.UNSAFE_componentWillUpdate === 'function') {
        instance.UNSAFE_componentWillUpdate(newProps, newState, nextContext);
      }
    }

    if (typeof instance.componentDidUpdate === 'function') {
      workInProgress.flags |= Update;
    }

    if (typeof instance.getSnapshotBeforeUpdate === 'function') {
      workInProgress.flags |= Snapshot;
    }
  } else {
    // If an update was already in progress, we should schedule an Update
    // effect even though we're bailing out, so that cWU/cDU are called.
    if (typeof instance.componentDidUpdate === 'function') {
      if (unresolvedOldProps !== current.memoizedProps || oldState !== current.memoizedState) {
        workInProgress.flags |= Update;
      }
    }

    if (typeof instance.getSnapshotBeforeUpdate === 'function') {
      if (unresolvedOldProps !== current.memoizedProps || oldState !== current.memoizedState) {
        workInProgress.flags |= Snapshot;
      }
    } // If shouldComponentUpdate returned false, we should still update the
    // memoized props/state to indicate that this work can be reused.


    workInProgress.memoizedProps = newProps;
    workInProgress.memoizedState = newState;
  } // Update the existing instance's state, props, and context pointers even
  // if shouldComponentUpdate returns false.


  instance.props = newProps;
  instance.state = newState;
  instance.context = nextContext;
  return shouldUpdate;
}

var didWarnAboutMaps;
var didWarnAboutGenerators;
var didWarnAboutStringRefs;
var ownerHasKeyUseWarning;
var ownerHasFunctionTypeWarning;

var warnForMissingKey = function (child, returnFiber) {};

{
  didWarnAboutMaps = false;
  didWarnAboutGenerators = false;
  didWarnAboutStringRefs = {};
  /**
   * Warn if there's no key explicitly set on dynamic arrays of children or
   * object keys are not valid. This allows us to keep track of children between
   * updates.
   */

  ownerHasKeyUseWarning = {};
  ownerHasFunctionTypeWarning = {};

  warnForMissingKey = function (child, returnFiber) {
    if (child === null || typeof child !== 'object') {
      return;
    }

    if (!child._store || child._store.validated || child.key != null) {
      return;
    }

    if (!(typeof child._store === 'object')) {
      {
        throw Error( "React Component in warnForMissingKey should have a _store. This error is likely caused by a bug in React. Please file an issue." );
      }
    }

    child._store.validated = true;
    var componentName = getComponentName(returnFiber.type) || 'Component';

    if (ownerHasKeyUseWarning[componentName]) {
      return;
    }

    ownerHasKeyUseWarning[componentName] = true;

    error('Each child in a list should have a unique ' + '"key" prop. See https://reactjs.org/link/warning-keys for ' + 'more information.');
  };
}

var isArray$1 = Array.isArray;

function coerceRef(returnFiber, current, element) {
  var mixedRef = element.ref;

  if (mixedRef !== null && typeof mixedRef !== 'function' && typeof mixedRef !== 'object') {
    {
      // TODO: Clean this up once we turn on the string ref warning for
      // everyone, because the strict mode case will no longer be relevant
      if ((returnFiber.mode & StrictMode || warnAboutStringRefs) && // We warn in ReactElement.js if owner and self are equal for string refs
      // because these cannot be automatically converted to an arrow function
      // using a codemod. Therefore, we don't have to warn about string refs again.
      !(element._owner && element._self && element._owner.stateNode !== element._self)) {
        var componentName = getComponentName(returnFiber.type) || 'Component';

        if (!didWarnAboutStringRefs[componentName]) {
          {
            error('A string ref, "%s", has been found within a strict mode tree. ' + 'String refs are a source of potential bugs and should be avoided. ' + 'We recommend using useRef() or createRef() instead. ' + 'Learn more about using refs safely here: ' + 'https://reactjs.org/link/strict-mode-string-ref', mixedRef);
          }

          didWarnAboutStringRefs[componentName] = true;
        }
      }
    }

    if (element._owner) {
      var owner = element._owner;
      var inst;

      if (owner) {
        var ownerFiber = owner;

        if (!(ownerFiber.tag === ClassComponent)) {
          {
            throw Error( "Function components cannot have string refs. We recommend using useRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref" );
          }
        }

        inst = ownerFiber.stateNode;
      }

      if (!inst) {
        {
          throw Error( "Missing owner for string ref " + mixedRef + ". This error is likely caused by a bug in React. Please file an issue." );
        }
      }

      var stringRef = '' + mixedRef; // Check if previous string ref matches new string ref

      if (current !== null && current.ref !== null && typeof current.ref === 'function' && current.ref._stringRef === stringRef) {
        return current.ref;
      }

      var ref = function (value) {
        var refs = inst.refs;

        if (refs === emptyRefsObject) {
          // This is a lazy pooled frozen object, so we need to initialize.
          refs = inst.refs = {};
        }

        if (value === null) {
          delete refs[stringRef];
        } else {
          refs[stringRef] = value;
        }
      };

      ref._stringRef = stringRef;
      return ref;
    } else {
      if (!(typeof mixedRef === 'string')) {
        {
          throw Error( "Expected ref to be a function, a string, an object returned by React.createRef(), or null." );
        }
      }

      if (!element._owner) {
        {
          throw Error( "Element ref was specified as a string (" + mixedRef + ") but no owner was set. This could happen for one of the following reasons:\n1. You may be adding a ref to a function component\n2. You may be adding a ref to a component that was not created inside a component's render method\n3. You have multiple copies of React loaded\nSee https://reactjs.org/link/refs-must-have-owner for more information." );
        }
      }
    }
  }

  return mixedRef;
}

function throwOnInvalidObjectType(returnFiber, newChild) {
  if (returnFiber.type !== 'textarea') {
    {
      {
        throw Error( "Objects are not valid as a React child (found: " + (Object.prototype.toString.call(newChild) === '[object Object]' ? 'object with keys {' + Object.keys(newChild).join(', ') + '}' : newChild) + "). If you meant to render a collection of children, use an array instead." );
      }
    }
  }
}

function warnOnFunctionType(returnFiber) {
  {
    var componentName = getComponentName(returnFiber.type) || 'Component';

    if (ownerHasFunctionTypeWarning[componentName]) {
      return;
    }

    ownerHasFunctionTypeWarning[componentName] = true;

    error('Functions are not valid as a React child. This may happen if ' + 'you return a Component instead of <Component /> from render. ' + 'Or maybe you meant to call this function rather than return it.');
  }
} // We avoid inlining this to avoid potential deopts from using try/catch.
// to be able to optimize each path individually by branching early. This needs
// a compiler or we can do it manually. Helpers that don't need this branching
// live outside of this function.


function ChildReconciler(shouldTrackSideEffects) {
  function deleteChild(returnFiber, childToDelete) {
    if (!shouldTrackSideEffects) {
      // Noop.
      return;
    } // Deletions are added in reversed order so we add it to the front.
    // At this point, the return fiber's effect list is empty except for
    // deletions, so we can just append the deletion to the list. The remaining
    // effects aren't added until the complete phase. Once we implement
    // resuming, this may not be true.


    var last = returnFiber.lastEffect;

    if (last !== null) {
      last.nextEffect = childToDelete;
      returnFiber.lastEffect = childToDelete;
    } else {
      returnFiber.firstEffect = returnFiber.lastEffect = childToDelete;
    }

    childToDelete.nextEffect = null;
    childToDelete.flags = Deletion;
  }

  function deleteRemainingChildren(returnFiber, currentFirstChild) {
    if (!shouldTrackSideEffects) {
      // Noop.
      return null;
    } // TODO: For the shouldClone case, this could be micro-optimized a bit by
    // assuming that after the first child we've already added everything.


    var childToDelete = currentFirstChild;

    while (childToDelete !== null) {
      deleteChild(returnFiber, childToDelete);
      childToDelete = childToDelete.sibling;
    }

    return null;
  }

  function mapRemainingChildren(returnFiber, currentFirstChild) {
    // Add the remaining children to a temporary map so that we can find them by
    // keys quickly. Implicit (null) keys get added to this set with their index
    // instead.
    var existingChildren = new Map();
    var existingChild = currentFirstChild;

    while (existingChild !== null) {
      if (existingChild.key !== null) {
        existingChildren.set(existingChild.key, existingChild);
      } else {
        existingChildren.set(existingChild.index, existingChild);
      }

      existingChild = existingChild.sibling;
    }

    return existingChildren;
  }

  function useFiber(fiber, pendingProps) {
    // We currently set sibling to null and index to 0 here because it is easy
    // to forget to do before returning it. E.g. for the single child case.
    var clone = createWorkInProgress(fiber, pendingProps);
    clone.index = 0;
    clone.sibling = null;
    return clone;
  }

  function placeChild(newFiber, lastPlacedIndex, newIndex) {
    newFiber.index = newIndex;

    if (!shouldTrackSideEffects) {
      // Noop.
      return lastPlacedIndex;
    }

    var current = newFiber.alternate;

    if (current !== null) {
      var oldIndex = current.index;

      if (oldIndex < lastPlacedIndex) {
        // This is a move.
        newFiber.flags = Placement;
        return lastPlacedIndex;
      } else {
        // This item can stay in place.
        return oldIndex;
      }
    } else {
      // This is an insertion.
      newFiber.flags = Placement;
      return lastPlacedIndex;
    }
  }

  function placeSingleChild(newFiber) {
    // This is simpler for the single child case. We only need to do a
    // placement for inserting new children.
    if (shouldTrackSideEffects && newFiber.alternate === null) {
      newFiber.flags = Placement;
    }

    return newFiber;
  }

  function updateTextNode(returnFiber, current, textContent, lanes) {
    if (current === null || current.tag !== HostText) {
      // Insert
      var created = createFiberFromText(textContent, returnFiber.mode, lanes);
      created.return = returnFiber;
      return created;
    } else {
      // Update
      var existing = useFiber(current, textContent);
      existing.return = returnFiber;
      return existing;
    }
  }

  function updateElement(returnFiber, current, element, lanes) {
    if (current !== null) {
      if (current.elementType === element.type || ( // Keep this check inline so it only runs on the false path:
       isCompatibleFamilyForHotReloading(current, element) )) {
        // Move based on index
        var existing = useFiber(current, element.props);
        existing.ref = coerceRef(returnFiber, current, element);
        existing.return = returnFiber;

        {
          existing._debugSource = element._source;
          existing._debugOwner = element._owner;
        }

        return existing;
      }
    } // Insert


    var created = createFiberFromElement(element, returnFiber.mode, lanes);
    created.ref = coerceRef(returnFiber, current, element);
    created.return = returnFiber;
    return created;
  }

  function updatePortal(returnFiber, current, portal, lanes) {
    if (current === null || current.tag !== HostPortal || current.stateNode.containerInfo !== portal.containerInfo || current.stateNode.implementation !== portal.implementation) {
      // Insert
      var created = createFiberFromPortal(portal, returnFiber.mode, lanes);
      created.return = returnFiber;
      return created;
    } else {
      // Update
      var existing = useFiber(current, portal.children || []);
      existing.return = returnFiber;
      return existing;
    }
  }

  function updateFragment(returnFiber, current, fragment, lanes, key) {
    if (current === null || current.tag !== Fragment) {
      // Insert
      var created = createFiberFromFragment(fragment, returnFiber.mode, lanes, key);
      created.return = returnFiber;
      return created;
    } else {
      // Update
      var existing = useFiber(current, fragment);
      existing.return = returnFiber;
      return existing;
    }
  }

  function createChild(returnFiber, newChild, lanes) {
    if (typeof newChild === 'string' || typeof newChild === 'number') {
      // Text nodes don't have keys. If the previous node is implicitly keyed
      // we can continue to replace it without aborting even if it is not a text
      // node.
      var created = createFiberFromText('' + newChild, returnFiber.mode, lanes);
      created.return = returnFiber;
      return created;
    }

    if (typeof newChild === 'object' && newChild !== null) {
      switch (newChild.$$typeof) {
        case REACT_ELEMENT_TYPE:
          {
            var _created = createFiberFromElement(newChild, returnFiber.mode, lanes);

            _created.ref = coerceRef(returnFiber, null, newChild);
            _created.return = returnFiber;
            return _created;
          }

        case REACT_PORTAL_TYPE:
          {
            var _created2 = createFiberFromPortal(newChild, returnFiber.mode, lanes);

            _created2.return = returnFiber;
            return _created2;
          }
      }

      if (isArray$1(newChild) || getIteratorFn(newChild)) {
        var _created3 = createFiberFromFragment(newChild, returnFiber.mode, lanes, null);

        _created3.return = returnFiber;
        return _created3;
      }

      throwOnInvalidObjectType(returnFiber, newChild);
    }

    {
      if (typeof newChild === 'function') {
        warnOnFunctionType(returnFiber);
      }
    }

    return null;
  }

  function updateSlot(returnFiber, oldFiber, newChild, lanes) {
    // Update the fiber if the keys match, otherwise return null.
    var key = oldFiber !== null ? oldFiber.key : null;

    if (typeof newChild === 'string' || typeof newChild === 'number') {
      // Text nodes don't have keys. If the previous node is implicitly keyed
      // we can continue to replace it without aborting even if it is not a text
      // node.
      if (key !== null) {
        return null;
      }

      return updateTextNode(returnFiber, oldFiber, '' + newChild, lanes);
    }

    if (typeof newChild === 'object' && newChild !== null) {
      switch (newChild.$$typeof) {
        case REACT_ELEMENT_TYPE:
          {
            if (newChild.key === key) {
              if (newChild.type === REACT_FRAGMENT_TYPE) {
                return updateFragment(returnFiber, oldFiber, newChild.props.children, lanes, key);
              }

              return updateElement(returnFiber, oldFiber, newChild, lanes);
            } else {
              return null;
            }
          }

        case REACT_PORTAL_TYPE:
          {
            if (newChild.key === key) {
              return updatePortal(returnFiber, oldFiber, newChild, lanes);
            } else {
              return null;
            }
          }
      }

      if (isArray$1(newChild) || getIteratorFn(newChild)) {
        if (key !== null) {
          return null;
        }

        return updateFragment(returnFiber, oldFiber, newChild, lanes, null);
      }

      throwOnInvalidObjectType(returnFiber, newChild);
    }

    {
      if (typeof newChild === 'function') {
        warnOnFunctionType(returnFiber);
      }
    }

    return null;
  }

  function updateFromMap(existingChildren, returnFiber, newIdx, newChild, lanes) {
    if (typeof newChild === 'string' || typeof newChild === 'number') {
      // Text nodes don't have keys, so we neither have to check the old nor
      // new node for the key. If both are text nodes, they match.
      var matchedFiber = existingChildren.get(newIdx) || null;
      return updateTextNode(returnFiber, matchedFiber, '' + newChild, lanes);
    }

    if (typeof newChild === 'object' && newChild !== null) {
      switch (newChild.$$typeof) {
        case REACT_ELEMENT_TYPE:
          {
            var _matchedFiber = existingChildren.get(newChild.key === null ? newIdx : newChild.key) || null;

            if (newChild.type === REACT_FRAGMENT_TYPE) {
              return updateFragment(returnFiber, _matchedFiber, newChild.props.children, lanes, newChild.key);
            }

            return updateElement(returnFiber, _matchedFiber, newChild, lanes);
          }

        case REACT_PORTAL_TYPE:
          {
            var _matchedFiber2 = existingChildren.get(newChild.key === null ? newIdx : newChild.key) || null;

            return updatePortal(returnFiber, _matchedFiber2, newChild, lanes);
          }

      }

      if (isArray$1(newChild) || getIteratorFn(newChild)) {
        var _matchedFiber3 = existingChildren.get(newIdx) || null;

        return updateFragment(returnFiber, _matchedFiber3, newChild, lanes, null);
      }

      throwOnInvalidObjectType(returnFiber, newChild);
    }

    {
      if (typeof newChild === 'function') {
        warnOnFunctionType(returnFiber);
      }
    }

    return null;
  }
  /**
   * Warns if there is a duplicate or missing key
   */


  function warnOnInvalidKey(child, knownKeys, returnFiber) {
    {
      if (typeof child !== 'object' || child === null) {
        return knownKeys;
      }

      switch (child.$$typeof) {
        case REACT_ELEMENT_TYPE:
        case REACT_PORTAL_TYPE:
          warnForMissingKey(child, returnFiber);
          var key = child.key;

          if (typeof key !== 'string') {
            break;
          }

          if (knownKeys === null) {
            knownKeys = new Set();
            knownKeys.add(key);
            break;
          }

          if (!knownKeys.has(key)) {
            knownKeys.add(key);
            break;
          }

          error('Encountered two children with the same key, `%s`. ' + 'Keys should be unique so that components maintain their identity ' + 'across updates. Non-unique keys may cause children to be ' + 'duplicated and/or omitted — the behavior is unsupported and ' + 'could change in a future version.', key);

          break;
      }
    }

    return knownKeys;
  }

  function reconcileChildrenArray(returnFiber, currentFirstChild, newChildren, lanes) {
    // This algorithm can't optimize by searching from both ends since we
    // don't have backpointers on fibers. I'm trying to see how far we can get
    // with that model. If it ends up not being worth the tradeoffs, we can
    // add it later.
    // Even with a two ended optimization, we'd want to optimize for the case
    // where there are few changes and brute force the comparison instead of
    // going for the Map. It'd like to explore hitting that path first in
    // forward-only mode and only go for the Map once we notice that we need
    // lots of look ahead. This doesn't handle reversal as well as two ended
    // search but that's unusual. Besides, for the two ended optimization to
    // work on Iterables, we'd need to copy the whole set.
    // In this first iteration, we'll just live with hitting the bad case
    // (adding everything to a Map) in for every insert/move.
    // If you change this code, also update reconcileChildrenIterator() which
    // uses the same algorithm.
    {
      // First, validate keys.
      var knownKeys = null;

      for (var i = 0; i < newChildren.length; i++) {
        var child = newChildren[i];
        knownKeys = warnOnInvalidKey(child, knownKeys, returnFiber);
      }
    }

    var resultingFirstChild = null;
    var previousNewFiber = null;
    var oldFiber = currentFirstChild;
    var lastPlacedIndex = 0;
    var newIdx = 0;
    var nextOldFiber = null;

    for (; oldFiber !== null && newIdx < newChildren.length; newIdx++) {
      if (oldFiber.index > newIdx) {
        nextOldFiber = oldFiber;
        oldFiber = null;
      } else {
        nextOldFiber = oldFiber.sibling;
      }

      var newFiber = updateSlot(returnFiber, oldFiber, newChildren[newIdx], lanes);

      if (newFiber === null) {
        // TODO: This breaks on empty slots like null children. That's
        // unfortunate because it triggers the slow path all the time. We need
        // a better way to communicate whether this was a miss or null,
        // boolean, undefined, etc.
        if (oldFiber === null) {
          oldFiber = nextOldFiber;
        }

        break;
      }

      if (shouldTrackSideEffects) {
        if (oldFiber && newFiber.alternate === null) {
          // We matched the slot, but we didn't reuse the existing fiber, so we
          // need to delete the existing child.
          deleteChild(returnFiber, oldFiber);
        }
      }

      lastPlacedIndex = placeChild(newFiber, lastPlacedIndex, newIdx);

      if (previousNewFiber === null) {
        // TODO: Move out of the loop. This only happens for the first run.
        resultingFirstChild = newFiber;
      } else {
        // TODO: Defer siblings if we're not at the right index for this slot.
        // I.e. if we had null values before, then we want to defer this
        // for each null value. However, we also don't want to call updateSlot
        // with the previous one.
        previousNewFiber.sibling = newFiber;
      }

      previousNewFiber = newFiber;
      oldFiber = nextOldFiber;
    }

    if (newIdx === newChildren.length) {
      // We've reached the end of the new children. We can delete the rest.
      deleteRemainingChildren(returnFiber, oldFiber);
      return resultingFirstChild;
    }

    if (oldFiber === null) {
      // If we don't have any more existing children we can choose a fast path
      // since the rest will all be insertions.
      for (; newIdx < newChildren.length; newIdx++) {
        var _newFiber = createChild(returnFiber, newChildren[newIdx], lanes);

        if (_newFiber === null) {
          continue;
        }

        lastPlacedIndex = placeChild(_newFiber, lastPlacedIndex, newIdx);

        if (previousNewFiber === null) {
          // TODO: Move out of the loop. This only happens for the first run.
          resultingFirstChild = _newFiber;
        } else {
          previousNewFiber.sibling = _newFiber;
        }

        previousNewFiber = _newFiber;
      }

      return resultingFirstChild;
    } // Add all children to a key map for quick lookups.


    var existingChildren = mapRemainingChildren(returnFiber, oldFiber); // Keep scanning and use the map to restore deleted items as moves.

    for (; newIdx < newChildren.length; newIdx++) {
      var _newFiber2 = updateFromMap(existingChildren, returnFiber, newIdx, newChildren[newIdx], lanes);

      if (_newFiber2 !== null) {
        if (shouldTrackSideEffects) {
          if (_newFiber2.alternate !== null) {
            // The new fiber is a work in progress, but if there exists a
            // current, that means that we reused the fiber. We need to delete
            // it from the child list so that we don't add it to the deletion
            // list.
            existingChildren.delete(_newFiber2.key === null ? newIdx : _newFiber2.key);
          }
        }

        lastPlacedIndex = placeChild(_newFiber2, lastPlacedIndex, newIdx);

        if (previousNewFiber === null) {
          resultingFirstChild = _newFiber2;
        } else {
          previousNewFiber.sibling = _newFiber2;
        }

        previousNewFiber = _newFiber2;
      }
    }

    if (shouldTrackSideEffects) {
      // Any existing children that weren't consumed above were deleted. We need
      // to add them to the deletion list.
      existingChildren.forEach(function (child) {
        return deleteChild(returnFiber, child);
      });
    }

    return resultingFirstChild;
  }

  function reconcileChildrenIterator(returnFiber, currentFirstChild, newChildrenIterable, lanes) {
    // This is the same implementation as reconcileChildrenArray(),
    // but using the iterator instead.
    var iteratorFn = getIteratorFn(newChildrenIterable);

    if (!(typeof iteratorFn === 'function')) {
      {
        throw Error( "An object is not an iterable. This error is likely caused by a bug in React. Please file an issue." );
      }
    }

    {
      // We don't support rendering Generators because it's a mutation.
      // See https://github.com/facebook/react/issues/12995
      if (typeof Symbol === 'function' && // $FlowFixMe Flow doesn't know about toStringTag
      newChildrenIterable[Symbol.toStringTag] === 'Generator') {
        if (!didWarnAboutGenerators) {
          error('Using Generators as children is unsupported and will likely yield ' + 'unexpected results because enumerating a generator mutates it. ' + 'You may convert it to an array with `Array.from()` or the ' + '`[...spread]` operator before rendering. Keep in mind ' + 'you might need to polyfill these features for older browsers.');
        }

        didWarnAboutGenerators = true;
      } // Warn about using Maps as children


      if (newChildrenIterable.entries === iteratorFn) {
        if (!didWarnAboutMaps) {
          error('Using Maps as children is not supported. ' + 'Use an array of keyed ReactElements instead.');
        }

        didWarnAboutMaps = true;
      } // First, validate keys.
      // We'll get a different iterator later for the main pass.


      var _newChildren = iteratorFn.call(newChildrenIterable);

      if (_newChildren) {
        var knownKeys = null;

        var _step = _newChildren.next();

        for (; !_step.done; _step = _newChildren.next()) {
          var child = _step.value;
          knownKeys = warnOnInvalidKey(child, knownKeys, returnFiber);
        }
      }
    }

    var newChildren = iteratorFn.call(newChildrenIterable);

    if (!(newChildren != null)) {
      {
        throw Error( "An iterable object provided no iterator." );
      }
    }

    var resultingFirstChild = null;
    var previousNewFiber = null;
    var oldFiber = currentFirstChild;
    var lastPlacedIndex = 0;
    var newIdx = 0;
    var nextOldFiber = null;
    var step = newChildren.next();

    for (; oldFiber !== null && !step.done; newIdx++, step = newChildren.next()) {
      if (oldFiber.index > newIdx) {
        nextOldFiber = oldFiber;
        oldFiber = null;
      } else {
        nextOldFiber = oldFiber.sibling;
      }

      var newFiber = updateSlot(returnFiber, oldFiber, step.value, lanes);

      if (newFiber === null) {
        // TODO: This breaks on empty slots like null children. That's
        // unfortunate because it triggers the slow path all the time. We need
        // a better way to communicate whether this was a miss or null,
        // boolean, undefined, etc.
        if (oldFiber === null) {
          oldFiber = nextOldFiber;
        }

        break;
      }

      if (shouldTrackSideEffects) {
        if (oldFiber && newFiber.alternate === null) {
          // We matched the slot, but we didn't reuse the existing fiber, so we
          // need to delete the existing child.
          deleteChild(returnFiber, oldFiber);
        }
      }

      lastPlacedIndex = placeChild(newFiber, lastPlacedIndex, newIdx);

      if (previousNewFiber === null) {
        // TODO: Move out of the loop. This only happens for the first run.
        resultingFirstChild = newFiber;
      } else {
        // TODO: Defer siblings if we're not at the right index for this slot.
        // I.e. if we had null values before, then we want to defer this
        // for each null value. However, we also don't want to call updateSlot
        // with the previous one.
        previousNewFiber.sibling = newFiber;
      }

      previousNewFiber = newFiber;
      oldFiber = nextOldFiber;
    }

    if (step.done) {
      // We've reached the end of the new children. We can delete the rest.
      deleteRemainingChildren(returnFiber, oldFiber);
      return resultingFirstChild;
    }

    if (oldFiber === null) {
      // If we don't have any more existing children we can choose a fast path
      // since the rest will all be insertions.
      for (; !step.done; newIdx++, step = newChildren.next()) {
        var _newFiber3 = createChild(returnFiber, step.value, lanes);

        if (_newFiber3 === null) {
          continue;
        }

        lastPlacedIndex = placeChild(_newFiber3, lastPlacedIndex, newIdx);

        if (previousNewFiber === null) {
          // TODO: Move out of the loop. This only happens for the first run.
          resultingFirstChild = _newFiber3;
        } else {
          previousNewFiber.sibling = _newFiber3;
        }

        previousNewFiber = _newFiber3;
      }

      return resultingFirstChild;
    } // Add all children to a key map for quick lookups.


    var existingChildren = mapRemainingChildren(returnFiber, oldFiber); // Keep scanning and use the map to restore deleted items as moves.

    for (; !step.done; newIdx++, step = newChildren.next()) {
      var _newFiber4 = updateFromMap(existingChildren, returnFiber, newIdx, step.value, lanes);

      if (_newFiber4 !== null) {
        if (shouldTrackSideEffects) {
          if (_newFiber4.alternate !== null) {
            // The new fiber is a work in progress, but if there exists a
            // current, that means that we reused the fiber. We need to delete
            // it from the child list so that we don't add it to the deletion
            // list.
            existingChildren.delete(_newFiber4.key === null ? newIdx : _newFiber4.key);
          }
        }

        lastPlacedIndex = placeChild(_newFiber4, lastPlacedIndex, newIdx);

        if (previousNewFiber === null) {
          resultingFirstChild = _newFiber4;
        } else {
          previousNewFiber.sibling = _newFiber4;
        }

        previousNewFiber = _newFiber4;
      }
    }

    if (shouldTrackSideEffects) {
      // Any existing children that weren't consumed above were deleted. We need
      // to add them to the deletion list.
      existingChildren.forEach(function (child) {
        return deleteChild(returnFiber, child);
      });
    }

    return resultingFirstChild;
  }

  function reconcileSingleTextNode(returnFiber, currentFirstChild, textContent, lanes) {
    // There's no need to check for keys on text nodes since we don't have a
    // way to define them.
    if (currentFirstChild !== null && currentFirstChild.tag === HostText) {
      // We already have an existing node so let's just update it and delete
      // the rest.
      deleteRemainingChildren(returnFiber, currentFirstChild.sibling);
      var existing = useFiber(currentFirstChild, textContent);
      existing.return = returnFiber;
      return existing;
    } // The existing first child is not a text node so we need to create one
    // and delete the existing ones.


    deleteRemainingChildren(returnFiber, currentFirstChild);
    var created = createFiberFromText(textContent, returnFiber.mode, lanes);
    created.return = returnFiber;
    return created;
  }

  function reconcileSingleElement(returnFiber, currentFirstChild, element, lanes) {
    var key = element.key;
    var child = currentFirstChild;

    while (child !== null) {
      // TODO: If key === null and child.key === null, then this only applies to
      // the first item in the list.
      if (child.key === key) {
        switch (child.tag) {
          case Fragment:
            {
              if (element.type === REACT_FRAGMENT_TYPE) {
                deleteRemainingChildren(returnFiber, child.sibling);
                var existing = useFiber(child, element.props.children);
                existing.return = returnFiber;

                {
                  existing._debugSource = element._source;
                  existing._debugOwner = element._owner;
                }

                return existing;
              }

              break;
            }

          case Block:

          // We intentionally fallthrough here if enableBlocksAPI is not on.
          // eslint-disable-next-lined no-fallthrough

          default:
            {
              if (child.elementType === element.type || ( // Keep this check inline so it only runs on the false path:
               isCompatibleFamilyForHotReloading(child, element) )) {
                deleteRemainingChildren(returnFiber, child.sibling);

                var _existing3 = useFiber(child, element.props);

                _existing3.ref = coerceRef(returnFiber, child, element);
                _existing3.return = returnFiber;

                {
                  _existing3._debugSource = element._source;
                  _existing3._debugOwner = element._owner;
                }

                return _existing3;
              }

              break;
            }
        } // Didn't match.


        deleteRemainingChildren(returnFiber, child);
        break;
      } else {
        deleteChild(returnFiber, child);
      }

      child = child.sibling;
    }

    if (element.type === REACT_FRAGMENT_TYPE) {
      var created = createFiberFromFragment(element.props.children, returnFiber.mode, lanes, element.key);
      created.return = returnFiber;
      return created;
    } else {
      var _created4 = createFiberFromElement(element, returnFiber.mode, lanes);

      _created4.ref = coerceRef(returnFiber, currentFirstChild, element);
      _created4.return = returnFiber;
      return _created4;
    }
  }

  function reconcileSinglePortal(returnFiber, currentFirstChild, portal, lanes) {
    var key = portal.key;
    var child = currentFirstChild;

    while (child !== null) {
      // TODO: If key === null and child.key === null, then this only applies to
      // the first item in the list.
      if (child.key === key) {
        if (child.tag === HostPortal && child.stateNode.containerInfo === portal.containerInfo && child.stateNode.implementation === portal.implementation) {
          deleteRemainingChildren(returnFiber, child.sibling);
          var existing = useFiber(child, portal.children || []);
          existing.return = returnFiber;
          return existing;
        } else {
          deleteRemainingChildren(returnFiber, child);
          break;
        }
      } else {
        deleteChild(returnFiber, child);
      }

      child = child.sibling;
    }

    var created = createFiberFromPortal(portal, returnFiber.mode, lanes);
    created.return = returnFiber;
    return created;
  } // This API will tag the children with the side-effect of the reconciliation
  // itself. They will be added to the side-effect list as we pass through the
  // children and the parent.


  function reconcileChildFibers(returnFiber, currentFirstChild, newChild, lanes) {
    // This function is not recursive.
    // If the top level item is an array, we treat it as a set of children,
    // not as a fragment. Nested arrays on the other hand will be treated as
    // fragment nodes. Recursion happens at the normal flow.
    // Handle top level unkeyed fragments as if they were arrays.
    // This leads to an ambiguity between <>{[...]}</> and <>...</>.
    // We treat the ambiguous cases above the same.
    var isUnkeyedTopLevelFragment = typeof newChild === 'object' && newChild !== null && newChild.type === REACT_FRAGMENT_TYPE && newChild.key === null;

    if (isUnkeyedTopLevelFragment) {
      newChild = newChild.props.children;
    } // Handle object types


    var isObject = typeof newChild === 'object' && newChild !== null;

    if (isObject) {
      switch (newChild.$$typeof) {
        case REACT_ELEMENT_TYPE:
          return placeSingleChild(reconcileSingleElement(returnFiber, currentFirstChild, newChild, lanes));

        case REACT_PORTAL_TYPE:
          return placeSingleChild(reconcileSinglePortal(returnFiber, currentFirstChild, newChild, lanes));

      }
    }

    if (typeof newChild === 'string' || typeof newChild === 'number') {
      return placeSingleChild(reconcileSingleTextNode(returnFiber, currentFirstChild, '' + newChild, lanes));
    }

    if (isArray$1(newChild)) {
      return reconcileChildrenArray(returnFiber, currentFirstChild, newChild, lanes);
    }

    if (getIteratorFn(newChild)) {
      return reconcileChildrenIterator(returnFiber, currentFirstChild, newChild, lanes);
    }

    if (isObject) {
      throwOnInvalidObjectType(returnFiber, newChild);
    }

    {
      if (typeof newChild === 'function') {
        warnOnFunctionType(returnFiber);
      }
    }

    if (typeof newChild === 'undefined' && !isUnkeyedTopLevelFragment) {
      // If the new child is undefined, and the return fiber is a composite
      // component, throw an error. If Fiber return types are disabled,
      // we already threw above.
      switch (returnFiber.tag) {
        case ClassComponent:
          {
            {
              var instance = returnFiber.stateNode;

              if (instance.render._isMockFunction) {
                // We allow auto-mocks to proceed as if they're returning null.
                break;
              }
            }
          }
        // Intentionally fall through to the next case, which handles both
        // functions and classes
        // eslint-disable-next-lined no-fallthrough

        case Block:
        case FunctionComponent:
        case ForwardRef:
        case SimpleMemoComponent:
          {
            {
              {
                throw Error( (getComponentName(returnFiber.type) || 'Component') + "(...): Nothing was returned from render. This usually means a return statement is missing. Or, to render nothing, return null." );
              }
            }
          }
      }
    } // Remaining cases are all treated as empty.


    return deleteRemainingChildren(returnFiber, currentFirstChild);
  }

  return reconcileChildFibers;
}

var reconcileChildFibers = ChildReconciler(true);
var mountChildFibers = ChildReconciler(false);
function cloneChildFibers(current, workInProgress) {
  if (!(current === null || workInProgress.child === current.child)) {
    {
      throw Error( "Resuming work not yet implemented." );
    }
  }

  if (workInProgress.child === null) {
    return;
  }

  var currentChild = workInProgress.child;
  var newChild = createWorkInProgress(currentChild, currentChild.pendingProps);
  workInProgress.child = newChild;
  newChild.return = workInProgress;

  while (currentChild.sibling !== null) {
    currentChild = currentChild.sibling;
    newChild = newChild.sibling = createWorkInProgress(currentChild, currentChild.pendingProps);
    newChild.return = workInProgress;
  }

  newChild.sibling = null;
} // Reset a workInProgress child set to prepare it for a second pass.

function resetChildFibers(workInProgress, lanes) {
  var child = workInProgress.child;

  while (child !== null) {
    resetWorkInProgress(child, lanes);
    child = child.sibling;
  }
}

var NO_CONTEXT = {};
var contextStackCursor$1 = createCursor(NO_CONTEXT);
var contextFiberStackCursor = createCursor(NO_CONTEXT);
var rootInstanceStackCursor = createCursor(NO_CONTEXT);

function requiredContext(c) {
  if (!(c !== NO_CONTEXT)) {
    {
      throw Error( "Expected host context to exist. This error is likely caused by a bug in React. Please file an issue." );
    }
  }

  return c;
}

function getRootHostContainer() {
  var rootInstance = requiredContext(rootInstanceStackCursor.current);
  return rootInstance;
}

function pushHostContainer(fiber, nextRootInstance) {
  // Push current root instance onto the stack;
  // This allows us to reset root when portals are popped.
  push(rootInstanceStackCursor, nextRootInstance, fiber); // Track the context and the Fiber that provided it.
  // This enables us to pop only Fibers that provide unique contexts.

  push(contextFiberStackCursor, fiber, fiber); // Finally, we need to push the host context to the stack.
  // However, we can't just call getRootHostContext() and push it because
  // we'd have a different number of entries on the stack depending on
  // whether getRootHostContext() throws somewhere in renderer code or not.
  // So we push an empty value first. This lets us safely unwind on errors.

  push(contextStackCursor$1, NO_CONTEXT, fiber);
  var nextRootContext = getRootHostContext(nextRootInstance); // Now that we know this function doesn't throw, replace it.

  pop(contextStackCursor$1, fiber);
  push(contextStackCursor$1, nextRootContext, fiber);
}

function popHostContainer(fiber) {
  pop(contextStackCursor$1, fiber);
  pop(contextFiberStackCursor, fiber);
  pop(rootInstanceStackCursor, fiber);
}

function getHostContext() {
  var context = requiredContext(contextStackCursor$1.current);
  return context;
}

function pushHostContext(fiber) {
  var rootInstance = requiredContext(rootInstanceStackCursor.current);
  var context = requiredContext(contextStackCursor$1.current);
  var nextContext = getChildHostContext(context, fiber.type); // Don't push this Fiber's context unless it's unique.

  if (context === nextContext) {
    return;
  } // Track the context and the Fiber that provided it.
  // This enables us to pop only Fibers that provide unique contexts.


  push(contextFiberStackCursor, fiber, fiber);
  push(contextStackCursor$1, nextContext, fiber);
}

function popHostContext(fiber) {
  // Do not pop unless this Fiber provided the current context.
  // pushHostContext() only pushes Fibers that provide unique contexts.
  if (contextFiberStackCursor.current !== fiber) {
    return;
  }

  pop(contextStackCursor$1, fiber);
  pop(contextFiberStackCursor, fiber);
}

var DefaultSuspenseContext = 0; // The Suspense Context is split into two parts. The lower bits is
// inherited deeply down the subtree. The upper bits only affect
// this immediate suspense boundary and gets reset each new
// boundary or suspense list.

var SubtreeSuspenseContextMask = 1; // Subtree Flags:
// InvisibleParentSuspenseContext indicates that one of our parent Suspense
// boundaries is not currently showing visible main content.
// Either because it is already showing a fallback or is not mounted at all.
// We can use this to determine if it is desirable to trigger a fallback at
// the parent. If not, then we might need to trigger undesirable boundaries
// and/or suspend the commit to avoid hiding the parent content.

var InvisibleParentSuspenseContext = 1; // Shallow Flags:
// ForceSuspenseFallback can be used by SuspenseList to force newly added
// items into their fallback state during one of the render passes.

var ForceSuspenseFallback = 2;
var suspenseStackCursor = createCursor(DefaultSuspenseContext);
function hasSuspenseContext(parentContext, flag) {
  return (parentContext & flag) !== 0;
}
function setDefaultShallowSuspenseContext(parentContext) {
  return parentContext & SubtreeSuspenseContextMask;
}
function setShallowSuspenseContext(parentContext, shallowContext) {
  return parentContext & SubtreeSuspenseContextMask | shallowContext;
}
function addSubtreeSuspenseContext(parentContext, subtreeContext) {
  return parentContext | subtreeContext;
}
function pushSuspenseContext(fiber, newContext) {
  push(suspenseStackCursor, newContext, fiber);
}
function popSuspenseContext(fiber) {
  pop(suspenseStackCursor, fiber);
}

function shouldCaptureSuspense(workInProgress, hasInvisibleParent) {
  // If it was the primary children that just suspended, capture and render the
  // fallback. Otherwise, don't capture and bubble to the next boundary.
  var nextState = workInProgress.memoizedState;

  if (nextState !== null) {
    if (nextState.dehydrated !== null) {
      // A dehydrated boundary always captures.
      return true;
    }

    return false;
  }

  var props = workInProgress.memoizedProps; // In order to capture, the Suspense component must have a fallback prop.

  if (props.fallback === undefined) {
    return false;
  } // Regular boundaries always capture.


  if (props.unstable_avoidThisFallback !== true) {
    return true;
  } // If it's a boundary we should avoid, then we prefer to bubble up to the
  // parent boundary if it is currently invisible.


  if (hasInvisibleParent) {
    return false;
  } // If the parent is not able to handle it, we must handle it.


  return true;
}
function findFirstSuspended(row) {
  var node = row;

  while (node !== null) {
    if (node.tag === SuspenseComponent) {
      var state = node.memoizedState;

      if (state !== null) {
        var dehydrated = state.dehydrated;

        if (dehydrated === null || isSuspenseInstancePending(dehydrated) || isSuspenseInstanceFallback(dehydrated)) {
          return node;
        }
      }
    } else if (node.tag === SuspenseListComponent && // revealOrder undefined can't be trusted because it don't
    // keep track of whether it suspended or not.
    node.memoizedProps.revealOrder !== undefined) {
      var didSuspend = (node.flags & DidCapture) !== NoFlags;

      if (didSuspend) {
        return node;
      }
    } else if (node.child !== null) {
      node.child.return = node;
      node = node.child;
      continue;
    }

    if (node === row) {
      return null;
    }

    while (node.sibling === null) {
      if (node.return === null || node.return === row) {
        return null;
      }

      node = node.return;
    }

    node.sibling.return = node.return;
    node = node.sibling;
  }

  return null;
}

var NoFlags$1 =
/*  */
0; // Represents whether effect should fire.

var HasEffect =
/* */
1; // Represents the phase in which the effect (not the clean-up) fires.

var Layout =
/*    */
2;
var Passive$1 =
/*   */
4;

// This may have been an insertion or a hydration.

var hydrationParentFiber = null;
var nextHydratableInstance = null;
var isHydrating = false;

function enterHydrationState(fiber) {

  var parentInstance = fiber.stateNode.containerInfo;
  nextHydratableInstance = getFirstHydratableChild(parentInstance);
  hydrationParentFiber = fiber;
  isHydrating = true;
  return true;
}

function deleteHydratableInstance(returnFiber, instance) {
  {
    switch (returnFiber.tag) {
      case HostRoot:
        didNotHydrateContainerInstance(returnFiber.stateNode.containerInfo, instance);
        break;

      case HostComponent:
        didNotHydrateInstance(returnFiber.type, returnFiber.memoizedProps, returnFiber.stateNode, instance);
        break;
    }
  }

  var childToDelete = createFiberFromHostInstanceForDeletion();
  childToDelete.stateNode = instance;
  childToDelete.return = returnFiber;
  childToDelete.flags = Deletion; // This might seem like it belongs on progressedFirstDeletion. However,
  // these children are not part of the reconciliation list of children.
  // Even if we abort and rereconcile the children, that will try to hydrate
  // again and the nodes are still in the host tree so these will be
  // recreated.

  if (returnFiber.lastEffect !== null) {
    returnFiber.lastEffect.nextEffect = childToDelete;
    returnFiber.lastEffect = childToDelete;
  } else {
    returnFiber.firstEffect = returnFiber.lastEffect = childToDelete;
  }
}

function insertNonHydratedInstance(returnFiber, fiber) {
  fiber.flags = fiber.flags & ~Hydrating | Placement;

  {
    switch (returnFiber.tag) {
      case HostRoot:
        {
          var parentContainer = returnFiber.stateNode.containerInfo;

          switch (fiber.tag) {
            case HostComponent:
              var type = fiber.type;
              var props = fiber.pendingProps;
              didNotFindHydratableContainerInstance(parentContainer, type);
              break;

            case HostText:
              var text = fiber.pendingProps;
              didNotFindHydratableContainerTextInstance(parentContainer, text);
              break;
          }

          break;
        }

      case HostComponent:
        {
          var parentType = returnFiber.type;
          var parentProps = returnFiber.memoizedProps;
          var parentInstance = returnFiber.stateNode;

          switch (fiber.tag) {
            case HostComponent:
              var _type = fiber.type;
              var _props = fiber.pendingProps;
              didNotFindHydratableInstance(parentType, parentProps, parentInstance, _type);
              break;

            case HostText:
              var _text = fiber.pendingProps;
              didNotFindHydratableTextInstance(parentType, parentProps, parentInstance, _text);
              break;

            case SuspenseComponent:
              didNotFindHydratableSuspenseInstance(parentType, parentProps);
              break;
          }

          break;
        }

      default:
        return;
    }
  }
}

function tryHydrate(fiber, nextInstance) {
  switch (fiber.tag) {
    case HostComponent:
      {
        var type = fiber.type;
        var props = fiber.pendingProps;
        var instance = canHydrateInstance(nextInstance, type);

        if (instance !== null) {
          fiber.stateNode = instance;
          return true;
        }

        return false;
      }

    case HostText:
      {
        var text = fiber.pendingProps;
        var textInstance = canHydrateTextInstance(nextInstance, text);

        if (textInstance !== null) {
          fiber.stateNode = textInstance;
          return true;
        }

        return false;
      }

    case SuspenseComponent:
      {

        return false;
      }

    default:
      return false;
  }
}

function tryToClaimNextHydratableInstance(fiber) {
  if (!isHydrating) {
    return;
  }

  var nextInstance = nextHydratableInstance;

  if (!nextInstance) {
    // Nothing to hydrate. Make it an insertion.
    insertNonHydratedInstance(hydrationParentFiber, fiber);
    isHydrating = false;
    hydrationParentFiber = fiber;
    return;
  }

  var firstAttemptedInstance = nextInstance;

  if (!tryHydrate(fiber, nextInstance)) {
    // If we can't hydrate this instance let's try the next one.
    // We use this as a heuristic. It's based on intuition and not data so it
    // might be flawed or unnecessary.
    nextInstance = getNextHydratableSibling(firstAttemptedInstance);

    if (!nextInstance || !tryHydrate(fiber, nextInstance)) {
      // Nothing to hydrate. Make it an insertion.
      insertNonHydratedInstance(hydrationParentFiber, fiber);
      isHydrating = false;
      hydrationParentFiber = fiber;
      return;
    } // We matched the next one, we'll now assume that the first one was
    // superfluous and we'll delete it. Since we can't eagerly delete it
    // we'll have to schedule a deletion. To do that, this node needs a dummy
    // fiber associated with it.


    deleteHydratableInstance(hydrationParentFiber, firstAttemptedInstance);
  }

  hydrationParentFiber = fiber;
  nextHydratableInstance = getFirstHydratableChild(nextInstance);
}

function prepareToHydrateHostInstance(fiber, rootContainerInstance, hostContext) {

  var instance = fiber.stateNode;
  var updatePayload = hydrateInstance(instance, fiber.type, fiber.memoizedProps, rootContainerInstance, hostContext, fiber); // TODO: Type this specific to this type of component.

  fiber.updateQueue = updatePayload; // If the update payload indicates that there is a change or if there
  // is a new ref we mark this as an update.

  if (updatePayload !== null) {
    return true;
  }

  return false;
}

function prepareToHydrateHostTextInstance(fiber) {

  var textInstance = fiber.stateNode;
  var textContent = fiber.memoizedProps;
  var shouldUpdate = hydrateTextInstance(textInstance, textContent, fiber);

  {
    if (shouldUpdate) {
      // We assume that prepareToHydrateHostTextInstance is called in a context where the
      // hydration parent is the parent host component of this host text.
      var returnFiber = hydrationParentFiber;

      if (returnFiber !== null) {
        switch (returnFiber.tag) {
          case HostRoot:
            {
              var parentContainer = returnFiber.stateNode.containerInfo;
              didNotMatchHydratedContainerTextInstance(parentContainer, textInstance, textContent);
              break;
            }

          case HostComponent:
            {
              var parentType = returnFiber.type;
              var parentProps = returnFiber.memoizedProps;
              var parentInstance = returnFiber.stateNode;
              didNotMatchHydratedTextInstance(parentType, parentProps, parentInstance, textInstance, textContent);
              break;
            }
        }
      }
    }
  }

  return shouldUpdate;
}

function skipPastDehydratedSuspenseInstance(fiber) {

  var suspenseState = fiber.memoizedState;
  var suspenseInstance = suspenseState !== null ? suspenseState.dehydrated : null;

  if (!suspenseInstance) {
    {
      throw Error( "Expected to have a hydrated suspense instance. This error is likely caused by a bug in React. Please file an issue." );
    }
  }

  return getNextHydratableInstanceAfterSuspenseInstance(suspenseInstance);
}

function popToNextHostParent(fiber) {
  var parent = fiber.return;

  while (parent !== null && parent.tag !== HostComponent && parent.tag !== HostRoot && parent.tag !== SuspenseComponent) {
    parent = parent.return;
  }

  hydrationParentFiber = parent;
}

function popHydrationState(fiber) {

  if (fiber !== hydrationParentFiber) {
    // We're deeper than the current hydration context, inside an inserted
    // tree.
    return false;
  }

  if (!isHydrating) {
    // If we're not currently hydrating but we're in a hydration context, then
    // we were an insertion and now need to pop up reenter hydration of our
    // siblings.
    popToNextHostParent(fiber);
    isHydrating = true;
    return false;
  }

  var type = fiber.type; // If we have any remaining hydratable nodes, we need to delete them now.
  // We only do this deeper than head and body since they tend to have random
  // other nodes in them. We also ignore components with pure text content in
  // side of them.
  // TODO: Better heuristic.

  if (fiber.tag !== HostComponent || type !== 'head' && type !== 'body' && !shouldSetTextContent(type, fiber.memoizedProps)) {
    var nextInstance = nextHydratableInstance;

    while (nextInstance) {
      deleteHydratableInstance(fiber, nextInstance);
      nextInstance = getNextHydratableSibling(nextInstance);
    }
  }

  popToNextHostParent(fiber);

  if (fiber.tag === SuspenseComponent) {
    nextHydratableInstance = skipPastDehydratedSuspenseInstance(fiber);
  } else {
    nextHydratableInstance = hydrationParentFiber ? getNextHydratableSibling(fiber.stateNode) : null;
  }

  return true;
}

function resetHydrationState() {

  hydrationParentFiber = null;
  nextHydratableInstance = null;
  isHydrating = false;
}

function getIsHydrating() {
  return isHydrating;
}

// and should be reset before starting a new render.
// This tracks which mutable sources need to be reset after a render.

var workInProgressSources = [];
var rendererSigil$1;

{
  // Used to detect multiple renderers using the same mutable source.
  rendererSigil$1 = {};
}

function markSourceAsDirty(mutableSource) {
  workInProgressSources.push(mutableSource);
}
function resetWorkInProgressVersions() {
  for (var i = 0; i < workInProgressSources.length; i++) {
    var mutableSource = workInProgressSources[i];

    {
      mutableSource._workInProgressVersionPrimary = null;
    }
  }

  workInProgressSources.length = 0;
}
function getWorkInProgressVersion(mutableSource) {
  {
    return mutableSource._workInProgressVersionPrimary;
  }
}
function setWorkInProgressVersion(mutableSource, version) {
  {
    mutableSource._workInProgressVersionPrimary = version;
  }

  workInProgressSources.push(mutableSource);
}
function warnAboutMultipleRenderersDEV(mutableSource) {
  {
    {
      if (mutableSource._currentPrimaryRenderer == null) {
        mutableSource._currentPrimaryRenderer = rendererSigil$1;
      } else if (mutableSource._currentPrimaryRenderer !== rendererSigil$1) {
        error('Detected multiple renderers concurrently rendering the ' + 'same mutable source. This is currently unsupported.');
      }
    }
  }
} // Eager reads the version of a mutable source and stores it on the root.

var ReactCurrentDispatcher$1 = ReactSharedInternals.ReactCurrentDispatcher,
    ReactCurrentBatchConfig$1 = ReactSharedInternals.ReactCurrentBatchConfig;
var didWarnAboutMismatchedHooksForComponent;
var didWarnAboutUseOpaqueIdentifier;

{
  didWarnAboutUseOpaqueIdentifier = {};
  didWarnAboutMismatchedHooksForComponent = new Set();
}

// These are set right before calling the component.
var renderLanes = NoLanes; // The work-in-progress fiber. I've named it differently to distinguish it from
// the work-in-progress hook.

var currentlyRenderingFiber$1 = null; // Hooks are stored as a linked list on the fiber's memoizedState field. The
// current hook list is the list that belongs to the current fiber. The
// work-in-progress hook list is a new list that will be added to the
// work-in-progress fiber.

var currentHook = null;
var workInProgressHook = null; // Whether an update was scheduled at any point during the render phase. This
// does not get reset if we do another render pass; only when we're completely
// finished evaluating this component. This is an optimization so we know
// whether we need to clear render phase updates after a throw.

var didScheduleRenderPhaseUpdate = false; // Where an update was scheduled only during the current render pass. This
// gets reset after each attempt.
// TODO: Maybe there's some way to consolidate this with
// `didScheduleRenderPhaseUpdate`. Or with `numberOfReRenders`.

var didScheduleRenderPhaseUpdateDuringThisPass = false;
var RE_RENDER_LIMIT = 25; // In DEV, this is the name of the currently executing primitive hook

var currentHookNameInDev = null; // In DEV, this list ensures that hooks are called in the same order between renders.
// The list stores the order of hooks used during the initial render (mount).
// Subsequent renders (updates) reference this list.

var hookTypesDev = null;
var hookTypesUpdateIndexDev = -1; // In DEV, this tracks whether currently rendering component needs to ignore
// the dependencies for Hooks that need them (e.g. useEffect or useMemo).
// When true, such Hooks will always be "remounted". Only used during hot reload.

var ignorePreviousDependencies = false;

function mountHookTypesDev() {
  {
    var hookName = currentHookNameInDev;

    if (hookTypesDev === null) {
      hookTypesDev = [hookName];
    } else {
      hookTypesDev.push(hookName);
    }
  }
}

function updateHookTypesDev() {
  {
    var hookName = currentHookNameInDev;

    if (hookTypesDev !== null) {
      hookTypesUpdateIndexDev++;

      if (hookTypesDev[hookTypesUpdateIndexDev] !== hookName) {
        warnOnHookMismatchInDev(hookName);
      }
    }
  }
}

function checkDepsAreArrayDev(deps) {
  {
    if (deps !== undefined && deps !== null && !Array.isArray(deps)) {
      // Verify deps, but only on mount to avoid extra checks.
      // It's unlikely their type would change as usually you define them inline.
      error('%s received a final argument that is not an array (instead, received `%s`). When ' + 'specified, the final argument must be an array.', currentHookNameInDev, typeof deps);
    }
  }
}

function warnOnHookMismatchInDev(currentHookName) {
  {
    var componentName = getComponentName(currentlyRenderingFiber$1.type);

    if (!didWarnAboutMismatchedHooksForComponent.has(componentName)) {
      didWarnAboutMismatchedHooksForComponent.add(componentName);

      if (hookTypesDev !== null) {
        var table = '';
        var secondColumnStart = 30;

        for (var i = 0; i <= hookTypesUpdateIndexDev; i++) {
          var oldHookName = hookTypesDev[i];
          var newHookName = i === hookTypesUpdateIndexDev ? currentHookName : oldHookName;
          var row = i + 1 + ". " + oldHookName; // Extra space so second column lines up
          // lol @ IE not supporting String#repeat

          while (row.length < secondColumnStart) {
            row += ' ';
          }

          row += newHookName + '\n';
          table += row;
        }

        error('React has detected a change in the order of Hooks called by %s. ' + 'This will lead to bugs and errors if not fixed. ' + 'For more information, read the Rules of Hooks: https://reactjs.org/link/rules-of-hooks\n\n' + '   Previous render            Next render\n' + '   ------------------------------------------------------\n' + '%s' + '   ^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^\n', componentName, table);
      }
    }
  }
}

function throwInvalidHookError() {
  {
    {
      throw Error( "Invalid hook call. Hooks can only be called inside of the body of a function component. This could happen for one of the following reasons:\n1. You might have mismatching versions of React and the renderer (such as React DOM)\n2. You might be breaking the Rules of Hooks\n3. You might have more than one copy of React in the same app\nSee https://reactjs.org/link/invalid-hook-call for tips about how to debug and fix this problem." );
    }
  }
}

function areHookInputsEqual(nextDeps, prevDeps) {
  {
    if (ignorePreviousDependencies) {
      // Only true when this component is being hot reloaded.
      return false;
    }
  }

  if (prevDeps === null) {
    {
      error('%s received a final argument during this render, but not during ' + 'the previous render. Even though the final argument is optional, ' + 'its type cannot change between renders.', currentHookNameInDev);
    }

    return false;
  }

  {
    // Don't bother comparing lengths in prod because these arrays should be
    // passed inline.
    if (nextDeps.length !== prevDeps.length) {
      error('The final argument passed to %s changed size between renders. The ' + 'order and size of this array must remain constant.\n\n' + 'Previous: %s\n' + 'Incoming: %s', currentHookNameInDev, "[" + prevDeps.join(', ') + "]", "[" + nextDeps.join(', ') + "]");
    }
  }

  for (var i = 0; i < prevDeps.length && i < nextDeps.length; i++) {
    if (objectIs(nextDeps[i], prevDeps[i])) {
      continue;
    }

    return false;
  }

  return true;
}

function renderWithHooks(current, workInProgress, Component, props, secondArg, nextRenderLanes) {
  renderLanes = nextRenderLanes;
  currentlyRenderingFiber$1 = workInProgress;

  {
    hookTypesDev = current !== null ? current._debugHookTypes : null;
    hookTypesUpdateIndexDev = -1; // Used for hot reloading:

    ignorePreviousDependencies = current !== null && current.type !== workInProgress.type;
  }

  workInProgress.memoizedState = null;
  workInProgress.updateQueue = null;
  workInProgress.lanes = NoLanes; // The following should have already been reset
  // currentHook = null;
  // workInProgressHook = null;
  // didScheduleRenderPhaseUpdate = false;
  // TODO Warn if no hooks are used at all during mount, then some are used during update.
  // Currently we will identify the update render as a mount because memoizedState === null.
  // This is tricky because it's valid for certain types of components (e.g. React.lazy)
  // Using memoizedState to differentiate between mount/update only works if at least one stateful hook is used.
  // Non-stateful hooks (e.g. context) don't get added to memoizedState,
  // so memoizedState would be null during updates and mounts.

  {
    if (current !== null && current.memoizedState !== null) {
      ReactCurrentDispatcher$1.current = HooksDispatcherOnUpdateInDEV;
    } else if (hookTypesDev !== null) {
      // This dispatcher handles an edge case where a component is updating,
      // but no stateful hooks have been used.
      // We want to match the production code behavior (which will use HooksDispatcherOnMount),
      // but with the extra DEV validation to ensure hooks ordering hasn't changed.
      // This dispatcher does that.
      ReactCurrentDispatcher$1.current = HooksDispatcherOnMountWithHookTypesInDEV;
    } else {
      ReactCurrentDispatcher$1.current = HooksDispatcherOnMountInDEV;
    }
  }

  var children = Component(props, secondArg); // Check if there was a render phase update

  if (didScheduleRenderPhaseUpdateDuringThisPass) {
    // Keep rendering in a loop for as long as render phase updates continue to
    // be scheduled. Use a counter to prevent infinite loops.
    var numberOfReRenders = 0;

    do {
      didScheduleRenderPhaseUpdateDuringThisPass = false;

      if (!(numberOfReRenders < RE_RENDER_LIMIT)) {
        {
          throw Error( "Too many re-renders. React limits the number of renders to prevent an infinite loop." );
        }
      }

      numberOfReRenders += 1;

      {
        // Even when hot reloading, allow dependencies to stabilize
        // after first render to prevent infinite render phase updates.
        ignorePreviousDependencies = false;
      } // Start over from the beginning of the list


      currentHook = null;
      workInProgressHook = null;
      workInProgress.updateQueue = null;

      {
        // Also validate hook order for cascading updates.
        hookTypesUpdateIndexDev = -1;
      }

      ReactCurrentDispatcher$1.current =  HooksDispatcherOnRerenderInDEV ;
      children = Component(props, secondArg);
    } while (didScheduleRenderPhaseUpdateDuringThisPass);
  } // We can assume the previous dispatcher is always this one, since we set it
  // at the beginning of the render phase and there's no re-entrancy.


  ReactCurrentDispatcher$1.current = ContextOnlyDispatcher;

  {
    workInProgress._debugHookTypes = hookTypesDev;
  } // This check uses currentHook so that it works the same in DEV and prod bundles.
  // hookTypesDev could catch more cases (e.g. context) but only in DEV bundles.


  var didRenderTooFewHooks = currentHook !== null && currentHook.next !== null;
  renderLanes = NoLanes;
  currentlyRenderingFiber$1 = null;
  currentHook = null;
  workInProgressHook = null;

  {
    currentHookNameInDev = null;
    hookTypesDev = null;
    hookTypesUpdateIndexDev = -1;
  }

  didScheduleRenderPhaseUpdate = false;

  if (!!didRenderTooFewHooks) {
    {
      throw Error( "Rendered fewer hooks than expected. This may be caused by an accidental early return statement." );
    }
  }

  return children;
}
function bailoutHooks(current, workInProgress, lanes) {
  workInProgress.updateQueue = current.updateQueue;
  workInProgress.flags &= ~(Passive | Update);
  current.lanes = removeLanes(current.lanes, lanes);
}
function resetHooksAfterThrow() {
  // We can assume the previous dispatcher is always this one, since we set it
  // at the beginning of the render phase and there's no re-entrancy.
  ReactCurrentDispatcher$1.current = ContextOnlyDispatcher;

  if (didScheduleRenderPhaseUpdate) {
    // There were render phase updates. These are only valid for this render
    // phase, which we are now aborting. Remove the updates from the queues so
    // they do not persist to the next render. Do not remove updates from hooks
    // that weren't processed.
    //
    // Only reset the updates from the queue if it has a clone. If it does
    // not have a clone, that means it wasn't processed, and the updates were
    // scheduled before we entered the render phase.
    var hook = currentlyRenderingFiber$1.memoizedState;

    while (hook !== null) {
      var queue = hook.queue;

      if (queue !== null) {
        queue.pending = null;
      }

      hook = hook.next;
    }

    didScheduleRenderPhaseUpdate = false;
  }

  renderLanes = NoLanes;
  currentlyRenderingFiber$1 = null;
  currentHook = null;
  workInProgressHook = null;

  {
    hookTypesDev = null;
    hookTypesUpdateIndexDev = -1;
    currentHookNameInDev = null;
    isUpdatingOpaqueValueInRenderPhase = false;
  }

  didScheduleRenderPhaseUpdateDuringThisPass = false;
}

function mountWorkInProgressHook() {
  var hook = {
    memoizedState: null,
    baseState: null,
    baseQueue: null,
    queue: null,
    next: null
  };

  if (workInProgressHook === null) {
    // This is the first hook in the list
    currentlyRenderingFiber$1.memoizedState = workInProgressHook = hook;
  } else {
    // Append to the end of the list
    workInProgressHook = workInProgressHook.next = hook;
  }

  return workInProgressHook;
}

function updateWorkInProgressHook() {
  // This function is used both for updates and for re-renders triggered by a
  // render phase update. It assumes there is either a current hook we can
  // clone, or a work-in-progress hook from a previous render pass that we can
  // use as a base. When we reach the end of the base list, we must switch to
  // the dispatcher used for mounts.
  var nextCurrentHook;

  if (currentHook === null) {
    var current = currentlyRenderingFiber$1.alternate;

    if (current !== null) {
      nextCurrentHook = current.memoizedState;
    } else {
      nextCurrentHook = null;
    }
  } else {
    nextCurrentHook = currentHook.next;
  }

  var nextWorkInProgressHook;

  if (workInProgressHook === null) {
    nextWorkInProgressHook = currentlyRenderingFiber$1.memoizedState;
  } else {
    nextWorkInProgressHook = workInProgressHook.next;
  }

  if (nextWorkInProgressHook !== null) {
    // There's already a work-in-progress. Reuse it.
    workInProgressHook = nextWorkInProgressHook;
    nextWorkInProgressHook = workInProgressHook.next;
    currentHook = nextCurrentHook;
  } else {
    // Clone from the current hook.
    if (!(nextCurrentHook !== null)) {
      {
        throw Error( "Rendered more hooks than during the previous render." );
      }
    }

    currentHook = nextCurrentHook;
    var newHook = {
      memoizedState: currentHook.memoizedState,
      baseState: currentHook.baseState,
      baseQueue: currentHook.baseQueue,
      queue: currentHook.queue,
      next: null
    };

    if (workInProgressHook === null) {
      // This is the first hook in the list.
      currentlyRenderingFiber$1.memoizedState = workInProgressHook = newHook;
    } else {
      // Append to the end of the list.
      workInProgressHook = workInProgressHook.next = newHook;
    }
  }

  return workInProgressHook;
}

function createFunctionComponentUpdateQueue() {
  return {
    lastEffect: null
  };
}

function basicStateReducer(state, action) {
  // $FlowFixMe: Flow doesn't like mixed types
  return typeof action === 'function' ? action(state) : action;
}

function mountReducer(reducer, initialArg, init) {
  var hook = mountWorkInProgressHook();
  var initialState;

  if (init !== undefined) {
    initialState = init(initialArg);
  } else {
    initialState = initialArg;
  }

  hook.memoizedState = hook.baseState = initialState;
  var queue = hook.queue = {
    pending: null,
    dispatch: null,
    lastRenderedReducer: reducer,
    lastRenderedState: initialState
  };
  var dispatch = queue.dispatch = dispatchAction.bind(null, currentlyRenderingFiber$1, queue);
  return [hook.memoizedState, dispatch];
}

function updateReducer(reducer, initialArg, init) {
  var hook = updateWorkInProgressHook();
  var queue = hook.queue;

  if (!(queue !== null)) {
    {
      throw Error( "Should have a queue. This is likely a bug in React. Please file an issue." );
    }
  }

  queue.lastRenderedReducer = reducer;
  var current = currentHook; // The last rebase update that is NOT part of the base state.

  var baseQueue = current.baseQueue; // The last pending update that hasn't been processed yet.

  var pendingQueue = queue.pending;

  if (pendingQueue !== null) {
    // We have new updates that haven't been processed yet.
    // We'll add them to the base queue.
    if (baseQueue !== null) {
      // Merge the pending queue and the base queue.
      var baseFirst = baseQueue.next;
      var pendingFirst = pendingQueue.next;
      baseQueue.next = pendingFirst;
      pendingQueue.next = baseFirst;
    }

    {
      if (current.baseQueue !== baseQueue) {
        // Internal invariant that should never happen, but feasibly could in
        // the future if we implement resuming, or some form of that.
        error('Internal error: Expected work-in-progress queue to be a clone. ' + 'This is a bug in React.');
      }
    }

    current.baseQueue = baseQueue = pendingQueue;
    queue.pending = null;
  }

  if (baseQueue !== null) {
    // We have a queue to process.
    var first = baseQueue.next;
    var newState = current.baseState;
    var newBaseState = null;
    var newBaseQueueFirst = null;
    var newBaseQueueLast = null;
    var update = first;

    do {
      var updateLane = update.lane;

      if (!isSubsetOfLanes(renderLanes, updateLane)) {
        // Priority is insufficient. Skip this update. If this is the first
        // skipped update, the previous update/state is the new base
        // update/state.
        var clone = {
          lane: updateLane,
          action: update.action,
          eagerReducer: update.eagerReducer,
          eagerState: update.eagerState,
          next: null
        };

        if (newBaseQueueLast === null) {
          newBaseQueueFirst = newBaseQueueLast = clone;
          newBaseState = newState;
        } else {
          newBaseQueueLast = newBaseQueueLast.next = clone;
        } // Update the remaining priority in the queue.
        // TODO: Don't need to accumulate this. Instead, we can remove
        // renderLanes from the original lanes.


        currentlyRenderingFiber$1.lanes = mergeLanes(currentlyRenderingFiber$1.lanes, updateLane);
        markSkippedUpdateLanes(updateLane);
      } else {
        // This update does have sufficient priority.
        if (newBaseQueueLast !== null) {
          var _clone = {
            // This update is going to be committed so we never want uncommit
            // it. Using NoLane works because 0 is a subset of all bitmasks, so
            // this will never be skipped by the check above.
            lane: NoLane,
            action: update.action,
            eagerReducer: update.eagerReducer,
            eagerState: update.eagerState,
            next: null
          };
          newBaseQueueLast = newBaseQueueLast.next = _clone;
        } // Process this update.


        if (update.eagerReducer === reducer) {
          // If this update was processed eagerly, and its reducer matches the
          // current reducer, we can use the eagerly computed state.
          newState = update.eagerState;
        } else {
          var action = update.action;
          newState = reducer(newState, action);
        }
      }

      update = update.next;
    } while (update !== null && update !== first);

    if (newBaseQueueLast === null) {
      newBaseState = newState;
    } else {
      newBaseQueueLast.next = newBaseQueueFirst;
    } // Mark that the fiber performed work, but only if the new state is
    // different from the current state.


    if (!objectIs(newState, hook.memoizedState)) {
      markWorkInProgressReceivedUpdate();
    }

    hook.memoizedState = newState;
    hook.baseState = newBaseState;
    hook.baseQueue = newBaseQueueLast;
    queue.lastRenderedState = newState;
  }

  var dispatch = queue.dispatch;
  return [hook.memoizedState, dispatch];
}

function rerenderReducer(reducer, initialArg, init) {
  var hook = updateWorkInProgressHook();
  var queue = hook.queue;

  if (!(queue !== null)) {
    {
      throw Error( "Should have a queue. This is likely a bug in React. Please file an issue." );
    }
  }

  queue.lastRenderedReducer = reducer; // This is a re-render. Apply the new render phase updates to the previous
  // work-in-progress hook.

  var dispatch = queue.dispatch;
  var lastRenderPhaseUpdate = queue.pending;
  var newState = hook.memoizedState;

  if (lastRenderPhaseUpdate !== null) {
    // The queue doesn't persist past this render pass.
    queue.pending = null;
    var firstRenderPhaseUpdate = lastRenderPhaseUpdate.next;
    var update = firstRenderPhaseUpdate;

    do {
      // Process this render phase update. We don't have to check the
      // priority because it will always be the same as the current
      // render's.
      var action = update.action;
      newState = reducer(newState, action);
      update = update.next;
    } while (update !== firstRenderPhaseUpdate); // Mark that the fiber performed work, but only if the new state is
    // different from the current state.


    if (!objectIs(newState, hook.memoizedState)) {
      markWorkInProgressReceivedUpdate();
    }

    hook.memoizedState = newState; // Don't persist the state accumulated from the render phase updates to
    // the base state unless the queue is empty.
    // TODO: Not sure if this is the desired semantics, but it's what we
    // do for gDSFP. I can't remember why.

    if (hook.baseQueue === null) {
      hook.baseState = newState;
    }

    queue.lastRenderedState = newState;
  }

  return [newState, dispatch];
}

function readFromUnsubcribedMutableSource(root, source, getSnapshot) {
  {
    warnAboutMultipleRenderersDEV(source);
  }

  var getVersion = source._getVersion;
  var version = getVersion(source._source); // Is it safe for this component to read from this source during the current render?

  var isSafeToReadFromSource = false; // Check the version first.
  // If this render has already been started with a specific version,
  // we can use it alone to determine if we can safely read from the source.

  var currentRenderVersion = getWorkInProgressVersion(source);

  if (currentRenderVersion !== null) {
    // It's safe to read if the store hasn't been mutated since the last time
    // we read something.
    isSafeToReadFromSource = currentRenderVersion === version;
  } else {
    // If there's no version, then this is the first time we've read from the
    // source during the current render pass, so we need to do a bit more work.
    // What we need to determine is if there are any hooks that already
    // subscribed to the source, and if so, whether there are any pending
    // mutations that haven't been synchronized yet.
    //
    // If there are no pending mutations, then `root.mutableReadLanes` will be
    // empty, and we know we can safely read.
    //
    // If there *are* pending mutations, we may still be able to safely read
    // if the currently rendering lanes are inclusive of the pending mutation
    // lanes, since that guarantees that the value we're about to read from
    // the source is consistent with the values that we read during the most
    // recent mutation.
    isSafeToReadFromSource = isSubsetOfLanes(renderLanes, root.mutableReadLanes);

    if (isSafeToReadFromSource) {
      // If it's safe to read from this source during the current render,
      // store the version in case other components read from it.
      // A changed version number will let those components know to throw and restart the render.
      setWorkInProgressVersion(source, version);
    }
  }

  if (isSafeToReadFromSource) {
    var snapshot = getSnapshot(source._source);

    {
      if (typeof snapshot === 'function') {
        error('Mutable source should not return a function as the snapshot value. ' + 'Functions may close over mutable values and cause tearing.');
      }
    }

    return snapshot;
  } else {
    // This handles the special case of a mutable source being shared between renderers.
    // In that case, if the source is mutated between the first and second renderer,
    // The second renderer don't know that it needs to reset the WIP version during unwind,
    // (because the hook only marks sources as dirty if it's written to their WIP version).
    // That would cause this tear check to throw again and eventually be visible to the user.
    // We can avoid this infinite loop by explicitly marking the source as dirty.
    //
    // This can lead to tearing in the first renderer when it resumes,
    // but there's nothing we can do about that (short of throwing here and refusing to continue the render).
    markSourceAsDirty(source);

    {
      {
        throw Error( "Cannot read from mutable source during the current render without tearing. This is a bug in React. Please file an issue." );
      }
    }
  }
}

function useMutableSource(hook, source, getSnapshot, subscribe) {
  var root = getWorkInProgressRoot();

  if (!(root !== null)) {
    {
      throw Error( "Expected a work-in-progress root. This is a bug in React. Please file an issue." );
    }
  }

  var getVersion = source._getVersion;
  var version = getVersion(source._source);
  var dispatcher = ReactCurrentDispatcher$1.current; // eslint-disable-next-line prefer-const

  var _dispatcher$useState = dispatcher.useState(function () {
    return readFromUnsubcribedMutableSource(root, source, getSnapshot);
  }),
      currentSnapshot = _dispatcher$useState[0],
      setSnapshot = _dispatcher$useState[1];

  var snapshot = currentSnapshot; // Grab a handle to the state hook as well.
  // We use it to clear the pending update queue if we have a new source.

  var stateHook = workInProgressHook;
  var memoizedState = hook.memoizedState;
  var refs = memoizedState.refs;
  var prevGetSnapshot = refs.getSnapshot;
  var prevSource = memoizedState.source;
  var prevSubscribe = memoizedState.subscribe;
  var fiber = currentlyRenderingFiber$1;
  hook.memoizedState = {
    refs: refs,
    source: source,
    subscribe: subscribe
  }; // Sync the values needed by our subscription handler after each commit.

  dispatcher.useEffect(function () {
    refs.getSnapshot = getSnapshot; // Normally the dispatch function for a state hook never changes,
    // but this hook recreates the queue in certain cases  to avoid updates from stale sources.
    // handleChange() below needs to reference the dispatch function without re-subscribing,
    // so we use a ref to ensure that it always has the latest version.

    refs.setSnapshot = setSnapshot; // Check for a possible change between when we last rendered now.

    var maybeNewVersion = getVersion(source._source);

    if (!objectIs(version, maybeNewVersion)) {
      var maybeNewSnapshot = getSnapshot(source._source);

      {
        if (typeof maybeNewSnapshot === 'function') {
          error('Mutable source should not return a function as the snapshot value. ' + 'Functions may close over mutable values and cause tearing.');
        }
      }

      if (!objectIs(snapshot, maybeNewSnapshot)) {
        setSnapshot(maybeNewSnapshot);
        var lane = requestUpdateLane(fiber);
        markRootMutableRead(root, lane);
      } // If the source mutated between render and now,
      // there may be state updates already scheduled from the old source.
      // Entangle the updates so that they render in the same batch.


      markRootEntangled(root, root.mutableReadLanes);
    }
  }, [getSnapshot, source, subscribe]); // If we got a new source or subscribe function, re-subscribe in a passive effect.

  dispatcher.useEffect(function () {
    var handleChange = function () {
      var latestGetSnapshot = refs.getSnapshot;
      var latestSetSnapshot = refs.setSnapshot;

      try {
        latestSetSnapshot(latestGetSnapshot(source._source)); // Record a pending mutable source update with the same expiration time.

        var lane = requestUpdateLane(fiber);
        markRootMutableRead(root, lane);
      } catch (error) {
        // A selector might throw after a source mutation.
        // e.g. it might try to read from a part of the store that no longer exists.
        // In this case we should still schedule an update with React.
        // Worst case the selector will throw again and then an error boundary will handle it.
        latestSetSnapshot(function () {
          throw error;
        });
      }
    };

    var unsubscribe = subscribe(source._source, handleChange);

    {
      if (typeof unsubscribe !== 'function') {
        error('Mutable source subscribe function must return an unsubscribe function.');
      }
    }

    return unsubscribe;
  }, [source, subscribe]); // If any of the inputs to useMutableSource change, reading is potentially unsafe.
  //
  // If either the source or the subscription have changed we can't can't trust the update queue.
  // Maybe the source changed in a way that the old subscription ignored but the new one depends on.
  //
  // If the getSnapshot function changed, we also shouldn't rely on the update queue.
  // It's possible that the underlying source was mutated between the when the last "change" event fired,
  // and when the current render (with the new getSnapshot function) is processed.
  //
  // In both cases, we need to throw away pending updates (since they are no longer relevant)
  // and treat reading from the source as we do in the mount case.

  if (!objectIs(prevGetSnapshot, getSnapshot) || !objectIs(prevSource, source) || !objectIs(prevSubscribe, subscribe)) {
    // Create a new queue and setState method,
    // So if there are interleaved updates, they get pushed to the older queue.
    // When this becomes current, the previous queue and dispatch method will be discarded,
    // including any interleaving updates that occur.
    var newQueue = {
      pending: null,
      dispatch: null,
      lastRenderedReducer: basicStateReducer,
      lastRenderedState: snapshot
    };
    newQueue.dispatch = setSnapshot = dispatchAction.bind(null, currentlyRenderingFiber$1, newQueue);
    stateHook.queue = newQueue;
    stateHook.baseQueue = null;
    snapshot = readFromUnsubcribedMutableSource(root, source, getSnapshot);
    stateHook.memoizedState = stateHook.baseState = snapshot;
  }

  return snapshot;
}

function mountMutableSource(source, getSnapshot, subscribe) {
  var hook = mountWorkInProgressHook();
  hook.memoizedState = {
    refs: {
      getSnapshot: getSnapshot,
      setSnapshot: null
    },
    source: source,
    subscribe: subscribe
  };
  return useMutableSource(hook, source, getSnapshot, subscribe);
}

function updateMutableSource(source, getSnapshot, subscribe) {
  var hook = updateWorkInProgressHook();
  return useMutableSource(hook, source, getSnapshot, subscribe);
}

function mountState(initialState) {
  var hook = mountWorkInProgressHook();

  if (typeof initialState === 'function') {
    // $FlowFixMe: Flow doesn't like mixed types
    initialState = initialState();
  }

  hook.memoizedState = hook.baseState = initialState;
  var queue = hook.queue = {
    pending: null,
    dispatch: null,
    lastRenderedReducer: basicStateReducer,
    lastRenderedState: initialState
  };
  var dispatch = queue.dispatch = dispatchAction.bind(null, currentlyRenderingFiber$1, queue);
  return [hook.memoizedState, dispatch];
}

function updateState(initialState) {
  return updateReducer(basicStateReducer);
}

function rerenderState(initialState) {
  return rerenderReducer(basicStateReducer);
}

function pushEffect(tag, create, destroy, deps) {
  var effect = {
    tag: tag,
    create: create,
    destroy: destroy,
    deps: deps,
    // Circular
    next: null
  };
  var componentUpdateQueue = currentlyRenderingFiber$1.updateQueue;

  if (componentUpdateQueue === null) {
    componentUpdateQueue = createFunctionComponentUpdateQueue();
    currentlyRenderingFiber$1.updateQueue = componentUpdateQueue;
    componentUpdateQueue.lastEffect = effect.next = effect;
  } else {
    var lastEffect = componentUpdateQueue.lastEffect;

    if (lastEffect === null) {
      componentUpdateQueue.lastEffect = effect.next = effect;
    } else {
      var firstEffect = lastEffect.next;
      lastEffect.next = effect;
      effect.next = firstEffect;
      componentUpdateQueue.lastEffect = effect;
    }
  }

  return effect;
}

function mountRef(initialValue) {
  var hook = mountWorkInProgressHook();
  var ref = {
    current: initialValue
  };

  {
    Object.seal(ref);
  }

  hook.memoizedState = ref;
  return ref;
}

function updateRef(initialValue) {
  var hook = updateWorkInProgressHook();
  return hook.memoizedState;
}

function mountEffectImpl(fiberFlags, hookFlags, create, deps) {
  var hook = mountWorkInProgressHook();
  var nextDeps = deps === undefined ? null : deps;
  currentlyRenderingFiber$1.flags |= fiberFlags;
  hook.memoizedState = pushEffect(HasEffect | hookFlags, create, undefined, nextDeps);
}

function updateEffectImpl(fiberFlags, hookFlags, create, deps) {
  var hook = updateWorkInProgressHook();
  var nextDeps = deps === undefined ? null : deps;
  var destroy = undefined;

  if (currentHook !== null) {
    var prevEffect = currentHook.memoizedState;
    destroy = prevEffect.destroy;

    if (nextDeps !== null) {
      var prevDeps = prevEffect.deps;

      if (areHookInputsEqual(nextDeps, prevDeps)) {
        pushEffect(hookFlags, create, destroy, nextDeps);
        return;
      }
    }
  }

  currentlyRenderingFiber$1.flags |= fiberFlags;
  hook.memoizedState = pushEffect(HasEffect | hookFlags, create, destroy, nextDeps);
}

function mountEffect(create, deps) {
  {
    // $FlowExpectedError - jest isn't a global, and isn't recognized outside of tests
    if ('undefined' !== typeof jest) {
      warnIfNotCurrentlyActingEffectsInDEV(currentlyRenderingFiber$1);
    }
  }

  return mountEffectImpl(Update | Passive, Passive$1, create, deps);
}

function updateEffect(create, deps) {
  {
    // $FlowExpectedError - jest isn't a global, and isn't recognized outside of tests
    if ('undefined' !== typeof jest) {
      warnIfNotCurrentlyActingEffectsInDEV(currentlyRenderingFiber$1);
    }
  }

  return updateEffectImpl(Update | Passive, Passive$1, create, deps);
}

function mountLayoutEffect(create, deps) {
  return mountEffectImpl(Update, Layout, create, deps);
}

function updateLayoutEffect(create, deps) {
  return updateEffectImpl(Update, Layout, create, deps);
}

function imperativeHandleEffect(create, ref) {
  if (typeof ref === 'function') {
    var refCallback = ref;

    var _inst = create();

    refCallback(_inst);
    return function () {
      refCallback(null);
    };
  } else if (ref !== null && ref !== undefined) {
    var refObject = ref;

    {
      if (!refObject.hasOwnProperty('current')) {
        error('Expected useImperativeHandle() first argument to either be a ' + 'ref callback or React.createRef() object. Instead received: %s.', 'an object with keys {' + Object.keys(refObject).join(', ') + '}');
      }
    }

    var _inst2 = create();

    refObject.current = _inst2;
    return function () {
      refObject.current = null;
    };
  }
}

function mountImperativeHandle(ref, create, deps) {
  {
    if (typeof create !== 'function') {
      error('Expected useImperativeHandle() second argument to be a function ' + 'that creates a handle. Instead received: %s.', create !== null ? typeof create : 'null');
    }
  } // TODO: If deps are provided, should we skip comparing the ref itself?


  var effectDeps = deps !== null && deps !== undefined ? deps.concat([ref]) : null;
  return mountEffectImpl(Update, Layout, imperativeHandleEffect.bind(null, create, ref), effectDeps);
}

function updateImperativeHandle(ref, create, deps) {
  {
    if (typeof create !== 'function') {
      error('Expected useImperativeHandle() second argument to be a function ' + 'that creates a handle. Instead received: %s.', create !== null ? typeof create : 'null');
    }
  } // TODO: If deps are provided, should we skip comparing the ref itself?


  var effectDeps = deps !== null && deps !== undefined ? deps.concat([ref]) : null;
  return updateEffectImpl(Update, Layout, imperativeHandleEffect.bind(null, create, ref), effectDeps);
}

function mountDebugValue(value, formatterFn) {// This hook is normally a no-op.
  // The react-debug-hooks package injects its own implementation
  // so that e.g. DevTools can display custom hook values.
}

var updateDebugValue = mountDebugValue;

function mountCallback(callback, deps) {
  var hook = mountWorkInProgressHook();
  var nextDeps = deps === undefined ? null : deps;
  hook.memoizedState = [callback, nextDeps];
  return callback;
}

function updateCallback(callback, deps) {
  var hook = updateWorkInProgressHook();
  var nextDeps = deps === undefined ? null : deps;
  var prevState = hook.memoizedState;

  if (prevState !== null) {
    if (nextDeps !== null) {
      var prevDeps = prevState[1];

      if (areHookInputsEqual(nextDeps, prevDeps)) {
        return prevState[0];
      }
    }
  }

  hook.memoizedState = [callback, nextDeps];
  return callback;
}

function mountMemo(nextCreate, deps) {
  var hook = mountWorkInProgressHook();
  var nextDeps = deps === undefined ? null : deps;
  var nextValue = nextCreate();
  hook.memoizedState = [nextValue, nextDeps];
  return nextValue;
}

function updateMemo(nextCreate, deps) {
  var hook = updateWorkInProgressHook();
  var nextDeps = deps === undefined ? null : deps;
  var prevState = hook.memoizedState;

  if (prevState !== null) {
    // Assume these are defined. If they're not, areHookInputsEqual will warn.
    if (nextDeps !== null) {
      var prevDeps = prevState[1];

      if (areHookInputsEqual(nextDeps, prevDeps)) {
        return prevState[0];
      }
    }
  }

  var nextValue = nextCreate();
  hook.memoizedState = [nextValue, nextDeps];
  return nextValue;
}

function mountDeferredValue(value) {
  var _mountState = mountState(value),
      prevValue = _mountState[0],
      setValue = _mountState[1];

  mountEffect(function () {
    var prevTransition = ReactCurrentBatchConfig$1.transition;
    ReactCurrentBatchConfig$1.transition = 1;

    try {
      setValue(value);
    } finally {
      ReactCurrentBatchConfig$1.transition = prevTransition;
    }
  }, [value]);
  return prevValue;
}

function updateDeferredValue(value) {
  var _updateState = updateState(),
      prevValue = _updateState[0],
      setValue = _updateState[1];

  updateEffect(function () {
    var prevTransition = ReactCurrentBatchConfig$1.transition;
    ReactCurrentBatchConfig$1.transition = 1;

    try {
      setValue(value);
    } finally {
      ReactCurrentBatchConfig$1.transition = prevTransition;
    }
  }, [value]);
  return prevValue;
}

function rerenderDeferredValue(value) {
  var _rerenderState = rerenderState(),
      prevValue = _rerenderState[0],
      setValue = _rerenderState[1];

  updateEffect(function () {
    var prevTransition = ReactCurrentBatchConfig$1.transition;
    ReactCurrentBatchConfig$1.transition = 1;

    try {
      setValue(value);
    } finally {
      ReactCurrentBatchConfig$1.transition = prevTransition;
    }
  }, [value]);
  return prevValue;
}

function startTransition(setPending, callback) {
  var priorityLevel = getCurrentPriorityLevel();

  {
    runWithPriority$1(priorityLevel < UserBlockingPriority$2 ? UserBlockingPriority$2 : priorityLevel, function () {
      setPending(true);
    });
    runWithPriority$1(priorityLevel > NormalPriority$1 ? NormalPriority$1 : priorityLevel, function () {
      var prevTransition = ReactCurrentBatchConfig$1.transition;
      ReactCurrentBatchConfig$1.transition = 1;

      try {
        setPending(false);
        callback();
      } finally {
        ReactCurrentBatchConfig$1.transition = prevTransition;
      }
    });
  }
}

function mountTransition() {
  var _mountState2 = mountState(false),
      isPending = _mountState2[0],
      setPending = _mountState2[1]; // The `start` method can be stored on a ref, since `setPending`
  // never changes.


  var start = startTransition.bind(null, setPending);
  mountRef(start);
  return [start, isPending];
}

function updateTransition() {
  var _updateState2 = updateState(),
      isPending = _updateState2[0];

  var startRef = updateRef();
  var start = startRef.current;
  return [start, isPending];
}

function rerenderTransition() {
  var _rerenderState2 = rerenderState(),
      isPending = _rerenderState2[0];

  var startRef = updateRef();
  var start = startRef.current;
  return [start, isPending];
}

var isUpdatingOpaqueValueInRenderPhase = false;
function getIsUpdatingOpaqueValueInRenderPhaseInDEV() {
  {
    return isUpdatingOpaqueValueInRenderPhase;
  }
}

function warnOnOpaqueIdentifierAccessInDEV(fiber) {
  {
    // TODO: Should warn in effects and callbacks, too
    var name = getComponentName(fiber.type) || 'Unknown';

    if (getIsRendering() && !didWarnAboutUseOpaqueIdentifier[name]) {
      error('The object passed back from useOpaqueIdentifier is meant to be ' + 'passed through to attributes only. Do not read the ' + 'value directly.');

      didWarnAboutUseOpaqueIdentifier[name] = true;
    }
  }
}

function mountOpaqueIdentifier() {
  var makeId =  makeClientIdInDEV.bind(null, warnOnOpaqueIdentifierAccessInDEV.bind(null, currentlyRenderingFiber$1)) ;

  if (getIsHydrating()) {
    var didUpgrade = false;
    var fiber = currentlyRenderingFiber$1;

    var readValue = function () {
      if (!didUpgrade) {
        // Only upgrade once. This works even inside the render phase because
        // the update is added to a shared queue, which outlasts the
        // in-progress render.
        didUpgrade = true;

        {
          isUpdatingOpaqueValueInRenderPhase = true;
          setId(makeId());
          isUpdatingOpaqueValueInRenderPhase = false;
          warnOnOpaqueIdentifierAccessInDEV(fiber);
        }
      }

      {
        {
          throw Error( "The object passed back from useOpaqueIdentifier is meant to be passed through to attributes only. Do not read the value directly." );
        }
      }
    };

    var id = makeOpaqueHydratingObject(readValue);
    var setId = mountState(id)[1];

    if ((currentlyRenderingFiber$1.mode & BlockingMode) === NoMode) {
      currentlyRenderingFiber$1.flags |= Update | Passive;
      pushEffect(HasEffect | Passive$1, function () {
        setId(makeId());
      }, undefined, null);
    }

    return id;
  } else {
    var _id = makeId();

    mountState(_id);
    return _id;
  }
}

function updateOpaqueIdentifier() {
  var id = updateState()[0];
  return id;
}

function rerenderOpaqueIdentifier() {
  var id = rerenderState()[0];
  return id;
}

function dispatchAction(fiber, queue, action) {
  {
    if (typeof arguments[3] === 'function') {
      error("State updates from the useState() and useReducer() Hooks don't support the " + 'second callback argument. To execute a side effect after ' + 'rendering, declare it in the component body with useEffect().');
    }
  }

  var eventTime = requestEventTime();
  var lane = requestUpdateLane(fiber);
  var update = {
    lane: lane,
    action: action,
    eagerReducer: null,
    eagerState: null,
    next: null
  }; // Append the update to the end of the list.

  var pending = queue.pending;

  if (pending === null) {
    // This is the first update. Create a circular list.
    update.next = update;
  } else {
    update.next = pending.next;
    pending.next = update;
  }

  queue.pending = update;
  var alternate = fiber.alternate;

  if (fiber === currentlyRenderingFiber$1 || alternate !== null && alternate === currentlyRenderingFiber$1) {
    // This is a render phase update. Stash it in a lazily-created map of
    // queue -> linked list of updates. After this render pass, we'll restart
    // and apply the stashed updates on top of the work-in-progress hook.
    didScheduleRenderPhaseUpdateDuringThisPass = didScheduleRenderPhaseUpdate = true;
  } else {
    if (fiber.lanes === NoLanes && (alternate === null || alternate.lanes === NoLanes)) {
      // The queue is currently empty, which means we can eagerly compute the
      // next state before entering the render phase. If the new state is the
      // same as the current state, we may be able to bail out entirely.
      var lastRenderedReducer = queue.lastRenderedReducer;

      if (lastRenderedReducer !== null) {
        var prevDispatcher;

        {
          prevDispatcher = ReactCurrentDispatcher$1.current;
          ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnUpdateInDEV;
        }

        try {
          var currentState = queue.lastRenderedState;
          var eagerState = lastRenderedReducer(currentState, action); // Stash the eagerly computed state, and the reducer used to compute
          // it, on the update object. If the reducer hasn't changed by the
          // time we enter the render phase, then the eager state can be used
          // without calling the reducer again.

          update.eagerReducer = lastRenderedReducer;
          update.eagerState = eagerState;

          if (objectIs(eagerState, currentState)) {
            // Fast path. We can bail out without scheduling React to re-render.
            // It's still possible that we'll need to rebase this update later,
            // if the component re-renders for a different reason and by that
            // time the reducer has changed.
            return;
          }
        } catch (error) {// Suppress the error. It will throw again in the render phase.
        } finally {
          {
            ReactCurrentDispatcher$1.current = prevDispatcher;
          }
        }
      }
    }

    {
      // $FlowExpectedError - jest isn't a global, and isn't recognized outside of tests
      if ('undefined' !== typeof jest) {
        warnIfNotScopedWithMatchingAct(fiber);
        warnIfNotCurrentlyActingUpdatesInDev(fiber);
      }
    }

    scheduleUpdateOnFiber(fiber, lane, eventTime);
  }
}

var ContextOnlyDispatcher = {
  readContext: readContext,
  useCallback: throwInvalidHookError,
  useContext: throwInvalidHookError,
  useEffect: throwInvalidHookError,
  useImperativeHandle: throwInvalidHookError,
  useLayoutEffect: throwInvalidHookError,
  useMemo: throwInvalidHookError,
  useReducer: throwInvalidHookError,
  useRef: throwInvalidHookError,
  useState: throwInvalidHookError,
  useDebugValue: throwInvalidHookError,
  useDeferredValue: throwInvalidHookError,
  useTransition: throwInvalidHookError,
  useMutableSource: throwInvalidHookError,
  useOpaqueIdentifier: throwInvalidHookError,
  unstable_isNewReconciler: enableNewReconciler
};
var HooksDispatcherOnMountInDEV = null;
var HooksDispatcherOnMountWithHookTypesInDEV = null;
var HooksDispatcherOnUpdateInDEV = null;
var HooksDispatcherOnRerenderInDEV = null;
var InvalidNestedHooksDispatcherOnMountInDEV = null;
var InvalidNestedHooksDispatcherOnUpdateInDEV = null;
var InvalidNestedHooksDispatcherOnRerenderInDEV = null;

{
  var warnInvalidContextAccess = function () {
    error('Context can only be read while React is rendering. ' + 'In classes, you can read it in the render method or getDerivedStateFromProps. ' + 'In function components, you can read it directly in the function body, but not ' + 'inside Hooks like useReducer() or useMemo().');
  };

  var warnInvalidHookAccess = function () {
    error('Do not call Hooks inside useEffect(...), useMemo(...), or other built-in Hooks. ' + 'You can only call Hooks at the top level of your React function. ' + 'For more information, see ' + 'https://reactjs.org/link/rules-of-hooks');
  };

  HooksDispatcherOnMountInDEV = {
    readContext: function (context, observedBits) {
      return readContext(context, observedBits);
    },
    useCallback: function (callback, deps) {
      currentHookNameInDev = 'useCallback';
      mountHookTypesDev();
      checkDepsAreArrayDev(deps);
      return mountCallback(callback, deps);
    },
    useContext: function (context, observedBits) {
      currentHookNameInDev = 'useContext';
      mountHookTypesDev();
      return readContext(context, observedBits);
    },
    useEffect: function (create, deps) {
      currentHookNameInDev = 'useEffect';
      mountHookTypesDev();
      checkDepsAreArrayDev(deps);
      return mountEffect(create, deps);
    },
    useImperativeHandle: function (ref, create, deps) {
      currentHookNameInDev = 'useImperativeHandle';
      mountHookTypesDev();
      checkDepsAreArrayDev(deps);
      return mountImperativeHandle(ref, create, deps);
    },
    useLayoutEffect: function (create, deps) {
      currentHookNameInDev = 'useLayoutEffect';
      mountHookTypesDev();
      checkDepsAreArrayDev(deps);
      return mountLayoutEffect(create, deps);
    },
    useMemo: function (create, deps) {
      currentHookNameInDev = 'useMemo';
      mountHookTypesDev();
      checkDepsAreArrayDev(deps);
      var prevDispatcher = ReactCurrentDispatcher$1.current;
      ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnMountInDEV;

      try {
        return mountMemo(create, deps);
      } finally {
        ReactCurrentDispatcher$1.current = prevDispatcher;
      }
    },
    useReducer: function (reducer, initialArg, init) {
      currentHookNameInDev = 'useReducer';
      mountHookTypesDev();
      var prevDispatcher = ReactCurrentDispatcher$1.current;
      ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnMountInDEV;

      try {
        return mountReducer(reducer, initialArg, init);
      } finally {
        ReactCurrentDispatcher$1.current = prevDispatcher;
      }
    },
    useRef: function (initialValue) {
      currentHookNameInDev = 'useRef';
      mountHookTypesDev();
      return mountRef(initialValue);
    },
    useState: function (initialState) {
      currentHookNameInDev = 'useState';
      mountHookTypesDev();
      var prevDispatcher = ReactCurrentDispatcher$1.current;
      ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnMountInDEV;

      try {
        return mountState(initialState);
      } finally {
        ReactCurrentDispatcher$1.current = prevDispatcher;
      }
    },
    useDebugValue: function (value, formatterFn) {
      currentHookNameInDev = 'useDebugValue';
      mountHookTypesDev();
      return mountDebugValue();
    },
    useDeferredValue: function (value) {
      currentHookNameInDev = 'useDeferredValue';
      mountHookTypesDev();
      return mountDeferredValue(value);
    },
    useTransition: function () {
      currentHookNameInDev = 'useTransition';
      mountHookTypesDev();
      return mountTransition();
    },
    useMutableSource: function (source, getSnapshot, subscribe) {
      currentHookNameInDev = 'useMutableSource';
      mountHookTypesDev();
      return mountMutableSource(source, getSnapshot, subscribe);
    },
    useOpaqueIdentifier: function () {
      currentHookNameInDev = 'useOpaqueIdentifier';
      mountHookTypesDev();
      return mountOpaqueIdentifier();
    },
    unstable_isNewReconciler: enableNewReconciler
  };
  HooksDispatcherOnMountWithHookTypesInDEV = {
    readContext: function (context, observedBits) {
      return readContext(context, observedBits);
    },
    useCallback: function (callback, deps) {
      currentHookNameInDev = 'useCallback';
      updateHookTypesDev();
      return mountCallback(callback, deps);
    },
    useContext: function (context, observedBits) {
      currentHookNameInDev = 'useContext';
      updateHookTypesDev();
      return readContext(context, observedBits);
    },
    useEffect: function (create, deps) {
      currentHookNameInDev = 'useEffect';
      updateHookTypesDev();
      return mountEffect(create, deps);
    },
    useImperativeHandle: function (ref, create, deps) {
      currentHookNameInDev = 'useImperativeHandle';
      updateHookTypesDev();
      return mountImperativeHandle(ref, create, deps);
    },
    useLayoutEffect: function (create, deps) {
      currentHookNameInDev = 'useLayoutEffect';
      updateHookTypesDev();
      return mountLayoutEffect(create, deps);
    },
    useMemo: function (create, deps) {
      currentHookNameInDev = 'useMemo';
      updateHookTypesDev();
      var prevDispatcher = ReactCurrentDispatcher$1.current;
      ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnMountInDEV;

      try {
        return mountMemo(create, deps);
      } finally {
        ReactCurrentDispatcher$1.current = prevDispatcher;
      }
    },
    useReducer: function (reducer, initialArg, init) {
      currentHookNameInDev = 'useReducer';
      updateHookTypesDev();
      var prevDispatcher = ReactCurrentDispatcher$1.current;
      ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnMountInDEV;

      try {
        return mountReducer(reducer, initialArg, init);
      } finally {
        ReactCurrentDispatcher$1.current = prevDispatcher;
      }
    },
    useRef: function (initialValue) {
      currentHookNameInDev = 'useRef';
      updateHookTypesDev();
      return mountRef(initialValue);
    },
    useState: function (initialState) {
      currentHookNameInDev = 'useState';
      updateHookTypesDev();
      var prevDispatcher = ReactCurrentDispatcher$1.current;
      ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnMountInDEV;

      try {
        return mountState(initialState);
      } finally {
        ReactCurrentDispatcher$1.current = prevDispatcher;
      }
    },
    useDebugValue: function (value, formatterFn) {
      currentHookNameInDev = 'useDebugValue';
      updateHookTypesDev();
      return mountDebugValue();
    },
    useDeferredValue: function (value) {
      currentHookNameInDev = 'useDeferredValue';
      updateHookTypesDev();
      return mountDeferredValue(value);
    },
    useTransition: function () {
      currentHookNameInDev = 'useTransition';
      updateHookTypesDev();
      return mountTransition();
    },
    useMutableSource: function (source, getSnapshot, subscribe) {
      currentHookNameInDev = 'useMutableSource';
      updateHookTypesDev();
      return mountMutableSource(source, getSnapshot, subscribe);
    },
    useOpaqueIdentifier: function () {
      currentHookNameInDev = 'useOpaqueIdentifier';
      updateHookTypesDev();
      return mountOpaqueIdentifier();
    },
    unstable_isNewReconciler: enableNewReconciler
  };
  HooksDispatcherOnUpdateInDEV = {
    readContext: function (context, observedBits) {
      return readContext(context, observedBits);
    },
    useCallback: function (callback, deps) {
      currentHookNameInDev = 'useCallback';
      updateHookTypesDev();
      return updateCallback(callback, deps);
    },
    useContext: function (context, observedBits) {
      currentHookNameInDev = 'useContext';
      updateHookTypesDev();
      return readContext(context, observedBits);
    },
    useEffect: function (create, deps) {
      currentHookNameInDev = 'useEffect';
      updateHookTypesDev();
      return updateEffect(create, deps);
    },
    useImperativeHandle: function (ref, create, deps) {
      currentHookNameInDev = 'useImperativeHandle';
      updateHookTypesDev();
      return updateImperativeHandle(ref, create, deps);
    },
    useLayoutEffect: function (create, deps) {
      currentHookNameInDev = 'useLayoutEffect';
      updateHookTypesDev();
      return updateLayoutEffect(create, deps);
    },
    useMemo: function (create, deps) {
      currentHookNameInDev = 'useMemo';
      updateHookTypesDev();
      var prevDispatcher = ReactCurrentDispatcher$1.current;
      ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnUpdateInDEV;

      try {
        return updateMemo(create, deps);
      } finally {
        ReactCurrentDispatcher$1.current = prevDispatcher;
      }
    },
    useReducer: function (reducer, initialArg, init) {
      currentHookNameInDev = 'useReducer';
      updateHookTypesDev();
      var prevDispatcher = ReactCurrentDispatcher$1.current;
      ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnUpdateInDEV;

      try {
        return updateReducer(reducer, initialArg, init);
      } finally {
        ReactCurrentDispatcher$1.current = prevDispatcher;
      }
    },
    useRef: function (initialValue) {
      currentHookNameInDev = 'useRef';
      updateHookTypesDev();
      return updateRef();
    },
    useState: function (initialState) {
      currentHookNameInDev = 'useState';
      updateHookTypesDev();
      var prevDispatcher = ReactCurrentDispatcher$1.current;
      ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnUpdateInDEV;

      try {
        return updateState(initialState);
      } finally {
        ReactCurrentDispatcher$1.current = prevDispatcher;
      }
    },
    useDebugValue: function (value, formatterFn) {
      currentHookNameInDev = 'useDebugValue';
      updateHookTypesDev();
      return updateDebugValue();
    },
    useDeferredValue: function (value) {
      currentHookNameInDev = 'useDeferredValue';
      updateHookTypesDev();
      return updateDeferredValue(value);
    },
    useTransition: function () {
      currentHookNameInDev = 'useTransition';
      updateHookTypesDev();
      return updateTransition();
    },
    useMutableSource: function (source, getSnapshot, subscribe) {
      currentHookNameInDev = 'useMutableSource';
      updateHookTypesDev();
      return updateMutableSource(source, getSnapshot, subscribe);
    },
    useOpaqueIdentifier: function () {
      currentHookNameInDev = 'useOpaqueIdentifier';
      updateHookTypesDev();
      return updateOpaqueIdentifier();
    },
    unstable_isNewReconciler: enableNewReconciler
  };
  HooksDispatcherOnRerenderInDEV = {
    readContext: function (context, observedBits) {
      return readContext(context, observedBits);
    },
    useCallback: function (callback, deps) {
      currentHookNameInDev = 'useCallback';
      updateHookTypesDev();
      return updateCallback(callback, deps);
    },
    useContext: function (context, observedBits) {
      currentHookNameInDev = 'useContext';
      updateHookTypesDev();
      return readContext(context, observedBits);
    },
    useEffect: function (create, deps) {
      currentHookNameInDev = 'useEffect';
      updateHookTypesDev();
      return updateEffect(create, deps);
    },
    useImperativeHandle: function (ref, create, deps) {
      currentHookNameInDev = 'useImperativeHandle';
      updateHookTypesDev();
      return updateImperativeHandle(ref, create, deps);
    },
    useLayoutEffect: function (create, deps) {
      currentHookNameInDev = 'useLayoutEffect';
      updateHookTypesDev();
      return updateLayoutEffect(create, deps);
    },
    useMemo: function (create, deps) {
      currentHookNameInDev = 'useMemo';
      updateHookTypesDev();
      var prevDispatcher = ReactCurrentDispatcher$1.current;
      ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnRerenderInDEV;

      try {
        return updateMemo(create, deps);
      } finally {
        ReactCurrentDispatcher$1.current = prevDispatcher;
      }
    },
    useReducer: function (reducer, initialArg, init) {
      currentHookNameInDev = 'useReducer';
      updateHookTypesDev();
      var prevDispatcher = ReactCurrentDispatcher$1.current;
      ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnRerenderInDEV;

      try {
        return rerenderReducer(reducer, initialArg, init);
      } finally {
        ReactCurrentDispatcher$1.current = prevDispatcher;
      }
    },
    useRef: function (initialValue) {
      currentHookNameInDev = 'useRef';
      updateHookTypesDev();
      return updateRef();
    },
    useState: function (initialState) {
      currentHookNameInDev = 'useState';
      updateHookTypesDev();
      var prevDispatcher = ReactCurrentDispatcher$1.current;
      ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnRerenderInDEV;

      try {
        return rerenderState(initialState);
      } finally {
        ReactCurrentDispatcher$1.current = prevDispatcher;
      }
    },
    useDebugValue: function (value, formatterFn) {
      currentHookNameInDev = 'useDebugValue';
      updateHookTypesDev();
      return updateDebugValue();
    },
    useDeferredValue: function (value) {
      currentHookNameInDev = 'useDeferredValue';
      updateHookTypesDev();
      return rerenderDeferredValue(value);
    },
    useTransition: function () {
      currentHookNameInDev = 'useTransition';
      updateHookTypesDev();
      return rerenderTransition();
    },
    useMutableSource: function (source, getSnapshot, subscribe) {
      currentHookNameInDev = 'useMutableSource';
      updateHookTypesDev();
      return updateMutableSource(source, getSnapshot, subscribe);
    },
    useOpaqueIdentifier: function () {
      currentHookNameInDev = 'useOpaqueIdentifier';
      updateHookTypesDev();
      return rerenderOpaqueIdentifier();
    },
    unstable_isNewReconciler: enableNewReconciler
  };
  InvalidNestedHooksDispatcherOnMountInDEV = {
    readContext: function (context, observedBits) {
      warnInvalidContextAccess();
      return readContext(context, observedBits);
    },
    useCallback: function (callback, deps) {
      currentHookNameInDev = 'useCallback';
      warnInvalidHookAccess();
      mountHookTypesDev();
      return mountCallback(callback, deps);
    },
    useContext: function (context, observedBits) {
      currentHookNameInDev = 'useContext';
      warnInvalidHookAccess();
      mountHookTypesDev();
      return readContext(context, observedBits);
    },
    useEffect: function (create, deps) {
      currentHookNameInDev = 'useEffect';
      warnInvalidHookAccess();
      mountHookTypesDev();
      return mountEffect(create, deps);
    },
    useImperativeHandle: function (ref, create, deps) {
      currentHookNameInDev = 'useImperativeHandle';
      warnInvalidHookAccess();
      mountHookTypesDev();
      return mountImperativeHandle(ref, create, deps);
    },
    useLayoutEffect: function (create, deps) {
      currentHookNameInDev = 'useLayoutEffect';
      warnInvalidHookAccess();
      mountHookTypesDev();
      return mountLayoutEffect(create, deps);
    },
    useMemo: function (create, deps) {
      currentHookNameInDev = 'useMemo';
      warnInvalidHookAccess();
      mountHookTypesDev();
      var prevDispatcher = ReactCurrentDispatcher$1.current;
      ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnMountInDEV;

      try {
        return mountMemo(create, deps);
      } finally {
        ReactCurrentDispatcher$1.current = prevDispatcher;
      }
    },
    useReducer: function (reducer, initialArg, init) {
      currentHookNameInDev = 'useReducer';
      warnInvalidHookAccess();
      mountHookTypesDev();
      var prevDispatcher = ReactCurrentDispatcher$1.current;
      ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnMountInDEV;

      try {
        return mountReducer(reducer, initialArg, init);
      } finally {
        ReactCurrentDispatcher$1.current = prevDispatcher;
      }
    },
    useRef: function (initialValue) {
      currentHookNameInDev = 'useRef';
      warnInvalidHookAccess();
      mountHookTypesDev();
      return mountRef(initialValue);
    },
    useState: function (initialState) {
      currentHookNameInDev = 'useState';
      warnInvalidHookAccess();
      mountHookTypesDev();
      var prevDispatcher = ReactCurrentDispatcher$1.current;
      ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnMountInDEV;

      try {
        return mountState(initialState);
      } finally {
        ReactCurrentDispatcher$1.current = prevDispatcher;
      }
    },
    useDebugValue: function (value, formatterFn) {
      currentHookNameInDev = 'useDebugValue';
      warnInvalidHookAccess();
      mountHookTypesDev();
      return mountDebugValue();
    },
    useDeferredValue: function (value) {
      currentHookNameInDev = 'useDeferredValue';
      warnInvalidHookAccess();
      mountHookTypesDev();
      return mountDeferredValue(value);
    },
    useTransition: function () {
      currentHookNameInDev = 'useTransition';
      warnInvalidHookAccess();
      mountHookTypesDev();
      return mountTransition();
    },
    useMutableSource: function (source, getSnapshot, subscribe) {
      currentHookNameInDev = 'useMutableSource';
      warnInvalidHookAccess();
      mountHookTypesDev();
      return mountMutableSource(source, getSnapshot, subscribe);
    },
    useOpaqueIdentifier: function () {
      currentHookNameInDev = 'useOpaqueIdentifier';
      warnInvalidHookAccess();
      mountHookTypesDev();
      return mountOpaqueIdentifier();
    },
    unstable_isNewReconciler: enableNewReconciler
  };
  InvalidNestedHooksDispatcherOnUpdateInDEV = {
    readContext: function (context, observedBits) {
      warnInvalidContextAccess();
      return readContext(context, observedBits);
    },
    useCallback: function (callback, deps) {
      currentHookNameInDev = 'useCallback';
      warnInvalidHookAccess();
      updateHookTypesDev();
      return updateCallback(callback, deps);
    },
    useContext: function (context, observedBits) {
      currentHookNameInDev = 'useContext';
      warnInvalidHookAccess();
      updateHookTypesDev();
      return readContext(context, observedBits);
    },
    useEffect: function (create, deps) {
      currentHookNameInDev = 'useEffect';
      warnInvalidHookAccess();
      updateHookTypesDev();
      return updateEffect(create, deps);
    },
    useImperativeHandle: function (ref, create, deps) {
      currentHookNameInDev = 'useImperativeHandle';
      warnInvalidHookAccess();
      updateHookTypesDev();
      return updateImperativeHandle(ref, create, deps);
    },
    useLayoutEffect: function (create, deps) {
      currentHookNameInDev = 'useLayoutEffect';
      warnInvalidHookAccess();
      updateHookTypesDev();
      return updateLayoutEffect(create, deps);
    },
    useMemo: function (create, deps) {
      currentHookNameInDev = 'useMemo';
      warnInvalidHookAccess();
      updateHookTypesDev();
      var prevDispatcher = ReactCurrentDispatcher$1.current;
      ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnUpdateInDEV;

      try {
        return updateMemo(create, deps);
      } finally {
        ReactCurrentDispatcher$1.current = prevDispatcher;
      }
    },
    useReducer: function (reducer, initialArg, init) {
      currentHookNameInDev = 'useReducer';
      warnInvalidHookAccess();
      updateHookTypesDev();
      var prevDispatcher = ReactCurrentDispatcher$1.current;
      ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnUpdateInDEV;

      try {
        return updateReducer(reducer, initialArg, init);
      } finally {
        ReactCurrentDispatcher$1.current = prevDispatcher;
      }
    },
    useRef: function (initialValue) {
      currentHookNameInDev = 'useRef';
      warnInvalidHookAccess();
      updateHookTypesDev();
      return updateRef();
    },
    useState: function (initialState) {
      currentHookNameInDev = 'useState';
      warnInvalidHookAccess();
      updateHookTypesDev();
      var prevDispatcher = ReactCurrentDispatcher$1.current;
      ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnUpdateInDEV;

      try {
        return updateState(initialState);
      } finally {
        ReactCurrentDispatcher$1.current = prevDispatcher;
      }
    },
    useDebugValue: function (value, formatterFn) {
      currentHookNameInDev = 'useDebugValue';
      warnInvalidHookAccess();
      updateHookTypesDev();
      return updateDebugValue();
    },
    useDeferredValue: function (value) {
      currentHookNameInDev = 'useDeferredValue';
      warnInvalidHookAccess();
      updateHookTypesDev();
      return updateDeferredValue(value);
    },
    useTransition: function () {
      currentHookNameInDev = 'useTransition';
      warnInvalidHookAccess();
      updateHookTypesDev();
      return updateTransition();
    },
    useMutableSource: function (source, getSnapshot, subscribe) {
      currentHookNameInDev = 'useMutableSource';
      warnInvalidHookAccess();
      updateHookTypesDev();
      return updateMutableSource(source, getSnapshot, subscribe);
    },
    useOpaqueIdentifier: function () {
      currentHookNameInDev = 'useOpaqueIdentifier';
      warnInvalidHookAccess();
      updateHookTypesDev();
      return updateOpaqueIdentifier();
    },
    unstable_isNewReconciler: enableNewReconciler
  };
  InvalidNestedHooksDispatcherOnRerenderInDEV = {
    readContext: function (context, observedBits) {
      warnInvalidContextAccess();
      return readContext(context, observedBits);
    },
    useCallback: function (callback, deps) {
      currentHookNameInDev = 'useCallback';
      warnInvalidHookAccess();
      updateHookTypesDev();
      return updateCallback(callback, deps);
    },
    useContext: function (context, observedBits) {
      currentHookNameInDev = 'useContext';
      warnInvalidHookAccess();
      updateHookTypesDev();
      return readContext(context, observedBits);
    },
    useEffect: function (create, deps) {
      currentHookNameInDev = 'useEffect';
      warnInvalidHookAccess();
      updateHookTypesDev();
      return updateEffect(create, deps);
    },
    useImperativeHandle: function (ref, create, deps) {
      currentHookNameInDev = 'useImperativeHandle';
      warnInvalidHookAccess();
      updateHookTypesDev();
      return updateImperativeHandle(ref, create, deps);
    },
    useLayoutEffect: function (create, deps) {
      currentHookNameInDev = 'useLayoutEffect';
      warnInvalidHookAccess();
      updateHookTypesDev();
      return updateLayoutEffect(create, deps);
    },
    useMemo: function (create, deps) {
      currentHookNameInDev = 'useMemo';
      warnInvalidHookAccess();
      updateHookTypesDev();
      var prevDispatcher = ReactCurrentDispatcher$1.current;
      ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnUpdateInDEV;

      try {
        return updateMemo(create, deps);
      } finally {
        ReactCurrentDispatcher$1.current = prevDispatcher;
      }
    },
    useReducer: function (reducer, initialArg, init) {
      currentHookNameInDev = 'useReducer';
      warnInvalidHookAccess();
      updateHookTypesDev();
      var prevDispatcher = ReactCurrentDispatcher$1.current;
      ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnUpdateInDEV;

      try {
        return rerenderReducer(reducer, initialArg, init);
      } finally {
        ReactCurrentDispatcher$1.current = prevDispatcher;
      }
    },
    useRef: function (initialValue) {
      currentHookNameInDev = 'useRef';
      warnInvalidHookAccess();
      updateHookTypesDev();
      return updateRef();
    },
    useState: function (initialState) {
      currentHookNameInDev = 'useState';
      warnInvalidHookAccess();
      updateHookTypesDev();
      var prevDispatcher = ReactCurrentDispatcher$1.current;
      ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnUpdateInDEV;

      try {
        return rerenderState(initialState);
      } finally {
        ReactCurrentDispatcher$1.current = prevDispatcher;
      }
    },
    useDebugValue: function (value, formatterFn) {
      currentHookNameInDev = 'useDebugValue';
      warnInvalidHookAccess();
      updateHookTypesDev();
      return updateDebugValue();
    },
    useDeferredValue: function (value) {
      currentHookNameInDev = 'useDeferredValue';
      warnInvalidHookAccess();
      updateHookTypesDev();
      return rerenderDeferredValue(value);
    },
    useTransition: function () {
      currentHookNameInDev = 'useTransition';
      warnInvalidHookAccess();
      updateHookTypesDev();
      return rerenderTransition();
    },
    useMutableSource: function (source, getSnapshot, subscribe) {
      currentHookNameInDev = 'useMutableSource';
      warnInvalidHookAccess();
      updateHookTypesDev();
      return updateMutableSource(source, getSnapshot, subscribe);
    },
    useOpaqueIdentifier: function () {
      currentHookNameInDev = 'useOpaqueIdentifier';
      warnInvalidHookAccess();
      updateHookTypesDev();
      return rerenderOpaqueIdentifier();
    },
    unstable_isNewReconciler: enableNewReconciler
  };
}

var now$1 = Scheduler.unstable_now;
var commitTime = 0;
var profilerStartTime = -1;

function getCommitTime() {
  return commitTime;
}

function recordCommitTime() {

  commitTime = now$1();
}

function startProfilerTimer(fiber) {

  profilerStartTime = now$1();

  if (fiber.actualStartTime < 0) {
    fiber.actualStartTime = now$1();
  }
}

function stopProfilerTimerIfRunning(fiber) {

  profilerStartTime = -1;
}

function stopProfilerTimerIfRunningAndRecordDelta(fiber, overrideBaseTime) {

  if (profilerStartTime >= 0) {
    var elapsedTime = now$1() - profilerStartTime;
    fiber.actualDuration += elapsedTime;

    if (overrideBaseTime) {
      fiber.selfBaseDuration = elapsedTime;
    }

    profilerStartTime = -1;
  }
}

function transferActualDuration(fiber) {
  // Transfer time spent rendering these children so we don't lose it
  // after we rerender. This is used as a helper in special cases
  // where we should count the work of multiple passes.
  var child = fiber.child;

  while (child) {
    fiber.actualDuration += child.actualDuration;
    child = child.sibling;
  }
}

var ReactCurrentOwner$1 = ReactSharedInternals.ReactCurrentOwner;
var didReceiveUpdate = false;
var didWarnAboutBadClass;
var didWarnAboutModulePatternComponent;
var didWarnAboutContextTypeOnFunctionComponent;
var didWarnAboutGetDerivedStateOnFunctionComponent;
var didWarnAboutFunctionRefs;
var didWarnAboutReassigningProps;
var didWarnAboutRevealOrder;
var didWarnAboutTailOptions;

{
  didWarnAboutBadClass = {};
  didWarnAboutModulePatternComponent = {};
  didWarnAboutContextTypeOnFunctionComponent = {};
  didWarnAboutGetDerivedStateOnFunctionComponent = {};
  didWarnAboutFunctionRefs = {};
  didWarnAboutReassigningProps = false;
  didWarnAboutRevealOrder = {};
  didWarnAboutTailOptions = {};
}

function reconcileChildren(current, workInProgress, nextChildren, renderLanes) {
  if (current === null) {
    // If this is a fresh new component that hasn't been rendered yet, we
    // won't update its child set by applying minimal side-effects. Instead,
    // we will add them all to the child before it gets rendered. That means
    // we can optimize this reconciliation pass by not tracking side-effects.
    workInProgress.child = mountChildFibers(workInProgress, null, nextChildren, renderLanes);
  } else {
    // If the current child is the same as the work in progress, it means that
    // we haven't yet started any work on these children. Therefore, we use
    // the clone algorithm to create a copy of all the current children.
    // If we had any progressed work already, that is invalid at this point so
    // let's throw it out.
    workInProgress.child = reconcileChildFibers(workInProgress, current.child, nextChildren, renderLanes);
  }
}

function forceUnmountCurrentAndReconcile(current, workInProgress, nextChildren, renderLanes) {
  // This function is fork of reconcileChildren. It's used in cases where we
  // want to reconcile without matching against the existing set. This has the
  // effect of all current children being unmounted; even if the type and key
  // are the same, the old child is unmounted and a new child is created.
  //
  // To do this, we're going to go through the reconcile algorithm twice. In
  // the first pass, we schedule a deletion for all the current children by
  // passing null.
  workInProgress.child = reconcileChildFibers(workInProgress, current.child, null, renderLanes); // In the second pass, we mount the new children. The trick here is that we
  // pass null in place of where we usually pass the current child set. This has
  // the effect of remounting all children regardless of whether their
  // identities match.

  workInProgress.child = reconcileChildFibers(workInProgress, null, nextChildren, renderLanes);
}

function updateForwardRef(current, workInProgress, Component, nextProps, renderLanes) {
  // TODO: current can be non-null here even if the component
  // hasn't yet mounted. This happens after the first render suspends.
  // We'll need to figure out if this is fine or can cause issues.
  {
    if (workInProgress.type !== workInProgress.elementType) {
      // Lazy component props can't be validated in createElement
      // because they're only guaranteed to be resolved here.
      var innerPropTypes = Component.propTypes;

      if (innerPropTypes) {
        checkPropTypes(innerPropTypes, nextProps, // Resolved props
        'prop', getComponentName(Component));
      }
    }
  }

  var render = Component.render;
  var ref = workInProgress.ref; // The rest is a fork of updateFunctionComponent

  var nextChildren;
  prepareToReadContext(workInProgress, renderLanes);

  {
    ReactCurrentOwner$1.current = workInProgress;
    setIsRendering(true);
    nextChildren = renderWithHooks(current, workInProgress, render, nextProps, ref, renderLanes);

    if ( workInProgress.mode & StrictMode) {
      disableLogs();

      try {
        nextChildren = renderWithHooks(current, workInProgress, render, nextProps, ref, renderLanes);
      } finally {
        reenableLogs();
      }
    }

    setIsRendering(false);
  }

  if (current !== null && !didReceiveUpdate) {
    bailoutHooks(current, workInProgress, renderLanes);
    return bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
  } // React DevTools reads this flag.


  workInProgress.flags |= PerformedWork;
  reconcileChildren(current, workInProgress, nextChildren, renderLanes);
  return workInProgress.child;
}

function updateMemoComponent(current, workInProgress, Component, nextProps, updateLanes, renderLanes) {
  if (current === null) {
    var type = Component.type;

    if (isSimpleFunctionComponent(type) && Component.compare === null && // SimpleMemoComponent codepath doesn't resolve outer props either.
    Component.defaultProps === undefined) {
      var resolvedType = type;

      {
        resolvedType = resolveFunctionForHotReloading(type);
      } // If this is a plain function component without default props,
      // and with only the default shallow comparison, we upgrade it
      // to a SimpleMemoComponent to allow fast path updates.


      workInProgress.tag = SimpleMemoComponent;
      workInProgress.type = resolvedType;

      {
        validateFunctionComponentInDev(workInProgress, type);
      }

      return updateSimpleMemoComponent(current, workInProgress, resolvedType, nextProps, updateLanes, renderLanes);
    }

    {
      var innerPropTypes = type.propTypes;

      if (innerPropTypes) {
        // Inner memo component props aren't currently validated in createElement.
        // We could move it there, but we'd still need this for lazy code path.
        checkPropTypes(innerPropTypes, nextProps, // Resolved props
        'prop', getComponentName(type));
      }
    }

    var child = createFiberFromTypeAndProps(Component.type, null, nextProps, workInProgress, workInProgress.mode, renderLanes);
    child.ref = workInProgress.ref;
    child.return = workInProgress;
    workInProgress.child = child;
    return child;
  }

  {
    var _type = Component.type;
    var _innerPropTypes = _type.propTypes;

    if (_innerPropTypes) {
      // Inner memo component props aren't currently validated in createElement.
      // We could move it there, but we'd still need this for lazy code path.
      checkPropTypes(_innerPropTypes, nextProps, // Resolved props
      'prop', getComponentName(_type));
    }
  }

  var currentChild = current.child; // This is always exactly one child

  if (!includesSomeLane(updateLanes, renderLanes)) {
    // This will be the props with resolved defaultProps,
    // unlike current.memoizedProps which will be the unresolved ones.
    var prevProps = currentChild.memoizedProps; // Default to shallow comparison

    var compare = Component.compare;
    compare = compare !== null ? compare : shallowEqual;

    if (compare(prevProps, nextProps) && current.ref === workInProgress.ref) {
      return bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    }
  } // React DevTools reads this flag.


  workInProgress.flags |= PerformedWork;
  var newChild = createWorkInProgress(currentChild, nextProps);
  newChild.ref = workInProgress.ref;
  newChild.return = workInProgress;
  workInProgress.child = newChild;
  return newChild;
}

function updateSimpleMemoComponent(current, workInProgress, Component, nextProps, updateLanes, renderLanes) {
  // TODO: current can be non-null here even if the component
  // hasn't yet mounted. This happens when the inner render suspends.
  // We'll need to figure out if this is fine or can cause issues.
  {
    if (workInProgress.type !== workInProgress.elementType) {
      // Lazy component props can't be validated in createElement
      // because they're only guaranteed to be resolved here.
      var outerMemoType = workInProgress.elementType;

      if (outerMemoType.$$typeof === REACT_LAZY_TYPE) {
        // We warn when you define propTypes on lazy()
        // so let's just skip over it to find memo() outer wrapper.
        // Inner props for memo are validated later.
        var lazyComponent = outerMemoType;
        var payload = lazyComponent._payload;
        var init = lazyComponent._init;

        try {
          outerMemoType = init(payload);
        } catch (x) {
          outerMemoType = null;
        } // Inner propTypes will be validated in the function component path.


        var outerPropTypes = outerMemoType && outerMemoType.propTypes;

        if (outerPropTypes) {
          checkPropTypes(outerPropTypes, nextProps, // Resolved (SimpleMemoComponent has no defaultProps)
          'prop', getComponentName(outerMemoType));
        }
      }
    }
  }

  if (current !== null) {
    var prevProps = current.memoizedProps;

    if (shallowEqual(prevProps, nextProps) && current.ref === workInProgress.ref && ( // Prevent bailout if the implementation changed due to hot reload.
     workInProgress.type === current.type )) {
      didReceiveUpdate = false;

      if (!includesSomeLane(renderLanes, updateLanes)) {
        // The pending lanes were cleared at the beginning of beginWork. We're
        // about to bail out, but there might be other lanes that weren't
        // included in the current render. Usually, the priority level of the
        // remaining updates is accumlated during the evaluation of the
        // component (i.e. when processing the update queue). But since since
        // we're bailing out early *without* evaluating the component, we need
        // to account for it here, too. Reset to the value of the current fiber.
        // NOTE: This only applies to SimpleMemoComponent, not MemoComponent,
        // because a MemoComponent fiber does not have hooks or an update queue;
        // rather, it wraps around an inner component, which may or may not
        // contains hooks.
        // TODO: Move the reset at in beginWork out of the common path so that
        // this is no longer necessary.
        workInProgress.lanes = current.lanes;
        return bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
      } else if ((current.flags & ForceUpdateForLegacySuspense) !== NoFlags) {
        // This is a special case that only exists for legacy mode.
        // See https://github.com/facebook/react/pull/19216.
        didReceiveUpdate = true;
      }
    }
  }

  return updateFunctionComponent(current, workInProgress, Component, nextProps, renderLanes);
}

function updateOffscreenComponent(current, workInProgress, renderLanes) {
  var nextProps = workInProgress.pendingProps;
  var nextChildren = nextProps.children;
  var prevState = current !== null ? current.memoizedState : null;

  if (nextProps.mode === 'hidden' || nextProps.mode === 'unstable-defer-without-hiding') {
    if ((workInProgress.mode & ConcurrentMode) === NoMode) {
      // In legacy sync mode, don't defer the subtree. Render it now.
      // TODO: Figure out what we should do in Blocking mode.
      var nextState = {
        baseLanes: NoLanes
      };
      workInProgress.memoizedState = nextState;
      pushRenderLanes(workInProgress, renderLanes);
    } else if (!includesSomeLane(renderLanes, OffscreenLane)) {
      var nextBaseLanes;

      if (prevState !== null) {
        var prevBaseLanes = prevState.baseLanes;
        nextBaseLanes = mergeLanes(prevBaseLanes, renderLanes);
      } else {
        nextBaseLanes = renderLanes;
      } // Schedule this fiber to re-render at offscreen priority. Then bailout.


      {
        markSpawnedWork(OffscreenLane);
      }

      workInProgress.lanes = workInProgress.childLanes = laneToLanes(OffscreenLane);
      var _nextState = {
        baseLanes: nextBaseLanes
      };
      workInProgress.memoizedState = _nextState; // We're about to bail out, but we need to push this to the stack anyway
      // to avoid a push/pop misalignment.

      pushRenderLanes(workInProgress, nextBaseLanes);
      return null;
    } else {
      // Rendering at offscreen, so we can clear the base lanes.
      var _nextState2 = {
        baseLanes: NoLanes
      };
      workInProgress.memoizedState = _nextState2; // Push the lanes that were skipped when we bailed out.

      var subtreeRenderLanes = prevState !== null ? prevState.baseLanes : renderLanes;
      pushRenderLanes(workInProgress, subtreeRenderLanes);
    }
  } else {
    var _subtreeRenderLanes;

    if (prevState !== null) {
      _subtreeRenderLanes = mergeLanes(prevState.baseLanes, renderLanes); // Since we're not hidden anymore, reset the state

      workInProgress.memoizedState = null;
    } else {
      // We weren't previously hidden, and we still aren't, so there's nothing
      // special to do. Need to push to the stack regardless, though, to avoid
      // a push/pop misalignment.
      _subtreeRenderLanes = renderLanes;
    }

    pushRenderLanes(workInProgress, _subtreeRenderLanes);
  }

  reconcileChildren(current, workInProgress, nextChildren, renderLanes);
  return workInProgress.child;
} // Note: These happen to have identical begin phases, for now. We shouldn't hold
// ourselves to this constraint, though. If the behavior diverges, we should
// fork the function.


var updateLegacyHiddenComponent = updateOffscreenComponent;

function updateFragment(current, workInProgress, renderLanes) {
  var nextChildren = workInProgress.pendingProps;
  reconcileChildren(current, workInProgress, nextChildren, renderLanes);
  return workInProgress.child;
}

function updateMode(current, workInProgress, renderLanes) {
  var nextChildren = workInProgress.pendingProps.children;
  reconcileChildren(current, workInProgress, nextChildren, renderLanes);
  return workInProgress.child;
}

function updateProfiler(current, workInProgress, renderLanes) {
  {
    workInProgress.flags |= Update; // Reset effect durations for the next eventual effect phase.
    // These are reset during render to allow the DevTools commit hook a chance to read them,

    var stateNode = workInProgress.stateNode;
    stateNode.effectDuration = 0;
    stateNode.passiveEffectDuration = 0;
  }

  var nextProps = workInProgress.pendingProps;
  var nextChildren = nextProps.children;
  reconcileChildren(current, workInProgress, nextChildren, renderLanes);
  return workInProgress.child;
}

function markRef(current, workInProgress) {
  var ref = workInProgress.ref;

  if (current === null && ref !== null || current !== null && current.ref !== ref) {
    // Schedule a Ref effect
    workInProgress.flags |= Ref;
  }
}

function updateFunctionComponent(current, workInProgress, Component, nextProps, renderLanes) {
  {
    if (workInProgress.type !== workInProgress.elementType) {
      // Lazy component props can't be validated in createElement
      // because they're only guaranteed to be resolved here.
      var innerPropTypes = Component.propTypes;

      if (innerPropTypes) {
        checkPropTypes(innerPropTypes, nextProps, // Resolved props
        'prop', getComponentName(Component));
      }
    }
  }

  var context;

  {
    var unmaskedContext = getUnmaskedContext(workInProgress, Component, true);
    context = getMaskedContext(workInProgress, unmaskedContext);
  }

  var nextChildren;
  prepareToReadContext(workInProgress, renderLanes);

  {
    ReactCurrentOwner$1.current = workInProgress;
    setIsRendering(true);
    nextChildren = renderWithHooks(current, workInProgress, Component, nextProps, context, renderLanes);

    if ( workInProgress.mode & StrictMode) {
      disableLogs();

      try {
        nextChildren = renderWithHooks(current, workInProgress, Component, nextProps, context, renderLanes);
      } finally {
        reenableLogs();
      }
    }

    setIsRendering(false);
  }

  if (current !== null && !didReceiveUpdate) {
    bailoutHooks(current, workInProgress, renderLanes);
    return bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
  } // React DevTools reads this flag.


  workInProgress.flags |= PerformedWork;
  reconcileChildren(current, workInProgress, nextChildren, renderLanes);
  return workInProgress.child;
}

function updateClassComponent(current, workInProgress, Component, nextProps, renderLanes) {
  {
    if (workInProgress.type !== workInProgress.elementType) {
      // Lazy component props can't be validated in createElement
      // because they're only guaranteed to be resolved here.
      var innerPropTypes = Component.propTypes;

      if (innerPropTypes) {
        checkPropTypes(innerPropTypes, nextProps, // Resolved props
        'prop', getComponentName(Component));
      }
    }
  } // Push context providers early to prevent context stack mismatches.
  // During mounting we don't know the child context yet as the instance doesn't exist.
  // We will invalidate the child context in finishClassComponent() right after rendering.


  var hasContext;

  if (isContextProvider(Component)) {
    hasContext = true;
    pushContextProvider(workInProgress);
  } else {
    hasContext = false;
  }

  prepareToReadContext(workInProgress, renderLanes);
  var instance = workInProgress.stateNode;
  var shouldUpdate;

  if (instance === null) {
    if (current !== null) {
      // A class component without an instance only mounts if it suspended
      // inside a non-concurrent tree, in an inconsistent state. We want to
      // treat it like a new mount, even though an empty version of it already
      // committed. Disconnect the alternate pointers.
      current.alternate = null;
      workInProgress.alternate = null; // Since this is conceptually a new fiber, schedule a Placement effect

      workInProgress.flags |= Placement;
    } // In the initial pass we might need to construct the instance.


    constructClassInstance(workInProgress, Component, nextProps);
    mountClassInstance(workInProgress, Component, nextProps, renderLanes);
    shouldUpdate = true;
  } else if (current === null) {
    // In a resume, we'll already have an instance we can reuse.
    shouldUpdate = resumeMountClassInstance(workInProgress, Component, nextProps, renderLanes);
  } else {
    shouldUpdate = updateClassInstance(current, workInProgress, Component, nextProps, renderLanes);
  }

  var nextUnitOfWork = finishClassComponent(current, workInProgress, Component, shouldUpdate, hasContext, renderLanes);

  {
    var inst = workInProgress.stateNode;

    if (shouldUpdate && inst.props !== nextProps) {
      if (!didWarnAboutReassigningProps) {
        error('It looks like %s is reassigning its own `this.props` while rendering. ' + 'This is not supported and can lead to confusing bugs.', getComponentName(workInProgress.type) || 'a component');
      }

      didWarnAboutReassigningProps = true;
    }
  }

  return nextUnitOfWork;
}

function finishClassComponent(current, workInProgress, Component, shouldUpdate, hasContext, renderLanes) {
  // Refs should update even if shouldComponentUpdate returns false
  markRef(current, workInProgress);
  var didCaptureError = (workInProgress.flags & DidCapture) !== NoFlags;

  if (!shouldUpdate && !didCaptureError) {
    // Context providers should defer to sCU for rendering
    if (hasContext) {
      invalidateContextProvider(workInProgress, Component, false);
    }

    return bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
  }

  var instance = workInProgress.stateNode; // Rerender

  ReactCurrentOwner$1.current = workInProgress;
  var nextChildren;

  if (didCaptureError && typeof Component.getDerivedStateFromError !== 'function') {
    // If we captured an error, but getDerivedStateFromError is not defined,
    // unmount all the children. componentDidCatch will schedule an update to
    // re-render a fallback. This is temporary until we migrate everyone to
    // the new API.
    // TODO: Warn in a future release.
    nextChildren = null;

    {
      stopProfilerTimerIfRunning();
    }
  } else {
    {
      setIsRendering(true);
      nextChildren = instance.render();

      if ( workInProgress.mode & StrictMode) {
        disableLogs();

        try {
          instance.render();
        } finally {
          reenableLogs();
        }
      }

      setIsRendering(false);
    }
  } // React DevTools reads this flag.


  workInProgress.flags |= PerformedWork;

  if (current !== null && didCaptureError) {
    // If we're recovering from an error, reconcile without reusing any of
    // the existing children. Conceptually, the normal children and the children
    // that are shown on error are two different sets, so we shouldn't reuse
    // normal children even if their identities match.
    forceUnmountCurrentAndReconcile(current, workInProgress, nextChildren, renderLanes);
  } else {
    reconcileChildren(current, workInProgress, nextChildren, renderLanes);
  } // Memoize state using the values we just used to render.
  // TODO: Restructure so we never read values from the instance.


  workInProgress.memoizedState = instance.state; // The context might have changed so we need to recalculate it.

  if (hasContext) {
    invalidateContextProvider(workInProgress, Component, true);
  }

  return workInProgress.child;
}

function pushHostRootContext(workInProgress) {
  var root = workInProgress.stateNode;

  if (root.pendingContext) {
    pushTopLevelContextObject(workInProgress, root.pendingContext, root.pendingContext !== root.context);
  } else if (root.context) {
    // Should always be set
    pushTopLevelContextObject(workInProgress, root.context, false);
  }

  pushHostContainer(workInProgress, root.containerInfo);
}

function updateHostRoot(current, workInProgress, renderLanes) {
  pushHostRootContext(workInProgress);
  var updateQueue = workInProgress.updateQueue;

  if (!(current !== null && updateQueue !== null)) {
    {
      throw Error( "If the root does not have an updateQueue, we should have already bailed out. This error is likely caused by a bug in React. Please file an issue." );
    }
  }

  var nextProps = workInProgress.pendingProps;
  var prevState = workInProgress.memoizedState;
  var prevChildren = prevState !== null ? prevState.element : null;
  cloneUpdateQueue(current, workInProgress);
  processUpdateQueue(workInProgress, nextProps, null, renderLanes);
  var nextState = workInProgress.memoizedState; // Caution: React DevTools currently depends on this property
  // being called "element".

  var nextChildren = nextState.element;

  if (nextChildren === prevChildren) {
    resetHydrationState();
    return bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
  }

  var root = workInProgress.stateNode;

  if (root.hydrate && enterHydrationState(workInProgress)) {
    // If we don't have any current children this might be the first pass.
    // We always try to hydrate. If this isn't a hydration pass there won't
    // be any children to hydrate which is effectively the same thing as
    // not hydrating.
    {
      var mutableSourceEagerHydrationData = root.mutableSourceEagerHydrationData;

      if (mutableSourceEagerHydrationData != null) {
        for (var i = 0; i < mutableSourceEagerHydrationData.length; i += 2) {
          var mutableSource = mutableSourceEagerHydrationData[i];
          var version = mutableSourceEagerHydrationData[i + 1];
          setWorkInProgressVersion(mutableSource, version);
        }
      }
    }

    var child = mountChildFibers(workInProgress, null, nextChildren, renderLanes);
    workInProgress.child = child;
    var node = child;

    while (node) {
      // Mark each child as hydrating. This is a fast path to know whether this
      // tree is part of a hydrating tree. This is used to determine if a child
      // node has fully mounted yet, and for scheduling event replaying.
      // Conceptually this is similar to Placement in that a new subtree is
      // inserted into the React tree here. It just happens to not need DOM
      // mutations because it already exists.
      node.flags = node.flags & ~Placement | Hydrating;
      node = node.sibling;
    }
  } else {
    // Otherwise reset hydration state in case we aborted and resumed another
    // root.
    reconcileChildren(current, workInProgress, nextChildren, renderLanes);
    resetHydrationState();
  }

  return workInProgress.child;
}

function updateHostComponent(current, workInProgress, renderLanes) {
  pushHostContext(workInProgress);

  if (current === null) {
    tryToClaimNextHydratableInstance(workInProgress);
  }

  var type = workInProgress.type;
  var nextProps = workInProgress.pendingProps;
  var prevProps = current !== null ? current.memoizedProps : null;
  var nextChildren = nextProps.children;
  var isDirectTextChild = shouldSetTextContent(type, nextProps);

  if (isDirectTextChild) {
    // We special case a direct text child of a host node. This is a common
    // case. We won't handle it as a reified child. We will instead handle
    // this in the host environment that also has access to this prop. That
    // avoids allocating another HostText fiber and traversing it.
    nextChildren = null;
  } else if (prevProps !== null && shouldSetTextContent(type, prevProps)) {
    // If we're switching from a direct text child to a normal child, or to
    // empty, we need to schedule the text content to be reset.
    workInProgress.flags |= ContentReset;
  }

  markRef(current, workInProgress);
  reconcileChildren(current, workInProgress, nextChildren, renderLanes);
  return workInProgress.child;
}

function updateHostText(current, workInProgress) {
  if (current === null) {
    tryToClaimNextHydratableInstance(workInProgress);
  } // Nothing to do here. This is terminal. We'll do the completion step
  // immediately after.


  return null;
}

function mountLazyComponent(_current, workInProgress, elementType, updateLanes, renderLanes) {
  if (_current !== null) {
    // A lazy component only mounts if it suspended inside a non-
    // concurrent tree, in an inconsistent state. We want to treat it like
    // a new mount, even though an empty version of it already committed.
    // Disconnect the alternate pointers.
    _current.alternate = null;
    workInProgress.alternate = null; // Since this is conceptually a new fiber, schedule a Placement effect

    workInProgress.flags |= Placement;
  }

  var props = workInProgress.pendingProps;
  var lazyComponent = elementType;
  var payload = lazyComponent._payload;
  var init = lazyComponent._init;
  var Component = init(payload); // Store the unwrapped component in the type.

  workInProgress.type = Component;
  var resolvedTag = workInProgress.tag = resolveLazyComponentTag(Component);
  var resolvedProps = resolveDefaultProps(Component, props);
  var child;

  switch (resolvedTag) {
    case FunctionComponent:
      {
        {
          validateFunctionComponentInDev(workInProgress, Component);
          workInProgress.type = Component = resolveFunctionForHotReloading(Component);
        }

        child = updateFunctionComponent(null, workInProgress, Component, resolvedProps, renderLanes);
        return child;
      }

    case ClassComponent:
      {
        {
          workInProgress.type = Component = resolveClassForHotReloading(Component);
        }

        child = updateClassComponent(null, workInProgress, Component, resolvedProps, renderLanes);
        return child;
      }

    case ForwardRef:
      {
        {
          workInProgress.type = Component = resolveForwardRefForHotReloading(Component);
        }

        child = updateForwardRef(null, workInProgress, Component, resolvedProps, renderLanes);
        return child;
      }

    case MemoComponent:
      {
        {
          if (workInProgress.type !== workInProgress.elementType) {
            var outerPropTypes = Component.propTypes;

            if (outerPropTypes) {
              checkPropTypes(outerPropTypes, resolvedProps, // Resolved for outer only
              'prop', getComponentName(Component));
            }
          }
        }

        child = updateMemoComponent(null, workInProgress, Component, resolveDefaultProps(Component.type, resolvedProps), // The inner type can have defaults too
        updateLanes, renderLanes);
        return child;
      }
  }

  var hint = '';

  {
    if (Component !== null && typeof Component === 'object' && Component.$$typeof === REACT_LAZY_TYPE) {
      hint = ' Did you wrap a component in React.lazy() more than once?';
    }
  } // This message intentionally doesn't mention ForwardRef or MemoComponent
  // because the fact that it's a separate type of work is an
  // implementation detail.


  {
    {
      throw Error( "Element type is invalid. Received a promise that resolves to: " + Component + ". Lazy element type must resolve to a class or function." + hint );
    }
  }
}

function mountIncompleteClassComponent(_current, workInProgress, Component, nextProps, renderLanes) {
  if (_current !== null) {
    // An incomplete component only mounts if it suspended inside a non-
    // concurrent tree, in an inconsistent state. We want to treat it like
    // a new mount, even though an empty version of it already committed.
    // Disconnect the alternate pointers.
    _current.alternate = null;
    workInProgress.alternate = null; // Since this is conceptually a new fiber, schedule a Placement effect

    workInProgress.flags |= Placement;
  } // Promote the fiber to a class and try rendering again.


  workInProgress.tag = ClassComponent; // The rest of this function is a fork of `updateClassComponent`
  // Push context providers early to prevent context stack mismatches.
  // During mounting we don't know the child context yet as the instance doesn't exist.
  // We will invalidate the child context in finishClassComponent() right after rendering.

  var hasContext;

  if (isContextProvider(Component)) {
    hasContext = true;
    pushContextProvider(workInProgress);
  } else {
    hasContext = false;
  }

  prepareToReadContext(workInProgress, renderLanes);
  constructClassInstance(workInProgress, Component, nextProps);
  mountClassInstance(workInProgress, Component, nextProps, renderLanes);
  return finishClassComponent(null, workInProgress, Component, true, hasContext, renderLanes);
}

function mountIndeterminateComponent(_current, workInProgress, Component, renderLanes) {
  if (_current !== null) {
    // An indeterminate component only mounts if it suspended inside a non-
    // concurrent tree, in an inconsistent state. We want to treat it like
    // a new mount, even though an empty version of it already committed.
    // Disconnect the alternate pointers.
    _current.alternate = null;
    workInProgress.alternate = null; // Since this is conceptually a new fiber, schedule a Placement effect

    workInProgress.flags |= Placement;
  }

  var props = workInProgress.pendingProps;
  var context;

  {
    var unmaskedContext = getUnmaskedContext(workInProgress, Component, false);
    context = getMaskedContext(workInProgress, unmaskedContext);
  }

  prepareToReadContext(workInProgress, renderLanes);
  var value;

  {
    if (Component.prototype && typeof Component.prototype.render === 'function') {
      var componentName = getComponentName(Component) || 'Unknown';

      if (!didWarnAboutBadClass[componentName]) {
        error("The <%s /> component appears to have a render method, but doesn't extend React.Component. " + 'This is likely to cause errors. Change %s to extend React.Component instead.', componentName, componentName);

        didWarnAboutBadClass[componentName] = true;
      }
    }

    if (workInProgress.mode & StrictMode) {
      ReactStrictModeWarnings.recordLegacyContextWarning(workInProgress, null);
    }

    setIsRendering(true);
    ReactCurrentOwner$1.current = workInProgress;
    value = renderWithHooks(null, workInProgress, Component, props, context, renderLanes);
    setIsRendering(false);
  } // React DevTools reads this flag.


  workInProgress.flags |= PerformedWork;

  {
    // Support for module components is deprecated and is removed behind a flag.
    // Whether or not it would crash later, we want to show a good message in DEV first.
    if (typeof value === 'object' && value !== null && typeof value.render === 'function' && value.$$typeof === undefined) {
      var _componentName = getComponentName(Component) || 'Unknown';

      if (!didWarnAboutModulePatternComponent[_componentName]) {
        error('The <%s /> component appears to be a function component that returns a class instance. ' + 'Change %s to a class that extends React.Component instead. ' + "If you can't use a class try assigning the prototype on the function as a workaround. " + "`%s.prototype = React.Component.prototype`. Don't use an arrow function since it " + 'cannot be called with `new` by React.', _componentName, _componentName, _componentName);

        didWarnAboutModulePatternComponent[_componentName] = true;
      }
    }
  }

  if ( // Run these checks in production only if the flag is off.
  // Eventually we'll delete this branch altogether.
   typeof value === 'object' && value !== null && typeof value.render === 'function' && value.$$typeof === undefined) {
    {
      var _componentName2 = getComponentName(Component) || 'Unknown';

      if (!didWarnAboutModulePatternComponent[_componentName2]) {
        error('The <%s /> component appears to be a function component that returns a class instance. ' + 'Change %s to a class that extends React.Component instead. ' + "If you can't use a class try assigning the prototype on the function as a workaround. " + "`%s.prototype = React.Component.prototype`. Don't use an arrow function since it " + 'cannot be called with `new` by React.', _componentName2, _componentName2, _componentName2);

        didWarnAboutModulePatternComponent[_componentName2] = true;
      }
    } // Proceed under the assumption that this is a class instance


    workInProgress.tag = ClassComponent; // Throw out any hooks that were used.

    workInProgress.memoizedState = null;
    workInProgress.updateQueue = null; // Push context providers early to prevent context stack mismatches.
    // During mounting we don't know the child context yet as the instance doesn't exist.
    // We will invalidate the child context in finishClassComponent() right after rendering.

    var hasContext = false;

    if (isContextProvider(Component)) {
      hasContext = true;
      pushContextProvider(workInProgress);
    } else {
      hasContext = false;
    }

    workInProgress.memoizedState = value.state !== null && value.state !== undefined ? value.state : null;
    initializeUpdateQueue(workInProgress);
    var getDerivedStateFromProps = Component.getDerivedStateFromProps;

    if (typeof getDerivedStateFromProps === 'function') {
      applyDerivedStateFromProps(workInProgress, Component, getDerivedStateFromProps, props);
    }

    adoptClassInstance(workInProgress, value);
    mountClassInstance(workInProgress, Component, props, renderLanes);
    return finishClassComponent(null, workInProgress, Component, true, hasContext, renderLanes);
  } else {
    // Proceed under the assumption that this is a function component
    workInProgress.tag = FunctionComponent;

    {

      if ( workInProgress.mode & StrictMode) {
        disableLogs();

        try {
          value = renderWithHooks(null, workInProgress, Component, props, context, renderLanes);
        } finally {
          reenableLogs();
        }
      }
    }

    reconcileChildren(null, workInProgress, value, renderLanes);

    {
      validateFunctionComponentInDev(workInProgress, Component);
    }

    return workInProgress.child;
  }
}

function validateFunctionComponentInDev(workInProgress, Component) {
  {
    if (Component) {
      if (Component.childContextTypes) {
        error('%s(...): childContextTypes cannot be defined on a function component.', Component.displayName || Component.name || 'Component');
      }
    }

    if (workInProgress.ref !== null) {
      var info = '';
      var ownerName = getCurrentFiberOwnerNameInDevOrNull();

      if (ownerName) {
        info += '\n\nCheck the render method of `' + ownerName + '`.';
      }

      var warningKey = ownerName || workInProgress._debugID || '';
      var debugSource = workInProgress._debugSource;

      if (debugSource) {
        warningKey = debugSource.fileName + ':' + debugSource.lineNumber;
      }

      if (!didWarnAboutFunctionRefs[warningKey]) {
        didWarnAboutFunctionRefs[warningKey] = true;

        error('Function components cannot be given refs. ' + 'Attempts to access this ref will fail. ' + 'Did you mean to use React.forwardRef()?%s', info);
      }
    }

    if (typeof Component.getDerivedStateFromProps === 'function') {
      var _componentName3 = getComponentName(Component) || 'Unknown';

      if (!didWarnAboutGetDerivedStateOnFunctionComponent[_componentName3]) {
        error('%s: Function components do not support getDerivedStateFromProps.', _componentName3);

        didWarnAboutGetDerivedStateOnFunctionComponent[_componentName3] = true;
      }
    }

    if (typeof Component.contextType === 'object' && Component.contextType !== null) {
      var _componentName4 = getComponentName(Component) || 'Unknown';

      if (!didWarnAboutContextTypeOnFunctionComponent[_componentName4]) {
        error('%s: Function components do not support contextType.', _componentName4);

        didWarnAboutContextTypeOnFunctionComponent[_componentName4] = true;
      }
    }
  }
}

var SUSPENDED_MARKER = {
  dehydrated: null,
  retryLane: NoLane
};

function mountSuspenseOffscreenState(renderLanes) {
  return {
    baseLanes: renderLanes
  };
}

function updateSuspenseOffscreenState(prevOffscreenState, renderLanes) {
  return {
    baseLanes: mergeLanes(prevOffscreenState.baseLanes, renderLanes)
  };
} // TODO: Probably should inline this back


function shouldRemainOnFallback(suspenseContext, current, workInProgress, renderLanes) {
  // If we're already showing a fallback, there are cases where we need to
  // remain on that fallback regardless of whether the content has resolved.
  // For example, SuspenseList coordinates when nested content appears.
  if (current !== null) {
    var suspenseState = current.memoizedState;

    if (suspenseState === null) {
      // Currently showing content. Don't hide it, even if ForceSuspenseFallack
      // is true. More precise name might be "ForceRemainSuspenseFallback".
      // Note: This is a factoring smell. Can't remain on a fallback if there's
      // no fallback to remain on.
      return false;
    }
  } // Not currently showing content. Consult the Suspense context.


  return hasSuspenseContext(suspenseContext, ForceSuspenseFallback);
}

function getRemainingWorkInPrimaryTree(current, renderLanes) {
  // TODO: Should not remove render lanes that were pinged during this render
  return removeLanes(current.childLanes, renderLanes);
}

function updateSuspenseComponent(current, workInProgress, renderLanes) {
  var nextProps = workInProgress.pendingProps; // This is used by DevTools to force a boundary to suspend.

  {
    if (shouldSuspend(workInProgress)) {
      workInProgress.flags |= DidCapture;
    }
  }

  var suspenseContext = suspenseStackCursor.current;
  var showFallback = false;
  var didSuspend = (workInProgress.flags & DidCapture) !== NoFlags;

  if (didSuspend || shouldRemainOnFallback(suspenseContext, current)) {
    // Something in this boundary's subtree already suspended. Switch to
    // rendering the fallback children.
    showFallback = true;
    workInProgress.flags &= ~DidCapture;
  } else {
    // Attempting the main content
    if (current === null || current.memoizedState !== null) {
      // This is a new mount or this boundary is already showing a fallback state.
      // Mark this subtree context as having at least one invisible parent that could
      // handle the fallback state.
      // Boundaries without fallbacks or should be avoided are not considered since
      // they cannot handle preferred fallback states.
      if (nextProps.fallback !== undefined && nextProps.unstable_avoidThisFallback !== true) {
        suspenseContext = addSubtreeSuspenseContext(suspenseContext, InvisibleParentSuspenseContext);
      }
    }
  }

  suspenseContext = setDefaultShallowSuspenseContext(suspenseContext);
  pushSuspenseContext(workInProgress, suspenseContext); // OK, the next part is confusing. We're about to reconcile the Suspense
  // boundary's children. This involves some custom reconcilation logic. Two
  // main reasons this is so complicated.
  //
  // First, Legacy Mode has different semantics for backwards compatibility. The
  // primary tree will commit in an inconsistent state, so when we do the
  // second pass to render the fallback, we do some exceedingly, uh, clever
  // hacks to make that not totally break. Like transferring effects and
  // deletions from hidden tree. In Concurrent Mode, it's much simpler,
  // because we bailout on the primary tree completely and leave it in its old
  // state, no effects. Same as what we do for Offscreen (except that
  // Offscreen doesn't have the first render pass).
  //
  // Second is hydration. During hydration, the Suspense fiber has a slightly
  // different layout, where the child points to a dehydrated fragment, which
  // contains the DOM rendered by the server.
  //
  // Third, even if you set all that aside, Suspense is like error boundaries in
  // that we first we try to render one tree, and if that fails, we render again
  // and switch to a different tree. Like a try/catch block. So we have to track
  // which branch we're currently rendering. Ideally we would model this using
  // a stack.

  if (current === null) {
    // Initial mount
    // If we're currently hydrating, try to hydrate this boundary.
    // But only if this has a fallback.
    if (nextProps.fallback !== undefined) {
      tryToClaimNextHydratableInstance(workInProgress); // This could've been a dehydrated suspense component.
    }

    var nextPrimaryChildren = nextProps.children;
    var nextFallbackChildren = nextProps.fallback;

    if (showFallback) {
      var fallbackFragment = mountSuspenseFallbackChildren(workInProgress, nextPrimaryChildren, nextFallbackChildren, renderLanes);
      var primaryChildFragment = workInProgress.child;
      primaryChildFragment.memoizedState = mountSuspenseOffscreenState(renderLanes);
      workInProgress.memoizedState = SUSPENDED_MARKER;
      return fallbackFragment;
    } else if (typeof nextProps.unstable_expectedLoadTime === 'number') {
      // This is a CPU-bound tree. Skip this tree and show a placeholder to
      // unblock the surrounding content. Then immediately retry after the
      // initial commit.
      var _fallbackFragment = mountSuspenseFallbackChildren(workInProgress, nextPrimaryChildren, nextFallbackChildren, renderLanes);

      var _primaryChildFragment = workInProgress.child;
      _primaryChildFragment.memoizedState = mountSuspenseOffscreenState(renderLanes);
      workInProgress.memoizedState = SUSPENDED_MARKER; // Since nothing actually suspended, there will nothing to ping this to
      // get it started back up to attempt the next item. While in terms of
      // priority this work has the same priority as this current render, it's
      // not part of the same transition once the transition has committed. If
      // it's sync, we still want to yield so that it can be painted.
      // Conceptually, this is really the same as pinging. We can use any
      // RetryLane even if it's the one currently rendering since we're leaving
      // it behind on this node.

      workInProgress.lanes = SomeRetryLane;

      {
        markSpawnedWork(SomeRetryLane);
      }

      return _fallbackFragment;
    } else {
      return mountSuspensePrimaryChildren(workInProgress, nextPrimaryChildren, renderLanes);
    }
  } else {
    // This is an update.
    // If the current fiber has a SuspenseState, that means it's already showing
    // a fallback.
    var prevState = current.memoizedState;

    if (prevState !== null) {

      if (showFallback) {
        var _nextFallbackChildren2 = nextProps.fallback;
        var _nextPrimaryChildren2 = nextProps.children;

        var _fallbackChildFragment = updateSuspenseFallbackChildren(current, workInProgress, _nextPrimaryChildren2, _nextFallbackChildren2, renderLanes);

        var _primaryChildFragment3 = workInProgress.child;
        var prevOffscreenState = current.child.memoizedState;
        _primaryChildFragment3.memoizedState = prevOffscreenState === null ? mountSuspenseOffscreenState(renderLanes) : updateSuspenseOffscreenState(prevOffscreenState, renderLanes);
        _primaryChildFragment3.childLanes = getRemainingWorkInPrimaryTree(current, renderLanes);
        workInProgress.memoizedState = SUSPENDED_MARKER;
        return _fallbackChildFragment;
      } else {
        var _nextPrimaryChildren3 = nextProps.children;

        var _primaryChildFragment4 = updateSuspensePrimaryChildren(current, workInProgress, _nextPrimaryChildren3, renderLanes);

        workInProgress.memoizedState = null;
        return _primaryChildFragment4;
      }
    } else {
      // The current tree is not already showing a fallback.
      if (showFallback) {
        // Timed out.
        var _nextFallbackChildren3 = nextProps.fallback;
        var _nextPrimaryChildren4 = nextProps.children;

        var _fallbackChildFragment2 = updateSuspenseFallbackChildren(current, workInProgress, _nextPrimaryChildren4, _nextFallbackChildren3, renderLanes);

        var _primaryChildFragment5 = workInProgress.child;
        var _prevOffscreenState = current.child.memoizedState;
        _primaryChildFragment5.memoizedState = _prevOffscreenState === null ? mountSuspenseOffscreenState(renderLanes) : updateSuspenseOffscreenState(_prevOffscreenState, renderLanes);
        _primaryChildFragment5.childLanes = getRemainingWorkInPrimaryTree(current, renderLanes); // Skip the primary children, and continue working on the
        // fallback children.

        workInProgress.memoizedState = SUSPENDED_MARKER;
        return _fallbackChildFragment2;
      } else {
        // Still haven't timed out. Continue rendering the children, like we
        // normally do.
        var _nextPrimaryChildren5 = nextProps.children;

        var _primaryChildFragment6 = updateSuspensePrimaryChildren(current, workInProgress, _nextPrimaryChildren5, renderLanes);

        workInProgress.memoizedState = null;
        return _primaryChildFragment6;
      }
    }
  }
}

function mountSuspensePrimaryChildren(workInProgress, primaryChildren, renderLanes) {
  var mode = workInProgress.mode;
  var primaryChildProps = {
    mode: 'visible',
    children: primaryChildren
  };
  var primaryChildFragment = createFiberFromOffscreen(primaryChildProps, mode, renderLanes, null);
  primaryChildFragment.return = workInProgress;
  workInProgress.child = primaryChildFragment;
  return primaryChildFragment;
}

function mountSuspenseFallbackChildren(workInProgress, primaryChildren, fallbackChildren, renderLanes) {
  var mode = workInProgress.mode;
  var progressedPrimaryFragment = workInProgress.child;
  var primaryChildProps = {
    mode: 'hidden',
    children: primaryChildren
  };
  var primaryChildFragment;
  var fallbackChildFragment;

  if ((mode & BlockingMode) === NoMode && progressedPrimaryFragment !== null) {
    // In legacy mode, we commit the primary tree as if it successfully
    // completed, even though it's in an inconsistent state.
    primaryChildFragment = progressedPrimaryFragment;
    primaryChildFragment.childLanes = NoLanes;
    primaryChildFragment.pendingProps = primaryChildProps;

    if ( workInProgress.mode & ProfileMode) {
      // Reset the durations from the first pass so they aren't included in the
      // final amounts. This seems counterintuitive, since we're intentionally
      // not measuring part of the render phase, but this makes it match what we
      // do in Concurrent Mode.
      primaryChildFragment.actualDuration = 0;
      primaryChildFragment.actualStartTime = -1;
      primaryChildFragment.selfBaseDuration = 0;
      primaryChildFragment.treeBaseDuration = 0;
    }

    fallbackChildFragment = createFiberFromFragment(fallbackChildren, mode, renderLanes, null);
  } else {
    primaryChildFragment = createFiberFromOffscreen(primaryChildProps, mode, NoLanes, null);
    fallbackChildFragment = createFiberFromFragment(fallbackChildren, mode, renderLanes, null);
  }

  primaryChildFragment.return = workInProgress;
  fallbackChildFragment.return = workInProgress;
  primaryChildFragment.sibling = fallbackChildFragment;
  workInProgress.child = primaryChildFragment;
  return fallbackChildFragment;
}

function createWorkInProgressOffscreenFiber(current, offscreenProps) {
  // The props argument to `createWorkInProgress` is `any` typed, so we use this
  // wrapper function to constrain it.
  return createWorkInProgress(current, offscreenProps);
}

function updateSuspensePrimaryChildren(current, workInProgress, primaryChildren, renderLanes) {
  var currentPrimaryChildFragment = current.child;
  var currentFallbackChildFragment = currentPrimaryChildFragment.sibling;
  var primaryChildFragment = createWorkInProgressOffscreenFiber(currentPrimaryChildFragment, {
    mode: 'visible',
    children: primaryChildren
  });

  if ((workInProgress.mode & BlockingMode) === NoMode) {
    primaryChildFragment.lanes = renderLanes;
  }

  primaryChildFragment.return = workInProgress;
  primaryChildFragment.sibling = null;

  if (currentFallbackChildFragment !== null) {
    // Delete the fallback child fragment
    currentFallbackChildFragment.nextEffect = null;
    currentFallbackChildFragment.flags = Deletion;
    workInProgress.firstEffect = workInProgress.lastEffect = currentFallbackChildFragment;
  }

  workInProgress.child = primaryChildFragment;
  return primaryChildFragment;
}

function updateSuspenseFallbackChildren(current, workInProgress, primaryChildren, fallbackChildren, renderLanes) {
  var mode = workInProgress.mode;
  var currentPrimaryChildFragment = current.child;
  var currentFallbackChildFragment = currentPrimaryChildFragment.sibling;
  var primaryChildProps = {
    mode: 'hidden',
    children: primaryChildren
  };
  var primaryChildFragment;

  if ( // In legacy mode, we commit the primary tree as if it successfully
  // completed, even though it's in an inconsistent state.
  (mode & BlockingMode) === NoMode && // Make sure we're on the second pass, i.e. the primary child fragment was
  // already cloned. In legacy mode, the only case where this isn't true is
  // when DevTools forces us to display a fallback; we skip the first render
  // pass entirely and go straight to rendering the fallback. (In Concurrent
  // Mode, SuspenseList can also trigger this scenario, but this is a legacy-
  // only codepath.)
  workInProgress.child !== currentPrimaryChildFragment) {
    var progressedPrimaryFragment = workInProgress.child;
    primaryChildFragment = progressedPrimaryFragment;
    primaryChildFragment.childLanes = NoLanes;
    primaryChildFragment.pendingProps = primaryChildProps;

    if ( workInProgress.mode & ProfileMode) {
      // Reset the durations from the first pass so they aren't included in the
      // final amounts. This seems counterintuitive, since we're intentionally
      // not measuring part of the render phase, but this makes it match what we
      // do in Concurrent Mode.
      primaryChildFragment.actualDuration = 0;
      primaryChildFragment.actualStartTime = -1;
      primaryChildFragment.selfBaseDuration = currentPrimaryChildFragment.selfBaseDuration;
      primaryChildFragment.treeBaseDuration = currentPrimaryChildFragment.treeBaseDuration;
    } // The fallback fiber was added as a deletion effect during the first pass.
    // However, since we're going to remain on the fallback, we no longer want
    // to delete it. So we need to remove it from the list. Deletions are stored
    // on the same list as effects. We want to keep the effects from the primary
    // tree. So we copy the primary child fragment's effect list, which does not
    // include the fallback deletion effect.


    var progressedLastEffect = primaryChildFragment.lastEffect;

    if (progressedLastEffect !== null) {
      workInProgress.firstEffect = primaryChildFragment.firstEffect;
      workInProgress.lastEffect = progressedLastEffect;
      progressedLastEffect.nextEffect = null;
    } else {
      // TODO: Reset this somewhere else? Lol legacy mode is so weird.
      workInProgress.firstEffect = workInProgress.lastEffect = null;
    }
  } else {
    primaryChildFragment = createWorkInProgressOffscreenFiber(currentPrimaryChildFragment, primaryChildProps);
  }

  var fallbackChildFragment;

  if (currentFallbackChildFragment !== null) {
    fallbackChildFragment = createWorkInProgress(currentFallbackChildFragment, fallbackChildren);
  } else {
    fallbackChildFragment = createFiberFromFragment(fallbackChildren, mode, renderLanes, null); // Needs a placement effect because the parent (the Suspense boundary) already
    // mounted but this is a new fiber.

    fallbackChildFragment.flags |= Placement;
  }

  fallbackChildFragment.return = workInProgress;
  primaryChildFragment.return = workInProgress;
  primaryChildFragment.sibling = fallbackChildFragment;
  workInProgress.child = primaryChildFragment;
  return fallbackChildFragment;
}

function scheduleWorkOnFiber(fiber, renderLanes) {
  fiber.lanes = mergeLanes(fiber.lanes, renderLanes);
  var alternate = fiber.alternate;

  if (alternate !== null) {
    alternate.lanes = mergeLanes(alternate.lanes, renderLanes);
  }

  scheduleWorkOnParentPath(fiber.return, renderLanes);
}

function propagateSuspenseContextChange(workInProgress, firstChild, renderLanes) {
  // Mark any Suspense boundaries with fallbacks as having work to do.
  // If they were previously forced into fallbacks, they may now be able
  // to unblock.
  var node = firstChild;

  while (node !== null) {
    if (node.tag === SuspenseComponent) {
      var state = node.memoizedState;

      if (state !== null) {
        scheduleWorkOnFiber(node, renderLanes);
      }
    } else if (node.tag === SuspenseListComponent) {
      // If the tail is hidden there might not be an Suspense boundaries
      // to schedule work on. In this case we have to schedule it on the
      // list itself.
      // We don't have to traverse to the children of the list since
      // the list will propagate the change when it rerenders.
      scheduleWorkOnFiber(node, renderLanes);
    } else if (node.child !== null) {
      node.child.return = node;
      node = node.child;
      continue;
    }

    if (node === workInProgress) {
      return;
    }

    while (node.sibling === null) {
      if (node.return === null || node.return === workInProgress) {
        return;
      }

      node = node.return;
    }

    node.sibling.return = node.return;
    node = node.sibling;
  }
}

function findLastContentRow(firstChild) {
  // This is going to find the last row among these children that is already
  // showing content on the screen, as opposed to being in fallback state or
  // new. If a row has multiple Suspense boundaries, any of them being in the
  // fallback state, counts as the whole row being in a fallback state.
  // Note that the "rows" will be workInProgress, but any nested children
  // will still be current since we haven't rendered them yet. The mounted
  // order may not be the same as the new order. We use the new order.
  var row = firstChild;
  var lastContentRow = null;

  while (row !== null) {
    var currentRow = row.alternate; // New rows can't be content rows.

    if (currentRow !== null && findFirstSuspended(currentRow) === null) {
      lastContentRow = row;
    }

    row = row.sibling;
  }

  return lastContentRow;
}

function validateRevealOrder(revealOrder) {
  {
    if (revealOrder !== undefined && revealOrder !== 'forwards' && revealOrder !== 'backwards' && revealOrder !== 'together' && !didWarnAboutRevealOrder[revealOrder]) {
      didWarnAboutRevealOrder[revealOrder] = true;

      if (typeof revealOrder === 'string') {
        switch (revealOrder.toLowerCase()) {
          case 'together':
          case 'forwards':
          case 'backwards':
            {
              error('"%s" is not a valid value for revealOrder on <SuspenseList />. ' + 'Use lowercase "%s" instead.', revealOrder, revealOrder.toLowerCase());

              break;
            }

          case 'forward':
          case 'backward':
            {
              error('"%s" is not a valid value for revealOrder on <SuspenseList />. ' + 'React uses the -s suffix in the spelling. Use "%ss" instead.', revealOrder, revealOrder.toLowerCase());

              break;
            }

          default:
            error('"%s" is not a supported revealOrder on <SuspenseList />. ' + 'Did you mean "together", "forwards" or "backwards"?', revealOrder);

            break;
        }
      } else {
        error('%s is not a supported value for revealOrder on <SuspenseList />. ' + 'Did you mean "together", "forwards" or "backwards"?', revealOrder);
      }
    }
  }
}

function validateTailOptions(tailMode, revealOrder) {
  {
    if (tailMode !== undefined && !didWarnAboutTailOptions[tailMode]) {
      if (tailMode !== 'collapsed' && tailMode !== 'hidden') {
        didWarnAboutTailOptions[tailMode] = true;

        error('"%s" is not a supported value for tail on <SuspenseList />. ' + 'Did you mean "collapsed" or "hidden"?', tailMode);
      } else if (revealOrder !== 'forwards' && revealOrder !== 'backwards') {
        didWarnAboutTailOptions[tailMode] = true;

        error('<SuspenseList tail="%s" /> is only valid if revealOrder is ' + '"forwards" or "backwards". ' + 'Did you mean to specify revealOrder="forwards"?', tailMode);
      }
    }
  }
}

function validateSuspenseListNestedChild(childSlot, index) {
  {
    var isArray = Array.isArray(childSlot);
    var isIterable = !isArray && typeof getIteratorFn(childSlot) === 'function';

    if (isArray || isIterable) {
      var type = isArray ? 'array' : 'iterable';

      error('A nested %s was passed to row #%s in <SuspenseList />. Wrap it in ' + 'an additional SuspenseList to configure its revealOrder: ' + '<SuspenseList revealOrder=...> ... ' + '<SuspenseList revealOrder=...>{%s}</SuspenseList> ... ' + '</SuspenseList>', type, index, type);

      return false;
    }
  }

  return true;
}

function validateSuspenseListChildren(children, revealOrder) {
  {
    if ((revealOrder === 'forwards' || revealOrder === 'backwards') && children !== undefined && children !== null && children !== false) {
      if (Array.isArray(children)) {
        for (var i = 0; i < children.length; i++) {
          if (!validateSuspenseListNestedChild(children[i], i)) {
            return;
          }
        }
      } else {
        var iteratorFn = getIteratorFn(children);

        if (typeof iteratorFn === 'function') {
          var childrenIterator = iteratorFn.call(children);

          if (childrenIterator) {
            var step = childrenIterator.next();
            var _i = 0;

            for (; !step.done; step = childrenIterator.next()) {
              if (!validateSuspenseListNestedChild(step.value, _i)) {
                return;
              }

              _i++;
            }
          }
        } else {
          error('A single row was passed to a <SuspenseList revealOrder="%s" />. ' + 'This is not useful since it needs multiple rows. ' + 'Did you mean to pass multiple children or an array?', revealOrder);
        }
      }
    }
  }
}

function initSuspenseListRenderState(workInProgress, isBackwards, tail, lastContentRow, tailMode, lastEffectBeforeRendering) {
  var renderState = workInProgress.memoizedState;

  if (renderState === null) {
    workInProgress.memoizedState = {
      isBackwards: isBackwards,
      rendering: null,
      renderingStartTime: 0,
      last: lastContentRow,
      tail: tail,
      tailMode: tailMode,
      lastEffect: lastEffectBeforeRendering
    };
  } else {
    // We can reuse the existing object from previous renders.
    renderState.isBackwards = isBackwards;
    renderState.rendering = null;
    renderState.renderingStartTime = 0;
    renderState.last = lastContentRow;
    renderState.tail = tail;
    renderState.tailMode = tailMode;
    renderState.lastEffect = lastEffectBeforeRendering;
  }
} // This can end up rendering this component multiple passes.
// The first pass splits the children fibers into two sets. A head and tail.
// We first render the head. If anything is in fallback state, we do another
// pass through beginWork to rerender all children (including the tail) with
// the force suspend context. If the first render didn't have anything in
// in fallback state. Then we render each row in the tail one-by-one.
// That happens in the completeWork phase without going back to beginWork.


function updateSuspenseListComponent(current, workInProgress, renderLanes) {
  var nextProps = workInProgress.pendingProps;
  var revealOrder = nextProps.revealOrder;
  var tailMode = nextProps.tail;
  var newChildren = nextProps.children;
  validateRevealOrder(revealOrder);
  validateTailOptions(tailMode, revealOrder);
  validateSuspenseListChildren(newChildren, revealOrder);
  reconcileChildren(current, workInProgress, newChildren, renderLanes);
  var suspenseContext = suspenseStackCursor.current;
  var shouldForceFallback = hasSuspenseContext(suspenseContext, ForceSuspenseFallback);

  if (shouldForceFallback) {
    suspenseContext = setShallowSuspenseContext(suspenseContext, ForceSuspenseFallback);
    workInProgress.flags |= DidCapture;
  } else {
    var didSuspendBefore = current !== null && (current.flags & DidCapture) !== NoFlags;

    if (didSuspendBefore) {
      // If we previously forced a fallback, we need to schedule work
      // on any nested boundaries to let them know to try to render
      // again. This is the same as context updating.
      propagateSuspenseContextChange(workInProgress, workInProgress.child, renderLanes);
    }

    suspenseContext = setDefaultShallowSuspenseContext(suspenseContext);
  }

  pushSuspenseContext(workInProgress, suspenseContext);

  if ((workInProgress.mode & BlockingMode) === NoMode) {
    // In legacy mode, SuspenseList doesn't work so we just
    // use make it a noop by treating it as the default revealOrder.
    workInProgress.memoizedState = null;
  } else {
    switch (revealOrder) {
      case 'forwards':
        {
          var lastContentRow = findLastContentRow(workInProgress.child);
          var tail;

          if (lastContentRow === null) {
            // The whole list is part of the tail.
            // TODO: We could fast path by just rendering the tail now.
            tail = workInProgress.child;
            workInProgress.child = null;
          } else {
            // Disconnect the tail rows after the content row.
            // We're going to render them separately later.
            tail = lastContentRow.sibling;
            lastContentRow.sibling = null;
          }

          initSuspenseListRenderState(workInProgress, false, // isBackwards
          tail, lastContentRow, tailMode, workInProgress.lastEffect);
          break;
        }

      case 'backwards':
        {
          // We're going to find the first row that has existing content.
          // At the same time we're going to reverse the list of everything
          // we pass in the meantime. That's going to be our tail in reverse
          // order.
          var _tail = null;
          var row = workInProgress.child;
          workInProgress.child = null;

          while (row !== null) {
            var currentRow = row.alternate; // New rows can't be content rows.

            if (currentRow !== null && findFirstSuspended(currentRow) === null) {
              // This is the beginning of the main content.
              workInProgress.child = row;
              break;
            }

            var nextRow = row.sibling;
            row.sibling = _tail;
            _tail = row;
            row = nextRow;
          } // TODO: If workInProgress.child is null, we can continue on the tail immediately.


          initSuspenseListRenderState(workInProgress, true, // isBackwards
          _tail, null, // last
          tailMode, workInProgress.lastEffect);
          break;
        }

      case 'together':
        {
          initSuspenseListRenderState(workInProgress, false, // isBackwards
          null, // tail
          null, // last
          undefined, workInProgress.lastEffect);
          break;
        }

      default:
        {
          // The default reveal order is the same as not having
          // a boundary.
          workInProgress.memoizedState = null;
        }
    }
  }

  return workInProgress.child;
}

function updatePortalComponent(current, workInProgress, renderLanes) {
  pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo);
  var nextChildren = workInProgress.pendingProps;

  if (current === null) {
    // Portals are special because we don't append the children during mount
    // but at commit. Therefore we need to track insertions which the normal
    // flow doesn't do during mount. This doesn't happen at the root because
    // the root always starts with a "current" with a null child.
    // TODO: Consider unifying this with how the root works.
    workInProgress.child = reconcileChildFibers(workInProgress, null, nextChildren, renderLanes);
  } else {
    reconcileChildren(current, workInProgress, nextChildren, renderLanes);
  }

  return workInProgress.child;
}

var hasWarnedAboutUsingNoValuePropOnContextProvider = false;

function updateContextProvider(current, workInProgress, renderLanes) {
  var providerType = workInProgress.type;
  var context = providerType._context;
  var newProps = workInProgress.pendingProps;
  var oldProps = workInProgress.memoizedProps;
  var newValue = newProps.value;

  {
    if (!('value' in newProps)) {
      if (!hasWarnedAboutUsingNoValuePropOnContextProvider) {
        hasWarnedAboutUsingNoValuePropOnContextProvider = true;

        error('The `value` prop is required for the `<Context.Provider>`. Did you misspell it or forget to pass it?');
      }
    }

    var providerPropTypes = workInProgress.type.propTypes;

    if (providerPropTypes) {
      checkPropTypes(providerPropTypes, newProps, 'prop', 'Context.Provider');
    }
  }

  pushProvider(workInProgress, newValue);

  if (oldProps !== null) {
    var oldValue = oldProps.value;
    var changedBits = calculateChangedBits(context, newValue, oldValue);

    if (changedBits === 0) {
      // No change. Bailout early if children are the same.
      if (oldProps.children === newProps.children && !hasContextChanged()) {
        return bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
      }
    } else {
      // The context value changed. Search for matching consumers and schedule
      // them to update.
      propagateContextChange(workInProgress, context, changedBits, renderLanes);
    }
  }

  var newChildren = newProps.children;
  reconcileChildren(current, workInProgress, newChildren, renderLanes);
  return workInProgress.child;
}

var hasWarnedAboutUsingContextAsConsumer = false;

function updateContextConsumer(current, workInProgress, renderLanes) {
  var context = workInProgress.type; // The logic below for Context differs depending on PROD or DEV mode. In
  // DEV mode, we create a separate object for Context.Consumer that acts
  // like a proxy to Context. This proxy object adds unnecessary code in PROD
  // so we use the old behaviour (Context.Consumer references Context) to
  // reduce size and overhead. The separate object references context via
  // a property called "_context", which also gives us the ability to check
  // in DEV mode if this property exists or not and warn if it does not.

  {
    if (context._context === undefined) {
      // This may be because it's a Context (rather than a Consumer).
      // Or it may be because it's older React where they're the same thing.
      // We only want to warn if we're sure it's a new React.
      if (context !== context.Consumer) {
        if (!hasWarnedAboutUsingContextAsConsumer) {
          hasWarnedAboutUsingContextAsConsumer = true;

          error('Rendering <Context> directly is not supported and will be removed in ' + 'a future major release. Did you mean to render <Context.Consumer> instead?');
        }
      }
    } else {
      context = context._context;
    }
  }

  var newProps = workInProgress.pendingProps;
  var render = newProps.children;

  {
    if (typeof render !== 'function') {
      error('A context consumer was rendered with multiple children, or a child ' + "that isn't a function. A context consumer expects a single child " + 'that is a function. If you did pass a function, make sure there ' + 'is no trailing or leading whitespace around it.');
    }
  }

  prepareToReadContext(workInProgress, renderLanes);
  var newValue = readContext(context, newProps.unstable_observedBits);
  var newChildren;

  {
    ReactCurrentOwner$1.current = workInProgress;
    setIsRendering(true);
    newChildren = render(newValue);
    setIsRendering(false);
  } // React DevTools reads this flag.


  workInProgress.flags |= PerformedWork;
  reconcileChildren(current, workInProgress, newChildren, renderLanes);
  return workInProgress.child;
}

function markWorkInProgressReceivedUpdate() {
  didReceiveUpdate = true;
}

function bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes) {
  if (current !== null) {
    // Reuse previous dependencies
    workInProgress.dependencies = current.dependencies;
  }

  {
    // Don't update "base" render times for bailouts.
    stopProfilerTimerIfRunning();
  }

  markSkippedUpdateLanes(workInProgress.lanes); // Check if the children have any pending work.

  if (!includesSomeLane(renderLanes, workInProgress.childLanes)) {
    // The children don't have any work either. We can skip them.
    // TODO: Once we add back resuming, we should check if the children are
    // a work-in-progress set. If so, we need to transfer their effects.
    return null;
  } else {
    // This fiber doesn't have work, but its subtree does. Clone the child
    // fibers and continue.
    cloneChildFibers(current, workInProgress);
    return workInProgress.child;
  }
}

function remountFiber(current, oldWorkInProgress, newWorkInProgress) {
  {
    var returnFiber = oldWorkInProgress.return;

    if (returnFiber === null) {
      throw new Error('Cannot swap the root fiber.');
    } // Disconnect from the old current.
    // It will get deleted.


    current.alternate = null;
    oldWorkInProgress.alternate = null; // Connect to the new tree.

    newWorkInProgress.index = oldWorkInProgress.index;
    newWorkInProgress.sibling = oldWorkInProgress.sibling;
    newWorkInProgress.return = oldWorkInProgress.return;
    newWorkInProgress.ref = oldWorkInProgress.ref; // Replace the child/sibling pointers above it.

    if (oldWorkInProgress === returnFiber.child) {
      returnFiber.child = newWorkInProgress;
    } else {
      var prevSibling = returnFiber.child;

      if (prevSibling === null) {
        throw new Error('Expected parent to have a child.');
      }

      while (prevSibling.sibling !== oldWorkInProgress) {
        prevSibling = prevSibling.sibling;

        if (prevSibling === null) {
          throw new Error('Expected to find the previous sibling.');
        }
      }

      prevSibling.sibling = newWorkInProgress;
    } // Delete the old fiber and place the new one.
    // Since the old fiber is disconnected, we have to schedule it manually.


    var last = returnFiber.lastEffect;

    if (last !== null) {
      last.nextEffect = current;
      returnFiber.lastEffect = current;
    } else {
      returnFiber.firstEffect = returnFiber.lastEffect = current;
    }

    current.nextEffect = null;
    current.flags = Deletion;
    newWorkInProgress.flags |= Placement; // Restart work from the new fiber.

    return newWorkInProgress;
  }
}

function beginWork(current, workInProgress, renderLanes) {
  var updateLanes = workInProgress.lanes;

  {
    if (workInProgress._debugNeedsRemount && current !== null) {
      // This will restart the begin phase with a new fiber.
      return remountFiber(current, workInProgress, createFiberFromTypeAndProps(workInProgress.type, workInProgress.key, workInProgress.pendingProps, workInProgress._debugOwner || null, workInProgress.mode, workInProgress.lanes));
    }
  }

  if (current !== null) {
    var oldProps = current.memoizedProps;
    var newProps = workInProgress.pendingProps;

    if (oldProps !== newProps || hasContextChanged() || ( // Force a re-render if the implementation changed due to hot reload:
     workInProgress.type !== current.type )) {
      // If props or context changed, mark the fiber as having performed work.
      // This may be unset if the props are determined to be equal later (memo).
      didReceiveUpdate = true;
    } else if (!includesSomeLane(renderLanes, updateLanes)) {
      didReceiveUpdate = false; // This fiber does not have any pending work. Bailout without entering
      // the begin phase. There's still some bookkeeping we that needs to be done
      // in this optimized path, mostly pushing stuff onto the stack.

      switch (workInProgress.tag) {
        case HostRoot:
          pushHostRootContext(workInProgress);
          resetHydrationState();
          break;

        case HostComponent:
          pushHostContext(workInProgress);
          break;

        case ClassComponent:
          {
            var Component = workInProgress.type;

            if (isContextProvider(Component)) {
              pushContextProvider(workInProgress);
            }

            break;
          }

        case HostPortal:
          pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo);
          break;

        case ContextProvider:
          {
            var newValue = workInProgress.memoizedProps.value;
            pushProvider(workInProgress, newValue);
            break;
          }

        case Profiler:
          {
            // Profiler should only call onRender when one of its descendants actually rendered.
            var hasChildWork = includesSomeLane(renderLanes, workInProgress.childLanes);

            if (hasChildWork) {
              workInProgress.flags |= Update;
            } // Reset effect durations for the next eventual effect phase.
            // These are reset during render to allow the DevTools commit hook a chance to read them,


            var stateNode = workInProgress.stateNode;
            stateNode.effectDuration = 0;
            stateNode.passiveEffectDuration = 0;
          }

          break;

        case SuspenseComponent:
          {
            var state = workInProgress.memoizedState;

            if (state !== null) {
              // whether to retry the primary children, or to skip over it and
              // go straight to the fallback. Check the priority of the primary
              // child fragment.


              var primaryChildFragment = workInProgress.child;
              var primaryChildLanes = primaryChildFragment.childLanes;

              if (includesSomeLane(renderLanes, primaryChildLanes)) {
                // The primary children have pending work. Use the normal path
                // to attempt to render the primary children again.
                return updateSuspenseComponent(current, workInProgress, renderLanes);
              } else {
                // The primary child fragment does not have pending work marked
                // on it
                pushSuspenseContext(workInProgress, setDefaultShallowSuspenseContext(suspenseStackCursor.current)); // The primary children do not have pending work with sufficient
                // priority. Bailout.

                var child = bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);

                if (child !== null) {
                  // The fallback children have pending work. Skip over the
                  // primary children and work on the fallback.
                  return child.sibling;
                } else {
                  return null;
                }
              }
            } else {
              pushSuspenseContext(workInProgress, setDefaultShallowSuspenseContext(suspenseStackCursor.current));
            }

            break;
          }

        case SuspenseListComponent:
          {
            var didSuspendBefore = (current.flags & DidCapture) !== NoFlags;

            var _hasChildWork = includesSomeLane(renderLanes, workInProgress.childLanes);

            if (didSuspendBefore) {
              if (_hasChildWork) {
                // If something was in fallback state last time, and we have all the
                // same children then we're still in progressive loading state.
                // Something might get unblocked by state updates or retries in the
                // tree which will affect the tail. So we need to use the normal
                // path to compute the correct tail.
                return updateSuspenseListComponent(current, workInProgress, renderLanes);
              } // If none of the children had any work, that means that none of
              // them got retried so they'll still be blocked in the same way
              // as before. We can fast bail out.


              workInProgress.flags |= DidCapture;
            } // If nothing suspended before and we're rendering the same children,
            // then the tail doesn't matter. Anything new that suspends will work
            // in the "together" mode, so we can continue from the state we had.


            var renderState = workInProgress.memoizedState;

            if (renderState !== null) {
              // Reset to the "together" mode in case we've started a different
              // update in the past but didn't complete it.
              renderState.rendering = null;
              renderState.tail = null;
              renderState.lastEffect = null;
            }

            pushSuspenseContext(workInProgress, suspenseStackCursor.current);

            if (_hasChildWork) {
              break;
            } else {
              // If none of the children had any work, that means that none of
              // them got retried so they'll still be blocked in the same way
              // as before. We can fast bail out.
              return null;
            }
          }

        case OffscreenComponent:
        case LegacyHiddenComponent:
          {
            // Need to check if the tree still needs to be deferred. This is
            // almost identical to the logic used in the normal update path,
            // so we'll just enter that. The only difference is we'll bail out
            // at the next level instead of this one, because the child props
            // have not changed. Which is fine.
            // TODO: Probably should refactor `beginWork` to split the bailout
            // path from the normal path. I'm tempted to do a labeled break here
            // but I won't :)
            workInProgress.lanes = NoLanes;
            return updateOffscreenComponent(current, workInProgress, renderLanes);
          }
      }

      return bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    } else {
      if ((current.flags & ForceUpdateForLegacySuspense) !== NoFlags) {
        // This is a special case that only exists for legacy mode.
        // See https://github.com/facebook/react/pull/19216.
        didReceiveUpdate = true;
      } else {
        // An update was scheduled on this fiber, but there are no new props
        // nor legacy context. Set this to false. If an update queue or context
        // consumer produces a changed value, it will set this to true. Otherwise,
        // the component will assume the children have not changed and bail out.
        didReceiveUpdate = false;
      }
    }
  } else {
    didReceiveUpdate = false;
  } // Before entering the begin phase, clear pending update priority.
  // TODO: This assumes that we're about to evaluate the component and process
  // the update queue. However, there's an exception: SimpleMemoComponent
  // sometimes bails out later in the begin phase. This indicates that we should
  // move this assignment out of the common path and into each branch.


  workInProgress.lanes = NoLanes;

  switch (workInProgress.tag) {
    case IndeterminateComponent:
      {
        return mountIndeterminateComponent(current, workInProgress, workInProgress.type, renderLanes);
      }

    case LazyComponent:
      {
        var elementType = workInProgress.elementType;
        return mountLazyComponent(current, workInProgress, elementType, updateLanes, renderLanes);
      }

    case FunctionComponent:
      {
        var _Component = workInProgress.type;
        var unresolvedProps = workInProgress.pendingProps;
        var resolvedProps = workInProgress.elementType === _Component ? unresolvedProps : resolveDefaultProps(_Component, unresolvedProps);
        return updateFunctionComponent(current, workInProgress, _Component, resolvedProps, renderLanes);
      }

    case ClassComponent:
      {
        var _Component2 = workInProgress.type;
        var _unresolvedProps = workInProgress.pendingProps;

        var _resolvedProps = workInProgress.elementType === _Component2 ? _unresolvedProps : resolveDefaultProps(_Component2, _unresolvedProps);

        return updateClassComponent(current, workInProgress, _Component2, _resolvedProps, renderLanes);
      }

    case HostRoot:
      return updateHostRoot(current, workInProgress, renderLanes);

    case HostComponent:
      return updateHostComponent(current, workInProgress, renderLanes);

    case HostText:
      return updateHostText(current, workInProgress);

    case SuspenseComponent:
      return updateSuspenseComponent(current, workInProgress, renderLanes);

    case HostPortal:
      return updatePortalComponent(current, workInProgress, renderLanes);

    case ForwardRef:
      {
        var type = workInProgress.type;
        var _unresolvedProps2 = workInProgress.pendingProps;

        var _resolvedProps2 = workInProgress.elementType === type ? _unresolvedProps2 : resolveDefaultProps(type, _unresolvedProps2);

        return updateForwardRef(current, workInProgress, type, _resolvedProps2, renderLanes);
      }

    case Fragment:
      return updateFragment(current, workInProgress, renderLanes);

    case Mode:
      return updateMode(current, workInProgress, renderLanes);

    case Profiler:
      return updateProfiler(current, workInProgress, renderLanes);

    case ContextProvider:
      return updateContextProvider(current, workInProgress, renderLanes);

    case ContextConsumer:
      return updateContextConsumer(current, workInProgress, renderLanes);

    case MemoComponent:
      {
        var _type2 = workInProgress.type;
        var _unresolvedProps3 = workInProgress.pendingProps; // Resolve outer props first, then resolve inner props.

        var _resolvedProps3 = resolveDefaultProps(_type2, _unresolvedProps3);

        {
          if (workInProgress.type !== workInProgress.elementType) {
            var outerPropTypes = _type2.propTypes;

            if (outerPropTypes) {
              checkPropTypes(outerPropTypes, _resolvedProps3, // Resolved for outer only
              'prop', getComponentName(_type2));
            }
          }
        }

        _resolvedProps3 = resolveDefaultProps(_type2.type, _resolvedProps3);
        return updateMemoComponent(current, workInProgress, _type2, _resolvedProps3, updateLanes, renderLanes);
      }

    case SimpleMemoComponent:
      {
        return updateSimpleMemoComponent(current, workInProgress, workInProgress.type, workInProgress.pendingProps, updateLanes, renderLanes);
      }

    case IncompleteClassComponent:
      {
        var _Component3 = workInProgress.type;
        var _unresolvedProps4 = workInProgress.pendingProps;

        var _resolvedProps4 = workInProgress.elementType === _Component3 ? _unresolvedProps4 : resolveDefaultProps(_Component3, _unresolvedProps4);

        return mountIncompleteClassComponent(current, workInProgress, _Component3, _resolvedProps4, renderLanes);
      }

    case SuspenseListComponent:
      {
        return updateSuspenseListComponent(current, workInProgress, renderLanes);
      }

    case FundamentalComponent:
      {

        break;
      }

    case ScopeComponent:
      {

        break;
      }

    case Block:
      {

        break;
      }

    case OffscreenComponent:
      {
        return updateOffscreenComponent(current, workInProgress, renderLanes);
      }

    case LegacyHiddenComponent:
      {
        return updateLegacyHiddenComponent(current, workInProgress, renderLanes);
      }
  }

  {
    {
      throw Error( "Unknown unit of work tag (" + workInProgress.tag + "). This error is likely caused by a bug in React. Please file an issue." );
    }
  }
}

function markUpdate(workInProgress) {
  // Tag the fiber with an update effect. This turns a Placement into
  // a PlacementAndUpdate.
  workInProgress.flags |= Update;
}

function markRef$1(workInProgress) {
  workInProgress.flags |= Ref;
}

var appendAllChildren;
var updateHostContainer;
var updateHostComponent$1;
var updateHostText$1;

{
  // Mutation mode
  appendAllChildren = function (parent, workInProgress, needsVisibilityToggle, isHidden) {
    // We only have the top Fiber that was created but we need recurse down its
    // children to find all the terminal nodes.
    var node = workInProgress.child;

    while (node !== null) {
      if (node.tag === HostComponent || node.tag === HostText) {
        appendInitialChild(parent, node.stateNode);
      } else if (node.tag === HostPortal) ; else if (node.child !== null) {
        node.child.return = node;
        node = node.child;
        continue;
      }

      if (node === workInProgress) {
        return;
      }

      while (node.sibling === null) {
        if (node.return === null || node.return === workInProgress) {
          return;
        }

        node = node.return;
      }

      node.sibling.return = node.return;
      node = node.sibling;
    }
  };

  updateHostContainer = function (workInProgress) {// Noop
  };

  updateHostComponent$1 = function (current, workInProgress, type, newProps, rootContainerInstance) {
    // If we have an alternate, that means this is an update and we need to
    // schedule a side-effect to do the updates.
    var oldProps = current.memoizedProps;

    if (oldProps === newProps) {
      // In mutation mode, this is sufficient for a bailout because
      // we won't touch this node even if children changed.
      return;
    } // If we get updated because one of our children updated, we don't
    // have newProps so we'll have to reuse them.
    // TODO: Split the update API as separate for the props vs. children.
    // Even better would be if children weren't special cased at all tho.


    var instance = workInProgress.stateNode;
    var currentHostContext = getHostContext(); // TODO: Experiencing an error where oldProps is null. Suggests a host
    // component is hitting the resume path. Figure out why. Possibly
    // related to `hidden`.

    var updatePayload = prepareUpdate(instance, type, oldProps, newProps, rootContainerInstance, currentHostContext); // TODO: Type this specific to this type of component.

    workInProgress.updateQueue = updatePayload; // If the update payload indicates that there is a change or if there
    // is a new ref we mark this as an update. All the work is done in commitWork.

    if (updatePayload) {
      markUpdate(workInProgress);
    }
  };

  updateHostText$1 = function (current, workInProgress, oldText, newText) {
    // If the text differs, mark it as an update. All the work in done in commitWork.
    if (oldText !== newText) {
      markUpdate(workInProgress);
    }
  };
}

function cutOffTailIfNeeded(renderState, hasRenderedATailFallback) {
  if (getIsHydrating()) {
    // If we're hydrating, we should consume as many items as we can
    // so we don't leave any behind.
    return;
  }

  switch (renderState.tailMode) {
    case 'hidden':
      {
        // Any insertions at the end of the tail list after this point
        // should be invisible. If there are already mounted boundaries
        // anything before them are not considered for collapsing.
        // Therefore we need to go through the whole tail to find if
        // there are any.
        var tailNode = renderState.tail;
        var lastTailNode = null;

        while (tailNode !== null) {
          if (tailNode.alternate !== null) {
            lastTailNode = tailNode;
          }

          tailNode = tailNode.sibling;
        } // Next we're simply going to delete all insertions after the
        // last rendered item.


        if (lastTailNode === null) {
          // All remaining items in the tail are insertions.
          renderState.tail = null;
        } else {
          // Detach the insertion after the last node that was already
          // inserted.
          lastTailNode.sibling = null;
        }

        break;
      }

    case 'collapsed':
      {
        // Any insertions at the end of the tail list after this point
        // should be invisible. If there are already mounted boundaries
        // anything before them are not considered for collapsing.
        // Therefore we need to go through the whole tail to find if
        // there are any.
        var _tailNode = renderState.tail;
        var _lastTailNode = null;

        while (_tailNode !== null) {
          if (_tailNode.alternate !== null) {
            _lastTailNode = _tailNode;
          }

          _tailNode = _tailNode.sibling;
        } // Next we're simply going to delete all insertions after the
        // last rendered item.


        if (_lastTailNode === null) {
          // All remaining items in the tail are insertions.
          if (!hasRenderedATailFallback && renderState.tail !== null) {
            // We suspended during the head. We want to show at least one
            // row at the tail. So we'll keep on and cut off the rest.
            renderState.tail.sibling = null;
          } else {
            renderState.tail = null;
          }
        } else {
          // Detach the insertion after the last node that was already
          // inserted.
          _lastTailNode.sibling = null;
        }

        break;
      }
  }
}

function completeWork(current, workInProgress, renderLanes) {
  var newProps = workInProgress.pendingProps;

  switch (workInProgress.tag) {
    case IndeterminateComponent:
    case LazyComponent:
    case SimpleMemoComponent:
    case FunctionComponent:
    case ForwardRef:
    case Fragment:
    case Mode:
    case Profiler:
    case ContextConsumer:
    case MemoComponent:
      return null;

    case ClassComponent:
      {
        var Component = workInProgress.type;

        if (isContextProvider(Component)) {
          popContext(workInProgress);
        }

        return null;
      }

    case HostRoot:
      {
        popHostContainer(workInProgress);
        popTopLevelContextObject(workInProgress);
        resetWorkInProgressVersions();
        var fiberRoot = workInProgress.stateNode;

        if (fiberRoot.pendingContext) {
          fiberRoot.context = fiberRoot.pendingContext;
          fiberRoot.pendingContext = null;
        }

        if (current === null || current.child === null) {
          // If we hydrated, pop so that we can delete any remaining children
          // that weren't hydrated.
          var wasHydrated = popHydrationState(workInProgress);

          if (wasHydrated) {
            // If we hydrated, then we'll need to schedule an update for
            // the commit side-effects on the root.
            markUpdate(workInProgress);
          } else if (!fiberRoot.hydrate) {
            // Schedule an effect to clear this container at the start of the next commit.
            // This handles the case of React rendering into a container with previous children.
            // It's also safe to do for updates too, because current.child would only be null
            // if the previous render was null (so the the container would already be empty).
            workInProgress.flags |= Snapshot;
          }
        }

        updateHostContainer(workInProgress);
        return null;
      }

    case HostComponent:
      {
        popHostContext(workInProgress);
        var rootContainerInstance = getRootHostContainer();
        var type = workInProgress.type;

        if (current !== null && workInProgress.stateNode != null) {
          updateHostComponent$1(current, workInProgress, type, newProps, rootContainerInstance);

          if (current.ref !== workInProgress.ref) {
            markRef$1(workInProgress);
          }
        } else {
          if (!newProps) {
            if (!(workInProgress.stateNode !== null)) {
              {
                throw Error( "We must have new props for new mounts. This error is likely caused by a bug in React. Please file an issue." );
              }
            } // This can happen when we abort work.


            return null;
          }

          var currentHostContext = getHostContext(); // TODO: Move createInstance to beginWork and keep it on a context
          // "stack" as the parent. Then append children as we go in beginWork
          // or completeWork depending on whether we want to add them top->down or
          // bottom->up. Top->down is faster in IE11.

          var _wasHydrated = popHydrationState(workInProgress);

          if (_wasHydrated) {
            // TODO: Move this and createInstance step into the beginPhase
            // to consolidate.
            if (prepareToHydrateHostInstance(workInProgress, rootContainerInstance, currentHostContext)) {
              // If changes to the hydrated node need to be applied at the
              // commit-phase we mark this as such.
              markUpdate(workInProgress);
            }
          } else {
            var instance = createInstance(type, newProps, rootContainerInstance, currentHostContext, workInProgress);
            appendAllChildren(instance, workInProgress, false, false);
            workInProgress.stateNode = instance; // Certain renderers require commit-time effects for initial mount.
            // (eg DOM renderer supports auto-focus for certain elements).
            // Make sure such renderers get scheduled for later work.

            if (finalizeInitialChildren(instance, type, newProps, rootContainerInstance)) {
              markUpdate(workInProgress);
            }
          }

          if (workInProgress.ref !== null) {
            // If there is a ref on a host node we need to schedule a callback
            markRef$1(workInProgress);
          }
        }

        return null;
      }

    case HostText:
      {
        var newText = newProps;

        if (current && workInProgress.stateNode != null) {
          var oldText = current.memoizedProps; // If we have an alternate, that means this is an update and we need
          // to schedule a side-effect to do the updates.

          updateHostText$1(current, workInProgress, oldText, newText);
        } else {
          if (typeof newText !== 'string') {
            if (!(workInProgress.stateNode !== null)) {
              {
                throw Error( "We must have new props for new mounts. This error is likely caused by a bug in React. Please file an issue." );
              }
            } // This can happen when we abort work.

          }

          var _rootContainerInstance = getRootHostContainer();

          var _currentHostContext = getHostContext();

          var _wasHydrated2 = popHydrationState(workInProgress);

          if (_wasHydrated2) {
            if (prepareToHydrateHostTextInstance(workInProgress)) {
              markUpdate(workInProgress);
            }
          } else {
            workInProgress.stateNode = createTextInstance(newText, _rootContainerInstance, _currentHostContext, workInProgress);
          }
        }

        return null;
      }

    case SuspenseComponent:
      {
        popSuspenseContext(workInProgress);
        var nextState = workInProgress.memoizedState;

        if ((workInProgress.flags & DidCapture) !== NoFlags) {
          // Something suspended. Re-render with the fallback children.
          workInProgress.lanes = renderLanes; // Do not reset the effect list.

          if ( (workInProgress.mode & ProfileMode) !== NoMode) {
            transferActualDuration(workInProgress);
          }

          return workInProgress;
        }

        var nextDidTimeout = nextState !== null;
        var prevDidTimeout = false;

        if (current === null) {
          if (workInProgress.memoizedProps.fallback !== undefined) {
            popHydrationState(workInProgress);
          }
        } else {
          var prevState = current.memoizedState;
          prevDidTimeout = prevState !== null;
        }

        if (nextDidTimeout && !prevDidTimeout) {
          // If this subtreee is running in blocking mode we can suspend,
          // otherwise we won't suspend.
          // TODO: This will still suspend a synchronous tree if anything
          // in the concurrent tree already suspended during this render.
          // This is a known bug.
          if ((workInProgress.mode & BlockingMode) !== NoMode) {
            // TODO: Move this back to throwException because this is too late
            // if this is a large tree which is common for initial loads. We
            // don't know if we should restart a render or not until we get
            // this marker, and this is too late.
            // If this render already had a ping or lower pri updates,
            // and this is the first time we know we're going to suspend we
            // should be able to immediately restart from within throwException.
            var hasInvisibleChildContext = current === null && workInProgress.memoizedProps.unstable_avoidThisFallback !== true;

            if (hasInvisibleChildContext || hasSuspenseContext(suspenseStackCursor.current, InvisibleParentSuspenseContext)) {
              // If this was in an invisible tree or a new render, then showing
              // this boundary is ok.
              renderDidSuspend();
            } else {
              // Otherwise, we're going to have to hide content so we should
              // suspend for longer if possible.
              renderDidSuspendDelayIfPossible();
            }
          }
        }

        {
          // TODO: Only schedule updates if these values are non equal, i.e. it changed.
          if (nextDidTimeout || prevDidTimeout) {
            // If this boundary just timed out, schedule an effect to attach a
            // retry listener to the promise. This flag is also used to hide the
            // primary children. In mutation mode, we also need the flag to
            // *unhide* children that were previously hidden, so check if this
            // is currently timed out, too.
            workInProgress.flags |= Update;
          }
        }

        return null;
      }

    case HostPortal:
      popHostContainer(workInProgress);
      updateHostContainer(workInProgress);

      if (current === null) {
        preparePortalMount(workInProgress.stateNode.containerInfo);
      }

      return null;

    case ContextProvider:
      // Pop provider fiber
      popProvider(workInProgress);
      return null;

    case IncompleteClassComponent:
      {
        // Same as class component case. I put it down here so that the tags are
        // sequential to ensure this switch is compiled to a jump table.
        var _Component = workInProgress.type;

        if (isContextProvider(_Component)) {
          popContext(workInProgress);
        }

        return null;
      }

    case SuspenseListComponent:
      {
        popSuspenseContext(workInProgress);
        var renderState = workInProgress.memoizedState;

        if (renderState === null) {
          // We're running in the default, "independent" mode.
          // We don't do anything in this mode.
          return null;
        }

        var didSuspendAlready = (workInProgress.flags & DidCapture) !== NoFlags;
        var renderedTail = renderState.rendering;

        if (renderedTail === null) {
          // We just rendered the head.
          if (!didSuspendAlready) {
            // This is the first pass. We need to figure out if anything is still
            // suspended in the rendered set.
            // If new content unsuspended, but there's still some content that
            // didn't. Then we need to do a second pass that forces everything
            // to keep showing their fallbacks.
            // We might be suspended if something in this render pass suspended, or
            // something in the previous committed pass suspended. Otherwise,
            // there's no chance so we can skip the expensive call to
            // findFirstSuspended.
            var cannotBeSuspended = renderHasNotSuspendedYet() && (current === null || (current.flags & DidCapture) === NoFlags);

            if (!cannotBeSuspended) {
              var row = workInProgress.child;

              while (row !== null) {
                var suspended = findFirstSuspended(row);

                if (suspended !== null) {
                  didSuspendAlready = true;
                  workInProgress.flags |= DidCapture;
                  cutOffTailIfNeeded(renderState, false); // If this is a newly suspended tree, it might not get committed as
                  // part of the second pass. In that case nothing will subscribe to
                  // its thennables. Instead, we'll transfer its thennables to the
                  // SuspenseList so that it can retry if they resolve.
                  // There might be multiple of these in the list but since we're
                  // going to wait for all of them anyway, it doesn't really matter
                  // which ones gets to ping. In theory we could get clever and keep
                  // track of how many dependencies remain but it gets tricky because
                  // in the meantime, we can add/remove/change items and dependencies.
                  // We might bail out of the loop before finding any but that
                  // doesn't matter since that means that the other boundaries that
                  // we did find already has their listeners attached.

                  var newThennables = suspended.updateQueue;

                  if (newThennables !== null) {
                    workInProgress.updateQueue = newThennables;
                    workInProgress.flags |= Update;
                  } // Rerender the whole list, but this time, we'll force fallbacks
                  // to stay in place.
                  // Reset the effect list before doing the second pass since that's now invalid.


                  if (renderState.lastEffect === null) {
                    workInProgress.firstEffect = null;
                  }

                  workInProgress.lastEffect = renderState.lastEffect; // Reset the child fibers to their original state.

                  resetChildFibers(workInProgress, renderLanes); // Set up the Suspense Context to force suspense and immediately
                  // rerender the children.

                  pushSuspenseContext(workInProgress, setShallowSuspenseContext(suspenseStackCursor.current, ForceSuspenseFallback));
                  return workInProgress.child;
                }

                row = row.sibling;
              }
            }

            if (renderState.tail !== null && now() > getRenderTargetTime()) {
              // We have already passed our CPU deadline but we still have rows
              // left in the tail. We'll just give up further attempts to render
              // the main content and only render fallbacks.
              workInProgress.flags |= DidCapture;
              didSuspendAlready = true;
              cutOffTailIfNeeded(renderState, false); // Since nothing actually suspended, there will nothing to ping this
              // to get it started back up to attempt the next item. While in terms
              // of priority this work has the same priority as this current render,
              // it's not part of the same transition once the transition has
              // committed. If it's sync, we still want to yield so that it can be
              // painted. Conceptually, this is really the same as pinging.
              // We can use any RetryLane even if it's the one currently rendering
              // since we're leaving it behind on this node.

              workInProgress.lanes = SomeRetryLane;

              {
                markSpawnedWork(SomeRetryLane);
              }
            }
          } else {
            cutOffTailIfNeeded(renderState, false);
          } // Next we're going to render the tail.

        } else {
          // Append the rendered row to the child list.
          if (!didSuspendAlready) {
            var _suspended = findFirstSuspended(renderedTail);

            if (_suspended !== null) {
              workInProgress.flags |= DidCapture;
              didSuspendAlready = true; // Ensure we transfer the update queue to the parent so that it doesn't
              // get lost if this row ends up dropped during a second pass.

              var _newThennables = _suspended.updateQueue;

              if (_newThennables !== null) {
                workInProgress.updateQueue = _newThennables;
                workInProgress.flags |= Update;
              }

              cutOffTailIfNeeded(renderState, true); // This might have been modified.

              if (renderState.tail === null && renderState.tailMode === 'hidden' && !renderedTail.alternate && !getIsHydrating() // We don't cut it if we're hydrating.
              ) {
                  // We need to delete the row we just rendered.
                  // Reset the effect list to what it was before we rendered this
                  // child. The nested children have already appended themselves.
                  var lastEffect = workInProgress.lastEffect = renderState.lastEffect; // Remove any effects that were appended after this point.

                  if (lastEffect !== null) {
                    lastEffect.nextEffect = null;
                  } // We're done.


                  return null;
                }
            } else if ( // The time it took to render last row is greater than the remaining
            // time we have to render. So rendering one more row would likely
            // exceed it.
            now() * 2 - renderState.renderingStartTime > getRenderTargetTime() && renderLanes !== OffscreenLane) {
              // We have now passed our CPU deadline and we'll just give up further
              // attempts to render the main content and only render fallbacks.
              // The assumption is that this is usually faster.
              workInProgress.flags |= DidCapture;
              didSuspendAlready = true;
              cutOffTailIfNeeded(renderState, false); // Since nothing actually suspended, there will nothing to ping this
              // to get it started back up to attempt the next item. While in terms
              // of priority this work has the same priority as this current render,
              // it's not part of the same transition once the transition has
              // committed. If it's sync, we still want to yield so that it can be
              // painted. Conceptually, this is really the same as pinging.
              // We can use any RetryLane even if it's the one currently rendering
              // since we're leaving it behind on this node.

              workInProgress.lanes = SomeRetryLane;

              {
                markSpawnedWork(SomeRetryLane);
              }
            }
          }

          if (renderState.isBackwards) {
            // The effect list of the backwards tail will have been added
            // to the end. This breaks the guarantee that life-cycles fire in
            // sibling order but that isn't a strong guarantee promised by React.
            // Especially since these might also just pop in during future commits.
            // Append to the beginning of the list.
            renderedTail.sibling = workInProgress.child;
            workInProgress.child = renderedTail;
          } else {
            var previousSibling = renderState.last;

            if (previousSibling !== null) {
              previousSibling.sibling = renderedTail;
            } else {
              workInProgress.child = renderedTail;
            }

            renderState.last = renderedTail;
          }
        }

        if (renderState.tail !== null) {
          // We still have tail rows to render.
          // Pop a row.
          var next = renderState.tail;
          renderState.rendering = next;
          renderState.tail = next.sibling;
          renderState.lastEffect = workInProgress.lastEffect;
          renderState.renderingStartTime = now();
          next.sibling = null; // Restore the context.
          // TODO: We can probably just avoid popping it instead and only
          // setting it the first time we go from not suspended to suspended.

          var suspenseContext = suspenseStackCursor.current;

          if (didSuspendAlready) {
            suspenseContext = setShallowSuspenseContext(suspenseContext, ForceSuspenseFallback);
          } else {
            suspenseContext = setDefaultShallowSuspenseContext(suspenseContext);
          }

          pushSuspenseContext(workInProgress, suspenseContext); // Do a pass over the next row.

          return next;
        }

        return null;
      }

    case FundamentalComponent:
      {

        break;
      }

    case ScopeComponent:
      {

        break;
      }

    case Block:

      break;

    case OffscreenComponent:
    case LegacyHiddenComponent:
      {
        popRenderLanes(workInProgress);

        if (current !== null) {
          var _nextState = workInProgress.memoizedState;
          var _prevState = current.memoizedState;
          var prevIsHidden = _prevState !== null;
          var nextIsHidden = _nextState !== null;

          if (prevIsHidden !== nextIsHidden && newProps.mode !== 'unstable-defer-without-hiding') {
            workInProgress.flags |= Update;
          }
        }

        return null;
      }
  }

  {
    {
      throw Error( "Unknown unit of work tag (" + workInProgress.tag + "). This error is likely caused by a bug in React. Please file an issue." );
    }
  }
}

function unwindWork(workInProgress, renderLanes) {
  switch (workInProgress.tag) {
    case ClassComponent:
      {
        var Component = workInProgress.type;

        if (isContextProvider(Component)) {
          popContext(workInProgress);
        }

        var flags = workInProgress.flags;

        if (flags & ShouldCapture) {
          workInProgress.flags = flags & ~ShouldCapture | DidCapture;

          if ( (workInProgress.mode & ProfileMode) !== NoMode) {
            transferActualDuration(workInProgress);
          }

          return workInProgress;
        }

        return null;
      }

    case HostRoot:
      {
        popHostContainer(workInProgress);
        popTopLevelContextObject(workInProgress);
        resetWorkInProgressVersions();
        var _flags = workInProgress.flags;

        if (!((_flags & DidCapture) === NoFlags)) {
          {
            throw Error( "The root failed to unmount after an error. This is likely a bug in React. Please file an issue." );
          }
        }

        workInProgress.flags = _flags & ~ShouldCapture | DidCapture;
        return workInProgress;
      }

    case HostComponent:
      {
        // TODO: popHydrationState
        popHostContext(workInProgress);
        return null;
      }

    case SuspenseComponent:
      {
        popSuspenseContext(workInProgress);

        var _flags2 = workInProgress.flags;

        if (_flags2 & ShouldCapture) {
          workInProgress.flags = _flags2 & ~ShouldCapture | DidCapture; // Captured a suspense effect. Re-render the boundary.

          if ( (workInProgress.mode & ProfileMode) !== NoMode) {
            transferActualDuration(workInProgress);
          }

          return workInProgress;
        }

        return null;
      }

    case SuspenseListComponent:
      {
        popSuspenseContext(workInProgress); // SuspenseList doesn't actually catch anything. It should've been
        // caught by a nested boundary. If not, it should bubble through.

        return null;
      }

    case HostPortal:
      popHostContainer(workInProgress);
      return null;

    case ContextProvider:
      popProvider(workInProgress);
      return null;

    case OffscreenComponent:
    case LegacyHiddenComponent:
      popRenderLanes(workInProgress);
      return null;

    default:
      return null;
  }
}

function unwindInterruptedWork(interruptedWork) {
  switch (interruptedWork.tag) {
    case ClassComponent:
      {
        var childContextTypes = interruptedWork.type.childContextTypes;

        if (childContextTypes !== null && childContextTypes !== undefined) {
          popContext(interruptedWork);
        }

        break;
      }

    case HostRoot:
      {
        popHostContainer(interruptedWork);
        popTopLevelContextObject(interruptedWork);
        resetWorkInProgressVersions();
        break;
      }

    case HostComponent:
      {
        popHostContext(interruptedWork);
        break;
      }

    case HostPortal:
      popHostContainer(interruptedWork);
      break;

    case SuspenseComponent:
      popSuspenseContext(interruptedWork);
      break;

    case SuspenseListComponent:
      popSuspenseContext(interruptedWork);
      break;

    case ContextProvider:
      popProvider(interruptedWork);
      break;

    case OffscreenComponent:
    case LegacyHiddenComponent:
      popRenderLanes(interruptedWork);
      break;
  }
}

function createCapturedValue(value, source) {
  // If the value is an error, call this function immediately after it is thrown
  // so the stack is accurate.
  return {
    value: value,
    source: source,
    stack: getStackByFiberInDevAndProd(source)
  };
}

// This module is forked in different environments.
// By default, return `true` to log errors to the console.
// Forks can return `false` if this isn't desirable.
function showErrorDialog(boundary, errorInfo) {
  return true;
}

function logCapturedError(boundary, errorInfo) {
  try {
    var logError = showErrorDialog(boundary, errorInfo); // Allow injected showErrorDialog() to prevent default console.error logging.
    // This enables renderers like ReactNative to better manage redbox behavior.

    if (logError === false) {
      return;
    }

    var error = errorInfo.value;

    if (true) {
      var source = errorInfo.source;
      var stack = errorInfo.stack;
      var componentStack = stack !== null ? stack : ''; // Browsers support silencing uncaught errors by calling
      // `preventDefault()` in window `error` handler.
      // We record this information as an expando on the error.

      if (error != null && error._suppressLogging) {
        if (boundary.tag === ClassComponent) {
          // The error is recoverable and was silenced.
          // Ignore it and don't print the stack addendum.
          // This is handy for testing error boundaries without noise.
          return;
        } // The error is fatal. Since the silencing might have
        // been accidental, we'll surface it anyway.
        // However, the browser would have silenced the original error
        // so we'll print it first, and then print the stack addendum.


        console['error'](error); // Don't transform to our wrapper
        // For a more detailed description of this block, see:
        // https://github.com/facebook/react/pull/13384
      }

      var componentName = source ? getComponentName(source.type) : null;
      var componentNameMessage = componentName ? "The above error occurred in the <" + componentName + "> component:" : 'The above error occurred in one of your React components:';
      var errorBoundaryMessage;
      var errorBoundaryName = getComponentName(boundary.type);

      if (errorBoundaryName) {
        errorBoundaryMessage = "React will try to recreate this component tree from scratch " + ("using the error boundary you provided, " + errorBoundaryName + ".");
      } else {
        errorBoundaryMessage = 'Consider adding an error boundary to your tree to customize error handling behavior.\n' + 'Visit https://reactjs.org/link/error-boundaries to learn more about error boundaries.';
      }

      var combinedMessage = componentNameMessage + "\n" + componentStack + "\n\n" + ("" + errorBoundaryMessage); // In development, we provide our own message with just the component stack.
      // We don't include the original error message and JS stack because the browser
      // has already printed it. Even if the application swallows the error, it is still
      // displayed by the browser thanks to the DEV-only fake event trick in ReactErrorUtils.

      console['error'](combinedMessage); // Don't transform to our wrapper
    } else {}
  } catch (e) {
    // This method must not throw, or React internal state will get messed up.
    // If console.error is overridden, or logCapturedError() shows a dialog that throws,
    // we want to report this error outside of the normal stack as a last resort.
    // https://github.com/facebook/react/issues/13188
    setTimeout(function () {
      throw e;
    });
  }
}

var PossiblyWeakMap$1 = typeof WeakMap === 'function' ? WeakMap : Map;

function createRootErrorUpdate(fiber, errorInfo, lane) {
  var update = createUpdate(NoTimestamp, lane); // Unmount the root by rendering null.

  update.tag = CaptureUpdate; // Caution: React DevTools currently depends on this property
  // being called "element".

  update.payload = {
    element: null
  };
  var error = errorInfo.value;

  update.callback = function () {
    onUncaughtError(error);
    logCapturedError(fiber, errorInfo);
  };

  return update;
}

function createClassErrorUpdate(fiber, errorInfo, lane) {
  var update = createUpdate(NoTimestamp, lane);
  update.tag = CaptureUpdate;
  var getDerivedStateFromError = fiber.type.getDerivedStateFromError;

  if (typeof getDerivedStateFromError === 'function') {
    var error$1 = errorInfo.value;

    update.payload = function () {
      logCapturedError(fiber, errorInfo);
      return getDerivedStateFromError(error$1);
    };
  }

  var inst = fiber.stateNode;

  if (inst !== null && typeof inst.componentDidCatch === 'function') {
    update.callback = function callback() {
      {
        markFailedErrorBoundaryForHotReloading(fiber);
      }

      if (typeof getDerivedStateFromError !== 'function') {
        // To preserve the preexisting retry behavior of error boundaries,
        // we keep track of which ones already failed during this batch.
        // This gets reset before we yield back to the browser.
        // TODO: Warn in strict mode if getDerivedStateFromError is
        // not defined.
        markLegacyErrorBoundaryAsFailed(this); // Only log here if componentDidCatch is the only error boundary method defined

        logCapturedError(fiber, errorInfo);
      }

      var error$1 = errorInfo.value;
      var stack = errorInfo.stack;
      this.componentDidCatch(error$1, {
        componentStack: stack !== null ? stack : ''
      });

      {
        if (typeof getDerivedStateFromError !== 'function') {
          // If componentDidCatch is the only error boundary method defined,
          // then it needs to call setState to recover from errors.
          // If no state update is scheduled then the boundary will swallow the error.
          if (!includesSomeLane(fiber.lanes, SyncLane)) {
            error('%s: Error boundaries should implement getDerivedStateFromError(). ' + 'In that method, return a state update to display an error message or fallback UI.', getComponentName(fiber.type) || 'Unknown');
          }
        }
      }
    };
  } else {
    update.callback = function () {
      markFailedErrorBoundaryForHotReloading(fiber);
    };
  }

  return update;
}

function attachPingListener(root, wakeable, lanes) {
  // Attach a listener to the promise to "ping" the root and retry. But only if
  // one does not already exist for the lanes we're currently rendering (which
  // acts like a "thread ID" here).
  var pingCache = root.pingCache;
  var threadIDs;

  if (pingCache === null) {
    pingCache = root.pingCache = new PossiblyWeakMap$1();
    threadIDs = new Set();
    pingCache.set(wakeable, threadIDs);
  } else {
    threadIDs = pingCache.get(wakeable);

    if (threadIDs === undefined) {
      threadIDs = new Set();
      pingCache.set(wakeable, threadIDs);
    }
  }

  if (!threadIDs.has(lanes)) {
    // Memoize using the thread ID to prevent redundant listeners.
    threadIDs.add(lanes);
    var ping = pingSuspendedRoot.bind(null, root, wakeable, lanes);
    wakeable.then(ping, ping);
  }
}

function throwException(root, returnFiber, sourceFiber, value, rootRenderLanes) {
  // The source fiber did not complete.
  sourceFiber.flags |= Incomplete; // Its effect list is no longer valid.

  sourceFiber.firstEffect = sourceFiber.lastEffect = null;

  if (value !== null && typeof value === 'object' && typeof value.then === 'function') {
    // This is a wakeable.
    var wakeable = value;

    if ((sourceFiber.mode & BlockingMode) === NoMode) {
      // Reset the memoizedState to what it was before we attempted
      // to render it.
      var currentSource = sourceFiber.alternate;

      if (currentSource) {
        sourceFiber.updateQueue = currentSource.updateQueue;
        sourceFiber.memoizedState = currentSource.memoizedState;
        sourceFiber.lanes = currentSource.lanes;
      } else {
        sourceFiber.updateQueue = null;
        sourceFiber.memoizedState = null;
      }
    }

    var hasInvisibleParentBoundary = hasSuspenseContext(suspenseStackCursor.current, InvisibleParentSuspenseContext); // Schedule the nearest Suspense to re-render the timed out view.

    var _workInProgress = returnFiber;

    do {
      if (_workInProgress.tag === SuspenseComponent && shouldCaptureSuspense(_workInProgress, hasInvisibleParentBoundary)) {
        // Found the nearest boundary.
        // Stash the promise on the boundary fiber. If the boundary times out, we'll
        // attach another listener to flip the boundary back to its normal state.
        var wakeables = _workInProgress.updateQueue;

        if (wakeables === null) {
          var updateQueue = new Set();
          updateQueue.add(wakeable);
          _workInProgress.updateQueue = updateQueue;
        } else {
          wakeables.add(wakeable);
        } // If the boundary is outside of blocking mode, we should *not*
        // suspend the commit. Pretend as if the suspended component rendered
        // null and keep rendering. In the commit phase, we'll schedule a
        // subsequent synchronous update to re-render the Suspense.
        //
        // Note: It doesn't matter whether the component that suspended was
        // inside a blocking mode tree. If the Suspense is outside of it, we
        // should *not* suspend the commit.


        if ((_workInProgress.mode & BlockingMode) === NoMode) {
          _workInProgress.flags |= DidCapture;
          sourceFiber.flags |= ForceUpdateForLegacySuspense; // We're going to commit this fiber even though it didn't complete.
          // But we shouldn't call any lifecycle methods or callbacks. Remove
          // all lifecycle effect tags.

          sourceFiber.flags &= ~(LifecycleEffectMask | Incomplete);

          if (sourceFiber.tag === ClassComponent) {
            var currentSourceFiber = sourceFiber.alternate;

            if (currentSourceFiber === null) {
              // This is a new mount. Change the tag so it's not mistaken for a
              // completed class component. For example, we should not call
              // componentWillUnmount if it is deleted.
              sourceFiber.tag = IncompleteClassComponent;
            } else {
              // When we try rendering again, we should not reuse the current fiber,
              // since it's known to be in an inconsistent state. Use a force update to
              // prevent a bail out.
              var update = createUpdate(NoTimestamp, SyncLane);
              update.tag = ForceUpdate;
              enqueueUpdate(sourceFiber, update);
            }
          } // The source fiber did not complete. Mark it with Sync priority to
          // indicate that it still has pending work.


          sourceFiber.lanes = mergeLanes(sourceFiber.lanes, SyncLane); // Exit without suspending.

          return;
        } // Confirmed that the boundary is in a concurrent mode tree. Continue
        // with the normal suspend path.
        //
        // After this we'll use a set of heuristics to determine whether this
        // render pass will run to completion or restart or "suspend" the commit.
        // The actual logic for this is spread out in different places.
        //
        // This first principle is that if we're going to suspend when we complete
        // a root, then we should also restart if we get an update or ping that
        // might unsuspend it, and vice versa. The only reason to suspend is
        // because you think you might want to restart before committing. However,
        // it doesn't make sense to restart only while in the period we're suspended.
        //
        // Restarting too aggressively is also not good because it starves out any
        // intermediate loading state. So we use heuristics to determine when.
        // Suspense Heuristics
        //
        // If nothing threw a Promise or all the same fallbacks are already showing,
        // then don't suspend/restart.
        //
        // If this is an initial render of a new tree of Suspense boundaries and
        // those trigger a fallback, then don't suspend/restart. We want to ensure
        // that we can show the initial loading state as quickly as possible.
        //
        // If we hit a "Delayed" case, such as when we'd switch from content back into
        // a fallback, then we should always suspend/restart. Transitions apply
        // to this case. If none is defined, JND is used instead.
        //
        // If we're already showing a fallback and it gets "retried", allowing us to show
        // another level, but there's still an inner boundary that would show a fallback,
        // then we suspend/restart for 500ms since the last time we showed a fallback
        // anywhere in the tree. This effectively throttles progressive loading into a
        // consistent train of commits. This also gives us an opportunity to restart to
        // get to the completed state slightly earlier.
        //
        // If there's ambiguity due to batching it's resolved in preference of:
        // 1) "delayed", 2) "initial render", 3) "retry".
        //
        // We want to ensure that a "busy" state doesn't get force committed. We want to
        // ensure that new initial loading states can commit as soon as possible.


        attachPingListener(root, wakeable, rootRenderLanes);
        _workInProgress.flags |= ShouldCapture;
        _workInProgress.lanes = rootRenderLanes;
        return;
      } // This boundary already captured during this render. Continue to the next
      // boundary.


      _workInProgress = _workInProgress.return;
    } while (_workInProgress !== null); // No boundary was found. Fallthrough to error mode.
    // TODO: Use invariant so the message is stripped in prod?


    value = new Error((getComponentName(sourceFiber.type) || 'A React component') + ' suspended while rendering, but no fallback UI was specified.\n' + '\n' + 'Add a <Suspense fallback=...> component higher in the tree to ' + 'provide a loading indicator or placeholder to display.');
  } // We didn't find a boundary that could handle this type of exception. Start
  // over and traverse parent path again, this time treating the exception
  // as an error.


  renderDidError();
  value = createCapturedValue(value, sourceFiber);
  var workInProgress = returnFiber;

  do {
    switch (workInProgress.tag) {
      case HostRoot:
        {
          var _errorInfo = value;
          workInProgress.flags |= ShouldCapture;
          var lane = pickArbitraryLane(rootRenderLanes);
          workInProgress.lanes = mergeLanes(workInProgress.lanes, lane);

          var _update = createRootErrorUpdate(workInProgress, _errorInfo, lane);

          enqueueCapturedUpdate(workInProgress, _update);
          return;
        }

      case ClassComponent:
        // Capture and retry
        var errorInfo = value;
        var ctor = workInProgress.type;
        var instance = workInProgress.stateNode;

        if ((workInProgress.flags & DidCapture) === NoFlags && (typeof ctor.getDerivedStateFromError === 'function' || instance !== null && typeof instance.componentDidCatch === 'function' && !isAlreadyFailedLegacyErrorBoundary(instance))) {
          workInProgress.flags |= ShouldCapture;

          var _lane = pickArbitraryLane(rootRenderLanes);

          workInProgress.lanes = mergeLanes(workInProgress.lanes, _lane); // Schedule the error boundary to re-render using updated state

          var _update2 = createClassErrorUpdate(workInProgress, errorInfo, _lane);

          enqueueCapturedUpdate(workInProgress, _update2);
          return;
        }

        break;
    }

    workInProgress = workInProgress.return;
  } while (workInProgress !== null);
}

var didWarnAboutUndefinedSnapshotBeforeUpdate = null;

{
  didWarnAboutUndefinedSnapshotBeforeUpdate = new Set();
}

var PossiblyWeakSet = typeof WeakSet === 'function' ? WeakSet : Set;

var callComponentWillUnmountWithTimer = function (current, instance) {
  instance.props = current.memoizedProps;
  instance.state = current.memoizedState;

  {
    instance.componentWillUnmount();
  }
}; // Capture errors so they don't interrupt unmounting.


function safelyCallComponentWillUnmount(current, instance) {
  {
    invokeGuardedCallback(null, callComponentWillUnmountWithTimer, null, current, instance);

    if (hasCaughtError()) {
      var unmountError = clearCaughtError();
      captureCommitPhaseError(current, unmountError);
    }
  }
}

function safelyDetachRef(current) {
  var ref = current.ref;

  if (ref !== null) {
    if (typeof ref === 'function') {
      {
        invokeGuardedCallback(null, ref, null, null);

        if (hasCaughtError()) {
          var refError = clearCaughtError();
          captureCommitPhaseError(current, refError);
        }
      }
    } else {
      ref.current = null;
    }
  }
}

function safelyCallDestroy(current, destroy) {
  {
    invokeGuardedCallback(null, destroy, null);

    if (hasCaughtError()) {
      var error = clearCaughtError();
      captureCommitPhaseError(current, error);
    }
  }
}

function commitBeforeMutationLifeCycles(current, finishedWork) {
  switch (finishedWork.tag) {
    case FunctionComponent:
    case ForwardRef:
    case SimpleMemoComponent:
    case Block:
      {
        return;
      }

    case ClassComponent:
      {
        if (finishedWork.flags & Snapshot) {
          if (current !== null) {
            var prevProps = current.memoizedProps;
            var prevState = current.memoizedState;
            var instance = finishedWork.stateNode; // We could update instance props and state here,
            // but instead we rely on them being set during last render.
            // TODO: revisit this when we implement resuming.

            {
              if (finishedWork.type === finishedWork.elementType && !didWarnAboutReassigningProps) {
                if (instance.props !== finishedWork.memoizedProps) {
                  error('Expected %s props to match memoized props before ' + 'getSnapshotBeforeUpdate. ' + 'This might either be because of a bug in React, or because ' + 'a component reassigns its own `this.props`. ' + 'Please file an issue.', getComponentName(finishedWork.type) || 'instance');
                }

                if (instance.state !== finishedWork.memoizedState) {
                  error('Expected %s state to match memoized state before ' + 'getSnapshotBeforeUpdate. ' + 'This might either be because of a bug in React, or because ' + 'a component reassigns its own `this.state`. ' + 'Please file an issue.', getComponentName(finishedWork.type) || 'instance');
                }
              }
            }

            var snapshot = instance.getSnapshotBeforeUpdate(finishedWork.elementType === finishedWork.type ? prevProps : resolveDefaultProps(finishedWork.type, prevProps), prevState);

            {
              var didWarnSet = didWarnAboutUndefinedSnapshotBeforeUpdate;

              if (snapshot === undefined && !didWarnSet.has(finishedWork.type)) {
                didWarnSet.add(finishedWork.type);

                error('%s.getSnapshotBeforeUpdate(): A snapshot value (or null) ' + 'must be returned. You have returned undefined.', getComponentName(finishedWork.type));
              }
            }

            instance.__reactInternalSnapshotBeforeUpdate = snapshot;
          }
        }

        return;
      }

    case HostRoot:
      {
        {
          if (finishedWork.flags & Snapshot) {
            var root = finishedWork.stateNode;
            clearContainer(root.containerInfo);
          }
        }

        return;
      }

    case HostComponent:
    case HostText:
    case HostPortal:
    case IncompleteClassComponent:
      // Nothing to do for these component types
      return;
  }

  {
    {
      throw Error( "This unit of work tag should not have side-effects. This error is likely caused by a bug in React. Please file an issue." );
    }
  }
}

function commitHookEffectListUnmount(tag, finishedWork) {
  var updateQueue = finishedWork.updateQueue;
  var lastEffect = updateQueue !== null ? updateQueue.lastEffect : null;

  if (lastEffect !== null) {
    var firstEffect = lastEffect.next;
    var effect = firstEffect;

    do {
      if ((effect.tag & tag) === tag) {
        // Unmount
        var destroy = effect.destroy;
        effect.destroy = undefined;

        if (destroy !== undefined) {
          destroy();
        }
      }

      effect = effect.next;
    } while (effect !== firstEffect);
  }
}

function commitHookEffectListMount(tag, finishedWork) {
  var updateQueue = finishedWork.updateQueue;
  var lastEffect = updateQueue !== null ? updateQueue.lastEffect : null;

  if (lastEffect !== null) {
    var firstEffect = lastEffect.next;
    var effect = firstEffect;

    do {
      if ((effect.tag & tag) === tag) {
        // Mount
        var create = effect.create;
        effect.destroy = create();

        {
          var destroy = effect.destroy;

          if (destroy !== undefined && typeof destroy !== 'function') {
            var addendum = void 0;

            if (destroy === null) {
              addendum = ' You returned null. If your effect does not require clean ' + 'up, return undefined (or nothing).';
            } else if (typeof destroy.then === 'function') {
              addendum = '\n\nIt looks like you wrote useEffect(async () => ...) or returned a Promise. ' + 'Instead, write the async function inside your effect ' + 'and call it immediately:\n\n' + 'useEffect(() => {\n' + '  async function fetchData() {\n' + '    // You can await here\n' + '    const response = await MyAPI.getData(someId);\n' + '    // ...\n' + '  }\n' + '  fetchData();\n' + "}, [someId]); // Or [] if effect doesn't need props or state\n\n" + 'Learn more about data fetching with Hooks: https://reactjs.org/link/hooks-data-fetching';
            } else {
              addendum = ' You returned: ' + destroy;
            }

            error('An effect function must not return anything besides a function, ' + 'which is used for clean-up.%s', addendum);
          }
        }
      }

      effect = effect.next;
    } while (effect !== firstEffect);
  }
}

function schedulePassiveEffects(finishedWork) {
  var updateQueue = finishedWork.updateQueue;
  var lastEffect = updateQueue !== null ? updateQueue.lastEffect : null;

  if (lastEffect !== null) {
    var firstEffect = lastEffect.next;
    var effect = firstEffect;

    do {
      var _effect = effect,
          next = _effect.next,
          tag = _effect.tag;

      if ((tag & Passive$1) !== NoFlags$1 && (tag & HasEffect) !== NoFlags$1) {
        enqueuePendingPassiveHookEffectUnmount(finishedWork, effect);
        enqueuePendingPassiveHookEffectMount(finishedWork, effect);
      }

      effect = next;
    } while (effect !== firstEffect);
  }
}

function commitLifeCycles(finishedRoot, current, finishedWork, committedLanes) {
  switch (finishedWork.tag) {
    case FunctionComponent:
    case ForwardRef:
    case SimpleMemoComponent:
    case Block:
      {
        // At this point layout effects have already been destroyed (during mutation phase).
        // This is done to prevent sibling component effects from interfering with each other,
        // e.g. a destroy function in one component should never override a ref set
        // by a create function in another component during the same commit.
        {
          commitHookEffectListMount(Layout | HasEffect, finishedWork);
        }

        schedulePassiveEffects(finishedWork);
        return;
      }

    case ClassComponent:
      {
        var instance = finishedWork.stateNode;

        if (finishedWork.flags & Update) {
          if (current === null) {
            // We could update instance props and state here,
            // but instead we rely on them being set during last render.
            // TODO: revisit this when we implement resuming.
            {
              if (finishedWork.type === finishedWork.elementType && !didWarnAboutReassigningProps) {
                if (instance.props !== finishedWork.memoizedProps) {
                  error('Expected %s props to match memoized props before ' + 'componentDidMount. ' + 'This might either be because of a bug in React, or because ' + 'a component reassigns its own `this.props`. ' + 'Please file an issue.', getComponentName(finishedWork.type) || 'instance');
                }

                if (instance.state !== finishedWork.memoizedState) {
                  error('Expected %s state to match memoized state before ' + 'componentDidMount. ' + 'This might either be because of a bug in React, or because ' + 'a component reassigns its own `this.state`. ' + 'Please file an issue.', getComponentName(finishedWork.type) || 'instance');
                }
              }
            }

            {
              instance.componentDidMount();
            }
          } else {
            var prevProps = finishedWork.elementType === finishedWork.type ? current.memoizedProps : resolveDefaultProps(finishedWork.type, current.memoizedProps);
            var prevState = current.memoizedState; // We could update instance props and state here,
            // but instead we rely on them being set during last render.
            // TODO: revisit this when we implement resuming.

            {
              if (finishedWork.type === finishedWork.elementType && !didWarnAboutReassigningProps) {
                if (instance.props !== finishedWork.memoizedProps) {
                  error('Expected %s props to match memoized props before ' + 'componentDidUpdate. ' + 'This might either be because of a bug in React, or because ' + 'a component reassigns its own `this.props`. ' + 'Please file an issue.', getComponentName(finishedWork.type) || 'instance');
                }

                if (instance.state !== finishedWork.memoizedState) {
                  error('Expected %s state to match memoized state before ' + 'componentDidUpdate. ' + 'This might either be because of a bug in React, or because ' + 'a component reassigns its own `this.state`. ' + 'Please file an issue.', getComponentName(finishedWork.type) || 'instance');
                }
              }
            }

            {
              instance.componentDidUpdate(prevProps, prevState, instance.__reactInternalSnapshotBeforeUpdate);
            }
          }
        } // TODO: I think this is now always non-null by the time it reaches the
        // commit phase. Consider removing the type check.


        var updateQueue = finishedWork.updateQueue;

        if (updateQueue !== null) {
          {
            if (finishedWork.type === finishedWork.elementType && !didWarnAboutReassigningProps) {
              if (instance.props !== finishedWork.memoizedProps) {
                error('Expected %s props to match memoized props before ' + 'processing the update queue. ' + 'This might either be because of a bug in React, or because ' + 'a component reassigns its own `this.props`. ' + 'Please file an issue.', getComponentName(finishedWork.type) || 'instance');
              }

              if (instance.state !== finishedWork.memoizedState) {
                error('Expected %s state to match memoized state before ' + 'processing the update queue. ' + 'This might either be because of a bug in React, or because ' + 'a component reassigns its own `this.state`. ' + 'Please file an issue.', getComponentName(finishedWork.type) || 'instance');
              }
            }
          } // We could update instance props and state here,
          // but instead we rely on them being set during last render.
          // TODO: revisit this when we implement resuming.


          commitUpdateQueue(finishedWork, updateQueue, instance);
        }

        return;
      }

    case HostRoot:
      {
        // TODO: I think this is now always non-null by the time it reaches the
        // commit phase. Consider removing the type check.
        var _updateQueue = finishedWork.updateQueue;

        if (_updateQueue !== null) {
          var _instance = null;

          if (finishedWork.child !== null) {
            switch (finishedWork.child.tag) {
              case HostComponent:
                _instance = getPublicInstance(finishedWork.child.stateNode);
                break;

              case ClassComponent:
                _instance = finishedWork.child.stateNode;
                break;
            }
          }

          commitUpdateQueue(finishedWork, _updateQueue, _instance);
        }

        return;
      }

    case HostComponent:
      {
        var _instance2 = finishedWork.stateNode; // Renderers may schedule work to be done after host components are mounted
        // (eg DOM renderer may schedule auto-focus for inputs and form controls).
        // These effects should only be committed when components are first mounted,
        // aka when there is no current/alternate.

        if (current === null && finishedWork.flags & Update) {
          var type = finishedWork.type;
          var props = finishedWork.memoizedProps;
          commitMount(_instance2, type, props);
        }

        return;
      }

    case HostText:
      {
        // We have no life-cycles associated with text.
        return;
      }

    case HostPortal:
      {
        // We have no life-cycles associated with portals.
        return;
      }

    case Profiler:
      {
        {
          var _finishedWork$memoize2 = finishedWork.memoizedProps,
              onCommit = _finishedWork$memoize2.onCommit,
              onRender = _finishedWork$memoize2.onRender;
          var effectDuration = finishedWork.stateNode.effectDuration;
          var commitTime = getCommitTime();

          if (typeof onRender === 'function') {
            {
              onRender(finishedWork.memoizedProps.id, current === null ? 'mount' : 'update', finishedWork.actualDuration, finishedWork.treeBaseDuration, finishedWork.actualStartTime, commitTime, finishedRoot.memoizedInteractions);
            }
          }
        }

        return;
      }

    case SuspenseComponent:
      {
        commitSuspenseHydrationCallbacks(finishedRoot, finishedWork);
        return;
      }

    case SuspenseListComponent:
    case IncompleteClassComponent:
    case FundamentalComponent:
    case ScopeComponent:
    case OffscreenComponent:
    case LegacyHiddenComponent:
      return;
  }

  {
    {
      throw Error( "This unit of work tag should not have side-effects. This error is likely caused by a bug in React. Please file an issue." );
    }
  }
}

function hideOrUnhideAllChildren(finishedWork, isHidden) {
  {
    // We only have the top Fiber that was inserted but we need to recurse down its
    // children to find all the terminal nodes.
    var node = finishedWork;

    while (true) {
      if (node.tag === HostComponent) {
        var instance = node.stateNode;

        if (isHidden) {
          hideInstance(instance);
        } else {
          unhideInstance(node.stateNode, node.memoizedProps);
        }
      } else if (node.tag === HostText) {
        var _instance3 = node.stateNode;

        if (isHidden) {
          hideTextInstance(_instance3);
        } else {
          unhideTextInstance(_instance3, node.memoizedProps);
        }
      } else if ((node.tag === OffscreenComponent || node.tag === LegacyHiddenComponent) && node.memoizedState !== null && node !== finishedWork) ; else if (node.child !== null) {
        node.child.return = node;
        node = node.child;
        continue;
      }

      if (node === finishedWork) {
        return;
      }

      while (node.sibling === null) {
        if (node.return === null || node.return === finishedWork) {
          return;
        }

        node = node.return;
      }

      node.sibling.return = node.return;
      node = node.sibling;
    }
  }
}

function commitAttachRef(finishedWork) {
  var ref = finishedWork.ref;

  if (ref !== null) {
    var instance = finishedWork.stateNode;
    var instanceToUse;

    switch (finishedWork.tag) {
      case HostComponent:
        instanceToUse = getPublicInstance(instance);
        break;

      default:
        instanceToUse = instance;
    } // Moved outside to ensure DCE works with this flag

    if (typeof ref === 'function') {
      ref(instanceToUse);
    } else {
      {
        if (!ref.hasOwnProperty('current')) {
          error('Unexpected ref object provided for %s. ' + 'Use either a ref-setter function or React.createRef().', getComponentName(finishedWork.type));
        }
      }

      ref.current = instanceToUse;
    }
  }
}

function commitDetachRef(current) {
  var currentRef = current.ref;

  if (currentRef !== null) {
    if (typeof currentRef === 'function') {
      currentRef(null);
    } else {
      currentRef.current = null;
    }
  }
} // User-originating errors (lifecycles and refs) should not interrupt
// deletion, so don't let them throw. Host-originating errors should
// interrupt deletion, so it's okay


function commitUnmount(finishedRoot, current, renderPriorityLevel) {
  onCommitUnmount(current);

  switch (current.tag) {
    case FunctionComponent:
    case ForwardRef:
    case MemoComponent:
    case SimpleMemoComponent:
    case Block:
      {
        var updateQueue = current.updateQueue;

        if (updateQueue !== null) {
          var lastEffect = updateQueue.lastEffect;

          if (lastEffect !== null) {
            var firstEffect = lastEffect.next;
            var effect = firstEffect;

            do {
              var _effect2 = effect,
                  destroy = _effect2.destroy,
                  tag = _effect2.tag;

              if (destroy !== undefined) {
                if ((tag & Passive$1) !== NoFlags$1) {
                  enqueuePendingPassiveHookEffectUnmount(current, effect);
                } else {
                  {
                    safelyCallDestroy(current, destroy);
                  }
                }
              }

              effect = effect.next;
            } while (effect !== firstEffect);
          }
        }

        return;
      }

    case ClassComponent:
      {
        safelyDetachRef(current);
        var instance = current.stateNode;

        if (typeof instance.componentWillUnmount === 'function') {
          safelyCallComponentWillUnmount(current, instance);
        }

        return;
      }

    case HostComponent:
      {
        safelyDetachRef(current);
        return;
      }

    case HostPortal:
      {
        // TODO: this is recursive.
        // We are also not using this parent because
        // the portal will get pushed immediately.
        {
          unmountHostComponents(finishedRoot, current);
        }

        return;
      }

    case FundamentalComponent:
      {

        return;
      }

    case DehydratedFragment:
      {

        return;
      }

    case ScopeComponent:
      {

        return;
      }
  }
}

function commitNestedUnmounts(finishedRoot, root, renderPriorityLevel) {
  // While we're inside a removed host node we don't want to call
  // removeChild on the inner nodes because they're removed by the top
  // call anyway. We also want to call componentWillUnmount on all
  // composites before this host node is removed from the tree. Therefore
  // we do an inner loop while we're still inside the host node.
  var node = root;

  while (true) {
    commitUnmount(finishedRoot, node); // Visit children because they may contain more composite or host nodes.
    // Skip portals because commitUnmount() currently visits them recursively.

    if (node.child !== null && ( // If we use mutation we drill down into portals using commitUnmount above.
    // If we don't use mutation we drill down into portals here instead.
     node.tag !== HostPortal)) {
      node.child.return = node;
      node = node.child;
      continue;
    }

    if (node === root) {
      return;
    }

    while (node.sibling === null) {
      if (node.return === null || node.return === root) {
        return;
      }

      node = node.return;
    }

    node.sibling.return = node.return;
    node = node.sibling;
  }
}

function detachFiberMutation(fiber) {
  // Cut off the return pointers to disconnect it from the tree. Ideally, we
  // should clear the child pointer of the parent alternate to let this
  // get GC:ed but we don't know which for sure which parent is the current
  // one so we'll settle for GC:ing the subtree of this child. This child
  // itself will be GC:ed when the parent updates the next time.
  // Note: we cannot null out sibling here, otherwise it can cause issues
  // with findDOMNode and how it requires the sibling field to carry out
  // traversal in a later effect. See PR #16820. We now clear the sibling
  // field after effects, see: detachFiberAfterEffects.
  //
  // Don't disconnect stateNode now; it will be detached in detachFiberAfterEffects.
  // It may be required if the current component is an error boundary,
  // and one of its descendants throws while unmounting a passive effect.
  fiber.alternate = null;
  fiber.child = null;
  fiber.dependencies = null;
  fiber.firstEffect = null;
  fiber.lastEffect = null;
  fiber.memoizedProps = null;
  fiber.memoizedState = null;
  fiber.pendingProps = null;
  fiber.return = null;
  fiber.updateQueue = null;

  {
    fiber._debugOwner = null;
  }
}

function getHostParentFiber(fiber) {
  var parent = fiber.return;

  while (parent !== null) {
    if (isHostParent(parent)) {
      return parent;
    }

    parent = parent.return;
  }

  {
    {
      throw Error( "Expected to find a host parent. This error is likely caused by a bug in React. Please file an issue." );
    }
  }
}

function isHostParent(fiber) {
  return fiber.tag === HostComponent || fiber.tag === HostRoot || fiber.tag === HostPortal;
}

function getHostSibling(fiber) {
  // We're going to search forward into the tree until we find a sibling host
  // node. Unfortunately, if multiple insertions are done in a row we have to
  // search past them. This leads to exponential search for the next sibling.
  // TODO: Find a more efficient way to do this.
  var node = fiber;

  siblings: while (true) {
    // If we didn't find anything, let's try the next sibling.
    while (node.sibling === null) {
      if (node.return === null || isHostParent(node.return)) {
        // If we pop out of the root or hit the parent the fiber we are the
        // last sibling.
        return null;
      }

      node = node.return;
    }

    node.sibling.return = node.return;
    node = node.sibling;

    while (node.tag !== HostComponent && node.tag !== HostText && node.tag !== DehydratedFragment) {
      // If it is not host node and, we might have a host node inside it.
      // Try to search down until we find one.
      if (node.flags & Placement) {
        // If we don't have a child, try the siblings instead.
        continue siblings;
      } // If we don't have a child, try the siblings instead.
      // We also skip portals because they are not part of this host tree.


      if (node.child === null || node.tag === HostPortal) {
        continue siblings;
      } else {
        node.child.return = node;
        node = node.child;
      }
    } // Check if this host node is stable or about to be placed.


    if (!(node.flags & Placement)) {
      // Found it!
      return node.stateNode;
    }
  }
}

function commitPlacement(finishedWork) {


  var parentFiber = getHostParentFiber(finishedWork); // Note: these two variables *must* always be updated together.

  var parent;
  var isContainer;
  var parentStateNode = parentFiber.stateNode;

  switch (parentFiber.tag) {
    case HostComponent:
      parent = parentStateNode;
      isContainer = false;
      break;

    case HostRoot:
      parent = parentStateNode.containerInfo;
      isContainer = true;
      break;

    case HostPortal:
      parent = parentStateNode.containerInfo;
      isContainer = true;
      break;

    case FundamentalComponent:

    // eslint-disable-next-line-no-fallthrough

    default:
      {
        {
          throw Error( "Invalid host parent fiber. This error is likely caused by a bug in React. Please file an issue." );
        }
      }

  }

  if (parentFiber.flags & ContentReset) {
    // Reset the text content of the parent before doing any insertions
    resetTextContent(parent); // Clear ContentReset from the effect tag

    parentFiber.flags &= ~ContentReset;
  }

  var before = getHostSibling(finishedWork); // We only have the top Fiber that was inserted but we need to recurse down its
  // children to find all the terminal nodes.

  if (isContainer) {
    insertOrAppendPlacementNodeIntoContainer(finishedWork, before, parent);
  } else {
    insertOrAppendPlacementNode(finishedWork, before, parent);
  }
}

function insertOrAppendPlacementNodeIntoContainer(node, before, parent) {
  var tag = node.tag;
  var isHost = tag === HostComponent || tag === HostText;

  if (isHost || enableFundamentalAPI ) {
    var stateNode = isHost ? node.stateNode : node.stateNode.instance;

    if (before) {
      insertInContainerBefore(parent, stateNode, before);
    } else {
      appendChildToContainer(parent, stateNode);
    }
  } else if (tag === HostPortal) ; else {
    var child = node.child;

    if (child !== null) {
      insertOrAppendPlacementNodeIntoContainer(child, before, parent);
      var sibling = child.sibling;

      while (sibling !== null) {
        insertOrAppendPlacementNodeIntoContainer(sibling, before, parent);
        sibling = sibling.sibling;
      }
    }
  }
}

function insertOrAppendPlacementNode(node, before, parent) {
  var tag = node.tag;
  var isHost = tag === HostComponent || tag === HostText;

  if (isHost || enableFundamentalAPI ) {
    var stateNode = isHost ? node.stateNode : node.stateNode.instance;

    if (before) {
      insertBefore(parent, stateNode, before);
    } else {
      appendChild(parent, stateNode);
    }
  } else if (tag === HostPortal) ; else {
    var child = node.child;

    if (child !== null) {
      insertOrAppendPlacementNode(child, before, parent);
      var sibling = child.sibling;

      while (sibling !== null) {
        insertOrAppendPlacementNode(sibling, before, parent);
        sibling = sibling.sibling;
      }
    }
  }
}

function unmountHostComponents(finishedRoot, current, renderPriorityLevel) {
  // We only have the top Fiber that was deleted but we need to recurse down its
  // children to find all the terminal nodes.
  var node = current; // Each iteration, currentParent is populated with node's host parent if not
  // currentParentIsValid.

  var currentParentIsValid = false; // Note: these two variables *must* always be updated together.

  var currentParent;
  var currentParentIsContainer;

  while (true) {
    if (!currentParentIsValid) {
      var parent = node.return;

      findParent: while (true) {
        if (!(parent !== null)) {
          {
            throw Error( "Expected to find a host parent. This error is likely caused by a bug in React. Please file an issue." );
          }
        }

        var parentStateNode = parent.stateNode;

        switch (parent.tag) {
          case HostComponent:
            currentParent = parentStateNode;
            currentParentIsContainer = false;
            break findParent;

          case HostRoot:
            currentParent = parentStateNode.containerInfo;
            currentParentIsContainer = true;
            break findParent;

          case HostPortal:
            currentParent = parentStateNode.containerInfo;
            currentParentIsContainer = true;
            break findParent;

        }

        parent = parent.return;
      }

      currentParentIsValid = true;
    }

    if (node.tag === HostComponent || node.tag === HostText) {
      commitNestedUnmounts(finishedRoot, node); // After all the children have unmounted, it is now safe to remove the
      // node from the tree.

      if (currentParentIsContainer) {
        removeChildFromContainer(currentParent, node.stateNode);
      } else {
        removeChild(currentParent, node.stateNode);
      } // Don't visit children because we already visited them.

    } else if (node.tag === HostPortal) {
      if (node.child !== null) {
        // When we go into a portal, it becomes the parent to remove from.
        // We will reassign it back when we pop the portal on the way up.
        currentParent = node.stateNode.containerInfo;
        currentParentIsContainer = true; // Visit children because portals might contain host components.

        node.child.return = node;
        node = node.child;
        continue;
      }
    } else {
      commitUnmount(finishedRoot, node); // Visit children because we may find more host components below.

      if (node.child !== null) {
        node.child.return = node;
        node = node.child;
        continue;
      }
    }

    if (node === current) {
      return;
    }

    while (node.sibling === null) {
      if (node.return === null || node.return === current) {
        return;
      }

      node = node.return;

      if (node.tag === HostPortal) {
        // When we go out of the portal, we need to restore the parent.
        // Since we don't keep a stack of them, we will search for it.
        currentParentIsValid = false;
      }
    }

    node.sibling.return = node.return;
    node = node.sibling;
  }
}

function commitDeletion(finishedRoot, current, renderPriorityLevel) {
  {
    // Recursively delete all host nodes from the parent.
    // Detach refs and call componentWillUnmount() on the whole subtree.
    unmountHostComponents(finishedRoot, current);
  }

  var alternate = current.alternate;
  detachFiberMutation(current);

  if (alternate !== null) {
    detachFiberMutation(alternate);
  }
}

function commitWork(current, finishedWork) {

  switch (finishedWork.tag) {
    case FunctionComponent:
    case ForwardRef:
    case MemoComponent:
    case SimpleMemoComponent:
    case Block:
      {
        // Layout effects are destroyed during the mutation phase so that all
        // destroy functions for all fibers are called before any create functions.
        // This prevents sibling component effects from interfering with each other,
        // e.g. a destroy function in one component should never override a ref set
        // by a create function in another component during the same commit.
        {
          commitHookEffectListUnmount(Layout | HasEffect, finishedWork);
        }

        return;
      }

    case ClassComponent:
      {
        return;
      }

    case HostComponent:
      {
        var instance = finishedWork.stateNode;

        if (instance != null) {
          // Commit the work prepared earlier.
          var newProps = finishedWork.memoizedProps; // For hydration we reuse the update path but we treat the oldProps
          // as the newProps. The updatePayload will contain the real change in
          // this case.

          var oldProps = current !== null ? current.memoizedProps : newProps;
          var type = finishedWork.type; // TODO: Type the updateQueue to be specific to host components.

          var updatePayload = finishedWork.updateQueue;
          finishedWork.updateQueue = null;

          if (updatePayload !== null) {
            commitUpdate(instance, updatePayload, type, oldProps, newProps);
          }
        }

        return;
      }

    case HostText:
      {
        if (!(finishedWork.stateNode !== null)) {
          {
            throw Error( "This should have a text node initialized. This error is likely caused by a bug in React. Please file an issue." );
          }
        }

        var textInstance = finishedWork.stateNode;
        var newText = finishedWork.memoizedProps; // For hydration we reuse the update path but we treat the oldProps
        // as the newProps. The updatePayload will contain the real change in
        // this case.

        var oldText = current !== null ? current.memoizedProps : newText;
        commitTextUpdate(textInstance, oldText, newText);
        return;
      }

    case HostRoot:
      {
        {
          var _root = finishedWork.stateNode;

          if (_root.hydrate) {
            // We've just hydrated. No need to hydrate again.
            _root.hydrate = false;
            commitHydratedContainer(_root.containerInfo);
          }
        }

        return;
      }

    case Profiler:
      {
        return;
      }

    case SuspenseComponent:
      {
        commitSuspenseComponent(finishedWork);
        attachSuspenseRetryListeners(finishedWork);
        return;
      }

    case SuspenseListComponent:
      {
        attachSuspenseRetryListeners(finishedWork);
        return;
      }

    case IncompleteClassComponent:
      {
        return;
      }

    case FundamentalComponent:
      {

        break;
      }

    case ScopeComponent:
      {

        break;
      }

    case OffscreenComponent:
    case LegacyHiddenComponent:
      {
        var newState = finishedWork.memoizedState;
        var isHidden = newState !== null;
        hideOrUnhideAllChildren(finishedWork, isHidden);
        return;
      }
  }

  {
    {
      throw Error( "This unit of work tag should not have side-effects. This error is likely caused by a bug in React. Please file an issue." );
    }
  }
}

function commitSuspenseComponent(finishedWork) {
  var newState = finishedWork.memoizedState;

  if (newState !== null) {
    markCommitTimeOfFallback();

    {
      // Hide the Offscreen component that contains the primary children. TODO:
      // Ideally, this effect would have been scheduled on the Offscreen fiber
      // itself. That's how unhiding works: the Offscreen component schedules an
      // effect on itself. However, in this case, the component didn't complete,
      // so the fiber was never added to the effect list in the normal path. We
      // could have appended it to the effect list in the Suspense component's
      // second pass, but doing it this way is less complicated. This would be
      // simpler if we got rid of the effect list and traversed the tree, like
      // we're planning to do.
      var primaryChildParent = finishedWork.child;
      hideOrUnhideAllChildren(primaryChildParent, true);
    }
  }
}

function commitSuspenseHydrationCallbacks(finishedRoot, finishedWork) {

  var newState = finishedWork.memoizedState;

  if (newState === null) {
    var current = finishedWork.alternate;

    if (current !== null) {
      var prevState = current.memoizedState;

      if (prevState !== null) {
        var suspenseInstance = prevState.dehydrated;

        if (suspenseInstance !== null) {
          commitHydratedSuspenseInstance(suspenseInstance);
        }
      }
    }
  }
}

function attachSuspenseRetryListeners(finishedWork) {
  // If this boundary just timed out, then it will have a set of wakeables.
  // For each wakeable, attach a listener so that when it resolves, React
  // attempts to re-render the boundary in the primary (pre-timeout) state.
  var wakeables = finishedWork.updateQueue;

  if (wakeables !== null) {
    finishedWork.updateQueue = null;
    var retryCache = finishedWork.stateNode;

    if (retryCache === null) {
      retryCache = finishedWork.stateNode = new PossiblyWeakSet();
    }

    wakeables.forEach(function (wakeable) {
      // Memoize using the boundary fiber to prevent redundant listeners.
      var retry = resolveRetryWakeable.bind(null, finishedWork, wakeable);

      if (!retryCache.has(wakeable)) {
        {
          if (wakeable.__reactDoNotTraceInteractions !== true) {
            retry = tracing.unstable_wrap(retry);
          }
        }

        retryCache.add(wakeable);
        wakeable.then(retry, retry);
      }
    });
  }
} // This function detects when a Suspense boundary goes from visible to hidden.
// It returns false if the boundary is already hidden.
// TODO: Use an effect tag.


function isSuspenseBoundaryBeingHidden(current, finishedWork) {
  if (current !== null) {
    var oldState = current.memoizedState;

    if (oldState === null || oldState.dehydrated !== null) {
      var newState = finishedWork.memoizedState;
      return newState !== null && newState.dehydrated === null;
    }
  }

  return false;
}

function commitResetTextContent(current) {

  resetTextContent(current.stateNode);
}

var COMPONENT_TYPE = 0;
var HAS_PSEUDO_CLASS_TYPE = 1;
var ROLE_TYPE = 2;
var TEST_NAME_TYPE = 3;
var TEXT_TYPE = 4;

if (typeof Symbol === 'function' && Symbol.for) {
  var symbolFor$1 = Symbol.for;
  COMPONENT_TYPE = symbolFor$1('selector.component');
  HAS_PSEUDO_CLASS_TYPE = symbolFor$1('selector.has_pseudo_class');
  ROLE_TYPE = symbolFor$1('selector.role');
  TEST_NAME_TYPE = symbolFor$1('selector.test_id');
  TEXT_TYPE = symbolFor$1('selector.text');
}
var commitHooks = [];
function onCommitRoot$1() {
  {
    commitHooks.forEach(function (commitHook) {
      return commitHook();
    });
  }
}

var ceil = Math.ceil;
var ReactCurrentDispatcher$2 = ReactSharedInternals.ReactCurrentDispatcher,
    ReactCurrentOwner$2 = ReactSharedInternals.ReactCurrentOwner,
    IsSomeRendererActing = ReactSharedInternals.IsSomeRendererActing;
var NoContext =
/*             */
0;
var BatchedContext =
/*               */
1;
var EventContext =
/*                 */
2;
var DiscreteEventContext =
/*         */
4;
var LegacyUnbatchedContext =
/*       */
8;
var RenderContext =
/*                */
16;
var CommitContext =
/*                */
32;
var RetryAfterError =
/*       */
64;
var RootIncomplete = 0;
var RootFatalErrored = 1;
var RootErrored = 2;
var RootSuspended = 3;
var RootSuspendedWithDelay = 4;
var RootCompleted = 5; // Describes where we are in the React execution stack

var executionContext = NoContext; // The root we're working on

var workInProgressRoot = null; // The fiber we're working on

var workInProgress = null; // The lanes we're rendering

var workInProgressRootRenderLanes = NoLanes; // Stack that allows components to change the render lanes for its subtree
// This is a superset of the lanes we started working on at the root. The only
// case where it's different from `workInProgressRootRenderLanes` is when we
// enter a subtree that is hidden and needs to be unhidden: Suspense and
// Offscreen component.
//
// Most things in the work loop should deal with workInProgressRootRenderLanes.
// Most things in begin/complete phases should deal with subtreeRenderLanes.

var subtreeRenderLanes = NoLanes;
var subtreeRenderLanesCursor = createCursor(NoLanes); // Whether to root completed, errored, suspended, etc.

var workInProgressRootExitStatus = RootIncomplete; // A fatal error, if one is thrown

var workInProgressRootFatalError = null; // "Included" lanes refer to lanes that were worked on during this render. It's
// slightly different than `renderLanes` because `renderLanes` can change as you
// enter and exit an Offscreen tree. This value is the combination of all render
// lanes for the entire render phase.

var workInProgressRootIncludedLanes = NoLanes; // The work left over by components that were visited during this render. Only
// includes unprocessed updates, not work in bailed out children.

var workInProgressRootSkippedLanes = NoLanes; // Lanes that were updated (in an interleaved event) during this render.

var workInProgressRootUpdatedLanes = NoLanes; // Lanes that were pinged (in an interleaved event) during this render.

var workInProgressRootPingedLanes = NoLanes;
var mostRecentlyUpdatedRoot = null; // The most recent time we committed a fallback. This lets us ensure a train
// model where we don't commit new loading states in too quick succession.

var globalMostRecentFallbackTime = 0;
var FALLBACK_THROTTLE_MS = 500; // The absolute time for when we should start giving up on rendering
// more and prefer CPU suspense heuristics instead.

var workInProgressRootRenderTargetTime = Infinity; // How long a render is supposed to take before we start following CPU
// suspense heuristics and opt out of rendering more content.

var RENDER_TIMEOUT_MS = 500;

function resetRenderTimer() {
  workInProgressRootRenderTargetTime = now() + RENDER_TIMEOUT_MS;
}

function getRenderTargetTime() {
  return workInProgressRootRenderTargetTime;
}
var nextEffect = null;
var hasUncaughtError = false;
var firstUncaughtError = null;
var legacyErrorBoundariesThatAlreadyFailed = null;
var rootDoesHavePassiveEffects = false;
var rootWithPendingPassiveEffects = null;
var pendingPassiveEffectsRenderPriority = NoPriority$1;
var pendingPassiveEffectsLanes = NoLanes;
var pendingPassiveHookEffectsMount = [];
var pendingPassiveHookEffectsUnmount = [];
var rootsWithPendingDiscreteUpdates = null; // Use these to prevent an infinite loop of nested updates

var NESTED_UPDATE_LIMIT = 50;
var nestedUpdateCount = 0;
var rootWithNestedUpdates = null;
var NESTED_PASSIVE_UPDATE_LIMIT = 50;
var nestedPassiveUpdateCount = 0; // Marks the need to reschedule pending interactions at these lanes
// during the commit phase. This enables them to be traced across components
// that spawn new work during render. E.g. hidden boundaries, suspended SSR
// hydration or SuspenseList.
// TODO: Can use a bitmask instead of an array

var spawnedWorkDuringRender = null; // If two updates are scheduled within the same event, we should treat their
// event times as simultaneous, even if the actual clock time has advanced
// between the first and second call.

var currentEventTime = NoTimestamp;
var currentEventWipLanes = NoLanes;
var currentEventPendingLanes = NoLanes; // Dev only flag that tracks if passive effects are currently being flushed.
// We warn about state updates for unmounted components differently in this case.

var isFlushingPassiveEffects = false;
var focusedInstanceHandle = null;
var shouldFireAfterActiveInstanceBlur = false;
function getWorkInProgressRoot() {
  return workInProgressRoot;
}
function requestEventTime() {
  if ((executionContext & (RenderContext | CommitContext)) !== NoContext) {
    // We're inside React, so it's fine to read the actual time.
    return now();
  } // We're not inside React, so we may be in the middle of a browser event.


  if (currentEventTime !== NoTimestamp) {
    // Use the same start time for all updates until we enter React again.
    return currentEventTime;
  } // This is the first update since React yielded. Compute a new start time.


  currentEventTime = now();
  return currentEventTime;
}
function requestUpdateLane(fiber) {
  // Special cases
  var mode = fiber.mode;

  if ((mode & BlockingMode) === NoMode) {
    return SyncLane;
  } else if ((mode & ConcurrentMode) === NoMode) {
    return getCurrentPriorityLevel() === ImmediatePriority$1 ? SyncLane : SyncBatchedLane;
  } // The algorithm for assigning an update to a lane should be stable for all
  // updates at the same priority within the same event. To do this, the inputs
  // to the algorithm must be the same. For example, we use the `renderLanes`
  // to avoid choosing a lane that is already in the middle of rendering.
  //
  // However, the "included" lanes could be mutated in between updates in the
  // same event, like if you perform an update inside `flushSync`. Or any other
  // code path that might call `prepareFreshStack`.
  //
  // The trick we use is to cache the first of each of these inputs within an
  // event. Then reset the cached values once we can be sure the event is over.
  // Our heuristic for that is whenever we enter a concurrent work loop.
  //
  // We'll do the same for `currentEventPendingLanes` below.


  if (currentEventWipLanes === NoLanes) {
    currentEventWipLanes = workInProgressRootIncludedLanes;
  }

  var isTransition = requestCurrentTransition() !== NoTransition;

  if (isTransition) {
    if (currentEventPendingLanes !== NoLanes) {
      currentEventPendingLanes = mostRecentlyUpdatedRoot !== null ? mostRecentlyUpdatedRoot.pendingLanes : NoLanes;
    }

    return findTransitionLane(currentEventWipLanes, currentEventPendingLanes);
  } // TODO: Remove this dependency on the Scheduler priority.
  // To do that, we're replacing it with an update lane priority.


  var schedulerPriority = getCurrentPriorityLevel(); // The old behavior was using the priority level of the Scheduler.
  // This couples React to the Scheduler internals, so we're replacing it
  // with the currentUpdateLanePriority above. As an example of how this
  // could be problematic, if we're not inside `Scheduler.runWithPriority`,
  // then we'll get the priority of the current running Scheduler task,
  // which is probably not what we want.

  var lane;

  if ( // TODO: Temporary. We're removing the concept of discrete updates.
  (executionContext & DiscreteEventContext) !== NoContext && schedulerPriority === UserBlockingPriority$2) {
    lane = findUpdateLane(InputDiscreteLanePriority, currentEventWipLanes);
  } else {
    var schedulerLanePriority = schedulerPriorityToLanePriority(schedulerPriority);

    lane = findUpdateLane(schedulerLanePriority, currentEventWipLanes);
  }

  return lane;
}

function requestRetryLane(fiber) {
  // This is a fork of `requestUpdateLane` designed specifically for Suspense
  // "retries" — a special update that attempts to flip a Suspense boundary
  // from its placeholder state to its primary/resolved state.
  // Special cases
  var mode = fiber.mode;

  if ((mode & BlockingMode) === NoMode) {
    return SyncLane;
  } else if ((mode & ConcurrentMode) === NoMode) {
    return getCurrentPriorityLevel() === ImmediatePriority$1 ? SyncLane : SyncBatchedLane;
  } // See `requestUpdateLane` for explanation of `currentEventWipLanes`


  if (currentEventWipLanes === NoLanes) {
    currentEventWipLanes = workInProgressRootIncludedLanes;
  }

  return findRetryLane(currentEventWipLanes);
}

function scheduleUpdateOnFiber(fiber, lane, eventTime) {
  checkForNestedUpdates();
  warnAboutRenderPhaseUpdatesInDEV(fiber);
  var root = markUpdateLaneFromFiberToRoot(fiber, lane);

  if (root === null) {
    warnAboutUpdateOnUnmountedFiberInDEV(fiber);
    return null;
  } // Mark that the root has a pending update.


  markRootUpdated(root, lane, eventTime);

  if (root === workInProgressRoot) {
    // Received an update to a tree that's in the middle of rendering. Mark
    // that there was an interleaved update work on this root. Unless the
    // `deferRenderPhaseUpdateToNextBatch` flag is off and this is a render
    // phase update. In that case, we don't treat render phase updates as if
    // they were interleaved, for backwards compat reasons.
    {
      workInProgressRootUpdatedLanes = mergeLanes(workInProgressRootUpdatedLanes, lane);
    }

    if (workInProgressRootExitStatus === RootSuspendedWithDelay) {
      // The root already suspended with a delay, which means this render
      // definitely won't finish. Since we have a new update, let's mark it as
      // suspended now, right before marking the incoming update. This has the
      // effect of interrupting the current render and switching to the update.
      // TODO: Make sure this doesn't override pings that happen while we've
      // already started rendering.
      markRootSuspended$1(root, workInProgressRootRenderLanes);
    }
  } // TODO: requestUpdateLanePriority also reads the priority. Pass the
  // priority as an argument to that function and this one.


  var priorityLevel = getCurrentPriorityLevel();

  if (lane === SyncLane) {
    if ( // Check if we're inside unbatchedUpdates
    (executionContext & LegacyUnbatchedContext) !== NoContext && // Check if we're not already rendering
    (executionContext & (RenderContext | CommitContext)) === NoContext) {
      // Register pending interactions on the root to avoid losing traced interaction data.
      schedulePendingInteractions(root, lane); // This is a legacy edge case. The initial mount of a ReactDOM.render-ed
      // root inside of batchedUpdates should be synchronous, but layout updates
      // should be deferred until the end of the batch.

      performSyncWorkOnRoot(root);
    } else {
      ensureRootIsScheduled(root, eventTime);
      schedulePendingInteractions(root, lane);

      if (executionContext === NoContext) {
        // Flush the synchronous work now, unless we're already working or inside
        // a batch. This is intentionally inside scheduleUpdateOnFiber instead of
        // scheduleCallbackForFiber to preserve the ability to schedule a callback
        // without immediately flushing it. We only do this for user-initiated
        // updates, to preserve historical behavior of legacy mode.
        resetRenderTimer();
        flushSyncCallbackQueue();
      }
    }
  } else {
    // Schedule a discrete update but only if it's not Sync.
    if ((executionContext & DiscreteEventContext) !== NoContext && ( // Only updates at user-blocking priority or greater are considered
    // discrete, even inside a discrete event.
    priorityLevel === UserBlockingPriority$2 || priorityLevel === ImmediatePriority$1)) {
      // This is the result of a discrete event. Track the lowest priority
      // discrete update per root so we can flush them early, if needed.
      if (rootsWithPendingDiscreteUpdates === null) {
        rootsWithPendingDiscreteUpdates = new Set([root]);
      } else {
        rootsWithPendingDiscreteUpdates.add(root);
      }
    } // Schedule other updates after in case the callback is sync.


    ensureRootIsScheduled(root, eventTime);
    schedulePendingInteractions(root, lane);
  } // We use this when assigning a lane for a transition inside
  // `requestUpdateLane`. We assume it's the same as the root being updated,
  // since in the common case of a single root app it probably is. If it's not
  // the same root, then it's not a huge deal, we just might batch more stuff
  // together more than necessary.


  mostRecentlyUpdatedRoot = root;
} // This is split into a separate function so we can mark a fiber with pending
// work without treating it as a typical update that originates from an event;
// e.g. retrying a Suspense boundary isn't an update, but it does schedule work
// on a fiber.

function markUpdateLaneFromFiberToRoot(sourceFiber, lane) {
  // Update the source fiber's lanes
  sourceFiber.lanes = mergeLanes(sourceFiber.lanes, lane);
  var alternate = sourceFiber.alternate;

  if (alternate !== null) {
    alternate.lanes = mergeLanes(alternate.lanes, lane);
  }

  {
    if (alternate === null && (sourceFiber.flags & (Placement | Hydrating)) !== NoFlags) {
      warnAboutUpdateOnNotYetMountedFiberInDEV(sourceFiber);
    }
  } // Walk the parent path to the root and update the child expiration time.


  var node = sourceFiber;
  var parent = sourceFiber.return;

  while (parent !== null) {
    parent.childLanes = mergeLanes(parent.childLanes, lane);
    alternate = parent.alternate;

    if (alternate !== null) {
      alternate.childLanes = mergeLanes(alternate.childLanes, lane);
    } else {
      {
        if ((parent.flags & (Placement | Hydrating)) !== NoFlags) {
          warnAboutUpdateOnNotYetMountedFiberInDEV(sourceFiber);
        }
      }
    }

    node = parent;
    parent = parent.return;
  }

  if (node.tag === HostRoot) {
    var root = node.stateNode;
    return root;
  } else {
    return null;
  }
} // Use this function to schedule a task for a root. There's only one task per
// root; if a task was already scheduled, we'll check to make sure the priority
// of the existing task is the same as the priority of the next level that the
// root has work on. This function is called on every update, and right before
// exiting a task.


function ensureRootIsScheduled(root, currentTime) {
  var existingCallbackNode = root.callbackNode; // Check if any lanes are being starved by other work. If so, mark them as
  // expired so we know to work on those next.

  markStarvedLanesAsExpired(root, currentTime); // Determine the next lanes to work on, and their priority.

  var nextLanes = getNextLanes(root, root === workInProgressRoot ? workInProgressRootRenderLanes : NoLanes); // This returns the priority level computed during the `getNextLanes` call.

  var newCallbackPriority = returnNextLanesPriority();

  if (nextLanes === NoLanes) {
    // Special case: There's nothing to work on.
    if (existingCallbackNode !== null) {
      cancelCallback(existingCallbackNode);
      root.callbackNode = null;
      root.callbackPriority = NoLanePriority;
    }

    return;
  } // Check if there's an existing task. We may be able to reuse it.


  if (existingCallbackNode !== null) {
    var existingCallbackPriority = root.callbackPriority;

    if (existingCallbackPriority === newCallbackPriority) {
      // The priority hasn't changed. We can reuse the existing task. Exit.
      return;
    } // The priority changed. Cancel the existing callback. We'll schedule a new
    // one below.


    cancelCallback(existingCallbackNode);
  } // Schedule a new callback.


  var newCallbackNode;

  if (newCallbackPriority === SyncLanePriority) {
    // Special case: Sync React callbacks are scheduled on a special
    // internal queue
    newCallbackNode = scheduleSyncCallback(performSyncWorkOnRoot.bind(null, root));
  } else if (newCallbackPriority === SyncBatchedLanePriority) {
    newCallbackNode = scheduleCallback(ImmediatePriority$1, performSyncWorkOnRoot.bind(null, root));
  } else {
    var schedulerPriorityLevel = lanePriorityToSchedulerPriority(newCallbackPriority);
    newCallbackNode = scheduleCallback(schedulerPriorityLevel, performConcurrentWorkOnRoot.bind(null, root));
  }

  root.callbackPriority = newCallbackPriority;
  root.callbackNode = newCallbackNode;
} // This is the entry point for every concurrent task, i.e. anything that
// goes through Scheduler.


function performConcurrentWorkOnRoot(root) {
  // Since we know we're in a React event, we can clear the current
  // event time. The next update will compute a new event time.
  currentEventTime = NoTimestamp;
  currentEventWipLanes = NoLanes;
  currentEventPendingLanes = NoLanes;

  if (!((executionContext & (RenderContext | CommitContext)) === NoContext)) {
    {
      throw Error( "Should not already be working." );
    }
  } // Flush any pending passive effects before deciding which lanes to work on,
  // in case they schedule additional work.


  var originalCallbackNode = root.callbackNode;
  var didFlushPassiveEffects = flushPassiveEffects();

  if (didFlushPassiveEffects) {
    // Something in the passive effect phase may have canceled the current task.
    // Check if the task node for this root was changed.
    if (root.callbackNode !== originalCallbackNode) {
      // The current task was canceled. Exit. We don't need to call
      // `ensureRootIsScheduled` because the check above implies either that
      // there's a new task, or that there's no remaining work on this root.
      return null;
    }
  } // Determine the next expiration time to work on, using the fields stored
  // on the root.


  var lanes = getNextLanes(root, root === workInProgressRoot ? workInProgressRootRenderLanes : NoLanes);

  if (lanes === NoLanes) {
    // Defensive coding. This is never expected to happen.
    return null;
  }

  var exitStatus = renderRootConcurrent(root, lanes);

  if (includesSomeLane(workInProgressRootIncludedLanes, workInProgressRootUpdatedLanes)) {
    // The render included lanes that were updated during the render phase.
    // For example, when unhiding a hidden tree, we include all the lanes
    // that were previously skipped when the tree was hidden. That set of
    // lanes is a superset of the lanes we started rendering with.
    //
    // So we'll throw out the current work and restart.
    prepareFreshStack(root, NoLanes);
  } else if (exitStatus !== RootIncomplete) {
    if (exitStatus === RootErrored) {
      executionContext |= RetryAfterError; // If an error occurred during hydration,
      // discard server response and fall back to client side render.

      if (root.hydrate) {
        root.hydrate = false;
        clearContainer(root.containerInfo);
      } // If something threw an error, try rendering one more time. We'll render
      // synchronously to block concurrent data mutations, and we'll includes
      // all pending updates are included. If it still fails after the second
      // attempt, we'll give up and commit the resulting tree.


      lanes = getLanesToRetrySynchronouslyOnError(root);

      if (lanes !== NoLanes) {
        exitStatus = renderRootSync(root, lanes);
      }
    }

    if (exitStatus === RootFatalErrored) {
      var fatalError = workInProgressRootFatalError;
      prepareFreshStack(root, NoLanes);
      markRootSuspended$1(root, lanes);
      ensureRootIsScheduled(root, now());
      throw fatalError;
    } // We now have a consistent tree. The next step is either to commit it,
    // or, if something suspended, wait to commit it after a timeout.


    var finishedWork = root.current.alternate;
    root.finishedWork = finishedWork;
    root.finishedLanes = lanes;
    finishConcurrentRender(root, exitStatus, lanes);
  }

  ensureRootIsScheduled(root, now());

  if (root.callbackNode === originalCallbackNode) {
    // The task node scheduled for this root is the same one that's
    // currently executed. Need to return a continuation.
    return performConcurrentWorkOnRoot.bind(null, root);
  }

  return null;
}

function finishConcurrentRender(root, exitStatus, lanes) {
  switch (exitStatus) {
    case RootIncomplete:
    case RootFatalErrored:
      {
        {
          {
            throw Error( "Root did not complete. This is a bug in React." );
          }
        }
      }
    // Flow knows about invariant, so it complains if I add a break
    // statement, but eslint doesn't know about invariant, so it complains
    // if I do. eslint-disable-next-line no-fallthrough

    case RootErrored:
      {
        // We should have already attempted to retry this tree. If we reached
        // this point, it errored again. Commit it.
        commitRoot(root);
        break;
      }

    case RootSuspended:
      {
        markRootSuspended$1(root, lanes); // We have an acceptable loading state. We need to figure out if we
        // should immediately commit it or wait a bit.

        if (includesOnlyRetries(lanes) && // do not delay if we're inside an act() scope
        !shouldForceFlushFallbacksInDEV()) {
          // This render only included retries, no updates. Throttle committing
          // retries so that we don't show too many loading states too quickly.
          var msUntilTimeout = globalMostRecentFallbackTime + FALLBACK_THROTTLE_MS - now(); // Don't bother with a very short suspense time.

          if (msUntilTimeout > 10) {
            var nextLanes = getNextLanes(root, NoLanes);

            if (nextLanes !== NoLanes) {
              // There's additional work on this root.
              break;
            }

            var suspendedLanes = root.suspendedLanes;

            if (!isSubsetOfLanes(suspendedLanes, lanes)) {
              // We should prefer to render the fallback of at the last
              // suspended level. Ping the last suspended level to try
              // rendering it again.
              // FIXME: What if the suspended lanes are Idle? Should not restart.
              var eventTime = requestEventTime();
              markRootPinged(root, suspendedLanes);
              break;
            } // The render is suspended, it hasn't timed out, and there's no
            // lower priority work to do. Instead of committing the fallback
            // immediately, wait for more data to arrive.


            root.timeoutHandle = scheduleTimeout(commitRoot.bind(null, root), msUntilTimeout);
            break;
          }
        } // The work expired. Commit immediately.


        commitRoot(root);
        break;
      }

    case RootSuspendedWithDelay:
      {
        markRootSuspended$1(root, lanes);

        if (includesOnlyTransitions(lanes)) {
          // This is a transition, so we should exit without committing a
          // placeholder and without scheduling a timeout. Delay indefinitely
          // until we receive more data.
          break;
        }

        if (!shouldForceFlushFallbacksInDEV()) {
          // This is not a transition, but we did trigger an avoided state.
          // Schedule a placeholder to display after a short delay, using the Just
          // Noticeable Difference.
          // TODO: Is the JND optimization worth the added complexity? If this is
          // the only reason we track the event time, then probably not.
          // Consider removing.
          var mostRecentEventTime = getMostRecentEventTime(root, lanes);
          var eventTimeMs = mostRecentEventTime;
          var timeElapsedMs = now() - eventTimeMs;

          var _msUntilTimeout = jnd(timeElapsedMs) - timeElapsedMs; // Don't bother with a very short suspense time.


          if (_msUntilTimeout > 10) {
            // Instead of committing the fallback immediately, wait for more data
            // to arrive.
            root.timeoutHandle = scheduleTimeout(commitRoot.bind(null, root), _msUntilTimeout);
            break;
          }
        } // Commit the placeholder.


        commitRoot(root);
        break;
      }

    case RootCompleted:
      {
        // The work completed. Ready to commit.
        commitRoot(root);
        break;
      }

    default:
      {
        {
          {
            throw Error( "Unknown root exit status." );
          }
        }
      }
  }
}

function markRootSuspended$1(root, suspendedLanes) {
  // When suspending, we should always exclude lanes that were pinged or (more
  // rarely, since we try to avoid it) updated during the render phase.
  // TODO: Lol maybe there's a better way to factor this besides this
  // obnoxiously named function :)
  suspendedLanes = removeLanes(suspendedLanes, workInProgressRootPingedLanes);
  suspendedLanes = removeLanes(suspendedLanes, workInProgressRootUpdatedLanes);
  markRootSuspended(root, suspendedLanes);
} // This is the entry point for synchronous tasks that don't go
// through Scheduler


function performSyncWorkOnRoot(root) {
  if (!((executionContext & (RenderContext | CommitContext)) === NoContext)) {
    {
      throw Error( "Should not already be working." );
    }
  }

  flushPassiveEffects();
  var lanes;
  var exitStatus;

  if (root === workInProgressRoot && includesSomeLane(root.expiredLanes, workInProgressRootRenderLanes)) {
    // There's a partial tree, and at least one of its lanes has expired. Finish
    // rendering it before rendering the rest of the expired work.
    lanes = workInProgressRootRenderLanes;
    exitStatus = renderRootSync(root, lanes);

    if (includesSomeLane(workInProgressRootIncludedLanes, workInProgressRootUpdatedLanes)) {
      // The render included lanes that were updated during the render phase.
      // For example, when unhiding a hidden tree, we include all the lanes
      // that were previously skipped when the tree was hidden. That set of
      // lanes is a superset of the lanes we started rendering with.
      //
      // Note that this only happens when part of the tree is rendered
      // concurrently. If the whole tree is rendered synchronously, then there
      // are no interleaved events.
      lanes = getNextLanes(root, lanes);
      exitStatus = renderRootSync(root, lanes);
    }
  } else {
    lanes = getNextLanes(root, NoLanes);
    exitStatus = renderRootSync(root, lanes);
  }

  if (root.tag !== LegacyRoot && exitStatus === RootErrored) {
    executionContext |= RetryAfterError; // If an error occurred during hydration,
    // discard server response and fall back to client side render.

    if (root.hydrate) {
      root.hydrate = false;
      clearContainer(root.containerInfo);
    } // If something threw an error, try rendering one more time. We'll render
    // synchronously to block concurrent data mutations, and we'll includes
    // all pending updates are included. If it still fails after the second
    // attempt, we'll give up and commit the resulting tree.


    lanes = getLanesToRetrySynchronouslyOnError(root);

    if (lanes !== NoLanes) {
      exitStatus = renderRootSync(root, lanes);
    }
  }

  if (exitStatus === RootFatalErrored) {
    var fatalError = workInProgressRootFatalError;
    prepareFreshStack(root, NoLanes);
    markRootSuspended$1(root, lanes);
    ensureRootIsScheduled(root, now());
    throw fatalError;
  } // We now have a consistent tree. Because this is a sync render, we
  // will commit it even if something suspended.


  var finishedWork = root.current.alternate;
  root.finishedWork = finishedWork;
  root.finishedLanes = lanes;
  commitRoot(root); // Before exiting, make sure there's a callback scheduled for the next
  // pending level.

  ensureRootIsScheduled(root, now());
  return null;
}
function flushDiscreteUpdates() {
  // TODO: Should be able to flush inside batchedUpdates, but not inside `act`.
  // However, `act` uses `batchedUpdates`, so there's no way to distinguish
  // those two cases. Need to fix this before exposing flushDiscreteUpdates
  // as a public API.
  if ((executionContext & (BatchedContext | RenderContext | CommitContext)) !== NoContext) {
    {
      if ((executionContext & RenderContext) !== NoContext) {
        error('unstable_flushDiscreteUpdates: Cannot flush updates when React is ' + 'already rendering.');
      }
    } // We're already rendering, so we can't synchronously flush pending work.
    // This is probably a nested event dispatch triggered by a lifecycle/effect,
    // like `el.focus()`. Exit.


    return;
  }

  flushPendingDiscreteUpdates(); // If the discrete updates scheduled passive effects, flush them now so that
  // they fire before the next serial event.

  flushPassiveEffects();
}

function flushPendingDiscreteUpdates() {
  if (rootsWithPendingDiscreteUpdates !== null) {
    // For each root with pending discrete updates, schedule a callback to
    // immediately flush them.
    var roots = rootsWithPendingDiscreteUpdates;
    rootsWithPendingDiscreteUpdates = null;
    roots.forEach(function (root) {
      markDiscreteUpdatesExpired(root);
      ensureRootIsScheduled(root, now());
    });
  } // Now flush the immediate queue.


  flushSyncCallbackQueue();
}

function batchedUpdates$1(fn, a) {
  var prevExecutionContext = executionContext;
  executionContext |= BatchedContext;

  try {
    return fn(a);
  } finally {
    executionContext = prevExecutionContext;

    if (executionContext === NoContext) {
      // Flush the immediate callbacks that were scheduled during this batch
      resetRenderTimer();
      flushSyncCallbackQueue();
    }
  }
}
function batchedEventUpdates$1(fn, a) {
  var prevExecutionContext = executionContext;
  executionContext |= EventContext;

  try {
    return fn(a);
  } finally {
    executionContext = prevExecutionContext;

    if (executionContext === NoContext) {
      // Flush the immediate callbacks that were scheduled during this batch
      resetRenderTimer();
      flushSyncCallbackQueue();
    }
  }
}
function discreteUpdates$1(fn, a, b, c, d) {
  var prevExecutionContext = executionContext;
  executionContext |= DiscreteEventContext;

  {
    try {
      return runWithPriority$1(UserBlockingPriority$2, fn.bind(null, a, b, c, d));
    } finally {
      executionContext = prevExecutionContext;

      if (executionContext === NoContext) {
        // Flush the immediate callbacks that were scheduled during this batch
        resetRenderTimer();
        flushSyncCallbackQueue();
      }
    }
  }
}
function unbatchedUpdates(fn, a) {
  var prevExecutionContext = executionContext;
  executionContext &= ~BatchedContext;
  executionContext |= LegacyUnbatchedContext;

  try {
    return fn(a);
  } finally {
    executionContext = prevExecutionContext;

    if (executionContext === NoContext) {
      // Flush the immediate callbacks that were scheduled during this batch
      resetRenderTimer();
      flushSyncCallbackQueue();
    }
  }
}
function flushSync(fn, a) {
  var prevExecutionContext = executionContext;

  if ((prevExecutionContext & (RenderContext | CommitContext)) !== NoContext) {
    {
      error('flushSync was called from inside a lifecycle method. React cannot ' + 'flush when React is already rendering. Consider moving this call to ' + 'a scheduler task or micro task.');
    }

    return fn(a);
  }

  executionContext |= BatchedContext;

  {
    try {
      if (fn) {
        return runWithPriority$1(ImmediatePriority$1, fn.bind(null, a));
      } else {
        return undefined;
      }
    } finally {
      executionContext = prevExecutionContext; // Flush the immediate callbacks that were scheduled during this batch.
      // Note that this will happen even if batchedUpdates is higher up
      // the stack.

      flushSyncCallbackQueue();
    }
  }
}
function pushRenderLanes(fiber, lanes) {
  push(subtreeRenderLanesCursor, subtreeRenderLanes, fiber);
  subtreeRenderLanes = mergeLanes(subtreeRenderLanes, lanes);
  workInProgressRootIncludedLanes = mergeLanes(workInProgressRootIncludedLanes, lanes);
}
function popRenderLanes(fiber) {
  subtreeRenderLanes = subtreeRenderLanesCursor.current;
  pop(subtreeRenderLanesCursor, fiber);
}

function prepareFreshStack(root, lanes) {
  root.finishedWork = null;
  root.finishedLanes = NoLanes;
  var timeoutHandle = root.timeoutHandle;

  if (timeoutHandle !== noTimeout) {
    // The root previous suspended and scheduled a timeout to commit a fallback
    // state. Now that we have additional work, cancel the timeout.
    root.timeoutHandle = noTimeout; // $FlowFixMe Complains noTimeout is not a TimeoutID, despite the check above

    cancelTimeout(timeoutHandle);
  }

  if (workInProgress !== null) {
    var interruptedWork = workInProgress.return;

    while (interruptedWork !== null) {
      unwindInterruptedWork(interruptedWork);
      interruptedWork = interruptedWork.return;
    }
  }

  workInProgressRoot = root;
  workInProgress = createWorkInProgress(root.current, null);
  workInProgressRootRenderLanes = subtreeRenderLanes = workInProgressRootIncludedLanes = lanes;
  workInProgressRootExitStatus = RootIncomplete;
  workInProgressRootFatalError = null;
  workInProgressRootSkippedLanes = NoLanes;
  workInProgressRootUpdatedLanes = NoLanes;
  workInProgressRootPingedLanes = NoLanes;

  {
    spawnedWorkDuringRender = null;
  }

  {
    ReactStrictModeWarnings.discardPendingWarnings();
  }
}

function handleError(root, thrownValue) {
  do {
    var erroredWork = workInProgress;

    try {
      // Reset module-level state that was set during the render phase.
      resetContextDependencies();
      resetHooksAfterThrow();
      resetCurrentFiber(); // TODO: I found and added this missing line while investigating a
      // separate issue. Write a regression test using string refs.

      ReactCurrentOwner$2.current = null;

      if (erroredWork === null || erroredWork.return === null) {
        // Expected to be working on a non-root fiber. This is a fatal error
        // because there's no ancestor that can handle it; the root is
        // supposed to capture all errors that weren't caught by an error
        // boundary.
        workInProgressRootExitStatus = RootFatalErrored;
        workInProgressRootFatalError = thrownValue; // Set `workInProgress` to null. This represents advancing to the next
        // sibling, or the parent if there are no siblings. But since the root
        // has no siblings nor a parent, we set it to null. Usually this is
        // handled by `completeUnitOfWork` or `unwindWork`, but since we're
        // intentionally not calling those, we need set it here.
        // TODO: Consider calling `unwindWork` to pop the contexts.

        workInProgress = null;
        return;
      }

      if (enableProfilerTimer && erroredWork.mode & ProfileMode) {
        // Record the time spent rendering before an error was thrown. This
        // avoids inaccurate Profiler durations in the case of a
        // suspended render.
        stopProfilerTimerIfRunningAndRecordDelta(erroredWork, true);
      }

      throwException(root, erroredWork.return, erroredWork, thrownValue, workInProgressRootRenderLanes);
      completeUnitOfWork(erroredWork);
    } catch (yetAnotherThrownValue) {
      // Something in the return path also threw.
      thrownValue = yetAnotherThrownValue;

      if (workInProgress === erroredWork && erroredWork !== null) {
        // If this boundary has already errored, then we had trouble processing
        // the error. Bubble it to the next boundary.
        erroredWork = erroredWork.return;
        workInProgress = erroredWork;
      } else {
        erroredWork = workInProgress;
      }

      continue;
    } // Return to the normal work loop.


    return;
  } while (true);
}

function pushDispatcher() {
  var prevDispatcher = ReactCurrentDispatcher$2.current;
  ReactCurrentDispatcher$2.current = ContextOnlyDispatcher;

  if (prevDispatcher === null) {
    // The React isomorphic package does not include a default dispatcher.
    // Instead the first renderer will lazily attach one, in order to give
    // nicer error messages.
    return ContextOnlyDispatcher;
  } else {
    return prevDispatcher;
  }
}

function popDispatcher(prevDispatcher) {
  ReactCurrentDispatcher$2.current = prevDispatcher;
}

function pushInteractions(root) {
  {
    var prevInteractions = tracing.__interactionsRef.current;
    tracing.__interactionsRef.current = root.memoizedInteractions;
    return prevInteractions;
  }
}

function popInteractions(prevInteractions) {
  {
    tracing.__interactionsRef.current = prevInteractions;
  }
}

function markCommitTimeOfFallback() {
  globalMostRecentFallbackTime = now();
}
function markSkippedUpdateLanes(lane) {
  workInProgressRootSkippedLanes = mergeLanes(lane, workInProgressRootSkippedLanes);
}
function renderDidSuspend() {
  if (workInProgressRootExitStatus === RootIncomplete) {
    workInProgressRootExitStatus = RootSuspended;
  }
}
function renderDidSuspendDelayIfPossible() {
  if (workInProgressRootExitStatus === RootIncomplete || workInProgressRootExitStatus === RootSuspended) {
    workInProgressRootExitStatus = RootSuspendedWithDelay;
  } // Check if there are updates that we skipped tree that might have unblocked
  // this render.


  if (workInProgressRoot !== null && (includesNonIdleWork(workInProgressRootSkippedLanes) || includesNonIdleWork(workInProgressRootUpdatedLanes))) {
    // Mark the current render as suspended so that we switch to working on
    // the updates that were skipped. Usually we only suspend at the end of
    // the render phase.
    // TODO: We should probably always mark the root as suspended immediately
    // (inside this function), since by suspending at the end of the render
    // phase introduces a potential mistake where we suspend lanes that were
    // pinged or updated while we were rendering.
    markRootSuspended$1(workInProgressRoot, workInProgressRootRenderLanes);
  }
}
function renderDidError() {
  if (workInProgressRootExitStatus !== RootCompleted) {
    workInProgressRootExitStatus = RootErrored;
  }
} // Called during render to determine if anything has suspended.
// Returns false if we're not sure.

function renderHasNotSuspendedYet() {
  // If something errored or completed, we can't really be sure,
  // so those are false.
  return workInProgressRootExitStatus === RootIncomplete;
}

function renderRootSync(root, lanes) {
  var prevExecutionContext = executionContext;
  executionContext |= RenderContext;
  var prevDispatcher = pushDispatcher(); // If the root or lanes have changed, throw out the existing stack
  // and prepare a fresh one. Otherwise we'll continue where we left off.

  if (workInProgressRoot !== root || workInProgressRootRenderLanes !== lanes) {
    prepareFreshStack(root, lanes);
    startWorkOnPendingInteractions(root, lanes);
  }

  var prevInteractions = pushInteractions(root);

  do {
    try {
      workLoopSync();
      break;
    } catch (thrownValue) {
      handleError(root, thrownValue);
    }
  } while (true);

  resetContextDependencies();

  {
    popInteractions(prevInteractions);
  }

  executionContext = prevExecutionContext;
  popDispatcher(prevDispatcher);

  if (workInProgress !== null) {
    // This is a sync render, so we should have finished the whole tree.
    {
      {
        throw Error( "Cannot commit an incomplete root. This error is likely caused by a bug in React. Please file an issue." );
      }
    }
  }


  workInProgressRoot = null;
  workInProgressRootRenderLanes = NoLanes;
  return workInProgressRootExitStatus;
} // The work loop is an extremely hot path. Tell Closure not to inline it.

/** @noinline */


function workLoopSync() {
  // Already timed out, so perform work without checking if we need to yield.
  while (workInProgress !== null) {
    performUnitOfWork(workInProgress);
  }
}

function renderRootConcurrent(root, lanes) {
  var prevExecutionContext = executionContext;
  executionContext |= RenderContext;
  var prevDispatcher = pushDispatcher(); // If the root or lanes have changed, throw out the existing stack
  // and prepare a fresh one. Otherwise we'll continue where we left off.

  if (workInProgressRoot !== root || workInProgressRootRenderLanes !== lanes) {
    resetRenderTimer();
    prepareFreshStack(root, lanes);
    startWorkOnPendingInteractions(root, lanes);
  }

  var prevInteractions = pushInteractions(root);

  do {
    try {
      workLoopConcurrent();
      break;
    } catch (thrownValue) {
      handleError(root, thrownValue);
    }
  } while (true);

  resetContextDependencies();

  {
    popInteractions(prevInteractions);
  }

  popDispatcher(prevDispatcher);
  executionContext = prevExecutionContext;


  if (workInProgress !== null) {

    return RootIncomplete;
  } else {


    workInProgressRoot = null;
    workInProgressRootRenderLanes = NoLanes; // Return the final exit status.

    return workInProgressRootExitStatus;
  }
}
/** @noinline */


function workLoopConcurrent() {
  // Perform work until Scheduler asks us to yield
  while (workInProgress !== null && !shouldYield()) {
    performUnitOfWork(workInProgress);
  }
}

function performUnitOfWork(unitOfWork) {
  // The current, flushed, state of this fiber is the alternate. Ideally
  // nothing should rely on this, but relying on it here means that we don't
  // need an additional field on the work in progress.
  var current = unitOfWork.alternate;
  setCurrentFiber(unitOfWork);
  var next;

  if ( (unitOfWork.mode & ProfileMode) !== NoMode) {
    startProfilerTimer(unitOfWork);
    next = beginWork$1(current, unitOfWork, subtreeRenderLanes);
    stopProfilerTimerIfRunningAndRecordDelta(unitOfWork, true);
  } else {
    next = beginWork$1(current, unitOfWork, subtreeRenderLanes);
  }

  resetCurrentFiber();
  unitOfWork.memoizedProps = unitOfWork.pendingProps;

  if (next === null) {
    // If this doesn't spawn new work, complete the current work.
    completeUnitOfWork(unitOfWork);
  } else {
    workInProgress = next;
  }

  ReactCurrentOwner$2.current = null;
}

function completeUnitOfWork(unitOfWork) {
  // Attempt to complete the current unit of work, then move to the next
  // sibling. If there are no more siblings, return to the parent fiber.
  var completedWork = unitOfWork;

  do {
    // The current, flushed, state of this fiber is the alternate. Ideally
    // nothing should rely on this, but relying on it here means that we don't
    // need an additional field on the work in progress.
    var current = completedWork.alternate;
    var returnFiber = completedWork.return; // Check if the work completed or if something threw.

    if ((completedWork.flags & Incomplete) === NoFlags) {
      setCurrentFiber(completedWork);
      var next = void 0;

      if ( (completedWork.mode & ProfileMode) === NoMode) {
        next = completeWork(current, completedWork, subtreeRenderLanes);
      } else {
        startProfilerTimer(completedWork);
        next = completeWork(current, completedWork, subtreeRenderLanes); // Update render duration assuming we didn't error.

        stopProfilerTimerIfRunningAndRecordDelta(completedWork, false);
      }

      resetCurrentFiber();

      if (next !== null) {
        // Completing this fiber spawned new work. Work on that next.
        workInProgress = next;
        return;
      }

      resetChildLanes(completedWork);

      if (returnFiber !== null && // Do not append effects to parents if a sibling failed to complete
      (returnFiber.flags & Incomplete) === NoFlags) {
        // Append all the effects of the subtree and this fiber onto the effect
        // list of the parent. The completion order of the children affects the
        // side-effect order.
        if (returnFiber.firstEffect === null) {
          returnFiber.firstEffect = completedWork.firstEffect;
        }

        if (completedWork.lastEffect !== null) {
          if (returnFiber.lastEffect !== null) {
            returnFiber.lastEffect.nextEffect = completedWork.firstEffect;
          }

          returnFiber.lastEffect = completedWork.lastEffect;
        } // If this fiber had side-effects, we append it AFTER the children's
        // side-effects. We can perform certain side-effects earlier if needed,
        // by doing multiple passes over the effect list. We don't want to
        // schedule our own side-effect on our own list because if end up
        // reusing children we'll schedule this effect onto itself since we're
        // at the end.


        var flags = completedWork.flags; // Skip both NoWork and PerformedWork tags when creating the effect
        // list. PerformedWork effect is read by React DevTools but shouldn't be
        // committed.

        if (flags > PerformedWork) {
          if (returnFiber.lastEffect !== null) {
            returnFiber.lastEffect.nextEffect = completedWork;
          } else {
            returnFiber.firstEffect = completedWork;
          }

          returnFiber.lastEffect = completedWork;
        }
      }
    } else {
      // This fiber did not complete because something threw. Pop values off
      // the stack without entering the complete phase. If this is a boundary,
      // capture values if possible.
      var _next = unwindWork(completedWork); // Because this fiber did not complete, don't reset its expiration time.


      if (_next !== null) {
        // If completing this work spawned new work, do that next. We'll come
        // back here again.
        // Since we're restarting, remove anything that is not a host effect
        // from the effect tag.
        _next.flags &= HostEffectMask;
        workInProgress = _next;
        return;
      }

      if ( (completedWork.mode & ProfileMode) !== NoMode) {
        // Record the render duration for the fiber that errored.
        stopProfilerTimerIfRunningAndRecordDelta(completedWork, false); // Include the time spent working on failed children before continuing.

        var actualDuration = completedWork.actualDuration;
        var child = completedWork.child;

        while (child !== null) {
          actualDuration += child.actualDuration;
          child = child.sibling;
        }

        completedWork.actualDuration = actualDuration;
      }

      if (returnFiber !== null) {
        // Mark the parent fiber as incomplete and clear its effect list.
        returnFiber.firstEffect = returnFiber.lastEffect = null;
        returnFiber.flags |= Incomplete;
      }
    }

    var siblingFiber = completedWork.sibling;

    if (siblingFiber !== null) {
      // If there is more work to do in this returnFiber, do that next.
      workInProgress = siblingFiber;
      return;
    } // Otherwise, return to the parent


    completedWork = returnFiber; // Update the next thing we're working on in case something throws.

    workInProgress = completedWork;
  } while (completedWork !== null); // We've reached the root.


  if (workInProgressRootExitStatus === RootIncomplete) {
    workInProgressRootExitStatus = RootCompleted;
  }
}

function resetChildLanes(completedWork) {
  if ( // TODO: Move this check out of the hot path by moving `resetChildLanes`
  // to switch statement in `completeWork`.
  (completedWork.tag === LegacyHiddenComponent || completedWork.tag === OffscreenComponent) && completedWork.memoizedState !== null && !includesSomeLane(subtreeRenderLanes, OffscreenLane) && (completedWork.mode & ConcurrentMode) !== NoLanes) {
    // The children of this component are hidden. Don't bubble their
    // expiration times.
    return;
  }

  var newChildLanes = NoLanes; // Bubble up the earliest expiration time.

  if ( (completedWork.mode & ProfileMode) !== NoMode) {
    // In profiling mode, resetChildExpirationTime is also used to reset
    // profiler durations.
    var actualDuration = completedWork.actualDuration;
    var treeBaseDuration = completedWork.selfBaseDuration; // When a fiber is cloned, its actualDuration is reset to 0. This value will
    // only be updated if work is done on the fiber (i.e. it doesn't bailout).
    // When work is done, it should bubble to the parent's actualDuration. If
    // the fiber has not been cloned though, (meaning no work was done), then
    // this value will reflect the amount of time spent working on a previous
    // render. In that case it should not bubble. We determine whether it was
    // cloned by comparing the child pointer.

    var shouldBubbleActualDurations = completedWork.alternate === null || completedWork.child !== completedWork.alternate.child;
    var child = completedWork.child;

    while (child !== null) {
      newChildLanes = mergeLanes(newChildLanes, mergeLanes(child.lanes, child.childLanes));

      if (shouldBubbleActualDurations) {
        actualDuration += child.actualDuration;
      }

      treeBaseDuration += child.treeBaseDuration;
      child = child.sibling;
    }

    var isTimedOutSuspense = completedWork.tag === SuspenseComponent && completedWork.memoizedState !== null;

    if (isTimedOutSuspense) {
      // Don't count time spent in a timed out Suspense subtree as part of the base duration.
      var primaryChildFragment = completedWork.child;

      if (primaryChildFragment !== null) {
        treeBaseDuration -= primaryChildFragment.treeBaseDuration;
      }
    }

    completedWork.actualDuration = actualDuration;
    completedWork.treeBaseDuration = treeBaseDuration;
  } else {
    var _child = completedWork.child;

    while (_child !== null) {
      newChildLanes = mergeLanes(newChildLanes, mergeLanes(_child.lanes, _child.childLanes));
      _child = _child.sibling;
    }
  }

  completedWork.childLanes = newChildLanes;
}

function commitRoot(root) {
  var renderPriorityLevel = getCurrentPriorityLevel();
  runWithPriority$1(ImmediatePriority$1, commitRootImpl.bind(null, root, renderPriorityLevel));
  return null;
}

function commitRootImpl(root, renderPriorityLevel) {
  do {
    // `flushPassiveEffects` will call `flushSyncUpdateQueue` at the end, which
    // means `flushPassiveEffects` will sometimes result in additional
    // passive effects. So we need to keep flushing in a loop until there are
    // no more pending effects.
    // TODO: Might be better if `flushPassiveEffects` did not automatically
    // flush synchronous work at the end, to avoid factoring hazards like this.
    flushPassiveEffects();
  } while (rootWithPendingPassiveEffects !== null);

  flushRenderPhaseStrictModeWarningsInDEV();

  if (!((executionContext & (RenderContext | CommitContext)) === NoContext)) {
    {
      throw Error( "Should not already be working." );
    }
  }

  var finishedWork = root.finishedWork;
  var lanes = root.finishedLanes;

  if (finishedWork === null) {

    return null;
  }

  root.finishedWork = null;
  root.finishedLanes = NoLanes;

  if (!(finishedWork !== root.current)) {
    {
      throw Error( "Cannot commit the same tree as before. This error is likely caused by a bug in React. Please file an issue." );
    }
  } // commitRoot never returns a continuation; it always finishes synchronously.
  // So we can clear these now to allow a new callback to be scheduled.


  root.callbackNode = null; // Update the first and last pending times on this root. The new first
  // pending time is whatever is left on the root fiber.

  var remainingLanes = mergeLanes(finishedWork.lanes, finishedWork.childLanes);
  markRootFinished(root, remainingLanes); // Clear already finished discrete updates in case that a later call of
  // `flushDiscreteUpdates` starts a useless render pass which may cancels
  // a scheduled timeout.

  if (rootsWithPendingDiscreteUpdates !== null) {
    if (!hasDiscreteLanes(remainingLanes) && rootsWithPendingDiscreteUpdates.has(root)) {
      rootsWithPendingDiscreteUpdates.delete(root);
    }
  }

  if (root === workInProgressRoot) {
    // We can reset these now that they are finished.
    workInProgressRoot = null;
    workInProgress = null;
    workInProgressRootRenderLanes = NoLanes;
  } // Get the list of effects.


  var firstEffect;

  if (finishedWork.flags > PerformedWork) {
    // A fiber's effect list consists only of its children, not itself. So if
    // the root has an effect, we need to add it to the end of the list. The
    // resulting list is the set that would belong to the root's parent, if it
    // had one; that is, all the effects in the tree including the root.
    if (finishedWork.lastEffect !== null) {
      finishedWork.lastEffect.nextEffect = finishedWork;
      firstEffect = finishedWork.firstEffect;
    } else {
      firstEffect = finishedWork;
    }
  } else {
    // There is no effect on the root.
    firstEffect = finishedWork.firstEffect;
  }

  if (firstEffect !== null) {

    var prevExecutionContext = executionContext;
    executionContext |= CommitContext;
    var prevInteractions = pushInteractions(root); // Reset this to null before calling lifecycles

    ReactCurrentOwner$2.current = null; // The commit phase is broken into several sub-phases. We do a separate pass
    // of the effect list for each phase: all mutation effects come before all
    // layout effects, and so on.
    // The first phase a "before mutation" phase. We use this phase to read the
    // state of the host tree right before we mutate it. This is where
    // getSnapshotBeforeUpdate is called.

    focusedInstanceHandle = prepareForCommit(root.containerInfo);
    shouldFireAfterActiveInstanceBlur = false;
    nextEffect = firstEffect;

    do {
      {
        invokeGuardedCallback(null, commitBeforeMutationEffects, null);

        if (hasCaughtError()) {
          if (!(nextEffect !== null)) {
            {
              throw Error( "Should be working on an effect." );
            }
          }

          var error = clearCaughtError();
          captureCommitPhaseError(nextEffect, error);
          nextEffect = nextEffect.nextEffect;
        }
      }
    } while (nextEffect !== null); // We no longer need to track the active instance fiber


    focusedInstanceHandle = null;

    {
      // Mark the current commit time to be shared by all Profilers in this
      // batch. This enables them to be grouped later.
      recordCommitTime();
    } // The next phase is the mutation phase, where we mutate the host tree.


    nextEffect = firstEffect;

    do {
      {
        invokeGuardedCallback(null, commitMutationEffects, null, root, renderPriorityLevel);

        if (hasCaughtError()) {
          if (!(nextEffect !== null)) {
            {
              throw Error( "Should be working on an effect." );
            }
          }

          var _error = clearCaughtError();

          captureCommitPhaseError(nextEffect, _error);
          nextEffect = nextEffect.nextEffect;
        }
      }
    } while (nextEffect !== null);

    resetAfterCommit(root.containerInfo); // The work-in-progress tree is now the current tree. This must come after
    // the mutation phase, so that the previous tree is still current during
    // componentWillUnmount, but before the layout phase, so that the finished
    // work is current during componentDidMount/Update.

    root.current = finishedWork; // The next phase is the layout phase, where we call effects that read
    // the host tree after it's been mutated. The idiomatic use case for this is
    // layout, but class component lifecycles also fire here for legacy reasons.

    nextEffect = firstEffect;

    do {
      {
        invokeGuardedCallback(null, commitLayoutEffects, null, root, lanes);

        if (hasCaughtError()) {
          if (!(nextEffect !== null)) {
            {
              throw Error( "Should be working on an effect." );
            }
          }

          var _error2 = clearCaughtError();

          captureCommitPhaseError(nextEffect, _error2);
          nextEffect = nextEffect.nextEffect;
        }
      }
    } while (nextEffect !== null);

    nextEffect = null; // Tell Scheduler to yield at the end of the frame, so the browser has an
    // opportunity to paint.

    requestPaint();

    {
      popInteractions(prevInteractions);
    }

    executionContext = prevExecutionContext;
  } else {
    // No effects.
    root.current = finishedWork; // Measure these anyway so the flamegraph explicitly shows that there were
    // no effects.
    // TODO: Maybe there's a better way to report this.

    {
      recordCommitTime();
    }
  }

  var rootDidHavePassiveEffects = rootDoesHavePassiveEffects;

  if (rootDoesHavePassiveEffects) {
    // This commit has passive effects. Stash a reference to them. But don't
    // schedule a callback until after flushing layout work.
    rootDoesHavePassiveEffects = false;
    rootWithPendingPassiveEffects = root;
    pendingPassiveEffectsLanes = lanes;
    pendingPassiveEffectsRenderPriority = renderPriorityLevel;
  } else {
    // We are done with the effect chain at this point so let's clear the
    // nextEffect pointers to assist with GC. If we have passive effects, we'll
    // clear this in flushPassiveEffects.
    nextEffect = firstEffect;

    while (nextEffect !== null) {
      var nextNextEffect = nextEffect.nextEffect;
      nextEffect.nextEffect = null;

      if (nextEffect.flags & Deletion) {
        detachFiberAfterEffects(nextEffect);
      }

      nextEffect = nextNextEffect;
    }
  } // Read this again, since an effect might have updated it


  remainingLanes = root.pendingLanes; // Check if there's remaining work on this root

  if (remainingLanes !== NoLanes) {
    {
      if (spawnedWorkDuringRender !== null) {
        var expirationTimes = spawnedWorkDuringRender;
        spawnedWorkDuringRender = null;

        for (var i = 0; i < expirationTimes.length; i++) {
          scheduleInteractions(root, expirationTimes[i], root.memoizedInteractions);
        }
      }

      schedulePendingInteractions(root, remainingLanes);
    }
  } else {
    // If there's no remaining work, we can clear the set of already failed
    // error boundaries.
    legacyErrorBoundariesThatAlreadyFailed = null;
  }

  {
    if (!rootDidHavePassiveEffects) {
      // If there are no passive effects, then we can complete the pending interactions.
      // Otherwise, we'll wait until after the passive effects are flushed.
      // Wait to do this until after remaining work has been scheduled,
      // so that we don't prematurely signal complete for interactions when there's e.g. hidden work.
      finishPendingInteractions(root, lanes);
    }
  }

  if (remainingLanes === SyncLane) {
    // Count the number of times the root synchronously re-renders without
    // finishing. If there are too many, it indicates an infinite update loop.
    if (root === rootWithNestedUpdates) {
      nestedUpdateCount++;
    } else {
      nestedUpdateCount = 0;
      rootWithNestedUpdates = root;
    }
  } else {
    nestedUpdateCount = 0;
  }

  onCommitRoot(finishedWork.stateNode, renderPriorityLevel);

  {
    onCommitRoot$1();
  } // Always call this before exiting `commitRoot`, to ensure that any
  // additional work on this root is scheduled.


  ensureRootIsScheduled(root, now());

  if (hasUncaughtError) {
    hasUncaughtError = false;
    var _error3 = firstUncaughtError;
    firstUncaughtError = null;
    throw _error3;
  }

  if ((executionContext & LegacyUnbatchedContext) !== NoContext) {
    // a ReactDOM.render-ed root inside of batchedUpdates. The commit fired
    // synchronously, but layout updates should be deferred until the end
    // of the batch.


    return null;
  } // If layout work was scheduled, flush it now.


  flushSyncCallbackQueue();

  return null;
}

function commitBeforeMutationEffects() {
  while (nextEffect !== null) {
    var current = nextEffect.alternate;

    if (!shouldFireAfterActiveInstanceBlur && focusedInstanceHandle !== null) {
      if ((nextEffect.flags & Deletion) !== NoFlags) {
        if (doesFiberContain(nextEffect, focusedInstanceHandle)) {
          shouldFireAfterActiveInstanceBlur = true;
        }
      } else {
        // TODO: Move this out of the hot path using a dedicated effect tag.
        if (nextEffect.tag === SuspenseComponent && isSuspenseBoundaryBeingHidden(current, nextEffect) && doesFiberContain(nextEffect, focusedInstanceHandle)) {
          shouldFireAfterActiveInstanceBlur = true;
        }
      }
    }

    var flags = nextEffect.flags;

    if ((flags & Snapshot) !== NoFlags) {
      setCurrentFiber(nextEffect);
      commitBeforeMutationLifeCycles(current, nextEffect);
      resetCurrentFiber();
    }

    if ((flags & Passive) !== NoFlags) {
      // If there are passive effects, schedule a callback to flush at
      // the earliest opportunity.
      if (!rootDoesHavePassiveEffects) {
        rootDoesHavePassiveEffects = true;
        scheduleCallback(NormalPriority$1, function () {
          flushPassiveEffects();
          return null;
        });
      }
    }

    nextEffect = nextEffect.nextEffect;
  }
}

function commitMutationEffects(root, renderPriorityLevel) {
  // TODO: Should probably move the bulk of this function to commitWork.
  while (nextEffect !== null) {
    setCurrentFiber(nextEffect);
    var flags = nextEffect.flags;

    if (flags & ContentReset) {
      commitResetTextContent(nextEffect);
    }

    if (flags & Ref) {
      var current = nextEffect.alternate;

      if (current !== null) {
        commitDetachRef(current);
      }
    } // The following switch statement is only concerned about placement,
    // updates, and deletions. To avoid needing to add a case for every possible
    // bitmap value, we remove the secondary effects from the effect tag and
    // switch on that value.


    var primaryFlags = flags & (Placement | Update | Deletion | Hydrating);

    switch (primaryFlags) {
      case Placement:
        {
          commitPlacement(nextEffect); // Clear the "placement" from effect tag so that we know that this is
          // inserted, before any life-cycles like componentDidMount gets called.
          // TODO: findDOMNode doesn't rely on this any more but isMounted does
          // and isMounted is deprecated anyway so we should be able to kill this.

          nextEffect.flags &= ~Placement;
          break;
        }

      case PlacementAndUpdate:
        {
          // Placement
          commitPlacement(nextEffect); // Clear the "placement" from effect tag so that we know that this is
          // inserted, before any life-cycles like componentDidMount gets called.

          nextEffect.flags &= ~Placement; // Update

          var _current = nextEffect.alternate;
          commitWork(_current, nextEffect);
          break;
        }

      case Hydrating:
        {
          nextEffect.flags &= ~Hydrating;
          break;
        }

      case HydratingAndUpdate:
        {
          nextEffect.flags &= ~Hydrating; // Update

          var _current2 = nextEffect.alternate;
          commitWork(_current2, nextEffect);
          break;
        }

      case Update:
        {
          var _current3 = nextEffect.alternate;
          commitWork(_current3, nextEffect);
          break;
        }

      case Deletion:
        {
          commitDeletion(root, nextEffect);
          break;
        }
    }

    resetCurrentFiber();
    nextEffect = nextEffect.nextEffect;
  }
}

function commitLayoutEffects(root, committedLanes) {


  while (nextEffect !== null) {
    setCurrentFiber(nextEffect);
    var flags = nextEffect.flags;

    if (flags & (Update | Callback)) {
      var current = nextEffect.alternate;
      commitLifeCycles(root, current, nextEffect);
    }

    {
      if (flags & Ref) {
        commitAttachRef(nextEffect);
      }
    }

    resetCurrentFiber();
    nextEffect = nextEffect.nextEffect;
  }
}

function flushPassiveEffects() {
  // Returns whether passive effects were flushed.
  if (pendingPassiveEffectsRenderPriority !== NoPriority$1) {
    var priorityLevel = pendingPassiveEffectsRenderPriority > NormalPriority$1 ? NormalPriority$1 : pendingPassiveEffectsRenderPriority;
    pendingPassiveEffectsRenderPriority = NoPriority$1;

    {
      return runWithPriority$1(priorityLevel, flushPassiveEffectsImpl);
    }
  }

  return false;
}
function enqueuePendingPassiveHookEffectMount(fiber, effect) {
  pendingPassiveHookEffectsMount.push(effect, fiber);

  if (!rootDoesHavePassiveEffects) {
    rootDoesHavePassiveEffects = true;
    scheduleCallback(NormalPriority$1, function () {
      flushPassiveEffects();
      return null;
    });
  }
}
function enqueuePendingPassiveHookEffectUnmount(fiber, effect) {
  pendingPassiveHookEffectsUnmount.push(effect, fiber);

  {
    fiber.flags |= PassiveUnmountPendingDev;
    var alternate = fiber.alternate;

    if (alternate !== null) {
      alternate.flags |= PassiveUnmountPendingDev;
    }
  }

  if (!rootDoesHavePassiveEffects) {
    rootDoesHavePassiveEffects = true;
    scheduleCallback(NormalPriority$1, function () {
      flushPassiveEffects();
      return null;
    });
  }
}

function invokePassiveEffectCreate(effect) {
  var create = effect.create;
  effect.destroy = create();
}

function flushPassiveEffectsImpl() {
  if (rootWithPendingPassiveEffects === null) {
    return false;
  }

  var root = rootWithPendingPassiveEffects;
  var lanes = pendingPassiveEffectsLanes;
  rootWithPendingPassiveEffects = null;
  pendingPassiveEffectsLanes = NoLanes;

  if (!((executionContext & (RenderContext | CommitContext)) === NoContext)) {
    {
      throw Error( "Cannot flush passive effects while already rendering." );
    }
  }

  {
    isFlushingPassiveEffects = true;
  }

  var prevExecutionContext = executionContext;
  executionContext |= CommitContext;
  var prevInteractions = pushInteractions(root); // It's important that ALL pending passive effect destroy functions are called
  // before ANY passive effect create functions are called.
  // Otherwise effects in sibling components might interfere with each other.
  // e.g. a destroy function in one component may unintentionally override a ref
  // value set by a create function in another component.
  // Layout effects have the same constraint.
  // First pass: Destroy stale passive effects.

  var unmountEffects = pendingPassiveHookEffectsUnmount;
  pendingPassiveHookEffectsUnmount = [];

  for (var i = 0; i < unmountEffects.length; i += 2) {
    var _effect = unmountEffects[i];
    var fiber = unmountEffects[i + 1];
    var destroy = _effect.destroy;
    _effect.destroy = undefined;

    {
      fiber.flags &= ~PassiveUnmountPendingDev;
      var alternate = fiber.alternate;

      if (alternate !== null) {
        alternate.flags &= ~PassiveUnmountPendingDev;
      }
    }

    if (typeof destroy === 'function') {
      {
        setCurrentFiber(fiber);

        {
          invokeGuardedCallback(null, destroy, null);
        }

        if (hasCaughtError()) {
          if (!(fiber !== null)) {
            {
              throw Error( "Should be working on an effect." );
            }
          }

          var error = clearCaughtError();
          captureCommitPhaseError(fiber, error);
        }

        resetCurrentFiber();
      }
    }
  } // Second pass: Create new passive effects.


  var mountEffects = pendingPassiveHookEffectsMount;
  pendingPassiveHookEffectsMount = [];

  for (var _i = 0; _i < mountEffects.length; _i += 2) {
    var _effect2 = mountEffects[_i];
    var _fiber = mountEffects[_i + 1];

    {
      setCurrentFiber(_fiber);

      {
        invokeGuardedCallback(null, invokePassiveEffectCreate, null, _effect2);
      }

      if (hasCaughtError()) {
        if (!(_fiber !== null)) {
          {
            throw Error( "Should be working on an effect." );
          }
        }

        var _error4 = clearCaughtError();

        captureCommitPhaseError(_fiber, _error4);
      }

      resetCurrentFiber();
    }
  } // Note: This currently assumes there are no passive effects on the root fiber
  // because the root is not part of its own effect list.
  // This could change in the future.


  var effect = root.current.firstEffect;

  while (effect !== null) {
    var nextNextEffect = effect.nextEffect; // Remove nextEffect pointer to assist GC

    effect.nextEffect = null;

    if (effect.flags & Deletion) {
      detachFiberAfterEffects(effect);
    }

    effect = nextNextEffect;
  }

  {
    popInteractions(prevInteractions);
    finishPendingInteractions(root, lanes);
  }

  {
    isFlushingPassiveEffects = false;
  }

  executionContext = prevExecutionContext;
  flushSyncCallbackQueue(); // If additional passive effects were scheduled, increment a counter. If this
  // exceeds the limit, we'll fire a warning.

  nestedPassiveUpdateCount = rootWithPendingPassiveEffects === null ? 0 : nestedPassiveUpdateCount + 1;
  return true;
}

function isAlreadyFailedLegacyErrorBoundary(instance) {
  return legacyErrorBoundariesThatAlreadyFailed !== null && legacyErrorBoundariesThatAlreadyFailed.has(instance);
}
function markLegacyErrorBoundaryAsFailed(instance) {
  if (legacyErrorBoundariesThatAlreadyFailed === null) {
    legacyErrorBoundariesThatAlreadyFailed = new Set([instance]);
  } else {
    legacyErrorBoundariesThatAlreadyFailed.add(instance);
  }
}

function prepareToThrowUncaughtError(error) {
  if (!hasUncaughtError) {
    hasUncaughtError = true;
    firstUncaughtError = error;
  }
}

var onUncaughtError = prepareToThrowUncaughtError;

function captureCommitPhaseErrorOnRoot(rootFiber, sourceFiber, error) {
  var errorInfo = createCapturedValue(error, sourceFiber);
  var update = createRootErrorUpdate(rootFiber, errorInfo, SyncLane);
  enqueueUpdate(rootFiber, update);
  var eventTime = requestEventTime();
  var root = markUpdateLaneFromFiberToRoot(rootFiber, SyncLane);

  if (root !== null) {
    markRootUpdated(root, SyncLane, eventTime);
    ensureRootIsScheduled(root, eventTime);
    schedulePendingInteractions(root, SyncLane);
  }
}

function captureCommitPhaseError(sourceFiber, error) {
  if (sourceFiber.tag === HostRoot) {
    // Error was thrown at the root. There is no parent, so the root
    // itself should capture it.
    captureCommitPhaseErrorOnRoot(sourceFiber, sourceFiber, error);
    return;
  }

  var fiber = sourceFiber.return;

  while (fiber !== null) {
    if (fiber.tag === HostRoot) {
      captureCommitPhaseErrorOnRoot(fiber, sourceFiber, error);
      return;
    } else if (fiber.tag === ClassComponent) {
      var ctor = fiber.type;
      var instance = fiber.stateNode;

      if (typeof ctor.getDerivedStateFromError === 'function' || typeof instance.componentDidCatch === 'function' && !isAlreadyFailedLegacyErrorBoundary(instance)) {
        var errorInfo = createCapturedValue(error, sourceFiber);
        var update = createClassErrorUpdate(fiber, errorInfo, SyncLane);
        enqueueUpdate(fiber, update);
        var eventTime = requestEventTime();
        var root = markUpdateLaneFromFiberToRoot(fiber, SyncLane);

        if (root !== null) {
          markRootUpdated(root, SyncLane, eventTime);
          ensureRootIsScheduled(root, eventTime);
          schedulePendingInteractions(root, SyncLane);
        } else {
          // This component has already been unmounted.
          // We can't schedule any follow up work for the root because the fiber is already unmounted,
          // but we can still call the log-only boundary so the error isn't swallowed.
          //
          // TODO This is only a temporary bandaid for the old reconciler fork.
          // We can delete this special case once the new fork is merged.
          if (typeof instance.componentDidCatch === 'function' && !isAlreadyFailedLegacyErrorBoundary(instance)) {
            try {
              instance.componentDidCatch(error, errorInfo);
            } catch (errorToIgnore) {// TODO Ignore this error? Rethrow it?
              // This is kind of an edge case.
            }
          }
        }

        return;
      }
    }

    fiber = fiber.return;
  }
}
function pingSuspendedRoot(root, wakeable, pingedLanes) {
  var pingCache = root.pingCache;

  if (pingCache !== null) {
    // The wakeable resolved, so we no longer need to memoize, because it will
    // never be thrown again.
    pingCache.delete(wakeable);
  }

  var eventTime = requestEventTime();
  markRootPinged(root, pingedLanes);

  if (workInProgressRoot === root && isSubsetOfLanes(workInProgressRootRenderLanes, pingedLanes)) {
    // Received a ping at the same priority level at which we're currently
    // rendering. We might want to restart this render. This should mirror
    // the logic of whether or not a root suspends once it completes.
    // TODO: If we're rendering sync either due to Sync, Batched or expired,
    // we should probably never restart.
    // If we're suspended with delay, or if it's a retry, we'll always suspend
    // so we can always restart.
    if (workInProgressRootExitStatus === RootSuspendedWithDelay || workInProgressRootExitStatus === RootSuspended && includesOnlyRetries(workInProgressRootRenderLanes) && now() - globalMostRecentFallbackTime < FALLBACK_THROTTLE_MS) {
      // Restart from the root.
      prepareFreshStack(root, NoLanes);
    } else {
      // Even though we can't restart right now, we might get an
      // opportunity later. So we mark this render as having a ping.
      workInProgressRootPingedLanes = mergeLanes(workInProgressRootPingedLanes, pingedLanes);
    }
  }

  ensureRootIsScheduled(root, eventTime);
  schedulePendingInteractions(root, pingedLanes);
}

function retryTimedOutBoundary(boundaryFiber, retryLane) {
  // The boundary fiber (a Suspense component or SuspenseList component)
  // previously was rendered in its fallback state. One of the promises that
  // suspended it has resolved, which means at least part of the tree was
  // likely unblocked. Try rendering again, at a new expiration time.
  if (retryLane === NoLane) {
    retryLane = requestRetryLane(boundaryFiber);
  } // TODO: Special case idle priority?


  var eventTime = requestEventTime();
  var root = markUpdateLaneFromFiberToRoot(boundaryFiber, retryLane);

  if (root !== null) {
    markRootUpdated(root, retryLane, eventTime);
    ensureRootIsScheduled(root, eventTime);
    schedulePendingInteractions(root, retryLane);
  }
}
function resolveRetryWakeable(boundaryFiber, wakeable) {
  var retryLane = NoLane; // Default

  var retryCache;

  {
    retryCache = boundaryFiber.stateNode;
  }

  if (retryCache !== null) {
    // The wakeable resolved, so we no longer need to memoize, because it will
    // never be thrown again.
    retryCache.delete(wakeable);
  }

  retryTimedOutBoundary(boundaryFiber, retryLane);
} // Computes the next Just Noticeable Difference (JND) boundary.
// The theory is that a person can't tell the difference between small differences in time.
// Therefore, if we wait a bit longer than necessary that won't translate to a noticeable
// difference in the experience. However, waiting for longer might mean that we can avoid
// showing an intermediate loading state. The longer we have already waited, the harder it
// is to tell small differences in time. Therefore, the longer we've already waited,
// the longer we can wait additionally. At some point we have to give up though.
// We pick a train model where the next boundary commits at a consistent schedule.
// These particular numbers are vague estimates. We expect to adjust them based on research.

function jnd(timeElapsed) {
  return timeElapsed < 120 ? 120 : timeElapsed < 480 ? 480 : timeElapsed < 1080 ? 1080 : timeElapsed < 1920 ? 1920 : timeElapsed < 3000 ? 3000 : timeElapsed < 4320 ? 4320 : ceil(timeElapsed / 1960) * 1960;
}

function checkForNestedUpdates() {
  if (nestedUpdateCount > NESTED_UPDATE_LIMIT) {
    nestedUpdateCount = 0;
    rootWithNestedUpdates = null;

    {
      {
        throw Error( "Maximum update depth exceeded. This can happen when a component repeatedly calls setState inside componentWillUpdate or componentDidUpdate. React limits the number of nested updates to prevent infinite loops." );
      }
    }
  }

  {
    if (nestedPassiveUpdateCount > NESTED_PASSIVE_UPDATE_LIMIT) {
      nestedPassiveUpdateCount = 0;

      error('Maximum update depth exceeded. This can happen when a component ' + "calls setState inside useEffect, but useEffect either doesn't " + 'have a dependency array, or one of the dependencies changes on ' + 'every render.');
    }
  }
}

function flushRenderPhaseStrictModeWarningsInDEV() {
  {
    ReactStrictModeWarnings.flushLegacyContextWarning();

    {
      ReactStrictModeWarnings.flushPendingUnsafeLifecycleWarnings();
    }
  }
}

var didWarnStateUpdateForNotYetMountedComponent = null;

function warnAboutUpdateOnNotYetMountedFiberInDEV(fiber) {
  {
    if ((executionContext & RenderContext) !== NoContext) {
      // We let the other warning about render phase updates deal with this one.
      return;
    }

    if (!(fiber.mode & (BlockingMode | ConcurrentMode))) {
      return;
    }

    var tag = fiber.tag;

    if (tag !== IndeterminateComponent && tag !== HostRoot && tag !== ClassComponent && tag !== FunctionComponent && tag !== ForwardRef && tag !== MemoComponent && tag !== SimpleMemoComponent && tag !== Block) {
      // Only warn for user-defined components, not internal ones like Suspense.
      return;
    } // We show the whole stack but dedupe on the top component's name because
    // the problematic code almost always lies inside that component.


    var componentName = getComponentName(fiber.type) || 'ReactComponent';

    if (didWarnStateUpdateForNotYetMountedComponent !== null) {
      if (didWarnStateUpdateForNotYetMountedComponent.has(componentName)) {
        return;
      }

      didWarnStateUpdateForNotYetMountedComponent.add(componentName);
    } else {
      didWarnStateUpdateForNotYetMountedComponent = new Set([componentName]);
    }

    var previousFiber = current;

    try {
      setCurrentFiber(fiber);

      error("Can't perform a React state update on a component that hasn't mounted yet. " + 'This indicates that you have a side-effect in your render function that ' + 'asynchronously later calls tries to update the component. Move this work to ' + 'useEffect instead.');
    } finally {
      if (previousFiber) {
        setCurrentFiber(fiber);
      } else {
        resetCurrentFiber();
      }
    }
  }
}

var didWarnStateUpdateForUnmountedComponent = null;

function warnAboutUpdateOnUnmountedFiberInDEV(fiber) {
  {
    var tag = fiber.tag;

    if (tag !== HostRoot && tag !== ClassComponent && tag !== FunctionComponent && tag !== ForwardRef && tag !== MemoComponent && tag !== SimpleMemoComponent && tag !== Block) {
      // Only warn for user-defined components, not internal ones like Suspense.
      return;
    } // If there are pending passive effects unmounts for this Fiber,
    // we can assume that they would have prevented this update.


    if ((fiber.flags & PassiveUnmountPendingDev) !== NoFlags) {
      return;
    } // We show the whole stack but dedupe on the top component's name because
    // the problematic code almost always lies inside that component.


    var componentName = getComponentName(fiber.type) || 'ReactComponent';

    if (didWarnStateUpdateForUnmountedComponent !== null) {
      if (didWarnStateUpdateForUnmountedComponent.has(componentName)) {
        return;
      }

      didWarnStateUpdateForUnmountedComponent.add(componentName);
    } else {
      didWarnStateUpdateForUnmountedComponent = new Set([componentName]);
    }

    if (isFlushingPassiveEffects) ; else {
      var previousFiber = current;

      try {
        setCurrentFiber(fiber);

        error("Can't perform a React state update on an unmounted component. This " + 'is a no-op, but it indicates a memory leak in your application. To ' + 'fix, cancel all subscriptions and asynchronous tasks in %s.', tag === ClassComponent ? 'the componentWillUnmount method' : 'a useEffect cleanup function');
      } finally {
        if (previousFiber) {
          setCurrentFiber(fiber);
        } else {
          resetCurrentFiber();
        }
      }
    }
  }
}

var beginWork$1;

{
  var dummyFiber = null;

  beginWork$1 = function (current, unitOfWork, lanes) {
    // If a component throws an error, we replay it again in a synchronously
    // dispatched event, so that the debugger will treat it as an uncaught
    // error See ReactErrorUtils for more information.
    // Before entering the begin phase, copy the work-in-progress onto a dummy
    // fiber. If beginWork throws, we'll use this to reset the state.
    var originalWorkInProgressCopy = assignFiberPropertiesInDEV(dummyFiber, unitOfWork);

    try {
      return beginWork(current, unitOfWork, lanes);
    } catch (originalError) {
      if (originalError !== null && typeof originalError === 'object' && typeof originalError.then === 'function') {
        // Don't replay promises. Treat everything else like an error.
        throw originalError;
      } // Keep this code in sync with handleError; any changes here must have
      // corresponding changes there.


      resetContextDependencies();
      resetHooksAfterThrow(); // Don't reset current debug fiber, since we're about to work on the
      // same fiber again.
      // Unwind the failed stack frame

      unwindInterruptedWork(unitOfWork); // Restore the original properties of the fiber.

      assignFiberPropertiesInDEV(unitOfWork, originalWorkInProgressCopy);

      if ( unitOfWork.mode & ProfileMode) {
        // Reset the profiler timer.
        startProfilerTimer(unitOfWork);
      } // Run beginWork again.


      invokeGuardedCallback(null, beginWork, null, current, unitOfWork, lanes);

      if (hasCaughtError()) {
        var replayError = clearCaughtError(); // `invokeGuardedCallback` sometimes sets an expando `_suppressLogging`.
        // Rethrow this error instead of the original one.

        throw replayError;
      } else {
        // This branch is reachable if the render phase is impure.
        throw originalError;
      }
    }
  };
}

var didWarnAboutUpdateInRender = false;
var didWarnAboutUpdateInRenderForAnotherComponent;

{
  didWarnAboutUpdateInRenderForAnotherComponent = new Set();
}

function warnAboutRenderPhaseUpdatesInDEV(fiber) {
  {
    if (isRendering && (executionContext & RenderContext) !== NoContext && !getIsUpdatingOpaqueValueInRenderPhaseInDEV()) {
      switch (fiber.tag) {
        case FunctionComponent:
        case ForwardRef:
        case SimpleMemoComponent:
          {
            var renderingComponentName = workInProgress && getComponentName(workInProgress.type) || 'Unknown'; // Dedupe by the rendering component because it's the one that needs to be fixed.

            var dedupeKey = renderingComponentName;

            if (!didWarnAboutUpdateInRenderForAnotherComponent.has(dedupeKey)) {
              didWarnAboutUpdateInRenderForAnotherComponent.add(dedupeKey);
              var setStateComponentName = getComponentName(fiber.type) || 'Unknown';

              error('Cannot update a component (`%s`) while rendering a ' + 'different component (`%s`). To locate the bad setState() call inside `%s`, ' + 'follow the stack trace as described in https://reactjs.org/link/setstate-in-render', setStateComponentName, renderingComponentName, renderingComponentName);
            }

            break;
          }

        case ClassComponent:
          {
            if (!didWarnAboutUpdateInRender) {
              error('Cannot update during an existing state transition (such as ' + 'within `render`). Render methods should be a pure ' + 'function of props and state.');

              didWarnAboutUpdateInRender = true;
            }

            break;
          }
      }
    }
  }
} // a 'shared' variable that changes when act() opens/closes in tests.


var IsThisRendererActing = {
  current: false
};
function warnIfNotScopedWithMatchingAct(fiber) {
  {
    if ( IsSomeRendererActing.current === true && IsThisRendererActing.current !== true) {
      var previousFiber = current;

      try {
        setCurrentFiber(fiber);

        error("It looks like you're using the wrong act() around your test interactions.\n" + 'Be sure to use the matching version of act() corresponding to your renderer:\n\n' + '// for react-dom:\n' + // Break up imports to avoid accidentally parsing them as dependencies.
        'import {act} fr' + "om 'react-dom/test-utils';\n" + '// ...\n' + 'act(() => ...);\n\n' + '// for react-test-renderer:\n' + // Break up imports to avoid accidentally parsing them as dependencies.
        'import TestRenderer fr' + "om react-test-renderer';\n" + 'const {act} = TestRenderer;\n' + '// ...\n' + 'act(() => ...);');
      } finally {
        if (previousFiber) {
          setCurrentFiber(fiber);
        } else {
          resetCurrentFiber();
        }
      }
    }
  }
}
function warnIfNotCurrentlyActingEffectsInDEV(fiber) {
  {
    if ( (fiber.mode & StrictMode) !== NoMode && IsSomeRendererActing.current === false && IsThisRendererActing.current === false) {
      error('An update to %s ran an effect, but was not wrapped in act(...).\n\n' + 'When testing, code that causes React state updates should be ' + 'wrapped into act(...):\n\n' + 'act(() => {\n' + '  /* fire events that update state */\n' + '});\n' + '/* assert on the output */\n\n' + "This ensures that you're testing the behavior the user would see " + 'in the browser.' + ' Learn more at https://reactjs.org/link/wrap-tests-with-act', getComponentName(fiber.type));
    }
  }
}

function warnIfNotCurrentlyActingUpdatesInDEV(fiber) {
  {
    if ( executionContext === NoContext && IsSomeRendererActing.current === false && IsThisRendererActing.current === false) {
      var previousFiber = current;

      try {
        setCurrentFiber(fiber);

        error('An update to %s inside a test was not wrapped in act(...).\n\n' + 'When testing, code that causes React state updates should be ' + 'wrapped into act(...):\n\n' + 'act(() => {\n' + '  /* fire events that update state */\n' + '});\n' + '/* assert on the output */\n\n' + "This ensures that you're testing the behavior the user would see " + 'in the browser.' + ' Learn more at https://reactjs.org/link/wrap-tests-with-act', getComponentName(fiber.type));
      } finally {
        if (previousFiber) {
          setCurrentFiber(fiber);
        } else {
          resetCurrentFiber();
        }
      }
    }
  }
}

var warnIfNotCurrentlyActingUpdatesInDev = warnIfNotCurrentlyActingUpdatesInDEV; // In tests, we want to enforce a mocked scheduler.

var didWarnAboutUnmockedScheduler = false; // TODO Before we release concurrent mode, revisit this and decide whether a mocked
// scheduler is the actual recommendation. The alternative could be a testing build,
// a new lib, or whatever; we dunno just yet. This message is for early adopters
// to get their tests right.

function warnIfUnmockedScheduler(fiber) {
  {
    if (didWarnAboutUnmockedScheduler === false && Scheduler.unstable_flushAllWithoutAsserting === undefined) {
      if (fiber.mode & BlockingMode || fiber.mode & ConcurrentMode) {
        didWarnAboutUnmockedScheduler = true;

        error('In Concurrent or Sync modes, the "scheduler" module needs to be mocked ' + 'to guarantee consistent behaviour across tests and browsers. ' + 'For example, with jest: \n' + // Break up requires to avoid accidentally parsing them as dependencies.
        "jest.mock('scheduler', () => require" + "('scheduler/unstable_mock'));\n\n" + 'For more info, visit https://reactjs.org/link/mock-scheduler');
      }
    }
  }
}

function computeThreadID(root, lane) {
  // Interaction threads are unique per root and expiration time.
  // NOTE: Intentionally unsound cast. All that matters is that it's a number
  // and it represents a batch of work. Could make a helper function instead,
  // but meh this is fine for now.
  return lane * 1000 + root.interactionThreadID;
}

function markSpawnedWork(lane) {

  if (spawnedWorkDuringRender === null) {
    spawnedWorkDuringRender = [lane];
  } else {
    spawnedWorkDuringRender.push(lane);
  }
}

function scheduleInteractions(root, lane, interactions) {

  if (interactions.size > 0) {
    var pendingInteractionMap = root.pendingInteractionMap;
    var pendingInteractions = pendingInteractionMap.get(lane);

    if (pendingInteractions != null) {
      interactions.forEach(function (interaction) {
        if (!pendingInteractions.has(interaction)) {
          // Update the pending async work count for previously unscheduled interaction.
          interaction.__count++;
        }

        pendingInteractions.add(interaction);
      });
    } else {
      pendingInteractionMap.set(lane, new Set(interactions)); // Update the pending async work count for the current interactions.

      interactions.forEach(function (interaction) {
        interaction.__count++;
      });
    }

    var subscriber = tracing.__subscriberRef.current;

    if (subscriber !== null) {
      var threadID = computeThreadID(root, lane);
      subscriber.onWorkScheduled(interactions, threadID);
    }
  }
}

function schedulePendingInteractions(root, lane) {

  scheduleInteractions(root, lane, tracing.__interactionsRef.current);
}

function startWorkOnPendingInteractions(root, lanes) {
  // we can accurately attribute time spent working on it, And so that cascading
  // work triggered during the render phase will be associated with it.


  var interactions = new Set();
  root.pendingInteractionMap.forEach(function (scheduledInteractions, scheduledLane) {
    if (includesSomeLane(lanes, scheduledLane)) {
      scheduledInteractions.forEach(function (interaction) {
        return interactions.add(interaction);
      });
    }
  }); // Store the current set of interactions on the FiberRoot for a few reasons:
  // We can re-use it in hot functions like performConcurrentWorkOnRoot()
  // without having to recalculate it. We will also use it in commitWork() to
  // pass to any Profiler onRender() hooks. This also provides DevTools with a
  // way to access it when the onCommitRoot() hook is called.

  root.memoizedInteractions = interactions;

  if (interactions.size > 0) {
    var subscriber = tracing.__subscriberRef.current;

    if (subscriber !== null) {
      var threadID = computeThreadID(root, lanes);

      try {
        subscriber.onWorkStarted(interactions, threadID);
      } catch (error) {
        // If the subscriber throws, rethrow it in a separate task
        scheduleCallback(ImmediatePriority$1, function () {
          throw error;
        });
      }
    }
  }
}

function finishPendingInteractions(root, committedLanes) {

  var remainingLanesAfterCommit = root.pendingLanes;
  var subscriber;

  try {
    subscriber = tracing.__subscriberRef.current;

    if (subscriber !== null && root.memoizedInteractions.size > 0) {
      // FIXME: More than one lane can finish in a single commit.
      var threadID = computeThreadID(root, committedLanes);
      subscriber.onWorkStopped(root.memoizedInteractions, threadID);
    }
  } catch (error) {
    // If the subscriber throws, rethrow it in a separate task
    scheduleCallback(ImmediatePriority$1, function () {
      throw error;
    });
  } finally {
    // Clear completed interactions from the pending Map.
    // Unless the render was suspended or cascading work was scheduled,
    // In which case– leave pending interactions until the subsequent render.
    var pendingInteractionMap = root.pendingInteractionMap;
    pendingInteractionMap.forEach(function (scheduledInteractions, lane) {
      // Only decrement the pending interaction count if we're done.
      // If there's still work at the current priority,
      // That indicates that we are waiting for suspense data.
      if (!includesSomeLane(remainingLanesAfterCommit, lane)) {
        pendingInteractionMap.delete(lane);
        scheduledInteractions.forEach(function (interaction) {
          interaction.__count--;

          if (subscriber !== null && interaction.__count === 0) {
            try {
              subscriber.onInteractionScheduledWorkCompleted(interaction);
            } catch (error) {
              // If the subscriber throws, rethrow it in a separate task
              scheduleCallback(ImmediatePriority$1, function () {
                throw error;
              });
            }
          }
        });
      }
    });
  }
} // `act` testing API

function shouldForceFlushFallbacksInDEV() {
  // Never force flush in production. This function should get stripped out.
  return  actingUpdatesScopeDepth > 0;
}
// so we can tell if any async act() calls try to run in parallel.


var actingUpdatesScopeDepth = 0;

function detachFiberAfterEffects(fiber) {
  fiber.sibling = null;
  fiber.stateNode = null;
}

var resolveFamily = null; // $FlowFixMe Flow gets confused by a WeakSet feature check below.

var failedBoundaries = null;
var setRefreshHandler = function (handler) {
  {
    resolveFamily = handler;
  }
};
function resolveFunctionForHotReloading(type) {
  {
    if (resolveFamily === null) {
      // Hot reloading is disabled.
      return type;
    }

    var family = resolveFamily(type);

    if (family === undefined) {
      return type;
    } // Use the latest known implementation.


    return family.current;
  }
}
function resolveClassForHotReloading(type) {
  // No implementation differences.
  return resolveFunctionForHotReloading(type);
}
function resolveForwardRefForHotReloading(type) {
  {
    if (resolveFamily === null) {
      // Hot reloading is disabled.
      return type;
    }

    var family = resolveFamily(type);

    if (family === undefined) {
      // Check if we're dealing with a real forwardRef. Don't want to crash early.
      if (type !== null && type !== undefined && typeof type.render === 'function') {
        // ForwardRef is special because its resolved .type is an object,
        // but it's possible that we only have its inner render function in the map.
        // If that inner render function is different, we'll build a new forwardRef type.
        var currentRender = resolveFunctionForHotReloading(type.render);

        if (type.render !== currentRender) {
          var syntheticType = {
            $$typeof: REACT_FORWARD_REF_TYPE,
            render: currentRender
          };

          if (type.displayName !== undefined) {
            syntheticType.displayName = type.displayName;
          }

          return syntheticType;
        }
      }

      return type;
    } // Use the latest known implementation.


    return family.current;
  }
}
function isCompatibleFamilyForHotReloading(fiber, element) {
  {
    if (resolveFamily === null) {
      // Hot reloading is disabled.
      return false;
    }

    var prevType = fiber.elementType;
    var nextType = element.type; // If we got here, we know types aren't === equal.

    var needsCompareFamilies = false;
    var $$typeofNextType = typeof nextType === 'object' && nextType !== null ? nextType.$$typeof : null;

    switch (fiber.tag) {
      case ClassComponent:
        {
          if (typeof nextType === 'function') {
            needsCompareFamilies = true;
          }

          break;
        }

      case FunctionComponent:
        {
          if (typeof nextType === 'function') {
            needsCompareFamilies = true;
          } else if ($$typeofNextType === REACT_LAZY_TYPE) {
            // We don't know the inner type yet.
            // We're going to assume that the lazy inner type is stable,
            // and so it is sufficient to avoid reconciling it away.
            // We're not going to unwrap or actually use the new lazy type.
            needsCompareFamilies = true;
          }

          break;
        }

      case ForwardRef:
        {
          if ($$typeofNextType === REACT_FORWARD_REF_TYPE) {
            needsCompareFamilies = true;
          } else if ($$typeofNextType === REACT_LAZY_TYPE) {
            needsCompareFamilies = true;
          }

          break;
        }

      case MemoComponent:
      case SimpleMemoComponent:
        {
          if ($$typeofNextType === REACT_MEMO_TYPE) {
            // TODO: if it was but can no longer be simple,
            // we shouldn't set this.
            needsCompareFamilies = true;
          } else if ($$typeofNextType === REACT_LAZY_TYPE) {
            needsCompareFamilies = true;
          }

          break;
        }

      default:
        return false;
    } // Check if both types have a family and it's the same one.


    if (needsCompareFamilies) {
      // Note: memo() and forwardRef() we'll compare outer rather than inner type.
      // This means both of them need to be registered to preserve state.
      // If we unwrapped and compared the inner types for wrappers instead,
      // then we would risk falsely saying two separate memo(Foo)
      // calls are equivalent because they wrap the same Foo function.
      var prevFamily = resolveFamily(prevType);

      if (prevFamily !== undefined && prevFamily === resolveFamily(nextType)) {
        return true;
      }
    }

    return false;
  }
}
function markFailedErrorBoundaryForHotReloading(fiber) {
  {
    if (resolveFamily === null) {
      // Hot reloading is disabled.
      return;
    }

    if (typeof WeakSet !== 'function') {
      return;
    }

    if (failedBoundaries === null) {
      failedBoundaries = new WeakSet();
    }

    failedBoundaries.add(fiber);
  }
}
var scheduleRefresh = function (root, update) {
  {
    if (resolveFamily === null) {
      // Hot reloading is disabled.
      return;
    }

    var staleFamilies = update.staleFamilies,
        updatedFamilies = update.updatedFamilies;
    flushPassiveEffects();
    flushSync(function () {
      scheduleFibersWithFamiliesRecursively(root.current, updatedFamilies, staleFamilies);
    });
  }
};
var scheduleRoot = function (root, element) {
  {
    if (root.context !== emptyContextObject) {
      // Super edge case: root has a legacy _renderSubtree context
      // but we don't know the parentComponent so we can't pass it.
      // Just ignore. We'll delete this with _renderSubtree code path later.
      return;
    }

    flushPassiveEffects();
    flushSync(function () {
      updateContainer(element, root, null, null);
    });
  }
};

function scheduleFibersWithFamiliesRecursively(fiber, updatedFamilies, staleFamilies) {
  {
    var alternate = fiber.alternate,
        child = fiber.child,
        sibling = fiber.sibling,
        tag = fiber.tag,
        type = fiber.type;
    var candidateType = null;

    switch (tag) {
      case FunctionComponent:
      case SimpleMemoComponent:
      case ClassComponent:
        candidateType = type;
        break;

      case ForwardRef:
        candidateType = type.render;
        break;
    }

    if (resolveFamily === null) {
      throw new Error('Expected resolveFamily to be set during hot reload.');
    }

    var needsRender = false;
    var needsRemount = false;

    if (candidateType !== null) {
      var family = resolveFamily(candidateType);

      if (family !== undefined) {
        if (staleFamilies.has(family)) {
          needsRemount = true;
        } else if (updatedFamilies.has(family)) {
          if (tag === ClassComponent) {
            needsRemount = true;
          } else {
            needsRender = true;
          }
        }
      }
    }

    if (failedBoundaries !== null) {
      if (failedBoundaries.has(fiber) || alternate !== null && failedBoundaries.has(alternate)) {
        needsRemount = true;
      }
    }

    if (needsRemount) {
      fiber._debugNeedsRemount = true;
    }

    if (needsRemount || needsRender) {
      scheduleUpdateOnFiber(fiber, SyncLane, NoTimestamp);
    }

    if (child !== null && !needsRemount) {
      scheduleFibersWithFamiliesRecursively(child, updatedFamilies, staleFamilies);
    }

    if (sibling !== null) {
      scheduleFibersWithFamiliesRecursively(sibling, updatedFamilies, staleFamilies);
    }
  }
}

var findHostInstancesForRefresh = function (root, families) {
  {
    var hostInstances = new Set();
    var types = new Set(families.map(function (family) {
      return family.current;
    }));
    findHostInstancesForMatchingFibersRecursively(root.current, types, hostInstances);
    return hostInstances;
  }
};

function findHostInstancesForMatchingFibersRecursively(fiber, types, hostInstances) {
  {
    var child = fiber.child,
        sibling = fiber.sibling,
        tag = fiber.tag,
        type = fiber.type;
    var candidateType = null;

    switch (tag) {
      case FunctionComponent:
      case SimpleMemoComponent:
      case ClassComponent:
        candidateType = type;
        break;

      case ForwardRef:
        candidateType = type.render;
        break;
    }

    var didMatch = false;

    if (candidateType !== null) {
      if (types.has(candidateType)) {
        didMatch = true;
      }
    }

    if (didMatch) {
      // We have a match. This only drills down to the closest host components.
      // There's no need to search deeper because for the purpose of giving
      // visual feedback, "flashing" outermost parent rectangles is sufficient.
      findHostInstancesForFiberShallowly(fiber, hostInstances);
    } else {
      // If there's no match, maybe there will be one further down in the child tree.
      if (child !== null) {
        findHostInstancesForMatchingFibersRecursively(child, types, hostInstances);
      }
    }

    if (sibling !== null) {
      findHostInstancesForMatchingFibersRecursively(sibling, types, hostInstances);
    }
  }
}

function findHostInstancesForFiberShallowly(fiber, hostInstances) {
  {
    var foundHostInstances = findChildHostInstancesForFiberShallowly(fiber, hostInstances);

    if (foundHostInstances) {
      return;
    } // If we didn't find any host children, fallback to closest host parent.


    var node = fiber;

    while (true) {
      switch (node.tag) {
        case HostComponent:
          hostInstances.add(node.stateNode);
          return;

        case HostPortal:
          hostInstances.add(node.stateNode.containerInfo);
          return;

        case HostRoot:
          hostInstances.add(node.stateNode.containerInfo);
          return;
      }

      if (node.return === null) {
        throw new Error('Expected to reach root first.');
      }

      node = node.return;
    }
  }
}

function findChildHostInstancesForFiberShallowly(fiber, hostInstances) {
  {
    var node = fiber;
    var foundHostInstances = false;

    while (true) {
      if (node.tag === HostComponent) {
        // We got a match.
        foundHostInstances = true;
        hostInstances.add(node.stateNode); // There may still be more, so keep searching.
      } else if (node.child !== null) {
        node.child.return = node;
        node = node.child;
        continue;
      }

      if (node === fiber) {
        return foundHostInstances;
      }

      while (node.sibling === null) {
        if (node.return === null || node.return === fiber) {
          return foundHostInstances;
        }

        node = node.return;
      }

      node.sibling.return = node.return;
      node = node.sibling;
    }
  }

  return false;
}

var hasBadMapPolyfill;

{
  hasBadMapPolyfill = false;

  try {
    var nonExtensibleObject = Object.preventExtensions({});
    /* eslint-disable no-new */

    new Map([[nonExtensibleObject, null]]);
    new Set([nonExtensibleObject]);
    /* eslint-enable no-new */
  } catch (e) {
    // TODO: Consider warning about bad polyfills
    hasBadMapPolyfill = true;
  }
}

var debugCounter = 1;

function FiberNode(tag, pendingProps, key, mode) {
  // Instance
  this.tag = tag;
  this.key = key;
  this.elementType = null;
  this.type = null;
  this.stateNode = null; // Fiber

  this.return = null;
  this.child = null;
  this.sibling = null;
  this.index = 0;
  this.ref = null;
  this.pendingProps = pendingProps;
  this.memoizedProps = null;
  this.updateQueue = null;
  this.memoizedState = null;
  this.dependencies = null;
  this.mode = mode; // Effects

  this.flags = NoFlags;
  this.nextEffect = null;
  this.firstEffect = null;
  this.lastEffect = null;
  this.lanes = NoLanes;
  this.childLanes = NoLanes;
  this.alternate = null;

  {
    // Note: The following is done to avoid a v8 performance cliff.
    //
    // Initializing the fields below to smis and later updating them with
    // double values will cause Fibers to end up having separate shapes.
    // This behavior/bug has something to do with Object.preventExtension().
    // Fortunately this only impacts DEV builds.
    // Unfortunately it makes React unusably slow for some applications.
    // To work around this, initialize the fields below with doubles.
    //
    // Learn more about this here:
    // https://github.com/facebook/react/issues/14365
    // https://bugs.chromium.org/p/v8/issues/detail?id=8538
    this.actualDuration = Number.NaN;
    this.actualStartTime = Number.NaN;
    this.selfBaseDuration = Number.NaN;
    this.treeBaseDuration = Number.NaN; // It's okay to replace the initial doubles with smis after initialization.
    // This won't trigger the performance cliff mentioned above,
    // and it simplifies other profiler code (including DevTools).

    this.actualDuration = 0;
    this.actualStartTime = -1;
    this.selfBaseDuration = 0;
    this.treeBaseDuration = 0;
  }

  {
    // This isn't directly used but is handy for debugging internals:
    this._debugID = debugCounter++;
    this._debugSource = null;
    this._debugOwner = null;
    this._debugNeedsRemount = false;
    this._debugHookTypes = null;

    if (!hasBadMapPolyfill && typeof Object.preventExtensions === 'function') {
      Object.preventExtensions(this);
    }
  }
} // This is a constructor function, rather than a POJO constructor, still
// please ensure we do the following:
// 1) Nobody should add any instance methods on this. Instance methods can be
//    more difficult to predict when they get optimized and they are almost
//    never inlined properly in static compilers.
// 2) Nobody should rely on `instanceof Fiber` for type testing. We should
//    always know when it is a fiber.
// 3) We might want to experiment with using numeric keys since they are easier
//    to optimize in a non-JIT environment.
// 4) We can easily go from a constructor to a createFiber object literal if that
//    is faster.
// 5) It should be easy to port this to a C struct and keep a C implementation
//    compatible.


var createFiber = function (tag, pendingProps, key, mode) {
  // $FlowFixMe: the shapes are exact here but Flow doesn't like constructors
  return new FiberNode(tag, pendingProps, key, mode);
};

function shouldConstruct$1(Component) {
  var prototype = Component.prototype;
  return !!(prototype && prototype.isReactComponent);
}

function isSimpleFunctionComponent(type) {
  return typeof type === 'function' && !shouldConstruct$1(type) && type.defaultProps === undefined;
}
function resolveLazyComponentTag(Component) {
  if (typeof Component === 'function') {
    return shouldConstruct$1(Component) ? ClassComponent : FunctionComponent;
  } else if (Component !== undefined && Component !== null) {
    var $$typeof = Component.$$typeof;

    if ($$typeof === REACT_FORWARD_REF_TYPE) {
      return ForwardRef;
    }

    if ($$typeof === REACT_MEMO_TYPE) {
      return MemoComponent;
    }
  }

  return IndeterminateComponent;
} // This is used to create an alternate fiber to do work on.

function createWorkInProgress(current, pendingProps) {
  var workInProgress = current.alternate;

  if (workInProgress === null) {
    // We use a double buffering pooling technique because we know that we'll
    // only ever need at most two versions of a tree. We pool the "other" unused
    // node that we're free to reuse. This is lazily created to avoid allocating
    // extra objects for things that are never updated. It also allow us to
    // reclaim the extra memory if needed.
    workInProgress = createFiber(current.tag, pendingProps, current.key, current.mode);
    workInProgress.elementType = current.elementType;
    workInProgress.type = current.type;
    workInProgress.stateNode = current.stateNode;

    {
      // DEV-only fields
      workInProgress._debugID = current._debugID;
      workInProgress._debugSource = current._debugSource;
      workInProgress._debugOwner = current._debugOwner;
      workInProgress._debugHookTypes = current._debugHookTypes;
    }

    workInProgress.alternate = current;
    current.alternate = workInProgress;
  } else {
    workInProgress.pendingProps = pendingProps; // Needed because Blocks store data on type.

    workInProgress.type = current.type; // We already have an alternate.
    // Reset the effect tag.

    workInProgress.flags = NoFlags; // The effect list is no longer valid.

    workInProgress.nextEffect = null;
    workInProgress.firstEffect = null;
    workInProgress.lastEffect = null;

    {
      // We intentionally reset, rather than copy, actualDuration & actualStartTime.
      // This prevents time from endlessly accumulating in new commits.
      // This has the downside of resetting values for different priority renders,
      // But works for yielding (the common case) and should support resuming.
      workInProgress.actualDuration = 0;
      workInProgress.actualStartTime = -1;
    }
  }

  workInProgress.childLanes = current.childLanes;
  workInProgress.lanes = current.lanes;
  workInProgress.child = current.child;
  workInProgress.memoizedProps = current.memoizedProps;
  workInProgress.memoizedState = current.memoizedState;
  workInProgress.updateQueue = current.updateQueue; // Clone the dependencies object. This is mutated during the render phase, so
  // it cannot be shared with the current fiber.

  var currentDependencies = current.dependencies;
  workInProgress.dependencies = currentDependencies === null ? null : {
    lanes: currentDependencies.lanes,
    firstContext: currentDependencies.firstContext
  }; // These will be overridden during the parent's reconciliation

  workInProgress.sibling = current.sibling;
  workInProgress.index = current.index;
  workInProgress.ref = current.ref;

  {
    workInProgress.selfBaseDuration = current.selfBaseDuration;
    workInProgress.treeBaseDuration = current.treeBaseDuration;
  }

  {
    workInProgress._debugNeedsRemount = current._debugNeedsRemount;

    switch (workInProgress.tag) {
      case IndeterminateComponent:
      case FunctionComponent:
      case SimpleMemoComponent:
        workInProgress.type = resolveFunctionForHotReloading(current.type);
        break;

      case ClassComponent:
        workInProgress.type = resolveClassForHotReloading(current.type);
        break;

      case ForwardRef:
        workInProgress.type = resolveForwardRefForHotReloading(current.type);
        break;
    }
  }

  return workInProgress;
} // Used to reuse a Fiber for a second pass.

function resetWorkInProgress(workInProgress, renderLanes) {
  // This resets the Fiber to what createFiber or createWorkInProgress would
  // have set the values to before during the first pass. Ideally this wouldn't
  // be necessary but unfortunately many code paths reads from the workInProgress
  // when they should be reading from current and writing to workInProgress.
  // We assume pendingProps, index, key, ref, return are still untouched to
  // avoid doing another reconciliation.
  // Reset the effect tag but keep any Placement tags, since that's something
  // that child fiber is setting, not the reconciliation.
  workInProgress.flags &= Placement; // The effect list is no longer valid.

  workInProgress.nextEffect = null;
  workInProgress.firstEffect = null;
  workInProgress.lastEffect = null;
  var current = workInProgress.alternate;

  if (current === null) {
    // Reset to createFiber's initial values.
    workInProgress.childLanes = NoLanes;
    workInProgress.lanes = renderLanes;
    workInProgress.child = null;
    workInProgress.memoizedProps = null;
    workInProgress.memoizedState = null;
    workInProgress.updateQueue = null;
    workInProgress.dependencies = null;
    workInProgress.stateNode = null;

    {
      // Note: We don't reset the actualTime counts. It's useful to accumulate
      // actual time across multiple render passes.
      workInProgress.selfBaseDuration = 0;
      workInProgress.treeBaseDuration = 0;
    }
  } else {
    // Reset to the cloned values that createWorkInProgress would've.
    workInProgress.childLanes = current.childLanes;
    workInProgress.lanes = current.lanes;
    workInProgress.child = current.child;
    workInProgress.memoizedProps = current.memoizedProps;
    workInProgress.memoizedState = current.memoizedState;
    workInProgress.updateQueue = current.updateQueue; // Needed because Blocks store data on type.

    workInProgress.type = current.type; // Clone the dependencies object. This is mutated during the render phase, so
    // it cannot be shared with the current fiber.

    var currentDependencies = current.dependencies;
    workInProgress.dependencies = currentDependencies === null ? null : {
      lanes: currentDependencies.lanes,
      firstContext: currentDependencies.firstContext
    };

    {
      // Note: We don't reset the actualTime counts. It's useful to accumulate
      // actual time across multiple render passes.
      workInProgress.selfBaseDuration = current.selfBaseDuration;
      workInProgress.treeBaseDuration = current.treeBaseDuration;
    }
  }

  return workInProgress;
}
function createHostRootFiber(tag) {
  var mode;

  if (tag === ConcurrentRoot) {
    mode = ConcurrentMode | BlockingMode | StrictMode;
  } else if (tag === BlockingRoot) {
    mode = BlockingMode | StrictMode;
  } else {
    mode = NoMode;
  }

  if ( isDevToolsPresent) {
    // Always collect profile timings when DevTools are present.
    // This enables DevTools to start capturing timing at any point–
    // Without some nodes in the tree having empty base times.
    mode |= ProfileMode;
  }

  return createFiber(HostRoot, null, null, mode);
}
function createFiberFromTypeAndProps(type, // React$ElementType
key, pendingProps, owner, mode, lanes) {
  var fiberTag = IndeterminateComponent; // The resolved type is set if we know what the final type will be. I.e. it's not lazy.

  var resolvedType = type;

  if (typeof type === 'function') {
    if (shouldConstruct$1(type)) {
      fiberTag = ClassComponent;

      {
        resolvedType = resolveClassForHotReloading(resolvedType);
      }
    } else {
      {
        resolvedType = resolveFunctionForHotReloading(resolvedType);
      }
    }
  } else if (typeof type === 'string') {
    fiberTag = HostComponent;
  } else {
    getTag: switch (type) {
      case REACT_FRAGMENT_TYPE:
        return createFiberFromFragment(pendingProps.children, mode, lanes, key);

      case REACT_DEBUG_TRACING_MODE_TYPE:
        fiberTag = Mode;
        mode |= DebugTracingMode;
        break;

      case REACT_STRICT_MODE_TYPE:
        fiberTag = Mode;
        mode |= StrictMode;
        break;

      case REACT_PROFILER_TYPE:
        return createFiberFromProfiler(pendingProps, mode, lanes, key);

      case REACT_SUSPENSE_TYPE:
        return createFiberFromSuspense(pendingProps, mode, lanes, key);

      case REACT_SUSPENSE_LIST_TYPE:
        return createFiberFromSuspenseList(pendingProps, mode, lanes, key);

      case REACT_OFFSCREEN_TYPE:
        return createFiberFromOffscreen(pendingProps, mode, lanes, key);

      case REACT_LEGACY_HIDDEN_TYPE:
        return createFiberFromLegacyHidden(pendingProps, mode, lanes, key);

      case REACT_SCOPE_TYPE:

      // eslint-disable-next-line no-fallthrough

      default:
        {
          if (typeof type === 'object' && type !== null) {
            switch (type.$$typeof) {
              case REACT_PROVIDER_TYPE:
                fiberTag = ContextProvider;
                break getTag;

              case REACT_CONTEXT_TYPE:
                // This is a consumer
                fiberTag = ContextConsumer;
                break getTag;

              case REACT_FORWARD_REF_TYPE:
                fiberTag = ForwardRef;

                {
                  resolvedType = resolveForwardRefForHotReloading(resolvedType);
                }

                break getTag;

              case REACT_MEMO_TYPE:
                fiberTag = MemoComponent;
                break getTag;

              case REACT_LAZY_TYPE:
                fiberTag = LazyComponent;
                resolvedType = null;
                break getTag;

              case REACT_BLOCK_TYPE:
                fiberTag = Block;
                break getTag;
            }
          }

          var info = '';

          {
            if (type === undefined || typeof type === 'object' && type !== null && Object.keys(type).length === 0) {
              info += ' You likely forgot to export your component from the file ' + "it's defined in, or you might have mixed up default and " + 'named imports.';
            }

            var ownerName = owner ? getComponentName(owner.type) : null;

            if (ownerName) {
              info += '\n\nCheck the render method of `' + ownerName + '`.';
            }
          }

          {
            {
              throw Error( "Element type is invalid: expected a string (for built-in components) or a class/function (for composite components) but got: " + (type == null ? type : typeof type) + "." + info );
            }
          }
        }
    }
  }

  var fiber = createFiber(fiberTag, pendingProps, key, mode);
  fiber.elementType = type;
  fiber.type = resolvedType;
  fiber.lanes = lanes;

  {
    fiber._debugOwner = owner;
  }

  return fiber;
}
function createFiberFromElement(element, mode, lanes) {
  var owner = null;

  {
    owner = element._owner;
  }

  var type = element.type;
  var key = element.key;
  var pendingProps = element.props;
  var fiber = createFiberFromTypeAndProps(type, key, pendingProps, owner, mode, lanes);

  {
    fiber._debugSource = element._source;
    fiber._debugOwner = element._owner;
  }

  return fiber;
}
function createFiberFromFragment(elements, mode, lanes, key) {
  var fiber = createFiber(Fragment, elements, key, mode);
  fiber.lanes = lanes;
  return fiber;
}

function createFiberFromProfiler(pendingProps, mode, lanes, key) {
  {
    if (typeof pendingProps.id !== 'string') {
      error('Profiler must specify an "id" as a prop');
    }
  }

  var fiber = createFiber(Profiler, pendingProps, key, mode | ProfileMode); // TODO: The Profiler fiber shouldn't have a type. It has a tag.

  fiber.elementType = REACT_PROFILER_TYPE;
  fiber.type = REACT_PROFILER_TYPE;
  fiber.lanes = lanes;

  {
    fiber.stateNode = {
      effectDuration: 0,
      passiveEffectDuration: 0
    };
  }

  return fiber;
}

function createFiberFromSuspense(pendingProps, mode, lanes, key) {
  var fiber = createFiber(SuspenseComponent, pendingProps, key, mode); // TODO: The SuspenseComponent fiber shouldn't have a type. It has a tag.
  // This needs to be fixed in getComponentName so that it relies on the tag
  // instead.

  fiber.type = REACT_SUSPENSE_TYPE;
  fiber.elementType = REACT_SUSPENSE_TYPE;
  fiber.lanes = lanes;
  return fiber;
}
function createFiberFromSuspenseList(pendingProps, mode, lanes, key) {
  var fiber = createFiber(SuspenseListComponent, pendingProps, key, mode);

  {
    // TODO: The SuspenseListComponent fiber shouldn't have a type. It has a tag.
    // This needs to be fixed in getComponentName so that it relies on the tag
    // instead.
    fiber.type = REACT_SUSPENSE_LIST_TYPE;
  }

  fiber.elementType = REACT_SUSPENSE_LIST_TYPE;
  fiber.lanes = lanes;
  return fiber;
}
function createFiberFromOffscreen(pendingProps, mode, lanes, key) {
  var fiber = createFiber(OffscreenComponent, pendingProps, key, mode); // TODO: The OffscreenComponent fiber shouldn't have a type. It has a tag.
  // This needs to be fixed in getComponentName so that it relies on the tag
  // instead.

  {
    fiber.type = REACT_OFFSCREEN_TYPE;
  }

  fiber.elementType = REACT_OFFSCREEN_TYPE;
  fiber.lanes = lanes;
  return fiber;
}
function createFiberFromLegacyHidden(pendingProps, mode, lanes, key) {
  var fiber = createFiber(LegacyHiddenComponent, pendingProps, key, mode); // TODO: The LegacyHidden fiber shouldn't have a type. It has a tag.
  // This needs to be fixed in getComponentName so that it relies on the tag
  // instead.

  {
    fiber.type = REACT_LEGACY_HIDDEN_TYPE;
  }

  fiber.elementType = REACT_LEGACY_HIDDEN_TYPE;
  fiber.lanes = lanes;
  return fiber;
}
function createFiberFromText(content, mode, lanes) {
  var fiber = createFiber(HostText, content, null, mode);
  fiber.lanes = lanes;
  return fiber;
}
function createFiberFromHostInstanceForDeletion() {
  var fiber = createFiber(HostComponent, null, null, NoMode); // TODO: These should not need a type.

  fiber.elementType = 'DELETED';
  fiber.type = 'DELETED';
  return fiber;
}
function createFiberFromPortal(portal, mode, lanes) {
  var pendingProps = portal.children !== null ? portal.children : [];
  var fiber = createFiber(HostPortal, pendingProps, portal.key, mode);
  fiber.lanes = lanes;
  fiber.stateNode = {
    containerInfo: portal.containerInfo,
    pendingChildren: null,
    // Used by persistent updates
    implementation: portal.implementation
  };
  return fiber;
} // Used for stashing WIP properties to replay failed work in DEV.

function assignFiberPropertiesInDEV(target, source) {
  if (target === null) {
    // This Fiber's initial properties will always be overwritten.
    // We only use a Fiber to ensure the same hidden class so DEV isn't slow.
    target = createFiber(IndeterminateComponent, null, null, NoMode);
  } // This is intentionally written as a list of all properties.
  // We tried to use Object.assign() instead but this is called in
  // the hottest path, and Object.assign() was too slow:
  // https://github.com/facebook/react/issues/12502
  // This code is DEV-only so size is not a concern.


  target.tag = source.tag;
  target.key = source.key;
  target.elementType = source.elementType;
  target.type = source.type;
  target.stateNode = source.stateNode;
  target.return = source.return;
  target.child = source.child;
  target.sibling = source.sibling;
  target.index = source.index;
  target.ref = source.ref;
  target.pendingProps = source.pendingProps;
  target.memoizedProps = source.memoizedProps;
  target.updateQueue = source.updateQueue;
  target.memoizedState = source.memoizedState;
  target.dependencies = source.dependencies;
  target.mode = source.mode;
  target.flags = source.flags;
  target.nextEffect = source.nextEffect;
  target.firstEffect = source.firstEffect;
  target.lastEffect = source.lastEffect;
  target.lanes = source.lanes;
  target.childLanes = source.childLanes;
  target.alternate = source.alternate;

  {
    target.actualDuration = source.actualDuration;
    target.actualStartTime = source.actualStartTime;
    target.selfBaseDuration = source.selfBaseDuration;
    target.treeBaseDuration = source.treeBaseDuration;
  }

  target._debugID = source._debugID;
  target._debugSource = source._debugSource;
  target._debugOwner = source._debugOwner;
  target._debugNeedsRemount = source._debugNeedsRemount;
  target._debugHookTypes = source._debugHookTypes;
  return target;
}

function FiberRootNode(containerInfo, tag, hydrate) {
  this.tag = tag;
  this.containerInfo = containerInfo;
  this.pendingChildren = null;
  this.current = null;
  this.pingCache = null;
  this.finishedWork = null;
  this.timeoutHandle = noTimeout;
  this.context = null;
  this.pendingContext = null;
  this.hydrate = hydrate;
  this.callbackNode = null;
  this.callbackPriority = NoLanePriority;
  this.eventTimes = createLaneMap(NoLanes);
  this.expirationTimes = createLaneMap(NoTimestamp);
  this.pendingLanes = NoLanes;
  this.suspendedLanes = NoLanes;
  this.pingedLanes = NoLanes;
  this.expiredLanes = NoLanes;
  this.mutableReadLanes = NoLanes;
  this.finishedLanes = NoLanes;
  this.entangledLanes = NoLanes;
  this.entanglements = createLaneMap(NoLanes);

  {
    this.mutableSourceEagerHydrationData = null;
  }

  {
    this.interactionThreadID = tracing.unstable_getThreadID();
    this.memoizedInteractions = new Set();
    this.pendingInteractionMap = new Map();
  }

  {
    switch (tag) {
      case BlockingRoot:
        this._debugRootType = 'createBlockingRoot()';
        break;

      case ConcurrentRoot:
        this._debugRootType = 'createRoot()';
        break;

      case LegacyRoot:
        this._debugRootType = 'createLegacyRoot()';
        break;
    }
  }
}

function createFiberRoot(containerInfo, tag, hydrate, hydrationCallbacks) {
  var root = new FiberRootNode(containerInfo, tag, hydrate);
  // stateNode is any.


  var uninitializedFiber = createHostRootFiber(tag);
  root.current = uninitializedFiber;
  uninitializedFiber.stateNode = root;
  initializeUpdateQueue(uninitializedFiber);
  return root;
}

// This ensures that the version used for server rendering matches the one
// that is eventually read during hydration.
// If they don't match there's a potential tear and a full deopt render is required.

function registerMutableSourceForHydration(root, mutableSource) {
  var getVersion = mutableSource._getVersion;
  var version = getVersion(mutableSource._source); // TODO Clear this data once all pending hydration work is finished.
  // Retaining it forever may interfere with GC.

  if (root.mutableSourceEagerHydrationData == null) {
    root.mutableSourceEagerHydrationData = [mutableSource, version];
  } else {
    root.mutableSourceEagerHydrationData.push(mutableSource, version);
  }
}

function createPortal(children, containerInfo, // TODO: figure out the API for cross-renderer implementation.
implementation) {
  var key = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
  return {
    // This tag allow us to uniquely identify this as a React Portal
    $$typeof: REACT_PORTAL_TYPE,
    key: key == null ? null : '' + key,
    children: children,
    containerInfo: containerInfo,
    implementation: implementation
  };
}

var didWarnAboutNestedUpdates;
var didWarnAboutFindNodeInStrictMode;

{
  didWarnAboutNestedUpdates = false;
  didWarnAboutFindNodeInStrictMode = {};
}

function getContextForSubtree(parentComponent) {
  if (!parentComponent) {
    return emptyContextObject;
  }

  var fiber = get(parentComponent);
  var parentContext = findCurrentUnmaskedContext(fiber);

  if (fiber.tag === ClassComponent) {
    var Component = fiber.type;

    if (isContextProvider(Component)) {
      return processChildContext(fiber, Component, parentContext);
    }
  }

  return parentContext;
}

function findHostInstanceWithWarning(component, methodName) {
  {
    var fiber = get(component);

    if (fiber === undefined) {
      if (typeof component.render === 'function') {
        {
          {
            throw Error( "Unable to find node on an unmounted component." );
          }
        }
      } else {
        {
          {
            throw Error( "Argument appears to not be a ReactComponent. Keys: " + Object.keys(component) );
          }
        }
      }
    }

    var hostFiber = findCurrentHostFiber(fiber);

    if (hostFiber === null) {
      return null;
    }

    if (hostFiber.mode & StrictMode) {
      var componentName = getComponentName(fiber.type) || 'Component';

      if (!didWarnAboutFindNodeInStrictMode[componentName]) {
        didWarnAboutFindNodeInStrictMode[componentName] = true;
        var previousFiber = current;

        try {
          setCurrentFiber(hostFiber);

          if (fiber.mode & StrictMode) {
            error('%s is deprecated in StrictMode. ' + '%s was passed an instance of %s which is inside StrictMode. ' + 'Instead, add a ref directly to the element you want to reference. ' + 'Learn more about using refs safely here: ' + 'https://reactjs.org/link/strict-mode-find-node', methodName, methodName, componentName);
          } else {
            error('%s is deprecated in StrictMode. ' + '%s was passed an instance of %s which renders StrictMode children. ' + 'Instead, add a ref directly to the element you want to reference. ' + 'Learn more about using refs safely here: ' + 'https://reactjs.org/link/strict-mode-find-node', methodName, methodName, componentName);
          }
        } finally {
          // Ideally this should reset to previous but this shouldn't be called in
          // render and there's another warning for that anyway.
          if (previousFiber) {
            setCurrentFiber(previousFiber);
          } else {
            resetCurrentFiber();
          }
        }
      }
    }

    return hostFiber.stateNode;
  }
}

function createContainer(containerInfo, tag, hydrate, hydrationCallbacks) {
  return createFiberRoot(containerInfo, tag, hydrate);
}
function updateContainer(element, container, parentComponent, callback) {
  {
    onScheduleRoot(container, element);
  }

  var current$1 = container.current;
  var eventTime = requestEventTime();

  {
    // $FlowExpectedError - jest isn't a global, and isn't recognized outside of tests
    if ('undefined' !== typeof jest) {
      warnIfUnmockedScheduler(current$1);
      warnIfNotScopedWithMatchingAct(current$1);
    }
  }

  var lane = requestUpdateLane(current$1);

  var context = getContextForSubtree(parentComponent);

  if (container.context === null) {
    container.context = context;
  } else {
    container.pendingContext = context;
  }

  {
    if (isRendering && current !== null && !didWarnAboutNestedUpdates) {
      didWarnAboutNestedUpdates = true;

      error('Render methods should be a pure function of props and state; ' + 'triggering nested component updates from render is not allowed. ' + 'If necessary, trigger nested updates in componentDidUpdate.\n\n' + 'Check the render method of %s.', getComponentName(current.type) || 'Unknown');
    }
  }

  var update = createUpdate(eventTime, lane); // Caution: React DevTools currently depends on this property
  // being called "element".

  update.payload = {
    element: element
  };
  callback = callback === undefined ? null : callback;

  if (callback !== null) {
    {
      if (typeof callback !== 'function') {
        error('render(...): Expected the last optional `callback` argument to be a ' + 'function. Instead received: %s.', callback);
      }
    }

    update.callback = callback;
  }

  enqueueUpdate(current$1, update);
  scheduleUpdateOnFiber(current$1, lane, eventTime);
  return lane;
}
function getPublicRootInstance(container) {
  var containerFiber = container.current;

  if (!containerFiber.child) {
    return null;
  }

  switch (containerFiber.child.tag) {
    case HostComponent:
      return getPublicInstance(containerFiber.child.stateNode);

    default:
      return containerFiber.child.stateNode;
  }
}

function markRetryLaneImpl(fiber, retryLane) {
  var suspenseState = fiber.memoizedState;

  if (suspenseState !== null && suspenseState.dehydrated !== null) {
    suspenseState.retryLane = higherPriorityLane(suspenseState.retryLane, retryLane);
  }
} // Increases the priority of thennables when they resolve within this boundary.


function markRetryLaneIfNotHydrated(fiber, retryLane) {
  markRetryLaneImpl(fiber, retryLane);
  var alternate = fiber.alternate;

  if (alternate) {
    markRetryLaneImpl(alternate, retryLane);
  }
}

function attemptUserBlockingHydration$1(fiber) {
  if (fiber.tag !== SuspenseComponent) {
    // We ignore HostRoots here because we can't increase
    // their priority and they should not suspend on I/O,
    // since you have to wrap anything that might suspend in
    // Suspense.
    return;
  }

  var eventTime = requestEventTime();
  var lane = InputDiscreteHydrationLane;
  scheduleUpdateOnFiber(fiber, lane, eventTime);
  markRetryLaneIfNotHydrated(fiber, lane);
}
function attemptContinuousHydration$1(fiber) {
  if (fiber.tag !== SuspenseComponent) {
    // We ignore HostRoots here because we can't increase
    // their priority and they should not suspend on I/O,
    // since you have to wrap anything that might suspend in
    // Suspense.
    return;
  }

  var eventTime = requestEventTime();
  var lane = SelectiveHydrationLane;
  scheduleUpdateOnFiber(fiber, lane, eventTime);
  markRetryLaneIfNotHydrated(fiber, lane);
}
function attemptHydrationAtCurrentPriority$1(fiber) {
  if (fiber.tag !== SuspenseComponent) {
    // We ignore HostRoots here because we can't increase
    // their priority other than synchronously flush it.
    return;
  }

  var eventTime = requestEventTime();
  var lane = requestUpdateLane(fiber);
  scheduleUpdateOnFiber(fiber, lane, eventTime);
  markRetryLaneIfNotHydrated(fiber, lane);
}
function runWithPriority$2(priority, fn) {

  try {
    setCurrentUpdateLanePriority(priority);
    return fn();
  } finally {
  }
}
function findHostInstanceWithNoPortals(fiber) {
  var hostFiber = findCurrentHostFiberWithNoPortals(fiber);

  if (hostFiber === null) {
    return null;
  }

  if (hostFiber.tag === FundamentalComponent) {
    return hostFiber.stateNode.instance;
  }

  return hostFiber.stateNode;
}

var shouldSuspendImpl = function (fiber) {
  return false;
};

function shouldSuspend(fiber) {
  return shouldSuspendImpl(fiber);
}
var overrideHookState = null;
var overrideHookStateDeletePath = null;
var overrideHookStateRenamePath = null;
var overrideProps = null;
var overridePropsDeletePath = null;
var overridePropsRenamePath = null;
var scheduleUpdate = null;
var setSuspenseHandler = null;

{
  var copyWithDeleteImpl = function (obj, path, index) {
    var key = path[index];
    var updated = Array.isArray(obj) ? obj.slice() : _assign({}, obj);

    if (index + 1 === path.length) {
      if (Array.isArray(updated)) {
        updated.splice(key, 1);
      } else {
        delete updated[key];
      }

      return updated;
    } // $FlowFixMe number or string is fine here


    updated[key] = copyWithDeleteImpl(obj[key], path, index + 1);
    return updated;
  };

  var copyWithDelete = function (obj, path) {
    return copyWithDeleteImpl(obj, path, 0);
  };

  var copyWithRenameImpl = function (obj, oldPath, newPath, index) {
    var oldKey = oldPath[index];
    var updated = Array.isArray(obj) ? obj.slice() : _assign({}, obj);

    if (index + 1 === oldPath.length) {
      var newKey = newPath[index]; // $FlowFixMe number or string is fine here

      updated[newKey] = updated[oldKey];

      if (Array.isArray(updated)) {
        updated.splice(oldKey, 1);
      } else {
        delete updated[oldKey];
      }
    } else {
      // $FlowFixMe number or string is fine here
      updated[oldKey] = copyWithRenameImpl( // $FlowFixMe number or string is fine here
      obj[oldKey], oldPath, newPath, index + 1);
    }

    return updated;
  };

  var copyWithRename = function (obj, oldPath, newPath) {
    if (oldPath.length !== newPath.length) {
      warn('copyWithRename() expects paths of the same length');

      return;
    } else {
      for (var i = 0; i < newPath.length - 1; i++) {
        if (oldPath[i] !== newPath[i]) {
          warn('copyWithRename() expects paths to be the same except for the deepest key');

          return;
        }
      }
    }

    return copyWithRenameImpl(obj, oldPath, newPath, 0);
  };

  var copyWithSetImpl = function (obj, path, index, value) {
    if (index >= path.length) {
      return value;
    }

    var key = path[index];
    var updated = Array.isArray(obj) ? obj.slice() : _assign({}, obj); // $FlowFixMe number or string is fine here

    updated[key] = copyWithSetImpl(obj[key], path, index + 1, value);
    return updated;
  };

  var copyWithSet = function (obj, path, value) {
    return copyWithSetImpl(obj, path, 0, value);
  };

  var findHook = function (fiber, id) {
    // For now, the "id" of stateful hooks is just the stateful hook index.
    // This may change in the future with e.g. nested hooks.
    var currentHook = fiber.memoizedState;

    while (currentHook !== null && id > 0) {
      currentHook = currentHook.next;
      id--;
    }

    return currentHook;
  }; // Support DevTools editable values for useState and useReducer.


  overrideHookState = function (fiber, id, path, value) {
    var hook = findHook(fiber, id);

    if (hook !== null) {
      var newState = copyWithSet(hook.memoizedState, path, value);
      hook.memoizedState = newState;
      hook.baseState = newState; // We aren't actually adding an update to the queue,
      // because there is no update we can add for useReducer hooks that won't trigger an error.
      // (There's no appropriate action type for DevTools overrides.)
      // As a result though, React will see the scheduled update as a noop and bailout.
      // Shallow cloning props works as a workaround for now to bypass the bailout check.

      fiber.memoizedProps = _assign({}, fiber.memoizedProps);
      scheduleUpdateOnFiber(fiber, SyncLane, NoTimestamp);
    }
  };

  overrideHookStateDeletePath = function (fiber, id, path) {
    var hook = findHook(fiber, id);

    if (hook !== null) {
      var newState = copyWithDelete(hook.memoizedState, path);
      hook.memoizedState = newState;
      hook.baseState = newState; // We aren't actually adding an update to the queue,
      // because there is no update we can add for useReducer hooks that won't trigger an error.
      // (There's no appropriate action type for DevTools overrides.)
      // As a result though, React will see the scheduled update as a noop and bailout.
      // Shallow cloning props works as a workaround for now to bypass the bailout check.

      fiber.memoizedProps = _assign({}, fiber.memoizedProps);
      scheduleUpdateOnFiber(fiber, SyncLane, NoTimestamp);
    }
  };

  overrideHookStateRenamePath = function (fiber, id, oldPath, newPath) {
    var hook = findHook(fiber, id);

    if (hook !== null) {
      var newState = copyWithRename(hook.memoizedState, oldPath, newPath);
      hook.memoizedState = newState;
      hook.baseState = newState; // We aren't actually adding an update to the queue,
      // because there is no update we can add for useReducer hooks that won't trigger an error.
      // (There's no appropriate action type for DevTools overrides.)
      // As a result though, React will see the scheduled update as a noop and bailout.
      // Shallow cloning props works as a workaround for now to bypass the bailout check.

      fiber.memoizedProps = _assign({}, fiber.memoizedProps);
      scheduleUpdateOnFiber(fiber, SyncLane, NoTimestamp);
    }
  }; // Support DevTools props for function components, forwardRef, memo, host components, etc.


  overrideProps = function (fiber, path, value) {
    fiber.pendingProps = copyWithSet(fiber.memoizedProps, path, value);

    if (fiber.alternate) {
      fiber.alternate.pendingProps = fiber.pendingProps;
    }

    scheduleUpdateOnFiber(fiber, SyncLane, NoTimestamp);
  };

  overridePropsDeletePath = function (fiber, path) {
    fiber.pendingProps = copyWithDelete(fiber.memoizedProps, path);

    if (fiber.alternate) {
      fiber.alternate.pendingProps = fiber.pendingProps;
    }

    scheduleUpdateOnFiber(fiber, SyncLane, NoTimestamp);
  };

  overridePropsRenamePath = function (fiber, oldPath, newPath) {
    fiber.pendingProps = copyWithRename(fiber.memoizedProps, oldPath, newPath);

    if (fiber.alternate) {
      fiber.alternate.pendingProps = fiber.pendingProps;
    }

    scheduleUpdateOnFiber(fiber, SyncLane, NoTimestamp);
  };

  scheduleUpdate = function (fiber) {
    scheduleUpdateOnFiber(fiber, SyncLane, NoTimestamp);
  };

  setSuspenseHandler = function (newShouldSuspendImpl) {
    shouldSuspendImpl = newShouldSuspendImpl;
  };
}

function findHostInstanceByFiber(fiber) {
  var hostFiber = findCurrentHostFiber(fiber);

  if (hostFiber === null) {
    return null;
  }

  return hostFiber.stateNode;
}

function emptyFindFiberByHostInstance(instance) {
  return null;
}

function getCurrentFiberForDevTools() {
  return current;
}

function injectIntoDevTools(devToolsConfig) {
  var findFiberByHostInstance = devToolsConfig.findFiberByHostInstance;
  var ReactCurrentDispatcher = ReactSharedInternals.ReactCurrentDispatcher;
  return injectInternals({
    bundleType: devToolsConfig.bundleType,
    version: devToolsConfig.version,
    rendererPackageName: devToolsConfig.rendererPackageName,
    rendererConfig: devToolsConfig.rendererConfig,
    overrideHookState: overrideHookState,
    overrideHookStateDeletePath: overrideHookStateDeletePath,
    overrideHookStateRenamePath: overrideHookStateRenamePath,
    overrideProps: overrideProps,
    overridePropsDeletePath: overridePropsDeletePath,
    overridePropsRenamePath: overridePropsRenamePath,
    setSuspenseHandler: setSuspenseHandler,
    scheduleUpdate: scheduleUpdate,
    currentDispatcherRef: ReactCurrentDispatcher,
    findHostInstanceByFiber: findHostInstanceByFiber,
    findFiberByHostInstance: findFiberByHostInstance || emptyFindFiberByHostInstance,
    // React Refresh
    findHostInstancesForRefresh:  findHostInstancesForRefresh ,
    scheduleRefresh:  scheduleRefresh ,
    scheduleRoot:  scheduleRoot ,
    setRefreshHandler:  setRefreshHandler ,
    // Enables DevTools to append owner stacks to error messages in DEV mode.
    getCurrentFiber:  getCurrentFiberForDevTools 
  });
}

function ReactDOMRoot(container, options) {
  this._internalRoot = createRootImpl(container, ConcurrentRoot, options);
}

function ReactDOMBlockingRoot(container, tag, options) {
  this._internalRoot = createRootImpl(container, tag, options);
}

ReactDOMRoot.prototype.render = ReactDOMBlockingRoot.prototype.render = function (children) {
  var root = this._internalRoot;

  {
    if (typeof arguments[1] === 'function') {
      error('render(...): does not support the second callback argument. ' + 'To execute a side effect after rendering, declare it in a component body with useEffect().');
    }

    var container = root.containerInfo;

    if (container.nodeType !== COMMENT_NODE) {
      var hostInstance = findHostInstanceWithNoPortals(root.current);

      if (hostInstance) {
        if (hostInstance.parentNode !== container) {
          error('render(...): It looks like the React-rendered content of the ' + 'root container was removed without using React. This is not ' + 'supported and will cause errors. Instead, call ' + "root.unmount() to empty a root's container.");
        }
      }
    }
  }

  updateContainer(children, root, null, null);
};

ReactDOMRoot.prototype.unmount = ReactDOMBlockingRoot.prototype.unmount = function () {
  {
    if (typeof arguments[0] === 'function') {
      error('unmount(...): does not support a callback argument. ' + 'To execute a side effect after rendering, declare it in a component body with useEffect().');
    }
  }

  var root = this._internalRoot;
  var container = root.containerInfo;
  updateContainer(null, root, null, function () {
    unmarkContainerAsRoot(container);
  });
};

function createRootImpl(container, tag, options) {
  // Tag is either LegacyRoot or Concurrent Root
  var hydrate = options != null && options.hydrate === true;
  var hydrationCallbacks = options != null && options.hydrationOptions || null;
  var mutableSources = options != null && options.hydrationOptions != null && options.hydrationOptions.mutableSources || null;
  var root = createContainer(container, tag, hydrate);
  markContainerAsRoot(root.current, container);
  var containerNodeType = container.nodeType;

  {
    var rootContainerElement = container.nodeType === COMMENT_NODE ? container.parentNode : container;
    listenToAllSupportedEvents(rootContainerElement);
  }

  if (mutableSources) {
    for (var i = 0; i < mutableSources.length; i++) {
      var mutableSource = mutableSources[i];
      registerMutableSourceForHydration(root, mutableSource);
    }
  }

  return root;
}
function createLegacyRoot(container, options) {
  return new ReactDOMBlockingRoot(container, LegacyRoot, options);
}
function isValidContainer(node) {
  return !!(node && (node.nodeType === ELEMENT_NODE || node.nodeType === DOCUMENT_NODE || node.nodeType === DOCUMENT_FRAGMENT_NODE || node.nodeType === COMMENT_NODE && node.nodeValue === ' react-mount-point-unstable '));
}

var ReactCurrentOwner$3 = ReactSharedInternals.ReactCurrentOwner;
var topLevelUpdateWarnings;
var warnedAboutHydrateAPI = false;

{
  topLevelUpdateWarnings = function (container) {
    if (container._reactRootContainer && container.nodeType !== COMMENT_NODE) {
      var hostInstance = findHostInstanceWithNoPortals(container._reactRootContainer._internalRoot.current);

      if (hostInstance) {
        if (hostInstance.parentNode !== container) {
          error('render(...): It looks like the React-rendered content of this ' + 'container was removed without using React. This is not ' + 'supported and will cause errors. Instead, call ' + 'ReactDOM.unmountComponentAtNode to empty a container.');
        }
      }
    }

    var isRootRenderedBySomeReact = !!container._reactRootContainer;
    var rootEl = getReactRootElementInContainer(container);
    var hasNonRootReactChild = !!(rootEl && getInstanceFromNode(rootEl));

    if (hasNonRootReactChild && !isRootRenderedBySomeReact) {
      error('render(...): Replacing React-rendered children with a new root ' + 'component. If you intended to update the children of this node, ' + 'you should instead have the existing children update their state ' + 'and render the new components instead of calling ReactDOM.render.');
    }

    if (container.nodeType === ELEMENT_NODE && container.tagName && container.tagName.toUpperCase() === 'BODY') {
      error('render(): Rendering components directly into document.body is ' + 'discouraged, since its children are often manipulated by third-party ' + 'scripts and browser extensions. This may lead to subtle ' + 'reconciliation issues. Try rendering into a container element created ' + 'for your app.');
    }
  };
}

function getReactRootElementInContainer(container) {
  if (!container) {
    return null;
  }

  if (container.nodeType === DOCUMENT_NODE) {
    return container.documentElement;
  } else {
    return container.firstChild;
  }
}

function shouldHydrateDueToLegacyHeuristic(container) {
  var rootElement = getReactRootElementInContainer(container);
  return !!(rootElement && rootElement.nodeType === ELEMENT_NODE && rootElement.hasAttribute(ROOT_ATTRIBUTE_NAME));
}

function legacyCreateRootFromDOMContainer(container, forceHydrate) {
  var shouldHydrate = forceHydrate || shouldHydrateDueToLegacyHeuristic(container); // First clear any existing content.

  if (!shouldHydrate) {
    var warned = false;
    var rootSibling;

    while (rootSibling = container.lastChild) {
      {
        if (!warned && rootSibling.nodeType === ELEMENT_NODE && rootSibling.hasAttribute(ROOT_ATTRIBUTE_NAME)) {
          warned = true;

          error('render(): Target node has markup rendered by React, but there ' + 'are unrelated nodes as well. This is most commonly caused by ' + 'white-space inserted around server-rendered markup.');
        }
      }

      container.removeChild(rootSibling);
    }
  }

  {
    if (shouldHydrate && !forceHydrate && !warnedAboutHydrateAPI) {
      warnedAboutHydrateAPI = true;

      warn('render(): Calling ReactDOM.render() to hydrate server-rendered markup ' + 'will stop working in React v18. Replace the ReactDOM.render() call ' + 'with ReactDOM.hydrate() if you want React to attach to the server HTML.');
    }
  }

  return createLegacyRoot(container, shouldHydrate ? {
    hydrate: true
  } : undefined);
}

function warnOnInvalidCallback$1(callback, callerName) {
  {
    if (callback !== null && typeof callback !== 'function') {
      error('%s(...): Expected the last optional `callback` argument to be a ' + 'function. Instead received: %s.', callerName, callback);
    }
  }
}

function legacyRenderSubtreeIntoContainer(parentComponent, children, container, forceHydrate, callback) {
  {
    topLevelUpdateWarnings(container);
    warnOnInvalidCallback$1(callback === undefined ? null : callback, 'render');
  } // TODO: Without `any` type, Flow says "Property cannot be accessed on any
  // member of intersection type." Whyyyyyy.


  var root = container._reactRootContainer;
  var fiberRoot;

  if (!root) {
    // Initial mount
    root = container._reactRootContainer = legacyCreateRootFromDOMContainer(container, forceHydrate);
    fiberRoot = root._internalRoot;

    if (typeof callback === 'function') {
      var originalCallback = callback;

      callback = function () {
        var instance = getPublicRootInstance(fiberRoot);
        originalCallback.call(instance);
      };
    } // Initial mount should not be batched.


    unbatchedUpdates(function () {
      updateContainer(children, fiberRoot, parentComponent, callback);
    });
  } else {
    fiberRoot = root._internalRoot;

    if (typeof callback === 'function') {
      var _originalCallback = callback;

      callback = function () {
        var instance = getPublicRootInstance(fiberRoot);

        _originalCallback.call(instance);
      };
    } // Update


    updateContainer(children, fiberRoot, parentComponent, callback);
  }

  return getPublicRootInstance(fiberRoot);
}

function findDOMNode(componentOrElement) {
  {
    var owner = ReactCurrentOwner$3.current;

    if (owner !== null && owner.stateNode !== null) {
      var warnedAboutRefsInRender = owner.stateNode._warnedAboutRefsInRender;

      if (!warnedAboutRefsInRender) {
        error('%s is accessing findDOMNode inside its render(). ' + 'render() should be a pure function of props and state. It should ' + 'never access something that requires stale data from the previous ' + 'render, such as refs. Move this logic to componentDidMount and ' + 'componentDidUpdate instead.', getComponentName(owner.type) || 'A component');
      }

      owner.stateNode._warnedAboutRefsInRender = true;
    }
  }

  if (componentOrElement == null) {
    return null;
  }

  if (componentOrElement.nodeType === ELEMENT_NODE) {
    return componentOrElement;
  }

  {
    return findHostInstanceWithWarning(componentOrElement, 'findDOMNode');
  }
}
function hydrate(element, container, callback) {
  if (!isValidContainer(container)) {
    {
      throw Error( "Target container is not a DOM element." );
    }
  }

  {
    var isModernRoot = isContainerMarkedAsRoot(container) && container._reactRootContainer === undefined;

    if (isModernRoot) {
      error('You are calling ReactDOM.hydrate() on a container that was previously ' + 'passed to ReactDOM.createRoot(). This is not supported. ' + 'Did you mean to call createRoot(container, {hydrate: true}).render(element)?');
    }
  } // TODO: throw or warn if we couldn't hydrate?


  return legacyRenderSubtreeIntoContainer(null, element, container, true, callback);
}
function render(element, container, callback) {
  if (!isValidContainer(container)) {
    {
      throw Error( "Target container is not a DOM element." );
    }
  }

  {
    var isModernRoot = isContainerMarkedAsRoot(container) && container._reactRootContainer === undefined;

    if (isModernRoot) {
      error('You are calling ReactDOM.render() on a container that was previously ' + 'passed to ReactDOM.createRoot(). This is not supported. ' + 'Did you mean to call root.render(element)?');
    }
  }

  return legacyRenderSubtreeIntoContainer(null, element, container, false, callback);
}
function unstable_renderSubtreeIntoContainer(parentComponent, element, containerNode, callback) {
  if (!isValidContainer(containerNode)) {
    {
      throw Error( "Target container is not a DOM element." );
    }
  }

  if (!(parentComponent != null && has(parentComponent))) {
    {
      throw Error( "parentComponent must be a valid React Component" );
    }
  }

  return legacyRenderSubtreeIntoContainer(parentComponent, element, containerNode, false, callback);
}
function unmountComponentAtNode(container) {
  if (!isValidContainer(container)) {
    {
      throw Error( "unmountComponentAtNode(...): Target container is not a DOM element." );
    }
  }

  {
    var isModernRoot = isContainerMarkedAsRoot(container) && container._reactRootContainer === undefined;

    if (isModernRoot) {
      error('You are calling ReactDOM.unmountComponentAtNode() on a container that was previously ' + 'passed to ReactDOM.createRoot(). This is not supported. Did you mean to call root.unmount()?');
    }
  }

  if (container._reactRootContainer) {
    {
      var rootEl = getReactRootElementInContainer(container);
      var renderedByDifferentReact = rootEl && !getInstanceFromNode(rootEl);

      if (renderedByDifferentReact) {
        error("unmountComponentAtNode(): The node you're attempting to unmount " + 'was rendered by another copy of React.');
      }
    } // Unmount should not be batched.


    unbatchedUpdates(function () {
      legacyRenderSubtreeIntoContainer(null, null, container, false, function () {
        // $FlowFixMe This should probably use `delete container._reactRootContainer`
        container._reactRootContainer = null;
        unmarkContainerAsRoot(container);
      });
    }); // If you call unmountComponentAtNode twice in quick succession, you'll
    // get `true` twice. That's probably fine?

    return true;
  } else {
    {
      var _rootEl = getReactRootElementInContainer(container);

      var hasNonRootReactChild = !!(_rootEl && getInstanceFromNode(_rootEl)); // Check if the container itself is a React root node.

      var isContainerReactRoot = container.nodeType === ELEMENT_NODE && isValidContainer(container.parentNode) && !!container.parentNode._reactRootContainer;

      if (hasNonRootReactChild) {
        error("unmountComponentAtNode(): The node you're attempting to unmount " + 'was rendered by React and is not a top-level container. %s', isContainerReactRoot ? 'You may have accidentally passed in a React root node instead ' + 'of its container.' : 'Instead, have the parent component update its state and ' + 'rerender in order to remove this component.');
      }
    }

    return false;
  }
}

setAttemptUserBlockingHydration(attemptUserBlockingHydration$1);
setAttemptContinuousHydration(attemptContinuousHydration$1);
setAttemptHydrationAtCurrentPriority(attemptHydrationAtCurrentPriority$1);
setAttemptHydrationAtPriority(runWithPriority$2);
var didWarnAboutUnstableCreatePortal = false;

{
  if (typeof Map !== 'function' || // $FlowIssue Flow incorrectly thinks Map has no prototype
  Map.prototype == null || typeof Map.prototype.forEach !== 'function' || typeof Set !== 'function' || // $FlowIssue Flow incorrectly thinks Set has no prototype
  Set.prototype == null || typeof Set.prototype.clear !== 'function' || typeof Set.prototype.forEach !== 'function') {
    error('React depends on Map and Set built-in types. Make sure that you load a ' + 'polyfill in older browsers. https://reactjs.org/link/react-polyfills');
  }
}

setRestoreImplementation(restoreControlledState$3);
setBatchingImplementation(batchedUpdates$1, discreteUpdates$1, flushDiscreteUpdates, batchedEventUpdates$1);

function createPortal$1(children, container) {
  var key = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

  if (!isValidContainer(container)) {
    {
      throw Error( "Target container is not a DOM element." );
    }
  } // TODO: pass ReactDOM portal implementation as third argument
  // $FlowFixMe The Flow type is opaque but there's no way to actually create it.


  return createPortal(children, container, null, key);
}

function renderSubtreeIntoContainer(parentComponent, element, containerNode, callback) {

  return unstable_renderSubtreeIntoContainer(parentComponent, element, containerNode, callback);
}

function unstable_createPortal(children, container) {
  var key = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

  {
    if (!didWarnAboutUnstableCreatePortal) {
      didWarnAboutUnstableCreatePortal = true;

      warn('The ReactDOM.unstable_createPortal() alias has been deprecated, ' + 'and will be removed in React 18+. Update your code to use ' + 'ReactDOM.createPortal() instead. It has the exact same API, ' + 'but without the "unstable_" prefix.');
    }
  }

  return createPortal$1(children, container, key);
}

var Internals = {
  // Keep in sync with ReactTestUtils.js, and ReactTestUtilsAct.js.
  // This is an array for better minification.
  Events: [getInstanceFromNode, getNodeFromInstance, getFiberCurrentPropsFromNode, enqueueStateRestore, restoreStateIfNeeded, flushPassiveEffects, // TODO: This is related to `act`, not events. Move to separate key?
  IsThisRendererActing]
};
var foundDevTools = injectIntoDevTools({
  findFiberByHostInstance: getClosestInstanceFromNode,
  bundleType:  1 ,
  version: ReactVersion,
  rendererPackageName: 'react-dom'
});

{
  if (!foundDevTools && canUseDOM && window.top === window.self) {
    // If we're in Chrome or Firefox, provide a download link if not installed.
    if (navigator.userAgent.indexOf('Chrome') > -1 && navigator.userAgent.indexOf('Edge') === -1 || navigator.userAgent.indexOf('Firefox') > -1) {
      var protocol = window.location.protocol; // Don't warn in exotic cases like chrome-extension://.

      if (/^(https?|file):$/.test(protocol)) {
        // eslint-disable-next-line react-internal/no-production-logging
        console.info('%cDownload the React DevTools ' + 'for a better development experience: ' + 'https://reactjs.org/link/react-devtools' + (protocol === 'file:' ? '\nYou might need to use a local HTTP server (instead of file://): ' + 'https://reactjs.org/link/react-devtools-faq' : ''), 'font-weight:bold');
      }
    }
  }
}

exports.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = Internals;
exports.createPortal = createPortal$1;
exports.findDOMNode = findDOMNode;
exports.flushSync = flushSync;
exports.hydrate = hydrate;
exports.render = render;
exports.unmountComponentAtNode = unmountComponentAtNode;
exports.unstable_batchedUpdates = batchedUpdates$1;
exports.unstable_createPortal = unstable_createPortal;
exports.unstable_renderSubtreeIntoContainer = renderSubtreeIntoContainer;
exports.version = ReactVersion;
  })();
}


/***/ }),

/***/ "./node_modules/react-dom/index.js":
/*!*****************************************!*\
  !*** ./node_modules/react-dom/index.js ***!
  \*****************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function checkDCE() {
  /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */
  if (
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' ||
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function'
  ) {
    return;
  }
  if (true) {
    // This branch is unreachable because this function is only called
    // in production, but the condition is true only in development.
    // Therefore if the branch is still here, dead code elimination wasn't
    // properly applied.
    // Don't change the message. React DevTools relies on it. Also make sure
    // this message doesn't occur elsewhere in this function, or it will cause
    // a false positive.
    throw new Error('^_^');
  }
  try {
    // Verify that the code above has been dead code eliminated (DCE'd).
    __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE(checkDCE);
  } catch (err) {
    // DevTools shouldn't crash React, no matter what.
    // We should still report in case we break this code.
    console.error(err);
  }
}

if (false) {} else {
  module.exports = __webpack_require__(/*! ./cjs/react-dom.development.js */ "./node_modules/react-dom/cjs/react-dom.development.js");
}


/***/ }),

/***/ "./node_modules/react/cjs/react.development.js":
/*!*****************************************************!*\
  !*** ./node_modules/react/cjs/react.development.js ***!
  \*****************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v17.0.1
 * react.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



if (true) {
  (function() {
'use strict';

var _assign = __webpack_require__(/*! object-assign */ "./node_modules/object-assign/index.js");

// TODO: this is special because it gets imported during build.
var ReactVersion = '17.0.1';

// ATTENTION
// When adding new symbols to this file,
// Please consider also adding to 'react-devtools-shared/src/backend/ReactSymbols'
// The Symbol used to tag the ReactElement-like types. If there is no native Symbol
// nor polyfill, then a plain number is used for performance.
var REACT_ELEMENT_TYPE = 0xeac7;
var REACT_PORTAL_TYPE = 0xeaca;
exports.Fragment = 0xeacb;
exports.StrictMode = 0xeacc;
exports.Profiler = 0xead2;
var REACT_PROVIDER_TYPE = 0xeacd;
var REACT_CONTEXT_TYPE = 0xeace;
var REACT_FORWARD_REF_TYPE = 0xead0;
exports.Suspense = 0xead1;
var REACT_SUSPENSE_LIST_TYPE = 0xead8;
var REACT_MEMO_TYPE = 0xead3;
var REACT_LAZY_TYPE = 0xead4;
var REACT_BLOCK_TYPE = 0xead9;
var REACT_SERVER_BLOCK_TYPE = 0xeada;
var REACT_FUNDAMENTAL_TYPE = 0xead5;
var REACT_SCOPE_TYPE = 0xead7;
var REACT_OPAQUE_ID_TYPE = 0xeae0;
var REACT_DEBUG_TRACING_MODE_TYPE = 0xeae1;
var REACT_OFFSCREEN_TYPE = 0xeae2;
var REACT_LEGACY_HIDDEN_TYPE = 0xeae3;

if (typeof Symbol === 'function' && Symbol.for) {
  var symbolFor = Symbol.for;
  REACT_ELEMENT_TYPE = symbolFor('react.element');
  REACT_PORTAL_TYPE = symbolFor('react.portal');
  exports.Fragment = symbolFor('react.fragment');
  exports.StrictMode = symbolFor('react.strict_mode');
  exports.Profiler = symbolFor('react.profiler');
  REACT_PROVIDER_TYPE = symbolFor('react.provider');
  REACT_CONTEXT_TYPE = symbolFor('react.context');
  REACT_FORWARD_REF_TYPE = symbolFor('react.forward_ref');
  exports.Suspense = symbolFor('react.suspense');
  REACT_SUSPENSE_LIST_TYPE = symbolFor('react.suspense_list');
  REACT_MEMO_TYPE = symbolFor('react.memo');
  REACT_LAZY_TYPE = symbolFor('react.lazy');
  REACT_BLOCK_TYPE = symbolFor('react.block');
  REACT_SERVER_BLOCK_TYPE = symbolFor('react.server.block');
  REACT_FUNDAMENTAL_TYPE = symbolFor('react.fundamental');
  REACT_SCOPE_TYPE = symbolFor('react.scope');
  REACT_OPAQUE_ID_TYPE = symbolFor('react.opaque.id');
  REACT_DEBUG_TRACING_MODE_TYPE = symbolFor('react.debug_trace_mode');
  REACT_OFFSCREEN_TYPE = symbolFor('react.offscreen');
  REACT_LEGACY_HIDDEN_TYPE = symbolFor('react.legacy_hidden');
}

var MAYBE_ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
var FAUX_ITERATOR_SYMBOL = '@@iterator';
function getIteratorFn(maybeIterable) {
  if (maybeIterable === null || typeof maybeIterable !== 'object') {
    return null;
  }

  var maybeIterator = MAYBE_ITERATOR_SYMBOL && maybeIterable[MAYBE_ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL];

  if (typeof maybeIterator === 'function') {
    return maybeIterator;
  }

  return null;
}

/**
 * Keeps track of the current dispatcher.
 */
var ReactCurrentDispatcher = {
  /**
   * @internal
   * @type {ReactComponent}
   */
  current: null
};

/**
 * Keeps track of the current batch's configuration such as how long an update
 * should suspend for if it needs to.
 */
var ReactCurrentBatchConfig = {
  transition: 0
};

/**
 * Keeps track of the current owner.
 *
 * The current owner is the component who should own any components that are
 * currently being constructed.
 */
var ReactCurrentOwner = {
  /**
   * @internal
   * @type {ReactComponent}
   */
  current: null
};

var ReactDebugCurrentFrame = {};
var currentExtraStackFrame = null;
function setExtraStackFrame(stack) {
  {
    currentExtraStackFrame = stack;
  }
}

{
  ReactDebugCurrentFrame.setExtraStackFrame = function (stack) {
    {
      currentExtraStackFrame = stack;
    }
  }; // Stack implementation injected by the current renderer.


  ReactDebugCurrentFrame.getCurrentStack = null;

  ReactDebugCurrentFrame.getStackAddendum = function () {
    var stack = ''; // Add an extra top frame while an element is being validated

    if (currentExtraStackFrame) {
      stack += currentExtraStackFrame;
    } // Delegate to the injected renderer-specific implementation


    var impl = ReactDebugCurrentFrame.getCurrentStack;

    if (impl) {
      stack += impl() || '';
    }

    return stack;
  };
}

/**
 * Used by act() to track whether you're inside an act() scope.
 */
var IsSomeRendererActing = {
  current: false
};

var ReactSharedInternals = {
  ReactCurrentDispatcher: ReactCurrentDispatcher,
  ReactCurrentBatchConfig: ReactCurrentBatchConfig,
  ReactCurrentOwner: ReactCurrentOwner,
  IsSomeRendererActing: IsSomeRendererActing,
  // Used by renderers to avoid bundling object-assign twice in UMD bundles:
  assign: _assign
};

{
  ReactSharedInternals.ReactDebugCurrentFrame = ReactDebugCurrentFrame;
}

// by calls to these methods by a Babel plugin.
//
// In PROD (or in packages without access to React internals),
// they are left as they are instead.

function warn(format) {
  {
    for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    printWarning('warn', format, args);
  }
}
function error(format) {
  {
    for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
      args[_key2 - 1] = arguments[_key2];
    }

    printWarning('error', format, args);
  }
}

function printWarning(level, format, args) {
  // When changing this logic, you might want to also
  // update consoleWithStackDev.www.js as well.
  {
    var ReactDebugCurrentFrame = ReactSharedInternals.ReactDebugCurrentFrame;
    var stack = ReactDebugCurrentFrame.getStackAddendum();

    if (stack !== '') {
      format += '%s';
      args = args.concat([stack]);
    }

    var argsWithFormat = args.map(function (item) {
      return '' + item;
    }); // Careful: RN currently depends on this prefix

    argsWithFormat.unshift('Warning: ' + format); // We intentionally don't use spread (or .apply) directly because it
    // breaks IE9: https://github.com/facebook/react/issues/13610
    // eslint-disable-next-line react-internal/no-production-logging

    Function.prototype.apply.call(console[level], console, argsWithFormat);
  }
}

var didWarnStateUpdateForUnmountedComponent = {};

function warnNoop(publicInstance, callerName) {
  {
    var _constructor = publicInstance.constructor;
    var componentName = _constructor && (_constructor.displayName || _constructor.name) || 'ReactClass';
    var warningKey = componentName + "." + callerName;

    if (didWarnStateUpdateForUnmountedComponent[warningKey]) {
      return;
    }

    error("Can't call %s on a component that is not yet mounted. " + 'This is a no-op, but it might indicate a bug in your application. ' + 'Instead, assign to `this.state` directly or define a `state = {};` ' + 'class property with the desired state in the %s component.', callerName, componentName);

    didWarnStateUpdateForUnmountedComponent[warningKey] = true;
  }
}
/**
 * This is the abstract API for an update queue.
 */


var ReactNoopUpdateQueue = {
  /**
   * Checks whether or not this composite component is mounted.
   * @param {ReactClass} publicInstance The instance we want to test.
   * @return {boolean} True if mounted, false otherwise.
   * @protected
   * @final
   */
  isMounted: function (publicInstance) {
    return false;
  },

  /**
   * Forces an update. This should only be invoked when it is known with
   * certainty that we are **not** in a DOM transaction.
   *
   * You may want to call this when you know that some deeper aspect of the
   * component's state has changed but `setState` was not called.
   *
   * This will not invoke `shouldComponentUpdate`, but it will invoke
   * `componentWillUpdate` and `componentDidUpdate`.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @param {?function} callback Called after component is updated.
   * @param {?string} callerName name of the calling function in the public API.
   * @internal
   */
  enqueueForceUpdate: function (publicInstance, callback, callerName) {
    warnNoop(publicInstance, 'forceUpdate');
  },

  /**
   * Replaces all of the state. Always use this or `setState` to mutate state.
   * You should treat `this.state` as immutable.
   *
   * There is no guarantee that `this.state` will be immediately updated, so
   * accessing `this.state` after calling this method may return the old value.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @param {object} completeState Next state.
   * @param {?function} callback Called after component is updated.
   * @param {?string} callerName name of the calling function in the public API.
   * @internal
   */
  enqueueReplaceState: function (publicInstance, completeState, callback, callerName) {
    warnNoop(publicInstance, 'replaceState');
  },

  /**
   * Sets a subset of the state. This only exists because _pendingState is
   * internal. This provides a merging strategy that is not available to deep
   * properties which is confusing. TODO: Expose pendingState or don't use it
   * during the merge.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @param {object} partialState Next partial state to be merged with state.
   * @param {?function} callback Called after component is updated.
   * @param {?string} Name of the calling function in the public API.
   * @internal
   */
  enqueueSetState: function (publicInstance, partialState, callback, callerName) {
    warnNoop(publicInstance, 'setState');
  }
};

var emptyObject = {};

{
  Object.freeze(emptyObject);
}
/**
 * Base class helpers for the updating state of a component.
 */


function Component(props, context, updater) {
  this.props = props;
  this.context = context; // If a component has string refs, we will assign a different object later.

  this.refs = emptyObject; // We initialize the default updater but the real one gets injected by the
  // renderer.

  this.updater = updater || ReactNoopUpdateQueue;
}

Component.prototype.isReactComponent = {};
/**
 * Sets a subset of the state. Always use this to mutate
 * state. You should treat `this.state` as immutable.
 *
 * There is no guarantee that `this.state` will be immediately updated, so
 * accessing `this.state` after calling this method may return the old value.
 *
 * There is no guarantee that calls to `setState` will run synchronously,
 * as they may eventually be batched together.  You can provide an optional
 * callback that will be executed when the call to setState is actually
 * completed.
 *
 * When a function is provided to setState, it will be called at some point in
 * the future (not synchronously). It will be called with the up to date
 * component arguments (state, props, context). These values can be different
 * from this.* because your function may be called after receiveProps but before
 * shouldComponentUpdate, and this new state, props, and context will not yet be
 * assigned to this.
 *
 * @param {object|function} partialState Next partial state or function to
 *        produce next partial state to be merged with current state.
 * @param {?function} callback Called after state is updated.
 * @final
 * @protected
 */

Component.prototype.setState = function (partialState, callback) {
  if (!(typeof partialState === 'object' || typeof partialState === 'function' || partialState == null)) {
    {
      throw Error( "setState(...): takes an object of state variables to update or a function which returns an object of state variables." );
    }
  }

  this.updater.enqueueSetState(this, partialState, callback, 'setState');
};
/**
 * Forces an update. This should only be invoked when it is known with
 * certainty that we are **not** in a DOM transaction.
 *
 * You may want to call this when you know that some deeper aspect of the
 * component's state has changed but `setState` was not called.
 *
 * This will not invoke `shouldComponentUpdate`, but it will invoke
 * `componentWillUpdate` and `componentDidUpdate`.
 *
 * @param {?function} callback Called after update is complete.
 * @final
 * @protected
 */


Component.prototype.forceUpdate = function (callback) {
  this.updater.enqueueForceUpdate(this, callback, 'forceUpdate');
};
/**
 * Deprecated APIs. These APIs used to exist on classic React classes but since
 * we would like to deprecate them, we're not going to move them over to this
 * modern base class. Instead, we define a getter that warns if it's accessed.
 */


{
  var deprecatedAPIs = {
    isMounted: ['isMounted', 'Instead, make sure to clean up subscriptions and pending requests in ' + 'componentWillUnmount to prevent memory leaks.'],
    replaceState: ['replaceState', 'Refactor your code to use setState instead (see ' + 'https://github.com/facebook/react/issues/3236).']
  };

  var defineDeprecationWarning = function (methodName, info) {
    Object.defineProperty(Component.prototype, methodName, {
      get: function () {
        warn('%s(...) is deprecated in plain JavaScript React classes. %s', info[0], info[1]);

        return undefined;
      }
    });
  };

  for (var fnName in deprecatedAPIs) {
    if (deprecatedAPIs.hasOwnProperty(fnName)) {
      defineDeprecationWarning(fnName, deprecatedAPIs[fnName]);
    }
  }
}

function ComponentDummy() {}

ComponentDummy.prototype = Component.prototype;
/**
 * Convenience component with default shallow equality check for sCU.
 */

function PureComponent(props, context, updater) {
  this.props = props;
  this.context = context; // If a component has string refs, we will assign a different object later.

  this.refs = emptyObject;
  this.updater = updater || ReactNoopUpdateQueue;
}

var pureComponentPrototype = PureComponent.prototype = new ComponentDummy();
pureComponentPrototype.constructor = PureComponent; // Avoid an extra prototype jump for these methods.

_assign(pureComponentPrototype, Component.prototype);

pureComponentPrototype.isPureReactComponent = true;

// an immutable object with a single mutable value
function createRef() {
  var refObject = {
    current: null
  };

  {
    Object.seal(refObject);
  }

  return refObject;
}

function getWrappedName(outerType, innerType, wrapperName) {
  var functionName = innerType.displayName || innerType.name || '';
  return outerType.displayName || (functionName !== '' ? wrapperName + "(" + functionName + ")" : wrapperName);
}

function getContextName(type) {
  return type.displayName || 'Context';
}

function getComponentName(type) {
  if (type == null) {
    // Host root, text node or just invalid type.
    return null;
  }

  {
    if (typeof type.tag === 'number') {
      error('Received an unexpected object in getComponentName(). ' + 'This is likely a bug in React. Please file an issue.');
    }
  }

  if (typeof type === 'function') {
    return type.displayName || type.name || null;
  }

  if (typeof type === 'string') {
    return type;
  }

  switch (type) {
    case exports.Fragment:
      return 'Fragment';

    case REACT_PORTAL_TYPE:
      return 'Portal';

    case exports.Profiler:
      return 'Profiler';

    case exports.StrictMode:
      return 'StrictMode';

    case exports.Suspense:
      return 'Suspense';

    case REACT_SUSPENSE_LIST_TYPE:
      return 'SuspenseList';
  }

  if (typeof type === 'object') {
    switch (type.$$typeof) {
      case REACT_CONTEXT_TYPE:
        var context = type;
        return getContextName(context) + '.Consumer';

      case REACT_PROVIDER_TYPE:
        var provider = type;
        return getContextName(provider._context) + '.Provider';

      case REACT_FORWARD_REF_TYPE:
        return getWrappedName(type, type.render, 'ForwardRef');

      case REACT_MEMO_TYPE:
        return getComponentName(type.type);

      case REACT_BLOCK_TYPE:
        return getComponentName(type._render);

      case REACT_LAZY_TYPE:
        {
          var lazyComponent = type;
          var payload = lazyComponent._payload;
          var init = lazyComponent._init;

          try {
            return getComponentName(init(payload));
          } catch (x) {
            return null;
          }
        }
    }
  }

  return null;
}

var hasOwnProperty = Object.prototype.hasOwnProperty;
var RESERVED_PROPS = {
  key: true,
  ref: true,
  __self: true,
  __source: true
};
var specialPropKeyWarningShown, specialPropRefWarningShown, didWarnAboutStringRefs;

{
  didWarnAboutStringRefs = {};
}

function hasValidRef(config) {
  {
    if (hasOwnProperty.call(config, 'ref')) {
      var getter = Object.getOwnPropertyDescriptor(config, 'ref').get;

      if (getter && getter.isReactWarning) {
        return false;
      }
    }
  }

  return config.ref !== undefined;
}

function hasValidKey(config) {
  {
    if (hasOwnProperty.call(config, 'key')) {
      var getter = Object.getOwnPropertyDescriptor(config, 'key').get;

      if (getter && getter.isReactWarning) {
        return false;
      }
    }
  }

  return config.key !== undefined;
}

function defineKeyPropWarningGetter(props, displayName) {
  var warnAboutAccessingKey = function () {
    {
      if (!specialPropKeyWarningShown) {
        specialPropKeyWarningShown = true;

        error('%s: `key` is not a prop. Trying to access it will result ' + 'in `undefined` being returned. If you need to access the same ' + 'value within the child component, you should pass it as a different ' + 'prop. (https://reactjs.org/link/special-props)', displayName);
      }
    }
  };

  warnAboutAccessingKey.isReactWarning = true;
  Object.defineProperty(props, 'key', {
    get: warnAboutAccessingKey,
    configurable: true
  });
}

function defineRefPropWarningGetter(props, displayName) {
  var warnAboutAccessingRef = function () {
    {
      if (!specialPropRefWarningShown) {
        specialPropRefWarningShown = true;

        error('%s: `ref` is not a prop. Trying to access it will result ' + 'in `undefined` being returned. If you need to access the same ' + 'value within the child component, you should pass it as a different ' + 'prop. (https://reactjs.org/link/special-props)', displayName);
      }
    }
  };

  warnAboutAccessingRef.isReactWarning = true;
  Object.defineProperty(props, 'ref', {
    get: warnAboutAccessingRef,
    configurable: true
  });
}

function warnIfStringRefCannotBeAutoConverted(config) {
  {
    if (typeof config.ref === 'string' && ReactCurrentOwner.current && config.__self && ReactCurrentOwner.current.stateNode !== config.__self) {
      var componentName = getComponentName(ReactCurrentOwner.current.type);

      if (!didWarnAboutStringRefs[componentName]) {
        error('Component "%s" contains the string ref "%s". ' + 'Support for string refs will be removed in a future major release. ' + 'This case cannot be automatically converted to an arrow function. ' + 'We ask you to manually fix this case by using useRef() or createRef() instead. ' + 'Learn more about using refs safely here: ' + 'https://reactjs.org/link/strict-mode-string-ref', componentName, config.ref);

        didWarnAboutStringRefs[componentName] = true;
      }
    }
  }
}
/**
 * Factory method to create a new React element. This no longer adheres to
 * the class pattern, so do not use new to call it. Also, instanceof check
 * will not work. Instead test $$typeof field against Symbol.for('react.element') to check
 * if something is a React Element.
 *
 * @param {*} type
 * @param {*} props
 * @param {*} key
 * @param {string|object} ref
 * @param {*} owner
 * @param {*} self A *temporary* helper to detect places where `this` is
 * different from the `owner` when React.createElement is called, so that we
 * can warn. We want to get rid of owner and replace string `ref`s with arrow
 * functions, and as long as `this` and owner are the same, there will be no
 * change in behavior.
 * @param {*} source An annotation object (added by a transpiler or otherwise)
 * indicating filename, line number, and/or other information.
 * @internal
 */


var ReactElement = function (type, key, ref, self, source, owner, props) {
  var element = {
    // This tag allows us to uniquely identify this as a React Element
    $$typeof: REACT_ELEMENT_TYPE,
    // Built-in properties that belong on the element
    type: type,
    key: key,
    ref: ref,
    props: props,
    // Record the component responsible for creating this element.
    _owner: owner
  };

  {
    // The validation flag is currently mutative. We put it on
    // an external backing store so that we can freeze the whole object.
    // This can be replaced with a WeakMap once they are implemented in
    // commonly used development environments.
    element._store = {}; // To make comparing ReactElements easier for testing purposes, we make
    // the validation flag non-enumerable (where possible, which should
    // include every environment we run tests in), so the test framework
    // ignores it.

    Object.defineProperty(element._store, 'validated', {
      configurable: false,
      enumerable: false,
      writable: true,
      value: false
    }); // self and source are DEV only properties.

    Object.defineProperty(element, '_self', {
      configurable: false,
      enumerable: false,
      writable: false,
      value: self
    }); // Two elements created in two different places should be considered
    // equal for testing purposes and therefore we hide it from enumeration.

    Object.defineProperty(element, '_source', {
      configurable: false,
      enumerable: false,
      writable: false,
      value: source
    });

    if (Object.freeze) {
      Object.freeze(element.props);
      Object.freeze(element);
    }
  }

  return element;
};
/**
 * Create and return a new ReactElement of the given type.
 * See https://reactjs.org/docs/react-api.html#createelement
 */

function createElement(type, config, children) {
  var propName; // Reserved names are extracted

  var props = {};
  var key = null;
  var ref = null;
  var self = null;
  var source = null;

  if (config != null) {
    if (hasValidRef(config)) {
      ref = config.ref;

      {
        warnIfStringRefCannotBeAutoConverted(config);
      }
    }

    if (hasValidKey(config)) {
      key = '' + config.key;
    }

    self = config.__self === undefined ? null : config.__self;
    source = config.__source === undefined ? null : config.__source; // Remaining properties are added to a new props object

    for (propName in config) {
      if (hasOwnProperty.call(config, propName) && !RESERVED_PROPS.hasOwnProperty(propName)) {
        props[propName] = config[propName];
      }
    }
  } // Children can be more than one argument, and those are transferred onto
  // the newly allocated props object.


  var childrenLength = arguments.length - 2;

  if (childrenLength === 1) {
    props.children = children;
  } else if (childrenLength > 1) {
    var childArray = Array(childrenLength);

    for (var i = 0; i < childrenLength; i++) {
      childArray[i] = arguments[i + 2];
    }

    {
      if (Object.freeze) {
        Object.freeze(childArray);
      }
    }

    props.children = childArray;
  } // Resolve default props


  if (type && type.defaultProps) {
    var defaultProps = type.defaultProps;

    for (propName in defaultProps) {
      if (props[propName] === undefined) {
        props[propName] = defaultProps[propName];
      }
    }
  }

  {
    if (key || ref) {
      var displayName = typeof type === 'function' ? type.displayName || type.name || 'Unknown' : type;

      if (key) {
        defineKeyPropWarningGetter(props, displayName);
      }

      if (ref) {
        defineRefPropWarningGetter(props, displayName);
      }
    }
  }

  return ReactElement(type, key, ref, self, source, ReactCurrentOwner.current, props);
}
function cloneAndReplaceKey(oldElement, newKey) {
  var newElement = ReactElement(oldElement.type, newKey, oldElement.ref, oldElement._self, oldElement._source, oldElement._owner, oldElement.props);
  return newElement;
}
/**
 * Clone and return a new ReactElement using element as the starting point.
 * See https://reactjs.org/docs/react-api.html#cloneelement
 */

function cloneElement(element, config, children) {
  if (!!(element === null || element === undefined)) {
    {
      throw Error( "React.cloneElement(...): The argument must be a React element, but you passed " + element + "." );
    }
  }

  var propName; // Original props are copied

  var props = _assign({}, element.props); // Reserved names are extracted


  var key = element.key;
  var ref = element.ref; // Self is preserved since the owner is preserved.

  var self = element._self; // Source is preserved since cloneElement is unlikely to be targeted by a
  // transpiler, and the original source is probably a better indicator of the
  // true owner.

  var source = element._source; // Owner will be preserved, unless ref is overridden

  var owner = element._owner;

  if (config != null) {
    if (hasValidRef(config)) {
      // Silently steal the ref from the parent.
      ref = config.ref;
      owner = ReactCurrentOwner.current;
    }

    if (hasValidKey(config)) {
      key = '' + config.key;
    } // Remaining properties override existing props


    var defaultProps;

    if (element.type && element.type.defaultProps) {
      defaultProps = element.type.defaultProps;
    }

    for (propName in config) {
      if (hasOwnProperty.call(config, propName) && !RESERVED_PROPS.hasOwnProperty(propName)) {
        if (config[propName] === undefined && defaultProps !== undefined) {
          // Resolve default props
          props[propName] = defaultProps[propName];
        } else {
          props[propName] = config[propName];
        }
      }
    }
  } // Children can be more than one argument, and those are transferred onto
  // the newly allocated props object.


  var childrenLength = arguments.length - 2;

  if (childrenLength === 1) {
    props.children = children;
  } else if (childrenLength > 1) {
    var childArray = Array(childrenLength);

    for (var i = 0; i < childrenLength; i++) {
      childArray[i] = arguments[i + 2];
    }

    props.children = childArray;
  }

  return ReactElement(element.type, key, ref, self, source, owner, props);
}
/**
 * Verifies the object is a ReactElement.
 * See https://reactjs.org/docs/react-api.html#isvalidelement
 * @param {?object} object
 * @return {boolean} True if `object` is a ReactElement.
 * @final
 */

function isValidElement(object) {
  return typeof object === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
}

var SEPARATOR = '.';
var SUBSEPARATOR = ':';
/**
 * Escape and wrap key so it is safe to use as a reactid
 *
 * @param {string} key to be escaped.
 * @return {string} the escaped key.
 */

function escape(key) {
  var escapeRegex = /[=:]/g;
  var escaperLookup = {
    '=': '=0',
    ':': '=2'
  };
  var escapedString = key.replace(escapeRegex, function (match) {
    return escaperLookup[match];
  });
  return '$' + escapedString;
}
/**
 * TODO: Test that a single child and an array with one item have the same key
 * pattern.
 */


var didWarnAboutMaps = false;
var userProvidedKeyEscapeRegex = /\/+/g;

function escapeUserProvidedKey(text) {
  return text.replace(userProvidedKeyEscapeRegex, '$&/');
}
/**
 * Generate a key string that identifies a element within a set.
 *
 * @param {*} element A element that could contain a manual key.
 * @param {number} index Index that is used if a manual key is not provided.
 * @return {string}
 */


function getElementKey(element, index) {
  // Do some typechecking here since we call this blindly. We want to ensure
  // that we don't block potential future ES APIs.
  if (typeof element === 'object' && element !== null && element.key != null) {
    // Explicit key
    return escape('' + element.key);
  } // Implicit key determined by the index in the set


  return index.toString(36);
}

function mapIntoArray(children, array, escapedPrefix, nameSoFar, callback) {
  var type = typeof children;

  if (type === 'undefined' || type === 'boolean') {
    // All of the above are perceived as null.
    children = null;
  }

  var invokeCallback = false;

  if (children === null) {
    invokeCallback = true;
  } else {
    switch (type) {
      case 'string':
      case 'number':
        invokeCallback = true;
        break;

      case 'object':
        switch (children.$$typeof) {
          case REACT_ELEMENT_TYPE:
          case REACT_PORTAL_TYPE:
            invokeCallback = true;
        }

    }
  }

  if (invokeCallback) {
    var _child = children;
    var mappedChild = callback(_child); // If it's the only child, treat the name as if it was wrapped in an array
    // so that it's consistent if the number of children grows:

    var childKey = nameSoFar === '' ? SEPARATOR + getElementKey(_child, 0) : nameSoFar;

    if (Array.isArray(mappedChild)) {
      var escapedChildKey = '';

      if (childKey != null) {
        escapedChildKey = escapeUserProvidedKey(childKey) + '/';
      }

      mapIntoArray(mappedChild, array, escapedChildKey, '', function (c) {
        return c;
      });
    } else if (mappedChild != null) {
      if (isValidElement(mappedChild)) {
        mappedChild = cloneAndReplaceKey(mappedChild, // Keep both the (mapped) and old keys if they differ, just as
        // traverseAllChildren used to do for objects as children
        escapedPrefix + ( // $FlowFixMe Flow incorrectly thinks React.Portal doesn't have a key
        mappedChild.key && (!_child || _child.key !== mappedChild.key) ? // $FlowFixMe Flow incorrectly thinks existing element's key can be a number
        escapeUserProvidedKey('' + mappedChild.key) + '/' : '') + childKey);
      }

      array.push(mappedChild);
    }

    return 1;
  }

  var child;
  var nextName;
  var subtreeCount = 0; // Count of children found in the current subtree.

  var nextNamePrefix = nameSoFar === '' ? SEPARATOR : nameSoFar + SUBSEPARATOR;

  if (Array.isArray(children)) {
    for (var i = 0; i < children.length; i++) {
      child = children[i];
      nextName = nextNamePrefix + getElementKey(child, i);
      subtreeCount += mapIntoArray(child, array, escapedPrefix, nextName, callback);
    }
  } else {
    var iteratorFn = getIteratorFn(children);

    if (typeof iteratorFn === 'function') {
      var iterableChildren = children;

      {
        // Warn about using Maps as children
        if (iteratorFn === iterableChildren.entries) {
          if (!didWarnAboutMaps) {
            warn('Using Maps as children is not supported. ' + 'Use an array of keyed ReactElements instead.');
          }

          didWarnAboutMaps = true;
        }
      }

      var iterator = iteratorFn.call(iterableChildren);
      var step;
      var ii = 0;

      while (!(step = iterator.next()).done) {
        child = step.value;
        nextName = nextNamePrefix + getElementKey(child, ii++);
        subtreeCount += mapIntoArray(child, array, escapedPrefix, nextName, callback);
      }
    } else if (type === 'object') {
      var childrenString = '' + children;

      {
        {
          throw Error( "Objects are not valid as a React child (found: " + (childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString) + "). If you meant to render a collection of children, use an array instead." );
        }
      }
    }
  }

  return subtreeCount;
}

/**
 * Maps children that are typically specified as `props.children`.
 *
 * See https://reactjs.org/docs/react-api.html#reactchildrenmap
 *
 * The provided mapFunction(child, index) will be called for each
 * leaf child.
 *
 * @param {?*} children Children tree container.
 * @param {function(*, int)} func The map function.
 * @param {*} context Context for mapFunction.
 * @return {object} Object containing the ordered map of results.
 */
function mapChildren(children, func, context) {
  if (children == null) {
    return children;
  }

  var result = [];
  var count = 0;
  mapIntoArray(children, result, '', '', function (child) {
    return func.call(context, child, count++);
  });
  return result;
}
/**
 * Count the number of children that are typically specified as
 * `props.children`.
 *
 * See https://reactjs.org/docs/react-api.html#reactchildrencount
 *
 * @param {?*} children Children tree container.
 * @return {number} The number of children.
 */


function countChildren(children) {
  var n = 0;
  mapChildren(children, function () {
    n++; // Don't return anything
  });
  return n;
}

/**
 * Iterates through children that are typically specified as `props.children`.
 *
 * See https://reactjs.org/docs/react-api.html#reactchildrenforeach
 *
 * The provided forEachFunc(child, index) will be called for each
 * leaf child.
 *
 * @param {?*} children Children tree container.
 * @param {function(*, int)} forEachFunc
 * @param {*} forEachContext Context for forEachContext.
 */
function forEachChildren(children, forEachFunc, forEachContext) {
  mapChildren(children, function () {
    forEachFunc.apply(this, arguments); // Don't return anything.
  }, forEachContext);
}
/**
 * Flatten a children object (typically specified as `props.children`) and
 * return an array with appropriately re-keyed children.
 *
 * See https://reactjs.org/docs/react-api.html#reactchildrentoarray
 */


function toArray(children) {
  return mapChildren(children, function (child) {
    return child;
  }) || [];
}
/**
 * Returns the first child in a collection of children and verifies that there
 * is only one child in the collection.
 *
 * See https://reactjs.org/docs/react-api.html#reactchildrenonly
 *
 * The current implementation of this function assumes that a single child gets
 * passed without a wrapper, but the purpose of this helper function is to
 * abstract away the particular structure of children.
 *
 * @param {?object} children Child collection structure.
 * @return {ReactElement} The first and only `ReactElement` contained in the
 * structure.
 */


function onlyChild(children) {
  if (!isValidElement(children)) {
    {
      throw Error( "React.Children.only expected to receive a single React element child." );
    }
  }

  return children;
}

function createContext(defaultValue, calculateChangedBits) {
  if (calculateChangedBits === undefined) {
    calculateChangedBits = null;
  } else {
    {
      if (calculateChangedBits !== null && typeof calculateChangedBits !== 'function') {
        error('createContext: Expected the optional second argument to be a ' + 'function. Instead received: %s', calculateChangedBits);
      }
    }
  }

  var context = {
    $$typeof: REACT_CONTEXT_TYPE,
    _calculateChangedBits: calculateChangedBits,
    // As a workaround to support multiple concurrent renderers, we categorize
    // some renderers as primary and others as secondary. We only expect
    // there to be two concurrent renderers at most: React Native (primary) and
    // Fabric (secondary); React DOM (primary) and React ART (secondary).
    // Secondary renderers store their context values on separate fields.
    _currentValue: defaultValue,
    _currentValue2: defaultValue,
    // Used to track how many concurrent renderers this context currently
    // supports within in a single renderer. Such as parallel server rendering.
    _threadCount: 0,
    // These are circular
    Provider: null,
    Consumer: null
  };
  context.Provider = {
    $$typeof: REACT_PROVIDER_TYPE,
    _context: context
  };
  var hasWarnedAboutUsingNestedContextConsumers = false;
  var hasWarnedAboutUsingConsumerProvider = false;
  var hasWarnedAboutDisplayNameOnConsumer = false;

  {
    // A separate object, but proxies back to the original context object for
    // backwards compatibility. It has a different $$typeof, so we can properly
    // warn for the incorrect usage of Context as a Consumer.
    var Consumer = {
      $$typeof: REACT_CONTEXT_TYPE,
      _context: context,
      _calculateChangedBits: context._calculateChangedBits
    }; // $FlowFixMe: Flow complains about not setting a value, which is intentional here

    Object.defineProperties(Consumer, {
      Provider: {
        get: function () {
          if (!hasWarnedAboutUsingConsumerProvider) {
            hasWarnedAboutUsingConsumerProvider = true;

            error('Rendering <Context.Consumer.Provider> is not supported and will be removed in ' + 'a future major release. Did you mean to render <Context.Provider> instead?');
          }

          return context.Provider;
        },
        set: function (_Provider) {
          context.Provider = _Provider;
        }
      },
      _currentValue: {
        get: function () {
          return context._currentValue;
        },
        set: function (_currentValue) {
          context._currentValue = _currentValue;
        }
      },
      _currentValue2: {
        get: function () {
          return context._currentValue2;
        },
        set: function (_currentValue2) {
          context._currentValue2 = _currentValue2;
        }
      },
      _threadCount: {
        get: function () {
          return context._threadCount;
        },
        set: function (_threadCount) {
          context._threadCount = _threadCount;
        }
      },
      Consumer: {
        get: function () {
          if (!hasWarnedAboutUsingNestedContextConsumers) {
            hasWarnedAboutUsingNestedContextConsumers = true;

            error('Rendering <Context.Consumer.Consumer> is not supported and will be removed in ' + 'a future major release. Did you mean to render <Context.Consumer> instead?');
          }

          return context.Consumer;
        }
      },
      displayName: {
        get: function () {
          return context.displayName;
        },
        set: function (displayName) {
          if (!hasWarnedAboutDisplayNameOnConsumer) {
            warn('Setting `displayName` on Context.Consumer has no effect. ' + "You should set it directly on the context with Context.displayName = '%s'.", displayName);

            hasWarnedAboutDisplayNameOnConsumer = true;
          }
        }
      }
    }); // $FlowFixMe: Flow complains about missing properties because it doesn't understand defineProperty

    context.Consumer = Consumer;
  }

  {
    context._currentRenderer = null;
    context._currentRenderer2 = null;
  }

  return context;
}

var Uninitialized = -1;
var Pending = 0;
var Resolved = 1;
var Rejected = 2;

function lazyInitializer(payload) {
  if (payload._status === Uninitialized) {
    var ctor = payload._result;
    var thenable = ctor(); // Transition to the next state.

    var pending = payload;
    pending._status = Pending;
    pending._result = thenable;
    thenable.then(function (moduleObject) {
      if (payload._status === Pending) {
        var defaultExport = moduleObject.default;

        {
          if (defaultExport === undefined) {
            error('lazy: Expected the result of a dynamic import() call. ' + 'Instead received: %s\n\nYour code should look like: \n  ' + // Break up imports to avoid accidentally parsing them as dependencies.
            'const MyComponent = lazy(() => imp' + "ort('./MyComponent'))", moduleObject);
          }
        } // Transition to the next state.


        var resolved = payload;
        resolved._status = Resolved;
        resolved._result = defaultExport;
      }
    }, function (error) {
      if (payload._status === Pending) {
        // Transition to the next state.
        var rejected = payload;
        rejected._status = Rejected;
        rejected._result = error;
      }
    });
  }

  if (payload._status === Resolved) {
    return payload._result;
  } else {
    throw payload._result;
  }
}

function lazy(ctor) {
  var payload = {
    // We use these fields to store the result.
    _status: -1,
    _result: ctor
  };
  var lazyType = {
    $$typeof: REACT_LAZY_TYPE,
    _payload: payload,
    _init: lazyInitializer
  };

  {
    // In production, this would just set it on the object.
    var defaultProps;
    var propTypes; // $FlowFixMe

    Object.defineProperties(lazyType, {
      defaultProps: {
        configurable: true,
        get: function () {
          return defaultProps;
        },
        set: function (newDefaultProps) {
          error('React.lazy(...): It is not supported to assign `defaultProps` to ' + 'a lazy component import. Either specify them where the component ' + 'is defined, or create a wrapping component around it.');

          defaultProps = newDefaultProps; // Match production behavior more closely:
          // $FlowFixMe

          Object.defineProperty(lazyType, 'defaultProps', {
            enumerable: true
          });
        }
      },
      propTypes: {
        configurable: true,
        get: function () {
          return propTypes;
        },
        set: function (newPropTypes) {
          error('React.lazy(...): It is not supported to assign `propTypes` to ' + 'a lazy component import. Either specify them where the component ' + 'is defined, or create a wrapping component around it.');

          propTypes = newPropTypes; // Match production behavior more closely:
          // $FlowFixMe

          Object.defineProperty(lazyType, 'propTypes', {
            enumerable: true
          });
        }
      }
    });
  }

  return lazyType;
}

function forwardRef(render) {
  {
    if (render != null && render.$$typeof === REACT_MEMO_TYPE) {
      error('forwardRef requires a render function but received a `memo` ' + 'component. Instead of forwardRef(memo(...)), use ' + 'memo(forwardRef(...)).');
    } else if (typeof render !== 'function') {
      error('forwardRef requires a render function but was given %s.', render === null ? 'null' : typeof render);
    } else {
      if (render.length !== 0 && render.length !== 2) {
        error('forwardRef render functions accept exactly two parameters: props and ref. %s', render.length === 1 ? 'Did you forget to use the ref parameter?' : 'Any additional parameter will be undefined.');
      }
    }

    if (render != null) {
      if (render.defaultProps != null || render.propTypes != null) {
        error('forwardRef render functions do not support propTypes or defaultProps. ' + 'Did you accidentally pass a React component?');
      }
    }
  }

  var elementType = {
    $$typeof: REACT_FORWARD_REF_TYPE,
    render: render
  };

  {
    var ownName;
    Object.defineProperty(elementType, 'displayName', {
      enumerable: false,
      configurable: true,
      get: function () {
        return ownName;
      },
      set: function (name) {
        ownName = name;

        if (render.displayName == null) {
          render.displayName = name;
        }
      }
    });
  }

  return elementType;
}

// Filter certain DOM attributes (e.g. src, href) if their values are empty strings.

var enableScopeAPI = false; // Experimental Create Event Handle API.

function isValidElementType(type) {
  if (typeof type === 'string' || typeof type === 'function') {
    return true;
  } // Note: typeof might be other than 'symbol' or 'number' (e.g. if it's a polyfill).


  if (type === exports.Fragment || type === exports.Profiler || type === REACT_DEBUG_TRACING_MODE_TYPE || type === exports.StrictMode || type === exports.Suspense || type === REACT_SUSPENSE_LIST_TYPE || type === REACT_LEGACY_HIDDEN_TYPE || enableScopeAPI ) {
    return true;
  }

  if (typeof type === 'object' && type !== null) {
    if (type.$$typeof === REACT_LAZY_TYPE || type.$$typeof === REACT_MEMO_TYPE || type.$$typeof === REACT_PROVIDER_TYPE || type.$$typeof === REACT_CONTEXT_TYPE || type.$$typeof === REACT_FORWARD_REF_TYPE || type.$$typeof === REACT_FUNDAMENTAL_TYPE || type.$$typeof === REACT_BLOCK_TYPE || type[0] === REACT_SERVER_BLOCK_TYPE) {
      return true;
    }
  }

  return false;
}

function memo(type, compare) {
  {
    if (!isValidElementType(type)) {
      error('memo: The first argument must be a component. Instead ' + 'received: %s', type === null ? 'null' : typeof type);
    }
  }

  var elementType = {
    $$typeof: REACT_MEMO_TYPE,
    type: type,
    compare: compare === undefined ? null : compare
  };

  {
    var ownName;
    Object.defineProperty(elementType, 'displayName', {
      enumerable: false,
      configurable: true,
      get: function () {
        return ownName;
      },
      set: function (name) {
        ownName = name;

        if (type.displayName == null) {
          type.displayName = name;
        }
      }
    });
  }

  return elementType;
}

function resolveDispatcher() {
  var dispatcher = ReactCurrentDispatcher.current;

  if (!(dispatcher !== null)) {
    {
      throw Error( "Invalid hook call. Hooks can only be called inside of the body of a function component. This could happen for one of the following reasons:\n1. You might have mismatching versions of React and the renderer (such as React DOM)\n2. You might be breaking the Rules of Hooks\n3. You might have more than one copy of React in the same app\nSee https://reactjs.org/link/invalid-hook-call for tips about how to debug and fix this problem." );
    }
  }

  return dispatcher;
}

function useContext(Context, unstable_observedBits) {
  var dispatcher = resolveDispatcher();

  {
    if (unstable_observedBits !== undefined) {
      error('useContext() second argument is reserved for future ' + 'use in React. Passing it is not supported. ' + 'You passed: %s.%s', unstable_observedBits, typeof unstable_observedBits === 'number' && Array.isArray(arguments[2]) ? '\n\nDid you call array.map(useContext)? ' + 'Calling Hooks inside a loop is not supported. ' + 'Learn more at https://reactjs.org/link/rules-of-hooks' : '');
    } // TODO: add a more generic warning for invalid values.


    if (Context._context !== undefined) {
      var realContext = Context._context; // Don't deduplicate because this legitimately causes bugs
      // and nobody should be using this in existing code.

      if (realContext.Consumer === Context) {
        error('Calling useContext(Context.Consumer) is not supported, may cause bugs, and will be ' + 'removed in a future major release. Did you mean to call useContext(Context) instead?');
      } else if (realContext.Provider === Context) {
        error('Calling useContext(Context.Provider) is not supported. ' + 'Did you mean to call useContext(Context) instead?');
      }
    }
  }

  return dispatcher.useContext(Context, unstable_observedBits);
}
function useState(initialState) {
  var dispatcher = resolveDispatcher();
  return dispatcher.useState(initialState);
}
function useReducer(reducer, initialArg, init) {
  var dispatcher = resolveDispatcher();
  return dispatcher.useReducer(reducer, initialArg, init);
}
function useRef(initialValue) {
  var dispatcher = resolveDispatcher();
  return dispatcher.useRef(initialValue);
}
function useEffect(create, deps) {
  var dispatcher = resolveDispatcher();
  return dispatcher.useEffect(create, deps);
}
function useLayoutEffect(create, deps) {
  var dispatcher = resolveDispatcher();
  return dispatcher.useLayoutEffect(create, deps);
}
function useCallback(callback, deps) {
  var dispatcher = resolveDispatcher();
  return dispatcher.useCallback(callback, deps);
}
function useMemo(create, deps) {
  var dispatcher = resolveDispatcher();
  return dispatcher.useMemo(create, deps);
}
function useImperativeHandle(ref, create, deps) {
  var dispatcher = resolveDispatcher();
  return dispatcher.useImperativeHandle(ref, create, deps);
}
function useDebugValue(value, formatterFn) {
  {
    var dispatcher = resolveDispatcher();
    return dispatcher.useDebugValue(value, formatterFn);
  }
}

// Helpers to patch console.logs to avoid logging during side-effect free
// replaying on render function. This currently only patches the object
// lazily which won't cover if the log function was extracted eagerly.
// We could also eagerly patch the method.
var disabledDepth = 0;
var prevLog;
var prevInfo;
var prevWarn;
var prevError;
var prevGroup;
var prevGroupCollapsed;
var prevGroupEnd;

function disabledLog() {}

disabledLog.__reactDisabledLog = true;
function disableLogs() {
  {
    if (disabledDepth === 0) {
      /* eslint-disable react-internal/no-production-logging */
      prevLog = console.log;
      prevInfo = console.info;
      prevWarn = console.warn;
      prevError = console.error;
      prevGroup = console.group;
      prevGroupCollapsed = console.groupCollapsed;
      prevGroupEnd = console.groupEnd; // https://github.com/facebook/react/issues/19099

      var props = {
        configurable: true,
        enumerable: true,
        value: disabledLog,
        writable: true
      }; // $FlowFixMe Flow thinks console is immutable.

      Object.defineProperties(console, {
        info: props,
        log: props,
        warn: props,
        error: props,
        group: props,
        groupCollapsed: props,
        groupEnd: props
      });
      /* eslint-enable react-internal/no-production-logging */
    }

    disabledDepth++;
  }
}
function reenableLogs() {
  {
    disabledDepth--;

    if (disabledDepth === 0) {
      /* eslint-disable react-internal/no-production-logging */
      var props = {
        configurable: true,
        enumerable: true,
        writable: true
      }; // $FlowFixMe Flow thinks console is immutable.

      Object.defineProperties(console, {
        log: _assign({}, props, {
          value: prevLog
        }),
        info: _assign({}, props, {
          value: prevInfo
        }),
        warn: _assign({}, props, {
          value: prevWarn
        }),
        error: _assign({}, props, {
          value: prevError
        }),
        group: _assign({}, props, {
          value: prevGroup
        }),
        groupCollapsed: _assign({}, props, {
          value: prevGroupCollapsed
        }),
        groupEnd: _assign({}, props, {
          value: prevGroupEnd
        })
      });
      /* eslint-enable react-internal/no-production-logging */
    }

    if (disabledDepth < 0) {
      error('disabledDepth fell below zero. ' + 'This is a bug in React. Please file an issue.');
    }
  }
}

var ReactCurrentDispatcher$1 = ReactSharedInternals.ReactCurrentDispatcher;
var prefix;
function describeBuiltInComponentFrame(name, source, ownerFn) {
  {
    if (prefix === undefined) {
      // Extract the VM specific prefix used by each line.
      try {
        throw Error();
      } catch (x) {
        var match = x.stack.trim().match(/\n( *(at )?)/);
        prefix = match && match[1] || '';
      }
    } // We use the prefix to ensure our stacks line up with native stack frames.


    return '\n' + prefix + name;
  }
}
var reentry = false;
var componentFrameCache;

{
  var PossiblyWeakMap = typeof WeakMap === 'function' ? WeakMap : Map;
  componentFrameCache = new PossiblyWeakMap();
}

function describeNativeComponentFrame(fn, construct) {
  // If something asked for a stack inside a fake render, it should get ignored.
  if (!fn || reentry) {
    return '';
  }

  {
    var frame = componentFrameCache.get(fn);

    if (frame !== undefined) {
      return frame;
    }
  }

  var control;
  reentry = true;
  var previousPrepareStackTrace = Error.prepareStackTrace; // $FlowFixMe It does accept undefined.

  Error.prepareStackTrace = undefined;
  var previousDispatcher;

  {
    previousDispatcher = ReactCurrentDispatcher$1.current; // Set the dispatcher in DEV because this might be call in the render function
    // for warnings.

    ReactCurrentDispatcher$1.current = null;
    disableLogs();
  }

  try {
    // This should throw.
    if (construct) {
      // Something should be setting the props in the constructor.
      var Fake = function () {
        throw Error();
      }; // $FlowFixMe


      Object.defineProperty(Fake.prototype, 'props', {
        set: function () {
          // We use a throwing setter instead of frozen or non-writable props
          // because that won't throw in a non-strict mode function.
          throw Error();
        }
      });

      if (typeof Reflect === 'object' && Reflect.construct) {
        // We construct a different control for this case to include any extra
        // frames added by the construct call.
        try {
          Reflect.construct(Fake, []);
        } catch (x) {
          control = x;
        }

        Reflect.construct(fn, [], Fake);
      } else {
        try {
          Fake.call();
        } catch (x) {
          control = x;
        }

        fn.call(Fake.prototype);
      }
    } else {
      try {
        throw Error();
      } catch (x) {
        control = x;
      }

      fn();
    }
  } catch (sample) {
    // This is inlined manually because closure doesn't do it for us.
    if (sample && control && typeof sample.stack === 'string') {
      // This extracts the first frame from the sample that isn't also in the control.
      // Skipping one frame that we assume is the frame that calls the two.
      var sampleLines = sample.stack.split('\n');
      var controlLines = control.stack.split('\n');
      var s = sampleLines.length - 1;
      var c = controlLines.length - 1;

      while (s >= 1 && c >= 0 && sampleLines[s] !== controlLines[c]) {
        // We expect at least one stack frame to be shared.
        // Typically this will be the root most one. However, stack frames may be
        // cut off due to maximum stack limits. In this case, one maybe cut off
        // earlier than the other. We assume that the sample is longer or the same
        // and there for cut off earlier. So we should find the root most frame in
        // the sample somewhere in the control.
        c--;
      }

      for (; s >= 1 && c >= 0; s--, c--) {
        // Next we find the first one that isn't the same which should be the
        // frame that called our sample function and the control.
        if (sampleLines[s] !== controlLines[c]) {
          // In V8, the first line is describing the message but other VMs don't.
          // If we're about to return the first line, and the control is also on the same
          // line, that's a pretty good indicator that our sample threw at same line as
          // the control. I.e. before we entered the sample frame. So we ignore this result.
          // This can happen if you passed a class to function component, or non-function.
          if (s !== 1 || c !== 1) {
            do {
              s--;
              c--; // We may still have similar intermediate frames from the construct call.
              // The next one that isn't the same should be our match though.

              if (c < 0 || sampleLines[s] !== controlLines[c]) {
                // V8 adds a "new" prefix for native classes. Let's remove it to make it prettier.
                var _frame = '\n' + sampleLines[s].replace(' at new ', ' at ');

                {
                  if (typeof fn === 'function') {
                    componentFrameCache.set(fn, _frame);
                  }
                } // Return the line we found.


                return _frame;
              }
            } while (s >= 1 && c >= 0);
          }

          break;
        }
      }
    }
  } finally {
    reentry = false;

    {
      ReactCurrentDispatcher$1.current = previousDispatcher;
      reenableLogs();
    }

    Error.prepareStackTrace = previousPrepareStackTrace;
  } // Fallback to just using the name if we couldn't make it throw.


  var name = fn ? fn.displayName || fn.name : '';
  var syntheticFrame = name ? describeBuiltInComponentFrame(name) : '';

  {
    if (typeof fn === 'function') {
      componentFrameCache.set(fn, syntheticFrame);
    }
  }

  return syntheticFrame;
}
function describeFunctionComponentFrame(fn, source, ownerFn) {
  {
    return describeNativeComponentFrame(fn, false);
  }
}

function shouldConstruct(Component) {
  var prototype = Component.prototype;
  return !!(prototype && prototype.isReactComponent);
}

function describeUnknownElementTypeFrameInDEV(type, source, ownerFn) {

  if (type == null) {
    return '';
  }

  if (typeof type === 'function') {
    {
      return describeNativeComponentFrame(type, shouldConstruct(type));
    }
  }

  if (typeof type === 'string') {
    return describeBuiltInComponentFrame(type);
  }

  switch (type) {
    case exports.Suspense:
      return describeBuiltInComponentFrame('Suspense');

    case REACT_SUSPENSE_LIST_TYPE:
      return describeBuiltInComponentFrame('SuspenseList');
  }

  if (typeof type === 'object') {
    switch (type.$$typeof) {
      case REACT_FORWARD_REF_TYPE:
        return describeFunctionComponentFrame(type.render);

      case REACT_MEMO_TYPE:
        // Memo may contain any component type so we recursively resolve it.
        return describeUnknownElementTypeFrameInDEV(type.type, source, ownerFn);

      case REACT_BLOCK_TYPE:
        return describeFunctionComponentFrame(type._render);

      case REACT_LAZY_TYPE:
        {
          var lazyComponent = type;
          var payload = lazyComponent._payload;
          var init = lazyComponent._init;

          try {
            // Lazy may contain any component type so we recursively resolve it.
            return describeUnknownElementTypeFrameInDEV(init(payload), source, ownerFn);
          } catch (x) {}
        }
    }
  }

  return '';
}

var loggedTypeFailures = {};
var ReactDebugCurrentFrame$1 = ReactSharedInternals.ReactDebugCurrentFrame;

function setCurrentlyValidatingElement(element) {
  {
    if (element) {
      var owner = element._owner;
      var stack = describeUnknownElementTypeFrameInDEV(element.type, element._source, owner ? owner.type : null);
      ReactDebugCurrentFrame$1.setExtraStackFrame(stack);
    } else {
      ReactDebugCurrentFrame$1.setExtraStackFrame(null);
    }
  }
}

function checkPropTypes(typeSpecs, values, location, componentName, element) {
  {
    // $FlowFixMe This is okay but Flow doesn't know it.
    var has = Function.call.bind(Object.prototype.hasOwnProperty);

    for (var typeSpecName in typeSpecs) {
      if (has(typeSpecs, typeSpecName)) {
        var error$1 = void 0; // Prop type validation may throw. In case they do, we don't want to
        // fail the render phase where it didn't fail before. So we log it.
        // After these have been cleaned up, we'll let them throw.

        try {
          // This is intentionally an invariant that gets caught. It's the same
          // behavior as without this statement except with a better message.
          if (typeof typeSpecs[typeSpecName] !== 'function') {
            var err = Error((componentName || 'React class') + ': ' + location + ' type `' + typeSpecName + '` is invalid; ' + 'it must be a function, usually from the `prop-types` package, but received `' + typeof typeSpecs[typeSpecName] + '`.' + 'This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.');
            err.name = 'Invariant Violation';
            throw err;
          }

          error$1 = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED');
        } catch (ex) {
          error$1 = ex;
        }

        if (error$1 && !(error$1 instanceof Error)) {
          setCurrentlyValidatingElement(element);

          error('%s: type specification of %s' + ' `%s` is invalid; the type checker ' + 'function must return `null` or an `Error` but returned a %s. ' + 'You may have forgotten to pass an argument to the type checker ' + 'creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and ' + 'shape all require an argument).', componentName || 'React class', location, typeSpecName, typeof error$1);

          setCurrentlyValidatingElement(null);
        }

        if (error$1 instanceof Error && !(error$1.message in loggedTypeFailures)) {
          // Only monitor this failure once because there tends to be a lot of the
          // same error.
          loggedTypeFailures[error$1.message] = true;
          setCurrentlyValidatingElement(element);

          error('Failed %s type: %s', location, error$1.message);

          setCurrentlyValidatingElement(null);
        }
      }
    }
  }
}

function setCurrentlyValidatingElement$1(element) {
  {
    if (element) {
      var owner = element._owner;
      var stack = describeUnknownElementTypeFrameInDEV(element.type, element._source, owner ? owner.type : null);
      setExtraStackFrame(stack);
    } else {
      setExtraStackFrame(null);
    }
  }
}

var propTypesMisspellWarningShown;

{
  propTypesMisspellWarningShown = false;
}

function getDeclarationErrorAddendum() {
  if (ReactCurrentOwner.current) {
    var name = getComponentName(ReactCurrentOwner.current.type);

    if (name) {
      return '\n\nCheck the render method of `' + name + '`.';
    }
  }

  return '';
}

function getSourceInfoErrorAddendum(source) {
  if (source !== undefined) {
    var fileName = source.fileName.replace(/^.*[\\\/]/, '');
    var lineNumber = source.lineNumber;
    return '\n\nCheck your code at ' + fileName + ':' + lineNumber + '.';
  }

  return '';
}

function getSourceInfoErrorAddendumForProps(elementProps) {
  if (elementProps !== null && elementProps !== undefined) {
    return getSourceInfoErrorAddendum(elementProps.__source);
  }

  return '';
}
/**
 * Warn if there's no key explicitly set on dynamic arrays of children or
 * object keys are not valid. This allows us to keep track of children between
 * updates.
 */


var ownerHasKeyUseWarning = {};

function getCurrentComponentErrorInfo(parentType) {
  var info = getDeclarationErrorAddendum();

  if (!info) {
    var parentName = typeof parentType === 'string' ? parentType : parentType.displayName || parentType.name;

    if (parentName) {
      info = "\n\nCheck the top-level render call using <" + parentName + ">.";
    }
  }

  return info;
}
/**
 * Warn if the element doesn't have an explicit key assigned to it.
 * This element is in an array. The array could grow and shrink or be
 * reordered. All children that haven't already been validated are required to
 * have a "key" property assigned to it. Error statuses are cached so a warning
 * will only be shown once.
 *
 * @internal
 * @param {ReactElement} element Element that requires a key.
 * @param {*} parentType element's parent's type.
 */


function validateExplicitKey(element, parentType) {
  if (!element._store || element._store.validated || element.key != null) {
    return;
  }

  element._store.validated = true;
  var currentComponentErrorInfo = getCurrentComponentErrorInfo(parentType);

  if (ownerHasKeyUseWarning[currentComponentErrorInfo]) {
    return;
  }

  ownerHasKeyUseWarning[currentComponentErrorInfo] = true; // Usually the current owner is the offender, but if it accepts children as a
  // property, it may be the creator of the child that's responsible for
  // assigning it a key.

  var childOwner = '';

  if (element && element._owner && element._owner !== ReactCurrentOwner.current) {
    // Give the component that originally created this child.
    childOwner = " It was passed a child from " + getComponentName(element._owner.type) + ".";
  }

  {
    setCurrentlyValidatingElement$1(element);

    error('Each child in a list should have a unique "key" prop.' + '%s%s See https://reactjs.org/link/warning-keys for more information.', currentComponentErrorInfo, childOwner);

    setCurrentlyValidatingElement$1(null);
  }
}
/**
 * Ensure that every element either is passed in a static location, in an
 * array with an explicit keys property defined, or in an object literal
 * with valid key property.
 *
 * @internal
 * @param {ReactNode} node Statically passed child of any type.
 * @param {*} parentType node's parent's type.
 */


function validateChildKeys(node, parentType) {
  if (typeof node !== 'object') {
    return;
  }

  if (Array.isArray(node)) {
    for (var i = 0; i < node.length; i++) {
      var child = node[i];

      if (isValidElement(child)) {
        validateExplicitKey(child, parentType);
      }
    }
  } else if (isValidElement(node)) {
    // This element was passed in a valid location.
    if (node._store) {
      node._store.validated = true;
    }
  } else if (node) {
    var iteratorFn = getIteratorFn(node);

    if (typeof iteratorFn === 'function') {
      // Entry iterators used to provide implicit keys,
      // but now we print a separate warning for them later.
      if (iteratorFn !== node.entries) {
        var iterator = iteratorFn.call(node);
        var step;

        while (!(step = iterator.next()).done) {
          if (isValidElement(step.value)) {
            validateExplicitKey(step.value, parentType);
          }
        }
      }
    }
  }
}
/**
 * Given an element, validate that its props follow the propTypes definition,
 * provided by the type.
 *
 * @param {ReactElement} element
 */


function validatePropTypes(element) {
  {
    var type = element.type;

    if (type === null || type === undefined || typeof type === 'string') {
      return;
    }

    var propTypes;

    if (typeof type === 'function') {
      propTypes = type.propTypes;
    } else if (typeof type === 'object' && (type.$$typeof === REACT_FORWARD_REF_TYPE || // Note: Memo only checks outer props here.
    // Inner props are checked in the reconciler.
    type.$$typeof === REACT_MEMO_TYPE)) {
      propTypes = type.propTypes;
    } else {
      return;
    }

    if (propTypes) {
      // Intentionally inside to avoid triggering lazy initializers:
      var name = getComponentName(type);
      checkPropTypes(propTypes, element.props, 'prop', name, element);
    } else if (type.PropTypes !== undefined && !propTypesMisspellWarningShown) {
      propTypesMisspellWarningShown = true; // Intentionally inside to avoid triggering lazy initializers:

      var _name = getComponentName(type);

      error('Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?', _name || 'Unknown');
    }

    if (typeof type.getDefaultProps === 'function' && !type.getDefaultProps.isReactClassApproved) {
      error('getDefaultProps is only used on classic React.createClass ' + 'definitions. Use a static property named `defaultProps` instead.');
    }
  }
}
/**
 * Given a fragment, validate that it can only be provided with fragment props
 * @param {ReactElement} fragment
 */


function validateFragmentProps(fragment) {
  {
    var keys = Object.keys(fragment.props);

    for (var i = 0; i < keys.length; i++) {
      var key = keys[i];

      if (key !== 'children' && key !== 'key') {
        setCurrentlyValidatingElement$1(fragment);

        error('Invalid prop `%s` supplied to `React.Fragment`. ' + 'React.Fragment can only have `key` and `children` props.', key);

        setCurrentlyValidatingElement$1(null);
        break;
      }
    }

    if (fragment.ref !== null) {
      setCurrentlyValidatingElement$1(fragment);

      error('Invalid attribute `ref` supplied to `React.Fragment`.');

      setCurrentlyValidatingElement$1(null);
    }
  }
}
function createElementWithValidation(type, props, children) {
  var validType = isValidElementType(type); // We warn in this case but don't throw. We expect the element creation to
  // succeed and there will likely be errors in render.

  if (!validType) {
    var info = '';

    if (type === undefined || typeof type === 'object' && type !== null && Object.keys(type).length === 0) {
      info += ' You likely forgot to export your component from the file ' + "it's defined in, or you might have mixed up default and named imports.";
    }

    var sourceInfo = getSourceInfoErrorAddendumForProps(props);

    if (sourceInfo) {
      info += sourceInfo;
    } else {
      info += getDeclarationErrorAddendum();
    }

    var typeString;

    if (type === null) {
      typeString = 'null';
    } else if (Array.isArray(type)) {
      typeString = 'array';
    } else if (type !== undefined && type.$$typeof === REACT_ELEMENT_TYPE) {
      typeString = "<" + (getComponentName(type.type) || 'Unknown') + " />";
      info = ' Did you accidentally export a JSX literal instead of a component?';
    } else {
      typeString = typeof type;
    }

    {
      error('React.createElement: type is invalid -- expected a string (for ' + 'built-in components) or a class/function (for composite ' + 'components) but got: %s.%s', typeString, info);
    }
  }

  var element = createElement.apply(this, arguments); // The result can be nullish if a mock or a custom function is used.
  // TODO: Drop this when these are no longer allowed as the type argument.

  if (element == null) {
    return element;
  } // Skip key warning if the type isn't valid since our key validation logic
  // doesn't expect a non-string/function type and can throw confusing errors.
  // We don't want exception behavior to differ between dev and prod.
  // (Rendering will throw with a helpful message and as soon as the type is
  // fixed, the key warnings will appear.)


  if (validType) {
    for (var i = 2; i < arguments.length; i++) {
      validateChildKeys(arguments[i], type);
    }
  }

  if (type === exports.Fragment) {
    validateFragmentProps(element);
  } else {
    validatePropTypes(element);
  }

  return element;
}
var didWarnAboutDeprecatedCreateFactory = false;
function createFactoryWithValidation(type) {
  var validatedFactory = createElementWithValidation.bind(null, type);
  validatedFactory.type = type;

  {
    if (!didWarnAboutDeprecatedCreateFactory) {
      didWarnAboutDeprecatedCreateFactory = true;

      warn('React.createFactory() is deprecated and will be removed in ' + 'a future major release. Consider using JSX ' + 'or use React.createElement() directly instead.');
    } // Legacy hook: remove it


    Object.defineProperty(validatedFactory, 'type', {
      enumerable: false,
      get: function () {
        warn('Factory.type is deprecated. Access the class directly ' + 'before passing it to createFactory.');

        Object.defineProperty(this, 'type', {
          value: type
        });
        return type;
      }
    });
  }

  return validatedFactory;
}
function cloneElementWithValidation(element, props, children) {
  var newElement = cloneElement.apply(this, arguments);

  for (var i = 2; i < arguments.length; i++) {
    validateChildKeys(arguments[i], newElement.type);
  }

  validatePropTypes(newElement);
  return newElement;
}

{

  try {
    var frozenObject = Object.freeze({});
    /* eslint-disable no-new */

    new Map([[frozenObject, null]]);
    new Set([frozenObject]);
    /* eslint-enable no-new */
  } catch (e) {
  }
}

var createElement$1 =  createElementWithValidation ;
var cloneElement$1 =  cloneElementWithValidation ;
var createFactory =  createFactoryWithValidation ;
var Children = {
  map: mapChildren,
  forEach: forEachChildren,
  count: countChildren,
  toArray: toArray,
  only: onlyChild
};

exports.Children = Children;
exports.Component = Component;
exports.PureComponent = PureComponent;
exports.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = ReactSharedInternals;
exports.cloneElement = cloneElement$1;
exports.createContext = createContext;
exports.createElement = createElement$1;
exports.createFactory = createFactory;
exports.createRef = createRef;
exports.forwardRef = forwardRef;
exports.isValidElement = isValidElement;
exports.lazy = lazy;
exports.memo = memo;
exports.useCallback = useCallback;
exports.useContext = useContext;
exports.useDebugValue = useDebugValue;
exports.useEffect = useEffect;
exports.useImperativeHandle = useImperativeHandle;
exports.useLayoutEffect = useLayoutEffect;
exports.useMemo = useMemo;
exports.useReducer = useReducer;
exports.useRef = useRef;
exports.useState = useState;
exports.version = ReactVersion;
  })();
}


/***/ }),

/***/ "./node_modules/react/index.js":
/*!*************************************!*\
  !*** ./node_modules/react/index.js ***!
  \*************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (false) {} else {
  module.exports = __webpack_require__(/*! ./cjs/react.development.js */ "./node_modules/react/cjs/react.development.js");
}


/***/ }),

/***/ "./node_modules/readable-stream/duplex-browser.js":
/*!********************************************************!*\
  !*** ./node_modules/readable-stream/duplex-browser.js ***!
  \********************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(/*! ./lib/_stream_duplex.js */ "./node_modules/readable-stream/lib/_stream_duplex.js");


/***/ }),

/***/ "./node_modules/readable-stream/lib/_stream_duplex.js":
/*!************************************************************!*\
  !*** ./node_modules/readable-stream/lib/_stream_duplex.js ***!
  \************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

// a duplex stream is just a stream that is both readable and writable.
// Since JS doesn't have multiple prototypal inheritance, this class
// prototypally inherits from Readable, and then parasitically from
// Writable.



/*<replacement>*/

var pna = __webpack_require__(/*! process-nextick-args */ "./node_modules/process-nextick-args/index.js");
/*</replacement>*/

/*<replacement>*/
var objectKeys = Object.keys || function (obj) {
  var keys = [];
  for (var key in obj) {
    keys.push(key);
  }return keys;
};
/*</replacement>*/

module.exports = Duplex;

/*<replacement>*/
var util = Object.create(__webpack_require__(/*! core-util-is */ "./node_modules/core-util-is/lib/util.js"));
util.inherits = __webpack_require__(/*! inherits */ "./node_modules/inherits/inherits_browser.js");
/*</replacement>*/

var Readable = __webpack_require__(/*! ./_stream_readable */ "./node_modules/readable-stream/lib/_stream_readable.js");
var Writable = __webpack_require__(/*! ./_stream_writable */ "./node_modules/readable-stream/lib/_stream_writable.js");

util.inherits(Duplex, Readable);

{
  // avoid scope creep, the keys array can then be collected
  var keys = objectKeys(Writable.prototype);
  for (var v = 0; v < keys.length; v++) {
    var method = keys[v];
    if (!Duplex.prototype[method]) Duplex.prototype[method] = Writable.prototype[method];
  }
}

function Duplex(options) {
  if (!(this instanceof Duplex)) return new Duplex(options);

  Readable.call(this, options);
  Writable.call(this, options);

  if (options && options.readable === false) this.readable = false;

  if (options && options.writable === false) this.writable = false;

  this.allowHalfOpen = true;
  if (options && options.allowHalfOpen === false) this.allowHalfOpen = false;

  this.once('end', onend);
}

Object.defineProperty(Duplex.prototype, 'writableHighWaterMark', {
  // making it explicit this property is not enumerable
  // because otherwise some prototype manipulation in
  // userland will fail
  enumerable: false,
  get: function () {
    return this._writableState.highWaterMark;
  }
});

// the no-half-open enforcer
function onend() {
  // if we allow half-open state, or if the writable side ended,
  // then we're ok.
  if (this.allowHalfOpen || this._writableState.ended) return;

  // no more data can be written.
  // But allow more writes to happen in this tick.
  pna.nextTick(onEndNT, this);
}

function onEndNT(self) {
  self.end();
}

Object.defineProperty(Duplex.prototype, 'destroyed', {
  get: function () {
    if (this._readableState === undefined || this._writableState === undefined) {
      return false;
    }
    return this._readableState.destroyed && this._writableState.destroyed;
  },
  set: function (value) {
    // we ignore the value if the stream
    // has not been initialized yet
    if (this._readableState === undefined || this._writableState === undefined) {
      return;
    }

    // backward compatibility, the user is explicitly
    // managing destroyed
    this._readableState.destroyed = value;
    this._writableState.destroyed = value;
  }
});

Duplex.prototype._destroy = function (err, cb) {
  this.push(null);
  this.end();

  pna.nextTick(cb, err);
};

/***/ }),

/***/ "./node_modules/readable-stream/lib/_stream_passthrough.js":
/*!*****************************************************************!*\
  !*** ./node_modules/readable-stream/lib/_stream_passthrough.js ***!
  \*****************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

// a passthrough stream.
// basically just the most minimal sort of Transform stream.
// Every written chunk gets output as-is.



module.exports = PassThrough;

var Transform = __webpack_require__(/*! ./_stream_transform */ "./node_modules/readable-stream/lib/_stream_transform.js");

/*<replacement>*/
var util = Object.create(__webpack_require__(/*! core-util-is */ "./node_modules/core-util-is/lib/util.js"));
util.inherits = __webpack_require__(/*! inherits */ "./node_modules/inherits/inherits_browser.js");
/*</replacement>*/

util.inherits(PassThrough, Transform);

function PassThrough(options) {
  if (!(this instanceof PassThrough)) return new PassThrough(options);

  Transform.call(this, options);
}

PassThrough.prototype._transform = function (chunk, encoding, cb) {
  cb(null, chunk);
};

/***/ }),

/***/ "./node_modules/readable-stream/lib/_stream_readable.js":
/*!**************************************************************!*\
  !*** ./node_modules/readable-stream/lib/_stream_readable.js ***!
  \**************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global, process) {// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.



/*<replacement>*/

var pna = __webpack_require__(/*! process-nextick-args */ "./node_modules/process-nextick-args/index.js");
/*</replacement>*/

module.exports = Readable;

/*<replacement>*/
var isArray = __webpack_require__(/*! isarray */ "./node_modules/isarray/index.js");
/*</replacement>*/

/*<replacement>*/
var Duplex;
/*</replacement>*/

Readable.ReadableState = ReadableState;

/*<replacement>*/
var EE = __webpack_require__(/*! events */ "./node_modules/events/events.js").EventEmitter;

var EElistenerCount = function (emitter, type) {
  return emitter.listeners(type).length;
};
/*</replacement>*/

/*<replacement>*/
var Stream = __webpack_require__(/*! ./internal/streams/stream */ "./node_modules/readable-stream/lib/internal/streams/stream-browser.js");
/*</replacement>*/

/*<replacement>*/

var Buffer = __webpack_require__(/*! safe-buffer */ "./node_modules/safe-buffer/index.js").Buffer;
var OurUint8Array = global.Uint8Array || function () {};
function _uint8ArrayToBuffer(chunk) {
  return Buffer.from(chunk);
}
function _isUint8Array(obj) {
  return Buffer.isBuffer(obj) || obj instanceof OurUint8Array;
}

/*</replacement>*/

/*<replacement>*/
var util = Object.create(__webpack_require__(/*! core-util-is */ "./node_modules/core-util-is/lib/util.js"));
util.inherits = __webpack_require__(/*! inherits */ "./node_modules/inherits/inherits_browser.js");
/*</replacement>*/

/*<replacement>*/
var debugUtil = __webpack_require__(/*! util */ 2);
var debug = void 0;
if (debugUtil && debugUtil.debuglog) {
  debug = debugUtil.debuglog('stream');
} else {
  debug = function () {};
}
/*</replacement>*/

var BufferList = __webpack_require__(/*! ./internal/streams/BufferList */ "./node_modules/readable-stream/lib/internal/streams/BufferList.js");
var destroyImpl = __webpack_require__(/*! ./internal/streams/destroy */ "./node_modules/readable-stream/lib/internal/streams/destroy.js");
var StringDecoder;

util.inherits(Readable, Stream);

var kProxyEvents = ['error', 'close', 'destroy', 'pause', 'resume'];

function prependListener(emitter, event, fn) {
  // Sadly this is not cacheable as some libraries bundle their own
  // event emitter implementation with them.
  if (typeof emitter.prependListener === 'function') return emitter.prependListener(event, fn);

  // This is a hack to make sure that our error handler is attached before any
  // userland ones.  NEVER DO THIS. This is here only because this code needs
  // to continue to work with older versions of Node.js that do not include
  // the prependListener() method. The goal is to eventually remove this hack.
  if (!emitter._events || !emitter._events[event]) emitter.on(event, fn);else if (isArray(emitter._events[event])) emitter._events[event].unshift(fn);else emitter._events[event] = [fn, emitter._events[event]];
}

function ReadableState(options, stream) {
  Duplex = Duplex || __webpack_require__(/*! ./_stream_duplex */ "./node_modules/readable-stream/lib/_stream_duplex.js");

  options = options || {};

  // Duplex streams are both readable and writable, but share
  // the same options object.
  // However, some cases require setting options to different
  // values for the readable and the writable sides of the duplex stream.
  // These options can be provided separately as readableXXX and writableXXX.
  var isDuplex = stream instanceof Duplex;

  // object stream flag. Used to make read(n) ignore n and to
  // make all the buffer merging and length checks go away
  this.objectMode = !!options.objectMode;

  if (isDuplex) this.objectMode = this.objectMode || !!options.readableObjectMode;

  // the point at which it stops calling _read() to fill the buffer
  // Note: 0 is a valid value, means "don't call _read preemptively ever"
  var hwm = options.highWaterMark;
  var readableHwm = options.readableHighWaterMark;
  var defaultHwm = this.objectMode ? 16 : 16 * 1024;

  if (hwm || hwm === 0) this.highWaterMark = hwm;else if (isDuplex && (readableHwm || readableHwm === 0)) this.highWaterMark = readableHwm;else this.highWaterMark = defaultHwm;

  // cast to ints.
  this.highWaterMark = Math.floor(this.highWaterMark);

  // A linked list is used to store data chunks instead of an array because the
  // linked list can remove elements from the beginning faster than
  // array.shift()
  this.buffer = new BufferList();
  this.length = 0;
  this.pipes = null;
  this.pipesCount = 0;
  this.flowing = null;
  this.ended = false;
  this.endEmitted = false;
  this.reading = false;

  // a flag to be able to tell if the event 'readable'/'data' is emitted
  // immediately, or on a later tick.  We set this to true at first, because
  // any actions that shouldn't happen until "later" should generally also
  // not happen before the first read call.
  this.sync = true;

  // whenever we return null, then we set a flag to say
  // that we're awaiting a 'readable' event emission.
  this.needReadable = false;
  this.emittedReadable = false;
  this.readableListening = false;
  this.resumeScheduled = false;

  // has it been destroyed
  this.destroyed = false;

  // Crypto is kind of old and crusty.  Historically, its default string
  // encoding is 'binary' so we have to make this configurable.
  // Everything else in the universe uses 'utf8', though.
  this.defaultEncoding = options.defaultEncoding || 'utf8';

  // the number of writers that are awaiting a drain event in .pipe()s
  this.awaitDrain = 0;

  // if true, a maybeReadMore has been scheduled
  this.readingMore = false;

  this.decoder = null;
  this.encoding = null;
  if (options.encoding) {
    if (!StringDecoder) StringDecoder = __webpack_require__(/*! string_decoder/ */ "./node_modules/string_decoder/lib/string_decoder.js").StringDecoder;
    this.decoder = new StringDecoder(options.encoding);
    this.encoding = options.encoding;
  }
}

function Readable(options) {
  Duplex = Duplex || __webpack_require__(/*! ./_stream_duplex */ "./node_modules/readable-stream/lib/_stream_duplex.js");

  if (!(this instanceof Readable)) return new Readable(options);

  this._readableState = new ReadableState(options, this);

  // legacy
  this.readable = true;

  if (options) {
    if (typeof options.read === 'function') this._read = options.read;

    if (typeof options.destroy === 'function') this._destroy = options.destroy;
  }

  Stream.call(this);
}

Object.defineProperty(Readable.prototype, 'destroyed', {
  get: function () {
    if (this._readableState === undefined) {
      return false;
    }
    return this._readableState.destroyed;
  },
  set: function (value) {
    // we ignore the value if the stream
    // has not been initialized yet
    if (!this._readableState) {
      return;
    }

    // backward compatibility, the user is explicitly
    // managing destroyed
    this._readableState.destroyed = value;
  }
});

Readable.prototype.destroy = destroyImpl.destroy;
Readable.prototype._undestroy = destroyImpl.undestroy;
Readable.prototype._destroy = function (err, cb) {
  this.push(null);
  cb(err);
};

// Manually shove something into the read() buffer.
// This returns true if the highWaterMark has not been hit yet,
// similar to how Writable.write() returns true if you should
// write() some more.
Readable.prototype.push = function (chunk, encoding) {
  var state = this._readableState;
  var skipChunkCheck;

  if (!state.objectMode) {
    if (typeof chunk === 'string') {
      encoding = encoding || state.defaultEncoding;
      if (encoding !== state.encoding) {
        chunk = Buffer.from(chunk, encoding);
        encoding = '';
      }
      skipChunkCheck = true;
    }
  } else {
    skipChunkCheck = true;
  }

  return readableAddChunk(this, chunk, encoding, false, skipChunkCheck);
};

// Unshift should *always* be something directly out of read()
Readable.prototype.unshift = function (chunk) {
  return readableAddChunk(this, chunk, null, true, false);
};

function readableAddChunk(stream, chunk, encoding, addToFront, skipChunkCheck) {
  var state = stream._readableState;
  if (chunk === null) {
    state.reading = false;
    onEofChunk(stream, state);
  } else {
    var er;
    if (!skipChunkCheck) er = chunkInvalid(state, chunk);
    if (er) {
      stream.emit('error', er);
    } else if (state.objectMode || chunk && chunk.length > 0) {
      if (typeof chunk !== 'string' && !state.objectMode && Object.getPrototypeOf(chunk) !== Buffer.prototype) {
        chunk = _uint8ArrayToBuffer(chunk);
      }

      if (addToFront) {
        if (state.endEmitted) stream.emit('error', new Error('stream.unshift() after end event'));else addChunk(stream, state, chunk, true);
      } else if (state.ended) {
        stream.emit('error', new Error('stream.push() after EOF'));
      } else {
        state.reading = false;
        if (state.decoder && !encoding) {
          chunk = state.decoder.write(chunk);
          if (state.objectMode || chunk.length !== 0) addChunk(stream, state, chunk, false);else maybeReadMore(stream, state);
        } else {
          addChunk(stream, state, chunk, false);
        }
      }
    } else if (!addToFront) {
      state.reading = false;
    }
  }

  return needMoreData(state);
}

function addChunk(stream, state, chunk, addToFront) {
  if (state.flowing && state.length === 0 && !state.sync) {
    stream.emit('data', chunk);
    stream.read(0);
  } else {
    // update the buffer info.
    state.length += state.objectMode ? 1 : chunk.length;
    if (addToFront) state.buffer.unshift(chunk);else state.buffer.push(chunk);

    if (state.needReadable) emitReadable(stream);
  }
  maybeReadMore(stream, state);
}

function chunkInvalid(state, chunk) {
  var er;
  if (!_isUint8Array(chunk) && typeof chunk !== 'string' && chunk !== undefined && !state.objectMode) {
    er = new TypeError('Invalid non-string/buffer chunk');
  }
  return er;
}

// if it's past the high water mark, we can push in some more.
// Also, if we have no data yet, we can stand some
// more bytes.  This is to work around cases where hwm=0,
// such as the repl.  Also, if the push() triggered a
// readable event, and the user called read(largeNumber) such that
// needReadable was set, then we ought to push more, so that another
// 'readable' event will be triggered.
function needMoreData(state) {
  return !state.ended && (state.needReadable || state.length < state.highWaterMark || state.length === 0);
}

Readable.prototype.isPaused = function () {
  return this._readableState.flowing === false;
};

// backwards compatibility.
Readable.prototype.setEncoding = function (enc) {
  if (!StringDecoder) StringDecoder = __webpack_require__(/*! string_decoder/ */ "./node_modules/string_decoder/lib/string_decoder.js").StringDecoder;
  this._readableState.decoder = new StringDecoder(enc);
  this._readableState.encoding = enc;
  return this;
};

// Don't raise the hwm > 8MB
var MAX_HWM = 0x800000;
function computeNewHighWaterMark(n) {
  if (n >= MAX_HWM) {
    n = MAX_HWM;
  } else {
    // Get the next highest power of 2 to prevent increasing hwm excessively in
    // tiny amounts
    n--;
    n |= n >>> 1;
    n |= n >>> 2;
    n |= n >>> 4;
    n |= n >>> 8;
    n |= n >>> 16;
    n++;
  }
  return n;
}

// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function howMuchToRead(n, state) {
  if (n <= 0 || state.length === 0 && state.ended) return 0;
  if (state.objectMode) return 1;
  if (n !== n) {
    // Only flow one buffer at a time
    if (state.flowing && state.length) return state.buffer.head.data.length;else return state.length;
  }
  // If we're asking for more than the current hwm, then raise the hwm.
  if (n > state.highWaterMark) state.highWaterMark = computeNewHighWaterMark(n);
  if (n <= state.length) return n;
  // Don't have enough
  if (!state.ended) {
    state.needReadable = true;
    return 0;
  }
  return state.length;
}

// you can override either this method, or the async _read(n) below.
Readable.prototype.read = function (n) {
  debug('read', n);
  n = parseInt(n, 10);
  var state = this._readableState;
  var nOrig = n;

  if (n !== 0) state.emittedReadable = false;

  // if we're doing read(0) to trigger a readable event, but we
  // already have a bunch of data in the buffer, then just trigger
  // the 'readable' event and move on.
  if (n === 0 && state.needReadable && (state.length >= state.highWaterMark || state.ended)) {
    debug('read: emitReadable', state.length, state.ended);
    if (state.length === 0 && state.ended) endReadable(this);else emitReadable(this);
    return null;
  }

  n = howMuchToRead(n, state);

  // if we've ended, and we're now clear, then finish it up.
  if (n === 0 && state.ended) {
    if (state.length === 0) endReadable(this);
    return null;
  }

  // All the actual chunk generation logic needs to be
  // *below* the call to _read.  The reason is that in certain
  // synthetic stream cases, such as passthrough streams, _read
  // may be a completely synchronous operation which may change
  // the state of the read buffer, providing enough data when
  // before there was *not* enough.
  //
  // So, the steps are:
  // 1. Figure out what the state of things will be after we do
  // a read from the buffer.
  //
  // 2. If that resulting state will trigger a _read, then call _read.
  // Note that this may be asynchronous, or synchronous.  Yes, it is
  // deeply ugly to write APIs this way, but that still doesn't mean
  // that the Readable class should behave improperly, as streams are
  // designed to be sync/async agnostic.
  // Take note if the _read call is sync or async (ie, if the read call
  // has returned yet), so that we know whether or not it's safe to emit
  // 'readable' etc.
  //
  // 3. Actually pull the requested chunks out of the buffer and return.

  // if we need a readable event, then we need to do some reading.
  var doRead = state.needReadable;
  debug('need readable', doRead);

  // if we currently have less than the highWaterMark, then also read some
  if (state.length === 0 || state.length - n < state.highWaterMark) {
    doRead = true;
    debug('length less than watermark', doRead);
  }

  // however, if we've ended, then there's no point, and if we're already
  // reading, then it's unnecessary.
  if (state.ended || state.reading) {
    doRead = false;
    debug('reading or ended', doRead);
  } else if (doRead) {
    debug('do read');
    state.reading = true;
    state.sync = true;
    // if the length is currently zero, then we *need* a readable event.
    if (state.length === 0) state.needReadable = true;
    // call internal read method
    this._read(state.highWaterMark);
    state.sync = false;
    // If _read pushed data synchronously, then `reading` will be false,
    // and we need to re-evaluate how much data we can return to the user.
    if (!state.reading) n = howMuchToRead(nOrig, state);
  }

  var ret;
  if (n > 0) ret = fromList(n, state);else ret = null;

  if (ret === null) {
    state.needReadable = true;
    n = 0;
  } else {
    state.length -= n;
  }

  if (state.length === 0) {
    // If we have nothing in the buffer, then we want to know
    // as soon as we *do* get something into the buffer.
    if (!state.ended) state.needReadable = true;

    // If we tried to read() past the EOF, then emit end on the next tick.
    if (nOrig !== n && state.ended) endReadable(this);
  }

  if (ret !== null) this.emit('data', ret);

  return ret;
};

function onEofChunk(stream, state) {
  if (state.ended) return;
  if (state.decoder) {
    var chunk = state.decoder.end();
    if (chunk && chunk.length) {
      state.buffer.push(chunk);
      state.length += state.objectMode ? 1 : chunk.length;
    }
  }
  state.ended = true;

  // emit 'readable' now to make sure it gets picked up.
  emitReadable(stream);
}

// Don't emit readable right away in sync mode, because this can trigger
// another read() call => stack overflow.  This way, it might trigger
// a nextTick recursion warning, but that's not so bad.
function emitReadable(stream) {
  var state = stream._readableState;
  state.needReadable = false;
  if (!state.emittedReadable) {
    debug('emitReadable', state.flowing);
    state.emittedReadable = true;
    if (state.sync) pna.nextTick(emitReadable_, stream);else emitReadable_(stream);
  }
}

function emitReadable_(stream) {
  debug('emit readable');
  stream.emit('readable');
  flow(stream);
}

// at this point, the user has presumably seen the 'readable' event,
// and called read() to consume some data.  that may have triggered
// in turn another _read(n) call, in which case reading = true if
// it's in progress.
// However, if we're not ended, or reading, and the length < hwm,
// then go ahead and try to read some more preemptively.
function maybeReadMore(stream, state) {
  if (!state.readingMore) {
    state.readingMore = true;
    pna.nextTick(maybeReadMore_, stream, state);
  }
}

function maybeReadMore_(stream, state) {
  var len = state.length;
  while (!state.reading && !state.flowing && !state.ended && state.length < state.highWaterMark) {
    debug('maybeReadMore read 0');
    stream.read(0);
    if (len === state.length)
      // didn't get any data, stop spinning.
      break;else len = state.length;
  }
  state.readingMore = false;
}

// abstract method.  to be overridden in specific implementation classes.
// call cb(er, data) where data is <= n in length.
// for virtual (non-string, non-buffer) streams, "length" is somewhat
// arbitrary, and perhaps not very meaningful.
Readable.prototype._read = function (n) {
  this.emit('error', new Error('_read() is not implemented'));
};

Readable.prototype.pipe = function (dest, pipeOpts) {
  var src = this;
  var state = this._readableState;

  switch (state.pipesCount) {
    case 0:
      state.pipes = dest;
      break;
    case 1:
      state.pipes = [state.pipes, dest];
      break;
    default:
      state.pipes.push(dest);
      break;
  }
  state.pipesCount += 1;
  debug('pipe count=%d opts=%j', state.pipesCount, pipeOpts);

  var doEnd = (!pipeOpts || pipeOpts.end !== false) && dest !== process.stdout && dest !== process.stderr;

  var endFn = doEnd ? onend : unpipe;
  if (state.endEmitted) pna.nextTick(endFn);else src.once('end', endFn);

  dest.on('unpipe', onunpipe);
  function onunpipe(readable, unpipeInfo) {
    debug('onunpipe');
    if (readable === src) {
      if (unpipeInfo && unpipeInfo.hasUnpiped === false) {
        unpipeInfo.hasUnpiped = true;
        cleanup();
      }
    }
  }

  function onend() {
    debug('onend');
    dest.end();
  }

  // when the dest drains, it reduces the awaitDrain counter
  // on the source.  This would be more elegant with a .once()
  // handler in flow(), but adding and removing repeatedly is
  // too slow.
  var ondrain = pipeOnDrain(src);
  dest.on('drain', ondrain);

  var cleanedUp = false;
  function cleanup() {
    debug('cleanup');
    // cleanup event handlers once the pipe is broken
    dest.removeListener('close', onclose);
    dest.removeListener('finish', onfinish);
    dest.removeListener('drain', ondrain);
    dest.removeListener('error', onerror);
    dest.removeListener('unpipe', onunpipe);
    src.removeListener('end', onend);
    src.removeListener('end', unpipe);
    src.removeListener('data', ondata);

    cleanedUp = true;

    // if the reader is waiting for a drain event from this
    // specific writer, then it would cause it to never start
    // flowing again.
    // So, if this is awaiting a drain, then we just call it now.
    // If we don't know, then assume that we are waiting for one.
    if (state.awaitDrain && (!dest._writableState || dest._writableState.needDrain)) ondrain();
  }

  // If the user pushes more data while we're writing to dest then we'll end up
  // in ondata again. However, we only want to increase awaitDrain once because
  // dest will only emit one 'drain' event for the multiple writes.
  // => Introduce a guard on increasing awaitDrain.
  var increasedAwaitDrain = false;
  src.on('data', ondata);
  function ondata(chunk) {
    debug('ondata');
    increasedAwaitDrain = false;
    var ret = dest.write(chunk);
    if (false === ret && !increasedAwaitDrain) {
      // If the user unpiped during `dest.write()`, it is possible
      // to get stuck in a permanently paused state if that write
      // also returned false.
      // => Check whether `dest` is still a piping destination.
      if ((state.pipesCount === 1 && state.pipes === dest || state.pipesCount > 1 && indexOf(state.pipes, dest) !== -1) && !cleanedUp) {
        debug('false write response, pause', src._readableState.awaitDrain);
        src._readableState.awaitDrain++;
        increasedAwaitDrain = true;
      }
      src.pause();
    }
  }

  // if the dest has an error, then stop piping into it.
  // however, don't suppress the throwing behavior for this.
  function onerror(er) {
    debug('onerror', er);
    unpipe();
    dest.removeListener('error', onerror);
    if (EElistenerCount(dest, 'error') === 0) dest.emit('error', er);
  }

  // Make sure our error handler is attached before userland ones.
  prependListener(dest, 'error', onerror);

  // Both close and finish should trigger unpipe, but only once.
  function onclose() {
    dest.removeListener('finish', onfinish);
    unpipe();
  }
  dest.once('close', onclose);
  function onfinish() {
    debug('onfinish');
    dest.removeListener('close', onclose);
    unpipe();
  }
  dest.once('finish', onfinish);

  function unpipe() {
    debug('unpipe');
    src.unpipe(dest);
  }

  // tell the dest that it's being piped to
  dest.emit('pipe', src);

  // start the flow if it hasn't been started already.
  if (!state.flowing) {
    debug('pipe resume');
    src.resume();
  }

  return dest;
};

function pipeOnDrain(src) {
  return function () {
    var state = src._readableState;
    debug('pipeOnDrain', state.awaitDrain);
    if (state.awaitDrain) state.awaitDrain--;
    if (state.awaitDrain === 0 && EElistenerCount(src, 'data')) {
      state.flowing = true;
      flow(src);
    }
  };
}

Readable.prototype.unpipe = function (dest) {
  var state = this._readableState;
  var unpipeInfo = { hasUnpiped: false };

  // if we're not piping anywhere, then do nothing.
  if (state.pipesCount === 0) return this;

  // just one destination.  most common case.
  if (state.pipesCount === 1) {
    // passed in one, but it's not the right one.
    if (dest && dest !== state.pipes) return this;

    if (!dest) dest = state.pipes;

    // got a match.
    state.pipes = null;
    state.pipesCount = 0;
    state.flowing = false;
    if (dest) dest.emit('unpipe', this, unpipeInfo);
    return this;
  }

  // slow case. multiple pipe destinations.

  if (!dest) {
    // remove all.
    var dests = state.pipes;
    var len = state.pipesCount;
    state.pipes = null;
    state.pipesCount = 0;
    state.flowing = false;

    for (var i = 0; i < len; i++) {
      dests[i].emit('unpipe', this, unpipeInfo);
    }return this;
  }

  // try to find the right one.
  var index = indexOf(state.pipes, dest);
  if (index === -1) return this;

  state.pipes.splice(index, 1);
  state.pipesCount -= 1;
  if (state.pipesCount === 1) state.pipes = state.pipes[0];

  dest.emit('unpipe', this, unpipeInfo);

  return this;
};

// set up data events if they are asked for
// Ensure readable listeners eventually get something
Readable.prototype.on = function (ev, fn) {
  var res = Stream.prototype.on.call(this, ev, fn);

  if (ev === 'data') {
    // Start flowing on next tick if stream isn't explicitly paused
    if (this._readableState.flowing !== false) this.resume();
  } else if (ev === 'readable') {
    var state = this._readableState;
    if (!state.endEmitted && !state.readableListening) {
      state.readableListening = state.needReadable = true;
      state.emittedReadable = false;
      if (!state.reading) {
        pna.nextTick(nReadingNextTick, this);
      } else if (state.length) {
        emitReadable(this);
      }
    }
  }

  return res;
};
Readable.prototype.addListener = Readable.prototype.on;

function nReadingNextTick(self) {
  debug('readable nexttick read 0');
  self.read(0);
}

// pause() and resume() are remnants of the legacy readable stream API
// If the user uses them, then switch into old mode.
Readable.prototype.resume = function () {
  var state = this._readableState;
  if (!state.flowing) {
    debug('resume');
    state.flowing = true;
    resume(this, state);
  }
  return this;
};

function resume(stream, state) {
  if (!state.resumeScheduled) {
    state.resumeScheduled = true;
    pna.nextTick(resume_, stream, state);
  }
}

function resume_(stream, state) {
  if (!state.reading) {
    debug('resume read 0');
    stream.read(0);
  }

  state.resumeScheduled = false;
  state.awaitDrain = 0;
  stream.emit('resume');
  flow(stream);
  if (state.flowing && !state.reading) stream.read(0);
}

Readable.prototype.pause = function () {
  debug('call pause flowing=%j', this._readableState.flowing);
  if (false !== this._readableState.flowing) {
    debug('pause');
    this._readableState.flowing = false;
    this.emit('pause');
  }
  return this;
};

function flow(stream) {
  var state = stream._readableState;
  debug('flow', state.flowing);
  while (state.flowing && stream.read() !== null) {}
}

// wrap an old-style stream as the async data source.
// This is *not* part of the readable stream interface.
// It is an ugly unfortunate mess of history.
Readable.prototype.wrap = function (stream) {
  var _this = this;

  var state = this._readableState;
  var paused = false;

  stream.on('end', function () {
    debug('wrapped end');
    if (state.decoder && !state.ended) {
      var chunk = state.decoder.end();
      if (chunk && chunk.length) _this.push(chunk);
    }

    _this.push(null);
  });

  stream.on('data', function (chunk) {
    debug('wrapped data');
    if (state.decoder) chunk = state.decoder.write(chunk);

    // don't skip over falsy values in objectMode
    if (state.objectMode && (chunk === null || chunk === undefined)) return;else if (!state.objectMode && (!chunk || !chunk.length)) return;

    var ret = _this.push(chunk);
    if (!ret) {
      paused = true;
      stream.pause();
    }
  });

  // proxy all the other methods.
  // important when wrapping filters and duplexes.
  for (var i in stream) {
    if (this[i] === undefined && typeof stream[i] === 'function') {
      this[i] = function (method) {
        return function () {
          return stream[method].apply(stream, arguments);
        };
      }(i);
    }
  }

  // proxy certain important events.
  for (var n = 0; n < kProxyEvents.length; n++) {
    stream.on(kProxyEvents[n], this.emit.bind(this, kProxyEvents[n]));
  }

  // when we try to consume some more bytes, simply unpause the
  // underlying stream.
  this._read = function (n) {
    debug('wrapped _read', n);
    if (paused) {
      paused = false;
      stream.resume();
    }
  };

  return this;
};

Object.defineProperty(Readable.prototype, 'readableHighWaterMark', {
  // making it explicit this property is not enumerable
  // because otherwise some prototype manipulation in
  // userland will fail
  enumerable: false,
  get: function () {
    return this._readableState.highWaterMark;
  }
});

// exposed for testing purposes only.
Readable._fromList = fromList;

// Pluck off n bytes from an array of buffers.
// Length is the combined lengths of all the buffers in the list.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function fromList(n, state) {
  // nothing buffered
  if (state.length === 0) return null;

  var ret;
  if (state.objectMode) ret = state.buffer.shift();else if (!n || n >= state.length) {
    // read it all, truncate the list
    if (state.decoder) ret = state.buffer.join('');else if (state.buffer.length === 1) ret = state.buffer.head.data;else ret = state.buffer.concat(state.length);
    state.buffer.clear();
  } else {
    // read part of list
    ret = fromListPartial(n, state.buffer, state.decoder);
  }

  return ret;
}

// Extracts only enough buffered data to satisfy the amount requested.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function fromListPartial(n, list, hasStrings) {
  var ret;
  if (n < list.head.data.length) {
    // slice is the same for buffers and strings
    ret = list.head.data.slice(0, n);
    list.head.data = list.head.data.slice(n);
  } else if (n === list.head.data.length) {
    // first chunk is a perfect match
    ret = list.shift();
  } else {
    // result spans more than one buffer
    ret = hasStrings ? copyFromBufferString(n, list) : copyFromBuffer(n, list);
  }
  return ret;
}

// Copies a specified amount of characters from the list of buffered data
// chunks.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function copyFromBufferString(n, list) {
  var p = list.head;
  var c = 1;
  var ret = p.data;
  n -= ret.length;
  while (p = p.next) {
    var str = p.data;
    var nb = n > str.length ? str.length : n;
    if (nb === str.length) ret += str;else ret += str.slice(0, n);
    n -= nb;
    if (n === 0) {
      if (nb === str.length) {
        ++c;
        if (p.next) list.head = p.next;else list.head = list.tail = null;
      } else {
        list.head = p;
        p.data = str.slice(nb);
      }
      break;
    }
    ++c;
  }
  list.length -= c;
  return ret;
}

// Copies a specified amount of bytes from the list of buffered data chunks.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function copyFromBuffer(n, list) {
  var ret = Buffer.allocUnsafe(n);
  var p = list.head;
  var c = 1;
  p.data.copy(ret);
  n -= p.data.length;
  while (p = p.next) {
    var buf = p.data;
    var nb = n > buf.length ? buf.length : n;
    buf.copy(ret, ret.length - n, 0, nb);
    n -= nb;
    if (n === 0) {
      if (nb === buf.length) {
        ++c;
        if (p.next) list.head = p.next;else list.head = list.tail = null;
      } else {
        list.head = p;
        p.data = buf.slice(nb);
      }
      break;
    }
    ++c;
  }
  list.length -= c;
  return ret;
}

function endReadable(stream) {
  var state = stream._readableState;

  // If we get here before consuming all the bytes, then that is a
  // bug in node.  Should never happen.
  if (state.length > 0) throw new Error('"endReadable()" called on non-empty stream');

  if (!state.endEmitted) {
    state.ended = true;
    pna.nextTick(endReadableNT, state, stream);
  }
}

function endReadableNT(state, stream) {
  // Check that we didn't get one last unshift.
  if (!state.endEmitted && state.length === 0) {
    state.endEmitted = true;
    stream.readable = false;
    stream.emit('end');
  }
}

function indexOf(xs, x) {
  for (var i = 0, l = xs.length; i < l; i++) {
    if (xs[i] === x) return i;
  }
  return -1;
}
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(/*! ./../../webpack/buildin/global.js */ "./node_modules/webpack/buildin/global.js"), __webpack_require__(/*! ./../../process/browser.js */ "./node_modules/process/browser.js")))

/***/ }),

/***/ "./node_modules/readable-stream/lib/_stream_transform.js":
/*!***************************************************************!*\
  !*** ./node_modules/readable-stream/lib/_stream_transform.js ***!
  \***************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

// a transform stream is a readable/writable stream where you do
// something with the data.  Sometimes it's called a "filter",
// but that's not a great name for it, since that implies a thing where
// some bits pass through, and others are simply ignored.  (That would
// be a valid example of a transform, of course.)
//
// While the output is causally related to the input, it's not a
// necessarily symmetric or synchronous transformation.  For example,
// a zlib stream might take multiple plain-text writes(), and then
// emit a single compressed chunk some time in the future.
//
// Here's how this works:
//
// The Transform stream has all the aspects of the readable and writable
// stream classes.  When you write(chunk), that calls _write(chunk,cb)
// internally, and returns false if there's a lot of pending writes
// buffered up.  When you call read(), that calls _read(n) until
// there's enough pending readable data buffered up.
//
// In a transform stream, the written data is placed in a buffer.  When
// _read(n) is called, it transforms the queued up data, calling the
// buffered _write cb's as it consumes chunks.  If consuming a single
// written chunk would result in multiple output chunks, then the first
// outputted bit calls the readcb, and subsequent chunks just go into
// the read buffer, and will cause it to emit 'readable' if necessary.
//
// This way, back-pressure is actually determined by the reading side,
// since _read has to be called to start processing a new chunk.  However,
// a pathological inflate type of transform can cause excessive buffering
// here.  For example, imagine a stream where every byte of input is
// interpreted as an integer from 0-255, and then results in that many
// bytes of output.  Writing the 4 bytes {ff,ff,ff,ff} would result in
// 1kb of data being output.  In this case, you could write a very small
// amount of input, and end up with a very large amount of output.  In
// such a pathological inflating mechanism, there'd be no way to tell
// the system to stop doing the transform.  A single 4MB write could
// cause the system to run out of memory.
//
// However, even in such a pathological case, only a single written chunk
// would be consumed, and then the rest would wait (un-transformed) until
// the results of the previous transformed chunk were consumed.



module.exports = Transform;

var Duplex = __webpack_require__(/*! ./_stream_duplex */ "./node_modules/readable-stream/lib/_stream_duplex.js");

/*<replacement>*/
var util = Object.create(__webpack_require__(/*! core-util-is */ "./node_modules/core-util-is/lib/util.js"));
util.inherits = __webpack_require__(/*! inherits */ "./node_modules/inherits/inherits_browser.js");
/*</replacement>*/

util.inherits(Transform, Duplex);

function afterTransform(er, data) {
  var ts = this._transformState;
  ts.transforming = false;

  var cb = ts.writecb;

  if (!cb) {
    return this.emit('error', new Error('write callback called multiple times'));
  }

  ts.writechunk = null;
  ts.writecb = null;

  if (data != null) // single equals check for both `null` and `undefined`
    this.push(data);

  cb(er);

  var rs = this._readableState;
  rs.reading = false;
  if (rs.needReadable || rs.length < rs.highWaterMark) {
    this._read(rs.highWaterMark);
  }
}

function Transform(options) {
  if (!(this instanceof Transform)) return new Transform(options);

  Duplex.call(this, options);

  this._transformState = {
    afterTransform: afterTransform.bind(this),
    needTransform: false,
    transforming: false,
    writecb: null,
    writechunk: null,
    writeencoding: null
  };

  // start out asking for a readable event once data is transformed.
  this._readableState.needReadable = true;

  // we have implemented the _read method, and done the other things
  // that Readable wants before the first _read call, so unset the
  // sync guard flag.
  this._readableState.sync = false;

  if (options) {
    if (typeof options.transform === 'function') this._transform = options.transform;

    if (typeof options.flush === 'function') this._flush = options.flush;
  }

  // When the writable side finishes, then flush out anything remaining.
  this.on('prefinish', prefinish);
}

function prefinish() {
  var _this = this;

  if (typeof this._flush === 'function') {
    this._flush(function (er, data) {
      done(_this, er, data);
    });
  } else {
    done(this, null, null);
  }
}

Transform.prototype.push = function (chunk, encoding) {
  this._transformState.needTransform = false;
  return Duplex.prototype.push.call(this, chunk, encoding);
};

// This is the part where you do stuff!
// override this function in implementation classes.
// 'chunk' is an input chunk.
//
// Call `push(newChunk)` to pass along transformed output
// to the readable side.  You may call 'push' zero or more times.
//
// Call `cb(err)` when you are done with this chunk.  If you pass
// an error, then that'll put the hurt on the whole operation.  If you
// never call cb(), then you'll never get another chunk.
Transform.prototype._transform = function (chunk, encoding, cb) {
  throw new Error('_transform() is not implemented');
};

Transform.prototype._write = function (chunk, encoding, cb) {
  var ts = this._transformState;
  ts.writecb = cb;
  ts.writechunk = chunk;
  ts.writeencoding = encoding;
  if (!ts.transforming) {
    var rs = this._readableState;
    if (ts.needTransform || rs.needReadable || rs.length < rs.highWaterMark) this._read(rs.highWaterMark);
  }
};

// Doesn't matter what the args are here.
// _transform does all the work.
// That we got here means that the readable side wants more data.
Transform.prototype._read = function (n) {
  var ts = this._transformState;

  if (ts.writechunk !== null && ts.writecb && !ts.transforming) {
    ts.transforming = true;
    this._transform(ts.writechunk, ts.writeencoding, ts.afterTransform);
  } else {
    // mark that we need a transform, so that any data that comes in
    // will get processed, now that we've asked for it.
    ts.needTransform = true;
  }
};

Transform.prototype._destroy = function (err, cb) {
  var _this2 = this;

  Duplex.prototype._destroy.call(this, err, function (err2) {
    cb(err2);
    _this2.emit('close');
  });
};

function done(stream, er, data) {
  if (er) return stream.emit('error', er);

  if (data != null) // single equals check for both `null` and `undefined`
    stream.push(data);

  // if there's nothing in the write buffer, then that means
  // that nothing more will ever be provided
  if (stream._writableState.length) throw new Error('Calling transform done when ws.length != 0');

  if (stream._transformState.transforming) throw new Error('Calling transform done when still transforming');

  return stream.push(null);
}

/***/ }),

/***/ "./node_modules/readable-stream/lib/_stream_writable.js":
/*!**************************************************************!*\
  !*** ./node_modules/readable-stream/lib/_stream_writable.js ***!
  \**************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process, setImmediate, global) {// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

// A bit simpler than readable streams.
// Implement an async ._write(chunk, encoding, cb), and it'll handle all
// the drain event emission and buffering.



/*<replacement>*/

var pna = __webpack_require__(/*! process-nextick-args */ "./node_modules/process-nextick-args/index.js");
/*</replacement>*/

module.exports = Writable;

/* <replacement> */
function WriteReq(chunk, encoding, cb) {
  this.chunk = chunk;
  this.encoding = encoding;
  this.callback = cb;
  this.next = null;
}

// It seems a linked list but it is not
// there will be only 2 of these for each stream
function CorkedRequest(state) {
  var _this = this;

  this.next = null;
  this.entry = null;
  this.finish = function () {
    onCorkedFinish(_this, state);
  };
}
/* </replacement> */

/*<replacement>*/
var asyncWrite = !process.browser && ['v0.10', 'v0.9.'].indexOf(process.version.slice(0, 5)) > -1 ? setImmediate : pna.nextTick;
/*</replacement>*/

/*<replacement>*/
var Duplex;
/*</replacement>*/

Writable.WritableState = WritableState;

/*<replacement>*/
var util = Object.create(__webpack_require__(/*! core-util-is */ "./node_modules/core-util-is/lib/util.js"));
util.inherits = __webpack_require__(/*! inherits */ "./node_modules/inherits/inherits_browser.js");
/*</replacement>*/

/*<replacement>*/
var internalUtil = {
  deprecate: __webpack_require__(/*! util-deprecate */ "./node_modules/util-deprecate/browser.js")
};
/*</replacement>*/

/*<replacement>*/
var Stream = __webpack_require__(/*! ./internal/streams/stream */ "./node_modules/readable-stream/lib/internal/streams/stream-browser.js");
/*</replacement>*/

/*<replacement>*/

var Buffer = __webpack_require__(/*! safe-buffer */ "./node_modules/safe-buffer/index.js").Buffer;
var OurUint8Array = global.Uint8Array || function () {};
function _uint8ArrayToBuffer(chunk) {
  return Buffer.from(chunk);
}
function _isUint8Array(obj) {
  return Buffer.isBuffer(obj) || obj instanceof OurUint8Array;
}

/*</replacement>*/

var destroyImpl = __webpack_require__(/*! ./internal/streams/destroy */ "./node_modules/readable-stream/lib/internal/streams/destroy.js");

util.inherits(Writable, Stream);

function nop() {}

function WritableState(options, stream) {
  Duplex = Duplex || __webpack_require__(/*! ./_stream_duplex */ "./node_modules/readable-stream/lib/_stream_duplex.js");

  options = options || {};

  // Duplex streams are both readable and writable, but share
  // the same options object.
  // However, some cases require setting options to different
  // values for the readable and the writable sides of the duplex stream.
  // These options can be provided separately as readableXXX and writableXXX.
  var isDuplex = stream instanceof Duplex;

  // object stream flag to indicate whether or not this stream
  // contains buffers or objects.
  this.objectMode = !!options.objectMode;

  if (isDuplex) this.objectMode = this.objectMode || !!options.writableObjectMode;

  // the point at which write() starts returning false
  // Note: 0 is a valid value, means that we always return false if
  // the entire buffer is not flushed immediately on write()
  var hwm = options.highWaterMark;
  var writableHwm = options.writableHighWaterMark;
  var defaultHwm = this.objectMode ? 16 : 16 * 1024;

  if (hwm || hwm === 0) this.highWaterMark = hwm;else if (isDuplex && (writableHwm || writableHwm === 0)) this.highWaterMark = writableHwm;else this.highWaterMark = defaultHwm;

  // cast to ints.
  this.highWaterMark = Math.floor(this.highWaterMark);

  // if _final has been called
  this.finalCalled = false;

  // drain event flag.
  this.needDrain = false;
  // at the start of calling end()
  this.ending = false;
  // when end() has been called, and returned
  this.ended = false;
  // when 'finish' is emitted
  this.finished = false;

  // has it been destroyed
  this.destroyed = false;

  // should we decode strings into buffers before passing to _write?
  // this is here so that some node-core streams can optimize string
  // handling at a lower level.
  var noDecode = options.decodeStrings === false;
  this.decodeStrings = !noDecode;

  // Crypto is kind of old and crusty.  Historically, its default string
  // encoding is 'binary' so we have to make this configurable.
  // Everything else in the universe uses 'utf8', though.
  this.defaultEncoding = options.defaultEncoding || 'utf8';

  // not an actual buffer we keep track of, but a measurement
  // of how much we're waiting to get pushed to some underlying
  // socket or file.
  this.length = 0;

  // a flag to see when we're in the middle of a write.
  this.writing = false;

  // when true all writes will be buffered until .uncork() call
  this.corked = 0;

  // a flag to be able to tell if the onwrite cb is called immediately,
  // or on a later tick.  We set this to true at first, because any
  // actions that shouldn't happen until "later" should generally also
  // not happen before the first write call.
  this.sync = true;

  // a flag to know if we're processing previously buffered items, which
  // may call the _write() callback in the same tick, so that we don't
  // end up in an overlapped onwrite situation.
  this.bufferProcessing = false;

  // the callback that's passed to _write(chunk,cb)
  this.onwrite = function (er) {
    onwrite(stream, er);
  };

  // the callback that the user supplies to write(chunk,encoding,cb)
  this.writecb = null;

  // the amount that is being written when _write is called.
  this.writelen = 0;

  this.bufferedRequest = null;
  this.lastBufferedRequest = null;

  // number of pending user-supplied write callbacks
  // this must be 0 before 'finish' can be emitted
  this.pendingcb = 0;

  // emit prefinish if the only thing we're waiting for is _write cbs
  // This is relevant for synchronous Transform streams
  this.prefinished = false;

  // True if the error was already emitted and should not be thrown again
  this.errorEmitted = false;

  // count buffered requests
  this.bufferedRequestCount = 0;

  // allocate the first CorkedRequest, there is always
  // one allocated and free to use, and we maintain at most two
  this.corkedRequestsFree = new CorkedRequest(this);
}

WritableState.prototype.getBuffer = function getBuffer() {
  var current = this.bufferedRequest;
  var out = [];
  while (current) {
    out.push(current);
    current = current.next;
  }
  return out;
};

(function () {
  try {
    Object.defineProperty(WritableState.prototype, 'buffer', {
      get: internalUtil.deprecate(function () {
        return this.getBuffer();
      }, '_writableState.buffer is deprecated. Use _writableState.getBuffer ' + 'instead.', 'DEP0003')
    });
  } catch (_) {}
})();

// Test _writableState for inheritance to account for Duplex streams,
// whose prototype chain only points to Readable.
var realHasInstance;
if (typeof Symbol === 'function' && Symbol.hasInstance && typeof Function.prototype[Symbol.hasInstance] === 'function') {
  realHasInstance = Function.prototype[Symbol.hasInstance];
  Object.defineProperty(Writable, Symbol.hasInstance, {
    value: function (object) {
      if (realHasInstance.call(this, object)) return true;
      if (this !== Writable) return false;

      return object && object._writableState instanceof WritableState;
    }
  });
} else {
  realHasInstance = function (object) {
    return object instanceof this;
  };
}

function Writable(options) {
  Duplex = Duplex || __webpack_require__(/*! ./_stream_duplex */ "./node_modules/readable-stream/lib/_stream_duplex.js");

  // Writable ctor is applied to Duplexes, too.
  // `realHasInstance` is necessary because using plain `instanceof`
  // would return false, as no `_writableState` property is attached.

  // Trying to use the custom `instanceof` for Writable here will also break the
  // Node.js LazyTransform implementation, which has a non-trivial getter for
  // `_writableState` that would lead to infinite recursion.
  if (!realHasInstance.call(Writable, this) && !(this instanceof Duplex)) {
    return new Writable(options);
  }

  this._writableState = new WritableState(options, this);

  // legacy.
  this.writable = true;

  if (options) {
    if (typeof options.write === 'function') this._write = options.write;

    if (typeof options.writev === 'function') this._writev = options.writev;

    if (typeof options.destroy === 'function') this._destroy = options.destroy;

    if (typeof options.final === 'function') this._final = options.final;
  }

  Stream.call(this);
}

// Otherwise people can pipe Writable streams, which is just wrong.
Writable.prototype.pipe = function () {
  this.emit('error', new Error('Cannot pipe, not readable'));
};

function writeAfterEnd(stream, cb) {
  var er = new Error('write after end');
  // TODO: defer error events consistently everywhere, not just the cb
  stream.emit('error', er);
  pna.nextTick(cb, er);
}

// Checks that a user-supplied chunk is valid, especially for the particular
// mode the stream is in. Currently this means that `null` is never accepted
// and undefined/non-string values are only allowed in object mode.
function validChunk(stream, state, chunk, cb) {
  var valid = true;
  var er = false;

  if (chunk === null) {
    er = new TypeError('May not write null values to stream');
  } else if (typeof chunk !== 'string' && chunk !== undefined && !state.objectMode) {
    er = new TypeError('Invalid non-string/buffer chunk');
  }
  if (er) {
    stream.emit('error', er);
    pna.nextTick(cb, er);
    valid = false;
  }
  return valid;
}

Writable.prototype.write = function (chunk, encoding, cb) {
  var state = this._writableState;
  var ret = false;
  var isBuf = !state.objectMode && _isUint8Array(chunk);

  if (isBuf && !Buffer.isBuffer(chunk)) {
    chunk = _uint8ArrayToBuffer(chunk);
  }

  if (typeof encoding === 'function') {
    cb = encoding;
    encoding = null;
  }

  if (isBuf) encoding = 'buffer';else if (!encoding) encoding = state.defaultEncoding;

  if (typeof cb !== 'function') cb = nop;

  if (state.ended) writeAfterEnd(this, cb);else if (isBuf || validChunk(this, state, chunk, cb)) {
    state.pendingcb++;
    ret = writeOrBuffer(this, state, isBuf, chunk, encoding, cb);
  }

  return ret;
};

Writable.prototype.cork = function () {
  var state = this._writableState;

  state.corked++;
};

Writable.prototype.uncork = function () {
  var state = this._writableState;

  if (state.corked) {
    state.corked--;

    if (!state.writing && !state.corked && !state.finished && !state.bufferProcessing && state.bufferedRequest) clearBuffer(this, state);
  }
};

Writable.prototype.setDefaultEncoding = function setDefaultEncoding(encoding) {
  // node::ParseEncoding() requires lower case.
  if (typeof encoding === 'string') encoding = encoding.toLowerCase();
  if (!(['hex', 'utf8', 'utf-8', 'ascii', 'binary', 'base64', 'ucs2', 'ucs-2', 'utf16le', 'utf-16le', 'raw'].indexOf((encoding + '').toLowerCase()) > -1)) throw new TypeError('Unknown encoding: ' + encoding);
  this._writableState.defaultEncoding = encoding;
  return this;
};

function decodeChunk(state, chunk, encoding) {
  if (!state.objectMode && state.decodeStrings !== false && typeof chunk === 'string') {
    chunk = Buffer.from(chunk, encoding);
  }
  return chunk;
}

Object.defineProperty(Writable.prototype, 'writableHighWaterMark', {
  // making it explicit this property is not enumerable
  // because otherwise some prototype manipulation in
  // userland will fail
  enumerable: false,
  get: function () {
    return this._writableState.highWaterMark;
  }
});

// if we're already writing something, then just put this
// in the queue, and wait our turn.  Otherwise, call _write
// If we return false, then we need a drain event, so set that flag.
function writeOrBuffer(stream, state, isBuf, chunk, encoding, cb) {
  if (!isBuf) {
    var newChunk = decodeChunk(state, chunk, encoding);
    if (chunk !== newChunk) {
      isBuf = true;
      encoding = 'buffer';
      chunk = newChunk;
    }
  }
  var len = state.objectMode ? 1 : chunk.length;

  state.length += len;

  var ret = state.length < state.highWaterMark;
  // we must ensure that previous needDrain will not be reset to false.
  if (!ret) state.needDrain = true;

  if (state.writing || state.corked) {
    var last = state.lastBufferedRequest;
    state.lastBufferedRequest = {
      chunk: chunk,
      encoding: encoding,
      isBuf: isBuf,
      callback: cb,
      next: null
    };
    if (last) {
      last.next = state.lastBufferedRequest;
    } else {
      state.bufferedRequest = state.lastBufferedRequest;
    }
    state.bufferedRequestCount += 1;
  } else {
    doWrite(stream, state, false, len, chunk, encoding, cb);
  }

  return ret;
}

function doWrite(stream, state, writev, len, chunk, encoding, cb) {
  state.writelen = len;
  state.writecb = cb;
  state.writing = true;
  state.sync = true;
  if (writev) stream._writev(chunk, state.onwrite);else stream._write(chunk, encoding, state.onwrite);
  state.sync = false;
}

function onwriteError(stream, state, sync, er, cb) {
  --state.pendingcb;

  if (sync) {
    // defer the callback if we are being called synchronously
    // to avoid piling up things on the stack
    pna.nextTick(cb, er);
    // this can emit finish, and it will always happen
    // after error
    pna.nextTick(finishMaybe, stream, state);
    stream._writableState.errorEmitted = true;
    stream.emit('error', er);
  } else {
    // the caller expect this to happen before if
    // it is async
    cb(er);
    stream._writableState.errorEmitted = true;
    stream.emit('error', er);
    // this can emit finish, but finish must
    // always follow error
    finishMaybe(stream, state);
  }
}

function onwriteStateUpdate(state) {
  state.writing = false;
  state.writecb = null;
  state.length -= state.writelen;
  state.writelen = 0;
}

function onwrite(stream, er) {
  var state = stream._writableState;
  var sync = state.sync;
  var cb = state.writecb;

  onwriteStateUpdate(state);

  if (er) onwriteError(stream, state, sync, er, cb);else {
    // Check if we're actually ready to finish, but don't emit yet
    var finished = needFinish(state);

    if (!finished && !state.corked && !state.bufferProcessing && state.bufferedRequest) {
      clearBuffer(stream, state);
    }

    if (sync) {
      /*<replacement>*/
      asyncWrite(afterWrite, stream, state, finished, cb);
      /*</replacement>*/
    } else {
      afterWrite(stream, state, finished, cb);
    }
  }
}

function afterWrite(stream, state, finished, cb) {
  if (!finished) onwriteDrain(stream, state);
  state.pendingcb--;
  cb();
  finishMaybe(stream, state);
}

// Must force callback to be called on nextTick, so that we don't
// emit 'drain' before the write() consumer gets the 'false' return
// value, and has a chance to attach a 'drain' listener.
function onwriteDrain(stream, state) {
  if (state.length === 0 && state.needDrain) {
    state.needDrain = false;
    stream.emit('drain');
  }
}

// if there's something in the buffer waiting, then process it
function clearBuffer(stream, state) {
  state.bufferProcessing = true;
  var entry = state.bufferedRequest;

  if (stream._writev && entry && entry.next) {
    // Fast case, write everything using _writev()
    var l = state.bufferedRequestCount;
    var buffer = new Array(l);
    var holder = state.corkedRequestsFree;
    holder.entry = entry;

    var count = 0;
    var allBuffers = true;
    while (entry) {
      buffer[count] = entry;
      if (!entry.isBuf) allBuffers = false;
      entry = entry.next;
      count += 1;
    }
    buffer.allBuffers = allBuffers;

    doWrite(stream, state, true, state.length, buffer, '', holder.finish);

    // doWrite is almost always async, defer these to save a bit of time
    // as the hot path ends with doWrite
    state.pendingcb++;
    state.lastBufferedRequest = null;
    if (holder.next) {
      state.corkedRequestsFree = holder.next;
      holder.next = null;
    } else {
      state.corkedRequestsFree = new CorkedRequest(state);
    }
    state.bufferedRequestCount = 0;
  } else {
    // Slow case, write chunks one-by-one
    while (entry) {
      var chunk = entry.chunk;
      var encoding = entry.encoding;
      var cb = entry.callback;
      var len = state.objectMode ? 1 : chunk.length;

      doWrite(stream, state, false, len, chunk, encoding, cb);
      entry = entry.next;
      state.bufferedRequestCount--;
      // if we didn't call the onwrite immediately, then
      // it means that we need to wait until it does.
      // also, that means that the chunk and cb are currently
      // being processed, so move the buffer counter past them.
      if (state.writing) {
        break;
      }
    }

    if (entry === null) state.lastBufferedRequest = null;
  }

  state.bufferedRequest = entry;
  state.bufferProcessing = false;
}

Writable.prototype._write = function (chunk, encoding, cb) {
  cb(new Error('_write() is not implemented'));
};

Writable.prototype._writev = null;

Writable.prototype.end = function (chunk, encoding, cb) {
  var state = this._writableState;

  if (typeof chunk === 'function') {
    cb = chunk;
    chunk = null;
    encoding = null;
  } else if (typeof encoding === 'function') {
    cb = encoding;
    encoding = null;
  }

  if (chunk !== null && chunk !== undefined) this.write(chunk, encoding);

  // .end() fully uncorks
  if (state.corked) {
    state.corked = 1;
    this.uncork();
  }

  // ignore unnecessary end() calls.
  if (!state.ending && !state.finished) endWritable(this, state, cb);
};

function needFinish(state) {
  return state.ending && state.length === 0 && state.bufferedRequest === null && !state.finished && !state.writing;
}
function callFinal(stream, state) {
  stream._final(function (err) {
    state.pendingcb--;
    if (err) {
      stream.emit('error', err);
    }
    state.prefinished = true;
    stream.emit('prefinish');
    finishMaybe(stream, state);
  });
}
function prefinish(stream, state) {
  if (!state.prefinished && !state.finalCalled) {
    if (typeof stream._final === 'function') {
      state.pendingcb++;
      state.finalCalled = true;
      pna.nextTick(callFinal, stream, state);
    } else {
      state.prefinished = true;
      stream.emit('prefinish');
    }
  }
}

function finishMaybe(stream, state) {
  var need = needFinish(state);
  if (need) {
    prefinish(stream, state);
    if (state.pendingcb === 0) {
      state.finished = true;
      stream.emit('finish');
    }
  }
  return need;
}

function endWritable(stream, state, cb) {
  state.ending = true;
  finishMaybe(stream, state);
  if (cb) {
    if (state.finished) pna.nextTick(cb);else stream.once('finish', cb);
  }
  state.ended = true;
  stream.writable = false;
}

function onCorkedFinish(corkReq, state, err) {
  var entry = corkReq.entry;
  corkReq.entry = null;
  while (entry) {
    var cb = entry.callback;
    state.pendingcb--;
    cb(err);
    entry = entry.next;
  }
  if (state.corkedRequestsFree) {
    state.corkedRequestsFree.next = corkReq;
  } else {
    state.corkedRequestsFree = corkReq;
  }
}

Object.defineProperty(Writable.prototype, 'destroyed', {
  get: function () {
    if (this._writableState === undefined) {
      return false;
    }
    return this._writableState.destroyed;
  },
  set: function (value) {
    // we ignore the value if the stream
    // has not been initialized yet
    if (!this._writableState) {
      return;
    }

    // backward compatibility, the user is explicitly
    // managing destroyed
    this._writableState.destroyed = value;
  }
});

Writable.prototype.destroy = destroyImpl.destroy;
Writable.prototype._undestroy = destroyImpl.undestroy;
Writable.prototype._destroy = function (err, cb) {
  this.end();
  cb(err);
};
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(/*! ./../../process/browser.js */ "./node_modules/process/browser.js"), __webpack_require__(/*! ./../../timers-browserify/main.js */ "./node_modules/timers-browserify/main.js").setImmediate, __webpack_require__(/*! ./../../webpack/buildin/global.js */ "./node_modules/webpack/buildin/global.js")))

/***/ }),

/***/ "./node_modules/readable-stream/lib/internal/streams/BufferList.js":
/*!*************************************************************************!*\
  !*** ./node_modules/readable-stream/lib/internal/streams/BufferList.js ***!
  \*************************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Buffer = __webpack_require__(/*! safe-buffer */ "./node_modules/safe-buffer/index.js").Buffer;
var util = __webpack_require__(/*! util */ 3);

function copyBuffer(src, target, offset) {
  src.copy(target, offset);
}

module.exports = function () {
  function BufferList() {
    _classCallCheck(this, BufferList);

    this.head = null;
    this.tail = null;
    this.length = 0;
  }

  BufferList.prototype.push = function push(v) {
    var entry = { data: v, next: null };
    if (this.length > 0) this.tail.next = entry;else this.head = entry;
    this.tail = entry;
    ++this.length;
  };

  BufferList.prototype.unshift = function unshift(v) {
    var entry = { data: v, next: this.head };
    if (this.length === 0) this.tail = entry;
    this.head = entry;
    ++this.length;
  };

  BufferList.prototype.shift = function shift() {
    if (this.length === 0) return;
    var ret = this.head.data;
    if (this.length === 1) this.head = this.tail = null;else this.head = this.head.next;
    --this.length;
    return ret;
  };

  BufferList.prototype.clear = function clear() {
    this.head = this.tail = null;
    this.length = 0;
  };

  BufferList.prototype.join = function join(s) {
    if (this.length === 0) return '';
    var p = this.head;
    var ret = '' + p.data;
    while (p = p.next) {
      ret += s + p.data;
    }return ret;
  };

  BufferList.prototype.concat = function concat(n) {
    if (this.length === 0) return Buffer.alloc(0);
    if (this.length === 1) return this.head.data;
    var ret = Buffer.allocUnsafe(n >>> 0);
    var p = this.head;
    var i = 0;
    while (p) {
      copyBuffer(p.data, ret, i);
      i += p.data.length;
      p = p.next;
    }
    return ret;
  };

  return BufferList;
}();

if (util && util.inspect && util.inspect.custom) {
  module.exports.prototype[util.inspect.custom] = function () {
    var obj = util.inspect({ length: this.length });
    return this.constructor.name + ' ' + obj;
  };
}

/***/ }),

/***/ "./node_modules/readable-stream/lib/internal/streams/destroy.js":
/*!**********************************************************************!*\
  !*** ./node_modules/readable-stream/lib/internal/streams/destroy.js ***!
  \**********************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/*<replacement>*/

var pna = __webpack_require__(/*! process-nextick-args */ "./node_modules/process-nextick-args/index.js");
/*</replacement>*/

// undocumented cb() API, needed for core, not for public API
function destroy(err, cb) {
  var _this = this;

  var readableDestroyed = this._readableState && this._readableState.destroyed;
  var writableDestroyed = this._writableState && this._writableState.destroyed;

  if (readableDestroyed || writableDestroyed) {
    if (cb) {
      cb(err);
    } else if (err && (!this._writableState || !this._writableState.errorEmitted)) {
      pna.nextTick(emitErrorNT, this, err);
    }
    return this;
  }

  // we set destroyed to true before firing error callbacks in order
  // to make it re-entrance safe in case destroy() is called within callbacks

  if (this._readableState) {
    this._readableState.destroyed = true;
  }

  // if this is a duplex stream mark the writable part as destroyed as well
  if (this._writableState) {
    this._writableState.destroyed = true;
  }

  this._destroy(err || null, function (err) {
    if (!cb && err) {
      pna.nextTick(emitErrorNT, _this, err);
      if (_this._writableState) {
        _this._writableState.errorEmitted = true;
      }
    } else if (cb) {
      cb(err);
    }
  });

  return this;
}

function undestroy() {
  if (this._readableState) {
    this._readableState.destroyed = false;
    this._readableState.reading = false;
    this._readableState.ended = false;
    this._readableState.endEmitted = false;
  }

  if (this._writableState) {
    this._writableState.destroyed = false;
    this._writableState.ended = false;
    this._writableState.ending = false;
    this._writableState.finished = false;
    this._writableState.errorEmitted = false;
  }
}

function emitErrorNT(self, err) {
  self.emit('error', err);
}

module.exports = {
  destroy: destroy,
  undestroy: undestroy
};

/***/ }),

/***/ "./node_modules/readable-stream/lib/internal/streams/stream-browser.js":
/*!*****************************************************************************!*\
  !*** ./node_modules/readable-stream/lib/internal/streams/stream-browser.js ***!
  \*****************************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(/*! events */ "./node_modules/events/events.js").EventEmitter;


/***/ }),

/***/ "./node_modules/readable-stream/passthrough.js":
/*!*****************************************************!*\
  !*** ./node_modules/readable-stream/passthrough.js ***!
  \*****************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(/*! ./readable */ "./node_modules/readable-stream/readable-browser.js").PassThrough


/***/ }),

/***/ "./node_modules/readable-stream/readable-browser.js":
/*!**********************************************************!*\
  !*** ./node_modules/readable-stream/readable-browser.js ***!
  \**********************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(/*! ./lib/_stream_readable.js */ "./node_modules/readable-stream/lib/_stream_readable.js");
exports.Stream = exports;
exports.Readable = exports;
exports.Writable = __webpack_require__(/*! ./lib/_stream_writable.js */ "./node_modules/readable-stream/lib/_stream_writable.js");
exports.Duplex = __webpack_require__(/*! ./lib/_stream_duplex.js */ "./node_modules/readable-stream/lib/_stream_duplex.js");
exports.Transform = __webpack_require__(/*! ./lib/_stream_transform.js */ "./node_modules/readable-stream/lib/_stream_transform.js");
exports.PassThrough = __webpack_require__(/*! ./lib/_stream_passthrough.js */ "./node_modules/readable-stream/lib/_stream_passthrough.js");


/***/ }),

/***/ "./node_modules/readable-stream/transform.js":
/*!***************************************************!*\
  !*** ./node_modules/readable-stream/transform.js ***!
  \***************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(/*! ./readable */ "./node_modules/readable-stream/readable-browser.js").Transform


/***/ }),

/***/ "./node_modules/readable-stream/writable-browser.js":
/*!**********************************************************!*\
  !*** ./node_modules/readable-stream/writable-browser.js ***!
  \**********************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(/*! ./lib/_stream_writable.js */ "./node_modules/readable-stream/lib/_stream_writable.js");


/***/ }),

/***/ "./node_modules/ripemd160/index.js":
/*!*****************************************!*\
  !*** ./node_modules/ripemd160/index.js ***!
  \*****************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Buffer = __webpack_require__(/*! buffer */ "./node_modules/node-libs-browser/node_modules/buffer/index.js").Buffer
var inherits = __webpack_require__(/*! inherits */ "./node_modules/inherits/inherits_browser.js")
var HashBase = __webpack_require__(/*! hash-base */ "./node_modules/hash-base/index.js")

var ARRAY16 = new Array(16)

var zl = [
  0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15,
  7, 4, 13, 1, 10, 6, 15, 3, 12, 0, 9, 5, 2, 14, 11, 8,
  3, 10, 14, 4, 9, 15, 8, 1, 2, 7, 0, 6, 13, 11, 5, 12,
  1, 9, 11, 10, 0, 8, 12, 4, 13, 3, 7, 15, 14, 5, 6, 2,
  4, 0, 5, 9, 7, 12, 2, 10, 14, 1, 3, 8, 11, 6, 15, 13
]

var zr = [
  5, 14, 7, 0, 9, 2, 11, 4, 13, 6, 15, 8, 1, 10, 3, 12,
  6, 11, 3, 7, 0, 13, 5, 10, 14, 15, 8, 12, 4, 9, 1, 2,
  15, 5, 1, 3, 7, 14, 6, 9, 11, 8, 12, 2, 10, 0, 4, 13,
  8, 6, 4, 1, 3, 11, 15, 0, 5, 12, 2, 13, 9, 7, 10, 14,
  12, 15, 10, 4, 1, 5, 8, 7, 6, 2, 13, 14, 0, 3, 9, 11
]

var sl = [
  11, 14, 15, 12, 5, 8, 7, 9, 11, 13, 14, 15, 6, 7, 9, 8,
  7, 6, 8, 13, 11, 9, 7, 15, 7, 12, 15, 9, 11, 7, 13, 12,
  11, 13, 6, 7, 14, 9, 13, 15, 14, 8, 13, 6, 5, 12, 7, 5,
  11, 12, 14, 15, 14, 15, 9, 8, 9, 14, 5, 6, 8, 6, 5, 12,
  9, 15, 5, 11, 6, 8, 13, 12, 5, 12, 13, 14, 11, 8, 5, 6
]

var sr = [
  8, 9, 9, 11, 13, 15, 15, 5, 7, 7, 8, 11, 14, 14, 12, 6,
  9, 13, 15, 7, 12, 8, 9, 11, 7, 7, 12, 7, 6, 15, 13, 11,
  9, 7, 15, 11, 8, 6, 6, 14, 12, 13, 5, 14, 13, 13, 7, 5,
  15, 5, 8, 11, 14, 14, 6, 14, 6, 9, 12, 9, 12, 5, 15, 8,
  8, 5, 12, 9, 12, 5, 14, 6, 8, 13, 6, 5, 15, 13, 11, 11
]

var hl = [0x00000000, 0x5a827999, 0x6ed9eba1, 0x8f1bbcdc, 0xa953fd4e]
var hr = [0x50a28be6, 0x5c4dd124, 0x6d703ef3, 0x7a6d76e9, 0x00000000]

function RIPEMD160 () {
  HashBase.call(this, 64)

  // state
  this._a = 0x67452301
  this._b = 0xefcdab89
  this._c = 0x98badcfe
  this._d = 0x10325476
  this._e = 0xc3d2e1f0
}

inherits(RIPEMD160, HashBase)

RIPEMD160.prototype._update = function () {
  var words = ARRAY16
  for (var j = 0; j < 16; ++j) words[j] = this._block.readInt32LE(j * 4)

  var al = this._a | 0
  var bl = this._b | 0
  var cl = this._c | 0
  var dl = this._d | 0
  var el = this._e | 0

  var ar = this._a | 0
  var br = this._b | 0
  var cr = this._c | 0
  var dr = this._d | 0
  var er = this._e | 0

  // computation
  for (var i = 0; i < 80; i += 1) {
    var tl
    var tr
    if (i < 16) {
      tl = fn1(al, bl, cl, dl, el, words[zl[i]], hl[0], sl[i])
      tr = fn5(ar, br, cr, dr, er, words[zr[i]], hr[0], sr[i])
    } else if (i < 32) {
      tl = fn2(al, bl, cl, dl, el, words[zl[i]], hl[1], sl[i])
      tr = fn4(ar, br, cr, dr, er, words[zr[i]], hr[1], sr[i])
    } else if (i < 48) {
      tl = fn3(al, bl, cl, dl, el, words[zl[i]], hl[2], sl[i])
      tr = fn3(ar, br, cr, dr, er, words[zr[i]], hr[2], sr[i])
    } else if (i < 64) {
      tl = fn4(al, bl, cl, dl, el, words[zl[i]], hl[3], sl[i])
      tr = fn2(ar, br, cr, dr, er, words[zr[i]], hr[3], sr[i])
    } else { // if (i<80) {
      tl = fn5(al, bl, cl, dl, el, words[zl[i]], hl[4], sl[i])
      tr = fn1(ar, br, cr, dr, er, words[zr[i]], hr[4], sr[i])
    }

    al = el
    el = dl
    dl = rotl(cl, 10)
    cl = bl
    bl = tl

    ar = er
    er = dr
    dr = rotl(cr, 10)
    cr = br
    br = tr
  }

  // update state
  var t = (this._b + cl + dr) | 0
  this._b = (this._c + dl + er) | 0
  this._c = (this._d + el + ar) | 0
  this._d = (this._e + al + br) | 0
  this._e = (this._a + bl + cr) | 0
  this._a = t
}

RIPEMD160.prototype._digest = function () {
  // create padding and handle blocks
  this._block[this._blockOffset++] = 0x80
  if (this._blockOffset > 56) {
    this._block.fill(0, this._blockOffset, 64)
    this._update()
    this._blockOffset = 0
  }

  this._block.fill(0, this._blockOffset, 56)
  this._block.writeUInt32LE(this._length[0], 56)
  this._block.writeUInt32LE(this._length[1], 60)
  this._update()

  // produce result
  var buffer = Buffer.alloc ? Buffer.alloc(20) : new Buffer(20)
  buffer.writeInt32LE(this._a, 0)
  buffer.writeInt32LE(this._b, 4)
  buffer.writeInt32LE(this._c, 8)
  buffer.writeInt32LE(this._d, 12)
  buffer.writeInt32LE(this._e, 16)
  return buffer
}

function rotl (x, n) {
  return (x << n) | (x >>> (32 - n))
}

function fn1 (a, b, c, d, e, m, k, s) {
  return (rotl((a + (b ^ c ^ d) + m + k) | 0, s) + e) | 0
}

function fn2 (a, b, c, d, e, m, k, s) {
  return (rotl((a + ((b & c) | ((~b) & d)) + m + k) | 0, s) + e) | 0
}

function fn3 (a, b, c, d, e, m, k, s) {
  return (rotl((a + ((b | (~c)) ^ d) + m + k) | 0, s) + e) | 0
}

function fn4 (a, b, c, d, e, m, k, s) {
  return (rotl((a + ((b & d) | (c & (~d))) + m + k) | 0, s) + e) | 0
}

function fn5 (a, b, c, d, e, m, k, s) {
  return (rotl((a + (b ^ (c | (~d))) + m + k) | 0, s) + e) | 0
}

module.exports = RIPEMD160


/***/ }),

/***/ "./node_modules/rxjs/_esm5/index.js":
/*!******************************************!*\
  !*** ./node_modules/rxjs/_esm5/index.js ***!
  \******************************************/
/*! exports provided: Observable, ConnectableObservable, GroupedObservable, observable, Subject, BehaviorSubject, ReplaySubject, AsyncSubject, asap, asapScheduler, async, asyncScheduler, queue, queueScheduler, animationFrame, animationFrameScheduler, VirtualTimeScheduler, VirtualAction, Scheduler, Subscription, Subscriber, Notification, NotificationKind, pipe, noop, identity, isObservable, ArgumentOutOfRangeError, EmptyError, ObjectUnsubscribedError, UnsubscriptionError, TimeoutError, bindCallback, bindNodeCallback, combineLatest, concat, defer, empty, forkJoin, from, fromEvent, fromEventPattern, generate, iif, interval, merge, never, of, onErrorResumeNext, pairs, partition, race, range, throwError, timer, using, zip, scheduled, EMPTY, NEVER, config */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _internal_Observable__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./internal/Observable */ "./node_modules/rxjs/_esm5/internal/Observable.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Observable", function() { return _internal_Observable__WEBPACK_IMPORTED_MODULE_0__["Observable"]; });

/* harmony import */ var _internal_observable_ConnectableObservable__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./internal/observable/ConnectableObservable */ "./node_modules/rxjs/_esm5/internal/observable/ConnectableObservable.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ConnectableObservable", function() { return _internal_observable_ConnectableObservable__WEBPACK_IMPORTED_MODULE_1__["ConnectableObservable"]; });

/* harmony import */ var _internal_operators_groupBy__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./internal/operators/groupBy */ "./node_modules/rxjs/_esm5/internal/operators/groupBy.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "GroupedObservable", function() { return _internal_operators_groupBy__WEBPACK_IMPORTED_MODULE_2__["GroupedObservable"]; });

/* harmony import */ var _internal_symbol_observable__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./internal/symbol/observable */ "./node_modules/rxjs/_esm5/internal/symbol/observable.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "observable", function() { return _internal_symbol_observable__WEBPACK_IMPORTED_MODULE_3__["observable"]; });

/* harmony import */ var _internal_Subject__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./internal/Subject */ "./node_modules/rxjs/_esm5/internal/Subject.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Subject", function() { return _internal_Subject__WEBPACK_IMPORTED_MODULE_4__["Subject"]; });

/* harmony import */ var _internal_BehaviorSubject__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./internal/BehaviorSubject */ "./node_modules/rxjs/_esm5/internal/BehaviorSubject.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "BehaviorSubject", function() { return _internal_BehaviorSubject__WEBPACK_IMPORTED_MODULE_5__["BehaviorSubject"]; });

/* harmony import */ var _internal_ReplaySubject__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ./internal/ReplaySubject */ "./node_modules/rxjs/_esm5/internal/ReplaySubject.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ReplaySubject", function() { return _internal_ReplaySubject__WEBPACK_IMPORTED_MODULE_6__["ReplaySubject"]; });

/* harmony import */ var _internal_AsyncSubject__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ./internal/AsyncSubject */ "./node_modules/rxjs/_esm5/internal/AsyncSubject.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "AsyncSubject", function() { return _internal_AsyncSubject__WEBPACK_IMPORTED_MODULE_7__["AsyncSubject"]; });

/* harmony import */ var _internal_scheduler_asap__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ./internal/scheduler/asap */ "./node_modules/rxjs/_esm5/internal/scheduler/asap.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "asap", function() { return _internal_scheduler_asap__WEBPACK_IMPORTED_MODULE_8__["asap"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "asapScheduler", function() { return _internal_scheduler_asap__WEBPACK_IMPORTED_MODULE_8__["asapScheduler"]; });

/* harmony import */ var _internal_scheduler_async__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ./internal/scheduler/async */ "./node_modules/rxjs/_esm5/internal/scheduler/async.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "async", function() { return _internal_scheduler_async__WEBPACK_IMPORTED_MODULE_9__["async"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "asyncScheduler", function() { return _internal_scheduler_async__WEBPACK_IMPORTED_MODULE_9__["asyncScheduler"]; });

/* harmony import */ var _internal_scheduler_queue__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ./internal/scheduler/queue */ "./node_modules/rxjs/_esm5/internal/scheduler/queue.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "queue", function() { return _internal_scheduler_queue__WEBPACK_IMPORTED_MODULE_10__["queue"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "queueScheduler", function() { return _internal_scheduler_queue__WEBPACK_IMPORTED_MODULE_10__["queueScheduler"]; });

/* harmony import */ var _internal_scheduler_animationFrame__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ./internal/scheduler/animationFrame */ "./node_modules/rxjs/_esm5/internal/scheduler/animationFrame.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "animationFrame", function() { return _internal_scheduler_animationFrame__WEBPACK_IMPORTED_MODULE_11__["animationFrame"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "animationFrameScheduler", function() { return _internal_scheduler_animationFrame__WEBPACK_IMPORTED_MODULE_11__["animationFrameScheduler"]; });

/* harmony import */ var _internal_scheduler_VirtualTimeScheduler__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! ./internal/scheduler/VirtualTimeScheduler */ "./node_modules/rxjs/_esm5/internal/scheduler/VirtualTimeScheduler.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "VirtualTimeScheduler", function() { return _internal_scheduler_VirtualTimeScheduler__WEBPACK_IMPORTED_MODULE_12__["VirtualTimeScheduler"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "VirtualAction", function() { return _internal_scheduler_VirtualTimeScheduler__WEBPACK_IMPORTED_MODULE_12__["VirtualAction"]; });

/* harmony import */ var _internal_Scheduler__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! ./internal/Scheduler */ "./node_modules/rxjs/_esm5/internal/Scheduler.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Scheduler", function() { return _internal_Scheduler__WEBPACK_IMPORTED_MODULE_13__["Scheduler"]; });

/* harmony import */ var _internal_Subscription__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! ./internal/Subscription */ "./node_modules/rxjs/_esm5/internal/Subscription.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Subscription", function() { return _internal_Subscription__WEBPACK_IMPORTED_MODULE_14__["Subscription"]; });

/* harmony import */ var _internal_Subscriber__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! ./internal/Subscriber */ "./node_modules/rxjs/_esm5/internal/Subscriber.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Subscriber", function() { return _internal_Subscriber__WEBPACK_IMPORTED_MODULE_15__["Subscriber"]; });

/* harmony import */ var _internal_Notification__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(/*! ./internal/Notification */ "./node_modules/rxjs/_esm5/internal/Notification.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Notification", function() { return _internal_Notification__WEBPACK_IMPORTED_MODULE_16__["Notification"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "NotificationKind", function() { return _internal_Notification__WEBPACK_IMPORTED_MODULE_16__["NotificationKind"]; });

/* harmony import */ var _internal_util_pipe__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(/*! ./internal/util/pipe */ "./node_modules/rxjs/_esm5/internal/util/pipe.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "pipe", function() { return _internal_util_pipe__WEBPACK_IMPORTED_MODULE_17__["pipe"]; });

/* harmony import */ var _internal_util_noop__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(/*! ./internal/util/noop */ "./node_modules/rxjs/_esm5/internal/util/noop.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "noop", function() { return _internal_util_noop__WEBPACK_IMPORTED_MODULE_18__["noop"]; });

/* harmony import */ var _internal_util_identity__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(/*! ./internal/util/identity */ "./node_modules/rxjs/_esm5/internal/util/identity.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "identity", function() { return _internal_util_identity__WEBPACK_IMPORTED_MODULE_19__["identity"]; });

/* harmony import */ var _internal_util_isObservable__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(/*! ./internal/util/isObservable */ "./node_modules/rxjs/_esm5/internal/util/isObservable.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "isObservable", function() { return _internal_util_isObservable__WEBPACK_IMPORTED_MODULE_20__["isObservable"]; });

/* harmony import */ var _internal_util_ArgumentOutOfRangeError__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(/*! ./internal/util/ArgumentOutOfRangeError */ "./node_modules/rxjs/_esm5/internal/util/ArgumentOutOfRangeError.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ArgumentOutOfRangeError", function() { return _internal_util_ArgumentOutOfRangeError__WEBPACK_IMPORTED_MODULE_21__["ArgumentOutOfRangeError"]; });

/* harmony import */ var _internal_util_EmptyError__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(/*! ./internal/util/EmptyError */ "./node_modules/rxjs/_esm5/internal/util/EmptyError.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "EmptyError", function() { return _internal_util_EmptyError__WEBPACK_IMPORTED_MODULE_22__["EmptyError"]; });

/* harmony import */ var _internal_util_ObjectUnsubscribedError__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(/*! ./internal/util/ObjectUnsubscribedError */ "./node_modules/rxjs/_esm5/internal/util/ObjectUnsubscribedError.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ObjectUnsubscribedError", function() { return _internal_util_ObjectUnsubscribedError__WEBPACK_IMPORTED_MODULE_23__["ObjectUnsubscribedError"]; });

/* harmony import */ var _internal_util_UnsubscriptionError__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(/*! ./internal/util/UnsubscriptionError */ "./node_modules/rxjs/_esm5/internal/util/UnsubscriptionError.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "UnsubscriptionError", function() { return _internal_util_UnsubscriptionError__WEBPACK_IMPORTED_MODULE_24__["UnsubscriptionError"]; });

/* harmony import */ var _internal_util_TimeoutError__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__(/*! ./internal/util/TimeoutError */ "./node_modules/rxjs/_esm5/internal/util/TimeoutError.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "TimeoutError", function() { return _internal_util_TimeoutError__WEBPACK_IMPORTED_MODULE_25__["TimeoutError"]; });

/* harmony import */ var _internal_observable_bindCallback__WEBPACK_IMPORTED_MODULE_26__ = __webpack_require__(/*! ./internal/observable/bindCallback */ "./node_modules/rxjs/_esm5/internal/observable/bindCallback.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "bindCallback", function() { return _internal_observable_bindCallback__WEBPACK_IMPORTED_MODULE_26__["bindCallback"]; });

/* harmony import */ var _internal_observable_bindNodeCallback__WEBPACK_IMPORTED_MODULE_27__ = __webpack_require__(/*! ./internal/observable/bindNodeCallback */ "./node_modules/rxjs/_esm5/internal/observable/bindNodeCallback.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "bindNodeCallback", function() { return _internal_observable_bindNodeCallback__WEBPACK_IMPORTED_MODULE_27__["bindNodeCallback"]; });

/* harmony import */ var _internal_observable_combineLatest__WEBPACK_IMPORTED_MODULE_28__ = __webpack_require__(/*! ./internal/observable/combineLatest */ "./node_modules/rxjs/_esm5/internal/observable/combineLatest.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "combineLatest", function() { return _internal_observable_combineLatest__WEBPACK_IMPORTED_MODULE_28__["combineLatest"]; });

/* harmony import */ var _internal_observable_concat__WEBPACK_IMPORTED_MODULE_29__ = __webpack_require__(/*! ./internal/observable/concat */ "./node_modules/rxjs/_esm5/internal/observable/concat.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "concat", function() { return _internal_observable_concat__WEBPACK_IMPORTED_MODULE_29__["concat"]; });

/* harmony import */ var _internal_observable_defer__WEBPACK_IMPORTED_MODULE_30__ = __webpack_require__(/*! ./internal/observable/defer */ "./node_modules/rxjs/_esm5/internal/observable/defer.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "defer", function() { return _internal_observable_defer__WEBPACK_IMPORTED_MODULE_30__["defer"]; });

/* harmony import */ var _internal_observable_empty__WEBPACK_IMPORTED_MODULE_31__ = __webpack_require__(/*! ./internal/observable/empty */ "./node_modules/rxjs/_esm5/internal/observable/empty.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "empty", function() { return _internal_observable_empty__WEBPACK_IMPORTED_MODULE_31__["empty"]; });

/* harmony import */ var _internal_observable_forkJoin__WEBPACK_IMPORTED_MODULE_32__ = __webpack_require__(/*! ./internal/observable/forkJoin */ "./node_modules/rxjs/_esm5/internal/observable/forkJoin.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "forkJoin", function() { return _internal_observable_forkJoin__WEBPACK_IMPORTED_MODULE_32__["forkJoin"]; });

/* harmony import */ var _internal_observable_from__WEBPACK_IMPORTED_MODULE_33__ = __webpack_require__(/*! ./internal/observable/from */ "./node_modules/rxjs/_esm5/internal/observable/from.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "from", function() { return _internal_observable_from__WEBPACK_IMPORTED_MODULE_33__["from"]; });

/* harmony import */ var _internal_observable_fromEvent__WEBPACK_IMPORTED_MODULE_34__ = __webpack_require__(/*! ./internal/observable/fromEvent */ "./node_modules/rxjs/_esm5/internal/observable/fromEvent.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "fromEvent", function() { return _internal_observable_fromEvent__WEBPACK_IMPORTED_MODULE_34__["fromEvent"]; });

/* harmony import */ var _internal_observable_fromEventPattern__WEBPACK_IMPORTED_MODULE_35__ = __webpack_require__(/*! ./internal/observable/fromEventPattern */ "./node_modules/rxjs/_esm5/internal/observable/fromEventPattern.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "fromEventPattern", function() { return _internal_observable_fromEventPattern__WEBPACK_IMPORTED_MODULE_35__["fromEventPattern"]; });

/* harmony import */ var _internal_observable_generate__WEBPACK_IMPORTED_MODULE_36__ = __webpack_require__(/*! ./internal/observable/generate */ "./node_modules/rxjs/_esm5/internal/observable/generate.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "generate", function() { return _internal_observable_generate__WEBPACK_IMPORTED_MODULE_36__["generate"]; });

/* harmony import */ var _internal_observable_iif__WEBPACK_IMPORTED_MODULE_37__ = __webpack_require__(/*! ./internal/observable/iif */ "./node_modules/rxjs/_esm5/internal/observable/iif.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "iif", function() { return _internal_observable_iif__WEBPACK_IMPORTED_MODULE_37__["iif"]; });

/* harmony import */ var _internal_observable_interval__WEBPACK_IMPORTED_MODULE_38__ = __webpack_require__(/*! ./internal/observable/interval */ "./node_modules/rxjs/_esm5/internal/observable/interval.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "interval", function() { return _internal_observable_interval__WEBPACK_IMPORTED_MODULE_38__["interval"]; });

/* harmony import */ var _internal_observable_merge__WEBPACK_IMPORTED_MODULE_39__ = __webpack_require__(/*! ./internal/observable/merge */ "./node_modules/rxjs/_esm5/internal/observable/merge.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "merge", function() { return _internal_observable_merge__WEBPACK_IMPORTED_MODULE_39__["merge"]; });

/* harmony import */ var _internal_observable_never__WEBPACK_IMPORTED_MODULE_40__ = __webpack_require__(/*! ./internal/observable/never */ "./node_modules/rxjs/_esm5/internal/observable/never.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "never", function() { return _internal_observable_never__WEBPACK_IMPORTED_MODULE_40__["never"]; });

/* harmony import */ var _internal_observable_of__WEBPACK_IMPORTED_MODULE_41__ = __webpack_require__(/*! ./internal/observable/of */ "./node_modules/rxjs/_esm5/internal/observable/of.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "of", function() { return _internal_observable_of__WEBPACK_IMPORTED_MODULE_41__["of"]; });

/* harmony import */ var _internal_observable_onErrorResumeNext__WEBPACK_IMPORTED_MODULE_42__ = __webpack_require__(/*! ./internal/observable/onErrorResumeNext */ "./node_modules/rxjs/_esm5/internal/observable/onErrorResumeNext.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "onErrorResumeNext", function() { return _internal_observable_onErrorResumeNext__WEBPACK_IMPORTED_MODULE_42__["onErrorResumeNext"]; });

/* harmony import */ var _internal_observable_pairs__WEBPACK_IMPORTED_MODULE_43__ = __webpack_require__(/*! ./internal/observable/pairs */ "./node_modules/rxjs/_esm5/internal/observable/pairs.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "pairs", function() { return _internal_observable_pairs__WEBPACK_IMPORTED_MODULE_43__["pairs"]; });

/* harmony import */ var _internal_observable_partition__WEBPACK_IMPORTED_MODULE_44__ = __webpack_require__(/*! ./internal/observable/partition */ "./node_modules/rxjs/_esm5/internal/observable/partition.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "partition", function() { return _internal_observable_partition__WEBPACK_IMPORTED_MODULE_44__["partition"]; });

/* harmony import */ var _internal_observable_race__WEBPACK_IMPORTED_MODULE_45__ = __webpack_require__(/*! ./internal/observable/race */ "./node_modules/rxjs/_esm5/internal/observable/race.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "race", function() { return _internal_observable_race__WEBPACK_IMPORTED_MODULE_45__["race"]; });

/* harmony import */ var _internal_observable_range__WEBPACK_IMPORTED_MODULE_46__ = __webpack_require__(/*! ./internal/observable/range */ "./node_modules/rxjs/_esm5/internal/observable/range.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "range", function() { return _internal_observable_range__WEBPACK_IMPORTED_MODULE_46__["range"]; });

/* harmony import */ var _internal_observable_throwError__WEBPACK_IMPORTED_MODULE_47__ = __webpack_require__(/*! ./internal/observable/throwError */ "./node_modules/rxjs/_esm5/internal/observable/throwError.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "throwError", function() { return _internal_observable_throwError__WEBPACK_IMPORTED_MODULE_47__["throwError"]; });

/* harmony import */ var _internal_observable_timer__WEBPACK_IMPORTED_MODULE_48__ = __webpack_require__(/*! ./internal/observable/timer */ "./node_modules/rxjs/_esm5/internal/observable/timer.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "timer", function() { return _internal_observable_timer__WEBPACK_IMPORTED_MODULE_48__["timer"]; });

/* harmony import */ var _internal_observable_using__WEBPACK_IMPORTED_MODULE_49__ = __webpack_require__(/*! ./internal/observable/using */ "./node_modules/rxjs/_esm5/internal/observable/using.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "using", function() { return _internal_observable_using__WEBPACK_IMPORTED_MODULE_49__["using"]; });

/* harmony import */ var _internal_observable_zip__WEBPACK_IMPORTED_MODULE_50__ = __webpack_require__(/*! ./internal/observable/zip */ "./node_modules/rxjs/_esm5/internal/observable/zip.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "zip", function() { return _internal_observable_zip__WEBPACK_IMPORTED_MODULE_50__["zip"]; });

/* harmony import */ var _internal_scheduled_scheduled__WEBPACK_IMPORTED_MODULE_51__ = __webpack_require__(/*! ./internal/scheduled/scheduled */ "./node_modules/rxjs/_esm5/internal/scheduled/scheduled.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "scheduled", function() { return _internal_scheduled_scheduled__WEBPACK_IMPORTED_MODULE_51__["scheduled"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "EMPTY", function() { return _internal_observable_empty__WEBPACK_IMPORTED_MODULE_31__["EMPTY"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "NEVER", function() { return _internal_observable_never__WEBPACK_IMPORTED_MODULE_40__["NEVER"]; });

/* harmony import */ var _internal_config__WEBPACK_IMPORTED_MODULE_52__ = __webpack_require__(/*! ./internal/config */ "./node_modules/rxjs/_esm5/internal/config.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "config", function() { return _internal_config__WEBPACK_IMPORTED_MODULE_52__["config"]; });

/** PURE_IMPORTS_START  PURE_IMPORTS_END */























































//# sourceMappingURL=index.js.map


/***/ }),

/***/ "./node_modules/rxjs/_esm5/internal/AsyncSubject.js":
/*!**********************************************************!*\
  !*** ./node_modules/rxjs/_esm5/internal/AsyncSubject.js ***!
  \**********************************************************/
/*! exports provided: AsyncSubject */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "AsyncSubject", function() { return AsyncSubject; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/rxjs/node_modules/tslib/tslib.es6.js");
/* harmony import */ var _Subject__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./Subject */ "./node_modules/rxjs/_esm5/internal/Subject.js");
/* harmony import */ var _Subscription__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./Subscription */ "./node_modules/rxjs/_esm5/internal/Subscription.js");
/** PURE_IMPORTS_START tslib,_Subject,_Subscription PURE_IMPORTS_END */



var AsyncSubject = /*@__PURE__*/ (function (_super) {
    tslib__WEBPACK_IMPORTED_MODULE_0__["__extends"](AsyncSubject, _super);
    function AsyncSubject() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.value = null;
        _this.hasNext = false;
        _this.hasCompleted = false;
        return _this;
    }
    AsyncSubject.prototype._subscribe = function (subscriber) {
        if (this.hasError) {
            subscriber.error(this.thrownError);
            return _Subscription__WEBPACK_IMPORTED_MODULE_2__["Subscription"].EMPTY;
        }
        else if (this.hasCompleted && this.hasNext) {
            subscriber.next(this.value);
            subscriber.complete();
            return _Subscription__WEBPACK_IMPORTED_MODULE_2__["Subscription"].EMPTY;
        }
        return _super.prototype._subscribe.call(this, subscriber);
    };
    AsyncSubject.prototype.next = function (value) {
        if (!this.hasCompleted) {
            this.value = value;
            this.hasNext = true;
        }
    };
    AsyncSubject.prototype.error = function (error) {
        if (!this.hasCompleted) {
            _super.prototype.error.call(this, error);
        }
    };
    AsyncSubject.prototype.complete = function () {
        this.hasCompleted = true;
        if (this.hasNext) {
            _super.prototype.next.call(this, this.value);
        }
        _super.prototype.complete.call(this);
    };
    return AsyncSubject;
}(_Subject__WEBPACK_IMPORTED_MODULE_1__["Subject"]));

//# sourceMappingURL=AsyncSubject.js.map


/***/ }),

/***/ "./node_modules/rxjs/_esm5/internal/BehaviorSubject.js":
/*!*************************************************************!*\
  !*** ./node_modules/rxjs/_esm5/internal/BehaviorSubject.js ***!
  \*************************************************************/
/*! exports provided: BehaviorSubject */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "BehaviorSubject", function() { return BehaviorSubject; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/rxjs/node_modules/tslib/tslib.es6.js");
/* harmony import */ var _Subject__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./Subject */ "./node_modules/rxjs/_esm5/internal/Subject.js");
/* harmony import */ var _util_ObjectUnsubscribedError__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./util/ObjectUnsubscribedError */ "./node_modules/rxjs/_esm5/internal/util/ObjectUnsubscribedError.js");
/** PURE_IMPORTS_START tslib,_Subject,_util_ObjectUnsubscribedError PURE_IMPORTS_END */



var BehaviorSubject = /*@__PURE__*/ (function (_super) {
    tslib__WEBPACK_IMPORTED_MODULE_0__["__extends"](BehaviorSubject, _super);
    function BehaviorSubject(_value) {
        var _this = _super.call(this) || this;
        _this._value = _value;
        return _this;
    }
    Object.defineProperty(BehaviorSubject.prototype, "value", {
        get: function () {
            return this.getValue();
        },
        enumerable: true,
        configurable: true
    });
    BehaviorSubject.prototype._subscribe = function (subscriber) {
        var subscription = _super.prototype._subscribe.call(this, subscriber);
        if (subscription && !subscription.closed) {
            subscriber.next(this._value);
        }
        return subscription;
    };
    BehaviorSubject.prototype.getValue = function () {
        if (this.hasError) {
            throw this.thrownError;
        }
        else if (this.closed) {
            throw new _util_ObjectUnsubscribedError__WEBPACK_IMPORTED_MODULE_2__["ObjectUnsubscribedError"]();
        }
        else {
            return this._value;
        }
    };
    BehaviorSubject.prototype.next = function (value) {
        _super.prototype.next.call(this, this._value = value);
    };
    return BehaviorSubject;
}(_Subject__WEBPACK_IMPORTED_MODULE_1__["Subject"]));

//# sourceMappingURL=BehaviorSubject.js.map


/***/ }),

/***/ "./node_modules/rxjs/_esm5/internal/InnerSubscriber.js":
/*!*************************************************************!*\
  !*** ./node_modules/rxjs/_esm5/internal/InnerSubscriber.js ***!
  \*************************************************************/
/*! exports provided: InnerSubscriber */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "InnerSubscriber", function() { return InnerSubscriber; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/rxjs/node_modules/tslib/tslib.es6.js");
/* harmony import */ var _Subscriber__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./Subscriber */ "./node_modules/rxjs/_esm5/internal/Subscriber.js");
/** PURE_IMPORTS_START tslib,_Subscriber PURE_IMPORTS_END */


var InnerSubscriber = /*@__PURE__*/ (function (_super) {
    tslib__WEBPACK_IMPORTED_MODULE_0__["__extends"](InnerSubscriber, _super);
    function InnerSubscriber(parent, outerValue, outerIndex) {
        var _this = _super.call(this) || this;
        _this.parent = parent;
        _this.outerValue = outerValue;
        _this.outerIndex = outerIndex;
        _this.index = 0;
        return _this;
    }
    InnerSubscriber.prototype._next = function (value) {
        this.parent.notifyNext(this.outerValue, value, this.outerIndex, this.index++, this);
    };
    InnerSubscriber.prototype._error = function (error) {
        this.parent.notifyError(error, this);
        this.unsubscribe();
    };
    InnerSubscriber.prototype._complete = function () {
        this.parent.notifyComplete(this);
        this.unsubscribe();
    };
    return InnerSubscriber;
}(_Subscriber__WEBPACK_IMPORTED_MODULE_1__["Subscriber"]));

//# sourceMappingURL=InnerSubscriber.js.map


/***/ }),

/***/ "./node_modules/rxjs/_esm5/internal/Notification.js":
/*!**********************************************************!*\
  !*** ./node_modules/rxjs/_esm5/internal/Notification.js ***!
  \**********************************************************/
/*! exports provided: NotificationKind, Notification */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "NotificationKind", function() { return NotificationKind; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Notification", function() { return Notification; });
/* harmony import */ var _observable_empty__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./observable/empty */ "./node_modules/rxjs/_esm5/internal/observable/empty.js");
/* harmony import */ var _observable_of__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./observable/of */ "./node_modules/rxjs/_esm5/internal/observable/of.js");
/* harmony import */ var _observable_throwError__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./observable/throwError */ "./node_modules/rxjs/_esm5/internal/observable/throwError.js");
/** PURE_IMPORTS_START _observable_empty,_observable_of,_observable_throwError PURE_IMPORTS_END */



var NotificationKind;
/*@__PURE__*/ (function (NotificationKind) {
    NotificationKind["NEXT"] = "N";
    NotificationKind["ERROR"] = "E";
    NotificationKind["COMPLETE"] = "C";
})(NotificationKind || (NotificationKind = {}));
var Notification = /*@__PURE__*/ (function () {
    function Notification(kind, value, error) {
        this.kind = kind;
        this.value = value;
        this.error = error;
        this.hasValue = kind === 'N';
    }
    Notification.prototype.observe = function (observer) {
        switch (this.kind) {
            case 'N':
                return observer.next && observer.next(this.value);
            case 'E':
                return observer.error && observer.error(this.error);
            case 'C':
                return observer.complete && observer.complete();
        }
    };
    Notification.prototype.do = function (next, error, complete) {
        var kind = this.kind;
        switch (kind) {
            case 'N':
                return next && next(this.value);
            case 'E':
                return error && error(this.error);
            case 'C':
                return complete && complete();
        }
    };
    Notification.prototype.accept = function (nextOrObserver, error, complete) {
        if (nextOrObserver && typeof nextOrObserver.next === 'function') {
            return this.observe(nextOrObserver);
        }
        else {
            return this.do(nextOrObserver, error, complete);
        }
    };
    Notification.prototype.toObservable = function () {
        var kind = this.kind;
        switch (kind) {
            case 'N':
                return Object(_observable_of__WEBPACK_IMPORTED_MODULE_1__["of"])(this.value);
            case 'E':
                return Object(_observable_throwError__WEBPACK_IMPORTED_MODULE_2__["throwError"])(this.error);
            case 'C':
                return Object(_observable_empty__WEBPACK_IMPORTED_MODULE_0__["empty"])();
        }
        throw new Error('unexpected notification kind value');
    };
    Notification.createNext = function (value) {
        if (typeof value !== 'undefined') {
            return new Notification('N', value);
        }
        return Notification.undefinedValueNotification;
    };
    Notification.createError = function (err) {
        return new Notification('E', undefined, err);
    };
    Notification.createComplete = function () {
        return Notification.completeNotification;
    };
    Notification.completeNotification = new Notification('C');
    Notification.undefinedValueNotification = new Notification('N', undefined);
    return Notification;
}());

//# sourceMappingURL=Notification.js.map


/***/ }),

/***/ "./node_modules/rxjs/_esm5/internal/Observable.js":
/*!********************************************************!*\
  !*** ./node_modules/rxjs/_esm5/internal/Observable.js ***!
  \********************************************************/
/*! exports provided: Observable */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Observable", function() { return Observable; });
/* harmony import */ var _util_canReportError__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./util/canReportError */ "./node_modules/rxjs/_esm5/internal/util/canReportError.js");
/* harmony import */ var _util_toSubscriber__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./util/toSubscriber */ "./node_modules/rxjs/_esm5/internal/util/toSubscriber.js");
/* harmony import */ var _symbol_observable__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./symbol/observable */ "./node_modules/rxjs/_esm5/internal/symbol/observable.js");
/* harmony import */ var _util_pipe__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./util/pipe */ "./node_modules/rxjs/_esm5/internal/util/pipe.js");
/* harmony import */ var _config__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./config */ "./node_modules/rxjs/_esm5/internal/config.js");
/** PURE_IMPORTS_START _util_canReportError,_util_toSubscriber,_symbol_observable,_util_pipe,_config PURE_IMPORTS_END */





var Observable = /*@__PURE__*/ (function () {
    function Observable(subscribe) {
        this._isScalar = false;
        if (subscribe) {
            this._subscribe = subscribe;
        }
    }
    Observable.prototype.lift = function (operator) {
        var observable = new Observable();
        observable.source = this;
        observable.operator = operator;
        return observable;
    };
    Observable.prototype.subscribe = function (observerOrNext, error, complete) {
        var operator = this.operator;
        var sink = Object(_util_toSubscriber__WEBPACK_IMPORTED_MODULE_1__["toSubscriber"])(observerOrNext, error, complete);
        if (operator) {
            sink.add(operator.call(sink, this.source));
        }
        else {
            sink.add(this.source || (_config__WEBPACK_IMPORTED_MODULE_4__["config"].useDeprecatedSynchronousErrorHandling && !sink.syncErrorThrowable) ?
                this._subscribe(sink) :
                this._trySubscribe(sink));
        }
        if (_config__WEBPACK_IMPORTED_MODULE_4__["config"].useDeprecatedSynchronousErrorHandling) {
            if (sink.syncErrorThrowable) {
                sink.syncErrorThrowable = false;
                if (sink.syncErrorThrown) {
                    throw sink.syncErrorValue;
                }
            }
        }
        return sink;
    };
    Observable.prototype._trySubscribe = function (sink) {
        try {
            return this._subscribe(sink);
        }
        catch (err) {
            if (_config__WEBPACK_IMPORTED_MODULE_4__["config"].useDeprecatedSynchronousErrorHandling) {
                sink.syncErrorThrown = true;
                sink.syncErrorValue = err;
            }
            if (Object(_util_canReportError__WEBPACK_IMPORTED_MODULE_0__["canReportError"])(sink)) {
                sink.error(err);
            }
            else {
                console.warn(err);
            }
        }
    };
    Observable.prototype.forEach = function (next, promiseCtor) {
        var _this = this;
        promiseCtor = getPromiseCtor(promiseCtor);
        return new promiseCtor(function (resolve, reject) {
            var subscription;
            subscription = _this.subscribe(function (value) {
                try {
                    next(value);
                }
                catch (err) {
                    reject(err);
                    if (subscription) {
                        subscription.unsubscribe();
                    }
                }
            }, reject, resolve);
        });
    };
    Observable.prototype._subscribe = function (subscriber) {
        var source = this.source;
        return source && source.subscribe(subscriber);
    };
    Observable.prototype[_symbol_observable__WEBPACK_IMPORTED_MODULE_2__["observable"]] = function () {
        return this;
    };
    Observable.prototype.pipe = function () {
        var operations = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            operations[_i] = arguments[_i];
        }
        if (operations.length === 0) {
            return this;
        }
        return Object(_util_pipe__WEBPACK_IMPORTED_MODULE_3__["pipeFromArray"])(operations)(this);
    };
    Observable.prototype.toPromise = function (promiseCtor) {
        var _this = this;
        promiseCtor = getPromiseCtor(promiseCtor);
        return new promiseCtor(function (resolve, reject) {
            var value;
            _this.subscribe(function (x) { return value = x; }, function (err) { return reject(err); }, function () { return resolve(value); });
        });
    };
    Observable.create = function (subscribe) {
        return new Observable(subscribe);
    };
    return Observable;
}());

function getPromiseCtor(promiseCtor) {
    if (!promiseCtor) {
        promiseCtor = _config__WEBPACK_IMPORTED_MODULE_4__["config"].Promise || Promise;
    }
    if (!promiseCtor) {
        throw new Error('no Promise impl found');
    }
    return promiseCtor;
}
//# sourceMappingURL=Observable.js.map


/***/ }),

/***/ "./node_modules/rxjs/_esm5/internal/Observer.js":
/*!******************************************************!*\
  !*** ./node_modules/rxjs/_esm5/internal/Observer.js ***!
  \******************************************************/
/*! exports provided: empty */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "empty", function() { return empty; });
/* harmony import */ var _config__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./config */ "./node_modules/rxjs/_esm5/internal/config.js");
/* harmony import */ var _util_hostReportError__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./util/hostReportError */ "./node_modules/rxjs/_esm5/internal/util/hostReportError.js");
/** PURE_IMPORTS_START _config,_util_hostReportError PURE_IMPORTS_END */


var empty = {
    closed: true,
    next: function (value) { },
    error: function (err) {
        if (_config__WEBPACK_IMPORTED_MODULE_0__["config"].useDeprecatedSynchronousErrorHandling) {
            throw err;
        }
        else {
            Object(_util_hostReportError__WEBPACK_IMPORTED_MODULE_1__["hostReportError"])(err);
        }
    },
    complete: function () { }
};
//# sourceMappingURL=Observer.js.map


/***/ }),

/***/ "./node_modules/rxjs/_esm5/internal/OuterSubscriber.js":
/*!*************************************************************!*\
  !*** ./node_modules/rxjs/_esm5/internal/OuterSubscriber.js ***!
  \*************************************************************/
/*! exports provided: OuterSubscriber */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "OuterSubscriber", function() { return OuterSubscriber; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/rxjs/node_modules/tslib/tslib.es6.js");
/* harmony import */ var _Subscriber__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./Subscriber */ "./node_modules/rxjs/_esm5/internal/Subscriber.js");
/** PURE_IMPORTS_START tslib,_Subscriber PURE_IMPORTS_END */


var OuterSubscriber = /*@__PURE__*/ (function (_super) {
    tslib__WEBPACK_IMPORTED_MODULE_0__["__extends"](OuterSubscriber, _super);
    function OuterSubscriber() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    OuterSubscriber.prototype.notifyNext = function (outerValue, innerValue, outerIndex, innerIndex, innerSub) {
        this.destination.next(innerValue);
    };
    OuterSubscriber.prototype.notifyError = function (error, innerSub) {
        this.destination.error(error);
    };
    OuterSubscriber.prototype.notifyComplete = function (innerSub) {
        this.destination.complete();
    };
    return OuterSubscriber;
}(_Subscriber__WEBPACK_IMPORTED_MODULE_1__["Subscriber"]));

//# sourceMappingURL=OuterSubscriber.js.map


/***/ }),

/***/ "./node_modules/rxjs/_esm5/internal/ReplaySubject.js":
/*!***********************************************************!*\
  !*** ./node_modules/rxjs/_esm5/internal/ReplaySubject.js ***!
  \***********************************************************/
/*! exports provided: ReplaySubject */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ReplaySubject", function() { return ReplaySubject; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/rxjs/node_modules/tslib/tslib.es6.js");
/* harmony import */ var _Subject__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./Subject */ "./node_modules/rxjs/_esm5/internal/Subject.js");
/* harmony import */ var _scheduler_queue__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./scheduler/queue */ "./node_modules/rxjs/_esm5/internal/scheduler/queue.js");
/* harmony import */ var _Subscription__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./Subscription */ "./node_modules/rxjs/_esm5/internal/Subscription.js");
/* harmony import */ var _operators_observeOn__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./operators/observeOn */ "./node_modules/rxjs/_esm5/internal/operators/observeOn.js");
/* harmony import */ var _util_ObjectUnsubscribedError__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./util/ObjectUnsubscribedError */ "./node_modules/rxjs/_esm5/internal/util/ObjectUnsubscribedError.js");
/* harmony import */ var _SubjectSubscription__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ./SubjectSubscription */ "./node_modules/rxjs/_esm5/internal/SubjectSubscription.js");
/** PURE_IMPORTS_START tslib,_Subject,_scheduler_queue,_Subscription,_operators_observeOn,_util_ObjectUnsubscribedError,_SubjectSubscription PURE_IMPORTS_END */







var ReplaySubject = /*@__PURE__*/ (function (_super) {
    tslib__WEBPACK_IMPORTED_MODULE_0__["__extends"](ReplaySubject, _super);
    function ReplaySubject(bufferSize, windowTime, scheduler) {
        if (bufferSize === void 0) {
            bufferSize = Number.POSITIVE_INFINITY;
        }
        if (windowTime === void 0) {
            windowTime = Number.POSITIVE_INFINITY;
        }
        var _this = _super.call(this) || this;
        _this.scheduler = scheduler;
        _this._events = [];
        _this._infiniteTimeWindow = false;
        _this._bufferSize = bufferSize < 1 ? 1 : bufferSize;
        _this._windowTime = windowTime < 1 ? 1 : windowTime;
        if (windowTime === Number.POSITIVE_INFINITY) {
            _this._infiniteTimeWindow = true;
            _this.next = _this.nextInfiniteTimeWindow;
        }
        else {
            _this.next = _this.nextTimeWindow;
        }
        return _this;
    }
    ReplaySubject.prototype.nextInfiniteTimeWindow = function (value) {
        if (!this.isStopped) {
            var _events = this._events;
            _events.push(value);
            if (_events.length > this._bufferSize) {
                _events.shift();
            }
        }
        _super.prototype.next.call(this, value);
    };
    ReplaySubject.prototype.nextTimeWindow = function (value) {
        if (!this.isStopped) {
            this._events.push(new ReplayEvent(this._getNow(), value));
            this._trimBufferThenGetEvents();
        }
        _super.prototype.next.call(this, value);
    };
    ReplaySubject.prototype._subscribe = function (subscriber) {
        var _infiniteTimeWindow = this._infiniteTimeWindow;
        var _events = _infiniteTimeWindow ? this._events : this._trimBufferThenGetEvents();
        var scheduler = this.scheduler;
        var len = _events.length;
        var subscription;
        if (this.closed) {
            throw new _util_ObjectUnsubscribedError__WEBPACK_IMPORTED_MODULE_5__["ObjectUnsubscribedError"]();
        }
        else if (this.isStopped || this.hasError) {
            subscription = _Subscription__WEBPACK_IMPORTED_MODULE_3__["Subscription"].EMPTY;
        }
        else {
            this.observers.push(subscriber);
            subscription = new _SubjectSubscription__WEBPACK_IMPORTED_MODULE_6__["SubjectSubscription"](this, subscriber);
        }
        if (scheduler) {
            subscriber.add(subscriber = new _operators_observeOn__WEBPACK_IMPORTED_MODULE_4__["ObserveOnSubscriber"](subscriber, scheduler));
        }
        if (_infiniteTimeWindow) {
            for (var i = 0; i < len && !subscriber.closed; i++) {
                subscriber.next(_events[i]);
            }
        }
        else {
            for (var i = 0; i < len && !subscriber.closed; i++) {
                subscriber.next(_events[i].value);
            }
        }
        if (this.hasError) {
            subscriber.error(this.thrownError);
        }
        else if (this.isStopped) {
            subscriber.complete();
        }
        return subscription;
    };
    ReplaySubject.prototype._getNow = function () {
        return (this.scheduler || _scheduler_queue__WEBPACK_IMPORTED_MODULE_2__["queue"]).now();
    };
    ReplaySubject.prototype._trimBufferThenGetEvents = function () {
        var now = this._getNow();
        var _bufferSize = this._bufferSize;
        var _windowTime = this._windowTime;
        var _events = this._events;
        var eventsCount = _events.length;
        var spliceCount = 0;
        while (spliceCount < eventsCount) {
            if ((now - _events[spliceCount].time) < _windowTime) {
                break;
            }
            spliceCount++;
        }
        if (eventsCount > _bufferSize) {
            spliceCount = Math.max(spliceCount, eventsCount - _bufferSize);
        }
        if (spliceCount > 0) {
            _events.splice(0, spliceCount);
        }
        return _events;
    };
    return ReplaySubject;
}(_Subject__WEBPACK_IMPORTED_MODULE_1__["Subject"]));

var ReplayEvent = /*@__PURE__*/ (function () {
    function ReplayEvent(time, value) {
        this.time = time;
        this.value = value;
    }
    return ReplayEvent;
}());
//# sourceMappingURL=ReplaySubject.js.map


/***/ }),

/***/ "./node_modules/rxjs/_esm5/internal/Scheduler.js":
/*!*******************************************************!*\
  !*** ./node_modules/rxjs/_esm5/internal/Scheduler.js ***!
  \*******************************************************/
/*! exports provided: Scheduler */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Scheduler", function() { return Scheduler; });
var Scheduler = /*@__PURE__*/ (function () {
    function Scheduler(SchedulerAction, now) {
        if (now === void 0) {
            now = Scheduler.now;
        }
        this.SchedulerAction = SchedulerAction;
        this.now = now;
    }
    Scheduler.prototype.schedule = function (work, delay, state) {
        if (delay === void 0) {
            delay = 0;
        }
        return new this.SchedulerAction(this, work).schedule(state, delay);
    };
    Scheduler.now = function () { return Date.now(); };
    return Scheduler;
}());

//# sourceMappingURL=Scheduler.js.map


/***/ }),

/***/ "./node_modules/rxjs/_esm5/internal/Subject.js":
/*!*****************************************************!*\
  !*** ./node_modules/rxjs/_esm5/internal/Subject.js ***!
  \*****************************************************/
/*! exports provided: SubjectSubscriber, Subject, AnonymousSubject */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SubjectSubscriber", function() { return SubjectSubscriber; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Subject", function() { return Subject; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "AnonymousSubject", function() { return AnonymousSubject; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/rxjs/node_modules/tslib/tslib.es6.js");
/* harmony import */ var _Observable__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./Observable */ "./node_modules/rxjs/_esm5/internal/Observable.js");
/* harmony import */ var _Subscriber__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./Subscriber */ "./node_modules/rxjs/_esm5/internal/Subscriber.js");
/* harmony import */ var _Subscription__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./Subscription */ "./node_modules/rxjs/_esm5/internal/Subscription.js");
/* harmony import */ var _util_ObjectUnsubscribedError__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./util/ObjectUnsubscribedError */ "./node_modules/rxjs/_esm5/internal/util/ObjectUnsubscribedError.js");
/* harmony import */ var _SubjectSubscription__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./SubjectSubscription */ "./node_modules/rxjs/_esm5/internal/SubjectSubscription.js");
/* harmony import */ var _internal_symbol_rxSubscriber__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../internal/symbol/rxSubscriber */ "./node_modules/rxjs/_esm5/internal/symbol/rxSubscriber.js");
/** PURE_IMPORTS_START tslib,_Observable,_Subscriber,_Subscription,_util_ObjectUnsubscribedError,_SubjectSubscription,_internal_symbol_rxSubscriber PURE_IMPORTS_END */







var SubjectSubscriber = /*@__PURE__*/ (function (_super) {
    tslib__WEBPACK_IMPORTED_MODULE_0__["__extends"](SubjectSubscriber, _super);
    function SubjectSubscriber(destination) {
        var _this = _super.call(this, destination) || this;
        _this.destination = destination;
        return _this;
    }
    return SubjectSubscriber;
}(_Subscriber__WEBPACK_IMPORTED_MODULE_2__["Subscriber"]));

var Subject = /*@__PURE__*/ (function (_super) {
    tslib__WEBPACK_IMPORTED_MODULE_0__["__extends"](Subject, _super);
    function Subject() {
        var _this = _super.call(this) || this;
        _this.observers = [];
        _this.closed = false;
        _this.isStopped = false;
        _this.hasError = false;
        _this.thrownError = null;
        return _this;
    }
    Subject.prototype[_internal_symbol_rxSubscriber__WEBPACK_IMPORTED_MODULE_6__["rxSubscriber"]] = function () {
        return new SubjectSubscriber(this);
    };
    Subject.prototype.lift = function (operator) {
        var subject = new AnonymousSubject(this, this);
        subject.operator = operator;
        return subject;
    };
    Subject.prototype.next = function (value) {
        if (this.closed) {
            throw new _util_ObjectUnsubscribedError__WEBPACK_IMPORTED_MODULE_4__["ObjectUnsubscribedError"]();
        }
        if (!this.isStopped) {
            var observers = this.observers;
            var len = observers.length;
            var copy = observers.slice();
            for (var i = 0; i < len; i++) {
                copy[i].next(value);
            }
        }
    };
    Subject.prototype.error = function (err) {
        if (this.closed) {
            throw new _util_ObjectUnsubscribedError__WEBPACK_IMPORTED_MODULE_4__["ObjectUnsubscribedError"]();
        }
        this.hasError = true;
        this.thrownError = err;
        this.isStopped = true;
        var observers = this.observers;
        var len = observers.length;
        var copy = observers.slice();
        for (var i = 0; i < len; i++) {
            copy[i].error(err);
        }
        this.observers.length = 0;
    };
    Subject.prototype.complete = function () {
        if (this.closed) {
            throw new _util_ObjectUnsubscribedError__WEBPACK_IMPORTED_MODULE_4__["ObjectUnsubscribedError"]();
        }
        this.isStopped = true;
        var observers = this.observers;
        var len = observers.length;
        var copy = observers.slice();
        for (var i = 0; i < len; i++) {
            copy[i].complete();
        }
        this.observers.length = 0;
    };
    Subject.prototype.unsubscribe = function () {
        this.isStopped = true;
        this.closed = true;
        this.observers = null;
    };
    Subject.prototype._trySubscribe = function (subscriber) {
        if (this.closed) {
            throw new _util_ObjectUnsubscribedError__WEBPACK_IMPORTED_MODULE_4__["ObjectUnsubscribedError"]();
        }
        else {
            return _super.prototype._trySubscribe.call(this, subscriber);
        }
    };
    Subject.prototype._subscribe = function (subscriber) {
        if (this.closed) {
            throw new _util_ObjectUnsubscribedError__WEBPACK_IMPORTED_MODULE_4__["ObjectUnsubscribedError"]();
        }
        else if (this.hasError) {
            subscriber.error(this.thrownError);
            return _Subscription__WEBPACK_IMPORTED_MODULE_3__["Subscription"].EMPTY;
        }
        else if (this.isStopped) {
            subscriber.complete();
            return _Subscription__WEBPACK_IMPORTED_MODULE_3__["Subscription"].EMPTY;
        }
        else {
            this.observers.push(subscriber);
            return new _SubjectSubscription__WEBPACK_IMPORTED_MODULE_5__["SubjectSubscription"](this, subscriber);
        }
    };
    Subject.prototype.asObservable = function () {
        var observable = new _Observable__WEBPACK_IMPORTED_MODULE_1__["Observable"]();
        observable.source = this;
        return observable;
    };
    Subject.create = function (destination, source) {
        return new AnonymousSubject(destination, source);
    };
    return Subject;
}(_Observable__WEBPACK_IMPORTED_MODULE_1__["Observable"]));

var AnonymousSubject = /*@__PURE__*/ (function (_super) {
    tslib__WEBPACK_IMPORTED_MODULE_0__["__extends"](AnonymousSubject, _super);
    function AnonymousSubject(destination, source) {
        var _this = _super.call(this) || this;
        _this.destination = destination;
        _this.source = source;
        return _this;
    }
    AnonymousSubject.prototype.next = function (value) {
        var destination = this.destination;
        if (destination && destination.next) {
            destination.next(value);
        }
    };
    AnonymousSubject.prototype.error = function (err) {
        var destination = this.destination;
        if (destination && destination.error) {
            this.destination.error(err);
        }
    };
    AnonymousSubject.prototype.complete = function () {
        var destination = this.destination;
        if (destination && destination.complete) {
            this.destination.complete();
        }
    };
    AnonymousSubject.prototype._subscribe = function (subscriber) {
        var source = this.source;
        if (source) {
            return this.source.subscribe(subscriber);
        }
        else {
            return _Subscription__WEBPACK_IMPORTED_MODULE_3__["Subscription"].EMPTY;
        }
    };
    return AnonymousSubject;
}(Subject));

//# sourceMappingURL=Subject.js.map


/***/ }),

/***/ "./node_modules/rxjs/_esm5/internal/SubjectSubscription.js":
/*!*****************************************************************!*\
  !*** ./node_modules/rxjs/_esm5/internal/SubjectSubscription.js ***!
  \*****************************************************************/
/*! exports provided: SubjectSubscription */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SubjectSubscription", function() { return SubjectSubscription; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/rxjs/node_modules/tslib/tslib.es6.js");
/* harmony import */ var _Subscription__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./Subscription */ "./node_modules/rxjs/_esm5/internal/Subscription.js");
/** PURE_IMPORTS_START tslib,_Subscription PURE_IMPORTS_END */


var SubjectSubscription = /*@__PURE__*/ (function (_super) {
    tslib__WEBPACK_IMPORTED_MODULE_0__["__extends"](SubjectSubscription, _super);
    function SubjectSubscription(subject, subscriber) {
        var _this = _super.call(this) || this;
        _this.subject = subject;
        _this.subscriber = subscriber;
        _this.closed = false;
        return _this;
    }
    SubjectSubscription.prototype.unsubscribe = function () {
        if (this.closed) {
            return;
        }
        this.closed = true;
        var subject = this.subject;
        var observers = subject.observers;
        this.subject = null;
        if (!observers || observers.length === 0 || subject.isStopped || subject.closed) {
            return;
        }
        var subscriberIndex = observers.indexOf(this.subscriber);
        if (subscriberIndex !== -1) {
            observers.splice(subscriberIndex, 1);
        }
    };
    return SubjectSubscription;
}(_Subscription__WEBPACK_IMPORTED_MODULE_1__["Subscription"]));

//# sourceMappingURL=SubjectSubscription.js.map


/***/ }),

/***/ "./node_modules/rxjs/_esm5/internal/Subscriber.js":
/*!********************************************************!*\
  !*** ./node_modules/rxjs/_esm5/internal/Subscriber.js ***!
  \********************************************************/
/*! exports provided: Subscriber, SafeSubscriber */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Subscriber", function() { return Subscriber; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SafeSubscriber", function() { return SafeSubscriber; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/rxjs/node_modules/tslib/tslib.es6.js");
/* harmony import */ var _util_isFunction__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./util/isFunction */ "./node_modules/rxjs/_esm5/internal/util/isFunction.js");
/* harmony import */ var _Observer__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./Observer */ "./node_modules/rxjs/_esm5/internal/Observer.js");
/* harmony import */ var _Subscription__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./Subscription */ "./node_modules/rxjs/_esm5/internal/Subscription.js");
/* harmony import */ var _internal_symbol_rxSubscriber__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../internal/symbol/rxSubscriber */ "./node_modules/rxjs/_esm5/internal/symbol/rxSubscriber.js");
/* harmony import */ var _config__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./config */ "./node_modules/rxjs/_esm5/internal/config.js");
/* harmony import */ var _util_hostReportError__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ./util/hostReportError */ "./node_modules/rxjs/_esm5/internal/util/hostReportError.js");
/** PURE_IMPORTS_START tslib,_util_isFunction,_Observer,_Subscription,_internal_symbol_rxSubscriber,_config,_util_hostReportError PURE_IMPORTS_END */







var Subscriber = /*@__PURE__*/ (function (_super) {
    tslib__WEBPACK_IMPORTED_MODULE_0__["__extends"](Subscriber, _super);
    function Subscriber(destinationOrNext, error, complete) {
        var _this = _super.call(this) || this;
        _this.syncErrorValue = null;
        _this.syncErrorThrown = false;
        _this.syncErrorThrowable = false;
        _this.isStopped = false;
        switch (arguments.length) {
            case 0:
                _this.destination = _Observer__WEBPACK_IMPORTED_MODULE_2__["empty"];
                break;
            case 1:
                if (!destinationOrNext) {
                    _this.destination = _Observer__WEBPACK_IMPORTED_MODULE_2__["empty"];
                    break;
                }
                if (typeof destinationOrNext === 'object') {
                    if (destinationOrNext instanceof Subscriber) {
                        _this.syncErrorThrowable = destinationOrNext.syncErrorThrowable;
                        _this.destination = destinationOrNext;
                        destinationOrNext.add(_this);
                    }
                    else {
                        _this.syncErrorThrowable = true;
                        _this.destination = new SafeSubscriber(_this, destinationOrNext);
                    }
                    break;
                }
            default:
                _this.syncErrorThrowable = true;
                _this.destination = new SafeSubscriber(_this, destinationOrNext, error, complete);
                break;
        }
        return _this;
    }
    Subscriber.prototype[_internal_symbol_rxSubscriber__WEBPACK_IMPORTED_MODULE_4__["rxSubscriber"]] = function () { return this; };
    Subscriber.create = function (next, error, complete) {
        var subscriber = new Subscriber(next, error, complete);
        subscriber.syncErrorThrowable = false;
        return subscriber;
    };
    Subscriber.prototype.next = function (value) {
        if (!this.isStopped) {
            this._next(value);
        }
    };
    Subscriber.prototype.error = function (err) {
        if (!this.isStopped) {
            this.isStopped = true;
            this._error(err);
        }
    };
    Subscriber.prototype.complete = function () {
        if (!this.isStopped) {
            this.isStopped = true;
            this._complete();
        }
    };
    Subscriber.prototype.unsubscribe = function () {
        if (this.closed) {
            return;
        }
        this.isStopped = true;
        _super.prototype.unsubscribe.call(this);
    };
    Subscriber.prototype._next = function (value) {
        this.destination.next(value);
    };
    Subscriber.prototype._error = function (err) {
        this.destination.error(err);
        this.unsubscribe();
    };
    Subscriber.prototype._complete = function () {
        this.destination.complete();
        this.unsubscribe();
    };
    Subscriber.prototype._unsubscribeAndRecycle = function () {
        var _parentOrParents = this._parentOrParents;
        this._parentOrParents = null;
        this.unsubscribe();
        this.closed = false;
        this.isStopped = false;
        this._parentOrParents = _parentOrParents;
        return this;
    };
    return Subscriber;
}(_Subscription__WEBPACK_IMPORTED_MODULE_3__["Subscription"]));

var SafeSubscriber = /*@__PURE__*/ (function (_super) {
    tslib__WEBPACK_IMPORTED_MODULE_0__["__extends"](SafeSubscriber, _super);
    function SafeSubscriber(_parentSubscriber, observerOrNext, error, complete) {
        var _this = _super.call(this) || this;
        _this._parentSubscriber = _parentSubscriber;
        var next;
        var context = _this;
        if (Object(_util_isFunction__WEBPACK_IMPORTED_MODULE_1__["isFunction"])(observerOrNext)) {
            next = observerOrNext;
        }
        else if (observerOrNext) {
            next = observerOrNext.next;
            error = observerOrNext.error;
            complete = observerOrNext.complete;
            if (observerOrNext !== _Observer__WEBPACK_IMPORTED_MODULE_2__["empty"]) {
                context = Object.create(observerOrNext);
                if (Object(_util_isFunction__WEBPACK_IMPORTED_MODULE_1__["isFunction"])(context.unsubscribe)) {
                    _this.add(context.unsubscribe.bind(context));
                }
                context.unsubscribe = _this.unsubscribe.bind(_this);
            }
        }
        _this._context = context;
        _this._next = next;
        _this._error = error;
        _this._complete = complete;
        return _this;
    }
    SafeSubscriber.prototype.next = function (value) {
        if (!this.isStopped && this._next) {
            var _parentSubscriber = this._parentSubscriber;
            if (!_config__WEBPACK_IMPORTED_MODULE_5__["config"].useDeprecatedSynchronousErrorHandling || !_parentSubscriber.syncErrorThrowable) {
                this.__tryOrUnsub(this._next, value);
            }
            else if (this.__tryOrSetError(_parentSubscriber, this._next, value)) {
                this.unsubscribe();
            }
        }
    };
    SafeSubscriber.prototype.error = function (err) {
        if (!this.isStopped) {
            var _parentSubscriber = this._parentSubscriber;
            var useDeprecatedSynchronousErrorHandling = _config__WEBPACK_IMPORTED_MODULE_5__["config"].useDeprecatedSynchronousErrorHandling;
            if (this._error) {
                if (!useDeprecatedSynchronousErrorHandling || !_parentSubscriber.syncErrorThrowable) {
                    this.__tryOrUnsub(this._error, err);
                    this.unsubscribe();
                }
                else {
                    this.__tryOrSetError(_parentSubscriber, this._error, err);
                    this.unsubscribe();
                }
            }
            else if (!_parentSubscriber.syncErrorThrowable) {
                this.unsubscribe();
                if (useDeprecatedSynchronousErrorHandling) {
                    throw err;
                }
                Object(_util_hostReportError__WEBPACK_IMPORTED_MODULE_6__["hostReportError"])(err);
            }
            else {
                if (useDeprecatedSynchronousErrorHandling) {
                    _parentSubscriber.syncErrorValue = err;
                    _parentSubscriber.syncErrorThrown = true;
                }
                else {
                    Object(_util_hostReportError__WEBPACK_IMPORTED_MODULE_6__["hostReportError"])(err);
                }
                this.unsubscribe();
            }
        }
    };
    SafeSubscriber.prototype.complete = function () {
        var _this = this;
        if (!this.isStopped) {
            var _parentSubscriber = this._parentSubscriber;
            if (this._complete) {
                var wrappedComplete = function () { return _this._complete.call(_this._context); };
                if (!_config__WEBPACK_IMPORTED_MODULE_5__["config"].useDeprecatedSynchronousErrorHandling || !_parentSubscriber.syncErrorThrowable) {
                    this.__tryOrUnsub(wrappedComplete);
                    this.unsubscribe();
                }
                else {
                    this.__tryOrSetError(_parentSubscriber, wrappedComplete);
                    this.unsubscribe();
                }
            }
            else {
                this.unsubscribe();
            }
        }
    };
    SafeSubscriber.prototype.__tryOrUnsub = function (fn, value) {
        try {
            fn.call(this._context, value);
        }
        catch (err) {
            this.unsubscribe();
            if (_config__WEBPACK_IMPORTED_MODULE_5__["config"].useDeprecatedSynchronousErrorHandling) {
                throw err;
            }
            else {
                Object(_util_hostReportError__WEBPACK_IMPORTED_MODULE_6__["hostReportError"])(err);
            }
        }
    };
    SafeSubscriber.prototype.__tryOrSetError = function (parent, fn, value) {
        if (!_config__WEBPACK_IMPORTED_MODULE_5__["config"].useDeprecatedSynchronousErrorHandling) {
            throw new Error('bad call');
        }
        try {
            fn.call(this._context, value);
        }
        catch (err) {
            if (_config__WEBPACK_IMPORTED_MODULE_5__["config"].useDeprecatedSynchronousErrorHandling) {
                parent.syncErrorValue = err;
                parent.syncErrorThrown = true;
                return true;
            }
            else {
                Object(_util_hostReportError__WEBPACK_IMPORTED_MODULE_6__["hostReportError"])(err);
                return true;
            }
        }
        return false;
    };
    SafeSubscriber.prototype._unsubscribe = function () {
        var _parentSubscriber = this._parentSubscriber;
        this._context = null;
        this._parentSubscriber = null;
        _parentSubscriber.unsubscribe();
    };
    return SafeSubscriber;
}(Subscriber));

//# sourceMappingURL=Subscriber.js.map


/***/ }),

/***/ "./node_modules/rxjs/_esm5/internal/Subscription.js":
/*!**********************************************************!*\
  !*** ./node_modules/rxjs/_esm5/internal/Subscription.js ***!
  \**********************************************************/
/*! exports provided: Subscription */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Subscription", function() { return Subscription; });
/* harmony import */ var _util_isArray__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./util/isArray */ "./node_modules/rxjs/_esm5/internal/util/isArray.js");
/* harmony import */ var _util_isObject__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./util/isObject */ "./node_modules/rxjs/_esm5/internal/util/isObject.js");
/* harmony import */ var _util_isFunction__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./util/isFunction */ "./node_modules/rxjs/_esm5/internal/util/isFunction.js");
/* harmony import */ var _util_UnsubscriptionError__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./util/UnsubscriptionError */ "./node_modules/rxjs/_esm5/internal/util/UnsubscriptionError.js");
/** PURE_IMPORTS_START _util_isArray,_util_isObject,_util_isFunction,_util_UnsubscriptionError PURE_IMPORTS_END */




var Subscription = /*@__PURE__*/ (function () {
    function Subscription(unsubscribe) {
        this.closed = false;
        this._parentOrParents = null;
        this._subscriptions = null;
        if (unsubscribe) {
            this._ctorUnsubscribe = true;
            this._unsubscribe = unsubscribe;
        }
    }
    Subscription.prototype.unsubscribe = function () {
        var errors;
        if (this.closed) {
            return;
        }
        var _a = this, _parentOrParents = _a._parentOrParents, _ctorUnsubscribe = _a._ctorUnsubscribe, _unsubscribe = _a._unsubscribe, _subscriptions = _a._subscriptions;
        this.closed = true;
        this._parentOrParents = null;
        this._subscriptions = null;
        if (_parentOrParents instanceof Subscription) {
            _parentOrParents.remove(this);
        }
        else if (_parentOrParents !== null) {
            for (var index = 0; index < _parentOrParents.length; ++index) {
                var parent_1 = _parentOrParents[index];
                parent_1.remove(this);
            }
        }
        if (Object(_util_isFunction__WEBPACK_IMPORTED_MODULE_2__["isFunction"])(_unsubscribe)) {
            if (_ctorUnsubscribe) {
                this._unsubscribe = undefined;
            }
            try {
                _unsubscribe.call(this);
            }
            catch (e) {
                errors = e instanceof _util_UnsubscriptionError__WEBPACK_IMPORTED_MODULE_3__["UnsubscriptionError"] ? flattenUnsubscriptionErrors(e.errors) : [e];
            }
        }
        if (Object(_util_isArray__WEBPACK_IMPORTED_MODULE_0__["isArray"])(_subscriptions)) {
            var index = -1;
            var len = _subscriptions.length;
            while (++index < len) {
                var sub = _subscriptions[index];
                if (Object(_util_isObject__WEBPACK_IMPORTED_MODULE_1__["isObject"])(sub)) {
                    try {
                        sub.unsubscribe();
                    }
                    catch (e) {
                        errors = errors || [];
                        if (e instanceof _util_UnsubscriptionError__WEBPACK_IMPORTED_MODULE_3__["UnsubscriptionError"]) {
                            errors = errors.concat(flattenUnsubscriptionErrors(e.errors));
                        }
                        else {
                            errors.push(e);
                        }
                    }
                }
            }
        }
        if (errors) {
            throw new _util_UnsubscriptionError__WEBPACK_IMPORTED_MODULE_3__["UnsubscriptionError"](errors);
        }
    };
    Subscription.prototype.add = function (teardown) {
        var subscription = teardown;
        if (!teardown) {
            return Subscription.EMPTY;
        }
        switch (typeof teardown) {
            case 'function':
                subscription = new Subscription(teardown);
            case 'object':
                if (subscription === this || subscription.closed || typeof subscription.unsubscribe !== 'function') {
                    return subscription;
                }
                else if (this.closed) {
                    subscription.unsubscribe();
                    return subscription;
                }
                else if (!(subscription instanceof Subscription)) {
                    var tmp = subscription;
                    subscription = new Subscription();
                    subscription._subscriptions = [tmp];
                }
                break;
            default: {
                throw new Error('unrecognized teardown ' + teardown + ' added to Subscription.');
            }
        }
        var _parentOrParents = subscription._parentOrParents;
        if (_parentOrParents === null) {
            subscription._parentOrParents = this;
        }
        else if (_parentOrParents instanceof Subscription) {
            if (_parentOrParents === this) {
                return subscription;
            }
            subscription._parentOrParents = [_parentOrParents, this];
        }
        else if (_parentOrParents.indexOf(this) === -1) {
            _parentOrParents.push(this);
        }
        else {
            return subscription;
        }
        var subscriptions = this._subscriptions;
        if (subscriptions === null) {
            this._subscriptions = [subscription];
        }
        else {
            subscriptions.push(subscription);
        }
        return subscription;
    };
    Subscription.prototype.remove = function (subscription) {
        var subscriptions = this._subscriptions;
        if (subscriptions) {
            var subscriptionIndex = subscriptions.indexOf(subscription);
            if (subscriptionIndex !== -1) {
                subscriptions.splice(subscriptionIndex, 1);
            }
        }
    };
    Subscription.EMPTY = (function (empty) {
        empty.closed = true;
        return empty;
    }(new Subscription()));
    return Subscription;
}());

function flattenUnsubscriptionErrors(errors) {
    return errors.reduce(function (errs, err) { return errs.concat((err instanceof _util_UnsubscriptionError__WEBPACK_IMPORTED_MODULE_3__["UnsubscriptionError"]) ? err.errors : err); }, []);
}
//# sourceMappingURL=Subscription.js.map


/***/ }),

/***/ "./node_modules/rxjs/_esm5/internal/config.js":
/*!****************************************************!*\
  !*** ./node_modules/rxjs/_esm5/internal/config.js ***!
  \****************************************************/
/*! exports provided: config */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "config", function() { return config; });
/** PURE_IMPORTS_START  PURE_IMPORTS_END */
var _enable_super_gross_mode_that_will_cause_bad_things = false;
var config = {
    Promise: undefined,
    set useDeprecatedSynchronousErrorHandling(value) {
        if (value) {
            var error = /*@__PURE__*/ new Error();
            /*@__PURE__*/ console.warn('DEPRECATED! RxJS was set to use deprecated synchronous error handling behavior by code at: \n' + error.stack);
        }
        else if (_enable_super_gross_mode_that_will_cause_bad_things) {
            /*@__PURE__*/ console.log('RxJS: Back to a better error behavior. Thank you. <3');
        }
        _enable_super_gross_mode_that_will_cause_bad_things = value;
    },
    get useDeprecatedSynchronousErrorHandling() {
        return _enable_super_gross_mode_that_will_cause_bad_things;
    },
};
//# sourceMappingURL=config.js.map


/***/ }),

/***/ "./node_modules/rxjs/_esm5/internal/innerSubscribe.js":
/*!************************************************************!*\
  !*** ./node_modules/rxjs/_esm5/internal/innerSubscribe.js ***!
  \************************************************************/
/*! exports provided: SimpleInnerSubscriber, ComplexInnerSubscriber, SimpleOuterSubscriber, ComplexOuterSubscriber, innerSubscribe */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SimpleInnerSubscriber", function() { return SimpleInnerSubscriber; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ComplexInnerSubscriber", function() { return ComplexInnerSubscriber; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SimpleOuterSubscriber", function() { return SimpleOuterSubscriber; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ComplexOuterSubscriber", function() { return ComplexOuterSubscriber; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "innerSubscribe", function() { return innerSubscribe; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/rxjs/node_modules/tslib/tslib.es6.js");
/* harmony import */ var _Subscriber__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./Subscriber */ "./node_modules/rxjs/_esm5/internal/Subscriber.js");
/* harmony import */ var _Observable__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./Observable */ "./node_modules/rxjs/_esm5/internal/Observable.js");
/* harmony import */ var _util_subscribeTo__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./util/subscribeTo */ "./node_modules/rxjs/_esm5/internal/util/subscribeTo.js");
/** PURE_IMPORTS_START tslib,_Subscriber,_Observable,_util_subscribeTo PURE_IMPORTS_END */




var SimpleInnerSubscriber = /*@__PURE__*/ (function (_super) {
    tslib__WEBPACK_IMPORTED_MODULE_0__["__extends"](SimpleInnerSubscriber, _super);
    function SimpleInnerSubscriber(parent) {
        var _this = _super.call(this) || this;
        _this.parent = parent;
        return _this;
    }
    SimpleInnerSubscriber.prototype._next = function (value) {
        this.parent.notifyNext(value);
    };
    SimpleInnerSubscriber.prototype._error = function (error) {
        this.parent.notifyError(error);
        this.unsubscribe();
    };
    SimpleInnerSubscriber.prototype._complete = function () {
        this.parent.notifyComplete();
        this.unsubscribe();
    };
    return SimpleInnerSubscriber;
}(_Subscriber__WEBPACK_IMPORTED_MODULE_1__["Subscriber"]));

var ComplexInnerSubscriber = /*@__PURE__*/ (function (_super) {
    tslib__WEBPACK_IMPORTED_MODULE_0__["__extends"](ComplexInnerSubscriber, _super);
    function ComplexInnerSubscriber(parent, outerValue, outerIndex) {
        var _this = _super.call(this) || this;
        _this.parent = parent;
        _this.outerValue = outerValue;
        _this.outerIndex = outerIndex;
        return _this;
    }
    ComplexInnerSubscriber.prototype._next = function (value) {
        this.parent.notifyNext(this.outerValue, value, this.outerIndex, this);
    };
    ComplexInnerSubscriber.prototype._error = function (error) {
        this.parent.notifyError(error);
        this.unsubscribe();
    };
    ComplexInnerSubscriber.prototype._complete = function () {
        this.parent.notifyComplete(this);
        this.unsubscribe();
    };
    return ComplexInnerSubscriber;
}(_Subscriber__WEBPACK_IMPORTED_MODULE_1__["Subscriber"]));

var SimpleOuterSubscriber = /*@__PURE__*/ (function (_super) {
    tslib__WEBPACK_IMPORTED_MODULE_0__["__extends"](SimpleOuterSubscriber, _super);
    function SimpleOuterSubscriber() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    SimpleOuterSubscriber.prototype.notifyNext = function (innerValue) {
        this.destination.next(innerValue);
    };
    SimpleOuterSubscriber.prototype.notifyError = function (err) {
        this.destination.error(err);
    };
    SimpleOuterSubscriber.prototype.notifyComplete = function () {
        this.destination.complete();
    };
    return SimpleOuterSubscriber;
}(_Subscriber__WEBPACK_IMPORTED_MODULE_1__["Subscriber"]));

var ComplexOuterSubscriber = /*@__PURE__*/ (function (_super) {
    tslib__WEBPACK_IMPORTED_MODULE_0__["__extends"](ComplexOuterSubscriber, _super);
    function ComplexOuterSubscriber() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ComplexOuterSubscriber.prototype.notifyNext = function (_outerValue, innerValue, _outerIndex, _innerSub) {
        this.destination.next(innerValue);
    };
    ComplexOuterSubscriber.prototype.notifyError = function (error) {
        this.destination.error(error);
    };
    ComplexOuterSubscriber.prototype.notifyComplete = function (_innerSub) {
        this.destination.complete();
    };
    return ComplexOuterSubscriber;
}(_Subscriber__WEBPACK_IMPORTED_MODULE_1__["Subscriber"]));

function innerSubscribe(result, innerSubscriber) {
    if (innerSubscriber.closed) {
        return undefined;
    }
    if (result instanceof _Observable__WEBPACK_IMPORTED_MODULE_2__["Observable"]) {
        return result.subscribe(innerSubscriber);
    }
    return Object(_util_subscribeTo__WEBPACK_IMPORTED_MODULE_3__["subscribeTo"])(result)(innerSubscriber);
}
//# sourceMappingURL=innerSubscribe.js.map


/***/ }),

/***/ "./node_modules/rxjs/_esm5/internal/observable/ConnectableObservable.js":
/*!******************************************************************************!*\
  !*** ./node_modules/rxjs/_esm5/internal/observable/ConnectableObservable.js ***!
  \******************************************************************************/
/*! exports provided: ConnectableObservable, connectableObservableDescriptor */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ConnectableObservable", function() { return ConnectableObservable; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "connectableObservableDescriptor", function() { return connectableObservableDescriptor; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/rxjs/node_modules/tslib/tslib.es6.js");
/* harmony import */ var _Subject__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../Subject */ "./node_modules/rxjs/_esm5/internal/Subject.js");
/* harmony import */ var _Observable__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../Observable */ "./node_modules/rxjs/_esm5/internal/Observable.js");
/* harmony import */ var _Subscriber__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../Subscriber */ "./node_modules/rxjs/_esm5/internal/Subscriber.js");
/* harmony import */ var _Subscription__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../Subscription */ "./node_modules/rxjs/_esm5/internal/Subscription.js");
/* harmony import */ var _operators_refCount__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../operators/refCount */ "./node_modules/rxjs/_esm5/internal/operators/refCount.js");
/** PURE_IMPORTS_START tslib,_Subject,_Observable,_Subscriber,_Subscription,_operators_refCount PURE_IMPORTS_END */






var ConnectableObservable = /*@__PURE__*/ (function (_super) {
    tslib__WEBPACK_IMPORTED_MODULE_0__["__extends"](ConnectableObservable, _super);
    function ConnectableObservable(source, subjectFactory) {
        var _this = _super.call(this) || this;
        _this.source = source;
        _this.subjectFactory = subjectFactory;
        _this._refCount = 0;
        _this._isComplete = false;
        return _this;
    }
    ConnectableObservable.prototype._subscribe = function (subscriber) {
        return this.getSubject().subscribe(subscriber);
    };
    ConnectableObservable.prototype.getSubject = function () {
        var subject = this._subject;
        if (!subject || subject.isStopped) {
            this._subject = this.subjectFactory();
        }
        return this._subject;
    };
    ConnectableObservable.prototype.connect = function () {
        var connection = this._connection;
        if (!connection) {
            this._isComplete = false;
            connection = this._connection = new _Subscription__WEBPACK_IMPORTED_MODULE_4__["Subscription"]();
            connection.add(this.source
                .subscribe(new ConnectableSubscriber(this.getSubject(), this)));
            if (connection.closed) {
                this._connection = null;
                connection = _Subscription__WEBPACK_IMPORTED_MODULE_4__["Subscription"].EMPTY;
            }
        }
        return connection;
    };
    ConnectableObservable.prototype.refCount = function () {
        return Object(_operators_refCount__WEBPACK_IMPORTED_MODULE_5__["refCount"])()(this);
    };
    return ConnectableObservable;
}(_Observable__WEBPACK_IMPORTED_MODULE_2__["Observable"]));

var connectableObservableDescriptor = /*@__PURE__*/ (function () {
    var connectableProto = ConnectableObservable.prototype;
    return {
        operator: { value: null },
        _refCount: { value: 0, writable: true },
        _subject: { value: null, writable: true },
        _connection: { value: null, writable: true },
        _subscribe: { value: connectableProto._subscribe },
        _isComplete: { value: connectableProto._isComplete, writable: true },
        getSubject: { value: connectableProto.getSubject },
        connect: { value: connectableProto.connect },
        refCount: { value: connectableProto.refCount }
    };
})();
var ConnectableSubscriber = /*@__PURE__*/ (function (_super) {
    tslib__WEBPACK_IMPORTED_MODULE_0__["__extends"](ConnectableSubscriber, _super);
    function ConnectableSubscriber(destination, connectable) {
        var _this = _super.call(this, destination) || this;
        _this.connectable = connectable;
        return _this;
    }
    ConnectableSubscriber.prototype._error = function (err) {
        this._unsubscribe();
        _super.prototype._error.call(this, err);
    };
    ConnectableSubscriber.prototype._complete = function () {
        this.connectable._isComplete = true;
        this._unsubscribe();
        _super.prototype._complete.call(this);
    };
    ConnectableSubscriber.prototype._unsubscribe = function () {
        var connectable = this.connectable;
        if (connectable) {
            this.connectable = null;
            var connection = connectable._connection;
            connectable._refCount = 0;
            connectable._subject = null;
            connectable._connection = null;
            if (connection) {
                connection.unsubscribe();
            }
        }
    };
    return ConnectableSubscriber;
}(_Subject__WEBPACK_IMPORTED_MODULE_1__["SubjectSubscriber"]));
var RefCountOperator = /*@__PURE__*/ (function () {
    function RefCountOperator(connectable) {
        this.connectable = connectable;
    }
    RefCountOperator.prototype.call = function (subscriber, source) {
        var connectable = this.connectable;
        connectable._refCount++;
        var refCounter = new RefCountSubscriber(subscriber, connectable);
        var subscription = source.subscribe(refCounter);
        if (!refCounter.closed) {
            refCounter.connection = connectable.connect();
        }
        return subscription;
    };
    return RefCountOperator;
}());
var RefCountSubscriber = /*@__PURE__*/ (function (_super) {
    tslib__WEBPACK_IMPORTED_MODULE_0__["__extends"](RefCountSubscriber, _super);
    function RefCountSubscriber(destination, connectable) {
        var _this = _super.call(this, destination) || this;
        _this.connectable = connectable;
        return _this;
    }
    RefCountSubscriber.prototype._unsubscribe = function () {
        var connectable = this.connectable;
        if (!connectable) {
            this.connection = null;
            return;
        }
        this.connectable = null;
        var refCount = connectable._refCount;
        if (refCount <= 0) {
            this.connection = null;
            return;
        }
        connectable._refCount = refCount - 1;
        if (refCount > 1) {
            this.connection = null;
            return;
        }
        var connection = this.connection;
        var sharedConnection = connectable._connection;
        this.connection = null;
        if (sharedConnection && (!connection || sharedConnection === connection)) {
            sharedConnection.unsubscribe();
        }
    };
    return RefCountSubscriber;
}(_Subscriber__WEBPACK_IMPORTED_MODULE_3__["Subscriber"]));
//# sourceMappingURL=ConnectableObservable.js.map


/***/ }),

/***/ "./node_modules/rxjs/_esm5/internal/observable/SubscribeOnObservable.js":
/*!******************************************************************************!*\
  !*** ./node_modules/rxjs/_esm5/internal/observable/SubscribeOnObservable.js ***!
  \******************************************************************************/
/*! exports provided: SubscribeOnObservable */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SubscribeOnObservable", function() { return SubscribeOnObservable; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/rxjs/node_modules/tslib/tslib.es6.js");
/* harmony import */ var _Observable__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../Observable */ "./node_modules/rxjs/_esm5/internal/Observable.js");
/* harmony import */ var _scheduler_asap__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../scheduler/asap */ "./node_modules/rxjs/_esm5/internal/scheduler/asap.js");
/* harmony import */ var _util_isNumeric__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../util/isNumeric */ "./node_modules/rxjs/_esm5/internal/util/isNumeric.js");
/** PURE_IMPORTS_START tslib,_Observable,_scheduler_asap,_util_isNumeric PURE_IMPORTS_END */




var SubscribeOnObservable = /*@__PURE__*/ (function (_super) {
    tslib__WEBPACK_IMPORTED_MODULE_0__["__extends"](SubscribeOnObservable, _super);
    function SubscribeOnObservable(source, delayTime, scheduler) {
        if (delayTime === void 0) {
            delayTime = 0;
        }
        if (scheduler === void 0) {
            scheduler = _scheduler_asap__WEBPACK_IMPORTED_MODULE_2__["asap"];
        }
        var _this = _super.call(this) || this;
        _this.source = source;
        _this.delayTime = delayTime;
        _this.scheduler = scheduler;
        if (!Object(_util_isNumeric__WEBPACK_IMPORTED_MODULE_3__["isNumeric"])(delayTime) || delayTime < 0) {
            _this.delayTime = 0;
        }
        if (!scheduler || typeof scheduler.schedule !== 'function') {
            _this.scheduler = _scheduler_asap__WEBPACK_IMPORTED_MODULE_2__["asap"];
        }
        return _this;
    }
    SubscribeOnObservable.create = function (source, delay, scheduler) {
        if (delay === void 0) {
            delay = 0;
        }
        if (scheduler === void 0) {
            scheduler = _scheduler_asap__WEBPACK_IMPORTED_MODULE_2__["asap"];
        }
        return new SubscribeOnObservable(source, delay, scheduler);
    };
    SubscribeOnObservable.dispatch = function (arg) {
        var source = arg.source, subscriber = arg.subscriber;
        return this.add(source.subscribe(subscriber));
    };
    SubscribeOnObservable.prototype._subscribe = function (subscriber) {
        var delay = this.delayTime;
        var source = this.source;
        var scheduler = this.scheduler;
        return scheduler.schedule(SubscribeOnObservable.dispatch, delay, {
            source: source, subscriber: subscriber
        });
    };
    return SubscribeOnObservable;
}(_Observable__WEBPACK_IMPORTED_MODULE_1__["Observable"]));

//# sourceMappingURL=SubscribeOnObservable.js.map


/***/ }),

/***/ "./node_modules/rxjs/_esm5/internal/observable/bindCallback.js":
/*!*********************************************************************!*\
  !*** ./node_modules/rxjs/_esm5/internal/observable/bindCallback.js ***!
  \*********************************************************************/
/*! exports provided: bindCallback */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "bindCallback", function() { return bindCallback; });
/* harmony import */ var _Observable__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../Observable */ "./node_modules/rxjs/_esm5/internal/Observable.js");
/* harmony import */ var _AsyncSubject__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../AsyncSubject */ "./node_modules/rxjs/_esm5/internal/AsyncSubject.js");
/* harmony import */ var _operators_map__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../operators/map */ "./node_modules/rxjs/_esm5/internal/operators/map.js");
/* harmony import */ var _util_canReportError__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../util/canReportError */ "./node_modules/rxjs/_esm5/internal/util/canReportError.js");
/* harmony import */ var _util_isArray__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../util/isArray */ "./node_modules/rxjs/_esm5/internal/util/isArray.js");
/* harmony import */ var _util_isScheduler__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../util/isScheduler */ "./node_modules/rxjs/_esm5/internal/util/isScheduler.js");
/** PURE_IMPORTS_START _Observable,_AsyncSubject,_operators_map,_util_canReportError,_util_isArray,_util_isScheduler PURE_IMPORTS_END */






function bindCallback(callbackFunc, resultSelector, scheduler) {
    if (resultSelector) {
        if (Object(_util_isScheduler__WEBPACK_IMPORTED_MODULE_5__["isScheduler"])(resultSelector)) {
            scheduler = resultSelector;
        }
        else {
            return function () {
                var args = [];
                for (var _i = 0; _i < arguments.length; _i++) {
                    args[_i] = arguments[_i];
                }
                return bindCallback(callbackFunc, scheduler).apply(void 0, args).pipe(Object(_operators_map__WEBPACK_IMPORTED_MODULE_2__["map"])(function (args) { return Object(_util_isArray__WEBPACK_IMPORTED_MODULE_4__["isArray"])(args) ? resultSelector.apply(void 0, args) : resultSelector(args); }));
            };
        }
    }
    return function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        var context = this;
        var subject;
        var params = {
            context: context,
            subject: subject,
            callbackFunc: callbackFunc,
            scheduler: scheduler,
        };
        return new _Observable__WEBPACK_IMPORTED_MODULE_0__["Observable"](function (subscriber) {
            if (!scheduler) {
                if (!subject) {
                    subject = new _AsyncSubject__WEBPACK_IMPORTED_MODULE_1__["AsyncSubject"]();
                    var handler = function () {
                        var innerArgs = [];
                        for (var _i = 0; _i < arguments.length; _i++) {
                            innerArgs[_i] = arguments[_i];
                        }
                        subject.next(innerArgs.length <= 1 ? innerArgs[0] : innerArgs);
                        subject.complete();
                    };
                    try {
                        callbackFunc.apply(context, args.concat([handler]));
                    }
                    catch (err) {
                        if (Object(_util_canReportError__WEBPACK_IMPORTED_MODULE_3__["canReportError"])(subject)) {
                            subject.error(err);
                        }
                        else {
                            console.warn(err);
                        }
                    }
                }
                return subject.subscribe(subscriber);
            }
            else {
                var state = {
                    args: args, subscriber: subscriber, params: params,
                };
                return scheduler.schedule(dispatch, 0, state);
            }
        });
    };
}
function dispatch(state) {
    var _this = this;
    var self = this;
    var args = state.args, subscriber = state.subscriber, params = state.params;
    var callbackFunc = params.callbackFunc, context = params.context, scheduler = params.scheduler;
    var subject = params.subject;
    if (!subject) {
        subject = params.subject = new _AsyncSubject__WEBPACK_IMPORTED_MODULE_1__["AsyncSubject"]();
        var handler = function () {
            var innerArgs = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                innerArgs[_i] = arguments[_i];
            }
            var value = innerArgs.length <= 1 ? innerArgs[0] : innerArgs;
            _this.add(scheduler.schedule(dispatchNext, 0, { value: value, subject: subject }));
        };
        try {
            callbackFunc.apply(context, args.concat([handler]));
        }
        catch (err) {
            subject.error(err);
        }
    }
    this.add(subject.subscribe(subscriber));
}
function dispatchNext(state) {
    var value = state.value, subject = state.subject;
    subject.next(value);
    subject.complete();
}
function dispatchError(state) {
    var err = state.err, subject = state.subject;
    subject.error(err);
}
//# sourceMappingURL=bindCallback.js.map


/***/ }),

/***/ "./node_modules/rxjs/_esm5/internal/observable/bindNodeCallback.js":
/*!*************************************************************************!*\
  !*** ./node_modules/rxjs/_esm5/internal/observable/bindNodeCallback.js ***!
  \*************************************************************************/
/*! exports provided: bindNodeCallback */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "bindNodeCallback", function() { return bindNodeCallback; });
/* harmony import */ var _Observable__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../Observable */ "./node_modules/rxjs/_esm5/internal/Observable.js");
/* harmony import */ var _AsyncSubject__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../AsyncSubject */ "./node_modules/rxjs/_esm5/internal/AsyncSubject.js");
/* harmony import */ var _operators_map__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../operators/map */ "./node_modules/rxjs/_esm5/internal/operators/map.js");
/* harmony import */ var _util_canReportError__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../util/canReportError */ "./node_modules/rxjs/_esm5/internal/util/canReportError.js");
/* harmony import */ var _util_isScheduler__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../util/isScheduler */ "./node_modules/rxjs/_esm5/internal/util/isScheduler.js");
/* harmony import */ var _util_isArray__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../util/isArray */ "./node_modules/rxjs/_esm5/internal/util/isArray.js");
/** PURE_IMPORTS_START _Observable,_AsyncSubject,_operators_map,_util_canReportError,_util_isScheduler,_util_isArray PURE_IMPORTS_END */






function bindNodeCallback(callbackFunc, resultSelector, scheduler) {
    if (resultSelector) {
        if (Object(_util_isScheduler__WEBPACK_IMPORTED_MODULE_4__["isScheduler"])(resultSelector)) {
            scheduler = resultSelector;
        }
        else {
            return function () {
                var args = [];
                for (var _i = 0; _i < arguments.length; _i++) {
                    args[_i] = arguments[_i];
                }
                return bindNodeCallback(callbackFunc, scheduler).apply(void 0, args).pipe(Object(_operators_map__WEBPACK_IMPORTED_MODULE_2__["map"])(function (args) { return Object(_util_isArray__WEBPACK_IMPORTED_MODULE_5__["isArray"])(args) ? resultSelector.apply(void 0, args) : resultSelector(args); }));
            };
        }
    }
    return function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        var params = {
            subject: undefined,
            args: args,
            callbackFunc: callbackFunc,
            scheduler: scheduler,
            context: this,
        };
        return new _Observable__WEBPACK_IMPORTED_MODULE_0__["Observable"](function (subscriber) {
            var context = params.context;
            var subject = params.subject;
            if (!scheduler) {
                if (!subject) {
                    subject = params.subject = new _AsyncSubject__WEBPACK_IMPORTED_MODULE_1__["AsyncSubject"]();
                    var handler = function () {
                        var innerArgs = [];
                        for (var _i = 0; _i < arguments.length; _i++) {
                            innerArgs[_i] = arguments[_i];
                        }
                        var err = innerArgs.shift();
                        if (err) {
                            subject.error(err);
                            return;
                        }
                        subject.next(innerArgs.length <= 1 ? innerArgs[0] : innerArgs);
                        subject.complete();
                    };
                    try {
                        callbackFunc.apply(context, args.concat([handler]));
                    }
                    catch (err) {
                        if (Object(_util_canReportError__WEBPACK_IMPORTED_MODULE_3__["canReportError"])(subject)) {
                            subject.error(err);
                        }
                        else {
                            console.warn(err);
                        }
                    }
                }
                return subject.subscribe(subscriber);
            }
            else {
                return scheduler.schedule(dispatch, 0, { params: params, subscriber: subscriber, context: context });
            }
        });
    };
}
function dispatch(state) {
    var _this = this;
    var params = state.params, subscriber = state.subscriber, context = state.context;
    var callbackFunc = params.callbackFunc, args = params.args, scheduler = params.scheduler;
    var subject = params.subject;
    if (!subject) {
        subject = params.subject = new _AsyncSubject__WEBPACK_IMPORTED_MODULE_1__["AsyncSubject"]();
        var handler = function () {
            var innerArgs = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                innerArgs[_i] = arguments[_i];
            }
            var err = innerArgs.shift();
            if (err) {
                _this.add(scheduler.schedule(dispatchError, 0, { err: err, subject: subject }));
            }
            else {
                var value = innerArgs.length <= 1 ? innerArgs[0] : innerArgs;
                _this.add(scheduler.schedule(dispatchNext, 0, { value: value, subject: subject }));
            }
        };
        try {
            callbackFunc.apply(context, args.concat([handler]));
        }
        catch (err) {
            this.add(scheduler.schedule(dispatchError, 0, { err: err, subject: subject }));
        }
    }
    this.add(subject.subscribe(subscriber));
}
function dispatchNext(arg) {
    var value = arg.value, subject = arg.subject;
    subject.next(value);
    subject.complete();
}
function dispatchError(arg) {
    var err = arg.err, subject = arg.subject;
    subject.error(err);
}
//# sourceMappingURL=bindNodeCallback.js.map


/***/ }),

/***/ "./node_modules/rxjs/_esm5/internal/observable/combineLatest.js":
/*!**********************************************************************!*\
  !*** ./node_modules/rxjs/_esm5/internal/observable/combineLatest.js ***!
  \**********************************************************************/
/*! exports provided: combineLatest, CombineLatestOperator, CombineLatestSubscriber */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "combineLatest", function() { return combineLatest; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CombineLatestOperator", function() { return CombineLatestOperator; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CombineLatestSubscriber", function() { return CombineLatestSubscriber; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/rxjs/node_modules/tslib/tslib.es6.js");
/* harmony import */ var _util_isScheduler__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../util/isScheduler */ "./node_modules/rxjs/_esm5/internal/util/isScheduler.js");
/* harmony import */ var _util_isArray__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../util/isArray */ "./node_modules/rxjs/_esm5/internal/util/isArray.js");
/* harmony import */ var _OuterSubscriber__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../OuterSubscriber */ "./node_modules/rxjs/_esm5/internal/OuterSubscriber.js");
/* harmony import */ var _util_subscribeToResult__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../util/subscribeToResult */ "./node_modules/rxjs/_esm5/internal/util/subscribeToResult.js");
/* harmony import */ var _fromArray__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./fromArray */ "./node_modules/rxjs/_esm5/internal/observable/fromArray.js");
/** PURE_IMPORTS_START tslib,_util_isScheduler,_util_isArray,_OuterSubscriber,_util_subscribeToResult,_fromArray PURE_IMPORTS_END */






var NONE = {};
function combineLatest() {
    var observables = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        observables[_i] = arguments[_i];
    }
    var resultSelector = undefined;
    var scheduler = undefined;
    if (Object(_util_isScheduler__WEBPACK_IMPORTED_MODULE_1__["isScheduler"])(observables[observables.length - 1])) {
        scheduler = observables.pop();
    }
    if (typeof observables[observables.length - 1] === 'function') {
        resultSelector = observables.pop();
    }
    if (observables.length === 1 && Object(_util_isArray__WEBPACK_IMPORTED_MODULE_2__["isArray"])(observables[0])) {
        observables = observables[0];
    }
    return Object(_fromArray__WEBPACK_IMPORTED_MODULE_5__["fromArray"])(observables, scheduler).lift(new CombineLatestOperator(resultSelector));
}
var CombineLatestOperator = /*@__PURE__*/ (function () {
    function CombineLatestOperator(resultSelector) {
        this.resultSelector = resultSelector;
    }
    CombineLatestOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new CombineLatestSubscriber(subscriber, this.resultSelector));
    };
    return CombineLatestOperator;
}());

var CombineLatestSubscriber = /*@__PURE__*/ (function (_super) {
    tslib__WEBPACK_IMPORTED_MODULE_0__["__extends"](CombineLatestSubscriber, _super);
    function CombineLatestSubscriber(destination, resultSelector) {
        var _this = _super.call(this, destination) || this;
        _this.resultSelector = resultSelector;
        _this.active = 0;
        _this.values = [];
        _this.observables = [];
        return _this;
    }
    CombineLatestSubscriber.prototype._next = function (observable) {
        this.values.push(NONE);
        this.observables.push(observable);
    };
    CombineLatestSubscriber.prototype._complete = function () {
        var observables = this.observables;
        var len = observables.length;
        if (len === 0) {
            this.destination.complete();
        }
        else {
            this.active = len;
            this.toRespond = len;
            for (var i = 0; i < len; i++) {
                var observable = observables[i];
                this.add(Object(_util_subscribeToResult__WEBPACK_IMPORTED_MODULE_4__["subscribeToResult"])(this, observable, undefined, i));
            }
        }
    };
    CombineLatestSubscriber.prototype.notifyComplete = function (unused) {
        if ((this.active -= 1) === 0) {
            this.destination.complete();
        }
    };
    CombineLatestSubscriber.prototype.notifyNext = function (_outerValue, innerValue, outerIndex) {
        var values = this.values;
        var oldVal = values[outerIndex];
        var toRespond = !this.toRespond
            ? 0
            : oldVal === NONE ? --this.toRespond : this.toRespond;
        values[outerIndex] = innerValue;
        if (toRespond === 0) {
            if (this.resultSelector) {
                this._tryResultSelector(values);
            }
            else {
                this.destination.next(values.slice());
            }
        }
    };
    CombineLatestSubscriber.prototype._tryResultSelector = function (values) {
        var result;
        try {
            result = this.resultSelector.apply(this, values);
        }
        catch (err) {
            this.destination.error(err);
            return;
        }
        this.destination.next(result);
    };
    return CombineLatestSubscriber;
}(_OuterSubscriber__WEBPACK_IMPORTED_MODULE_3__["OuterSubscriber"]));

//# sourceMappingURL=combineLatest.js.map


/***/ }),

/***/ "./node_modules/rxjs/_esm5/internal/observable/concat.js":
/*!***************************************************************!*\
  !*** ./node_modules/rxjs/_esm5/internal/observable/concat.js ***!
  \***************************************************************/
/*! exports provided: concat */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "concat", function() { return concat; });
/* harmony import */ var _of__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./of */ "./node_modules/rxjs/_esm5/internal/observable/of.js");
/* harmony import */ var _operators_concatAll__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../operators/concatAll */ "./node_modules/rxjs/_esm5/internal/operators/concatAll.js");
/** PURE_IMPORTS_START _of,_operators_concatAll PURE_IMPORTS_END */


function concat() {
    var observables = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        observables[_i] = arguments[_i];
    }
    return Object(_operators_concatAll__WEBPACK_IMPORTED_MODULE_1__["concatAll"])()(_of__WEBPACK_IMPORTED_MODULE_0__["of"].apply(void 0, observables));
}
//# sourceMappingURL=concat.js.map


/***/ }),

/***/ "./node_modules/rxjs/_esm5/internal/observable/defer.js":
/*!**************************************************************!*\
  !*** ./node_modules/rxjs/_esm5/internal/observable/defer.js ***!
  \**************************************************************/
/*! exports provided: defer */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "defer", function() { return defer; });
/* harmony import */ var _Observable__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../Observable */ "./node_modules/rxjs/_esm5/internal/Observable.js");
/* harmony import */ var _from__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./from */ "./node_modules/rxjs/_esm5/internal/observable/from.js");
/* harmony import */ var _empty__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./empty */ "./node_modules/rxjs/_esm5/internal/observable/empty.js");
/** PURE_IMPORTS_START _Observable,_from,_empty PURE_IMPORTS_END */



function defer(observableFactory) {
    return new _Observable__WEBPACK_IMPORTED_MODULE_0__["Observable"](function (subscriber) {
        var input;
        try {
            input = observableFactory();
        }
        catch (err) {
            subscriber.error(err);
            return undefined;
        }
        var source = input ? Object(_from__WEBPACK_IMPORTED_MODULE_1__["from"])(input) : Object(_empty__WEBPACK_IMPORTED_MODULE_2__["empty"])();
        return source.subscribe(subscriber);
    });
}
//# sourceMappingURL=defer.js.map


/***/ }),

/***/ "./node_modules/rxjs/_esm5/internal/observable/empty.js":
/*!**************************************************************!*\
  !*** ./node_modules/rxjs/_esm5/internal/observable/empty.js ***!
  \**************************************************************/
/*! exports provided: EMPTY, empty */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "EMPTY", function() { return EMPTY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "empty", function() { return empty; });
/* harmony import */ var _Observable__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../Observable */ "./node_modules/rxjs/_esm5/internal/Observable.js");
/** PURE_IMPORTS_START _Observable PURE_IMPORTS_END */

var EMPTY = /*@__PURE__*/ new _Observable__WEBPACK_IMPORTED_MODULE_0__["Observable"](function (subscriber) { return subscriber.complete(); });
function empty(scheduler) {
    return scheduler ? emptyScheduled(scheduler) : EMPTY;
}
function emptyScheduled(scheduler) {
    return new _Observable__WEBPACK_IMPORTED_MODULE_0__["Observable"](function (subscriber) { return scheduler.schedule(function () { return subscriber.complete(); }); });
}
//# sourceMappingURL=empty.js.map


/***/ }),

/***/ "./node_modules/rxjs/_esm5/internal/observable/forkJoin.js":
/*!*****************************************************************!*\
  !*** ./node_modules/rxjs/_esm5/internal/observable/forkJoin.js ***!
  \*****************************************************************/
/*! exports provided: forkJoin */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "forkJoin", function() { return forkJoin; });
/* harmony import */ var _Observable__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../Observable */ "./node_modules/rxjs/_esm5/internal/Observable.js");
/* harmony import */ var _util_isArray__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../util/isArray */ "./node_modules/rxjs/_esm5/internal/util/isArray.js");
/* harmony import */ var _operators_map__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../operators/map */ "./node_modules/rxjs/_esm5/internal/operators/map.js");
/* harmony import */ var _util_isObject__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../util/isObject */ "./node_modules/rxjs/_esm5/internal/util/isObject.js");
/* harmony import */ var _from__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./from */ "./node_modules/rxjs/_esm5/internal/observable/from.js");
/** PURE_IMPORTS_START _Observable,_util_isArray,_operators_map,_util_isObject,_from PURE_IMPORTS_END */





function forkJoin() {
    var sources = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        sources[_i] = arguments[_i];
    }
    if (sources.length === 1) {
        var first_1 = sources[0];
        if (Object(_util_isArray__WEBPACK_IMPORTED_MODULE_1__["isArray"])(first_1)) {
            return forkJoinInternal(first_1, null);
        }
        if (Object(_util_isObject__WEBPACK_IMPORTED_MODULE_3__["isObject"])(first_1) && Object.getPrototypeOf(first_1) === Object.prototype) {
            var keys = Object.keys(first_1);
            return forkJoinInternal(keys.map(function (key) { return first_1[key]; }), keys);
        }
    }
    if (typeof sources[sources.length - 1] === 'function') {
        var resultSelector_1 = sources.pop();
        sources = (sources.length === 1 && Object(_util_isArray__WEBPACK_IMPORTED_MODULE_1__["isArray"])(sources[0])) ? sources[0] : sources;
        return forkJoinInternal(sources, null).pipe(Object(_operators_map__WEBPACK_IMPORTED_MODULE_2__["map"])(function (args) { return resultSelector_1.apply(void 0, args); }));
    }
    return forkJoinInternal(sources, null);
}
function forkJoinInternal(sources, keys) {
    return new _Observable__WEBPACK_IMPORTED_MODULE_0__["Observable"](function (subscriber) {
        var len = sources.length;
        if (len === 0) {
            subscriber.complete();
            return;
        }
        var values = new Array(len);
        var completed = 0;
        var emitted = 0;
        var _loop_1 = function (i) {
            var source = Object(_from__WEBPACK_IMPORTED_MODULE_4__["from"])(sources[i]);
            var hasValue = false;
            subscriber.add(source.subscribe({
                next: function (value) {
                    if (!hasValue) {
                        hasValue = true;
                        emitted++;
                    }
                    values[i] = value;
                },
                error: function (err) { return subscriber.error(err); },
                complete: function () {
                    completed++;
                    if (completed === len || !hasValue) {
                        if (emitted === len) {
                            subscriber.next(keys ?
                                keys.reduce(function (result, key, i) { return (result[key] = values[i], result); }, {}) :
                                values);
                        }
                        subscriber.complete();
                    }
                }
            }));
        };
        for (var i = 0; i < len; i++) {
            _loop_1(i);
        }
    });
}
//# sourceMappingURL=forkJoin.js.map


/***/ }),

/***/ "./node_modules/rxjs/_esm5/internal/observable/from.js":
/*!*************************************************************!*\
  !*** ./node_modules/rxjs/_esm5/internal/observable/from.js ***!
  \*************************************************************/
/*! exports provided: from */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "from", function() { return from; });
/* harmony import */ var _Observable__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../Observable */ "./node_modules/rxjs/_esm5/internal/Observable.js");
/* harmony import */ var _util_subscribeTo__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../util/subscribeTo */ "./node_modules/rxjs/_esm5/internal/util/subscribeTo.js");
/* harmony import */ var _scheduled_scheduled__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../scheduled/scheduled */ "./node_modules/rxjs/_esm5/internal/scheduled/scheduled.js");
/** PURE_IMPORTS_START _Observable,_util_subscribeTo,_scheduled_scheduled PURE_IMPORTS_END */



function from(input, scheduler) {
    if (!scheduler) {
        if (input instanceof _Observable__WEBPACK_IMPORTED_MODULE_0__["Observable"]) {
            return input;
        }
        return new _Observable__WEBPACK_IMPORTED_MODULE_0__["Observable"](Object(_util_subscribeTo__WEBPACK_IMPORTED_MODULE_1__["subscribeTo"])(input));
    }
    else {
        return Object(_scheduled_scheduled__WEBPACK_IMPORTED_MODULE_2__["scheduled"])(input, scheduler);
    }
}
//# sourceMappingURL=from.js.map


/***/ }),

/***/ "./node_modules/rxjs/_esm5/internal/observable/fromArray.js":
/*!******************************************************************!*\
  !*** ./node_modules/rxjs/_esm5/internal/observable/fromArray.js ***!
  \******************************************************************/
/*! exports provided: fromArray */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fromArray", function() { return fromArray; });
/* harmony import */ var _Observable__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../Observable */ "./node_modules/rxjs/_esm5/internal/Observable.js");
/* harmony import */ var _util_subscribeToArray__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../util/subscribeToArray */ "./node_modules/rxjs/_esm5/internal/util/subscribeToArray.js");
/* harmony import */ var _scheduled_scheduleArray__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../scheduled/scheduleArray */ "./node_modules/rxjs/_esm5/internal/scheduled/scheduleArray.js");
/** PURE_IMPORTS_START _Observable,_util_subscribeToArray,_scheduled_scheduleArray PURE_IMPORTS_END */



function fromArray(input, scheduler) {
    if (!scheduler) {
        return new _Observable__WEBPACK_IMPORTED_MODULE_0__["Observable"](Object(_util_subscribeToArray__WEBPACK_IMPORTED_MODULE_1__["subscribeToArray"])(input));
    }
    else {
        return Object(_scheduled_scheduleArray__WEBPACK_IMPORTED_MODULE_2__["scheduleArray"])(input, scheduler);
    }
}
//# sourceMappingURL=fromArray.js.map


/***/ }),

/***/ "./node_modules/rxjs/_esm5/internal/observable/fromEvent.js":
/*!******************************************************************!*\
  !*** ./node_modules/rxjs/_esm5/internal/observable/fromEvent.js ***!
  \******************************************************************/
/*! exports provided: fromEvent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fromEvent", function() { return fromEvent; });
/* harmony import */ var _Observable__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../Observable */ "./node_modules/rxjs/_esm5/internal/Observable.js");
/* harmony import */ var _util_isArray__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../util/isArray */ "./node_modules/rxjs/_esm5/internal/util/isArray.js");
/* harmony import */ var _util_isFunction__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../util/isFunction */ "./node_modules/rxjs/_esm5/internal/util/isFunction.js");
/* harmony import */ var _operators_map__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../operators/map */ "./node_modules/rxjs/_esm5/internal/operators/map.js");
/** PURE_IMPORTS_START _Observable,_util_isArray,_util_isFunction,_operators_map PURE_IMPORTS_END */




var toString = /*@__PURE__*/ (function () { return Object.prototype.toString; })();
function fromEvent(target, eventName, options, resultSelector) {
    if (Object(_util_isFunction__WEBPACK_IMPORTED_MODULE_2__["isFunction"])(options)) {
        resultSelector = options;
        options = undefined;
    }
    if (resultSelector) {
        return fromEvent(target, eventName, options).pipe(Object(_operators_map__WEBPACK_IMPORTED_MODULE_3__["map"])(function (args) { return Object(_util_isArray__WEBPACK_IMPORTED_MODULE_1__["isArray"])(args) ? resultSelector.apply(void 0, args) : resultSelector(args); }));
    }
    return new _Observable__WEBPACK_IMPORTED_MODULE_0__["Observable"](function (subscriber) {
        function handler(e) {
            if (arguments.length > 1) {
                subscriber.next(Array.prototype.slice.call(arguments));
            }
            else {
                subscriber.next(e);
            }
        }
        setupSubscription(target, eventName, handler, subscriber, options);
    });
}
function setupSubscription(sourceObj, eventName, handler, subscriber, options) {
    var unsubscribe;
    if (isEventTarget(sourceObj)) {
        var source_1 = sourceObj;
        sourceObj.addEventListener(eventName, handler, options);
        unsubscribe = function () { return source_1.removeEventListener(eventName, handler, options); };
    }
    else if (isJQueryStyleEventEmitter(sourceObj)) {
        var source_2 = sourceObj;
        sourceObj.on(eventName, handler);
        unsubscribe = function () { return source_2.off(eventName, handler); };
    }
    else if (isNodeStyleEventEmitter(sourceObj)) {
        var source_3 = sourceObj;
        sourceObj.addListener(eventName, handler);
        unsubscribe = function () { return source_3.removeListener(eventName, handler); };
    }
    else if (sourceObj && sourceObj.length) {
        for (var i = 0, len = sourceObj.length; i < len; i++) {
            setupSubscription(sourceObj[i], eventName, handler, subscriber, options);
        }
    }
    else {
        throw new TypeError('Invalid event target');
    }
    subscriber.add(unsubscribe);
}
function isNodeStyleEventEmitter(sourceObj) {
    return sourceObj && typeof sourceObj.addListener === 'function' && typeof sourceObj.removeListener === 'function';
}
function isJQueryStyleEventEmitter(sourceObj) {
    return sourceObj && typeof sourceObj.on === 'function' && typeof sourceObj.off === 'function';
}
function isEventTarget(sourceObj) {
    return sourceObj && typeof sourceObj.addEventListener === 'function' && typeof sourceObj.removeEventListener === 'function';
}
//# sourceMappingURL=fromEvent.js.map


/***/ }),

/***/ "./node_modules/rxjs/_esm5/internal/observable/fromEventPattern.js":
/*!*************************************************************************!*\
  !*** ./node_modules/rxjs/_esm5/internal/observable/fromEventPattern.js ***!
  \*************************************************************************/
/*! exports provided: fromEventPattern */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fromEventPattern", function() { return fromEventPattern; });
/* harmony import */ var _Observable__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../Observable */ "./node_modules/rxjs/_esm5/internal/Observable.js");
/* harmony import */ var _util_isArray__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../util/isArray */ "./node_modules/rxjs/_esm5/internal/util/isArray.js");
/* harmony import */ var _util_isFunction__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../util/isFunction */ "./node_modules/rxjs/_esm5/internal/util/isFunction.js");
/* harmony import */ var _operators_map__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../operators/map */ "./node_modules/rxjs/_esm5/internal/operators/map.js");
/** PURE_IMPORTS_START _Observable,_util_isArray,_util_isFunction,_operators_map PURE_IMPORTS_END */




function fromEventPattern(addHandler, removeHandler, resultSelector) {
    if (resultSelector) {
        return fromEventPattern(addHandler, removeHandler).pipe(Object(_operators_map__WEBPACK_IMPORTED_MODULE_3__["map"])(function (args) { return Object(_util_isArray__WEBPACK_IMPORTED_MODULE_1__["isArray"])(args) ? resultSelector.apply(void 0, args) : resultSelector(args); }));
    }
    return new _Observable__WEBPACK_IMPORTED_MODULE_0__["Observable"](function (subscriber) {
        var handler = function () {
            var e = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                e[_i] = arguments[_i];
            }
            return subscriber.next(e.length === 1 ? e[0] : e);
        };
        var retValue;
        try {
            retValue = addHandler(handler);
        }
        catch (err) {
            subscriber.error(err);
            return undefined;
        }
        if (!Object(_util_isFunction__WEBPACK_IMPORTED_MODULE_2__["isFunction"])(removeHandler)) {
            return undefined;
        }
        return function () { return removeHandler(handler, retValue); };
    });
}
//# sourceMappingURL=fromEventPattern.js.map


/***/ }),

/***/ "./node_modules/rxjs/_esm5/internal/observable/generate.js":
/*!*****************************************************************!*\
  !*** ./node_modules/rxjs/_esm5/internal/observable/generate.js ***!
  \*****************************************************************/
/*! exports provided: generate */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "generate", function() { return generate; });
/* harmony import */ var _Observable__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../Observable */ "./node_modules/rxjs/_esm5/internal/Observable.js");
/* harmony import */ var _util_identity__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../util/identity */ "./node_modules/rxjs/_esm5/internal/util/identity.js");
/* harmony import */ var _util_isScheduler__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../util/isScheduler */ "./node_modules/rxjs/_esm5/internal/util/isScheduler.js");
/** PURE_IMPORTS_START _Observable,_util_identity,_util_isScheduler PURE_IMPORTS_END */



function generate(initialStateOrOptions, condition, iterate, resultSelectorOrObservable, scheduler) {
    var resultSelector;
    var initialState;
    if (arguments.length == 1) {
        var options = initialStateOrOptions;
        initialState = options.initialState;
        condition = options.condition;
        iterate = options.iterate;
        resultSelector = options.resultSelector || _util_identity__WEBPACK_IMPORTED_MODULE_1__["identity"];
        scheduler = options.scheduler;
    }
    else if (resultSelectorOrObservable === undefined || Object(_util_isScheduler__WEBPACK_IMPORTED_MODULE_2__["isScheduler"])(resultSelectorOrObservable)) {
        initialState = initialStateOrOptions;
        resultSelector = _util_identity__WEBPACK_IMPORTED_MODULE_1__["identity"];
        scheduler = resultSelectorOrObservable;
    }
    else {
        initialState = initialStateOrOptions;
        resultSelector = resultSelectorOrObservable;
    }
    return new _Observable__WEBPACK_IMPORTED_MODULE_0__["Observable"](function (subscriber) {
        var state = initialState;
        if (scheduler) {
            return scheduler.schedule(dispatch, 0, {
                subscriber: subscriber,
                iterate: iterate,
                condition: condition,
                resultSelector: resultSelector,
                state: state
            });
        }
        do {
            if (condition) {
                var conditionResult = void 0;
                try {
                    conditionResult = condition(state);
                }
                catch (err) {
                    subscriber.error(err);
                    return undefined;
                }
                if (!conditionResult) {
                    subscriber.complete();
                    break;
                }
            }
            var value = void 0;
            try {
                value = resultSelector(state);
            }
            catch (err) {
                subscriber.error(err);
                return undefined;
            }
            subscriber.next(value);
            if (subscriber.closed) {
                break;
            }
            try {
                state = iterate(state);
            }
            catch (err) {
                subscriber.error(err);
                return undefined;
            }
        } while (true);
        return undefined;
    });
}
function dispatch(state) {
    var subscriber = state.subscriber, condition = state.condition;
    if (subscriber.closed) {
        return undefined;
    }
    if (state.needIterate) {
        try {
            state.state = state.iterate(state.state);
        }
        catch (err) {
            subscriber.error(err);
            return undefined;
        }
    }
    else {
        state.needIterate = true;
    }
    if (condition) {
        var conditionResult = void 0;
        try {
            conditionResult = condition(state.state);
        }
        catch (err) {
            subscriber.error(err);
            return undefined;
        }
        if (!conditionResult) {
            subscriber.complete();
            return undefined;
        }
        if (subscriber.closed) {
            return undefined;
        }
    }
    var value;
    try {
        value = state.resultSelector(state.state);
    }
    catch (err) {
        subscriber.error(err);
        return undefined;
    }
    if (subscriber.closed) {
        return undefined;
    }
    subscriber.next(value);
    if (subscriber.closed) {
        return undefined;
    }
    return this.schedule(state);
}
//# sourceMappingURL=generate.js.map


/***/ }),

/***/ "./node_modules/rxjs/_esm5/internal/observable/iif.js":
/*!************************************************************!*\
  !*** ./node_modules/rxjs/_esm5/internal/observable/iif.js ***!
  \************************************************************/
/*! exports provided: iif */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "iif", function() { return iif; });
/* harmony import */ var _defer__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./defer */ "./node_modules/rxjs/_esm5/internal/observable/defer.js");
/* harmony import */ var _empty__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./empty */ "./node_modules/rxjs/_esm5/internal/observable/empty.js");
/** PURE_IMPORTS_START _defer,_empty PURE_IMPORTS_END */


function iif(condition, trueResult, falseResult) {
    if (trueResult === void 0) {
        trueResult = _empty__WEBPACK_IMPORTED_MODULE_1__["EMPTY"];
    }
    if (falseResult === void 0) {
        falseResult = _empty__WEBPACK_IMPORTED_MODULE_1__["EMPTY"];
    }
    return Object(_defer__WEBPACK_IMPORTED_MODULE_0__["defer"])(function () { return condition() ? trueResult : falseResult; });
}
//# sourceMappingURL=iif.js.map


/***/ }),

/***/ "./node_modules/rxjs/_esm5/internal/observable/interval.js":
/*!*****************************************************************!*\
  !*** ./node_modules/rxjs/_esm5/internal/observable/interval.js ***!
  \*****************************************************************/
/*! exports provided: interval */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "interval", function() { return interval; });
/* harmony import */ var _Observable__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../Observable */ "./node_modules/rxjs/_esm5/internal/Observable.js");
/* harmony import */ var _scheduler_async__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../scheduler/async */ "./node_modules/rxjs/_esm5/internal/scheduler/async.js");
/* harmony import */ var _util_isNumeric__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../util/isNumeric */ "./node_modules/rxjs/_esm5/internal/util/isNumeric.js");
/** PURE_IMPORTS_START _Observable,_scheduler_async,_util_isNumeric PURE_IMPORTS_END */



function interval(period, scheduler) {
    if (period === void 0) {
        period = 0;
    }
    if (scheduler === void 0) {
        scheduler = _scheduler_async__WEBPACK_IMPORTED_MODULE_1__["async"];
    }
    if (!Object(_util_isNumeric__WEBPACK_IMPORTED_MODULE_2__["isNumeric"])(period) || period < 0) {
        period = 0;
    }
    if (!scheduler || typeof scheduler.schedule !== 'function') {
        scheduler = _scheduler_async__WEBPACK_IMPORTED_MODULE_1__["async"];
    }
    return new _Observable__WEBPACK_IMPORTED_MODULE_0__["Observable"](function (subscriber) {
        subscriber.add(scheduler.schedule(dispatch, period, { subscriber: subscriber, counter: 0, period: period }));
        return subscriber;
    });
}
function dispatch(state) {
    var subscriber = state.subscriber, counter = state.counter, period = state.period;
    subscriber.next(counter);
    this.schedule({ subscriber: subscriber, counter: counter + 1, period: period }, period);
}
//# sourceMappingURL=interval.js.map


/***/ }),

/***/ "./node_modules/rxjs/_esm5/internal/observable/merge.js":
/*!**************************************************************!*\
  !*** ./node_modules/rxjs/_esm5/internal/observable/merge.js ***!
  \**************************************************************/
/*! exports provided: merge */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "merge", function() { return merge; });
/* harmony import */ var _Observable__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../Observable */ "./node_modules/rxjs/_esm5/internal/Observable.js");
/* harmony import */ var _util_isScheduler__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../util/isScheduler */ "./node_modules/rxjs/_esm5/internal/util/isScheduler.js");
/* harmony import */ var _operators_mergeAll__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../operators/mergeAll */ "./node_modules/rxjs/_esm5/internal/operators/mergeAll.js");
/* harmony import */ var _fromArray__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./fromArray */ "./node_modules/rxjs/_esm5/internal/observable/fromArray.js");
/** PURE_IMPORTS_START _Observable,_util_isScheduler,_operators_mergeAll,_fromArray PURE_IMPORTS_END */




function merge() {
    var observables = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        observables[_i] = arguments[_i];
    }
    var concurrent = Number.POSITIVE_INFINITY;
    var scheduler = null;
    var last = observables[observables.length - 1];
    if (Object(_util_isScheduler__WEBPACK_IMPORTED_MODULE_1__["isScheduler"])(last)) {
        scheduler = observables.pop();
        if (observables.length > 1 && typeof observables[observables.length - 1] === 'number') {
            concurrent = observables.pop();
        }
    }
    else if (typeof last === 'number') {
        concurrent = observables.pop();
    }
    if (scheduler === null && observables.length === 1 && observables[0] instanceof _Observable__WEBPACK_IMPORTED_MODULE_0__["Observable"]) {
        return observables[0];
    }
    return Object(_operators_mergeAll__WEBPACK_IMPORTED_MODULE_2__["mergeAll"])(concurrent)(Object(_fromArray__WEBPACK_IMPORTED_MODULE_3__["fromArray"])(observables, scheduler));
}
//# sourceMappingURL=merge.js.map


/***/ }),

/***/ "./node_modules/rxjs/_esm5/internal/observable/never.js":
/*!**************************************************************!*\
  !*** ./node_modules/rxjs/_esm5/internal/observable/never.js ***!
  \**************************************************************/
/*! exports provided: NEVER, never */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "NEVER", function() { return NEVER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "never", function() { return never; });
/* harmony import */ var _Observable__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../Observable */ "./node_modules/rxjs/_esm5/internal/Observable.js");
/* harmony import */ var _util_noop__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../util/noop */ "./node_modules/rxjs/_esm5/internal/util/noop.js");
/** PURE_IMPORTS_START _Observable,_util_noop PURE_IMPORTS_END */


var NEVER = /*@__PURE__*/ new _Observable__WEBPACK_IMPORTED_MODULE_0__["Observable"](_util_noop__WEBPACK_IMPORTED_MODULE_1__["noop"]);
function never() {
    return NEVER;
}
//# sourceMappingURL=never.js.map


/***/ }),

/***/ "./node_modules/rxjs/_esm5/internal/observable/of.js":
/*!***********************************************************!*\
  !*** ./node_modules/rxjs/_esm5/internal/observable/of.js ***!
  \***********************************************************/
/*! exports provided: of */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "of", function() { return of; });
/* harmony import */ var _util_isScheduler__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../util/isScheduler */ "./node_modules/rxjs/_esm5/internal/util/isScheduler.js");
/* harmony import */ var _fromArray__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./fromArray */ "./node_modules/rxjs/_esm5/internal/observable/fromArray.js");
/* harmony import */ var _scheduled_scheduleArray__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../scheduled/scheduleArray */ "./node_modules/rxjs/_esm5/internal/scheduled/scheduleArray.js");
/** PURE_IMPORTS_START _util_isScheduler,_fromArray,_scheduled_scheduleArray PURE_IMPORTS_END */



function of() {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    var scheduler = args[args.length - 1];
    if (Object(_util_isScheduler__WEBPACK_IMPORTED_MODULE_0__["isScheduler"])(scheduler)) {
        args.pop();
        return Object(_scheduled_scheduleArray__WEBPACK_IMPORTED_MODULE_2__["scheduleArray"])(args, scheduler);
    }
    else {
        return Object(_fromArray__WEBPACK_IMPORTED_MODULE_1__["fromArray"])(args);
    }
}
//# sourceMappingURL=of.js.map


/***/ }),

/***/ "./node_modules/rxjs/_esm5/internal/observable/onErrorResumeNext.js":
/*!**************************************************************************!*\
  !*** ./node_modules/rxjs/_esm5/internal/observable/onErrorResumeNext.js ***!
  \**************************************************************************/
/*! exports provided: onErrorResumeNext */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "onErrorResumeNext", function() { return onErrorResumeNext; });
/* harmony import */ var _Observable__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../Observable */ "./node_modules/rxjs/_esm5/internal/Observable.js");
/* harmony import */ var _from__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./from */ "./node_modules/rxjs/_esm5/internal/observable/from.js");
/* harmony import */ var _util_isArray__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../util/isArray */ "./node_modules/rxjs/_esm5/internal/util/isArray.js");
/* harmony import */ var _empty__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./empty */ "./node_modules/rxjs/_esm5/internal/observable/empty.js");
/** PURE_IMPORTS_START _Observable,_from,_util_isArray,_empty PURE_IMPORTS_END */




function onErrorResumeNext() {
    var sources = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        sources[_i] = arguments[_i];
    }
    if (sources.length === 0) {
        return _empty__WEBPACK_IMPORTED_MODULE_3__["EMPTY"];
    }
    var first = sources[0], remainder = sources.slice(1);
    if (sources.length === 1 && Object(_util_isArray__WEBPACK_IMPORTED_MODULE_2__["isArray"])(first)) {
        return onErrorResumeNext.apply(void 0, first);
    }
    return new _Observable__WEBPACK_IMPORTED_MODULE_0__["Observable"](function (subscriber) {
        var subNext = function () { return subscriber.add(onErrorResumeNext.apply(void 0, remainder).subscribe(subscriber)); };
        return Object(_from__WEBPACK_IMPORTED_MODULE_1__["from"])(first).subscribe({
            next: function (value) { subscriber.next(value); },
            error: subNext,
            complete: subNext,
        });
    });
}
//# sourceMappingURL=onErrorResumeNext.js.map


/***/ }),

/***/ "./node_modules/rxjs/_esm5/internal/observable/pairs.js":
/*!**************************************************************!*\
  !*** ./node_modules/rxjs/_esm5/internal/observable/pairs.js ***!
  \**************************************************************/
/*! exports provided: pairs, dispatch */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "pairs", function() { return pairs; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "dispatch", function() { return dispatch; });
/* harmony import */ var _Observable__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../Observable */ "./node_modules/rxjs/_esm5/internal/Observable.js");
/* harmony import */ var _Subscription__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../Subscription */ "./node_modules/rxjs/_esm5/internal/Subscription.js");
/** PURE_IMPORTS_START _Observable,_Subscription PURE_IMPORTS_END */


function pairs(obj, scheduler) {
    if (!scheduler) {
        return new _Observable__WEBPACK_IMPORTED_MODULE_0__["Observable"](function (subscriber) {
            var keys = Object.keys(obj);
            for (var i = 0; i < keys.length && !subscriber.closed; i++) {
                var key = keys[i];
                if (obj.hasOwnProperty(key)) {
                    subscriber.next([key, obj[key]]);
                }
            }
            subscriber.complete();
        });
    }
    else {
        return new _Observable__WEBPACK_IMPORTED_MODULE_0__["Observable"](function (subscriber) {
            var keys = Object.keys(obj);
            var subscription = new _Subscription__WEBPACK_IMPORTED_MODULE_1__["Subscription"]();
            subscription.add(scheduler.schedule(dispatch, 0, { keys: keys, index: 0, subscriber: subscriber, subscription: subscription, obj: obj }));
            return subscription;
        });
    }
}
function dispatch(state) {
    var keys = state.keys, index = state.index, subscriber = state.subscriber, subscription = state.subscription, obj = state.obj;
    if (!subscriber.closed) {
        if (index < keys.length) {
            var key = keys[index];
            subscriber.next([key, obj[key]]);
            subscription.add(this.schedule({ keys: keys, index: index + 1, subscriber: subscriber, subscription: subscription, obj: obj }));
        }
        else {
            subscriber.complete();
        }
    }
}
//# sourceMappingURL=pairs.js.map


/***/ }),

/***/ "./node_modules/rxjs/_esm5/internal/observable/partition.js":
/*!******************************************************************!*\
  !*** ./node_modules/rxjs/_esm5/internal/observable/partition.js ***!
  \******************************************************************/
/*! exports provided: partition */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "partition", function() { return partition; });
/* harmony import */ var _util_not__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../util/not */ "./node_modules/rxjs/_esm5/internal/util/not.js");
/* harmony import */ var _util_subscribeTo__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../util/subscribeTo */ "./node_modules/rxjs/_esm5/internal/util/subscribeTo.js");
/* harmony import */ var _operators_filter__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../operators/filter */ "./node_modules/rxjs/_esm5/internal/operators/filter.js");
/* harmony import */ var _Observable__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../Observable */ "./node_modules/rxjs/_esm5/internal/Observable.js");
/** PURE_IMPORTS_START _util_not,_util_subscribeTo,_operators_filter,_Observable PURE_IMPORTS_END */




function partition(source, predicate, thisArg) {
    return [
        Object(_operators_filter__WEBPACK_IMPORTED_MODULE_2__["filter"])(predicate, thisArg)(new _Observable__WEBPACK_IMPORTED_MODULE_3__["Observable"](Object(_util_subscribeTo__WEBPACK_IMPORTED_MODULE_1__["subscribeTo"])(source))),
        Object(_operators_filter__WEBPACK_IMPORTED_MODULE_2__["filter"])(Object(_util_not__WEBPACK_IMPORTED_MODULE_0__["not"])(predicate, thisArg))(new _Observable__WEBPACK_IMPORTED_MODULE_3__["Observable"](Object(_util_subscribeTo__WEBPACK_IMPORTED_MODULE_1__["subscribeTo"])(source)))
    ];
}
//# sourceMappingURL=partition.js.map


/***/ }),

/***/ "./node_modules/rxjs/_esm5/internal/observable/race.js":
/*!*************************************************************!*\
  !*** ./node_modules/rxjs/_esm5/internal/observable/race.js ***!
  \*************************************************************/
/*! exports provided: race, RaceOperator, RaceSubscriber */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "race", function() { return race; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "RaceOperator", function() { return RaceOperator; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "RaceSubscriber", function() { return RaceSubscriber; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/rxjs/node_modules/tslib/tslib.es6.js");
/* harmony import */ var _util_isArray__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../util/isArray */ "./node_modules/rxjs/_esm5/internal/util/isArray.js");
/* harmony import */ var _fromArray__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./fromArray */ "./node_modules/rxjs/_esm5/internal/observable/fromArray.js");
/* harmony import */ var _OuterSubscriber__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../OuterSubscriber */ "./node_modules/rxjs/_esm5/internal/OuterSubscriber.js");
/* harmony import */ var _util_subscribeToResult__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../util/subscribeToResult */ "./node_modules/rxjs/_esm5/internal/util/subscribeToResult.js");
/** PURE_IMPORTS_START tslib,_util_isArray,_fromArray,_OuterSubscriber,_util_subscribeToResult PURE_IMPORTS_END */





function race() {
    var observables = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        observables[_i] = arguments[_i];
    }
    if (observables.length === 1) {
        if (Object(_util_isArray__WEBPACK_IMPORTED_MODULE_1__["isArray"])(observables[0])) {
            observables = observables[0];
        }
        else {
            return observables[0];
        }
    }
    return Object(_fromArray__WEBPACK_IMPORTED_MODULE_2__["fromArray"])(observables, undefined).lift(new RaceOperator());
}
var RaceOperator = /*@__PURE__*/ (function () {
    function RaceOperator() {
    }
    RaceOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new RaceSubscriber(subscriber));
    };
    return RaceOperator;
}());

var RaceSubscriber = /*@__PURE__*/ (function (_super) {
    tslib__WEBPACK_IMPORTED_MODULE_0__["__extends"](RaceSubscriber, _super);
    function RaceSubscriber(destination) {
        var _this = _super.call(this, destination) || this;
        _this.hasFirst = false;
        _this.observables = [];
        _this.subscriptions = [];
        return _this;
    }
    RaceSubscriber.prototype._next = function (observable) {
        this.observables.push(observable);
    };
    RaceSubscriber.prototype._complete = function () {
        var observables = this.observables;
        var len = observables.length;
        if (len === 0) {
            this.destination.complete();
        }
        else {
            for (var i = 0; i < len && !this.hasFirst; i++) {
                var observable = observables[i];
                var subscription = Object(_util_subscribeToResult__WEBPACK_IMPORTED_MODULE_4__["subscribeToResult"])(this, observable, undefined, i);
                if (this.subscriptions) {
                    this.subscriptions.push(subscription);
                }
                this.add(subscription);
            }
            this.observables = null;
        }
    };
    RaceSubscriber.prototype.notifyNext = function (_outerValue, innerValue, outerIndex) {
        if (!this.hasFirst) {
            this.hasFirst = true;
            for (var i = 0; i < this.subscriptions.length; i++) {
                if (i !== outerIndex) {
                    var subscription = this.subscriptions[i];
                    subscription.unsubscribe();
                    this.remove(subscription);
                }
            }
            this.subscriptions = null;
        }
        this.destination.next(innerValue);
    };
    return RaceSubscriber;
}(_OuterSubscriber__WEBPACK_IMPORTED_MODULE_3__["OuterSubscriber"]));

//# sourceMappingURL=race.js.map


/***/ }),

/***/ "./node_modules/rxjs/_esm5/internal/observable/range.js":
/*!**************************************************************!*\
  !*** ./node_modules/rxjs/_esm5/internal/observable/range.js ***!
  \**************************************************************/
/*! exports provided: range, dispatch */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "range", function() { return range; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "dispatch", function() { return dispatch; });
/* harmony import */ var _Observable__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../Observable */ "./node_modules/rxjs/_esm5/internal/Observable.js");
/** PURE_IMPORTS_START _Observable PURE_IMPORTS_END */

function range(start, count, scheduler) {
    if (start === void 0) {
        start = 0;
    }
    return new _Observable__WEBPACK_IMPORTED_MODULE_0__["Observable"](function (subscriber) {
        if (count === undefined) {
            count = start;
            start = 0;
        }
        var index = 0;
        var current = start;
        if (scheduler) {
            return scheduler.schedule(dispatch, 0, {
                index: index, count: count, start: start, subscriber: subscriber
            });
        }
        else {
            do {
                if (index++ >= count) {
                    subscriber.complete();
                    break;
                }
                subscriber.next(current++);
                if (subscriber.closed) {
                    break;
                }
            } while (true);
        }
        return undefined;
    });
}
function dispatch(state) {
    var start = state.start, index = state.index, count = state.count, subscriber = state.subscriber;
    if (index >= count) {
        subscriber.complete();
        return;
    }
    subscriber.next(start);
    if (subscriber.closed) {
        return;
    }
    state.index = index + 1;
    state.start = start + 1;
    this.schedule(state);
}
//# sourceMappingURL=range.js.map


/***/ }),

/***/ "./node_modules/rxjs/_esm5/internal/observable/throwError.js":
/*!*******************************************************************!*\
  !*** ./node_modules/rxjs/_esm5/internal/observable/throwError.js ***!
  \*******************************************************************/
/*! exports provided: throwError */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "throwError", function() { return throwError; });
/* harmony import */ var _Observable__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../Observable */ "./node_modules/rxjs/_esm5/internal/Observable.js");
/** PURE_IMPORTS_START _Observable PURE_IMPORTS_END */

function throwError(error, scheduler) {
    if (!scheduler) {
        return new _Observable__WEBPACK_IMPORTED_MODULE_0__["Observable"](function (subscriber) { return subscriber.error(error); });
    }
    else {
        return new _Observable__WEBPACK_IMPORTED_MODULE_0__["Observable"](function (subscriber) { return scheduler.schedule(dispatch, 0, { error: error, subscriber: subscriber }); });
    }
}
function dispatch(_a) {
    var error = _a.error, subscriber = _a.subscriber;
    subscriber.error(error);
}
//# sourceMappingURL=throwError.js.map


/***/ }),

/***/ "./node_modules/rxjs/_esm5/internal/observable/timer.js":
/*!**************************************************************!*\
  !*** ./node_modules/rxjs/_esm5/internal/observable/timer.js ***!
  \**************************************************************/
/*! exports provided: timer */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "timer", function() { return timer; });
/* harmony import */ var _Observable__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../Observable */ "./node_modules/rxjs/_esm5/internal/Observable.js");
/* harmony import */ var _scheduler_async__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../scheduler/async */ "./node_modules/rxjs/_esm5/internal/scheduler/async.js");
/* harmony import */ var _util_isNumeric__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../util/isNumeric */ "./node_modules/rxjs/_esm5/internal/util/isNumeric.js");
/* harmony import */ var _util_isScheduler__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../util/isScheduler */ "./node_modules/rxjs/_esm5/internal/util/isScheduler.js");
/** PURE_IMPORTS_START _Observable,_scheduler_async,_util_isNumeric,_util_isScheduler PURE_IMPORTS_END */




function timer(dueTime, periodOrScheduler, scheduler) {
    if (dueTime === void 0) {
        dueTime = 0;
    }
    var period = -1;
    if (Object(_util_isNumeric__WEBPACK_IMPORTED_MODULE_2__["isNumeric"])(periodOrScheduler)) {
        period = Number(periodOrScheduler) < 1 && 1 || Number(periodOrScheduler);
    }
    else if (Object(_util_isScheduler__WEBPACK_IMPORTED_MODULE_3__["isScheduler"])(periodOrScheduler)) {
        scheduler = periodOrScheduler;
    }
    if (!Object(_util_isScheduler__WEBPACK_IMPORTED_MODULE_3__["isScheduler"])(scheduler)) {
        scheduler = _scheduler_async__WEBPACK_IMPORTED_MODULE_1__["async"];
    }
    return new _Observable__WEBPACK_IMPORTED_MODULE_0__["Observable"](function (subscriber) {
        var due = Object(_util_isNumeric__WEBPACK_IMPORTED_MODULE_2__["isNumeric"])(dueTime)
            ? dueTime
            : (+dueTime - scheduler.now());
        return scheduler.schedule(dispatch, due, {
            index: 0, period: period, subscriber: subscriber
        });
    });
}
function dispatch(state) {
    var index = state.index, period = state.period, subscriber = state.subscriber;
    subscriber.next(index);
    if (subscriber.closed) {
        return;
    }
    else if (period === -1) {
        return subscriber.complete();
    }
    state.index = index + 1;
    this.schedule(state, period);
}
//# sourceMappingURL=timer.js.map


/***/ }),

/***/ "./node_modules/rxjs/_esm5/internal/observable/using.js":
/*!**************************************************************!*\
  !*** ./node_modules/rxjs/_esm5/internal/observable/using.js ***!
  \**************************************************************/
/*! exports provided: using */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "using", function() { return using; });
/* harmony import */ var _Observable__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../Observable */ "./node_modules/rxjs/_esm5/internal/Observable.js");
/* harmony import */ var _from__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./from */ "./node_modules/rxjs/_esm5/internal/observable/from.js");
/* harmony import */ var _empty__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./empty */ "./node_modules/rxjs/_esm5/internal/observable/empty.js");
/** PURE_IMPORTS_START _Observable,_from,_empty PURE_IMPORTS_END */



function using(resourceFactory, observableFactory) {
    return new _Observable__WEBPACK_IMPORTED_MODULE_0__["Observable"](function (subscriber) {
        var resource;
        try {
            resource = resourceFactory();
        }
        catch (err) {
            subscriber.error(err);
            return undefined;
        }
        var result;
        try {
            result = observableFactory(resource);
        }
        catch (err) {
            subscriber.error(err);
            return undefined;
        }
        var source = result ? Object(_from__WEBPACK_IMPORTED_MODULE_1__["from"])(result) : _empty__WEBPACK_IMPORTED_MODULE_2__["EMPTY"];
        var subscription = source.subscribe(subscriber);
        return function () {
            subscription.unsubscribe();
            if (resource) {
                resource.unsubscribe();
            }
        };
    });
}
//# sourceMappingURL=using.js.map


/***/ }),

/***/ "./node_modules/rxjs/_esm5/internal/observable/zip.js":
/*!************************************************************!*\
  !*** ./node_modules/rxjs/_esm5/internal/observable/zip.js ***!
  \************************************************************/
/*! exports provided: zip, ZipOperator, ZipSubscriber */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "zip", function() { return zip; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ZipOperator", function() { return ZipOperator; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ZipSubscriber", function() { return ZipSubscriber; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/rxjs/node_modules/tslib/tslib.es6.js");
/* harmony import */ var _fromArray__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./fromArray */ "./node_modules/rxjs/_esm5/internal/observable/fromArray.js");
/* harmony import */ var _util_isArray__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../util/isArray */ "./node_modules/rxjs/_esm5/internal/util/isArray.js");
/* harmony import */ var _Subscriber__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../Subscriber */ "./node_modules/rxjs/_esm5/internal/Subscriber.js");
/* harmony import */ var _internal_symbol_iterator__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../internal/symbol/iterator */ "./node_modules/rxjs/_esm5/internal/symbol/iterator.js");
/* harmony import */ var _innerSubscribe__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../innerSubscribe */ "./node_modules/rxjs/_esm5/internal/innerSubscribe.js");
/** PURE_IMPORTS_START tslib,_fromArray,_util_isArray,_Subscriber,_.._internal_symbol_iterator,_innerSubscribe PURE_IMPORTS_END */






function zip() {
    var observables = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        observables[_i] = arguments[_i];
    }
    var resultSelector = observables[observables.length - 1];
    if (typeof resultSelector === 'function') {
        observables.pop();
    }
    return Object(_fromArray__WEBPACK_IMPORTED_MODULE_1__["fromArray"])(observables, undefined).lift(new ZipOperator(resultSelector));
}
var ZipOperator = /*@__PURE__*/ (function () {
    function ZipOperator(resultSelector) {
        this.resultSelector = resultSelector;
    }
    ZipOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new ZipSubscriber(subscriber, this.resultSelector));
    };
    return ZipOperator;
}());

var ZipSubscriber = /*@__PURE__*/ (function (_super) {
    tslib__WEBPACK_IMPORTED_MODULE_0__["__extends"](ZipSubscriber, _super);
    function ZipSubscriber(destination, resultSelector, values) {
        if (values === void 0) {
            values = Object.create(null);
        }
        var _this = _super.call(this, destination) || this;
        _this.resultSelector = resultSelector;
        _this.iterators = [];
        _this.active = 0;
        _this.resultSelector = (typeof resultSelector === 'function') ? resultSelector : undefined;
        return _this;
    }
    ZipSubscriber.prototype._next = function (value) {
        var iterators = this.iterators;
        if (Object(_util_isArray__WEBPACK_IMPORTED_MODULE_2__["isArray"])(value)) {
            iterators.push(new StaticArrayIterator(value));
        }
        else if (typeof value[_internal_symbol_iterator__WEBPACK_IMPORTED_MODULE_4__["iterator"]] === 'function') {
            iterators.push(new StaticIterator(value[_internal_symbol_iterator__WEBPACK_IMPORTED_MODULE_4__["iterator"]]()));
        }
        else {
            iterators.push(new ZipBufferIterator(this.destination, this, value));
        }
    };
    ZipSubscriber.prototype._complete = function () {
        var iterators = this.iterators;
        var len = iterators.length;
        this.unsubscribe();
        if (len === 0) {
            this.destination.complete();
            return;
        }
        this.active = len;
        for (var i = 0; i < len; i++) {
            var iterator = iterators[i];
            if (iterator.stillUnsubscribed) {
                var destination = this.destination;
                destination.add(iterator.subscribe());
            }
            else {
                this.active--;
            }
        }
    };
    ZipSubscriber.prototype.notifyInactive = function () {
        this.active--;
        if (this.active === 0) {
            this.destination.complete();
        }
    };
    ZipSubscriber.prototype.checkIterators = function () {
        var iterators = this.iterators;
        var len = iterators.length;
        var destination = this.destination;
        for (var i = 0; i < len; i++) {
            var iterator = iterators[i];
            if (typeof iterator.hasValue === 'function' && !iterator.hasValue()) {
                return;
            }
        }
        var shouldComplete = false;
        var args = [];
        for (var i = 0; i < len; i++) {
            var iterator = iterators[i];
            var result = iterator.next();
            if (iterator.hasCompleted()) {
                shouldComplete = true;
            }
            if (result.done) {
                destination.complete();
                return;
            }
            args.push(result.value);
        }
        if (this.resultSelector) {
            this._tryresultSelector(args);
        }
        else {
            destination.next(args);
        }
        if (shouldComplete) {
            destination.complete();
        }
    };
    ZipSubscriber.prototype._tryresultSelector = function (args) {
        var result;
        try {
            result = this.resultSelector.apply(this, args);
        }
        catch (err) {
            this.destination.error(err);
            return;
        }
        this.destination.next(result);
    };
    return ZipSubscriber;
}(_Subscriber__WEBPACK_IMPORTED_MODULE_3__["Subscriber"]));

var StaticIterator = /*@__PURE__*/ (function () {
    function StaticIterator(iterator) {
        this.iterator = iterator;
        this.nextResult = iterator.next();
    }
    StaticIterator.prototype.hasValue = function () {
        return true;
    };
    StaticIterator.prototype.next = function () {
        var result = this.nextResult;
        this.nextResult = this.iterator.next();
        return result;
    };
    StaticIterator.prototype.hasCompleted = function () {
        var nextResult = this.nextResult;
        return Boolean(nextResult && nextResult.done);
    };
    return StaticIterator;
}());
var StaticArrayIterator = /*@__PURE__*/ (function () {
    function StaticArrayIterator(array) {
        this.array = array;
        this.index = 0;
        this.length = 0;
        this.length = array.length;
    }
    StaticArrayIterator.prototype[_internal_symbol_iterator__WEBPACK_IMPORTED_MODULE_4__["iterator"]] = function () {
        return this;
    };
    StaticArrayIterator.prototype.next = function (value) {
        var i = this.index++;
        var array = this.array;
        return i < this.length ? { value: array[i], done: false } : { value: null, done: true };
    };
    StaticArrayIterator.prototype.hasValue = function () {
        return this.array.length > this.index;
    };
    StaticArrayIterator.prototype.hasCompleted = function () {
        return this.array.length === this.index;
    };
    return StaticArrayIterator;
}());
var ZipBufferIterator = /*@__PURE__*/ (function (_super) {
    tslib__WEBPACK_IMPORTED_MODULE_0__["__extends"](ZipBufferIterator, _super);
    function ZipBufferIterator(destination, parent, observable) {
        var _this = _super.call(this, destination) || this;
        _this.parent = parent;
        _this.observable = observable;
        _this.stillUnsubscribed = true;
        _this.buffer = [];
        _this.isComplete = false;
        return _this;
    }
    ZipBufferIterator.prototype[_internal_symbol_iterator__WEBPACK_IMPORTED_MODULE_4__["iterator"]] = function () {
        return this;
    };
    ZipBufferIterator.prototype.next = function () {
        var buffer = this.buffer;
        if (buffer.length === 0 && this.isComplete) {
            return { value: null, done: true };
        }
        else {
            return { value: buffer.shift(), done: false };
        }
    };
    ZipBufferIterator.prototype.hasValue = function () {
        return this.buffer.length > 0;
    };
    ZipBufferIterator.prototype.hasCompleted = function () {
        return this.buffer.length === 0 && this.isComplete;
    };
    ZipBufferIterator.prototype.notifyComplete = function () {
        if (this.buffer.length > 0) {
            this.isComplete = true;
            this.parent.notifyInactive();
        }
        else {
            this.destination.complete();
        }
    };
    ZipBufferIterator.prototype.notifyNext = function (innerValue) {
        this.buffer.push(innerValue);
        this.parent.checkIterators();
    };
    ZipBufferIterator.prototype.subscribe = function () {
        return Object(_innerSubscribe__WEBPACK_IMPORTED_MODULE_5__["innerSubscribe"])(this.observable, new _innerSubscribe__WEBPACK_IMPORTED_MODULE_5__["SimpleInnerSubscriber"](this));
    };
    return ZipBufferIterator;
}(_innerSubscribe__WEBPACK_IMPORTED_MODULE_5__["SimpleOuterSubscriber"]));
//# sourceMappingURL=zip.js.map


/***/ }),

/***/ "./node_modules/rxjs/_esm5/internal/operators/audit.js":
/*!*************************************************************!*\
  !*** ./node_modules/rxjs/_esm5/internal/operators/audit.js ***!
  \*************************************************************/
/*! exports provided: audit */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "audit", function() { return audit; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/rxjs/node_modules/tslib/tslib.es6.js");
/* harmony import */ var _innerSubscribe__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../innerSubscribe */ "./node_modules/rxjs/_esm5/internal/innerSubscribe.js");
/** PURE_IMPORTS_START tslib,_innerSubscribe PURE_IMPORTS_END */


function audit(durationSelector) {
    return function auditOperatorFunction(source) {
        return source.lift(new AuditOperator(durationSelector));
    };
}
var AuditOperator = /*@__PURE__*/ (function () {
    function AuditOperator(durationSelector) {
        this.durationSelector = durationSelector;
    }
    AuditOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new AuditSubscriber(subscriber, this.durationSelector));
    };
    return AuditOperator;
}());
var AuditSubscriber = /*@__PURE__*/ (function (_super) {
    tslib__WEBPACK_IMPORTED_MODULE_0__["__extends"](AuditSubscriber, _super);
    function AuditSubscriber(destination, durationSelector) {
        var _this = _super.call(this, destination) || this;
        _this.durationSelector = durationSelector;
        _this.hasValue = false;
        return _this;
    }
    AuditSubscriber.prototype._next = function (value) {
        this.value = value;
        this.hasValue = true;
        if (!this.throttled) {
            var duration = void 0;
            try {
                var durationSelector = this.durationSelector;
                duration = durationSelector(value);
            }
            catch (err) {
                return this.destination.error(err);
            }
            var innerSubscription = Object(_innerSubscribe__WEBPACK_IMPORTED_MODULE_1__["innerSubscribe"])(duration, new _innerSubscribe__WEBPACK_IMPORTED_MODULE_1__["SimpleInnerSubscriber"](this));
            if (!innerSubscription || innerSubscription.closed) {
                this.clearThrottle();
            }
            else {
                this.add(this.throttled = innerSubscription);
            }
        }
    };
    AuditSubscriber.prototype.clearThrottle = function () {
        var _a = this, value = _a.value, hasValue = _a.hasValue, throttled = _a.throttled;
        if (throttled) {
            this.remove(throttled);
            this.throttled = undefined;
            throttled.unsubscribe();
        }
        if (hasValue) {
            this.value = undefined;
            this.hasValue = false;
            this.destination.next(value);
        }
    };
    AuditSubscriber.prototype.notifyNext = function () {
        this.clearThrottle();
    };
    AuditSubscriber.prototype.notifyComplete = function () {
        this.clearThrottle();
    };
    return AuditSubscriber;
}(_innerSubscribe__WEBPACK_IMPORTED_MODULE_1__["SimpleOuterSubscriber"]));
//# sourceMappingURL=audit.js.map


/***/ }),

/***/ "./node_modules/rxjs/_esm5/internal/operators/auditTime.js":
/*!*****************************************************************!*\
  !*** ./node_modules/rxjs/_esm5/internal/operators/auditTime.js ***!
  \*****************************************************************/
/*! exports provided: auditTime */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "auditTime", function() { return auditTime; });
/* harmony import */ var _scheduler_async__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../scheduler/async */ "./node_modules/rxjs/_esm5/internal/scheduler/async.js");
/* harmony import */ var _audit__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./audit */ "./node_modules/rxjs/_esm5/internal/operators/audit.js");
/* harmony import */ var _observable_timer__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../observable/timer */ "./node_modules/rxjs/_esm5/internal/observable/timer.js");
/** PURE_IMPORTS_START _scheduler_async,_audit,_observable_timer PURE_IMPORTS_END */



function auditTime(duration, scheduler) {
    if (scheduler === void 0) {
        scheduler = _scheduler_async__WEBPACK_IMPORTED_MODULE_0__["async"];
    }
    return Object(_audit__WEBPACK_IMPORTED_MODULE_1__["audit"])(function () { return Object(_observable_timer__WEBPACK_IMPORTED_MODULE_2__["timer"])(duration, scheduler); });
}
//# sourceMappingURL=auditTime.js.map


/***/ }),

/***/ "./node_modules/rxjs/_esm5/internal/operators/buffer.js":
/*!**************************************************************!*\
  !*** ./node_modules/rxjs/_esm5/internal/operators/buffer.js ***!
  \**************************************************************/
/*! exports provided: buffer */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "buffer", function() { return buffer; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/rxjs/node_modules/tslib/tslib.es6.js");
/* harmony import */ var _innerSubscribe__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../innerSubscribe */ "./node_modules/rxjs/_esm5/internal/innerSubscribe.js");
/** PURE_IMPORTS_START tslib,_innerSubscribe PURE_IMPORTS_END */


function buffer(closingNotifier) {
    return function bufferOperatorFunction(source) {
        return source.lift(new BufferOperator(closingNotifier));
    };
}
var BufferOperator = /*@__PURE__*/ (function () {
    function BufferOperator(closingNotifier) {
        this.closingNotifier = closingNotifier;
    }
    BufferOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new BufferSubscriber(subscriber, this.closingNotifier));
    };
    return BufferOperator;
}());
var BufferSubscriber = /*@__PURE__*/ (function (_super) {
    tslib__WEBPACK_IMPORTED_MODULE_0__["__extends"](BufferSubscriber, _super);
    function BufferSubscriber(destination, closingNotifier) {
        var _this = _super.call(this, destination) || this;
        _this.buffer = [];
        _this.add(Object(_innerSubscribe__WEBPACK_IMPORTED_MODULE_1__["innerSubscribe"])(closingNotifier, new _innerSubscribe__WEBPACK_IMPORTED_MODULE_1__["SimpleInnerSubscriber"](_this)));
        return _this;
    }
    BufferSubscriber.prototype._next = function (value) {
        this.buffer.push(value);
    };
    BufferSubscriber.prototype.notifyNext = function () {
        var buffer = this.buffer;
        this.buffer = [];
        this.destination.next(buffer);
    };
    return BufferSubscriber;
}(_innerSubscribe__WEBPACK_IMPORTED_MODULE_1__["SimpleOuterSubscriber"]));
//# sourceMappingURL=buffer.js.map


/***/ }),

/***/ "./node_modules/rxjs/_esm5/internal/operators/bufferCount.js":
/*!*******************************************************************!*\
  !*** ./node_modules/rxjs/_esm5/internal/operators/bufferCount.js ***!
  \*******************************************************************/
/*! exports provided: bufferCount */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "bufferCount", function() { return bufferCount; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/rxjs/node_modules/tslib/tslib.es6.js");
/* harmony import */ var _Subscriber__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../Subscriber */ "./node_modules/rxjs/_esm5/internal/Subscriber.js");
/** PURE_IMPORTS_START tslib,_Subscriber PURE_IMPORTS_END */


function bufferCount(bufferSize, startBufferEvery) {
    if (startBufferEvery === void 0) {
        startBufferEvery = null;
    }
    return function bufferCountOperatorFunction(source) {
        return source.lift(new BufferCountOperator(bufferSize, startBufferEvery));
    };
}
var BufferCountOperator = /*@__PURE__*/ (function () {
    function BufferCountOperator(bufferSize, startBufferEvery) {
        this.bufferSize = bufferSize;
        this.startBufferEvery = startBufferEvery;
        if (!startBufferEvery || bufferSize === startBufferEvery) {
            this.subscriberClass = BufferCountSubscriber;
        }
        else {
            this.subscriberClass = BufferSkipCountSubscriber;
        }
    }
    BufferCountOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new this.subscriberClass(subscriber, this.bufferSize, this.startBufferEvery));
    };
    return BufferCountOperator;
}());
var BufferCountSubscriber = /*@__PURE__*/ (function (_super) {
    tslib__WEBPACK_IMPORTED_MODULE_0__["__extends"](BufferCountSubscriber, _super);
    function BufferCountSubscriber(destination, bufferSize) {
        var _this = _super.call(this, destination) || this;
        _this.bufferSize = bufferSize;
        _this.buffer = [];
        return _this;
    }
    BufferCountSubscriber.prototype._next = function (value) {
        var buffer = this.buffer;
        buffer.push(value);
        if (buffer.length == this.bufferSize) {
            this.destination.next(buffer);
            this.buffer = [];
        }
    };
    BufferCountSubscriber.prototype._complete = function () {
        var buffer = this.buffer;
        if (buffer.length > 0) {
            this.destination.next(buffer);
        }
        _super.prototype._complete.call(this);
    };
    return BufferCountSubscriber;
}(_Subscriber__WEBPACK_IMPORTED_MODULE_1__["Subscriber"]));
var BufferSkipCountSubscriber = /*@__PURE__*/ (function (_super) {
    tslib__WEBPACK_IMPORTED_MODULE_0__["__extends"](BufferSkipCountSubscriber, _super);
    function BufferSkipCountSubscriber(destination, bufferSize, startBufferEvery) {
        var _this = _super.call(this, destination) || this;
        _this.bufferSize = bufferSize;
        _this.startBufferEvery = startBufferEvery;
        _this.buffers = [];
        _this.count = 0;
        return _this;
    }
    BufferSkipCountSubscriber.prototype._next = function (value) {
        var _a = this, bufferSize = _a.bufferSize, startBufferEvery = _a.startBufferEvery, buffers = _a.buffers, count = _a.count;
        this.count++;
        if (count % startBufferEvery === 0) {
            buffers.push([]);
        }
        for (var i = buffers.length; i--;) {
            var buffer = buffers[i];
            buffer.push(value);
            if (buffer.length === bufferSize) {
                buffers.splice(i, 1);
                this.destination.next(buffer);
            }
        }
    };
    BufferSkipCountSubscriber.prototype._complete = function () {
        var _a = this, buffers = _a.buffers, destination = _a.destination;
        while (buffers.length > 0) {
            var buffer = buffers.shift();
            if (buffer.length > 0) {
                destination.next(buffer);
            }
        }
        _super.prototype._complete.call(this);
    };
    return BufferSkipCountSubscriber;
}(_Subscriber__WEBPACK_IMPORTED_MODULE_1__["Subscriber"]));
//# sourceMappingURL=bufferCount.js.map


/***/ }),

/***/ "./node_modules/rxjs/_esm5/internal/operators/bufferTime.js":
/*!******************************************************************!*\
  !*** ./node_modules/rxjs/_esm5/internal/operators/bufferTime.js ***!
  \******************************************************************/
/*! exports provided: bufferTime */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "bufferTime", function() { return bufferTime; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/rxjs/node_modules/tslib/tslib.es6.js");
/* harmony import */ var _scheduler_async__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../scheduler/async */ "./node_modules/rxjs/_esm5/internal/scheduler/async.js");
/* harmony import */ var _Subscriber__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../Subscriber */ "./node_modules/rxjs/_esm5/internal/Subscriber.js");
/* harmony import */ var _util_isScheduler__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../util/isScheduler */ "./node_modules/rxjs/_esm5/internal/util/isScheduler.js");
/** PURE_IMPORTS_START tslib,_scheduler_async,_Subscriber,_util_isScheduler PURE_IMPORTS_END */




function bufferTime(bufferTimeSpan) {
    var length = arguments.length;
    var scheduler = _scheduler_async__WEBPACK_IMPORTED_MODULE_1__["async"];
    if (Object(_util_isScheduler__WEBPACK_IMPORTED_MODULE_3__["isScheduler"])(arguments[arguments.length - 1])) {
        scheduler = arguments[arguments.length - 1];
        length--;
    }
    var bufferCreationInterval = null;
    if (length >= 2) {
        bufferCreationInterval = arguments[1];
    }
    var maxBufferSize = Number.POSITIVE_INFINITY;
    if (length >= 3) {
        maxBufferSize = arguments[2];
    }
    return function bufferTimeOperatorFunction(source) {
        return source.lift(new BufferTimeOperator(bufferTimeSpan, bufferCreationInterval, maxBufferSize, scheduler));
    };
}
var BufferTimeOperator = /*@__PURE__*/ (function () {
    function BufferTimeOperator(bufferTimeSpan, bufferCreationInterval, maxBufferSize, scheduler) {
        this.bufferTimeSpan = bufferTimeSpan;
        this.bufferCreationInterval = bufferCreationInterval;
        this.maxBufferSize = maxBufferSize;
        this.scheduler = scheduler;
    }
    BufferTimeOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new BufferTimeSubscriber(subscriber, this.bufferTimeSpan, this.bufferCreationInterval, this.maxBufferSize, this.scheduler));
    };
    return BufferTimeOperator;
}());
var Context = /*@__PURE__*/ (function () {
    function Context() {
        this.buffer = [];
    }
    return Context;
}());
var BufferTimeSubscriber = /*@__PURE__*/ (function (_super) {
    tslib__WEBPACK_IMPORTED_MODULE_0__["__extends"](BufferTimeSubscriber, _super);
    function BufferTimeSubscriber(destination, bufferTimeSpan, bufferCreationInterval, maxBufferSize, scheduler) {
        var _this = _super.call(this, destination) || this;
        _this.bufferTimeSpan = bufferTimeSpan;
        _this.bufferCreationInterval = bufferCreationInterval;
        _this.maxBufferSize = maxBufferSize;
        _this.scheduler = scheduler;
        _this.contexts = [];
        var context = _this.openContext();
        _this.timespanOnly = bufferCreationInterval == null || bufferCreationInterval < 0;
        if (_this.timespanOnly) {
            var timeSpanOnlyState = { subscriber: _this, context: context, bufferTimeSpan: bufferTimeSpan };
            _this.add(context.closeAction = scheduler.schedule(dispatchBufferTimeSpanOnly, bufferTimeSpan, timeSpanOnlyState));
        }
        else {
            var closeState = { subscriber: _this, context: context };
            var creationState = { bufferTimeSpan: bufferTimeSpan, bufferCreationInterval: bufferCreationInterval, subscriber: _this, scheduler: scheduler };
            _this.add(context.closeAction = scheduler.schedule(dispatchBufferClose, bufferTimeSpan, closeState));
            _this.add(scheduler.schedule(dispatchBufferCreation, bufferCreationInterval, creationState));
        }
        return _this;
    }
    BufferTimeSubscriber.prototype._next = function (value) {
        var contexts = this.contexts;
        var len = contexts.length;
        var filledBufferContext;
        for (var i = 0; i < len; i++) {
            var context_1 = contexts[i];
            var buffer = context_1.buffer;
            buffer.push(value);
            if (buffer.length == this.maxBufferSize) {
                filledBufferContext = context_1;
            }
        }
        if (filledBufferContext) {
            this.onBufferFull(filledBufferContext);
        }
    };
    BufferTimeSubscriber.prototype._error = function (err) {
        this.contexts.length = 0;
        _super.prototype._error.call(this, err);
    };
    BufferTimeSubscriber.prototype._complete = function () {
        var _a = this, contexts = _a.contexts, destination = _a.destination;
        while (contexts.length > 0) {
            var context_2 = contexts.shift();
            destination.next(context_2.buffer);
        }
        _super.prototype._complete.call(this);
    };
    BufferTimeSubscriber.prototype._unsubscribe = function () {
        this.contexts = null;
    };
    BufferTimeSubscriber.prototype.onBufferFull = function (context) {
        this.closeContext(context);
        var closeAction = context.closeAction;
        closeAction.unsubscribe();
        this.remove(closeAction);
        if (!this.closed && this.timespanOnly) {
            context = this.openContext();
            var bufferTimeSpan = this.bufferTimeSpan;
            var timeSpanOnlyState = { subscriber: this, context: context, bufferTimeSpan: bufferTimeSpan };
            this.add(context.closeAction = this.scheduler.schedule(dispatchBufferTimeSpanOnly, bufferTimeSpan, timeSpanOnlyState));
        }
    };
    BufferTimeSubscriber.prototype.openContext = function () {
        var context = new Context();
        this.contexts.push(context);
        return context;
    };
    BufferTimeSubscriber.prototype.closeContext = function (context) {
        this.destination.next(context.buffer);
        var contexts = this.contexts;
        var spliceIndex = contexts ? contexts.indexOf(context) : -1;
        if (spliceIndex >= 0) {
            contexts.splice(contexts.indexOf(context), 1);
        }
    };
    return BufferTimeSubscriber;
}(_Subscriber__WEBPACK_IMPORTED_MODULE_2__["Subscriber"]));
function dispatchBufferTimeSpanOnly(state) {
    var subscriber = state.subscriber;
    var prevContext = state.context;
    if (prevContext) {
        subscriber.closeContext(prevContext);
    }
    if (!subscriber.closed) {
        state.context = subscriber.openContext();
        state.context.closeAction = this.schedule(state, state.bufferTimeSpan);
    }
}
function dispatchBufferCreation(state) {
    var bufferCreationInterval = state.bufferCreationInterval, bufferTimeSpan = state.bufferTimeSpan, subscriber = state.subscriber, scheduler = state.scheduler;
    var context = subscriber.openContext();
    var action = this;
    if (!subscriber.closed) {
        subscriber.add(context.closeAction = scheduler.schedule(dispatchBufferClose, bufferTimeSpan, { subscriber: subscriber, context: context }));
        action.schedule(state, bufferCreationInterval);
    }
}
function dispatchBufferClose(arg) {
    var subscriber = arg.subscriber, context = arg.context;
    subscriber.closeContext(context);
}
//# sourceMappingURL=bufferTime.js.map


/***/ }),

/***/ "./node_modules/rxjs/_esm5/internal/operators/bufferToggle.js":
/*!********************************************************************!*\
  !*** ./node_modules/rxjs/_esm5/internal/operators/bufferToggle.js ***!
  \********************************************************************/
/*! exports provided: bufferToggle */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "bufferToggle", function() { return bufferToggle; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/rxjs/node_modules/tslib/tslib.es6.js");
/* harmony import */ var _Subscription__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../Subscription */ "./node_modules/rxjs/_esm5/internal/Subscription.js");
/* harmony import */ var _util_subscribeToResult__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../util/subscribeToResult */ "./node_modules/rxjs/_esm5/internal/util/subscribeToResult.js");
/* harmony import */ var _OuterSubscriber__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../OuterSubscriber */ "./node_modules/rxjs/_esm5/internal/OuterSubscriber.js");
/** PURE_IMPORTS_START tslib,_Subscription,_util_subscribeToResult,_OuterSubscriber PURE_IMPORTS_END */




function bufferToggle(openings, closingSelector) {
    return function bufferToggleOperatorFunction(source) {
        return source.lift(new BufferToggleOperator(openings, closingSelector));
    };
}
var BufferToggleOperator = /*@__PURE__*/ (function () {
    function BufferToggleOperator(openings, closingSelector) {
        this.openings = openings;
        this.closingSelector = closingSelector;
    }
    BufferToggleOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new BufferToggleSubscriber(subscriber, this.openings, this.closingSelector));
    };
    return BufferToggleOperator;
}());
var BufferToggleSubscriber = /*@__PURE__*/ (function (_super) {
    tslib__WEBPACK_IMPORTED_MODULE_0__["__extends"](BufferToggleSubscriber, _super);
    function BufferToggleSubscriber(destination, openings, closingSelector) {
        var _this = _super.call(this, destination) || this;
        _this.closingSelector = closingSelector;
        _this.contexts = [];
        _this.add(Object(_util_subscribeToResult__WEBPACK_IMPORTED_MODULE_2__["subscribeToResult"])(_this, openings));
        return _this;
    }
    BufferToggleSubscriber.prototype._next = function (value) {
        var contexts = this.contexts;
        var len = contexts.length;
        for (var i = 0; i < len; i++) {
            contexts[i].buffer.push(value);
        }
    };
    BufferToggleSubscriber.prototype._error = function (err) {
        var contexts = this.contexts;
        while (contexts.length > 0) {
            var context_1 = contexts.shift();
            context_1.subscription.unsubscribe();
            context_1.buffer = null;
            context_1.subscription = null;
        }
        this.contexts = null;
        _super.prototype._error.call(this, err);
    };
    BufferToggleSubscriber.prototype._complete = function () {
        var contexts = this.contexts;
        while (contexts.length > 0) {
            var context_2 = contexts.shift();
            this.destination.next(context_2.buffer);
            context_2.subscription.unsubscribe();
            context_2.buffer = null;
            context_2.subscription = null;
        }
        this.contexts = null;
        _super.prototype._complete.call(this);
    };
    BufferToggleSubscriber.prototype.notifyNext = function (outerValue, innerValue) {
        outerValue ? this.closeBuffer(outerValue) : this.openBuffer(innerValue);
    };
    BufferToggleSubscriber.prototype.notifyComplete = function (innerSub) {
        this.closeBuffer(innerSub.context);
    };
    BufferToggleSubscriber.prototype.openBuffer = function (value) {
        try {
            var closingSelector = this.closingSelector;
            var closingNotifier = closingSelector.call(this, value);
            if (closingNotifier) {
                this.trySubscribe(closingNotifier);
            }
        }
        catch (err) {
            this._error(err);
        }
    };
    BufferToggleSubscriber.prototype.closeBuffer = function (context) {
        var contexts = this.contexts;
        if (contexts && context) {
            var buffer = context.buffer, subscription = context.subscription;
            this.destination.next(buffer);
            contexts.splice(contexts.indexOf(context), 1);
            this.remove(subscription);
            subscription.unsubscribe();
        }
    };
    BufferToggleSubscriber.prototype.trySubscribe = function (closingNotifier) {
        var contexts = this.contexts;
        var buffer = [];
        var subscription = new _Subscription__WEBPACK_IMPORTED_MODULE_1__["Subscription"]();
        var context = { buffer: buffer, subscription: subscription };
        contexts.push(context);
        var innerSubscription = Object(_util_subscribeToResult__WEBPACK_IMPORTED_MODULE_2__["subscribeToResult"])(this, closingNotifier, context);
        if (!innerSubscription || innerSubscription.closed) {
            this.closeBuffer(context);
        }
        else {
            innerSubscription.context = context;
            this.add(innerSubscription);
            subscription.add(innerSubscription);
        }
    };
    return BufferToggleSubscriber;
}(_OuterSubscriber__WEBPACK_IMPORTED_MODULE_3__["OuterSubscriber"]));
//# sourceMappingURL=bufferToggle.js.map


/***/ }),

/***/ "./node_modules/rxjs/_esm5/internal/operators/bufferWhen.js":
/*!******************************************************************!*\
  !*** ./node_modules/rxjs/_esm5/internal/operators/bufferWhen.js ***!
  \******************************************************************/
/*! exports provided: bufferWhen */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "bufferWhen", function() { return bufferWhen; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/rxjs/node_modules/tslib/tslib.es6.js");
/* harmony import */ var _Subscription__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../Subscription */ "./node_modules/rxjs/_esm5/internal/Subscription.js");
/* harmony import */ var _innerSubscribe__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../innerSubscribe */ "./node_modules/rxjs/_esm5/internal/innerSubscribe.js");
/** PURE_IMPORTS_START tslib,_Subscription,_innerSubscribe PURE_IMPORTS_END */



function bufferWhen(closingSelector) {
    return function (source) {
        return source.lift(new BufferWhenOperator(closingSelector));
    };
}
var BufferWhenOperator = /*@__PURE__*/ (function () {
    function BufferWhenOperator(closingSelector) {
        this.closingSelector = closingSelector;
    }
    BufferWhenOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new BufferWhenSubscriber(subscriber, this.closingSelector));
    };
    return BufferWhenOperator;
}());
var BufferWhenSubscriber = /*@__PURE__*/ (function (_super) {
    tslib__WEBPACK_IMPORTED_MODULE_0__["__extends"](BufferWhenSubscriber, _super);
    function BufferWhenSubscriber(destination, closingSelector) {
        var _this = _super.call(this, destination) || this;
        _this.closingSelector = closingSelector;
        _this.subscribing = false;
        _this.openBuffer();
        return _this;
    }
    BufferWhenSubscriber.prototype._next = function (value) {
        this.buffer.push(value);
    };
    BufferWhenSubscriber.prototype._complete = function () {
        var buffer = this.buffer;
        if (buffer) {
            this.destination.next(buffer);
        }
        _super.prototype._complete.call(this);
    };
    BufferWhenSubscriber.prototype._unsubscribe = function () {
        this.buffer = undefined;
        this.subscribing = false;
    };
    BufferWhenSubscriber.prototype.notifyNext = function () {
        this.openBuffer();
    };
    BufferWhenSubscriber.prototype.notifyComplete = function () {
        if (this.subscribing) {
            this.complete();
        }
        else {
            this.openBuffer();
        }
    };
    BufferWhenSubscriber.prototype.openBuffer = function () {
        var closingSubscription = this.closingSubscription;
        if (closingSubscription) {
            this.remove(closingSubscription);
            closingSubscription.unsubscribe();
        }
        var buffer = this.buffer;
        if (this.buffer) {
            this.destination.next(buffer);
        }
        this.buffer = [];
        var closingNotifier;
        try {
            var closingSelector = this.closingSelector;
            closingNotifier = closingSelector();
        }
        catch (err) {
            return this.error(err);
        }
        closingSubscription = new _Subscription__WEBPACK_IMPORTED_MODULE_1__["Subscription"]();
        this.closingSubscription = closingSubscription;
        this.add(closingSubscription);
        this.subscribing = true;
        closingSubscription.add(Object(_innerSubscribe__WEBPACK_IMPORTED_MODULE_2__["innerSubscribe"])(closingNotifier, new _innerSubscribe__WEBPACK_IMPORTED_MODULE_2__["SimpleInnerSubscriber"](this)));
        this.subscribing = false;
    };
    return BufferWhenSubscriber;
}(_innerSubscribe__WEBPACK_IMPORTED_MODULE_2__["SimpleOuterSubscriber"]));
//# sourceMappingURL=bufferWhen.js.map


/***/ }),

/***/ "./node_modules/rxjs/_esm5/internal/operators/catchError.js":
/*!******************************************************************!*\
  !*** ./node_modules/rxjs/_esm5/internal/operators/catchError.js ***!
  \******************************************************************/
/*! exports provided: catchError */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "catchError", function() { return catchError; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/rxjs/node_modules/tslib/tslib.es6.js");
/* harmony import */ var _innerSubscribe__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../innerSubscribe */ "./node_modules/rxjs/_esm5/internal/innerSubscribe.js");
/** PURE_IMPORTS_START tslib,_innerSubscribe PURE_IMPORTS_END */


function catchError(selector) {
    return function catchErrorOperatorFunction(source) {
        var operator = new CatchOperator(selector);
        var caught = source.lift(operator);
        return (operator.caught = caught);
    };
}
var CatchOperator = /*@__PURE__*/ (function () {
    function CatchOperator(selector) {
        this.selector = selector;
    }
    CatchOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new CatchSubscriber(subscriber, this.selector, this.caught));
    };
    return CatchOperator;
}());
var CatchSubscriber = /*@__PURE__*/ (function (_super) {
    tslib__WEBPACK_IMPORTED_MODULE_0__["__extends"](CatchSubscriber, _super);
    function CatchSubscriber(destination, selector, caught) {
        var _this = _super.call(this, destination) || this;
        _this.selector = selector;
        _this.caught = caught;
        return _this;
    }
    CatchSubscriber.prototype.error = function (err) {
        if (!this.isStopped) {
            var result = void 0;
            try {
                result = this.selector(err, this.caught);
            }
            catch (err2) {
                _super.prototype.error.call(this, err2);
                return;
            }
            this._unsubscribeAndRecycle();
            var innerSubscriber = new _innerSubscribe__WEBPACK_IMPORTED_MODULE_1__["SimpleInnerSubscriber"](this);
            this.add(innerSubscriber);
            var innerSubscription = Object(_innerSubscribe__WEBPACK_IMPORTED_MODULE_1__["innerSubscribe"])(result, innerSubscriber);
            if (innerSubscription !== innerSubscriber) {
                this.add(innerSubscription);
            }
        }
    };
    return CatchSubscriber;
}(_innerSubscribe__WEBPACK_IMPORTED_MODULE_1__["SimpleOuterSubscriber"]));
//# sourceMappingURL=catchError.js.map


/***/ }),

/***/ "./node_modules/rxjs/_esm5/internal/operators/combineAll.js":
/*!******************************************************************!*\
  !*** ./node_modules/rxjs/_esm5/internal/operators/combineAll.js ***!
  \******************************************************************/
/*! exports provided: combineAll */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "combineAll", function() { return combineAll; });
/* harmony import */ var _observable_combineLatest__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../observable/combineLatest */ "./node_modules/rxjs/_esm5/internal/observable/combineLatest.js");
/** PURE_IMPORTS_START _observable_combineLatest PURE_IMPORTS_END */

function combineAll(project) {
    return function (source) { return source.lift(new _observable_combineLatest__WEBPACK_IMPORTED_MODULE_0__["CombineLatestOperator"](project)); };
}
//# sourceMappingURL=combineAll.js.map


/***/ }),

/***/ "./node_modules/rxjs/_esm5/internal/operators/combineLatest.js":
/*!*********************************************************************!*\
  !*** ./node_modules/rxjs/_esm5/internal/operators/combineLatest.js ***!
  \*********************************************************************/
/*! exports provided: combineLatest */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "combineLatest", function() { return combineLatest; });
/* harmony import */ var _util_isArray__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../util/isArray */ "./node_modules/rxjs/_esm5/internal/util/isArray.js");
/* harmony import */ var _observable_combineLatest__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../observable/combineLatest */ "./node_modules/rxjs/_esm5/internal/observable/combineLatest.js");
/* harmony import */ var _observable_from__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../observable/from */ "./node_modules/rxjs/_esm5/internal/observable/from.js");
/** PURE_IMPORTS_START _util_isArray,_observable_combineLatest,_observable_from PURE_IMPORTS_END */



var none = {};
function combineLatest() {
    var observables = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        observables[_i] = arguments[_i];
    }
    var project = null;
    if (typeof observables[observables.length - 1] === 'function') {
        project = observables.pop();
    }
    if (observables.length === 1 && Object(_util_isArray__WEBPACK_IMPORTED_MODULE_0__["isArray"])(observables[0])) {
        observables = observables[0].slice();
    }
    return function (source) { return source.lift.call(Object(_observable_from__WEBPACK_IMPORTED_MODULE_2__["from"])([source].concat(observables)), new _observable_combineLatest__WEBPACK_IMPORTED_MODULE_1__["CombineLatestOperator"](project)); };
}
//# sourceMappingURL=combineLatest.js.map


/***/ }),

/***/ "./node_modules/rxjs/_esm5/internal/operators/concat.js":
/*!**************************************************************!*\
  !*** ./node_modules/rxjs/_esm5/internal/operators/concat.js ***!
  \**************************************************************/
/*! exports provided: concat */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "concat", function() { return concat; });
/* harmony import */ var _observable_concat__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../observable/concat */ "./node_modules/rxjs/_esm5/internal/observable/concat.js");
/** PURE_IMPORTS_START _observable_concat PURE_IMPORTS_END */

function concat() {
    var observables = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        observables[_i] = arguments[_i];
    }
    return function (source) { return source.lift.call(_observable_concat__WEBPACK_IMPORTED_MODULE_0__["concat"].apply(void 0, [source].concat(observables))); };
}
//# sourceMappingURL=concat.js.map


/***/ }),

/***/ "./node_modules/rxjs/_esm5/internal/operators/concatAll.js":
/*!*****************************************************************!*\
  !*** ./node_modules/rxjs/_esm5/internal/operators/concatAll.js ***!
  \*****************************************************************/
/*! exports provided: concatAll */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "concatAll", function() { return concatAll; });
/* harmony import */ var _mergeAll__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./mergeAll */ "./node_modules/rxjs/_esm5/internal/operators/mergeAll.js");
/** PURE_IMPORTS_START _mergeAll PURE_IMPORTS_END */

function concatAll() {
    return Object(_mergeAll__WEBPACK_IMPORTED_MODULE_0__["mergeAll"])(1);
}
//# sourceMappingURL=concatAll.js.map


/***/ }),

/***/ "./node_modules/rxjs/_esm5/internal/operators/concatMap.js":
/*!*****************************************************************!*\
  !*** ./node_modules/rxjs/_esm5/internal/operators/concatMap.js ***!
  \*****************************************************************/
/*! exports provided: concatMap */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "concatMap", function() { return concatMap; });
/* harmony import */ var _mergeMap__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./mergeMap */ "./node_modules/rxjs/_esm5/internal/operators/mergeMap.js");
/** PURE_IMPORTS_START _mergeMap PURE_IMPORTS_END */

function concatMap(project, resultSelector) {
    return Object(_mergeMap__WEBPACK_IMPORTED_MODULE_0__["mergeMap"])(project, resultSelector, 1);
}
//# sourceMappingURL=concatMap.js.map


/***/ }),

/***/ "./node_modules/rxjs/_esm5/internal/operators/concatMapTo.js":
/*!*******************************************************************!*\
  !*** ./node_modules/rxjs/_esm5/internal/operators/concatMapTo.js ***!
  \*******************************************************************/
/*! exports provided: concatMapTo */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "concatMapTo", function() { return concatMapTo; });
/* harmony import */ var _concatMap__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./concatMap */ "./node_modules/rxjs/_esm5/internal/operators/concatMap.js");
/** PURE_IMPORTS_START _concatMap PURE_IMPORTS_END */

function concatMapTo(innerObservable, resultSelector) {
    return Object(_concatMap__WEBPACK_IMPORTED_MODULE_0__["concatMap"])(function () { return innerObservable; }, resultSelector);
}
//# sourceMappingURL=concatMapTo.js.map


/***/ }),

/***/ "./node_modules/rxjs/_esm5/internal/operators/count.js":
/*!*************************************************************!*\
  !*** ./node_modules/rxjs/_esm5/internal/operators/count.js ***!
  \*************************************************************/
/*! exports provided: count */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "count", function() { return count; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/rxjs/node_modules/tslib/tslib.es6.js");
/* harmony import */ var _Subscriber__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../Subscriber */ "./node_modules/rxjs/_esm5/internal/Subscriber.js");
/** PURE_IMPORTS_START tslib,_Subscriber PURE_IMPORTS_END */


function count(predicate) {
    return function (source) { return source.lift(new CountOperator(predicate, source)); };
}
var CountOperator = /*@__PURE__*/ (function () {
    function CountOperator(predicate, source) {
        this.predicate = predicate;
        this.source = source;
    }
    CountOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new CountSubscriber(subscriber, this.predicate, this.source));
    };
    return CountOperator;
}());
var CountSubscriber = /*@__PURE__*/ (function (_super) {
    tslib__WEBPACK_IMPORTED_MODULE_0__["__extends"](CountSubscriber, _super);
    function CountSubscriber(destination, predicate, source) {
        var _this = _super.call(this, destination) || this;
        _this.predicate = predicate;
        _this.source = source;
        _this.count = 0;
        _this.index = 0;
        return _this;
    }
    CountSubscriber.prototype._next = function (value) {
        if (this.predicate) {
            this._tryPredicate(value);
        }
        else {
            this.count++;
        }
    };
    CountSubscriber.prototype._tryPredicate = function (value) {
        var result;
        try {
            result = this.predicate(value, this.index++, this.source);
        }
        catch (err) {
            this.destination.error(err);
            return;
        }
        if (result) {
            this.count++;
        }
    };
    CountSubscriber.prototype._complete = function () {
        this.destination.next(this.count);
        this.destination.complete();
    };
    return CountSubscriber;
}(_Subscriber__WEBPACK_IMPORTED_MODULE_1__["Subscriber"]));
//# sourceMappingURL=count.js.map


/***/ }),

/***/ "./node_modules/rxjs/_esm5/internal/operators/debounce.js":
/*!****************************************************************!*\
  !*** ./node_modules/rxjs/_esm5/internal/operators/debounce.js ***!
  \****************************************************************/
/*! exports provided: debounce */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "debounce", function() { return debounce; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/rxjs/node_modules/tslib/tslib.es6.js");
/* harmony import */ var _innerSubscribe__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../innerSubscribe */ "./node_modules/rxjs/_esm5/internal/innerSubscribe.js");
/** PURE_IMPORTS_START tslib,_innerSubscribe PURE_IMPORTS_END */


function debounce(durationSelector) {
    return function (source) { return source.lift(new DebounceOperator(durationSelector)); };
}
var DebounceOperator = /*@__PURE__*/ (function () {
    function DebounceOperator(durationSelector) {
        this.durationSelector = durationSelector;
    }
    DebounceOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new DebounceSubscriber(subscriber, this.durationSelector));
    };
    return DebounceOperator;
}());
var DebounceSubscriber = /*@__PURE__*/ (function (_super) {
    tslib__WEBPACK_IMPORTED_MODULE_0__["__extends"](DebounceSubscriber, _super);
    function DebounceSubscriber(destination, durationSelector) {
        var _this = _super.call(this, destination) || this;
        _this.durationSelector = durationSelector;
        _this.hasValue = false;
        return _this;
    }
    DebounceSubscriber.prototype._next = function (value) {
        try {
            var result = this.durationSelector.call(this, value);
            if (result) {
                this._tryNext(value, result);
            }
        }
        catch (err) {
            this.destination.error(err);
        }
    };
    DebounceSubscriber.prototype._complete = function () {
        this.emitValue();
        this.destination.complete();
    };
    DebounceSubscriber.prototype._tryNext = function (value, duration) {
        var subscription = this.durationSubscription;
        this.value = value;
        this.hasValue = true;
        if (subscription) {
            subscription.unsubscribe();
            this.remove(subscription);
        }
        subscription = Object(_innerSubscribe__WEBPACK_IMPORTED_MODULE_1__["innerSubscribe"])(duration, new _innerSubscribe__WEBPACK_IMPORTED_MODULE_1__["SimpleInnerSubscriber"](this));
        if (subscription && !subscription.closed) {
            this.add(this.durationSubscription = subscription);
        }
    };
    DebounceSubscriber.prototype.notifyNext = function () {
        this.emitValue();
    };
    DebounceSubscriber.prototype.notifyComplete = function () {
        this.emitValue();
    };
    DebounceSubscriber.prototype.emitValue = function () {
        if (this.hasValue) {
            var value = this.value;
            var subscription = this.durationSubscription;
            if (subscription) {
                this.durationSubscription = undefined;
                subscription.unsubscribe();
                this.remove(subscription);
            }
            this.value = undefined;
            this.hasValue = false;
            _super.prototype._next.call(this, value);
        }
    };
    return DebounceSubscriber;
}(_innerSubscribe__WEBPACK_IMPORTED_MODULE_1__["SimpleOuterSubscriber"]));
//# sourceMappingURL=debounce.js.map


/***/ }),

/***/ "./node_modules/rxjs/_esm5/internal/operators/debounceTime.js":
/*!********************************************************************!*\
  !*** ./node_modules/rxjs/_esm5/internal/operators/debounceTime.js ***!
  \********************************************************************/
/*! exports provided: debounceTime */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "debounceTime", function() { return debounceTime; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/rxjs/node_modules/tslib/tslib.es6.js");
/* harmony import */ var _Subscriber__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../Subscriber */ "./node_modules/rxjs/_esm5/internal/Subscriber.js");
/* harmony import */ var _scheduler_async__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../scheduler/async */ "./node_modules/rxjs/_esm5/internal/scheduler/async.js");
/** PURE_IMPORTS_START tslib,_Subscriber,_scheduler_async PURE_IMPORTS_END */



function debounceTime(dueTime, scheduler) {
    if (scheduler === void 0) {
        scheduler = _scheduler_async__WEBPACK_IMPORTED_MODULE_2__["async"];
    }
    return function (source) { return source.lift(new DebounceTimeOperator(dueTime, scheduler)); };
}
var DebounceTimeOperator = /*@__PURE__*/ (function () {
    function DebounceTimeOperator(dueTime, scheduler) {
        this.dueTime = dueTime;
        this.scheduler = scheduler;
    }
    DebounceTimeOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new DebounceTimeSubscriber(subscriber, this.dueTime, this.scheduler));
    };
    return DebounceTimeOperator;
}());
var DebounceTimeSubscriber = /*@__PURE__*/ (function (_super) {
    tslib__WEBPACK_IMPORTED_MODULE_0__["__extends"](DebounceTimeSubscriber, _super);
    function DebounceTimeSubscriber(destination, dueTime, scheduler) {
        var _this = _super.call(this, destination) || this;
        _this.dueTime = dueTime;
        _this.scheduler = scheduler;
        _this.debouncedSubscription = null;
        _this.lastValue = null;
        _this.hasValue = false;
        return _this;
    }
    DebounceTimeSubscriber.prototype._next = function (value) {
        this.clearDebounce();
        this.lastValue = value;
        this.hasValue = true;
        this.add(this.debouncedSubscription = this.scheduler.schedule(dispatchNext, this.dueTime, this));
    };
    DebounceTimeSubscriber.prototype._complete = function () {
        this.debouncedNext();
        this.destination.complete();
    };
    DebounceTimeSubscriber.prototype.debouncedNext = function () {
        this.clearDebounce();
        if (this.hasValue) {
            var lastValue = this.lastValue;
            this.lastValue = null;
            this.hasValue = false;
            this.destination.next(lastValue);
        }
    };
    DebounceTimeSubscriber.prototype.clearDebounce = function () {
        var debouncedSubscription = this.debouncedSubscription;
        if (debouncedSubscription !== null) {
            this.remove(debouncedSubscription);
            debouncedSubscription.unsubscribe();
            this.debouncedSubscription = null;
        }
    };
    return DebounceTimeSubscriber;
}(_Subscriber__WEBPACK_IMPORTED_MODULE_1__["Subscriber"]));
function dispatchNext(subscriber) {
    subscriber.debouncedNext();
}
//# sourceMappingURL=debounceTime.js.map


/***/ }),

/***/ "./node_modules/rxjs/_esm5/internal/operators/defaultIfEmpty.js":
/*!**********************************************************************!*\
  !*** ./node_modules/rxjs/_esm5/internal/operators/defaultIfEmpty.js ***!
  \**********************************************************************/
/*! exports provided: defaultIfEmpty */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "defaultIfEmpty", function() { return defaultIfEmpty; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/rxjs/node_modules/tslib/tslib.es6.js");
/* harmony import */ var _Subscriber__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../Subscriber */ "./node_modules/rxjs/_esm5/internal/Subscriber.js");
/** PURE_IMPORTS_START tslib,_Subscriber PURE_IMPORTS_END */


function defaultIfEmpty(defaultValue) {
    if (defaultValue === void 0) {
        defaultValue = null;
    }
    return function (source) { return source.lift(new DefaultIfEmptyOperator(defaultValue)); };
}
var DefaultIfEmptyOperator = /*@__PURE__*/ (function () {
    function DefaultIfEmptyOperator(defaultValue) {
        this.defaultValue = defaultValue;
    }
    DefaultIfEmptyOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new DefaultIfEmptySubscriber(subscriber, this.defaultValue));
    };
    return DefaultIfEmptyOperator;
}());
var DefaultIfEmptySubscriber = /*@__PURE__*/ (function (_super) {
    tslib__WEBPACK_IMPORTED_MODULE_0__["__extends"](DefaultIfEmptySubscriber, _super);
    function DefaultIfEmptySubscriber(destination, defaultValue) {
        var _this = _super.call(this, destination) || this;
        _this.defaultValue = defaultValue;
        _this.isEmpty = true;
        return _this;
    }
    DefaultIfEmptySubscriber.prototype._next = function (value) {
        this.isEmpty = false;
        this.destination.next(value);
    };
    DefaultIfEmptySubscriber.prototype._complete = function () {
        if (this.isEmpty) {
            this.destination.next(this.defaultValue);
        }
        this.destination.complete();
    };
    return DefaultIfEmptySubscriber;
}(_Subscriber__WEBPACK_IMPORTED_MODULE_1__["Subscriber"]));
//# sourceMappingURL=defaultIfEmpty.js.map


/***/ }),

/***/ "./node_modules/rxjs/_esm5/internal/operators/delay.js":
/*!*************************************************************!*\
  !*** ./node_modules/rxjs/_esm5/internal/operators/delay.js ***!
  \*************************************************************/
/*! exports provided: delay */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "delay", function() { return delay; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/rxjs/node_modules/tslib/tslib.es6.js");
/* harmony import */ var _scheduler_async__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../scheduler/async */ "./node_modules/rxjs/_esm5/internal/scheduler/async.js");
/* harmony import */ var _util_isDate__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../util/isDate */ "./node_modules/rxjs/_esm5/internal/util/isDate.js");
/* harmony import */ var _Subscriber__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../Subscriber */ "./node_modules/rxjs/_esm5/internal/Subscriber.js");
/* harmony import */ var _Notification__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../Notification */ "./node_modules/rxjs/_esm5/internal/Notification.js");
/** PURE_IMPORTS_START tslib,_scheduler_async,_util_isDate,_Subscriber,_Notification PURE_IMPORTS_END */





function delay(delay, scheduler) {
    if (scheduler === void 0) {
        scheduler = _scheduler_async__WEBPACK_IMPORTED_MODULE_1__["async"];
    }
    var absoluteDelay = Object(_util_isDate__WEBPACK_IMPORTED_MODULE_2__["isDate"])(delay);
    var delayFor = absoluteDelay ? (+delay - scheduler.now()) : Math.abs(delay);
    return function (source) { return source.lift(new DelayOperator(delayFor, scheduler)); };
}
var DelayOperator = /*@__PURE__*/ (function () {
    function DelayOperator(delay, scheduler) {
        this.delay = delay;
        this.scheduler = scheduler;
    }
    DelayOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new DelaySubscriber(subscriber, this.delay, this.scheduler));
    };
    return DelayOperator;
}());
var DelaySubscriber = /*@__PURE__*/ (function (_super) {
    tslib__WEBPACK_IMPORTED_MODULE_0__["__extends"](DelaySubscriber, _super);
    function DelaySubscriber(destination, delay, scheduler) {
        var _this = _super.call(this, destination) || this;
        _this.delay = delay;
        _this.scheduler = scheduler;
        _this.queue = [];
        _this.active = false;
        _this.errored = false;
        return _this;
    }
    DelaySubscriber.dispatch = function (state) {
        var source = state.source;
        var queue = source.queue;
        var scheduler = state.scheduler;
        var destination = state.destination;
        while (queue.length > 0 && (queue[0].time - scheduler.now()) <= 0) {
            queue.shift().notification.observe(destination);
        }
        if (queue.length > 0) {
            var delay_1 = Math.max(0, queue[0].time - scheduler.now());
            this.schedule(state, delay_1);
        }
        else {
            this.unsubscribe();
            source.active = false;
        }
    };
    DelaySubscriber.prototype._schedule = function (scheduler) {
        this.active = true;
        var destination = this.destination;
        destination.add(scheduler.schedule(DelaySubscriber.dispatch, this.delay, {
            source: this, destination: this.destination, scheduler: scheduler
        }));
    };
    DelaySubscriber.prototype.scheduleNotification = function (notification) {
        if (this.errored === true) {
            return;
        }
        var scheduler = this.scheduler;
        var message = new DelayMessage(scheduler.now() + this.delay, notification);
        this.queue.push(message);
        if (this.active === false) {
            this._schedule(scheduler);
        }
    };
    DelaySubscriber.prototype._next = function (value) {
        this.scheduleNotification(_Notification__WEBPACK_IMPORTED_MODULE_4__["Notification"].createNext(value));
    };
    DelaySubscriber.prototype._error = function (err) {
        this.errored = true;
        this.queue = [];
        this.destination.error(err);
        this.unsubscribe();
    };
    DelaySubscriber.prototype._complete = function () {
        this.scheduleNotification(_Notification__WEBPACK_IMPORTED_MODULE_4__["Notification"].createComplete());
        this.unsubscribe();
    };
    return DelaySubscriber;
}(_Subscriber__WEBPACK_IMPORTED_MODULE_3__["Subscriber"]));
var DelayMessage = /*@__PURE__*/ (function () {
    function DelayMessage(time, notification) {
        this.time = time;
        this.notification = notification;
    }
    return DelayMessage;
}());
//# sourceMappingURL=delay.js.map


/***/ }),

/***/ "./node_modules/rxjs/_esm5/internal/operators/delayWhen.js":
/*!*****************************************************************!*\
  !*** ./node_modules/rxjs/_esm5/internal/operators/delayWhen.js ***!
  \*****************************************************************/
/*! exports provided: delayWhen */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "delayWhen", function() { return delayWhen; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/rxjs/node_modules/tslib/tslib.es6.js");
/* harmony import */ var _Subscriber__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../Subscriber */ "./node_modules/rxjs/_esm5/internal/Subscriber.js");
/* harmony import */ var _Observable__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../Observable */ "./node_modules/rxjs/_esm5/internal/Observable.js");
/* harmony import */ var _OuterSubscriber__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../OuterSubscriber */ "./node_modules/rxjs/_esm5/internal/OuterSubscriber.js");
/* harmony import */ var _util_subscribeToResult__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../util/subscribeToResult */ "./node_modules/rxjs/_esm5/internal/util/subscribeToResult.js");
/** PURE_IMPORTS_START tslib,_Subscriber,_Observable,_OuterSubscriber,_util_subscribeToResult PURE_IMPORTS_END */





function delayWhen(delayDurationSelector, subscriptionDelay) {
    if (subscriptionDelay) {
        return function (source) {
            return new SubscriptionDelayObservable(source, subscriptionDelay)
                .lift(new DelayWhenOperator(delayDurationSelector));
        };
    }
    return function (source) { return source.lift(new DelayWhenOperator(delayDurationSelector)); };
}
var DelayWhenOperator = /*@__PURE__*/ (function () {
    function DelayWhenOperator(delayDurationSelector) {
        this.delayDurationSelector = delayDurationSelector;
    }
    DelayWhenOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new DelayWhenSubscriber(subscriber, this.delayDurationSelector));
    };
    return DelayWhenOperator;
}());
var DelayWhenSubscriber = /*@__PURE__*/ (function (_super) {
    tslib__WEBPACK_IMPORTED_MODULE_0__["__extends"](DelayWhenSubscriber, _super);
    function DelayWhenSubscriber(destination, delayDurationSelector) {
        var _this = _super.call(this, destination) || this;
        _this.delayDurationSelector = delayDurationSelector;
        _this.completed = false;
        _this.delayNotifierSubscriptions = [];
        _this.index = 0;
        return _this;
    }
    DelayWhenSubscriber.prototype.notifyNext = function (outerValue, _innerValue, _outerIndex, _innerIndex, innerSub) {
        this.destination.next(outerValue);
        this.removeSubscription(innerSub);
        this.tryComplete();
    };
    DelayWhenSubscriber.prototype.notifyError = function (error, innerSub) {
        this._error(error);
    };
    DelayWhenSubscriber.prototype.notifyComplete = function (innerSub) {
        var value = this.removeSubscription(innerSub);
        if (value) {
            this.destination.next(value);
        }
        this.tryComplete();
    };
    DelayWhenSubscriber.prototype._next = function (value) {
        var index = this.index++;
        try {
            var delayNotifier = this.delayDurationSelector(value, index);
            if (delayNotifier) {
                this.tryDelay(delayNotifier, value);
            }
        }
        catch (err) {
            this.destination.error(err);
        }
    };
    DelayWhenSubscriber.prototype._complete = function () {
        this.completed = true;
        this.tryComplete();
        this.unsubscribe();
    };
    DelayWhenSubscriber.prototype.removeSubscription = function (subscription) {
        subscription.unsubscribe();
        var subscriptionIdx = this.delayNotifierSubscriptions.indexOf(subscription);
        if (subscriptionIdx !== -1) {
            this.delayNotifierSubscriptions.splice(subscriptionIdx, 1);
        }
        return subscription.outerValue;
    };
    DelayWhenSubscriber.prototype.tryDelay = function (delayNotifier, value) {
        var notifierSubscription = Object(_util_subscribeToResult__WEBPACK_IMPORTED_MODULE_4__["subscribeToResult"])(this, delayNotifier, value);
        if (notifierSubscription && !notifierSubscription.closed) {
            var destination = this.destination;
            destination.add(notifierSubscription);
            this.delayNotifierSubscriptions.push(notifierSubscription);
        }
    };
    DelayWhenSubscriber.prototype.tryComplete = function () {
        if (this.completed && this.delayNotifierSubscriptions.length === 0) {
            this.destination.complete();
        }
    };
    return DelayWhenSubscriber;
}(_OuterSubscriber__WEBPACK_IMPORTED_MODULE_3__["OuterSubscriber"]));
var SubscriptionDelayObservable = /*@__PURE__*/ (function (_super) {
    tslib__WEBPACK_IMPORTED_MODULE_0__["__extends"](SubscriptionDelayObservable, _super);
    function SubscriptionDelayObservable(source, subscriptionDelay) {
        var _this = _super.call(this) || this;
        _this.source = source;
        _this.subscriptionDelay = subscriptionDelay;
        return _this;
    }
    SubscriptionDelayObservable.prototype._subscribe = function (subscriber) {
        this.subscriptionDelay.subscribe(new SubscriptionDelaySubscriber(subscriber, this.source));
    };
    return SubscriptionDelayObservable;
}(_Observable__WEBPACK_IMPORTED_MODULE_2__["Observable"]));
var SubscriptionDelaySubscriber = /*@__PURE__*/ (function (_super) {
    tslib__WEBPACK_IMPORTED_MODULE_0__["__extends"](SubscriptionDelaySubscriber, _super);
    function SubscriptionDelaySubscriber(parent, source) {
        var _this = _super.call(this) || this;
        _this.parent = parent;
        _this.source = source;
        _this.sourceSubscribed = false;
        return _this;
    }
    SubscriptionDelaySubscriber.prototype._next = function (unused) {
        this.subscribeToSource();
    };
    SubscriptionDelaySubscriber.prototype._error = function (err) {
        this.unsubscribe();
        this.parent.error(err);
    };
    SubscriptionDelaySubscriber.prototype._complete = function () {
        this.unsubscribe();
        this.subscribeToSource();
    };
    SubscriptionDelaySubscriber.prototype.subscribeToSource = function () {
        if (!this.sourceSubscribed) {
            this.sourceSubscribed = true;
            this.unsubscribe();
            this.source.subscribe(this.parent);
        }
    };
    return SubscriptionDelaySubscriber;
}(_Subscriber__WEBPACK_IMPORTED_MODULE_1__["Subscriber"]));
//# sourceMappingURL=delayWhen.js.map


/***/ }),

/***/ "./node_modules/rxjs/_esm5/internal/operators/dematerialize.js":
/*!*********************************************************************!*\
  !*** ./node_modules/rxjs/_esm5/internal/operators/dematerialize.js ***!
  \*********************************************************************/
/*! exports provided: dematerialize */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "dematerialize", function() { return dematerialize; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/rxjs/node_modules/tslib/tslib.es6.js");
/* harmony import */ var _Subscriber__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../Subscriber */ "./node_modules/rxjs/_esm5/internal/Subscriber.js");
/** PURE_IMPORTS_START tslib,_Subscriber PURE_IMPORTS_END */


function dematerialize() {
    return function dematerializeOperatorFunction(source) {
        return source.lift(new DeMaterializeOperator());
    };
}
var DeMaterializeOperator = /*@__PURE__*/ (function () {
    function DeMaterializeOperator() {
    }
    DeMaterializeOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new DeMaterializeSubscriber(subscriber));
    };
    return DeMaterializeOperator;
}());
var DeMaterializeSubscriber = /*@__PURE__*/ (function (_super) {
    tslib__WEBPACK_IMPORTED_MODULE_0__["__extends"](DeMaterializeSubscriber, _super);
    function DeMaterializeSubscriber(destination) {
        return _super.call(this, destination) || this;
    }
    DeMaterializeSubscriber.prototype._next = function (value) {
        value.observe(this.destination);
    };
    return DeMaterializeSubscriber;
}(_Subscriber__WEBPACK_IMPORTED_MODULE_1__["Subscriber"]));
//# sourceMappingURL=dematerialize.js.map


/***/ }),

/***/ "./node_modules/rxjs/_esm5/internal/operators/distinct.js":
/*!****************************************************************!*\
  !*** ./node_modules/rxjs/_esm5/internal/operators/distinct.js ***!
  \****************************************************************/
/*! exports provided: distinct, DistinctSubscriber */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "distinct", function() { return distinct; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DistinctSubscriber", function() { return DistinctSubscriber; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/rxjs/node_modules/tslib/tslib.es6.js");
/* harmony import */ var _innerSubscribe__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../innerSubscribe */ "./node_modules/rxjs/_esm5/internal/innerSubscribe.js");
/** PURE_IMPORTS_START tslib,_innerSubscribe PURE_IMPORTS_END */


function distinct(keySelector, flushes) {
    return function (source) { return source.lift(new DistinctOperator(keySelector, flushes)); };
}
var DistinctOperator = /*@__PURE__*/ (function () {
    function DistinctOperator(keySelector, flushes) {
        this.keySelector = keySelector;
        this.flushes = flushes;
    }
    DistinctOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new DistinctSubscriber(subscriber, this.keySelector, this.flushes));
    };
    return DistinctOperator;
}());
var DistinctSubscriber = /*@__PURE__*/ (function (_super) {
    tslib__WEBPACK_IMPORTED_MODULE_0__["__extends"](DistinctSubscriber, _super);
    function DistinctSubscriber(destination, keySelector, flushes) {
        var _this = _super.call(this, destination) || this;
        _this.keySelector = keySelector;
        _this.values = new Set();
        if (flushes) {
            _this.add(Object(_innerSubscribe__WEBPACK_IMPORTED_MODULE_1__["innerSubscribe"])(flushes, new _innerSubscribe__WEBPACK_IMPORTED_MODULE_1__["SimpleInnerSubscriber"](_this)));
        }
        return _this;
    }
    DistinctSubscriber.prototype.notifyNext = function () {
        this.values.clear();
    };
    DistinctSubscriber.prototype.notifyError = function (error) {
        this._error(error);
    };
    DistinctSubscriber.prototype._next = function (value) {
        if (this.keySelector) {
            this._useKeySelector(value);
        }
        else {
            this._finalizeNext(value, value);
        }
    };
    DistinctSubscriber.prototype._useKeySelector = function (value) {
        var key;
        var destination = this.destination;
        try {
            key = this.keySelector(value);
        }
        catch (err) {
            destination.error(err);
            return;
        }
        this._finalizeNext(key, value);
    };
    DistinctSubscriber.prototype._finalizeNext = function (key, value) {
        var values = this.values;
        if (!values.has(key)) {
            values.add(key);
            this.destination.next(value);
        }
    };
    return DistinctSubscriber;
}(_innerSubscribe__WEBPACK_IMPORTED_MODULE_1__["SimpleOuterSubscriber"]));

//# sourceMappingURL=distinct.js.map


/***/ }),

/***/ "./node_modules/rxjs/_esm5/internal/operators/distinctUntilChanged.js":
/*!****************************************************************************!*\
  !*** ./node_modules/rxjs/_esm5/internal/operators/distinctUntilChanged.js ***!
  \****************************************************************************/
/*! exports provided: distinctUntilChanged */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "distinctUntilChanged", function() { return distinctUntilChanged; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/rxjs/node_modules/tslib/tslib.es6.js");
/* harmony import */ var _Subscriber__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../Subscriber */ "./node_modules/rxjs/_esm5/internal/Subscriber.js");
/** PURE_IMPORTS_START tslib,_Subscriber PURE_IMPORTS_END */


function distinctUntilChanged(compare, keySelector) {
    return function (source) { return source.lift(new DistinctUntilChangedOperator(compare, keySelector)); };
}
var DistinctUntilChangedOperator = /*@__PURE__*/ (function () {
    function DistinctUntilChangedOperator(compare, keySelector) {
        this.compare = compare;
        this.keySelector = keySelector;
    }
    DistinctUntilChangedOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new DistinctUntilChangedSubscriber(subscriber, this.compare, this.keySelector));
    };
    return DistinctUntilChangedOperator;
}());
var DistinctUntilChangedSubscriber = /*@__PURE__*/ (function (_super) {
    tslib__WEBPACK_IMPORTED_MODULE_0__["__extends"](DistinctUntilChangedSubscriber, _super);
    function DistinctUntilChangedSubscriber(destination, compare, keySelector) {
        var _this = _super.call(this, destination) || this;
        _this.keySelector = keySelector;
        _this.hasKey = false;
        if (typeof compare === 'function') {
            _this.compare = compare;
        }
        return _this;
    }
    DistinctUntilChangedSubscriber.prototype.compare = function (x, y) {
        return x === y;
    };
    DistinctUntilChangedSubscriber.prototype._next = function (value) {
        var key;
        try {
            var keySelector = this.keySelector;
            key = keySelector ? keySelector(value) : value;
        }
        catch (err) {
            return this.destination.error(err);
        }
        var result = false;
        if (this.hasKey) {
            try {
                var compare = this.compare;
                result = compare(this.key, key);
            }
            catch (err) {
                return this.destination.error(err);
            }
        }
        else {
            this.hasKey = true;
        }
        if (!result) {
            this.key = key;
            this.destination.next(value);
        }
    };
    return DistinctUntilChangedSubscriber;
}(_Subscriber__WEBPACK_IMPORTED_MODULE_1__["Subscriber"]));
//# sourceMappingURL=distinctUntilChanged.js.map


/***/ }),

/***/ "./node_modules/rxjs/_esm5/internal/operators/distinctUntilKeyChanged.js":
/*!*******************************************************************************!*\
  !*** ./node_modules/rxjs/_esm5/internal/operators/distinctUntilKeyChanged.js ***!
  \*******************************************************************************/
/*! exports provided: distinctUntilKeyChanged */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "distinctUntilKeyChanged", function() { return distinctUntilKeyChanged; });
/* harmony import */ var _distinctUntilChanged__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./distinctUntilChanged */ "./node_modules/rxjs/_esm5/internal/operators/distinctUntilChanged.js");
/** PURE_IMPORTS_START _distinctUntilChanged PURE_IMPORTS_END */

function distinctUntilKeyChanged(key, compare) {
    return Object(_distinctUntilChanged__WEBPACK_IMPORTED_MODULE_0__["distinctUntilChanged"])(function (x, y) { return compare ? compare(x[key], y[key]) : x[key] === y[key]; });
}
//# sourceMappingURL=distinctUntilKeyChanged.js.map


/***/ }),

/***/ "./node_modules/rxjs/_esm5/internal/operators/elementAt.js":
/*!*****************************************************************!*\
  !*** ./node_modules/rxjs/_esm5/internal/operators/elementAt.js ***!
  \*****************************************************************/
/*! exports provided: elementAt */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "elementAt", function() { return elementAt; });
/* harmony import */ var _util_ArgumentOutOfRangeError__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../util/ArgumentOutOfRangeError */ "./node_modules/rxjs/_esm5/internal/util/ArgumentOutOfRangeError.js");
/* harmony import */ var _filter__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./filter */ "./node_modules/rxjs/_esm5/internal/operators/filter.js");
/* harmony import */ var _throwIfEmpty__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./throwIfEmpty */ "./node_modules/rxjs/_esm5/internal/operators/throwIfEmpty.js");
/* harmony import */ var _defaultIfEmpty__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./defaultIfEmpty */ "./node_modules/rxjs/_esm5/internal/operators/defaultIfEmpty.js");
/* harmony import */ var _take__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./take */ "./node_modules/rxjs/_esm5/internal/operators/take.js");
/** PURE_IMPORTS_START _util_ArgumentOutOfRangeError,_filter,_throwIfEmpty,_defaultIfEmpty,_take PURE_IMPORTS_END */





function elementAt(index, defaultValue) {
    if (index < 0) {
        throw new _util_ArgumentOutOfRangeError__WEBPACK_IMPORTED_MODULE_0__["ArgumentOutOfRangeError"]();
    }
    var hasDefaultValue = arguments.length >= 2;
    return function (source) {
        return source.pipe(Object(_filter__WEBPACK_IMPORTED_MODULE_1__["filter"])(function (v, i) { return i === index; }), Object(_take__WEBPACK_IMPORTED_MODULE_4__["take"])(1), hasDefaultValue
            ? Object(_defaultIfEmpty__WEBPACK_IMPORTED_MODULE_3__["defaultIfEmpty"])(defaultValue)
            : Object(_throwIfEmpty__WEBPACK_IMPORTED_MODULE_2__["throwIfEmpty"])(function () { return new _util_ArgumentOutOfRangeError__WEBPACK_IMPORTED_MODULE_0__["ArgumentOutOfRangeError"](); }));
    };
}
//# sourceMappingURL=elementAt.js.map


/***/ }),

/***/ "./node_modules/rxjs/_esm5/internal/operators/endWith.js":
/*!***************************************************************!*\
  !*** ./node_modules/rxjs/_esm5/internal/operators/endWith.js ***!
  \***************************************************************/
/*! exports provided: endWith */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "endWith", function() { return endWith; });
/* harmony import */ var _observable_concat__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../observable/concat */ "./node_modules/rxjs/_esm5/internal/observable/concat.js");
/* harmony import */ var _observable_of__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../observable/of */ "./node_modules/rxjs/_esm5/internal/observable/of.js");
/** PURE_IMPORTS_START _observable_concat,_observable_of PURE_IMPORTS_END */


function endWith() {
    var array = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        array[_i] = arguments[_i];
    }
    return function (source) { return Object(_observable_concat__WEBPACK_IMPORTED_MODULE_0__["concat"])(source, _observable_of__WEBPACK_IMPORTED_MODULE_1__["of"].apply(void 0, array)); };
}
//# sourceMappingURL=endWith.js.map


/***/ }),

/***/ "./node_modules/rxjs/_esm5/internal/operators/every.js":
/*!*************************************************************!*\
  !*** ./node_modules/rxjs/_esm5/internal/operators/every.js ***!
  \*************************************************************/
/*! exports provided: every */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "every", function() { return every; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/rxjs/node_modules/tslib/tslib.es6.js");
/* harmony import */ var _Subscriber__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../Subscriber */ "./node_modules/rxjs/_esm5/internal/Subscriber.js");
/** PURE_IMPORTS_START tslib,_Subscriber PURE_IMPORTS_END */


function every(predicate, thisArg) {
    return function (source) { return source.lift(new EveryOperator(predicate, thisArg, source)); };
}
var EveryOperator = /*@__PURE__*/ (function () {
    function EveryOperator(predicate, thisArg, source) {
        this.predicate = predicate;
        this.thisArg = thisArg;
        this.source = source;
    }
    EveryOperator.prototype.call = function (observer, source) {
        return source.subscribe(new EverySubscriber(observer, this.predicate, this.thisArg, this.source));
    };
    return EveryOperator;
}());
var EverySubscriber = /*@__PURE__*/ (function (_super) {
    tslib__WEBPACK_IMPORTED_MODULE_0__["__extends"](EverySubscriber, _super);
    function EverySubscriber(destination, predicate, thisArg, source) {
        var _this = _super.call(this, destination) || this;
        _this.predicate = predicate;
        _this.thisArg = thisArg;
        _this.source = source;
        _this.index = 0;
        _this.thisArg = thisArg || _this;
        return _this;
    }
    EverySubscriber.prototype.notifyComplete = function (everyValueMatch) {
        this.destination.next(everyValueMatch);
        this.destination.complete();
    };
    EverySubscriber.prototype._next = function (value) {
        var result = false;
        try {
            result = this.predicate.call(this.thisArg, value, this.index++, this.source);
        }
        catch (err) {
            this.destination.error(err);
            return;
        }
        if (!result) {
            this.notifyComplete(false);
        }
    };
    EverySubscriber.prototype._complete = function () {
        this.notifyComplete(true);
    };
    return EverySubscriber;
}(_Subscriber__WEBPACK_IMPORTED_MODULE_1__["Subscriber"]));
//# sourceMappingURL=every.js.map


/***/ }),

/***/ "./node_modules/rxjs/_esm5/internal/operators/exhaust.js":
/*!***************************************************************!*\
  !*** ./node_modules/rxjs/_esm5/internal/operators/exhaust.js ***!
  \***************************************************************/
/*! exports provided: exhaust */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "exhaust", function() { return exhaust; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/rxjs/node_modules/tslib/tslib.es6.js");
/* harmony import */ var _innerSubscribe__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../innerSubscribe */ "./node_modules/rxjs/_esm5/internal/innerSubscribe.js");
/** PURE_IMPORTS_START tslib,_innerSubscribe PURE_IMPORTS_END */


function exhaust() {
    return function (source) { return source.lift(new SwitchFirstOperator()); };
}
var SwitchFirstOperator = /*@__PURE__*/ (function () {
    function SwitchFirstOperator() {
    }
    SwitchFirstOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new SwitchFirstSubscriber(subscriber));
    };
    return SwitchFirstOperator;
}());
var SwitchFirstSubscriber = /*@__PURE__*/ (function (_super) {
    tslib__WEBPACK_IMPORTED_MODULE_0__["__extends"](SwitchFirstSubscriber, _super);
    function SwitchFirstSubscriber(destination) {
        var _this = _super.call(this, destination) || this;
        _this.hasCompleted = false;
        _this.hasSubscription = false;
        return _this;
    }
    SwitchFirstSubscriber.prototype._next = function (value) {
        if (!this.hasSubscription) {
            this.hasSubscription = true;
            this.add(Object(_innerSubscribe__WEBPACK_IMPORTED_MODULE_1__["innerSubscribe"])(value, new _innerSubscribe__WEBPACK_IMPORTED_MODULE_1__["SimpleInnerSubscriber"](this)));
        }
    };
    SwitchFirstSubscriber.prototype._complete = function () {
        this.hasCompleted = true;
        if (!this.hasSubscription) {
            this.destination.complete();
        }
    };
    SwitchFirstSubscriber.prototype.notifyComplete = function () {
        this.hasSubscription = false;
        if (this.hasCompleted) {
            this.destination.complete();
        }
    };
    return SwitchFirstSubscriber;
}(_innerSubscribe__WEBPACK_IMPORTED_MODULE_1__["SimpleOuterSubscriber"]));
//# sourceMappingURL=exhaust.js.map


/***/ }),

/***/ "./node_modules/rxjs/_esm5/internal/operators/exhaustMap.js":
/*!******************************************************************!*\
  !*** ./node_modules/rxjs/_esm5/internal/operators/exhaustMap.js ***!
  \******************************************************************/
/*! exports provided: exhaustMap */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "exhaustMap", function() { return exhaustMap; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/rxjs/node_modules/tslib/tslib.es6.js");
/* harmony import */ var _map__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./map */ "./node_modules/rxjs/_esm5/internal/operators/map.js");
/* harmony import */ var _observable_from__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../observable/from */ "./node_modules/rxjs/_esm5/internal/observable/from.js");
/* harmony import */ var _innerSubscribe__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../innerSubscribe */ "./node_modules/rxjs/_esm5/internal/innerSubscribe.js");
/** PURE_IMPORTS_START tslib,_map,_observable_from,_innerSubscribe PURE_IMPORTS_END */




function exhaustMap(project, resultSelector) {
    if (resultSelector) {
        return function (source) { return source.pipe(exhaustMap(function (a, i) { return Object(_observable_from__WEBPACK_IMPORTED_MODULE_2__["from"])(project(a, i)).pipe(Object(_map__WEBPACK_IMPORTED_MODULE_1__["map"])(function (b, ii) { return resultSelector(a, b, i, ii); })); })); };
    }
    return function (source) {
        return source.lift(new ExhaustMapOperator(project));
    };
}
var ExhaustMapOperator = /*@__PURE__*/ (function () {
    function ExhaustMapOperator(project) {
        this.project = project;
    }
    ExhaustMapOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new ExhaustMapSubscriber(subscriber, this.project));
    };
    return ExhaustMapOperator;
}());
var ExhaustMapSubscriber = /*@__PURE__*/ (function (_super) {
    tslib__WEBPACK_IMPORTED_MODULE_0__["__extends"](ExhaustMapSubscriber, _super);
    function ExhaustMapSubscriber(destination, project) {
        var _this = _super.call(this, destination) || this;
        _this.project = project;
        _this.hasSubscription = false;
        _this.hasCompleted = false;
        _this.index = 0;
        return _this;
    }
    ExhaustMapSubscriber.prototype._next = function (value) {
        if (!this.hasSubscription) {
            this.tryNext(value);
        }
    };
    ExhaustMapSubscriber.prototype.tryNext = function (value) {
        var result;
        var index = this.index++;
        try {
            result = this.project(value, index);
        }
        catch (err) {
            this.destination.error(err);
            return;
        }
        this.hasSubscription = true;
        this._innerSub(result);
    };
    ExhaustMapSubscriber.prototype._innerSub = function (result) {
        var innerSubscriber = new _innerSubscribe__WEBPACK_IMPORTED_MODULE_3__["SimpleInnerSubscriber"](this);
        var destination = this.destination;
        destination.add(innerSubscriber);
        var innerSubscription = Object(_innerSubscribe__WEBPACK_IMPORTED_MODULE_3__["innerSubscribe"])(result, innerSubscriber);
        if (innerSubscription !== innerSubscriber) {
            destination.add(innerSubscription);
        }
    };
    ExhaustMapSubscriber.prototype._complete = function () {
        this.hasCompleted = true;
        if (!this.hasSubscription) {
            this.destination.complete();
        }
        this.unsubscribe();
    };
    ExhaustMapSubscriber.prototype.notifyNext = function (innerValue) {
        this.destination.next(innerValue);
    };
    ExhaustMapSubscriber.prototype.notifyError = function (err) {
        this.destination.error(err);
    };
    ExhaustMapSubscriber.prototype.notifyComplete = function () {
        this.hasSubscription = false;
        if (this.hasCompleted) {
            this.destination.complete();
        }
    };
    return ExhaustMapSubscriber;
}(_innerSubscribe__WEBPACK_IMPORTED_MODULE_3__["SimpleOuterSubscriber"]));
//# sourceMappingURL=exhaustMap.js.map


/***/ }),

/***/ "./node_modules/rxjs/_esm5/internal/operators/expand.js":
/*!**************************************************************!*\
  !*** ./node_modules/rxjs/_esm5/internal/operators/expand.js ***!
  \**************************************************************/
/*! exports provided: expand, ExpandOperator, ExpandSubscriber */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "expand", function() { return expand; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ExpandOperator", function() { return ExpandOperator; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ExpandSubscriber", function() { return ExpandSubscriber; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/rxjs/node_modules/tslib/tslib.es6.js");
/* harmony import */ var _innerSubscribe__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../innerSubscribe */ "./node_modules/rxjs/_esm5/internal/innerSubscribe.js");
/** PURE_IMPORTS_START tslib,_innerSubscribe PURE_IMPORTS_END */


function expand(project, concurrent, scheduler) {
    if (concurrent === void 0) {
        concurrent = Number.POSITIVE_INFINITY;
    }
    concurrent = (concurrent || 0) < 1 ? Number.POSITIVE_INFINITY : concurrent;
    return function (source) { return source.lift(new ExpandOperator(project, concurrent, scheduler)); };
}
var ExpandOperator = /*@__PURE__*/ (function () {
    function ExpandOperator(project, concurrent, scheduler) {
        this.project = project;
        this.concurrent = concurrent;
        this.scheduler = scheduler;
    }
    ExpandOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new ExpandSubscriber(subscriber, this.project, this.concurrent, this.scheduler));
    };
    return ExpandOperator;
}());

var ExpandSubscriber = /*@__PURE__*/ (function (_super) {
    tslib__WEBPACK_IMPORTED_MODULE_0__["__extends"](ExpandSubscriber, _super);
    function ExpandSubscriber(destination, project, concurrent, scheduler) {
        var _this = _super.call(this, destination) || this;
        _this.project = project;
        _this.concurrent = concurrent;
        _this.scheduler = scheduler;
        _this.index = 0;
        _this.active = 0;
        _this.hasCompleted = false;
        if (concurrent < Number.POSITIVE_INFINITY) {
            _this.buffer = [];
        }
        return _this;
    }
    ExpandSubscriber.dispatch = function (arg) {
        var subscriber = arg.subscriber, result = arg.result, value = arg.value, index = arg.index;
        subscriber.subscribeToProjection(result, value, index);
    };
    ExpandSubscriber.prototype._next = function (value) {
        var destination = this.destination;
        if (destination.closed) {
            this._complete();
            return;
        }
        var index = this.index++;
        if (this.active < this.concurrent) {
            destination.next(value);
            try {
                var project = this.project;
                var result = project(value, index);
                if (!this.scheduler) {
                    this.subscribeToProjection(result, value, index);
                }
                else {
                    var state = { subscriber: this, result: result, value: value, index: index };
                    var destination_1 = this.destination;
                    destination_1.add(this.scheduler.schedule(ExpandSubscriber.dispatch, 0, state));
                }
            }
            catch (e) {
                destination.error(e);
            }
        }
        else {
            this.buffer.push(value);
        }
    };
    ExpandSubscriber.prototype.subscribeToProjection = function (result, value, index) {
        this.active++;
        var destination = this.destination;
        destination.add(Object(_innerSubscribe__WEBPACK_IMPORTED_MODULE_1__["innerSubscribe"])(result, new _innerSubscribe__WEBPACK_IMPORTED_MODULE_1__["SimpleInnerSubscriber"](this)));
    };
    ExpandSubscriber.prototype._complete = function () {
        this.hasCompleted = true;
        if (this.hasCompleted && this.active === 0) {
            this.destination.complete();
        }
        this.unsubscribe();
    };
    ExpandSubscriber.prototype.notifyNext = function (innerValue) {
        this._next(innerValue);
    };
    ExpandSubscriber.prototype.notifyComplete = function () {
        var buffer = this.buffer;
        this.active--;
        if (buffer && buffer.length > 0) {
            this._next(buffer.shift());
        }
        if (this.hasCompleted && this.active === 0) {
            this.destination.complete();
        }
    };
    return ExpandSubscriber;
}(_innerSubscribe__WEBPACK_IMPORTED_MODULE_1__["SimpleOuterSubscriber"]));

//# sourceMappingURL=expand.js.map


/***/ }),

/***/ "./node_modules/rxjs/_esm5/internal/operators/filter.js":
/*!**************************************************************!*\
  !*** ./node_modules/rxjs/_esm5/internal/operators/filter.js ***!
  \**************************************************************/
/*! exports provided: filter */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "filter", function() { return filter; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/rxjs/node_modules/tslib/tslib.es6.js");
/* harmony import */ var _Subscriber__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../Subscriber */ "./node_modules/rxjs/_esm5/internal/Subscriber.js");
/** PURE_IMPORTS_START tslib,_Subscriber PURE_IMPORTS_END */


function filter(predicate, thisArg) {
    return function filterOperatorFunction(source) {
        return source.lift(new FilterOperator(predicate, thisArg));
    };
}
var FilterOperator = /*@__PURE__*/ (function () {
    function FilterOperator(predicate, thisArg) {
        this.predicate = predicate;
        this.thisArg = thisArg;
    }
    FilterOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new FilterSubscriber(subscriber, this.predicate, this.thisArg));
    };
    return FilterOperator;
}());
var FilterSubscriber = /*@__PURE__*/ (function (_super) {
    tslib__WEBPACK_IMPORTED_MODULE_0__["__extends"](FilterSubscriber, _super);
    function FilterSubscriber(destination, predicate, thisArg) {
        var _this = _super.call(this, destination) || this;
        _this.predicate = predicate;
        _this.thisArg = thisArg;
        _this.count = 0;
        return _this;
    }
    FilterSubscriber.prototype._next = function (value) {
        var result;
        try {
            result = this.predicate.call(this.thisArg, value, this.count++);
        }
        catch (err) {
            this.destination.error(err);
            return;
        }
        if (result) {
            this.destination.next(value);
        }
    };
    return FilterSubscriber;
}(_Subscriber__WEBPACK_IMPORTED_MODULE_1__["Subscriber"]));
//# sourceMappingURL=filter.js.map


/***/ }),

/***/ "./node_modules/rxjs/_esm5/internal/operators/finalize.js":
/*!****************************************************************!*\
  !*** ./node_modules/rxjs/_esm5/internal/operators/finalize.js ***!
  \****************************************************************/
/*! exports provided: finalize */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "finalize", function() { return finalize; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/rxjs/node_modules/tslib/tslib.es6.js");
/* harmony import */ var _Subscriber__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../Subscriber */ "./node_modules/rxjs/_esm5/internal/Subscriber.js");
/* harmony import */ var _Subscription__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../Subscription */ "./node_modules/rxjs/_esm5/internal/Subscription.js");
/** PURE_IMPORTS_START tslib,_Subscriber,_Subscription PURE_IMPORTS_END */



function finalize(callback) {
    return function (source) { return source.lift(new FinallyOperator(callback)); };
}
var FinallyOperator = /*@__PURE__*/ (function () {
    function FinallyOperator(callback) {
        this.callback = callback;
    }
    FinallyOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new FinallySubscriber(subscriber, this.callback));
    };
    return FinallyOperator;
}());
var FinallySubscriber = /*@__PURE__*/ (function (_super) {
    tslib__WEBPACK_IMPORTED_MODULE_0__["__extends"](FinallySubscriber, _super);
    function FinallySubscriber(destination, callback) {
        var _this = _super.call(this, destination) || this;
        _this.add(new _Subscription__WEBPACK_IMPORTED_MODULE_2__["Subscription"](callback));
        return _this;
    }
    return FinallySubscriber;
}(_Subscriber__WEBPACK_IMPORTED_MODULE_1__["Subscriber"]));
//# sourceMappingURL=finalize.js.map


/***/ }),

/***/ "./node_modules/rxjs/_esm5/internal/operators/find.js":
/*!************************************************************!*\
  !*** ./node_modules/rxjs/_esm5/internal/operators/find.js ***!
  \************************************************************/
/*! exports provided: find, FindValueOperator, FindValueSubscriber */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "find", function() { return find; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FindValueOperator", function() { return FindValueOperator; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FindValueSubscriber", function() { return FindValueSubscriber; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/rxjs/node_modules/tslib/tslib.es6.js");
/* harmony import */ var _Subscriber__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../Subscriber */ "./node_modules/rxjs/_esm5/internal/Subscriber.js");
/** PURE_IMPORTS_START tslib,_Subscriber PURE_IMPORTS_END */


function find(predicate, thisArg) {
    if (typeof predicate !== 'function') {
        throw new TypeError('predicate is not a function');
    }
    return function (source) { return source.lift(new FindValueOperator(predicate, source, false, thisArg)); };
}
var FindValueOperator = /*@__PURE__*/ (function () {
    function FindValueOperator(predicate, source, yieldIndex, thisArg) {
        this.predicate = predicate;
        this.source = source;
        this.yieldIndex = yieldIndex;
        this.thisArg = thisArg;
    }
    FindValueOperator.prototype.call = function (observer, source) {
        return source.subscribe(new FindValueSubscriber(observer, this.predicate, this.source, this.yieldIndex, this.thisArg));
    };
    return FindValueOperator;
}());

var FindValueSubscriber = /*@__PURE__*/ (function (_super) {
    tslib__WEBPACK_IMPORTED_MODULE_0__["__extends"](FindValueSubscriber, _super);
    function FindValueSubscriber(destination, predicate, source, yieldIndex, thisArg) {
        var _this = _super.call(this, destination) || this;
        _this.predicate = predicate;
        _this.source = source;
        _this.yieldIndex = yieldIndex;
        _this.thisArg = thisArg;
        _this.index = 0;
        return _this;
    }
    FindValueSubscriber.prototype.notifyComplete = function (value) {
        var destination = this.destination;
        destination.next(value);
        destination.complete();
        this.unsubscribe();
    };
    FindValueSubscriber.prototype._next = function (value) {
        var _a = this, predicate = _a.predicate, thisArg = _a.thisArg;
        var index = this.index++;
        try {
            var result = predicate.call(thisArg || this, value, index, this.source);
            if (result) {
                this.notifyComplete(this.yieldIndex ? index : value);
            }
        }
        catch (err) {
            this.destination.error(err);
        }
    };
    FindValueSubscriber.prototype._complete = function () {
        this.notifyComplete(this.yieldIndex ? -1 : undefined);
    };
    return FindValueSubscriber;
}(_Subscriber__WEBPACK_IMPORTED_MODULE_1__["Subscriber"]));

//# sourceMappingURL=find.js.map


/***/ }),

/***/ "./node_modules/rxjs/_esm5/internal/operators/findIndex.js":
/*!*****************************************************************!*\
  !*** ./node_modules/rxjs/_esm5/internal/operators/findIndex.js ***!
  \*****************************************************************/
/*! exports provided: findIndex */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "findIndex", function() { return findIndex; });
/* harmony import */ var _operators_find__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../operators/find */ "./node_modules/rxjs/_esm5/internal/operators/find.js");
/** PURE_IMPORTS_START _operators_find PURE_IMPORTS_END */

function findIndex(predicate, thisArg) {
    return function (source) { return source.lift(new _operators_find__WEBPACK_IMPORTED_MODULE_0__["FindValueOperator"](predicate, source, true, thisArg)); };
}
//# sourceMappingURL=findIndex.js.map


/***/ }),

/***/ "./node_modules/rxjs/_esm5/internal/operators/first.js":
/*!*************************************************************!*\
  !*** ./node_modules/rxjs/_esm5/internal/operators/first.js ***!
  \*************************************************************/
/*! exports provided: first */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "first", function() { return first; });
/* harmony import */ var _util_EmptyError__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../util/EmptyError */ "./node_modules/rxjs/_esm5/internal/util/EmptyError.js");
/* harmony import */ var _filter__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./filter */ "./node_modules/rxjs/_esm5/internal/operators/filter.js");
/* harmony import */ var _take__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./take */ "./node_modules/rxjs/_esm5/internal/operators/take.js");
/* harmony import */ var _defaultIfEmpty__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./defaultIfEmpty */ "./node_modules/rxjs/_esm5/internal/operators/defaultIfEmpty.js");
/* harmony import */ var _throwIfEmpty__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./throwIfEmpty */ "./node_modules/rxjs/_esm5/internal/operators/throwIfEmpty.js");
/* harmony import */ var _util_identity__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../util/identity */ "./node_modules/rxjs/_esm5/internal/util/identity.js");
/** PURE_IMPORTS_START _util_EmptyError,_filter,_take,_defaultIfEmpty,_throwIfEmpty,_util_identity PURE_IMPORTS_END */






function first(predicate, defaultValue) {
    var hasDefaultValue = arguments.length >= 2;
    return function (source) { return source.pipe(predicate ? Object(_filter__WEBPACK_IMPORTED_MODULE_1__["filter"])(function (v, i) { return predicate(v, i, source); }) : _util_identity__WEBPACK_IMPORTED_MODULE_5__["identity"], Object(_take__WEBPACK_IMPORTED_MODULE_2__["take"])(1), hasDefaultValue ? Object(_defaultIfEmpty__WEBPACK_IMPORTED_MODULE_3__["defaultIfEmpty"])(defaultValue) : Object(_throwIfEmpty__WEBPACK_IMPORTED_MODULE_4__["throwIfEmpty"])(function () { return new _util_EmptyError__WEBPACK_IMPORTED_MODULE_0__["EmptyError"](); })); };
}
//# sourceMappingURL=first.js.map


/***/ }),

/***/ "./node_modules/rxjs/_esm5/internal/operators/groupBy.js":
/*!***************************************************************!*\
  !*** ./node_modules/rxjs/_esm5/internal/operators/groupBy.js ***!
  \***************************************************************/
/*! exports provided: groupBy, GroupedObservable */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "groupBy", function() { return groupBy; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "GroupedObservable", function() { return GroupedObservable; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/rxjs/node_modules/tslib/tslib.es6.js");
/* harmony import */ var _Subscriber__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../Subscriber */ "./node_modules/rxjs/_esm5/internal/Subscriber.js");
/* harmony import */ var _Subscription__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../Subscription */ "./node_modules/rxjs/_esm5/internal/Subscription.js");
/* harmony import */ var _Observable__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../Observable */ "./node_modules/rxjs/_esm5/internal/Observable.js");
/* harmony import */ var _Subject__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../Subject */ "./node_modules/rxjs/_esm5/internal/Subject.js");
/** PURE_IMPORTS_START tslib,_Subscriber,_Subscription,_Observable,_Subject PURE_IMPORTS_END */





function groupBy(keySelector, elementSelector, durationSelector, subjectSelector) {
    return function (source) {
        return source.lift(new GroupByOperator(keySelector, elementSelector, durationSelector, subjectSelector));
    };
}
var GroupByOperator = /*@__PURE__*/ (function () {
    function GroupByOperator(keySelector, elementSelector, durationSelector, subjectSelector) {
        this.keySelector = keySelector;
        this.elementSelector = elementSelector;
        this.durationSelector = durationSelector;
        this.subjectSelector = subjectSelector;
    }
    GroupByOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new GroupBySubscriber(subscriber, this.keySelector, this.elementSelector, this.durationSelector, this.subjectSelector));
    };
    return GroupByOperator;
}());
var GroupBySubscriber = /*@__PURE__*/ (function (_super) {
    tslib__WEBPACK_IMPORTED_MODULE_0__["__extends"](GroupBySubscriber, _super);
    function GroupBySubscriber(destination, keySelector, elementSelector, durationSelector, subjectSelector) {
        var _this = _super.call(this, destination) || this;
        _this.keySelector = keySelector;
        _this.elementSelector = elementSelector;
        _this.durationSelector = durationSelector;
        _this.subjectSelector = subjectSelector;
        _this.groups = null;
        _this.attemptedToUnsubscribe = false;
        _this.count = 0;
        return _this;
    }
    GroupBySubscriber.prototype._next = function (value) {
        var key;
        try {
            key = this.keySelector(value);
        }
        catch (err) {
            this.error(err);
            return;
        }
        this._group(value, key);
    };
    GroupBySubscriber.prototype._group = function (value, key) {
        var groups = this.groups;
        if (!groups) {
            groups = this.groups = new Map();
        }
        var group = groups.get(key);
        var element;
        if (this.elementSelector) {
            try {
                element = this.elementSelector(value);
            }
            catch (err) {
                this.error(err);
            }
        }
        else {
            element = value;
        }
        if (!group) {
            group = (this.subjectSelector ? this.subjectSelector() : new _Subject__WEBPACK_IMPORTED_MODULE_4__["Subject"]());
            groups.set(key, group);
            var groupedObservable = new GroupedObservable(key, group, this);
            this.destination.next(groupedObservable);
            if (this.durationSelector) {
                var duration = void 0;
                try {
                    duration = this.durationSelector(new GroupedObservable(key, group));
                }
                catch (err) {
                    this.error(err);
                    return;
                }
                this.add(duration.subscribe(new GroupDurationSubscriber(key, group, this)));
            }
        }
        if (!group.closed) {
            group.next(element);
        }
    };
    GroupBySubscriber.prototype._error = function (err) {
        var groups = this.groups;
        if (groups) {
            groups.forEach(function (group, key) {
                group.error(err);
            });
            groups.clear();
        }
        this.destination.error(err);
    };
    GroupBySubscriber.prototype._complete = function () {
        var groups = this.groups;
        if (groups) {
            groups.forEach(function (group, key) {
                group.complete();
            });
            groups.clear();
        }
        this.destination.complete();
    };
    GroupBySubscriber.prototype.removeGroup = function (key) {
        this.groups.delete(key);
    };
    GroupBySubscriber.prototype.unsubscribe = function () {
        if (!this.closed) {
            this.attemptedToUnsubscribe = true;
            if (this.count === 0) {
                _super.prototype.unsubscribe.call(this);
            }
        }
    };
    return GroupBySubscriber;
}(_Subscriber__WEBPACK_IMPORTED_MODULE_1__["Subscriber"]));
var GroupDurationSubscriber = /*@__PURE__*/ (function (_super) {
    tslib__WEBPACK_IMPORTED_MODULE_0__["__extends"](GroupDurationSubscriber, _super);
    function GroupDurationSubscriber(key, group, parent) {
        var _this = _super.call(this, group) || this;
        _this.key = key;
        _this.group = group;
        _this.parent = parent;
        return _this;
    }
    GroupDurationSubscriber.prototype._next = function (value) {
        this.complete();
    };
    GroupDurationSubscriber.prototype._unsubscribe = function () {
        var _a = this, parent = _a.parent, key = _a.key;
        this.key = this.parent = null;
        if (parent) {
            parent.removeGroup(key);
        }
    };
    return GroupDurationSubscriber;
}(_Subscriber__WEBPACK_IMPORTED_MODULE_1__["Subscriber"]));
var GroupedObservable = /*@__PURE__*/ (function (_super) {
    tslib__WEBPACK_IMPORTED_MODULE_0__["__extends"](GroupedObservable, _super);
    function GroupedObservable(key, groupSubject, refCountSubscription) {
        var _this = _super.call(this) || this;
        _this.key = key;
        _this.groupSubject = groupSubject;
        _this.refCountSubscription = refCountSubscription;
        return _this;
    }
    GroupedObservable.prototype._subscribe = function (subscriber) {
        var subscription = new _Subscription__WEBPACK_IMPORTED_MODULE_2__["Subscription"]();
        var _a = this, refCountSubscription = _a.refCountSubscription, groupSubject = _a.groupSubject;
        if (refCountSubscription && !refCountSubscription.closed) {
            subscription.add(new InnerRefCountSubscription(refCountSubscription));
        }
        subscription.add(groupSubject.subscribe(subscriber));
        return subscription;
    };
    return GroupedObservable;
}(_Observable__WEBPACK_IMPORTED_MODULE_3__["Observable"]));

var InnerRefCountSubscription = /*@__PURE__*/ (function (_super) {
    tslib__WEBPACK_IMPORTED_MODULE_0__["__extends"](InnerRefCountSubscription, _super);
    function InnerRefCountSubscription(parent) {
        var _this = _super.call(this) || this;
        _this.parent = parent;
        parent.count++;
        return _this;
    }
    InnerRefCountSubscription.prototype.unsubscribe = function () {
        var parent = this.parent;
        if (!parent.closed && !this.closed) {
            _super.prototype.unsubscribe.call(this);
            parent.count -= 1;
            if (parent.count === 0 && parent.attemptedToUnsubscribe) {
                parent.unsubscribe();
            }
        }
    };
    return InnerRefCountSubscription;
}(_Subscription__WEBPACK_IMPORTED_MODULE_2__["Subscription"]));
//# sourceMappingURL=groupBy.js.map


/***/ }),

/***/ "./node_modules/rxjs/_esm5/internal/operators/ignoreElements.js":
/*!**********************************************************************!*\
  !*** ./node_modules/rxjs/_esm5/internal/operators/ignoreElements.js ***!
  \**********************************************************************/
/*! exports provided: ignoreElements */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ignoreElements", function() { return ignoreElements; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/rxjs/node_modules/tslib/tslib.es6.js");
/* harmony import */ var _Subscriber__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../Subscriber */ "./node_modules/rxjs/_esm5/internal/Subscriber.js");
/** PURE_IMPORTS_START tslib,_Subscriber PURE_IMPORTS_END */


function ignoreElements() {
    return function ignoreElementsOperatorFunction(source) {
        return source.lift(new IgnoreElementsOperator());
    };
}
var IgnoreElementsOperator = /*@__PURE__*/ (function () {
    function IgnoreElementsOperator() {
    }
    IgnoreElementsOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new IgnoreElementsSubscriber(subscriber));
    };
    return IgnoreElementsOperator;
}());
var IgnoreElementsSubscriber = /*@__PURE__*/ (function (_super) {
    tslib__WEBPACK_IMPORTED_MODULE_0__["__extends"](IgnoreElementsSubscriber, _super);
    function IgnoreElementsSubscriber() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    IgnoreElementsSubscriber.prototype._next = function (unused) {
    };
    return IgnoreElementsSubscriber;
}(_Subscriber__WEBPACK_IMPORTED_MODULE_1__["Subscriber"]));
//# sourceMappingURL=ignoreElements.js.map


/***/ }),

/***/ "./node_modules/rxjs/_esm5/internal/operators/isEmpty.js":
/*!***************************************************************!*\
  !*** ./node_modules/rxjs/_esm5/internal/operators/isEmpty.js ***!
  \***************************************************************/
/*! exports provided: isEmpty */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isEmpty", function() { return isEmpty; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/rxjs/node_modules/tslib/tslib.es6.js");
/* harmony import */ var _Subscriber__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../Subscriber */ "./node_modules/rxjs/_esm5/internal/Subscriber.js");
/** PURE_IMPORTS_START tslib,_Subscriber PURE_IMPORTS_END */


function isEmpty() {
    return function (source) { return source.lift(new IsEmptyOperator()); };
}
var IsEmptyOperator = /*@__PURE__*/ (function () {
    function IsEmptyOperator() {
    }
    IsEmptyOperator.prototype.call = function (observer, source) {
        return source.subscribe(new IsEmptySubscriber(observer));
    };
    return IsEmptyOperator;
}());
var IsEmptySubscriber = /*@__PURE__*/ (function (_super) {
    tslib__WEBPACK_IMPORTED_MODULE_0__["__extends"](IsEmptySubscriber, _super);
    function IsEmptySubscriber(destination) {
        return _super.call(this, destination) || this;
    }
    IsEmptySubscriber.prototype.notifyComplete = function (isEmpty) {
        var destination = this.destination;
        destination.next(isEmpty);
        destination.complete();
    };
    IsEmptySubscriber.prototype._next = function (value) {
        this.notifyComplete(false);
    };
    IsEmptySubscriber.prototype._complete = function () {
        this.notifyComplete(true);
    };
    return IsEmptySubscriber;
}(_Subscriber__WEBPACK_IMPORTED_MODULE_1__["Subscriber"]));
//# sourceMappingURL=isEmpty.js.map


/***/ }),

/***/ "./node_modules/rxjs/_esm5/internal/operators/last.js":
/*!************************************************************!*\
  !*** ./node_modules/rxjs/_esm5/internal/operators/last.js ***!
  \************************************************************/
/*! exports provided: last */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "last", function() { return last; });
/* harmony import */ var _util_EmptyError__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../util/EmptyError */ "./node_modules/rxjs/_esm5/internal/util/EmptyError.js");
/* harmony import */ var _filter__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./filter */ "./node_modules/rxjs/_esm5/internal/operators/filter.js");
/* harmony import */ var _takeLast__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./takeLast */ "./node_modules/rxjs/_esm5/internal/operators/takeLast.js");
/* harmony import */ var _throwIfEmpty__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./throwIfEmpty */ "./node_modules/rxjs/_esm5/internal/operators/throwIfEmpty.js");
/* harmony import */ var _defaultIfEmpty__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./defaultIfEmpty */ "./node_modules/rxjs/_esm5/internal/operators/defaultIfEmpty.js");
/* harmony import */ var _util_identity__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../util/identity */ "./node_modules/rxjs/_esm5/internal/util/identity.js");
/** PURE_IMPORTS_START _util_EmptyError,_filter,_takeLast,_throwIfEmpty,_defaultIfEmpty,_util_identity PURE_IMPORTS_END */






function last(predicate, defaultValue) {
    var hasDefaultValue = arguments.length >= 2;
    return function (source) { return source.pipe(predicate ? Object(_filter__WEBPACK_IMPORTED_MODULE_1__["filter"])(function (v, i) { return predicate(v, i, source); }) : _util_identity__WEBPACK_IMPORTED_MODULE_5__["identity"], Object(_takeLast__WEBPACK_IMPORTED_MODULE_2__["takeLast"])(1), hasDefaultValue ? Object(_defaultIfEmpty__WEBPACK_IMPORTED_MODULE_4__["defaultIfEmpty"])(defaultValue) : Object(_throwIfEmpty__WEBPACK_IMPORTED_MODULE_3__["throwIfEmpty"])(function () { return new _util_EmptyError__WEBPACK_IMPORTED_MODULE_0__["EmptyError"](); })); };
}
//# sourceMappingURL=last.js.map


/***/ }),

/***/ "./node_modules/rxjs/_esm5/internal/operators/map.js":
/*!***********************************************************!*\
  !*** ./node_modules/rxjs/_esm5/internal/operators/map.js ***!
  \***********************************************************/
/*! exports provided: map, MapOperator */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "map", function() { return map; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MapOperator", function() { return MapOperator; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/rxjs/node_modules/tslib/tslib.es6.js");
/* harmony import */ var _Subscriber__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../Subscriber */ "./node_modules/rxjs/_esm5/internal/Subscriber.js");
/** PURE_IMPORTS_START tslib,_Subscriber PURE_IMPORTS_END */


function map(project, thisArg) {
    return function mapOperation(source) {
        if (typeof project !== 'function') {
            throw new TypeError('argument is not a function. Are you looking for `mapTo()`?');
        }
        return source.lift(new MapOperator(project, thisArg));
    };
}
var MapOperator = /*@__PURE__*/ (function () {
    function MapOperator(project, thisArg) {
        this.project = project;
        this.thisArg = thisArg;
    }
    MapOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new MapSubscriber(subscriber, this.project, this.thisArg));
    };
    return MapOperator;
}());

var MapSubscriber = /*@__PURE__*/ (function (_super) {
    tslib__WEBPACK_IMPORTED_MODULE_0__["__extends"](MapSubscriber, _super);
    function MapSubscriber(destination, project, thisArg) {
        var _this = _super.call(this, destination) || this;
        _this.project = project;
        _this.count = 0;
        _this.thisArg = thisArg || _this;
        return _this;
    }
    MapSubscriber.prototype._next = function (value) {
        var result;
        try {
            result = this.project.call(this.thisArg, value, this.count++);
        }
        catch (err) {
            this.destination.error(err);
            return;
        }
        this.destination.next(result);
    };
    return MapSubscriber;
}(_Subscriber__WEBPACK_IMPORTED_MODULE_1__["Subscriber"]));
//# sourceMappingURL=map.js.map


/***/ }),

/***/ "./node_modules/rxjs/_esm5/internal/operators/mapTo.js":
/*!*************************************************************!*\
  !*** ./node_modules/rxjs/_esm5/internal/operators/mapTo.js ***!
  \*************************************************************/
/*! exports provided: mapTo */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "mapTo", function() { return mapTo; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/rxjs/node_modules/tslib/tslib.es6.js");
/* harmony import */ var _Subscriber__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../Subscriber */ "./node_modules/rxjs/_esm5/internal/Subscriber.js");
/** PURE_IMPORTS_START tslib,_Subscriber PURE_IMPORTS_END */


function mapTo(value) {
    return function (source) { return source.lift(new MapToOperator(value)); };
}
var MapToOperator = /*@__PURE__*/ (function () {
    function MapToOperator(value) {
        this.value = value;
    }
    MapToOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new MapToSubscriber(subscriber, this.value));
    };
    return MapToOperator;
}());
var MapToSubscriber = /*@__PURE__*/ (function (_super) {
    tslib__WEBPACK_IMPORTED_MODULE_0__["__extends"](MapToSubscriber, _super);
    function MapToSubscriber(destination, value) {
        var _this = _super.call(this, destination) || this;
        _this.value = value;
        return _this;
    }
    MapToSubscriber.prototype._next = function (x) {
        this.destination.next(this.value);
    };
    return MapToSubscriber;
}(_Subscriber__WEBPACK_IMPORTED_MODULE_1__["Subscriber"]));
//# sourceMappingURL=mapTo.js.map


/***/ }),

/***/ "./node_modules/rxjs/_esm5/internal/operators/materialize.js":
/*!*******************************************************************!*\
  !*** ./node_modules/rxjs/_esm5/internal/operators/materialize.js ***!
  \*******************************************************************/
/*! exports provided: materialize */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "materialize", function() { return materialize; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/rxjs/node_modules/tslib/tslib.es6.js");
/* harmony import */ var _Subscriber__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../Subscriber */ "./node_modules/rxjs/_esm5/internal/Subscriber.js");
/* harmony import */ var _Notification__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../Notification */ "./node_modules/rxjs/_esm5/internal/Notification.js");
/** PURE_IMPORTS_START tslib,_Subscriber,_Notification PURE_IMPORTS_END */



function materialize() {
    return function materializeOperatorFunction(source) {
        return source.lift(new MaterializeOperator());
    };
}
var MaterializeOperator = /*@__PURE__*/ (function () {
    function MaterializeOperator() {
    }
    MaterializeOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new MaterializeSubscriber(subscriber));
    };
    return MaterializeOperator;
}());
var MaterializeSubscriber = /*@__PURE__*/ (function (_super) {
    tslib__WEBPACK_IMPORTED_MODULE_0__["__extends"](MaterializeSubscriber, _super);
    function MaterializeSubscriber(destination) {
        return _super.call(this, destination) || this;
    }
    MaterializeSubscriber.prototype._next = function (value) {
        this.destination.next(_Notification__WEBPACK_IMPORTED_MODULE_2__["Notification"].createNext(value));
    };
    MaterializeSubscriber.prototype._error = function (err) {
        var destination = this.destination;
        destination.next(_Notification__WEBPACK_IMPORTED_MODULE_2__["Notification"].createError(err));
        destination.complete();
    };
    MaterializeSubscriber.prototype._complete = function () {
        var destination = this.destination;
        destination.next(_Notification__WEBPACK_IMPORTED_MODULE_2__["Notification"].createComplete());
        destination.complete();
    };
    return MaterializeSubscriber;
}(_Subscriber__WEBPACK_IMPORTED_MODULE_1__["Subscriber"]));
//# sourceMappingURL=materialize.js.map


/***/ }),

/***/ "./node_modules/rxjs/_esm5/internal/operators/max.js":
/*!***********************************************************!*\
  !*** ./node_modules/rxjs/_esm5/internal/operators/max.js ***!
  \***********************************************************/
/*! exports provided: max */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "max", function() { return max; });
/* harmony import */ var _reduce__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./reduce */ "./node_modules/rxjs/_esm5/internal/operators/reduce.js");
/** PURE_IMPORTS_START _reduce PURE_IMPORTS_END */

function max(comparer) {
    var max = (typeof comparer === 'function')
        ? function (x, y) { return comparer(x, y) > 0 ? x : y; }
        : function (x, y) { return x > y ? x : y; };
    return Object(_reduce__WEBPACK_IMPORTED_MODULE_0__["reduce"])(max);
}
//# sourceMappingURL=max.js.map


/***/ }),

/***/ "./node_modules/rxjs/_esm5/internal/operators/merge.js":
/*!*************************************************************!*\
  !*** ./node_modules/rxjs/_esm5/internal/operators/merge.js ***!
  \*************************************************************/
/*! exports provided: merge */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "merge", function() { return merge; });
/* harmony import */ var _observable_merge__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../observable/merge */ "./node_modules/rxjs/_esm5/internal/observable/merge.js");
/** PURE_IMPORTS_START _observable_merge PURE_IMPORTS_END */

function merge() {
    var observables = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        observables[_i] = arguments[_i];
    }
    return function (source) { return source.lift.call(_observable_merge__WEBPACK_IMPORTED_MODULE_0__["merge"].apply(void 0, [source].concat(observables))); };
}
//# sourceMappingURL=merge.js.map


/***/ }),

/***/ "./node_modules/rxjs/_esm5/internal/operators/mergeAll.js":
/*!****************************************************************!*\
  !*** ./node_modules/rxjs/_esm5/internal/operators/mergeAll.js ***!
  \****************************************************************/
/*! exports provided: mergeAll */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "mergeAll", function() { return mergeAll; });
/* harmony import */ var _mergeMap__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./mergeMap */ "./node_modules/rxjs/_esm5/internal/operators/mergeMap.js");
/* harmony import */ var _util_identity__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../util/identity */ "./node_modules/rxjs/_esm5/internal/util/identity.js");
/** PURE_IMPORTS_START _mergeMap,_util_identity PURE_IMPORTS_END */


function mergeAll(concurrent) {
    if (concurrent === void 0) {
        concurrent = Number.POSITIVE_INFINITY;
    }
    return Object(_mergeMap__WEBPACK_IMPORTED_MODULE_0__["mergeMap"])(_util_identity__WEBPACK_IMPORTED_MODULE_1__["identity"], concurrent);
}
//# sourceMappingURL=mergeAll.js.map


/***/ }),

/***/ "./node_modules/rxjs/_esm5/internal/operators/mergeMap.js":
/*!****************************************************************!*\
  !*** ./node_modules/rxjs/_esm5/internal/operators/mergeMap.js ***!
  \****************************************************************/
/*! exports provided: mergeMap, MergeMapOperator, MergeMapSubscriber, flatMap */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "mergeMap", function() { return mergeMap; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MergeMapOperator", function() { return MergeMapOperator; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MergeMapSubscriber", function() { return MergeMapSubscriber; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "flatMap", function() { return flatMap; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/rxjs/node_modules/tslib/tslib.es6.js");
/* harmony import */ var _map__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./map */ "./node_modules/rxjs/_esm5/internal/operators/map.js");
/* harmony import */ var _observable_from__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../observable/from */ "./node_modules/rxjs/_esm5/internal/observable/from.js");
/* harmony import */ var _innerSubscribe__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../innerSubscribe */ "./node_modules/rxjs/_esm5/internal/innerSubscribe.js");
/** PURE_IMPORTS_START tslib,_map,_observable_from,_innerSubscribe PURE_IMPORTS_END */




function mergeMap(project, resultSelector, concurrent) {
    if (concurrent === void 0) {
        concurrent = Number.POSITIVE_INFINITY;
    }
    if (typeof resultSelector === 'function') {
        return function (source) { return source.pipe(mergeMap(function (a, i) { return Object(_observable_from__WEBPACK_IMPORTED_MODULE_2__["from"])(project(a, i)).pipe(Object(_map__WEBPACK_IMPORTED_MODULE_1__["map"])(function (b, ii) { return resultSelector(a, b, i, ii); })); }, concurrent)); };
    }
    else if (typeof resultSelector === 'number') {
        concurrent = resultSelector;
    }
    return function (source) { return source.lift(new MergeMapOperator(project, concurrent)); };
}
var MergeMapOperator = /*@__PURE__*/ (function () {
    function MergeMapOperator(project, concurrent) {
        if (concurrent === void 0) {
            concurrent = Number.POSITIVE_INFINITY;
        }
        this.project = project;
        this.concurrent = concurrent;
    }
    MergeMapOperator.prototype.call = function (observer, source) {
        return source.subscribe(new MergeMapSubscriber(observer, this.project, this.concurrent));
    };
    return MergeMapOperator;
}());

var MergeMapSubscriber = /*@__PURE__*/ (function (_super) {
    tslib__WEBPACK_IMPORTED_MODULE_0__["__extends"](MergeMapSubscriber, _super);
    function MergeMapSubscriber(destination, project, concurrent) {
        if (concurrent === void 0) {
            concurrent = Number.POSITIVE_INFINITY;
        }
        var _this = _super.call(this, destination) || this;
        _this.project = project;
        _this.concurrent = concurrent;
        _this.hasCompleted = false;
        _this.buffer = [];
        _this.active = 0;
        _this.index = 0;
        return _this;
    }
    MergeMapSubscriber.prototype._next = function (value) {
        if (this.active < this.concurrent) {
            this._tryNext(value);
        }
        else {
            this.buffer.push(value);
        }
    };
    MergeMapSubscriber.prototype._tryNext = function (value) {
        var result;
        var index = this.index++;
        try {
            result = this.project(value, index);
        }
        catch (err) {
            this.destination.error(err);
            return;
        }
        this.active++;
        this._innerSub(result);
    };
    MergeMapSubscriber.prototype._innerSub = function (ish) {
        var innerSubscriber = new _innerSubscribe__WEBPACK_IMPORTED_MODULE_3__["SimpleInnerSubscriber"](this);
        var destination = this.destination;
        destination.add(innerSubscriber);
        var innerSubscription = Object(_innerSubscribe__WEBPACK_IMPORTED_MODULE_3__["innerSubscribe"])(ish, innerSubscriber);
        if (innerSubscription !== innerSubscriber) {
            destination.add(innerSubscription);
        }
    };
    MergeMapSubscriber.prototype._complete = function () {
        this.hasCompleted = true;
        if (this.active === 0 && this.buffer.length === 0) {
            this.destination.complete();
        }
        this.unsubscribe();
    };
    MergeMapSubscriber.prototype.notifyNext = function (innerValue) {
        this.destination.next(innerValue);
    };
    MergeMapSubscriber.prototype.notifyComplete = function () {
        var buffer = this.buffer;
        this.active--;
        if (buffer.length > 0) {
            this._next(buffer.shift());
        }
        else if (this.active === 0 && this.hasCompleted) {
            this.destination.complete();
        }
    };
    return MergeMapSubscriber;
}(_innerSubscribe__WEBPACK_IMPORTED_MODULE_3__["SimpleOuterSubscriber"]));

var flatMap = mergeMap;
//# sourceMappingURL=mergeMap.js.map


/***/ }),

/***/ "./node_modules/rxjs/_esm5/internal/operators/mergeMapTo.js":
/*!******************************************************************!*\
  !*** ./node_modules/rxjs/_esm5/internal/operators/mergeMapTo.js ***!
  \******************************************************************/
/*! exports provided: mergeMapTo */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "mergeMapTo", function() { return mergeMapTo; });
/* harmony import */ var _mergeMap__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./mergeMap */ "./node_modules/rxjs/_esm5/internal/operators/mergeMap.js");
/** PURE_IMPORTS_START _mergeMap PURE_IMPORTS_END */

function mergeMapTo(innerObservable, resultSelector, concurrent) {
    if (concurrent === void 0) {
        concurrent = Number.POSITIVE_INFINITY;
    }
    if (typeof resultSelector === 'function') {
        return Object(_mergeMap__WEBPACK_IMPORTED_MODULE_0__["mergeMap"])(function () { return innerObservable; }, resultSelector, concurrent);
    }
    if (typeof resultSelector === 'number') {
        concurrent = resultSelector;
    }
    return Object(_mergeMap__WEBPACK_IMPORTED_MODULE_0__["mergeMap"])(function () { return innerObservable; }, concurrent);
}
//# sourceMappingURL=mergeMapTo.js.map


/***/ }),

/***/ "./node_modules/rxjs/_esm5/internal/operators/mergeScan.js":
/*!*****************************************************************!*\
  !*** ./node_modules/rxjs/_esm5/internal/operators/mergeScan.js ***!
  \*****************************************************************/
/*! exports provided: mergeScan, MergeScanOperator, MergeScanSubscriber */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "mergeScan", function() { return mergeScan; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MergeScanOperator", function() { return MergeScanOperator; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MergeScanSubscriber", function() { return MergeScanSubscriber; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/rxjs/node_modules/tslib/tslib.es6.js");
/* harmony import */ var _innerSubscribe__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../innerSubscribe */ "./node_modules/rxjs/_esm5/internal/innerSubscribe.js");
/** PURE_IMPORTS_START tslib,_innerSubscribe PURE_IMPORTS_END */


function mergeScan(accumulator, seed, concurrent) {
    if (concurrent === void 0) {
        concurrent = Number.POSITIVE_INFINITY;
    }
    return function (source) { return source.lift(new MergeScanOperator(accumulator, seed, concurrent)); };
}
var MergeScanOperator = /*@__PURE__*/ (function () {
    function MergeScanOperator(accumulator, seed, concurrent) {
        this.accumulator = accumulator;
        this.seed = seed;
        this.concurrent = concurrent;
    }
    MergeScanOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new MergeScanSubscriber(subscriber, this.accumulator, this.seed, this.concurrent));
    };
    return MergeScanOperator;
}());

var MergeScanSubscriber = /*@__PURE__*/ (function (_super) {
    tslib__WEBPACK_IMPORTED_MODULE_0__["__extends"](MergeScanSubscriber, _super);
    function MergeScanSubscriber(destination, accumulator, acc, concurrent) {
        var _this = _super.call(this, destination) || this;
        _this.accumulator = accumulator;
        _this.acc = acc;
        _this.concurrent = concurrent;
        _this.hasValue = false;
        _this.hasCompleted = false;
        _this.buffer = [];
        _this.active = 0;
        _this.index = 0;
        return _this;
    }
    MergeScanSubscriber.prototype._next = function (value) {
        if (this.active < this.concurrent) {
            var index = this.index++;
            var destination = this.destination;
            var ish = void 0;
            try {
                var accumulator = this.accumulator;
                ish = accumulator(this.acc, value, index);
            }
            catch (e) {
                return destination.error(e);
            }
            this.active++;
            this._innerSub(ish);
        }
        else {
            this.buffer.push(value);
        }
    };
    MergeScanSubscriber.prototype._innerSub = function (ish) {
        var innerSubscriber = new _innerSubscribe__WEBPACK_IMPORTED_MODULE_1__["SimpleInnerSubscriber"](this);
        var destination = this.destination;
        destination.add(innerSubscriber);
        var innerSubscription = Object(_innerSubscribe__WEBPACK_IMPORTED_MODULE_1__["innerSubscribe"])(ish, innerSubscriber);
        if (innerSubscription !== innerSubscriber) {
            destination.add(innerSubscription);
        }
    };
    MergeScanSubscriber.prototype._complete = function () {
        this.hasCompleted = true;
        if (this.active === 0 && this.buffer.length === 0) {
            if (this.hasValue === false) {
                this.destination.next(this.acc);
            }
            this.destination.complete();
        }
        this.unsubscribe();
    };
    MergeScanSubscriber.prototype.notifyNext = function (innerValue) {
        var destination = this.destination;
        this.acc = innerValue;
        this.hasValue = true;
        destination.next(innerValue);
    };
    MergeScanSubscriber.prototype.notifyComplete = function () {
        var buffer = this.buffer;
        this.active--;
        if (buffer.length > 0) {
            this._next(buffer.shift());
        }
        else if (this.active === 0 && this.hasCompleted) {
            if (this.hasValue === false) {
                this.destination.next(this.acc);
            }
            this.destination.complete();
        }
    };
    return MergeScanSubscriber;
}(_innerSubscribe__WEBPACK_IMPORTED_MODULE_1__["SimpleOuterSubscriber"]));

//# sourceMappingURL=mergeScan.js.map


/***/ }),

/***/ "./node_modules/rxjs/_esm5/internal/operators/min.js":
/*!***********************************************************!*\
  !*** ./node_modules/rxjs/_esm5/internal/operators/min.js ***!
  \***********************************************************/
/*! exports provided: min */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "min", function() { return min; });
/* harmony import */ var _reduce__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./reduce */ "./node_modules/rxjs/_esm5/internal/operators/reduce.js");
/** PURE_IMPORTS_START _reduce PURE_IMPORTS_END */

function min(comparer) {
    var min = (typeof comparer === 'function')
        ? function (x, y) { return comparer(x, y) < 0 ? x : y; }
        : function (x, y) { return x < y ? x : y; };
    return Object(_reduce__WEBPACK_IMPORTED_MODULE_0__["reduce"])(min);
}
//# sourceMappingURL=min.js.map


/***/ }),

/***/ "./node_modules/rxjs/_esm5/internal/operators/multicast.js":
/*!*****************************************************************!*\
  !*** ./node_modules/rxjs/_esm5/internal/operators/multicast.js ***!
  \*****************************************************************/
/*! exports provided: multicast, MulticastOperator */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "multicast", function() { return multicast; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MulticastOperator", function() { return MulticastOperator; });
/* harmony import */ var _observable_ConnectableObservable__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../observable/ConnectableObservable */ "./node_modules/rxjs/_esm5/internal/observable/ConnectableObservable.js");
/** PURE_IMPORTS_START _observable_ConnectableObservable PURE_IMPORTS_END */

function multicast(subjectOrSubjectFactory, selector) {
    return function multicastOperatorFunction(source) {
        var subjectFactory;
        if (typeof subjectOrSubjectFactory === 'function') {
            subjectFactory = subjectOrSubjectFactory;
        }
        else {
            subjectFactory = function subjectFactory() {
                return subjectOrSubjectFactory;
            };
        }
        if (typeof selector === 'function') {
            return source.lift(new MulticastOperator(subjectFactory, selector));
        }
        var connectable = Object.create(source, _observable_ConnectableObservable__WEBPACK_IMPORTED_MODULE_0__["connectableObservableDescriptor"]);
        connectable.source = source;
        connectable.subjectFactory = subjectFactory;
        return connectable;
    };
}
var MulticastOperator = /*@__PURE__*/ (function () {
    function MulticastOperator(subjectFactory, selector) {
        this.subjectFactory = subjectFactory;
        this.selector = selector;
    }
    MulticastOperator.prototype.call = function (subscriber, source) {
        var selector = this.selector;
        var subject = this.subjectFactory();
        var subscription = selector(subject).subscribe(subscriber);
        subscription.add(source.subscribe(subject));
        return subscription;
    };
    return MulticastOperator;
}());

//# sourceMappingURL=multicast.js.map


/***/ }),

/***/ "./node_modules/rxjs/_esm5/internal/operators/observeOn.js":
/*!*****************************************************************!*\
  !*** ./node_modules/rxjs/_esm5/internal/operators/observeOn.js ***!
  \*****************************************************************/
/*! exports provided: observeOn, ObserveOnOperator, ObserveOnSubscriber, ObserveOnMessage */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "observeOn", function() { return observeOn; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ObserveOnOperator", function() { return ObserveOnOperator; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ObserveOnSubscriber", function() { return ObserveOnSubscriber; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ObserveOnMessage", function() { return ObserveOnMessage; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/rxjs/node_modules/tslib/tslib.es6.js");
/* harmony import */ var _Subscriber__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../Subscriber */ "./node_modules/rxjs/_esm5/internal/Subscriber.js");
/* harmony import */ var _Notification__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../Notification */ "./node_modules/rxjs/_esm5/internal/Notification.js");
/** PURE_IMPORTS_START tslib,_Subscriber,_Notification PURE_IMPORTS_END */



function observeOn(scheduler, delay) {
    if (delay === void 0) {
        delay = 0;
    }
    return function observeOnOperatorFunction(source) {
        return source.lift(new ObserveOnOperator(scheduler, delay));
    };
}
var ObserveOnOperator = /*@__PURE__*/ (function () {
    function ObserveOnOperator(scheduler, delay) {
        if (delay === void 0) {
            delay = 0;
        }
        this.scheduler = scheduler;
        this.delay = delay;
    }
    ObserveOnOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new ObserveOnSubscriber(subscriber, this.scheduler, this.delay));
    };
    return ObserveOnOperator;
}());

var ObserveOnSubscriber = /*@__PURE__*/ (function (_super) {
    tslib__WEBPACK_IMPORTED_MODULE_0__["__extends"](ObserveOnSubscriber, _super);
    function ObserveOnSubscriber(destination, scheduler, delay) {
        if (delay === void 0) {
            delay = 0;
        }
        var _this = _super.call(this, destination) || this;
        _this.scheduler = scheduler;
        _this.delay = delay;
        return _this;
    }
    ObserveOnSubscriber.dispatch = function (arg) {
        var notification = arg.notification, destination = arg.destination;
        notification.observe(destination);
        this.unsubscribe();
    };
    ObserveOnSubscriber.prototype.scheduleMessage = function (notification) {
        var destination = this.destination;
        destination.add(this.scheduler.schedule(ObserveOnSubscriber.dispatch, this.delay, new ObserveOnMessage(notification, this.destination)));
    };
    ObserveOnSubscriber.prototype._next = function (value) {
        this.scheduleMessage(_Notification__WEBPACK_IMPORTED_MODULE_2__["Notification"].createNext(value));
    };
    ObserveOnSubscriber.prototype._error = function (err) {
        this.scheduleMessage(_Notification__WEBPACK_IMPORTED_MODULE_2__["Notification"].createError(err));
        this.unsubscribe();
    };
    ObserveOnSubscriber.prototype._complete = function () {
        this.scheduleMessage(_Notification__WEBPACK_IMPORTED_MODULE_2__["Notification"].createComplete());
        this.unsubscribe();
    };
    return ObserveOnSubscriber;
}(_Subscriber__WEBPACK_IMPORTED_MODULE_1__["Subscriber"]));

var ObserveOnMessage = /*@__PURE__*/ (function () {
    function ObserveOnMessage(notification, destination) {
        this.notification = notification;
        this.destination = destination;
    }
    return ObserveOnMessage;
}());

//# sourceMappingURL=observeOn.js.map


/***/ }),

/***/ "./node_modules/rxjs/_esm5/internal/operators/onErrorResumeNext.js":
/*!*************************************************************************!*\
  !*** ./node_modules/rxjs/_esm5/internal/operators/onErrorResumeNext.js ***!
  \*************************************************************************/
/*! exports provided: onErrorResumeNext, onErrorResumeNextStatic */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "onErrorResumeNext", function() { return onErrorResumeNext; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "onErrorResumeNextStatic", function() { return onErrorResumeNextStatic; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/rxjs/node_modules/tslib/tslib.es6.js");
/* harmony import */ var _observable_from__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../observable/from */ "./node_modules/rxjs/_esm5/internal/observable/from.js");
/* harmony import */ var _util_isArray__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../util/isArray */ "./node_modules/rxjs/_esm5/internal/util/isArray.js");
/* harmony import */ var _innerSubscribe__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../innerSubscribe */ "./node_modules/rxjs/_esm5/internal/innerSubscribe.js");
/** PURE_IMPORTS_START tslib,_observable_from,_util_isArray,_innerSubscribe PURE_IMPORTS_END */




function onErrorResumeNext() {
    var nextSources = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        nextSources[_i] = arguments[_i];
    }
    if (nextSources.length === 1 && Object(_util_isArray__WEBPACK_IMPORTED_MODULE_2__["isArray"])(nextSources[0])) {
        nextSources = nextSources[0];
    }
    return function (source) { return source.lift(new OnErrorResumeNextOperator(nextSources)); };
}
function onErrorResumeNextStatic() {
    var nextSources = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        nextSources[_i] = arguments[_i];
    }
    var source = undefined;
    if (nextSources.length === 1 && Object(_util_isArray__WEBPACK_IMPORTED_MODULE_2__["isArray"])(nextSources[0])) {
        nextSources = nextSources[0];
    }
    source = nextSources.shift();
    return Object(_observable_from__WEBPACK_IMPORTED_MODULE_1__["from"])(source).lift(new OnErrorResumeNextOperator(nextSources));
}
var OnErrorResumeNextOperator = /*@__PURE__*/ (function () {
    function OnErrorResumeNextOperator(nextSources) {
        this.nextSources = nextSources;
    }
    OnErrorResumeNextOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new OnErrorResumeNextSubscriber(subscriber, this.nextSources));
    };
    return OnErrorResumeNextOperator;
}());
var OnErrorResumeNextSubscriber = /*@__PURE__*/ (function (_super) {
    tslib__WEBPACK_IMPORTED_MODULE_0__["__extends"](OnErrorResumeNextSubscriber, _super);
    function OnErrorResumeNextSubscriber(destination, nextSources) {
        var _this = _super.call(this, destination) || this;
        _this.destination = destination;
        _this.nextSources = nextSources;
        return _this;
    }
    OnErrorResumeNextSubscriber.prototype.notifyError = function () {
        this.subscribeToNextSource();
    };
    OnErrorResumeNextSubscriber.prototype.notifyComplete = function () {
        this.subscribeToNextSource();
    };
    OnErrorResumeNextSubscriber.prototype._error = function (err) {
        this.subscribeToNextSource();
        this.unsubscribe();
    };
    OnErrorResumeNextSubscriber.prototype._complete = function () {
        this.subscribeToNextSource();
        this.unsubscribe();
    };
    OnErrorResumeNextSubscriber.prototype.subscribeToNextSource = function () {
        var next = this.nextSources.shift();
        if (!!next) {
            var innerSubscriber = new _innerSubscribe__WEBPACK_IMPORTED_MODULE_3__["SimpleInnerSubscriber"](this);
            var destination = this.destination;
            destination.add(innerSubscriber);
            var innerSubscription = Object(_innerSubscribe__WEBPACK_IMPORTED_MODULE_3__["innerSubscribe"])(next, innerSubscriber);
            if (innerSubscription !== innerSubscriber) {
                destination.add(innerSubscription);
            }
        }
        else {
            this.destination.complete();
        }
    };
    return OnErrorResumeNextSubscriber;
}(_innerSubscribe__WEBPACK_IMPORTED_MODULE_3__["SimpleOuterSubscriber"]));
//# sourceMappingURL=onErrorResumeNext.js.map


/***/ }),

/***/ "./node_modules/rxjs/_esm5/internal/operators/pairwise.js":
/*!****************************************************************!*\
  !*** ./node_modules/rxjs/_esm5/internal/operators/pairwise.js ***!
  \****************************************************************/
/*! exports provided: pairwise */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "pairwise", function() { return pairwise; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/rxjs/node_modules/tslib/tslib.es6.js");
/* harmony import */ var _Subscriber__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../Subscriber */ "./node_modules/rxjs/_esm5/internal/Subscriber.js");
/** PURE_IMPORTS_START tslib,_Subscriber PURE_IMPORTS_END */


function pairwise() {
    return function (source) { return source.lift(new PairwiseOperator()); };
}
var PairwiseOperator = /*@__PURE__*/ (function () {
    function PairwiseOperator() {
    }
    PairwiseOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new PairwiseSubscriber(subscriber));
    };
    return PairwiseOperator;
}());
var PairwiseSubscriber = /*@__PURE__*/ (function (_super) {
    tslib__WEBPACK_IMPORTED_MODULE_0__["__extends"](PairwiseSubscriber, _super);
    function PairwiseSubscriber(destination) {
        var _this = _super.call(this, destination) || this;
        _this.hasPrev = false;
        return _this;
    }
    PairwiseSubscriber.prototype._next = function (value) {
        var pair;
        if (this.hasPrev) {
            pair = [this.prev, value];
        }
        else {
            this.hasPrev = true;
        }
        this.prev = value;
        if (pair) {
            this.destination.next(pair);
        }
    };
    return PairwiseSubscriber;
}(_Subscriber__WEBPACK_IMPORTED_MODULE_1__["Subscriber"]));
//# sourceMappingURL=pairwise.js.map


/***/ }),

/***/ "./node_modules/rxjs/_esm5/internal/operators/partition.js":
/*!*****************************************************************!*\
  !*** ./node_modules/rxjs/_esm5/internal/operators/partition.js ***!
  \*****************************************************************/
/*! exports provided: partition */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "partition", function() { return partition; });
/* harmony import */ var _util_not__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../util/not */ "./node_modules/rxjs/_esm5/internal/util/not.js");
/* harmony import */ var _filter__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./filter */ "./node_modules/rxjs/_esm5/internal/operators/filter.js");
/** PURE_IMPORTS_START _util_not,_filter PURE_IMPORTS_END */


function partition(predicate, thisArg) {
    return function (source) {
        return [
            Object(_filter__WEBPACK_IMPORTED_MODULE_1__["filter"])(predicate, thisArg)(source),
            Object(_filter__WEBPACK_IMPORTED_MODULE_1__["filter"])(Object(_util_not__WEBPACK_IMPORTED_MODULE_0__["not"])(predicate, thisArg))(source)
        ];
    };
}
//# sourceMappingURL=partition.js.map


/***/ }),

/***/ "./node_modules/rxjs/_esm5/internal/operators/pluck.js":
/*!*************************************************************!*\
  !*** ./node_modules/rxjs/_esm5/internal/operators/pluck.js ***!
  \*************************************************************/
/*! exports provided: pluck */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "pluck", function() { return pluck; });
/* harmony import */ var _map__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./map */ "./node_modules/rxjs/_esm5/internal/operators/map.js");
/** PURE_IMPORTS_START _map PURE_IMPORTS_END */

function pluck() {
    var properties = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        properties[_i] = arguments[_i];
    }
    var length = properties.length;
    if (length === 0) {
        throw new Error('list of properties cannot be empty.');
    }
    return function (source) { return Object(_map__WEBPACK_IMPORTED_MODULE_0__["map"])(plucker(properties, length))(source); };
}
function plucker(props, length) {
    var mapper = function (x) {
        var currentProp = x;
        for (var i = 0; i < length; i++) {
            var p = currentProp != null ? currentProp[props[i]] : undefined;
            if (p !== void 0) {
                currentProp = p;
            }
            else {
                return undefined;
            }
        }
        return currentProp;
    };
    return mapper;
}
//# sourceMappingURL=pluck.js.map


/***/ }),

/***/ "./node_modules/rxjs/_esm5/internal/operators/publish.js":
/*!***************************************************************!*\
  !*** ./node_modules/rxjs/_esm5/internal/operators/publish.js ***!
  \***************************************************************/
/*! exports provided: publish */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "publish", function() { return publish; });
/* harmony import */ var _Subject__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../Subject */ "./node_modules/rxjs/_esm5/internal/Subject.js");
/* harmony import */ var _multicast__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./multicast */ "./node_modules/rxjs/_esm5/internal/operators/multicast.js");
/** PURE_IMPORTS_START _Subject,_multicast PURE_IMPORTS_END */


function publish(selector) {
    return selector ?
        Object(_multicast__WEBPACK_IMPORTED_MODULE_1__["multicast"])(function () { return new _Subject__WEBPACK_IMPORTED_MODULE_0__["Subject"](); }, selector) :
        Object(_multicast__WEBPACK_IMPORTED_MODULE_1__["multicast"])(new _Subject__WEBPACK_IMPORTED_MODULE_0__["Subject"]());
}
//# sourceMappingURL=publish.js.map


/***/ }),

/***/ "./node_modules/rxjs/_esm5/internal/operators/publishBehavior.js":
/*!***********************************************************************!*\
  !*** ./node_modules/rxjs/_esm5/internal/operators/publishBehavior.js ***!
  \***********************************************************************/
/*! exports provided: publishBehavior */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "publishBehavior", function() { return publishBehavior; });
/* harmony import */ var _BehaviorSubject__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../BehaviorSubject */ "./node_modules/rxjs/_esm5/internal/BehaviorSubject.js");
/* harmony import */ var _multicast__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./multicast */ "./node_modules/rxjs/_esm5/internal/operators/multicast.js");
/** PURE_IMPORTS_START _BehaviorSubject,_multicast PURE_IMPORTS_END */


function publishBehavior(value) {
    return function (source) { return Object(_multicast__WEBPACK_IMPORTED_MODULE_1__["multicast"])(new _BehaviorSubject__WEBPACK_IMPORTED_MODULE_0__["BehaviorSubject"](value))(source); };
}
//# sourceMappingURL=publishBehavior.js.map


/***/ }),

/***/ "./node_modules/rxjs/_esm5/internal/operators/publishLast.js":
/*!*******************************************************************!*\
  !*** ./node_modules/rxjs/_esm5/internal/operators/publishLast.js ***!
  \*******************************************************************/
/*! exports provided: publishLast */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "publishLast", function() { return publishLast; });
/* harmony import */ var _AsyncSubject__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../AsyncSubject */ "./node_modules/rxjs/_esm5/internal/AsyncSubject.js");
/* harmony import */ var _multicast__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./multicast */ "./node_modules/rxjs/_esm5/internal/operators/multicast.js");
/** PURE_IMPORTS_START _AsyncSubject,_multicast PURE_IMPORTS_END */


function publishLast() {
    return function (source) { return Object(_multicast__WEBPACK_IMPORTED_MODULE_1__["multicast"])(new _AsyncSubject__WEBPACK_IMPORTED_MODULE_0__["AsyncSubject"]())(source); };
}
//# sourceMappingURL=publishLast.js.map


/***/ }),

/***/ "./node_modules/rxjs/_esm5/internal/operators/publishReplay.js":
/*!*********************************************************************!*\
  !*** ./node_modules/rxjs/_esm5/internal/operators/publishReplay.js ***!
  \*********************************************************************/
/*! exports provided: publishReplay */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "publishReplay", function() { return publishReplay; });
/* harmony import */ var _ReplaySubject__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../ReplaySubject */ "./node_modules/rxjs/_esm5/internal/ReplaySubject.js");
/* harmony import */ var _multicast__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./multicast */ "./node_modules/rxjs/_esm5/internal/operators/multicast.js");
/** PURE_IMPORTS_START _ReplaySubject,_multicast PURE_IMPORTS_END */


function publishReplay(bufferSize, windowTime, selectorOrScheduler, scheduler) {
    if (selectorOrScheduler && typeof selectorOrScheduler !== 'function') {
        scheduler = selectorOrScheduler;
    }
    var selector = typeof selectorOrScheduler === 'function' ? selectorOrScheduler : undefined;
    var subject = new _ReplaySubject__WEBPACK_IMPORTED_MODULE_0__["ReplaySubject"](bufferSize, windowTime, scheduler);
    return function (source) { return Object(_multicast__WEBPACK_IMPORTED_MODULE_1__["multicast"])(function () { return subject; }, selector)(source); };
}
//# sourceMappingURL=publishReplay.js.map


/***/ }),

/***/ "./node_modules/rxjs/_esm5/internal/operators/race.js":
/*!************************************************************!*\
  !*** ./node_modules/rxjs/_esm5/internal/operators/race.js ***!
  \************************************************************/
/*! exports provided: race */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "race", function() { return race; });
/* harmony import */ var _util_isArray__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../util/isArray */ "./node_modules/rxjs/_esm5/internal/util/isArray.js");
/* harmony import */ var _observable_race__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../observable/race */ "./node_modules/rxjs/_esm5/internal/observable/race.js");
/** PURE_IMPORTS_START _util_isArray,_observable_race PURE_IMPORTS_END */


function race() {
    var observables = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        observables[_i] = arguments[_i];
    }
    return function raceOperatorFunction(source) {
        if (observables.length === 1 && Object(_util_isArray__WEBPACK_IMPORTED_MODULE_0__["isArray"])(observables[0])) {
            observables = observables[0];
        }
        return source.lift.call(_observable_race__WEBPACK_IMPORTED_MODULE_1__["race"].apply(void 0, [source].concat(observables)));
    };
}
//# sourceMappingURL=race.js.map


/***/ }),

/***/ "./node_modules/rxjs/_esm5/internal/operators/reduce.js":
/*!**************************************************************!*\
  !*** ./node_modules/rxjs/_esm5/internal/operators/reduce.js ***!
  \**************************************************************/
/*! exports provided: reduce */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "reduce", function() { return reduce; });
/* harmony import */ var _scan__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./scan */ "./node_modules/rxjs/_esm5/internal/operators/scan.js");
/* harmony import */ var _takeLast__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./takeLast */ "./node_modules/rxjs/_esm5/internal/operators/takeLast.js");
/* harmony import */ var _defaultIfEmpty__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./defaultIfEmpty */ "./node_modules/rxjs/_esm5/internal/operators/defaultIfEmpty.js");
/* harmony import */ var _util_pipe__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../util/pipe */ "./node_modules/rxjs/_esm5/internal/util/pipe.js");
/** PURE_IMPORTS_START _scan,_takeLast,_defaultIfEmpty,_util_pipe PURE_IMPORTS_END */




function reduce(accumulator, seed) {
    if (arguments.length >= 2) {
        return function reduceOperatorFunctionWithSeed(source) {
            return Object(_util_pipe__WEBPACK_IMPORTED_MODULE_3__["pipe"])(Object(_scan__WEBPACK_IMPORTED_MODULE_0__["scan"])(accumulator, seed), Object(_takeLast__WEBPACK_IMPORTED_MODULE_1__["takeLast"])(1), Object(_defaultIfEmpty__WEBPACK_IMPORTED_MODULE_2__["defaultIfEmpty"])(seed))(source);
        };
    }
    return function reduceOperatorFunction(source) {
        return Object(_util_pipe__WEBPACK_IMPORTED_MODULE_3__["pipe"])(Object(_scan__WEBPACK_IMPORTED_MODULE_0__["scan"])(function (acc, value, index) { return accumulator(acc, value, index + 1); }), Object(_takeLast__WEBPACK_IMPORTED_MODULE_1__["takeLast"])(1))(source);
    };
}
//# sourceMappingURL=reduce.js.map


/***/ }),

/***/ "./node_modules/rxjs/_esm5/internal/operators/refCount.js":
/*!****************************************************************!*\
  !*** ./node_modules/rxjs/_esm5/internal/operators/refCount.js ***!
  \****************************************************************/
/*! exports provided: refCount */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "refCount", function() { return refCount; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/rxjs/node_modules/tslib/tslib.es6.js");
/* harmony import */ var _Subscriber__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../Subscriber */ "./node_modules/rxjs/_esm5/internal/Subscriber.js");
/** PURE_IMPORTS_START tslib,_Subscriber PURE_IMPORTS_END */


function refCount() {
    return function refCountOperatorFunction(source) {
        return source.lift(new RefCountOperator(source));
    };
}
var RefCountOperator = /*@__PURE__*/ (function () {
    function RefCountOperator(connectable) {
        this.connectable = connectable;
    }
    RefCountOperator.prototype.call = function (subscriber, source) {
        var connectable = this.connectable;
        connectable._refCount++;
        var refCounter = new RefCountSubscriber(subscriber, connectable);
        var subscription = source.subscribe(refCounter);
        if (!refCounter.closed) {
            refCounter.connection = connectable.connect();
        }
        return subscription;
    };
    return RefCountOperator;
}());
var RefCountSubscriber = /*@__PURE__*/ (function (_super) {
    tslib__WEBPACK_IMPORTED_MODULE_0__["__extends"](RefCountSubscriber, _super);
    function RefCountSubscriber(destination, connectable) {
        var _this = _super.call(this, destination) || this;
        _this.connectable = connectable;
        return _this;
    }
    RefCountSubscriber.prototype._unsubscribe = function () {
        var connectable = this.connectable;
        if (!connectable) {
            this.connection = null;
            return;
        }
        this.connectable = null;
        var refCount = connectable._refCount;
        if (refCount <= 0) {
            this.connection = null;
            return;
        }
        connectable._refCount = refCount - 1;
        if (refCount > 1) {
            this.connection = null;
            return;
        }
        var connection = this.connection;
        var sharedConnection = connectable._connection;
        this.connection = null;
        if (sharedConnection && (!connection || sharedConnection === connection)) {
            sharedConnection.unsubscribe();
        }
    };
    return RefCountSubscriber;
}(_Subscriber__WEBPACK_IMPORTED_MODULE_1__["Subscriber"]));
//# sourceMappingURL=refCount.js.map


/***/ }),

/***/ "./node_modules/rxjs/_esm5/internal/operators/repeat.js":
/*!**************************************************************!*\
  !*** ./node_modules/rxjs/_esm5/internal/operators/repeat.js ***!
  \**************************************************************/
/*! exports provided: repeat */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "repeat", function() { return repeat; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/rxjs/node_modules/tslib/tslib.es6.js");
/* harmony import */ var _Subscriber__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../Subscriber */ "./node_modules/rxjs/_esm5/internal/Subscriber.js");
/* harmony import */ var _observable_empty__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../observable/empty */ "./node_modules/rxjs/_esm5/internal/observable/empty.js");
/** PURE_IMPORTS_START tslib,_Subscriber,_observable_empty PURE_IMPORTS_END */



function repeat(count) {
    if (count === void 0) {
        count = -1;
    }
    return function (source) {
        if (count === 0) {
            return Object(_observable_empty__WEBPACK_IMPORTED_MODULE_2__["empty"])();
        }
        else if (count < 0) {
            return source.lift(new RepeatOperator(-1, source));
        }
        else {
            return source.lift(new RepeatOperator(count - 1, source));
        }
    };
}
var RepeatOperator = /*@__PURE__*/ (function () {
    function RepeatOperator(count, source) {
        this.count = count;
        this.source = source;
    }
    RepeatOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new RepeatSubscriber(subscriber, this.count, this.source));
    };
    return RepeatOperator;
}());
var RepeatSubscriber = /*@__PURE__*/ (function (_super) {
    tslib__WEBPACK_IMPORTED_MODULE_0__["__extends"](RepeatSubscriber, _super);
    function RepeatSubscriber(destination, count, source) {
        var _this = _super.call(this, destination) || this;
        _this.count = count;
        _this.source = source;
        return _this;
    }
    RepeatSubscriber.prototype.complete = function () {
        if (!this.isStopped) {
            var _a = this, source = _a.source, count = _a.count;
            if (count === 0) {
                return _super.prototype.complete.call(this);
            }
            else if (count > -1) {
                this.count = count - 1;
            }
            source.subscribe(this._unsubscribeAndRecycle());
        }
    };
    return RepeatSubscriber;
}(_Subscriber__WEBPACK_IMPORTED_MODULE_1__["Subscriber"]));
//# sourceMappingURL=repeat.js.map


/***/ }),

/***/ "./node_modules/rxjs/_esm5/internal/operators/repeatWhen.js":
/*!******************************************************************!*\
  !*** ./node_modules/rxjs/_esm5/internal/operators/repeatWhen.js ***!
  \******************************************************************/
/*! exports provided: repeatWhen */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "repeatWhen", function() { return repeatWhen; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/rxjs/node_modules/tslib/tslib.es6.js");
/* harmony import */ var _Subject__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../Subject */ "./node_modules/rxjs/_esm5/internal/Subject.js");
/* harmony import */ var _innerSubscribe__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../innerSubscribe */ "./node_modules/rxjs/_esm5/internal/innerSubscribe.js");
/** PURE_IMPORTS_START tslib,_Subject,_innerSubscribe PURE_IMPORTS_END */



function repeatWhen(notifier) {
    return function (source) { return source.lift(new RepeatWhenOperator(notifier)); };
}
var RepeatWhenOperator = /*@__PURE__*/ (function () {
    function RepeatWhenOperator(notifier) {
        this.notifier = notifier;
    }
    RepeatWhenOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new RepeatWhenSubscriber(subscriber, this.notifier, source));
    };
    return RepeatWhenOperator;
}());
var RepeatWhenSubscriber = /*@__PURE__*/ (function (_super) {
    tslib__WEBPACK_IMPORTED_MODULE_0__["__extends"](RepeatWhenSubscriber, _super);
    function RepeatWhenSubscriber(destination, notifier, source) {
        var _this = _super.call(this, destination) || this;
        _this.notifier = notifier;
        _this.source = source;
        _this.sourceIsBeingSubscribedTo = true;
        return _this;
    }
    RepeatWhenSubscriber.prototype.notifyNext = function () {
        this.sourceIsBeingSubscribedTo = true;
        this.source.subscribe(this);
    };
    RepeatWhenSubscriber.prototype.notifyComplete = function () {
        if (this.sourceIsBeingSubscribedTo === false) {
            return _super.prototype.complete.call(this);
        }
    };
    RepeatWhenSubscriber.prototype.complete = function () {
        this.sourceIsBeingSubscribedTo = false;
        if (!this.isStopped) {
            if (!this.retries) {
                this.subscribeToRetries();
            }
            if (!this.retriesSubscription || this.retriesSubscription.closed) {
                return _super.prototype.complete.call(this);
            }
            this._unsubscribeAndRecycle();
            this.notifications.next(undefined);
        }
    };
    RepeatWhenSubscriber.prototype._unsubscribe = function () {
        var _a = this, notifications = _a.notifications, retriesSubscription = _a.retriesSubscription;
        if (notifications) {
            notifications.unsubscribe();
            this.notifications = undefined;
        }
        if (retriesSubscription) {
            retriesSubscription.unsubscribe();
            this.retriesSubscription = undefined;
        }
        this.retries = undefined;
    };
    RepeatWhenSubscriber.prototype._unsubscribeAndRecycle = function () {
        var _unsubscribe = this._unsubscribe;
        this._unsubscribe = null;
        _super.prototype._unsubscribeAndRecycle.call(this);
        this._unsubscribe = _unsubscribe;
        return this;
    };
    RepeatWhenSubscriber.prototype.subscribeToRetries = function () {
        this.notifications = new _Subject__WEBPACK_IMPORTED_MODULE_1__["Subject"]();
        var retries;
        try {
            var notifier = this.notifier;
            retries = notifier(this.notifications);
        }
        catch (e) {
            return _super.prototype.complete.call(this);
        }
        this.retries = retries;
        this.retriesSubscription = Object(_innerSubscribe__WEBPACK_IMPORTED_MODULE_2__["innerSubscribe"])(retries, new _innerSubscribe__WEBPACK_IMPORTED_MODULE_2__["SimpleInnerSubscriber"](this));
    };
    return RepeatWhenSubscriber;
}(_innerSubscribe__WEBPACK_IMPORTED_MODULE_2__["SimpleOuterSubscriber"]));
//# sourceMappingURL=repeatWhen.js.map


/***/ }),

/***/ "./node_modules/rxjs/_esm5/internal/operators/retry.js":
/*!*************************************************************!*\
  !*** ./node_modules/rxjs/_esm5/internal/operators/retry.js ***!
  \*************************************************************/
/*! exports provided: retry */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "retry", function() { return retry; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/rxjs/node_modules/tslib/tslib.es6.js");
/* harmony import */ var _Subscriber__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../Subscriber */ "./node_modules/rxjs/_esm5/internal/Subscriber.js");
/** PURE_IMPORTS_START tslib,_Subscriber PURE_IMPORTS_END */


function retry(count) {
    if (count === void 0) {
        count = -1;
    }
    return function (source) { return source.lift(new RetryOperator(count, source)); };
}
var RetryOperator = /*@__PURE__*/ (function () {
    function RetryOperator(count, source) {
        this.count = count;
        this.source = source;
    }
    RetryOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new RetrySubscriber(subscriber, this.count, this.source));
    };
    return RetryOperator;
}());
var RetrySubscriber = /*@__PURE__*/ (function (_super) {
    tslib__WEBPACK_IMPORTED_MODULE_0__["__extends"](RetrySubscriber, _super);
    function RetrySubscriber(destination, count, source) {
        var _this = _super.call(this, destination) || this;
        _this.count = count;
        _this.source = source;
        return _this;
    }
    RetrySubscriber.prototype.error = function (err) {
        if (!this.isStopped) {
            var _a = this, source = _a.source, count = _a.count;
            if (count === 0) {
                return _super.prototype.error.call(this, err);
            }
            else if (count > -1) {
                this.count = count - 1;
            }
            source.subscribe(this._unsubscribeAndRecycle());
        }
    };
    return RetrySubscriber;
}(_Subscriber__WEBPACK_IMPORTED_MODULE_1__["Subscriber"]));
//# sourceMappingURL=retry.js.map


/***/ }),

/***/ "./node_modules/rxjs/_esm5/internal/operators/retryWhen.js":
/*!*****************************************************************!*\
  !*** ./node_modules/rxjs/_esm5/internal/operators/retryWhen.js ***!
  \*****************************************************************/
/*! exports provided: retryWhen */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "retryWhen", function() { return retryWhen; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/rxjs/node_modules/tslib/tslib.es6.js");
/* harmony import */ var _Subject__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../Subject */ "./node_modules/rxjs/_esm5/internal/Subject.js");
/* harmony import */ var _innerSubscribe__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../innerSubscribe */ "./node_modules/rxjs/_esm5/internal/innerSubscribe.js");
/** PURE_IMPORTS_START tslib,_Subject,_innerSubscribe PURE_IMPORTS_END */



function retryWhen(notifier) {
    return function (source) { return source.lift(new RetryWhenOperator(notifier, source)); };
}
var RetryWhenOperator = /*@__PURE__*/ (function () {
    function RetryWhenOperator(notifier, source) {
        this.notifier = notifier;
        this.source = source;
    }
    RetryWhenOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new RetryWhenSubscriber(subscriber, this.notifier, this.source));
    };
    return RetryWhenOperator;
}());
var RetryWhenSubscriber = /*@__PURE__*/ (function (_super) {
    tslib__WEBPACK_IMPORTED_MODULE_0__["__extends"](RetryWhenSubscriber, _super);
    function RetryWhenSubscriber(destination, notifier, source) {
        var _this = _super.call(this, destination) || this;
        _this.notifier = notifier;
        _this.source = source;
        return _this;
    }
    RetryWhenSubscriber.prototype.error = function (err) {
        if (!this.isStopped) {
            var errors = this.errors;
            var retries = this.retries;
            var retriesSubscription = this.retriesSubscription;
            if (!retries) {
                errors = new _Subject__WEBPACK_IMPORTED_MODULE_1__["Subject"]();
                try {
                    var notifier = this.notifier;
                    retries = notifier(errors);
                }
                catch (e) {
                    return _super.prototype.error.call(this, e);
                }
                retriesSubscription = Object(_innerSubscribe__WEBPACK_IMPORTED_MODULE_2__["innerSubscribe"])(retries, new _innerSubscribe__WEBPACK_IMPORTED_MODULE_2__["SimpleInnerSubscriber"](this));
            }
            else {
                this.errors = undefined;
                this.retriesSubscription = undefined;
            }
            this._unsubscribeAndRecycle();
            this.errors = errors;
            this.retries = retries;
            this.retriesSubscription = retriesSubscription;
            errors.next(err);
        }
    };
    RetryWhenSubscriber.prototype._unsubscribe = function () {
        var _a = this, errors = _a.errors, retriesSubscription = _a.retriesSubscription;
        if (errors) {
            errors.unsubscribe();
            this.errors = undefined;
        }
        if (retriesSubscription) {
            retriesSubscription.unsubscribe();
            this.retriesSubscription = undefined;
        }
        this.retries = undefined;
    };
    RetryWhenSubscriber.prototype.notifyNext = function () {
        var _unsubscribe = this._unsubscribe;
        this._unsubscribe = null;
        this._unsubscribeAndRecycle();
        this._unsubscribe = _unsubscribe;
        this.source.subscribe(this);
    };
    return RetryWhenSubscriber;
}(_innerSubscribe__WEBPACK_IMPORTED_MODULE_2__["SimpleOuterSubscriber"]));
//# sourceMappingURL=retryWhen.js.map


/***/ }),

/***/ "./node_modules/rxjs/_esm5/internal/operators/sample.js":
/*!**************************************************************!*\
  !*** ./node_modules/rxjs/_esm5/internal/operators/sample.js ***!
  \**************************************************************/
/*! exports provided: sample */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "sample", function() { return sample; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/rxjs/node_modules/tslib/tslib.es6.js");
/* harmony import */ var _innerSubscribe__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../innerSubscribe */ "./node_modules/rxjs/_esm5/internal/innerSubscribe.js");
/** PURE_IMPORTS_START tslib,_innerSubscribe PURE_IMPORTS_END */


function sample(notifier) {
    return function (source) { return source.lift(new SampleOperator(notifier)); };
}
var SampleOperator = /*@__PURE__*/ (function () {
    function SampleOperator(notifier) {
        this.notifier = notifier;
    }
    SampleOperator.prototype.call = function (subscriber, source) {
        var sampleSubscriber = new SampleSubscriber(subscriber);
        var subscription = source.subscribe(sampleSubscriber);
        subscription.add(Object(_innerSubscribe__WEBPACK_IMPORTED_MODULE_1__["innerSubscribe"])(this.notifier, new _innerSubscribe__WEBPACK_IMPORTED_MODULE_1__["SimpleInnerSubscriber"](sampleSubscriber)));
        return subscription;
    };
    return SampleOperator;
}());
var SampleSubscriber = /*@__PURE__*/ (function (_super) {
    tslib__WEBPACK_IMPORTED_MODULE_0__["__extends"](SampleSubscriber, _super);
    function SampleSubscriber() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.hasValue = false;
        return _this;
    }
    SampleSubscriber.prototype._next = function (value) {
        this.value = value;
        this.hasValue = true;
    };
    SampleSubscriber.prototype.notifyNext = function () {
        this.emitValue();
    };
    SampleSubscriber.prototype.notifyComplete = function () {
        this.emitValue();
    };
    SampleSubscriber.prototype.emitValue = function () {
        if (this.hasValue) {
            this.hasValue = false;
            this.destination.next(this.value);
        }
    };
    return SampleSubscriber;
}(_innerSubscribe__WEBPACK_IMPORTED_MODULE_1__["SimpleOuterSubscriber"]));
//# sourceMappingURL=sample.js.map


/***/ }),

/***/ "./node_modules/rxjs/_esm5/internal/operators/sampleTime.js":
/*!******************************************************************!*\
  !*** ./node_modules/rxjs/_esm5/internal/operators/sampleTime.js ***!
  \******************************************************************/
/*! exports provided: sampleTime */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "sampleTime", function() { return sampleTime; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/rxjs/node_modules/tslib/tslib.es6.js");
/* harmony import */ var _Subscriber__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../Subscriber */ "./node_modules/rxjs/_esm5/internal/Subscriber.js");
/* harmony import */ var _scheduler_async__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../scheduler/async */ "./node_modules/rxjs/_esm5/internal/scheduler/async.js");
/** PURE_IMPORTS_START tslib,_Subscriber,_scheduler_async PURE_IMPORTS_END */



function sampleTime(period, scheduler) {
    if (scheduler === void 0) {
        scheduler = _scheduler_async__WEBPACK_IMPORTED_MODULE_2__["async"];
    }
    return function (source) { return source.lift(new SampleTimeOperator(period, scheduler)); };
}
var SampleTimeOperator = /*@__PURE__*/ (function () {
    function SampleTimeOperator(period, scheduler) {
        this.period = period;
        this.scheduler = scheduler;
    }
    SampleTimeOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new SampleTimeSubscriber(subscriber, this.period, this.scheduler));
    };
    return SampleTimeOperator;
}());
var SampleTimeSubscriber = /*@__PURE__*/ (function (_super) {
    tslib__WEBPACK_IMPORTED_MODULE_0__["__extends"](SampleTimeSubscriber, _super);
    function SampleTimeSubscriber(destination, period, scheduler) {
        var _this = _super.call(this, destination) || this;
        _this.period = period;
        _this.scheduler = scheduler;
        _this.hasValue = false;
        _this.add(scheduler.schedule(dispatchNotification, period, { subscriber: _this, period: period }));
        return _this;
    }
    SampleTimeSubscriber.prototype._next = function (value) {
        this.lastValue = value;
        this.hasValue = true;
    };
    SampleTimeSubscriber.prototype.notifyNext = function () {
        if (this.hasValue) {
            this.hasValue = false;
            this.destination.next(this.lastValue);
        }
    };
    return SampleTimeSubscriber;
}(_Subscriber__WEBPACK_IMPORTED_MODULE_1__["Subscriber"]));
function dispatchNotification(state) {
    var subscriber = state.subscriber, period = state.period;
    subscriber.notifyNext();
    this.schedule(state, period);
}
//# sourceMappingURL=sampleTime.js.map


/***/ }),

/***/ "./node_modules/rxjs/_esm5/internal/operators/scan.js":
/*!************************************************************!*\
  !*** ./node_modules/rxjs/_esm5/internal/operators/scan.js ***!
  \************************************************************/
/*! exports provided: scan */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "scan", function() { return scan; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/rxjs/node_modules/tslib/tslib.es6.js");
/* harmony import */ var _Subscriber__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../Subscriber */ "./node_modules/rxjs/_esm5/internal/Subscriber.js");
/** PURE_IMPORTS_START tslib,_Subscriber PURE_IMPORTS_END */


function scan(accumulator, seed) {
    var hasSeed = false;
    if (arguments.length >= 2) {
        hasSeed = true;
    }
    return function scanOperatorFunction(source) {
        return source.lift(new ScanOperator(accumulator, seed, hasSeed));
    };
}
var ScanOperator = /*@__PURE__*/ (function () {
    function ScanOperator(accumulator, seed, hasSeed) {
        if (hasSeed === void 0) {
            hasSeed = false;
        }
        this.accumulator = accumulator;
        this.seed = seed;
        this.hasSeed = hasSeed;
    }
    ScanOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new ScanSubscriber(subscriber, this.accumulator, this.seed, this.hasSeed));
    };
    return ScanOperator;
}());
var ScanSubscriber = /*@__PURE__*/ (function (_super) {
    tslib__WEBPACK_IMPORTED_MODULE_0__["__extends"](ScanSubscriber, _super);
    function ScanSubscriber(destination, accumulator, _seed, hasSeed) {
        var _this = _super.call(this, destination) || this;
        _this.accumulator = accumulator;
        _this._seed = _seed;
        _this.hasSeed = hasSeed;
        _this.index = 0;
        return _this;
    }
    Object.defineProperty(ScanSubscriber.prototype, "seed", {
        get: function () {
            return this._seed;
        },
        set: function (value) {
            this.hasSeed = true;
            this._seed = value;
        },
        enumerable: true,
        configurable: true
    });
    ScanSubscriber.prototype._next = function (value) {
        if (!this.hasSeed) {
            this.seed = value;
            this.destination.next(value);
        }
        else {
            return this._tryNext(value);
        }
    };
    ScanSubscriber.prototype._tryNext = function (value) {
        var index = this.index++;
        var result;
        try {
            result = this.accumulator(this.seed, value, index);
        }
        catch (err) {
            this.destination.error(err);
        }
        this.seed = result;
        this.destination.next(result);
    };
    return ScanSubscriber;
}(_Subscriber__WEBPACK_IMPORTED_MODULE_1__["Subscriber"]));
//# sourceMappingURL=scan.js.map


/***/ }),

/***/ "./node_modules/rxjs/_esm5/internal/operators/sequenceEqual.js":
/*!*********************************************************************!*\
  !*** ./node_modules/rxjs/_esm5/internal/operators/sequenceEqual.js ***!
  \*********************************************************************/
/*! exports provided: sequenceEqual, SequenceEqualOperator, SequenceEqualSubscriber */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "sequenceEqual", function() { return sequenceEqual; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SequenceEqualOperator", function() { return SequenceEqualOperator; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SequenceEqualSubscriber", function() { return SequenceEqualSubscriber; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/rxjs/node_modules/tslib/tslib.es6.js");
/* harmony import */ var _Subscriber__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../Subscriber */ "./node_modules/rxjs/_esm5/internal/Subscriber.js");
/** PURE_IMPORTS_START tslib,_Subscriber PURE_IMPORTS_END */


function sequenceEqual(compareTo, comparator) {
    return function (source) { return source.lift(new SequenceEqualOperator(compareTo, comparator)); };
}
var SequenceEqualOperator = /*@__PURE__*/ (function () {
    function SequenceEqualOperator(compareTo, comparator) {
        this.compareTo = compareTo;
        this.comparator = comparator;
    }
    SequenceEqualOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new SequenceEqualSubscriber(subscriber, this.compareTo, this.comparator));
    };
    return SequenceEqualOperator;
}());

var SequenceEqualSubscriber = /*@__PURE__*/ (function (_super) {
    tslib__WEBPACK_IMPORTED_MODULE_0__["__extends"](SequenceEqualSubscriber, _super);
    function SequenceEqualSubscriber(destination, compareTo, comparator) {
        var _this = _super.call(this, destination) || this;
        _this.compareTo = compareTo;
        _this.comparator = comparator;
        _this._a = [];
        _this._b = [];
        _this._oneComplete = false;
        _this.destination.add(compareTo.subscribe(new SequenceEqualCompareToSubscriber(destination, _this)));
        return _this;
    }
    SequenceEqualSubscriber.prototype._next = function (value) {
        if (this._oneComplete && this._b.length === 0) {
            this.emit(false);
        }
        else {
            this._a.push(value);
            this.checkValues();
        }
    };
    SequenceEqualSubscriber.prototype._complete = function () {
        if (this._oneComplete) {
            this.emit(this._a.length === 0 && this._b.length === 0);
        }
        else {
            this._oneComplete = true;
        }
        this.unsubscribe();
    };
    SequenceEqualSubscriber.prototype.checkValues = function () {
        var _c = this, _a = _c._a, _b = _c._b, comparator = _c.comparator;
        while (_a.length > 0 && _b.length > 0) {
            var a = _a.shift();
            var b = _b.shift();
            var areEqual = false;
            try {
                areEqual = comparator ? comparator(a, b) : a === b;
            }
            catch (e) {
                this.destination.error(e);
            }
            if (!areEqual) {
                this.emit(false);
            }
        }
    };
    SequenceEqualSubscriber.prototype.emit = function (value) {
        var destination = this.destination;
        destination.next(value);
        destination.complete();
    };
    SequenceEqualSubscriber.prototype.nextB = function (value) {
        if (this._oneComplete && this._a.length === 0) {
            this.emit(false);
        }
        else {
            this._b.push(value);
            this.checkValues();
        }
    };
    SequenceEqualSubscriber.prototype.completeB = function () {
        if (this._oneComplete) {
            this.emit(this._a.length === 0 && this._b.length === 0);
        }
        else {
            this._oneComplete = true;
        }
    };
    return SequenceEqualSubscriber;
}(_Subscriber__WEBPACK_IMPORTED_MODULE_1__["Subscriber"]));

var SequenceEqualCompareToSubscriber = /*@__PURE__*/ (function (_super) {
    tslib__WEBPACK_IMPORTED_MODULE_0__["__extends"](SequenceEqualCompareToSubscriber, _super);
    function SequenceEqualCompareToSubscriber(destination, parent) {
        var _this = _super.call(this, destination) || this;
        _this.parent = parent;
        return _this;
    }
    SequenceEqualCompareToSubscriber.prototype._next = function (value) {
        this.parent.nextB(value);
    };
    SequenceEqualCompareToSubscriber.prototype._error = function (err) {
        this.parent.error(err);
        this.unsubscribe();
    };
    SequenceEqualCompareToSubscriber.prototype._complete = function () {
        this.parent.completeB();
        this.unsubscribe();
    };
    return SequenceEqualCompareToSubscriber;
}(_Subscriber__WEBPACK_IMPORTED_MODULE_1__["Subscriber"]));
//# sourceMappingURL=sequenceEqual.js.map


/***/ }),

/***/ "./node_modules/rxjs/_esm5/internal/operators/share.js":
/*!*************************************************************!*\
  !*** ./node_modules/rxjs/_esm5/internal/operators/share.js ***!
  \*************************************************************/
/*! exports provided: share */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "share", function() { return share; });
/* harmony import */ var _multicast__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./multicast */ "./node_modules/rxjs/_esm5/internal/operators/multicast.js");
/* harmony import */ var _refCount__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./refCount */ "./node_modules/rxjs/_esm5/internal/operators/refCount.js");
/* harmony import */ var _Subject__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../Subject */ "./node_modules/rxjs/_esm5/internal/Subject.js");
/** PURE_IMPORTS_START _multicast,_refCount,_Subject PURE_IMPORTS_END */



function shareSubjectFactory() {
    return new _Subject__WEBPACK_IMPORTED_MODULE_2__["Subject"]();
}
function share() {
    return function (source) { return Object(_refCount__WEBPACK_IMPORTED_MODULE_1__["refCount"])()(Object(_multicast__WEBPACK_IMPORTED_MODULE_0__["multicast"])(shareSubjectFactory)(source)); };
}
//# sourceMappingURL=share.js.map


/***/ }),

/***/ "./node_modules/rxjs/_esm5/internal/operators/shareReplay.js":
/*!*******************************************************************!*\
  !*** ./node_modules/rxjs/_esm5/internal/operators/shareReplay.js ***!
  \*******************************************************************/
/*! exports provided: shareReplay */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "shareReplay", function() { return shareReplay; });
/* harmony import */ var _ReplaySubject__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../ReplaySubject */ "./node_modules/rxjs/_esm5/internal/ReplaySubject.js");
/** PURE_IMPORTS_START _ReplaySubject PURE_IMPORTS_END */

function shareReplay(configOrBufferSize, windowTime, scheduler) {
    var config;
    if (configOrBufferSize && typeof configOrBufferSize === 'object') {
        config = configOrBufferSize;
    }
    else {
        config = {
            bufferSize: configOrBufferSize,
            windowTime: windowTime,
            refCount: false,
            scheduler: scheduler
        };
    }
    return function (source) { return source.lift(shareReplayOperator(config)); };
}
function shareReplayOperator(_a) {
    var _b = _a.bufferSize, bufferSize = _b === void 0 ? Number.POSITIVE_INFINITY : _b, _c = _a.windowTime, windowTime = _c === void 0 ? Number.POSITIVE_INFINITY : _c, useRefCount = _a.refCount, scheduler = _a.scheduler;
    var subject;
    var refCount = 0;
    var subscription;
    var hasError = false;
    var isComplete = false;
    return function shareReplayOperation(source) {
        refCount++;
        var innerSub;
        if (!subject || hasError) {
            hasError = false;
            subject = new _ReplaySubject__WEBPACK_IMPORTED_MODULE_0__["ReplaySubject"](bufferSize, windowTime, scheduler);
            innerSub = subject.subscribe(this);
            subscription = source.subscribe({
                next: function (value) { subject.next(value); },
                error: function (err) {
                    hasError = true;
                    subject.error(err);
                },
                complete: function () {
                    isComplete = true;
                    subscription = undefined;
                    subject.complete();
                },
            });
        }
        else {
            innerSub = subject.subscribe(this);
        }
        this.add(function () {
            refCount--;
            innerSub.unsubscribe();
            if (subscription && !isComplete && useRefCount && refCount === 0) {
                subscription.unsubscribe();
                subscription = undefined;
                subject = undefined;
            }
        });
    };
}
//# sourceMappingURL=shareReplay.js.map


/***/ }),

/***/ "./node_modules/rxjs/_esm5/internal/operators/single.js":
/*!**************************************************************!*\
  !*** ./node_modules/rxjs/_esm5/internal/operators/single.js ***!
  \**************************************************************/
/*! exports provided: single */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "single", function() { return single; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/rxjs/node_modules/tslib/tslib.es6.js");
/* harmony import */ var _Subscriber__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../Subscriber */ "./node_modules/rxjs/_esm5/internal/Subscriber.js");
/* harmony import */ var _util_EmptyError__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../util/EmptyError */ "./node_modules/rxjs/_esm5/internal/util/EmptyError.js");
/** PURE_IMPORTS_START tslib,_Subscriber,_util_EmptyError PURE_IMPORTS_END */



function single(predicate) {
    return function (source) { return source.lift(new SingleOperator(predicate, source)); };
}
var SingleOperator = /*@__PURE__*/ (function () {
    function SingleOperator(predicate, source) {
        this.predicate = predicate;
        this.source = source;
    }
    SingleOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new SingleSubscriber(subscriber, this.predicate, this.source));
    };
    return SingleOperator;
}());
var SingleSubscriber = /*@__PURE__*/ (function (_super) {
    tslib__WEBPACK_IMPORTED_MODULE_0__["__extends"](SingleSubscriber, _super);
    function SingleSubscriber(destination, predicate, source) {
        var _this = _super.call(this, destination) || this;
        _this.predicate = predicate;
        _this.source = source;
        _this.seenValue = false;
        _this.index = 0;
        return _this;
    }
    SingleSubscriber.prototype.applySingleValue = function (value) {
        if (this.seenValue) {
            this.destination.error('Sequence contains more than one element');
        }
        else {
            this.seenValue = true;
            this.singleValue = value;
        }
    };
    SingleSubscriber.prototype._next = function (value) {
        var index = this.index++;
        if (this.predicate) {
            this.tryNext(value, index);
        }
        else {
            this.applySingleValue(value);
        }
    };
    SingleSubscriber.prototype.tryNext = function (value, index) {
        try {
            if (this.predicate(value, index, this.source)) {
                this.applySingleValue(value);
            }
        }
        catch (err) {
            this.destination.error(err);
        }
    };
    SingleSubscriber.prototype._complete = function () {
        var destination = this.destination;
        if (this.index > 0) {
            destination.next(this.seenValue ? this.singleValue : undefined);
            destination.complete();
        }
        else {
            destination.error(new _util_EmptyError__WEBPACK_IMPORTED_MODULE_2__["EmptyError"]);
        }
    };
    return SingleSubscriber;
}(_Subscriber__WEBPACK_IMPORTED_MODULE_1__["Subscriber"]));
//# sourceMappingURL=single.js.map


/***/ }),

/***/ "./node_modules/rxjs/_esm5/internal/operators/skip.js":
/*!************************************************************!*\
  !*** ./node_modules/rxjs/_esm5/internal/operators/skip.js ***!
  \************************************************************/
/*! exports provided: skip */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "skip", function() { return skip; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/rxjs/node_modules/tslib/tslib.es6.js");
/* harmony import */ var _Subscriber__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../Subscriber */ "./node_modules/rxjs/_esm5/internal/Subscriber.js");
/** PURE_IMPORTS_START tslib,_Subscriber PURE_IMPORTS_END */


function skip(count) {
    return function (source) { return source.lift(new SkipOperator(count)); };
}
var SkipOperator = /*@__PURE__*/ (function () {
    function SkipOperator(total) {
        this.total = total;
    }
    SkipOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new SkipSubscriber(subscriber, this.total));
    };
    return SkipOperator;
}());
var SkipSubscriber = /*@__PURE__*/ (function (_super) {
    tslib__WEBPACK_IMPORTED_MODULE_0__["__extends"](SkipSubscriber, _super);
    function SkipSubscriber(destination, total) {
        var _this = _super.call(this, destination) || this;
        _this.total = total;
        _this.count = 0;
        return _this;
    }
    SkipSubscriber.prototype._next = function (x) {
        if (++this.count > this.total) {
            this.destination.next(x);
        }
    };
    return SkipSubscriber;
}(_Subscriber__WEBPACK_IMPORTED_MODULE_1__["Subscriber"]));
//# sourceMappingURL=skip.js.map


/***/ }),

/***/ "./node_modules/rxjs/_esm5/internal/operators/skipLast.js":
/*!****************************************************************!*\
  !*** ./node_modules/rxjs/_esm5/internal/operators/skipLast.js ***!
  \****************************************************************/
/*! exports provided: skipLast */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "skipLast", function() { return skipLast; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/rxjs/node_modules/tslib/tslib.es6.js");
/* harmony import */ var _Subscriber__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../Subscriber */ "./node_modules/rxjs/_esm5/internal/Subscriber.js");
/* harmony import */ var _util_ArgumentOutOfRangeError__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../util/ArgumentOutOfRangeError */ "./node_modules/rxjs/_esm5/internal/util/ArgumentOutOfRangeError.js");
/** PURE_IMPORTS_START tslib,_Subscriber,_util_ArgumentOutOfRangeError PURE_IMPORTS_END */



function skipLast(count) {
    return function (source) { return source.lift(new SkipLastOperator(count)); };
}
var SkipLastOperator = /*@__PURE__*/ (function () {
    function SkipLastOperator(_skipCount) {
        this._skipCount = _skipCount;
        if (this._skipCount < 0) {
            throw new _util_ArgumentOutOfRangeError__WEBPACK_IMPORTED_MODULE_2__["ArgumentOutOfRangeError"];
        }
    }
    SkipLastOperator.prototype.call = function (subscriber, source) {
        if (this._skipCount === 0) {
            return source.subscribe(new _Subscriber__WEBPACK_IMPORTED_MODULE_1__["Subscriber"](subscriber));
        }
        else {
            return source.subscribe(new SkipLastSubscriber(subscriber, this._skipCount));
        }
    };
    return SkipLastOperator;
}());
var SkipLastSubscriber = /*@__PURE__*/ (function (_super) {
    tslib__WEBPACK_IMPORTED_MODULE_0__["__extends"](SkipLastSubscriber, _super);
    function SkipLastSubscriber(destination, _skipCount) {
        var _this = _super.call(this, destination) || this;
        _this._skipCount = _skipCount;
        _this._count = 0;
        _this._ring = new Array(_skipCount);
        return _this;
    }
    SkipLastSubscriber.prototype._next = function (value) {
        var skipCount = this._skipCount;
        var count = this._count++;
        if (count < skipCount) {
            this._ring[count] = value;
        }
        else {
            var currentIndex = count % skipCount;
            var ring = this._ring;
            var oldValue = ring[currentIndex];
            ring[currentIndex] = value;
            this.destination.next(oldValue);
        }
    };
    return SkipLastSubscriber;
}(_Subscriber__WEBPACK_IMPORTED_MODULE_1__["Subscriber"]));
//# sourceMappingURL=skipLast.js.map


/***/ }),

/***/ "./node_modules/rxjs/_esm5/internal/operators/skipUntil.js":
/*!*****************************************************************!*\
  !*** ./node_modules/rxjs/_esm5/internal/operators/skipUntil.js ***!
  \*****************************************************************/
/*! exports provided: skipUntil */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "skipUntil", function() { return skipUntil; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/rxjs/node_modules/tslib/tslib.es6.js");
/* harmony import */ var _innerSubscribe__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../innerSubscribe */ "./node_modules/rxjs/_esm5/internal/innerSubscribe.js");
/** PURE_IMPORTS_START tslib,_innerSubscribe PURE_IMPORTS_END */


function skipUntil(notifier) {
    return function (source) { return source.lift(new SkipUntilOperator(notifier)); };
}
var SkipUntilOperator = /*@__PURE__*/ (function () {
    function SkipUntilOperator(notifier) {
        this.notifier = notifier;
    }
    SkipUntilOperator.prototype.call = function (destination, source) {
        return source.subscribe(new SkipUntilSubscriber(destination, this.notifier));
    };
    return SkipUntilOperator;
}());
var SkipUntilSubscriber = /*@__PURE__*/ (function (_super) {
    tslib__WEBPACK_IMPORTED_MODULE_0__["__extends"](SkipUntilSubscriber, _super);
    function SkipUntilSubscriber(destination, notifier) {
        var _this = _super.call(this, destination) || this;
        _this.hasValue = false;
        var innerSubscriber = new _innerSubscribe__WEBPACK_IMPORTED_MODULE_1__["SimpleInnerSubscriber"](_this);
        _this.add(innerSubscriber);
        _this.innerSubscription = innerSubscriber;
        var innerSubscription = Object(_innerSubscribe__WEBPACK_IMPORTED_MODULE_1__["innerSubscribe"])(notifier, innerSubscriber);
        if (innerSubscription !== innerSubscriber) {
            _this.add(innerSubscription);
            _this.innerSubscription = innerSubscription;
        }
        return _this;
    }
    SkipUntilSubscriber.prototype._next = function (value) {
        if (this.hasValue) {
            _super.prototype._next.call(this, value);
        }
    };
    SkipUntilSubscriber.prototype.notifyNext = function () {
        this.hasValue = true;
        if (this.innerSubscription) {
            this.innerSubscription.unsubscribe();
        }
    };
    SkipUntilSubscriber.prototype.notifyComplete = function () {
    };
    return SkipUntilSubscriber;
}(_innerSubscribe__WEBPACK_IMPORTED_MODULE_1__["SimpleOuterSubscriber"]));
//# sourceMappingURL=skipUntil.js.map


/***/ }),

/***/ "./node_modules/rxjs/_esm5/internal/operators/skipWhile.js":
/*!*****************************************************************!*\
  !*** ./node_modules/rxjs/_esm5/internal/operators/skipWhile.js ***!
  \*****************************************************************/
/*! exports provided: skipWhile */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "skipWhile", function() { return skipWhile; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/rxjs/node_modules/tslib/tslib.es6.js");
/* harmony import */ var _Subscriber__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../Subscriber */ "./node_modules/rxjs/_esm5/internal/Subscriber.js");
/** PURE_IMPORTS_START tslib,_Subscriber PURE_IMPORTS_END */


function skipWhile(predicate) {
    return function (source) { return source.lift(new SkipWhileOperator(predicate)); };
}
var SkipWhileOperator = /*@__PURE__*/ (function () {
    function SkipWhileOperator(predicate) {
        this.predicate = predicate;
    }
    SkipWhileOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new SkipWhileSubscriber(subscriber, this.predicate));
    };
    return SkipWhileOperator;
}());
var SkipWhileSubscriber = /*@__PURE__*/ (function (_super) {
    tslib__WEBPACK_IMPORTED_MODULE_0__["__extends"](SkipWhileSubscriber, _super);
    function SkipWhileSubscriber(destination, predicate) {
        var _this = _super.call(this, destination) || this;
        _this.predicate = predicate;
        _this.skipping = true;
        _this.index = 0;
        return _this;
    }
    SkipWhileSubscriber.prototype._next = function (value) {
        var destination = this.destination;
        if (this.skipping) {
            this.tryCallPredicate(value);
        }
        if (!this.skipping) {
            destination.next(value);
        }
    };
    SkipWhileSubscriber.prototype.tryCallPredicate = function (value) {
        try {
            var result = this.predicate(value, this.index++);
            this.skipping = Boolean(result);
        }
        catch (err) {
            this.destination.error(err);
        }
    };
    return SkipWhileSubscriber;
}(_Subscriber__WEBPACK_IMPORTED_MODULE_1__["Subscriber"]));
//# sourceMappingURL=skipWhile.js.map


/***/ }),

/***/ "./node_modules/rxjs/_esm5/internal/operators/startWith.js":
/*!*****************************************************************!*\
  !*** ./node_modules/rxjs/_esm5/internal/operators/startWith.js ***!
  \*****************************************************************/
/*! exports provided: startWith */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "startWith", function() { return startWith; });
/* harmony import */ var _observable_concat__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../observable/concat */ "./node_modules/rxjs/_esm5/internal/observable/concat.js");
/* harmony import */ var _util_isScheduler__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../util/isScheduler */ "./node_modules/rxjs/_esm5/internal/util/isScheduler.js");
/** PURE_IMPORTS_START _observable_concat,_util_isScheduler PURE_IMPORTS_END */


function startWith() {
    var array = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        array[_i] = arguments[_i];
    }
    var scheduler = array[array.length - 1];
    if (Object(_util_isScheduler__WEBPACK_IMPORTED_MODULE_1__["isScheduler"])(scheduler)) {
        array.pop();
        return function (source) { return Object(_observable_concat__WEBPACK_IMPORTED_MODULE_0__["concat"])(array, source, scheduler); };
    }
    else {
        return function (source) { return Object(_observable_concat__WEBPACK_IMPORTED_MODULE_0__["concat"])(array, source); };
    }
}
//# sourceMappingURL=startWith.js.map


/***/ }),

/***/ "./node_modules/rxjs/_esm5/internal/operators/subscribeOn.js":
/*!*******************************************************************!*\
  !*** ./node_modules/rxjs/_esm5/internal/operators/subscribeOn.js ***!
  \*******************************************************************/
/*! exports provided: subscribeOn */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "subscribeOn", function() { return subscribeOn; });
/* harmony import */ var _observable_SubscribeOnObservable__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../observable/SubscribeOnObservable */ "./node_modules/rxjs/_esm5/internal/observable/SubscribeOnObservable.js");
/** PURE_IMPORTS_START _observable_SubscribeOnObservable PURE_IMPORTS_END */

function subscribeOn(scheduler, delay) {
    if (delay === void 0) {
        delay = 0;
    }
    return function subscribeOnOperatorFunction(source) {
        return source.lift(new SubscribeOnOperator(scheduler, delay));
    };
}
var SubscribeOnOperator = /*@__PURE__*/ (function () {
    function SubscribeOnOperator(scheduler, delay) {
        this.scheduler = scheduler;
        this.delay = delay;
    }
    SubscribeOnOperator.prototype.call = function (subscriber, source) {
        return new _observable_SubscribeOnObservable__WEBPACK_IMPORTED_MODULE_0__["SubscribeOnObservable"](source, this.delay, this.scheduler).subscribe(subscriber);
    };
    return SubscribeOnOperator;
}());
//# sourceMappingURL=subscribeOn.js.map


/***/ }),

/***/ "./node_modules/rxjs/_esm5/internal/operators/switchAll.js":
/*!*****************************************************************!*\
  !*** ./node_modules/rxjs/_esm5/internal/operators/switchAll.js ***!
  \*****************************************************************/
/*! exports provided: switchAll */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "switchAll", function() { return switchAll; });
/* harmony import */ var _switchMap__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./switchMap */ "./node_modules/rxjs/_esm5/internal/operators/switchMap.js");
/* harmony import */ var _util_identity__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../util/identity */ "./node_modules/rxjs/_esm5/internal/util/identity.js");
/** PURE_IMPORTS_START _switchMap,_util_identity PURE_IMPORTS_END */


function switchAll() {
    return Object(_switchMap__WEBPACK_IMPORTED_MODULE_0__["switchMap"])(_util_identity__WEBPACK_IMPORTED_MODULE_1__["identity"]);
}
//# sourceMappingURL=switchAll.js.map


/***/ }),

/***/ "./node_modules/rxjs/_esm5/internal/operators/switchMap.js":
/*!*****************************************************************!*\
  !*** ./node_modules/rxjs/_esm5/internal/operators/switchMap.js ***!
  \*****************************************************************/
/*! exports provided: switchMap */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "switchMap", function() { return switchMap; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/rxjs/node_modules/tslib/tslib.es6.js");
/* harmony import */ var _map__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./map */ "./node_modules/rxjs/_esm5/internal/operators/map.js");
/* harmony import */ var _observable_from__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../observable/from */ "./node_modules/rxjs/_esm5/internal/observable/from.js");
/* harmony import */ var _innerSubscribe__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../innerSubscribe */ "./node_modules/rxjs/_esm5/internal/innerSubscribe.js");
/** PURE_IMPORTS_START tslib,_map,_observable_from,_innerSubscribe PURE_IMPORTS_END */




function switchMap(project, resultSelector) {
    if (typeof resultSelector === 'function') {
        return function (source) { return source.pipe(switchMap(function (a, i) { return Object(_observable_from__WEBPACK_IMPORTED_MODULE_2__["from"])(project(a, i)).pipe(Object(_map__WEBPACK_IMPORTED_MODULE_1__["map"])(function (b, ii) { return resultSelector(a, b, i, ii); })); })); };
    }
    return function (source) { return source.lift(new SwitchMapOperator(project)); };
}
var SwitchMapOperator = /*@__PURE__*/ (function () {
    function SwitchMapOperator(project) {
        this.project = project;
    }
    SwitchMapOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new SwitchMapSubscriber(subscriber, this.project));
    };
    return SwitchMapOperator;
}());
var SwitchMapSubscriber = /*@__PURE__*/ (function (_super) {
    tslib__WEBPACK_IMPORTED_MODULE_0__["__extends"](SwitchMapSubscriber, _super);
    function SwitchMapSubscriber(destination, project) {
        var _this = _super.call(this, destination) || this;
        _this.project = project;
        _this.index = 0;
        return _this;
    }
    SwitchMapSubscriber.prototype._next = function (value) {
        var result;
        var index = this.index++;
        try {
            result = this.project(value, index);
        }
        catch (error) {
            this.destination.error(error);
            return;
        }
        this._innerSub(result);
    };
    SwitchMapSubscriber.prototype._innerSub = function (result) {
        var innerSubscription = this.innerSubscription;
        if (innerSubscription) {
            innerSubscription.unsubscribe();
        }
        var innerSubscriber = new _innerSubscribe__WEBPACK_IMPORTED_MODULE_3__["SimpleInnerSubscriber"](this);
        var destination = this.destination;
        destination.add(innerSubscriber);
        this.innerSubscription = Object(_innerSubscribe__WEBPACK_IMPORTED_MODULE_3__["innerSubscribe"])(result, innerSubscriber);
        if (this.innerSubscription !== innerSubscriber) {
            destination.add(this.innerSubscription);
        }
    };
    SwitchMapSubscriber.prototype._complete = function () {
        var innerSubscription = this.innerSubscription;
        if (!innerSubscription || innerSubscription.closed) {
            _super.prototype._complete.call(this);
        }
        this.unsubscribe();
    };
    SwitchMapSubscriber.prototype._unsubscribe = function () {
        this.innerSubscription = undefined;
    };
    SwitchMapSubscriber.prototype.notifyComplete = function () {
        this.innerSubscription = undefined;
        if (this.isStopped) {
            _super.prototype._complete.call(this);
        }
    };
    SwitchMapSubscriber.prototype.notifyNext = function (innerValue) {
        this.destination.next(innerValue);
    };
    return SwitchMapSubscriber;
}(_innerSubscribe__WEBPACK_IMPORTED_MODULE_3__["SimpleOuterSubscriber"]));
//# sourceMappingURL=switchMap.js.map


/***/ }),

/***/ "./node_modules/rxjs/_esm5/internal/operators/switchMapTo.js":
/*!*******************************************************************!*\
  !*** ./node_modules/rxjs/_esm5/internal/operators/switchMapTo.js ***!
  \*******************************************************************/
/*! exports provided: switchMapTo */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "switchMapTo", function() { return switchMapTo; });
/* harmony import */ var _switchMap__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./switchMap */ "./node_modules/rxjs/_esm5/internal/operators/switchMap.js");
/** PURE_IMPORTS_START _switchMap PURE_IMPORTS_END */

function switchMapTo(innerObservable, resultSelector) {
    return resultSelector ? Object(_switchMap__WEBPACK_IMPORTED_MODULE_0__["switchMap"])(function () { return innerObservable; }, resultSelector) : Object(_switchMap__WEBPACK_IMPORTED_MODULE_0__["switchMap"])(function () { return innerObservable; });
}
//# sourceMappingURL=switchMapTo.js.map


/***/ }),

/***/ "./node_modules/rxjs/_esm5/internal/operators/take.js":
/*!************************************************************!*\
  !*** ./node_modules/rxjs/_esm5/internal/operators/take.js ***!
  \************************************************************/
/*! exports provided: take */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "take", function() { return take; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/rxjs/node_modules/tslib/tslib.es6.js");
/* harmony import */ var _Subscriber__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../Subscriber */ "./node_modules/rxjs/_esm5/internal/Subscriber.js");
/* harmony import */ var _util_ArgumentOutOfRangeError__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../util/ArgumentOutOfRangeError */ "./node_modules/rxjs/_esm5/internal/util/ArgumentOutOfRangeError.js");
/* harmony import */ var _observable_empty__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../observable/empty */ "./node_modules/rxjs/_esm5/internal/observable/empty.js");
/** PURE_IMPORTS_START tslib,_Subscriber,_util_ArgumentOutOfRangeError,_observable_empty PURE_IMPORTS_END */




function take(count) {
    return function (source) {
        if (count === 0) {
            return Object(_observable_empty__WEBPACK_IMPORTED_MODULE_3__["empty"])();
        }
        else {
            return source.lift(new TakeOperator(count));
        }
    };
}
var TakeOperator = /*@__PURE__*/ (function () {
    function TakeOperator(total) {
        this.total = total;
        if (this.total < 0) {
            throw new _util_ArgumentOutOfRangeError__WEBPACK_IMPORTED_MODULE_2__["ArgumentOutOfRangeError"];
        }
    }
    TakeOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new TakeSubscriber(subscriber, this.total));
    };
    return TakeOperator;
}());
var TakeSubscriber = /*@__PURE__*/ (function (_super) {
    tslib__WEBPACK_IMPORTED_MODULE_0__["__extends"](TakeSubscriber, _super);
    function TakeSubscriber(destination, total) {
        var _this = _super.call(this, destination) || this;
        _this.total = total;
        _this.count = 0;
        return _this;
    }
    TakeSubscriber.prototype._next = function (value) {
        var total = this.total;
        var count = ++this.count;
        if (count <= total) {
            this.destination.next(value);
            if (count === total) {
                this.destination.complete();
                this.unsubscribe();
            }
        }
    };
    return TakeSubscriber;
}(_Subscriber__WEBPACK_IMPORTED_MODULE_1__["Subscriber"]));
//# sourceMappingURL=take.js.map


/***/ }),

/***/ "./node_modules/rxjs/_esm5/internal/operators/takeLast.js":
/*!****************************************************************!*\
  !*** ./node_modules/rxjs/_esm5/internal/operators/takeLast.js ***!
  \****************************************************************/
/*! exports provided: takeLast */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "takeLast", function() { return takeLast; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/rxjs/node_modules/tslib/tslib.es6.js");
/* harmony import */ var _Subscriber__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../Subscriber */ "./node_modules/rxjs/_esm5/internal/Subscriber.js");
/* harmony import */ var _util_ArgumentOutOfRangeError__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../util/ArgumentOutOfRangeError */ "./node_modules/rxjs/_esm5/internal/util/ArgumentOutOfRangeError.js");
/* harmony import */ var _observable_empty__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../observable/empty */ "./node_modules/rxjs/_esm5/internal/observable/empty.js");
/** PURE_IMPORTS_START tslib,_Subscriber,_util_ArgumentOutOfRangeError,_observable_empty PURE_IMPORTS_END */




function takeLast(count) {
    return function takeLastOperatorFunction(source) {
        if (count === 0) {
            return Object(_observable_empty__WEBPACK_IMPORTED_MODULE_3__["empty"])();
        }
        else {
            return source.lift(new TakeLastOperator(count));
        }
    };
}
var TakeLastOperator = /*@__PURE__*/ (function () {
    function TakeLastOperator(total) {
        this.total = total;
        if (this.total < 0) {
            throw new _util_ArgumentOutOfRangeError__WEBPACK_IMPORTED_MODULE_2__["ArgumentOutOfRangeError"];
        }
    }
    TakeLastOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new TakeLastSubscriber(subscriber, this.total));
    };
    return TakeLastOperator;
}());
var TakeLastSubscriber = /*@__PURE__*/ (function (_super) {
    tslib__WEBPACK_IMPORTED_MODULE_0__["__extends"](TakeLastSubscriber, _super);
    function TakeLastSubscriber(destination, total) {
        var _this = _super.call(this, destination) || this;
        _this.total = total;
        _this.ring = new Array();
        _this.count = 0;
        return _this;
    }
    TakeLastSubscriber.prototype._next = function (value) {
        var ring = this.ring;
        var total = this.total;
        var count = this.count++;
        if (ring.length < total) {
            ring.push(value);
        }
        else {
            var index = count % total;
            ring[index] = value;
        }
    };
    TakeLastSubscriber.prototype._complete = function () {
        var destination = this.destination;
        var count = this.count;
        if (count > 0) {
            var total = this.count >= this.total ? this.total : this.count;
            var ring = this.ring;
            for (var i = 0; i < total; i++) {
                var idx = (count++) % total;
                destination.next(ring[idx]);
            }
        }
        destination.complete();
    };
    return TakeLastSubscriber;
}(_Subscriber__WEBPACK_IMPORTED_MODULE_1__["Subscriber"]));
//# sourceMappingURL=takeLast.js.map


/***/ }),

/***/ "./node_modules/rxjs/_esm5/internal/operators/takeUntil.js":
/*!*****************************************************************!*\
  !*** ./node_modules/rxjs/_esm5/internal/operators/takeUntil.js ***!
  \*****************************************************************/
/*! exports provided: takeUntil */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "takeUntil", function() { return takeUntil; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/rxjs/node_modules/tslib/tslib.es6.js");
/* harmony import */ var _innerSubscribe__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../innerSubscribe */ "./node_modules/rxjs/_esm5/internal/innerSubscribe.js");
/** PURE_IMPORTS_START tslib,_innerSubscribe PURE_IMPORTS_END */


function takeUntil(notifier) {
    return function (source) { return source.lift(new TakeUntilOperator(notifier)); };
}
var TakeUntilOperator = /*@__PURE__*/ (function () {
    function TakeUntilOperator(notifier) {
        this.notifier = notifier;
    }
    TakeUntilOperator.prototype.call = function (subscriber, source) {
        var takeUntilSubscriber = new TakeUntilSubscriber(subscriber);
        var notifierSubscription = Object(_innerSubscribe__WEBPACK_IMPORTED_MODULE_1__["innerSubscribe"])(this.notifier, new _innerSubscribe__WEBPACK_IMPORTED_MODULE_1__["SimpleInnerSubscriber"](takeUntilSubscriber));
        if (notifierSubscription && !takeUntilSubscriber.seenValue) {
            takeUntilSubscriber.add(notifierSubscription);
            return source.subscribe(takeUntilSubscriber);
        }
        return takeUntilSubscriber;
    };
    return TakeUntilOperator;
}());
var TakeUntilSubscriber = /*@__PURE__*/ (function (_super) {
    tslib__WEBPACK_IMPORTED_MODULE_0__["__extends"](TakeUntilSubscriber, _super);
    function TakeUntilSubscriber(destination) {
        var _this = _super.call(this, destination) || this;
        _this.seenValue = false;
        return _this;
    }
    TakeUntilSubscriber.prototype.notifyNext = function () {
        this.seenValue = true;
        this.complete();
    };
    TakeUntilSubscriber.prototype.notifyComplete = function () {
    };
    return TakeUntilSubscriber;
}(_innerSubscribe__WEBPACK_IMPORTED_MODULE_1__["SimpleOuterSubscriber"]));
//# sourceMappingURL=takeUntil.js.map


/***/ }),

/***/ "./node_modules/rxjs/_esm5/internal/operators/takeWhile.js":
/*!*****************************************************************!*\
  !*** ./node_modules/rxjs/_esm5/internal/operators/takeWhile.js ***!
  \*****************************************************************/
/*! exports provided: takeWhile */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "takeWhile", function() { return takeWhile; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/rxjs/node_modules/tslib/tslib.es6.js");
/* harmony import */ var _Subscriber__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../Subscriber */ "./node_modules/rxjs/_esm5/internal/Subscriber.js");
/** PURE_IMPORTS_START tslib,_Subscriber PURE_IMPORTS_END */


function takeWhile(predicate, inclusive) {
    if (inclusive === void 0) {
        inclusive = false;
    }
    return function (source) {
        return source.lift(new TakeWhileOperator(predicate, inclusive));
    };
}
var TakeWhileOperator = /*@__PURE__*/ (function () {
    function TakeWhileOperator(predicate, inclusive) {
        this.predicate = predicate;
        this.inclusive = inclusive;
    }
    TakeWhileOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new TakeWhileSubscriber(subscriber, this.predicate, this.inclusive));
    };
    return TakeWhileOperator;
}());
var TakeWhileSubscriber = /*@__PURE__*/ (function (_super) {
    tslib__WEBPACK_IMPORTED_MODULE_0__["__extends"](TakeWhileSubscriber, _super);
    function TakeWhileSubscriber(destination, predicate, inclusive) {
        var _this = _super.call(this, destination) || this;
        _this.predicate = predicate;
        _this.inclusive = inclusive;
        _this.index = 0;
        return _this;
    }
    TakeWhileSubscriber.prototype._next = function (value) {
        var destination = this.destination;
        var result;
        try {
            result = this.predicate(value, this.index++);
        }
        catch (err) {
            destination.error(err);
            return;
        }
        this.nextOrComplete(value, result);
    };
    TakeWhileSubscriber.prototype.nextOrComplete = function (value, predicateResult) {
        var destination = this.destination;
        if (Boolean(predicateResult)) {
            destination.next(value);
        }
        else {
            if (this.inclusive) {
                destination.next(value);
            }
            destination.complete();
        }
    };
    return TakeWhileSubscriber;
}(_Subscriber__WEBPACK_IMPORTED_MODULE_1__["Subscriber"]));
//# sourceMappingURL=takeWhile.js.map


/***/ }),

/***/ "./node_modules/rxjs/_esm5/internal/operators/tap.js":
/*!***********************************************************!*\
  !*** ./node_modules/rxjs/_esm5/internal/operators/tap.js ***!
  \***********************************************************/
/*! exports provided: tap */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "tap", function() { return tap; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/rxjs/node_modules/tslib/tslib.es6.js");
/* harmony import */ var _Subscriber__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../Subscriber */ "./node_modules/rxjs/_esm5/internal/Subscriber.js");
/* harmony import */ var _util_noop__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../util/noop */ "./node_modules/rxjs/_esm5/internal/util/noop.js");
/* harmony import */ var _util_isFunction__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../util/isFunction */ "./node_modules/rxjs/_esm5/internal/util/isFunction.js");
/** PURE_IMPORTS_START tslib,_Subscriber,_util_noop,_util_isFunction PURE_IMPORTS_END */




function tap(nextOrObserver, error, complete) {
    return function tapOperatorFunction(source) {
        return source.lift(new DoOperator(nextOrObserver, error, complete));
    };
}
var DoOperator = /*@__PURE__*/ (function () {
    function DoOperator(nextOrObserver, error, complete) {
        this.nextOrObserver = nextOrObserver;
        this.error = error;
        this.complete = complete;
    }
    DoOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new TapSubscriber(subscriber, this.nextOrObserver, this.error, this.complete));
    };
    return DoOperator;
}());
var TapSubscriber = /*@__PURE__*/ (function (_super) {
    tslib__WEBPACK_IMPORTED_MODULE_0__["__extends"](TapSubscriber, _super);
    function TapSubscriber(destination, observerOrNext, error, complete) {
        var _this = _super.call(this, destination) || this;
        _this._tapNext = _util_noop__WEBPACK_IMPORTED_MODULE_2__["noop"];
        _this._tapError = _util_noop__WEBPACK_IMPORTED_MODULE_2__["noop"];
        _this._tapComplete = _util_noop__WEBPACK_IMPORTED_MODULE_2__["noop"];
        _this._tapError = error || _util_noop__WEBPACK_IMPORTED_MODULE_2__["noop"];
        _this._tapComplete = complete || _util_noop__WEBPACK_IMPORTED_MODULE_2__["noop"];
        if (Object(_util_isFunction__WEBPACK_IMPORTED_MODULE_3__["isFunction"])(observerOrNext)) {
            _this._context = _this;
            _this._tapNext = observerOrNext;
        }
        else if (observerOrNext) {
            _this._context = observerOrNext;
            _this._tapNext = observerOrNext.next || _util_noop__WEBPACK_IMPORTED_MODULE_2__["noop"];
            _this._tapError = observerOrNext.error || _util_noop__WEBPACK_IMPORTED_MODULE_2__["noop"];
            _this._tapComplete = observerOrNext.complete || _util_noop__WEBPACK_IMPORTED_MODULE_2__["noop"];
        }
        return _this;
    }
    TapSubscriber.prototype._next = function (value) {
        try {
            this._tapNext.call(this._context, value);
        }
        catch (err) {
            this.destination.error(err);
            return;
        }
        this.destination.next(value);
    };
    TapSubscriber.prototype._error = function (err) {
        try {
            this._tapError.call(this._context, err);
        }
        catch (err) {
            this.destination.error(err);
            return;
        }
        this.destination.error(err);
    };
    TapSubscriber.prototype._complete = function () {
        try {
            this._tapComplete.call(this._context);
        }
        catch (err) {
            this.destination.error(err);
            return;
        }
        return this.destination.complete();
    };
    return TapSubscriber;
}(_Subscriber__WEBPACK_IMPORTED_MODULE_1__["Subscriber"]));
//# sourceMappingURL=tap.js.map


/***/ }),

/***/ "./node_modules/rxjs/_esm5/internal/operators/throttle.js":
/*!****************************************************************!*\
  !*** ./node_modules/rxjs/_esm5/internal/operators/throttle.js ***!
  \****************************************************************/
/*! exports provided: defaultThrottleConfig, throttle */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "defaultThrottleConfig", function() { return defaultThrottleConfig; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "throttle", function() { return throttle; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/rxjs/node_modules/tslib/tslib.es6.js");
/* harmony import */ var _innerSubscribe__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../innerSubscribe */ "./node_modules/rxjs/_esm5/internal/innerSubscribe.js");
/** PURE_IMPORTS_START tslib,_innerSubscribe PURE_IMPORTS_END */


var defaultThrottleConfig = {
    leading: true,
    trailing: false
};
function throttle(durationSelector, config) {
    if (config === void 0) {
        config = defaultThrottleConfig;
    }
    return function (source) { return source.lift(new ThrottleOperator(durationSelector, !!config.leading, !!config.trailing)); };
}
var ThrottleOperator = /*@__PURE__*/ (function () {
    function ThrottleOperator(durationSelector, leading, trailing) {
        this.durationSelector = durationSelector;
        this.leading = leading;
        this.trailing = trailing;
    }
    ThrottleOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new ThrottleSubscriber(subscriber, this.durationSelector, this.leading, this.trailing));
    };
    return ThrottleOperator;
}());
var ThrottleSubscriber = /*@__PURE__*/ (function (_super) {
    tslib__WEBPACK_IMPORTED_MODULE_0__["__extends"](ThrottleSubscriber, _super);
    function ThrottleSubscriber(destination, durationSelector, _leading, _trailing) {
        var _this = _super.call(this, destination) || this;
        _this.destination = destination;
        _this.durationSelector = durationSelector;
        _this._leading = _leading;
        _this._trailing = _trailing;
        _this._hasValue = false;
        return _this;
    }
    ThrottleSubscriber.prototype._next = function (value) {
        this._hasValue = true;
        this._sendValue = value;
        if (!this._throttled) {
            if (this._leading) {
                this.send();
            }
            else {
                this.throttle(value);
            }
        }
    };
    ThrottleSubscriber.prototype.send = function () {
        var _a = this, _hasValue = _a._hasValue, _sendValue = _a._sendValue;
        if (_hasValue) {
            this.destination.next(_sendValue);
            this.throttle(_sendValue);
        }
        this._hasValue = false;
        this._sendValue = undefined;
    };
    ThrottleSubscriber.prototype.throttle = function (value) {
        var duration = this.tryDurationSelector(value);
        if (!!duration) {
            this.add(this._throttled = Object(_innerSubscribe__WEBPACK_IMPORTED_MODULE_1__["innerSubscribe"])(duration, new _innerSubscribe__WEBPACK_IMPORTED_MODULE_1__["SimpleInnerSubscriber"](this)));
        }
    };
    ThrottleSubscriber.prototype.tryDurationSelector = function (value) {
        try {
            return this.durationSelector(value);
        }
        catch (err) {
            this.destination.error(err);
            return null;
        }
    };
    ThrottleSubscriber.prototype.throttlingDone = function () {
        var _a = this, _throttled = _a._throttled, _trailing = _a._trailing;
        if (_throttled) {
            _throttled.unsubscribe();
        }
        this._throttled = undefined;
        if (_trailing) {
            this.send();
        }
    };
    ThrottleSubscriber.prototype.notifyNext = function () {
        this.throttlingDone();
    };
    ThrottleSubscriber.prototype.notifyComplete = function () {
        this.throttlingDone();
    };
    return ThrottleSubscriber;
}(_innerSubscribe__WEBPACK_IMPORTED_MODULE_1__["SimpleOuterSubscriber"]));
//# sourceMappingURL=throttle.js.map


/***/ }),

/***/ "./node_modules/rxjs/_esm5/internal/operators/throttleTime.js":
/*!********************************************************************!*\
  !*** ./node_modules/rxjs/_esm5/internal/operators/throttleTime.js ***!
  \********************************************************************/
/*! exports provided: throttleTime */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "throttleTime", function() { return throttleTime; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/rxjs/node_modules/tslib/tslib.es6.js");
/* harmony import */ var _Subscriber__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../Subscriber */ "./node_modules/rxjs/_esm5/internal/Subscriber.js");
/* harmony import */ var _scheduler_async__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../scheduler/async */ "./node_modules/rxjs/_esm5/internal/scheduler/async.js");
/* harmony import */ var _throttle__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./throttle */ "./node_modules/rxjs/_esm5/internal/operators/throttle.js");
/** PURE_IMPORTS_START tslib,_Subscriber,_scheduler_async,_throttle PURE_IMPORTS_END */




function throttleTime(duration, scheduler, config) {
    if (scheduler === void 0) {
        scheduler = _scheduler_async__WEBPACK_IMPORTED_MODULE_2__["async"];
    }
    if (config === void 0) {
        config = _throttle__WEBPACK_IMPORTED_MODULE_3__["defaultThrottleConfig"];
    }
    return function (source) { return source.lift(new ThrottleTimeOperator(duration, scheduler, config.leading, config.trailing)); };
}
var ThrottleTimeOperator = /*@__PURE__*/ (function () {
    function ThrottleTimeOperator(duration, scheduler, leading, trailing) {
        this.duration = duration;
        this.scheduler = scheduler;
        this.leading = leading;
        this.trailing = trailing;
    }
    ThrottleTimeOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new ThrottleTimeSubscriber(subscriber, this.duration, this.scheduler, this.leading, this.trailing));
    };
    return ThrottleTimeOperator;
}());
var ThrottleTimeSubscriber = /*@__PURE__*/ (function (_super) {
    tslib__WEBPACK_IMPORTED_MODULE_0__["__extends"](ThrottleTimeSubscriber, _super);
    function ThrottleTimeSubscriber(destination, duration, scheduler, leading, trailing) {
        var _this = _super.call(this, destination) || this;
        _this.duration = duration;
        _this.scheduler = scheduler;
        _this.leading = leading;
        _this.trailing = trailing;
        _this._hasTrailingValue = false;
        _this._trailingValue = null;
        return _this;
    }
    ThrottleTimeSubscriber.prototype._next = function (value) {
        if (this.throttled) {
            if (this.trailing) {
                this._trailingValue = value;
                this._hasTrailingValue = true;
            }
        }
        else {
            this.add(this.throttled = this.scheduler.schedule(dispatchNext, this.duration, { subscriber: this }));
            if (this.leading) {
                this.destination.next(value);
            }
            else if (this.trailing) {
                this._trailingValue = value;
                this._hasTrailingValue = true;
            }
        }
    };
    ThrottleTimeSubscriber.prototype._complete = function () {
        if (this._hasTrailingValue) {
            this.destination.next(this._trailingValue);
            this.destination.complete();
        }
        else {
            this.destination.complete();
        }
    };
    ThrottleTimeSubscriber.prototype.clearThrottle = function () {
        var throttled = this.throttled;
        if (throttled) {
            if (this.trailing && this._hasTrailingValue) {
                this.destination.next(this._trailingValue);
                this._trailingValue = null;
                this._hasTrailingValue = false;
            }
            throttled.unsubscribe();
            this.remove(throttled);
            this.throttled = null;
        }
    };
    return ThrottleTimeSubscriber;
}(_Subscriber__WEBPACK_IMPORTED_MODULE_1__["Subscriber"]));
function dispatchNext(arg) {
    var subscriber = arg.subscriber;
    subscriber.clearThrottle();
}
//# sourceMappingURL=throttleTime.js.map


/***/ }),

/***/ "./node_modules/rxjs/_esm5/internal/operators/throwIfEmpty.js":
/*!********************************************************************!*\
  !*** ./node_modules/rxjs/_esm5/internal/operators/throwIfEmpty.js ***!
  \********************************************************************/
/*! exports provided: throwIfEmpty */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "throwIfEmpty", function() { return throwIfEmpty; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/rxjs/node_modules/tslib/tslib.es6.js");
/* harmony import */ var _util_EmptyError__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../util/EmptyError */ "./node_modules/rxjs/_esm5/internal/util/EmptyError.js");
/* harmony import */ var _Subscriber__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../Subscriber */ "./node_modules/rxjs/_esm5/internal/Subscriber.js");
/** PURE_IMPORTS_START tslib,_util_EmptyError,_Subscriber PURE_IMPORTS_END */



function throwIfEmpty(errorFactory) {
    if (errorFactory === void 0) {
        errorFactory = defaultErrorFactory;
    }
    return function (source) {
        return source.lift(new ThrowIfEmptyOperator(errorFactory));
    };
}
var ThrowIfEmptyOperator = /*@__PURE__*/ (function () {
    function ThrowIfEmptyOperator(errorFactory) {
        this.errorFactory = errorFactory;
    }
    ThrowIfEmptyOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new ThrowIfEmptySubscriber(subscriber, this.errorFactory));
    };
    return ThrowIfEmptyOperator;
}());
var ThrowIfEmptySubscriber = /*@__PURE__*/ (function (_super) {
    tslib__WEBPACK_IMPORTED_MODULE_0__["__extends"](ThrowIfEmptySubscriber, _super);
    function ThrowIfEmptySubscriber(destination, errorFactory) {
        var _this = _super.call(this, destination) || this;
        _this.errorFactory = errorFactory;
        _this.hasValue = false;
        return _this;
    }
    ThrowIfEmptySubscriber.prototype._next = function (value) {
        this.hasValue = true;
        this.destination.next(value);
    };
    ThrowIfEmptySubscriber.prototype._complete = function () {
        if (!this.hasValue) {
            var err = void 0;
            try {
                err = this.errorFactory();
            }
            catch (e) {
                err = e;
            }
            this.destination.error(err);
        }
        else {
            return this.destination.complete();
        }
    };
    return ThrowIfEmptySubscriber;
}(_Subscriber__WEBPACK_IMPORTED_MODULE_2__["Subscriber"]));
function defaultErrorFactory() {
    return new _util_EmptyError__WEBPACK_IMPORTED_MODULE_1__["EmptyError"]();
}
//# sourceMappingURL=throwIfEmpty.js.map


/***/ }),

/***/ "./node_modules/rxjs/_esm5/internal/operators/timeInterval.js":
/*!********************************************************************!*\
  !*** ./node_modules/rxjs/_esm5/internal/operators/timeInterval.js ***!
  \********************************************************************/
/*! exports provided: timeInterval, TimeInterval */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "timeInterval", function() { return timeInterval; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "TimeInterval", function() { return TimeInterval; });
/* harmony import */ var _scheduler_async__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../scheduler/async */ "./node_modules/rxjs/_esm5/internal/scheduler/async.js");
/* harmony import */ var _scan__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./scan */ "./node_modules/rxjs/_esm5/internal/operators/scan.js");
/* harmony import */ var _observable_defer__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../observable/defer */ "./node_modules/rxjs/_esm5/internal/observable/defer.js");
/* harmony import */ var _map__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./map */ "./node_modules/rxjs/_esm5/internal/operators/map.js");
/** PURE_IMPORTS_START _scheduler_async,_scan,_observable_defer,_map PURE_IMPORTS_END */




function timeInterval(scheduler) {
    if (scheduler === void 0) {
        scheduler = _scheduler_async__WEBPACK_IMPORTED_MODULE_0__["async"];
    }
    return function (source) {
        return Object(_observable_defer__WEBPACK_IMPORTED_MODULE_2__["defer"])(function () {
            return source.pipe(Object(_scan__WEBPACK_IMPORTED_MODULE_1__["scan"])(function (_a, value) {
                var current = _a.current;
                return ({ value: value, current: scheduler.now(), last: current });
            }, { current: scheduler.now(), value: undefined, last: undefined }), Object(_map__WEBPACK_IMPORTED_MODULE_3__["map"])(function (_a) {
                var current = _a.current, last = _a.last, value = _a.value;
                return new TimeInterval(value, current - last);
            }));
        });
    };
}
var TimeInterval = /*@__PURE__*/ (function () {
    function TimeInterval(value, interval) {
        this.value = value;
        this.interval = interval;
    }
    return TimeInterval;
}());

//# sourceMappingURL=timeInterval.js.map


/***/ }),

/***/ "./node_modules/rxjs/_esm5/internal/operators/timeout.js":
/*!***************************************************************!*\
  !*** ./node_modules/rxjs/_esm5/internal/operators/timeout.js ***!
  \***************************************************************/
/*! exports provided: timeout */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "timeout", function() { return timeout; });
/* harmony import */ var _scheduler_async__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../scheduler/async */ "./node_modules/rxjs/_esm5/internal/scheduler/async.js");
/* harmony import */ var _util_TimeoutError__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../util/TimeoutError */ "./node_modules/rxjs/_esm5/internal/util/TimeoutError.js");
/* harmony import */ var _timeoutWith__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./timeoutWith */ "./node_modules/rxjs/_esm5/internal/operators/timeoutWith.js");
/* harmony import */ var _observable_throwError__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../observable/throwError */ "./node_modules/rxjs/_esm5/internal/observable/throwError.js");
/** PURE_IMPORTS_START _scheduler_async,_util_TimeoutError,_timeoutWith,_observable_throwError PURE_IMPORTS_END */




function timeout(due, scheduler) {
    if (scheduler === void 0) {
        scheduler = _scheduler_async__WEBPACK_IMPORTED_MODULE_0__["async"];
    }
    return Object(_timeoutWith__WEBPACK_IMPORTED_MODULE_2__["timeoutWith"])(due, Object(_observable_throwError__WEBPACK_IMPORTED_MODULE_3__["throwError"])(new _util_TimeoutError__WEBPACK_IMPORTED_MODULE_1__["TimeoutError"]()), scheduler);
}
//# sourceMappingURL=timeout.js.map


/***/ }),

/***/ "./node_modules/rxjs/_esm5/internal/operators/timeoutWith.js":
/*!*******************************************************************!*\
  !*** ./node_modules/rxjs/_esm5/internal/operators/timeoutWith.js ***!
  \*******************************************************************/
/*! exports provided: timeoutWith */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "timeoutWith", function() { return timeoutWith; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/rxjs/node_modules/tslib/tslib.es6.js");
/* harmony import */ var _scheduler_async__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../scheduler/async */ "./node_modules/rxjs/_esm5/internal/scheduler/async.js");
/* harmony import */ var _util_isDate__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../util/isDate */ "./node_modules/rxjs/_esm5/internal/util/isDate.js");
/* harmony import */ var _innerSubscribe__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../innerSubscribe */ "./node_modules/rxjs/_esm5/internal/innerSubscribe.js");
/** PURE_IMPORTS_START tslib,_scheduler_async,_util_isDate,_innerSubscribe PURE_IMPORTS_END */




function timeoutWith(due, withObservable, scheduler) {
    if (scheduler === void 0) {
        scheduler = _scheduler_async__WEBPACK_IMPORTED_MODULE_1__["async"];
    }
    return function (source) {
        var absoluteTimeout = Object(_util_isDate__WEBPACK_IMPORTED_MODULE_2__["isDate"])(due);
        var waitFor = absoluteTimeout ? (+due - scheduler.now()) : Math.abs(due);
        return source.lift(new TimeoutWithOperator(waitFor, absoluteTimeout, withObservable, scheduler));
    };
}
var TimeoutWithOperator = /*@__PURE__*/ (function () {
    function TimeoutWithOperator(waitFor, absoluteTimeout, withObservable, scheduler) {
        this.waitFor = waitFor;
        this.absoluteTimeout = absoluteTimeout;
        this.withObservable = withObservable;
        this.scheduler = scheduler;
    }
    TimeoutWithOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new TimeoutWithSubscriber(subscriber, this.absoluteTimeout, this.waitFor, this.withObservable, this.scheduler));
    };
    return TimeoutWithOperator;
}());
var TimeoutWithSubscriber = /*@__PURE__*/ (function (_super) {
    tslib__WEBPACK_IMPORTED_MODULE_0__["__extends"](TimeoutWithSubscriber, _super);
    function TimeoutWithSubscriber(destination, absoluteTimeout, waitFor, withObservable, scheduler) {
        var _this = _super.call(this, destination) || this;
        _this.absoluteTimeout = absoluteTimeout;
        _this.waitFor = waitFor;
        _this.withObservable = withObservable;
        _this.scheduler = scheduler;
        _this.scheduleTimeout();
        return _this;
    }
    TimeoutWithSubscriber.dispatchTimeout = function (subscriber) {
        var withObservable = subscriber.withObservable;
        subscriber._unsubscribeAndRecycle();
        subscriber.add(Object(_innerSubscribe__WEBPACK_IMPORTED_MODULE_3__["innerSubscribe"])(withObservable, new _innerSubscribe__WEBPACK_IMPORTED_MODULE_3__["SimpleInnerSubscriber"](subscriber)));
    };
    TimeoutWithSubscriber.prototype.scheduleTimeout = function () {
        var action = this.action;
        if (action) {
            this.action = action.schedule(this, this.waitFor);
        }
        else {
            this.add(this.action = this.scheduler.schedule(TimeoutWithSubscriber.dispatchTimeout, this.waitFor, this));
        }
    };
    TimeoutWithSubscriber.prototype._next = function (value) {
        if (!this.absoluteTimeout) {
            this.scheduleTimeout();
        }
        _super.prototype._next.call(this, value);
    };
    TimeoutWithSubscriber.prototype._unsubscribe = function () {
        this.action = undefined;
        this.scheduler = null;
        this.withObservable = null;
    };
    return TimeoutWithSubscriber;
}(_innerSubscribe__WEBPACK_IMPORTED_MODULE_3__["SimpleOuterSubscriber"]));
//# sourceMappingURL=timeoutWith.js.map


/***/ }),

/***/ "./node_modules/rxjs/_esm5/internal/operators/timestamp.js":
/*!*****************************************************************!*\
  !*** ./node_modules/rxjs/_esm5/internal/operators/timestamp.js ***!
  \*****************************************************************/
/*! exports provided: timestamp, Timestamp */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "timestamp", function() { return timestamp; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Timestamp", function() { return Timestamp; });
/* harmony import */ var _scheduler_async__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../scheduler/async */ "./node_modules/rxjs/_esm5/internal/scheduler/async.js");
/* harmony import */ var _map__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./map */ "./node_modules/rxjs/_esm5/internal/operators/map.js");
/** PURE_IMPORTS_START _scheduler_async,_map PURE_IMPORTS_END */


function timestamp(scheduler) {
    if (scheduler === void 0) {
        scheduler = _scheduler_async__WEBPACK_IMPORTED_MODULE_0__["async"];
    }
    return Object(_map__WEBPACK_IMPORTED_MODULE_1__["map"])(function (value) { return new Timestamp(value, scheduler.now()); });
}
var Timestamp = /*@__PURE__*/ (function () {
    function Timestamp(value, timestamp) {
        this.value = value;
        this.timestamp = timestamp;
    }
    return Timestamp;
}());

//# sourceMappingURL=timestamp.js.map


/***/ }),

/***/ "./node_modules/rxjs/_esm5/internal/operators/toArray.js":
/*!***************************************************************!*\
  !*** ./node_modules/rxjs/_esm5/internal/operators/toArray.js ***!
  \***************************************************************/
/*! exports provided: toArray */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "toArray", function() { return toArray; });
/* harmony import */ var _reduce__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./reduce */ "./node_modules/rxjs/_esm5/internal/operators/reduce.js");
/** PURE_IMPORTS_START _reduce PURE_IMPORTS_END */

function toArrayReducer(arr, item, index) {
    if (index === 0) {
        return [item];
    }
    arr.push(item);
    return arr;
}
function toArray() {
    return Object(_reduce__WEBPACK_IMPORTED_MODULE_0__["reduce"])(toArrayReducer, []);
}
//# sourceMappingURL=toArray.js.map


/***/ }),

/***/ "./node_modules/rxjs/_esm5/internal/operators/window.js":
/*!**************************************************************!*\
  !*** ./node_modules/rxjs/_esm5/internal/operators/window.js ***!
  \**************************************************************/
/*! exports provided: window */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "window", function() { return window; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/rxjs/node_modules/tslib/tslib.es6.js");
/* harmony import */ var _Subject__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../Subject */ "./node_modules/rxjs/_esm5/internal/Subject.js");
/* harmony import */ var _innerSubscribe__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../innerSubscribe */ "./node_modules/rxjs/_esm5/internal/innerSubscribe.js");
/** PURE_IMPORTS_START tslib,_Subject,_innerSubscribe PURE_IMPORTS_END */



function window(windowBoundaries) {
    return function windowOperatorFunction(source) {
        return source.lift(new WindowOperator(windowBoundaries));
    };
}
var WindowOperator = /*@__PURE__*/ (function () {
    function WindowOperator(windowBoundaries) {
        this.windowBoundaries = windowBoundaries;
    }
    WindowOperator.prototype.call = function (subscriber, source) {
        var windowSubscriber = new WindowSubscriber(subscriber);
        var sourceSubscription = source.subscribe(windowSubscriber);
        if (!sourceSubscription.closed) {
            windowSubscriber.add(Object(_innerSubscribe__WEBPACK_IMPORTED_MODULE_2__["innerSubscribe"])(this.windowBoundaries, new _innerSubscribe__WEBPACK_IMPORTED_MODULE_2__["SimpleInnerSubscriber"](windowSubscriber)));
        }
        return sourceSubscription;
    };
    return WindowOperator;
}());
var WindowSubscriber = /*@__PURE__*/ (function (_super) {
    tslib__WEBPACK_IMPORTED_MODULE_0__["__extends"](WindowSubscriber, _super);
    function WindowSubscriber(destination) {
        var _this = _super.call(this, destination) || this;
        _this.window = new _Subject__WEBPACK_IMPORTED_MODULE_1__["Subject"]();
        destination.next(_this.window);
        return _this;
    }
    WindowSubscriber.prototype.notifyNext = function () {
        this.openWindow();
    };
    WindowSubscriber.prototype.notifyError = function (error) {
        this._error(error);
    };
    WindowSubscriber.prototype.notifyComplete = function () {
        this._complete();
    };
    WindowSubscriber.prototype._next = function (value) {
        this.window.next(value);
    };
    WindowSubscriber.prototype._error = function (err) {
        this.window.error(err);
        this.destination.error(err);
    };
    WindowSubscriber.prototype._complete = function () {
        this.window.complete();
        this.destination.complete();
    };
    WindowSubscriber.prototype._unsubscribe = function () {
        this.window = null;
    };
    WindowSubscriber.prototype.openWindow = function () {
        var prevWindow = this.window;
        if (prevWindow) {
            prevWindow.complete();
        }
        var destination = this.destination;
        var newWindow = this.window = new _Subject__WEBPACK_IMPORTED_MODULE_1__["Subject"]();
        destination.next(newWindow);
    };
    return WindowSubscriber;
}(_innerSubscribe__WEBPACK_IMPORTED_MODULE_2__["SimpleOuterSubscriber"]));
//# sourceMappingURL=window.js.map


/***/ }),

/***/ "./node_modules/rxjs/_esm5/internal/operators/windowCount.js":
/*!*******************************************************************!*\
  !*** ./node_modules/rxjs/_esm5/internal/operators/windowCount.js ***!
  \*******************************************************************/
/*! exports provided: windowCount */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "windowCount", function() { return windowCount; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/rxjs/node_modules/tslib/tslib.es6.js");
/* harmony import */ var _Subscriber__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../Subscriber */ "./node_modules/rxjs/_esm5/internal/Subscriber.js");
/* harmony import */ var _Subject__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../Subject */ "./node_modules/rxjs/_esm5/internal/Subject.js");
/** PURE_IMPORTS_START tslib,_Subscriber,_Subject PURE_IMPORTS_END */



function windowCount(windowSize, startWindowEvery) {
    if (startWindowEvery === void 0) {
        startWindowEvery = 0;
    }
    return function windowCountOperatorFunction(source) {
        return source.lift(new WindowCountOperator(windowSize, startWindowEvery));
    };
}
var WindowCountOperator = /*@__PURE__*/ (function () {
    function WindowCountOperator(windowSize, startWindowEvery) {
        this.windowSize = windowSize;
        this.startWindowEvery = startWindowEvery;
    }
    WindowCountOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new WindowCountSubscriber(subscriber, this.windowSize, this.startWindowEvery));
    };
    return WindowCountOperator;
}());
var WindowCountSubscriber = /*@__PURE__*/ (function (_super) {
    tslib__WEBPACK_IMPORTED_MODULE_0__["__extends"](WindowCountSubscriber, _super);
    function WindowCountSubscriber(destination, windowSize, startWindowEvery) {
        var _this = _super.call(this, destination) || this;
        _this.destination = destination;
        _this.windowSize = windowSize;
        _this.startWindowEvery = startWindowEvery;
        _this.windows = [new _Subject__WEBPACK_IMPORTED_MODULE_2__["Subject"]()];
        _this.count = 0;
        destination.next(_this.windows[0]);
        return _this;
    }
    WindowCountSubscriber.prototype._next = function (value) {
        var startWindowEvery = (this.startWindowEvery > 0) ? this.startWindowEvery : this.windowSize;
        var destination = this.destination;
        var windowSize = this.windowSize;
        var windows = this.windows;
        var len = windows.length;
        for (var i = 0; i < len && !this.closed; i++) {
            windows[i].next(value);
        }
        var c = this.count - windowSize + 1;
        if (c >= 0 && c % startWindowEvery === 0 && !this.closed) {
            windows.shift().complete();
        }
        if (++this.count % startWindowEvery === 0 && !this.closed) {
            var window_1 = new _Subject__WEBPACK_IMPORTED_MODULE_2__["Subject"]();
            windows.push(window_1);
            destination.next(window_1);
        }
    };
    WindowCountSubscriber.prototype._error = function (err) {
        var windows = this.windows;
        if (windows) {
            while (windows.length > 0 && !this.closed) {
                windows.shift().error(err);
            }
        }
        this.destination.error(err);
    };
    WindowCountSubscriber.prototype._complete = function () {
        var windows = this.windows;
        if (windows) {
            while (windows.length > 0 && !this.closed) {
                windows.shift().complete();
            }
        }
        this.destination.complete();
    };
    WindowCountSubscriber.prototype._unsubscribe = function () {
        this.count = 0;
        this.windows = null;
    };
    return WindowCountSubscriber;
}(_Subscriber__WEBPACK_IMPORTED_MODULE_1__["Subscriber"]));
//# sourceMappingURL=windowCount.js.map


/***/ }),

/***/ "./node_modules/rxjs/_esm5/internal/operators/windowTime.js":
/*!******************************************************************!*\
  !*** ./node_modules/rxjs/_esm5/internal/operators/windowTime.js ***!
  \******************************************************************/
/*! exports provided: windowTime */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "windowTime", function() { return windowTime; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/rxjs/node_modules/tslib/tslib.es6.js");
/* harmony import */ var _Subject__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../Subject */ "./node_modules/rxjs/_esm5/internal/Subject.js");
/* harmony import */ var _scheduler_async__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../scheduler/async */ "./node_modules/rxjs/_esm5/internal/scheduler/async.js");
/* harmony import */ var _Subscriber__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../Subscriber */ "./node_modules/rxjs/_esm5/internal/Subscriber.js");
/* harmony import */ var _util_isNumeric__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../util/isNumeric */ "./node_modules/rxjs/_esm5/internal/util/isNumeric.js");
/* harmony import */ var _util_isScheduler__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../util/isScheduler */ "./node_modules/rxjs/_esm5/internal/util/isScheduler.js");
/** PURE_IMPORTS_START tslib,_Subject,_scheduler_async,_Subscriber,_util_isNumeric,_util_isScheduler PURE_IMPORTS_END */






function windowTime(windowTimeSpan) {
    var scheduler = _scheduler_async__WEBPACK_IMPORTED_MODULE_2__["async"];
    var windowCreationInterval = null;
    var maxWindowSize = Number.POSITIVE_INFINITY;
    if (Object(_util_isScheduler__WEBPACK_IMPORTED_MODULE_5__["isScheduler"])(arguments[3])) {
        scheduler = arguments[3];
    }
    if (Object(_util_isScheduler__WEBPACK_IMPORTED_MODULE_5__["isScheduler"])(arguments[2])) {
        scheduler = arguments[2];
    }
    else if (Object(_util_isNumeric__WEBPACK_IMPORTED_MODULE_4__["isNumeric"])(arguments[2])) {
        maxWindowSize = Number(arguments[2]);
    }
    if (Object(_util_isScheduler__WEBPACK_IMPORTED_MODULE_5__["isScheduler"])(arguments[1])) {
        scheduler = arguments[1];
    }
    else if (Object(_util_isNumeric__WEBPACK_IMPORTED_MODULE_4__["isNumeric"])(arguments[1])) {
        windowCreationInterval = Number(arguments[1]);
    }
    return function windowTimeOperatorFunction(source) {
        return source.lift(new WindowTimeOperator(windowTimeSpan, windowCreationInterval, maxWindowSize, scheduler));
    };
}
var WindowTimeOperator = /*@__PURE__*/ (function () {
    function WindowTimeOperator(windowTimeSpan, windowCreationInterval, maxWindowSize, scheduler) {
        this.windowTimeSpan = windowTimeSpan;
        this.windowCreationInterval = windowCreationInterval;
        this.maxWindowSize = maxWindowSize;
        this.scheduler = scheduler;
    }
    WindowTimeOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new WindowTimeSubscriber(subscriber, this.windowTimeSpan, this.windowCreationInterval, this.maxWindowSize, this.scheduler));
    };
    return WindowTimeOperator;
}());
var CountedSubject = /*@__PURE__*/ (function (_super) {
    tslib__WEBPACK_IMPORTED_MODULE_0__["__extends"](CountedSubject, _super);
    function CountedSubject() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this._numberOfNextedValues = 0;
        return _this;
    }
    CountedSubject.prototype.next = function (value) {
        this._numberOfNextedValues++;
        _super.prototype.next.call(this, value);
    };
    Object.defineProperty(CountedSubject.prototype, "numberOfNextedValues", {
        get: function () {
            return this._numberOfNextedValues;
        },
        enumerable: true,
        configurable: true
    });
    return CountedSubject;
}(_Subject__WEBPACK_IMPORTED_MODULE_1__["Subject"]));
var WindowTimeSubscriber = /*@__PURE__*/ (function (_super) {
    tslib__WEBPACK_IMPORTED_MODULE_0__["__extends"](WindowTimeSubscriber, _super);
    function WindowTimeSubscriber(destination, windowTimeSpan, windowCreationInterval, maxWindowSize, scheduler) {
        var _this = _super.call(this, destination) || this;
        _this.destination = destination;
        _this.windowTimeSpan = windowTimeSpan;
        _this.windowCreationInterval = windowCreationInterval;
        _this.maxWindowSize = maxWindowSize;
        _this.scheduler = scheduler;
        _this.windows = [];
        var window = _this.openWindow();
        if (windowCreationInterval !== null && windowCreationInterval >= 0) {
            var closeState = { subscriber: _this, window: window, context: null };
            var creationState = { windowTimeSpan: windowTimeSpan, windowCreationInterval: windowCreationInterval, subscriber: _this, scheduler: scheduler };
            _this.add(scheduler.schedule(dispatchWindowClose, windowTimeSpan, closeState));
            _this.add(scheduler.schedule(dispatchWindowCreation, windowCreationInterval, creationState));
        }
        else {
            var timeSpanOnlyState = { subscriber: _this, window: window, windowTimeSpan: windowTimeSpan };
            _this.add(scheduler.schedule(dispatchWindowTimeSpanOnly, windowTimeSpan, timeSpanOnlyState));
        }
        return _this;
    }
    WindowTimeSubscriber.prototype._next = function (value) {
        var windows = this.windows;
        var len = windows.length;
        for (var i = 0; i < len; i++) {
            var window_1 = windows[i];
            if (!window_1.closed) {
                window_1.next(value);
                if (window_1.numberOfNextedValues >= this.maxWindowSize) {
                    this.closeWindow(window_1);
                }
            }
        }
    };
    WindowTimeSubscriber.prototype._error = function (err) {
        var windows = this.windows;
        while (windows.length > 0) {
            windows.shift().error(err);
        }
        this.destination.error(err);
    };
    WindowTimeSubscriber.prototype._complete = function () {
        var windows = this.windows;
        while (windows.length > 0) {
            var window_2 = windows.shift();
            if (!window_2.closed) {
                window_2.complete();
            }
        }
        this.destination.complete();
    };
    WindowTimeSubscriber.prototype.openWindow = function () {
        var window = new CountedSubject();
        this.windows.push(window);
        var destination = this.destination;
        destination.next(window);
        return window;
    };
    WindowTimeSubscriber.prototype.closeWindow = function (window) {
        window.complete();
        var windows = this.windows;
        windows.splice(windows.indexOf(window), 1);
    };
    return WindowTimeSubscriber;
}(_Subscriber__WEBPACK_IMPORTED_MODULE_3__["Subscriber"]));
function dispatchWindowTimeSpanOnly(state) {
    var subscriber = state.subscriber, windowTimeSpan = state.windowTimeSpan, window = state.window;
    if (window) {
        subscriber.closeWindow(window);
    }
    state.window = subscriber.openWindow();
    this.schedule(state, windowTimeSpan);
}
function dispatchWindowCreation(state) {
    var windowTimeSpan = state.windowTimeSpan, subscriber = state.subscriber, scheduler = state.scheduler, windowCreationInterval = state.windowCreationInterval;
    var window = subscriber.openWindow();
    var action = this;
    var context = { action: action, subscription: null };
    var timeSpanState = { subscriber: subscriber, window: window, context: context };
    context.subscription = scheduler.schedule(dispatchWindowClose, windowTimeSpan, timeSpanState);
    action.add(context.subscription);
    action.schedule(state, windowCreationInterval);
}
function dispatchWindowClose(state) {
    var subscriber = state.subscriber, window = state.window, context = state.context;
    if (context && context.action && context.subscription) {
        context.action.remove(context.subscription);
    }
    subscriber.closeWindow(window);
}
//# sourceMappingURL=windowTime.js.map


/***/ }),

/***/ "./node_modules/rxjs/_esm5/internal/operators/windowToggle.js":
/*!********************************************************************!*\
  !*** ./node_modules/rxjs/_esm5/internal/operators/windowToggle.js ***!
  \********************************************************************/
/*! exports provided: windowToggle */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "windowToggle", function() { return windowToggle; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/rxjs/node_modules/tslib/tslib.es6.js");
/* harmony import */ var _Subject__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../Subject */ "./node_modules/rxjs/_esm5/internal/Subject.js");
/* harmony import */ var _Subscription__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../Subscription */ "./node_modules/rxjs/_esm5/internal/Subscription.js");
/* harmony import */ var _OuterSubscriber__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../OuterSubscriber */ "./node_modules/rxjs/_esm5/internal/OuterSubscriber.js");
/* harmony import */ var _util_subscribeToResult__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../util/subscribeToResult */ "./node_modules/rxjs/_esm5/internal/util/subscribeToResult.js");
/** PURE_IMPORTS_START tslib,_Subject,_Subscription,_OuterSubscriber,_util_subscribeToResult PURE_IMPORTS_END */





function windowToggle(openings, closingSelector) {
    return function (source) { return source.lift(new WindowToggleOperator(openings, closingSelector)); };
}
var WindowToggleOperator = /*@__PURE__*/ (function () {
    function WindowToggleOperator(openings, closingSelector) {
        this.openings = openings;
        this.closingSelector = closingSelector;
    }
    WindowToggleOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new WindowToggleSubscriber(subscriber, this.openings, this.closingSelector));
    };
    return WindowToggleOperator;
}());
var WindowToggleSubscriber = /*@__PURE__*/ (function (_super) {
    tslib__WEBPACK_IMPORTED_MODULE_0__["__extends"](WindowToggleSubscriber, _super);
    function WindowToggleSubscriber(destination, openings, closingSelector) {
        var _this = _super.call(this, destination) || this;
        _this.openings = openings;
        _this.closingSelector = closingSelector;
        _this.contexts = [];
        _this.add(_this.openSubscription = Object(_util_subscribeToResult__WEBPACK_IMPORTED_MODULE_4__["subscribeToResult"])(_this, openings, openings));
        return _this;
    }
    WindowToggleSubscriber.prototype._next = function (value) {
        var contexts = this.contexts;
        if (contexts) {
            var len = contexts.length;
            for (var i = 0; i < len; i++) {
                contexts[i].window.next(value);
            }
        }
    };
    WindowToggleSubscriber.prototype._error = function (err) {
        var contexts = this.contexts;
        this.contexts = null;
        if (contexts) {
            var len = contexts.length;
            var index = -1;
            while (++index < len) {
                var context_1 = contexts[index];
                context_1.window.error(err);
                context_1.subscription.unsubscribe();
            }
        }
        _super.prototype._error.call(this, err);
    };
    WindowToggleSubscriber.prototype._complete = function () {
        var contexts = this.contexts;
        this.contexts = null;
        if (contexts) {
            var len = contexts.length;
            var index = -1;
            while (++index < len) {
                var context_2 = contexts[index];
                context_2.window.complete();
                context_2.subscription.unsubscribe();
            }
        }
        _super.prototype._complete.call(this);
    };
    WindowToggleSubscriber.prototype._unsubscribe = function () {
        var contexts = this.contexts;
        this.contexts = null;
        if (contexts) {
            var len = contexts.length;
            var index = -1;
            while (++index < len) {
                var context_3 = contexts[index];
                context_3.window.unsubscribe();
                context_3.subscription.unsubscribe();
            }
        }
    };
    WindowToggleSubscriber.prototype.notifyNext = function (outerValue, innerValue, outerIndex, innerIndex, innerSub) {
        if (outerValue === this.openings) {
            var closingNotifier = void 0;
            try {
                var closingSelector = this.closingSelector;
                closingNotifier = closingSelector(innerValue);
            }
            catch (e) {
                return this.error(e);
            }
            var window_1 = new _Subject__WEBPACK_IMPORTED_MODULE_1__["Subject"]();
            var subscription = new _Subscription__WEBPACK_IMPORTED_MODULE_2__["Subscription"]();
            var context_4 = { window: window_1, subscription: subscription };
            this.contexts.push(context_4);
            var innerSubscription = Object(_util_subscribeToResult__WEBPACK_IMPORTED_MODULE_4__["subscribeToResult"])(this, closingNotifier, context_4);
            if (innerSubscription.closed) {
                this.closeWindow(this.contexts.length - 1);
            }
            else {
                innerSubscription.context = context_4;
                subscription.add(innerSubscription);
            }
            this.destination.next(window_1);
        }
        else {
            this.closeWindow(this.contexts.indexOf(outerValue));
        }
    };
    WindowToggleSubscriber.prototype.notifyError = function (err) {
        this.error(err);
    };
    WindowToggleSubscriber.prototype.notifyComplete = function (inner) {
        if (inner !== this.openSubscription) {
            this.closeWindow(this.contexts.indexOf(inner.context));
        }
    };
    WindowToggleSubscriber.prototype.closeWindow = function (index) {
        if (index === -1) {
            return;
        }
        var contexts = this.contexts;
        var context = contexts[index];
        var window = context.window, subscription = context.subscription;
        contexts.splice(index, 1);
        window.complete();
        subscription.unsubscribe();
    };
    return WindowToggleSubscriber;
}(_OuterSubscriber__WEBPACK_IMPORTED_MODULE_3__["OuterSubscriber"]));
//# sourceMappingURL=windowToggle.js.map


/***/ }),

/***/ "./node_modules/rxjs/_esm5/internal/operators/windowWhen.js":
/*!******************************************************************!*\
  !*** ./node_modules/rxjs/_esm5/internal/operators/windowWhen.js ***!
  \******************************************************************/
/*! exports provided: windowWhen */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "windowWhen", function() { return windowWhen; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/rxjs/node_modules/tslib/tslib.es6.js");
/* harmony import */ var _Subject__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../Subject */ "./node_modules/rxjs/_esm5/internal/Subject.js");
/* harmony import */ var _OuterSubscriber__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../OuterSubscriber */ "./node_modules/rxjs/_esm5/internal/OuterSubscriber.js");
/* harmony import */ var _util_subscribeToResult__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../util/subscribeToResult */ "./node_modules/rxjs/_esm5/internal/util/subscribeToResult.js");
/** PURE_IMPORTS_START tslib,_Subject,_OuterSubscriber,_util_subscribeToResult PURE_IMPORTS_END */




function windowWhen(closingSelector) {
    return function windowWhenOperatorFunction(source) {
        return source.lift(new WindowOperator(closingSelector));
    };
}
var WindowOperator = /*@__PURE__*/ (function () {
    function WindowOperator(closingSelector) {
        this.closingSelector = closingSelector;
    }
    WindowOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new WindowSubscriber(subscriber, this.closingSelector));
    };
    return WindowOperator;
}());
var WindowSubscriber = /*@__PURE__*/ (function (_super) {
    tslib__WEBPACK_IMPORTED_MODULE_0__["__extends"](WindowSubscriber, _super);
    function WindowSubscriber(destination, closingSelector) {
        var _this = _super.call(this, destination) || this;
        _this.destination = destination;
        _this.closingSelector = closingSelector;
        _this.openWindow();
        return _this;
    }
    WindowSubscriber.prototype.notifyNext = function (_outerValue, _innerValue, _outerIndex, _innerIndex, innerSub) {
        this.openWindow(innerSub);
    };
    WindowSubscriber.prototype.notifyError = function (error) {
        this._error(error);
    };
    WindowSubscriber.prototype.notifyComplete = function (innerSub) {
        this.openWindow(innerSub);
    };
    WindowSubscriber.prototype._next = function (value) {
        this.window.next(value);
    };
    WindowSubscriber.prototype._error = function (err) {
        this.window.error(err);
        this.destination.error(err);
        this.unsubscribeClosingNotification();
    };
    WindowSubscriber.prototype._complete = function () {
        this.window.complete();
        this.destination.complete();
        this.unsubscribeClosingNotification();
    };
    WindowSubscriber.prototype.unsubscribeClosingNotification = function () {
        if (this.closingNotification) {
            this.closingNotification.unsubscribe();
        }
    };
    WindowSubscriber.prototype.openWindow = function (innerSub) {
        if (innerSub === void 0) {
            innerSub = null;
        }
        if (innerSub) {
            this.remove(innerSub);
            innerSub.unsubscribe();
        }
        var prevWindow = this.window;
        if (prevWindow) {
            prevWindow.complete();
        }
        var window = this.window = new _Subject__WEBPACK_IMPORTED_MODULE_1__["Subject"]();
        this.destination.next(window);
        var closingNotifier;
        try {
            var closingSelector = this.closingSelector;
            closingNotifier = closingSelector();
        }
        catch (e) {
            this.destination.error(e);
            this.window.error(e);
            return;
        }
        this.add(this.closingNotification = Object(_util_subscribeToResult__WEBPACK_IMPORTED_MODULE_3__["subscribeToResult"])(this, closingNotifier));
    };
    return WindowSubscriber;
}(_OuterSubscriber__WEBPACK_IMPORTED_MODULE_2__["OuterSubscriber"]));
//# sourceMappingURL=windowWhen.js.map


/***/ }),

/***/ "./node_modules/rxjs/_esm5/internal/operators/withLatestFrom.js":
/*!**********************************************************************!*\
  !*** ./node_modules/rxjs/_esm5/internal/operators/withLatestFrom.js ***!
  \**********************************************************************/
/*! exports provided: withLatestFrom */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "withLatestFrom", function() { return withLatestFrom; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/rxjs/node_modules/tslib/tslib.es6.js");
/* harmony import */ var _OuterSubscriber__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../OuterSubscriber */ "./node_modules/rxjs/_esm5/internal/OuterSubscriber.js");
/* harmony import */ var _util_subscribeToResult__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../util/subscribeToResult */ "./node_modules/rxjs/_esm5/internal/util/subscribeToResult.js");
/** PURE_IMPORTS_START tslib,_OuterSubscriber,_util_subscribeToResult PURE_IMPORTS_END */



function withLatestFrom() {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    return function (source) {
        var project;
        if (typeof args[args.length - 1] === 'function') {
            project = args.pop();
        }
        var observables = args;
        return source.lift(new WithLatestFromOperator(observables, project));
    };
}
var WithLatestFromOperator = /*@__PURE__*/ (function () {
    function WithLatestFromOperator(observables, project) {
        this.observables = observables;
        this.project = project;
    }
    WithLatestFromOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new WithLatestFromSubscriber(subscriber, this.observables, this.project));
    };
    return WithLatestFromOperator;
}());
var WithLatestFromSubscriber = /*@__PURE__*/ (function (_super) {
    tslib__WEBPACK_IMPORTED_MODULE_0__["__extends"](WithLatestFromSubscriber, _super);
    function WithLatestFromSubscriber(destination, observables, project) {
        var _this = _super.call(this, destination) || this;
        _this.observables = observables;
        _this.project = project;
        _this.toRespond = [];
        var len = observables.length;
        _this.values = new Array(len);
        for (var i = 0; i < len; i++) {
            _this.toRespond.push(i);
        }
        for (var i = 0; i < len; i++) {
            var observable = observables[i];
            _this.add(Object(_util_subscribeToResult__WEBPACK_IMPORTED_MODULE_2__["subscribeToResult"])(_this, observable, undefined, i));
        }
        return _this;
    }
    WithLatestFromSubscriber.prototype.notifyNext = function (_outerValue, innerValue, outerIndex) {
        this.values[outerIndex] = innerValue;
        var toRespond = this.toRespond;
        if (toRespond.length > 0) {
            var found = toRespond.indexOf(outerIndex);
            if (found !== -1) {
                toRespond.splice(found, 1);
            }
        }
    };
    WithLatestFromSubscriber.prototype.notifyComplete = function () {
    };
    WithLatestFromSubscriber.prototype._next = function (value) {
        if (this.toRespond.length === 0) {
            var args = [value].concat(this.values);
            if (this.project) {
                this._tryProject(args);
            }
            else {
                this.destination.next(args);
            }
        }
    };
    WithLatestFromSubscriber.prototype._tryProject = function (args) {
        var result;
        try {
            result = this.project.apply(this, args);
        }
        catch (err) {
            this.destination.error(err);
            return;
        }
        this.destination.next(result);
    };
    return WithLatestFromSubscriber;
}(_OuterSubscriber__WEBPACK_IMPORTED_MODULE_1__["OuterSubscriber"]));
//# sourceMappingURL=withLatestFrom.js.map


/***/ }),

/***/ "./node_modules/rxjs/_esm5/internal/operators/zip.js":
/*!***********************************************************!*\
  !*** ./node_modules/rxjs/_esm5/internal/operators/zip.js ***!
  \***********************************************************/
/*! exports provided: zip */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "zip", function() { return zip; });
/* harmony import */ var _observable_zip__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../observable/zip */ "./node_modules/rxjs/_esm5/internal/observable/zip.js");
/** PURE_IMPORTS_START _observable_zip PURE_IMPORTS_END */

function zip() {
    var observables = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        observables[_i] = arguments[_i];
    }
    return function zipOperatorFunction(source) {
        return source.lift.call(_observable_zip__WEBPACK_IMPORTED_MODULE_0__["zip"].apply(void 0, [source].concat(observables)));
    };
}
//# sourceMappingURL=zip.js.map


/***/ }),

/***/ "./node_modules/rxjs/_esm5/internal/operators/zipAll.js":
/*!**************************************************************!*\
  !*** ./node_modules/rxjs/_esm5/internal/operators/zipAll.js ***!
  \**************************************************************/
/*! exports provided: zipAll */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "zipAll", function() { return zipAll; });
/* harmony import */ var _observable_zip__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../observable/zip */ "./node_modules/rxjs/_esm5/internal/observable/zip.js");
/** PURE_IMPORTS_START _observable_zip PURE_IMPORTS_END */

function zipAll(project) {
    return function (source) { return source.lift(new _observable_zip__WEBPACK_IMPORTED_MODULE_0__["ZipOperator"](project)); };
}
//# sourceMappingURL=zipAll.js.map


/***/ }),

/***/ "./node_modules/rxjs/_esm5/internal/scheduled/scheduleArray.js":
/*!*********************************************************************!*\
  !*** ./node_modules/rxjs/_esm5/internal/scheduled/scheduleArray.js ***!
  \*********************************************************************/
/*! exports provided: scheduleArray */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "scheduleArray", function() { return scheduleArray; });
/* harmony import */ var _Observable__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../Observable */ "./node_modules/rxjs/_esm5/internal/Observable.js");
/* harmony import */ var _Subscription__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../Subscription */ "./node_modules/rxjs/_esm5/internal/Subscription.js");
/** PURE_IMPORTS_START _Observable,_Subscription PURE_IMPORTS_END */


function scheduleArray(input, scheduler) {
    return new _Observable__WEBPACK_IMPORTED_MODULE_0__["Observable"](function (subscriber) {
        var sub = new _Subscription__WEBPACK_IMPORTED_MODULE_1__["Subscription"]();
        var i = 0;
        sub.add(scheduler.schedule(function () {
            if (i === input.length) {
                subscriber.complete();
                return;
            }
            subscriber.next(input[i++]);
            if (!subscriber.closed) {
                sub.add(this.schedule());
            }
        }));
        return sub;
    });
}
//# sourceMappingURL=scheduleArray.js.map


/***/ }),

/***/ "./node_modules/rxjs/_esm5/internal/scheduled/scheduleIterable.js":
/*!************************************************************************!*\
  !*** ./node_modules/rxjs/_esm5/internal/scheduled/scheduleIterable.js ***!
  \************************************************************************/
/*! exports provided: scheduleIterable */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "scheduleIterable", function() { return scheduleIterable; });
/* harmony import */ var _Observable__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../Observable */ "./node_modules/rxjs/_esm5/internal/Observable.js");
/* harmony import */ var _Subscription__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../Subscription */ "./node_modules/rxjs/_esm5/internal/Subscription.js");
/* harmony import */ var _symbol_iterator__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../symbol/iterator */ "./node_modules/rxjs/_esm5/internal/symbol/iterator.js");
/** PURE_IMPORTS_START _Observable,_Subscription,_symbol_iterator PURE_IMPORTS_END */



function scheduleIterable(input, scheduler) {
    if (!input) {
        throw new Error('Iterable cannot be null');
    }
    return new _Observable__WEBPACK_IMPORTED_MODULE_0__["Observable"](function (subscriber) {
        var sub = new _Subscription__WEBPACK_IMPORTED_MODULE_1__["Subscription"]();
        var iterator;
        sub.add(function () {
            if (iterator && typeof iterator.return === 'function') {
                iterator.return();
            }
        });
        sub.add(scheduler.schedule(function () {
            iterator = input[_symbol_iterator__WEBPACK_IMPORTED_MODULE_2__["iterator"]]();
            sub.add(scheduler.schedule(function () {
                if (subscriber.closed) {
                    return;
                }
                var value;
                var done;
                try {
                    var result = iterator.next();
                    value = result.value;
                    done = result.done;
                }
                catch (err) {
                    subscriber.error(err);
                    return;
                }
                if (done) {
                    subscriber.complete();
                }
                else {
                    subscriber.next(value);
                    this.schedule();
                }
            }));
        }));
        return sub;
    });
}
//# sourceMappingURL=scheduleIterable.js.map


/***/ }),

/***/ "./node_modules/rxjs/_esm5/internal/scheduled/scheduleObservable.js":
/*!**************************************************************************!*\
  !*** ./node_modules/rxjs/_esm5/internal/scheduled/scheduleObservable.js ***!
  \**************************************************************************/
/*! exports provided: scheduleObservable */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "scheduleObservable", function() { return scheduleObservable; });
/* harmony import */ var _Observable__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../Observable */ "./node_modules/rxjs/_esm5/internal/Observable.js");
/* harmony import */ var _Subscription__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../Subscription */ "./node_modules/rxjs/_esm5/internal/Subscription.js");
/* harmony import */ var _symbol_observable__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../symbol/observable */ "./node_modules/rxjs/_esm5/internal/symbol/observable.js");
/** PURE_IMPORTS_START _Observable,_Subscription,_symbol_observable PURE_IMPORTS_END */



function scheduleObservable(input, scheduler) {
    return new _Observable__WEBPACK_IMPORTED_MODULE_0__["Observable"](function (subscriber) {
        var sub = new _Subscription__WEBPACK_IMPORTED_MODULE_1__["Subscription"]();
        sub.add(scheduler.schedule(function () {
            var observable = input[_symbol_observable__WEBPACK_IMPORTED_MODULE_2__["observable"]]();
            sub.add(observable.subscribe({
                next: function (value) { sub.add(scheduler.schedule(function () { return subscriber.next(value); })); },
                error: function (err) { sub.add(scheduler.schedule(function () { return subscriber.error(err); })); },
                complete: function () { sub.add(scheduler.schedule(function () { return subscriber.complete(); })); },
            }));
        }));
        return sub;
    });
}
//# sourceMappingURL=scheduleObservable.js.map


/***/ }),

/***/ "./node_modules/rxjs/_esm5/internal/scheduled/schedulePromise.js":
/*!***********************************************************************!*\
  !*** ./node_modules/rxjs/_esm5/internal/scheduled/schedulePromise.js ***!
  \***********************************************************************/
/*! exports provided: schedulePromise */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "schedulePromise", function() { return schedulePromise; });
/* harmony import */ var _Observable__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../Observable */ "./node_modules/rxjs/_esm5/internal/Observable.js");
/* harmony import */ var _Subscription__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../Subscription */ "./node_modules/rxjs/_esm5/internal/Subscription.js");
/** PURE_IMPORTS_START _Observable,_Subscription PURE_IMPORTS_END */


function schedulePromise(input, scheduler) {
    return new _Observable__WEBPACK_IMPORTED_MODULE_0__["Observable"](function (subscriber) {
        var sub = new _Subscription__WEBPACK_IMPORTED_MODULE_1__["Subscription"]();
        sub.add(scheduler.schedule(function () {
            return input.then(function (value) {
                sub.add(scheduler.schedule(function () {
                    subscriber.next(value);
                    sub.add(scheduler.schedule(function () { return subscriber.complete(); }));
                }));
            }, function (err) {
                sub.add(scheduler.schedule(function () { return subscriber.error(err); }));
            });
        }));
        return sub;
    });
}
//# sourceMappingURL=schedulePromise.js.map


/***/ }),

/***/ "./node_modules/rxjs/_esm5/internal/scheduled/scheduled.js":
/*!*****************************************************************!*\
  !*** ./node_modules/rxjs/_esm5/internal/scheduled/scheduled.js ***!
  \*****************************************************************/
/*! exports provided: scheduled */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "scheduled", function() { return scheduled; });
/* harmony import */ var _scheduleObservable__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./scheduleObservable */ "./node_modules/rxjs/_esm5/internal/scheduled/scheduleObservable.js");
/* harmony import */ var _schedulePromise__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./schedulePromise */ "./node_modules/rxjs/_esm5/internal/scheduled/schedulePromise.js");
/* harmony import */ var _scheduleArray__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./scheduleArray */ "./node_modules/rxjs/_esm5/internal/scheduled/scheduleArray.js");
/* harmony import */ var _scheduleIterable__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./scheduleIterable */ "./node_modules/rxjs/_esm5/internal/scheduled/scheduleIterable.js");
/* harmony import */ var _util_isInteropObservable__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../util/isInteropObservable */ "./node_modules/rxjs/_esm5/internal/util/isInteropObservable.js");
/* harmony import */ var _util_isPromise__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../util/isPromise */ "./node_modules/rxjs/_esm5/internal/util/isPromise.js");
/* harmony import */ var _util_isArrayLike__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../util/isArrayLike */ "./node_modules/rxjs/_esm5/internal/util/isArrayLike.js");
/* harmony import */ var _util_isIterable__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../util/isIterable */ "./node_modules/rxjs/_esm5/internal/util/isIterable.js");
/** PURE_IMPORTS_START _scheduleObservable,_schedulePromise,_scheduleArray,_scheduleIterable,_util_isInteropObservable,_util_isPromise,_util_isArrayLike,_util_isIterable PURE_IMPORTS_END */








function scheduled(input, scheduler) {
    if (input != null) {
        if (Object(_util_isInteropObservable__WEBPACK_IMPORTED_MODULE_4__["isInteropObservable"])(input)) {
            return Object(_scheduleObservable__WEBPACK_IMPORTED_MODULE_0__["scheduleObservable"])(input, scheduler);
        }
        else if (Object(_util_isPromise__WEBPACK_IMPORTED_MODULE_5__["isPromise"])(input)) {
            return Object(_schedulePromise__WEBPACK_IMPORTED_MODULE_1__["schedulePromise"])(input, scheduler);
        }
        else if (Object(_util_isArrayLike__WEBPACK_IMPORTED_MODULE_6__["isArrayLike"])(input)) {
            return Object(_scheduleArray__WEBPACK_IMPORTED_MODULE_2__["scheduleArray"])(input, scheduler);
        }
        else if (Object(_util_isIterable__WEBPACK_IMPORTED_MODULE_7__["isIterable"])(input) || typeof input === 'string') {
            return Object(_scheduleIterable__WEBPACK_IMPORTED_MODULE_3__["scheduleIterable"])(input, scheduler);
        }
    }
    throw new TypeError((input !== null && typeof input || input) + ' is not observable');
}
//# sourceMappingURL=scheduled.js.map


/***/ }),

/***/ "./node_modules/rxjs/_esm5/internal/scheduler/Action.js":
/*!**************************************************************!*\
  !*** ./node_modules/rxjs/_esm5/internal/scheduler/Action.js ***!
  \**************************************************************/
/*! exports provided: Action */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Action", function() { return Action; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/rxjs/node_modules/tslib/tslib.es6.js");
/* harmony import */ var _Subscription__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../Subscription */ "./node_modules/rxjs/_esm5/internal/Subscription.js");
/** PURE_IMPORTS_START tslib,_Subscription PURE_IMPORTS_END */


var Action = /*@__PURE__*/ (function (_super) {
    tslib__WEBPACK_IMPORTED_MODULE_0__["__extends"](Action, _super);
    function Action(scheduler, work) {
        return _super.call(this) || this;
    }
    Action.prototype.schedule = function (state, delay) {
        if (delay === void 0) {
            delay = 0;
        }
        return this;
    };
    return Action;
}(_Subscription__WEBPACK_IMPORTED_MODULE_1__["Subscription"]));

//# sourceMappingURL=Action.js.map


/***/ }),

/***/ "./node_modules/rxjs/_esm5/internal/scheduler/AnimationFrameAction.js":
/*!****************************************************************************!*\
  !*** ./node_modules/rxjs/_esm5/internal/scheduler/AnimationFrameAction.js ***!
  \****************************************************************************/
/*! exports provided: AnimationFrameAction */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "AnimationFrameAction", function() { return AnimationFrameAction; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/rxjs/node_modules/tslib/tslib.es6.js");
/* harmony import */ var _AsyncAction__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./AsyncAction */ "./node_modules/rxjs/_esm5/internal/scheduler/AsyncAction.js");
/** PURE_IMPORTS_START tslib,_AsyncAction PURE_IMPORTS_END */


var AnimationFrameAction = /*@__PURE__*/ (function (_super) {
    tslib__WEBPACK_IMPORTED_MODULE_0__["__extends"](AnimationFrameAction, _super);
    function AnimationFrameAction(scheduler, work) {
        var _this = _super.call(this, scheduler, work) || this;
        _this.scheduler = scheduler;
        _this.work = work;
        return _this;
    }
    AnimationFrameAction.prototype.requestAsyncId = function (scheduler, id, delay) {
        if (delay === void 0) {
            delay = 0;
        }
        if (delay !== null && delay > 0) {
            return _super.prototype.requestAsyncId.call(this, scheduler, id, delay);
        }
        scheduler.actions.push(this);
        return scheduler.scheduled || (scheduler.scheduled = requestAnimationFrame(function () { return scheduler.flush(null); }));
    };
    AnimationFrameAction.prototype.recycleAsyncId = function (scheduler, id, delay) {
        if (delay === void 0) {
            delay = 0;
        }
        if ((delay !== null && delay > 0) || (delay === null && this.delay > 0)) {
            return _super.prototype.recycleAsyncId.call(this, scheduler, id, delay);
        }
        if (scheduler.actions.length === 0) {
            cancelAnimationFrame(id);
            scheduler.scheduled = undefined;
        }
        return undefined;
    };
    return AnimationFrameAction;
}(_AsyncAction__WEBPACK_IMPORTED_MODULE_1__["AsyncAction"]));

//# sourceMappingURL=AnimationFrameAction.js.map


/***/ }),

/***/ "./node_modules/rxjs/_esm5/internal/scheduler/AnimationFrameScheduler.js":
/*!*******************************************************************************!*\
  !*** ./node_modules/rxjs/_esm5/internal/scheduler/AnimationFrameScheduler.js ***!
  \*******************************************************************************/
/*! exports provided: AnimationFrameScheduler */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "AnimationFrameScheduler", function() { return AnimationFrameScheduler; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/rxjs/node_modules/tslib/tslib.es6.js");
/* harmony import */ var _AsyncScheduler__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./AsyncScheduler */ "./node_modules/rxjs/_esm5/internal/scheduler/AsyncScheduler.js");
/** PURE_IMPORTS_START tslib,_AsyncScheduler PURE_IMPORTS_END */


var AnimationFrameScheduler = /*@__PURE__*/ (function (_super) {
    tslib__WEBPACK_IMPORTED_MODULE_0__["__extends"](AnimationFrameScheduler, _super);
    function AnimationFrameScheduler() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    AnimationFrameScheduler.prototype.flush = function (action) {
        this.active = true;
        this.scheduled = undefined;
        var actions = this.actions;
        var error;
        var index = -1;
        var count = actions.length;
        action = action || actions.shift();
        do {
            if (error = action.execute(action.state, action.delay)) {
                break;
            }
        } while (++index < count && (action = actions.shift()));
        this.active = false;
        if (error) {
            while (++index < count && (action = actions.shift())) {
                action.unsubscribe();
            }
            throw error;
        }
    };
    return AnimationFrameScheduler;
}(_AsyncScheduler__WEBPACK_IMPORTED_MODULE_1__["AsyncScheduler"]));

//# sourceMappingURL=AnimationFrameScheduler.js.map


/***/ }),

/***/ "./node_modules/rxjs/_esm5/internal/scheduler/AsapAction.js":
/*!******************************************************************!*\
  !*** ./node_modules/rxjs/_esm5/internal/scheduler/AsapAction.js ***!
  \******************************************************************/
/*! exports provided: AsapAction */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "AsapAction", function() { return AsapAction; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/rxjs/node_modules/tslib/tslib.es6.js");
/* harmony import */ var _util_Immediate__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../util/Immediate */ "./node_modules/rxjs/_esm5/internal/util/Immediate.js");
/* harmony import */ var _AsyncAction__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./AsyncAction */ "./node_modules/rxjs/_esm5/internal/scheduler/AsyncAction.js");
/** PURE_IMPORTS_START tslib,_util_Immediate,_AsyncAction PURE_IMPORTS_END */



var AsapAction = /*@__PURE__*/ (function (_super) {
    tslib__WEBPACK_IMPORTED_MODULE_0__["__extends"](AsapAction, _super);
    function AsapAction(scheduler, work) {
        var _this = _super.call(this, scheduler, work) || this;
        _this.scheduler = scheduler;
        _this.work = work;
        return _this;
    }
    AsapAction.prototype.requestAsyncId = function (scheduler, id, delay) {
        if (delay === void 0) {
            delay = 0;
        }
        if (delay !== null && delay > 0) {
            return _super.prototype.requestAsyncId.call(this, scheduler, id, delay);
        }
        scheduler.actions.push(this);
        return scheduler.scheduled || (scheduler.scheduled = _util_Immediate__WEBPACK_IMPORTED_MODULE_1__["Immediate"].setImmediate(scheduler.flush.bind(scheduler, null)));
    };
    AsapAction.prototype.recycleAsyncId = function (scheduler, id, delay) {
        if (delay === void 0) {
            delay = 0;
        }
        if ((delay !== null && delay > 0) || (delay === null && this.delay > 0)) {
            return _super.prototype.recycleAsyncId.call(this, scheduler, id, delay);
        }
        if (scheduler.actions.length === 0) {
            _util_Immediate__WEBPACK_IMPORTED_MODULE_1__["Immediate"].clearImmediate(id);
            scheduler.scheduled = undefined;
        }
        return undefined;
    };
    return AsapAction;
}(_AsyncAction__WEBPACK_IMPORTED_MODULE_2__["AsyncAction"]));

//# sourceMappingURL=AsapAction.js.map


/***/ }),

/***/ "./node_modules/rxjs/_esm5/internal/scheduler/AsapScheduler.js":
/*!*********************************************************************!*\
  !*** ./node_modules/rxjs/_esm5/internal/scheduler/AsapScheduler.js ***!
  \*********************************************************************/
/*! exports provided: AsapScheduler */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "AsapScheduler", function() { return AsapScheduler; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/rxjs/node_modules/tslib/tslib.es6.js");
/* harmony import */ var _AsyncScheduler__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./AsyncScheduler */ "./node_modules/rxjs/_esm5/internal/scheduler/AsyncScheduler.js");
/** PURE_IMPORTS_START tslib,_AsyncScheduler PURE_IMPORTS_END */


var AsapScheduler = /*@__PURE__*/ (function (_super) {
    tslib__WEBPACK_IMPORTED_MODULE_0__["__extends"](AsapScheduler, _super);
    function AsapScheduler() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    AsapScheduler.prototype.flush = function (action) {
        this.active = true;
        this.scheduled = undefined;
        var actions = this.actions;
        var error;
        var index = -1;
        var count = actions.length;
        action = action || actions.shift();
        do {
            if (error = action.execute(action.state, action.delay)) {
                break;
            }
        } while (++index < count && (action = actions.shift()));
        this.active = false;
        if (error) {
            while (++index < count && (action = actions.shift())) {
                action.unsubscribe();
            }
            throw error;
        }
    };
    return AsapScheduler;
}(_AsyncScheduler__WEBPACK_IMPORTED_MODULE_1__["AsyncScheduler"]));

//# sourceMappingURL=AsapScheduler.js.map


/***/ }),

/***/ "./node_modules/rxjs/_esm5/internal/scheduler/AsyncAction.js":
/*!*******************************************************************!*\
  !*** ./node_modules/rxjs/_esm5/internal/scheduler/AsyncAction.js ***!
  \*******************************************************************/
/*! exports provided: AsyncAction */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "AsyncAction", function() { return AsyncAction; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/rxjs/node_modules/tslib/tslib.es6.js");
/* harmony import */ var _Action__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./Action */ "./node_modules/rxjs/_esm5/internal/scheduler/Action.js");
/** PURE_IMPORTS_START tslib,_Action PURE_IMPORTS_END */


var AsyncAction = /*@__PURE__*/ (function (_super) {
    tslib__WEBPACK_IMPORTED_MODULE_0__["__extends"](AsyncAction, _super);
    function AsyncAction(scheduler, work) {
        var _this = _super.call(this, scheduler, work) || this;
        _this.scheduler = scheduler;
        _this.work = work;
        _this.pending = false;
        return _this;
    }
    AsyncAction.prototype.schedule = function (state, delay) {
        if (delay === void 0) {
            delay = 0;
        }
        if (this.closed) {
            return this;
        }
        this.state = state;
        var id = this.id;
        var scheduler = this.scheduler;
        if (id != null) {
            this.id = this.recycleAsyncId(scheduler, id, delay);
        }
        this.pending = true;
        this.delay = delay;
        this.id = this.id || this.requestAsyncId(scheduler, this.id, delay);
        return this;
    };
    AsyncAction.prototype.requestAsyncId = function (scheduler, id, delay) {
        if (delay === void 0) {
            delay = 0;
        }
        return setInterval(scheduler.flush.bind(scheduler, this), delay);
    };
    AsyncAction.prototype.recycleAsyncId = function (scheduler, id, delay) {
        if (delay === void 0) {
            delay = 0;
        }
        if (delay !== null && this.delay === delay && this.pending === false) {
            return id;
        }
        clearInterval(id);
        return undefined;
    };
    AsyncAction.prototype.execute = function (state, delay) {
        if (this.closed) {
            return new Error('executing a cancelled action');
        }
        this.pending = false;
        var error = this._execute(state, delay);
        if (error) {
            return error;
        }
        else if (this.pending === false && this.id != null) {
            this.id = this.recycleAsyncId(this.scheduler, this.id, null);
        }
    };
    AsyncAction.prototype._execute = function (state, delay) {
        var errored = false;
        var errorValue = undefined;
        try {
            this.work(state);
        }
        catch (e) {
            errored = true;
            errorValue = !!e && e || new Error(e);
        }
        if (errored) {
            this.unsubscribe();
            return errorValue;
        }
    };
    AsyncAction.prototype._unsubscribe = function () {
        var id = this.id;
        var scheduler = this.scheduler;
        var actions = scheduler.actions;
        var index = actions.indexOf(this);
        this.work = null;
        this.state = null;
        this.pending = false;
        this.scheduler = null;
        if (index !== -1) {
            actions.splice(index, 1);
        }
        if (id != null) {
            this.id = this.recycleAsyncId(scheduler, id, null);
        }
        this.delay = null;
    };
    return AsyncAction;
}(_Action__WEBPACK_IMPORTED_MODULE_1__["Action"]));

//# sourceMappingURL=AsyncAction.js.map


/***/ }),

/***/ "./node_modules/rxjs/_esm5/internal/scheduler/AsyncScheduler.js":
/*!**********************************************************************!*\
  !*** ./node_modules/rxjs/_esm5/internal/scheduler/AsyncScheduler.js ***!
  \**********************************************************************/
/*! exports provided: AsyncScheduler */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "AsyncScheduler", function() { return AsyncScheduler; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/rxjs/node_modules/tslib/tslib.es6.js");
/* harmony import */ var _Scheduler__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../Scheduler */ "./node_modules/rxjs/_esm5/internal/Scheduler.js");
/** PURE_IMPORTS_START tslib,_Scheduler PURE_IMPORTS_END */


var AsyncScheduler = /*@__PURE__*/ (function (_super) {
    tslib__WEBPACK_IMPORTED_MODULE_0__["__extends"](AsyncScheduler, _super);
    function AsyncScheduler(SchedulerAction, now) {
        if (now === void 0) {
            now = _Scheduler__WEBPACK_IMPORTED_MODULE_1__["Scheduler"].now;
        }
        var _this = _super.call(this, SchedulerAction, function () {
            if (AsyncScheduler.delegate && AsyncScheduler.delegate !== _this) {
                return AsyncScheduler.delegate.now();
            }
            else {
                return now();
            }
        }) || this;
        _this.actions = [];
        _this.active = false;
        _this.scheduled = undefined;
        return _this;
    }
    AsyncScheduler.prototype.schedule = function (work, delay, state) {
        if (delay === void 0) {
            delay = 0;
        }
        if (AsyncScheduler.delegate && AsyncScheduler.delegate !== this) {
            return AsyncScheduler.delegate.schedule(work, delay, state);
        }
        else {
            return _super.prototype.schedule.call(this, work, delay, state);
        }
    };
    AsyncScheduler.prototype.flush = function (action) {
        var actions = this.actions;
        if (this.active) {
            actions.push(action);
            return;
        }
        var error;
        this.active = true;
        do {
            if (error = action.execute(action.state, action.delay)) {
                break;
            }
        } while (action = actions.shift());
        this.active = false;
        if (error) {
            while (action = actions.shift()) {
                action.unsubscribe();
            }
            throw error;
        }
    };
    return AsyncScheduler;
}(_Scheduler__WEBPACK_IMPORTED_MODULE_1__["Scheduler"]));

//# sourceMappingURL=AsyncScheduler.js.map


/***/ }),

/***/ "./node_modules/rxjs/_esm5/internal/scheduler/QueueAction.js":
/*!*******************************************************************!*\
  !*** ./node_modules/rxjs/_esm5/internal/scheduler/QueueAction.js ***!
  \*******************************************************************/
/*! exports provided: QueueAction */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "QueueAction", function() { return QueueAction; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/rxjs/node_modules/tslib/tslib.es6.js");
/* harmony import */ var _AsyncAction__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./AsyncAction */ "./node_modules/rxjs/_esm5/internal/scheduler/AsyncAction.js");
/** PURE_IMPORTS_START tslib,_AsyncAction PURE_IMPORTS_END */


var QueueAction = /*@__PURE__*/ (function (_super) {
    tslib__WEBPACK_IMPORTED_MODULE_0__["__extends"](QueueAction, _super);
    function QueueAction(scheduler, work) {
        var _this = _super.call(this, scheduler, work) || this;
        _this.scheduler = scheduler;
        _this.work = work;
        return _this;
    }
    QueueAction.prototype.schedule = function (state, delay) {
        if (delay === void 0) {
            delay = 0;
        }
        if (delay > 0) {
            return _super.prototype.schedule.call(this, state, delay);
        }
        this.delay = delay;
        this.state = state;
        this.scheduler.flush(this);
        return this;
    };
    QueueAction.prototype.execute = function (state, delay) {
        return (delay > 0 || this.closed) ?
            _super.prototype.execute.call(this, state, delay) :
            this._execute(state, delay);
    };
    QueueAction.prototype.requestAsyncId = function (scheduler, id, delay) {
        if (delay === void 0) {
            delay = 0;
        }
        if ((delay !== null && delay > 0) || (delay === null && this.delay > 0)) {
            return _super.prototype.requestAsyncId.call(this, scheduler, id, delay);
        }
        return scheduler.flush(this);
    };
    return QueueAction;
}(_AsyncAction__WEBPACK_IMPORTED_MODULE_1__["AsyncAction"]));

//# sourceMappingURL=QueueAction.js.map


/***/ }),

/***/ "./node_modules/rxjs/_esm5/internal/scheduler/QueueScheduler.js":
/*!**********************************************************************!*\
  !*** ./node_modules/rxjs/_esm5/internal/scheduler/QueueScheduler.js ***!
  \**********************************************************************/
/*! exports provided: QueueScheduler */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "QueueScheduler", function() { return QueueScheduler; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/rxjs/node_modules/tslib/tslib.es6.js");
/* harmony import */ var _AsyncScheduler__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./AsyncScheduler */ "./node_modules/rxjs/_esm5/internal/scheduler/AsyncScheduler.js");
/** PURE_IMPORTS_START tslib,_AsyncScheduler PURE_IMPORTS_END */


var QueueScheduler = /*@__PURE__*/ (function (_super) {
    tslib__WEBPACK_IMPORTED_MODULE_0__["__extends"](QueueScheduler, _super);
    function QueueScheduler() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return QueueScheduler;
}(_AsyncScheduler__WEBPACK_IMPORTED_MODULE_1__["AsyncScheduler"]));

//# sourceMappingURL=QueueScheduler.js.map


/***/ }),

/***/ "./node_modules/rxjs/_esm5/internal/scheduler/VirtualTimeScheduler.js":
/*!****************************************************************************!*\
  !*** ./node_modules/rxjs/_esm5/internal/scheduler/VirtualTimeScheduler.js ***!
  \****************************************************************************/
/*! exports provided: VirtualTimeScheduler, VirtualAction */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "VirtualTimeScheduler", function() { return VirtualTimeScheduler; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "VirtualAction", function() { return VirtualAction; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/rxjs/node_modules/tslib/tslib.es6.js");
/* harmony import */ var _AsyncAction__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./AsyncAction */ "./node_modules/rxjs/_esm5/internal/scheduler/AsyncAction.js");
/* harmony import */ var _AsyncScheduler__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./AsyncScheduler */ "./node_modules/rxjs/_esm5/internal/scheduler/AsyncScheduler.js");
/** PURE_IMPORTS_START tslib,_AsyncAction,_AsyncScheduler PURE_IMPORTS_END */



var VirtualTimeScheduler = /*@__PURE__*/ (function (_super) {
    tslib__WEBPACK_IMPORTED_MODULE_0__["__extends"](VirtualTimeScheduler, _super);
    function VirtualTimeScheduler(SchedulerAction, maxFrames) {
        if (SchedulerAction === void 0) {
            SchedulerAction = VirtualAction;
        }
        if (maxFrames === void 0) {
            maxFrames = Number.POSITIVE_INFINITY;
        }
        var _this = _super.call(this, SchedulerAction, function () { return _this.frame; }) || this;
        _this.maxFrames = maxFrames;
        _this.frame = 0;
        _this.index = -1;
        return _this;
    }
    VirtualTimeScheduler.prototype.flush = function () {
        var _a = this, actions = _a.actions, maxFrames = _a.maxFrames;
        var error, action;
        while ((action = actions[0]) && action.delay <= maxFrames) {
            actions.shift();
            this.frame = action.delay;
            if (error = action.execute(action.state, action.delay)) {
                break;
            }
        }
        if (error) {
            while (action = actions.shift()) {
                action.unsubscribe();
            }
            throw error;
        }
    };
    VirtualTimeScheduler.frameTimeFactor = 10;
    return VirtualTimeScheduler;
}(_AsyncScheduler__WEBPACK_IMPORTED_MODULE_2__["AsyncScheduler"]));

var VirtualAction = /*@__PURE__*/ (function (_super) {
    tslib__WEBPACK_IMPORTED_MODULE_0__["__extends"](VirtualAction, _super);
    function VirtualAction(scheduler, work, index) {
        if (index === void 0) {
            index = scheduler.index += 1;
        }
        var _this = _super.call(this, scheduler, work) || this;
        _this.scheduler = scheduler;
        _this.work = work;
        _this.index = index;
        _this.active = true;
        _this.index = scheduler.index = index;
        return _this;
    }
    VirtualAction.prototype.schedule = function (state, delay) {
        if (delay === void 0) {
            delay = 0;
        }
        if (!this.id) {
            return _super.prototype.schedule.call(this, state, delay);
        }
        this.active = false;
        var action = new VirtualAction(this.scheduler, this.work);
        this.add(action);
        return action.schedule(state, delay);
    };
    VirtualAction.prototype.requestAsyncId = function (scheduler, id, delay) {
        if (delay === void 0) {
            delay = 0;
        }
        this.delay = scheduler.frame + delay;
        var actions = scheduler.actions;
        actions.push(this);
        actions.sort(VirtualAction.sortActions);
        return true;
    };
    VirtualAction.prototype.recycleAsyncId = function (scheduler, id, delay) {
        if (delay === void 0) {
            delay = 0;
        }
        return undefined;
    };
    VirtualAction.prototype._execute = function (state, delay) {
        if (this.active === true) {
            return _super.prototype._execute.call(this, state, delay);
        }
    };
    VirtualAction.sortActions = function (a, b) {
        if (a.delay === b.delay) {
            if (a.index === b.index) {
                return 0;
            }
            else if (a.index > b.index) {
                return 1;
            }
            else {
                return -1;
            }
        }
        else if (a.delay > b.delay) {
            return 1;
        }
        else {
            return -1;
        }
    };
    return VirtualAction;
}(_AsyncAction__WEBPACK_IMPORTED_MODULE_1__["AsyncAction"]));

//# sourceMappingURL=VirtualTimeScheduler.js.map


/***/ }),

/***/ "./node_modules/rxjs/_esm5/internal/scheduler/animationFrame.js":
/*!**********************************************************************!*\
  !*** ./node_modules/rxjs/_esm5/internal/scheduler/animationFrame.js ***!
  \**********************************************************************/
/*! exports provided: animationFrameScheduler, animationFrame */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "animationFrameScheduler", function() { return animationFrameScheduler; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "animationFrame", function() { return animationFrame; });
/* harmony import */ var _AnimationFrameAction__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./AnimationFrameAction */ "./node_modules/rxjs/_esm5/internal/scheduler/AnimationFrameAction.js");
/* harmony import */ var _AnimationFrameScheduler__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./AnimationFrameScheduler */ "./node_modules/rxjs/_esm5/internal/scheduler/AnimationFrameScheduler.js");
/** PURE_IMPORTS_START _AnimationFrameAction,_AnimationFrameScheduler PURE_IMPORTS_END */


var animationFrameScheduler = /*@__PURE__*/ new _AnimationFrameScheduler__WEBPACK_IMPORTED_MODULE_1__["AnimationFrameScheduler"](_AnimationFrameAction__WEBPACK_IMPORTED_MODULE_0__["AnimationFrameAction"]);
var animationFrame = animationFrameScheduler;
//# sourceMappingURL=animationFrame.js.map


/***/ }),

/***/ "./node_modules/rxjs/_esm5/internal/scheduler/asap.js":
/*!************************************************************!*\
  !*** ./node_modules/rxjs/_esm5/internal/scheduler/asap.js ***!
  \************************************************************/
/*! exports provided: asapScheduler, asap */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "asapScheduler", function() { return asapScheduler; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "asap", function() { return asap; });
/* harmony import */ var _AsapAction__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./AsapAction */ "./node_modules/rxjs/_esm5/internal/scheduler/AsapAction.js");
/* harmony import */ var _AsapScheduler__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./AsapScheduler */ "./node_modules/rxjs/_esm5/internal/scheduler/AsapScheduler.js");
/** PURE_IMPORTS_START _AsapAction,_AsapScheduler PURE_IMPORTS_END */


var asapScheduler = /*@__PURE__*/ new _AsapScheduler__WEBPACK_IMPORTED_MODULE_1__["AsapScheduler"](_AsapAction__WEBPACK_IMPORTED_MODULE_0__["AsapAction"]);
var asap = asapScheduler;
//# sourceMappingURL=asap.js.map


/***/ }),

/***/ "./node_modules/rxjs/_esm5/internal/scheduler/async.js":
/*!*************************************************************!*\
  !*** ./node_modules/rxjs/_esm5/internal/scheduler/async.js ***!
  \*************************************************************/
/*! exports provided: asyncScheduler, async */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "asyncScheduler", function() { return asyncScheduler; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "async", function() { return async; });
/* harmony import */ var _AsyncAction__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./AsyncAction */ "./node_modules/rxjs/_esm5/internal/scheduler/AsyncAction.js");
/* harmony import */ var _AsyncScheduler__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./AsyncScheduler */ "./node_modules/rxjs/_esm5/internal/scheduler/AsyncScheduler.js");
/** PURE_IMPORTS_START _AsyncAction,_AsyncScheduler PURE_IMPORTS_END */


var asyncScheduler = /*@__PURE__*/ new _AsyncScheduler__WEBPACK_IMPORTED_MODULE_1__["AsyncScheduler"](_AsyncAction__WEBPACK_IMPORTED_MODULE_0__["AsyncAction"]);
var async = asyncScheduler;
//# sourceMappingURL=async.js.map


/***/ }),

/***/ "./node_modules/rxjs/_esm5/internal/scheduler/queue.js":
/*!*************************************************************!*\
  !*** ./node_modules/rxjs/_esm5/internal/scheduler/queue.js ***!
  \*************************************************************/
/*! exports provided: queueScheduler, queue */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "queueScheduler", function() { return queueScheduler; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "queue", function() { return queue; });
/* harmony import */ var _QueueAction__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./QueueAction */ "./node_modules/rxjs/_esm5/internal/scheduler/QueueAction.js");
/* harmony import */ var _QueueScheduler__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./QueueScheduler */ "./node_modules/rxjs/_esm5/internal/scheduler/QueueScheduler.js");
/** PURE_IMPORTS_START _QueueAction,_QueueScheduler PURE_IMPORTS_END */


var queueScheduler = /*@__PURE__*/ new _QueueScheduler__WEBPACK_IMPORTED_MODULE_1__["QueueScheduler"](_QueueAction__WEBPACK_IMPORTED_MODULE_0__["QueueAction"]);
var queue = queueScheduler;
//# sourceMappingURL=queue.js.map


/***/ }),

/***/ "./node_modules/rxjs/_esm5/internal/symbol/iterator.js":
/*!*************************************************************!*\
  !*** ./node_modules/rxjs/_esm5/internal/symbol/iterator.js ***!
  \*************************************************************/
/*! exports provided: getSymbolIterator, iterator, $$iterator */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getSymbolIterator", function() { return getSymbolIterator; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "iterator", function() { return iterator; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "$$iterator", function() { return $$iterator; });
/** PURE_IMPORTS_START  PURE_IMPORTS_END */
function getSymbolIterator() {
    if (typeof Symbol !== 'function' || !Symbol.iterator) {
        return '@@iterator';
    }
    return Symbol.iterator;
}
var iterator = /*@__PURE__*/ getSymbolIterator();
var $$iterator = iterator;
//# sourceMappingURL=iterator.js.map


/***/ }),

/***/ "./node_modules/rxjs/_esm5/internal/symbol/observable.js":
/*!***************************************************************!*\
  !*** ./node_modules/rxjs/_esm5/internal/symbol/observable.js ***!
  \***************************************************************/
/*! exports provided: observable */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "observable", function() { return observable; });
/** PURE_IMPORTS_START  PURE_IMPORTS_END */
var observable = /*@__PURE__*/ (function () { return typeof Symbol === 'function' && Symbol.observable || '@@observable'; })();
//# sourceMappingURL=observable.js.map


/***/ }),

/***/ "./node_modules/rxjs/_esm5/internal/symbol/rxSubscriber.js":
/*!*****************************************************************!*\
  !*** ./node_modules/rxjs/_esm5/internal/symbol/rxSubscriber.js ***!
  \*****************************************************************/
/*! exports provided: rxSubscriber, $$rxSubscriber */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "rxSubscriber", function() { return rxSubscriber; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "$$rxSubscriber", function() { return $$rxSubscriber; });
/** PURE_IMPORTS_START  PURE_IMPORTS_END */
var rxSubscriber = /*@__PURE__*/ (function () {
    return typeof Symbol === 'function'
        ? /*@__PURE__*/ Symbol('rxSubscriber')
        : '@@rxSubscriber_' + /*@__PURE__*/ Math.random();
})();
var $$rxSubscriber = rxSubscriber;
//# sourceMappingURL=rxSubscriber.js.map


/***/ }),

/***/ "./node_modules/rxjs/_esm5/internal/util/ArgumentOutOfRangeError.js":
/*!**************************************************************************!*\
  !*** ./node_modules/rxjs/_esm5/internal/util/ArgumentOutOfRangeError.js ***!
  \**************************************************************************/
/*! exports provided: ArgumentOutOfRangeError */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ArgumentOutOfRangeError", function() { return ArgumentOutOfRangeError; });
/** PURE_IMPORTS_START  PURE_IMPORTS_END */
var ArgumentOutOfRangeErrorImpl = /*@__PURE__*/ (function () {
    function ArgumentOutOfRangeErrorImpl() {
        Error.call(this);
        this.message = 'argument out of range';
        this.name = 'ArgumentOutOfRangeError';
        return this;
    }
    ArgumentOutOfRangeErrorImpl.prototype = /*@__PURE__*/ Object.create(Error.prototype);
    return ArgumentOutOfRangeErrorImpl;
})();
var ArgumentOutOfRangeError = ArgumentOutOfRangeErrorImpl;
//# sourceMappingURL=ArgumentOutOfRangeError.js.map


/***/ }),

/***/ "./node_modules/rxjs/_esm5/internal/util/EmptyError.js":
/*!*************************************************************!*\
  !*** ./node_modules/rxjs/_esm5/internal/util/EmptyError.js ***!
  \*************************************************************/
/*! exports provided: EmptyError */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "EmptyError", function() { return EmptyError; });
/** PURE_IMPORTS_START  PURE_IMPORTS_END */
var EmptyErrorImpl = /*@__PURE__*/ (function () {
    function EmptyErrorImpl() {
        Error.call(this);
        this.message = 'no elements in sequence';
        this.name = 'EmptyError';
        return this;
    }
    EmptyErrorImpl.prototype = /*@__PURE__*/ Object.create(Error.prototype);
    return EmptyErrorImpl;
})();
var EmptyError = EmptyErrorImpl;
//# sourceMappingURL=EmptyError.js.map


/***/ }),

/***/ "./node_modules/rxjs/_esm5/internal/util/Immediate.js":
/*!************************************************************!*\
  !*** ./node_modules/rxjs/_esm5/internal/util/Immediate.js ***!
  \************************************************************/
/*! exports provided: Immediate, TestTools */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Immediate", function() { return Immediate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "TestTools", function() { return TestTools; });
/** PURE_IMPORTS_START  PURE_IMPORTS_END */
var nextHandle = 1;
var RESOLVED = /*@__PURE__*/ (function () { return /*@__PURE__*/ Promise.resolve(); })();
var activeHandles = {};
function findAndClearHandle(handle) {
    if (handle in activeHandles) {
        delete activeHandles[handle];
        return true;
    }
    return false;
}
var Immediate = {
    setImmediate: function (cb) {
        var handle = nextHandle++;
        activeHandles[handle] = true;
        RESOLVED.then(function () { return findAndClearHandle(handle) && cb(); });
        return handle;
    },
    clearImmediate: function (handle) {
        findAndClearHandle(handle);
    },
};
var TestTools = {
    pending: function () {
        return Object.keys(activeHandles).length;
    }
};
//# sourceMappingURL=Immediate.js.map


/***/ }),

/***/ "./node_modules/rxjs/_esm5/internal/util/ObjectUnsubscribedError.js":
/*!**************************************************************************!*\
  !*** ./node_modules/rxjs/_esm5/internal/util/ObjectUnsubscribedError.js ***!
  \**************************************************************************/
/*! exports provided: ObjectUnsubscribedError */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ObjectUnsubscribedError", function() { return ObjectUnsubscribedError; });
/** PURE_IMPORTS_START  PURE_IMPORTS_END */
var ObjectUnsubscribedErrorImpl = /*@__PURE__*/ (function () {
    function ObjectUnsubscribedErrorImpl() {
        Error.call(this);
        this.message = 'object unsubscribed';
        this.name = 'ObjectUnsubscribedError';
        return this;
    }
    ObjectUnsubscribedErrorImpl.prototype = /*@__PURE__*/ Object.create(Error.prototype);
    return ObjectUnsubscribedErrorImpl;
})();
var ObjectUnsubscribedError = ObjectUnsubscribedErrorImpl;
//# sourceMappingURL=ObjectUnsubscribedError.js.map


/***/ }),

/***/ "./node_modules/rxjs/_esm5/internal/util/TimeoutError.js":
/*!***************************************************************!*\
  !*** ./node_modules/rxjs/_esm5/internal/util/TimeoutError.js ***!
  \***************************************************************/
/*! exports provided: TimeoutError */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "TimeoutError", function() { return TimeoutError; });
/** PURE_IMPORTS_START  PURE_IMPORTS_END */
var TimeoutErrorImpl = /*@__PURE__*/ (function () {
    function TimeoutErrorImpl() {
        Error.call(this);
        this.message = 'Timeout has occurred';
        this.name = 'TimeoutError';
        return this;
    }
    TimeoutErrorImpl.prototype = /*@__PURE__*/ Object.create(Error.prototype);
    return TimeoutErrorImpl;
})();
var TimeoutError = TimeoutErrorImpl;
//# sourceMappingURL=TimeoutError.js.map


/***/ }),

/***/ "./node_modules/rxjs/_esm5/internal/util/UnsubscriptionError.js":
/*!**********************************************************************!*\
  !*** ./node_modules/rxjs/_esm5/internal/util/UnsubscriptionError.js ***!
  \**********************************************************************/
/*! exports provided: UnsubscriptionError */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "UnsubscriptionError", function() { return UnsubscriptionError; });
/** PURE_IMPORTS_START  PURE_IMPORTS_END */
var UnsubscriptionErrorImpl = /*@__PURE__*/ (function () {
    function UnsubscriptionErrorImpl(errors) {
        Error.call(this);
        this.message = errors ?
            errors.length + " errors occurred during unsubscription:\n" + errors.map(function (err, i) { return i + 1 + ") " + err.toString(); }).join('\n  ') : '';
        this.name = 'UnsubscriptionError';
        this.errors = errors;
        return this;
    }
    UnsubscriptionErrorImpl.prototype = /*@__PURE__*/ Object.create(Error.prototype);
    return UnsubscriptionErrorImpl;
})();
var UnsubscriptionError = UnsubscriptionErrorImpl;
//# sourceMappingURL=UnsubscriptionError.js.map


/***/ }),

/***/ "./node_modules/rxjs/_esm5/internal/util/canReportError.js":
/*!*****************************************************************!*\
  !*** ./node_modules/rxjs/_esm5/internal/util/canReportError.js ***!
  \*****************************************************************/
/*! exports provided: canReportError */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "canReportError", function() { return canReportError; });
/* harmony import */ var _Subscriber__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../Subscriber */ "./node_modules/rxjs/_esm5/internal/Subscriber.js");
/** PURE_IMPORTS_START _Subscriber PURE_IMPORTS_END */

function canReportError(observer) {
    while (observer) {
        var _a = observer, closed_1 = _a.closed, destination = _a.destination, isStopped = _a.isStopped;
        if (closed_1 || isStopped) {
            return false;
        }
        else if (destination && destination instanceof _Subscriber__WEBPACK_IMPORTED_MODULE_0__["Subscriber"]) {
            observer = destination;
        }
        else {
            observer = null;
        }
    }
    return true;
}
//# sourceMappingURL=canReportError.js.map


/***/ }),

/***/ "./node_modules/rxjs/_esm5/internal/util/hostReportError.js":
/*!******************************************************************!*\
  !*** ./node_modules/rxjs/_esm5/internal/util/hostReportError.js ***!
  \******************************************************************/
/*! exports provided: hostReportError */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "hostReportError", function() { return hostReportError; });
/** PURE_IMPORTS_START  PURE_IMPORTS_END */
function hostReportError(err) {
    setTimeout(function () { throw err; }, 0);
}
//# sourceMappingURL=hostReportError.js.map


/***/ }),

/***/ "./node_modules/rxjs/_esm5/internal/util/identity.js":
/*!***********************************************************!*\
  !*** ./node_modules/rxjs/_esm5/internal/util/identity.js ***!
  \***********************************************************/
/*! exports provided: identity */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "identity", function() { return identity; });
/** PURE_IMPORTS_START  PURE_IMPORTS_END */
function identity(x) {
    return x;
}
//# sourceMappingURL=identity.js.map


/***/ }),

/***/ "./node_modules/rxjs/_esm5/internal/util/isArray.js":
/*!**********************************************************!*\
  !*** ./node_modules/rxjs/_esm5/internal/util/isArray.js ***!
  \**********************************************************/
/*! exports provided: isArray */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isArray", function() { return isArray; });
/** PURE_IMPORTS_START  PURE_IMPORTS_END */
var isArray = /*@__PURE__*/ (function () { return Array.isArray || (function (x) { return x && typeof x.length === 'number'; }); })();
//# sourceMappingURL=isArray.js.map


/***/ }),

/***/ "./node_modules/rxjs/_esm5/internal/util/isArrayLike.js":
/*!**************************************************************!*\
  !*** ./node_modules/rxjs/_esm5/internal/util/isArrayLike.js ***!
  \**************************************************************/
/*! exports provided: isArrayLike */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isArrayLike", function() { return isArrayLike; });
/** PURE_IMPORTS_START  PURE_IMPORTS_END */
var isArrayLike = (function (x) { return x && typeof x.length === 'number' && typeof x !== 'function'; });
//# sourceMappingURL=isArrayLike.js.map


/***/ }),

/***/ "./node_modules/rxjs/_esm5/internal/util/isDate.js":
/*!*********************************************************!*\
  !*** ./node_modules/rxjs/_esm5/internal/util/isDate.js ***!
  \*********************************************************/
/*! exports provided: isDate */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isDate", function() { return isDate; });
/** PURE_IMPORTS_START  PURE_IMPORTS_END */
function isDate(value) {
    return value instanceof Date && !isNaN(+value);
}
//# sourceMappingURL=isDate.js.map


/***/ }),

/***/ "./node_modules/rxjs/_esm5/internal/util/isFunction.js":
/*!*************************************************************!*\
  !*** ./node_modules/rxjs/_esm5/internal/util/isFunction.js ***!
  \*************************************************************/
/*! exports provided: isFunction */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isFunction", function() { return isFunction; });
/** PURE_IMPORTS_START  PURE_IMPORTS_END */
function isFunction(x) {
    return typeof x === 'function';
}
//# sourceMappingURL=isFunction.js.map


/***/ }),

/***/ "./node_modules/rxjs/_esm5/internal/util/isInteropObservable.js":
/*!**********************************************************************!*\
  !*** ./node_modules/rxjs/_esm5/internal/util/isInteropObservable.js ***!
  \**********************************************************************/
/*! exports provided: isInteropObservable */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isInteropObservable", function() { return isInteropObservable; });
/* harmony import */ var _symbol_observable__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../symbol/observable */ "./node_modules/rxjs/_esm5/internal/symbol/observable.js");
/** PURE_IMPORTS_START _symbol_observable PURE_IMPORTS_END */

function isInteropObservable(input) {
    return input && typeof input[_symbol_observable__WEBPACK_IMPORTED_MODULE_0__["observable"]] === 'function';
}
//# sourceMappingURL=isInteropObservable.js.map


/***/ }),

/***/ "./node_modules/rxjs/_esm5/internal/util/isIterable.js":
/*!*************************************************************!*\
  !*** ./node_modules/rxjs/_esm5/internal/util/isIterable.js ***!
  \*************************************************************/
/*! exports provided: isIterable */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isIterable", function() { return isIterable; });
/* harmony import */ var _symbol_iterator__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../symbol/iterator */ "./node_modules/rxjs/_esm5/internal/symbol/iterator.js");
/** PURE_IMPORTS_START _symbol_iterator PURE_IMPORTS_END */

function isIterable(input) {
    return input && typeof input[_symbol_iterator__WEBPACK_IMPORTED_MODULE_0__["iterator"]] === 'function';
}
//# sourceMappingURL=isIterable.js.map


/***/ }),

/***/ "./node_modules/rxjs/_esm5/internal/util/isNumeric.js":
/*!************************************************************!*\
  !*** ./node_modules/rxjs/_esm5/internal/util/isNumeric.js ***!
  \************************************************************/
/*! exports provided: isNumeric */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isNumeric", function() { return isNumeric; });
/* harmony import */ var _isArray__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./isArray */ "./node_modules/rxjs/_esm5/internal/util/isArray.js");
/** PURE_IMPORTS_START _isArray PURE_IMPORTS_END */

function isNumeric(val) {
    return !Object(_isArray__WEBPACK_IMPORTED_MODULE_0__["isArray"])(val) && (val - parseFloat(val) + 1) >= 0;
}
//# sourceMappingURL=isNumeric.js.map


/***/ }),

/***/ "./node_modules/rxjs/_esm5/internal/util/isObject.js":
/*!***********************************************************!*\
  !*** ./node_modules/rxjs/_esm5/internal/util/isObject.js ***!
  \***********************************************************/
/*! exports provided: isObject */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isObject", function() { return isObject; });
/** PURE_IMPORTS_START  PURE_IMPORTS_END */
function isObject(x) {
    return x !== null && typeof x === 'object';
}
//# sourceMappingURL=isObject.js.map


/***/ }),

/***/ "./node_modules/rxjs/_esm5/internal/util/isObservable.js":
/*!***************************************************************!*\
  !*** ./node_modules/rxjs/_esm5/internal/util/isObservable.js ***!
  \***************************************************************/
/*! exports provided: isObservable */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isObservable", function() { return isObservable; });
/* harmony import */ var _Observable__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../Observable */ "./node_modules/rxjs/_esm5/internal/Observable.js");
/** PURE_IMPORTS_START _Observable PURE_IMPORTS_END */

function isObservable(obj) {
    return !!obj && (obj instanceof _Observable__WEBPACK_IMPORTED_MODULE_0__["Observable"] || (typeof obj.lift === 'function' && typeof obj.subscribe === 'function'));
}
//# sourceMappingURL=isObservable.js.map


/***/ }),

/***/ "./node_modules/rxjs/_esm5/internal/util/isPromise.js":
/*!************************************************************!*\
  !*** ./node_modules/rxjs/_esm5/internal/util/isPromise.js ***!
  \************************************************************/
/*! exports provided: isPromise */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isPromise", function() { return isPromise; });
/** PURE_IMPORTS_START  PURE_IMPORTS_END */
function isPromise(value) {
    return !!value && typeof value.subscribe !== 'function' && typeof value.then === 'function';
}
//# sourceMappingURL=isPromise.js.map


/***/ }),

/***/ "./node_modules/rxjs/_esm5/internal/util/isScheduler.js":
/*!**************************************************************!*\
  !*** ./node_modules/rxjs/_esm5/internal/util/isScheduler.js ***!
  \**************************************************************/
/*! exports provided: isScheduler */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isScheduler", function() { return isScheduler; });
/** PURE_IMPORTS_START  PURE_IMPORTS_END */
function isScheduler(value) {
    return value && typeof value.schedule === 'function';
}
//# sourceMappingURL=isScheduler.js.map


/***/ }),

/***/ "./node_modules/rxjs/_esm5/internal/util/noop.js":
/*!*******************************************************!*\
  !*** ./node_modules/rxjs/_esm5/internal/util/noop.js ***!
  \*******************************************************/
/*! exports provided: noop */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "noop", function() { return noop; });
/** PURE_IMPORTS_START  PURE_IMPORTS_END */
function noop() { }
//# sourceMappingURL=noop.js.map


/***/ }),

/***/ "./node_modules/rxjs/_esm5/internal/util/not.js":
/*!******************************************************!*\
  !*** ./node_modules/rxjs/_esm5/internal/util/not.js ***!
  \******************************************************/
/*! exports provided: not */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "not", function() { return not; });
/** PURE_IMPORTS_START  PURE_IMPORTS_END */
function not(pred, thisArg) {
    function notPred() {
        return !(notPred.pred.apply(notPred.thisArg, arguments));
    }
    notPred.pred = pred;
    notPred.thisArg = thisArg;
    return notPred;
}
//# sourceMappingURL=not.js.map


/***/ }),

/***/ "./node_modules/rxjs/_esm5/internal/util/pipe.js":
/*!*******************************************************!*\
  !*** ./node_modules/rxjs/_esm5/internal/util/pipe.js ***!
  \*******************************************************/
/*! exports provided: pipe, pipeFromArray */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "pipe", function() { return pipe; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "pipeFromArray", function() { return pipeFromArray; });
/* harmony import */ var _identity__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./identity */ "./node_modules/rxjs/_esm5/internal/util/identity.js");
/** PURE_IMPORTS_START _identity PURE_IMPORTS_END */

function pipe() {
    var fns = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        fns[_i] = arguments[_i];
    }
    return pipeFromArray(fns);
}
function pipeFromArray(fns) {
    if (fns.length === 0) {
        return _identity__WEBPACK_IMPORTED_MODULE_0__["identity"];
    }
    if (fns.length === 1) {
        return fns[0];
    }
    return function piped(input) {
        return fns.reduce(function (prev, fn) { return fn(prev); }, input);
    };
}
//# sourceMappingURL=pipe.js.map


/***/ }),

/***/ "./node_modules/rxjs/_esm5/internal/util/subscribeTo.js":
/*!**************************************************************!*\
  !*** ./node_modules/rxjs/_esm5/internal/util/subscribeTo.js ***!
  \**************************************************************/
/*! exports provided: subscribeTo */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "subscribeTo", function() { return subscribeTo; });
/* harmony import */ var _subscribeToArray__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./subscribeToArray */ "./node_modules/rxjs/_esm5/internal/util/subscribeToArray.js");
/* harmony import */ var _subscribeToPromise__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./subscribeToPromise */ "./node_modules/rxjs/_esm5/internal/util/subscribeToPromise.js");
/* harmony import */ var _subscribeToIterable__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./subscribeToIterable */ "./node_modules/rxjs/_esm5/internal/util/subscribeToIterable.js");
/* harmony import */ var _subscribeToObservable__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./subscribeToObservable */ "./node_modules/rxjs/_esm5/internal/util/subscribeToObservable.js");
/* harmony import */ var _isArrayLike__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./isArrayLike */ "./node_modules/rxjs/_esm5/internal/util/isArrayLike.js");
/* harmony import */ var _isPromise__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./isPromise */ "./node_modules/rxjs/_esm5/internal/util/isPromise.js");
/* harmony import */ var _isObject__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ./isObject */ "./node_modules/rxjs/_esm5/internal/util/isObject.js");
/* harmony import */ var _symbol_iterator__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../symbol/iterator */ "./node_modules/rxjs/_esm5/internal/symbol/iterator.js");
/* harmony import */ var _symbol_observable__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ../symbol/observable */ "./node_modules/rxjs/_esm5/internal/symbol/observable.js");
/** PURE_IMPORTS_START _subscribeToArray,_subscribeToPromise,_subscribeToIterable,_subscribeToObservable,_isArrayLike,_isPromise,_isObject,_symbol_iterator,_symbol_observable PURE_IMPORTS_END */









var subscribeTo = function (result) {
    if (!!result && typeof result[_symbol_observable__WEBPACK_IMPORTED_MODULE_8__["observable"]] === 'function') {
        return Object(_subscribeToObservable__WEBPACK_IMPORTED_MODULE_3__["subscribeToObservable"])(result);
    }
    else if (Object(_isArrayLike__WEBPACK_IMPORTED_MODULE_4__["isArrayLike"])(result)) {
        return Object(_subscribeToArray__WEBPACK_IMPORTED_MODULE_0__["subscribeToArray"])(result);
    }
    else if (Object(_isPromise__WEBPACK_IMPORTED_MODULE_5__["isPromise"])(result)) {
        return Object(_subscribeToPromise__WEBPACK_IMPORTED_MODULE_1__["subscribeToPromise"])(result);
    }
    else if (!!result && typeof result[_symbol_iterator__WEBPACK_IMPORTED_MODULE_7__["iterator"]] === 'function') {
        return Object(_subscribeToIterable__WEBPACK_IMPORTED_MODULE_2__["subscribeToIterable"])(result);
    }
    else {
        var value = Object(_isObject__WEBPACK_IMPORTED_MODULE_6__["isObject"])(result) ? 'an invalid object' : "'" + result + "'";
        var msg = "You provided " + value + " where a stream was expected."
            + ' You can provide an Observable, Promise, Array, or Iterable.';
        throw new TypeError(msg);
    }
};
//# sourceMappingURL=subscribeTo.js.map


/***/ }),

/***/ "./node_modules/rxjs/_esm5/internal/util/subscribeToArray.js":
/*!*******************************************************************!*\
  !*** ./node_modules/rxjs/_esm5/internal/util/subscribeToArray.js ***!
  \*******************************************************************/
/*! exports provided: subscribeToArray */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "subscribeToArray", function() { return subscribeToArray; });
/** PURE_IMPORTS_START  PURE_IMPORTS_END */
var subscribeToArray = function (array) {
    return function (subscriber) {
        for (var i = 0, len = array.length; i < len && !subscriber.closed; i++) {
            subscriber.next(array[i]);
        }
        subscriber.complete();
    };
};
//# sourceMappingURL=subscribeToArray.js.map


/***/ }),

/***/ "./node_modules/rxjs/_esm5/internal/util/subscribeToIterable.js":
/*!**********************************************************************!*\
  !*** ./node_modules/rxjs/_esm5/internal/util/subscribeToIterable.js ***!
  \**********************************************************************/
/*! exports provided: subscribeToIterable */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "subscribeToIterable", function() { return subscribeToIterable; });
/* harmony import */ var _symbol_iterator__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../symbol/iterator */ "./node_modules/rxjs/_esm5/internal/symbol/iterator.js");
/** PURE_IMPORTS_START _symbol_iterator PURE_IMPORTS_END */

var subscribeToIterable = function (iterable) {
    return function (subscriber) {
        var iterator = iterable[_symbol_iterator__WEBPACK_IMPORTED_MODULE_0__["iterator"]]();
        do {
            var item = void 0;
            try {
                item = iterator.next();
            }
            catch (err) {
                subscriber.error(err);
                return subscriber;
            }
            if (item.done) {
                subscriber.complete();
                break;
            }
            subscriber.next(item.value);
            if (subscriber.closed) {
                break;
            }
        } while (true);
        if (typeof iterator.return === 'function') {
            subscriber.add(function () {
                if (iterator.return) {
                    iterator.return();
                }
            });
        }
        return subscriber;
    };
};
//# sourceMappingURL=subscribeToIterable.js.map


/***/ }),

/***/ "./node_modules/rxjs/_esm5/internal/util/subscribeToObservable.js":
/*!************************************************************************!*\
  !*** ./node_modules/rxjs/_esm5/internal/util/subscribeToObservable.js ***!
  \************************************************************************/
/*! exports provided: subscribeToObservable */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "subscribeToObservable", function() { return subscribeToObservable; });
/* harmony import */ var _symbol_observable__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../symbol/observable */ "./node_modules/rxjs/_esm5/internal/symbol/observable.js");
/** PURE_IMPORTS_START _symbol_observable PURE_IMPORTS_END */

var subscribeToObservable = function (obj) {
    return function (subscriber) {
        var obs = obj[_symbol_observable__WEBPACK_IMPORTED_MODULE_0__["observable"]]();
        if (typeof obs.subscribe !== 'function') {
            throw new TypeError('Provided object does not correctly implement Symbol.observable');
        }
        else {
            return obs.subscribe(subscriber);
        }
    };
};
//# sourceMappingURL=subscribeToObservable.js.map


/***/ }),

/***/ "./node_modules/rxjs/_esm5/internal/util/subscribeToPromise.js":
/*!*********************************************************************!*\
  !*** ./node_modules/rxjs/_esm5/internal/util/subscribeToPromise.js ***!
  \*********************************************************************/
/*! exports provided: subscribeToPromise */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "subscribeToPromise", function() { return subscribeToPromise; });
/* harmony import */ var _hostReportError__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./hostReportError */ "./node_modules/rxjs/_esm5/internal/util/hostReportError.js");
/** PURE_IMPORTS_START _hostReportError PURE_IMPORTS_END */

var subscribeToPromise = function (promise) {
    return function (subscriber) {
        promise.then(function (value) {
            if (!subscriber.closed) {
                subscriber.next(value);
                subscriber.complete();
            }
        }, function (err) { return subscriber.error(err); })
            .then(null, _hostReportError__WEBPACK_IMPORTED_MODULE_0__["hostReportError"]);
        return subscriber;
    };
};
//# sourceMappingURL=subscribeToPromise.js.map


/***/ }),

/***/ "./node_modules/rxjs/_esm5/internal/util/subscribeToResult.js":
/*!********************************************************************!*\
  !*** ./node_modules/rxjs/_esm5/internal/util/subscribeToResult.js ***!
  \********************************************************************/
/*! exports provided: subscribeToResult */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "subscribeToResult", function() { return subscribeToResult; });
/* harmony import */ var _InnerSubscriber__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../InnerSubscriber */ "./node_modules/rxjs/_esm5/internal/InnerSubscriber.js");
/* harmony import */ var _subscribeTo__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./subscribeTo */ "./node_modules/rxjs/_esm5/internal/util/subscribeTo.js");
/* harmony import */ var _Observable__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../Observable */ "./node_modules/rxjs/_esm5/internal/Observable.js");
/** PURE_IMPORTS_START _InnerSubscriber,_subscribeTo,_Observable PURE_IMPORTS_END */



function subscribeToResult(outerSubscriber, result, outerValue, outerIndex, innerSubscriber) {
    if (innerSubscriber === void 0) {
        innerSubscriber = new _InnerSubscriber__WEBPACK_IMPORTED_MODULE_0__["InnerSubscriber"](outerSubscriber, outerValue, outerIndex);
    }
    if (innerSubscriber.closed) {
        return undefined;
    }
    if (result instanceof _Observable__WEBPACK_IMPORTED_MODULE_2__["Observable"]) {
        return result.subscribe(innerSubscriber);
    }
    return Object(_subscribeTo__WEBPACK_IMPORTED_MODULE_1__["subscribeTo"])(result)(innerSubscriber);
}
//# sourceMappingURL=subscribeToResult.js.map


/***/ }),

/***/ "./node_modules/rxjs/_esm5/internal/util/toSubscriber.js":
/*!***************************************************************!*\
  !*** ./node_modules/rxjs/_esm5/internal/util/toSubscriber.js ***!
  \***************************************************************/
/*! exports provided: toSubscriber */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "toSubscriber", function() { return toSubscriber; });
/* harmony import */ var _Subscriber__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../Subscriber */ "./node_modules/rxjs/_esm5/internal/Subscriber.js");
/* harmony import */ var _symbol_rxSubscriber__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../symbol/rxSubscriber */ "./node_modules/rxjs/_esm5/internal/symbol/rxSubscriber.js");
/* harmony import */ var _Observer__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../Observer */ "./node_modules/rxjs/_esm5/internal/Observer.js");
/** PURE_IMPORTS_START _Subscriber,_symbol_rxSubscriber,_Observer PURE_IMPORTS_END */



function toSubscriber(nextOrObserver, error, complete) {
    if (nextOrObserver) {
        if (nextOrObserver instanceof _Subscriber__WEBPACK_IMPORTED_MODULE_0__["Subscriber"]) {
            return nextOrObserver;
        }
        if (nextOrObserver[_symbol_rxSubscriber__WEBPACK_IMPORTED_MODULE_1__["rxSubscriber"]]) {
            return nextOrObserver[_symbol_rxSubscriber__WEBPACK_IMPORTED_MODULE_1__["rxSubscriber"]]();
        }
    }
    if (!nextOrObserver && !error && !complete) {
        return new _Subscriber__WEBPACK_IMPORTED_MODULE_0__["Subscriber"](_Observer__WEBPACK_IMPORTED_MODULE_2__["empty"]);
    }
    return new _Subscriber__WEBPACK_IMPORTED_MODULE_0__["Subscriber"](nextOrObserver, error, complete);
}
//# sourceMappingURL=toSubscriber.js.map


/***/ }),

/***/ "./node_modules/rxjs/_esm5/operators/index.js":
/*!****************************************************!*\
  !*** ./node_modules/rxjs/_esm5/operators/index.js ***!
  \****************************************************/
/*! exports provided: audit, auditTime, buffer, bufferCount, bufferTime, bufferToggle, bufferWhen, catchError, combineAll, combineLatest, concat, concatAll, concatMap, concatMapTo, count, debounce, debounceTime, defaultIfEmpty, delay, delayWhen, dematerialize, distinct, distinctUntilChanged, distinctUntilKeyChanged, elementAt, endWith, every, exhaust, exhaustMap, expand, filter, finalize, find, findIndex, first, groupBy, ignoreElements, isEmpty, last, map, mapTo, materialize, max, merge, mergeAll, mergeMap, flatMap, mergeMapTo, mergeScan, min, multicast, observeOn, onErrorResumeNext, pairwise, partition, pluck, publish, publishBehavior, publishLast, publishReplay, race, reduce, repeat, repeatWhen, retry, retryWhen, refCount, sample, sampleTime, scan, sequenceEqual, share, shareReplay, single, skip, skipLast, skipUntil, skipWhile, startWith, subscribeOn, switchAll, switchMap, switchMapTo, take, takeLast, takeUntil, takeWhile, tap, throttle, throttleTime, throwIfEmpty, timeInterval, timeout, timeoutWith, timestamp, toArray, window, windowCount, windowTime, windowToggle, windowWhen, withLatestFrom, zip, zipAll */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _internal_operators_audit__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../internal/operators/audit */ "./node_modules/rxjs/_esm5/internal/operators/audit.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "audit", function() { return _internal_operators_audit__WEBPACK_IMPORTED_MODULE_0__["audit"]; });

/* harmony import */ var _internal_operators_auditTime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../internal/operators/auditTime */ "./node_modules/rxjs/_esm5/internal/operators/auditTime.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "auditTime", function() { return _internal_operators_auditTime__WEBPACK_IMPORTED_MODULE_1__["auditTime"]; });

/* harmony import */ var _internal_operators_buffer__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../internal/operators/buffer */ "./node_modules/rxjs/_esm5/internal/operators/buffer.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "buffer", function() { return _internal_operators_buffer__WEBPACK_IMPORTED_MODULE_2__["buffer"]; });

/* harmony import */ var _internal_operators_bufferCount__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../internal/operators/bufferCount */ "./node_modules/rxjs/_esm5/internal/operators/bufferCount.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "bufferCount", function() { return _internal_operators_bufferCount__WEBPACK_IMPORTED_MODULE_3__["bufferCount"]; });

/* harmony import */ var _internal_operators_bufferTime__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../internal/operators/bufferTime */ "./node_modules/rxjs/_esm5/internal/operators/bufferTime.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "bufferTime", function() { return _internal_operators_bufferTime__WEBPACK_IMPORTED_MODULE_4__["bufferTime"]; });

/* harmony import */ var _internal_operators_bufferToggle__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../internal/operators/bufferToggle */ "./node_modules/rxjs/_esm5/internal/operators/bufferToggle.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "bufferToggle", function() { return _internal_operators_bufferToggle__WEBPACK_IMPORTED_MODULE_5__["bufferToggle"]; });

/* harmony import */ var _internal_operators_bufferWhen__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../internal/operators/bufferWhen */ "./node_modules/rxjs/_esm5/internal/operators/bufferWhen.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "bufferWhen", function() { return _internal_operators_bufferWhen__WEBPACK_IMPORTED_MODULE_6__["bufferWhen"]; });

/* harmony import */ var _internal_operators_catchError__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../internal/operators/catchError */ "./node_modules/rxjs/_esm5/internal/operators/catchError.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "catchError", function() { return _internal_operators_catchError__WEBPACK_IMPORTED_MODULE_7__["catchError"]; });

/* harmony import */ var _internal_operators_combineAll__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ../internal/operators/combineAll */ "./node_modules/rxjs/_esm5/internal/operators/combineAll.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "combineAll", function() { return _internal_operators_combineAll__WEBPACK_IMPORTED_MODULE_8__["combineAll"]; });

/* harmony import */ var _internal_operators_combineLatest__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ../internal/operators/combineLatest */ "./node_modules/rxjs/_esm5/internal/operators/combineLatest.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "combineLatest", function() { return _internal_operators_combineLatest__WEBPACK_IMPORTED_MODULE_9__["combineLatest"]; });

/* harmony import */ var _internal_operators_concat__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ../internal/operators/concat */ "./node_modules/rxjs/_esm5/internal/operators/concat.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "concat", function() { return _internal_operators_concat__WEBPACK_IMPORTED_MODULE_10__["concat"]; });

/* harmony import */ var _internal_operators_concatAll__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ../internal/operators/concatAll */ "./node_modules/rxjs/_esm5/internal/operators/concatAll.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "concatAll", function() { return _internal_operators_concatAll__WEBPACK_IMPORTED_MODULE_11__["concatAll"]; });

/* harmony import */ var _internal_operators_concatMap__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! ../internal/operators/concatMap */ "./node_modules/rxjs/_esm5/internal/operators/concatMap.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "concatMap", function() { return _internal_operators_concatMap__WEBPACK_IMPORTED_MODULE_12__["concatMap"]; });

/* harmony import */ var _internal_operators_concatMapTo__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! ../internal/operators/concatMapTo */ "./node_modules/rxjs/_esm5/internal/operators/concatMapTo.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "concatMapTo", function() { return _internal_operators_concatMapTo__WEBPACK_IMPORTED_MODULE_13__["concatMapTo"]; });

/* harmony import */ var _internal_operators_count__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! ../internal/operators/count */ "./node_modules/rxjs/_esm5/internal/operators/count.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "count", function() { return _internal_operators_count__WEBPACK_IMPORTED_MODULE_14__["count"]; });

/* harmony import */ var _internal_operators_debounce__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! ../internal/operators/debounce */ "./node_modules/rxjs/_esm5/internal/operators/debounce.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "debounce", function() { return _internal_operators_debounce__WEBPACK_IMPORTED_MODULE_15__["debounce"]; });

/* harmony import */ var _internal_operators_debounceTime__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(/*! ../internal/operators/debounceTime */ "./node_modules/rxjs/_esm5/internal/operators/debounceTime.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "debounceTime", function() { return _internal_operators_debounceTime__WEBPACK_IMPORTED_MODULE_16__["debounceTime"]; });

/* harmony import */ var _internal_operators_defaultIfEmpty__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(/*! ../internal/operators/defaultIfEmpty */ "./node_modules/rxjs/_esm5/internal/operators/defaultIfEmpty.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "defaultIfEmpty", function() { return _internal_operators_defaultIfEmpty__WEBPACK_IMPORTED_MODULE_17__["defaultIfEmpty"]; });

/* harmony import */ var _internal_operators_delay__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(/*! ../internal/operators/delay */ "./node_modules/rxjs/_esm5/internal/operators/delay.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "delay", function() { return _internal_operators_delay__WEBPACK_IMPORTED_MODULE_18__["delay"]; });

/* harmony import */ var _internal_operators_delayWhen__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(/*! ../internal/operators/delayWhen */ "./node_modules/rxjs/_esm5/internal/operators/delayWhen.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "delayWhen", function() { return _internal_operators_delayWhen__WEBPACK_IMPORTED_MODULE_19__["delayWhen"]; });

/* harmony import */ var _internal_operators_dematerialize__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(/*! ../internal/operators/dematerialize */ "./node_modules/rxjs/_esm5/internal/operators/dematerialize.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "dematerialize", function() { return _internal_operators_dematerialize__WEBPACK_IMPORTED_MODULE_20__["dematerialize"]; });

/* harmony import */ var _internal_operators_distinct__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(/*! ../internal/operators/distinct */ "./node_modules/rxjs/_esm5/internal/operators/distinct.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "distinct", function() { return _internal_operators_distinct__WEBPACK_IMPORTED_MODULE_21__["distinct"]; });

/* harmony import */ var _internal_operators_distinctUntilChanged__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(/*! ../internal/operators/distinctUntilChanged */ "./node_modules/rxjs/_esm5/internal/operators/distinctUntilChanged.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "distinctUntilChanged", function() { return _internal_operators_distinctUntilChanged__WEBPACK_IMPORTED_MODULE_22__["distinctUntilChanged"]; });

/* harmony import */ var _internal_operators_distinctUntilKeyChanged__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(/*! ../internal/operators/distinctUntilKeyChanged */ "./node_modules/rxjs/_esm5/internal/operators/distinctUntilKeyChanged.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "distinctUntilKeyChanged", function() { return _internal_operators_distinctUntilKeyChanged__WEBPACK_IMPORTED_MODULE_23__["distinctUntilKeyChanged"]; });

/* harmony import */ var _internal_operators_elementAt__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(/*! ../internal/operators/elementAt */ "./node_modules/rxjs/_esm5/internal/operators/elementAt.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "elementAt", function() { return _internal_operators_elementAt__WEBPACK_IMPORTED_MODULE_24__["elementAt"]; });

/* harmony import */ var _internal_operators_endWith__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__(/*! ../internal/operators/endWith */ "./node_modules/rxjs/_esm5/internal/operators/endWith.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "endWith", function() { return _internal_operators_endWith__WEBPACK_IMPORTED_MODULE_25__["endWith"]; });

/* harmony import */ var _internal_operators_every__WEBPACK_IMPORTED_MODULE_26__ = __webpack_require__(/*! ../internal/operators/every */ "./node_modules/rxjs/_esm5/internal/operators/every.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "every", function() { return _internal_operators_every__WEBPACK_IMPORTED_MODULE_26__["every"]; });

/* harmony import */ var _internal_operators_exhaust__WEBPACK_IMPORTED_MODULE_27__ = __webpack_require__(/*! ../internal/operators/exhaust */ "./node_modules/rxjs/_esm5/internal/operators/exhaust.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "exhaust", function() { return _internal_operators_exhaust__WEBPACK_IMPORTED_MODULE_27__["exhaust"]; });

/* harmony import */ var _internal_operators_exhaustMap__WEBPACK_IMPORTED_MODULE_28__ = __webpack_require__(/*! ../internal/operators/exhaustMap */ "./node_modules/rxjs/_esm5/internal/operators/exhaustMap.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "exhaustMap", function() { return _internal_operators_exhaustMap__WEBPACK_IMPORTED_MODULE_28__["exhaustMap"]; });

/* harmony import */ var _internal_operators_expand__WEBPACK_IMPORTED_MODULE_29__ = __webpack_require__(/*! ../internal/operators/expand */ "./node_modules/rxjs/_esm5/internal/operators/expand.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "expand", function() { return _internal_operators_expand__WEBPACK_IMPORTED_MODULE_29__["expand"]; });

/* harmony import */ var _internal_operators_filter__WEBPACK_IMPORTED_MODULE_30__ = __webpack_require__(/*! ../internal/operators/filter */ "./node_modules/rxjs/_esm5/internal/operators/filter.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "filter", function() { return _internal_operators_filter__WEBPACK_IMPORTED_MODULE_30__["filter"]; });

/* harmony import */ var _internal_operators_finalize__WEBPACK_IMPORTED_MODULE_31__ = __webpack_require__(/*! ../internal/operators/finalize */ "./node_modules/rxjs/_esm5/internal/operators/finalize.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "finalize", function() { return _internal_operators_finalize__WEBPACK_IMPORTED_MODULE_31__["finalize"]; });

/* harmony import */ var _internal_operators_find__WEBPACK_IMPORTED_MODULE_32__ = __webpack_require__(/*! ../internal/operators/find */ "./node_modules/rxjs/_esm5/internal/operators/find.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "find", function() { return _internal_operators_find__WEBPACK_IMPORTED_MODULE_32__["find"]; });

/* harmony import */ var _internal_operators_findIndex__WEBPACK_IMPORTED_MODULE_33__ = __webpack_require__(/*! ../internal/operators/findIndex */ "./node_modules/rxjs/_esm5/internal/operators/findIndex.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "findIndex", function() { return _internal_operators_findIndex__WEBPACK_IMPORTED_MODULE_33__["findIndex"]; });

/* harmony import */ var _internal_operators_first__WEBPACK_IMPORTED_MODULE_34__ = __webpack_require__(/*! ../internal/operators/first */ "./node_modules/rxjs/_esm5/internal/operators/first.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "first", function() { return _internal_operators_first__WEBPACK_IMPORTED_MODULE_34__["first"]; });

/* harmony import */ var _internal_operators_groupBy__WEBPACK_IMPORTED_MODULE_35__ = __webpack_require__(/*! ../internal/operators/groupBy */ "./node_modules/rxjs/_esm5/internal/operators/groupBy.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "groupBy", function() { return _internal_operators_groupBy__WEBPACK_IMPORTED_MODULE_35__["groupBy"]; });

/* harmony import */ var _internal_operators_ignoreElements__WEBPACK_IMPORTED_MODULE_36__ = __webpack_require__(/*! ../internal/operators/ignoreElements */ "./node_modules/rxjs/_esm5/internal/operators/ignoreElements.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ignoreElements", function() { return _internal_operators_ignoreElements__WEBPACK_IMPORTED_MODULE_36__["ignoreElements"]; });

/* harmony import */ var _internal_operators_isEmpty__WEBPACK_IMPORTED_MODULE_37__ = __webpack_require__(/*! ../internal/operators/isEmpty */ "./node_modules/rxjs/_esm5/internal/operators/isEmpty.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "isEmpty", function() { return _internal_operators_isEmpty__WEBPACK_IMPORTED_MODULE_37__["isEmpty"]; });

/* harmony import */ var _internal_operators_last__WEBPACK_IMPORTED_MODULE_38__ = __webpack_require__(/*! ../internal/operators/last */ "./node_modules/rxjs/_esm5/internal/operators/last.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "last", function() { return _internal_operators_last__WEBPACK_IMPORTED_MODULE_38__["last"]; });

/* harmony import */ var _internal_operators_map__WEBPACK_IMPORTED_MODULE_39__ = __webpack_require__(/*! ../internal/operators/map */ "./node_modules/rxjs/_esm5/internal/operators/map.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "map", function() { return _internal_operators_map__WEBPACK_IMPORTED_MODULE_39__["map"]; });

/* harmony import */ var _internal_operators_mapTo__WEBPACK_IMPORTED_MODULE_40__ = __webpack_require__(/*! ../internal/operators/mapTo */ "./node_modules/rxjs/_esm5/internal/operators/mapTo.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "mapTo", function() { return _internal_operators_mapTo__WEBPACK_IMPORTED_MODULE_40__["mapTo"]; });

/* harmony import */ var _internal_operators_materialize__WEBPACK_IMPORTED_MODULE_41__ = __webpack_require__(/*! ../internal/operators/materialize */ "./node_modules/rxjs/_esm5/internal/operators/materialize.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "materialize", function() { return _internal_operators_materialize__WEBPACK_IMPORTED_MODULE_41__["materialize"]; });

/* harmony import */ var _internal_operators_max__WEBPACK_IMPORTED_MODULE_42__ = __webpack_require__(/*! ../internal/operators/max */ "./node_modules/rxjs/_esm5/internal/operators/max.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "max", function() { return _internal_operators_max__WEBPACK_IMPORTED_MODULE_42__["max"]; });

/* harmony import */ var _internal_operators_merge__WEBPACK_IMPORTED_MODULE_43__ = __webpack_require__(/*! ../internal/operators/merge */ "./node_modules/rxjs/_esm5/internal/operators/merge.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "merge", function() { return _internal_operators_merge__WEBPACK_IMPORTED_MODULE_43__["merge"]; });

/* harmony import */ var _internal_operators_mergeAll__WEBPACK_IMPORTED_MODULE_44__ = __webpack_require__(/*! ../internal/operators/mergeAll */ "./node_modules/rxjs/_esm5/internal/operators/mergeAll.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "mergeAll", function() { return _internal_operators_mergeAll__WEBPACK_IMPORTED_MODULE_44__["mergeAll"]; });

/* harmony import */ var _internal_operators_mergeMap__WEBPACK_IMPORTED_MODULE_45__ = __webpack_require__(/*! ../internal/operators/mergeMap */ "./node_modules/rxjs/_esm5/internal/operators/mergeMap.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "mergeMap", function() { return _internal_operators_mergeMap__WEBPACK_IMPORTED_MODULE_45__["mergeMap"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "flatMap", function() { return _internal_operators_mergeMap__WEBPACK_IMPORTED_MODULE_45__["flatMap"]; });

/* harmony import */ var _internal_operators_mergeMapTo__WEBPACK_IMPORTED_MODULE_46__ = __webpack_require__(/*! ../internal/operators/mergeMapTo */ "./node_modules/rxjs/_esm5/internal/operators/mergeMapTo.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "mergeMapTo", function() { return _internal_operators_mergeMapTo__WEBPACK_IMPORTED_MODULE_46__["mergeMapTo"]; });

/* harmony import */ var _internal_operators_mergeScan__WEBPACK_IMPORTED_MODULE_47__ = __webpack_require__(/*! ../internal/operators/mergeScan */ "./node_modules/rxjs/_esm5/internal/operators/mergeScan.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "mergeScan", function() { return _internal_operators_mergeScan__WEBPACK_IMPORTED_MODULE_47__["mergeScan"]; });

/* harmony import */ var _internal_operators_min__WEBPACK_IMPORTED_MODULE_48__ = __webpack_require__(/*! ../internal/operators/min */ "./node_modules/rxjs/_esm5/internal/operators/min.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "min", function() { return _internal_operators_min__WEBPACK_IMPORTED_MODULE_48__["min"]; });

/* harmony import */ var _internal_operators_multicast__WEBPACK_IMPORTED_MODULE_49__ = __webpack_require__(/*! ../internal/operators/multicast */ "./node_modules/rxjs/_esm5/internal/operators/multicast.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "multicast", function() { return _internal_operators_multicast__WEBPACK_IMPORTED_MODULE_49__["multicast"]; });

/* harmony import */ var _internal_operators_observeOn__WEBPACK_IMPORTED_MODULE_50__ = __webpack_require__(/*! ../internal/operators/observeOn */ "./node_modules/rxjs/_esm5/internal/operators/observeOn.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "observeOn", function() { return _internal_operators_observeOn__WEBPACK_IMPORTED_MODULE_50__["observeOn"]; });

/* harmony import */ var _internal_operators_onErrorResumeNext__WEBPACK_IMPORTED_MODULE_51__ = __webpack_require__(/*! ../internal/operators/onErrorResumeNext */ "./node_modules/rxjs/_esm5/internal/operators/onErrorResumeNext.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "onErrorResumeNext", function() { return _internal_operators_onErrorResumeNext__WEBPACK_IMPORTED_MODULE_51__["onErrorResumeNext"]; });

/* harmony import */ var _internal_operators_pairwise__WEBPACK_IMPORTED_MODULE_52__ = __webpack_require__(/*! ../internal/operators/pairwise */ "./node_modules/rxjs/_esm5/internal/operators/pairwise.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "pairwise", function() { return _internal_operators_pairwise__WEBPACK_IMPORTED_MODULE_52__["pairwise"]; });

/* harmony import */ var _internal_operators_partition__WEBPACK_IMPORTED_MODULE_53__ = __webpack_require__(/*! ../internal/operators/partition */ "./node_modules/rxjs/_esm5/internal/operators/partition.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "partition", function() { return _internal_operators_partition__WEBPACK_IMPORTED_MODULE_53__["partition"]; });

/* harmony import */ var _internal_operators_pluck__WEBPACK_IMPORTED_MODULE_54__ = __webpack_require__(/*! ../internal/operators/pluck */ "./node_modules/rxjs/_esm5/internal/operators/pluck.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "pluck", function() { return _internal_operators_pluck__WEBPACK_IMPORTED_MODULE_54__["pluck"]; });

/* harmony import */ var _internal_operators_publish__WEBPACK_IMPORTED_MODULE_55__ = __webpack_require__(/*! ../internal/operators/publish */ "./node_modules/rxjs/_esm5/internal/operators/publish.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "publish", function() { return _internal_operators_publish__WEBPACK_IMPORTED_MODULE_55__["publish"]; });

/* harmony import */ var _internal_operators_publishBehavior__WEBPACK_IMPORTED_MODULE_56__ = __webpack_require__(/*! ../internal/operators/publishBehavior */ "./node_modules/rxjs/_esm5/internal/operators/publishBehavior.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "publishBehavior", function() { return _internal_operators_publishBehavior__WEBPACK_IMPORTED_MODULE_56__["publishBehavior"]; });

/* harmony import */ var _internal_operators_publishLast__WEBPACK_IMPORTED_MODULE_57__ = __webpack_require__(/*! ../internal/operators/publishLast */ "./node_modules/rxjs/_esm5/internal/operators/publishLast.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "publishLast", function() { return _internal_operators_publishLast__WEBPACK_IMPORTED_MODULE_57__["publishLast"]; });

/* harmony import */ var _internal_operators_publishReplay__WEBPACK_IMPORTED_MODULE_58__ = __webpack_require__(/*! ../internal/operators/publishReplay */ "./node_modules/rxjs/_esm5/internal/operators/publishReplay.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "publishReplay", function() { return _internal_operators_publishReplay__WEBPACK_IMPORTED_MODULE_58__["publishReplay"]; });

/* harmony import */ var _internal_operators_race__WEBPACK_IMPORTED_MODULE_59__ = __webpack_require__(/*! ../internal/operators/race */ "./node_modules/rxjs/_esm5/internal/operators/race.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "race", function() { return _internal_operators_race__WEBPACK_IMPORTED_MODULE_59__["race"]; });

/* harmony import */ var _internal_operators_reduce__WEBPACK_IMPORTED_MODULE_60__ = __webpack_require__(/*! ../internal/operators/reduce */ "./node_modules/rxjs/_esm5/internal/operators/reduce.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "reduce", function() { return _internal_operators_reduce__WEBPACK_IMPORTED_MODULE_60__["reduce"]; });

/* harmony import */ var _internal_operators_repeat__WEBPACK_IMPORTED_MODULE_61__ = __webpack_require__(/*! ../internal/operators/repeat */ "./node_modules/rxjs/_esm5/internal/operators/repeat.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "repeat", function() { return _internal_operators_repeat__WEBPACK_IMPORTED_MODULE_61__["repeat"]; });

/* harmony import */ var _internal_operators_repeatWhen__WEBPACK_IMPORTED_MODULE_62__ = __webpack_require__(/*! ../internal/operators/repeatWhen */ "./node_modules/rxjs/_esm5/internal/operators/repeatWhen.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "repeatWhen", function() { return _internal_operators_repeatWhen__WEBPACK_IMPORTED_MODULE_62__["repeatWhen"]; });

/* harmony import */ var _internal_operators_retry__WEBPACK_IMPORTED_MODULE_63__ = __webpack_require__(/*! ../internal/operators/retry */ "./node_modules/rxjs/_esm5/internal/operators/retry.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "retry", function() { return _internal_operators_retry__WEBPACK_IMPORTED_MODULE_63__["retry"]; });

/* harmony import */ var _internal_operators_retryWhen__WEBPACK_IMPORTED_MODULE_64__ = __webpack_require__(/*! ../internal/operators/retryWhen */ "./node_modules/rxjs/_esm5/internal/operators/retryWhen.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "retryWhen", function() { return _internal_operators_retryWhen__WEBPACK_IMPORTED_MODULE_64__["retryWhen"]; });

/* harmony import */ var _internal_operators_refCount__WEBPACK_IMPORTED_MODULE_65__ = __webpack_require__(/*! ../internal/operators/refCount */ "./node_modules/rxjs/_esm5/internal/operators/refCount.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "refCount", function() { return _internal_operators_refCount__WEBPACK_IMPORTED_MODULE_65__["refCount"]; });

/* harmony import */ var _internal_operators_sample__WEBPACK_IMPORTED_MODULE_66__ = __webpack_require__(/*! ../internal/operators/sample */ "./node_modules/rxjs/_esm5/internal/operators/sample.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "sample", function() { return _internal_operators_sample__WEBPACK_IMPORTED_MODULE_66__["sample"]; });

/* harmony import */ var _internal_operators_sampleTime__WEBPACK_IMPORTED_MODULE_67__ = __webpack_require__(/*! ../internal/operators/sampleTime */ "./node_modules/rxjs/_esm5/internal/operators/sampleTime.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "sampleTime", function() { return _internal_operators_sampleTime__WEBPACK_IMPORTED_MODULE_67__["sampleTime"]; });

/* harmony import */ var _internal_operators_scan__WEBPACK_IMPORTED_MODULE_68__ = __webpack_require__(/*! ../internal/operators/scan */ "./node_modules/rxjs/_esm5/internal/operators/scan.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "scan", function() { return _internal_operators_scan__WEBPACK_IMPORTED_MODULE_68__["scan"]; });

/* harmony import */ var _internal_operators_sequenceEqual__WEBPACK_IMPORTED_MODULE_69__ = __webpack_require__(/*! ../internal/operators/sequenceEqual */ "./node_modules/rxjs/_esm5/internal/operators/sequenceEqual.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "sequenceEqual", function() { return _internal_operators_sequenceEqual__WEBPACK_IMPORTED_MODULE_69__["sequenceEqual"]; });

/* harmony import */ var _internal_operators_share__WEBPACK_IMPORTED_MODULE_70__ = __webpack_require__(/*! ../internal/operators/share */ "./node_modules/rxjs/_esm5/internal/operators/share.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "share", function() { return _internal_operators_share__WEBPACK_IMPORTED_MODULE_70__["share"]; });

/* harmony import */ var _internal_operators_shareReplay__WEBPACK_IMPORTED_MODULE_71__ = __webpack_require__(/*! ../internal/operators/shareReplay */ "./node_modules/rxjs/_esm5/internal/operators/shareReplay.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "shareReplay", function() { return _internal_operators_shareReplay__WEBPACK_IMPORTED_MODULE_71__["shareReplay"]; });

/* harmony import */ var _internal_operators_single__WEBPACK_IMPORTED_MODULE_72__ = __webpack_require__(/*! ../internal/operators/single */ "./node_modules/rxjs/_esm5/internal/operators/single.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "single", function() { return _internal_operators_single__WEBPACK_IMPORTED_MODULE_72__["single"]; });

/* harmony import */ var _internal_operators_skip__WEBPACK_IMPORTED_MODULE_73__ = __webpack_require__(/*! ../internal/operators/skip */ "./node_modules/rxjs/_esm5/internal/operators/skip.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "skip", function() { return _internal_operators_skip__WEBPACK_IMPORTED_MODULE_73__["skip"]; });

/* harmony import */ var _internal_operators_skipLast__WEBPACK_IMPORTED_MODULE_74__ = __webpack_require__(/*! ../internal/operators/skipLast */ "./node_modules/rxjs/_esm5/internal/operators/skipLast.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "skipLast", function() { return _internal_operators_skipLast__WEBPACK_IMPORTED_MODULE_74__["skipLast"]; });

/* harmony import */ var _internal_operators_skipUntil__WEBPACK_IMPORTED_MODULE_75__ = __webpack_require__(/*! ../internal/operators/skipUntil */ "./node_modules/rxjs/_esm5/internal/operators/skipUntil.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "skipUntil", function() { return _internal_operators_skipUntil__WEBPACK_IMPORTED_MODULE_75__["skipUntil"]; });

/* harmony import */ var _internal_operators_skipWhile__WEBPACK_IMPORTED_MODULE_76__ = __webpack_require__(/*! ../internal/operators/skipWhile */ "./node_modules/rxjs/_esm5/internal/operators/skipWhile.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "skipWhile", function() { return _internal_operators_skipWhile__WEBPACK_IMPORTED_MODULE_76__["skipWhile"]; });

/* harmony import */ var _internal_operators_startWith__WEBPACK_IMPORTED_MODULE_77__ = __webpack_require__(/*! ../internal/operators/startWith */ "./node_modules/rxjs/_esm5/internal/operators/startWith.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "startWith", function() { return _internal_operators_startWith__WEBPACK_IMPORTED_MODULE_77__["startWith"]; });

/* harmony import */ var _internal_operators_subscribeOn__WEBPACK_IMPORTED_MODULE_78__ = __webpack_require__(/*! ../internal/operators/subscribeOn */ "./node_modules/rxjs/_esm5/internal/operators/subscribeOn.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "subscribeOn", function() { return _internal_operators_subscribeOn__WEBPACK_IMPORTED_MODULE_78__["subscribeOn"]; });

/* harmony import */ var _internal_operators_switchAll__WEBPACK_IMPORTED_MODULE_79__ = __webpack_require__(/*! ../internal/operators/switchAll */ "./node_modules/rxjs/_esm5/internal/operators/switchAll.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "switchAll", function() { return _internal_operators_switchAll__WEBPACK_IMPORTED_MODULE_79__["switchAll"]; });

/* harmony import */ var _internal_operators_switchMap__WEBPACK_IMPORTED_MODULE_80__ = __webpack_require__(/*! ../internal/operators/switchMap */ "./node_modules/rxjs/_esm5/internal/operators/switchMap.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "switchMap", function() { return _internal_operators_switchMap__WEBPACK_IMPORTED_MODULE_80__["switchMap"]; });

/* harmony import */ var _internal_operators_switchMapTo__WEBPACK_IMPORTED_MODULE_81__ = __webpack_require__(/*! ../internal/operators/switchMapTo */ "./node_modules/rxjs/_esm5/internal/operators/switchMapTo.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "switchMapTo", function() { return _internal_operators_switchMapTo__WEBPACK_IMPORTED_MODULE_81__["switchMapTo"]; });

/* harmony import */ var _internal_operators_take__WEBPACK_IMPORTED_MODULE_82__ = __webpack_require__(/*! ../internal/operators/take */ "./node_modules/rxjs/_esm5/internal/operators/take.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "take", function() { return _internal_operators_take__WEBPACK_IMPORTED_MODULE_82__["take"]; });

/* harmony import */ var _internal_operators_takeLast__WEBPACK_IMPORTED_MODULE_83__ = __webpack_require__(/*! ../internal/operators/takeLast */ "./node_modules/rxjs/_esm5/internal/operators/takeLast.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "takeLast", function() { return _internal_operators_takeLast__WEBPACK_IMPORTED_MODULE_83__["takeLast"]; });

/* harmony import */ var _internal_operators_takeUntil__WEBPACK_IMPORTED_MODULE_84__ = __webpack_require__(/*! ../internal/operators/takeUntil */ "./node_modules/rxjs/_esm5/internal/operators/takeUntil.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "takeUntil", function() { return _internal_operators_takeUntil__WEBPACK_IMPORTED_MODULE_84__["takeUntil"]; });

/* harmony import */ var _internal_operators_takeWhile__WEBPACK_IMPORTED_MODULE_85__ = __webpack_require__(/*! ../internal/operators/takeWhile */ "./node_modules/rxjs/_esm5/internal/operators/takeWhile.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "takeWhile", function() { return _internal_operators_takeWhile__WEBPACK_IMPORTED_MODULE_85__["takeWhile"]; });

/* harmony import */ var _internal_operators_tap__WEBPACK_IMPORTED_MODULE_86__ = __webpack_require__(/*! ../internal/operators/tap */ "./node_modules/rxjs/_esm5/internal/operators/tap.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "tap", function() { return _internal_operators_tap__WEBPACK_IMPORTED_MODULE_86__["tap"]; });

/* harmony import */ var _internal_operators_throttle__WEBPACK_IMPORTED_MODULE_87__ = __webpack_require__(/*! ../internal/operators/throttle */ "./node_modules/rxjs/_esm5/internal/operators/throttle.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "throttle", function() { return _internal_operators_throttle__WEBPACK_IMPORTED_MODULE_87__["throttle"]; });

/* harmony import */ var _internal_operators_throttleTime__WEBPACK_IMPORTED_MODULE_88__ = __webpack_require__(/*! ../internal/operators/throttleTime */ "./node_modules/rxjs/_esm5/internal/operators/throttleTime.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "throttleTime", function() { return _internal_operators_throttleTime__WEBPACK_IMPORTED_MODULE_88__["throttleTime"]; });

/* harmony import */ var _internal_operators_throwIfEmpty__WEBPACK_IMPORTED_MODULE_89__ = __webpack_require__(/*! ../internal/operators/throwIfEmpty */ "./node_modules/rxjs/_esm5/internal/operators/throwIfEmpty.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "throwIfEmpty", function() { return _internal_operators_throwIfEmpty__WEBPACK_IMPORTED_MODULE_89__["throwIfEmpty"]; });

/* harmony import */ var _internal_operators_timeInterval__WEBPACK_IMPORTED_MODULE_90__ = __webpack_require__(/*! ../internal/operators/timeInterval */ "./node_modules/rxjs/_esm5/internal/operators/timeInterval.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "timeInterval", function() { return _internal_operators_timeInterval__WEBPACK_IMPORTED_MODULE_90__["timeInterval"]; });

/* harmony import */ var _internal_operators_timeout__WEBPACK_IMPORTED_MODULE_91__ = __webpack_require__(/*! ../internal/operators/timeout */ "./node_modules/rxjs/_esm5/internal/operators/timeout.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "timeout", function() { return _internal_operators_timeout__WEBPACK_IMPORTED_MODULE_91__["timeout"]; });

/* harmony import */ var _internal_operators_timeoutWith__WEBPACK_IMPORTED_MODULE_92__ = __webpack_require__(/*! ../internal/operators/timeoutWith */ "./node_modules/rxjs/_esm5/internal/operators/timeoutWith.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "timeoutWith", function() { return _internal_operators_timeoutWith__WEBPACK_IMPORTED_MODULE_92__["timeoutWith"]; });

/* harmony import */ var _internal_operators_timestamp__WEBPACK_IMPORTED_MODULE_93__ = __webpack_require__(/*! ../internal/operators/timestamp */ "./node_modules/rxjs/_esm5/internal/operators/timestamp.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "timestamp", function() { return _internal_operators_timestamp__WEBPACK_IMPORTED_MODULE_93__["timestamp"]; });

/* harmony import */ var _internal_operators_toArray__WEBPACK_IMPORTED_MODULE_94__ = __webpack_require__(/*! ../internal/operators/toArray */ "./node_modules/rxjs/_esm5/internal/operators/toArray.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "toArray", function() { return _internal_operators_toArray__WEBPACK_IMPORTED_MODULE_94__["toArray"]; });

/* harmony import */ var _internal_operators_window__WEBPACK_IMPORTED_MODULE_95__ = __webpack_require__(/*! ../internal/operators/window */ "./node_modules/rxjs/_esm5/internal/operators/window.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "window", function() { return _internal_operators_window__WEBPACK_IMPORTED_MODULE_95__["window"]; });

/* harmony import */ var _internal_operators_windowCount__WEBPACK_IMPORTED_MODULE_96__ = __webpack_require__(/*! ../internal/operators/windowCount */ "./node_modules/rxjs/_esm5/internal/operators/windowCount.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "windowCount", function() { return _internal_operators_windowCount__WEBPACK_IMPORTED_MODULE_96__["windowCount"]; });

/* harmony import */ var _internal_operators_windowTime__WEBPACK_IMPORTED_MODULE_97__ = __webpack_require__(/*! ../internal/operators/windowTime */ "./node_modules/rxjs/_esm5/internal/operators/windowTime.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "windowTime", function() { return _internal_operators_windowTime__WEBPACK_IMPORTED_MODULE_97__["windowTime"]; });

/* harmony import */ var _internal_operators_windowToggle__WEBPACK_IMPORTED_MODULE_98__ = __webpack_require__(/*! ../internal/operators/windowToggle */ "./node_modules/rxjs/_esm5/internal/operators/windowToggle.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "windowToggle", function() { return _internal_operators_windowToggle__WEBPACK_IMPORTED_MODULE_98__["windowToggle"]; });

/* harmony import */ var _internal_operators_windowWhen__WEBPACK_IMPORTED_MODULE_99__ = __webpack_require__(/*! ../internal/operators/windowWhen */ "./node_modules/rxjs/_esm5/internal/operators/windowWhen.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "windowWhen", function() { return _internal_operators_windowWhen__WEBPACK_IMPORTED_MODULE_99__["windowWhen"]; });

/* harmony import */ var _internal_operators_withLatestFrom__WEBPACK_IMPORTED_MODULE_100__ = __webpack_require__(/*! ../internal/operators/withLatestFrom */ "./node_modules/rxjs/_esm5/internal/operators/withLatestFrom.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "withLatestFrom", function() { return _internal_operators_withLatestFrom__WEBPACK_IMPORTED_MODULE_100__["withLatestFrom"]; });

/* harmony import */ var _internal_operators_zip__WEBPACK_IMPORTED_MODULE_101__ = __webpack_require__(/*! ../internal/operators/zip */ "./node_modules/rxjs/_esm5/internal/operators/zip.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "zip", function() { return _internal_operators_zip__WEBPACK_IMPORTED_MODULE_101__["zip"]; });

/* harmony import */ var _internal_operators_zipAll__WEBPACK_IMPORTED_MODULE_102__ = __webpack_require__(/*! ../internal/operators/zipAll */ "./node_modules/rxjs/_esm5/internal/operators/zipAll.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "zipAll", function() { return _internal_operators_zipAll__WEBPACK_IMPORTED_MODULE_102__["zipAll"]; });

/** PURE_IMPORTS_START  PURE_IMPORTS_END */







































































































//# sourceMappingURL=index.js.map


/***/ }),

/***/ "./node_modules/rxjs/node_modules/tslib/tslib.es6.js":
/*!***********************************************************!*\
  !*** ./node_modules/rxjs/node_modules/tslib/tslib.es6.js ***!
  \***********************************************************/
/*! exports provided: __extends, __assign, __rest, __decorate, __param, __metadata, __awaiter, __generator, __createBinding, __exportStar, __values, __read, __spread, __spreadArrays, __await, __asyncGenerator, __asyncDelegator, __asyncValues, __makeTemplateObject, __importStar, __importDefault, __classPrivateFieldGet, __classPrivateFieldSet */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__extends", function() { return __extends; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__assign", function() { return __assign; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__rest", function() { return __rest; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__decorate", function() { return __decorate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__param", function() { return __param; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__metadata", function() { return __metadata; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__awaiter", function() { return __awaiter; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__generator", function() { return __generator; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__createBinding", function() { return __createBinding; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__exportStar", function() { return __exportStar; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__values", function() { return __values; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__read", function() { return __read; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__spread", function() { return __spread; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__spreadArrays", function() { return __spreadArrays; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__await", function() { return __await; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__asyncGenerator", function() { return __asyncGenerator; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__asyncDelegator", function() { return __asyncDelegator; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__asyncValues", function() { return __asyncValues; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__makeTemplateObject", function() { return __makeTemplateObject; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__importStar", function() { return __importStar; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__importDefault", function() { return __importDefault; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__classPrivateFieldGet", function() { return __classPrivateFieldGet; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__classPrivateFieldSet", function() { return __classPrivateFieldSet; });
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
/* global Reflect, Promise */

var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return extendStatics(d, b);
};

function __extends(d, b) {
    extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    }
    return __assign.apply(this, arguments);
}

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

function __decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}

function __param(paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
}

function __metadata(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}

function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}

function __createBinding(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}

function __exportStar(m, exports) {
    for (var p in m) if (p !== "default" && !exports.hasOwnProperty(p)) exports[p] = m[p];
}

function __values(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}

function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
}

function __spread() {
    for (var ar = [], i = 0; i < arguments.length; i++)
        ar = ar.concat(__read(arguments[i]));
    return ar;
}

function __spreadArrays() {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};

function __await(v) {
    return this instanceof __await ? (this.v = v, this) : new __await(v);
}

function __asyncGenerator(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i;
    function verb(n) { if (g[n]) i[n] = function (v) { return new Promise(function (a, b) { q.push([n, v, a, b]) > 1 || resume(n, v); }); }; }
    function resume(n, v) { try { step(g[n](v)); } catch (e) { settle(q[0][3], e); } }
    function step(r) { r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r); }
    function fulfill(value) { resume("next", value); }
    function reject(value) { resume("throw", value); }
    function settle(f, v) { if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]); }
}

function __asyncDelegator(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function (e) { throw e; }), verb("return"), i[Symbol.iterator] = function () { return this; }, i;
    function verb(n, f) { i[n] = o[n] ? function (v) { return (p = !p) ? { value: __await(o[n](v)), done: n === "return" } : f ? f(v) : v; } : f; }
}

function __asyncValues(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i);
    function verb(n) { i[n] = o[n] && function (v) { return new Promise(function (resolve, reject) { v = o[n](v), settle(resolve, reject, v.done, v.value); }); }; }
    function settle(resolve, reject, d, v) { Promise.resolve(v).then(function(v) { resolve({ value: v, done: d }); }, reject); }
}

function __makeTemplateObject(cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};

function __importStar(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result.default = mod;
    return result;
}

function __importDefault(mod) {
    return (mod && mod.__esModule) ? mod : { default: mod };
}

function __classPrivateFieldGet(receiver, privateMap) {
    if (!privateMap.has(receiver)) {
        throw new TypeError("attempted to get private field on non-instance");
    }
    return privateMap.get(receiver);
}

function __classPrivateFieldSet(receiver, privateMap, value) {
    if (!privateMap.has(receiver)) {
        throw new TypeError("attempted to set private field on non-instance");
    }
    privateMap.set(receiver, value);
    return value;
}


/***/ }),

/***/ "./node_modules/safe-buffer/index.js":
/*!*******************************************!*\
  !*** ./node_modules/safe-buffer/index.js ***!
  \*******************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

/* eslint-disable node/no-deprecated-api */
var buffer = __webpack_require__(/*! buffer */ "./node_modules/node-libs-browser/node_modules/buffer/index.js")
var Buffer = buffer.Buffer

// alternative to using Object.keys for old browsers
function copyProps (src, dst) {
  for (var key in src) {
    dst[key] = src[key]
  }
}
if (Buffer.from && Buffer.alloc && Buffer.allocUnsafe && Buffer.allocUnsafeSlow) {
  module.exports = buffer
} else {
  // Copy properties from require('buffer')
  copyProps(buffer, exports)
  exports.Buffer = SafeBuffer
}

function SafeBuffer (arg, encodingOrOffset, length) {
  return Buffer(arg, encodingOrOffset, length)
}

// Copy static methods from Buffer
copyProps(Buffer, SafeBuffer)

SafeBuffer.from = function (arg, encodingOrOffset, length) {
  if (typeof arg === 'number') {
    throw new TypeError('Argument must not be a number')
  }
  return Buffer(arg, encodingOrOffset, length)
}

SafeBuffer.alloc = function (size, fill, encoding) {
  if (typeof size !== 'number') {
    throw new TypeError('Argument must be a number')
  }
  var buf = Buffer(size)
  if (fill !== undefined) {
    if (typeof encoding === 'string') {
      buf.fill(fill, encoding)
    } else {
      buf.fill(fill)
    }
  } else {
    buf.fill(0)
  }
  return buf
}

SafeBuffer.allocUnsafe = function (size) {
  if (typeof size !== 'number') {
    throw new TypeError('Argument must be a number')
  }
  return Buffer(size)
}

SafeBuffer.allocUnsafeSlow = function (size) {
  if (typeof size !== 'number') {
    throw new TypeError('Argument must be a number')
  }
  return buffer.SlowBuffer(size)
}


/***/ }),

/***/ "./node_modules/safer-buffer/safer.js":
/*!********************************************!*\
  !*** ./node_modules/safer-buffer/safer.js ***!
  \********************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {/* eslint-disable node/no-deprecated-api */



var buffer = __webpack_require__(/*! buffer */ "./node_modules/node-libs-browser/node_modules/buffer/index.js")
var Buffer = buffer.Buffer

var safer = {}

var key

for (key in buffer) {
  if (!buffer.hasOwnProperty(key)) continue
  if (key === 'SlowBuffer' || key === 'Buffer') continue
  safer[key] = buffer[key]
}

var Safer = safer.Buffer = {}
for (key in Buffer) {
  if (!Buffer.hasOwnProperty(key)) continue
  if (key === 'allocUnsafe' || key === 'allocUnsafeSlow') continue
  Safer[key] = Buffer[key]
}

safer.Buffer.prototype = Buffer.prototype

if (!Safer.from || Safer.from === Uint8Array.from) {
  Safer.from = function (value, encodingOrOffset, length) {
    if (typeof value === 'number') {
      throw new TypeError('The "value" argument must not be of type number. Received type ' + typeof value)
    }
    if (value && typeof value.length === 'undefined') {
      throw new TypeError('The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type ' + typeof value)
    }
    return Buffer(value, encodingOrOffset, length)
  }
}

if (!Safer.alloc) {
  Safer.alloc = function (size, fill, encoding) {
    if (typeof size !== 'number') {
      throw new TypeError('The "size" argument must be of type number. Received type ' + typeof size)
    }
    if (size < 0 || size >= 2 * (1 << 30)) {
      throw new RangeError('The value "' + size + '" is invalid for option "size"')
    }
    var buf = Buffer(size)
    if (!fill || fill.length === 0) {
      buf.fill(0)
    } else if (typeof encoding === 'string') {
      buf.fill(fill, encoding)
    } else {
      buf.fill(fill)
    }
    return buf
  }
}

if (!safer.kStringMaxLength) {
  try {
    safer.kStringMaxLength = process.binding('buffer').kStringMaxLength
  } catch (e) {
    // we can't determine kStringMaxLength in environments where process.binding
    // is unsupported, so let's not set it
  }
}

if (!safer.constants) {
  safer.constants = {
    MAX_LENGTH: safer.kMaxLength
  }
  if (safer.kStringMaxLength) {
    safer.constants.MAX_STRING_LENGTH = safer.kStringMaxLength
  }
}

module.exports = safer

/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(/*! ./../process/browser.js */ "./node_modules/process/browser.js")))

/***/ }),

/***/ "./node_modules/scheduler/cjs/scheduler-tracing.development.js":
/*!*********************************************************************!*\
  !*** ./node_modules/scheduler/cjs/scheduler-tracing.development.js ***!
  \*********************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v0.20.1
 * scheduler-tracing.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



if (true) {
  (function() {
'use strict';

var DEFAULT_THREAD_ID = 0; // Counters used to generate unique IDs.

var interactionIDCounter = 0;
var threadIDCounter = 0; // Set of currently traced interactions.
// Interactions "stack"–
// Meaning that newly traced interactions are appended to the previously active set.
// When an interaction goes out of scope, the previous set (if any) is restored.

exports.__interactionsRef = null; // Listener(s) to notify when interactions begin and end.

exports.__subscriberRef = null;

{
  exports.__interactionsRef = {
    current: new Set()
  };
  exports.__subscriberRef = {
    current: null
  };
}
function unstable_clear(callback) {

  var prevInteractions = exports.__interactionsRef.current;
  exports.__interactionsRef.current = new Set();

  try {
    return callback();
  } finally {
    exports.__interactionsRef.current = prevInteractions;
  }
}
function unstable_getCurrent() {
  {
    return exports.__interactionsRef.current;
  }
}
function unstable_getThreadID() {
  return ++threadIDCounter;
}
function unstable_trace(name, timestamp, callback) {
  var threadID = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : DEFAULT_THREAD_ID;

  var interaction = {
    __count: 1,
    id: interactionIDCounter++,
    name: name,
    timestamp: timestamp
  };
  var prevInteractions = exports.__interactionsRef.current; // Traced interactions should stack/accumulate.
  // To do that, clone the current interactions.
  // The previous set will be restored upon completion.

  var interactions = new Set(prevInteractions);
  interactions.add(interaction);
  exports.__interactionsRef.current = interactions;
  var subscriber = exports.__subscriberRef.current;
  var returnValue;

  try {
    if (subscriber !== null) {
      subscriber.onInteractionTraced(interaction);
    }
  } finally {
    try {
      if (subscriber !== null) {
        subscriber.onWorkStarted(interactions, threadID);
      }
    } finally {
      try {
        returnValue = callback();
      } finally {
        exports.__interactionsRef.current = prevInteractions;

        try {
          if (subscriber !== null) {
            subscriber.onWorkStopped(interactions, threadID);
          }
        } finally {
          interaction.__count--; // If no async work was scheduled for this interaction,
          // Notify subscribers that it's completed.

          if (subscriber !== null && interaction.__count === 0) {
            subscriber.onInteractionScheduledWorkCompleted(interaction);
          }
        }
      }
    }
  }

  return returnValue;
}
function unstable_wrap(callback) {
  var threadID = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : DEFAULT_THREAD_ID;

  var wrappedInteractions = exports.__interactionsRef.current;
  var subscriber = exports.__subscriberRef.current;

  if (subscriber !== null) {
    subscriber.onWorkScheduled(wrappedInteractions, threadID);
  } // Update the pending async work count for the current interactions.
  // Update after calling subscribers in case of error.


  wrappedInteractions.forEach(function (interaction) {
    interaction.__count++;
  });
  var hasRun = false;

  function wrapped() {
    var prevInteractions = exports.__interactionsRef.current;
    exports.__interactionsRef.current = wrappedInteractions;
    subscriber = exports.__subscriberRef.current;

    try {
      var returnValue;

      try {
        if (subscriber !== null) {
          subscriber.onWorkStarted(wrappedInteractions, threadID);
        }
      } finally {
        try {
          returnValue = callback.apply(undefined, arguments);
        } finally {
          exports.__interactionsRef.current = prevInteractions;

          if (subscriber !== null) {
            subscriber.onWorkStopped(wrappedInteractions, threadID);
          }
        }
      }

      return returnValue;
    } finally {
      if (!hasRun) {
        // We only expect a wrapped function to be executed once,
        // But in the event that it's executed more than once–
        // Only decrement the outstanding interaction counts once.
        hasRun = true; // Update pending async counts for all wrapped interactions.
        // If this was the last scheduled async work for any of them,
        // Mark them as completed.

        wrappedInteractions.forEach(function (interaction) {
          interaction.__count--;

          if (subscriber !== null && interaction.__count === 0) {
            subscriber.onInteractionScheduledWorkCompleted(interaction);
          }
        });
      }
    }
  }

  wrapped.cancel = function cancel() {
    subscriber = exports.__subscriberRef.current;

    try {
      if (subscriber !== null) {
        subscriber.onWorkCanceled(wrappedInteractions, threadID);
      }
    } finally {
      // Update pending async counts for all wrapped interactions.
      // If this was the last scheduled async work for any of them,
      // Mark them as completed.
      wrappedInteractions.forEach(function (interaction) {
        interaction.__count--;

        if (subscriber && interaction.__count === 0) {
          subscriber.onInteractionScheduledWorkCompleted(interaction);
        }
      });
    }
  };

  return wrapped;
}

var subscribers = null;

{
  subscribers = new Set();
}

function unstable_subscribe(subscriber) {
  {
    subscribers.add(subscriber);

    if (subscribers.size === 1) {
      exports.__subscriberRef.current = {
        onInteractionScheduledWorkCompleted: onInteractionScheduledWorkCompleted,
        onInteractionTraced: onInteractionTraced,
        onWorkCanceled: onWorkCanceled,
        onWorkScheduled: onWorkScheduled,
        onWorkStarted: onWorkStarted,
        onWorkStopped: onWorkStopped
      };
    }
  }
}
function unstable_unsubscribe(subscriber) {
  {
    subscribers.delete(subscriber);

    if (subscribers.size === 0) {
      exports.__subscriberRef.current = null;
    }
  }
}

function onInteractionTraced(interaction) {
  var didCatchError = false;
  var caughtError = null;
  subscribers.forEach(function (subscriber) {
    try {
      subscriber.onInteractionTraced(interaction);
    } catch (error) {
      if (!didCatchError) {
        didCatchError = true;
        caughtError = error;
      }
    }
  });

  if (didCatchError) {
    throw caughtError;
  }
}

function onInteractionScheduledWorkCompleted(interaction) {
  var didCatchError = false;
  var caughtError = null;
  subscribers.forEach(function (subscriber) {
    try {
      subscriber.onInteractionScheduledWorkCompleted(interaction);
    } catch (error) {
      if (!didCatchError) {
        didCatchError = true;
        caughtError = error;
      }
    }
  });

  if (didCatchError) {
    throw caughtError;
  }
}

function onWorkScheduled(interactions, threadID) {
  var didCatchError = false;
  var caughtError = null;
  subscribers.forEach(function (subscriber) {
    try {
      subscriber.onWorkScheduled(interactions, threadID);
    } catch (error) {
      if (!didCatchError) {
        didCatchError = true;
        caughtError = error;
      }
    }
  });

  if (didCatchError) {
    throw caughtError;
  }
}

function onWorkStarted(interactions, threadID) {
  var didCatchError = false;
  var caughtError = null;
  subscribers.forEach(function (subscriber) {
    try {
      subscriber.onWorkStarted(interactions, threadID);
    } catch (error) {
      if (!didCatchError) {
        didCatchError = true;
        caughtError = error;
      }
    }
  });

  if (didCatchError) {
    throw caughtError;
  }
}

function onWorkStopped(interactions, threadID) {
  var didCatchError = false;
  var caughtError = null;
  subscribers.forEach(function (subscriber) {
    try {
      subscriber.onWorkStopped(interactions, threadID);
    } catch (error) {
      if (!didCatchError) {
        didCatchError = true;
        caughtError = error;
      }
    }
  });

  if (didCatchError) {
    throw caughtError;
  }
}

function onWorkCanceled(interactions, threadID) {
  var didCatchError = false;
  var caughtError = null;
  subscribers.forEach(function (subscriber) {
    try {
      subscriber.onWorkCanceled(interactions, threadID);
    } catch (error) {
      if (!didCatchError) {
        didCatchError = true;
        caughtError = error;
      }
    }
  });

  if (didCatchError) {
    throw caughtError;
  }
}

exports.unstable_clear = unstable_clear;
exports.unstable_getCurrent = unstable_getCurrent;
exports.unstable_getThreadID = unstable_getThreadID;
exports.unstable_subscribe = unstable_subscribe;
exports.unstable_trace = unstable_trace;
exports.unstable_unsubscribe = unstable_unsubscribe;
exports.unstable_wrap = unstable_wrap;
  })();
}


/***/ }),

/***/ "./node_modules/scheduler/cjs/scheduler.development.js":
/*!*************************************************************!*\
  !*** ./node_modules/scheduler/cjs/scheduler.development.js ***!
  \*************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v0.20.1
 * scheduler.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



if (true) {
  (function() {
'use strict';

var enableSchedulerDebugging = false;
var enableProfiling = true;

var requestHostCallback;
var requestHostTimeout;
var cancelHostTimeout;
var requestPaint;
var hasPerformanceNow = typeof performance === 'object' && typeof performance.now === 'function';

if (hasPerformanceNow) {
  var localPerformance = performance;

  exports.unstable_now = function () {
    return localPerformance.now();
  };
} else {
  var localDate = Date;
  var initialTime = localDate.now();

  exports.unstable_now = function () {
    return localDate.now() - initialTime;
  };
}

if ( // If Scheduler runs in a non-DOM environment, it falls back to a naive
// implementation using setTimeout.
typeof window === 'undefined' || // Check if MessageChannel is supported, too.
typeof MessageChannel !== 'function') {
  // If this accidentally gets imported in a non-browser environment, e.g. JavaScriptCore,
  // fallback to a naive implementation.
  var _callback = null;
  var _timeoutID = null;

  var _flushCallback = function () {
    if (_callback !== null) {
      try {
        var currentTime = exports.unstable_now();
        var hasRemainingTime = true;

        _callback(hasRemainingTime, currentTime);

        _callback = null;
      } catch (e) {
        setTimeout(_flushCallback, 0);
        throw e;
      }
    }
  };

  requestHostCallback = function (cb) {
    if (_callback !== null) {
      // Protect against re-entrancy.
      setTimeout(requestHostCallback, 0, cb);
    } else {
      _callback = cb;
      setTimeout(_flushCallback, 0);
    }
  };

  requestHostTimeout = function (cb, ms) {
    _timeoutID = setTimeout(cb, ms);
  };

  cancelHostTimeout = function () {
    clearTimeout(_timeoutID);
  };

  exports.unstable_shouldYield = function () {
    return false;
  };

  requestPaint = exports.unstable_forceFrameRate = function () {};
} else {
  // Capture local references to native APIs, in case a polyfill overrides them.
  var _setTimeout = window.setTimeout;
  var _clearTimeout = window.clearTimeout;

  if (typeof console !== 'undefined') {
    // TODO: Scheduler no longer requires these methods to be polyfilled. But
    // maybe we want to continue warning if they don't exist, to preserve the
    // option to rely on it in the future?
    var requestAnimationFrame = window.requestAnimationFrame;
    var cancelAnimationFrame = window.cancelAnimationFrame;

    if (typeof requestAnimationFrame !== 'function') {
      // Using console['error'] to evade Babel and ESLint
      console['error']("This browser doesn't support requestAnimationFrame. " + 'Make sure that you load a ' + 'polyfill in older browsers. https://reactjs.org/link/react-polyfills');
    }

    if (typeof cancelAnimationFrame !== 'function') {
      // Using console['error'] to evade Babel and ESLint
      console['error']("This browser doesn't support cancelAnimationFrame. " + 'Make sure that you load a ' + 'polyfill in older browsers. https://reactjs.org/link/react-polyfills');
    }
  }

  var isMessageLoopRunning = false;
  var scheduledHostCallback = null;
  var taskTimeoutID = -1; // Scheduler periodically yields in case there is other work on the main
  // thread, like user events. By default, it yields multiple times per frame.
  // It does not attempt to align with frame boundaries, since most tasks don't
  // need to be frame aligned; for those that do, use requestAnimationFrame.

  var yieldInterval = 5;
  var deadline = 0; // TODO: Make this configurable

  {
    // `isInputPending` is not available. Since we have no way of knowing if
    // there's pending input, always yield at the end of the frame.
    exports.unstable_shouldYield = function () {
      return exports.unstable_now() >= deadline;
    }; // Since we yield every frame regardless, `requestPaint` has no effect.


    requestPaint = function () {};
  }

  exports.unstable_forceFrameRate = function (fps) {
    if (fps < 0 || fps > 125) {
      // Using console['error'] to evade Babel and ESLint
      console['error']('forceFrameRate takes a positive int between 0 and 125, ' + 'forcing frame rates higher than 125 fps is not supported');
      return;
    }

    if (fps > 0) {
      yieldInterval = Math.floor(1000 / fps);
    } else {
      // reset the framerate
      yieldInterval = 5;
    }
  };

  var performWorkUntilDeadline = function () {
    if (scheduledHostCallback !== null) {
      var currentTime = exports.unstable_now(); // Yield after `yieldInterval` ms, regardless of where we are in the vsync
      // cycle. This means there's always time remaining at the beginning of
      // the message event.

      deadline = currentTime + yieldInterval;
      var hasTimeRemaining = true;

      try {
        var hasMoreWork = scheduledHostCallback(hasTimeRemaining, currentTime);

        if (!hasMoreWork) {
          isMessageLoopRunning = false;
          scheduledHostCallback = null;
        } else {
          // If there's more work, schedule the next message event at the end
          // of the preceding one.
          port.postMessage(null);
        }
      } catch (error) {
        // If a scheduler task throws, exit the current browser task so the
        // error can be observed.
        port.postMessage(null);
        throw error;
      }
    } else {
      isMessageLoopRunning = false;
    } // Yielding to the browser will give it a chance to paint, so we can
  };

  var channel = new MessageChannel();
  var port = channel.port2;
  channel.port1.onmessage = performWorkUntilDeadline;

  requestHostCallback = function (callback) {
    scheduledHostCallback = callback;

    if (!isMessageLoopRunning) {
      isMessageLoopRunning = true;
      port.postMessage(null);
    }
  };

  requestHostTimeout = function (callback, ms) {
    taskTimeoutID = _setTimeout(function () {
      callback(exports.unstable_now());
    }, ms);
  };

  cancelHostTimeout = function () {
    _clearTimeout(taskTimeoutID);

    taskTimeoutID = -1;
  };
}

function push(heap, node) {
  var index = heap.length;
  heap.push(node);
  siftUp(heap, node, index);
}
function peek(heap) {
  var first = heap[0];
  return first === undefined ? null : first;
}
function pop(heap) {
  var first = heap[0];

  if (first !== undefined) {
    var last = heap.pop();

    if (last !== first) {
      heap[0] = last;
      siftDown(heap, last, 0);
    }

    return first;
  } else {
    return null;
  }
}

function siftUp(heap, node, i) {
  var index = i;

  while (true) {
    var parentIndex = index - 1 >>> 1;
    var parent = heap[parentIndex];

    if (parent !== undefined && compare(parent, node) > 0) {
      // The parent is larger. Swap positions.
      heap[parentIndex] = node;
      heap[index] = parent;
      index = parentIndex;
    } else {
      // The parent is smaller. Exit.
      return;
    }
  }
}

function siftDown(heap, node, i) {
  var index = i;
  var length = heap.length;

  while (index < length) {
    var leftIndex = (index + 1) * 2 - 1;
    var left = heap[leftIndex];
    var rightIndex = leftIndex + 1;
    var right = heap[rightIndex]; // If the left or right node is smaller, swap with the smaller of those.

    if (left !== undefined && compare(left, node) < 0) {
      if (right !== undefined && compare(right, left) < 0) {
        heap[index] = right;
        heap[rightIndex] = node;
        index = rightIndex;
      } else {
        heap[index] = left;
        heap[leftIndex] = node;
        index = leftIndex;
      }
    } else if (right !== undefined && compare(right, node) < 0) {
      heap[index] = right;
      heap[rightIndex] = node;
      index = rightIndex;
    } else {
      // Neither child is smaller. Exit.
      return;
    }
  }
}

function compare(a, b) {
  // Compare sort index first, then task id.
  var diff = a.sortIndex - b.sortIndex;
  return diff !== 0 ? diff : a.id - b.id;
}

// TODO: Use symbols?
var NoPriority = 0;
var ImmediatePriority = 1;
var UserBlockingPriority = 2;
var NormalPriority = 3;
var LowPriority = 4;
var IdlePriority = 5;

var runIdCounter = 0;
var mainThreadIdCounter = 0;
var profilingStateSize = 4;
var sharedProfilingBuffer =  // $FlowFixMe Flow doesn't know about SharedArrayBuffer
typeof SharedArrayBuffer === 'function' ? new SharedArrayBuffer(profilingStateSize * Int32Array.BYTES_PER_ELEMENT) : // $FlowFixMe Flow doesn't know about ArrayBuffer
typeof ArrayBuffer === 'function' ? new ArrayBuffer(profilingStateSize * Int32Array.BYTES_PER_ELEMENT) : null // Don't crash the init path on IE9
;
var profilingState =  sharedProfilingBuffer !== null ? new Int32Array(sharedProfilingBuffer) : []; // We can't read this but it helps save bytes for null checks

var PRIORITY = 0;
var CURRENT_TASK_ID = 1;
var CURRENT_RUN_ID = 2;
var QUEUE_SIZE = 3;

{
  profilingState[PRIORITY] = NoPriority; // This is maintained with a counter, because the size of the priority queue
  // array might include canceled tasks.

  profilingState[QUEUE_SIZE] = 0;
  profilingState[CURRENT_TASK_ID] = 0;
} // Bytes per element is 4


var INITIAL_EVENT_LOG_SIZE = 131072;
var MAX_EVENT_LOG_SIZE = 524288; // Equivalent to 2 megabytes

var eventLogSize = 0;
var eventLogBuffer = null;
var eventLog = null;
var eventLogIndex = 0;
var TaskStartEvent = 1;
var TaskCompleteEvent = 2;
var TaskErrorEvent = 3;
var TaskCancelEvent = 4;
var TaskRunEvent = 5;
var TaskYieldEvent = 6;
var SchedulerSuspendEvent = 7;
var SchedulerResumeEvent = 8;

function logEvent(entries) {
  if (eventLog !== null) {
    var offset = eventLogIndex;
    eventLogIndex += entries.length;

    if (eventLogIndex + 1 > eventLogSize) {
      eventLogSize *= 2;

      if (eventLogSize > MAX_EVENT_LOG_SIZE) {
        // Using console['error'] to evade Babel and ESLint
        console['error']("Scheduler Profiling: Event log exceeded maximum size. Don't " + 'forget to call `stopLoggingProfilingEvents()`.');
        stopLoggingProfilingEvents();
        return;
      }

      var newEventLog = new Int32Array(eventLogSize * 4);
      newEventLog.set(eventLog);
      eventLogBuffer = newEventLog.buffer;
      eventLog = newEventLog;
    }

    eventLog.set(entries, offset);
  }
}

function startLoggingProfilingEvents() {
  eventLogSize = INITIAL_EVENT_LOG_SIZE;
  eventLogBuffer = new ArrayBuffer(eventLogSize * 4);
  eventLog = new Int32Array(eventLogBuffer);
  eventLogIndex = 0;
}
function stopLoggingProfilingEvents() {
  var buffer = eventLogBuffer;
  eventLogSize = 0;
  eventLogBuffer = null;
  eventLog = null;
  eventLogIndex = 0;
  return buffer;
}
function markTaskStart(task, ms) {
  {
    profilingState[QUEUE_SIZE]++;

    if (eventLog !== null) {
      // performance.now returns a float, representing milliseconds. When the
      // event is logged, it's coerced to an int. Convert to microseconds to
      // maintain extra degrees of precision.
      logEvent([TaskStartEvent, ms * 1000, task.id, task.priorityLevel]);
    }
  }
}
function markTaskCompleted(task, ms) {
  {
    profilingState[PRIORITY] = NoPriority;
    profilingState[CURRENT_TASK_ID] = 0;
    profilingState[QUEUE_SIZE]--;

    if (eventLog !== null) {
      logEvent([TaskCompleteEvent, ms * 1000, task.id]);
    }
  }
}
function markTaskCanceled(task, ms) {
  {
    profilingState[QUEUE_SIZE]--;

    if (eventLog !== null) {
      logEvent([TaskCancelEvent, ms * 1000, task.id]);
    }
  }
}
function markTaskErrored(task, ms) {
  {
    profilingState[PRIORITY] = NoPriority;
    profilingState[CURRENT_TASK_ID] = 0;
    profilingState[QUEUE_SIZE]--;

    if (eventLog !== null) {
      logEvent([TaskErrorEvent, ms * 1000, task.id]);
    }
  }
}
function markTaskRun(task, ms) {
  {
    runIdCounter++;
    profilingState[PRIORITY] = task.priorityLevel;
    profilingState[CURRENT_TASK_ID] = task.id;
    profilingState[CURRENT_RUN_ID] = runIdCounter;

    if (eventLog !== null) {
      logEvent([TaskRunEvent, ms * 1000, task.id, runIdCounter]);
    }
  }
}
function markTaskYield(task, ms) {
  {
    profilingState[PRIORITY] = NoPriority;
    profilingState[CURRENT_TASK_ID] = 0;
    profilingState[CURRENT_RUN_ID] = 0;

    if (eventLog !== null) {
      logEvent([TaskYieldEvent, ms * 1000, task.id, runIdCounter]);
    }
  }
}
function markSchedulerSuspended(ms) {
  {
    mainThreadIdCounter++;

    if (eventLog !== null) {
      logEvent([SchedulerSuspendEvent, ms * 1000, mainThreadIdCounter]);
    }
  }
}
function markSchedulerUnsuspended(ms) {
  {
    if (eventLog !== null) {
      logEvent([SchedulerResumeEvent, ms * 1000, mainThreadIdCounter]);
    }
  }
}

/* eslint-disable no-var */
// Math.pow(2, 30) - 1
// 0b111111111111111111111111111111

var maxSigned31BitInt = 1073741823; // Times out immediately

var IMMEDIATE_PRIORITY_TIMEOUT = -1; // Eventually times out

var USER_BLOCKING_PRIORITY_TIMEOUT = 250;
var NORMAL_PRIORITY_TIMEOUT = 5000;
var LOW_PRIORITY_TIMEOUT = 10000; // Never times out

var IDLE_PRIORITY_TIMEOUT = maxSigned31BitInt; // Tasks are stored on a min heap

var taskQueue = [];
var timerQueue = []; // Incrementing id counter. Used to maintain insertion order.

var taskIdCounter = 1; // Pausing the scheduler is useful for debugging.
var currentTask = null;
var currentPriorityLevel = NormalPriority; // This is set while performing work, to prevent re-entrancy.

var isPerformingWork = false;
var isHostCallbackScheduled = false;
var isHostTimeoutScheduled = false;

function advanceTimers(currentTime) {
  // Check for tasks that are no longer delayed and add them to the queue.
  var timer = peek(timerQueue);

  while (timer !== null) {
    if (timer.callback === null) {
      // Timer was cancelled.
      pop(timerQueue);
    } else if (timer.startTime <= currentTime) {
      // Timer fired. Transfer to the task queue.
      pop(timerQueue);
      timer.sortIndex = timer.expirationTime;
      push(taskQueue, timer);

      {
        markTaskStart(timer, currentTime);
        timer.isQueued = true;
      }
    } else {
      // Remaining timers are pending.
      return;
    }

    timer = peek(timerQueue);
  }
}

function handleTimeout(currentTime) {
  isHostTimeoutScheduled = false;
  advanceTimers(currentTime);

  if (!isHostCallbackScheduled) {
    if (peek(taskQueue) !== null) {
      isHostCallbackScheduled = true;
      requestHostCallback(flushWork);
    } else {
      var firstTimer = peek(timerQueue);

      if (firstTimer !== null) {
        requestHostTimeout(handleTimeout, firstTimer.startTime - currentTime);
      }
    }
  }
}

function flushWork(hasTimeRemaining, initialTime) {
  {
    markSchedulerUnsuspended(initialTime);
  } // We'll need a host callback the next time work is scheduled.


  isHostCallbackScheduled = false;

  if (isHostTimeoutScheduled) {
    // We scheduled a timeout but it's no longer needed. Cancel it.
    isHostTimeoutScheduled = false;
    cancelHostTimeout();
  }

  isPerformingWork = true;
  var previousPriorityLevel = currentPriorityLevel;

  try {
    if (enableProfiling) {
      try {
        return workLoop(hasTimeRemaining, initialTime);
      } catch (error) {
        if (currentTask !== null) {
          var currentTime = exports.unstable_now();
          markTaskErrored(currentTask, currentTime);
          currentTask.isQueued = false;
        }

        throw error;
      }
    } else {
      // No catch in prod code path.
      return workLoop(hasTimeRemaining, initialTime);
    }
  } finally {
    currentTask = null;
    currentPriorityLevel = previousPriorityLevel;
    isPerformingWork = false;

    {
      var _currentTime = exports.unstable_now();

      markSchedulerSuspended(_currentTime);
    }
  }
}

function workLoop(hasTimeRemaining, initialTime) {
  var currentTime = initialTime;
  advanceTimers(currentTime);
  currentTask = peek(taskQueue);

  while (currentTask !== null && !(enableSchedulerDebugging )) {
    if (currentTask.expirationTime > currentTime && (!hasTimeRemaining || exports.unstable_shouldYield())) {
      // This currentTask hasn't expired, and we've reached the deadline.
      break;
    }

    var callback = currentTask.callback;

    if (typeof callback === 'function') {
      currentTask.callback = null;
      currentPriorityLevel = currentTask.priorityLevel;
      var didUserCallbackTimeout = currentTask.expirationTime <= currentTime;
      markTaskRun(currentTask, currentTime);
      var continuationCallback = callback(didUserCallbackTimeout);
      currentTime = exports.unstable_now();

      if (typeof continuationCallback === 'function') {
        currentTask.callback = continuationCallback;
        markTaskYield(currentTask, currentTime);
      } else {
        {
          markTaskCompleted(currentTask, currentTime);
          currentTask.isQueued = false;
        }

        if (currentTask === peek(taskQueue)) {
          pop(taskQueue);
        }
      }

      advanceTimers(currentTime);
    } else {
      pop(taskQueue);
    }

    currentTask = peek(taskQueue);
  } // Return whether there's additional work


  if (currentTask !== null) {
    return true;
  } else {
    var firstTimer = peek(timerQueue);

    if (firstTimer !== null) {
      requestHostTimeout(handleTimeout, firstTimer.startTime - currentTime);
    }

    return false;
  }
}

function unstable_runWithPriority(priorityLevel, eventHandler) {
  switch (priorityLevel) {
    case ImmediatePriority:
    case UserBlockingPriority:
    case NormalPriority:
    case LowPriority:
    case IdlePriority:
      break;

    default:
      priorityLevel = NormalPriority;
  }

  var previousPriorityLevel = currentPriorityLevel;
  currentPriorityLevel = priorityLevel;

  try {
    return eventHandler();
  } finally {
    currentPriorityLevel = previousPriorityLevel;
  }
}

function unstable_next(eventHandler) {
  var priorityLevel;

  switch (currentPriorityLevel) {
    case ImmediatePriority:
    case UserBlockingPriority:
    case NormalPriority:
      // Shift down to normal priority
      priorityLevel = NormalPriority;
      break;

    default:
      // Anything lower than normal priority should remain at the current level.
      priorityLevel = currentPriorityLevel;
      break;
  }

  var previousPriorityLevel = currentPriorityLevel;
  currentPriorityLevel = priorityLevel;

  try {
    return eventHandler();
  } finally {
    currentPriorityLevel = previousPriorityLevel;
  }
}

function unstable_wrapCallback(callback) {
  var parentPriorityLevel = currentPriorityLevel;
  return function () {
    // This is a fork of runWithPriority, inlined for performance.
    var previousPriorityLevel = currentPriorityLevel;
    currentPriorityLevel = parentPriorityLevel;

    try {
      return callback.apply(this, arguments);
    } finally {
      currentPriorityLevel = previousPriorityLevel;
    }
  };
}

function unstable_scheduleCallback(priorityLevel, callback, options) {
  var currentTime = exports.unstable_now();
  var startTime;

  if (typeof options === 'object' && options !== null) {
    var delay = options.delay;

    if (typeof delay === 'number' && delay > 0) {
      startTime = currentTime + delay;
    } else {
      startTime = currentTime;
    }
  } else {
    startTime = currentTime;
  }

  var timeout;

  switch (priorityLevel) {
    case ImmediatePriority:
      timeout = IMMEDIATE_PRIORITY_TIMEOUT;
      break;

    case UserBlockingPriority:
      timeout = USER_BLOCKING_PRIORITY_TIMEOUT;
      break;

    case IdlePriority:
      timeout = IDLE_PRIORITY_TIMEOUT;
      break;

    case LowPriority:
      timeout = LOW_PRIORITY_TIMEOUT;
      break;

    case NormalPriority:
    default:
      timeout = NORMAL_PRIORITY_TIMEOUT;
      break;
  }

  var expirationTime = startTime + timeout;
  var newTask = {
    id: taskIdCounter++,
    callback: callback,
    priorityLevel: priorityLevel,
    startTime: startTime,
    expirationTime: expirationTime,
    sortIndex: -1
  };

  {
    newTask.isQueued = false;
  }

  if (startTime > currentTime) {
    // This is a delayed task.
    newTask.sortIndex = startTime;
    push(timerQueue, newTask);

    if (peek(taskQueue) === null && newTask === peek(timerQueue)) {
      // All tasks are delayed, and this is the task with the earliest delay.
      if (isHostTimeoutScheduled) {
        // Cancel an existing timeout.
        cancelHostTimeout();
      } else {
        isHostTimeoutScheduled = true;
      } // Schedule a timeout.


      requestHostTimeout(handleTimeout, startTime - currentTime);
    }
  } else {
    newTask.sortIndex = expirationTime;
    push(taskQueue, newTask);

    {
      markTaskStart(newTask, currentTime);
      newTask.isQueued = true;
    } // Schedule a host callback, if needed. If we're already performing work,
    // wait until the next time we yield.


    if (!isHostCallbackScheduled && !isPerformingWork) {
      isHostCallbackScheduled = true;
      requestHostCallback(flushWork);
    }
  }

  return newTask;
}

function unstable_pauseExecution() {
}

function unstable_continueExecution() {

  if (!isHostCallbackScheduled && !isPerformingWork) {
    isHostCallbackScheduled = true;
    requestHostCallback(flushWork);
  }
}

function unstable_getFirstCallbackNode() {
  return peek(taskQueue);
}

function unstable_cancelCallback(task) {
  {
    if (task.isQueued) {
      var currentTime = exports.unstable_now();
      markTaskCanceled(task, currentTime);
      task.isQueued = false;
    }
  } // Null out the callback to indicate the task has been canceled. (Can't
  // remove from the queue because you can't remove arbitrary nodes from an
  // array based heap, only the first one.)


  task.callback = null;
}

function unstable_getCurrentPriorityLevel() {
  return currentPriorityLevel;
}

var unstable_requestPaint = requestPaint;
var unstable_Profiling =  {
  startLoggingProfilingEvents: startLoggingProfilingEvents,
  stopLoggingProfilingEvents: stopLoggingProfilingEvents,
  sharedProfilingBuffer: sharedProfilingBuffer
} ;

exports.unstable_IdlePriority = IdlePriority;
exports.unstable_ImmediatePriority = ImmediatePriority;
exports.unstable_LowPriority = LowPriority;
exports.unstable_NormalPriority = NormalPriority;
exports.unstable_Profiling = unstable_Profiling;
exports.unstable_UserBlockingPriority = UserBlockingPriority;
exports.unstable_cancelCallback = unstable_cancelCallback;
exports.unstable_continueExecution = unstable_continueExecution;
exports.unstable_getCurrentPriorityLevel = unstable_getCurrentPriorityLevel;
exports.unstable_getFirstCallbackNode = unstable_getFirstCallbackNode;
exports.unstable_next = unstable_next;
exports.unstable_pauseExecution = unstable_pauseExecution;
exports.unstable_requestPaint = unstable_requestPaint;
exports.unstable_runWithPriority = unstable_runWithPriority;
exports.unstable_scheduleCallback = unstable_scheduleCallback;
exports.unstable_wrapCallback = unstable_wrapCallback;
  })();
}


/***/ }),

/***/ "./node_modules/scheduler/index.js":
/*!*****************************************!*\
  !*** ./node_modules/scheduler/index.js ***!
  \*****************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (false) {} else {
  module.exports = __webpack_require__(/*! ./cjs/scheduler.development.js */ "./node_modules/scheduler/cjs/scheduler.development.js");
}


/***/ }),

/***/ "./node_modules/scheduler/tracing.js":
/*!*******************************************!*\
  !*** ./node_modules/scheduler/tracing.js ***!
  \*******************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (false) {} else {
  module.exports = __webpack_require__(/*! ./cjs/scheduler-tracing.development.js */ "./node_modules/scheduler/cjs/scheduler-tracing.development.js");
}


/***/ }),

/***/ "./node_modules/setimmediate/setImmediate.js":
/*!***************************************************!*\
  !*** ./node_modules/setimmediate/setImmediate.js ***!
  \***************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global, process) {(function (global, undefined) {
    "use strict";

    if (global.setImmediate) {
        return;
    }

    var nextHandle = 1; // Spec says greater than zero
    var tasksByHandle = {};
    var currentlyRunningATask = false;
    var doc = global.document;
    var registerImmediate;

    function setImmediate(callback) {
      // Callback can either be a function or a string
      if (typeof callback !== "function") {
        callback = new Function("" + callback);
      }
      // Copy function arguments
      var args = new Array(arguments.length - 1);
      for (var i = 0; i < args.length; i++) {
          args[i] = arguments[i + 1];
      }
      // Store and register the task
      var task = { callback: callback, args: args };
      tasksByHandle[nextHandle] = task;
      registerImmediate(nextHandle);
      return nextHandle++;
    }

    function clearImmediate(handle) {
        delete tasksByHandle[handle];
    }

    function run(task) {
        var callback = task.callback;
        var args = task.args;
        switch (args.length) {
        case 0:
            callback();
            break;
        case 1:
            callback(args[0]);
            break;
        case 2:
            callback(args[0], args[1]);
            break;
        case 3:
            callback(args[0], args[1], args[2]);
            break;
        default:
            callback.apply(undefined, args);
            break;
        }
    }

    function runIfPresent(handle) {
        // From the spec: "Wait until any invocations of this algorithm started before this one have completed."
        // So if we're currently running a task, we'll need to delay this invocation.
        if (currentlyRunningATask) {
            // Delay by doing a setTimeout. setImmediate was tried instead, but in Firefox 7 it generated a
            // "too much recursion" error.
            setTimeout(runIfPresent, 0, handle);
        } else {
            var task = tasksByHandle[handle];
            if (task) {
                currentlyRunningATask = true;
                try {
                    run(task);
                } finally {
                    clearImmediate(handle);
                    currentlyRunningATask = false;
                }
            }
        }
    }

    function installNextTickImplementation() {
        registerImmediate = function(handle) {
            process.nextTick(function () { runIfPresent(handle); });
        };
    }

    function canUsePostMessage() {
        // The test against `importScripts` prevents this implementation from being installed inside a web worker,
        // where `global.postMessage` means something completely different and can't be used for this purpose.
        if (global.postMessage && !global.importScripts) {
            var postMessageIsAsynchronous = true;
            var oldOnMessage = global.onmessage;
            global.onmessage = function() {
                postMessageIsAsynchronous = false;
            };
            global.postMessage("", "*");
            global.onmessage = oldOnMessage;
            return postMessageIsAsynchronous;
        }
    }

    function installPostMessageImplementation() {
        // Installs an event handler on `global` for the `message` event: see
        // * https://developer.mozilla.org/en/DOM/window.postMessage
        // * http://www.whatwg.org/specs/web-apps/current-work/multipage/comms.html#crossDocumentMessages

        var messagePrefix = "setImmediate$" + Math.random() + "$";
        var onGlobalMessage = function(event) {
            if (event.source === global &&
                typeof event.data === "string" &&
                event.data.indexOf(messagePrefix) === 0) {
                runIfPresent(+event.data.slice(messagePrefix.length));
            }
        };

        if (global.addEventListener) {
            global.addEventListener("message", onGlobalMessage, false);
        } else {
            global.attachEvent("onmessage", onGlobalMessage);
        }

        registerImmediate = function(handle) {
            global.postMessage(messagePrefix + handle, "*");
        };
    }

    function installMessageChannelImplementation() {
        var channel = new MessageChannel();
        channel.port1.onmessage = function(event) {
            var handle = event.data;
            runIfPresent(handle);
        };

        registerImmediate = function(handle) {
            channel.port2.postMessage(handle);
        };
    }

    function installReadyStateChangeImplementation() {
        var html = doc.documentElement;
        registerImmediate = function(handle) {
            // Create a <script> element; its readystatechange event will be fired asynchronously once it is inserted
            // into the document. Do so, thus queuing up the task. Remember to clean up once it's been called.
            var script = doc.createElement("script");
            script.onreadystatechange = function () {
                runIfPresent(handle);
                script.onreadystatechange = null;
                html.removeChild(script);
                script = null;
            };
            html.appendChild(script);
        };
    }

    function installSetTimeoutImplementation() {
        registerImmediate = function(handle) {
            setTimeout(runIfPresent, 0, handle);
        };
    }

    // If supported, we should attach to the prototype of global, since that is where setTimeout et al. live.
    var attachTo = Object.getPrototypeOf && Object.getPrototypeOf(global);
    attachTo = attachTo && attachTo.setTimeout ? attachTo : global;

    // Don't get fooled by e.g. browserify environments.
    if ({}.toString.call(global.process) === "[object process]") {
        // For Node.js before 0.9
        installNextTickImplementation();

    } else if (canUsePostMessage()) {
        // For non-IE10 modern browsers
        installPostMessageImplementation();

    } else if (global.MessageChannel) {
        // For web workers, where supported
        installMessageChannelImplementation();

    } else if (doc && "onreadystatechange" in doc.createElement("script")) {
        // For IE 6–8
        installReadyStateChangeImplementation();

    } else {
        // For older browsers
        installSetTimeoutImplementation();
    }

    attachTo.setImmediate = setImmediate;
    attachTo.clearImmediate = clearImmediate;
}(typeof self === "undefined" ? typeof global === "undefined" ? this : global : self));

/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(/*! ./../webpack/buildin/global.js */ "./node_modules/webpack/buildin/global.js"), __webpack_require__(/*! ./../process/browser.js */ "./node_modules/process/browser.js")))

/***/ }),

/***/ "./node_modules/sha.js/hash.js":
/*!*************************************!*\
  !*** ./node_modules/sha.js/hash.js ***!
  \*************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var Buffer = __webpack_require__(/*! safe-buffer */ "./node_modules/safe-buffer/index.js").Buffer

// prototype class for hash functions
function Hash (blockSize, finalSize) {
  this._block = Buffer.alloc(blockSize)
  this._finalSize = finalSize
  this._blockSize = blockSize
  this._len = 0
}

Hash.prototype.update = function (data, enc) {
  if (typeof data === 'string') {
    enc = enc || 'utf8'
    data = Buffer.from(data, enc)
  }

  var block = this._block
  var blockSize = this._blockSize
  var length = data.length
  var accum = this._len

  for (var offset = 0; offset < length;) {
    var assigned = accum % blockSize
    var remainder = Math.min(length - offset, blockSize - assigned)

    for (var i = 0; i < remainder; i++) {
      block[assigned + i] = data[offset + i]
    }

    accum += remainder
    offset += remainder

    if ((accum % blockSize) === 0) {
      this._update(block)
    }
  }

  this._len += length
  return this
}

Hash.prototype.digest = function (enc) {
  var rem = this._len % this._blockSize

  this._block[rem] = 0x80

  // zero (rem + 1) trailing bits, where (rem + 1) is the smallest
  // non-negative solution to the equation (length + 1 + (rem + 1)) === finalSize mod blockSize
  this._block.fill(0, rem + 1)

  if (rem >= this._finalSize) {
    this._update(this._block)
    this._block.fill(0)
  }

  var bits = this._len * 8

  // uint32
  if (bits <= 0xffffffff) {
    this._block.writeUInt32BE(bits, this._blockSize - 4)

  // uint64
  } else {
    var lowBits = (bits & 0xffffffff) >>> 0
    var highBits = (bits - lowBits) / 0x100000000

    this._block.writeUInt32BE(highBits, this._blockSize - 8)
    this._block.writeUInt32BE(lowBits, this._blockSize - 4)
  }

  this._update(this._block)
  var hash = this._hash()

  return enc ? hash.toString(enc) : hash
}

Hash.prototype._update = function () {
  throw new Error('_update must be implemented by subclass')
}

module.exports = Hash


/***/ }),

/***/ "./node_modules/sha.js/index.js":
/*!**************************************!*\
  !*** ./node_modules/sha.js/index.js ***!
  \**************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var exports = module.exports = function SHA (algorithm) {
  algorithm = algorithm.toLowerCase()

  var Algorithm = exports[algorithm]
  if (!Algorithm) throw new Error(algorithm + ' is not supported (we accept pull requests)')

  return new Algorithm()
}

exports.sha = __webpack_require__(/*! ./sha */ "./node_modules/sha.js/sha.js")
exports.sha1 = __webpack_require__(/*! ./sha1 */ "./node_modules/sha.js/sha1.js")
exports.sha224 = __webpack_require__(/*! ./sha224 */ "./node_modules/sha.js/sha224.js")
exports.sha256 = __webpack_require__(/*! ./sha256 */ "./node_modules/sha.js/sha256.js")
exports.sha384 = __webpack_require__(/*! ./sha384 */ "./node_modules/sha.js/sha384.js")
exports.sha512 = __webpack_require__(/*! ./sha512 */ "./node_modules/sha.js/sha512.js")


/***/ }),

/***/ "./node_modules/sha.js/sha.js":
/*!************************************!*\
  !*** ./node_modules/sha.js/sha.js ***!
  \************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

/*
 * A JavaScript implementation of the Secure Hash Algorithm, SHA-0, as defined
 * in FIPS PUB 180-1
 * This source code is derived from sha1.js of the same repository.
 * The difference between SHA-0 and SHA-1 is just a bitwise rotate left
 * operation was added.
 */

var inherits = __webpack_require__(/*! inherits */ "./node_modules/inherits/inherits_browser.js")
var Hash = __webpack_require__(/*! ./hash */ "./node_modules/sha.js/hash.js")
var Buffer = __webpack_require__(/*! safe-buffer */ "./node_modules/safe-buffer/index.js").Buffer

var K = [
  0x5a827999, 0x6ed9eba1, 0x8f1bbcdc | 0, 0xca62c1d6 | 0
]

var W = new Array(80)

function Sha () {
  this.init()
  this._w = W

  Hash.call(this, 64, 56)
}

inherits(Sha, Hash)

Sha.prototype.init = function () {
  this._a = 0x67452301
  this._b = 0xefcdab89
  this._c = 0x98badcfe
  this._d = 0x10325476
  this._e = 0xc3d2e1f0

  return this
}

function rotl5 (num) {
  return (num << 5) | (num >>> 27)
}

function rotl30 (num) {
  return (num << 30) | (num >>> 2)
}

function ft (s, b, c, d) {
  if (s === 0) return (b & c) | ((~b) & d)
  if (s === 2) return (b & c) | (b & d) | (c & d)
  return b ^ c ^ d
}

Sha.prototype._update = function (M) {
  var W = this._w

  var a = this._a | 0
  var b = this._b | 0
  var c = this._c | 0
  var d = this._d | 0
  var e = this._e | 0

  for (var i = 0; i < 16; ++i) W[i] = M.readInt32BE(i * 4)
  for (; i < 80; ++i) W[i] = W[i - 3] ^ W[i - 8] ^ W[i - 14] ^ W[i - 16]

  for (var j = 0; j < 80; ++j) {
    var s = ~~(j / 20)
    var t = (rotl5(a) + ft(s, b, c, d) + e + W[j] + K[s]) | 0

    e = d
    d = c
    c = rotl30(b)
    b = a
    a = t
  }

  this._a = (a + this._a) | 0
  this._b = (b + this._b) | 0
  this._c = (c + this._c) | 0
  this._d = (d + this._d) | 0
  this._e = (e + this._e) | 0
}

Sha.prototype._hash = function () {
  var H = Buffer.allocUnsafe(20)

  H.writeInt32BE(this._a | 0, 0)
  H.writeInt32BE(this._b | 0, 4)
  H.writeInt32BE(this._c | 0, 8)
  H.writeInt32BE(this._d | 0, 12)
  H.writeInt32BE(this._e | 0, 16)

  return H
}

module.exports = Sha


/***/ }),

/***/ "./node_modules/sha.js/sha1.js":
/*!*************************************!*\
  !*** ./node_modules/sha.js/sha1.js ***!
  \*************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

/*
 * A JavaScript implementation of the Secure Hash Algorithm, SHA-1, as defined
 * in FIPS PUB 180-1
 * Version 2.1a Copyright Paul Johnston 2000 - 2002.
 * Other contributors: Greg Holt, Andrew Kepert, Ydnar, Lostinet
 * Distributed under the BSD License
 * See http://pajhome.org.uk/crypt/md5 for details.
 */

var inherits = __webpack_require__(/*! inherits */ "./node_modules/inherits/inherits_browser.js")
var Hash = __webpack_require__(/*! ./hash */ "./node_modules/sha.js/hash.js")
var Buffer = __webpack_require__(/*! safe-buffer */ "./node_modules/safe-buffer/index.js").Buffer

var K = [
  0x5a827999, 0x6ed9eba1, 0x8f1bbcdc | 0, 0xca62c1d6 | 0
]

var W = new Array(80)

function Sha1 () {
  this.init()
  this._w = W

  Hash.call(this, 64, 56)
}

inherits(Sha1, Hash)

Sha1.prototype.init = function () {
  this._a = 0x67452301
  this._b = 0xefcdab89
  this._c = 0x98badcfe
  this._d = 0x10325476
  this._e = 0xc3d2e1f0

  return this
}

function rotl1 (num) {
  return (num << 1) | (num >>> 31)
}

function rotl5 (num) {
  return (num << 5) | (num >>> 27)
}

function rotl30 (num) {
  return (num << 30) | (num >>> 2)
}

function ft (s, b, c, d) {
  if (s === 0) return (b & c) | ((~b) & d)
  if (s === 2) return (b & c) | (b & d) | (c & d)
  return b ^ c ^ d
}

Sha1.prototype._update = function (M) {
  var W = this._w

  var a = this._a | 0
  var b = this._b | 0
  var c = this._c | 0
  var d = this._d | 0
  var e = this._e | 0

  for (var i = 0; i < 16; ++i) W[i] = M.readInt32BE(i * 4)
  for (; i < 80; ++i) W[i] = rotl1(W[i - 3] ^ W[i - 8] ^ W[i - 14] ^ W[i - 16])

  for (var j = 0; j < 80; ++j) {
    var s = ~~(j / 20)
    var t = (rotl5(a) + ft(s, b, c, d) + e + W[j] + K[s]) | 0

    e = d
    d = c
    c = rotl30(b)
    b = a
    a = t
  }

  this._a = (a + this._a) | 0
  this._b = (b + this._b) | 0
  this._c = (c + this._c) | 0
  this._d = (d + this._d) | 0
  this._e = (e + this._e) | 0
}

Sha1.prototype._hash = function () {
  var H = Buffer.allocUnsafe(20)

  H.writeInt32BE(this._a | 0, 0)
  H.writeInt32BE(this._b | 0, 4)
  H.writeInt32BE(this._c | 0, 8)
  H.writeInt32BE(this._d | 0, 12)
  H.writeInt32BE(this._e | 0, 16)

  return H
}

module.exports = Sha1


/***/ }),

/***/ "./node_modules/sha.js/sha224.js":
/*!***************************************!*\
  !*** ./node_modules/sha.js/sha224.js ***!
  \***************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

/**
 * A JavaScript implementation of the Secure Hash Algorithm, SHA-256, as defined
 * in FIPS 180-2
 * Version 2.2-beta Copyright Angel Marin, Paul Johnston 2000 - 2009.
 * Other contributors: Greg Holt, Andrew Kepert, Ydnar, Lostinet
 *
 */

var inherits = __webpack_require__(/*! inherits */ "./node_modules/inherits/inherits_browser.js")
var Sha256 = __webpack_require__(/*! ./sha256 */ "./node_modules/sha.js/sha256.js")
var Hash = __webpack_require__(/*! ./hash */ "./node_modules/sha.js/hash.js")
var Buffer = __webpack_require__(/*! safe-buffer */ "./node_modules/safe-buffer/index.js").Buffer

var W = new Array(64)

function Sha224 () {
  this.init()

  this._w = W // new Array(64)

  Hash.call(this, 64, 56)
}

inherits(Sha224, Sha256)

Sha224.prototype.init = function () {
  this._a = 0xc1059ed8
  this._b = 0x367cd507
  this._c = 0x3070dd17
  this._d = 0xf70e5939
  this._e = 0xffc00b31
  this._f = 0x68581511
  this._g = 0x64f98fa7
  this._h = 0xbefa4fa4

  return this
}

Sha224.prototype._hash = function () {
  var H = Buffer.allocUnsafe(28)

  H.writeInt32BE(this._a, 0)
  H.writeInt32BE(this._b, 4)
  H.writeInt32BE(this._c, 8)
  H.writeInt32BE(this._d, 12)
  H.writeInt32BE(this._e, 16)
  H.writeInt32BE(this._f, 20)
  H.writeInt32BE(this._g, 24)

  return H
}

module.exports = Sha224


/***/ }),

/***/ "./node_modules/sha.js/sha256.js":
/*!***************************************!*\
  !*** ./node_modules/sha.js/sha256.js ***!
  \***************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

/**
 * A JavaScript implementation of the Secure Hash Algorithm, SHA-256, as defined
 * in FIPS 180-2
 * Version 2.2-beta Copyright Angel Marin, Paul Johnston 2000 - 2009.
 * Other contributors: Greg Holt, Andrew Kepert, Ydnar, Lostinet
 *
 */

var inherits = __webpack_require__(/*! inherits */ "./node_modules/inherits/inherits_browser.js")
var Hash = __webpack_require__(/*! ./hash */ "./node_modules/sha.js/hash.js")
var Buffer = __webpack_require__(/*! safe-buffer */ "./node_modules/safe-buffer/index.js").Buffer

var K = [
  0x428A2F98, 0x71374491, 0xB5C0FBCF, 0xE9B5DBA5,
  0x3956C25B, 0x59F111F1, 0x923F82A4, 0xAB1C5ED5,
  0xD807AA98, 0x12835B01, 0x243185BE, 0x550C7DC3,
  0x72BE5D74, 0x80DEB1FE, 0x9BDC06A7, 0xC19BF174,
  0xE49B69C1, 0xEFBE4786, 0x0FC19DC6, 0x240CA1CC,
  0x2DE92C6F, 0x4A7484AA, 0x5CB0A9DC, 0x76F988DA,
  0x983E5152, 0xA831C66D, 0xB00327C8, 0xBF597FC7,
  0xC6E00BF3, 0xD5A79147, 0x06CA6351, 0x14292967,
  0x27B70A85, 0x2E1B2138, 0x4D2C6DFC, 0x53380D13,
  0x650A7354, 0x766A0ABB, 0x81C2C92E, 0x92722C85,
  0xA2BFE8A1, 0xA81A664B, 0xC24B8B70, 0xC76C51A3,
  0xD192E819, 0xD6990624, 0xF40E3585, 0x106AA070,
  0x19A4C116, 0x1E376C08, 0x2748774C, 0x34B0BCB5,
  0x391C0CB3, 0x4ED8AA4A, 0x5B9CCA4F, 0x682E6FF3,
  0x748F82EE, 0x78A5636F, 0x84C87814, 0x8CC70208,
  0x90BEFFFA, 0xA4506CEB, 0xBEF9A3F7, 0xC67178F2
]

var W = new Array(64)

function Sha256 () {
  this.init()

  this._w = W // new Array(64)

  Hash.call(this, 64, 56)
}

inherits(Sha256, Hash)

Sha256.prototype.init = function () {
  this._a = 0x6a09e667
  this._b = 0xbb67ae85
  this._c = 0x3c6ef372
  this._d = 0xa54ff53a
  this._e = 0x510e527f
  this._f = 0x9b05688c
  this._g = 0x1f83d9ab
  this._h = 0x5be0cd19

  return this
}

function ch (x, y, z) {
  return z ^ (x & (y ^ z))
}

function maj (x, y, z) {
  return (x & y) | (z & (x | y))
}

function sigma0 (x) {
  return (x >>> 2 | x << 30) ^ (x >>> 13 | x << 19) ^ (x >>> 22 | x << 10)
}

function sigma1 (x) {
  return (x >>> 6 | x << 26) ^ (x >>> 11 | x << 21) ^ (x >>> 25 | x << 7)
}

function gamma0 (x) {
  return (x >>> 7 | x << 25) ^ (x >>> 18 | x << 14) ^ (x >>> 3)
}

function gamma1 (x) {
  return (x >>> 17 | x << 15) ^ (x >>> 19 | x << 13) ^ (x >>> 10)
}

Sha256.prototype._update = function (M) {
  var W = this._w

  var a = this._a | 0
  var b = this._b | 0
  var c = this._c | 0
  var d = this._d | 0
  var e = this._e | 0
  var f = this._f | 0
  var g = this._g | 0
  var h = this._h | 0

  for (var i = 0; i < 16; ++i) W[i] = M.readInt32BE(i * 4)
  for (; i < 64; ++i) W[i] = (gamma1(W[i - 2]) + W[i - 7] + gamma0(W[i - 15]) + W[i - 16]) | 0

  for (var j = 0; j < 64; ++j) {
    var T1 = (h + sigma1(e) + ch(e, f, g) + K[j] + W[j]) | 0
    var T2 = (sigma0(a) + maj(a, b, c)) | 0

    h = g
    g = f
    f = e
    e = (d + T1) | 0
    d = c
    c = b
    b = a
    a = (T1 + T2) | 0
  }

  this._a = (a + this._a) | 0
  this._b = (b + this._b) | 0
  this._c = (c + this._c) | 0
  this._d = (d + this._d) | 0
  this._e = (e + this._e) | 0
  this._f = (f + this._f) | 0
  this._g = (g + this._g) | 0
  this._h = (h + this._h) | 0
}

Sha256.prototype._hash = function () {
  var H = Buffer.allocUnsafe(32)

  H.writeInt32BE(this._a, 0)
  H.writeInt32BE(this._b, 4)
  H.writeInt32BE(this._c, 8)
  H.writeInt32BE(this._d, 12)
  H.writeInt32BE(this._e, 16)
  H.writeInt32BE(this._f, 20)
  H.writeInt32BE(this._g, 24)
  H.writeInt32BE(this._h, 28)

  return H
}

module.exports = Sha256


/***/ }),

/***/ "./node_modules/sha.js/sha384.js":
/*!***************************************!*\
  !*** ./node_modules/sha.js/sha384.js ***!
  \***************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var inherits = __webpack_require__(/*! inherits */ "./node_modules/inherits/inherits_browser.js")
var SHA512 = __webpack_require__(/*! ./sha512 */ "./node_modules/sha.js/sha512.js")
var Hash = __webpack_require__(/*! ./hash */ "./node_modules/sha.js/hash.js")
var Buffer = __webpack_require__(/*! safe-buffer */ "./node_modules/safe-buffer/index.js").Buffer

var W = new Array(160)

function Sha384 () {
  this.init()
  this._w = W

  Hash.call(this, 128, 112)
}

inherits(Sha384, SHA512)

Sha384.prototype.init = function () {
  this._ah = 0xcbbb9d5d
  this._bh = 0x629a292a
  this._ch = 0x9159015a
  this._dh = 0x152fecd8
  this._eh = 0x67332667
  this._fh = 0x8eb44a87
  this._gh = 0xdb0c2e0d
  this._hh = 0x47b5481d

  this._al = 0xc1059ed8
  this._bl = 0x367cd507
  this._cl = 0x3070dd17
  this._dl = 0xf70e5939
  this._el = 0xffc00b31
  this._fl = 0x68581511
  this._gl = 0x64f98fa7
  this._hl = 0xbefa4fa4

  return this
}

Sha384.prototype._hash = function () {
  var H = Buffer.allocUnsafe(48)

  function writeInt64BE (h, l, offset) {
    H.writeInt32BE(h, offset)
    H.writeInt32BE(l, offset + 4)
  }

  writeInt64BE(this._ah, this._al, 0)
  writeInt64BE(this._bh, this._bl, 8)
  writeInt64BE(this._ch, this._cl, 16)
  writeInt64BE(this._dh, this._dl, 24)
  writeInt64BE(this._eh, this._el, 32)
  writeInt64BE(this._fh, this._fl, 40)

  return H
}

module.exports = Sha384


/***/ }),

/***/ "./node_modules/sha.js/sha512.js":
/*!***************************************!*\
  !*** ./node_modules/sha.js/sha512.js ***!
  \***************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var inherits = __webpack_require__(/*! inherits */ "./node_modules/inherits/inherits_browser.js")
var Hash = __webpack_require__(/*! ./hash */ "./node_modules/sha.js/hash.js")
var Buffer = __webpack_require__(/*! safe-buffer */ "./node_modules/safe-buffer/index.js").Buffer

var K = [
  0x428a2f98, 0xd728ae22, 0x71374491, 0x23ef65cd,
  0xb5c0fbcf, 0xec4d3b2f, 0xe9b5dba5, 0x8189dbbc,
  0x3956c25b, 0xf348b538, 0x59f111f1, 0xb605d019,
  0x923f82a4, 0xaf194f9b, 0xab1c5ed5, 0xda6d8118,
  0xd807aa98, 0xa3030242, 0x12835b01, 0x45706fbe,
  0x243185be, 0x4ee4b28c, 0x550c7dc3, 0xd5ffb4e2,
  0x72be5d74, 0xf27b896f, 0x80deb1fe, 0x3b1696b1,
  0x9bdc06a7, 0x25c71235, 0xc19bf174, 0xcf692694,
  0xe49b69c1, 0x9ef14ad2, 0xefbe4786, 0x384f25e3,
  0x0fc19dc6, 0x8b8cd5b5, 0x240ca1cc, 0x77ac9c65,
  0x2de92c6f, 0x592b0275, 0x4a7484aa, 0x6ea6e483,
  0x5cb0a9dc, 0xbd41fbd4, 0x76f988da, 0x831153b5,
  0x983e5152, 0xee66dfab, 0xa831c66d, 0x2db43210,
  0xb00327c8, 0x98fb213f, 0xbf597fc7, 0xbeef0ee4,
  0xc6e00bf3, 0x3da88fc2, 0xd5a79147, 0x930aa725,
  0x06ca6351, 0xe003826f, 0x14292967, 0x0a0e6e70,
  0x27b70a85, 0x46d22ffc, 0x2e1b2138, 0x5c26c926,
  0x4d2c6dfc, 0x5ac42aed, 0x53380d13, 0x9d95b3df,
  0x650a7354, 0x8baf63de, 0x766a0abb, 0x3c77b2a8,
  0x81c2c92e, 0x47edaee6, 0x92722c85, 0x1482353b,
  0xa2bfe8a1, 0x4cf10364, 0xa81a664b, 0xbc423001,
  0xc24b8b70, 0xd0f89791, 0xc76c51a3, 0x0654be30,
  0xd192e819, 0xd6ef5218, 0xd6990624, 0x5565a910,
  0xf40e3585, 0x5771202a, 0x106aa070, 0x32bbd1b8,
  0x19a4c116, 0xb8d2d0c8, 0x1e376c08, 0x5141ab53,
  0x2748774c, 0xdf8eeb99, 0x34b0bcb5, 0xe19b48a8,
  0x391c0cb3, 0xc5c95a63, 0x4ed8aa4a, 0xe3418acb,
  0x5b9cca4f, 0x7763e373, 0x682e6ff3, 0xd6b2b8a3,
  0x748f82ee, 0x5defb2fc, 0x78a5636f, 0x43172f60,
  0x84c87814, 0xa1f0ab72, 0x8cc70208, 0x1a6439ec,
  0x90befffa, 0x23631e28, 0xa4506ceb, 0xde82bde9,
  0xbef9a3f7, 0xb2c67915, 0xc67178f2, 0xe372532b,
  0xca273ece, 0xea26619c, 0xd186b8c7, 0x21c0c207,
  0xeada7dd6, 0xcde0eb1e, 0xf57d4f7f, 0xee6ed178,
  0x06f067aa, 0x72176fba, 0x0a637dc5, 0xa2c898a6,
  0x113f9804, 0xbef90dae, 0x1b710b35, 0x131c471b,
  0x28db77f5, 0x23047d84, 0x32caab7b, 0x40c72493,
  0x3c9ebe0a, 0x15c9bebc, 0x431d67c4, 0x9c100d4c,
  0x4cc5d4be, 0xcb3e42b6, 0x597f299c, 0xfc657e2a,
  0x5fcb6fab, 0x3ad6faec, 0x6c44198c, 0x4a475817
]

var W = new Array(160)

function Sha512 () {
  this.init()
  this._w = W

  Hash.call(this, 128, 112)
}

inherits(Sha512, Hash)

Sha512.prototype.init = function () {
  this._ah = 0x6a09e667
  this._bh = 0xbb67ae85
  this._ch = 0x3c6ef372
  this._dh = 0xa54ff53a
  this._eh = 0x510e527f
  this._fh = 0x9b05688c
  this._gh = 0x1f83d9ab
  this._hh = 0x5be0cd19

  this._al = 0xf3bcc908
  this._bl = 0x84caa73b
  this._cl = 0xfe94f82b
  this._dl = 0x5f1d36f1
  this._el = 0xade682d1
  this._fl = 0x2b3e6c1f
  this._gl = 0xfb41bd6b
  this._hl = 0x137e2179

  return this
}

function Ch (x, y, z) {
  return z ^ (x & (y ^ z))
}

function maj (x, y, z) {
  return (x & y) | (z & (x | y))
}

function sigma0 (x, xl) {
  return (x >>> 28 | xl << 4) ^ (xl >>> 2 | x << 30) ^ (xl >>> 7 | x << 25)
}

function sigma1 (x, xl) {
  return (x >>> 14 | xl << 18) ^ (x >>> 18 | xl << 14) ^ (xl >>> 9 | x << 23)
}

function Gamma0 (x, xl) {
  return (x >>> 1 | xl << 31) ^ (x >>> 8 | xl << 24) ^ (x >>> 7)
}

function Gamma0l (x, xl) {
  return (x >>> 1 | xl << 31) ^ (x >>> 8 | xl << 24) ^ (x >>> 7 | xl << 25)
}

function Gamma1 (x, xl) {
  return (x >>> 19 | xl << 13) ^ (xl >>> 29 | x << 3) ^ (x >>> 6)
}

function Gamma1l (x, xl) {
  return (x >>> 19 | xl << 13) ^ (xl >>> 29 | x << 3) ^ (x >>> 6 | xl << 26)
}

function getCarry (a, b) {
  return (a >>> 0) < (b >>> 0) ? 1 : 0
}

Sha512.prototype._update = function (M) {
  var W = this._w

  var ah = this._ah | 0
  var bh = this._bh | 0
  var ch = this._ch | 0
  var dh = this._dh | 0
  var eh = this._eh | 0
  var fh = this._fh | 0
  var gh = this._gh | 0
  var hh = this._hh | 0

  var al = this._al | 0
  var bl = this._bl | 0
  var cl = this._cl | 0
  var dl = this._dl | 0
  var el = this._el | 0
  var fl = this._fl | 0
  var gl = this._gl | 0
  var hl = this._hl | 0

  for (var i = 0; i < 32; i += 2) {
    W[i] = M.readInt32BE(i * 4)
    W[i + 1] = M.readInt32BE(i * 4 + 4)
  }
  for (; i < 160; i += 2) {
    var xh = W[i - 15 * 2]
    var xl = W[i - 15 * 2 + 1]
    var gamma0 = Gamma0(xh, xl)
    var gamma0l = Gamma0l(xl, xh)

    xh = W[i - 2 * 2]
    xl = W[i - 2 * 2 + 1]
    var gamma1 = Gamma1(xh, xl)
    var gamma1l = Gamma1l(xl, xh)

    // W[i] = gamma0 + W[i - 7] + gamma1 + W[i - 16]
    var Wi7h = W[i - 7 * 2]
    var Wi7l = W[i - 7 * 2 + 1]

    var Wi16h = W[i - 16 * 2]
    var Wi16l = W[i - 16 * 2 + 1]

    var Wil = (gamma0l + Wi7l) | 0
    var Wih = (gamma0 + Wi7h + getCarry(Wil, gamma0l)) | 0
    Wil = (Wil + gamma1l) | 0
    Wih = (Wih + gamma1 + getCarry(Wil, gamma1l)) | 0
    Wil = (Wil + Wi16l) | 0
    Wih = (Wih + Wi16h + getCarry(Wil, Wi16l)) | 0

    W[i] = Wih
    W[i + 1] = Wil
  }

  for (var j = 0; j < 160; j += 2) {
    Wih = W[j]
    Wil = W[j + 1]

    var majh = maj(ah, bh, ch)
    var majl = maj(al, bl, cl)

    var sigma0h = sigma0(ah, al)
    var sigma0l = sigma0(al, ah)
    var sigma1h = sigma1(eh, el)
    var sigma1l = sigma1(el, eh)

    // t1 = h + sigma1 + ch + K[j] + W[j]
    var Kih = K[j]
    var Kil = K[j + 1]

    var chh = Ch(eh, fh, gh)
    var chl = Ch(el, fl, gl)

    var t1l = (hl + sigma1l) | 0
    var t1h = (hh + sigma1h + getCarry(t1l, hl)) | 0
    t1l = (t1l + chl) | 0
    t1h = (t1h + chh + getCarry(t1l, chl)) | 0
    t1l = (t1l + Kil) | 0
    t1h = (t1h + Kih + getCarry(t1l, Kil)) | 0
    t1l = (t1l + Wil) | 0
    t1h = (t1h + Wih + getCarry(t1l, Wil)) | 0

    // t2 = sigma0 + maj
    var t2l = (sigma0l + majl) | 0
    var t2h = (sigma0h + majh + getCarry(t2l, sigma0l)) | 0

    hh = gh
    hl = gl
    gh = fh
    gl = fl
    fh = eh
    fl = el
    el = (dl + t1l) | 0
    eh = (dh + t1h + getCarry(el, dl)) | 0
    dh = ch
    dl = cl
    ch = bh
    cl = bl
    bh = ah
    bl = al
    al = (t1l + t2l) | 0
    ah = (t1h + t2h + getCarry(al, t1l)) | 0
  }

  this._al = (this._al + al) | 0
  this._bl = (this._bl + bl) | 0
  this._cl = (this._cl + cl) | 0
  this._dl = (this._dl + dl) | 0
  this._el = (this._el + el) | 0
  this._fl = (this._fl + fl) | 0
  this._gl = (this._gl + gl) | 0
  this._hl = (this._hl + hl) | 0

  this._ah = (this._ah + ah + getCarry(this._al, al)) | 0
  this._bh = (this._bh + bh + getCarry(this._bl, bl)) | 0
  this._ch = (this._ch + ch + getCarry(this._cl, cl)) | 0
  this._dh = (this._dh + dh + getCarry(this._dl, dl)) | 0
  this._eh = (this._eh + eh + getCarry(this._el, el)) | 0
  this._fh = (this._fh + fh + getCarry(this._fl, fl)) | 0
  this._gh = (this._gh + gh + getCarry(this._gl, gl)) | 0
  this._hh = (this._hh + hh + getCarry(this._hl, hl)) | 0
}

Sha512.prototype._hash = function () {
  var H = Buffer.allocUnsafe(64)

  function writeInt64BE (h, l, offset) {
    H.writeInt32BE(h, offset)
    H.writeInt32BE(l, offset + 4)
  }

  writeInt64BE(this._ah, this._al, 0)
  writeInt64BE(this._bh, this._bl, 8)
  writeInt64BE(this._ch, this._cl, 16)
  writeInt64BE(this._dh, this._dl, 24)
  writeInt64BE(this._eh, this._el, 32)
  writeInt64BE(this._fh, this._fl, 40)
  writeInt64BE(this._gh, this._gl, 48)
  writeInt64BE(this._hh, this._hl, 56)

  return H
}

module.exports = Sha512


/***/ }),

/***/ "./node_modules/stream-browserify/index.js":
/*!*************************************************!*\
  !*** ./node_modules/stream-browserify/index.js ***!
  \*************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

module.exports = Stream;

var EE = __webpack_require__(/*! events */ "./node_modules/events/events.js").EventEmitter;
var inherits = __webpack_require__(/*! inherits */ "./node_modules/inherits/inherits_browser.js");

inherits(Stream, EE);
Stream.Readable = __webpack_require__(/*! readable-stream/readable.js */ "./node_modules/readable-stream/readable-browser.js");
Stream.Writable = __webpack_require__(/*! readable-stream/writable.js */ "./node_modules/readable-stream/writable-browser.js");
Stream.Duplex = __webpack_require__(/*! readable-stream/duplex.js */ "./node_modules/readable-stream/duplex-browser.js");
Stream.Transform = __webpack_require__(/*! readable-stream/transform.js */ "./node_modules/readable-stream/transform.js");
Stream.PassThrough = __webpack_require__(/*! readable-stream/passthrough.js */ "./node_modules/readable-stream/passthrough.js");

// Backwards-compat with node 0.4.x
Stream.Stream = Stream;



// old-style streams.  Note that the pipe method (the only relevant
// part of this class) is overridden in the Readable class.

function Stream() {
  EE.call(this);
}

Stream.prototype.pipe = function(dest, options) {
  var source = this;

  function ondata(chunk) {
    if (dest.writable) {
      if (false === dest.write(chunk) && source.pause) {
        source.pause();
      }
    }
  }

  source.on('data', ondata);

  function ondrain() {
    if (source.readable && source.resume) {
      source.resume();
    }
  }

  dest.on('drain', ondrain);

  // If the 'end' option is not supplied, dest.end() will be called when
  // source gets the 'end' or 'close' events.  Only dest.end() once.
  if (!dest._isStdio && (!options || options.end !== false)) {
    source.on('end', onend);
    source.on('close', onclose);
  }

  var didOnEnd = false;
  function onend() {
    if (didOnEnd) return;
    didOnEnd = true;

    dest.end();
  }


  function onclose() {
    if (didOnEnd) return;
    didOnEnd = true;

    if (typeof dest.destroy === 'function') dest.destroy();
  }

  // don't leave dangling pipes when there are errors.
  function onerror(er) {
    cleanup();
    if (EE.listenerCount(this, 'error') === 0) {
      throw er; // Unhandled stream error in pipe.
    }
  }

  source.on('error', onerror);
  dest.on('error', onerror);

  // remove all the event listeners that were added.
  function cleanup() {
    source.removeListener('data', ondata);
    dest.removeListener('drain', ondrain);

    source.removeListener('end', onend);
    source.removeListener('close', onclose);

    source.removeListener('error', onerror);
    dest.removeListener('error', onerror);

    source.removeListener('end', cleanup);
    source.removeListener('close', cleanup);

    dest.removeListener('close', cleanup);
  }

  source.on('end', cleanup);
  source.on('close', cleanup);

  dest.on('close', cleanup);

  dest.emit('pipe', source);

  // Allow for unix-like usage: A.pipe(B).pipe(C)
  return dest;
};


/***/ }),

/***/ "./node_modules/string_decoder/lib/string_decoder.js":
/*!***********************************************************!*\
  !*** ./node_modules/string_decoder/lib/string_decoder.js ***!
  \***********************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.



/*<replacement>*/

var Buffer = __webpack_require__(/*! safe-buffer */ "./node_modules/safe-buffer/index.js").Buffer;
/*</replacement>*/

var isEncoding = Buffer.isEncoding || function (encoding) {
  encoding = '' + encoding;
  switch (encoding && encoding.toLowerCase()) {
    case 'hex':case 'utf8':case 'utf-8':case 'ascii':case 'binary':case 'base64':case 'ucs2':case 'ucs-2':case 'utf16le':case 'utf-16le':case 'raw':
      return true;
    default:
      return false;
  }
};

function _normalizeEncoding(enc) {
  if (!enc) return 'utf8';
  var retried;
  while (true) {
    switch (enc) {
      case 'utf8':
      case 'utf-8':
        return 'utf8';
      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return 'utf16le';
      case 'latin1':
      case 'binary':
        return 'latin1';
      case 'base64':
      case 'ascii':
      case 'hex':
        return enc;
      default:
        if (retried) return; // undefined
        enc = ('' + enc).toLowerCase();
        retried = true;
    }
  }
};

// Do not cache `Buffer.isEncoding` when checking encoding names as some
// modules monkey-patch it to support additional encodings
function normalizeEncoding(enc) {
  var nenc = _normalizeEncoding(enc);
  if (typeof nenc !== 'string' && (Buffer.isEncoding === isEncoding || !isEncoding(enc))) throw new Error('Unknown encoding: ' + enc);
  return nenc || enc;
}

// StringDecoder provides an interface for efficiently splitting a series of
// buffers into a series of JS strings without breaking apart multi-byte
// characters.
exports.StringDecoder = StringDecoder;
function StringDecoder(encoding) {
  this.encoding = normalizeEncoding(encoding);
  var nb;
  switch (this.encoding) {
    case 'utf16le':
      this.text = utf16Text;
      this.end = utf16End;
      nb = 4;
      break;
    case 'utf8':
      this.fillLast = utf8FillLast;
      nb = 4;
      break;
    case 'base64':
      this.text = base64Text;
      this.end = base64End;
      nb = 3;
      break;
    default:
      this.write = simpleWrite;
      this.end = simpleEnd;
      return;
  }
  this.lastNeed = 0;
  this.lastTotal = 0;
  this.lastChar = Buffer.allocUnsafe(nb);
}

StringDecoder.prototype.write = function (buf) {
  if (buf.length === 0) return '';
  var r;
  var i;
  if (this.lastNeed) {
    r = this.fillLast(buf);
    if (r === undefined) return '';
    i = this.lastNeed;
    this.lastNeed = 0;
  } else {
    i = 0;
  }
  if (i < buf.length) return r ? r + this.text(buf, i) : this.text(buf, i);
  return r || '';
};

StringDecoder.prototype.end = utf8End;

// Returns only complete characters in a Buffer
StringDecoder.prototype.text = utf8Text;

// Attempts to complete a partial non-UTF-8 character using bytes from a Buffer
StringDecoder.prototype.fillLast = function (buf) {
  if (this.lastNeed <= buf.length) {
    buf.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, this.lastNeed);
    return this.lastChar.toString(this.encoding, 0, this.lastTotal);
  }
  buf.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, buf.length);
  this.lastNeed -= buf.length;
};

// Checks the type of a UTF-8 byte, whether it's ASCII, a leading byte, or a
// continuation byte. If an invalid byte is detected, -2 is returned.
function utf8CheckByte(byte) {
  if (byte <= 0x7F) return 0;else if (byte >> 5 === 0x06) return 2;else if (byte >> 4 === 0x0E) return 3;else if (byte >> 3 === 0x1E) return 4;
  return byte >> 6 === 0x02 ? -1 : -2;
}

// Checks at most 3 bytes at the end of a Buffer in order to detect an
// incomplete multi-byte UTF-8 character. The total number of bytes (2, 3, or 4)
// needed to complete the UTF-8 character (if applicable) are returned.
function utf8CheckIncomplete(self, buf, i) {
  var j = buf.length - 1;
  if (j < i) return 0;
  var nb = utf8CheckByte(buf[j]);
  if (nb >= 0) {
    if (nb > 0) self.lastNeed = nb - 1;
    return nb;
  }
  if (--j < i || nb === -2) return 0;
  nb = utf8CheckByte(buf[j]);
  if (nb >= 0) {
    if (nb > 0) self.lastNeed = nb - 2;
    return nb;
  }
  if (--j < i || nb === -2) return 0;
  nb = utf8CheckByte(buf[j]);
  if (nb >= 0) {
    if (nb > 0) {
      if (nb === 2) nb = 0;else self.lastNeed = nb - 3;
    }
    return nb;
  }
  return 0;
}

// Validates as many continuation bytes for a multi-byte UTF-8 character as
// needed or are available. If we see a non-continuation byte where we expect
// one, we "replace" the validated continuation bytes we've seen so far with
// a single UTF-8 replacement character ('\ufffd'), to match v8's UTF-8 decoding
// behavior. The continuation byte check is included three times in the case
// where all of the continuation bytes for a character exist in the same buffer.
// It is also done this way as a slight performance increase instead of using a
// loop.
function utf8CheckExtraBytes(self, buf, p) {
  if ((buf[0] & 0xC0) !== 0x80) {
    self.lastNeed = 0;
    return '\ufffd';
  }
  if (self.lastNeed > 1 && buf.length > 1) {
    if ((buf[1] & 0xC0) !== 0x80) {
      self.lastNeed = 1;
      return '\ufffd';
    }
    if (self.lastNeed > 2 && buf.length > 2) {
      if ((buf[2] & 0xC0) !== 0x80) {
        self.lastNeed = 2;
        return '\ufffd';
      }
    }
  }
}

// Attempts to complete a multi-byte UTF-8 character using bytes from a Buffer.
function utf8FillLast(buf) {
  var p = this.lastTotal - this.lastNeed;
  var r = utf8CheckExtraBytes(this, buf, p);
  if (r !== undefined) return r;
  if (this.lastNeed <= buf.length) {
    buf.copy(this.lastChar, p, 0, this.lastNeed);
    return this.lastChar.toString(this.encoding, 0, this.lastTotal);
  }
  buf.copy(this.lastChar, p, 0, buf.length);
  this.lastNeed -= buf.length;
}

// Returns all complete UTF-8 characters in a Buffer. If the Buffer ended on a
// partial character, the character's bytes are buffered until the required
// number of bytes are available.
function utf8Text(buf, i) {
  var total = utf8CheckIncomplete(this, buf, i);
  if (!this.lastNeed) return buf.toString('utf8', i);
  this.lastTotal = total;
  var end = buf.length - (total - this.lastNeed);
  buf.copy(this.lastChar, 0, end);
  return buf.toString('utf8', i, end);
}

// For UTF-8, a replacement character is added when ending on a partial
// character.
function utf8End(buf) {
  var r = buf && buf.length ? this.write(buf) : '';
  if (this.lastNeed) return r + '\ufffd';
  return r;
}

// UTF-16LE typically needs two bytes per character, but even if we have an even
// number of bytes available, we need to check if we end on a leading/high
// surrogate. In that case, we need to wait for the next two bytes in order to
// decode the last character properly.
function utf16Text(buf, i) {
  if ((buf.length - i) % 2 === 0) {
    var r = buf.toString('utf16le', i);
    if (r) {
      var c = r.charCodeAt(r.length - 1);
      if (c >= 0xD800 && c <= 0xDBFF) {
        this.lastNeed = 2;
        this.lastTotal = 4;
        this.lastChar[0] = buf[buf.length - 2];
        this.lastChar[1] = buf[buf.length - 1];
        return r.slice(0, -1);
      }
    }
    return r;
  }
  this.lastNeed = 1;
  this.lastTotal = 2;
  this.lastChar[0] = buf[buf.length - 1];
  return buf.toString('utf16le', i, buf.length - 1);
}

// For UTF-16LE we do not explicitly append special replacement characters if we
// end on a partial character, we simply let v8 handle that.
function utf16End(buf) {
  var r = buf && buf.length ? this.write(buf) : '';
  if (this.lastNeed) {
    var end = this.lastTotal - this.lastNeed;
    return r + this.lastChar.toString('utf16le', 0, end);
  }
  return r;
}

function base64Text(buf, i) {
  var n = (buf.length - i) % 3;
  if (n === 0) return buf.toString('base64', i);
  this.lastNeed = 3 - n;
  this.lastTotal = 3;
  if (n === 1) {
    this.lastChar[0] = buf[buf.length - 1];
  } else {
    this.lastChar[0] = buf[buf.length - 2];
    this.lastChar[1] = buf[buf.length - 1];
  }
  return buf.toString('base64', i, buf.length - n);
}

function base64End(buf) {
  var r = buf && buf.length ? this.write(buf) : '';
  if (this.lastNeed) return r + this.lastChar.toString('base64', 0, 3 - this.lastNeed);
  return r;
}

// Pass bytes on through for single-byte encodings (e.g. ascii, latin1, hex)
function simpleWrite(buf) {
  return buf.toString(this.encoding);
}

function simpleEnd(buf) {
  return buf && buf.length ? this.write(buf) : '';
}

/***/ }),

/***/ "./node_modules/timers-browserify/main.js":
/*!************************************************!*\
  !*** ./node_modules/timers-browserify/main.js ***!
  \************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {var scope = (typeof global !== "undefined" && global) ||
            (typeof self !== "undefined" && self) ||
            window;
var apply = Function.prototype.apply;

// DOM APIs, for completeness

exports.setTimeout = function() {
  return new Timeout(apply.call(setTimeout, scope, arguments), clearTimeout);
};
exports.setInterval = function() {
  return new Timeout(apply.call(setInterval, scope, arguments), clearInterval);
};
exports.clearTimeout =
exports.clearInterval = function(timeout) {
  if (timeout) {
    timeout.close();
  }
};

function Timeout(id, clearFn) {
  this._id = id;
  this._clearFn = clearFn;
}
Timeout.prototype.unref = Timeout.prototype.ref = function() {};
Timeout.prototype.close = function() {
  this._clearFn.call(scope, this._id);
};

// Does not start the time, just sets up the members needed.
exports.enroll = function(item, msecs) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = msecs;
};

exports.unenroll = function(item) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = -1;
};

exports._unrefActive = exports.active = function(item) {
  clearTimeout(item._idleTimeoutId);

  var msecs = item._idleTimeout;
  if (msecs >= 0) {
    item._idleTimeoutId = setTimeout(function onTimeout() {
      if (item._onTimeout)
        item._onTimeout();
    }, msecs);
  }
};

// setimmediate attaches itself to the global object
__webpack_require__(/*! setimmediate */ "./node_modules/setimmediate/setImmediate.js");
// On some exotic environments, it's not clear which object `setimmediate` was
// able to install onto.  Search each possibility in the same order as the
// `setimmediate` library.
exports.setImmediate = (typeof self !== "undefined" && self.setImmediate) ||
                       (typeof global !== "undefined" && global.setImmediate) ||
                       (this && this.setImmediate);
exports.clearImmediate = (typeof self !== "undefined" && self.clearImmediate) ||
                         (typeof global !== "undefined" && global.clearImmediate) ||
                         (this && this.clearImmediate);

/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(/*! ./../webpack/buildin/global.js */ "./node_modules/webpack/buildin/global.js")))

/***/ }),

/***/ "./node_modules/tslib/tslib.es6.js":
/*!*****************************************!*\
  !*** ./node_modules/tslib/tslib.es6.js ***!
  \*****************************************/
/*! exports provided: __extends, __assign, __rest, __decorate, __param, __metadata, __awaiter, __generator, __createBinding, __exportStar, __values, __read, __spread, __spreadArrays, __await, __asyncGenerator, __asyncDelegator, __asyncValues, __makeTemplateObject, __importStar, __importDefault, __classPrivateFieldGet, __classPrivateFieldSet */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__extends", function() { return __extends; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__assign", function() { return __assign; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__rest", function() { return __rest; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__decorate", function() { return __decorate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__param", function() { return __param; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__metadata", function() { return __metadata; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__awaiter", function() { return __awaiter; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__generator", function() { return __generator; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__createBinding", function() { return __createBinding; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__exportStar", function() { return __exportStar; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__values", function() { return __values; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__read", function() { return __read; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__spread", function() { return __spread; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__spreadArrays", function() { return __spreadArrays; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__await", function() { return __await; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__asyncGenerator", function() { return __asyncGenerator; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__asyncDelegator", function() { return __asyncDelegator; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__asyncValues", function() { return __asyncValues; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__makeTemplateObject", function() { return __makeTemplateObject; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__importStar", function() { return __importStar; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__importDefault", function() { return __importDefault; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__classPrivateFieldGet", function() { return __classPrivateFieldGet; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__classPrivateFieldSet", function() { return __classPrivateFieldSet; });
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
/* global Reflect, Promise */

var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
    return extendStatics(d, b);
};

function __extends(d, b) {
    extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    }
    return __assign.apply(this, arguments);
}

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

function __decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}

function __param(paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
}

function __metadata(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}

function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}

var __createBinding = Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});

function __exportStar(m, o) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) __createBinding(o, m, p);
}

function __values(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}

function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
}

function __spread() {
    for (var ar = [], i = 0; i < arguments.length; i++)
        ar = ar.concat(__read(arguments[i]));
    return ar;
}

function __spreadArrays() {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};

function __await(v) {
    return this instanceof __await ? (this.v = v, this) : new __await(v);
}

function __asyncGenerator(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i;
    function verb(n) { if (g[n]) i[n] = function (v) { return new Promise(function (a, b) { q.push([n, v, a, b]) > 1 || resume(n, v); }); }; }
    function resume(n, v) { try { step(g[n](v)); } catch (e) { settle(q[0][3], e); } }
    function step(r) { r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r); }
    function fulfill(value) { resume("next", value); }
    function reject(value) { resume("throw", value); }
    function settle(f, v) { if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]); }
}

function __asyncDelegator(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function (e) { throw e; }), verb("return"), i[Symbol.iterator] = function () { return this; }, i;
    function verb(n, f) { i[n] = o[n] ? function (v) { return (p = !p) ? { value: __await(o[n](v)), done: n === "return" } : f ? f(v) : v; } : f; }
}

function __asyncValues(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i);
    function verb(n) { i[n] = o[n] && function (v) { return new Promise(function (resolve, reject) { v = o[n](v), settle(resolve, reject, v.done, v.value); }); }; }
    function settle(resolve, reject, d, v) { Promise.resolve(v).then(function(v) { resolve({ value: v, done: d }); }, reject); }
}

function __makeTemplateObject(cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};

var __setModuleDefault = Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
};

function __importStar(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
}

function __importDefault(mod) {
    return (mod && mod.__esModule) ? mod : { default: mod };
}

function __classPrivateFieldGet(receiver, privateMap) {
    if (!privateMap.has(receiver)) {
        throw new TypeError("attempted to get private field on non-instance");
    }
    return privateMap.get(receiver);
}

function __classPrivateFieldSet(receiver, privateMap, value) {
    if (!privateMap.has(receiver)) {
        throw new TypeError("attempted to set private field on non-instance");
    }
    privateMap.set(receiver, value);
    return value;
}


/***/ }),

/***/ "./node_modules/util-deprecate/browser.js":
/*!************************************************!*\
  !*** ./node_modules/util-deprecate/browser.js ***!
  \************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {
/**
 * Module exports.
 */

module.exports = deprecate;

/**
 * Mark that a method should not be used.
 * Returns a modified function which warns once by default.
 *
 * If `localStorage.noDeprecation = true` is set, then it is a no-op.
 *
 * If `localStorage.throwDeprecation = true` is set, then deprecated functions
 * will throw an Error when invoked.
 *
 * If `localStorage.traceDeprecation = true` is set, then deprecated functions
 * will invoke `console.trace()` instead of `console.error()`.
 *
 * @param {Function} fn - the function to deprecate
 * @param {String} msg - the string to print to the console when `fn` is invoked
 * @returns {Function} a new "deprecated" version of `fn`
 * @api public
 */

function deprecate (fn, msg) {
  if (config('noDeprecation')) {
    return fn;
  }

  var warned = false;
  function deprecated() {
    if (!warned) {
      if (config('throwDeprecation')) {
        throw new Error(msg);
      } else if (config('traceDeprecation')) {
        console.trace(msg);
      } else {
        console.warn(msg);
      }
      warned = true;
    }
    return fn.apply(this, arguments);
  }

  return deprecated;
}

/**
 * Checks `localStorage` for boolean values for the given `name`.
 *
 * @param {String} name
 * @returns {Boolean}
 * @api private
 */

function config (name) {
  // accessing global.localStorage can trigger a DOMException in sandboxed iframes
  try {
    if (!global.localStorage) return false;
  } catch (_) {
    return false;
  }
  var val = global.localStorage[name];
  if (null == val) return false;
  return String(val).toLowerCase() === 'true';
}

/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(/*! ./../webpack/buildin/global.js */ "./node_modules/webpack/buildin/global.js")))

/***/ }),

/***/ "./node_modules/webpack/buildin/global.js":
/*!***********************************!*\
  !*** (webpack)/buildin/global.js ***!
  \***********************************/
/*! no static exports found */
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || new Function("return this")();
} catch (e) {
	// This works if the window reference is available
	if (typeof window === "object") g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),

/***/ "./node_modules/webpack/buildin/module.js":
/*!***********************************!*\
  !*** (webpack)/buildin/module.js ***!
  \***********************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = function(module) {
	if (!module.webpackPolyfill) {
		module.deprecate = function() {};
		module.paths = [];
		// module.parent = undefined by default
		if (!module.children) module.children = [];
		Object.defineProperty(module, "loaded", {
			enumerable: true,
			get: function() {
				return module.l;
			}
		});
		Object.defineProperty(module, "id", {
			enumerable: true,
			get: function() {
				return module.i;
			}
		});
		module.webpackPolyfill = 1;
	}
	return module;
};


/***/ }),

/***/ "./node_modules/xhr2/lib/browser.js":
/*!******************************************!*\
  !*** ./node_modules/xhr2/lib/browser.js ***!
  \******************************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = XMLHttpRequest;


/***/ }),

/***/ 0:
/*!**********************!*\
  !*** util (ignored) ***!
  \**********************/
/*! no static exports found */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 1:
/*!**********************!*\
  !*** util (ignored) ***!
  \**********************/
/*! no static exports found */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 10:
/*!************************!*\
  !*** buffer (ignored) ***!
  \************************/
/*! no static exports found */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 11:
/*!************************!*\
  !*** buffer (ignored) ***!
  \************************/
/*! no static exports found */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 12:
/*!************************!*\
  !*** buffer (ignored) ***!
  \************************/
/*! no static exports found */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 13:
/*!************************!*\
  !*** buffer (ignored) ***!
  \************************/
/*! no static exports found */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 2:
/*!**********************!*\
  !*** util (ignored) ***!
  \**********************/
/*! no static exports found */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 3:
/*!**********************!*\
  !*** util (ignored) ***!
  \**********************/
/*! no static exports found */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 4:
/*!************************!*\
  !*** buffer (ignored) ***!
  \************************/
/*! no static exports found */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 5:
/*!************************!*\
  !*** buffer (ignored) ***!
  \************************/
/*! no static exports found */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 6:
/*!************************!*\
  !*** crypto (ignored) ***!
  \************************/
/*! no static exports found */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 7:
/*!**********************!*\
  !*** util (ignored) ***!
  \**********************/
/*! no static exports found */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 8:
/*!**********************!*\
  !*** util (ignored) ***!
  \**********************/
/*! no static exports found */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 9:
/*!************************!*\
  !*** buffer (ignored) ***!
  \************************/
/*! no static exports found */
/***/ (function(module, exports) {

/* (ignored) */

/***/ })

/******/ });
});